/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		244: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "dashboard/js/" + ({}[chunkId]||chunkId) + "." + {"0":"3c484bef","1":"7cc7d7dd","2":"eb95ac9b","3":"86b3675c","4":"16d064c9","5":"f1173ade","6":"8259019b","7":"bb0025cc","8":"c864805b","9":"4f35fbaf","10":"2887b800","11":"4f1ec9db","12":"e8f08cd5","13":"26db02d7","14":"80587e7e","15":"ece83fe8","16":"d700e403","17":"a04a0ff4","18":"153860d8","19":"286a64bd","20":"59a84bba","21":"115ed1d1","22":"4c614b41","23":"71f013ac","24":"397f1099","25":"a751372e","26":"29b9d097","27":"45c9986f","28":"82fa4caf","29":"dd6a7aaa","30":"8dede326","31":"10b3f813","32":"9c2a503d","33":"9161f567","34":"01506d87","35":"7ed6eaed","36":"cfc9e4c9","37":"6f608575","38":"cd107287","39":"92216cf1","40":"c65bc0ec","41":"29e6dbd5","42":"a1b7381c","43":"17a3b878","44":"a46000d3","45":"728b952f","46":"3864134a","47":"686713f3","48":"124fa8fd","49":"5d0f4196","50":"0c119da3","51":"9516cca9","52":"c02e1fd4","53":"b11b62d8","54":"268c61b6","55":"f5714dca","56":"d37f70ce","57":"0a850f0c","58":"f758547d","59":"ed8e729c","60":"6abc549e","61":"634d4f6a","62":"03b96f2a","63":"440ebb48","64":"a4d21257","65":"a0dc0b44","66":"2f65de50","67":"315cb987","68":"71b153e3","69":"c5ce39b7","70":"387ce4b9","71":"f2f4d7cc","72":"d13bdce0","73":"b8d03c0a","74":"c735e610","75":"8466d861","76":"cdc27bd2","77":"a5e237c5","78":"167bb187","79":"31b1c044","80":"32b5ecc1","81":"90a63e80","82":"374f838b","83":"4526b894","84":"c4177cfe","85":"ba511e6a","86":"5c5e592a","87":"cd0cd1b7","88":"b99a6817","89":"a38a677f","90":"1211c29f","91":"82ee3b46","92":"2ad9a885","93":"359cced8","94":"3d0e844b","95":"0e67fd3a","96":"18015d22","97":"ada4d33a","98":"d232c049","99":"bc912793","100":"4a1805bf","101":"af465862","102":"680360b1","103":"2edfebde","104":"32d69a05","105":"6860da40","106":"b24316ad","107":"d7e94eab","108":"9ba1d221","109":"33418f67","110":"0dc4fd24","111":"006b2db7","112":"d065a014","113":"30e1da9e","114":"24ff9ca8","115":"658f4ffc","116":"baf3b5ed","117":"5a084d90","118":"94e6bf4e","119":"f79f65c9","120":"0f596d84","121":"7959905e","122":"1d1de52a","123":"78840d84","124":"0c441d47","125":"d10462be","126":"0983dd88","127":"4a336079","128":"b016ee22","129":"5273e909","130":"0a939727","131":"144ac34c","132":"c4d1f253","133":"20271d46","134":"e2e1c04e","135":"135ee05e","136":"2bbacc69","137":"8982d8e7","138":"1e5201d2","139":"5d463a42","140":"cb589800","141":"e27f011b","142":"34da5bf9","143":"e54f9872","144":"e931e173","145":"15098333","146":"1f61766b","147":"ea9c7fe1","148":"0575b57b","149":"c1587ce3","150":"90552ddd","151":"3fde8eae","152":"d446f16e","153":"8dc4d130","154":"c4779c10","155":"a1c171fc","156":"89e4eff0","157":"56d3a1bb","158":"7c965538","159":"a9824885","160":"a9689bac","161":"548d6eff","162":"01a99232","163":"4714a7d7","164":"21a68e7e","165":"fc4a7827","166":"d3c1eba3","167":"7e7980b1","168":"8799e777","169":"07cea438","170":"9be5ae54","171":"083982fc","172":"0384acc6","173":"9b9be8e7","174":"f29772be","175":"509b73d2","176":"3883984d","177":"f4fccbdd","178":"921efbc6","179":"ef84e860","180":"269fb79f","181":"01a6de37","182":"2994ea99","183":"f811710b","184":"787b940f","185":"250d13e2","186":"4db6f6f1","187":"3dc6e5e7","188":"0e5a2f30","189":"bb73f35b","190":"3798bc1a","191":"e4a4cbdf","192":"1b3bbdca","193":"ad0ec94d","194":"b602e5ee","195":"9e10c600","196":"fc964c6c","197":"c059acb3","198":"fbe74af1","199":"f92a3080","200":"90292710","201":"4c94d95d","202":"d1788bf4","203":"f81dd99d","204":"3f343808","205":"814bd070","206":"265f6aa4","207":"826aad26","208":"ea37a8b8","209":"978c86d2","210":"547122ae","211":"d9b9e479","212":"bf17b3a0","213":"dd3ba1c5","214":"b1940df6","215":"6a7d3a63","216":"a63178bb","217":"24e6fb80","218":"2ed8c93b","219":"9fae828e","220":"c9ecb470","221":"d31694a0","222":"8c2e3c02","223":"e7a6a393","224":"5d29b4c6","225":"905c40d4","226":"735e34c4","227":"f84d671b","228":"d6cc0ebb","229":"a72084e8","230":"8b9a7428","231":"8f4497f1","232":"23ffc5f9","233":"d2302cdc","234":"18f9442d","235":"39d6b795","236":"61a16ce4","237":"3bf3a69d","238":"56d29c08","239":"6cc0cf8a","240":"36c229e0","241":"2cb2c51b","242":"7e92bed7","243":"f05888d6"}[chunkId] + ".chunk.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1125);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1334);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__version__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__ = __webpack_require__(61);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["r"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["s"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["t"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["u"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["v"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["w"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["x"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["y"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["z"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["A"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["B"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["C"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["D"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["E"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["F"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["G"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["H"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["I"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["J"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["K"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["L"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["M"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["N"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["O"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["P"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["Q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["R"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["S"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["T"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["U"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["V"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["X"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["Y"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["Z"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_0"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_1"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_2"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_3"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_4"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_5"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_6"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_7"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_8"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_9"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_10"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_11"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_12"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_13"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_14"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_15"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_16"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_17"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_18"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_19"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_20"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_21"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_22"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_23"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_25"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_27"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_28"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_29"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_30"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_31"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_32"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_33"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_34"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_35"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_36"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_37"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_38"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_39"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_40"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_41"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_42"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_43"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_44"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_45"]; });


//# sourceMappingURL=Utilities.js.map

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["d"] = __rest;
/* harmony export (immutable) */ __webpack_exports__["b"] = __decorate;
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* unused harmony export __spreadArrays */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(14);
var core = __webpack_require__(70);
var hide = __webpack_require__(58);
var redefine = __webpack_require__(59);
var ctx = __webpack_require__(71);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(234);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_0__Constants__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_0__Constants__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_0__Constants__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_0__Constants__["k"]; });
/* unused harmony reexport strShimHasOwnProperty */
/* unused harmony reexport strDefault */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Constants__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__Constants__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Constants__["a"]; });
/* unused harmony reexport ObjCreate */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__Constants__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__Constants__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Helpers__ = __webpack_require__(355);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_1__Helpers__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_1__Helpers__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__Helpers__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TsLibShims__ = __webpack_require__(540);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__TsLibShims__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__TsLibShims__["c"]; });
/* unused harmony reexport __restFn */
/* unused harmony reexport __spreadArrayFn */
/* unused harmony reexport __spreadArraysFn */
/* unused harmony reexport __decorateFn */
/* unused harmony reexport __paramFn */
/* unused harmony reexport __metadataFn */
/* unused harmony reexport __createBindingFn */
/* unused harmony reexport __valuesFn */
/* unused harmony reexport __readFn */
/* unused harmony reexport __makeTemplateObjectFn */
/* unused harmony reexport __importDefaultFn */
/* unused harmony reexport __importStarFn */
/* unused harmony reexport __exportStarFn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TsLibGlobals__ = __webpack_require__(1380);
/* unused harmony reexport __exposeGlobalTsLib */
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.




//# sourceMappingURL=applicationinsights-shims.js.map

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__version__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__uifabric_styling__ = __webpack_require__(22);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_styling__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_styling__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_styling__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_styling__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_styling__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_styling__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_styling__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_styling__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_styling__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_styling__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_styling__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_styling__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_styling__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_styling__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_styling__["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_styling__["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_styling__["q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_styling__["r"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_styling__["s"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_styling__["t"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_styling__["u"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_styling__["v"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_styling__["w"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_styling__["x"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_styling__["y"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_styling__["z"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_styling__["A"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_styling__["C"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_styling__["D"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_styling__["E"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_styling__["F"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_styling__["G"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_styling__["H"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_1__uifabric_styling__["I"]; });


//# sourceMappingURL=Styling.js.map

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export propTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return propTypes; });
/* unused harmony export onError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return observer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Observer; });
/* unused harmony export renderReporter */
/* unused harmony export componentByNodeRegistery */
/* unused harmony export trackComponents */
/* unused harmony export useStaticRendering */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Provider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return inject; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);




// These functions can be stubbed out in specific environments
var unstable_batchedUpdates$1 = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();









var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var EventEmitter = function () {
    function EventEmitter() {
        classCallCheck(this, EventEmitter);
        this.listeners = [];
    }

    createClass(EventEmitter, [{
        key: "on",
        value: function on(cb) {
            var _this = this;

            this.listeners.push(cb);
            return function () {
                var index = _this.listeners.indexOf(cb);
                if (index !== -1) _this.listeners.splice(index, 1);
            };
        }
    }, {
        key: "emit",
        value: function emit(data) {
            this.listeners.forEach(function (fn) {
                return fn(data);
            });
        }
    }]);
    return EventEmitter;
}();

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
'use strict';

var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var defineProperty$1 = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

var hoistNonReactStatics = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty$1(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
};

// Copied from React.PropTypes
function createChainableTypeChecker(validate) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        for (var _len = arguments.length, rest = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
            rest[_key - 6] = arguments[_key];
        }

        return Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["o" /* untracked */])(function () {
            componentName = componentName || "<<anonymous>>";
            propFullName = propFullName || propName;
            if (props[propName] == null) {
                if (isRequired) {
                    var actual = props[propName] === null ? "null" : "undefined";
                    return new Error("The " + location + " `" + propFullName + "` is marked as required " + "in `" + componentName + "`, but its value is `" + actual + "`.");
                }
                return null;
            } else {
                return validate.apply(undefined, [props, propName, componentName, location, propFullName].concat(rest));
            }
        });
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}

// Copied from React.PropTypes
function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === "symbol") {
        return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue["@@toStringTag"] === "Symbol") {
        return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === "function" && propValue instanceof Symbol) {
        return true;
    }

    return false;
}

// Copied from React.PropTypes
function getPropType(propValue) {
    var propType = typeof propValue === "undefined" ? "undefined" : _typeof(propValue);
    if (Array.isArray(propValue)) {
        return "array";
    }
    if (propValue instanceof RegExp) {
        // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return "object";
    }
    if (isSymbol(propType, propValue)) {
        return "symbol";
    }
    return propType;
}

// This handles more types than `getPropType`. Only used for error messages.
// Copied from React.PropTypes
function getPreciseType(propValue) {
    var propType = getPropType(propValue);
    if (propType === "object") {
        if (propValue instanceof Date) {
            return "date";
        } else if (propValue instanceof RegExp) {
            return "regexp";
        }
    }
    return propType;
}

function createObservableTypeCheckerCreator(allowNativeType, mobxType) {
    return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["o" /* untracked */])(function () {
            if (allowNativeType) {
                if (getPropType(props[propName]) === mobxType.toLowerCase()) return null;
            }
            var mobxChecker = void 0;
            switch (mobxType) {
                case "Array":
                    mobxChecker = __WEBPACK_IMPORTED_MODULE_0_mobx__["g" /* isObservableArray */];
                    break;
                case "Object":
                    mobxChecker = __WEBPACK_IMPORTED_MODULE_0_mobx__["i" /* isObservableObject */];
                    break;
                case "Map":
                    mobxChecker = __WEBPACK_IMPORTED_MODULE_0_mobx__["h" /* isObservableMap */];
                    break;
                default:
                    throw new Error("Unexpected mobxType: " + mobxType);
            }
            var propValue = props[propName];
            if (!mobxChecker(propValue)) {
                var preciseType = getPreciseType(propValue);
                var nativeTypeExpectationMessage = allowNativeType ? " or javascript `" + mobxType.toLowerCase() + "`" : "";
                return new Error("Invalid prop `" + propFullName + "` of type `" + preciseType + "` supplied to" + " `" + componentName + "`, expected `mobx.Observable" + mobxType + "`" + nativeTypeExpectationMessage + ".");
            }
            return null;
        });
    });
}

function createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
    return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
        for (var _len2 = arguments.length, rest = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
            rest[_key2 - 5] = arguments[_key2];
        }

        return Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["o" /* untracked */])(function () {
            if (typeof typeChecker !== "function") {
                return new Error("Property `" + propFullName + "` of component `" + componentName + "` has " + "invalid PropType notation.");
            }
            var error = createObservableTypeCheckerCreator(allowNativeType, "Array")(props, propName, componentName);
            if (error instanceof Error) return error;
            var propValue = props[propName];
            for (var i = 0; i < propValue.length; i++) {
                error = typeChecker.apply(undefined, [propValue, i, componentName, location, propFullName + "[" + i + "]"].concat(rest));
                if (error instanceof Error) return error;
            }
            return null;
        });
    });
}

var observableArray = createObservableTypeCheckerCreator(false, "Array");
var observableArrayOf = createObservableArrayOfTypeChecker.bind(null, false);
var observableMap = createObservableTypeCheckerCreator(false, "Map");
var observableObject = createObservableTypeCheckerCreator(false, "Object");
var arrayOrObservableArray = createObservableTypeCheckerCreator(true, "Array");
var arrayOrObservableArrayOf = createObservableArrayOfTypeChecker.bind(null, true);
var objectOrObservableObject = createObservableTypeCheckerCreator(true, "Object");



var propTypes = Object.freeze({
	observableArray: observableArray,
	observableArrayOf: observableArrayOf,
	observableMap: observableMap,
	observableObject: observableObject,
	arrayOrObservableArray: arrayOrObservableArray,
	arrayOrObservableArrayOf: arrayOrObservableArrayOf,
	objectOrObservableObject: objectOrObservableObject
});

function isStateless(component) {
    // `function() {}` has prototype, but `() => {}` doesn't
    // `() => {}` via Babel has prototype too.
    return !(component.prototype && component.prototype.render);
}

var injectorContextTypes = {
    mobxStores: objectOrObservableObject
};
Object.seal(injectorContextTypes);

var proxiedInjectorProps = {
    contextTypes: {
        get: function get$$1() {
            return injectorContextTypes;
        },
        set: function set$$1(_) {
            console.warn("Mobx Injector: you are trying to attach `contextTypes` on an component decorated with `inject` (or `observer`) HOC. Please specify the contextTypes on the wrapped component instead. It is accessible through the `wrappedComponent`");
        },
        configurable: true,
        enumerable: false
    },
    isMobxInjector: {
        value: true,
        writable: true,
        configurable: true,
        enumerable: true
    }

    /**
     * Store Injection
     */
};function createStoreInjector(grabStoresFn, component, injectNames) {
    var _class, _temp2;

    var displayName = "inject-" + (component.displayName || component.name || component.constructor && component.constructor.name || "Unknown");
    if (injectNames) displayName += "-with-" + injectNames;

    var Injector = (_temp2 = _class = function (_Component) {
        inherits(Injector, _Component);

        function Injector() {
            var _ref;

            var _temp, _this, _ret;

            classCallCheck(this, Injector);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Injector.__proto__ || Object.getPrototypeOf(Injector)).call.apply(_ref, [this].concat(args))), _this), _this.storeRef = function (instance) {
                _this.wrappedInstance = instance;
            }, _temp), possibleConstructorReturn(_this, _ret);
        }

        createClass(Injector, [{
            key: "render",
            value: function render() {
                // Optimization: it might be more efficient to apply the mapper function *outside* the render method
                // (if the mapper is a function), that could avoid expensive(?) re-rendering of the injector component
                // See this test: 'using a custom injector is not too reactive' in inject.js
                var newProps = {};
                for (var key in this.props) {
                    if (this.props.hasOwnProperty(key)) {
                        newProps[key] = this.props[key];
                    }
                }var additionalProps = grabStoresFn(this.context.mobxStores || {}, newProps, this.context) || {};
                for (var _key2 in additionalProps) {
                    newProps[_key2] = additionalProps[_key2];
                }

                if (!isStateless(component)) {
                    newProps.ref = this.storeRef;
                }

                return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(component, newProps);
            }
        }]);
        return Injector;
    }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.displayName = displayName, _temp2);

    // Static fields from component should be visible on the generated Injector

    hoistNonReactStatics(Injector, component);

    Injector.wrappedComponent = component;
    Object.defineProperties(Injector, proxiedInjectorProps);

    return Injector;
}

function grabStoresByName(storeNames) {
    return function (baseStores, nextProps) {
        storeNames.forEach(function (storeName) {
            if (storeName in nextProps // prefer props over stores
            ) return;
            if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
            nextProps[storeName] = baseStores[storeName];
        });
        return nextProps;
    };
}

/**
 * higher order component that injects stores to a child.
 * takes either a varargs list of strings, which are stores read from the context,
 * or a function that manually maps the available stores from the context to props:
 * storesToProps(mobxStores, props, context) => newProps
 */
function inject() /* fn(stores, nextProps) or ...storeNames */{
    var grabStoresFn = void 0;
    if (typeof arguments[0] === "function") {
        grabStoresFn = arguments[0];
        return function (componentClass) {
            var injected = createStoreInjector(grabStoresFn, componentClass);
            injected.isMobxInjector = false; // supress warning
            // mark the Injector as observer, to make it react to expressions in `grabStoresFn`,
            // see #111
            injected = observer(injected);
            injected.isMobxInjector = true; // restore warning
            return injected;
        };
    } else {
        var storeNames = [];
        for (var i = 0; i < arguments.length; i++) {
            storeNames[i] = arguments[i];
        }grabStoresFn = grabStoresByName(storeNames);
        return function (componentClass) {
            return createStoreInjector(grabStoresFn, componentClass, storeNames.join("-"));
        };
    }
}

/**
 * dev tool support
 */
var isDevtoolsEnabled = false;

var isUsingStaticRendering = false;

var warnedAboutObserverInjectDeprecation = false;

// WeakMap<Node, Object>;
var componentByNodeRegistery = typeof WeakMap !== "undefined" ? new WeakMap() : undefined;
var renderReporter = new EventEmitter();

function findDOMNode$2(component) {
    if (__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"]) {
        try {
            return Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(component);
        } catch (e) {
            // findDOMNode will throw in react-test-renderer, see:
            // See https://github.com/mobxjs/mobx-react/issues/216
            // Is there a better heuristic?
            return null;
        }
    }
    return null;
}

function reportRendering(component) {
    var node = findDOMNode$2(component);
    if (node && componentByNodeRegistery) componentByNodeRegistery.set(node, component);

    renderReporter.emit({
        event: "render",
        renderTime: component.__$mobRenderEnd - component.__$mobRenderStart,
        totalTime: Date.now() - component.__$mobRenderStart,
        component: component,
        node: node
    });
}

function trackComponents() {
    if (typeof WeakMap === "undefined") throw new Error("[mobx-react] tracking components is not supported in this browser.");
    if (!isDevtoolsEnabled) isDevtoolsEnabled = true;
}

function useStaticRendering(useStaticRendering) {
    isUsingStaticRendering = useStaticRendering;
}

/**
 * Errors reporter
 */

var errorsReporter = new EventEmitter();

/**
 * Utilities
 */

function patch(target, funcName) {
    var runMixinFirst = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var base = target[funcName];
    var mixinFunc = reactiveMixin[funcName];
    var f = !base ? mixinFunc : runMixinFirst === true ? function () {
        mixinFunc.apply(this, arguments);
        base.apply(this, arguments);
    } : function () {
        base.apply(this, arguments);
        mixinFunc.apply(this, arguments);
    };

    // MWE: ideally we freeze here to protect against accidental overwrites in component instances, see #195
    // ...but that breaks react-hot-loader, see #231...
    target[funcName] = f;
}

function shallowEqual(objA, objB) {
    //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (is(objA, objB)) return true;
    if ((typeof objA === "undefined" ? "undefined" : _typeof(objA)) !== "object" || objA === null || (typeof objB === "undefined" ? "undefined" : _typeof(objB)) !== "object" || objB === null) {
        return false;
    }
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for (var i = 0; i < keysA.length; i++) {
        if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
            return false;
        }
    }
    return true;
}

function is(x, y) {
    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (x === y) {
        return x !== 0 || 1 / x === 1 / y;
    } else {
        return x !== x && y !== y;
    }
}

/**
 * ReactiveMixin
 */
var reactiveMixin = {
    componentWillMount: function componentWillMount() {
        var _this = this;

        if (isUsingStaticRendering === true) return;
        // Generate friendly name for debugging
        var initialName = this.displayName || this.name || this.constructor && (this.constructor.displayName || this.constructor.name) || "<component>";
        var rootNodeID = this._reactInternalInstance && this._reactInternalInstance._rootNodeID || this._reactInternalFiber && this._reactInternalFiber._debugID;

        /**
         * If props are shallowly modified, react will render anyway,
         * so atom.reportChanged() should not result in yet another re-render
         */
        var skipRender = false;
        /**
         * forceUpdate will re-assign this.props. We don't want that to cause a loop,
         * so detect these changes
         */
        var isForcingUpdate = false;

        function makePropertyObservableReference(propName) {
            var valueHolder = this[propName];
            var atom = new __WEBPACK_IMPORTED_MODULE_0_mobx__["a" /* Atom */]("reactive " + propName);
            Object.defineProperty(this, propName, {
                configurable: true,
                enumerable: true,
                get: function get$$1() {
                    atom.reportObserved();
                    return valueHolder;
                },
                set: function set$$1(v) {
                    if (!isForcingUpdate && !shallowEqual(valueHolder, v)) {
                        valueHolder = v;
                        skipRender = true;
                        atom.reportChanged();
                        skipRender = false;
                    } else {
                        valueHolder = v;
                    }
                }
            });
        }

        // make this.props an observable reference, see #124
        makePropertyObservableReference.call(this, "props");
        // make state an observable reference
        makePropertyObservableReference.call(this, "state");

        // wire up reactive render
        var baseRender = this.render.bind(this);
        var reaction = null;
        var isRenderingPending = false;

        var initialRender = function initialRender() {
            reaction = new __WEBPACK_IMPORTED_MODULE_0_mobx__["b" /* Reaction */](initialName + "#" + rootNodeID + ".render()", function () {
                if (!isRenderingPending) {
                    // N.B. Getting here *before mounting* means that a component constructor has side effects (see the relevant test in misc.js)
                    // This unidiomatic React usage but React will correctly warn about this so we continue as usual
                    // See #85 / Pull #44
                    isRenderingPending = true;
                    if (typeof _this.componentWillReact === "function") _this.componentWillReact(); // TODO: wrap in action?
                    if (_this.__$mobxIsUnmounted !== true) {
                        // If we are unmounted at this point, componentWillReact() had a side effect causing the component to unmounted
                        // TODO: remove this check? Then react will properly warn about the fact that this should not happen? See #73
                        // However, people also claim this migth happen during unit tests..
                        var hasError = true;
                        try {
                            isForcingUpdate = true;
                            if (!skipRender) __WEBPACK_IMPORTED_MODULE_1_react__["Component"].prototype.forceUpdate.call(_this);
                            hasError = false;
                        } finally {
                            isForcingUpdate = false;
                            if (hasError) reaction.dispose();
                        }
                    }
                }
            });
            reaction.reactComponent = _this;
            reactiveRender.$mobx = reaction;
            _this.render = reactiveRender;
            return reactiveRender();
        };

        var reactiveRender = function reactiveRender() {
            isRenderingPending = false;
            var exception = undefined;
            var rendering = undefined;
            reaction.track(function () {
                if (isDevtoolsEnabled) {
                    _this.__$mobRenderStart = Date.now();
                }
                try {
                    rendering = __WEBPACK_IMPORTED_MODULE_0_mobx__["f" /* extras */].allowStateChanges(false, baseRender);
                } catch (e) {
                    exception = e;
                }
                if (isDevtoolsEnabled) {
                    _this.__$mobRenderEnd = Date.now();
                }
            });
            if (exception) {
                errorsReporter.emit(exception);
                throw exception;
            }
            return rendering;
        };

        this.render = initialRender;
    },

    componentWillUnmount: function componentWillUnmount() {
        if (isUsingStaticRendering === true) return;
        this.render.$mobx && this.render.$mobx.dispose();
        this.__$mobxIsUnmounted = true;
        if (isDevtoolsEnabled) {
            var node = findDOMNode$2(this);
            if (node && componentByNodeRegistery) {
                componentByNodeRegistery.delete(node);
            }
            renderReporter.emit({
                event: "destroy",
                component: this,
                node: node
            });
        }
    },

    componentDidMount: function componentDidMount() {
        if (isDevtoolsEnabled) {
            reportRendering(this);
        }
    },

    componentDidUpdate: function componentDidUpdate() {
        if (isDevtoolsEnabled) {
            reportRendering(this);
        }
    },

    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
        if (isUsingStaticRendering) {
            console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
        }
        // update on any state changes (as is the default)
        if (this.state !== nextState) {
            return true;
        }
        // update if props are shallowly not equal, inspired by PureRenderMixin
        // we could return just 'false' here, and avoid the `skipRender` checks etc
        // however, it is nicer if lifecycle events are triggered like usually,
        // so we return true here if props are shallowly modified.
        return !shallowEqual(this.props, nextProps);
    }

    /**
     * Observer function / decorator
     */
};function observer(arg1, arg2) {
    if (typeof arg1 === "string") {
        throw new Error("Store names should be provided as array");
    }
    if (Array.isArray(arg1)) {
        // component needs stores
        if (!warnedAboutObserverInjectDeprecation) {
            warnedAboutObserverInjectDeprecation = true;
            console.warn('Mobx observer: Using observer to inject stores is deprecated since 4.0. Use `@inject("store1", "store2") @observer ComponentClass` or `inject("store1", "store2")(observer(componentClass))` instead of `@observer(["store1", "store2"]) ComponentClass`');
        }
        if (!arg2) {
            // invoked as decorator
            return function (componentClass) {
                return observer(arg1, componentClass);
            };
        } else {
            return inject.apply(null, arg1)(observer(arg2));
        }
    }
    var componentClass = arg1;

    if (componentClass.isMobxInjector === true) {
        console.warn("Mobx observer: You are trying to use 'observer' on a component that already has 'inject'. Please apply 'observer' before applying 'inject'");
    }

    // Stateless function component:
    // If it is function but doesn't seem to be a react class constructor,
    // wrap it to a react class automatically
    if (typeof componentClass === "function" && (!componentClass.prototype || !componentClass.prototype.render) && !componentClass.isReactClass && !__WEBPACK_IMPORTED_MODULE_1_react__["Component"].isPrototypeOf(componentClass)) {
        var _class, _temp;

        return observer((_temp = _class = function (_Component) {
            inherits(_class, _Component);

            function _class() {
                classCallCheck(this, _class);
                return possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
            }

            createClass(_class, [{
                key: "render",
                value: function render() {
                    return componentClass.call(this, this.props, this.context);
                }
            }]);
            return _class;
        }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.displayName = componentClass.displayName || componentClass.name, _class.contextTypes = componentClass.contextTypes, _class.propTypes = componentClass.propTypes, _class.defaultProps = componentClass.defaultProps, _temp));
    }

    if (!componentClass) {
        throw new Error("Please pass a valid component to 'observer'");
    }

    var target = componentClass.prototype || componentClass;
    mixinLifecycleEvents(target);
    componentClass.isMobXReactObserver = true;
    return componentClass;
}

function mixinLifecycleEvents(target) {
    patch(target, "componentWillMount", true);["componentDidMount", "componentWillUnmount", "componentDidUpdate"].forEach(function (funcName) {
        patch(target, funcName);
    });
    if (!target.shouldComponentUpdate) {
        target.shouldComponentUpdate = reactiveMixin.shouldComponentUpdate;
    }
}

// TODO: support injection somehow as well?
var Observer = observer(function (_ref) {
    var children = _ref.children,
        observerInject = _ref.inject,
        render = _ref.render;

    var component = children || render;
    if (typeof component === "undefined") {
        return null;
    }
    if (!observerInject) {
        return component();
    }
    var InjectComponent = inject(observerInject)(component);
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InjectComponent, null);
});

Observer.displayName = "Observer";

var ObserverPropsCheck = function ObserverPropsCheck(props, key, componentName, location, propFullName) {
    var extraKey = key === "children" ? "render" : "children";
    if (typeof props[key] === "function" && typeof props[extraKey] === "function") {
        return new Error("Invalid prop,do not use children and render in the same time in`" + componentName);
    }

    if (typeof props[key] === "function" || typeof props[extraKey] === "function") {
        return;
    }
    return new Error("Invalid prop `" + propFullName + "` of type `" + _typeof(props[key]) + "` supplied to" + " `" + componentName + "`, expected `function`.");
};

Observer.propTypes = {
    render: ObserverPropsCheck,
    children: ObserverPropsCheck
};

var _class;
var _temp;

var specialReactKeys = { children: true, key: true, ref: true };

var Provider = (_temp = _class = function (_Component) {
    inherits(Provider, _Component);

    function Provider() {
        classCallCheck(this, Provider);
        return possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).apply(this, arguments));
    }

    createClass(Provider, [{
        key: "render",
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
        }
    }, {
        key: "getChildContext",
        value: function getChildContext() {
            var stores = {};
            // inherit stores
            var baseStores = this.context.mobxStores;
            if (baseStores) for (var key in baseStores) {
                stores[key] = baseStores[key];
            }
            // add own stores
            for (var _key in this.props) {
                if (!specialReactKeys[_key] && _key !== "suppressChangedStoreWarning") stores[_key] = this.props[_key];
            }return {
                mobxStores: stores
            };
        }
    }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            // Maybe this warning is too aggressive?
            if (Object.keys(nextProps).length !== Object.keys(this.props).length) console.warn("MobX Provider: The set of provided stores has changed. Please avoid changing stores as the change might not propagate to all children");
            if (!nextProps.suppressChangedStoreWarning) for (var key in nextProps) {
                if (!specialReactKeys[key] && this.props[key] !== nextProps[key]) console.warn("MobX Provider: Provided store '" + key + "' has changed. Please avoid replacing stores as the change might not propagate to all children");
            }
        }
    }]);
    return Provider;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.contextTypes = {
    mobxStores: objectOrObservableObject
}, _class.childContextTypes = {
    mobxStores: objectOrObservableObject.isRequired
}, _temp);

if (!__WEBPACK_IMPORTED_MODULE_1_react__["Component"]) throw new Error("mobx-react requires React to be available");
if (!__WEBPACK_IMPORTED_MODULE_0_mobx__["f" /* extras */]) throw new Error("mobx-react requires mobx to be available");

if (typeof __WEBPACK_IMPORTED_MODULE_2_react_dom__["unstable_batchedUpdates"] === "function") __WEBPACK_IMPORTED_MODULE_0_mobx__["f" /* extras */].setReactionScheduler(__WEBPACK_IMPORTED_MODULE_2_react_dom__["unstable_batchedUpdates"]);else if (typeof unstable_batchedUpdates$1 === "function") __WEBPACK_IMPORTED_MODULE_0_mobx__["f" /* extras */].setReactionScheduler(unstable_batchedUpdates$1);

var onError = function onError(fn) {
    return errorsReporter.on(fn);
};

/* DevTool support */
// See: https://github.com/andykog/mobx-devtools/blob/d8976c24b8cb727ed59f9a0bc905a009df79e221/src/backend/installGlobalHook.js

if ((typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "undefined" ? "undefined" : _typeof(__MOBX_DEVTOOLS_GLOBAL_HOOK__)) === "object") {
    var mobx$1 = { spy: __WEBPACK_IMPORTED_MODULE_0_mobx__["m" /* spy */], extras: __WEBPACK_IMPORTED_MODULE_0_mobx__["f" /* extras */] };
    var mobxReact = { renderReporter: renderReporter, componentByNodeRegistery: componentByNodeRegistery, trackComponents: trackComponents };
    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobxReact(mobxReact, mobx$1);
}




/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return extras; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Reaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return untracked; });
/* unused harmony export IDerivationState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Atom; });
/* unused harmony export BaseAtom */
/* unused harmony export useStrict */
/* unused harmony export isStrictModeEnabled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return spy; });
/* unused harmony export comparer */
/* unused harmony export asReference */
/* unused harmony export asFlat */
/* unused harmony export asStructure */
/* unused harmony export asMap */
/* unused harmony export isModifierDescriptor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isObservableObject; });
/* unused harmony export isBoxedObservable */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isObservableArray; });
/* unused harmony export ObservableMap */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isObservableMap; });
/* unused harmony export map */
/* unused harmony export transaction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return observable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return computed; });
/* unused harmony export isObservable */
/* unused harmony export isComputed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return extendObservable; });
/* unused harmony export extendShallowObservable */
/* unused harmony export observe */
/* unused harmony export intercept */
/* unused harmony export autorun */
/* unused harmony export autorunAsync */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return when; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return reaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return action; });
/* unused harmony export isAction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return runInAction; });
/* unused harmony export expr */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return toJS; });
/* unused harmony export createTransformer */
/* unused harmony export whyRun */
/* unused harmony export trace */
/* unused harmony export isArrayLike */
/** MobX - (c) Michel Weststrate 2015, 2016 - MIT Licensed */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

/**
 * Anything that can be used to _store_ state is an Atom in mobx. Atoms have two important jobs
 *
 * 1) detect when they are being _used_ and report this (using reportObserved). This allows mobx to make the connection between running functions and the data they used
 * 2) they should notify mobx whenever they have _changed_. This way mobx can re-run any functions (derivations) that are using this atom.
 */
var BaseAtom = /** @class */ (function () {
    /**
     * Create a new atom. For debugging purposes it is recommended to give it a name.
     * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
     */
    function BaseAtom(name) {
        if (name === void 0) { name = "Atom@" + getNextId(); }
        this.name = name;
        this.isPendingUnobservation = true; // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
        this.observers = [];
        this.observersIndexes = {};
        this.diffValue = 0;
        this.lastAccessedBy = 0;
        this.lowestObserverState = IDerivationState.NOT_TRACKING;
    }
    BaseAtom.prototype.onBecomeUnobserved = function () {
        // noop
    };
    /**
     * Invoke this method to notify mobx that your atom has been used somehow.
     */
    BaseAtom.prototype.reportObserved = function () {
        reportObserved(this);
    };
    /**
     * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
     */
    BaseAtom.prototype.reportChanged = function () {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    BaseAtom.prototype.toString = function () {
        return this.name;
    };
    return BaseAtom;
}());
var Atom = /** @class */ (function (_super) {
    __extends(Atom, _super);
    /**
     * Create a new atom. For debugging purposes it is recommended to give it a name.
     * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
     */
    function Atom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
        if (name === void 0) { name = "Atom@" + getNextId(); }
        if (onBecomeObservedHandler === void 0) { onBecomeObservedHandler = noop; }
        if (onBecomeUnobservedHandler === void 0) { onBecomeUnobservedHandler = noop; }
        var _this = _super.call(this, name) || this;
        _this.name = name;
        _this.onBecomeObservedHandler = onBecomeObservedHandler;
        _this.onBecomeUnobservedHandler = onBecomeUnobservedHandler;
        _this.isPendingUnobservation = false; // for effective unobserving.
        _this.isBeingTracked = false;
        return _this;
    }
    Atom.prototype.reportObserved = function () {
        startBatch();
        _super.prototype.reportObserved.call(this);
        if (!this.isBeingTracked) {
            this.isBeingTracked = true;
            this.onBecomeObservedHandler();
        }
        endBatch();
        return !!globalState.trackingDerivation;
        // return doesn't really give useful info, because it can be as well calling computed which calls atom (no reactions)
        // also it could not trigger when calculating reaction dependent on Atom because Atom's value was cached by computed called by given reaction.
    };
    Atom.prototype.onBecomeUnobserved = function () {
        this.isBeingTracked = false;
        this.onBecomeUnobservedHandler();
    };
    return Atom;
}(BaseAtom));
var isAtom = createInstanceofPredicate("Atom", BaseAtom);

function hasInterceptors(interceptable) {
    return interceptable.interceptors && interceptable.interceptors.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors || (interceptable.interceptors = []);
    interceptors.push(handler);
    return once(function () {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1)
            interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        var interceptors = interceptable.interceptors;
        if (interceptors)
            for (var i = 0, l = interceptors.length; i < l; i++) {
                change = interceptors[i](change);
                invariant(!change || change.type, "Intercept handlers should return nothing or a change object");
                if (!change)
                    break;
            }
        return change;
    }
    finally {
        untrackedEnd(prevU);
    }
}

function hasListeners(listenable) {
    return listenable.changeListeners && listenable.changeListeners.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners || (listenable.changeListeners = []);
    listeners.push(handler);
    return once(function () {
        var idx = listeners.indexOf(handler);
        if (idx !== -1)
            listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners;
    if (!listeners)
        return;
    listeners = listeners.slice();
    for (var i = 0, l = listeners.length; i < l; i++) {
        listeners[i](change);
    }
    untrackedEnd(prevU);
}

function isSpyEnabled() {
    return !!globalState.spyListeners.length;
}
function spyReport(event) {
    if (!globalState.spyListeners.length)
        return;
    var listeners = globalState.spyListeners;
    for (var i = 0, l = listeners.length; i < l; i++)
        listeners[i](event);
}
function spyReportStart(event) {
    var change = objectAssign({}, event, { spyReportStart: true });
    spyReport(change);
}
var END_EVENT = { spyReportEnd: true };
function spyReportEnd(change) {
    if (change)
        spyReport(objectAssign({}, change, END_EVENT));
    else
        spyReport(END_EVENT);
}
function spy(listener) {
    globalState.spyListeners.push(listener);
    return once(function () {
        var idx = globalState.spyListeners.indexOf(listener);
        if (idx !== -1)
            globalState.spyListeners.splice(idx, 1);
    });
}

function iteratorSymbol() {
    return (typeof Symbol === "function" && Symbol.iterator) || "@@iterator";
}
var IS_ITERATING_MARKER = "__$$iterating";
function arrayAsIterator(array) {
    // returning an array for entries(), values() etc for maps was a mis-interpretation of the specs..,
    // yet it is quite convenient to be able to use the response both as array directly and as iterator
    // it is suboptimal, but alas...
    invariant(array[IS_ITERATING_MARKER] !== true, "Illegal state: cannot recycle array as iterator");
    addHiddenFinalProp(array, IS_ITERATING_MARKER, true);
    var idx = -1;
    addHiddenFinalProp(array, "next", function next() {
        idx++;
        return {
            done: idx >= this.length,
            value: idx < this.length ? this[idx] : undefined
        };
    });
    return array;
}
function declareIterator(prototType, iteratorFactory) {
    addHiddenFinalProp(prototType, iteratorSymbol(), iteratorFactory);
}

var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
// Detects bug in safari 9.1.1 (or iOS 9 safari mobile). See #364
var safariPrototypeSetterInheritanceBug = (function () {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function () {
            v = true;
        }
    });
    Object.create(p)["0"] = 1;
    return v === false;
})();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */
var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = /** @class */ (function () {
    function StubArray() {
    }
    return StubArray;
}());
function inherit(ctor, proto) {
    if (typeof Object["setPrototypeOf"] !== "undefined") {
        Object["setPrototypeOf"](ctor.prototype, proto);
    }
    else if (typeof ctor.prototype.__proto__ !== "undefined") {
        ctor.prototype.__proto__ = proto;
    }
    else {
        ctor["prototype"] = proto;
    }
}
inherit(StubArray, Array.prototype);
// Weex freeze Array.prototype
// Make them writeable and configurable in prototype chain
// https://github.com/alibaba/weex/pull/1529
if (Object.isFrozen(Array)) {
    
    [
        "constructor",
        "push",
        "shift",
        "concat",
        "pop",
        "unshift",
        "replace",
        "find",
        "findIndex",
        "splice",
        "reverse",
        "sort"
    ].forEach(function (key) {
        Object.defineProperty(StubArray.prototype, key, {
            configurable: true,
            writable: true,
            value: Array.prototype[key]
        });
    });
}
var ObservableArrayAdministration = /** @class */ (function () {
    function ObservableArrayAdministration(name, enhancer, array, owned) {
        this.array = array;
        this.owned = owned;
        this.values = [];
        this.lastKnownLength = 0;
        this.interceptors = null;
        this.changeListeners = null;
        this.atom = new BaseAtom(name || "ObservableArray@" + getNextId());
        this.enhancer = function (newV, oldV) { return enhancer(newV, oldV, name + "[..]"); };
    }
    ObservableArrayAdministration.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined)
            return this.dehancer(value);
        return value;
    };
    ObservableArrayAdministration.prototype.dehanceValues = function (values) {
        if (this.dehancer !== undefined)
            return values.map(this.dehancer);
        return values;
    };
    ObservableArrayAdministration.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableArrayAdministration.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately === void 0) { fireImmediately = false; }
        if (fireImmediately) {
            listener({
                object: this.array,
                type: "splice",
                index: 0,
                added: this.values.slice(),
                addedCount: this.values.length,
                removed: [],
                removedCount: 0
            });
        }
        return registerListener(this, listener);
    };
    ObservableArrayAdministration.prototype.getArrayLength = function () {
        this.atom.reportObserved();
        return this.values.length;
    };
    ObservableArrayAdministration.prototype.setArrayLength = function (newLength) {
        if (typeof newLength !== "number" || newLength < 0)
            throw new Error("[mobx.array] Out of range: " + newLength);
        var currentLength = this.values.length;
        if (newLength === currentLength)
            return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for (var i = 0; i < newLength - currentLength; i++)
                newItems[i] = undefined; // No Array.fill everywhere...
            this.spliceWithArray(currentLength, 0, newItems);
        }
        else
            this.spliceWithArray(newLength, currentLength - newLength);
    };
    // adds / removes the necessary numeric properties to this object
    ObservableArrayAdministration.prototype.updateArrayLength = function (oldLength, delta) {
        if (oldLength !== this.lastKnownLength)
            throw new Error("[mobx] Modification exception: the internal structure of an observable array was changed. Did you use peek() to change it?");
        this.lastKnownLength += delta;
        if (delta > 0 && oldLength + delta + 1 > OBSERVABLE_ARRAY_BUFFER_SIZE)
            reserveArrayBuffer(oldLength + delta + 1);
    };
    ObservableArrayAdministration.prototype.spliceWithArray = function (index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom);
        var length = this.values.length;
        if (index === undefined)
            index = 0;
        else if (index > length)
            index = length;
        else if (index < 0)
            index = Math.max(0, length + index);
        if (arguments.length === 1)
            deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null)
            deleteCount = 0;
        else
            deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined)
            newItems = [];
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.array,
                type: "splice",
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change)
                return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.map(function (v) { return _this.enhancer(v, undefined); });
        var lengthDelta = newItems.length - deleteCount;
        this.updateArrayLength(length, lengthDelta); // create or remove new entries
        var res = this.spliceItemsIntoValues(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0)
            this.notifyArraySplice(index, newItems, res);
        return this.dehanceValues(res);
    };
    ObservableArrayAdministration.prototype.spliceItemsIntoValues = function (index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            return (_a = this.values).splice.apply(_a, [index, deleteCount].concat(newItems));
        }
        else {
            var res = this.values.slice(index, index + deleteCount);
            this.values = this.values
                .slice(0, index)
                .concat(newItems, this.values.slice(index + deleteCount));
            return res;
        }
        var _a;
    };
    ObservableArrayAdministration.prototype.notifyArrayChildUpdate = function (index, newValue, oldValue) {
        var notifySpy = !this.owned && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                object: this.array,
                type: "update",
                index: index,
                newValue: newValue,
                oldValue: oldValue
            }
            : null;
        if (notifySpy)
            spyReportStart(change);
        this.atom.reportChanged();
        if (notify)
            notifyListeners(this, change);
        if (notifySpy)
            spyReportEnd();
    };
    ObservableArrayAdministration.prototype.notifyArraySplice = function (index, added, removed) {
        var notifySpy = !this.owned && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                object: this.array,
                type: "splice",
                index: index,
                removed: removed,
                added: added,
                removedCount: removed.length,
                addedCount: added.length
            }
            : null;
        if (notifySpy)
            spyReportStart(change);
        this.atom.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify)
            notifyListeners(this, change);
        if (notifySpy)
            spyReportEnd();
    };
    return ObservableArrayAdministration;
}());
var ObservableArray = /** @class */ (function (_super) {
    __extends(ObservableArray, _super);
    function ObservableArray(initialValues, enhancer, name, owned) {
        if (name === void 0) { name = "ObservableArray@" + getNextId(); }
        if (owned === void 0) { owned = false; }
        var _this = _super.call(this) || this;
        var adm = new ObservableArrayAdministration(name, enhancer, _this, owned);
        addHiddenFinalProp(_this, "$mobx", adm);
        if (initialValues && initialValues.length) {
            _this.spliceWithArray(0, 0, initialValues);
        }
        if (safariPrototypeSetterInheritanceBug) {
            // Seems that Safari won't use numeric prototype setter untill any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(adm.array, "0", ENTRY_0);
        }
        return _this;
    }
    ObservableArray.prototype.intercept = function (handler) {
        return this.$mobx.intercept(handler);
    };
    ObservableArray.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately === void 0) { fireImmediately = false; }
        return this.$mobx.observe(listener, fireImmediately);
    };
    ObservableArray.prototype.clear = function () {
        return this.splice(0);
    };
    ObservableArray.prototype.concat = function () {
        var arrays = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arrays[_i] = arguments[_i];
        }
        this.$mobx.atom.reportObserved();
        return Array.prototype.concat.apply(this.peek(), arrays.map(function (a) { return (isObservableArray(a) ? a.peek() : a); }));
    };
    ObservableArray.prototype.replace = function (newItems) {
        return this.$mobx.spliceWithArray(0, this.$mobx.values.length, newItems);
    };
    /**
     * Converts this array back to a (shallow) javascript structure.
     * For a deep clone use mobx.toJS
     */
    ObservableArray.prototype.toJS = function () {
        return this.slice();
    };
    ObservableArray.prototype.toJSON = function () {
        // Used by JSON.stringify
        return this.toJS();
    };
    ObservableArray.prototype.peek = function () {
        this.$mobx.atom.reportObserved();
        return this.$mobx.dehanceValues(this.$mobx.values);
    };
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
    ObservableArray.prototype.find = function (predicate, thisArg, fromIndex) {
        if (fromIndex === void 0) { fromIndex = 0; }
        var idx = this.findIndex.apply(this, arguments);
        return idx === -1 ? undefined : this.get(idx);
    };
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
    ObservableArray.prototype.findIndex = function (predicate, thisArg, fromIndex) {
        if (fromIndex === void 0) { fromIndex = 0; }
        var items = this.peek(), l = items.length;
        for (var i = fromIndex; i < l; i++)
            if (predicate.call(thisArg, items[i], i, this))
                return i;
        return -1;
    };
    /*
     * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
     * since these functions alter the inner structure of the array, the have side effects.
     * Because the have side effects, they should not be used in computed function,
     * and for that reason the do not call dependencyState.notifyObserved
     */
    ObservableArray.prototype.splice = function (index, deleteCount) {
        var newItems = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            newItems[_i - 2] = arguments[_i];
        }
        switch (arguments.length) {
            case 0:
                return [];
            case 1:
                return this.$mobx.spliceWithArray(index);
            case 2:
                return this.$mobx.spliceWithArray(index, deleteCount);
        }
        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
    };
    ObservableArray.prototype.spliceWithArray = function (index, deleteCount, newItems) {
        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
    };
    ObservableArray.prototype.push = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var adm = this.$mobx;
        adm.spliceWithArray(adm.values.length, 0, items);
        return adm.values.length;
    };
    ObservableArray.prototype.pop = function () {
        return this.splice(Math.max(this.$mobx.values.length - 1, 0), 1)[0];
    };
    ObservableArray.prototype.shift = function () {
        return this.splice(0, 1)[0];
    };
    ObservableArray.prototype.unshift = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var adm = this.$mobx;
        adm.spliceWithArray(0, 0, items);
        return adm.values.length;
    };
    ObservableArray.prototype.reverse = function () {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        // so we deviate from the default and just make it an dervitation
        var clone = this.slice();
        return clone.reverse.apply(clone, arguments);
    };
    ObservableArray.prototype.sort = function (compareFn) {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        var clone = this.slice();
        return clone.sort.apply(clone, arguments);
    };
    ObservableArray.prototype.remove = function (value) {
        var idx = this.$mobx.dehanceValues(this.$mobx.values).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    };
    ObservableArray.prototype.move = function (fromIndex, toIndex) {
        function checkIndex(index) {
            if (index < 0) {
                throw new Error("[mobx.array] Index out of bounds: " + index + " is negative");
            }
            var length = this.$mobx.values.length;
            if (index >= length) {
                throw new Error("[mobx.array] Index out of bounds: " + index + " is not smaller than " + length);
            }
        }
        checkIndex.call(this, fromIndex);
        checkIndex.call(this, toIndex);
        if (fromIndex === toIndex) {
            return;
        }
        var oldItems = this.$mobx.values;
        var newItems;
        if (fromIndex < toIndex) {
            newItems = oldItems.slice(0, fromIndex).concat(oldItems.slice(fromIndex + 1, toIndex + 1), [
                oldItems[fromIndex]
            ], oldItems.slice(toIndex + 1));
        }
        else {
            // toIndex < fromIndex
            newItems = oldItems.slice(0, toIndex).concat([
                oldItems[fromIndex]
            ], oldItems.slice(toIndex, fromIndex), oldItems.slice(fromIndex + 1));
        }
        this.replace(newItems);
    };
    // See #734, in case property accessors are unreliable...
    ObservableArray.prototype.get = function (index) {
        var impl = this.$mobx;
        if (impl) {
            if (index < impl.values.length) {
                impl.atom.reportObserved();
                return impl.dehanceValue(impl.values[index]);
            }
            console.warn("[mobx.array] Attempt to read an array index (" + index + ") that is out of bounds (" + impl
                .values
                .length + "). Please check length first. Out of bound indices will not be tracked by MobX");
        }
        return undefined;
    };
    // See #734, in case property accessors are unreliable...
    ObservableArray.prototype.set = function (index, newValue) {
        var adm = this.$mobx;
        var values = adm.values;
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(adm.atom);
            var oldValue = values[index];
            if (hasInterceptors(adm)) {
                var change = interceptChange(adm, {
                    type: "update",
                    object: this,
                    index: index,
                    newValue: newValue
                });
                if (!change)
                    return;
                newValue = change.newValue;
            }
            newValue = adm.enhancer(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                adm.notifyArrayChildUpdate(index, newValue, oldValue);
            }
        }
        else if (index === values.length) {
            // add a new item
            adm.spliceWithArray(index, 0, [newValue]);
        }
        else {
            // out of bounds
            throw new Error("[mobx.array] Index out of bounds, " + index + " is larger than " + values.length);
        }
    };
    return ObservableArray;
}(StubArray));
declareIterator(ObservableArray.prototype, function () {
    return arrayAsIterator(this.slice());
});
Object.defineProperty(ObservableArray.prototype, "length", {
    enumerable: false,
    configurable: true,
    get: function () {
        return this.$mobx.getArrayLength();
    },
    set: function (newLength) {
        this.$mobx.setArrayLength(newLength);
    }
});
[
    "every",
    "filter",
    "forEach",
    "indexOf",
    "join",
    "lastIndexOf",
    "map",
    "reduce",
    "reduceRight",
    "slice",
    "some",
    "toString",
    "toLocaleString"
].forEach(function (funcName) {
    var baseFunc = Array.prototype[funcName];
    invariant(typeof baseFunc === "function", "Base function not defined on Array prototype: '" + funcName + "'");
    addHiddenProp(ObservableArray.prototype, funcName, function () {
        return baseFunc.apply(this.peek(), arguments);
    });
});
/**
 * We don't want those to show up in `for (const key in ar)` ...
 */
makeNonEnumerable(ObservableArray.prototype, [
    "constructor",
    "intercept",
    "observe",
    "clear",
    "concat",
    "get",
    "replace",
    "toJS",
    "toJSON",
    "peek",
    "find",
    "findIndex",
    "splice",
    "spliceWithArray",
    "push",
    "pop",
    "set",
    "shift",
    "unshift",
    "reverse",
    "sort",
    "remove",
    "move",
    "toString",
    "toLocaleString"
]);
// See #364
var ENTRY_0 = createArrayEntryDescriptor(0);
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: false,
        get: function () {
            // TODO: Check `this`?, see #752?
            return this.get(index);
        },
        set: function (value) {
            this.set(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    Object.defineProperty(ObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    for (var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max; index++)
        createArrayBufferItem(index);
    OBSERVABLE_ARRAY_BUFFER_SIZE = max;
}
reserveArrayBuffer(1000);
var isObservableArrayAdministration = createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing.$mobx);
}

var UNCHANGED = {};
var ObservableValue = /** @class */ (function (_super) {
    __extends(ObservableValue, _super);
    function ObservableValue(value, enhancer, name, notifySpy) {
        if (name === void 0) { name = "ObservableValue@" + getNextId(); }
        if (notifySpy === void 0) { notifySpy = true; }
        var _this = _super.call(this, name) || this;
        _this.enhancer = enhancer;
        _this.hasUnreportedChange = false;
        _this.dehancer = undefined;
        _this.value = enhancer(value, undefined, name);
        if (notifySpy && isSpyEnabled()) {
            // only notify spy if this is a stand-alone observable
            spyReport({ type: "create", object: _this, newValue: _this.value });
        }
        return _this;
    }
    ObservableValue.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined)
            return this.dehancer(value);
        return value;
    };
    ObservableValue.prototype.set = function (newValue) {
        var oldValue = this.value;
        newValue = this.prepareNewValue(newValue);
        if (newValue !== UNCHANGED) {
            var notifySpy = isSpyEnabled();
            if (notifySpy) {
                spyReportStart({
                    type: "update",
                    object: this,
                    newValue: newValue,
                    oldValue: oldValue
                });
            }
            this.setNewValue(newValue);
            if (notifySpy)
                spyReportEnd();
        }
    };
    ObservableValue.prototype.prepareNewValue = function (newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: "update",
                newValue: newValue
            });
            if (!change)
                return UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value, this.name);
        return this.value !== newValue ? newValue : UNCHANGED;
    };
    ObservableValue.prototype.setNewValue = function (newValue) {
        var oldValue = this.value;
        this.value = newValue;
        this.reportChanged();
        if (hasListeners(this)) {
            notifyListeners(this, {
                type: "update",
                object: this,
                newValue: newValue,
                oldValue: oldValue
            });
        }
    };
    ObservableValue.prototype.get = function () {
        this.reportObserved();
        return this.dehanceValue(this.value);
    };
    ObservableValue.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableValue.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately)
            listener({
                object: this,
                type: "update",
                newValue: this.value,
                oldValue: undefined
            });
        return registerListener(this, listener);
    };
    ObservableValue.prototype.toJSON = function () {
        return this.get();
    };
    ObservableValue.prototype.toString = function () {
        return this.name + "[" + this.value + "]";
    };
    ObservableValue.prototype.valueOf = function () {
        return toPrimitive(this.get());
    };
    return ObservableValue;
}(BaseAtom));
ObservableValue.prototype[primitiveSymbol()] = ObservableValue.prototype.valueOf;
var isObservableValue = createInstanceofPredicate("ObservableValue", ObservableValue);

var messages = {
    m001: "It is not allowed to assign new values to @action fields",
    m002: "`runInAction` expects a function",
    m003: "`runInAction` expects a function without arguments",
    m004: "autorun expects a function",
    m005: "Warning: attempted to pass an action to autorun. Actions are untracked and will not trigger on state changes. Use `reaction` or wrap only your state modification code in an action.",
    m006: "Warning: attempted to pass an action to autorunAsync. Actions are untracked and will not trigger on state changes. Use `reaction` or wrap only your state modification code in an action.",
    m007: "reaction only accepts 2 or 3 arguments. If migrating from MobX 2, please provide an options object",
    m008: "wrapping reaction expression in `asReference` is no longer supported, use options object instead",
    m009: "@computed can only be used on getter functions, like: '@computed get myProps() { return ...; }'. It looks like it was used on a property.",
    m010: "@computed can only be used on getter functions, like: '@computed get myProps() { return ...; }'",
    m011: "First argument to `computed` should be an expression. If using computed as decorator, don't pass it arguments",
    m012: "computed takes one or two arguments if used as function",
    m013: "[mobx.expr] 'expr' should only be used inside other reactive functions.",
    m014: "extendObservable expected 2 or more arguments",
    m015: "extendObservable expects an object as first argument",
    m016: "extendObservable should not be used on maps, use map.merge instead",
    m017: "all arguments of extendObservable should be objects",
    m018: "extending an object with another observable (object) is not supported. Please construct an explicit propertymap, using `toJS` if need. See issue #540",
    m019: "[mobx.isObservable] isObservable(object, propertyName) is not supported for arrays and maps. Use map.has or array.length instead.",
    m020: "modifiers can only be used for individual object properties",
    m021: "observable expects zero or one arguments",
    m022: "@observable can not be used on getters, use @computed instead",
    m024: "whyRun() can only be used if a derivation is active, or by passing an computed value / reaction explicitly. If you invoked whyRun from inside a computation; the computation is currently suspended but re-evaluating because somebody requested its value.",
    m025: "whyRun can only be used on reactions and computed values",
    m026: "`action` can only be invoked on functions",
    m028: "It is not allowed to set `useStrict` when a derivation is running",
    m029: "INTERNAL ERROR only onBecomeUnobserved shouldn't be called twice in a row",
    m030a: "Since strict-mode is enabled, changing observed observable values outside actions is not allowed. Please wrap the code in an `action` if this change is intended. Tried to modify: ",
    m030b: "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, the render function of a React component? Tried to modify: ",
    m031: "Computed values are not allowed to cause side effects by changing observables that are already being observed. Tried to modify: ",
    m032: "* This computation is suspended (not in use by any reaction) and won't run automatically.\n	Didn't expect this computation to be suspended at this point?\n	  1. Make sure this computation is used by a reaction (reaction, autorun, observer).\n	  2. Check whether you are using this computation synchronously (in the same stack as they reaction that needs it).",
    m033: "`observe` doesn't support the fire immediately property for observable maps.",
    m034: "`mobx.map` is deprecated, use `new ObservableMap` or `mobx.observable.map` instead",
    m035: "Cannot make the designated object observable; it is not extensible",
    m036: "It is not possible to get index atoms from arrays",
    m037: "Hi there! I'm sorry you have just run into an exception.\nIf your debugger ends up here, know that some reaction (like the render() of an observer component, autorun or reaction)\nthrew an exception and that mobx caught it, to avoid that it brings the rest of your application down.\nThe original cause of the exception (the code that caused this reaction to run (again)), is still in the stack.\n\nHowever, more interesting is the actual stack trace of the error itself.\nHopefully the error is an instanceof Error, because in that case you can inspect the original stack of the error from where it was thrown.\nSee `error.stack` property, or press the very subtle \"(...)\" link you see near the console.error message that probably brought you here.\nThat stack is more interesting than the stack of this console.error itself.\n\nIf the exception you see is an exception you created yourself, make sure to use `throw new Error(\"Oops\")` instead of `throw \"Oops\"`,\nbecause the javascript environment will only preserve the original stack trace in the first form.\n\nYou can also make sure the debugger pauses the next time this very same exception is thrown by enabling \"Pause on caught exception\".\n(Note that it might pause on many other, unrelated exception as well).\n\nIf that all doesn't help you out, feel free to open an issue https://github.com/mobxjs/mobx/issues!\n",
    m038: "Missing items in this list?\n    1. Check whether all used values are properly marked as observable (use isObservable to verify)\n    2. Make sure you didn't dereference values too early. MobX observes props, not primitives. E.g: use 'person.name' instead of 'name' in your computation.\n"
};
function getMessage(id) {
    return messages[id];
}

function createAction(actionName, fn) {
    invariant(typeof fn === "function", getMessage("m026"));
    invariant(typeof actionName === "string" && actionName.length > 0, "actions should have valid names, got: '" + actionName + "'");
    var res = function () {
        return executeAction(actionName, fn, this, arguments);
    };
    res.originalFn = fn;
    res.isMobxAction = true;
    return res;
}
function executeAction(actionName, fn, scope, args) {
    var runInfo = startAction(actionName, fn, scope, args);
    try {
        return fn.apply(scope, args);
    }
    finally {
        endAction(runInfo);
    }
}
function startAction(actionName, fn, scope, args) {
    var notifySpy = isSpyEnabled() && !!actionName;
    var startTime = 0;
    if (notifySpy) {
        startTime = Date.now();
        var l = (args && args.length) || 0;
        var flattendArgs = new Array(l);
        if (l > 0)
            for (var i = 0; i < l; i++)
                flattendArgs[i] = args[i];
        spyReportStart({
            type: "action",
            name: actionName,
            fn: fn,
            object: scope,
            arguments: flattendArgs
        });
    }
    var prevDerivation = untrackedStart();
    startBatch();
    var prevAllowStateChanges = allowStateChangesStart(true);
    return {
        prevDerivation: prevDerivation,
        prevAllowStateChanges: prevAllowStateChanges,
        notifySpy: notifySpy,
        startTime: startTime
    };
}
function endAction(runInfo) {
    allowStateChangesEnd(runInfo.prevAllowStateChanges);
    endBatch();
    untrackedEnd(runInfo.prevDerivation);
    if (runInfo.notifySpy)
        spyReportEnd({ time: Date.now() - runInfo.startTime });
}
function useStrict(strict) {
    invariant(globalState.trackingDerivation === null, getMessage("m028"));
    globalState.strictMode = strict;
    globalState.allowStateChanges = !strict;
}
function isStrictModeEnabled() {
    return globalState.strictMode;
}
function allowStateChanges(allowStateChanges, func) {
    // TODO: deprecate / refactor this function in next major
    // Currently only used by `@observer`
    // Proposed change: remove first param, rename to `forbidStateChanges`,
    // require error callback instead of the hardcoded error message now used
    // Use `inAction` instead of allowStateChanges in derivation.ts to check strictMode
    var prev = allowStateChangesStart(allowStateChanges);
    var res;
    try {
        res = func();
    }
    finally {
        allowStateChangesEnd(prev);
    }
    return res;
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}

/**
 * Constructs a decorator, that normalizes the differences between
 * TypeScript and Babel. Mainly caused by the fact that legacy-decorator cannot assign
 * values during instance creation to properties that have a getter setter.
 *
 * - Sigh -
 *
 * Also takes care of the difference between @decorator field and @decorator(args) field, and different forms of values.
 * For performance (cpu and mem) reasons the properties are always defined on the prototype (at least initially).
 * This means that these properties despite being enumerable might not show up in Object.keys() (but they will show up in for...in loops).
 */
function createClassPropertyDecorator(
/**
 * This function is invoked once, when the property is added to a new instance.
 * When this happens is not strictly determined due to differences in TS and Babel:
 * Typescript: Usually when constructing the new instance
 * Babel, sometimes Typescript: during the first get / set
 * Both: when calling `runLazyInitializers(instance)`
 */
onInitialize, get, set, enumerable, 
/**
 * Can this decorator invoked with arguments? e.g. @decorator(args)
 */
allowCustomArguments) {
    function classPropertyDecorator(target, key, descriptor, customArgs, argLen) {
        if (argLen === void 0) { argLen = 0; }
        invariant(allowCustomArguments || quacksLikeADecorator(arguments), "This function is a decorator, but it wasn't invoked like a decorator");
        if (!descriptor) {
            // typescript (except for getter / setters)
            var newDescriptor = {
                enumerable: enumerable,
                configurable: true,
                get: function () {
                    if (!this.__mobxInitializedProps || this.__mobxInitializedProps[key] !== true)
                        typescriptInitializeProperty(this, key, undefined, onInitialize, customArgs, descriptor);
                    return get.call(this, key);
                },
                set: function (v) {
                    if (!this.__mobxInitializedProps || this.__mobxInitializedProps[key] !== true) {
                        typescriptInitializeProperty(this, key, v, onInitialize, customArgs, descriptor);
                    }
                    else {
                        set.call(this, key, v);
                    }
                }
            };
            if (arguments.length < 3 || (arguments.length === 5 && argLen < 3)) {
                // Typescript target is ES3, so it won't define property for us
                // or using Reflect.decorate polyfill, which will return no descriptor
                // (see https://github.com/mobxjs/mobx/issues/333)
                Object.defineProperty(target, key, newDescriptor);
            }
            return newDescriptor;
        }
        else {
            // babel and typescript getter / setter props
            if (!hasOwnProperty(target, "__mobxLazyInitializers")) {
                addHiddenProp(target, "__mobxLazyInitializers", (target.__mobxLazyInitializers && target.__mobxLazyInitializers.slice()) || [] // support inheritance
                );
            }
            var value_1 = descriptor.value, initializer_1 = descriptor.initializer;
            target.__mobxLazyInitializers.push(function (instance) {
                onInitialize(instance, key, initializer_1 ? initializer_1.call(instance) : value_1, customArgs, descriptor);
            });
            return {
                enumerable: enumerable,
                configurable: true,
                get: function () {
                    if (this.__mobxDidRunLazyInitializers !== true)
                        runLazyInitializers(this);
                    return get.call(this, key);
                },
                set: function (v) {
                    if (this.__mobxDidRunLazyInitializers !== true)
                        runLazyInitializers(this);
                    set.call(this, key, v);
                }
            };
        }
    }
    if (allowCustomArguments) {
        /** If custom arguments are allowed, we should return a function that returns a decorator */
        return function () {
            /** Direct invocation: @decorator bla */
            if (quacksLikeADecorator(arguments))
                return classPropertyDecorator.apply(null, arguments);
            /** Indirect invocation: @decorator(args) bla */
            var outerArgs = arguments;
            var argLen = arguments.length;
            return function (target, key, descriptor) {
                return classPropertyDecorator(target, key, descriptor, outerArgs, argLen);
            };
        };
    }
    return classPropertyDecorator;
}
function typescriptInitializeProperty(instance, key, v, onInitialize, customArgs, baseDescriptor) {
    if (!hasOwnProperty(instance, "__mobxInitializedProps"))
        addHiddenProp(instance, "__mobxInitializedProps", {});
    instance.__mobxInitializedProps[key] = true;
    onInitialize(instance, key, v, customArgs, baseDescriptor);
}
function runLazyInitializers(instance) {
    if (instance.__mobxDidRunLazyInitializers === true)
        return;
    if (instance.__mobxLazyInitializers) {
        addHiddenProp(instance, "__mobxDidRunLazyInitializers", true);
        instance.__mobxDidRunLazyInitializers &&
            instance.__mobxLazyInitializers.forEach(function (initializer) { return initializer(instance); });
    }
}
function quacksLikeADecorator(args) {
    return (args.length === 2 || args.length === 3) && typeof args[1] === "string";
}

var actionFieldDecorator = createClassPropertyDecorator(function (target, key, value, args, originalDescriptor) {
    var actionName = args && args.length === 1 ? args[0] : value.name || key || "<unnamed action>";
    var wrappedAction = action(actionName, value);
    addHiddenProp(target, key, wrappedAction);
}, function (key) {
    return this[key];
}, function () {
    invariant(false, getMessage("m001"));
}, false, true);
var boundActionDecorator = createClassPropertyDecorator(function (target, key, value) {
    defineBoundAction(target, key, value);
}, function (key) {
    return this[key];
}, function () {
    invariant(false, getMessage("m001"));
}, false, false);
var action = function action(arg1, arg2, arg3, arg4) {
    if (arguments.length === 1 && typeof arg1 === "function")
        return createAction(arg1.name || "<unnamed action>", arg1);
    if (arguments.length === 2 && typeof arg2 === "function")
        return createAction(arg1, arg2);
    if (arguments.length === 1 && typeof arg1 === "string")
        return namedActionDecorator(arg1);
    return namedActionDecorator(arg2).apply(null, arguments);
};
action.bound = function boundAction(arg1, arg2, arg3) {
    if (typeof arg1 === "function") {
        var action_1 = createAction("<not yet bound action>", arg1);
        action_1.autoBind = true;
        return action_1;
    }
    return boundActionDecorator.apply(null, arguments);
};
function namedActionDecorator(name) {
    return function (target, prop, descriptor) {
        if (descriptor && typeof descriptor.value === "function") {
            // TypeScript @action method() { }. Defined on proto before being decorated
            // Don't use the field decorator if we are just decorating a method
            descriptor.value = createAction(name, descriptor.value);
            descriptor.enumerable = false;
            descriptor.configurable = true;
            return descriptor;
        }
        if (descriptor !== undefined && descriptor.get !== undefined) {
            throw new Error("[mobx] action is not expected to be used with getters");
        }
        // bound instance methods
        return actionFieldDecorator(name).apply(this, arguments);
    };
}
function runInAction(arg1, arg2, arg3) {
    var actionName = typeof arg1 === "string" ? arg1 : arg1.name || "<unnamed action>";
    var fn = typeof arg1 === "function" ? arg1 : arg2;
    var scope = typeof arg1 === "function" ? arg2 : arg3;
    invariant(typeof fn === "function", getMessage("m002"));
    invariant(fn.length === 0, getMessage("m003"));
    invariant(typeof actionName === "string" && actionName.length > 0, "actions should have valid names, got: '" + actionName + "'");
    return executeAction(actionName, fn, scope, undefined);
}
function isAction(thing) {
    return typeof thing === "function" && thing.isMobxAction === true;
}
function defineBoundAction(target, propertyName, fn) {
    var res = function () {
        return executeAction(propertyName, fn, target, arguments);
    };
    res.isMobxAction = true;
    addHiddenProp(target, propertyName, res);
}

var toString = Object.prototype.toString;
function deepEqual(a, b) {
    return eq(a, b);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Internal recursive comparison function for `isEqual`.
function eq(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b)
        return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null)
        return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a)
        return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object")
        return false;
    return deepEq(a, b, aStack, bStack);
}
// Internal recursive comparison function for `isEqual`.
function deepEq(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b))
        return false;
    switch (className) {
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a)
                return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return (typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b));
    }
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object")
            return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor &&
            !(typeof aCtor === "function" &&
                aCtor instanceof aCtor &&
                typeof bCtor === "function" &&
                bCtor instanceof bCtor) &&
            ("constructor" in a && "constructor" in b)) {
            return false;
        }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a)
            return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length)
            return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while (length--) {
            if (!eq(a[length], b[length], aStack, bStack))
                return false;
        }
    }
    else {
        // Deep compare objects.
        var keys = Object.keys(a), key;
        length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== length)
            return false;
        while (length--) {
            // Deep compare each member
            key = keys[length];
            if (!(has(b, key) && eq(a[key], b[key], aStack, bStack)))
                return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a))
        return a.peek();
    if (isObservableMap(a))
        return a.entries();
    if (isES6Map(a))
        return iteratorToArray(a.entries());
    return a;
}
function has(a, key) {
    return Object.prototype.hasOwnProperty.call(a, key);
}

function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function defaultComparer(a, b) {
    return areBothNaN(a, b) || identityComparer(a, b);
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    default: defaultComparer
};

function autorun(arg1, arg2, arg3) {
    var name, view, scope;
    if (typeof arg1 === "string") {
        name = arg1;
        view = arg2;
        scope = arg3;
    }
    else {
        name = arg1.name || "Autorun@" + getNextId();
        view = arg1;
        scope = arg2;
    }
    invariant(typeof view === "function", getMessage("m004"));
    invariant(isAction(view) === false, getMessage("m005"));
    if (scope)
        view = view.bind(scope);
    var reaction = new Reaction(name, function () {
        this.track(reactionRunner);
    });
    function reactionRunner() {
        view(reaction);
    }
    reaction.schedule();
    return reaction.getDisposer();
}
function when(arg1, arg2, arg3, arg4) {
    var name, predicate, effect, scope;
    if (typeof arg1 === "string") {
        name = arg1;
        predicate = arg2;
        effect = arg3;
        scope = arg4;
    }
    else {
        name = "When@" + getNextId();
        predicate = arg1;
        effect = arg2;
        scope = arg3;
    }
    var disposer = autorun(name, function (r) {
        if (predicate.call(scope)) {
            r.dispose();
            var prevUntracked = untrackedStart();
            effect.call(scope);
            untrackedEnd(prevUntracked);
        }
    });
    return disposer;
}
function autorunAsync(arg1, arg2, arg3, arg4) {
    var name, func, delay, scope;
    if (typeof arg1 === "string") {
        name = arg1;
        func = arg2;
        delay = arg3;
        scope = arg4;
    }
    else {
        name = arg1.name || "AutorunAsync@" + getNextId();
        func = arg1;
        delay = arg2;
        scope = arg3;
    }
    invariant(isAction(func) === false, getMessage("m006"));
    if (delay === void 0)
        delay = 1;
    if (scope)
        func = func.bind(scope);
    var isScheduled = false;
    var r = new Reaction(name, function () {
        if (!isScheduled) {
            isScheduled = true;
            setTimeout(function () {
                isScheduled = false;
                if (!r.isDisposed)
                    r.track(reactionRunner);
            }, delay);
        }
    });
    function reactionRunner() {
        func(r);
    }
    r.schedule();
    return r.getDisposer();
}
function reaction(expression, effect, arg3) {
    if (arguments.length > 3) {
        fail(getMessage("m007"));
    }
    if (isModifierDescriptor(expression)) {
        fail(getMessage("m008"));
    }
    var opts;
    if (typeof arg3 === "object") {
        opts = arg3;
    }
    else {
        opts = {};
    }
    opts.name =
        opts.name || expression.name || effect.name || "Reaction@" + getNextId();
    opts.fireImmediately = arg3 === true || opts.fireImmediately === true;
    opts.delay = opts.delay || 0;
    opts.compareStructural = opts.compareStructural || opts.struct || false;
    // TODO: creates ugly spy events, use `effect = (r) => runInAction(opts.name, () => effect(r))` instead
    effect = action(opts.name, opts.context ? effect.bind(opts.context) : effect);
    if (opts.context) {
        expression = expression.bind(opts.context);
    }
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.equals
        ? opts.equals
        : opts.compareStructural || opts.struct ? comparer.structural : comparer.default;
    var r = new Reaction(opts.name, function () {
        if (firstTime || opts.delay < 1) {
            reactionRunner();
        }
        else if (!isScheduled) {
            isScheduled = true;
            setTimeout(function () {
                isScheduled = false;
                reactionRunner();
            }, opts.delay);
        }
    });
    function reactionRunner() {
        if (r.isDisposed)
            return;
        var changed = false;
        r.track(function () {
            var nextValue = expression(r);
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately)
            effect(value, r);
        if (!firstTime && changed === true)
            effect(value, r);
        if (firstTime)
            firstTime = false;
    }
    r.schedule();
    return r.getDisposer();
}

/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */
var ComputedValue = /** @class */ (function () {
    /**
     * Create a new computed value based on a function expression.
     *
     * The `name` property is for debug purposes only.
     *
     * The `equals` property specifies the comparer function to use to determine if a newly produced
     * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
     * compares based on identity comparison (===), and `structualComparer` deeply compares the structure.
     * Structural comparison can be convenient if you always produce an new aggregated object and
     * don't want to notify observers if it is structurally the same.
     * This is useful for working with vectors, mouse coordinates etc.
     */
    function ComputedValue(derivation, scope, equals, name, setter) {
        this.derivation = derivation;
        this.scope = scope;
        this.equals = equals;
        this.dependenciesState = IDerivationState.NOT_TRACKING;
        this.observing = []; // nodes we are looking at. Our value depends on these nodes
        this.newObserving = null; // during tracking it's an array with new observed observers
        this.isPendingUnobservation = false;
        this.observers = [];
        this.observersIndexes = {};
        this.diffValue = 0;
        this.runId = 0;
        this.lastAccessedBy = 0;
        this.lowestObserverState = IDerivationState.UP_TO_DATE;
        this.unboundDepsCount = 0;
        this.__mapid = "#" + getNextId();
        this.value = new CaughtException(null);
        this.isComputing = false; // to check for cycles
        this.isRunningSetter = false;
        this.isTracing = TraceMode.NONE;
        this.name = name || "ComputedValue@" + getNextId();
        if (setter)
            this.setter = createAction(name + "-setter", setter);
    }
    ComputedValue.prototype.onBecomeStale = function () {
        propagateMaybeChanged(this);
    };
    ComputedValue.prototype.onBecomeUnobserved = function () {
        clearObserving(this);
        this.value = undefined;
    };
    /**
     * Returns the current value of this computed value.
     * Will evaluate its computation first if needed.
     */
    ComputedValue.prototype.get = function () {
        invariant(!this.isComputing, "Cycle detected in computation " + this.name, this.derivation);
        if (globalState.inBatch === 0) {
            // This is an minor optimization which could be omitted to simplify the code
            // The computedValue is accessed outside of any mobx stuff. Batch observing should be enough and don't need
            // tracking as it will never be called again inside this batch.
            startBatch();
            if (shouldCompute(this)) {
                if (this.isTracing !== TraceMode.NONE) {
                    console.log("[mobx.trace] '" + this
                        .name + "' is being read outside a reactive context and doing a full recompute");
                }
                this.value = this.computeValue(false);
            }
            endBatch();
        }
        else {
            reportObserved(this);
            if (shouldCompute(this))
                if (this.trackAndCompute())
                    propagateChangeConfirmed(this);
        }
        var result = this.value;
        if (isCaughtException(result))
            throw result.cause;
        return result;
    };
    ComputedValue.prototype.peek = function () {
        var res = this.computeValue(false);
        if (isCaughtException(res))
            throw res.cause;
        return res;
    };
    ComputedValue.prototype.set = function (value) {
        if (this.setter) {
            invariant(!this.isRunningSetter, "The setter of computed value '" + this
                .name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?");
            this.isRunningSetter = true;
            try {
                this.setter.call(this.scope, value);
            }
            finally {
                this.isRunningSetter = false;
            }
        }
        else
            invariant(false, "[ComputedValue '" + this
                .name + "'] It is not possible to assign a new value to a computed value.");
    };
    ComputedValue.prototype.trackAndCompute = function () {
        if (isSpyEnabled()) {
            spyReport({
                object: this.scope,
                type: "compute",
                fn: this.derivation
            });
        }
        var oldValue = this.value;
        var wasSuspended = 
        /* see #1208 */ this.dependenciesState === IDerivationState.NOT_TRACKING;
        var newValue = (this.value = this.computeValue(true));
        return (wasSuspended ||
            isCaughtException(oldValue) ||
            isCaughtException(newValue) ||
            !this.equals(oldValue, newValue));
    };
    ComputedValue.prototype.computeValue = function (track) {
        this.isComputing = true;
        globalState.computationDepth++;
        var res;
        if (track) {
            res = trackDerivedFunction(this, this.derivation, this.scope);
        }
        else {
            try {
                res = this.derivation.call(this.scope);
            }
            catch (e) {
                res = new CaughtException(e);
            }
        }
        globalState.computationDepth--;
        this.isComputing = false;
        return res;
    };
    ComputedValue.prototype.observe = function (listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function () {
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    type: "update",
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    ComputedValue.prototype.toJSON = function () {
        return this.get();
    };
    ComputedValue.prototype.toString = function () {
        return this.name + "[" + this.derivation.toString() + "]";
    };
    ComputedValue.prototype.valueOf = function () {
        return toPrimitive(this.get());
    };
    ComputedValue.prototype.whyRun = function () {
        var isTracking = Boolean(globalState.trackingDerivation);
        var observing = unique(this.isComputing ? this.newObserving : this.observing).map(function (dep) { return dep.name; });
        var observers = unique(getObservers(this).map(function (dep) { return dep.name; }));
        return ("\nWhyRun? computation '" + this.name + "':\n * Running because: " + (isTracking
            ? "[active] the value of this computation is needed by a reaction"
            : this.isComputing
                ? "[get] The value of this computed was requested outside a reaction"
                : "[idle] not running at the moment") + "\n" +
            (this.dependenciesState === IDerivationState.NOT_TRACKING
                ? getMessage("m032")
                : " * This computation will re-run if any of the following observables changes:\n    " + joinStrings(observing) + "\n    " + (this.isComputing && isTracking
                    ? " (... or any observable accessed during the remainder of the current run)"
                    : "") + "\n    " + getMessage("m038") + "\n\n  * If the outcome of this computation changes, the following observers will be re-run:\n    " + joinStrings(observers) + "\n"));
    };
    return ComputedValue;
}());
ComputedValue.prototype[primitiveSymbol()] = ComputedValue.prototype.valueOf;
var isComputedValue = createInstanceofPredicate("ComputedValue", ComputedValue);

var ObservableObjectAdministration = /** @class */ (function () {
    function ObservableObjectAdministration(target, name) {
        this.target = target;
        this.name = name;
        this.values = {};
        this.changeListeners = null;
        this.interceptors = null;
    }
    /**
     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
     * for callback details
     */
    ObservableObjectAdministration.prototype.observe = function (callback, fireImmediately) {
        invariant(fireImmediately !== true, "`observe` doesn't support the fire immediately property for observable objects.");
        return registerListener(this, callback);
    };
    ObservableObjectAdministration.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    return ObservableObjectAdministration;
}());
function asObservableObject(target, name) {
    if (isObservableObject(target) && target.hasOwnProperty("$mobx"))
        return target.$mobx;
    invariant(Object.isExtensible(target), getMessage("m035"));
    if (!isPlainObject(target))
        name = (target.constructor.name || "ObservableObject") + "@" + getNextId();
    if (!name)
        name = "ObservableObject@" + getNextId();
    var adm = new ObservableObjectAdministration(target, name);
    addHiddenFinalProp(target, "$mobx", adm);
    return adm;
}
function defineObservablePropertyFromDescriptor(adm, propName, descriptor, defaultEnhancer) {
    if (adm.values[propName] && !isComputedValue(adm.values[propName])) {
        // already observable property
        invariant("value" in descriptor, "The property " + propName + " in " + adm.name + " is already observable, cannot redefine it as computed property");
        adm.target[propName] = descriptor.value; // the property setter will make 'value' reactive if needed.
        return;
    }
    // not yet observable property
    if ("value" in descriptor) {
        // not a computed value
        if (isModifierDescriptor(descriptor.value)) {
            // x : ref(someValue)
            var modifierDescriptor = descriptor.value;
            defineObservableProperty(adm, propName, modifierDescriptor.initialValue, modifierDescriptor.enhancer);
        }
        else if (isAction(descriptor.value) && descriptor.value.autoBind === true) {
            defineBoundAction(adm.target, propName, descriptor.value.originalFn);
        }
        else if (isComputedValue(descriptor.value)) {
            // x: computed(someExpr)
            defineComputedPropertyFromComputedValue(adm, propName, descriptor.value);
        }
        else {
            // x: someValue
            defineObservableProperty(adm, propName, descriptor.value, defaultEnhancer);
        }
    }
    else {
        // get x() { return 3 } set x(v) { }
        defineComputedProperty(adm, propName, descriptor.get, descriptor.set, comparer.default, true);
    }
}
function defineObservableProperty(adm, propName, newValue, enhancer) {
    assertPropertyConfigurable(adm.target, propName);
    if (hasInterceptors(adm)) {
        var change = interceptChange(adm, {
            object: adm.target,
            name: propName,
            type: "add",
            newValue: newValue
        });
        if (!change)
            return;
        newValue = change.newValue;
    }
    var observable = (adm.values[propName] = new ObservableValue(newValue, enhancer, adm.name + "." + propName, false));
    newValue = observable.value; // observableValue might have changed it
    Object.defineProperty(adm.target, propName, generateObservablePropConfig(propName));
    notifyPropertyAddition(adm, adm.target, propName, newValue);
}
function defineComputedProperty(adm, propName, getter, setter, equals, asInstanceProperty) {
    if (asInstanceProperty)
        assertPropertyConfigurable(adm.target, propName);
    adm.values[propName] = new ComputedValue(getter, adm.target, equals, adm.name + "." + propName, setter);
    if (asInstanceProperty) {
        Object.defineProperty(adm.target, propName, generateComputedPropConfig(propName));
    }
}
function defineComputedPropertyFromComputedValue(adm, propName, computedValue) {
    var name = adm.name + "." + propName;
    computedValue.name = name;
    if (!computedValue.scope)
        computedValue.scope = adm.target;
    adm.values[propName] = computedValue;
    Object.defineProperty(adm.target, propName, generateComputedPropConfig(propName));
}
var observablePropertyConfigs = {};
var computedPropertyConfigs = {};
function generateObservablePropConfig(propName) {
    return (observablePropertyConfigs[propName] ||
        (observablePropertyConfigs[propName] = {
            configurable: true,
            enumerable: true,
            get: function () {
                return this.$mobx.values[propName].get();
            },
            set: function (v) {
                setPropertyValue(this, propName, v);
            }
        }));
}
function generateComputedPropConfig(propName) {
    return (computedPropertyConfigs[propName] ||
        (computedPropertyConfigs[propName] = {
            configurable: true,
            enumerable: false,
            get: function () {
                return this.$mobx.values[propName].get();
            },
            set: function (v) {
                return this.$mobx.values[propName].set(v);
            }
        }));
}
function setPropertyValue(instance, name, newValue) {
    var adm = instance.$mobx;
    var observable = adm.values[name];
    // intercept
    if (hasInterceptors(adm)) {
        var change = interceptChange(adm, {
            type: "update",
            object: instance,
            name: name,
            newValue: newValue
        });
        if (!change)
            return;
        newValue = change.newValue;
    }
    newValue = observable.prepareNewValue(newValue);
    // notify spy & observers
    if (newValue !== UNCHANGED) {
        var notify = hasListeners(adm);
        var notifySpy = isSpyEnabled();
        var change = notify || notifySpy
            ? {
                type: "update",
                object: instance,
                oldValue: observable.value,
                name: name,
                newValue: newValue
            }
            : null;
        if (notifySpy)
            spyReportStart(change);
        observable.setNewValue(newValue);
        if (notify)
            notifyListeners(adm, change);
        if (notifySpy)
            spyReportEnd();
    }
}
function notifyPropertyAddition(adm, object, name, newValue) {
    var notify = hasListeners(adm);
    var notifySpy = isSpyEnabled();
    var change = notify || notifySpy
        ? {
            type: "add",
            object: object,
            name: name,
            newValue: newValue
        }
        : null;
    if (notifySpy)
        spyReportStart(change);
    if (notify)
        notifyListeners(adm, change);
    if (notifySpy)
        spyReportEnd();
}
var isObservableObjectAdministration = createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function isObservableObject(thing) {
    if (isObject(thing)) {
        // Initializers run lazily when transpiling to babel, so make sure they are run...
        runLazyInitializers(thing);
        return isObservableObjectAdministration(thing.$mobx);
    }
    return false;
}

/**
 * Returns true if the provided value is reactive.
 * @param value object, function or array
 * @param property if property is specified, checks whether value.property is reactive.
 */
function isObservable(value, property) {
    if (value === null || value === undefined)
        return false;
    if (property !== undefined) {
        if (isObservableArray(value) || isObservableMap(value))
            throw new Error(getMessage("m019"));
        else if (isObservableObject(value)) {
            var o = value.$mobx;
            return o.values && !!o.values[property];
        }
        return false;
    }
    // For first check, see #701
    return (isObservableObject(value) ||
        !!value.$mobx ||
        isAtom(value) ||
        isReaction(value) ||
        isComputedValue(value));
}

function createDecoratorForEnhancer(enhancer) {
    invariant(!!enhancer, ":(");
    return createClassPropertyDecorator(function (target, name, baseValue, _, baseDescriptor) {
        assertPropertyConfigurable(target, name);
        invariant(!baseDescriptor || !baseDescriptor.get, getMessage("m022"));
        var adm = asObservableObject(target, undefined);
        defineObservableProperty(adm, name, baseValue, enhancer);
    }, function (name) {
        var observable = this.$mobx.values[name];
        if (observable === undefined // See #505
        )
            return undefined;
        return observable.get();
    }, function (name, value) {
        setPropertyValue(this, name, value);
    }, true, false);
}

function extendObservable(target) {
    var properties = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        properties[_i - 1] = arguments[_i];
    }
    return extendObservableHelper(target, deepEnhancer, properties);
}
function extendShallowObservable(target) {
    var properties = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        properties[_i - 1] = arguments[_i];
    }
    return extendObservableHelper(target, referenceEnhancer, properties);
}
function extendObservableHelper(target, defaultEnhancer, properties) {
    invariant(arguments.length >= 2, getMessage("m014"));
    invariant(typeof target === "object", getMessage("m015"));
    invariant(!isObservableMap(target), getMessage("m016"));
    properties.forEach(function (propSet) {
        invariant(typeof propSet === "object", getMessage("m017"));
        invariant(!isObservable(propSet), getMessage("m018"));
    });
    var adm = asObservableObject(target);
    var definedProps = {};
    // Note could be optimised if properties.length === 1
    for (var i = properties.length - 1; i >= 0; i--) {
        var propSet = properties[i];
        for (var key in propSet)
            if (definedProps[key] !== true && hasOwnProperty(propSet, key)) {
                definedProps[key] = true;
                if (target === propSet && !isPropertyConfigurable(target, key))
                    continue; // see #111, skip non-configurable or non-writable props for `observable(object)`.
                var descriptor = Object.getOwnPropertyDescriptor(propSet, key);
                defineObservablePropertyFromDescriptor(adm, key, descriptor, defaultEnhancer);
            }
    }
    return target;
}

var deepDecorator = createDecoratorForEnhancer(deepEnhancer);
var shallowDecorator = createDecoratorForEnhancer(shallowEnhancer);
var refDecorator = createDecoratorForEnhancer(referenceEnhancer);
var deepStructDecorator = createDecoratorForEnhancer(deepStructEnhancer);
var refStructDecorator = createDecoratorForEnhancer(refStructEnhancer);
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */
function createObservable(v) {
    if (v === void 0) { v = undefined; }
    // @observable someProp;
    if (typeof arguments[1] === "string")
        return deepDecorator.apply(null, arguments);
    invariant(arguments.length <= 1, getMessage("m021"));
    invariant(!isModifierDescriptor(v), getMessage("m020"));
    // it is an observable already, done
    if (isObservable(v))
        return v;
    // something that can be converted and mutated?
    var res = deepEnhancer(v, undefined, undefined);
    // this value could be converted to a new observable data structure, return it
    if (res !== v)
        return res;
    // otherwise, just box it
    return observable.box(v);
}
var observableFactories = {
    box: function (value, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("box");
        return new ObservableValue(value, deepEnhancer, name);
    },
    shallowBox: function (value, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowBox");
        return new ObservableValue(value, referenceEnhancer, name);
    },
    array: function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("array");
        return new ObservableArray(initialValues, deepEnhancer, name);
    },
    shallowArray: function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowArray");
        return new ObservableArray(initialValues, referenceEnhancer, name);
    },
    map: function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("map");
        return new ObservableMap(initialValues, deepEnhancer, name);
    },
    shallowMap: function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowMap");
        return new ObservableMap(initialValues, referenceEnhancer, name);
    },
    object: function (props, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("object");
        var res = {};
        // convert to observable object
        asObservableObject(res, name);
        // add properties
        extendObservable(res, props);
        return res;
    },
    shallowObject: function (props, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowObject");
        var res = {};
        asObservableObject(res, name);
        extendShallowObservable(res, props);
        return res;
    },
    ref: function () {
        if (arguments.length < 2) {
            // although ref creates actually a modifier descriptor, the type of the resultig properties
            // of the object is `T` in the end, when the descriptors are interpreted
            return createModifierDescriptor(referenceEnhancer, arguments[0]);
        }
        else {
            return refDecorator.apply(null, arguments);
        }
    },
    shallow: function () {
        if (arguments.length < 2) {
            // although ref creates actually a modifier descriptor, the type of the resultig properties
            // of the object is `T` in the end, when the descriptors are interpreted
            return createModifierDescriptor(shallowEnhancer, arguments[0]);
        }
        else {
            return shallowDecorator.apply(null, arguments);
        }
    },
    deep: function () {
        if (arguments.length < 2) {
            // although ref creates actually a modifier descriptor, the type of the resultig properties
            // of the object is `T` in the end, when the descriptors are interpreted
            return createModifierDescriptor(deepEnhancer, arguments[0]);
        }
        else {
            return deepDecorator.apply(null, arguments);
        }
    },
    struct: function () {
        if (arguments.length < 2) {
            // although ref creates actually a modifier descriptor, the type of the resultig properties
            // of the object is `T` in the end, when the descriptors are interpreted
            return createModifierDescriptor(deepStructEnhancer, arguments[0]);
        }
        else {
            return deepStructDecorator.apply(null, arguments);
        }
    }
};
var observable = createObservable;
// weird trick to keep our typings nicely with our funcs, and still extend the observable function
Object.keys(observableFactories).forEach(function (name) { return (observable[name] = observableFactories[name]); });
observable.deep.struct = observable.struct;
observable.ref.struct = function () {
    if (arguments.length < 2) {
        return createModifierDescriptor(refStructEnhancer, arguments[0]);
    }
    else {
        return refStructDecorator.apply(null, arguments);
    }
};
function incorrectlyUsedAsDecorator(methodName) {
    fail("Expected one or two arguments to observable." + methodName + ". Did you accidentally try to use observable." + methodName + " as decorator?");
}

function isModifierDescriptor(thing) {
    return typeof thing === "object" && thing !== null && thing.isMobxModifierDescriptor === true;
}
function createModifierDescriptor(enhancer, initialValue) {
    invariant(!isModifierDescriptor(initialValue), "Modifiers cannot be nested");
    return {
        isMobxModifierDescriptor: true,
        initialValue: initialValue,
        enhancer: enhancer
    };
}
function deepEnhancer(v, _, name) {
    if (isModifierDescriptor(v))
        fail("You tried to assign a modifier wrapped value to a collection, please define modifiers when creating the collection, not when modifying it");
    // it is an observable already, done
    if (isObservable(v))
        return v;
    // something that can be converted and mutated?
    if (Array.isArray(v))
        return observable.array(v, name);
    if (isPlainObject(v))
        return observable.object(v, name);
    if (isES6Map(v))
        return observable.map(v, name);
    return v;
}
function shallowEnhancer(v, _, name) {
    if (isModifierDescriptor(v))
        fail("You tried to assign a modifier wrapped value to a collection, please define modifiers when creating the collection, not when modifying it");
    if (v === undefined || v === null)
        return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v))
        return v;
    if (Array.isArray(v))
        return observable.shallowArray(v, name);
    if (isPlainObject(v))
        return observable.shallowObject(v, name);
    if (isES6Map(v))
        return observable.shallowMap(v, name);
    return fail("The shallow modifier / decorator can only used in combination with arrays, objects and maps");
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function deepStructEnhancer(v, oldValue, name) {
    // don't confuse structurally compare enhancer with ref enhancer! The latter is probably
    // more suited for immutable objects
    if (deepEqual(v, oldValue))
        return oldValue;
    // it is an observable already, done
    if (isObservable(v))
        return v;
    // something that can be converted and mutated?
    if (Array.isArray(v))
        return new ObservableArray(v, deepStructEnhancer, name);
    if (isES6Map(v))
        return new ObservableMap(v, deepStructEnhancer, name);
    if (isPlainObject(v)) {
        var res = {};
        asObservableObject(res, name);
        extendObservableHelper(res, deepStructEnhancer, [v]);
        return res;
    }
    return v;
}
function refStructEnhancer(v, oldValue, name) {
    if (deepEqual(v, oldValue))
        return oldValue;
    return v;
}

/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */
function transaction(action, thisArg) {
    if (thisArg === void 0) { thisArg = undefined; }
    startBatch();
    try {
        return action.apply(thisArg);
    }
    finally {
        endBatch();
    }
}

var ObservableMapMarker = {};
var ObservableMap = /** @class */ (function () {
    function ObservableMap(initialData, enhancer, name) {
        if (enhancer === void 0) { enhancer = deepEnhancer; }
        if (name === void 0) { name = "ObservableMap@" + getNextId(); }
        this.enhancer = enhancer;
        this.name = name;
        this.$mobx = ObservableMapMarker;
        this._data = Object.create(null);
        this._hasMap = Object.create(null); // hasMap, not hashMap >-).
        this._keys = new ObservableArray(undefined, referenceEnhancer, this.name + ".keys()", true);
        this.interceptors = null;
        this.changeListeners = null;
        this.dehancer = undefined;
        this.merge(initialData);
    }
    ObservableMap.prototype._has = function (key) {
        return typeof this._data[key] !== "undefined";
    };
    ObservableMap.prototype.has = function (key) {
        if (!this.isValidKey(key))
            return false;
        key = "" + key;
        if (this._hasMap[key])
            return this._hasMap[key].get();
        return this._updateHasMapEntry(key, false).get();
    };
    ObservableMap.prototype.set = function (key, value) {
        this.assertValidKey(key);
        key = "" + key;
        var hasKey = this._has(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? "update" : "add",
                object: this,
                newValue: value,
                name: key
            });
            if (!change)
                return this;
            value = change.newValue;
        }
        if (hasKey) {
            this._updateValue(key, value);
        }
        else {
            this._addValue(key, value);
        }
        return this;
    };
    ObservableMap.prototype.delete = function (key) {
        var _this = this;
        this.assertValidKey(key);
        key = "" + key;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "delete",
                object: this,
                name: key
            });
            if (!change)
                return false;
        }
        if (this._has(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy
                ? {
                    type: "delete",
                    object: this,
                    oldValue: this._data[key].value,
                    name: key
                }
                : null;
            if (notifySpy)
                spyReportStart(change);
            transaction(function () {
                _this._keys.remove(key);
                _this._updateHasMapEntry(key, false);
                var observable$$1 = _this._data[key];
                observable$$1.setNewValue(undefined);
                _this._data[key] = undefined;
            });
            if (notify)
                notifyListeners(this, change);
            if (notifySpy)
                spyReportEnd();
            return true;
        }
        return false;
    };
    ObservableMap.prototype._updateHasMapEntry = function (key, value) {
        // optimization; don't fill the hasMap if we are not observing, or remove entry if there are no observers anymore
        var entry = this._hasMap[key];
        if (entry) {
            entry.setNewValue(value);
        }
        else {
            entry = this._hasMap[key] = new ObservableValue(value, referenceEnhancer, this.name + "." + key + "?", false);
        }
        return entry;
    };
    ObservableMap.prototype._updateValue = function (name, newValue) {
        var observable$$1 = this._data[name];
        newValue = observable$$1.prepareNewValue(newValue);
        if (newValue !== UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy
                ? {
                    type: "update",
                    object: this,
                    oldValue: observable$$1.value,
                    name: name,
                    newValue: newValue
                }
                : null;
            if (notifySpy)
                spyReportStart(change);
            observable$$1.setNewValue(newValue);
            if (notify)
                notifyListeners(this, change);
            if (notifySpy)
                spyReportEnd();
        }
    };
    ObservableMap.prototype._addValue = function (name, newValue) {
        var _this = this;
        transaction(function () {
            var observable$$1 = (_this._data[name] = new ObservableValue(newValue, _this.enhancer, _this.name + "." + name, false));
            newValue = observable$$1.value; // value might have been changed
            _this._updateHasMapEntry(name, true);
            _this._keys.push(name);
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                type: "add",
                object: this,
                name: name,
                newValue: newValue
            }
            : null;
        if (notifySpy)
            spyReportStart(change);
        if (notify)
            notifyListeners(this, change);
        if (notifySpy)
            spyReportEnd();
    };
    ObservableMap.prototype.get = function (key) {
        key = "" + key;
        if (this.has(key))
            return this.dehanceValue(this._data[key].get());
        return this.dehanceValue(undefined);
    };
    ObservableMap.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined) {
            return this.dehancer(value);
        }
        return value;
    };
    ObservableMap.prototype.keys = function () {
        return arrayAsIterator(this._keys.slice());
    };
    ObservableMap.prototype.values = function () {
        return arrayAsIterator(this._keys.map(this.get, this));
    };
    ObservableMap.prototype.entries = function () {
        var _this = this;
        return arrayAsIterator(this._keys.map(function (key) { return [key, _this.get(key)]; }));
    };
    ObservableMap.prototype.forEach = function (callback, thisArg) {
        var _this = this;
        this.keys().forEach(function (key) { return callback.call(thisArg, _this.get(key), key, _this); });
    };
    /** Merge another object into this object, returns this. */
    ObservableMap.prototype.merge = function (other) {
        var _this = this;
        if (isObservableMap(other)) {
            other = other.toJS();
        }
        transaction(function () {
            if (isPlainObject(other))
                Object.keys(other).forEach(function (key) { return _this.set(key, other[key]); });
            else if (Array.isArray(other))
                other.forEach(function (_a) {
                    var key = _a[0], value = _a[1];
                    return _this.set(key, value);
                });
            else if (isES6Map(other))
                other.forEach(function (value, key) { return _this.set(key, value); });
            else if (other !== null && other !== undefined)
                fail("Cannot initialize map from " + other);
        });
        return this;
    };
    ObservableMap.prototype.clear = function () {
        var _this = this;
        transaction(function () {
            untracked(function () {
                _this.keys().forEach(_this.delete, _this);
            });
        });
    };
    ObservableMap.prototype.replace = function (values) {
        var _this = this;
        transaction(function () {
            // grab all the keys that are present in the new map but not present in the current map
            // and delete them from the map, then merge the new map
            // this will cause reactions only on changed values
            var newKeys = getMapLikeKeys(values);
            var oldKeys = _this.keys();
            var missingKeys = oldKeys.filter(function (k) { return newKeys.indexOf(k) === -1; });
            missingKeys.forEach(function (k) { return _this.delete(k); });
            _this.merge(values);
        });
        return this;
    };
    Object.defineProperty(ObservableMap.prototype, "size", {
        get: function () {
            return this._keys.length;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a shallow non observable object clone of this map.
     * Note that the values might still be observable. For a deep clone use mobx.toJS.
     */
    ObservableMap.prototype.toJS = function () {
        var _this = this;
        var res = {};
        this.keys().forEach(function (key) { return (res[key] = _this.get(key)); });
        return res;
    };
    ObservableMap.prototype.toJSON = function () {
        // Used by JSON.stringify
        return this.toJS();
    };
    ObservableMap.prototype.isValidKey = function (key) {
        if (key === null || key === undefined)
            return false;
        if (typeof key === "string" || typeof key === "number" || typeof key === "boolean")
            return true;
        return false;
    };
    ObservableMap.prototype.assertValidKey = function (key) {
        if (!this.isValidKey(key))
            throw new Error("[mobx.map] Invalid key: '" + key + "', only strings, numbers and booleans are accepted as key in observable maps.");
    };
    ObservableMap.prototype.toString = function () {
        var _this = this;
        return (this.name +
            "[{ " +
            this.keys().map(function (key) { return key + ": " + ("" + _this.get(key)); }).join(", ") +
            " }]");
    };
    /**
     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
     * for callback details
     */
    ObservableMap.prototype.observe = function (listener, fireImmediately) {
        invariant(fireImmediately !== true, getMessage("m033"));
        return registerListener(this, listener);
    };
    ObservableMap.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    return ObservableMap;
}());
declareIterator(ObservableMap.prototype, function () {
    return this.entries();
});
function map(initialValues) {
    deprecated("`mobx.map` is deprecated, use `new ObservableMap` or `mobx.observable.map` instead");
    return observable.map(initialValues);
}
/* 'var' fixes small-build issue */
var isObservableMap = createInstanceofPredicate("ObservableMap", ObservableMap);

var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
function getGlobal() {
    return typeof window !== "undefined" ? window : global;
}
function getNextId() {
    return ++globalState.mobxGuid;
}
function fail(message, thing) {
    invariant(false, message, thing);
    throw "X"; // unreachable
}
function invariant(check, message, thing) {
    if (!check)
        throw new Error("[mobx] Invariant failed: " + message + (thing ? " in '" + thing + "'" : ""));
}
/**
 * Prints a deprecation message, but only one time.
 * Returns false if the deprecated message was already printed before
 */
var deprecatedMessages = [];
function deprecated(msg) {
    if (deprecatedMessages.indexOf(msg) !== -1)
        return false;
    deprecatedMessages.push(msg);
    console.error("[mobx] Deprecated: " + msg);
    return true;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */
function once(func) {
    var invoked = false;
    return function () {
        if (invoked)
            return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function () { };
function unique(list) {
    var res = [];
    list.forEach(function (item) {
        if (res.indexOf(item) === -1)
            res.push(item);
    });
    return res;
}
function joinStrings(things, limit, separator) {
    if (limit === void 0) { limit = 100; }
    if (separator === void 0) { separator = " - "; }
    if (!things)
        return "";
    var sliced = things.slice(0, limit);
    return "" + sliced.join(separator) + (things.length > limit
        ? " (... and " + (things.length - limit) + "more)"
        : "");
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (value === null || typeof value !== "object")
        return false;
    var proto = Object.getPrototypeOf(value);
    return proto === Object.prototype || proto === null;
}
function objectAssign() {
    var res = arguments[0];
    for (var i = 1, l = arguments.length; i < l; i++) {
        var source = arguments[i];
        for (var key in source)
            if (hasOwnProperty(source, key)) {
                res[key] = source[key];
            }
    }
    return res;
}
var prototypeHasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwnProperty(object, propName) {
    return prototypeHasOwnProperty.call(object, propName);
}
function makeNonEnumerable(object, propNames) {
    for (var i = 0; i < propNames.length; i++) {
        addHiddenProp(object, propNames[i], object[propNames[i]]);
    }
}
function addHiddenProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function isPropertyConfigurable(object, prop) {
    var descriptor = Object.getOwnPropertyDescriptor(object, prop);
    return !descriptor || (descriptor.configurable !== false && descriptor.writable !== false);
}
function assertPropertyConfigurable(object, prop) {
    invariant(isPropertyConfigurable(object, prop), "Cannot make property '" + prop + "' observable, it is not configurable and writable in the target object");
}
function createInstanceofPredicate(name, clazz) {
    var propName = "isMobX" + name;
    clazz.prototype[propName] = true;
    return function (x) {
        return isObject(x) && x[propName] === true;
    };
}
function areBothNaN(a, b) {
    return typeof a === "number" && typeof b === "number" && isNaN(a) && isNaN(b);
}
/**
 * Returns whether the argument is an array, disregarding observability.
 */
function isArrayLike(x) {
    return Array.isArray(x) || isObservableArray(x);
}
function isES6Map(thing) {
    if (getGlobal().Map !== undefined && thing instanceof getGlobal().Map)
        return true;
    return false;
}
function getMapLikeKeys(map$$1) {
    if (isPlainObject(map$$1))
        return Object.keys(map$$1);
    if (Array.isArray(map$$1))
        return map$$1.map(function (_a) {
            var key = _a[0];
            return key;
        });
    if (isES6Map(map$$1))
        return Array.from(map$$1.keys());
    if (isObservableMap(map$$1))
        return map$$1.keys();
    return fail("Cannot get keys from " + map$$1);
}
function iteratorToArray(it) {
    var res = [];
    while (true) {
        var r = it.next();
        if (r.done)
            break;
        res.push(r.value);
    }
    return res;
}
function primitiveSymbol() {
    return (typeof Symbol === "function" && Symbol.toPrimitive) || "@@toPrimitive";
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}

/**
 * These values will persist if global state is reset
 */
var persistentKeys = ["mobxGuid", "resetId", "spyListeners", "strictMode", "runId"];
var MobXGlobals = /** @class */ (function () {
    function MobXGlobals() {
        /**
         * MobXGlobals version.
         * MobX compatiblity with other versions loaded in memory as long as this version matches.
         * It indicates that the global state still stores similar information
         */
        this.version = 5;
        /**
         * Currently running derivation
         */
        this.trackingDerivation = null;
        /**
         * Are we running a computation currently? (not a reaction)
         */
        this.computationDepth = 0;
        /**
         * Each time a derivation is tracked, it is assigned a unique run-id
         */
        this.runId = 0;
        /**
         * 'guid' for general purpose. Will be persisted amongst resets.
         */
        this.mobxGuid = 0;
        /**
         * Are we in a batch block? (and how many of them)
         */
        this.inBatch = 0;
        /**
         * Observables that don't have observers anymore, and are about to be
         * suspended, unless somebody else accesses it in the same batch
         *
         * @type {IObservable[]}
         */
        this.pendingUnobservations = [];
        /**
         * List of scheduled, not yet executed, reactions.
         */
        this.pendingReactions = [];
        /**
         * Are we currently processing reactions?
         */
        this.isRunningReactions = false;
        /**
         * Is it allowed to change observables at this point?
         * In general, MobX doesn't allow that when running computations and React.render.
         * To ensure that those functions stay pure.
         */
        this.allowStateChanges = true;
        /**
         * If strict mode is enabled, state changes are by default not allowed
         */
        this.strictMode = false;
        /**
         * Used by createTransformer to detect that the global state has been reset.
         */
        this.resetId = 0;
        /**
         * Spy callbacks
         */
        this.spyListeners = [];
        /**
         * Globally attached error handlers that react specifically to errors in reactions
         */
        this.globalReactionErrorHandlers = [];
    }
    return MobXGlobals;
}());
var globalState = new MobXGlobals();
var shareGlobalStateCalled = false;
var runInIsolationCalled = false;
var warnedAboutMultipleInstances = false;
{
    var global_1 = getGlobal();
    if (!global_1.__mobxInstanceCount) {
        global_1.__mobxInstanceCount = 1;
    }
    else {
        global_1.__mobxInstanceCount++;
        setTimeout(function () {
            if (!shareGlobalStateCalled && !runInIsolationCalled && !warnedAboutMultipleInstances) {
                warnedAboutMultipleInstances = true;
                console.warn("[mobx] Warning: there are multiple mobx instances active. This might lead to unexpected results. See https://github.com/mobxjs/mobx/issues/1082 for details.");
            }
        }, 1);
    }
}
function isolateGlobalState() {
    runInIsolationCalled = true;
    getGlobal().__mobxInstanceCount--;
}
function shareGlobalState() {
    // TODO: remove in 4.0; just use peer dependencies instead.
    deprecated("Using `shareGlobalState` is not recommended, use peer dependencies instead. See https://github.com/mobxjs/mobx/issues/1082 for details.");
    shareGlobalStateCalled = true;
    var global = getGlobal();
    var ownState = globalState;
    /**
     * Backward compatibility check
     */
    if (global.__mobservableTrackingStack || global.__mobservableViewStack)
        throw new Error("[mobx] An incompatible version of mobservable is already loaded.");
    if (global.__mobxGlobal && global.__mobxGlobal.version !== ownState.version)
        throw new Error("[mobx] An incompatible version of mobx is already loaded.");
    if (global.__mobxGlobal)
        globalState = global.__mobxGlobal;
    else
        global.__mobxGlobal = ownState;
}
function getGlobalState() {
    return globalState;
}

/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */
function resetGlobalState() {
    globalState.resetId++;
    var defaultGlobals = new MobXGlobals();
    for (var key in defaultGlobals)
        if (persistentKeys.indexOf(key) === -1)
            globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.strictMode;
}

function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            invariant(property === undefined, getMessage("m036"));
            return thing.$mobx.atom;
        }
        if (isObservableMap(thing)) {
            var anyThing = thing;
            if (property === undefined)
                return getAtom(anyThing._keys);
            var observable = anyThing._data[property] || anyThing._hasMap[property];
            invariant(!!observable, "the entry '" + property + "' does not exist in the observable map '" + getDebugName(thing) + "'");
            return observable;
        }
        // Initializers run lazily when transpiling to babel, so make sure they are run...
        runLazyInitializers(thing);
        if (property && !thing.$mobx)
            thing[property]; // See #1072 // TODO: remove in 4.0
        if (isObservableObject(thing)) {
            if (!property)
                return fail("please specify a property");
            var observable = thing.$mobx.values[property];
            invariant(!!observable, "no observable property '" + property + "' found on the observable object '" + getDebugName(thing) + "'");
            return observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) {
            return thing;
        }
    }
    else if (typeof thing === "function") {
        if (isReaction(thing.$mobx)) {
            // disposer function
            return thing.$mobx;
        }
    }
    return fail("Cannot obtain atom from " + thing);
}
function getAdministration(thing, property) {
    invariant(thing, "Expecting some object");
    if (property !== undefined)
        return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing))
        return thing;
    if (isObservableMap(thing))
        return thing;
    // Initializers run lazily when transpiling to babel, so make sure they are run...
    runLazyInitializers(thing);
    if (thing.$mobx)
        return thing.$mobx;
    invariant(false, "Cannot obtain administration from " + thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined)
        named = getAtom(thing, property);
    else if (isObservableObject(thing) || isObservableMap(thing))
        named = getAdministration(thing);
    else
        named = getAtom(thing); // valid for arrays as well
    return named.name;
}

function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name
    };
    if (node.observing && node.observing.length > 0)
        result.dependencies = unique(node.observing).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name
    };
    if (hasObservers(node))
        result.observers = getObservers(node).map(nodeToObserverTree);
    return result;
}

function hasObservers(observable) {
    return observable.observers && observable.observers.length > 0;
}
function getObservers(observable) {
    return observable.observers;
}
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    var l = observable.observers.length;
    if (l) {
        // because object assignment is relatively expensive, let's not store data about index 0.
        observable.observersIndexes[node.__mapid] = l;
    }
    observable.observers[l] = node;
    if (observable.lowestObserverState > node.dependenciesState)
        observable.lowestObserverState = node.dependenciesState;
    // invariantObservers(observable);
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    if (observable.observers.length === 1) {
        // deleting last observer
        observable.observers.length = 0;
        queueForUnobservation(observable);
    }
    else {
        // deleting from _observersIndexes is straight forward, to delete from _observers, let's swap `node` with last element
        var list = observable.observers;
        var map = observable.observersIndexes;
        var filler = list.pop(); // get last element, which should fill the place of `node`, so the array doesn't have holes
        if (filler !== node) {
            // otherwise node was the last element, which already got removed from array
            var index = map[node.__mapid] || 0; // getting index of `node`. this is the only place we actually use map.
            if (index) {
                // map store all indexes but 0, see comment in `addObserver`
                map[filler.__mapid] = index;
            }
            else {
                delete map[filler.__mapid];
            }
            list[index] = filler;
        }
        delete map[node.__mapid];
    }
    // invariantObservers(observable);
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (!observable.isPendingUnobservation) {
        // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */
function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for (var i = 0; i < list.length; i++) {
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers.length === 0) {
                observable.onBecomeUnobserved();
                // NOTE: onBecomeUnobserved might push to `pendingUnobservations`
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
         * Simple optimization, give each derivation run an unique id (runId)
         * Check if last time this observable was accessed the same runId is used
         * if this is the case, the relation is already known
         */
        if (derivation.runId !== observable.lastAccessedBy) {
            observable.lastAccessedBy = derivation.runId;
            derivation.newObserving[derivation.unboundDepsCount++] = observable;
        }
    }
    else if (observable.observers.length === 0) {
        queueForUnobservation(observable);
    }
}
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */
// Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState === IDerivationState.STALE)
        return;
    observable.lowestObserverState = IDerivationState.STALE;
    var observers = observable.observers;
    var i = observers.length;
    while (i--) {
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
            if (d.isTracing !== TraceMode.NONE) {
                logTraceInfo(d, observable);
            }
            d.onBecomeStale();
        }
        d.dependenciesState = IDerivationState.STALE;
    }
    // invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState === IDerivationState.STALE)
        return;
    observable.lowestObserverState = IDerivationState.STALE;
    var observers = observable.observers;
    var i = observers.length;
    while (i--) {
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.POSSIBLY_STALE)
            d.dependenciesState = IDerivationState.STALE;
        else if (d.dependenciesState === IDerivationState.UP_TO_DATE // this happens during computing of `d`, just keep lowestObserverState up to date.
        )
            observable.lowestObserverState = IDerivationState.UP_TO_DATE;
    }
    // invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState !== IDerivationState.UP_TO_DATE)
        return;
    observable.lowestObserverState = IDerivationState.POSSIBLY_STALE;
    var observers = observable.observers;
    var i = observers.length;
    while (i--) {
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
            d.dependenciesState = IDerivationState.POSSIBLY_STALE;
            if (d.isTracing !== TraceMode.NONE) {
                logTraceInfo(d, observable);
            }
            d.onBecomeStale();
        }
    }
    // invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name + "' is invalidated due to a change in: '" + observable.name + "'");
    if (derivation.isTracing === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name + "'\n\nYou are entering this break point because derivation '" + derivation.name + "' is being traced and '" + observable.name + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString() : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + new Array(depth).join("\t") + tree.name); // MWE: not the fastest, but the easiest way :)
    if (tree.dependencies)
        tree.dependencies.forEach(function (child) { return printDepTree(child, lines, depth + 1); });
}

var IDerivationState;
(function (IDerivationState) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState[IDerivationState["NOT_TRACKING"] = -1] = "NOT_TRACKING";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState[IDerivationState["UP_TO_DATE"] = 0] = "UP_TO_DATE";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState[IDerivationState["POSSIBLY_STALE"] = 1] = "POSSIBLY_STALE";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState[IDerivationState["STALE"] = 2] = "STALE";
})(IDerivationState || (IDerivationState = {}));
var TraceMode;
(function (TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = /** @class */ (function () {
    function CaughtException(cause) {
        this.cause = cause;
        // Empty
    }
    return CaughtException;
}());
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */
function shouldCompute(derivation) {
    switch (derivation.dependenciesState) {
        case IDerivationState.UP_TO_DATE:
            return false;
        case IDerivationState.NOT_TRACKING:
        case IDerivationState.STALE:
            return true;
        case IDerivationState.POSSIBLY_STALE: {
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing, l = obs.length;
            for (var i = 0; i < l; i++) {
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    try {
                        obj.get();
                    }
                    catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        return true;
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    if (derivation.dependenciesState === IDerivationState.STALE) {
                        untrackedEnd(prevUntracked);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            return false;
        }
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers$$1 = atom.observers.length > 0;
    // Should never be possible to change an observed observable from inside computed, see #798
    if (globalState.computationDepth > 0 && hasObservers$$1)
        fail(getMessage("m031") + atom.name);
    // Should not be possible to change observed state outside strict mode, except during initialization, see #563
    if (!globalState.allowStateChanges && hasObservers$$1)
        fail(getMessage(globalState.strictMode ? "m030a" : "m030b") + atom.name);
}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */
function trackDerivedFunction(derivation, f, context) {
    // pre allocate array allocation + room for variation in deps
    // array will be trimmed by bindDependencies
    changeDependenciesStateTo0(derivation);
    derivation.newObserving = new Array(derivation.observing.length + 100);
    derivation.unboundDepsCount = 0;
    derivation.runId = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    var result;
    try {
        result = f.call(context);
    }
    catch (e) {
        result = new CaughtException(e);
    }
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    return result;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */
function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing;
    var observing = (derivation.observing = derivation.newObserving);
    var lowestNewObservingDerivationState = IDerivationState.UP_TO_DATE;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount;
    for (var i = 0; i < l; i++) {
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i)
                observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState > lowestNewObservingDerivationState) {
            lowestNewObservingDerivationState = dep.dependenciesState;
        }
    }
    observing.length = i0;
    derivation.newObserving = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while (l--) {
        var dep = prevObserving[l];
        if (dep.diffValue === 0) {
            removeObserver(dep, derivation);
        }
        dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while (i0--) {
        var dep = observing[i0];
        if (dep.diffValue === 1) {
            dep.diffValue = 0;
            addObserver(dep, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState.UP_TO_DATE) {
        derivation.dependenciesState = lowestNewObservingDerivationState;
        derivation.onBecomeStale();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing;
    derivation.observing = [];
    var i = obs.length;
    while (i--)
        removeObserver(obs[i], derivation);
    derivation.dependenciesState = IDerivationState.NOT_TRACKING;
}
function untracked(action) {
    var prev = untrackedStart();
    var res = action();
    untrackedEnd(prev);
    return res;
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */
function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState === IDerivationState.UP_TO_DATE)
        return;
    derivation.dependenciesState = IDerivationState.UP_TO_DATE;
    var obs = derivation.observing;
    var i = obs.length;
    while (i--)
        obs[i].lowestObserverState = IDerivationState.UP_TO_DATE;
}

function log(msg) {
    console.log(msg);
    return msg;
}
function whyRun(thing, prop) {
    deprecated("`whyRun` is deprecated in favor of `trace`");
    thing = getAtomFromArgs(arguments);
    if (!thing)
        return log(getMessage("m024"));
    if (isComputedValue(thing) || isReaction(thing))
        return log(thing.whyRun());
    return fail(getMessage("m025"));
}
function trace() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var enterBreakPoint = false;
    if (typeof args[args.length - 1] === "boolean")
        enterBreakPoint = args.pop();
    var derivation = getAtomFromArgs(args);
    if (!derivation) {
        return fail("'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
    }
    if (derivation.isTracing === TraceMode.NONE) {
        console.log("[mobx.trace] '" + derivation.name + "' tracing enabled");
    }
    derivation.isTracing = enterBreakPoint ? TraceMode.BREAK : TraceMode.LOG;
}
function getAtomFromArgs(args) {
    switch (args.length) {
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}

var Reaction = /** @class */ (function () {
    function Reaction(name, onInvalidate) {
        if (name === void 0) { name = "Reaction@" + getNextId(); }
        this.name = name;
        this.onInvalidate = onInvalidate;
        this.observing = []; // nodes we are looking at. Our value depends on these nodes
        this.newObserving = [];
        this.dependenciesState = IDerivationState.NOT_TRACKING;
        this.diffValue = 0;
        this.runId = 0;
        this.unboundDepsCount = 0;
        this.__mapid = "#" + getNextId();
        this.isDisposed = false;
        this._isScheduled = false;
        this._isTrackPending = false;
        this._isRunning = false;
        this.isTracing = TraceMode.NONE;
    }
    Reaction.prototype.onBecomeStale = function () {
        this.schedule();
    };
    Reaction.prototype.schedule = function () {
        if (!this._isScheduled) {
            this._isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    Reaction.prototype.isScheduled = function () {
        return this._isScheduled;
    };
    /**
     * internal, use schedule() if you intend to kick off a reaction
     */
    Reaction.prototype.runReaction = function () {
        if (!this.isDisposed) {
            startBatch();
            this._isScheduled = false;
            if (shouldCompute(this)) {
                this._isTrackPending = true;
                this.onInvalidate();
                if (this._isTrackPending && isSpyEnabled()) {
                    // onInvalidate didn't trigger track right away..
                    spyReport({
                        object: this,
                        type: "scheduled-reaction"
                    });
                }
            }
            endBatch();
        }
    };
    Reaction.prototype.track = function (fn) {
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        if (notify) {
            startTime = Date.now();
            spyReportStart({
                object: this,
                type: "reaction",
                fn: fn
            });
        }
        this._isRunning = true;
        var result = trackDerivedFunction(this, fn, undefined);
        this._isRunning = false;
        this._isTrackPending = false;
        if (this.isDisposed) {
            // disposed during last run. Clean up everything that was bound after the dispose call.
            clearObserving(this);
        }
        if (isCaughtException(result))
            this.reportExceptionInDerivation(result.cause);
        if (notify) {
            spyReportEnd({
                time: Date.now() - startTime
            });
        }
        endBatch();
    };
    Reaction.prototype.reportExceptionInDerivation = function (error) {
        var _this = this;
        if (this.errorHandler) {
            this.errorHandler(error, this);
            return;
        }
        var message = "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this;
        var messageToUser = getMessage("m037");
        console.error(message || messageToUser /* latter will not be true, make sure uglify doesn't remove */, error);
        /** If debugging brought you here, please, read the above message :-). Tnx! */
        if (isSpyEnabled()) {
            spyReport({
                type: "error",
                message: message,
                error: error,
                object: this
            });
        }
        globalState.globalReactionErrorHandlers.forEach(function (f) { return f(error, _this); });
    };
    Reaction.prototype.dispose = function () {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this._isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    Reaction.prototype.getDisposer = function () {
        var r = this.dispose.bind(this);
        r.$mobx = this;
        r.onError = registerErrorHandler;
        return r;
    };
    Reaction.prototype.toString = function () {
        return "Reaction[" + this.name + "]";
    };
    Reaction.prototype.whyRun = function () {
        var observing = unique(this._isRunning ? this.newObserving : this.observing).map(function (dep) { return dep.name; });
        return "\nWhyRun? reaction '" + this.name + "':\n * Status: [" + (this.isDisposed
            ? "stopped"
            : this._isRunning ? "running" : this.isScheduled() ? "scheduled" : "idle") + "]\n * This reaction will re-run if any of the following observables changes:\n    " + joinStrings(observing) + "\n    " + (this._isRunning
            ? " (... or any observable accessed during the remainder of the current run)"
            : "") + "\n\t" + getMessage("m038") + "\n";
    };
    Reaction.prototype.trace = function (enterBreakPoint) {
        if (enterBreakPoint === void 0) { enterBreakPoint = false; }
        trace(this, enterBreakPoint);
    };
    return Reaction;
}());
function registerErrorHandler(handler) {
    invariant(this && this.$mobx && isReaction(this.$mobx), "Invalid `this`");
    invariant(!this.$mobx.errorHandler, "Only one onErrorHandler can be registered");
    this.$mobx.errorHandler = handler;
}
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function () {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0)
            globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */
var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function (f) { return f(); };
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions)
        return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while (allReactions.length > 0) {
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("Reaction doesn't converge to a stable state after " + MAX_REACTION_ITERATIONS + " iterations." +
                (" Probably there is a cycle in the reactive function: " + allReactions[0]));
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for (var i = 0, l = remainingReactions.length; i < l; i++)
            remainingReactions[i].runReaction();
    }
    globalState.isRunningReactions = false;
}
var isReaction = createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function (f) { return fn(function () { return baseScheduler(f); }); };
}

function asReference(value) {
    deprecated("asReference is deprecated, use observable.ref instead");
    return observable.ref(value);
}
function asStructure(value) {
    deprecated("asStructure is deprecated. Use observable.struct, computed.struct or reaction options instead.");
    return observable.struct(value);
}
function asFlat(value) {
    deprecated("asFlat is deprecated, use observable.shallow instead");
    return observable.shallow(value);
}
function asMap(data) {
    deprecated("asMap is deprecated, use observable.map or observable.shallowMap instead");
    return observable.map(data || {});
}

function createComputedDecorator(equals) {
    return createClassPropertyDecorator(function (target, name, _, __, originalDescriptor) {
        invariant(typeof originalDescriptor !== "undefined", getMessage("m009"));
        invariant(typeof originalDescriptor.get === "function", getMessage("m010"));
        var adm = asObservableObject(target, "");
        defineComputedProperty(adm, name, originalDescriptor.get, originalDescriptor.set, equals, false);
    }, function (name) {
        var observable = this.$mobx.values[name];
        if (observable === undefined // See #505
        )
            return undefined;
        return observable.get();
    }, function (name, value) {
        this.$mobx.values[name].set(value);
    }, false, false);
}
var computedDecorator = createComputedDecorator(comparer.default);
var computedStructDecorator = createComputedDecorator(comparer.structural);
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */
var computed = function computed(arg1, arg2, arg3) {
    if (typeof arg2 === "string") {
        return computedDecorator.apply(null, arguments);
    }
    invariant(typeof arg1 === "function", getMessage("m011"));
    invariant(arguments.length < 3, getMessage("m012"));
    var opts = typeof arg2 === "object" ? arg2 : {};
    opts.setter = typeof arg2 === "function" ? arg2 : opts.setter;
    var equals = opts.equals
        ? opts.equals
        : opts.compareStructural || opts.struct ? comparer.structural : comparer.default;
    return new ComputedValue(arg1, opts.context, equals, opts.name || arg1.name || "", opts.setter);
};
computed.struct = computedStructDecorator;
computed.equals = createComputedDecorator;

function isComputed(value, property) {
    if (value === null || value === undefined)
        return false;
    if (property !== undefined) {
        if (isObservableObject(value) === false)
            return false;
        if (!value.$mobx.values[property])
            return false;
        var atom = getAtom(value, property);
        return isComputedValue(atom);
    }
    return isComputedValue(value);
}

function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (typeof cbOrFire === "function")
        return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else
        return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe(listener, fireImmediately);
}

function intercept(thing, propOrHandler, handler) {
    if (typeof handler === "function")
        return interceptProperty(thing, propOrHandler, handler);
    else
        return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept(handler);
}

/**
 * expr can be used to create temporarily views inside views.
 * This can be improved to improve performance if a value changes often, but usually doesn't affect the outcome of an expression.
 *
 * In the following example the expression prevents that a component is rerender _each time_ the selection changes;
 * instead it will only rerenders when the current todo is (de)selected.
 *
 * reactiveComponent((props) => {
 *     const todo = props.todo;
 *     const isSelected = mobx.expr(() => props.viewState.selection === todo);
 *     return <div className={isSelected ? "todo todo-selected" : "todo"}>{todo.title}</div>
 * });
 *
 */
function expr(expr, scope) {
    if (!isComputingDerivation())
        console.warn(getMessage("m013"));
    // optimization: would be more efficient if the expr itself wouldn't be evaluated first on the next change, but just a 'changed' signal would be fired
    return computed(expr, { context: scope }).get();
}

function toJS(source, detectCycles, __alreadySeen) {
    if (detectCycles === void 0) { detectCycles = true; }
    if (__alreadySeen === void 0) { __alreadySeen = []; }
    // optimization: using ES6 map would be more efficient!
    // optimization: lift this function outside toJS, this makes recursion expensive
    function cache(value) {
        if (detectCycles)
            __alreadySeen.push([source, value]);
        return value;
    }
    if (isObservable(source)) {
        if (detectCycles && __alreadySeen === null)
            __alreadySeen = [];
        if (detectCycles && source !== null && typeof source === "object") {
            for (var i = 0, l = __alreadySeen.length; i < l; i++)
                if (__alreadySeen[i][0] === source)
                    return __alreadySeen[i][1];
        }
        if (isObservableArray(source)) {
            var res = cache([]);
            var toAdd = source.map(function (value) { return toJS(value, detectCycles, __alreadySeen); });
            res.length = toAdd.length;
            for (var i = 0, l = toAdd.length; i < l; i++)
                res[i] = toAdd[i];
            return res;
        }
        if (isObservableObject(source)) {
            var res = cache({});
            for (var key in source)
                res[key] = toJS(source[key], detectCycles, __alreadySeen);
            return res;
        }
        if (isObservableMap(source)) {
            var res_1 = cache({});
            source.forEach(function (value, key) { return (res_1[key] = toJS(value, detectCycles, __alreadySeen)); });
            return res_1;
        }
        if (isObservableValue(source))
            return toJS(source.get(), detectCycles, __alreadySeen);
    }
    return source;
}

function createTransformer(transformer, onCleanup) {
    invariant(typeof transformer === "function" && transformer.length < 2, "createTransformer expects a function that accepts one argument");
    // Memoizes: object id -> reactive view that applies transformer to the object
    var objectCache = {};
    // If the resetId changes, we will clear the object cache, see #163
    // This construction is used to avoid leaking refs to the objectCache directly
    var resetId = globalState.resetId;
    // Local transformer class specifically for this transformer
    var Transformer = /** @class */ (function (_super) {
        __extends(Transformer, _super);
        function Transformer(sourceIdentifier, sourceObject) {
            var _this = _super.call(this, function () { return transformer(sourceObject); }, undefined, comparer.default, "Transformer-" + transformer.name + "-" + sourceIdentifier, undefined) || this;
            _this.sourceIdentifier = sourceIdentifier;
            _this.sourceObject = sourceObject;
            return _this;
        }
        Transformer.prototype.onBecomeUnobserved = function () {
            var lastValue = this.value;
            _super.prototype.onBecomeUnobserved.call(this);
            delete objectCache[this.sourceIdentifier];
            if (onCleanup)
                onCleanup(lastValue, this.sourceObject);
        };
        return Transformer;
    }(ComputedValue));
    return function (object) {
        if (resetId !== globalState.resetId) {
            objectCache = {};
            resetId = globalState.resetId;
        }
        var identifier = getMemoizationId(object);
        var reactiveTransformer = objectCache[identifier];
        if (reactiveTransformer)
            return reactiveTransformer.get();
        // Not in cache; create a reactive view
        reactiveTransformer = objectCache[identifier] = new Transformer(identifier, object);
        return reactiveTransformer.get();
    };
}
function getMemoizationId(object) {
    if (typeof object === "string" || typeof object === "number")
        return object;
    if (object === null || typeof object !== "object")
        throw new Error("[mobx] transform expected some kind of object or primitive value, got: " + object);
    var tid = object.$transformId;
    if (tid === undefined) {
        tid = getNextId();
        addHiddenProp(object, "$transformId", tid);
    }
    return tid;
}

function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) {
        target = getAdministration(thing);
    }
    else if (isObservableObject(thing)) {
        if (typeof propOrHandler !== "string")
            return fail("InterceptReads can only be used with a specific property, not with an object in general");
        target = getAdministration(thing, propOrHandler);
    }
    else {
        return fail("Expected observable map, object or array as first array");
    }
    if (target.dehancer !== undefined)
        return fail("An intercept reader was already established");
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function () {
        target.dehancer = undefined;
    };
}

/**
 * (c) Michel Weststrate 2015 - 2016
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get an global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */
var extras = {
    allowStateChanges: allowStateChanges,
    deepEqual: deepEqual,
    getAtom: getAtom,
    getDebugName: getDebugName,
    getDependencyTree: getDependencyTree,
    getAdministration: getAdministration,
    getGlobalState: getGlobalState,
    getObserverTree: getObserverTree,
    interceptReads: interceptReads,
    isComputingDerivation: isComputingDerivation,
    isSpyEnabled: isSpyEnabled,
    onReactionError: onReactionError,
    reserveArrayBuffer: reserveArrayBuffer,
    resetGlobalState: resetGlobalState,
    isolateGlobalState: isolateGlobalState,
    shareGlobalState: shareGlobalState,
    spyReport: spyReport,
    spyReportEnd: spyReportEnd,
    spyReportStart: spyReportStart,
    setReactionScheduler: setReactionScheduler
};
var everything = {
    Reaction: Reaction,
    untracked: untracked,
    Atom: Atom,
    BaseAtom: BaseAtom,
    useStrict: useStrict,
    isStrictModeEnabled: isStrictModeEnabled,
    spy: spy,
    comparer: comparer,
    asReference: asReference,
    asFlat: asFlat,
    asStructure: asStructure,
    asMap: asMap,
    isModifierDescriptor: isModifierDescriptor,
    isObservableObject: isObservableObject,
    isBoxedObservable: isObservableValue,
    isObservableArray: isObservableArray,
    ObservableMap: ObservableMap,
    isObservableMap: isObservableMap,
    map: map,
    transaction: transaction,
    observable: observable,
    computed: computed,
    isObservable: isObservable,
    isComputed: isComputed,
    extendObservable: extendObservable,
    extendShallowObservable: extendShallowObservable,
    observe: observe,
    intercept: intercept,
    autorun: autorun,
    autorunAsync: autorunAsync,
    when: when,
    reaction: reaction,
    action: action,
    isAction: isAction,
    runInAction: runInAction,
    expr: expr,
    toJS: toJS,
    createTransformer: createTransformer,
    whyRun: whyRun,
    isArrayLike: isArrayLike,
    extras: extras
};
var warnedAboutDefaultExport = false;
var _loop_1 = function (p) {
    var val = everything[p];
    Object.defineProperty(everything, p, {
        get: function () {
            if (!warnedAboutDefaultExport) {
                warnedAboutDefaultExport = true;
                console.warn("Using default export (`import mobx from 'mobx'`) is deprecated " +
                    "and won’t work in mobx@4.0.0\n" +
                    "Use `import * as mobx from 'mobx'` instead");
            }
            return val;
        }
    });
};
for (var p in everything) {
    _loop_1(p);
}
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") {
    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({ spy: spy, extras: extras });
}

/* unused harmony default export */ var _unused_webpack_default_export = (everything);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(33)))

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = localizable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react_intl__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_unorm__ = __webpack_require__(1730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_unorm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_unorm__);
var createLocalizable=function createLocalizable(WrappedComponent,displayName){function getDisplayName(component){return displayName||component.displayName||component.name||'Component';}function getCanonicalId(text){return text?Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_unorm__["nfd"])(text).replace(/[\s]+/g,'_').replace(/[^\w0-9_]+/g,'').toLowerCase():'';}function formatMessage(text,values,props,context,defaultText){// react-intl does Object.keys(values), which throws on null
values=values||undefined;var namespace='';var index=text?text.indexOf('::'):-1;if(index>=0){// handle the case where namespace is already specified in the text
namespace=text.substring(0,index);text=text.substring(index+2);// strip the namespace from the text
}else namespace=getDisplayName(WrappedComponent);if(namespace!=='')namespace+='::';// strings in 'global' namespace do not contain '::'
var canonicalId=getCanonicalId(text);// For some reason context.intl.formatMessage() does not recognize resource strings containing double curly braces
// (e.g. 'ImageUpload::cloudinary_queue_title_uploading_with_counter': '{{num}} Assets hochladen')
// unless the default message contains curly braces too.
var defaultMessage='{_}';var id=''+namespace+canonicalId;var localized=context.intl.formatMessage({id:id,defaultMessage:defaultMessage},values);if(localized===defaultMessage){if(namespace!==''&&!!canonicalId){// try in 'global' namespace
id=canonicalId;localized=context.intl.formatMessage({id:id,defaultMessage:defaultMessage},values);}}// go with defaultText if provided
if(localized===defaultMessage&&defaultText){return formatMessage(defaultText,values,props,context);}if(localized===defaultMessage){console.log('[localizable]: Missing localization for '+namespace+canonicalId);return context.intl.formatMessage({id:''+namespace+canonicalId,defaultMessage:text},values);}// return '✓ ' + localized + ' ✓';
if("false"===true||"false"==='true')return localized+'~'+id+'~';else return localized;}var localizable=function localizable(props,context){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(WrappedComponent,Object.assign({},props,{intl:context.intl,t:function t(text,values,defaultText){return formatMessage(text,values,props,context,defaultText);}}));};localizable.contextTypes={intl:__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react_intl__["d" /* intlShape */]};localizable.displayName=displayName||'localizable('+getDisplayName(WrappedComponent)+')';return localizable;};// export function localizable() {
//   let WrappedComponent = arguments[arguments.length - 1];
//   let displayName = arguments.length > 1 ? arguments[0] : null;
//   return createLocalizable(WrappedComponent, displayName);
// }
function localizable(){if(typeof arguments[0]==='function'){var componentClass=arguments[0];return createLocalizable(componentClass,undefined);}else{var displayName=arguments[0];return function(componentClass){return createLocalizable(componentClass,displayName);};}}

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1354)();
}


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Button_index__ = __webpack_require__(1732);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Button_index__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Button_index__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Button_index__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Button_index__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Button_index__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Button_index__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Button_index__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Button_index__["h"]; });

//# sourceMappingURL=Button.js.map

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1647);


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_index__ = __webpack_require__(671);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Icon", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Icon_index__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "IconBase", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Icon_index__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "IconType", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Icon_index__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getIconContent", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Icon_index__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "FontIcon", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Icon_index__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getFontIcon", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Icon_index__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ImageIcon", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Icon_index__["e"]; });

//# sourceMappingURL=Icon.js.map

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 14 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bpfrpt_proptype_CellPosition */
/* unused harmony export bpfrpt_proptype_CellRendererParams */
/* unused harmony export bpfrpt_proptype_CellRenderer */
/* unused harmony export bpfrpt_proptype_CellCache */
/* unused harmony export bpfrpt_proptype_StyleCache */
/* unused harmony export bpfrpt_proptype_CellRangeRendererParams */
/* unused harmony export bpfrpt_proptype_CellRangeRenderer */
/* unused harmony export bpfrpt_proptype_CellSizeGetter */
/* unused harmony export bpfrpt_proptype_CellSize */
/* unused harmony export bpfrpt_proptype_NoContentRenderer */
/* unused harmony export bpfrpt_proptype_Scroll */
/* unused harmony export bpfrpt_proptype_ScrollbarPresenceChange */
/* unused harmony export bpfrpt_proptype_RenderedSection */
/* unused harmony export bpfrpt_proptype_OverscanIndicesGetterParams */
/* unused harmony export bpfrpt_proptype_OverscanIndices */
/* unused harmony export bpfrpt_proptype_OverscanIndicesGetter */
/* unused harmony export bpfrpt_proptype_Alignment */
/* unused harmony export bpfrpt_proptype_VisibleCellRange */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_ScalingCellSizeAndPositionManager__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);


var bpfrpt_proptype_CellPosition =  true ? null : {
  "columnIndex": PropTypes.number.isRequired,
  "rowIndex": PropTypes.number.isRequired
};
var bpfrpt_proptype_CellRendererParams =  true ? null : {
  "columnIndex": PropTypes.number.isRequired,
  "isScrolling": PropTypes.bool.isRequired,
  "isVisible": PropTypes.bool.isRequired,
  "key": PropTypes.string.isRequired,
  "parent": PropTypes.object.isRequired,
  "rowIndex": PropTypes.number.isRequired,
  "style": PropTypes.object.isRequired
};
var bpfrpt_proptype_CellRenderer =  true ? null : PropTypes.func;
var bpfrpt_proptype_CellCache =  true ? null : PropTypes.objectOf(PropTypes.node.isRequired);
var bpfrpt_proptype_StyleCache =  true ? null : PropTypes.objectOf(PropTypes.object.isRequired);
var bpfrpt_proptype_CellRangeRendererParams =  true ? null : {
  "cellCache": PropTypes.objectOf(PropTypes.node.isRequired).isRequired,
  "cellRenderer": PropTypes.func.isRequired,
  "columnSizeAndPositionManager": function columnSizeAndPositionManager() {
    return (typeof ScalingCellSizeAndPositionManager === "function" ? PropTypes.instanceOf(ScalingCellSizeAndPositionManager).isRequired : PropTypes.any.isRequired).apply(this, arguments);
  },
  "columnStartIndex": PropTypes.number.isRequired,
  "columnStopIndex": PropTypes.number.isRequired,
  "deferredMeasurementCache": PropTypes.object,
  "horizontalOffsetAdjustment": PropTypes.number.isRequired,
  "isScrolling": PropTypes.bool.isRequired,
  "isScrollingOptOut": PropTypes.bool.isRequired,
  "parent": PropTypes.object.isRequired,
  "rowSizeAndPositionManager": function rowSizeAndPositionManager() {
    return (typeof ScalingCellSizeAndPositionManager === "function" ? PropTypes.instanceOf(ScalingCellSizeAndPositionManager).isRequired : PropTypes.any.isRequired).apply(this, arguments);
  },
  "rowStartIndex": PropTypes.number.isRequired,
  "rowStopIndex": PropTypes.number.isRequired,
  "scrollLeft": PropTypes.number.isRequired,
  "scrollTop": PropTypes.number.isRequired,
  "styleCache": PropTypes.objectOf(PropTypes.object.isRequired).isRequired,
  "verticalOffsetAdjustment": PropTypes.number.isRequired,
  "visibleColumnIndices": PropTypes.object.isRequired,
  "visibleRowIndices": PropTypes.object.isRequired
};
var bpfrpt_proptype_CellRangeRenderer =  true ? null : PropTypes.func;
var bpfrpt_proptype_CellSizeGetter =  true ? null : PropTypes.func;
var bpfrpt_proptype_CellSize =  true ? null : PropTypes.oneOfType([PropTypes.func, PropTypes.number]);
var bpfrpt_proptype_NoContentRenderer =  true ? null : PropTypes.func;
var bpfrpt_proptype_Scroll =  true ? null : {
  "clientHeight": PropTypes.number.isRequired,
  "clientWidth": PropTypes.number.isRequired,
  "scrollHeight": PropTypes.number.isRequired,
  "scrollLeft": PropTypes.number.isRequired,
  "scrollTop": PropTypes.number.isRequired,
  "scrollWidth": PropTypes.number.isRequired
};
var bpfrpt_proptype_ScrollbarPresenceChange =  true ? null : {
  "horizontal": PropTypes.bool.isRequired,
  "vertical": PropTypes.bool.isRequired,
  "size": PropTypes.number.isRequired
};
var bpfrpt_proptype_RenderedSection =  true ? null : {
  "columnOverscanStartIndex": PropTypes.number.isRequired,
  "columnOverscanStopIndex": PropTypes.number.isRequired,
  "columnStartIndex": PropTypes.number.isRequired,
  "columnStopIndex": PropTypes.number.isRequired,
  "rowOverscanStartIndex": PropTypes.number.isRequired,
  "rowOverscanStopIndex": PropTypes.number.isRequired,
  "rowStartIndex": PropTypes.number.isRequired,
  "rowStopIndex": PropTypes.number.isRequired
};
var bpfrpt_proptype_OverscanIndicesGetterParams =  true ? null : {
  // One of SCROLL_DIRECTION_HORIZONTAL or SCROLL_DIRECTION_VERTICAL
  "direction": PropTypes.oneOf(["horizontal", "vertical"]).isRequired,
  // One of SCROLL_DIRECTION_BACKWARD or SCROLL_DIRECTION_FORWARD
  "scrollDirection": PropTypes.oneOf([-1, 1]).isRequired,
  // Number of rows or columns in the current axis
  "cellCount": PropTypes.number.isRequired,
  // Maximum number of cells to over-render in either direction
  "overscanCellsCount": PropTypes.number.isRequired,
  // Begin of range of visible cells
  "startIndex": PropTypes.number.isRequired,
  // End of range of visible cells
  "stopIndex": PropTypes.number.isRequired
};
var bpfrpt_proptype_OverscanIndices =  true ? null : {
  "overscanStartIndex": PropTypes.number.isRequired,
  "overscanStopIndex": PropTypes.number.isRequired
};
var bpfrpt_proptype_OverscanIndicesGetter =  true ? null : PropTypes.func;
var bpfrpt_proptype_Alignment =  true ? null : PropTypes.oneOf(["auto", "end", "start", "center"]);
var bpfrpt_proptype_VisibleCellRange =  true ? null : {
  "start": PropTypes.number,
  "stop": PropTypes.number
};




















/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UNAUTHORIZED_EVENT; });
/* harmony export (immutable) */ __webpack_exports__["b"] = request;
/* harmony export (immutable) */ __webpack_exports__["d"] = get;
/* harmony export (immutable) */ __webpack_exports__["e"] = post;
/* harmony export (immutable) */ __webpack_exports__["f"] = put;
/* harmony export (immutable) */ __webpack_exports__["c"] = del;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_whatwg_fetch__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_whatwg_fetch__);
var checkStatus=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(response){var error;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!(response.status>=200&&response.status<300)){_context.next=2;break;}return _context.abrupt('return',response);case 2:if(response.status===401){notifyUnauthorized();}error=new Error(response.statusText);error.status=response.status;_context.prev=5;_context.next=8;return parse(response);case 8:error.response=_context.sent;_context.next=13;break;case 11:_context.prev=11;_context.t0=_context['catch'](5);case 13:throw error;case 14:case'end':return _context.stop();}}},_callee,this,[[5,11]]);}));return function checkStatus(_x2){return _ref.apply(this,arguments);};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var UNAUTHORIZED_EVENT='dav:unauthorized';function notifyUnauthorized(){if(typeof window!=='undefined'&&window.dispatchEvent){window.dispatchEvent(new Event(UNAUTHORIZED_EVENT));}}function send(method,url,token,data){var abortSignal=arguments.length>4&&arguments[4]!==undefined?arguments[4]:null;var options={method:method,headers:{Accept:'application/json','Content-Type':'application/json'},credentials:'include'};if(token)options.headers['Authorization']='Bearer '+token;if(data)options['body']=JSON.stringify(data);if(abortSignal)options['signal']=abortSignal;return request(url,options);}function parse(response){return response.json();}function request(url,options){return fetch(url,options).then(checkStatus).then(parse);}function get(url){var token=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var data=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var abortSignal=arguments.length>3&&arguments[3]!==undefined?arguments[3]:null;if(data!==null){url+=(url.indexOf('?')>=0?'&':'?')+Object.keys(data).map(function(k){return encodeURIComponent(k)+'='+encodeURIComponent(data[k]);}).join('&');}return send('GET',url,token,null,abortSignal);}function post(url,data){var token=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var abortSignal=arguments.length>3&&arguments[3]!==undefined?arguments[3]:null;return send('POST',url,token,data,abortSignal);}function put(url,data){var token=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var abortSignal=arguments.length>3&&arguments[3]!==undefined?arguments[3]:null;return send('PUT',url,token,data,abortSignal);}function del(url){var token=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var abortSignal=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;return send('DELETE',url,token,abortSignal);}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33), __webpack_require__(657)(module)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(164)('wks');
var uid = __webpack_require__(125);
var Symbol = __webpack_require__(14).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(73);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__classNames_index__ = __webpack_require__(1562);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__classNames_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_index__ = __webpack_require__(387);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__styles_index__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__styles_index__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__styles_index__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__styles_index__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__styles_index__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_1__styles_index__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__styles_index__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_1__styles_index__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_1__styles_index__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_1__styles_index__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_1__styles_index__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_1__styles_index__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_1__styles_index__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_1__styles_index__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_1__styles_index__["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_1__styles_index__["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_1__styles_index__["q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_1__styles_index__["r"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_1__styles_index__["s"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_1__styles_index__["t"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_1__styles_index__["u"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_1__styles_index__["v"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_1__styles_index__["w"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_1__styles_index__["x"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_1__styles_index__["y"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_1__styles_index__["z"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_1__styles_index__["A"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_1__styles_index__["B"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_1__styles_index__["C"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_index__ = __webpack_require__(628);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_2__utilities_index__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_2__utilities_index__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_2__utilities_index__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MergeStyles__ = __webpack_require__(630);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_3__MergeStyles__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_3__MergeStyles__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_3__MergeStyles__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_3__MergeStyles__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__version__ = __webpack_require__(1636);





//# sourceMappingURL=index.js.map

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(16)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 24 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(13);
var IE8_DOM_DEFINE = __webpack_require__(495);
var toPrimitive = __webpack_require__(92);
var dP = Object.defineProperty;

exports.f = __webpack_require__(23) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 26 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(93);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FocusZone_index__ = __webpack_require__(1689);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_FocusZone_index__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__components_FocusZone_index__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__components_FocusZone_index__["c"]; });

//# sourceMappingURL=FocusZone.js.map

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TextField_index__ = __webpack_require__(1792);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_TextField_index__["a"]; });

//# sourceMappingURL=TextField.js.map

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Interfaces_IChannelControls__ = __webpack_require__(1422);
/* unused harmony reexport MinChannelPriorty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JavaScriptSDK_Enums_EventsDiscardedReason__ = __webpack_require__(563);
/* unused harmony reexport EventsDiscardedReason */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JavaScriptSDK_AppInsightsCore__ = __webpack_require__(1423);
/* unused harmony reexport AppInsightsCore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__JavaScriptSDK_BaseCore__ = __webpack_require__(564);
/* unused harmony reexport BaseCore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__JavaScriptSDK_BaseTelemetryPlugin__ = __webpack_require__(565);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__JavaScriptSDK_BaseTelemetryPlugin__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__JavaScriptSDK_RandomHelper__ = __webpack_require__(567);
/* unused harmony reexport randomValue */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_5__JavaScriptSDK_RandomHelper__["c"]; });
/* unused harmony reexport mwcRandomSeed */
/* unused harmony reexport mwcRandom32 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__ = __webpack_require__(1426);
/* unused harmony reexport CoreUtils */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["a"]; });
/* unused harmony reexport Undefined */
/* unused harmony reexport addEventHandler */
/* unused harmony reexport newGuid */
/* unused harmony reexport perfNow */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["c"]; });
/* unused harmony reexport _legacyCookieMgr */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__ = __webpack_require__(43);
/* unused harmony reexport isTypeof */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["y"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["s"]; });
/* unused harmony reexport hasOwnProperty */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["u"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["p"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["e"]; });
/* unused harmony reexport detachEvent */
/* unused harmony reexport normalizeJsName */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["A"]; });
/* unused harmony reexport strEndsWith */
/* unused harmony reexport strStartsWith */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["n"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["o"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["v"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["t"]; });
/* unused harmony reexport isBoolean */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["I"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["G"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["B"]; });
/* unused harmony reexport objDefineAccessors */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["H"]; });
/* unused harmony reexport strContains */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["D"]; });
/* unused harmony reexport getSetValue */
/* unused harmony reexport isNotTruthy */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["w"]; });
/* unused harmony reexport proxyAssign */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["C"]; });
/* unused harmony reexport isNotUndefined */
/* unused harmony reexport isNotNullOrUndefined */
/* unused harmony reexport objFreeze */
/* unused harmony reexport objSeal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__ = __webpack_require__(172);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["e"]; });
/* unused harmony reexport hasWindow */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["l"]; });
/* unused harmony reexport hasDocument */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["d"]; });
/* unused harmony reexport getCrypto */
/* unused harmony reexport getMsCrypto */
/* unused harmony reexport hasNavigator */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["j"]; });
/* unused harmony reexport hasHistory */
/* unused harmony reexport getHistory */
/* unused harmony reexport getLocation */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["g"]; });
/* unused harmony reexport isReactNative */
/* unused harmony reexport getConsole */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["a"]; });
/* unused harmony reexport isIE */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["f"]; });
/* unused harmony reexport isSafari */
/* unused harmony reexport setEnableEnvMocks */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_9__microsoft_applicationinsights_shims__["h"]; });
/* unused harmony reexport objCreate */
/* unused harmony reexport strPrototype */
/* unused harmony reexport strFunction */
/* unused harmony reexport strUndefined */
/* unused harmony reexport strObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__JavaScriptSDK_NotificationManager__ = __webpack_require__(566);
/* unused harmony reexport NotificationManager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__JavaScriptSDK_PerfManager__ = __webpack_require__(245);
/* unused harmony reexport PerfEvent */
/* unused harmony reexport PerfManager */
/* unused harmony reexport doPerf */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__JavaScriptSDK_DiagnosticLogger__ = __webpack_require__(365);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_12__JavaScriptSDK_DiagnosticLogger__["c"]; });
/* unused harmony reexport DiagnosticLogger */
/* unused harmony reexport _InternalLogMessage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__JavaScriptSDK_ProcessTelemetryContext__ = __webpack_require__(243);
/* unused harmony reexport ProcessTelemetryContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__JavaScriptSDK_TelemetryHelpers__ = __webpack_require__(367);
/* unused harmony reexport initializePlugins */
/* unused harmony reexport sortPlugins */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__JavaScriptSDK_Enums_LoggingEnums__ = __webpack_require__(244);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_15__JavaScriptSDK_Enums_LoggingEnums__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_15__JavaScriptSDK_Enums_LoggingEnums__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__JavaScriptSDK_InstrumentHooks__ = __webpack_require__(1427);
/* unused harmony reexport InstrumentProto */
/* unused harmony reexport InstrumentProtos */
/* unused harmony reexport InstrumentFunc */
/* unused harmony reexport InstrumentFuncs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__JavaScriptSDK_CookieMgr__ = __webpack_require__(368);
/* unused harmony reexport createCookieMgr */
/* unused harmony reexport safeGetCookieMgr */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_17__JavaScriptSDK_CookieMgr__["c"]; });
/* unused harmony reexport areCookiesSupported */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__JavaScriptSDK_Constants__ = __webpack_require__(366);
/* unused harmony reexport strIKey */
/* unused harmony reexport strExtensionConfig */
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



















//# sourceMappingURL=applicationinsights-core-js.js.map

/***/ }),
/* 31 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Panel_index__ = __webpack_require__(1802);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Panel_index__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Panel_index__["b"]; });

//# sourceMappingURL=Panel.js.map

/***/ }),
/* 33 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Interfaces_IChannelControls__ = __webpack_require__(1460);
/* unused harmony reexport MinChannelPriorty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JavaScriptSDK_Enums_EventsDiscardedReason__ = __webpack_require__(578);
/* unused harmony reexport EventsDiscardedReason */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JavaScriptSDK_AppInsightsCore__ = __webpack_require__(1461);
/* unused harmony reexport AppInsightsCore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__JavaScriptSDK_BaseCore__ = __webpack_require__(579);
/* unused harmony reexport BaseCore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__JavaScriptSDK_BaseTelemetryPlugin__ = __webpack_require__(580);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__JavaScriptSDK_BaseTelemetryPlugin__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__JavaScriptSDK_RandomHelper__ = __webpack_require__(582);
/* unused harmony reexport randomValue */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_5__JavaScriptSDK_RandomHelper__["c"]; });
/* unused harmony reexport mwcRandomSeed */
/* unused harmony reexport mwcRandom32 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__ = __webpack_require__(1464);
/* unused harmony reexport CoreUtils */
/* unused harmony reexport EventHelper */
/* unused harmony reexport Undefined */
/* unused harmony reexport addEventHandler */
/* unused harmony reexport newGuid */
/* unused harmony reexport perfNow */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["b"]; });
/* unused harmony reexport _legacyCookieMgr */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__ = __webpack_require__(44);
/* unused harmony reexport isTypeof */
/* unused harmony reexport isUndefined */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["s"]; });
/* unused harmony reexport hasOwnProperty */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["u"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["p"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["e"]; });
/* unused harmony reexport detachEvent */
/* unused harmony reexport normalizeJsName */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["A"]; });
/* unused harmony reexport strEndsWith */
/* unused harmony reexport strStartsWith */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["n"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["o"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["v"]; });
/* unused harmony reexport isNumber */
/* unused harmony reexport isBoolean */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["H"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["a"]; });
/* unused harmony reexport arrIndexOf */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["F"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["B"]; });
/* unused harmony reexport objDefineAccessors */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["i"]; });
/* unused harmony reexport throwError */
/* unused harmony reexport strContains */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["C"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["j"]; });
/* unused harmony reexport isNotTruthy */
/* unused harmony reexport isTruthy */
/* unused harmony reexport proxyAssign */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["f"]; });
/* unused harmony reexport optimizeObject */
/* unused harmony reexport isNotUndefined */
/* unused harmony reexport isNotNullOrUndefined */
/* unused harmony reexport objFreeze */
/* unused harmony reexport objSeal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__ = __webpack_require__(173);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["n"]; });
/* unused harmony reexport getWindow */
/* unused harmony reexport hasDocument */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["d"]; });
/* unused harmony reexport getCrypto */
/* unused harmony reexport getMsCrypto */
/* unused harmony reexport hasNavigator */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["j"]; });
/* unused harmony reexport hasHistory */
/* unused harmony reexport getHistory */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["g"]; });
/* unused harmony reexport isReactNative */
/* unused harmony reexport getConsole */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["a"]; });
/* unused harmony reexport isIE */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["f"]; });
/* unused harmony reexport isSafari */
/* unused harmony reexport setEnableEnvMocks */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_9__microsoft_applicationinsights_shims__["h"]; });
/* unused harmony reexport objCreate */
/* unused harmony reexport strPrototype */
/* unused harmony reexport strFunction */
/* unused harmony reexport strUndefined */
/* unused harmony reexport strObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__JavaScriptSDK_NotificationManager__ = __webpack_require__(581);
/* unused harmony reexport NotificationManager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__JavaScriptSDK_PerfManager__ = __webpack_require__(249);
/* unused harmony reexport PerfEvent */
/* unused harmony reexport PerfManager */
/* unused harmony reexport doPerf */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__JavaScriptSDK_DiagnosticLogger__ = __webpack_require__(370);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_12__JavaScriptSDK_DiagnosticLogger__["c"]; });
/* unused harmony reexport DiagnosticLogger */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_12__JavaScriptSDK_DiagnosticLogger__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__JavaScriptSDK_ProcessTelemetryContext__ = __webpack_require__(247);
/* unused harmony reexport ProcessTelemetryContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__JavaScriptSDK_TelemetryHelpers__ = __webpack_require__(372);
/* unused harmony reexport initializePlugins */
/* unused harmony reexport sortPlugins */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__JavaScriptSDK_Enums_LoggingEnums__ = __webpack_require__(248);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_15__JavaScriptSDK_Enums_LoggingEnums__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_15__JavaScriptSDK_Enums_LoggingEnums__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__JavaScriptSDK_InstrumentHooks__ = __webpack_require__(1465);
/* unused harmony reexport InstrumentProto */
/* unused harmony reexport InstrumentProtos */
/* unused harmony reexport InstrumentFunc */
/* unused harmony reexport InstrumentFuncs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__JavaScriptSDK_CookieMgr__ = __webpack_require__(373);
/* unused harmony reexport createCookieMgr */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_17__JavaScriptSDK_CookieMgr__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_17__JavaScriptSDK_CookieMgr__["d"]; });
/* unused harmony reexport areCookiesSupported */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__JavaScriptSDK_Constants__ = __webpack_require__(371);
/* unused harmony reexport strIKey */
/* unused harmony reexport strExtensionConfig */
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



















//# sourceMappingURL=applicationinsights-core-js.js.map

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Interfaces_IChannelControls__ = __webpack_require__(1497);
/* unused harmony reexport MinChannelPriorty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JavaScriptSDK_Enums_EventsDiscardedReason__ = __webpack_require__(599);
/* unused harmony reexport EventsDiscardedReason */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JavaScriptSDK_AppInsightsCore__ = __webpack_require__(1498);
/* unused harmony reexport AppInsightsCore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__JavaScriptSDK_BaseCore__ = __webpack_require__(600);
/* unused harmony reexport BaseCore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__JavaScriptSDK_BaseTelemetryPlugin__ = __webpack_require__(601);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__JavaScriptSDK_BaseTelemetryPlugin__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__JavaScriptSDK_RandomHelper__ = __webpack_require__(603);
/* unused harmony reexport randomValue */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_5__JavaScriptSDK_RandomHelper__["c"]; });
/* unused harmony reexport mwcRandomSeed */
/* unused harmony reexport mwcRandom32 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__ = __webpack_require__(1501);
/* unused harmony reexport CoreUtils */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["a"]; });
/* unused harmony reexport Undefined */
/* unused harmony reexport addEventHandler */
/* unused harmony reexport newGuid */
/* unused harmony reexport perfNow */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["c"]; });
/* unused harmony reexport _legacyCookieMgr */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__ = __webpack_require__(45);
/* unused harmony reexport isTypeof */
/* unused harmony reexport isUndefined */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["s"]; });
/* unused harmony reexport hasOwnProperty */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["u"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["p"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["e"]; });
/* unused harmony reexport detachEvent */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["z"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["B"]; });
/* unused harmony reexport strEndsWith */
/* unused harmony reexport strStartsWith */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["n"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["o"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["v"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["t"]; });
/* unused harmony reexport isBoolean */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["I"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["a"]; });
/* unused harmony reexport arrIndexOf */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["G"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["C"]; });
/* unused harmony reexport objDefineAccessors */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["i"]; });
/* unused harmony reexport throwError */
/* unused harmony reexport strContains */
/* unused harmony reexport setValue */
/* unused harmony reexport getSetValue */
/* unused harmony reexport isNotTruthy */
/* unused harmony reexport isTruthy */
/* unused harmony reexport proxyAssign */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["f"]; });
/* unused harmony reexport optimizeObject */
/* unused harmony reexport isNotUndefined */
/* unused harmony reexport isNotNullOrUndefined */
/* unused harmony reexport objFreeze */
/* unused harmony reexport objSeal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__ = __webpack_require__(175);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["e"]; });
/* unused harmony reexport hasWindow */
/* unused harmony reexport getWindow */
/* unused harmony reexport hasDocument */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["d"]; });
/* unused harmony reexport getCrypto */
/* unused harmony reexport getMsCrypto */
/* unused harmony reexport hasNavigator */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["j"]; });
/* unused harmony reexport hasHistory */
/* unused harmony reexport getHistory */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["g"]; });
/* unused harmony reexport isReactNative */
/* unused harmony reexport getConsole */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["a"]; });
/* unused harmony reexport isIE */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["f"]; });
/* unused harmony reexport isSafari */
/* unused harmony reexport setEnableEnvMocks */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_9__microsoft_applicationinsights_shims__["h"]; });
/* unused harmony reexport objCreate */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_9__microsoft_applicationinsights_shims__["l"]; });
/* unused harmony reexport strFunction */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_9__microsoft_applicationinsights_shims__["m"]; });
/* unused harmony reexport strObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__JavaScriptSDK_NotificationManager__ = __webpack_require__(602);
/* unused harmony reexport NotificationManager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__JavaScriptSDK_PerfManager__ = __webpack_require__(253);
/* unused harmony reexport PerfEvent */
/* unused harmony reexport PerfManager */
/* unused harmony reexport doPerf */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__JavaScriptSDK_DiagnosticLogger__ = __webpack_require__(375);
/* unused harmony reexport safeGetLogger */
/* unused harmony reexport DiagnosticLogger */
/* unused harmony reexport _InternalLogMessage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__JavaScriptSDK_ProcessTelemetryContext__ = __webpack_require__(251);
/* unused harmony reexport ProcessTelemetryContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__JavaScriptSDK_TelemetryHelpers__ = __webpack_require__(377);
/* unused harmony reexport initializePlugins */
/* unused harmony reexport sortPlugins */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__JavaScriptSDK_Enums_LoggingEnums__ = __webpack_require__(252);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_15__JavaScriptSDK_Enums_LoggingEnums__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_15__JavaScriptSDK_Enums_LoggingEnums__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__JavaScriptSDK_InstrumentHooks__ = __webpack_require__(1502);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_16__JavaScriptSDK_InstrumentHooks__["b"]; });
/* unused harmony reexport InstrumentProtos */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_16__JavaScriptSDK_InstrumentHooks__["a"]; });
/* unused harmony reexport InstrumentFuncs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__JavaScriptSDK_CookieMgr__ = __webpack_require__(378);
/* unused harmony reexport createCookieMgr */
/* unused harmony reexport safeGetCookieMgr */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_17__JavaScriptSDK_CookieMgr__["c"]; });
/* unused harmony reexport areCookiesSupported */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__JavaScriptSDK_Constants__ = __webpack_require__(376);
/* unused harmony reexport strIKey */
/* unused harmony reexport strExtensionConfig */
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



















//# sourceMappingURL=applicationinsights-core-js.js.map

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DirectionalHint; });
var DirectionalHint = {
    /**
     * Appear above the target element, with the left edges of the callout and target aligning.
     */
    topLeftEdge: 0,
    /**
     * Appear above the target element, with the centers of the callout and target aligning.
     */
    topCenter: 1,
    /**
     * Appear above the target element, with the right edges of the callout and target aligning.
     */
    topRightEdge: 2,
    /**
     * Appear above the target element, aligning with the target element such that the callout tends toward the center of the screen.
     */
    topAutoEdge: 3,
    /**
     * Appear below the target element, with the left edges of the callout and target aligning.
     */
    bottomLeftEdge: 4,
    /**
     * Appear below the target element, with the centers of the callout and target aligning.
     */
    bottomCenter: 5,
    /**
     * Appear below the target element, with the right edges of the callout and target aligning.
     */
    bottomRightEdge: 6,
    /**
     * Appear below the target element, aligning with the target element such that the callout tends toward the center of the screen.
     */
    bottomAutoEdge: 7,
    /**
     * Appear to the left of the target element, with the top edges of the callout and target aligning.
     */
    leftTopEdge: 8,
    /**
     * Appear to the left of the target element, with the centers of the callout and target aligning.
     */
    leftCenter: 9,
    /**
     * Appear to the left of the target element, with the bottom edges of the callout and target aligning.
     */
    leftBottomEdge: 10,
    /**
     * Appear to the right of the target element, with the top edges of the callout and target aligning.
     */
    rightTopEdge: 11,
    /**
     * Appear to the right of the target element, with the centers of the callout and target aligning.
     */
    rightCenter: 12,
    /**
     * Appear to the right of the target element, with the bottom edges of the callout and target aligning.
     */
    rightBottomEdge: 13
};
//# sourceMappingURL=DirectionalHint.js.map

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MAX_COLOR_SATURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MAX_COLOR_HUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return MAX_COLOR_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MAX_COLOR_RGB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MAX_COLOR_RGBA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MAX_COLOR_ALPHA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return MIN_HEX_LENGTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return MAX_HEX_LENGTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return MIN_RGBA_LENGTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return MAX_RGBA_LENGTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HEX_REGEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return RGBA_REGEX; });
var MAX_COLOR_SATURATION = 100;
var MAX_COLOR_HUE = 359;
var MAX_COLOR_VALUE = 100;
var MAX_COLOR_RGB = 255;
/** @deprecated Use MAX_COLOR_RGB (255) or MAX_COLOR_ALPHA (100) */
var MAX_COLOR_RGBA = MAX_COLOR_RGB;
var MAX_COLOR_ALPHA = 100;
/** Minimum length for a hexadecimal color string (not including the #) */
var MIN_HEX_LENGTH = 3;
/** Maximum length for a hexadecimal color string (not including the #) */
var MAX_HEX_LENGTH = 6;
/** Minimum length for a string of an RGBA color component */
var MIN_RGBA_LENGTH = 1;
/** Maximum length for a string of an RGBA color component */
var MAX_RGBA_LENGTH = 3;
/** Regular expression matching only valid hexadecimal chars */
var HEX_REGEX = /^[\da-f]{0,6}$/i;
/** Regular expression matching only numbers */
var RGBA_REGEX = /^\d{0,3}$/;
//# sourceMappingURL=consts.js.map

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var moment = module.exports = __webpack_require__(1654);
moment.tz.load(__webpack_require__(1655));


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Interfaces_IChannelControls__ = __webpack_require__(1378);
/* unused harmony reexport MinChannelPriorty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JavaScriptSDK_Enums_EventsDiscardedReason__ = __webpack_require__(539);
/* unused harmony reexport EventsDiscardedReason */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JavaScriptSDK_AppInsightsCore__ = __webpack_require__(1379);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__JavaScriptSDK_AppInsightsCore__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__JavaScriptSDK_BaseCore__ = __webpack_require__(541);
/* unused harmony reexport BaseCore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__JavaScriptSDK_BaseTelemetryPlugin__ = __webpack_require__(542);
/* unused harmony reexport BaseTelemetryPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__JavaScriptSDK_RandomHelper__ = __webpack_require__(544);
/* unused harmony reexport randomValue */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_5__JavaScriptSDK_RandomHelper__["c"]; });
/* unused harmony reexport mwcRandomSeed */
/* unused harmony reexport mwcRandom32 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__ = __webpack_require__(1383);
/* unused harmony reexport CoreUtils */
/* unused harmony reexport EventHelper */
/* unused harmony reexport Undefined */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["b"]; });
/* unused harmony reexport newGuid */
/* unused harmony reexport perfNow */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__ = __webpack_require__(40);
/* unused harmony reexport isTypeof */
/* unused harmony reexport isUndefined */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["s"]; });
/* unused harmony reexport hasOwnProperty */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["u"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["p"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["e"]; });
/* unused harmony reexport detachEvent */
/* unused harmony reexport normalizeJsName */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["A"]; });
/* unused harmony reexport strEndsWith */
/* unused harmony reexport strStartsWith */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["n"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["o"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["v"]; });
/* unused harmony reexport isNumber */
/* unused harmony reexport isBoolean */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["I"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["a"]; });
/* unused harmony reexport arrIndexOf */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["G"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["B"]; });
/* unused harmony reexport objDefineAccessors */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["H"]; });
/* unused harmony reexport strContains */
/* unused harmony reexport setValue */
/* unused harmony reexport getSetValue */
/* unused harmony reexport isNotTruthy */
/* unused harmony reexport isTruthy */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["C"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["f"]; });
/* unused harmony reexport optimizeObject */
/* unused harmony reexport isNotUndefined */
/* unused harmony reexport isNotNullOrUndefined */
/* unused harmony reexport objFreeze */
/* unused harmony reexport objSeal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__ = __webpack_require__(169);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["o"]; });
/* unused harmony reexport getWindow */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["d"]; });
/* unused harmony reexport getCrypto */
/* unused harmony reexport getMsCrypto */
/* unused harmony reexport hasNavigator */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["j"]; });
/* unused harmony reexport hasHistory */
/* unused harmony reexport getHistory */
/* unused harmony reexport getLocation */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["n"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["q"]; });
/* unused harmony reexport getConsole */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["a"]; });
/* unused harmony reexport isIE */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["f"]; });
/* unused harmony reexport isSafari */
/* unused harmony reexport setEnableEnvMocks */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_9__microsoft_applicationinsights_shims__["h"]; });
/* unused harmony reexport objCreate */
/* unused harmony reexport strPrototype */
/* unused harmony reexport strFunction */
/* unused harmony reexport strUndefined */
/* unused harmony reexport strObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__JavaScriptSDK_NotificationManager__ = __webpack_require__(543);
/* unused harmony reexport NotificationManager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__JavaScriptSDK_PerfManager__ = __webpack_require__(237);
/* unused harmony reexport PerfEvent */
/* unused harmony reexport PerfManager */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_11__JavaScriptSDK_PerfManager__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__JavaScriptSDK_DiagnosticLogger__ = __webpack_require__(356);
/* unused harmony reexport safeGetLogger */
/* unused harmony reexport DiagnosticLogger */
/* unused harmony reexport _InternalLogMessage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__JavaScriptSDK_ProcessTelemetryContext__ = __webpack_require__(235);
/* unused harmony reexport ProcessTelemetryContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__JavaScriptSDK_TelemetryHelpers__ = __webpack_require__(358);
/* unused harmony reexport initializePlugins */
/* unused harmony reexport sortPlugins */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__JavaScriptSDK_Enums_LoggingEnums__ = __webpack_require__(236);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_15__JavaScriptSDK_Enums_LoggingEnums__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_15__JavaScriptSDK_Enums_LoggingEnums__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__JavaScriptSDK_InstrumentHooks__ = __webpack_require__(1384);
/* unused harmony reexport InstrumentProto */
/* unused harmony reexport InstrumentProtos */
/* unused harmony reexport InstrumentFunc */
/* unused harmony reexport InstrumentFuncs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__JavaScriptSDK_CookieMgr__ = __webpack_require__(359);
/* unused harmony reexport createCookieMgr */
/* unused harmony reexport safeGetCookieMgr */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_17__JavaScriptSDK_CookieMgr__["c"]; });
/* unused harmony reexport areCookiesSupported */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__JavaScriptSDK_Constants__ = __webpack_require__(357);
/* unused harmony reexport strIKey */
/* unused harmony reexport strExtensionConfig */
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



















//# sourceMappingURL=applicationinsights-core-js.js.map

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export objToString */
/* harmony export (immutable) */ __webpack_exports__["x"] = isTypeof;
/* harmony export (immutable) */ __webpack_exports__["y"] = isUndefined;
/* unused harmony export isNotUndefined */
/* harmony export (immutable) */ __webpack_exports__["s"] = isNullOrUndefined;
/* harmony export (immutable) */ __webpack_exports__["q"] = isNotNullOrUndefined;
/* harmony export (immutable) */ __webpack_exports__["k"] = hasOwnProperty;
/* harmony export (immutable) */ __webpack_exports__["u"] = isObject;
/* harmony export (immutable) */ __webpack_exports__["p"] = isFunction;
/* harmony export (immutable) */ __webpack_exports__["e"] = attachEvent;
/* harmony export (immutable) */ __webpack_exports__["h"] = detachEvent;
/* unused harmony export normalizeJsName */
/* harmony export (immutable) */ __webpack_exports__["A"] = objForEachKey;
/* harmony export (immutable) */ __webpack_exports__["F"] = strEndsWith;
/* unused harmony export strStartsWith */
/* harmony export (immutable) */ __webpack_exports__["E"] = strContains;
/* harmony export (immutable) */ __webpack_exports__["n"] = isDate;
/* harmony export (immutable) */ __webpack_exports__["l"] = isArray;
/* harmony export (immutable) */ __webpack_exports__["o"] = isError;
/* harmony export (immutable) */ __webpack_exports__["v"] = isString;
/* harmony export (immutable) */ __webpack_exports__["t"] = isNumber;
/* harmony export (immutable) */ __webpack_exports__["m"] = isBoolean;
/* harmony export (immutable) */ __webpack_exports__["I"] = toISOString;
/* harmony export (immutable) */ __webpack_exports__["a"] = arrForEach;
/* harmony export (immutable) */ __webpack_exports__["b"] = arrIndexOf;
/* harmony export (immutable) */ __webpack_exports__["c"] = arrMap;
/* harmony export (immutable) */ __webpack_exports__["d"] = arrReduce;
/* harmony export (immutable) */ __webpack_exports__["G"] = strTrim;
/* harmony export (immutable) */ __webpack_exports__["B"] = objKeys;
/* harmony export (immutable) */ __webpack_exports__["z"] = objDefineAccessors;
/* unused harmony export objFreeze */
/* unused harmony export objSeal */
/* harmony export (immutable) */ __webpack_exports__["g"] = dateNow;
/* harmony export (immutable) */ __webpack_exports__["i"] = getExceptionName;
/* harmony export (immutable) */ __webpack_exports__["D"] = setValue;
/* harmony export (immutable) */ __webpack_exports__["j"] = getSetValue;
/* harmony export (immutable) */ __webpack_exports__["r"] = isNotTruthy;
/* harmony export (immutable) */ __webpack_exports__["w"] = isTruthy;
/* harmony export (immutable) */ __webpack_exports__["H"] = throwError;
/* harmony export (immutable) */ __webpack_exports__["C"] = proxyAssign;
/* harmony export (immutable) */ __webpack_exports__["f"] = createClassFromInterface;
/* unused harmony export optimizeObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



// RESTRICT and AVOID circular dependencies you should not import other contained modules or export the contents of this file directly
// Added to help with minfication
var strOnPrefix = "on";
var strAttachEvent = "attachEvent";
var strAddEventHelper = "addEventListener";
var strDetachEvent = "detachEvent";
var strRemoveEventListener = "removeEventListener";
var _objDefineProperty = __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["c" /* ObjDefineProperty */];
var _objFreeze = __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["b" /* ObjClass */]["freeze"];
var _objSeal = __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["b" /* ObjClass */]["seal"];
function objToString(obj) {
    return __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["e" /* ObjProto */].toString.call(obj);
}
function isTypeof(value, theType) {
    return typeof value === theType;
}
;
function isUndefined(value) {
    return value === undefined || typeof value === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["m" /* strShimUndefined */];
}
;
function isNotUndefined(value) {
    return !isUndefined(value);
}
function isNullOrUndefined(value) {
    return (value === null || isUndefined(value));
}
function isNotNullOrUndefined(value) {
    return !isNullOrUndefined(value);
}
function hasOwnProperty(obj, prop) {
    return obj && __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["d" /* ObjHasOwnProperty */].call(obj, prop);
}
;
function isObject(value) {
    // Changing to inline for performance
    return typeof value === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */];
}
;
function isFunction(value) {
    // Changing to inline for performance
    return typeof value === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["j" /* strShimFunction */];
}
;
/**
 * Binds the specified function to an event, so that the function gets called whenever the event fires on the object
 * @param obj Object to add the event too.
 * @param eventNameWithoutOn String that specifies any of the standard DHTML Events without "on" prefix
 * @param handlerRef Pointer that specifies the function to call when event fires
 * @param useCapture [Optional] Defaults to false
 * @returns True if the function was bound successfully to the event, otherwise false
 */
function attachEvent(obj, eventNameWithoutOn, handlerRef, useCapture) {
    if (useCapture === void 0) { useCapture = false; }
    var result = false;
    if (!isNullOrUndefined(obj)) {
        try {
            if (!isNullOrUndefined(obj[strAddEventHelper])) {
                // all browsers except IE before version 9
                obj[strAddEventHelper](eventNameWithoutOn, handlerRef, useCapture);
                result = true;
            }
            else if (!isNullOrUndefined(obj[strAttachEvent])) {
                // IE before version 9                    
                obj[strAttachEvent](strOnPrefix + eventNameWithoutOn, handlerRef);
                result = true;
            }
        }
        catch (e) {
            // Just Ignore any error so that we don't break any execution path
        }
    }
    return result;
}
/**
 * Removes an event handler for the specified event
 * @param Object to remove the event from
 * @param eventNameWithoutOn {string} - The name of the event
 * @param handlerRef {any} - The callback function that needs to be executed for the given event
 * @param useCapture [Optional] Defaults to false
 */
function detachEvent(obj, eventNameWithoutOn, handlerRef, useCapture) {
    if (useCapture === void 0) { useCapture = false; }
    if (!isNullOrUndefined(obj)) {
        try {
            if (!isNullOrUndefined(obj[strRemoveEventListener])) {
                obj[strRemoveEventListener](eventNameWithoutOn, handlerRef, useCapture);
            }
            else if (!isNullOrUndefined(obj[strDetachEvent])) {
                obj[strDetachEvent](strOnPrefix + eventNameWithoutOn, handlerRef);
            }
        }
        catch (e) {
            // Just Ignore any error so that we don't break any execution path
        }
    }
}
/**
 * Validates that the string name conforms to the JS IdentifierName specification and if not
 * normalizes the name so that it would. This method does not identify or change any keywords
 * meaning that if you pass in a known keyword the same value will be returned.
 * This is a simplified version
 * @param name The name to validate
 */
function normalizeJsName(name) {
    var value = name;
    var match = /([^\w\d_$])/g;
    if (match.test(name)) {
        value = name.replace(match, "_");
    }
    return value;
}
/**
 * This is a helper function for the equivalent of arForEach(objKeys(target), callbackFn), this is a
 * performance optimization to avoid the creation of a new array for large objects
 * @param target The target object to find and process the keys
 * @param callbackfn The function to call with the details
 */
function objForEachKey(target, callbackfn) {
    if (target) {
        for (var prop in target) {
            if (__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["d" /* ObjHasOwnProperty */].call(target, prop)) {
                callbackfn.call(target, prop, target[prop]);
            }
        }
    }
}
/**
 * The strEndsWith() method determines whether a string ends with the characters of a specified string, returning true or false as appropriate.
 * @param value - The value to check whether it ends with the search value.
 * @param search - The characters to be searched for at the end of the value.
 * @returns true if the given search value is found at the end of the string, otherwise false.
 */
function strEndsWith(value, search) {
    if (value && search) {
        var searchLen = search.length;
        var valLen = value.length;
        if (value === search) {
            return true;
        }
        else if (valLen >= searchLen) {
            var pos = valLen - 1;
            for (var lp = searchLen - 1; lp >= 0; lp--) {
                if (value[pos] != search[lp]) {
                    return false;
                }
                pos--;
            }
            return true;
        }
    }
    return false;
}
/**
 * The strStartsWith() method determines whether a string starts with the characters of the specified string, returning true or false as appropriate.
 * @param value - The value to check whether it ends with the search value.
 * @param checkValue - The characters to be searched for at the start of the value.
 * @returns true if the given search value is found at the start of the string, otherwise false.
 */
function strStartsWith(value, checkValue) {
    // Using helper for performance and because string startsWith() is not available on IE
    var result = false;
    if (value && checkValue) {
        var chkLen = checkValue.length;
        if (value === checkValue) {
            return true;
        }
        else if (value.length >= chkLen) {
            for (var lp = 0; lp < chkLen; lp++) {
                if (value[lp] !== checkValue[lp]) {
                    return false;
                }
            }
            result = true;
        }
    }
    return result;
}
/**
 * A simple wrapper (for minification support) to check if the value contains the search string.
 * @param value - The string value to check for the existence of the search value
 * @param search - The value search within the value
 */
function strContains(value, search) {
    if (value && search) {
        return value.indexOf(search) !== -1;
    }
    return false;
}
/**
 * Check if an object is of type Date
 */
function isDate(obj) {
    return objToString(obj) === "[object Date]";
}
/**
 * Check if an object is of type Array
 */
function isArray(obj) {
    return objToString(obj) === "[object Array]";
}
/**
 * Check if an object is of type Error
 */
function isError(obj) {
    return objToString(obj) === "[object Error]";
}
/**
 * Checks if the type of value is a string.
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is a string, false otherwise.
 */
function isString(value) {
    // Changing to inline for performance
    return typeof value === "string";
}
/**
 * Checks if the type of value is a number.
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is a number, false otherwise.
 */
function isNumber(value) {
    // Changing to inline for performance
    return typeof value === "number";
}
/**
 * Checks if the type of value is a boolean.
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is a boolean, false otherwise.
 */
function isBoolean(value) {
    // Changing to inline for performance
    return typeof value === "boolean";
}
/**
 * Convert a date to I.S.O. format in IE8
 */
function toISOString(date) {
    if (isDate(date)) {
        var pad = function (num) {
            var r = String(num);
            if (r.length === 1) {
                r = "0" + r;
            }
            return r;
        };
        return date.getUTCFullYear()
            + "-" + pad(date.getUTCMonth() + 1)
            + "-" + pad(date.getUTCDate())
            + "T" + pad(date.getUTCHours())
            + ":" + pad(date.getUTCMinutes())
            + ":" + pad(date.getUTCSeconds())
            + "." + String((date.getUTCMilliseconds() / 1000).toFixed(3)).slice(2, 5)
            + "Z";
    }
}
/**
 * Performs the specified action for each element in an array. This helper exists to avoid adding a polyfil for older browsers
 * that do not define Array.prototype.xxxx (eg. ES3 only, IE8) just in case any page checks for presence/absence of the prototype
 * implementation. Note: For consistency this will not use the Array.prototype.xxxx implementation if it exists as this would
 * cause a testing requirement to test with and without the implementations
 * @param callbackfn  A function that accepts up to three arguments. forEach calls the callbackfn function one time for each element in the array. It can return -1 to break out of the loop
 * @param thisArg  [Optional] An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, undefined is used as the this value.
 */
function arrForEach(arr, callbackfn, thisArg) {
    var len = arr.length;
    for (var idx = 0; idx < len; idx++) {
        if (idx in arr) {
            if (callbackfn.call(thisArg || arr, arr[idx], idx, arr) === -1) {
                break;
            }
        }
    }
}
/**
 * Returns the index of the first occurrence of a value in an array. This helper exists to avoid adding a polyfil for older browsers
 * that do not define Array.prototype.xxxx (eg. ES3 only, IE8) just in case any page checks for presence/absence of the prototype
 * implementation. Note: For consistency this will not use the Array.prototype.xxxx implementation if it exists as this would
 * cause a testing requirement to test with and without the implementations
 * @param searchElement The value to locate in the array.
 * @param fromIndex The array index at which to begin the search. If fromIndex is omitted, the search starts at index 0.
 */
function arrIndexOf(arr, searchElement, fromIndex) {
    var len = arr.length;
    var from = fromIndex || 0;
    for (var lp = Math.max(from >= 0 ? from : len - Math.abs(from), 0); lp < len; lp++) {
        if (lp in arr && arr[lp] === searchElement) {
            return lp;
        }
    }
    return -1;
}
/**
 * Calls a defined callback function on each element of an array, and returns an array that contains the results. This helper exists
 * to avoid adding a polyfil for older browsers that do not define Array.prototype.xxxx (eg. ES3 only, IE8) just in case any page
 * checks for presence/absence of the prototype implementation. Note: For consistency this will not use the Array.prototype.xxxx
 * implementation if it exists as this would cause a testing requirement to test with and without the implementations
 * @param callbackfn A function that accepts up to three arguments. The map method calls the callbackfn function one time for each element in the array.
 * @param thisArg An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, undefined is used as the this value.
 */
function arrMap(arr, callbackfn, thisArg) {
    var len = arr.length;
    var _this = thisArg || arr;
    var results = new Array(len);
    for (var lp = 0; lp < len; lp++) {
        if (lp in arr) {
            results[lp] = callbackfn.call(_this, arr[lp], arr);
        }
    }
    return results;
}
/**
 * Calls the specified callback function for all the elements in an array. The return value of the callback function is the accumulated result, and is
 * provided as an argument in the next call to the callback function. This helper exists to avoid adding a polyfil for older browsers that do not define
 * Array.prototype.xxxx (eg. ES3 only, IE8) just in case any page checks for presence/absence of the prototype implementation. Note: For consistency
 * this will not use the Array.prototype.xxxx implementation if it exists as this would cause a testing requirement to test with and without the implementations
 * @param callbackfn A function that accepts up to four arguments. The reduce method calls the callbackfn function one time for each element in the array.
 * @param initialValue If initialValue is specified, it is used as the initial value to start the accumulation. The first call to the callbackfn function provides this value as an argument instead of an array value.
 */
function arrReduce(arr, callbackfn, initialValue) {
    var len = arr.length;
    var lp = 0;
    var value;
    // Specifically checking the number of passed arguments as the value could be anything
    if (arguments.length >= 3) {
        value = arguments[2];
    }
    else {
        while (lp < len && !(lp in arr)) {
            lp++;
        }
        value = arr[lp++];
    }
    while (lp < len) {
        if (lp in arr) {
            value = callbackfn(value, arr[lp], lp, arr);
        }
        lp++;
    }
    return value;
}
/**
 * helper method to trim strings (IE8 does not implement String.prototype.trim)
 */
function strTrim(str) {
    if (typeof str !== "string") {
        return str;
    }
    return str.replace(/^\s+|\s+$/g, "");
}
var _objKeysHasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString');
var _objKeysDontEnums = [
    'toString',
    'toLocaleString',
    'valueOf',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'constructor'
];
/**
 * Returns the names of the enumerable string properties and methods of an object. This helper exists to avoid adding a polyfil for older browsers
 * that do not define Object.keys eg. ES3 only, IE8 just in case any page checks for presence/absence of the prototype implementation.
 * Note: For consistency this will not use the Object.keys implementation if it exists as this would cause a testing requirement to test with and without the implementations
 * @param obj Object that contains the properties and methods. This can be an object that you created or an existing Document Object Model (DOM) object.
 */
function objKeys(obj) {
    var objType = typeof obj;
    if (objType !== __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["j" /* strShimFunction */] && (objType !== __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] || obj === null)) {
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["n" /* throwTypeError */])('objKeys called on non-object');
    }
    var result = [];
    for (var prop in obj) {
        if (obj && __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["d" /* ObjHasOwnProperty */].call(obj, prop)) {
            result.push(prop);
        }
    }
    if (_objKeysHasDontEnumBug) {
        var dontEnumsLength = _objKeysDontEnums.length;
        for (var lp = 0; lp < dontEnumsLength; lp++) {
            if (obj && __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["d" /* ObjHasOwnProperty */].call(obj, _objKeysDontEnums[lp])) {
                result.push(_objKeysDontEnums[lp]);
            }
        }
    }
    return result;
}
/**
 * Try to define get/set object property accessors for the target object/prototype, this will provide compatibility with
 * existing API definition when run within an ES5+ container that supports accessors but still enable the code to be loaded
 * and executed in an ES3 container, providing basic IE8 compatibility.
 * @param target The object on which to define the property.
 * @param prop The name of the property to be defined or modified.
 * @param getProp The getter function to wire against the getter.
 * @param setProp The setter function to wire against the setter.
 * @returns True if it was able to create the accessors otherwise false
 */
function objDefineAccessors(target, prop, getProp, setProp) {
    if (_objDefineProperty) {
        try {
            var descriptor = {
                enumerable: true,
                configurable: true
            };
            if (getProp) {
                descriptor.get = getProp;
            }
            if (setProp) {
                descriptor.set = setProp;
            }
            _objDefineProperty(target, prop, descriptor);
            return true;
        }
        catch (e) {
            // IE8 Defines a defineProperty on Object but it's only supported for DOM elements so it will throw
            // We will just ignore this here.
        }
    }
    return false;
}
function objFreeze(value) {
    if (_objFreeze) {
        value = _objFreeze(value);
    }
    return value;
}
function objSeal(value) {
    if (_objSeal) {
        value = _objSeal(value);
    }
    return value;
}
/**
 * Return the current time via the Date now() function (if available) and falls back to (new Date()).getTime() if now() is unavailable (IE8 or less)
 * https://caniuse.com/#search=Date.now
 */
function dateNow() {
    var dt = Date;
    if (dt.now) {
        return dt.now();
    }
    return new dt().getTime();
}
/**
 * Returns the name of object if it's an Error. Otherwise, returns empty string.
 */
function getExceptionName(object) {
    if (isError(object)) {
        return object.name;
    }
    return "";
}
/**
 * Sets the provided value on the target instance using the field name when the provided chk function returns true, the chk
 * function will only be called if the new value is no equal to the original value.
 * @param target - The target object
 * @param field - The key of the target
 * @param value - The value to set
 * @param valChk - [Optional] Callback to check the value that if supplied will be called check if the new value can be set
 * @param srcChk - [Optional] Callback to check to original value that if supplied will be called if the new value should be set (if allowed)
 * @returns The existing or new value, depending what was set
 */
function setValue(target, field, value, valChk, srcChk) {
    var theValue = value;
    if (target) {
        theValue = target[field];
        if (theValue !== value && (!srcChk || srcChk(theValue)) && (!valChk || valChk(value))) {
            theValue = value;
            target[field] = theValue;
        }
    }
    return theValue;
}
/**
 * Returns the current value from the target object if not null or undefined otherwise sets the new value and returns it
 * @param target - The target object to return or set the default value
 * @param field - The key for the field to set on the target
 * @param defValue - [Optional] The value to set if not already present, when not provided a empty object will be added
 */
function getSetValue(target, field, defValue) {
    var theValue;
    if (target) {
        theValue = target[field];
        if (!theValue && isNullOrUndefined(theValue)) {
            // Supports having the default as null
            theValue = !isUndefined(defValue) ? defValue : {};
            target[field] = theValue;
        }
    }
    else {
        // Expanded for performance so we only check defValue if required
        theValue = !isUndefined(defValue) ? defValue : {};
    }
    return theValue;
}
function isNotTruthy(value) {
    return !value;
}
function isTruthy(value) {
    return !!value;
}
function throwError(message) {
    throw new Error(message);
}
/**
 * Effectively assigns all enumerable properties (not just own properties) and functions (including inherited prototype) from
 * the source object to the target, it attempts to use proxy getters / setters (if possible) and proxy functions to avoid potential
 * implementation issues by assigning prototype functions as instance ones
 *
 * This method is the primary method used to "update" the snippet proxy with the ultimate implementations.
 *
 * Special ES3 Notes:
 * Updates (setting) of direct property values on the target or indirectly on the source object WILL NOT WORK PROPERLY, updates to the
 * properties of "referenced" object will work (target.context.newValue = 10 => will be reflected in the source.context as it's the
 * same object). ES3 Failures: assigning target.myProp = 3 -> Won't change source.myProp = 3, likewise the reverse would also fail.
 * @param target - The target object to be assigned with the source properties and functions
 * @param source - The source object which will be assigned / called by setting / calling the targets proxies
 * @param chkSet - An optional callback to determine whether a specific property/function should be proxied
 * @memberof Initialization
 */
function proxyAssign(target, source, chkSet) {
    if (target && source && target !== source && isObject(target) && isObject(source)) {
        var _loop_1 = function (field) {
            if (isString(field)) {
                var value = source[field];
                if (isFunction(value)) {
                    if (!chkSet || chkSet(field, true, source, target)) {
                        // Create a proxy function rather than just copying the (possible) prototype to the new object as an instance function
                        target[field] = (function (funcName) {
                            return function () {
                                // Capture the original arguments passed to the method
                                var originalArguments = arguments;
                                return source[funcName].apply(source, originalArguments);
                            };
                        })(field);
                    }
                }
                else if (!chkSet || chkSet(field, false, source, target)) {
                    if (hasOwnProperty(target, field)) {
                        // Remove any previous instance property
                        delete target[field];
                    }
                    if (!objDefineAccessors(target, field, function () {
                        return source[field];
                    }, function (theValue) {
                        source[field] = theValue;
                    })) {
                        // Unable to create an accessor, so just assign the values as a fallback
                        // -- this will (mostly) work for objects
                        // -- but will fail for accessing primitives (if the source changes it) and all types of "setters" as the source won't be modified
                        target[field] = value;
                    }
                }
            }
        };
        // effectively apply/proxy full source to the target instance
        for (var field in source) {
            _loop_1(field);
        }
    }
    return target;
}
/**
 * Simpler helper to create a dynamic class that implements the interface and populates the values with the defaults.
 * Only instance properties (hasOwnProperty) values are copied from the defaults to the new instance
 * @param defaults Simple helper
 */
function createClassFromInterface(defaults) {
    return /** @class */ (function () {
        function class_1() {
            var _this = this;
            if (defaults) {
                objForEachKey(defaults, function (field, value) {
                    _this[field] = value;
                });
            }
        }
        return class_1;
    }());
}
/**
 * A helper function to assist with JIT performance for objects that have properties added / removed dynamically
 * this is primarily for chromium based browsers and has limited effects on Firefox and none of IE. Only call this
 * function after you have finished "updating" the object, calling this within loops reduces or defeats the benefits.
 * This helps when iterating using for..in, objKeys() and objForEach()
 * @param theObject - The object to be optimized if possible
 */
function optimizeObject(theObject) {
    // V8 Optimization to cause the JIT compiler to create a new optimized object for looking up the own properties
    // primarily for object with <= 19 properties for >= 20 the effect is reduced or non-existent
    if (theObject) {
        theObject = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["b" /* ObjClass */])(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["a" /* ObjAssign */] ? Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["a" /* ObjAssign */])({}, theObject) : theObject);
    }
    return theObject;
}
//# sourceMappingURL=HelperFuncs.js.map

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Interfaces_IChannelControls__ = __webpack_require__(1386);
/* unused harmony reexport MinChannelPriorty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JavaScriptSDK_Enums_EventsDiscardedReason__ = __webpack_require__(547);
/* unused harmony reexport EventsDiscardedReason */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JavaScriptSDK_AppInsightsCore__ = __webpack_require__(1387);
/* unused harmony reexport AppInsightsCore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__JavaScriptSDK_BaseCore__ = __webpack_require__(548);
/* unused harmony reexport BaseCore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__JavaScriptSDK_BaseTelemetryPlugin__ = __webpack_require__(549);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__JavaScriptSDK_BaseTelemetryPlugin__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__JavaScriptSDK_RandomHelper__ = __webpack_require__(551);
/* unused harmony reexport randomValue */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_5__JavaScriptSDK_RandomHelper__["c"]; });
/* unused harmony reexport mwcRandomSeed */
/* unused harmony reexport mwcRandom32 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__ = __webpack_require__(1390);
/* unused harmony reexport CoreUtils */
/* unused harmony reexport EventHelper */
/* unused harmony reexport Undefined */
/* unused harmony reexport addEventHandler */
/* unused harmony reexport newGuid */
/* unused harmony reexport perfNow */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_CoreUtils__["b"]; });
/* unused harmony reexport _legacyCookieMgr */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__ = __webpack_require__(42);
/* unused harmony reexport isTypeof */
/* unused harmony reexport isUndefined */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["s"]; });
/* unused harmony reexport hasOwnProperty */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["u"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["p"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["e"]; });
/* unused harmony reexport detachEvent */
/* unused harmony reexport normalizeJsName */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["A"]; });
/* unused harmony reexport strEndsWith */
/* unused harmony reexport strStartsWith */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["n"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["o"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["v"]; });
/* unused harmony reexport isNumber */
/* unused harmony reexport isBoolean */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["H"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["a"]; });
/* unused harmony reexport arrIndexOf */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["F"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["B"]; });
/* unused harmony reexport objDefineAccessors */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["G"]; });
/* unused harmony reexport strContains */
/* unused harmony reexport setValue */
/* unused harmony reexport getSetValue */
/* unused harmony reexport isNotTruthy */
/* unused harmony reexport isTruthy */
/* unused harmony reexport proxyAssign */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_HelperFuncs__["f"]; });
/* unused harmony reexport optimizeObject */
/* unused harmony reexport isNotUndefined */
/* unused harmony reexport isNotNullOrUndefined */
/* unused harmony reexport objFreeze */
/* unused harmony reexport objSeal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__ = __webpack_require__(170);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["e"]; });
/* unused harmony reexport hasWindow */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["m"]; });
/* unused harmony reexport hasDocument */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["d"]; });
/* unused harmony reexport getCrypto */
/* unused harmony reexport getMsCrypto */
/* unused harmony reexport hasNavigator */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["k"]; });
/* unused harmony reexport hasHistory */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["n"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["h"]; });
/* unused harmony reexport isReactNative */
/* unused harmony reexport getConsole */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["a"]; });
/* unused harmony reexport isIE */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_EnvUtils__["g"]; });
/* unused harmony reexport isSafari */
/* unused harmony reexport setEnableEnvMocks */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_9__microsoft_applicationinsights_shims__["h"]; });
/* unused harmony reexport objCreate */
/* unused harmony reexport strPrototype */
/* unused harmony reexport strFunction */
/* unused harmony reexport strUndefined */
/* unused harmony reexport strObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__JavaScriptSDK_NotificationManager__ = __webpack_require__(550);
/* unused harmony reexport NotificationManager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__JavaScriptSDK_PerfManager__ = __webpack_require__(241);
/* unused harmony reexport PerfEvent */
/* unused harmony reexport PerfManager */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_11__JavaScriptSDK_PerfManager__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__JavaScriptSDK_DiagnosticLogger__ = __webpack_require__(360);
/* unused harmony reexport safeGetLogger */
/* unused harmony reexport DiagnosticLogger */
/* unused harmony reexport _InternalLogMessage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__JavaScriptSDK_ProcessTelemetryContext__ = __webpack_require__(239);
/* unused harmony reexport ProcessTelemetryContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__JavaScriptSDK_TelemetryHelpers__ = __webpack_require__(362);
/* unused harmony reexport initializePlugins */
/* unused harmony reexport sortPlugins */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__JavaScriptSDK_Enums_LoggingEnums__ = __webpack_require__(240);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_15__JavaScriptSDK_Enums_LoggingEnums__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_15__JavaScriptSDK_Enums_LoggingEnums__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__JavaScriptSDK_InstrumentHooks__ = __webpack_require__(1391);
/* unused harmony reexport InstrumentProto */
/* unused harmony reexport InstrumentProtos */
/* unused harmony reexport InstrumentFunc */
/* unused harmony reexport InstrumentFuncs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__JavaScriptSDK_CookieMgr__ = __webpack_require__(363);
/* unused harmony reexport createCookieMgr */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_17__JavaScriptSDK_CookieMgr__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_17__JavaScriptSDK_CookieMgr__["d"]; });
/* unused harmony reexport areCookiesSupported */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__JavaScriptSDK_Constants__ = __webpack_require__(361);
/* unused harmony reexport strIKey */
/* unused harmony reexport strExtensionConfig */
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



















//# sourceMappingURL=applicationinsights-core-js.js.map

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export objToString */
/* harmony export (immutable) */ __webpack_exports__["x"] = isTypeof;
/* harmony export (immutable) */ __webpack_exports__["y"] = isUndefined;
/* unused harmony export isNotUndefined */
/* harmony export (immutable) */ __webpack_exports__["s"] = isNullOrUndefined;
/* harmony export (immutable) */ __webpack_exports__["q"] = isNotNullOrUndefined;
/* harmony export (immutable) */ __webpack_exports__["k"] = hasOwnProperty;
/* harmony export (immutable) */ __webpack_exports__["u"] = isObject;
/* harmony export (immutable) */ __webpack_exports__["p"] = isFunction;
/* harmony export (immutable) */ __webpack_exports__["e"] = attachEvent;
/* harmony export (immutable) */ __webpack_exports__["h"] = detachEvent;
/* unused harmony export normalizeJsName */
/* harmony export (immutable) */ __webpack_exports__["A"] = objForEachKey;
/* harmony export (immutable) */ __webpack_exports__["E"] = strEndsWith;
/* unused harmony export strStartsWith */
/* harmony export (immutable) */ __webpack_exports__["D"] = strContains;
/* harmony export (immutable) */ __webpack_exports__["n"] = isDate;
/* harmony export (immutable) */ __webpack_exports__["l"] = isArray;
/* harmony export (immutable) */ __webpack_exports__["o"] = isError;
/* harmony export (immutable) */ __webpack_exports__["v"] = isString;
/* harmony export (immutable) */ __webpack_exports__["t"] = isNumber;
/* harmony export (immutable) */ __webpack_exports__["m"] = isBoolean;
/* harmony export (immutable) */ __webpack_exports__["H"] = toISOString;
/* harmony export (immutable) */ __webpack_exports__["a"] = arrForEach;
/* harmony export (immutable) */ __webpack_exports__["b"] = arrIndexOf;
/* harmony export (immutable) */ __webpack_exports__["c"] = arrMap;
/* harmony export (immutable) */ __webpack_exports__["d"] = arrReduce;
/* harmony export (immutable) */ __webpack_exports__["F"] = strTrim;
/* harmony export (immutable) */ __webpack_exports__["B"] = objKeys;
/* harmony export (immutable) */ __webpack_exports__["z"] = objDefineAccessors;
/* unused harmony export objFreeze */
/* unused harmony export objSeal */
/* harmony export (immutable) */ __webpack_exports__["g"] = dateNow;
/* harmony export (immutable) */ __webpack_exports__["i"] = getExceptionName;
/* harmony export (immutable) */ __webpack_exports__["C"] = setValue;
/* harmony export (immutable) */ __webpack_exports__["j"] = getSetValue;
/* harmony export (immutable) */ __webpack_exports__["r"] = isNotTruthy;
/* harmony export (immutable) */ __webpack_exports__["w"] = isTruthy;
/* harmony export (immutable) */ __webpack_exports__["G"] = throwError;
/* unused harmony export proxyAssign */
/* harmony export (immutable) */ __webpack_exports__["f"] = createClassFromInterface;
/* unused harmony export optimizeObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



// RESTRICT and AVOID circular dependencies you should not import other contained modules or export the contents of this file directly
// Added to help with minfication
var strOnPrefix = "on";
var strAttachEvent = "attachEvent";
var strAddEventHelper = "addEventListener";
var strDetachEvent = "detachEvent";
var strRemoveEventListener = "removeEventListener";
var _objDefineProperty = __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["c" /* ObjDefineProperty */];
var _objFreeze = __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["b" /* ObjClass */]["freeze"];
var _objSeal = __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["b" /* ObjClass */]["seal"];
function objToString(obj) {
    return __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["e" /* ObjProto */].toString.call(obj);
}
function isTypeof(value, theType) {
    return typeof value === theType;
}
;
function isUndefined(value) {
    return value === undefined || typeof value === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["m" /* strShimUndefined */];
}
;
function isNotUndefined(value) {
    return !isUndefined(value);
}
function isNullOrUndefined(value) {
    return (value === null || isUndefined(value));
}
function isNotNullOrUndefined(value) {
    return !isNullOrUndefined(value);
}
function hasOwnProperty(obj, prop) {
    return obj && __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["d" /* ObjHasOwnProperty */].call(obj, prop);
}
;
function isObject(value) {
    // Changing to inline for performance
    return typeof value === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */];
}
;
function isFunction(value) {
    // Changing to inline for performance
    return typeof value === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["j" /* strShimFunction */];
}
;
/**
 * Binds the specified function to an event, so that the function gets called whenever the event fires on the object
 * @param obj Object to add the event too.
 * @param eventNameWithoutOn String that specifies any of the standard DHTML Events without "on" prefix
 * @param handlerRef Pointer that specifies the function to call when event fires
 * @param useCapture [Optional] Defaults to false
 * @returns True if the function was bound successfully to the event, otherwise false
 */
function attachEvent(obj, eventNameWithoutOn, handlerRef, useCapture) {
    if (useCapture === void 0) { useCapture = false; }
    var result = false;
    if (!isNullOrUndefined(obj)) {
        try {
            if (!isNullOrUndefined(obj[strAddEventHelper])) {
                // all browsers except IE before version 9
                obj[strAddEventHelper](eventNameWithoutOn, handlerRef, useCapture);
                result = true;
            }
            else if (!isNullOrUndefined(obj[strAttachEvent])) {
                // IE before version 9                    
                obj[strAttachEvent](strOnPrefix + eventNameWithoutOn, handlerRef);
                result = true;
            }
        }
        catch (e) {
            // Just Ignore any error so that we don't break any execution path
        }
    }
    return result;
}
/**
 * Removes an event handler for the specified event
 * @param Object to remove the event from
 * @param eventNameWithoutOn {string} - The name of the event
 * @param handlerRef {any} - The callback function that needs to be executed for the given event
 * @param useCapture [Optional] Defaults to false
 */
function detachEvent(obj, eventNameWithoutOn, handlerRef, useCapture) {
    if (useCapture === void 0) { useCapture = false; }
    if (!isNullOrUndefined(obj)) {
        try {
            if (!isNullOrUndefined(obj[strRemoveEventListener])) {
                obj[strRemoveEventListener](eventNameWithoutOn, handlerRef, useCapture);
            }
            else if (!isNullOrUndefined(obj[strDetachEvent])) {
                obj[strDetachEvent](strOnPrefix + eventNameWithoutOn, handlerRef);
            }
        }
        catch (e) {
            // Just Ignore any error so that we don't break any execution path
        }
    }
}
/**
 * Validates that the string name conforms to the JS IdentifierName specification and if not
 * normalizes the name so that it would. This method does not identify or change any keywords
 * meaning that if you pass in a known keyword the same value will be returned.
 * This is a simplified version
 * @param name The name to validate
 */
function normalizeJsName(name) {
    var value = name;
    var match = /([^\w\d_$])/g;
    if (match.test(name)) {
        value = name.replace(match, "_");
    }
    return value;
}
/**
 * This is a helper function for the equivalent of arForEach(objKeys(target), callbackFn), this is a
 * performance optimization to avoid the creation of a new array for large objects
 * @param target The target object to find and process the keys
 * @param callbackfn The function to call with the details
 */
function objForEachKey(target, callbackfn) {
    if (target) {
        for (var prop in target) {
            if (__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["d" /* ObjHasOwnProperty */].call(target, prop)) {
                callbackfn.call(target, prop, target[prop]);
            }
        }
    }
}
/**
 * The strEndsWith() method determines whether a string ends with the characters of a specified string, returning true or false as appropriate.
 * @param value - The value to check whether it ends with the search value.
 * @param search - The characters to be searched for at the end of the value.
 * @returns true if the given search value is found at the end of the string, otherwise false.
 */
function strEndsWith(value, search) {
    if (value && search) {
        var searchLen = search.length;
        var valLen = value.length;
        if (value === search) {
            return true;
        }
        else if (valLen >= searchLen) {
            var pos = valLen - 1;
            for (var lp = searchLen - 1; lp >= 0; lp--) {
                if (value[pos] != search[lp]) {
                    return false;
                }
                pos--;
            }
            return true;
        }
    }
    return false;
}
/**
 * The strStartsWith() method determines whether a string starts with the characters of the specified string, returning true or false as appropriate.
 * @param value - The value to check whether it ends with the search value.
 * @param checkValue - The characters to be searched for at the start of the value.
 * @returns true if the given search value is found at the start of the string, otherwise false.
 */
function strStartsWith(value, checkValue) {
    // Using helper for performance and because string startsWith() is not available on IE
    var result = false;
    if (value && checkValue) {
        var chkLen = checkValue.length;
        if (value === checkValue) {
            return true;
        }
        else if (value.length >= chkLen) {
            for (var lp = 0; lp < chkLen; lp++) {
                if (value[lp] !== checkValue[lp]) {
                    return false;
                }
            }
            result = true;
        }
    }
    return result;
}
/**
 * A simple wrapper (for minification support) to check if the value contains the search string.
 * @param value - The string value to check for the existence of the search value
 * @param search - The value search within the value
 */
function strContains(value, search) {
    if (value && search) {
        return value.indexOf(search) !== -1;
    }
    return false;
}
/**
 * Check if an object is of type Date
 */
function isDate(obj) {
    return objToString(obj) === "[object Date]";
}
/**
 * Check if an object is of type Array
 */
function isArray(obj) {
    return objToString(obj) === "[object Array]";
}
/**
 * Check if an object is of type Error
 */
function isError(obj) {
    return objToString(obj) === "[object Error]";
}
/**
 * Checks if the type of value is a string.
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is a string, false otherwise.
 */
function isString(value) {
    // Changing to inline for performance
    return typeof value === "string";
}
/**
 * Checks if the type of value is a number.
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is a number, false otherwise.
 */
function isNumber(value) {
    // Changing to inline for performance
    return typeof value === "number";
}
/**
 * Checks if the type of value is a boolean.
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is a boolean, false otherwise.
 */
function isBoolean(value) {
    // Changing to inline for performance
    return typeof value === "boolean";
}
/**
 * Convert a date to I.S.O. format in IE8
 */
function toISOString(date) {
    if (isDate(date)) {
        var pad = function (num) {
            var r = String(num);
            if (r.length === 1) {
                r = "0" + r;
            }
            return r;
        };
        return date.getUTCFullYear()
            + "-" + pad(date.getUTCMonth() + 1)
            + "-" + pad(date.getUTCDate())
            + "T" + pad(date.getUTCHours())
            + ":" + pad(date.getUTCMinutes())
            + ":" + pad(date.getUTCSeconds())
            + "." + String((date.getUTCMilliseconds() / 1000).toFixed(3)).slice(2, 5)
            + "Z";
    }
}
/**
 * Performs the specified action for each element in an array. This helper exists to avoid adding a polyfil for older browsers
 * that do not define Array.prototype.xxxx (eg. ES3 only, IE8) just in case any page checks for presence/absence of the prototype
 * implementation. Note: For consistency this will not use the Array.prototype.xxxx implementation if it exists as this would
 * cause a testing requirement to test with and without the implementations
 * @param callbackfn  A function that accepts up to three arguments. forEach calls the callbackfn function one time for each element in the array. It can return -1 to break out of the loop
 * @param thisArg  [Optional] An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, undefined is used as the this value.
 */
function arrForEach(arr, callbackfn, thisArg) {
    var len = arr.length;
    for (var idx = 0; idx < len; idx++) {
        if (idx in arr) {
            if (callbackfn.call(thisArg || arr, arr[idx], idx, arr) === -1) {
                break;
            }
        }
    }
}
/**
 * Returns the index of the first occurrence of a value in an array. This helper exists to avoid adding a polyfil for older browsers
 * that do not define Array.prototype.xxxx (eg. ES3 only, IE8) just in case any page checks for presence/absence of the prototype
 * implementation. Note: For consistency this will not use the Array.prototype.xxxx implementation if it exists as this would
 * cause a testing requirement to test with and without the implementations
 * @param searchElement The value to locate in the array.
 * @param fromIndex The array index at which to begin the search. If fromIndex is omitted, the search starts at index 0.
 */
function arrIndexOf(arr, searchElement, fromIndex) {
    var len = arr.length;
    var from = fromIndex || 0;
    for (var lp = Math.max(from >= 0 ? from : len - Math.abs(from), 0); lp < len; lp++) {
        if (lp in arr && arr[lp] === searchElement) {
            return lp;
        }
    }
    return -1;
}
/**
 * Calls a defined callback function on each element of an array, and returns an array that contains the results. This helper exists
 * to avoid adding a polyfil for older browsers that do not define Array.prototype.xxxx (eg. ES3 only, IE8) just in case any page
 * checks for presence/absence of the prototype implementation. Note: For consistency this will not use the Array.prototype.xxxx
 * implementation if it exists as this would cause a testing requirement to test with and without the implementations
 * @param callbackfn A function that accepts up to three arguments. The map method calls the callbackfn function one time for each element in the array.
 * @param thisArg An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, undefined is used as the this value.
 */
function arrMap(arr, callbackfn, thisArg) {
    var len = arr.length;
    var _this = thisArg || arr;
    var results = new Array(len);
    for (var lp = 0; lp < len; lp++) {
        if (lp in arr) {
            results[lp] = callbackfn.call(_this, arr[lp], arr);
        }
    }
    return results;
}
/**
 * Calls the specified callback function for all the elements in an array. The return value of the callback function is the accumulated result, and is
 * provided as an argument in the next call to the callback function. This helper exists to avoid adding a polyfil for older browsers that do not define
 * Array.prototype.xxxx (eg. ES3 only, IE8) just in case any page checks for presence/absence of the prototype implementation. Note: For consistency
 * this will not use the Array.prototype.xxxx implementation if it exists as this would cause a testing requirement to test with and without the implementations
 * @param callbackfn A function that accepts up to four arguments. The reduce method calls the callbackfn function one time for each element in the array.
 * @param initialValue If initialValue is specified, it is used as the initial value to start the accumulation. The first call to the callbackfn function provides this value as an argument instead of an array value.
 */
function arrReduce(arr, callbackfn, initialValue) {
    var len = arr.length;
    var lp = 0;
    var value;
    // Specifically checking the number of passed arguments as the value could be anything
    if (arguments.length >= 3) {
        value = arguments[2];
    }
    else {
        while (lp < len && !(lp in arr)) {
            lp++;
        }
        value = arr[lp++];
    }
    while (lp < len) {
        if (lp in arr) {
            value = callbackfn(value, arr[lp], lp, arr);
        }
        lp++;
    }
    return value;
}
/**
 * helper method to trim strings (IE8 does not implement String.prototype.trim)
 */
function strTrim(str) {
    if (typeof str !== "string") {
        return str;
    }
    return str.replace(/^\s+|\s+$/g, "");
}
var _objKeysHasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString');
var _objKeysDontEnums = [
    'toString',
    'toLocaleString',
    'valueOf',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'constructor'
];
/**
 * Returns the names of the enumerable string properties and methods of an object. This helper exists to avoid adding a polyfil for older browsers
 * that do not define Object.keys eg. ES3 only, IE8 just in case any page checks for presence/absence of the prototype implementation.
 * Note: For consistency this will not use the Object.keys implementation if it exists as this would cause a testing requirement to test with and without the implementations
 * @param obj Object that contains the properties and methods. This can be an object that you created or an existing Document Object Model (DOM) object.
 */
function objKeys(obj) {
    var objType = typeof obj;
    if (objType !== __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["j" /* strShimFunction */] && (objType !== __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] || obj === null)) {
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["n" /* throwTypeError */])('objKeys called on non-object');
    }
    var result = [];
    for (var prop in obj) {
        if (obj && __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["d" /* ObjHasOwnProperty */].call(obj, prop)) {
            result.push(prop);
        }
    }
    if (_objKeysHasDontEnumBug) {
        var dontEnumsLength = _objKeysDontEnums.length;
        for (var lp = 0; lp < dontEnumsLength; lp++) {
            if (obj && __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["d" /* ObjHasOwnProperty */].call(obj, _objKeysDontEnums[lp])) {
                result.push(_objKeysDontEnums[lp]);
            }
        }
    }
    return result;
}
/**
 * Try to define get/set object property accessors for the target object/prototype, this will provide compatibility with
 * existing API definition when run within an ES5+ container that supports accessors but still enable the code to be loaded
 * and executed in an ES3 container, providing basic IE8 compatibility.
 * @param target The object on which to define the property.
 * @param prop The name of the property to be defined or modified.
 * @param getProp The getter function to wire against the getter.
 * @param setProp The setter function to wire against the setter.
 * @returns True if it was able to create the accessors otherwise false
 */
function objDefineAccessors(target, prop, getProp, setProp) {
    if (_objDefineProperty) {
        try {
            var descriptor = {
                enumerable: true,
                configurable: true
            };
            if (getProp) {
                descriptor.get = getProp;
            }
            if (setProp) {
                descriptor.set = setProp;
            }
            _objDefineProperty(target, prop, descriptor);
            return true;
        }
        catch (e) {
            // IE8 Defines a defineProperty on Object but it's only supported for DOM elements so it will throw
            // We will just ignore this here.
        }
    }
    return false;
}
function objFreeze(value) {
    if (_objFreeze) {
        value = _objFreeze(value);
    }
    return value;
}
function objSeal(value) {
    if (_objSeal) {
        value = _objSeal(value);
    }
    return value;
}
/**
 * Return the current time via the Date now() function (if available) and falls back to (new Date()).getTime() if now() is unavailable (IE8 or less)
 * https://caniuse.com/#search=Date.now
 */
function dateNow() {
    var dt = Date;
    if (dt.now) {
        return dt.now();
    }
    return new dt().getTime();
}
/**
 * Returns the name of object if it's an Error. Otherwise, returns empty string.
 */
function getExceptionName(object) {
    if (isError(object)) {
        return object.name;
    }
    return "";
}
/**
 * Sets the provided value on the target instance using the field name when the provided chk function returns true, the chk
 * function will only be called if the new value is no equal to the original value.
 * @param target - The target object
 * @param field - The key of the target
 * @param value - The value to set
 * @param valChk - [Optional] Callback to check the value that if supplied will be called check if the new value can be set
 * @param srcChk - [Optional] Callback to check to original value that if supplied will be called if the new value should be set (if allowed)
 * @returns The existing or new value, depending what was set
 */
function setValue(target, field, value, valChk, srcChk) {
    var theValue = value;
    if (target) {
        theValue = target[field];
        if (theValue !== value && (!srcChk || srcChk(theValue)) && (!valChk || valChk(value))) {
            theValue = value;
            target[field] = theValue;
        }
    }
    return theValue;
}
/**
 * Returns the current value from the target object if not null or undefined otherwise sets the new value and returns it
 * @param target - The target object to return or set the default value
 * @param field - The key for the field to set on the target
 * @param defValue - [Optional] The value to set if not already present, when not provided a empty object will be added
 */
function getSetValue(target, field, defValue) {
    var theValue;
    if (target) {
        theValue = target[field];
        if (!theValue && isNullOrUndefined(theValue)) {
            // Supports having the default as null
            theValue = !isUndefined(defValue) ? defValue : {};
            target[field] = theValue;
        }
    }
    else {
        // Expanded for performance so we only check defValue if required
        theValue = !isUndefined(defValue) ? defValue : {};
    }
    return theValue;
}
function isNotTruthy(value) {
    return !value;
}
function isTruthy(value) {
    return !!value;
}
function throwError(message) {
    throw new Error(message);
}
/**
 * Effectively assigns all enumerable properties (not just own properties) and functions (including inherited prototype) from
 * the source object to the target, it attempts to use proxy getters / setters (if possible) and proxy functions to avoid potential
 * implementation issues by assigning prototype functions as instance ones
 *
 * This method is the primary method used to "update" the snippet proxy with the ultimate implementations.
 *
 * Special ES3 Notes:
 * Updates (setting) of direct property values on the target or indirectly on the source object WILL NOT WORK PROPERLY, updates to the
 * properties of "referenced" object will work (target.context.newValue = 10 => will be reflected in the source.context as it's the
 * same object). ES3 Failures: assigning target.myProp = 3 -> Won't change source.myProp = 3, likewise the reverse would also fail.
 * @param target - The target object to be assigned with the source properties and functions
 * @param source - The source object which will be assigned / called by setting / calling the targets proxies
 * @param chkSet - An optional callback to determine whether a specific property/function should be proxied
 * @memberof Initialization
 */
function proxyAssign(target, source, chkSet) {
    if (target && source && target !== source && isObject(target) && isObject(source)) {
        var _loop_1 = function (field) {
            if (isString(field)) {
                var value = source[field];
                if (isFunction(value)) {
                    if (!chkSet || chkSet(field, true, source, target)) {
                        // Create a proxy function rather than just copying the (possible) prototype to the new object as an instance function
                        target[field] = (function (funcName) {
                            return function () {
                                // Capture the original arguments passed to the method
                                var originalArguments = arguments;
                                return source[funcName].apply(source, originalArguments);
                            };
                        })(field);
                    }
                }
                else if (!chkSet || chkSet(field, false, source, target)) {
                    if (hasOwnProperty(target, field)) {
                        // Remove any previous instance property
                        delete target[field];
                    }
                    if (!objDefineAccessors(target, field, function () {
                        return source[field];
                    }, function (theValue) {
                        source[field] = theValue;
                    })) {
                        // Unable to create an accessor, so just assign the values as a fallback
                        // -- this will (mostly) work for objects
                        // -- but will fail for accessing primitives (if the source changes it) and all types of "setters" as the source won't be modified
                        target[field] = value;
                    }
                }
            }
        };
        // effectively apply/proxy full source to the target instance
        for (var field in source) {
            _loop_1(field);
        }
    }
    return target;
}
/**
 * Simpler helper to create a dynamic class that implements the interface and populates the values with the defaults.
 * Only instance properties (hasOwnProperty) values are copied from the defaults to the new instance
 * @param defaults Simple helper
 */
function createClassFromInterface(defaults) {
    return /** @class */ (function () {
        function class_1() {
            var _this = this;
            if (defaults) {
                objForEachKey(defaults, function (field, value) {
                    _this[field] = value;
                });
            }
        }
        return class_1;
    }());
}
/**
 * A helper function to assist with JIT performance for objects that have properties added / removed dynamically
 * this is primarily for chromium based browsers and has limited effects on Firefox and none of IE. Only call this
 * function after you have finished "updating" the object, calling this within loops reduces or defeats the benefits.
 * This helps when iterating using for..in, objKeys() and objForEach()
 * @param theObject - The object to be optimized if possible
 */
function optimizeObject(theObject) {
    // V8 Optimization to cause the JIT compiler to create a new optimized object for looking up the own properties
    // primarily for object with <= 19 properties for >= 20 the effect is reduced or non-existent
    if (theObject) {
        theObject = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["b" /* ObjClass */])(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["a" /* ObjAssign */] ? Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["a" /* ObjAssign */])({}, theObject) : theObject);
    }
    return theObject;
}
//# sourceMappingURL=HelperFuncs.js.map

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export objToString */
/* harmony export (immutable) */ __webpack_exports__["x"] = isTypeof;
/* harmony export (immutable) */ __webpack_exports__["y"] = isUndefined;
/* unused harmony export isNotUndefined */
/* harmony export (immutable) */ __webpack_exports__["s"] = isNullOrUndefined;
/* harmony export (immutable) */ __webpack_exports__["q"] = isNotNullOrUndefined;
/* harmony export (immutable) */ __webpack_exports__["k"] = hasOwnProperty;
/* harmony export (immutable) */ __webpack_exports__["u"] = isObject;
/* harmony export (immutable) */ __webpack_exports__["p"] = isFunction;
/* harmony export (immutable) */ __webpack_exports__["e"] = attachEvent;
/* harmony export (immutable) */ __webpack_exports__["h"] = detachEvent;
/* unused harmony export normalizeJsName */
/* harmony export (immutable) */ __webpack_exports__["A"] = objForEachKey;
/* harmony export (immutable) */ __webpack_exports__["F"] = strEndsWith;
/* unused harmony export strStartsWith */
/* harmony export (immutable) */ __webpack_exports__["E"] = strContains;
/* harmony export (immutable) */ __webpack_exports__["n"] = isDate;
/* harmony export (immutable) */ __webpack_exports__["l"] = isArray;
/* harmony export (immutable) */ __webpack_exports__["o"] = isError;
/* harmony export (immutable) */ __webpack_exports__["v"] = isString;
/* harmony export (immutable) */ __webpack_exports__["t"] = isNumber;
/* harmony export (immutable) */ __webpack_exports__["m"] = isBoolean;
/* harmony export (immutable) */ __webpack_exports__["I"] = toISOString;
/* harmony export (immutable) */ __webpack_exports__["a"] = arrForEach;
/* harmony export (immutable) */ __webpack_exports__["b"] = arrIndexOf;
/* harmony export (immutable) */ __webpack_exports__["c"] = arrMap;
/* harmony export (immutable) */ __webpack_exports__["d"] = arrReduce;
/* harmony export (immutable) */ __webpack_exports__["G"] = strTrim;
/* harmony export (immutable) */ __webpack_exports__["B"] = objKeys;
/* harmony export (immutable) */ __webpack_exports__["z"] = objDefineAccessors;
/* unused harmony export objFreeze */
/* unused harmony export objSeal */
/* harmony export (immutable) */ __webpack_exports__["g"] = dateNow;
/* harmony export (immutable) */ __webpack_exports__["i"] = getExceptionName;
/* harmony export (immutable) */ __webpack_exports__["D"] = setValue;
/* harmony export (immutable) */ __webpack_exports__["j"] = getSetValue;
/* harmony export (immutable) */ __webpack_exports__["r"] = isNotTruthy;
/* harmony export (immutable) */ __webpack_exports__["w"] = isTruthy;
/* harmony export (immutable) */ __webpack_exports__["H"] = throwError;
/* unused harmony export proxyAssign */
/* harmony export (immutable) */ __webpack_exports__["f"] = createClassFromInterface;
/* harmony export (immutable) */ __webpack_exports__["C"] = optimizeObject;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



// RESTRICT and AVOID circular dependencies you should not import other contained modules or export the contents of this file directly
// Added to help with minfication
var strOnPrefix = "on";
var strAttachEvent = "attachEvent";
var strAddEventHelper = "addEventListener";
var strDetachEvent = "detachEvent";
var strRemoveEventListener = "removeEventListener";
var _objDefineProperty = __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["c" /* ObjDefineProperty */];
var _objFreeze = __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["b" /* ObjClass */]["freeze"];
var _objSeal = __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["b" /* ObjClass */]["seal"];
function objToString(obj) {
    return __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["e" /* ObjProto */].toString.call(obj);
}
function isTypeof(value, theType) {
    return typeof value === theType;
}
;
function isUndefined(value) {
    return value === undefined || typeof value === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["m" /* strShimUndefined */];
}
;
function isNotUndefined(value) {
    return !isUndefined(value);
}
function isNullOrUndefined(value) {
    return (value === null || isUndefined(value));
}
function isNotNullOrUndefined(value) {
    return !isNullOrUndefined(value);
}
function hasOwnProperty(obj, prop) {
    return obj && __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["d" /* ObjHasOwnProperty */].call(obj, prop);
}
;
function isObject(value) {
    // Changing to inline for performance
    return typeof value === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */];
}
;
function isFunction(value) {
    // Changing to inline for performance
    return typeof value === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["j" /* strShimFunction */];
}
;
/**
 * Binds the specified function to an event, so that the function gets called whenever the event fires on the object
 * @param obj Object to add the event too.
 * @param eventNameWithoutOn String that specifies any of the standard DHTML Events without "on" prefix
 * @param handlerRef Pointer that specifies the function to call when event fires
 * @param useCapture [Optional] Defaults to false
 * @returns True if the function was bound successfully to the event, otherwise false
 */
function attachEvent(obj, eventNameWithoutOn, handlerRef, useCapture) {
    if (useCapture === void 0) { useCapture = false; }
    var result = false;
    if (!isNullOrUndefined(obj)) {
        try {
            if (!isNullOrUndefined(obj[strAddEventHelper])) {
                // all browsers except IE before version 9
                obj[strAddEventHelper](eventNameWithoutOn, handlerRef, useCapture);
                result = true;
            }
            else if (!isNullOrUndefined(obj[strAttachEvent])) {
                // IE before version 9                    
                obj[strAttachEvent](strOnPrefix + eventNameWithoutOn, handlerRef);
                result = true;
            }
        }
        catch (e) {
            // Just Ignore any error so that we don't break any execution path
        }
    }
    return result;
}
/**
 * Removes an event handler for the specified event
 * @param Object to remove the event from
 * @param eventNameWithoutOn {string} - The name of the event
 * @param handlerRef {any} - The callback function that needs to be executed for the given event
 * @param useCapture [Optional] Defaults to false
 */
function detachEvent(obj, eventNameWithoutOn, handlerRef, useCapture) {
    if (useCapture === void 0) { useCapture = false; }
    if (!isNullOrUndefined(obj)) {
        try {
            if (!isNullOrUndefined(obj[strRemoveEventListener])) {
                obj[strRemoveEventListener](eventNameWithoutOn, handlerRef, useCapture);
            }
            else if (!isNullOrUndefined(obj[strDetachEvent])) {
                obj[strDetachEvent](strOnPrefix + eventNameWithoutOn, handlerRef);
            }
        }
        catch (e) {
            // Just Ignore any error so that we don't break any execution path
        }
    }
}
/**
 * Validates that the string name conforms to the JS IdentifierName specification and if not
 * normalizes the name so that it would. This method does not identify or change any keywords
 * meaning that if you pass in a known keyword the same value will be returned.
 * This is a simplified version
 * @param name The name to validate
 */
function normalizeJsName(name) {
    var value = name;
    var match = /([^\w\d_$])/g;
    if (match.test(name)) {
        value = name.replace(match, "_");
    }
    return value;
}
/**
 * This is a helper function for the equivalent of arForEach(objKeys(target), callbackFn), this is a
 * performance optimization to avoid the creation of a new array for large objects
 * @param target The target object to find and process the keys
 * @param callbackfn The function to call with the details
 */
function objForEachKey(target, callbackfn) {
    if (target) {
        for (var prop in target) {
            if (__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["d" /* ObjHasOwnProperty */].call(target, prop)) {
                callbackfn.call(target, prop, target[prop]);
            }
        }
    }
}
/**
 * The strEndsWith() method determines whether a string ends with the characters of a specified string, returning true or false as appropriate.
 * @param value - The value to check whether it ends with the search value.
 * @param search - The characters to be searched for at the end of the value.
 * @returns true if the given search value is found at the end of the string, otherwise false.
 */
function strEndsWith(value, search) {
    if (value && search) {
        var searchLen = search.length;
        var valLen = value.length;
        if (value === search) {
            return true;
        }
        else if (valLen >= searchLen) {
            var pos = valLen - 1;
            for (var lp = searchLen - 1; lp >= 0; lp--) {
                if (value[pos] != search[lp]) {
                    return false;
                }
                pos--;
            }
            return true;
        }
    }
    return false;
}
/**
 * The strStartsWith() method determines whether a string starts with the characters of the specified string, returning true or false as appropriate.
 * @param value - The value to check whether it ends with the search value.
 * @param checkValue - The characters to be searched for at the start of the value.
 * @returns true if the given search value is found at the start of the string, otherwise false.
 */
function strStartsWith(value, checkValue) {
    // Using helper for performance and because string startsWith() is not available on IE
    var result = false;
    if (value && checkValue) {
        var chkLen = checkValue.length;
        if (value === checkValue) {
            return true;
        }
        else if (value.length >= chkLen) {
            for (var lp = 0; lp < chkLen; lp++) {
                if (value[lp] !== checkValue[lp]) {
                    return false;
                }
            }
            result = true;
        }
    }
    return result;
}
/**
 * A simple wrapper (for minification support) to check if the value contains the search string.
 * @param value - The string value to check for the existence of the search value
 * @param search - The value search within the value
 */
function strContains(value, search) {
    if (value && search) {
        return value.indexOf(search) !== -1;
    }
    return false;
}
/**
 * Check if an object is of type Date
 */
function isDate(obj) {
    return objToString(obj) === "[object Date]";
}
/**
 * Check if an object is of type Array
 */
function isArray(obj) {
    return objToString(obj) === "[object Array]";
}
/**
 * Check if an object is of type Error
 */
function isError(obj) {
    return objToString(obj) === "[object Error]";
}
/**
 * Checks if the type of value is a string.
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is a string, false otherwise.
 */
function isString(value) {
    // Changing to inline for performance
    return typeof value === "string";
}
/**
 * Checks if the type of value is a number.
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is a number, false otherwise.
 */
function isNumber(value) {
    // Changing to inline for performance
    return typeof value === "number";
}
/**
 * Checks if the type of value is a boolean.
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is a boolean, false otherwise.
 */
function isBoolean(value) {
    // Changing to inline for performance
    return typeof value === "boolean";
}
/**
 * Convert a date to I.S.O. format in IE8
 */
function toISOString(date) {
    if (isDate(date)) {
        var pad = function (num) {
            var r = String(num);
            if (r.length === 1) {
                r = "0" + r;
            }
            return r;
        };
        return date.getUTCFullYear()
            + "-" + pad(date.getUTCMonth() + 1)
            + "-" + pad(date.getUTCDate())
            + "T" + pad(date.getUTCHours())
            + ":" + pad(date.getUTCMinutes())
            + ":" + pad(date.getUTCSeconds())
            + "." + String((date.getUTCMilliseconds() / 1000).toFixed(3)).slice(2, 5)
            + "Z";
    }
}
/**
 * Performs the specified action for each element in an array. This helper exists to avoid adding a polyfil for older browsers
 * that do not define Array.prototype.xxxx (eg. ES3 only, IE8) just in case any page checks for presence/absence of the prototype
 * implementation. Note: For consistency this will not use the Array.prototype.xxxx implementation if it exists as this would
 * cause a testing requirement to test with and without the implementations
 * @param callbackfn  A function that accepts up to three arguments. forEach calls the callbackfn function one time for each element in the array. It can return -1 to break out of the loop
 * @param thisArg  [Optional] An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, undefined is used as the this value.
 */
function arrForEach(arr, callbackfn, thisArg) {
    var len = arr.length;
    for (var idx = 0; idx < len; idx++) {
        if (idx in arr) {
            if (callbackfn.call(thisArg || arr, arr[idx], idx, arr) === -1) {
                break;
            }
        }
    }
}
/**
 * Returns the index of the first occurrence of a value in an array. This helper exists to avoid adding a polyfil for older browsers
 * that do not define Array.prototype.xxxx (eg. ES3 only, IE8) just in case any page checks for presence/absence of the prototype
 * implementation. Note: For consistency this will not use the Array.prototype.xxxx implementation if it exists as this would
 * cause a testing requirement to test with and without the implementations
 * @param searchElement The value to locate in the array.
 * @param fromIndex The array index at which to begin the search. If fromIndex is omitted, the search starts at index 0.
 */
function arrIndexOf(arr, searchElement, fromIndex) {
    var len = arr.length;
    var from = fromIndex || 0;
    for (var lp = Math.max(from >= 0 ? from : len - Math.abs(from), 0); lp < len; lp++) {
        if (lp in arr && arr[lp] === searchElement) {
            return lp;
        }
    }
    return -1;
}
/**
 * Calls a defined callback function on each element of an array, and returns an array that contains the results. This helper exists
 * to avoid adding a polyfil for older browsers that do not define Array.prototype.xxxx (eg. ES3 only, IE8) just in case any page
 * checks for presence/absence of the prototype implementation. Note: For consistency this will not use the Array.prototype.xxxx
 * implementation if it exists as this would cause a testing requirement to test with and without the implementations
 * @param callbackfn A function that accepts up to three arguments. The map method calls the callbackfn function one time for each element in the array.
 * @param thisArg An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, undefined is used as the this value.
 */
function arrMap(arr, callbackfn, thisArg) {
    var len = arr.length;
    var _this = thisArg || arr;
    var results = new Array(len);
    for (var lp = 0; lp < len; lp++) {
        if (lp in arr) {
            results[lp] = callbackfn.call(_this, arr[lp], arr);
        }
    }
    return results;
}
/**
 * Calls the specified callback function for all the elements in an array. The return value of the callback function is the accumulated result, and is
 * provided as an argument in the next call to the callback function. This helper exists to avoid adding a polyfil for older browsers that do not define
 * Array.prototype.xxxx (eg. ES3 only, IE8) just in case any page checks for presence/absence of the prototype implementation. Note: For consistency
 * this will not use the Array.prototype.xxxx implementation if it exists as this would cause a testing requirement to test with and without the implementations
 * @param callbackfn A function that accepts up to four arguments. The reduce method calls the callbackfn function one time for each element in the array.
 * @param initialValue If initialValue is specified, it is used as the initial value to start the accumulation. The first call to the callbackfn function provides this value as an argument instead of an array value.
 */
function arrReduce(arr, callbackfn, initialValue) {
    var len = arr.length;
    var lp = 0;
    var value;
    // Specifically checking the number of passed arguments as the value could be anything
    if (arguments.length >= 3) {
        value = arguments[2];
    }
    else {
        while (lp < len && !(lp in arr)) {
            lp++;
        }
        value = arr[lp++];
    }
    while (lp < len) {
        if (lp in arr) {
            value = callbackfn(value, arr[lp], lp, arr);
        }
        lp++;
    }
    return value;
}
/**
 * helper method to trim strings (IE8 does not implement String.prototype.trim)
 */
function strTrim(str) {
    if (typeof str !== "string") {
        return str;
    }
    return str.replace(/^\s+|\s+$/g, "");
}
var _objKeysHasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString');
var _objKeysDontEnums = [
    'toString',
    'toLocaleString',
    'valueOf',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'constructor'
];
/**
 * Returns the names of the enumerable string properties and methods of an object. This helper exists to avoid adding a polyfil for older browsers
 * that do not define Object.keys eg. ES3 only, IE8 just in case any page checks for presence/absence of the prototype implementation.
 * Note: For consistency this will not use the Object.keys implementation if it exists as this would cause a testing requirement to test with and without the implementations
 * @param obj Object that contains the properties and methods. This can be an object that you created or an existing Document Object Model (DOM) object.
 */
function objKeys(obj) {
    var objType = typeof obj;
    if (objType !== __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["j" /* strShimFunction */] && (objType !== __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] || obj === null)) {
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["n" /* throwTypeError */])('objKeys called on non-object');
    }
    var result = [];
    for (var prop in obj) {
        if (obj && __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["d" /* ObjHasOwnProperty */].call(obj, prop)) {
            result.push(prop);
        }
    }
    if (_objKeysHasDontEnumBug) {
        var dontEnumsLength = _objKeysDontEnums.length;
        for (var lp = 0; lp < dontEnumsLength; lp++) {
            if (obj && __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["d" /* ObjHasOwnProperty */].call(obj, _objKeysDontEnums[lp])) {
                result.push(_objKeysDontEnums[lp]);
            }
        }
    }
    return result;
}
/**
 * Try to define get/set object property accessors for the target object/prototype, this will provide compatibility with
 * existing API definition when run within an ES5+ container that supports accessors but still enable the code to be loaded
 * and executed in an ES3 container, providing basic IE8 compatibility.
 * @param target The object on which to define the property.
 * @param prop The name of the property to be defined or modified.
 * @param getProp The getter function to wire against the getter.
 * @param setProp The setter function to wire against the setter.
 * @returns True if it was able to create the accessors otherwise false
 */
function objDefineAccessors(target, prop, getProp, setProp) {
    if (_objDefineProperty) {
        try {
            var descriptor = {
                enumerable: true,
                configurable: true
            };
            if (getProp) {
                descriptor.get = getProp;
            }
            if (setProp) {
                descriptor.set = setProp;
            }
            _objDefineProperty(target, prop, descriptor);
            return true;
        }
        catch (e) {
            // IE8 Defines a defineProperty on Object but it's only supported for DOM elements so it will throw
            // We will just ignore this here.
        }
    }
    return false;
}
function objFreeze(value) {
    if (_objFreeze) {
        value = _objFreeze(value);
    }
    return value;
}
function objSeal(value) {
    if (_objSeal) {
        value = _objSeal(value);
    }
    return value;
}
/**
 * Return the current time via the Date now() function (if available) and falls back to (new Date()).getTime() if now() is unavailable (IE8 or less)
 * https://caniuse.com/#search=Date.now
 */
function dateNow() {
    var dt = Date;
    if (dt.now) {
        return dt.now();
    }
    return new dt().getTime();
}
/**
 * Returns the name of object if it's an Error. Otherwise, returns empty string.
 */
function getExceptionName(object) {
    if (isError(object)) {
        return object.name;
    }
    return "";
}
/**
 * Sets the provided value on the target instance using the field name when the provided chk function returns true, the chk
 * function will only be called if the new value is no equal to the original value.
 * @param target - The target object
 * @param field - The key of the target
 * @param value - The value to set
 * @param valChk - [Optional] Callback to check the value that if supplied will be called check if the new value can be set
 * @param srcChk - [Optional] Callback to check to original value that if supplied will be called if the new value should be set (if allowed)
 * @returns The existing or new value, depending what was set
 */
function setValue(target, field, value, valChk, srcChk) {
    var theValue = value;
    if (target) {
        theValue = target[field];
        if (theValue !== value && (!srcChk || srcChk(theValue)) && (!valChk || valChk(value))) {
            theValue = value;
            target[field] = theValue;
        }
    }
    return theValue;
}
/**
 * Returns the current value from the target object if not null or undefined otherwise sets the new value and returns it
 * @param target - The target object to return or set the default value
 * @param field - The key for the field to set on the target
 * @param defValue - [Optional] The value to set if not already present, when not provided a empty object will be added
 */
function getSetValue(target, field, defValue) {
    var theValue;
    if (target) {
        theValue = target[field];
        if (!theValue && isNullOrUndefined(theValue)) {
            // Supports having the default as null
            theValue = !isUndefined(defValue) ? defValue : {};
            target[field] = theValue;
        }
    }
    else {
        // Expanded for performance so we only check defValue if required
        theValue = !isUndefined(defValue) ? defValue : {};
    }
    return theValue;
}
function isNotTruthy(value) {
    return !value;
}
function isTruthy(value) {
    return !!value;
}
function throwError(message) {
    throw new Error(message);
}
/**
 * Effectively assigns all enumerable properties (not just own properties) and functions (including inherited prototype) from
 * the source object to the target, it attempts to use proxy getters / setters (if possible) and proxy functions to avoid potential
 * implementation issues by assigning prototype functions as instance ones
 *
 * This method is the primary method used to "update" the snippet proxy with the ultimate implementations.
 *
 * Special ES3 Notes:
 * Updates (setting) of direct property values on the target or indirectly on the source object WILL NOT WORK PROPERLY, updates to the
 * properties of "referenced" object will work (target.context.newValue = 10 => will be reflected in the source.context as it's the
 * same object). ES3 Failures: assigning target.myProp = 3 -> Won't change source.myProp = 3, likewise the reverse would also fail.
 * @param target - The target object to be assigned with the source properties and functions
 * @param source - The source object which will be assigned / called by setting / calling the targets proxies
 * @param chkSet - An optional callback to determine whether a specific property/function should be proxied
 * @memberof Initialization
 */
function proxyAssign(target, source, chkSet) {
    if (target && source && target !== source && isObject(target) && isObject(source)) {
        var _loop_1 = function (field) {
            if (isString(field)) {
                var value = source[field];
                if (isFunction(value)) {
                    if (!chkSet || chkSet(field, true, source, target)) {
                        // Create a proxy function rather than just copying the (possible) prototype to the new object as an instance function
                        target[field] = (function (funcName) {
                            return function () {
                                // Capture the original arguments passed to the method
                                var originalArguments = arguments;
                                return source[funcName].apply(source, originalArguments);
                            };
                        })(field);
                    }
                }
                else if (!chkSet || chkSet(field, false, source, target)) {
                    if (hasOwnProperty(target, field)) {
                        // Remove any previous instance property
                        delete target[field];
                    }
                    if (!objDefineAccessors(target, field, function () {
                        return source[field];
                    }, function (theValue) {
                        source[field] = theValue;
                    })) {
                        // Unable to create an accessor, so just assign the values as a fallback
                        // -- this will (mostly) work for objects
                        // -- but will fail for accessing primitives (if the source changes it) and all types of "setters" as the source won't be modified
                        target[field] = value;
                    }
                }
            }
        };
        // effectively apply/proxy full source to the target instance
        for (var field in source) {
            _loop_1(field);
        }
    }
    return target;
}
/**
 * Simpler helper to create a dynamic class that implements the interface and populates the values with the defaults.
 * Only instance properties (hasOwnProperty) values are copied from the defaults to the new instance
 * @param defaults Simple helper
 */
function createClassFromInterface(defaults) {
    return /** @class */ (function () {
        function class_1() {
            var _this = this;
            if (defaults) {
                objForEachKey(defaults, function (field, value) {
                    _this[field] = value;
                });
            }
        }
        return class_1;
    }());
}
/**
 * A helper function to assist with JIT performance for objects that have properties added / removed dynamically
 * this is primarily for chromium based browsers and has limited effects on Firefox and none of IE. Only call this
 * function after you have finished "updating" the object, calling this within loops reduces or defeats the benefits.
 * This helps when iterating using for..in, objKeys() and objForEach()
 * @param theObject - The object to be optimized if possible
 */
function optimizeObject(theObject) {
    // V8 Optimization to cause the JIT compiler to create a new optimized object for looking up the own properties
    // primarily for object with <= 19 properties for >= 20 the effect is reduced or non-existent
    if (theObject) {
        theObject = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["b" /* ObjClass */])(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["a" /* ObjAssign */] ? Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["a" /* ObjAssign */])({}, theObject) : theObject);
    }
    return theObject;
}
//# sourceMappingURL=HelperFuncs.js.map

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export objToString */
/* harmony export (immutable) */ __webpack_exports__["x"] = isTypeof;
/* harmony export (immutable) */ __webpack_exports__["y"] = isUndefined;
/* unused harmony export isNotUndefined */
/* harmony export (immutable) */ __webpack_exports__["s"] = isNullOrUndefined;
/* harmony export (immutable) */ __webpack_exports__["q"] = isNotNullOrUndefined;
/* harmony export (immutable) */ __webpack_exports__["k"] = hasOwnProperty;
/* harmony export (immutable) */ __webpack_exports__["u"] = isObject;
/* harmony export (immutable) */ __webpack_exports__["p"] = isFunction;
/* harmony export (immutable) */ __webpack_exports__["e"] = attachEvent;
/* harmony export (immutable) */ __webpack_exports__["h"] = detachEvent;
/* unused harmony export normalizeJsName */
/* harmony export (immutable) */ __webpack_exports__["A"] = objForEachKey;
/* harmony export (immutable) */ __webpack_exports__["E"] = strEndsWith;
/* unused harmony export strStartsWith */
/* harmony export (immutable) */ __webpack_exports__["D"] = strContains;
/* harmony export (immutable) */ __webpack_exports__["n"] = isDate;
/* harmony export (immutable) */ __webpack_exports__["l"] = isArray;
/* harmony export (immutable) */ __webpack_exports__["o"] = isError;
/* harmony export (immutable) */ __webpack_exports__["v"] = isString;
/* harmony export (immutable) */ __webpack_exports__["t"] = isNumber;
/* harmony export (immutable) */ __webpack_exports__["m"] = isBoolean;
/* harmony export (immutable) */ __webpack_exports__["H"] = toISOString;
/* harmony export (immutable) */ __webpack_exports__["a"] = arrForEach;
/* harmony export (immutable) */ __webpack_exports__["b"] = arrIndexOf;
/* harmony export (immutable) */ __webpack_exports__["c"] = arrMap;
/* harmony export (immutable) */ __webpack_exports__["d"] = arrReduce;
/* harmony export (immutable) */ __webpack_exports__["F"] = strTrim;
/* harmony export (immutable) */ __webpack_exports__["B"] = objKeys;
/* harmony export (immutable) */ __webpack_exports__["z"] = objDefineAccessors;
/* unused harmony export objFreeze */
/* unused harmony export objSeal */
/* harmony export (immutable) */ __webpack_exports__["g"] = dateNow;
/* harmony export (immutable) */ __webpack_exports__["i"] = getExceptionName;
/* harmony export (immutable) */ __webpack_exports__["C"] = setValue;
/* harmony export (immutable) */ __webpack_exports__["j"] = getSetValue;
/* harmony export (immutable) */ __webpack_exports__["r"] = isNotTruthy;
/* harmony export (immutable) */ __webpack_exports__["w"] = isTruthy;
/* harmony export (immutable) */ __webpack_exports__["G"] = throwError;
/* unused harmony export proxyAssign */
/* harmony export (immutable) */ __webpack_exports__["f"] = createClassFromInterface;
/* unused harmony export optimizeObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



// RESTRICT and AVOID circular dependencies you should not import other contained modules or export the contents of this file directly
// Added to help with minfication
var strOnPrefix = "on";
var strAttachEvent = "attachEvent";
var strAddEventHelper = "addEventListener";
var strDetachEvent = "detachEvent";
var strRemoveEventListener = "removeEventListener";
var _objDefineProperty = __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["c" /* ObjDefineProperty */];
var _objFreeze = __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["b" /* ObjClass */]["freeze"];
var _objSeal = __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["b" /* ObjClass */]["seal"];
function objToString(obj) {
    return __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["e" /* ObjProto */].toString.call(obj);
}
function isTypeof(value, theType) {
    return typeof value === theType;
}
;
function isUndefined(value) {
    return value === undefined || typeof value === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["m" /* strShimUndefined */];
}
;
function isNotUndefined(value) {
    return !isUndefined(value);
}
function isNullOrUndefined(value) {
    return (value === null || isUndefined(value));
}
function isNotNullOrUndefined(value) {
    return !isNullOrUndefined(value);
}
function hasOwnProperty(obj, prop) {
    return obj && __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["d" /* ObjHasOwnProperty */].call(obj, prop);
}
;
function isObject(value) {
    // Changing to inline for performance
    return typeof value === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */];
}
;
function isFunction(value) {
    // Changing to inline for performance
    return typeof value === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["j" /* strShimFunction */];
}
;
/**
 * Binds the specified function to an event, so that the function gets called whenever the event fires on the object
 * @param obj Object to add the event too.
 * @param eventNameWithoutOn String that specifies any of the standard DHTML Events without "on" prefix
 * @param handlerRef Pointer that specifies the function to call when event fires
 * @param useCapture [Optional] Defaults to false
 * @returns True if the function was bound successfully to the event, otherwise false
 */
function attachEvent(obj, eventNameWithoutOn, handlerRef, useCapture) {
    if (useCapture === void 0) { useCapture = false; }
    var result = false;
    if (!isNullOrUndefined(obj)) {
        try {
            if (!isNullOrUndefined(obj[strAddEventHelper])) {
                // all browsers except IE before version 9
                obj[strAddEventHelper](eventNameWithoutOn, handlerRef, useCapture);
                result = true;
            }
            else if (!isNullOrUndefined(obj[strAttachEvent])) {
                // IE before version 9                    
                obj[strAttachEvent](strOnPrefix + eventNameWithoutOn, handlerRef);
                result = true;
            }
        }
        catch (e) {
            // Just Ignore any error so that we don't break any execution path
        }
    }
    return result;
}
/**
 * Removes an event handler for the specified event
 * @param Object to remove the event from
 * @param eventNameWithoutOn {string} - The name of the event
 * @param handlerRef {any} - The callback function that needs to be executed for the given event
 * @param useCapture [Optional] Defaults to false
 */
function detachEvent(obj, eventNameWithoutOn, handlerRef, useCapture) {
    if (useCapture === void 0) { useCapture = false; }
    if (!isNullOrUndefined(obj)) {
        try {
            if (!isNullOrUndefined(obj[strRemoveEventListener])) {
                obj[strRemoveEventListener](eventNameWithoutOn, handlerRef, useCapture);
            }
            else if (!isNullOrUndefined(obj[strDetachEvent])) {
                obj[strDetachEvent](strOnPrefix + eventNameWithoutOn, handlerRef);
            }
        }
        catch (e) {
            // Just Ignore any error so that we don't break any execution path
        }
    }
}
/**
 * Validates that the string name conforms to the JS IdentifierName specification and if not
 * normalizes the name so that it would. This method does not identify or change any keywords
 * meaning that if you pass in a known keyword the same value will be returned.
 * This is a simplified version
 * @param name The name to validate
 */
function normalizeJsName(name) {
    var value = name;
    var match = /([^\w\d_$])/g;
    if (match.test(name)) {
        value = name.replace(match, "_");
    }
    return value;
}
/**
 * This is a helper function for the equivalent of arForEach(objKeys(target), callbackFn), this is a
 * performance optimization to avoid the creation of a new array for large objects
 * @param target The target object to find and process the keys
 * @param callbackfn The function to call with the details
 */
function objForEachKey(target, callbackfn) {
    if (target) {
        for (var prop in target) {
            if (__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["d" /* ObjHasOwnProperty */].call(target, prop)) {
                callbackfn.call(target, prop, target[prop]);
            }
        }
    }
}
/**
 * The strEndsWith() method determines whether a string ends with the characters of a specified string, returning true or false as appropriate.
 * @param value - The value to check whether it ends with the search value.
 * @param search - The characters to be searched for at the end of the value.
 * @returns true if the given search value is found at the end of the string, otherwise false.
 */
function strEndsWith(value, search) {
    if (value && search) {
        var searchLen = search.length;
        var valLen = value.length;
        if (value === search) {
            return true;
        }
        else if (valLen >= searchLen) {
            var pos = valLen - 1;
            for (var lp = searchLen - 1; lp >= 0; lp--) {
                if (value[pos] != search[lp]) {
                    return false;
                }
                pos--;
            }
            return true;
        }
    }
    return false;
}
/**
 * The strStartsWith() method determines whether a string starts with the characters of the specified string, returning true or false as appropriate.
 * @param value - The value to check whether it ends with the search value.
 * @param checkValue - The characters to be searched for at the start of the value.
 * @returns true if the given search value is found at the start of the string, otherwise false.
 */
function strStartsWith(value, checkValue) {
    // Using helper for performance and because string startsWith() is not available on IE
    var result = false;
    if (value && checkValue) {
        var chkLen = checkValue.length;
        if (value === checkValue) {
            return true;
        }
        else if (value.length >= chkLen) {
            for (var lp = 0; lp < chkLen; lp++) {
                if (value[lp] !== checkValue[lp]) {
                    return false;
                }
            }
            result = true;
        }
    }
    return result;
}
/**
 * A simple wrapper (for minification support) to check if the value contains the search string.
 * @param value - The string value to check for the existence of the search value
 * @param search - The value search within the value
 */
function strContains(value, search) {
    if (value && search) {
        return value.indexOf(search) !== -1;
    }
    return false;
}
/**
 * Check if an object is of type Date
 */
function isDate(obj) {
    return objToString(obj) === "[object Date]";
}
/**
 * Check if an object is of type Array
 */
function isArray(obj) {
    return objToString(obj) === "[object Array]";
}
/**
 * Check if an object is of type Error
 */
function isError(obj) {
    return objToString(obj) === "[object Error]";
}
/**
 * Checks if the type of value is a string.
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is a string, false otherwise.
 */
function isString(value) {
    // Changing to inline for performance
    return typeof value === "string";
}
/**
 * Checks if the type of value is a number.
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is a number, false otherwise.
 */
function isNumber(value) {
    // Changing to inline for performance
    return typeof value === "number";
}
/**
 * Checks if the type of value is a boolean.
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is a boolean, false otherwise.
 */
function isBoolean(value) {
    // Changing to inline for performance
    return typeof value === "boolean";
}
/**
 * Convert a date to I.S.O. format in IE8
 */
function toISOString(date) {
    if (isDate(date)) {
        var pad = function (num) {
            var r = String(num);
            if (r.length === 1) {
                r = "0" + r;
            }
            return r;
        };
        return date.getUTCFullYear()
            + "-" + pad(date.getUTCMonth() + 1)
            + "-" + pad(date.getUTCDate())
            + "T" + pad(date.getUTCHours())
            + ":" + pad(date.getUTCMinutes())
            + ":" + pad(date.getUTCSeconds())
            + "." + String((date.getUTCMilliseconds() / 1000).toFixed(3)).slice(2, 5)
            + "Z";
    }
}
/**
 * Performs the specified action for each element in an array. This helper exists to avoid adding a polyfil for older browsers
 * that do not define Array.prototype.xxxx (eg. ES3 only, IE8) just in case any page checks for presence/absence of the prototype
 * implementation. Note: For consistency this will not use the Array.prototype.xxxx implementation if it exists as this would
 * cause a testing requirement to test with and without the implementations
 * @param callbackfn  A function that accepts up to three arguments. forEach calls the callbackfn function one time for each element in the array. It can return -1 to break out of the loop
 * @param thisArg  [Optional] An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, undefined is used as the this value.
 */
function arrForEach(arr, callbackfn, thisArg) {
    var len = arr.length;
    for (var idx = 0; idx < len; idx++) {
        if (idx in arr) {
            if (callbackfn.call(thisArg || arr, arr[idx], idx, arr) === -1) {
                break;
            }
        }
    }
}
/**
 * Returns the index of the first occurrence of a value in an array. This helper exists to avoid adding a polyfil for older browsers
 * that do not define Array.prototype.xxxx (eg. ES3 only, IE8) just in case any page checks for presence/absence of the prototype
 * implementation. Note: For consistency this will not use the Array.prototype.xxxx implementation if it exists as this would
 * cause a testing requirement to test with and without the implementations
 * @param searchElement The value to locate in the array.
 * @param fromIndex The array index at which to begin the search. If fromIndex is omitted, the search starts at index 0.
 */
function arrIndexOf(arr, searchElement, fromIndex) {
    var len = arr.length;
    var from = fromIndex || 0;
    for (var lp = Math.max(from >= 0 ? from : len - Math.abs(from), 0); lp < len; lp++) {
        if (lp in arr && arr[lp] === searchElement) {
            return lp;
        }
    }
    return -1;
}
/**
 * Calls a defined callback function on each element of an array, and returns an array that contains the results. This helper exists
 * to avoid adding a polyfil for older browsers that do not define Array.prototype.xxxx (eg. ES3 only, IE8) just in case any page
 * checks for presence/absence of the prototype implementation. Note: For consistency this will not use the Array.prototype.xxxx
 * implementation if it exists as this would cause a testing requirement to test with and without the implementations
 * @param callbackfn A function that accepts up to three arguments. The map method calls the callbackfn function one time for each element in the array.
 * @param thisArg An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, undefined is used as the this value.
 */
function arrMap(arr, callbackfn, thisArg) {
    var len = arr.length;
    var _this = thisArg || arr;
    var results = new Array(len);
    for (var lp = 0; lp < len; lp++) {
        if (lp in arr) {
            results[lp] = callbackfn.call(_this, arr[lp], arr);
        }
    }
    return results;
}
/**
 * Calls the specified callback function for all the elements in an array. The return value of the callback function is the accumulated result, and is
 * provided as an argument in the next call to the callback function. This helper exists to avoid adding a polyfil for older browsers that do not define
 * Array.prototype.xxxx (eg. ES3 only, IE8) just in case any page checks for presence/absence of the prototype implementation. Note: For consistency
 * this will not use the Array.prototype.xxxx implementation if it exists as this would cause a testing requirement to test with and without the implementations
 * @param callbackfn A function that accepts up to four arguments. The reduce method calls the callbackfn function one time for each element in the array.
 * @param initialValue If initialValue is specified, it is used as the initial value to start the accumulation. The first call to the callbackfn function provides this value as an argument instead of an array value.
 */
function arrReduce(arr, callbackfn, initialValue) {
    var len = arr.length;
    var lp = 0;
    var value;
    // Specifically checking the number of passed arguments as the value could be anything
    if (arguments.length >= 3) {
        value = arguments[2];
    }
    else {
        while (lp < len && !(lp in arr)) {
            lp++;
        }
        value = arr[lp++];
    }
    while (lp < len) {
        if (lp in arr) {
            value = callbackfn(value, arr[lp], lp, arr);
        }
        lp++;
    }
    return value;
}
/**
 * helper method to trim strings (IE8 does not implement String.prototype.trim)
 */
function strTrim(str) {
    if (typeof str !== "string") {
        return str;
    }
    return str.replace(/^\s+|\s+$/g, "");
}
var _objKeysHasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString');
var _objKeysDontEnums = [
    'toString',
    'toLocaleString',
    'valueOf',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'constructor'
];
/**
 * Returns the names of the enumerable string properties and methods of an object. This helper exists to avoid adding a polyfil for older browsers
 * that do not define Object.keys eg. ES3 only, IE8 just in case any page checks for presence/absence of the prototype implementation.
 * Note: For consistency this will not use the Object.keys implementation if it exists as this would cause a testing requirement to test with and without the implementations
 * @param obj Object that contains the properties and methods. This can be an object that you created or an existing Document Object Model (DOM) object.
 */
function objKeys(obj) {
    var objType = typeof obj;
    if (objType !== __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["j" /* strShimFunction */] && (objType !== __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] || obj === null)) {
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["n" /* throwTypeError */])('objKeys called on non-object');
    }
    var result = [];
    for (var prop in obj) {
        if (obj && __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["d" /* ObjHasOwnProperty */].call(obj, prop)) {
            result.push(prop);
        }
    }
    if (_objKeysHasDontEnumBug) {
        var dontEnumsLength = _objKeysDontEnums.length;
        for (var lp = 0; lp < dontEnumsLength; lp++) {
            if (obj && __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["d" /* ObjHasOwnProperty */].call(obj, _objKeysDontEnums[lp])) {
                result.push(_objKeysDontEnums[lp]);
            }
        }
    }
    return result;
}
/**
 * Try to define get/set object property accessors for the target object/prototype, this will provide compatibility with
 * existing API definition when run within an ES5+ container that supports accessors but still enable the code to be loaded
 * and executed in an ES3 container, providing basic IE8 compatibility.
 * @param target The object on which to define the property.
 * @param prop The name of the property to be defined or modified.
 * @param getProp The getter function to wire against the getter.
 * @param setProp The setter function to wire against the setter.
 * @returns True if it was able to create the accessors otherwise false
 */
function objDefineAccessors(target, prop, getProp, setProp) {
    if (_objDefineProperty) {
        try {
            var descriptor = {
                enumerable: true,
                configurable: true
            };
            if (getProp) {
                descriptor.get = getProp;
            }
            if (setProp) {
                descriptor.set = setProp;
            }
            _objDefineProperty(target, prop, descriptor);
            return true;
        }
        catch (e) {
            // IE8 Defines a defineProperty on Object but it's only supported for DOM elements so it will throw
            // We will just ignore this here.
        }
    }
    return false;
}
function objFreeze(value) {
    if (_objFreeze) {
        value = _objFreeze(value);
    }
    return value;
}
function objSeal(value) {
    if (_objSeal) {
        value = _objSeal(value);
    }
    return value;
}
/**
 * Return the current time via the Date now() function (if available) and falls back to (new Date()).getTime() if now() is unavailable (IE8 or less)
 * https://caniuse.com/#search=Date.now
 */
function dateNow() {
    var dt = Date;
    if (dt.now) {
        return dt.now();
    }
    return new dt().getTime();
}
/**
 * Returns the name of object if it's an Error. Otherwise, returns empty string.
 */
function getExceptionName(object) {
    if (isError(object)) {
        return object.name;
    }
    return "";
}
/**
 * Sets the provided value on the target instance using the field name when the provided chk function returns true, the chk
 * function will only be called if the new value is no equal to the original value.
 * @param target - The target object
 * @param field - The key of the target
 * @param value - The value to set
 * @param valChk - [Optional] Callback to check the value that if supplied will be called check if the new value can be set
 * @param srcChk - [Optional] Callback to check to original value that if supplied will be called if the new value should be set (if allowed)
 * @returns The existing or new value, depending what was set
 */
function setValue(target, field, value, valChk, srcChk) {
    var theValue = value;
    if (target) {
        theValue = target[field];
        if (theValue !== value && (!srcChk || srcChk(theValue)) && (!valChk || valChk(value))) {
            theValue = value;
            target[field] = theValue;
        }
    }
    return theValue;
}
/**
 * Returns the current value from the target object if not null or undefined otherwise sets the new value and returns it
 * @param target - The target object to return or set the default value
 * @param field - The key for the field to set on the target
 * @param defValue - [Optional] The value to set if not already present, when not provided a empty object will be added
 */
function getSetValue(target, field, defValue) {
    var theValue;
    if (target) {
        theValue = target[field];
        if (!theValue && isNullOrUndefined(theValue)) {
            // Supports having the default as null
            theValue = !isUndefined(defValue) ? defValue : {};
            target[field] = theValue;
        }
    }
    else {
        // Expanded for performance so we only check defValue if required
        theValue = !isUndefined(defValue) ? defValue : {};
    }
    return theValue;
}
function isNotTruthy(value) {
    return !value;
}
function isTruthy(value) {
    return !!value;
}
function throwError(message) {
    throw new Error(message);
}
/**
 * Effectively assigns all enumerable properties (not just own properties) and functions (including inherited prototype) from
 * the source object to the target, it attempts to use proxy getters / setters (if possible) and proxy functions to avoid potential
 * implementation issues by assigning prototype functions as instance ones
 *
 * This method is the primary method used to "update" the snippet proxy with the ultimate implementations.
 *
 * Special ES3 Notes:
 * Updates (setting) of direct property values on the target or indirectly on the source object WILL NOT WORK PROPERLY, updates to the
 * properties of "referenced" object will work (target.context.newValue = 10 => will be reflected in the source.context as it's the
 * same object). ES3 Failures: assigning target.myProp = 3 -> Won't change source.myProp = 3, likewise the reverse would also fail.
 * @param target - The target object to be assigned with the source properties and functions
 * @param source - The source object which will be assigned / called by setting / calling the targets proxies
 * @param chkSet - An optional callback to determine whether a specific property/function should be proxied
 * @memberof Initialization
 */
function proxyAssign(target, source, chkSet) {
    if (target && source && target !== source && isObject(target) && isObject(source)) {
        var _loop_1 = function (field) {
            if (isString(field)) {
                var value = source[field];
                if (isFunction(value)) {
                    if (!chkSet || chkSet(field, true, source, target)) {
                        // Create a proxy function rather than just copying the (possible) prototype to the new object as an instance function
                        target[field] = (function (funcName) {
                            return function () {
                                // Capture the original arguments passed to the method
                                var originalArguments = arguments;
                                return source[funcName].apply(source, originalArguments);
                            };
                        })(field);
                    }
                }
                else if (!chkSet || chkSet(field, false, source, target)) {
                    if (hasOwnProperty(target, field)) {
                        // Remove any previous instance property
                        delete target[field];
                    }
                    if (!objDefineAccessors(target, field, function () {
                        return source[field];
                    }, function (theValue) {
                        source[field] = theValue;
                    })) {
                        // Unable to create an accessor, so just assign the values as a fallback
                        // -- this will (mostly) work for objects
                        // -- but will fail for accessing primitives (if the source changes it) and all types of "setters" as the source won't be modified
                        target[field] = value;
                    }
                }
            }
        };
        // effectively apply/proxy full source to the target instance
        for (var field in source) {
            _loop_1(field);
        }
    }
    return target;
}
/**
 * Simpler helper to create a dynamic class that implements the interface and populates the values with the defaults.
 * Only instance properties (hasOwnProperty) values are copied from the defaults to the new instance
 * @param defaults Simple helper
 */
function createClassFromInterface(defaults) {
    return /** @class */ (function () {
        function class_1() {
            var _this = this;
            if (defaults) {
                objForEachKey(defaults, function (field, value) {
                    _this[field] = value;
                });
            }
        }
        return class_1;
    }());
}
/**
 * A helper function to assist with JIT performance for objects that have properties added / removed dynamically
 * this is primarily for chromium based browsers and has limited effects on Firefox and none of IE. Only call this
 * function after you have finished "updating" the object, calling this within loops reduces or defeats the benefits.
 * This helps when iterating using for..in, objKeys() and objForEach()
 * @param theObject - The object to be optimized if possible
 */
function optimizeObject(theObject) {
    // V8 Optimization to cause the JIT compiler to create a new optimized object for looking up the own properties
    // primarily for object with <= 19 properties for >= 20 the effect is reduced or non-existent
    if (theObject) {
        theObject = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["b" /* ObjClass */])(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["a" /* ObjAssign */] ? Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["a" /* ObjAssign */])({}, theObject) : theObject);
    }
    return theObject;
}
//# sourceMappingURL=HelperFuncs.js.map

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export objToString */
/* harmony export (immutable) */ __webpack_exports__["x"] = isTypeof;
/* harmony export (immutable) */ __webpack_exports__["y"] = isUndefined;
/* unused harmony export isNotUndefined */
/* harmony export (immutable) */ __webpack_exports__["s"] = isNullOrUndefined;
/* harmony export (immutable) */ __webpack_exports__["q"] = isNotNullOrUndefined;
/* harmony export (immutable) */ __webpack_exports__["k"] = hasOwnProperty;
/* harmony export (immutable) */ __webpack_exports__["u"] = isObject;
/* harmony export (immutable) */ __webpack_exports__["p"] = isFunction;
/* harmony export (immutable) */ __webpack_exports__["e"] = attachEvent;
/* harmony export (immutable) */ __webpack_exports__["h"] = detachEvent;
/* harmony export (immutable) */ __webpack_exports__["z"] = normalizeJsName;
/* harmony export (immutable) */ __webpack_exports__["B"] = objForEachKey;
/* harmony export (immutable) */ __webpack_exports__["F"] = strEndsWith;
/* unused harmony export strStartsWith */
/* harmony export (immutable) */ __webpack_exports__["E"] = strContains;
/* harmony export (immutable) */ __webpack_exports__["n"] = isDate;
/* harmony export (immutable) */ __webpack_exports__["l"] = isArray;
/* harmony export (immutable) */ __webpack_exports__["o"] = isError;
/* harmony export (immutable) */ __webpack_exports__["v"] = isString;
/* harmony export (immutable) */ __webpack_exports__["t"] = isNumber;
/* harmony export (immutable) */ __webpack_exports__["m"] = isBoolean;
/* harmony export (immutable) */ __webpack_exports__["I"] = toISOString;
/* harmony export (immutable) */ __webpack_exports__["a"] = arrForEach;
/* harmony export (immutable) */ __webpack_exports__["b"] = arrIndexOf;
/* harmony export (immutable) */ __webpack_exports__["c"] = arrMap;
/* harmony export (immutable) */ __webpack_exports__["d"] = arrReduce;
/* harmony export (immutable) */ __webpack_exports__["G"] = strTrim;
/* harmony export (immutable) */ __webpack_exports__["C"] = objKeys;
/* harmony export (immutable) */ __webpack_exports__["A"] = objDefineAccessors;
/* unused harmony export objFreeze */
/* unused harmony export objSeal */
/* harmony export (immutable) */ __webpack_exports__["g"] = dateNow;
/* harmony export (immutable) */ __webpack_exports__["i"] = getExceptionName;
/* harmony export (immutable) */ __webpack_exports__["D"] = setValue;
/* harmony export (immutable) */ __webpack_exports__["j"] = getSetValue;
/* harmony export (immutable) */ __webpack_exports__["r"] = isNotTruthy;
/* harmony export (immutable) */ __webpack_exports__["w"] = isTruthy;
/* harmony export (immutable) */ __webpack_exports__["H"] = throwError;
/* unused harmony export proxyAssign */
/* harmony export (immutable) */ __webpack_exports__["f"] = createClassFromInterface;
/* unused harmony export optimizeObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



// RESTRICT and AVOID circular dependencies you should not import other contained modules or export the contents of this file directly
// Added to help with minfication
var strOnPrefix = "on";
var strAttachEvent = "attachEvent";
var strAddEventHelper = "addEventListener";
var strDetachEvent = "detachEvent";
var strRemoveEventListener = "removeEventListener";
var _objDefineProperty = __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["c" /* ObjDefineProperty */];
var _objFreeze = __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["b" /* ObjClass */]["freeze"];
var _objSeal = __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["b" /* ObjClass */]["seal"];
function objToString(obj) {
    return __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["e" /* ObjProto */].toString.call(obj);
}
function isTypeof(value, theType) {
    return typeof value === theType;
}
;
function isUndefined(value) {
    return value === undefined || typeof value === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["m" /* strShimUndefined */];
}
;
function isNotUndefined(value) {
    return !isUndefined(value);
}
function isNullOrUndefined(value) {
    return (value === null || isUndefined(value));
}
function isNotNullOrUndefined(value) {
    return !isNullOrUndefined(value);
}
function hasOwnProperty(obj, prop) {
    return obj && __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["d" /* ObjHasOwnProperty */].call(obj, prop);
}
;
function isObject(value) {
    // Changing to inline for performance
    return typeof value === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */];
}
;
function isFunction(value) {
    // Changing to inline for performance
    return typeof value === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["j" /* strShimFunction */];
}
;
/**
 * Binds the specified function to an event, so that the function gets called whenever the event fires on the object
 * @param obj Object to add the event too.
 * @param eventNameWithoutOn String that specifies any of the standard DHTML Events without "on" prefix
 * @param handlerRef Pointer that specifies the function to call when event fires
 * @param useCapture [Optional] Defaults to false
 * @returns True if the function was bound successfully to the event, otherwise false
 */
function attachEvent(obj, eventNameWithoutOn, handlerRef, useCapture) {
    if (useCapture === void 0) { useCapture = false; }
    var result = false;
    if (!isNullOrUndefined(obj)) {
        try {
            if (!isNullOrUndefined(obj[strAddEventHelper])) {
                // all browsers except IE before version 9
                obj[strAddEventHelper](eventNameWithoutOn, handlerRef, useCapture);
                result = true;
            }
            else if (!isNullOrUndefined(obj[strAttachEvent])) {
                // IE before version 9                    
                obj[strAttachEvent](strOnPrefix + eventNameWithoutOn, handlerRef);
                result = true;
            }
        }
        catch (e) {
            // Just Ignore any error so that we don't break any execution path
        }
    }
    return result;
}
/**
 * Removes an event handler for the specified event
 * @param Object to remove the event from
 * @param eventNameWithoutOn {string} - The name of the event
 * @param handlerRef {any} - The callback function that needs to be executed for the given event
 * @param useCapture [Optional] Defaults to false
 */
function detachEvent(obj, eventNameWithoutOn, handlerRef, useCapture) {
    if (useCapture === void 0) { useCapture = false; }
    if (!isNullOrUndefined(obj)) {
        try {
            if (!isNullOrUndefined(obj[strRemoveEventListener])) {
                obj[strRemoveEventListener](eventNameWithoutOn, handlerRef, useCapture);
            }
            else if (!isNullOrUndefined(obj[strDetachEvent])) {
                obj[strDetachEvent](strOnPrefix + eventNameWithoutOn, handlerRef);
            }
        }
        catch (e) {
            // Just Ignore any error so that we don't break any execution path
        }
    }
}
/**
 * Validates that the string name conforms to the JS IdentifierName specification and if not
 * normalizes the name so that it would. This method does not identify or change any keywords
 * meaning that if you pass in a known keyword the same value will be returned.
 * This is a simplified version
 * @param name The name to validate
 */
function normalizeJsName(name) {
    var value = name;
    var match = /([^\w\d_$])/g;
    if (match.test(name)) {
        value = name.replace(match, "_");
    }
    return value;
}
/**
 * This is a helper function for the equivalent of arForEach(objKeys(target), callbackFn), this is a
 * performance optimization to avoid the creation of a new array for large objects
 * @param target The target object to find and process the keys
 * @param callbackfn The function to call with the details
 */
function objForEachKey(target, callbackfn) {
    if (target) {
        for (var prop in target) {
            if (__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["d" /* ObjHasOwnProperty */].call(target, prop)) {
                callbackfn.call(target, prop, target[prop]);
            }
        }
    }
}
/**
 * The strEndsWith() method determines whether a string ends with the characters of a specified string, returning true or false as appropriate.
 * @param value - The value to check whether it ends with the search value.
 * @param search - The characters to be searched for at the end of the value.
 * @returns true if the given search value is found at the end of the string, otherwise false.
 */
function strEndsWith(value, search) {
    if (value && search) {
        var searchLen = search.length;
        var valLen = value.length;
        if (value === search) {
            return true;
        }
        else if (valLen >= searchLen) {
            var pos = valLen - 1;
            for (var lp = searchLen - 1; lp >= 0; lp--) {
                if (value[pos] != search[lp]) {
                    return false;
                }
                pos--;
            }
            return true;
        }
    }
    return false;
}
/**
 * The strStartsWith() method determines whether a string starts with the characters of the specified string, returning true or false as appropriate.
 * @param value - The value to check whether it ends with the search value.
 * @param checkValue - The characters to be searched for at the start of the value.
 * @returns true if the given search value is found at the start of the string, otherwise false.
 */
function strStartsWith(value, checkValue) {
    // Using helper for performance and because string startsWith() is not available on IE
    var result = false;
    if (value && checkValue) {
        var chkLen = checkValue.length;
        if (value === checkValue) {
            return true;
        }
        else if (value.length >= chkLen) {
            for (var lp = 0; lp < chkLen; lp++) {
                if (value[lp] !== checkValue[lp]) {
                    return false;
                }
            }
            result = true;
        }
    }
    return result;
}
/**
 * A simple wrapper (for minification support) to check if the value contains the search string.
 * @param value - The string value to check for the existence of the search value
 * @param search - The value search within the value
 */
function strContains(value, search) {
    if (value && search) {
        return value.indexOf(search) !== -1;
    }
    return false;
}
/**
 * Check if an object is of type Date
 */
function isDate(obj) {
    return objToString(obj) === "[object Date]";
}
/**
 * Check if an object is of type Array
 */
function isArray(obj) {
    return objToString(obj) === "[object Array]";
}
/**
 * Check if an object is of type Error
 */
function isError(obj) {
    return objToString(obj) === "[object Error]";
}
/**
 * Checks if the type of value is a string.
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is a string, false otherwise.
 */
function isString(value) {
    // Changing to inline for performance
    return typeof value === "string";
}
/**
 * Checks if the type of value is a number.
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is a number, false otherwise.
 */
function isNumber(value) {
    // Changing to inline for performance
    return typeof value === "number";
}
/**
 * Checks if the type of value is a boolean.
 * @param {any} value - Value to be checked.
 * @return {boolean} True if the value is a boolean, false otherwise.
 */
function isBoolean(value) {
    // Changing to inline for performance
    return typeof value === "boolean";
}
/**
 * Convert a date to I.S.O. format in IE8
 */
function toISOString(date) {
    if (isDate(date)) {
        var pad = function (num) {
            var r = String(num);
            if (r.length === 1) {
                r = "0" + r;
            }
            return r;
        };
        return date.getUTCFullYear()
            + "-" + pad(date.getUTCMonth() + 1)
            + "-" + pad(date.getUTCDate())
            + "T" + pad(date.getUTCHours())
            + ":" + pad(date.getUTCMinutes())
            + ":" + pad(date.getUTCSeconds())
            + "." + String((date.getUTCMilliseconds() / 1000).toFixed(3)).slice(2, 5)
            + "Z";
    }
}
/**
 * Performs the specified action for each element in an array. This helper exists to avoid adding a polyfil for older browsers
 * that do not define Array.prototype.xxxx (eg. ES3 only, IE8) just in case any page checks for presence/absence of the prototype
 * implementation. Note: For consistency this will not use the Array.prototype.xxxx implementation if it exists as this would
 * cause a testing requirement to test with and without the implementations
 * @param callbackfn  A function that accepts up to three arguments. forEach calls the callbackfn function one time for each element in the array. It can return -1 to break out of the loop
 * @param thisArg  [Optional] An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, undefined is used as the this value.
 */
function arrForEach(arr, callbackfn, thisArg) {
    var len = arr.length;
    for (var idx = 0; idx < len; idx++) {
        if (idx in arr) {
            if (callbackfn.call(thisArg || arr, arr[idx], idx, arr) === -1) {
                break;
            }
        }
    }
}
/**
 * Returns the index of the first occurrence of a value in an array. This helper exists to avoid adding a polyfil for older browsers
 * that do not define Array.prototype.xxxx (eg. ES3 only, IE8) just in case any page checks for presence/absence of the prototype
 * implementation. Note: For consistency this will not use the Array.prototype.xxxx implementation if it exists as this would
 * cause a testing requirement to test with and without the implementations
 * @param searchElement The value to locate in the array.
 * @param fromIndex The array index at which to begin the search. If fromIndex is omitted, the search starts at index 0.
 */
function arrIndexOf(arr, searchElement, fromIndex) {
    var len = arr.length;
    var from = fromIndex || 0;
    for (var lp = Math.max(from >= 0 ? from : len - Math.abs(from), 0); lp < len; lp++) {
        if (lp in arr && arr[lp] === searchElement) {
            return lp;
        }
    }
    return -1;
}
/**
 * Calls a defined callback function on each element of an array, and returns an array that contains the results. This helper exists
 * to avoid adding a polyfil for older browsers that do not define Array.prototype.xxxx (eg. ES3 only, IE8) just in case any page
 * checks for presence/absence of the prototype implementation. Note: For consistency this will not use the Array.prototype.xxxx
 * implementation if it exists as this would cause a testing requirement to test with and without the implementations
 * @param callbackfn A function that accepts up to three arguments. The map method calls the callbackfn function one time for each element in the array.
 * @param thisArg An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, undefined is used as the this value.
 */
function arrMap(arr, callbackfn, thisArg) {
    var len = arr.length;
    var _this = thisArg || arr;
    var results = new Array(len);
    for (var lp = 0; lp < len; lp++) {
        if (lp in arr) {
            results[lp] = callbackfn.call(_this, arr[lp], arr);
        }
    }
    return results;
}
/**
 * Calls the specified callback function for all the elements in an array. The return value of the callback function is the accumulated result, and is
 * provided as an argument in the next call to the callback function. This helper exists to avoid adding a polyfil for older browsers that do not define
 * Array.prototype.xxxx (eg. ES3 only, IE8) just in case any page checks for presence/absence of the prototype implementation. Note: For consistency
 * this will not use the Array.prototype.xxxx implementation if it exists as this would cause a testing requirement to test with and without the implementations
 * @param callbackfn A function that accepts up to four arguments. The reduce method calls the callbackfn function one time for each element in the array.
 * @param initialValue If initialValue is specified, it is used as the initial value to start the accumulation. The first call to the callbackfn function provides this value as an argument instead of an array value.
 */
function arrReduce(arr, callbackfn, initialValue) {
    var len = arr.length;
    var lp = 0;
    var value;
    // Specifically checking the number of passed arguments as the value could be anything
    if (arguments.length >= 3) {
        value = arguments[2];
    }
    else {
        while (lp < len && !(lp in arr)) {
            lp++;
        }
        value = arr[lp++];
    }
    while (lp < len) {
        if (lp in arr) {
            value = callbackfn(value, arr[lp], lp, arr);
        }
        lp++;
    }
    return value;
}
/**
 * helper method to trim strings (IE8 does not implement String.prototype.trim)
 */
function strTrim(str) {
    if (typeof str !== "string") {
        return str;
    }
    return str.replace(/^\s+|\s+$/g, "");
}
var _objKeysHasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString');
var _objKeysDontEnums = [
    'toString',
    'toLocaleString',
    'valueOf',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'constructor'
];
/**
 * Returns the names of the enumerable string properties and methods of an object. This helper exists to avoid adding a polyfil for older browsers
 * that do not define Object.keys eg. ES3 only, IE8 just in case any page checks for presence/absence of the prototype implementation.
 * Note: For consistency this will not use the Object.keys implementation if it exists as this would cause a testing requirement to test with and without the implementations
 * @param obj Object that contains the properties and methods. This can be an object that you created or an existing Document Object Model (DOM) object.
 */
function objKeys(obj) {
    var objType = typeof obj;
    if (objType !== __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["j" /* strShimFunction */] && (objType !== __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] || obj === null)) {
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["n" /* throwTypeError */])('objKeys called on non-object');
    }
    var result = [];
    for (var prop in obj) {
        if (obj && __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["d" /* ObjHasOwnProperty */].call(obj, prop)) {
            result.push(prop);
        }
    }
    if (_objKeysHasDontEnumBug) {
        var dontEnumsLength = _objKeysDontEnums.length;
        for (var lp = 0; lp < dontEnumsLength; lp++) {
            if (obj && __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["d" /* ObjHasOwnProperty */].call(obj, _objKeysDontEnums[lp])) {
                result.push(_objKeysDontEnums[lp]);
            }
        }
    }
    return result;
}
/**
 * Try to define get/set object property accessors for the target object/prototype, this will provide compatibility with
 * existing API definition when run within an ES5+ container that supports accessors but still enable the code to be loaded
 * and executed in an ES3 container, providing basic IE8 compatibility.
 * @param target The object on which to define the property.
 * @param prop The name of the property to be defined or modified.
 * @param getProp The getter function to wire against the getter.
 * @param setProp The setter function to wire against the setter.
 * @returns True if it was able to create the accessors otherwise false
 */
function objDefineAccessors(target, prop, getProp, setProp) {
    if (_objDefineProperty) {
        try {
            var descriptor = {
                enumerable: true,
                configurable: true
            };
            if (getProp) {
                descriptor.get = getProp;
            }
            if (setProp) {
                descriptor.set = setProp;
            }
            _objDefineProperty(target, prop, descriptor);
            return true;
        }
        catch (e) {
            // IE8 Defines a defineProperty on Object but it's only supported for DOM elements so it will throw
            // We will just ignore this here.
        }
    }
    return false;
}
function objFreeze(value) {
    if (_objFreeze) {
        value = _objFreeze(value);
    }
    return value;
}
function objSeal(value) {
    if (_objSeal) {
        value = _objSeal(value);
    }
    return value;
}
/**
 * Return the current time via the Date now() function (if available) and falls back to (new Date()).getTime() if now() is unavailable (IE8 or less)
 * https://caniuse.com/#search=Date.now
 */
function dateNow() {
    var dt = Date;
    if (dt.now) {
        return dt.now();
    }
    return new dt().getTime();
}
/**
 * Returns the name of object if it's an Error. Otherwise, returns empty string.
 */
function getExceptionName(object) {
    if (isError(object)) {
        return object.name;
    }
    return "";
}
/**
 * Sets the provided value on the target instance using the field name when the provided chk function returns true, the chk
 * function will only be called if the new value is no equal to the original value.
 * @param target - The target object
 * @param field - The key of the target
 * @param value - The value to set
 * @param valChk - [Optional] Callback to check the value that if supplied will be called check if the new value can be set
 * @param srcChk - [Optional] Callback to check to original value that if supplied will be called if the new value should be set (if allowed)
 * @returns The existing or new value, depending what was set
 */
function setValue(target, field, value, valChk, srcChk) {
    var theValue = value;
    if (target) {
        theValue = target[field];
        if (theValue !== value && (!srcChk || srcChk(theValue)) && (!valChk || valChk(value))) {
            theValue = value;
            target[field] = theValue;
        }
    }
    return theValue;
}
/**
 * Returns the current value from the target object if not null or undefined otherwise sets the new value and returns it
 * @param target - The target object to return or set the default value
 * @param field - The key for the field to set on the target
 * @param defValue - [Optional] The value to set if not already present, when not provided a empty object will be added
 */
function getSetValue(target, field, defValue) {
    var theValue;
    if (target) {
        theValue = target[field];
        if (!theValue && isNullOrUndefined(theValue)) {
            // Supports having the default as null
            theValue = !isUndefined(defValue) ? defValue : {};
            target[field] = theValue;
        }
    }
    else {
        // Expanded for performance so we only check defValue if required
        theValue = !isUndefined(defValue) ? defValue : {};
    }
    return theValue;
}
function isNotTruthy(value) {
    return !value;
}
function isTruthy(value) {
    return !!value;
}
function throwError(message) {
    throw new Error(message);
}
/**
 * Effectively assigns all enumerable properties (not just own properties) and functions (including inherited prototype) from
 * the source object to the target, it attempts to use proxy getters / setters (if possible) and proxy functions to avoid potential
 * implementation issues by assigning prototype functions as instance ones
 *
 * This method is the primary method used to "update" the snippet proxy with the ultimate implementations.
 *
 * Special ES3 Notes:
 * Updates (setting) of direct property values on the target or indirectly on the source object WILL NOT WORK PROPERLY, updates to the
 * properties of "referenced" object will work (target.context.newValue = 10 => will be reflected in the source.context as it's the
 * same object). ES3 Failures: assigning target.myProp = 3 -> Won't change source.myProp = 3, likewise the reverse would also fail.
 * @param target - The target object to be assigned with the source properties and functions
 * @param source - The source object which will be assigned / called by setting / calling the targets proxies
 * @param chkSet - An optional callback to determine whether a specific property/function should be proxied
 * @memberof Initialization
 */
function proxyAssign(target, source, chkSet) {
    if (target && source && target !== source && isObject(target) && isObject(source)) {
        var _loop_1 = function (field) {
            if (isString(field)) {
                var value = source[field];
                if (isFunction(value)) {
                    if (!chkSet || chkSet(field, true, source, target)) {
                        // Create a proxy function rather than just copying the (possible) prototype to the new object as an instance function
                        target[field] = (function (funcName) {
                            return function () {
                                // Capture the original arguments passed to the method
                                var originalArguments = arguments;
                                return source[funcName].apply(source, originalArguments);
                            };
                        })(field);
                    }
                }
                else if (!chkSet || chkSet(field, false, source, target)) {
                    if (hasOwnProperty(target, field)) {
                        // Remove any previous instance property
                        delete target[field];
                    }
                    if (!objDefineAccessors(target, field, function () {
                        return source[field];
                    }, function (theValue) {
                        source[field] = theValue;
                    })) {
                        // Unable to create an accessor, so just assign the values as a fallback
                        // -- this will (mostly) work for objects
                        // -- but will fail for accessing primitives (if the source changes it) and all types of "setters" as the source won't be modified
                        target[field] = value;
                    }
                }
            }
        };
        // effectively apply/proxy full source to the target instance
        for (var field in source) {
            _loop_1(field);
        }
    }
    return target;
}
/**
 * Simpler helper to create a dynamic class that implements the interface and populates the values with the defaults.
 * Only instance properties (hasOwnProperty) values are copied from the defaults to the new instance
 * @param defaults Simple helper
 */
function createClassFromInterface(defaults) {
    return /** @class */ (function () {
        function class_1() {
            var _this = this;
            if (defaults) {
                objForEachKey(defaults, function (field, value) {
                    _this[field] = value;
                });
            }
        }
        return class_1;
    }());
}
/**
 * A helper function to assist with JIT performance for objects that have properties added / removed dynamically
 * this is primarily for chromium based browsers and has limited effects on Firefox and none of IE. Only call this
 * function after you have finished "updating" the object, calling this within loops reduces or defeats the benefits.
 * This helps when iterating using for..in, objKeys() and objForEach()
 * @param theObject - The object to be optimized if possible
 */
function optimizeObject(theObject) {
    // V8 Optimization to cause the JIT compiler to create a new optimized object for looking up the own properties
    // primarily for object with <= 19 properties for >= 20 the effect is reduced or non-existent
    if (theObject) {
        theObject = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["b" /* ObjClass */])(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["a" /* ObjAssign */] ? Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["a" /* ObjAssign */])({}, theObject) : theObject);
    }
    return theObject;
}
//# sourceMappingURL=HelperFuncs.js.map

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mergeStyles__ = __webpack_require__(1564);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__mergeStyles__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mergeStyleSets__ = __webpack_require__(1569);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__mergeStyleSets__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__concatStyleSets__ = __webpack_require__(633);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__concatStyleSets__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fontFace__ = __webpack_require__(1570);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__fontFace__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__keyframes__ = __webpack_require__(1571);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__keyframes__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Stylesheet__ = __webpack_require__(146);
/* unused harmony reexport InjectionMode */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__Stylesheet__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__transforms_rtlifyRules__ = __webpack_require__(631);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__transforms_rtlifyRules__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__version__ = __webpack_require__(1572);








//# sourceMappingURL=index.js.map

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, module) {/* unused harmony export css */
/* unused harmony export keyframes */
/* unused harmony export injectGlobal */
/* unused harmony export isStyledComponent */
/* unused harmony export consolidateStreamedStyles */
/* unused harmony export ThemeProvider */
/* unused harmony export withTheme */
/* unused harmony export ServerStyleSheet */
/* unused harmony export StyleSheetManager */
/* unused harmony export __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName__ = __webpack_require__(1826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylis__ = __webpack_require__(1828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_stylis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet__ = __webpack_require__(1829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__ = __webpack_require__(1830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_is__);








var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

// 
var isPlainObject = (function (x) {
  return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x.constructor === Object;
});

// 


/**
 * Parse errors.md and turn it into a simple hash of code: message
 */
var ERRORS =  false ? {
  "1": "Cannot create styled-component for component: %s.\n\n",
  "2": "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n* Are you trying to reuse it across renders?\n* Are you accidentally calling collectStyles twice?\n\n",
  "3": "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
  "4": "The `StyleSheetManager` expects a valid target or sheet prop!\n\n* Does this error occur on the client and is your target falsy?\n* Does this error occur on the server and is the sheet falsy?\n\n",
  "5": "The clone method cannot be used on the client!\n\n* Are you running in a client-like environment on the server?\n* Are you trying to run SSR on the client?\n\n",
  "6": "Trying to insert a new style tag, but the given Node is unmounted!\n\n* Are you using a custom target that isn't mounted?\n* Does your document not have a valid head element?\n* Have you accidentally removed a style tag manually?\n\n",
  "7": "ThemeProvider: Please return an object from your \"theme\" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n",
  "8": "ThemeProvider: Please make your \"theme\" prop an object.\n\n",
  "9": "Missing document `<head>`\n\n",
  "10": "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
  "11": "A plain React class (%s) has been interpolated into styles, probably as a component selector (https://www.styled-components.com/docs/advanced#referring-to-other-components). Only styled-component classes can be targeted in this fashion."
} : {};

/**
 * super basic version of sprintf
 */
function format() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var a = args[0];
  var b = [];
  var c = void 0;

  for (c = 1; c < args.length; c += 1) {
    b.push(args[c]);
  }

  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });

  return a;
}

/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */

var StyledComponentsError = function (_Error) {
  inherits(StyledComponentsError, _Error);

  function StyledComponentsError(code) {
    classCallCheck(this, StyledComponentsError);

    for (var _len2 = arguments.length, interpolations = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      interpolations[_key2 - 1] = arguments[_key2];
    }

    if (true) {
      var _this = possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/src/utils/errors.md#' + code + ' for more information. ' + (interpolations ? 'Additional arguments: ' + interpolations.join(', ') : '')));
    } else {
      var _this = possibleConstructorReturn(this, _Error.call(this, format.apply(undefined, [ERRORS[code]].concat(interpolations))));
    }
    return possibleConstructorReturn(_this);
  }

  return StyledComponentsError;
}(Error);

// 

var objToCss = function objToCss(obj, prevKey) {
  var css = Object.keys(obj).filter(function (key) {
    var chunk = obj[key];
    return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
  }).map(function (key) {
    if (isPlainObject(obj[key])) return objToCss(obj[key], key);
    return __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName___default()(key) + ': ' + obj[key] + ';';
  }).join(' ');
  return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
};

var flatten = function flatten(chunks, executionContext) {
  return chunks.reduce(function (ruleSet, chunk) {
    /* Remove falsey values */
    if (chunk === undefined || chunk === null || chunk === false || chunk === '') {
      return ruleSet;
    }

    /* Flatten ruleSet */
    if (Array.isArray(chunk)) {
      ruleSet.push.apply(ruleSet, flatten(chunk, executionContext));
      return ruleSet;
    }

    /* Handle other components */
    if (chunk.hasOwnProperty('styledComponentId')) {
      // $FlowFixMe not sure how to make this pass
      ruleSet.push('.' + chunk.styledComponentId);
      return ruleSet;
    }

    /* Either execute or defer the function */
    if (typeof chunk === 'function') {
      if (executionContext) {
        var nextChunk = chunk(executionContext);
        /* Throw if a React Element was given styles */
        if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(nextChunk)) {
          var elementName = chunk.displayName || chunk.name;
          throw new StyledComponentsError(11, elementName);
        }
        ruleSet.push.apply(ruleSet, flatten([nextChunk], executionContext));
      } else ruleSet.push(chunk);

      return ruleSet;
    }

    /* Handle objects */
    ruleSet.push(
    // $FlowFixMe have to add %checks somehow to isPlainObject
    isPlainObject(chunk) ? objToCss(chunk) : chunk.toString());

    return ruleSet;
  }, []);
};

// 

var COMMENT_REGEX = /^\s*\/\/.*$/gm;

// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var stylisSplitter = new __WEBPACK_IMPORTED_MODULE_2_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: false,
  compress: false,
  semicolon: true
});

var stylis = new __WEBPACK_IMPORTED_MODULE_2_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: true,
  compress: false,
  semicolon: false // NOTE: This means "autocomplete missing semicolons"
});

// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture

var parsingRules = [];
// eslint-disable-next-line consistent-return
var returnRulesPlugin = function returnRulesPlugin(context) {
  if (context === -2) {
    var parsedRules = parsingRules;
    parsingRules = [];
    return parsedRules;
  }
};

var parseRulesPlugin = __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet___default()(function (rule) {
  parsingRules.push(rule);
});

stylis.use([parseRulesPlugin, returnRulesPlugin]);
stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);

var stringifyRules = function stringifyRules(rules, selector, prefix) {
  var flatCSS = rules.join('').replace(COMMENT_REGEX, ''); // replace JS comments

  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;

  return stylis(prefix || !selector ? '' : selector, cssStr);
};

var splitByRules = function splitByRules(css) {
  return stylisSplitter('', css);
};

// 

function isStyledComponent(target) /* : %checks */{
  return (
    // $FlowFixMe TODO: flow for styledComponentId
    typeof target === 'function' && typeof target.styledComponentId === 'string'
  );
}

// 

/* This function is DEPRECATED and will be removed on the next major version release.
 * It was needed to rehydrate all style blocks prepended to chunks before React
 * tries to rehydrate its HTML stream. Since the master StyleSheet will now detect
 * the use of streamed style tags and will perform the rehydration earlier when needed
 * this function will not be needed anymore */
function consolidateStreamedStyles() {
  if (false) {
    // eslint-disable-next-line no-console
    console.warn('styled-components automatically does streaming SSR rehydration now.\n' + 'Calling consolidateStreamedStyles manually is no longer necessary and a noop now.\n' + '- Please remove the consolidateStreamedStyles call from your client.');
  }
}

// 
/* eslint-disable no-bitwise */

/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */
var charsLength = 52;

/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
var getAlphabeticChar = function getAlphabeticChar(code) {
  return String.fromCharCode(code + (code > 25 ? 39 : 97));
};

/* input a number, usually a hash and convert it to base-52 */
var generateAlphabeticName = function generateAlphabeticName(code) {
  var name = '';
  var x = void 0;

  /* get a char and divide by alphabet-length */
  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
    name = getAlphabeticChar(x % charsLength) + name;
  }

  return getAlphabeticChar(x % charsLength) + name;
};

// 

var interleave = (function (strings, interpolations) {
  var result = [strings[0]];

  for (var i = 0, len = interpolations.length; i < len; i += 1) {
    result.push(interpolations[i], strings[i + 1]);
  }

  return result;
});

// 
var EMPTY_ARRAY = Object.freeze([]);
var EMPTY_OBJECT = Object.freeze({});

// 

var css = (function (styles) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  if (typeof styles === 'function' || isPlainObject(styles)) {
    // $FlowFixMe
    return flatten(interleave(EMPTY_ARRAY, [styles].concat(interpolations)));
  }

  // $FlowFixMe
  return flatten(interleave(styles, interpolations));
});

// 


var SC_ATTR = typeof process !== 'undefined' && Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_LOCALIZATION_ASSISTANT":"false","REACT_APP_TENANT":"propnow","REACT_APP_LOCALIZATION_ASSISTANT_URL":"https://translate.lingohub.com/auctiontech/editor?q={key}&targetLocale={locale}&project=dav-slash-dashboard","REACT_APP_DASHBOARD_SHOW_OFFER_LINKS":"true"}).SC_ATTR || 'data-styled-components';
var SC_STREAM_ATTR = 'data-styled-streamed';
var CONTEXT_KEY = '__styled-components-stylesheet__';

var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;

var DISABLE_SPEEDY = "production" !== 'production';

// 
var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;

var extractComps = (function (maybeCSS) {
  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
  var existingComponents = [];
  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
    return match;
  });
  return existingComponents.map(function (_ref, i) {
    var componentId = _ref.componentId,
        matchIndex = _ref.matchIndex;

    var nextComp = existingComponents[i + 1];
    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
    return { componentId: componentId, cssFromDOM: cssFromDOM };
  });
});

// 
/* eslint-disable camelcase, no-undef */

var getNonce = (function () {
  return  true ? __webpack_require__.nc : null;
});

// 
// Helper to call a given function, only once
var once = (function (cb) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      cb();
    }
  };
});

// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */

/* adds a new ID:name pairing to a names dictionary */
var addNameForId = function addNameForId(names, id, name) {
  if (name) {
    // eslint-disable-next-line no-param-reassign
    var namesForId = names[id] || (names[id] = Object.create(null));
    namesForId[name] = true;
  }
};

/* resets an ID entirely by overwriting it in the dictionary */
var resetIdNames = function resetIdNames(names, id) {
  // eslint-disable-next-line no-param-reassign
  names[id] = Object.create(null);
};

/* factory for a names dictionary checking the existance of an ID:name pairing */
var hasNameForId = function hasNameForId(names) {
  return function (id, name) {
    return names[id] !== undefined && names[id][name];
  };
};

/* stringifies names for the html/element output */
var stringifyNames = function stringifyNames(names) {
  var str = '';
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    str += Object.keys(names[id]).join(' ') + ' ';
  }
  return str.trim();
};

/* clones the nested names dictionary */
var cloneNames = function cloneNames(names) {
  var clone = Object.create(null);
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    clone[id] = _extends({}, names[id]);
  }
  return clone;
};

// 

/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */

/* retrieve a sheet for a given style tag */
var sheetForTag = function sheetForTag(tag) {
  // $FlowFixMe
  if (tag.sheet) return tag.sheet;

  /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */
  var size = document.styleSheets.length;
  for (var i = 0; i < size; i += 1) {
    var sheet = document.styleSheets[i];
    // $FlowFixMe
    if (sheet.ownerNode === tag) return sheet;
  }

  /* we should always be able to find a tag */
  throw new StyledComponentsError(10);
};

/* insert a rule safely and return whether it was actually injected */
var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
  /* abort early if cssRule string is falsy */
  if (!cssRule) return false;

  var maxIndex = sheet.cssRules.length;

  try {
    /* use insertRule and cap passed index with maxIndex (no of cssRules) */
    sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
  } catch (err) {
    /* any error indicates an invalid rule */
    return false;
  }

  return true;
};

/* deletes `size` rules starting from `removalIndex` */
var deleteRules = function deleteRules(sheet, removalIndex, size) {
  var lowerBound = removalIndex - size;
  for (var i = removalIndex; i > lowerBound; i -= 1) {
    sheet.deleteRule(i);
  }
};

// 

/* this marker separates component styles and is important for rehydration */
var makeTextMarker = function makeTextMarker(id) {
  return '\n/* sc-component-id: ' + id + ' */\n';
};

/* add up all numbers in array up until and including the index */
var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
  var totalUpToIndex = 0;
  for (var i = 0; i <= index; i += 1) {
    totalUpToIndex += sizes[i];
  }

  return totalUpToIndex;
};

/* create a new style tag after lastEl */
var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
  var el = document.createElement('style');
  el.setAttribute(SC_ATTR, '');

  var nonce = getNonce();
  if (nonce) {
    el.setAttribute('nonce', nonce);
  }

  /* Work around insertRule quirk in EdgeHTML */
  el.appendChild(document.createTextNode(''));

  if (target && !tagEl) {
    /* Append to target when no previous element was passed */
    target.appendChild(el);
  } else {
    if (!tagEl || !target || !tagEl.parentNode) {
      throw new StyledComponentsError(6);
    }

    /* Insert new style tag after the previous one */
    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
  }

  return el;
};

/* takes a css factory function and outputs an html styled tag factory */
var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
  return function (additionalAttrs) {
    var nonce = getNonce();
    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', additionalAttrs];

    var htmlAttr = attrs.filter(Boolean).join(' ');
    return '<style ' + htmlAttr + '>' + css() + '</style>';
  };
};

/* takes a css factory function and outputs an element factory */
var wrapAsElement = function wrapAsElement(css, names) {
  return function () {
    var _props;

    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props);

    var nonce = getNonce();
    if (nonce) {
      // $FlowFixMe
      props.nonce = nonce;
    }

    // eslint-disable-next-line react/no-danger
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
  };
};

var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
  return function () {
    return Object.keys(markers);
  };
};

/* speedy tags utilise insertRule */
var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);
  var sizes = [];

  var extractImport = getImportRuleTag !== undefined;
  /* indicates whther getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = sizes.length;
    sizes.push(0);
    resetIdNames(names, id);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var sheet = sheetForTag(el);
    var insertIndex = addUpUntilIndex(sizes, marker);

    var injectedRules = 0;
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var cssRule = cssRules[i];
      var mayHaveImport = extractImport; /* @import rules are reordered to appear first */
      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
        importRules.push(cssRule);
      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
        mayHaveImport = false;
        injectedRules += 1;
      }
    }

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }

    sizes[marker] += injectedRules; /* add up no of injected rules */
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    var size = sizes[marker];
    var sheet = sheetForTag(el);
    var removalIndex = addUpUntilIndex(sizes, marker);
    deleteRules(sheet, removalIndex, size);
    sizes[marker] = 0;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var _sheetForTag = sheetForTag(el),
        cssRules = _sheetForTag.cssRules;

    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += makeTextMarker(id);
      var marker = markers[id];
      var end = addUpUntilIndex(sizes, marker);
      var size = sizes[marker];
      for (var i = end - size; i < end; i += 1) {
        var rule = cssRules[i];
        if (rule !== undefined) {
          str += rule.cssText;
        }
      }
    }

    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeTextNode = function makeTextNode(id) {
  return document.createTextNode(makeTextMarker(id));
};

var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);

  var extractImport = getImportRuleTag !== undefined;

  /* indicates whther getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = makeTextNode(id);
    el.appendChild(markers[id]);
    names[id] = Object.create(null);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var rule = cssRules[i];
      var mayHaveImport = extractImport;
      if (mayHaveImport && rule.indexOf('@import') !== -1) {
        importRules.push(rule);
      } else {
        mayHaveImport = false;
        var separator = i === cssRulesSize - 1 ? '' : ' ';
        marker.appendData('' + rule + separator);
      }
    }

    addNameForId(names, id, name);

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    /* create new empty text node and replace the current one */
    var newMarker = makeTextNode(id);
    el.replaceChild(newMarker, marker);
    markers[id] = newMarker;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += markers[id].data;
    }
    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeServerTagInternal = function makeServerTagInternal(namesArg, markersArg) {
  var names = namesArg === undefined ? Object.create(null) : namesArg;
  var markers = markersArg === undefined ? Object.create(null) : markersArg;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    return markers[id] = [''];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    marker[0] += cssRules.join(' ');
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;
    marker[0] = '';
    resetIdNames(names, id);
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      var cssForId = markers[id][0];
      if (cssForId) {
        str += makeTextMarker(id) + cssForId;
      }
    }
    return str;
  };

  var clone = function clone() {
    var namesClone = cloneNames(names);
    var markersClone = Object.create(null);

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      markersClone[id] = [markers[id][0]];
    }

    return makeServerTagInternal(namesClone, markersClone);
  };

  var tag = {
    clone: clone,
    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: null,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };

  return tag;
};

var makeServerTag = function makeServerTag() {
  return makeServerTagInternal();
};

var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
  if (IS_BROWSER && !forceServer) {
    var el = makeStyleTag(target, tagEl, insertBefore);

    if (DISABLE_SPEEDY) {
      return makeBrowserTag(el, getImportRuleTag);
    } else {
      return makeSpeedyTag(el, getImportRuleTag);
    }
  }

  return makeServerTag();
};

/* wraps a given tag so that rehydration is performed once when necessary */
var makeRehydrationTag = function makeRehydrationTag(tag, els, extracted, immediateRehydration) {
  /* rehydration function that adds all rules to the new tag */
  var rehydrate = once(function () {
    /* add all extracted components to the new tag */
    for (var i = 0, len = extracted.length; i < len; i += 1) {
      var _extracted$i = extracted[i],
          componentId = _extracted$i.componentId,
          cssFromDOM = _extracted$i.cssFromDOM;

      var cssRules = splitByRules(cssFromDOM);
      tag.insertRules(componentId, cssRules);
    }

    /* remove old HTMLStyleElements, since they have been rehydrated */
    for (var _i = 0, _len = els.length; _i < _len; _i += 1) {
      var el = els[_i];
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
  });

  if (immediateRehydration) rehydrate();

  return _extends({}, tag, {
    /* add rehydration hook to insertion methods */
    insertMarker: function insertMarker(id) {
      rehydrate();
      return tag.insertMarker(id);
    },
    insertRules: function insertRules(id, cssRules, name) {
      rehydrate();
      return tag.insertRules(id, cssRules, name);
    }
  });
};

// 

var SPLIT_REGEX = /\s+/;

/* determine the maximum number of components before tags are sharded */
var MAX_SIZE = void 0;
if (IS_BROWSER) {
  /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */
  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
} else {
  /* for servers we do not need to shard at all */
  MAX_SIZE = -1;
}

var sheetRunningId = 0;
var master = void 0;

var StyleSheet = function () {
  /* a map from ids to tags */
  /* deferred rules for a given id */
  /* this is used for not reinjecting rules via hasNameForId() */
  /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */
  /* a list of tags belonging to this StyleSheet */
  /* a tag for import rules */
  /* current capacity until a new tag must be created */
  /* children (aka clones) of this StyleSheet inheriting all and future injections */

  function StyleSheet() {
    var _this = this;

    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    classCallCheck(this, StyleSheet);

    this.getImportRuleTag = function () {
      var importRuleTag = _this.importRuleTag;

      if (importRuleTag !== undefined) {
        return importRuleTag;
      }

      var firstTag = _this.tags[0];
      var insertBefore = true;

      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
    };

    sheetRunningId += 1;
    this.id = sheetRunningId;
    this.forceServer = forceServer;
    this.target = forceServer ? null : target;
    this.tagMap = {};
    this.deferred = {};
    this.rehydratedNames = {};
    this.ignoreRehydratedNames = {};
    this.tags = [];
    this.capacity = 1;
    this.clones = [];
  }

  /* rehydrate all SSR'd style tags */


  StyleSheet.prototype.rehydrate = function rehydrate() {
    if (!IS_BROWSER || this.forceServer) {
      return this;
    }

    var els = [];
    var extracted = [];
    var isStreamed = false;

    /* retrieve all of our SSR style elements from the DOM */
    var nodes = document.querySelectorAll('style[' + SC_ATTR + ']');
    var nodesSize = nodes.length;

    /* abort rehydration if no previous style tags were found */
    if (nodesSize === 0) {
      return this;
    }

    for (var i = 0; i < nodesSize; i += 1) {
      // $FlowFixMe: We can trust that all elements in this query are style elements
      var el = nodes[i];

      /* check if style tag is a streamed tag */
      if (!isStreamed) isStreamed = !!el.getAttribute(SC_STREAM_ATTR);

      /* retrieve all component names */
      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(SPLIT_REGEX);
      var elNamesSize = elNames.length;
      for (var j = 0; j < elNamesSize; j += 1) {
        var name = elNames[j];
        /* add rehydrated name to sheet to avoid readding styles */
        this.rehydratedNames[name] = true;
      }

      /* extract all components and their CSS */
      extracted.push.apply(extracted, extractComps(el.textContent));

      /* store original HTMLStyleElement */
      els.push(el);
    }

    /* abort rehydration if nothing was extracted */
    var extractedSize = extracted.length;
    if (extractedSize === 0) {
      return this;
    }

    /* create a tag to be used for rehydration */
    var tag = this.makeTag(null);
    var rehydrationTag = makeRehydrationTag(tag, els, extracted, isStreamed);

    /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */
    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
    this.tags.push(rehydrationTag);

    /* retrieve all component ids */
    for (var _j = 0; _j < extractedSize; _j += 1) {
      this.tagMap[extracted[_j].componentId] = rehydrationTag;
    }

    return this;
  };

  /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by injectGlobal, keyframes, and components outside of any
    * StyleSheetManager's context */


  /* reset the internal "master" instance */
  StyleSheet.reset = function reset() {
    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    master = new StyleSheet(undefined, forceServer).rehydrate();
  };

  /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */


  StyleSheet.prototype.clone = function clone() {
    var sheet = new StyleSheet(this.target, this.forceServer);

    /* add to clone array */
    this.clones.push(sheet);

    /* clone all tags */
    sheet.tags = this.tags.map(function (tag) {
      var ids = tag.getIds();
      var newTag = tag.clone();

      /* reconstruct tagMap */
      for (var i = 0; i < ids.length; i += 1) {
        sheet.tagMap[ids[i]] = newTag;
      }

      return newTag;
    });

    /* clone other maps */
    sheet.rehydratedNames = _extends({}, this.rehydratedNames);
    sheet.deferred = _extends({}, this.deferred);

    return sheet;
  };

  /* force StyleSheet to create a new tag on the next injection */


  StyleSheet.prototype.sealAllTags = function sealAllTags() {
    this.capacity = 1;

    this.tags.forEach(function (tag) {
      // eslint-disable-next-line no-param-reassign
      tag.sealed = true;
    });
  };

  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
    var lastEl = tag ? tag.styleTag : null;
    var insertBefore = false;

    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
  };

  /* get a tag for a given componentId, assign the componentId to one, or shard */
  StyleSheet.prototype.getTagForId = function getTagForId(id) {
    /* simply return a tag, when the componentId was already assigned one */
    var prev = this.tagMap[id];
    if (prev !== undefined && !prev.sealed) {
      return prev;
    }

    var tag = this.tags[this.tags.length - 1];

    /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */
    this.capacity -= 1;

    if (this.capacity === 0) {
      this.capacity = MAX_SIZE;
      tag = this.makeTag(tag);
      this.tags.push(tag);
    }

    return this.tagMap[id] = tag;
  };

  /* mainly for injectGlobal to check for its id */


  StyleSheet.prototype.hasId = function hasId(id) {
    return this.tagMap[id] !== undefined;
  };

  /* caching layer checking id+name to already have a corresponding tag and injected rules */


  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
    /* exception for rehydrated names which are checked separately */
    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
      return true;
    }

    var tag = this.tagMap[id];
    return tag !== undefined && tag.hasNameForId(id, name);
  };

  /* registers a componentId and registers it on its tag */


  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
    /* don't inject when the id is already registered */
    if (this.tagMap[id] !== undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].deferredInject(id, cssRules);
    }

    this.getTagForId(id).insertMarker(id);
    this.deferred[id] = cssRules;
  };

  /* injects rules for a given id with a name that will need to be cached */


  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
    var clones = this.clones;


    for (var i = 0; i < clones.length; i += 1) {
      clones[i].inject(id, cssRules, name);
    }

    var tag = this.getTagForId(id);

    /* add deferred rules for component */
    if (this.deferred[id] !== undefined) {
      // Combine passed cssRules with previously deferred CSS rules
      // NOTE: We cannot mutate the deferred array itself as all clones
      // do the same (see clones[i].inject)
      var rules = this.deferred[id].concat(cssRules);
      tag.insertRules(id, rules, name);

      this.deferred[id] = undefined;
    } else {
      tag.insertRules(id, cssRules, name);
    }
  };

  /* removes all rules for a given id, which doesn't remove its marker but resets it */


  StyleSheet.prototype.remove = function remove(id) {
    var tag = this.tagMap[id];
    if (tag === undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].remove(id);
    }

    /* remove all rules from the tag */
    tag.removeRules(id);
    /* ignore possible rehydrated names */
    this.ignoreRehydratedNames[id] = true;
    /* delete possible deferred rules */
    this.deferred[id] = undefined;
  };

  StyleSheet.prototype.toHTML = function toHTML() {
    return this.tags.map(function (tag) {
      return tag.toHTML();
    }).join('');
  };

  StyleSheet.prototype.toReactElements = function toReactElements() {
    var id = this.id;


    return this.tags.map(function (tag, i) {
      var key = 'sc-' + id + '-' + i;
      return Object(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(tag.toElement(), { key: key });
    });
  };

  createClass(StyleSheet, null, [{
    key: 'master',
    get: function get$$1() {
      return master || (master = new StyleSheet().rehydrate());
    }

    /* NOTE: This is just for backwards-compatibility with jest-styled-components */

  }, {
    key: 'instance',
    get: function get$$1() {
      return StyleSheet.master;
    }
  }]);
  return StyleSheet;
}();

var _StyleSheetManager$ch;

var StyleSheetManager = function (_Component) {
  inherits(StyleSheetManager, _Component);

  function StyleSheetManager() {
    classCallCheck(this, StyleSheetManager);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  StyleSheetManager.prototype.getChildContext = function getChildContext() {
    var _ref;

    return _ref = {}, _ref[CONTEXT_KEY] = this.sheetInstance, _ref;
  };

  StyleSheetManager.prototype.componentWillMount = function componentWillMount() {
    if (this.props.sheet) {
      this.sheetInstance = this.props.sheet;
    } else if (this.props.target) {
      this.sheetInstance = new StyleSheet(this.props.target);
    } else {
      throw new StyledComponentsError(4);
    }
  };

  StyleSheetManager.prototype.render = function render() {
    /* eslint-disable react/prop-types */
    // Flow v0.43.1 will report an error accessing the `children` property,
    // but v0.47.0 will not. It is necessary to use a type cast instead of
    // a "fixme" comment to satisfy both Flow versions.
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.only(this.props.children);
  };

  return StyleSheetManager;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

StyleSheetManager.childContextTypes = (_StyleSheetManager$ch = {}, _StyleSheetManager$ch[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(ServerStyleSheet)]).isRequired, _StyleSheetManager$ch);
 false ? StyleSheetManager.propTypes = {
  sheet: PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]),
  target: PropTypes.shape({
    appendChild: PropTypes.func.isRequired
  })
} : void 0;

// 

var ServerStyleSheet = function () {
  function ServerStyleSheet() {
    classCallCheck(this, ServerStyleSheet);

    /* The master sheet might be reset, so keep a reference here */
    this.masterSheet = StyleSheet.master;
    this.instance = this.masterSheet.clone();
    this.closed = false;
  }

  ServerStyleSheet.prototype.complete = function complete() {
    if (!this.closed) {
      /* Remove closed StyleSheets from the master sheet */
      var index = this.masterSheet.clones.indexOf(this.instance);
      this.masterSheet.clones.splice(index, 1);
      this.closed = true;
    }
  };

  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
    if (this.closed) {
      throw new StyledComponentsError(2);
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      StyleSheetManager,
      { sheet: this.instance },
      children
    );
  };

  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
    this.complete();
    return this.instance.toHTML();
  };

  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
    this.complete();
    return this.instance.toReactElements();
  };

  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
    var _this = this;

    {
      throw new StyledComponentsError(3);
    }

    /* the tag index keeps track of which tags have already been emitted */
    var instance = this.instance;

    var instanceTagIndex = 0;

    var streamAttr = SC_STREAM_ATTR + '="true"';

    var transformer = new stream.Transform({
      transform: function appendStyleChunks(chunk, /* encoding */_, callback) {
        var tags = instance.tags;

        var html = '';

        /* retrieve html for each new style tag */
        for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
          var tag = tags[instanceTagIndex];
          html += tag.toHTML(streamAttr);
        }

        /* force our StyleSheets to emit entirely new tags */
        instance.sealAllTags();

        /* prepend style html to chunk */
        this.push(html + chunk);
        callback();
      }
    });

    readableStream.on('end', function () {
      return _this.complete();
    });
    readableStream.on('error', function (err) {
      _this.complete();

      // forward the error to the transform stream
      transformer.emit('error', err);
    });

    return readableStream.pipe(transformer);
  };

  return ServerStyleSheet;
}();

// 

var LIMIT = 200;

var createWarnTooManyClasses = (function (displayName) {
  var generatedClasses = {};
  var warningSeen = false;

  return function (className) {
    if (!warningSeen) {
      generatedClasses[className] = true;
      if (Object.keys(generatedClasses).length >= LIMIT) {
        // Unable to find latestRule in test environment.
        /* eslint-disable no-console, prefer-template */
        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
        warningSeen = true;
        generatedClasses = {};
      }
    }
  };
});

// 

var determineTheme = (function (props, fallbackTheme, defaultProps) {
  // Props should take precedence over ThemeProvider, which should take precedence over
  // defaultProps, but React automatically puts defaultProps on props.

  /* eslint-disable react/prop-types */
  var isDefaultTheme = defaultProps && props.theme === defaultProps.theme;
  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme;
  /* eslint-enable */

  return theme;
});

// 
var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var dashesAtEnds = /(^-|-$)/g;

/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */
function escape(str) {
  return str
  // Replace all possible CSS selectors
  .replace(escapeRegex, '-')

  // Remove extraneous hyphens at the start and end
  .replace(dashesAtEnds, '');
}

// 

function getComponentName(target) {
  return target.displayName || target.name || 'Component';
}

// 

function isTag(target) /* : %checks */{
  return typeof target === 'string';
}

// 

function generateDisplayName(target) {
  return isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')';
}

// 
/* eslint-disable max-len */
/**
 * Trying to avoid the unknown-prop errors on styled components by filtering by
 * React's attribute whitelist.
 *
 * To regenerate this regex:
 *
 * 1. `npm i -g regexgen` (https://github.com/devongovett/regexgen)
 * 2. Run `regexgen` with the list of space-separated words below as input
 * 3. Surround the emitted regex with this: `/^(GENERATED_REGEX)$/` -- this will ensure a full string match
 *    and no false positives from partials
 * */
/*
children dangerouslySetInnerHTML key ref autoFocus defaultValue valueLink defaultChecked checkedLink innerHTML suppressContentEditableWarning onFocusIn onFocusOut className onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown onKeyPress onKeyUp onFocus onBlur onChange onInput onInvalid onSubmit onReset onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onAnimationStart onAnimationEnd onAnimationIteration onTransitionEnd onCopyCapture onCutCapture onPasteCapture onCompositionEndCapture onCompositionStartCapture onCompositionUpdateCapture onKeyDownCapture onKeyPressCapture onKeyUpCapture onFocusCapture onBlurCapture onChangeCapture onInputCapture onSubmitCapture onResetCapture onClickCapture onContextMenuCapture onDoubleClickCapture onDragCapture onDragEndCapture onDragEnterCapture onDragExitCapture onDragLeaveCapture onDragOverCapture onDragStartCapture onDropCapture onMouseDownCapture onMouseEnterCapture onMouseLeaveCapture onMouseMoveCapture onMouseOutCapture onMouseOverCapture onMouseUpCapture onSelectCapture onTouchCancelCapture onTouchEndCapture onTouchMoveCapture onTouchStartCapture onScrollCapture onWheelCapture onAbortCapture onCanPlayCapture onCanPlayThroughCapture onDurationChangeCapture onEmptiedCapture onEncryptedCapture onEndedCapture onErrorCapture onLoadedDataCapture onLoadedMetadataCapture onLoadStartCapture onPauseCapture onPlayCapture onPlayingCapture onProgressCapture onRateChangeCapture onSeekedCapture onSeekingCapture onStalledCapture onSuspendCapture onTimeUpdateCapture onVolumeChangeCapture onWaitingCapture onLoadCapture onAnimationStartCapture onAnimationEndCapture onAnimationIterationCapture onTransitionEndCapture accept acceptCharset accessKey action allowFullScreen allowTransparency alt as async autoComplete autoPlay capture cellPadding cellSpacing charSet challenge checked cite classID className cols colSpan content contentEditable contextMenu controlsList controls coords crossOrigin data dateTime default defer dir disabled download draggable encType form formAction formEncType formMethod formNoValidate formTarget frameBorder headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media mediaGroup method min minLength multiple muted name nonce noValidate open optimum pattern placeholder playsInline poster preload profile radioGroup readOnly referrerPolicy rel required reversed role rows rowSpan sandbox scope scoped scrolling seamless selected shape size sizes span spellCheck src srcDoc srcLang srcSet start step style summary tabIndex target title type useMap value width wmode wrap about datatype inlist prefix property resource typeof vocab autoCapitalize autoCorrect autoSave color itemProp itemScope itemType itemID itemRef results security unselectable accentHeight accumulate additive alignmentBaseline allowReorder alphabetic amplitude arabicForm ascent attributeName attributeType autoReverse azimuth baseFrequency baseProfile baselineShift bbox begin bias by calcMode capHeight clip clipPath clipRule clipPathUnits colorInterpolation colorInterpolationFilters colorProfile colorRendering contentScriptType contentStyleType cursor cx cy d decelerate descent diffuseConstant direction display divisor dominantBaseline dur dx dy edgeMode elevation enableBackground end exponent externalResourcesRequired fill fillOpacity fillRule filter filterRes filterUnits floodColor floodOpacity focusable fontFamily fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontWeight format from fx fy g1 g2 glyphName glyphOrientationHorizontal glyphOrientationVertical glyphRef gradientTransform gradientUnits hanging horizAdvX horizOriginX ideographic imageRendering in in2 intercept k k1 k2 k3 k4 kernelMatrix kernelUnitLength kerning keyPoints keySplines keyTimes lengthAdjust letterSpacing lightingColor limitingConeAngle local markerEnd markerMid markerStart markerHeight markerUnits markerWidth mask maskContentUnits maskUnits mathematical mode numOctaves offset opacity operator order orient orientation origin overflow overlinePosition overlineThickness paintOrder panose1 pathLength patternContentUnits patternTransform patternUnits pointerEvents points pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits r radius refX refY renderingIntent repeatCount repeatDur requiredExtensions requiredFeatures restart result rotate rx ry scale seed shapeRendering slope spacing specularConstant specularExponent speed spreadMethod startOffset stdDeviation stemh stemv stitchTiles stopColor stopOpacity strikethroughPosition strikethroughThickness string stroke strokeDasharray strokeDashoffset strokeLinecap strokeLinejoin strokeMiterlimit strokeOpacity strokeWidth surfaceScale systemLanguage tableValues targetX targetY textAnchor textDecoration textRendering textLength to transform u1 u2 underlinePosition underlineThickness unicode unicodeBidi unicodeRange unitsPerEm vAlphabetic vHanging vIdeographic vMathematical values vectorEffect version vertAdvY vertOriginX vertOriginY viewBox viewTarget visibility widths wordSpacing writingMode x xHeight x1 x2 xChannelSelector xlinkActuate xlinkArcrole xlinkHref xlinkRole xlinkShow xlinkTitle xlinkType xmlBase xmlns xmlnsXlink xmlLang xmlSpace y y1 y2 yChannelSelector z zoomAndPan onPointerDown onPointerMove onPointerUp onPointerCancel onGotPointerCapture onLostPointerCapture onPointerEnter onPointerLeave onPointerOver onPointerOut class for autofocus allow allowUserMedia allowPaymentRequest
*/
/* eslint-enable max-len */

var ATTRIBUTE_REGEX = /^((?:s(?:uppressContentEditableWarn|croll|pac)|(?:shape|image|text)Render|(?:letter|word)Spac|vHang|hang)ing|(?:on(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:Animation|Touch|Load|Drag)Start|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|Lo(?:stPointer|ad)|TimeUpdate|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|GotPointer|MouseDown|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|KeyPress|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|P(?:rogress|laying)|DragEnd|Key(?:Down|Up)|(?:MouseU|Dro)p|(?:Wait|Seek)ing|Scroll|Focus|Paste|Abort|Drag|Play|Blur)Captur|alignmentBaselin|(?:limitingConeAng|xlink(?:(?:Arcr|R)o|Tit)|s(?:urfaceSca|ty|ca)|unselectab|baseProfi|fontSty|(?:focus|dragg)ab|multip|profi|tit)l|d(?:ominantBaselin|efaultValu)|onPointerLeav|a(?:uto(?:Capitaliz|Revers|Sav)|dditiv)|(?:(?:formNoValid|xlinkActu|noValid|accumul|rot)a|autoComple|decelera)t|(?:(?:attribute|item)T|datat)yp|onPointerMov|(?:attribute|glyph)Nam|playsInlin|(?:writing|input|edge)Mod|(?:formE|e)ncTyp|(?:amplitu|mo)d|(?:xlinkTy|itemSco|keyTy|slo)p|(?:xmlSpa|non)c|fillRul|(?:dateTi|na)m|r(?:esourc|ol)|xmlBas|wmod)e|(?:glyphOrientationHorizont|loc)al|(?:externalResourcesRequir|select|revers|mut)ed|c(?:o(?:lorInterpolationFilter|ord)s|o(?:lor(?:Interpolation)?|nt(?:rols|ent))|(?:ontentS(?:cript|tyle)Typ|o(?:ntentEditab|lorProfi)l|l(?:assNam|ipRul)|a(?:lcMod|ptur)|it)e|olorRendering|l(?:ipPathUnits|assID)|(?:ontrolsLis|apHeigh)t|h(?:eckedLink|a(?:llenge|rSet)|ildren|ecked)|ell(?:Spac|Padd)ing|o(?:ntextMenu|ls)|(?:rossOrigi|olSpa)n|l(?:ip(?:Path)?|ass)|ursor|[xy])|glyphOrientationVertical|d(?:angerouslySetInnerHTML|efaultChecked|ownload|isabled|isplay|[xy])|(?:s(?:trikethroughThickn|eaml)es|(?:und|ov)erlineThicknes|r(?:equiredExtension|adiu)|(?:requiredFeatur|tableValu|stitchTil|numOctav|filterR)e|key(?:(?:Splin|Tim)e|Param)|auto[Ff]ocu|header|bia)s|(?:(?:st(?:rikethroughPosi|dDevia)|(?:und|ov)erlinePosi|(?:textDecor|elev)a|orienta)tio|(?:strokeLinejo|orig)i|on(?:PointerDow|FocusI)|formActio|zoomAndPa|directio|(?:vers|act)io|rowSpa|begi|ico)n|o(?:n(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)|rient)|p(?:reserveAspectRatio|ointsAt[X-Z]|anose1)|(?:(?:allowPaymentReque|(?:fontSize|length)Adju|manife)s|strokeMiterlimi|(?:(?:specularE|e)xpon|renderingInt|asc)en|(?:specularConsta|repeatCou|fontVaria)n|d(?:iffuseConsta|esce)n|baselineShif|vectorEffec|onPointerOu|(?:(?:mar(?:ker|gin)|x)H|accentH|fontW)eigh|markerStar|a(?:utoCorrec|bou)|onFocusOu|intercep|restar|forma|inlis|heigh|lis)t|(?:patternContent|ma(?:sk(?:Content)?|rker)|primitive|gradient|pattern|filter)Units|(?:(?:allowTranspar|baseFrequ)enc|re(?:ferrerPolic|adOnl)|(?:(?:st(?:roke|op)O|floodO|fillO|o)pac|integr|secur)it|visibilit|fontFamil|accessKe|propert|summar)y|(?:gradientT|patternT|t)ransform|(?:(?:st(?:rokeDasho|artO)|o)ffs|acceptChars|formTarg|viewTarg|srcS)et|(?:[xy]ChannelSelect|lightingCol|textAnch|floodCol|stopCol|operat|htmlF)or|(?:(?:enableBackgrou|markerE)n|s(?:p(?:readMetho|ee)|ee)|formMetho|(?:markerM|onInval)i|preloa|metho|kin)d|k(?:ernel(?:UnitLength|Matrix)|[1-4])|strokeDasharray|(?:onPointerCanc|lab)el|(?:allowFullScre|hidd)en|a(?:l(?:lowUserMedia|phabetic|t)|rabicForm|sync)|systemLanguage|(?:(?:o(?:nPointer(?:Ent|Ov)|rd)|allowReord|placehold|frameBord|paintOrd|post)e|repeatDu|d(?:efe|u))r|(?:pointerEve|keyPoi)nts|preserveAlpha|(?:strokeLineca|onPointerU|itemPro|useMa|wra|loo)p|v(?:Mathematical|ert(?:Origin[XY]|AdvY)|alues|ocab)|unicodeRange|h(?:oriz(?:Origin|Adv)X|ttpEquiv)|(?:vI|i)deographic|mathematical|u(?:nicodeBidi|[12])|(?:fontStretc|hig)h|vAlphabetic|(?:(?:mar(?:ker|gin)W|strokeW)id|azimu)th|(?:xmlnsXl|valueL)ink|mediaGroup|spellCheck|(?:text|m(?:in|ax))Length|(?:unitsPerE|optimu|fro)m|r(?:adioGroup|e(?:sults|f[XY]|l)|ows|[xy])|pathLength|(?:xlinkHr|glyphR)ef|innerHTML|xlinkShow|f(?:o(?:ntSize|rm?)|il(?:ter|l))|(?:tabInde|(?:sand|b)bo|viewBo)x|autoPlay|r(?:e(?:quired|sult|f))?|(?:(?:href|xml|src)La|kerni)ng|o(?:verflow|pen)|i(?:temRef|n2|s)|p(?:attern|oints)|unicode|d(?:efault|ata|ir)?|divisor|t(?:arget[XY]|o)|(?:stri|la)ng|(?:width|size)s|prefix|typeof|srcDoc|s(?:coped|te(?:m[hv]|p)|pan)|s(?:t(?:roke|art)|hape|cope|rc)|a(?:ccept|llow|s)|itemID|t(?:arget|ype)|m(?:edia|a(?:sk|x)|in)|value|width|x(?:mlns)?|size|href|k(?:ey)?|end|low|by|x[12]|y[12]|g[12]|i[dn]|f[xy]|[yz])$/;
/* From DOMProperty */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(x|data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));

var validAttr = (function (name) {
  return ATTRIBUTE_REGEX.test(name) || isCustomAttribute(name.toLowerCase());
});

// 

function hasInInheritanceChain(child, parent) {
  var target = child;

  while (target) {
    target = Object.getPrototypeOf(target);

    if (target && target === parent) {
      return true;
    }
  }

  return false;
}

// 
/**
 * Creates a broadcast that can be listened to, i.e. simple event emitter
 *
 * @see https://github.com/ReactTraining/react-broadcast
 */

var createBroadcast = function createBroadcast(initialState) {
  var listeners = {};
  var id = 0;
  var state = initialState;

  function publish(nextState) {
    state = nextState;

    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in listeners) {
      var listener = listeners[key];
      if (listener === undefined) {
        // eslint-disable-next-line no-continue
        continue;
      }

      listener(state);
    }
  }

  function subscribe(listener) {
    var currentId = id;
    listeners[currentId] = listener;
    id += 1;
    listener(state);
    return currentId;
  }

  function unsubscribe(unsubID) {
    listeners[unsubID] = undefined;
  }

  return { publish: publish, subscribe: subscribe, unsubscribe: unsubscribe };
};

var _contextShape, _ThemeProvider$contex;

// NOTE: DO NOT CHANGE, changing this is a semver major change!
var CHANNEL = '__styled-components__';
var CHANNEL_NEXT = CHANNEL + 'next__';

var CONTEXT_CHANNEL_SHAPE = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
  getTheme: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  subscribe: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  unsubscribe: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
});

var contextShape = (_contextShape = {}, _contextShape[CHANNEL] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, _contextShape[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _contextShape);

var warnChannelDeprecated = void 0;
if (false) {
  warnChannelDeprecated = once(function () {
    // eslint-disable-next-line no-console
    console.warn('Warning: Usage of `context.' + CHANNEL + '` as a function is deprecated. It will be replaced with the object on `.context.' + CHANNEL_NEXT + '` in a future version.');
  });
}

var isFunction = function isFunction(test) {
  return typeof test === 'function';
};

/**
 * Provide a theme to an entire react component tree via context and event listeners (have to do
 * both context and event emitter as pure components block context updates)
 */

var ThemeProvider = function (_Component) {
  inherits(ThemeProvider, _Component);

  function ThemeProvider() {
    classCallCheck(this, ThemeProvider);

    var _this = possibleConstructorReturn(this, _Component.call(this));

    _this.unsubscribeToOuterId = -1;

    _this.getTheme = _this.getTheme.bind(_this);
    return _this;
  }

  ThemeProvider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
    // with the outer theme
    var outerContext = this.context[CHANNEL_NEXT];
    if (outerContext !== undefined) {
      this.unsubscribeToOuterId = outerContext.subscribe(function (theme) {
        _this2.outerTheme = theme;

        if (_this2.broadcast !== undefined) {
          _this2.publish(_this2.props.theme);
        }
      });
    }

    this.broadcast = createBroadcast(this.getTheme());
  };

  ThemeProvider.prototype.getChildContext = function getChildContext() {
    var _this3 = this,
        _babelHelpers$extends;

    return _extends({}, this.context, (_babelHelpers$extends = {}, _babelHelpers$extends[CHANNEL_NEXT] = {
      getTheme: this.getTheme,
      subscribe: this.broadcast.subscribe,
      unsubscribe: this.broadcast.unsubscribe
    }, _babelHelpers$extends[CHANNEL] = function (subscriber) {
      if (false) {
        warnChannelDeprecated();
      }

      // Patch the old `subscribe` provide via `CHANNEL` for older clients.
      var unsubscribeId = _this3.broadcast.subscribe(subscriber);
      return function () {
        return _this3.broadcast.unsubscribe(unsubscribeId);
      };
    }, _babelHelpers$extends));
  };

  ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.theme !== nextProps.theme) {
      this.publish(nextProps.theme);
    }
  };

  ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribeToOuterId !== -1) {
      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
    }
  };

  // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation


  ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
    var theme = passedTheme || this.props.theme;

    if (isFunction(theme)) {
      var mergedTheme = theme(this.outerTheme);

      if (false) {
        throw new StyledComponentsError(7);
      }

      return mergedTheme;
    }

    if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : _typeof(theme)) !== 'object') {
      throw new StyledComponentsError(8);
    }

    return _extends({}, this.outerTheme, theme);
  };

  ThemeProvider.prototype.publish = function publish(theme) {
    this.broadcast.publish(this.getTheme(theme));
  };

  ThemeProvider.prototype.render = function render() {
    if (!this.props.children) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.only(this.props.children);
  };

  return ThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

ThemeProvider.childContextTypes = contextShape;
ThemeProvider.contextTypes = (_ThemeProvider$contex = {}, _ThemeProvider$contex[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$contex);

var _babelHelpers$extends;

// HACK for generating all static styles without needing to allocate
// an empty execution context every single time...
var STATIC_EXECUTION_CONTEXT = {};

var modifiedContextShape = _extends({}, contextShape, (_babelHelpers$extends = {}, _babelHelpers$extends[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(ServerStyleSheet)]), _babelHelpers$extends));

var identifiers = {};

/* We depend on components having unique IDs */
var generateId = function generateId(ComponentStyle, _displayName, parentComponentId) {
  var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);

  /**
   * This ensures uniqueness if two components happen to share
   * the same displayName.
   */
  var nr = (identifiers[displayName] || 0) + 1;
  identifiers[displayName] = nr;

  var componentId = displayName + '-' + ComponentStyle.generateName(displayName + nr);

  return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
};

var warnExtendDeprecated = function warnExtendDeprecated() {};
if (false) {
  warnExtendDeprecated = once(function () {
    // eslint-disable-next-line no-console
    console.warn('Warning: The "extend" API will be removed in the upcoming v4.0 release. Use styled(StyledComponent) instead. You can find more information here: https://github.com/styled-components/styled-components/issues/1546');
  });
}

// $FlowFixMe

var BaseStyledComponent = function (_Component) {
  inherits(BaseStyledComponent, _Component);

  function BaseStyledComponent() {
    var _temp, _this, _ret;

    classCallCheck(this, BaseStyledComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.attrs = {}, _this.state = {
      theme: null,
      generatedClassName: ''
    }, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
  }

  BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
    if (this.unsubscribeId !== -1) {
      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
    }
  };

  BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
    var attrs = this.constructor.attrs;

    var context = _extends({}, props, { theme: theme });
    if (attrs === undefined) {
      return context;
    }

    this.attrs = Object.keys(attrs).reduce(function (acc, key) {
      var attr = attrs[key];

      // eslint-disable-next-line no-param-reassign
      acc[key] = typeof attr === 'function' && !hasInInheritanceChain(attr, __WEBPACK_IMPORTED_MODULE_1_react__["Component"]) ? attr(context) : attr;
      return acc;
    }, {});

    return _extends({}, context, this.attrs);
  };

  BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
    var _constructor = this.constructor,
        attrs = _constructor.attrs,
        componentStyle = _constructor.componentStyle,
        warnTooManyClasses = _constructor.warnTooManyClasses;

    var styleSheet = this.context[CONTEXT_KEY] || StyleSheet.master;

    // statically styled-components don't need to build an execution context object,
    // and shouldn't be increasing the number of class names
    if (componentStyle.isStatic && attrs === undefined) {
      return componentStyle.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, styleSheet);
    } else {
      var executionContext = this.buildExecutionContext(theme, props);
      var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);

      if (false) {
        warnTooManyClasses(className);
      }

      return className;
    }
  };

  BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var componentStyle = this.constructor.componentStyle;

    var styledContext = this.context[CHANNEL_NEXT];

    // If this is a statically-styled component, we don't need to the theme
    // to generate or build styles.
    if (componentStyle.isStatic) {
      var generatedClassName = this.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, this.props);
      this.setState({ generatedClassName: generatedClassName });
      // If there is a theme in the context, subscribe to the event emitter. This
      // is necessary due to pure components blocking context updates, this circumvents
      // that by updating when an event is emitted
    } else if (styledContext !== undefined) {
      var subscribe = styledContext.subscribe;

      this.unsubscribeId = subscribe(function (nextTheme) {
        // This will be called once immediately
        var theme = determineTheme(_this2.props, nextTheme, _this2.constructor.defaultProps);

        var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);

        _this2.setState({ theme: theme, generatedClassName: generatedClassName });
      });
    } else {
      // eslint-disable-next-line react/prop-types
      var theme = this.props.theme || EMPTY_OBJECT;
      var _generatedClassName = this.generateAndInjectStyles(theme, this.props);
      this.setState({ theme: theme, generatedClassName: _generatedClassName });
    }
  };

  BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this3 = this;

    // If this is a statically-styled component, we don't need to listen to
    // props changes to update styles
    var componentStyle = this.constructor.componentStyle;

    if (componentStyle.isStatic) {
      return;
    }

    this.setState(function (prevState) {
      var theme = determineTheme(nextProps, prevState.theme, _this3.constructor.defaultProps);
      var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);

      return { theme: theme, generatedClassName: generatedClassName };
    });
  };

  BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unsubscribeFromContext();
  };

  BaseStyledComponent.prototype.render = function render() {
    // eslint-disable-next-line react/prop-types
    var innerRef = this.props.innerRef;
    var generatedClassName = this.state.generatedClassName;
    var _constructor2 = this.constructor,
        styledComponentId = _constructor2.styledComponentId,
        target = _constructor2.target;


    var isTargetTag = isTag(target);

    var className = [
    // eslint-disable-next-line react/prop-types
    this.props.className, styledComponentId, this.attrs.className, generatedClassName].filter(Boolean).join(' ');

    var baseProps = _extends({}, this.attrs, {
      className: className
    });

    if (isStyledComponent(target)) {
      baseProps.innerRef = innerRef;
    } else {
      baseProps.ref = innerRef;
    }

    var propsForElement = baseProps;
    var key = void 0;

    for (key in this.props) {
      // Don't pass through non HTML tags through to HTML elements
      // always omit innerRef
      if (key !== 'innerRef' && key !== 'className' && (!isTargetTag || validAttr(key))) {
        propsForElement[key] = key === 'style' && key in this.attrs ? _extends({}, this.attrs[key], this.props[key]) : this.props[key];
      }
    }

    return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(target, propsForElement);
  };

  return BaseStyledComponent;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var _StyledComponent = (function (ComponentStyle, constructWithOptions) {
  var createStyledComponent = function createStyledComponent(target, options, rules) {
    var _options$isClass = options.isClass,
        isClass = _options$isClass === undefined ? !isTag(target) : _options$isClass,
        _options$displayName = options.displayName,
        displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName,
        _options$componentId = options.componentId,
        componentId = _options$componentId === undefined ? generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId,
        _options$ParentCompon = options.ParentComponent,
        ParentComponent = _options$ParentCompon === undefined ? BaseStyledComponent : _options$ParentCompon,
        extendingRules = options.rules,
        attrs = options.attrs;


    var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;

    var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), attrs, styledComponentId);

    var StyledComponent = function (_ParentComponent) {
      inherits(StyledComponent, _ParentComponent);

      function StyledComponent() {
        classCallCheck(this, StyledComponent);
        return possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
      }

      StyledComponent.withComponent = function withComponent(tag) {
        var previousComponentId = options.componentId,
            optionsToCopy = objectWithoutProperties(options, ['componentId']);


        var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));

        var newOptions = _extends({}, optionsToCopy, {
          componentId: newComponentId,
          ParentComponent: StyledComponent
        });

        return createStyledComponent(tag, newOptions, rules);
      };

      createClass(StyledComponent, null, [{
        key: 'extend',
        get: function get$$1() {
          var rulesFromOptions = options.rules,
              parentComponentId = options.componentId,
              optionsToCopy = objectWithoutProperties(options, ['rules', 'componentId']);


          var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);

          var newOptions = _extends({}, optionsToCopy, {
            rules: newRules,
            parentComponentId: parentComponentId,
            ParentComponent: StyledComponent
          });

          warnExtendDeprecated();

          return constructWithOptions(createStyledComponent, target, newOptions);
        }
      }]);
      return StyledComponent;
    }(ParentComponent);

    StyledComponent.attrs = attrs;
    StyledComponent.componentStyle = componentStyle;
    StyledComponent.contextTypes = modifiedContextShape;
    StyledComponent.displayName = displayName;
    StyledComponent.styledComponentId = styledComponentId;
    StyledComponent.target = target;


    if (false) {
      StyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
    }

    if (isClass) {
      __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(StyledComponent, target, {
        // all SC-specific things should not be hoisted
        attrs: true,
        componentStyle: true,
        displayName: true,
        extend: true,
        styledComponentId: true,
        target: true,
        warnTooManyClasses: true,
        withComponent: true
      });
    }

    return StyledComponent;
  };

  return createStyledComponent;
});

// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash(str) {
  var l = str.length | 0,
      h = l | 0,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;

    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);

    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;

    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;

  return h >>> 0;
}

// 

var areStylesCacheable = IS_BROWSER;

var isStaticRules = function isStaticRules(rules, attrs) {
  for (var i = 0, len = rules.length; i < len; i += 1) {
    var rule = rules[i];

    // recursive case
    if (Array.isArray(rule) && !isStaticRules(rule)) {
      return false;
    } else if (typeof rule === 'function' && !isStyledComponent(rule)) {
      // functions are allowed to be static if they're just being
      // used to get the classname of a nested styled component
      return false;
    }
  }

  if (attrs !== undefined) {
    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in attrs) {
      if (typeof attrs[key] === 'function') {
        return false;
      }
    }
  }

  return true;
};

var isHMREnabled = typeof module !== 'undefined' && module.hot && "production" !== 'production';

/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */
var _ComponentStyle = (function (nameGenerator, flatten, stringifyRules) {
  /* combines hashStr (murmurhash) and nameGenerator for convenience */
  var generateRuleHash = function generateRuleHash(str) {
    return nameGenerator(murmurhash(str));
  };

  var ComponentStyle = function () {
    function ComponentStyle(rules, attrs, componentId) {
      classCallCheck(this, ComponentStyle);

      this.rules = rules;
      this.isStatic = !isHMREnabled && isStaticRules(rules, attrs);
      this.componentId = componentId;

      if (!StyleSheet.master.hasId(componentId)) {
        var placeholder =  false ? ['.' + componentId + ' {}'] : [];

        StyleSheet.master.deferredInject(componentId, placeholder);
      }
    }

    /*
     * Flattens a rule set into valid CSS
     * Hashes it, wraps the whole chunk in a .hash1234 {}
     * Returns the hash to be injected on render()
     * */


    ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
      var isStatic = this.isStatic,
          componentId = this.componentId,
          lastClassName = this.lastClassName;

      if (areStylesCacheable && isStatic && lastClassName !== undefined && styleSheet.hasNameForId(componentId, lastClassName)) {
        return lastClassName;
      }

      var flatCSS = flatten(this.rules, executionContext);
      var name = generateRuleHash(this.componentId + flatCSS.join(''));

      if (!styleSheet.hasNameForId(componentId, name)) {
        styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name), name);
      }

      this.lastClassName = name;
      return name;
    };

    ComponentStyle.generateName = function generateName(str) {
      return generateRuleHash(str);
    };

    return ComponentStyle;
  }();

  return ComponentStyle;
});

// 
// Thanks to ReactDOMFactories for this handy list!

var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',

// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

// 

var _styled = (function (styledComponent, constructWithOptions) {
  var styled = function styled(tag) {
    return constructWithOptions(styledComponent, tag);
  };

  // Shorthands for all valid HTML Elements
  domElements.forEach(function (domElement) {
    styled[domElement] = styled(domElement);
  });

  return styled;
});

// 

var replaceWhitespace = function replaceWhitespace(str) {
  return str.replace(/\s|\\n/g, '');
};

var _keyframes = (function (nameGenerator, stringifyRules, css) {
  return function () {
    var styleSheet = StyleSheet.master;
    var rules = css.apply(undefined, arguments);
    var name = nameGenerator(murmurhash(replaceWhitespace(JSON.stringify(rules))));
    var id = 'sc-keyframes-' + name;

    if (!styleSheet.hasNameForId(id, name)) {
      styleSheet.inject(id, stringifyRules(rules, name, '@keyframes'), name);
    }

    return name;
  };
});

// 

var _injectGlobal = (function (stringifyRules, css) {
  var injectGlobal = function injectGlobal() {
    var styleSheet = StyleSheet.master;
    var rules = css.apply(undefined, arguments);
    var hash = murmurhash(JSON.stringify(rules));
    var id = 'sc-global-' + hash;

    if (!styleSheet.hasId(id)) {
      styleSheet.inject(id, stringifyRules(rules));
    }
  };

  return injectGlobal;
});

// 

var _constructWithOptions = (function (css) {
  var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

    if (!Object(__WEBPACK_IMPORTED_MODULE_6_react_is__["isValidElementType"])(tag)) {
      throw new StyledComponentsError(1, String(tag));
    }

    /* This is callable directly as a template function */
    // $FlowFixMe: Not typed to avoid destructuring arguments
    var templateFunction = function templateFunction() {
      return componentConstructor(tag, options, css.apply(undefined, arguments));
    };

    /* If config methods are called, wrap up a new template function and merge options */
    templateFunction.withConfig = function (config) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
    };
    templateFunction.attrs = function (attrs) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, {
        attrs: _extends({}, options.attrs || EMPTY_OBJECT, attrs)
      }));
    };

    return templateFunction;
  };

  return constructWithOptions;
});

// 

var withTheme = (function (Component$$1) {
  var isStatelessFunctionalComponent = typeof Component$$1 === 'function' &&
  // $FlowFixMe TODO: flow for prototype
  !(Component$$1.prototype && 'isReactComponent' in Component$$1.prototype);

  // NOTE: We can't pass a ref to a stateless functional component
  var shouldSetInnerRef = isStyledComponent(Component$$1) || isStatelessFunctionalComponent;

  var WithTheme = function (_React$Component) {
    inherits(WithTheme, _React$Component);

    function WithTheme() {
      var _temp, _this, _ret;

      classCallCheck(this, WithTheme);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = EMPTY_OBJECT, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
    }

    // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping


    WithTheme.prototype.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var defaultProps = this.constructor.defaultProps;

      var styledContext = this.context[CHANNEL_NEXT];
      var themeProp = determineTheme(this.props, undefined, defaultProps);
      if (styledContext === undefined && themeProp === undefined && "production" !== 'production') {
        // eslint-disable-next-line no-console
        console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps');
      } else if (styledContext === undefined && themeProp !== undefined) {
        this.setState({ theme: themeProp });
      } else {
        var subscribe = styledContext.subscribe;

        this.unsubscribeId = subscribe(function (nextTheme) {
          var theme = determineTheme(_this2.props, nextTheme, defaultProps);
          _this2.setState({ theme: theme });
        });
      }
    };

    WithTheme.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var defaultProps = this.constructor.defaultProps;

      this.setState(function (oldState) {
        var theme = determineTheme(nextProps, oldState.theme, defaultProps);

        return { theme: theme };
      });
    };

    WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.unsubscribeId !== -1) {
        this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
      }
    };

    WithTheme.prototype.render = function render() {
      var props = _extends({
        theme: this.state.theme
      }, this.props);

      if (!shouldSetInnerRef) {
        props.ref = props.innerRef;
        delete props.innerRef;
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component$$1, props);
    };

    return WithTheme;
  }(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

  WithTheme.contextTypes = contextShape;
  WithTheme.displayName = 'WithTheme(' + getComponentName(Component$$1) + ')';
  WithTheme.styledComponentId = 'withTheme';


  return __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(WithTheme, Component$$1);
});

// 

/* eslint-disable */
var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
  StyleSheet: StyleSheet
};

// 

/* Warning if you've imported this file on React Native */
if (false) {
  // eslint-disable-next-line no-console
  console.warn("It looks like you've imported 'styled-components' on React Native.\n" + "Perhaps you're looking to import 'styled-components/native'?\n" + 'Read more about this at https://www.styled-components.com/docs/basics#react-native');
}

/* Warning if there are several instances of styled-components */
if (false) {
  window['__styled-components-init__'] = window['__styled-components-init__'] || 0;

  if (window['__styled-components-init__'] === 1) {
    // eslint-disable-next-line no-console
    console.warn("It looks like there are several instances of 'styled-components' initialized in this application. " + 'This may cause dynamic styles not rendering properly, errors happening during rehydration process ' + 'and makes your application bigger without a good reason.\n\n' + 'See https://s-c.sh/2BAXzed for more info.');
  }

  window['__styled-components-init__'] += 1;
}

/* Instantiate singletons */
var ComponentStyle = _ComponentStyle(generateAlphabeticName, flatten, stringifyRules);
var constructWithOptions = _constructWithOptions(css);
var StyledComponent = _StyledComponent(ComponentStyle, constructWithOptions);

/* Instantiate exported singletons */
var keyframes = _keyframes(generateAlphabeticName, stringifyRules, css);
var injectGlobal = _injectGlobal(stringifyRules, css);
var styled = _styled(StyledComponent, constructWithOptions);

/* harmony default export */ __webpack_exports__["a"] = (styled);

//# sourceMappingURL=styled-components.browser.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(147), __webpack_require__(1825)(module)))

/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(2187)["default"];

var assertThisInitialized = __webpack_require__(50);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 50 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 51 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(2188);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Link_index__ = __webpack_require__(1713);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Link_index__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "LinkBase", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Link_index__["b"]; });

//# sourceMappingURL=Link.js.map

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Callout_index__ = __webpack_require__(697);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Callout_index__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Callout_index__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Callout_index__["c"]; });

//# sourceMappingURL=Callout.js.map

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Grid__ = __webpack_require__(866);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Grid__["a"]; });
/* unused harmony reexport Grid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessibilityOverscanIndicesGetter__ = __webpack_require__(2196);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__accessibilityOverscanIndicesGetter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultCellRangeRenderer__ = __webpack_require__(869);
/* unused harmony reexport defaultCellRangeRenderer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaultOverscanIndicesGetter__ = __webpack_require__(868);
/* unused harmony reexport defaultOverscanIndicesGetter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(15);
/* unused harmony reexport bpfrpt_proptype_NoContentRenderer */
/* unused harmony reexport bpfrpt_proptype_Alignment */
/* unused harmony reexport bpfrpt_proptype_CellPosition */
/* unused harmony reexport bpfrpt_proptype_CellSize */
/* unused harmony reexport bpfrpt_proptype_OverscanIndicesGetter */
/* unused harmony reexport bpfrpt_proptype_RenderedSection */
/* unused harmony reexport bpfrpt_proptype_CellRendererParams */
/* unused harmony reexport bpfrpt_proptype_Scroll */






















/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dropdown_index__ = __webpack_require__(1796);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Dropdown_index__["a"]; });

//# sourceMappingURL=Dropdown.js.map

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DetailsList_index__ = __webpack_require__(1686);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_DetailsList_index__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__components_DetailsList_index__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__components_DetailsList_index__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__components_DetailsList_index__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__components_DetailsList_index__["e"]; });

//# sourceMappingURL=DetailsList.js.map

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(25);
var createDesc = __webpack_require__(124);
module.exports = __webpack_require__(23) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(14);
var hide = __webpack_require__(58);
var has = __webpack_require__(63);
var SRC = __webpack_require__(125)('src');
var $toString = __webpack_require__(1135);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(70).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var fails = __webpack_require__(16);
var defined = __webpack_require__(93);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Async__ = __webpack_require__(635);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Async__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AutoScroll__ = __webpack_require__(1573);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__AutoScroll__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseComponent__ = __webpack_require__(1574);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__BaseComponent__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return __WEBPACK_IMPORTED_MODULE_2__BaseComponent__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Context__ = __webpack_require__(1576);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return __WEBPACK_IMPORTED_MODULE_3__Context__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DelayedRender__ = __webpack_require__(1577);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_4__DelayedRender__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EventGroup__ = __webpack_require__(258);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_5__EventGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FabricPerformance__ = __webpack_require__(1578);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__GlobalSettings__ = __webpack_require__(643);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_7__GlobalSettings__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__KeyCodes__ = __webpack_require__(384);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_8__KeyCodes__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Rectangle__ = __webpack_require__(1579);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_9__Rectangle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__appendFunction__ = __webpack_require__(644);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__aria__ = __webpack_require__(1580);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return __WEBPACK_IMPORTED_MODULE_11__aria__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__array__ = __webpack_require__(1581);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_12__array__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_12__array__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_12__array__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_12__array__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return __WEBPACK_IMPORTED_MODULE_12__array__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return __WEBPACK_IMPORTED_MODULE_12__array__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__asAsync__ = __webpack_require__(1582);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assertNever__ = __webpack_require__(1583);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_14__assertNever__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__autobind__ = __webpack_require__(1584);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_15__autobind__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__classNamesFunction__ = __webpack_require__(1585);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_16__classNamesFunction__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__createRef__ = __webpack_require__(1586);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_17__createRef__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__css__ = __webpack_require__(1587);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_18__css__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__customizations_Customizations__ = __webpack_require__(260);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_19__customizations_Customizations__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__customizations_Customizer__ = __webpack_require__(1588);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_20__customizations_Customizer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__customizations_CustomizerContext__ = __webpack_require__(261);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_21__customizations_CustomizerContext__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__customizations_customizable__ = __webpack_require__(1589);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_22__customizations_customizable__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__customizations_mergeCustomizations__ = __webpack_require__(645);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__customizations_mergeSettings__ = __webpack_require__(646);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return __WEBPACK_IMPORTED_MODULE_24__customizations_mergeSettings__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__dom__ = __webpack_require__(1590);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_25__dom__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_25__dom__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_25__dom__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return __WEBPACK_IMPORTED_MODULE_25__dom__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return __WEBPACK_IMPORTED_MODULE_25__dom__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return __WEBPACK_IMPORTED_MODULE_25__dom__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return __WEBPACK_IMPORTED_MODULE_25__dom__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return __WEBPACK_IMPORTED_MODULE_25__dom__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return __WEBPACK_IMPORTED_MODULE_25__dom__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return __WEBPACK_IMPORTED_MODULE_25__dom__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return __WEBPACK_IMPORTED_MODULE_25__dom__["k"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__extendComponent__ = __webpack_require__(263);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__focus__ = __webpack_require__(1596);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_27__focus__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_27__focus__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_27__focus__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_27__focus__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_27__focus__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_27__focus__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_27__focus__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_27__focus__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_27__focus__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return __WEBPACK_IMPORTED_MODULE_27__focus__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return __WEBPACK_IMPORTED_MODULE_27__focus__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return __WEBPACK_IMPORTED_MODULE_27__focus__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return __WEBPACK_IMPORTED_MODULE_27__focus__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return __WEBPACK_IMPORTED_MODULE_27__focus__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return __WEBPACK_IMPORTED_MODULE_27__focus__["o"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__hoist__ = __webpack_require__(1597);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return __WEBPACK_IMPORTED_MODULE_28__hoist__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return __WEBPACK_IMPORTED_MODULE_28__hoist__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__hoistStatics__ = __webpack_require__(647);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return __WEBPACK_IMPORTED_MODULE_29__hoistStatics__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__initializeComponentRef__ = __webpack_require__(1598);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return __WEBPACK_IMPORTED_MODULE_30__initializeComponentRef__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__initializeFocusRects__ = __webpack_require__(641);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_31__initializeFocusRects__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return __WEBPACK_IMPORTED_MODULE_31__initializeFocusRects__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__initials__ = __webpack_require__(1599);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_32__initials__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__keyboard__ = __webpack_require__(642);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return __WEBPACK_IMPORTED_MODULE_33__keyboard__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__language__ = __webpack_require__(1600);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_34__language__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__math__ = __webpack_require__(1602);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_35__math__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_35__math__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return __WEBPACK_IMPORTED_MODULE_35__math__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__memoize__ = __webpack_require__(1603);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return __WEBPACK_IMPORTED_MODULE_36__memoize__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__merge__ = __webpack_require__(1604);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return __WEBPACK_IMPORTED_MODULE_37__merge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__mobileDetector__ = __webpack_require__(1605);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return __WEBPACK_IMPORTED_MODULE_38__mobileDetector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__object__ = __webpack_require__(383);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_39__object__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_39__object__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return __WEBPACK_IMPORTED_MODULE_39__object__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return __WEBPACK_IMPORTED_MODULE_39__object__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return __WEBPACK_IMPORTED_MODULE_39__object__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__osDetector__ = __webpack_require__(1606);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return __WEBPACK_IMPORTED_MODULE_40__osDetector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__overflow__ = __webpack_require__(1607);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return __WEBPACK_IMPORTED_MODULE_41__overflow__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__properties__ = __webpack_require__(1608);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_42__properties__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_42__properties__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_42__properties__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_42__properties__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return __WEBPACK_IMPORTED_MODULE_42__properties__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return __WEBPACK_IMPORTED_MODULE_42__properties__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return __WEBPACK_IMPORTED_MODULE_42__properties__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return __WEBPACK_IMPORTED_MODULE_42__properties__["h"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__resources__ = __webpack_require__(1609);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__rtl__ = __webpack_require__(1610);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return __WEBPACK_IMPORTED_MODULE_44__rtl__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return __WEBPACK_IMPORTED_MODULE_44__rtl__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__safeRequestAnimationFrame__ = __webpack_require__(1612);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return __WEBPACK_IMPORTED_MODULE_45__safeRequestAnimationFrame__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__safeSetTimeout__ = __webpack_require__(1613);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__scroll__ = __webpack_require__(636);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_47__scroll__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_47__scroll__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_47__scroll__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_47__scroll__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return __WEBPACK_IMPORTED_MODULE_47__scroll__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__selection_index__ = __webpack_require__(1614);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_48__selection_index__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_48__selection_index__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_48__selection_index__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__string__ = __webpack_require__(1616);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_49__string__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__styled__ = __webpack_require__(1617);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return __WEBPACK_IMPORTED_MODULE_50__styled__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__warn__ = __webpack_require__(1618);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return __WEBPACK_IMPORTED_MODULE_51__warn__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return __WEBPACK_IMPORTED_MODULE_51__warn__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__setFocusVisibility__ = __webpack_require__(1619);
/* unused harmony reexport setFocusVisibility */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__dom_setSSR__ = __webpack_require__(382);
/* unused harmony reexport setSSR */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__version__ = __webpack_require__(1620);























































//# sourceMappingURL=index.js.map

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DynamicComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_loadable_component__ = __webpack_require__(1785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_moment_timezone__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Empty__ = __webpack_require__(1790);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var dynamicImport=function dynamicImport(_ref){var tenant=_ref.tenant,component=_ref.component,_ref$fallback=_ref.fallback,fallback=_ref$fallback===undefined?__WEBPACK_IMPORTED_MODULE_3__Empty__["a" /* default */]:_ref$fallback;tenant=tenant||"propnow";component=component.startsWith('/')?component:'/'+component;return Object(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_loadable_component__["a" /* default */])(function(){return __webpack_require__(1791)("./@"+tenant+component).catch(function(){return fallback;});});};/* harmony default export */ __webpack_exports__["b"] = (dynamicImport);var DynamicComponent=function(_Component){_inherits(DynamicComponent,_Component);function DynamicComponent(props){_classCallCheck(this,DynamicComponent);var _this=_possibleConstructorReturn(this,(DynamicComponent.__proto__||Object.getPrototypeOf(DynamicComponent)).call(this,props));__WEBPACK_IMPORTED_MODULE_1__build_node_modules_moment_timezone___default.a.locale(props.intl.locale);return _this;}return DynamicComponent;}(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_react__["Component"]);

/***/ }),
/* 63 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(165);
var defined = __webpack_require__(93);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(166);
var createDesc = __webpack_require__(124);
var toIObject = __webpack_require__(64);
var toPrimitive = __webpack_require__(92);
var has = __webpack_require__(63);
var IE8_DOM_DEFINE = __webpack_require__(495);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(23) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(63);
var toObject = __webpack_require__(27);
var IE_PROTO = __webpack_require__(325)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["a"] = loadStyles;
/* unused harmony export configureLoadStyles */
/* unused harmony export configureRunMode */
/* unused harmony export flush */
/* harmony export (immutable) */ __webpack_exports__["b"] = loadTheme;
/* unused harmony export clearStyles */
/* unused harmony export detokenize */
/* unused harmony export splitStyles */
// Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
// See LICENSE in the project root for license information.
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// Store the theming state in __themeState__ global scope for reuse in the case of duplicate
// load-themed-styles hosted on the page.
var _root = typeof window === 'undefined' ? global : window; // eslint-disable-line @typescript-eslint/no-explicit-any
// Nonce string to inject into script tag if one provided. This is used in CSP (Content Security Policy).
var _styleNonce = _root && _root.CSPSettings && _root.CSPSettings.nonce;
var _themeState = initializeThemeState();
/**
 * Matches theming tokens. For example, "[theme: themeSlotName, default: #FFF]" (including the quotes).
 */
var _themeTokenRegex = /[\'\"]\[theme:\s*(\w+)\s*(?:\,\s*default:\s*([\\"\']?[\.\,\(\)\#\-\s\w]*[\.\,\(\)\#\-\w][\"\']?))?\s*\][\'\"]/g;
var now = function () {
    return typeof performance !== 'undefined' && !!performance.now ? performance.now() : Date.now();
};
function measure(func) {
    var start = now();
    func();
    var end = now();
    _themeState.perf.duration += end - start;
}
/**
 * initialize global state object
 */
function initializeThemeState() {
    var state = _root.__themeState__ || {
        theme: undefined,
        lastStyleElement: undefined,
        registeredStyles: []
    };
    if (!state.runState) {
        state = __assign(__assign({}, state), { perf: {
                count: 0,
                duration: 0
            }, runState: {
                flushTimer: 0,
                mode: 0 /* sync */,
                buffer: []
            } });
    }
    if (!state.registeredThemableStyles) {
        state = __assign(__assign({}, state), { registeredThemableStyles: [] });
    }
    _root.__themeState__ = state;
    return state;
}
/**
 * Loads a set of style text. If it is registered too early, we will register it when the window.load
 * event is fired.
 * @param {string | ThemableArray} styles Themable style text to register.
 * @param {boolean} loadAsync When true, always load styles in async mode, irrespective of current sync mode.
 */
function loadStyles(styles, loadAsync) {
    if (loadAsync === void 0) { loadAsync = false; }
    measure(function () {
        var styleParts = Array.isArray(styles) ? styles : splitStyles(styles);
        var _a = _themeState.runState, mode = _a.mode, buffer = _a.buffer, flushTimer = _a.flushTimer;
        if (loadAsync || mode === 1 /* async */) {
            buffer.push(styleParts);
            if (!flushTimer) {
                _themeState.runState.flushTimer = asyncLoadStyles();
            }
        }
        else {
            applyThemableStyles(styleParts);
        }
    });
}
/**
 * Allows for customizable loadStyles logic. e.g. for server side rendering application
 * @param {(processedStyles: string, rawStyles?: string | ThemableArray) => void}
 * a loadStyles callback that gets called when styles are loaded or reloaded
 */
function configureLoadStyles(loadStylesFn) {
    _themeState.loadStyles = loadStylesFn;
}
/**
 * Configure run mode of load-themable-styles
 * @param mode load-themable-styles run mode, async or sync
 */
function configureRunMode(mode) {
    _themeState.runState.mode = mode;
}
/**
 * external code can call flush to synchronously force processing of currently buffered styles
 */
function flush() {
    measure(function () {
        var styleArrays = _themeState.runState.buffer.slice();
        _themeState.runState.buffer = [];
        var mergedStyleArray = [].concat.apply([], styleArrays);
        if (mergedStyleArray.length > 0) {
            applyThemableStyles(mergedStyleArray);
        }
    });
}
/**
 * register async loadStyles
 */
function asyncLoadStyles() {
    return setTimeout(function () {
        _themeState.runState.flushTimer = 0;
        flush();
    }, 0);
}
/**
 * Loads a set of style text. If it is registered too early, we will register it when the window.load event
 * is fired.
 * @param {string} styleText Style to register.
 * @param {IStyleRecord} styleRecord Existing style record to re-apply.
 */
function applyThemableStyles(stylesArray, styleRecord) {
    if (_themeState.loadStyles) {
        _themeState.loadStyles(resolveThemableArray(stylesArray).styleString, stylesArray);
    }
    else {
        registerStyles(stylesArray);
    }
}
/**
 * Registers a set theme tokens to find and replace. If styles were already registered, they will be
 * replaced.
 * @param {theme} theme JSON object of theme tokens to values.
 */
function loadTheme(theme) {
    _themeState.theme = theme;
    // reload styles.
    reloadStyles();
}
/**
 * Clear already registered style elements and style records in theme_State object
 * @param option - specify which group of registered styles should be cleared.
 * Default to be both themable and non-themable styles will be cleared
 */
function clearStyles(option) {
    if (option === void 0) { option = 3 /* all */; }
    if (option === 3 /* all */ || option === 2 /* onlyNonThemable */) {
        clearStylesInternal(_themeState.registeredStyles);
        _themeState.registeredStyles = [];
    }
    if (option === 3 /* all */ || option === 1 /* onlyThemable */) {
        clearStylesInternal(_themeState.registeredThemableStyles);
        _themeState.registeredThemableStyles = [];
    }
}
function clearStylesInternal(records) {
    records.forEach(function (styleRecord) {
        var styleElement = styleRecord && styleRecord.styleElement;
        if (styleElement && styleElement.parentElement) {
            styleElement.parentElement.removeChild(styleElement);
        }
    });
}
/**
 * Reloads styles.
 */
function reloadStyles() {
    if (_themeState.theme) {
        var themableStyles = [];
        for (var _i = 0, _a = _themeState.registeredThemableStyles; _i < _a.length; _i++) {
            var styleRecord = _a[_i];
            themableStyles.push(styleRecord.themableStyle);
        }
        if (themableStyles.length > 0) {
            clearStyles(1 /* onlyThemable */);
            applyThemableStyles([].concat.apply([], themableStyles));
        }
    }
}
/**
 * Find theme tokens and replaces them with provided theme values.
 * @param {string} styles Tokenized styles to fix.
 */
function detokenize(styles) {
    if (styles) {
        styles = resolveThemableArray(splitStyles(styles)).styleString;
    }
    return styles;
}
/**
 * Resolves ThemingInstruction objects in an array and joins the result into a string.
 * @param {ThemableArray} splitStyleArray ThemableArray to resolve and join.
 */
function resolveThemableArray(splitStyleArray) {
    var theme = _themeState.theme;
    var themable = false;
    // Resolve the array of theming instructions to an array of strings.
    // Then join the array to produce the final CSS string.
    var resolvedArray = (splitStyleArray || []).map(function (currentValue) {
        var themeSlot = currentValue.theme;
        if (themeSlot) {
            themable = true;
            // A theming annotation. Resolve it.
            var themedValue = theme ? theme[themeSlot] : undefined;
            var defaultValue = currentValue.defaultValue || 'inherit';
            // Warn to console if we hit an unthemed value even when themes are provided, but only if "DEBUG" is true.
            // Allow the themedValue to be undefined to explicitly request the default value.
            if (theme &&
                !themedValue &&
                console &&
                !(themeSlot in theme) &&
                typeof DEBUG !== 'undefined' &&
                DEBUG) {
                console.warn("Theming value not provided for \"" + themeSlot + "\". Falling back to \"" + defaultValue + "\".");
            }
            return themedValue || defaultValue;
        }
        else {
            // A non-themable string. Preserve it.
            return currentValue.rawString;
        }
    });
    return {
        styleString: resolvedArray.join(''),
        themable: themable
    };
}
/**
 * Split tokenized CSS into an array of strings and theme specification objects
 * @param {string} styles Tokenized styles to split.
 */
function splitStyles(styles) {
    var result = [];
    if (styles) {
        var pos = 0; // Current position in styles.
        var tokenMatch = void 0;
        while ((tokenMatch = _themeTokenRegex.exec(styles))) {
            var matchIndex = tokenMatch.index;
            if (matchIndex > pos) {
                result.push({
                    rawString: styles.substring(pos, matchIndex)
                });
            }
            result.push({
                theme: tokenMatch[1],
                defaultValue: tokenMatch[2] // May be undefined
            });
            // index of the first character after the current match
            pos = _themeTokenRegex.lastIndex;
        }
        // Push the rest of the string after the last match.
        result.push({
            rawString: styles.substring(pos)
        });
    }
    return result;
}
/**
 * Registers a set of style text. If it is registered too early, we will register it when the
 * window.load event is fired.
 * @param {ThemableArray} styleArray Array of IThemingInstruction objects to register.
 * @param {IStyleRecord} styleRecord May specify a style Element to update.
 */
function registerStyles(styleArray) {
    if (typeof document === 'undefined') {
        return;
    }
    var head = document.getElementsByTagName('head')[0];
    var styleElement = document.createElement('style');
    var _a = resolveThemableArray(styleArray), styleString = _a.styleString, themable = _a.themable;
    styleElement.setAttribute('data-load-themed-styles', 'true');
    if (_styleNonce) {
        styleElement.setAttribute('nonce', _styleNonce);
    }
    styleElement.appendChild(document.createTextNode(styleString));
    _themeState.perf.count++;
    head.appendChild(styleElement);
    var ev = document.createEvent('HTMLEvents');
    ev.initEvent('styleinsert', true /* bubbleEvent */, false /* cancelable */);
    ev.args = {
        newStyle: styleElement
    };
    document.dispatchEvent(ev);
    var record = {
        styleElement: styleElement,
        themableStyle: styleArray
    };
    if (themable) {
        _themeState.registeredThemableStyles.push(record);
    }
    else {
        _themeState.registeredStyles.push(record);
    }
}
//# sourceMappingURL=index.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(33)))

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BaseStep=function(_Component){_inherits(BaseStep,_Component);function BaseStep(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BaseStep);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BaseStep.__proto__||Object.getPrototypeOf(BaseStep)).call.apply(_ref,[this].concat(args))),_this),_this.renderBuyerName=function(item){var t=_this.props.t;if(!item.buyer.buyer_lastName&&!item.buyer.buyer_firstName&&!item.buyer.buyer_company_name){if(item.agentData){if(item.agentData.buyer_reference)return t('Customer {buyer_reference} of {name}',item.agentData);return t('Customer of {name}',item.agentData);}return t('Customer');}var names=[];names.push(item.buyer.buyer_firstName+' '+item.buyer.buyer_lastName);if(item.buyer.buyer_type==='company')names.push(item.buyer.buyer_company_name);if(item.buyer.others)item.buyer.others.forEach(function(buyer2){names.push(buyer2.buyer_firstName+' '+buyer2.buyer_lastName);});var name=names.join(', ');return name;},_temp),_possibleConstructorReturn(_this,_ret);}return BaseStep;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (BaseStep);

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
function isNumeric(num){return!isNaN(parseFloat(num));}var Money=function Money(_ref){var value=_ref.value,_ref$defaultValue=_ref.defaultValue,defaultValue=_ref$defaultValue===undefined?'':_ref$defaultValue,currency=_ref.currency,locale=_ref.locale;return isNumeric(value)?value.toFormattedMoney(locale,currency,defaultValue):__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',null,defaultValue);};/* harmony default export */ __webpack_exports__["a"] = (Money);

/***/ }),
/* 70 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(48);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 72 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 73 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(16);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Undefined */
/* unused harmony export normalizeJsName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CoreUtils; });
/* unused harmony export EventHelper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EnvUtils__ = __webpack_require__(232);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.


// Added to help with minfication
var Undefined = __WEBPACK_IMPORTED_MODULE_0__EnvUtils__["h" /* strUndefined */];
var strOnPrefix = "on";
var strAttachEvent = "attachEvent";
var strAddEventHelper = "addEventListener";
var strDetachEvent = "detachEvent";
var strRemoveEventListener = "removeEventListener";
function _isTypeof(value, theType) {
    return typeof value === theType;
}
;
function _isUndefined(value) {
    return _isTypeof(value, __WEBPACK_IMPORTED_MODULE_0__EnvUtils__["h" /* strUndefined */]) || value === undefined;
}
;
function _isNullOrUndefined(value) {
    return (_isUndefined(value) || value === null);
}
function _hasOwnProperty(obj, prop) {
    return obj && Object[__WEBPACK_IMPORTED_MODULE_0__EnvUtils__["g" /* strPrototype */]].hasOwnProperty.call(obj, prop);
}
;
function _isObject(value) {
    return _isTypeof(value, __WEBPACK_IMPORTED_MODULE_0__EnvUtils__["f" /* strObject */]);
}
;
function _isFunction(value) {
    return _isTypeof(value, __WEBPACK_IMPORTED_MODULE_0__EnvUtils__["e" /* strFunction */]);
}
;
/**
 * Binds the specified function to an event, so that the function gets called whenever the event fires on the object
 * @param obj Object to add the event too.
 * @param eventNameWithoutOn String that specifies any of the standard DHTML Events without "on" prefix
 * @param handlerRef Pointer that specifies the function to call when event fires
 * @param useCapture [Optional] Defaults to false
 * @returns True if the function was bound successfully to the event, otherwise false
 */
function _attachEvent(obj, eventNameWithoutOn, handlerRef, useCapture) {
    if (useCapture === void 0) { useCapture = false; }
    var result = false;
    if (!_isNullOrUndefined(obj)) {
        try {
            if (!_isNullOrUndefined(obj[strAddEventHelper])) {
                // all browsers except IE before version 9
                obj[strAddEventHelper](eventNameWithoutOn, handlerRef, useCapture);
                result = true;
            }
            else if (!_isNullOrUndefined(obj[strAttachEvent])) {
                // IE before version 9                    
                obj[strAttachEvent](strOnPrefix + eventNameWithoutOn, handlerRef);
                result = true;
            }
        }
        catch (e) {
            // Just Ignore any error so that we don't break any execution path
        }
    }
    return result;
}
/**
 * Removes an event handler for the specified event
 * @param Object to remove the event from
 * @param eventNameWithoutOn {string} - The name of the event
 * @param handlerRef {any} - The callback function that needs to be executed for the given event
 * @param useCapture [Optional] Defaults to false
 */
function _detachEvent(obj, eventNameWithoutOn, handlerRef, useCapture) {
    if (useCapture === void 0) { useCapture = false; }
    if (!_isNullOrUndefined(obj)) {
        try {
            if (!_isNullOrUndefined(obj[strRemoveEventListener])) {
                obj[strRemoveEventListener](eventNameWithoutOn, handlerRef, useCapture);
            }
            else if (!_isNullOrUndefined(obj[strDetachEvent])) {
                obj[strDetachEvent](strOnPrefix + eventNameWithoutOn, handlerRef);
            }
        }
        catch (e) {
            // Just Ignore any error so that we don't break any execution path
        }
    }
}
/**
 * Validates that the string name conforms to the JS IdentifierName specification and if not
 * normalizes the name so that it would. This method does not identify or change any keywords
 * meaning that if you pass in a known keyword the same value will be returned.
 * This is a simplified version
 * @param name The name to validate
 */
function normalizeJsName(name) {
    var value = name;
    var match = /([^\w\d_$])/g;
    if (match.test(name)) {
        value = name.replace(match, "_");
    }
    return value;
}
var CoreUtils = /** @class */ (function () {
    function CoreUtils() {
    }
    /**
     * Check if an object is of type Date
     */
    CoreUtils.isDate = function (obj) {
        return Object[__WEBPACK_IMPORTED_MODULE_0__EnvUtils__["g" /* strPrototype */]].toString.call(obj) === "[object Date]";
    };
    /**
     * Checks if the type of value is a string.
     * @param {any} value - Value to be checked.
     * @return {boolean} True if the value is a string, false otherwise.
     */
    CoreUtils.isString = function (value) {
        return _isTypeof(value, "string");
    };
    /**
     * Checks if the type of value is a number.
     * @param {any} value - Value to be checked.
     * @return {boolean} True if the value is a number, false otherwise.
     */
    CoreUtils.isNumber = function (value) {
        return _isTypeof(value, "number");
    };
    /**
     * Checks if the type of value is a boolean.
     * @param {any} value - Value to be checked.
     * @return {boolean} True if the value is a boolean, false otherwise.
     */
    CoreUtils.isBoolean = function (value) {
        return _isTypeof(value, "boolean");
    };
    /**
     * Creates a new GUID.
     * @return {string} A GUID.
     */
    CoreUtils.disableCookies = function () {
        CoreUtils._canUseCookies = false;
    };
    CoreUtils.newGuid = function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(GuidRegex, function (c) {
            var r = (Math.random() * 16 | 0), v = (c === 'x' ? r : r & 0x3 | 0x8);
            return v.toString(16);
        });
    };
    /**
     * Convert a date to I.S.O. format in IE8
     */
    CoreUtils.toISOString = function (date) {
        if (CoreUtils.isDate(date)) {
            var pad = function (num) {
                var r = String(num);
                if (r.length === 1) {
                    r = "0" + r;
                }
                return r;
            };
            return date.getUTCFullYear()
                + "-" + pad(date.getUTCMonth() + 1)
                + "-" + pad(date.getUTCDate())
                + "T" + pad(date.getUTCHours())
                + ":" + pad(date.getUTCMinutes())
                + ":" + pad(date.getUTCSeconds())
                + "." + String((date.getUTCMilliseconds() / 1000).toFixed(3)).slice(2, 5)
                + "Z";
        }
    };
    /**
     * Performs the specified action for each element in an array. This helper exists to avoid adding a polyfil for older browsers
     * that do not define Array.prototype.xxxx (eg. ES3 only, IE8) just in case any page checks for presence/absence of the prototype
     * implementation. Note: For consistency this will not use the Array.prototype.xxxx implementation if it exists as this would
     * cause a testing requirement to test with and without the implementations
     * @param callbackfn  A function that accepts up to three arguments. forEach calls the callbackfn function one time for each element in the array.
     * @param thisArg  [Optional] An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, undefined is used as the this value.
     */
    CoreUtils.arrForEach = function (arr, callbackfn, thisArg) {
        var len = arr.length;
        for (var idx = 0; idx < len; ++idx) {
            if (idx in arr) {
                callbackfn.call(thisArg || arr, arr[idx], idx, arr);
            }
        }
    };
    /**
     * Returns the index of the first occurrence of a value in an array. This helper exists to avoid adding a polyfil for older browsers
     * that do not define Array.prototype.xxxx (eg. ES3 only, IE8) just in case any page checks for presence/absence of the prototype
     * implementation. Note: For consistency this will not use the Array.prototype.xxxx implementation if it exists as this would
     * cause a testing requirement to test with and without the implementations
     * @param searchElement The value to locate in the array.
     * @param fromIndex The array index at which to begin the search. If fromIndex is omitted, the search starts at index 0.
     */
    CoreUtils.arrIndexOf = function (arr, searchElement, fromIndex) {
        var len = arr.length;
        var from = fromIndex || 0;
        for (var lp = Math.max(from >= 0 ? from : len - Math.abs(from), 0); lp < len; lp++) {
            if (lp in arr && arr[lp] === searchElement) {
                return lp;
            }
        }
        return -1;
    };
    /**
     * Calls a defined callback function on each element of an array, and returns an array that contains the results. This helper exists
     * to avoid adding a polyfil for older browsers that do not define Array.prototype.xxxx (eg. ES3 only, IE8) just in case any page
     * checks for presence/absence of the prototype implementation. Note: For consistency this will not use the Array.prototype.xxxx
     * implementation if it exists as this would cause a testing requirement to test with and without the implementations
     * @param callbackfn A function that accepts up to three arguments. The map method calls the callbackfn function one time for each element in the array.
     * @param thisArg An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, undefined is used as the this value.
     */
    CoreUtils.arrMap = function (arr, callbackfn, thisArg) {
        var len = arr.length;
        var _this = thisArg || arr;
        var results = new Array(len);
        for (var lp = 0; lp < len; lp++) {
            if (lp in arr) {
                results[lp] = callbackfn.call(_this, arr[lp], arr);
            }
        }
        return results;
    };
    /**
     * Calls the specified callback function for all the elements in an array. The return value of the callback function is the accumulated result, and is
     * provided as an argument in the next call to the callback function. This helper exists to avoid adding a polyfil for older browsers that do not define
     * Array.prototype.xxxx (eg. ES3 only, IE8) just in case any page checks for presence/absence of the prototype implementation. Note: For consistency
     * this will not use the Array.prototype.xxxx implementation if it exists as this would cause a testing requirement to test with and without the implementations
     * @param callbackfn A function that accepts up to four arguments. The reduce method calls the callbackfn function one time for each element in the array.
     * @param initialValue If initialValue is specified, it is used as the initial value to start the accumulation. The first call to the callbackfn function provides this value as an argument instead of an array value.
     */
    CoreUtils.arrReduce = function (arr, callbackfn, initialValue) {
        var len = arr.length;
        var lp = 0;
        var value;
        // Specifically checking the number of passed arguments as the value could be anything
        if (arguments.length >= 3) {
            value = arguments[2];
        }
        else {
            while (lp < len && !(lp in arr)) {
                lp++;
            }
            value = arr[lp++];
        }
        while (lp < len) {
            if (lp in arr) {
                value = callbackfn(value, arr[lp], lp, arr);
            }
            lp++;
        }
        return value;
    };
    /**
     * Creates an object that has the specified prototype, and that optionally contains specified properties. This helper exists to avoid adding a polyfil
     * for older browsers that do not define Object.create eg. ES3 only, IE8 just in case any page checks for presence/absence of the prototype implementation.
     * Note: For consistency this will not use the Object.create implementation if it exists as this would cause a testing requirement to test with and without the implementations
     * @param obj Object to use as a prototype. May be null
     */
    CoreUtils.objCreate = function (obj) {
        if (obj == null) {
            return {};
        }
        if (!_isObject(obj) && !_isFunction(obj)) {
            throw new TypeError('Object prototype may only be an Object: ' + obj);
        }
        function tmpFunc() { }
        ;
        tmpFunc[__WEBPACK_IMPORTED_MODULE_0__EnvUtils__["g" /* strPrototype */]] = obj;
        return new tmpFunc();
    };
    /**
     * Returns the names of the enumerable string properties and methods of an object. This helper exists to avoid adding a polyfil for older browsers
     * that do not define Object.keys eg. ES3 only, IE8 just in case any page checks for presence/absence of the prototype implementation.
     * Note: For consistency this will not use the Object.keys implementation if it exists as this would cause a testing requirement to test with and without the implementations
     * @param obj Object that contains the properties and methods. This can be an object that you created or an existing Document Object Model (DOM) object.
     */
    CoreUtils.objKeys = function (obj) {
        var hasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString');
        if (!_isFunction(obj) && (!_isObject(obj) || obj === null)) {
            throw new TypeError('objKeys called on non-object');
        }
        var result = [];
        for (var prop in obj) {
            if (_hasOwnProperty(obj, prop)) {
                result.push(prop);
            }
        }
        if (hasDontEnumBug) {
            var dontEnums = [
                'toString',
                'toLocaleString',
                'valueOf',
                'hasOwnProperty',
                'isPrototypeOf',
                'propertyIsEnumerable',
                'constructor'
            ];
            var dontEnumsLength = dontEnums.length;
            for (var lp = 0; lp < dontEnumsLength; lp++) {
                if (_hasOwnProperty(obj, dontEnums[lp])) {
                    result.push(dontEnums[lp]);
                }
            }
        }
        return result;
    };
    /**
     * Try to define get/set object property accessors for the target object/prototype, this will provide compatibility with
     * existing API definition when run within an ES5+ container that supports accessors but still enable the code to be loaded
     * and executed in an ES3 container, providing basic IE8 compatibility.
     * @param target The object on which to define the property.
     * @param prop The name of the property to be defined or modified.
     * @param getProp The getter function to wire against the getter.
     * @param setProp The setter function to wire against the setter.
     * @returns True if it was able to create the accessors otherwise false
     */
    CoreUtils.objDefineAccessors = function (target, prop, getProp, setProp) {
        var defineProp = Object["defineProperty"];
        if (defineProp) {
            try {
                var descriptor = {
                    enumerable: true,
                    configurable: true
                };
                if (getProp) {
                    descriptor.get = getProp;
                }
                if (setProp) {
                    descriptor.set = setProp;
                }
                defineProp(target, prop, descriptor);
                return true;
            }
            catch (e) {
                // IE8 Defines a defineProperty on Object but it's only supported for DOM elements so it will throw
                // We will just ignore this here.
            }
        }
        return false;
    };
    /**
     * Trys to add an event handler for the specified event to the window, body and document
     * @param eventName {string} - The name of the event
     * @param callback {any} - The callback function that needs to be executed for the given event
     * @return {boolean} - true if the handler was successfully added
     */
    CoreUtils.addEventHandler = function (eventName, callback) {
        var result = false;
        var w = Object(__WEBPACK_IMPORTED_MODULE_0__EnvUtils__["c" /* getWindow */])();
        if (w) {
            result = _attachEvent(w, eventName, callback);
            result = _attachEvent(w["body"], eventName, callback) || result;
        }
        var doc = Object(__WEBPACK_IMPORTED_MODULE_0__EnvUtils__["a" /* getDocument */])();
        if (doc) {
            result = EventHelper.Attach(doc, eventName, callback) || result;
        }
        return result;
    };
    CoreUtils.isTypeof = _isTypeof;
    CoreUtils.isUndefined = _isUndefined;
    CoreUtils.isNullOrUndefined = _isNullOrUndefined;
    CoreUtils.hasOwnProperty = _hasOwnProperty;
    /**
     * Checks if the passed of value is a function.
     * @param {any} value - Value to be checked.
     * @return {boolean} True if the value is a boolean, false otherwise.
     */
    CoreUtils.isFunction = _isFunction;
    /**
     * Checks if the passed of value is a function.
     * @param {any} value - Value to be checked.
     * @return {boolean} True if the value is a boolean, false otherwise.
     */
    CoreUtils.isObject = _isObject;
    return CoreUtils;
}());

var GuidRegex = /[xy]/g;
var EventHelper = /** @class */ (function () {
    function EventHelper() {
    }
    /**
     * Binds the specified function to an event, so that the function gets called whenever the event fires on the object
     * @param obj Object to add the event too.
     * @param eventNameWithoutOn String that specifies any of the standard DHTML Events without "on" prefix
     * @param handlerRef Pointer that specifies the function to call when event fires
     * @returns True if the function was bound successfully to the event, otherwise false
     */
    EventHelper.Attach = _attachEvent;
    /**
     * Binds the specified function to an event, so that the function gets called whenever the event fires on the object
     * @deprecated Use {@link EventHelper#Attach} as we are already in a class call EventHelper the extra "Event" just causes a larger result
     * @param obj Object to add the event too.
     * @param eventNameWithoutOn String that specifies any of the standard DHTML Events without "on" prefix
     * @param handlerRef Pointer that specifies the function to call when event fires
     * @returns True if the function was bound successfully to the event, otherwise false
     */
    EventHelper.AttachEvent = _attachEvent;
    /**
     * Removes an event handler for the specified event
     * @param eventName {string} - The name of the event
     * @param callback {any} - The callback function that needs to be executed for the given event
     * @return {boolean} - true if the handler was successfully added
     */
    EventHelper.Detach = _detachEvent;
    /**
     * Removes an event handler for the specified event
     * @deprecated Use {@link EventHelper#Detach} as we are already in a class call EventHelper the extra "Event" just causes a larger result
     * @param eventName {string} - The name of the event
     * @param callback {any} - The callback function that needs to be executed for the given event
     * @return {boolean} - true if the handler was successfully added
     */
    EventHelper.DetachEvent = _detachEvent;
    return EventHelper;
}());

//# sourceMappingURL=CoreUtils.js.map

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export dataSanitizeKeyAndAddUniqueness */
/* unused harmony export dataSanitizeKey */
/* harmony export (immutable) */ __webpack_exports__["f"] = dataSanitizeString;
/* harmony export (immutable) */ __webpack_exports__["g"] = dataSanitizeUrl;
/* harmony export (immutable) */ __webpack_exports__["d"] = dataSanitizeMessage;
/* harmony export (immutable) */ __webpack_exports__["a"] = dataSanitizeException;
/* harmony export (immutable) */ __webpack_exports__["e"] = dataSanitizeProperties;
/* harmony export (immutable) */ __webpack_exports__["c"] = dataSanitizeMeasurements;
/* harmony export (immutable) */ __webpack_exports__["b"] = dataSanitizeId;
/* unused harmony export dataSanitizeInput */
/* unused harmony export dsPadNumber */
/* unused harmony export DataSanitizer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(41);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



;
function dataSanitizeKeyAndAddUniqueness(logger, key, map) {
    var origLength = key.length;
    var field = dataSanitizeKey(logger, key);
    // validation truncated the length.  We need to add uniqueness
    if (field.length !== origLength) {
        var i = 0;
        var uniqueField = field;
        while (map[uniqueField] !== undefined) {
            i++;
            uniqueField = field.substring(0, 150 /* MAX_NAME_LENGTH */ - 3) + dsPadNumber(i);
        }
        field = uniqueField;
    }
    return field;
}
function dataSanitizeKey(logger, name) {
    var nameTrunc;
    if (name) {
        // Remove any leading or trailing whitepace
        name = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["P" /* strTrim */])(name.toString());
        // truncate the string to 150 chars
        if (name.length > 150 /* MAX_NAME_LENGTH */) {
            nameTrunc = name.substring(0, 150 /* MAX_NAME_LENGTH */);
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].NameTooLong, "name is too long.  It has been truncated to " + 150 /* MAX_NAME_LENGTH */ + " characters.", { name: name }, true);
        }
    }
    return nameTrunc || name;
}
function dataSanitizeString(logger, value, maxLength) {
    if (maxLength === void 0) { maxLength = 1024 /* MAX_STRING_LENGTH */; }
    var valueTrunc;
    if (value) {
        maxLength = maxLength ? maxLength : 1024 /* MAX_STRING_LENGTH */; // in case default parameters dont work
        value = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["P" /* strTrim */])(value);
        if (value.toString().length > maxLength) {
            valueTrunc = value.toString().substring(0, maxLength);
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].StringValueTooLong, "string value is too long. It has been truncated to " + maxLength + " characters.", { value: value }, true);
        }
    }
    return valueTrunc || value;
}
function dataSanitizeUrl(logger, url) {
    return dataSanitizeInput(logger, url, 2048 /* MAX_URL_LENGTH */, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].UrlTooLong);
}
function dataSanitizeMessage(logger, message) {
    var messageTrunc;
    if (message) {
        if (message.length > 32768 /* MAX_MESSAGE_LENGTH */) {
            messageTrunc = message.substring(0, 32768 /* MAX_MESSAGE_LENGTH */);
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].MessageTruncated, "message is too long, it has been truncated to " + 32768 /* MAX_MESSAGE_LENGTH */ + " characters.", { message: message }, true);
        }
    }
    return messageTrunc || message;
}
function dataSanitizeException(logger, exception) {
    var exceptionTrunc;
    if (exception) {
        // Make surte its a string
        var value = "" + exception;
        if (value.length > 32768 /* MAX_EXCEPTION_LENGTH */) {
            exceptionTrunc = value.substring(0, 32768 /* MAX_EXCEPTION_LENGTH */);
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].ExceptionTruncated, "exception is too long, it has been truncated to " + 32768 /* MAX_EXCEPTION_LENGTH */ + " characters.", { exception: exception }, true);
        }
    }
    return exceptionTrunc || exception;
}
function dataSanitizeProperties(logger, properties) {
    if (properties) {
        var tempProps_1 = {};
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["K" /* objForEachKey */])(properties, function (prop, value) {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["H" /* isObject */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["B" /* hasJSON */])()) {
                // Stringify any part C properties
                try {
                    value = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["w" /* getJSON */])().stringify(value);
                }
                catch (e) {
                    logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].CannotSerializeObjectNonSerializable, "custom property is not valid", { exception: e }, true);
                }
            }
            value = dataSanitizeString(logger, value, 8192 /* MAX_PROPERTY_LENGTH */);
            prop = dataSanitizeKeyAndAddUniqueness(logger, prop, tempProps_1);
            tempProps_1[prop] = value;
        });
        properties = tempProps_1;
    }
    return properties;
}
function dataSanitizeMeasurements(logger, measurements) {
    if (measurements) {
        var tempMeasurements_1 = {};
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["K" /* objForEachKey */])(measurements, function (measure, value) {
            measure = dataSanitizeKeyAndAddUniqueness(logger, measure, tempMeasurements_1);
            tempMeasurements_1[measure] = value;
        });
        measurements = tempMeasurements_1;
    }
    return measurements;
}
function dataSanitizeId(logger, id) {
    return id ? dataSanitizeInput(logger, id, 128 /* MAX_ID_LENGTH */, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].IdTooLong).toString() : id;
}
function dataSanitizeInput(logger, input, maxLength, _msgId) {
    var inputTrunc;
    if (input) {
        input = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["P" /* strTrim */])(input);
        if (input.length > maxLength) {
            inputTrunc = input.substring(0, maxLength);
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, _msgId, "input is too long, it has been truncated to " + maxLength + " characters.", { data: input }, true);
        }
    }
    return inputTrunc || input;
}
function dsPadNumber(num) {
    var s = "00" + num;
    return s.substr(s.length - 3);
}
;
/**
 * Provides the DataSanitizer functions within the previous namespace.
 */
var DataSanitizer = {
    MAX_NAME_LENGTH: 150 /* MAX_NAME_LENGTH */,
    MAX_ID_LENGTH: 128 /* MAX_ID_LENGTH */,
    MAX_PROPERTY_LENGTH: 8192 /* MAX_PROPERTY_LENGTH */,
    MAX_STRING_LENGTH: 1024 /* MAX_STRING_LENGTH */,
    MAX_URL_LENGTH: 2048 /* MAX_URL_LENGTH */,
    MAX_MESSAGE_LENGTH: 32768 /* MAX_MESSAGE_LENGTH */,
    MAX_EXCEPTION_LENGTH: 32768 /* MAX_EXCEPTION_LENGTH */,
    sanitizeKeyAndAddUniqueness: dataSanitizeKeyAndAddUniqueness,
    sanitizeKey: dataSanitizeKey,
    sanitizeString: dataSanitizeString,
    sanitizeUrl: dataSanitizeUrl,
    sanitizeMessage: dataSanitizeMessage,
    sanitizeException: dataSanitizeException,
    sanitizeProperties: dataSanitizeProperties,
    sanitizeMeasurements: dataSanitizeMeasurements,
    sanitizeId: dataSanitizeId,
    sanitizeInput: dataSanitizeInput,
    padNumber: dsPadNumber,
    trim: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["P" /* strTrim */]
};
//# sourceMappingURL=DataSanitizer.js.map

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DisabledPropertyName */
/* unused harmony export SampleRate */
/* unused harmony export ProcessLegacy */
/* unused harmony export HttpMethod */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_BREEZE_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return strNotSpecified; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * This is an internal property used to cause internal (reporting) requests to be ignored from reporting
 * additional telemetry, to handle polyfil implementations ALL urls used with a disabled request will
 * also be ignored for future requests even when this property is not provided.
 * Tagging as Ignore as this is an internal value and is not expected to be used outside of the SDK
 * @ignore
 */
var DisabledPropertyName = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation";
var SampleRate = "sampleRate";
var ProcessLegacy = "ProcessLegacy";
var HttpMethod = "http.method";
var DEFAULT_BREEZE_ENDPOINT = "https://dc.services.visualstudio.com";
var strNotSpecified = "not_specified";
//# sourceMappingURL=Constants.js.map

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export dataSanitizeKeyAndAddUniqueness */
/* unused harmony export dataSanitizeKey */
/* harmony export (immutable) */ __webpack_exports__["f"] = dataSanitizeString;
/* harmony export (immutable) */ __webpack_exports__["g"] = dataSanitizeUrl;
/* harmony export (immutable) */ __webpack_exports__["d"] = dataSanitizeMessage;
/* harmony export (immutable) */ __webpack_exports__["a"] = dataSanitizeException;
/* harmony export (immutable) */ __webpack_exports__["e"] = dataSanitizeProperties;
/* harmony export (immutable) */ __webpack_exports__["c"] = dataSanitizeMeasurements;
/* harmony export (immutable) */ __webpack_exports__["b"] = dataSanitizeId;
/* unused harmony export dataSanitizeInput */
/* unused harmony export dsPadNumber */
/* unused harmony export DataSanitizer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(30);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



;
function dataSanitizeKeyAndAddUniqueness(logger, key, map) {
    var origLength = key.length;
    var field = dataSanitizeKey(logger, key);
    // validation truncated the length.  We need to add uniqueness
    if (field.length !== origLength) {
        var i = 0;
        var uniqueField = field;
        while (map[uniqueField] !== undefined) {
            i++;
            uniqueField = field.substring(0, 150 /* MAX_NAME_LENGTH */ - 3) + dsPadNumber(i);
        }
        field = uniqueField;
    }
    return field;
}
function dataSanitizeKey(logger, name) {
    var nameTrunc;
    if (name) {
        // Remove any leading or trailing whitepace
        name = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["T" /* strTrim */])(name.toString());
        // truncate the string to 150 chars
        if (name.length > 150 /* MAX_NAME_LENGTH */) {
            nameTrunc = name.substring(0, 150 /* MAX_NAME_LENGTH */);
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].NameTooLong, "name is too long.  It has been truncated to " + 150 /* MAX_NAME_LENGTH */ + " characters.", { name: name }, true);
        }
    }
    return nameTrunc || name;
}
function dataSanitizeString(logger, value, maxLength) {
    if (maxLength === void 0) { maxLength = 1024 /* MAX_STRING_LENGTH */; }
    var valueTrunc;
    if (value) {
        maxLength = maxLength ? maxLength : 1024 /* MAX_STRING_LENGTH */; // in case default parameters dont work
        value = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["T" /* strTrim */])(value);
        if (value.toString().length > maxLength) {
            valueTrunc = value.toString().substring(0, maxLength);
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].StringValueTooLong, "string value is too long. It has been truncated to " + maxLength + " characters.", { value: value }, true);
        }
    }
    return valueTrunc || value;
}
function dataSanitizeUrl(logger, url) {
    return dataSanitizeInput(logger, url, 2048 /* MAX_URL_LENGTH */, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].UrlTooLong);
}
function dataSanitizeMessage(logger, message) {
    var messageTrunc;
    if (message) {
        if (message.length > 32768 /* MAX_MESSAGE_LENGTH */) {
            messageTrunc = message.substring(0, 32768 /* MAX_MESSAGE_LENGTH */);
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].MessageTruncated, "message is too long, it has been truncated to " + 32768 /* MAX_MESSAGE_LENGTH */ + " characters.", { message: message }, true);
        }
    }
    return messageTrunc || message;
}
function dataSanitizeException(logger, exception) {
    var exceptionTrunc;
    if (exception) {
        // Make surte its a string
        var value = "" + exception;
        if (value.length > 32768 /* MAX_EXCEPTION_LENGTH */) {
            exceptionTrunc = value.substring(0, 32768 /* MAX_EXCEPTION_LENGTH */);
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].ExceptionTruncated, "exception is too long, it has been truncated to " + 32768 /* MAX_EXCEPTION_LENGTH */ + " characters.", { exception: exception }, true);
        }
    }
    return exceptionTrunc || exception;
}
function dataSanitizeProperties(logger, properties) {
    if (properties) {
        var tempProps_1 = {};
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["M" /* objForEachKey */])(properties, function (prop, value) {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["H" /* isObject */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["A" /* hasJSON */])()) {
                // Stringify any part C properties
                try {
                    value = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["w" /* getJSON */])().stringify(value);
                }
                catch (e) {
                    logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].CannotSerializeObjectNonSerializable, "custom property is not valid", { exception: e }, true);
                }
            }
            value = dataSanitizeString(logger, value, 8192 /* MAX_PROPERTY_LENGTH */);
            prop = dataSanitizeKeyAndAddUniqueness(logger, prop, tempProps_1);
            tempProps_1[prop] = value;
        });
        properties = tempProps_1;
    }
    return properties;
}
function dataSanitizeMeasurements(logger, measurements) {
    if (measurements) {
        var tempMeasurements_1 = {};
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["M" /* objForEachKey */])(measurements, function (measure, value) {
            measure = dataSanitizeKeyAndAddUniqueness(logger, measure, tempMeasurements_1);
            tempMeasurements_1[measure] = value;
        });
        measurements = tempMeasurements_1;
    }
    return measurements;
}
function dataSanitizeId(logger, id) {
    return id ? dataSanitizeInput(logger, id, 128 /* MAX_ID_LENGTH */, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].IdTooLong).toString() : id;
}
function dataSanitizeInput(logger, input, maxLength, _msgId) {
    var inputTrunc;
    if (input) {
        input = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["T" /* strTrim */])(input);
        if (input.length > maxLength) {
            inputTrunc = input.substring(0, maxLength);
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].WARNING, _msgId, "input is too long, it has been truncated to " + maxLength + " characters.", { data: input }, true);
        }
    }
    return inputTrunc || input;
}
function dsPadNumber(num) {
    var s = "00" + num;
    return s.substr(s.length - 3);
}
;
/**
 * Provides the DataSanitizer functions within the previous namespace.
 */
var DataSanitizer = {
    MAX_NAME_LENGTH: 150 /* MAX_NAME_LENGTH */,
    MAX_ID_LENGTH: 128 /* MAX_ID_LENGTH */,
    MAX_PROPERTY_LENGTH: 8192 /* MAX_PROPERTY_LENGTH */,
    MAX_STRING_LENGTH: 1024 /* MAX_STRING_LENGTH */,
    MAX_URL_LENGTH: 2048 /* MAX_URL_LENGTH */,
    MAX_MESSAGE_LENGTH: 32768 /* MAX_MESSAGE_LENGTH */,
    MAX_EXCEPTION_LENGTH: 32768 /* MAX_EXCEPTION_LENGTH */,
    sanitizeKeyAndAddUniqueness: dataSanitizeKeyAndAddUniqueness,
    sanitizeKey: dataSanitizeKey,
    sanitizeString: dataSanitizeString,
    sanitizeUrl: dataSanitizeUrl,
    sanitizeMessage: dataSanitizeMessage,
    sanitizeException: dataSanitizeException,
    sanitizeProperties: dataSanitizeProperties,
    sanitizeMeasurements: dataSanitizeMeasurements,
    sanitizeId: dataSanitizeId,
    sanitizeInput: dataSanitizeInput,
    padNumber: dsPadNumber,
    trim: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["T" /* strTrim */]
};
//# sourceMappingURL=DataSanitizer.js.map

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DisabledPropertyName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SampleRate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ProcessLegacy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HttpMethod; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_BREEZE_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return strNotSpecified; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * This is an internal property used to cause internal (reporting) requests to be ignored from reporting
 * additional telemetry, to handle polyfil implementations ALL urls used with a disabled request will
 * also be ignored for future requests even when this property is not provided.
 * Tagging as Ignore as this is an internal value and is not expected to be used outside of the SDK
 * @ignore
 */
var DisabledPropertyName = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation";
var SampleRate = "sampleRate";
var ProcessLegacy = "ProcessLegacy";
var HttpMethod = "http.method";
var DEFAULT_BREEZE_ENDPOINT = "https://dc.services.visualstudio.com";
var strNotSpecified = "not_specified";
//# sourceMappingURL=Constants.js.map

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export dataSanitizeKeyAndAddUniqueness */
/* unused harmony export dataSanitizeKey */
/* harmony export (immutable) */ __webpack_exports__["f"] = dataSanitizeString;
/* harmony export (immutable) */ __webpack_exports__["g"] = dataSanitizeUrl;
/* harmony export (immutable) */ __webpack_exports__["d"] = dataSanitizeMessage;
/* harmony export (immutable) */ __webpack_exports__["a"] = dataSanitizeException;
/* harmony export (immutable) */ __webpack_exports__["e"] = dataSanitizeProperties;
/* harmony export (immutable) */ __webpack_exports__["c"] = dataSanitizeMeasurements;
/* harmony export (immutable) */ __webpack_exports__["b"] = dataSanitizeId;
/* unused harmony export dataSanitizeInput */
/* unused harmony export dsPadNumber */
/* unused harmony export DataSanitizer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(34);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



;
function dataSanitizeKeyAndAddUniqueness(logger, key, map) {
    var origLength = key.length;
    var field = dataSanitizeKey(logger, key);
    // validation truncated the length.  We need to add uniqueness
    if (field.length !== origLength) {
        var i = 0;
        var uniqueField = field;
        while (map[uniqueField] !== undefined) {
            i++;
            uniqueField = field.substring(0, 150 /* MAX_NAME_LENGTH */ - 3) + dsPadNumber(i);
        }
        field = uniqueField;
    }
    return field;
}
function dataSanitizeKey(logger, name) {
    var nameTrunc;
    if (name) {
        // Remove any leading or trailing whitepace
        name = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["R" /* strTrim */])(name.toString());
        // truncate the string to 150 chars
        if (name.length > 150 /* MAX_NAME_LENGTH */) {
            nameTrunc = name.substring(0, 150 /* MAX_NAME_LENGTH */);
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].NameTooLong, "name is too long.  It has been truncated to " + 150 /* MAX_NAME_LENGTH */ + " characters.", { name: name }, true);
        }
    }
    return nameTrunc || name;
}
function dataSanitizeString(logger, value, maxLength) {
    if (maxLength === void 0) { maxLength = 1024 /* MAX_STRING_LENGTH */; }
    var valueTrunc;
    if (value) {
        maxLength = maxLength ? maxLength : 1024 /* MAX_STRING_LENGTH */; // in case default parameters dont work
        value = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["R" /* strTrim */])(value);
        if (value.toString().length > maxLength) {
            valueTrunc = value.toString().substring(0, maxLength);
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].StringValueTooLong, "string value is too long. It has been truncated to " + maxLength + " characters.", { value: value }, true);
        }
    }
    return valueTrunc || value;
}
function dataSanitizeUrl(logger, url) {
    return dataSanitizeInput(logger, url, 2048 /* MAX_URL_LENGTH */, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].UrlTooLong);
}
function dataSanitizeMessage(logger, message) {
    var messageTrunc;
    if (message) {
        if (message.length > 32768 /* MAX_MESSAGE_LENGTH */) {
            messageTrunc = message.substring(0, 32768 /* MAX_MESSAGE_LENGTH */);
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].MessageTruncated, "message is too long, it has been truncated to " + 32768 /* MAX_MESSAGE_LENGTH */ + " characters.", { message: message }, true);
        }
    }
    return messageTrunc || message;
}
function dataSanitizeException(logger, exception) {
    var exceptionTrunc;
    if (exception) {
        // Make surte its a string
        var value = "" + exception;
        if (value.length > 32768 /* MAX_EXCEPTION_LENGTH */) {
            exceptionTrunc = value.substring(0, 32768 /* MAX_EXCEPTION_LENGTH */);
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].ExceptionTruncated, "exception is too long, it has been truncated to " + 32768 /* MAX_EXCEPTION_LENGTH */ + " characters.", { exception: exception }, true);
        }
    }
    return exceptionTrunc || exception;
}
function dataSanitizeProperties(logger, properties) {
    if (properties) {
        var tempProps_1 = {};
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["K" /* objForEachKey */])(properties, function (prop, value) {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["H" /* isObject */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["A" /* hasJSON */])()) {
                // Stringify any part C properties
                try {
                    value = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["v" /* getJSON */])().stringify(value);
                }
                catch (e) {
                    logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].CannotSerializeObjectNonSerializable, "custom property is not valid", { exception: e }, true);
                }
            }
            value = dataSanitizeString(logger, value, 8192 /* MAX_PROPERTY_LENGTH */);
            prop = dataSanitizeKeyAndAddUniqueness(logger, prop, tempProps_1);
            tempProps_1[prop] = value;
        });
        properties = tempProps_1;
    }
    return properties;
}
function dataSanitizeMeasurements(logger, measurements) {
    if (measurements) {
        var tempMeasurements_1 = {};
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["K" /* objForEachKey */])(measurements, function (measure, value) {
            measure = dataSanitizeKeyAndAddUniqueness(logger, measure, tempMeasurements_1);
            tempMeasurements_1[measure] = value;
        });
        measurements = tempMeasurements_1;
    }
    return measurements;
}
function dataSanitizeId(logger, id) {
    return id ? dataSanitizeInput(logger, id, 128 /* MAX_ID_LENGTH */, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].IdTooLong).toString() : id;
}
function dataSanitizeInput(logger, input, maxLength, _msgId) {
    var inputTrunc;
    if (input) {
        input = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["R" /* strTrim */])(input);
        if (input.length > maxLength) {
            inputTrunc = input.substring(0, maxLength);
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, _msgId, "input is too long, it has been truncated to " + maxLength + " characters.", { data: input }, true);
        }
    }
    return inputTrunc || input;
}
function dsPadNumber(num) {
    var s = "00" + num;
    return s.substr(s.length - 3);
}
;
/**
 * Provides the DataSanitizer functions within the previous namespace.
 */
var DataSanitizer = {
    MAX_NAME_LENGTH: 150 /* MAX_NAME_LENGTH */,
    MAX_ID_LENGTH: 128 /* MAX_ID_LENGTH */,
    MAX_PROPERTY_LENGTH: 8192 /* MAX_PROPERTY_LENGTH */,
    MAX_STRING_LENGTH: 1024 /* MAX_STRING_LENGTH */,
    MAX_URL_LENGTH: 2048 /* MAX_URL_LENGTH */,
    MAX_MESSAGE_LENGTH: 32768 /* MAX_MESSAGE_LENGTH */,
    MAX_EXCEPTION_LENGTH: 32768 /* MAX_EXCEPTION_LENGTH */,
    sanitizeKeyAndAddUniqueness: dataSanitizeKeyAndAddUniqueness,
    sanitizeKey: dataSanitizeKey,
    sanitizeString: dataSanitizeString,
    sanitizeUrl: dataSanitizeUrl,
    sanitizeMessage: dataSanitizeMessage,
    sanitizeException: dataSanitizeException,
    sanitizeProperties: dataSanitizeProperties,
    sanitizeMeasurements: dataSanitizeMeasurements,
    sanitizeId: dataSanitizeId,
    sanitizeInput: dataSanitizeInput,
    padNumber: dsPadNumber,
    trim: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["R" /* strTrim */]
};
//# sourceMappingURL=DataSanitizer.js.map

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DisabledPropertyName */
/* unused harmony export SampleRate */
/* unused harmony export ProcessLegacy */
/* unused harmony export HttpMethod */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_BREEZE_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return strNotSpecified; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * This is an internal property used to cause internal (reporting) requests to be ignored from reporting
 * additional telemetry, to handle polyfil implementations ALL urls used with a disabled request will
 * also be ignored for future requests even when this property is not provided.
 * Tagging as Ignore as this is an internal value and is not expected to be used outside of the SDK
 * @ignore
 */
var DisabledPropertyName = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation";
var SampleRate = "sampleRate";
var ProcessLegacy = "ProcessLegacy";
var HttpMethod = "http.method";
var DEFAULT_BREEZE_ENDPOINT = "https://dc.services.visualstudio.com";
var strNotSpecified = "not_specified";
//# sourceMappingURL=Constants.js.map

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export dataSanitizeKeyAndAddUniqueness */
/* unused harmony export dataSanitizeKey */
/* harmony export (immutable) */ __webpack_exports__["f"] = dataSanitizeString;
/* harmony export (immutable) */ __webpack_exports__["g"] = dataSanitizeUrl;
/* harmony export (immutable) */ __webpack_exports__["d"] = dataSanitizeMessage;
/* harmony export (immutable) */ __webpack_exports__["a"] = dataSanitizeException;
/* harmony export (immutable) */ __webpack_exports__["e"] = dataSanitizeProperties;
/* harmony export (immutable) */ __webpack_exports__["c"] = dataSanitizeMeasurements;
/* harmony export (immutable) */ __webpack_exports__["b"] = dataSanitizeId;
/* unused harmony export dataSanitizeInput */
/* unused harmony export dsPadNumber */
/* unused harmony export DataSanitizer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(35);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



;
function dataSanitizeKeyAndAddUniqueness(logger, key, map) {
    var origLength = key.length;
    var field = dataSanitizeKey(logger, key);
    // validation truncated the length.  We need to add uniqueness
    if (field.length !== origLength) {
        var i = 0;
        var uniqueField = field;
        while (map[uniqueField] !== undefined) {
            i++;
            uniqueField = field.substring(0, 150 /* MAX_NAME_LENGTH */ - 3) + dsPadNumber(i);
        }
        field = uniqueField;
    }
    return field;
}
function dataSanitizeKey(logger, name) {
    var nameTrunc;
    if (name) {
        // Remove any leading or trailing whitepace
        name = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["R" /* strTrim */])(name.toString());
        // truncate the string to 150 chars
        if (name.length > 150 /* MAX_NAME_LENGTH */) {
            nameTrunc = name.substring(0, 150 /* MAX_NAME_LENGTH */);
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["e" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["f" /* _InternalMessageId */].NameTooLong, "name is too long.  It has been truncated to " + 150 /* MAX_NAME_LENGTH */ + " characters.", { name: name }, true);
        }
    }
    return nameTrunc || name;
}
function dataSanitizeString(logger, value, maxLength) {
    if (maxLength === void 0) { maxLength = 1024 /* MAX_STRING_LENGTH */; }
    var valueTrunc;
    if (value) {
        maxLength = maxLength ? maxLength : 1024 /* MAX_STRING_LENGTH */; // in case default parameters dont work
        value = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["R" /* strTrim */])(value);
        if (value.toString().length > maxLength) {
            valueTrunc = value.toString().substring(0, maxLength);
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["e" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["f" /* _InternalMessageId */].StringValueTooLong, "string value is too long. It has been truncated to " + maxLength + " characters.", { value: value }, true);
        }
    }
    return valueTrunc || value;
}
function dataSanitizeUrl(logger, url) {
    return dataSanitizeInput(logger, url, 2048 /* MAX_URL_LENGTH */, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["f" /* _InternalMessageId */].UrlTooLong);
}
function dataSanitizeMessage(logger, message) {
    var messageTrunc;
    if (message) {
        if (message.length > 32768 /* MAX_MESSAGE_LENGTH */) {
            messageTrunc = message.substring(0, 32768 /* MAX_MESSAGE_LENGTH */);
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["e" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["f" /* _InternalMessageId */].MessageTruncated, "message is too long, it has been truncated to " + 32768 /* MAX_MESSAGE_LENGTH */ + " characters.", { message: message }, true);
        }
    }
    return messageTrunc || message;
}
function dataSanitizeException(logger, exception) {
    var exceptionTrunc;
    if (exception) {
        // Make surte its a string
        var value = "" + exception;
        if (value.length > 32768 /* MAX_EXCEPTION_LENGTH */) {
            exceptionTrunc = value.substring(0, 32768 /* MAX_EXCEPTION_LENGTH */);
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["e" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["f" /* _InternalMessageId */].ExceptionTruncated, "exception is too long, it has been truncated to " + 32768 /* MAX_EXCEPTION_LENGTH */ + " characters.", { exception: exception }, true);
        }
    }
    return exceptionTrunc || exception;
}
function dataSanitizeProperties(logger, properties) {
    if (properties) {
        var tempProps_1 = {};
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["M" /* objForEachKey */])(properties, function (prop, value) {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["I" /* isObject */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["B" /* hasJSON */])()) {
                // Stringify any part C properties
                try {
                    value = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["x" /* getJSON */])().stringify(value);
                }
                catch (e) {
                    logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["e" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["f" /* _InternalMessageId */].CannotSerializeObjectNonSerializable, "custom property is not valid", { exception: e }, true);
                }
            }
            value = dataSanitizeString(logger, value, 8192 /* MAX_PROPERTY_LENGTH */);
            prop = dataSanitizeKeyAndAddUniqueness(logger, prop, tempProps_1);
            tempProps_1[prop] = value;
        });
        properties = tempProps_1;
    }
    return properties;
}
function dataSanitizeMeasurements(logger, measurements) {
    if (measurements) {
        var tempMeasurements_1 = {};
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["M" /* objForEachKey */])(measurements, function (measure, value) {
            measure = dataSanitizeKeyAndAddUniqueness(logger, measure, tempMeasurements_1);
            tempMeasurements_1[measure] = value;
        });
        measurements = tempMeasurements_1;
    }
    return measurements;
}
function dataSanitizeId(logger, id) {
    return id ? dataSanitizeInput(logger, id, 128 /* MAX_ID_LENGTH */, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["f" /* _InternalMessageId */].IdTooLong).toString() : id;
}
function dataSanitizeInput(logger, input, maxLength, _msgId) {
    var inputTrunc;
    if (input) {
        input = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["R" /* strTrim */])(input);
        if (input.length > maxLength) {
            inputTrunc = input.substring(0, maxLength);
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["e" /* LoggingSeverity */].WARNING, _msgId, "input is too long, it has been truncated to " + maxLength + " characters.", { data: input }, true);
        }
    }
    return inputTrunc || input;
}
function dsPadNumber(num) {
    var s = "00" + num;
    return s.substr(s.length - 3);
}
;
/**
 * Provides the DataSanitizer functions within the previous namespace.
 */
var DataSanitizer = {
    MAX_NAME_LENGTH: 150 /* MAX_NAME_LENGTH */,
    MAX_ID_LENGTH: 128 /* MAX_ID_LENGTH */,
    MAX_PROPERTY_LENGTH: 8192 /* MAX_PROPERTY_LENGTH */,
    MAX_STRING_LENGTH: 1024 /* MAX_STRING_LENGTH */,
    MAX_URL_LENGTH: 2048 /* MAX_URL_LENGTH */,
    MAX_MESSAGE_LENGTH: 32768 /* MAX_MESSAGE_LENGTH */,
    MAX_EXCEPTION_LENGTH: 32768 /* MAX_EXCEPTION_LENGTH */,
    sanitizeKeyAndAddUniqueness: dataSanitizeKeyAndAddUniqueness,
    sanitizeKey: dataSanitizeKey,
    sanitizeString: dataSanitizeString,
    sanitizeUrl: dataSanitizeUrl,
    sanitizeMessage: dataSanitizeMessage,
    sanitizeException: dataSanitizeException,
    sanitizeProperties: dataSanitizeProperties,
    sanitizeMeasurements: dataSanitizeMeasurements,
    sanitizeId: dataSanitizeId,
    sanitizeInput: dataSanitizeInput,
    padNumber: dsPadNumber,
    trim: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["R" /* strTrim */]
};
//# sourceMappingURL=DataSanitizer.js.map

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DisabledPropertyName; });
/* unused harmony export SampleRate */
/* unused harmony export ProcessLegacy */
/* unused harmony export HttpMethod */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_BREEZE_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return strNotSpecified; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * This is an internal property used to cause internal (reporting) requests to be ignored from reporting
 * additional telemetry, to handle polyfil implementations ALL urls used with a disabled request will
 * also be ignored for future requests even when this property is not provided.
 * Tagging as Ignore as this is an internal value and is not expected to be used outside of the SDK
 * @ignore
 */
var DisabledPropertyName = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation";
var SampleRate = "sampleRate";
var ProcessLegacy = "ProcessLegacy";
var HttpMethod = "http.method";
var DEFAULT_BREEZE_ENDPOINT = "https://dc.services.visualstudio.com";
var strNotSpecified = "not_specified";
//# sourceMappingURL=Constants.js.map

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export dataSanitizeKeyAndAddUniqueness */
/* unused harmony export dataSanitizeKey */
/* harmony export (immutable) */ __webpack_exports__["g"] = dataSanitizeString;
/* harmony export (immutable) */ __webpack_exports__["h"] = dataSanitizeUrl;
/* harmony export (immutable) */ __webpack_exports__["e"] = dataSanitizeMessage;
/* harmony export (immutable) */ __webpack_exports__["b"] = dataSanitizeException;
/* harmony export (immutable) */ __webpack_exports__["f"] = dataSanitizeProperties;
/* harmony export (immutable) */ __webpack_exports__["d"] = dataSanitizeMeasurements;
/* harmony export (immutable) */ __webpack_exports__["c"] = dataSanitizeId;
/* unused harmony export dataSanitizeInput */
/* unused harmony export dsPadNumber */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataSanitizer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(39);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



;
function dataSanitizeKeyAndAddUniqueness(logger, key, map) {
    var origLength = key.length;
    var field = dataSanitizeKey(logger, key);
    // validation truncated the length.  We need to add uniqueness
    if (field.length !== origLength) {
        var i = 0;
        var uniqueField = field;
        while (map[uniqueField] !== undefined) {
            i++;
            uniqueField = field.substring(0, 150 /* MAX_NAME_LENGTH */ - 3) + dsPadNumber(i);
        }
        field = uniqueField;
    }
    return field;
}
function dataSanitizeKey(logger, name) {
    var nameTrunc;
    if (name) {
        // Remove any leading or trailing whitepace
        name = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["R" /* strTrim */])(name.toString());
        // truncate the string to 150 chars
        if (name.length > 150 /* MAX_NAME_LENGTH */) {
            nameTrunc = name.substring(0, 150 /* MAX_NAME_LENGTH */);
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].NameTooLong, "name is too long.  It has been truncated to " + 150 /* MAX_NAME_LENGTH */ + " characters.", { name: name }, true);
        }
    }
    return nameTrunc || name;
}
function dataSanitizeString(logger, value, maxLength) {
    if (maxLength === void 0) { maxLength = 1024 /* MAX_STRING_LENGTH */; }
    var valueTrunc;
    if (value) {
        maxLength = maxLength ? maxLength : 1024 /* MAX_STRING_LENGTH */; // in case default parameters dont work
        value = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["R" /* strTrim */])(value);
        if (value.toString().length > maxLength) {
            valueTrunc = value.toString().substring(0, maxLength);
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].StringValueTooLong, "string value is too long. It has been truncated to " + maxLength + " characters.", { value: value }, true);
        }
    }
    return valueTrunc || value;
}
function dataSanitizeUrl(logger, url) {
    return dataSanitizeInput(logger, url, 2048 /* MAX_URL_LENGTH */, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].UrlTooLong);
}
function dataSanitizeMessage(logger, message) {
    var messageTrunc;
    if (message) {
        if (message.length > 32768 /* MAX_MESSAGE_LENGTH */) {
            messageTrunc = message.substring(0, 32768 /* MAX_MESSAGE_LENGTH */);
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].MessageTruncated, "message is too long, it has been truncated to " + 32768 /* MAX_MESSAGE_LENGTH */ + " characters.", { message: message }, true);
        }
    }
    return messageTrunc || message;
}
function dataSanitizeException(logger, exception) {
    var exceptionTrunc;
    if (exception) {
        // Make surte its a string
        var value = "" + exception;
        if (value.length > 32768 /* MAX_EXCEPTION_LENGTH */) {
            exceptionTrunc = value.substring(0, 32768 /* MAX_EXCEPTION_LENGTH */);
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].ExceptionTruncated, "exception is too long, it has been truncated to " + 32768 /* MAX_EXCEPTION_LENGTH */ + " characters.", { exception: exception }, true);
        }
    }
    return exceptionTrunc || exception;
}
function dataSanitizeProperties(logger, properties) {
    if (properties) {
        var tempProps_1 = {};
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["M" /* objForEachKey */])(properties, function (prop, value) {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["I" /* isObject */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["B" /* hasJSON */])()) {
                // Stringify any part C properties
                try {
                    value = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["x" /* getJSON */])().stringify(value);
                }
                catch (e) {
                    logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].CannotSerializeObjectNonSerializable, "custom property is not valid", { exception: e }, true);
                }
            }
            value = dataSanitizeString(logger, value, 8192 /* MAX_PROPERTY_LENGTH */);
            prop = dataSanitizeKeyAndAddUniqueness(logger, prop, tempProps_1);
            tempProps_1[prop] = value;
        });
        properties = tempProps_1;
    }
    return properties;
}
function dataSanitizeMeasurements(logger, measurements) {
    if (measurements) {
        var tempMeasurements_1 = {};
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["M" /* objForEachKey */])(measurements, function (measure, value) {
            measure = dataSanitizeKeyAndAddUniqueness(logger, measure, tempMeasurements_1);
            tempMeasurements_1[measure] = value;
        });
        measurements = tempMeasurements_1;
    }
    return measurements;
}
function dataSanitizeId(logger, id) {
    return id ? dataSanitizeInput(logger, id, 128 /* MAX_ID_LENGTH */, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].IdTooLong).toString() : id;
}
function dataSanitizeInput(logger, input, maxLength, _msgId) {
    var inputTrunc;
    if (input) {
        input = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["R" /* strTrim */])(input);
        if (input.length > maxLength) {
            inputTrunc = input.substring(0, maxLength);
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, _msgId, "input is too long, it has been truncated to " + maxLength + " characters.", { data: input }, true);
        }
    }
    return inputTrunc || input;
}
function dsPadNumber(num) {
    var s = "00" + num;
    return s.substr(s.length - 3);
}
;
/**
 * Provides the DataSanitizer functions within the previous namespace.
 */
var DataSanitizer = {
    MAX_NAME_LENGTH: 150 /* MAX_NAME_LENGTH */,
    MAX_ID_LENGTH: 128 /* MAX_ID_LENGTH */,
    MAX_PROPERTY_LENGTH: 8192 /* MAX_PROPERTY_LENGTH */,
    MAX_STRING_LENGTH: 1024 /* MAX_STRING_LENGTH */,
    MAX_URL_LENGTH: 2048 /* MAX_URL_LENGTH */,
    MAX_MESSAGE_LENGTH: 32768 /* MAX_MESSAGE_LENGTH */,
    MAX_EXCEPTION_LENGTH: 32768 /* MAX_EXCEPTION_LENGTH */,
    sanitizeKeyAndAddUniqueness: dataSanitizeKeyAndAddUniqueness,
    sanitizeKey: dataSanitizeKey,
    sanitizeString: dataSanitizeString,
    sanitizeUrl: dataSanitizeUrl,
    sanitizeMessage: dataSanitizeMessage,
    sanitizeException: dataSanitizeException,
    sanitizeProperties: dataSanitizeProperties,
    sanitizeMeasurements: dataSanitizeMeasurements,
    sanitizeId: dataSanitizeId,
    sanitizeInput: dataSanitizeInput,
    padNumber: dsPadNumber,
    trim: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["R" /* strTrim */]
};
//# sourceMappingURL=DataSanitizer.js.map

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DisabledPropertyName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SampleRate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ProcessLegacy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HttpMethod; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_BREEZE_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return strNotSpecified; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * This is an internal property used to cause internal (reporting) requests to be ignored from reporting
 * additional telemetry, to handle polyfil implementations ALL urls used with a disabled request will
 * also be ignored for future requests even when this property is not provided.
 * Tagging as Ignore as this is an internal value and is not expected to be used outside of the SDK
 * @ignore
 */
var DisabledPropertyName = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation";
var SampleRate = "sampleRate";
var ProcessLegacy = "ProcessLegacy";
var HttpMethod = "http.method";
var DEFAULT_BREEZE_ENDPOINT = "https://dc.services.visualstudio.com";
var strNotSpecified = "not_specified";
//# sourceMappingURL=Constants.js.map

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getWindow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setSSR__ = __webpack_require__(382);

var _window = undefined;
// Note: Accessing "window" in IE11 is somewhat expensive, and calling "typeof window"
// hits a memory leak, whereas aliasing it and calling "typeof _window" does not.
// Caching the window value at the file scope lets us minimize the impact.
try {
    _window = window;
}
catch (e) {
    /* no-op */
}
/**
 * Helper to get the window object. The helper will make sure to use a cached variable
 * of "window", to avoid overhead and memory leaks in IE11. Note that in popup scenarios the
 * window object won't match the "global" window object, and for these scenarios, you should
 * pass in an element hosted within the popup.
 *
 * @public
 */
function getWindow(rootElement) {
    if (__WEBPACK_IMPORTED_MODULE_0__setSSR__["a" /* _isSSR */] || typeof _window === 'undefined') {
        return undefined;
    }
    else {
        var el = rootElement;
        return el && el.ownerDocument && el.ownerDocument.defaultView ? el.ownerDocument.defaultView : _window;
    }
}
//# sourceMappingURL=getWindow.js.map

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LogLevel; });
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
// These values are designed to match the ASP.NET Log Levels since that's the pattern we're emulating here.
/** Indicates the severity of a log message.
 *
 * Log Levels are ordered in increasing severity. So `Debug` is more severe than `Trace`, etc.
 */
var LogLevel;
(function (LogLevel) {
    /** Log level for very low severity diagnostic messages. */
    LogLevel[LogLevel["Trace"] = 0] = "Trace";
    /** Log level for low severity diagnostic messages. */
    LogLevel[LogLevel["Debug"] = 1] = "Debug";
    /** Log level for informational diagnostic messages. */
    LogLevel[LogLevel["Information"] = 2] = "Information";
    /** Log level for diagnostic messages that indicate a non-fatal problem. */
    LogLevel[LogLevel["Warning"] = 3] = "Warning";
    /** Log level for diagnostic messages that indicate a failure in the current operation. */
    LogLevel[LogLevel["Error"] = 4] = "Error";
    /** Log level for diagnostic messages that indicate a failure that will terminate the entire application. */
    LogLevel[LogLevel["Critical"] = 5] = "Critical";
    /** The highest possible log level. Used when configuring logging to indicate that no log messages should be emitted. */
    LogLevel[LogLevel["None"] = 6] = "None";
})(LogLevel || (LogLevel = {}));
//# sourceMappingURL=ILogger.js.map

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* unused harmony export VERSION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Arg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Platform; });
/* harmony export (immutable) */ __webpack_exports__["f"] = getDataDetail;
/* unused harmony export formatArrayBuffer */
/* harmony export (immutable) */ __webpack_exports__["h"] = isArrayBuffer;
/* harmony export (immutable) */ __webpack_exports__["i"] = sendMessage;
/* harmony export (immutable) */ __webpack_exports__["e"] = createLogger;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SubjectSubscription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ConsoleLogger; });
/* harmony export (immutable) */ __webpack_exports__["g"] = getUserAgentHeader;
/* unused harmony export constructUserAgent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ILogger__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Loggers__ = __webpack_require__(266);
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


// Version token that will be replaced by the prepack command
/** The version of the SignalR client. */
var VERSION = "5.0.7";
/** @private */
var Arg = /** @class */ (function () {
    function Arg() {
    }
    Arg.isRequired = function (val, name) {
        if (val === null || val === undefined) {
            throw new Error("The '" + name + "' argument is required.");
        }
    };
    Arg.isNotEmpty = function (val, name) {
        if (!val || val.match(/^\s*$/)) {
            throw new Error("The '" + name + "' argument should not be empty.");
        }
    };
    Arg.isIn = function (val, values, name) {
        // TypeScript enums have keys for **both** the name and the value of each enum member on the type itself.
        if (!(val in values)) {
            throw new Error("Unknown " + name + " value: " + val + ".");
        }
    };
    return Arg;
}());

/** @private */
var Platform = /** @class */ (function () {
    function Platform() {
    }
    Object.defineProperty(Platform, "isBrowser", {
        get: function () {
            return typeof window === "object";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Platform, "isWebWorker", {
        get: function () {
            return typeof self === "object" && "importScripts" in self;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Platform, "isNode", {
        get: function () {
            return !this.isBrowser && !this.isWebWorker;
        },
        enumerable: true,
        configurable: true
    });
    return Platform;
}());

/** @private */
function getDataDetail(data, includeContent) {
    var detail = "";
    if (isArrayBuffer(data)) {
        detail = "Binary data of length " + data.byteLength;
        if (includeContent) {
            detail += ". Content: '" + formatArrayBuffer(data) + "'";
        }
    }
    else if (typeof data === "string") {
        detail = "String data of length " + data.length;
        if (includeContent) {
            detail += ". Content: '" + data + "'";
        }
    }
    return detail;
}
/** @private */
function formatArrayBuffer(data) {
    var view = new Uint8Array(data);
    // Uint8Array.map only supports returning another Uint8Array?
    var str = "";
    view.forEach(function (num) {
        var pad = num < 16 ? "0" : "";
        str += "0x" + pad + num.toString(16) + " ";
    });
    // Trim of trailing space.
    return str.substr(0, str.length - 1);
}
// Also in signalr-protocol-msgpack/Utils.ts
/** @private */
function isArrayBuffer(val) {
    return val && typeof ArrayBuffer !== "undefined" &&
        (val instanceof ArrayBuffer ||
            // Sometimes we get an ArrayBuffer that doesn't satisfy instanceof
            (val.constructor && val.constructor.name === "ArrayBuffer"));
}
/** @private */
function sendMessage(logger, transportName, httpClient, url, accessTokenFactory, content, logMessageContent, withCredentials, defaultHeaders) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, headers, token, _b, name, value, responseType, response;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    headers = {};
                    if (!accessTokenFactory) return [3 /*break*/, 2];
                    return [4 /*yield*/, accessTokenFactory()];
                case 1:
                    token = _c.sent();
                    if (token) {
                        headers = (_a = {},
                            _a["Authorization"] = "Bearer " + token,
                            _a);
                    }
                    _c.label = 2;
                case 2:
                    _b = getUserAgentHeader(), name = _b[0], value = _b[1];
                    headers[name] = value;
                    logger.log(__WEBPACK_IMPORTED_MODULE_0__ILogger__["a" /* LogLevel */].Trace, "(" + transportName + " transport) sending data. " + getDataDetail(content, logMessageContent) + ".");
                    responseType = isArrayBuffer(content) ? "arraybuffer" : "text";
                    return [4 /*yield*/, httpClient.post(url, {
                            content: content,
                            headers: __assign({}, headers, defaultHeaders),
                            responseType: responseType,
                            withCredentials: withCredentials,
                        })];
                case 3:
                    response = _c.sent();
                    logger.log(__WEBPACK_IMPORTED_MODULE_0__ILogger__["a" /* LogLevel */].Trace, "(" + transportName + " transport) request complete. Response status: " + response.statusCode + ".");
                    return [2 /*return*/];
            }
        });
    });
}
/** @private */
function createLogger(logger) {
    if (logger === undefined) {
        return new ConsoleLogger(__WEBPACK_IMPORTED_MODULE_0__ILogger__["a" /* LogLevel */].Information);
    }
    if (logger === null) {
        return __WEBPACK_IMPORTED_MODULE_1__Loggers__["a" /* NullLogger */].instance;
    }
    if (logger.log) {
        return logger;
    }
    return new ConsoleLogger(logger);
}
/** @private */
var SubjectSubscription = /** @class */ (function () {
    function SubjectSubscription(subject, observer) {
        this.subject = subject;
        this.observer = observer;
    }
    SubjectSubscription.prototype.dispose = function () {
        var index = this.subject.observers.indexOf(this.observer);
        if (index > -1) {
            this.subject.observers.splice(index, 1);
        }
        if (this.subject.observers.length === 0 && this.subject.cancelCallback) {
            this.subject.cancelCallback().catch(function (_) { });
        }
    };
    return SubjectSubscription;
}());

/** @private */
var ConsoleLogger = /** @class */ (function () {
    function ConsoleLogger(minimumLogLevel) {
        this.minimumLogLevel = minimumLogLevel;
        this.outputConsole = console;
    }
    ConsoleLogger.prototype.log = function (logLevel, message) {
        if (logLevel >= this.minimumLogLevel) {
            switch (logLevel) {
                case __WEBPACK_IMPORTED_MODULE_0__ILogger__["a" /* LogLevel */].Critical:
                case __WEBPACK_IMPORTED_MODULE_0__ILogger__["a" /* LogLevel */].Error:
                    this.outputConsole.error("[" + new Date().toISOString() + "] " + __WEBPACK_IMPORTED_MODULE_0__ILogger__["a" /* LogLevel */][logLevel] + ": " + message);
                    break;
                case __WEBPACK_IMPORTED_MODULE_0__ILogger__["a" /* LogLevel */].Warning:
                    this.outputConsole.warn("[" + new Date().toISOString() + "] " + __WEBPACK_IMPORTED_MODULE_0__ILogger__["a" /* LogLevel */][logLevel] + ": " + message);
                    break;
                case __WEBPACK_IMPORTED_MODULE_0__ILogger__["a" /* LogLevel */].Information:
                    this.outputConsole.info("[" + new Date().toISOString() + "] " + __WEBPACK_IMPORTED_MODULE_0__ILogger__["a" /* LogLevel */][logLevel] + ": " + message);
                    break;
                default:
                    // console.debug only goes to attached debuggers in Node, so we use console.log for Trace and Debug
                    this.outputConsole.log("[" + new Date().toISOString() + "] " + __WEBPACK_IMPORTED_MODULE_0__ILogger__["a" /* LogLevel */][logLevel] + ": " + message);
                    break;
            }
        }
    };
    return ConsoleLogger;
}());

/** @private */
function getUserAgentHeader() {
    var userAgentHeaderName = "X-SignalR-User-Agent";
    if (Platform.isNode) {
        userAgentHeaderName = "User-Agent";
    }
    return [userAgentHeaderName, constructUserAgent(VERSION, getOsName(), getRuntime(), getRuntimeVersion())];
}
/** @private */
function constructUserAgent(version, os, runtime, runtimeVersion) {
    // Microsoft SignalR/[Version] ([Detailed Version]; [Operating System]; [Runtime]; [Runtime Version])
    var userAgent = "Microsoft SignalR/";
    var majorAndMinor = version.split(".");
    userAgent += majorAndMinor[0] + "." + majorAndMinor[1];
    userAgent += " (" + version + "; ";
    if (os && os !== "") {
        userAgent += os + "; ";
    }
    else {
        userAgent += "Unknown OS; ";
    }
    userAgent += "" + runtime;
    if (runtimeVersion) {
        userAgent += "; " + runtimeVersion;
    }
    else {
        userAgent += "; Unknown Runtime Version";
    }
    userAgent += ")";
    return userAgent;
}
function getOsName() {
    if (Platform.isNode) {
        switch (process.platform) {
            case "win32":
                return "Windows NT";
            case "darwin":
                return "macOS";
            case "linux":
                return "Linux";
            default:
                return process.platform;
        }
    }
    else {
        return "";
    }
}
function getRuntimeVersion() {
    if (Platform.isNode) {
        return process.versions.node;
    }
    return undefined;
}
function getRuntime() {
    if (Platform.isNode) {
        return "NodeJS";
    }
    else {
        return "Browser";
    }
}
//# sourceMappingURL=Utils.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(147)))

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_KeytipData_index__ = __webpack_require__(1715);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_KeytipData_index__["a"]; });

//# sourceMappingURL=KeytipData.js.map

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_office_ui_fabric_react_lib_Overlay__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_Spinner__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_css__ = __webpack_require__(2151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_css__);
var Loading=function Loading(_ref){var _ref$label=_ref.label,label=_ref$label===undefined?'':_ref$label,_ref$isVisible=_ref.isVisible,isVisible=_ref$isVisible===undefined?true:_ref$isVisible,_ref$fullscreen=_ref.fullscreen,fullscreen=_ref$fullscreen===undefined?false:_ref$fullscreen,_ref$opacity=_ref.opacity,opacity=_ref$opacity===undefined?1:_ref$opacity,_ref$position=_ref.position,position=_ref$position===undefined?null:_ref$position;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:fullscreen?'loading is-fullscreen':'loading',style:{opacity:opacity}},isVisible&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_office_ui_fabric_react_lib_Overlay__["a" /* Overlay */],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'loading-overlay'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_Spinner__["a" /* Spinner */],{label:label,size:__WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_Spinner__["b" /* SpinnerSize */].medium,className:'loading-spinner'}))));};/* harmony default export */ __webpack_exports__["a"] = (Loading);

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Checkbox_index__ = __webpack_require__(1798);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Checkbox_index__["a"]; });

//# sourceMappingURL=Checkbox.js.map

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(17);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 93 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(3);
var core = __webpack_require__(70);
var fails = __webpack_require__(16);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(71);
var IObject = __webpack_require__(165);
var toObject = __webpack_require__(27);
var toLength = __webpack_require__(21);
var asc = __webpack_require__(341);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(1335);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
 * Microsoft Dynamic Proto Utility, 1.1.4
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
 * Constant string defined to support minimization
 * @ignore
 */
var Constructor = 'constructor';
/**
 * Constant string defined to support minimization
 * @ignore
 */
var Prototype = 'prototype';
/**
 * Constant string defined to support minimization
 * @ignore
 */
var strFunction = 'function';
/**
 * Used to define the name of the instance function lookup table
 * @ignore
 */
var DynInstFuncTable = '_dynInstFuncs';
/**
 * Name used to tag the dynamic prototype function
 * @ignore
 */
var DynProxyTag = '_isDynProxy';
/**
 * Name added to a prototype to define the dynamic prototype "class" name used to lookup the function table
 * @ignore
 */
var DynClassName = '_dynClass';
/**
 * Prefix added to the classname to avoid any name clashes with other instance level properties
 * @ignore
 */
var DynClassNamePrefix = '_dynCls$';
/**
 * A tag which is used to check if we have already to attempted to set the instance function if one is not present
 * @ignore
 */
var DynInstChkTag = '_dynInstChk';
/**
 * A tag which is used to check if we are allows to try and set an instance function is one is not present. Using the same
 * tag name as the function level but a different const name for readability only.
 */
var DynAllowInstChkTag = DynInstChkTag;
/**
 * The global (imported) instances where the global performance options are stored
 */
var DynProtoDefaultOptions = '_dfOpts';
/**
 * Value used as the name of a class when it cannot be determined
 * @ignore
 */
var UnknownValue = '_unknown_';
/**
 * Constant string defined to support minimization
 * @ignore
 */
var str__Proto = "__proto__";
/**
 * Constant string defined to support minimization
 * @ignore
 */
var strUseBaseInst = 'useBaseInst';
/**
 * Constant string defined to support minimization
 * @ignore
 */
var strSetInstFuncs = 'setInstFuncs';
var Obj = Object;
/**
 * Pre-lookup to check if we are running on a modern browser (i.e. not IE8)
 * @ignore
 */
var _objGetPrototypeOf = Obj["getPrototypeOf"];
/**
 * Internal Global used to generate a unique dynamic class name, every new class will increase this value
 * @ignore
 */
var _dynamicNames = 0;
/**
 * Helper to check if the object contains a property of the name
 * @ignore
 */
function _hasOwnProperty(obj, prop) {
    return obj && Obj[Prototype].hasOwnProperty.call(obj, prop);
}
/**
 * Helper used to check whether the target is an Object prototype or Array prototype
 * @ignore
 */
function _isObjectOrArrayPrototype(target) {
    return target && (target === Obj[Prototype] || target === Array[Prototype]);
}
/**
 * Helper used to check whether the target is an Object prototype, Array prototype or Function prototype
 * @ignore
 */
function _isObjectArrayOrFunctionPrototype(target) {
    return _isObjectOrArrayPrototype(target) || target === Function[Prototype];
}
/**
 * Helper used to get the prototype of the target object as getPrototypeOf is not available in an ES3 environment.
 * @ignore
 */
function _getObjProto(target) {
    if (target) {
        // This method doesn't existing in older browsers (e.g. IE8)
        if (_objGetPrototypeOf) {
            return _objGetPrototypeOf(target);
        }
        // target[Constructor] May break if the constructor has been changed or removed
        var newProto = target[str__Proto] || target[Prototype] || (target[Constructor] ? target[Constructor][Prototype] : null);
        if (newProto) {
            return newProto;
        }
    }
    return null;
}
/**
 * Helper to get the properties of an object, including none enumerable ones as functions on a prototype in ES6
 * are not enumerable.
 * @param target
 */
function _forEachProp(target, func) {
    var props = [];
    var getOwnProps = Obj["getOwnPropertyNames"];
    if (getOwnProps) {
        props = getOwnProps(target);
    }
    else {
        for (var name_1 in target) {
            if (typeof name_1 === "string" && _hasOwnProperty(target, name_1)) {
                props.push(name_1);
            }
        }
    }
    if (props && props.length > 0) {
        for (var lp = 0; lp < props.length; lp++) {
            func(props[lp]);
        }
    }
}
/**
 * Helper function to check whether the provided function name is a potential candidate for dynamic
 * callback and prototype generation.
 * @param target The target object, may be a prototype or class object
 * @param funcName The function name
 * @param skipOwn Skips the check for own property
 * @ignore
 */
function _isDynamicCandidate(target, funcName, skipOwn) {
    return (funcName !== Constructor && typeof target[funcName] === strFunction && (skipOwn || _hasOwnProperty(target, funcName)));
}
/**
 * Helper to throw a TypeError exception
 * @param message the message
 * @ignore
 */
function _throwTypeError(message) {
    throw new TypeError("DynamicProto: " + message);
}
/**
 * Returns a collection of the instance functions that are defined directly on the thisTarget object, it does
 * not return any inherited functions
 * @param thisTarget The object to get the instance functions from
 * @ignore
 */
function _getInstanceFuncs(thisTarget) {
    // Get the base proto
    var instFuncs = {};
    // Save any existing instance functions
    _forEachProp(thisTarget, function (name) {
        // Don't include any dynamic prototype instances - as we only want the real functions
        if (!instFuncs[name] && _isDynamicCandidate(thisTarget, name, false)) {
            // Create an instance callback for passing the base function to the caller
            instFuncs[name] = thisTarget[name];
        }
    });
    return instFuncs;
}
/**
 * Returns whether the value is included in the array
 * @param values The array of values
 * @param value  The value
 */
function _hasVisited(values, value) {
    for (var lp = values.length - 1; lp >= 0; lp--) {
        if (values[lp] === value) {
            return true;
        }
    }
    return false;
}
/**
 * Returns an object that contains callback functions for all "base/super" functions, this is used to "save"
 * enabling calling super.xxx() functions without requiring that the base "class" has defined a prototype references
 * @param target The current instance
 * @ignore
 */
function _getBaseFuncs(classProto, thisTarget, instFuncs, useBaseInst) {
    function _instFuncProxy(target, funcHost, funcName) {
        var theFunc = funcHost[funcName];
        if (theFunc[DynProxyTag] && useBaseInst) {
            // grab and reuse the hosted looking function (if available) otherwise the original passed function
            var instFuncTable = target[DynInstFuncTable] || {};
            if (instFuncTable[DynAllowInstChkTag] !== false) {
                theFunc = (instFuncTable[funcHost[DynClassName]] || {})[funcName] || theFunc;
            }
        }
        return function () {
            return theFunc.apply(target, arguments);
        };
    }
    // Start creating a new baseFuncs by creating proxies for the instance functions (as they may get replaced)
    var baseFuncs = {};
    _forEachProp(instFuncs, function (name) {
        // Create an instance callback for passing the base function to the caller
        baseFuncs[name] = _instFuncProxy(thisTarget, instFuncs, name);
    });
    // Get the base prototype functions
    var baseProto = _getObjProto(classProto);
    var visited = [];
    // Don't include base object functions for Object, Array or Function
    while (baseProto && !_isObjectArrayOrFunctionPrototype(baseProto) && !_hasVisited(visited, baseProto)) {
        // look for prototype functions
        _forEachProp(baseProto, function (name) {
            // Don't include any dynamic prototype instances - as we only want the real functions
            // For IE 7/8 the prototype lookup doesn't provide the full chain so we need to bypass the 
            // hasOwnProperty check we get all of the methods, main difference is that IE7/8 doesn't return
            // the Object prototype methods while bypassing the check
            if (!baseFuncs[name] && _isDynamicCandidate(baseProto, name, !_objGetPrototypeOf)) {
                // Create an instance callback for passing the base function to the caller
                baseFuncs[name] = _instFuncProxy(thisTarget, baseProto, name);
            }
        });
        // We need to find all possible functions that might be overloaded by walking the entire prototype chain
        // This avoids the caller from needing to check whether it's direct base class implements the function or not
        // by walking the entire chain it simplifies the usage and issues from upgrading any of the base classes.
        visited.push(baseProto);
        baseProto = _getObjProto(baseProto);
    }
    return baseFuncs;
}
function _getInstFunc(target, funcName, proto, currentDynProtoProxy) {
    var instFunc = null;
    // We need to check whether the class name is defined directly on this prototype otherwise
    // it will walk the proto chain and return any parent proto classname.
    if (target && _hasOwnProperty(proto, DynClassName)) {
        var instFuncTable = target[DynInstFuncTable] || {};
        instFunc = (instFuncTable[proto[DynClassName]] || {})[funcName];
        if (!instFunc) {
            // Avoid stack overflow from recursive calling the same function
            _throwTypeError("Missing [" + funcName + "] " + strFunction);
        }
        // We have the instance function, lets check it we can speed up further calls
        // by adding the instance function back directly on the instance (avoiding the dynamic func lookup)
        if (!instFunc[DynInstChkTag] && instFuncTable[DynAllowInstChkTag] !== false) {
            // If the instance already has an instance function we can't replace it
            var canAddInst = !_hasOwnProperty(target, funcName);
            // Get current prototype
            var objProto = _getObjProto(target);
            var visited = [];
            // Lookup the function starting at the top (instance level prototype) and traverse down, if the first matching function
            // if nothing is found or if the first hit is a dynamic proto instance then we can safely add an instance shortcut
            while (canAddInst && objProto && !_isObjectArrayOrFunctionPrototype(objProto) && !_hasVisited(visited, objProto)) {
                var protoFunc = objProto[funcName];
                if (protoFunc) {
                    canAddInst = (protoFunc === currentDynProtoProxy);
                    break;
                }
                // We need to find all possible initial functions to ensure that we don't bypass a valid override function
                visited.push(objProto);
                objProto = _getObjProto(objProto);
            }
            try {
                if (canAddInst) {
                    // This instance doesn't have an instance func and the class hierarchy does have a higher level prototype version
                    // so it's safe to directly assign for any subsequent calls (for better performance)
                    target[funcName] = instFunc;
                }
                // Block further attempts to set the instance function for any
                instFunc[DynInstChkTag] = 1;
            }
            catch (e) {
                // Don't crash if the object is readonly or the runtime doesn't allow changing this
                // And set a flag so we don't try again for any function
                instFuncTable[DynAllowInstChkTag] = false;
            }
        }
    }
    return instFunc;
}
function _getProtoFunc(funcName, proto, currentDynProtoProxy) {
    var protoFunc = proto[funcName];
    // Check that the prototype function is not a self reference -- try to avoid stack overflow!
    if (protoFunc === currentDynProtoProxy) {
        // It is so lookup the base prototype
        protoFunc = _getObjProto(proto)[funcName];
    }
    if (typeof protoFunc !== strFunction) {
        _throwTypeError("[" + funcName + "] is not a " + strFunction);
    }
    return protoFunc;
}
/**
 * Add the required dynamic prototype methods to the the class prototype
 * @param proto - The class prototype
 * @param className - The instance classname
 * @param target - The target instance
 * @param baseInstFuncs - The base instance functions
 * @param setInstanceFunc - Flag to allow prototype function to reset the instance function if one does not exist
 * @ignore
 */
function _populatePrototype(proto, className, target, baseInstFuncs, setInstanceFunc) {
    function _createDynamicPrototype(proto, funcName) {
        var dynProtoProxy = function () {
            // Use the instance or prototype function
            var instFunc = _getInstFunc(this, funcName, proto, dynProtoProxy) || _getProtoFunc(funcName, proto, dynProtoProxy);
            return instFunc.apply(this, arguments);
        };
        // Tag this function as a proxy to support replacing dynamic proxy elements (primary use case is for unit testing
        // via which can dynamically replace the prototype function reference)
        dynProtoProxy[DynProxyTag] = 1;
        return dynProtoProxy;
    }
    if (!_isObjectOrArrayPrototype(proto)) {
        var instFuncTable = target[DynInstFuncTable] = target[DynInstFuncTable] || {};
        var instFuncs_1 = instFuncTable[className] = (instFuncTable[className] || {}); // fetch and assign if as it may not exist yet
        // Set whether we are allow to lookup instances, if someone has set to false then do not re-enable
        if (instFuncTable[DynAllowInstChkTag] !== false) {
            instFuncTable[DynAllowInstChkTag] = !!setInstanceFunc;
        }
        _forEachProp(target, function (name) {
            // Only add overridden functions
            if (_isDynamicCandidate(target, name, false) && target[name] !== baseInstFuncs[name]) {
                // Save the instance Function to the lookup table and remove it from the instance as it's not a dynamic proto function
                instFuncs_1[name] = target[name];
                delete target[name];
                // Add a dynamic proto if one doesn't exist or if a prototype function exists and it's not a dynamic one
                if (!_hasOwnProperty(proto, name) || (proto[name] && !proto[name][DynProxyTag])) {
                    proto[name] = _createDynamicPrototype(proto, name);
                }
            }
        });
    }
}
/**
 * Checks whether the passed prototype object appears to be correct by walking the prototype hierarchy of the instance
 * @param classProto The class prototype instance
 * @param thisTarget The current instance that will be checked whether the passed prototype instance is in the hierarchy
 * @ignore
 */
function _checkPrototype(classProto, thisTarget) {
    // This method doesn't existing in older browsers (e.g. IE8)
    if (_objGetPrototypeOf) {
        // As this is primarily a coding time check, don't bother checking if running in IE8 or lower
        var visited = [];
        var thisProto = _getObjProto(thisTarget);
        while (thisProto && !_isObjectArrayOrFunctionPrototype(thisProto) && !_hasVisited(visited, thisProto)) {
            if (thisProto === classProto) {
                return true;
            }
            // This avoids the caller from needing to check whether it's direct base class implements the function or not
            // by walking the entire chain it simplifies the usage and issues from upgrading any of the base classes.
            visited.push(thisProto);
            thisProto = _getObjProto(thisProto);
        }
    }
    return false;
}
/**
 * Gets the current prototype name using the ES6 name if available otherwise falling back to a use unknown as the name.
 * It's not critical for this to return a name, it's used to decorate the generated unique name for easier debugging only.
 * @param target
 * @param unknownValue
 * @ignore
 */
function _getObjName(target, unknownValue) {
    if (_hasOwnProperty(target, Prototype)) {
        // Look like a prototype
        return target.name || unknownValue || UnknownValue;
    }
    return (((target || {})[Constructor]) || {}).name || unknownValue || UnknownValue;
}
/**
 * Helper function when creating dynamic (inline) functions for classes, this helper performs the following tasks :-
 * - Saves references to all defined base class functions
 * - Calls the delegateFunc with the current target (this) and a base object reference that can be used to call all "super" functions.
 * - Will populate the class prototype for all overridden functions to support class extension that call the prototype instance.
 * Callers should use this helper when declaring all function within the constructor of a class, as mentioned above the delegateFunc is
 * passed both the target "this" and an object that can be used to call any base (super) functions, using this based object in place of
 * super.XXX() (which gets expanded to _super.prototype.XXX()) provides a better minification outcome and also ensures the correct "this"
 * context is maintained as TypeScript creates incorrect references using super.XXXX() for dynamically defined functions i.e. Functions
 * defined in the constructor or some other function (rather than declared as complete typescript functions).
 * ### Usage
 * ```typescript
 * import dynamicProto from "@microsoft/dynamicproto-js";
 * class ExampleClass extends BaseClass {
 *     constructor() {
 *         dynamicProto(ExampleClass, this, (_self, base) => {
 *             // This will define a function that will be converted to a prototype function
 *             _self.newFunc = () => {
 *                 // Access any "this" instance property
 *                 if (_self.someProperty) {
 *                     ...
 *                 }
 *             }
 *             // This will define a function that will be converted to a prototype function
 *             _self.myFunction = () => {
 *                 // Access any "this" instance property
 *                 if (_self.someProperty) {
 *                     // Call the base version of the function that we are overriding
 *                     base.myFunction();
 *                 }
 *                 ...
 *             }
 *             _self.initialize = () => {
 *                 ...
 *             }
 *             // Warnings: While the following will work as _self is simply a reference to
 *             // this, if anyone overrides myFunction() the overridden will be called first
 *             // as the normal JavaScript method resolution will occur and the defined
 *             // _self.initialize() function is actually gets removed from the instance and
 *             // a proxy prototype version is created to reference the created method.
 *             _self.initialize();
 *         });
 *     }
 * }
 * ```
 * @typeparam DPType This is the generic type of the class, used to keep intellisense valid
 * @typeparam DPCls The type that contains the prototype of the current class
 * @param theClass - This is the current class instance which contains the prototype for the current class
 * @param target - The current "this" (target) reference, when the class has been extended this.prototype will not be the 'theClass' value.
 * @param delegateFunc - The callback function (closure) that will create the dynamic function
 * @param options - Additional options to configure how the dynamic prototype operates
 */
function dynamicProto(theClass, target, delegateFunc, options) {
    // Make sure that the passed theClass argument looks correct
    if (!_hasOwnProperty(theClass, Prototype)) {
        _throwTypeError("theClass is an invalid class definition.");
    }
    // Quick check to make sure that the passed theClass argument looks correct (this is a common copy/paste error)
    var classProto = theClass[Prototype];
    if (!_checkPrototype(classProto, target)) {
        _throwTypeError("[" + _getObjName(theClass) + "] is not in class hierarchy of [" + _getObjName(target) + "]");
    }
    var className = null;
    if (_hasOwnProperty(classProto, DynClassName)) {
        // Only grab the class name if it's defined on this prototype (i.e. don't walk the prototype chain)
        className = classProto[DynClassName];
    }
    else {
        // As not all browser support name on the prototype creating a unique dynamic one if we have not already
        // assigned one, so we can use a simple string as the lookup rather than an object for the dynamic instance
        // function table lookup.
        className = DynClassNamePrefix + _getObjName(theClass, "_") + "$" + _dynamicNames;
        _dynamicNames++;
        classProto[DynClassName] = className;
    }
    var perfOptions = dynamicProto[DynProtoDefaultOptions];
    var useBaseInst = !!perfOptions[strUseBaseInst];
    if (useBaseInst && options && options[strUseBaseInst] !== undefined) {
        useBaseInst = !!options[strUseBaseInst];
    }
    // Get the current instance functions
    var instFuncs = _getInstanceFuncs(target);
    // Get all of the functions for any base instance (before they are potentially overridden)
    var baseFuncs = _getBaseFuncs(classProto, target, instFuncs, useBaseInst);
    // Execute the delegate passing in both the current target "this" and "base" function references
    // Note casting the same type as we don't actually have the base class here and this will provide some intellisense support
    delegateFunc(target, baseFuncs);
    // Don't allow setting instance functions for older IE instances
    var setInstanceFunc = !!_objGetPrototypeOf && !!perfOptions[strSetInstFuncs];
    if (setInstanceFunc && options) {
        setInstanceFunc = !!options[strSetInstFuncs];
    }
    // Populate the Prototype for any overridden instance functions
    _populatePrototype(classProto, className, target, instFuncs, setInstanceFunc !== false);
}
/**
 * Exposes the default global options to allow global configuration, if the global values are disabled these will override
 * any passed values. This is primarily exposed to support unit-testing without the need for individual classes to expose
 * their internal usage of dynamic proto.
 */
var perfDefaults = {
    setInstFuncs: true,
    useBaseInst: true
};
// And expose for testing
dynamicProto[DynProtoDefaultOptions] = perfDefaults;

/* harmony default export */ __webpack_exports__["a"] = (dynamicProto);
//# sourceMappingURL=dynamicproto-js.js.map


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
 * Microsoft Dynamic Proto Utility, 1.1.4
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
 * Constant string defined to support minimization
 * @ignore
 */
var Constructor = 'constructor';
/**
 * Constant string defined to support minimization
 * @ignore
 */
var Prototype = 'prototype';
/**
 * Constant string defined to support minimization
 * @ignore
 */
var strFunction = 'function';
/**
 * Used to define the name of the instance function lookup table
 * @ignore
 */
var DynInstFuncTable = '_dynInstFuncs';
/**
 * Name used to tag the dynamic prototype function
 * @ignore
 */
var DynProxyTag = '_isDynProxy';
/**
 * Name added to a prototype to define the dynamic prototype "class" name used to lookup the function table
 * @ignore
 */
var DynClassName = '_dynClass';
/**
 * Prefix added to the classname to avoid any name clashes with other instance level properties
 * @ignore
 */
var DynClassNamePrefix = '_dynCls$';
/**
 * A tag which is used to check if we have already to attempted to set the instance function if one is not present
 * @ignore
 */
var DynInstChkTag = '_dynInstChk';
/**
 * A tag which is used to check if we are allows to try and set an instance function is one is not present. Using the same
 * tag name as the function level but a different const name for readability only.
 */
var DynAllowInstChkTag = DynInstChkTag;
/**
 * The global (imported) instances where the global performance options are stored
 */
var DynProtoDefaultOptions = '_dfOpts';
/**
 * Value used as the name of a class when it cannot be determined
 * @ignore
 */
var UnknownValue = '_unknown_';
/**
 * Constant string defined to support minimization
 * @ignore
 */
var str__Proto = "__proto__";
/**
 * Constant string defined to support minimization
 * @ignore
 */
var strUseBaseInst = 'useBaseInst';
/**
 * Constant string defined to support minimization
 * @ignore
 */
var strSetInstFuncs = 'setInstFuncs';
var Obj = Object;
/**
 * Pre-lookup to check if we are running on a modern browser (i.e. not IE8)
 * @ignore
 */
var _objGetPrototypeOf = Obj["getPrototypeOf"];
/**
 * Internal Global used to generate a unique dynamic class name, every new class will increase this value
 * @ignore
 */
var _dynamicNames = 0;
/**
 * Helper to check if the object contains a property of the name
 * @ignore
 */
function _hasOwnProperty(obj, prop) {
    return obj && Obj[Prototype].hasOwnProperty.call(obj, prop);
}
/**
 * Helper used to check whether the target is an Object prototype or Array prototype
 * @ignore
 */
function _isObjectOrArrayPrototype(target) {
    return target && (target === Obj[Prototype] || target === Array[Prototype]);
}
/**
 * Helper used to check whether the target is an Object prototype, Array prototype or Function prototype
 * @ignore
 */
function _isObjectArrayOrFunctionPrototype(target) {
    return _isObjectOrArrayPrototype(target) || target === Function[Prototype];
}
/**
 * Helper used to get the prototype of the target object as getPrototypeOf is not available in an ES3 environment.
 * @ignore
 */
function _getObjProto(target) {
    if (target) {
        // This method doesn't existing in older browsers (e.g. IE8)
        if (_objGetPrototypeOf) {
            return _objGetPrototypeOf(target);
        }
        // target[Constructor] May break if the constructor has been changed or removed
        var newProto = target[str__Proto] || target[Prototype] || (target[Constructor] ? target[Constructor][Prototype] : null);
        if (newProto) {
            return newProto;
        }
    }
    return null;
}
/**
 * Helper to get the properties of an object, including none enumerable ones as functions on a prototype in ES6
 * are not enumerable.
 * @param target
 */
function _forEachProp(target, func) {
    var props = [];
    var getOwnProps = Obj["getOwnPropertyNames"];
    if (getOwnProps) {
        props = getOwnProps(target);
    }
    else {
        for (var name_1 in target) {
            if (typeof name_1 === "string" && _hasOwnProperty(target, name_1)) {
                props.push(name_1);
            }
        }
    }
    if (props && props.length > 0) {
        for (var lp = 0; lp < props.length; lp++) {
            func(props[lp]);
        }
    }
}
/**
 * Helper function to check whether the provided function name is a potential candidate for dynamic
 * callback and prototype generation.
 * @param target The target object, may be a prototype or class object
 * @param funcName The function name
 * @param skipOwn Skips the check for own property
 * @ignore
 */
function _isDynamicCandidate(target, funcName, skipOwn) {
    return (funcName !== Constructor && typeof target[funcName] === strFunction && (skipOwn || _hasOwnProperty(target, funcName)));
}
/**
 * Helper to throw a TypeError exception
 * @param message the message
 * @ignore
 */
function _throwTypeError(message) {
    throw new TypeError("DynamicProto: " + message);
}
/**
 * Returns a collection of the instance functions that are defined directly on the thisTarget object, it does
 * not return any inherited functions
 * @param thisTarget The object to get the instance functions from
 * @ignore
 */
function _getInstanceFuncs(thisTarget) {
    // Get the base proto
    var instFuncs = {};
    // Save any existing instance functions
    _forEachProp(thisTarget, function (name) {
        // Don't include any dynamic prototype instances - as we only want the real functions
        if (!instFuncs[name] && _isDynamicCandidate(thisTarget, name, false)) {
            // Create an instance callback for passing the base function to the caller
            instFuncs[name] = thisTarget[name];
        }
    });
    return instFuncs;
}
/**
 * Returns whether the value is included in the array
 * @param values The array of values
 * @param value  The value
 */
function _hasVisited(values, value) {
    for (var lp = values.length - 1; lp >= 0; lp--) {
        if (values[lp] === value) {
            return true;
        }
    }
    return false;
}
/**
 * Returns an object that contains callback functions for all "base/super" functions, this is used to "save"
 * enabling calling super.xxx() functions without requiring that the base "class" has defined a prototype references
 * @param target The current instance
 * @ignore
 */
function _getBaseFuncs(classProto, thisTarget, instFuncs, useBaseInst) {
    function _instFuncProxy(target, funcHost, funcName) {
        var theFunc = funcHost[funcName];
        if (theFunc[DynProxyTag] && useBaseInst) {
            // grab and reuse the hosted looking function (if available) otherwise the original passed function
            var instFuncTable = target[DynInstFuncTable] || {};
            if (instFuncTable[DynAllowInstChkTag] !== false) {
                theFunc = (instFuncTable[funcHost[DynClassName]] || {})[funcName] || theFunc;
            }
        }
        return function () {
            return theFunc.apply(target, arguments);
        };
    }
    // Start creating a new baseFuncs by creating proxies for the instance functions (as they may get replaced)
    var baseFuncs = {};
    _forEachProp(instFuncs, function (name) {
        // Create an instance callback for passing the base function to the caller
        baseFuncs[name] = _instFuncProxy(thisTarget, instFuncs, name);
    });
    // Get the base prototype functions
    var baseProto = _getObjProto(classProto);
    var visited = [];
    // Don't include base object functions for Object, Array or Function
    while (baseProto && !_isObjectArrayOrFunctionPrototype(baseProto) && !_hasVisited(visited, baseProto)) {
        // look for prototype functions
        _forEachProp(baseProto, function (name) {
            // Don't include any dynamic prototype instances - as we only want the real functions
            // For IE 7/8 the prototype lookup doesn't provide the full chain so we need to bypass the 
            // hasOwnProperty check we get all of the methods, main difference is that IE7/8 doesn't return
            // the Object prototype methods while bypassing the check
            if (!baseFuncs[name] && _isDynamicCandidate(baseProto, name, !_objGetPrototypeOf)) {
                // Create an instance callback for passing the base function to the caller
                baseFuncs[name] = _instFuncProxy(thisTarget, baseProto, name);
            }
        });
        // We need to find all possible functions that might be overloaded by walking the entire prototype chain
        // This avoids the caller from needing to check whether it's direct base class implements the function or not
        // by walking the entire chain it simplifies the usage and issues from upgrading any of the base classes.
        visited.push(baseProto);
        baseProto = _getObjProto(baseProto);
    }
    return baseFuncs;
}
function _getInstFunc(target, funcName, proto, currentDynProtoProxy) {
    var instFunc = null;
    // We need to check whether the class name is defined directly on this prototype otherwise
    // it will walk the proto chain and return any parent proto classname.
    if (target && _hasOwnProperty(proto, DynClassName)) {
        var instFuncTable = target[DynInstFuncTable] || {};
        instFunc = (instFuncTable[proto[DynClassName]] || {})[funcName];
        if (!instFunc) {
            // Avoid stack overflow from recursive calling the same function
            _throwTypeError("Missing [" + funcName + "] " + strFunction);
        }
        // We have the instance function, lets check it we can speed up further calls
        // by adding the instance function back directly on the instance (avoiding the dynamic func lookup)
        if (!instFunc[DynInstChkTag] && instFuncTable[DynAllowInstChkTag] !== false) {
            // If the instance already has an instance function we can't replace it
            var canAddInst = !_hasOwnProperty(target, funcName);
            // Get current prototype
            var objProto = _getObjProto(target);
            var visited = [];
            // Lookup the function starting at the top (instance level prototype) and traverse down, if the first matching function
            // if nothing is found or if the first hit is a dynamic proto instance then we can safely add an instance shortcut
            while (canAddInst && objProto && !_isObjectArrayOrFunctionPrototype(objProto) && !_hasVisited(visited, objProto)) {
                var protoFunc = objProto[funcName];
                if (protoFunc) {
                    canAddInst = (protoFunc === currentDynProtoProxy);
                    break;
                }
                // We need to find all possible initial functions to ensure that we don't bypass a valid override function
                visited.push(objProto);
                objProto = _getObjProto(objProto);
            }
            try {
                if (canAddInst) {
                    // This instance doesn't have an instance func and the class hierarchy does have a higher level prototype version
                    // so it's safe to directly assign for any subsequent calls (for better performance)
                    target[funcName] = instFunc;
                }
                // Block further attempts to set the instance function for any
                instFunc[DynInstChkTag] = 1;
            }
            catch (e) {
                // Don't crash if the object is readonly or the runtime doesn't allow changing this
                // And set a flag so we don't try again for any function
                instFuncTable[DynAllowInstChkTag] = false;
            }
        }
    }
    return instFunc;
}
function _getProtoFunc(funcName, proto, currentDynProtoProxy) {
    var protoFunc = proto[funcName];
    // Check that the prototype function is not a self reference -- try to avoid stack overflow!
    if (protoFunc === currentDynProtoProxy) {
        // It is so lookup the base prototype
        protoFunc = _getObjProto(proto)[funcName];
    }
    if (typeof protoFunc !== strFunction) {
        _throwTypeError("[" + funcName + "] is not a " + strFunction);
    }
    return protoFunc;
}
/**
 * Add the required dynamic prototype methods to the the class prototype
 * @param proto - The class prototype
 * @param className - The instance classname
 * @param target - The target instance
 * @param baseInstFuncs - The base instance functions
 * @param setInstanceFunc - Flag to allow prototype function to reset the instance function if one does not exist
 * @ignore
 */
function _populatePrototype(proto, className, target, baseInstFuncs, setInstanceFunc) {
    function _createDynamicPrototype(proto, funcName) {
        var dynProtoProxy = function () {
            // Use the instance or prototype function
            var instFunc = _getInstFunc(this, funcName, proto, dynProtoProxy) || _getProtoFunc(funcName, proto, dynProtoProxy);
            return instFunc.apply(this, arguments);
        };
        // Tag this function as a proxy to support replacing dynamic proxy elements (primary use case is for unit testing
        // via which can dynamically replace the prototype function reference)
        dynProtoProxy[DynProxyTag] = 1;
        return dynProtoProxy;
    }
    if (!_isObjectOrArrayPrototype(proto)) {
        var instFuncTable = target[DynInstFuncTable] = target[DynInstFuncTable] || {};
        var instFuncs_1 = instFuncTable[className] = (instFuncTable[className] || {}); // fetch and assign if as it may not exist yet
        // Set whether we are allow to lookup instances, if someone has set to false then do not re-enable
        if (instFuncTable[DynAllowInstChkTag] !== false) {
            instFuncTable[DynAllowInstChkTag] = !!setInstanceFunc;
        }
        _forEachProp(target, function (name) {
            // Only add overridden functions
            if (_isDynamicCandidate(target, name, false) && target[name] !== baseInstFuncs[name]) {
                // Save the instance Function to the lookup table and remove it from the instance as it's not a dynamic proto function
                instFuncs_1[name] = target[name];
                delete target[name];
                // Add a dynamic proto if one doesn't exist or if a prototype function exists and it's not a dynamic one
                if (!_hasOwnProperty(proto, name) || (proto[name] && !proto[name][DynProxyTag])) {
                    proto[name] = _createDynamicPrototype(proto, name);
                }
            }
        });
    }
}
/**
 * Checks whether the passed prototype object appears to be correct by walking the prototype hierarchy of the instance
 * @param classProto The class prototype instance
 * @param thisTarget The current instance that will be checked whether the passed prototype instance is in the hierarchy
 * @ignore
 */
function _checkPrototype(classProto, thisTarget) {
    // This method doesn't existing in older browsers (e.g. IE8)
    if (_objGetPrototypeOf) {
        // As this is primarily a coding time check, don't bother checking if running in IE8 or lower
        var visited = [];
        var thisProto = _getObjProto(thisTarget);
        while (thisProto && !_isObjectArrayOrFunctionPrototype(thisProto) && !_hasVisited(visited, thisProto)) {
            if (thisProto === classProto) {
                return true;
            }
            // This avoids the caller from needing to check whether it's direct base class implements the function or not
            // by walking the entire chain it simplifies the usage and issues from upgrading any of the base classes.
            visited.push(thisProto);
            thisProto = _getObjProto(thisProto);
        }
    }
    return false;
}
/**
 * Gets the current prototype name using the ES6 name if available otherwise falling back to a use unknown as the name.
 * It's not critical for this to return a name, it's used to decorate the generated unique name for easier debugging only.
 * @param target
 * @param unknownValue
 * @ignore
 */
function _getObjName(target, unknownValue) {
    if (_hasOwnProperty(target, Prototype)) {
        // Look like a prototype
        return target.name || unknownValue || UnknownValue;
    }
    return (((target || {})[Constructor]) || {}).name || unknownValue || UnknownValue;
}
/**
 * Helper function when creating dynamic (inline) functions for classes, this helper performs the following tasks :-
 * - Saves references to all defined base class functions
 * - Calls the delegateFunc with the current target (this) and a base object reference that can be used to call all "super" functions.
 * - Will populate the class prototype for all overridden functions to support class extension that call the prototype instance.
 * Callers should use this helper when declaring all function within the constructor of a class, as mentioned above the delegateFunc is
 * passed both the target "this" and an object that can be used to call any base (super) functions, using this based object in place of
 * super.XXX() (which gets expanded to _super.prototype.XXX()) provides a better minification outcome and also ensures the correct "this"
 * context is maintained as TypeScript creates incorrect references using super.XXXX() for dynamically defined functions i.e. Functions
 * defined in the constructor or some other function (rather than declared as complete typescript functions).
 * ### Usage
 * ```typescript
 * import dynamicProto from "@microsoft/dynamicproto-js";
 * class ExampleClass extends BaseClass {
 *     constructor() {
 *         dynamicProto(ExampleClass, this, (_self, base) => {
 *             // This will define a function that will be converted to a prototype function
 *             _self.newFunc = () => {
 *                 // Access any "this" instance property
 *                 if (_self.someProperty) {
 *                     ...
 *                 }
 *             }
 *             // This will define a function that will be converted to a prototype function
 *             _self.myFunction = () => {
 *                 // Access any "this" instance property
 *                 if (_self.someProperty) {
 *                     // Call the base version of the function that we are overriding
 *                     base.myFunction();
 *                 }
 *                 ...
 *             }
 *             _self.initialize = () => {
 *                 ...
 *             }
 *             // Warnings: While the following will work as _self is simply a reference to
 *             // this, if anyone overrides myFunction() the overridden will be called first
 *             // as the normal JavaScript method resolution will occur and the defined
 *             // _self.initialize() function is actually gets removed from the instance and
 *             // a proxy prototype version is created to reference the created method.
 *             _self.initialize();
 *         });
 *     }
 * }
 * ```
 * @typeparam DPType This is the generic type of the class, used to keep intellisense valid
 * @typeparam DPCls The type that contains the prototype of the current class
 * @param theClass - This is the current class instance which contains the prototype for the current class
 * @param target - The current "this" (target) reference, when the class has been extended this.prototype will not be the 'theClass' value.
 * @param delegateFunc - The callback function (closure) that will create the dynamic function
 * @param options - Additional options to configure how the dynamic prototype operates
 */
function dynamicProto(theClass, target, delegateFunc, options) {
    // Make sure that the passed theClass argument looks correct
    if (!_hasOwnProperty(theClass, Prototype)) {
        _throwTypeError("theClass is an invalid class definition.");
    }
    // Quick check to make sure that the passed theClass argument looks correct (this is a common copy/paste error)
    var classProto = theClass[Prototype];
    if (!_checkPrototype(classProto, target)) {
        _throwTypeError("[" + _getObjName(theClass) + "] is not in class hierarchy of [" + _getObjName(target) + "]");
    }
    var className = null;
    if (_hasOwnProperty(classProto, DynClassName)) {
        // Only grab the class name if it's defined on this prototype (i.e. don't walk the prototype chain)
        className = classProto[DynClassName];
    }
    else {
        // As not all browser support name on the prototype creating a unique dynamic one if we have not already
        // assigned one, so we can use a simple string as the lookup rather than an object for the dynamic instance
        // function table lookup.
        className = DynClassNamePrefix + _getObjName(theClass, "_") + "$" + _dynamicNames;
        _dynamicNames++;
        classProto[DynClassName] = className;
    }
    var perfOptions = dynamicProto[DynProtoDefaultOptions];
    var useBaseInst = !!perfOptions[strUseBaseInst];
    if (useBaseInst && options && options[strUseBaseInst] !== undefined) {
        useBaseInst = !!options[strUseBaseInst];
    }
    // Get the current instance functions
    var instFuncs = _getInstanceFuncs(target);
    // Get all of the functions for any base instance (before they are potentially overridden)
    var baseFuncs = _getBaseFuncs(classProto, target, instFuncs, useBaseInst);
    // Execute the delegate passing in both the current target "this" and "base" function references
    // Note casting the same type as we don't actually have the base class here and this will provide some intellisense support
    delegateFunc(target, baseFuncs);
    // Don't allow setting instance functions for older IE instances
    var setInstanceFunc = !!_objGetPrototypeOf && !!perfOptions[strSetInstFuncs];
    if (setInstanceFunc && options) {
        setInstanceFunc = !!options[strSetInstFuncs];
    }
    // Populate the Prototype for any overridden instance functions
    _populatePrototype(classProto, className, target, instFuncs, setInstanceFunc !== false);
}
/**
 * Exposes the default global options to allow global configuration, if the global values are disabled these will override
 * any passed values. This is primarily exposed to support unit-testing without the need for individual classes to expose
 * their internal usage of dynamic proto.
 */
var perfDefaults = {
    setInstFuncs: true,
    useBaseInst: true
};
// And expose for testing
dynamicProto[DynProtoDefaultOptions] = perfDefaults;

/* harmony default export */ __webpack_exports__["a"] = (dynamicProto);
//# sourceMappingURL=dynamicproto-js.js.map


/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_CELL_STYLE_PROPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_ROW_HEIGHTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Styling__ = __webpack_require__(5);


var GlobalClassNames = {
    root: 'ms-DetailsRow',
    compact: 'ms-DetailsList--Compact',
    cell: 'ms-DetailsRow-cell',
    cellAnimation: 'ms-DetailsRow-cellAnimation',
    cellCheck: 'ms-DetailsRow-cellCheck',
    cellMeasurer: 'ms-DetailsRow-cellMeasurer',
    listCellFirstChild: 'ms-List-cell:first-child',
    isContentUnselectable: 'is-contentUnselectable',
    isSelected: 'is-selected',
    isCheckVisible: 'is-check-visible',
    fields: 'ms-DetailsRow-fields'
};
var IsFocusableSelector = "[data-is-focusable='true']";
var DEFAULT_CELL_STYLE_PROPS = {
    cellLeftPadding: 12,
    cellRightPadding: 8,
    cellExtraRightPadding: 24
};
// Source of default row heights to share.
var DEFAULT_ROW_HEIGHTS = {
    rowHeight: 42,
    compactRowHeight: 32
};
// Constant values
var values = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, DEFAULT_ROW_HEIGHTS, { rowVerticalPadding: 11, compactRowVerticalPadding: 6, rowShimmerLineHeight: 7, rowShimmerIconPlaceholderHeight: 16, rowShimmerVerticalBorder: 0, compactRowShimmerVerticalBorder: 0 });
// Computed Values
values = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, values, {
    rowShimmerVerticalBorder: (values.rowHeight - values.rowShimmerLineHeight) / 2,
    compactRowShimmerVerticalBorder: (values.compactRowHeight - values.rowShimmerLineHeight) / 2
});
var getStyles = function (props) {
    var theme = props.theme, isSelected = props.isSelected, canSelect = props.canSelect, droppingClassName = props.droppingClassName, anySelected = props.anySelected, isCheckVisible = props.isCheckVisible, checkboxCellClassName = props.checkboxCellClassName, compact = props.compact, className = props.className, _a = props.cellStyleProps, cellStyleProps = _a === void 0 ? DEFAULT_CELL_STYLE_PROPS : _a, enableUpdateAnimations = props.enableUpdateAnimations;
    var _b = theme.palette, neutralPrimary = _b.neutralPrimary, white = _b.white, neutralSecondary = _b.neutralSecondary, neutralLighter = _b.neutralLighter, neutralLight = _b.neutralLight, neutralDark = _b.neutralDark, neutralQuaternaryAlt = _b.neutralQuaternaryAlt, black = _b.black;
    var focusBorder = theme.semanticColors.focusBorder;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    var colors = {
        // Default
        defaultHeaderTextColor: neutralPrimary,
        defaultMetaTextColor: neutralSecondary,
        defaultBackgroundColor: white,
        // Hover
        hoverTextColor: neutralPrimary,
        hoverColorBackground: neutralLighter,
        // Selected
        selectedTextColor: neutralDark,
        selectedMetaTextColor: neutralPrimary,
        selectedBackgroundColor: neutralLight,
        // Selected Hover
        selectedHoverTextColor: black,
        selectedHoverMetaTextColor: neutralDark,
        selectedHoverBackgroundColor: neutralQuaternaryAlt,
        // Focus
        focusHeaderTextColor: black,
        focusBackgroundColor: neutralQuaternaryAlt,
        focusMetaTextColor: neutralDark
    };
    var shimmerRightBorderStyle = cellStyleProps.cellRightPadding * 4 + "px solid " + colors.defaultBackgroundColor;
    var shimmerLeftBorderStyle = cellStyleProps.cellLeftPadding + "px solid " + colors.defaultBackgroundColor;
    var selectedStyles = [
        Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["v" /* getFocusStyle */])(theme, { inset: -1, borderColor: focusBorder, outlineColor: white }),
        classNames.isSelected,
        {
            color: colors.selectedMetaTextColor,
            background: colors.selectedBackgroundColor,
            borderBottom: "1px solid " + white,
            selectors: (_c = {
                    '&:before': {
                        position: 'absolute',
                        display: 'block',
                        top: -1,
                        height: 1,
                        bottom: 0,
                        left: 0,
                        right: 0,
                        content: '',
                        borderTop: "1px solid " + white
                    },
                    // Selected State hover
                    '&:hover': {
                        background: colors.selectedHoverBackgroundColor,
                        selectors: (_d = {
                                // Selected State hover meta cell
                                $cell: {
                                    color: colors.selectedHoverMetaTextColor,
                                    selectors: (_e = {},
                                        _e[__WEBPACK_IMPORTED_MODULE_1__Styling__["g" /* HighContrastSelector */]] = {
                                            color: 'HighlightText',
                                            selectors: {
                                                '> a': {
                                                    color: 'HighlightText'
                                                }
                                            }
                                        },
                                        // Selected State hover Header cell
                                        _e['&.$isRowHeader'] = {
                                            color: colors.selectedHoverTextColor,
                                            selectors: (_f = {},
                                                _f[__WEBPACK_IMPORTED_MODULE_1__Styling__["g" /* HighContrastSelector */]] = {
                                                    color: 'HighlightText'
                                                },
                                                _f)
                                        },
                                        _e)
                                }
                            },
                            // Ensure high-contrast mode overrides default hover background
                            _d[__WEBPACK_IMPORTED_MODULE_1__Styling__["g" /* HighContrastSelector */]] = {
                                background: 'Highlight'
                            },
                            _d)
                    },
                    // Focus state
                    '&:focus': {
                        background: colors.focusBackgroundColor,
                        selectors: (_g = {
                                // Selected State hover meta cell
                                $cell: {
                                    color: colors.focusMetaTextColor,
                                    // Row header cell
                                    '&.$isRowHeader': {
                                        color: colors.focusHeaderTextColor,
                                        selectors: (_h = {},
                                            _h[__WEBPACK_IMPORTED_MODULE_1__Styling__["g" /* HighContrastSelector */]] = {
                                                color: 'HighlightText'
                                            },
                                            _h)
                                    }
                                }
                            },
                            // Ensure high-contrast mode overrides default focus background
                            _g[__WEBPACK_IMPORTED_MODULE_1__Styling__["g" /* HighContrastSelector */]] = {
                                background: 'Highlight'
                            },
                            _g)
                    }
                },
                _c[__WEBPACK_IMPORTED_MODULE_1__Styling__["g" /* HighContrastSelector */]] = {
                    background: 'Highlight',
                    color: 'HighlightText',
                    MsHighContrastAdjust: 'none',
                    selectors: {
                        a: {
                            color: 'HighlightText'
                        }
                    }
                },
                _c)
        }
    ];
    var cannotSelectStyles = [
        classNames.isContentUnselectable,
        {
            userSelect: 'none',
            cursor: 'default'
        }
    ];
    var rootCompactStyles = {
        minHeight: values.compactRowHeight,
        border: 0
    };
    var cellCompactStyles = {
        minHeight: values.compactRowHeight,
        paddingTop: values.compactRowVerticalPadding,
        paddingBottom: values.compactRowVerticalPadding,
        paddingLeft: cellStyleProps.cellLeftPadding + "px",
        selectors: (_j = {},
            // Masking the running shimmer background with borders
            _j["&$shimmer"] = {
                padding: 0,
                borderLeft: shimmerLeftBorderStyle,
                borderRight: shimmerRightBorderStyle,
                borderTop: values.compactRowShimmerVerticalBorder + "px solid " + colors.defaultBackgroundColor,
                borderBottom: values.compactRowShimmerVerticalBorder + "px solid " + colors.defaultBackgroundColor
            },
            // Masking the running shimmer background with borders when it's an Icon placeholder
            _j["&$shimmerIconPlaceholder"] = {
                borderRight: cellStyleProps.cellRightPadding + "px solid " + colors.defaultBackgroundColor,
                borderBottom: (values.compactRowHeight - values.rowShimmerIconPlaceholderHeight) / 2 + "px solid " + colors.defaultBackgroundColor,
                borderTop: (values.compactRowHeight - values.rowShimmerIconPlaceholderHeight) / 2 + "px solid " + colors.defaultBackgroundColor
            },
            _j)
    };
    var defaultCellStyles = [
        Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["v" /* getFocusStyle */])(theme, { inset: -1 }),
        classNames.cell,
        {
            display: 'inline-block',
            position: 'relative',
            boxSizing: 'border-box',
            minHeight: values.rowHeight,
            verticalAlign: 'top',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            paddingTop: values.rowVerticalPadding,
            paddingBottom: values.rowVerticalPadding,
            paddingLeft: cellStyleProps.cellLeftPadding + "px",
            selectors: (_k = {
                    '& > button': {
                        maxWidth: '100%'
                    }
                },
                _k[IsFocusableSelector] = Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["v" /* getFocusStyle */])(theme, { inset: -1, borderColor: neutralSecondary, outlineColor: white }),
                _k['&$shimmer'] = {
                    padding: 0,
                    borderLeft: shimmerLeftBorderStyle,
                    borderRight: shimmerRightBorderStyle,
                    borderTop: values.rowShimmerVerticalBorder + "px solid " + colors.defaultBackgroundColor,
                    borderBottom: values.rowShimmerVerticalBorder + "px solid " + colors.defaultBackgroundColor
                },
                _k['&$shimmerIconPlaceholder'] = {
                    borderRight: cellStyleProps.cellRightPadding + "px solid " + colors.defaultBackgroundColor,
                    borderBottom: (values.rowHeight - values.rowShimmerIconPlaceholderHeight) / 2 + "px solid " + colors.defaultBackgroundColor,
                    borderTop: (values.rowHeight - values.rowShimmerIconPlaceholderHeight) / 2 + "px solid " + colors.defaultBackgroundColor
                },
                _k)
        },
        compact && cellCompactStyles
    ];
    return {
        root: [
            classNames.root,
            __WEBPACK_IMPORTED_MODULE_1__Styling__["a" /* AnimationClassNames */].fadeIn400,
            droppingClassName,
            theme.fonts.small,
            isCheckVisible && classNames.isCheckVisible,
            Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["v" /* getFocusStyle */])(theme, { borderColor: focusBorder, outlineColor: white }),
            {
                borderBottom: "1px solid " + neutralLighter,
                background: colors.defaultBackgroundColor,
                color: colors.defaultMetaTextColor,
                display: 'inline-flex',
                minWidth: '100%',
                minHeight: values.rowHeight,
                whiteSpace: 'nowrap',
                padding: 0,
                boxSizing: 'border-box',
                verticalAlign: 'top',
                textAlign: 'left',
                selectors: (_l = {},
                    _l[classNames.listCellFirstChild + " &:before"] = {
                        display: 'none'
                    },
                    _l['&:hover'] = {
                        background: colors.hoverColorBackground
                    },
                    _l['&:hover $check'] = {
                        opacity: 1
                    },
                    _l)
            },
            isSelected && selectedStyles,
            !canSelect && cannotSelectStyles,
            compact && rootCompactStyles,
            className
        ],
        cellUnpadded: {
            paddingRight: cellStyleProps.cellRightPadding + "px"
        },
        cellPadded: {
            paddingRight: cellStyleProps.cellExtraRightPadding + cellStyleProps.cellRightPadding + "px",
            selectors: {
                '&.$checkCell': {
                    paddingRight: 0
                }
            }
        },
        cell: defaultCellStyles,
        cellAnimation: enableUpdateAnimations && __WEBPACK_IMPORTED_MODULE_1__Styling__["b" /* AnimationStyles */].slideLeftIn40,
        cellMeasurer: [
            classNames.cellMeasurer,
            {
                overflow: 'visible',
                whiteSpace: 'nowrap'
            }
        ],
        checkCell: [
            defaultCellStyles,
            classNames.cellCheck,
            checkboxCellClassName,
            {
                padding: 0,
                // Ensure that the check cell covers the top border of the cell.
                // This ensures the click target does not leave a spot which would
                // cause other items to be deselected.
                paddingTop: 1,
                marginTop: -1,
                flexShrink: 0
            }
        ],
        checkCover: {
            position: 'absolute',
            top: -1,
            left: 0,
            bottom: 0,
            right: 0,
            display: anySelected ? 'block' : 'none'
        },
        fields: [
            classNames.fields,
            {
                display: 'flex',
                alignItems: 'stretch'
            }
        ],
        isRowHeader: [
            {
                color: colors.defaultHeaderTextColor,
                fontSize: __WEBPACK_IMPORTED_MODULE_1__Styling__["e" /* FontSizes */].medium
            }
        ],
        isMultiline: [
            defaultCellStyles,
            {
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                textOverflow: 'clip'
            }
        ],
        shimmer: [],
        shimmerIconPlaceholder: [],
        shimmerLeftBorder: [
            {
                // 40px to take into account the checkbox of items if present.
                borderLeft: "40px solid " + colors.defaultBackgroundColor
            }
        ],
        shimmerBottomBorder: [
            {
                // 1px to take into account the border-bottom when items replace shimmer lines and in default state.
                borderBottom: "1px solid " + colors.defaultBackgroundColor
            }
        ],
        check: []
    };
    var _c, _d, _e, _f, _g, _h, _j, _k, _l;
};
//# sourceMappingURL=DetailsRow.styles.js.map

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Spinner_index__ = __webpack_require__(1708);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Spinner_index__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Spinner_index__["b"]; });

//# sourceMappingURL=Spinner.js.map

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FooterContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_styled_components__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Button__ = __webpack_require__(10);
var _templateObject=_taggedTemplateLiteral(['\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: flex-end;\n  > button:not(:last-child) {\n    margin-right: 5px;\n  }\n\n  @media screen and (max-width: 321px) {\n    flex-flow: row wrap;\n    > button {\n      margin: 0 5px 5px 0;\n      width: 47%;\n    }\n  }\n'],['\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: flex-end;\n  > button:not(:last-child) {\n    margin-right: 5px;\n  }\n\n  @media screen and (max-width: 321px) {\n    flex-flow: row wrap;\n    > button {\n      margin: 0 5px 5px 0;\n      width: 47%;\n    }\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var FooterContainer=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_styled_components__["a" /* default */].div(_templateObject);var PanelFooter=function PanelFooter(_ref){var saveBtnLabel=_ref.saveBtnLabel,closeBtnLabel=_ref.closeBtnLabel,onSave=_ref.onSave,onClose=_ref.onClose,saveDisabled=_ref.saveDisabled;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(FooterContainer,null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Button__["h" /* PrimaryButton */],{onClick:onSave,disabled:saveDisabled},saveBtnLabel||'Submit'),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Button__["f" /* DefaultButton */],{onClick:onClose},closeBtnLabel||'Close'));};PanelFooter.propTypes={saveBtnLabel:__WEBPACK_IMPORTED_MODULE_1__build_node_modules_prop_types___default.a.string,closeBtnLabel:__WEBPACK_IMPORTED_MODULE_1__build_node_modules_prop_types___default.a.string,onSubmit:__WEBPACK_IMPORTED_MODULE_1__build_node_modules_prop_types___default.a.func,onClose:__WEBPACK_IMPORTED_MODULE_1__build_node_modules_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["b"] = (PanelFooter);

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.29.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key;
                for (i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i;
            for (i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
                    matched,
                    p1,
                    p2,
                    p3,
                    p4
                ) {
                    return p1 || p2 || p3 || p4;
                })
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
            '_'
        ),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^)]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
        input,
        array,
        config,
        token
    ) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) {
            getParsingFlags(config).era = era;
        } else {
            getParsingFlags(config).invalidEra = input;
        }
    });

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(657)(module)))

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Image_index__ = __webpack_require__(1840);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Image_index__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Image_index__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Image_index__["c"]; });

//# sourceMappingURL=Image.js.map

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_lodash__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_localized_countries__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_localized_countries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_localized_countries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_localized_countries_data_de__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_localized_countries_data_de___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_localized_countries_data_de__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_localized_countries_data_en__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_localized_countries_data_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_localized_countries_data_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_localized_countries_data_es__ = __webpack_require__(1652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_localized_countries_data_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_localized_countries_data_es__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_localized_countries_data_fi__ = __webpack_require__(1653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_localized_countries_data_fi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_localized_countries_data_fi__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_node_modules_localized_countries_data_sl__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_node_modules_localized_countries_data_sl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_localized_countries_data_sl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__build_node_modules_localized_countries_data_ro__ = __webpack_require__(1011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__build_node_modules_localized_countries_data_ro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__build_node_modules_localized_countries_data_ro__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__build_node_modules_localized_countries_data_fr__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__build_node_modules_localized_countries_data_fr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__build_node_modules_localized_countries_data_fr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__build_src_app_config__ = __webpack_require__(901);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();/* harmony default export */ __webpack_exports__["default"] = (Object.assign({},__WEBPACK_IMPORTED_MODULE_9__build_src_app_config__["a" /* default */],{customerSupport:{email:'support@propnow.com',phone:'+49 30 959992518'},localeCodes:['de-DE'],buyerTypes:['private','company'],ownershipTypes:['sole','joint','share'],maritalStatuses:['none','single','married'],companyLegalForms:['simple_society','general_partnership','limited_partnership','joint-stock_company','kommandit-aktiengesellschaft','limited_liability_company','cooperative','society','foundation','other'],documentTypes:['annual_statement','appraisal','area_allocation_plan','area_measurement','building_permit','easement_register','energy_certificate','expose','insurance_policy','land_register','location_map','partition_deed','partition_plan','rental_contract','reserves','utility_costs','other'],uploadTypes:['identity_document','proof_of_financial_resources'],defaultUploadTypes:[],requiredUploadTypes:[],titleTypes:['doctor','professor'],provisionTypes:['none','fixed_amount','fixed_percentage'],defaultProvisionType:'none',depositTypes:['none','percentage'],provision_percentage_max:100,deposit_percentage_max:10,handoverTypes:['land_register','money_transfer','key_handover','sale_contract'],privateSellers:['private','privat-bieterportal','bvbi'],disableRightOfWithdrawal:['wuestenrot'],disableSaleToC:['kski'],hideKnownDefects:['kski'],defaultSaleOfferData:{},mlsTypes:['none','tenant','everyone'],roundTypes:['incremental_auction','sealed_bidding','simple_offer'],// roundTypeBadges: {
//   incremental_auction: ['new'],
//   simple_offer: ['new', 'free'],
// },
saleCountryOverride:{de:{handoverTypes:['land_register','money_transfer','key_handover','sale_contract'],defaultSaleOfferData:{handover:'sale_contract'}},ch:{currency:{code:'CHF',symbol:'CHF'},localeCodes:['de-CH','fr-CH','it-CH','en'],uploadTypes:['identity_document','residence_permit','proof_of_financial_resources'],ownershipTypes:['ae','ge','meg','stwe'],defaultProvisionType:'none',depositTypes:['none','fixed_amount','percentage'],swissResidentialStatuses:['B','C','Ci','G','L','F','N','S','none'],martialStatuses:['none','single','married','divorced','widowed']},si:{currency:{code:'EUR',symbol:'EUR'},localeCodes:['sl-SI'],uploadTypes:['identity_document','proof_of_financial_resources','confirmation_of_payment_reservation'],mlsTypes:['none'],depositTypes:['none','fixed_amount','percentage'],defaultProvisionType:'none',companyLegalForms:['limited_liability_company','unlimited_liability_company','self_employed','jointstock_company','kommanditaktiengesellschaft','foundation','other']},at:{localeCodes:['de-AT','en'],ownershipTypes:['sole','joint','partnership','share','condominium'],provisionTypes:['none','standard_at','fixed_amount','fixed_percentage'],defaultProvisionType:'standard_at',allowConditionsInRounds:['incremental_auction','simple_offer']},gb:{currency:{code:'GBP',symbol:'£'},roundHideValidity:true,localeCodes:['en-GB'],saleEditTotalPages:2,defaultUploadTypes:[],documentTypes:['expose','energy_certificate'],salePropertyTypes:['house','flat','property','office','business','other'],defaultSaleOfferData:{timezone:'Europe/London'}},fi:{roundTypes:['open_bidding','sealed_bidding'],salePropertyTypes:['flat'],localeCodes:['fi-FI','en'],defaultSaleOfferData:{timezone:'Europe/Helsinki'},paymentTypes:['none','deposit','penalty'],depositTypes:['none','fixed_amount','percentage'],penaltyTypes:['none','fixed_amount','percentage'],handoverTypes:['land_register','money_transfer'],documentTypes:['brochure','real_estate_managers_certificate','share_based_dwelling_printout','share_register_printout','financial_statements','articles_of_association','floor_plan','moisture_measurement_and_condition_audit_reports','condition_of_the_building_report','maintenance_needs_report','long_term_repair_plan','maintenance_plan','energy_performance_certificate','repairs_and_alterations_report','lease','floor_area_measurement_record','certificate_of_title','encumbrance_certificate','cadastral_certificate']},it:{customerSupport:{email:'sales@propnow.com',phone:'+39 02 3858 5482'},// roundTypes: ['open_bidding', 'sealed_bidding'],
localeCodes:['it-IT','en','de'],buyerTypes:['private','company','entrepreneur'],sellerTypes:['private','company','entrepreneur'],usageTypes:['residential','commercial','industrial','service','tourist'],objectProvenanceTypes:['sale','donation','succession','other'],objectProvenanceTypesWithDetails:['sale','donation','succession'],cadastralComplianceTypes:['compliant','noncompliant_fixed'],regulationComplianceTypes:['guaranteed','not_guaranteed'],occupationTypes:['free','rented'],debtTypes:['none','mortgage','lien','judical_claim','forclosure'],documentTypes:['expose','origin_deed','cadastral_survey','cadastral_plan','energy_certificate'],depositTypes:['none','fixed_amount'],uploadTypes:['identity_document','proof_of_financial_resources'],defaultUploadTypes:[],requiredUploadTypes:[],defaultSaleOfferData:{due_diligence_deadline_days:7,deposit_type:'fixed_amount',deposit_transfer_owner:'Parte Venditrice'}},za:{currency:{code:'ZAR'},localeCodes:['en-ZA'],sellerTypes:['private','company'],depositTypes:['none','fixed_amount','percentage'],handoverTypes:['transfer'],salutationTypes:['mr','mrs','ms','miss'],timezone:'Africa/Johannesburg',defaultSaleOfferData:{timezone:'Africa/Johannesburg'},offerData:{onUpdate:{offer_variant:{residential:{offer_template_version:'v8'},commercial:{offer_template_version:'v6'}}}},documentTypes:['brochure','property_condition_report','tenancy_overview'],defaultUploadTypes:[],// proof of funds is preselected for commercial OTPs only
getDefaultUploadTypes:function getDefaultUploadTypes(offerData){return offerData.offer_variant==='commercial'?['proof_of_financial_resources']:[];},certificateTypes:['electrical_compliance_certificate','gas_installation','electrical_fence_certificate','beetle_certificate','water_certificate','plumbing_certificate','alien_and_invasive_species_regulations'],getRequiredDocumentTypes:function getRequiredDocumentTypes(sale,offerData){var types=['property_condition_report'];if(offerData.offer_variant==='commercial'&&offerData.occupation==='multi_tenancies'){types.push('tenancy_overview');}return types;}},es:{localeCodes:['es-ES','de','en'],buyerTypes:['private','company'],sellerTypes:['private','company'],usageTypes:['residential','commercial','industrial','service','tourist'],debtTypes:['','mortgage','lien','judical_claim','foreclosure'],uploadTypes:['identity_document','proof_of_financial_resources'],defaultUploadTypes:[],requiredUploadTypes:[],defaultSaleOfferData:{signing_deadline_days:10,closing_seller_target_days:60,closing_seller_deadline_days:60,deposit_type:'fixed_amount',security_type:'percentage',security_percentage:10,costs_deed:'law',timezone:'Europe/Madrid'},sellerIdTypes:['dni','nie','nif','personal_id','passport'],objectProvenanceTypes:['sale','donation','succession','awarding','other'],depositTypes:['none','fixed_amount'],securityTypes:['none','percentage']},vi:{timezone:'America/Virgin',deedTypes:['warranty','special_warranty','quitclaim'],tenancyTypes:['free','occupied'],salutationTypes:['mr','mrs','ms','miss'],localeCodes:['en-US'],currency:{code:'USD'},defaultSaleOfferData:{timezone:'America/Virgin',agent_representing:true,closing_location:'St. Thomas'},agentRegistrationDefaultTenant:'propnow-vi'},pr:{saleEditTotalPages:2,timezone:'America/Puerto_Rico',localeCodes:['en-PR'],currency:{code:'USD'},defaultSaleOfferData:{timezone:'America/Puerto_Rico'}},bs:{saleEditTotalPages:2,timezone:'America/Nassau',localeCodes:['en-BS'],currency:{code:'USD'},defaultSaleOfferData:{timezone:'America/Nassau'}},ro:{localeCodes:['ro-RO'],buyerTypes:['private','company'],ownershipTypes:['sole','share'],documentTypes:['commercial_register_proof','proof_of_ownership','ownership_deed','property_sketch','energy_certificate','land_register','photo','seller_statements','location_map','building_permit','technical_documentation','cadastral_documentation','cadastral_plan','area_allocation_plan','lease_agreement','other'],uploadTypes:['identity_document'],defaultUploadTypes:['identity_document'],requiredUploadTypes:['identity_document'],objectConstructionTypes:['concrete','brick','bca','wood','metal','frame','plates','monolith','other'],sellerTypes:['private','company'],provisionTypes:['none','fixed_amount','fixed_percentage'],saleCurrencies:['EUR'],maritalStatuses:['none','single','married'],prenuptialAgreementValues:['yes','no'],idDocumentTypes:['national_id','passport'],vatValues:[5,19],getRequiredDocumentTypes:function getRequiredDocumentTypes(sale,offerData){var result={};if(offerData.object_type==='property')result['property']=['ownership_deed','property_sketch','land_register'];else result['property']=['ownership_deed','property_sketch','energy_certificate','land_register'];return result;},getRegistrationScheme:function getRegistrationScheme(sale,t){var scheme=__WEBPACK_IMPORTED_MODULE_9__build_src_app_config__["a" /* default */].getRegistrationScheme.call(this,sale,t);delete scheme.title;if(sale.offerData.deposit_type&&sale.offerData.deposit_type!=='none'){scheme.depositRequired={type:'dropdown',options:[true,false],required:true,target:['offerData.deposit_type'],transform:function transform(value){if(value)return sale.offerData&&sale.offerData.deposit_type?sale.offerData.deposit_type:'fixed_amount';else return'none';}};}return scheme;}},lu:{customerSupport:{email:'support@propnow.com',phone:'+49 30 959992518'},localeCodes:['fr-LU'],roundDefaultDurationInDays:3,durationTypes:['fixed'],buyerTypes:['private','company'],sellerTypes:['private','company'],ownershipTypes:['sole','joint','share'],depositTypes:['none','fixed_amount'],companyLegalForms:['simple_society','general_partnership','limited_partnership','joint-stock_company','kommandit-aktiengesellschaft','limited_liability_company','cooperative','society','foundation','other'],handoverTypes:['key_handover','contract'],documentTypes:['expose','land_register','building_permit','energy_certificate','appraisal','promissory_note'],uploadTypes:['identity_document','proof_of_financial_resources'],defaultUploadTypes:[],requiredUploadTypes:[],saleActions:['award','confirmAward','counteroffer','increase','rejectAll','duplicate','notifySeller'],mlsTypes:['everyone'],getRegistrationScheme:function getRegistrationScheme(sale,t){var scheme=__WEBPACK_IMPORTED_MODULE_9__build_src_app_config__["a" /* default */].getRegistrationScheme.call(this,sale,t);delete scheme.title;return scheme;},roundTypes:['sealed_bidding','counteroffer_bidding'],allowConditionsInRounds:['sealed_bidding','counteroffer_bidding'],getRoundTypes:function getRoundTypes(store){if(store.round&&store.round.status==='closed'){return['sealed_bidding','counteroffer_bidding'];}return['sealed_bidding'];}}},saleCommands:['whitelisting','edit','preview','previewPdf','delete','close','overview','download','manage','notifications','settings','messaging','inviteSeller','inviteBuyerAgent'],getRegistrationScheme:function getRegistrationScheme(sale,t){var scheme=__WEBPACK_IMPORTED_MODULE_9__build_src_app_config__["a" /* default */].getRegistrationScheme.call(this,sale,t);scheme.email.headers.push('E-Mail Firma');scheme.phone.headers=[].concat(scheme.phone.headers,['Telefon','Telefon (privat)','Telefon (geschäftlich)','Mobiltelefon','Telefon Firma','Telefon (privat) Firma','Telefon (geschäftlich) Firma','Mobiltelefon Firma']);scheme.salutation.headers.push('Anrede Firma');scheme.firstName.headers.push('Vorname Firma');scheme.lastName.headers.push('Nachname Firma');scheme.title.headers.push('Titel Firma');scheme=Object.assign(scheme,{street:{title:t('Street'),type:'textfield',target:'buyerData.buyer_street',headers:[t('Street'),'street','Straße','Straße Firma'],additional:true},street_additional:{title:t('House number'),type:'textfield',target:'buyerData.buyer_street_additional',headers:[t('House number'),'house number','Hausnummer','Hausnummer Firma'],additional:true},zip:{title:t('ZIP code'),type:'textfield',target:'buyerData.buyer_zip',headers:[t('ZIP code'),t('Postal code'),'zip','PLZ','PLZ Firma'],additional:true},city:{title:t('City'),type:'textfield',target:'buyerData.buyer_city',headers:[t('City'),'city','Stadt','Stadt Firma'],additional:true},country_code:{title:t('Country'),type:'textfield',target:'buyerData.buyer_country_code',headers:[t('Country'),'country','Land','Land Firma'],import:function _import(value,item,data){return value==='D'?'DE':value;}},country:{title:t('Country'),type:'textfield',target:'buyerData.buyer_country',additional:true,import:function _import(value,item,data){return item['country_code']==='DE'?'Deutschland':item['country_code'];}},citizenship_code:{title:t('Citizenship'),type:'textfield',target:'buyerData.buyer_citizenship_code',additional:true,import:function _import(value,item,data){return'DE';}},citizenship:{title:t('Citizenship'),type:'textfield',target:'buyerData.buyer_citizenship',additional:true,import:function _import(value,item,data){return'Deutschland';}},dob:{title:t('Date of birth'),type:'textfield',target:'buyerData.buyer_dob',headers:[t('Date of birth'),'birth date','Geburtstag','dob'],additional:true},pob:{title:t('Place of birth'),type:'textfield',target:'buyerData.buyer_pob',headers:[t('Place of birth'),'birth place','Geburtsort','pob'],additional:true},company:{title:t('Company'),type:'textfield',target:'buyerData.buyer_company_name',headers:[t('Company'),t('Company name'),'company','Firma'],additional:true},buyer_type:{type:'textfield',target:'buyerData.buyer_type',transform:function transform(value,item){return!!item.company?'company':'private';},additional:true},other_email:{title:t('Email'),type:'textfield',target:'buyerData.others[0].buyer_email',headers:['E-Mail Partner','Mobiltelefon Partner'],additional:true},other_phone:{title:t('Phone number'),type:'textfield',target:'buyerData.others[0].buyer_phone',headers:['Telefon (privat) Partner'],additional:true},other_salutation:{title:t('Salutation'),type:'textfield',options:this.salutationTypes,localizationPrefixOverride:'salutation',target:'buyerData.others[0].buyer_salutation',headers:['Anrede Partner'],additional:true},other_title:{title:t('Title'),type:'textfield',target:'buyerData.others[0].buyer_title',headers:['Titel Partner'],additional:true},other_firstName:{title:t('First name'),type:'textfield',target:'buyerData.others[0].buyer_firstName',headers:['Vorname Partner'],additional:true},other_lastName:{title:t('Last name'),type:'textfield',target:'buyerData.others[0].buyer_lastName',headers:['Nachname Partner'],additional:true},other_street:{title:t('Street'),type:'textfield',target:'buyerData.others[0].buyer_street',headers:['Straße Partner'],additional:true},other_street_additional:{title:t('House number'),type:'textfield',target:'buyerData.others[0].buyer_street_additional',headers:['Hausnummer Partner'],additional:true},other_zip:{title:t('ZIP code'),type:'textfield',target:'buyerData.others[0].buyer_zip',headers:['PLZ Partner'],additional:true},other_city:{title:t('City'),type:'textfield',target:'buyerData.others[0].buyer_city',headers:['Stadt Partner'],additional:true},other_country_code:{title:t('Country code'),type:'textfield',target:'buyerData.others[0].buyer_country_code',headers:['Land Partner'],additional:true,import:function _import(value,item,data){return value==='D'?'DE':value;}},other_country:{title:t('Country'),type:'textfield',target:'buyerData.others[0].buyer_country',additional:true,import:function _import(value,item,data){return item['other_country_code']==='DE'?'Deutschland':item['other_country_code'];}},other_buyer_citizenship_code:{title:t('Citizenship code'),type:'textfield',target:'buyerData.others[0].buyer_citizenship_code',additional:true,transform:function transform(value,item){return!!item.other_email?'DE':null;}},other_buyer_citizenship:{title:t('Citizenship'),type:'textfield',target:'buyerData.others[0].buyer_citizenship',additional:true,transform:function transform(value,item){return!!item.other_email?'Deutschland':null;}},other_dob:{title:t('Date of birth'),type:'textfield',target:'buyerData.others[0].buyer_dob',headers:['Geburtstag Partner'],additional:true}});return scheme;},createOffer:function createOffer(sale,round){var withBuyerData=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;var offer=__WEBPACK_IMPORTED_MODULE_9__build_src_app_config__["a" /* default */].createOffer.call(this,sale,round,withBuyerData);if(!!sale.offerData.sale_country){var buyerData=withBuyerData?getCountryData(this,sale.offerData.sale_country):{};offer=__WEBPACK_IMPORTED_MODULE_0__build_node_modules_lodash___default.a.merge(offer,{offerData:{sale_country:sale.offerData.sale_country},buyerData:buyerData});}return offer;}}));function getCountryData(config,sale_country){var localizationData={de:__WEBPACK_IMPORTED_MODULE_2__build_node_modules_localized_countries_data_de___default.a,en:__WEBPACK_IMPORTED_MODULE_3__build_node_modules_localized_countries_data_en___default.a,fi:__WEBPACK_IMPORTED_MODULE_5__build_node_modules_localized_countries_data_fi___default.a,sl:__WEBPACK_IMPORTED_MODULE_6__build_node_modules_localized_countries_data_sl___default.a,es:__WEBPACK_IMPORTED_MODULE_4__build_node_modules_localized_countries_data_es___default.a,ro:__WEBPACK_IMPORTED_MODULE_7__build_node_modules_localized_countries_data_ro___default.a,fr:__WEBPACK_IMPORTED_MODULE_8__build_node_modules_localized_countries_data_fr___default.a};var _config$localeCodes$=config.localeCodes[0].split('-'),_config$localeCodes$2=_slicedToArray(_config$localeCodes$,1),locale=_config$localeCodes$2[0];var countries=__WEBPACK_IMPORTED_MODULE_1__build_node_modules_localized_countries___default()(localizationData[locale]||__WEBPACK_IMPORTED_MODULE_2__build_node_modules_localized_countries_data_de___default.a);var countryCode=sale_country.toUpperCase();var country=countries.get(countryCode);var hasCitizenship=['de','ch','at','fi','gb','ro','si'].includes(sale_country);return{buyer_citizenship:hasCitizenship?country:undefined,buyer_citizenship_code:hasCitizenship?countryCode:undefined,buyer_country:country,buyer_country_code:countryCode};}

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(23)) {
  var LIBRARY = __webpack_require__(113);
  var global = __webpack_require__(14);
  var fails = __webpack_require__(16);
  var $export = __webpack_require__(3);
  var $typed = __webpack_require__(228);
  var $buffer = __webpack_require__(349);
  var ctx = __webpack_require__(71);
  var anInstance = __webpack_require__(131);
  var propertyDesc = __webpack_require__(124);
  var hide = __webpack_require__(58);
  var redefineAll = __webpack_require__(133);
  var toInteger = __webpack_require__(73);
  var toLength = __webpack_require__(21);
  var toIndex = __webpack_require__(523);
  var toAbsoluteIndex = __webpack_require__(127);
  var toPrimitive = __webpack_require__(92);
  var has = __webpack_require__(63);
  var classof = __webpack_require__(140);
  var isObject = __webpack_require__(17);
  var toObject = __webpack_require__(27);
  var isArrayIter = __webpack_require__(338);
  var create = __webpack_require__(128);
  var getPrototypeOf = __webpack_require__(66);
  var gOPN = __webpack_require__(129).f;
  var getIterFn = __webpack_require__(340);
  var uid = __webpack_require__(125);
  var wks = __webpack_require__(20);
  var createArrayMethod = __webpack_require__(95);
  var createArrayIncludes = __webpack_require__(218);
  var speciesConstructor = __webpack_require__(168);
  var ArrayIterators = __webpack_require__(343);
  var Iterators = __webpack_require__(142);
  var $iterDetect = __webpack_require__(223);
  var setSpecies = __webpack_require__(130);
  var arrayFill = __webpack_require__(342);
  var arrayCopyWithin = __webpack_require__(512);
  var $DP = __webpack_require__(25);
  var $GOPD = __webpack_require__(65);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(518);
var $export = __webpack_require__(3);
var shared = __webpack_require__(164)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(521))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SPACER_WIDTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GroupSpacer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var SPACER_WIDTH = 32;
var GroupSpacer = function (props) {
    var count = props.count, _a = props.indentWidth, indentWidth = _a === void 0 ? SPACER_WIDTH : _a;
    var width = count * indentWidth;
    return count > 0 ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: 'ms-GroupSpacer', style: { display: 'inline-block', width: width } }) : null;
};
//# sourceMappingURL=GroupSpacer.js.map

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Tooltip_index__ = __webpack_require__(1774);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Tooltip_index__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Tooltip_index__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Tooltip_index__["c"]; });

//# sourceMappingURL=Tooltip.js.map

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Label_index__ = __webpack_require__(1780);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Label_index__["a"]; });

//# sourceMappingURL=Label.js.map

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Persona_index__ = __webpack_require__(736);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Persona_index__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Persona_index__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Persona_index__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Persona_index__["e"]; });

//# sourceMappingURL=Persona.js.map

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dialog_index__ = __webpack_require__(710);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Dialog_index__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Dialog_index__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Dialog_index__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Dialog_index__["a"]; });


//# sourceMappingURL=Dialog.js.map

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MessageBar_index__ = __webpack_require__(1994);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_MessageBar_index__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__components_MessageBar_index__["b"]; });

//# sourceMappingURL=MessageBar.js.map

/***/ }),
/* 113 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(125)('meta');
var isObject = __webpack_require__(17);
var has = __webpack_require__(63);
var setDesc = __webpack_require__(25).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(16)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(20)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(58)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
 * Microsoft Dynamic Proto Utility, 1.1.4
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
 * Constant string defined to support minimization
 * @ignore
 */
var Constructor = 'constructor';
/**
 * Constant string defined to support minimization
 * @ignore
 */
var Prototype = 'prototype';
/**
 * Constant string defined to support minimization
 * @ignore
 */
var strFunction = 'function';
/**
 * Used to define the name of the instance function lookup table
 * @ignore
 */
var DynInstFuncTable = '_dynInstFuncs';
/**
 * Name used to tag the dynamic prototype function
 * @ignore
 */
var DynProxyTag = '_isDynProxy';
/**
 * Name added to a prototype to define the dynamic prototype "class" name used to lookup the function table
 * @ignore
 */
var DynClassName = '_dynClass';
/**
 * Prefix added to the classname to avoid any name clashes with other instance level properties
 * @ignore
 */
var DynClassNamePrefix = '_dynCls$';
/**
 * A tag which is used to check if we have already to attempted to set the instance function if one is not present
 * @ignore
 */
var DynInstChkTag = '_dynInstChk';
/**
 * A tag which is used to check if we are allows to try and set an instance function is one is not present. Using the same
 * tag name as the function level but a different const name for readability only.
 */
var DynAllowInstChkTag = DynInstChkTag;
/**
 * The global (imported) instances where the global performance options are stored
 */
var DynProtoDefaultOptions = '_dfOpts';
/**
 * Value used as the name of a class when it cannot be determined
 * @ignore
 */
var UnknownValue = '_unknown_';
/**
 * Constant string defined to support minimization
 * @ignore
 */
var str__Proto = "__proto__";
/**
 * Constant string defined to support minimization
 * @ignore
 */
var strUseBaseInst = 'useBaseInst';
/**
 * Constant string defined to support minimization
 * @ignore
 */
var strSetInstFuncs = 'setInstFuncs';
var Obj = Object;
/**
 * Pre-lookup to check if we are running on a modern browser (i.e. not IE8)
 * @ignore
 */
var _objGetPrototypeOf = Obj["getPrototypeOf"];
/**
 * Internal Global used to generate a unique dynamic class name, every new class will increase this value
 * @ignore
 */
var _dynamicNames = 0;
/**
 * Helper to check if the object contains a property of the name
 * @ignore
 */
function _hasOwnProperty(obj, prop) {
    return obj && Obj[Prototype].hasOwnProperty.call(obj, prop);
}
/**
 * Helper used to check whether the target is an Object prototype or Array prototype
 * @ignore
 */
function _isObjectOrArrayPrototype(target) {
    return target && (target === Obj[Prototype] || target === Array[Prototype]);
}
/**
 * Helper used to check whether the target is an Object prototype, Array prototype or Function prototype
 * @ignore
 */
function _isObjectArrayOrFunctionPrototype(target) {
    return _isObjectOrArrayPrototype(target) || target === Function[Prototype];
}
/**
 * Helper used to get the prototype of the target object as getPrototypeOf is not available in an ES3 environment.
 * @ignore
 */
function _getObjProto(target) {
    if (target) {
        // This method doesn't existing in older browsers (e.g. IE8)
        if (_objGetPrototypeOf) {
            return _objGetPrototypeOf(target);
        }
        // target[Constructor] May break if the constructor has been changed or removed
        var newProto = target[str__Proto] || target[Prototype] || (target[Constructor] ? target[Constructor][Prototype] : null);
        if (newProto) {
            return newProto;
        }
    }
    return null;
}
/**
 * Helper to get the properties of an object, including none enumerable ones as functions on a prototype in ES6
 * are not enumerable.
 * @param target
 */
function _forEachProp(target, func) {
    var props = [];
    var getOwnProps = Obj["getOwnPropertyNames"];
    if (getOwnProps) {
        props = getOwnProps(target);
    }
    else {
        for (var name_1 in target) {
            if (typeof name_1 === "string" && _hasOwnProperty(target, name_1)) {
                props.push(name_1);
            }
        }
    }
    if (props && props.length > 0) {
        for (var lp = 0; lp < props.length; lp++) {
            func(props[lp]);
        }
    }
}
/**
 * Helper function to check whether the provided function name is a potential candidate for dynamic
 * callback and prototype generation.
 * @param target The target object, may be a prototype or class object
 * @param funcName The function name
 * @param skipOwn Skips the check for own property
 * @ignore
 */
function _isDynamicCandidate(target, funcName, skipOwn) {
    return (funcName !== Constructor && typeof target[funcName] === strFunction && (skipOwn || _hasOwnProperty(target, funcName)));
}
/**
 * Helper to throw a TypeError exception
 * @param message the message
 * @ignore
 */
function _throwTypeError(message) {
    throw new TypeError("DynamicProto: " + message);
}
/**
 * Returns a collection of the instance functions that are defined directly on the thisTarget object, it does
 * not return any inherited functions
 * @param thisTarget The object to get the instance functions from
 * @ignore
 */
function _getInstanceFuncs(thisTarget) {
    // Get the base proto
    var instFuncs = {};
    // Save any existing instance functions
    _forEachProp(thisTarget, function (name) {
        // Don't include any dynamic prototype instances - as we only want the real functions
        if (!instFuncs[name] && _isDynamicCandidate(thisTarget, name, false)) {
            // Create an instance callback for passing the base function to the caller
            instFuncs[name] = thisTarget[name];
        }
    });
    return instFuncs;
}
/**
 * Returns whether the value is included in the array
 * @param values The array of values
 * @param value  The value
 */
function _hasVisited(values, value) {
    for (var lp = values.length - 1; lp >= 0; lp--) {
        if (values[lp] === value) {
            return true;
        }
    }
    return false;
}
/**
 * Returns an object that contains callback functions for all "base/super" functions, this is used to "save"
 * enabling calling super.xxx() functions without requiring that the base "class" has defined a prototype references
 * @param target The current instance
 * @ignore
 */
function _getBaseFuncs(classProto, thisTarget, instFuncs, useBaseInst) {
    function _instFuncProxy(target, funcHost, funcName) {
        var theFunc = funcHost[funcName];
        if (theFunc[DynProxyTag] && useBaseInst) {
            // grab and reuse the hosted looking function (if available) otherwise the original passed function
            var instFuncTable = target[DynInstFuncTable] || {};
            if (instFuncTable[DynAllowInstChkTag] !== false) {
                theFunc = (instFuncTable[funcHost[DynClassName]] || {})[funcName] || theFunc;
            }
        }
        return function () {
            return theFunc.apply(target, arguments);
        };
    }
    // Start creating a new baseFuncs by creating proxies for the instance functions (as they may get replaced)
    var baseFuncs = {};
    _forEachProp(instFuncs, function (name) {
        // Create an instance callback for passing the base function to the caller
        baseFuncs[name] = _instFuncProxy(thisTarget, instFuncs, name);
    });
    // Get the base prototype functions
    var baseProto = _getObjProto(classProto);
    var visited = [];
    // Don't include base object functions for Object, Array or Function
    while (baseProto && !_isObjectArrayOrFunctionPrototype(baseProto) && !_hasVisited(visited, baseProto)) {
        // look for prototype functions
        _forEachProp(baseProto, function (name) {
            // Don't include any dynamic prototype instances - as we only want the real functions
            // For IE 7/8 the prototype lookup doesn't provide the full chain so we need to bypass the 
            // hasOwnProperty check we get all of the methods, main difference is that IE7/8 doesn't return
            // the Object prototype methods while bypassing the check
            if (!baseFuncs[name] && _isDynamicCandidate(baseProto, name, !_objGetPrototypeOf)) {
                // Create an instance callback for passing the base function to the caller
                baseFuncs[name] = _instFuncProxy(thisTarget, baseProto, name);
            }
        });
        // We need to find all possible functions that might be overloaded by walking the entire prototype chain
        // This avoids the caller from needing to check whether it's direct base class implements the function or not
        // by walking the entire chain it simplifies the usage and issues from upgrading any of the base classes.
        visited.push(baseProto);
        baseProto = _getObjProto(baseProto);
    }
    return baseFuncs;
}
function _getInstFunc(target, funcName, proto, currentDynProtoProxy) {
    var instFunc = null;
    // We need to check whether the class name is defined directly on this prototype otherwise
    // it will walk the proto chain and return any parent proto classname.
    if (target && _hasOwnProperty(proto, DynClassName)) {
        var instFuncTable = target[DynInstFuncTable] || {};
        instFunc = (instFuncTable[proto[DynClassName]] || {})[funcName];
        if (!instFunc) {
            // Avoid stack overflow from recursive calling the same function
            _throwTypeError("Missing [" + funcName + "] " + strFunction);
        }
        // We have the instance function, lets check it we can speed up further calls
        // by adding the instance function back directly on the instance (avoiding the dynamic func lookup)
        if (!instFunc[DynInstChkTag] && instFuncTable[DynAllowInstChkTag] !== false) {
            // If the instance already has an instance function we can't replace it
            var canAddInst = !_hasOwnProperty(target, funcName);
            // Get current prototype
            var objProto = _getObjProto(target);
            var visited = [];
            // Lookup the function starting at the top (instance level prototype) and traverse down, if the first matching function
            // if nothing is found or if the first hit is a dynamic proto instance then we can safely add an instance shortcut
            while (canAddInst && objProto && !_isObjectArrayOrFunctionPrototype(objProto) && !_hasVisited(visited, objProto)) {
                var protoFunc = objProto[funcName];
                if (protoFunc) {
                    canAddInst = (protoFunc === currentDynProtoProxy);
                    break;
                }
                // We need to find all possible initial functions to ensure that we don't bypass a valid override function
                visited.push(objProto);
                objProto = _getObjProto(objProto);
            }
            try {
                if (canAddInst) {
                    // This instance doesn't have an instance func and the class hierarchy does have a higher level prototype version
                    // so it's safe to directly assign for any subsequent calls (for better performance)
                    target[funcName] = instFunc;
                }
                // Block further attempts to set the instance function for any
                instFunc[DynInstChkTag] = 1;
            }
            catch (e) {
                // Don't crash if the object is readonly or the runtime doesn't allow changing this
                // And set a flag so we don't try again for any function
                instFuncTable[DynAllowInstChkTag] = false;
            }
        }
    }
    return instFunc;
}
function _getProtoFunc(funcName, proto, currentDynProtoProxy) {
    var protoFunc = proto[funcName];
    // Check that the prototype function is not a self reference -- try to avoid stack overflow!
    if (protoFunc === currentDynProtoProxy) {
        // It is so lookup the base prototype
        protoFunc = _getObjProto(proto)[funcName];
    }
    if (typeof protoFunc !== strFunction) {
        _throwTypeError("[" + funcName + "] is not a " + strFunction);
    }
    return protoFunc;
}
/**
 * Add the required dynamic prototype methods to the the class prototype
 * @param proto - The class prototype
 * @param className - The instance classname
 * @param target - The target instance
 * @param baseInstFuncs - The base instance functions
 * @param setInstanceFunc - Flag to allow prototype function to reset the instance function if one does not exist
 * @ignore
 */
function _populatePrototype(proto, className, target, baseInstFuncs, setInstanceFunc) {
    function _createDynamicPrototype(proto, funcName) {
        var dynProtoProxy = function () {
            // Use the instance or prototype function
            var instFunc = _getInstFunc(this, funcName, proto, dynProtoProxy) || _getProtoFunc(funcName, proto, dynProtoProxy);
            return instFunc.apply(this, arguments);
        };
        // Tag this function as a proxy to support replacing dynamic proxy elements (primary use case is for unit testing
        // via which can dynamically replace the prototype function reference)
        dynProtoProxy[DynProxyTag] = 1;
        return dynProtoProxy;
    }
    if (!_isObjectOrArrayPrototype(proto)) {
        var instFuncTable = target[DynInstFuncTable] = target[DynInstFuncTable] || {};
        var instFuncs_1 = instFuncTable[className] = (instFuncTable[className] || {}); // fetch and assign if as it may not exist yet
        // Set whether we are allow to lookup instances, if someone has set to false then do not re-enable
        if (instFuncTable[DynAllowInstChkTag] !== false) {
            instFuncTable[DynAllowInstChkTag] = !!setInstanceFunc;
        }
        _forEachProp(target, function (name) {
            // Only add overridden functions
            if (_isDynamicCandidate(target, name, false) && target[name] !== baseInstFuncs[name]) {
                // Save the instance Function to the lookup table and remove it from the instance as it's not a dynamic proto function
                instFuncs_1[name] = target[name];
                delete target[name];
                // Add a dynamic proto if one doesn't exist or if a prototype function exists and it's not a dynamic one
                if (!_hasOwnProperty(proto, name) || (proto[name] && !proto[name][DynProxyTag])) {
                    proto[name] = _createDynamicPrototype(proto, name);
                }
            }
        });
    }
}
/**
 * Checks whether the passed prototype object appears to be correct by walking the prototype hierarchy of the instance
 * @param classProto The class prototype instance
 * @param thisTarget The current instance that will be checked whether the passed prototype instance is in the hierarchy
 * @ignore
 */
function _checkPrototype(classProto, thisTarget) {
    // This method doesn't existing in older browsers (e.g. IE8)
    if (_objGetPrototypeOf) {
        // As this is primarily a coding time check, don't bother checking if running in IE8 or lower
        var visited = [];
        var thisProto = _getObjProto(thisTarget);
        while (thisProto && !_isObjectArrayOrFunctionPrototype(thisProto) && !_hasVisited(visited, thisProto)) {
            if (thisProto === classProto) {
                return true;
            }
            // This avoids the caller from needing to check whether it's direct base class implements the function or not
            // by walking the entire chain it simplifies the usage and issues from upgrading any of the base classes.
            visited.push(thisProto);
            thisProto = _getObjProto(thisProto);
        }
    }
    return false;
}
/**
 * Gets the current prototype name using the ES6 name if available otherwise falling back to a use unknown as the name.
 * It's not critical for this to return a name, it's used to decorate the generated unique name for easier debugging only.
 * @param target
 * @param unknownValue
 * @ignore
 */
function _getObjName(target, unknownValue) {
    if (_hasOwnProperty(target, Prototype)) {
        // Look like a prototype
        return target.name || unknownValue || UnknownValue;
    }
    return (((target || {})[Constructor]) || {}).name || unknownValue || UnknownValue;
}
/**
 * Helper function when creating dynamic (inline) functions for classes, this helper performs the following tasks :-
 * - Saves references to all defined base class functions
 * - Calls the delegateFunc with the current target (this) and a base object reference that can be used to call all "super" functions.
 * - Will populate the class prototype for all overridden functions to support class extension that call the prototype instance.
 * Callers should use this helper when declaring all function within the constructor of a class, as mentioned above the delegateFunc is
 * passed both the target "this" and an object that can be used to call any base (super) functions, using this based object in place of
 * super.XXX() (which gets expanded to _super.prototype.XXX()) provides a better minification outcome and also ensures the correct "this"
 * context is maintained as TypeScript creates incorrect references using super.XXXX() for dynamically defined functions i.e. Functions
 * defined in the constructor or some other function (rather than declared as complete typescript functions).
 * ### Usage
 * ```typescript
 * import dynamicProto from "@microsoft/dynamicproto-js";
 * class ExampleClass extends BaseClass {
 *     constructor() {
 *         dynamicProto(ExampleClass, this, (_self, base) => {
 *             // This will define a function that will be converted to a prototype function
 *             _self.newFunc = () => {
 *                 // Access any "this" instance property
 *                 if (_self.someProperty) {
 *                     ...
 *                 }
 *             }
 *             // This will define a function that will be converted to a prototype function
 *             _self.myFunction = () => {
 *                 // Access any "this" instance property
 *                 if (_self.someProperty) {
 *                     // Call the base version of the function that we are overriding
 *                     base.myFunction();
 *                 }
 *                 ...
 *             }
 *             _self.initialize = () => {
 *                 ...
 *             }
 *             // Warnings: While the following will work as _self is simply a reference to
 *             // this, if anyone overrides myFunction() the overridden will be called first
 *             // as the normal JavaScript method resolution will occur and the defined
 *             // _self.initialize() function is actually gets removed from the instance and
 *             // a proxy prototype version is created to reference the created method.
 *             _self.initialize();
 *         });
 *     }
 * }
 * ```
 * @typeparam DPType This is the generic type of the class, used to keep intellisense valid
 * @typeparam DPCls The type that contains the prototype of the current class
 * @param theClass - This is the current class instance which contains the prototype for the current class
 * @param target - The current "this" (target) reference, when the class has been extended this.prototype will not be the 'theClass' value.
 * @param delegateFunc - The callback function (closure) that will create the dynamic function
 * @param options - Additional options to configure how the dynamic prototype operates
 */
function dynamicProto(theClass, target, delegateFunc, options) {
    // Make sure that the passed theClass argument looks correct
    if (!_hasOwnProperty(theClass, Prototype)) {
        _throwTypeError("theClass is an invalid class definition.");
    }
    // Quick check to make sure that the passed theClass argument looks correct (this is a common copy/paste error)
    var classProto = theClass[Prototype];
    if (!_checkPrototype(classProto, target)) {
        _throwTypeError("[" + _getObjName(theClass) + "] is not in class hierarchy of [" + _getObjName(target) + "]");
    }
    var className = null;
    if (_hasOwnProperty(classProto, DynClassName)) {
        // Only grab the class name if it's defined on this prototype (i.e. don't walk the prototype chain)
        className = classProto[DynClassName];
    }
    else {
        // As not all browser support name on the prototype creating a unique dynamic one if we have not already
        // assigned one, so we can use a simple string as the lookup rather than an object for the dynamic instance
        // function table lookup.
        className = DynClassNamePrefix + _getObjName(theClass, "_") + "$" + _dynamicNames;
        _dynamicNames++;
        classProto[DynClassName] = className;
    }
    var perfOptions = dynamicProto[DynProtoDefaultOptions];
    var useBaseInst = !!perfOptions[strUseBaseInst];
    if (useBaseInst && options && options[strUseBaseInst] !== undefined) {
        useBaseInst = !!options[strUseBaseInst];
    }
    // Get the current instance functions
    var instFuncs = _getInstanceFuncs(target);
    // Get all of the functions for any base instance (before they are potentially overridden)
    var baseFuncs = _getBaseFuncs(classProto, target, instFuncs, useBaseInst);
    // Execute the delegate passing in both the current target "this" and "base" function references
    // Note casting the same type as we don't actually have the base class here and this will provide some intellisense support
    delegateFunc(target, baseFuncs);
    // Don't allow setting instance functions for older IE instances
    var setInstanceFunc = !!_objGetPrototypeOf && !!perfOptions[strSetInstFuncs];
    if (setInstanceFunc && options) {
        setInstanceFunc = !!options[strSetInstFuncs];
    }
    // Populate the Prototype for any overridden instance functions
    _populatePrototype(classProto, className, target, instFuncs, setInstanceFunc !== false);
}
/**
 * Exposes the default global options to allow global configuration, if the global values are disabled these will override
 * any passed values. This is primarily exposed to support unit-testing without the need for individual classes to expose
 * their internal usage of dynamic proto.
 */
var perfDefaults = {
    setInstFuncs: true,
    useBaseInst: true
};
// And expose for testing
dynamicProto[DynProtoDefaultOptions] = perfDefaults;

/* harmony default export */ __webpack_exports__["a"] = (dynamicProto);
//# sourceMappingURL=dynamicproto-js.js.map


/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
 * Microsoft Dynamic Proto Utility, 1.1.4
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
 * Constant string defined to support minimization
 * @ignore
 */
var Constructor = 'constructor';
/**
 * Constant string defined to support minimization
 * @ignore
 */
var Prototype = 'prototype';
/**
 * Constant string defined to support minimization
 * @ignore
 */
var strFunction = 'function';
/**
 * Used to define the name of the instance function lookup table
 * @ignore
 */
var DynInstFuncTable = '_dynInstFuncs';
/**
 * Name used to tag the dynamic prototype function
 * @ignore
 */
var DynProxyTag = '_isDynProxy';
/**
 * Name added to a prototype to define the dynamic prototype "class" name used to lookup the function table
 * @ignore
 */
var DynClassName = '_dynClass';
/**
 * Prefix added to the classname to avoid any name clashes with other instance level properties
 * @ignore
 */
var DynClassNamePrefix = '_dynCls$';
/**
 * A tag which is used to check if we have already to attempted to set the instance function if one is not present
 * @ignore
 */
var DynInstChkTag = '_dynInstChk';
/**
 * A tag which is used to check if we are allows to try and set an instance function is one is not present. Using the same
 * tag name as the function level but a different const name for readability only.
 */
var DynAllowInstChkTag = DynInstChkTag;
/**
 * The global (imported) instances where the global performance options are stored
 */
var DynProtoDefaultOptions = '_dfOpts';
/**
 * Value used as the name of a class when it cannot be determined
 * @ignore
 */
var UnknownValue = '_unknown_';
/**
 * Constant string defined to support minimization
 * @ignore
 */
var str__Proto = "__proto__";
/**
 * Constant string defined to support minimization
 * @ignore
 */
var strUseBaseInst = 'useBaseInst';
/**
 * Constant string defined to support minimization
 * @ignore
 */
var strSetInstFuncs = 'setInstFuncs';
var Obj = Object;
/**
 * Pre-lookup to check if we are running on a modern browser (i.e. not IE8)
 * @ignore
 */
var _objGetPrototypeOf = Obj["getPrototypeOf"];
/**
 * Internal Global used to generate a unique dynamic class name, every new class will increase this value
 * @ignore
 */
var _dynamicNames = 0;
/**
 * Helper to check if the object contains a property of the name
 * @ignore
 */
function _hasOwnProperty(obj, prop) {
    return obj && Obj[Prototype].hasOwnProperty.call(obj, prop);
}
/**
 * Helper used to check whether the target is an Object prototype or Array prototype
 * @ignore
 */
function _isObjectOrArrayPrototype(target) {
    return target && (target === Obj[Prototype] || target === Array[Prototype]);
}
/**
 * Helper used to check whether the target is an Object prototype, Array prototype or Function prototype
 * @ignore
 */
function _isObjectArrayOrFunctionPrototype(target) {
    return _isObjectOrArrayPrototype(target) || target === Function[Prototype];
}
/**
 * Helper used to get the prototype of the target object as getPrototypeOf is not available in an ES3 environment.
 * @ignore
 */
function _getObjProto(target) {
    if (target) {
        // This method doesn't existing in older browsers (e.g. IE8)
        if (_objGetPrototypeOf) {
            return _objGetPrototypeOf(target);
        }
        // target[Constructor] May break if the constructor has been changed or removed
        var newProto = target[str__Proto] || target[Prototype] || (target[Constructor] ? target[Constructor][Prototype] : null);
        if (newProto) {
            return newProto;
        }
    }
    return null;
}
/**
 * Helper to get the properties of an object, including none enumerable ones as functions on a prototype in ES6
 * are not enumerable.
 * @param target
 */
function _forEachProp(target, func) {
    var props = [];
    var getOwnProps = Obj["getOwnPropertyNames"];
    if (getOwnProps) {
        props = getOwnProps(target);
    }
    else {
        for (var name_1 in target) {
            if (typeof name_1 === "string" && _hasOwnProperty(target, name_1)) {
                props.push(name_1);
            }
        }
    }
    if (props && props.length > 0) {
        for (var lp = 0; lp < props.length; lp++) {
            func(props[lp]);
        }
    }
}
/**
 * Helper function to check whether the provided function name is a potential candidate for dynamic
 * callback and prototype generation.
 * @param target The target object, may be a prototype or class object
 * @param funcName The function name
 * @param skipOwn Skips the check for own property
 * @ignore
 */
function _isDynamicCandidate(target, funcName, skipOwn) {
    return (funcName !== Constructor && typeof target[funcName] === strFunction && (skipOwn || _hasOwnProperty(target, funcName)));
}
/**
 * Helper to throw a TypeError exception
 * @param message the message
 * @ignore
 */
function _throwTypeError(message) {
    throw new TypeError("DynamicProto: " + message);
}
/**
 * Returns a collection of the instance functions that are defined directly on the thisTarget object, it does
 * not return any inherited functions
 * @param thisTarget The object to get the instance functions from
 * @ignore
 */
function _getInstanceFuncs(thisTarget) {
    // Get the base proto
    var instFuncs = {};
    // Save any existing instance functions
    _forEachProp(thisTarget, function (name) {
        // Don't include any dynamic prototype instances - as we only want the real functions
        if (!instFuncs[name] && _isDynamicCandidate(thisTarget, name, false)) {
            // Create an instance callback for passing the base function to the caller
            instFuncs[name] = thisTarget[name];
        }
    });
    return instFuncs;
}
/**
 * Returns whether the value is included in the array
 * @param values The array of values
 * @param value  The value
 */
function _hasVisited(values, value) {
    for (var lp = values.length - 1; lp >= 0; lp--) {
        if (values[lp] === value) {
            return true;
        }
    }
    return false;
}
/**
 * Returns an object that contains callback functions for all "base/super" functions, this is used to "save"
 * enabling calling super.xxx() functions without requiring that the base "class" has defined a prototype references
 * @param target The current instance
 * @ignore
 */
function _getBaseFuncs(classProto, thisTarget, instFuncs, useBaseInst) {
    function _instFuncProxy(target, funcHost, funcName) {
        var theFunc = funcHost[funcName];
        if (theFunc[DynProxyTag] && useBaseInst) {
            // grab and reuse the hosted looking function (if available) otherwise the original passed function
            var instFuncTable = target[DynInstFuncTable] || {};
            if (instFuncTable[DynAllowInstChkTag] !== false) {
                theFunc = (instFuncTable[funcHost[DynClassName]] || {})[funcName] || theFunc;
            }
        }
        return function () {
            return theFunc.apply(target, arguments);
        };
    }
    // Start creating a new baseFuncs by creating proxies for the instance functions (as they may get replaced)
    var baseFuncs = {};
    _forEachProp(instFuncs, function (name) {
        // Create an instance callback for passing the base function to the caller
        baseFuncs[name] = _instFuncProxy(thisTarget, instFuncs, name);
    });
    // Get the base prototype functions
    var baseProto = _getObjProto(classProto);
    var visited = [];
    // Don't include base object functions for Object, Array or Function
    while (baseProto && !_isObjectArrayOrFunctionPrototype(baseProto) && !_hasVisited(visited, baseProto)) {
        // look for prototype functions
        _forEachProp(baseProto, function (name) {
            // Don't include any dynamic prototype instances - as we only want the real functions
            // For IE 7/8 the prototype lookup doesn't provide the full chain so we need to bypass the 
            // hasOwnProperty check we get all of the methods, main difference is that IE7/8 doesn't return
            // the Object prototype methods while bypassing the check
            if (!baseFuncs[name] && _isDynamicCandidate(baseProto, name, !_objGetPrototypeOf)) {
                // Create an instance callback for passing the base function to the caller
                baseFuncs[name] = _instFuncProxy(thisTarget, baseProto, name);
            }
        });
        // We need to find all possible functions that might be overloaded by walking the entire prototype chain
        // This avoids the caller from needing to check whether it's direct base class implements the function or not
        // by walking the entire chain it simplifies the usage and issues from upgrading any of the base classes.
        visited.push(baseProto);
        baseProto = _getObjProto(baseProto);
    }
    return baseFuncs;
}
function _getInstFunc(target, funcName, proto, currentDynProtoProxy) {
    var instFunc = null;
    // We need to check whether the class name is defined directly on this prototype otherwise
    // it will walk the proto chain and return any parent proto classname.
    if (target && _hasOwnProperty(proto, DynClassName)) {
        var instFuncTable = target[DynInstFuncTable] || {};
        instFunc = (instFuncTable[proto[DynClassName]] || {})[funcName];
        if (!instFunc) {
            // Avoid stack overflow from recursive calling the same function
            _throwTypeError("Missing [" + funcName + "] " + strFunction);
        }
        // We have the instance function, lets check it we can speed up further calls
        // by adding the instance function back directly on the instance (avoiding the dynamic func lookup)
        if (!instFunc[DynInstChkTag] && instFuncTable[DynAllowInstChkTag] !== false) {
            // If the instance already has an instance function we can't replace it
            var canAddInst = !_hasOwnProperty(target, funcName);
            // Get current prototype
            var objProto = _getObjProto(target);
            var visited = [];
            // Lookup the function starting at the top (instance level prototype) and traverse down, if the first matching function
            // if nothing is found or if the first hit is a dynamic proto instance then we can safely add an instance shortcut
            while (canAddInst && objProto && !_isObjectArrayOrFunctionPrototype(objProto) && !_hasVisited(visited, objProto)) {
                var protoFunc = objProto[funcName];
                if (protoFunc) {
                    canAddInst = (protoFunc === currentDynProtoProxy);
                    break;
                }
                // We need to find all possible initial functions to ensure that we don't bypass a valid override function
                visited.push(objProto);
                objProto = _getObjProto(objProto);
            }
            try {
                if (canAddInst) {
                    // This instance doesn't have an instance func and the class hierarchy does have a higher level prototype version
                    // so it's safe to directly assign for any subsequent calls (for better performance)
                    target[funcName] = instFunc;
                }
                // Block further attempts to set the instance function for any
                instFunc[DynInstChkTag] = 1;
            }
            catch (e) {
                // Don't crash if the object is readonly or the runtime doesn't allow changing this
                // And set a flag so we don't try again for any function
                instFuncTable[DynAllowInstChkTag] = false;
            }
        }
    }
    return instFunc;
}
function _getProtoFunc(funcName, proto, currentDynProtoProxy) {
    var protoFunc = proto[funcName];
    // Check that the prototype function is not a self reference -- try to avoid stack overflow!
    if (protoFunc === currentDynProtoProxy) {
        // It is so lookup the base prototype
        protoFunc = _getObjProto(proto)[funcName];
    }
    if (typeof protoFunc !== strFunction) {
        _throwTypeError("[" + funcName + "] is not a " + strFunction);
    }
    return protoFunc;
}
/**
 * Add the required dynamic prototype methods to the the class prototype
 * @param proto - The class prototype
 * @param className - The instance classname
 * @param target - The target instance
 * @param baseInstFuncs - The base instance functions
 * @param setInstanceFunc - Flag to allow prototype function to reset the instance function if one does not exist
 * @ignore
 */
function _populatePrototype(proto, className, target, baseInstFuncs, setInstanceFunc) {
    function _createDynamicPrototype(proto, funcName) {
        var dynProtoProxy = function () {
            // Use the instance or prototype function
            var instFunc = _getInstFunc(this, funcName, proto, dynProtoProxy) || _getProtoFunc(funcName, proto, dynProtoProxy);
            return instFunc.apply(this, arguments);
        };
        // Tag this function as a proxy to support replacing dynamic proxy elements (primary use case is for unit testing
        // via which can dynamically replace the prototype function reference)
        dynProtoProxy[DynProxyTag] = 1;
        return dynProtoProxy;
    }
    if (!_isObjectOrArrayPrototype(proto)) {
        var instFuncTable = target[DynInstFuncTable] = target[DynInstFuncTable] || {};
        var instFuncs_1 = instFuncTable[className] = (instFuncTable[className] || {}); // fetch and assign if as it may not exist yet
        // Set whether we are allow to lookup instances, if someone has set to false then do not re-enable
        if (instFuncTable[DynAllowInstChkTag] !== false) {
            instFuncTable[DynAllowInstChkTag] = !!setInstanceFunc;
        }
        _forEachProp(target, function (name) {
            // Only add overridden functions
            if (_isDynamicCandidate(target, name, false) && target[name] !== baseInstFuncs[name]) {
                // Save the instance Function to the lookup table and remove it from the instance as it's not a dynamic proto function
                instFuncs_1[name] = target[name];
                delete target[name];
                // Add a dynamic proto if one doesn't exist or if a prototype function exists and it's not a dynamic one
                if (!_hasOwnProperty(proto, name) || (proto[name] && !proto[name][DynProxyTag])) {
                    proto[name] = _createDynamicPrototype(proto, name);
                }
            }
        });
    }
}
/**
 * Checks whether the passed prototype object appears to be correct by walking the prototype hierarchy of the instance
 * @param classProto The class prototype instance
 * @param thisTarget The current instance that will be checked whether the passed prototype instance is in the hierarchy
 * @ignore
 */
function _checkPrototype(classProto, thisTarget) {
    // This method doesn't existing in older browsers (e.g. IE8)
    if (_objGetPrototypeOf) {
        // As this is primarily a coding time check, don't bother checking if running in IE8 or lower
        var visited = [];
        var thisProto = _getObjProto(thisTarget);
        while (thisProto && !_isObjectArrayOrFunctionPrototype(thisProto) && !_hasVisited(visited, thisProto)) {
            if (thisProto === classProto) {
                return true;
            }
            // This avoids the caller from needing to check whether it's direct base class implements the function or not
            // by walking the entire chain it simplifies the usage and issues from upgrading any of the base classes.
            visited.push(thisProto);
            thisProto = _getObjProto(thisProto);
        }
    }
    return false;
}
/**
 * Gets the current prototype name using the ES6 name if available otherwise falling back to a use unknown as the name.
 * It's not critical for this to return a name, it's used to decorate the generated unique name for easier debugging only.
 * @param target
 * @param unknownValue
 * @ignore
 */
function _getObjName(target, unknownValue) {
    if (_hasOwnProperty(target, Prototype)) {
        // Look like a prototype
        return target.name || unknownValue || UnknownValue;
    }
    return (((target || {})[Constructor]) || {}).name || unknownValue || UnknownValue;
}
/**
 * Helper function when creating dynamic (inline) functions for classes, this helper performs the following tasks :-
 * - Saves references to all defined base class functions
 * - Calls the delegateFunc with the current target (this) and a base object reference that can be used to call all "super" functions.
 * - Will populate the class prototype for all overridden functions to support class extension that call the prototype instance.
 * Callers should use this helper when declaring all function within the constructor of a class, as mentioned above the delegateFunc is
 * passed both the target "this" and an object that can be used to call any base (super) functions, using this based object in place of
 * super.XXX() (which gets expanded to _super.prototype.XXX()) provides a better minification outcome and also ensures the correct "this"
 * context is maintained as TypeScript creates incorrect references using super.XXXX() for dynamically defined functions i.e. Functions
 * defined in the constructor or some other function (rather than declared as complete typescript functions).
 * ### Usage
 * ```typescript
 * import dynamicProto from "@microsoft/dynamicproto-js";
 * class ExampleClass extends BaseClass {
 *     constructor() {
 *         dynamicProto(ExampleClass, this, (_self, base) => {
 *             // This will define a function that will be converted to a prototype function
 *             _self.newFunc = () => {
 *                 // Access any "this" instance property
 *                 if (_self.someProperty) {
 *                     ...
 *                 }
 *             }
 *             // This will define a function that will be converted to a prototype function
 *             _self.myFunction = () => {
 *                 // Access any "this" instance property
 *                 if (_self.someProperty) {
 *                     // Call the base version of the function that we are overriding
 *                     base.myFunction();
 *                 }
 *                 ...
 *             }
 *             _self.initialize = () => {
 *                 ...
 *             }
 *             // Warnings: While the following will work as _self is simply a reference to
 *             // this, if anyone overrides myFunction() the overridden will be called first
 *             // as the normal JavaScript method resolution will occur and the defined
 *             // _self.initialize() function is actually gets removed from the instance and
 *             // a proxy prototype version is created to reference the created method.
 *             _self.initialize();
 *         });
 *     }
 * }
 * ```
 * @typeparam DPType This is the generic type of the class, used to keep intellisense valid
 * @typeparam DPCls The type that contains the prototype of the current class
 * @param theClass - This is the current class instance which contains the prototype for the current class
 * @param target - The current "this" (target) reference, when the class has been extended this.prototype will not be the 'theClass' value.
 * @param delegateFunc - The callback function (closure) that will create the dynamic function
 * @param options - Additional options to configure how the dynamic prototype operates
 */
function dynamicProto(theClass, target, delegateFunc, options) {
    // Make sure that the passed theClass argument looks correct
    if (!_hasOwnProperty(theClass, Prototype)) {
        _throwTypeError("theClass is an invalid class definition.");
    }
    // Quick check to make sure that the passed theClass argument looks correct (this is a common copy/paste error)
    var classProto = theClass[Prototype];
    if (!_checkPrototype(classProto, target)) {
        _throwTypeError("[" + _getObjName(theClass) + "] is not in class hierarchy of [" + _getObjName(target) + "]");
    }
    var className = null;
    if (_hasOwnProperty(classProto, DynClassName)) {
        // Only grab the class name if it's defined on this prototype (i.e. don't walk the prototype chain)
        className = classProto[DynClassName];
    }
    else {
        // As not all browser support name on the prototype creating a unique dynamic one if we have not already
        // assigned one, so we can use a simple string as the lookup rather than an object for the dynamic instance
        // function table lookup.
        className = DynClassNamePrefix + _getObjName(theClass, "_") + "$" + _dynamicNames;
        _dynamicNames++;
        classProto[DynClassName] = className;
    }
    var perfOptions = dynamicProto[DynProtoDefaultOptions];
    var useBaseInst = !!perfOptions[strUseBaseInst];
    if (useBaseInst && options && options[strUseBaseInst] !== undefined) {
        useBaseInst = !!options[strUseBaseInst];
    }
    // Get the current instance functions
    var instFuncs = _getInstanceFuncs(target);
    // Get all of the functions for any base instance (before they are potentially overridden)
    var baseFuncs = _getBaseFuncs(classProto, target, instFuncs, useBaseInst);
    // Execute the delegate passing in both the current target "this" and "base" function references
    // Note casting the same type as we don't actually have the base class here and this will provide some intellisense support
    delegateFunc(target, baseFuncs);
    // Don't allow setting instance functions for older IE instances
    var setInstanceFunc = !!_objGetPrototypeOf && !!perfOptions[strSetInstFuncs];
    if (setInstanceFunc && options) {
        setInstanceFunc = !!options[strSetInstFuncs];
    }
    // Populate the Prototype for any overridden instance functions
    _populatePrototype(classProto, className, target, instFuncs, setInstanceFunc !== false);
}
/**
 * Exposes the default global options to allow global configuration, if the global values are disabled these will override
 * any passed values. This is primarily exposed to support unit-testing without the need for individual classes to expose
 * their internal usage of dynamic proto.
 */
var perfDefaults = {
    setInstFuncs: true,
    useBaseInst: true
};
// And expose for testing
dynamicProto[DynProtoDefaultOptions] = perfDefaults;

/* harmony default export */ __webpack_exports__["a"] = (dynamicProto);
//# sourceMappingURL=dynamicproto-js.js.map


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interfaces__ = __webpack_require__(180);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__interfaces__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__interfaces__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Selection__ = __webpack_require__(1687);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Selection__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SelectionZone__ = __webpack_require__(1688);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__SelectionZone__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hsv2rgb;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts__ = __webpack_require__(37);

/** Converts HSV components to an RGB color. Does not set the alpha value. */
function hsv2rgb(h, s, v) {
    s = s / 100;
    v = v / 100;
    var rgb = [];
    var c = v * s;
    var hh = h / 60;
    var x = c * (1 - Math.abs((hh % 2) - 1));
    var m = v - c;
    switch (Math.floor(hh)) {
        case 0:
            rgb = [c, x, 0];
            break;
        case 1:
            rgb = [x, c, 0];
            break;
        case 2:
            rgb = [0, c, x];
            break;
        case 3:
            rgb = [0, x, c];
            break;
        case 4:
            rgb = [x, 0, c];
            break;
        case 5:
            rgb = [c, 0, x];
            break;
    }
    return {
        r: Math.round(__WEBPACK_IMPORTED_MODULE_0__consts__["d" /* MAX_COLOR_RGB */] * (rgb[0] + m)),
        g: Math.round(__WEBPACK_IMPORTED_MODULE_0__consts__["d" /* MAX_COLOR_RGB */] * (rgb[1] + m)),
        b: Math.round(__WEBPACK_IMPORTED_MODULE_0__consts__["d" /* MAX_COLOR_RGB */] * (rgb[2] + m))
    };
}
//# sourceMappingURL=hsv2rgb.js.map

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getColorFromString;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cssColor__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getColorFromRGBA__ = __webpack_require__(156);



/**
 * Converts a CSS color string to a color object.
 * Note that hex colors *must* be prefixed with # to be considered valid.
 *
 * `inputColor` will be used unmodified as the `str` property of the returned object.
 * Alpha defaults to 100 if not specified in `inputColor`.
 * Returns undefined if the color string is invalid/not recognized.
 */
function getColorFromString(inputColor) {
    var color = Object(__WEBPACK_IMPORTED_MODULE_1__cssColor__["a" /* cssColor */])(inputColor);
    if (!color) {
        return;
    }
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, Object(__WEBPACK_IMPORTED_MODULE_2__getColorFromRGBA__["a" /* getColorFromRGBA */])(color), { str: inputColor });
}
//# sourceMappingURL=getColorFromString.js.map

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ActivityItem__ = __webpack_require__(1831);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Autofill__ = __webpack_require__(742);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Announced__ = __webpack_require__(1844);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Breadcrumb__ = __webpack_require__(1848);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Button__ = __webpack_require__(10);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__Button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Calendar__ = __webpack_require__(420);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Callout__ = __webpack_require__(54);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Check__ = __webpack_require__(401);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Checkbox__ = __webpack_require__(91);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_8__Checkbox__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ChoiceGroup__ = __webpack_require__(490);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_9__ChoiceGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ChoiceGroupOption__ = __webpack_require__(1860);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Coachmark__ = __webpack_require__(1861);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Color__ = __webpack_require__(1868);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ColorPicker__ = __webpack_require__(1871);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ComboBox__ = __webpack_require__(216);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_14__ComboBox__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__CommandBar__ = __webpack_require__(279);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ContextualMenu__ = __webpack_require__(270);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__DatePicker__ = __webpack_require__(486);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__DetailsList__ = __webpack_require__(57);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Dialog__ = __webpack_require__(111);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Divider__ = __webpack_require__(703);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__DocumentCard__ = __webpack_require__(1887);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Dropdown__ = __webpack_require__(56);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_22__Dropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ExtendedPicker__ = __webpack_require__(1915);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Fabric__ = __webpack_require__(400);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Facepile__ = __webpack_require__(1922);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__FloatingPicker__ = __webpack_require__(1928);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__FocusTrapZone__ = __webpack_require__(271);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__FocusZone__ = __webpack_require__(28);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Foundation__ = __webpack_require__(188);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Grid__ = __webpack_require__(1950);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__GroupedList__ = __webpack_require__(267);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__HoverCard__ = __webpack_require__(1954);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Icon__ = __webpack_require__(12);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_33__Icon__["Icon"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__Icons__ = __webpack_require__(1960);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__Image__ = __webpack_require__(103);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__Keytip__ = __webpack_require__(795);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__KeytipData__ = __webpack_require__(89);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__KeytipLayer__ = __webpack_require__(1985);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Label__ = __webpack_require__(109);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__Layer__ = __webpack_require__(135);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__Link__ = __webpack_require__(53);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__List__ = __webpack_require__(181);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__MarqueeSelection__ = __webpack_require__(1990);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__MessageBar__ = __webpack_require__(112);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_44__MessageBar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__Modal__ = __webpack_require__(184);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__Nav__ = __webpack_require__(1997);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__OverflowSet__ = __webpack_require__(757);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__Overlay__ = __webpack_require__(185);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__Panel__ = __webpack_require__(32);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__Persona__ = __webpack_require__(110);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__PersonaCoin__ = __webpack_require__(435);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__Pickers__ = __webpack_require__(770);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__Pivot__ = __webpack_require__(2000);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__Popup__ = __webpack_require__(409);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__PositioningContainer__ = __webpack_require__(2004);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__ProgressIndicator__ = __webpack_require__(2005);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__Rating__ = __webpack_require__(2009);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__ResizeGroup__ = __webpack_require__(422);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__ScrollablePane__ = __webpack_require__(2013);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__SearchBox__ = __webpack_require__(2018);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__SelectableOption__ = __webpack_require__(2022);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__SelectedItemsList__ = __webpack_require__(2023);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__Selection__ = __webpack_require__(436);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__Separator__ = __webpack_require__(2030);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__Shimmer__ = __webpack_require__(812);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__ShimmeredDetailsList__ = __webpack_require__(2041);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__Slider__ = __webpack_require__(2044);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__SpinButton__ = __webpack_require__(2048);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__Spinner__ = __webpack_require__(100);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__Stack__ = __webpack_require__(825);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__Sticky__ = __webpack_require__(2058);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__Styling__ = __webpack_require__(5);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__SwatchColorPicker__ = __webpack_require__(2061);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__TeachingBubble__ = __webpack_require__(2066);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__Text__ = __webpack_require__(2069);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__TextField__ = __webpack_require__(29);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_76__TextField__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__ThemeGenerator__ = __webpack_require__(2072);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__Toggle__ = __webpack_require__(725);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__Tooltip__ = __webpack_require__(108);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_79__Tooltip__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__Utilities__ = __webpack_require__(1);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_80__Utilities__["r"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_80__Utilities__["t"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__version__ = __webpack_require__(256);




















































// export * from './PersonaPresence'; (Exported as part of Persona)






























//# sourceMappingURL=index.js.map

/***/ }),
/* 124 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 125 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(497);
var enumBugKeys = __webpack_require__(326);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(73);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(13);
var dPs = __webpack_require__(498);
var enumBugKeys = __webpack_require__(326);
var IE_PROTO = __webpack_require__(325)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(323)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(327).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(497);
var hiddenKeys = __webpack_require__(326).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(14);
var dP = __webpack_require__(25);
var DESCRIPTORS = __webpack_require__(23);
var SPECIES = __webpack_require__(20)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 131 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(71);
var call = __webpack_require__(510);
var isArrayIter = __webpack_require__(338);
var anObject = __webpack_require__(13);
var toLength = __webpack_require__(21);
var getIterFn = __webpack_require__(340);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(59);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__version__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Layer_index__ = __webpack_require__(1694);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__components_Layer_index__["a"]; });


//# sourceMappingURL=Layer.js.map

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResponsiveMode; });
/* unused harmony export setResponsiveMode */
/* unused harmony export initializeResponsiveMode */
/* harmony export (immutable) */ __webpack_exports__["b"] = withResponsiveMode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BaseDecorator__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utilities__ = __webpack_require__(1);





var ResponsiveMode;
(function (ResponsiveMode) {
    ResponsiveMode[ResponsiveMode["small"] = 0] = "small";
    ResponsiveMode[ResponsiveMode["medium"] = 1] = "medium";
    ResponsiveMode[ResponsiveMode["large"] = 2] = "large";
    ResponsiveMode[ResponsiveMode["xLarge"] = 3] = "xLarge";
    ResponsiveMode[ResponsiveMode["xxLarge"] = 4] = "xxLarge";
    ResponsiveMode[ResponsiveMode["xxxLarge"] = 5] = "xxxLarge";
    ResponsiveMode[ResponsiveMode["unknown"] = 999] = "unknown";
})(ResponsiveMode || (ResponsiveMode = {}));
var RESPONSIVE_MAX_CONSTRAINT = [479, 639, 1023, 1365, 1919, 99999999];
/**
 * User specified mode to default to, useful for server side rendering scenarios.
 */
var _defaultMode;
/**
 * Tracking the last mode we successfully rendered, which allows us to
 * paint initial renders with the correct size.
 */
var _lastMode;
/**
 * Allows a server rendered scenario to provide a default responsive mode.
 */
function setResponsiveMode(responsiveMode) {
    _defaultMode = responsiveMode;
}
/**
 * Initializes the responsive mode to the current window size. This can be used to avoid
 * a re-render during first component mount since the window would otherwise not be measured
 * until after mounting.
 */
function initializeResponsiveMode(element) {
    if (typeof window !== 'undefined') {
        var currentWindow = (element && Object(__WEBPACK_IMPORTED_MODULE_4__Utilities__["Z" /* getWindow */])(element)) || window;
        getResponsiveMode(currentWindow);
    }
}
function withResponsiveMode(ComposedComponent) {
    var resultClass = /** @class */ (function (_super) {
        __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](WithResponsiveMode, _super);
        function WithResponsiveMode(props) {
            var _this = _super.call(this, props) || this;
            _this._onResize = function () {
                var element = Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(_this);
                var currentWindow = (element && Object(__WEBPACK_IMPORTED_MODULE_4__Utilities__["Z" /* getWindow */])(element)) || window;
                var responsiveMode = getResponsiveMode(currentWindow);
                if (responsiveMode !== _this.state.responsiveMode) {
                    _this.setState({
                        responsiveMode: responsiveMode
                    });
                }
            };
            _this._updateComposedComponentRef = _this._updateComposedComponentRef.bind(_this);
            _this.state = {
                responsiveMode: _defaultMode || _lastMode || ResponsiveMode.large
            };
            return _this;
        }
        WithResponsiveMode.prototype.componentDidMount = function () {
            this._events.on(window, 'resize', this._onResize);
            this._onResize();
        };
        WithResponsiveMode.prototype.componentWillUnmount = function () {
            this._events.dispose();
        };
        WithResponsiveMode.prototype.render = function () {
            var responsiveMode = this.state.responsiveMode;
            return responsiveMode === ResponsiveMode.unknown ? null : (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ComposedComponent, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ ref: this._updateComposedComponentRef, responsiveMode: responsiveMode }, this.props)));
        };
        return WithResponsiveMode;
    }(__WEBPACK_IMPORTED_MODULE_3__BaseDecorator__["a" /* BaseDecorator */]));
    return Object(__WEBPACK_IMPORTED_MODULE_4__Utilities__["_2" /* hoistStatics */])(ComposedComponent, resultClass);
}
function getResponsiveMode(currentWindow) {
    var responsiveMode = ResponsiveMode.small;
    if (currentWindow) {
        try {
            while (currentWindow.innerWidth > RESPONSIVE_MAX_CONSTRAINT[responsiveMode]) {
                responsiveMode++;
            }
        }
        catch (e) {
            // Return a best effort result in cases where we're in the browser but it throws on getting innerWidth.
            responsiveMode = _defaultMode || _lastMode || ResponsiveMode.large;
        }
        // Tracking last mode just gives us a better default in future renders,
        // which avoids starting with the wrong value if we've measured once.
        _lastMode = responsiveMode;
    }
    else {
        if (_defaultMode !== undefined) {
            responsiveMode = _defaultMode;
        }
        else {
            throw new Error('Content was rendered in a server environment without providing a default responsive mode. ' +
                'Call setResponsiveMode to define what the responsive mode is.');
        }
    }
    return responsiveMode;
}
//# sourceMappingURL=withResponsiveMode.js.map

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Styling__ = __webpack_require__(5);


var noOutline = {
    outline: 0
};
var iconStyle = {
    fontSize: __WEBPACK_IMPORTED_MODULE_1__Styling__["e" /* FontSizes */].icon,
    margin: '0 4px',
    height: '16px',
    lineHeight: '16px',
    textAlign: 'center',
    verticalAlign: 'middle',
    flexShrink: 0
};
/**
 * Gets the base button styles. Note: because it is a base class to be used with the `mergeRules`
 * helper, it should have values for all class names in the interface. This let `mergeRules` optimize
 * mixing class names together.
 */
var getStyles = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_15" /* memoizeFunction */])(function (theme) {
    var semanticColors = theme.semanticColors;
    var border = semanticColors.buttonBorder;
    var disabledBackground = semanticColors.disabledBackground;
    var disabledText = semanticColors.disabledText;
    var buttonHighContrastFocus = {
        left: -2,
        top: -2,
        bottom: -2,
        right: -2,
        border: 'none',
        outlineColor: 'ButtonText'
    };
    return {
        root: [
            Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["v" /* getFocusStyle */])(theme, { inset: -1, highContrastStyle: buttonHighContrastFocus }),
            theme.fonts.medium,
            {
                boxSizing: 'border-box',
                border: '1px solid ' + border,
                userSelect: 'none',
                display: 'inline-block',
                textDecoration: 'none',
                textAlign: 'center',
                cursor: 'pointer',
                verticalAlign: 'top',
                padding: '0 16px',
                borderRadius: 0,
                margin: 0,
                selectors: {
                    // IE11 workaround for preventing shift of child elements of a button when active.
                    ':active > *': {
                        position: 'relative',
                        left: 0,
                        top: 0
                    }
                }
            }
        ],
        rootDisabled: [
            Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["v" /* getFocusStyle */])(theme, { inset: -1, highContrastStyle: buttonHighContrastFocus }),
            {
                backgroundColor: disabledBackground,
                color: disabledText,
                cursor: 'default',
                pointerEvents: 'none',
                selectors: (_a = {
                        ':hover': noOutline,
                        ':focus': noOutline
                    },
                    _a[__WEBPACK_IMPORTED_MODULE_1__Styling__["g" /* HighContrastSelector */]] = {
                        color: 'grayText',
                        bordercolor: 'grayText'
                    },
                    _a)
            }
        ],
        iconDisabled: {
            color: disabledText
        },
        menuIconDisabled: {
            color: disabledText
        },
        flexContainer: {
            display: 'flex',
            height: '100%',
            flexWrap: 'nowrap',
            justifyContent: 'center',
            alignItems: 'center'
        },
        textContainer: {
            flexGrow: 1
        },
        icon: iconStyle,
        menuIcon: [
            iconStyle,
            {
                fontSize: __WEBPACK_IMPORTED_MODULE_1__Styling__["e" /* FontSizes */].small
            }
        ],
        label: {
            margin: '0 4px',
            lineHeight: '100%'
        },
        screenReaderText: __WEBPACK_IMPORTED_MODULE_1__Styling__["B" /* hiddenContentStyle */]
    };
    var _a;
});
//# sourceMappingURL=BaseButton.styles.js.map

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var pna = __webpack_require__(284);
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = Object.create(__webpack_require__(212));
util.inherits = __webpack_require__(158);
/*</replacement>*/

var Readable = __webpack_require__(859);
var Writable = __webpack_require__(479);

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(25).f;
var has = __webpack_require__(63);
var TAG = __webpack_require__(20)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(72);
var TAG = __webpack_require__(20)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var defined = __webpack_require__(93);
var fails = __webpack_require__(16);
var spaces = __webpack_require__(329);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 142 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addLocaleData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return intlShape; });
/* unused harmony export injectIntl */
/* unused harmony export defineMessages */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IntlProvider; });
/* unused harmony export FormattedDate */
/* unused harmony export FormattedTime */
/* unused harmony export FormattedRelative */
/* unused harmony export FormattedNumber */
/* unused harmony export FormattedPlural */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormattedMessage; });
/* unused harmony export FormattedHTMLMessage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__ = __webpack_require__(1338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_intl_format_cache__ = __webpack_require__(1357);
/*
 * Copyright 2019, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */










// GENERATED FILE
var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
    var s = String(n).split("."),
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "year-short": { "displayName": "yr.", "relative": { "0": "this yr.", "1": "next yr.", "-1": "last yr." }, "relativeTime": { "future": { "one": "in {0} yr.", "other": "in {0} yr." }, "past": { "one": "{0} yr. ago", "other": "{0} yr. ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "month-short": { "displayName": "mo.", "relative": { "0": "this mo.", "1": "next mo.", "-1": "last mo." }, "relativeTime": { "future": { "one": "in {0} mo.", "other": "in {0} mo." }, "past": { "one": "{0} mo. ago", "other": "{0} mo. ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "day-short": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "hour-short": { "displayName": "hr.", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hr.", "other": "in {0} hr." }, "past": { "one": "{0} hr. ago", "other": "{0} hr. ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "minute-short": { "displayName": "min.", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} min.", "other": "in {0} min." }, "past": { "one": "{0} min. ago", "other": "{0} min. ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } }, "second-short": { "displayName": "sec.", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} sec.", "other": "in {0} sec." }, "past": { "one": "{0} sec. ago", "other": "{0} sec. ago" } } } } };

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function addLocaleData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var locales = Array.isArray(data) ? data : [data];

  locales.forEach(function (localeData) {
    if (localeData && localeData.locale) {
      __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__addLocaleData(localeData);
      __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__addLocaleData(localeData);
    }
  });
}

function hasLocaleData(locale) {
  var localeParts = (locale || '').split('-');

  while (localeParts.length > 0) {
    if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
      return true;
    }

    localeParts.pop();
  }

  return false;
}

function hasIMFAndIRFLocaleData(locale) {
  var normalizedLocale = locale && locale.toLowerCase();

  return !!(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__localeData__[normalizedLocale] && __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__localeData__[normalizedLocale]);
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};



















var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var bool = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool;
var number = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number;
var string = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string;
var func = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func;
var object = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object;
var oneOf = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf;
var shape = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape;
var any = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any;
var oneOfType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType;

var localeMatcher = oneOf(['best fit', 'lookup']);
var narrowShortLong = oneOf(['narrow', 'short', 'long']);
var numeric2digit = oneOf(['numeric', '2-digit']);
var funcReq = func.isRequired;

var intlConfigPropTypes = {
  locale: string,
  timeZone: string,
  formats: object,
  messages: object,
  textComponent: any,

  defaultLocale: string,
  defaultFormats: object,

  onError: func
};

var intlFormatPropTypes = {
  formatDate: funcReq,
  formatTime: funcReq,
  formatRelative: funcReq,
  formatNumber: funcReq,
  formatPlural: funcReq,
  formatMessage: funcReq,
  formatHTMLMessage: funcReq
};

var intlShape = shape(_extends({}, intlConfigPropTypes, intlFormatPropTypes, {
  formatters: object,
  now: funcReq
}));

var messageDescriptorPropTypes = {
  id: string.isRequired,
  description: oneOfType([string, object]),
  defaultMessage: string
};

var dateTimeFormatPropTypes = {
  localeMatcher: localeMatcher,
  formatMatcher: oneOf(['basic', 'best fit']),

  timeZone: string,
  hour12: bool,

  weekday: narrowShortLong,
  era: narrowShortLong,
  year: numeric2digit,
  month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
  day: numeric2digit,
  hour: numeric2digit,
  minute: numeric2digit,
  second: numeric2digit,
  timeZoneName: oneOf(['short', 'long'])
};

var numberFormatPropTypes = {
  localeMatcher: localeMatcher,

  style: oneOf(['decimal', 'currency', 'percent']),
  currency: string,
  currencyDisplay: oneOf(['symbol', 'code', 'name']),
  useGrouping: bool,

  minimumIntegerDigits: number,
  minimumFractionDigits: number,
  maximumFractionDigits: number,
  minimumSignificantDigits: number,
  maximumSignificantDigits: number
};

var relativeFormatPropTypes = {
  style: oneOf(['best fit', 'numeric']),
  units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year', 'second-short', 'minute-short', 'hour-short', 'day-short', 'month-short', 'year-short'])
};

var pluralFormatPropTypes = {
  style: oneOf(['cardinal', 'ordinal'])
};

/*
HTML escaping and shallow-equals implementations are the same as React's
(on purpose.) Therefore, it has the following Copyright and Licensing:

Copyright 2013-2014, Facebook, Inc.
All rights reserved.

This source code is licensed under the BSD-style license found in the LICENSE
file in the root directory of React's source tree.
*/

var intlConfigPropNames = Object.keys(intlConfigPropTypes);

var ESCAPED_CHARS = {
  '&': '&amp;',
  '>': '&gt;',
  '<': '&lt;',
  '"': '&quot;',
  "'": '&#x27;'
};

var UNSAFE_CHARS_REGEX = /[&><"']/g;

function escape(str) {
  return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
    return ESCAPED_CHARS[match];
  });
}

function filterProps(props, whitelist) {
  var defaults$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return whitelist.reduce(function (filtered, name) {
    if (props.hasOwnProperty(name)) {
      filtered[name] = props[name];
    } else if (defaults$$1.hasOwnProperty(name)) {
      filtered[name] = defaults$$1[name];
    }

    return filtered;
  }, {});
}

function invariantIntlContext() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      intl = _ref.intl;

  __WEBPACK_IMPORTED_MODULE_6_invariant___default()(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
}

function shallowEquals(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  for (var i = 0; i < keysA.length; i++) {
    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
  var props = _ref2.props,
      state = _ref2.state,
      _ref2$context = _ref2.context,
      context = _ref2$context === undefined ? {} : _ref2$context;
  var nextContext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _context$intl = context.intl,
      intl = _context$intl === undefined ? {} : _context$intl;
  var _nextContext$intl = nextContext.intl,
      nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;


  return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
}

function createError(message, exception) {
  var eMsg = exception ? '\n' + exception : '';
  return '[React Intl] ' + message + eMsg;
}

function defaultErrorHandler(error) {
  if (false) {
    console.error(error);
  }
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// Inspired by react-redux's `connect()` HOC factory function implementation:
// https://github.com/rackt/react-redux

function getDisplayName(Component$$1) {
  return Component$$1.displayName || Component$$1.name || 'Component';
}

function injectIntl(WrappedComponent) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$intlPropName = options.intlPropName,
      intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName,
      _options$withRef = options.withRef,
      withRef = _options$withRef === undefined ? false : _options$withRef;

  var InjectIntl = function (_Component) {
    inherits(InjectIntl, _Component);

    function InjectIntl(props, context) {
      classCallCheck(this, InjectIntl);

      var _this = possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).call(this, props, context));

      invariantIntlContext(context);
      return _this;
    }

    createClass(InjectIntl, [{
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_6_invariant___default()(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');

        return this._wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(WrappedComponent, _extends({}, this.props, defineProperty({}, intlPropName, this.context.intl), {
          ref: withRef ? /* istanbul ignore next */function (ref) {
            return _this2._wrappedInstance = ref;
          } : null
        }));
      }
    }]);
    return InjectIntl;
  }(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

  InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
  InjectIntl.contextTypes = {
    intl: intlShape
  };
  InjectIntl.WrappedComponent = WrappedComponent;


  return __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(InjectIntl, WrappedComponent);
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function defineMessages(messageDescriptors) {
  // This simply returns what's passed-in because it's meant to be a hook for
  // babel-plugin-react-intl.
  return messageDescriptors;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// This is a "hack" until a proper `intl-pluralformat` package is created.

function resolveLocale(locales) {
  // IntlMessageFormat#_resolveLocale() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._resolveLocale(locales);
}

function findPluralFunction(locale) {
  // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._findPluralRuleFunction(locale);
}

var IntlPluralFormat = function IntlPluralFormat(locales) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  classCallCheck(this, IntlPluralFormat);

  var useOrdinal = options.style === 'ordinal';
  var pluralFn = findPluralFunction(resolveLocale(locales));

  this.format = function (value) {
    return pluralFn(value, useOrdinal);
  };
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);

var RELATIVE_FORMAT_THRESHOLDS = {
  second: 60, // seconds to minute
  minute: 60, // minutes to hour
  hour: 24, // hours to day
  day: 30, // days to month
  month: 12 };

function updateRelativeFormatThresholds(newThresholds) {
  var thresholds = __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds;
  thresholds.second = newThresholds.second;
  thresholds.minute = newThresholds.minute;
  thresholds.hour = newThresholds.hour;
  thresholds.day = newThresholds.day;
  thresholds.month = newThresholds.month;
  thresholds['second-short'] = newThresholds['second-short'];
  thresholds['minute-short'] = newThresholds['minute-short'];
  thresholds['hour-short'] = newThresholds['hour-short'];
  thresholds['day-short'] = newThresholds['day-short'];
  thresholds['month-short'] = newThresholds['month-short'];
}

function getNamedFormat(formats, type, name, onError) {
  var format = formats && formats[type] && formats[type][name];
  if (format) {
    return format;
  }

  onError(createError('No ' + type + ' format named: ' + name));
}

function formatDate(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      timeZone = config.timeZone;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var defaults$$1 = _extends({}, timeZone && { timeZone: timeZone }, format && getNamedFormat(formats, 'date', format, onError));
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    onError(createError('Error formatting date.', e));
  }

  return String(date);
}

function formatTime(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      timeZone = config.timeZone;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var defaults$$1 = _extends({}, timeZone && { timeZone: timeZone }, format && getNamedFormat(formats, 'time', format, onError));
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
    // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = _extends({}, filteredOptions, { hour: 'numeric', minute: 'numeric' });
  }

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    onError(createError('Error formatting time.', e));
  }

  return String(date);
}

function formatRelative(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var now = new Date(options.now);
  var defaults$$1 = format && getNamedFormat(formats, 'relative', format, onError);
  var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults$$1);

  // Capture the current threshold values, then temporarily override them with
  // specific values just for this render.
  var oldThresholds = _extends({}, __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds);
  updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);

  try {
    return state.getRelativeFormat(locale, filteredOptions).format(date, {
      now: isFinite(now) ? now : state.now()
    });
  } catch (e) {
    onError(createError('Error formatting relative time.', e));
  } finally {
    updateRelativeFormatThresholds(oldThresholds);
  }

  return String(date);
}

function formatNumber(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var defaults$$1 = format && getNamedFormat(formats, 'number', format, onError);
  var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getNumberFormat(locale, filteredOptions).format(value);
  } catch (e) {
    onError(createError('Error formatting number.', e));
  }

  return String(value);
}

function formatPlural(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale;


  var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);
  var onError = config.onError || defaultErrorHandler;

  try {
    return state.getPluralFormat(locale, filteredOptions).format(value);
  } catch (e) {
    onError(createError('Error formatting plural.', e));
  }

  return 'other';
}

function formatMessage(config, state) {
  var messageDescriptor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      messages = config.messages,
      defaultLocale = config.defaultLocale,
      defaultFormats = config.defaultFormats;
  var id = messageDescriptor.id,
      defaultMessage = messageDescriptor.defaultMessage;

  // Produce a better error if the user calls `intl.formatMessage(element)`

  if (false) {
    invariant(!isValidElement(config), '[React Intl] Don\'t pass React elements to ' + 'formatMessage(), pass `.props`.');
  }

  // `id` is a required field of a Message Descriptor.
  __WEBPACK_IMPORTED_MODULE_6_invariant___default()(id, '[React Intl] An `id` must be provided to format a message.');

  var message = messages && messages[id];
  var hasValues = Object.keys(values).length > 0;

  // Avoid expensive message formatting for simple messages without values. In
  // development messages will always be formatted in case of missing values.
  if (!hasValues && "production" === 'production') {
    return message || defaultMessage || id;
  }

  var formattedMessage = void 0;
  var onError = config.onError || defaultErrorHandler;

  if (message) {
    try {
      var formatter = state.getMessageFormat(message, locale, formats);

      formattedMessage = formatter.format(values);
    } catch (e) {
      onError(createError('Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''), e));
    }
  } else {
    // This prevents warnings from littering the console in development
    // when no `messages` are passed into the <IntlProvider> for the
    // default locale, and a default message is in the source.
    if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {
      onError(createError('Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '')));
    }
  }

  if (!formattedMessage && defaultMessage) {
    try {
      var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);

      formattedMessage = _formatter.format(values);
    } catch (e) {
      onError(createError('Error formatting the default message for: "' + id + '"', e));
    }
  }

  if (!formattedMessage) {
    onError(createError('Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.')));
  }

  return formattedMessage || message || defaultMessage || id;
}

function formatHTMLMessage(config, state, messageDescriptor) {
  var rawValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  // Process all the values before they are used when formatting the ICU
  // Message string. Since the formatted message might be injected via
  // `innerHTML`, all String-based values need to be HTML-escaped.
  var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
    var value = rawValues[name];
    escaped[name] = typeof value === 'string' ? escape(value) : value;
    return escaped;
  }, {});

  return formatMessage(config, state, messageDescriptor, escapedValues);
}



var format = Object.freeze({
	formatDate: formatDate,
	formatTime: formatTime,
	formatRelative: formatRelative,
	formatNumber: formatNumber,
	formatPlural: formatPlural,
	formatMessage: formatMessage,
	formatHTMLMessage: formatHTMLMessage
});

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
var intlFormatPropNames = Object.keys(intlFormatPropTypes);

// These are not a static property on the `IntlProvider` class so the intl
// config values can be inherited from an <IntlProvider> ancestor.
var defaultProps = {
  formats: {},
  messages: {},
  timeZone: null,
  textComponent: 'span',

  defaultLocale: 'en',
  defaultFormats: {},

  onError: defaultErrorHandler
};

var IntlProvider = function (_Component) {
  inherits(IntlProvider, _Component);

  function IntlProvider(props) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, IntlProvider);

    var _this = possibleConstructorReturn(this, (IntlProvider.__proto__ || Object.getPrototypeOf(IntlProvider)).call(this, props, context));

    __WEBPACK_IMPORTED_MODULE_6_invariant___default()(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');

    var intlContext = context.intl;

    // Used to stabilize time when performing an initial rendering so that
    // all relative times use the same reference "now" time.

    var initialNow = void 0;
    if (isFinite(props.initialNow)) {
      initialNow = Number(props.initialNow);
    } else {
      // When an `initialNow` isn't provided via `props`, look to see an
      // <IntlProvider> exists in the ancestry and call its `now()`
      // function to propagate its value for "now".
      initialNow = intlContext ? intlContext.now() : Date.now();
    }

    // Creating `Intl*` formatters is expensive. If there's a parent
    // `<IntlProvider>`, then its formatters will be used. Otherwise, this
    // memoize the `Intl*` constructors and cache them for the lifecycle of
    // this IntlProvider instance.

    var _ref = intlContext || {},
        _ref$formatters = _ref.formatters,
        formatters = _ref$formatters === undefined ? {
      getDateTimeFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(Intl.DateTimeFormat),
      getNumberFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(Intl.NumberFormat),
      getMessageFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a),
      getRelativeFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a),
      getPluralFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(IntlPluralFormat)
    } : _ref$formatters;

    _this.state = _extends({}, formatters, {

      // Wrapper to provide stable "now" time for initial render.
      now: function now() {
        return _this._didDisplay ? Date.now() : initialNow;
      }
    });
    return _this;
  }

  createClass(IntlProvider, [{
    key: 'getConfig',
    value: function getConfig() {
      var intlContext = this.context.intl;

      // Build a whitelisted config object from `props`, defaults, and
      // `context.intl`, if an <IntlProvider> exists in the ancestry.

      var config = filterProps(this.props, intlConfigPropNames$1, intlContext);

      // Apply default props. This must be applied last after the props have
      // been resolved and inherited from any <IntlProvider> in the ancestry.
      // This matches how React resolves `defaultProps`.
      for (var propName in defaultProps) {
        if (config[propName] === undefined) {
          config[propName] = defaultProps[propName];
        }
      }

      if (!hasLocaleData(config.locale)) {
        var _config = config,
            locale = _config.locale,
            defaultLocale = _config.defaultLocale,
            defaultFormats = _config.defaultFormats,
            onError = _config.onError;


        onError(createError('Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.')));

        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        config = _extends({}, config, {
          locale: defaultLocale,
          formats: defaultFormats,
          messages: defaultProps.messages
        });
      }

      return config;
    }
  }, {
    key: 'getBoundFormatFns',
    value: function getBoundFormatFns(config, state) {
      return intlFormatPropNames.reduce(function (boundFormatFns, name) {
        boundFormatFns[name] = format[name].bind(null, config, state);
        return boundFormatFns;
      }, {});
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      var config = this.getConfig();

      // Bind intl factories and current config to the format functions.
      var boundFormatFns = this.getBoundFormatFns(config, this.state);

      var _state = this.state,
          now = _state.now,
          formatters = objectWithoutProperties(_state, ['now']);


      return {
        intl: _extends({}, config, boundFormatFns, {
          formatters: formatters,
          now: now
        })
      };
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._didDisplay = true;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react__["Children"].only(this.props.children);
    }
  }]);
  return IntlProvider;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

IntlProvider.displayName = 'IntlProvider';
IntlProvider.contextTypes = {
  intl: intlShape
};
IntlProvider.childContextTypes = {
  intl: intlShape.isRequired
};
 false ? IntlProvider.propTypes = _extends({}, intlConfigPropTypes, {
  children: PropTypes.element.isRequired,
  initialNow: PropTypes.any
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedDate = function (_Component) {
  inherits(FormattedDate, _Component);

  function FormattedDate(props, context) {
    classCallCheck(this, FormattedDate);

    var _this = possibleConstructorReturn(this, (FormattedDate.__proto__ || Object.getPrototypeOf(FormattedDate)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedDate, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatDate = _context$intl.formatDate,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedDate = formatDate(value, this.props);

      if (typeof children === 'function') {
        return children(formattedDate);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedDate
      );
    }
  }]);
  return FormattedDate;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedDate.displayName = 'FormattedDate';
FormattedDate.contextTypes = {
  intl: intlShape
};
 false ? FormattedDate.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedTime = function (_Component) {
  inherits(FormattedTime, _Component);

  function FormattedTime(props, context) {
    classCallCheck(this, FormattedTime);

    var _this = possibleConstructorReturn(this, (FormattedTime.__proto__ || Object.getPrototypeOf(FormattedTime)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedTime, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatTime = _context$intl.formatTime,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedTime = formatTime(value, this.props);

      if (typeof children === 'function') {
        return children(formattedTime);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedTime
      );
    }
  }]);
  return FormattedTime;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedTime.displayName = 'FormattedTime';
FormattedTime.contextTypes = {
  intl: intlShape
};
 false ? FormattedTime.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var SECOND = 1000;
var MINUTE = 1000 * 60;
var HOUR = 1000 * 60 * 60;
var DAY = 1000 * 60 * 60 * 24;

// The maximum timer delay value is a 32-bit signed integer.
// See: https://mdn.io/setTimeout
var MAX_TIMER_DELAY = 2147483647;

function selectUnits(delta) {
  var absDelta = Math.abs(delta);

  if (absDelta < MINUTE) {
    return 'second';
  }

  if (absDelta < HOUR) {
    return 'minute';
  }

  if (absDelta < DAY) {
    return 'hour';
  }

  // The maximum scheduled delay will be measured in days since the maximum
  // timer delay is less than the number of milliseconds in 25 days.
  return 'day';
}

function getUnitDelay(units) {
  switch (units) {
    case 'second':
      return SECOND;
    case 'minute':
      return MINUTE;
    case 'hour':
      return HOUR;
    case 'day':
      return DAY;
    default:
      return MAX_TIMER_DELAY;
  }
}

function isSameDate(a, b) {
  if (a === b) {
    return true;
  }

  var aTime = new Date(a).getTime();
  var bTime = new Date(b).getTime();

  return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
}

var FormattedRelative = function (_Component) {
  inherits(FormattedRelative, _Component);

  function FormattedRelative(props, context) {
    classCallCheck(this, FormattedRelative);

    var _this = possibleConstructorReturn(this, (FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call(this, props, context));

    invariantIntlContext(context);

    var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();

    // `now` is stored as state so that `render()` remains a function of
    // props + state, instead of accessing `Date.now()` inside `render()`.
    _this.state = { now: now };
    return _this;
  }

  createClass(FormattedRelative, [{
    key: 'scheduleNextUpdate',
    value: function scheduleNextUpdate(props, state) {
      var _this2 = this;

      // Cancel and pending update because we're scheduling a new update.
      clearTimeout(this._timer);

      var value = props.value,
          units = props.units,
          updateInterval = props.updateInterval;

      var time = new Date(value).getTime();

      // If the `updateInterval` is falsy, including `0` or we don't have a
      // valid date, then auto updates have been turned off, so we bail and
      // skip scheduling an update.
      if (!updateInterval || !isFinite(time)) {
        return;
      }

      var delta = time - state.now;
      var unitDelay = getUnitDelay(units || selectUnits(delta));
      var unitRemainder = Math.abs(delta % unitDelay);

      // We want the largest possible timer delay which will still display
      // accurate information while reducing unnecessary re-renders. The delay
      // should be until the next "interesting" moment, like a tick from
      // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
      var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);

      this._timer = setTimeout(function () {
        _this2.setState({ now: _this2.context.intl.now() });
      }, delay);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scheduleNextUpdate(this.props, this.state);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var nextValue = _ref.value;

      // When the `props.value` date changes, `state.now` needs to be updated,
      // and the next update can be rescheduled.
      if (!isSameDate(nextValue, this.props.value)) {
        this.setState({ now: this.context.intl.now() });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      this.scheduleNextUpdate(nextProps, nextState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this._timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatRelative = _context$intl.formatRelative,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedRelative = formatRelative(value, _extends({}, this.props, this.state));

      if (typeof children === 'function') {
        return children(formattedRelative);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedRelative
      );
    }
  }]);
  return FormattedRelative;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedRelative.displayName = 'FormattedRelative';
FormattedRelative.contextTypes = {
  intl: intlShape
};
FormattedRelative.defaultProps = {
  updateInterval: 1000 * 10
};
 false ? FormattedRelative.propTypes = _extends({}, relativeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  updateInterval: PropTypes.number,
  initialNow: PropTypes.any,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedNumber = function (_Component) {
  inherits(FormattedNumber, _Component);

  function FormattedNumber(props, context) {
    classCallCheck(this, FormattedNumber);

    var _this = possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedNumber, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatNumber = _context$intl.formatNumber,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedNumber = formatNumber(value, this.props);

      if (typeof children === 'function') {
        return children(formattedNumber);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedNumber
      );
    }
  }]);
  return FormattedNumber;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedNumber.displayName = 'FormattedNumber';
FormattedNumber.contextTypes = {
  intl: intlShape
};
 false ? FormattedNumber.propTypes = _extends({}, numberFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedPlural = function (_Component) {
  inherits(FormattedPlural, _Component);

  function FormattedPlural(props, context) {
    classCallCheck(this, FormattedPlural);

    var _this = possibleConstructorReturn(this, (FormattedPlural.__proto__ || Object.getPrototypeOf(FormattedPlural)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedPlural, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatPlural = _context$intl.formatPlural,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          other = _props.other,
          children = _props.children;


      var pluralCategory = formatPlural(value, this.props);
      var formattedPlural = this.props[pluralCategory] || other;

      if (typeof children === 'function') {
        return children(formattedPlural);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedPlural
      );
    }
  }]);
  return FormattedPlural;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedPlural.displayName = 'FormattedPlural';
FormattedPlural.contextTypes = {
  intl: intlShape
};
FormattedPlural.defaultProps = {
  style: 'cardinal'
};
 false ? FormattedPlural.propTypes = _extends({}, pluralFormatPropTypes, {
  value: PropTypes.any.isRequired,

  other: PropTypes.node.isRequired,
  zero: PropTypes.node,
  one: PropTypes.node,
  two: PropTypes.node,
  few: PropTypes.node,
  many: PropTypes.node,

  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var defaultFormatMessage = function defaultFormatMessage(descriptor, values) {
  if (false) {
    console.error('[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry. Using default message as fallback.');
  }
  return formatMessage({}, { getMessageFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a) }, descriptor, values);
};

var FormattedMessage = function (_Component) {
  inherits(FormattedMessage, _Component);

  function FormattedMessage(props, context) {
    classCallCheck(this, FormattedMessage);

    var _this = possibleConstructorReturn(this, (FormattedMessage.__proto__ || Object.getPrototypeOf(FormattedMessage)).call(this, props, context));

    if (!props.defaultMessage) {
      invariantIntlContext(context);
    }
    return _this;
  }

  createClass(FormattedMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _ref = this.context.intl || {},
          _ref$formatMessage = _ref.formatMessage,
          formatMessage$$1 = _ref$formatMessage === undefined ? defaultFormatMessage : _ref$formatMessage,
          _ref$textComponent = _ref.textComponent,
          Text = _ref$textComponent === undefined ? 'span' : _ref$textComponent;

      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          values = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var tokenDelimiter = void 0;
      var tokenizedValues = void 0;
      var elements = void 0;

      var hasValues = values && Object.keys(values).length > 0;
      if (hasValues) {
        // Creates a token with a random UID that should not be guessable or
        // conflict with other parts of the `message` string.
        var uid = Math.floor(Math.random() * 0x10000000000).toString(16);

        var generateToken = function () {
          var counter = 0;
          return function () {
            return 'ELEMENT-' + uid + '-' + (counter += 1);
          };
        }();

        // Splitting with a delimiter to support IE8. When using a regex
        // with a capture group IE8 does not include the capture group in
        // the resulting array.
        tokenDelimiter = '@__' + uid + '__@';
        tokenizedValues = {};
        elements = {};

        // Iterates over the `props` to keep track of any React Element
        // values so they can be represented by the `token` as a placeholder
        // when the `message` is formatted. This allows the formatted
        // message to then be broken-up into parts with references to the
        // React Elements inserted back in.
        Object.keys(values).forEach(function (name) {
          var value = values[name];

          if (Object(__WEBPACK_IMPORTED_MODULE_4_react__["isValidElement"])(value)) {
            var token = generateToken();
            tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
            elements[token] = value;
          } else {
            tokenizedValues[name] = value;
          }
        });
      }

      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedMessage = formatMessage$$1(descriptor, tokenizedValues || values);

      var nodes = void 0;

      var hasElements = elements && Object.keys(elements).length > 0;
      if (hasElements) {
        // Split the message into parts so the React Element values captured
        // above can be inserted back into the rendered message. This
        // approach allows messages to render with React Elements while
        // keeping React's virtual diffing working properly.
        nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
          return !!part;
        }).map(function (part) {
          return elements[part] || part;
        });
      } else {
        nodes = [formattedMessage];
      }

      if (typeof children === 'function') {
        return children.apply(undefined, toConsumableArray(nodes));
      }

      // Needs to use `createElement()` instead of JSX, otherwise React will
      // warn about a missing `key` prop with rich-text message formatting.
      return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"].apply(undefined, [Component$$1, null].concat(toConsumableArray(nodes)));
    }
  }]);
  return FormattedMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedMessage.displayName = 'FormattedMessage';
FormattedMessage.contextTypes = {
  intl: intlShape
};
FormattedMessage.defaultProps = {
  values: {}
};
 false ? FormattedMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedHTMLMessage = function (_Component) {
  inherits(FormattedHTMLMessage, _Component);

  function FormattedHTMLMessage(props, context) {
    classCallCheck(this, FormattedHTMLMessage);

    var _this = possibleConstructorReturn(this, (FormattedHTMLMessage.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedHTMLMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatHTMLMessage = _context$intl.formatHTMLMessage,
          Text = _context$intl.textComponent;
      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          rawValues = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);

      if (typeof children === 'function') {
        return children(formattedHTMLMessage);
      }

      // Since the message presumably has HTML in it, we need to set
      // `innerHTML` in order for it to be rendered and not escaped by React.
      // To be safe, all string prop values were escaped when formatting the
      // message. It is assumed that the message is not UGC, and came from the
      // developer making it more like a template.
      //
      // Note: There's a perf impact of using this component since there's no
      // way for React to do its virtual DOM diffing.
      var html = { __html: formattedHTMLMessage };
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component$$1, { dangerouslySetInnerHTML: html });
    }
  }]);
  return FormattedHTMLMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
FormattedHTMLMessage.contextTypes = {
  intl: intlShape
};
FormattedHTMLMessage.defaultProps = {
  values: {}
};
 false ? FormattedHTMLMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(defaultLocaleData);

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default.a);




/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
 * Microsoft Dynamic Proto Utility, 1.1.4
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
 * Constant string defined to support minimization
 * @ignore
 */
var Constructor = 'constructor';
/**
 * Constant string defined to support minimization
 * @ignore
 */
var Prototype = 'prototype';
/**
 * Constant string defined to support minimization
 * @ignore
 */
var strFunction = 'function';
/**
 * Used to define the name of the instance function lookup table
 * @ignore
 */
var DynInstFuncTable = '_dynInstFuncs';
/**
 * Name used to tag the dynamic prototype function
 * @ignore
 */
var DynProxyTag = '_isDynProxy';
/**
 * Name added to a prototype to define the dynamic prototype "class" name used to lookup the function table
 * @ignore
 */
var DynClassName = '_dynClass';
/**
 * Prefix added to the classname to avoid any name clashes with other instance level properties
 * @ignore
 */
var DynClassNamePrefix = '_dynCls$';
/**
 * A tag which is used to check if we have already to attempted to set the instance function if one is not present
 * @ignore
 */
var DynInstChkTag = '_dynInstChk';
/**
 * A tag which is used to check if we are allows to try and set an instance function is one is not present. Using the same
 * tag name as the function level but a different const name for readability only.
 */
var DynAllowInstChkTag = DynInstChkTag;
/**
 * The global (imported) instances where the global performance options are stored
 */
var DynProtoDefaultOptions = '_dfOpts';
/**
 * Value used as the name of a class when it cannot be determined
 * @ignore
 */
var UnknownValue = '_unknown_';
/**
 * Constant string defined to support minimization
 * @ignore
 */
var str__Proto = "__proto__";
/**
 * Constant string defined to support minimization
 * @ignore
 */
var strUseBaseInst = 'useBaseInst';
/**
 * Constant string defined to support minimization
 * @ignore
 */
var strSetInstFuncs = 'setInstFuncs';
var Obj = Object;
/**
 * Pre-lookup to check if we are running on a modern browser (i.e. not IE8)
 * @ignore
 */
var _objGetPrototypeOf = Obj["getPrototypeOf"];
/**
 * Internal Global used to generate a unique dynamic class name, every new class will increase this value
 * @ignore
 */
var _dynamicNames = 0;
/**
 * Helper to check if the object contains a property of the name
 * @ignore
 */
function _hasOwnProperty(obj, prop) {
    return obj && Obj[Prototype].hasOwnProperty.call(obj, prop);
}
/**
 * Helper used to check whether the target is an Object prototype or Array prototype
 * @ignore
 */
function _isObjectOrArrayPrototype(target) {
    return target && (target === Obj[Prototype] || target === Array[Prototype]);
}
/**
 * Helper used to check whether the target is an Object prototype, Array prototype or Function prototype
 * @ignore
 */
function _isObjectArrayOrFunctionPrototype(target) {
    return _isObjectOrArrayPrototype(target) || target === Function[Prototype];
}
/**
 * Helper used to get the prototype of the target object as getPrototypeOf is not available in an ES3 environment.
 * @ignore
 */
function _getObjProto(target) {
    if (target) {
        // This method doesn't existing in older browsers (e.g. IE8)
        if (_objGetPrototypeOf) {
            return _objGetPrototypeOf(target);
        }
        // target[Constructor] May break if the constructor has been changed or removed
        var newProto = target[str__Proto] || target[Prototype] || (target[Constructor] ? target[Constructor][Prototype] : null);
        if (newProto) {
            return newProto;
        }
    }
    return null;
}
/**
 * Helper to get the properties of an object, including none enumerable ones as functions on a prototype in ES6
 * are not enumerable.
 * @param target
 */
function _forEachProp(target, func) {
    var props = [];
    var getOwnProps = Obj["getOwnPropertyNames"];
    if (getOwnProps) {
        props = getOwnProps(target);
    }
    else {
        for (var name_1 in target) {
            if (typeof name_1 === "string" && _hasOwnProperty(target, name_1)) {
                props.push(name_1);
            }
        }
    }
    if (props && props.length > 0) {
        for (var lp = 0; lp < props.length; lp++) {
            func(props[lp]);
        }
    }
}
/**
 * Helper function to check whether the provided function name is a potential candidate for dynamic
 * callback and prototype generation.
 * @param target The target object, may be a prototype or class object
 * @param funcName The function name
 * @param skipOwn Skips the check for own property
 * @ignore
 */
function _isDynamicCandidate(target, funcName, skipOwn) {
    return (funcName !== Constructor && typeof target[funcName] === strFunction && (skipOwn || _hasOwnProperty(target, funcName)));
}
/**
 * Helper to throw a TypeError exception
 * @param message the message
 * @ignore
 */
function _throwTypeError(message) {
    throw new TypeError("DynamicProto: " + message);
}
/**
 * Returns a collection of the instance functions that are defined directly on the thisTarget object, it does
 * not return any inherited functions
 * @param thisTarget The object to get the instance functions from
 * @ignore
 */
function _getInstanceFuncs(thisTarget) {
    // Get the base proto
    var instFuncs = {};
    // Save any existing instance functions
    _forEachProp(thisTarget, function (name) {
        // Don't include any dynamic prototype instances - as we only want the real functions
        if (!instFuncs[name] && _isDynamicCandidate(thisTarget, name, false)) {
            // Create an instance callback for passing the base function to the caller
            instFuncs[name] = thisTarget[name];
        }
    });
    return instFuncs;
}
/**
 * Returns whether the value is included in the array
 * @param values The array of values
 * @param value  The value
 */
function _hasVisited(values, value) {
    for (var lp = values.length - 1; lp >= 0; lp--) {
        if (values[lp] === value) {
            return true;
        }
    }
    return false;
}
/**
 * Returns an object that contains callback functions for all "base/super" functions, this is used to "save"
 * enabling calling super.xxx() functions without requiring that the base "class" has defined a prototype references
 * @param target The current instance
 * @ignore
 */
function _getBaseFuncs(classProto, thisTarget, instFuncs, useBaseInst) {
    function _instFuncProxy(target, funcHost, funcName) {
        var theFunc = funcHost[funcName];
        if (theFunc[DynProxyTag] && useBaseInst) {
            // grab and reuse the hosted looking function (if available) otherwise the original passed function
            var instFuncTable = target[DynInstFuncTable] || {};
            if (instFuncTable[DynAllowInstChkTag] !== false) {
                theFunc = (instFuncTable[funcHost[DynClassName]] || {})[funcName] || theFunc;
            }
        }
        return function () {
            return theFunc.apply(target, arguments);
        };
    }
    // Start creating a new baseFuncs by creating proxies for the instance functions (as they may get replaced)
    var baseFuncs = {};
    _forEachProp(instFuncs, function (name) {
        // Create an instance callback for passing the base function to the caller
        baseFuncs[name] = _instFuncProxy(thisTarget, instFuncs, name);
    });
    // Get the base prototype functions
    var baseProto = _getObjProto(classProto);
    var visited = [];
    // Don't include base object functions for Object, Array or Function
    while (baseProto && !_isObjectArrayOrFunctionPrototype(baseProto) && !_hasVisited(visited, baseProto)) {
        // look for prototype functions
        _forEachProp(baseProto, function (name) {
            // Don't include any dynamic prototype instances - as we only want the real functions
            // For IE 7/8 the prototype lookup doesn't provide the full chain so we need to bypass the 
            // hasOwnProperty check we get all of the methods, main difference is that IE7/8 doesn't return
            // the Object prototype methods while bypassing the check
            if (!baseFuncs[name] && _isDynamicCandidate(baseProto, name, !_objGetPrototypeOf)) {
                // Create an instance callback for passing the base function to the caller
                baseFuncs[name] = _instFuncProxy(thisTarget, baseProto, name);
            }
        });
        // We need to find all possible functions that might be overloaded by walking the entire prototype chain
        // This avoids the caller from needing to check whether it's direct base class implements the function or not
        // by walking the entire chain it simplifies the usage and issues from upgrading any of the base classes.
        visited.push(baseProto);
        baseProto = _getObjProto(baseProto);
    }
    return baseFuncs;
}
function _getInstFunc(target, funcName, proto, currentDynProtoProxy) {
    var instFunc = null;
    // We need to check whether the class name is defined directly on this prototype otherwise
    // it will walk the proto chain and return any parent proto classname.
    if (target && _hasOwnProperty(proto, DynClassName)) {
        var instFuncTable = target[DynInstFuncTable] || {};
        instFunc = (instFuncTable[proto[DynClassName]] || {})[funcName];
        if (!instFunc) {
            // Avoid stack overflow from recursive calling the same function
            _throwTypeError("Missing [" + funcName + "] " + strFunction);
        }
        // We have the instance function, lets check it we can speed up further calls
        // by adding the instance function back directly on the instance (avoiding the dynamic func lookup)
        if (!instFunc[DynInstChkTag] && instFuncTable[DynAllowInstChkTag] !== false) {
            // If the instance already has an instance function we can't replace it
            var canAddInst = !_hasOwnProperty(target, funcName);
            // Get current prototype
            var objProto = _getObjProto(target);
            var visited = [];
            // Lookup the function starting at the top (instance level prototype) and traverse down, if the first matching function
            // if nothing is found or if the first hit is a dynamic proto instance then we can safely add an instance shortcut
            while (canAddInst && objProto && !_isObjectArrayOrFunctionPrototype(objProto) && !_hasVisited(visited, objProto)) {
                var protoFunc = objProto[funcName];
                if (protoFunc) {
                    canAddInst = (protoFunc === currentDynProtoProxy);
                    break;
                }
                // We need to find all possible initial functions to ensure that we don't bypass a valid override function
                visited.push(objProto);
                objProto = _getObjProto(objProto);
            }
            try {
                if (canAddInst) {
                    // This instance doesn't have an instance func and the class hierarchy does have a higher level prototype version
                    // so it's safe to directly assign for any subsequent calls (for better performance)
                    target[funcName] = instFunc;
                }
                // Block further attempts to set the instance function for any
                instFunc[DynInstChkTag] = 1;
            }
            catch (e) {
                // Don't crash if the object is readonly or the runtime doesn't allow changing this
                // And set a flag so we don't try again for any function
                instFuncTable[DynAllowInstChkTag] = false;
            }
        }
    }
    return instFunc;
}
function _getProtoFunc(funcName, proto, currentDynProtoProxy) {
    var protoFunc = proto[funcName];
    // Check that the prototype function is not a self reference -- try to avoid stack overflow!
    if (protoFunc === currentDynProtoProxy) {
        // It is so lookup the base prototype
        protoFunc = _getObjProto(proto)[funcName];
    }
    if (typeof protoFunc !== strFunction) {
        _throwTypeError("[" + funcName + "] is not a " + strFunction);
    }
    return protoFunc;
}
/**
 * Add the required dynamic prototype methods to the the class prototype
 * @param proto - The class prototype
 * @param className - The instance classname
 * @param target - The target instance
 * @param baseInstFuncs - The base instance functions
 * @param setInstanceFunc - Flag to allow prototype function to reset the instance function if one does not exist
 * @ignore
 */
function _populatePrototype(proto, className, target, baseInstFuncs, setInstanceFunc) {
    function _createDynamicPrototype(proto, funcName) {
        var dynProtoProxy = function () {
            // Use the instance or prototype function
            var instFunc = _getInstFunc(this, funcName, proto, dynProtoProxy) || _getProtoFunc(funcName, proto, dynProtoProxy);
            return instFunc.apply(this, arguments);
        };
        // Tag this function as a proxy to support replacing dynamic proxy elements (primary use case is for unit testing
        // via which can dynamically replace the prototype function reference)
        dynProtoProxy[DynProxyTag] = 1;
        return dynProtoProxy;
    }
    if (!_isObjectOrArrayPrototype(proto)) {
        var instFuncTable = target[DynInstFuncTable] = target[DynInstFuncTable] || {};
        var instFuncs_1 = instFuncTable[className] = (instFuncTable[className] || {}); // fetch and assign if as it may not exist yet
        // Set whether we are allow to lookup instances, if someone has set to false then do not re-enable
        if (instFuncTable[DynAllowInstChkTag] !== false) {
            instFuncTable[DynAllowInstChkTag] = !!setInstanceFunc;
        }
        _forEachProp(target, function (name) {
            // Only add overridden functions
            if (_isDynamicCandidate(target, name, false) && target[name] !== baseInstFuncs[name]) {
                // Save the instance Function to the lookup table and remove it from the instance as it's not a dynamic proto function
                instFuncs_1[name] = target[name];
                delete target[name];
                // Add a dynamic proto if one doesn't exist or if a prototype function exists and it's not a dynamic one
                if (!_hasOwnProperty(proto, name) || (proto[name] && !proto[name][DynProxyTag])) {
                    proto[name] = _createDynamicPrototype(proto, name);
                }
            }
        });
    }
}
/**
 * Checks whether the passed prototype object appears to be correct by walking the prototype hierarchy of the instance
 * @param classProto The class prototype instance
 * @param thisTarget The current instance that will be checked whether the passed prototype instance is in the hierarchy
 * @ignore
 */
function _checkPrototype(classProto, thisTarget) {
    // This method doesn't existing in older browsers (e.g. IE8)
    if (_objGetPrototypeOf) {
        // As this is primarily a coding time check, don't bother checking if running in IE8 or lower
        var visited = [];
        var thisProto = _getObjProto(thisTarget);
        while (thisProto && !_isObjectArrayOrFunctionPrototype(thisProto) && !_hasVisited(visited, thisProto)) {
            if (thisProto === classProto) {
                return true;
            }
            // This avoids the caller from needing to check whether it's direct base class implements the function or not
            // by walking the entire chain it simplifies the usage and issues from upgrading any of the base classes.
            visited.push(thisProto);
            thisProto = _getObjProto(thisProto);
        }
    }
    return false;
}
/**
 * Gets the current prototype name using the ES6 name if available otherwise falling back to a use unknown as the name.
 * It's not critical for this to return a name, it's used to decorate the generated unique name for easier debugging only.
 * @param target
 * @param unknownValue
 * @ignore
 */
function _getObjName(target, unknownValue) {
    if (_hasOwnProperty(target, Prototype)) {
        // Look like a prototype
        return target.name || unknownValue || UnknownValue;
    }
    return (((target || {})[Constructor]) || {}).name || unknownValue || UnknownValue;
}
/**
 * Helper function when creating dynamic (inline) functions for classes, this helper performs the following tasks :-
 * - Saves references to all defined base class functions
 * - Calls the delegateFunc with the current target (this) and a base object reference that can be used to call all "super" functions.
 * - Will populate the class prototype for all overridden functions to support class extension that call the prototype instance.
 * Callers should use this helper when declaring all function within the constructor of a class, as mentioned above the delegateFunc is
 * passed both the target "this" and an object that can be used to call any base (super) functions, using this based object in place of
 * super.XXX() (which gets expanded to _super.prototype.XXX()) provides a better minification outcome and also ensures the correct "this"
 * context is maintained as TypeScript creates incorrect references using super.XXXX() for dynamically defined functions i.e. Functions
 * defined in the constructor or some other function (rather than declared as complete typescript functions).
 * ### Usage
 * ```typescript
 * import dynamicProto from "@microsoft/dynamicproto-js";
 * class ExampleClass extends BaseClass {
 *     constructor() {
 *         dynamicProto(ExampleClass, this, (_self, base) => {
 *             // This will define a function that will be converted to a prototype function
 *             _self.newFunc = () => {
 *                 // Access any "this" instance property
 *                 if (_self.someProperty) {
 *                     ...
 *                 }
 *             }
 *             // This will define a function that will be converted to a prototype function
 *             _self.myFunction = () => {
 *                 // Access any "this" instance property
 *                 if (_self.someProperty) {
 *                     // Call the base version of the function that we are overriding
 *                     base.myFunction();
 *                 }
 *                 ...
 *             }
 *             _self.initialize = () => {
 *                 ...
 *             }
 *             // Warnings: While the following will work as _self is simply a reference to
 *             // this, if anyone overrides myFunction() the overridden will be called first
 *             // as the normal JavaScript method resolution will occur and the defined
 *             // _self.initialize() function is actually gets removed from the instance and
 *             // a proxy prototype version is created to reference the created method.
 *             _self.initialize();
 *         });
 *     }
 * }
 * ```
 * @typeparam DPType This is the generic type of the class, used to keep intellisense valid
 * @typeparam DPCls The type that contains the prototype of the current class
 * @param theClass - This is the current class instance which contains the prototype for the current class
 * @param target - The current "this" (target) reference, when the class has been extended this.prototype will not be the 'theClass' value.
 * @param delegateFunc - The callback function (closure) that will create the dynamic function
 * @param options - Additional options to configure how the dynamic prototype operates
 */
function dynamicProto(theClass, target, delegateFunc, options) {
    // Make sure that the passed theClass argument looks correct
    if (!_hasOwnProperty(theClass, Prototype)) {
        _throwTypeError("theClass is an invalid class definition.");
    }
    // Quick check to make sure that the passed theClass argument looks correct (this is a common copy/paste error)
    var classProto = theClass[Prototype];
    if (!_checkPrototype(classProto, target)) {
        _throwTypeError("[" + _getObjName(theClass) + "] is not in class hierarchy of [" + _getObjName(target) + "]");
    }
    var className = null;
    if (_hasOwnProperty(classProto, DynClassName)) {
        // Only grab the class name if it's defined on this prototype (i.e. don't walk the prototype chain)
        className = classProto[DynClassName];
    }
    else {
        // As not all browser support name on the prototype creating a unique dynamic one if we have not already
        // assigned one, so we can use a simple string as the lookup rather than an object for the dynamic instance
        // function table lookup.
        className = DynClassNamePrefix + _getObjName(theClass, "_") + "$" + _dynamicNames;
        _dynamicNames++;
        classProto[DynClassName] = className;
    }
    var perfOptions = dynamicProto[DynProtoDefaultOptions];
    var useBaseInst = !!perfOptions[strUseBaseInst];
    if (useBaseInst && options && options[strUseBaseInst] !== undefined) {
        useBaseInst = !!options[strUseBaseInst];
    }
    // Get the current instance functions
    var instFuncs = _getInstanceFuncs(target);
    // Get all of the functions for any base instance (before they are potentially overridden)
    var baseFuncs = _getBaseFuncs(classProto, target, instFuncs, useBaseInst);
    // Execute the delegate passing in both the current target "this" and "base" function references
    // Note casting the same type as we don't actually have the base class here and this will provide some intellisense support
    delegateFunc(target, baseFuncs);
    // Don't allow setting instance functions for older IE instances
    var setInstanceFunc = !!_objGetPrototypeOf && !!perfOptions[strSetInstFuncs];
    if (setInstanceFunc && options) {
        setInstanceFunc = !!options[strSetInstFuncs];
    }
    // Populate the Prototype for any overridden instance functions
    _populatePrototype(classProto, className, target, instFuncs, setInstanceFunc !== false);
}
/**
 * Exposes the default global options to allow global configuration, if the global values are disabled these will override
 * any passed values. This is primarily exposed to support unit-testing without the need for individual classes to expose
 * their internal usage of dynamic proto.
 */
var perfDefaults = {
    setInstFuncs: true,
    useBaseInst: true
};
// And expose for testing
dynamicProto[DynProtoDefaultOptions] = perfDefaults;

/* harmony default export */ __webpack_exports__["a"] = (dynamicProto);
//# sourceMappingURL=dynamicproto-js.js.map


/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setVersion__ = __webpack_require__(1561);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__setVersion__["a"]; });


Object(__WEBPACK_IMPORTED_MODULE_0__setVersion__["a" /* setVersion */])('@uifabric/set-version', '6.0.0');
//# sourceMappingURL=index.js.map

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InjectionMode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Stylesheet; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);

var InjectionMode = {
    /**
     * Avoids style injection, use getRules() to read the styles.
     */
    none: 0,
    /**
     * Inserts rules using the insertRule api.
     */
    insertNode: 1,
    /**
     * Appends rules using appendChild.
     */
    appendChild: 2
};
var STYLESHEET_SETTING = '__stylesheet__';
// tslint:disable-next-line:no-any
var _global = {};
// Grab window.
try {
    _global = window;
}
catch (_a) {
    /* leave as blank object */
}
var _stylesheet;
/**
 * Represents the state of styles registered in the page. Abstracts
 * the surface for adding styles to the stylesheet, exposes helpers
 * for reading the styles registered in server rendered scenarios.
 *
 * @public
 */
var Stylesheet = /** @class */ (function () {
    function Stylesheet(config) {
        this._rules = [];
        this._preservedRules = [];
        this._rulesToInsert = [];
        this._counter = 0;
        this._keyToClassName = {};
        this._onResetCallbacks = [];
        // tslint:disable-next-line:no-any
        this._classNameToArgs = {};
        this._config = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ injectionMode: InjectionMode.insertNode, defaultPrefix: 'css', namespace: undefined, cspSettings: undefined }, config);
    }
    /**
     * Gets the singleton instance.
     */
    Stylesheet.getInstance = function () {
        // tslint:disable-next-line:no-any
        _stylesheet = _global[STYLESHEET_SETTING];
        if (!_stylesheet || (_stylesheet._lastStyleElement && _stylesheet._lastStyleElement.ownerDocument !== document)) {
            // tslint:disable-next-line:no-string-literal
            var fabricConfig = (_global && _global['FabricConfig']) || {};
            _stylesheet = _global[STYLESHEET_SETTING] = new Stylesheet(fabricConfig.mergeStyles);
        }
        return _stylesheet;
    };
    /**
     * Configures the stylesheet.
     */
    Stylesheet.prototype.setConfig = function (config) {
        this._config = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._config, config);
    };
    /**
     * Configures a reset callback.
     *
     * @param callback - A callback which will be called when the Stylesheet is reset.
     */
    Stylesheet.prototype.onReset = function (callback) {
        this._onResetCallbacks.push(callback);
    };
    /**
     * Generates a unique classname.
     *
     * @param displayName - Optional value to use as a prefix.
     */
    Stylesheet.prototype.getClassName = function (displayName) {
        var namespace = this._config.namespace;
        var prefix = displayName || this._config.defaultPrefix;
        return "" + (namespace ? namespace + '-' : '') + prefix + "-" + this._counter++;
    };
    /**
     * Used internally to cache information about a class which was
     * registered with the stylesheet.
     */
    Stylesheet.prototype.cacheClassName = function (className, key, args, rules) {
        this._keyToClassName[key] = className;
        this._classNameToArgs[className] = {
            args: args,
            rules: rules
        };
    };
    /**
     * Gets the appropriate classname given a key which was previously
     * registered using cacheClassName.
     */
    Stylesheet.prototype.classNameFromKey = function (key) {
        return this._keyToClassName[key];
    };
    /**
     * Gets the arguments associated with a given classname which was
     * previously registered using cacheClassName.
     */
    Stylesheet.prototype.argsFromClassName = function (className) {
        var entry = this._classNameToArgs[className];
        return entry && entry.args;
    };
    /**
     * Gets the arguments associated with a given classname which was
     * previously registered using cacheClassName.
     */
    Stylesheet.prototype.insertedRulesFromClassName = function (className) {
        var entry = this._classNameToArgs[className];
        return entry && entry.rules;
    };
    /**
     * Inserts a css rule into the stylesheet.
     * @param preserve - Preserves the rule beyond a reset boundary.
     */
    Stylesheet.prototype.insertRule = function (rule, preserve) {
        var injectionMode = this._config.injectionMode;
        var element = injectionMode !== InjectionMode.none ? this._getStyleElement() : undefined;
        if (preserve) {
            this._preservedRules.push(rule);
        }
        if (element) {
            switch (this._config.injectionMode) {
                case InjectionMode.insertNode:
                    var sheet = element.sheet;
                    try {
                        sheet.insertRule(rule, sheet.cssRules.length);
                    }
                    catch (e) {
                        // The browser will throw exceptions on unsupported rules (such as a moz prefix in webkit.)
                        // We need to swallow the exceptions for this scenario, otherwise we'd need to filter
                        // which could be slower and bulkier.
                    }
                    break;
                case InjectionMode.appendChild:
                    element.appendChild(document.createTextNode(rule));
                    break;
            }
        }
        else {
            this._rules.push(rule);
        }
        if (this._config.onInsertRule) {
            this._config.onInsertRule(rule);
        }
    };
    /**
     * Gets all rules registered with the stylesheet; only valid when
     * using InsertionMode.none.
     */
    Stylesheet.prototype.getRules = function (includePreservedRules) {
        return (includePreservedRules ? this._preservedRules.join('') : '') + this._rules.join('') + this._rulesToInsert.join('');
    };
    /**
     * Resets the internal state of the stylesheet. Only used in server
     * rendered scenarios where we're using InsertionMode.none.
     */
    Stylesheet.prototype.reset = function () {
        this._rules = [];
        this._rulesToInsert = [];
        this._counter = 0;
        this._classNameToArgs = {};
        this._keyToClassName = {};
        this._onResetCallbacks.forEach(function (callback) { return callback(); });
    };
    // Forces the regeneration of incoming styles without totally resetting the stylesheet.
    Stylesheet.prototype.resetKeys = function () {
        this._keyToClassName = {};
    };
    Stylesheet.prototype._getStyleElement = function () {
        var _this = this;
        if (!this._styleElement && typeof document !== 'undefined') {
            this._styleElement = this._createStyleElement();
            // Reset the style element on the next frame.
            window.requestAnimationFrame(function () {
                _this._styleElement = undefined;
            });
        }
        return this._styleElement;
    };
    Stylesheet.prototype._createStyleElement = function () {
        var styleElement = document.createElement('style');
        styleElement.setAttribute('data-merge-styles', 'true');
        styleElement.type = 'text/css';
        var cspSettings = this._config.cspSettings;
        if (cspSettings) {
            if (cspSettings.nonce) {
                styleElement.setAttribute('nonce', cspSettings.nonce);
            }
        }
        if (this._lastStyleElement && this._lastStyleElement.nextElementSibling) {
            document.head.insertBefore(styleElement, this._lastStyleElement.nextElementSibling);
        }
        else {
            document.head.appendChild(styleElement);
        }
        this._lastStyleElement = styleElement;
        return styleElement;
    };
    return Stylesheet;
}());

//# sourceMappingURL=Stylesheet.js.map

/***/ }),
/* 147 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HttpTransportType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TransferFormat; });
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
// This will be treated as a bit flag in the future, so we keep it using power-of-two values.
/** Specifies a specific HTTP transport type. */
var HttpTransportType;
(function (HttpTransportType) {
    /** Specifies no transport preference. */
    HttpTransportType[HttpTransportType["None"] = 0] = "None";
    /** Specifies the WebSockets transport. */
    HttpTransportType[HttpTransportType["WebSockets"] = 1] = "WebSockets";
    /** Specifies the Server-Sent Events transport. */
    HttpTransportType[HttpTransportType["ServerSentEvents"] = 2] = "ServerSentEvents";
    /** Specifies the Long Polling transport. */
    HttpTransportType[HttpTransportType["LongPolling"] = 4] = "LongPolling";
})(HttpTransportType || (HttpTransportType = {}));
/** Specifies the transfer format for a connection. */
var TransferFormat;
(function (TransferFormat) {
    /** Specifies that only text data will be transmitted over the connection. */
    TransferFormat[TransferFormat["Text"] = 1] = "Text";
    /** Specifies that binary data will be transmitted over the connection. */
    TransferFormat[TransferFormat["Binary"] = 2] = "Binary";
})(TransferFormat || (TransferFormat = {}));
//# sourceMappingURL=ITransport.js.map

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ColumnActionsMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ConstrainMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ColumnDragEndLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DetailsListLayoutMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CheckboxVisibility; });
/**
 * Enum to describe how a particular column header behaves.... This enum is used to
 * to specify the property IColumn:columnActionsMode.
 * If IColumn:columnActionsMode is undefined, then it's equivalent to ColumnActionsMode.clickable
 * {@docCategory DetailsList}
 */
var ColumnActionsMode;
(function (ColumnActionsMode) {
    /**
     * Renders the column header as disabled.
     */
    ColumnActionsMode[ColumnActionsMode["disabled"] = 0] = "disabled";
    /**
     * Renders the column header is clickable.
     */
    ColumnActionsMode[ColumnActionsMode["clickable"] = 1] = "clickable";
    /**
     * Renders the column header ias clickable and displays the dropdown cheveron.
     */
    ColumnActionsMode[ColumnActionsMode["hasDropdown"] = 2] = "hasDropdown";
})(ColumnActionsMode || (ColumnActionsMode = {}));
/**
 * {@docCategory DetailsList}
 */
var ConstrainMode;
(function (ConstrainMode) {
    /** If specified, lets the content grow which allows the page to manage scrolling. */
    ConstrainMode[ConstrainMode["unconstrained"] = 0] = "unconstrained";
    /**
     * If specified, constrains the list to the given layout space.
     */
    ConstrainMode[ConstrainMode["horizontalConstrained"] = 1] = "horizontalConstrained";
})(ConstrainMode || (ConstrainMode = {}));
/**
 * Enum to describe where the column has been dropped, after starting the drag
 * {@docCategory DetailsList}
 */
var ColumnDragEndLocation;
(function (ColumnDragEndLocation) {
    /**
     * Drag ended outside of current list
     */
    ColumnDragEndLocation[ColumnDragEndLocation["outside"] = 0] = "outside";
    /**
     * Drag ended on current List
     */
    ColumnDragEndLocation[ColumnDragEndLocation["surface"] = 1] = "surface";
    /**
     * Drag ended on Header
     */
    ColumnDragEndLocation[ColumnDragEndLocation["header"] = 2] = "header";
})(ColumnDragEndLocation || (ColumnDragEndLocation = {}));
/**
 * {@docCategory DetailsList}
 */
var DetailsListLayoutMode;
(function (DetailsListLayoutMode) {
    /**
     * Lets the user resize columns and makes not attempt to fit them.
     */
    DetailsListLayoutMode[DetailsListLayoutMode["fixedColumns"] = 0] = "fixedColumns";
    /**
     * Manages which columns are visible, tries to size them according to their min/max rules and drops
     * off columns that can't fit and have isCollapsible set.
     */
    DetailsListLayoutMode[DetailsListLayoutMode["justified"] = 1] = "justified";
})(DetailsListLayoutMode || (DetailsListLayoutMode = {}));
/**
 * {@docCategory DetailsList}
 */
var CheckboxVisibility;
(function (CheckboxVisibility) {
    /**
     * Visible on hover.
     */
    CheckboxVisibility[CheckboxVisibility["onHover"] = 0] = "onHover";
    /**
     * Visible always.
     */
    CheckboxVisibility[CheckboxVisibility["always"] = 1] = "always";
    /**
     * Hide checkboxes.
     */
    CheckboxVisibility[CheckboxVisibility["hidden"] = 2] = "hidden";
})(CheckboxVisibility || (CheckboxVisibility = {}));
//# sourceMappingURL=DetailsList.types.js.map

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icon__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_DirectionalHint__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContextualMenu__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BaseButton_classNames__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SplitButton_SplitButton_classNames__ = __webpack_require__(1754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__KeytipData__ = __webpack_require__(89);









var TouchIdleDelay = 500; /* ms */
/**
 * {@docCategory Button}
 */
var BaseButton = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](BaseButton, _super);
    function BaseButton(props, rootClassName) {
        var _this = _super.call(this, props) || this;
        _this._buttonElement = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._splitButtonContainer = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._renderedPersistentMenu = false;
        _this._onRenderIcon = function (buttonProps, defaultRender) {
            var iconProps = _this.props.iconProps;
            if (iconProps && (iconProps.iconName !== undefined || iconProps.imageProps)) {
                var className = iconProps.className, rest = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __rest */](iconProps, ["className"]);
                return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Icon__["Icon"], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])(_this._classNames.icon, className) }, rest));
            }
            return null;
        };
        _this._onRenderTextContents = function () {
            var _a = _this.props, text = _a.text, children = _a.children, _b = _a.secondaryText, secondaryText = _b === void 0 ? _this.props.description : _b, _c = _a.onRenderText, onRenderText = _c === void 0 ? _this._onRenderText : _c, _d = _a.onRenderDescription, onRenderDescription = _d === void 0 ? _this._onRenderDescription : _d;
            if (text || typeof children === 'string' || secondaryText) {
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: _this._classNames.textContainer },
                    onRenderText(_this.props, _this._onRenderText),
                    onRenderDescription(_this.props, _this._onRenderDescription)));
            }
            return [onRenderText(_this.props, _this._onRenderText), onRenderDescription(_this.props, _this._onRenderDescription)];
        };
        _this._onRenderText = function () {
            var text = _this.props.text;
            var children = _this.props.children;
            // For backwards compat, we should continue to take in the text content from children.
            if (text === undefined && typeof children === 'string') {
                text = children;
            }
            if (_this._hasText()) {
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { key: _this._labelId, className: _this._classNames.label, id: _this._labelId }, text));
            }
            return null;
        };
        _this._onRenderChildren = function () {
            var children = _this.props.children;
            // If children is just a string, either it or the text will be rendered via onRenderLabel
            // If children is another component, it will be rendered after text
            if (typeof children === 'string') {
                return null;
            }
            return children;
        };
        _this._onRenderDescription = function (props) {
            var _a = props.secondaryText, secondaryText = _a === void 0 ? _this.props.description : _a;
            // ms-Button-description is only shown when the button type is compound.
            // In other cases it will not be displayed.
            return secondaryText ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { key: _this._descriptionId, className: _this._classNames.description, id: _this._descriptionId }, secondaryText)) : null;
        };
        _this._onRenderAriaDescription = function () {
            var ariaDescription = _this.props.ariaDescription;
            // If ariaDescription is given, descriptionId will be assigned to ariaDescriptionSpan,
            // otherwise it will be assigned to descriptionSpan.
            return ariaDescription ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: _this._classNames.screenReaderText, id: _this._ariaDescriptionId }, ariaDescription)) : null;
        };
        _this._onRenderMenuIcon = function (props) {
            var menuIconProps = _this.props.menuIconProps;
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Icon__["Icon"], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ iconName: "ChevronDown" }, menuIconProps, { className: _this._classNames.menuIcon }));
        };
        _this._onRenderMenu = function (menuProps) {
            var _a = menuProps.onDismiss, onDismiss = _a === void 0 ? _this._dismissMenu : _a;
            var MenuType = _this.props.menuAs || __WEBPACK_IMPORTED_MODULE_5__ContextualMenu__["a" /* ContextualMenu */];
            // the accessible menu label (accessible name) has a relationship to the button.
            // If the menu props do not specify an explicit value for aria-label or aria-labelledBy,
            // AND the button has text, we'll set the menu aria-labelledBy to the text element id.
            if (!menuProps.ariaLabel && !menuProps.labelElementId && _this._hasText()) {
                menuProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, menuProps, { labelElementId: _this._labelId });
            }
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](MenuType, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ id: _this._labelId + '-menu', directionalHint: __WEBPACK_IMPORTED_MODULE_4__common_DirectionalHint__["a" /* DirectionalHint */].bottomLeftEdge }, menuProps, { shouldFocusOnContainer: _this.state.menuProps ? _this.state.menuProps.shouldFocusOnContainer : undefined, shouldFocusOnMount: _this.state.menuProps ? _this.state.menuProps.shouldFocusOnMount : undefined, hidden: _this.state.menuProps ? _this.state.menuProps.hidden : undefined, className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-BaseButton-menuhost', menuProps.className), target: _this._isSplitButton ? _this._splitButtonContainer.current : _this._buttonElement.current, onDismiss: onDismiss })));
        };
        _this._dismissMenu = function () {
            var menuProps = null;
            if (_this.props.persistMenu && _this.state.menuProps) {
                // Create a new object to trigger componentDidUpdate
                menuProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, _this.state.menuProps, { hidden: true });
            }
            _this.setState({ menuProps: menuProps });
        };
        _this._openMenu = function (shouldFocusOnContainer, shouldFocusOnMount) {
            if (shouldFocusOnMount === void 0) { shouldFocusOnMount = true; }
            if (_this.props.menuProps) {
                var menuProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, _this.props.menuProps, { shouldFocusOnContainer: shouldFocusOnContainer, shouldFocusOnMount: shouldFocusOnMount });
                if (_this.props.persistMenu) {
                    _this._renderedPersistentMenu = true;
                    menuProps.hidden = false;
                }
                _this.setState({ menuProps: menuProps });
            }
        };
        _this._onToggleMenu = function (shouldFocusOnContainer) {
            var currentMenuProps = _this.state.menuProps;
            var shouldFocusOnMount = true;
            if (_this.props.menuProps && _this.props.menuProps.shouldFocusOnMount === false) {
                shouldFocusOnMount = false;
            }
            if (_this.props.persistMenu) {
                // _renderedPersistentMenu ensures that the first rendering of
                // the menu happens on-screen, as edge's scrollbar calcuations are off if done while hidden.
                !_this._renderedPersistentMenu || (currentMenuProps && currentMenuProps.hidden)
                    ? _this._openMenu(shouldFocusOnContainer, shouldFocusOnMount)
                    : _this._dismissMenu();
            }
            else {
                currentMenuProps ? _this._dismissMenu() : _this._openMenu(shouldFocusOnContainer, shouldFocusOnMount);
            }
        };
        _this._onSplitContainerFocusCapture = function (ev) {
            var container = _this._splitButtonContainer.current;
            // If the target is coming from the portal we do not need to set focus on the container.
            if (!container || (ev.target && Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_19" /* portalContainsElement */])(ev.target, container))) {
                return;
            }
            // We should never be able to focus the individual buttons in a split button. Focus
            // should always remain on the container.
            container.focus();
        };
        _this._onSplitButtonPrimaryClick = function (ev) {
            if (_this._isExpanded) {
                _this._dismissMenu();
            }
            if (!_this._processingTouch && _this.props.onClick) {
                _this.props.onClick(ev);
            }
            else if (_this._processingTouch) {
                _this._onMenuClick(ev);
            }
        };
        _this._onKeyDown = function (ev) {
            // explicity cancelling event so click won't fire after this
            if (_this.props.disabled && (ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].enter || ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].space)) {
                ev.preventDefault();
                ev.stopPropagation();
            }
            else if (!_this.props.disabled) {
                if (_this.props.menuProps) {
                    _this._onMenuKeyDown(ev);
                }
                else if (_this.props.onKeyDown !== undefined) {
                    _this.props.onKeyDown(ev); // not cancelling event because it's not disabled
                }
            }
        };
        _this._onKeyUp = function (ev) {
            if (!_this.props.disabled && _this.props.onKeyUp !== undefined) {
                _this.props.onKeyUp(ev); // not cancelling event because it's not disabled
            }
        };
        _this._onKeyPress = function (ev) {
            if (!_this.props.disabled && _this.props.onKeyPress !== undefined) {
                _this.props.onKeyPress(ev); // not cancelling event because it's not disabled
            }
        };
        _this._onMouseUp = function (ev) {
            if (!_this.props.disabled && _this.props.onMouseUp !== undefined) {
                _this.props.onMouseUp(ev); // not cancelling event because it's not disabled
            }
        };
        _this._onMouseDown = function (ev) {
            if (!_this.props.disabled && _this.props.onMouseDown !== undefined) {
                _this.props.onMouseDown(ev); // not cancelling event because it's not disabled
            }
        };
        _this._onClick = function (ev) {
            if (!_this.props.disabled) {
                if (_this.props.menuProps) {
                    _this._onMenuClick(ev);
                }
                else if (_this.props.onClick !== undefined) {
                    _this.props.onClick(ev); // not cancelling event because it's not disabled
                }
            }
        };
        _this._onSplitButtonContainerKeyDown = function (ev) {
            if (ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].enter) {
                if (_this._buttonElement.current) {
                    _this._buttonElement.current.click();
                    ev.preventDefault();
                    ev.stopPropagation();
                }
            }
            else {
                _this._onMenuKeyDown(ev);
            }
        };
        _this._onMenuKeyDown = function (ev) {
            if (_this.props.disabled) {
                return;
            }
            if (_this.props.onKeyDown) {
                _this.props.onKeyDown(ev);
            }
            var isUp = ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].up;
            var isDown = ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].down;
            if (!ev.defaultPrevented && _this._isValidMenuOpenKey(ev)) {
                var onMenuClick = _this.props.onMenuClick;
                if (onMenuClick) {
                    onMenuClick(ev, _this);
                }
                _this._onToggleMenu(false);
                ev.preventDefault();
                ev.stopPropagation();
            }
            if (!(ev.altKey || ev.metaKey) && (isUp || isDown)) {
                _this.setState(function (state) {
                    if (state.menuProps && !state.menuProps.shouldFocusOnMount) {
                        return { menuProps: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, state.menuProps, { shouldFocusOnMount: true }) };
                    }
                    return state;
                });
                // This should be done in the setStateCallback but because preventDefault
                // needs to be called, we have to evaluate the current state, even though
                // it might not be 100% accurate;
                if (_this.state.menuProps && !_this.state.menuProps.shouldFocusOnMount) {
                    ev.preventDefault();
                    ev.stopPropagation();
                }
            }
        };
        _this._onTouchStart = function () {
            if (_this._isSplitButton && _this._splitButtonContainer.current && !('onpointerdown' in _this._splitButtonContainer.current)) {
                _this._handleTouchAndPointerEvent();
            }
        };
        _this._onMenuClick = function (ev) {
            var onMenuClick = _this.props.onMenuClick;
            if (onMenuClick) {
                onMenuClick(ev, _this);
            }
            if (!ev.defaultPrevented) {
                // When Edge + Narrator are used together (regardless of if the button is in a form or not), pressing
                // "Enter" fires this method and not _onMenuKeyDown. Checking ev.nativeEvent.detail differentiates
                // between a real click event and a keypress event (detail should be the number of mouse clicks).
                // ...Plot twist! For a real click event in IE 11, detail is always 0 (Edge sets it properly to 1).
                // So we also check the pointerType property, which both Edge and IE set to "mouse" for real clicks
                // and "" for pressing "Enter" with Narrator on.
                var shouldFocusOnContainer = ev.nativeEvent.detail !== 0 || ev.nativeEvent.pointerType === 'mouse';
                _this._onToggleMenu(shouldFocusOnContainer);
                ev.preventDefault();
                ev.stopPropagation();
            }
        };
        _this._warnConditionallyRequiredProps(['menuProps', 'onClick'], 'split', _this.props.split);
        _this._warnDeprecations({
            rootProps: undefined,
            description: 'secondaryText',
            toggled: 'checked'
        });
        _this._labelId = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["N" /* getId */])();
        _this._descriptionId = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["N" /* getId */])();
        _this._ariaDescriptionId = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["N" /* getId */])();
        _this.state = {
            menuProps: null
        };
        return _this;
    }
    Object.defineProperty(BaseButton.prototype, "_isSplitButton", {
        get: function () {
            return !!this.props.menuProps && !!this.props.onClick && this.props.split === true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseButton.prototype, "_isExpanded", {
        get: function () {
            var menuProps = this.state.menuProps;
            if (this.props.persistMenu) {
                return !!menuProps && !menuProps.hidden;
            }
            return !!menuProps;
        },
        enumerable: true,
        configurable: true
    });
    BaseButton.prototype.render = function () {
        var _a = this.props, ariaDescription = _a.ariaDescription, ariaLabel = _a.ariaLabel, ariaHidden = _a.ariaHidden, className = _a.className, disabled = _a.disabled, allowDisabledFocus = _a.allowDisabledFocus, primaryDisabled = _a.primaryDisabled, _b = _a.secondaryText, secondaryText = _b === void 0 ? this.props.description : _b, href = _a.href, iconProps = _a.iconProps, menuIconProps = _a.menuIconProps, styles = _a.styles, checked = _a.checked, variantClassName = _a.variantClassName, theme = _a.theme, toggle = _a.toggle, getClassNames = _a.getClassNames;
        // Button is disabled if the whole button (in case of splitbutton is disabled) or if the primary action is disabled
        var isPrimaryButtonDisabled = disabled || primaryDisabled;
        this._classNames = getClassNames
            ? getClassNames(theme, className, variantClassName, iconProps && iconProps.className, menuIconProps && menuIconProps.className, isPrimaryButtonDisabled, checked, this._isExpanded, this.props.split, !!allowDisabledFocus)
            : Object(__WEBPACK_IMPORTED_MODULE_6__BaseButton_classNames__["b" /* getBaseButtonClassNames */])(theme, styles, className, variantClassName, iconProps && iconProps.className, menuIconProps && menuIconProps.className, isPrimaryButtonDisabled, checked, this._isExpanded, this.props.split);
        var _c = this, _ariaDescriptionId = _c._ariaDescriptionId, _labelId = _c._labelId, _descriptionId = _c._descriptionId;
        // Anchor tag cannot be disabled hence in disabled state rendering
        // anchor button as normal button
        var renderAsAnchor = !isPrimaryButtonDisabled && !!href;
        var tag = renderAsAnchor ? 'a' : 'button';
        var nativeProps = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["R" /* getNativeProps */])(Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["n" /* assign */])(renderAsAnchor ? {} : { type: 'button' }, this.props.rootProps, this.props), renderAsAnchor ? __WEBPACK_IMPORTED_MODULE_2__Utilities__["k" /* anchorProperties */] : __WEBPACK_IMPORTED_MODULE_2__Utilities__["p" /* buttonProperties */], [
            'disabled' // let disabled buttons be focused and styled as disabled.
        ]);
        // Check for ariaLabel passed in via Button props, and fall back to aria-label passed in via native props
        var resolvedAriaLabel = ariaLabel || nativeProps['aria-label'];
        // Check for ariaDescription, secondaryText or aria-describedby in the native props to determine source of aria-describedby
        // otherwise default to undefined so property does not appear in output.
        var ariaDescribedBy = undefined;
        if (ariaDescription) {
            ariaDescribedBy = _ariaDescriptionId;
        }
        else if (secondaryText) {
            ariaDescribedBy = _descriptionId;
        }
        else if (nativeProps['aria-describedby']) {
            ariaDescribedBy = nativeProps['aria-describedby'];
        }
        // If an explicit ariaLabel is given, use that as the label and we're done.
        // If an explicit aria-labelledby is given, use that and we're done.
        // If any kind of description is given (which will end up as an aria-describedby attribute),
        // set the labelledby element. Otherwise, the button is labeled implicitly by the descendent
        // text on the button (if it exists). Never set both aria-label and aria-labelledby.
        var ariaLabelledBy = undefined;
        if (!resolvedAriaLabel) {
            if (nativeProps['aria-labelledby']) {
                ariaLabelledBy = nativeProps['aria-labelledby'];
            }
            else if (ariaDescribedBy) {
                ariaLabelledBy = this._hasText() ? _labelId : undefined;
            }
        }
        var dataIsFocusable = this.props['data-is-focusable'] === false || (disabled && !allowDisabledFocus) || this._isSplitButton ? false : true;
        var buttonProps = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["n" /* assign */])(nativeProps, {
            className: this._classNames.root,
            ref: this._buttonElement,
            disabled: isPrimaryButtonDisabled && !allowDisabledFocus,
            onKeyDown: this._onKeyDown,
            onKeyPress: this._onKeyPress,
            onKeyUp: this._onKeyUp,
            onMouseDown: this._onMouseDown,
            onMouseUp: this._onMouseUp,
            onClick: this._onClick,
            'aria-label': resolvedAriaLabel,
            'aria-labelledby': ariaLabelledBy,
            'aria-describedby': ariaDescribedBy,
            'aria-disabled': isPrimaryButtonDisabled,
            'data-is-focusable': dataIsFocusable,
            'aria-pressed': toggle ? !!checked : undefined // aria-pressed attribute should only be present for toggle buttons
        });
        if (ariaHidden) {
            buttonProps['aria-hidden'] = true;
        }
        if (this._isSplitButton) {
            return this._onRenderSplitButtonContent(tag, buttonProps);
        }
        else if (this.props.menuProps) {
            Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["n" /* assign */])(buttonProps, {
                'aria-expanded': this._isExpanded,
                'aria-owns': this.state.menuProps ? this._labelId + '-menu' : null,
                'aria-haspopup': true
            });
        }
        return this._onRenderContent(tag, buttonProps);
    };
    BaseButton.prototype.componentDidMount = function () {
        // For split buttons, touching anywhere in the button should drop the dropdown, which should contain the primary action.
        // This gives more hit target space for touch environments. We're setting the onpointerdown here, because React
        // does not support Pointer events yet.
        if (this._isSplitButton && this._splitButtonContainer.current && 'onpointerdown' in this._splitButtonContainer.current) {
            this._events.on(this._splitButtonContainer.current, 'pointerdown', this._onPointerDown, true);
        }
    };
    BaseButton.prototype.componentDidUpdate = function (prevProps, prevState) {
        // If Button's menu was closed, run onAfterMenuDismiss. If the menu is being persisted
        // this condition is tested by checking on a change on the menuProps hidden value.
        if (this.props.onAfterMenuDismiss && prevState.menuProps) {
            if (!this.state.menuProps || (this.props.persistMenu && !prevState.menuProps.hidden && this.state.menuProps.hidden)) {
                this.props.onAfterMenuDismiss();
            }
        }
    };
    BaseButton.prototype.focus = function () {
        if (this._isSplitButton && this._splitButtonContainer.current) {
            this._splitButtonContainer.current.focus();
        }
        else if (this._buttonElement.current) {
            this._buttonElement.current.focus();
        }
    };
    BaseButton.prototype.dismissMenu = function () {
        this._dismissMenu();
    };
    BaseButton.prototype.openMenu = function (shouldFocusOnContainer, shouldFocusOnMount) {
        this._openMenu(shouldFocusOnContainer, shouldFocusOnMount);
    };
    BaseButton.prototype._onRenderContent = function (tag, buttonProps) {
        var _this = this;
        var props = this.props;
        var Tag = tag;
        var menuIconProps = props.menuIconProps, menuProps = props.menuProps, _a = props.onRenderIcon, onRenderIcon = _a === void 0 ? this._onRenderIcon : _a, _b = props.onRenderAriaDescription, onRenderAriaDescription = _b === void 0 ? this._onRenderAriaDescription : _b, _c = props.onRenderChildren, onRenderChildren = _c === void 0 ? this._onRenderChildren : _c, _d = props.onRenderMenu, onRenderMenu = _d === void 0 ? this._onRenderMenu : _d, _e = props.onRenderMenuIcon, onRenderMenuIcon = _e === void 0 ? this._onRenderMenuIcon : _e, disabled = props.disabled;
        var keytipProps = props.keytipProps;
        if (keytipProps && menuProps) {
            keytipProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, keytipProps, { hasMenu: true });
        }
        var Content = (
        // If we're making a split button, we won't put the keytip here
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__KeytipData__["a" /* KeytipData */], { keytipProps: !this._isSplitButton ? keytipProps : undefined, ariaDescribedBy: buttonProps['aria-describedby'], disabled: disabled }, function (keytipAttributes) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Tag, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, buttonProps, keytipAttributes),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: _this._classNames.flexContainer },
                onRenderIcon(props, _this._onRenderIcon),
                _this._onRenderTextContents(),
                onRenderAriaDescription(props, _this._onRenderAriaDescription),
                onRenderChildren(props, _this._onRenderChildren),
                !_this._isSplitButton &&
                    (menuProps || menuIconProps || _this.props.onRenderMenuIcon) &&
                    onRenderMenuIcon(_this.props, _this._onRenderMenuIcon),
                _this.state.menuProps && !_this.state.menuProps.doNotLayer && onRenderMenu(menuProps, _this._onRenderMenu)))); }));
        if (menuProps && menuProps.doNotLayer) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { style: { display: 'inline-block' } },
                Content,
                this.state.menuProps && onRenderMenu(menuProps, this._onRenderMenu)));
        }
        return Content;
    };
    BaseButton.prototype._hasText = function () {
        // _onRenderTextContents and _onRenderText do not perform the same checks. Below is parity with what _onRenderText used to have
        // before the refactor that introduced this function. _onRenderTextContents does not require props.text to be undefined in order
        // for props.children to be used as a fallback. Purely a code maintainability/reuse issue, but logged as Issue #4979
        return this.props.text !== null && (this.props.text !== undefined || typeof this.props.children === 'string');
    };
    BaseButton.prototype._onRenderSplitButtonContent = function (tag, buttonProps) {
        var _this = this;
        var _a = this.props, _b = _a.styles, styles = _b === void 0 ? {} : _b, disabled = _a.disabled, allowDisabledFocus = _a.allowDisabledFocus, checked = _a.checked, getSplitButtonClassNames = _a.getSplitButtonClassNames, primaryDisabled = _a.primaryDisabled, menuProps = _a.menuProps, toggle = _a.toggle;
        var keytipProps = this.props.keytipProps;
        var classNames = getSplitButtonClassNames
            ? getSplitButtonClassNames(!!disabled, this._isExpanded, !!checked, !!allowDisabledFocus)
            : styles && Object(__WEBPACK_IMPORTED_MODULE_7__SplitButton_SplitButton_classNames__["a" /* getClassNames */])(styles, !!disabled, this._isExpanded, !!checked, !!primaryDisabled);
        Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["n" /* assign */])(buttonProps, {
            onClick: undefined,
            tabIndex: -1,
            'data-is-focusable': false
        });
        var ariaDescribedBy = buttonProps.ariaDescription;
        if (keytipProps && menuProps) {
            keytipProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, keytipProps, { hasMenu: true });
        }
        var containerProps = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["R" /* getNativeProps */])(buttonProps, [], ['disabled']);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__KeytipData__["a" /* KeytipData */], { keytipProps: keytipProps, disabled: disabled }, function (keytipAttributes) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, containerProps, { "data-ktp-target": keytipAttributes['data-ktp-target'], role: 'button', "aria-disabled": disabled, "aria-haspopup": true, "aria-expanded": _this._isExpanded, "aria-pressed": toggle ? !!checked : undefined, "aria-describedby": Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_16" /* mergeAriaAttributeValues */])(ariaDescribedBy, keytipAttributes['aria-describedby']), className: classNames && classNames.splitButtonContainer, onKeyDown: _this._onSplitButtonContainerKeyDown, onTouchStart: _this._onTouchStart, ref: _this._splitButtonContainer, "data-is-focusable": true, onClick: !disabled && !primaryDisabled ? _this._onSplitButtonPrimaryClick : undefined, tabIndex: !disabled || allowDisabledFocus ? 0 : undefined, "aria-roledescription": buttonProps['aria-roledescription'], onFocusCapture: _this._onSplitContainerFocusCapture }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { style: { display: 'flex' } },
                _this._onRenderContent(tag, buttonProps),
                _this._onRenderSplitButtonMenuButton(classNames, keytipAttributes),
                _this._onRenderSplitButtonDivider(classNames)))); }));
    };
    BaseButton.prototype._onRenderSplitButtonDivider = function (classNames) {
        if (classNames && classNames.divider) {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: classNames.divider, "aria-hidden": true });
        }
        return null;
    };
    BaseButton.prototype._onRenderSplitButtonMenuButton = function (classNames, keytipAttributes) {
        var _a = this.props, allowDisabledFocus = _a.allowDisabledFocus, checked = _a.checked, disabled = _a.disabled;
        var menuIconProps = this.props.menuIconProps;
        var splitButtonAriaLabel = this.props.splitButtonAriaLabel;
        if (menuIconProps === undefined) {
            menuIconProps = {
                iconName: 'ChevronDown'
            };
        }
        var splitButtonProps = {
            styles: classNames,
            checked: checked,
            disabled: disabled,
            allowDisabledFocus: allowDisabledFocus,
            onClick: this._onMenuClick,
            menuProps: undefined,
            iconProps: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, menuIconProps, { className: this._classNames.menuIcon }),
            ariaLabel: splitButtonAriaLabel,
            'aria-haspopup': true,
            'aria-expanded': this._isExpanded,
            'data-is-focusable': false
        };
        // Add data-ktp-execute-target to the split button if the keytip is defined
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](BaseButton, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, splitButtonProps, { "data-ktp-execute-target": keytipAttributes['data-ktp-execute-target'], onMouseDown: this._onMouseDown, tabIndex: -1 })));
    };
    BaseButton.prototype._onPointerDown = function (ev) {
        if (ev.pointerType === 'touch') {
            this._handleTouchAndPointerEvent();
            ev.preventDefault();
            ev.stopImmediatePropagation();
        }
    };
    BaseButton.prototype._handleTouchAndPointerEvent = function () {
        var _this = this;
        // If we already have an existing timeeout from a previous touch and pointer event
        // cancel that timeout so we can set a nwe one.
        if (this._lastTouchTimeoutId !== undefined) {
            this._async.clearTimeout(this._lastTouchTimeoutId);
            this._lastTouchTimeoutId = undefined;
        }
        this._processingTouch = true;
        this._lastTouchTimeoutId = this._async.setTimeout(function () {
            _this._processingTouch = false;
            _this._lastTouchTimeoutId = undefined;
        }, TouchIdleDelay);
    };
    /**
     * Returns if the user hits a valid keyboard key to open the menu
     * @param ev - the keyboard event
     * @returns True if user clicks on custom trigger key if enabled or alt + down arrow if not. False otherwise.
     */
    BaseButton.prototype._isValidMenuOpenKey = function (ev) {
        if (this.props.menuTriggerKeyCode) {
            return ev.which === this.props.menuTriggerKeyCode;
        }
        else if (this.props.menuProps) {
            return ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].down && (ev.altKey || ev.metaKey);
        }
        // Note: When enter is pressed, we will let the event continue to propagate
        // to trigger the onClick event on the button
        return false;
    };
    BaseButton.defaultProps = {
        baseClassName: 'ms-Button',
        styles: {},
        split: false
    };
    return BaseButton;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=BaseButton.js.map

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__positioning_index__ = __webpack_require__(1738);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__positioning_index__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__positioning_index__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__positioning_index__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__positioning_index__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__positioning_index__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__positioning_index__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__positioning_index__["g"]; });

//# sourceMappingURL=positioning.js.map

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PersonaSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PersonaPresence; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PersonaInitialsColor; });
/**
 * {@docCategory Persona}
 */
var PersonaSize;
(function (PersonaSize) {
    /**
     * tiny size has been deprecated in favor of standardized numeric sizing. Use `size10` instead.
     * @deprecated Use `size10` instead.
     */
    PersonaSize[PersonaSize["tiny"] = 0] = "tiny";
    /**
     *
     * extraExtraSmall size has been deprecated in favor of standardized numeric sizing. Use `size24` instead.
     * @deprecated Use `size24` instead.
     */
    PersonaSize[PersonaSize["extraExtraSmall"] = 1] = "extraExtraSmall";
    /**
     * extraSmall size has been deprecated in favor of standardized numeric sizing. Use `size32` instead.
     * @deprecated Use `size32` instead.
     */
    PersonaSize[PersonaSize["extraSmall"] = 2] = "extraSmall";
    /**
     * small size has been deprecated in favor of standardized numeric sizing. Use `size40` instead.
     * @deprecated Use `size40` instead.
     */
    PersonaSize[PersonaSize["small"] = 3] = "small";
    /**
     * regular size has been deprecated in favor of standardized numeric sizing. Use `size48` instead.
     * @deprecated Use `size48` instead.
     */
    PersonaSize[PersonaSize["regular"] = 4] = "regular";
    /**
     * large size has been deprecated in favor of standardized numeric sizing. Use `size72` instead.
     * @deprecated Use `size72` instead.
     */
    PersonaSize[PersonaSize["large"] = 5] = "large";
    /**
     * extraLarge size has been deprecated in favor of standardized numeric sizing. Use `size100` instead.
     * @deprecated Use `size100` instead.
     */
    PersonaSize[PersonaSize["extraLarge"] = 6] = "extraLarge";
    PersonaSize[PersonaSize["size28"] = 7] = "size28";
    PersonaSize[PersonaSize["size16"] = 8] = "size16";
    PersonaSize[PersonaSize["size10"] = 9] = "size10";
    PersonaSize[PersonaSize["size24"] = 10] = "size24";
    PersonaSize[PersonaSize["size32"] = 11] = "size32";
    PersonaSize[PersonaSize["size40"] = 12] = "size40";
    PersonaSize[PersonaSize["size48"] = 13] = "size48";
    PersonaSize[PersonaSize["size72"] = 14] = "size72";
    PersonaSize[PersonaSize["size100"] = 15] = "size100";
})(PersonaSize || (PersonaSize = {}));
/**
 * {@docCategory Persona}
 */
var PersonaPresence;
(function (PersonaPresence) {
    PersonaPresence[PersonaPresence["none"] = 0] = "none";
    PersonaPresence[PersonaPresence["offline"] = 1] = "offline";
    PersonaPresence[PersonaPresence["online"] = 2] = "online";
    PersonaPresence[PersonaPresence["away"] = 3] = "away";
    PersonaPresence[PersonaPresence["dnd"] = 4] = "dnd";
    PersonaPresence[PersonaPresence["blocked"] = 5] = "blocked";
    PersonaPresence[PersonaPresence["busy"] = 6] = "busy";
})(PersonaPresence || (PersonaPresence = {}));
/**
 * {@docCategory Persona}
 */
var PersonaInitialsColor;
(function (PersonaInitialsColor) {
    PersonaInitialsColor[PersonaInitialsColor["lightBlue"] = 0] = "lightBlue";
    PersonaInitialsColor[PersonaInitialsColor["blue"] = 1] = "blue";
    PersonaInitialsColor[PersonaInitialsColor["darkBlue"] = 2] = "darkBlue";
    PersonaInitialsColor[PersonaInitialsColor["teal"] = 3] = "teal";
    PersonaInitialsColor[PersonaInitialsColor["lightGreen"] = 4] = "lightGreen";
    PersonaInitialsColor[PersonaInitialsColor["green"] = 5] = "green";
    PersonaInitialsColor[PersonaInitialsColor["darkGreen"] = 6] = "darkGreen";
    PersonaInitialsColor[PersonaInitialsColor["lightPink"] = 7] = "lightPink";
    PersonaInitialsColor[PersonaInitialsColor["pink"] = 8] = "pink";
    PersonaInitialsColor[PersonaInitialsColor["magenta"] = 9] = "magenta";
    PersonaInitialsColor[PersonaInitialsColor["purple"] = 10] = "purple";
    /**
     * `black` is a color that can result in offensive persona coins with some initials combinations, so it can only be set with overrides.
     * @deprecated will be removed in a future major release.
     */
    PersonaInitialsColor[PersonaInitialsColor["black"] = 11] = "black";
    PersonaInitialsColor[PersonaInitialsColor["orange"] = 12] = "orange";
    /**
     * `red` is a color that often has a special meaning, so it is considered a reserved color and can only be set with overrides
     * @deprecated will be removed in a future major release.
     */
    PersonaInitialsColor[PersonaInitialsColor["red"] = 13] = "red";
    PersonaInitialsColor[PersonaInitialsColor["darkRed"] = 14] = "darkRed";
    /**
     * Transparent is not intended to be used with typical initials due to accessibility issues.
     * Its primary use is for overflow buttons, so it is considered a reserved color and can only be set with overrides.
     */
    PersonaInitialsColor[PersonaInitialsColor["transparent"] = 15] = "transparent";
    PersonaInitialsColor[PersonaInitialsColor["violet"] = 16] = "violet";
    PersonaInitialsColor[PersonaInitialsColor["lightRed"] = 17] = "lightRed";
    PersonaInitialsColor[PersonaInitialsColor["gold"] = 18] = "gold";
    PersonaInitialsColor[PersonaInitialsColor["burgundy"] = 19] = "burgundy";
    PersonaInitialsColor[PersonaInitialsColor["warmGray"] = 20] = "warmGray";
    PersonaInitialsColor[PersonaInitialsColor["coolGray"] = 21] = "coolGray";
    /**
     * `gray` is a color that can result in offensive persona coins with some initials combinations, so it can only be set with overrides
     */
    PersonaInitialsColor[PersonaInitialsColor["gray"] = 22] = "gray";
    PersonaInitialsColor[PersonaInitialsColor["cyan"] = 23] = "cyan";
    PersonaInitialsColor[PersonaInitialsColor["rust"] = 24] = "rust";
})(PersonaInitialsColor || (PersonaInitialsColor = {}));
//# sourceMappingURL=Persona.types.js.map

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return personaSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return personaPresenceSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return sizeBoolean; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return sizeToPixels; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return presenceBoolean; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Persona_types__ = __webpack_require__(152);

// Persona Sizes
var personaSize;
(function (personaSize) {
    personaSize.size10 = '20px';
    personaSize.size16 = '16px';
    personaSize.size24 = '24px';
    personaSize.size28 = '28px';
    personaSize.size32 = '32px';
    personaSize.size40 = '40px';
    personaSize.size48 = '48px';
    personaSize.size72 = '72px';
    personaSize.size100 = '100px';
})(personaSize || (personaSize = {}));
// Persona Presence Sizes
var personaPresenceSize;
(function (personaPresenceSize) {
    personaPresenceSize.size6 = '6px';
    personaPresenceSize.size8 = '8px';
    personaPresenceSize.size12 = '12px';
    personaPresenceSize.size20 = '20px';
    personaPresenceSize.size28 = '28px';
    /**
     * @deprecated This is now unused
     */
    personaPresenceSize.border = '2px';
})(personaPresenceSize || (personaPresenceSize = {}));
var sizeBoolean = function (size) { return ({
    isSize10: size === __WEBPACK_IMPORTED_MODULE_0__Persona_types__["c" /* PersonaSize */].size10 || size === __WEBPACK_IMPORTED_MODULE_0__Persona_types__["c" /* PersonaSize */].tiny,
    isSize16: size === __WEBPACK_IMPORTED_MODULE_0__Persona_types__["c" /* PersonaSize */].size16,
    isSize24: size === __WEBPACK_IMPORTED_MODULE_0__Persona_types__["c" /* PersonaSize */].size24 || size === __WEBPACK_IMPORTED_MODULE_0__Persona_types__["c" /* PersonaSize */].extraExtraSmall,
    isSize28: size === __WEBPACK_IMPORTED_MODULE_0__Persona_types__["c" /* PersonaSize */].size28 || size === __WEBPACK_IMPORTED_MODULE_0__Persona_types__["c" /* PersonaSize */].extraSmall,
    isSize32: size === __WEBPACK_IMPORTED_MODULE_0__Persona_types__["c" /* PersonaSize */].size32,
    isSize40: size === __WEBPACK_IMPORTED_MODULE_0__Persona_types__["c" /* PersonaSize */].size40 || size === __WEBPACK_IMPORTED_MODULE_0__Persona_types__["c" /* PersonaSize */].small,
    isSize48: size === __WEBPACK_IMPORTED_MODULE_0__Persona_types__["c" /* PersonaSize */].size48 || size === __WEBPACK_IMPORTED_MODULE_0__Persona_types__["c" /* PersonaSize */].regular,
    isSize72: size === __WEBPACK_IMPORTED_MODULE_0__Persona_types__["c" /* PersonaSize */].size72 || size === __WEBPACK_IMPORTED_MODULE_0__Persona_types__["c" /* PersonaSize */].large,
    isSize100: size === __WEBPACK_IMPORTED_MODULE_0__Persona_types__["c" /* PersonaSize */].size100 || size === __WEBPACK_IMPORTED_MODULE_0__Persona_types__["c" /* PersonaSize */].extraLarge
}); };
var sizeToPixels = (_a = {},
    _a[__WEBPACK_IMPORTED_MODULE_0__Persona_types__["c" /* PersonaSize */].tiny] = 10,
    _a[__WEBPACK_IMPORTED_MODULE_0__Persona_types__["c" /* PersonaSize */].extraExtraSmall] = 24,
    _a[__WEBPACK_IMPORTED_MODULE_0__Persona_types__["c" /* PersonaSize */].extraSmall] = 28,
    _a[__WEBPACK_IMPORTED_MODULE_0__Persona_types__["c" /* PersonaSize */].small] = 40,
    _a[__WEBPACK_IMPORTED_MODULE_0__Persona_types__["c" /* PersonaSize */].regular] = 48,
    _a[__WEBPACK_IMPORTED_MODULE_0__Persona_types__["c" /* PersonaSize */].large] = 72,
    _a[__WEBPACK_IMPORTED_MODULE_0__Persona_types__["c" /* PersonaSize */].extraLarge] = 100,
    _a[__WEBPACK_IMPORTED_MODULE_0__Persona_types__["c" /* PersonaSize */].size10] = 10,
    _a[__WEBPACK_IMPORTED_MODULE_0__Persona_types__["c" /* PersonaSize */].size16] = 16,
    _a[__WEBPACK_IMPORTED_MODULE_0__Persona_types__["c" /* PersonaSize */].size24] = 24,
    _a[__WEBPACK_IMPORTED_MODULE_0__Persona_types__["c" /* PersonaSize */].size28] = 28,
    _a[__WEBPACK_IMPORTED_MODULE_0__Persona_types__["c" /* PersonaSize */].size32] = 32,
    _a[__WEBPACK_IMPORTED_MODULE_0__Persona_types__["c" /* PersonaSize */].size40] = 40,
    _a[__WEBPACK_IMPORTED_MODULE_0__Persona_types__["c" /* PersonaSize */].size48] = 48,
    _a[__WEBPACK_IMPORTED_MODULE_0__Persona_types__["c" /* PersonaSize */].size72] = 72,
    _a[__WEBPACK_IMPORTED_MODULE_0__Persona_types__["c" /* PersonaSize */].size100] = 100,
    _a);
var presenceBoolean = function (presence) { return ({
    isAvailable: presence === __WEBPACK_IMPORTED_MODULE_0__Persona_types__["b" /* PersonaPresence */].online,
    isAway: presence === __WEBPACK_IMPORTED_MODULE_0__Persona_types__["b" /* PersonaPresence */].away,
    isBlocked: presence === __WEBPACK_IMPORTED_MODULE_0__Persona_types__["b" /* PersonaPresence */].blocked,
    isBusy: presence === __WEBPACK_IMPORTED_MODULE_0__Persona_types__["b" /* PersonaPresence */].busy,
    isDoNotDisturb: presence === __WEBPACK_IMPORTED_MODULE_0__Persona_types__["b" /* PersonaPresence */].dnd,
    isOffline: presence === __WEBPACK_IMPORTED_MODULE_0__Persona_types__["b" /* PersonaPresence */].offline
}); };
var _a;
//# sourceMappingURL=PersonaConsts.js.map

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = rgb2hex;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clamp__ = __webpack_require__(155);


/** Converts RGB components to a hex color string (without # prefix). */
function rgb2hex(r, g, b) {
    return [_rgbToPaddedHex(r), _rgbToPaddedHex(g), _rgbToPaddedHex(b)].join('');
}
/** Converts an RGB component to a 0-padded hex component of length 2. */
function _rgbToPaddedHex(num) {
    num = Object(__WEBPACK_IMPORTED_MODULE_1__clamp__["a" /* clamp */])(num, __WEBPACK_IMPORTED_MODULE_0__consts__["d" /* MAX_COLOR_RGB */]);
    var hex = num.toString(16);
    return hex.length === 1 ? '0' + hex : hex;
}
//# sourceMappingURL=rgb2hex.js.map

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = clamp;
/** Clamp a value to ensure it falls within a given range. */
function clamp(value, max, min) {
    if (min === void 0) { min = 0; }
    return value < min ? min : value > max ? max : value;
}
//# sourceMappingURL=clamp.js.map

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getColorFromRGBA;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rgb2hsv__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rgb2hex__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rgbaOrHexString__ = __webpack_require__(187);




/** Converts an RGBA color to a color object (alpha defaults to 100). */
function getColorFromRGBA(rgba) {
    var _a = rgba.a, a = _a === void 0 ? __WEBPACK_IMPORTED_MODULE_0__consts__["b" /* MAX_COLOR_ALPHA */] : _a, b = rgba.b, g = rgba.g, r = rgba.r;
    var _b = Object(__WEBPACK_IMPORTED_MODULE_1__rgb2hsv__["a" /* rgb2hsv */])(r, g, b), h = _b.h, s = _b.s, v = _b.v;
    var hex = Object(__WEBPACK_IMPORTED_MODULE_2__rgb2hex__["a" /* rgb2hex */])(r, g, b);
    var str = Object(__WEBPACK_IMPORTED_MODULE_3__rgbaOrHexString__["a" /* _rgbaOrHexString */])(r, g, b, a, hex);
    return { a: a, b: b, g: g, h: h, hex: hex, r: r, s: s, str: str, v: v };
}
//# sourceMappingURL=getColorFromRGBA.js.map

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(627);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["default"])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["default"])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["default"])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["default"])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 158 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),
/* 159 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _extends.apply(this, arguments);
}

module.exports = _extends;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

/* harmony default export */ __webpack_exports__["a"] = (function () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x
			}
		}
	}
	return str;
});


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bpfrpt_proptype_Index */
/* unused harmony export bpfrpt_proptype_PositionInfo */
/* unused harmony export bpfrpt_proptype_ScrollPosition */
/* unused harmony export bpfrpt_proptype_SizeAndPositionInfo */
/* unused harmony export bpfrpt_proptype_SizeInfo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var bpfrpt_proptype_Index =  true ? null : {
  "index": PropTypes.number.isRequired
};
var bpfrpt_proptype_PositionInfo =  true ? null : {
  "x": PropTypes.number.isRequired,
  "y": PropTypes.number.isRequired
};
var bpfrpt_proptype_ScrollPosition =  true ? null : {
  "scrollLeft": PropTypes.number.isRequired,
  "scrollTop": PropTypes.number.isRequired
};
var bpfrpt_proptype_SizeAndPositionInfo =  true ? null : {
  "height": PropTypes.number.isRequired,
  "width": PropTypes.number.isRequired,
  "x": PropTypes.number.isRequired,
  "y": PropTypes.number.isRequired
};
var bpfrpt_proptype_SizeInfo =  true ? null : {
  "height": PropTypes.number.isRequired,
  "width": PropTypes.number.isRequired
};







/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cadastreFields", function() { return cadastreFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cadastreProps", function() { return cadastreProps; });
var cadastreFields=function cadastreFields(){return[{name:'registry_number',required:true,type:'string',size:'ms-sm12'},{name:'city',required:true,type:'string',size:'ms-sm6'},{name:'volume',required:true,type:'string',size:'ms-sm6'},{name:'book',required:true,type:'string',size:'ms-sm6'},{name:'folio',required:true,type:'string',size:'ms-sm6'},{name:'property_number',required:true,type:'string',size:'ms-sm12'}];};var cadastreProps=function cadastreProps(){var result={};cadastreFields(null).forEach(function(field){result[field.name]=field.type==='string'?'':0;});return result;};

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cadastreLandFields__ = __webpack_require__(445);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "cadastreLandFields", function() { return __WEBPACK_IMPORTED_MODULE_0__cadastreLandFields__["cadastreLandFields"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "cadastreLandProps", function() { return __WEBPACK_IMPORTED_MODULE_0__cadastreLandFields__["cadastreLandProps"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cadastreUrbanFields__ = __webpack_require__(446);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "cadastreUrbanFields", function() { return __WEBPACK_IMPORTED_MODULE_1__cadastreUrbanFields__["cadastreUrbanFields"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "cadastreUrbanProps", function() { return __WEBPACK_IMPORTED_MODULE_1__cadastreUrbanFields__["cadastreUrbanProps"]; });


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(70);
var global = __webpack_require__(14);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(113) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(72);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 166 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(13);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(13);
var aFunction = __webpack_require__(48);
var SPECIES = __webpack_require__(20)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setEnableEnvMocks */
/* harmony export (immutable) */ __webpack_exports__["e"] = getGlobalInst;
/* harmony export (immutable) */ __webpack_exports__["o"] = hasWindow;
/* harmony export (immutable) */ __webpack_exports__["l"] = getWindow;
/* harmony export (immutable) */ __webpack_exports__["m"] = hasDocument;
/* harmony export (immutable) */ __webpack_exports__["d"] = getDocument;
/* unused harmony export hasNavigator */
/* harmony export (immutable) */ __webpack_exports__["j"] = getNavigator;
/* unused harmony export hasHistory */
/* unused harmony export getHistory */
/* harmony export (immutable) */ __webpack_exports__["h"] = getLocation;
/* harmony export (immutable) */ __webpack_exports__["b"] = getConsole;
/* harmony export (immutable) */ __webpack_exports__["k"] = getPerformance;
/* harmony export (immutable) */ __webpack_exports__["n"] = hasJSON;
/* harmony export (immutable) */ __webpack_exports__["g"] = getJSON;
/* harmony export (immutable) */ __webpack_exports__["c"] = getCrypto;
/* harmony export (immutable) */ __webpack_exports__["i"] = getMsCrypto;
/* harmony export (immutable) */ __webpack_exports__["q"] = isReactNative;
/* harmony export (immutable) */ __webpack_exports__["p"] = isIE;
/* harmony export (immutable) */ __webpack_exports__["f"] = getIEVersion;
/* harmony export (immutable) */ __webpack_exports__["a"] = dumpObj;
/* unused harmony export isSafari */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HelperFuncs__ = __webpack_require__(40);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





/**
 * This file exists to hold environment utilities that are required to check and
 * validate the current operating environment. Unless otherwise required, please
 * only defined methods (functions) in this class so that users of these
 * functions/properties only need to include those that are used within their own modules.
 */
var strWindow = "window";
var strDocument = "document";
var strNavigator = "navigator";
var strHistory = "history";
var strLocation = "location";
var strConsole = "console";
var strPerformance = "performance";
var strJSON = "JSON";
var strCrypto = "crypto";
var strMsCrypto = "msCrypto";
var strReactNative = "ReactNative";
var strMsie = "msie";
var strTrident = "trident/";
var _isTrident = null;
var _navUserAgentCheck = null;
var _enableMocks = false;
/**
 * Enable the lookup of test mock objects if requested
 * @param enabled
 */
function setEnableEnvMocks(enabled) {
    _enableMocks = enabled;
}
/**
 * Return the named global object if available, will return null if the object is not available.
 * @param name The globally named object
 */
function getGlobalInst(name) {
    var gbl = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["h" /* getGlobal */])();
    if (gbl && gbl[name]) {
        return gbl[name];
    }
    // Test workaround, for environments where <global>.window (when global == window) doesn't return the base window
    if (name === strWindow && hasWindow()) {
        // tslint:disable-next-line: no-angle-bracket-type-assertion
        return window;
    }
    return null;
}
/**
 * Checks if window object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a window
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: window is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasWindow() {
    return Boolean(typeof window === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] && window);
}
/**
 * Returns the global window object if it is present otherwise null.
 * This helper is used to access the window object without causing an exception
 * "Uncaught ReferenceError: window is not defined"
 */
function getWindow() {
    if (hasWindow()) {
        return window;
    }
    // Return the global instance or null
    return getGlobalInst(strWindow);
}
/**
 * Checks if document object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a document
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: document is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasDocument() {
    return Boolean(typeof document === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] && document);
}
/**
 * Returns the global document object if it is present otherwise null.
 * This helper is used to access the document object without causing an exception
 * "Uncaught ReferenceError: document is not defined"
 */
function getDocument() {
    if (hasDocument()) {
        return document;
    }
    return getGlobalInst(strDocument);
}
/**
 * Checks if navigator object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a navigator
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: navigator is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasNavigator() {
    return Boolean(typeof navigator === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] && navigator);
}
/**
 * Returns the global navigator object if it is present otherwise null.
 * This helper is used to access the navigator object without causing an exception
 * "Uncaught ReferenceError: navigator is not defined"
 */
function getNavigator() {
    if (hasNavigator()) {
        return navigator;
    }
    return getGlobalInst(strNavigator);
}
/**
 * Checks if history object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a history
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: history is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasHistory() {
    return Boolean(typeof history === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] && history);
}
/**
 * Returns the global history object if it is present otherwise null.
 * This helper is used to access the history object without causing an exception
 * "Uncaught ReferenceError: history is not defined"
 */
function getHistory() {
    if (hasHistory()) {
        return history;
    }
    return getGlobalInst(strHistory);
}
/**
 * Returns the global location object if it is present otherwise null.
 * This helper is used to access the location object without causing an exception
 * "Uncaught ReferenceError: location is not defined"
 */
function getLocation(checkForMock) {
    if (checkForMock && _enableMocks) {
        var mockLocation = getGlobalInst("__mockLocation");
        if (mockLocation) {
            return mockLocation;
        }
    }
    if (typeof location === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] && location) {
        return location;
    }
    return getGlobalInst(strLocation);
}
/**
 * Returns the global console object
 */
function getConsole() {
    if (typeof console !== __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["m" /* strShimUndefined */]) {
        return console;
    }
    return getGlobalInst(strConsole);
}
/**
 * Returns the performance object if it is present otherwise null.
 * This helper is used to access the performance object from the current
 * global instance which could be window or globalThis for a web worker
 */
function getPerformance() {
    return getGlobalInst(strPerformance);
}
/**
 * Checks if JSON object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a history
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: JSON is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasJSON() {
    return Boolean((typeof JSON === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] && JSON) || getGlobalInst(strJSON) !== null);
}
/**
 * Returns the global JSON object if it is present otherwise null.
 * This helper is used to access the JSON object without causing an exception
 * "Uncaught ReferenceError: JSON is not defined"
 */
function getJSON() {
    if (hasJSON()) {
        return JSON || getGlobalInst(strJSON);
    }
    return null;
}
/**
 * Returns the crypto object if it is present otherwise null.
 * This helper is used to access the crypto object from the current
 * global instance which could be window or globalThis for a web worker
 */
function getCrypto() {
    return getGlobalInst(strCrypto);
}
/**
 * Returns the crypto object if it is present otherwise null.
 * This helper is used to access the crypto object from the current
 * global instance which could be window or globalThis for a web worker
 */
function getMsCrypto() {
    return getGlobalInst(strMsCrypto);
}
/**
 * Returns whether the environment is reporting that we are running in a React Native Environment
 */
function isReactNative() {
    // If running in React Native, navigator.product will be populated
    var nav = getNavigator();
    if (nav && nav.product) {
        return nav.product === strReactNative;
    }
    return false;
}
/**
 * Identifies whether the current environment appears to be IE
 */
function isIE() {
    var nav = getNavigator();
    if (nav && (nav.userAgent !== _navUserAgentCheck || _isTrident === null)) {
        // Added to support test mocking of the user agent
        _navUserAgentCheck = nav.userAgent;
        var userAgent = (_navUserAgentCheck || "").toLowerCase();
        _isTrident = (Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["E" /* strContains */])(userAgent, strMsie) || Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["E" /* strContains */])(userAgent, strTrident));
    }
    return _isTrident;
}
/**
 * Gets IE version returning the document emulation mode if we are running on IE, or null otherwise
 */
function getIEVersion(userAgentStr) {
    if (userAgentStr === void 0) { userAgentStr = null; }
    if (!userAgentStr) {
        var navigator_1 = getNavigator() || {};
        userAgentStr = navigator_1 ? (navigator_1.userAgent || "").toLowerCase() : "";
    }
    var ua = (userAgentStr || "").toLowerCase();
    if (Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["E" /* strContains */])(ua, strMsie)) {
        return parseInt(ua.split(strMsie)[1]);
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["E" /* strContains */])(ua, strTrident)) {
        var tridentVer = parseInt(ua.split(strTrident)[1]);
        if (tridentVer) {
            return tridentVer + 4;
        }
    }
    return null;
}
/**
 * Returns string representation of an object suitable for diagnostics logging.
 */
function dumpObj(object) {
    var objectTypeDump = Object[__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["l" /* strShimPrototype */]].toString.call(object);
    var propertyValueDump = "";
    if (objectTypeDump === "[object Error]") {
        propertyValueDump = "{ stack: '" + object.stack + "', message: '" + object.message + "', name: '" + object.name + "'";
    }
    else if (hasJSON()) {
        propertyValueDump = getJSON().stringify(object);
    }
    return objectTypeDump + propertyValueDump;
}
function isSafari(userAgentStr) {
    if (!userAgentStr || !Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["v" /* isString */])(userAgentStr)) {
        var navigator_2 = getNavigator() || {};
        userAgentStr = navigator_2 ? (navigator_2.userAgent || "").toLowerCase() : "";
    }
    var ua = (userAgentStr || "").toLowerCase();
    return (ua.indexOf('safari') >= 0);
}
//# sourceMappingURL=EnvUtils.js.map

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setEnableEnvMocks */
/* harmony export (immutable) */ __webpack_exports__["e"] = getGlobalInst;
/* unused harmony export hasWindow */
/* harmony export (immutable) */ __webpack_exports__["m"] = getWindow;
/* unused harmony export hasDocument */
/* harmony export (immutable) */ __webpack_exports__["d"] = getDocument;
/* unused harmony export hasNavigator */
/* harmony export (immutable) */ __webpack_exports__["k"] = getNavigator;
/* unused harmony export hasHistory */
/* harmony export (immutable) */ __webpack_exports__["f"] = getHistory;
/* harmony export (immutable) */ __webpack_exports__["i"] = getLocation;
/* harmony export (immutable) */ __webpack_exports__["b"] = getConsole;
/* harmony export (immutable) */ __webpack_exports__["l"] = getPerformance;
/* harmony export (immutable) */ __webpack_exports__["n"] = hasJSON;
/* harmony export (immutable) */ __webpack_exports__["h"] = getJSON;
/* harmony export (immutable) */ __webpack_exports__["c"] = getCrypto;
/* harmony export (immutable) */ __webpack_exports__["j"] = getMsCrypto;
/* unused harmony export isReactNative */
/* harmony export (immutable) */ __webpack_exports__["o"] = isIE;
/* harmony export (immutable) */ __webpack_exports__["g"] = getIEVersion;
/* harmony export (immutable) */ __webpack_exports__["a"] = dumpObj;
/* unused harmony export isSafari */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HelperFuncs__ = __webpack_require__(42);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





/**
 * This file exists to hold environment utilities that are required to check and
 * validate the current operating environment. Unless otherwise required, please
 * only defined methods (functions) in this class so that users of these
 * functions/properties only need to include those that are used within their own modules.
 */
var strWindow = "window";
var strDocument = "document";
var strNavigator = "navigator";
var strHistory = "history";
var strLocation = "location";
var strConsole = "console";
var strPerformance = "performance";
var strJSON = "JSON";
var strCrypto = "crypto";
var strMsCrypto = "msCrypto";
var strReactNative = "ReactNative";
var strMsie = "msie";
var strTrident = "trident/";
var _isTrident = null;
var _navUserAgentCheck = null;
var _enableMocks = false;
/**
 * Enable the lookup of test mock objects if requested
 * @param enabled
 */
function setEnableEnvMocks(enabled) {
    _enableMocks = enabled;
}
/**
 * Return the named global object if available, will return null if the object is not available.
 * @param name The globally named object
 */
function getGlobalInst(name) {
    var gbl = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["h" /* getGlobal */])();
    if (gbl && gbl[name]) {
        return gbl[name];
    }
    // Test workaround, for environments where <global>.window (when global == window) doesn't return the base window
    if (name === strWindow && hasWindow()) {
        // tslint:disable-next-line: no-angle-bracket-type-assertion
        return window;
    }
    return null;
}
/**
 * Checks if window object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a window
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: window is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasWindow() {
    return Boolean(typeof window === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] && window);
}
/**
 * Returns the global window object if it is present otherwise null.
 * This helper is used to access the window object without causing an exception
 * "Uncaught ReferenceError: window is not defined"
 */
function getWindow() {
    if (hasWindow()) {
        return window;
    }
    // Return the global instance or null
    return getGlobalInst(strWindow);
}
/**
 * Checks if document object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a document
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: document is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasDocument() {
    return Boolean(typeof document === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] && document);
}
/**
 * Returns the global document object if it is present otherwise null.
 * This helper is used to access the document object without causing an exception
 * "Uncaught ReferenceError: document is not defined"
 */
function getDocument() {
    if (hasDocument()) {
        return document;
    }
    return getGlobalInst(strDocument);
}
/**
 * Checks if navigator object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a navigator
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: navigator is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasNavigator() {
    return Boolean(typeof navigator === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] && navigator);
}
/**
 * Returns the global navigator object if it is present otherwise null.
 * This helper is used to access the navigator object without causing an exception
 * "Uncaught ReferenceError: navigator is not defined"
 */
function getNavigator() {
    if (hasNavigator()) {
        return navigator;
    }
    return getGlobalInst(strNavigator);
}
/**
 * Checks if history object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a history
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: history is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasHistory() {
    return Boolean(typeof history === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] && history);
}
/**
 * Returns the global history object if it is present otherwise null.
 * This helper is used to access the history object without causing an exception
 * "Uncaught ReferenceError: history is not defined"
 */
function getHistory() {
    if (hasHistory()) {
        return history;
    }
    return getGlobalInst(strHistory);
}
/**
 * Returns the global location object if it is present otherwise null.
 * This helper is used to access the location object without causing an exception
 * "Uncaught ReferenceError: location is not defined"
 */
function getLocation(checkForMock) {
    if (checkForMock && _enableMocks) {
        var mockLocation = getGlobalInst("__mockLocation");
        if (mockLocation) {
            return mockLocation;
        }
    }
    if (typeof location === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] && location) {
        return location;
    }
    return getGlobalInst(strLocation);
}
/**
 * Returns the global console object
 */
function getConsole() {
    if (typeof console !== __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["m" /* strShimUndefined */]) {
        return console;
    }
    return getGlobalInst(strConsole);
}
/**
 * Returns the performance object if it is present otherwise null.
 * This helper is used to access the performance object from the current
 * global instance which could be window or globalThis for a web worker
 */
function getPerformance() {
    return getGlobalInst(strPerformance);
}
/**
 * Checks if JSON object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a history
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: JSON is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasJSON() {
    return Boolean((typeof JSON === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] && JSON) || getGlobalInst(strJSON) !== null);
}
/**
 * Returns the global JSON object if it is present otherwise null.
 * This helper is used to access the JSON object without causing an exception
 * "Uncaught ReferenceError: JSON is not defined"
 */
function getJSON() {
    if (hasJSON()) {
        return JSON || getGlobalInst(strJSON);
    }
    return null;
}
/**
 * Returns the crypto object if it is present otherwise null.
 * This helper is used to access the crypto object from the current
 * global instance which could be window or globalThis for a web worker
 */
function getCrypto() {
    return getGlobalInst(strCrypto);
}
/**
 * Returns the crypto object if it is present otherwise null.
 * This helper is used to access the crypto object from the current
 * global instance which could be window or globalThis for a web worker
 */
function getMsCrypto() {
    return getGlobalInst(strMsCrypto);
}
/**
 * Returns whether the environment is reporting that we are running in a React Native Environment
 */
function isReactNative() {
    // If running in React Native, navigator.product will be populated
    var nav = getNavigator();
    if (nav && nav.product) {
        return nav.product === strReactNative;
    }
    return false;
}
/**
 * Identifies whether the current environment appears to be IE
 */
function isIE() {
    var nav = getNavigator();
    if (nav && (nav.userAgent !== _navUserAgentCheck || _isTrident === null)) {
        // Added to support test mocking of the user agent
        _navUserAgentCheck = nav.userAgent;
        var userAgent = (_navUserAgentCheck || "").toLowerCase();
        _isTrident = (Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["D" /* strContains */])(userAgent, strMsie) || Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["D" /* strContains */])(userAgent, strTrident));
    }
    return _isTrident;
}
/**
 * Gets IE version returning the document emulation mode if we are running on IE, or null otherwise
 */
function getIEVersion(userAgentStr) {
    if (userAgentStr === void 0) { userAgentStr = null; }
    if (!userAgentStr) {
        var navigator_1 = getNavigator() || {};
        userAgentStr = navigator_1 ? (navigator_1.userAgent || "").toLowerCase() : "";
    }
    var ua = (userAgentStr || "").toLowerCase();
    if (Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["D" /* strContains */])(ua, strMsie)) {
        return parseInt(ua.split(strMsie)[1]);
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["D" /* strContains */])(ua, strTrident)) {
        var tridentVer = parseInt(ua.split(strTrident)[1]);
        if (tridentVer) {
            return tridentVer + 4;
        }
    }
    return null;
}
/**
 * Returns string representation of an object suitable for diagnostics logging.
 */
function dumpObj(object) {
    var objectTypeDump = Object[__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["l" /* strShimPrototype */]].toString.call(object);
    var propertyValueDump = "";
    if (objectTypeDump === "[object Error]") {
        propertyValueDump = "{ stack: '" + object.stack + "', message: '" + object.message + "', name: '" + object.name + "'";
    }
    else if (hasJSON()) {
        propertyValueDump = getJSON().stringify(object);
    }
    return objectTypeDump + propertyValueDump;
}
function isSafari(userAgentStr) {
    if (!userAgentStr || !Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["v" /* isString */])(userAgentStr)) {
        var navigator_2 = getNavigator() || {};
        userAgentStr = navigator_2 ? (navigator_2.userAgent || "").toLowerCase() : "";
    }
    var ua = (userAgentStr || "").toLowerCase();
    return (ua.indexOf('safari') >= 0);
}
//# sourceMappingURL=EnvUtils.js.map

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PropertiesPluginIdentifier */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BreezeChannelIdentifier; });
/* unused harmony export AnalyticsPluginIdentifier */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Util__ = __webpack_require__(562);
/* unused harmony reexport Util */
/* unused harmony reexport CorrelationIdHelper */
/* unused harmony reexport DateTimeUtils */
/* unused harmony reexport dateTimeUtilsNow */
/* unused harmony reexport dateTimeUtilsDuration */
/* unused harmony reexport UrlHelper */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_0__Util__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConnectionStringParser__ = __webpack_require__(1428);
/* unused harmony reexport parseConnectionString */
/* unused harmony reexport ConnectionStringParser */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RequestResponseHeaders__ = __webpack_require__(568);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_2__RequestResponseHeaders__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Constants__ = __webpack_require__(79);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__Constants__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_3__Constants__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_3__Constants__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_3__Constants__["c"]; });
/* unused harmony reexport DEFAULT_BREEZE_ENDPOINT */
/* unused harmony reexport strNotSpecified */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Interfaces_Contracts_Generated_Data__ = __webpack_require__(573);
/* unused harmony reexport AIData */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Interfaces_Contracts_Generated_Base__ = __webpack_require__(574);
/* unused harmony reexport AIBase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Telemetry_Common_Envelope__ = __webpack_require__(1429);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_6__Telemetry_Common_Envelope__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Telemetry_Event__ = __webpack_require__(1431);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_7__Telemetry_Event__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Telemetry_Exception__ = __webpack_require__(1432);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_8__Telemetry_Exception__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Telemetry_Metric__ = __webpack_require__(1436);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_9__Telemetry_Metric__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Telemetry_PageView__ = __webpack_require__(1441);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_10__Telemetry_PageView__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Interfaces_Contracts_Generated_PageViewData__ = __webpack_require__(369);
/* unused harmony reexport PageViewData */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Telemetry_RemoteDependencyData__ = __webpack_require__(1442);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_12__Telemetry_RemoteDependencyData__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Telemetry_Trace__ = __webpack_require__(1444);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_13__Telemetry_Trace__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Telemetry_PageViewPerformance__ = __webpack_require__(1446);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_14__Telemetry_PageViewPerformance__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Telemetry_Common_Data__ = __webpack_require__(1448);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_15__Telemetry_Common_Data__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Interfaces_Contracts_Generated_SeverityLevel__ = __webpack_require__(1449);
/* unused harmony reexport SeverityLevel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Interfaces_IConfig__ = __webpack_require__(1450);
/* unused harmony reexport ConfigurationManager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Interfaces_Contracts_Generated_ContextTagKeys__ = __webpack_require__(576);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_18__Interfaces_Contracts_Generated_ContextTagKeys__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Telemetry_Common_DataSanitizer__ = __webpack_require__(78);
/* unused harmony reexport DataSanitizer */
/* unused harmony reexport dataSanitizeKeyAndAddUniqueness */
/* unused harmony reexport dataSanitizeKey */
/* unused harmony reexport dataSanitizeString */
/* unused harmony reexport dataSanitizeUrl */
/* unused harmony reexport dataSanitizeMessage */
/* unused harmony reexport dataSanitizeException */
/* unused harmony reexport dataSanitizeProperties */
/* unused harmony reexport dataSanitizeMeasurements */
/* unused harmony reexport dataSanitizeId */
/* unused harmony reexport dataSanitizeInput */
/* unused harmony reexport dsPadNumber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__TelemetryItemCreator__ = __webpack_require__(1451);
/* unused harmony reexport TelemetryItemCreator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Interfaces_PartAExtensions__ = __webpack_require__(1452);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_21__Interfaces_PartAExtensions__["a"]; });
/* unused harmony reexport Extensions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Enums__ = __webpack_require__(571);
/* unused harmony reexport DistributedTracingModes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__HelperFuncs__ = __webpack_require__(246);
/* unused harmony reexport stringToBoolOrDefault */
/* unused harmony reexport msToTimeSpan */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_23__HelperFuncs__["b"]; });
/* unused harmony reexport getExtensionByName */
/* unused harmony reexport isCrossOriginError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__DomHelperFuncs__ = __webpack_require__(569);
/* unused harmony reexport createDomEvent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__StorageHelperFuncs__ = __webpack_require__(570);
/* unused harmony reexport utlDisableStorage */
/* unused harmony reexport utlCanUseLocalStorage */
/* unused harmony reexport utlGetLocalStorage */
/* unused harmony reexport utlSetLocalStorage */
/* unused harmony reexport utlRemoveStorage */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_25__StorageHelperFuncs__["b"]; });
/* unused harmony reexport utlGetSessionStorageKeys */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_25__StorageHelperFuncs__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_25__StorageHelperFuncs__["j"]; });
/* unused harmony reexport utlRemoveSessionStorage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__UrlHelperFuncs__ = __webpack_require__(572);
/* unused harmony reexport urlParseUrl */
/* unused harmony reexport urlGetAbsoluteUrl */
/* unused harmony reexport urlGetPathName */
/* unused harmony reexport urlGetCompleteUrl */
/* unused harmony reexport urlParseHost */
/* unused harmony reexport urlParseFullHost */
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





























var PropertiesPluginIdentifier = "AppInsightsPropertiesPlugin";
var BreezeChannelIdentifier = "AppInsightsChannelPlugin";
var AnalyticsPluginIdentifier = "ApplicationInsightsAnalytics";
//# sourceMappingURL=applicationinsights-common.js.map

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setEnableEnvMocks */
/* harmony export (immutable) */ __webpack_exports__["e"] = getGlobalInst;
/* unused harmony export hasWindow */
/* harmony export (immutable) */ __webpack_exports__["l"] = getWindow;
/* unused harmony export hasDocument */
/* harmony export (immutable) */ __webpack_exports__["d"] = getDocument;
/* unused harmony export hasNavigator */
/* harmony export (immutable) */ __webpack_exports__["j"] = getNavigator;
/* unused harmony export hasHistory */
/* unused harmony export getHistory */
/* harmony export (immutable) */ __webpack_exports__["h"] = getLocation;
/* harmony export (immutable) */ __webpack_exports__["b"] = getConsole;
/* harmony export (immutable) */ __webpack_exports__["k"] = getPerformance;
/* harmony export (immutable) */ __webpack_exports__["m"] = hasJSON;
/* harmony export (immutable) */ __webpack_exports__["g"] = getJSON;
/* harmony export (immutable) */ __webpack_exports__["c"] = getCrypto;
/* harmony export (immutable) */ __webpack_exports__["i"] = getMsCrypto;
/* unused harmony export isReactNative */
/* harmony export (immutable) */ __webpack_exports__["n"] = isIE;
/* harmony export (immutable) */ __webpack_exports__["f"] = getIEVersion;
/* harmony export (immutable) */ __webpack_exports__["a"] = dumpObj;
/* unused harmony export isSafari */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HelperFuncs__ = __webpack_require__(43);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





/**
 * This file exists to hold environment utilities that are required to check and
 * validate the current operating environment. Unless otherwise required, please
 * only defined methods (functions) in this class so that users of these
 * functions/properties only need to include those that are used within their own modules.
 */
var strWindow = "window";
var strDocument = "document";
var strNavigator = "navigator";
var strHistory = "history";
var strLocation = "location";
var strConsole = "console";
var strPerformance = "performance";
var strJSON = "JSON";
var strCrypto = "crypto";
var strMsCrypto = "msCrypto";
var strReactNative = "ReactNative";
var strMsie = "msie";
var strTrident = "trident/";
var _isTrident = null;
var _navUserAgentCheck = null;
var _enableMocks = false;
/**
 * Enable the lookup of test mock objects if requested
 * @param enabled
 */
function setEnableEnvMocks(enabled) {
    _enableMocks = enabled;
}
/**
 * Return the named global object if available, will return null if the object is not available.
 * @param name The globally named object
 */
function getGlobalInst(name) {
    var gbl = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["h" /* getGlobal */])();
    if (gbl && gbl[name]) {
        return gbl[name];
    }
    // Test workaround, for environments where <global>.window (when global == window) doesn't return the base window
    if (name === strWindow && hasWindow()) {
        // tslint:disable-next-line: no-angle-bracket-type-assertion
        return window;
    }
    return null;
}
/**
 * Checks if window object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a window
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: window is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasWindow() {
    return Boolean(typeof window === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] && window);
}
/**
 * Returns the global window object if it is present otherwise null.
 * This helper is used to access the window object without causing an exception
 * "Uncaught ReferenceError: window is not defined"
 */
function getWindow() {
    if (hasWindow()) {
        return window;
    }
    // Return the global instance or null
    return getGlobalInst(strWindow);
}
/**
 * Checks if document object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a document
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: document is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasDocument() {
    return Boolean(typeof document === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] && document);
}
/**
 * Returns the global document object if it is present otherwise null.
 * This helper is used to access the document object without causing an exception
 * "Uncaught ReferenceError: document is not defined"
 */
function getDocument() {
    if (hasDocument()) {
        return document;
    }
    return getGlobalInst(strDocument);
}
/**
 * Checks if navigator object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a navigator
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: navigator is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasNavigator() {
    return Boolean(typeof navigator === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] && navigator);
}
/**
 * Returns the global navigator object if it is present otherwise null.
 * This helper is used to access the navigator object without causing an exception
 * "Uncaught ReferenceError: navigator is not defined"
 */
function getNavigator() {
    if (hasNavigator()) {
        return navigator;
    }
    return getGlobalInst(strNavigator);
}
/**
 * Checks if history object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a history
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: history is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasHistory() {
    return Boolean(typeof history === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] && history);
}
/**
 * Returns the global history object if it is present otherwise null.
 * This helper is used to access the history object without causing an exception
 * "Uncaught ReferenceError: history is not defined"
 */
function getHistory() {
    if (hasHistory()) {
        return history;
    }
    return getGlobalInst(strHistory);
}
/**
 * Returns the global location object if it is present otherwise null.
 * This helper is used to access the location object without causing an exception
 * "Uncaught ReferenceError: location is not defined"
 */
function getLocation(checkForMock) {
    if (checkForMock && _enableMocks) {
        var mockLocation = getGlobalInst("__mockLocation");
        if (mockLocation) {
            return mockLocation;
        }
    }
    if (typeof location === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] && location) {
        return location;
    }
    return getGlobalInst(strLocation);
}
/**
 * Returns the global console object
 */
function getConsole() {
    if (typeof console !== __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["m" /* strShimUndefined */]) {
        return console;
    }
    return getGlobalInst(strConsole);
}
/**
 * Returns the performance object if it is present otherwise null.
 * This helper is used to access the performance object from the current
 * global instance which could be window or globalThis for a web worker
 */
function getPerformance() {
    return getGlobalInst(strPerformance);
}
/**
 * Checks if JSON object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a history
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: JSON is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasJSON() {
    return Boolean((typeof JSON === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] && JSON) || getGlobalInst(strJSON) !== null);
}
/**
 * Returns the global JSON object if it is present otherwise null.
 * This helper is used to access the JSON object without causing an exception
 * "Uncaught ReferenceError: JSON is not defined"
 */
function getJSON() {
    if (hasJSON()) {
        return JSON || getGlobalInst(strJSON);
    }
    return null;
}
/**
 * Returns the crypto object if it is present otherwise null.
 * This helper is used to access the crypto object from the current
 * global instance which could be window or globalThis for a web worker
 */
function getCrypto() {
    return getGlobalInst(strCrypto);
}
/**
 * Returns the crypto object if it is present otherwise null.
 * This helper is used to access the crypto object from the current
 * global instance which could be window or globalThis for a web worker
 */
function getMsCrypto() {
    return getGlobalInst(strMsCrypto);
}
/**
 * Returns whether the environment is reporting that we are running in a React Native Environment
 */
function isReactNative() {
    // If running in React Native, navigator.product will be populated
    var nav = getNavigator();
    if (nav && nav.product) {
        return nav.product === strReactNative;
    }
    return false;
}
/**
 * Identifies whether the current environment appears to be IE
 */
function isIE() {
    var nav = getNavigator();
    if (nav && (nav.userAgent !== _navUserAgentCheck || _isTrident === null)) {
        // Added to support test mocking of the user agent
        _navUserAgentCheck = nav.userAgent;
        var userAgent = (_navUserAgentCheck || "").toLowerCase();
        _isTrident = (Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["E" /* strContains */])(userAgent, strMsie) || Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["E" /* strContains */])(userAgent, strTrident));
    }
    return _isTrident;
}
/**
 * Gets IE version returning the document emulation mode if we are running on IE, or null otherwise
 */
function getIEVersion(userAgentStr) {
    if (userAgentStr === void 0) { userAgentStr = null; }
    if (!userAgentStr) {
        var navigator_1 = getNavigator() || {};
        userAgentStr = navigator_1 ? (navigator_1.userAgent || "").toLowerCase() : "";
    }
    var ua = (userAgentStr || "").toLowerCase();
    if (Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["E" /* strContains */])(ua, strMsie)) {
        return parseInt(ua.split(strMsie)[1]);
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["E" /* strContains */])(ua, strTrident)) {
        var tridentVer = parseInt(ua.split(strTrident)[1]);
        if (tridentVer) {
            return tridentVer + 4;
        }
    }
    return null;
}
/**
 * Returns string representation of an object suitable for diagnostics logging.
 */
function dumpObj(object) {
    var objectTypeDump = Object[__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["l" /* strShimPrototype */]].toString.call(object);
    var propertyValueDump = "";
    if (objectTypeDump === "[object Error]") {
        propertyValueDump = "{ stack: '" + object.stack + "', message: '" + object.message + "', name: '" + object.name + "'";
    }
    else if (hasJSON()) {
        propertyValueDump = getJSON().stringify(object);
    }
    return objectTypeDump + propertyValueDump;
}
function isSafari(userAgentStr) {
    if (!userAgentStr || !Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["v" /* isString */])(userAgentStr)) {
        var navigator_2 = getNavigator() || {};
        userAgentStr = navigator_2 ? (navigator_2.userAgent || "").toLowerCase() : "";
    }
    var ua = (userAgentStr || "").toLowerCase();
    return (ua.indexOf('safari') >= 0);
}
//# sourceMappingURL=EnvUtils.js.map

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setEnableEnvMocks */
/* harmony export (immutable) */ __webpack_exports__["e"] = getGlobalInst;
/* harmony export (immutable) */ __webpack_exports__["n"] = hasWindow;
/* harmony export (immutable) */ __webpack_exports__["l"] = getWindow;
/* unused harmony export hasDocument */
/* harmony export (immutable) */ __webpack_exports__["d"] = getDocument;
/* unused harmony export hasNavigator */
/* harmony export (immutable) */ __webpack_exports__["j"] = getNavigator;
/* unused harmony export hasHistory */
/* unused harmony export getHistory */
/* harmony export (immutable) */ __webpack_exports__["h"] = getLocation;
/* harmony export (immutable) */ __webpack_exports__["b"] = getConsole;
/* harmony export (immutable) */ __webpack_exports__["k"] = getPerformance;
/* harmony export (immutable) */ __webpack_exports__["m"] = hasJSON;
/* harmony export (immutable) */ __webpack_exports__["g"] = getJSON;
/* harmony export (immutable) */ __webpack_exports__["c"] = getCrypto;
/* harmony export (immutable) */ __webpack_exports__["i"] = getMsCrypto;
/* unused harmony export isReactNative */
/* harmony export (immutable) */ __webpack_exports__["o"] = isIE;
/* harmony export (immutable) */ __webpack_exports__["f"] = getIEVersion;
/* harmony export (immutable) */ __webpack_exports__["a"] = dumpObj;
/* unused harmony export isSafari */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HelperFuncs__ = __webpack_require__(44);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





/**
 * This file exists to hold environment utilities that are required to check and
 * validate the current operating environment. Unless otherwise required, please
 * only defined methods (functions) in this class so that users of these
 * functions/properties only need to include those that are used within their own modules.
 */
var strWindow = "window";
var strDocument = "document";
var strNavigator = "navigator";
var strHistory = "history";
var strLocation = "location";
var strConsole = "console";
var strPerformance = "performance";
var strJSON = "JSON";
var strCrypto = "crypto";
var strMsCrypto = "msCrypto";
var strReactNative = "ReactNative";
var strMsie = "msie";
var strTrident = "trident/";
var _isTrident = null;
var _navUserAgentCheck = null;
var _enableMocks = false;
/**
 * Enable the lookup of test mock objects if requested
 * @param enabled
 */
function setEnableEnvMocks(enabled) {
    _enableMocks = enabled;
}
/**
 * Return the named global object if available, will return null if the object is not available.
 * @param name The globally named object
 */
function getGlobalInst(name) {
    var gbl = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["h" /* getGlobal */])();
    if (gbl && gbl[name]) {
        return gbl[name];
    }
    // Test workaround, for environments where <global>.window (when global == window) doesn't return the base window
    if (name === strWindow && hasWindow()) {
        // tslint:disable-next-line: no-angle-bracket-type-assertion
        return window;
    }
    return null;
}
/**
 * Checks if window object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a window
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: window is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasWindow() {
    return Boolean(typeof window === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] && window);
}
/**
 * Returns the global window object if it is present otherwise null.
 * This helper is used to access the window object without causing an exception
 * "Uncaught ReferenceError: window is not defined"
 */
function getWindow() {
    if (hasWindow()) {
        return window;
    }
    // Return the global instance or null
    return getGlobalInst(strWindow);
}
/**
 * Checks if document object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a document
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: document is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasDocument() {
    return Boolean(typeof document === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] && document);
}
/**
 * Returns the global document object if it is present otherwise null.
 * This helper is used to access the document object without causing an exception
 * "Uncaught ReferenceError: document is not defined"
 */
function getDocument() {
    if (hasDocument()) {
        return document;
    }
    return getGlobalInst(strDocument);
}
/**
 * Checks if navigator object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a navigator
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: navigator is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasNavigator() {
    return Boolean(typeof navigator === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] && navigator);
}
/**
 * Returns the global navigator object if it is present otherwise null.
 * This helper is used to access the navigator object without causing an exception
 * "Uncaught ReferenceError: navigator is not defined"
 */
function getNavigator() {
    if (hasNavigator()) {
        return navigator;
    }
    return getGlobalInst(strNavigator);
}
/**
 * Checks if history object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a history
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: history is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasHistory() {
    return Boolean(typeof history === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] && history);
}
/**
 * Returns the global history object if it is present otherwise null.
 * This helper is used to access the history object without causing an exception
 * "Uncaught ReferenceError: history is not defined"
 */
function getHistory() {
    if (hasHistory()) {
        return history;
    }
    return getGlobalInst(strHistory);
}
/**
 * Returns the global location object if it is present otherwise null.
 * This helper is used to access the location object without causing an exception
 * "Uncaught ReferenceError: location is not defined"
 */
function getLocation(checkForMock) {
    if (checkForMock && _enableMocks) {
        var mockLocation = getGlobalInst("__mockLocation");
        if (mockLocation) {
            return mockLocation;
        }
    }
    if (typeof location === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] && location) {
        return location;
    }
    return getGlobalInst(strLocation);
}
/**
 * Returns the global console object
 */
function getConsole() {
    if (typeof console !== __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["m" /* strShimUndefined */]) {
        return console;
    }
    return getGlobalInst(strConsole);
}
/**
 * Returns the performance object if it is present otherwise null.
 * This helper is used to access the performance object from the current
 * global instance which could be window or globalThis for a web worker
 */
function getPerformance() {
    return getGlobalInst(strPerformance);
}
/**
 * Checks if JSON object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a history
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: JSON is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasJSON() {
    return Boolean((typeof JSON === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] && JSON) || getGlobalInst(strJSON) !== null);
}
/**
 * Returns the global JSON object if it is present otherwise null.
 * This helper is used to access the JSON object without causing an exception
 * "Uncaught ReferenceError: JSON is not defined"
 */
function getJSON() {
    if (hasJSON()) {
        return JSON || getGlobalInst(strJSON);
    }
    return null;
}
/**
 * Returns the crypto object if it is present otherwise null.
 * This helper is used to access the crypto object from the current
 * global instance which could be window or globalThis for a web worker
 */
function getCrypto() {
    return getGlobalInst(strCrypto);
}
/**
 * Returns the crypto object if it is present otherwise null.
 * This helper is used to access the crypto object from the current
 * global instance which could be window or globalThis for a web worker
 */
function getMsCrypto() {
    return getGlobalInst(strMsCrypto);
}
/**
 * Returns whether the environment is reporting that we are running in a React Native Environment
 */
function isReactNative() {
    // If running in React Native, navigator.product will be populated
    var nav = getNavigator();
    if (nav && nav.product) {
        return nav.product === strReactNative;
    }
    return false;
}
/**
 * Identifies whether the current environment appears to be IE
 */
function isIE() {
    var nav = getNavigator();
    if (nav && (nav.userAgent !== _navUserAgentCheck || _isTrident === null)) {
        // Added to support test mocking of the user agent
        _navUserAgentCheck = nav.userAgent;
        var userAgent = (_navUserAgentCheck || "").toLowerCase();
        _isTrident = (Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["D" /* strContains */])(userAgent, strMsie) || Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["D" /* strContains */])(userAgent, strTrident));
    }
    return _isTrident;
}
/**
 * Gets IE version returning the document emulation mode if we are running on IE, or null otherwise
 */
function getIEVersion(userAgentStr) {
    if (userAgentStr === void 0) { userAgentStr = null; }
    if (!userAgentStr) {
        var navigator_1 = getNavigator() || {};
        userAgentStr = navigator_1 ? (navigator_1.userAgent || "").toLowerCase() : "";
    }
    var ua = (userAgentStr || "").toLowerCase();
    if (Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["D" /* strContains */])(ua, strMsie)) {
        return parseInt(ua.split(strMsie)[1]);
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["D" /* strContains */])(ua, strTrident)) {
        var tridentVer = parseInt(ua.split(strTrident)[1]);
        if (tridentVer) {
            return tridentVer + 4;
        }
    }
    return null;
}
/**
 * Returns string representation of an object suitable for diagnostics logging.
 */
function dumpObj(object) {
    var objectTypeDump = Object[__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["l" /* strShimPrototype */]].toString.call(object);
    var propertyValueDump = "";
    if (objectTypeDump === "[object Error]") {
        propertyValueDump = "{ stack: '" + object.stack + "', message: '" + object.message + "', name: '" + object.name + "'";
    }
    else if (hasJSON()) {
        propertyValueDump = getJSON().stringify(object);
    }
    return objectTypeDump + propertyValueDump;
}
function isSafari(userAgentStr) {
    if (!userAgentStr || !Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["v" /* isString */])(userAgentStr)) {
        var navigator_2 = getNavigator() || {};
        userAgentStr = navigator_2 ? (navigator_2.userAgent || "").toLowerCase() : "";
    }
    var ua = (userAgentStr || "").toLowerCase();
    return (ua.indexOf('safari') >= 0);
}
//# sourceMappingURL=EnvUtils.js.map

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PropertiesPluginIdentifier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BreezeChannelIdentifier; });
/* unused harmony export AnalyticsPluginIdentifier */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Util__ = __webpack_require__(585);
/* unused harmony reexport Util */
/* unused harmony reexport CorrelationIdHelper */
/* unused harmony reexport DateTimeUtils */
/* unused harmony reexport dateTimeUtilsNow */
/* unused harmony reexport dateTimeUtilsDuration */
/* unused harmony reexport UrlHelper */
/* unused harmony reexport isInternalApplicationInsightsEndpoint */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConnectionStringParser__ = __webpack_require__(1466);
/* unused harmony reexport parseConnectionString */
/* unused harmony reexport ConnectionStringParser */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RequestResponseHeaders__ = __webpack_require__(586);
/* unused harmony reexport RequestHeaders */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Constants__ = __webpack_require__(81);
/* unused harmony reexport DisabledPropertyName */
/* unused harmony reexport ProcessLegacy */
/* unused harmony reexport SampleRate */
/* unused harmony reexport HttpMethod */
/* unused harmony reexport DEFAULT_BREEZE_ENDPOINT */
/* unused harmony reexport strNotSpecified */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Interfaces_Contracts_Generated_Data__ = __webpack_require__(591);
/* unused harmony reexport AIData */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Interfaces_Contracts_Generated_Base__ = __webpack_require__(592);
/* unused harmony reexport AIBase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Telemetry_Common_Envelope__ = __webpack_require__(1467);
/* unused harmony reexport Envelope */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Telemetry_Event__ = __webpack_require__(1469);
/* unused harmony reexport Event */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Telemetry_Exception__ = __webpack_require__(1470);
/* unused harmony reexport Exception */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Telemetry_Metric__ = __webpack_require__(1474);
/* unused harmony reexport Metric */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Telemetry_PageView__ = __webpack_require__(1479);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_10__Telemetry_PageView__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Interfaces_Contracts_Generated_PageViewData__ = __webpack_require__(374);
/* unused harmony reexport PageViewData */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Telemetry_RemoteDependencyData__ = __webpack_require__(1480);
/* unused harmony reexport RemoteDependencyData */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Telemetry_Trace__ = __webpack_require__(1482);
/* unused harmony reexport Trace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Telemetry_PageViewPerformance__ = __webpack_require__(1484);
/* unused harmony reexport PageViewPerformance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Telemetry_Common_Data__ = __webpack_require__(1486);
/* unused harmony reexport Data */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Interfaces_Contracts_Generated_SeverityLevel__ = __webpack_require__(1487);
/* unused harmony reexport SeverityLevel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Interfaces_IConfig__ = __webpack_require__(1488);
/* unused harmony reexport ConfigurationManager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Interfaces_Contracts_Generated_ContextTagKeys__ = __webpack_require__(594);
/* unused harmony reexport ContextTagKeys */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Telemetry_Common_DataSanitizer__ = __webpack_require__(80);
/* unused harmony reexport DataSanitizer */
/* unused harmony reexport dataSanitizeKeyAndAddUniqueness */
/* unused harmony reexport dataSanitizeKey */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_19__Telemetry_Common_DataSanitizer__["f"]; });
/* unused harmony reexport dataSanitizeUrl */
/* unused harmony reexport dataSanitizeMessage */
/* unused harmony reexport dataSanitizeException */
/* unused harmony reexport dataSanitizeProperties */
/* unused harmony reexport dataSanitizeMeasurements */
/* unused harmony reexport dataSanitizeId */
/* unused harmony reexport dataSanitizeInput */
/* unused harmony reexport dsPadNumber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__TelemetryItemCreator__ = __webpack_require__(1489);
/* unused harmony reexport TelemetryItemCreator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Interfaces_PartAExtensions__ = __webpack_require__(1490);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_21__Interfaces_PartAExtensions__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_21__Interfaces_PartAExtensions__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Enums__ = __webpack_require__(589);
/* unused harmony reexport DistributedTracingModes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__HelperFuncs__ = __webpack_require__(250);
/* unused harmony reexport stringToBoolOrDefault */
/* unused harmony reexport msToTimeSpan */
/* unused harmony reexport isBeaconApiSupported */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_23__HelperFuncs__["a"]; });
/* unused harmony reexport isCrossOriginError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__DomHelperFuncs__ = __webpack_require__(587);
/* unused harmony reexport createDomEvent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__StorageHelperFuncs__ = __webpack_require__(588);
/* unused harmony reexport utlDisableStorage */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_25__StorageHelperFuncs__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_25__StorageHelperFuncs__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_25__StorageHelperFuncs__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_25__StorageHelperFuncs__["h"]; });
/* unused harmony reexport utlCanUseSessionStorage */
/* unused harmony reexport utlGetSessionStorageKeys */
/* unused harmony reexport utlGetSessionStorage */
/* unused harmony reexport utlSetSessionStorage */
/* unused harmony reexport utlRemoveSessionStorage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__UrlHelperFuncs__ = __webpack_require__(590);
/* unused harmony reexport urlParseUrl */
/* unused harmony reexport urlGetAbsoluteUrl */
/* unused harmony reexport urlGetPathName */
/* unused harmony reexport urlGetCompleteUrl */
/* unused harmony reexport urlParseHost */
/* unused harmony reexport urlParseFullHost */
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





























var PropertiesPluginIdentifier = "AppInsightsPropertiesPlugin";
var BreezeChannelIdentifier = "AppInsightsChannelPlugin";
var AnalyticsPluginIdentifier = "ApplicationInsightsAnalytics";
//# sourceMappingURL=applicationinsights-common.js.map

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setEnableEnvMocks */
/* harmony export (immutable) */ __webpack_exports__["e"] = getGlobalInst;
/* unused harmony export hasWindow */
/* harmony export (immutable) */ __webpack_exports__["l"] = getWindow;
/* unused harmony export hasDocument */
/* harmony export (immutable) */ __webpack_exports__["d"] = getDocument;
/* unused harmony export hasNavigator */
/* harmony export (immutable) */ __webpack_exports__["j"] = getNavigator;
/* unused harmony export hasHistory */
/* unused harmony export getHistory */
/* harmony export (immutable) */ __webpack_exports__["h"] = getLocation;
/* harmony export (immutable) */ __webpack_exports__["b"] = getConsole;
/* harmony export (immutable) */ __webpack_exports__["k"] = getPerformance;
/* harmony export (immutable) */ __webpack_exports__["m"] = hasJSON;
/* harmony export (immutable) */ __webpack_exports__["g"] = getJSON;
/* harmony export (immutable) */ __webpack_exports__["c"] = getCrypto;
/* harmony export (immutable) */ __webpack_exports__["i"] = getMsCrypto;
/* unused harmony export isReactNative */
/* harmony export (immutable) */ __webpack_exports__["n"] = isIE;
/* harmony export (immutable) */ __webpack_exports__["f"] = getIEVersion;
/* harmony export (immutable) */ __webpack_exports__["a"] = dumpObj;
/* unused harmony export isSafari */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HelperFuncs__ = __webpack_require__(45);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





/**
 * This file exists to hold environment utilities that are required to check and
 * validate the current operating environment. Unless otherwise required, please
 * only defined methods (functions) in this class so that users of these
 * functions/properties only need to include those that are used within their own modules.
 */
var strWindow = "window";
var strDocument = "document";
var strNavigator = "navigator";
var strHistory = "history";
var strLocation = "location";
var strConsole = "console";
var strPerformance = "performance";
var strJSON = "JSON";
var strCrypto = "crypto";
var strMsCrypto = "msCrypto";
var strReactNative = "ReactNative";
var strMsie = "msie";
var strTrident = "trident/";
var _isTrident = null;
var _navUserAgentCheck = null;
var _enableMocks = false;
/**
 * Enable the lookup of test mock objects if requested
 * @param enabled
 */
function setEnableEnvMocks(enabled) {
    _enableMocks = enabled;
}
/**
 * Return the named global object if available, will return null if the object is not available.
 * @param name The globally named object
 */
function getGlobalInst(name) {
    var gbl = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["h" /* getGlobal */])();
    if (gbl && gbl[name]) {
        return gbl[name];
    }
    // Test workaround, for environments where <global>.window (when global == window) doesn't return the base window
    if (name === strWindow && hasWindow()) {
        // tslint:disable-next-line: no-angle-bracket-type-assertion
        return window;
    }
    return null;
}
/**
 * Checks if window object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a window
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: window is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasWindow() {
    return Boolean(typeof window === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] && window);
}
/**
 * Returns the global window object if it is present otherwise null.
 * This helper is used to access the window object without causing an exception
 * "Uncaught ReferenceError: window is not defined"
 */
function getWindow() {
    if (hasWindow()) {
        return window;
    }
    // Return the global instance or null
    return getGlobalInst(strWindow);
}
/**
 * Checks if document object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a document
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: document is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasDocument() {
    return Boolean(typeof document === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] && document);
}
/**
 * Returns the global document object if it is present otherwise null.
 * This helper is used to access the document object without causing an exception
 * "Uncaught ReferenceError: document is not defined"
 */
function getDocument() {
    if (hasDocument()) {
        return document;
    }
    return getGlobalInst(strDocument);
}
/**
 * Checks if navigator object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a navigator
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: navigator is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasNavigator() {
    return Boolean(typeof navigator === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] && navigator);
}
/**
 * Returns the global navigator object if it is present otherwise null.
 * This helper is used to access the navigator object without causing an exception
 * "Uncaught ReferenceError: navigator is not defined"
 */
function getNavigator() {
    if (hasNavigator()) {
        return navigator;
    }
    return getGlobalInst(strNavigator);
}
/**
 * Checks if history object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a history
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: history is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasHistory() {
    return Boolean(typeof history === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] && history);
}
/**
 * Returns the global history object if it is present otherwise null.
 * This helper is used to access the history object without causing an exception
 * "Uncaught ReferenceError: history is not defined"
 */
function getHistory() {
    if (hasHistory()) {
        return history;
    }
    return getGlobalInst(strHistory);
}
/**
 * Returns the global location object if it is present otherwise null.
 * This helper is used to access the location object without causing an exception
 * "Uncaught ReferenceError: location is not defined"
 */
function getLocation(checkForMock) {
    if (checkForMock && _enableMocks) {
        var mockLocation = getGlobalInst("__mockLocation");
        if (mockLocation) {
            return mockLocation;
        }
    }
    if (typeof location === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] && location) {
        return location;
    }
    return getGlobalInst(strLocation);
}
/**
 * Returns the global console object
 */
function getConsole() {
    if (typeof console !== __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["m" /* strShimUndefined */]) {
        return console;
    }
    return getGlobalInst(strConsole);
}
/**
 * Returns the performance object if it is present otherwise null.
 * This helper is used to access the performance object from the current
 * global instance which could be window or globalThis for a web worker
 */
function getPerformance() {
    return getGlobalInst(strPerformance);
}
/**
 * Checks if JSON object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a history
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: JSON is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasJSON() {
    return Boolean((typeof JSON === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["k" /* strShimObject */] && JSON) || getGlobalInst(strJSON) !== null);
}
/**
 * Returns the global JSON object if it is present otherwise null.
 * This helper is used to access the JSON object without causing an exception
 * "Uncaught ReferenceError: JSON is not defined"
 */
function getJSON() {
    if (hasJSON()) {
        return JSON || getGlobalInst(strJSON);
    }
    return null;
}
/**
 * Returns the crypto object if it is present otherwise null.
 * This helper is used to access the crypto object from the current
 * global instance which could be window or globalThis for a web worker
 */
function getCrypto() {
    return getGlobalInst(strCrypto);
}
/**
 * Returns the crypto object if it is present otherwise null.
 * This helper is used to access the crypto object from the current
 * global instance which could be window or globalThis for a web worker
 */
function getMsCrypto() {
    return getGlobalInst(strMsCrypto);
}
/**
 * Returns whether the environment is reporting that we are running in a React Native Environment
 */
function isReactNative() {
    // If running in React Native, navigator.product will be populated
    var nav = getNavigator();
    if (nav && nav.product) {
        return nav.product === strReactNative;
    }
    return false;
}
/**
 * Identifies whether the current environment appears to be IE
 */
function isIE() {
    var nav = getNavigator();
    if (nav && (nav.userAgent !== _navUserAgentCheck || _isTrident === null)) {
        // Added to support test mocking of the user agent
        _navUserAgentCheck = nav.userAgent;
        var userAgent = (_navUserAgentCheck || "").toLowerCase();
        _isTrident = (Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["E" /* strContains */])(userAgent, strMsie) || Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["E" /* strContains */])(userAgent, strTrident));
    }
    return _isTrident;
}
/**
 * Gets IE version returning the document emulation mode if we are running on IE, or null otherwise
 */
function getIEVersion(userAgentStr) {
    if (userAgentStr === void 0) { userAgentStr = null; }
    if (!userAgentStr) {
        var navigator_1 = getNavigator() || {};
        userAgentStr = navigator_1 ? (navigator_1.userAgent || "").toLowerCase() : "";
    }
    var ua = (userAgentStr || "").toLowerCase();
    if (Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["E" /* strContains */])(ua, strMsie)) {
        return parseInt(ua.split(strMsie)[1]);
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["E" /* strContains */])(ua, strTrident)) {
        var tridentVer = parseInt(ua.split(strTrident)[1]);
        if (tridentVer) {
            return tridentVer + 4;
        }
    }
    return null;
}
/**
 * Returns string representation of an object suitable for diagnostics logging.
 */
function dumpObj(object) {
    var objectTypeDump = Object[__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["l" /* strShimPrototype */]].toString.call(object);
    var propertyValueDump = "";
    if (objectTypeDump === "[object Error]") {
        propertyValueDump = "{ stack: '" + object.stack + "', message: '" + object.message + "', name: '" + object.name + "'";
    }
    else if (hasJSON()) {
        propertyValueDump = getJSON().stringify(object);
    }
    return objectTypeDump + propertyValueDump;
}
function isSafari(userAgentStr) {
    if (!userAgentStr || !Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["v" /* isString */])(userAgentStr)) {
        var navigator_2 = getNavigator() || {};
        userAgentStr = navigator_2 ? (navigator_2.userAgent || "").toLowerCase() : "";
    }
    var ua = (userAgentStr || "").toLowerCase();
    return (ua.indexOf('safari') >= 0);
}
//# sourceMappingURL=EnvUtils.js.map

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDocument;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setSSR__ = __webpack_require__(382);

/**
 * Helper to get the document object. Note that in popup window cases, document
 * might be the wrong document, which is why we look at ownerDocument for the
 * truth. Also note that the SSR flag is used to test ssr scenarios even if
 * document is defined (from JSDOM for example.)
 *
 * @public
 */
function getDocument(rootElement) {
    if (__WEBPACK_IMPORTED_MODULE_0__setSSR__["a" /* _isSSR */] || typeof document === 'undefined') {
        return undefined;
    }
    else {
        var el = rootElement;
        return el && el.ownerDocument ? el.ownerDocument : document;
    }
}
//# sourceMappingURL=getDocument.js.map

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export readwriteRoles */
/* unused harmony export readonlyRoles */
/* unused harmony export UserStore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_moment_timezone__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_src_app_helpers_createUserManager__ = __webpack_require__(1656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_src_app_helpers_queryString__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_src_app_services_request__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__build_src_app_services_WebStorage__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_prepareConfig__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AppStore__ = __webpack_require__(351);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5;function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var readwriteRoles=['admin','owner','agent','assistant'];var readonlyRoles=['readonly-agent'].concat(readwriteRoles);var UserStore=(_class=function(){_createClass(UserStore,[{key:'userConfig',get:function get(){return Object(__WEBPACK_IMPORTED_MODULE_8__helpers_prepareConfig__["c" /* prepareUserConfig */])(this.app.config,this.app.data,this.claims);}}]);function UserStore(app){var _this=this;_classCallCheck(this,UserStore);_initDefineProp(this,'data',_descriptor,this);_initDefineProp(this,'error',_descriptor2,this);_initDefineProp(this,'claims',_descriptor3,this);_initDefineProp(this,'favicon_url',_descriptor4,this);_initDefineProp(this,'friendly_name',_descriptor5,this);this.app=null;this.storage=new __WEBPACK_IMPORTED_MODULE_7__build_src_app_services_WebStorage__["a" /* default */]();this.roleDefinitions={readonly:readonlyRoles};this.onUnauthorized=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!(!_this.manager||_this.reauthenticating)){_context.next=2;break;}return _context.abrupt('return');case 2:_this.reauthenticating=true;_context.prev=3;console.debug('[auth] unauthorized response, re-authenticating');_context.next=7;return _this.manager.removeUser();case 7:_context.next=9;return _this.signin();case 9:_context.next=14;break;case 11:_context.prev=11;_context.t0=_context['catch'](3);console.error('[auth] re-authentication failed',_context.t0);case 14:_context.prev=14;_this.reauthenticating=false;return _context.finish(14);case 17:case'end':return _context.stop();}}},_callee,_this,[[3,11,14,17]]);}));this.onUserLoaded=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(user){var appPalette,defaultTheme,_ref3,_ref3$theme,theme,logo_url,favicon_url,friendly_name,sale_country,features,dashboard,agent_terms_url,agent_privacy_url,agent_avv_url,fabric;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(!(_this.app.tenant.startsWith('propnow')||_this.app.tenant==='remax-de')){_context2.next=25;break;}appPalette=_this.app.theme.palette;defaultTheme={palette:{primary:{main:appPalette.themePrimary},secondary:{main:appPalette.themeSecondary||appPalette.themeDarkAlt},error:{main:appPalette.alert}}};_context2.prev=3;_context2.next=6;return Object(__WEBPACK_IMPORTED_MODULE_6__build_src_app_services_request__["d" /* get */])(_this.app.config.userManagement.url+'/app-settings?name='+(user.profile.tenant||_this.app.tenant));case 6:_ref3=_context2.sent;_ref3$theme=_ref3.theme;theme=_ref3$theme===undefined?defaultTheme:_ref3$theme;logo_url=_ref3.logo_url;favicon_url=_ref3.favicon_url;friendly_name=_ref3.friendly_name;sale_country=_ref3.sale_country;features=_ref3.features;dashboard=_ref3.dashboard;agent_terms_url=_ref3.agent_terms_url;agent_privacy_url=_ref3.agent_privacy_url;agent_avv_url=_ref3.agent_avv_url;fabric=__WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash___default.a.merge({},_this.app.theme,{palette:{themePrimary:__WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash___default.a.get(theme,'palette.primary.main'),themeSecondary:__WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash___default.a.get(theme,'palette.secondary.main'),themeDarkAlt:__WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash___default.a.get(theme,'palette.primary.main'),alert:__WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash___default.a.get(theme,'palette.error.main')},logo_url:logo_url,favicon_url:favicon_url,friendly_name:friendly_name});Object(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx__["l" /* runInAction */])(function(){_this.app.setData({friendly_name:friendly_name,sale_country:user.profile.sale_country||sale_country,features:features,dashboard:dashboard,agent_terms_url:agent_terms_url,agent_privacy_url:agent_privacy_url,agent_avv_url:agent_avv_url});_this.app.setTheme(fabric);});_context2.next=25;break;case 22:_context2.prev=22;_context2.t0=_context2['catch'](3);console.error(_context2.t0);case 25:if(user.profile){_this.claims=user.profile;}_this.data=user;console.debug('[oidc] onUserLoaded');case 28:case'end':return _context2.stop();}}},_callee2,_this,[[3,22]]);}));return function(_x){return _ref2.apply(this,arguments);};}();this.onSilentRenewError=function(error){_this.error=error;};this.onAccessTokenExpiring=function(){console.debug('[oidc] onAccessTokenExpiring');};this.onAccessTokenExpired=function(){console.debug('[oidc] onAccessTokenExpired');};this.onUserSignedOut=function(){// this.data = null;
console.debug('[oidc] onUserSignedOut');};this.onUserUnloaded=function(){_this.data=null;console.debug('[oidc] onUserUnloaded');if(_this.isUsingCustomIdentityService){_this.signin();}};this.offices=function(){return[].concat(_toConsumableArray(new Set([].concat(_toConsumableArray(!!_this.claims.permissions&&Array.isArray(_this.claims.permissions.toJS())?_this.claims.permissions.toJS().filter(function(_ref4){var role=_ref4.role,office=_ref4.office,agent=_ref4.agent;return role==='agent'&&!!agent&&!!office;}).map(function(a){return a.office;}):[]),_toConsumableArray(!!_this.claims.office_ids_allowed?_this.claims.office_ids_allowed.split(';'):[])))));};this.office_id=function(){return _this.offices().find(Boolean);};this.agentData=function(){var _claims=_this.claims,name=_claims.name,family_name=_claims.family_name,given_name=_claims.given_name;var userName=family_name?given_name+' '+family_name:name;var _claims2=_this.claims,office_ids_allowed=_claims2.office_ids_allowed,permissions=_claims2.permissions,hasBrokerownerRight=_claims2.hasBrokerownerRight,hasOfficeRight=_claims2.hasOfficeRight,s_hash=_claims2.s_hash,sid=_claims2.sid,auth_time=_claims2.auth_time,idp=_claims2.idp,amr=_claims2.amr,rest=_objectWithoutProperties(_claims2,['office_ids_allowed','permissions','hasBrokerownerRight','hasOfficeRight','s_hash','sid','auth_time','idp','amr']);// separate claims that should not go into agent_data
return Object.assign({},rest,{id:_this.claims.agent_id,name:userName,phone:_this.claims.phone_number,office_id:_this.office_id()});};this.app=app;this.appInit=Object(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx__["k" /* reaction */])(function(){return app.config;},function(config){_this.createUserManager(config);});this.tokenReaction=Object(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx__["k" /* reaction */])(function(){return _this.accessToken;},function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3(token){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:if(_this.accessToken){_context3.next=2;break;}return _context3.abrupt('return');case 2:if(!_this.claims){_context3.next=4;break;}return _context3.abrupt('return');case 4:_context3.next=6;return Object(__WEBPACK_IMPORTED_MODULE_6__build_src_app_services_request__["d" /* get */])('/api/v1/users',_this.accessToken);case 6:_this.claims=_context3.sent.claims;case 7:case'end':return _context3.stop();}}},_callee3,_this);}));return function(_x2){return _ref5.apply(this,arguments);};}());this.profileReaction=Object(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx__["k" /* reaction */])(function(){return _this.profile;},function(claims){if(claims!==null){var locale=claims.locale;window.locale=locale;__WEBPACK_IMPORTED_MODULE_2__build_node_modules_moment_timezone___default.a.locale(locale);}});if(typeof window!=='undefined'&&window.addEventListener){window.addEventListener(__WEBPACK_IMPORTED_MODULE_6__build_src_app_services_request__["a" /* UNAUTHORIZED_EVENT */],this.onUnauthorized);}}_createClass(UserStore,[{key:'signin',value:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee4(){var usertoken,idp,idpAcrValue,user;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:usertoken=Object(__WEBPACK_IMPORTED_MODULE_4__build_src_app_helpers_queryString__["a" /* getQueryStringValue */])('usertoken');idp=Object(__WEBPACK_IMPORTED_MODULE_4__build_src_app_helpers_queryString__["a" /* getQueryStringValue */])('idp');// if (!idp || idp === '') {
//   idp = this.app.tenant === 'remax-at' ? 'privatenet' : null;
// }
idpAcrValue=idp?'idp:'+idp:null;if(!(usertoken||idp)){_context4.next=8;break;}_context4.next=6;return this.manager.clearStaleState();case 6:_context4.next=8;return this.manager.removeUser();case 8:if(!usertoken){_context4.next=12;break;}_context4.next=11;return this.manager.signinRedirect({extraQueryParams:{usertoken:usertoken}});case 11:return _context4.abrupt('return');case 12:_context4.next=14;return this.manager.getUser();case 14:user=_context4.sent;if(!(user&&!user.expired)){_context4.next=19;break;}this.onUserLoaded(user);_context4.next=21;break;case 19:_context4.next=21;return this.manager.signinRedirect({acr_values:idpAcrValue});case 21:case'end':return _context4.stop();}}},_callee4,this);}));function signin(){return _ref6.apply(this,arguments);}return signin;}()},{key:'signout',value:function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee6(){var _this2=this;var doPost;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:doPost=this.isUsingCustomIdentityService;_context6.prev=1;if(!doPost){_context6.next=5;break;}_context6.next=5;return Object(__WEBPACK_IMPORTED_MODULE_6__build_src_app_services_request__["e" /* post */])('/api/v1/users/signout',{},this.accessToken);case 5:_context6.next=9;break;case 7:_context6.prev=7;_context6.t0=_context6['catch'](1);case 9:_context6.prev=9;Object(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx__["l" /* runInAction */])(_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee5(){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_this2.data=null;_this2.claims=null;_this2.error=null;_context5.next=5;return _this2.manager.removeUser();case 5:case'end':return _context5.stop();}}},_callee5,_this2);})));return _context6.abrupt('return',{redirect:!doPost});case 13:case'end':return _context6.stop();}}},_callee6,this,[[1,7,9,13]]);}));function signout(){return _ref7.apply(this,arguments);}return signout;}()// An API call was rejected with 401: the identity session is no longer valid
// (e.g. it was invalidated server-side). Drop the stale oidc user and start a
// fresh sign-in instead of leaving the UI to retry with a dead token.
},{key:'createUserManager',value:function createUserManager(config){if(!config){return;}this.manager=Object(__WEBPACK_IMPORTED_MODULE_3__build_src_app_helpers_createUserManager__["a" /* default */])(config.oidc);this.manager.events.addUserLoaded(this.onUserLoaded);this.manager.events.addSilentRenewError(this.onSilentRenewError);this.manager.events.addAccessTokenExpired(this.onAccessTokenExpired);this.manager.events.addAccessTokenExpiring(this.onAccessTokenExpiring);this.manager.events.addUserUnloaded(this.onUserUnloaded);this.manager.events.addUserSignedOut(this.onUserSignedOut);}// event callback when silent renew errored
// event callback when the user is expiring
// event callback when the access token expired
// event callback when the user is signed out
// event callback when the user is logged out
// get first office
},{key:'hasRole',get:function get(){var permissions=this.profile.permissions;return function(roles){if(!permissions){return true;}return permissions.some(function(p){return roles.some(function(r){return r===p.role;});});};}},{key:'hasReadWritePermissions',get:function get(){return this.hasRole(readwriteRoles);}},{key:'hasPermissions',get:function get(){var _this3=this;var office=typeof this.app.features.officeRequired==='undefined'?true:!!this.app.features.officeRequired;return function(entityAgentData){var roles=arguments.length>1&&arguments[1]!==undefined?arguments[1]:readwriteRoles;var officeRequired=arguments.length>2&&arguments[2]!==undefined?arguments[2]:office;var agentTenant=_this3.profile.tenant||_this3.app.tenant;var entityTenant=entityAgentData.tenant||_this3.app.tenant;if(!!_this3.profile.sub&&!!entityAgentData.sub&&_this3.profile.sub===entityAgentData.sub){return true;}if(agentTenant===entityTenant&&_this3.profile.permissions&&_this3.profile.permissions.length>0){var permissions=_this3.profile.permissions;return permissions.filter(function(p){return!officeRequired||!!p.office||p.role==='admin'||p.role==='owner'||p.role==='assistant';}).some(function(p){return(!p.office||p.office===entityAgentData.office_id)&&(// has office permissions
!p.agent||p.agent===entityAgentData.id)&&roles.some(function(r){return r===p.role;});});}if(entityTenant===agentTenant&&_this3.profile.office_ids_allowed&&_this3.profile.office_ids_allowed.split(';').includes(entityAgentData.office_id)&&(_this3.profile.hasOfficeRight||_this3.profile.hasBrokerownerRight)){return true;}return false;};}},{key:'isAuthenticated',get:function get(){return this.data!==null&&this.claims!==null;}},{key:'profile',get:function get(){if(!this.isAuthenticated){return null;}return this.claims;}},{key:'accessToken',get:function get(){return this.data!==null?this.data.access_token:null;}},{key:'sub',get:function get(){return Object(__WEBPACK_IMPORTED_MODULE_4__build_src_app_helpers_queryString__["a" /* getQueryStringValue */])('sub');}},{key:'isUsingCustomIdentityService',get:function get(){return!!__WEBPACK_IMPORTED_MODULE_9__AppStore__["a" /* default */].config.oidc.user_endpoint;}}]);return UserStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'data',[__WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'error',[__WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'claims',[__WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'favicon_url',[__WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'friendly_name',[__WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return null;}}),_applyDecoratedDescriptor(_class.prototype,'userConfig',[__WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'userConfig'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'hasRole',[__WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'hasRole'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'hasReadWritePermissions',[__WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'hasReadWritePermissions'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'hasPermissions',[__WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'hasPermissions'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isAuthenticated',[__WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isAuthenticated'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'profile',[__WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'profile'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'accessToken',[__WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'accessToken'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'sub',[__WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'sub'),_class.prototype)),_class);var user=new UserStore(__WEBPACK_IMPORTED_MODULE_9__AppStore__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (user);

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getQueryStringValue;
function getQueryStringValue(key){return new URLSearchParams(window.location.search).get(key);}

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HttpError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TimeoutError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AbortError; });
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/** Error thrown when an HTTP request fails. */
var HttpError = /** @class */ (function (_super) {
    __extends(HttpError, _super);
    /** Constructs a new instance of {@link @microsoft/signalr.HttpError}.
     *
     * @param {string} errorMessage A descriptive error message.
     * @param {number} statusCode The HTTP status code represented by this error.
     */
    function HttpError(errorMessage, statusCode) {
        var _newTarget = this.constructor;
        var _this = this;
        var trueProto = _newTarget.prototype;
        _this = _super.call(this, errorMessage) || this;
        _this.statusCode = statusCode;
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        _this.__proto__ = trueProto;
        return _this;
    }
    return HttpError;
}(Error));

/** Error thrown when a timeout elapses. */
var TimeoutError = /** @class */ (function (_super) {
    __extends(TimeoutError, _super);
    /** Constructs a new instance of {@link @microsoft/signalr.TimeoutError}.
     *
     * @param {string} errorMessage A descriptive error message.
     */
    function TimeoutError(errorMessage) {
        var _newTarget = this.constructor;
        if (errorMessage === void 0) { errorMessage = "A timeout occurred."; }
        var _this = this;
        var trueProto = _newTarget.prototype;
        _this = _super.call(this, errorMessage) || this;
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        _this.__proto__ = trueProto;
        return _this;
    }
    return TimeoutError;
}(Error));

/** Error thrown when an action is aborted. */
var AbortError = /** @class */ (function (_super) {
    __extends(AbortError, _super);
    /** Constructs a new instance of {@link AbortError}.
     *
     * @param {string} errorMessage A descriptive error message.
     */
    function AbortError(errorMessage) {
        var _newTarget = this.constructor;
        if (errorMessage === void 0) { errorMessage = "An abort occurred."; }
        var _this = this;
        var trueProto = _newTarget.prototype;
        _this = _super.call(this, errorMessage) || this;
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        _this.__proto__ = trueProto;
        return _this;
    }
    return AbortError;
}(Error));

//# sourceMappingURL=Errors.js.map

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uifabric_utilities__ = __webpack_require__(61);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__uifabric_utilities__["m"]; });
/* unused harmony reexport SelectionDirection */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__uifabric_utilities__["o"]; });

//# sourceMappingURL=interfaces.js.map

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_List_index__ = __webpack_require__(1720);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_List_index__["a"]; });

//# sourceMappingURL=List.js.map

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contextualMenuUtility__ = __webpack_require__(1735);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__contextualMenuUtility__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__contextualMenuUtility__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__contextualMenuUtility__["c"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContextualMenuItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContextualMenuItem_base__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ContextualMenu_classNames__ = __webpack_require__(411);



/**
 * ContextualMenuItem description
 */
var ContextualMenuItem = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__ContextualMenuItem_base__["a" /* ContextualMenuItemBase */], __WEBPACK_IMPORTED_MODULE_2__ContextualMenu_classNames__["a" /* getItemStyles */], undefined, { scope: 'ContextualMenuItem' });
//# sourceMappingURL=ContextualMenuItem.js.map

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Modal_index__ = __webpack_require__(712);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Modal_index__["a"]; });
/* unused harmony reexport default */


//# sourceMappingURL=Modal.js.map

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Overlay_index__ = __webpack_require__(1766);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Overlay_index__["a"]; });

//# sourceMappingURL=Overlay.js.map

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DayOfWeek; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MonthOfYear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FirstWeekOfYear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DateRangeType; });
/**
 * The days of the week
 * {@docCategory DayOfWeek}
 */
var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek[DayOfWeek["Sunday"] = 0] = "Sunday";
    DayOfWeek[DayOfWeek["Monday"] = 1] = "Monday";
    DayOfWeek[DayOfWeek["Tuesday"] = 2] = "Tuesday";
    DayOfWeek[DayOfWeek["Wednesday"] = 3] = "Wednesday";
    DayOfWeek[DayOfWeek["Thursday"] = 4] = "Thursday";
    DayOfWeek[DayOfWeek["Friday"] = 5] = "Friday";
    DayOfWeek[DayOfWeek["Saturday"] = 6] = "Saturday";
})(DayOfWeek || (DayOfWeek = {}));
/**
 * The months
 * {@docCategory MonthOfYear}
 */
var MonthOfYear;
(function (MonthOfYear) {
    MonthOfYear[MonthOfYear["January"] = 0] = "January";
    MonthOfYear[MonthOfYear["February"] = 1] = "February";
    MonthOfYear[MonthOfYear["March"] = 2] = "March";
    MonthOfYear[MonthOfYear["April"] = 3] = "April";
    MonthOfYear[MonthOfYear["May"] = 4] = "May";
    MonthOfYear[MonthOfYear["June"] = 5] = "June";
    MonthOfYear[MonthOfYear["July"] = 6] = "July";
    MonthOfYear[MonthOfYear["August"] = 7] = "August";
    MonthOfYear[MonthOfYear["September"] = 8] = "September";
    MonthOfYear[MonthOfYear["October"] = 9] = "October";
    MonthOfYear[MonthOfYear["November"] = 10] = "November";
    MonthOfYear[MonthOfYear["December"] = 11] = "December";
})(MonthOfYear || (MonthOfYear = {}));
/**
 * First week of the year settings types
 * {@docCategory FirstWeekOfYear}
 */
var FirstWeekOfYear;
(function (FirstWeekOfYear) {
    FirstWeekOfYear[FirstWeekOfYear["FirstDay"] = 0] = "FirstDay";
    FirstWeekOfYear[FirstWeekOfYear["FirstFullWeek"] = 1] = "FirstFullWeek";
    FirstWeekOfYear[FirstWeekOfYear["FirstFourDayWeek"] = 2] = "FirstFourDayWeek";
})(FirstWeekOfYear || (FirstWeekOfYear = {}));
/**
 * The supported date range types
 * {@docCategory DateRangeType}
 */
var DateRangeType;
(function (DateRangeType) {
    DateRangeType[DateRangeType["Day"] = 0] = "Day";
    DateRangeType[DateRangeType["Week"] = 1] = "Week";
    DateRangeType[DateRangeType["Month"] = 2] = "Month";
    DateRangeType[DateRangeType["WorkWeek"] = 3] = "WorkWeek";
})(DateRangeType || (DateRangeType = {}));
//# sourceMappingURL=DateValues.js.map

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _rgbaOrHexString;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts__ = __webpack_require__(37);

/**
 * @internal
 * Get a CSS color string from some color components.
 * If `a` is specified and not 100, returns an `rgba()` string.
 * Otherwise returns `hex` prefixed with #.
 */
function _rgbaOrHexString(r, g, b, a, hex) {
    return a === __WEBPACK_IMPORTED_MODULE_0__consts__["b" /* MAX_COLOR_ALPHA */] || typeof a !== 'number' ? "#" + hex : "rgba(" + r + ", " + g + ", " + b + ", " + a / __WEBPACK_IMPORTED_MODULE_0__consts__["b" /* MAX_COLOR_ALPHA */] + ")";
}
//# sourceMappingURL=_rgbaOrHexString.js.map

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uifabric_foundation__ = __webpack_require__(1946);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__uifabric_foundation__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__uifabric_foundation__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__uifabric_foundation__["c"]; });

//# sourceMappingURL=Foundation.js.map

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__de_json__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__de_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__de_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__en_json__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__en_json__);
var messages={de:__WEBPACK_IMPORTED_MODULE_0__de_json___default.a,en:__WEBPACK_IMPORTED_MODULE_1__en_json___default.a};/* harmony default export */ __webpack_exports__["default"] = ({messages:messages,invariant:'de'});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__de_json__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__de_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__de_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__en_json__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__en_json__);
var messages={de:__WEBPACK_IMPORTED_MODULE_0__de_json___default.a,en:__WEBPACK_IMPORTED_MODULE_1__en_json___default.a};/* harmony default export */ __webpack_exports__["default"] = ({messages:messages,invariant:'de'});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SaleEditStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SaleEditStore", function() { return SaleEditStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3;function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var SaleEditStore=(_class=function(){function SaleEditStore(user){_classCallCheck(this,SaleEditStore);_initDefineProp(this,'page',_descriptor,this);_initDefineProp(this,'offerData',_descriptor2,this);_initDefineProp(this,'docs',_descriptor3,this);this.user=null;this.user=user;}_createClass(SaleEditStore,[{key:'initialize',value:function initialize(offerData,docs){this.offerData=Object.assign({},offerData);this.docs=(docs||[]).slice();Object(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["e" /* extendObservable */])(this.offerData,{object_type:offerData.object_type||'',surface_area:offerData.surface_area||0,objectno:offerData.objectno||'',object_address:offerData.object_address||'',deed1:offerData.deed1||'',ownership:offerData.ownership||'',ownership_share:offerData.ownership_share||'',ownership_total:offerData.ownership_total||'',ubernommene_lasten:offerData.ubernommene_lasten||null,sonstige_gegenleistungen:offerData.sonstige_gegenleistungen||null,vat_percentage:offerData.vat_percentage,vat_mandate:offerData.vat_mandate||false,handover:offerData.handover||''});}},{key:'isPage1Valid',get:function get(){var data=this.offerData;return!!data.object_type&&!!data.surface_area&&!!data.object_address&&!!data.deed1;}},{key:'isPage2Valid',get:function get(){return true;}},{key:'isPage3Valid',get:function get(){return true;}}]);return SaleEditStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'page',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return 1;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'offerData',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'docs',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}}),_applyDecoratedDescriptor(_class.prototype,'isPage1Valid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isPage1Valid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isPage2Valid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isPage2Valid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isPage3Valid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isPage3Valid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'initialize',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'initialize'),_class.prototype)),_class);

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SaleEditStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SaleEditStore", function() { return SaleEditStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3;function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var SaleEditStore=(_class=function(){function SaleEditStore(user){_classCallCheck(this,SaleEditStore);_initDefineProp(this,'page',_descriptor,this);_initDefineProp(this,'offerData',_descriptor2,this);_initDefineProp(this,'docs',_descriptor3,this);this.user=null;this.user=user;}_createClass(SaleEditStore,[{key:'initialize',value:function initialize(offerData,docs){this.offerData=Object.assign({},offerData);this.docs=(docs||[]).slice();Object(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["e" /* extendObservable */])(this.offerData,{object_type:offerData.object_type||'',surface_area:offerData.surface_area||0,plot_area:offerData.plot_area||0,objectno:offerData.objectno||'',object_address:offerData.object_address||'',deed1:offerData.deed1||'',ownership:offerData.ownership||'',ownership_share:offerData.ownership_share||'',ownership_total:offerData.ownership_total||'',ubernommene_lasten:offerData.ubernommene_lasten||null,sonstige_gegenleistungen:offerData.sonstige_gegenleistungen||null,vat_percentage:offerData.vat_percentage,vat_mandate:offerData.vat_mandate||false,handover:offerData.handover||''});}},{key:'isPage1Valid',get:function get(){var data=this.offerData;return!!data.object_type&&(!!data.surface_area||!!data.plot_area)&&!!data.object_address&&!!data.deed1;}},{key:'isPage2Valid',get:function get(){var data=this.offerData;return!!data.handover;}},{key:'isPage3Valid',get:function get(){return true;}}]);return SaleEditStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'page',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return 1;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'offerData',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'docs',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}}),_applyDecoratedDescriptor(_class.prototype,'isPage1Valid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isPage1Valid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isPage2Valid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isPage2Valid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isPage3Valid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isPage3Valid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'initialize',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'initialize'),_class.prototype)),_class);

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SaleEditStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SaleEditStore", function() { return SaleEditStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3;function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var SaleEditStore=(_class=function(){function SaleEditStore(user){_classCallCheck(this,SaleEditStore);_initDefineProp(this,'page',_descriptor,this);_initDefineProp(this,'offerData',_descriptor2,this);_initDefineProp(this,'docs',_descriptor3,this);this.user=null;this.user=user;}_createClass(SaleEditStore,[{key:'initialize',value:function initialize(offerData,docs){this.offerData=Object.assign({},offerData);this.docs=(docs||[]).slice();Object(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["e" /* extendObservable */])(this.offerData,{object_type:offerData.object_type||'',surface_area:offerData.surface_area||0,objectno:offerData.objectno||'',object_address:offerData.object_address||'',deed1:offerData.deed1||'',ownership:offerData.ownership||'',ownership_share:offerData.ownership_share||'',ownership_total:offerData.ownership_total||'',ubernommene_lasten:offerData.ubernommene_lasten||null,sonstige_gegenleistungen:offerData.sonstige_gegenleistungen||null,vat_percentage:offerData.vat_percentage,vat_mandate:offerData.vat_mandate||false,handover:offerData.handover||'',provisionType:offerData.provisionType||'none'});}},{key:'isPage1Valid',get:function get(){var data=this.offerData;return!!data.object_type&&!!data.surface_area&&!!data.object_address;}},{key:'isPage2Valid',get:function get(){return true;}},{key:'isPage3Valid',get:function get(){return true;}}]);return SaleEditStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'page',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return 1;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'offerData',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'docs',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}}),_applyDecoratedDescriptor(_class.prototype,'isPage1Valid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isPage1Valid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isPage2Valid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isPage2Valid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isPage3Valid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isPage3Valid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'initialize',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'initialize'),_class.prototype)),_class);

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SaleEditStore", function() { return SaleEditStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cadastreFields__ = __webpack_require__(162);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3;function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var SaleEditStore=(_class=function(){function SaleEditStore(){_classCallCheck(this,SaleEditStore);_initDefineProp(this,'page',_descriptor,this);_initDefineProp(this,'offerData',_descriptor2,this);_initDefineProp(this,'docs',_descriptor3,this);}_createClass(SaleEditStore,[{key:'initialize',value:function initialize(offerData,docs){this.offerData=Object.assign({},offerData);this.docs=(docs||[]).slice();Object(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["e" /* extendObservable */])(this.offerData,{// Page1
object_type:offerData.object_type||'',object_address_street:offerData.object_address_street||'',object_address_house_number:offerData.object_address_house_number||'',object_address_apartment_number:offerData.object_address_apartment_number||'',object_address_state:offerData.object_address_state||'',object_address_zip:offerData.object_address_zip||'',cadastre:offerData.cadastre||Object(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */])([Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_1__cadastreFields__["cadastreProps"])())]),cadastre_registry_number:offerData.cadastre_registry_number||'',cadastre_city:offerData.cadastre_city||'',cadastre_volume:offerData.cadastre_volume||'',cadastre_book:offerData.cadastre_book||'',cadastre_folio:offerData.cadastre_folio||'',cadastre_property_number:offerData.cadastre_property_number||'',seller_notes:offerData.seller_notes||'',debt_type:offerData.debt_type||'',debt_amount:offerData.debt_amount||'',debt_details:offerData.debt_details||'',// Page2
seller_type:offerData.seller_type||'private',seller_company_name:offerData.seller_company_name||'',seller_vat_id:offerData.seller_company_vat_id||'',seller_salutation:offerData.seller_salutation||'',seller_firstName:offerData.seller_firstName||'',seller_lastName:offerData.seller_lastName||'',seller_street:offerData.seller_street||'',seller_house_number:offerData.seller_house_number||'',seller_street_additional:offerData.seller_street_additional||'',seller_zip:offerData.seller_zip||'',seller_city:offerData.seller_city||'',seller_country:offerData.seller_country||'España',seller_country_code:offerData.seller_country_code||'ES',seller_id_type:offerData.seller_id_type||'',seller_id_number:offerData.seller_id_number||'',seller_citizenship:offerData.seller_citizenship||'España',seller_citizenship_code:offerData.seller_citizenship_code||'ES',additional_sellers:offerData.additional_sellers||[],deposit_type:offerData.deposit_type||'none',deposit_fixed_amount:offerData.deposit_fixed_amount||0,deposit_percentage:offerData.deposit_percentage||0,security_type:offerData.security_type||'none',security_fixed_amount:offerData.security_fixed_amount||0,security_percentage:offerData.security_percentage||0,closing_seller_deadline_days:offerData.closing_seller_deadline_days||0,closing_seller_target_days:offerData.closing_seller_target_days||0,notary:offerData.notary||''});}},{key:'isPage1Valid',get:function get(){var object_type=this.offerData.object_type;return!!object_type;}},{key:'isPage2Valid',get:function get(){return true;}},{key:'isPage3Valid',get:function get(){return true;}}]);return SaleEditStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'page',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return 1;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'offerData',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'docs',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}}),_applyDecoratedDescriptor(_class.prototype,'isPage1Valid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isPage1Valid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isPage2Valid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isPage2Valid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isPage3Valid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isPage3Valid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'initialize',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'initialize'),_class.prototype)),_class);

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SaleEditStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SaleEditStore", function() { return SaleEditStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3;function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var SaleEditStore=(_class=function(){function SaleEditStore(user){_classCallCheck(this,SaleEditStore);_initDefineProp(this,'page',_descriptor,this);_initDefineProp(this,'offerData',_descriptor2,this);_initDefineProp(this,'docs',_descriptor3,this);this.user=null;this.user=user;}_createClass(SaleEditStore,[{key:'initialize',value:function initialize(offerData,docs){this.offerData=Object.assign({},offerData);this.docs=(docs||[]).slice();Object(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["e" /* extendObservable */])(this.offerData,{object_type:offerData.object_type||'',housing_company:offerData.housing_company||'',object_address:offerData.object_address||'',flat_number:offerData.flat_number||'',shares:offerData.shares||'',redemption_clause:offerData.redemption_clause||false,electronic_share:offerData.electronic_share||false,additional_description:offerData.additional_description||'',handover:offerData.handover||''});}},{key:'isPage1Valid',get:function get(){var data=this.offerData;return!!data.object_type&&!!data.housing_company&&!!data.object_address&&!!data.shares;}},{key:'isPage2Valid',get:function get(){return true;}},{key:'isPage3Valid',get:function get(){return true;}}]);return SaleEditStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'page',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return 1;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'offerData',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'docs',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}}),_applyDecoratedDescriptor(_class.prototype,'isPage1Valid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isPage1Valid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isPage2Valid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isPage2Valid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isPage3Valid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isPage3Valid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'initialize',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'initialize'),_class.prototype)),_class);

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SaleEditStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SaleEditStore", function() { return SaleEditStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3;function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var SaleEditStore=(_class=function(){function SaleEditStore(user){_classCallCheck(this,SaleEditStore);_initDefineProp(this,'page',_descriptor,this);_initDefineProp(this,'offerData',_descriptor2,this);_initDefineProp(this,'docs',_descriptor3,this);this.user=null;this.user=user;}_createClass(SaleEditStore,[{key:'initialize',value:function initialize(offerData,docs){this.offerData=Object.assign({},offerData);this.docs=(docs||[]).slice();Object(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["e" /* extendObservable */])(this.offerData,{object_type:offerData.object_type||'',objectno:offerData.objectno||'',object_address:offerData.object_address||''});}},{key:'isPage1Valid',get:function get(){var data=this.offerData;return!!data.object_type&&!!data.object_address;}},{key:'isPage2Valid',get:function get(){return true;}}]);return SaleEditStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'page',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return 1;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'offerData',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'docs',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}}),_applyDecoratedDescriptor(_class.prototype,'isPage1Valid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isPage1Valid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isPage2Valid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isPage2Valid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'initialize',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'initialize'),_class.prototype)),_class);

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SaleEditStore", function() { return SaleEditStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cadastreFields__ = __webpack_require__(163);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3;function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var SaleEditStore=(_class=function(){function SaleEditStore(){_classCallCheck(this,SaleEditStore);_initDefineProp(this,'page',_descriptor,this);_initDefineProp(this,'offerData',_descriptor2,this);_initDefineProp(this,'docs',_descriptor3,this);}_createClass(SaleEditStore,[{key:'initialize',value:function initialize(offerData,docs){this.offerData=Object.assign({},offerData);this.docs=(docs||[]).slice();Object(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["e" /* extendObservable */])(this.offerData,{// Page1
object_type:offerData.object_type||'',object_address_street:offerData.object_address_street||'',object_address_house_number:offerData.object_address_house_number||'',object_address_apartment_number:offerData.object_address_apartment_number||'',object_address_state:offerData.object_address_state||'',object_address_zip:offerData.object_address_zip||'',object_owner:offerData.object_owner||'',object_usage:offerData.object_usage||'',object_composition:offerData.object_composition||'',object_provenance_type:offerData.object_provenance_type||'',object_provenance_date:offerData.object_provenance_date||'',object_provenance_notary:offerData.object_provenance_notary||'',object_provenance_detail:offerData.object_provenance_detail||'',cadastral_municipality:offerData.cadastral_municipality||'',cadastre_urban:offerData.cadastre_urban||Object(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */])([Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_1__cadastreFields__["cadastreUrbanProps"])())]),cadastre_land:offerData.cadastre_land||Object(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */])([]),occupation_type:offerData.occupation_type||'',occupation_rent_name:offerData.occupation_rent_name||'',occupation_rent_amount:offerData.occupation_rent_amount||'',occupation_rent_expiration:offerData.occupation_rent_expiration||'',object_cadastral_compliance:offerData.object_cadastral_compliance||'',object_regulation_compliance:offerData.object_regulation_compliance||'',object_usability_compliance_equiped:offerData.object_usability_compliance_equiped||false,object_usability_compliance_indemnification:offerData.object_usability_compliance_indemnification||false,administration_costs_annual:offerData.administration_costs_annual||0,administration_costs_extra:offerData.administration_costs_extra||0,administration_costs_heating_included:offerData.administration_costs_heating_included||false,seller_notes:offerData.seller_notes||'',debt_type:offerData.debt_type||'none',debt_amount:offerData.debt_amount||'',debt_details:offerData.debt_details||'',// Page2
seller_type:offerData.seller_type||'private',seller_company_name:offerData.seller_company_name||'',seller_vat_id:offerData.seller_company_vat_id||'',seller_firstName:offerData.seller_firstName||'',seller_lastName:offerData.seller_lastName||'',seller_dob:offerData.seller_dob||'',seller_pob:offerData.seller_pob||'',seller_street:offerData.seller_street||'',seller_house_number:offerData.seller_house_number||'',seller_street_additional:offerData.seller_street_additional||'',seller_zip:offerData.seller_zip||'',seller_city:offerData.seller_city||'',seller_country:offerData.seller_country||'Italia',seller_country_code:offerData.seller_country_code||'IT',additional_sellers:offerData.additional_sellers||[],deposit_type:offerData.deposit_type||'',deposit_fixed_amount:offerData.deposit_fixed_amount||'',deposit_percentage:offerData.deposit_percentage||'',tranches:offerData.tranches||Object(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */])([]),handover:offerData.handover||'',due_diligence_deadline_days:offerData.due_diligence_deadline_days||'',court:offerData.court||'',deposit_transfer_iban:offerData.deposit_transfer_iban||'',deposit_transfer_bank:offerData.deposit_transfer_bank||'',deposit_transfer_owner:offerData.deposit_transfer_owner||'',deposit_transfer_duration:offerData.deposit_transfer_duration||7});}},{key:'isPage1Valid',get:function get(){var data=this.offerData;return!!data.object_type&&!!data.object_address;}},{key:'isPage2Valid',get:function get(){// const data = this.offerData;
return true;}},{key:'isPage3Valid',get:function get(){return true;}}]);return SaleEditStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'page',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return 1;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'offerData',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'docs',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}}),_applyDecoratedDescriptor(_class.prototype,'isPage1Valid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isPage1Valid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isPage2Valid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isPage2Valid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isPage3Valid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isPage3Valid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'initialize',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'initialize'),_class.prototype)),_class);

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SaleEditStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SaleEditStore", function() { return SaleEditStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3;function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var SaleEditStore=(_class=function(){function SaleEditStore(){_classCallCheck(this,SaleEditStore);_initDefineProp(this,'page',_descriptor,this);_initDefineProp(this,'offerData',_descriptor2,this);_initDefineProp(this,'docs',_descriptor3,this);}_createClass(SaleEditStore,[{key:'initialize',value:function initialize(offerData,docs){this.offerData=Object.assign({},offerData);this.docs=(docs||[]).slice();Object(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["e" /* extendObservable */])(this.offerData,{object_type:offerData.object_type||'',surface_area:offerData.surface_area||0,objectno:offerData.objectno||'',object_address:offerData.object_address||'',deed1:offerData.deed1||'',ownership:offerData.ownership||'',ownership_share:offerData.ownership_share||'',ownership_total:offerData.ownership_total||'',ubernommene_lasten:offerData.ubernommene_lasten||null,sonstige_gegenleistungen:offerData.sonstige_gegenleistungen||null,additional_sellers:offerData.additional_sellers||[],vat_percentage:offerData.vat_percentage,vat_mandate:offerData.vat_mandate||false,mortgage:offerData.mortgage||null,mortgage_detail:offerData.mortgage_detail||null,mortgage_condition:offerData.mortgage_condition||null,deferred_sale:offerData.deferred_sale||false,handover:offerData.handover||null});}},{key:'isPage1Valid',get:function get(){var data=this.offerData;return!!data.object_type&&!!data.surface_area&&!!data.object_address&&!!data.deed1&&!!data.ownership&&(data.ownership!=='share'||!!data.ownership_share&&!!data.ownership_total);}},{key:'isPage2Valid',get:function get(){var data=this.offerData;var mortgage=data.mortgage;return!!data.handover&&(!mortgage||!!mortgage&&data.mortgage_detail);}},{key:'isPage3Valid',get:function get(){return true;}}]);return SaleEditStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'page',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return 1;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'offerData',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'docs',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}}),_applyDecoratedDescriptor(_class.prototype,'isPage1Valid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isPage1Valid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isPage2Valid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isPage2Valid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isPage3Valid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isPage3Valid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'initialize',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'initialize'),_class.prototype)),_class);

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SaleEditStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SaleEditStore", function() { return SaleEditStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3;function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var SaleEditStore=(_class=function(){function SaleEditStore(user){_classCallCheck(this,SaleEditStore);_initDefineProp(this,'page',_descriptor,this);_initDefineProp(this,'offerData',_descriptor2,this);_initDefineProp(this,'docs',_descriptor3,this);this.user=null;this.user=user;}_createClass(SaleEditStore,[{key:'initialize',value:function initialize(offerData,docs){this.offerData=Object.assign({},offerData);this.docs=(docs||[]).slice();Object(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["e" /* extendObservable */])(this.offerData,{// Page1
object_type:offerData.object_type||'',object_address:offerData.object_address||'',additional_description:offerData.additional_description||'',seller_commission_percentage:offerData.seller_commission_percentage||0,owner_financing_offered:offerData.owner_financing_offered||false,owner_financing_information:offerData.owner_financing_information||''});}},{key:'isPage1Valid',get:function get(){var data=this.offerData;return!!data.object_type&&!!data.object_address;}},{key:'isPage2Valid',get:function get(){return true;}},{key:'isPage3Valid',get:function get(){return true;}}]);return SaleEditStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'page',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return 1;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'offerData',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'docs',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}}),_applyDecoratedDescriptor(_class.prototype,'isPage1Valid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isPage1Valid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isPage2Valid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isPage2Valid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isPage3Valid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isPage3Valid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'initialize',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'initialize'),_class.prototype)),_class);

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SaleEditStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SaleEditStore", function() { return SaleEditStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3;function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var SaleEditStore=(_class=function(){function SaleEditStore(user){_classCallCheck(this,SaleEditStore);_initDefineProp(this,'page',_descriptor,this);_initDefineProp(this,'offerData',_descriptor2,this);_initDefineProp(this,'docs',_descriptor3,this);this.user=null;this.user=user;}_createClass(SaleEditStore,[{key:'initialize',value:function initialize(offerData,docs){this.offerData=Object.assign({},offerData);this.docs=(docs||[]).slice();Object(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["e" /* extendObservable */])(this.offerData,{object_type:offerData.object_type||'',surface_area:offerData.surface_area||'',objectno:offerData.objectno||'',object_address:offerData.object_address||'',deed1:offerData.deed1||'',ownership:offerData.ownership||'',ownership_share:offerData.ownership_share||'',ownership_total:offerData.ownership_total||'',ubernommene_lasten:offerData.ubernommene_lasten||null,sonstige_gegenleistungen:offerData.sonstige_gegenleistungen||null,vat_percentage:offerData.vat_percentage,vat_mandate:offerData.vat_mandate||false,handover:offerData.handover||''});}},{key:'isPage1Valid',get:function get(){var data=this.offerData;return!!data.object_type&&(data.object_type!=='property'||!!data.surface_area)&&!!data.object_address&&!!data.deed1;}},{key:'isPage2Valid',get:function get(){return true;}},{key:'isPage3Valid',get:function get(){return true;}}]);return SaleEditStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'page',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return 1;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'offerData',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'docs',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}}),_applyDecoratedDescriptor(_class.prototype,'isPage1Valid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isPage1Valid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isPage2Valid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isPage2Valid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isPage3Valid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isPage3Valid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'initialize',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'initialize'),_class.prototype)),_class);

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SaleEditStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SaleEditStore", function() { return SaleEditStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3;function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var SaleEditStore=(_class=function(){function SaleEditStore(user){_classCallCheck(this,SaleEditStore);_initDefineProp(this,'page',_descriptor,this);_initDefineProp(this,'offerData',_descriptor2,this);_initDefineProp(this,'docs',_descriptor3,this);this.user=null;this.user=user;}_createClass(SaleEditStore,[{key:'initialize',value:function initialize(offerData,docs){this.offerData=Object.assign({},offerData);this.docs=(docs||[]).slice();Object(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["e" /* extendObservable */])(this.offerData,{// Page1
property_name:offerData.property_name||'',address:offerData.address||'',estate:offerData.estate||'',quarter:offerData.quarter||'',island:offerData.island||'',map_reference:offerData.map_reference||'',tax_parcel_number:offerData.tax_parcel_number||'',additional_description:offerData.additional_description||'',deed_type:offerData.deed_type||'',tenancy_current:offerData.tenancy_current||'',lead_warning_disclosure:offerData.lead_warning_disclosure||false,// Page2
seller_type:offerData.seller_type||'private',seller_company_name:offerData.seller_company_name||'',seller_vat_id:offerData.seller_company_vat_id||'',seller_firstName:offerData.seller_firstName||'',seller_lastName:offerData.seller_lastName||'',seller_dob:offerData.seller_dob||'',seller_pob:offerData.seller_pob||'',seller_street:offerData.seller_street||'',seller_house_number:offerData.seller_house_number||'',seller_street_additional:offerData.seller_street_additional||'',seller_city:offerData.seller_city||'',seller_state:offerData.seller_state||'',seller_zip:offerData.seller_zip||'',seller_country:offerData.seller_country||'U.S. Virgin Islands',seller_country_code:offerData.seller_country_code||'VI',additional_sellers:offerData.additional_sellers||[],proposal_stamp_tax:offerData.proposal_stamp_tax||'',agent_representing:offerData.agent_representing||false,seller_exchange:offerData.seller_exchange||false,closing_location:offerData.closing_location||''});}},{key:'isPage1Valid',get:function get(){var data=this.offerData;return!!data.property_name&&!!data.estate&&!!data.quarter&&!!data.island&&!!data.deed_type&&!!data.tenancy_current;}},{key:'isPage2Valid',get:function get(){return true;}},{key:'isPage3Valid',get:function get(){return true;}}]);return SaleEditStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'page',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return 1;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'offerData',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'docs',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}}),_applyDecoratedDescriptor(_class.prototype,'isPage1Valid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isPage1Valid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isPage2Valid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isPage2Valid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isPage3Valid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isPage3Valid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'initialize',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'initialize'),_class.prototype)),_class);

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SaleEditStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SaleEditStore", function() { return SaleEditStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3;function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var SaleEditStore=(_class=function(){function SaleEditStore(user){_classCallCheck(this,SaleEditStore);_initDefineProp(this,'page',_descriptor,this);_initDefineProp(this,'offerData',_descriptor2,this);_initDefineProp(this,'docs',_descriptor3,this);this.user=null;this.user=user;}_createClass(SaleEditStore,[{key:'initialize',value:function initialize(offerData,docs){this.offerData=Object.assign({},offerData);this.docs=(docs||[]).slice();Object(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["e" /* extendObservable */])(this.offerData,{// Page1
offer_variant:offerData.offer_variant||'residential',title_type:offerData.title_type||'',sales_reference_no:offerData.sales_reference_no||'',listing_no:offerData.listing_no||'',conveyancer_name:offerData.conveyancer_name||'',conveyancer_address:offerData.conveyancer_address||'',conveyancer_account:offerData.conveyancer_account||'',conveyancer_bank:offerData.conveyancer_bank||'',conveyancer_branch:offerData.conveyancer_branch||'',bonded_to:offerData.bonded_to||'',bond_account_number:offerData.bond_account_number||'',object_type:offerData.object_type||'',address:offerData.address||'',title_deed_no:offerData.title_deed_no||'',erf_number:offerData.erf_number||'',township:offerData.township||'',area:offerData.area||'',section_number:offerData.section_number||'',door_number:offerData.door_number||'',scheme_name:offerData.scheme_name||'',sectional_plan_number:offerData.sectional_plan_number||'',sectional_plan_area:offerData.sectional_plan_area||'',parking_bay_number:offerData.parking_bay_number||'',garden_number:offerData.garden_number||'',yard_number:offerData.yard_number||'',balcony_number:offerData.balcony_number||'',utility_room_number:offerData.utility_room_number||'',reservation_of_rights_of_extension:offerData.reservation_of_rights_of_extension||'',fixtures:offerData.fixtures||'',occupation:offerData.occupation||'',existing_tenants:offerData.existing_tenants||'',lease_agreement:offerData.lease_agreement||'',certificates:offerData.certificates||[],// Page2
existing_mandate:offerData.existing_mandate||false,vat_mandate:offerData.vat_mandate||false,vat_percentage:offerData.vat_percentage,surety_required:offerData.surety_required||false,seller_type:offerData.seller_type||'private',seller_company_name:offerData.seller_company_name||'',seller_vat_id:offerData.seller_company_vat_id||'',seller_firstName:offerData.seller_firstName||'',seller_lastName:offerData.seller_lastName||'',seller_personal_id:offerData.seller_personal_id||'',seller_tax_number:offerData.seller_tax_number||'',seller_vat_number:offerData.seller_vat_number||'',seller_company_vat_id:offerData.seller_company_vat_id||'',seller_street:offerData.seller_street||'',seller_email:offerData.seller_email||'',seller_phone_number:offerData.seller_phone_number||'',seller_marital_status:offerData.seller_marital_status||'',seller_marital_status_law:offerData.seller_marital_status_law||'',seller_marital_status_other:offerData.seller_marital_status_other||'',seller_is_resident:offerData.seller_is_resident||false,seller_house_number:offerData.seller_house_number||'',seller_street_additional:offerData.seller_street_additional||'',seller_zip:offerData.seller_zip||'',seller_city:offerData.seller_city||'',seller_country:offerData.seller_country||'South Africa',seller_country_code:offerData.seller_country_code||'ZA',seller_going_concern:offerData.seller_going_concern||false,seller_going_concern_income_earning:offerData.seller_going_concern_income_earning||false,seller_going_concern_separate_operation:offerData.seller_going_concern_separate_operation||false,// pre-populate keys so MobX tracks them on existing additional sellers
additional_sellers:(offerData.additional_sellers||[]).map(function(seller){return Object.assign({seller_tax_number:'',seller_vat_number:''},seller);}),penalty:offerData.penalty||'',handover:offerData.handover||''});}},{key:'isPage1Valid',get:function get(){var data=this.offerData;return!!data.object_type;}},{key:'isPage2Valid',get:function get(){return true;}},{key:'isPage3Valid',get:function get(){return true;}},{key:'isCommercial',get:function get(){return this.offerData.offer_variant==='commercial';}},{key:'isResidential',get:function get(){return this.offerData.offer_variant==='residential';}// VAT section is shown only if a seller has a VAT number. Sales that are
// already VAT-liable keep it visible so the agent can still see/untick it.
},{key:'sellerHasVatNumber',get:function get(){var data=this.offerData;if(data.seller_type==='company'){return!!data.seller_company_vat_id;}return!!data.seller_vat_number||(data.additional_sellers||[]).some(function(s){return!!s.seller_vat_number;});}},{key:'showVatSection',get:function get(){return this.sellerHasVatNumber||!!this.offerData.vat_mandate;}},{key:'showGoingConcernSection',get:function get(){return this.isCommercial&&this.showVatSection&&!!this.offerData.vat_mandate;}},{key:'titleType',get:function get(){if(!!this.offerData.title_type){return this.offerData.title_type;}// full vs. sectional
switch(this.offerData.object_type){case'flat':return'sectional';default:return'full';}}}]);return SaleEditStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'page',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return 1;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'offerData',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'docs',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}}),_applyDecoratedDescriptor(_class.prototype,'isPage1Valid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isPage1Valid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isPage2Valid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isPage2Valid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isPage3Valid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isPage3Valid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isCommercial',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isCommercial'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isResidential',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isResidential'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'sellerHasVatNumber',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'sellerHasVatNumber'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'showVatSection',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'showVatSection'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'showGoingConcernSection',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'showGoingConcernSection'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'titleType',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'titleType'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'initialize',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'initialize'),_class.prototype)),_class);

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SaleEditStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__at_stores__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ch_stores__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__es_stores__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fi_stores__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__gb_stores__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__it_stores__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pr_stores__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__si_stores__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vi_stores__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__za_stores__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lu_stores__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__default_stores__ = __webpack_require__(193);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var SaleEditStore=function(){function SaleEditStore(){_classCallCheck(this,SaleEditStore);throw new Error('Call SaleEditStore.create() instead');}_createClass(SaleEditStore,null,[{key:'create',value:function create(user,offerData,appData){switch((offerData?offerData.sale_country:'')||(appData?appData.sale_country:'')){case'at':return new __WEBPACK_IMPORTED_MODULE_0__at_stores__["SaleEditStore"](user);case'ch':return new __WEBPACK_IMPORTED_MODULE_1__ch_stores__["SaleEditStore"](user);case'es':return new __WEBPACK_IMPORTED_MODULE_2__es_stores__["SaleEditStore"](user);case'fi':return new __WEBPACK_IMPORTED_MODULE_3__fi_stores__["SaleEditStore"](user);case'gb':return new __WEBPACK_IMPORTED_MODULE_4__gb_stores__["SaleEditStore"](user);case'it':return new __WEBPACK_IMPORTED_MODULE_5__it_stores__["SaleEditStore"](user);case'pr':return new __WEBPACK_IMPORTED_MODULE_6__pr_stores__["SaleEditStore"](user);case'si':return new __WEBPACK_IMPORTED_MODULE_7__si_stores__["SaleEditStore"](user);case'vi':return new __WEBPACK_IMPORTED_MODULE_8__vi_stores__["SaleEditStore"](user);case'za':return new __WEBPACK_IMPORTED_MODULE_9__za_stores__["SaleEditStore"](user);case'lu':return new __WEBPACK_IMPORTED_MODULE_10__lu_stores__["SaleEditStore"](user);default:return new __WEBPACK_IMPORTED_MODULE_11__default_stores__["SaleEditStore"](user);}}}]);return SaleEditStore;}();

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__de_json__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__de_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__de_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__de_CH_json__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__de_CH_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__de_CH_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__en_json__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__en_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__en_GB_json__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__en_GB_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__en_GB_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__en_US_json__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__en_US_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__en_US_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__en_ZA_json__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__en_ZA_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__en_ZA_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__es_json__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__es_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__es_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fi_json__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fi_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__fi_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fr_json__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fr_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__fr_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__it_json__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__it_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__it_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__sl_json__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__sl_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__sl_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ro__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ro__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__bhs_en_json__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__bhs_en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__bhs_en_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__vir_en_json__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__vir_en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__vir_en_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pri_en_json__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pri_en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__pri_en_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__zaf_en_json__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__zaf_en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__zaf_en_json__);
var messages={de:__WEBPACK_IMPORTED_MODULE_0__de_json___default.a,en:Object.assign({},__WEBPACK_IMPORTED_MODULE_2__en_json___default.a,__WEBPACK_IMPORTED_MODULE_13__vir_en_json___default.a),// ??
es:__WEBPACK_IMPORTED_MODULE_6__es_json___default.a,fi:__WEBPACK_IMPORTED_MODULE_7__fi_json___default.a,fr:__WEBPACK_IMPORTED_MODULE_8__fr_json___default.a,it:__WEBPACK_IMPORTED_MODULE_9__it_json___default.a,sl:__WEBPACK_IMPORTED_MODULE_10__sl_json___default.a,ro:__WEBPACK_IMPORTED_MODULE_11__ro___default.a,'en-GB':__WEBPACK_IMPORTED_MODULE_3__en_GB_json___default.a,'en-US':__WEBPACK_IMPORTED_MODULE_4__en_US_json___default.a,'en-ZA':Object.assign({},__WEBPACK_IMPORTED_MODULE_5__en_ZA_json___default.a,__WEBPACK_IMPORTED_MODULE_15__zaf_en_json___default.a),'es-ES':__WEBPACK_IMPORTED_MODULE_6__es_json___default.a,'de-CH':__WEBPACK_IMPORTED_MODULE_1__de_CH_json___default.a,'ro-RO':__WEBPACK_IMPORTED_MODULE_11__ro___default.a,'en-PR':Object.assign({},__WEBPACK_IMPORTED_MODULE_4__en_US_json___default.a,__WEBPACK_IMPORTED_MODULE_14__pri_en_json___default.a),'en-BS':Object.assign({},__WEBPACK_IMPORTED_MODULE_4__en_US_json___default.a,__WEBPACK_IMPORTED_MODULE_12__bhs_en_json___default.a)};/* harmony default export */ __webpack_exports__["default"] = ({messages:messages,invariant:'de'});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__de_json__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__de_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__de_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__en_json__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__en_json__);
var messages={de:__WEBPACK_IMPORTED_MODULE_0__de_json___default.a,en:__WEBPACK_IMPORTED_MODULE_1__en_json___default.a};/* harmony default export */ __webpack_exports__["default"] = ({messages:messages,invariant:'de'});

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__de_json__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__de_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__de_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__en_json__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__en_json__);
var messages={de:__WEBPACK_IMPORTED_MODULE_0__de_json___default.a,en:__WEBPACK_IMPORTED_MODULE_1__en_json___default.a};/* harmony default export */ __webpack_exports__["default"] = ({messages:messages,invariant:'de'});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__de_json__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__de_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__de_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__en_json__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__en_json__);
var messages={de:__WEBPACK_IMPORTED_MODULE_0__de_json___default.a,en:__WEBPACK_IMPORTED_MODULE_1__en_json___default.a};/* harmony default export */ __webpack_exports__["default"] = ({messages:messages,invariant:'de'});

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PromptDialog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Dialog__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx_react__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PromptDialog=Object(__WEBPACK_IMPORTED_MODULE_2__Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx_react__["e" /* observer */])(_class=(_temp2=_class2=function(_Component){_inherits(PromptDialog,_Component);function PromptDialog(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PromptDialog);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PromptDialog.__proto__||Object.getPrototypeOf(PromptDialog)).call.apply(_ref,[this].concat(args))),_this),_this.handleSubmit=function(){var onSubmit=_this.props.onSubmit;if(onSubmit){onSubmit();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PromptDialog,[{key:'render',value:function render(){var _props=this.props,onClose=_props.onClose,title=_props.title,message=_props.message,t=_props.t,opened=_props.opened,dialogProps=_props.dialogProps,_props$showPrimaryBut=_props.showPrimaryButton,showPrimaryButton=_props$showPrimaryBut===undefined?true:_props$showPrimaryBut,_props$disablePrimary=_props.disablePrimaryButton,disablePrimaryButton=_props$disablePrimary===undefined?false:_props$disablePrimary,defaultButtonText=_props.defaultButtonText;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Dialog__["a" /* Dialog */],Object.assign({hidden:!opened,onDismiss:onClose,dialogContentProps:{type:__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Dialog__["c" /* DialogType */].largeHeader,title:title,subText:message},modalProps:{titleAriaId:'myLabelId',subtitleAriaId:'mySubTextId',isBlocking:true,containerClassName:'ms-dialogMainOverride'}},dialogProps),this.props.children,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Dialog__["b" /* DialogFooter */],null,showPrimaryButton?__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Button__["h" /* PrimaryButton */],{onClick:this.handleSubmit,text:t('Yes'),disabled:disablePrimaryButton}):null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Button__["f" /* DefaultButton */],{onClick:onClose,text:defaultButtonText||t('No')})));}}]);return PromptDialog;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class2.displayName='PromptDialog',_class2.propTypes={onSubmit:__WEBPACK_IMPORTED_MODULE_1__build_node_modules_prop_types___default.a.func,onClose:__WEBPACK_IMPORTED_MODULE_1__build_node_modules_prop_types___default.a.func,title:__WEBPACK_IMPORTED_MODULE_1__build_node_modules_prop_types___default.a.string.isRequired,message:__WEBPACK_IMPORTED_MODULE_1__build_node_modules_prop_types___default.a.string},_temp2))||_class)||_class;

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__it_json__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__it_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__it_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__en_json__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__en_json__);
var messages={it:__WEBPACK_IMPORTED_MODULE_0__it_json___default.a,en:__WEBPACK_IMPORTED_MODULE_1__en_json___default.a};/* harmony default export */ __webpack_exports__["default"] = ({messages:messages,invariant:'en'});

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__en_json__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__en_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ro_json__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ro_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ro_json__);
var messages={en:__WEBPACK_IMPORTED_MODULE_0__en_json___default.a,ro:__WEBPACK_IMPORTED_MODULE_1__ro_json___default.a};/* harmony default export */ __webpack_exports__["default"] = ({messages:messages,invariant:'en'});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AuctionFinalsMatrix__ = __webpack_require__(2102);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__AuctionFinalsMatrix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuctionFinalsList__ = __webpack_require__(2104);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__AuctionFinalsList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AuctionFinalsTotals__ = __webpack_require__(2106);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__AuctionFinalsTotals__["a"]; });


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(395).Buffer))

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cancelAnimationTimeout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return requestAnimationTimeout; });
/* unused harmony export bpfrpt_proptype_AnimationTimeoutId */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__animationFrame__ = __webpack_require__(2195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);

var bpfrpt_proptype_AnimationTimeoutId =  true ? null : {
  "id": PropTypes.number.isRequired
};
var cancelAnimationTimeout = function cancelAnimationTimeout(frame) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__animationFrame__["a" /* caf */])(frame.id);
};
/**
 * Recursively calls requestAnimationFrame until a specified delay has been met or exceeded.
 * When the delay time has been reached the function you're timing out will be called.
 *
 * Credit: Joe Lambert (https://gist.github.com/joelambert/1002116#file-requesttimeout-js)
 */

var requestAnimationTimeout = function requestAnimationTimeout(callback, delay) {
  var start; // wait for end of processing current event handler, because event handler may be long

  Promise.resolve().then(function () {
    start = Date.now();
  });

  var timeout = function timeout() {
    if (Date.now() - start >= delay) {
      callback.call();
    } else {
      frame.id = Object(__WEBPACK_IMPORTED_MODULE_0__animationFrame__["b" /* raf */])(timeout);
    }
  };

  var frame = {
    id: Object(__WEBPACK_IMPORTED_MODULE_0__animationFrame__["b" /* raf */])(timeout)
  };
  return frame;
};



/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bpfrpt_proptype_CellDataGetterParams */
/* unused harmony export bpfrpt_proptype_CellRendererParams */
/* unused harmony export bpfrpt_proptype_HeaderRowRendererParams */
/* unused harmony export bpfrpt_proptype_HeaderRendererParams */
/* unused harmony export bpfrpt_proptype_RowRendererParams */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var bpfrpt_proptype_CellDataGetterParams =  true ? null : {
  "columnData": PropTypes.any,
  "dataKey": PropTypes.string.isRequired,
  "rowData": function rowData(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `".concat(propName, "` has type 'any' or 'mixed', but was not provided to `").concat(componentName, "`. Pass undefined or any other value."));
    }
  }
};
var bpfrpt_proptype_CellRendererParams =  true ? null : {
  "cellData": PropTypes.any,
  "columnData": PropTypes.any,
  "dataKey": PropTypes.string.isRequired,
  "rowData": function rowData(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `".concat(propName, "` has type 'any' or 'mixed', but was not provided to `").concat(componentName, "`. Pass undefined or any other value."));
    }
  },
  "rowIndex": PropTypes.number.isRequired
};
var bpfrpt_proptype_HeaderRowRendererParams =  true ? null : {
  "className": PropTypes.string.isRequired,
  "columns": PropTypes.arrayOf(function (props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `".concat(propName, "` has type 'any' or 'mixed', but was not provided to `").concat(componentName, "`. Pass undefined or any other value."));
    }
  }).isRequired,
  "style": function style(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `".concat(propName, "` has type 'any' or 'mixed', but was not provided to `").concat(componentName, "`. Pass undefined or any other value."));
    }
  }
};
var bpfrpt_proptype_HeaderRendererParams =  true ? null : {
  "columnData": PropTypes.any,
  "dataKey": PropTypes.string.isRequired,
  "disableSort": PropTypes.bool,
  "label": PropTypes.any,
  "sortBy": PropTypes.string,
  "sortDirection": PropTypes.string
};
var bpfrpt_proptype_RowRendererParams =  true ? null : {
  "className": PropTypes.string.isRequired,
  "columns": PropTypes.arrayOf(function (props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `".concat(propName, "` has type 'any' or 'mixed', but was not provided to `").concat(componentName, "`. Pass undefined or any other value."));
    }
  }).isRequired,
  "index": PropTypes.number.isRequired,
  "isScrolling": PropTypes.bool.isRequired,
  "onRowClick": PropTypes.func,
  "onRowDoubleClick": PropTypes.func,
  "onRowMouseOver": PropTypes.func,
  "onRowMouseOut": PropTypes.func,
  "rowData": function rowData(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `".concat(propName, "` has type 'any' or 'mixed', but was not provided to `").concat(componentName, "`. Pass undefined or any other value."));
    }
  },
  "style": function style(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `".concat(propName, "` has type 'any' or 'mixed', but was not provided to `").concat(componentName, "`. Pass undefined or any other value."));
    }
  },
  "key": PropTypes.string.isRequired
};







/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ComboBox_index__ = __webpack_require__(1820);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_ComboBox_index__["a"]; });

//# sourceMappingURL=ComboBox.js.map

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(64);
var toLength = __webpack_require__(21);
var toAbsoluteIndex = __webpack_require__(127);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 219 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(72);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(73);
var defined = __webpack_require__(93);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(17);
var cof = __webpack_require__(72);
var MATCH = __webpack_require__(20)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(20)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(140);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(514);
var redefine = __webpack_require__(59);
var hide = __webpack_require__(58);
var fails = __webpack_require__(16);
var defined = __webpack_require__(93);
var wks = __webpack_require__(20);
var regexpExec = __webpack_require__(344);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(14);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(14);
var $export = __webpack_require__(3);
var redefine = __webpack_require__(59);
var redefineAll = __webpack_require__(133);
var meta = __webpack_require__(114);
var forOf = __webpack_require__(132);
var anInstance = __webpack_require__(131);
var isObject = __webpack_require__(17);
var fails = __webpack_require__(16);
var $iterDetect = __webpack_require__(223);
var setToStringTag = __webpack_require__(139);
var inheritIfRequired = __webpack_require__(330);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(14);
var hide = __webpack_require__(58);
var uid = __webpack_require__(125);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(113) || !__webpack_require__(16)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(14)[K];
});


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(3);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(3);
var aFunction = __webpack_require__(48);
var ctx = __webpack_require__(71);
var forOf = __webpack_require__(132);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return strUndefined; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return strObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return strPrototype; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return strFunction; });
/* unused harmony export getGlobal */
/* unused harmony export getGlobalInst */
/* unused harmony export hasWindow */
/* harmony export (immutable) */ __webpack_exports__["c"] = getWindow;
/* unused harmony export hasDocument */
/* harmony export (immutable) */ __webpack_exports__["a"] = getDocument;
/* unused harmony export hasNavigator */
/* unused harmony export getNavigator */
/* unused harmony export hasHistory */
/* unused harmony export getHistory */
/* unused harmony export getLocation */
/* unused harmony export getPerformance */
/* harmony export (immutable) */ __webpack_exports__["d"] = hasJSON;
/* harmony export (immutable) */ __webpack_exports__["b"] = getJSON;
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

/**
 * This file exists to hold environment utilities that are requied to check and
 * validate the current operating environment. Unless otherwise required, please
 * only defined methods (functions) in this class so that users of these
 * functions/properties only need to include those that are used within their own modules.
 */
var strUndefined = "undefined";
var strObject = "object";
var strPrototype = "prototype";
var strFunction = "function";
var strWindow = "window";
var strDocument = "document";
var strNavigator = "navigator";
var strHistory = "history";
var strLocation = "location";
var strPerformance = "performance";
var strJSON = "JSON";
/**
 * Returns the current global scope object, for a normal web page this will be the current
 * window, for a Web Worker this will be current worker global scope via "self". The internal
 * implementation returns the first available instance object in the following order
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS standard)
 * - <null> (When all else fails)
 * While the return type is a Window for the normal case, not all environments will support all
 * of the properties or functions.
 */
function getGlobal() {
    if (typeof globalThis !== strUndefined && globalThis) {
        return globalThis;
    }
    if (typeof self !== strUndefined && self) {
        return self;
    }
    if (typeof window !== strUndefined && window) {
        return window;
    }
    if (typeof global !== strUndefined && global) {
        return global;
    }
    return null;
}
/**
 * Return the named global object if available, will return null if the object is not available.
 * @param name The globally named object
 */
function getGlobalInst(name) {
    var gbl = getGlobal();
    if (gbl && gbl[name]) {
        return gbl[name];
    }
    // Test workaround, for environments where <global>.window (when global == window) doesn't return the base window
    if (name === strWindow && hasWindow()) {
        // tslint:disable-next-line: no-angle-bracket-type-assertion
        return window;
    }
    return null;
}
/**
 * Checks if window object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a window
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: window is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasWindow() {
    return Boolean(typeof window === strObject && window);
}
/**
 * Returns the global window object if it is present otherwise null.
 * This helper is used to access the window object without causing an exception
 * "Uncaught ReferenceError: window is not defined"
 */
function getWindow() {
    if (hasWindow()) {
        return window;
    }
    // Return the global instance or null
    return getGlobalInst(strWindow);
}
/**
 * Checks if document object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a document
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: document is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasDocument() {
    return Boolean(typeof document === strObject && document);
}
/**
 * Returns the global document object if it is present otherwise null.
 * This helper is used to access the document object without causing an exception
 * "Uncaught ReferenceError: document is not defined"
 */
function getDocument() {
    if (hasDocument()) {
        return document;
    }
    return getGlobalInst(strDocument);
}
/**
 * Checks if navigator object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a navigator
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: navigator is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasNavigator() {
    return Boolean(typeof navigator === strObject && navigator);
}
/**
 * Returns the global navigator object if it is present otherwise null.
 * This helper is used to access the navigator object without causing an exception
 * "Uncaught ReferenceError: navigator is not defined"
 */
function getNavigator() {
    if (hasNavigator()) {
        return navigator;
    }
    return getGlobalInst(strNavigator);
}
/**
 * Checks if history object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a history
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: history is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasHistory() {
    return Boolean(typeof history === strObject && history);
}
/**
 * Returns the global history object if it is present otherwise null.
 * This helper is used to access the history object without causing an exception
 * "Uncaught ReferenceError: history is not defined"
 */
function getHistory() {
    if (hasHistory()) {
        return history;
    }
    return getGlobalInst(strHistory);
}
/**
 * Returns the global location object if it is present otherwise null.
 * This helper is used to access the location object without causing an exception
 * "Uncaught ReferenceError: location is not defined"
 */
function getLocation() {
    if (typeof location === strObject && location) {
        return location;
    }
    return getGlobalInst(strLocation);
}
/**
 * Returns the performance object if it is present otherwise null.
 * This helper is used to access the performance object from the current
 * global instance which could be window or globalThis for a web worker
 */
function getPerformance() {
    return getGlobalInst(strPerformance);
}
/**
 * Checks if JSON object is available, this is required as we support the API running without a
 * window /document (eg. Node server, electron webworkers) and if we attempt to assign a history
 * object to a local variable or pass as an argument an "Uncaught ReferenceError: JSON is not defined"
 * exception will be thrown.
 * Defined as a function to support lazy / late binding environments.
 */
function hasJSON() {
    return Boolean((typeof JSON === strObject && JSON) || getGlobalInst(strJSON) !== null);
}
/**
 * Returns the global JSON object if it is present otherwise null.
 * This helper is used to access the JSON object without causing an exception
 * "Uncaught ReferenceError: JSON is not defined"
 */
function getJSON() {
    if (hasJSON()) {
        return JSON || getGlobalInst(strJSON);
    }
    return null;
}
//# sourceMappingURL=EnvUtils.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(33)))

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProcessTelemetryContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CoreUtils__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DiagnosticLogger__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TelemetryPluginChain__ = __webpack_require__(1374);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.




var _isNullOrUndefined = __WEBPACK_IMPORTED_MODULE_0__CoreUtils__["a" /* CoreUtils */].isNullOrUndefined;
/**
 * Creates the instance execution chain for the plugins
 */
function _createProxyChain(plugins, itemCtx) {
    var proxies = [];
    if (plugins && plugins.length > 0) {
        // Create the proxies and wire up the next plugin chain
        var lastProxy = null;
        for (var idx = 0; idx < plugins.length; idx++) {
            var thePlugin = plugins[idx];
            if (thePlugin && __WEBPACK_IMPORTED_MODULE_0__CoreUtils__["a" /* CoreUtils */].isFunction(thePlugin.processTelemetry)) {
                // Only add plugins that are processors
                var newProxy = new __WEBPACK_IMPORTED_MODULE_2__TelemetryPluginChain__["a" /* TelemetryPluginChain */](thePlugin, itemCtx);
                proxies.push(newProxy);
                if (lastProxy) {
                    // Set this new proxy as the next for the previous one
                    lastProxy.setNext(newProxy);
                }
                lastProxy = newProxy;
            }
        }
    }
    return proxies.length > 0 ? proxies[0] : null;
}
function _copyProxyChain(proxy, itemCtx, startAt) {
    var plugins = [];
    var add = startAt ? false : true;
    if (proxy) {
        while (proxy) {
            var thePlugin = proxy.getPlugin();
            if (add || thePlugin === startAt) {
                add = true;
                plugins.push(thePlugin);
            }
            proxy = proxy.getNext();
        }
    }
    if (!add) {
        plugins.push(startAt);
    }
    return _createProxyChain(plugins, itemCtx);
}
function _copyPluginChain(srcPlugins, itemCtx, startAt) {
    var plugins = srcPlugins;
    var add = false;
    if (startAt && srcPlugins) {
        plugins = [];
        __WEBPACK_IMPORTED_MODULE_0__CoreUtils__["a" /* CoreUtils */].arrForEach(srcPlugins, function (thePlugin) {
            if (add || thePlugin === startAt) {
                add = true;
                plugins.push(thePlugin);
            }
        });
    }
    if (startAt && !add) {
        if (!plugins) {
            plugins = [];
        }
        plugins.push(startAt);
    }
    return _createProxyChain(plugins, itemCtx);
}
var ProcessTelemetryContext = /** @class */ (function () {
    /**
     * Creates a new Telemetry Item context with the current config, core and plugin execution chain
     * @param plugins - The plugin instances that will be executed
     * @param config - The current config
     * @param core - The current core instance
     */
    function ProcessTelemetryContext(plugins, config, core, startAt) {
        var _self = this;
        var _nextProxy = null; // Null == No next plugin
        // There is no next element (null) vs not defined (undefined)
        if (startAt !== null) {
            if (plugins && __WEBPACK_IMPORTED_MODULE_0__CoreUtils__["a" /* CoreUtils */].isFunction(plugins.getPlugin)) {
                // We have a proxy chain object
                _nextProxy = _copyProxyChain(plugins, _self, startAt || plugins.getPlugin());
            }
            else {
                // We just have an array
                if (startAt) {
                    _nextProxy = _copyPluginChain(plugins, _self, startAt);
                }
                else if (__WEBPACK_IMPORTED_MODULE_0__CoreUtils__["a" /* CoreUtils */].isUndefined(startAt)) {
                    // Undefined means copy the existing chain
                    _nextProxy = _createProxyChain(plugins, _self);
                }
            }
        }
        _self.core = function () {
            return core;
        };
        _self.diagLog = function () {
            var logger = (core || {}).logger;
            if (!logger) {
                // Fallback so we always have a logger
                logger = new __WEBPACK_IMPORTED_MODULE_1__DiagnosticLogger__["a" /* DiagnosticLogger */](config || {});
            }
            return logger;
        };
        _self.getCfg = function () {
            return config;
        };
        _self.getExtCfg = function (identifier, defaultValue) {
            if (defaultValue === void 0) { defaultValue = {}; }
            var theConfig;
            if (config) {
                var extConfig = config.extensionConfig;
                if (extConfig && identifier) {
                    theConfig = extConfig[identifier];
                }
            }
            return (theConfig ? theConfig : defaultValue);
        };
        _self.getConfig = function (identifier, field, defaultValue) {
            if (defaultValue === void 0) { defaultValue = false; }
            var theValue;
            var extConfig = _self.getExtCfg(identifier, null);
            if (extConfig && !_isNullOrUndefined(extConfig[field])) {
                theValue = extConfig[field];
            }
            else if (config && !_isNullOrUndefined(config[field])) {
                theValue = config[field];
            }
            return !_isNullOrUndefined(theValue) ? theValue : defaultValue;
        };
        _self.hasNext = function () {
            return _nextProxy != null;
        };
        _self.getNext = function () {
            return _nextProxy;
        };
        _self.setNext = function (nextPlugin) {
            _nextProxy = nextPlugin;
        };
        _self.processNext = function (env) {
            var nextPlugin = _nextProxy;
            if (nextPlugin) {
                // Automatically move to the next plugin
                _nextProxy = nextPlugin.getNext();
                nextPlugin.processTelemetry(env, _self);
            }
        };
        _self.createNew = function (plugins, startAt) {
            if (plugins === void 0) { plugins = null; }
            return new ProcessTelemetryContext(plugins || _nextProxy, config, core, startAt);
        };
    }
    return ProcessTelemetryContext;
}());

//# sourceMappingURL=ProcessTelemetryContext.js.map

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return strShimFunction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return strShimObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return strShimUndefined; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return strShimPrototype; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return strShimHasOwnProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return strDefault; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ObjClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ObjProto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ObjAssign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ObjCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ObjDefineProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ObjHasOwnProperty; });
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var strShimFunction = "function";
var strShimObject = "object";
var strShimUndefined = "undefined";
var strShimPrototype = "prototype";
var strShimHasOwnProperty = "hasOwnProperty";
var strDefault = "default";
var ObjClass = Object;
var ObjProto = ObjClass[strShimPrototype];
var ObjAssign = ObjClass["assign"];
var ObjCreate = ObjClass["create"];
var ObjDefineProperty = ObjClass["defineProperty"];
var ObjHasOwnProperty = ObjProto[strShimHasOwnProperty];
//# sourceMappingURL=Constants.js.map

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProcessTelemetryContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DiagnosticLogger__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TelemetryPluginChain__ = __webpack_require__(1382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__ = __webpack_require__(40);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






/**
 * Creates the instance execution chain for the plugins
 */
function _createProxyChain(plugins, itemCtx) {
    var proxies = [];
    if (plugins && plugins.length > 0) {
        // Create the proxies and wire up the next plugin chain
        var lastProxy = null;
        for (var idx = 0; idx < plugins.length; idx++) {
            var thePlugin = plugins[idx];
            if (thePlugin && Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["p" /* isFunction */])(thePlugin.processTelemetry)) {
                // Only add plugins that are processors
                var newProxy = new __WEBPACK_IMPORTED_MODULE_1__TelemetryPluginChain__["a" /* TelemetryPluginChain */](thePlugin, itemCtx);
                proxies.push(newProxy);
                if (lastProxy) {
                    // Set this new proxy as the next for the previous one
                    lastProxy.setNext(newProxy);
                }
                lastProxy = newProxy;
            }
        }
    }
    return proxies.length > 0 ? proxies[0] : null;
}
function _copyProxyChain(proxy, itemCtx, startAt) {
    var plugins = [];
    var add = startAt ? false : true;
    if (proxy) {
        while (proxy) {
            var thePlugin = proxy.getPlugin();
            if (add || thePlugin === startAt) {
                add = true;
                plugins.push(thePlugin);
            }
            proxy = proxy.getNext();
        }
    }
    if (!add) {
        plugins.push(startAt);
    }
    return _createProxyChain(plugins, itemCtx);
}
function _copyPluginChain(srcPlugins, itemCtx, startAt) {
    var plugins = srcPlugins;
    var add = false;
    if (startAt && srcPlugins) {
        plugins = [];
        Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["a" /* arrForEach */])(srcPlugins, function (thePlugin) {
            if (add || thePlugin === startAt) {
                add = true;
                plugins.push(thePlugin);
            }
        });
    }
    if (startAt && !add) {
        if (!plugins) {
            plugins = [];
        }
        plugins.push(startAt);
    }
    return _createProxyChain(plugins, itemCtx);
}
var ProcessTelemetryContext = /** @class */ (function () {
    /**
     * Creates a new Telemetry Item context with the current config, core and plugin execution chain
     * @param plugins - The plugin instances that will be executed
     * @param config - The current config
     * @param core - The current core instance
     */
    function ProcessTelemetryContext(plugins, config, core, startAt) {
        var _self = this;
        var _nextProxy = null; // Null == No next plugin
        // There is no next element (null) vs not defined (undefined)
        if (startAt !== null) {
            if (plugins && Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["p" /* isFunction */])(plugins.getPlugin)) {
                // We have a proxy chain object
                _nextProxy = _copyProxyChain(plugins, _self, startAt || plugins.getPlugin());
            }
            else {
                // We just have an array
                if (startAt) {
                    _nextProxy = _copyPluginChain(plugins, _self, startAt);
                }
                else if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */])(startAt)) {
                    // Undefined means copy the existing chain
                    _nextProxy = _createProxyChain(plugins, _self);
                }
            }
        }
        _self.core = function () {
            return core;
        };
        _self.diagLog = function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__DiagnosticLogger__["c" /* safeGetLogger */])(core, config);
        };
        _self.getCfg = function () {
            return config;
        };
        _self.getExtCfg = function (identifier, defaultValue) {
            if (defaultValue === void 0) { defaultValue = {}; }
            var theConfig;
            if (config) {
                var extConfig = config.extensionConfig;
                if (extConfig && identifier) {
                    theConfig = extConfig[identifier];
                }
            }
            return (theConfig ? theConfig : defaultValue);
        };
        _self.getConfig = function (identifier, field, defaultValue) {
            if (defaultValue === void 0) { defaultValue = false; }
            var theValue;
            var extConfig = _self.getExtCfg(identifier, null);
            if (extConfig && !Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */])(extConfig[field])) {
                theValue = extConfig[field];
            }
            else if (config && !Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */])(config[field])) {
                theValue = config[field];
            }
            return !Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */])(theValue) ? theValue : defaultValue;
        };
        _self.hasNext = function () {
            return _nextProxy != null;
        };
        _self.getNext = function () {
            return _nextProxy;
        };
        _self.setNext = function (nextPlugin) {
            _nextProxy = nextPlugin;
        };
        _self.processNext = function (env) {
            var nextPlugin = _nextProxy;
            if (nextPlugin) {
                // Automatically move to the next plugin
                _nextProxy = nextPlugin.getNext();
                nextPlugin.processTelemetry(env, _self);
            }
        };
        _self.createNew = function (plugins, startAt) {
            if (plugins === void 0) { plugins = null; }
            return new ProcessTelemetryContext(plugins || _nextProxy, config, core, startAt);
        };
    }
    return ProcessTelemetryContext;
}());

//# sourceMappingURL=ProcessTelemetryContext.js.map

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoggingSeverity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _InternalMessageId; });
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var LoggingSeverity;
(function (LoggingSeverity) {
    /**
     * Error will be sent as internal telemetry
     */
    LoggingSeverity[LoggingSeverity["CRITICAL"] = 1] = "CRITICAL";
    /**
     * Error will NOT be sent as internal telemetry, and will only be shown in browser console
     */
    LoggingSeverity[LoggingSeverity["WARNING"] = 2] = "WARNING";
})(LoggingSeverity || (LoggingSeverity = {}));
/**
 * Internal message ID. Please create a new one for every conceptually different message. Please keep alphabetically ordered
 */
var _InternalMessageId = {
    // Non user actionable
    BrowserDoesNotSupportLocalStorage: 0,
    BrowserCannotReadLocalStorage: 1,
    BrowserCannotReadSessionStorage: 2,
    BrowserCannotWriteLocalStorage: 3,
    BrowserCannotWriteSessionStorage: 4,
    BrowserFailedRemovalFromLocalStorage: 5,
    BrowserFailedRemovalFromSessionStorage: 6,
    CannotSendEmptyTelemetry: 7,
    ClientPerformanceMathError: 8,
    ErrorParsingAISessionCookie: 9,
    ErrorPVCalc: 10,
    ExceptionWhileLoggingError: 11,
    FailedAddingTelemetryToBuffer: 12,
    FailedMonitorAjaxAbort: 13,
    FailedMonitorAjaxDur: 14,
    FailedMonitorAjaxOpen: 15,
    FailedMonitorAjaxRSC: 16,
    FailedMonitorAjaxSend: 17,
    FailedMonitorAjaxGetCorrelationHeader: 18,
    FailedToAddHandlerForOnBeforeUnload: 19,
    FailedToSendQueuedTelemetry: 20,
    FailedToReportDataLoss: 21,
    FlushFailed: 22,
    MessageLimitPerPVExceeded: 23,
    MissingRequiredFieldSpecification: 24,
    NavigationTimingNotSupported: 25,
    OnError: 26,
    SessionRenewalDateIsZero: 27,
    SenderNotInitialized: 28,
    StartTrackEventFailed: 29,
    StopTrackEventFailed: 30,
    StartTrackFailed: 31,
    StopTrackFailed: 32,
    TelemetrySampledAndNotSent: 33,
    TrackEventFailed: 34,
    TrackExceptionFailed: 35,
    TrackMetricFailed: 36,
    TrackPVFailed: 37,
    TrackPVFailedCalc: 38,
    TrackTraceFailed: 39,
    TransmissionFailed: 40,
    FailedToSetStorageBuffer: 41,
    FailedToRestoreStorageBuffer: 42,
    InvalidBackendResponse: 43,
    FailedToFixDepricatedValues: 44,
    InvalidDurationValue: 45,
    TelemetryEnvelopeInvalid: 46,
    CreateEnvelopeError: 47,
    // User actionable
    CannotSerializeObject: 48,
    CannotSerializeObjectNonSerializable: 49,
    CircularReferenceDetected: 50,
    ClearAuthContextFailed: 51,
    ExceptionTruncated: 52,
    IllegalCharsInName: 53,
    ItemNotInArray: 54,
    MaxAjaxPerPVExceeded: 55,
    MessageTruncated: 56,
    NameTooLong: 57,
    SampleRateOutOfRange: 58,
    SetAuthContextFailed: 59,
    SetAuthContextFailedAccountName: 60,
    StringValueTooLong: 61,
    StartCalledMoreThanOnce: 62,
    StopCalledWithoutStart: 63,
    TelemetryInitializerFailed: 64,
    TrackArgumentsNotSpecified: 65,
    UrlTooLong: 66,
    SessionStorageBufferFull: 67,
    CannotAccessCookie: 68,
    IdTooLong: 69,
    InvalidEvent: 70,
    FailedMonitorAjaxSetRequestHeader: 71,
    SendBrowserInfoOnUserInit: 72,
    PluginException: 73,
    NotificationException: 74,
    SnippetScriptLoadFailure: 99,
    InvalidInstrumentationKey: 100,
    CannotParseAiBlobValue: 101,
    InvalidContentBlob: 102,
    TrackPageActionEventFailed: 103
};
//# sourceMappingURL=LoggingEnums.js.map

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PerfEvent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PerfManager; });
/* harmony export (immutable) */ __webpack_exports__["b"] = doPerf;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HelperFuncs__ = __webpack_require__(40);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var strExecutionContextKey = "ctx";
var PerfEvent = /** @class */ (function () {
    function PerfEvent(name, payloadDetails, isAsync) {
        var _self = this;
        var accessorDefined = false;
        _self.start = Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["g" /* dateNow */])();
        _self.name = name;
        _self.isAsync = isAsync;
        _self.isChildEvt = function () { return false; };
        if (Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["p" /* isFunction */])(payloadDetails)) {
            // Create an accessor to minimize the potential performance impact of executing the payloadDetails callback
            var theDetails_1;
            accessorDefined = Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["z" /* objDefineAccessors */])(_self, 'payload', function () {
                // Delay the execution of the payloadDetails until needed
                if (!theDetails_1 && Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["p" /* isFunction */])(payloadDetails)) {
                    theDetails_1 = payloadDetails();
                    // clear it out now so the referenced objects can be garbage collected
                    payloadDetails = null;
                }
                return theDetails_1;
            });
        }
        _self.getCtx = function (key) {
            if (key) {
                // The parent and child links are located directly on the object (for better viewing in the DebugPlugin)
                if (key === PerfEvent.ParentContextKey || key === PerfEvent.ChildrenContextKey) {
                    return _self[key];
                }
                return (_self[strExecutionContextKey] || {})[key];
            }
            return null;
        };
        _self.setCtx = function (key, value) {
            if (key) {
                // Put the parent and child links directly on the object (for better viewing in the DebugPlugin)
                if (key === PerfEvent.ParentContextKey) {
                    // Simple assumption, if we are setting a parent then we must be a child
                    if (!_self[key]) {
                        _self.isChildEvt = function () { return true; };
                    }
                    _self[key] = value;
                }
                else if (key === PerfEvent.ChildrenContextKey) {
                    _self[key] = value;
                }
                else {
                    var ctx = _self[strExecutionContextKey] = _self[strExecutionContextKey] || {};
                    ctx[key] = value;
                }
            }
        };
        _self.complete = function () {
            var childTime = 0;
            var childEvts = _self.getCtx(PerfEvent.ChildrenContextKey);
            if (Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["l" /* isArray */])(childEvts)) {
                for (var lp = 0; lp < childEvts.length; lp++) {
                    var childEvt = childEvts[lp];
                    if (childEvt) {
                        childTime += childEvt.time;
                    }
                }
            }
            _self.time = Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["g" /* dateNow */])() - _self.start;
            _self.exTime = _self.time - childTime;
            _self.complete = function () { };
            if (!accessorDefined && Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["p" /* isFunction */])(payloadDetails)) {
                // If we couldn't define the property set during complete -- to minimize the perf impact until after the time
                _self.payload = payloadDetails();
            }
        };
    }
    PerfEvent.ParentContextKey = "parent";
    PerfEvent.ChildrenContextKey = "childEvts";
    return PerfEvent;
}());

var PerfManager = /** @class */ (function () {
    function PerfManager(manager) {
        /**
         * General bucket used for execution context set and retrieved via setCtx() and getCtx.
         * Defined as private so it can be visualized via the DebugPlugin
         */
        this.ctx = {};
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__["a" /* default */])(PerfManager, this, function (_self) {
            _self.create = function (src, payloadDetails, isAsync) {
                // TODO (@MSNev): at some point we will want to add additional configuration to "select" which events to instrument
                // for now this is just a simple do everything.
                return new PerfEvent(src, payloadDetails, isAsync);
            };
            _self.fire = function (perfEvent) {
                if (perfEvent) {
                    perfEvent.complete();
                    if (manager) {
                        manager.perfEvent(perfEvent);
                    }
                }
            };
            _self.setCtx = function (key, value) {
                if (key) {
                    var ctx = _self[strExecutionContextKey] = _self[strExecutionContextKey] || {};
                    ctx[key] = value;
                }
            };
            _self.getCtx = function (key) {
                return (_self[strExecutionContextKey] || {})[key];
            };
        });
    }
// Removed Stub for PerfManager.prototype.create.
// Removed Stub for PerfManager.prototype.fire.
// Removed Stub for PerfManager.prototype.setCtx.
// Removed Stub for PerfManager.prototype.getCtx.
    return PerfManager;
}());

var doPerfActiveKey = "CoreUtils.doPerf";
/**
 * Helper function to wrap a function with a perf event
 * @param mgrSource - The Performance Manager or a Performance provider source (may be null)
 * @param getSource - The callback to create the source name for the event (if perf monitoring is enabled)
 * @param func - The function to call and measure
 * @param details - A function to return the payload details
 * @param isAsync - Is the event / function being call asynchronously or synchronously
 */
function doPerf(mgrSource, getSource, func, details, isAsync) {
    if (mgrSource) {
        var perfMgr = mgrSource;
        if (perfMgr && Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["p" /* isFunction */])(perfMgr["getPerfMgr"])) {
            // Looks like a perf manager provider object
            perfMgr = perfMgr["getPerfMgr"]();
        }
        if (perfMgr) {
            var perfEvt = void 0;
            var currentActive = perfMgr.getCtx(doPerfActiveKey);
            try {
                perfEvt = perfMgr.create(getSource(), details, isAsync);
                if (perfEvt) {
                    if (currentActive && perfEvt.setCtx) {
                        perfEvt.setCtx(PerfEvent.ParentContextKey, currentActive);
                        if (currentActive.getCtx && currentActive.setCtx) {
                            var children = currentActive.getCtx(PerfEvent.ChildrenContextKey);
                            if (!children) {
                                children = [];
                                currentActive.setCtx(PerfEvent.ChildrenContextKey, children);
                            }
                            children.push(perfEvt);
                        }
                    }
                    // Set this event as the active event now
                    perfMgr.setCtx(doPerfActiveKey, perfEvt);
                    return func(perfEvt);
                }
            }
            catch (ex) {
                if (perfEvt && perfEvt.setCtx) {
                    perfEvt.setCtx("exception", ex);
                }
            }
            finally {
                // fire the perf event
                if (perfEvt) {
                    perfMgr.fire(perfEvt);
                }
                // Reset the active event to the previous value
                perfMgr.setCtx(doPerfActiveKey, currentActive);
            }
        }
    }
    return func();
}
//# sourceMappingURL=PerfManager.js.map

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PropertiesPluginIdentifier; });
/* unused harmony export BreezeChannelIdentifier */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnalyticsPluginIdentifier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Util__ = __webpack_require__(546);
/* unused harmony reexport Util */
/* unused harmony reexport CorrelationIdHelper */
/* unused harmony reexport DateTimeUtils */
/* unused harmony reexport dateTimeUtilsNow */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_0__Util__["b"]; });
/* unused harmony reexport UrlHelper */
/* unused harmony reexport isInternalApplicationInsightsEndpoint */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConnectionStringParser__ = __webpack_require__(1392);
/* unused harmony reexport parseConnectionString */
/* unused harmony reexport ConnectionStringParser */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RequestResponseHeaders__ = __webpack_require__(552);
/* unused harmony reexport RequestHeaders */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Constants__ = __webpack_require__(77);
/* unused harmony reexport DisabledPropertyName */
/* unused harmony reexport ProcessLegacy */
/* unused harmony reexport SampleRate */
/* unused harmony reexport HttpMethod */
/* unused harmony reexport DEFAULT_BREEZE_ENDPOINT */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_3__Constants__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Interfaces_Contracts_Generated_Data__ = __webpack_require__(557);
/* unused harmony reexport AIData */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Interfaces_Contracts_Generated_Base__ = __webpack_require__(558);
/* unused harmony reexport AIBase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Telemetry_Common_Envelope__ = __webpack_require__(1393);
/* unused harmony reexport Envelope */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Telemetry_Event__ = __webpack_require__(1395);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__Telemetry_Event__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Telemetry_Exception__ = __webpack_require__(1396);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_8__Telemetry_Exception__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Telemetry_Metric__ = __webpack_require__(1400);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_9__Telemetry_Metric__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Telemetry_PageView__ = __webpack_require__(1405);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_10__Telemetry_PageView__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Interfaces_Contracts_Generated_PageViewData__ = __webpack_require__(364);
/* unused harmony reexport PageViewData */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Telemetry_RemoteDependencyData__ = __webpack_require__(1406);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_12__Telemetry_RemoteDependencyData__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Telemetry_Trace__ = __webpack_require__(1408);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_13__Telemetry_Trace__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Telemetry_PageViewPerformance__ = __webpack_require__(1410);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_14__Telemetry_PageViewPerformance__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Telemetry_Common_Data__ = __webpack_require__(1412);
/* unused harmony reexport Data */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Interfaces_Contracts_Generated_SeverityLevel__ = __webpack_require__(1413);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_16__Interfaces_Contracts_Generated_SeverityLevel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Interfaces_IConfig__ = __webpack_require__(1414);
/* unused harmony reexport ConfigurationManager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Interfaces_Contracts_Generated_ContextTagKeys__ = __webpack_require__(560);
/* unused harmony reexport ContextTagKeys */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Telemetry_Common_DataSanitizer__ = __webpack_require__(76);
/* unused harmony reexport DataSanitizer */
/* unused harmony reexport dataSanitizeKeyAndAddUniqueness */
/* unused harmony reexport dataSanitizeKey */
/* unused harmony reexport dataSanitizeString */
/* unused harmony reexport dataSanitizeUrl */
/* unused harmony reexport dataSanitizeMessage */
/* unused harmony reexport dataSanitizeException */
/* unused harmony reexport dataSanitizeProperties */
/* unused harmony reexport dataSanitizeMeasurements */
/* unused harmony reexport dataSanitizeId */
/* unused harmony reexport dataSanitizeInput */
/* unused harmony reexport dsPadNumber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__TelemetryItemCreator__ = __webpack_require__(1415);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_20__TelemetryItemCreator__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Interfaces_PartAExtensions__ = __webpack_require__(1416);
/* unused harmony reexport CtxTagKeys */
/* unused harmony reexport Extensions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Enums__ = __webpack_require__(555);
/* unused harmony reexport DistributedTracingModes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__HelperFuncs__ = __webpack_require__(242);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_23__HelperFuncs__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_23__HelperFuncs__["d"]; });
/* unused harmony reexport isBeaconApiSupported */
/* unused harmony reexport getExtensionByName */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_23__HelperFuncs__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__DomHelperFuncs__ = __webpack_require__(553);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_24__DomHelperFuncs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__StorageHelperFuncs__ = __webpack_require__(554);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_25__StorageHelperFuncs__["c"]; });
/* unused harmony reexport utlCanUseLocalStorage */
/* unused harmony reexport utlGetLocalStorage */
/* unused harmony reexport utlSetLocalStorage */
/* unused harmony reexport utlRemoveStorage */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_25__StorageHelperFuncs__["b"]; });
/* unused harmony reexport utlGetSessionStorageKeys */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_25__StorageHelperFuncs__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_25__StorageHelperFuncs__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_25__StorageHelperFuncs__["g"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__UrlHelperFuncs__ = __webpack_require__(556);
/* unused harmony reexport urlParseUrl */
/* unused harmony reexport urlGetAbsoluteUrl */
/* unused harmony reexport urlGetPathName */
/* unused harmony reexport urlGetCompleteUrl */
/* unused harmony reexport urlParseHost */
/* unused harmony reexport urlParseFullHost */
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





























var PropertiesPluginIdentifier = "AppInsightsPropertiesPlugin";
var BreezeChannelIdentifier = "AppInsightsChannelPlugin";
var AnalyticsPluginIdentifier = "ApplicationInsightsAnalytics";
//# sourceMappingURL=applicationinsights-common.js.map

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProcessTelemetryContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DiagnosticLogger__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TelemetryPluginChain__ = __webpack_require__(1389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__ = __webpack_require__(42);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






/**
 * Creates the instance execution chain for the plugins
 */
function _createProxyChain(plugins, itemCtx) {
    var proxies = [];
    if (plugins && plugins.length > 0) {
        // Create the proxies and wire up the next plugin chain
        var lastProxy = null;
        for (var idx = 0; idx < plugins.length; idx++) {
            var thePlugin = plugins[idx];
            if (thePlugin && Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["p" /* isFunction */])(thePlugin.processTelemetry)) {
                // Only add plugins that are processors
                var newProxy = new __WEBPACK_IMPORTED_MODULE_1__TelemetryPluginChain__["a" /* TelemetryPluginChain */](thePlugin, itemCtx);
                proxies.push(newProxy);
                if (lastProxy) {
                    // Set this new proxy as the next for the previous one
                    lastProxy.setNext(newProxy);
                }
                lastProxy = newProxy;
            }
        }
    }
    return proxies.length > 0 ? proxies[0] : null;
}
function _copyProxyChain(proxy, itemCtx, startAt) {
    var plugins = [];
    var add = startAt ? false : true;
    if (proxy) {
        while (proxy) {
            var thePlugin = proxy.getPlugin();
            if (add || thePlugin === startAt) {
                add = true;
                plugins.push(thePlugin);
            }
            proxy = proxy.getNext();
        }
    }
    if (!add) {
        plugins.push(startAt);
    }
    return _createProxyChain(plugins, itemCtx);
}
function _copyPluginChain(srcPlugins, itemCtx, startAt) {
    var plugins = srcPlugins;
    var add = false;
    if (startAt && srcPlugins) {
        plugins = [];
        Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["a" /* arrForEach */])(srcPlugins, function (thePlugin) {
            if (add || thePlugin === startAt) {
                add = true;
                plugins.push(thePlugin);
            }
        });
    }
    if (startAt && !add) {
        if (!plugins) {
            plugins = [];
        }
        plugins.push(startAt);
    }
    return _createProxyChain(plugins, itemCtx);
}
var ProcessTelemetryContext = /** @class */ (function () {
    /**
     * Creates a new Telemetry Item context with the current config, core and plugin execution chain
     * @param plugins - The plugin instances that will be executed
     * @param config - The current config
     * @param core - The current core instance
     */
    function ProcessTelemetryContext(plugins, config, core, startAt) {
        var _self = this;
        var _nextProxy = null; // Null == No next plugin
        // There is no next element (null) vs not defined (undefined)
        if (startAt !== null) {
            if (plugins && Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["p" /* isFunction */])(plugins.getPlugin)) {
                // We have a proxy chain object
                _nextProxy = _copyProxyChain(plugins, _self, startAt || plugins.getPlugin());
            }
            else {
                // We just have an array
                if (startAt) {
                    _nextProxy = _copyPluginChain(plugins, _self, startAt);
                }
                else if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */])(startAt)) {
                    // Undefined means copy the existing chain
                    _nextProxy = _createProxyChain(plugins, _self);
                }
            }
        }
        _self.core = function () {
            return core;
        };
        _self.diagLog = function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__DiagnosticLogger__["c" /* safeGetLogger */])(core, config);
        };
        _self.getCfg = function () {
            return config;
        };
        _self.getExtCfg = function (identifier, defaultValue) {
            if (defaultValue === void 0) { defaultValue = {}; }
            var theConfig;
            if (config) {
                var extConfig = config.extensionConfig;
                if (extConfig && identifier) {
                    theConfig = extConfig[identifier];
                }
            }
            return (theConfig ? theConfig : defaultValue);
        };
        _self.getConfig = function (identifier, field, defaultValue) {
            if (defaultValue === void 0) { defaultValue = false; }
            var theValue;
            var extConfig = _self.getExtCfg(identifier, null);
            if (extConfig && !Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */])(extConfig[field])) {
                theValue = extConfig[field];
            }
            else if (config && !Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */])(config[field])) {
                theValue = config[field];
            }
            return !Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */])(theValue) ? theValue : defaultValue;
        };
        _self.hasNext = function () {
            return _nextProxy != null;
        };
        _self.getNext = function () {
            return _nextProxy;
        };
        _self.setNext = function (nextPlugin) {
            _nextProxy = nextPlugin;
        };
        _self.processNext = function (env) {
            var nextPlugin = _nextProxy;
            if (nextPlugin) {
                // Automatically move to the next plugin
                _nextProxy = nextPlugin.getNext();
                nextPlugin.processTelemetry(env, _self);
            }
        };
        _self.createNew = function (plugins, startAt) {
            if (plugins === void 0) { plugins = null; }
            return new ProcessTelemetryContext(plugins || _nextProxy, config, core, startAt);
        };
    }
    return ProcessTelemetryContext;
}());

//# sourceMappingURL=ProcessTelemetryContext.js.map

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoggingSeverity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _InternalMessageId; });
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var LoggingSeverity;
(function (LoggingSeverity) {
    /**
     * Error will be sent as internal telemetry
     */
    LoggingSeverity[LoggingSeverity["CRITICAL"] = 1] = "CRITICAL";
    /**
     * Error will NOT be sent as internal telemetry, and will only be shown in browser console
     */
    LoggingSeverity[LoggingSeverity["WARNING"] = 2] = "WARNING";
})(LoggingSeverity || (LoggingSeverity = {}));
/**
 * Internal message ID. Please create a new one for every conceptually different message. Please keep alphabetically ordered
 */
var _InternalMessageId = {
    // Non user actionable
    BrowserDoesNotSupportLocalStorage: 0,
    BrowserCannotReadLocalStorage: 1,
    BrowserCannotReadSessionStorage: 2,
    BrowserCannotWriteLocalStorage: 3,
    BrowserCannotWriteSessionStorage: 4,
    BrowserFailedRemovalFromLocalStorage: 5,
    BrowserFailedRemovalFromSessionStorage: 6,
    CannotSendEmptyTelemetry: 7,
    ClientPerformanceMathError: 8,
    ErrorParsingAISessionCookie: 9,
    ErrorPVCalc: 10,
    ExceptionWhileLoggingError: 11,
    FailedAddingTelemetryToBuffer: 12,
    FailedMonitorAjaxAbort: 13,
    FailedMonitorAjaxDur: 14,
    FailedMonitorAjaxOpen: 15,
    FailedMonitorAjaxRSC: 16,
    FailedMonitorAjaxSend: 17,
    FailedMonitorAjaxGetCorrelationHeader: 18,
    FailedToAddHandlerForOnBeforeUnload: 19,
    FailedToSendQueuedTelemetry: 20,
    FailedToReportDataLoss: 21,
    FlushFailed: 22,
    MessageLimitPerPVExceeded: 23,
    MissingRequiredFieldSpecification: 24,
    NavigationTimingNotSupported: 25,
    OnError: 26,
    SessionRenewalDateIsZero: 27,
    SenderNotInitialized: 28,
    StartTrackEventFailed: 29,
    StopTrackEventFailed: 30,
    StartTrackFailed: 31,
    StopTrackFailed: 32,
    TelemetrySampledAndNotSent: 33,
    TrackEventFailed: 34,
    TrackExceptionFailed: 35,
    TrackMetricFailed: 36,
    TrackPVFailed: 37,
    TrackPVFailedCalc: 38,
    TrackTraceFailed: 39,
    TransmissionFailed: 40,
    FailedToSetStorageBuffer: 41,
    FailedToRestoreStorageBuffer: 42,
    InvalidBackendResponse: 43,
    FailedToFixDepricatedValues: 44,
    InvalidDurationValue: 45,
    TelemetryEnvelopeInvalid: 46,
    CreateEnvelopeError: 47,
    // User actionable
    CannotSerializeObject: 48,
    CannotSerializeObjectNonSerializable: 49,
    CircularReferenceDetected: 50,
    ClearAuthContextFailed: 51,
    ExceptionTruncated: 52,
    IllegalCharsInName: 53,
    ItemNotInArray: 54,
    MaxAjaxPerPVExceeded: 55,
    MessageTruncated: 56,
    NameTooLong: 57,
    SampleRateOutOfRange: 58,
    SetAuthContextFailed: 59,
    SetAuthContextFailedAccountName: 60,
    StringValueTooLong: 61,
    StartCalledMoreThanOnce: 62,
    StopCalledWithoutStart: 63,
    TelemetryInitializerFailed: 64,
    TrackArgumentsNotSpecified: 65,
    UrlTooLong: 66,
    SessionStorageBufferFull: 67,
    CannotAccessCookie: 68,
    IdTooLong: 69,
    InvalidEvent: 70,
    FailedMonitorAjaxSetRequestHeader: 71,
    SendBrowserInfoOnUserInit: 72,
    PluginException: 73,
    NotificationException: 74,
    SnippetScriptLoadFailure: 99,
    InvalidInstrumentationKey: 100,
    CannotParseAiBlobValue: 101,
    InvalidContentBlob: 102,
    TrackPageActionEventFailed: 103
};
//# sourceMappingURL=LoggingEnums.js.map

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PerfEvent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PerfManager; });
/* harmony export (immutable) */ __webpack_exports__["b"] = doPerf;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HelperFuncs__ = __webpack_require__(42);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var strExecutionContextKey = "ctx";
var PerfEvent = /** @class */ (function () {
    function PerfEvent(name, payloadDetails, isAsync) {
        var _self = this;
        var accessorDefined = false;
        _self.start = Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["g" /* dateNow */])();
        _self.name = name;
        _self.isAsync = isAsync;
        _self.isChildEvt = function () { return false; };
        if (Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["p" /* isFunction */])(payloadDetails)) {
            // Create an accessor to minimize the potential performance impact of executing the payloadDetails callback
            var theDetails_1;
            accessorDefined = Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["z" /* objDefineAccessors */])(_self, 'payload', function () {
                // Delay the execution of the payloadDetails until needed
                if (!theDetails_1 && Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["p" /* isFunction */])(payloadDetails)) {
                    theDetails_1 = payloadDetails();
                    // clear it out now so the referenced objects can be garbage collected
                    payloadDetails = null;
                }
                return theDetails_1;
            });
        }
        _self.getCtx = function (key) {
            if (key) {
                // The parent and child links are located directly on the object (for better viewing in the DebugPlugin)
                if (key === PerfEvent.ParentContextKey || key === PerfEvent.ChildrenContextKey) {
                    return _self[key];
                }
                return (_self[strExecutionContextKey] || {})[key];
            }
            return null;
        };
        _self.setCtx = function (key, value) {
            if (key) {
                // Put the parent and child links directly on the object (for better viewing in the DebugPlugin)
                if (key === PerfEvent.ParentContextKey) {
                    // Simple assumption, if we are setting a parent then we must be a child
                    if (!_self[key]) {
                        _self.isChildEvt = function () { return true; };
                    }
                    _self[key] = value;
                }
                else if (key === PerfEvent.ChildrenContextKey) {
                    _self[key] = value;
                }
                else {
                    var ctx = _self[strExecutionContextKey] = _self[strExecutionContextKey] || {};
                    ctx[key] = value;
                }
            }
        };
        _self.complete = function () {
            var childTime = 0;
            var childEvts = _self.getCtx(PerfEvent.ChildrenContextKey);
            if (Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["l" /* isArray */])(childEvts)) {
                for (var lp = 0; lp < childEvts.length; lp++) {
                    var childEvt = childEvts[lp];
                    if (childEvt) {
                        childTime += childEvt.time;
                    }
                }
            }
            _self.time = Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["g" /* dateNow */])() - _self.start;
            _self.exTime = _self.time - childTime;
            _self.complete = function () { };
            if (!accessorDefined && Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["p" /* isFunction */])(payloadDetails)) {
                // If we couldn't define the property set during complete -- to minimize the perf impact until after the time
                _self.payload = payloadDetails();
            }
        };
    }
    PerfEvent.ParentContextKey = "parent";
    PerfEvent.ChildrenContextKey = "childEvts";
    return PerfEvent;
}());

var PerfManager = /** @class */ (function () {
    function PerfManager(manager) {
        /**
         * General bucket used for execution context set and retrieved via setCtx() and getCtx.
         * Defined as private so it can be visualized via the DebugPlugin
         */
        this.ctx = {};
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__["a" /* default */])(PerfManager, this, function (_self) {
            _self.create = function (src, payloadDetails, isAsync) {
                // TODO (@MSNev): at some point we will want to add additional configuration to "select" which events to instrument
                // for now this is just a simple do everything.
                return new PerfEvent(src, payloadDetails, isAsync);
            };
            _self.fire = function (perfEvent) {
                if (perfEvent) {
                    perfEvent.complete();
                    if (manager) {
                        manager.perfEvent(perfEvent);
                    }
                }
            };
            _self.setCtx = function (key, value) {
                if (key) {
                    var ctx = _self[strExecutionContextKey] = _self[strExecutionContextKey] || {};
                    ctx[key] = value;
                }
            };
            _self.getCtx = function (key) {
                return (_self[strExecutionContextKey] || {})[key];
            };
        });
    }
// Removed Stub for PerfManager.prototype.create.
// Removed Stub for PerfManager.prototype.fire.
// Removed Stub for PerfManager.prototype.setCtx.
// Removed Stub for PerfManager.prototype.getCtx.
    return PerfManager;
}());

var doPerfActiveKey = "CoreUtils.doPerf";
/**
 * Helper function to wrap a function with a perf event
 * @param mgrSource - The Performance Manager or a Performance provider source (may be null)
 * @param getSource - The callback to create the source name for the event (if perf monitoring is enabled)
 * @param func - The function to call and measure
 * @param details - A function to return the payload details
 * @param isAsync - Is the event / function being call asynchronously or synchronously
 */
function doPerf(mgrSource, getSource, func, details, isAsync) {
    if (mgrSource) {
        var perfMgr = mgrSource;
        if (perfMgr && Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["p" /* isFunction */])(perfMgr["getPerfMgr"])) {
            // Looks like a perf manager provider object
            perfMgr = perfMgr["getPerfMgr"]();
        }
        if (perfMgr) {
            var perfEvt = void 0;
            var currentActive = perfMgr.getCtx(doPerfActiveKey);
            try {
                perfEvt = perfMgr.create(getSource(), details, isAsync);
                if (perfEvt) {
                    if (currentActive && perfEvt.setCtx) {
                        perfEvt.setCtx(PerfEvent.ParentContextKey, currentActive);
                        if (currentActive.getCtx && currentActive.setCtx) {
                            var children = currentActive.getCtx(PerfEvent.ChildrenContextKey);
                            if (!children) {
                                children = [];
                                currentActive.setCtx(PerfEvent.ChildrenContextKey, children);
                            }
                            children.push(perfEvt);
                        }
                    }
                    // Set this event as the active event now
                    perfMgr.setCtx(doPerfActiveKey, perfEvt);
                    return func(perfEvt);
                }
            }
            catch (ex) {
                if (perfEvt && perfEvt.setCtx) {
                    perfEvt.setCtx("exception", ex);
                }
            }
            finally {
                // fire the perf event
                if (perfEvt) {
                    perfMgr.fire(perfEvt);
                }
                // Reset the active event to the previous value
                perfMgr.setCtx(doPerfActiveKey, currentActive);
            }
        }
    }
    return func();
}
//# sourceMappingURL=PerfManager.js.map

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = stringToBoolOrDefault;
/* harmony export (immutable) */ __webpack_exports__["d"] = msToTimeSpan;
/* harmony export (immutable) */ __webpack_exports__["b"] = isBeaconApiSupported;
/* harmony export (immutable) */ __webpack_exports__["a"] = getExtensionByName;
/* harmony export (immutable) */ __webpack_exports__["c"] = isCrossOriginError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(41);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



function stringToBoolOrDefault(str, defaultValue) {
    if (defaultValue === void 0) { defaultValue = false; }
    if (str === undefined || str === null) {
        return defaultValue;
    }
    return str.toString().toLowerCase() === "true";
}
/**
 * Convert ms to c# time span format
 */
function msToTimeSpan(totalms) {
    if (isNaN(totalms) || totalms < 0) {
        totalms = 0;
    }
    totalms = Math.round(totalms);
    var ms = "" + totalms % 1000;
    var sec = "" + Math.floor(totalms / 1000) % 60;
    var min = "" + Math.floor(totalms / (1000 * 60)) % 60;
    var hour = "" + Math.floor(totalms / (1000 * 60 * 60)) % 24;
    var days = Math.floor(totalms / (1000 * 60 * 60 * 24));
    ms = ms.length === 1 ? "00" + ms : ms.length === 2 ? "0" + ms : ms;
    sec = sec.length < 2 ? "0" + sec : sec;
    min = min.length < 2 ? "0" + min : min;
    hour = hour.length < 2 ? "0" + hour : hour;
    return (days > 0 ? days + "." : "") + hour + ":" + min + ":" + sec + "." + ms;
}
function isBeaconApiSupported() {
    var nav = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["y" /* getNavigator */])();
    return ('sendBeacon' in nav && nav.sendBeacon);
}
function getExtensionByName(extensions, identifier) {
    var extension = null;
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["d" /* arrForEach */])(extensions, function (value) {
        if (value.identifier === identifier) {
            extension = value;
            return -1;
        }
    });
    return extension;
}
function isCrossOriginError(message, url, lineNumber, columnNumber, error) {
    return !error && Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["I" /* isString */])(message) && (message === "Script error." || message === "Script error");
}
//# sourceMappingURL=HelperFuncs.js.map

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProcessTelemetryContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DiagnosticLogger__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TelemetryPluginChain__ = __webpack_require__(1425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__ = __webpack_require__(43);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






/**
 * Creates the instance execution chain for the plugins
 */
function _createProxyChain(plugins, itemCtx) {
    var proxies = [];
    if (plugins && plugins.length > 0) {
        // Create the proxies and wire up the next plugin chain
        var lastProxy = null;
        for (var idx = 0; idx < plugins.length; idx++) {
            var thePlugin = plugins[idx];
            if (thePlugin && Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["p" /* isFunction */])(thePlugin.processTelemetry)) {
                // Only add plugins that are processors
                var newProxy = new __WEBPACK_IMPORTED_MODULE_1__TelemetryPluginChain__["a" /* TelemetryPluginChain */](thePlugin, itemCtx);
                proxies.push(newProxy);
                if (lastProxy) {
                    // Set this new proxy as the next for the previous one
                    lastProxy.setNext(newProxy);
                }
                lastProxy = newProxy;
            }
        }
    }
    return proxies.length > 0 ? proxies[0] : null;
}
function _copyProxyChain(proxy, itemCtx, startAt) {
    var plugins = [];
    var add = startAt ? false : true;
    if (proxy) {
        while (proxy) {
            var thePlugin = proxy.getPlugin();
            if (add || thePlugin === startAt) {
                add = true;
                plugins.push(thePlugin);
            }
            proxy = proxy.getNext();
        }
    }
    if (!add) {
        plugins.push(startAt);
    }
    return _createProxyChain(plugins, itemCtx);
}
function _copyPluginChain(srcPlugins, itemCtx, startAt) {
    var plugins = srcPlugins;
    var add = false;
    if (startAt && srcPlugins) {
        plugins = [];
        Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["a" /* arrForEach */])(srcPlugins, function (thePlugin) {
            if (add || thePlugin === startAt) {
                add = true;
                plugins.push(thePlugin);
            }
        });
    }
    if (startAt && !add) {
        if (!plugins) {
            plugins = [];
        }
        plugins.push(startAt);
    }
    return _createProxyChain(plugins, itemCtx);
}
var ProcessTelemetryContext = /** @class */ (function () {
    /**
     * Creates a new Telemetry Item context with the current config, core and plugin execution chain
     * @param plugins - The plugin instances that will be executed
     * @param config - The current config
     * @param core - The current core instance
     */
    function ProcessTelemetryContext(plugins, config, core, startAt) {
        var _self = this;
        var _nextProxy = null; // Null == No next plugin
        // There is no next element (null) vs not defined (undefined)
        if (startAt !== null) {
            if (plugins && Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["p" /* isFunction */])(plugins.getPlugin)) {
                // We have a proxy chain object
                _nextProxy = _copyProxyChain(plugins, _self, startAt || plugins.getPlugin());
            }
            else {
                // We just have an array
                if (startAt) {
                    _nextProxy = _copyPluginChain(plugins, _self, startAt);
                }
                else if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */])(startAt)) {
                    // Undefined means copy the existing chain
                    _nextProxy = _createProxyChain(plugins, _self);
                }
            }
        }
        _self.core = function () {
            return core;
        };
        _self.diagLog = function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__DiagnosticLogger__["c" /* safeGetLogger */])(core, config);
        };
        _self.getCfg = function () {
            return config;
        };
        _self.getExtCfg = function (identifier, defaultValue) {
            if (defaultValue === void 0) { defaultValue = {}; }
            var theConfig;
            if (config) {
                var extConfig = config.extensionConfig;
                if (extConfig && identifier) {
                    theConfig = extConfig[identifier];
                }
            }
            return (theConfig ? theConfig : defaultValue);
        };
        _self.getConfig = function (identifier, field, defaultValue) {
            if (defaultValue === void 0) { defaultValue = false; }
            var theValue;
            var extConfig = _self.getExtCfg(identifier, null);
            if (extConfig && !Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */])(extConfig[field])) {
                theValue = extConfig[field];
            }
            else if (config && !Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */])(config[field])) {
                theValue = config[field];
            }
            return !Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */])(theValue) ? theValue : defaultValue;
        };
        _self.hasNext = function () {
            return _nextProxy != null;
        };
        _self.getNext = function () {
            return _nextProxy;
        };
        _self.setNext = function (nextPlugin) {
            _nextProxy = nextPlugin;
        };
        _self.processNext = function (env) {
            var nextPlugin = _nextProxy;
            if (nextPlugin) {
                // Automatically move to the next plugin
                _nextProxy = nextPlugin.getNext();
                nextPlugin.processTelemetry(env, _self);
            }
        };
        _self.createNew = function (plugins, startAt) {
            if (plugins === void 0) { plugins = null; }
            return new ProcessTelemetryContext(plugins || _nextProxy, config, core, startAt);
        };
    }
    return ProcessTelemetryContext;
}());

//# sourceMappingURL=ProcessTelemetryContext.js.map

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoggingSeverity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _InternalMessageId; });
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var LoggingSeverity;
(function (LoggingSeverity) {
    /**
     * Error will be sent as internal telemetry
     */
    LoggingSeverity[LoggingSeverity["CRITICAL"] = 1] = "CRITICAL";
    /**
     * Error will NOT be sent as internal telemetry, and will only be shown in browser console
     */
    LoggingSeverity[LoggingSeverity["WARNING"] = 2] = "WARNING";
})(LoggingSeverity || (LoggingSeverity = {}));
/**
 * Internal message ID. Please create a new one for every conceptually different message. Please keep alphabetically ordered
 */
var _InternalMessageId = {
    // Non user actionable
    BrowserDoesNotSupportLocalStorage: 0,
    BrowserCannotReadLocalStorage: 1,
    BrowserCannotReadSessionStorage: 2,
    BrowserCannotWriteLocalStorage: 3,
    BrowserCannotWriteSessionStorage: 4,
    BrowserFailedRemovalFromLocalStorage: 5,
    BrowserFailedRemovalFromSessionStorage: 6,
    CannotSendEmptyTelemetry: 7,
    ClientPerformanceMathError: 8,
    ErrorParsingAISessionCookie: 9,
    ErrorPVCalc: 10,
    ExceptionWhileLoggingError: 11,
    FailedAddingTelemetryToBuffer: 12,
    FailedMonitorAjaxAbort: 13,
    FailedMonitorAjaxDur: 14,
    FailedMonitorAjaxOpen: 15,
    FailedMonitorAjaxRSC: 16,
    FailedMonitorAjaxSend: 17,
    FailedMonitorAjaxGetCorrelationHeader: 18,
    FailedToAddHandlerForOnBeforeUnload: 19,
    FailedToSendQueuedTelemetry: 20,
    FailedToReportDataLoss: 21,
    FlushFailed: 22,
    MessageLimitPerPVExceeded: 23,
    MissingRequiredFieldSpecification: 24,
    NavigationTimingNotSupported: 25,
    OnError: 26,
    SessionRenewalDateIsZero: 27,
    SenderNotInitialized: 28,
    StartTrackEventFailed: 29,
    StopTrackEventFailed: 30,
    StartTrackFailed: 31,
    StopTrackFailed: 32,
    TelemetrySampledAndNotSent: 33,
    TrackEventFailed: 34,
    TrackExceptionFailed: 35,
    TrackMetricFailed: 36,
    TrackPVFailed: 37,
    TrackPVFailedCalc: 38,
    TrackTraceFailed: 39,
    TransmissionFailed: 40,
    FailedToSetStorageBuffer: 41,
    FailedToRestoreStorageBuffer: 42,
    InvalidBackendResponse: 43,
    FailedToFixDepricatedValues: 44,
    InvalidDurationValue: 45,
    TelemetryEnvelopeInvalid: 46,
    CreateEnvelopeError: 47,
    // User actionable
    CannotSerializeObject: 48,
    CannotSerializeObjectNonSerializable: 49,
    CircularReferenceDetected: 50,
    ClearAuthContextFailed: 51,
    ExceptionTruncated: 52,
    IllegalCharsInName: 53,
    ItemNotInArray: 54,
    MaxAjaxPerPVExceeded: 55,
    MessageTruncated: 56,
    NameTooLong: 57,
    SampleRateOutOfRange: 58,
    SetAuthContextFailed: 59,
    SetAuthContextFailedAccountName: 60,
    StringValueTooLong: 61,
    StartCalledMoreThanOnce: 62,
    StopCalledWithoutStart: 63,
    TelemetryInitializerFailed: 64,
    TrackArgumentsNotSpecified: 65,
    UrlTooLong: 66,
    SessionStorageBufferFull: 67,
    CannotAccessCookie: 68,
    IdTooLong: 69,
    InvalidEvent: 70,
    FailedMonitorAjaxSetRequestHeader: 71,
    SendBrowserInfoOnUserInit: 72,
    PluginException: 73,
    NotificationException: 74,
    SnippetScriptLoadFailure: 99,
    InvalidInstrumentationKey: 100,
    CannotParseAiBlobValue: 101,
    InvalidContentBlob: 102,
    TrackPageActionEventFailed: 103
};
//# sourceMappingURL=LoggingEnums.js.map

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PerfEvent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PerfManager; });
/* harmony export (immutable) */ __webpack_exports__["b"] = doPerf;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HelperFuncs__ = __webpack_require__(43);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var strExecutionContextKey = "ctx";
var PerfEvent = /** @class */ (function () {
    function PerfEvent(name, payloadDetails, isAsync) {
        var _self = this;
        var accessorDefined = false;
        _self.start = Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["g" /* dateNow */])();
        _self.name = name;
        _self.isAsync = isAsync;
        _self.isChildEvt = function () { return false; };
        if (Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["p" /* isFunction */])(payloadDetails)) {
            // Create an accessor to minimize the potential performance impact of executing the payloadDetails callback
            var theDetails_1;
            accessorDefined = Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["z" /* objDefineAccessors */])(_self, 'payload', function () {
                // Delay the execution of the payloadDetails until needed
                if (!theDetails_1 && Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["p" /* isFunction */])(payloadDetails)) {
                    theDetails_1 = payloadDetails();
                    // clear it out now so the referenced objects can be garbage collected
                    payloadDetails = null;
                }
                return theDetails_1;
            });
        }
        _self.getCtx = function (key) {
            if (key) {
                // The parent and child links are located directly on the object (for better viewing in the DebugPlugin)
                if (key === PerfEvent.ParentContextKey || key === PerfEvent.ChildrenContextKey) {
                    return _self[key];
                }
                return (_self[strExecutionContextKey] || {})[key];
            }
            return null;
        };
        _self.setCtx = function (key, value) {
            if (key) {
                // Put the parent and child links directly on the object (for better viewing in the DebugPlugin)
                if (key === PerfEvent.ParentContextKey) {
                    // Simple assumption, if we are setting a parent then we must be a child
                    if (!_self[key]) {
                        _self.isChildEvt = function () { return true; };
                    }
                    _self[key] = value;
                }
                else if (key === PerfEvent.ChildrenContextKey) {
                    _self[key] = value;
                }
                else {
                    var ctx = _self[strExecutionContextKey] = _self[strExecutionContextKey] || {};
                    ctx[key] = value;
                }
            }
        };
        _self.complete = function () {
            var childTime = 0;
            var childEvts = _self.getCtx(PerfEvent.ChildrenContextKey);
            if (Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["l" /* isArray */])(childEvts)) {
                for (var lp = 0; lp < childEvts.length; lp++) {
                    var childEvt = childEvts[lp];
                    if (childEvt) {
                        childTime += childEvt.time;
                    }
                }
            }
            _self.time = Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["g" /* dateNow */])() - _self.start;
            _self.exTime = _self.time - childTime;
            _self.complete = function () { };
            if (!accessorDefined && Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["p" /* isFunction */])(payloadDetails)) {
                // If we couldn't define the property set during complete -- to minimize the perf impact until after the time
                _self.payload = payloadDetails();
            }
        };
    }
    PerfEvent.ParentContextKey = "parent";
    PerfEvent.ChildrenContextKey = "childEvts";
    return PerfEvent;
}());

var PerfManager = /** @class */ (function () {
    function PerfManager(manager) {
        /**
         * General bucket used for execution context set and retrieved via setCtx() and getCtx.
         * Defined as private so it can be visualized via the DebugPlugin
         */
        this.ctx = {};
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__["a" /* default */])(PerfManager, this, function (_self) {
            _self.create = function (src, payloadDetails, isAsync) {
                // TODO (@MSNev): at some point we will want to add additional configuration to "select" which events to instrument
                // for now this is just a simple do everything.
                return new PerfEvent(src, payloadDetails, isAsync);
            };
            _self.fire = function (perfEvent) {
                if (perfEvent) {
                    perfEvent.complete();
                    if (manager) {
                        manager.perfEvent(perfEvent);
                    }
                }
            };
            _self.setCtx = function (key, value) {
                if (key) {
                    var ctx = _self[strExecutionContextKey] = _self[strExecutionContextKey] || {};
                    ctx[key] = value;
                }
            };
            _self.getCtx = function (key) {
                return (_self[strExecutionContextKey] || {})[key];
            };
        });
    }
// Removed Stub for PerfManager.prototype.create.
// Removed Stub for PerfManager.prototype.fire.
// Removed Stub for PerfManager.prototype.setCtx.
// Removed Stub for PerfManager.prototype.getCtx.
    return PerfManager;
}());

var doPerfActiveKey = "CoreUtils.doPerf";
/**
 * Helper function to wrap a function with a perf event
 * @param mgrSource - The Performance Manager or a Performance provider source (may be null)
 * @param getSource - The callback to create the source name for the event (if perf monitoring is enabled)
 * @param func - The function to call and measure
 * @param details - A function to return the payload details
 * @param isAsync - Is the event / function being call asynchronously or synchronously
 */
function doPerf(mgrSource, getSource, func, details, isAsync) {
    if (mgrSource) {
        var perfMgr = mgrSource;
        if (perfMgr && Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["p" /* isFunction */])(perfMgr["getPerfMgr"])) {
            // Looks like a perf manager provider object
            perfMgr = perfMgr["getPerfMgr"]();
        }
        if (perfMgr) {
            var perfEvt = void 0;
            var currentActive = perfMgr.getCtx(doPerfActiveKey);
            try {
                perfEvt = perfMgr.create(getSource(), details, isAsync);
                if (perfEvt) {
                    if (currentActive && perfEvt.setCtx) {
                        perfEvt.setCtx(PerfEvent.ParentContextKey, currentActive);
                        if (currentActive.getCtx && currentActive.setCtx) {
                            var children = currentActive.getCtx(PerfEvent.ChildrenContextKey);
                            if (!children) {
                                children = [];
                                currentActive.setCtx(PerfEvent.ChildrenContextKey, children);
                            }
                            children.push(perfEvt);
                        }
                    }
                    // Set this event as the active event now
                    perfMgr.setCtx(doPerfActiveKey, perfEvt);
                    return func(perfEvt);
                }
            }
            catch (ex) {
                if (perfEvt && perfEvt.setCtx) {
                    perfEvt.setCtx("exception", ex);
                }
            }
            finally {
                // fire the perf event
                if (perfEvt) {
                    perfMgr.fire(perfEvt);
                }
                // Reset the active event to the previous value
                perfMgr.setCtx(doPerfActiveKey, currentActive);
            }
        }
    }
    return func();
}
//# sourceMappingURL=PerfManager.js.map

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = stringToBoolOrDefault;
/* harmony export (immutable) */ __webpack_exports__["d"] = msToTimeSpan;
/* harmony export (immutable) */ __webpack_exports__["b"] = isBeaconApiSupported;
/* harmony export (immutable) */ __webpack_exports__["a"] = getExtensionByName;
/* harmony export (immutable) */ __webpack_exports__["c"] = isCrossOriginError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(30);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



function stringToBoolOrDefault(str, defaultValue) {
    if (defaultValue === void 0) { defaultValue = false; }
    if (str === undefined || str === null) {
        return defaultValue;
    }
    return str.toString().toLowerCase() === "true";
}
/**
 * Convert ms to c# time span format
 */
function msToTimeSpan(totalms) {
    if (isNaN(totalms) || totalms < 0) {
        totalms = 0;
    }
    totalms = Math.round(totalms);
    var ms = "" + totalms % 1000;
    var sec = "" + Math.floor(totalms / 1000) % 60;
    var min = "" + Math.floor(totalms / (1000 * 60)) % 60;
    var hour = "" + Math.floor(totalms / (1000 * 60 * 60)) % 24;
    var days = Math.floor(totalms / (1000 * 60 * 60 * 24));
    ms = ms.length === 1 ? "00" + ms : ms.length === 2 ? "0" + ms : ms;
    sec = sec.length < 2 ? "0" + sec : sec;
    min = min.length < 2 ? "0" + min : min;
    hour = hour.length < 2 ? "0" + hour : hour;
    return (days > 0 ? days + "." : "") + hour + ":" + min + ":" + sec + "." + ms;
}
function isBeaconApiSupported() {
    var nav = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["x" /* getNavigator */])();
    return ('sendBeacon' in nav && nav.sendBeacon);
}
function getExtensionByName(extensions, identifier) {
    var extension = null;
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["e" /* arrForEach */])(extensions, function (value) {
        if (value.identifier === identifier) {
            extension = value;
            return -1;
        }
    });
    return extension;
}
function isCrossOriginError(message, url, lineNumber, columnNumber, error) {
    return !error && Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["I" /* isString */])(message) && (message === "Script error." || message === "Script error");
}
//# sourceMappingURL=HelperFuncs.js.map

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProcessTelemetryContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DiagnosticLogger__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TelemetryPluginChain__ = __webpack_require__(1463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__ = __webpack_require__(44);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






/**
 * Creates the instance execution chain for the plugins
 */
function _createProxyChain(plugins, itemCtx) {
    var proxies = [];
    if (plugins && plugins.length > 0) {
        // Create the proxies and wire up the next plugin chain
        var lastProxy = null;
        for (var idx = 0; idx < plugins.length; idx++) {
            var thePlugin = plugins[idx];
            if (thePlugin && Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["p" /* isFunction */])(thePlugin.processTelemetry)) {
                // Only add plugins that are processors
                var newProxy = new __WEBPACK_IMPORTED_MODULE_1__TelemetryPluginChain__["a" /* TelemetryPluginChain */](thePlugin, itemCtx);
                proxies.push(newProxy);
                if (lastProxy) {
                    // Set this new proxy as the next for the previous one
                    lastProxy.setNext(newProxy);
                }
                lastProxy = newProxy;
            }
        }
    }
    return proxies.length > 0 ? proxies[0] : null;
}
function _copyProxyChain(proxy, itemCtx, startAt) {
    var plugins = [];
    var add = startAt ? false : true;
    if (proxy) {
        while (proxy) {
            var thePlugin = proxy.getPlugin();
            if (add || thePlugin === startAt) {
                add = true;
                plugins.push(thePlugin);
            }
            proxy = proxy.getNext();
        }
    }
    if (!add) {
        plugins.push(startAt);
    }
    return _createProxyChain(plugins, itemCtx);
}
function _copyPluginChain(srcPlugins, itemCtx, startAt) {
    var plugins = srcPlugins;
    var add = false;
    if (startAt && srcPlugins) {
        plugins = [];
        Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["a" /* arrForEach */])(srcPlugins, function (thePlugin) {
            if (add || thePlugin === startAt) {
                add = true;
                plugins.push(thePlugin);
            }
        });
    }
    if (startAt && !add) {
        if (!plugins) {
            plugins = [];
        }
        plugins.push(startAt);
    }
    return _createProxyChain(plugins, itemCtx);
}
var ProcessTelemetryContext = /** @class */ (function () {
    /**
     * Creates a new Telemetry Item context with the current config, core and plugin execution chain
     * @param plugins - The plugin instances that will be executed
     * @param config - The current config
     * @param core - The current core instance
     */
    function ProcessTelemetryContext(plugins, config, core, startAt) {
        var _self = this;
        var _nextProxy = null; // Null == No next plugin
        // There is no next element (null) vs not defined (undefined)
        if (startAt !== null) {
            if (plugins && Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["p" /* isFunction */])(plugins.getPlugin)) {
                // We have a proxy chain object
                _nextProxy = _copyProxyChain(plugins, _self, startAt || plugins.getPlugin());
            }
            else {
                // We just have an array
                if (startAt) {
                    _nextProxy = _copyPluginChain(plugins, _self, startAt);
                }
                else if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */])(startAt)) {
                    // Undefined means copy the existing chain
                    _nextProxy = _createProxyChain(plugins, _self);
                }
            }
        }
        _self.core = function () {
            return core;
        };
        _self.diagLog = function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__DiagnosticLogger__["c" /* safeGetLogger */])(core, config);
        };
        _self.getCfg = function () {
            return config;
        };
        _self.getExtCfg = function (identifier, defaultValue) {
            if (defaultValue === void 0) { defaultValue = {}; }
            var theConfig;
            if (config) {
                var extConfig = config.extensionConfig;
                if (extConfig && identifier) {
                    theConfig = extConfig[identifier];
                }
            }
            return (theConfig ? theConfig : defaultValue);
        };
        _self.getConfig = function (identifier, field, defaultValue) {
            if (defaultValue === void 0) { defaultValue = false; }
            var theValue;
            var extConfig = _self.getExtCfg(identifier, null);
            if (extConfig && !Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */])(extConfig[field])) {
                theValue = extConfig[field];
            }
            else if (config && !Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */])(config[field])) {
                theValue = config[field];
            }
            return !Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */])(theValue) ? theValue : defaultValue;
        };
        _self.hasNext = function () {
            return _nextProxy != null;
        };
        _self.getNext = function () {
            return _nextProxy;
        };
        _self.setNext = function (nextPlugin) {
            _nextProxy = nextPlugin;
        };
        _self.processNext = function (env) {
            var nextPlugin = _nextProxy;
            if (nextPlugin) {
                // Automatically move to the next plugin
                _nextProxy = nextPlugin.getNext();
                nextPlugin.processTelemetry(env, _self);
            }
        };
        _self.createNew = function (plugins, startAt) {
            if (plugins === void 0) { plugins = null; }
            return new ProcessTelemetryContext(plugins || _nextProxy, config, core, startAt);
        };
    }
    return ProcessTelemetryContext;
}());

//# sourceMappingURL=ProcessTelemetryContext.js.map

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoggingSeverity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _InternalMessageId; });
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var LoggingSeverity;
(function (LoggingSeverity) {
    /**
     * Error will be sent as internal telemetry
     */
    LoggingSeverity[LoggingSeverity["CRITICAL"] = 1] = "CRITICAL";
    /**
     * Error will NOT be sent as internal telemetry, and will only be shown in browser console
     */
    LoggingSeverity[LoggingSeverity["WARNING"] = 2] = "WARNING";
})(LoggingSeverity || (LoggingSeverity = {}));
/**
 * Internal message ID. Please create a new one for every conceptually different message. Please keep alphabetically ordered
 */
var _InternalMessageId = {
    // Non user actionable
    BrowserDoesNotSupportLocalStorage: 0,
    BrowserCannotReadLocalStorage: 1,
    BrowserCannotReadSessionStorage: 2,
    BrowserCannotWriteLocalStorage: 3,
    BrowserCannotWriteSessionStorage: 4,
    BrowserFailedRemovalFromLocalStorage: 5,
    BrowserFailedRemovalFromSessionStorage: 6,
    CannotSendEmptyTelemetry: 7,
    ClientPerformanceMathError: 8,
    ErrorParsingAISessionCookie: 9,
    ErrorPVCalc: 10,
    ExceptionWhileLoggingError: 11,
    FailedAddingTelemetryToBuffer: 12,
    FailedMonitorAjaxAbort: 13,
    FailedMonitorAjaxDur: 14,
    FailedMonitorAjaxOpen: 15,
    FailedMonitorAjaxRSC: 16,
    FailedMonitorAjaxSend: 17,
    FailedMonitorAjaxGetCorrelationHeader: 18,
    FailedToAddHandlerForOnBeforeUnload: 19,
    FailedToSendQueuedTelemetry: 20,
    FailedToReportDataLoss: 21,
    FlushFailed: 22,
    MessageLimitPerPVExceeded: 23,
    MissingRequiredFieldSpecification: 24,
    NavigationTimingNotSupported: 25,
    OnError: 26,
    SessionRenewalDateIsZero: 27,
    SenderNotInitialized: 28,
    StartTrackEventFailed: 29,
    StopTrackEventFailed: 30,
    StartTrackFailed: 31,
    StopTrackFailed: 32,
    TelemetrySampledAndNotSent: 33,
    TrackEventFailed: 34,
    TrackExceptionFailed: 35,
    TrackMetricFailed: 36,
    TrackPVFailed: 37,
    TrackPVFailedCalc: 38,
    TrackTraceFailed: 39,
    TransmissionFailed: 40,
    FailedToSetStorageBuffer: 41,
    FailedToRestoreStorageBuffer: 42,
    InvalidBackendResponse: 43,
    FailedToFixDepricatedValues: 44,
    InvalidDurationValue: 45,
    TelemetryEnvelopeInvalid: 46,
    CreateEnvelopeError: 47,
    // User actionable
    CannotSerializeObject: 48,
    CannotSerializeObjectNonSerializable: 49,
    CircularReferenceDetected: 50,
    ClearAuthContextFailed: 51,
    ExceptionTruncated: 52,
    IllegalCharsInName: 53,
    ItemNotInArray: 54,
    MaxAjaxPerPVExceeded: 55,
    MessageTruncated: 56,
    NameTooLong: 57,
    SampleRateOutOfRange: 58,
    SetAuthContextFailed: 59,
    SetAuthContextFailedAccountName: 60,
    StringValueTooLong: 61,
    StartCalledMoreThanOnce: 62,
    StopCalledWithoutStart: 63,
    TelemetryInitializerFailed: 64,
    TrackArgumentsNotSpecified: 65,
    UrlTooLong: 66,
    SessionStorageBufferFull: 67,
    CannotAccessCookie: 68,
    IdTooLong: 69,
    InvalidEvent: 70,
    FailedMonitorAjaxSetRequestHeader: 71,
    SendBrowserInfoOnUserInit: 72,
    PluginException: 73,
    NotificationException: 74,
    SnippetScriptLoadFailure: 99,
    InvalidInstrumentationKey: 100,
    CannotParseAiBlobValue: 101,
    InvalidContentBlob: 102,
    TrackPageActionEventFailed: 103
};
//# sourceMappingURL=LoggingEnums.js.map

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PerfEvent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PerfManager; });
/* harmony export (immutable) */ __webpack_exports__["b"] = doPerf;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HelperFuncs__ = __webpack_require__(44);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var strExecutionContextKey = "ctx";
var PerfEvent = /** @class */ (function () {
    function PerfEvent(name, payloadDetails, isAsync) {
        var _self = this;
        var accessorDefined = false;
        _self.start = Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["g" /* dateNow */])();
        _self.name = name;
        _self.isAsync = isAsync;
        _self.isChildEvt = function () { return false; };
        if (Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["p" /* isFunction */])(payloadDetails)) {
            // Create an accessor to minimize the potential performance impact of executing the payloadDetails callback
            var theDetails_1;
            accessorDefined = Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["z" /* objDefineAccessors */])(_self, 'payload', function () {
                // Delay the execution of the payloadDetails until needed
                if (!theDetails_1 && Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["p" /* isFunction */])(payloadDetails)) {
                    theDetails_1 = payloadDetails();
                    // clear it out now so the referenced objects can be garbage collected
                    payloadDetails = null;
                }
                return theDetails_1;
            });
        }
        _self.getCtx = function (key) {
            if (key) {
                // The parent and child links are located directly on the object (for better viewing in the DebugPlugin)
                if (key === PerfEvent.ParentContextKey || key === PerfEvent.ChildrenContextKey) {
                    return _self[key];
                }
                return (_self[strExecutionContextKey] || {})[key];
            }
            return null;
        };
        _self.setCtx = function (key, value) {
            if (key) {
                // Put the parent and child links directly on the object (for better viewing in the DebugPlugin)
                if (key === PerfEvent.ParentContextKey) {
                    // Simple assumption, if we are setting a parent then we must be a child
                    if (!_self[key]) {
                        _self.isChildEvt = function () { return true; };
                    }
                    _self[key] = value;
                }
                else if (key === PerfEvent.ChildrenContextKey) {
                    _self[key] = value;
                }
                else {
                    var ctx = _self[strExecutionContextKey] = _self[strExecutionContextKey] || {};
                    ctx[key] = value;
                }
            }
        };
        _self.complete = function () {
            var childTime = 0;
            var childEvts = _self.getCtx(PerfEvent.ChildrenContextKey);
            if (Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["l" /* isArray */])(childEvts)) {
                for (var lp = 0; lp < childEvts.length; lp++) {
                    var childEvt = childEvts[lp];
                    if (childEvt) {
                        childTime += childEvt.time;
                    }
                }
            }
            _self.time = Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["g" /* dateNow */])() - _self.start;
            _self.exTime = _self.time - childTime;
            _self.complete = function () { };
            if (!accessorDefined && Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["p" /* isFunction */])(payloadDetails)) {
                // If we couldn't define the property set during complete -- to minimize the perf impact until after the time
                _self.payload = payloadDetails();
            }
        };
    }
    PerfEvent.ParentContextKey = "parent";
    PerfEvent.ChildrenContextKey = "childEvts";
    return PerfEvent;
}());

var PerfManager = /** @class */ (function () {
    function PerfManager(manager) {
        /**
         * General bucket used for execution context set and retrieved via setCtx() and getCtx.
         * Defined as private so it can be visualized via the DebugPlugin
         */
        this.ctx = {};
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__["a" /* default */])(PerfManager, this, function (_self) {
            _self.create = function (src, payloadDetails, isAsync) {
                // TODO (@MSNev): at some point we will want to add additional configuration to "select" which events to instrument
                // for now this is just a simple do everything.
                return new PerfEvent(src, payloadDetails, isAsync);
            };
            _self.fire = function (perfEvent) {
                if (perfEvent) {
                    perfEvent.complete();
                    if (manager) {
                        manager.perfEvent(perfEvent);
                    }
                }
            };
            _self.setCtx = function (key, value) {
                if (key) {
                    var ctx = _self[strExecutionContextKey] = _self[strExecutionContextKey] || {};
                    ctx[key] = value;
                }
            };
            _self.getCtx = function (key) {
                return (_self[strExecutionContextKey] || {})[key];
            };
        });
    }
// Removed Stub for PerfManager.prototype.create.
// Removed Stub for PerfManager.prototype.fire.
// Removed Stub for PerfManager.prototype.setCtx.
// Removed Stub for PerfManager.prototype.getCtx.
    return PerfManager;
}());

var doPerfActiveKey = "CoreUtils.doPerf";
/**
 * Helper function to wrap a function with a perf event
 * @param mgrSource - The Performance Manager or a Performance provider source (may be null)
 * @param getSource - The callback to create the source name for the event (if perf monitoring is enabled)
 * @param func - The function to call and measure
 * @param details - A function to return the payload details
 * @param isAsync - Is the event / function being call asynchronously or synchronously
 */
function doPerf(mgrSource, getSource, func, details, isAsync) {
    if (mgrSource) {
        var perfMgr = mgrSource;
        if (perfMgr && Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["p" /* isFunction */])(perfMgr["getPerfMgr"])) {
            // Looks like a perf manager provider object
            perfMgr = perfMgr["getPerfMgr"]();
        }
        if (perfMgr) {
            var perfEvt = void 0;
            var currentActive = perfMgr.getCtx(doPerfActiveKey);
            try {
                perfEvt = perfMgr.create(getSource(), details, isAsync);
                if (perfEvt) {
                    if (currentActive && perfEvt.setCtx) {
                        perfEvt.setCtx(PerfEvent.ParentContextKey, currentActive);
                        if (currentActive.getCtx && currentActive.setCtx) {
                            var children = currentActive.getCtx(PerfEvent.ChildrenContextKey);
                            if (!children) {
                                children = [];
                                currentActive.setCtx(PerfEvent.ChildrenContextKey, children);
                            }
                            children.push(perfEvt);
                        }
                    }
                    // Set this event as the active event now
                    perfMgr.setCtx(doPerfActiveKey, perfEvt);
                    return func(perfEvt);
                }
            }
            catch (ex) {
                if (perfEvt && perfEvt.setCtx) {
                    perfEvt.setCtx("exception", ex);
                }
            }
            finally {
                // fire the perf event
                if (perfEvt) {
                    perfMgr.fire(perfEvt);
                }
                // Reset the active event to the previous value
                perfMgr.setCtx(doPerfActiveKey, currentActive);
            }
        }
    }
    return func();
}
//# sourceMappingURL=PerfManager.js.map

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = stringToBoolOrDefault;
/* harmony export (immutable) */ __webpack_exports__["d"] = msToTimeSpan;
/* harmony export (immutable) */ __webpack_exports__["b"] = isBeaconApiSupported;
/* harmony export (immutable) */ __webpack_exports__["a"] = getExtensionByName;
/* harmony export (immutable) */ __webpack_exports__["c"] = isCrossOriginError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(34);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



function stringToBoolOrDefault(str, defaultValue) {
    if (defaultValue === void 0) { defaultValue = false; }
    if (str === undefined || str === null) {
        return defaultValue;
    }
    return str.toString().toLowerCase() === "true";
}
/**
 * Convert ms to c# time span format
 */
function msToTimeSpan(totalms) {
    if (isNaN(totalms) || totalms < 0) {
        totalms = 0;
    }
    totalms = Math.round(totalms);
    var ms = "" + totalms % 1000;
    var sec = "" + Math.floor(totalms / 1000) % 60;
    var min = "" + Math.floor(totalms / (1000 * 60)) % 60;
    var hour = "" + Math.floor(totalms / (1000 * 60 * 60)) % 24;
    var days = Math.floor(totalms / (1000 * 60 * 60 * 24));
    ms = ms.length === 1 ? "00" + ms : ms.length === 2 ? "0" + ms : ms;
    sec = sec.length < 2 ? "0" + sec : sec;
    min = min.length < 2 ? "0" + min : min;
    hour = hour.length < 2 ? "0" + hour : hour;
    return (days > 0 ? days + "." : "") + hour + ":" + min + ":" + sec + "." + ms;
}
function isBeaconApiSupported() {
    var nav = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["x" /* getNavigator */])();
    return ('sendBeacon' in nav && nav.sendBeacon);
}
function getExtensionByName(extensions, identifier) {
    var extension = null;
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["e" /* arrForEach */])(extensions, function (value) {
        if (value.identifier === identifier) {
            extension = value;
            return -1;
        }
    });
    return extension;
}
function isCrossOriginError(message, url, lineNumber, columnNumber, error) {
    return !error && Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["I" /* isString */])(message) && (message === "Script error." || message === "Script error");
}
//# sourceMappingURL=HelperFuncs.js.map

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProcessTelemetryContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DiagnosticLogger__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TelemetryPluginChain__ = __webpack_require__(1500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__ = __webpack_require__(45);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






/**
 * Creates the instance execution chain for the plugins
 */
function _createProxyChain(plugins, itemCtx) {
    var proxies = [];
    if (plugins && plugins.length > 0) {
        // Create the proxies and wire up the next plugin chain
        var lastProxy = null;
        for (var idx = 0; idx < plugins.length; idx++) {
            var thePlugin = plugins[idx];
            if (thePlugin && Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["p" /* isFunction */])(thePlugin.processTelemetry)) {
                // Only add plugins that are processors
                var newProxy = new __WEBPACK_IMPORTED_MODULE_1__TelemetryPluginChain__["a" /* TelemetryPluginChain */](thePlugin, itemCtx);
                proxies.push(newProxy);
                if (lastProxy) {
                    // Set this new proxy as the next for the previous one
                    lastProxy.setNext(newProxy);
                }
                lastProxy = newProxy;
            }
        }
    }
    return proxies.length > 0 ? proxies[0] : null;
}
function _copyProxyChain(proxy, itemCtx, startAt) {
    var plugins = [];
    var add = startAt ? false : true;
    if (proxy) {
        while (proxy) {
            var thePlugin = proxy.getPlugin();
            if (add || thePlugin === startAt) {
                add = true;
                plugins.push(thePlugin);
            }
            proxy = proxy.getNext();
        }
    }
    if (!add) {
        plugins.push(startAt);
    }
    return _createProxyChain(plugins, itemCtx);
}
function _copyPluginChain(srcPlugins, itemCtx, startAt) {
    var plugins = srcPlugins;
    var add = false;
    if (startAt && srcPlugins) {
        plugins = [];
        Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["a" /* arrForEach */])(srcPlugins, function (thePlugin) {
            if (add || thePlugin === startAt) {
                add = true;
                plugins.push(thePlugin);
            }
        });
    }
    if (startAt && !add) {
        if (!plugins) {
            plugins = [];
        }
        plugins.push(startAt);
    }
    return _createProxyChain(plugins, itemCtx);
}
var ProcessTelemetryContext = /** @class */ (function () {
    /**
     * Creates a new Telemetry Item context with the current config, core and plugin execution chain
     * @param plugins - The plugin instances that will be executed
     * @param config - The current config
     * @param core - The current core instance
     */
    function ProcessTelemetryContext(plugins, config, core, startAt) {
        var _self = this;
        var _nextProxy = null; // Null == No next plugin
        // There is no next element (null) vs not defined (undefined)
        if (startAt !== null) {
            if (plugins && Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["p" /* isFunction */])(plugins.getPlugin)) {
                // We have a proxy chain object
                _nextProxy = _copyProxyChain(plugins, _self, startAt || plugins.getPlugin());
            }
            else {
                // We just have an array
                if (startAt) {
                    _nextProxy = _copyPluginChain(plugins, _self, startAt);
                }
                else if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */])(startAt)) {
                    // Undefined means copy the existing chain
                    _nextProxy = _createProxyChain(plugins, _self);
                }
            }
        }
        _self.core = function () {
            return core;
        };
        _self.diagLog = function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__DiagnosticLogger__["c" /* safeGetLogger */])(core, config);
        };
        _self.getCfg = function () {
            return config;
        };
        _self.getExtCfg = function (identifier, defaultValue) {
            if (defaultValue === void 0) { defaultValue = {}; }
            var theConfig;
            if (config) {
                var extConfig = config.extensionConfig;
                if (extConfig && identifier) {
                    theConfig = extConfig[identifier];
                }
            }
            return (theConfig ? theConfig : defaultValue);
        };
        _self.getConfig = function (identifier, field, defaultValue) {
            if (defaultValue === void 0) { defaultValue = false; }
            var theValue;
            var extConfig = _self.getExtCfg(identifier, null);
            if (extConfig && !Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */])(extConfig[field])) {
                theValue = extConfig[field];
            }
            else if (config && !Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */])(config[field])) {
                theValue = config[field];
            }
            return !Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */])(theValue) ? theValue : defaultValue;
        };
        _self.hasNext = function () {
            return _nextProxy != null;
        };
        _self.getNext = function () {
            return _nextProxy;
        };
        _self.setNext = function (nextPlugin) {
            _nextProxy = nextPlugin;
        };
        _self.processNext = function (env) {
            var nextPlugin = _nextProxy;
            if (nextPlugin) {
                // Automatically move to the next plugin
                _nextProxy = nextPlugin.getNext();
                nextPlugin.processTelemetry(env, _self);
            }
        };
        _self.createNew = function (plugins, startAt) {
            if (plugins === void 0) { plugins = null; }
            return new ProcessTelemetryContext(plugins || _nextProxy, config, core, startAt);
        };
    }
    return ProcessTelemetryContext;
}());

//# sourceMappingURL=ProcessTelemetryContext.js.map

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoggingSeverity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _InternalMessageId; });
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var LoggingSeverity;
(function (LoggingSeverity) {
    /**
     * Error will be sent as internal telemetry
     */
    LoggingSeverity[LoggingSeverity["CRITICAL"] = 1] = "CRITICAL";
    /**
     * Error will NOT be sent as internal telemetry, and will only be shown in browser console
     */
    LoggingSeverity[LoggingSeverity["WARNING"] = 2] = "WARNING";
})(LoggingSeverity || (LoggingSeverity = {}));
/**
 * Internal message ID. Please create a new one for every conceptually different message. Please keep alphabetically ordered
 */
var _InternalMessageId = {
    // Non user actionable
    BrowserDoesNotSupportLocalStorage: 0,
    BrowserCannotReadLocalStorage: 1,
    BrowserCannotReadSessionStorage: 2,
    BrowserCannotWriteLocalStorage: 3,
    BrowserCannotWriteSessionStorage: 4,
    BrowserFailedRemovalFromLocalStorage: 5,
    BrowserFailedRemovalFromSessionStorage: 6,
    CannotSendEmptyTelemetry: 7,
    ClientPerformanceMathError: 8,
    ErrorParsingAISessionCookie: 9,
    ErrorPVCalc: 10,
    ExceptionWhileLoggingError: 11,
    FailedAddingTelemetryToBuffer: 12,
    FailedMonitorAjaxAbort: 13,
    FailedMonitorAjaxDur: 14,
    FailedMonitorAjaxOpen: 15,
    FailedMonitorAjaxRSC: 16,
    FailedMonitorAjaxSend: 17,
    FailedMonitorAjaxGetCorrelationHeader: 18,
    FailedToAddHandlerForOnBeforeUnload: 19,
    FailedToSendQueuedTelemetry: 20,
    FailedToReportDataLoss: 21,
    FlushFailed: 22,
    MessageLimitPerPVExceeded: 23,
    MissingRequiredFieldSpecification: 24,
    NavigationTimingNotSupported: 25,
    OnError: 26,
    SessionRenewalDateIsZero: 27,
    SenderNotInitialized: 28,
    StartTrackEventFailed: 29,
    StopTrackEventFailed: 30,
    StartTrackFailed: 31,
    StopTrackFailed: 32,
    TelemetrySampledAndNotSent: 33,
    TrackEventFailed: 34,
    TrackExceptionFailed: 35,
    TrackMetricFailed: 36,
    TrackPVFailed: 37,
    TrackPVFailedCalc: 38,
    TrackTraceFailed: 39,
    TransmissionFailed: 40,
    FailedToSetStorageBuffer: 41,
    FailedToRestoreStorageBuffer: 42,
    InvalidBackendResponse: 43,
    FailedToFixDepricatedValues: 44,
    InvalidDurationValue: 45,
    TelemetryEnvelopeInvalid: 46,
    CreateEnvelopeError: 47,
    // User actionable
    CannotSerializeObject: 48,
    CannotSerializeObjectNonSerializable: 49,
    CircularReferenceDetected: 50,
    ClearAuthContextFailed: 51,
    ExceptionTruncated: 52,
    IllegalCharsInName: 53,
    ItemNotInArray: 54,
    MaxAjaxPerPVExceeded: 55,
    MessageTruncated: 56,
    NameTooLong: 57,
    SampleRateOutOfRange: 58,
    SetAuthContextFailed: 59,
    SetAuthContextFailedAccountName: 60,
    StringValueTooLong: 61,
    StartCalledMoreThanOnce: 62,
    StopCalledWithoutStart: 63,
    TelemetryInitializerFailed: 64,
    TrackArgumentsNotSpecified: 65,
    UrlTooLong: 66,
    SessionStorageBufferFull: 67,
    CannotAccessCookie: 68,
    IdTooLong: 69,
    InvalidEvent: 70,
    FailedMonitorAjaxSetRequestHeader: 71,
    SendBrowserInfoOnUserInit: 72,
    PluginException: 73,
    NotificationException: 74,
    SnippetScriptLoadFailure: 99,
    InvalidInstrumentationKey: 100,
    CannotParseAiBlobValue: 101,
    InvalidContentBlob: 102,
    TrackPageActionEventFailed: 103
};
//# sourceMappingURL=LoggingEnums.js.map

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PerfEvent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PerfManager; });
/* harmony export (immutable) */ __webpack_exports__["b"] = doPerf;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HelperFuncs__ = __webpack_require__(45);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var strExecutionContextKey = "ctx";
var PerfEvent = /** @class */ (function () {
    function PerfEvent(name, payloadDetails, isAsync) {
        var _self = this;
        var accessorDefined = false;
        _self.start = Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["g" /* dateNow */])();
        _self.name = name;
        _self.isAsync = isAsync;
        _self.isChildEvt = function () { return false; };
        if (Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["p" /* isFunction */])(payloadDetails)) {
            // Create an accessor to minimize the potential performance impact of executing the payloadDetails callback
            var theDetails_1;
            accessorDefined = Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["A" /* objDefineAccessors */])(_self, 'payload', function () {
                // Delay the execution of the payloadDetails until needed
                if (!theDetails_1 && Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["p" /* isFunction */])(payloadDetails)) {
                    theDetails_1 = payloadDetails();
                    // clear it out now so the referenced objects can be garbage collected
                    payloadDetails = null;
                }
                return theDetails_1;
            });
        }
        _self.getCtx = function (key) {
            if (key) {
                // The parent and child links are located directly on the object (for better viewing in the DebugPlugin)
                if (key === PerfEvent.ParentContextKey || key === PerfEvent.ChildrenContextKey) {
                    return _self[key];
                }
                return (_self[strExecutionContextKey] || {})[key];
            }
            return null;
        };
        _self.setCtx = function (key, value) {
            if (key) {
                // Put the parent and child links directly on the object (for better viewing in the DebugPlugin)
                if (key === PerfEvent.ParentContextKey) {
                    // Simple assumption, if we are setting a parent then we must be a child
                    if (!_self[key]) {
                        _self.isChildEvt = function () { return true; };
                    }
                    _self[key] = value;
                }
                else if (key === PerfEvent.ChildrenContextKey) {
                    _self[key] = value;
                }
                else {
                    var ctx = _self[strExecutionContextKey] = _self[strExecutionContextKey] || {};
                    ctx[key] = value;
                }
            }
        };
        _self.complete = function () {
            var childTime = 0;
            var childEvts = _self.getCtx(PerfEvent.ChildrenContextKey);
            if (Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["l" /* isArray */])(childEvts)) {
                for (var lp = 0; lp < childEvts.length; lp++) {
                    var childEvt = childEvts[lp];
                    if (childEvt) {
                        childTime += childEvt.time;
                    }
                }
            }
            _self.time = Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["g" /* dateNow */])() - _self.start;
            _self.exTime = _self.time - childTime;
            _self.complete = function () { };
            if (!accessorDefined && Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["p" /* isFunction */])(payloadDetails)) {
                // If we couldn't define the property set during complete -- to minimize the perf impact until after the time
                _self.payload = payloadDetails();
            }
        };
    }
    PerfEvent.ParentContextKey = "parent";
    PerfEvent.ChildrenContextKey = "childEvts";
    return PerfEvent;
}());

var PerfManager = /** @class */ (function () {
    function PerfManager(manager) {
        /**
         * General bucket used for execution context set and retrieved via setCtx() and getCtx.
         * Defined as private so it can be visualized via the DebugPlugin
         */
        this.ctx = {};
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__["a" /* default */])(PerfManager, this, function (_self) {
            _self.create = function (src, payloadDetails, isAsync) {
                // TODO (@MSNev): at some point we will want to add additional configuration to "select" which events to instrument
                // for now this is just a simple do everything.
                return new PerfEvent(src, payloadDetails, isAsync);
            };
            _self.fire = function (perfEvent) {
                if (perfEvent) {
                    perfEvent.complete();
                    if (manager) {
                        manager.perfEvent(perfEvent);
                    }
                }
            };
            _self.setCtx = function (key, value) {
                if (key) {
                    var ctx = _self[strExecutionContextKey] = _self[strExecutionContextKey] || {};
                    ctx[key] = value;
                }
            };
            _self.getCtx = function (key) {
                return (_self[strExecutionContextKey] || {})[key];
            };
        });
    }
// Removed Stub for PerfManager.prototype.create.
// Removed Stub for PerfManager.prototype.fire.
// Removed Stub for PerfManager.prototype.setCtx.
// Removed Stub for PerfManager.prototype.getCtx.
    return PerfManager;
}());

var doPerfActiveKey = "CoreUtils.doPerf";
/**
 * Helper function to wrap a function with a perf event
 * @param mgrSource - The Performance Manager or a Performance provider source (may be null)
 * @param getSource - The callback to create the source name for the event (if perf monitoring is enabled)
 * @param func - The function to call and measure
 * @param details - A function to return the payload details
 * @param isAsync - Is the event / function being call asynchronously or synchronously
 */
function doPerf(mgrSource, getSource, func, details, isAsync) {
    if (mgrSource) {
        var perfMgr = mgrSource;
        if (perfMgr && Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["p" /* isFunction */])(perfMgr["getPerfMgr"])) {
            // Looks like a perf manager provider object
            perfMgr = perfMgr["getPerfMgr"]();
        }
        if (perfMgr) {
            var perfEvt = void 0;
            var currentActive = perfMgr.getCtx(doPerfActiveKey);
            try {
                perfEvt = perfMgr.create(getSource(), details, isAsync);
                if (perfEvt) {
                    if (currentActive && perfEvt.setCtx) {
                        perfEvt.setCtx(PerfEvent.ParentContextKey, currentActive);
                        if (currentActive.getCtx && currentActive.setCtx) {
                            var children = currentActive.getCtx(PerfEvent.ChildrenContextKey);
                            if (!children) {
                                children = [];
                                currentActive.setCtx(PerfEvent.ChildrenContextKey, children);
                            }
                            children.push(perfEvt);
                        }
                    }
                    // Set this event as the active event now
                    perfMgr.setCtx(doPerfActiveKey, perfEvt);
                    return func(perfEvt);
                }
            }
            catch (ex) {
                if (perfEvt && perfEvt.setCtx) {
                    perfEvt.setCtx("exception", ex);
                }
            }
            finally {
                // fire the perf event
                if (perfEvt) {
                    perfMgr.fire(perfEvt);
                }
                // Reset the active event to the previous value
                perfMgr.setCtx(doPerfActiveKey, currentActive);
            }
        }
    }
    return func();
}
//# sourceMappingURL=PerfManager.js.map

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = stringToBoolOrDefault;
/* harmony export (immutable) */ __webpack_exports__["d"] = msToTimeSpan;
/* harmony export (immutable) */ __webpack_exports__["b"] = isBeaconApiSupported;
/* harmony export (immutable) */ __webpack_exports__["a"] = getExtensionByName;
/* harmony export (immutable) */ __webpack_exports__["c"] = isCrossOriginError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(35);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



function stringToBoolOrDefault(str, defaultValue) {
    if (defaultValue === void 0) { defaultValue = false; }
    if (str === undefined || str === null) {
        return defaultValue;
    }
    return str.toString().toLowerCase() === "true";
}
/**
 * Convert ms to c# time span format
 */
function msToTimeSpan(totalms) {
    if (isNaN(totalms) || totalms < 0) {
        totalms = 0;
    }
    totalms = Math.round(totalms);
    var ms = "" + totalms % 1000;
    var sec = "" + Math.floor(totalms / 1000) % 60;
    var min = "" + Math.floor(totalms / (1000 * 60)) % 60;
    var hour = "" + Math.floor(totalms / (1000 * 60 * 60)) % 24;
    var days = Math.floor(totalms / (1000 * 60 * 60 * 24));
    ms = ms.length === 1 ? "00" + ms : ms.length === 2 ? "0" + ms : ms;
    sec = sec.length < 2 ? "0" + sec : sec;
    min = min.length < 2 ? "0" + min : min;
    hour = hour.length < 2 ? "0" + hour : hour;
    return (days > 0 ? days + "." : "") + hour + ":" + min + ":" + sec + "." + ms;
}
function isBeaconApiSupported() {
    var nav = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["z" /* getNavigator */])();
    return ('sendBeacon' in nav && nav.sendBeacon);
}
function getExtensionByName(extensions, identifier) {
    var extension = null;
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["g" /* arrForEach */])(extensions, function (value) {
        if (value.identifier === identifier) {
            extension = value;
            return -1;
        }
    });
    return extension;
}
function isCrossOriginError(message, url, lineNumber, columnNumber, error) {
    return !error && Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["J" /* isString */])(message) && (message === "Script error." || message === "Script error");
}
//# sourceMappingURL=HelperFuncs.js.map

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = stringToBoolOrDefault;
/* harmony export (immutable) */ __webpack_exports__["d"] = msToTimeSpan;
/* harmony export (immutable) */ __webpack_exports__["b"] = isBeaconApiSupported;
/* harmony export (immutable) */ __webpack_exports__["a"] = getExtensionByName;
/* harmony export (immutable) */ __webpack_exports__["c"] = isCrossOriginError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(39);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



function stringToBoolOrDefault(str, defaultValue) {
    if (defaultValue === void 0) { defaultValue = false; }
    if (str === undefined || str === null) {
        return defaultValue;
    }
    return str.toString().toLowerCase() === "true";
}
/**
 * Convert ms to c# time span format
 */
function msToTimeSpan(totalms) {
    if (isNaN(totalms) || totalms < 0) {
        totalms = 0;
    }
    totalms = Math.round(totalms);
    var ms = "" + totalms % 1000;
    var sec = "" + Math.floor(totalms / 1000) % 60;
    var min = "" + Math.floor(totalms / (1000 * 60)) % 60;
    var hour = "" + Math.floor(totalms / (1000 * 60 * 60)) % 24;
    var days = Math.floor(totalms / (1000 * 60 * 60 * 24));
    ms = ms.length === 1 ? "00" + ms : ms.length === 2 ? "0" + ms : ms;
    sec = sec.length < 2 ? "0" + sec : sec;
    min = min.length < 2 ? "0" + min : min;
    hour = hour.length < 2 ? "0" + hour : hour;
    return (days > 0 ? days + "." : "") + hour + ":" + min + ":" + sec + "." + ms;
}
function isBeaconApiSupported() {
    var nav = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["y" /* getNavigator */])();
    return ('sendBeacon' in nav && nav.sendBeacon);
}
function getExtensionByName(extensions, identifier) {
    var extension = null;
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["f" /* arrForEach */])(extensions, function (value) {
        if (value.identifier === identifier) {
            extension = value;
            return -1;
        }
    });
    return extension;
}
function isCrossOriginError(message, url, lineNumber, columnNumber, error) {
    return !error && Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["K" /* isString */])(message) && (message === "Script error." || message === "Script error");
}
//# sourceMappingURL=HelperFuncs.js.map

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uifabric_set_version__ = __webpack_require__(145);
// office-ui-fabric-react@6.214.0
// Do not modify this file, the file is generated as part of publish. The checked in version is a placeholder only.

Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_set_version__["a" /* setVersion */])('office-ui-fabric-react', '6.214.0');
//# sourceMappingURL=version.js.map

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = serializeRuleEntries;
/* harmony export (immutable) */ __webpack_exports__["d"] = styleToRegistration;
/* harmony export (immutable) */ __webpack_exports__["a"] = applyRegistration;
/* harmony export (immutable) */ __webpack_exports__["c"] = styleToClassName;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stylesheet__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transforms_kebabRules__ = __webpack_require__(1565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transforms_prefixRules__ = __webpack_require__(1566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__transforms_provideUnits__ = __webpack_require__(1568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__transforms_rtlifyRules__ = __webpack_require__(631);





var DISPLAY_NAME = 'displayName';
function getDisplayName(rules) {
    var rootStyle = rules && rules['&'];
    return rootStyle ? rootStyle.displayName : undefined;
}
var globalSelectorRegExp = /\:global\((.+?)\)/g;
/**
 * Finds comma separated selectors in a :global() e.g. ":global(.class1, .class2, .class3)"
 * and wraps them each in their own global ":global(.class1), :global(.class2), :global(.class3)"
 *
 * @param selectorWithGlobals The selector to process
 * @returns The updated selector
 */
function expandCommaSeparatedGlobals(selectorWithGlobals) {
    // We the selector does not have a :global() we can shortcut
    if (!globalSelectorRegExp.test(selectorWithGlobals)) {
        return selectorWithGlobals;
    }
    var replacementInfo = [];
    var findGlobal = /\:global\((.+?)\)/g;
    var match = null;
    // Create a result list for global selectors so we can replace them.
    while ((match = findGlobal.exec(selectorWithGlobals))) {
        // Only if the found selector is a comma separated list we'll process it.
        if (match[1].indexOf(',') > -1) {
            replacementInfo.push([
                match.index,
                match.index + match[0].length,
                // Wrap each of the found selectors in :global()
                match[1]
                    .split(',')
                    .map(function (v) { return ":global(" + v.trim() + ")"; })
                    .join(', ')
            ]);
        }
    }
    // Replace the found selectors with their wrapped variants in reverse order
    return replacementInfo.reverse().reduce(function (selector, _a) {
        var matchIndex = _a[0], matchEndIndex = _a[1], replacement = _a[2];
        var prefix = selector.slice(0, matchIndex);
        var suffix = selector.slice(matchEndIndex);
        return prefix + replacement + suffix;
    }, selectorWithGlobals);
}
function expandSelector(newSelector, currentSelector) {
    if (newSelector.indexOf(':global(') >= 0) {
        return newSelector.replace(globalSelectorRegExp, '$1');
    }
    else if (newSelector.indexOf(':') === 0) {
        return currentSelector + newSelector;
    }
    else if (newSelector.indexOf('&') < 0) {
        return currentSelector + ' ' + newSelector;
    }
    return newSelector;
}
function extractRules(args, rules, currentSelector) {
    if (rules === void 0) { rules = { __order: [] }; }
    if (currentSelector === void 0) { currentSelector = '&'; }
    var stylesheet = __WEBPACK_IMPORTED_MODULE_0__Stylesheet__["a" /* Stylesheet */].getInstance();
    var currentRules = rules[currentSelector];
    if (!currentRules) {
        currentRules = {};
        rules[currentSelector] = currentRules;
        rules.__order.push(currentSelector);
    }
    for (var _i = 0, args_1 = args; _i < args_1.length; _i++) {
        var arg = args_1[_i];
        // If the arg is a string, we need to look up the class map and merge.
        if (typeof arg === 'string') {
            var expandedRules = stylesheet.argsFromClassName(arg);
            if (expandedRules) {
                extractRules(expandedRules, rules, currentSelector);
            }
            // Else if the arg is an array, we need to recurse in.
        }
        else if (Array.isArray(arg)) {
            extractRules(arg, rules, currentSelector);
        }
        else {
            // tslint:disable-next-line:no-any
            for (var prop in arg) {
                if (prop === 'selectors') {
                    // tslint:disable-next-line:no-any
                    var selectors = arg.selectors;
                    for (var newSelector in selectors) {
                        if (selectors.hasOwnProperty(newSelector)) {
                            var selectorValue = selectors[newSelector];
                            if (newSelector.indexOf('@') === 0) {
                                newSelector = newSelector + '{' + currentSelector;
                                extractRules([selectorValue], rules, newSelector);
                            }
                            else if (newSelector.indexOf(',') > -1) {
                                var commaSeparatedSelectors = expandCommaSeparatedGlobals(newSelector)
                                    .split(/,/g)
                                    .map(function (s) { return s.trim(); });
                                extractRules([selectorValue], rules, commaSeparatedSelectors
                                    .map(function (commaSeparatedSelector) { return expandSelector(commaSeparatedSelector, currentSelector); })
                                    .join(', '));
                            }
                            else {
                                extractRules([selectorValue], rules, expandSelector(newSelector, currentSelector));
                            }
                        }
                    }
                }
                else {
                    if (arg[prop] !== undefined) {
                        // Else, add the rule to the currentSelector.
                        if (prop === 'margin' || prop === 'padding') {
                            // tslint:disable-next-line:no-any
                            expandQuads(currentRules, prop, arg[prop]);
                        }
                        else {
                            // tslint:disable-next-line:no-any
                            currentRules[prop] = arg[prop];
                        }
                    }
                }
            }
        }
    }
    return rules;
}
function expandQuads(currentRules, name, value) {
    var parts = typeof value === 'string' ? value.split(' ') : [value];
    currentRules[name + 'Top'] = parts[0];
    currentRules[name + 'Right'] = parts[1] || parts[0];
    currentRules[name + 'Bottom'] = parts[2] || parts[0];
    currentRules[name + 'Left'] = parts[3] || parts[1] || parts[0];
}
function getKeyForRules(rules) {
    var serialized = [];
    var hasProps = false;
    for (var _i = 0, _a = rules.__order; _i < _a.length; _i++) {
        var selector = _a[_i];
        serialized.push(selector);
        var rulesForSelector = rules[selector];
        for (var propName in rulesForSelector) {
            if (rulesForSelector.hasOwnProperty(propName) && rulesForSelector[propName] !== undefined) {
                hasProps = true;
                serialized.push(propName, rulesForSelector[propName]);
            }
        }
    }
    return hasProps ? serialized.join('') : undefined;
}
function serializeRuleEntries(ruleEntries) {
    if (!ruleEntries) {
        return '';
    }
    var allEntries = [];
    for (var entry in ruleEntries) {
        if (ruleEntries.hasOwnProperty(entry) && entry !== DISPLAY_NAME && ruleEntries[entry] !== undefined) {
            allEntries.push(entry, ruleEntries[entry]);
        }
    }
    // Apply transforms.
    for (var i = 0; i < allEntries.length; i += 2) {
        Object(__WEBPACK_IMPORTED_MODULE_1__transforms_kebabRules__["a" /* kebabRules */])(allEntries, i);
        Object(__WEBPACK_IMPORTED_MODULE_3__transforms_provideUnits__["a" /* provideUnits */])(allEntries, i);
        Object(__WEBPACK_IMPORTED_MODULE_4__transforms_rtlifyRules__["a" /* rtlifyRules */])(allEntries, i);
        Object(__WEBPACK_IMPORTED_MODULE_2__transforms_prefixRules__["a" /* prefixRules */])(allEntries, i);
    }
    // Apply punctuation.
    for (var i = 1; i < allEntries.length; i += 4) {
        allEntries.splice(i, 1, ':', allEntries[i], ';');
    }
    return allEntries.join('');
}
function styleToRegistration() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var rules = extractRules(args);
    var key = getKeyForRules(rules);
    if (key) {
        var stylesheet = __WEBPACK_IMPORTED_MODULE_0__Stylesheet__["a" /* Stylesheet */].getInstance();
        var registration = {
            className: stylesheet.classNameFromKey(key),
            key: key,
            args: args
        };
        if (!registration.className) {
            registration.className = stylesheet.getClassName(getDisplayName(rules));
            var rulesToInsert = [];
            for (var _a = 0, _b = rules.__order; _a < _b.length; _a++) {
                var selector = _b[_a];
                rulesToInsert.push(selector, serializeRuleEntries(rules[selector]));
            }
            registration.rulesToInsert = rulesToInsert;
        }
        return registration;
    }
}
function applyRegistration(registration, classMap) {
    var stylesheet = __WEBPACK_IMPORTED_MODULE_0__Stylesheet__["a" /* Stylesheet */].getInstance();
    var className = registration.className, key = registration.key, args = registration.args, rulesToInsert = registration.rulesToInsert;
    if (rulesToInsert) {
        // rulesToInsert is an ordered array of selector/rule pairs.
        for (var i = 0; i < rulesToInsert.length; i += 2) {
            var rules = rulesToInsert[i + 1];
            if (rules) {
                var selector = rulesToInsert[i];
                // Fix selector using map.
                selector = selector.replace(/(&)|\$([\w-]+)\b/g, function (match, amp, cn) {
                    if (amp) {
                        return '.' + registration.className;
                    }
                    else if (cn) {
                        return '.' + ((classMap && classMap[cn]) || cn);
                    }
                    return '';
                });
                // Insert. Note if a media query, we must close the query with a final bracket.
                var processedRule = selector + "{" + rules + "}" + (selector.indexOf('@') === 0 ? '}' : '');
                stylesheet.insertRule(processedRule);
            }
        }
        stylesheet.cacheClassName(className, key, args, rulesToInsert);
    }
}
function styleToClassName() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var registration = styleToRegistration.apply(void 0, args);
    if (registration) {
        applyRegistration(registration);
        return registration.className;
    }
    return '';
}
//# sourceMappingURL=styleToClassName.js.map

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__object__ = __webpack_require__(383);
/* tslint:disable:no-string-literal */

/** An instance of EventGroup allows anything with a handle to it to trigger events on it.
 *  If the target is an HTMLElement, the event will be attached to the element and can be
 *  triggered as usual (like clicking for onclick).
 *  The event can be triggered by calling EventGroup.raise() here. If the target is an
 *  HTMLElement, the event gets raised and is handled by the browser. Otherwise, it gets
 *  handled here in EventGroup, and the handler is called in the context of the parent
 *  (which is passed in in the constructor).
 *
 * @public
 * {@docCategory EventGroup}
 */
var EventGroup = /** @class */ (function () {
    /** parent: the context in which events attached to non-HTMLElements are called */
    // tslint:disable-next-line:no-any
    function EventGroup(parent) {
        this._id = EventGroup._uniqueId++;
        this._parent = parent;
        this._eventRecords = [];
    }
    /** For IE8, bubbleEvent is ignored here and must be dealt with by the handler.
     *  Events raised here by default have bubbling set to false and cancelable set to true.
     *  This applies also to built-in events being raised manually here on HTMLElements,
     *  which may lead to unexpected behavior if it differs from the defaults.
     *
     */
    EventGroup.raise = function (
    // tslint:disable-next-line:no-any
    target, eventName, 
    // tslint:disable-next-line:no-any
    eventArgs, bubbleEvent) {
        var retVal;
        if (EventGroup._isElement(target)) {
            if (typeof document !== 'undefined' && document.createEvent) {
                var ev = document.createEvent('HTMLEvents');
                ev.initEvent(eventName, bubbleEvent || false, true);
                Object(__WEBPACK_IMPORTED_MODULE_0__object__["a" /* assign */])(ev, eventArgs);
                retVal = target.dispatchEvent(ev);
                // tslint:disable-next-line:no-any
            }
            else if (typeof document !== 'undefined' && document['createEventObject']) {
                // IE8
                // tslint:disable-next-line:no-any
                var evObj = document['createEventObject'](eventArgs);
                // cannot set cancelBubble on evObj, fireEvent will overwrite it
                target.fireEvent('on' + eventName, evObj);
            }
        }
        else {
            while (target && retVal !== false) {
                var events = target.__events__;
                var eventRecords = events ? events[eventName] : null;
                if (eventRecords) {
                    for (var id in eventRecords) {
                        if (eventRecords.hasOwnProperty(id)) {
                            var eventRecordList = eventRecords[id];
                            for (var listIndex = 0; retVal !== false && listIndex < eventRecordList.length; listIndex++) {
                                var record = eventRecordList[listIndex];
                                if (record.objectCallback) {
                                    retVal = record.objectCallback.call(record.parent, eventArgs);
                                }
                            }
                        }
                    }
                }
                // If the target has a parent, bubble the event up.
                target = bubbleEvent ? target.parent : null;
            }
        }
        return retVal;
    };
    // tslint:disable-next-line:no-any
    EventGroup.isObserved = function (target, eventName) {
        var events = target && target.__events__;
        return !!events && !!events[eventName];
    };
    /** Check to see if the target has declared support of the given event. */
    // tslint:disable-next-line:no-any
    EventGroup.isDeclared = function (target, eventName) {
        var declaredEvents = target && target.__declaredEvents;
        return !!declaredEvents && !!declaredEvents[eventName];
    };
    // tslint:disable-next-line:no-any
    EventGroup.stopPropagation = function (event) {
        if (event.stopPropagation) {
            event.stopPropagation();
        }
        else {
            // IE8
            event.cancelBubble = true;
        }
    };
    EventGroup._isElement = function (target) {
        return !!target && (!!target.addEventListener || (typeof HTMLElement !== 'undefined' && target instanceof HTMLElement));
    };
    EventGroup.prototype.dispose = function () {
        if (!this._isDisposed) {
            this._isDisposed = true;
            this.off();
            this._parent = null;
        }
    };
    /** On the target, attach a set of events, where the events object is a name to function mapping. */
    // tslint:disable-next-line:no-any
    EventGroup.prototype.onAll = function (target, events, useCapture) {
        for (var eventName in events) {
            if (events.hasOwnProperty(eventName)) {
                this.on(target, eventName, events[eventName], useCapture);
            }
        }
    };
    /** On the target, attach an event whose handler will be called in the context of the parent
     * of this instance of EventGroup.
     */
    // tslint:disable-next-line:no-any
    EventGroup.prototype.on = function (target, eventName, callback, options) {
        var _this = this;
        if (eventName.indexOf(',') > -1) {
            var events = eventName.split(/[ ,]+/);
            for (var i = 0; i < events.length; i++) {
                this.on(target, events[i], callback, options);
            }
        }
        else {
            var parent_1 = this._parent;
            var eventRecord = {
                target: target,
                eventName: eventName,
                parent: parent_1,
                callback: callback,
                options: options
            };
            // Initialize and wire up the record on the target, so that it can call the callback if the event fires.
            var events = (target.__events__ = target.__events__ || {});
            events[eventName] =
                events[eventName] ||
                    {
                        count: 0
                    };
            events[eventName][this._id] = events[eventName][this._id] || [];
            events[eventName][this._id].push(eventRecord);
            events[eventName].count++;
            if (EventGroup._isElement(target)) {
                // tslint:disable-next-line:no-any
                var processElementEvent = function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    if (_this._isDisposed) {
                        return;
                    }
                    var result;
                    try {
                        result = callback.apply(parent_1, args);
                        if (result === false && args[0]) {
                            var e = args[0];
                            if (e.preventDefault) {
                                e.preventDefault();
                            }
                            if (e.stopPropagation) {
                                e.stopPropagation();
                            }
                            e.cancelBubble = true;
                        }
                    }
                    catch (e) {
                        /* ErrorHelper.log(e); */
                    }
                    return result;
                };
                eventRecord.elementCallback = processElementEvent;
                if (target.addEventListener) {
                    /* tslint:disable:ban-native-functions */
                    target.addEventListener(eventName, processElementEvent, options);
                    /* tslint:enable:ban-native-functions */
                }
                else if (target.attachEvent) {
                    // IE8
                    target.attachEvent('on' + eventName, processElementEvent);
                }
            }
            else {
                // tslint:disable-next-line:no-any
                var processObjectEvent = function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    if (_this._isDisposed) {
                        return;
                    }
                    return callback.apply(parent_1, args);
                };
                eventRecord.objectCallback = processObjectEvent;
            }
            // Remember the record locally, so that it can be removed.
            this._eventRecords.push(eventRecord);
        }
    };
    // tslint:disable-next-line:no-any
    EventGroup.prototype.off = function (target, eventName, callback, options) {
        for (var i = 0; i < this._eventRecords.length; i++) {
            var eventRecord = this._eventRecords[i];
            if ((!target || target === eventRecord.target) &&
                (!eventName || eventName === eventRecord.eventName) &&
                (!callback || callback === eventRecord.callback) &&
                (typeof options !== 'boolean' || options === eventRecord.options)) {
                var events = eventRecord.target.__events__;
                var targetArrayLookup = events[eventRecord.eventName];
                var targetArray = targetArrayLookup ? targetArrayLookup[this._id] : null;
                // We may have already target's entries, so check for null.
                if (targetArray) {
                    if (targetArray.length === 1 || !callback) {
                        targetArrayLookup.count -= targetArray.length;
                        delete events[eventRecord.eventName][this._id];
                    }
                    else {
                        targetArrayLookup.count--;
                        targetArray.splice(targetArray.indexOf(eventRecord), 1);
                    }
                    if (!targetArrayLookup.count) {
                        delete events[eventRecord.eventName];
                    }
                }
                if (eventRecord.elementCallback) {
                    if (eventRecord.target.removeEventListener) {
                        eventRecord.target.removeEventListener(eventRecord.eventName, eventRecord.elementCallback, eventRecord.options);
                    }
                    else if (eventRecord.target.detachEvent) {
                        // IE8
                        eventRecord.target.detachEvent('on' + eventRecord.eventName, eventRecord.elementCallback);
                    }
                }
                this._eventRecords.splice(i--, 1);
            }
        }
    };
    /** Trigger the given event in the context of this instance of EventGroup. */
    // tslint:disable-next-line:no-any
    EventGroup.prototype.raise = function (eventName, eventArgs, bubbleEvent) {
        return EventGroup.raise(this._parent, eventName, eventArgs, bubbleEvent);
    };
    /** Declare an event as being supported by this instance of EventGroup. */
    EventGroup.prototype.declare = function (event) {
        var declaredEvents = (this._parent.__declaredEvents = this._parent.__declaredEvents || {});
        if (typeof event === 'string') {
            declaredEvents[event] = true;
        }
        else {
            for (var i = 0; i < event.length; i++) {
                declaredEvents[event[i]] = true;
            }
        }
    };
    // tslint:disable-next-line:no-inferrable-types
    EventGroup._uniqueId = 0;
    return EventGroup;
}());

//# sourceMappingURL=EventGroup.js.map

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warn;
/* unused harmony export setWarningCallback */
var _warningCallback = undefined;
/**
 * Sends a warning to console, if the api is present.
 *
 * @public
 * @param message - Warning message.
 */
function warn(message) {
    if (_warningCallback && "production" !== 'production') {
        _warningCallback(message);
    }
    else if (console && console.warn) {
        console.warn(message);
    }
}
/**
 * Configures the warning callback. Passing in undefined will reset it to use the default
 * console.warn function.
 *
 * @public
 * @param warningCallback - Callback to override the generated warnings.
 */
function setWarningCallback(warningCallback) {
    _warningCallback = warningCallback;
}
//# sourceMappingURL=warn.js.map

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Customizations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GlobalSettings__ = __webpack_require__(643);


var CustomizationsGlobalKey = 'customizations';
var NO_CUSTOMIZATIONS = { settings: {}, scopedSettings: {}, inCustomizerContext: false };
var _allSettings = __WEBPACK_IMPORTED_MODULE_1__GlobalSettings__["a" /* GlobalSettings */].getValue(CustomizationsGlobalKey, {
    settings: {},
    scopedSettings: {},
    inCustomizerContext: false
});
var _events = [];
var Customizations = /** @class */ (function () {
    function Customizations() {
    }
    Customizations.reset = function () {
        _allSettings.settings = {};
        _allSettings.scopedSettings = {};
    };
    /** Apply global Customization settings.
     * @example Customizations.applySettings(\{ theme: \{...\} \});
     */
    Customizations.applySettings = function (settings) {
        _allSettings.settings = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, _allSettings.settings, settings);
        Customizations._raiseChange();
    };
    /** Apply Customizations to a particular named scope, like a component.
     * @example Customizations.applyScopedSettings('Nav', \{ styles: () =\> \{\} \});
     */
    Customizations.applyScopedSettings = function (scopeName, settings) {
        _allSettings.scopedSettings[scopeName] = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, _allSettings.scopedSettings[scopeName], settings);
        Customizations._raiseChange();
    };
    Customizations.getSettings = function (properties, scopeName, localSettings
    // tslint:disable-next-line:no-any
    ) {
        if (localSettings === void 0) { localSettings = NO_CUSTOMIZATIONS; }
        var settings = {};
        var localScopedSettings = (scopeName && localSettings.scopedSettings[scopeName]) || {};
        var globalScopedSettings = (scopeName && _allSettings.scopedSettings[scopeName]) || {};
        for (var _i = 0, properties_1 = properties; _i < properties_1.length; _i++) {
            var property = properties_1[_i];
            settings[property] =
                localScopedSettings[property] ||
                    localSettings.settings[property] ||
                    globalScopedSettings[property] ||
                    _allSettings.settings[property];
        }
        return settings;
    };
    /** Used to run some code that sets Customizations without triggering an update until the end.
     * Useful for applying Customizations that don't affect anything currently rendered, or for
     * applying many customizations at once.
     * @param suppressUpdate - Do not raise the change event at the end, preventing all updates
     */
    Customizations.applyBatchedUpdates = function (code, suppressUpdate) {
        Customizations._suppressUpdates = true;
        try {
            code();
        }
        catch ( /* do nothing */_a) { /* do nothing */ }
        Customizations._suppressUpdates = false;
        if (!suppressUpdate) {
            Customizations._raiseChange();
        }
    };
    Customizations.observe = function (onChange) {
        _events.push(onChange);
    };
    Customizations.unobserve = function (onChange) {
        _events = _events.filter(function (cb) { return cb !== onChange; });
    };
    Customizations._raiseChange = function () {
        if (!Customizations._suppressUpdates) {
            _events.forEach(function (cb) { return cb(); });
        }
    };
    return Customizations;
}());

//# sourceMappingURL=Customizations.js.map

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CustomizerContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var CustomizerContext = __WEBPACK_IMPORTED_MODULE_0_react__["createContext"]({
    customizations: {
        inCustomizerContext: false,
        settings: {},
        scopedSettings: {}
    }
});
//# sourceMappingURL=CustomizerContext.js.map

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getParent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getVirtualParent__ = __webpack_require__(649);

/**
 * Gets the element which is the parent of a given element.
 * If `allowVirtuaParents` is `true`, this method prefers the virtual parent over
 * real DOM parent when present.
 *
 * @public
 */
function getParent(child, allowVirtualParents) {
    if (allowVirtualParents === void 0) { allowVirtualParents = true; }
    return child && ((allowVirtualParents && Object(__WEBPACK_IMPORTED_MODULE_0__getVirtualParent__["a" /* getVirtualParent */])(child)) || (child.parentNode && child.parentNode));
}
//# sourceMappingURL=getParent.js.map

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = extendComponent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appendFunction__ = __webpack_require__(644);

/**
 * Extends a component's lifetime methods by appending new functions to the existing lifetime functions.
 */
function extendComponent(parent, methods) {
    for (var name_1 in methods) {
        if (methods.hasOwnProperty(name_1)) {
            // tslint:disable-next-line:no-any
            parent[name_1] = Object(__WEBPACK_IMPORTED_MODULE_0__appendFunction__["a" /* appendFunction */])(parent, parent[name_1], methods[name_1]);
        }
    }
}
//# sourceMappingURL=extendComponent.js.map

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SaleStore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_stores_UserStore__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_stores_WebSocketStore__ = __webpack_require__(1659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SaleUiStore__ = __webpack_require__(1673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SaleEditStore__ = __webpack_require__(1676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OffersStore__ = __webpack_require__(1677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RoundStore__ = __webpack_require__(1678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CommandBarStore__ = __webpack_require__(1679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__build_src_app_services_request__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__BiddingStore__ = __webpack_require__(1680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__WhitelistingStore__ = __webpack_require__(1681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_prepareConfig__ = __webpack_require__(391);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_dec2,_desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var defaultStatus='NotStarted';var SaleStore=(_dec=__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["c" /* action */].bound,_dec2=__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["c" /* action */].bound,(_class=function(){_createClass(SaleStore,[{key:'isMls',get:function get(){return this.mls&&this.mls!=='none';}},{key:'isTest',get:function get(){return this.features&&this.features.test;}},{key:'roundDefinition',get:function get(){return this.round.definition;}},{key:'isDeleted',get:function get(){return this.status==='deleted';}},{key:'isClosed',get:function get(){return this.status==='closed';}},{key:'isComplete',get:function get(){return this.isValid;}},{key:'hasSalePermissions',get:function get(){return this.user.hasPermissions(this.saleEdit.agentData);}},{key:'hasExclusiveOfferPermissions',get:function get(){var selectedOffer=this.offers.selectedOffer;return selectedOffer&&this.user.hasPermissions(selectedOffer.agentData);}},{key:'hasOfferPermissions',get:function get(){return this.hasSalePermissions||this.hasExclusiveOfferPermissions;}},{key:'saleConfig',get:function get(){return Object(__WEBPACK_IMPORTED_MODULE_11__helpers_prepareConfig__["a" /* prepareSaleConfig */])(this.user.app.config,this.user.app.data,this.user.claims,this);}}]);function SaleStore(user,socket){var _this=this;_classCallCheck(this,SaleStore);_initDefineProp(this,'saleAgentData',_descriptor,this);_initDefineProp(this,'mls',_descriptor2,this);_initDefineProp(this,'inviteOnly',_descriptor3,this);_initDefineProp(this,'features',_descriptor4,this);_initDefineProp(this,'integrations',_descriptor5,this);_initDefineProp(this,'status',_descriptor6,this);_initDefineProp(this,'isValid',_descriptor7,this);_initDefineProp(this,'saleId',_descriptor8,this);_initDefineProp(this,'item',_descriptor9,this);_initDefineProp(this,'response',_descriptor10,this);_initDefineProp(this,'error',_descriptor11,this);this.user=user;this.socket=socket;this.socket.received=function(message){return _this.received(message);};this.ui=new __WEBPACK_IMPORTED_MODULE_3__SaleUiStore__["a" /* default */]({root:this});this.saleEdit=new __WEBPACK_IMPORTED_MODULE_4__SaleEditStore__["a" /* default */]({root:this});this.offers=new __WEBPACK_IMPORTED_MODULE_5__OffersStore__["a" /* default */]({root:this});this.round=new __WEBPACK_IMPORTED_MODULE_6__RoundStore__["a" /* default */]({root:this});this.cmdBar=new __WEBPACK_IMPORTED_MODULE_7__CommandBarStore__["a" /* default */]({root:this});this.bidding=new __WEBPACK_IMPORTED_MODULE_9__BiddingStore__["a" /* default */]({offers:this.offers});this.whitelisting=new __WEBPACK_IMPORTED_MODULE_10__WhitelistingStore__["a" /* default */]({root:this});}_createClass(SaleStore,[{key:'start',value:function start(item){return Object(__WEBPACK_IMPORTED_MODULE_8__build_src_app_services_request__["e" /* post */])('/api/v1/sales',item,this.user.accessToken).then(this.success,this.failed);}},{key:'success',value:function success(body){this.response=body;this.error=null;}},{key:'failed',value:function failed(err){this.error={message:err.message,code:!!err.response&&!!err.response.result?err.response.result.error:''};}},{key:'received',value:function received(message){var _this2=this;if(message.offers!==undefined){this.offers.update(message.offers);if(!!message.offers.lastCorrelationUpdateId){this.ui.loading.done(message.offers.lastCorrelationUpdateId);}}if(!!message.openBidding){this.bidding.update(message.openBidding);}if(!!message.whitelisting){this.whitelisting.update(message.whitelisting);}if(!message.sale){return;}var _message$sale=message.sale,status=_message$sale.status,isValid=_message$sale.isValid,isValidExplanation=_message$sale.isValidExplanation,item=_message$sale.item,round=_message$sale.round,saleId=_message$sale.saleId,currencyCode=_message$sale.currencyCode,locale=_message$sale.locale,offerData=_message$sale.offerData,agentData=_message$sale.agentData,docs=_message$sale.docs,notifications=_message$sale.notifications,mls=_message$sale.mls,features=_message$sale.features,integrations=_message$sale.integrations,invitedSeller=_message$sale.invitedSeller,invitedSellerBlocked=_message$sale.invitedSellerBlocked,inviteOnly=_message$sale.inviteOnly,whitelistedUsers=_message$sale.whitelistedUsers,rest=_objectWithoutProperties(_message$sale,['status','isValid','isValidExplanation','item','round','saleId','currencyCode','locale','offerData','agentData','docs','notifications','mls','features','integrations','invitedSeller','invitedSellerBlocked','inviteOnly','whitelistedUsers']);if(this.status!==status){this.status=status;}if(item&&item.updatedAt!==this.item.updatedAt){this.item=item;}if(round&&round.updatedAt!==this.round.definition.updatedAt){this.round.definition=round;}if(this.isValid!==isValid){this.isValid=isValid;}if(currencyCode){this.saleEdit.currencyCode=currencyCode;}if(locale){this.saleEdit.locale=locale;}if(offerData){this.saleEdit.offerData=offerData;}if(agentData){// construct agentData for compatibility
var enhancedAgentData=Object.assign({tenant:rest.tenant,sub:rest.createdBy},agentData);this.saleEdit.agentData=enhancedAgentData;this.saleAgentData=enhancedAgentData;}if(notifications){// prepare notifications
this.saleEdit.notifications=notifications.some(function(n){return(// n.name === this.user.claims.name &&
n.email===_this2.user.claims.email&&(n.phoneNumber===_this2.user.claims.phone||n.phoneNumber===_this2.user.claims.phone_number));})?notifications:[].concat(_toConsumableArray(notifications),[{name:this.user.claims.name,role:'agent',enabled:false,locale:this.user.claims.locale,email:this.user.claims.email,phoneNumber:this.user.claims.phone||this.user.claims.phone_number}]);}if(docs){this.saleEdit.docs=docs;}this.saleEdit.invitedSeller={data:invitedSeller,blocked:invitedSellerBlocked};this.mls=mls;this.inviteOnly=inviteOnly;this.features=features;this.integrations=integrations;this.saleId=saleId||this.saleId;// if (!isValid && isValidExplanation) console.log(isValidExplanation);
var hasAccess=this.hasSalePermissions;if(hasAccess)return;if(this.isMls){var userTenant=this.user.profile.tenant||this.app.tenant;hasAccess=this.mls!=='tenant'||rest.tenant===userTenant;hasAccess=hasAccess&&(!inviteOnly||inviteOnly&&whitelistedUsers.some(function(u){return u===_this2.user.profile.sub;}));}if(!hasAccess){this.socket.onAccessDenied();}}},{key:'connect',value:function connect(uri){this.socket.connect(uri);}},{key:'disconnect',value:function disconnect(){this.socket.disconnect();}},{key:'clearError',value:function clearError(){this.error=null;this.round.reqError=null;this.offers.reqError=null;}},{key:'clearResponse',value:function clearResponse(){this.response={};}},{key:'reset',value:function reset(){this.saleId=null;this.isValid=false;this.item={};this.offerData={};this.agentData={};this.status=defaultStatus;this.response={};this.error=null;this.round.reset();this.offers.reset();this.saleEdit.reset();this.bidding.reset();this.ui.prompt.close();this.ui.loading.clear();}},{key:'connected',get:function get(){return this.socket.connected;}},{key:'forbidden',get:function get(){return this.socket.forbidden;}},{key:'notFound',get:function get(){return this.socket.notFound;}},{key:'unavailable',get:function get(){return this.socket.unavailable;}}]);return SaleStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'saleAgentData',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'mls',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'inviteOnly',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'features',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'integrations',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return null;}}),_applyDecoratedDescriptor(_class.prototype,'isMls',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isMls'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isTest',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isTest'),_class.prototype),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'status',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return defaultStatus;}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'isValid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'saleId',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'item',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'response',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'error',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return null;}}),_applyDecoratedDescriptor(_class.prototype,'roundDefinition',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'roundDefinition'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isDeleted',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isDeleted'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isClosed',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isClosed'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isComplete',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isComplete'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'hasSalePermissions',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'hasSalePermissions'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'hasExclusiveOfferPermissions',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'hasExclusiveOfferPermissions'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'hasOfferPermissions',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'hasOfferPermissions'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'saleConfig',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'saleConfig'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'start',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'start'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'success',[_dec],Object.getOwnPropertyDescriptor(_class.prototype,'success'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'failed',[_dec2],Object.getOwnPropertyDescriptor(_class.prototype,'failed'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'received',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'received'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'connect',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'connect'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'disconnect',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'disconnect'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'connected',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'connected'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'forbidden',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'forbidden'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'notFound',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'notFound'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'unavailable',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'unavailable'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'clearError',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'clearError'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'clearResponse',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'clearResponse'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'reset',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'reset'),_class.prototype)),_class));var sale=new SaleStore(__WEBPACK_IMPORTED_MODULE_1__App_stores_UserStore__["a" /* default */],new __WEBPACK_IMPORTED_MODULE_2__App_stores_WebSocketStore__["a" /* WebSocketStore */](__WEBPACK_IMPORTED_MODULE_1__App_stores_UserStore__["a" /* default */]));/* harmony default export */ __webpack_exports__["a"] = (sale);

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HttpResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HttpClient; });
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
/** Represents an HTTP response. */
var HttpResponse = /** @class */ (function () {
    function HttpResponse(statusCode, statusText, content) {
        this.statusCode = statusCode;
        this.statusText = statusText;
        this.content = content;
    }
    return HttpResponse;
}());

/** Abstraction over an HTTP client.
 *
 * This class provides an abstraction over an HTTP client so that a different implementation can be provided on different platforms.
 */
var HttpClient = /** @class */ (function () {
    function HttpClient() {
    }
    HttpClient.prototype.get = function (url, options) {
        return this.send(__assign({}, options, { method: "GET", url: url }));
    };
    HttpClient.prototype.post = function (url, options) {
        return this.send(__assign({}, options, { method: "POST", url: url }));
    };
    HttpClient.prototype.delete = function (url, options) {
        return this.send(__assign({}, options, { method: "DELETE", url: url }));
    };
    /** Gets all cookies that apply to the specified URL.
     *
     * @param url The URL that the cookies are valid for.
     * @returns {string} A string containing all the key-value cookie pairs for the specified URL.
     */
    // @ts-ignore
    HttpClient.prototype.getCookieString = function (url) {
        return "";
    };
    return HttpClient;
}());

//# sourceMappingURL=HttpClient.js.map

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NullLogger; });
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
/** A logger that does nothing when log messages are sent to it. */
var NullLogger = /** @class */ (function () {
    function NullLogger() {
    }
    /** @inheritDoc */
    // tslint:disable-next-line
    NullLogger.prototype.log = function (_logLevel, _message) {
    };
    /** The singleton instance of the {@link @microsoft/signalr.NullLogger}. */
    NullLogger.instance = new NullLogger();
    return NullLogger;
}());

//# sourceMappingURL=Loggers.js.map

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_GroupedList_index__ = __webpack_require__(1700);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_GroupedList_index__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__components_GroupedList_index__["b"]; });

//# sourceMappingURL=GroupedList.js.map

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return KTP_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return KTP_SEPARATOR; });
/* unused harmony export KTP_FULL_PREFIX */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DATAKTP_TARGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DATAKTP_EXECUTE_TARGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return KTP_LAYER_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return KTP_ARIA_SEPARATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return KeytipEvents; });
var KTP_PREFIX = 'ktp';
var KTP_SEPARATOR = '-';
var KTP_FULL_PREFIX = KTP_PREFIX + KTP_SEPARATOR;
var DATAKTP_TARGET = 'data-ktp-target';
var DATAKTP_EXECUTE_TARGET = 'data-ktp-execute-target';
var KTP_LAYER_ID = 'ktp-layer-id';
var KTP_ARIA_SEPARATOR = ', ';
// Events
var KeytipEvents;
(function (KeytipEvents) {
    KeytipEvents.KEYTIP_ADDED = 'keytipAdded';
    KeytipEvents.KEYTIP_REMOVED = 'keytipRemoved';
    KeytipEvents.KEYTIP_UPDATED = 'keytipUpdated';
    KeytipEvents.PERSISTED_KEYTIP_ADDED = 'persistedKeytipAdded';
    KeytipEvents.PERSISTED_KEYTIP_REMOVED = 'persistedKeytipRemoved';
    KeytipEvents.PERSISTED_KEYTIP_EXECUTE = 'persistedKeytipExecute';
    KeytipEvents.ENTER_KEYTIP_MODE = 'enterKeytipMode';
    KeytipEvents.EXIT_KEYTIP_MODE = 'exitKeytipMode';
})(KeytipEvents || (KeytipEvents = {}));
//# sourceMappingURL=KeytipConstants.js.map

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = sequencesToID;
/* harmony export (immutable) */ __webpack_exports__["d"] = mergeOverflows;
/* harmony export (immutable) */ __webpack_exports__["c"] = ktpTargetFromSequences;
/* harmony export (immutable) */ __webpack_exports__["b"] = ktpTargetFromId;
/* harmony export (immutable) */ __webpack_exports__["a"] = getAriaDescribedBy;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__KeytipConstants__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utilities__ = __webpack_require__(1);


/**
 * Converts a whole set of KeySequences into one keytip ID, which will be the ID for the last keytip sequence specified
 * keySequences should not include the initial keytip 'start' sequence.
 *
 * @param keySequences - Full path of IKeySequences for one keytip.
 * @returns {string} String to use for the keytip ID.
 */
function sequencesToID(keySequences) {
    return keySequences.reduce(function (prevValue, keySequence) {
        return prevValue + __WEBPACK_IMPORTED_MODULE_0__KeytipConstants__["f" /* KTP_SEPARATOR */] + keySequence.split('').join(__WEBPACK_IMPORTED_MODULE_0__KeytipConstants__["f" /* KTP_SEPARATOR */]);
    }, __WEBPACK_IMPORTED_MODULE_0__KeytipConstants__["e" /* KTP_PREFIX */]);
}
/**
 * Merges an overflow sequence with a key sequence.
 *
 * @param keySequences - Full sequence for one keytip.
 * @param overflowKeySequences - Full overflow keytip sequence.
 * @returns {string[]} Sequence that will be used by the keytip when in the overflow.
 */
function mergeOverflows(keySequences, overflowKeySequences) {
    var overflowSequenceLen = overflowKeySequences.length;
    var overflowSequence = overflowKeySequences.slice().pop();
    var newKeySequences = keySequences.slice();
    return Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["i" /* addElementAtIndex */])(newKeySequences, overflowSequenceLen - 1, overflowSequence);
}
/**
 * Constructs the data-ktp-target attribute selector from a full key sequence.
 *
 * @param keySequences - Full string[] for a Keytip.
 * @returns {string} String selector to use to query for the keytip target.
 */
function ktpTargetFromSequences(keySequences) {
    return '[' + __WEBPACK_IMPORTED_MODULE_0__KeytipConstants__["b" /* DATAKTP_TARGET */] + '="' + sequencesToID(keySequences) + '"]';
}
/**
 * Constructs the data-ktp-execute-target attribute selector from a keytip ID.
 *
 * @param keytipId - ID of the Keytip.
 * @returns {string} String selector to use to query for the keytip execute target.
 */
function ktpTargetFromId(keytipId) {
    return '[' + __WEBPACK_IMPORTED_MODULE_0__KeytipConstants__["a" /* DATAKTP_EXECUTE_TARGET */] + '="' + keytipId + '"]';
}
/**
 * Gets the aria-describedby value to put on the component with this keytip.
 *
 * @param keySequences - KeySequences of the keytip.
 * @returns {string} The aria-describedby value to set on the component with this keytip.
 */
function getAriaDescribedBy(keySequences) {
    var describedby = ' ' + __WEBPACK_IMPORTED_MODULE_0__KeytipConstants__["d" /* KTP_LAYER_ID */];
    if (!keySequences.length) {
        // Return just the layer ID
        return describedby;
    }
    return describedby + ' ' + sequencesToID(keySequences);
}
//# sourceMappingURL=KeytipUtils.js.map

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ContextualMenu_index__ = __webpack_require__(1733);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_ContextualMenu_index__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__components_ContextualMenu_index__["b"]; });

//# sourceMappingURL=ContextualMenu.js.map

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FocusTrapZone_index__ = __webpack_require__(410);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_FocusTrapZone_index__["a"]; });

//# sourceMappingURL=FocusTrapZone.js.map

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContextualMenuItemWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utilities__ = __webpack_require__(1);


var ContextualMenuItemWrapper = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ContextualMenuItemWrapper, _super);
    function ContextualMenuItemWrapper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onItemMouseEnter = function (ev) {
            var _a = _this.props, item = _a.item, onItemMouseEnter = _a.onItemMouseEnter;
            if (onItemMouseEnter) {
                onItemMouseEnter(item, ev, ev.currentTarget);
            }
        };
        _this._onItemClick = function (ev) {
            var _a = _this.props, item = _a.item, onItemClickBase = _a.onItemClickBase;
            if (onItemClickBase) {
                onItemClickBase(item, ev, ev.currentTarget);
            }
        };
        _this._onItemMouseLeave = function (ev) {
            var _a = _this.props, item = _a.item, onItemMouseLeave = _a.onItemMouseLeave;
            if (onItemMouseLeave) {
                onItemMouseLeave(item, ev);
            }
        };
        _this._onItemKeyDown = function (ev) {
            var _a = _this.props, item = _a.item, onItemKeyDown = _a.onItemKeyDown;
            if (onItemKeyDown) {
                onItemKeyDown(item, ev);
            }
        };
        _this._onItemMouseMove = function (ev) {
            var _a = _this.props, item = _a.item, onItemMouseMove = _a.onItemMouseMove;
            if (onItemMouseMove) {
                onItemMouseMove(item, ev, ev.currentTarget);
            }
        };
        _this._getSubMenuId = function (item) {
            var getSubMenuId = _this.props.getSubMenuId;
            if (getSubMenuId) {
                return getSubMenuId(item);
            }
        };
        _this._getSubmenuTarget = function () {
            return undefined;
        };
        return _this;
    }
    ContextualMenuItemWrapper.prototype.shouldComponentUpdate = function (newProps) {
        return !Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["_27" /* shallowCompare */])(newProps, this.props);
    };
    return ContextualMenuItemWrapper;
}(__WEBPACK_IMPORTED_MODULE_1__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=ContextualMenuItemWrapper.js.map

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DefaultButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseButton__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DefaultButton_styles__ = __webpack_require__(1756);





/**
 * {@docCategory Button}
 */
var DefaultButton = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](DefaultButton, _super);
    function DefaultButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Tell BaseComponent to bypass resolution of componentRef.
         */
        _this._skipComponentRefResolution = true;
        return _this;
    }
    DefaultButton.prototype.render = function () {
        var _a = this.props, _b = _a.primary, primary = _b === void 0 ? false : _b, styles = _a.styles, theme = _a.theme;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__BaseButton__["a" /* BaseButton */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this.props, { variantClassName: primary ? 'ms-Button--primary' : 'ms-Button--default', styles: Object(__WEBPACK_IMPORTED_MODULE_4__DefaultButton_styles__["a" /* getStyles */])(theme, styles, primary), onRenderDescription: __WEBPACK_IMPORTED_MODULE_3__Utilities__["_17" /* nullRender */] })));
    };
    DefaultButton = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["u" /* customizable */])('DefaultButton', ['theme', 'styles'], true)
    ], DefaultButton);
    return DefaultButton;
}(__WEBPACK_IMPORTED_MODULE_3__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=DefaultButton.js.map

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utilities__ = __webpack_require__(1);


var getStyles = Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["_15" /* memoizeFunction */])(function (theme, customStyles) {
    var buttonHighContrastFocus = {
        left: -2,
        top: -2,
        bottom: -2,
        right: -2,
        border: 'none'
    };
    var splitButtonDivider = {
        position: 'absolute',
        width: 1,
        right: 31,
        top: 8,
        bottom: 8
    };
    var splitButtonDividerDisabled = {
        position: 'absolute',
        width: 1,
        right: 31,
        top: 8,
        bottom: 8,
        selectors: (_a = {},
            _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                backgroundColor: 'GrayText'
            },
            _a)
    };
    var splitButtonStyles = {
        splitButtonContainer: [
            Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["v" /* getFocusStyle */])(theme, { highContrastStyle: buttonHighContrastFocus }),
            {
                display: 'inline-flex',
                selectors: {
                    '.ms-Button--default, .ms-Button--primary': {
                        borderRight: 'none'
                    }
                }
            }
        ],
        splitButtonContainerFocused: {
            outline: 'none!important'
        },
        splitButtonMenuButton: {
            padding: 6,
            height: 'auto',
            boxSizing: 'border-box',
            border: 0,
            borderRadius: 0,
            outline: 'transparent',
            userSelect: 'none',
            display: 'inline-block',
            textDecoration: 'none',
            textAlign: 'center',
            cursor: 'pointer',
            verticalAlign: 'top',
            width: 32,
            marginLeft: -1,
            marginTop: 0,
            marginRight: 0,
            marginBottom: 0,
            selectors: (_b = {},
                _b[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                    border: "1px solid white",
                    borderLeft: 'none'
                },
                _b)
        },
        splitButtonDivider: splitButtonDivider,
        splitButtonDividerDisabled: splitButtonDividerDisabled,
        splitButtonMenuButtonDisabled: {
            pointerEvents: 'none',
            selectors: (_c = {
                    ':hover': {
                        cursor: 'default'
                    }
                },
                _c[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                    border: "1px solid GrayText",
                    color: 'GrayText',
                    backgroundColor: 'Window'
                },
                _c)
        },
        splitButtonFlexContainer: {
            display: 'flex',
            height: '100%',
            flexWrap: 'nowrap',
            justifyContent: 'center',
            alignItems: 'center'
        },
        splitButtonContainerDisabled: {
            outline: 'none',
            border: 'none'
        }
    };
    return Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["t" /* concatStyleSets */])(splitButtonStyles, customStyles);
    var _a, _b, _c;
});
//# sourceMappingURL=SplitButton.styles.js.map

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TooltipDelay; });
/**
 * {@docCategory Tooltip}
 */
var TooltipDelay;
(function (TooltipDelay) {
    TooltipDelay[TooltipDelay["zero"] = 0] = "zero";
    TooltipDelay[TooltipDelay["medium"] = 1] = "medium";
    TooltipDelay[TooltipDelay["long"] = 2] = "long";
})(TooltipDelay || (TooltipDelay = {}));
//# sourceMappingURL=Tooltip.types.js.map

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addDays;
/* harmony export (immutable) */ __webpack_exports__["c"] = addWeeks;
/* harmony export (immutable) */ __webpack_exports__["b"] = addMonths;
/* harmony export (immutable) */ __webpack_exports__["d"] = addYears;
/* harmony export (immutable) */ __webpack_exports__["i"] = getMonthStart;
/* harmony export (immutable) */ __webpack_exports__["h"] = getMonthEnd;
/* harmony export (immutable) */ __webpack_exports__["m"] = getYearStart;
/* harmony export (immutable) */ __webpack_exports__["l"] = getYearEnd;
/* harmony export (immutable) */ __webpack_exports__["o"] = setMonth;
/* harmony export (immutable) */ __webpack_exports__["f"] = compareDates;
/* harmony export (immutable) */ __webpack_exports__["e"] = compareDatePart;
/* harmony export (immutable) */ __webpack_exports__["g"] = getDateRangeArray;
/* harmony export (immutable) */ __webpack_exports__["n"] = isInDateRangeArray;
/* harmony export (immutable) */ __webpack_exports__["k"] = getWeekNumbersInMonth;
/* harmony export (immutable) */ __webpack_exports__["j"] = getWeekNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dateValues_DateValues__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dateValues_TimeConstants__ = __webpack_require__(1816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);



/**
 * Returns a date offset from the given date by the specified number of days.
 * @param {Date} date - The origin date
 * @param {number} days - The number of days to offset. 'days' can be negative.
 * @return {Date} A new Date object offset from the origin date by the given number of days
 */
function addDays(date, days) {
    var result = new Date(date.getTime());
    result.setDate(result.getDate() + days);
    return result;
}
/**
 * Returns a date offset from the given date by the specified number of weeks.
 * @param {Date} date - The origin date
 * @param {number} weeks - The number of weeks to offset. 'weeks' can be negative.
 * @return {Date} A new Date object offset from the origin date by the given number of weeks
 */
function addWeeks(date, weeks) {
    return addDays(date, weeks * __WEBPACK_IMPORTED_MODULE_1__dateValues_TimeConstants__["a" /* default */].DaysInOneWeek);
}
/**
 * Returns a date offset from the given date by the specified number of months.
 * The method tries to preserve the day-of-month; however, if the new month does not have enough days
 * to contain the original day-of-month, we'll use the last day of the new month.
 * @param {Date} date - The origin date
 * @param {number} months - The number of months to offset. 'months' can be negative.
 * @return {Date} A new Date object offset from the origin date by the given number of months
 */
function addMonths(date, months) {
    var result = new Date(date.getTime());
    var newMonth = result.getMonth() + months;
    result.setMonth(newMonth);
    // We want to maintain the same day-of-month, but that may not be possible if the new month doesn't have enough days.
    // Loop until we back up to a day the new month has.
    // (Weird modulo math is due to Javascript's treatment of negative numbers in modulo)
    if (result.getMonth() !== ((newMonth % __WEBPACK_IMPORTED_MODULE_1__dateValues_TimeConstants__["a" /* default */].MonthInOneYear) + __WEBPACK_IMPORTED_MODULE_1__dateValues_TimeConstants__["a" /* default */].MonthInOneYear) % __WEBPACK_IMPORTED_MODULE_1__dateValues_TimeConstants__["a" /* default */].MonthInOneYear) {
        result = addDays(result, -result.getDate());
    }
    return result;
}
/**
 * Returns a date offset from the given date by the specified number of years.
 * The method tries to preserve the day-of-month; however, if the new month does not have enough days
 * to contain the original day-of-month, we'll use the last day of the new month.
 * @param {Date} date - The origin date
 * @param {number} years - The number of years to offset. 'years' can be negative.
 * @return {Date} A new Date object offset from the origin date by the given number of years
 */
function addYears(date, years) {
    var result = new Date(date.getTime());
    result.setFullYear(date.getFullYear() + years);
    // We want to maintain the same day-of-month, but that may not be possible if the new month doesn't have enough days.
    // Loop until we back up to a day the new month has.
    // (Weird modulo math is due to Javascript's treatment of negative numbers in modulo)
    if (result.getMonth() !==
        ((date.getMonth() % __WEBPACK_IMPORTED_MODULE_1__dateValues_TimeConstants__["a" /* default */].MonthInOneYear) + __WEBPACK_IMPORTED_MODULE_1__dateValues_TimeConstants__["a" /* default */].MonthInOneYear) % __WEBPACK_IMPORTED_MODULE_1__dateValues_TimeConstants__["a" /* default */].MonthInOneYear) {
        result = addDays(result, -result.getDate());
    }
    return result;
}
/**
 * Returns a date that is the first day of the month of the provided date.
 * @param {Date} date - The origin date
 * @return {Date} A new Date object with the day set to the first day of the month.
 */
function getMonthStart(date) {
    return new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0, 0);
}
/**
 * Returns a date that is the last day of the month of the provided date.
 * @param {Date} date - The origin date
 * @return {Date} A new Date object with the day set to the last day of the month.
 */
function getMonthEnd(date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0, 0, 0, 0, 0);
}
/**
 * Returns a date that is the first day of the year of the provided date.
 * @param {Date} date - The origin date
 * @return {Date} A new Date object with the day set to the first day of the year.
 */
function getYearStart(date) {
    return new Date(date.getFullYear(), 0, 1, 0, 0, 0, 0);
}
/**
 * Returns a date that is the last day of the year of the provided date.
 * @param {Date} date - The origin date
 * @return {Date} A new Date object with the day set to the last day of the year.
 */
function getYearEnd(date) {
    return new Date(date.getFullYear() + 1, 0, 0, 0, 0, 0, 0);
}
/**
 * Returns a date that is a copy of the given date, aside from the month changing to the given month.
 *  The method tries to preserve the day-of-month; however, if the new month does not have enough days
 * to contain the original day-of-month, we'll use the last day of the new month.
 * @param {Date} date - The origin date
 * @param {number} month - The 0-based index of the month to set on the date.
 * @return {Date} A new Date object with the given month set.
 */
function setMonth(date, month) {
    return addMonths(date, month - date.getMonth());
}
/**
 * Compares two dates, and returns true if the two dates (not accounting for time-of-day) are equal.
 * @return {boolean} True if the two dates represent the same date (regardless of time-of-day), false otherwise.
 */
function compareDates(date1, date2) {
    if (!date1 && !date2) {
        return true;
    }
    else if (!date1 || !date2) {
        return false;
    }
    else {
        return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
    }
}
/**
 * Compare the date parts of two dates
 * @param {Date} date1 - The first date to compare
 * @param {Date} date2 - The second date to compare
 * @returns {Number} A negative value if date1 is earlier than date2, 0 if the dates are equal, or a positive value
 * if date1 is later than date2.
 */
function compareDatePart(date1, date2) {
    return getDatePartHashValue(date1) - getDatePartHashValue(date2);
}
/**
 * Gets the date range array including the specified date. The date range array is calculated as the list
 * of dates accounting for the specified first day of the week and date range type.
 * @param {Date} date - The input date
 * @param {DateRangeType} dateRangeType - The desired date range type, i.e., day, week, month, etc.
 * @param {DayOfWeek} firstDayOfWeek - The first day of the week.
 * @param {DayOfWeek[]} workWeekDays - The allowed days in work week. If not provided, assumes all days are allowed.
 * @returns {Date[]} An array of dates representing the date range containing the specified date.
 */
function getDateRangeArray(date, dateRangeType, firstDayOfWeek, workWeekDays) {
    var datesArray = new Array();
    var startDate;
    var endDate = null;
    if (!workWeekDays) {
        workWeekDays = [__WEBPACK_IMPORTED_MODULE_0__dateValues_DateValues__["b" /* DayOfWeek */].Monday, __WEBPACK_IMPORTED_MODULE_0__dateValues_DateValues__["b" /* DayOfWeek */].Tuesday, __WEBPACK_IMPORTED_MODULE_0__dateValues_DateValues__["b" /* DayOfWeek */].Wednesday, __WEBPACK_IMPORTED_MODULE_0__dateValues_DateValues__["b" /* DayOfWeek */].Thursday, __WEBPACK_IMPORTED_MODULE_0__dateValues_DateValues__["b" /* DayOfWeek */].Friday];
    }
    switch (dateRangeType) {
        case __WEBPACK_IMPORTED_MODULE_0__dateValues_DateValues__["a" /* DateRangeType */].Day:
            startDate = getDatePart(date);
            endDate = addDays(startDate, 1);
            break;
        case __WEBPACK_IMPORTED_MODULE_0__dateValues_DateValues__["a" /* DateRangeType */].Week:
        case __WEBPACK_IMPORTED_MODULE_0__dateValues_DateValues__["a" /* DateRangeType */].WorkWeek:
            startDate = getStartDateOfWeek(getDatePart(date), firstDayOfWeek);
            endDate = addDays(startDate, __WEBPACK_IMPORTED_MODULE_1__dateValues_TimeConstants__["a" /* default */].DaysInOneWeek);
            break;
        case __WEBPACK_IMPORTED_MODULE_0__dateValues_DateValues__["a" /* DateRangeType */].Month:
            startDate = new Date(date.getFullYear(), date.getMonth(), 1);
            endDate = addMonths(startDate, 1);
            break;
        default:
            return Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["m" /* assertNever */])(dateRangeType);
    }
    // Populate the dates array with the dates in range
    var nextDate = startDate;
    do {
        if (dateRangeType !== __WEBPACK_IMPORTED_MODULE_0__dateValues_DateValues__["a" /* DateRangeType */].WorkWeek) {
            // push all days not in work week view
            datesArray.push(nextDate);
        }
        else if (workWeekDays.indexOf(nextDate.getDay()) !== -1) {
            datesArray.push(nextDate);
        }
        nextDate = addDays(nextDate, 1);
    } while (!compareDates(nextDate, endDate));
    return datesArray;
}
/**
 * Checks whether the specified date is in the given date range.
 * @param {Date} date - The origin date
 * @param {Date[]} dateRange - An array of dates to do the lookup on
 * @returns {bool} True if the date matches one of the dates in the specified array, false otherwise.
 */
function isInDateRangeArray(date, dateRange) {
    for (var _i = 0, dateRange_1 = dateRange; _i < dateRange_1.length; _i++) {
        var dateInRange = dateRange_1[_i];
        if (compareDates(date, dateInRange)) {
            return true;
        }
    }
    return false;
}
/**
 * Returns the week number for a date.
 * Week numbers are 1 - 52 (53) in a year
 * @param {navigatedDate} Date - A date to find the week number for.
 * @param {firstDayOfWeek} DayOfWeek - The first day of the week (0-6, Sunday = 0)
 * @param {firstWeekOfYear} FirstWeekOfYear - The first week of the year (1-2)
 * @return {weeksArray} The weeks number array for the current month.
 */
function getWeekNumbersInMonth(weeksInMonth, firstDayOfWeek, firstWeekOfYear, navigatedDate) {
    var selectedYear = navigatedDate.getFullYear();
    var selectedMonth = navigatedDate.getMonth();
    var dayOfMonth = 1;
    var fistDayOfMonth = new Date(selectedYear, selectedMonth, dayOfMonth);
    var endOfFirstWeek = dayOfMonth + (firstDayOfWeek + __WEBPACK_IMPORTED_MODULE_1__dateValues_TimeConstants__["a" /* default */].DaysInOneWeek - 1) - adjustWeekDay(firstDayOfWeek, fistDayOfMonth.getDay());
    var endOfWeekRange = new Date(selectedYear, selectedMonth, endOfFirstWeek);
    dayOfMonth = endOfWeekRange.getDate();
    var weeksArray = [];
    for (var i = 0; i < weeksInMonth; i++) {
        // Get week number for end of week
        weeksArray.push(getWeekNumber(endOfWeekRange, firstDayOfWeek, firstWeekOfYear));
        dayOfMonth += __WEBPACK_IMPORTED_MODULE_1__dateValues_TimeConstants__["a" /* default */].DaysInOneWeek;
        endOfWeekRange = new Date(selectedYear, selectedMonth, dayOfMonth);
    }
    return weeksArray;
}
/**
 * Returns the week number for a date.
 * Week numbers are 1 - 52 (53) in a year
 * @param {Date} date - A date to find the week number for.
 * @param {DayOfWeek} firstDayOfWeek - The first day of the week (0-6, Sunday = 0)
 * @param {firstWeekOfYear} firstWeekOfYear - The first week of the year (1-2)
 * @return {Number} The week's number in the year.
 */
function getWeekNumber(date, firstDayOfWeek, firstWeekOfYear) {
    // First four-day week of the year - minumum days count
    var fourDayWeek = 4;
    switch (firstWeekOfYear) {
        case __WEBPACK_IMPORTED_MODULE_0__dateValues_DateValues__["c" /* FirstWeekOfYear */].FirstFullWeek:
            return getWeekOfYearFullDays(date, firstDayOfWeek, __WEBPACK_IMPORTED_MODULE_1__dateValues_TimeConstants__["a" /* default */].DaysInOneWeek);
        case __WEBPACK_IMPORTED_MODULE_0__dateValues_DateValues__["c" /* FirstWeekOfYear */].FirstFourDayWeek:
            return getWeekOfYearFullDays(date, firstDayOfWeek, fourDayWeek);
        default:
            return getFirstDayWeekOfYear(date, firstDayOfWeek);
    }
}
/**
 * Gets a new date with the time portion zeroed out, i.e., set to midnight
 * @param {Date} date - The origin date
 * @returns {Date} A new date with the time set to midnight
 */
function getDatePart(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}
/**
 * Gets the date for the first day of the week based on the given date assuming
 * the specified first day of the week.
 * @param {Date} date - The date to find the beginning of the week date for.
 * @return {Date} A new date object representing the first day of the week containing the input date.
 */
function getStartDateOfWeek(date, firstDayOfWeek) {
    var daysOffset = firstDayOfWeek - date.getDay();
    if (daysOffset > 0) {
        // If first day of week is > date, go 1 week back, to ensure resulting date is in the past.
        daysOffset -= __WEBPACK_IMPORTED_MODULE_1__dateValues_TimeConstants__["a" /* default */].DaysInOneWeek;
    }
    return addDays(date, daysOffset);
}
/**
 * Helper function to assist in date comparisons
 */
function getDatePartHashValue(date) {
    // Generate date hash value created as sum of Date (up to 31 = 5 bits), Month (up to 11 = 4 bits) and Year.
    /* tslint:disable:no-bitwise */
    return date.getDate() + (date.getMonth() << 5) + (date.getFullYear() << 9);
    /* tslint:enable:no-bitwise */
}
/**
 * Helper function for getWeekNumber.
 * Returns week number for a date
 * @param {date} Date - current selected date.
 * @param {firstDayOfWeek} DayOfWeek - The first day of week (0-6, Sunday = 0)
 * @param {numberOfFullDays} number - week settings.
 * @return {Number} The week's number in the year.
 */
function getWeekOfYearFullDays(date, firstDayOfWeek, numberOfFullDays) {
    var dayOfYear = getDayOfYear(date) - 1;
    var num = date.getDay() - (dayOfYear % __WEBPACK_IMPORTED_MODULE_1__dateValues_TimeConstants__["a" /* default */].DaysInOneWeek);
    var lastDayOfPrevYear = new Date(date.getFullYear() - 1, __WEBPACK_IMPORTED_MODULE_0__dateValues_DateValues__["d" /* MonthOfYear */].December, 31);
    var daysInYear = getDayOfYear(lastDayOfPrevYear) - 1;
    var num2 = (firstDayOfWeek - num + 2 * __WEBPACK_IMPORTED_MODULE_1__dateValues_TimeConstants__["a" /* default */].DaysInOneWeek) % __WEBPACK_IMPORTED_MODULE_1__dateValues_TimeConstants__["a" /* default */].DaysInOneWeek;
    if (num2 !== 0 && num2 >= numberOfFullDays) {
        num2 -= __WEBPACK_IMPORTED_MODULE_1__dateValues_TimeConstants__["a" /* default */].DaysInOneWeek;
    }
    var num3 = dayOfYear - num2;
    if (num3 < 0) {
        num -= daysInYear % __WEBPACK_IMPORTED_MODULE_1__dateValues_TimeConstants__["a" /* default */].DaysInOneWeek;
        num2 = (firstDayOfWeek - num + 2 * __WEBPACK_IMPORTED_MODULE_1__dateValues_TimeConstants__["a" /* default */].DaysInOneWeek) % __WEBPACK_IMPORTED_MODULE_1__dateValues_TimeConstants__["a" /* default */].DaysInOneWeek;
        if (num2 !== 0 && num2 + 1 >= numberOfFullDays) {
            num2 -= __WEBPACK_IMPORTED_MODULE_1__dateValues_TimeConstants__["a" /* default */].DaysInOneWeek;
        }
        num3 = daysInYear - num2;
    }
    return Math.floor(num3 / __WEBPACK_IMPORTED_MODULE_1__dateValues_TimeConstants__["a" /* default */].DaysInOneWeek + 1);
}
/**
 * Helper function for getWeekNumber.
 * Returns week number for a date
 * @param {date} Date - current selected date.
 * @param {firstDayOfWeek} DayOfWeek - The first day of week (0-6, Sunday = 0)
 * @return {Number} The week's number in the year.
 */
function getFirstDayWeekOfYear(date, firstDayOfWeek) {
    var num = getDayOfYear(date) - 1;
    var num2 = date.getDay() - (num % __WEBPACK_IMPORTED_MODULE_1__dateValues_TimeConstants__["a" /* default */].DaysInOneWeek);
    var num3 = (num2 - firstDayOfWeek + 2 * __WEBPACK_IMPORTED_MODULE_1__dateValues_TimeConstants__["a" /* default */].DaysInOneWeek) % __WEBPACK_IMPORTED_MODULE_1__dateValues_TimeConstants__["a" /* default */].DaysInOneWeek;
    return Math.floor((num + num3) / __WEBPACK_IMPORTED_MODULE_1__dateValues_TimeConstants__["a" /* default */].DaysInOneWeek + 1);
}
/**
 * Helper function for getWeekNumber.
 * Returns adjusted week day number when firstDayOfWeek is other than Sunday
 * For Week Day Number comparison checks
 * @param {firstDayOfWeek} DayOfWeek - The first day of week (0-6, Sunday = 0)
 * @param {dateWeekDay} DayOfWeek - shifts number forward to 1 week in case passed as true
 * @return {DayOfWeek} The day of week adjusted to firstDayOfWeek. E.g. when FirstDyOfWeek is Monday (1), Sunday becomes = 7 (7 > 1).
 */
function adjustWeekDay(firstDayOfWeek, dateWeekDay) {
    return firstDayOfWeek !== __WEBPACK_IMPORTED_MODULE_0__dateValues_DateValues__["b" /* DayOfWeek */].Sunday && dateWeekDay < firstDayOfWeek ? dateWeekDay + __WEBPACK_IMPORTED_MODULE_1__dateValues_TimeConstants__["a" /* default */].DaysInOneWeek : dateWeekDay;
}
/**
 * Returns the day number for a date in a year
 * The number of days since January 1st in the particular year.
 * @param {Date} date - A date to find the day number for.
 * @return {Number} The day's number in the year.
 */
function getDayOfYear(date) {
    var month = date.getMonth();
    var year = date.getFullYear();
    var daysUntilDate = 0;
    for (var i = 0; i < month; i++) {
        daysUntilDate += daysInMonth(i + 1, year);
    }
    daysUntilDate += date.getDate();
    return daysUntilDate;
}
/**
 * Returns the number of days in the month
 * @param {number} month - The month number to target (months 1-12).
 * @param {number} year - The year to target.
 * @return {Number} The number of days in the month.
 */
function daysInMonth(month, year) {
    return new Date(year, month, 0).getDate();
}
//# sourceMappingURL=DateMath.js.map

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "root", function() { return root; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "picker", function() { return picker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "holder", function() { return holder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pickerIsOpened", function() { return pickerIsOpened; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "frame", function() { return frame; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wrap", function() { return wrap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "goTodaySpacing", function() { return goTodaySpacing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dayPicker", function() { return dayPicker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "header", function() { return header; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "divider", function() { return divider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "monthAndYear", function() { return monthAndYear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "year", function() { return year; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "decade", function() { return decade; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentYear", function() { return currentYear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentDecade", function() { return currentDecade; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "table", function() { return table; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dayWrapper", function() { return dayWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "weekday", function() { return weekday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "day", function() { return day; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "daySelection", function() { return daySelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dayIsToday", function() { return dayIsToday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dayIsDisabled", function() { return dayIsDisabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dayIsUnfocused", function() { return dayIsUnfocused; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dayIsFocused", function() { return dayIsFocused; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dayIsHighlighted", function() { return dayIsHighlighted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pickerIsFocused", function() { return pickerIsFocused; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dayDisabled", function() { return dayDisabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dayBackground", function() { return dayBackground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dayHover", function() { return dayHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dayPress", function() { return dayPress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "weekBackground", function() { return weekBackground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "showWeekNumbers", function() { return showWeekNumbers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "weekNumbers", function() { return weekNumbers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "weekIsHighlighted", function() { return weekIsHighlighted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "showWeekNumbersRTL", function() { return showWeekNumbersRTL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "monthComponents", function() { return monthComponents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yearComponents", function() { return yearComponents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "decadeComponents", function() { return decadeComponents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "closeButton", function() { return closeButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prevMonth", function() { return prevMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nextMonth", function() { return nextMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prevYear", function() { return prevYear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nextYear", function() { return nextYear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prevDecade", function() { return prevDecade; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nextDecade", function() { return nextDecade; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prevMonthIsDisabled", function() { return prevMonthIsDisabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nextMonthIsDisabled", function() { return nextMonthIsDisabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prevYearIsDisabled", function() { return prevYearIsDisabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nextYearIsDisabled", function() { return nextYearIsDisabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prevDecadeIsDisabled", function() { return prevDecadeIsDisabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nextDecadeIsDisabled", function() { return nextDecadeIsDisabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "headerToggleView", function() { return headerToggleView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "optionGrid", function() { return optionGrid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "monthOption", function() { return monthOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yearOption", function() { return yearOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isHighlighted", function() { return isHighlighted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "monthOptionIsDisabled", function() { return monthOptionIsDisabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yearOptionIsDisabled", function() { return yearOptionIsDisabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "goToday", function() { return goToday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "goToTodayIsDisabled", function() { return goToTodayIsDisabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "goTodayInlineMonth", function() { return goTodayInlineMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isPickingYears", function() { return isPickingYears; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "monthPicker", function() { return monthPicker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yearPicker", function() { return yearPicker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "monthPickerVisible", function() { return monthPickerVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleMonthView", function() { return toggleMonthView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calendarsInline", function() { return calendarsInline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "monthPickerOnly", function() { return monthPickerOnly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "monthPickerAsOverlay", function() { return monthPickerAsOverlay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "holderWithButton", function() { return holderWithButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "monthIsHighlighted", function() { return monthIsHighlighted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "monthIsCurrentMonth", function() { return monthIsCurrentMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yearIsHighlighted", function() { return yearIsHighlighted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yearIsCurrentYear", function() { return yearIsCurrentYear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "topLeftCornerDate", function() { return topLeftCornerDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "topRightCornerDate", function() { return topRightCornerDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bottomLeftCornerDate", function() { return bottomLeftCornerDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bottomRightCornerDate", function() { return bottomRightCornerDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "weekSelection", function() { return weekSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "monthSelection", function() { return monthSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "topDate", function() { return topDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rightDate", function() { return rightDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bottomDate", function() { return bottomDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "leftdate", function() { return leftdate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_load_themed_styles__ = __webpack_require__(67);
/* tslint:disable */

Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_load_themed_styles__["a" /* loadStyles */])([{ "rawString": ".root_8e9f232b{-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:none;box-shadow:none;margin:0;padding:0}.root_8e9f232b *{overflow:visible}.root_8e9f232b *::-moz-focus-inner{border:0}.root_8e9f232b *{outline:transparent}.root_8e9f232b *{position:relative}.ms-Fabric--isFocusVisible .root_8e9f232b *:focus:after{content:'';position:absolute;top:0;right:0;bottom:0;left:0;pointer-events:none;border:1px solid " }, { "theme": "neutralSecondary", "defaultValue": "#666666" }, { "rawString": "}.picker_8e9f232b{color:" }, { "theme": "black", "defaultValue": "#000000" }, { "rawString": ";font-size:14px;position:relative}html[dir='ltr'] .picker_8e9f232b{text-align:left}html[dir='rtl'] .picker_8e9f232b{text-align:right}.holder_8e9f232b{-webkit-overflow-scrolling:touch;-webkit-box-sizing:border-box;box-sizing:border-box;display:none}.picker_8e9f232b.pickerIsOpened_8e9f232b .holder_8e9f232b{-webkit-box-sizing:border-box;box-sizing:border-box;display:inline-block}.pickerIsOpened_8e9f232b{position:relative}.frame_8e9f232b{position:relative}.wrap_8e9f232b{min-height:212px;padding:12px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-sizing:content-box;box-sizing:content-box}.wrap_8e9f232b.goTodaySpacing_8e9f232b{min-height:228px}.dayPicker_8e9f232b{display:block}.header_8e9f232b{position:relative;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;height:28px;line-height:44px;width:100%}.divider_8e9f232b{top:0;margin-top:-12px;margin-bottom:-12px}html[dir='ltr'] .divider_8e9f232b{border-right:1px solid " }, { "theme": "neutralLight", "defaultValue": "#eaeaea" }, { "rawString": "}html[dir='rtl'] .divider_8e9f232b{border-left:1px solid " }, { "theme": "neutralLight", "defaultValue": "#eaeaea" }, { "rawString": "}.monthAndYear_8e9f232b,.year_8e9f232b,.decade_8e9f232b{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;font-size:14px;font-weight:400;color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": ";font-weight:600;padding:0 5px}.monthAndYear_8e9f232b:hover,.currentYear_8e9f232b:hover,.currentDecade_8e9f232b:hover{cursor:default}.table_8e9f232b{text-align:center;border-collapse:collapse;border-spacing:0;table-layout:fixed;font-size:inherit;margin-top:4px;width:197px}.table_8e9f232b td{margin:0;padding:0}.dayWrapper_8e9f232b,.weekday_8e9f232b{width:28px;height:28px;padding:0;line-height:28px;font-size:12px;font-size:15px;font-weight:400;color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": ";-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:default}.dayWrapper_8e9f232b *::-moz-focus-inner,.weekday_8e9f232b *::-moz-focus-inner{border:0}.dayWrapper_8e9f232b *,.weekday_8e9f232b *{outline:transparent}.dayWrapper_8e9f232b *,.weekday_8e9f232b *{position:relative}.ms-Fabric--isFocusVisible .dayWrapper_8e9f232b *:focus:after,.ms-Fabric--isFocusVisible .weekday_8e9f232b *:focus:after{content:'';position:absolute;top:-2px;right:-2px;bottom:-2px;left:-2px;pointer-events:none;border:1px solid " }, { "theme": "neutralSecondary", "defaultValue": "#666666" }, { "rawString": "}.day_8e9f232b{width:24px;height:24px;border-radius:2px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border:none;padding:0;background-color:transparent;line-height:100%;font-size:inherit;color:inherit;font-weight:inherit}@media screen and (-ms-high-contrast: active){.daySelection_8e9f232b .day_8e9f232b:hover,.daySelection_8e9f232b .day_8e9f232b:active{outline:1px solid highlight}}@media screen and (-ms-high-contrast: active){.daySelection_8e9f232b .day_8e9f232b:active{color:highlight}}.dayIsToday_8e9f232b,.dayIsToday_8e9f232b:hover{position:relative;background-color:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.dayIsToday_8e9f232b,.dayIsToday_8e9f232b:hover{background-color:highlight;border-radius:2px}}@media screen and (-ms-high-contrast: active){.dayIsToday_8e9f232b span,.dayIsToday_8e9f232b:hover span{-ms-high-contrast-adjust:none;color:window}}.dayIsToday_8e9f232b:hover,.dayIsToday_8e9f232b:hover:hover{border-radius:0px}.dayIsDisabled_8e9f232b:before{border-top-color:" }, { "theme": "neutralTertiary", "defaultValue": "#a6a6a6" }, { "rawString": "}.dayIsUnfocused_8e9f232b{color:" }, { "theme": "neutralSecondary", "defaultValue": "#666666" }, { "rawString": ";font-weight:400}.dayIsFocused_8e9f232b:hover,.dayIsUnfocused_8e9f232b:hover{cursor:pointer;background:" }, { "theme": "neutralLight", "defaultValue": "#eaeaea" }, { "rawString": ";color:" }, { "theme": "neutralDark", "defaultValue": "#212121" }, { "rawString": "}.daySelection_8e9f232b.dayIsHighlighted_8e9f232b:hover,.pickerIsFocused_8e9f232b .dayIsHighlighted_8e9f232b.daySelection_8e9f232b{cursor:pointer}@media screen and (-ms-high-contrast: active){.daySelection_8e9f232b.dayIsHighlighted_8e9f232b:hover,.pickerIsFocused_8e9f232b .dayIsHighlighted_8e9f232b.daySelection_8e9f232b{border:2px solid Highlight}.daySelection_8e9f232b.dayIsHighlighted_8e9f232b:hover :not(.dayIsToday_8e9f232b) span,.pickerIsFocused_8e9f232b .dayIsHighlighted_8e9f232b.daySelection_8e9f232b :not(.dayIsToday_8e9f232b) span{color:Highlight}}@media screen and (-ms-high-contrast: active){.dayIsHighlighted_8e9f232b button.dayIsToday_8e9f232b{border-radius:0px}}@media screen and (-ms-high-contrast: active){.dayIsHighlighted_8e9f232b button.dayIsToday_8e9f232b span{color:Window}}.dayIsFocused_8e9f232b:active,.dayIsHighlighted_8e9f232b{background:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": "}.dayIsFocused_8e9f232b:active.day_8e9f232b,.dayIsHighlighted_8e9f232b.day_8e9f232b{color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": ";font-weight:600}.dayIsHighlighted_8e9f232b.dayDisabled_8e9f232b,.dayIsHighlighted_8e9f232b.dayDisabled_8e9f232b:hover{background:" }, { "theme": "neutralTertiary", "defaultValue": "#a6a6a6" }, { "rawString": "}.dayBackground_8e9f232b,.dayBackground_8e9f232b:hover,.dayBackground_8e9f232b:active{border-radius:2px}.dayHover_8e9f232b,.dayHover_8e9f232b:hover{cursor:pointer;background:" }, { "theme": "neutralLight", "defaultValue": "#eaeaea" }, { "rawString": ";color:" }, { "theme": "neutralDark", "defaultValue": "#212121" }, { "rawString": "}.dayPress_8e9f232b,.dayPress_8e9f232b:hover{cursor:pointer;font-weight:600;background:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": ";color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": "}.dayPress_8e9f232b .dayIsToday_8e9f232b,.dayPress_8e9f232b:hover .dayIsToday_8e9f232b{background:" }, { "theme": "themePrimary", "defaultValue": "#0078d4" }, { "rawString": "}.dayIsUnfocused_8e9f232b:active,.dayIsFocused_8e9f232b:active,.dayIsHighlighted_8e9f232b,.dayIsHighlighted_8e9f232b:hover,.dayIsHighlighted_8e9f232b:active,.weekBackground_8e9f232b,.weekBackground_8e9f232b:hover,.weekBackground_8e9f232b:active{background:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": ";color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": ";font-weight:600}.dayIsToday_8e9f232b,.pickerIsFocused_8e9f232b .dayIsToday_8e9f232b,.dayIsToday_8e9f232b.day_8e9f232b:active{position:relative;color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": ";font-weight:600;background:" }, { "theme": "themePrimary", "defaultValue": "#0078d4" }, { "rawString": "}.showWeekNumbers_8e9f232b .weekNumbers_8e9f232b{border-right:1px solid " }, { "theme": "neutralLight", "defaultValue": "#eaeaea" }, { "rawString": ";-webkit-box-sizing:border-box;box-sizing:border-box;width:28px;padding:0}.showWeekNumbers_8e9f232b .weekNumbers_8e9f232b .dayWrapper_8e9f232b{color:" }, { "theme": "neutralSecondary", "defaultValue": "#666666" }, { "rawString": "}.showWeekNumbers_8e9f232b .weekNumbers_8e9f232b .dayWrapper_8e9f232b.weekIsHighlighted_8e9f232b{color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": "}.showWeekNumbers_8e9f232b .table_8e9f232b{width:225px}.showWeekNumbers_8e9f232b .table_8e9f232b .dayWrapper_8e9f232b,.showWeekNumbers_8e9f232b .table_8e9f232b .weekday_8e9f232b{width:30px}.showWeekNumbersRTL_8e9f232b .weekNumbers_8e9f232b{border-left:1px solid " }, { "theme": "neutralLight", "defaultValue": "#eaeaea" }, { "rawString": ";-webkit-box-sizing:border-box;box-sizing:border-box}.showWeekNumbersRTL_8e9f232b .weekNumbers_8e9f232b .dayWrapper_8e9f232b{color:" }, { "theme": "neutralSecondary", "defaultValue": "#666666" }, { "rawString": "}.showWeekNumbersRTL_8e9f232b .weekNumbers_8e9f232b .dayWrapper_8e9f232b.weekIsHighlighted_8e9f232b{color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": "}.showWeekNumbersRTL_8e9f232b .table_8e9f232b{width:225px}.showWeekNumbersRTL_8e9f232b .table_8e9f232b .dayWrapper_8e9f232b,.showWeekNumbersRTL_8e9f232b .table_8e9f232b .weekday_8e9f232b{width:30px}.monthComponents_8e9f232b,.yearComponents_8e9f232b,.decadeComponents_8e9f232b{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-ms-flex-item-align:end;align-self:flex-end}.closeButton_8e9f232b,.prevMonth_8e9f232b,.nextMonth_8e9f232b,.prevYear_8e9f232b,.nextYear_8e9f232b,.prevDecade_8e9f232b,.nextDecade_8e9f232b{width:28px;height:28px;display:block;text-align:center;line-height:28px;text-align:center;font-size:12px;color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": ";border-radius:2px;position:relative;background-color:transparent;border:none;padding:0}.closeButton_8e9f232b:hover,.prevMonth_8e9f232b:hover,.nextMonth_8e9f232b:hover,.prevYear_8e9f232b:hover,.nextYear_8e9f232b:hover,.prevDecade_8e9f232b:hover,.nextDecade_8e9f232b:hover{color:" }, { "theme": "neutralDark", "defaultValue": "#212121" }, { "rawString": ";cursor:pointer;outline:1px solid transparent}.prevMonthIsDisabled_8e9f232b,.nextMonthIsDisabled_8e9f232b,.prevYearIsDisabled_8e9f232b,.nextYearIsDisabled_8e9f232b,.prevDecadeIsDisabled_8e9f232b,.nextDecadeIsDisabled_8e9f232b{color:" }, { "theme": "neutralTertiaryAlt", "defaultValue": "#c8c8c8" }, { "rawString": ";pointer-events:none}.headerToggleView_8e9f232b{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:4px 8px}.headerToggleView_8e9f232b:hover{color:" }, { "theme": "black", "defaultValue": "#000000" }, { "rawString": ";cursor:pointer}@media screen and (-ms-high-contrast: active){.headerToggleView_8e9f232b:hover{outline:1px solid highlight}}@media screen and (-ms-high-contrast: active){.headerToggleView_8e9f232b:hover:active{color:highlight}}.currentYear_8e9f232b,.currentDecade_8e9f232b{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;padding:0 5px;font-size:14px;font-weight:400;color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": ";height:28px;line-height:28px;font-weight:600}html[dir='ltr'] .currentYear_8e9f232b,html[dir='ltr'] .currentDecade_8e9f232b{margin-left:5px}html[dir='rtl'] .currentYear_8e9f232b,html[dir='rtl'] .currentDecade_8e9f232b{margin-right:5px}.optionGrid_8e9f232b{position:relative;height:210px;width:196px;margin:4px 0 0 0}html[dir='rtl'] .optionGrid_8e9f232b{margin:4px 0 0 0}.monthOption_8e9f232b,.yearOption_8e9f232b{width:60px;height:60px;line-height:100%;cursor:pointer;margin:0 10px 10px 0;font-size:13px;font-weight:400;color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": ";text-align:center;border:none;padding:0;background-color:transparent;border-radius:2px}html[dir='ltr'] .monthOption_8e9f232b,html[dir='ltr'] .yearOption_8e9f232b{float:left}html[dir='rtl'] .monthOption_8e9f232b,html[dir='rtl'] .yearOption_8e9f232b{float:right}html[dir='rtl'] .monthOption_8e9f232b,html[dir='rtl'] .yearOption_8e9f232b{margin:0 0 10px 10px}.monthOption_8e9f232b:hover,.yearOption_8e9f232b:hover{color:" }, { "theme": "neutralDark", "defaultValue": "#212121" }, { "rawString": ";background-color:" }, { "theme": "neutralLight", "defaultValue": "#eaeaea" }, { "rawString": ";outline:1px solid transparent}@media screen and (-ms-high-contrast: active){.monthOption_8e9f232b:hover,.yearOption_8e9f232b:hover{outline-color:highlight}}@media screen and (-ms-high-contrast: active){.monthOption_8e9f232b:active,.yearOption_8e9f232b:active{color:highlight}}.monthOption_8e9f232b.isHighlighted_8e9f232b,.yearOption_8e9f232b.isHighlighted_8e9f232b{background-color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": ";color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": "}.dayIsDisabled_8e9f232b,.monthOptionIsDisabled_8e9f232b,.yearOptionIsDisabled_8e9f232b{color:" }, { "theme": "neutralTertiaryAlt", "defaultValue": "#c8c8c8" }, { "rawString": ";pointer-events:none}.goToday_8e9f232b{bottom:0;color:" }, { "theme": "themePrimary", "defaultValue": "#0078d4" }, { "rawString": ";cursor:pointer;font-size:12px;font-weight:400;color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": ";height:30px;line-height:30px;padding:0 10px;background-color:transparent;border:none;position:absolute !important;-webkit-box-sizing:content-box;box-sizing:content-box}[dir='ltr'] .goToday_8e9f232b{right:13px}[dir='rtl'] .goToday_8e9f232b{left:13px}.goToday_8e9f232b:hover{color:" }, { "theme": "themePrimary", "defaultValue": "#0078d4" }, { "rawString": ";outline:1px solid transparent}@media screen and (-ms-high-contrast: active){.goToday_8e9f232b:hover{outline-color:highlight}}.goToday_8e9f232b:active{color:" }, { "theme": "themeDark", "defaultValue": "#005a9e" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.goToday_8e9f232b:active{color:highlight}}.goToTodayIsDisabled_8e9f232b{color:" }, { "theme": "neutralTertiaryAlt", "defaultValue": "#c8c8c8" }, { "rawString": ";pointer-events:none}.goTodayInlineMonth_8e9f232b{top:212px}.wrap_8e9f232b.goTodaySpacing_8e9f232b{padding-bottom:28px}.root_8e9f232b.isPickingYears_8e9f232b .dayPicker_8e9f232b,.root_8e9f232b.isPickingYears_8e9f232b .monthComponents_8e9f232b{display:none}.root_8e9f232b.isPickingYears_8e9f232b .monthPicker_8e9f232b{display:none}.root_8e9f232b.isPickingYears_8e9f232b .yearPicker_8e9f232b{display:block}@media (min-device-width: 460px){.wrap_8e9f232b{padding:12px}.dayPicker_8e9f232b,.monthPicker_8e9f232b{min-height:200px}.header_8e9f232b{height:28px;line-height:28px;width:100%}.dayWrapper_8e9f232b,.weekday_8e9f232b{width:28px;height:28px;line-height:28px;font-size:12px}.closeButton_8e9f232b,.prevMonth_8e9f232b,.nextMonth_8e9f232b,.prevYear_8e9f232b,.nextYear_8e9f232b,.prevDecade_8e9f232b,.nextDecade_8e9f232b{font-size:12px;width:28px;height:28px;line-height:28px}.holder_8e9f232b{display:inline-block;height:auto;overflow:hidden}.monthAndYear_8e9f232b,.year_8e9f232b,.decade_8e9f232b{font-size:14px;color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": "}.yearComponents_8e9f232b{margin-left:1px}.goToday_8e9f232b{padding:0 3px}[dir='ltr'] .goToday_8e9f232b{right:20px}[dir='rtl'] .goToday_8e9f232b{left:20px}.showWeekNumbers_8e9f232b .table_8e9f232b .dayWrapper_8e9f232b,.showWeekNumbers_8e9f232b .table_8e9f232b .weekday_8e9f232b{width:28px}.showWeekNumbersRTL_8e9f232b .table_8e9f232b .dayWrapper_8e9f232b,.showWeekNumbersRTL_8e9f232b .table_8e9f232b .weekday_8e9f232b{width:28px}.monthPickerVisible_8e9f232b .wrap_8e9f232b{padding:12px}.monthPickerVisible_8e9f232b .dayPicker_8e9f232b{margin:-10px 0;padding:10px 0}.monthPickerVisible_8e9f232b .dayPicker_8e9f232b{-webkit-box-sizing:border-box;box-sizing:border-box;width:212px;min-height:200px}.monthPickerVisible_8e9f232b .monthPicker_8e9f232b{display:block}.monthPickerVisible_8e9f232b .optionGrid_8e9f232b{height:150px;width:196px}.monthPickerVisible_8e9f232b .toggleMonthView_8e9f232b{display:none}.monthPickerVisible_8e9f232b .currentYear_8e9f232b,.monthPickerVisible_8e9f232b .currentDecade_8e9f232b{font-size:14px;margin:0;height:28px;line-height:28px;display:inline-block}.monthPickerVisible_8e9f232b .monthOption_8e9f232b,.monthPickerVisible_8e9f232b .yearOption_8e9f232b{width:40px;height:40px;line-height:100%;font-size:12px;margin:0 12px 16px 0}html[dir='rtl'] .monthPickerVisible_8e9f232b .monthOption_8e9f232b,html[dir='rtl'] .monthPickerVisible_8e9f232b .yearOption_8e9f232b{margin:0 0 16px 12px}.monthPickerVisible_8e9f232b .monthOption_8e9f232b:hover,.monthPickerVisible_8e9f232b .yearOption_8e9f232b:hover{outline:1px solid transparent}.monthPickerVisible_8e9f232b .monthOption_8e9f232b:nth-child(4n+4),.monthPickerVisible_8e9f232b .yearOption_8e9f232b:nth-child(4n+4){margin:0 0px 16px 0}html[dir='rtl'] .monthPickerVisible_8e9f232b .monthOption_8e9f232b:nth-child(4n+4),html[dir='rtl'] .monthPickerVisible_8e9f232b .yearOption_8e9f232b:nth-child(4n+4){margin:0 0 16px 0px}.monthPickerVisible_8e9f232b .goToday_8e9f232b{font-size:12px;height:28px;line-height:28px;padding:0 10px}[dir='ltr'] .monthPickerVisible_8e9f232b .goToday_8e9f232b{right:8px}[dir='rtl'] .monthPickerVisible_8e9f232b .goToday_8e9f232b{left:8px}html[dir='ltr'] .monthPickerVisible_8e9f232b .goToday_8e9f232b{text-align:right}html[dir='rtl'] .monthPickerVisible_8e9f232b .goToday_8e9f232b{text-align:left}.monthPickerVisible_8e9f232b .root_8e9f232b.isPickingYears_8e9f232b .dayPicker_8e9f232b,.monthPickerVisible_8e9f232b .root_8e9f232b.isPickingYears_8e9f232b .monthComponents_8e9f232b{display:block}.monthPickerVisible_8e9f232b .root_8e9f232b.isPickingYears_8e9f232b .monthPicker_8e9f232b{display:none}.monthPickerVisible_8e9f232b .root_8e9f232b.isPickingYears_8e9f232b .yearPicker_8e9f232b{display:block}.calendarsInline_8e9f232b .wrap_8e9f232b{padding:12px}.calendarsInline_8e9f232b .holder_8e9f232b{height:auto}html[dir='ltr'] .calendarsInline_8e9f232b .table_8e9f232b{margin-right:12px}html[dir='rtl'] .calendarsInline_8e9f232b .table_8e9f232b{margin-left:12px}.calendarsInline_8e9f232b .dayPicker_8e9f232b{width:auto}html[dir='ltr'] .calendarsInline_8e9f232b .monthPicker_8e9f232b{margin-left:12px}html[dir='rtl'] .calendarsInline_8e9f232b .monthPicker_8e9f232b{margin-right:12px}html[dir='ltr'] .calendarsInline_8e9f232b .yearPicker_8e9f232b{margin-left:12px}html[dir='rtl'] .calendarsInline_8e9f232b .yearPicker_8e9f232b{margin-right:12px}.calendarsInline_8e9f232b .goToday_8e9f232b{padding:0 10px}[dir='ltr'] .calendarsInline_8e9f232b .goToday_8e9f232b{right:14px}[dir='rtl'] .calendarsInline_8e9f232b .goToday_8e9f232b{left:14px}html[dir='ltr'] .calendarsInline_8e9f232b .monthComponents_8e9f232b{margin-right:12px}html[dir='rtl'] .calendarsInline_8e9f232b .monthComponents_8e9f232b{margin-left:12px}.monthPickerOnly_8e9f232b .wrap_8e9f232b{padding:12px}.monthPickerAsOverlay_8e9f232b .wrap_8e9f232b{padding-bottom:28px;margin-bottom:6px}.monthPickerAsOverlay_8e9f232b .holder_8e9f232b{height:240px;min-height:240px}.monthPickerAsOverlay_8e9f232b .holderWithButton_8e9f232b{padding-top:6px;height:auto}}@media (max-device-width: 459px){.calendarsInline_8e9f232b .monthPicker_8e9f232b,.calendarsInline_8e9f232b .yearPicker_8e9f232b{display:none}.yearComponents_8e9f232b{margin-top:2px}}.goToday_8e9f232b{width:auto}.closeButton_8e9f232b,.nextMonth_8e9f232b,.prevMonth_8e9f232b,.nextYear_8e9f232b,.prevYear_8e9f232b,.nextDecade_8e9f232b,.prevDecade_8e9f232b{display:inline-block}.closeButton_8e9f232b:hover,.nextMonth_8e9f232b:hover,.prevMonth_8e9f232b:hover,.nextYear_8e9f232b:hover,.prevYear_8e9f232b:hover,.nextDecade_8e9f232b:hover,.prevDecade_8e9f232b:hover{background-color:" }, { "theme": "neutralLight", "defaultValue": "#eaeaea" }, { "rawString": ";color:" }, { "theme": "neutralDark", "defaultValue": "#212121" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.closeButton_8e9f232b:hover,.nextMonth_8e9f232b:hover,.prevMonth_8e9f232b:hover,.nextYear_8e9f232b:hover,.prevYear_8e9f232b:hover,.nextDecade_8e9f232b:hover,.prevDecade_8e9f232b:hover{outline:1px solid highlight}}.closeButton_8e9f232b:active,.nextMonth_8e9f232b:active,.prevMonth_8e9f232b:active,.nextYear_8e9f232b:active,.prevYear_8e9f232b:active,.nextDecade_8e9f232b:active,.prevDecade_8e9f232b:active{background-color:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.closeButton_8e9f232b:active,.nextMonth_8e9f232b:active,.prevMonth_8e9f232b:active,.nextYear_8e9f232b:active,.prevYear_8e9f232b:active,.nextDecade_8e9f232b:active,.prevDecade_8e9f232b:active{color:highlight}}.monthIsHighlighted_8e9f232b{font-weight:600;background-color:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": ";color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": "}.monthIsHighlighted_8e9f232b.monthOption_8e9f232b:hover{background-color:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.monthIsHighlighted_8e9f232b{color:highlight;border:2px solid highlight;border-radius:2px}.monthIsHighlighted_8e9f232b:hover{outline:0 !important}}.monthIsCurrentMonth_8e9f232b{font-weight:600;color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": ";background-color:" }, { "theme": "themePrimary", "defaultValue": "#0078d4" }, { "rawString": "}.monthIsCurrentMonth_8e9f232b.monthOption_8e9f232b:hover{font-weight:600;color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": ";background-color:" }, { "theme": "themePrimary", "defaultValue": "#0078d4" }, { "rawString": "}.monthOption_8e9f232b:active{background-color:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": ";color:" }, { "theme": "neutralDark", "defaultValue": "#212121" }, { "rawString": "}.yearIsHighlighted_8e9f232b{font-weight:600;background-color:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": ";color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": "}.yearIsHighlighted_8e9f232b.yearOption_8e9f232b:hover{background-color:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": "}.yearIsCurrentYear_8e9f232b{font-weight:600;color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": ";background-color:" }, { "theme": "themePrimary", "defaultValue": "#0078d4" }, { "rawString": "}.yearIsCurrentYear_8e9f232b.yearOption_8e9f232b:hover{font-weight:600;color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": ";background-color:" }, { "theme": "themePrimary", "defaultValue": "#0078d4" }, { "rawString": "}.yearOption_8e9f232b:active{background-color:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": ";color:" }, { "theme": "neutralDark", "defaultValue": "#212121" }, { "rawString": "}.topLeftCornerDate_8e9f232b{border-top-left-radius:2px}.topRightCornerDate_8e9f232b{border-top-right-radius:2px}.bottomLeftCornerDate_8e9f232b{border-bottom-left-radius:2px}.bottomRightCornerDate_8e9f232b{border-bottom-right-radius:2px}@media screen and (-ms-high-contrast: active){.weekBackground_8e9f232b{border-top:1px solid highlight;border-bottom:1px solid highlight}.weekBackground_8e9f232b.bottomRightCornerDate_8e9f232b.topRightCornerDate_8e9f232b{border-right:1px solid highlight;border-left:none;padding-left:1px}.weekBackground_8e9f232b.bottomLeftCornerDate_8e9f232b.topLeftCornerDate_8e9f232b{border-left:1px solid highlight;border-right:none;padding-right:1px}.weekBackground_8e9f232b :not(.dayIsToday_8e9f232b) span{color:highlight}.weekSelection_8e9f232b.dayHover_8e9f232b{border-top:1px solid highlight;border-bottom:1px solid highlight}.weekSelection_8e9f232b.dayHover_8e9f232b.bottomLeftCornerDate_8e9f232b.topLeftCornerDate_8e9f232b{border-left:1px solid highlight;padding-right:1px}.weekSelection_8e9f232b.dayHover_8e9f232b.bottomRightCornerDate_8e9f232b.topRightCornerDate_8e9f232b{border-right:1px solid highlight;padding-left:1px}.weekSelection_8e9f232b.dayHover_8e9f232b.dayPress_8e9f232b :not(.dayIsToday_8e9f232b) span{color:highlight}.monthSelection_8e9f232b.dayHover_8e9f232b.bottomLeftCornerDate_8e9f232b,.monthSelection_8e9f232b.dayHover_8e9f232b.topLeftCornerDate_8e9f232b{border-left:1px solid highlight;padding-right:1px}.monthSelection_8e9f232b.dayHover_8e9f232b.bottomRightCornerDate_8e9f232b,.monthSelection_8e9f232b.dayHover_8e9f232b.topRightCornerDate_8e9f232b{border-right:1px solid highlight;padding-left:1px}.monthSelection_8e9f232b.dayIsFocused_8e9f232b.dayHover_8e9f232b.topDate_8e9f232b,.monthSelection_8e9f232b.dayIsUnfocused_8e9f232b.dayHover_8e9f232b.topDate_8e9f232b{border-top:1px solid highlight;padding-bottom:1px}.monthSelection_8e9f232b.dayIsFocused_8e9f232b.dayHover_8e9f232b.rightDate_8e9f232b,.monthSelection_8e9f232b.dayIsUnfocused_8e9f232b.dayHover_8e9f232b.rightDate_8e9f232b{border-right:1px solid highlight;padding-left:1px}.monthSelection_8e9f232b.dayIsFocused_8e9f232b.dayHover_8e9f232b.bottomDate_8e9f232b,.monthSelection_8e9f232b.dayIsUnfocused_8e9f232b.dayHover_8e9f232b.bottomDate_8e9f232b{border-bottom:1px solid highlight;padding-top:1px}.monthSelection_8e9f232b.dayIsFocused_8e9f232b.dayHover_8e9f232b.leftdate_8e9f232b,.monthSelection_8e9f232b.dayIsUnfocused_8e9f232b.dayHover_8e9f232b.leftdate_8e9f232b{border-left:1px solid highlight;padding-right:1px}.monthSelection_8e9f232b.dayIsFocused_8e9f232b.dayHover_8e9f232b.dayPress_8e9f232b :not(.dayIsToday_8e9f232b) span,.monthSelection_8e9f232b.dayIsUnfocused_8e9f232b.dayHover_8e9f232b.dayPress_8e9f232b :not(.dayIsToday_8e9f232b) span{color:highlight}}\n" }]);
var root = "root_8e9f232b";
var picker = "picker_8e9f232b";
var holder = "holder_8e9f232b";
var pickerIsOpened = "pickerIsOpened_8e9f232b";
var frame = "frame_8e9f232b";
var wrap = "wrap_8e9f232b";
var goTodaySpacing = "goTodaySpacing_8e9f232b";
var dayPicker = "dayPicker_8e9f232b";
var header = "header_8e9f232b";
var divider = "divider_8e9f232b";
var monthAndYear = "monthAndYear_8e9f232b";
var year = "year_8e9f232b";
var decade = "decade_8e9f232b";
var currentYear = "currentYear_8e9f232b";
var currentDecade = "currentDecade_8e9f232b";
var table = "table_8e9f232b";
var dayWrapper = "dayWrapper_8e9f232b";
var weekday = "weekday_8e9f232b";
var day = "day_8e9f232b";
var daySelection = "daySelection_8e9f232b";
var dayIsToday = "dayIsToday_8e9f232b";
var dayIsDisabled = "dayIsDisabled_8e9f232b";
var dayIsUnfocused = "dayIsUnfocused_8e9f232b";
var dayIsFocused = "dayIsFocused_8e9f232b";
var dayIsHighlighted = "dayIsHighlighted_8e9f232b";
var pickerIsFocused = "pickerIsFocused_8e9f232b";
var dayDisabled = "dayDisabled_8e9f232b";
var dayBackground = "dayBackground_8e9f232b";
var dayHover = "dayHover_8e9f232b";
var dayPress = "dayPress_8e9f232b";
var weekBackground = "weekBackground_8e9f232b";
var showWeekNumbers = "showWeekNumbers_8e9f232b";
var weekNumbers = "weekNumbers_8e9f232b";
var weekIsHighlighted = "weekIsHighlighted_8e9f232b";
var showWeekNumbersRTL = "showWeekNumbersRTL_8e9f232b";
var monthComponents = "monthComponents_8e9f232b";
var yearComponents = "yearComponents_8e9f232b";
var decadeComponents = "decadeComponents_8e9f232b";
var closeButton = "closeButton_8e9f232b";
var prevMonth = "prevMonth_8e9f232b";
var nextMonth = "nextMonth_8e9f232b";
var prevYear = "prevYear_8e9f232b";
var nextYear = "nextYear_8e9f232b";
var prevDecade = "prevDecade_8e9f232b";
var nextDecade = "nextDecade_8e9f232b";
var prevMonthIsDisabled = "prevMonthIsDisabled_8e9f232b";
var nextMonthIsDisabled = "nextMonthIsDisabled_8e9f232b";
var prevYearIsDisabled = "prevYearIsDisabled_8e9f232b";
var nextYearIsDisabled = "nextYearIsDisabled_8e9f232b";
var prevDecadeIsDisabled = "prevDecadeIsDisabled_8e9f232b";
var nextDecadeIsDisabled = "nextDecadeIsDisabled_8e9f232b";
var headerToggleView = "headerToggleView_8e9f232b";
var optionGrid = "optionGrid_8e9f232b";
var monthOption = "monthOption_8e9f232b";
var yearOption = "yearOption_8e9f232b";
var isHighlighted = "isHighlighted_8e9f232b";
var monthOptionIsDisabled = "monthOptionIsDisabled_8e9f232b";
var yearOptionIsDisabled = "yearOptionIsDisabled_8e9f232b";
var goToday = "goToday_8e9f232b";
var goToTodayIsDisabled = "goToTodayIsDisabled_8e9f232b";
var goTodayInlineMonth = "goTodayInlineMonth_8e9f232b";
var isPickingYears = "isPickingYears_8e9f232b";
var monthPicker = "monthPicker_8e9f232b";
var yearPicker = "yearPicker_8e9f232b";
var monthPickerVisible = "monthPickerVisible_8e9f232b";
var toggleMonthView = "toggleMonthView_8e9f232b";
var calendarsInline = "calendarsInline_8e9f232b";
var monthPickerOnly = "monthPickerOnly_8e9f232b";
var monthPickerAsOverlay = "monthPickerAsOverlay_8e9f232b";
var holderWithButton = "holderWithButton_8e9f232b";
var monthIsHighlighted = "monthIsHighlighted_8e9f232b";
var monthIsCurrentMonth = "monthIsCurrentMonth_8e9f232b";
var yearIsHighlighted = "yearIsHighlighted_8e9f232b";
var yearIsCurrentYear = "yearIsCurrentYear_8e9f232b";
var topLeftCornerDate = "topLeftCornerDate_8e9f232b";
var topRightCornerDate = "topRightCornerDate_8e9f232b";
var bottomLeftCornerDate = "bottomLeftCornerDate_8e9f232b";
var bottomRightCornerDate = "bottomRightCornerDate_8e9f232b";
var weekSelection = "weekSelection_8e9f232b";
var monthSelection = "monthSelection_8e9f232b";
var topDate = "topDate_8e9f232b";
var rightDate = "rightDate_8e9f232b";
var bottomDate = "bottomDate_8e9f232b";
var leftdate = "leftdate_8e9f232b";
//# sourceMappingURL=Calendar.scss.js.map

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hsv2hex;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hsv2rgb__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rgb2hex__ = __webpack_require__(154);


/** Converts HSV components to a hex color string (without # prefix). */
function hsv2hex(h, s, v) {
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0__hsv2rgb__["a" /* hsv2rgb */])(h, s, v), r = _a.r, g = _a.g, b = _a.b;
    return Object(__WEBPACK_IMPORTED_MODULE_1__rgb2hex__["a" /* rgb2hex */])(r, g, b);
}
//# sourceMappingURL=hsv2hex.js.map

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CommandBar_index__ = __webpack_require__(1881);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_CommandBar_index__["a"]; });

//# sourceMappingURL=CommandBar.js.map

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ValidationState; });
/**
 * Validation state of the user's input.
 * {@docCategory Pickers}
 */
var ValidationState;
(function (ValidationState) {
    /** User input is valid. */
    ValidationState[ValidationState["valid"] = 0] = "valid";
    /** User input could be valid or invalid, its state is not known yet. */
    ValidationState[ValidationState["warning"] = 1] = "warning";
    /** User input is invalid. */
    ValidationState[ValidationState["invalid"] = 2] = "invalid";
})(ValidationState || (ValidationState = {}));
//# sourceMappingURL=BasePicker.types.js.map

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_styled_components__ = __webpack_require__(47);
var _templateObject=_taggedTemplateLiteral(['\n  background-color: #ffffff;\n  text-align: center;\n  color: #404041;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n'],['\n  background-color: #ffffff;\n  text-align: center;\n  color: #404041;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=function Container(_ref){var className=_ref.className,children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:className+' guide-overlay ms-font-xl ms-fontWeight-semibold'},children);};// const StyledContainer = styled(Container)`
//   background-color: #ffffff;
//   top: 0;
//   bottom: 0;
//   left: 0;
//   right: 0;
//   position: absolute;
//   text-align: center;
//   color: #404041;
//   border-radius: 2px;
// `;
var StyledContainer=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_styled_components__["a" /* default */])(Container)(_templateObject);var GuideOverlay=function GuideOverlay(_ref2){var _ref2$label=_ref2.label,label=_ref2$label===undefined?'':_ref2$label,_ref2$isVisible=_ref2.isVisible,isVisible=_ref2$isVisible===undefined?true:_ref2$isVisible,theme=_ref2.theme,children=_ref2.children;return isVisible?__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(StyledContainer,{theme:theme},children):null;};/* harmony default export */ __webpack_exports__["a"] = (GuideOverlay);

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (typeof process === 'undefined' ||
    !process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(147)))

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(395)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bpfrpt_proptype_RowRendererParams */
/* unused harmony export bpfrpt_proptype_RowRenderer */
/* unused harmony export bpfrpt_proptype_RenderedRows */
/* unused harmony export bpfrpt_proptype_Scroll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);

var bpfrpt_proptype_RowRendererParams =  true ? null : {
  "index": PropTypes.number.isRequired,
  "isScrolling": PropTypes.bool.isRequired,
  "isVisible": PropTypes.bool.isRequired,
  "key": PropTypes.string.isRequired,
  "parent": PropTypes.object.isRequired,
  "style": PropTypes.object.isRequired
};
var bpfrpt_proptype_RowRenderer =  true ? null : PropTypes.func;
var bpfrpt_proptype_RenderedRows =  true ? null : {
  "overscanStartIndex": PropTypes.number.isRequired,
  "overscanStopIndex": PropTypes.number.isRequired,
  "startIndex": PropTypes.number.isRequired,
  "stopIndex": PropTypes.number.isRequired
};
var bpfrpt_proptype_Scroll =  true ? null : {
  "clientHeight": PropTypes.number.isRequired,
  "scrollHeight": PropTypes.number.isRequired,
  "scrollTop": PropTypes.number.isRequired
};






/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SortDirection = {
  /**
   * Sort items in ascending order.
   * This means arranging from the lowest value to the highest (e.g. a-z, 0-9).
   */
  ASC: 'ASC',

  /**
   * Sort items in descending order.
   * This means arranging from the highest value to the lowest (e.g. z-a, 9-0).
   */
  DESC: 'DESC'
};
/* harmony default export */ __webpack_exports__["a"] = (SortDirection);

/***/ }),
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_office_ui_fabric_react_lib_TextField__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_src_app_helpers_emailValidator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_src_app_components_Localization__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp2;function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EmailField=Object(__WEBPACK_IMPORTED_MODULE_3__build_src_app_components_Localization__["a" /* localizable */])(_class=(_temp2=_class2=function(_Component){_inherits(EmailField,_Component);function EmailField(){var _ref;var _temp,_this,_ret;_classCallCheck(this,EmailField);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=EmailField.__proto__||Object.getPrototypeOf(EmailField)).call.apply(_ref,[this].concat(args))),_this),_this.emailField=null,_this.validate=function(value){var _this$props=_this.props,originalOnGetErrorMessage=_this$props.onGetErrorMessage,t=_this$props.t;var result=Object(__WEBPACK_IMPORTED_MODULE_2__build_src_app_helpers_emailValidator__["a" /* default */])(value);if(!result)return t('Invalid e-mail');if(originalOnGetErrorMessage)return originalOnGetErrorMessage(value);return'';},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(EmailField,[{key:'render',value:function render(){var _this2=this;var _props=this.props,_=_props.onGetErrorMessage,rest=_objectWithoutProperties(_props,['onGetErrorMessage']);return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_office_ui_fabric_react_lib_TextField__["a" /* TextField */],Object.assign({onGetErrorMessage:this.validate,componentRef:function componentRef(ref){return _this2.emailField=ref;},inputMode:'email'},rest)));}}]);return EmailField;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class2.displayName='EmailField',_temp2))||_class;/* harmony default export */ __webpack_exports__["a"] = (EmailField);

/***/ }),
/* 293 */,
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var tester=/^[-!#$%&'*+/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;// https://github.com/manishsaraan/email-validator/blob/master/index.js
// Thanks to:
// http://fightingforalostcause.net/misc/2006/compare-email-regex.php
// http://thedailywtf.com/Articles/Validating_Email_Addresses.aspx
// http://stackoverflow.com/questions/201323/what-is-the-best-regular-expression-for-validating-email-addresses/201378#201378
/* harmony default export */ __webpack_exports__["a"] = (function(email){if(!email)return false;if(email.length>254)return false;var valid=tester.test(email);if(!valid)return false;// Further checking of some things regex can't handle
var parts=email.split('@');if(parts[0].length>64)return false;var domainParts=parts[1].split('.');if(domainParts.some(function(part){return part.length>63;}))return false;return true;});

/***/ }),
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDefaultUploadTypes;
/**
 * Upload types preselected as required when inviting a buyer. A sale config
 * can make them depend on the sale via `getDefaultUploadTypes(offerData)`.
 */function getDefaultUploadTypes(config){var offerData=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};if(typeof config.getDefaultUploadTypes==='function')return config.getDefaultUploadTypes(offerData||{});return config.defaultUploadTypes||[];}

/***/ }),
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17);
var document = __webpack_require__(14).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(14);
var core = __webpack_require__(70);
var LIBRARY = __webpack_require__(113);
var wksExt = __webpack_require__(496);
var defineProperty = __webpack_require__(25).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(164)('keys');
var uid = __webpack_require__(125);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 326 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(14).document;
module.exports = document && document.documentElement;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(17);
var anObject = __webpack_require__(13);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(71)(Function.call, __webpack_require__(65).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 329 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17);
var setPrototypeOf = __webpack_require__(328).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(73);
var defined = __webpack_require__(93);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 332 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 333 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(113);
var $export = __webpack_require__(3);
var redefine = __webpack_require__(59);
var hide = __webpack_require__(58);
var Iterators = __webpack_require__(142);
var $iterCreate = __webpack_require__(335);
var setToStringTag = __webpack_require__(139);
var getPrototypeOf = __webpack_require__(66);
var ITERATOR = __webpack_require__(20)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(128);
var descriptor = __webpack_require__(124);
var setToStringTag = __webpack_require__(139);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(58)(IteratorPrototype, __webpack_require__(20)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(222);
var defined = __webpack_require__(93);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(20)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(142);
var ITERATOR = __webpack_require__(20)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(25);
var createDesc = __webpack_require__(124);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(140);
var ITERATOR = __webpack_require__(20)('iterator');
var Iterators = __webpack_require__(142);
module.exports = __webpack_require__(70).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(1224);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(27);
var toAbsoluteIndex = __webpack_require__(127);
var toLength = __webpack_require__(21);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(115);
var step = __webpack_require__(513);
var Iterators = __webpack_require__(142);
var toIObject = __webpack_require__(64);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(334)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(167);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(221)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(71);
var invoke = __webpack_require__(503);
var html = __webpack_require__(327);
var cel = __webpack_require__(323);
var global = __webpack_require__(14);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(72)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(14);
var macrotask = __webpack_require__(346).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(72)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(48);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(14);
var DESCRIPTORS = __webpack_require__(23);
var LIBRARY = __webpack_require__(113);
var $typed = __webpack_require__(228);
var hide = __webpack_require__(58);
var redefineAll = __webpack_require__(133);
var fails = __webpack_require__(16);
var anInstance = __webpack_require__(131);
var toInteger = __webpack_require__(73);
var toLength = __webpack_require__(21);
var toIndex = __webpack_require__(523);
var gOPN = __webpack_require__(129).f;
var dP = __webpack_require__(25).f;
var arrayFill = __webpack_require__(342);
var setToStringTag = __webpack_require__(139);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1356);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AppStore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_microsoft_applicationinsights_react_js__ = __webpack_require__(1368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_microsoft_applicationinsights_web__ = __webpack_require__(1377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_history_createBrowserHistory__ = __webpack_require__(1557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_react_ga__ = __webpack_require__(1637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_src_app_services_request__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__build_node_modules_uuid_v4__ = __webpack_require__(1649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__build_node_modules_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__build_node_modules_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_prepareConfig__ = __webpack_require__(391);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_dec2,_desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var STATE_INIT='initializing';var STATE_READY='ready';var STATE_ERROR='error';var gaOptions={storeGac:false,clientId:__WEBPACK_IMPORTED_MODULE_7__build_node_modules_uuid_v4___default()(),storage:'none'};var gaSettings={anonymizeIp:true};var _require=__webpack_require__(392),theme=_require.theme;var AppStore=(_dec=__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["c" /* action */].bound,_dec2=__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["c" /* action */].bound,(_class=function(){_createClass(AppStore,[{key:'ready',// "initializing" | "ready" | "error"
get:function get(){return this.state===STATE_READY;}},{key:'tenant',get:function get(){return this.config.tenant;}},{key:'currency',get:function get(){return this.tenantConfig.currency;}},{key:'tenantConfig',get:function get(){return Object(__WEBPACK_IMPORTED_MODULE_8__helpers_prepareConfig__["b" /* prepareTenantConfig */])(this.config,this.data);}},{key:'features',get:function get(){return Object.assign({},this.config.features,!!this.data?this.data.features:null);}},{key:'canMls',get:function get(){return this.tenantConfig.mlsTypes&&this.tenantConfig.mlsTypes.length>=1&&(this.tenantConfig.mlsTypes.length>1||this.tenantConfig.mlsTypes[0]!=='none')&&this.features&&this.features.mls;}}]);function AppStore(){_classCallCheck(this,AppStore);_initDefineProp(this,'state',_descriptor,this);_initDefineProp(this,'config',_descriptor2,this);_initDefineProp(this,'theme',_descriptor3,this);_initDefineProp(this,'data',_descriptor4,this);this.history=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_history_createBrowserHistory___default()();this.theme=theme;this.history.listen(function(location){__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react_ga__["a" /* default */].set(Object.assign({page:location.pathname+location.search},gaSettings));__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react_ga__["a" /* default */].pageview(location.pathname+location.search);});}_createClass(AppStore,[{key:'setTheme',value:function setTheme(theme){this.theme=theme;Object(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Styling__["D" /* loadTheme */])(Object.assign({},theme));}},{key:'setData',value:function setData(data){this.data=Object.assign({},data);}},{key:'init',value:function init(){Object(__WEBPACK_IMPORTED_MODULE_6__build_src_app_services_request__["d" /* get */])('/.well-known/configuration/dashboard').then(this.initSuccess,this.initError);}},{key:'initSuccess',value:function initSuccess(config){this.state=STATE_READY;this.config=config;if(!config||!config.client){return;}if(!this.tenant.startsWith('propnow')){Object(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Styling__["D" /* loadTheme */])(theme);}if(config.client.ga){__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react_ga__["a" /* default */].initialize(config.client.ga,{gaOptions:gaOptions});__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react_ga__["a" /* default */].set(Object.assign({page:window.location.pathname+window.location.search},gaSettings));__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react_ga__["a" /* default */].pageview(window.location.pathname+window.location.search);}if(config.client.appInsights){var reactPlugin=new __WEBPACK_IMPORTED_MODULE_0__build_node_modules_microsoft_applicationinsights_react_js__["a" /* ReactPlugin */]();var appInsights=new __WEBPACK_IMPORTED_MODULE_1__build_node_modules_microsoft_applicationinsights_web__["a" /* ApplicationInsights */]({config:{instrumentationKey:config.client.appInsights,extensions:[reactPlugin],extensionConfig:_defineProperty({},reactPlugin.identifier,{history:this.history})}});appInsights.loadAppInsights();}}},{key:'initError',value:function initError(error){this.state=STATE_ERROR;}},{key:'getSaleFeatures',value:function getSaleFeatures(additional){return Object.fromEntries([['disableRightOfWithdrawal',this.features.disableRightOfWithdrawal],['alwaysShowBuyerConditions',this.features.alwaysShowBuyerConditions],['neverShowBuyerConditions',this.features.neverShowBuyerConditions],['bidNotificationsToAll',this.features.bidNotificationsToAll],['hideBiddingHistoryOnClose',this.features.hideBiddingHistoryOnClose],['disableAutomaticReminders',this.features.disableAutomaticReminders]].concat(_toConsumableArray(Object.entries(additional||{}))).filter(function(a){return!!a[1];}));}}]);return AppStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'state',[__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return STATE_INIT;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'config',[__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:null}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'theme',[__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:null}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'data',[__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:null}),_applyDecoratedDescriptor(_class.prototype,'ready',[__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'ready'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'tenant',[__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'tenant'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'currency',[__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'currency'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'tenantConfig',[__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'tenantConfig'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'features',[__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'features'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'canMls',[__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'canMls'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setTheme',[__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'setTheme'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setData',[__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'setData'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'init',[__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'init'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'initSuccess',[_dec],Object.getOwnPropertyDescriptor(_class.prototype,'initSuccess'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'initError',[_dec2],Object.getOwnPropertyDescriptor(_class.prototype,'initError'),_class.prototype)),_class));var app=new AppStore();/* harmony default export */ __webpack_exports__["a"] = (app);

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _InternalLogMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DiagnosticLogger; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_LoggingEnums__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CoreUtils__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EnvUtils__ = __webpack_require__(232);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.




var _InternalLogMessage = /** @class */ (function () {
    function _InternalLogMessage(msgId, msg, isUserAct, properties) {
        if (isUserAct === void 0) { isUserAct = false; }
        this.messageId = msgId;
        this.message =
            (isUserAct ? _InternalLogMessage.AiUserActionablePrefix : _InternalLogMessage.AiNonUserActionablePrefix) +
                msgId;
        var strProps = "";
        if (Object(__WEBPACK_IMPORTED_MODULE_2__EnvUtils__["d" /* hasJSON */])()) {
            strProps = Object(__WEBPACK_IMPORTED_MODULE_2__EnvUtils__["b" /* getJSON */])().stringify(properties);
        }
        var diagnosticText = (msg ? " message:" + _InternalLogMessage.sanitizeDiagnosticText(msg) : "") +
            (properties ? " props:" + _InternalLogMessage.sanitizeDiagnosticText(strProps) : "");
        this.message += diagnosticText;
    }
    _InternalLogMessage.sanitizeDiagnosticText = function (text) {
        if (text) {
            return "\"" + text.replace(/\"/g, "") + "\"";
        }
        return "";
    };
    _InternalLogMessage.dataType = "MessageData";
    /**
     * For user non actionable traces use AI Internal prefix.
     */
    _InternalLogMessage.AiNonUserActionablePrefix = "AI (Internal): ";
    /**
     * Prefix of the traces in portal.
     */
    _InternalLogMessage.AiUserActionablePrefix = "AI: ";
    return _InternalLogMessage;
}());

var DiagnosticLogger = /** @class */ (function () {
    function DiagnosticLogger(config) {
        /**
         * The internal logging queue
         */
        this.queue = [];
        /**
         *  Session storage key for the prefix for the key indicating message type already logged
         */
        this.AIInternalMessagePrefix = "AITR_";
        /**
         * Count of internal messages sent
         */
        this._messageCount = 0;
        /**
         * Holds information about what message types were already logged to console or sent to server.
         */
        this._messageLogged = {};
        /**
         * When this is true the SDK will throw exceptions to aid in debugging.
         */
        this.enableDebugExceptions = function () { return false; };
        /**
         * 0: OFF (default)
         * 1: CRITICAL
         * 2: >= WARNING
         */
        this.consoleLoggingLevel = function () { return 0; };
        /**
         * 0: OFF
         * 1: CRITICAL (default)
         * 2: >= WARNING
         */
        this.telemetryLoggingLevel = function () { return 1; };
        /**
         * The maximum number of internal messages allowed to be sent per page view
         */
        this.maxInternalMessageLimit = function () { return 25; };
        if (__WEBPACK_IMPORTED_MODULE_1__CoreUtils__["a" /* CoreUtils */].isNullOrUndefined(config)) {
            // TODO: Use default config
            // config = AppInsightsCore.defaultConfig;
            // For now, use defaults specified in DiagnosticLogger members;
            return;
        }
        if (!__WEBPACK_IMPORTED_MODULE_1__CoreUtils__["a" /* CoreUtils */].isNullOrUndefined(config.loggingLevelConsole)) {
            this.consoleLoggingLevel = function () { return config.loggingLevelConsole; };
        }
        if (!__WEBPACK_IMPORTED_MODULE_1__CoreUtils__["a" /* CoreUtils */].isNullOrUndefined(config.loggingLevelTelemetry)) {
            this.telemetryLoggingLevel = function () { return config.loggingLevelTelemetry; };
        }
        if (!__WEBPACK_IMPORTED_MODULE_1__CoreUtils__["a" /* CoreUtils */].isNullOrUndefined(config.maxMessageLimit)) {
            this.maxInternalMessageLimit = function () { return config.maxMessageLimit; };
        }
        if (!__WEBPACK_IMPORTED_MODULE_1__CoreUtils__["a" /* CoreUtils */].isNullOrUndefined(config.enableDebugExceptions)) {
            this.enableDebugExceptions = function () { return config.enableDebugExceptions; };
        }
    }
    /**
     * This method will throw exceptions in debug mode or attempt to log the error as a console warning.
     * @param severity {LoggingSeverity} - The severity of the log message
     * @param message {_InternalLogMessage} - The log message.
     */
    DiagnosticLogger.prototype.throwInternal = function (severity, msgId, msg, properties, isUserAct) {
        if (isUserAct === void 0) { isUserAct = false; }
        var message = new _InternalLogMessage(msgId, msg, isUserAct, properties);
        var _this = this;
        if (_this.enableDebugExceptions()) {
            throw message;
        }
        else {
            if (!__WEBPACK_IMPORTED_MODULE_1__CoreUtils__["a" /* CoreUtils */].isUndefined(message) && !!message) {
                if (!__WEBPACK_IMPORTED_MODULE_1__CoreUtils__["a" /* CoreUtils */].isUndefined(message.message)) {
                    if (isUserAct) {
                        // check if this message type was already logged to console for this page view and if so, don't log it again
                        var messageKey = +message.messageId;
                        if (!_this._messageLogged[messageKey] && _this.consoleLoggingLevel() >= __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_LoggingEnums__["a" /* LoggingSeverity */].WARNING) {
                            _this.warnToConsole(message.message);
                            _this._messageLogged[messageKey] = true;
                        }
                    }
                    else {
                        // don't log internal AI traces in the console, unless the verbose logging is enabled
                        if (_this.consoleLoggingLevel() >= __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_LoggingEnums__["a" /* LoggingSeverity */].WARNING) {
                            _this.warnToConsole(message.message);
                        }
                    }
                    _this.logInternalMessage(severity, message);
                }
            }
        }
    };
    /**
     * This will write a warning to the console if possible
     * @param message {string} - The warning message
     */
    DiagnosticLogger.prototype.warnToConsole = function (message) {
        if (!__WEBPACK_IMPORTED_MODULE_1__CoreUtils__["a" /* CoreUtils */].isUndefined(console) && !!console) {
            if (__WEBPACK_IMPORTED_MODULE_1__CoreUtils__["a" /* CoreUtils */].isFunction(console.warn)) {
                console.warn(message);
            }
            else if (__WEBPACK_IMPORTED_MODULE_1__CoreUtils__["a" /* CoreUtils */].isFunction(console.log)) {
                console.log(message);
            }
        }
    };
    /**
     * Resets the internal message count
     */
    DiagnosticLogger.prototype.resetInternalMessageCount = function () {
        this._messageCount = 0;
        this._messageLogged = {};
    };
    /**
     * Logs a message to the internal queue.
     * @param severity {LoggingSeverity} - The severity of the log message
     * @param message {_InternalLogMessage} - The message to log.
     */
    DiagnosticLogger.prototype.logInternalMessage = function (severity, message) {
        var _this = this;
        if (_this._areInternalMessagesThrottled()) {
            return;
        }
        // check if this message type was already logged for this session and if so, don't log it again
        var logMessage = true;
        var messageKey = _this.AIInternalMessagePrefix + message.messageId;
        // if the session storage is not available, limit to only one message type per page view
        if (_this._messageLogged[messageKey]) {
            logMessage = false;
        }
        else {
            _this._messageLogged[messageKey] = true;
        }
        if (logMessage) {
            // Push the event in the internal queue
            if (severity <= _this.telemetryLoggingLevel()) {
                _this.queue.push(message);
                _this._messageCount++;
            }
            // When throttle limit reached, send a special event
            if (_this._messageCount === _this.maxInternalMessageLimit()) {
                var throttleLimitMessage = "Internal events throttle limit per PageView reached for this app.";
                var throttleMessage = new _InternalLogMessage(__WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_LoggingEnums__["b" /* _InternalMessageId */].MessageLimitPerPVExceeded, throttleLimitMessage, false);
                _this.queue.push(throttleMessage);
                _this.warnToConsole(throttleLimitMessage);
            }
        }
    };
    /**
     * Indicates whether the internal events are throttled
     */
    DiagnosticLogger.prototype._areInternalMessagesThrottled = function () {
        return this._messageCount >= this.maxInternalMessageLimit();
    };
    return DiagnosticLogger;
}());

//# sourceMappingURL=DiagnosticLogger.js.map

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoggingSeverity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _InternalMessageId; });
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var LoggingSeverity;
(function (LoggingSeverity) {
    /**
     * Error will be sent as internal telemetry
     */
    LoggingSeverity[LoggingSeverity["CRITICAL"] = 1] = "CRITICAL";
    /**
     * Error will NOT be sent as internal telemetry, and will only be shown in browser console
     */
    LoggingSeverity[LoggingSeverity["WARNING"] = 2] = "WARNING";
})(LoggingSeverity || (LoggingSeverity = {}));
/**
 * Internal message ID. Please create a new one for every conceptually different message. Please keep alphabetically ordered
 */
var _InternalMessageId = {
    // Non user actionable
    BrowserDoesNotSupportLocalStorage: 0,
    BrowserCannotReadLocalStorage: 1,
    BrowserCannotReadSessionStorage: 2,
    BrowserCannotWriteLocalStorage: 3,
    BrowserCannotWriteSessionStorage: 4,
    BrowserFailedRemovalFromLocalStorage: 5,
    BrowserFailedRemovalFromSessionStorage: 6,
    CannotSendEmptyTelemetry: 7,
    ClientPerformanceMathError: 8,
    ErrorParsingAISessionCookie: 9,
    ErrorPVCalc: 10,
    ExceptionWhileLoggingError: 11,
    FailedAddingTelemetryToBuffer: 12,
    FailedMonitorAjaxAbort: 13,
    FailedMonitorAjaxDur: 14,
    FailedMonitorAjaxOpen: 15,
    FailedMonitorAjaxRSC: 16,
    FailedMonitorAjaxSend: 17,
    FailedMonitorAjaxGetCorrelationHeader: 18,
    FailedToAddHandlerForOnBeforeUnload: 19,
    FailedToSendQueuedTelemetry: 20,
    FailedToReportDataLoss: 21,
    FlushFailed: 22,
    MessageLimitPerPVExceeded: 23,
    MissingRequiredFieldSpecification: 24,
    NavigationTimingNotSupported: 25,
    OnError: 26,
    SessionRenewalDateIsZero: 27,
    SenderNotInitialized: 28,
    StartTrackEventFailed: 29,
    StopTrackEventFailed: 30,
    StartTrackFailed: 31,
    StopTrackFailed: 32,
    TelemetrySampledAndNotSent: 33,
    TrackEventFailed: 34,
    TrackExceptionFailed: 35,
    TrackMetricFailed: 36,
    TrackPVFailed: 37,
    TrackPVFailedCalc: 38,
    TrackTraceFailed: 39,
    TransmissionFailed: 40,
    FailedToSetStorageBuffer: 41,
    FailedToRestoreStorageBuffer: 42,
    InvalidBackendResponse: 43,
    FailedToFixDepricatedValues: 44,
    InvalidDurationValue: 45,
    TelemetryEnvelopeInvalid: 46,
    CreateEnvelopeError: 47,
    // User actionable
    CannotSerializeObject: 48,
    CannotSerializeObjectNonSerializable: 49,
    CircularReferenceDetected: 50,
    ClearAuthContextFailed: 51,
    ExceptionTruncated: 52,
    IllegalCharsInName: 53,
    ItemNotInArray: 54,
    MaxAjaxPerPVExceeded: 55,
    MessageTruncated: 56,
    NameTooLong: 57,
    SampleRateOutOfRange: 58,
    SetAuthContextFailed: 59,
    SetAuthContextFailedAccountName: 60,
    StringValueTooLong: 61,
    StartCalledMoreThanOnce: 62,
    StopCalledWithoutStart: 63,
    TelemetryInitializerFailed: 64,
    TrackArgumentsNotSpecified: 65,
    UrlTooLong: 66,
    SessionStorageBufferFull: 67,
    CannotAccessCookie: 68,
    IdTooLong: 69,
    InvalidEvent: 70,
    FailedMonitorAjaxSetRequestHeader: 71,
    SendBrowserInfoOnUserInit: 72,
    PluginException: 73
};
//# sourceMappingURL=LoggingEnums.js.map

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initializePlugins;
/* harmony export (immutable) */ __webpack_exports__["b"] = sortPlugins;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CoreUtils__ = __webpack_require__(75);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.


var _isFunction = __WEBPACK_IMPORTED_MODULE_0__CoreUtils__["a" /* CoreUtils */].isFunction;
var processTelemetry = "processTelemetry";
var priority = "priority";
var setNextPlugin = "setNextPlugin";
var isInitialized = "isInitialized";
/**
 * Initialize the queue of plugins
 * @param plugins - The array of plugins to initialize and setting of the next plugin
 * @param config The current config for the instance
 * @param core THe current core instance
 * @param extensions The extensions
 */
function initializePlugins(processContext, extensions) {
    // Set the next plugin and identified the uninitialized plugins
    var initPlugins = [];
    var lastPlugin = null;
    var proxy = processContext.getNext();
    while (proxy) {
        var thePlugin = proxy.getPlugin();
        if (thePlugin) {
            if (lastPlugin &&
                _isFunction(lastPlugin[setNextPlugin]) &&
                _isFunction(thePlugin[processTelemetry])) {
                // Set this plugin as the next for the previous one
                lastPlugin[setNextPlugin](thePlugin);
            }
            if (!_isFunction(thePlugin[isInitialized]) || !thePlugin[isInitialized]()) {
                initPlugins.push(thePlugin);
            }
            lastPlugin = thePlugin;
            proxy = proxy.getNext();
        }
    }
    // Now initiatilize the plugins
    __WEBPACK_IMPORTED_MODULE_0__CoreUtils__["a" /* CoreUtils */].arrForEach(initPlugins, function (thePlugin) {
        thePlugin.initialize(processContext.getCfg(), processContext.core(), extensions, processContext.getNext());
    });
}
function sortPlugins(plugins) {
    // Sort by priority
    return plugins.sort(function (extA, extB) {
        var result = 0;
        var bHasProcess = _isFunction(extB[processTelemetry]);
        if (_isFunction(extA[processTelemetry])) {
            result = bHasProcess ? extA[priority] - extB[priority] : 1;
        }
        else if (bHasProcess) {
            result = -1;
        }
        return result;
    });
    // sort complete    
}
//# sourceMappingURL=TelemetryHelpers.js.map

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["a"] = getGlobal;
/* harmony export (immutable) */ __webpack_exports__["c"] = throwTypeError;
/* harmony export (immutable) */ __webpack_exports__["b"] = objCreateFn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(234);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

/**
 * Returns the current global scope object, for a normal web page this will be the current
 * window, for a Web Worker this will be current worker global scope via "self". The internal
 * implementation returns the first available instance object in the following order
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS standard)
 * - <null> (When all else fails)
 * While the return type is a Window for the normal case, not all environments will support all
 * of the properties or functions.
 */
function getGlobal() {
    if (typeof globalThis !== __WEBPACK_IMPORTED_MODULE_0__Constants__["l" /* strShimUndefined */] && globalThis) {
        return globalThis;
    }
    if (typeof self !== __WEBPACK_IMPORTED_MODULE_0__Constants__["l" /* strShimUndefined */] && self) {
        return self;
    }
    if (typeof window !== __WEBPACK_IMPORTED_MODULE_0__Constants__["l" /* strShimUndefined */] && window) {
        return window;
    }
    if (typeof global !== __WEBPACK_IMPORTED_MODULE_0__Constants__["l" /* strShimUndefined */] && global) {
        return global;
    }
    return null;
}
function throwTypeError(message) {
    throw new TypeError(message);
}
/**
 * Creates an object that has the specified prototype, and that optionally contains specified properties. This helper exists to avoid adding a polyfil
 * for older browsers that do not define Object.create eg. ES3 only, IE8 just in case any page checks for presence/absence of the prototype implementation.
 * Note: For consistency this will not use the Object.create implementation if it exists as this would cause a testing requirement to test with and without the implementations
 * @param obj Object to use as a prototype. May be null
 */
function objCreateFn(obj) {
    var func = __WEBPACK_IMPORTED_MODULE_0__Constants__["c" /* ObjCreate */];
    // Use build in Object.create
    if (func) {
        // Use Object create method if it exists
        return func(obj);
    }
    if (obj == null) {
        return {};
    }
    var type = typeof obj;
    if (type !== __WEBPACK_IMPORTED_MODULE_0__Constants__["j" /* strShimObject */] && type !== __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */]) {
        throwTypeError('Object prototype may only be an Object:' + obj);
    }
    function tmpFunc() { }
    tmpFunc[__WEBPACK_IMPORTED_MODULE_0__Constants__["k" /* strShimPrototype */]] = obj;
    return new tmpFunc();
}
//# sourceMappingURL=Helpers.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(33)))

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _InternalLogMessage; });
/* harmony export (immutable) */ __webpack_exports__["c"] = safeGetLogger;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DiagnosticLogger; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_LoggingEnums__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EnvUtils__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__microsoft_dynamicproto_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__ = __webpack_require__(40);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







/**
 * For user non actionable traces use AI Internal prefix.
 */
var AiNonUserActionablePrefix = "AI (Internal): ";
/**
 * Prefix of the traces in portal.
 */
var AiUserActionablePrefix = "AI: ";
/**
 *  Session storage key for the prefix for the key indicating message type already logged
 */
var AIInternalMessagePrefix = "AITR_";
function _sanitizeDiagnosticText(text) {
    if (text) {
        return "\"" + text.replace(/\"/g, "") + "\"";
    }
    return "";
}
var _InternalLogMessage = /** @class */ (function () {
    function _InternalLogMessage(msgId, msg, isUserAct, properties) {
        if (isUserAct === void 0) { isUserAct = false; }
        var _self = this;
        _self.messageId = msgId;
        _self.message =
            (isUserAct ? AiUserActionablePrefix : AiNonUserActionablePrefix) +
                msgId;
        var strProps = "";
        if (Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["n" /* hasJSON */])()) {
            strProps = Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["g" /* getJSON */])().stringify(properties);
        }
        var diagnosticText = (msg ? " message:" + _sanitizeDiagnosticText(msg) : "") +
            (properties ? " props:" + _sanitizeDiagnosticText(strProps) : "");
        _self.message += diagnosticText;
    }
    _InternalLogMessage.dataType = "MessageData";
    return _InternalLogMessage;
}());

function safeGetLogger(core, config) {
    return (core || {}).logger || new DiagnosticLogger(config);
}
var DiagnosticLogger = /** @class */ (function () {
    function DiagnosticLogger(config) {
        this.identifier = 'DiagnosticLogger';
        /**
         * The internal logging queue
         */
        this.queue = [];
        /**
         * Count of internal messages sent
         */
        var _messageCount = 0;
        /**
         * Holds information about what message types were already logged to console or sent to server.
         */
        var _messageLogged = {};
        Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_dynamicproto_js__["a" /* default */])(DiagnosticLogger, this, function (_self) {
            if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["s" /* isNullOrUndefined */])(config)) {
                config = {};
            }
            _self.consoleLoggingLevel = function () { return _getConfigValue('loggingLevelConsole', 0); };
            _self.telemetryLoggingLevel = function () { return _getConfigValue('loggingLevelTelemetry', 1); };
            _self.maxInternalMessageLimit = function () { return _getConfigValue('maxMessageLimit', 25); };
            _self.enableDebugExceptions = function () { return _getConfigValue('enableDebugExceptions', false); };
            /**
             * This method will throw exceptions in debug mode or attempt to log the error as a console warning.
             * @param severity {LoggingSeverity} - The severity of the log message
             * @param message {_InternalLogMessage} - The log message.
             */
            _self.throwInternal = function (severity, msgId, msg, properties, isUserAct) {
                if (isUserAct === void 0) { isUserAct = false; }
                var message = new _InternalLogMessage(msgId, msg, isUserAct, properties);
                if (_self.enableDebugExceptions()) {
                    throw message;
                }
                else {
                    if (!Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["y" /* isUndefined */])(message) && !!message && !Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["y" /* isUndefined */])(message.message)) {
                        var logLevel = _self.consoleLoggingLevel();
                        if (isUserAct) {
                            // check if this message type was already logged to console for this page view and if so, don't log it again
                            var messageKey = +message.messageId;
                            if (!_messageLogged[messageKey] && logLevel >= __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_LoggingEnums__["a" /* LoggingSeverity */].WARNING) {
                                _self.warnToConsole(message.message);
                                _messageLogged[messageKey] = true;
                            }
                        }
                        else {
                            // don't log internal AI traces in the console, unless the verbose logging is enabled
                            if (logLevel >= __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_LoggingEnums__["a" /* LoggingSeverity */].WARNING) {
                                _self.warnToConsole(message.message);
                            }
                        }
                        _self.logInternalMessage(severity, message);
                    }
                }
            };
            /**
             * This will write a warning to the console if possible
             * @param message {string} - The warning message
             */
            _self.warnToConsole = function (message) {
                var theConsole = Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["b" /* getConsole */])();
                if (!!theConsole) {
                    var logFunc = 'log';
                    if (theConsole.warn) {
                        logFunc = 'warn';
                    }
                    if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["p" /* isFunction */])(theConsole[logFunc])) {
                        theConsole[logFunc](message);
                    }
                }
            };
            /**
             * Resets the internal message count
             */
            _self.resetInternalMessageCount = function () {
                _messageCount = 0;
                _messageLogged = {};
            };
            /**
             * Logs a message to the internal queue.
             * @param severity {LoggingSeverity} - The severity of the log message
             * @param message {_InternalLogMessage} - The message to log.
             */
            _self.logInternalMessage = function (severity, message) {
                if (_areInternalMessagesThrottled()) {
                    return;
                }
                // check if this message type was already logged for this session and if so, don't log it again
                var logMessage = true;
                var messageKey = AIInternalMessagePrefix + message.messageId;
                // if the session storage is not available, limit to only one message type per page view
                if (_messageLogged[messageKey]) {
                    logMessage = false;
                }
                else {
                    _messageLogged[messageKey] = true;
                }
                if (logMessage) {
                    // Push the event in the internal queue
                    if (severity <= _self.telemetryLoggingLevel()) {
                        _self.queue.push(message);
                        _messageCount++;
                    }
                    // When throttle limit reached, send a special event
                    if (_messageCount === _self.maxInternalMessageLimit()) {
                        var throttleLimitMessage = "Internal events throttle limit per PageView reached for this app.";
                        var throttleMessage = new _InternalLogMessage(__WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_LoggingEnums__["b" /* _InternalMessageId */].MessageLimitPerPVExceeded, throttleLimitMessage, false);
                        _self.queue.push(throttleMessage);
                        _self.warnToConsole(throttleLimitMessage);
                    }
                }
            };
            function _getConfigValue(name, defValue) {
                var value = config[name];
                if (!Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["s" /* isNullOrUndefined */])(value)) {
                    return value;
                }
                return defValue;
            }
            function _areInternalMessagesThrottled() {
                return _messageCount >= _self.maxInternalMessageLimit();
            }
        });
    }
// Removed Stub for DiagnosticLogger.prototype.enableDebugExceptions.
// Removed Stub for DiagnosticLogger.prototype.consoleLoggingLevel.
// Removed Stub for DiagnosticLogger.prototype.telemetryLoggingLevel.
// Removed Stub for DiagnosticLogger.prototype.maxInternalMessageLimit.
// Removed Stub for DiagnosticLogger.prototype.throwInternal.
// Removed Stub for DiagnosticLogger.prototype.warnToConsole.
// Removed Stub for DiagnosticLogger.prototype.resetInternalMessageCount.
// Removed Stub for DiagnosticLogger.prototype.logInternalMessage.
    return DiagnosticLogger;
}());

//# sourceMappingURL=DiagnosticLogger.js.map

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return strIKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return strExtensionConfig; });
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var strIKey = "iKey";
var strExtensionConfig = "extensionConfig";
//# sourceMappingURL=Constants.js.map

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initializePlugins;
/* harmony export (immutable) */ __webpack_exports__["b"] = sortPlugins;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HelperFuncs__ = __webpack_require__(40);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var processTelemetry = "processTelemetry";
var priority = "priority";
var setNextPlugin = "setNextPlugin";
var isInitialized = "isInitialized";
/**
 * Initialize the queue of plugins
 * @param plugins - The array of plugins to initialize and setting of the next plugin
 * @param config The current config for the instance
 * @param core THe current core instance
 * @param extensions The extensions
 */
function initializePlugins(processContext, extensions) {
    // Set the next plugin and identified the uninitialized plugins
    var initPlugins = [];
    var lastPlugin = null;
    var proxy = processContext.getNext();
    while (proxy) {
        var thePlugin = proxy.getPlugin();
        if (thePlugin) {
            if (lastPlugin &&
                Object(__WEBPACK_IMPORTED_MODULE_0__HelperFuncs__["p" /* isFunction */])(lastPlugin[setNextPlugin]) &&
                Object(__WEBPACK_IMPORTED_MODULE_0__HelperFuncs__["p" /* isFunction */])(thePlugin[processTelemetry])) {
                // Set this plugin as the next for the previous one
                lastPlugin[setNextPlugin](thePlugin);
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__HelperFuncs__["p" /* isFunction */])(thePlugin[isInitialized]) || !thePlugin[isInitialized]()) {
                initPlugins.push(thePlugin);
            }
            lastPlugin = thePlugin;
            proxy = proxy.getNext();
        }
    }
    // Now initiatilize the plugins
    Object(__WEBPACK_IMPORTED_MODULE_0__HelperFuncs__["a" /* arrForEach */])(initPlugins, function (thePlugin) {
        thePlugin.initialize(processContext.getCfg(), processContext.core(), extensions, processContext.getNext());
    });
}
function sortPlugins(plugins) {
    // Sort by priority
    return plugins.sort(function (extA, extB) {
        var result = 0;
        var bHasProcess = Object(__WEBPACK_IMPORTED_MODULE_0__HelperFuncs__["p" /* isFunction */])(extB[processTelemetry]);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__HelperFuncs__["p" /* isFunction */])(extA[processTelemetry])) {
            result = bHasProcess ? extA[priority] - extB[priority] : 1;
        }
        else if (bHasProcess) {
            result = -1;
        }
        return result;
    });
    // sort complete    
}
//# sourceMappingURL=TelemetryHelpers.js.map

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _gblCookieMgr;
/* unused harmony export safeGetCookieMgr */
/* harmony export (immutable) */ __webpack_exports__["b"] = createCookieMgr;
/* unused harmony export areCookiesSupported */
/* harmony export (immutable) */ __webpack_exports__["c"] = uaDisallowsSameSiteNone;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_LoggingEnums__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EnvUtils__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__ = __webpack_require__(40);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



var strToGMTString = "toGMTString";
var strToUTCString = "toUTCString";
var strCookie = "cookie";
var strExpires = "expires";
var strEnabled = "enabled";
var strIsCookieUseDisabled = "isCookieUseDisabled";
var strDisableCookiesUsage = "disableCookiesUsage";
var strConfigCookieMgr = "_ckMgr";
var strEmpty = "";
var _supportsCookies = null;
var _allowUaSameSite = null;
var _parsedCookieValue = null;
var _doc = Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["d" /* getDocument */])();
var _cookieCache = {};
var _globalCookieConfig = {};
/**
 * @ignore
 * DO NOT USE or export from the module, this is exposed as public to support backward compatibility of previous static utility methods only.
 * If you want to manager cookies either use the ICookieMgr available from the core instance via getCookieMgr() or create
 * your own instance of the CookieMgr and use that.
 * Using this directly for enabling / disabling cookie handling will not only affect your usage but EVERY user of cookies.
 * Example, if you are using a shared component that is also using Application Insights you will affect their cookie handling.
 * @param logger - The DiagnosticLogger to use for reporting errors.
 */
function _gblCookieMgr(config, logger) {
    // Stash the global instance against the BaseCookieMgr class
    var inst = createCookieMgr[strConfigCookieMgr] || _globalCookieConfig[strConfigCookieMgr];
    if (!inst) {
        // Note: not using the getSetValue() helper as that would require always creating a temporary cookieMgr
        // that ultimately is never used
        inst = createCookieMgr[strConfigCookieMgr] = createCookieMgr(config, logger);
        _globalCookieConfig[strConfigCookieMgr] = inst;
    }
    return inst;
}
function _isMgrEnabled(cookieMgr) {
    if (cookieMgr) {
        return cookieMgr.isEnabled();
    }
    return true;
}
function _createCookieMgrConfig(rootConfig) {
    var cookieMgrCfg = rootConfig.cookieCfg = rootConfig.cookieCfg || {};
    // Sets the values from the root config if not already present on the cookieMgrCfg
    Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* setValue */])(cookieMgrCfg, "domain", rootConfig.cookieDomain, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["q" /* isNotNullOrUndefined */], __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */]);
    Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* setValue */])(cookieMgrCfg, "path", rootConfig.cookiePath || "/", null, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */]);
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */])(cookieMgrCfg[strEnabled])) {
        // Set the enabled from the provided setting or the legacy root values
        var cookieEnabled = void 0;
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */])(rootConfig[strIsCookieUseDisabled])) {
            cookieEnabled = !rootConfig[strIsCookieUseDisabled];
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */])(rootConfig[strDisableCookiesUsage])) {
            cookieEnabled = !rootConfig[strDisableCookiesUsage];
        }
        cookieMgrCfg[strEnabled] = cookieEnabled;
    }
    return cookieMgrCfg;
}
/**
 * Helper to return the ICookieMgr from the core (if not null/undefined) or a default implementation
 * associated with the configuration or a legacy default.
 * @param core
 * @param config
 * @returns
 */
function safeGetCookieMgr(core, config) {
    var cookieMgr;
    if (core) {
        // Always returns an instance
        cookieMgr = core.getCookieMgr();
    }
    else if (config) {
        var cookieCfg = (config || {}).cookieCfg;
        if (cookieCfg[strConfigCookieMgr]) {
            cookieMgr = cookieCfg[strConfigCookieMgr];
        }
        else {
            cookieMgr = createCookieMgr(config);
        }
    }
    if (!cookieMgr) {
        // Get or initialize the default global (legacy) cookie manager if we couldn't find one
        cookieMgr = _gblCookieMgr(config, (core || {}).logger);
    }
    return cookieMgr;
}
function createCookieMgr(rootConfig, logger) {
    var cookieMgrConfig = _createCookieMgrConfig(rootConfig || _globalCookieConfig);
    var _path = cookieMgrConfig.path || "/";
    var _domain = cookieMgrConfig.domain;
    // Explicitly checking against false, so that setting to undefined will === true
    var _enabled = cookieMgrConfig[strEnabled] !== false;
    var cookieMgr = {
        isEnabled: function () {
            var enabled = _enabled && areCookiesSupported(logger);
            // Using an indirect lookup for any global cookie manager to support tree shaking for SDK's
            // that don't use the "applicationinsights-core" version of the default cookie function
            var gblManager = _globalCookieConfig[strConfigCookieMgr];
            if (enabled && gblManager && cookieMgr !== gblManager) {
                // Make sure the GlobalCookie Manager instance (if not this instance) is also enabled.
                // As the global (deprecated) functions may have been called (for backward compatibility)
                enabled = _isMgrEnabled(gblManager);
            }
            return enabled;
        },
        setEnabled: function (value) {
            // Explicitly checking against false, so that setting to undefined will === true
            _enabled = value !== false;
        },
        set: function (name, value, maxAgeSec, domain, path) {
            if (_isMgrEnabled(cookieMgr)) {
                var values = {};
                var theValue = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["G" /* strTrim */])(value || strEmpty);
                var idx = theValue.indexOf(";");
                if (idx !== -1) {
                    theValue = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["G" /* strTrim */])(value.substring(0, idx));
                    values = _extractParts(value.substring(idx + 1));
                }
                // Only update domain if not already present (isUndefined) and the value is truthy (not null, undefined or empty string)
                Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* setValue */])(values, "domain", domain || _domain, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["w" /* isTruthy */], __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */]);
                if (!Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */])(maxAgeSec)) {
                    var _isIE = Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["p" /* isIE */])();
                    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */])(values[strExpires])) {
                        var nowMs = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["g" /* dateNow */])();
                        // Only add expires if not already present
                        var expireMs = nowMs + (maxAgeSec * 1000);
                        // Sanity check, if zero or -ve then ignore
                        if (expireMs > 0) {
                            var expiry = new Date();
                            expiry.setTime(expireMs);
                            Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* setValue */])(values, strExpires, _formatDate(expiry, !_isIE ? strToUTCString : strToGMTString) || _formatDate(expiry, _isIE ? strToGMTString : strToUTCString) || strEmpty, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["w" /* isTruthy */]);
                        }
                    }
                    if (!_isIE) {
                        // Only replace if not already present
                        Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* setValue */])(values, "max-age", strEmpty + maxAgeSec, null, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */]);
                    }
                }
                var location_1 = Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["h" /* getLocation */])();
                if (location_1 && location_1.protocol === "https:") {
                    Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* setValue */])(values, "secure", null, null, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */]);
                    // Only set same site if not also secure
                    if (_allowUaSameSite === null) {
                        _allowUaSameSite = !uaDisallowsSameSiteNone((Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["j" /* getNavigator */])() || {}).userAgent);
                    }
                    if (_allowUaSameSite) {
                        Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* setValue */])(values, "SameSite", "None", null, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */]);
                    }
                }
                Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* setValue */])(values, "path", path || _path, null, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */]);
                var setCookieFn = cookieMgrConfig.setCookie || _setCookieValue;
                setCookieFn(name, _formatCookieValue(theValue, values));
            }
        },
        get: function (name) {
            var value = strEmpty;
            if (_isMgrEnabled(cookieMgr)) {
                value = (cookieMgrConfig.getCookie || _getCookieValue)(name);
            }
            return value;
        },
        del: function (name, path) {
            if (_isMgrEnabled(cookieMgr)) {
                // Only remove the cookie if the manager and cookie support has not been disabled
                cookieMgr.purge(name, path);
            }
        },
        purge: function (name, path) {
            if (areCookiesSupported(logger)) {
                // Setting the expiration date in the past immediately removes the cookie
                var values = (_a = {},
                    _a["path"] = path ? path : "/",
                    _a[strExpires] = "Thu, 01 Jan 1970 00:00:01 GMT",
                    _a);
                if (!Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["p" /* isIE */])()) {
                    // Set max age to expire now
                    values["max-age"] = "0";
                }
                var delCookie = cookieMgrConfig.delCookie || _setCookieValue;
                delCookie(name, _formatCookieValue(strEmpty, values));
            }
            var _a;
        }
    };
    // Associated this cookie manager with the config
    cookieMgr[strConfigCookieMgr] = cookieMgr;
    return cookieMgr;
}
/*
* Helper method to tell if document.cookie object is supported by the runtime
*/
function areCookiesSupported(logger) {
    if (_supportsCookies === null) {
        _supportsCookies = false;
        try {
            var doc = _doc || {};
            _supportsCookies = doc[strCookie] !== undefined;
        }
        catch (e) {
            logger && logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_LoggingEnums__["a" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_LoggingEnums__["b" /* _InternalMessageId */].CannotAccessCookie, "Cannot access document.cookie - " + Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["i" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["a" /* dumpObj */])(e) });
        }
    }
    return _supportsCookies;
}
function _extractParts(theValue) {
    var values = {};
    if (theValue && theValue.length) {
        var parts = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["G" /* strTrim */])(theValue).split(";");
        Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["a" /* arrForEach */])(parts, function (thePart) {
            thePart = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["G" /* strTrim */])(thePart || strEmpty);
            if (thePart) {
                var idx = thePart.indexOf("=");
                if (idx === -1) {
                    values[thePart] = null;
                }
                else {
                    values[Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["G" /* strTrim */])(thePart.substring(0, idx))] = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["G" /* strTrim */])(thePart.substring(idx + 1));
                }
            }
        });
    }
    return values;
}
function _formatDate(theDate, func) {
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["p" /* isFunction */])(theDate[func])) {
        return theDate[func]();
    }
    return null;
}
function _formatCookieValue(value, values) {
    var cookieValue = value || strEmpty;
    Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["A" /* objForEachKey */])(values, function (name, theValue) {
        cookieValue += "; " + name + (!Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */])(theValue) ? "=" + theValue : strEmpty);
    });
    return cookieValue;
}
function _getCookieValue(name) {
    var cookieValue = strEmpty;
    if (_doc) {
        var theCookie = _doc[strCookie] || strEmpty;
        if (_parsedCookieValue !== theCookie) {
            _cookieCache = _extractParts(theCookie);
            _parsedCookieValue = theCookie;
        }
        cookieValue = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["G" /* strTrim */])(_cookieCache[name] || strEmpty);
    }
    return cookieValue;
}
function _setCookieValue(name, cookieValue) {
    if (_doc) {
        _doc[strCookie] = name + "=" + cookieValue;
    }
}
function uaDisallowsSameSiteNone(userAgent) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["v" /* isString */])(userAgent)) {
        return false;
    }
    // Cover all iOS based browsers here. This includes:
    // - Safari on iOS 12 for iPhone, iPod Touch, iPad
    // - WkWebview on iOS 12 for iPhone, iPod Touch, iPad
    // - Chrome on iOS 12 for iPhone, iPod Touch, iPad
    // All of which are broken by SameSite=None, because they use the iOS networking stack
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["E" /* strContains */])(userAgent, "CPU iPhone OS 12") || Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["E" /* strContains */])(userAgent, "iPad; CPU OS 12")) {
        return true;
    }
    // Cover Mac OS X based browsers that use the Mac OS networking stack. This includes:
    // - Safari on Mac OS X
    // This does not include:
    // - Internal browser on Mac OS X
    // - Chrome on Mac OS X
    // - Chromium on Mac OS X
    // Because they do not use the Mac OS networking stack.
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["E" /* strContains */])(userAgent, "Macintosh; Intel Mac OS X 10_14") && Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["E" /* strContains */])(userAgent, "Version/") && Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["E" /* strContains */])(userAgent, "Safari")) {
        return true;
    }
    // Cover Mac OS X internal browsers that use the Mac OS networking stack. This includes:
    // - Internal browser on Mac OS X
    // This does not include:
    // - Safari on Mac OS X
    // - Chrome on Mac OS X
    // - Chromium on Mac OS X
    // Because they do not use the Mac OS networking stack.
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["E" /* strContains */])(userAgent, "Macintosh; Intel Mac OS X 10_14") && Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["F" /* strEndsWith */])(userAgent, "AppleWebKit/605.1.15 (KHTML, like Gecko)")) {
        return true;
    }
    // Cover Chrome 50-69, because some versions are broken by SameSite=None, and none in this range require it.
    // Note: this covers some pre-Chromium Edge versions, but pre-Chromim Edge does not require SameSite=None, so this is fine.
    // Note: this regex applies to Windows, Mac OS X, and Linux, deliberately.
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["E" /* strContains */])(userAgent, "Chrome/5") || Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["E" /* strContains */])(userAgent, "Chrome/6")) {
        return true;
    }
    // Unreal Engine runs Chromium 59, but does not advertise as Chrome until 4.23. Treat versions of Unreal
    // that don't specify their Chrome version as lacking support for SameSite=None.
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["E" /* strContains */])(userAgent, "UnrealEngine") && !Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["E" /* strContains */])(userAgent, "Chrome")) {
        return true;
    }
    // UCBrowser < 12.13.2 ignores Set-Cookie headers with SameSite=None
    // NB: this rule isn't complete - you need regex to make a complete rule.
    // See: https://www.chromium.org/updates/same-site/incompatible-clients
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["E" /* strContains */])(userAgent, "UCBrowser/12") || Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["E" /* strContains */])(userAgent, "UCBrowser/11")) {
        return true;
    }
    return false;
}
//# sourceMappingURL=CookieMgr.js.map

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _InternalLogMessage; });
/* harmony export (immutable) */ __webpack_exports__["c"] = safeGetLogger;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DiagnosticLogger; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_LoggingEnums__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EnvUtils__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__microsoft_dynamicproto_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__ = __webpack_require__(42);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







/**
 * For user non actionable traces use AI Internal prefix.
 */
var AiNonUserActionablePrefix = "AI (Internal): ";
/**
 * Prefix of the traces in portal.
 */
var AiUserActionablePrefix = "AI: ";
/**
 *  Session storage key for the prefix for the key indicating message type already logged
 */
var AIInternalMessagePrefix = "AITR_";
function _sanitizeDiagnosticText(text) {
    if (text) {
        return "\"" + text.replace(/\"/g, "") + "\"";
    }
    return "";
}
var _InternalLogMessage = /** @class */ (function () {
    function _InternalLogMessage(msgId, msg, isUserAct, properties) {
        if (isUserAct === void 0) { isUserAct = false; }
        var _self = this;
        _self.messageId = msgId;
        _self.message =
            (isUserAct ? AiUserActionablePrefix : AiNonUserActionablePrefix) +
                msgId;
        var strProps = "";
        if (Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["n" /* hasJSON */])()) {
            strProps = Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["h" /* getJSON */])().stringify(properties);
        }
        var diagnosticText = (msg ? " message:" + _sanitizeDiagnosticText(msg) : "") +
            (properties ? " props:" + _sanitizeDiagnosticText(strProps) : "");
        _self.message += diagnosticText;
    }
    _InternalLogMessage.dataType = "MessageData";
    return _InternalLogMessage;
}());

function safeGetLogger(core, config) {
    return (core || {}).logger || new DiagnosticLogger(config);
}
var DiagnosticLogger = /** @class */ (function () {
    function DiagnosticLogger(config) {
        this.identifier = 'DiagnosticLogger';
        /**
         * The internal logging queue
         */
        this.queue = [];
        /**
         * Count of internal messages sent
         */
        var _messageCount = 0;
        /**
         * Holds information about what message types were already logged to console or sent to server.
         */
        var _messageLogged = {};
        Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_dynamicproto_js__["a" /* default */])(DiagnosticLogger, this, function (_self) {
            if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["s" /* isNullOrUndefined */])(config)) {
                config = {};
            }
            _self.consoleLoggingLevel = function () { return _getConfigValue('loggingLevelConsole', 0); };
            _self.telemetryLoggingLevel = function () { return _getConfigValue('loggingLevelTelemetry', 1); };
            _self.maxInternalMessageLimit = function () { return _getConfigValue('maxMessageLimit', 25); };
            _self.enableDebugExceptions = function () { return _getConfigValue('enableDebugExceptions', false); };
            /**
             * This method will throw exceptions in debug mode or attempt to log the error as a console warning.
             * @param severity {LoggingSeverity} - The severity of the log message
             * @param message {_InternalLogMessage} - The log message.
             */
            _self.throwInternal = function (severity, msgId, msg, properties, isUserAct) {
                if (isUserAct === void 0) { isUserAct = false; }
                var message = new _InternalLogMessage(msgId, msg, isUserAct, properties);
                if (_self.enableDebugExceptions()) {
                    throw message;
                }
                else {
                    if (!Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["y" /* isUndefined */])(message) && !!message && !Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["y" /* isUndefined */])(message.message)) {
                        var logLevel = _self.consoleLoggingLevel();
                        if (isUserAct) {
                            // check if this message type was already logged to console for this page view and if so, don't log it again
                            var messageKey = +message.messageId;
                            if (!_messageLogged[messageKey] && logLevel >= __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_LoggingEnums__["a" /* LoggingSeverity */].WARNING) {
                                _self.warnToConsole(message.message);
                                _messageLogged[messageKey] = true;
                            }
                        }
                        else {
                            // don't log internal AI traces in the console, unless the verbose logging is enabled
                            if (logLevel >= __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_LoggingEnums__["a" /* LoggingSeverity */].WARNING) {
                                _self.warnToConsole(message.message);
                            }
                        }
                        _self.logInternalMessage(severity, message);
                    }
                }
            };
            /**
             * This will write a warning to the console if possible
             * @param message {string} - The warning message
             */
            _self.warnToConsole = function (message) {
                var theConsole = Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["b" /* getConsole */])();
                if (!!theConsole) {
                    var logFunc = 'log';
                    if (theConsole.warn) {
                        logFunc = 'warn';
                    }
                    if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["p" /* isFunction */])(theConsole[logFunc])) {
                        theConsole[logFunc](message);
                    }
                }
            };
            /**
             * Resets the internal message count
             */
            _self.resetInternalMessageCount = function () {
                _messageCount = 0;
                _messageLogged = {};
            };
            /**
             * Logs a message to the internal queue.
             * @param severity {LoggingSeverity} - The severity of the log message
             * @param message {_InternalLogMessage} - The message to log.
             */
            _self.logInternalMessage = function (severity, message) {
                if (_areInternalMessagesThrottled()) {
                    return;
                }
                // check if this message type was already logged for this session and if so, don't log it again
                var logMessage = true;
                var messageKey = AIInternalMessagePrefix + message.messageId;
                // if the session storage is not available, limit to only one message type per page view
                if (_messageLogged[messageKey]) {
                    logMessage = false;
                }
                else {
                    _messageLogged[messageKey] = true;
                }
                if (logMessage) {
                    // Push the event in the internal queue
                    if (severity <= _self.telemetryLoggingLevel()) {
                        _self.queue.push(message);
                        _messageCount++;
                    }
                    // When throttle limit reached, send a special event
                    if (_messageCount === _self.maxInternalMessageLimit()) {
                        var throttleLimitMessage = "Internal events throttle limit per PageView reached for this app.";
                        var throttleMessage = new _InternalLogMessage(__WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_LoggingEnums__["b" /* _InternalMessageId */].MessageLimitPerPVExceeded, throttleLimitMessage, false);
                        _self.queue.push(throttleMessage);
                        _self.warnToConsole(throttleLimitMessage);
                    }
                }
            };
            function _getConfigValue(name, defValue) {
                var value = config[name];
                if (!Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["s" /* isNullOrUndefined */])(value)) {
                    return value;
                }
                return defValue;
            }
            function _areInternalMessagesThrottled() {
                return _messageCount >= _self.maxInternalMessageLimit();
            }
        });
    }
// Removed Stub for DiagnosticLogger.prototype.enableDebugExceptions.
// Removed Stub for DiagnosticLogger.prototype.consoleLoggingLevel.
// Removed Stub for DiagnosticLogger.prototype.telemetryLoggingLevel.
// Removed Stub for DiagnosticLogger.prototype.maxInternalMessageLimit.
// Removed Stub for DiagnosticLogger.prototype.throwInternal.
// Removed Stub for DiagnosticLogger.prototype.warnToConsole.
// Removed Stub for DiagnosticLogger.prototype.resetInternalMessageCount.
// Removed Stub for DiagnosticLogger.prototype.logInternalMessage.
    return DiagnosticLogger;
}());

//# sourceMappingURL=DiagnosticLogger.js.map

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return strIKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return strExtensionConfig; });
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var strIKey = "iKey";
var strExtensionConfig = "extensionConfig";
//# sourceMappingURL=Constants.js.map

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initializePlugins;
/* harmony export (immutable) */ __webpack_exports__["b"] = sortPlugins;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HelperFuncs__ = __webpack_require__(42);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var processTelemetry = "processTelemetry";
var priority = "priority";
var setNextPlugin = "setNextPlugin";
var isInitialized = "isInitialized";
/**
 * Initialize the queue of plugins
 * @param plugins - The array of plugins to initialize and setting of the next plugin
 * @param config The current config for the instance
 * @param core THe current core instance
 * @param extensions The extensions
 */
function initializePlugins(processContext, extensions) {
    // Set the next plugin and identified the uninitialized plugins
    var initPlugins = [];
    var lastPlugin = null;
    var proxy = processContext.getNext();
    while (proxy) {
        var thePlugin = proxy.getPlugin();
        if (thePlugin) {
            if (lastPlugin &&
                Object(__WEBPACK_IMPORTED_MODULE_0__HelperFuncs__["p" /* isFunction */])(lastPlugin[setNextPlugin]) &&
                Object(__WEBPACK_IMPORTED_MODULE_0__HelperFuncs__["p" /* isFunction */])(thePlugin[processTelemetry])) {
                // Set this plugin as the next for the previous one
                lastPlugin[setNextPlugin](thePlugin);
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__HelperFuncs__["p" /* isFunction */])(thePlugin[isInitialized]) || !thePlugin[isInitialized]()) {
                initPlugins.push(thePlugin);
            }
            lastPlugin = thePlugin;
            proxy = proxy.getNext();
        }
    }
    // Now initiatilize the plugins
    Object(__WEBPACK_IMPORTED_MODULE_0__HelperFuncs__["a" /* arrForEach */])(initPlugins, function (thePlugin) {
        thePlugin.initialize(processContext.getCfg(), processContext.core(), extensions, processContext.getNext());
    });
}
function sortPlugins(plugins) {
    // Sort by priority
    return plugins.sort(function (extA, extB) {
        var result = 0;
        var bHasProcess = Object(__WEBPACK_IMPORTED_MODULE_0__HelperFuncs__["p" /* isFunction */])(extB[processTelemetry]);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__HelperFuncs__["p" /* isFunction */])(extA[processTelemetry])) {
            result = bHasProcess ? extA[priority] - extB[priority] : 1;
        }
        else if (bHasProcess) {
            result = -1;
        }
        return result;
    });
    // sort complete    
}
//# sourceMappingURL=TelemetryHelpers.js.map

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _gblCookieMgr;
/* harmony export (immutable) */ __webpack_exports__["c"] = safeGetCookieMgr;
/* harmony export (immutable) */ __webpack_exports__["b"] = createCookieMgr;
/* unused harmony export areCookiesSupported */
/* harmony export (immutable) */ __webpack_exports__["d"] = uaDisallowsSameSiteNone;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_LoggingEnums__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EnvUtils__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__ = __webpack_require__(42);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



var strToGMTString = "toGMTString";
var strToUTCString = "toUTCString";
var strCookie = "cookie";
var strExpires = "expires";
var strEnabled = "enabled";
var strIsCookieUseDisabled = "isCookieUseDisabled";
var strDisableCookiesUsage = "disableCookiesUsage";
var strConfigCookieMgr = "_ckMgr";
var strEmpty = "";
var _supportsCookies = null;
var _allowUaSameSite = null;
var _parsedCookieValue = null;
var _doc = Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["d" /* getDocument */])();
var _cookieCache = {};
var _globalCookieConfig = {};
/**
 * @ignore
 * DO NOT USE or export from the module, this is exposed as public to support backward compatibility of previous static utility methods only.
 * If you want to manager cookies either use the ICookieMgr available from the core instance via getCookieMgr() or create
 * your own instance of the CookieMgr and use that.
 * Using this directly for enabling / disabling cookie handling will not only affect your usage but EVERY user of cookies.
 * Example, if you are using a shared component that is also using Application Insights you will affect their cookie handling.
 * @param logger - The DiagnosticLogger to use for reporting errors.
 */
function _gblCookieMgr(config, logger) {
    // Stash the global instance against the BaseCookieMgr class
    var inst = createCookieMgr[strConfigCookieMgr] || _globalCookieConfig[strConfigCookieMgr];
    if (!inst) {
        // Note: not using the getSetValue() helper as that would require always creating a temporary cookieMgr
        // that ultimately is never used
        inst = createCookieMgr[strConfigCookieMgr] = createCookieMgr(config, logger);
        _globalCookieConfig[strConfigCookieMgr] = inst;
    }
    return inst;
}
function _isMgrEnabled(cookieMgr) {
    if (cookieMgr) {
        return cookieMgr.isEnabled();
    }
    return true;
}
function _createCookieMgrConfig(rootConfig) {
    var cookieMgrCfg = rootConfig.cookieCfg = rootConfig.cookieCfg || {};
    // Sets the values from the root config if not already present on the cookieMgrCfg
    Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["C" /* setValue */])(cookieMgrCfg, "domain", rootConfig.cookieDomain, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["q" /* isNotNullOrUndefined */], __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */]);
    Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["C" /* setValue */])(cookieMgrCfg, "path", rootConfig.cookiePath || "/", null, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */]);
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */])(cookieMgrCfg[strEnabled])) {
        // Set the enabled from the provided setting or the legacy root values
        var cookieEnabled = void 0;
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */])(rootConfig[strIsCookieUseDisabled])) {
            cookieEnabled = !rootConfig[strIsCookieUseDisabled];
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */])(rootConfig[strDisableCookiesUsage])) {
            cookieEnabled = !rootConfig[strDisableCookiesUsage];
        }
        cookieMgrCfg[strEnabled] = cookieEnabled;
    }
    return cookieMgrCfg;
}
/**
 * Helper to return the ICookieMgr from the core (if not null/undefined) or a default implementation
 * associated with the configuration or a legacy default.
 * @param core
 * @param config
 * @returns
 */
function safeGetCookieMgr(core, config) {
    var cookieMgr;
    if (core) {
        // Always returns an instance
        cookieMgr = core.getCookieMgr();
    }
    else if (config) {
        var cookieCfg = (config || {}).cookieCfg;
        if (cookieCfg[strConfigCookieMgr]) {
            cookieMgr = cookieCfg[strConfigCookieMgr];
        }
        else {
            cookieMgr = createCookieMgr(config);
        }
    }
    if (!cookieMgr) {
        // Get or initialize the default global (legacy) cookie manager if we couldn't find one
        cookieMgr = _gblCookieMgr(config, (core || {}).logger);
    }
    return cookieMgr;
}
function createCookieMgr(rootConfig, logger) {
    var cookieMgrConfig = _createCookieMgrConfig(rootConfig || _globalCookieConfig);
    var _path = cookieMgrConfig.path || "/";
    var _domain = cookieMgrConfig.domain;
    // Explicitly checking against false, so that setting to undefined will === true
    var _enabled = cookieMgrConfig[strEnabled] !== false;
    var cookieMgr = {
        isEnabled: function () {
            var enabled = _enabled && areCookiesSupported(logger);
            // Using an indirect lookup for any global cookie manager to support tree shaking for SDK's
            // that don't use the "applicationinsights-core" version of the default cookie function
            var gblManager = _globalCookieConfig[strConfigCookieMgr];
            if (enabled && gblManager && cookieMgr !== gblManager) {
                // Make sure the GlobalCookie Manager instance (if not this instance) is also enabled.
                // As the global (deprecated) functions may have been called (for backward compatibility)
                enabled = _isMgrEnabled(gblManager);
            }
            return enabled;
        },
        setEnabled: function (value) {
            // Explicitly checking against false, so that setting to undefined will === true
            _enabled = value !== false;
        },
        set: function (name, value, maxAgeSec, domain, path) {
            if (_isMgrEnabled(cookieMgr)) {
                var values = {};
                var theValue = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["F" /* strTrim */])(value || strEmpty);
                var idx = theValue.indexOf(";");
                if (idx !== -1) {
                    theValue = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["F" /* strTrim */])(value.substring(0, idx));
                    values = _extractParts(value.substring(idx + 1));
                }
                // Only update domain if not already present (isUndefined) and the value is truthy (not null, undefined or empty string)
                Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["C" /* setValue */])(values, "domain", domain || _domain, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["w" /* isTruthy */], __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */]);
                if (!Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */])(maxAgeSec)) {
                    var _isIE = Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["o" /* isIE */])();
                    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */])(values[strExpires])) {
                        var nowMs = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["g" /* dateNow */])();
                        // Only add expires if not already present
                        var expireMs = nowMs + (maxAgeSec * 1000);
                        // Sanity check, if zero or -ve then ignore
                        if (expireMs > 0) {
                            var expiry = new Date();
                            expiry.setTime(expireMs);
                            Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["C" /* setValue */])(values, strExpires, _formatDate(expiry, !_isIE ? strToUTCString : strToGMTString) || _formatDate(expiry, _isIE ? strToGMTString : strToUTCString) || strEmpty, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["w" /* isTruthy */]);
                        }
                    }
                    if (!_isIE) {
                        // Only replace if not already present
                        Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["C" /* setValue */])(values, "max-age", strEmpty + maxAgeSec, null, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */]);
                    }
                }
                var location_1 = Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["i" /* getLocation */])();
                if (location_1 && location_1.protocol === "https:") {
                    Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["C" /* setValue */])(values, "secure", null, null, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */]);
                    // Only set same site if not also secure
                    if (_allowUaSameSite === null) {
                        _allowUaSameSite = !uaDisallowsSameSiteNone((Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["k" /* getNavigator */])() || {}).userAgent);
                    }
                    if (_allowUaSameSite) {
                        Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["C" /* setValue */])(values, "SameSite", "None", null, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */]);
                    }
                }
                Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["C" /* setValue */])(values, "path", path || _path, null, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */]);
                var setCookieFn = cookieMgrConfig.setCookie || _setCookieValue;
                setCookieFn(name, _formatCookieValue(theValue, values));
            }
        },
        get: function (name) {
            var value = strEmpty;
            if (_isMgrEnabled(cookieMgr)) {
                value = (cookieMgrConfig.getCookie || _getCookieValue)(name);
            }
            return value;
        },
        del: function (name, path) {
            if (_isMgrEnabled(cookieMgr)) {
                // Only remove the cookie if the manager and cookie support has not been disabled
                cookieMgr.purge(name, path);
            }
        },
        purge: function (name, path) {
            if (areCookiesSupported(logger)) {
                // Setting the expiration date in the past immediately removes the cookie
                var values = (_a = {},
                    _a["path"] = path ? path : "/",
                    _a[strExpires] = "Thu, 01 Jan 1970 00:00:01 GMT",
                    _a);
                if (!Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["o" /* isIE */])()) {
                    // Set max age to expire now
                    values["max-age"] = "0";
                }
                var delCookie = cookieMgrConfig.delCookie || _setCookieValue;
                delCookie(name, _formatCookieValue(strEmpty, values));
            }
            var _a;
        }
    };
    // Associated this cookie manager with the config
    cookieMgr[strConfigCookieMgr] = cookieMgr;
    return cookieMgr;
}
/*
* Helper method to tell if document.cookie object is supported by the runtime
*/
function areCookiesSupported(logger) {
    if (_supportsCookies === null) {
        _supportsCookies = false;
        try {
            var doc = _doc || {};
            _supportsCookies = doc[strCookie] !== undefined;
        }
        catch (e) {
            logger && logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_LoggingEnums__["a" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_LoggingEnums__["b" /* _InternalMessageId */].CannotAccessCookie, "Cannot access document.cookie - " + Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["i" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["a" /* dumpObj */])(e) });
        }
    }
    return _supportsCookies;
}
function _extractParts(theValue) {
    var values = {};
    if (theValue && theValue.length) {
        var parts = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["F" /* strTrim */])(theValue).split(";");
        Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["a" /* arrForEach */])(parts, function (thePart) {
            thePart = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["F" /* strTrim */])(thePart || strEmpty);
            if (thePart) {
                var idx = thePart.indexOf("=");
                if (idx === -1) {
                    values[thePart] = null;
                }
                else {
                    values[Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["F" /* strTrim */])(thePart.substring(0, idx))] = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["F" /* strTrim */])(thePart.substring(idx + 1));
                }
            }
        });
    }
    return values;
}
function _formatDate(theDate, func) {
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["p" /* isFunction */])(theDate[func])) {
        return theDate[func]();
    }
    return null;
}
function _formatCookieValue(value, values) {
    var cookieValue = value || strEmpty;
    Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["A" /* objForEachKey */])(values, function (name, theValue) {
        cookieValue += "; " + name + (!Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */])(theValue) ? "=" + theValue : strEmpty);
    });
    return cookieValue;
}
function _getCookieValue(name) {
    var cookieValue = strEmpty;
    if (_doc) {
        var theCookie = _doc[strCookie] || strEmpty;
        if (_parsedCookieValue !== theCookie) {
            _cookieCache = _extractParts(theCookie);
            _parsedCookieValue = theCookie;
        }
        cookieValue = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["F" /* strTrim */])(_cookieCache[name] || strEmpty);
    }
    return cookieValue;
}
function _setCookieValue(name, cookieValue) {
    if (_doc) {
        _doc[strCookie] = name + "=" + cookieValue;
    }
}
function uaDisallowsSameSiteNone(userAgent) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["v" /* isString */])(userAgent)) {
        return false;
    }
    // Cover all iOS based browsers here. This includes:
    // - Safari on iOS 12 for iPhone, iPod Touch, iPad
    // - WkWebview on iOS 12 for iPhone, iPod Touch, iPad
    // - Chrome on iOS 12 for iPhone, iPod Touch, iPad
    // All of which are broken by SameSite=None, because they use the iOS networking stack
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* strContains */])(userAgent, "CPU iPhone OS 12") || Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* strContains */])(userAgent, "iPad; CPU OS 12")) {
        return true;
    }
    // Cover Mac OS X based browsers that use the Mac OS networking stack. This includes:
    // - Safari on Mac OS X
    // This does not include:
    // - Internal browser on Mac OS X
    // - Chrome on Mac OS X
    // - Chromium on Mac OS X
    // Because they do not use the Mac OS networking stack.
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* strContains */])(userAgent, "Macintosh; Intel Mac OS X 10_14") && Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* strContains */])(userAgent, "Version/") && Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* strContains */])(userAgent, "Safari")) {
        return true;
    }
    // Cover Mac OS X internal browsers that use the Mac OS networking stack. This includes:
    // - Internal browser on Mac OS X
    // This does not include:
    // - Safari on Mac OS X
    // - Chrome on Mac OS X
    // - Chromium on Mac OS X
    // Because they do not use the Mac OS networking stack.
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* strContains */])(userAgent, "Macintosh; Intel Mac OS X 10_14") && Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["E" /* strEndsWith */])(userAgent, "AppleWebKit/605.1.15 (KHTML, like Gecko)")) {
        return true;
    }
    // Cover Chrome 50-69, because some versions are broken by SameSite=None, and none in this range require it.
    // Note: this covers some pre-Chromium Edge versions, but pre-Chromim Edge does not require SameSite=None, so this is fine.
    // Note: this regex applies to Windows, Mac OS X, and Linux, deliberately.
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* strContains */])(userAgent, "Chrome/5") || Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* strContains */])(userAgent, "Chrome/6")) {
        return true;
    }
    // Unreal Engine runs Chromium 59, but does not advertise as Chrome until 4.23. Treat versions of Unreal
    // that don't specify their Chrome version as lacking support for SameSite=None.
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* strContains */])(userAgent, "UnrealEngine") && !Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* strContains */])(userAgent, "Chrome")) {
        return true;
    }
    // UCBrowser < 12.13.2 ignores Set-Cookie headers with SameSite=None
    // NB: this rule isn't complete - you need regex to make a complete rule.
    // See: https://www.chromium.org/updates/same-site/incompatible-clients
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* strContains */])(userAgent, "UCBrowser/12") || Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* strContains */])(userAgent, "UCBrowser/11")) {
        return true;
    }
    return false;
}
//# sourceMappingURL=CookieMgr.js.map

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageViewData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventData__ = __webpack_require__(559);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



// THIS FILE WAS AUTOGENERATED

/**
 * An instance of PageView represents a generic action on a page like a button click. It is also the base type for PageView.
 */
var PageViewData = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(PageViewData, _super);
    function PageViewData() {
        var _this = _super.call(this) || this;
        /**
         * Schema version
         */
        _this.ver = 2;
        /**
         * Collection of custom properties.
         */
        _this.properties = {};
        /**
         * Collection of custom measurements.
         */
        _this.measurements = {};
        return _this;
    }
    return PageViewData;
}(__WEBPACK_IMPORTED_MODULE_1__EventData__["a" /* EventData */]));

//# sourceMappingURL=PageViewData.js.map

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _InternalLogMessage; });
/* harmony export (immutable) */ __webpack_exports__["c"] = safeGetLogger;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DiagnosticLogger; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_LoggingEnums__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EnvUtils__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__microsoft_dynamicproto_js__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__ = __webpack_require__(43);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







/**
 * For user non actionable traces use AI Internal prefix.
 */
var AiNonUserActionablePrefix = "AI (Internal): ";
/**
 * Prefix of the traces in portal.
 */
var AiUserActionablePrefix = "AI: ";
/**
 *  Session storage key for the prefix for the key indicating message type already logged
 */
var AIInternalMessagePrefix = "AITR_";
function _sanitizeDiagnosticText(text) {
    if (text) {
        return "\"" + text.replace(/\"/g, "") + "\"";
    }
    return "";
}
var _InternalLogMessage = /** @class */ (function () {
    function _InternalLogMessage(msgId, msg, isUserAct, properties) {
        if (isUserAct === void 0) { isUserAct = false; }
        var _self = this;
        _self.messageId = msgId;
        _self.message =
            (isUserAct ? AiUserActionablePrefix : AiNonUserActionablePrefix) +
                msgId;
        var strProps = "";
        if (Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["m" /* hasJSON */])()) {
            strProps = Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["g" /* getJSON */])().stringify(properties);
        }
        var diagnosticText = (msg ? " message:" + _sanitizeDiagnosticText(msg) : "") +
            (properties ? " props:" + _sanitizeDiagnosticText(strProps) : "");
        _self.message += diagnosticText;
    }
    _InternalLogMessage.dataType = "MessageData";
    return _InternalLogMessage;
}());

function safeGetLogger(core, config) {
    return (core || {}).logger || new DiagnosticLogger(config);
}
var DiagnosticLogger = /** @class */ (function () {
    function DiagnosticLogger(config) {
        this.identifier = 'DiagnosticLogger';
        /**
         * The internal logging queue
         */
        this.queue = [];
        /**
         * Count of internal messages sent
         */
        var _messageCount = 0;
        /**
         * Holds information about what message types were already logged to console or sent to server.
         */
        var _messageLogged = {};
        Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_dynamicproto_js__["a" /* default */])(DiagnosticLogger, this, function (_self) {
            if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["s" /* isNullOrUndefined */])(config)) {
                config = {};
            }
            _self.consoleLoggingLevel = function () { return _getConfigValue('loggingLevelConsole', 0); };
            _self.telemetryLoggingLevel = function () { return _getConfigValue('loggingLevelTelemetry', 1); };
            _self.maxInternalMessageLimit = function () { return _getConfigValue('maxMessageLimit', 25); };
            _self.enableDebugExceptions = function () { return _getConfigValue('enableDebugExceptions', false); };
            /**
             * This method will throw exceptions in debug mode or attempt to log the error as a console warning.
             * @param severity {LoggingSeverity} - The severity of the log message
             * @param message {_InternalLogMessage} - The log message.
             */
            _self.throwInternal = function (severity, msgId, msg, properties, isUserAct) {
                if (isUserAct === void 0) { isUserAct = false; }
                var message = new _InternalLogMessage(msgId, msg, isUserAct, properties);
                if (_self.enableDebugExceptions()) {
                    throw message;
                }
                else {
                    if (!Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["y" /* isUndefined */])(message) && !!message && !Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["y" /* isUndefined */])(message.message)) {
                        var logLevel = _self.consoleLoggingLevel();
                        if (isUserAct) {
                            // check if this message type was already logged to console for this page view and if so, don't log it again
                            var messageKey = +message.messageId;
                            if (!_messageLogged[messageKey] && logLevel >= __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_LoggingEnums__["a" /* LoggingSeverity */].WARNING) {
                                _self.warnToConsole(message.message);
                                _messageLogged[messageKey] = true;
                            }
                        }
                        else {
                            // don't log internal AI traces in the console, unless the verbose logging is enabled
                            if (logLevel >= __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_LoggingEnums__["a" /* LoggingSeverity */].WARNING) {
                                _self.warnToConsole(message.message);
                            }
                        }
                        _self.logInternalMessage(severity, message);
                    }
                }
            };
            /**
             * This will write a warning to the console if possible
             * @param message {string} - The warning message
             */
            _self.warnToConsole = function (message) {
                var theConsole = Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["b" /* getConsole */])();
                if (!!theConsole) {
                    var logFunc = 'log';
                    if (theConsole.warn) {
                        logFunc = 'warn';
                    }
                    if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["p" /* isFunction */])(theConsole[logFunc])) {
                        theConsole[logFunc](message);
                    }
                }
            };
            /**
             * Resets the internal message count
             */
            _self.resetInternalMessageCount = function () {
                _messageCount = 0;
                _messageLogged = {};
            };
            /**
             * Logs a message to the internal queue.
             * @param severity {LoggingSeverity} - The severity of the log message
             * @param message {_InternalLogMessage} - The message to log.
             */
            _self.logInternalMessage = function (severity, message) {
                if (_areInternalMessagesThrottled()) {
                    return;
                }
                // check if this message type was already logged for this session and if so, don't log it again
                var logMessage = true;
                var messageKey = AIInternalMessagePrefix + message.messageId;
                // if the session storage is not available, limit to only one message type per page view
                if (_messageLogged[messageKey]) {
                    logMessage = false;
                }
                else {
                    _messageLogged[messageKey] = true;
                }
                if (logMessage) {
                    // Push the event in the internal queue
                    if (severity <= _self.telemetryLoggingLevel()) {
                        _self.queue.push(message);
                        _messageCount++;
                    }
                    // When throttle limit reached, send a special event
                    if (_messageCount === _self.maxInternalMessageLimit()) {
                        var throttleLimitMessage = "Internal events throttle limit per PageView reached for this app.";
                        var throttleMessage = new _InternalLogMessage(__WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_LoggingEnums__["b" /* _InternalMessageId */].MessageLimitPerPVExceeded, throttleLimitMessage, false);
                        _self.queue.push(throttleMessage);
                        _self.warnToConsole(throttleLimitMessage);
                    }
                }
            };
            function _getConfigValue(name, defValue) {
                var value = config[name];
                if (!Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["s" /* isNullOrUndefined */])(value)) {
                    return value;
                }
                return defValue;
            }
            function _areInternalMessagesThrottled() {
                return _messageCount >= _self.maxInternalMessageLimit();
            }
        });
    }
// Removed Stub for DiagnosticLogger.prototype.enableDebugExceptions.
// Removed Stub for DiagnosticLogger.prototype.consoleLoggingLevel.
// Removed Stub for DiagnosticLogger.prototype.telemetryLoggingLevel.
// Removed Stub for DiagnosticLogger.prototype.maxInternalMessageLimit.
// Removed Stub for DiagnosticLogger.prototype.throwInternal.
// Removed Stub for DiagnosticLogger.prototype.warnToConsole.
// Removed Stub for DiagnosticLogger.prototype.resetInternalMessageCount.
// Removed Stub for DiagnosticLogger.prototype.logInternalMessage.
    return DiagnosticLogger;
}());

//# sourceMappingURL=DiagnosticLogger.js.map

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return strIKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return strExtensionConfig; });
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var strIKey = "iKey";
var strExtensionConfig = "extensionConfig";
//# sourceMappingURL=Constants.js.map

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initializePlugins;
/* harmony export (immutable) */ __webpack_exports__["b"] = sortPlugins;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HelperFuncs__ = __webpack_require__(43);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var processTelemetry = "processTelemetry";
var priority = "priority";
var setNextPlugin = "setNextPlugin";
var isInitialized = "isInitialized";
/**
 * Initialize the queue of plugins
 * @param plugins - The array of plugins to initialize and setting of the next plugin
 * @param config The current config for the instance
 * @param core THe current core instance
 * @param extensions The extensions
 */
function initializePlugins(processContext, extensions) {
    // Set the next plugin and identified the uninitialized plugins
    var initPlugins = [];
    var lastPlugin = null;
    var proxy = processContext.getNext();
    while (proxy) {
        var thePlugin = proxy.getPlugin();
        if (thePlugin) {
            if (lastPlugin &&
                Object(__WEBPACK_IMPORTED_MODULE_0__HelperFuncs__["p" /* isFunction */])(lastPlugin[setNextPlugin]) &&
                Object(__WEBPACK_IMPORTED_MODULE_0__HelperFuncs__["p" /* isFunction */])(thePlugin[processTelemetry])) {
                // Set this plugin as the next for the previous one
                lastPlugin[setNextPlugin](thePlugin);
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__HelperFuncs__["p" /* isFunction */])(thePlugin[isInitialized]) || !thePlugin[isInitialized]()) {
                initPlugins.push(thePlugin);
            }
            lastPlugin = thePlugin;
            proxy = proxy.getNext();
        }
    }
    // Now initiatilize the plugins
    Object(__WEBPACK_IMPORTED_MODULE_0__HelperFuncs__["a" /* arrForEach */])(initPlugins, function (thePlugin) {
        thePlugin.initialize(processContext.getCfg(), processContext.core(), extensions, processContext.getNext());
    });
}
function sortPlugins(plugins) {
    // Sort by priority
    return plugins.sort(function (extA, extB) {
        var result = 0;
        var bHasProcess = Object(__WEBPACK_IMPORTED_MODULE_0__HelperFuncs__["p" /* isFunction */])(extB[processTelemetry]);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__HelperFuncs__["p" /* isFunction */])(extA[processTelemetry])) {
            result = bHasProcess ? extA[priority] - extB[priority] : 1;
        }
        else if (bHasProcess) {
            result = -1;
        }
        return result;
    });
    // sort complete    
}
//# sourceMappingURL=TelemetryHelpers.js.map

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _gblCookieMgr;
/* unused harmony export safeGetCookieMgr */
/* harmony export (immutable) */ __webpack_exports__["b"] = createCookieMgr;
/* unused harmony export areCookiesSupported */
/* harmony export (immutable) */ __webpack_exports__["c"] = uaDisallowsSameSiteNone;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_LoggingEnums__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EnvUtils__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__ = __webpack_require__(43);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



var strToGMTString = "toGMTString";
var strToUTCString = "toUTCString";
var strCookie = "cookie";
var strExpires = "expires";
var strEnabled = "enabled";
var strIsCookieUseDisabled = "isCookieUseDisabled";
var strDisableCookiesUsage = "disableCookiesUsage";
var strConfigCookieMgr = "_ckMgr";
var strEmpty = "";
var _supportsCookies = null;
var _allowUaSameSite = null;
var _parsedCookieValue = null;
var _doc = Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["d" /* getDocument */])();
var _cookieCache = {};
var _globalCookieConfig = {};
/**
 * @ignore
 * DO NOT USE or export from the module, this is exposed as public to support backward compatibility of previous static utility methods only.
 * If you want to manager cookies either use the ICookieMgr available from the core instance via getCookieMgr() or create
 * your own instance of the CookieMgr and use that.
 * Using this directly for enabling / disabling cookie handling will not only affect your usage but EVERY user of cookies.
 * Example, if you are using a shared component that is also using Application Insights you will affect their cookie handling.
 * @param logger - The DiagnosticLogger to use for reporting errors.
 */
function _gblCookieMgr(config, logger) {
    // Stash the global instance against the BaseCookieMgr class
    var inst = createCookieMgr[strConfigCookieMgr] || _globalCookieConfig[strConfigCookieMgr];
    if (!inst) {
        // Note: not using the getSetValue() helper as that would require always creating a temporary cookieMgr
        // that ultimately is never used
        inst = createCookieMgr[strConfigCookieMgr] = createCookieMgr(config, logger);
        _globalCookieConfig[strConfigCookieMgr] = inst;
    }
    return inst;
}
function _isMgrEnabled(cookieMgr) {
    if (cookieMgr) {
        return cookieMgr.isEnabled();
    }
    return true;
}
function _createCookieMgrConfig(rootConfig) {
    var cookieMgrCfg = rootConfig.cookieCfg = rootConfig.cookieCfg || {};
    // Sets the values from the root config if not already present on the cookieMgrCfg
    Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* setValue */])(cookieMgrCfg, "domain", rootConfig.cookieDomain, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["q" /* isNotNullOrUndefined */], __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */]);
    Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* setValue */])(cookieMgrCfg, "path", rootConfig.cookiePath || "/", null, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */]);
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */])(cookieMgrCfg[strEnabled])) {
        // Set the enabled from the provided setting or the legacy root values
        var cookieEnabled = void 0;
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */])(rootConfig[strIsCookieUseDisabled])) {
            cookieEnabled = !rootConfig[strIsCookieUseDisabled];
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */])(rootConfig[strDisableCookiesUsage])) {
            cookieEnabled = !rootConfig[strDisableCookiesUsage];
        }
        cookieMgrCfg[strEnabled] = cookieEnabled;
    }
    return cookieMgrCfg;
}
/**
 * Helper to return the ICookieMgr from the core (if not null/undefined) or a default implementation
 * associated with the configuration or a legacy default.
 * @param core
 * @param config
 * @returns
 */
function safeGetCookieMgr(core, config) {
    var cookieMgr;
    if (core) {
        // Always returns an instance
        cookieMgr = core.getCookieMgr();
    }
    else if (config) {
        var cookieCfg = (config || {}).cookieCfg;
        if (cookieCfg[strConfigCookieMgr]) {
            cookieMgr = cookieCfg[strConfigCookieMgr];
        }
        else {
            cookieMgr = createCookieMgr(config);
        }
    }
    if (!cookieMgr) {
        // Get or initialize the default global (legacy) cookie manager if we couldn't find one
        cookieMgr = _gblCookieMgr(config, (core || {}).logger);
    }
    return cookieMgr;
}
function createCookieMgr(rootConfig, logger) {
    var cookieMgrConfig = _createCookieMgrConfig(rootConfig || _globalCookieConfig);
    var _path = cookieMgrConfig.path || "/";
    var _domain = cookieMgrConfig.domain;
    // Explicitly checking against false, so that setting to undefined will === true
    var _enabled = cookieMgrConfig[strEnabled] !== false;
    var cookieMgr = {
        isEnabled: function () {
            var enabled = _enabled && areCookiesSupported(logger);
            // Using an indirect lookup for any global cookie manager to support tree shaking for SDK's
            // that don't use the "applicationinsights-core" version of the default cookie function
            var gblManager = _globalCookieConfig[strConfigCookieMgr];
            if (enabled && gblManager && cookieMgr !== gblManager) {
                // Make sure the GlobalCookie Manager instance (if not this instance) is also enabled.
                // As the global (deprecated) functions may have been called (for backward compatibility)
                enabled = _isMgrEnabled(gblManager);
            }
            return enabled;
        },
        setEnabled: function (value) {
            // Explicitly checking against false, so that setting to undefined will === true
            _enabled = value !== false;
        },
        set: function (name, value, maxAgeSec, domain, path) {
            if (_isMgrEnabled(cookieMgr)) {
                var values = {};
                var theValue = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["G" /* strTrim */])(value || strEmpty);
                var idx = theValue.indexOf(";");
                if (idx !== -1) {
                    theValue = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["G" /* strTrim */])(value.substring(0, idx));
                    values = _extractParts(value.substring(idx + 1));
                }
                // Only update domain if not already present (isUndefined) and the value is truthy (not null, undefined or empty string)
                Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* setValue */])(values, "domain", domain || _domain, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["w" /* isTruthy */], __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */]);
                if (!Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */])(maxAgeSec)) {
                    var _isIE = Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["n" /* isIE */])();
                    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */])(values[strExpires])) {
                        var nowMs = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["g" /* dateNow */])();
                        // Only add expires if not already present
                        var expireMs = nowMs + (maxAgeSec * 1000);
                        // Sanity check, if zero or -ve then ignore
                        if (expireMs > 0) {
                            var expiry = new Date();
                            expiry.setTime(expireMs);
                            Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* setValue */])(values, strExpires, _formatDate(expiry, !_isIE ? strToUTCString : strToGMTString) || _formatDate(expiry, _isIE ? strToGMTString : strToUTCString) || strEmpty, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["w" /* isTruthy */]);
                        }
                    }
                    if (!_isIE) {
                        // Only replace if not already present
                        Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* setValue */])(values, "max-age", strEmpty + maxAgeSec, null, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */]);
                    }
                }
                var location_1 = Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["h" /* getLocation */])();
                if (location_1 && location_1.protocol === "https:") {
                    Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* setValue */])(values, "secure", null, null, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */]);
                    // Only set same site if not also secure
                    if (_allowUaSameSite === null) {
                        _allowUaSameSite = !uaDisallowsSameSiteNone((Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["j" /* getNavigator */])() || {}).userAgent);
                    }
                    if (_allowUaSameSite) {
                        Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* setValue */])(values, "SameSite", "None", null, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */]);
                    }
                }
                Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* setValue */])(values, "path", path || _path, null, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */]);
                var setCookieFn = cookieMgrConfig.setCookie || _setCookieValue;
                setCookieFn(name, _formatCookieValue(theValue, values));
            }
        },
        get: function (name) {
            var value = strEmpty;
            if (_isMgrEnabled(cookieMgr)) {
                value = (cookieMgrConfig.getCookie || _getCookieValue)(name);
            }
            return value;
        },
        del: function (name, path) {
            if (_isMgrEnabled(cookieMgr)) {
                // Only remove the cookie if the manager and cookie support has not been disabled
                cookieMgr.purge(name, path);
            }
        },
        purge: function (name, path) {
            if (areCookiesSupported(logger)) {
                // Setting the expiration date in the past immediately removes the cookie
                var values = (_a = {},
                    _a["path"] = path ? path : "/",
                    _a[strExpires] = "Thu, 01 Jan 1970 00:00:01 GMT",
                    _a);
                if (!Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["n" /* isIE */])()) {
                    // Set max age to expire now
                    values["max-age"] = "0";
                }
                var delCookie = cookieMgrConfig.delCookie || _setCookieValue;
                delCookie(name, _formatCookieValue(strEmpty, values));
            }
            var _a;
        }
    };
    // Associated this cookie manager with the config
    cookieMgr[strConfigCookieMgr] = cookieMgr;
    return cookieMgr;
}
/*
* Helper method to tell if document.cookie object is supported by the runtime
*/
function areCookiesSupported(logger) {
    if (_supportsCookies === null) {
        _supportsCookies = false;
        try {
            var doc = _doc || {};
            _supportsCookies = doc[strCookie] !== undefined;
        }
        catch (e) {
            logger && logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_LoggingEnums__["a" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_LoggingEnums__["b" /* _InternalMessageId */].CannotAccessCookie, "Cannot access document.cookie - " + Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["i" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["a" /* dumpObj */])(e) });
        }
    }
    return _supportsCookies;
}
function _extractParts(theValue) {
    var values = {};
    if (theValue && theValue.length) {
        var parts = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["G" /* strTrim */])(theValue).split(";");
        Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["a" /* arrForEach */])(parts, function (thePart) {
            thePart = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["G" /* strTrim */])(thePart || strEmpty);
            if (thePart) {
                var idx = thePart.indexOf("=");
                if (idx === -1) {
                    values[thePart] = null;
                }
                else {
                    values[Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["G" /* strTrim */])(thePart.substring(0, idx))] = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["G" /* strTrim */])(thePart.substring(idx + 1));
                }
            }
        });
    }
    return values;
}
function _formatDate(theDate, func) {
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["p" /* isFunction */])(theDate[func])) {
        return theDate[func]();
    }
    return null;
}
function _formatCookieValue(value, values) {
    var cookieValue = value || strEmpty;
    Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["A" /* objForEachKey */])(values, function (name, theValue) {
        cookieValue += "; " + name + (!Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */])(theValue) ? "=" + theValue : strEmpty);
    });
    return cookieValue;
}
function _getCookieValue(name) {
    var cookieValue = strEmpty;
    if (_doc) {
        var theCookie = _doc[strCookie] || strEmpty;
        if (_parsedCookieValue !== theCookie) {
            _cookieCache = _extractParts(theCookie);
            _parsedCookieValue = theCookie;
        }
        cookieValue = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["G" /* strTrim */])(_cookieCache[name] || strEmpty);
    }
    return cookieValue;
}
function _setCookieValue(name, cookieValue) {
    if (_doc) {
        _doc[strCookie] = name + "=" + cookieValue;
    }
}
function uaDisallowsSameSiteNone(userAgent) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["v" /* isString */])(userAgent)) {
        return false;
    }
    // Cover all iOS based browsers here. This includes:
    // - Safari on iOS 12 for iPhone, iPod Touch, iPad
    // - WkWebview on iOS 12 for iPhone, iPod Touch, iPad
    // - Chrome on iOS 12 for iPhone, iPod Touch, iPad
    // All of which are broken by SameSite=None, because they use the iOS networking stack
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["E" /* strContains */])(userAgent, "CPU iPhone OS 12") || Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["E" /* strContains */])(userAgent, "iPad; CPU OS 12")) {
        return true;
    }
    // Cover Mac OS X based browsers that use the Mac OS networking stack. This includes:
    // - Safari on Mac OS X
    // This does not include:
    // - Internal browser on Mac OS X
    // - Chrome on Mac OS X
    // - Chromium on Mac OS X
    // Because they do not use the Mac OS networking stack.
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["E" /* strContains */])(userAgent, "Macintosh; Intel Mac OS X 10_14") && Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["E" /* strContains */])(userAgent, "Version/") && Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["E" /* strContains */])(userAgent, "Safari")) {
        return true;
    }
    // Cover Mac OS X internal browsers that use the Mac OS networking stack. This includes:
    // - Internal browser on Mac OS X
    // This does not include:
    // - Safari on Mac OS X
    // - Chrome on Mac OS X
    // - Chromium on Mac OS X
    // Because they do not use the Mac OS networking stack.
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["E" /* strContains */])(userAgent, "Macintosh; Intel Mac OS X 10_14") && Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["F" /* strEndsWith */])(userAgent, "AppleWebKit/605.1.15 (KHTML, like Gecko)")) {
        return true;
    }
    // Cover Chrome 50-69, because some versions are broken by SameSite=None, and none in this range require it.
    // Note: this covers some pre-Chromium Edge versions, but pre-Chromim Edge does not require SameSite=None, so this is fine.
    // Note: this regex applies to Windows, Mac OS X, and Linux, deliberately.
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["E" /* strContains */])(userAgent, "Chrome/5") || Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["E" /* strContains */])(userAgent, "Chrome/6")) {
        return true;
    }
    // Unreal Engine runs Chromium 59, but does not advertise as Chrome until 4.23. Treat versions of Unreal
    // that don't specify their Chrome version as lacking support for SameSite=None.
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["E" /* strContains */])(userAgent, "UnrealEngine") && !Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["E" /* strContains */])(userAgent, "Chrome")) {
        return true;
    }
    // UCBrowser < 12.13.2 ignores Set-Cookie headers with SameSite=None
    // NB: this rule isn't complete - you need regex to make a complete rule.
    // See: https://www.chromium.org/updates/same-site/incompatible-clients
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["E" /* strContains */])(userAgent, "UCBrowser/12") || Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["E" /* strContains */])(userAgent, "UCBrowser/11")) {
        return true;
    }
    return false;
}
//# sourceMappingURL=CookieMgr.js.map

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageViewData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventData__ = __webpack_require__(575);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



// THIS FILE WAS AUTOGENERATED

/**
 * An instance of PageView represents a generic action on a page like a button click. It is also the base type for PageView.
 */
var PageViewData = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(PageViewData, _super);
    function PageViewData() {
        var _this = _super.call(this) || this;
        /**
         * Schema version
         */
        _this.ver = 2;
        /**
         * Collection of custom properties.
         */
        _this.properties = {};
        /**
         * Collection of custom measurements.
         */
        _this.measurements = {};
        return _this;
    }
    return PageViewData;
}(__WEBPACK_IMPORTED_MODULE_1__EventData__["a" /* EventData */]));

//# sourceMappingURL=PageViewData.js.map

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _InternalLogMessage; });
/* harmony export (immutable) */ __webpack_exports__["c"] = safeGetLogger;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DiagnosticLogger; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_LoggingEnums__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EnvUtils__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__microsoft_dynamicproto_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__ = __webpack_require__(44);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







/**
 * For user non actionable traces use AI Internal prefix.
 */
var AiNonUserActionablePrefix = "AI (Internal): ";
/**
 * Prefix of the traces in portal.
 */
var AiUserActionablePrefix = "AI: ";
/**
 *  Session storage key for the prefix for the key indicating message type already logged
 */
var AIInternalMessagePrefix = "AITR_";
function _sanitizeDiagnosticText(text) {
    if (text) {
        return "\"" + text.replace(/\"/g, "") + "\"";
    }
    return "";
}
var _InternalLogMessage = /** @class */ (function () {
    function _InternalLogMessage(msgId, msg, isUserAct, properties) {
        if (isUserAct === void 0) { isUserAct = false; }
        var _self = this;
        _self.messageId = msgId;
        _self.message =
            (isUserAct ? AiUserActionablePrefix : AiNonUserActionablePrefix) +
                msgId;
        var strProps = "";
        if (Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["m" /* hasJSON */])()) {
            strProps = Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["g" /* getJSON */])().stringify(properties);
        }
        var diagnosticText = (msg ? " message:" + _sanitizeDiagnosticText(msg) : "") +
            (properties ? " props:" + _sanitizeDiagnosticText(strProps) : "");
        _self.message += diagnosticText;
    }
    _InternalLogMessage.dataType = "MessageData";
    return _InternalLogMessage;
}());

function safeGetLogger(core, config) {
    return (core || {}).logger || new DiagnosticLogger(config);
}
var DiagnosticLogger = /** @class */ (function () {
    function DiagnosticLogger(config) {
        this.identifier = 'DiagnosticLogger';
        /**
         * The internal logging queue
         */
        this.queue = [];
        /**
         * Count of internal messages sent
         */
        var _messageCount = 0;
        /**
         * Holds information about what message types were already logged to console or sent to server.
         */
        var _messageLogged = {};
        Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_dynamicproto_js__["a" /* default */])(DiagnosticLogger, this, function (_self) {
            if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["s" /* isNullOrUndefined */])(config)) {
                config = {};
            }
            _self.consoleLoggingLevel = function () { return _getConfigValue('loggingLevelConsole', 0); };
            _self.telemetryLoggingLevel = function () { return _getConfigValue('loggingLevelTelemetry', 1); };
            _self.maxInternalMessageLimit = function () { return _getConfigValue('maxMessageLimit', 25); };
            _self.enableDebugExceptions = function () { return _getConfigValue('enableDebugExceptions', false); };
            /**
             * This method will throw exceptions in debug mode or attempt to log the error as a console warning.
             * @param severity {LoggingSeverity} - The severity of the log message
             * @param message {_InternalLogMessage} - The log message.
             */
            _self.throwInternal = function (severity, msgId, msg, properties, isUserAct) {
                if (isUserAct === void 0) { isUserAct = false; }
                var message = new _InternalLogMessage(msgId, msg, isUserAct, properties);
                if (_self.enableDebugExceptions()) {
                    throw message;
                }
                else {
                    if (!Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["y" /* isUndefined */])(message) && !!message && !Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["y" /* isUndefined */])(message.message)) {
                        var logLevel = _self.consoleLoggingLevel();
                        if (isUserAct) {
                            // check if this message type was already logged to console for this page view and if so, don't log it again
                            var messageKey = +message.messageId;
                            if (!_messageLogged[messageKey] && logLevel >= __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_LoggingEnums__["a" /* LoggingSeverity */].WARNING) {
                                _self.warnToConsole(message.message);
                                _messageLogged[messageKey] = true;
                            }
                        }
                        else {
                            // don't log internal AI traces in the console, unless the verbose logging is enabled
                            if (logLevel >= __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_LoggingEnums__["a" /* LoggingSeverity */].WARNING) {
                                _self.warnToConsole(message.message);
                            }
                        }
                        _self.logInternalMessage(severity, message);
                    }
                }
            };
            /**
             * This will write a warning to the console if possible
             * @param message {string} - The warning message
             */
            _self.warnToConsole = function (message) {
                var theConsole = Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["b" /* getConsole */])();
                if (!!theConsole) {
                    var logFunc = 'log';
                    if (theConsole.warn) {
                        logFunc = 'warn';
                    }
                    if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["p" /* isFunction */])(theConsole[logFunc])) {
                        theConsole[logFunc](message);
                    }
                }
            };
            /**
             * Resets the internal message count
             */
            _self.resetInternalMessageCount = function () {
                _messageCount = 0;
                _messageLogged = {};
            };
            /**
             * Logs a message to the internal queue.
             * @param severity {LoggingSeverity} - The severity of the log message
             * @param message {_InternalLogMessage} - The message to log.
             */
            _self.logInternalMessage = function (severity, message) {
                if (_areInternalMessagesThrottled()) {
                    return;
                }
                // check if this message type was already logged for this session and if so, don't log it again
                var logMessage = true;
                var messageKey = AIInternalMessagePrefix + message.messageId;
                // if the session storage is not available, limit to only one message type per page view
                if (_messageLogged[messageKey]) {
                    logMessage = false;
                }
                else {
                    _messageLogged[messageKey] = true;
                }
                if (logMessage) {
                    // Push the event in the internal queue
                    if (severity <= _self.telemetryLoggingLevel()) {
                        _self.queue.push(message);
                        _messageCount++;
                    }
                    // When throttle limit reached, send a special event
                    if (_messageCount === _self.maxInternalMessageLimit()) {
                        var throttleLimitMessage = "Internal events throttle limit per PageView reached for this app.";
                        var throttleMessage = new _InternalLogMessage(__WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_LoggingEnums__["b" /* _InternalMessageId */].MessageLimitPerPVExceeded, throttleLimitMessage, false);
                        _self.queue.push(throttleMessage);
                        _self.warnToConsole(throttleLimitMessage);
                    }
                }
            };
            function _getConfigValue(name, defValue) {
                var value = config[name];
                if (!Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["s" /* isNullOrUndefined */])(value)) {
                    return value;
                }
                return defValue;
            }
            function _areInternalMessagesThrottled() {
                return _messageCount >= _self.maxInternalMessageLimit();
            }
        });
    }
// Removed Stub for DiagnosticLogger.prototype.enableDebugExceptions.
// Removed Stub for DiagnosticLogger.prototype.consoleLoggingLevel.
// Removed Stub for DiagnosticLogger.prototype.telemetryLoggingLevel.
// Removed Stub for DiagnosticLogger.prototype.maxInternalMessageLimit.
// Removed Stub for DiagnosticLogger.prototype.throwInternal.
// Removed Stub for DiagnosticLogger.prototype.warnToConsole.
// Removed Stub for DiagnosticLogger.prototype.resetInternalMessageCount.
// Removed Stub for DiagnosticLogger.prototype.logInternalMessage.
    return DiagnosticLogger;
}());

//# sourceMappingURL=DiagnosticLogger.js.map

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return strIKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return strExtensionConfig; });
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var strIKey = "iKey";
var strExtensionConfig = "extensionConfig";
//# sourceMappingURL=Constants.js.map

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initializePlugins;
/* harmony export (immutable) */ __webpack_exports__["b"] = sortPlugins;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HelperFuncs__ = __webpack_require__(44);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var processTelemetry = "processTelemetry";
var priority = "priority";
var setNextPlugin = "setNextPlugin";
var isInitialized = "isInitialized";
/**
 * Initialize the queue of plugins
 * @param plugins - The array of plugins to initialize and setting of the next plugin
 * @param config The current config for the instance
 * @param core THe current core instance
 * @param extensions The extensions
 */
function initializePlugins(processContext, extensions) {
    // Set the next plugin and identified the uninitialized plugins
    var initPlugins = [];
    var lastPlugin = null;
    var proxy = processContext.getNext();
    while (proxy) {
        var thePlugin = proxy.getPlugin();
        if (thePlugin) {
            if (lastPlugin &&
                Object(__WEBPACK_IMPORTED_MODULE_0__HelperFuncs__["p" /* isFunction */])(lastPlugin[setNextPlugin]) &&
                Object(__WEBPACK_IMPORTED_MODULE_0__HelperFuncs__["p" /* isFunction */])(thePlugin[processTelemetry])) {
                // Set this plugin as the next for the previous one
                lastPlugin[setNextPlugin](thePlugin);
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__HelperFuncs__["p" /* isFunction */])(thePlugin[isInitialized]) || !thePlugin[isInitialized]()) {
                initPlugins.push(thePlugin);
            }
            lastPlugin = thePlugin;
            proxy = proxy.getNext();
        }
    }
    // Now initiatilize the plugins
    Object(__WEBPACK_IMPORTED_MODULE_0__HelperFuncs__["a" /* arrForEach */])(initPlugins, function (thePlugin) {
        thePlugin.initialize(processContext.getCfg(), processContext.core(), extensions, processContext.getNext());
    });
}
function sortPlugins(plugins) {
    // Sort by priority
    return plugins.sort(function (extA, extB) {
        var result = 0;
        var bHasProcess = Object(__WEBPACK_IMPORTED_MODULE_0__HelperFuncs__["p" /* isFunction */])(extB[processTelemetry]);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__HelperFuncs__["p" /* isFunction */])(extA[processTelemetry])) {
            result = bHasProcess ? extA[priority] - extB[priority] : 1;
        }
        else if (bHasProcess) {
            result = -1;
        }
        return result;
    });
    // sort complete    
}
//# sourceMappingURL=TelemetryHelpers.js.map

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _gblCookieMgr;
/* harmony export (immutable) */ __webpack_exports__["c"] = safeGetCookieMgr;
/* harmony export (immutable) */ __webpack_exports__["b"] = createCookieMgr;
/* unused harmony export areCookiesSupported */
/* harmony export (immutable) */ __webpack_exports__["d"] = uaDisallowsSameSiteNone;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_LoggingEnums__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EnvUtils__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__ = __webpack_require__(44);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



var strToGMTString = "toGMTString";
var strToUTCString = "toUTCString";
var strCookie = "cookie";
var strExpires = "expires";
var strEnabled = "enabled";
var strIsCookieUseDisabled = "isCookieUseDisabled";
var strDisableCookiesUsage = "disableCookiesUsage";
var strConfigCookieMgr = "_ckMgr";
var strEmpty = "";
var _supportsCookies = null;
var _allowUaSameSite = null;
var _parsedCookieValue = null;
var _doc = Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["d" /* getDocument */])();
var _cookieCache = {};
var _globalCookieConfig = {};
/**
 * @ignore
 * DO NOT USE or export from the module, this is exposed as public to support backward compatibility of previous static utility methods only.
 * If you want to manager cookies either use the ICookieMgr available from the core instance via getCookieMgr() or create
 * your own instance of the CookieMgr and use that.
 * Using this directly for enabling / disabling cookie handling will not only affect your usage but EVERY user of cookies.
 * Example, if you are using a shared component that is also using Application Insights you will affect their cookie handling.
 * @param logger - The DiagnosticLogger to use for reporting errors.
 */
function _gblCookieMgr(config, logger) {
    // Stash the global instance against the BaseCookieMgr class
    var inst = createCookieMgr[strConfigCookieMgr] || _globalCookieConfig[strConfigCookieMgr];
    if (!inst) {
        // Note: not using the getSetValue() helper as that would require always creating a temporary cookieMgr
        // that ultimately is never used
        inst = createCookieMgr[strConfigCookieMgr] = createCookieMgr(config, logger);
        _globalCookieConfig[strConfigCookieMgr] = inst;
    }
    return inst;
}
function _isMgrEnabled(cookieMgr) {
    if (cookieMgr) {
        return cookieMgr.isEnabled();
    }
    return true;
}
function _createCookieMgrConfig(rootConfig) {
    var cookieMgrCfg = rootConfig.cookieCfg = rootConfig.cookieCfg || {};
    // Sets the values from the root config if not already present on the cookieMgrCfg
    Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["C" /* setValue */])(cookieMgrCfg, "domain", rootConfig.cookieDomain, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["q" /* isNotNullOrUndefined */], __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */]);
    Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["C" /* setValue */])(cookieMgrCfg, "path", rootConfig.cookiePath || "/", null, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */]);
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */])(cookieMgrCfg[strEnabled])) {
        // Set the enabled from the provided setting or the legacy root values
        var cookieEnabled = void 0;
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */])(rootConfig[strIsCookieUseDisabled])) {
            cookieEnabled = !rootConfig[strIsCookieUseDisabled];
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */])(rootConfig[strDisableCookiesUsage])) {
            cookieEnabled = !rootConfig[strDisableCookiesUsage];
        }
        cookieMgrCfg[strEnabled] = cookieEnabled;
    }
    return cookieMgrCfg;
}
/**
 * Helper to return the ICookieMgr from the core (if not null/undefined) or a default implementation
 * associated with the configuration or a legacy default.
 * @param core
 * @param config
 * @returns
 */
function safeGetCookieMgr(core, config) {
    var cookieMgr;
    if (core) {
        // Always returns an instance
        cookieMgr = core.getCookieMgr();
    }
    else if (config) {
        var cookieCfg = (config || {}).cookieCfg;
        if (cookieCfg[strConfigCookieMgr]) {
            cookieMgr = cookieCfg[strConfigCookieMgr];
        }
        else {
            cookieMgr = createCookieMgr(config);
        }
    }
    if (!cookieMgr) {
        // Get or initialize the default global (legacy) cookie manager if we couldn't find one
        cookieMgr = _gblCookieMgr(config, (core || {}).logger);
    }
    return cookieMgr;
}
function createCookieMgr(rootConfig, logger) {
    var cookieMgrConfig = _createCookieMgrConfig(rootConfig || _globalCookieConfig);
    var _path = cookieMgrConfig.path || "/";
    var _domain = cookieMgrConfig.domain;
    // Explicitly checking against false, so that setting to undefined will === true
    var _enabled = cookieMgrConfig[strEnabled] !== false;
    var cookieMgr = {
        isEnabled: function () {
            var enabled = _enabled && areCookiesSupported(logger);
            // Using an indirect lookup for any global cookie manager to support tree shaking for SDK's
            // that don't use the "applicationinsights-core" version of the default cookie function
            var gblManager = _globalCookieConfig[strConfigCookieMgr];
            if (enabled && gblManager && cookieMgr !== gblManager) {
                // Make sure the GlobalCookie Manager instance (if not this instance) is also enabled.
                // As the global (deprecated) functions may have been called (for backward compatibility)
                enabled = _isMgrEnabled(gblManager);
            }
            return enabled;
        },
        setEnabled: function (value) {
            // Explicitly checking against false, so that setting to undefined will === true
            _enabled = value !== false;
        },
        set: function (name, value, maxAgeSec, domain, path) {
            if (_isMgrEnabled(cookieMgr)) {
                var values = {};
                var theValue = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["F" /* strTrim */])(value || strEmpty);
                var idx = theValue.indexOf(";");
                if (idx !== -1) {
                    theValue = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["F" /* strTrim */])(value.substring(0, idx));
                    values = _extractParts(value.substring(idx + 1));
                }
                // Only update domain if not already present (isUndefined) and the value is truthy (not null, undefined or empty string)
                Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["C" /* setValue */])(values, "domain", domain || _domain, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["w" /* isTruthy */], __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */]);
                if (!Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */])(maxAgeSec)) {
                    var _isIE = Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["o" /* isIE */])();
                    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */])(values[strExpires])) {
                        var nowMs = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["g" /* dateNow */])();
                        // Only add expires if not already present
                        var expireMs = nowMs + (maxAgeSec * 1000);
                        // Sanity check, if zero or -ve then ignore
                        if (expireMs > 0) {
                            var expiry = new Date();
                            expiry.setTime(expireMs);
                            Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["C" /* setValue */])(values, strExpires, _formatDate(expiry, !_isIE ? strToUTCString : strToGMTString) || _formatDate(expiry, _isIE ? strToGMTString : strToUTCString) || strEmpty, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["w" /* isTruthy */]);
                        }
                    }
                    if (!_isIE) {
                        // Only replace if not already present
                        Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["C" /* setValue */])(values, "max-age", strEmpty + maxAgeSec, null, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */]);
                    }
                }
                var location_1 = Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["h" /* getLocation */])();
                if (location_1 && location_1.protocol === "https:") {
                    Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["C" /* setValue */])(values, "secure", null, null, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */]);
                    // Only set same site if not also secure
                    if (_allowUaSameSite === null) {
                        _allowUaSameSite = !uaDisallowsSameSiteNone((Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["j" /* getNavigator */])() || {}).userAgent);
                    }
                    if (_allowUaSameSite) {
                        Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["C" /* setValue */])(values, "SameSite", "None", null, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */]);
                    }
                }
                Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["C" /* setValue */])(values, "path", path || _path, null, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */]);
                var setCookieFn = cookieMgrConfig.setCookie || _setCookieValue;
                setCookieFn(name, _formatCookieValue(theValue, values));
            }
        },
        get: function (name) {
            var value = strEmpty;
            if (_isMgrEnabled(cookieMgr)) {
                value = (cookieMgrConfig.getCookie || _getCookieValue)(name);
            }
            return value;
        },
        del: function (name, path) {
            if (_isMgrEnabled(cookieMgr)) {
                // Only remove the cookie if the manager and cookie support has not been disabled
                cookieMgr.purge(name, path);
            }
        },
        purge: function (name, path) {
            if (areCookiesSupported(logger)) {
                // Setting the expiration date in the past immediately removes the cookie
                var values = (_a = {},
                    _a["path"] = path ? path : "/",
                    _a[strExpires] = "Thu, 01 Jan 1970 00:00:01 GMT",
                    _a);
                if (!Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["o" /* isIE */])()) {
                    // Set max age to expire now
                    values["max-age"] = "0";
                }
                var delCookie = cookieMgrConfig.delCookie || _setCookieValue;
                delCookie(name, _formatCookieValue(strEmpty, values));
            }
            var _a;
        }
    };
    // Associated this cookie manager with the config
    cookieMgr[strConfigCookieMgr] = cookieMgr;
    return cookieMgr;
}
/*
* Helper method to tell if document.cookie object is supported by the runtime
*/
function areCookiesSupported(logger) {
    if (_supportsCookies === null) {
        _supportsCookies = false;
        try {
            var doc = _doc || {};
            _supportsCookies = doc[strCookie] !== undefined;
        }
        catch (e) {
            logger && logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_LoggingEnums__["a" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_LoggingEnums__["b" /* _InternalMessageId */].CannotAccessCookie, "Cannot access document.cookie - " + Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["i" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["a" /* dumpObj */])(e) });
        }
    }
    return _supportsCookies;
}
function _extractParts(theValue) {
    var values = {};
    if (theValue && theValue.length) {
        var parts = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["F" /* strTrim */])(theValue).split(";");
        Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["a" /* arrForEach */])(parts, function (thePart) {
            thePart = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["F" /* strTrim */])(thePart || strEmpty);
            if (thePart) {
                var idx = thePart.indexOf("=");
                if (idx === -1) {
                    values[thePart] = null;
                }
                else {
                    values[Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["F" /* strTrim */])(thePart.substring(0, idx))] = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["F" /* strTrim */])(thePart.substring(idx + 1));
                }
            }
        });
    }
    return values;
}
function _formatDate(theDate, func) {
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["p" /* isFunction */])(theDate[func])) {
        return theDate[func]();
    }
    return null;
}
function _formatCookieValue(value, values) {
    var cookieValue = value || strEmpty;
    Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["A" /* objForEachKey */])(values, function (name, theValue) {
        cookieValue += "; " + name + (!Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */])(theValue) ? "=" + theValue : strEmpty);
    });
    return cookieValue;
}
function _getCookieValue(name) {
    var cookieValue = strEmpty;
    if (_doc) {
        var theCookie = _doc[strCookie] || strEmpty;
        if (_parsedCookieValue !== theCookie) {
            _cookieCache = _extractParts(theCookie);
            _parsedCookieValue = theCookie;
        }
        cookieValue = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["F" /* strTrim */])(_cookieCache[name] || strEmpty);
    }
    return cookieValue;
}
function _setCookieValue(name, cookieValue) {
    if (_doc) {
        _doc[strCookie] = name + "=" + cookieValue;
    }
}
function uaDisallowsSameSiteNone(userAgent) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["v" /* isString */])(userAgent)) {
        return false;
    }
    // Cover all iOS based browsers here. This includes:
    // - Safari on iOS 12 for iPhone, iPod Touch, iPad
    // - WkWebview on iOS 12 for iPhone, iPod Touch, iPad
    // - Chrome on iOS 12 for iPhone, iPod Touch, iPad
    // All of which are broken by SameSite=None, because they use the iOS networking stack
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* strContains */])(userAgent, "CPU iPhone OS 12") || Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* strContains */])(userAgent, "iPad; CPU OS 12")) {
        return true;
    }
    // Cover Mac OS X based browsers that use the Mac OS networking stack. This includes:
    // - Safari on Mac OS X
    // This does not include:
    // - Internal browser on Mac OS X
    // - Chrome on Mac OS X
    // - Chromium on Mac OS X
    // Because they do not use the Mac OS networking stack.
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* strContains */])(userAgent, "Macintosh; Intel Mac OS X 10_14") && Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* strContains */])(userAgent, "Version/") && Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* strContains */])(userAgent, "Safari")) {
        return true;
    }
    // Cover Mac OS X internal browsers that use the Mac OS networking stack. This includes:
    // - Internal browser on Mac OS X
    // This does not include:
    // - Safari on Mac OS X
    // - Chrome on Mac OS X
    // - Chromium on Mac OS X
    // Because they do not use the Mac OS networking stack.
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* strContains */])(userAgent, "Macintosh; Intel Mac OS X 10_14") && Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["E" /* strEndsWith */])(userAgent, "AppleWebKit/605.1.15 (KHTML, like Gecko)")) {
        return true;
    }
    // Cover Chrome 50-69, because some versions are broken by SameSite=None, and none in this range require it.
    // Note: this covers some pre-Chromium Edge versions, but pre-Chromim Edge does not require SameSite=None, so this is fine.
    // Note: this regex applies to Windows, Mac OS X, and Linux, deliberately.
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* strContains */])(userAgent, "Chrome/5") || Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* strContains */])(userAgent, "Chrome/6")) {
        return true;
    }
    // Unreal Engine runs Chromium 59, but does not advertise as Chrome until 4.23. Treat versions of Unreal
    // that don't specify their Chrome version as lacking support for SameSite=None.
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* strContains */])(userAgent, "UnrealEngine") && !Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* strContains */])(userAgent, "Chrome")) {
        return true;
    }
    // UCBrowser < 12.13.2 ignores Set-Cookie headers with SameSite=None
    // NB: this rule isn't complete - you need regex to make a complete rule.
    // See: https://www.chromium.org/updates/same-site/incompatible-clients
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* strContains */])(userAgent, "UCBrowser/12") || Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* strContains */])(userAgent, "UCBrowser/11")) {
        return true;
    }
    return false;
}
//# sourceMappingURL=CookieMgr.js.map

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageViewData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventData__ = __webpack_require__(593);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



// THIS FILE WAS AUTOGENERATED

/**
 * An instance of PageView represents a generic action on a page like a button click. It is also the base type for PageView.
 */
var PageViewData = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(PageViewData, _super);
    function PageViewData() {
        var _this = _super.call(this) || this;
        /**
         * Schema version
         */
        _this.ver = 2;
        /**
         * Collection of custom properties.
         */
        _this.properties = {};
        /**
         * Collection of custom measurements.
         */
        _this.measurements = {};
        return _this;
    }
    return PageViewData;
}(__WEBPACK_IMPORTED_MODULE_1__EventData__["a" /* EventData */]));

//# sourceMappingURL=PageViewData.js.map

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _InternalLogMessage; });
/* harmony export (immutable) */ __webpack_exports__["c"] = safeGetLogger;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DiagnosticLogger; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_LoggingEnums__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EnvUtils__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__microsoft_dynamicproto_js__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__ = __webpack_require__(45);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







/**
 * For user non actionable traces use AI Internal prefix.
 */
var AiNonUserActionablePrefix = "AI (Internal): ";
/**
 * Prefix of the traces in portal.
 */
var AiUserActionablePrefix = "AI: ";
/**
 *  Session storage key for the prefix for the key indicating message type already logged
 */
var AIInternalMessagePrefix = "AITR_";
function _sanitizeDiagnosticText(text) {
    if (text) {
        return "\"" + text.replace(/\"/g, "") + "\"";
    }
    return "";
}
var _InternalLogMessage = /** @class */ (function () {
    function _InternalLogMessage(msgId, msg, isUserAct, properties) {
        if (isUserAct === void 0) { isUserAct = false; }
        var _self = this;
        _self.messageId = msgId;
        _self.message =
            (isUserAct ? AiUserActionablePrefix : AiNonUserActionablePrefix) +
                msgId;
        var strProps = "";
        if (Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["m" /* hasJSON */])()) {
            strProps = Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["g" /* getJSON */])().stringify(properties);
        }
        var diagnosticText = (msg ? " message:" + _sanitizeDiagnosticText(msg) : "") +
            (properties ? " props:" + _sanitizeDiagnosticText(strProps) : "");
        _self.message += diagnosticText;
    }
    _InternalLogMessage.dataType = "MessageData";
    return _InternalLogMessage;
}());

function safeGetLogger(core, config) {
    return (core || {}).logger || new DiagnosticLogger(config);
}
var DiagnosticLogger = /** @class */ (function () {
    function DiagnosticLogger(config) {
        this.identifier = 'DiagnosticLogger';
        /**
         * The internal logging queue
         */
        this.queue = [];
        /**
         * Count of internal messages sent
         */
        var _messageCount = 0;
        /**
         * Holds information about what message types were already logged to console or sent to server.
         */
        var _messageLogged = {};
        Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_dynamicproto_js__["a" /* default */])(DiagnosticLogger, this, function (_self) {
            if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["s" /* isNullOrUndefined */])(config)) {
                config = {};
            }
            _self.consoleLoggingLevel = function () { return _getConfigValue('loggingLevelConsole', 0); };
            _self.telemetryLoggingLevel = function () { return _getConfigValue('loggingLevelTelemetry', 1); };
            _self.maxInternalMessageLimit = function () { return _getConfigValue('maxMessageLimit', 25); };
            _self.enableDebugExceptions = function () { return _getConfigValue('enableDebugExceptions', false); };
            /**
             * This method will throw exceptions in debug mode or attempt to log the error as a console warning.
             * @param severity {LoggingSeverity} - The severity of the log message
             * @param message {_InternalLogMessage} - The log message.
             */
            _self.throwInternal = function (severity, msgId, msg, properties, isUserAct) {
                if (isUserAct === void 0) { isUserAct = false; }
                var message = new _InternalLogMessage(msgId, msg, isUserAct, properties);
                if (_self.enableDebugExceptions()) {
                    throw message;
                }
                else {
                    if (!Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["y" /* isUndefined */])(message) && !!message && !Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["y" /* isUndefined */])(message.message)) {
                        var logLevel = _self.consoleLoggingLevel();
                        if (isUserAct) {
                            // check if this message type was already logged to console for this page view and if so, don't log it again
                            var messageKey = +message.messageId;
                            if (!_messageLogged[messageKey] && logLevel >= __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_LoggingEnums__["a" /* LoggingSeverity */].WARNING) {
                                _self.warnToConsole(message.message);
                                _messageLogged[messageKey] = true;
                            }
                        }
                        else {
                            // don't log internal AI traces in the console, unless the verbose logging is enabled
                            if (logLevel >= __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_LoggingEnums__["a" /* LoggingSeverity */].WARNING) {
                                _self.warnToConsole(message.message);
                            }
                        }
                        _self.logInternalMessage(severity, message);
                    }
                }
            };
            /**
             * This will write a warning to the console if possible
             * @param message {string} - The warning message
             */
            _self.warnToConsole = function (message) {
                var theConsole = Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["b" /* getConsole */])();
                if (!!theConsole) {
                    var logFunc = 'log';
                    if (theConsole.warn) {
                        logFunc = 'warn';
                    }
                    if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["p" /* isFunction */])(theConsole[logFunc])) {
                        theConsole[logFunc](message);
                    }
                }
            };
            /**
             * Resets the internal message count
             */
            _self.resetInternalMessageCount = function () {
                _messageCount = 0;
                _messageLogged = {};
            };
            /**
             * Logs a message to the internal queue.
             * @param severity {LoggingSeverity} - The severity of the log message
             * @param message {_InternalLogMessage} - The message to log.
             */
            _self.logInternalMessage = function (severity, message) {
                if (_areInternalMessagesThrottled()) {
                    return;
                }
                // check if this message type was already logged for this session and if so, don't log it again
                var logMessage = true;
                var messageKey = AIInternalMessagePrefix + message.messageId;
                // if the session storage is not available, limit to only one message type per page view
                if (_messageLogged[messageKey]) {
                    logMessage = false;
                }
                else {
                    _messageLogged[messageKey] = true;
                }
                if (logMessage) {
                    // Push the event in the internal queue
                    if (severity <= _self.telemetryLoggingLevel()) {
                        _self.queue.push(message);
                        _messageCount++;
                    }
                    // When throttle limit reached, send a special event
                    if (_messageCount === _self.maxInternalMessageLimit()) {
                        var throttleLimitMessage = "Internal events throttle limit per PageView reached for this app.";
                        var throttleMessage = new _InternalLogMessage(__WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_LoggingEnums__["b" /* _InternalMessageId */].MessageLimitPerPVExceeded, throttleLimitMessage, false);
                        _self.queue.push(throttleMessage);
                        _self.warnToConsole(throttleLimitMessage);
                    }
                }
            };
            function _getConfigValue(name, defValue) {
                var value = config[name];
                if (!Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["s" /* isNullOrUndefined */])(value)) {
                    return value;
                }
                return defValue;
            }
            function _areInternalMessagesThrottled() {
                return _messageCount >= _self.maxInternalMessageLimit();
            }
        });
    }
// Removed Stub for DiagnosticLogger.prototype.enableDebugExceptions.
// Removed Stub for DiagnosticLogger.prototype.consoleLoggingLevel.
// Removed Stub for DiagnosticLogger.prototype.telemetryLoggingLevel.
// Removed Stub for DiagnosticLogger.prototype.maxInternalMessageLimit.
// Removed Stub for DiagnosticLogger.prototype.throwInternal.
// Removed Stub for DiagnosticLogger.prototype.warnToConsole.
// Removed Stub for DiagnosticLogger.prototype.resetInternalMessageCount.
// Removed Stub for DiagnosticLogger.prototype.logInternalMessage.
    return DiagnosticLogger;
}());

//# sourceMappingURL=DiagnosticLogger.js.map

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return strIKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return strExtensionConfig; });
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var strIKey = "iKey";
var strExtensionConfig = "extensionConfig";
//# sourceMappingURL=Constants.js.map

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initializePlugins;
/* harmony export (immutable) */ __webpack_exports__["b"] = sortPlugins;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HelperFuncs__ = __webpack_require__(45);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var processTelemetry = "processTelemetry";
var priority = "priority";
var setNextPlugin = "setNextPlugin";
var isInitialized = "isInitialized";
/**
 * Initialize the queue of plugins
 * @param plugins - The array of plugins to initialize and setting of the next plugin
 * @param config The current config for the instance
 * @param core THe current core instance
 * @param extensions The extensions
 */
function initializePlugins(processContext, extensions) {
    // Set the next plugin and identified the uninitialized plugins
    var initPlugins = [];
    var lastPlugin = null;
    var proxy = processContext.getNext();
    while (proxy) {
        var thePlugin = proxy.getPlugin();
        if (thePlugin) {
            if (lastPlugin &&
                Object(__WEBPACK_IMPORTED_MODULE_0__HelperFuncs__["p" /* isFunction */])(lastPlugin[setNextPlugin]) &&
                Object(__WEBPACK_IMPORTED_MODULE_0__HelperFuncs__["p" /* isFunction */])(thePlugin[processTelemetry])) {
                // Set this plugin as the next for the previous one
                lastPlugin[setNextPlugin](thePlugin);
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_0__HelperFuncs__["p" /* isFunction */])(thePlugin[isInitialized]) || !thePlugin[isInitialized]()) {
                initPlugins.push(thePlugin);
            }
            lastPlugin = thePlugin;
            proxy = proxy.getNext();
        }
    }
    // Now initiatilize the plugins
    Object(__WEBPACK_IMPORTED_MODULE_0__HelperFuncs__["a" /* arrForEach */])(initPlugins, function (thePlugin) {
        thePlugin.initialize(processContext.getCfg(), processContext.core(), extensions, processContext.getNext());
    });
}
function sortPlugins(plugins) {
    // Sort by priority
    return plugins.sort(function (extA, extB) {
        var result = 0;
        var bHasProcess = Object(__WEBPACK_IMPORTED_MODULE_0__HelperFuncs__["p" /* isFunction */])(extB[processTelemetry]);
        if (Object(__WEBPACK_IMPORTED_MODULE_0__HelperFuncs__["p" /* isFunction */])(extA[processTelemetry])) {
            result = bHasProcess ? extA[priority] - extB[priority] : 1;
        }
        else if (bHasProcess) {
            result = -1;
        }
        return result;
    });
    // sort complete    
}
//# sourceMappingURL=TelemetryHelpers.js.map

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _gblCookieMgr;
/* unused harmony export safeGetCookieMgr */
/* harmony export (immutable) */ __webpack_exports__["b"] = createCookieMgr;
/* unused harmony export areCookiesSupported */
/* harmony export (immutable) */ __webpack_exports__["c"] = uaDisallowsSameSiteNone;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_LoggingEnums__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EnvUtils__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__ = __webpack_require__(45);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



var strToGMTString = "toGMTString";
var strToUTCString = "toUTCString";
var strCookie = "cookie";
var strExpires = "expires";
var strEnabled = "enabled";
var strIsCookieUseDisabled = "isCookieUseDisabled";
var strDisableCookiesUsage = "disableCookiesUsage";
var strConfigCookieMgr = "_ckMgr";
var strEmpty = "";
var _supportsCookies = null;
var _allowUaSameSite = null;
var _parsedCookieValue = null;
var _doc = Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["d" /* getDocument */])();
var _cookieCache = {};
var _globalCookieConfig = {};
/**
 * @ignore
 * DO NOT USE or export from the module, this is exposed as public to support backward compatibility of previous static utility methods only.
 * If you want to manager cookies either use the ICookieMgr available from the core instance via getCookieMgr() or create
 * your own instance of the CookieMgr and use that.
 * Using this directly for enabling / disabling cookie handling will not only affect your usage but EVERY user of cookies.
 * Example, if you are using a shared component that is also using Application Insights you will affect their cookie handling.
 * @param logger - The DiagnosticLogger to use for reporting errors.
 */
function _gblCookieMgr(config, logger) {
    // Stash the global instance against the BaseCookieMgr class
    var inst = createCookieMgr[strConfigCookieMgr] || _globalCookieConfig[strConfigCookieMgr];
    if (!inst) {
        // Note: not using the getSetValue() helper as that would require always creating a temporary cookieMgr
        // that ultimately is never used
        inst = createCookieMgr[strConfigCookieMgr] = createCookieMgr(config, logger);
        _globalCookieConfig[strConfigCookieMgr] = inst;
    }
    return inst;
}
function _isMgrEnabled(cookieMgr) {
    if (cookieMgr) {
        return cookieMgr.isEnabled();
    }
    return true;
}
function _createCookieMgrConfig(rootConfig) {
    var cookieMgrCfg = rootConfig.cookieCfg = rootConfig.cookieCfg || {};
    // Sets the values from the root config if not already present on the cookieMgrCfg
    Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* setValue */])(cookieMgrCfg, "domain", rootConfig.cookieDomain, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["q" /* isNotNullOrUndefined */], __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */]);
    Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* setValue */])(cookieMgrCfg, "path", rootConfig.cookiePath || "/", null, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */]);
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */])(cookieMgrCfg[strEnabled])) {
        // Set the enabled from the provided setting or the legacy root values
        var cookieEnabled = void 0;
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */])(rootConfig[strIsCookieUseDisabled])) {
            cookieEnabled = !rootConfig[strIsCookieUseDisabled];
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */])(rootConfig[strDisableCookiesUsage])) {
            cookieEnabled = !rootConfig[strDisableCookiesUsage];
        }
        cookieMgrCfg[strEnabled] = cookieEnabled;
    }
    return cookieMgrCfg;
}
/**
 * Helper to return the ICookieMgr from the core (if not null/undefined) or a default implementation
 * associated with the configuration or a legacy default.
 * @param core
 * @param config
 * @returns
 */
function safeGetCookieMgr(core, config) {
    var cookieMgr;
    if (core) {
        // Always returns an instance
        cookieMgr = core.getCookieMgr();
    }
    else if (config) {
        var cookieCfg = (config || {}).cookieCfg;
        if (cookieCfg[strConfigCookieMgr]) {
            cookieMgr = cookieCfg[strConfigCookieMgr];
        }
        else {
            cookieMgr = createCookieMgr(config);
        }
    }
    if (!cookieMgr) {
        // Get or initialize the default global (legacy) cookie manager if we couldn't find one
        cookieMgr = _gblCookieMgr(config, (core || {}).logger);
    }
    return cookieMgr;
}
function createCookieMgr(rootConfig, logger) {
    var cookieMgrConfig = _createCookieMgrConfig(rootConfig || _globalCookieConfig);
    var _path = cookieMgrConfig.path || "/";
    var _domain = cookieMgrConfig.domain;
    // Explicitly checking against false, so that setting to undefined will === true
    var _enabled = cookieMgrConfig[strEnabled] !== false;
    var cookieMgr = {
        isEnabled: function () {
            var enabled = _enabled && areCookiesSupported(logger);
            // Using an indirect lookup for any global cookie manager to support tree shaking for SDK's
            // that don't use the "applicationinsights-core" version of the default cookie function
            var gblManager = _globalCookieConfig[strConfigCookieMgr];
            if (enabled && gblManager && cookieMgr !== gblManager) {
                // Make sure the GlobalCookie Manager instance (if not this instance) is also enabled.
                // As the global (deprecated) functions may have been called (for backward compatibility)
                enabled = _isMgrEnabled(gblManager);
            }
            return enabled;
        },
        setEnabled: function (value) {
            // Explicitly checking against false, so that setting to undefined will === true
            _enabled = value !== false;
        },
        set: function (name, value, maxAgeSec, domain, path) {
            if (_isMgrEnabled(cookieMgr)) {
                var values = {};
                var theValue = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["G" /* strTrim */])(value || strEmpty);
                var idx = theValue.indexOf(";");
                if (idx !== -1) {
                    theValue = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["G" /* strTrim */])(value.substring(0, idx));
                    values = _extractParts(value.substring(idx + 1));
                }
                // Only update domain if not already present (isUndefined) and the value is truthy (not null, undefined or empty string)
                Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* setValue */])(values, "domain", domain || _domain, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["w" /* isTruthy */], __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */]);
                if (!Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */])(maxAgeSec)) {
                    var _isIE = Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["n" /* isIE */])();
                    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */])(values[strExpires])) {
                        var nowMs = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["g" /* dateNow */])();
                        // Only add expires if not already present
                        var expireMs = nowMs + (maxAgeSec * 1000);
                        // Sanity check, if zero or -ve then ignore
                        if (expireMs > 0) {
                            var expiry = new Date();
                            expiry.setTime(expireMs);
                            Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* setValue */])(values, strExpires, _formatDate(expiry, !_isIE ? strToUTCString : strToGMTString) || _formatDate(expiry, _isIE ? strToGMTString : strToUTCString) || strEmpty, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["w" /* isTruthy */]);
                        }
                    }
                    if (!_isIE) {
                        // Only replace if not already present
                        Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* setValue */])(values, "max-age", strEmpty + maxAgeSec, null, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */]);
                    }
                }
                var location_1 = Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["h" /* getLocation */])();
                if (location_1 && location_1.protocol === "https:") {
                    Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* setValue */])(values, "secure", null, null, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */]);
                    // Only set same site if not also secure
                    if (_allowUaSameSite === null) {
                        _allowUaSameSite = !uaDisallowsSameSiteNone((Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["j" /* getNavigator */])() || {}).userAgent);
                    }
                    if (_allowUaSameSite) {
                        Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* setValue */])(values, "SameSite", "None", null, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */]);
                    }
                }
                Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["D" /* setValue */])(values, "path", path || _path, null, __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["y" /* isUndefined */]);
                var setCookieFn = cookieMgrConfig.setCookie || _setCookieValue;
                setCookieFn(name, _formatCookieValue(theValue, values));
            }
        },
        get: function (name) {
            var value = strEmpty;
            if (_isMgrEnabled(cookieMgr)) {
                value = (cookieMgrConfig.getCookie || _getCookieValue)(name);
            }
            return value;
        },
        del: function (name, path) {
            if (_isMgrEnabled(cookieMgr)) {
                // Only remove the cookie if the manager and cookie support has not been disabled
                cookieMgr.purge(name, path);
            }
        },
        purge: function (name, path) {
            if (areCookiesSupported(logger)) {
                // Setting the expiration date in the past immediately removes the cookie
                var values = (_a = {},
                    _a["path"] = path ? path : "/",
                    _a[strExpires] = "Thu, 01 Jan 1970 00:00:01 GMT",
                    _a);
                if (!Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["n" /* isIE */])()) {
                    // Set max age to expire now
                    values["max-age"] = "0";
                }
                var delCookie = cookieMgrConfig.delCookie || _setCookieValue;
                delCookie(name, _formatCookieValue(strEmpty, values));
            }
            var _a;
        }
    };
    // Associated this cookie manager with the config
    cookieMgr[strConfigCookieMgr] = cookieMgr;
    return cookieMgr;
}
/*
* Helper method to tell if document.cookie object is supported by the runtime
*/
function areCookiesSupported(logger) {
    if (_supportsCookies === null) {
        _supportsCookies = false;
        try {
            var doc = _doc || {};
            _supportsCookies = doc[strCookie] !== undefined;
        }
        catch (e) {
            logger && logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_LoggingEnums__["a" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Enums_LoggingEnums__["b" /* _InternalMessageId */].CannotAccessCookie, "Cannot access document.cookie - " + Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["i" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_1__EnvUtils__["a" /* dumpObj */])(e) });
        }
    }
    return _supportsCookies;
}
function _extractParts(theValue) {
    var values = {};
    if (theValue && theValue.length) {
        var parts = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["G" /* strTrim */])(theValue).split(";");
        Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["a" /* arrForEach */])(parts, function (thePart) {
            thePart = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["G" /* strTrim */])(thePart || strEmpty);
            if (thePart) {
                var idx = thePart.indexOf("=");
                if (idx === -1) {
                    values[thePart] = null;
                }
                else {
                    values[Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["G" /* strTrim */])(thePart.substring(0, idx))] = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["G" /* strTrim */])(thePart.substring(idx + 1));
                }
            }
        });
    }
    return values;
}
function _formatDate(theDate, func) {
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["p" /* isFunction */])(theDate[func])) {
        return theDate[func]();
    }
    return null;
}
function _formatCookieValue(value, values) {
    var cookieValue = value || strEmpty;
    Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["B" /* objForEachKey */])(values, function (name, theValue) {
        cookieValue += "; " + name + (!Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["s" /* isNullOrUndefined */])(theValue) ? "=" + theValue : strEmpty);
    });
    return cookieValue;
}
function _getCookieValue(name) {
    var cookieValue = strEmpty;
    if (_doc) {
        var theCookie = _doc[strCookie] || strEmpty;
        if (_parsedCookieValue !== theCookie) {
            _cookieCache = _extractParts(theCookie);
            _parsedCookieValue = theCookie;
        }
        cookieValue = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["G" /* strTrim */])(_cookieCache[name] || strEmpty);
    }
    return cookieValue;
}
function _setCookieValue(name, cookieValue) {
    if (_doc) {
        _doc[strCookie] = name + "=" + cookieValue;
    }
}
function uaDisallowsSameSiteNone(userAgent) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["v" /* isString */])(userAgent)) {
        return false;
    }
    // Cover all iOS based browsers here. This includes:
    // - Safari on iOS 12 for iPhone, iPod Touch, iPad
    // - WkWebview on iOS 12 for iPhone, iPod Touch, iPad
    // - Chrome on iOS 12 for iPhone, iPod Touch, iPad
    // All of which are broken by SameSite=None, because they use the iOS networking stack
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["E" /* strContains */])(userAgent, "CPU iPhone OS 12") || Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["E" /* strContains */])(userAgent, "iPad; CPU OS 12")) {
        return true;
    }
    // Cover Mac OS X based browsers that use the Mac OS networking stack. This includes:
    // - Safari on Mac OS X
    // This does not include:
    // - Internal browser on Mac OS X
    // - Chrome on Mac OS X
    // - Chromium on Mac OS X
    // Because they do not use the Mac OS networking stack.
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["E" /* strContains */])(userAgent, "Macintosh; Intel Mac OS X 10_14") && Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["E" /* strContains */])(userAgent, "Version/") && Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["E" /* strContains */])(userAgent, "Safari")) {
        return true;
    }
    // Cover Mac OS X internal browsers that use the Mac OS networking stack. This includes:
    // - Internal browser on Mac OS X
    // This does not include:
    // - Safari on Mac OS X
    // - Chrome on Mac OS X
    // - Chromium on Mac OS X
    // Because they do not use the Mac OS networking stack.
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["E" /* strContains */])(userAgent, "Macintosh; Intel Mac OS X 10_14") && Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["F" /* strEndsWith */])(userAgent, "AppleWebKit/605.1.15 (KHTML, like Gecko)")) {
        return true;
    }
    // Cover Chrome 50-69, because some versions are broken by SameSite=None, and none in this range require it.
    // Note: this covers some pre-Chromium Edge versions, but pre-Chromim Edge does not require SameSite=None, so this is fine.
    // Note: this regex applies to Windows, Mac OS X, and Linux, deliberately.
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["E" /* strContains */])(userAgent, "Chrome/5") || Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["E" /* strContains */])(userAgent, "Chrome/6")) {
        return true;
    }
    // Unreal Engine runs Chromium 59, but does not advertise as Chrome until 4.23. Treat versions of Unreal
    // that don't specify their Chrome version as lacking support for SameSite=None.
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["E" /* strContains */])(userAgent, "UnrealEngine") && !Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["E" /* strContains */])(userAgent, "Chrome")) {
        return true;
    }
    // UCBrowser < 12.13.2 ignores Set-Cookie headers with SameSite=None
    // NB: this rule isn't complete - you need regex to make a complete rule.
    // See: https://www.chromium.org/updates/same-site/incompatible-clients
    if (Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["E" /* strContains */])(userAgent, "UCBrowser/12") || Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["E" /* strContains */])(userAgent, "UCBrowser/11")) {
        return true;
    }
    return false;
}
//# sourceMappingURL=CookieMgr.js.map

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageViewData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventData__ = __webpack_require__(611);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



// THIS FILE WAS AUTOGENERATED

/**
 * An instance of PageView represents a generic action on a page like a button click. It is also the base type for PageView.
 */
var PageViewData = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(PageViewData, _super);
    function PageViewData() {
        var _this = _super.call(this) || this;
        /**
         * Schema version
         */
        _this.ver = 2;
        /**
         * Collection of custom properties.
         */
        _this.properties = {};
        /**
         * Collection of custom measurements.
         */
        _this.measurements = {};
        return _this;
    }
    return PageViewData;
}(__WEBPACK_IMPORTED_MODULE_1__EventData__["a" /* EventData */]));

//# sourceMappingURL=PageViewData.js.map

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return PropertiesPluginIdentifier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BreezeChannelIdentifier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AnalyticsPluginIdentifier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Util__ = __webpack_require__(614);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_0__Util__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__Util__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_0__Util__["c"]; });
/* unused harmony reexport dateTimeUtilsNow */
/* unused harmony reexport dateTimeUtilsDuration */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_0__Util__["d"]; });
/* unused harmony reexport isInternalApplicationInsightsEndpoint */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConnectionStringParser__ = __webpack_require__(1530);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_1__ConnectionStringParser__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__ConnectionStringParser__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RequestResponseHeaders__ = __webpack_require__(615);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_2__RequestResponseHeaders__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Constants__ = __webpack_require__(85);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_3__Constants__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_3__Constants__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_3__Constants__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_3__Constants__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_3__Constants__["a"]; });
/* unused harmony reexport strNotSpecified */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Interfaces_Contracts_Generated_Data__ = __webpack_require__(620);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__Interfaces_Contracts_Generated_Data__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Interfaces_Contracts_Generated_Base__ = __webpack_require__(621);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__Interfaces_Contracts_Generated_Base__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Telemetry_Common_Envelope__ = __webpack_require__(1531);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_6__Telemetry_Common_Envelope__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Telemetry_Event__ = __webpack_require__(1533);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_7__Telemetry_Event__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Telemetry_Exception__ = __webpack_require__(1534);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_8__Telemetry_Exception__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Telemetry_Metric__ = __webpack_require__(1538);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_9__Telemetry_Metric__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Telemetry_PageView__ = __webpack_require__(1543);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_10__Telemetry_PageView__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Interfaces_Contracts_Generated_PageViewData__ = __webpack_require__(381);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_11__Interfaces_Contracts_Generated_PageViewData__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Telemetry_RemoteDependencyData__ = __webpack_require__(1544);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_12__Telemetry_RemoteDependencyData__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Telemetry_Trace__ = __webpack_require__(1546);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_13__Telemetry_Trace__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Telemetry_PageViewPerformance__ = __webpack_require__(1548);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_14__Telemetry_PageViewPerformance__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Telemetry_Common_Data__ = __webpack_require__(1550);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_15__Telemetry_Common_Data__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Interfaces_Contracts_Generated_SeverityLevel__ = __webpack_require__(1551);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_16__Interfaces_Contracts_Generated_SeverityLevel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Interfaces_IConfig__ = __webpack_require__(1552);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_17__Interfaces_IConfig__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Interfaces_Contracts_Generated_ContextTagKeys__ = __webpack_require__(623);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_18__Interfaces_Contracts_Generated_ContextTagKeys__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Telemetry_Common_DataSanitizer__ = __webpack_require__(84);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_19__Telemetry_Common_DataSanitizer__["a"]; });
/* unused harmony reexport dataSanitizeKeyAndAddUniqueness */
/* unused harmony reexport dataSanitizeKey */
/* unused harmony reexport dataSanitizeString */
/* unused harmony reexport dataSanitizeUrl */
/* unused harmony reexport dataSanitizeMessage */
/* unused harmony reexport dataSanitizeException */
/* unused harmony reexport dataSanitizeProperties */
/* unused harmony reexport dataSanitizeMeasurements */
/* unused harmony reexport dataSanitizeId */
/* unused harmony reexport dataSanitizeInput */
/* unused harmony reexport dsPadNumber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__TelemetryItemCreator__ = __webpack_require__(1553);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_20__TelemetryItemCreator__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Interfaces_PartAExtensions__ = __webpack_require__(1554);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_21__Interfaces_PartAExtensions__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_21__Interfaces_PartAExtensions__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Enums__ = __webpack_require__(618);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_22__Enums__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__HelperFuncs__ = __webpack_require__(255);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_23__HelperFuncs__["e"]; });
/* unused harmony reexport msToTimeSpan */
/* unused harmony reexport isBeaconApiSupported */
/* unused harmony reexport getExtensionByName */
/* unused harmony reexport isCrossOriginError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__DomHelperFuncs__ = __webpack_require__(616);
/* unused harmony reexport createDomEvent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__StorageHelperFuncs__ = __webpack_require__(617);
/* unused harmony reexport utlDisableStorage */
/* unused harmony reexport utlCanUseLocalStorage */
/* unused harmony reexport utlGetLocalStorage */
/* unused harmony reexport utlSetLocalStorage */
/* unused harmony reexport utlRemoveStorage */
/* unused harmony reexport utlCanUseSessionStorage */
/* unused harmony reexport utlGetSessionStorageKeys */
/* unused harmony reexport utlGetSessionStorage */
/* unused harmony reexport utlSetSessionStorage */
/* unused harmony reexport utlRemoveSessionStorage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__UrlHelperFuncs__ = __webpack_require__(619);
/* unused harmony reexport urlParseUrl */
/* unused harmony reexport urlGetAbsoluteUrl */
/* unused harmony reexport urlGetPathName */
/* unused harmony reexport urlGetCompleteUrl */
/* unused harmony reexport urlParseHost */
/* unused harmony reexport urlParseFullHost */
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





























var PropertiesPluginIdentifier = "AppInsightsPropertiesPlugin";
var BreezeChannelIdentifier = "AppInsightsChannelPlugin";
var AnalyticsPluginIdentifier = "ApplicationInsightsAnalytics";
//# sourceMappingURL=applicationinsights-common.js.map

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageViewData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventData__ = __webpack_require__(622);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



// THIS FILE WAS AUTOGENERATED

/**
 * An instance of PageView represents a generic action on a page like a button click. It is also the base type for PageView.
 */
var PageViewData = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(PageViewData, _super);
    function PageViewData() {
        var _this = _super.call(this) || this;
        /**
         * Schema version
         */
        _this.ver = 2;
        /**
         * Collection of custom properties.
         */
        _this.properties = {};
        /**
         * Collection of custom measurements.
         */
        _this.measurements = {};
        return _this;
    }
    return PageViewData;
}(__WEBPACK_IMPORTED_MODULE_1__EventData__["a" /* EventData */]));

//# sourceMappingURL=PageViewData.js.map

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _isSSR; });
/* unused harmony export setSSR */
var _isSSR = false;
/**
 * Helper to set ssr mode to simulate no window object returned from getWindow helper.
 *
 * @public
 */
function setSSR(isEnabled) {
    _isSSR = isEnabled;
}
//# sourceMappingURL=setSSR.js.map

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = shallowCompare;
/* harmony export (immutable) */ __webpack_exports__["a"] = assign;
/* harmony export (immutable) */ __webpack_exports__["b"] = filteredAssign;
/* harmony export (immutable) */ __webpack_exports__["c"] = getId;
/* unused harmony export resetIds */
/* harmony export (immutable) */ __webpack_exports__["d"] = mapEnumByName;
/* harmony export (immutable) */ __webpack_exports__["f"] = values;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uifabric_merge_styles__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_getWindow__ = __webpack_require__(86);


// Initialize global window id.
var CURRENT_ID_PROPERTY = '__currentId__';
var DEFAULT_ID_STRING = 'id__';
// tslint:disable-next-line:no-any
var _global = Object(__WEBPACK_IMPORTED_MODULE_1__dom_getWindow__["a" /* getWindow */])() || {};
if (_global[CURRENT_ID_PROPERTY] === undefined) {
    _global[CURRENT_ID_PROPERTY] = 0;
}
// tslint:disable-next-line:no-any
function checkProperties(a, b) {
    for (var propName in a) {
        if (a.hasOwnProperty(propName)) {
            if (!b.hasOwnProperty(propName) || b[propName] !== a[propName]) {
                return false;
            }
        }
    }
    return true;
}
/**
 * Compares a to b and b to a.
 *
 * @public
 */
function shallowCompare(a, b) {
    return checkProperties(a, b) && checkProperties(b, a);
}
/**
 * Makes a resulting merge of a bunch of objects. Pass in the target object followed by 1 or more
 * objects as arguments and they will be merged sequentially into the target. Note that this will
 * shallow merge; it will not create new cloned values for target members.
 *
 * @public
 * @param target - Target object to merge following object arguments into.
 * @param args - One or more objects that will be mixed into the target in the order they are provided.
 * @returns Resulting merged target.
 */
// tslint:disable-next-line:no-any
function assign(target) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return filteredAssign.apply(this, [null, target].concat(args));
}
/**
 * Makes a resulting merge of a bunch of objects, but allows a filter function to be passed in to filter
 * the resulting merges. This allows for scenarios where you want to merge "everything except that one thing"
 * or "properties that start with data-". Note that this will shallow merge; it will not create new cloned
 * values for target members.
 *
 * @public
 * @param isAllowed - Callback to determine if the given propName is allowed in the result.
 * @param target - Target object to merge following object arguments into.
 * @param args - One or more objects that will be mixed into the target in the order they are provided.
 * @returns Resulting merged target.
 */
// tslint:disable-next-line:no-any
function filteredAssign(isAllowed, target) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    target = target || {};
    for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
        var sourceObject = args_1[_a];
        if (sourceObject) {
            for (var propName in sourceObject) {
                if (sourceObject.hasOwnProperty(propName) && (!isAllowed || isAllowed(propName))) {
                    target[propName] = sourceObject[propName];
                }
            }
        }
    }
    return target;
}
// Configure ids to reset on stylesheet resets.
var stylesheet = __WEBPACK_IMPORTED_MODULE_0__uifabric_merge_styles__["a" /* Stylesheet */].getInstance();
if (stylesheet && stylesheet.onReset) {
    stylesheet.onReset(resetIds);
}
/**
 * Generates a unique id in the global scope (this spans across duplicate copies of the same library.)
 *
 * @public
 */
function getId(prefix) {
    var index = _global[CURRENT_ID_PROPERTY]++;
    return (prefix || DEFAULT_ID_STRING) + index;
}
/**
 * Resets id counter to an (optional) number.
 *
 * @public
 */
function resetIds(counter) {
    if (counter === void 0) { counter = 0; }
    _global[CURRENT_ID_PROPERTY] = counter;
}
/* Takes an enum and iterates over each value of the enum (as a string), running the callback on each, returning a mapped array.
 * The callback takes as a first parameter the string that represents the name of the entry, and the second parameter is the
 * value of that entry, which is the value you'd normally use when using the enum (usually a number).
 * */
function mapEnumByName(
// tslint:disable-next-line:no-any
theEnum, callback) {
    // map<any> to satisfy compiler since it doesn't realize we strip out undefineds in the .filter() call
    return Object.keys(theEnum)
        .map(function (p) {
        // map on each property name as a string
        if (String(Number(p)) !== p) {
            // if the property is not just a number (because enums in TypeScript will map both ways)
            return callback(p, theEnum[p]);
        }
    })
        .filter(function (v) { return !!v; }); // only return elements with values
}
/**
 * Get all values in an object dictionary
 *
 * @param obj - The dictionary to get values for
 */
// tslint:disable-next-line:no-any
function values(obj) {
    return Object.keys(obj).reduce(function (arr, key) {
        arr.push(obj[key]);
        return arr;
    }, []);
}
//# sourceMappingURL=object.js.map

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KeyCodes; });
/**
 * Simulated enum for keycodes. These will get inlined by uglify when used much like an enum
 *
 * @public
 * {@docCategory KeyCodes}
 */
var KeyCodes = {
    backspace: 8,
    tab: 9,
    enter: 13,
    shift: 16,
    ctrl: 17,
    alt: 18,
    pauseBreak: 19,
    capslock: 20,
    escape: 27,
    space: 32,
    pageUp: 33,
    pageDown: 34,
    end: 35,
    home: 36,
    left: 37,
    up: 38,
    right: 39,
    down: 40,
    insert: 45,
    del: 46,
    zero: 48,
    one: 49,
    two: 50,
    three: 51,
    four: 52,
    five: 53,
    six: 54,
    seven: 55,
    eight: 56,
    nine: 57,
    a: 65,
    b: 66,
    c: 67,
    d: 68,
    e: 69,
    f: 70,
    g: 71,
    h: 72,
    i: 73,
    j: 74,
    k: 75,
    l: 76,
    m: 77,
    n: 78,
    o: 79,
    p: 80,
    q: 81,
    r: 82,
    s: 83,
    t: 84,
    u: 85,
    v: 86,
    w: 87,
    x: 88,
    y: 89,
    z: 90,
    leftWindow: 91,
    rightWindow: 92,
    select: 93,
    zero_numpad: 96,
    one_numpad: 97,
    two_numpad: 98,
    three_numpad: 99,
    four_numpad: 100,
    five_numpad: 101,
    six_numpad: 102,
    seven_numpad: 103,
    eight_numpad: 104,
    nine_numpad: 105,
    multiply: 106,
    add: 107,
    subtract: 109,
    decimalPoint: 110,
    divide: 111,
    f1: 112,
    f2: 113,
    f3: 114,
    f4: 115,
    f5: 116,
    f6: 117,
    f7: 118,
    f8: 119,
    f9: 120,
    f10: 121,
    f11: 122,
    f12: 123,
    numlock: 144,
    scrollLock: 145,
    semicolon: 186,
    equalSign: 187,
    comma: 188,
    dash: 189,
    period: 190,
    forwardSlash: 191,
    graveAccent: 192,
    openBracket: 219,
    backSlash: 220,
    closeBracket: 221,
    singleQuote: 222
};
//# sourceMappingURL=KeyCodes.js.map

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isVirtualElement;
/**
 * Determines whether or not an element has the virtual hierarchy extension.
 *
 * @public
 */
function isVirtualElement(element) {
    return element && !!element._virtual;
}
//# sourceMappingURL=isVirtualElement.js.map

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findElementRecursive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getParent__ = __webpack_require__(262);

/**
 * Finds the first parent element where the matchFunction returns true
 * @param element - element to start searching at
 * @param matchFunction - the function that determines if the element is a match
 * @returns the matched element or null no match was found
 */
function findElementRecursive(element, matchFunction) {
    if (!element || element === document.body) {
        return null;
    }
    return matchFunction(element) ? element : findElementRecursive(Object(__WEBPACK_IMPORTED_MODULE_0__getParent__["a" /* getParent */])(element), matchFunction);
}
//# sourceMappingURL=findElementRecursive.js.map

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnimationStyles__ = __webpack_require__(1622);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AnimationStyles__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__AnimationStyles__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DefaultPalette__ = __webpack_require__(388);
/* unused harmony reexport DefaultPalette */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DefaultFontStyles__ = __webpack_require__(389);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__DefaultFontStyles__["a"]; });
/* unused harmony reexport registerDefaultFontFaces */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fonts__ = __webpack_require__(653);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__fonts__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__fonts__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_3__fonts__["c"]; });
/* unused harmony reexport createFontStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getFocusStyle__ = __webpack_require__(1623);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_4__getFocusStyle__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_4__getFocusStyle__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hiddenContentStyle__ = __webpack_require__(1624);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_5__hiddenContentStyle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PulsingBeaconAnimationStyles__ = __webpack_require__(1625);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__PulsingBeaconAnimationStyles__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__getGlobalClassNames__ = __webpack_require__(1626);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_7__getGlobalClassNames__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__scheme__ = __webpack_require__(1627);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_8__scheme__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__theme__ = __webpack_require__(1628);
/* unused harmony reexport ThemeSettingName */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_9__theme__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_9__theme__["b"]; });
/* unused harmony reexport createTheme */
/* unused harmony reexport registerOnThemeChangeCallback */
/* unused harmony reexport removeOnThemeChangeCallback */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CommonStyles__ = __webpack_require__(654);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_10__CommonStyles__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_10__CommonStyles__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_10__CommonStyles__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_10__CommonStyles__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_10__CommonStyles__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_10__CommonStyles__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_10__CommonStyles__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_10__CommonStyles__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_10__CommonStyles__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_10__CommonStyles__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_10__CommonStyles__["k"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__GeneralStyles__ = __webpack_require__(1631);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_11__GeneralStyles__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_11__GeneralStyles__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__getFadedOverflowStyle__ = __webpack_require__(1632);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__getPlaceholderStyles__ = __webpack_require__(1633);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_13__getPlaceholderStyles__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__zIndexes__ = __webpack_require__(655);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_14__zIndexes__["a"]; });















//# sourceMappingURL=index.js.map

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DefaultPalette; });
// When adding or removing a color, make sure you keep this consistent with IColorClassNames by adding the color variants.
var DefaultPalette = {
    themeDarker: '#004578',
    themeDark: '#005a9e',
    themeDarkAlt: '#106ebe',
    themePrimary: '#0078d4',
    themeSecondary: '#2b88d8',
    themeTertiary: '#71afe5',
    themeLight: '#c7e0f4',
    themeLighter: '#deecf9',
    themeLighterAlt: '#eff6fc',
    black: '#000000',
    blackTranslucent40: 'rgba(0,0,0,.4)',
    neutralDark: '#212121',
    neutralPrimary: '#333333',
    neutralPrimaryAlt: '#3c3c3c',
    neutralSecondary: '#666666',
    neutralSecondaryAlt: '#767676',
    neutralTertiary: '#a6a6a6',
    neutralTertiaryAlt: '#c8c8c8',
    neutralQuaternary: '#d0d0d0',
    neutralQuaternaryAlt: '#dadada',
    neutralLight: '#eaeaea',
    neutralLighter: '#f4f4f4',
    neutralLighterAlt: '#f8f8f8',
    accent: '#0078d4',
    white: '#ffffff',
    whiteTranslucent40: 'rgba(255,255,255,.4)',
    yellowDark: '#d29200',
    yellow: '#ffb900',
    yellowLight: '#fff100',
    orange: '#d83b01',
    orangeLight: '#ea4300',
    orangeLighter: '#ff8c00',
    redDark: '#a80000',
    red: '#e81123',
    magentaDark: '#5c005c',
    magenta: '#b4009e',
    magentaLight: '#e3008c',
    purpleDark: '#32145a',
    purple: '#5c2d91',
    purpleLight: '#b4a0ff',
    blueDark: '#002050',
    blueMid: '#00188f',
    blue: '#0078d4',
    blueLight: '#00bcf2',
    tealDark: '#004b50',
    teal: '#008272',
    tealLight: '#00b294',
    greenDark: '#004b1c',
    green: '#107c10',
    greenLight: '#bad80a'
};
//# sourceMappingURL=DefaultPalette.js.map

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DefaultFontStyles; });
/* unused harmony export registerDefaultFontFaces */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uifabric_merge_styles__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fonts__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__uifabric_utilities__ = __webpack_require__(61);



// Default urls.
var DefaultBaseUrl = 'https://static2.sharepointonline.com/files/fabric/assets';
// Standard font styling.
var DefaultFontStyles = Object(__WEBPACK_IMPORTED_MODULE_1__fonts__["f" /* createFontStyles */])(Object(__WEBPACK_IMPORTED_MODULE_2__uifabric_utilities__["W" /* getLanguage */])());
function _registerFontFace(fontFamily, url, fontWeight, localFontName) {
    fontFamily = "'" + fontFamily + "'";
    var localFontSrc = localFontName !== undefined ? "local('" + localFontName + "')," : '';
    Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_merge_styles__["c" /* fontFace */])({
        fontFamily: fontFamily,
        src: localFontSrc + ("url('" + url + ".woff2') format('woff2'),") + ("url('" + url + ".woff') format('woff')"),
        fontWeight: fontWeight,
        fontStyle: 'normal'
    });
}
function _registerFontFaceSet(baseUrl, fontFamily, cdnFolder, cdnFontName, localFontName) {
    if (cdnFontName === void 0) { cdnFontName = 'segoeui'; }
    var urlBase = baseUrl + "/" + cdnFolder + "/" + cdnFontName;
    _registerFontFace(fontFamily, urlBase + '-light', __WEBPACK_IMPORTED_MODULE_1__fonts__["b" /* FontWeights */].light, localFontName && localFontName + ' Light');
    _registerFontFace(fontFamily, urlBase + '-semilight', __WEBPACK_IMPORTED_MODULE_1__fonts__["b" /* FontWeights */].semilight, localFontName && localFontName + ' SemiLight');
    _registerFontFace(fontFamily, urlBase + '-regular', __WEBPACK_IMPORTED_MODULE_1__fonts__["b" /* FontWeights */].regular, localFontName);
    _registerFontFace(fontFamily, urlBase + '-semibold', __WEBPACK_IMPORTED_MODULE_1__fonts__["b" /* FontWeights */].semibold, localFontName && localFontName + ' SemiBold');
}
function registerDefaultFontFaces(baseUrl) {
    if (baseUrl) {
        var fontUrl = baseUrl + "/fonts";
        // Produce @font-face definitions for all supported web fonts.
        _registerFontFaceSet(fontUrl, __WEBPACK_IMPORTED_MODULE_1__fonts__["e" /* LocalizedFontNames */].Thai, 'leelawadeeui-thai', 'leelawadeeui');
        _registerFontFaceSet(fontUrl, __WEBPACK_IMPORTED_MODULE_1__fonts__["e" /* LocalizedFontNames */].Arabic, 'segoeui-arabic');
        _registerFontFaceSet(fontUrl, __WEBPACK_IMPORTED_MODULE_1__fonts__["e" /* LocalizedFontNames */].Cyrillic, 'segoeui-cyrillic');
        _registerFontFaceSet(fontUrl, __WEBPACK_IMPORTED_MODULE_1__fonts__["e" /* LocalizedFontNames */].EastEuropean, 'segoeui-easteuropean');
        _registerFontFaceSet(fontUrl, __WEBPACK_IMPORTED_MODULE_1__fonts__["e" /* LocalizedFontNames */].Greek, 'segoeui-greek');
        _registerFontFaceSet(fontUrl, __WEBPACK_IMPORTED_MODULE_1__fonts__["e" /* LocalizedFontNames */].Hebrew, 'segoeui-hebrew');
        _registerFontFaceSet(fontUrl, __WEBPACK_IMPORTED_MODULE_1__fonts__["e" /* LocalizedFontNames */].Vietnamese, 'segoeui-vietnamese');
        _registerFontFaceSet(fontUrl, __WEBPACK_IMPORTED_MODULE_1__fonts__["e" /* LocalizedFontNames */].WestEuropean, 'segoeui-westeuropean', 'segoeui', 'Segoe UI');
        _registerFontFaceSet(fontUrl, __WEBPACK_IMPORTED_MODULE_1__fonts__["d" /* LocalizedFontFamilies */].Selawik, 'selawik', 'selawik');
        // Leelawadee UI (Thai) does not have a 'light' weight, so we override
        // the font-face generated above to use the 'semilight' weight instead.
        _registerFontFace('Leelawadee UI Web', fontUrl + "/leelawadeeui-thai/leelawadeeui-semilight", __WEBPACK_IMPORTED_MODULE_1__fonts__["b" /* FontWeights */].light);
        // Leelawadee UI (Thai) does not have a 'semibold' weight, so we override
        // the font-face generated above to use the 'bold' weight instead.
        _registerFontFace('Leelawadee UI Web', fontUrl + "/leelawadeeui-thai/leelawadeeui-bold", __WEBPACK_IMPORTED_MODULE_1__fonts__["b" /* FontWeights */].semibold);
    }
}
/**
 * Reads the fontBaseUrl from window.FabricConfig.fontBaseUrl or falls back to a default.
 */
function _getFontBaseUrl() {
    var win = Object(__WEBPACK_IMPORTED_MODULE_2__uifabric_utilities__["_7" /* getWindow */])();
    // tslint:disable-next-line:no-string-literal no-any
    var fabricConfig = win ? win['FabricConfig'] : undefined;
    return fabricConfig && fabricConfig.fontBaseUrl !== undefined ? fabricConfig.fontBaseUrl : DefaultBaseUrl;
}
/**
 * Register the font faces.
 */
registerDefaultFontFaces(_getFontBaseUrl());
//# sourceMappingURL=DefaultFontStyles.js.map

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warn;
function warn(s) {
  console.warn('[react-ga]', s);
}

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export prepareConfig */
/* unused harmony export getSaleCountry */
/* harmony export (immutable) */ __webpack_exports__["b"] = prepareTenantConfig;
/* harmony export (immutable) */ __webpack_exports__["c"] = prepareUserConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = prepareSaleConfig;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_lodash__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_lodash__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var instanceConfig=__webpack_require__(104).default;function prepareConfig(config,sale_country){if(!sale_country||!config.saleCountryOverride||typeof config.saleCountryOverride[sale_country]==='undefined')return config;return Object.assign({},config,config.saleCountryOverride[sale_country]);}function getSaleCountry(tenantData,userClaims,sale){var saleOfferData=// can be both salestore and saleeditstore
(!!sale&&!!sale.saleEdit?sale.saleEdit.offerData:(sale||{}).offerData)||{};return saleOfferData.sale_country||(userClaims||{}).sale_country||(tenantData||{}).sale_country;}// runtimeConfig - from sales process dashboard endpoint
// instanceConfig - from src/@tenant/config.js - supports sale_country from user management
// tenantConfig - from user management
function prepareTenantConfig(runtimeConfig,tenantData){var saleCountry=getSaleCountry(tenantData);var _instanceConfig$saleC=instanceConfig.saleCountryOverride,saleCountryOverride=_instanceConfig$saleC===undefined?{}:_instanceConfig$saleC,generalInstanceConfig=_objectWithoutProperties(instanceConfig,['saleCountryOverride']);return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_lodash___default.a.merge({},generalInstanceConfig,saleCountryOverride[saleCountry||'de'],runtimeConfig,(tenantData||{}).dashboard,{features:(tenantData||{}).features});}// runtimeConfig - from sales process dashboard endpoint
// instanceConfig - from src/@tenant/config.js - supports sale_country from user management
// tenantConfig - from user management
function prepareUserConfig(runtimeConfig,tenantData,userClaims){var saleCountry=getSaleCountry(tenantData,userClaims);var _instanceConfig$saleC2=instanceConfig.saleCountryOverride,saleCountryOverride=_instanceConfig$saleC2===undefined?{}:_instanceConfig$saleC2,generalInstanceConfig=_objectWithoutProperties(instanceConfig,['saleCountryOverride']);return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_lodash___default.a.merge({},generalInstanceConfig,saleCountryOverride[saleCountry||'de'],runtimeConfig,(tenantData||{}).dashboard,{features:(tenantData||{}).features});}function prepareSaleConfig(runtimeConfig,tenantData,userClaims,sale){var saleCountry=getSaleCountry(tenantData,userClaims,sale);var _instanceConfig$saleC3=instanceConfig.saleCountryOverride,saleCountryOverride=_instanceConfig$saleC3===undefined?{}:_instanceConfig$saleC3,generalInstanceConfig=_objectWithoutProperties(instanceConfig,['saleCountryOverride']);return Object.assign({},generalInstanceConfig,saleCountryOverride[saleCountry||'de']||{},runtimeConfig,(tenantData||{}).dashboard||{},{features:(sale||{}).features});}

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "theme", function() { return theme; });
var theme={palette:{themePrimary:'#262262',themeDarkAlt:'#262262',themeSecondary:'#FFFFFF',alert:'#dc1c2e'},fonts:{tiny:{fontSize:'10px'},xSmall:{fontSize:'11px'},small:{fontSize:'12px'},smallPlus:{fontSize:'14px'},medium:{fontSize:'16px'},mediumPlus:{fontSize:'18px'},large:{fontSize:'20px'},xLarge:{fontSize:'22px'}// xxLarge:        { fontSize: '28px' },
// superLarge:     { fontSize: '42px' },
// mega:           { fontSize: '64px' },
},logo_url:'https://res.cloudinary.com/auctiontech/image/upload/v1631026259/dav/assets/propnow.png',favicon_url:'https://res.cloudinary.com/auctiontech/image/upload/v1699285967/dav/assets/propnow-favicon.png'};

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WebStorage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__storage__ = __webpack_require__(1657);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var WebStorage=function(){function WebStorage(){var _this=this;var _ref=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{},_ref$prefix=_ref.prefix,prefix=_ref$prefix===undefined?'remax.'+window.location.hostname+'.':_ref$prefix,_ref$webstorage=_ref.webstorage,webstorage=_ref$webstorage===undefined?__WEBPACK_IMPORTED_MODULE_0__storage__["a" /* storage */]:_ref$webstorage;_classCallCheck(this,WebStorage);this.keyGen=function(key){return _this.prefix+key;};this.storage=webstorage;this.prefix=prefix;}_createClass(WebStorage,[{key:'set',value:function set(key,value){key=this.keyGen(key);this.storage.setItem(key,value);return Promise.resolve();}},{key:'get',value:function get(key){key=this.keyGen(key);var item=this.storage.getItem(key);return Promise.resolve(item);}},{key:'remove',value:function remove(key){key=this.keyGen(key);var item=this.storage.getItem(key);this.storage.removeItem(key);return Promise.resolve(item);}}]);return WebStorage;}();

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ListingsStore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_stores_UserStore__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_request__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_dec2,_desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4;function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var byDefaultDoNothing=function byDefaultDoNothing(){};var overviewColumns=function overviewColumns(t){var onClick=arguments.length>1&&arguments[1]!==undefined?arguments[1]:byDefaultDoNothing;return[{key:'itemNumber',name:t('Number'),fieldName:'itemNumber',minWidth:50,maxWidth:130,onColumnClick:onClick,isSorted:false,isSortedDescending:false,isResizable:true},{key:'title',name:t('Title'),fieldName:'title',minWidth:200,maxWidth:450,onColumnClick:onClick,isSorted:false,isSortedDescending:false,isResizable:true},{key:'status',name:t('Status'),fieldName:'status',minWidth:200,maxWidth:300,isSorted:false,isSortedDescending:false,isResizable:true},{key:'agentName',name:t('Agent'),fieldName:'agentName',minWidth:100,maxWidth:200,onColumnClick:onClick,isSorted:false,isSortedDescending:false,isResizable:true},{key:'startAt',name:t('Start date'),fieldName:'startAt',minWidth:100,maxWidth:150,onColumnClick:onClick,isSorted:true,isSortedDescending:true,isResizable:true},{key:'pendingOffersCount',name:t('Pending offers'),fieldName:'pendingOffersCount',minWidth:90,maxWidth:90,onColumnClick:onClick,isSorted:false,isSortedDescending:false,isResizable:true}];};var ListingsStore=(_dec=__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["c" /* action */].bound,_dec2=__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["c" /* action */].bound,(_class=function(){function ListingsStore(user){_classCallCheck(this,ListingsStore);_initDefineProp(this,'items',_descriptor,this);_initDefineProp(this,'columns',_descriptor2,this);_initDefineProp(this,'fetching',_descriptor3,this);_initDefineProp(this,'loaded',_descriptor4,this);this.user=user;}_createClass(ListingsStore,[{key:'sortBy',value:function sortBy(field){var index=this.columns.findIndex(function(c){return c.key===field;});var column=this.columns[index];this.items=this.items.sortBy(field,column.isSortedDescending);this.columns=this.columns.map(function(c,i){if(i!==index){c.isSorted=false;c.isSortedDescending=false;}else{c.isSorted=true;c.isSortedDescending=!c.isSortedDescending;}return c;});}},{key:'load',value:function load(){this.fetching=true;Object(__WEBPACK_IMPORTED_MODULE_2__services_request__["d" /* get */])('/api/v1/sales',this.user.accessToken).then(this.loadListingsOverviewSuccess,this.loadListingsOverviewError);}},{key:'initColumns',value:function initColumns(t,onClick){this.columns=overviewColumns(t,onClick);}},{key:'loadListingsOverviewSuccess',value:function loadListingsOverviewSuccess(data){this.items=data.objects.sortBy('startAt',false);this.fetching=false;this.loaded=true;}},{key:'loadListingsOverviewError',value:function loadListingsOverviewError(error){this.fetching=false;}}]);return ListingsStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'items',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'columns',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'fetching',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'loaded',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_applyDecoratedDescriptor(_class.prototype,'sortBy',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'sortBy'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'load',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'load'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'initColumns',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'initColumns'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'loadListingsOverviewSuccess',[_dec],Object.getOwnPropertyDescriptor(_class.prototype,'loadListingsOverviewSuccess'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'loadListingsOverviewError',[_dec2],Object.getOwnPropertyDescriptor(_class.prototype,'loadListingsOverviewError'),_class.prototype)),_class));var listings=new ListingsStore(__WEBPACK_IMPORTED_MODULE_1__App_stores_UserStore__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (listings);

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(1664)
var ieee754 = __webpack_require__(1665)
var isArray = __webpack_require__(661)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)))

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MessageType; });
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
/** Defines the type of a Hub Message. */
var MessageType;
(function (MessageType) {
    /** Indicates the message is an Invocation message and implements the {@link @microsoft/signalr.InvocationMessage} interface. */
    MessageType[MessageType["Invocation"] = 1] = "Invocation";
    /** Indicates the message is a StreamItem message and implements the {@link @microsoft/signalr.StreamItemMessage} interface. */
    MessageType[MessageType["StreamItem"] = 2] = "StreamItem";
    /** Indicates the message is a Completion message and implements the {@link @microsoft/signalr.CompletionMessage} interface. */
    MessageType[MessageType["Completion"] = 3] = "Completion";
    /** Indicates the message is a Stream Invocation message and implements the {@link @microsoft/signalr.StreamInvocationMessage} interface. */
    MessageType[MessageType["StreamInvocation"] = 4] = "StreamInvocation";
    /** Indicates the message is a Cancel Invocation message and implements the {@link @microsoft/signalr.CancelInvocationMessage} interface. */
    MessageType[MessageType["CancelInvocation"] = 5] = "CancelInvocation";
    /** Indicates the message is a Ping message and implements the {@link @microsoft/signalr.PingMessage} interface. */
    MessageType[MessageType["Ping"] = 6] = "Ping";
    /** Indicates the message is a Close message and implements the {@link @microsoft/signalr.CloseMessage} interface. */
    MessageType[MessageType["Close"] = 7] = "Close";
})(MessageType || (MessageType = {}));
//# sourceMappingURL=IHubProtocol.js.map

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Image; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Image_base__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Image_styles__ = __webpack_require__(1692);



var Image = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__Image_base__["a" /* ImageBase */], __WEBPACK_IMPORTED_MODULE_2__Image_styles__["a" /* getStyles */], undefined, {
    scope: 'Image'
}, true);
//# sourceMappingURL=Image.js.map

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ImageFit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageCoverStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ImageLoadState; });
/**
 * The possible methods that can be used to fit the image.
 * {@docCategory Image}
 */
var ImageFit;
(function (ImageFit) {
    /**
     * The image is not scaled. The image is centered and cropped within the content box.
     */
    ImageFit[ImageFit["center"] = 0] = "center";
    /**
     * The image is scaled to maintain its aspect ratio while being fully contained within the frame. The image will
     * be centered horizontally and vertically within the frame. The space in the top and bottom or in the sides of
     * the frame will be empty depending on the difference in aspect ratio between the image and the frame.
     */
    ImageFit[ImageFit["contain"] = 1] = "contain";
    /**
     * The image is scaled to maintain its aspect ratio while filling the frame. Portions of the image will be cropped from
     * the top and bottom, or from the sides, depending on the difference in aspect ratio between the image and the frame.
     */
    ImageFit[ImageFit["cover"] = 2] = "cover";
    /**
     * Neither the image nor the frame are scaled. If their sizes do not match, the image will either be cropped or the
     * frame will have empty space.
     */
    ImageFit[ImageFit["none"] = 3] = "none";
    /**
     * The image will be centered horizontally and vertically within the frame and maintains its aspect ratio. It will
     * behave as ImageFit.center if the image's natural height or width is less than the Image frame's height or width,
     * but if both natural height and width are larger than the frame it will behave as ImageFit.cover.
     */
    ImageFit[ImageFit["centerCover"] = 4] = "centerCover";
    /**
     * The image will be centered horizontally and vertically within the frame and maintains its aspect ratio. It will
     * behave as ImageFit.center if the image's natural height and width is less than the Image frame's height and width,
     * but if either natural height or width are larger than the frame it will behave as ImageFit.contain.
     */
    ImageFit[ImageFit["centerContain"] = 5] = "centerContain";
})(ImageFit || (ImageFit = {}));
/**
 * The cover style to be used on the image
 * {@docCategory Image}
 */
var ImageCoverStyle;
(function (ImageCoverStyle) {
    /**
     * The image will be shown at 100% height of container and the width will be scaled accordingly
     */
    ImageCoverStyle[ImageCoverStyle["landscape"] = 0] = "landscape";
    /**
     * The image will be shown at 100% width of container and the height will be scaled accordingly
     */
    ImageCoverStyle[ImageCoverStyle["portrait"] = 1] = "portrait";
})(ImageCoverStyle || (ImageCoverStyle = {}));
/**
 * {@docCategory Image}
 */
var ImageLoadState;
(function (ImageLoadState) {
    /**
     * The image has not yet been loaded, and there is no error yet.
     */
    ImageLoadState[ImageLoadState["notLoaded"] = 0] = "notLoaded";
    /**
     * The image has been loaded successfully.
     */
    ImageLoadState[ImageLoadState["loaded"] = 1] = "loaded";
    /**
     * An error has been encountered while loading the image.
     */
    ImageLoadState[ImageLoadState["error"] = 2] = "error";
    /**
     * Deprecated at v1.3.6, to replace the src in case of errors, use `onLoadingStateChange` instead
     * and rerender the Image with a difference src.
     * @deprecated Use `onLoadingStateChange` instead
     * and rerender the Image with a difference src.
     */
    ImageLoadState[ImageLoadState["errorLoaded"] = 3] = "errorLoaded";
})(ImageLoadState || (ImageLoadState = {}));
//# sourceMappingURL=Image.types.js.map

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return classNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MS_ICON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

/** Class names used in themeable and non-themeable Icon components */
var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["E" /* mergeStyleSets */])({
    root: {
        display: 'inline-block'
    },
    placeholder: [
        'ms-Icon-placeHolder',
        {
            width: '1em'
        }
    ],
    image: [
        'ms-Icon-imageContainer',
        {
            overflow: 'hidden'
        }
    ]
});
/** Class name used only in non-themeable Icon components */
var MS_ICON = 'ms-Icon';
var getStyles = function (props) {
    var className = props.className, iconClassName = props.iconClassName, isPlaceholder = props.isPlaceholder, isImage = props.isImage, styles = props.styles;
    return {
        root: [
            isPlaceholder && classNames.placeholder,
            classNames.root,
            isImage && classNames.image,
            iconClassName,
            className,
            styles && styles.root,
            styles && styles.imageContainer
        ]
    };
};
//# sourceMappingURL=Icon.styles.js.map

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Fabric_index__ = __webpack_require__(1696);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Fabric_index__["a"]; });

//# sourceMappingURL=Fabric.js.map

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Check_index__ = __webpack_require__(1706);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Check_index__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Check_index__["b"]; });

//# sourceMappingURL=Check.js.map

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CheckGlobalClassNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utilities__ = __webpack_require__(1);


var CheckGlobalClassNames = {
    root: 'ms-Check',
    circle: 'ms-Check-circle',
    check: 'ms-Check-check',
    /** Must be manually applied to the parent element of the check. */
    checkHost: 'ms-Check-checkHost'
};
var getStyles = function (props) {
    var _a = props.checkBoxHeight, checkBoxHeight = _a === void 0 ? '18px' : _a, checked = props.checked, useGlobalCheckHostClass = props.useGlobalCheckHostClass, className = props.className, theme = props.theme;
    var palette = theme.palette, semanticColors = theme.semanticColors;
    var isRTL = Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["V" /* getRTL */])();
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(CheckGlobalClassNames, theme);
    var sharedCircleCheck = {
        fontSize: checkBoxHeight,
        position: 'absolute',
        left: 0,
        top: 0,
        width: checkBoxHeight,
        height: checkBoxHeight,
        textAlign: 'center',
        verticalAlign: 'middle'
    };
    var checkHostClass = useGlobalCheckHostClass ? CheckGlobalClassNames.checkHost : '$checkHost';
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            {
                // lineHeight currently needs to be a string to output without 'px'
                lineHeight: '1',
                width: checkBoxHeight,
                height: checkBoxHeight,
                verticalAlign: 'top',
                position: 'relative',
                userSelect: 'none',
                selectors: (_b = {
                        ':before': {
                            content: '""',
                            position: 'absolute',
                            top: '1px',
                            right: '1px',
                            bottom: '1px',
                            left: '1px',
                            borderRadius: '50%',
                            opacity: 1,
                            background: semanticColors.bodyBackground
                        }
                    },
                    _b["." + checkHostClass + ":hover &, ." + checkHostClass + ":focus &, &:hover, &:focus"] = {
                        opacity: 1
                    },
                    _b)
            },
            checked && [
                'is-checked',
                {
                    selectors: {
                        ':before': {
                            background: palette.themePrimary,
                            opacity: 1,
                            selectors: (_c = {},
                                _c[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                                    background: 'Window'
                                },
                                _c)
                        }
                    }
                }
            ],
            className
        ],
        circle: [
            classNames.circle,
            sharedCircleCheck,
            {
                color: palette.neutralTertiaryAlt,
                selectors: (_d = {},
                    _d[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        color: 'WindowText'
                    },
                    _d)
            },
            checked && {
                color: palette.white
            }
        ],
        check: [
            classNames.check,
            sharedCircleCheck,
            {
                opacity: 0,
                color: palette.neutralTertiaryAlt,
                fontSize: '16px',
                left: isRTL ? '-0.5px' : '.5px',
                selectors: (_e = {
                        ':hover': {
                            opacity: 1
                        }
                    },
                    _e[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        MsHighContrastAdjust: 'none'
                    },
                    _e)
            },
            checked && {
                opacity: 1,
                color: palette.white,
                fontWeight: 900,
                selectors: (_f = {},
                    _f[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        border: 'none',
                        color: 'WindowText'
                    },
                    _f)
            }
        ],
        checkHost: [{}]
    };
    var _b, _c, _d, _e, _f;
};
//# sourceMappingURL=Check.styles.js.map

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SpinnerSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SpinnerType; });
/**
 * Possible variations of the spinner circle size.
 * {@docCategory Spinner}
 */
var SpinnerSize;
(function (SpinnerSize) {
    /**
     * 12px Spinner diameter
     */
    SpinnerSize[SpinnerSize["xSmall"] = 0] = "xSmall";
    /**
     * 16px Spinner diameter
     */
    SpinnerSize[SpinnerSize["small"] = 1] = "small";
    /**
     * 20px Spinner diameter
     */
    SpinnerSize[SpinnerSize["medium"] = 2] = "medium";
    /**
     * 28px Spinner diameter
     */
    SpinnerSize[SpinnerSize["large"] = 3] = "large";
})(SpinnerSize || (SpinnerSize = {}));
/**
 * Deprecated at v2.0.0, use `SpinnerSize` instead.
 * @deprecated Use `SpinnerSize` instead.
 * {@docCategory Spinner}
 */
var SpinnerType;
(function (SpinnerType) {
    /**
     * Deprecated and will be removed at \>= 2.0.0. Use `SpinnerSize.medium` instead.
     * @deprecated Use `SpinnerSize.medium` instead.
     */
    SpinnerType[SpinnerType["normal"] = 0] = "normal";
    /**
     * Deprecated and will be removed at \>= 2.0.0. Use `SpinnerSize.large` instead.
     * @deprecated Use `SpinnerSize.large` instead.
     */
    SpinnerType[SpinnerType["large"] = 1] = "large";
})(SpinnerType || (SpinnerType = {}));
//# sourceMappingURL=Spinner.types.js.map

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KeytipManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_keytips_KeytipConstants__ = __webpack_require__(268);



/**
 * This class is responsible for handling registering, updating, and unregistering of keytips
 */
var KeytipManager = /** @class */ (function () {
    function KeytipManager() {
        this.keytips = [];
        this.persistedKeytips = [];
        // This is (and should be) updated and kept in sync
        // with the inKeytipMode in KeytipLayer.
        this.inKeytipMode = false;
        // Boolean that gets checked before entering keytip mode by the KeytipLayer
        // Used for an override in special cases (e.g. Disable entering keytip mode when a modal is shown)
        this.shouldEnterKeytipMode = true;
    }
    /**
     * Static function to get singleton KeytipManager instance
     *
     * @returns {KeytipManager} Singleton KeytipManager instance
     */
    KeytipManager.getInstance = function () {
        return this._instance;
    };
    /**
     * Registers a keytip
     *
     * @param keytipProps - Keytip to register
     * @param persisted - T/F if this keytip should be persisted, default is false
     * @returns {string} Unique ID for this keytip
     */
    KeytipManager.prototype.register = function (keytipProps, persisted) {
        if (persisted === void 0) { persisted = false; }
        var props = keytipProps;
        if (!persisted) {
            // Add the overflowSetSequence if necessary
            props = this.addParentOverflow(keytipProps);
        }
        // Create a unique keytip
        var uniqueKeytip = this._getUniqueKtp(props);
        // Add to array
        persisted ? this.persistedKeytips.push(uniqueKeytip) : this.keytips.push(uniqueKeytip);
        var event = persisted ? __WEBPACK_IMPORTED_MODULE_2__utilities_keytips_KeytipConstants__["g" /* KeytipEvents */].PERSISTED_KEYTIP_ADDED : __WEBPACK_IMPORTED_MODULE_2__utilities_keytips_KeytipConstants__["g" /* KeytipEvents */].KEYTIP_ADDED;
        __WEBPACK_IMPORTED_MODULE_1__Utilities__["e" /* EventGroup */].raise(this, event, {
            keytip: props,
            uniqueID: uniqueKeytip.uniqueID
        });
        return uniqueKeytip.uniqueID;
    };
    /**
     * Update a keytip
     *
     * @param keytipProps - Keytip to update
     * @param uniqueID - Unique ID of this keytip
     */
    KeytipManager.prototype.update = function (keytipProps, uniqueID) {
        var newKeytipProps = this.addParentOverflow(keytipProps);
        var uniqueKeytip = this._getUniqueKtp(newKeytipProps, uniqueID);
        var keytipIndex = Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["C" /* findIndex */])(this.keytips, function (ktp) {
            return ktp.uniqueID === uniqueID;
        });
        if (keytipIndex >= 0) {
            // Update everything except 'visible'
            uniqueKeytip.keytip.visible = this.keytips[keytipIndex].keytip.visible;
            // Update keytip in this.keytips
            this.keytips = Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["_23" /* replaceElement */])(this.keytips, uniqueKeytip, keytipIndex);
            // Raise event
            __WEBPACK_IMPORTED_MODULE_1__Utilities__["e" /* EventGroup */].raise(this, __WEBPACK_IMPORTED_MODULE_2__utilities_keytips_KeytipConstants__["g" /* KeytipEvents */].KEYTIP_UPDATED, {
                keytip: uniqueKeytip.keytip,
                uniqueID: uniqueKeytip.uniqueID
            });
        }
    };
    /**
     * Unregisters a keytip
     *
     * @param keytipToRemove - IKeytipProps of the keytip to remove
     * @param uniqueID - Unique ID of this keytip
     * @param persisted - T/F if this keytip should be persisted, default is false
     */
    KeytipManager.prototype.unregister = function (keytipToRemove, uniqueID, persisted) {
        if (persisted === void 0) { persisted = false; }
        if (persisted) {
            // Remove keytip from this.persistedKeytips
            this.persistedKeytips = this.persistedKeytips.filter(function (uniqueKtp) {
                return uniqueKtp.uniqueID !== uniqueID;
            });
        }
        else {
            // Remove keytip from this.keytips
            this.keytips = this.keytips.filter(function (uniqueKtp) {
                return uniqueKtp.uniqueID !== uniqueID;
            });
        }
        var event = persisted ? __WEBPACK_IMPORTED_MODULE_2__utilities_keytips_KeytipConstants__["g" /* KeytipEvents */].PERSISTED_KEYTIP_REMOVED : __WEBPACK_IMPORTED_MODULE_2__utilities_keytips_KeytipConstants__["g" /* KeytipEvents */].KEYTIP_REMOVED;
        __WEBPACK_IMPORTED_MODULE_1__Utilities__["e" /* EventGroup */].raise(this, event, {
            keytip: keytipToRemove,
            uniqueID: uniqueID
        });
    };
    /**
     * Manual call to enter keytip mode
     */
    KeytipManager.prototype.enterKeytipMode = function () {
        __WEBPACK_IMPORTED_MODULE_1__Utilities__["e" /* EventGroup */].raise(this, __WEBPACK_IMPORTED_MODULE_2__utilities_keytips_KeytipConstants__["g" /* KeytipEvents */].ENTER_KEYTIP_MODE);
    };
    /**
     * Manual call to exit keytip mode
     */
    KeytipManager.prototype.exitKeytipMode = function () {
        __WEBPACK_IMPORTED_MODULE_1__Utilities__["e" /* EventGroup */].raise(this, __WEBPACK_IMPORTED_MODULE_2__utilities_keytips_KeytipConstants__["g" /* KeytipEvents */].EXIT_KEYTIP_MODE);
    };
    /**
     * Gets all IKeytipProps from this.keytips
     *
     * @returns {IKeytipProps[]} All keytips stored in the manager
     */
    KeytipManager.prototype.getKeytips = function () {
        return this.keytips.map(function (uniqueKeytip) {
            return uniqueKeytip.keytip;
        });
    };
    /**
     * Adds the overflowSetSequence to the keytipProps if its parent keytip also has it
     *
     * @param keytipProps - Keytip props to add overflowSetSequence to if necessary
     * @returns {IKeytipProps} - Modified keytip props, if needed to be modified
     */
    KeytipManager.prototype.addParentOverflow = function (keytipProps) {
        var fullSequence = keytipProps.keySequences.slice();
        fullSequence.pop();
        if (fullSequence.length !== 0) {
            var parentKeytip = Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["A" /* find */])(this.getKeytips(), function (keytip) {
                return Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["l" /* arraysEqual */])(fullSequence, keytip.keySequences);
            });
            if (parentKeytip && parentKeytip.overflowSetSequence) {
                return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, keytipProps, { overflowSetSequence: parentKeytip.overflowSetSequence });
            }
        }
        return keytipProps;
    };
    /**
     * Public function to bind for overflow items that have a submenu
     *
     * @param overflowButtonSequences
     * @param keytipSequences
     */
    KeytipManager.prototype.menuExecute = function (overflowButtonSequences, keytipSequences) {
        __WEBPACK_IMPORTED_MODULE_1__Utilities__["e" /* EventGroup */].raise(this, __WEBPACK_IMPORTED_MODULE_2__utilities_keytips_KeytipConstants__["g" /* KeytipEvents */].PERSISTED_KEYTIP_EXECUTE, {
            overflowButtonSequences: overflowButtonSequences,
            keytipSequences: keytipSequences
        });
    };
    /**
     * Creates an IUniqueKeytip object
     *
     * @param keytipProps - IKeytipProps
     * @param uniqueID - Unique ID, will default to the next unique ID if not passed
     * @returns {IUniqueKeytip} IUniqueKeytip object
     */
    KeytipManager.prototype._getUniqueKtp = function (keytipProps, uniqueID) {
        if (uniqueID === void 0) { uniqueID = Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["N" /* getId */])(); }
        return { keytip: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, keytipProps), uniqueID: uniqueID };
    };
    KeytipManager._instance = new KeytipManager();
    return KeytipManager;
}());

//# sourceMappingURL=KeytipManager.js.map

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DetailsRowCheck; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Check__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Check_Check_styles__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DetailsRowCheck_styles__ = __webpack_require__(1722);






var getCheckClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])({
    disableCaching: true
});
var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])({
    disableCaching: true
});
var DetailsRowCheckBase = function (props) {
    var _a = props.isVisible, isVisible = _a === void 0 ? false : _a, _b = props.canSelect, canSelect = _b === void 0 ? false : _b, _c = props.isSelected, isSelected = _c === void 0 ? false : _c, _d = props.anySelected, anySelected = _d === void 0 ? false : _d, _e = props.selected, selected = _e === void 0 ? false : _e, _f = props.isHeader, isHeader = _f === void 0 ? false : _f, className = props.className, checkClassName = props.checkClassName, styles = props.styles, theme = props.theme, compact = props.compact, onRenderDetailsCheckbox = props.onRenderDetailsCheckbox, useFastIcons = props.useFastIcons, // must be removed from buttonProps
    buttonProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __rest */](props, ["isVisible", "canSelect", "isSelected", "anySelected", "selected", "isHeader", "className", "checkClassName", "styles", "theme", "compact", "onRenderDetailsCheckbox", "useFastIcons"]);
    var defaultCheckboxRender = useFastIcons ? _fastDefaultCheckboxRender : _defaultCheckboxRender;
    var onRenderCheckbox = onRenderDetailsCheckbox || defaultCheckboxRender;
    var isPressed = isSelected || selected;
    var checkStyles = useFastIcons ? undefined : Object(__WEBPACK_IMPORTED_MODULE_4__Check_Check_styles__["b" /* getStyles */])({ theme: theme });
    var checkClassNames = useFastIcons
        ? undefined
        : getCheckClassNames(checkStyles, {
            theme: theme
        });
    var classNames = getClassNames(styles, {
        theme: theme,
        canSelect: canSelect,
        selected: isPressed,
        anySelected: anySelected,
        className: className,
        isHeader: isHeader,
        isVisible: isVisible,
        compact: compact,
        useGlobalCheckHostClass: useFastIcons
    });
    var detailsCheckboxProps = {
        checked: isPressed,
        theme: theme
    };
    return canSelect ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, buttonProps, { role: "checkbox", className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])(classNames.root, classNames.check, checkClassNames && checkClassNames.checkHost), "aria-checked": isPressed, "data-selection-toggle": true, "data-automationid": "DetailsRowCheck" }), onRenderCheckbox(detailsCheckboxProps, defaultCheckboxRender))) : (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, buttonProps, { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])(classNames.root, classNames.check) })));
};
function _defaultCheckboxRender(checkboxProps) {
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Check__["a" /* Check */], { checked: checkboxProps.checked });
}
function _fastDefaultCheckboxRender(checkboxProps) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__Check__["b" /* getCheck */])(checkboxProps.theme, checkboxProps.checked);
}
var DetailsRowCheck = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_29" /* styled */])(DetailsRowCheckBase, __WEBPACK_IMPORTED_MODULE_5__DetailsRowCheck_styles__["a" /* getStyles */], undefined, { scope: 'DetailsRowCheck' }, true);
//# sourceMappingURL=DetailsRowCheck.js.map

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HEADER_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCellStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DetailsRow_styles__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GroupedList_GroupSpacer__ = __webpack_require__(107);



// For every group level there is a GroupSpacer added. Importing this const to have the source value in one place.

var GlobalClassNames = {
    tooltipHost: 'ms-TooltipHost',
    root: 'ms-DetailsHeader',
    cell: 'ms-DetailsHeader-cell',
    cellIsCheck: 'ms-DetailsHeader-cellIsCheck',
    collapseButton: 'ms-DetailsHeader-collapseButton',
    isCollapsed: 'is-collapsed',
    isAllSelected: 'is-allSelected',
    isSelectAllHidden: 'is-selectAllHidden',
    isResizingColumn: 'is-resizingColumn',
    cellSizer: 'ms-DetailsHeader-cellSizer',
    isResizing: 'is-resizing',
    dropHintCircleStyle: 'ms-DetailsHeader-dropHintCircleStyle',
    dropHintCaretStyle: 'ms-DetailsHeader-dropHintCaretStyle',
    dropHintLineStyle: 'ms-DetailsHeader-dropHintLineStyle',
    cellTitle: 'ms-DetailsHeader-cellTitle',
    cellName: 'ms-DetailsHeader-cellName',
    filterChevron: 'ms-DetailsHeader-filterChevron',
    gripperBarVertical: 'ms-DetailsColumn-gripperBarVertical'
};
var HEADER_HEIGHT = 32;
var getCellStyles = function (props) {
    var theme = props.theme, _a = props.cellStyleProps, cellStyleProps = _a === void 0 ? __WEBPACK_IMPORTED_MODULE_2__DetailsRow_styles__["a" /* DEFAULT_CELL_STYLE_PROPS */] : _a;
    var semanticColors = theme.semanticColors;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    return [
        classNames.cell,
        Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["v" /* getFocusStyle */])(theme),
        {
            color: semanticColors.bodyText,
            position: 'relative',
            display: 'inline-block',
            boxSizing: 'border-box',
            padding: "0 " + cellStyleProps.cellRightPadding + "px 0 " + cellStyleProps.cellLeftPadding + "px",
            lineHeight: 'inherit',
            margin: '0',
            height: HEADER_HEIGHT,
            verticalAlign: 'top',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            textAlign: 'left'
        }
    ];
};
var getStyles = function (props) {
    var theme = props.theme, className = props.className, isSelectAllHidden = props.isSelectAllHidden, isAllSelected = props.isAllSelected, isResizingColumn = props.isResizingColumn, isSizing = props.isSizing, isAllCollapsed = props.isAllCollapsed, _a = props.cellStyleProps, cellStyleProps = _a === void 0 ? __WEBPACK_IMPORTED_MODULE_2__DetailsRow_styles__["a" /* DEFAULT_CELL_STYLE_PROPS */] : _a;
    var semanticColors = theme.semanticColors, palette = theme.palette;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    var colors = {
        iconForegroundColor: semanticColors.bodySubtext,
        headerForegroundColor: semanticColors.bodyText,
        headerBackgroundColor: semanticColors.bodyBackground,
        dropdownChevronForegroundColor: palette.neutralTertiary,
        resizerColor: palette.neutralTertiaryAlt
    };
    var cellSizerFadeInStyles = {
        opacity: 1,
        transition: 'opacity 0.3s linear'
    };
    var cellStyles = getCellStyles(props);
    return {
        root: [
            classNames.root,
            theme.fonts.small,
            {
                display: 'inline-block',
                background: colors.headerBackgroundColor,
                position: 'relative',
                minWidth: '100%',
                verticalAlign: 'top',
                height: HEADER_HEIGHT,
                lineHeight: HEADER_HEIGHT,
                whiteSpace: 'nowrap',
                boxSizing: 'content-box',
                paddingBottom: '1px',
                paddingTop: '16px',
                borderBottom: "1px solid " + semanticColors.bodyDivider,
                cursor: 'default',
                userSelect: 'none',
                selectors: (_b = {
                        '&:hover $check': {
                            opacity: 1
                        }
                    },
                    _b[classNames.tooltipHost + " $checkTooltip"] = {
                        display: 'block'
                    },
                    _b)
            },
            isAllSelected && classNames.isAllSelected,
            isSelectAllHidden && {
                selectors: {
                    $cell$cellIsCheck: {
                        visibility: 'hidden'
                    }
                }
            },
            isResizingColumn && classNames.isResizingColumn,
            className
        ],
        check: {
            height: HEADER_HEIGHT,
            selectors: (_c = {},
                _c["." + __WEBPACK_IMPORTED_MODULE_1__Utilities__["f" /* IsFocusVisibleClassName */] + " &:focus"] = {
                    opacity: 1
                },
                _c)
        },
        cellWrapperPadded: {
            paddingRight: cellStyleProps.cellExtraRightPadding + cellStyleProps.cellRightPadding
        },
        cellIsCheck: [
            cellStyles,
            classNames.cellIsCheck,
            {
                position: 'relative',
                padding: 0,
                margin: 0,
                display: 'inline-flex',
                alignItems: 'center',
                border: 'none'
            },
            isAllSelected && {
                opacity: 1
            }
        ],
        cellIsGroupExpander: [
            cellStyles,
            {
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].small,
                padding: 0,
                border: 'none',
                width: __WEBPACK_IMPORTED_MODULE_3__GroupedList_GroupSpacer__["b" /* SPACER_WIDTH */],
                color: palette.neutralSecondary,
                selectors: {
                    ':hover': {
                        backgroundColor: palette.neutralLighter
                    },
                    ':active': {
                        backgroundColor: palette.neutralLight
                    }
                }
            }
        ],
        cellIsActionable: {
            selectors: {
                ':hover': {
                    color: semanticColors.bodyText,
                    background: semanticColors.listHeaderBackgroundHovered
                },
                ':active': {
                    background: semanticColors.listHeaderBackgroundPressed
                }
            }
        },
        cellIsEmpty: {
            textOverflow: 'clip'
        },
        cellSizer: [
            classNames.cellSizer,
            Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["u" /* focusClear */])(),
            {
                display: 'inline-block',
                position: 'relative',
                cursor: 'ew-resize',
                bottom: 0,
                top: 0,
                overflow: 'hidden',
                height: 'inherit',
                background: 'transparent',
                zIndex: 1,
                width: 16,
                selectors: {
                    ':after': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        bottom: 0,
                        width: 1,
                        background: colors.resizerColor,
                        opacity: 0,
                        left: '50%'
                    },
                    ':focus:after': cellSizerFadeInStyles,
                    ':hover:after': cellSizerFadeInStyles,
                    '&$cellIsResizing:after': [
                        cellSizerFadeInStyles,
                        {
                            boxShadow: '0 0 5px 0 rgba(0, 0, 0, 0.4)'
                        }
                    ]
                }
            }
        ],
        cellIsResizing: classNames.isResizing,
        cellSizerStart: {
            margin: '0 -8px'
        },
        cellSizerEnd: {
            margin: 0,
            marginLeft: -16
        },
        collapseButton: [
            classNames.collapseButton,
            {
                transformOrigin: '50% 50%',
                transition: 'transform .1s linear'
            },
            isAllCollapsed
                ? [
                    classNames.isCollapsed,
                    {
                        transform: 'rotate(0deg)'
                    }
                ]
                : {
                    transform: 'rotate(90deg)'
                }
        ],
        checkTooltip: [],
        sizingOverlay: isSizing && {
            position: 'absolute',
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            cursor: 'ew-resize',
            background: 'rgba(255, 255, 255, 0)',
            selectors: (_d = {},
                _d[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                    background: 'transparent',
                    MsHighContrastAdjust: 'none'
                },
                _d)
        },
        accessibleLabel: __WEBPACK_IMPORTED_MODULE_0__Styling__["B" /* hiddenContentStyle */],
        dropHintCircleStyle: [
            classNames.dropHintCircleStyle,
            {
                display: 'inline-block',
                visibility: 'hidden',
                position: 'absolute',
                bottom: 0,
                height: 9,
                width: 9,
                borderRadius: '50%',
                marginLeft: -5,
                top: 34,
                overflow: 'visible',
                zIndex: 10,
                border: "1px solid " + palette.themePrimary,
                background: palette.white
            }
        ],
        dropHintCaretStyle: [
            classNames.dropHintCaretStyle,
            {
                display: 'none',
                position: 'absolute',
                top: -23,
                left: -6.5,
                fontSize: 14,
                color: palette.themePrimary,
                overflow: 'visible',
                zIndex: 10
            }
        ],
        dropHintLineStyle: [
            classNames.dropHintLineStyle,
            {
                display: 'none',
                position: 'absolute',
                bottom: 0,
                top: 0,
                overflow: 'hidden',
                height: 33,
                width: 1,
                background: palette.themePrimary,
                zIndex: 10
            }
        ],
        dropHintStyle: {
            display: 'inline-block',
            position: 'absolute'
        }
    };
    var _b, _c, _d;
};
//# sourceMappingURL=DetailsHeader.styles.js.map

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectAllVisibility; });
/**
 * {@docCategory DetailsList}
 */
var SelectAllVisibility;
(function (SelectAllVisibility) {
    SelectAllVisibility[SelectAllVisibility["none"] = 0] = "none";
    SelectAllVisibility[SelectAllVisibility["hidden"] = 1] = "hidden";
    SelectAllVisibility[SelectAllVisibility["visible"] = 2] = "visible";
})(SelectAllVisibility || (SelectAllVisibility = {}));
//# sourceMappingURL=DetailsHeader.types.js.map

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Dialog__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ToggleField__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RoundDurationEdit__ = __webpack_require__(1784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RoundPriceEdit__ = __webpack_require__(2087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RoundTypeSelector__ = __webpack_require__(2088);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2,_descriptor,_class3,_temp2;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var RoundEdit=(_dec=Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__["d" /* inject */])('app','sale'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_0__build_src_app_components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__["e" /* observer */])(_class=(_class2=(_temp2=_class3=function(_Component){_inherits(RoundEdit,_Component);function RoundEdit(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RoundEdit);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RoundEdit.__proto__||Object.getPrototypeOf(RoundEdit)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'openRoundWarning',_descriptor,_this),_this.handleToggleChanged=function(field){return function(_,value){var round=_this.props.store.round;round[field]=value;};},_this.handleSelect=function(type){var _this$props$store=_this.props.store,round=_this$props$store.round,defaultStartsAt=_this$props$store.defaultStartsAt,allowConditionsForRound=_this$props$store.allowConditionsForRound;round.type=type;round.durationType='fixed';round.startsAt=defaultStartsAt(type);round.allowConditions=allowConditionsForRound(type);switch(round.type){case'sealed_bidding':_this.openRoundWarning=false;break;case'open_bidding':case'incremental_auction':round.estimate='';round.redButtonPrice='';_this.openRoundWarning=true;break;default:round.startPrice='';round.estimate='';round.redButtonPrice='';round.biddingSteps='';_this.openRoundWarning=false;break;}},_this.renderWarning=function(){var t=_this.props.t;var close=function close(){return _this.openRoundWarning=false;};return __WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Dialog__["a" /* Dialog */],{hidden:false,onDismiss:close,dialogContentProps:{type:__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Dialog__["c" /* DialogType */].close},modalProps:{titleAriaId:'myLabelId',subtitleAriaId:'mySubTextId',isBlocking:true,containerClassName:'ms-dialogMainOverride'}},t('open round warning'),__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Dialog__["b" /* DialogFooter */],null,__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Button__["h" /* PrimaryButton */],{onClick:close,text:t('Ok')})));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RoundEdit,[{key:'componentDidMount',value:function componentDidMount(){var round=this.props.store.round;if(!this.eligibleRounds||this.eligibleRounds.length===1){// if there's only one eligible round, set it a as default value
round.type=this.eligibleRounds[0];}}},{key:'render',value:function render(){var _props=this.props,store=_props.store,round=_props.store.round,intl=_props.intl,t=_props.t,sale=_props.sale;var config=sale.saleConfig;var isSimpleOffer=round.type==='simple_offer';return __WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__RoundTypeSelector__["a" /* RoundTypeSelector */],{rounds:this.eligibleRounds.map(function(type){return{type:type,title:t('roundtype::'+type),description:t('roundtype::'+type+'_description'),selected:type===round.type};}),onSelect:this.handleSelect,disabled:!this.canChangeType}),round.type&&round.type!=='none'?__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__RoundDurationEdit__["a" /* default */],{store:store,intl:intl,t:t,canChangeDurationType:isSimpleOffer,hideValidity:config.roundHideValidity||round.type==='registration'}),store.showAllowConditionsToggle?__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement('div',{style:{marginTop:'0.5em'}},__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_ToggleField__["a" /* default */],{label:t('roundtype::allow_conditions'),tooltip:t('roundtype::allow_conditions_tooltip'),onChange:this.handleToggleChanged('allowConditions'),checked:round.allowConditions})):null,!isSimpleOffer&&config.roundShowInvitedCustomersCount?__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement('div',{style:{marginTop:'0.5em'}},__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_ToggleField__["a" /* default */],{label:t('roundtype::show_invited_customers_count'),tooltip:t('roundtype::show_invited_customers_count_tooltip'),onChange:this.handleToggleChanged('showInvitedCustomersCount'),checked:round.showInvitedCustomersCount})):null,isSimpleOffer||round.type==='registration'?null:__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__RoundPriceEdit__["a" /* default */],{store:store,intl:intl,t:t,overrideStartPrice:this.props.overrideStartPrice})):null);}},{key:'eligibleRounds',get:function get(){var _props2=this.props,store=_props2.store,allowedRounds=_props2.allowedRounds,disallowedRounds=_props2.disallowedRounds,sale=_props2.sale;var config=sale.saleConfig;var rounds=[].concat(_toConsumableArray(new Set(!!config.getRoundTypes?config.getRoundTypes(store):undefined||config.roundTypes.filter(function(r){return(!allowedRounds||allowedRounds.indexOf(r)>=0)&&(!disallowedRounds||disallowedRounds.indexOf(r)<0);}))));var round=store.round;if(round.type&&round.type!=='none'&&rounds.indexOf(store.round.type)<0){rounds.push(round.type);}return rounds;}},{key:'canChangeType',get:function get(){return this.props.store.canChangeType||this.props.allowChangeType;}}]);return RoundEdit;}(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react__["Component"]),_class3.displayName='RoundEdit',_temp2),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'openRoundWarning',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_applyDecoratedDescriptor(_class2.prototype,'eligibleRounds',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class2.prototype,'eligibleRounds'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'canChangeType',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class2.prototype,'canChangeType'),_class2.prototype)),_class2))||_class)||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (RoundEdit);

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Popup_index__ = __webpack_require__(700);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Popup_index__["a"]; });

//# sourceMappingURL=Popup.js.map

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FocusTrapZone__ = __webpack_require__(1743);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__FocusTrapZone__["a"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSplitButtonVerticalDividerClassNames; });
/* unused harmony export getItemClassNames */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getItemStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Divider_VerticalDivider_classNames__ = __webpack_require__(1744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContextualMenu_cnstyles__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utilities__ = __webpack_require__(1);




var MediumScreenSelector = Object(__WEBPACK_IMPORTED_MODULE_2__Styling__["z" /* getScreenSelector */])(0, __WEBPACK_IMPORTED_MODULE_2__Styling__["l" /* ScreenWidthMaxMedium */]);
var getSplitButtonVerticalDividerClassNames = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_15" /* memoizeFunction */])(function (theme) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__Styling__["E" /* mergeStyleSets */])(Object(__WEBPACK_IMPORTED_MODULE_0__Divider_VerticalDivider_classNames__["a" /* getDividerClassNames */])(theme), {
        wrapper: {
            position: 'absolute',
            right: 28,
            selectors: (_a = {},
                _a[MediumScreenSelector] = {
                    right: 32 // fontSize of the icon increased from 12px to 16px
                },
                _a)
        },
        divider: {
            height: 16,
            width: 1
        }
    });
    var _a;
});
var GlobalClassNames = {
    item: 'ms-ContextualMenu-item',
    divider: 'ms-ContextualMenu-divider',
    root: 'ms-ContextualMenu-link',
    isChecked: 'is-checked',
    isExpanded: 'is-expanded',
    isDisabled: 'is-disabled',
    linkContent: 'ms-ContextualMenu-linkContent',
    linkContentMenu: 'ms-ContextualMenu-linkContent',
    icon: 'ms-ContextualMenu-icon',
    iconColor: 'ms-ContextualMenu-iconColor',
    checkmarkIcon: 'ms-ContextualMenu-checkmarkIcon',
    subMenuIcon: 'ms-ContextualMenu-submenuIcon',
    label: 'ms-ContextualMenu-itemText',
    secondaryText: 'ms-ContextualMenu-secondaryText'
};
/**
 * @deprecated To be removed in 7.0.
 * @internal
 * This is a package-internal method that has been depended on.
 * It is being kept in this form for backwards compatibility.
 * It should be cleaned up in 7.0.
 *
 * TODO: Audit perf. impact of and potentially remove memoizeFunction.
 * https://github.com/OfficeDev/office-ui-fabric-react/issues/5534
 */
var getItemClassNames = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_15" /* memoizeFunction */])(function (theme, disabled, expanded, checked, isAnchorLink, knownIcon, itemClassName, dividerClassName, iconClassName, subMenuClassName, primaryDisabled, className) {
    var styles = Object(__WEBPACK_IMPORTED_MODULE_1__ContextualMenu_cnstyles__["b" /* getMenuItemStyles */])(theme);
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_2__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    return Object(__WEBPACK_IMPORTED_MODULE_2__Styling__["E" /* mergeStyleSets */])({
        item: [classNames.item, styles.item, itemClassName],
        divider: [classNames.divider, styles.divider, dividerClassName],
        root: [
            classNames.root,
            styles.root,
            checked && [classNames.isChecked, styles.rootChecked],
            isAnchorLink && styles.anchorLink,
            expanded && [classNames.isExpanded, styles.rootExpanded],
            disabled && [classNames.isDisabled, styles.rootDisabled],
            !disabled &&
                !expanded && [
                {
                    selectors: (_a = {
                            ':hover': styles.rootHovered,
                            ':active': styles.rootPressed
                        },
                        _a["." + __WEBPACK_IMPORTED_MODULE_3__Utilities__["f" /* IsFocusVisibleClassName */] + " &:focus, ." + __WEBPACK_IMPORTED_MODULE_3__Utilities__["f" /* IsFocusVisibleClassName */] + " &:focus:hover"] = styles.rootFocused,
                        _a["." + __WEBPACK_IMPORTED_MODULE_3__Utilities__["f" /* IsFocusVisibleClassName */] + " &:hover"] = { background: 'inherit;' },
                        _a)
                }
            ],
            className
        ],
        splitPrimary: [
            styles.root,
            checked && ['is-checked', styles.rootChecked],
            (disabled || primaryDisabled) && ['is-disabled', styles.rootDisabled],
            !(disabled || primaryDisabled) &&
                !checked && [
                {
                    selectors: (_b = {
                            ':hover': styles.rootHovered,
                            ':hover ~ $splitMenu': styles.rootHovered,
                            ':active': styles.rootPressed
                        },
                        _b["." + __WEBPACK_IMPORTED_MODULE_3__Utilities__["f" /* IsFocusVisibleClassName */] + " &:focus, ." + __WEBPACK_IMPORTED_MODULE_3__Utilities__["f" /* IsFocusVisibleClassName */] + " &:focus:hover"] = styles.rootFocused,
                        _b["." + __WEBPACK_IMPORTED_MODULE_3__Utilities__["f" /* IsFocusVisibleClassName */] + " &:hover"] = { background: 'inherit;' },
                        _b)
                }
            ]
        ],
        splitMenu: [
            styles.root,
            {
                flexBasis: '0',
                padding: '0 8px',
                minWidth: 28
            },
            expanded && ['is-expanded', styles.rootExpanded],
            disabled && ['is-disabled', styles.rootDisabled],
            !disabled &&
                !expanded && [
                {
                    selectors: (_c = {
                            ':hover': styles.rootHovered,
                            ':active': styles.rootPressed
                        },
                        _c["." + __WEBPACK_IMPORTED_MODULE_3__Utilities__["f" /* IsFocusVisibleClassName */] + " &:focus, ." + __WEBPACK_IMPORTED_MODULE_3__Utilities__["f" /* IsFocusVisibleClassName */] + " &:focus:hover"] = styles.rootFocused,
                        _c["." + __WEBPACK_IMPORTED_MODULE_3__Utilities__["f" /* IsFocusVisibleClassName */] + " &:hover"] = { background: 'inherit;' },
                        _c)
                }
            ]
        ],
        anchorLink: styles.anchorLink,
        linkContent: [classNames.linkContent, styles.linkContent],
        linkContentMenu: [
            classNames.linkContentMenu,
            styles.linkContent,
            {
                justifyContent: 'center'
            }
        ],
        icon: [
            classNames.icon,
            knownIcon && styles.iconColor,
            styles.icon,
            iconClassName,
            disabled && [classNames.isDisabled, styles.iconDisabled]
        ],
        iconColor: styles.iconColor,
        checkmarkIcon: [classNames.checkmarkIcon, knownIcon && styles.checkmarkIcon, styles.icon, iconClassName],
        subMenuIcon: [classNames.subMenuIcon, styles.subMenuIcon, subMenuClassName],
        label: [classNames.label, styles.label],
        secondaryText: [classNames.secondaryText, styles.secondaryText],
        splitContainer: [
            styles.splitButtonFlexContainer,
            {
                alignItems: 'flex-start'
            },
            !disabled &&
                !checked && [
                {
                    selectors: (_d = {},
                        _d["." + __WEBPACK_IMPORTED_MODULE_3__Utilities__["f" /* IsFocusVisibleClassName */] + " &:focus, ." + __WEBPACK_IMPORTED_MODULE_3__Utilities__["f" /* IsFocusVisibleClassName */] + " &:focus:hover"] = styles.rootFocused,
                        _d)
                }
            ]
        ]
    });
    var _a, _b, _c, _d;
});
/**
 * Wrapper function for generating ContextualMenuItem classNames which adheres to
 * the getStyles API, but invokes memoized className generator function with
 * primitive values.
 *
 * @param props the ContextualMenuItem style props used to generate its styles.
 */
var getItemStyles = function (props) {
    var theme = props.theme, disabled = props.disabled, expanded = props.expanded, checked = props.checked, isAnchorLink = props.isAnchorLink, knownIcon = props.knownIcon, itemClassName = props.itemClassName, dividerClassName = props.dividerClassName, iconClassName = props.iconClassName, subMenuClassName = props.subMenuClassName, primaryDisabled = props.primaryDisabled, className = props.className;
    return getItemClassNames(theme, disabled, expanded, checked, isAnchorLink, knownIcon, itemClassName, dividerClassName, iconClassName, subMenuClassName, primaryDisabled, className);
};
//# sourceMappingURL=ContextualMenu.classNames.js.map

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonGlobalClassNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getBaseButtonClassNames; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Styling__ = __webpack_require__(5);



var ButtonGlobalClassNames = {
    msButton: 'ms-Button',
    msButtonIcon: 'ms-Button-icon',
    msButtonMenuIcon: 'ms-Button-menuIcon',
    msButtonLabel: 'ms-Button-label',
    msButtonDescription: 'ms-Button-description',
    msButtonScreenReaderText: 'ms-Button-screenReaderText',
    msButtonFlexContainer: 'ms-Button-flexContainer',
    msButtonTextContainer: 'ms-Button-textContainer'
};
var getBaseButtonClassNames = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_15" /* memoizeFunction */])(function (theme, styles, className, variantClassName, iconClassName, menuIconClassName, disabled, checked, expanded, isSplit) {
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["w" /* getGlobalClassNames */])(ButtonGlobalClassNames, theme || {});
    var isExpanded = expanded && !isSplit;
    return Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["E" /* mergeStyleSets */])({
        root: [
            classNames.msButton,
            styles.root,
            variantClassName,
            checked && ['is-checked', styles.rootChecked],
            isExpanded && [
                'is-expanded',
                styles.rootExpanded,
                {
                    selectors: (_a = {},
                        _a[":hover ." + classNames.msButtonIcon] = styles.iconExpandedHovered,
                        // menuIcon falls back to rootExpandedHovered to support original behavior
                        _a[":hover ." + classNames.msButtonMenuIcon] = styles.menuIconExpandedHovered || styles.rootExpandedHovered,
                        _a[':hover'] = styles.rootExpandedHovered,
                        _a)
                }
            ],
            disabled && ['is-disabled', styles.rootDisabled],
            !disabled &&
                !isExpanded &&
                !checked && {
                selectors: (_b = {
                        ':hover': styles.rootHovered
                    },
                    _b[":hover ." + classNames.msButtonLabel] = styles.labelHovered,
                    _b[":hover ." + classNames.msButtonIcon] = styles.iconHovered,
                    _b[":hover ." + classNames.msButtonDescription] = styles.descriptionHovered,
                    _b[":hover ." + classNames.msButtonMenuIcon] = styles.menuIconHovered,
                    _b[':focus'] = styles.rootFocused,
                    _b[':active'] = styles.rootPressed,
                    _b[":active ." + classNames.msButtonIcon] = styles.iconPressed,
                    _b[":active ." + classNames.msButtonDescription] = styles.descriptionPressed,
                    _b[":active ." + classNames.msButtonMenuIcon] = styles.menuIconPressed,
                    _b)
            },
            disabled && checked && [styles.rootCheckedDisabled],
            !disabled &&
                checked && {
                selectors: {
                    ':hover': styles.rootCheckedHovered,
                    ':active': styles.rootCheckedPressed
                }
            },
            className
        ],
        flexContainer: [classNames.msButtonFlexContainer, styles.flexContainer],
        textContainer: [classNames.msButtonTextContainer, styles.textContainer],
        icon: [
            classNames.msButtonIcon,
            iconClassName,
            styles.icon,
            isExpanded && styles.iconExpanded,
            checked && styles.iconChecked,
            disabled && styles.iconDisabled
        ],
        label: [classNames.msButtonLabel, styles.label, checked && styles.labelChecked, disabled && styles.labelDisabled],
        menuIcon: [
            classNames.msButtonMenuIcon,
            menuIconClassName,
            styles.menuIcon,
            checked && styles.menuIconChecked,
            disabled && !isSplit && styles.menuIconDisabled,
            !disabled &&
                !isExpanded &&
                !checked && {
                selectors: {
                    ':hover': styles.menuIconHovered,
                    ':active': styles.menuIconPressed
                }
            },
            isExpanded && ['is-expanded', styles.menuIconExpanded]
        ],
        description: [
            classNames.msButtonDescription,
            styles.description,
            checked && styles.descriptionChecked,
            disabled && styles.descriptionDisabled
        ],
        screenReaderText: [classNames.msButtonScreenReaderText, styles.screenReaderText]
    });
    var _a, _b;
});
//# sourceMappingURL=BaseButton.classNames.js.map

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseButton__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ActionButton_styles__ = __webpack_require__(706);





/**
 * {@docCategory Button}
 */
var ActionButton = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ActionButton, _super);
    function ActionButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Tell BaseComponent to bypass resolution of componentRef.
         */
        _this._skipComponentRefResolution = true;
        return _this;
    }
    ActionButton.prototype.render = function () {
        var _a = this.props, styles = _a.styles, theme = _a.theme;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__BaseButton__["a" /* BaseButton */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this.props, { variantClassName: "ms-Button--action ms-Button--command", styles: Object(__WEBPACK_IMPORTED_MODULE_4__ActionButton_styles__["a" /* getStyles */])(theme, styles), onRenderDescription: __WEBPACK_IMPORTED_MODULE_3__Utilities__["_17" /* nullRender */] })));
    };
    ActionButton = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["u" /* customizable */])('ActionButton', ['theme', 'styles'], true)
    ], ActionButton);
    return ActionButton;
}(__WEBPACK_IMPORTED_MODULE_3__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=ActionButton.js.map

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_decorators_withResponsiveMode__ = __webpack_require__(136);
/* unused harmony reexport ResponsiveMode */

 // Exported because the type is an optional prop and not exported otherwise.
/**
 * {@docCategory Dialog}
 */
var DialogType;
(function (DialogType) {
    /** Standard dialog */
    DialogType[DialogType["normal"] = 0] = "normal";
    /** Dialog with large header banner */
    DialogType[DialogType["largeHeader"] = 1] = "largeHeader";
    /** Dialog with an 'x' close button in the upper-right corner */
    DialogType[DialogType["close"] = 2] = "close";
})(DialogType || (DialogType = {}));
//# sourceMappingURL=DialogContent.types.js.map

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_decorators_withResponsiveMode__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_selectableOption_SelectableOption_types__ = __webpack_require__(417);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__utilities_selectableOption_SelectableOption_types__["a"]; });
/* unused harmony reexport ResponsiveMode */


 // Exported because the type is an optional prop and not exported otherwise.
//# sourceMappingURL=Dropdown.types.js.map

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectableOptionMenuItemType; });
var SelectableOptionMenuItemType;
(function (SelectableOptionMenuItemType) {
    SelectableOptionMenuItemType[SelectableOptionMenuItemType["Normal"] = 0] = "Normal";
    SelectableOptionMenuItemType[SelectableOptionMenuItemType["Divider"] = 1] = "Divider";
    SelectableOptionMenuItemType[SelectableOptionMenuItemType["Header"] = 2] = "Header";
})(SelectableOptionMenuItemType || (SelectableOptionMenuItemType = {}));
//# sourceMappingURL=SelectableOption.types.js.map

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PanelType; });
/**
 * {@docCategory Panel}
 */
var PanelType;
(function (PanelType) {
    /**
     * Renders the Panel with a `fluid` (full screen) width.
     * Recommended for use on small screen breakpoints.
     * - Small (320-479): full screen width, 16px left/right padding
     * - Medium (480-639): full screen width, 16px left/right padding
     * - Large (640-1023): full screen width, 32px left/right padding
     * - XLarge (1024-1365): full screen width, 32px left/right padding
     * - XXLarge (1366-up): full screen width, 40px left/right padding
     */
    PanelType[PanelType["smallFluid"] = 0] = "smallFluid";
    /**
     * Renders the Panel in fixed-width `small` size, anchored to the far side (right in LTR mode).
     * - Small (320-479): adapts to `PanelType.smallFluid` at this breakpoint
     * - Medium (480-639): 340px width, 16px left/right padding
     * - Large (640-1023): 340px width, 32px left/right padding
     * - XLarge (1024-1365): 340px width, 32px left/right padding
     * - XXLarge (1366-up): 340px width, 40px left/right padding
     */
    PanelType[PanelType["smallFixedFar"] = 1] = "smallFixedFar";
    /**
     * Renders the Panel in fixed-width `small` size, anchored to the near side (left in LTR mode).
     * - Small (320-479): 272px width, 16px left/right padding
     * - Medium (480-639): 272px width, 16px left/right padding
     * - Large (640-1023): 272px width, 32px left/right padding
     * - XLarge (1024-1365): 272px width, 32px left/right padding
     * - XXLarge (1366-up): 272px width, 40px left/right padding
     */
    PanelType[PanelType["smallFixedNear"] = 2] = "smallFixedNear";
    /**
     * Renders the Panel in `medium` size, anchored to the far side (right in LTR mode).
     * - Small (320-479): adapts to `PanelType.smallFluid` at this breakpoint
     * - Medium (480-639): adapts to `PanelType.smallFixedFar` at this breakpoint
     * - Large (640-1023): 592px width, 32px left/right padding
     * - XLarge (1024-1365): 644px width, 32px left/right padding
     * - XXLarge (1366-up): 644px width, 40px left/right padding
     */
    PanelType[PanelType["medium"] = 3] = "medium";
    /**
     * Renders the Panel in `large` size, anchored to the far side (right in LTR mode).
     * - Small (320-479): adapts to `PanelType.smallFluid` at this breakpoint
     * - Medium (480-639):  adapts to `PanelType.smallFixedFar` at this breakpoint
     * - Large (640-1023): adapts to `PanelType.medium` at this breakpoint
     * - XLarge (1024-1365): 48px fixed left margin, fluid width, 32px left/right padding
     * - XXLarge (1366-up): 428px fixed left margin, fluid width, 40px left/right padding
     */
    PanelType[PanelType["large"] = 4] = "large";
    /**
     * Renders the Panel in `large` size, anchored to the far side (right in LTR mode), with a fixed width at XX-Large breakpoint.
     * - Small (320-479): adapts to `PanelType.smallFluid` at this breakpoint
     * - Medium (480-639): adapts to `PanelType.smallFixedFar` at this breakpoint
     * - Large (640-1023): adapts to `PanelType.medium` at this breakpoint
     * - XLarge (1024-1365): 48px fixed left margin, fluid width, 32px left/right padding
     * - XXLarge (1366-up): 940px width, 40px left/right padding
     */
    PanelType[PanelType["largeFixed"] = 5] = "largeFixed";
    /**
     * Renders the Panel in `extra large` size, anchored to the far side (right in LTR mode).
     * - Small (320-479): adapts to `PanelType.smallFluid` at this breakpoint
     * - Medium (480-639): adapts to `PanelType.smallFixedFar` at this breakpoint
     * - Large (640-1023): adapts to `PanelType.medium` at this breakpoint
     * - XLarge (1024-1365): adapts to `PanelType.large` at this breakpoint
     * - XXLarge (1366-1919): 176px fixed left margin, fluid width, 40px left/right padding
     * - XXXLarge (1920-up): 176px fixed left margin, fluid width, 40px left/right padding
     */
    PanelType[PanelType["extraLarge"] = 6] = "extraLarge";
    /**
     * Renders the Panel in `custom` size using `customWidth`, anchored to the far side (right in LTR mode).
     * - Has a fixed width provided by the `customWidth` prop
     * - When screen width reaches the `customWidth` value it will behave like a fluid width Panel
     * taking up 100% of the viewport width
     */
    PanelType[PanelType["custom"] = 7] = "custom";
    /**
     * Renders the Panel in `custom` size using `customWidth`, anchored to the near side (left in LTR mode).
     * - Has a fixed width provided by the `customWidth` prop
     * - When screen width reaches the `customWidth` value it will behave like a fluid width Panel
     * taking up 100% of the viewport width
     */
    PanelType[PanelType["customNear"] = 8] = "customNear";
})(PanelType || (PanelType = {}));
//# sourceMappingURL=Panel.types.js.map

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SelectableOption__ = __webpack_require__(1806);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__SelectableOption__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SelectableOption_types__ = __webpack_require__(417);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__SelectableOption_types__["a"]; });


//# sourceMappingURL=index.js.map

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Calendar_index__ = __webpack_require__(1813);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Calendar_index__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Calendar_index__["b"]; });

//# sourceMappingURL=Calendar.js.map

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Autofill__ = __webpack_require__(735);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Autofill__["a"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ResizeGroup_index__ = __webpack_require__(1851);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_ResizeGroup_index__["a"]; });

//# sourceMappingURL=ResizeGroup.js.map

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ChoiceGroupOption__ = __webpack_require__(1856);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ChoiceGroupOption__["a"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cssColor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hsl2rgb__ = __webpack_require__(425);


/**
 * Converts a valid CSS color string to an RGB color.
 * Note that hex colors *must* be prefixed with # to be considered valid.
 * Alpha in returned color defaults to 100.
 * Four and eight digit hex values (with alpha) are supported if the current browser supports them.
 */
function cssColor(color) {
    if (!color) {
        return undefined;
    }
    // Need to check the following valid color formats: RGB(A), HSL(A), hex, named color
    // First check for well formatted RGB(A), HSL(A), and hex formats at the start.
    // This is for perf (no creating an element) and catches the intentional "transparent" color
    //   case early on.
    var easyColor = _rgba(color) || _hex6(color) || _hex3(color) || _hsla(color);
    if (easyColor) {
        return easyColor;
    }
    // if the above fails, do the more expensive catch-all
    return _browserCompute(color);
}
/**
 * Uses the browser's getComputedStyle() to determine what the passed-in color is.
 * This assumes _rgba, _hex6, _hex3, and _hsla have already been tried and all failed.
 * This works by attaching an element to the DOM, which may fail in server-side rendering
 *   or with headless browsers.
 */
function _browserCompute(str) {
    if (typeof document === 'undefined') {
        // don't throw an error when used server-side
        return undefined;
    }
    var elem = document.createElement('div');
    elem.style.backgroundColor = str;
    // This element must be attached to the DOM for getComputedStyle() to have a value
    elem.style.position = 'absolute';
    elem.style.top = '-9999px';
    elem.style.left = '-9999px';
    elem.style.height = '1px';
    elem.style.width = '1px';
    document.body.appendChild(elem);
    var eComputedStyle = getComputedStyle(elem);
    var computedColor = eComputedStyle && eComputedStyle.backgroundColor;
    document.body.removeChild(elem);
    // computedColor is always an RGB(A) string, except for invalid colors in IE/Edge which return 'transparent'
    // browsers return one of these if the color string is invalid,
    // so need to differentiate between an actual error and intentionally passing in this color
    if (computedColor === 'rgba(0, 0, 0, 0)' || computedColor === 'transparent') {
        switch (str.trim()) {
            // RGB and HSL were already checked at the start of the function
            case 'transparent':
            case '#0000':
            case '#00000000':
                return { r: 0, g: 0, b: 0, a: 0 };
        }
        return undefined;
    }
    return _rgba(computedColor);
}
/**
 * If `str` is in valid `rgb()` or `rgba()` format, returns an RGB color (alpha defaults to 100).
 * Otherwise returns undefined.
 */
function _rgba(str) {
    if (!str) {
        return undefined;
    }
    var match = str.match(/^rgb(a?)\(([\d., ]+)\)$/);
    if (match) {
        var hasAlpha = !!match[1];
        var expectedPartCount = hasAlpha ? 4 : 3;
        var parts = match[2].split(/ *, */).map(Number);
        if (parts.length === expectedPartCount) {
            return {
                r: parts[0],
                g: parts[1],
                b: parts[2],
                a: hasAlpha ? parts[3] * 100 : __WEBPACK_IMPORTED_MODULE_0__consts__["b" /* MAX_COLOR_ALPHA */]
            };
        }
    }
}
/**
 * If `str` is in `hsl()` or `hsla()` format, returns an RGB color (alpha defaults to 100).
 * Otherwise returns undefined.
 */
function _hsla(str) {
    var match = str.match(/^hsl(a?)\(([\d., ]+)\)$/);
    if (match) {
        var hasAlpha = !!match[1];
        var expectedPartCount = hasAlpha ? 4 : 3;
        var parts = match[2].split(/ *, */).map(Number);
        if (parts.length === expectedPartCount) {
            var rgba = Object(__WEBPACK_IMPORTED_MODULE_1__hsl2rgb__["a" /* hsl2rgb */])(parts[0], parts[1], parts[2]);
            rgba.a = hasAlpha ? parts[3] * 100 : __WEBPACK_IMPORTED_MODULE_0__consts__["b" /* MAX_COLOR_ALPHA */];
            return rgba;
        }
    }
}
/**
 * If `str` is in valid 6-digit hex format *with* # prefix, returns an RGB color (with alpha 100).
 * Otherwise returns undefined.
 */
function _hex6(str) {
    if ('#' === str[0] && 7 === str.length && /^#[\da-fA-F]{6}$/.test(str)) {
        return {
            r: parseInt(str.slice(1, 3), 16),
            g: parseInt(str.slice(3, 5), 16),
            b: parseInt(str.slice(5, 7), 16),
            a: __WEBPACK_IMPORTED_MODULE_0__consts__["b" /* MAX_COLOR_ALPHA */]
        };
    }
}
/**
 * If `str` is in valid 3-digit hex format *with* # prefix, returns an RGB color (with alpha 100).
 * Otherwise returns undefined.
 */
function _hex3(str) {
    if ('#' === str[0] && 4 === str.length && /^#[\da-fA-F]{3}$/.test(str)) {
        return {
            r: parseInt(str[1] + str[1], 16),
            g: parseInt(str[2] + str[2], 16),
            b: parseInt(str[3] + str[3], 16),
            a: __WEBPACK_IMPORTED_MODULE_0__consts__["b" /* MAX_COLOR_ALPHA */]
        };
    }
}
//# sourceMappingURL=cssColor.js.map

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hsl2rgb;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hsl2hsv__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hsv2rgb__ = __webpack_require__(120);


/** Converts HSL components to an RGB color. Does not set the alpha value. */
function hsl2rgb(h, s, l) {
    var hsv = Object(__WEBPACK_IMPORTED_MODULE_0__hsl2hsv__["a" /* hsl2hsv */])(h, s, l);
    return Object(__WEBPACK_IMPORTED_MODULE_1__hsv2rgb__["a" /* hsv2rgb */])(hsv.h, hsv.s, hsv.v);
}
//# sourceMappingURL=hsl2rgb.js.map

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hsl2hsv;
/** Converts HSL components to an HSV color. */
function hsl2hsv(h, s, l) {
    s *= (l < 50 ? l : 100 - l) / 100;
    var v = l + s;
    return {
        h: h,
        s: v === 0 ? 0 : ((2 * s) / v) * 100,
        v: v
    };
}
//# sourceMappingURL=hsl2hsv.js.map

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = rgb2hsv;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts__ = __webpack_require__(37);

/** Converts RGB components to an HSV color. */
function rgb2hsv(r, g, b) {
    var h = NaN;
    var s;
    var v;
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var delta = max - min;
    // hue
    if (delta === 0) {
        h = 0;
    }
    else if (r === max) {
        h = ((g - b) / delta) % 6;
    }
    else if (g === max) {
        h = (b - r) / delta + 2;
    }
    else if (b === max) {
        h = (r - g) / delta + 4;
    }
    h = Math.round(h * 60);
    if (h < 0) {
        h += 360;
    }
    // saturation
    s = Math.round((max === 0 ? 0 : delta / max) * 100);
    // value
    v = Math.round((max / __WEBPACK_IMPORTED_MODULE_0__consts__["d" /* MAX_COLOR_RGB */]) * 100);
    return { h: h, s: s, v: v };
}
//# sourceMappingURL=rgb2hsv.js.map

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hsv2hsl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts__ = __webpack_require__(37);

/** Converts HSV components to an HSL color. */
function hsv2hsl(h, s, v) {
    s /= __WEBPACK_IMPORTED_MODULE_0__consts__["f" /* MAX_COLOR_SATURATION */];
    v /= __WEBPACK_IMPORTED_MODULE_0__consts__["g" /* MAX_COLOR_VALUE */];
    var l = (2 - s) * v;
    var sl = s * v;
    sl /= l <= 1 ? l : 2 - l;
    sl = sl || 0;
    l /= 2;
    return { h: h, s: sl * 100, l: l * 100 };
}
//# sourceMappingURL=hsv2hsl.js.map

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getFullColorString;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hsv2hex__ = __webpack_require__(278);


/**
 * Converts a color hue to an HTML color string (with # prefix).
 * This implementation ignores all components of `color` except hue.
 */
function getFullColorString(color) {
    return "#" + Object(__WEBPACK_IMPORTED_MODULE_1__hsv2hex__["a" /* hsv2hex */])(color.h, __WEBPACK_IMPORTED_MODULE_0__consts__["f" /* MAX_COLOR_SATURATION */], __WEBPACK_IMPORTED_MODULE_0__consts__["g" /* MAX_COLOR_VALUE */]);
}
//# sourceMappingURL=getFullColorString.js.map

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updateSV;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hsv2rgb__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rgb2hex__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rgbaOrHexString__ = __webpack_require__(187);



/**
 * Gets a color with the same hue as `color` and other components updated to match the given
 * saturation and value.
 *
 * Does not modify the original `color` and does not supply a default alpha value.
 */
function updateSV(color, s, v) {
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0__hsv2rgb__["a" /* hsv2rgb */])(color.h, s, v), r = _a.r, g = _a.g, b = _a.b;
    var hex = Object(__WEBPACK_IMPORTED_MODULE_1__rgb2hex__["a" /* rgb2hex */])(r, g, b);
    return {
        a: color.a,
        b: b,
        g: g,
        h: color.h,
        hex: hex,
        r: r,
        s: s,
        str: Object(__WEBPACK_IMPORTED_MODULE_2__rgbaOrHexString__["a" /* _rgbaOrHexString */])(r, g, b, color.a, hex),
        v: v
    };
}
//# sourceMappingURL=updateSV.js.map

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updateH;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hsv2rgb__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rgb2hex__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rgbaOrHexString__ = __webpack_require__(187);



/**
 * Gets a color with the same saturation and value as `color` and the other components updated
 * to match the given hue.
 *
 * Does not modify the original `color` and does not supply a default alpha value.
 */
function updateH(color, h) {
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0__hsv2rgb__["a" /* hsv2rgb */])(h, color.s, color.v), r = _a.r, g = _a.g, b = _a.b;
    var hex = Object(__WEBPACK_IMPORTED_MODULE_1__rgb2hex__["a" /* rgb2hex */])(r, g, b);
    return {
        a: color.a,
        b: b,
        g: g,
        h: h,
        hex: hex,
        r: r,
        s: color.s,
        str: Object(__WEBPACK_IMPORTED_MODULE_2__rgbaOrHexString__["a" /* _rgbaOrHexString */])(r, g, b, color.a, hex),
        v: color.v
    };
}
//# sourceMappingURL=updateH.js.map

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updateA;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rgbaOrHexString__ = __webpack_require__(187);


/**
 * Gets a color with the given alpha value and the same other components as `color`.
 * Does not modify the original color.
 */
function updateA(color, a) {
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, color, { a: a, str: Object(__WEBPACK_IMPORTED_MODULE_1__rgbaOrHexString__["a" /* _rgbaOrHexString */])(color.r, color.g, color.b, a, color.hex) });
}
//# sourceMappingURL=updateA.js.map

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = correctRGB;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clamp__ = __webpack_require__(155);


/** Corrects an RGB color to fall within the valid range.  */
function correctRGB(color) {
    return {
        r: Object(__WEBPACK_IMPORTED_MODULE_1__clamp__["a" /* clamp */])(color.r, __WEBPACK_IMPORTED_MODULE_0__consts__["d" /* MAX_COLOR_RGB */]),
        g: Object(__WEBPACK_IMPORTED_MODULE_1__clamp__["a" /* clamp */])(color.g, __WEBPACK_IMPORTED_MODULE_0__consts__["d" /* MAX_COLOR_RGB */]),
        b: Object(__WEBPACK_IMPORTED_MODULE_1__clamp__["a" /* clamp */])(color.b, __WEBPACK_IMPORTED_MODULE_0__consts__["d" /* MAX_COLOR_RGB */]),
        a: typeof color.a === 'number' ? Object(__WEBPACK_IMPORTED_MODULE_1__clamp__["a" /* clamp */])(color.a, __WEBPACK_IMPORTED_MODULE_0__consts__["b" /* MAX_COLOR_ALPHA */]) : color.a
    };
}
//# sourceMappingURL=correctRGB.js.map

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Shade; });
/* harmony export (immutable) */ __webpack_exports__["d"] = isValidShade;
/* unused harmony export isDark */
/* harmony export (immutable) */ __webpack_exports__["c"] = getShade;
/* harmony export (immutable) */ __webpack_exports__["b"] = getBackgroundShade;
/* unused harmony export getContrastRatio */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hsv2hsl__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getColorFromRGBA__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hsv2rgb__ = __webpack_require__(120);





// Soften: to get closer to the background color's luminance
// (softening with a white background would be lightening, with black it'd be darkening)
// Strongen: opposite of soften
// Luminance multiplier constants for generating shades of a given color
var WhiteShadeTableBG = [0.027, 0.043, 0.082, 0.145, 0.184, 0.216, 0.349, 0.537]; // white bg
var BlackTintTableBG = [0.537, 0.45, 0.349, 0.216, 0.184, 0.145, 0.082, 0.043]; // black bg
var WhiteShadeTable = [0.537, 0.349, 0.216, 0.184, 0.145, 0.082, 0.043, 0.027]; // white fg
var BlackTintTable = [0.537, 0.45, 0.349, 0.216, 0.184, 0.145, 0.082, 0.043]; // black fg
var LumTintTable = [0.88, 0.77, 0.66, 0.55, 0.44, 0.33, 0.22, 0.11]; // light (strongen all)
var LumShadeTable = [0.11, 0.22, 0.33, 0.44, 0.55, 0.66, 0.77, 0.88]; // dark (soften all)
var ColorTintTable = [0.96, 0.84, 0.7, 0.4, 0.12]; // default soften
var ColorShadeTable = [0.1, 0.24, 0.44]; // default strongen
// If the given shade's luminance is below/above these values, we'll swap to using the White/Black tables above
var LowLuminanceThreshold = 0.2;
var HighLuminanceThreshold = 0.8;
/** Shades of a given color, from softest to strongest. */
var Shade;
(function (Shade) {
    Shade[Shade["Unshaded"] = 0] = "Unshaded";
    Shade[Shade["Shade1"] = 1] = "Shade1";
    Shade[Shade["Shade2"] = 2] = "Shade2";
    Shade[Shade["Shade3"] = 3] = "Shade3";
    Shade[Shade["Shade4"] = 4] = "Shade4";
    Shade[Shade["Shade5"] = 5] = "Shade5";
    Shade[Shade["Shade6"] = 6] = "Shade6";
    Shade[Shade["Shade7"] = 7] = "Shade7";
    Shade[Shade["Shade8"] = 8] = "Shade8";
    // remember to update isValidShade()!
})(Shade || (Shade = {}));
/**
 * Returns true if the argument is a valid Shade value
 * @param shade - The Shade value to validate.
 */
function isValidShade(shade) {
    'use strict';
    return typeof shade === 'number' && shade >= Shade.Unshaded && shade <= Shade.Shade8;
}
function _isBlack(color) {
    return color.r === 0 && color.g === 0 && color.b === 0;
}
function _isWhite(color) {
    return color.r === __WEBPACK_IMPORTED_MODULE_0__consts__["e" /* MAX_COLOR_RGBA */] && color.g === __WEBPACK_IMPORTED_MODULE_0__consts__["e" /* MAX_COLOR_RGBA */] && color.b === __WEBPACK_IMPORTED_MODULE_0__consts__["e" /* MAX_COLOR_RGBA */];
}
function _darken(hsv, factor) {
    return {
        h: hsv.h,
        s: hsv.s,
        v: _clamp(hsv.v - hsv.v * factor, 0, 100)
    };
}
function _lighten(hsv, factor) {
    return {
        h: hsv.h,
        s: _clamp(hsv.s - hsv.s * factor, 0, 100),
        v: _clamp(hsv.v + (100 - hsv.v) * factor, 0, 100)
    };
}
function _clamp(n, min, max) {
    return n; // Math.max(min, Math.min(n, max));
}
function isDark(color) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__hsv2hsl__["a" /* hsv2hsl */])(color.h, color.s, color.v).l < 50;
}
/**
 * Given a color and a shade specification, generates the requested shade of the color.
 * Logic:
 * if white
 *  darken via tables defined above
 * if black
 *  lighten
 * if light
 *  strongen
 * if dark
 *  soften
 * else default
 *  soften or strongen depending on shade#
 * @param color - The base color whose shade is to be computed
 * @param shade - The shade of the base color to compute
 * @param isInverted - Default false. Whether the given theme is inverted (reverse strongen/soften logic)
 */
function getShade(color, shade, isInverted) {
    'use strict';
    if (isInverted === void 0) { isInverted = false; }
    if (!color) {
        return null;
    }
    if (shade === Shade.Unshaded || !isValidShade(shade)) {
        return color;
    }
    var hsl = Object(__WEBPACK_IMPORTED_MODULE_2__hsv2hsl__["a" /* hsv2hsl */])(color.h, color.s, color.v);
    var hsv = { h: color.h, s: color.s, v: color.v };
    var tableIndex = shade - 1;
    var _soften = _lighten;
    var _strongen = _darken;
    if (isInverted) {
        _soften = _darken;
        _strongen = _lighten;
    }
    if (_isWhite(color)) {
        // white
        hsv = _darken(hsv, WhiteShadeTable[tableIndex]);
    }
    else if (_isBlack(color)) {
        // black
        hsv = _lighten(hsv, BlackTintTable[tableIndex]);
    }
    else if (hsl.l / 100 > HighLuminanceThreshold) {
        // light
        hsv = _strongen(hsv, LumShadeTable[tableIndex]);
    }
    else if (hsl.l / 100 < LowLuminanceThreshold) {
        // dark
        hsv = _soften(hsv, LumTintTable[tableIndex]);
    }
    else {
        // default
        if (tableIndex < ColorTintTable.length) {
            hsv = _soften(hsv, ColorTintTable[tableIndex]);
        }
        else {
            hsv = _strongen(hsv, ColorShadeTable[tableIndex - ColorTintTable.length]);
        }
    }
    return Object(__WEBPACK_IMPORTED_MODULE_3__getColorFromRGBA__["a" /* getColorFromRGBA */])(Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["n" /* assign */])(Object(__WEBPACK_IMPORTED_MODULE_4__hsv2rgb__["a" /* hsv2rgb */])(hsv.h, hsv.s, hsv.v), { a: color.a }));
}
// Background shades/tints are generated differently. The provided color will be guaranteed
//   to be the darkest or lightest one. If it is <50% luminance, it will always be the darkest,
//   otherwise it will always be the lightest.
function getBackgroundShade(color, shade, isInverted) {
    'use strict';
    if (isInverted === void 0) { isInverted = false; }
    if (!color) {
        return null;
    }
    if (shade === Shade.Unshaded || !isValidShade(shade)) {
        return color;
    }
    var hsv = { h: color.h, s: color.s, v: color.v };
    var tableIndex = shade - 1;
    if (!isInverted) {
        // lightish
        hsv = _darken(hsv, WhiteShadeTableBG[tableIndex]);
    }
    else {
        // default: if (hsl.l / 100 < .5) { // darkish
        hsv = _lighten(hsv, BlackTintTableBG[BlackTintTable.length - 1 - tableIndex]);
    }
    return Object(__WEBPACK_IMPORTED_MODULE_3__getColorFromRGBA__["a" /* getColorFromRGBA */])(Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["n" /* assign */])(Object(__WEBPACK_IMPORTED_MODULE_4__hsv2rgb__["a" /* hsv2rgb */])(hsv.h, hsv.s, hsv.v), { a: color.a }));
}
/* Calculates the contrast ratio between two colors. Used for verifying
 * color pairs meet minimum accessibility requirements.
 * See: https://www.w3.org/TR/WCAG20/ section 1.4.3
 */
function getContrastRatio(color1, color2) {
    // Formula defined by: http://www.w3.org/TR/UNDERSTANDING-WCAG20/visual-audio-contrast-contrast.html#contrast-ratiodef
    // relative luminance: http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
    /* calculate the intermediate value needed to calculating relative luminance */
    function _getThing(x) {
        if (x <= 0.03928) {
            return x / 12.92;
        }
        else {
            return Math.pow((x + 0.055) / 1.055, 2.4);
        }
    }
    var r1 = _getThing(color1.r / __WEBPACK_IMPORTED_MODULE_0__consts__["e" /* MAX_COLOR_RGBA */]);
    var g1 = _getThing(color1.g / __WEBPACK_IMPORTED_MODULE_0__consts__["e" /* MAX_COLOR_RGBA */]);
    var b1 = _getThing(color1.b / __WEBPACK_IMPORTED_MODULE_0__consts__["e" /* MAX_COLOR_RGBA */]);
    var L1 = 0.2126 * r1 + 0.7152 * g1 + 0.0722 * b1; // relative luminance of first color
    L1 += 0.05;
    var r2 = _getThing(color2.r / __WEBPACK_IMPORTED_MODULE_0__consts__["e" /* MAX_COLOR_RGBA */]);
    var g2 = _getThing(color2.g / __WEBPACK_IMPORTED_MODULE_0__consts__["e" /* MAX_COLOR_RGBA */]);
    var b2 = _getThing(color2.b / __WEBPACK_IMPORTED_MODULE_0__consts__["e" /* MAX_COLOR_RGBA */]);
    var L2 = 0.2126 * r2 + 0.7152 * g2 + 0.0722 * b2; // relative luminance of second color
    L2 += 0.05;
    // return the lighter color divided by darker
    return L1 / L2 > 1 ? L1 / L2 : L2 / L1;
}
//# sourceMappingURL=shades.js.map

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Persona_index__ = __webpack_require__(736);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Persona_index__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Persona_index__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Persona_index__["e"]; });

//# sourceMappingURL=PersonaCoin.js.map

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_selection_index__ = __webpack_require__(119);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__utilities_selection_index__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__utilities_selection_index__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__utilities_selection_index__["d"]; });

//# sourceMappingURL=Selection.js.map

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BasePicker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BasePickerListBelow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FocusZone__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Callout__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_selection_index__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Suggestions_Suggestions__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Suggestions_Suggestions_styles__ = __webpack_require__(1933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Suggestions_SuggestionsController__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__BasePicker_types__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Autofill_index__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__BasePicker_scss__ = __webpack_require__(1934);












var legacyStyles = __WEBPACK_IMPORTED_MODULE_11__BasePicker_scss__;
var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
/**
 * Should be removed once new picker without inheritance is created
 */
function getStyledSuggestions(suggestionsType) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_29" /* styled */])(suggestionsType, __WEBPACK_IMPORTED_MODULE_7__Suggestions_Suggestions_styles__["a" /* getStyles */], undefined, {
        scope: 'Suggestions'
    });
}
/**
 * {@docCategory Pickers}
 */
var BasePicker = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](BasePicker, _super);
    function BasePicker(basePickerProps) {
        var _this = _super.call(this, basePickerProps) || this;
        // Refs
        _this.root = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.input = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.focusZone = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.suggestionElement = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        /**
         * @deprecated this is no longer necessary as typescript now supports generic elements
         */
        _this.SuggestionOfProperType = __WEBPACK_IMPORTED_MODULE_6__Suggestions_Suggestions__["a" /* Suggestions */];
        _this._styledSuggestions = getStyledSuggestions(_this.SuggestionOfProperType);
        _this.dismissSuggestions = function (ev) {
            var selectItemFunction = function () {
                if (_this.props.onDismiss) {
                    _this.props.onDismiss(ev, _this.suggestionStore.currentSuggestion ? _this.suggestionStore.currentSuggestion.item : undefined);
                }
                if (!ev || (ev && !ev.defaultPrevented)) {
                    // Select the first suggestion if one is available when user leaves.
                    if (_this.canAddItems() && _this.suggestionStore.hasSelectedSuggestion() && _this.state.suggestedDisplayValue) {
                        _this.addItemByIndex(0);
                    }
                }
            };
            if (_this.currentPromise) {
                _this.currentPromise.then(function () { return selectItemFunction(); });
            }
            else {
                selectItemFunction();
            }
            _this.setState({ suggestionsVisible: false });
        };
        _this.refocusSuggestions = function (keyCode) {
            _this.resetFocus();
            if (_this.suggestionStore.suggestions && _this.suggestionStore.suggestions.length > 0) {
                if (keyCode === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].up) {
                    _this.suggestionStore.setSelectedSuggestion(_this.suggestionStore.suggestions.length - 1);
                }
                else if (keyCode === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].down) {
                    _this.suggestionStore.setSelectedSuggestion(0);
                }
            }
        };
        _this.onInputChange = function (value) {
            _this.updateValue(value);
            _this.setState({
                moreSuggestionsAvailable: true,
                isMostRecentlyUsedVisible: false
            });
        };
        _this.onSuggestionClick = function (ev, item, index) {
            _this.addItemByIndex(index);
            _this.setState({ suggestionsVisible: false });
        };
        _this.onSuggestionRemove = function (ev, item, index) {
            if (_this.props.onRemoveSuggestion) {
                _this.props.onRemoveSuggestion(item);
            }
            _this.suggestionStore.removeSuggestion(index);
        };
        _this.onInputFocus = function (ev) {
            // Only trigger all of the focus if this component isn't already focused.
            // For example when an item is selected or removed from the selected list it should be treated
            // as though the input is still focused.
            if (!_this.state.isFocused) {
                _this.setState({ isFocused: true });
                _this.selection.setAllSelected(false);
                if (_this.input.current && _this.input.current.value === '' && _this.props.onEmptyInputFocus) {
                    _this.onEmptyInputFocus();
                    _this.setState({
                        isMostRecentlyUsedVisible: true,
                        moreSuggestionsAvailable: false,
                        suggestionsVisible: true
                    });
                }
                else if (_this.input.current && _this.input.current.value) {
                    _this.setState({
                        isMostRecentlyUsedVisible: false,
                        suggestionsVisible: true
                    });
                }
                if (_this.props.inputProps && _this.props.inputProps.onFocus) {
                    _this.props.inputProps.onFocus(ev);
                }
            }
        };
        _this.onInputBlur = function (ev) {
            if (_this.props.inputProps && _this.props.inputProps.onBlur) {
                _this.props.inputProps.onBlur(ev);
            }
        };
        _this.onBlur = function (ev) {
            if (_this.state.isFocused) {
                // Only blur the entire component if an unrelated element gets focus. Otherwise treat it as though it still has focus.
                // Do nothing if the blur is coming from something
                // inside the comboBox root or the comboBox menu since
                // it we are not really bluring from the whole comboBox
                var relatedTarget = ev.relatedTarget;
                if (ev.relatedTarget === null) {
                    // In IE11, due to lack of support, event.relatedTarget is always
                    // null making every onBlur call to be "outside" of the ComboBox
                    // even when it's not. Using document.activeElement is another way
                    // for us to be able to get what the relatedTarget without relying
                    // on the event
                    relatedTarget = document.activeElement;
                }
                if (relatedTarget && !Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["y" /* elementContains */])(_this.root.current, relatedTarget)) {
                    _this.setState({ isFocused: false });
                    if (_this.props.onBlur) {
                        _this.props.onBlur(ev);
                    }
                }
            }
        };
        _this.onKeyDown = function (ev) {
            var keyCode = ev.which;
            switch (keyCode) {
                case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].escape:
                    if (_this.state.suggestionsVisible) {
                        _this.setState({ suggestionsVisible: false });
                        ev.preventDefault();
                        ev.stopPropagation();
                    }
                    break;
                case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].tab:
                case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].enter:
                    if (_this.suggestionElement.current && _this.suggestionElement.current.hasSuggestedActionSelected()) {
                        _this.suggestionElement.current.executeSelectedAction();
                    }
                    else if (!ev.shiftKey && _this.suggestionStore.hasSelectedSuggestion() && _this.state.suggestionsVisible) {
                        _this.completeSuggestion();
                        ev.preventDefault();
                        ev.stopPropagation();
                    }
                    else {
                        _this._completeGenericSuggestion();
                    }
                    break;
                case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].backspace:
                    if (!_this.props.disabled) {
                        _this.onBackspace(ev);
                    }
                    ev.stopPropagation();
                    break;
                case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].del:
                    if (!_this.props.disabled) {
                        if (_this.input.current &&
                            ev.target === _this.input.current.inputElement &&
                            _this.state.suggestionsVisible &&
                            _this.suggestionStore.currentIndex !== -1) {
                            if (_this.props.onRemoveSuggestion) {
                                _this.props.onRemoveSuggestion(_this.suggestionStore.currentSuggestion.item);
                            }
                            _this.suggestionStore.removeSuggestion(_this.suggestionStore.currentIndex);
                            _this.forceUpdate();
                        }
                        else {
                            _this.onBackspace(ev);
                        }
                    }
                    ev.stopPropagation();
                    break;
                case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].up:
                    if (_this.input.current && ev.target === _this.input.current.inputElement && _this.state.suggestionsVisible) {
                        if (_this.suggestionElement.current &&
                            _this.suggestionElement.current.tryHandleKeyDown(keyCode, _this.suggestionStore.currentIndex)) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        else {
                            if (_this.suggestionElement.current &&
                                _this.suggestionElement.current.hasSuggestedAction() &&
                                _this.suggestionStore.currentIndex === 0) {
                                ev.preventDefault();
                                ev.stopPropagation();
                                _this.suggestionElement.current.focusAboveSuggestions();
                                _this.suggestionStore.deselectAllSuggestions();
                                _this.forceUpdate();
                            }
                            else {
                                if (_this.suggestionStore.previousSuggestion()) {
                                    ev.preventDefault();
                                    ev.stopPropagation();
                                    _this.onSuggestionSelect();
                                }
                            }
                        }
                    }
                    break;
                case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].down:
                    if (_this.input.current && ev.target === _this.input.current.inputElement && _this.state.suggestionsVisible) {
                        if (_this.suggestionElement.current &&
                            _this.suggestionElement.current.tryHandleKeyDown(keyCode, _this.suggestionStore.currentIndex)) {
                            ev.preventDefault();
                            ev.stopPropagation();
                        }
                        else {
                            if (_this.suggestionElement.current &&
                                _this.suggestionElement.current.hasSuggestedAction() &&
                                _this.suggestionStore.currentIndex + 1 === _this.suggestionStore.suggestions.length) {
                                ev.preventDefault();
                                ev.stopPropagation();
                                _this.suggestionElement.current.focusBelowSuggestions();
                                _this.suggestionStore.deselectAllSuggestions();
                                _this.forceUpdate();
                            }
                            else {
                                if (_this.suggestionStore.nextSuggestion()) {
                                    ev.preventDefault();
                                    ev.stopPropagation();
                                    _this.onSuggestionSelect();
                                }
                            }
                        }
                    }
                    break;
            }
        };
        _this.onItemChange = function (changedItem, index) {
            var items = _this.state.items;
            if (index >= 0) {
                var newItems = items;
                newItems[index] = changedItem;
                _this._updateSelectedItems(newItems);
            }
        };
        _this.onGetMoreResults = function () {
            _this.setState({
                isSearching: true
            }, function () {
                if (_this.props.onGetMoreResults && _this.input.current) {
                    var suggestions = _this.props.onGetMoreResults(_this.input.current.value, _this.state.items);
                    var suggestionsArray = suggestions;
                    var suggestionsPromiseLike = suggestions;
                    if (Array.isArray(suggestionsArray)) {
                        _this.updateSuggestions(suggestionsArray);
                        _this.setState({ isSearching: false });
                    }
                    else if (suggestionsPromiseLike.then) {
                        suggestionsPromiseLike.then(function (newSuggestions) {
                            _this.updateSuggestions(newSuggestions);
                            _this.setState({ isSearching: false });
                        });
                    }
                }
                else {
                    _this.setState({ isSearching: false });
                }
                if (_this.input.current) {
                    _this.input.current.focus();
                }
                _this.setState({
                    moreSuggestionsAvailable: false,
                    isResultsFooterVisible: true
                });
            });
        };
        _this.addItemByIndex = function (index) {
            _this.addItem(_this.suggestionStore.getSuggestionAtIndex(index).item);
            if (_this.input.current) {
                _this.input.current.clear();
            }
            _this.updateValue('');
        };
        _this.addItem = function (item) {
            var processedItem = _this.props.onItemSelected ? _this.props.onItemSelected(item) : item;
            if (processedItem === null) {
                return;
            }
            var processedItemObject = processedItem;
            var processedItemPromiseLike = processedItem;
            if (processedItemPromiseLike && processedItemPromiseLike.then) {
                processedItemPromiseLike.then(function (resolvedProcessedItem) {
                    var newItems = _this.state.items.concat([resolvedProcessedItem]);
                    _this._updateSelectedItems(newItems);
                });
            }
            else {
                var newItems = _this.state.items.concat([processedItemObject]);
                _this._updateSelectedItems(newItems);
            }
            _this.setState({ suggestedDisplayValue: '' });
        };
        _this.removeItem = function (item, focusNextItem) {
            var items = _this.state.items;
            var index = items.indexOf(item);
            if (index >= 0) {
                var newItems = items.slice(0, index).concat(items.slice(index + 1));
                _this._updateSelectedItems(newItems, focusNextItem ? index : undefined);
            }
        };
        _this.removeItems = function (itemsToRemove) {
            var items = _this.state.items;
            var newItems = items.filter(function (item) { return itemsToRemove.indexOf(item) === -1; });
            var firstItemToRemove = itemsToRemove[0];
            var index = items.indexOf(firstItemToRemove);
            _this._updateSelectedItems(newItems, index);
        };
        _this._isFocusZoneInnerKeystroke = function (ev) {
            // If suggestions are shown const up/down keys control them, otherwise allow them through to control the focusZone.
            if (_this.state.suggestionsVisible) {
                switch (ev.which) {
                    case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].up:
                    case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].down:
                        return true;
                }
            }
            if (ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].enter) {
                return true;
            }
            return false;
        };
        _this._completeGenericSuggestion = function () {
            if (_this.props.onValidateInput &&
                _this.input.current &&
                _this.props.onValidateInput(_this.input.current.value) !== __WEBPACK_IMPORTED_MODULE_9__BasePicker_types__["a" /* ValidationState */].invalid &&
                _this.props.createGenericItem) {
                var itemToConvert = _this.props.createGenericItem(_this.input.current.value, _this.props.onValidateInput(_this.input.current.value));
                _this.suggestionStore.createGenericSuggestion(itemToConvert);
                _this.completeSuggestion();
            }
        };
        var items = basePickerProps.selectedItems || basePickerProps.defaultSelectedItems || [];
        _this._id = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["N" /* getId */])();
        _this._ariaMap = {
            selectedItems: "selected-items-" + _this._id,
            selectedSuggestionAlert: "selected-suggestion-alert-" + _this._id,
            suggestionList: "suggestion-list-" + _this._id
        };
        _this.suggestionStore = new __WEBPACK_IMPORTED_MODULE_8__Suggestions_SuggestionsController__["a" /* SuggestionsController */]();
        _this.selection = new __WEBPACK_IMPORTED_MODULE_5__utilities_selection_index__["b" /* Selection */]({ onSelectionChanged: function () { return _this.onSelectionChange(); } });
        _this.selection.setItems(items);
        _this.state = {
            items: items,
            suggestedDisplayValue: '',
            isMostRecentlyUsedVisible: false,
            moreSuggestionsAvailable: false,
            isFocused: false,
            isSearching: false,
            selectedIndices: []
        };
        return _this;
    }
    Object.defineProperty(BasePicker.prototype, "items", {
        get: function () {
            return this.state.items;
        },
        enumerable: true,
        configurable: true
    });
    BasePicker.prototype.componentWillUpdate = function (newProps, newState) {
        if (newState.items && newState.items !== this.state.items) {
            this.selection.setItems(newState.items);
        }
    };
    BasePicker.prototype.componentDidMount = function () {
        this.selection.setItems(this.state.items);
        this._onResolveSuggestions = this._async.debounce(this._onResolveSuggestions, this.props.resolveDelay);
    };
    BasePicker.prototype.componentWillReceiveProps = function (newProps) {
        var _this = this;
        var newItems = newProps.selectedItems;
        if (newItems) {
            var focusIndex_1;
            // If there are less new items than old items then something was removed and we
            // should try to keep focus consistent
            if (newItems.length < this.state.items.length) {
                focusIndex_1 = this.state.items.indexOf(this.selection.getSelection()[0]);
            }
            this.setState({
                items: newProps.selectedItems
            }, function () {
                // Only update the focus if this component is currently focused to ensure that the basepicker
                // doesn't steal focus from something else.
                if (_this.state.isFocused) {
                    // Need to reset focus in the same that way that we do if an item is selected by a non-controlled component
                    // See _onSelectedItemsUpdated.
                    _this.resetFocus(focusIndex_1);
                }
            });
        }
    };
    BasePicker.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        if (this.currentPromise) {
            this.currentPromise = undefined;
        }
    };
    BasePicker.prototype.focus = function () {
        if (this.focusZone.current) {
            this.focusZone.current.focus();
        }
    };
    BasePicker.prototype.focusInput = function () {
        if (this.input.current) {
            this.input.current.focus();
        }
    };
    BasePicker.prototype.completeSuggestion = function (forceComplete) {
        if (this.suggestionStore.hasSelectedSuggestion() && this.input.current) {
            this.addItem(this.suggestionStore.currentSuggestion.item);
            this.updateValue('');
            this.input.current.clear();
        }
        else if (forceComplete) {
            this._completeGenericSuggestion();
        }
    };
    BasePicker.prototype.render = function () {
        var _a = this.state, suggestedDisplayValue = _a.suggestedDisplayValue, isFocused = _a.isFocused, items = _a.items;
        var _b = this.props, className = _b.className, inputProps = _b.inputProps, disabled = _b.disabled, theme = _b.theme, styles = _b.styles;
        var selectedSuggestionAlertId = this.props.enableSelectedSuggestionAlert ? this._ariaMap.selectedSuggestionAlert : '';
        var suggestionsAvailable = this.state.suggestionsVisible ? this._ariaMap.suggestionList : '';
        // TODO
        // Clean this up by leaving only the first part after removing support for SASS.
        // Currently we can not remove the SASS styles from BasePicker class because it
        // might be used by consumers who created custom pickers from extending from
        // this base class and have not used the new 'styles' prop.
        // We check for 'styles' prop which is going to be injected by the 'styled' HOC
        // for every other already existing picker variant (PeoplePicker, TagPicker)
        // so that we can use the CSS-in-JS styles. If the check fails (ex: custom picker),
        // then we just use the old SASS styles instead.
        var classNames = styles
            ? getClassNames(styles, {
                theme: theme,
                className: className,
                isFocused: isFocused,
                disabled: disabled,
                inputClassName: inputProps && inputProps.className
            })
            : {
                root: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-BasePicker', className ? className : ''),
                text: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-BasePicker-text', legacyStyles.pickerText, this.state.isFocused && legacyStyles.inputFocused),
                itemsWrapper: legacyStyles.pickerItems,
                input: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-BasePicker-input', legacyStyles.pickerInput, inputProps && inputProps.className),
                screenReaderText: legacyStyles.screenReaderOnly
            };
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: this.root, className: classNames.root, onKeyDown: this.onKeyDown, onBlur: this.onBlur },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__FocusZone__["a" /* FocusZone */], { componentRef: this.focusZone, direction: __WEBPACK_IMPORTED_MODULE_3__FocusZone__["b" /* FocusZoneDirection */].bidirectional, isInnerZoneKeystroke: this._isFocusZoneInnerKeystroke },
                this.getSuggestionsAlert(classNames.screenReaderText),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__utilities_selection_index__["d" /* SelectionZone */], { selection: this.selection, selectionMode: __WEBPACK_IMPORTED_MODULE_5__utilities_selection_index__["c" /* SelectionMode */].multiple },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.text },
                        items.length > 0 && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { id: this._ariaMap.selectedItems, className: classNames.itemsWrapper, role: 'list' }, this.renderItems())),
                        this.canAddItems() && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Autofill_index__["a" /* Autofill */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ spellCheck: false }, inputProps, { className: classNames.input, componentRef: this.input, onFocus: this.onInputFocus, onBlur: this.onInputBlur, onInputValueChange: this.onInputChange, suggestedDisplayValue: suggestedDisplayValue, "aria-activedescendant": this.getActiveDescendant(), "aria-expanded": !!this.state.suggestionsVisible, "aria-haspopup": "true", "aria-describedby": items.length > 0 ? this._ariaMap.selectedItems : undefined, role: 'combobox', disabled: disabled, "aria-controls": suggestionsAvailable + " " + selectedSuggestionAlertId || undefined, "aria-owns": suggestionsAvailable || undefined, onInputChange: this.props.onInputChange })))))),
            this.renderSuggestions()));
    };
    BasePicker.prototype.canAddItems = function () {
        var items = this.state.items;
        var itemLimit = this.props.itemLimit;
        return itemLimit === undefined || items.length < itemLimit;
    };
    BasePicker.prototype.renderSuggestions = function () {
        var StyledTypedSuggestions = this._styledSuggestions;
        return this.state.suggestionsVisible && this.input ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Callout__["a" /* Callout */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ isBeakVisible: false, gapSpace: 5, target: this.input.current ? this.input.current.inputElement : undefined, onDismiss: this.dismissSuggestions, directionalHint: __WEBPACK_IMPORTED_MODULE_4__Callout__["b" /* DirectionalHint */].bottomLeftEdge, directionalHintForRTL: __WEBPACK_IMPORTED_MODULE_4__Callout__["b" /* DirectionalHint */].bottomRightEdge }, this.props.pickerCalloutProps),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](StyledTypedSuggestions, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ onRenderSuggestion: this.props.onRenderSuggestionsItem, onSuggestionClick: this.onSuggestionClick, onSuggestionRemove: this.onSuggestionRemove, suggestions: this.suggestionStore.getSuggestions(), componentRef: this.suggestionElement, onGetMoreResults: this.onGetMoreResults, moreSuggestionsAvailable: this.state.moreSuggestionsAvailable, isLoading: this.state.suggestionsLoading, isSearching: this.state.isSearching, isMostRecentlyUsedVisible: this.state.isMostRecentlyUsedVisible, isResultsFooterVisible: this.state.isResultsFooterVisible, refocusSuggestions: this.refocusSuggestions, removeSuggestionAriaLabel: this.props.removeButtonAriaLabel, suggestionsListId: this._ariaMap.suggestionList, createGenericItem: this._completeGenericSuggestion }, this.props.pickerSuggestionsProps)))) : null;
    };
    BasePicker.prototype.renderItems = function () {
        var _this = this;
        var _a = this.props, disabled = _a.disabled, removeButtonAriaLabel = _a.removeButtonAriaLabel;
        var onRenderItem = this.props.onRenderItem;
        var _b = this.state, items = _b.items, selectedIndices = _b.selectedIndices;
        return items.map(function (item, index) {
            return onRenderItem({
                item: item,
                index: index,
                key: item.key ? item.key : index,
                selected: selectedIndices.indexOf(index) !== -1,
                onRemoveItem: function () { return _this.removeItem(item, true); },
                disabled: disabled,
                onItemChange: _this.onItemChange,
                removeButtonAriaLabel: removeButtonAriaLabel
            });
        });
    };
    BasePicker.prototype.resetFocus = function (index) {
        var items = this.state.items;
        if (items.length && index >= 0) {
            var newEl = this.root.current &&
                this.root.current.querySelectorAll('[data-selection-index]')[Math.min(index, items.length - 1)];
            if (newEl && this.focusZone.current) {
                this.focusZone.current.focusElement(newEl);
            }
        }
        else if (!this.canAddItems()) {
            this.resetFocus(items.length - 1);
        }
        else {
            if (this.input.current) {
                this.input.current.focus();
            }
        }
    };
    BasePicker.prototype.onSuggestionSelect = function () {
        if (this.suggestionStore.currentSuggestion) {
            var currentValue = this.input.current ? this.input.current.value : '';
            var itemValue = this._getTextFromItem(this.suggestionStore.currentSuggestion.item, currentValue);
            this.setState({ suggestedDisplayValue: itemValue });
        }
    };
    BasePicker.prototype.onSelectionChange = function () {
        this.setState({
            selectedIndices: this.selection.getSelectedIndices()
        });
    };
    BasePicker.prototype.updateSuggestions = function (suggestions) {
        this.suggestionStore.updateSuggestions(suggestions, 0);
        this.forceUpdate();
    };
    BasePicker.prototype.onEmptyInputFocus = function () {
        var onEmptyInputFocus = this.props.onEmptyInputFocus;
        var suggestions = onEmptyInputFocus(this.state.items);
        this.updateSuggestionsList(suggestions);
    };
    BasePicker.prototype.updateValue = function (updatedValue) {
        this._onResolveSuggestions(updatedValue);
    };
    BasePicker.prototype.updateSuggestionsList = function (suggestions, updatedValue) {
        var _this = this;
        var suggestionsArray = suggestions;
        var suggestionsPromiseLike = suggestions;
        // Check to see if the returned value is an array, if it is then just pass it into the next function .
        // If the returned value is not an array then check to see if it's a promise or PromiseLike. If it is then resolve it asynchronously.
        if (Array.isArray(suggestionsArray)) {
            this._updateAndResolveValue(updatedValue, suggestionsArray);
        }
        else if (suggestionsPromiseLike && suggestionsPromiseLike.then) {
            this.setState({
                suggestionsLoading: true
            });
            // Clear suggestions
            this.suggestionStore.updateSuggestions([]);
            if (updatedValue !== undefined) {
                this.setState({
                    suggestionsVisible: this.input.current
                        ? this.input.current.value !== '' && this.input.current.inputElement === document.activeElement
                        : false
                });
            }
            else {
                this.setState({
                    suggestionsVisible: this.input.current ? this.input.current.inputElement === document.activeElement : false
                });
            }
            // Ensure that the promise will only use the callback if it was the most recent one.
            var promise_1 = (this.currentPromise = suggestionsPromiseLike);
            promise_1.then(function (newSuggestions) {
                if (promise_1 === _this.currentPromise) {
                    _this._updateAndResolveValue(updatedValue, newSuggestions);
                }
            });
        }
    };
    BasePicker.prototype.resolveNewValue = function (updatedValue, suggestions) {
        var _this = this;
        this.updateSuggestions(suggestions);
        var itemValue = undefined;
        if (this.suggestionStore.currentSuggestion) {
            itemValue = this._getTextFromItem(this.suggestionStore.currentSuggestion.item, updatedValue);
        }
        // Only set suggestionloading to false after there has been time for the new suggestions to flow
        // to the suggestions list. This is to ensure that the suggestions are available before aria-activedescendant
        // is set so that screen readers will read out the first selected option.
        this.setState({
            suggestedDisplayValue: itemValue,
            suggestionsVisible: this.input.current
                ? this.input.current.value !== '' && this.input.current.inputElement === document.activeElement
                : false
        }, function () { return _this.setState({ suggestionsLoading: false }); });
    };
    BasePicker.prototype.onChange = function (items) {
        if (this.props.onChange) {
            this.props.onChange(items);
        }
    };
    // This is protected because we may expect the backspace key to work differently in a different kind of picker.
    // This lets the subclass override it and provide it's own onBackspace. For an example see the BasePickerListBelow
    BasePicker.prototype.onBackspace = function (ev) {
        if ((this.state.items.length && !this.input.current) ||
            (this.input.current && !this.input.current.isValueSelected && this.input.current.cursorLocation === 0)) {
            if (this.selection.getSelectedCount() > 0) {
                this.removeItems(this.selection.getSelection());
            }
            else {
                this.removeItem(this.state.items[this.state.items.length - 1]);
            }
        }
    };
    BasePicker.prototype.getActiveDescendant = function () {
        var currentIndex = this.suggestionStore.currentIndex;
        return currentIndex > -1 && !this.state.suggestionsLoading ? 'sug-' + currentIndex : undefined;
    };
    BasePicker.prototype.getSuggestionsAlert = function (suggestionAlertClassName) {
        if (suggestionAlertClassName === void 0) { suggestionAlertClassName = legacyStyles.screenReaderOnly; }
        var currentIndex = this.suggestionStore.currentIndex;
        if (this.props.enableSelectedSuggestionAlert) {
            var selectedSuggestion = currentIndex > -1 ? this.suggestionStore.getSuggestionAtIndex(this.suggestionStore.currentIndex) : undefined;
            var selectedSuggestionAlertText = selectedSuggestion ? selectedSuggestion.ariaLabel : undefined;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: suggestionAlertClassName, role: "alert", id: this._ariaMap.selectedSuggestionAlert, "aria-live": "assertive" },
                selectedSuggestionAlertText,
                ' '));
        }
    };
    /**
     * Takes in the current updated value and either resolves it with the new suggestions
     * or if updated value is undefined then it clears out currently suggested items
     */
    BasePicker.prototype._updateAndResolveValue = function (updatedValue, newSuggestions) {
        if (updatedValue !== undefined) {
            this.resolveNewValue(updatedValue, newSuggestions);
        }
        else {
            this.suggestionStore.updateSuggestions(newSuggestions, -1);
            if (this.state.suggestionsLoading) {
                this.setState({
                    suggestionsLoading: false
                });
            }
        }
    };
    /**
     * Controls what happens whenever there is an action that impacts the selected items.
     * If selectedItems is provided as a property then this will act as a controlled component and it will not update it's own state.
     */
    BasePicker.prototype._updateSelectedItems = function (items, focusIndex) {
        var _this = this;
        if (this.props.selectedItems) {
            // If the component is a controlled component then the controlling component will need to add or remove the items.
            this.onChange(items);
        }
        else {
            this.setState({ items: items }, function () {
                _this._onSelectedItemsUpdated(items, focusIndex);
            });
        }
    };
    BasePicker.prototype._onSelectedItemsUpdated = function (items, focusIndex) {
        this.resetFocus(focusIndex);
        this.onChange(items);
    };
    BasePicker.prototype._onResolveSuggestions = function (updatedValue) {
        var suggestions = this.props.onResolveSuggestions(updatedValue, this.state.items);
        if (suggestions !== null) {
            this.updateSuggestionsList(suggestions, updatedValue);
        }
    };
    BasePicker.prototype._getTextFromItem = function (item, currentValue) {
        if (this.props.getTextFromItem) {
            return this.props.getTextFromItem(item, currentValue);
        }
        else {
            return '';
        }
    };
    return BasePicker;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

var BasePickerListBelow = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](BasePickerListBelow, _super);
    function BasePickerListBelow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BasePickerListBelow.prototype.render = function () {
        var _a = this.state, suggestedDisplayValue = _a.suggestedDisplayValue, isFocused = _a.isFocused;
        var _b = this.props, className = _b.className, inputProps = _b.inputProps, disabled = _b.disabled, theme = _b.theme, styles = _b.styles;
        var selectedSuggestionAlertId = this.props.enableSelectedSuggestionAlert
            ? this._ariaMap.selectedSuggestionAlert
            : '';
        var suggestionsAvailable = this.state.suggestionsVisible ? this._ariaMap.suggestionList : '';
        // TODO
        // Clean this up by leaving only the first part after removing support for SASS.
        // Currently we can not remove the SASS styles from BasePicker class because it
        // might be used by consumers who created custom pickers from extending from
        // this base class and have not used the new 'styles' prop.
        // We check for 'styles' prop which is going to be injected by the 'styled' HOC
        // for every other already existing picker variant (PeoplePicker, TagPicker)
        // so that we can use the CSS-in-JS styles. If the check fails (ex: custom picker),
        // then we just use the old SASS styles instead.
        var classNames = styles
            ? getClassNames(styles, {
                theme: theme,
                className: className,
                isFocused: isFocused,
                inputClassName: inputProps && inputProps.className
            })
            : {
                root: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-BasePicker', className ? className : ''),
                text: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-BasePicker-text', legacyStyles.pickerText, this.state.isFocused && legacyStyles.inputFocused),
                input: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-BasePicker-input', legacyStyles.pickerInput, inputProps && inputProps.className),
                screenReaderText: legacyStyles.screenReaderOnly
            };
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: this.root, onBlur: this.onBlur },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.root, onKeyDown: this.onKeyDown },
                this.getSuggestionsAlert(classNames.screenReaderText),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.text },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Autofill_index__["a" /* Autofill */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, inputProps, { className: classNames.input, componentRef: this.input, onFocus: this.onInputFocus, onBlur: this.onInputBlur, onInputValueChange: this.onInputChange, suggestedDisplayValue: suggestedDisplayValue, "aria-activedescendant": this.getActiveDescendant(), "aria-expanded": !!this.state.suggestionsVisible, role: "combobox", disabled: disabled, "aria-controls": suggestionsAvailable + " " + selectedSuggestionAlertId || undefined, "aria-owns": suggestionsAvailable || undefined, onInputChange: this.props.onInputChange })))),
            this.renderSuggestions(),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__utilities_selection_index__["d" /* SelectionZone */], { selection: this.selection, selectionMode: __WEBPACK_IMPORTED_MODULE_5__utilities_selection_index__["c" /* SelectionMode */].single },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__FocusZone__["a" /* FocusZone */], { componentRef: this.focusZone, className: "ms-BasePicker-selectedItems" // just a className hook without any styles applied to it.
                    , isCircularNavigation: true, direction: __WEBPACK_IMPORTED_MODULE_3__FocusZone__["b" /* FocusZoneDirection */].bidirectional, isInnerZoneKeystroke: this._isFocusZoneInnerKeystroke, id: this._ariaMap.selectedItems, role: 'list' }, this.renderItems()))));
    };
    BasePickerListBelow.prototype.onBackspace = function (ev) {
        // override the existing backspace method to not do anything because the list items appear below.
    };
    return BasePickerListBelow;
}(BasePicker));

//# sourceMappingURL=BasePicker.js.map

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExpandingCardMode; });
/**
 * {@docCategory HoverCard}
 */
var ExpandingCardMode;
(function (ExpandingCardMode) {
    /**
     * To have top compact card only
     */
    ExpandingCardMode[ExpandingCardMode["compact"] = 0] = "compact";
    /**
     * To have both top compact and bottom expanded card
     */
    ExpandingCardMode[ExpandingCardMode["expanded"] = 1] = "expanded";
})(ExpandingCardMode || (ExpandingCardMode = {}));
//# sourceMappingURL=ExpandingCard.types.js.map

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MessageBarType; });
/**
 * {@docCategory MessageBar}
 */
var MessageBarType;
(function (MessageBarType) {
    /** Info styled MessageBar */
    MessageBarType[MessageBarType["info"] = 0] = "info";
    /** Error styled MessageBar */
    MessageBarType[MessageBarType["error"] = 1] = "error";
    /** Blocked styled MessageBar */
    MessageBarType[MessageBarType["blocked"] = 2] = "blocked";
    /** SevereWarning styled MessageBar */
    MessageBarType[MessageBarType["severeWarning"] = 3] = "severeWarning";
    /** Success styled MessageBar */
    MessageBarType[MessageBarType["success"] = 4] = "success";
    /** Warning styled MessageBar */
    MessageBarType[MessageBarType["warning"] = 5] = "warning";
    /**
     * Deprecated at v0.48.0, to be removed at \>= v1.0.0. Use `blocked` instead.
     * @deprecated Use `blocked` instead.
     */
    MessageBarType[MessageBarType["remove"] = 90000] = "remove";
})(MessageBarType || (MessageBarType = {}));
//# sourceMappingURL=MessageBar.types.js.map

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PivotLinkFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PivotLinkSize; });
/**
 * {@docCategory Pivot}
 */
var PivotLinkFormat;
(function (PivotLinkFormat) {
    /**
     * Display Pivot Links as links
     */
    PivotLinkFormat[PivotLinkFormat["links"] = 0] = "links";
    /**
     * Display Pivot Links as Tabs
     */
    PivotLinkFormat[PivotLinkFormat["tabs"] = 1] = "tabs";
})(PivotLinkFormat || (PivotLinkFormat = {}));
/**
 * {@docCategory Pivot}
 */
var PivotLinkSize;
(function (PivotLinkSize) {
    /**
     * Display Link using normal font size
     */
    PivotLinkSize[PivotLinkSize["normal"] = 0] = "normal";
    /**
     * Display links using large font size
     */
    PivotLinkSize[PivotLinkSize["large"] = 1] = "large";
})(PivotLinkSize || (PivotLinkSize = {}));
//# sourceMappingURL=Pivot.types.js.map

/***/ }),
/* 441 */
/***/ (function(module, exports) {

module.exports = {"companylegalform::simple_society":"Einfache Gesellschaft","companylegalform::general_partnership":"Kollektivgesellschaft","companylegalform::limited_partnership":"Kommanditgesellschaft","companylegalform::jointstock_company":"Aktiengesellschaft (AG)","companylegalform::kommanditaktiengesellschaft":"Kommandit-Aktiengesellschaft","companylegalform::limited_liability_company":"Gesellschaft mit beschränkter Haftung (GmbH)","companylegalform::cooperative":"Genossenschaft","companylegalform::society":"Verein","companylegalform::foundation":"Stiftung","companylegalform::other":"Sonstige","deposittype::none":"Keine","deposittype::fixed_amount":"Fester Betrag","deposittype::percentage":"Prozentsatz","documenttype::expose":"Exposé (Immobilienbeschreibung)","documenttype::land_register":"Grundbuchauszug","documenttype::location_map":"Lage- / Katasterplan","documenttype::energy_certificate":"Energieausweis","documenttype::area_measurement":"Wohn- / Flächenberechnung","documenttype::built_area":"Kubaturberechnung (umbauter Raum)","documenttype::area_allocation_plan":"Zeichnungen / Flächenpläne","documenttype::partition_deed":"Teilungserklärung","documenttype::rental_contract":"Mietvertrag","documenttype::appraisal":"Nutzwertgutachten","documenttype::easement_register":"Baulastenverzeichnis","documenttype::partition_plan":"Teilungsplan","documenttype::building_permit":"Baugenehmigung","documenttype::utility_costs":"Nebenkostenabrechnung","documenttype::annual_statement":"Jahresabrechnung","documenttype::reserves":"Rücklagen","documenttype::community_minutes":"WEG-Protokolle","documenttype::insurance_policy":"Gebäudeversicherung","handovertype::land_register":"Nach Grundbucheintragung","handovertype::money_transfer":"Nach Überweisung des Kaufpreises","handovertype::key_handover":"Bei Schlüsselübergabe","handovertype::sale_contract":"Gemäß Kaufvertrag","maritalstatus::none":" ","ownershiptype::joint":"Gesamteigentum","phone_number":"Mobilnummer","uploadtype::identity_document":"Identitätsnachweis","uploadtype::residence_permit":"Aufenthaltsstatus","uploadtype::proof_of_financial_resources":"Finanzierungsnachweis","ListingsOverview::number":"Objekt-Nr","ListingsOverview::title":"Objekt-Titel","ListingsOverview::pending_offers":"Angebote","AgencyDataForm::iban_tooltip":"Makler-Konto auf welches der vom Verkäufer ausgewählte Käufer seine Reservierungsgebühr zahlen muss.","AgencyDataForm::iban_invalid":"Die IBAN ist nicht korrekt","Page1::object_number":"Objekt-Nr.","Page1::additional_description":"Sonstige Beschreibungen und wichtige Hinweise zum Objekt","Page1::known_defects":"Bekannte Mängel","Page1::no_known_defects":"Keine Mängel bekannt","Page1::following_known_defects":"Folgende Mängel sind bekannt","Page2::seller":"Verkäufer/Eigentümer","Page2::bank":"Bankverbindung des Maklers","Page2::notary":"Notar","Page2::deposit_and_noncompliance":"Reservierungsgebühr und Aufwandsentschädigung","Page2::allowance_for_noncompliance":"Aufwandsentschädigung bei Nichterfüllung","Page2::total_amount_must_be_documented":"Gesamtbetrag muss durch Belege nachweisbar sein","Page2::from_offer_value":"vom Angebotspreis","Page2::from_agent_commission":"von Brutto-Maklerprovision","Page2::can_be_max_max_of_the_gross_agent_commission":"Darf max. {max}% der Brutto-Maklerprovision entsprechen","Page2::provision_title":"Käufer-Maklerprovision (brutto)","Page2::deposit_title":"Reservierungsgebühr","Page2::provision":"Käufer-Maklerprovision (brutto)","Page2::deposit":"Reservierungsgebühr","Page3::documents":"Objektunterlagen","AgentProvisionForm::agent_commission":"Käufer-Maklerprovision (brutto)","AgentProvisionForm::agent_commission_description":"% vom Angebotspreis","AgentProvisionForm::agent_commission_tooltip":"Muss max. 1,19% der Brutto-Maklerprovision entsprechen","RefuseDialog::required_documents":"Erforderliche Unterlagen","RefuseDialog::optional_documents":"Optionale Unterlagen","RegistrationPanel::required_documents":"Erforderliche Unterlagen","RegistrationPanel::offer_viewing":"Besichtigungstermin erfolgte am","Sale::billing_notice":"Die Kosten dieses Angebotsverfahrens in Höhe von 0,1% des höchsten eingegangen Gebotes werden dem beauftragenden Makler in Rechnung gestellt. Geht kein Angebot ein, entstehen keine Kosten.","Sale::guide__open_round":"Um das digitale Angebotsverfahren zu starten und einzelne Kunden einzuladen, müssen Sie die Runde öffnen","Sale::guide__invite_users":"Um einen Interessenten einzuladen, brauchen Sie seinen vollen Namen, seine E-Mail-Adresse und seine Mobilnummer.","Sale::open_round_info_notice_sealedbidding":"Sie starten eine <strong>geschlossene</strong> Runde mit <strong>Richtpreis von {estimate}</strong> die <strong>{duration}</strong> am {date} <strong>um {time} endet.</strong>","Sale::open_round_info_notice_openbidding":"Sie starten eine <strong>offene</strong> Runde mit <strong>Startpreis von {startPrice}</strong> die <strong>{duration}</strong> am {date} <strong>um {time} endet.</strong>","RegistrationPanel::optional_documents":"Optionale Unterlagen","RegistrationPanel::locale":"Bevorzugte Sprache","BuyerDataForm::acting_organ__function":"Handelndes Organ - Funktion","SaleCreatePanel::price_tooltip":"Offizieller Listing-Preis, der auf der amarc21-Webseite bzw. in onOffice hinterlegt ist.","RoundEdit::red_button_price":"Niedrigster Verkaufspreis (Red Button Preis)","RoundEdit::open_round_warning":"Im offenen Angebotsverfahren ist nur eine Runde vorgesehen und alle Angebotspreise sind für alle Teilnehmer offen einsehbar.","RoundEdit::bidding_type_tooltip":"Beim offenen Verfahren muss mindestens der Startpreis geboten werden, alle eingehenden Kaufpreisangebote werden anonymisiert offengelegt und teilnehmende Bieter können ihr Angebot beliebig häufig in festgelegten Mindestschritten erhöhen. Beim geschlossenen Verfahren können Kaufinteressenten nur ein Angebot abgeben, dessen Höhe frei wählbar ist und bis Ende des Verfahrens im System verschlüsselt ist und erst nach Ende dem Makler offengelegt wird.","RoundPanel::round":"Eckdaten der Runde festlegen","provisiontype::none":"Keine zusätzliche Käuferprovision","provisiontype::fixed_amount":"Pauschalbetrag","provisiontype::fixed_percentage":"Prozentsatz","NotaryDataForm::company_name":"Kanzlei","phone_number_placeholder":"+49 150 0000 0000"}

/***/ }),
/* 442 */
/***/ (function(module, exports) {

module.exports = {"companylegalform::simple_society":"Ordinary company (Einfache Gesellschaft)","companylegalform::general_partnership":"General partnership (Kollektivgesellschaft)","companylegalform::limited_partnership":"Limited partnership (Kommanditgesellschaft)","companylegalform::jointstock_company":"Joint-stock company (Aktiengesellschaft)","companylegalform::kommanditaktiengesellschaft":"Limited stock company (Kommandit-Aktiengesellschaft)","companylegalform::limited_liability_company":"Limited liability company (GmbH)","companylegalform::cooperative":"Cooperative (Genossenschaft)","companylegalform::society":"Association (Verein)","companylegalform::foundation":"Foundation (Stiftung)","companylegalform::other":"Other","deposittype::none":"None","deposittype::fixed_amount":"Fixed amount","deposittype::percentage":"Percentage","documenttype::annual_statement":"Annual statement","documenttype::area_allocation_plan":"Area plans","documenttype::area_measurement":"Area measurement","documenttype::building_permit":"Building permit","documenttype::easement_register":"Easement register","documenttype::insurance_policy":"Special building insurance notice / insurance policy","documenttype::location_map":"Location map","documenttype::partition_deed":"Partition deed","documenttype::partition_plan":"Partition plan","documenttype::rental_contract":"Rental contract","documenttype::reserves":"Reserves","documenttype::utility_costs":"Utility costs","documenttype::weg_protocols":"WEG protocols","handovertype::land_register":"After entry in the land register excerpt","handovertype::money_transfer":"After transfer of the purchase price to a predefined account","handovertype::key_handover":"After key handover","handovertype::sale_contract":"According to the sales contract","ownershiptype::joint":"Joint ownership","upload_more":"Upload more documents","uploadtype::identity_document":"Identity document","uploadtype::residence_permit":"Residence permit","uploadtype::proof_of_financial_resources":"Proof of financing","AgencyDataForm::iban_tooltip":"Enter here the IBAN of the brokerage account, to which the prospective buyer has to pay the reservation fee.","ListingsOverview::number":"Property ID","ListingsOverview::title":"Title","ListingsOverview::pending_offers":"Offers","Page1::object_number":"Property ID","Page1::additional_description":"Other descriptions and important information about the property","Page1::known_defects":"Known defects","Page1::no_known_defects":"No defects known","Page1::following_known_defects":"The following defects are known","Page2::seller":"Seller/owner","Page2::bank":"Agent's bank details","Page2::deposit":"Deposit","Page2::allowance_for_noncompliance":"Allowance for non-compliance","Page2::total_amount_must_be_documented":"Total amount must be documented!","Page2::from_offer_value":"of the offer price","Page2::from_agent_commission":"of gross agent commission","Page2::can_be_max_max_of_the_gross_agent_commission":"Can be max {max}% of the gross agent commission","Page3::documents":"Property documents","AgentProvisionForm::agent_commission":"Agent commission (brutto)","AgentProvisionForm::agent_commission_description":"% of the offer price","AgentProvisionForm::agent_commission_tooltip":"Must be max. 1.19% of the gross agent commission","RefuseDialog::required_documents":"Required documents","RefuseDialog::optional_documents":"Optional documents","RegistrationPanel::required_documents":"Required documents","RegistrationPanel::offer_viewing":"Seen on","Sale::billing_notice":"The costs of this offer procedure amounting to 0.1% of the highest bid received will be charged to the commissioning broker.","RegistrationPanel::optional_documents":"Optional documents","RegistrationPanel::locale":"Preferred language","BuyerDataForm::acting_organ__function":"Authorized representative - role","SaleCreatePanel::price_tooltip":"Official listing price, which is stored on the Amarc21 website or in onOffice","RoundEdit::bidding_type_tooltip":"With the open procedure, at least the starting price must be offered, all incoming purchase price offers are disclosed anonymously and participating bidders can increase their offer as often as required in defined minimum steps. In the closed process, prospective buyers can only submit an offer, the amount of which can be freely selected and is encrypted in the system until the end of the process and is only disclosed to the broker after the end.","phone_number_placeholder":"+49 150 0000 0000"}

/***/ }),
/* 443 */
/***/ (function(module, exports) {

module.exports = {"AgentProvisionForm::agent_commission":"Käuferprovision (inkl. ges. MwSt.)","AgentProvisionForm::agent_commission_description":"% vom Kaufpreis","AgentProvisionForm::agent_commission_tooltip":"Muss max. 1,19% der Brutto-Maklerprovision entsprechen","bid_amount":"Angebotshöhe","BulkRegistrationCsvPanel::consent_to_use_data":"Einwilligung zur Datennutzung","BulkRegistrationCsvPanel::data_protection":"Datenschutz","BulkRegistrationCsvPanel::duplicate_description":"Datensatz bereits vorhanden","BulkRegistrationCsvPanel::full_salutation":"Briefanrede","BulkRegistrationCsvPanel::granted":"erteilt","BulkRegistrationCsvPanel::invalid_description":"Datensatz unvollständig (bitte in FIO vervollständigen und erneut per CSV-Datei importieren)","BulkRegistrationCsvPanel::legitimation":"Legitimation","BulkRegistrationCsvPanel::legitimation_status":"Legitimation Status","BulkRegistrationCsvPanel::valid_description":"Datensatz vollständig","BuyerDataForm::acting_organ__function":"Funktion","Commands::are_you_sure_to_block_user":"Hiermit wird der Kaufinteressent gesperrt und vom weiteren Angebotsprozess ausgeschlossen. Sind Sie sicher?","Commands::are_you_sure_to_end_round_early":"Wenn Sie das Verfahren vorzeitig beenden können keine weiteren Angebote mehr abgegeben werden. Sind Sie sicher?","Commands::are_you_sure_to_end_round_early_sealed":"Wenn Sie das Verfahren vorzeitig beenden können keine weiteren Angebote mehr abgegeben werden. Sind Sie sicher?","Commands::block_user":"Kaufinteressenten sperren","Commands::refuse":"Stornieren","company_id":"Handelsregisternummer","customer_name":"Name","deposittype::fixed_amount":"Fester Betrag","deposittype::none":"Keine","deposittype::percentage":"Prozentsatz","duration":"Ende der Angebotsverfahrens","field::full_salutation":"Briefanrede","ListingsOverview::number":"Objekt-Nr","ListingsOverview::pending_offers":"Angebote","ListingsOverview::title":"Objekt-Titel","maritalstatus::none":" ","notificationemailtemplate::cust_offer_refused":"Kaufangebot storniert","notificationemailtemplate::open_cust_offer_refused":"Kaufangebot storniert","offerstatus::refused":"Storniert","ownershiptype::joint":"Gesamteigentum","Page1::from_offer_value":"vom Kaufpreis","Page1::provision":"Käuferprovision (inkl. ges. MwSt.)","phone_number":"Mobilnummer","phone_number_placeholder":"+49 150 0000 0000","provisiontype::fixed_amount":"Pauschalbetrag","provisiontype::fixed_percentage":"Prozentsatz","provisiontype::none":"Keine","RefuseDialog::explanation":"Informieren Sie den Interessenten über den Grund der Stornierung.","RefuseDialog::refuse_an_offer":"Angebot stornieren","RegistrationPanel::bidding":"Gebote","RegistrationPanel::buyer":"Interessent","RoundEdit::antisniping_notice":"Das Ende der Angebotsfrist verlängert sich um 15 Minuten, wenn innerhalb der letzten 15 Minuten vor Ende der Angebotsfrist ein weiteres Angebot eingeht. Diese Verlängerung wiederholt sich, bis 15 Minuten lang kein weiteres Angebot mehr abgegeben wird.","RoundEdit::bidding_type_tooltip":"Beim offenen Verfahren muss mindestens der Angebotspreis geboten werden, alle eingehenden Kaufpreisangebote werden anonymisiert offengelegt und teilnehmende Interessenten können ihr Angebot beliebig häufig in festgelegten Mindestschritten erhöhen. Beim geschlossenen Verfahren können Kaufinteressenten nur ein Angebot abgeben, das bis Ende des Verfahrens im System verschlüsselt ist, dessen Höhe frei wählbar ist und welches erst nach Ende des Angebotsverfahrens dem Makler offengelegt wird.","RoundEdit::end_date_changed":"Alle eingeladenen Interessenten und Makler werden über die Änderung des Endes des Angebotsverfahrens per E-Mail informiert.","RoundEdit::ends_at":"Ende des Angebotsverfahrens","RoundEdit::estimate":"Angebotspreis","RoundEdit::estimate__tooltip":"Der Angebotspreis ist ein Preis, der dem Kaufinteressenten als Angebotspreis kommuniziert wird. Dies dient als Hilfestellung bei der Festlegung seines eigenen Angebotspreises. Wichtig: Der Angebotspreis stellt keinen Mindestpreis dar. D.h. der Interessent kann auch ein Angebot unterhalb des Angebotspreises abgeben.","RoundEdit::open_round_warning":"Im offenen Angebotsverfahren ist nur eine Runde vorgesehen und alle Angebotspreise sind für alle Teilnehmer offen einsehbar.","RoundEdit::starting_price":"Angebotspreis","RoundEdit::starting_price__tooltip":"Preis, den der Kaufinteressent bei Abgabe des ersten Angebotes mindestens bieten muss.","RoundPanel::round":"Eckdaten der Runde festlegen","roundtype::sealed_bidding":"Geschlossenes Angebotsverfahren","Sale::billing_notice":" ","Sale::cannot_update_documents_for_open_round__documents_uploaded":" ","Sale::cannot_update_documents_for_open_round__no_documents":" ","Sale::guide__edit_round":"Falls die Rundendaten nicht korrekt sind, passen Sie diese an","Sale::guide__import_users_csv":"Importieren Sie nun die Interessenten aus FIO mittels einer CSV-Datei","Sale::guide__invite_users":"Um einen Interessenten einzuladen, brauchen Sie seinen vollen Namen, seine E-Mail-Adresse und seine Mobilnummer.","Sale::guide__open_round":"Um das Angebotsverfahren zu starten und Interessenten einzuladen, müssen Sie die Runde öffnen","Sale::guide__start_round":"Als Nächstes müssen Sie die Eckdaten zum Rundenverlauf eintragen","Sale::guide__start_round_edit_sale":"Hier können Sie das Kaufangebotsformular noch einmal kontrollieren","Sale::guide_action__edit_round":"Anpassen","Sale::guide_action__import_users_csv":"CSV-Datei hochladen","Sale::guides__round_closed":"Das Angebotsverfahren ist beendet. Sie können nun eine \"Übersicht\" der Kaufpreisangebote erzeugen und diese an den Eigentümer übermitteln.","Sale::open_round_info_notice_openbidding":"Sie starten eine <strong>offene</strong> Runde mit <strong>Startpreis von {startPrice}</strong>, die <strong>{duration}</strong> am {date} <strong>um {time} endet.</strong>","Sale::open_round_info_notice_openbidding_fixed":"Sie öffnen eine <strong>offene</strong> Runde mit <strong>Startpreis von {startPrice}</strong>, die <strong>voraussichtlich {duration}</strong> am {date} <strong>um {time} endet.</strong>","Sale::open_round_info_notice_openbidding_flexible":"Sie öffnen eine <strong>offene</strong> Runde mit <strong>Startpreis von {startPrice}</strong>, die <strong>voraussichtlich in {duration} Tagen</strong> nach Eingang vom ersten Angebot endet.</strong>","Sale::open_round_info_notice_sealedbidding":"Sie starten eine <strong>verdeckte</strong> Runde mit <strong>Richtpreis von {estimate}</strong>, die <strong>{duration}</strong> am {date} <strong>um {time} endet.</strong>","Sale::open_round_info_notice_sealedbidding_fixed":"Sie öffnen eine <strong>verdeckte</strong> Runde mit <strong>Richtpreis von {estimate}</strong>, die <strong>voraussichtlich {duration}</strong> am {date} <strong>um {time} endet.</strong>","Sale::open_round_info_notice_sealedbidding_flexible":"Sie öffnen eine <strong>verdeckte</strong> Runde mit <strong>Richtpreis von {estimate}</strong>, die <strong>voraussichtlich in {duration} Tagen</strong> nach Eingang vom ersten Angebot endet.</strong>","SaleCreatePanel::agbs":"Nutzungsvereinbarung","SaleCreatePanel::avv":"Auftragsverarbeitungsvereinbarung","SaleCreatePanel::dataprotection":"Datenschutzerklärung","SaleCreatePanel::i_agree_to_the_link":"Ich habe die {agbs} gelesen und stimme dieser zu.","SaleCreatePanel::price_tooltip":"Offizieller Listing-Preis, der in onOffice hinterlegt ist","Search::agbs":"Nutzungsvereinbarung","Search::avv":"Auftragsverarbeitungsvereinbarung","Search::dataprotection":"Datenschutzerklärung","Search::i_agree_to_the_link":"Ich habe die {agbs} gelesen und stimme dieser zu.","street_and_house_number":"Anschrift","submitted_value":"Angebotshöhe","uploadtype::identity_document":"Identitätsnachweis","uploadtype::proof_of_financial_resources":"Finanzierungsnachweis","uploadtype::residence_permit":"Aufenthaltsstatus"}

/***/ }),
/* 444 */
/***/ (function(module, exports) {

module.exports = {"companylegalform::simple_society":"Ordinary company (Einfache Gesellschaft)","companylegalform::general_partnership":"General partnership (Kollektivgesellschaft)","companylegalform::limited_partnership":"Limited partnership (Kommanditgesellschaft)","companylegalform::jointstock_company":"Joint-stock company (Aktiengesellschaft)","companylegalform::kommanditaktiengesellschaft":"Limited stock company (Kommandit-Aktiengesellschaft)","companylegalform::limited_liability_company":"Limited liability company (GmbH)","companylegalform::cooperative":"Cooperative (Genossenschaft)","companylegalform::society":"Association (Verein)","companylegalform::foundation":"Foundation (Stiftung)","companylegalform::other":"Other","deposittype::none":"None","deposittype::fixed_amount":"Fixed amount","deposittype::percentage":"Percentage","documenttype::annual_statement":"Annual statement","documenttype::appraisal":"Appraisal","documenttype::area_allocation_plan":"Area allocation plan","documenttype::area_measurement":"Area measurement","documenttype::building_permit":"Building permit","documenttype::easement_register":"Easement register","documenttype::energy_certificate":"Energy certificate","documenttype::expose":"Exposé","documenttype::insurance_policy":"Insurance policy","documenttype::land_register":"Land register","documenttype::location_map":"Location map","documenttype::partition_deed":"Partition deed","documenttype::partition_plan":"Partition plan","documenttype::rental_contract":"Rental contract","documenttype::reserves":"Reserves","documenttype::utility_costs":"Utility costs","handovertype::land_register":"After entry in the land register excerpt","handovertype::money_transfer":"After transfer of the purchase price to a predefined account","handovertype::key_handover":"After key handover","handovertype::sale_contract":"According to the sales contract","ownershiptype::joint":"Joint ownership","upload_more":"Upload more documents","uploadtype::identity_document":"Identity document","uploadtype::residence_permit":"Residence permit","uploadtype::proof_of_financial_resources":"Proof of financing","ListingsOverview::number":"Property ID","ListingsOverview::title":"Title","ListingsOverview::pending_offers":"Offers","Page1::object_number":"Property ID","Page1::additional_description":"Other descriptions and important information about the property","Page1::known_defects":"Known defects","Page1::no_known_defects":"No defects known","Page1::following_known_defects":"The following defects are known","Page1::from_offer_value":"of the offer price","AgentProvisionForm::agent_commission":"Agent commission (brutto)","AgentProvisionForm::agent_commission_description":"% of the purchase price","AgentProvisionForm::agent_commission_tooltip":"Must be max. 1.19% of the gross agent commission","RefuseDialog::required_documents":"Required documents","RefuseDialog::optional_documents":"Optional documents","RegistrationPanel::required_documents":"Required documents","RegistrationPanel::offer_viewing":"Seen on","Sale::billing_notice":"The costs of this offer procedure amounting to 0.1% of the highest bid received will be charged to the commissioning broker.","RegistrationPanel::optional_documents":"Optional documents","RegistrationPanel::locale":"Preferred language","BuyerDataForm::acting_organ__function":"Authorized representative - role","SaleCreatePanel::price_tooltip":"Official listing price, which is stored on the RE/MAX website or in onOffice","RoundEdit::bidding_type_tooltip":"With the open procedure, at least the starting price must be offered, all incoming purchase price offers are disclosed anonymously and participating bidders can increase their offer as often as required in defined minimum steps. In the closed process, prospective buyers can only submit an offer, the amount of which can be freely selected and is encrypted in the system until the end of the process and is only disclosed to the broker after the end.","phone_number_placeholder":"+49 150 0000 0000"}

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cadastreLandFields", function() { return cadastreLandFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cadastreLandProps", function() { return cadastreLandProps; });
var cadastreLandFields=[{name:'section_code',type:'string',required:false,size:'ms-sm2'},{name:'map_sheet_number',type:'string',required:true,size:'ms-sm2'},{name:'parcel_number',type:'string',required:true,size:'ms-sm3'},{name:'type',type:'string',required:true,size:'ms-sm3'},{name:'class_of_prodctivity',type:'string',required:true,size:'ms-sm2'},{name:'consistency_ha',type:'number',required:true,suffix:'ha',size:'ms-sm4'},{name:'consistency_a',type:'number',required:true,suffix:'a',size:'ms-sm4'},{name:'consistency_ca',type:'number',required:true,suffix:'ca',size:'ms-sm4'},{name:'income_landlord',type:'currency',required:true,size:'ms-sm6'},{name:'income_agrarian',type:'currency',required:true,size:'ms-sm6'},{name:'cadastral_municipality',type:'string',required:false,size:'ms-sm4'},{name:'address',type:'string',required:false,size:'ms-sm8'}];var cadastreLandProps=function cadastreLandProps(){var result={};cadastreLandFields.forEach(function(field){result[field.name]=field.type==='string'?'':0;});return result;};

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cadastreUrbanFields", function() { return cadastreUrbanFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cadastreUrbanProps", function() { return cadastreUrbanProps; });
function consistencySuffix(typology){switch(typology){case'A':return'm2';case'B':return'm3';case'C':return'm2';default:return'm2';}}var cadastreUrbanFields=function cadastreUrbanFields(data){return[{name:'section_code',type:'string',required:false,size:'ms-sm3'},{name:'map_sheet_number',type:'string',required:true,size:'ms-sm3'},{name:'parcel_number',type:'string',required:true,size:'ms-sm3'},{name:'subparcel_number',type:'string',required:false,size:'ms-sm3'},{name:'typology',type:'string',required:true,size:'ms-sm3'},{name:'class_of_productivity',type:'string',required:true,size:'ms-sm3'},{name:'rooms',type:'number',// required: true,
// suffix:
//   data && data.typology ? consistencySuffix(data.typology) : undefined,
visible:data&&(data.typology==='A'||!data.typology),size:'ms-sm3'},{name:'cadastral_income',type:'currency',required:true,size:'ms-sm3'},{name:'size',type:'number',required:true,suffix:data&&data.typology?consistencySuffix(data.typology):undefined,visible:true,size:'ms-sm3'},{name:'size_netto',type:'number',required:true,suffix:data&&data.typology?consistencySuffix(data.typology):undefined,visible:data&&(data.typology==='A'||!data.typology),size:'ms-sm9'},{name:'cadastral_municipality',type:'string',required:false,size:'ms-sm4'},{name:'address',type:'string',required:false,size:'ms-sm8'}].filter(function(f){return f.visible!==false;});};var cadastreUrbanProps=function cadastreUrbanProps(){var result={};cadastreUrbanFields(null).forEach(function(field){result[field.name]=field.type==='string'?'':0;});return result;};

/***/ }),
/* 447 */
/***/ (function(module, exports) {

module.exports = {}

/***/ }),
/* 448 */
/***/ (function(module, exports) {

module.exports = {"Page2::deposit":"Reservationszahlung","Page2::deposit_title":"Reservationszahlung"}

/***/ }),
/* 449 */
/***/ (function(module, exports) {

module.exports = {"additional_description__tooltip":"Hier können z.B. folgende Informationen aufgeführt werden: Separater Verkauf von Garagen- oder sonstigen Stellplätzen, Abstandszahlung für Küche oder Einbaumöbel, Vorliegen von Bau- oder sonstigen Genehmigungen; behördliche Auflagen, etc.","AgentProvisionForm::agent_commission":"Käuferprovision (brutto)","AgentProvisionForm::agent_commission_description":"% vom Kaufpreis","AgentProvisionForm::agent_commission_tooltip":"Muss max. 1,19% der Brutto-Maklerprovision entsprechen","BuyerDataForm::acting_organ__function":"Handelndes Organ - Funktion","cadastre_new_item":"Weiteren Eintrag einfügen","closing_seller_deadline_days":"Maximale Frist für die Unterzeichnung eines Kaufvertrags (Contrato de compraventa)","closing_seller_target_days":"Vorgeschlagener Zeitraum für die Unterzeichnung eines Kaufvertrags (Contrato de compraventa)","Commands::are_you_sure_to_block_user":"Hiermit wird der Kaufinteressent gesperrt und vom weiteren Angebotsprozess ausgeschlossen. Sind Sie sicher?","Commands::are_you_sure_to_end_round_early":"Wenn Sie das Verfahren vorzeitig beenden können keine weiteren Angebote mehr abgegeben werden. Sind Sie sicher?","Commands::are_you_sure_to_end_round_early_sealed":"Wenn Sie das Verfahren vorzeitig beenden können keine weiteren Angebote mehr abgegeben werden und die Gebote werden offengelegt. Sind Sie sicher?","company_id":"Handelsregisternummer","companylegalform::cooperative":"Genossenschaft","companylegalform::foundation":"Stiftung","companylegalform::general_partnership":"Kollektivgesellschaft","companylegalform::jointstock_company":"Aktiengesellschaft (AG)","companylegalform::kommanditaktiengesellschaft":"Kommandit-Aktiengesellschaft","companylegalform::limited_liability_company":"Gesellschaft mit beschränkter Haftung (GmbH)","companylegalform::limited_partnership":"Kommanditgesellschaft","companylegalform::other":"Sonstige","companylegalform::simple_society":"Einfache Gesellschaft","companylegalform::society":"Verein","costs":"Kaufnebenkosten","costs_deed":"Die Kosten für die Erteilung der öffentlichen Urkunde werden getragen","costsdeed::buyer":"vom Käufer","costsdeed::law":"nach den gesetzlichen Bestimmungen","costsdeed::seller":"vom Verkäufer","costsoption::contract":"Vertragskosten","costsoption::notary":"Beurkundungskosten","costsoption::registry":"Grundbuchkosten","costsoption::reservation":"Kosten für Abwicklung der Reservationszahlung","costsoption::transfer_tax":"Handänderungssteuer","costsparty::buyer":"Kaufinteressent","costsparty::none":"Keine","costsparty::seller":"Eigentümer","costsparty::split":"50 - 50 geteilt","Dashboard::tel":"Telefon","days_after_signed":"Tage nach Angebotsannahme","debt_amount":"Restbetrag","debt_at":"Stand","debt_detail":"Details","debt_type":"Lasten","debt_type::foreclosure":"Zwangsvollstreckung","debt_type::judical_claim":"Gerichtlicher Anspruch","debt_type::lien":"Pfandrecht","debt_type::mortgage":"Hypothek","debt_type::none":"Keine","deposittype::fixed_amount":"Fester Betrag","deposittype::none":"Keine","deposittype::percentage":"Prozentsatz","documenttype::area_allocation_plan":"Flächenpläne","documenttype::area_measurement":"Flächenberechnung","documenttype::building_permit":"Baugenehmigung","documenttype::easement_register":"Baulastenverzeichnis","documenttype::insurance_policy":"Gebäudesonderversicherungsbescheid (KF) / Versicherungspolice","documenttype::location_map":"Lageplan","documenttype::other":"Sonstiges","documenttype::partition_deed":"Teilungserklärung","documenttype::partition_plan":"Teilungsplan","documenttype::rental_contract":"Mietvertrag","documenttype::reserves":"Rücklagen","documenttype::utility_costs":"Nebenkostenabrechnung","DuplicateStep1::agbs":"Nutzungsvereinbarung","DuplicateStep1::avv":"Auftragsverarbeitungsvereinbarung","DuplicateStep1::dataprotection":"Datenschutzhinweise","DuplicateStep1::i_agree_to_the_link":"Ich stimme der {agbs} zu und nehme die {dataprotection} zur Kenntnis.","floor":"Etage","from_agent_commission":"von Brutto-Maklerprovision","from_offer_value":"vom Angebotspreis","from_purchase_value":"vom Kaufpreis","handovertype::land_register":"Nach Grundbucheintragung","handovertype::money_transfer":"Nach Überweisung des Kaufpreises","ListingsOverview::number":"Objekt-Nr","ListingsOverview::pending_offers":"Angebote","ListingsOverview::title":"Objekt-Titel","ownershiptype::ae":"Alleineigentum","ownershiptype::condominium":"Wohnungseigentum","ownershiptype::ge":"Gesamteigentum","ownershiptype::joint":"Gesamteigentum","ownershiptype::meg":"Miteigentum","ownershiptype::partnership":"Eigentümerpartnerschaft","ownershiptype::share":"Miteigentum","ownershiptype::sole":"Alleineigentum","ownershiptype::stwe":"Stockwerkeigentum","Page1::additional_description":"Sonstige Beschreibungen und wichtige Hinweise zum Objekt","Page1::cadastre":"Kataster","Page1::following_known_defects":"Folgende Mängel sind bekannt","Page1::known_defects":"Bekannte wesentliche Mängel","Page1::no_known_defects":"Keine Mängel bekannt","Page1::object_number":"Objekt-Nr.","Page1::plot_area":"Grundstücksfläche","Page1::surface_area":"Wohn-/Nutzfläche","Page1ES::cadastre":"Kataster (Registro de la propriedad)","Page1ES::cadastre_book":"Buch (Libro)","Page1ES::cadastre_city":"Ort (Ciudad)","Page1ES::cadastre_folio":"Blatt (Folio)","Page1ES::cadastre_property_number":"Grundbuch Nr. (Finca Registral nº)","Page1ES::cadastre_registry_number":"Grundbuchamt Nr. (Número registro)","Page1ES::cadastre_volume":"Band (Tomo)","Page1ES::debt_type":"Lasten (Cargas)","Page1ES::information_title":"Weitere Informationen und Bedingungen des Verkäufers","Page2::can_be_max_max_of_the_gross_agent_commission":"Darf max. {max}% der Brutto-Maklerprovision entsprechen","Page2::deposit":"Reservierungsgebühr","Page2::has_mortgage":"Zu übernehmende Hypothek","Page2::mortgage_condition":"Konditionen","Page2::mortgage_condition_tooltip":"Hier relevante Konditionen wie Zinssatz, Restlaufzeit, etc. vermerken","Page2::mortgage_tooltip":"Tragen Sie hier den Betrag der Hypothek ein, der aktuell noch offen ist","Page2::noncompliance_title":"Aufwandsentschädigung bei Nichterfüllung","Page2::provision":"Käuferprovision (brutto)","Page2::provision_title":"Maklerprovision","Page2::total_amount_must_be_documented":"Gesamtbetrag muss durch Belege nachweisbar sein","Page2ES::deposit_title":"Reservierungsgebühr (Depósito inicial para ofertar)","Page2ES::notary_title":"Vom Verkäufer vorgeschlagener Notar","Page2ES::sale_act_title":"Kauf- und Verkaufskosten","Page2ES::security_title":"Reservierungszahlung (Arras)","Page2ES::signing_deadline":"Frist für die Unterzeichnung des Kautionsvertrags (Contrato de arras)","allowed_file_formats":"Es können nur Unterlagen im PDF- oder JPG-Format hochgeladen werden, mit einer Maximalgrösse von 20 MB.","Page3::documents":"Objektunterlagen","phone_number":"Mobilnummer","provisiontype::fixed_amount":"Pauschalbetrag","provisiontype::fixed_percentage":"Prozentsatz","provisiontype::none":"Keine","provisiontype::split_percentage":"Abwälzung","provisiontype::standard_at":"Standard","RefuseDialog::optional_documents":"Optionale Unterlagen","RefuseDialog::required_documents":"Erforderliche Unterlagen","RegistrationPanel::locale":"Bevorzugte Sprache","RegistrationPanel::offer_viewing":"Besichtigungstermin erfolgte am","RegistrationPanel::optional_documents":"Optionale Unterlagen","RegistrationPanel::required_documents":"Erforderliche Unterlagen","RegistrationPanel::upload_new_offer":"Angebot im Namen des Kunden abgeben","RoundEdit::bidding_type_tooltip":"Beim offenen Verfahren muss mindestens der Startpreis geboten werden, alle eingehenden Kaufpreisangebote werden anonymisiert offengelegt und teilnehmende Bieter können ihr Angebot beliebig häufig in festgelegten Mindestschritten erhöhen. Beim geschlossenen Verfahren können Kaufinteressenten nur ein Angebot abgeben, dessen Höhe frei wählbar ist und bis Ende des Verfahrens im System verschlüsselt ist und erst nach Ende dem Makler offengelegt wird.","RoundEdit::open_round_warning":"Im offenen Angebotsverfahren ist nur eine Runde vorgesehen und alle Angebotspreise sind für alle Teilnehmer offen einsehbar.","RoundEdit::red_button_price":"Red Button Preis (intern)","RoundPanel::open_round_warning":"Im offenen Angebotsverfahren ist nur eine Runde vorgesehen und alle Angebotspreise sind für alle Teilnehmer offen einsehbar.","RoundPanel::round":"Eckdaten der Runde festlegen","Sale::billing_notice":" ","Sale::guide__invite_users":"Um einen Interessenten einzuladen, brauchen Sie seinen vollen Namen, seine E-Mail-Adresse und seine Mobilnummer.","Sale::guide__open_round":"Um das digitale Angebotsverfahren zu starten und einzelne Kunden einzuladen, müssen Sie die Runde öffnen.","Sale::open_round_info_notice_openbidding":"Sie starten eine <strong>offene</strong> Runde mit <strong>Startpreis von {startPrice}</strong> die <strong>{duration}</strong> am {date} <strong>um {time} endet.</strong>","Sale::open_round_info_notice_sealedbidding":"Sie starten eine <strong>geschlossene</strong> Runde mit <strong>Richtpreis von {estimate}</strong> die <strong>{duration}</strong> am {date} <strong>um {time} endet.</strong>","Sale::you_are_about_to_upload_offer_in_the_name_of_customer":"Sie sind dabei das Kaufangebot im Namen des Kunden hochzuladen. Somit kann der Kunde sein Kaufangebot nicht mehr online abgeben.","SaleCreatePanel::agbs":"Nutzungsvereinbarung","SaleCreatePanel::avv":"Auftragsverarbeitungsvereinbarung","SaleCreatePanel::dataprotection":"Datenschutzhinweise","SaleCreatePanel::i_agree_to_the_link":"Ich stimme der {agbs} zu und nehme die {dataprotection} zur Kenntnis.","SaleCreatePanel::price_tooltip":"Offizieller Listing-Preis, der im Expose / Makler-Software hinterlegt ist","Search::agbs":"Nutzungsvereinbarung","Search::avv":"Auftragsverarbeitungsvereinbarung","Search::dataprotection":"Datenschutzhinweise","Search::error_loading_objects":"Beim laden von Objekten ist ein Fehler aufgetreten","Search::guide_no_objects":"Es scheint, als hätten Sie im Moment keine verfügbaren Objekte.","Search::i_agree_to_the_link":"Ich stimme der {agbs} zu und nehme die {dataprotection} zur Kenntnis.","securitytype::none":"Keine","securitytype::percentage":"Prozentsatz","seller_conditions":"Zusätzliche Verkäuferbedingungen","seller_id_type::dni":"DNI","seller_id_type::nie":"NIE","seller_id_type::nif":"NIF","seller_id_type::passport":"Reisepas","seller_id_type::personal_id":"Nationales Ausweisdokument","seller_title":"Verkäufer","SellerDataForm::seller_type":"Verkäufertyp","SellerFormListItem::id_document_number":"Nummer des Ausweisdokuments","SellerFormListItem::id_document_type":"Art des Ausweisdokuments","SellerFormListItem::nationality":"Staatsangehörigkeit","sellertype::company":"Firma","sellertype::private":"Privatperson","uploadtype::identity_document":"Identitätsnachweis","uploadtype::proof_of_financial_resources":"Finanzierungsnachweis","uploadtype::representation_mandate":"Vertretungsmandat","uploadtype::residence_permit":"Aufenthaltsstatus"}

/***/ }),
/* 450 */
/***/ (function(module, exports) {

module.exports = {"phone_number_placeholder":"+44 150 0000 0000"}

/***/ }),
/* 451 */
/***/ (function(module, exports) {

module.exports = {"area_unit":"sqft","phone_number_placeholder":"+1 555 555 5555","Search::number":"MLS ID"}

/***/ }),
/* 452 */
/***/ (function(module, exports) {

module.exports = {"city":"Town/City","country":"Country","Page1::certificates_placeholder":"Please select provided / existing certificates","Page2::provision":"Commission paid by the buyer (net, excluding VAT)","Page2::provision_title":"Commission paid by the seller (net, excluding VAT)","phone_number_placeholder":"+27 82 0000000","post_code":"Street code","state":"Province","street":"Street","suburb":"Suburb","additional_description__tooltip":"Here, for example, the following information can be listed: Commission paid by the buyer, separate sale of garage or other parking spaces, payment for the kitchen or built-in furniture, availability of building or other permits; regulatory requirements, etc."}

/***/ }),
/* 453 */
/***/ (function(module, exports) {

module.exports = {"additional_description__tooltip":"Here, for example, the following information can be listed: Separate sale of garage or other parking spaces, payment for the kitchen or built-in furniture, availability of building or other permits; regulatory requirements, etc.","Address::floor":"Floor","Address::state":"State","Address::suburb":"Suburb","administration_costs_annual":"","administration_costs_extra":"","administration_costs_extra_tooltip":"","administration_costs_heating_included":"","administrative_expenses":"","administrative_expenses_annual":"","administrative_expenses_extra":"","administrative_expenses_extra_tooltip":"","administrative_expenses_heating_included":"","agency":"","agency_name":"","agency_street":"","agent":"","AgentProvisionForm::agent_commission":"Agent commission (brutto)","AgentProvisionForm::agent_commission_description":"% of the purchase price","AgentProvisionForm::agent_commission_tooltip":"Must be max. 1.19% of the gross agent commission","apartment_number":"","area":"","billing_notice":"","BuyerDataForm::acting_organ__function":"Authorized representative - role","buyertype::company":"","buyertype::entrepreneur":"","buyertype::private":"","cadastral_compliance":"","cadastral_municipality":"","cadastre_land":"","cadastre_land::address":"","cadastre_land::cadastral_municipality":"","cadastre_land::class_of_prodctivity":"","cadastre_land::consistency":"","cadastre_land::consistency_a":"","cadastre_land::consistency_ca":"","cadastre_land::consistency_ha":"","cadastre_land::income_agrarian":"","cadastre_land::income_landlord":"","cadastre_land::map_sheet_number":"","cadastre_land::parcel_number":"","cadastre_land::section_code":"","cadastre_land::type":"","cadastre_new_item":"Insert another item","cadastre_urban":"","cadastre_urban::address":"","cadastre_urban::book":"Book","cadastre_urban::cadastral_income":"","cadastre_urban::cadastral_municipality":"","cadastre_urban::class_of_productivity":"","cadastre_urban::consistency":"","cadastre_urban::folio":"Folio","cadastre_urban::map_sheet_number":"","cadastre_urban::parcel_number":"","cadastre_urban::registry_number":"Registry number","cadastre_urban::rooms":"","cadastre_urban::section_code":"","cadastre_urban::size":"","cadastre_urban::size_netto":"","cadastre_urban::subparcel_number":"","cadastre_urban::subparcel_number_long":"","cadastre_urban::typology":"","cadastre_urban::volume":"Volume","cciaa":"","certificates_label":"Enter available compliance certificates","certificates_title":"Compliance certificates","certificatetype::beetle_certificate":"Beetle Certificate","certificatetype::electrical_compliance_certificate":"Electrical Compliance Certificate","certificatetype::electrical_fence_certificate":"Electrical Fence Certificate","certificatetype::gas_installation":"Gas Installation","certificatetype::plumbing_certificate":"Plumbing Certificate","certificatetype::water_certificate":"Water Certificate","certificatetype::alien_and_invasive_species_regulations":"Alien and Invasive Species","city":"City","closing_seller_deadline_days":"Maximum deadline for signing a purchase agreement (Contrato de compraventa)","closing_seller_target_days":"Suggested period for signing a purchase agreement (Contrato de compraventa)","Commands::are_you_sure_to_block_user":"The customer is will be blocked and excluded from the further offer process. Are you sure?","company_id":"Company registration number","companylegalform::cooperative":"Cooperative (Genossenschaft)","companylegalform::foundation":"Foundation (Stiftung)","companylegalform::general_partnership":"General partnership (Kollektivgesellschaft)","companylegalform::jointstock_company":"Joint-stock company (Aktiengesellschaft)","companylegalform::kommanditaktiengesellschaft":"Limited stock company (Kommandit-Aktiengesellschaft)","companylegalform::limited_liability_company":"Limited liability company (GmbH)","companylegalform::limited_partnership":"Limited partnership (Kommanditgesellschaft)","companylegalform::other":"Other","companylegalform::self_employed":"","companylegalform::simple_society":"Ordinary company (Einfache Gesellschaft)","companylegalform::society":"Association (Verein)","companylegalform::unlimited_liability_company":"","compliance":"","condominium_fees":"","consistency_a_a":"","consistency_ca_ca":"","consistency_ha_ha":"","costs":"Additional purchase costs","costs_deed":"The costs for issuing the public deed are borne","costsdeed::buyer":"by buyer","costsdeed::law":"according to the legal provisions","costsdeed::seller":"by seller","costsoption::contract":"contract costs","costsoption::notary":"notarisation costs","costsoption::registry":"land register costs","costsoption::reservation":"costs of processing the Reservation Payment","costsoption::transfer_tax":"transfer tax","costsparty::buyer":"Prospective Buyer","costsparty::none":"N/A","costsparty::seller":"Owner","costsparty::split":"Split 50-50","court_name":"Court","Dashboard::tel":"Phone","days_after_signed":"days after acceptance of the offer","debt_amount":"Rest amount","debt_at":"As of","debt_detail":"Details","debt_type::foreclosure":"Foreclosure","debt_type::judical_claim":"Judicial claim","debt_type::lien":"Lien","debt_type::mortgage":"Mortgage","debt_type::none":"None","deposit":"Deposit","deposit_transfer_bank":"Bank name","deposit_transfer_bic":"BIC","deposit_transfer_duration":"Duration","deposit_transfer_explanation":"(if selected as a payment method by the buyer)","deposit_transfer_iban":"IBAN","deposit_transfer_owner":"Bank account owner","deposit_transfer_title":"Deposit via Bank transfer","deposittype::fixed_amount":"Fixed amount","deposittype::none":"None","deposittype::percentage":"Percentage","description":"","documenttype::area_allocation_plan":"Area plans","documenttype::area_measurement":"Area measurement","documenttype::articles_of_association":"Articles of association","documenttype::brochure":"Brochure","documenttype::building_permit":"Building permit","documenttype::cadastral_certificate":"Cadastral certificate","documenttype::cadastral_plan":"","documenttype::cadastral_survey":"","documenttype::certificate_of_title":"Certificate of title ","documenttype::condition_of_the_building_report":"Report(s) regarding the condition of the building","documenttype::easement_register":"Easement register","documenttype::encumbrance_certificate":"Encumbrance certificate ","documenttype::energy_certificate":"","documenttype::energy_performance_certificate":"Energy performance certificate","documenttype::exclusive_sole_mandate":"Exclusive Sole Mandate","documenttype::financial_statements":"Financial statements","documenttype::floor_area_measurement_record":"Floor area measurement record","documenttype::floor_plan":"Floor plan","documenttype::insurance_policy":"Insurance policy","documenttype::lease":"Lease","documenttype::location_map":"Location map","documenttype::long_term_repair_plan":"Long-term repair plan","documenttype::maintenance_needs_report":"Maintenance needs report","documenttype::maintenance_plan":"Maintenance plan","documenttype::moisture_measurement_and_condition_audit_reports":"Flat moisture measurement records / condition audit reports","documenttype::origin_deed":"","documenttype::other":"Other","documenttype::partition_deed":"Partition deed","documenttype::partition_plan":"Partition plan","documenttype::property_condition_report":"Property Condition Report","documenttype::real_estate_managers_certificate":"Real estate manager’s certificate","documenttype::rental_contract":"Rental contract","documenttype::repairs_and_alterations_report":"Reports related to repairs and alterations carried out in the flat","documenttype::reserves":"Reserves","documenttype::share_based_dwelling_printout":"Share-based dwelling printout","documenttype::share_register_printout":"Share register printout","documenttype::utility_costs":"Utility costs","due_diligence_deadline":"","DuplicateStep1::agbs":"User agreement","DuplicateStep1::avv":"Order processing agreement","DuplicateStep1::dataprotection":"Data protection","DuplicateStep1::i_agree_to_the_link":"I have read the {agbs} and the {dataprotection} and I agree to them.","floor":"floor","from_agent_commission":"of gross agent commission","from_offer_value":"of the offer price","from_purchase_value":"of the purchase price","full_address":"","handovertype::land_register":"After registration in the land register","handovertype::money_transfer":"After transferring the purchase price","handovertype::transfer":"On the date of the Transfer","house_number":"No.","ListingsOverview::number":"Property ID","ListingsOverview::pending_offers":"Offers","ListingsOverview::title":"Title","notary_date":"","object_address":"","object_cadastral_compliance::compliant":"","object_cadastral_compliance::compliant_when_built":"","object_cadastral_compliance::noncompliant":"","object_cadastral_compliance::noncompliant_fixed":"","object_cadastral_compliance::pending":"","object_composition":"","object_owner":"","object_provenance":"","object_provenance::awarding":"Awarding","object_provenance::donation":"","object_provenance::other":"","object_provenance::sale":"","object_provenance::succession":"","object_provenance_date":"","object_provenance_description":"","object_provenance_detail":"","object_provenance_notary":"","object_provenance_title":"","object_regulation_compliance::guaranteed":"","object_regulation_compliance::not_guaranteed":"","object_usability_compliance::certificate_absent_indemnified":"","object_usability_compliance::certificate_absent_not_indemnified":"","object_usability_compliance::certificate_present":"","object_usability_compliance_equiped::false":"","object_usability_compliance_equiped::true":"","object_usability_compliance_indemnification::false":"","object_usability_compliance_indemnification::true":"","object_usage":"","occupation":"","occupation_name":"","occupation_rent_expiration":"","occupation_type":"","occupationtype::construction":"","occupationtype::free":"","occupationtype::rented":"","ownershiptype::ae":"Sole ownership","ownershiptype::condominium":"Condominium ownership","ownershiptype::ge":"Joint ownership","ownershiptype::joint":"Joint ownership","ownershiptype::meg":"Co-ownership","ownershiptype::partnership":"Ownership partnership","ownershiptype::share":"Co-ownership","ownershiptype::sole":"Sole ownership","ownershiptype::stwe":"Condominium","Page1::additional_description":"Other important information about the property or the sale","Page1::balcony_number":"Balcony number","Page1::bond_account_number":"Bond account number","Page1::bonded_to":"Bonded to","Page1::cadastre_new_item":"","Page1::conveyancer_account":"Account Number","Page1::conveyancer_address":"Address","Page1::conveyancer_bank":"Bank code","Page1::conveyancer_name":"Name(s)","Page1::conveyancers":"Conveyancers","Page1::door_number":"Door number","Page1::electronic_shares":"Electronic shares","Page1::erf_number":"ERF number","Page1::fixtures":"Fixtures and fittings","Page1::flat_no":"Flat number","Page1::following_known_defects":"The following defects are known","Page1::garden_number":"Garden number","Page1::housing_company":"Housing company","Page1::known_defects":"Known defects","Page1::listing_no":"Listing No","Page1::no_known_defects":"No defects known","Page1::object_number":"Property ID","Page1::object_provenance_title":"Provenance","Page1::parking_bay_number":"Parking bay number","Page1::plot_area":"Plot area","Page1::redemption_clause":"Redemption clause","Page1::reservation_of_rights_of_extension":"Reservation of rights of extension","Page1::scheme_name":"Scheme name","Page1::section_number":"Section number","Page1::sectional_plan_area":"Sectional plan area","Page1::sectional_plan_number":"Sectional plan number","Page1::shares":"Share numbers","Page1::storage_room_number":"Storage room number","Page1::surface_area":"Living area","Page1::title_deed_no":"Title deed no.","Page1::township":"Township","Page1::unit_number":"Unit number","Page1::utility_room_number":"Utility room number","Page1::yard_number":"Yard number","Page1ES::cadastre":"Cadastre (Registro de la propriedad)","Page1ES::cadastre_book":"Book (Libro)","Page1ES::cadastre_city":"City (Ciudad)","Page1ES::cadastre_folio":"Page (Folio)","Page1ES::cadastre_property_number":"Property No. (Finca Registral nº)","Page1ES::cadastre_registry_number":"Registry No. (Número registro)","Page1ES::cadastre_volume":"Volume (Tomo)","Page1ES::debt_type":"Encumbrances (Cargas)","Page1ES::information_title":"More information and conditions from the seller","Page2::can_be_max_max_of_the_gross_agent_commission":"Can be max {max}% of the gross agent commission","Page2::capital_charge_from":"","Page2::compensation":"Compensation on late vacancy","Page2::compensation__info":"If the vacation of the flat is delayed due to the Seller, the Seller shall pay to the Buyer as lump compensation for such delay","Page2::compensation__total":"Lump compensation","Page2::compensation__weekly":"Weekly","Page2::deposit":"Deposit","Page2::deposit_title":"Deposit","Page2::deposits_and_penalties":"Deposits / penalties","Page2::has_mortgage":"Mortgage to be taken over","Page2::is_rented":"Apartment is rented when sold","Page2::maintenance_takeover_from":"Buyer shall pay the maintenance and other charges as of","Page2::monthly_rent":"Monthly rent amount","Page2::mortgage_certificate_date":"Issue date of the debt certificate","Page2::mortgage_condition":"","Page2::mortgage_condition_tooltip":"Note relevant conditions such as interest rate, remaining term, etc. here","Page2::mortgage_tooltip":"","Page2::noncompliance_title":"Compensation for expenses in the event of non-fulfillment","Page2::other_trade_conditions":"","Page2::penalty":"Monthly occupational interest","Page2::provision":"Buyer agent commission (gross)","Page2::provision_title":"Agent commission","Page2::rent_deposit_transfer_until":"Transfer of rent deposit until","Page2::rent_payment_from":"Rent paid to buyer from","Page2::rental_status":"Apartment rental","Page2::total_amount_must_be_documented":"Total amount must be documented!","Page2::type_of_payment":"Type of reservation payment","Page2ES::deposit_title":"Deposit (Depósito inicial para ofertar)","Page2ES::notary_title":"Notary proposed by the seller","Page2ES::sale_act_title":"Purchase and Selling Costs","Page2ES::security_title":"Reservation payment (Arras)","Page2ES::signing_deadline":"Deadline for signing the deposit agreement (Contrato de arras)","allowed_file_formats":"Only documents in PDF, JPG or PNG format can be uploaded, with a maximum size of 20 MB.","Page3::documents":"Property documents","Page3::section__property":"Other documents about the property","paymenttype::deposit":"Deposit paid after accepted by seller","paymenttype::none":"No deposit or penalty","paymenttype::penalty":"Contractual penalty when withdrawing offer after being accepted","penaltytype::fixed_amount":"Lump sum","penaltytype::percentage":"Percentage","phone_number":"Mobile number","post_code":"","postal_code":"","prejudicial_registrations":"","proposal_stamp_tax":"Party Responsible for Stamp Taxes","provisiontype::fixed_amount":"Lump sum","provisiontype::fixed_percentage":"Percentage","provisiontype::none":"None","provisiontype::split_percentage":"Passing on","provisiontype::standard_at":"Standard","rea":"","RefuseDialog::optional_documents":"Optional documents","RefuseDialog::required_documents":"Required documents","registered_address":"","RegistrationPanel::locale":"Preferred language","RegistrationPanel::offer_viewing":"Property visited on","RegistrationPanel::optional_documents":"Optional documents","RegistrationPanel::required_documents":"Required documents","RegistrationPanel::upload_new_offer":"Submit an offer on behalf of the customer","regulation_compliance":"","rent_amount":"","represented_by":"","role":"","RoundEdit::antisniping_notice":"The end of the offer period is automatically extended by 15 minutes if a new offer is received within the last 15 minutes before the end. This extension is repeated until no further offers are made for 15 minutes.","RoundEdit::bidding_type_tooltip":"With the open procedure, at least the starting price must be offered, all incoming purchase price offers are disclosed anonymously and participating bidders can increase their offer as often as required in defined minimum steps. In the closed process, prospective buyers can only submit an offer, the amount of which can be freely selected and is encrypted in the system until the end of the process and is only disclosed to the broker after the end.","RoundEdit::open_round_warning":"In the open bidding process, only one round is planned and all bid prices are open to all participants.","RoundEdit::please_enter_a_starting_price":"Please enter a number greater than 0","RoundEdit::red_button_price":"Internal Reserve Price","RoundPanel::open_round_warning":"In the open bidding process, only one round is planned and all bid prices are open to all participants.","RoundPanel::round":"Define key parameters for the offer process","Sale::billing_notice":" ","Sale::cannot_update_documents_for_open_round__documents_uploaded":"","Sale::cannot_update_documents_for_open_round__no_documents":"","Sale::guide__invite_users":"To invite a prospect, you need their full name, email address and mobile number.","Sale::guide__open_round":"In order to start the digital offer process and invite individual customers, you have to open the round.","Sale::you_are_about_to_upload_offer_in_the_name_of_customer":"You are about to upload the purchase offer on behalf of the customer. Thus, the customer can no longer submit his purchase offer online.","SaleCreatePanel::agbs":"User agreement","SaleCreatePanel::avv":"Order processing agreement","SaleCreatePanel::dataprotection":"Data protection","SaleCreatePanel::i_agree_to_the_link":"I have read the {agbs} and the {dataprotection} and I agree to them.","SaleCreatePanel::number":"","SaleCreatePanel::price_tooltip":"Official listing price that is stored in CRM","sales_reference_no":"Sales reference Number","Search::agbs":"User agreement","Search::avv":"Order processing agreement","Search::dataprotection":"Data protection","Search::error_loading_objects":"An error occurred while loading properties","Search::guide_no_objects":"It seems that there are no available properties at the moment.","Search::i_agree_to_the_link":"I have read the {agbs} and the {dataprotection} and I agree to them.","securitytype::none":"None","securitytype::percentage":"Percentage","seller_civil_status::married_in_community":"Married in community of property","seller_civil_status::married_law":"Married, the marriage being governed by laws of","seller_civil_status::married_other":"Other","seller_civil_status::married_out_of_community":"Married out of community of property","seller_civil_status::unmarried":"Unmarried","seller_conditions":"Additional Seller Conditions","seller_id_type::dni":"DNI","seller_id_type::nie":"NIE","seller_id_type::nif":"NIF","seller_id_type::passport":"Passport","seller_id_type::personal_id":"National ID document","seller_notary_proposal":"","seller_title":"Seller","SellerDataForm::seller_type":"Seller Type","SellerFormAddress::floor":"Floor","SellerFormAddress::state":"State","SellerFormListItem::civil_status":"Marital status","SellerFormListItem::id_document_number":"ID document number","SellerFormListItem::id_document_type":"Type of ID document","SellerFormListItem::nationality":"Nationality","SellerFormListItem::personal_id":"ID/Passport/Registration No.","sellertype::company":"Company","sellertype::entrepreneur":"","sellertype::private":"Private Person","signing_deadline":"Signing deadline","size_m2":"","size_m3":"","size_netto_m2":"","size_netto_m3":"","stamp_tax::buyer":"Buyer","stamp_tax::seller":"Seller","stamp_tax::split":"Split (50/50)","state":"State","street":"Street","tax_code":"Tax code","termination_clause":"","tranches":"","tranches::amount":"","tranches::date":"","tranches_new":"","type_of_seller":"","uploadtype::confirmation_of_payment_reservation":"","uploadtype::identity_document":"Identity document","uploadtype::proof_of_financial_resources":"Proof of financing","uploadtype::representation_mandate":"Mandate of representation","uploadtype::residence_permit":"Residence permit","usability_compliance":"","usagetype::commercial":"","usagetype::industrial":"","usagetype::residential":"","usagetype::service":"","usagetype::tourist":"","vat_id":"","zip":"","zip_code":"ZIP Code"}

/***/ }),
/* 454 */
/***/ (function(module, exports) {

module.exports = {"Address::floor":"Piso","Address::state":"Región autónoma","Address::suburb":"Barrio","AgentProvisionForm::agent_commission":"Comisión del agente (brutto)","AgentProvisionForm::agent_commission_description":"% del precio de venta","AgentProvisionForm::agent_commission_tooltip":"Debe ser como máximo el 1,19% de la comisión bruta del agente","BuyerDataForm::acting_organ__function":"Representante autorizado - función","cadastral_municipality":"Municipio catastral","cadastre_new_item":"Otra entrada de cadastre","closing_seller_deadline_days":"Plazo máximo para firmar contrato de compraventa","closing_seller_target_days":"Plazo previsto para firmar contrato de compraventa","Commands::are_you_sure_to_block_user":"El cliente quedará bloqueado y excluido de este proceso de oferta ¿Está seguro?","Commands::are_you_sure_to_end_round_early":"Si termina el proceso de oferta antes de tiempo, no se podrán presentar más ofertas. ¿Está seguro?","company_id":"Número de registro de la empresa","companylegalform::cooperative":"Cooperativa ","companylegalform::foundation":"Fundación","companylegalform::general_partnership":"Sociedad colectiva","companylegalform::jointstock_company":"Sociedad anónima (SA)","companylegalform::kommanditaktiengesellschaft":"Sociedad anónima","companylegalform::limited_liability_company":"Sociedad de responsabilidad limitada","companylegalform::limited_partnership":"Sociedad en comandita simple","companylegalform::other":"Otro","companylegalform::simple_society":"Sociedad ordinaria ","companylegalform::society":"Asociación","costs":"Costes de compra adicionales","costs_deed":"Los gastos de otorgamiento de la escritura pública serán","costsdeed::buyer":"a cargo del comprador","costsdeed::law":"repartidos según ley","costsdeed::seller":"a cargo del vendedor","costsoption::contract":"costes contractuales","costsoption::notary":"gastos de notarización","costsoption::registry":"costes del registro de la propiedad","costsoption::reservation":"costes de tramitación del pago de la reserva","costsoption::transfer_tax":"impuesto de transferencia","costsparty::buyer":"Comprador interesado","costsparty::none":"N/A","costsparty::seller":"Propietario","costsparty::split":"Reparto 50-50","days_after_signed":"Días tras la aceptación de la oferta","debt_amount":"Monto deuda","debt_at":"Fecha","debt_detail":"Detalle deuda","debt_type::foreclosure":"Juicio hipotecario","debt_type::judical_claim":"Reclamo judicial","debt_type::lien":"Derecho de retención","debt_type::mortgage":"Hipoteca","debt_type::none":"No hay cargas","deposittype::fixed_amount":"Importe fijo","deposittype::none":"Ninguno","deposittype::percentage":"Porcentaje","documenttype::annual_statement":"Declaración anual","documenttype::appraisal":"Tasación","documenttype::area_allocation_plan":"Plano de localización","documenttype::area_measurement":"Medidas","documenttype::building_permit":"Permiso de construcción","documenttype::easement_register":" Inscripción de servidumbres","documenttype::energy_certificate":"Certificado de eficiencia energética","documenttype::expose":"Folleto (descripción de la propiedad)","documenttype::insurance_policy":"Póliza de seguro","documenttype::land_register":"Registro de la propiedad","documenttype::location_map":"Mapa de localización","documenttype::other":"Otros","documenttype::partition_deed":"Escritura de partición","documenttype::partition_plan":"Plano de distribución","documenttype::rental_contract":"Contrato de arrendamiento","documenttype::reserves":"Reservas","documenttype::utility_costs":"Costos de servicios","DuplicateStep1::agbs":"Acuerdo de usuario","DuplicateStep1::avv":"Acuerdo de tramitación de pedidos","DuplicateStep1::dataprotection":"Protección de datos","DuplicateStep1::i_agree_to_the_link":"He leído los {agbs} y la {dataprotection} y estoy de acuerdo con ellos.","from_agent_commission":"de la comisión bruta del agente","from_offer_value":"del precio de venta","from_purchase_value":"del precio de compra","handovertype::land_register":"Tras la inscripción en el Registro de la propiedad","handovertype::money_transfer":"Después de transferir el precio de compra","ListingsOverview::number":"Propriedad nº","ListingsOverview::pending_offers":"Ofertas","ListingsOverview::title":"Título","object_provenance":"Procedencia de la propiedad","object_provenance::awarding":"Concesión","object_provenance::donation":"Donación","object_provenance::other":"Otro","object_provenance::sale":"Venta","object_provenance::succession":"Sucesión","object_provenance_date":"Fecha de procedencia","ownershiptype::ae":"Propiedad exclusiva","ownershiptype::condominium":"Propiedad horizontal","ownershiptype::ge":"Propiedad conjunta","ownershiptype::joint":"Propiedad conjunta","ownershiptype::meg":"Copropiedad","ownershiptype::partnership":"Sociedad de propiedad","ownershiptype::share":"Copropiedad","ownershiptype::sole":"Propiedad exclusiva","ownershiptype::stwe":"Condominio","Page1::additional_description":"Otras informaciones importantes sobre la propriedad","Page1::following_known_defects":"Se conocen los siguientes defectos","Page1::known_defects":"Defectos conocidos","Page1::no_known_defects":"No se conocen defectos","Page1::object_number":"Propriedad nº","Page1::object_provenance_title":"Procedencia","Page1::plot_area":"Superficie de la parcela","Page1::surface_area":"Espacio habitable","Page1ES::additional_description__tooltip":"Aquí puede figurar la siguiente información. Ejemplo: Venta por separado de un garaje u otras plazas de aparcamiento, pago por la cocina o los muebles empotrados, disponibilidad de permisos de construcción o de otro tipo; requisitos reglamentarios, etc.","Page1ES::cadastre":"Registro de la propriedad","Page1ES::cadastre_book":"Libro","Page1ES::cadastre_city":"Ciudad","Page1ES::cadastre_folio":"Folio","Page1ES::cadastre_property_number":"Finca Registral nº","Page1ES::cadastre_registry_number":"Número registro","Page1ES::cadastre_volume":"Tomo","Page1ES::debt_type":"Cargas","Page1ES::information_title":"Otras informaciones y condiciones del vendedor","Page2::can_be_max_max_of_the_gross_agent_commission":"Puede ser el {max}% de la comisión bruta del agente","Page2::deposit":"Depósito inicial","Page2::noncompliance_title":"Compensación de gastos en caso de incumplimiento","Page2::provision":"Comisión del agente comprador (bruta)","Page2::provision_title":"Comisión del agente","Page2::total_amount_must_be_documented":"El importe total debe estar documentado","Page2ES::deposit_title":"Depósito inicial para ofertar","Page2ES::has_mortgage":"Hipoteca por asumir","Page2ES::mortgage_condition_tooltip":"Anote aquí las condiciones pertinentes, como el tipo de interés, el plazo restante, etc","Page2ES::notary_title":"Notario propuesto por el vendedor","Page2ES::sale_act_title":"Gastos de compraventa","Page2ES::security_title":"Arras","Page2ES::signing_deadline":"Fecha limite para firmar el contrato de arras","allowed_file_formats":"Sólo pueden cargarse documentos en formato PDF, JPG o PNG, con un tamaño máximo de 20 MB por archivo.","Page3::documents":"Documentos de la propiedad","phone_number":"Número de móvil","provisiontype::fixed_amount":"Suma global","provisiontype::fixed_percentage":"Porcentaje","provisiontype::none":"Ninguno","provisiontype::split_percentage":"Transmisión","provisiontype::standard_at":"Estándar","RefuseDialog::optional_documents":"Documentos opcionales","RefuseDialog::required_documents":"Documentos necesarios","RegistrationPanel::locale":"Idioma preferido","RegistrationPanel::offer_viewing":"Propiedad visitada el","RegistrationPanel::optional_documents":"Documentos opcionales","RegistrationPanel::required_documents":"Documentos necesarios","RegistrationPanel::upload_new_offer":"Presentar una oferta en nombre del cliente","RoundEdit::bidding_type_tooltip":"En el proceso de oferta abierta, debe ofrecerse al menos el precio inicial. Todas las ofertas de compra recibidas se revelan de forma anónima y los participantes pueden aumentar su oferta tantas veces como sea necesario en pasos mínimos definidos. En el proceso de oferta cerrada los compradores sólo pueden presentar una sola oferta, cuyo importe puede elegirse libremente y queda encriptado en el sistema hasta el final del proceso y sólo se revela al agente inmobilario una vez finalizado.","RoundEdit::open_round_warning":"En el proceso de oferta abierta, sólo está prevista una ronda del proceso y todos los precios y ofertas están abiertos a todos los participantes.","RoundEdit::red_button_price":"Precio mínimo interno","RoundPanel::open_round_warning":"En el proceso de oferta abierta, sólo está prevista una ronda del proceso y todos los precios y ofertas están abiertos a todos los participantes.","RoundPanel::round":"Definir los parámetros clave del proceso de oferta","Sale::guide__invite_users":"Para invitar a un cliente, necesita su nombre completo, su dirección de correo electrónico y su número de móvil.","Sale::guide__open_round":"Para iniciar el proceso de oferta digital e invitar a clientes, tiene que tiene que abrir este proceso.","Sale::open_round_info_notice_openbidding":"Está a punto de comenzar un proceso de oferta <strong>abierta</strong> con un precio inicial de <strong>{startPrice}</strong> que dura <strong>{duration}</strong> y termina el {date} <strong>a las {time}.</strong>","Sale::open_round_info_notice_sealedbidding":"Está a punto de iniciar un proceso de oferta <strong>cerrada</strong> con un precio de referencia <strong>de {estimado}</strong> que dura <strong>{duración}</strong> y finaliza el {fecha} <strong>a las {hora}.</strong>","Sale::you_are_about_to_upload_offer_in_the_name_of_customer":"Está a punto de cargar la oferta de compra en nombre del cliente. Por lo tanto, el cliente ya no puede enviar su oferta de compra en línea.","SaleCreatePanel::agbs":"Acuerdo de usuario","SaleCreatePanel::avv":"Acuerdo de tramitación de pedidos","SaleCreatePanel::dataprotection":"Protección de datos","SaleCreatePanel::i_agree_to_the_link":"He leído los {agbs} y la {dataprotection} y estoy de acuerdo con ellos.","SaleCreatePanel::price_tooltip":"Precio oficial de venta","Search::agbs":"Acuerdo de usuario","Search::avv":"Acuerdo de tramitación de pedidos","Search::dataprotection":"Protección de datos","Search::error_loading_objects":"Se ha producido un error al cargar las propiedades","Search::guide_no_objects":"Parece que no hay propiedades disponibles en este momento.","Search::i_agree_to_the_link":"He leído los {agbs} y la {dataprotection} y estoy de acuerdo con ellos.","securitytype::fixed_amount":"Importe fijo","securitytype::none":"Ninguno","securitytype::percentage":"Porcentaje","seller_conditions":"Condiciones adicionales del vendedor","seller_id_type::dni":"DNI","seller_id_type::id":"Identificación","seller_id_type::nie":"NIE","seller_id_type::nif":"NIF","seller_id_type::passport":"Pasaporte","seller_id_type::personal_id":"Documento nacional de identidad","seller_notary_proposal":"Notario sugerido por el vendedor","seller_title":"Vendedor","SellerDataForm::seller_type":"Tipo de vendedor","SellerFormAddress::floor":"Piso","SellerFormListItem::id_document_number":"Número del documento","SellerFormListItem::id_document_type":"Documento de identidad","SellerFormListItem::nationality":"Nacionalidad","sellertype::entrepreneur":"Emprendedor","sellertype::private":"Particular","sellertype::representing":"Representando","uploadtype::identity_document":"Documento de identidad","uploadtype::proof_of_financial_resources":"Prueba de capacidad financiera","uploadtype::representation_mandate":"Mandato de representación","uploadtype::residence_permit":"Permiso de residencia"}

/***/ }),
/* 455 */
/***/ (function(module, exports) {

module.exports = {"additional_description__tooltip":"Tässä voidaan luetella esimerkiksi seuraavat tiedot: Rakennus- tai muiden lupien saatavuus, viranomaisvaatimukset jne.","AgentProvisionForm::agent_commission":"Välityspalkkio (brutto)","AgentProvisionForm::agent_commission_description":"% ostohinnasta","AgentProvisionForm::agent_commission_tooltip":"Pitää olla max. 1.19 % välittäjän bruttopalkkiosta","BuyerDataForm::acting_organ__function":"Valtuutettu edustaja - rooli","Commands::are_you_sure_to_block_user":"Asiakas estetään ja suljetaan jatkotarjousprosessin ulkopuolelle. Oletko varma?","Commands::are_you_sure_to_end_round_early":"Jos lopetat menettelyn ennenaikaisesti, uusia tarjouksia ei voida tehdä. Oletko varma?","Commands::are_you_sure_to_end_round_early_sealed":"Jos lopetat menettelyn ennenaikaisesti, uusia tarjouksia ei voida tehdä ja tarjousten määrä paljastetaan. Oletko varma?","company_id":"Yrityksen rekisteröintinumero","companylegalform::cooperative":"Osuuskunta (Genossenschaft)","companylegalform::foundation":"Säätiö (Stiftung)","companylegalform::general_partnership":"Avoin yhtiö (Kollektivgesellschaft)","companylegalform::jointstock_company":"Osakeyhtiö (Aktiengesellschaft)","companylegalform::kommanditaktiengesellschaft":"Osakeyhtiö (Kommandit-Aktiengesellschaft)","companylegalform::limited_liability_company":"Osakeyhtiö (GmbH)","companylegalform::limited_partnership":"Kommandiittiyhtiö (Kommanditgesellschaft)","companylegalform::other":"Muut","companylegalform::simple_society":"Tavallinen yhtiö (Einfache Gesellschaft)","companylegalform::society":"Yhdistys (Verein)","costsoption::contract":"sopimuskustannukset","costsoption::notary":"notariaattikustannukset","costsoption::registry":"kiinteistörekisterikustannukset","costsoption::reservation":"varausmaksun käsittelykulut","costsoption::transfer_tax":"varainsiirtovero","costsparty::buyer":"Tuleva ostaja","costsparty::none":"N/A","costsparty::seller":"Omistaja","costsparty::split":"Jaa 50-50","deposittype::fixed_amount":"Kiinteä määrä","deposittype::none":"Ei ole","deposittype::percentage":"Prosenttiosuus","documenttype::area_allocation_plan":"Aluesuunnitelmat","documenttype::area_measurement":"Pinta-alan mittaus","documenttype::articles_of_association":"Yhtiöjärjestys","documenttype::brochure":"Esite","documenttype::building_permit":"Rakennuslupa","documenttype::cadastral_certificate":"Kiinteistörekisteriote","documenttype::certificate_of_title":"Lainhuutotodistus","documenttype::condition_of_the_building_report":"Yhtiön kuntoon liittyvä selvitys/selvitykset","documenttype::easement_register":"Käyttöoikeusrekisteri","documenttype::encumbrance_certificate":"Rasitustodistus","documenttype::energy_performance_certificate":"Energiatodistus","documenttype::financial_statements":"Tilinpäätös","documenttype::floor_area_measurement_record":"Pinta-alan mittauspöytäkirja","documenttype::floor_plan":"Pohjapiirros","documenttype::insurance_policy":"Vakuutus","documenttype::lease":"Vuokrasopimus","documenttype::location_map":"Sijaintikartta","documenttype::long_term_repair_plan":"PTS","documenttype::maintenance_needs_report":"Kunnossapitotarveselvitys","documenttype::maintenance_plan":"Kunnossapitosuunnitelma","documenttype::moisture_measurement_and_condition_audit_reports":"Huoneiston kosteusmittaus / kuntoon liittyvät selvitykset","documenttype::other":"Muut","documenttype::partition_deed":"Jakokirja","documenttype::partition_plan":"Jakosuunnitelma","documenttype::real_estate_managers_certificate":"Isännöitsijäntodistus","documenttype::rental_contract":"Vuokrasopimus","documenttype::repairs_and_alterations_report":"Huoneiston korjaus- ja muutostöihin liittyvät selvitykset","documenttype::reserves":"Varaukset","documenttype::share_based_dwelling_printout":"Osakehuoneistotuloste","documenttype::share_register_printout":"Osakeluettelotuloste","documenttype::utility_costs":"Yleishyödylliset kustannukset","DuplicateStep1::agbs":"Käyttäjäsopimus","DuplicateStep1::avv":"Sopimus tilausten käsittelystä","DuplicateStep1::dataprotection":"Tietosuoja","DuplicateStep1::i_agree_to_the_link":"Olen lukenut {agbs} ja {dataprotection} ja hyväksyn ne.","from_agent_commission":"välittäjän bruttopalkkiosta","from_offer_value":"tarjoushinnasta","from_purchase_value":"tarjoushinnasta","handovertype::land_register":"Omistusoikeuden siirtyessä","handovertype::money_transfer":"Kaupanteossa","ListingsOverview::number":"Kiinteistön tunnus","ListingsOverview::pending_offers":"Tarjoukset","ListingsOverview::title":"Otsikko","ownershiptype::ae":"Yksinomainen omistus","ownershiptype::ge":"Yhteinen omistus","ownershiptype::joint":"Yhteinen omistus","ownershiptype::meg":"Yhteisomistus","ownershiptype::stwe":"Asunto-osakeyhtiö","Page1::additional_description":"Muut kuvaukset ja tärkeät tiedot kiinteistöstä","Page1::balcony_number":"Parvekkeen numero","Page1::bond_account_number":"Joukkovelkakirjalainan tilinumero","Page1::bonded_to":"Sidottu","Page1::conveyancers":"Kiinteistönvälittäjät","Page1::door_number":"Oven numero","Page1::electronic_shares":"Sähköiset osakkeet","Page1::erf_number":"ERF-numero","Page1::flat_no":"Asunnon numero","Page1::following_known_defects":"Seuraavat viat ovat tiedossa","Page1::garden_number":"Puutarhan numero","Page1::housing_company":"Asunto-osakeyhtiö","Page1::known_defects":"Tunnetut viat","Page1::listing_no":"Kohdenumero","Page1::no_known_defects":"Ei tiedossa olevia vikoja","Page1::object_number":"Kiinteistön tunnus","Page1::parking_bay_number":"Pysäköintipaikan numero","Page1::plot_area":"Tontin pinta-ala","Page1::redemption_clause":"Lunastuslauseke","Page1::reservation_of_rights_of_extension":"Laajentamisoikeuksien varaaminen","Page1::scheme_name":"Järjestelmän nimi","Page1::section_number":"Jakson numero","Page1::sectional_plan_area":"Osayleiskaava-alue","Page1::sectional_plan_number":"Leikkaussuunnitelman numero","Page1::shares":"Osakenumerot","Page1::surface_area":"Olohuone","Page1::title_deed_no":"Osoitekirja nro.","Page1::township":"Kaupunki","Page1::unit_number":"Unit number","Page1::utility_room_number":"Kodinhoitohuoneen numero","Page1::yard_number":"Pihan numero","Page2::can_be_max_max_of_the_gross_agent_commission":"Voi olla enintään {max} % välittäjän bruttopalkkiosta","Page2::capital_charge_from":"Pääomavastikkeesta (rahoitusvastikkeesta) vastaa ostaja alkaen","Page2::compensation":"Korvaus viivästyneestä luovutuksesta","Page2::compensation__info":"Jos asunnon vapautuminen viivästyy myyjän vuoksi, myyjä maksaa ostajalle kertakorvauksen viivästyksestä.","Page2::compensation__total":"Kertakorvaus","Page2::compensation__weekly":"Viikoittain","Page2::deposit":"Talletus","Page2::deposit_title":"Talletus","Page2::deposits_and_penalties":"Käsiraha tai vakiokorvaus","Page2::has_mortgage":"Kiinnitys otetaan haltuun","Page2::is_rented":"Asunto myydään vuokrattuna","Page2::maintenance_takeover_from":"Ostaja maksaa ylläpito- ja muut maksut alkaen","Page2::monthly_rent":"Kuukausittainen vuokran määrä","Page2::mortgage_certificate_date":"Velkatodistuksen liikkeeseenlaskupäivä","Page2::mortgage_tooltip":"","Page2::noncompliance_title":"Kulujen korvaaminen, jos sopimus jää täyttämättä","Page2::other_trade_conditions":"Muut kaupan ehdot","Page2::provision":"Ostajan välityspalkkio (brutto)","Page2::provision_title":"Välityspalkkio","Page2::rent_deposit_transfer_until":"Vuokravakuuden siirto asti","Page2::rent_payment_from":"Vuokra maksetaan ostajalle alk","Page2::rental_status":"Huoneiston vuokraus","Page2::total_amount_must_be_documented":"Kokonaismäärä on dokumentoitava!","Page2::type_of_payment":"Varausmaksun tyyppi","allowed_file_formats":"Ainoastaan PDF- tai JPG-muotoisia asiakirjoja voi ladata, ja niiden enimmäiskoko on 20 Mt.","Page3::documents":"Kiinteistöasiakirjat","paymenttype::deposit":"Käsiraha maksetaan myyjän hyväksyttyä tarjouksen","paymenttype::none":"Ei käsirahaa tai vakiokorvausta","paymenttype::penalty":"Vakiokorvaus peruttaessa tarjous hyväksymisen jälkeen","penaltytype::fixed_amount":"Kertakorvaus","penaltytype::percentage":"Prosenttiosuus","phone_number":"Matkapuhelinnumero","provisiontype::fixed_amount":"Kertakorvaus","provisiontype::fixed_percentage":"Prosenttiosuus","provisiontype::none":"Ei ole","provisiontype::standard_at":"Standardi","RefuseDialog::optional_documents":"Valinnaiset asiakirjat","RefuseDialog::required_documents":"Tarvittavat asiakirjat","RegistrationPanel::locale":"Suositeltava kieli","RegistrationPanel::offer_viewing":"Asiakas vieraillut kohteessa","RegistrationPanel::optional_documents":"Valinnaiset asiakirjat","RegistrationPanel::required_documents":"Tarvittavat asiakirjat","RegistrationPanel::upload_new_offer":"Tarjouksen tekeminen asiakkaan puolesta","RoundEdit::antisniping_notice":"Tarjousajan päättymistä jatketaan automaattisesti 15 minuutilla, jos uusi tarjous vastaanotetaan viimeisten 15 minuutin aikana ennen päättymistä. Tämä pidennys toistuu, kunnes uusia tarjouksia ei ole tehty 15 minuuttiin.","RoundEdit::bidding_type_tooltip":"Avoimessa menettelyssä on tarjottava vähintään lähtöhinta, kaikki saapuvat ostohintatarjoukset julkistetaan nimettöminä, ja osallistuvat tarjoajat voivat korottaa tarjoustaan niin usein kuin on tarpeen määritellyissä vähimmäisvaiheissa. Suljetussa menettelyssä ostajaehdokkaat voivat tehdä vain tarjouksen, jonka suuruuden voi valita vapaasti ja joka on salattu järjestelmässä prosessin loppuun asti ja joka julkistetaan välittäjälle vasta sen päätyttyä.","RoundEdit::open_round_warning":"Avoimessa tarjouskilpailussa on suunniteltu vain yksi kierros, ja kaikki tarjoushinnat ovat avoimia kaikille osallistujille.","RoundEdit::please_enter_a_starting_price":"Syötä numero, joka on suurempi kuin 0","RoundEdit::red_button_price":"Sisäinen varaushinta","RoundPanel::open_round_warning":"Avoimessa tarjouskilpailussa on suunniteltu vain yksi kierros, ja kaikki tarjoushinnat ovat avoimia kaikille osallistujille.","RoundPanel::round":"Tarjousprosessin keskeisten parametrien määrittäminen","Sale::billing_notice":" ","Sale::cannot_update_documents_for_open_round__documents_uploaded":"Seuraavat asiakirjat ladattiin:","Sale::cannot_update_documents_for_open_round__no_documents":"Et ole ladannut mitään asiakirjoja.","Sale::guide__invite_users":"Kutsuaksesi potentiaalisen asiakkaan tarvitset hänen koko nimensä, sähköpostiosoitteensa ja matkapuhelinnumeronsa.","Sale::guide__open_round":"Jotta voit aloittaa digitaalisen tarjousprosessin ja kutsua yksittäisiä asiakkaita, sinun on avattava kierros.","Sale::open_round_info_notice_openbidding":"Olet aloittamassa <strong>avointa</strong> kierrosta, jonka <strong>lähtöhinta on {startPrice}</strong>, joka kestää <strong>{duration}</strong> ja päättyy {date} <strong>klo {time}</strong>.","Sale::open_round_info_notice_sealedbidding":"Olet aloittamassa <strong>suljetun</strong> kierroksen, jonka <strong>tavoitehinta on {arvio}</strong> ja joka kestää <strong>{kesto}</strong> ja päättyy {päivänä} <strong>{aikana}</strong>.","Sale::you_are_about_to_upload_offer_in_the_name_of_customer":"Olet aikeissa ladata ostotarjouksen asiakkaan puolesta. Näin ollen asiakas ei voi enää lähettää ostotarjoustaan verkossa.","SaleCreatePanel::agbs":"Käyttäjäsopimus","SaleCreatePanel::avv":"Sopimus tilausten käsittelystä","SaleCreatePanel::dataprotection":"Tietosuoja","SaleCreatePanel::i_agree_to_the_link":"Olen lukenut {agbs} ja {dataprotection} ja hyväksyn ne.","SaleCreatePanel::price_tooltip":"CRM:ään tallennettu virallinen listaushinta","seller_civil_status::married_in_community":"Avioliitto aviovarallisuussuhteessa","seller_civil_status::married_law":"Naimisissa, avioliitto on säädetty lakien mukaan","seller_civil_status::married_other":"Muut","seller_civil_status::married_out_of_community":"Avioliitto ilman varallisuusyhteyttä","seller_civil_status::unmarried":"Naimaton","uploadtype::identity_document":"Henkilöllisyystodistus","uploadtype::proof_of_financial_resources":"Rahoitustodisteet","uploadtype::residence_permit":"Oleskelulupa"}

/***/ }),
/* 456 */
/***/ (function(module, exports) {

module.exports = {"additional_description__tooltip":"Les informations suivantes, par exemple, peuvent être répertoriées ici: vente à part de garage ou autres places de parking.Paiement à distance pour la cuisine ou les meubles encastrables. exigences réglementaires, etc.","AgentProvisionForm::agent_commission":"Commission de courtage (brute)","AgentProvisionForm::agent_commission_description":"% du prix d'achat","AgentProvisionForm::agent_commission_tooltip":"Doit correspondre à un maximum de 1,19% de la commission de","BuyerDataForm::acting_organ__function":"Organe intérimaire - fonction","Commands::are_you_sure_to_block_user":"L'acheteur potentiel est par la présente bloqué et exclu du processus d'offre ultérieur. Es-tu sûr?","Commands::are_you_sure_to_end_round_early":"Si vous mettez fin à la procédure plus tôt, aucune autre offre ne pourra être soumise. Es-tu sûr?","Commands::are_you_sure_to_end_round_early_sealed":"Si vous mettez fin à la procédure plus tôt, aucune autre offre ne pourra être soumise et les montants des offres seront révélés. Es-tu sûr?","company_id":"Nnuméro d'entreprise","companylegalform::cooperative":"Coopérative","companylegalform::foundation":"Fondation","companylegalform::general_partnership":"Société collective","companylegalform::jointstock_company":"Aktiengesellschaft (AG)","companylegalform::kommanditaktiengesellschaft":"Partenariat limite","companylegalform::limited_liability_company":"Société à responsabilité limitée","companylegalform::limited_partnership":"Partenariat limite","companylegalform::other":"Autres","companylegalform::simple_society":"Entreprise simple","companylegalform::society":"Société","costs":"Frais d'achat supplémentaires","costsoption::contract":"Coûts du contrat","costsoption::notary":"Frais de notarisation","costsoption::registry":"Frais de cadastre","costsoption::reservation":"Frais de traitement du paiement de la réservation","costsoption::transfer_tax":"Taxe de transfert","costsparty::buyer":"Acheteur","costsparty::none":"Non","costsparty::seller":"Propriétaire","costsparty::split":"50 - 50 partagés","deposittype::fixed_amount":"Montant fixé","deposittype::none":"Non","deposittype::percentage":"Pourcentage","documenttype::area_allocation_plan":"Plans de zone","documenttype::area_measurement":"Calcul de surface","documenttype::building_permit":"Permis de construire","documenttype::easement_register":"Liste des charges du bâtiment","documenttype::insurance_policy":"Avis d'assurance spéciale bâtiment / police d'assurance","documenttype::location_map":"Une carte","documenttype::other":"Autres","documenttype::partition_deed":"Déclaration de division","documenttype::partition_plan":"Plan de division","documenttype::rental_contract":"Contrat de location","documenttype::reserves":"Réserves","documenttype::utility_costs":"Facture pour frais supplémentaires","DuplicateStep1::agbs":"Accord de l'utilisateur","DuplicateStep1::avv":"Accord de traitement des commandes","DuplicateStep1::dataprotection":"Protection des données","DuplicateStep1::i_agree_to_the_link":"J'ai lu le {agbs} et le {dataprotection} et je les accepte.","from_agent_commission":"de commission de courtage brute","from_offer_value":"du prix de l'offre","from_purchase_value":"du prix d'achat","handovertype::land_register":"Après inscription au registre foncier","handovertype::money_transfer":"Après avoir transféré le prix d'achat","ListingsOverview::number":"Objet non","ListingsOverview::pending_offers":"Des offres","ListingsOverview::title":"Titre de l'objet","ownershiptype::ae":"Propriété individuelle","ownershiptype::ge":"Pro­priété com­mune","ownershiptype::joint":"Possession commune","ownershiptype::meg":"Copropriété","ownershiptype::stwe":"Propriété par étages","Page1::additional_description":"Autres descriptions et informations importantes sur la propriété","Page1::following_known_defects":"Les défauts suivants sont connus","Page1::known_defects":"Défauts matériels connus","Page1::no_known_defects":"Aucun défaut connu","Page1::object_number":"Objet non","Page1::plot_area":"Superficie du terrain","Page1::surface_area":"Surface habitable / utilisable","Page2::can_be_max_max_of_the_gross_agent_commission":"Peut correspondre à un maximum de {max} % de la commission de courtage brute","Page2::deposit":"Frais de réservation","Page2::deposit_title":"Frais de réservation","Page2::has_mortgage":"Hypothèque à reprendre","Page2::mortgage_condition":"Conditions","Page2::mortgage_condition_tooltip":"Consigner ici les conditions déterminantes, telles que le taux d’intérêt, la durée de vie résiduelle, etc.","Page2::mortgage_tooltip":"Inscrivez ici le montant de l’hypothèque actuellement dû","Page2::noncompliance_title":"Indemnisation des dépenses en cas de non-exécution","Page2::provision":"Commission de courtage (brute)","Page2::provision_title":"Commission de courtage","Page2::total_amount_must_be_documented":"Le montant total doit être vérifiable par des pièces justificatives","allowed_file_formats":"Vous ne pouvez télécharger que des documents au format PDF ou JPG d'une taille maximale de 20 MB.","Page3::documents":"Documents de propriété","phone_number":"Numéro de téléphone portable","provisiontype::fixed_amount":"Montant forfaitaire","provisiontype::fixed_percentage":"Pourcentage","provisiontype::none":"Non","provisiontype::standard_at":"Norme","RefuseDialog::optional_documents":"Documents facultatifs","RefuseDialog::required_documents":"Documents requis","RegistrationPanel::locale":"Langue préférée","RegistrationPanel::offer_viewing":"Le rendez-vous de visite a eu lieu le","RegistrationPanel::optional_documents":"Documents facultatifs","RegistrationPanel::required_documents":"Documents requis","RegistrationPanel::upload_new_offer":"Soumettre une offre au nom du client","RoundEdit::bidding_type_tooltip":"Dans la procédure ouverte, au moins le prix de départ doit être proposé.Toutes les offres de prix d'achat entrantes sont publiées de manière anonyme et les enchérisseurs participants peuvent augmenter leur offre aussi souvent qu'ils le souhaitent dans des étapes minimales fixes. Dans le processus fermé, les acheteurs potentiels ne peuvent soumettre qu'une seule offre, dont le montant peut être librement choisi et est crypté dans le système jusqu'à la fin du processus et n'est divulgué au courtier qu'après la fin du processus.","RoundEdit::open_round_warning":"Dans le processus d'appel d'offres ouvert, un seul tour est prévu et tous les prix des offres sont ouverts à tous les participants.","RoundEdit::red_button_price":"Prix ​​du bouton rouge (interne)","RoundPanel::open_round_warning":"Dans le processus d'appel d'offres ouvert, un seul tour est prévu et tous les prix des offres sont ouverts à tous les participants.","RoundPanel::round":"Définir les données clés pour le tour","Sale::billing_notice":" ","Sale::guide__invite_users":"Pour inviter une personne intéressée, vous avez besoin de son nom complet, de son adresse e-mail et de son numéro de portable.","Sale::guide__open_round":"Pour lancer le processus d'offre numérique et inviter des clients individuels, vous devez ouvrir le tour.","Sale::open_round_info_notice_openbidding":"Vous commencez un tour <strong>ouvert</strong> avec un <strong>prix de départ de {startPrice}</strong> qui <strong>{duration}</strong> se termine le {date} <strong>à {time}.</strong>","Sale::open_round_info_notice_sealedbidding":"Vous commencez un tour <strong>fermé</strong> avec un <strong>cours cible de {estimate}</strong> qui <strong>{duration}</strong> se termine le {date} <strong>à {time}.</strong>","Sale::you_are_about_to_upload_offer_in_the_name_of_customer":"Vous êtes sur le point de télécharger l'offre d'achat au nom du client. Ainsi, le client ne peut plus soumettre son offre d'achat en ligne.","SaleCreatePanel::agbs":"Accord de l'utilisateur","SaleCreatePanel::avv":"Accord de traitement des commandes","SaleCreatePanel::dataprotection":"Protection des données","SaleCreatePanel::i_agree_to_the_link":"J'ai lu le {agbs} et le {dataprotection} et je les accepte.","SaleCreatePanel::price_tooltip":"Prix ​​de vente officiel stocké dans onOffice","Search::agbs":"Accord de l'utilisateur","Search::avv":"Accord de traitement des commandes","Search::dataprotection":"Protection des données","Search::error_loading_objects":"Une erreur s'est produite lors du chargement des objets","Search::i_agree_to_the_link":"J'ai lu le {agbs} et le {dataprotection} et je les accepte.","uploadtype::identity_document":"Preuve d'identité","uploadtype::proof_of_financial_resources":"Preuve de financement","uploadtype::residence_permit":"Statut résidentiel"}

/***/ }),
/* 457 */
/***/ (function(module, exports) {

module.exports = {"additional_description__tooltip":"Qui, ad esempio, possono essere elencate le seguenti informazioni: Vendita separata di garage o altri posti auto Pagamento a distanza per cucina o mobili da incasso. requisiti normativi ecc.","administration_costs_annual":"Ordinaria","administration_costs_extra":"Straordinaria","administration_costs_extra_tooltip":"Spese straordinarie deliberate nell’ultimo esercizio","administration_costs_heating_included":"Comprensive di riscaldamento","administrative_expenses":"Spese di amministrazione","administrative_expenses_annual":"Spese ordinarie (annue)","administrative_expenses_extra":"Spese straordinarie","administrative_expenses_extra_tooltip":"Spese straordinarie deliberate nell’ultimo esercizio","administrative_expenses_heating_included":"Comprensive di riscaldamento","agency":"Agenzia immobiliare","agency_name":"Ragione Sociale","agency_street":"Indirizzo","agent":"Agente immobiliare","AgentProvisionForm::agent_commission":"Commissione broker (lorda)","AgentProvisionForm::agent_commission_description":"% del prezzo di acquisto","AgentProvisionForm::agent_commission_tooltip":"Deve corrispondere ad un massimo dell'1,19% della commissione di intermediazione lorda","apartment_number":"Int.","area":"Dimensione","billing_notice":" ","BuyerDataForm::acting_organ__function":"Organo che agisce - funzione","buyertype::company":"Compagnia","buyertype::entrepreneur":"Imprenditore","buyertype::private":"Privato","cadastral_compliance":"Conformità dell’immobile alle norme edilizie e urbanistiche","cadastral_municipality":"Comune","cadastre":"Catasto","cadastre_land":"Catasto Terreni","cadastre_land::address":"Indirizzo","cadastre_land::cadastral_municipality":"Comune catastale","cadastre_land::class_of_prodctivity":"Classe","cadastre_land::consistency":"Superficie","cadastre_land::consistency_a":"Superficie (Are)","cadastre_land::consistency_ca":"Superficie (Ca)","cadastre_land::consistency_ha":"Superficie (Ha)","cadastre_land::income_agrarian":"Reddito agrario","cadastre_land::income_landlord":"Reddito dominicale","cadastre_land::map_sheet_number":"Foglio","cadastre_land::parcel_number":"Particella","cadastre_land::section_code":"Sezione","cadastre_land::type":"Qualità","cadastre_urban":"Catasto Fabbricati","cadastre_urban::address":"Indirizzo","cadastre_urban::cadastral_income":"Rendita","cadastre_urban::cadastral_municipality":"Comune catastale","cadastre_urban::class_of_productivity":"Classe","cadastre_urban::consistency":"Consistenza","cadastre_urban::map_sheet_number":"Foglio","cadastre_urban::parcel_number":"Particella","cadastre_urban::rooms":"Vani","cadastre_urban::section_code":"Sezione","cadastre_urban::size":"Superficie","cadastre_urban::size_netto":"Superficie Escluse Aree Scoperte","cadastre_urban::subparcel_number":"Sub.","cadastre_urban::subparcel_number_long":"Subalterno","cadastre_urban::typology":"Categoria","cciaa":"C.C.I.A.A.","city":"Città","Commands::are_you_sure_to_block_user":"Il potenziale acquirente è bloccato ed escluso dall'ulteriore processo di offerta. Sei sicuro?","Commands::are_you_sure_to_end_round_early":"In caso di conclusione anticipata della procedura non è possibile presentare ulteriori offerte. Sei sicuro?","Commands::are_you_sure_to_end_round_early_sealed":"In caso di conclusione anticipata della procedura non è possibile presentare ulteriori offerte e gli importi delle offerte saranno rivelati. Sei sicuro?","company_id":"Numero di registrazione della società","companylegalform::cooperative":"Cooperativa","companylegalform::foundation":"Fondazione","companylegalform::general_partnership":"Società in nome collettivo","companylegalform::jointstock_company":"Società per azioni","companylegalform::kommanditaktiengesellschaft":"Società in accomandita","companylegalform::limited_liability_company":"Società a responsabilità limitata","companylegalform::limited_partnership":"Società in accomandita","companylegalform::other":"Altri","companylegalform::simple_society":"Azienda semplice","companylegalform::society":"Società","compliance":"Conformità","condominium_fees":"Spese condominiali","consistency_a_a":"Are","consistency_ca_ca":"Ca","consistency_ha_ha":"Ha","costs":"Costi di acquisto aggiuntivi","costsoption::contract":"Costi contrattuali","costsoption::notary":"Spese notarili","costsoption::registry":"Spese catastali","costsoption::reservation":"Costi per l'elaborazione del pagamento della prenotazione","costsoption::transfer_tax":"Imposta di trasferimento","costsparty::buyer":"Acquirente","costsparty::none":"No","costsparty::seller":"Proprietario","costsparty::split":"50 - 50 condivisi","court_name":"Foro competente","debt_amount":"Debito residuo","debt_detail":"Dettagli del debito","debt_type":"Debito","debt_type::forclosure":"Pignoramento","debt_type::judical_claim":"Pretese giudiziali","debt_type::lien":"Ipoteca esattoriale","debt_type::mortgage":"Ipoteca (Mutuo residuo)","debt_type::none":"Nessuno","deposit":"Deposito","deposit_transfer_bank":"Nome della banca","deposit_transfer_bic":"BIC","deposit_transfer_duration":"Deposito entro","deposit_transfer_explanation":"(se selezionato come metodo di pagamento dall'acquirente)","deposit_transfer_iban":"IBAN","deposit_transfer_owner":"Titolare del conto bancario","deposit_transfer_title":"Con versamento diretto alla Parte Venditrice","deposittype::fixed_amount":"Importo fisso","deposittype::none":"Nessuno","deposittype::percentage":"Percentuale","description":"Descrizione","documenttype::area_allocation_plan":"Piani di zona","documenttype::area_measurement":"Calcolo dell'area","documenttype::building_permit":"Permesso di costruzione","documenttype::cadastral_plan":"Planimetria catastale","documenttype::cadastral_survey":"Visura catastale","documenttype::easement_register":"Elenco dei carichi dell'edificio","documenttype::energy_certificate":"APE","documenttype::insurance_policy":"Avviso di assicurazione speciale edificio / polizza assicurativa","documenttype::location_map":"Mappa di localizzazione","documenttype::origin_deed":"Atto di provenienza","documenttype::other":"Altri","documenttype::partition_deed":"Dichiarazione di divisione","documenttype::partition_plan":"Piano di divisione","documenttype::rental_contract":"contratto di affitto","documenttype::reserves":"Riserve","documenttype::utility_costs":"Fattura per costi aggiuntivi","due_diligence_deadline":"Giorni per la verifica di iscrizioni e/o trascrizioni","DuplicateStep1::agbs":"Condizioni Generali per l'Utilizzo","DuplicateStep1::avv":"Accordo per l'elaborazione degli ordini","DuplicateStep1::dataprotection":"l'Accordo sul Trattamento dei Dati Personali","DuplicateStep1::i_agree_to_the_link":"Ho letto le {agbs} e la {dataprotection} e le accetto.","from_agent_commission":"di commissione lorda di intermediazione","from_offer_value":"dal prezzo di offerta","from_purchase_value":"dal prezzo di acquisto","full_address":"Indirizzo n. civico, città, provincia, CAP","handovertype::land_register":"Dopo l'iscrizione nel registro fondiario","handovertype::money_transfer":"Dopo aver trasferito il prezzo di acquisto","house_number":"No.","ListingsOverview::number":"Oggetto no","ListingsOverview::pending_offers":"Offerte","ListingsOverview::title":"Titolo oggetto","notary_date":"Data fissata per la vendita","object_address":"Indirizzo di proprietà","object_cadastral_compliance::compliant":"Conforme","object_cadastral_compliance::compliant_when_built":"Conforme all’epoca di costruzione","object_cadastral_compliance::noncompliant":"Non conforme","object_cadastral_compliance::noncompliant_fixed":"Non conforme, e quindi da regolarizzare entro l’atto di vendita","object_cadastral_compliance::pending":"Da adeguare prima del rogito","object_composition":"Composizione","object_owner":"Proprietà intestata a","object_provenance":"Atto di provenienza","object_provenance::donation":"Donazione","object_provenance::other":"Altra","object_provenance::sale":"Vendita","object_provenance::succession":"Successione","object_provenance_date":"Data","object_provenance_description":"Dettagli sulla provenienza","object_provenance_detail":"Numero di repertorio","object_provenance_notary":"Notaio","object_provenance_title":"Provenienza","object_regulation_compliance::guaranteed":"Garantito dal venditore","object_regulation_compliance::not_guaranteed":"Non garantito dal venditore","object_usability_compliance::certificate_absent_indemnified":"Non dotato - Manleva","object_usability_compliance::certificate_absent_not_indemnified":"Non dotato - Non manleva","object_usability_compliance::certificate_present":"Dotato del certificato","object_usability_compliance_equiped::false":"Non dotato di agibilità","object_usability_compliance_equiped::true":"Dotato di agibilità","object_usability_compliance_indemnification::false":"Non manleva dal certificato e dagli adempimenti","object_usability_compliance_indemnification::true":"Manleva dal certificato e dagli adempimenti","object_usage":"Destinazione d’uso","occupation":"Occupazione (alla vendita)","occupation_name":"Nome","occupation_rent_expiration":"Scadenza del contratto","occupation_type":"Stato di occupazione possesso e consegna dell’immobile","occupationtype::construction":"In construzione","occupationtype::free":"Libero","occupationtype::rented":"Locato","ownershiptype::ae":"Proprietà individuale","ownershiptype::ge":"Pro­prie­tà co­mu­ne","ownershiptype::joint":"Comproprietà","ownershiptype::meg":"Comproprietà","ownershiptype::stwe":"Pro­prie­tà per pia­ni","Page1::additional_description":"Altre descrizioni e informazioni importanti sulla proprietà","Page1::cadastre_new_item":"Aggiungere nuova voce catastale","Page1::following_known_defects":"Sono note le seguenti carenze","Page1::known_defects":"Bekannte wesentliche Mängel","Page1::no_known_defects":"Difetti materiali noti","Page1::object_number":"Oggetto no","Page1::plot_area":"Area del grafico","Page1::surface_area":"Zona giorno/utilizzabile","Page2::can_be_max_max_of_the_gross_agent_commission":"Può corrispondere a un massimo del {max}% della commissione di intermediazione lorda","Page2::deposit":"Tassa di prenotazione","Page2::deposit_title":"Primo pagamento (Caparra)","Page2::has_mortgage":"Mutuo da prendere in carico","Page2::mortgage_condition":"Condizioni","Page2::mortgage_condition_tooltip":"Annotare qui le condizioni rilevanti come tasso d'interesse, durata residua ecc.","Page2::noncompliance_title":"Risarcimento spese in caso di inadempimento","Page2::provision":"Commissione broker (lorda)","Page2::provision_title":"Commissione di intermediazione","Page2::sale_act_title":"Atto di vendita","Page2::total_amount_must_be_documented":"L'importo totale deve essere verificabile mediante documenti giustificativi","allowed_file_formats":"Puoi caricare solo documenti in formato PDF o JPG con una dimensione massima di 20 MB.","Page3::documents":"Documenti di proprietà","phone_number_placeholder":"+39 30 000 00000","post_code":"CAP","postal_code":"CAP","prejudicial_registrations":"Esistenza di iscrizioni e/o trascrizioni pregiudizievoli","rea":"R.E.A.","RefuseDialog::optional_documents":"Documenti opzionali","RefuseDialog::required_documents":"Documenti richiesti","registered_address":"PEC","RegistrationPanel::locale":"Lingua preferita","RegistrationPanel::offer_viewing":"La visita dell'immobile ha avuto luogo il","RegistrationPanel::optional_documents":"Documenti opzionali","RegistrationPanel::required_documents":"Documenti richiesti","RegistrationPanel::upload_new_offer":"Invia un'offerta per conto del cliente","regulation_compliance":"Conformità degli impianti","rent_amount":"Canone annuo attuale","represented_by":"Rappresentata da","role":"Funzione","RoundEdit::bidding_type_tooltip":"Nella procedura aperta, deve essere offerto almeno il prezzo di partenza.Tutte le offerte di prezzo di acquisto in entrata sono pubblicate in forma anonima e gli offerenti partecipanti possono aumentare la loro offerta tutte le volte che vogliono in passaggi minimi prestabiliti. Nel processo chiuso, i potenziali acquirenti possono presentare solo un'offerta, il cui importo può essere selezionato liberamente ed è crittografato nel sistema fino alla fine del processo e viene comunicato al broker solo dopo la fine del processo.","RoundEdit::open_round_warning":"Nel processo di offerta aperta, è pianificato un solo round e tutti i prezzi di offerta sono aperti a tutti i partecipanti.","RoundEdit::red_button_price":"Prezzo pulsante rosso (interno)","RoundPanel::open_round_warning":"Nel processo di offerta aperta, è pianificato un solo round e tutti i prezzi di offerta sono aperti a tutti i partecipanti.","RoundPanel::round":"Definisci i dati chiave per il round","Sale::billing_notice":" ","Sale::guide__invite_users":"Per invitare una persona interessata, è necessario il suo nome completo, il suo indirizzo e-mail e il suo numero di cellulare.","Sale::guide__open_round":"Per avviare il processo di offerta digitale e invitare i singoli clienti, devi aprire il round.","Sale::open_round_info_notice_openbidding":"Inizi un round <strong>aperto</strong> con un <strong>prezzo iniziale di {startPrice}</strong> che <strong>{duration}</strong> termina il {date} <strong>alle {time}.</strong>","Sale::open_round_info_notice_sealedbidding":"Inizi un round <strong>chiuso</strong> con un <strong>prezzo target di {estimate}</strong> che <strong>{duration}</strong> termina il {date} <strong>alle {time}.</strong>","Sale::you_are_about_to_upload_offer_in_the_name_of_customer":"Stai per caricare l'offerta di acquisto per conto del cliente. Pertanto, il cliente non può più presentare la sua offerta di acquisto online.","SaleCreatePanel::agbs":"Condizioni Generali per l'Utilizzo","SaleCreatePanel::avv":"Accordo per l'elaborazione degli ordini","SaleCreatePanel::dataprotection":"l'Accordo sul Trattamento dei Dati Personali","SaleCreatePanel::i_agree_to_the_link":"Accetto le {agbs} della piattaforma e {dataprotection}.","SaleCreatePanel::number":"ID Immobile","SaleCreatePanel::price_tooltip":"Prezzo di quotazione ufficiale memorizzato in onOffice","Search::agbs":"Condizioni Generali per l'Utilizzo","Search::avv":"Accordo per l'elaborazione degli ordini","Search::dataprotection":"l'Accordo sul Trattamento dei Dati Personali","Search::error_loading_objects":"Si è verificato un errore durante il caricamento degli oggetti","Search::i_agree_to_the_link":"Accetto le {agbs} della piattaforma e {dataprotection}.","seller_conditions":"Condizioni del venditore","seller_notary_proposal":"Proposta data notarile da parte del venditore","seller_title":"Parte Venditrice","SellerDataForm::seller_type":"Tipo di venditore","sellertype::company":"Società","sellertype::entrepreneur":"Imprenditore","sellertype::private":"Soggetto privato","size_m2":"mq","size_m3":"mc","size_netto_m2":"mq","size_netto_m3":"mc","state":"Provincia","street":"Via","tax_code":"Codice Fiscale","termination_clause":"Clausola risolutiva espressa","tranches":"Pagamenti intermedi","tranches::amount":"Importo","tranches::date":"Entro il","tranches_explanation":"(come richiesto dal venditore)","tranches_new":"Aggiungere un'ulteriore voce nei pagamenti intermedi","type_of_seller":"Tipo di venditore","uploadtype::identity_document":"Documento di identità dell’acquirente","uploadtype::proof_of_financial_resources":"Documento di finanziamento","uploadtype::residence_permit":"Permesso di residenza","usability_compliance":"Riferimento all’Agibilità","usagetype::commercial":"Commerciale","usagetype::industrial":"Industriale/artigianale","usagetype::residential":"Residenziale","usagetype::service":"Direzionale/di servizio","usagetype::tourist":"Turistico/ricettivo","vat_id":"P. IVA","zip":"CAP","zip_code":"CAP"}

/***/ }),
/* 458 */
/***/ (function(module, exports) {

module.exports = {"additional_description__tooltip":"Tu so lahko na primer navedeni naslednji podatki: ločena prodaja garaže ali parkirnih mest, dodatno plačilo kuhinje ali vgradnega pohištva, razpoložljivost gradbenih ali drugih dovoljenj, posebne zahteve in pogoji itd.","AgentProvisionForm::agent_commission":"Posredniška provizija (bruto)","AgentProvisionForm::agent_commission_description":"% od pogodbene nakupne vrednosti","AgentProvisionForm::agent_commission_tooltip":"Mora znašati največ 1,19% bruto posredniške  provizije.","BuyerDataForm::acting_organ__function":"Pooblaščeni zastopnik - vloga","Commands::are_you_sure_to_block_user":"Potencialni kupec bo blokiran in izključen iz nadaljnjega postopka zbiranja ponudb. Ste prepričani?","Commands::are_you_sure_to_end_round_early":"Če predčasno zaključite postopek, ne bo mogoče sprejeti novih ponudb. Ste prepričani?","Commands::are_you_sure_to_end_round_early_sealed":"Če predčasno zaključite postopek, ne bo mogoče sprejeti novih ponudb in zneski ponudb bodo razkriti. Ste prepričani?","company_id":"Matična številka","companylegalform::cooperative":"","companylegalform::foundation":"Zavod","companylegalform::general_partnership":"","companylegalform::jointstock_company":"Delniška družba","companylegalform::kommanditaktiengesellschaft":"Komanditna družba","companylegalform::limited_liability_company":"Družba z omejeno odgovornostjo","companylegalform::limited_partnership":"","companylegalform::other":"Drugo","companylegalform::self_employed":"Samostojni podjetnik","companylegalform::simple_society":"","companylegalform::society":"","companylegalform::unlimited_liability_company":"Družba z neomejeno odgovornostjo","costs":"Drugi stroški ","costsoption::contract":"Stroški izpeljave pravnega posla","costsoption::notary":"Stroški notarske overitve","costsoption::registry":"Stroški vpisa v zemljiško knjigo","costsoption::reservation":"Stroški vodenja fiduciarnega računa","costsoption::transfer_tax":"Davek na promet v poslovanju z nepremičninami (2% pogodbene vrednosti)","costsparty::buyer":"Kupec","costsparty::none":"Ni podatka","costsparty::seller":"Prodajalec","costsparty::split":"Delitev 50/50","deposittype::fixed_amount":"Fiksni znesek","deposittype::none":"Brez","deposittype::percentage":"Odstotek ","documenttype::area_allocation_plan":"Prostorski načrti","documenttype::area_measurement":"Površina zemljišča","documenttype::building_permit":"Gradbeno dovoljenje","documenttype::easement_register":"Pogodba o služnosti","documenttype::insurance_policy":"Zavarovalna polica","documenttype::location_map":"Zemljevid lokacije","documenttype::other":"Drugo","documenttype::partition_deed":"Dokumenti glede etažiranja","documenttype::partition_plan":"Dokumenti glede parcelacije","documenttype::rental_contract":"Najemna pogodba","documenttype::reserves":"Rezervni sklad","documenttype::utility_costs":"Komunalni stroški","DuplicateStep1::agbs":"pogoje uporabe","DuplicateStep1::avv":"Politika varstva osebnih podatkov","DuplicateStep1::dataprotection":"politiko varstva podatkov","DuplicateStep1::i_agree_to_the_link":"Prebral sem {agbs} in {dataprotection} ter se z njimi strinjam.","from_agent_commission":"bruto posredniška provizija","from_offer_value":"od ponujene cene","from_purchase_value":"od kupnine","handovertype::land_register":"Po notarski overitvi","handovertype::money_transfer":"Po plačilu kupnine","ListingsOverview::number":"ID nepremičnine","ListingsOverview::pending_offers":"Ponudbe","ListingsOverview::title":"Naslov","ownershiptype::joint":"Deljeno lastništvo","Page1::additional_description":"Drugi opisi in pomembne informacije o nepremičnini","Page1::following_known_defects":"Na nepremičnini so znane naslednje napake:","Page1::known_defects":"Znane napake: ","Page1::no_known_defects":"Zaznanih ni nobenih napak","Page1::object_number":"ID nepremičnine","Page1::plot_area":"Površina zemljišča","Page1::surface_area":"Površina objekta","Page2::can_be_max_max_of_the_gross_agent_commission":"Lahko znaša največ {max}% bruto posredniške provizije","Page2::deposit":"Varščina","Page2::deposit_title":"Varščina","Page2::has_mortgage":"Hipoteka za prevzem","Page2::noncompliance_title":"Povračilo stroškov v primeru neizpolnitve pogodbenih obveznosti","Page2::provision":"Stroški za kupca","Page2::provision_title":"Posredniška provizija","Page2::total_amount_must_be_documented":"Navedeni morajo biti celotni stroški","allowed_file_formats":"Naložite lahko samo PDF ali JPG format dokumenta, maksimalne velikosti 20 MB.","Page3::documents":"Dokumenti nepremičnine","phone_number":"Mobilna telefonska številka","provisiontype::fixed_amount":"Fiksna vrednost","provisiontype::fixed_percentage":"Odstotek","provisiontype::none":"Brez","RefuseDialog::optional_documents":"Dodatni dokumenti","RefuseDialog::required_documents":"Obvezni dokumenti","RegistrationPanel::locale":"Izbran jezik","RegistrationPanel::offer_viewing":"Ogled nepremičnine se je izvedel na dan","RegistrationPanel::optional_documents":"Dodatni dokumenti","RegistrationPanel::required_documents":"Obvezni dokumenti","RegistrationPanel::upload_new_offer":"Oddaj ponudbo v imenu stranke","RoundEdit::antisniping_notice":"Konec postopka za oddajo ponudbe se avtomatsko podaljša za 15 minut, če je v zadnjih 15-tih minutah prejeta nova ponudba. To podaljševanje se ponavlja vse dokler v zadnjih 15-tih minutah ni prejete nove ponudbe.","RoundEdit::bidding_type_tooltip":"Pri odprtem postopku je potrebno ponuditi vsaj izklicno ceno, vse prejete ponudbe se razkrijejo anonimno, sodelujoči ponudniki pa lahko svojo ponudbo povečajo toliko krat, kot je zahtevano v določenih minimalnih korakih. V zaprtem postopku lahko bodoči kupci oddajo le eno ponudbo, katere znesek lahko prosto izberejo in je šifriran v sistemu do konca postopka ter se posredniku razkrije šele po koncu.","RoundEdit::open_round_warning":"Pri odprtem postopku je predviden samo en krog zbiranja ponudb in vse ponudbe so znane vsem ponudnikom.","RoundEdit::please_enter_a_starting_price":"Prosim vnesite število, ki je večje od 0","RoundEdit::red_button_price":"Rdeča cena (interna)","RoundPanel::open_round_warning":"V odprtem postopku oddaje ponudb je načrtovan samo en krog dražbe in vse nakupne ponudbe so vidne vsem ponudnikom.","RoundPanel::round":"Določite ključne podatke za novi krog","Sale::billing_notice":" ","Sale::guide__invite_users":"Da lahko pošljete vabilo na dražbo potrebujete ime in priimek, elektronski naslov in mobilno telefonsko številko potencialnih kupcev.","Sale::guide__open_round":"Za pričetek elektronske oddaje ponudb in za pošiljanje vabil, morate začeti nov krog dražbe.","Sale::open_round_info_notice_openbidding":"Začeli boste z<strong>odprtim</strong> krogom oddaje ponudb z <strong>začetno ceno {startPrice}</strong>, ki traja <strong>{duration}</strong> in se zaključi {date} <strong>ob {time}</strong>.","Sale::open_round_info_notice_sealedbidding":"Pričeli boste z<strong>zaprtim</strong> krogom oddaje ponudb z <strong>začetno ceno {estimate}</strong>, ki traja <strong>{duration}</strong> in se zaključi {date} <strong>ob {time}</strong>.","Sale::you_are_about_to_upload_offer_in_the_name_of_customer":"Naložili boste nakupno ponudbo v imenu stranke. Ta stranka ne more več oddati svoje ponudbe za nakup.","SaleCreatePanel::agbs":"pogoje uporabe","SaleCreatePanel::avv":"Politika varstva osebnih podatkov","SaleCreatePanel::dataprotection":"politiko varstva podatkov","SaleCreatePanel::i_agree_to_the_link":"Prebral sem {agbs} in {dataprotection} ter se z njimi strinjam.","SaleCreatePanel::price_tooltip":"Oglaševana cena nepremičnine, ki je zabeležena v iListu","Search::agbs":"pogoje uporabe","Search::avv":"Politika varstva osebnih podatkov","Search::dataprotection":"politiko varstva podatkov","Search::error_loading_objects":"Pri nalaganju je prišlo do napake","Search::guide_no_objects":"Izgleda, da trenutno ni nepremičnin.","Search::i_agree_to_the_link":"Prebral sem {agbs} in {dataprotection} ter se z njimi strinjam.","uploadtype::confirmation_of_payment_reservation":"Dokazilo o plačilu varščine","uploadtype::identity_document":"Kopija osebnega dokumenta","uploadtype::proof_of_financial_resources":"Dokazilo glede financiranja","uploadtype::residence_permit":"Potrdilo o stalnem prebivališču"}

/***/ }),
/* 459 */
/***/ (function(module, exports) {

module.exports = {"documenttype::cadastral_documentation":"Cadastrală","documenttype::cadastral_plan":"Plan cadastral","documenttype::commercial_register_proof":"Dovada din ONRC","documenttype::id_document":"Document de identitate","documenttype::lease_agreement":"Contract de închiriere","documenttype::location_map":"Certificat de urbanism","documenttype::national_id":"Carte de identitate","documenttype::other":"Altele","documenttype::ownership_deed":"Actul de proprietate asupra imobilului","documenttype::passport":"Pașaport","documenttype::photo":"Fotografie","documenttype::proof_of_ownership":"Documente referitoare la proprietate","documenttype::property_sketch":"Schiță imobil (releveu)","documenttype::seller_statements":"Declarații asumate de vânzător","documenttype::technical_documentation":"Documentație tehnică","objectconstructiontype::bca":"BCA","objectconstructiontype::brick":"Cărămidă","objectconstructiontype::concrete":"Beton","objectconstructiontype::frame":"Cadru","objectconstructiontype::metal":"Metal","objectconstructiontype::monolith":"Monolith","objectconstructiontype::other":"Altele","objectconstructiontype::plates":"Plăci","objectconstructiontype::wood":"Lemn","salecurrency::eur":"Euro","salecurrency::ron":"Leu","sellertype::private":"Persoană fizică","sellertype::company":"Companie","uploadtype::identity_document":"Dovadă de identitate","uploadtype::proof_of_financial_resources":"Dovada resurselor financiare","Page1::apartment":"Apartament","Page1::area_built":"Suprafață construită","Page1::area_usable":"Suprafață utilă","Page1::block_number":"Bloc","Page1::cadastral_or_topographic_number":"Număr cadastral sau topografic","Page1::common_parts_of_the_property":"Părți comune","Page1::compartmentalisation":"Compartimentarea construcției","Page1::county":"Județ","Page1::floor_level":"Etaj","Page1::further_information":"Informatii suplimentare","Page1::further_property_data":"Alte date despre proprietate","Page1::intended_use_of_property":"Destinație","Page1::land_registry_data":"Date de identificare în CF","Page1::number_of_rooms":"Număr camere","Page1::object_height":"Regim de înălțime al construcției","Page1::property_locationaddress":"Locația / adresa proprietății","Page1::stair_number":"Scară","Page1::surface_of_the_land":"Suprafața terenului aferent","Page1::type_of_construction":"Tipul construcției","Page1::utilities":"Utilități","Page2::commission":"Comisiei","Page2::currency_of_purchase":"Moneda de cumpărare","Page2::from_offer_value":"din prețul ofertei","Page2::ownership_total":"Ownership total","Page2::ownership_share":"Ownership share","Page2::payment_deadline":"Termen de plată a prețului","Page2::seller":"Vânzătorului","Page3::section__seller":"Acte referitoare la vânzător","Page3::section__property":"Alte documente ale imobilului","BuyerDataForm::address_suffix":"Adresa aditionala","BuyerDataForm::civil_status":"Stare civilă","BuyerDataForm::county":"Județ","BuyerDataForm::id_number":"C.I. nu","BuyerDataForm::id_series":"C.I. seria","BuyerDataForm::id_type":"Tipul ID-ului internațional","BuyerDataForm::personal_id_number":"CNP","BuyerDataForm::prenuptial_agreement":"Convenție matrimonială","BuyerDataForm::role":"Calitate","CompanyDataForm::company_registry_number":"Număr de înregistrare la ONRC","CompanyDataForm::tax_identification_code":"Cod identificare fiscală","RefuseDialog::required_documents":"Documente necesare","RefuseDialog::optional_documents":"Documente opționale","RegistrationPanel::required_documents":"Documente necesare","RegistrationPanel::optional_documents":"Documente opționale","RegistrationPanel::locale":"Limba preferată","Sale::billing_notice":"Costul pocesului de licitație, perceput de platforma IMOBID, este de 0,2% net, calculat din prețul ofertei câstigătoare - și se va factura biroului de către RE/MAX Romania.","SellerDataForm::postal_code":"Cod postal","SellerDataForm::address_suffix":"Adresă adițională","SellerDataForm::county":"Județ","SellerDataForm::position":"Calitatea","SellerDataForm::representative":"Reprezentant","SellerDataForm::tax_identification_code":"Cod identificare fiscală","SellerDataForm::type_of_seller":"Tipul vânzătorului","RegistrationPanel::purchase_price_gross_info":"TVA-ul este{vat}% si va fi adăugat la pretul net de cumpărare","OfferDetailsForm::purchase_price_gross_info":"TVA-ul este{vat}% si va fi adăugat la pretul net de cumpărare","phone_number_placeholder":"+40 333 00 00 00"}

/***/ }),
/* 460 */
/***/ (function(module, exports) {

module.exports = {"deed_type::quitclaim":"Quitclaim","deed_type::special_warranty":"Special Warranty","deed_type::warranty":"Warranty","Page1::estate":"Estate","Page1::form_of_deed":"Form of Deed","Page1::island":"Island","Page1::lead_warning_disclosure":"Lead Warning Disclosure (for improved property built pre-1978)","Page1::olg_map_reference":"OLG Map Reference","Page1::quarter":"Quarter","Page1::tax_parcel_number":"Tax Parcel Number","Page1::tenancy":"Tenancy","Page1::title_insurance_company":"Title Insurance Company","Page2::agent_representing":"Agent is representing the seller","Page2::seller_exchange":"This sale is part of Like-Kind Exchange under IRC Section 1031","tenancy::free":"Property not occupied or occupied by the owner only","tenancy::occupied":"Existing tenants"}

/***/ }),
/* 461 */
/***/ (function(module, exports) {

module.exports = {"owner_financing_provided":"Seller willing to offer owner financing","seller_commission_disclaimer":"If entered, will be shown to every potential buyer as part of \"Letter of Intent\"; if left empty or 0, it will not be shown."}

/***/ }),
/* 462 */
/***/ (function(module, exports) {

module.exports = {"occupation::unoccupied":"Vacant","occupation::with_tenants":"Single tenancy","Page1::conveyancer_name":"Conveyancer name","Page1::conveyancer_address":"Address","Page1::conveyancer_account":"Account number","Page1::conveyancer_bank":"Bank name","Page1::conveyancer_branch":"Branch code","existing_tenants":"The property is leased to","lease_agreement":"Lease agreement reference","otp::commercial":"Commercial OTP","otp::residential":"Residential OTP","Page1::full_title":"Full Title","Page1::occupation":"Existing tenancies","Page1::property_bonded_to":"","Page1::sale_type":"OTP type (residential / commercial)","Page1::title_type":"Title","Page2::going_concern":"The Property is intended to be sold as a going concern in terms of Section 11(1)(e) of the VAT Act 89 of 1991","Page2::surety_required":"Suretyship","Page2::surety_required_for_company_buyers":"The suretyship is required for company buyers.","SellerFormListItem::is_resident":"Is resident of South Africa","titletype::full":"Full Title","titletype::sectional":"Sectional Title","occupation::multi_tenancies":"Multiple tenancies","Page1::multi_tenancies_upload_hint":"Please upload an overview of all tenancies (document type \"Tenancy overview\") in the documents step.","Page2::going_concern_title":"Going concern","Page2::going_concern_income_earning":"The Property hereby sold will be part of an income earning activity on the date of transfer.","Page2::going_concern_separate_operation":"The Property is capable of separate business operation and all the assets necessary for the carrying on of a separate income earning activity are disposed of by the Seller to the Purchaser together with the Property.","SellerFormListItem::tax_number":"SARS Tax Number","SellerFormListItem::vat_number":"VAT Registration Number","documenttype::tenancy_overview":"Tenancy overview"}

/***/ }),
/* 463 */
/***/ (function(module, exports) {

module.exports = {"audiencetype::bidders":"Registrierung abgeschlossen","audiencetype::non_bidders":"Nicht abgeschlossene Registrierung","audiencetype::wishlist":"Mit Wunschliste","audiencetype::no_wishlist":"Ohne Wunschliste","audiencetype::item_bidders":"Bieter","audiencetype::non_item_bidders":"Nichtbieter","company_id":"Handelsregisternummer","companylegalform::simple_society":"Einfache Gesellschaft","companylegalform::general_partnership":"Kollektivgesellschaft","companylegalform::limited_partnership":"Kommanditgesellschaft","companylegalform::jointstock_company":"Aktiengesellschaft (AG)","companylegalform::kommanditaktiengesellschaft":"Kommandit-Aktiengesellschaft","companylegalform::limited_liability_company":"Gesellschaft mit beschränkter Haftung (GmbH)","companylegalform::cooperative":"Genossenschaft","companylegalform::society":"Verein","companylegalform::foundation":"Stiftung","companylegalform::other":"Sonstige","deposittype::none":"Keine","deposittype::fixed_amount":"Fester Betrag","deposittype::percentage":"Prozentsatz","documenttype::annual_statement":"Jahresabrechnung","documenttype::area_allocation_plan":"Flächenpläne","documenttype::area_measurement":"Flächenberechnung","documenttype::building_permit":"Baugenehmigung","documenttype::easement_register":"Baulastenverzeichnis","documenttype::insurance_policy":"Gebäudesonderversicherungsbescheid (KF) / Versicherungspolice","documenttype::location_map":"Lageplan","documenttype::partition_deed":"Teilungserklärung","documenttype::partition_plan":"Teilungsplan","documenttype::rental_contract":"Mietvertrag","documenttype::reserves":"Rücklagen","documenttype::utility_costs":"Nebenkostenabrechnung","documenttype::weg_protocols":"WEG-Protokolle","handovertype::land_register":"Nach Grundbucheintragung","handovertype::money_transfer":"Nach Überweisung des Kaufpreises","handovertype::key_handover":"Bei Schlüsselübergabe","handovertype::sale_contract":"Gemäß Kaufvertrag","maritalstatus::none":" ","ownershiptype::joint":"Gesamteigentum","phone_number":"Mobilnummer","template::cust_phase_wishlist_closing":"Nur noch 24 Std. für ihre Grundstücksvorauswahl","template::cust_phase_offer_starting":"Start der Kaufangebotsabgabe","uploadtype::identity_document":"Identitätsnachweis","uploadtype::residence_permit":"Aufenthaltsstatus","uploadtype::proof_of_financial_resources":"Finanzierungsnachweis","ListingsOverview::number":"Objekt-Nr","ListingsOverview::title":"Objekt-Titel","ListingsOverview::pending_offers":"Angebote","Page1::object_number":"Objekt-Nr.","Page1::additional_description":"Sonstige Beschreibungen und wichtige Hinweise zum Objekt","additional_description__tooltip":"Hier können z.B. folgende Informationen aufgeführt werden: Separater Verkauf von Garagen- oder sonstigen Stellplätzen, Abstandszahlung für Küche oder Einbaumöbel, Vorliegen von Bau- oder sonstigen Genehmigungen; behördliche Auflagen, etc.","Page1::known_defects":"Bekannte wesentliche Mängel","Page1::no_known_defects":"Keine Mängel bekannt","Page1::following_known_defects":"Folgende Mängel sind bekannt","Page2::provision":"Maklerprovision (brutto)","Page2::provision_title":"Maklerprovision","Page2::deposit_title":"Reservierungsgebühr","Page2::noncompliance_title":"Aufwandsentschädigung bei Nichterfüllung","Page2::deposit":"Reservierungsgebühr","Page2::total_amount_must_be_documented":"Gesamtbetrag muss durch Belege nachweisbar sein","Page2::from_offer_value":"vom Angebotspreis","Page2::from_agent_commission":"von Brutto-Maklerprovision","Page2::can_be_max_max_of_the_gross_agent_commission":"Darf max. {max}% der Brutto-Maklerprovision entsprechen","Page3::documents":"Objektunterlagen","AgentProvisionForm::agent_commission":"Maklerprovision (brutto)","AgentProvisionForm::agent_commission_description":"% vom Kaufpreis","AgentProvisionForm::agent_commission_tooltip":"Muss max. 1,19% der Brutto-Maklerprovision entsprechen","RefuseDialog::required_documents":"Erforderliche Unterlagen","RefuseDialog::optional_documents":"Optionale Unterlagen","RegistrationPanel::required_documents":"Erforderliche Unterlagen","RegistrationPanel::offer_viewing":"Besichtigungstermin erfolgte am","Sale::billing_notice":" ","Sale::guide__open_round":"Um das digitale Angebotsverfahren zu starten und einzelne Kunden einzuladen, müssen Sie die Runde öffnen","Sale::guide__invite_users":"Um einen Interessenten einzuladen, brauchen Sie seinen vollen Namen, seine E-Mail-Adresse und seine Mobilnummer.","Sale::open_round_info_notice_sealedbidding":"Sie starten eine <strong>geschlossene</strong> Runde mit <strong>Richtpreis von {estimate}</strong> die <strong>{duration}</strong> am {date} <strong>um {time} endet.</strong>","Sale::open_round_info_notice_openbidding":"Sie starten eine <strong>offene</strong> Runde mit <strong>Startpreis von {startPrice}</strong> die <strong>{duration}</strong> am {date} <strong>um {time} endet.</strong>","Sale::you_are_about_to_upload_offer_in_the_name_of_customer":"Sie sind dabei das Kaufangebot im Namen des Kunden hochzuladen. Somit kann der Kunde sein Kaufangebot nicht mehr online abgeben.","RegistrationPanel::optional_documents":"Optionale Unterlagen","RegistrationPanel::locale":"Bevorzugte Sprache","RegistrationPanel::upload_new_offer":"Angebot im Namen des Kunden abgeben","BuyerDataForm::acting_organ__function":"Handelndes Organ - Funktion","SaleCreatePanel::price_tooltip":"Offizieller Listing-Preis, der in onOffice hinterlegt ist","RoundEdit::bidding_type_tooltip":"Beim offenen Verfahren muss mindestens der Startpreis geboten werden, alle eingehenden Kaufpreisangebote werden anonymisiert offengelegt und teilnehmende Bieter können ihr Angebot beliebig häufig in festgelegten Mindestschritten erhöhen. Beim geschlossenen Verfahren können Kaufinteressenten nur ein Angebot abgeben, dessen Höhe frei wählbar ist und bis Ende des Verfahrens im System verschlüsselt ist und erst nach Ende dem Makler offengelegt wird.","RoundEdit::red_button_price":"Red Button Preis (intern)","RoundEdit::open_round_warning":"Im offenen Angebotsverfahren ist nur eine Runde vorgesehen und alle Angebotspreise sind für alle Teilnehmer offen einsehbar.","RoundPanel::round":"Eckdaten der Runde festlegen","RoundPanel::open_round_warning":"Im offenen Angebotsverfahren ist nur eine Runde vorgesehen und alle Angebotspreise sind für alle Teilnehmer offen einsehbar.","provisiontype::none":"Keine","provisiontype::fixed_amount":"Pauschalbetrag","provisiontype::fixed_percentage":"Prozentsatz","Commands::are_you_sure_to_end_round_early":"Wenn Sie das Verfahren vorzeitig beenden können keine weiteren Angebote mehr abgegeben werden. Sind Sie sicher?","Commands::are_you_sure_to_block_user":"Hiermit wird der Kaufinteressent gesperrt und vom weiteren Angebotsprozess ausgeschlossen. Sind Sie sicher?","DuplicateStep1::i_agree_to_the_link":"Ich habe die {agbs} und die {dataprotection} gelesen und stimme diesen zu.","DuplicateStep1::agbs":"Nutzungsvereinbarung","DuplicateStep1::dataprotection":"Datenschutzerklärung","DuplicateStep1::avv":"Auftragsverarbeitungsvereinbarung","SaleCreatePanel::i_agree_to_the_link":"Ich habe die {agbs} und die {dataprotection} gelesen und stimme diesen zu.","SaleCreatePanel::agbs":"Nutzungsvereinbarung","SaleCreatePanel::dataprotection":"Datenschutzerklärung","SaleCreatePanel::avv":"Auftragsverarbeitungsvereinbarung","Search::error_loading_objects":"Beim laden von Objekten ist ein Fehler aufgetreten","Search::i_agree_to_the_link":"Ich habe die {agbs} und die {dataprotection} gelesen und stimme diesen zu.","Search::agbs":"Nutzungsvereinbarung","Search::dataprotection":"Datenschutzerklärung","Search::avv":"Auftragsverarbeitungsvereinbarung"}

/***/ }),
/* 464 */
/***/ (function(module, exports) {

module.exports = {"audiencetype::bidders":"Finished registration","audiencetype::non_bidders":"Unfinished registration","audiencetype::wishlist":"With wishlist","audiencetype::no_wishlist":"Without wishlist","audiencetype::item_bidders":"Bidders","audiencetype::non_item_bidders":"Non-bidders","companylegalform::simple_society":"Ordinary company (Einfache Gesellschaft)","companylegalform::general_partnership":"General partnership (Kollektivgesellschaft)","companylegalform::limited_partnership":"Limited partnership (Kommanditgesellschaft)","companylegalform::jointstock_company":"Joint-stock company (Aktiengesellschaft)","companylegalform::kommanditaktiengesellschaft":"Limited stock company (Kommandit-Aktiengesellschaft)","companylegalform::limited_liability_company":"Limited liability company (GmbH)","companylegalform::cooperative":"Cooperative (Genossenschaft)","companylegalform::society":"Association (Verein)","companylegalform::foundation":"Foundation (Stiftung)","companylegalform::other":"Other","deposittype::none":"None","deposittype::fixed_amount":"Fixed amount","deposittype::percentage":"Percentage","documenttype::annual_statement":"Annual statement","documenttype::area_allocation_plan":"Area plans","documenttype::area_measurement":"Area measurement","documenttype::building_permit":"Building permit","documenttype::easement_register":"Easement register","documenttype::insurance_policy":"Special building insurance notice / insurance policy","documenttype::location_map":"Location map","documenttype::partition_deed":"Partition deed","documenttype::partition_plan":"Partition plan","documenttype::rental_contract":"Rental contract","documenttype::reserves":"Reserves","documenttype::utility_costs":"Utility costs","documenttype::weg_protocols":"WEG protocols","handovertype::land_register":"After entry in the land register excerpt","handovertype::money_transfer":"After transfer of the purchase price to a predefined account","handovertype::key_handover":"After key handover","handovertype::sale_contract":"According to the sales contract","ownershiptype::joint":"Joint ownership","template::cust_phase_wishlist_closing":"Wishlist phase is about to end","template::cust_phase_offer_starting":"Offer phase starting","upload_more":"Upload more documents","uploadtype::identity_document":"Identity document","uploadtype::residence_permit":"Residence permit","uploadtype::proof_of_financial_resources":"Proof of financing","ListingsOverview::number":"Property ID","ListingsOverview::title":"Title","ListingsOverview::pending_offers":"Offers","Page1::object_number":"Property ID","Page1::additional_description":"Other descriptions and important information about the property","Page1::known_defects":"Known defects","Page1::no_known_defects":"No defects known","Page1::following_known_defects":"The following defects are known","Page2::deposit":"Deposit","Page2::allowance_for_noncompliance":"Allowance for non-compliance","Page2::total_amount_must_be_documented":"Total amount must be documented!","Page2::from_offer_value":"of the offer price","Page2::from_agent_commission":"of gross agent commission","Page2::can_be_max_max_of_the_gross_agent_commission":"Can be max {max}% of the gross agent commission","Page3::documents":"Property documents","AgentProvisionForm::agent_commission":"Agent commission (brutto)","AgentProvisionForm::agent_commission_description":"% of the purchase price","AgentProvisionForm::agent_commission_tooltip":"Must be max. 1.19% of the gross agent commission","RefuseDialog::required_documents":"Required documents","RefuseDialog::optional_documents":"Optional documents","RegistrationPanel::required_documents":"Required documents","RegistrationPanel::offer_viewing":"Seen on","Sale::billing_notice":"The costs of this offer procedure amounting to 0.1% of the highest bid received will be charged to the commissioning broker.","RegistrationPanel::optional_documents":"Optional documents","RegistrationPanel::locale":"Preferred language","BuyerDataForm::acting_organ__function":"Authorized representative - role","SaleCreatePanel::price_tooltip":"Official listing price, which is stored on the RE/MAX website or in onOffice","RoundEdit::bidding_type_tooltip":"With the open procedure, at least the starting price must be offered, all incoming purchase price offers are disclosed anonymously and participating bidders can increase their offer as often as required in defined minimum steps. In the closed process, prospective buyers can only submit an offer, the amount of which can be freely selected and is encrypted in the system until the end of the process and is only disclosed to the broker after the end."}

/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports = {"Dashboard::tel__sms__whatsapp":"Tel","handovertype::money_transfer":"Nach Einlangen des Kaufpreises am Treuhandkonto","page_title":":DAVE","Page2::additional_buyer_uploads":"Welche Dokumente sollen Käufer (optional) noch hochladen müssen, neben Finanzierungsbestätigung und Identitätsnachweis?","Page2::buyer_uploads":"Zusätzliche Dokumente für Käufer","Page2::delivery_date_condition_warranty":"Übergabe-Termin, -Zustand, Gewährleistung","Page2::exceptions":"Ausnahme von grundbücherlichen und außerbücherlichen Lasten","Page2::notary":"Vertragserrichter","Page2::payment":"Zahlung","RoundEdit::red_button_price":"Red Button Preis","RoundItem::incremental_auction_costs":"- Einmalig 175 € pro Objekt wenn min. ein Anbot eingeht\n- Keine Anbote, <u>keine Kosten</u>","RoundItem::open_bidding_costs":"- Einmalig 175 € pro Objekt wenn min. ein Anbot eingeht\n- Keine Anbote, <u>keine Kosten</u>","RoundItem::sealed_bidding_costs":"- Einmalig 175 € pro Objekt wenn min. ein Anbot eingeht\n- Keine Anbote, <u>keine Kosten</u>","RoundItem::simple_offer_costs":"- <u>Kostenfrei</u>, sofern <u>weniger als zwei</u> Anbote eingehen\n- Bei zwei oder mehr Anboten, einmalig 175 € pro Objekt; Objekt kann dann <u>kostenfrei ins offene/geschlossene DAVE</u> überführt werden zur dynamischen Preisoptimierung","RoundItem::simple_offer_howitworkspoints":"- Einfache digitale Angebotsabgabe\n- Listingpreis = Referenz\n- Angebotspreis <u>frei</u> wählbar\n- Kunde kann nur <u>ein</u> Angebot abgeben\n- Keine Information zu möglichen anderen Interessenten\n- Kein fester Endtermin\n- Möglichkeit, flexibel ins DAVE zu wechseln, wenn mehrere Kunden Anbote abgeben","Sale::billing_notice":"Die Kosten dieses Angebotsverfahrens von 175,00 € werden mit Eingang des ersten Kaufangebots dem beauftragenden Makler in Rechnung gestellt.","Sale::billing_notice_simple_offer":"<strong>Kosten:</strong> Sollten min. zwei Anbote eingehen, so werden 175 € berechnet; das Objekt kann dann kostenfrei ins offene/geschlossene DAVE überführt werden zur dynamischen Preisoptimierung. Die ggf. entstehenden Kosten werden dem beauftragenden Makler in Rechnung gestellt.","Sale::guides__round_closed":"Ihre Runde ist jetzt vorüber. Sie können die Übersicht für den Abgeber vorbereiten und das Ergebnis eingeben.","SaleWizard::rejectall":"Nutzen Sie diese Funktion, wenn der Abgeber nicht weiter mit dem Verfahren fortfahren will und auch kein Kaufangebot angenommen wurde.\nAlle Interessenten die ein Angebot abgegeben haben werden benachrichtigt.\nDas Verfahren wird geschlossen, so dass keine weiteren Eingriffe mehr gemacht werden können.","uploadtype::identity_document":"Identitätsnachweis","uploadtype::proof_of_financial_resources":"Finanzierungsnachweis"}

/***/ }),
/* 466 */
/***/ (function(module, exports) {

module.exports = {"Dashboard::tel__sms__whatsapp":"Tel","Sale::billing_notice":"The costs of this bidding process of 175.00 € will be charged to the commissioning agent upon receipt of the first purchase offer.","Page2::buyer_uploads":"Additional buyer uploads","Page2::additional_buyer_uploads":"Which other documents should the buyer upload besides ID Card and Proof of financing","uploadtype::identity_document":"Identity document","uploadtype::proof_of_financial_resources":"Proof of financing"}

/***/ }),
/* 467 */
/***/ (function(module, exports) {

module.exports = {"additional_description__tooltip":"Hier können z.B. folgende Informationen aufgeführt werden: Separater Verkauf von Garagen- oder sonstigen Stellplätzen, Abstandszahlung für Küche oder Einbaumöbel, Vorliegen von Bau- oder sonstigen Genehmigungen; behördliche Auflagen, etc.","AgentProvisionForm::agent_commission":"Maklerprovision (brutto)","AgentProvisionForm::agent_commission_description":"% vom Angebotspreis","AgentProvisionForm::agent_commission_tooltip":"Muss max. 1,19% der Brutto-Maklerprovision entsprechen","BuyerDataForm::acting_organ__function":"Handelndes Organ - Funktion","company_id":"Handelsregisternummer","companylegalform::cooperative":"Genossenschaft","companylegalform::foundation":"Stiftung","companylegalform::general_partnership":"Kollektivgesellschaft","companylegalform::jointstock_company":"Aktiengesellschaft (AG)","companylegalform::kommanditaktiengesellschaft":"Kommandit-Aktiengesellschaft","companylegalform::limited_liability_company":"Gesellschaft mit beschränkter Haftung (GmbH)","companylegalform::limited_partnership":"Kommanditgesellschaft","companylegalform::other":"Sonstige","companylegalform::simple_society":"Einfache Gesellschaft","companylegalform::society":"Verein","deposittype::fixed_amount":"Fester Betrag","deposittype::none":"Keine","deposittype::percentage":"Prozentsatz","documenttype::annual_statement":"Jahresabrechnung","documenttype::area_allocation_plan":"Flächenpläne","documenttype::area_measurement":"Flächenberechnung","documenttype::building_permit":"Baugenehmigung","documenttype::easement_register":"Baulastenverzeichnis","documenttype::insurance_policy":"Gebäudesonderversicherungsbescheid (KF) / Versicherungspolice","documenttype::location_map":"Lageplan","documenttype::partition_deed":"Teilungserklärung","documenttype::partition_plan":"Teilungsplan","documenttype::rental_contract":"Mietvertrag","documenttype::reserves":"Rücklagen","documenttype::utility_costs":"Nebenkostenabrechnung","documenttype::weg_protocols":"WEG-Protokolle","handovertype::key_handover":"Bei Schlüsselübergabe","handovertype::land_register":"Nach Grundbucheintragung","handovertype::money_transfer":"Nach Überweisung des Kaufpreises","handovertype::sale_contract":"Gemäß Kaufvertrag","ListingsOverview::number":"Objekt-Nr","ListingsOverview::pending_offers":"Angebote","ListingsOverview::title":"Objekt-Titel","maritalstatus::none":" ","ownershiptype::joint":"Gesamteigentum","Page1::additional_description":"Sonstige Beschreibungen und wichtige Hinweise zum Objekt","Page1::following_known_defects":"Folgende Mängel sind bekannt","Page1::known_defects":"Bekannte Mängel","Page1::no_known_defects":"Keine Mängel bekannt","Page1::object_number":"Objekt-Nr.","Page2::can_be_max_max_of_the_gross_agent_commission":"Darf max. {max}% der Brutto-Maklerprovision entsprechen","Page2::deposit":"Reservierungsgebühr","Page2::deposit_title":"Reservierungsgebühr","Page2::from_agent_commission":"von Brutto-Maklerprovision","Page2::from_offer_value":"vom Angebotspreis","Page2::noncompliance_title":"Aufwandsentschädigung bei Nichterfüllung","Page2::provision":"Maklerprovision (brutto)","Page2::provision_title":"Maklerprovision","Page2::total_amount_must_be_documented":"Gesamtbetrag muss durch Belege nachweisbar sein","Page3::documents":"Objektunterlagen","page_title":"DAVEit","phone_number":"Mobilnummer","phone_number_placeholder":"+49 150 0000 0000","provisiontype::fixed_amount":"Pauschalbetrag","provisiontype::fixed_percentage":"Prozentsatz","provisiontype::none":"Keine","RefuseDialog::optional_documents":"Optionale Unterlagen","RefuseDialog::required_documents":"Erforderliche Unterlagen","RegistrationPanel::locale":"Bevorzugte Sprache","RegistrationPanel::offer_viewing":"Besichtigungstermin erfolgte am","RegistrationPanel::optional_documents":"Optionale Unterlagen","RegistrationPanel::required_documents":"Erforderliche Unterlagen","RoundEdit::bidding_type_tooltip":"Beim offenen Verfahren muss mindestens der Startpreis geboten werden, alle eingehenden Kaufpreisangebote werden anonymisiert offengelegt und teilnehmende Bieter können ihr Angebot beliebig häufig in festgelegten Mindestschritten erhöhen. Beim geschlossenen Verfahren können Kaufinteressenten nur ein Angebot abgeben, dessen Höhe frei wählbar ist und bis Ende des Verfahrens im System verschlüsselt ist und erst nach Ende dem Makler offengelegt wird.","RoundEdit::open_round_warning":"Im offenen Angebotsverfahren ist nur eine Runde vorgesehen und alle Angebotspreise sind für alle Teilnehmer offen einsehbar.","RoundEdit::red_button_price":"Red Button Preis (intern)","RoundPanel::open_round_warning":"Im offenen Angebotsverfahren ist nur eine Runde vorgesehen und alle Angebotspreise sind für alle Teilnehmer offen einsehbar.","RoundPanel::round":"Eckdaten der Runde festlegen","Sale::billing_notice":"Die Kosten dieses Angebotsverfahrens in Höhe von 0,1% des höchsten eingegangen Gebotes werden dem beauftragenden Makler in Rechnung gestellt. Geht kein Angebot ein, entstehen keine Kosten.","Sale::guide__invite_users":"Um einen Interessenten einzuladen, brauchen Sie seinen vollen Namen, seine E-Mail-Adresse und seine Mobilnummer.","Sale::guide__open_round":"Um das digitale Angebotsverfahren zu starten und einzelne Kunden einzuladen, müssen Sie die Runde öffnen","Sale::open_round_info_notice_openbidding":"Sie starten eine <strong>offene</strong> Runde mit <strong>Startpreis von {startPrice}</strong> die <strong>{duration}</strong> am {date} <strong>um {time} endet.</strong>","Sale::open_round_info_notice_sealedbidding":"Sie starten eine <strong>geschlossene</strong> Runde mit <strong>Richtpreis von {estimate}</strong> die <strong>{duration}</strong> am {date} <strong>um {time} endet.</strong>","SaleCreatePanel::price_tooltip":"Offizieller Listing-Preis, der auf de RE/MAX Webseite bzw. in onOffice hinterlegt ist","uploadtype::identity_document":"Identitätsnachweis","uploadtype::proof_of_financial_resources":"Finanzierungsnachweis","uploadtype::residence_permit":"Aufenthaltsstatus"}

/***/ }),
/* 468 */
/***/ (function(module, exports) {

module.exports = {"companylegalform::simple_society":"Ordinary company (Einfache Gesellschaft)","companylegalform::general_partnership":"General partnership (Kollektivgesellschaft)","companylegalform::limited_partnership":"Limited partnership (Kommanditgesellschaft)","companylegalform::jointstock_company":"Joint-stock company (Aktiengesellschaft)","companylegalform::kommanditaktiengesellschaft":"Limited stock company (Kommandit-Aktiengesellschaft)","companylegalform::limited_liability_company":"Limited liability company (GmbH)","companylegalform::cooperative":"Cooperative (Genossenschaft)","companylegalform::society":"Association (Verein)","companylegalform::foundation":"Foundation (Stiftung)","companylegalform::other":"Other","deposittype::none":"None","deposittype::fixed_amount":"Fixed amount","deposittype::percentage":"Percentage","documenttype::annual_statement":"Annual statement","documenttype::area_allocation_plan":"Area plans","documenttype::area_measurement":"Area measurement","documenttype::building_permit":"Building permit","documenttype::easement_register":"Easement register","documenttype::insurance_policy":"Special building insurance notice / insurance policy","documenttype::location_map":"Location map","documenttype::partition_deed":"Partition deed","documenttype::partition_plan":"Partition plan","documenttype::rental_contract":"Rental contract","documenttype::reserves":"Reserves","documenttype::utility_costs":"Utility costs","documenttype::weg_protocols":"WEG protocols","handovertype::land_register":"After entry in the land register excerpt","handovertype::money_transfer":"After transfer of the purchase price to a predefined account","handovertype::key_handover":"After key handover","handovertype::sale_contract":"According to the sales contract","ownershiptype::joint":"Joint ownership","upload_more":"Upload more documents","uploadtype::identity_document":"Identity document","uploadtype::residence_permit":"Residence permit","uploadtype::proof_of_financial_resources":"Proof of financing","ListingsOverview::number":"Property ID","ListingsOverview::title":"Title","ListingsOverview::pending_offers":"Offers","Page1::object_number":"Property ID","Page1::additional_description":"Other descriptions and important information about the property","Page1::known_defects":"Known defects","Page1::no_known_defects":"No defects known","Page1::following_known_defects":"The following defects are known","Page2::deposit":"Deposit","Page2::allowance_for_noncompliance":"Allowance for non-compliance","Page2::total_amount_must_be_documented":"Total amount must be documented!","Page2::from_offer_value":"of the offer price","Page2::from_agent_commission":"of gross agent commission","Page2::can_be_max_max_of_the_gross_agent_commission":"Can be max {max}% of the gross agent commission","Page3::documents":"Property documents","AgentProvisionForm::agent_commission":"Agent commission (brutto)","AgentProvisionForm::agent_commission_description":"% of the offer price","AgentProvisionForm::agent_commission_tooltip":"Must be max. 1.19% of the gross agent commission","RefuseDialog::required_documents":"Required documents","RefuseDialog::optional_documents":"Optional documents","RegistrationPanel::required_documents":"Required documents","RegistrationPanel::offer_viewing":"Seen on","Sale::billing_notice":"The costs of this offer procedure amounting to 0.1% of the highest bid received will be charged to the commissioning broker.","RegistrationPanel::optional_documents":"Optional documents","RegistrationPanel::locale":"Preferred language","BuyerDataForm::acting_organ__function":"Authorized representative - role","SaleCreatePanel::price_tooltip":"Official listing price, which is stored on the RE/MAX website or in onOffice","RoundEdit::bidding_type_tooltip":"With the open procedure, at least the starting price must be offered, all incoming purchase price offers are disclosed anonymously and participating bidders can increase their offer as often as required in defined minimum steps. In the closed process, prospective buyers can only submit an offer, the amount of which can be freely selected and is encrypted in the system until the end of the process and is only disclosed to the broker after the end.","phone_number_placeholder":"+49 150 0000 0000"}

/***/ }),
/* 469 */
/***/ (function(module, exports) {

module.exports = {"cadastraldata::sheet":"Sheet","cadastraldata::map":"Map","cadastraldata::sub":"Sub","cadastraldata::category":"Category","cadastraldata::class":"Class","cadastraldata::rooms":"Rooms","cadastraldata::pension":"Pension","cadastraldata::area":"Area","companylegalform::simple_society":"Ordinary company (Einfache Gesellschaft)","companylegalform::general_partnership":"General partnership (Kollektivgesellschaft)","companylegalform::limited_partnership":"Limited partnership (Kommanditgesellschaft)","companylegalform::jointstock_company":"Joint-stock company (Aktiengesellschaft)","companylegalform::kommanditaktiengesellschaft":"Limited stock company (Kommandit-Aktiengesellschaft)","companylegalform::limited_liability_company":"Limited liability company (GmbH)","companylegalform::cooperative":"Cooperative (Genossenschaft)","companylegalform::society":"Association (Verein)","companylegalform::foundation":"Foundation (Stiftung)","companylegalform::other":"Other","deposittype::none":"None","deposittype::fixed_amount":"Fixed amount","deposittype::percentage":"Percentage","energycertificatestatus::requested":"Requested","energycertificatestatus::issued":"Issued","occupationtype::free":"Free","occupationtype::owner":"By owner and vacated on sale","occupationtype::rented":"Rented","origintype::contract":"Previous sale contract","origintype::donation":"Donation","origintype::hereditary":"Hereditary","origintype::succession":"Succession","ownershiptype::joint":"Joint ownership","sellertype::private":"Private person","sellertype::company":"Company","uploadtype::identity_document":"Identity document","uploadtype::residence_permit":"Residence permit","uploadtype::proof_of_financial_resources":"Proof of financing","usagetype::residential":"Residential","usagetype::commercial":"Commercial","usagetype::office":"Office","owner_name":"Owner name","usage":"Usage","composition":"Composition","act_of_origin":"Act of origin","cadastral_compliance":"Cadastral compliance","regulation_compliance":"Regulation compliance","energy_certificate_status":"Energy certificate status","energy_certificate_issued_on":"Energy certificate issued on","energy_certificate_issuer":"Energy certificate issuer","seller_compliance_with_cadastral_data":"Seller compliance with cadastral data","cadastral_data":"Cadastral data","seller":"Seller","court_name":"Court name","occupation":"Occupation","has_mortgage":"Mortgage to be taken over","management_annual_expenses":"Management annual expenses","extra_expenses":"Extra expenses","mortgage_tooltip":"Please enter here the amount of the mortgage that is currently still outstanding.","mortgage_condition":"Conditions","mortgage_condition_tooltip":"Note here relevant conditions such as interest rate, remaining term, etc.","deposit":"Deposit","from_offer_value":"of the offer price","due_diligence_deadline":"Due diligence deadline","Sale::billing_notice":" ","RegistrationPanel::optional_documents":"Optional documents","RegistrationPanel::locale":"Preferred language","BuyerDataForm::acting_organ__function":"Authorized representative - role","phone_number_placeholder":"+39 30 000 00000","SellerDataForm::seller_type":"Type of seller","termination_clause":"Clausola risolutiva espressa"}

/***/ }),
/* 470 */
/***/ (function(module, exports) {

module.exports = {"DuplicateStep1::agbs":"Condizioni Generali per l'Utilizzo","DuplicateStep1::dataprotection":"l'Accordo sul Trattamento dei Dati Personali","DuplicateStep1::i_agree_to_the_link":"Accetto i {agbs} della piattaforma MAX/DEAL e {dataprotection}.","SaleCreatePanel::agbs":"Condizioni Generali per l'Utilizzo","SaleCreatePanel::dataprotection":"l'Accordo sul Trattamento dei Dati Personali","SaleCreatePanel::i_agree_to_the_link":"Accetto i {agbs} della piattaforma MAX/DEAL e {dataprotection}.","SaleCreatePanel::number":"ID Immobile (ID Maximizer)","Search::agbs":"Condizioni Generali per l'Utilizzo","Search::dataprotection":"l'Accordo sul Trattamento dei Dati Personali","Search::i_agree_to_the_link":"Accetto i {agbs} della piattaforma MAX/DEAL e {dataprotection}.","SellerDataForm::seller_type":"Tipo di venditore","agbs":"Condizioni Generali per l'Utilizzo","agency":"Agenzia immobiliare","agency_name":"Ragione Sociale","agency_street":"Indirizzo","agent":"Agente immobiliare","annual_costs":"Spese gestione ordinaria (annuali)","area":"Dimensione","billing_notice":" ","buyertype::company":"Compagnia","buyertype::entrepreneur":"Imprenditore","buyertype::private":"Privato","cadastral_compliance":"Conformità dell’immobile alle norme edilizie e urbanistiche","cadastral_data":"Dati Catastali","cadastraldata::area":"Dimensione","cadastraldata::category":"Categ. cat","cadastraldata::class":"Classe","cadastraldata::map":"Mappale","cadastraldata::pension":"Rendita","cadastraldata::rooms":"Vani","cadastraldata::sheet":"Foglio","cadastraldata::sub":"Sub","cciaa":"C.C.I.A.A.","city":"Città","compliance":"Conformità","costs":"Spese condominiali","costs_extra_tooltip":"Spese straordinarie deliberate nell’ultimo esercizio","court_name":"Foro competente","dataprotection":"l'Accordo sul Trattamento dei Dati Personali","deposit":"Deposito","deposittype::fixed_amount":"Importo fisso","deposittype::none":"Nessuno","deposittype::percentage":"Percentuale","documenttype::cadastral_plan":"Planimetria catastale","documenttype::cadastral_survey":"Visura catastale","documenttype::energy_certificate":"APE","documenttype::origin_deed":"Atto di provenienza","due_diligence_deadline":"Giorni per la verifica di iscrizioni e/o trascrizioni","energy_certificate_class":"Classe","energy_certificate_issued_on":"Rilasciato il","energy_certificate_issuer":"Da predisporre entro il","energy_certificate_status":"Attestato Prestazione Energetica","energy_certificate_status::issued":"Rilasciato","energy_certificate_status::requested":"Predisporre","extra_costs":"Spese straordinarie","full_address":"Indirizzo n. civico, città, provincia, CAP","object_address":"Indirizzo di proprietà","object_cadastral_compliance::compliant":"Conforme","object_cadastral_compliance::compliant_when_built":"Conforme all’epoca di costruzione","object_cadastral_compliance::noncompliant":"Non conforme","object_cadastral_compliance::pending":"Da adeguare prima del rogito","object_composition":"Composizione","object_owner":"Proprietà intestata a","object_regulation_compliance::compliant":"Conforme","object_regulation_compliance::compliant_when_built":"Conforme all’epoca di costruzione","object_regulation_compliance::noncompliant":"Non conforme","object_regulation_compliance::pending":"Da adeguare prima del rogito","object_usage":"Destinazione d’uso","objectorigin::contract":"Rogito","objectorigin::donation":"Donazione","objectorigin::hereditary":"Successione","objectorigin::succession":"Eredità","occupation":"Occupazione","occupation_name":"Nome","occupation_rent_expiration":"Scadenza del contratto","occupation_type":"Occupazione Corrente","occupationtype::construction":"In construzione","occupationtype::free":"Libero","occupationtype::owner":"Occupato dal proprietario","occupationtype::rented":"Locato","origin":"Atto di provenienza","origin_detail":"Numero di repertorio","page_title":"MAX/DEAL - powered by PropNow","phone_number_placeholder":"+39 30 000 00000","post_code":"CAP","postal_code":"CAP","prejudicial_registrations":"Esistenza di iscrizioni e/o trascrizioni pregiudizievoli","rea":"R.E.A.","regulation_compliance":"Conformità degli impianti alle normative vigenti","rent_amount":"Canone annuo attuale","role":"Funzione","seller_compliance_with_cadastral_data":"Il Venditore dichiara che lo stato di fatto in cui si trova l’immobile corrisponde ai dati catastali su indicati e alle relative planimetrie","seller_conditions":"Condizioni del venditore","sellertype::company":"Società","sellertype::entrepreneur":"Imprenditore","sellertype::private":"Soggetto privato","state":"Provincia","tax_code":"Codice Fiscale","tranches":"Pagamenti successivi","tranches::amount":"Importo","tranches::date":"Entro il","type_of_seller":"Tipo di venditore","uploadtype::identity_document":"Documento di identità dell’acquirente","uploadtype::proof_of_financial_resources":"Documento di finanziamento","usagetype::commercial":"Commerciale","usagetype::industrial":"Industriale/artigianale","usagetype::residential":"Residenziale","usagetype::service":"Direzionale/di servizio","usagetype::tourist":"Turistico/ricettivo","vat_id":"P. IVA","zip":"CAP","zip_code":"CAP"}

/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports = {"BuyerDataForm::address_suffix":"Address suffix","BuyerDataForm::civil_status":"Civil status","BuyerDataForm::county":"County","BuyerDataForm::id_number":"ID number","BuyerDataForm::id_series":"ID series","BuyerDataForm::id_type":"ID type","BuyerDataForm::personal_id_number":"Personal ID number","BuyerDataForm::prenuptial_agreement":"Prenuptial agreement","BuyerDataForm::role":"Role","CompanyDataForm::company_registry_number":"Commercial registry number","CompanyDataForm::tax_identification_code":"Tax identification code","documenttype::area_allocation_plan":"Area layout plan","documenttype::building_permit":"Construction permit","documenttype::cadastral_documentation":"Cadastral documentation","documenttype::cadastral_plan":"Cadastral plan","documenttype::commercial_register_proof":"Proof from the commercial register","documenttype::energy_certificate":"Energy performance certificate","documenttype::id_document":"ID document","documenttype::land_register":"Land registry extract","documenttype::lease_agreement":"Lease agreement","documenttype::location_map":"Town planning certificate","documenttype::national_id":"National ID","documenttype::other":"Other","documenttype::ownership_deed":"Deed of ownership of the property","documenttype::passport":"Passport","documenttype::photo":"Photo","documenttype::proof_of_ownership":"Proof of ownership","documenttype::property_sketch":"Property sketch","documenttype::seller_statements":"Statements assumed by the seller","documenttype::technical_documentation":"Technical documentation","objectconstructiontype::bca":"BCA","objectconstructiontype::brick":"Brick","objectconstructiontype::concrete":"Concrete","objectconstructiontype::frame":"Frame","objectconstructiontype::metal":"Metal","objectconstructiontype::monolith":"Monolith","objectconstructiontype::other":"Other","objectconstructiontype::plates":"Plates","objectconstructiontype::wood":"Wood","OfferDetailsForm::purchase_price_gross":"Purchase price","OfferDetailsForm::purchase_price_gross_info":"The VAT is {vat}% and will be added to the net purchase price","Page1::apartment":"Apartment","Page1::area_built":"Area built","Page1::area_usable":"Area usable","Page1::block_number":"Block number","Page1::cadastral_or_topographic_number":"Cadastral or topographic no.","Page1::common_parts_of_the_property":"Common parts of the property","Page1::compartmentalisation":"Compartmentalisation","Page1::county":"County","Page1::deed":"Land registry number","Page1::floor_level":"Floor level","Page1::further_information":"Further information","Page1::further_property_data":"Further property data","Page1::intended_use_of_property":"Intended use of property","Page1::land_registry_data":"Land registry data","Page1::number_of_rooms":"Number of rooms","Page1::object_height":"Height of construction","Page1::property_locationaddress":"Property location/address","Page1::stair_number":"Stair number","Page1::surface_of_the_land":"Surface of the land","Page1::type_of_construction":"Type of construction","Page1::utilities":"Utilities","Page2::commission":"Commission","Page2::currency_of_purchase":"Currency of purchase","Page2::from_offer_value":"of the offer price","Page2::ownership_share":"Share","Page2::ownership_total":"Total","Page2::payment_deadline":"Payment deadline","Page2::seller":"Seller / Owner","Page3::section__property":"Other documents about the property","Page3::section__seller":"Documents referring to the seller","phone_number_placeholder":"+40 333 00 00 00","ProvisionAck::i_have_taken_note_of_the_following_important_information":"I have read and confirm the following important information","RefuseDialog::optional_documents":"Optional documents","RefuseDialog::required_documents":"Required documents","RegistrationPanel::locale":"Preferred language","RegistrationPanel::optional_documents":"Optional documents","RegistrationPanel::purchase_price_gross":"Purchase price","RegistrationPanel::purchase_price_gross_info":"The VAT is {vat}% and will be added to the net purchase price","RegistrationPanel::required_documents":"Required documents","RoundEdit::offer_validity":"Deadline for signing the contract","RoundInfo::offer_validity":"Deadline for signing the contract","Sale::billing_notice":"The costs of this offer procedure amounting to 0.1% of the highest bid received will be charged to the commissioning broker.","salecurrency::eur":"Euro","salecurrency::ron":"Leu","SellerDataForm::address_suffix":"Address suffix","SellerDataForm::county":"County","SellerDataForm::nationality":"Nationality","SellerDataForm::position":"Position","SellerDataForm::postal_code":"Postal code","SellerDataForm::representative":"Representative","SellerDataForm::tax_identification_code":"Tax identification code","SellerDataForm::type_of_seller":"Type of seller","sellertype::company":"Company","sellertype::private":"Private","uploadtype::identity_document":"Proof of identity","uploadtype::proof_of_financial_resources":"Proof of financial resources","zip_code":"ZIP code"}

/***/ }),
/* 472 */
/***/ (function(module, exports) {

module.exports = {"documenttype::cadastral_documentation":"Cadastrală","documenttype::cadastral_plan":"Plan cadastral","documenttype::commercial_register_proof":"Dovada din ONRC","documenttype::id_document":"Document de identitate","documenttype::lease_agreement":"Contract de închiriere","documenttype::location_map":"Certificat de urbanism","documenttype::national_id":"Carte de identitate","documenttype::other":"Altele","documenttype::ownership_deed":"Actul de proprietate asupra imobilului","documenttype::passport":"Pașaport","documenttype::photo":"Fotografie","documenttype::proof_of_ownership":"Documente referitoare la proprietate","documenttype::property_sketch":"Schiță imobil (releveu)","documenttype::seller_statements":"Declarații asumate de vânzător","documenttype::technical_documentation":"Documentație tehnică","objectconstructiontype::bca":"BCA","objectconstructiontype::brick":"Cărămidă","objectconstructiontype::concrete":"Beton","objectconstructiontype::frame":"Cadru","objectconstructiontype::metal":"Metal","objectconstructiontype::monolith":"Monolith","objectconstructiontype::other":"Altele","objectconstructiontype::plates":"Plăci","objectconstructiontype::wood":"Lemn","salecurrency::eur":"Euro","salecurrency::ron":"Leu","sellertype::private":"Persoană fizică","sellertype::company":"Companie","uploadtype::identity_document":"Dovadă de identitate","uploadtype::proof_of_financial_resources":"Dovada resurselor financiare","Page1::apartment":"Apartament","Page1::area_built":"Suprafață construită","Page1::area_usable":"Suprafață utilă","Page1::block_number":"Bloc","Page1::cadastral_or_topographic_number":"Număr cadastral sau topografic","Page1::common_parts_of_the_property":"Părți comune","Page1::compartmentalisation":"Compartimentarea construcției","Page1::county":"Județ","Page1::floor_level":"Etaj","Page1::further_information":"Informatii suplimentare","Page1::further_property_data":"Alte date despre proprietate","Page1::intended_use_of_property":"Destinație","Page1::land_registry_data":"Date de identificare în CF","Page1::number_of_rooms":"Număr camere","Page1::object_height":"Regim de înălțime al construcției","Page1::property_locationaddress":"Locația / adresa proprietății","Page1::stair_number":"Scară","Page1::surface_of_the_land":"Suprafața terenului aferent","Page1::type_of_construction":"Tipul construcției","Page1::utilities":"Utilități","Page2::commission":"Comisiei","Page2::currency_of_purchase":"Moneda de cumpărare","Page2::from_offer_value":"din prețul ofertei","Page2::ownership_total":"Ownership total","Page2::ownership_share":"Ownership share","Page2::payment_deadline":"Termen de plată a prețului","Page2::seller":"Vânzătorului","Page3::section__seller":"Acte referitoare la vânzător","Page3::section__property":"Alte documente ale imobilului","BuyerDataForm::address_suffix":"Adresa aditionala","BuyerDataForm::civil_status":"Stare civilă","BuyerDataForm::county":"Județ","BuyerDataForm::id_number":"C.I. nu","BuyerDataForm::id_series":"C.I. seria","BuyerDataForm::id_type":"Tipul ID-ului internațional","BuyerDataForm::personal_id_number":"CNP","BuyerDataForm::prenuptial_agreement":"Convenție matrimonială","BuyerDataForm::role":"Calitate","CompanyDataForm::company_registry_number":"Număr de înregistrare la ONRC","CompanyDataForm::tax_identification_code":"Cod identificare fiscală","RefuseDialog::required_documents":"Documente necesare","RefuseDialog::optional_documents":"Documente opționale","RegistrationPanel::required_documents":"Documente necesare","RegistrationPanel::optional_documents":"Documente opționale","RegistrationPanel::locale":"Limba preferată","Sale::billing_notice":"Costul pocesului de licitație, perceput de platforma IMOBID, este de 0,2% net, calculat din prețul ofertei câstigătoare - și se va factura biroului de către RE/MAX Romania.","SellerDataForm::postal_code":"Cod postal","SellerDataForm::address_suffix":"Adresă adițională","SellerDataForm::county":"Județ","SellerDataForm::position":"Calitatea","SellerDataForm::representative":"Reprezentant","SellerDataForm::tax_identification_code":"Cod identificare fiscală","SellerDataForm::type_of_seller":"Tipul vânzătorului","RegistrationPanel::purchase_price_gross_info":"TVA-ul este{vat}% si va fi adăugat la pretul net de cumpărare","OfferDetailsForm::purchase_price_gross_info":"TVA-ul este{vat}% si va fi adăugat la pretul net de cumpărare","phone_number_placeholder":"+40 333 00 00 00"}

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RoundEditStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_moment_timezone__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_moment_duration_format__ = __webpack_require__(1033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_moment_duration_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_moment_duration_format__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor;function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var modeType={new:'new',edit:'edit'};var getEditableDate=function getEditableDate(date,tz){if(!date)return null;if(!tz)return __WEBPACK_IMPORTED_MODULE_1__build_node_modules_moment_timezone___default()(date).toDate();return new Date(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_moment_timezone___default.a.tz(date,tz).format('YYYY-MM-DDTHH:mm:ss'));};var RoundEditStore=(_class=function(){// JSON object coming from server
// editable round object, date properties are converted to Date objects using moment(value).toDate()
function RoundEditStore(round,config,timezone){var isNew=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;_classCallCheck(this,RoundEditStore);this.originalRound=null;_initDefineProp(this,'round',_descriptor,this);this.originalRound=Object.assign({},round);this.config=config;this.timezone=timezone;this.round=Object(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */])(this.originalRound);// convert date fields
this.round.startsAt=getEditableDate(this.round.startsAt,timezone);this.round.endsAt=getEditableDate(this.round.endsAt,timezone);this.round.offerValidityUntil=getEditableDate(this.round.offerValidityUntil,timezone);if(this.mode===modeType.new||isNew){// set default initial values
this.round.type=(!isNew&&this.round.type!=='none'?this.round.type:undefined)||this.config.roundTypes[0];this.round.status='notStarted';this.round.durationType='fixed';this.round.durationInDays=this.config.roundDefaultDurationInDays;this.round.offerValidityInDays=this.config.roundDefaultDurationInDays+this.config.roundDefaultOfferValidityExtensionInDays;var now=__WEBPACK_IMPORTED_MODULE_1__build_node_modules_moment_timezone___default()().hour(12).minute(0);var duration=__WEBPACK_IMPORTED_MODULE_1__build_node_modules_moment_timezone___default()(now).add(this.config.roundDefaultDurationInDays,'d');this.round.startsAt=this.defaultStartsAt(this.round.type);this.round.showInvitedCustomersCount=true;if(this.round.type)this.round.endsAt=duration.toDate();this.round.offerValidityUntil=!this.config.roundDefaultOfferValidityExtensionInDays?null:__WEBPACK_IMPORTED_MODULE_1__build_node_modules_moment_timezone___default()(duration).add(this.config.roundDefaultOfferValidityExtensionInDays,'d').toDate();if(this.allowConditions){this.round.allowConditions=true;}}}_createClass(RoundEditStore,[{key:'defaultStartsAt',get:function get(){var _this=this;return function(type){var now=__WEBPACK_IMPORTED_MODULE_1__build_node_modules_moment_timezone___default()().hour(12).minute(0);return _this.config.roundDefaultPreviewDays&&type!=='simple_offer'?__WEBPACK_IMPORTED_MODULE_1__build_node_modules_moment_timezone___default()(now).add(_this.config.roundDefaultPreviewDays,'d').toDate():null;};}},{key:'allowConditions',get:function get(){return(this.config.allowConditionsInRounds||[]).includes(this.round.type);}},{key:'allowConditionsForRound',get:function get(){var _this2=this;return function(type){return(_this2.config.allowConditionsInRounds||[]).includes(type);};}},{key:'showAllowConditionsToggle',get:function get(){return this.allowConditions&&this.round.type==='incremental_auction';}// returns JSON object ready to be posted to server
},{key:'saveableRound',get:function get(){var round=Object.assign({},this.round);round.roundType=round.type;if(round.durationType==='flexible'){// keeping: durationInDays, offerValidityInDays
delete round.endsAt;delete round.offerValidityUntil;}else{// keeping: endsAt, offerValidityUntil
round.startsAt=round.startsAt?round.startsAt.toStringFormat('YYYY-MM-DDTHH:mm'):'';round.endsAt=round.endsAt?round.endsAt.toStringFormat('YYYY-MM-DDTHH:mm'):'';if(round.offerValidityUntil){round.offerValidityUntil=round.offerValidityUntil.toStringFormat('YYYY-MM-DDTHH:mm');}delete round.durationInDays;delete round.offerValidityInDays;}if(round.type==='simple_offer'){delete round.durationInDays;delete round.endsAt;}if(round.status==='opened'){var original=getEditableDate(this.originalRound.endsAt,this.timezone);round.sendNotification=this.originalRound.endsAt!==null&&!__WEBPACK_IMPORTED_MODULE_1__build_node_modules_moment_timezone___default()(original).isSame(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_moment_timezone___default()(round.endsAt));}return round;}},{key:'isValid',get:function get(){return!!this.round.type&&this.round.type!=='none'&&this.areRoundDatesValid&&this.isStartingPriceValid&&this.isStartPriceValid&&this.isMinPriceValid;}},{key:'areRoundDatesValid',get:function get(){if(this.round.durationType==='flexible')return parseInt(this.round.offerValidityInDays,0)>=0// parseInt(this.round.durationInDays, 0)
;if(this.round.startsAt&&this.round.startsAt>=this.round.endsAt)return false;if(this.round.offerValidityUntil&&this.round.offerValidityUntil<=this.round.endsAt)return false;return true;}// legacy startPrice validation (should be called isEstimateValid)
},{key:'isStartingPriceValid',get:function get(){var startPrice=Number(this.round.startPrice);var estimate=Number(this.round.estimate);return this.round.type!=='sealed_bidding'||Number.isNaN(startPrice)||startPrice===0||Number.isNaN(estimate)||estimate===0||estimate>=startPrice;}},{key:'isStartPriceValid',get:function get(){var startPrice=Number(this.round.startPrice);var isAuction=this.round.type==='open_bidding'||this.round.type==='incremental_auction';return isAuction?!Number.isNaN(startPrice)&&startPrice>0:true;}},{key:'startPriceError',get:function get(){var startPrice=Number(this.round.startPrice);var isAuction=this.round.type==='open_bidding'||this.round.type==='incremental_auction';if(isAuction&&(Number.isNaN(startPrice)||startPrice<=0)){return'invalid starting price';}return this.isStartingPriceValid?'':'estimate lower than startprice';}},{key:'isMinPriceValid',get:function get(){return!this.minPriceError;}},{key:'minPriceError',get:function get(){var startPrice=Number(this.round.startPrice);var minPrice=Number(this.round.minPrice);if(this.round.type!=='incremental_auction')return undefined;if(!this.round.enableFlexibleBidding)return undefined;if(!this.round.biddingBelowStartingPrice)return undefined;if(Number.isNaN(startPrice))return undefined;if(minPrice>=startPrice)return'min price lower than start';return undefined;}},{key:'mode',get:function get(){return this.round.status&&(this.round.status==='notStarted'||this.round.status==='closed')?'new':'edit';}},{key:'canChangeType',get:function get(){var result=!!this.round.number&&(this.round.number<=1||this.config.canChangeRoundType)&&!this.isOpen;return result;}},{key:'isStarted',get:function get(){return!!this.round.status&&this.round.status==='started';}},{key:'isOpen',get:function get(){return!!this.round.status&&this.round.status==='opened';}},{key:'isClosed',get:function get(){return!!this.round.status&&this.round.status==='closed';}},{key:'type',get:function get(){return!!this.round.type?this.round.type:undefined;}},{key:'isOpenBidding',get:function get(){return this.type==='open_bidding';}},{key:'isSimpleOffer',get:function get(){return this.type==='simple_offer';}}]);return RoundEditStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'round',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return{};}}),_applyDecoratedDescriptor(_class.prototype,'defaultStartsAt',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'defaultStartsAt'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'allowConditions',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'allowConditions'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'allowConditionsForRound',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'allowConditionsForRound'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'showAllowConditionsToggle',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'showAllowConditionsToggle'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'saveableRound',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'saveableRound'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isValid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isValid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'areRoundDatesValid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'areRoundDatesValid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isStartingPriceValid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isStartingPriceValid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isStartPriceValid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isStartPriceValid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'startPriceError',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'startPriceError'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isMinPriceValid',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isMinPriceValid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'minPriceError',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'minPriceError'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'mode',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'mode'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'canChangeType',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'canChangeType'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isStarted',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isStarted'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isOpen',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isOpen'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isClosed',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isClosed'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'type',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'type'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isOpenBidding',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isOpenBidding'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isSimpleOffer',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isSimpleOffer'),_class.prototype)),_class);

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(281);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(282);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    };

    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(859);
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(479);
exports.Duplex = __webpack_require__(138);
exports.Transform = __webpack_require__(863);
exports.PassThrough = __webpack_require__(2179);


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



/*<replacement>*/

var pna = __webpack_require__(284);
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = Object.create(__webpack_require__(212));
util.inherits = __webpack_require__(158);
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(2178)
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(860);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(285).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = __webpack_require__(861);

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__(138);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__(138);

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }
  if (state.corkedRequestsFree) {
    state.corkedRequestsFree.next = corkReq;
  } else {
    state.corkedRequestsFree = corkReq;
  }
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(147), __webpack_require__(2176).setImmediate, __webpack_require__(33)))

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScalingCellSizeAndPositionManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CellSizeAndPositionManager__ = __webpack_require__(2191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__maxElementSize_js__ = __webpack_require__(2192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types__ = __webpack_require__(15);







/**
 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
 */
var ScalingCellSizeAndPositionManager =
/*#__PURE__*/
function () {
  function ScalingCellSizeAndPositionManager(_ref) {
    var _ref$maxScrollSize = _ref.maxScrollSize,
        maxScrollSize = _ref$maxScrollSize === void 0 ? Object(__WEBPACK_IMPORTED_MODULE_5__maxElementSize_js__["a" /* getMaxElementSize */])() : _ref$maxScrollSize,
        params = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default()(_ref, ["maxScrollSize"]);

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, ScalingCellSizeAndPositionManager);

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(this, "_cellSizeAndPositionManager", void 0);

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(this, "_maxScrollSize", void 0);

    // Favor composition over inheritance to simplify IE10 support
    this._cellSizeAndPositionManager = new __WEBPACK_IMPORTED_MODULE_4__CellSizeAndPositionManager__["a" /* default */](params);
    this._maxScrollSize = maxScrollSize;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(ScalingCellSizeAndPositionManager, [{
    key: "areOffsetsAdjusted",
    value: function areOffsetsAdjusted() {
      return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
    }
  }, {
    key: "configure",
    value: function configure(params) {
      this._cellSizeAndPositionManager.configure(params);
    }
  }, {
    key: "getCellCount",
    value: function getCellCount() {
      return this._cellSizeAndPositionManager.getCellCount();
    }
  }, {
    key: "getEstimatedCellSize",
    value: function getEstimatedCellSize() {
      return this._cellSizeAndPositionManager.getEstimatedCellSize();
    }
  }, {
    key: "getLastMeasuredIndex",
    value: function getLastMeasuredIndex() {
      return this._cellSizeAndPositionManager.getLastMeasuredIndex();
    }
    /**
     * Number of pixels a cell at the given position (offset) should be shifted in order to fit within the scaled container.
     * The offset passed to this function is scaled (safe) as well.
     */

  }, {
    key: "getOffsetAdjustment",
    value: function getOffsetAdjustment(_ref2) {
      var containerSize = _ref2.containerSize,
          offset = _ref2.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();

      var safeTotalSize = this.getTotalSize();

      var offsetPercentage = this._getOffsetPercentage({
        containerSize: containerSize,
        offset: offset,
        totalSize: safeTotalSize
      });

      return Math.round(offsetPercentage * (safeTotalSize - totalSize));
    }
  }, {
    key: "getSizeAndPositionOfCell",
    value: function getSizeAndPositionOfCell(index) {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
    }
  }, {
    key: "getSizeAndPositionOfLastMeasuredCell",
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
    }
    /** See CellSizeAndPositionManager#getTotalSize */

  }, {
    key: "getTotalSize",
    value: function getTotalSize() {
      return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
    }
    /** See CellSizeAndPositionManager#getUpdatedOffsetForIndex */

  }, {
    key: "getUpdatedOffsetForIndex",
    value: function getUpdatedOffsetForIndex(_ref3) {
      var _ref3$align = _ref3.align,
          align = _ref3$align === void 0 ? 'auto' : _ref3$align,
          containerSize = _ref3.containerSize,
          currentOffset = _ref3.currentOffset,
          targetIndex = _ref3.targetIndex;
      currentOffset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: currentOffset
      });

      var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
        align: align,
        containerSize: containerSize,
        currentOffset: currentOffset,
        targetIndex: targetIndex
      });

      return this._offsetToSafeOffset({
        containerSize: containerSize,
        offset: offset
      });
    }
    /** See CellSizeAndPositionManager#getVisibleCellRange */

  }, {
    key: "getVisibleCellRange",
    value: function getVisibleCellRange(_ref4) {
      var containerSize = _ref4.containerSize,
          offset = _ref4.offset;
      offset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: offset
      });
      return this._cellSizeAndPositionManager.getVisibleCellRange({
        containerSize: containerSize,
        offset: offset
      });
    }
  }, {
    key: "resetCell",
    value: function resetCell(index) {
      this._cellSizeAndPositionManager.resetCell(index);
    }
  }, {
    key: "_getOffsetPercentage",
    value: function _getOffsetPercentage(_ref5) {
      var containerSize = _ref5.containerSize,
          offset = _ref5.offset,
          totalSize = _ref5.totalSize;
      return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
    }
  }, {
    key: "_offsetToSafeOffset",
    value: function _offsetToSafeOffset(_ref6) {
      var containerSize = _ref6.containerSize,
          offset = _ref6.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();

      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: totalSize
        });

        return Math.round(offsetPercentage * (safeTotalSize - containerSize));
      }
    }
  }, {
    key: "_safeOffsetToOffset",
    value: function _safeOffsetToOffset(_ref7) {
      var containerSize = _ref7.containerSize,
          offset = _ref7.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();

      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: safeTotalSize
        });

        return Math.round(offsetPercentage * (totalSize - containerSize));
      }
    }
  }]);

  return ScalingCellSizeAndPositionManager;
}();






/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createCallbackMemoizer;
/**
 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
 */
function createCallbackMemoizer() {
  var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var cachedIndices = {};
  return function (_ref) {
    var callback = _ref.callback,
        indices = _ref.indices;
    var keys = Object.keys(indices);
    var allInitialized = !requireAllKeys || keys.every(function (key) {
      var value = indices[key];
      return Array.isArray(value) ? value.length > 0 : value >= 0;
    });
    var indexChanged = keys.length !== Object.keys(cachedIndices).length || keys.some(function (key) {
      var cachedValue = cachedIndices[key];
      var value = indices[key];
      return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
    });
    cachedIndices = indices;

    if (allInitialized && indexChanged) {
      callback(indices);
    }
  };
}

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_SCROLLING_RESET_TIME_INTERVAL */
/* unused harmony export bpfrpt_proptype_CellMeasurerCache */
/* unused harmony export bpfrpt_proptype_Positioner */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_clsx__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_lifecycles_compat__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PositionCache__ = __webpack_require__(2218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_requestAnimationTimeout__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);








var _class, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var emptyObject = {};
/**
 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */

var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;
/**
 * This component efficiently displays arbitrarily positioned cells using windowing techniques.
 * Cell position is determined by an injected `cellPositioner` property.
 * Windowing is vertical; this component does not support horizontal scrolling.
 *
 * Rendering occurs in two phases:
 * 1) First pass uses estimated cell sizes (provided by the cache) to determine how many cells to measure in a batch.
 *    Batch size is chosen using a fast, naive layout algorithm that stacks images in order until the viewport has been filled.
 *    After measurement is complete (componentDidMount or componentDidUpdate) this component evaluates positioned cells
 *    in order to determine if another measurement pass is required (eg if actual cell sizes were less than estimated sizes).
 *    All measurements are permanently cached (keyed by `keyMapper`) for performance purposes.
 * 2) Second pass uses the external `cellPositioner` to layout cells.
 *    At this time the positioner has access to cached size measurements for all cells.
 *    The positions it returns are cached by Masonry for fast access later.
 *    Phase one is repeated if the user scrolls beyond the current layout's bounds.
 *    If the layout is invalidated due to eg a resize, cached positions can be cleared using `recomputeCellPositions()`.
 *
 * Animation constraints:
 *   Simple animations are supported (eg translate/slide into place on initial reveal).
 *   More complex animations are not (eg flying from one position to another on resize).
 *
 * Layout constraints:
 *   This component supports multi-column layout.
 *   The height of each item may vary.
 *   The width of each item must not exceed the width of the column it is "in".
 *   The left position of all items within a column must align.
 *   (Items may not span multiple columns.)
 */

var Masonry = (_temp = _class =
/*#__PURE__*/
function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(Masonry, _React$PureComponent);

  function Masonry() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Masonry);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Masonry)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      isScrolling: false,
      scrollTop: 0
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_debounceResetIsScrollingId", void 0);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_invalidateOnUpdateStartIndex", null);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_invalidateOnUpdateStopIndex", null);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_positionCache", new __WEBPACK_IMPORTED_MODULE_10__PositionCache__["a" /* default */]());

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_startIndex", null);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_startIndexMemoized", null);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_stopIndex", null);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_stopIndexMemoized", null);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_debounceResetIsScrollingCallback", function () {
      _this.setState({
        isScrolling: false
      });
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_setScrollingContainerRef", function (ref) {
      _this._scrollingContainer = ref;
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_onScroll", function (event) {
      var height = _this.props.height;
      var eventScrollTop = event.currentTarget.scrollTop; // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.

      var scrollTop = Math.min(Math.max(0, _this._getEstimatedTotalHeight() - height), eventScrollTop); // On iOS, we can arrive at negative offsets by swiping past the start or end.
      // Avoid re-rendering in this case as it can cause problems; see #532 for more.

      if (eventScrollTop !== scrollTop) {
        return;
      } // Prevent pointer events from interrupting a smooth scroll


      _this._debounceResetIsScrolling(); // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.


      if (_this.state.scrollTop !== scrollTop) {
        _this.setState({
          isScrolling: true,
          scrollTop: scrollTop
        });
      }
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Masonry, [{
    key: "clearCellPositions",
    value: function clearCellPositions() {
      this._positionCache = new __WEBPACK_IMPORTED_MODULE_10__PositionCache__["a" /* default */]();
      this.forceUpdate();
    } // HACK This method signature was intended for Grid

  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender(_ref) {
      var index = _ref.rowIndex;

      if (this._invalidateOnUpdateStartIndex === null) {
        this._invalidateOnUpdateStartIndex = index;
        this._invalidateOnUpdateStopIndex = index;
      } else {
        this._invalidateOnUpdateStartIndex = Math.min(this._invalidateOnUpdateStartIndex, index);
        this._invalidateOnUpdateStopIndex = Math.max(this._invalidateOnUpdateStopIndex, index);
      }
    }
  }, {
    key: "recomputeCellPositions",
    value: function recomputeCellPositions() {
      var stopIndex = this._positionCache.count - 1;
      this._positionCache = new __WEBPACK_IMPORTED_MODULE_10__PositionCache__["a" /* default */]();

      this._populatePositionCache(0, stopIndex);

      this.forceUpdate();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this._checkInvalidateOnUpdate();

      this._invokeOnScrollCallback();

      this._invokeOnCellsRenderedCallback();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      this._checkInvalidateOnUpdate();

      this._invokeOnScrollCallback();

      this._invokeOnCellsRenderedCallback();

      if (this.props.scrollTop !== prevProps.scrollTop) {
        this._debounceResetIsScrolling();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._debounceResetIsScrollingId) {
        Object(__WEBPACK_IMPORTED_MODULE_11__utils_requestAnimationTimeout__["a" /* cancelAnimationTimeout */])(this._debounceResetIsScrollingId);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          autoHeight = _this$props.autoHeight,
          cellCount = _this$props.cellCount,
          cellMeasurerCache = _this$props.cellMeasurerCache,
          cellRenderer = _this$props.cellRenderer,
          className = _this$props.className,
          height = _this$props.height,
          id = _this$props.id,
          keyMapper = _this$props.keyMapper,
          overscanByPixels = _this$props.overscanByPixels,
          role = _this$props.role,
          style = _this$props.style,
          tabIndex = _this$props.tabIndex,
          width = _this$props.width,
          rowDirection = _this$props.rowDirection;
      var _this$state = this.state,
          isScrolling = _this$state.isScrolling,
          scrollTop = _this$state.scrollTop;
      var children = [];

      var estimateTotalHeight = this._getEstimatedTotalHeight();

      var shortestColumnSize = this._positionCache.shortestColumnSize;
      var measuredCellCount = this._positionCache.count;
      var startIndex = 0;
      var stopIndex;

      this._positionCache.range(Math.max(0, scrollTop - overscanByPixels), height + overscanByPixels * 2, function (index, left, top) {
        var _style;

        if (typeof stopIndex === 'undefined') {
          startIndex = index;
          stopIndex = index;
        } else {
          startIndex = Math.min(startIndex, index);
          stopIndex = Math.max(stopIndex, index);
        }

        children.push(cellRenderer({
          index: index,
          isScrolling: isScrolling,
          key: keyMapper(index),
          parent: _this2,
          style: (_style = {
            height: cellMeasurerCache.getHeight(index)
          }, __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(_style, rowDirection === 'ltr' ? 'left' : 'right', left), __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(_style, "position", 'absolute'), __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(_style, "top", top), __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(_style, "width", cellMeasurerCache.getWidth(index)), _style)
        }));
      }); // We need to measure additional cells for this layout


      if (shortestColumnSize < scrollTop + height + overscanByPixels && measuredCellCount < cellCount) {
        var batchSize = Math.min(cellCount - measuredCellCount, Math.ceil((scrollTop + height + overscanByPixels - shortestColumnSize) / cellMeasurerCache.defaultHeight * width / cellMeasurerCache.defaultWidth));

        for (var _index = measuredCellCount; _index < measuredCellCount + batchSize; _index++) {
          stopIndex = _index;
          children.push(cellRenderer({
            index: _index,
            isScrolling: isScrolling,
            key: keyMapper(_index),
            parent: this,
            style: {
              width: cellMeasurerCache.getWidth(_index)
            }
          }));
        }
      }

      this._startIndex = startIndex;
      this._stopIndex = stopIndex;
      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
        ref: this._setScrollingContainerRef,
        "aria-label": this.props['aria-label'],
        className: Object(__WEBPACK_IMPORTED_MODULE_7_clsx__["a" /* default */])('ReactVirtualized__Masonry', className),
        id: id,
        onScroll: this._onScroll,
        role: role,
        style: _objectSpread({
          boxSizing: 'border-box',
          direction: 'ltr',
          height: autoHeight ? 'auto' : height,
          overflowX: 'hidden',
          overflowY: estimateTotalHeight < height ? 'hidden' : 'auto',
          position: 'relative',
          width: width,
          WebkitOverflowScrolling: 'touch',
          willChange: 'transform'
        }, style),
        tabIndex: tabIndex
      }, __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
        className: "ReactVirtualized__Masonry__innerScrollContainer",
        style: {
          width: '100%',
          height: estimateTotalHeight,
          maxWidth: '100%',
          maxHeight: estimateTotalHeight,
          overflow: 'hidden',
          pointerEvents: isScrolling ? 'none' : '',
          position: 'relative'
        }
      }, children));
    }
  }, {
    key: "_checkInvalidateOnUpdate",
    value: function _checkInvalidateOnUpdate() {
      if (typeof this._invalidateOnUpdateStartIndex === 'number') {
        var startIndex = this._invalidateOnUpdateStartIndex;
        var stopIndex = this._invalidateOnUpdateStopIndex;
        this._invalidateOnUpdateStartIndex = null;
        this._invalidateOnUpdateStopIndex = null; // Query external layout logic for position of newly-measured cells

        this._populatePositionCache(startIndex, stopIndex);

        this.forceUpdate();
      }
    }
  }, {
    key: "_debounceResetIsScrolling",
    value: function _debounceResetIsScrolling() {
      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;

      if (this._debounceResetIsScrollingId) {
        Object(__WEBPACK_IMPORTED_MODULE_11__utils_requestAnimationTimeout__["a" /* cancelAnimationTimeout */])(this._debounceResetIsScrollingId);
      }

      this._debounceResetIsScrollingId = Object(__WEBPACK_IMPORTED_MODULE_11__utils_requestAnimationTimeout__["b" /* requestAnimationTimeout */])(this._debounceResetIsScrollingCallback, scrollingResetTimeInterval);
    }
  }, {
    key: "_getEstimatedTotalHeight",
    value: function _getEstimatedTotalHeight() {
      var _this$props2 = this.props,
          cellCount = _this$props2.cellCount,
          cellMeasurerCache = _this$props2.cellMeasurerCache,
          width = _this$props2.width;
      var estimatedColumnCount = Math.max(1, Math.floor(width / cellMeasurerCache.defaultWidth));
      return this._positionCache.estimateTotalHeight(cellCount, estimatedColumnCount, cellMeasurerCache.defaultHeight);
    }
  }, {
    key: "_invokeOnScrollCallback",
    value: function _invokeOnScrollCallback() {
      var _this$props3 = this.props,
          height = _this$props3.height,
          onScroll = _this$props3.onScroll;
      var scrollTop = this.state.scrollTop;

      if (this._onScrollMemoized !== scrollTop) {
        onScroll({
          clientHeight: height,
          scrollHeight: this._getEstimatedTotalHeight(),
          scrollTop: scrollTop
        });
        this._onScrollMemoized = scrollTop;
      }
    }
  }, {
    key: "_invokeOnCellsRenderedCallback",
    value: function _invokeOnCellsRenderedCallback() {
      if (this._startIndexMemoized !== this._startIndex || this._stopIndexMemoized !== this._stopIndex) {
        var onCellsRendered = this.props.onCellsRendered;
        onCellsRendered({
          startIndex: this._startIndex,
          stopIndex: this._stopIndex
        });
        this._startIndexMemoized = this._startIndex;
        this._stopIndexMemoized = this._stopIndex;
      }
    }
  }, {
    key: "_populatePositionCache",
    value: function _populatePositionCache(startIndex, stopIndex) {
      var _this$props4 = this.props,
          cellMeasurerCache = _this$props4.cellMeasurerCache,
          cellPositioner = _this$props4.cellPositioner;

      for (var _index2 = startIndex; _index2 <= stopIndex; _index2++) {
        var _cellPositioner = cellPositioner(_index2),
            left = _cellPositioner.left,
            top = _cellPositioner.top;

        this._positionCache.setPosition(_index2, left, top, cellMeasurerCache.getHeight(_index2));
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.scrollTop !== undefined && prevState.scrollTop !== nextProps.scrollTop) {
        return {
          isScrolling: true,
          scrollTop: nextProps.scrollTop
        };
      }

      return null;
    }
  }]);

  return Masonry;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]), __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(_class, "propTypes",  true ? null : {
  "autoHeight": PropTypes.bool.isRequired,
  "cellCount": PropTypes.number.isRequired,
  "cellMeasurerCache": function cellMeasurerCache() {
    return (typeof CellMeasurerCache === "function" ? PropTypes.instanceOf(CellMeasurerCache).isRequired : PropTypes.any.isRequired).apply(this, arguments);
  },
  "cellPositioner": function cellPositioner() {
    return (typeof Positioner === "function" ? PropTypes.instanceOf(Positioner).isRequired : PropTypes.any.isRequired).apply(this, arguments);
  },
  "cellRenderer": function cellRenderer() {
    return (typeof CellRenderer === "function" ? PropTypes.instanceOf(CellRenderer).isRequired : PropTypes.any.isRequired).apply(this, arguments);
  },
  "className": PropTypes.string,
  "height": PropTypes.number.isRequired,
  "id": PropTypes.string,
  "keyMapper": function keyMapper() {
    return (typeof KeyMapper === "function" ? PropTypes.instanceOf(KeyMapper).isRequired : PropTypes.any.isRequired).apply(this, arguments);
  },
  "onCellsRendered": function onCellsRendered() {
    return (typeof OnCellsRenderedCallback === "function" ? PropTypes.instanceOf(OnCellsRenderedCallback) : PropTypes.any).apply(this, arguments);
  },
  "onScroll": function onScroll() {
    return (typeof OnScrollCallback === "function" ? PropTypes.instanceOf(OnScrollCallback) : PropTypes.any).apply(this, arguments);
  },
  "overscanByPixels": PropTypes.number.isRequired,
  "role": PropTypes.string.isRequired,
  "scrollingResetTimeInterval": PropTypes.number.isRequired,
  "style": function style(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `".concat(propName, "` has type 'any' or 'mixed', but was not provided to `").concat(componentName, "`. Pass undefined or any other value."));
    }
  },
  "tabIndex": PropTypes.number.isRequired,
  "width": PropTypes.number.isRequired,
  "rowDirection": PropTypes.string.isRequired,
  "scrollTop": PropTypes.number
}), _temp);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(Masonry, "defaultProps", {
  autoHeight: false,
  keyMapper: identity,
  onCellsRendered: noop,
  onScroll: noop,
  overscanByPixels: 20,
  role: 'grid',
  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
  style: emptyObject,
  tabIndex: 0,
  rowDirection: 'ltr'
});

function identity(value) {
  return value;
}

function noop() {}

var bpfrpt_proptype_CellMeasurerCache =  true ? null : {
  "defaultHeight": PropTypes.number.isRequired,
  "defaultWidth": PropTypes.number.isRequired,
  "getHeight": PropTypes.func.isRequired,
  "getWidth": PropTypes.func.isRequired
};
Object(__WEBPACK_IMPORTED_MODULE_9_react_lifecycles_compat__["a" /* polyfill */])(Masonry);
/* harmony default export */ __webpack_exports__["a"] = (Masonry);
var bpfrpt_proptype_Positioner =  true ? null : PropTypes.func;





/***/ }),
/* 483 */
/***/ (function(module, exports) {

module.exports = compose

function compose (countries) {
  if (typeof countries !== 'object') {
    throw new Error(
      'You have to pass a countries object. You can require it like:\n' +
      '`countries = require("localized-countries")(require("localized-countries/data/en"))`'
    )
  }

  var list = Object.keys(countries).map(function (code) {
    return {code: code, label: countries[code]}
  })

  return {
    object: function getAllCountries () { return countries },
    array: function getAllCountries () { return list },
    get: function getCountryByCode (code) { return countries[code] }
  }
}


/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MoneyField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_src_app_helpers_numberFormatting__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_Icon__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Tooltip__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_node_modules_react_text_mask__ = __webpack_require__(1808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_node_modules_react_text_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_react_text_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__build_node_modules_text_mask_addons_dist_createNumberMask__ = __webpack_require__(1809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__build_node_modules_text_mask_addons_dist_createNumberMask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__build_node_modules_text_mask_addons_dist_createNumberMask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style_css__ = __webpack_require__(1810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__style_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp2;function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MoneyField=(_temp2=_class=function(_Component){_inherits(MoneyField,_Component);function MoneyField(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MoneyField);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MoneyField.__proto__||Object.getPrototypeOf(MoneyField)).call.apply(_ref,[this].concat(args))),_this),_this.hostId=Object(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Utilities__["N" /* getId */])('tooltipHost'),_this.handleChanged=function(e){var _this$props=_this.props,onChanged=_this$props.onChanged,currency=_this$props.currency,locale=_this$props.locale,allowDecimal=_this$props.allowDecimal;if(onChanged){onChanged(allowDecimal?e.target.value:Object(__WEBPACK_IMPORTED_MODULE_0__build_src_app_helpers_numberFormatting__["b" /* parseFormattedMoneyValue */])(e.target.value,currency,locale));}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MoneyField,[{key:'componentWillMount',value:function componentWillMount(){var _props=this.props,currency=_props.currency,locale=_props.locale,allowDecimal=_props.allowDecimal;this.options=Object(__WEBPACK_IMPORTED_MODULE_0__build_src_app_helpers_numberFormatting__["a" /* getMoneyFormattingOptions */])(currency,locale);var _mask=__WEBPACK_IMPORTED_MODULE_7__build_node_modules_text_mask_addons_dist_createNumberMask___default()({prefix:'',suffix:this.options.fixedDecimalZeroes?this.options.decimal+__WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash___default.a.repeat('0',this.options.fixedDecimalZeroes):'',includeThousandsSeparator:!!this.options.group,thousandsSeparatorSymbol:this.options.group,decimalSymbol:this.options.decimal,integerLimit:8,allowDecimal:allowDecimal,decimalLimit:2// allowNegative: false,
// allowLeadingZeroes: false,
});this.mask=allowDecimal?_mask:function(rawValue){var numericValue=Object(__WEBPACK_IMPORTED_MODULE_0__build_src_app_helpers_numberFormatting__["b" /* parseFormattedMoneyValue */])(rawValue,currency,locale);return _mask(numericValue.toString());};this.id=__WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash___default.a.uniqueId('MoneyField');}},{key:'render',value:function render(){var _props2=this.props,value=_props2.value,label=_props2.label,required=_props2.required,tooltip=_props2.tooltip,description=_props2.description;var _props3=this.props,errorMessage=_props3.errorMessage,allowDecimal=_props3.allowDecimal,fieldProps=_objectWithoutProperties(_props3,['errorMessage','allowDecimal']);var propsForwarded=Object.assign({},fieldProps);delete propsForwarded.onChanged;// <MaskedInput> does not support 'onChanged' attribute
return __WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement('div',{className:'ms-MoneyField ms-TextField '+(!!required?'is-required':'')},__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement('div',{className:'ms-TextField-wrapper'},label&&__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement('label',{className:'ms-Label',required:required||false,htmlFor:this.id,style:{paddingTop:'5px',paddingBottom:'5px',display:'inline-block'}},label,tooltip&&__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react__["Fragment"],null,' ',__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Tooltip__["b" /* TooltipHost */],{content:tooltip,id:this.hostId,calloutProps:{gapSpace:0}},__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_Icon__["Icon"],{iconName:'Info'})))),__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement('div',{className:'ms-TextField-fieldGroup'},this.options.prefix&&__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement('div',{className:'ms-TextField-prefix'},__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement('span',{style:{paddingBottom:'1px'}},this.options.prefix)),__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_react_text_mask___default.a,Object.assign({},propsForwarded,{id:this.id,mask:this.mask,value:value,onChange:this.handleChanged,className:'ms-TextField-field'+(this.props.className?' '+this.props.className:''),inputMode:'numeric'})),this.options.suffix&&__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement('div',{className:'ms-TextField-suffix'},__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement('span',{style:{paddingBottom:'1px'}},this.options.suffix))),description&&__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement('div',{style:{fontSize:'11px',paddingTop:'8px',color:'#666'}},__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement('span',{className:'ms-TextField-description'},description)),errorMessage&&errorMessage!==''&&__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement('p',{className:'errorMessage'},__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement('span',null,errorMessage)))));}}]);return MoneyField;}(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react__["Component"]),_class.displayName='MoneyField',_temp2);

/***/ }),
/* 485 */
/***/ (function(module, exports) {

module.exports = {"AF":"Afghanistan","EG":"Ägypten","AX":"Åland-Inseln","AL":"Albanien","DZ":"Algerien","UM":"Amerikanisch-Ozeanien","AS":"Amerikanisch-Samoa","VI":"Amerikanische Jungferninseln","AD":"Andorra","AO":"Angola","AI":"Anguilla","AQ":"Antarktis","AG":"Antigua und Barbuda","GQ":"Äquatorialguinea","AR":"Argentinien","AM":"Armenien","AW":"Aruba","AC":"Ascension","AZ":"Aserbaidschan","ET":"Äthiopien","AU":"Australien","BS":"Bahamas","BH":"Bahrain","BD":"Bangladesch","BB":"Barbados","BY":"Belarus","BE":"Belgien","BZ":"Belize","BJ":"Benin","BM":"Bermuda","BT":"Bhutan","BO":"Bolivien","BA":"Bosnien und Herzegowina","BW":"Botsuana","BR":"Brasilien","VG":"Britische Jungferninseln","IO":"Britisches Territorium im Indischen Ozean","BN":"Brunei Darussalam","BG":"Bulgarien","BF":"Burkina Faso","BI":"Burundi","EA":"Ceuta und Melilla","CL":"Chile","CN":"China","CK":"Cookinseln","CR":"Costa Rica","CI":"Côte d’Ivoire","CW":"Curaçao","DK":"Dänemark","KP":"Demokratische Volksrepublik Korea","DE":"Deutschland","DG":"Diego Garcia","DM":"Dominica","DO":"Dominikanische Republik","DJ":"Dschibuti","EC":"Ecuador","SV":"El Salvador","ER":"Eritrea","EE":"Estland","FK":"Falklandinseln","FO":"Färöer","FJ":"Fidschi","FI":"Finnland","FR":"Frankreich","GF":"Französisch-Guayana","PF":"Französisch-Polynesien","TF":"Französische Süd- und Antarktisgebiete","GA":"Gabun","GM":"Gambia","GE":"Georgien","GH":"Ghana","GI":"Gibraltar","GD":"Grenada","GR":"Griechenland","GL":"Grönland","GP":"Guadeloupe","GU":"Guam","GT":"Guatemala","GG":"Guernsey","GN":"Guinea","GW":"Guinea-Bissau","GY":"Guyana","HT":"Haiti","HN":"Honduras","IN":"Indien","ID":"Indonesien","IQ":"Irak","IR":"Iran","IE":"Irland","IS":"Island","IM":"Isle of Man","IL":"Israel","IT":"Italien","JM":"Jamaika","JP":"Japan","YE":"Jemen","JE":"Jersey","JO":"Jordanien","KY":"Kaimaninseln","KH":"Kambodscha","CM":"Kamerun","CA":"Kanada","IC":"Kanarische Inseln","CV":"Kap Verde","BQ":"Karibische Niederlande","KZ":"Kasachstan","QA":"Katar","KE":"Kenia","KG":"Kirgisistan","KI":"Kiribati","CC":"Kokosinseln","CO":"Kolumbien","KM":"Komoren","CG":"Kongo-Brazzaville","CD":"Kongo-Kinshasa","XK":"Kosovo","HR":"Kroatien","CU":"Kuba","KW":"Kuwait","LA":"Laos","LS":"Lesotho","LV":"Lettland","LB":"Libanon","LR":"Liberia","LY":"Libyen","LI":"Liechtenstein","LT":"Litauen","LU":"Luxemburg","MG":"Madagaskar","MW":"Malawi","MY":"Malaysia","MV":"Malediven","ML":"Mali","MT":"Malta","MA":"Marokko","MH":"Marshallinseln","MQ":"Martinique","MR":"Mauretanien","MU":"Mauritius","YT":"Mayotte","MK":"Mazedonien","MX":"Mexiko","FM":"Mikronesien","MC":"Monaco","MN":"Mongolei","ME":"Montenegro","MS":"Montserrat","MZ":"Mosambik","MM":"Myanmar","NA":"Namibia","NR":"Nauru","NP":"Nepal","NC":"Neukaledonien","NZ":"Neuseeland","NI":"Nicaragua","NL":"Niederlande","NE":"Niger","NG":"Nigeria","NU":"Niue","MP":"Nördliche Marianen","NF":"Norfolkinsel","NO":"Norwegen","OM":"Oman","AT":"Österreich","PK":"Pakistan","PS":"Palästinensische Autonomiegebiete","PW":"Palau","PA":"Panama","PG":"Papua-Neuguinea","PY":"Paraguay","PE":"Peru","PH":"Philippinen","PN":"Pitcairninseln","PL":"Polen","PT":"Portugal","PR":"Puerto Rico","KR":"Republik Korea","MD":"Republik Moldau","RE":"Réunion","RW":"Ruanda","RO":"Rumänien","RU":"Russische Föderation","SB":"Salomonen","ZM":"Sambia","WS":"Samoa","SM":"San Marino","ST":"São Tomé und Príncipe","SA":"Saudi-Arabien","SE":"Schweden","CH":"Schweiz","SN":"Senegal","RS":"Serbien","SC":"Seychellen","SL":"Sierra Leone","ZW":"Simbabwe","SG":"Singapur","SX":"Sint Maarten","SK":"Slowakei","SI":"Slowenien","SO":"Somalia","MO":"Sonderverwaltungsregion Macau","HK":"Sonderverwaltungszone Hongkong","ES":"Spanien","LK":"Sri Lanka","BL":"St. Barthélemy","SH":"St. Helena","KN":"St. Kitts und Nevis","LC":"St. Lucia","MF":"St. Martin","PM":"St. Pierre und Miquelon","VC":"St. Vincent und die Grenadinen","ZA":"Südafrika","SD":"Sudan","GS":"Südgeorgien und die Südlichen Sandwichinseln","SS":"Südsudan","SR":"Suriname","SJ":"Svalbard und Jan Mayen","SZ":"Swasiland","SY":"Syrien","TJ":"Tadschikistan","TW":"Taiwan","TZ":"Tansania","TH":"Thailand","TL":"Timor-Leste","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trinidad und Tobago","TA":"Tristan da Cunha","TD":"Tschad","CZ":"Tschechische Republik","TN":"Tunesien","TR":"Türkei","TM":"Turkmenistan","TC":"Turks- und Caicosinseln","TV":"Tuvalu","UG":"Uganda","UA":"Ukraine","HU":"Ungarn","UY":"Uruguay","UZ":"Usbekistan","VU":"Vanuatu","VA":"Vatikanstadt","VE":"Venezuela","AE":"Vereinigte Arabische Emirate","US":"Vereinigte Staaten","GB":"Vereinigtes Königreich","VN":"Vietnam","WF":"Wallis und Futuna","CX":"Weihnachtsinsel","EH":"Westsahara","CF":"Zentralafrikanische Republik","CY":"Zypern"}

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DatePicker_index__ = __webpack_require__(1811);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_DatePicker_index__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__components_DatePicker_index__["b"]; });

//# sourceMappingURL=DatePicker.js.map

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NotificationPreview; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Link__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Icon__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_Modal__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__build_node_modules_office_ui_fabric_react_lib_Spinner__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__build_src_app_services_request__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__build_src_app_components_Localization__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_desc,_value,_class2,_descriptor,_descriptor2,_descriptor3,_descriptor4,_class3,_temp2;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var NotificationPreview=Object(__WEBPACK_IMPORTED_MODULE_10__build_src_app_components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx_react__["e" /* observer */])(_class=(_class2=(_temp2=_class3=function(_Component){_inherits(NotificationPreview,_Component);function NotificationPreview(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,NotificationPreview);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NotificationPreview.__proto__||Object.getPrototypeOf(NotificationPreview)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'isOpen',_descriptor,_this),_initDefineProp(_this,'isLoading',_descriptor2,_this),_initDefineProp(_this,'groups',_descriptor3,_this),_initDefineProp(_this,'selectedGroup',_descriptor4,_this),_this.open=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(){var _this$props,action,query,data,url;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this$props=_this.props,action=_this$props.action,query=_this$props.query,data=_this$props.data;url=!!query?action+(action.indexOf('?')>=0?'&':'?')+Object.keys(query).map(function(k){return encodeURIComponent(k)+'='+encodeURIComponent(query[k]);}).join('&'):action;_this.groups=[];_this.isOpen=true;_this.isLoading=true;_context.prev=5;_context.next=8;return Object(__WEBPACK_IMPORTED_MODULE_9__build_src_app_services_request__["e" /* post */])(url,data);case 8:_this.groups=_context.sent;_this.selectedGroup=0;_context.next=16;break;case 12:_context.prev=12;_context.t0=_context['catch'](5);_this.isOpen=false;throw _context.t0;case 16:_context.prev=16;_this.isLoading=false;return _context.finish(16);case 19:case'end':return _context.stop();}}},_callee,_this2,[[5,12,16,19]]);})),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NotificationPreview,[{key:'render',// trigger = 'button' | 'icon'
value:function render(){var _this3=this;var _props=this.props,trigger=_props.trigger,t=_props.t;return __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__["Fragment"],null,trigger==='button'&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_Button__["f" /* DefaultButton */],{onClick:this.open},t('Preview')),trigger==='icon'&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Link__["Link"],{onClick:this.open,title:t('Preview')},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Icon__["Icon"],{iconName:'Zoom'})),this.isOpen&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_Modal__["a" /* Modal */],{isOpen:true,onDismiss:function onDismiss(){return _this3.isOpen=false;},isBlocking:false,containerClassName:'notification--preview--modal'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{style:{flex:'none'}},this.groups.map(function(group,index){return __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__["Fragment"],{key:index},index===_this3.selectedGroup?__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_Button__["h" /* PrimaryButton */],{onClick:function onClick(){_this3.selectedGroup=index;}},t("notificationcaption::"+group.caption)):__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_Button__["f" /* DefaultButton */],{onClick:function onClick(){_this3.selectedGroup=index;}},t("notificationcaption::"+group.caption)));})),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{style:{flex:'1 1 auto',display:'flex',flexDirection:'column',flexWrap:'nowrap',border:'1px solid #EE7F01',padding:'20px',paddingTop:0}},this.isLoading&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{style:{flex:'1 1 auto',display:'flex',alignItems:'center',justifyContent:'center'}},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__build_node_modules_office_ui_fabric_react_lib_Spinner__["a" /* Spinner */],{size:__WEBPACK_IMPORTED_MODULE_8__build_node_modules_office_ui_fabric_react_lib_Spinner__["b" /* SpinnerSize */].medium})),this.groups.map(function(group,index){return __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{key:index,style:{flex:'1 1 auto',display:index===_this3.selectedGroup?'flex':'none',flexDirection:'column',flexWrap:'nowrap',height:'100%'}},group.notifications.map(function(notification,index2){return __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__["Fragment"],{key:index2},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('h3',null,t(notification.caption)),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('iframe',{title:'notification_preview_iframe',src:notification.url,style:{flex:notification.short?'none':'1 1 auto',height:notification.short?'70px':'auto'}}));}));}),this.groups.length===0&&!this.isLoading&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{style:{flex:'1 1 auto',display:'flex',alignItems:'center',justifyContent:'center'}},t('No notification defined for the selected action')))));}}]);return NotificationPreview;}(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__["Component"]),_class3.displayName='NotificationPreview',_temp2),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'isOpen',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,'isLoading',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor3=_applyDecoratedDescriptor(_class2.prototype,'groups',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor4=_applyDecoratedDescriptor(_class2.prototype,'selectedGroup',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return-1;}})),_class2))||_class)||_class;

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getNumberFormattingOptions */
/* harmony export (immutable) */ __webpack_exports__["c"] = parseFormattedNumberValue;
/* harmony export (immutable) */ __webpack_exports__["a"] = getMoneyFormattingOptions;
/* harmony export (immutable) */ __webpack_exports__["b"] = parseFormattedMoneyValue;
/* harmony export (immutable) */ __webpack_exports__["d"] = toFormattedNumber;
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var config=__webpack_require__(104).default;// locale = e.g. 'de', 'de-CH'
// returns object with the following properties: {
//   group: thousands separator,
//   decimal: decimal separator
// }
function getNumberFormattingOptions(locale){var formatter=new Intl.NumberFormat(locale,{useGrouping:true});// safari hack for not supporting NumberFormat.prototype.formatToParts 😟
if(!formatter.formatToParts){var formatted=formatter.format(1000.5);var _formatted$match=formatted.match(/([^0-9]?)[0-9]+([^0-9])[0-9]+$/),_formatted$match2=_slicedToArray(_formatted$match,3),group=_formatted$match2[1],decimal=_formatted$match2[2];return{decimal:decimal,group:group,literal:''};}var result={};var parts=formatter.formatToParts(1000.5);parts.filter(function(p){return p.type!=='integer'&&p.type!=='fraction';}).map(function(p){result=Object.assign(result,_defineProperty({},p.type,p.value));return p;});result['literal']=result['literal']||'';return result;}// value = formatted numeric value
function parseFormattedNumberValue(value,locale){if(typeof value==='number')return value;if(value===''||value===null||typeof value==='undefined')return 0;var options=getNumberFormattingOptions(locale);if(options.group)value=value.replaceAll(options.group,'');// remove thousands separator
if(options.decimal&&options.decimal!=='.')value=value.replace(options.decimal,'.');// "normalize" decimal symbol to be simple dot
return parseFloat(value);}// currency = currency code, e.g. 'EUR'
// locale = e.g. 'de', 'de-CH'
// returns object with the following properties: {
//   prefix: currency code if the currency and locale specifies currency code to be BEFORE value,
//   suffix: currency code if the currency and locale specifies currency code to be AFTER value,
//   group: thousands separator,
//   decimal: decimal separator
// }
function getMoneyFormattingOptions(currency,locale){var formatter=new Intl.NumberFormat(locale,{style:'currency',currency:currency,useGrouping:true});// Safari hack for not supporting NumberFormat.prototype.formatToParts 😟
if(!formatter.formatToParts){var numberOptions=getNumberFormattingOptions(locale);var formatted=formatter.format(1000.5);var numberGroup='0-9'+numberOptions.group+numberOptions.decimal;var _formatted$match3=formatted.match(new RegExp('^([^'+numberGroup+'\\s]*)([\\s]*)['+numberGroup+']+?([\\s]*)([^'+numberGroup+'\\s]*)$')),_formatted$match4=_slicedToArray(_formatted$match3,5),prefix=_formatted$match4[1],prefixLiteral=_formatted$match4[2],suffixLiteral=_formatted$match4[3],suffix=_formatted$match4[4];return Object.assign({},numberOptions,{currency:prefix||suffix,literal:prefixLiteral||suffixLiteral,prefix:prefix,suffix:suffix,fixedDecimalZeroes:config.moneyFieldFixedDecimalZeroes});}var result={};var parts=formatter.formatToParts(1000.5);var currencyIndex=parts.map(function(p){return p.type;}).indexOf('currency');parts.filter(function(p){return p.type!=='integer'&&p.type!=='fraction';}).map(function(p){result=Object.assign(result,_defineProperty({},p.type,p.value));return p;});result['prefix']=currencyIndex===0?result['currency']:'';result['suffix']=currencyIndex>0?result['currency']:'';result['literal']=result['literal']||'';result['fixedDecimalZeroes']=config.moneyFieldFixedDecimalZeroes;return result;}// value = formatted money value WITHOUT currency code
function parseFormattedMoneyValue(value,currency,locale){if(typeof value==='number')return value;if(value===''||value===null||typeof value==='undefined')return 0;var options=getMoneyFormattingOptions(currency,locale);if(options.group)value=value.replaceAll(options.group,'');//remove thousands separator
if(options.decimal&&options.decimal!=='.')value=value.replace(options.decimal,'.');// "normalize" decimal symbol to be simple dot
return parseFloat(value);}function toFormattedNumber(value,locale){if(typeof value==='string')return value;if(value===''||value===null||typeof value==='undefined')return'';var options=getNumberFormattingOptions(locale);if(options.decimal&&options.decimal!=='.')value=value.toString().replace('.',options.decimal);return value;}

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ToggleField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_Icon__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Tooltip__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Toggle__ = __webpack_require__(725);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp2;function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ToggleField=(_temp2=_class=function(_Component){_inherits(ToggleField,_Component);function ToggleField(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ToggleField);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ToggleField.__proto__||Object.getPrototypeOf(ToggleField)).call.apply(_ref,[this].concat(args))),_this),_this.hostId=Object(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Utilities__["N" /* getId */])('tooltipHost'),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ToggleField,[{key:'componentWillMount',value:function componentWillMount(){this.id=__WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash___default.a.uniqueId('ToggleField');}},{key:'render',value:function render(){var _props=this.props,label=_props.label,tooltip=_props.tooltip,checked=_props.checked,rest=_objectWithoutProperties(_props,['label','tooltip','checked']);var tooltipIcon=__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,tooltip&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',{style:{marginLeft:'0.5em'}},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Tooltip__["b" /* TooltipHost */],{content:__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:tooltip}}),id:this.hostId,calloutProps:{gapSpace:0},onClick:function onClick(e){return e.stopPropagation();}},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_Icon__["Icon"],{iconName:'Info'}))));return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Toggle__["a" /* Toggle */],Object.assign({inlineLabel:true,label:__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,label,tooltipIcon),role:'checkbox','aria-checked':checked,checked:checked},rest));}}]);return ToggleField;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class.displayName='ToggleField',_temp2);

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ChoiceGroup_index__ = __webpack_require__(1854);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_ChoiceGroup_index__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__components_ChoiceGroup_index__["b"]; });

//# sourceMappingURL=ChoiceGroup.js.map

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_moment_timezone__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_DatePicker__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Icon__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Tooltip__ = __webpack_require__(108);
var _this=this;function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function renderFormattedDate(date){return date.toString().toFormatedDateString();}var DatePicker=function DatePicker(props){var label=props.label,tooltip=props.tooltip,checked=props.checked,rest=_objectWithoutProperties(props,['label','tooltip','checked']);var momentData=__WEBPACK_IMPORTED_MODULE_1__build_node_modules_moment_timezone___default.a.localeData();var tooltipIcon=__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,tooltip&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',{style:{marginLeft:'0.5em'}},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Tooltip__["b" /* TooltipHost */],{content:__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:tooltip}}),id:_this.hostId,calloutProps:{gapSpace:0},onClick:function onClick(e){return e.stopPropagation();}},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Icon__["Icon"],{iconName:'Info'}))));return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_DatePicker__["a" /* DatePicker */],Object.assign({label:__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,label,tooltipIcon),firstDayOfWeek:momentData.firstDayOfWeek(),formatDate:renderFormattedDate,strings:{months:momentData._months,shortMonths:momentData._monthsShort,days:momentData._weekdays,shortDays:momentData._weekdaysMin},showGoToToday:false},rest));};/* harmony default export */ __webpack_exports__["a"] = (DatePicker);

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TermsLabel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_styled_components__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_react_intl__ = __webpack_require__(143);
var _templateObject=_taggedTemplateLiteral(["\n  a {\n    color: ",";\n  }\n"],["\n  a {\n    color: ",";\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var TocSection=__WEBPACK_IMPORTED_MODULE_1__build_node_modules_styled_components__["a" /* default */].span(_templateObject,function(props){return props.theme.palette.themePrimary;});var TermsLabel=function TermsLabel(_ref){var app=_ref.app,user=_ref.user,t=_ref.t;var getLinks=function getLinks(){var _ref2=app.data||{},_ref2$agent_terms_url=_ref2.agent_terms_url,agent_terms_url=_ref2$agent_terms_url===undefined?'agb':_ref2$agent_terms_url,_ref2$agent_privacy_u=_ref2.agent_privacy_url,agent_privacy_url=_ref2$agent_privacy_u===undefined?'datenschutzerklaerung':_ref2$agent_privacy_u,_ref2$agent_avv_url=_ref2.agent_avv_url,agent_avv_url=_ref2$agent_avv_url===undefined?'avv':_ref2$agent_avv_url;return{terms:agent_terms_url,privacy:agent_privacy_url,avv:agent_avv_url};};var getUrl=function getUrl(page){if(page.startsWith('http'))return page+"?locale="+user.claims.locale;// HACK-ing
if(app.config.tenant.startsWith('propnow'))return window.location.origin.replace('://app.',"://"+user.claims.tenant+".")+"/content/"+page+"?locale="+user.claims.locale;return"/content/"+page+"?locale="+user.claims.locale;};var handleOpenToc=function handleOpenToc(e,page){e.preventDefault();e.stopPropagation();window.open(getUrl(page));};var links=getLinks();if(app.tenant==="remax-at"){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(TocSection,{theme:app.theme},"Ich stimme den",' ',__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement("a",{onClick:function onClick(e){return handleOpenToc(e,links.terms);}},"AGBs")," und den",' ',__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement("a",{onClick:function onClick(e){return handleOpenToc(e,'https://res.cloudinary.com/auctiontech/image/upload/v1688394942/dav/data/Richtlinie-digitales-Angebotsverfahren_2022.pdf');}},"Verhaltensrichtlinien")," zu.");}return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(TocSection,{theme:app.theme},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_react_intl__["a" /* FormattedMessage */],{id:"SaleCreatePanel::i_agree_to_the_link",values:{agbs:__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement("a",{onClick:function onClick(e){return handleOpenToc(e,links.terms);}},t('agbs')),dataprotection:__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement("a",{onClick:function onClick(e){return handleOpenToc(e,links.privacy);}},t('dataprotection')),avv:__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement("a",{onClick:function onClick(e){return handleOpenToc(e,links.avv);}},t('avv'))}}));};

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(1128);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 494 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(23) && !__webpack_require__(16)(function () {
  return Object.defineProperty(__webpack_require__(323)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(20);


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(63);
var toIObject = __webpack_require__(64);
var arrayIndexOf = __webpack_require__(218)(false);
var IE_PROTO = __webpack_require__(325)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(25);
var anObject = __webpack_require__(13);
var getKeys = __webpack_require__(126);

module.exports = __webpack_require__(23) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(64);
var gOPN = __webpack_require__(129).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(23);
var getKeys = __webpack_require__(126);
var gOPS = __webpack_require__(219);
var pIE = __webpack_require__(166);
var toObject = __webpack_require__(27);
var IObject = __webpack_require__(165);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(16)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 501 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(48);
var isObject = __webpack_require__(17);
var invoke = __webpack_require__(503);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 503 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(14).parseInt;
var $trim = __webpack_require__(141).trim;
var ws = __webpack_require__(329);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(14).parseFloat;
var $trim = __webpack_require__(141).trim;

module.exports = 1 / $parseFloat(__webpack_require__(329) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(72);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(17);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 508 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(332);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(13);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(48);
var toObject = __webpack_require__(27);
var IObject = __webpack_require__(165);
var toLength = __webpack_require__(21);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(27);
var toAbsoluteIndex = __webpack_require__(127);
var toLength = __webpack_require__(21);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 513 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(344);
__webpack_require__(3)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(23) && /./g.flags != 'g') __webpack_require__(25).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(167)
});


/***/ }),
/* 516 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(13);
var isObject = __webpack_require__(17);
var newPromiseCapability = __webpack_require__(348);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(519);
var validate = __webpack_require__(134);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(227)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(25).f;
var create = __webpack_require__(128);
var redefineAll = __webpack_require__(133);
var ctx = __webpack_require__(71);
var anInstance = __webpack_require__(131);
var forOf = __webpack_require__(132);
var $iterDefine = __webpack_require__(334);
var step = __webpack_require__(513);
var setSpecies = __webpack_require__(130);
var DESCRIPTORS = __webpack_require__(23);
var fastKey = __webpack_require__(114).fastKey;
var validate = __webpack_require__(134);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(519);
var validate = __webpack_require__(134);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(227)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(14);
var each = __webpack_require__(95)(0);
var redefine = __webpack_require__(59);
var meta = __webpack_require__(114);
var assign = __webpack_require__(500);
var weak = __webpack_require__(522);
var isObject = __webpack_require__(17);
var validate = __webpack_require__(134);
var NATIVE_WEAK_MAP = __webpack_require__(134);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(227)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(133);
var getWeak = __webpack_require__(114).getWeak;
var anObject = __webpack_require__(13);
var isObject = __webpack_require__(17);
var anInstance = __webpack_require__(131);
var forOf = __webpack_require__(132);
var createArrayMethod = __webpack_require__(95);
var $has = __webpack_require__(63);
var validate = __webpack_require__(134);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(73);
var toLength = __webpack_require__(21);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(129);
var gOPS = __webpack_require__(219);
var anObject = __webpack_require__(13);
var Reflect = __webpack_require__(14).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(220);
var isObject = __webpack_require__(17);
var toLength = __webpack_require__(21);
var ctx = __webpack_require__(71);
var IS_CONCAT_SPREADABLE = __webpack_require__(20)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(21);
var repeat = __webpack_require__(331);
var defined = __webpack_require__(93);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(23);
var getKeys = __webpack_require__(126);
var toIObject = __webpack_require__(64);
var isEnum = __webpack_require__(166).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(140);
var from = __webpack_require__(529);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(132);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 530 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlMessageFormat = __webpack_require__(1339)['default'];

// Add all locale data to `IntlMessageFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(1346);

// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlMessageFormat;
exports['default'] = exports;


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports.extend = extend;
var hop = Object.prototype.hasOwnProperty;

function extend(obj) {
    var sources = Array.prototype.slice.call(arguments, 1),
        i, len, source, key;

    for (i = 0, len = sources.length; i < len; i += 1) {
        source = sources[i];
        if (!source) { continue; }

        for (key in source) {
            if (hop.call(source, key)) {
                obj[key] = source[key];
            }
        }
    }

    return obj;
}
exports.hop = hop;

//# sourceMappingURL=utils.js.map

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(350);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventsDiscardedReason; });
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
/**
 * The EventsDiscardedReason enumeration contains a set of values that specify the reason for discarding an event.
 */
var EventsDiscardedReason = {
    /**
     * Unknown.
     */
    Unknown: 0,
    /**
     * Status set to non-retryable.
     */
    NonRetryableStatus: 1,
    /**
     * The event is invalid.
     */
    InvalidEvent: 2,
    /**
     * The size of the event is too large.
     */
    SizeLimitExceeded: 3,
    /**
     * The server is not accepting events from this instrumentation key.
     */
    KillSwitch: 4,
    /**
     * The event queue is full.
     */
    QueueFull: 5
};
//# sourceMappingURL=EventsDiscardedReason.js.map

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseCore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CoreUtils__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ChannelController__ = __webpack_require__(1373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProcessTelemetryContext__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TelemetryHelpers__ = __webpack_require__(354);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.





var validationError = "Extensions must provide callback to initialize";
var _arrForEach = __WEBPACK_IMPORTED_MODULE_0__CoreUtils__["a" /* CoreUtils */].arrForEach;
var _isNullOrUndefined = __WEBPACK_IMPORTED_MODULE_0__CoreUtils__["a" /* CoreUtils */].isNullOrUndefined;
var BaseCore = /** @class */ (function () {
    function BaseCore() {
        var _isInitialized = false;
        var _this = this;
        _this._extensions = new Array();
        _this._channelController = new __WEBPACK_IMPORTED_MODULE_1__ChannelController__["a" /* ChannelController */]();
        _this.isInitialized = function () { return _isInitialized; };
        _this._setInit = function (value) { _isInitialized = value; };
        _this._eventQueue = [];
    }
    BaseCore.prototype.initialize = function (config, extensions, logger, notificationManager) {
        var _this = this;
        // Make sure core is only initialized once
        if (_this.isInitialized()) {
            throw Error("Core should not be initialized more than once");
        }
        if (!config || _isNullOrUndefined(config.instrumentationKey)) {
            throw Error("Please provide instrumentation key");
        }
        _this.config = config;
        var channelController = _this._channelController;
        if (!notificationManager) {
            // Create Dummy notification manager
            notificationManager = __WEBPACK_IMPORTED_MODULE_0__CoreUtils__["a" /* CoreUtils */].objCreate({
                addNotificationListener: function (listener) { },
                removeNotificationListener: function (listener) { },
                eventsSent: function (events) { },
                eventsDiscarded: function (events, reason) { }
            });
        }
        _this._notificationManager = notificationManager;
        config.extensions = _isNullOrUndefined(config.extensions) ? [] : config.extensions;
        // add notification to the extensions in the config so other plugins can access it
        var extConfig = config.extensionConfig = _isNullOrUndefined(config.extensionConfig) ? {} : config.extensionConfig;
        extConfig.NotificationManager = notificationManager;
        if (!logger) {
            logger = __WEBPACK_IMPORTED_MODULE_0__CoreUtils__["a" /* CoreUtils */].objCreate({
                throwInternal: function (severity, msgId, msg, properties, isUserAct) {
                    if (isUserAct === void 0) { isUserAct = false; }
                },
                warnToConsole: function (message) { },
                resetInternalMessageCount: function () { }
            });
        }
        _this.logger = logger;
        // Concat all available extensions
        var allExtensions = [];
        allExtensions.push.apply(allExtensions, extensions.concat(config.extensions));
        allExtensions = Object(__WEBPACK_IMPORTED_MODULE_3__TelemetryHelpers__["b" /* sortPlugins */])(allExtensions);
        var coreExtensions = [];
        var channelExtensions = [];
        // Check if any two extensions have the same priority, then warn to console
        // And extract the local extensions from the 
        var extPriorities = {};
        // Extension validation
        _arrForEach(allExtensions, function (ext) {
            if (_isNullOrUndefined(ext) || _isNullOrUndefined(ext.initialize)) {
                throw Error(validationError);
            }
            var extPriority = ext.priority;
            var identifier = ext.identifier;
            if (ext && extPriority) {
                if (!_isNullOrUndefined(extPriorities[extPriority])) {
                    logger.warnToConsole("Two extensions have same priority #" + extPriority + " - " + extPriorities[extPriority] + ", " + identifier);
                }
                else {
                    // set a value
                    extPriorities[extPriority] = identifier;
                }
            }
            // Split extensions to core and channelController
            if (!extPriority || extPriority < channelController.priority) {
                // Add to core extension that will be managed by BaseCore
                coreExtensions.push(ext);
            }
            else {
                // Add all other extensions to be managed by the channel controller
                channelExtensions.push(ext);
            }
        });
        // Validation complete
        // Add the channelController to the complete extension collection and
        // to the end of the core extensions
        allExtensions.push(channelController);
        coreExtensions.push(channelController);
        // Sort the complete set of extensions by priority
        allExtensions = Object(__WEBPACK_IMPORTED_MODULE_3__TelemetryHelpers__["b" /* sortPlugins */])(allExtensions);
        _this._extensions = allExtensions;
        // initialize channel controller first, this will initialize all channel plugins
        Object(__WEBPACK_IMPORTED_MODULE_3__TelemetryHelpers__["a" /* initializePlugins */])(new __WEBPACK_IMPORTED_MODULE_2__ProcessTelemetryContext__["a" /* ProcessTelemetryContext */]([channelController], config, _this), allExtensions);
        Object(__WEBPACK_IMPORTED_MODULE_3__TelemetryHelpers__["a" /* initializePlugins */])(new __WEBPACK_IMPORTED_MODULE_2__ProcessTelemetryContext__["a" /* ProcessTelemetryContext */](coreExtensions, config, _this), allExtensions);
        // Now reset the extensions to just those being managed by Basecore
        _this._extensions = coreExtensions;
        if (_this.getTransmissionControls().length === 0) {
            throw new Error("No channels available");
        }
        _this._setInit(true);
    };
    BaseCore.prototype.getTransmissionControls = function () {
        return this._channelController.getChannelControls();
    };
    BaseCore.prototype.track = function (telemetryItem) {
        var _this = this;
        if (!telemetryItem.iKey) {
            // setup default iKey if not passed in
            telemetryItem.iKey = _this.config.instrumentationKey;
        }
        if (!telemetryItem.time) {
            // add default timestamp if not passed in
            telemetryItem.time = __WEBPACK_IMPORTED_MODULE_0__CoreUtils__["a" /* CoreUtils */].toISOString(new Date());
        }
        if (_isNullOrUndefined(telemetryItem.ver)) {
            // CommonSchema 4.0
            telemetryItem.ver = "4.0";
        }
        if (_this.isInitialized()) {
            // Release queue
            if (_this._eventQueue.length > 0) {
                _arrForEach(_this._eventQueue, function (event) {
                    _this.getProcessTelContext().processNext(event);
                });
                _this._eventQueue = [];
            }
            // Process the telemetry plugin chain
            _this.getProcessTelContext().processNext(telemetryItem);
        }
        else {
            // Queue events until all extensions are initialized
            _this._eventQueue.push(telemetryItem);
        }
    };
    BaseCore.prototype.getProcessTelContext = function () {
        var _this = this;
        var extensions = _this._extensions;
        var thePlugins = extensions;
        // invoke any common telemetry processors before sending through pipeline
        if (!extensions || extensions.length === 0) {
            // Pass to Channel controller so data is sent to correct channel queues
            thePlugins = [_this._channelController];
        }
        return new __WEBPACK_IMPORTED_MODULE_2__ProcessTelemetryContext__["a" /* ProcessTelemetryContext */](thePlugins, _this.config, _this);
    };
    return BaseCore;
}());

//# sourceMappingURL=BaseCore.js.map

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseTelemetryPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CoreUtils__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProcessTelemetryContext__ = __webpack_require__(233);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.



var _isFunction = __WEBPACK_IMPORTED_MODULE_0__CoreUtils__["a" /* CoreUtils */].isFunction;
var getPlugin = "getPlugin";
/**
 * BaseTelemetryPlugin provides a basic implementation of the ITelemetryPlugin interface so that plugins
 * can avoid implementation the same set of boiler plate code as well as provide a base
 * implementation so that new default implementations can be added without breaking all plugins.
 */
var BaseTelemetryPlugin = /** @class */ (function () {
    function BaseTelemetryPlugin() {
        var _self = this;
        var _isinitialized = false;
        var _rootCtx = null; // Used as the root context, holding the current config and initialized core
        var _nextPlugin = null; // Used for backward compatibility where plugins don't call the main pipeline
        _self.core = null;
        _self.diagLog = function (itemCtx) {
            return _self._getTelCtx(itemCtx).diagLog();
        };
        _self.isInitialized = function () {
            return _isinitialized;
        };
        _self.setInitialized = function (isInitialized) {
            _isinitialized = isInitialized;
        };
        // _self.getNextPlugin = () => DO NOT IMPLEMENT
        // Sub-classes of this base class *should* not be relying on this value and instead
        // should use processNext() function. If you require access to the plugin use the
        // IProcessTelemetryContext.getNext().getPlugin() while in the pipeline, Note getNext() may return null.
        _self.setNextPlugin = function (next) {
            _nextPlugin = next;
        };
        _self.processNext = function (env, itemCtx) {
            if (itemCtx) {
                // Normal core execution sequence
                itemCtx.processNext(env);
            }
            else if (_nextPlugin && _isFunction(_nextPlugin.processTelemetry)) {
                // Looks like backward compatibility or out of band processing. And as it looks 
                // like a ITelemetryPlugin or ITelemetryPluginChain, just call processTelemetry
                _nextPlugin.processTelemetry(env, null);
            }
        };
        _self._getTelCtx = function (currentCtx) {
            if (currentCtx === void 0) { currentCtx = null; }
            var itemCtx = currentCtx;
            if (!itemCtx) {
                var rootCtx = _rootCtx || new __WEBPACK_IMPORTED_MODULE_1__ProcessTelemetryContext__["a" /* ProcessTelemetryContext */](null, {}, _self.core);
                // tslint:disable-next-line: prefer-conditional-expression
                if (_nextPlugin && _nextPlugin[getPlugin]) {
                    // Looks like a chain object
                    itemCtx = rootCtx.createNew(null, _nextPlugin[getPlugin]);
                }
                else {
                    itemCtx = rootCtx.createNew(null, _nextPlugin);
                }
            }
            return itemCtx;
        };
        _self._baseTelInit = function (config, core, extensions, pluginChain) {
            if (config) {
                // Make sure the extensionConfig exists
                config.extensionConfig = config.extensionConfig || [];
            }
            if (!pluginChain && core) {
                // Get the first plugin from the core
                pluginChain = core.getProcessTelContext().getNext();
            }
            var nextPlugin = _nextPlugin;
            if (_nextPlugin && _nextPlugin[getPlugin]) {
                // If it looks like a proxy/chain then get the plugin
                nextPlugin = _nextPlugin[getPlugin]();
            }
            // Support legacy plugins where core was defined as a property
            _self.core = core;
            _rootCtx = new __WEBPACK_IMPORTED_MODULE_1__ProcessTelemetryContext__["a" /* ProcessTelemetryContext */](pluginChain, config, core, nextPlugin);
            _isinitialized = true;
        };
    }
    BaseTelemetryPlugin.prototype.initialize = function (config, core, extensions, pluginChain) {
        this._baseTelInit(config, core, extensions, pluginChain);
    };
    return BaseTelemetryPlugin;
}());

//# sourceMappingURL=BaseTelemetryPlugin.js.map

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NotificationManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CoreUtils__ = __webpack_require__(75);

/**
 * Class to manage sending notifications to all the listeners.
 */
var NotificationManager = /** @class */ (function () {
    function NotificationManager() {
        this.listeners = [];
    }
    /**
     * Adds a notification listener.
     * @param {INotificationListener} listener - The notification listener to be added.
     */
    NotificationManager.prototype.addNotificationListener = function (listener) {
        this.listeners.push(listener);
    };
    /**
     * Removes all instances of the listener.
     * @param {INotificationListener} listener - AWTNotificationListener to remove.
     */
    NotificationManager.prototype.removeNotificationListener = function (listener) {
        var index = __WEBPACK_IMPORTED_MODULE_0__CoreUtils__["a" /* CoreUtils */].arrIndexOf(this.listeners, listener);
        while (index > -1) {
            this.listeners.splice(index, 1);
            index = __WEBPACK_IMPORTED_MODULE_0__CoreUtils__["a" /* CoreUtils */].arrIndexOf(this.listeners, listener);
        }
    };
    /**
     * Notification for events sent.
     * @param {ITelemetryItem[]} events - The array of events that have been sent.
     */
    NotificationManager.prototype.eventsSent = function (events) {
        var _this = this;
        var _loop_1 = function (i) {
            if (this_1.listeners[i].eventsSent) {
                setTimeout(function () { return _this.listeners[i].eventsSent(events); }, 0);
            }
        };
        var this_1 = this;
        for (var i = 0; i < this.listeners.length; ++i) {
            _loop_1(i);
        }
    };
    /**
     * Notification for events being discarded.
     * @param {ITelemetryItem[]} events - The array of events that have been discarded by the SDK.
     * @param {number} reason           - The reason for which the SDK discarded the events. The EventsDiscardedReason
     * constant should be used to check the different values.
     */
    NotificationManager.prototype.eventsDiscarded = function (events, reason) {
        var _this = this;
        var _loop_2 = function (i) {
            if (this_2.listeners[i].eventsDiscarded) {
                setTimeout(function () { return _this.listeners[i].eventsDiscarded(events, reason); }, 0);
            }
        };
        var this_2 = this;
        for (var i = 0; i < this.listeners.length; ++i) {
            _loop_2(i);
        }
    };
    return NotificationManager;
}());

//# sourceMappingURL=NotificationManager.js.map

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Telemetry */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Initialization; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_analytics_js__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_channel_js__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_properties_js__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_dependencies_js__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_common__ = __webpack_require__(380);
/*
 * Application Insights JavaScript SDK - Web, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */








"use strict";
var _internalSdkSrc;
// This is an exclude list of properties that should not be updated during initialization
// They include a combination of private and internal property names
var _ignoreUpdateSnippetProperties = [
    "snippet", "dependencies", "properties", "_snippetVersion", "appInsightsNew", "getSKUDefaults",
];
;
// Re-exposing the Common classes as Telemetry, the list was taken by reviewing the generated code for the build while using
// the previous configuration :-
// import * as Common from "@microsoft/applicationinsights-common"
// export const Telemetry = Common;
var fieldType = {
    Default: 0 /* Default */,
    Required: 1 /* Required */,
    Array: 2 /* Array */,
    Hidden: 4 /* Hidden */
};
/**
 * Telemetry type classes, e.g. PageView, Exception, etc
 */
var Telemetry = {
    __proto__: null,
    PropertiesPluginIdentifier: __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_common__["z" /* PropertiesPluginIdentifier */],
    BreezeChannelIdentifier: __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_common__["d" /* BreezeChannelIdentifier */],
    AnalyticsPluginIdentifier: __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_common__["c" /* AnalyticsPluginIdentifier */],
    Util: __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_common__["H" /* Util */],
    CorrelationIdHelper: __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_common__["h" /* CorrelationIdHelper */],
    UrlHelper: __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_common__["G" /* UrlHelper */],
    DateTimeUtils: __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_common__["m" /* DateTimeUtils */],
    ConnectionStringParser: __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_common__["f" /* ConnectionStringParser */],
    FieldType: fieldType,
    RequestHeaders: __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_common__["B" /* RequestHeaders */],
    DisabledPropertyName: __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_common__["n" /* DisabledPropertyName */],
    ProcessLegacy: __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_common__["y" /* ProcessLegacy */],
    SampleRate: __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_common__["C" /* SampleRate */],
    HttpMethod: __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_common__["t" /* HttpMethod */],
    DEFAULT_BREEZE_ENDPOINT: __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_common__["j" /* DEFAULT_BREEZE_ENDPOINT */],
    AIData: __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_common__["b" /* AIData */],
    AIBase: __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_common__["a" /* AIBase */],
    Envelope: __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_common__["p" /* Envelope */],
    Event: __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_common__["q" /* Event */],
    Exception: __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_common__["r" /* Exception */],
    Metric: __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_common__["u" /* Metric */],
    PageView: __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_common__["v" /* PageView */],
    PageViewData: __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_common__["w" /* PageViewData */],
    RemoteDependencyData: __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_common__["A" /* RemoteDependencyData */],
    Trace: __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_common__["F" /* Trace */],
    PageViewPerformance: __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_common__["x" /* PageViewPerformance */],
    Data: __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_common__["k" /* Data */],
    SeverityLevel: __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_common__["D" /* SeverityLevel */],
    ConfigurationManager: __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_common__["e" /* ConfigurationManager */],
    ContextTagKeys: __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_common__["g" /* ContextTagKeys */],
    DataSanitizer: __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_common__["l" /* DataSanitizer */],
    TelemetryItemCreator: __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_common__["E" /* TelemetryItemCreator */],
    CtxTagKeys: __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_common__["i" /* CtxTagKeys */],
    Extensions: __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_common__["s" /* Extensions */],
    DistributedTracingModes: __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_common__["o" /* DistributedTracingModes */]
};
/**
 * Application Insights API
 * @class Initialization
 * @implements {IApplicationInsights}
 */
var Initialization = /** @class */ (function () {
    function Initialization(snippet) {
        var _self = this;
        // initialize the queue and config in case they are undefined
        _self._snippetVersion = "" + (snippet.sv || snippet.version || "");
        snippet.queue = snippet.queue || [];
        snippet.version = snippet.version || 2.0; // Default to new version
        var config = snippet.config || {};
        if (config.connectionString) {
            var cs = Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_common__["I" /* parseConnectionString */])(config.connectionString);
            var ingest = cs.ingestionendpoint;
            config.endpointUrl = ingest ? ingest + "/v2/track" : config.endpointUrl; // only add /v2/track when from connectionstring
            config.instrumentationKey = cs.instrumentationkey || config.instrumentationKey;
        }
        _self.appInsights = new __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_analytics_js__["a" /* ApplicationInsights */]();
        _self.properties = new __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_properties_js__["a" /* PropertiesPlugin */]();
        _self.dependencies = new __WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_dependencies_js__["a" /* AjaxPlugin */]();
        _self.core = new __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["a" /* AppInsightsCore */]();
        _self._sender = new __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_channel_js__["a" /* Sender */]();
        _self.snippet = snippet;
        _self.config = config;
        _self.getSKUDefaults();
    }
    // Analytics Plugin
    /**
     * Get the current cookie manager for this instance
     */
    Initialization.prototype.getCookieMgr = function () {
        return this.appInsights.getCookieMgr();
    };
    ;
    /**
     * Log a user action or other occurrence.
     * @param {IEventTelemetry} event
     * @param {ICustomProperties} [customProperties]
     * @memberof Initialization
     */
    Initialization.prototype.trackEvent = function (event, customProperties) {
        this.appInsights.trackEvent(event, customProperties);
    };
    /**
     * Logs that a page, or similar container was displayed to the user.
     * @param {IPageViewTelemetry} pageView
     * @memberof Initialization
     */
    Initialization.prototype.trackPageView = function (pageView) {
        var inPv = pageView || {};
        this.appInsights.trackPageView(inPv);
    };
    /**
     * Log a bag of performance information via the customProperties field.
     * @param {IPageViewPerformanceTelemetry} pageViewPerformance
     * @memberof Initialization
     */
    Initialization.prototype.trackPageViewPerformance = function (pageViewPerformance) {
        var inPvp = pageViewPerformance || {};
        this.appInsights.trackPageViewPerformance(inPvp);
    };
    /**
     * Log an exception that you have caught.
     * @param {IExceptionTelemetry} exception
     * @memberof Initialization
     */
    Initialization.prototype.trackException = function (exception) {
        if (exception && !exception.exception && exception.error) {
            exception.exception = exception.error;
        }
        this.appInsights.trackException(exception);
    };
    /**
     * Manually send uncaught exception telemetry. This method is automatically triggered
     * on a window.onerror event.
     * @param {IAutoExceptionTelemetry} exception
     * @memberof Initialization
     */
    Initialization.prototype._onerror = function (exception) {
        this.appInsights._onerror(exception);
    };
    /**
     * Log a diagnostic scenario such entering or leaving a function.
     * @param {ITraceTelemetry} trace
     * @param {ICustomProperties} [customProperties]
     * @memberof Initialization
     */
    Initialization.prototype.trackTrace = function (trace, customProperties) {
        this.appInsights.trackTrace(trace, customProperties);
    };
    /**
     * Log a numeric value that is not associated with a specific event. Typically used
     * to send regular reports of performance indicators.
     *
     * To send a single measurement, just use the `name` and `average` fields
     * of {@link IMetricTelemetry}.
     *
     * If you take measurements frequently, you can reduce the telemetry bandwidth by
     * aggregating multiple measurements and sending the resulting average and modifying
     * the `sampleCount` field of {@link IMetricTelemetry}.
     * @param {IMetricTelemetry} metric input object argument. Only `name` and `average` are mandatory.
     * @param {ICustomProperties} [customProperties]
     * @memberof Initialization
     */
    Initialization.prototype.trackMetric = function (metric, customProperties) {
        this.appInsights.trackMetric(metric, customProperties);
    };
    /**
     * Starts the timer for tracking a page load time. Use this instead of `trackPageView` if you want to control when the page view timer starts and stops,
     * but don't want to calculate the duration yourself. This method doesn't send any telemetry. Call `stopTrackPage` to log the end of the page view
     * and send the event.
     * @param name A string that idenfities this item, unique within this HTML document. Defaults to the document title.
     */
    Initialization.prototype.startTrackPage = function (name) {
        this.appInsights.startTrackPage(name);
    };
    /**
     * Stops the timer that was started by calling `startTrackPage` and sends the pageview load time telemetry with the specified properties and measurements.
     * The duration of the page view will be the time between calling `startTrackPage` and `stopTrackPage`.
     * @param   name  The string you used as the name in startTrackPage. Defaults to the document title.
     * @param   url   String - a relative or absolute URL that identifies the page or other item. Defaults to the window location.
     * @param   properties  map[string, string] - additional data used to filter pages and metrics in the portal. Defaults to empty.
     * @param   measurements    map[string, number] - metrics associated with this page, displayed in Metrics Explorer on the portal. Defaults to empty.
     */
    Initialization.prototype.stopTrackPage = function (name, url, customProperties, measurements) {
        this.appInsights.stopTrackPage(name, url, customProperties, measurements);
    };
    Initialization.prototype.startTrackEvent = function (name) {
        this.appInsights.startTrackEvent(name);
    };
    /**
     * Log an extended event that you started timing with `startTrackEvent`.
     * @param   name    The string you used to identify this event in `startTrackEvent`.
     * @param   properties  map[string, string] - additional data used to filter events and metrics in the portal. Defaults to empty.
     * @param   measurements    map[string, number] - metrics associated with this event, displayed in Metrics Explorer on the portal. Defaults to empty.
     */
    Initialization.prototype.stopTrackEvent = function (name, properties, measurements) {
        this.appInsights.stopTrackEvent(name, properties, measurements); // Todo: Fix to pass measurements once type is updated
    };
    Initialization.prototype.addTelemetryInitializer = function (telemetryInitializer) {
        return this.appInsights.addTelemetryInitializer(telemetryInitializer);
    };
    // Properties Plugin
    /**
     * Set the authenticated user id and the account id. Used for identifying a specific signed-in user. Parameters must not contain whitespace or ,;=|
     *
     * The method will only set the `authenticatedUserId` and `accountId` in the current page view. To set them for the whole session, you should set `storeInCookie = true`
     * @param {string} authenticatedUserId
     * @param {string} [accountId]
     * @param {boolean} [storeInCookie=false]
     * @memberof Initialization
     */
    Initialization.prototype.setAuthenticatedUserContext = function (authenticatedUserId, accountId, storeInCookie) {
        if (storeInCookie === void 0) { storeInCookie = false; }
        this.properties.context.user.setAuthenticatedUserContext(authenticatedUserId, accountId, storeInCookie);
    };
    /**
     * Clears the authenticated user id and account id. The associated cookie is cleared, if present.
     * @memberof Initialization
     */
    Initialization.prototype.clearAuthenticatedUserContext = function () {
        this.properties.context.user.clearAuthenticatedUserContext();
    };
    // Dependencies Plugin
    /**
     * Log a dependency call (e.g. ajax)
     * @param {IDependencyTelemetry} dependency
     * @memberof Initialization
     */
    Initialization.prototype.trackDependencyData = function (dependency) {
        this.dependencies.trackDependencyData(dependency);
    };
    // Misc
    /**
     * Manually trigger an immediate send of all telemetry still in the buffer.
     * @param {boolean} [async=true]
     * @memberof Initialization
     */
    Initialization.prototype.flush = function (async) {
        var _this = this;
        if (async === void 0) { async = true; }
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["o" /* doPerf */])(this.core, function () { return "AISKU.flush"; }, function () {
            Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["f" /* arrForEach */])(_this.core.getTransmissionControls(), function (channels) {
                Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["f" /* arrForEach */])(channels, function (channel) {
                    channel.flush(async);
                });
            });
        }, null, async);
    };
    /**
     * Manually trigger an immediate send of all telemetry still in the buffer using beacon Sender.
     * Fall back to xhr sender if beacon is not supported.
     * @param {boolean} [async=true]
     * @memberof Initialization
     */
    Initialization.prototype.onunloadFlush = function (async) {
        if (async === void 0) { async = true; }
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["f" /* arrForEach */])(this.core.getTransmissionControls(), function (channels) {
            Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["f" /* arrForEach */])(channels, function (channel) {
                if (channel.onunloadFlush) {
                    channel.onunloadFlush();
                }
                else {
                    channel.flush(async);
                }
            });
        });
    };
    /**
     * Initialize this instance of ApplicationInsights
     * @returns {IApplicationInsights}
     * @memberof Initialization
     */
    Initialization.prototype.loadAppInsights = function (legacyMode, logger, notificationManager) {
        var _this = this;
        if (legacyMode === void 0) { legacyMode = false; }
        var _self = this;
        function _updateSnippetProperties(snippet) {
            if (snippet) {
                var snippetVer = "";
                if (!Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["H" /* isNullOrUndefined */])(_self._snippetVersion)) {
                    snippetVer += _self._snippetVersion;
                }
                if (legacyMode) {
                    snippetVer += ".lg";
                }
                if (_self.context && _self.context.internal) {
                    _self.context.internal.snippetVer = snippetVer || "-";
                }
                // apply updated properties to the global instance (snippet)
                Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["M" /* objForEachKey */])(_self, function (field, value) {
                    if (Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["K" /* isString */])(field) &&
                        !Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["G" /* isFunction */])(value) &&
                        field && field[0] !== "_" && // Don't copy "internal" values
                        _ignoreUpdateSnippetProperties.indexOf(field) === -1) {
                        snippet[field] = value;
                    }
                });
            }
        }
        // dont allow additional channels/other extensions for legacy mode; legacy mode is only to allow users to switch with no code changes!
        if (legacyMode && _self.config.extensions && _self.config.extensions.length > 0) {
            Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["S" /* throwError */])("Extensions not allowed in legacy mode");
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["o" /* doPerf */])(_self.core, function () { return "AISKU.loadAppInsights"; }, function () {
            var extensions = [];
            extensions.push(_self._sender);
            extensions.push(_self.properties);
            extensions.push(_self.dependencies);
            extensions.push(_self.appInsights);
            // initialize core
            _self.core.initialize(_self.config, extensions, logger, notificationManager);
            _self.context = _self.properties.context;
            if (_internalSdkSrc && _self.context) {
                _self.context.internal.sdkSrc = _internalSdkSrc;
            }
            _updateSnippetProperties(_self.snippet);
            // Empty queue of all api calls logged prior to sdk download
            _self.emptyQueue();
            _self.pollInternalLogs();
            _self.addHousekeepingBeforeUnload(_this);
        });
        return _self;
    };
    /**
     * Overwrite the lazy loaded fields of global window snippet to contain the
     * actual initialized API methods
     * @param {Snippet} snippet
     * @memberof Initialization
     */
    Initialization.prototype.updateSnippetDefinitions = function (snippet) {
        // apply full appInsights to the global instance
        // Note: This must be called before loadAppInsights is called
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["O" /* proxyAssign */])(snippet, this, function (name) {
            // Not excluding names prefixed with "_" as we need to proxy some functions like _onError
            return name && _ignoreUpdateSnippetProperties.indexOf(name) === -1;
        });
    };
    /**
     * Call any functions that were queued before the main script was loaded
     * @memberof Initialization
     */
    Initialization.prototype.emptyQueue = function () {
        var _self = this;
        // call functions that were queued before the main script was loaded
        try {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["D" /* isArray */])(_self.snippet.queue)) {
                // note: do not check length in the for-loop conditional in case something goes wrong and the stub methods are not overridden.
                var length_1 = _self.snippet.queue.length;
                for (var i = 0; i < length_1; i++) {
                    var call = _self.snippet.queue[i];
                    call();
                }
                _self.snippet.queue = undefined;
                delete _self.snippet.queue;
            }
        }
        catch (exception) {
            var properties = {};
            if (exception && Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["G" /* isFunction */])(exception.toString)) {
                properties.exception = exception.toString();
            }
            // need from core
            // Microsoft.ApplicationInsights._InternalLogging.throwInternal(
            //     LoggingSeverity.WARNING,
            //     _InternalMessageId.FailedToSendQueuedTelemetry,
            //     "Failed to send queued telemetry",
            //     properties);
        }
    };
    Initialization.prototype.pollInternalLogs = function () {
        this.core.pollInternalLogs();
    };
    Initialization.prototype.addHousekeepingBeforeUnload = function (appInsightsInstance) {
        // Add callback to push events when the user navigates away
        if (Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["C" /* hasWindow */])() || Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["A" /* hasDocument */])()) {
            var performHousekeeping = function () {
                // Adds the ability to flush all data before the page unloads.
                // Note: This approach tries to push a sync request with all the pending events onbeforeunload.
                // Firefox does not respect this.Other browsers DO push out the call with < 100% hit rate.
                // Telemetry here will help us analyze how effective this approach is.
                // Another approach would be to make this call sync with a acceptable timeout to reduce the
                // impact on user experience.
                // appInsightsInstance.context._sender.triggerSend();
                appInsightsInstance.onunloadFlush(false);
                // Back up the current session to local storage
                // This lets us close expired sessions after the cookies themselves expire
                Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["f" /* arrForEach */])(appInsightsInstance.appInsights.core['_extensions'], function (ext) {
                    if (ext.identifier === __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_common__["z" /* PropertiesPluginIdentifier */]) {
                        if (ext && ext.context && ext.context._sessionManager) {
                            ext.context._sessionManager.backup();
                        }
                        return -1;
                    }
                });
            };
            if (!appInsightsInstance.appInsights.config.disableFlushOnBeforeUnload) {
                // Hook the unload event for the document, window and body to ensure that the client events are flushed to the server
                // As just hooking the window does not always fire (on chrome) for page navigations.
                var added = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["e" /* addEventHandler */])('beforeunload', performHousekeeping);
                added = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["e" /* addEventHandler */])('unload', performHousekeeping) || added;
                added = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["e" /* addEventHandler */])('pagehide', performHousekeeping) || added;
                // A reactNative app may not have a window and therefore the beforeunload/pagehide events -- so don't
                // log the failure in this case
                if (!added && !Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["J" /* isReactNative */])()) {
                    appInsightsInstance.appInsights.core.logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].FailedToAddHandlerForOnBeforeUnload, 'Could not add handler for beforeunload and pagehide');
                }
            }
            // We also need to hook the pagehide event as not all versions of Safari support load/unload events.
            if (!appInsightsInstance.appInsights.config.disableFlushOnUnload) {
                // Not adding any telemetry as pagehide as it's not supported on all browsers
                Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["e" /* addEventHandler */])('pagehide', performHousekeeping);
            }
        }
    };
    Initialization.prototype.getSender = function () {
        return this._sender;
    };
    Initialization.prototype.getSKUDefaults = function () {
        var _self = this;
        _self.config.diagnosticLogInterval =
            _self.config.diagnosticLogInterval && _self.config.diagnosticLogInterval > 0 ? _self.config.diagnosticLogInterval : 10000;
    };
    return Initialization;
}());

// tslint:disable-next-line
(function () {
    var sdkSrc = null;
    var isModule = false;
    var cdns = [
        "://js.monitor.azure.com/",
        "://az416426.vo.msecnd.net/"
    ];
    try {
        // Try and determine whether the sdk is being loaded from the CDN
        // currentScript is only valid during initial processing
        var scrpt = (document || {}).currentScript;
        if (scrpt) {
            sdkSrc = scrpt.src;
            // } else {
            //     // We need to update to at least typescript 2.9 for this to work :-(
            //     // Leaving as a stub for now so after we upgrade this breadcrumb is available
            //     let meta = import.meta;
            //     sdkSrc = (meta || {}).url;
            //     isModule = true;
        }
    }
    catch (e) {
    }
    if (sdkSrc) {
        try {
            var url = sdkSrc.toLowerCase();
            if (url) {
                var src = "";
                for (var idx = 0; idx < cdns.length; idx++) {
                    if (url.indexOf(cdns[idx]) !== -1) {
                        src = "cdn" + (idx + 1);
                        if (url.indexOf("/scripts/") === -1) {
                            if (url.indexOf("/next/") !== -1) {
                                src += "-next";
                            }
                            else if (url.indexOf("/beta/") !== -1) {
                                src += "-beta";
                            }
                        }
                        _internalSdkSrc = src + (isModule ? ".mod" : "");
                        break;
                    }
                }
            }
        }
        catch (e) {
        }
    }
})();
//# sourceMappingURL=Initialization.js.map

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventsDiscardedReason; });
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * The EventsDiscardedReason enumeration contains a set of values that specify the reason for discarding an event.
 */
var EventsDiscardedReason = {
    /**
     * Unknown.
     */
    Unknown: 0,
    /**
     * Status set to non-retryable.
     */
    NonRetryableStatus: 1,
    /**
     * The event is invalid.
     */
    InvalidEvent: 2,
    /**
     * The size of the event is too large.
     */
    SizeLimitExceeded: 3,
    /**
     * The server is not accepting events from this instrumentation key.
     */
    KillSwitch: 4,
    /**
     * The event queue is full.
     */
    QueueFull: 5
};
//# sourceMappingURL=EventsDiscardedReason.js.map

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SymbolObj */
/* unused harmony export ReflectObj */
/* unused harmony export __hasSymbol */
/* unused harmony export __hasReflect */
/* unused harmony export __objAssignFnImpl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assignFn; });
/* harmony export (immutable) */ __webpack_exports__["c"] = __extendsFn;
/* unused harmony export __restFn */
/* unused harmony export __decorateFn */
/* unused harmony export __paramFn */
/* unused harmony export __metadataFn */
/* unused harmony export __exportStarFn */
/* harmony export (immutable) */ __webpack_exports__["b"] = __createBindingFn;
/* unused harmony export __valuesFn */
/* unused harmony export __readFn */
/* unused harmony export __spreadArraysFn */
/* unused harmony export __spreadArrayFn */
/* unused harmony export __makeTemplateObjectFn */
/* unused harmony export __importStarFn */
/* unused harmony export __importDefaultFn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Helpers__ = __webpack_require__(355);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.


// Most of these functions have been directly shamelessly "lifted" from the https://github.com/@microsoft/tslib and
// modified to be ES3 compatible and applying several minification and tree-shaking techniques so that Application Insights
// can successfully use TypeScript "importHelpers" which imports tslib during compilation but it will use these at runtime
// Which is also why all of the functions have not been included as Application Insights currently doesn't use or require
// them.
var SymbolObj = (Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["a" /* getGlobal */])() || {})["Symbol"];
var ReflectObj = (Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["a" /* getGlobal */])() || {})["Reflect"];
var __hasSymbol = !!SymbolObj;
var __hasReflect = !!ReflectObj;
var strDecorate = "decorate";
var strMetadata = "metadata";
var strGetOwnPropertySymbols = "getOwnPropertySymbols";
var strIterator = "iterator";
var __objAssignFnImpl = function (t) {
    // tslint:disable-next-line: ban-comma-operator
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (__WEBPACK_IMPORTED_MODULE_0__Constants__["f" /* ObjProto */][__WEBPACK_IMPORTED_MODULE_0__Constants__["i" /* strShimHasOwnProperty */]].call(s, p)) {
                t[p] = s[p];
            }
        }
    }
    return t;
};
var __assignFn = __WEBPACK_IMPORTED_MODULE_0__Constants__["a" /* ObjAssign */] || __objAssignFnImpl;
// tslint:disable-next-line: only-arrow-functions
var extendStaticsFn = function (d, b) {
    extendStaticsFn = __WEBPACK_IMPORTED_MODULE_0__Constants__["b" /* ObjClass */]["setPrototypeOf"] ||
        // tslint:disable-next-line: only-arrow-functions
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        // tslint:disable-next-line: only-arrow-functions
        function (d, b) {
            for (var p in b) {
                if (b[__WEBPACK_IMPORTED_MODULE_0__Constants__["i" /* strShimHasOwnProperty */]](p)) {
                    d[p] = b[p];
                }
            }
        };
    return extendStaticsFn(d, b);
};
function __extendsFn(d, b) {
    if (typeof b !== __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */] && b !== null) {
        Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["c" /* throwTypeError */])("Class extends value " + String(b) + " is not a constructor or null");
    }
    extendStaticsFn(d, b);
    function __() { this.constructor = d; }
    // tslint:disable-next-line: ban-comma-operator
    d[__WEBPACK_IMPORTED_MODULE_0__Constants__["k" /* strShimPrototype */]] = b === null ? Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["b" /* objCreateFn */])(b) : (__[__WEBPACK_IMPORTED_MODULE_0__Constants__["k" /* strShimPrototype */]] = b[__WEBPACK_IMPORTED_MODULE_0__Constants__["k" /* strShimPrototype */]], new __());
}
function __restFn(s, e) {
    var t = {};
    for (var k in s) {
        if (__WEBPACK_IMPORTED_MODULE_0__Constants__["e" /* ObjHasOwnProperty */].call(s, k) && e.indexOf(k) < 0) {
            t[k] = s[k];
        }
    }
    if (s != null && typeof __WEBPACK_IMPORTED_MODULE_0__Constants__["b" /* ObjClass */][strGetOwnPropertySymbols] === __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */]) {
        for (var i = 0, p = __WEBPACK_IMPORTED_MODULE_0__Constants__["b" /* ObjClass */][strGetOwnPropertySymbols](s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && __WEBPACK_IMPORTED_MODULE_0__Constants__["f" /* ObjProto */]["propertyIsEnumerable"].call(s, p[i])) {
                t[p[i]] = s[p[i]];
            }
        }
    }
    return t;
}
function __decorateFn(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = __WEBPACK_IMPORTED_MODULE_0__Constants__["b" /* ObjClass */]["getOwnPropertyDescriptor"](target, key) : desc, d;
    if (__hasReflect && typeof ReflectObj[strDecorate] === __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */]) {
        r = ReflectObj[strDecorate](decorators, target, key, desc);
    }
    else {
        for (var i = decorators.length - 1; i >= 0; i--) {
            // tslint:disable-next-line:no-conditional-assignment
            if (d = decorators[i]) {
                r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
            }
        }
    }
    // tslint:disable-next-line:ban-comma-operator
    return c > 3 && r && Object(__WEBPACK_IMPORTED_MODULE_0__Constants__["d" /* ObjDefineProperty */])(target, key, r), r;
}
function __paramFn(paramIndex, decorator) {
    return function (target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadataFn(metadataKey, metadataValue) {
    if (__hasReflect && ReflectObj[strMetadata] === __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */]) {
        return ReflectObj[strMetadata](metadataKey, metadataValue);
    }
}
function __exportStarFn(m, o) {
    for (var p in m) {
        if (p !== __WEBPACK_IMPORTED_MODULE_0__Constants__["g" /* strDefault */] && !__WEBPACK_IMPORTED_MODULE_0__Constants__["e" /* ObjHasOwnProperty */].call(o, p)) {
            __createBindingFn(o, m, p);
        }
    }
}
function __createBindingFn(o, m, k, k2) {
    if (k2 === undefined) {
        k2 = k;
    }
    if (__WEBPACK_IMPORTED_MODULE_0__Constants__["c" /* ObjCreate */]) {
        Object(__WEBPACK_IMPORTED_MODULE_0__Constants__["d" /* ObjDefineProperty */])(o, k2, {
            enumerable: true,
            get: function () {
                return m[k];
            }
        });
    }
    else {
        o[k2] = m[k];
    }
}
function __valuesFn(o) {
    var s = typeof SymbolObj === __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */] && SymbolObj[strIterator], m = s && o[s], i = 0;
    if (m) {
        return m.call(o);
    }
    if (o && typeof o.length === "number") {
        return {
            next: function () {
                if (o && i >= o.length) {
                    o = void 0;
                }
                return { value: o && o[i++], done: !o };
            }
        };
    }
    Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["c" /* throwTypeError */])(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __readFn(o, n) {
    var m = typeof SymbolObj === __WEBPACK_IMPORTED_MODULE_0__Constants__["h" /* strShimFunction */] && o[SymbolObj[strIterator]];
    if (!m) {
        return o;
    }
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
            ar.push(r.value);
        }
    }
    catch (error) {
        e = {
            error: error
        };
    }
    finally {
        try {
            // tslint:disable-next-line:no-conditional-assignment
            if (r && !r.done && (m = i["return"])) {
                m.call(i);
            }
        }
        finally {
            if (e) {
                // tslint:disable-next-line:no-unsafe-finally
                throw e.error;
            }
        }
    }
    return ar;
}
/** @deprecated */
function __spreadArraysFn() {
    var theArgs = arguments;
    // Calculate new total size
    for (var s = 0, i = 0, il = theArgs.length; i < il; i++) {
        s += theArgs[i].length;
    }
    // Create new full array
    for (var r = Array(s), k = 0, i = 0; i < il; i++) {
        for (var a = theArgs[i], j = 0, jl = a.length; j < jl; j++, k++) {
            r[k] = a[j];
        }
    }
    return r;
}
function __spreadArrayFn(to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) {
        to[j] = from[i];
    }
    return to;
}
function __makeTemplateObjectFn(cooked, raw) {
    if (__WEBPACK_IMPORTED_MODULE_0__Constants__["d" /* ObjDefineProperty */]) {
        Object(__WEBPACK_IMPORTED_MODULE_0__Constants__["d" /* ObjDefineProperty */])(cooked, "raw", { value: raw });
    }
    else {
        cooked.raw = raw;
    }
    return cooked;
}
;
function __importStarFn(mod) {
    if (mod && mod.__esModule) {
        return mod;
    }
    var result = {};
    if (mod != null) {
        for (var k in mod) {
            if (k !== __WEBPACK_IMPORTED_MODULE_0__Constants__["g" /* strDefault */] && Object.prototype.hasOwnProperty.call(mod, k)) {
                __createBindingFn(result, mod, k);
            }
        }
    }
    // Set default module
    if (__WEBPACK_IMPORTED_MODULE_0__Constants__["c" /* ObjCreate */]) {
        Object(__WEBPACK_IMPORTED_MODULE_0__Constants__["d" /* ObjDefineProperty */])(result, __WEBPACK_IMPORTED_MODULE_0__Constants__["g" /* strDefault */], { enumerable: true, value: mod });
    }
    else {
        result[__WEBPACK_IMPORTED_MODULE_0__Constants__["g" /* strDefault */]] = mod;
    }
    return result;
}
;
function __importDefaultFn(mod) {
    return (mod && mod.__esModule) ? mod : { strDefault: mod };
}
//# sourceMappingURL=TsLibShims.js.map

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseCore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChannelController__ = __webpack_require__(1381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProcessTelemetryContext__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TelemetryHelpers__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PerfManager__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CookieMgr__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__HelperFuncs__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Constants__ = __webpack_require__(357);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */












var validationError = "Extensions must provide callback to initialize";
var strNotificationManager = "_notificationManager";
var BaseCore = /** @class */ (function () {
    function BaseCore() {
        var _isInitialized = false;
        var _eventQueue;
        var _channelController;
        var _notificationManager;
        var _perfManager;
        var _cookieManager;
        Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__["a" /* default */])(BaseCore, this, function (_self) {
            _self._extensions = new Array();
            _channelController = new __WEBPACK_IMPORTED_MODULE_2__ChannelController__["a" /* ChannelController */]();
            _self.logger = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["i" /* objCreateFn */])({
                throwInternal: function (severity, msgId, msg, properties, isUserAct) {
                    if (isUserAct === void 0) { isUserAct = false; }
                },
                warnToConsole: function (message) { },
                resetInternalMessageCount: function () { }
            });
            _eventQueue = [];
            _self.isInitialized = function () { return _isInitialized; };
            _self.initialize = function (config, extensions, logger, notificationManager) {
                // Make sure core is only initialized once
                if (_self.isInitialized()) {
                    Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["H" /* throwError */])("Core should not be initialized more than once");
                }
                if (!config || Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["s" /* isNullOrUndefined */])(config.instrumentationKey)) {
                    Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["H" /* throwError */])("Please provide instrumentation key");
                }
                _notificationManager = notificationManager;
                // For backward compatibility only
                _self[strNotificationManager] = notificationManager;
                _self.config = config || {};
                config.extensions = Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["s" /* isNullOrUndefined */])(config.extensions) ? [] : config.extensions;
                // add notification to the extensions in the config so other plugins can access it
                var extConfig = Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["j" /* getSetValue */])(config, __WEBPACK_IMPORTED_MODULE_8__Constants__["a" /* strExtensionConfig */]);
                extConfig.NotificationManager = notificationManager;
                if (logger) {
                    _self.logger = logger;
                }
                // Concat all available extensions
                var allExtensions = [];
                allExtensions.push.apply(allExtensions, extensions.concat(config.extensions));
                allExtensions = Object(__WEBPACK_IMPORTED_MODULE_4__TelemetryHelpers__["b" /* sortPlugins */])(allExtensions);
                var coreExtensions = [];
                var channelExtensions = [];
                // Check if any two extensions have the same priority, then warn to console
                // And extract the local extensions from the 
                var extPriorities = {};
                // Extension validation
                Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["a" /* arrForEach */])(allExtensions, function (ext) {
                    if (Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["s" /* isNullOrUndefined */])(ext) || Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["s" /* isNullOrUndefined */])(ext.initialize)) {
                        Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["H" /* throwError */])(validationError);
                    }
                    var extPriority = ext.priority;
                    var identifier = ext.identifier;
                    if (ext && extPriority) {
                        if (!Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["s" /* isNullOrUndefined */])(extPriorities[extPriority])) {
                            logger.warnToConsole("Two extensions have same priority #" + extPriority + " - " + extPriorities[extPriority] + ", " + identifier);
                        }
                        else {
                            // set a value
                            extPriorities[extPriority] = identifier;
                        }
                    }
                    // Split extensions to core and channelController
                    if (!extPriority || extPriority < _channelController.priority) {
                        // Add to core extension that will be managed by BaseCore
                        coreExtensions.push(ext);
                    }
                    else {
                        // Add all other extensions to be managed by the channel controller
                        channelExtensions.push(ext);
                    }
                });
                // Validation complete
                // Add the channelController to the complete extension collection and
                // to the end of the core extensions
                allExtensions.push(_channelController);
                coreExtensions.push(_channelController);
                // Sort the complete set of extensions by priority
                allExtensions = Object(__WEBPACK_IMPORTED_MODULE_4__TelemetryHelpers__["b" /* sortPlugins */])(allExtensions);
                _self._extensions = allExtensions;
                // initialize channel controller first, this will initialize all channel plugins
                Object(__WEBPACK_IMPORTED_MODULE_4__TelemetryHelpers__["a" /* initializePlugins */])(new __WEBPACK_IMPORTED_MODULE_3__ProcessTelemetryContext__["a" /* ProcessTelemetryContext */]([_channelController], config, _self), allExtensions);
                Object(__WEBPACK_IMPORTED_MODULE_4__TelemetryHelpers__["a" /* initializePlugins */])(new __WEBPACK_IMPORTED_MODULE_3__ProcessTelemetryContext__["a" /* ProcessTelemetryContext */](coreExtensions, config, _self), allExtensions);
                // Now reset the extensions to just those being managed by Basecore
                _self._extensions = coreExtensions;
                if (_self.getTransmissionControls().length === 0) {
                    Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["H" /* throwError */])("No channels available");
                }
                _isInitialized = true;
                _self.releaseQueue();
            };
            _self.getTransmissionControls = function () {
                return _channelController.getChannelControls();
            };
            _self.track = function (telemetryItem) {
                // setup default iKey if not passed in
                Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["D" /* setValue */])(telemetryItem, __WEBPACK_IMPORTED_MODULE_8__Constants__["b" /* strIKey */], _self.config.instrumentationKey, null, __WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["r" /* isNotTruthy */]);
                // add default timestamp if not passed in
                Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["D" /* setValue */])(telemetryItem, "time", Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["I" /* toISOString */])(new Date()), null, __WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["r" /* isNotTruthy */]);
                // Common Schema 4.0
                Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["D" /* setValue */])(telemetryItem, "ver", "4.0", null, __WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["s" /* isNullOrUndefined */]);
                if (_self.isInitialized()) {
                    // Process the telemetry plugin chain
                    _self.getProcessTelContext().processNext(telemetryItem);
                }
                else {
                    // Queue events until all extensions are initialized
                    _eventQueue.push(telemetryItem);
                }
            };
            _self.getProcessTelContext = function () {
                var extensions = _self._extensions;
                var thePlugins = extensions;
                // invoke any common telemetry processors before sending through pipeline
                if (!extensions || extensions.length === 0) {
                    // Pass to Channel controller so data is sent to correct channel queues
                    thePlugins = [_channelController];
                }
                return new __WEBPACK_IMPORTED_MODULE_3__ProcessTelemetryContext__["a" /* ProcessTelemetryContext */](thePlugins, _self.config, _self);
            };
            _self.getNotifyMgr = function () {
                if (!_notificationManager) {
                    // Create Dummy notification manager
                    _notificationManager = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["i" /* objCreateFn */])({
                        addNotificationListener: function (listener) { },
                        removeNotificationListener: function (listener) { },
                        eventsSent: function (events) { },
                        eventsDiscarded: function (events, reason) { },
                        eventsSendRequest: function (sendReason, isAsync) { }
                    });
                    // For backward compatibility only
                    _self[strNotificationManager] = _notificationManager;
                }
                return _notificationManager;
            };
            _self.getCookieMgr = function () {
                if (!_cookieManager) {
                    _cookieManager = Object(__WEBPACK_IMPORTED_MODULE_6__CookieMgr__["b" /* createCookieMgr */])(_self.config, _self.logger);
                }
                return _cookieManager;
            };
            _self.setCookieMgr = function (cookieMgr) {
                _cookieManager = cookieMgr;
            };
            _self.getPerfMgr = function () {
                if (!_perfManager) {
                    if (_self.config && _self.config.enablePerfMgr) {
                        _perfManager = new __WEBPACK_IMPORTED_MODULE_5__PerfManager__["a" /* PerfManager */](_self.getNotifyMgr());
                    }
                }
                return _perfManager;
            };
            _self.setPerfMgr = function (perfMgr) {
                _perfManager = perfMgr;
            };
            _self.eventCnt = function () {
                return _eventQueue.length;
            };
            _self.releaseQueue = function () {
                if (_eventQueue.length > 0) {
                    Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["a" /* arrForEach */])(_eventQueue, function (event) {
                        _self.getProcessTelContext().processNext(event);
                    });
                    _eventQueue = [];
                }
            };
        });
    }
// Removed Stub for BaseCore.prototype.initialize.
// Removed Stub for BaseCore.prototype.getTransmissionControls.
// Removed Stub for BaseCore.prototype.track.
// Removed Stub for BaseCore.prototype.getProcessTelContext.
// Removed Stub for BaseCore.prototype.getNotifyMgr.
// Removed Stub for BaseCore.prototype.getCookieMgr.
// Removed Stub for BaseCore.prototype.setCookieMgr.
// Removed Stub for BaseCore.prototype.getPerfMgr.
// Removed Stub for BaseCore.prototype.setPerfMgr.
// Removed Stub for BaseCore.prototype.eventCnt.
// Removed Stub for BaseCore.prototype.releaseQueue.
    return BaseCore;
}());

//# sourceMappingURL=BaseCore.js.map

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseTelemetryPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProcessTelemetryContext__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HelperFuncs__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Constants__ = __webpack_require__(357);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var strGetPlugin = "getPlugin";
/**
 * BaseTelemetryPlugin provides a basic implementation of the ITelemetryPlugin interface so that plugins
 * can avoid implementation the same set of boiler plate code as well as provide a base
 * implementation so that new default implementations can be added without breaking all plugins.
 */
var BaseTelemetryPlugin = /** @class */ (function () {
    function BaseTelemetryPlugin() {
        var _self = this;
        var _isinitialized = false;
        var _rootCtx = null; // Used as the root context, holding the current config and initialized core
        var _nextPlugin = null; // Used for backward compatibility where plugins don't call the main pipeline
        _self.core = null;
        _self.diagLog = function (itemCtx) {
            return _self._getTelCtx(itemCtx).diagLog();
        };
        _self.isInitialized = function () {
            return _isinitialized;
        };
        _self.setInitialized = function (isInitialized) {
            _isinitialized = isInitialized;
        };
        // _self.getNextPlugin = () => DO NOT IMPLEMENT
        // Sub-classes of this base class *should* not be relying on this value and instead
        // should use processNext() function. If you require access to the plugin use the
        // IProcessTelemetryContext.getNext().getPlugin() while in the pipeline, Note getNext() may return null.
        _self.setNextPlugin = function (next) {
            _nextPlugin = next;
        };
        _self.processNext = function (env, itemCtx) {
            if (itemCtx) {
                // Normal core execution sequence
                itemCtx.processNext(env);
            }
            else if (_nextPlugin && Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["p" /* isFunction */])(_nextPlugin.processTelemetry)) {
                // Looks like backward compatibility or out of band processing. And as it looks 
                // like a ITelemetryPlugin or ITelemetryPluginChain, just call processTelemetry
                _nextPlugin.processTelemetry(env, null);
            }
        };
        _self._getTelCtx = function (currentCtx) {
            if (currentCtx === void 0) { currentCtx = null; }
            var itemCtx = currentCtx;
            if (!itemCtx) {
                var rootCtx = _rootCtx || new __WEBPACK_IMPORTED_MODULE_0__ProcessTelemetryContext__["a" /* ProcessTelemetryContext */](null, {}, _self.core);
                // tslint:disable-next-line: prefer-conditional-expression
                if (_nextPlugin && _nextPlugin[strGetPlugin]) {
                    // Looks like a chain object
                    itemCtx = rootCtx.createNew(null, _nextPlugin[strGetPlugin]);
                }
                else {
                    itemCtx = rootCtx.createNew(null, _nextPlugin);
                }
            }
            return itemCtx;
        };
        _self._baseTelInit = function (config, core, extensions, pluginChain) {
            if (config) {
                // Make sure the extensionConfig exists
                Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["D" /* setValue */])(config, __WEBPACK_IMPORTED_MODULE_2__Constants__["a" /* strExtensionConfig */], [], null, __WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["s" /* isNullOrUndefined */]);
            }
            if (!pluginChain && core) {
                // Get the first plugin from the core
                pluginChain = core.getProcessTelContext().getNext();
            }
            var nextPlugin = _nextPlugin;
            if (_nextPlugin && _nextPlugin[strGetPlugin]) {
                // If it looks like a proxy/chain then get the plugin
                nextPlugin = _nextPlugin[strGetPlugin]();
            }
            // Support legacy plugins where core was defined as a property
            _self.core = core;
            _rootCtx = new __WEBPACK_IMPORTED_MODULE_0__ProcessTelemetryContext__["a" /* ProcessTelemetryContext */](pluginChain, config, core, nextPlugin);
            _isinitialized = true;
        };
    }
    BaseTelemetryPlugin.prototype.initialize = function (config, core, extensions, pluginChain) {
        this._baseTelInit(config, core, extensions, pluginChain);
    };
    return BaseTelemetryPlugin;
}());

//# sourceMappingURL=BaseTelemetryPlugin.js.map

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NotificationManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HelperFuncs__ = __webpack_require__(40);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * Class to manage sending notifications to all the listeners.
 */
var NotificationManager = /** @class */ (function () {
    function NotificationManager(config) {
        this.listeners = [];
        var perfEvtsSendAll = !!(config || {}).perfEvtsSendAll;
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__["a" /* default */])(NotificationManager, this, function (_self) {
            _self.addNotificationListener = function (listener) {
                _self.listeners.push(listener);
            };
            /**
             * Removes all instances of the listener.
             * @param {INotificationListener} listener - AWTNotificationListener to remove.
             */
            _self.removeNotificationListener = function (listener) {
                var index = Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["b" /* arrIndexOf */])(_self.listeners, listener);
                while (index > -1) {
                    _self.listeners.splice(index, 1);
                    index = Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["b" /* arrIndexOf */])(_self.listeners, listener);
                }
            };
            /**
             * Notification for events sent.
             * @param {ITelemetryItem[]} events - The array of events that have been sent.
             */
            _self.eventsSent = function (events) {
                Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["a" /* arrForEach */])(_self.listeners, function (listener) {
                    if (listener && listener.eventsSent) {
                        setTimeout(function () { return listener.eventsSent(events); }, 0);
                    }
                });
            };
            /**
             * Notification for events being discarded.
             * @param {ITelemetryItem[]} events - The array of events that have been discarded by the SDK.
             * @param {number} reason           - The reason for which the SDK discarded the events. The EventsDiscardedReason
             * constant should be used to check the different values.
             */
            _self.eventsDiscarded = function (events, reason) {
                Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["a" /* arrForEach */])(_self.listeners, function (listener) {
                    if (listener && listener.eventsDiscarded) {
                        setTimeout(function () { return listener.eventsDiscarded(events, reason); }, 0);
                    }
                });
            };
            /**
             * [Optional] A function called when the events have been requested to be sent to the sever.
             * @param {number} sendReason - The reason why the event batch is being sent.
             * @param {boolean} isAsync   - A flag which identifies whether the requests are being sent in an async or sync manner.
             */
            _self.eventsSendRequest = function (sendReason, isAsync) {
                Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["a" /* arrForEach */])(_self.listeners, function (listener) {
                    if (listener && listener.eventsSendRequest) {
                        if (isAsync) {
                            setTimeout(function () { return listener.eventsSendRequest(sendReason, isAsync); }, 0);
                        }
                        else {
                            try {
                                listener.eventsSendRequest(sendReason, isAsync);
                            }
                            catch (e) {
                                // Catch errors to ensure we don't block sending the requests
                            }
                        }
                    }
                });
            };
            _self.perfEvent = function (perfEvent) {
                if (perfEvent) {
                    // Send all events or only parent events
                    if (perfEvtsSendAll || !perfEvent.isChildEvt()) {
                        Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["a" /* arrForEach */])(_self.listeners, function (listener) {
                            if (listener && listener.perfEvent) {
                                if (perfEvent.isAsync) {
                                    setTimeout(function () { return listener.perfEvent(perfEvent); }, 0);
                                }
                                else {
                                    try {
                                        listener.perfEvent(perfEvent);
                                    }
                                    catch (e) {
                                        // Catch errors to ensure we don't block sending the requests
                                    }
                                }
                            }
                        });
                    }
                }
            };
        });
    }
// Removed Stub for NotificationManager.prototype.addNotificationListener.
// Removed Stub for NotificationManager.prototype.removeNotificationListener.
// Removed Stub for NotificationManager.prototype.eventsSent.
// Removed Stub for NotificationManager.prototype.eventsDiscarded.
// Removed Stub for NotificationManager.prototype.eventsSendRequest.
    return NotificationManager;
}());

//# sourceMappingURL=NotificationManager.js.map

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = randomValue;
/* harmony export (immutable) */ __webpack_exports__["c"] = random32;
/* harmony export (immutable) */ __webpack_exports__["b"] = mwcRandomSeed;
/* harmony export (immutable) */ __webpack_exports__["a"] = mwcRandom32;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EnvUtils__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HelperFuncs__ = __webpack_require__(40);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var UInt32Mask = 0x100000000;
var MaxUInt32 = 0xffffffff;
// MWC based Random generator (for IE)
var _mwcSeeded = false;
var _mwcW = 123456789;
var _mwcZ = 987654321;
// Takes any integer
function _mwcSeed(seedValue) {
    if (seedValue < 0) {
        // Make sure we end up with a positive number and not -ve one.
        seedValue >>>= 0;
    }
    _mwcW = (123456789 + seedValue) & MaxUInt32;
    _mwcZ = (987654321 - seedValue) & MaxUInt32;
    _mwcSeeded = true;
}
function _autoSeedMwc() {
    // Simple initialization using default Math.random() - So we inherit any entropy from the browser
    // and bitwise XOR with the current milliseconds
    try {
        var now = Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["g" /* dateNow */])() & 0x7fffffff;
        _mwcSeed(((Math.random() * UInt32Mask) ^ now) + now);
    }
    catch (e) {
        // Don't crash if something goes wrong
    }
}
/**
 * Generate a random value between 0 and maxValue, max value should be limited to a 32-bit maximum.
 * So maxValue(16) will produce a number from 0..16 (range of 17)
 * @param maxValue
 */
function randomValue(maxValue) {
    if (maxValue > 0) {
        return Math.floor((random32() / MaxUInt32) * (maxValue + 1)) >>> 0;
    }
    return 0;
}
/**
 * generate a random 32-bit number (0x000000..0xFFFFFFFF) or (-0x80000000..0x7FFFFFFF), defaults un-unsigned.
 * @param signed - True to return a signed 32-bit number (-0x80000000..0x7FFFFFFF) otherwise an unsigned one (0x000000..0xFFFFFFFF)
 */
function random32(signed) {
    var value;
    var c = Object(__WEBPACK_IMPORTED_MODULE_0__EnvUtils__["c" /* getCrypto */])() || Object(__WEBPACK_IMPORTED_MODULE_0__EnvUtils__["i" /* getMsCrypto */])();
    if (c && c.getRandomValues) {
        // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
        value = c.getRandomValues(new Uint32Array(1))[0] & MaxUInt32;
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_0__EnvUtils__["p" /* isIE */])()) {
        // For IE 6, 7, 8 (especially on XP) Math.random is not very random
        if (!_mwcSeeded) {
            // Set the seed for the Mwc algorithm
            _autoSeedMwc();
        }
        // Don't use Math.random for IE
        // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
        value = mwcRandom32() & MaxUInt32;
    }
    else {
        // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
        value = Math.floor((UInt32Mask * Math.random()) | 0);
    }
    if (!signed) {
        // Make sure we end up with a positive number and not -ve one.
        value >>>= 0;
    }
    return value;
}
/**
 * Seed the MWC random number generator with the specified seed or a random value
 * @param value - optional the number to used as the seed, if undefined, null or zero a random value will be chosen
 */
function mwcRandomSeed(value) {
    if (!value) {
        _autoSeedMwc();
    }
    else {
        _mwcSeed(value);
    }
}
/**
 * Generate a random 32-bit number between (0x000000..0xFFFFFFFF) or (-0x80000000..0x7FFFFFFF), using MWC (Multiply with carry)
 * instead of Math.random() defaults to un-signed.
 * Used as a replacement random generator for IE to avoid issues with older IE instances.
 * @param signed - True to return a signed 32-bit number (-0x80000000..0x7FFFFFFF) otherwise an unsigned one (0x000000..0xFFFFFFFF)
 */
function mwcRandom32(signed) {
    _mwcZ = (36969 * (_mwcZ & 0xFFFF) + (_mwcZ >> 16)) & MaxUInt32;
    _mwcW = (18000 * (_mwcW & 0xFFFF) + (_mwcW >> 16)) & MaxUInt32;
    var value = (((_mwcZ << 16) + (_mwcW & 0xFFFF)) >>> 0) & MaxUInt32 | 0;
    if (!signed) {
        // Make sure we end up with a positive number and not -ve one.
        value >>>= 0;
    }
    return value;
}
//# sourceMappingURL=RandomHelper.js.map

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_ApplicationInsights__ = __webpack_require__(1385);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_ApplicationInsights__["a"]; });
/*
 * Application Insights JavaScript SDK - Web Analytics, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



//# sourceMappingURL=applicationinsights-analytics-js.js.map

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isInternalApplicationInsightsEndpoint */
/* unused harmony export Util */
/* unused harmony export UrlHelper */
/* unused harmony export CorrelationIdHelper */
/* harmony export (immutable) */ __webpack_exports__["a"] = AjaxHelperParseDependencyPath;
/* unused harmony export dateTimeUtilsNow */
/* harmony export (immutable) */ __webpack_exports__["b"] = dateTimeUtilsDuration;
/* unused harmony export DateTimeUtils */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RequestResponseHeaders__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Telemetry_Common_DataSanitizer__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DomHelperFuncs__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HelperFuncs__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Constants__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__ = __webpack_require__(556);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */










// listing only non-geo specific locations
var _internalEndpoints = [
    "https://dc.services.visualstudio.com/v2/track",
    "https://breeze.aimon.applicationinsights.io/v2/track",
    "https://dc-int.services.visualstudio.com/v2/track"
];
function isInternalApplicationInsightsEndpoint(endpointUrl) {
    return _internalEndpoints.indexOf(endpointUrl.toLowerCase()) !== -1;
}
var Util = {
    NotSpecified: __WEBPACK_IMPORTED_MODULE_5__Constants__["b" /* strNotSpecified */],
    createDomEvent: __WEBPACK_IMPORTED_MODULE_3__DomHelperFuncs__["a" /* createDomEvent */],
    disableStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["c" /* utlDisableStorage */],
    isInternalApplicationInsightsEndpoint: isInternalApplicationInsightsEndpoint,
    canUseLocalStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["a" /* utlCanUseLocalStorage */],
    getStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["d" /* utlGetLocalStorage */],
    setStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["i" /* utlSetLocalStorage */],
    removeStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["h" /* utlRemoveStorage */],
    canUseSessionStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["b" /* utlCanUseSessionStorage */],
    getSessionStorageKeys: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["f" /* utlGetSessionStorageKeys */],
    getSessionStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["e" /* utlGetSessionStorage */],
    setSessionStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["j" /* utlSetSessionStorage */],
    removeSessionStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["g" /* utlRemoveSessionStorage */],
    disableCookies: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["l" /* disableCookies */],
    canUseCookies: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["h" /* canUseCookies */],
    disallowsSameSiteNone: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["S" /* uaDisallowsSameSiteNone */],
    setCookie: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["O" /* setCookie */],
    stringToBoolOrDefault: __WEBPACK_IMPORTED_MODULE_4__HelperFuncs__["e" /* stringToBoolOrDefault */],
    getCookie: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["p" /* getCookie */],
    deleteCookie: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["k" /* deleteCookie */],
    trim: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["P" /* strTrim */],
    newId: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["J" /* newId */],
    random32: function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["M" /* random32 */])(true);
    },
    generateW3CId: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["o" /* generateW3CId */],
    isArray: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["C" /* isArray */],
    isError: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["E" /* isError */],
    isDate: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["D" /* isDate */],
    toISOStringForIE8: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["R" /* toISOString */],
    getIEVersion: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["v" /* getIEVersion */],
    msToTimeSpan: __WEBPACK_IMPORTED_MODULE_4__HelperFuncs__["d" /* msToTimeSpan */],
    isCrossOriginError: __WEBPACK_IMPORTED_MODULE_4__HelperFuncs__["c" /* isCrossOriginError */],
    dump: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["n" /* dumpObj */],
    getExceptionName: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["r" /* getExceptionName */],
    addEventHandler: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["g" /* attachEvent */],
    IsBeaconApiSupported: __WEBPACK_IMPORTED_MODULE_4__HelperFuncs__["b" /* isBeaconApiSupported */],
    getExtension: __WEBPACK_IMPORTED_MODULE_4__HelperFuncs__["a" /* getExtensionByName */]
};
;
var UrlHelper = {
    parseUrl: __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["f" /* urlParseUrl */],
    getAbsoluteUrl: __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["a" /* urlGetAbsoluteUrl */],
    getPathName: __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["c" /* urlGetPathName */],
    getCompleteUrl: __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["b" /* urlGetCompleteUrl */],
    parseHost: __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["e" /* urlParseHost */],
    parseFullHost: __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["d" /* urlParseFullHost */]
};
var CorrelationIdHelper = {
    correlationIdPrefix: "cid-v1:",
    /**
     * Checks if a request url is not on a excluded domain list and if it is safe to add correlation headers.
     * Headers are always included if the current domain matches the request domain. If they do not match (CORS),
     * they are regex-ed across correlationHeaderDomains and correlationHeaderExcludedDomains to determine if headers are included.
     * Some environments don't give information on currentHost via window.location.host (e.g. Cordova). In these cases, the user must
     * manually supply domains to include correlation headers on. Else, no headers will be included at all.
     */
    canIncludeCorrelationHeader: function (config, requestUrl, currentHost) {
        if (!requestUrl || (config && config.disableCorrelationHeaders)) {
            return false;
        }
        if (config && config.correlationHeaderExcludePatterns) {
            for (var i = 0; i < config.correlationHeaderExcludePatterns.length; i++) {
                if (config.correlationHeaderExcludePatterns[i].test(requestUrl)) {
                    return false;
                }
            }
        }
        var requestHost = Object(__WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["f" /* urlParseUrl */])(requestUrl).host.toLowerCase();
        if (requestHost && (requestHost.indexOf(":443") !== -1 || requestHost.indexOf(":80") !== -1)) {
            // [Bug #1260] IE can include the port even for http and https URLs so if present 
            // try and parse it to remove if it matches the default protocol port
            requestHost = (Object(__WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["d" /* urlParseFullHost */])(requestUrl, true) || "").toLowerCase();
        }
        if ((!config || !config.enableCorsCorrelation) && requestHost !== currentHost) {
            return false;
        }
        var includedDomains = config && config.correlationHeaderDomains;
        if (includedDomains) {
            var matchExists_1;
            Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["d" /* arrForEach */])(includedDomains, function (domain) {
                var regex = new RegExp(domain.toLowerCase().replace(/\./g, "\.").replace(/\*/g, ".*"));
                matchExists_1 = matchExists_1 || regex.test(requestHost);
            });
            if (!matchExists_1) {
                return false;
            }
        }
        var excludedDomains = config && config.correlationHeaderExcludedDomains;
        if (!excludedDomains || excludedDomains.length === 0) {
            return true;
        }
        for (var i = 0; i < excludedDomains.length; i++) {
            var regex = new RegExp(excludedDomains[i].toLowerCase().replace(/\./g, "\.").replace(/\*/g, ".*"));
            if (regex.test(requestHost)) {
                return false;
            }
        }
        // if we don't know anything about the requestHost, require the user to use included/excludedDomains.
        // Previously we always returned false for a falsy requestHost
        return requestHost && requestHost.length > 0;
    },
    /**
     * Combines target appId and target role name from response header.
     */
    getCorrelationContext: function (responseHeader) {
        if (responseHeader) {
            var correlationId = CorrelationIdHelper.getCorrelationContextValue(responseHeader, __WEBPACK_IMPORTED_MODULE_1__RequestResponseHeaders__["a" /* RequestHeaders */].requestContextTargetKey);
            if (correlationId && correlationId !== CorrelationIdHelper.correlationIdPrefix) {
                return correlationId;
            }
        }
    },
    /**
     * Gets key from correlation response header
     */
    getCorrelationContextValue: function (responseHeader, key) {
        if (responseHeader) {
            var keyValues = responseHeader.split(",");
            for (var i = 0; i < keyValues.length; ++i) {
                var keyValue = keyValues[i].split("=");
                if (keyValue.length === 2 && keyValue[0] === key) {
                    return keyValue[1];
                }
            }
        }
    }
};
function AjaxHelperParseDependencyPath(logger, absoluteUrl, method, commandName) {
    var target, name = commandName, data = commandName;
    if (absoluteUrl && absoluteUrl.length > 0) {
        var parsedUrl = Object(__WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["f" /* urlParseUrl */])(absoluteUrl);
        target = parsedUrl.host;
        if (!name) {
            if (parsedUrl.pathname != null) {
                var pathName = (parsedUrl.pathname.length === 0) ? "/" : parsedUrl.pathname;
                if (pathName.charAt(0) !== '/') {
                    pathName = "/" + pathName;
                }
                data = parsedUrl.pathname;
                name = Object(__WEBPACK_IMPORTED_MODULE_2__Telemetry_Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, method ? method + " " + pathName : pathName);
            }
            else {
                name = Object(__WEBPACK_IMPORTED_MODULE_2__Telemetry_Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, absoluteUrl);
            }
        }
    }
    else {
        target = commandName;
        name = commandName;
    }
    return {
        target: target,
        name: name,
        data: data
    };
}
function dateTimeUtilsNow() {
    // returns the window or webworker performance object
    var perf = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["z" /* getPerformance */])();
    if (perf && perf.now && perf.timing) {
        var now = perf.now() + perf.timing.navigationStart;
        // Known issue with IE where this calculation can be negative, so if it is then ignore and fallback
        if (now > 0) {
            return now;
        }
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["j" /* dateNow */])();
}
function dateTimeUtilsDuration(start, end) {
    var result = null;
    if (start !== 0 && end !== 0 && !Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(start) && !Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(end)) {
        result = end - start;
    }
    return result;
}
/**
 * A utility class that helps getting time related parameters
 */
var DateTimeUtils = {
    Now: dateTimeUtilsNow,
    GetDuration: dateTimeUtilsDuration
};
//# sourceMappingURL=Util.js.map

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventsDiscardedReason; });
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * The EventsDiscardedReason enumeration contains a set of values that specify the reason for discarding an event.
 */
var EventsDiscardedReason = {
    /**
     * Unknown.
     */
    Unknown: 0,
    /**
     * Status set to non-retryable.
     */
    NonRetryableStatus: 1,
    /**
     * The event is invalid.
     */
    InvalidEvent: 2,
    /**
     * The size of the event is too large.
     */
    SizeLimitExceeded: 3,
    /**
     * The server is not accepting events from this instrumentation key.
     */
    KillSwitch: 4,
    /**
     * The event queue is full.
     */
    QueueFull: 5
};
//# sourceMappingURL=EventsDiscardedReason.js.map

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseCore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChannelController__ = __webpack_require__(1388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProcessTelemetryContext__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TelemetryHelpers__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PerfManager__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CookieMgr__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__HelperFuncs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Constants__ = __webpack_require__(361);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */












var validationError = "Extensions must provide callback to initialize";
var strNotificationManager = "_notificationManager";
var BaseCore = /** @class */ (function () {
    function BaseCore() {
        var _isInitialized = false;
        var _eventQueue;
        var _channelController;
        var _notificationManager;
        var _perfManager;
        var _cookieManager;
        Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__["a" /* default */])(BaseCore, this, function (_self) {
            _self._extensions = new Array();
            _channelController = new __WEBPACK_IMPORTED_MODULE_2__ChannelController__["a" /* ChannelController */]();
            _self.logger = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["i" /* objCreateFn */])({
                throwInternal: function (severity, msgId, msg, properties, isUserAct) {
                    if (isUserAct === void 0) { isUserAct = false; }
                },
                warnToConsole: function (message) { },
                resetInternalMessageCount: function () { }
            });
            _eventQueue = [];
            _self.isInitialized = function () { return _isInitialized; };
            _self.initialize = function (config, extensions, logger, notificationManager) {
                // Make sure core is only initialized once
                if (_self.isInitialized()) {
                    Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["G" /* throwError */])("Core should not be initialized more than once");
                }
                if (!config || Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["s" /* isNullOrUndefined */])(config.instrumentationKey)) {
                    Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["G" /* throwError */])("Please provide instrumentation key");
                }
                _notificationManager = notificationManager;
                // For backward compatibility only
                _self[strNotificationManager] = notificationManager;
                _self.config = config || {};
                config.extensions = Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["s" /* isNullOrUndefined */])(config.extensions) ? [] : config.extensions;
                // add notification to the extensions in the config so other plugins can access it
                var extConfig = Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["j" /* getSetValue */])(config, __WEBPACK_IMPORTED_MODULE_8__Constants__["a" /* strExtensionConfig */]);
                extConfig.NotificationManager = notificationManager;
                if (logger) {
                    _self.logger = logger;
                }
                // Concat all available extensions
                var allExtensions = [];
                allExtensions.push.apply(allExtensions, extensions.concat(config.extensions));
                allExtensions = Object(__WEBPACK_IMPORTED_MODULE_4__TelemetryHelpers__["b" /* sortPlugins */])(allExtensions);
                var coreExtensions = [];
                var channelExtensions = [];
                // Check if any two extensions have the same priority, then warn to console
                // And extract the local extensions from the 
                var extPriorities = {};
                // Extension validation
                Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["a" /* arrForEach */])(allExtensions, function (ext) {
                    if (Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["s" /* isNullOrUndefined */])(ext) || Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["s" /* isNullOrUndefined */])(ext.initialize)) {
                        Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["G" /* throwError */])(validationError);
                    }
                    var extPriority = ext.priority;
                    var identifier = ext.identifier;
                    if (ext && extPriority) {
                        if (!Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["s" /* isNullOrUndefined */])(extPriorities[extPriority])) {
                            logger.warnToConsole("Two extensions have same priority #" + extPriority + " - " + extPriorities[extPriority] + ", " + identifier);
                        }
                        else {
                            // set a value
                            extPriorities[extPriority] = identifier;
                        }
                    }
                    // Split extensions to core and channelController
                    if (!extPriority || extPriority < _channelController.priority) {
                        // Add to core extension that will be managed by BaseCore
                        coreExtensions.push(ext);
                    }
                    else {
                        // Add all other extensions to be managed by the channel controller
                        channelExtensions.push(ext);
                    }
                });
                // Validation complete
                // Add the channelController to the complete extension collection and
                // to the end of the core extensions
                allExtensions.push(_channelController);
                coreExtensions.push(_channelController);
                // Sort the complete set of extensions by priority
                allExtensions = Object(__WEBPACK_IMPORTED_MODULE_4__TelemetryHelpers__["b" /* sortPlugins */])(allExtensions);
                _self._extensions = allExtensions;
                // initialize channel controller first, this will initialize all channel plugins
                Object(__WEBPACK_IMPORTED_MODULE_4__TelemetryHelpers__["a" /* initializePlugins */])(new __WEBPACK_IMPORTED_MODULE_3__ProcessTelemetryContext__["a" /* ProcessTelemetryContext */]([_channelController], config, _self), allExtensions);
                Object(__WEBPACK_IMPORTED_MODULE_4__TelemetryHelpers__["a" /* initializePlugins */])(new __WEBPACK_IMPORTED_MODULE_3__ProcessTelemetryContext__["a" /* ProcessTelemetryContext */](coreExtensions, config, _self), allExtensions);
                // Now reset the extensions to just those being managed by Basecore
                _self._extensions = coreExtensions;
                if (_self.getTransmissionControls().length === 0) {
                    Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["G" /* throwError */])("No channels available");
                }
                _isInitialized = true;
                _self.releaseQueue();
            };
            _self.getTransmissionControls = function () {
                return _channelController.getChannelControls();
            };
            _self.track = function (telemetryItem) {
                // setup default iKey if not passed in
                Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["C" /* setValue */])(telemetryItem, __WEBPACK_IMPORTED_MODULE_8__Constants__["b" /* strIKey */], _self.config.instrumentationKey, null, __WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["r" /* isNotTruthy */]);
                // add default timestamp if not passed in
                Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["C" /* setValue */])(telemetryItem, "time", Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["H" /* toISOString */])(new Date()), null, __WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["r" /* isNotTruthy */]);
                // Common Schema 4.0
                Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["C" /* setValue */])(telemetryItem, "ver", "4.0", null, __WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["s" /* isNullOrUndefined */]);
                if (_self.isInitialized()) {
                    // Process the telemetry plugin chain
                    _self.getProcessTelContext().processNext(telemetryItem);
                }
                else {
                    // Queue events until all extensions are initialized
                    _eventQueue.push(telemetryItem);
                }
            };
            _self.getProcessTelContext = function () {
                var extensions = _self._extensions;
                var thePlugins = extensions;
                // invoke any common telemetry processors before sending through pipeline
                if (!extensions || extensions.length === 0) {
                    // Pass to Channel controller so data is sent to correct channel queues
                    thePlugins = [_channelController];
                }
                return new __WEBPACK_IMPORTED_MODULE_3__ProcessTelemetryContext__["a" /* ProcessTelemetryContext */](thePlugins, _self.config, _self);
            };
            _self.getNotifyMgr = function () {
                if (!_notificationManager) {
                    // Create Dummy notification manager
                    _notificationManager = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["i" /* objCreateFn */])({
                        addNotificationListener: function (listener) { },
                        removeNotificationListener: function (listener) { },
                        eventsSent: function (events) { },
                        eventsDiscarded: function (events, reason) { },
                        eventsSendRequest: function (sendReason, isAsync) { }
                    });
                    // For backward compatibility only
                    _self[strNotificationManager] = _notificationManager;
                }
                return _notificationManager;
            };
            _self.getCookieMgr = function () {
                if (!_cookieManager) {
                    _cookieManager = Object(__WEBPACK_IMPORTED_MODULE_6__CookieMgr__["b" /* createCookieMgr */])(_self.config, _self.logger);
                }
                return _cookieManager;
            };
            _self.setCookieMgr = function (cookieMgr) {
                _cookieManager = cookieMgr;
            };
            _self.getPerfMgr = function () {
                if (!_perfManager) {
                    if (_self.config && _self.config.enablePerfMgr) {
                        _perfManager = new __WEBPACK_IMPORTED_MODULE_5__PerfManager__["a" /* PerfManager */](_self.getNotifyMgr());
                    }
                }
                return _perfManager;
            };
            _self.setPerfMgr = function (perfMgr) {
                _perfManager = perfMgr;
            };
            _self.eventCnt = function () {
                return _eventQueue.length;
            };
            _self.releaseQueue = function () {
                if (_eventQueue.length > 0) {
                    Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["a" /* arrForEach */])(_eventQueue, function (event) {
                        _self.getProcessTelContext().processNext(event);
                    });
                    _eventQueue = [];
                }
            };
        });
    }
// Removed Stub for BaseCore.prototype.initialize.
// Removed Stub for BaseCore.prototype.getTransmissionControls.
// Removed Stub for BaseCore.prototype.track.
// Removed Stub for BaseCore.prototype.getProcessTelContext.
// Removed Stub for BaseCore.prototype.getNotifyMgr.
// Removed Stub for BaseCore.prototype.getCookieMgr.
// Removed Stub for BaseCore.prototype.setCookieMgr.
// Removed Stub for BaseCore.prototype.getPerfMgr.
// Removed Stub for BaseCore.prototype.setPerfMgr.
// Removed Stub for BaseCore.prototype.eventCnt.
// Removed Stub for BaseCore.prototype.releaseQueue.
    return BaseCore;
}());

//# sourceMappingURL=BaseCore.js.map

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseTelemetryPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProcessTelemetryContext__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HelperFuncs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Constants__ = __webpack_require__(361);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var strGetPlugin = "getPlugin";
/**
 * BaseTelemetryPlugin provides a basic implementation of the ITelemetryPlugin interface so that plugins
 * can avoid implementation the same set of boiler plate code as well as provide a base
 * implementation so that new default implementations can be added without breaking all plugins.
 */
var BaseTelemetryPlugin = /** @class */ (function () {
    function BaseTelemetryPlugin() {
        var _self = this;
        var _isinitialized = false;
        var _rootCtx = null; // Used as the root context, holding the current config and initialized core
        var _nextPlugin = null; // Used for backward compatibility where plugins don't call the main pipeline
        _self.core = null;
        _self.diagLog = function (itemCtx) {
            return _self._getTelCtx(itemCtx).diagLog();
        };
        _self.isInitialized = function () {
            return _isinitialized;
        };
        _self.setInitialized = function (isInitialized) {
            _isinitialized = isInitialized;
        };
        // _self.getNextPlugin = () => DO NOT IMPLEMENT
        // Sub-classes of this base class *should* not be relying on this value and instead
        // should use processNext() function. If you require access to the plugin use the
        // IProcessTelemetryContext.getNext().getPlugin() while in the pipeline, Note getNext() may return null.
        _self.setNextPlugin = function (next) {
            _nextPlugin = next;
        };
        _self.processNext = function (env, itemCtx) {
            if (itemCtx) {
                // Normal core execution sequence
                itemCtx.processNext(env);
            }
            else if (_nextPlugin && Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["p" /* isFunction */])(_nextPlugin.processTelemetry)) {
                // Looks like backward compatibility or out of band processing. And as it looks 
                // like a ITelemetryPlugin or ITelemetryPluginChain, just call processTelemetry
                _nextPlugin.processTelemetry(env, null);
            }
        };
        _self._getTelCtx = function (currentCtx) {
            if (currentCtx === void 0) { currentCtx = null; }
            var itemCtx = currentCtx;
            if (!itemCtx) {
                var rootCtx = _rootCtx || new __WEBPACK_IMPORTED_MODULE_0__ProcessTelemetryContext__["a" /* ProcessTelemetryContext */](null, {}, _self.core);
                // tslint:disable-next-line: prefer-conditional-expression
                if (_nextPlugin && _nextPlugin[strGetPlugin]) {
                    // Looks like a chain object
                    itemCtx = rootCtx.createNew(null, _nextPlugin[strGetPlugin]);
                }
                else {
                    itemCtx = rootCtx.createNew(null, _nextPlugin);
                }
            }
            return itemCtx;
        };
        _self._baseTelInit = function (config, core, extensions, pluginChain) {
            if (config) {
                // Make sure the extensionConfig exists
                Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["C" /* setValue */])(config, __WEBPACK_IMPORTED_MODULE_2__Constants__["a" /* strExtensionConfig */], [], null, __WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["s" /* isNullOrUndefined */]);
            }
            if (!pluginChain && core) {
                // Get the first plugin from the core
                pluginChain = core.getProcessTelContext().getNext();
            }
            var nextPlugin = _nextPlugin;
            if (_nextPlugin && _nextPlugin[strGetPlugin]) {
                // If it looks like a proxy/chain then get the plugin
                nextPlugin = _nextPlugin[strGetPlugin]();
            }
            // Support legacy plugins where core was defined as a property
            _self.core = core;
            _rootCtx = new __WEBPACK_IMPORTED_MODULE_0__ProcessTelemetryContext__["a" /* ProcessTelemetryContext */](pluginChain, config, core, nextPlugin);
            _isinitialized = true;
        };
    }
    BaseTelemetryPlugin.prototype.initialize = function (config, core, extensions, pluginChain) {
        this._baseTelInit(config, core, extensions, pluginChain);
    };
    return BaseTelemetryPlugin;
}());

//# sourceMappingURL=BaseTelemetryPlugin.js.map

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NotificationManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HelperFuncs__ = __webpack_require__(42);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * Class to manage sending notifications to all the listeners.
 */
var NotificationManager = /** @class */ (function () {
    function NotificationManager(config) {
        this.listeners = [];
        var perfEvtsSendAll = !!(config || {}).perfEvtsSendAll;
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__["a" /* default */])(NotificationManager, this, function (_self) {
            _self.addNotificationListener = function (listener) {
                _self.listeners.push(listener);
            };
            /**
             * Removes all instances of the listener.
             * @param {INotificationListener} listener - AWTNotificationListener to remove.
             */
            _self.removeNotificationListener = function (listener) {
                var index = Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["b" /* arrIndexOf */])(_self.listeners, listener);
                while (index > -1) {
                    _self.listeners.splice(index, 1);
                    index = Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["b" /* arrIndexOf */])(_self.listeners, listener);
                }
            };
            /**
             * Notification for events sent.
             * @param {ITelemetryItem[]} events - The array of events that have been sent.
             */
            _self.eventsSent = function (events) {
                Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["a" /* arrForEach */])(_self.listeners, function (listener) {
                    if (listener && listener.eventsSent) {
                        setTimeout(function () { return listener.eventsSent(events); }, 0);
                    }
                });
            };
            /**
             * Notification for events being discarded.
             * @param {ITelemetryItem[]} events - The array of events that have been discarded by the SDK.
             * @param {number} reason           - The reason for which the SDK discarded the events. The EventsDiscardedReason
             * constant should be used to check the different values.
             */
            _self.eventsDiscarded = function (events, reason) {
                Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["a" /* arrForEach */])(_self.listeners, function (listener) {
                    if (listener && listener.eventsDiscarded) {
                        setTimeout(function () { return listener.eventsDiscarded(events, reason); }, 0);
                    }
                });
            };
            /**
             * [Optional] A function called when the events have been requested to be sent to the sever.
             * @param {number} sendReason - The reason why the event batch is being sent.
             * @param {boolean} isAsync   - A flag which identifies whether the requests are being sent in an async or sync manner.
             */
            _self.eventsSendRequest = function (sendReason, isAsync) {
                Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["a" /* arrForEach */])(_self.listeners, function (listener) {
                    if (listener && listener.eventsSendRequest) {
                        if (isAsync) {
                            setTimeout(function () { return listener.eventsSendRequest(sendReason, isAsync); }, 0);
                        }
                        else {
                            try {
                                listener.eventsSendRequest(sendReason, isAsync);
                            }
                            catch (e) {
                                // Catch errors to ensure we don't block sending the requests
                            }
                        }
                    }
                });
            };
            _self.perfEvent = function (perfEvent) {
                if (perfEvent) {
                    // Send all events or only parent events
                    if (perfEvtsSendAll || !perfEvent.isChildEvt()) {
                        Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["a" /* arrForEach */])(_self.listeners, function (listener) {
                            if (listener && listener.perfEvent) {
                                if (perfEvent.isAsync) {
                                    setTimeout(function () { return listener.perfEvent(perfEvent); }, 0);
                                }
                                else {
                                    try {
                                        listener.perfEvent(perfEvent);
                                    }
                                    catch (e) {
                                        // Catch errors to ensure we don't block sending the requests
                                    }
                                }
                            }
                        });
                    }
                }
            };
        });
    }
// Removed Stub for NotificationManager.prototype.addNotificationListener.
// Removed Stub for NotificationManager.prototype.removeNotificationListener.
// Removed Stub for NotificationManager.prototype.eventsSent.
// Removed Stub for NotificationManager.prototype.eventsDiscarded.
// Removed Stub for NotificationManager.prototype.eventsSendRequest.
    return NotificationManager;
}());

//# sourceMappingURL=NotificationManager.js.map

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = randomValue;
/* harmony export (immutable) */ __webpack_exports__["c"] = random32;
/* harmony export (immutable) */ __webpack_exports__["b"] = mwcRandomSeed;
/* harmony export (immutable) */ __webpack_exports__["a"] = mwcRandom32;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EnvUtils__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HelperFuncs__ = __webpack_require__(42);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var UInt32Mask = 0x100000000;
var MaxUInt32 = 0xffffffff;
// MWC based Random generator (for IE)
var _mwcSeeded = false;
var _mwcW = 123456789;
var _mwcZ = 987654321;
// Takes any integer
function _mwcSeed(seedValue) {
    if (seedValue < 0) {
        // Make sure we end up with a positive number and not -ve one.
        seedValue >>>= 0;
    }
    _mwcW = (123456789 + seedValue) & MaxUInt32;
    _mwcZ = (987654321 - seedValue) & MaxUInt32;
    _mwcSeeded = true;
}
function _autoSeedMwc() {
    // Simple initialization using default Math.random() - So we inherit any entropy from the browser
    // and bitwise XOR with the current milliseconds
    try {
        var now = Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["g" /* dateNow */])() & 0x7fffffff;
        _mwcSeed(((Math.random() * UInt32Mask) ^ now) + now);
    }
    catch (e) {
        // Don't crash if something goes wrong
    }
}
/**
 * Generate a random value between 0 and maxValue, max value should be limited to a 32-bit maximum.
 * So maxValue(16) will produce a number from 0..16 (range of 17)
 * @param maxValue
 */
function randomValue(maxValue) {
    if (maxValue > 0) {
        return Math.floor((random32() / MaxUInt32) * (maxValue + 1)) >>> 0;
    }
    return 0;
}
/**
 * generate a random 32-bit number (0x000000..0xFFFFFFFF) or (-0x80000000..0x7FFFFFFF), defaults un-unsigned.
 * @param signed - True to return a signed 32-bit number (-0x80000000..0x7FFFFFFF) otherwise an unsigned one (0x000000..0xFFFFFFFF)
 */
function random32(signed) {
    var value;
    var c = Object(__WEBPACK_IMPORTED_MODULE_0__EnvUtils__["c" /* getCrypto */])() || Object(__WEBPACK_IMPORTED_MODULE_0__EnvUtils__["j" /* getMsCrypto */])();
    if (c && c.getRandomValues) {
        // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
        value = c.getRandomValues(new Uint32Array(1))[0] & MaxUInt32;
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_0__EnvUtils__["o" /* isIE */])()) {
        // For IE 6, 7, 8 (especially on XP) Math.random is not very random
        if (!_mwcSeeded) {
            // Set the seed for the Mwc algorithm
            _autoSeedMwc();
        }
        // Don't use Math.random for IE
        // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
        value = mwcRandom32() & MaxUInt32;
    }
    else {
        // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
        value = Math.floor((UInt32Mask * Math.random()) | 0);
    }
    if (!signed) {
        // Make sure we end up with a positive number and not -ve one.
        value >>>= 0;
    }
    return value;
}
/**
 * Seed the MWC random number generator with the specified seed or a random value
 * @param value - optional the number to used as the seed, if undefined, null or zero a random value will be chosen
 */
function mwcRandomSeed(value) {
    if (!value) {
        _autoSeedMwc();
    }
    else {
        _mwcSeed(value);
    }
}
/**
 * Generate a random 32-bit number between (0x000000..0xFFFFFFFF) or (-0x80000000..0x7FFFFFFF), using MWC (Multiply with carry)
 * instead of Math.random() defaults to un-signed.
 * Used as a replacement random generator for IE to avoid issues with older IE instances.
 * @param signed - True to return a signed 32-bit number (-0x80000000..0x7FFFFFFF) otherwise an unsigned one (0x000000..0xFFFFFFFF)
 */
function mwcRandom32(signed) {
    _mwcZ = (36969 * (_mwcZ & 0xFFFF) + (_mwcZ >> 16)) & MaxUInt32;
    _mwcW = (18000 * (_mwcW & 0xFFFF) + (_mwcW >> 16)) & MaxUInt32;
    var value = (((_mwcZ << 16) + (_mwcW & 0xFFFF)) >>> 0) & MaxUInt32 | 0;
    if (!signed) {
        // Make sure we end up with a positive number and not -ve one.
        value >>>= 0;
    }
    return value;
}
//# sourceMappingURL=RandomHelper.js.map

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RequestHeaders; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var RequestHeaders = {
    requestContextHeader: "Request-Context",
    requestContextTargetKey: "appId",
    requestContextAppIdFormat: "appId=cid-v1:",
    requestIdHeader: "Request-Id",
    traceParentHeader: "traceparent",
    traceStateHeader: "tracestate",
    sdkContextHeader: "Sdk-Context",
    sdkContextHeaderAppIdRequest: "appId",
    requestContextHeaderLowerCase: "request-context"
};
//# sourceMappingURL=RequestResponseHeaders.js.map

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createDomEvent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(41);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



function createDomEvent(eventName) {
    var event = null;
    if (Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["F" /* isFunction */])(Event)) {
        event = new Event(eventName);
    }
    else {
        var doc = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["q" /* getDocument */])();
        if (doc && doc.createEvent) {
            event = doc.createEvent("Event");
            event.initEvent(eventName, true, true);
        }
    }
    return event;
}
//# sourceMappingURL=DomHelperFuncs.js.map

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = utlDisableStorage;
/* harmony export (immutable) */ __webpack_exports__["a"] = utlCanUseLocalStorage;
/* harmony export (immutable) */ __webpack_exports__["d"] = utlGetLocalStorage;
/* harmony export (immutable) */ __webpack_exports__["i"] = utlSetLocalStorage;
/* harmony export (immutable) */ __webpack_exports__["h"] = utlRemoveStorage;
/* harmony export (immutable) */ __webpack_exports__["b"] = utlCanUseSessionStorage;
/* harmony export (immutable) */ __webpack_exports__["f"] = utlGetSessionStorageKeys;
/* harmony export (immutable) */ __webpack_exports__["e"] = utlGetSessionStorage;
/* harmony export (immutable) */ __webpack_exports__["j"] = utlSetSessionStorage;
/* harmony export (immutable) */ __webpack_exports__["g"] = utlRemoveSessionStorage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Enums__ = __webpack_require__(555);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var _canUseLocalStorage = undefined;
var _canUseSessionStorage = undefined;
/**
 * Gets the localStorage object if available
 * @return {Storage} - Returns the storage object if available else returns null
 */
function _getLocalStorageObject() {
    if (utlCanUseLocalStorage()) {
        return _getVerifiedStorageObject(__WEBPACK_IMPORTED_MODULE_1__Enums__["a" /* StorageType */].LocalStorage);
    }
    return null;
}
/**
 * Tests storage object (localStorage or sessionStorage) to verify that it is usable
 * More details here: https://mathiasbynens.be/notes/localstorage-pattern
 * @param storageType Type of storage
 * @return {Storage} Returns storage object verified that it is usable
 */
function _getVerifiedStorageObject(storageType) {
    try {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["s" /* getGlobal */])())) {
            return null;
        }
        var uid = new Date;
        var storage = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["t" /* getGlobalInst */])(storageType === __WEBPACK_IMPORTED_MODULE_1__Enums__["a" /* StorageType */].LocalStorage ? "localStorage" : "sessionStorage");
        storage.setItem(uid.toString(), uid.toString());
        var fail = storage.getItem(uid.toString()) !== uid.toString();
        storage.removeItem(uid.toString());
        if (!fail) {
            return storage;
        }
    }
    catch (exception) {
    }
    return null;
}
/**
 * Gets the sessionStorage object if available
 * @return {Storage} - Returns the storage object if available else returns null
 */
function _getSessionStorageObject() {
    if (utlCanUseSessionStorage()) {
        return _getVerifiedStorageObject(__WEBPACK_IMPORTED_MODULE_1__Enums__["a" /* StorageType */].SessionStorage);
    }
    return null;
}
function utlDisableStorage() {
    _canUseLocalStorage = false;
    _canUseSessionStorage = false;
}
function utlCanUseLocalStorage() {
    if (_canUseLocalStorage === undefined) {
        _canUseLocalStorage = !!_getVerifiedStorageObject(__WEBPACK_IMPORTED_MODULE_1__Enums__["a" /* StorageType */].LocalStorage);
    }
    return _canUseLocalStorage;
}
function utlGetLocalStorage(logger, name) {
    var storage = _getLocalStorageObject();
    if (storage !== null) {
        try {
            return storage.getItem(name);
        }
        catch (e) {
            _canUseLocalStorage = false;
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].BrowserCannotReadLocalStorage, "Browser failed read of local storage. " + Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["r" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["n" /* dumpObj */])(e) });
        }
    }
    return null;
}
function utlSetLocalStorage(logger, name, data) {
    var storage = _getLocalStorageObject();
    if (storage !== null) {
        try {
            storage.setItem(name, data);
            return true;
        }
        catch (e) {
            _canUseLocalStorage = false;
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].BrowserCannotWriteLocalStorage, "Browser failed write to local storage. " + Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["r" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["n" /* dumpObj */])(e) });
        }
    }
    return false;
}
function utlRemoveStorage(logger, name) {
    var storage = _getLocalStorageObject();
    if (storage !== null) {
        try {
            storage.removeItem(name);
            return true;
        }
        catch (e) {
            _canUseLocalStorage = false;
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].BrowserFailedRemovalFromLocalStorage, "Browser failed removal of local storage item. " + Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["r" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["n" /* dumpObj */])(e) });
        }
    }
    return false;
}
function utlCanUseSessionStorage() {
    if (_canUseSessionStorage === undefined) {
        _canUseSessionStorage = !!_getVerifiedStorageObject(__WEBPACK_IMPORTED_MODULE_1__Enums__["a" /* StorageType */].SessionStorage);
    }
    return _canUseSessionStorage;
}
function utlGetSessionStorageKeys() {
    var keys = [];
    if (utlCanUseSessionStorage()) {
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["K" /* objForEachKey */])(Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["t" /* getGlobalInst */])("sessionStorage"), function (key) {
            keys.push(key);
        });
    }
    return keys;
}
function utlGetSessionStorage(logger, name) {
    var storage = _getSessionStorageObject();
    if (storage !== null) {
        try {
            return storage.getItem(name);
        }
        catch (e) {
            _canUseSessionStorage = false;
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].BrowserCannotReadSessionStorage, "Browser failed read of session storage. " + Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["r" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["n" /* dumpObj */])(e) });
        }
    }
    return null;
}
function utlSetSessionStorage(logger, name, data) {
    var storage = _getSessionStorageObject();
    if (storage !== null) {
        try {
            storage.setItem(name, data);
            return true;
        }
        catch (e) {
            _canUseSessionStorage = false;
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].BrowserCannotWriteSessionStorage, "Browser failed write to session storage. " + Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["r" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["n" /* dumpObj */])(e) });
        }
    }
    return false;
}
function utlRemoveSessionStorage(logger, name) {
    var storage = _getSessionStorageObject();
    if (storage !== null) {
        try {
            storage.removeItem(name);
            return true;
        }
        catch (e) {
            _canUseSessionStorage = false;
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].BrowserFailedRemovalFromSessionStorage, "Browser failed removal of session storage item. " + Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["r" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["n" /* dumpObj */])(e) });
        }
    }
    return false;
}
//# sourceMappingURL=StorageHelperFuncs.js.map

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StorageType; });
/* unused harmony export DistributedTracingModes */
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * Type of storage to differentiate between local storage and session storage
 */
var StorageType;
(function (StorageType) {
    StorageType[StorageType["LocalStorage"] = 0] = "LocalStorage";
    StorageType[StorageType["SessionStorage"] = 1] = "SessionStorage";
})(StorageType || (StorageType = {}));
;
var DistributedTracingModes;
(function (DistributedTracingModes) {
    /**
     * (Default) Send Application Insights correlation headers
     */
    DistributedTracingModes[DistributedTracingModes["AI"] = 0] = "AI";
    /**
     * Send both W3C Trace Context headers and back-compatibility Application Insights headers
     */
    DistributedTracingModes[DistributedTracingModes["AI_AND_W3C"] = 1] = "AI_AND_W3C";
    /**
     * Send W3C Trace Context headers
     */
    DistributedTracingModes[DistributedTracingModes["W3C"] = 2] = "W3C";
})(DistributedTracingModes || (DistributedTracingModes = {}));
//# sourceMappingURL=Enums.js.map

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = urlParseUrl;
/* harmony export (immutable) */ __webpack_exports__["a"] = urlGetAbsoluteUrl;
/* harmony export (immutable) */ __webpack_exports__["c"] = urlGetPathName;
/* harmony export (immutable) */ __webpack_exports__["b"] = urlGetCompleteUrl;
/* harmony export (immutable) */ __webpack_exports__["e"] = urlParseHost;
/* harmony export (immutable) */ __webpack_exports__["d"] = urlParseFullHost;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(41);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



var _document = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["q" /* getDocument */])() || {};
var _htmlAnchorIdx = 0;
// Use an array of temporary values as it's possible for multiple calls to parseUrl() will be called with different URLs
// Using a cache size of 5 for now as it current depth usage is at least 2, so adding a minor buffer to handle future updates
var _htmlAnchorElement = [null, null, null, null, null];
function urlParseUrl(url) {
    var anchorIdx = _htmlAnchorIdx;
    var anchorCache = _htmlAnchorElement;
    var tempAnchor = anchorCache[anchorIdx];
    if (!_document.createElement) {
        // Always create the temp instance if createElement is not available
        tempAnchor = { host: urlParseHost(url, true) };
    }
    else if (!anchorCache[anchorIdx]) {
        // Create and cache the unattached anchor instance 
        tempAnchor = anchorCache[anchorIdx] = _document.createElement('a');
    }
    tempAnchor.href = url;
    // Move the cache index forward
    anchorIdx++;
    if (anchorIdx >= anchorCache.length) {
        anchorIdx = 0;
    }
    _htmlAnchorIdx = anchorIdx;
    return tempAnchor;
}
function urlGetAbsoluteUrl(url) {
    var result;
    var a = urlParseUrl(url);
    if (a) {
        result = a.href;
    }
    return result;
}
function urlGetPathName(url) {
    var result;
    var a = urlParseUrl(url);
    if (a) {
        result = a.pathname;
    }
    return result;
}
function urlGetCompleteUrl(method, absoluteUrl) {
    if (method) {
        return method.toUpperCase() + " " + absoluteUrl;
    }
    return absoluteUrl;
}
// Fallback method to grab host from url if document.createElement method is not available
function urlParseHost(url, inclPort) {
    var fullHost = urlParseFullHost(url, inclPort);
    if (fullHost) {
        var match = fullHost.match(/(www[0-9]?\.)?(.[^/:]+)(\:[\d]+)?/i);
        if (match != null && match.length > 3 && Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["I" /* isString */])(match[2]) && match[2].length > 0) {
            return match[2] + (match[3] || "");
        }
    }
    return fullHost;
}
function urlParseFullHost(url, inclPort) {
    var result = null;
    if (url) {
        var match = url.match(/(\w*):\/\/(.[^/:]+)(\:[\d]+)?/i);
        if (match != null && match.length > 2 && Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["I" /* isString */])(match[2]) && match[2].length > 0) {
            result = match[2] || "";
            if (inclPort && match.length > 2) {
                var protocol = (match[1] || "").toLowerCase();
                var port = match[3] || "";
                // IE includes the standard port so pass it off if it's the same as the protocol
                if (protocol === "http" && port === ":80") {
                    port = "";
                }
                else if (protocol === "https" && port === ":443") {
                    port = "";
                }
                result += port;
            }
        }
    }
    return result;
}
//# sourceMappingURL=UrlHelperFuncs.js.map

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Data; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Base__ = __webpack_require__(558);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



// THIS FILE WAS AUTOGENERATED

/**
 * Data struct to contain both B and C sections.
 */
var Data = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(Data, _super);
    function Data() {
        return _super.call(this) || this;
    }
    return Data;
}(__WEBPACK_IMPORTED_MODULE_1__Base__["a" /* Base */]));

//# sourceMappingURL=Data.js.map

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Base; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// THIS FILE WAS AUTOGENERATED
/**
 * Data struct to contain only C section with custom fields.
 */
var Base = /** @class */ (function () {
    function Base() {
    }
    return Base;
}());

//# sourceMappingURL=Base.js.map

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventData; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * Instances of Event represent structured event records that can be grouped and searched by their properties. Event data item also creates a metric of event count by name.
 */
var EventData = /** @class */ (function () {
    function EventData() {
        /**
         * Schema version
         */
        this.ver = 2;
        /**
         * Collection of custom properties.
         */
        this.properties = {};
        /**
         * Collection of custom measurements.
         */
        this.measurements = {};
    }
    return EventData;
}());

//# sourceMappingURL=EventData.js.map

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContextTagKeys; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__ = __webpack_require__(41);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




function _aiNameFunc(baseName) {
    var aiName = "ai." + baseName + ".";
    return function (name) {
        return aiName + name;
    };
}
var _aiApplication = _aiNameFunc("application");
var _aiDevice = _aiNameFunc("device");
var _aiLocation = _aiNameFunc("location");
var _aiOperation = _aiNameFunc("operation");
var _aiSession = _aiNameFunc("session");
var _aiUser = _aiNameFunc("user");
var _aiCloud = _aiNameFunc("cloud");
var _aiInternal = _aiNameFunc("internal");
var ContextTagKeys = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(ContextTagKeys, _super);
    function ContextTagKeys() {
        return _super.call(this) || this;
    }
    return ContextTagKeys;
}(Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["i" /* createClassFromInterface */])({
    applicationVersion: _aiApplication("ver"),
    applicationBuild: _aiApplication("build"),
    applicationTypeId: _aiApplication("typeId"),
    applicationId: _aiApplication("applicationId"),
    applicationLayer: _aiApplication("layer"),
    deviceId: _aiDevice("id"),
    deviceIp: _aiDevice("ip"),
    deviceLanguage: _aiDevice("language"),
    deviceLocale: _aiDevice("locale"),
    deviceModel: _aiDevice("model"),
    deviceFriendlyName: _aiDevice("friendlyName"),
    deviceNetwork: _aiDevice("network"),
    deviceNetworkName: _aiDevice("networkName"),
    deviceOEMName: _aiDevice("oemName"),
    deviceOS: _aiDevice("os"),
    deviceOSVersion: _aiDevice("osVersion"),
    deviceRoleInstance: _aiDevice("roleInstance"),
    deviceRoleName: _aiDevice("roleName"),
    deviceScreenResolution: _aiDevice("screenResolution"),
    deviceType: _aiDevice("type"),
    deviceMachineName: _aiDevice("machineName"),
    deviceVMName: _aiDevice("vmName"),
    deviceBrowser: _aiDevice("browser"),
    deviceBrowserVersion: _aiDevice("browserVersion"),
    locationIp: _aiLocation("ip"),
    locationCountry: _aiLocation("country"),
    locationProvince: _aiLocation("province"),
    locationCity: _aiLocation("city"),
    operationId: _aiOperation("id"),
    operationName: _aiOperation("name"),
    operationParentId: _aiOperation("parentId"),
    operationRootId: _aiOperation("rootId"),
    operationSyntheticSource: _aiOperation("syntheticSource"),
    operationCorrelationVector: _aiOperation("correlationVector"),
    sessionId: _aiSession("id"),
    sessionIsFirst: _aiSession("isFirst"),
    sessionIsNew: _aiSession("isNew"),
    userAccountAcquisitionDate: _aiUser("accountAcquisitionDate"),
    userAccountId: _aiUser("accountId"),
    userAgent: _aiUser("userAgent"),
    userId: _aiUser("id"),
    userStoreRegion: _aiUser("storeRegion"),
    userAuthUserId: _aiUser("authUserId"),
    userAnonymousUserAcquisitionDate: _aiUser("anonUserAcquisitionDate"),
    userAuthenticatedUserAcquisitionDate: _aiUser("authUserAcquisitionDate"),
    cloudName: _aiCloud("name"),
    cloudRole: _aiCloud("role"),
    cloudRoleVer: _aiCloud("roleVer"),
    cloudRoleInstance: _aiCloud("roleInstance"),
    cloudEnvironment: _aiCloud("environment"),
    cloudLocation: _aiCloud("location"),
    cloudDeploymentUnit: _aiCloud("deploymentUnit"),
    internalNodeName: _aiInternal("nodeName"),
    internalSdkVersion: _aiInternal("sdkVersion"),
    internalAgentVersion: _aiInternal("agentVersion"),
    internalSnippet: _aiInternal("snippet"),
    internalSdkSrc: _aiInternal("sdkSrc")
})));

//# sourceMappingURL=ContextTagKeys.js.map

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Sender__ = __webpack_require__(1420);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Sender__["a"]; });
/*
 * Application Insights JavaScript SDK - Channel, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

//# sourceMappingURL=applicationinsights-channel-js.js.map

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isInternalApplicationInsightsEndpoint;
/* unused harmony export Util */
/* unused harmony export UrlHelper */
/* unused harmony export CorrelationIdHelper */
/* harmony export (immutable) */ __webpack_exports__["a"] = AjaxHelperParseDependencyPath;
/* unused harmony export dateTimeUtilsNow */
/* unused harmony export dateTimeUtilsDuration */
/* unused harmony export DateTimeUtils */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RequestResponseHeaders__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Telemetry_Common_DataSanitizer__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DomHelperFuncs__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HelperFuncs__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Constants__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__ = __webpack_require__(572);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */










// listing only non-geo specific locations
var _internalEndpoints = [
    "https://dc.services.visualstudio.com/v2/track",
    "https://breeze.aimon.applicationinsights.io/v2/track",
    "https://dc-int.services.visualstudio.com/v2/track"
];
function isInternalApplicationInsightsEndpoint(endpointUrl) {
    return _internalEndpoints.indexOf(endpointUrl.toLowerCase()) !== -1;
}
var Util = {
    NotSpecified: __WEBPACK_IMPORTED_MODULE_5__Constants__["f" /* strNotSpecified */],
    createDomEvent: __WEBPACK_IMPORTED_MODULE_3__DomHelperFuncs__["a" /* createDomEvent */],
    disableStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["c" /* utlDisableStorage */],
    isInternalApplicationInsightsEndpoint: isInternalApplicationInsightsEndpoint,
    canUseLocalStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["a" /* utlCanUseLocalStorage */],
    getStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["d" /* utlGetLocalStorage */],
    setStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["i" /* utlSetLocalStorage */],
    removeStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["h" /* utlRemoveStorage */],
    canUseSessionStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["b" /* utlCanUseSessionStorage */],
    getSessionStorageKeys: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["f" /* utlGetSessionStorageKeys */],
    getSessionStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["e" /* utlGetSessionStorage */],
    setSessionStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["j" /* utlSetSessionStorage */],
    removeSessionStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["g" /* utlRemoveSessionStorage */],
    disableCookies: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["n" /* disableCookies */],
    canUseCookies: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["j" /* canUseCookies */],
    disallowsSameSiteNone: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["W" /* uaDisallowsSameSiteNone */],
    setCookie: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["R" /* setCookie */],
    stringToBoolOrDefault: __WEBPACK_IMPORTED_MODULE_4__HelperFuncs__["e" /* stringToBoolOrDefault */],
    getCookie: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["q" /* getCookie */],
    deleteCookie: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["m" /* deleteCookie */],
    trim: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["T" /* strTrim */],
    newId: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["L" /* newId */],
    random32: function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["P" /* random32 */])(true);
    },
    generateW3CId: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["p" /* generateW3CId */],
    isArray: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["B" /* isArray */],
    isError: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["D" /* isError */],
    isDate: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["C" /* isDate */],
    toISOStringForIE8: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["V" /* toISOString */],
    getIEVersion: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["v" /* getIEVersion */],
    msToTimeSpan: __WEBPACK_IMPORTED_MODULE_4__HelperFuncs__["d" /* msToTimeSpan */],
    isCrossOriginError: __WEBPACK_IMPORTED_MODULE_4__HelperFuncs__["c" /* isCrossOriginError */],
    dump: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["o" /* dumpObj */],
    getExceptionName: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["s" /* getExceptionName */],
    addEventHandler: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["i" /* attachEvent */],
    IsBeaconApiSupported: __WEBPACK_IMPORTED_MODULE_4__HelperFuncs__["b" /* isBeaconApiSupported */],
    getExtension: __WEBPACK_IMPORTED_MODULE_4__HelperFuncs__["a" /* getExtensionByName */]
};
;
var UrlHelper = {
    parseUrl: __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["f" /* urlParseUrl */],
    getAbsoluteUrl: __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["a" /* urlGetAbsoluteUrl */],
    getPathName: __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["c" /* urlGetPathName */],
    getCompleteUrl: __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["b" /* urlGetCompleteUrl */],
    parseHost: __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["e" /* urlParseHost */],
    parseFullHost: __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["d" /* urlParseFullHost */]
};
var CorrelationIdHelper = {
    correlationIdPrefix: "cid-v1:",
    /**
     * Checks if a request url is not on a excluded domain list and if it is safe to add correlation headers.
     * Headers are always included if the current domain matches the request domain. If they do not match (CORS),
     * they are regex-ed across correlationHeaderDomains and correlationHeaderExcludedDomains to determine if headers are included.
     * Some environments don't give information on currentHost via window.location.host (e.g. Cordova). In these cases, the user must
     * manually supply domains to include correlation headers on. Else, no headers will be included at all.
     */
    canIncludeCorrelationHeader: function (config, requestUrl, currentHost) {
        if (!requestUrl || (config && config.disableCorrelationHeaders)) {
            return false;
        }
        if (config && config.correlationHeaderExcludePatterns) {
            for (var i = 0; i < config.correlationHeaderExcludePatterns.length; i++) {
                if (config.correlationHeaderExcludePatterns[i].test(requestUrl)) {
                    return false;
                }
            }
        }
        var requestHost = Object(__WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["f" /* urlParseUrl */])(requestUrl).host.toLowerCase();
        if (requestHost && (requestHost.indexOf(":443") !== -1 || requestHost.indexOf(":80") !== -1)) {
            // [Bug #1260] IE can include the port even for http and https URLs so if present 
            // try and parse it to remove if it matches the default protocol port
            requestHost = (Object(__WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["d" /* urlParseFullHost */])(requestUrl, true) || "").toLowerCase();
        }
        if ((!config || !config.enableCorsCorrelation) && requestHost !== currentHost) {
            return false;
        }
        var includedDomains = config && config.correlationHeaderDomains;
        if (includedDomains) {
            var matchExists_1;
            Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["e" /* arrForEach */])(includedDomains, function (domain) {
                var regex = new RegExp(domain.toLowerCase().replace(/\./g, "\.").replace(/\*/g, ".*"));
                matchExists_1 = matchExists_1 || regex.test(requestHost);
            });
            if (!matchExists_1) {
                return false;
            }
        }
        var excludedDomains = config && config.correlationHeaderExcludedDomains;
        if (!excludedDomains || excludedDomains.length === 0) {
            return true;
        }
        for (var i = 0; i < excludedDomains.length; i++) {
            var regex = new RegExp(excludedDomains[i].toLowerCase().replace(/\./g, "\.").replace(/\*/g, ".*"));
            if (regex.test(requestHost)) {
                return false;
            }
        }
        // if we don't know anything about the requestHost, require the user to use included/excludedDomains.
        // Previously we always returned false for a falsy requestHost
        return requestHost && requestHost.length > 0;
    },
    /**
     * Combines target appId and target role name from response header.
     */
    getCorrelationContext: function (responseHeader) {
        if (responseHeader) {
            var correlationId = CorrelationIdHelper.getCorrelationContextValue(responseHeader, __WEBPACK_IMPORTED_MODULE_1__RequestResponseHeaders__["a" /* RequestHeaders */].requestContextTargetKey);
            if (correlationId && correlationId !== CorrelationIdHelper.correlationIdPrefix) {
                return correlationId;
            }
        }
    },
    /**
     * Gets key from correlation response header
     */
    getCorrelationContextValue: function (responseHeader, key) {
        if (responseHeader) {
            var keyValues = responseHeader.split(",");
            for (var i = 0; i < keyValues.length; ++i) {
                var keyValue = keyValues[i].split("=");
                if (keyValue.length === 2 && keyValue[0] === key) {
                    return keyValue[1];
                }
            }
        }
    }
};
function AjaxHelperParseDependencyPath(logger, absoluteUrl, method, commandName) {
    var target, name = commandName, data = commandName;
    if (absoluteUrl && absoluteUrl.length > 0) {
        var parsedUrl = Object(__WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["f" /* urlParseUrl */])(absoluteUrl);
        target = parsedUrl.host;
        if (!name) {
            if (parsedUrl.pathname != null) {
                var pathName = (parsedUrl.pathname.length === 0) ? "/" : parsedUrl.pathname;
                if (pathName.charAt(0) !== '/') {
                    pathName = "/" + pathName;
                }
                data = parsedUrl.pathname;
                name = Object(__WEBPACK_IMPORTED_MODULE_2__Telemetry_Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, method ? method + " " + pathName : pathName);
            }
            else {
                name = Object(__WEBPACK_IMPORTED_MODULE_2__Telemetry_Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, absoluteUrl);
            }
        }
    }
    else {
        target = commandName;
        name = commandName;
    }
    return {
        target: target,
        name: name,
        data: data
    };
}
function dateTimeUtilsNow() {
    // returns the window or webworker performance object
    var perf = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["y" /* getPerformance */])();
    if (perf && perf.now && perf.timing) {
        var now = perf.now() + perf.timing.navigationStart;
        // Known issue with IE where this calculation can be negative, so if it is then ignore and fallback
        if (now > 0) {
            return now;
        }
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["l" /* dateNow */])();
}
function dateTimeUtilsDuration(start, end) {
    var result = null;
    if (start !== 0 && end !== 0 && !Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["F" /* isNullOrUndefined */])(start) && !Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["F" /* isNullOrUndefined */])(end)) {
        result = end - start;
    }
    return result;
}
/**
 * A utility class that helps getting time related parameters
 */
var DateTimeUtils = {
    Now: dateTimeUtilsNow,
    GetDuration: dateTimeUtilsDuration
};
//# sourceMappingURL=Util.js.map

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventsDiscardedReason; });
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * The EventsDiscardedReason enumeration contains a set of values that specify the reason for discarding an event.
 */
var EventsDiscardedReason = {
    /**
     * Unknown.
     */
    Unknown: 0,
    /**
     * Status set to non-retryable.
     */
    NonRetryableStatus: 1,
    /**
     * The event is invalid.
     */
    InvalidEvent: 2,
    /**
     * The size of the event is too large.
     */
    SizeLimitExceeded: 3,
    /**
     * The server is not accepting events from this instrumentation key.
     */
    KillSwitch: 4,
    /**
     * The event queue is full.
     */
    QueueFull: 5
};
//# sourceMappingURL=EventsDiscardedReason.js.map

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseCore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChannelController__ = __webpack_require__(1424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProcessTelemetryContext__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TelemetryHelpers__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PerfManager__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CookieMgr__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__HelperFuncs__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Constants__ = __webpack_require__(366);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */












var validationError = "Extensions must provide callback to initialize";
var strNotificationManager = "_notificationManager";
var BaseCore = /** @class */ (function () {
    function BaseCore() {
        var _isInitialized = false;
        var _eventQueue;
        var _channelController;
        var _notificationManager;
        var _perfManager;
        var _cookieManager;
        Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__["a" /* default */])(BaseCore, this, function (_self) {
            _self._extensions = new Array();
            _channelController = new __WEBPACK_IMPORTED_MODULE_2__ChannelController__["a" /* ChannelController */]();
            _self.logger = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["i" /* objCreateFn */])({
                throwInternal: function (severity, msgId, msg, properties, isUserAct) {
                    if (isUserAct === void 0) { isUserAct = false; }
                },
                warnToConsole: function (message) { },
                resetInternalMessageCount: function () { }
            });
            _eventQueue = [];
            _self.isInitialized = function () { return _isInitialized; };
            _self.initialize = function (config, extensions, logger, notificationManager) {
                // Make sure core is only initialized once
                if (_self.isInitialized()) {
                    Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["H" /* throwError */])("Core should not be initialized more than once");
                }
                if (!config || Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["s" /* isNullOrUndefined */])(config.instrumentationKey)) {
                    Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["H" /* throwError */])("Please provide instrumentation key");
                }
                _notificationManager = notificationManager;
                // For backward compatibility only
                _self[strNotificationManager] = notificationManager;
                _self.config = config || {};
                config.extensions = Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["s" /* isNullOrUndefined */])(config.extensions) ? [] : config.extensions;
                // add notification to the extensions in the config so other plugins can access it
                var extConfig = Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["j" /* getSetValue */])(config, __WEBPACK_IMPORTED_MODULE_8__Constants__["a" /* strExtensionConfig */]);
                extConfig.NotificationManager = notificationManager;
                if (logger) {
                    _self.logger = logger;
                }
                // Concat all available extensions
                var allExtensions = [];
                allExtensions.push.apply(allExtensions, extensions.concat(config.extensions));
                allExtensions = Object(__WEBPACK_IMPORTED_MODULE_4__TelemetryHelpers__["b" /* sortPlugins */])(allExtensions);
                var coreExtensions = [];
                var channelExtensions = [];
                // Check if any two extensions have the same priority, then warn to console
                // And extract the local extensions from the 
                var extPriorities = {};
                // Extension validation
                Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["a" /* arrForEach */])(allExtensions, function (ext) {
                    if (Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["s" /* isNullOrUndefined */])(ext) || Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["s" /* isNullOrUndefined */])(ext.initialize)) {
                        Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["H" /* throwError */])(validationError);
                    }
                    var extPriority = ext.priority;
                    var identifier = ext.identifier;
                    if (ext && extPriority) {
                        if (!Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["s" /* isNullOrUndefined */])(extPriorities[extPriority])) {
                            logger.warnToConsole("Two extensions have same priority #" + extPriority + " - " + extPriorities[extPriority] + ", " + identifier);
                        }
                        else {
                            // set a value
                            extPriorities[extPriority] = identifier;
                        }
                    }
                    // Split extensions to core and channelController
                    if (!extPriority || extPriority < _channelController.priority) {
                        // Add to core extension that will be managed by BaseCore
                        coreExtensions.push(ext);
                    }
                    else {
                        // Add all other extensions to be managed by the channel controller
                        channelExtensions.push(ext);
                    }
                });
                // Validation complete
                // Add the channelController to the complete extension collection and
                // to the end of the core extensions
                allExtensions.push(_channelController);
                coreExtensions.push(_channelController);
                // Sort the complete set of extensions by priority
                allExtensions = Object(__WEBPACK_IMPORTED_MODULE_4__TelemetryHelpers__["b" /* sortPlugins */])(allExtensions);
                _self._extensions = allExtensions;
                // initialize channel controller first, this will initialize all channel plugins
                Object(__WEBPACK_IMPORTED_MODULE_4__TelemetryHelpers__["a" /* initializePlugins */])(new __WEBPACK_IMPORTED_MODULE_3__ProcessTelemetryContext__["a" /* ProcessTelemetryContext */]([_channelController], config, _self), allExtensions);
                Object(__WEBPACK_IMPORTED_MODULE_4__TelemetryHelpers__["a" /* initializePlugins */])(new __WEBPACK_IMPORTED_MODULE_3__ProcessTelemetryContext__["a" /* ProcessTelemetryContext */](coreExtensions, config, _self), allExtensions);
                // Now reset the extensions to just those being managed by Basecore
                _self._extensions = coreExtensions;
                if (_self.getTransmissionControls().length === 0) {
                    Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["H" /* throwError */])("No channels available");
                }
                _isInitialized = true;
                _self.releaseQueue();
            };
            _self.getTransmissionControls = function () {
                return _channelController.getChannelControls();
            };
            _self.track = function (telemetryItem) {
                // setup default iKey if not passed in
                Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["D" /* setValue */])(telemetryItem, __WEBPACK_IMPORTED_MODULE_8__Constants__["b" /* strIKey */], _self.config.instrumentationKey, null, __WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["r" /* isNotTruthy */]);
                // add default timestamp if not passed in
                Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["D" /* setValue */])(telemetryItem, "time", Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["I" /* toISOString */])(new Date()), null, __WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["r" /* isNotTruthy */]);
                // Common Schema 4.0
                Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["D" /* setValue */])(telemetryItem, "ver", "4.0", null, __WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["s" /* isNullOrUndefined */]);
                if (_self.isInitialized()) {
                    // Process the telemetry plugin chain
                    _self.getProcessTelContext().processNext(telemetryItem);
                }
                else {
                    // Queue events until all extensions are initialized
                    _eventQueue.push(telemetryItem);
                }
            };
            _self.getProcessTelContext = function () {
                var extensions = _self._extensions;
                var thePlugins = extensions;
                // invoke any common telemetry processors before sending through pipeline
                if (!extensions || extensions.length === 0) {
                    // Pass to Channel controller so data is sent to correct channel queues
                    thePlugins = [_channelController];
                }
                return new __WEBPACK_IMPORTED_MODULE_3__ProcessTelemetryContext__["a" /* ProcessTelemetryContext */](thePlugins, _self.config, _self);
            };
            _self.getNotifyMgr = function () {
                if (!_notificationManager) {
                    // Create Dummy notification manager
                    _notificationManager = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["i" /* objCreateFn */])({
                        addNotificationListener: function (listener) { },
                        removeNotificationListener: function (listener) { },
                        eventsSent: function (events) { },
                        eventsDiscarded: function (events, reason) { },
                        eventsSendRequest: function (sendReason, isAsync) { }
                    });
                    // For backward compatibility only
                    _self[strNotificationManager] = _notificationManager;
                }
                return _notificationManager;
            };
            _self.getCookieMgr = function () {
                if (!_cookieManager) {
                    _cookieManager = Object(__WEBPACK_IMPORTED_MODULE_6__CookieMgr__["b" /* createCookieMgr */])(_self.config, _self.logger);
                }
                return _cookieManager;
            };
            _self.setCookieMgr = function (cookieMgr) {
                _cookieManager = cookieMgr;
            };
            _self.getPerfMgr = function () {
                if (!_perfManager) {
                    if (_self.config && _self.config.enablePerfMgr) {
                        _perfManager = new __WEBPACK_IMPORTED_MODULE_5__PerfManager__["a" /* PerfManager */](_self.getNotifyMgr());
                    }
                }
                return _perfManager;
            };
            _self.setPerfMgr = function (perfMgr) {
                _perfManager = perfMgr;
            };
            _self.eventCnt = function () {
                return _eventQueue.length;
            };
            _self.releaseQueue = function () {
                if (_eventQueue.length > 0) {
                    Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["a" /* arrForEach */])(_eventQueue, function (event) {
                        _self.getProcessTelContext().processNext(event);
                    });
                    _eventQueue = [];
                }
            };
        });
    }
// Removed Stub for BaseCore.prototype.initialize.
// Removed Stub for BaseCore.prototype.getTransmissionControls.
// Removed Stub for BaseCore.prototype.track.
// Removed Stub for BaseCore.prototype.getProcessTelContext.
// Removed Stub for BaseCore.prototype.getNotifyMgr.
// Removed Stub for BaseCore.prototype.getCookieMgr.
// Removed Stub for BaseCore.prototype.setCookieMgr.
// Removed Stub for BaseCore.prototype.getPerfMgr.
// Removed Stub for BaseCore.prototype.setPerfMgr.
// Removed Stub for BaseCore.prototype.eventCnt.
// Removed Stub for BaseCore.prototype.releaseQueue.
    return BaseCore;
}());

//# sourceMappingURL=BaseCore.js.map

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseTelemetryPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProcessTelemetryContext__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HelperFuncs__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Constants__ = __webpack_require__(366);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var strGetPlugin = "getPlugin";
/**
 * BaseTelemetryPlugin provides a basic implementation of the ITelemetryPlugin interface so that plugins
 * can avoid implementation the same set of boiler plate code as well as provide a base
 * implementation so that new default implementations can be added without breaking all plugins.
 */
var BaseTelemetryPlugin = /** @class */ (function () {
    function BaseTelemetryPlugin() {
        var _self = this;
        var _isinitialized = false;
        var _rootCtx = null; // Used as the root context, holding the current config and initialized core
        var _nextPlugin = null; // Used for backward compatibility where plugins don't call the main pipeline
        _self.core = null;
        _self.diagLog = function (itemCtx) {
            return _self._getTelCtx(itemCtx).diagLog();
        };
        _self.isInitialized = function () {
            return _isinitialized;
        };
        _self.setInitialized = function (isInitialized) {
            _isinitialized = isInitialized;
        };
        // _self.getNextPlugin = () => DO NOT IMPLEMENT
        // Sub-classes of this base class *should* not be relying on this value and instead
        // should use processNext() function. If you require access to the plugin use the
        // IProcessTelemetryContext.getNext().getPlugin() while in the pipeline, Note getNext() may return null.
        _self.setNextPlugin = function (next) {
            _nextPlugin = next;
        };
        _self.processNext = function (env, itemCtx) {
            if (itemCtx) {
                // Normal core execution sequence
                itemCtx.processNext(env);
            }
            else if (_nextPlugin && Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["p" /* isFunction */])(_nextPlugin.processTelemetry)) {
                // Looks like backward compatibility or out of band processing. And as it looks 
                // like a ITelemetryPlugin or ITelemetryPluginChain, just call processTelemetry
                _nextPlugin.processTelemetry(env, null);
            }
        };
        _self._getTelCtx = function (currentCtx) {
            if (currentCtx === void 0) { currentCtx = null; }
            var itemCtx = currentCtx;
            if (!itemCtx) {
                var rootCtx = _rootCtx || new __WEBPACK_IMPORTED_MODULE_0__ProcessTelemetryContext__["a" /* ProcessTelemetryContext */](null, {}, _self.core);
                // tslint:disable-next-line: prefer-conditional-expression
                if (_nextPlugin && _nextPlugin[strGetPlugin]) {
                    // Looks like a chain object
                    itemCtx = rootCtx.createNew(null, _nextPlugin[strGetPlugin]);
                }
                else {
                    itemCtx = rootCtx.createNew(null, _nextPlugin);
                }
            }
            return itemCtx;
        };
        _self._baseTelInit = function (config, core, extensions, pluginChain) {
            if (config) {
                // Make sure the extensionConfig exists
                Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["D" /* setValue */])(config, __WEBPACK_IMPORTED_MODULE_2__Constants__["a" /* strExtensionConfig */], [], null, __WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["s" /* isNullOrUndefined */]);
            }
            if (!pluginChain && core) {
                // Get the first plugin from the core
                pluginChain = core.getProcessTelContext().getNext();
            }
            var nextPlugin = _nextPlugin;
            if (_nextPlugin && _nextPlugin[strGetPlugin]) {
                // If it looks like a proxy/chain then get the plugin
                nextPlugin = _nextPlugin[strGetPlugin]();
            }
            // Support legacy plugins where core was defined as a property
            _self.core = core;
            _rootCtx = new __WEBPACK_IMPORTED_MODULE_0__ProcessTelemetryContext__["a" /* ProcessTelemetryContext */](pluginChain, config, core, nextPlugin);
            _isinitialized = true;
        };
    }
    BaseTelemetryPlugin.prototype.initialize = function (config, core, extensions, pluginChain) {
        this._baseTelInit(config, core, extensions, pluginChain);
    };
    return BaseTelemetryPlugin;
}());

//# sourceMappingURL=BaseTelemetryPlugin.js.map

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NotificationManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HelperFuncs__ = __webpack_require__(43);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * Class to manage sending notifications to all the listeners.
 */
var NotificationManager = /** @class */ (function () {
    function NotificationManager(config) {
        this.listeners = [];
        var perfEvtsSendAll = !!(config || {}).perfEvtsSendAll;
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__["a" /* default */])(NotificationManager, this, function (_self) {
            _self.addNotificationListener = function (listener) {
                _self.listeners.push(listener);
            };
            /**
             * Removes all instances of the listener.
             * @param {INotificationListener} listener - AWTNotificationListener to remove.
             */
            _self.removeNotificationListener = function (listener) {
                var index = Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["b" /* arrIndexOf */])(_self.listeners, listener);
                while (index > -1) {
                    _self.listeners.splice(index, 1);
                    index = Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["b" /* arrIndexOf */])(_self.listeners, listener);
                }
            };
            /**
             * Notification for events sent.
             * @param {ITelemetryItem[]} events - The array of events that have been sent.
             */
            _self.eventsSent = function (events) {
                Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["a" /* arrForEach */])(_self.listeners, function (listener) {
                    if (listener && listener.eventsSent) {
                        setTimeout(function () { return listener.eventsSent(events); }, 0);
                    }
                });
            };
            /**
             * Notification for events being discarded.
             * @param {ITelemetryItem[]} events - The array of events that have been discarded by the SDK.
             * @param {number} reason           - The reason for which the SDK discarded the events. The EventsDiscardedReason
             * constant should be used to check the different values.
             */
            _self.eventsDiscarded = function (events, reason) {
                Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["a" /* arrForEach */])(_self.listeners, function (listener) {
                    if (listener && listener.eventsDiscarded) {
                        setTimeout(function () { return listener.eventsDiscarded(events, reason); }, 0);
                    }
                });
            };
            /**
             * [Optional] A function called when the events have been requested to be sent to the sever.
             * @param {number} sendReason - The reason why the event batch is being sent.
             * @param {boolean} isAsync   - A flag which identifies whether the requests are being sent in an async or sync manner.
             */
            _self.eventsSendRequest = function (sendReason, isAsync) {
                Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["a" /* arrForEach */])(_self.listeners, function (listener) {
                    if (listener && listener.eventsSendRequest) {
                        if (isAsync) {
                            setTimeout(function () { return listener.eventsSendRequest(sendReason, isAsync); }, 0);
                        }
                        else {
                            try {
                                listener.eventsSendRequest(sendReason, isAsync);
                            }
                            catch (e) {
                                // Catch errors to ensure we don't block sending the requests
                            }
                        }
                    }
                });
            };
            _self.perfEvent = function (perfEvent) {
                if (perfEvent) {
                    // Send all events or only parent events
                    if (perfEvtsSendAll || !perfEvent.isChildEvt()) {
                        Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["a" /* arrForEach */])(_self.listeners, function (listener) {
                            if (listener && listener.perfEvent) {
                                if (perfEvent.isAsync) {
                                    setTimeout(function () { return listener.perfEvent(perfEvent); }, 0);
                                }
                                else {
                                    try {
                                        listener.perfEvent(perfEvent);
                                    }
                                    catch (e) {
                                        // Catch errors to ensure we don't block sending the requests
                                    }
                                }
                            }
                        });
                    }
                }
            };
        });
    }
// Removed Stub for NotificationManager.prototype.addNotificationListener.
// Removed Stub for NotificationManager.prototype.removeNotificationListener.
// Removed Stub for NotificationManager.prototype.eventsSent.
// Removed Stub for NotificationManager.prototype.eventsDiscarded.
// Removed Stub for NotificationManager.prototype.eventsSendRequest.
    return NotificationManager;
}());

//# sourceMappingURL=NotificationManager.js.map

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = randomValue;
/* harmony export (immutable) */ __webpack_exports__["c"] = random32;
/* harmony export (immutable) */ __webpack_exports__["b"] = mwcRandomSeed;
/* harmony export (immutable) */ __webpack_exports__["a"] = mwcRandom32;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EnvUtils__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HelperFuncs__ = __webpack_require__(43);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var UInt32Mask = 0x100000000;
var MaxUInt32 = 0xffffffff;
// MWC based Random generator (for IE)
var _mwcSeeded = false;
var _mwcW = 123456789;
var _mwcZ = 987654321;
// Takes any integer
function _mwcSeed(seedValue) {
    if (seedValue < 0) {
        // Make sure we end up with a positive number and not -ve one.
        seedValue >>>= 0;
    }
    _mwcW = (123456789 + seedValue) & MaxUInt32;
    _mwcZ = (987654321 - seedValue) & MaxUInt32;
    _mwcSeeded = true;
}
function _autoSeedMwc() {
    // Simple initialization using default Math.random() - So we inherit any entropy from the browser
    // and bitwise XOR with the current milliseconds
    try {
        var now = Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["g" /* dateNow */])() & 0x7fffffff;
        _mwcSeed(((Math.random() * UInt32Mask) ^ now) + now);
    }
    catch (e) {
        // Don't crash if something goes wrong
    }
}
/**
 * Generate a random value between 0 and maxValue, max value should be limited to a 32-bit maximum.
 * So maxValue(16) will produce a number from 0..16 (range of 17)
 * @param maxValue
 */
function randomValue(maxValue) {
    if (maxValue > 0) {
        return Math.floor((random32() / MaxUInt32) * (maxValue + 1)) >>> 0;
    }
    return 0;
}
/**
 * generate a random 32-bit number (0x000000..0xFFFFFFFF) or (-0x80000000..0x7FFFFFFF), defaults un-unsigned.
 * @param signed - True to return a signed 32-bit number (-0x80000000..0x7FFFFFFF) otherwise an unsigned one (0x000000..0xFFFFFFFF)
 */
function random32(signed) {
    var value;
    var c = Object(__WEBPACK_IMPORTED_MODULE_0__EnvUtils__["c" /* getCrypto */])() || Object(__WEBPACK_IMPORTED_MODULE_0__EnvUtils__["i" /* getMsCrypto */])();
    if (c && c.getRandomValues) {
        // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
        value = c.getRandomValues(new Uint32Array(1))[0] & MaxUInt32;
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_0__EnvUtils__["n" /* isIE */])()) {
        // For IE 6, 7, 8 (especially on XP) Math.random is not very random
        if (!_mwcSeeded) {
            // Set the seed for the Mwc algorithm
            _autoSeedMwc();
        }
        // Don't use Math.random for IE
        // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
        value = mwcRandom32() & MaxUInt32;
    }
    else {
        // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
        value = Math.floor((UInt32Mask * Math.random()) | 0);
    }
    if (!signed) {
        // Make sure we end up with a positive number and not -ve one.
        value >>>= 0;
    }
    return value;
}
/**
 * Seed the MWC random number generator with the specified seed or a random value
 * @param value - optional the number to used as the seed, if undefined, null or zero a random value will be chosen
 */
function mwcRandomSeed(value) {
    if (!value) {
        _autoSeedMwc();
    }
    else {
        _mwcSeed(value);
    }
}
/**
 * Generate a random 32-bit number between (0x000000..0xFFFFFFFF) or (-0x80000000..0x7FFFFFFF), using MWC (Multiply with carry)
 * instead of Math.random() defaults to un-signed.
 * Used as a replacement random generator for IE to avoid issues with older IE instances.
 * @param signed - True to return a signed 32-bit number (-0x80000000..0x7FFFFFFF) otherwise an unsigned one (0x000000..0xFFFFFFFF)
 */
function mwcRandom32(signed) {
    _mwcZ = (36969 * (_mwcZ & 0xFFFF) + (_mwcZ >> 16)) & MaxUInt32;
    _mwcW = (18000 * (_mwcW & 0xFFFF) + (_mwcW >> 16)) & MaxUInt32;
    var value = (((_mwcZ << 16) + (_mwcW & 0xFFFF)) >>> 0) & MaxUInt32 | 0;
    if (!signed) {
        // Make sure we end up with a positive number and not -ve one.
        value >>>= 0;
    }
    return value;
}
//# sourceMappingURL=RandomHelper.js.map

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RequestHeaders; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var RequestHeaders = {
    requestContextHeader: "Request-Context",
    requestContextTargetKey: "appId",
    requestContextAppIdFormat: "appId=cid-v1:",
    requestIdHeader: "Request-Id",
    traceParentHeader: "traceparent",
    traceStateHeader: "tracestate",
    sdkContextHeader: "Sdk-Context",
    sdkContextHeaderAppIdRequest: "appId",
    requestContextHeaderLowerCase: "request-context"
};
//# sourceMappingURL=RequestResponseHeaders.js.map

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createDomEvent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(30);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



function createDomEvent(eventName) {
    var event = null;
    if (Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["E" /* isFunction */])(Event)) {
        event = new Event(eventName);
    }
    else {
        var doc = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["r" /* getDocument */])();
        if (doc && doc.createEvent) {
            event = doc.createEvent("Event");
            event.initEvent(eventName, true, true);
        }
    }
    return event;
}
//# sourceMappingURL=DomHelperFuncs.js.map

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = utlDisableStorage;
/* harmony export (immutable) */ __webpack_exports__["a"] = utlCanUseLocalStorage;
/* harmony export (immutable) */ __webpack_exports__["d"] = utlGetLocalStorage;
/* harmony export (immutable) */ __webpack_exports__["i"] = utlSetLocalStorage;
/* harmony export (immutable) */ __webpack_exports__["h"] = utlRemoveStorage;
/* harmony export (immutable) */ __webpack_exports__["b"] = utlCanUseSessionStorage;
/* harmony export (immutable) */ __webpack_exports__["f"] = utlGetSessionStorageKeys;
/* harmony export (immutable) */ __webpack_exports__["e"] = utlGetSessionStorage;
/* harmony export (immutable) */ __webpack_exports__["j"] = utlSetSessionStorage;
/* harmony export (immutable) */ __webpack_exports__["g"] = utlRemoveSessionStorage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Enums__ = __webpack_require__(571);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var _canUseLocalStorage = undefined;
var _canUseSessionStorage = undefined;
/**
 * Gets the localStorage object if available
 * @return {Storage} - Returns the storage object if available else returns null
 */
function _getLocalStorageObject() {
    if (utlCanUseLocalStorage()) {
        return _getVerifiedStorageObject(__WEBPACK_IMPORTED_MODULE_1__Enums__["a" /* StorageType */].LocalStorage);
    }
    return null;
}
/**
 * Tests storage object (localStorage or sessionStorage) to verify that it is usable
 * More details here: https://mathiasbynens.be/notes/localstorage-pattern
 * @param storageType Type of storage
 * @return {Storage} Returns storage object verified that it is usable
 */
function _getVerifiedStorageObject(storageType) {
    try {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["F" /* isNullOrUndefined */])(Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["t" /* getGlobal */])())) {
            return null;
        }
        var uid = new Date;
        var storage = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["u" /* getGlobalInst */])(storageType === __WEBPACK_IMPORTED_MODULE_1__Enums__["a" /* StorageType */].LocalStorage ? "localStorage" : "sessionStorage");
        storage.setItem(uid.toString(), uid.toString());
        var fail = storage.getItem(uid.toString()) !== uid.toString();
        storage.removeItem(uid.toString());
        if (!fail) {
            return storage;
        }
    }
    catch (exception) {
    }
    return null;
}
/**
 * Gets the sessionStorage object if available
 * @return {Storage} - Returns the storage object if available else returns null
 */
function _getSessionStorageObject() {
    if (utlCanUseSessionStorage()) {
        return _getVerifiedStorageObject(__WEBPACK_IMPORTED_MODULE_1__Enums__["a" /* StorageType */].SessionStorage);
    }
    return null;
}
function utlDisableStorage() {
    _canUseLocalStorage = false;
    _canUseSessionStorage = false;
}
function utlCanUseLocalStorage() {
    if (_canUseLocalStorage === undefined) {
        _canUseLocalStorage = !!_getVerifiedStorageObject(__WEBPACK_IMPORTED_MODULE_1__Enums__["a" /* StorageType */].LocalStorage);
    }
    return _canUseLocalStorage;
}
function utlGetLocalStorage(logger, name) {
    var storage = _getLocalStorageObject();
    if (storage !== null) {
        try {
            return storage.getItem(name);
        }
        catch (e) {
            _canUseLocalStorage = false;
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].BrowserCannotReadLocalStorage, "Browser failed read of local storage. " + Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["s" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["o" /* dumpObj */])(e) });
        }
    }
    return null;
}
function utlSetLocalStorage(logger, name, data) {
    var storage = _getLocalStorageObject();
    if (storage !== null) {
        try {
            storage.setItem(name, data);
            return true;
        }
        catch (e) {
            _canUseLocalStorage = false;
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].BrowserCannotWriteLocalStorage, "Browser failed write to local storage. " + Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["s" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["o" /* dumpObj */])(e) });
        }
    }
    return false;
}
function utlRemoveStorage(logger, name) {
    var storage = _getLocalStorageObject();
    if (storage !== null) {
        try {
            storage.removeItem(name);
            return true;
        }
        catch (e) {
            _canUseLocalStorage = false;
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].BrowserFailedRemovalFromLocalStorage, "Browser failed removal of local storage item. " + Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["s" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["o" /* dumpObj */])(e) });
        }
    }
    return false;
}
function utlCanUseSessionStorage() {
    if (_canUseSessionStorage === undefined) {
        _canUseSessionStorage = !!_getVerifiedStorageObject(__WEBPACK_IMPORTED_MODULE_1__Enums__["a" /* StorageType */].SessionStorage);
    }
    return _canUseSessionStorage;
}
function utlGetSessionStorageKeys() {
    var keys = [];
    if (utlCanUseSessionStorage()) {
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["M" /* objForEachKey */])(Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["u" /* getGlobalInst */])("sessionStorage"), function (key) {
            keys.push(key);
        });
    }
    return keys;
}
function utlGetSessionStorage(logger, name) {
    var storage = _getSessionStorageObject();
    if (storage !== null) {
        try {
            return storage.getItem(name);
        }
        catch (e) {
            _canUseSessionStorage = false;
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].BrowserCannotReadSessionStorage, "Browser failed read of session storage. " + Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["s" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["o" /* dumpObj */])(e) });
        }
    }
    return null;
}
function utlSetSessionStorage(logger, name, data) {
    var storage = _getSessionStorageObject();
    if (storage !== null) {
        try {
            storage.setItem(name, data);
            return true;
        }
        catch (e) {
            _canUseSessionStorage = false;
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].BrowserCannotWriteSessionStorage, "Browser failed write to session storage. " + Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["s" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["o" /* dumpObj */])(e) });
        }
    }
    return false;
}
function utlRemoveSessionStorage(logger, name) {
    var storage = _getSessionStorageObject();
    if (storage !== null) {
        try {
            storage.removeItem(name);
            return true;
        }
        catch (e) {
            _canUseSessionStorage = false;
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].BrowserFailedRemovalFromSessionStorage, "Browser failed removal of session storage item. " + Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["s" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["o" /* dumpObj */])(e) });
        }
    }
    return false;
}
//# sourceMappingURL=StorageHelperFuncs.js.map

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StorageType; });
/* unused harmony export DistributedTracingModes */
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * Type of storage to differentiate between local storage and session storage
 */
var StorageType;
(function (StorageType) {
    StorageType[StorageType["LocalStorage"] = 0] = "LocalStorage";
    StorageType[StorageType["SessionStorage"] = 1] = "SessionStorage";
})(StorageType || (StorageType = {}));
;
var DistributedTracingModes;
(function (DistributedTracingModes) {
    /**
     * (Default) Send Application Insights correlation headers
     */
    DistributedTracingModes[DistributedTracingModes["AI"] = 0] = "AI";
    /**
     * Send both W3C Trace Context headers and back-compatibility Application Insights headers
     */
    DistributedTracingModes[DistributedTracingModes["AI_AND_W3C"] = 1] = "AI_AND_W3C";
    /**
     * Send W3C Trace Context headers
     */
    DistributedTracingModes[DistributedTracingModes["W3C"] = 2] = "W3C";
})(DistributedTracingModes || (DistributedTracingModes = {}));
//# sourceMappingURL=Enums.js.map

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = urlParseUrl;
/* harmony export (immutable) */ __webpack_exports__["a"] = urlGetAbsoluteUrl;
/* harmony export (immutable) */ __webpack_exports__["c"] = urlGetPathName;
/* harmony export (immutable) */ __webpack_exports__["b"] = urlGetCompleteUrl;
/* harmony export (immutable) */ __webpack_exports__["e"] = urlParseHost;
/* harmony export (immutable) */ __webpack_exports__["d"] = urlParseFullHost;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(30);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



var _document = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["r" /* getDocument */])() || {};
var _htmlAnchorIdx = 0;
// Use an array of temporary values as it's possible for multiple calls to parseUrl() will be called with different URLs
// Using a cache size of 5 for now as it current depth usage is at least 2, so adding a minor buffer to handle future updates
var _htmlAnchorElement = [null, null, null, null, null];
function urlParseUrl(url) {
    var anchorIdx = _htmlAnchorIdx;
    var anchorCache = _htmlAnchorElement;
    var tempAnchor = anchorCache[anchorIdx];
    if (!_document.createElement) {
        // Always create the temp instance if createElement is not available
        tempAnchor = { host: urlParseHost(url, true) };
    }
    else if (!anchorCache[anchorIdx]) {
        // Create and cache the unattached anchor instance 
        tempAnchor = anchorCache[anchorIdx] = _document.createElement('a');
    }
    tempAnchor.href = url;
    // Move the cache index forward
    anchorIdx++;
    if (anchorIdx >= anchorCache.length) {
        anchorIdx = 0;
    }
    _htmlAnchorIdx = anchorIdx;
    return tempAnchor;
}
function urlGetAbsoluteUrl(url) {
    var result;
    var a = urlParseUrl(url);
    if (a) {
        result = a.href;
    }
    return result;
}
function urlGetPathName(url) {
    var result;
    var a = urlParseUrl(url);
    if (a) {
        result = a.pathname;
    }
    return result;
}
function urlGetCompleteUrl(method, absoluteUrl) {
    if (method) {
        return method.toUpperCase() + " " + absoluteUrl;
    }
    return absoluteUrl;
}
// Fallback method to grab host from url if document.createElement method is not available
function urlParseHost(url, inclPort) {
    var fullHost = urlParseFullHost(url, inclPort);
    if (fullHost) {
        var match = fullHost.match(/(www[0-9]?\.)?(.[^/:]+)(\:[\d]+)?/i);
        if (match != null && match.length > 3 && Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["I" /* isString */])(match[2]) && match[2].length > 0) {
            return match[2] + (match[3] || "");
        }
    }
    return fullHost;
}
function urlParseFullHost(url, inclPort) {
    var result = null;
    if (url) {
        var match = url.match(/(\w*):\/\/(.[^/:]+)(\:[\d]+)?/i);
        if (match != null && match.length > 2 && Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["I" /* isString */])(match[2]) && match[2].length > 0) {
            result = match[2] || "";
            if (inclPort && match.length > 2) {
                var protocol = (match[1] || "").toLowerCase();
                var port = match[3] || "";
                // IE includes the standard port so pass it off if it's the same as the protocol
                if (protocol === "http" && port === ":80") {
                    port = "";
                }
                else if (protocol === "https" && port === ":443") {
                    port = "";
                }
                result += port;
            }
        }
    }
    return result;
}
//# sourceMappingURL=UrlHelperFuncs.js.map

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Data; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Base__ = __webpack_require__(574);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



// THIS FILE WAS AUTOGENERATED

/**
 * Data struct to contain both B and C sections.
 */
var Data = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(Data, _super);
    function Data() {
        return _super.call(this) || this;
    }
    return Data;
}(__WEBPACK_IMPORTED_MODULE_1__Base__["a" /* Base */]));

//# sourceMappingURL=Data.js.map

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Base; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// THIS FILE WAS AUTOGENERATED
/**
 * Data struct to contain only C section with custom fields.
 */
var Base = /** @class */ (function () {
    function Base() {
    }
    return Base;
}());

//# sourceMappingURL=Base.js.map

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventData; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * Instances of Event represent structured event records that can be grouped and searched by their properties. Event data item also creates a metric of event count by name.
 */
var EventData = /** @class */ (function () {
    function EventData() {
        /**
         * Schema version
         */
        this.ver = 2;
        /**
         * Collection of custom properties.
         */
        this.properties = {};
        /**
         * Collection of custom measurements.
         */
        this.measurements = {};
    }
    return EventData;
}());

//# sourceMappingURL=EventData.js.map

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContextTagKeys; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__ = __webpack_require__(30);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




function _aiNameFunc(baseName) {
    var aiName = "ai." + baseName + ".";
    return function (name) {
        return aiName + name;
    };
}
var _aiApplication = _aiNameFunc("application");
var _aiDevice = _aiNameFunc("device");
var _aiLocation = _aiNameFunc("location");
var _aiOperation = _aiNameFunc("operation");
var _aiSession = _aiNameFunc("session");
var _aiUser = _aiNameFunc("user");
var _aiCloud = _aiNameFunc("cloud");
var _aiInternal = _aiNameFunc("internal");
var ContextTagKeys = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(ContextTagKeys, _super);
    function ContextTagKeys() {
        return _super.call(this) || this;
    }
    return ContextTagKeys;
}(Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["k" /* createClassFromInterface */])({
    applicationVersion: _aiApplication("ver"),
    applicationBuild: _aiApplication("build"),
    applicationTypeId: _aiApplication("typeId"),
    applicationId: _aiApplication("applicationId"),
    applicationLayer: _aiApplication("layer"),
    deviceId: _aiDevice("id"),
    deviceIp: _aiDevice("ip"),
    deviceLanguage: _aiDevice("language"),
    deviceLocale: _aiDevice("locale"),
    deviceModel: _aiDevice("model"),
    deviceFriendlyName: _aiDevice("friendlyName"),
    deviceNetwork: _aiDevice("network"),
    deviceNetworkName: _aiDevice("networkName"),
    deviceOEMName: _aiDevice("oemName"),
    deviceOS: _aiDevice("os"),
    deviceOSVersion: _aiDevice("osVersion"),
    deviceRoleInstance: _aiDevice("roleInstance"),
    deviceRoleName: _aiDevice("roleName"),
    deviceScreenResolution: _aiDevice("screenResolution"),
    deviceType: _aiDevice("type"),
    deviceMachineName: _aiDevice("machineName"),
    deviceVMName: _aiDevice("vmName"),
    deviceBrowser: _aiDevice("browser"),
    deviceBrowserVersion: _aiDevice("browserVersion"),
    locationIp: _aiLocation("ip"),
    locationCountry: _aiLocation("country"),
    locationProvince: _aiLocation("province"),
    locationCity: _aiLocation("city"),
    operationId: _aiOperation("id"),
    operationName: _aiOperation("name"),
    operationParentId: _aiOperation("parentId"),
    operationRootId: _aiOperation("rootId"),
    operationSyntheticSource: _aiOperation("syntheticSource"),
    operationCorrelationVector: _aiOperation("correlationVector"),
    sessionId: _aiSession("id"),
    sessionIsFirst: _aiSession("isFirst"),
    sessionIsNew: _aiSession("isNew"),
    userAccountAcquisitionDate: _aiUser("accountAcquisitionDate"),
    userAccountId: _aiUser("accountId"),
    userAgent: _aiUser("userAgent"),
    userId: _aiUser("id"),
    userStoreRegion: _aiUser("storeRegion"),
    userAuthUserId: _aiUser("authUserId"),
    userAnonymousUserAcquisitionDate: _aiUser("anonUserAcquisitionDate"),
    userAuthenticatedUserAcquisitionDate: _aiUser("authUserAcquisitionDate"),
    cloudName: _aiCloud("name"),
    cloudRole: _aiCloud("role"),
    cloudRoleVer: _aiCloud("roleVer"),
    cloudRoleInstance: _aiCloud("roleInstance"),
    cloudEnvironment: _aiCloud("environment"),
    cloudLocation: _aiCloud("location"),
    cloudDeploymentUnit: _aiCloud("deploymentUnit"),
    internalNodeName: _aiInternal("nodeName"),
    internalSdkVersion: _aiInternal("sdkVersion"),
    internalAgentVersion: _aiInternal("agentVersion"),
    internalSnippet: _aiInternal("snippet"),
    internalSdkSrc: _aiInternal("sdkSrc")
})));

//# sourceMappingURL=ContextTagKeys.js.map

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PropertiesPlugin__ = __webpack_require__(1459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Context_TelemetryTrace__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TelemetryContext__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Context_Session__ = __webpack_require__(584);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__PropertiesPlugin__["a"]; });
/* unused harmony reexport TelemetryTrace */
/* unused harmony reexport TelemetryContext */
/* unused harmony reexport Session */
/* unused harmony reexport SessionManager */
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







//# sourceMappingURL=applicationinsights-properties-js.js.map

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventsDiscardedReason; });
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * The EventsDiscardedReason enumeration contains a set of values that specify the reason for discarding an event.
 */
var EventsDiscardedReason = {
    /**
     * Unknown.
     */
    Unknown: 0,
    /**
     * Status set to non-retryable.
     */
    NonRetryableStatus: 1,
    /**
     * The event is invalid.
     */
    InvalidEvent: 2,
    /**
     * The size of the event is too large.
     */
    SizeLimitExceeded: 3,
    /**
     * The server is not accepting events from this instrumentation key.
     */
    KillSwitch: 4,
    /**
     * The event queue is full.
     */
    QueueFull: 5
};
//# sourceMappingURL=EventsDiscardedReason.js.map

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseCore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChannelController__ = __webpack_require__(1462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProcessTelemetryContext__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TelemetryHelpers__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PerfManager__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CookieMgr__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__HelperFuncs__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Constants__ = __webpack_require__(371);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */












var validationError = "Extensions must provide callback to initialize";
var strNotificationManager = "_notificationManager";
var BaseCore = /** @class */ (function () {
    function BaseCore() {
        var _isInitialized = false;
        var _eventQueue;
        var _channelController;
        var _notificationManager;
        var _perfManager;
        var _cookieManager;
        Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__["a" /* default */])(BaseCore, this, function (_self) {
            _self._extensions = new Array();
            _channelController = new __WEBPACK_IMPORTED_MODULE_2__ChannelController__["a" /* ChannelController */]();
            _self.logger = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["i" /* objCreateFn */])({
                throwInternal: function (severity, msgId, msg, properties, isUserAct) {
                    if (isUserAct === void 0) { isUserAct = false; }
                },
                warnToConsole: function (message) { },
                resetInternalMessageCount: function () { }
            });
            _eventQueue = [];
            _self.isInitialized = function () { return _isInitialized; };
            _self.initialize = function (config, extensions, logger, notificationManager) {
                // Make sure core is only initialized once
                if (_self.isInitialized()) {
                    Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["G" /* throwError */])("Core should not be initialized more than once");
                }
                if (!config || Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["s" /* isNullOrUndefined */])(config.instrumentationKey)) {
                    Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["G" /* throwError */])("Please provide instrumentation key");
                }
                _notificationManager = notificationManager;
                // For backward compatibility only
                _self[strNotificationManager] = notificationManager;
                _self.config = config || {};
                config.extensions = Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["s" /* isNullOrUndefined */])(config.extensions) ? [] : config.extensions;
                // add notification to the extensions in the config so other plugins can access it
                var extConfig = Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["j" /* getSetValue */])(config, __WEBPACK_IMPORTED_MODULE_8__Constants__["a" /* strExtensionConfig */]);
                extConfig.NotificationManager = notificationManager;
                if (logger) {
                    _self.logger = logger;
                }
                // Concat all available extensions
                var allExtensions = [];
                allExtensions.push.apply(allExtensions, extensions.concat(config.extensions));
                allExtensions = Object(__WEBPACK_IMPORTED_MODULE_4__TelemetryHelpers__["b" /* sortPlugins */])(allExtensions);
                var coreExtensions = [];
                var channelExtensions = [];
                // Check if any two extensions have the same priority, then warn to console
                // And extract the local extensions from the 
                var extPriorities = {};
                // Extension validation
                Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["a" /* arrForEach */])(allExtensions, function (ext) {
                    if (Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["s" /* isNullOrUndefined */])(ext) || Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["s" /* isNullOrUndefined */])(ext.initialize)) {
                        Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["G" /* throwError */])(validationError);
                    }
                    var extPriority = ext.priority;
                    var identifier = ext.identifier;
                    if (ext && extPriority) {
                        if (!Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["s" /* isNullOrUndefined */])(extPriorities[extPriority])) {
                            logger.warnToConsole("Two extensions have same priority #" + extPriority + " - " + extPriorities[extPriority] + ", " + identifier);
                        }
                        else {
                            // set a value
                            extPriorities[extPriority] = identifier;
                        }
                    }
                    // Split extensions to core and channelController
                    if (!extPriority || extPriority < _channelController.priority) {
                        // Add to core extension that will be managed by BaseCore
                        coreExtensions.push(ext);
                    }
                    else {
                        // Add all other extensions to be managed by the channel controller
                        channelExtensions.push(ext);
                    }
                });
                // Validation complete
                // Add the channelController to the complete extension collection and
                // to the end of the core extensions
                allExtensions.push(_channelController);
                coreExtensions.push(_channelController);
                // Sort the complete set of extensions by priority
                allExtensions = Object(__WEBPACK_IMPORTED_MODULE_4__TelemetryHelpers__["b" /* sortPlugins */])(allExtensions);
                _self._extensions = allExtensions;
                // initialize channel controller first, this will initialize all channel plugins
                Object(__WEBPACK_IMPORTED_MODULE_4__TelemetryHelpers__["a" /* initializePlugins */])(new __WEBPACK_IMPORTED_MODULE_3__ProcessTelemetryContext__["a" /* ProcessTelemetryContext */]([_channelController], config, _self), allExtensions);
                Object(__WEBPACK_IMPORTED_MODULE_4__TelemetryHelpers__["a" /* initializePlugins */])(new __WEBPACK_IMPORTED_MODULE_3__ProcessTelemetryContext__["a" /* ProcessTelemetryContext */](coreExtensions, config, _self), allExtensions);
                // Now reset the extensions to just those being managed by Basecore
                _self._extensions = coreExtensions;
                if (_self.getTransmissionControls().length === 0) {
                    Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["G" /* throwError */])("No channels available");
                }
                _isInitialized = true;
                _self.releaseQueue();
            };
            _self.getTransmissionControls = function () {
                return _channelController.getChannelControls();
            };
            _self.track = function (telemetryItem) {
                // setup default iKey if not passed in
                Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["C" /* setValue */])(telemetryItem, __WEBPACK_IMPORTED_MODULE_8__Constants__["b" /* strIKey */], _self.config.instrumentationKey, null, __WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["r" /* isNotTruthy */]);
                // add default timestamp if not passed in
                Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["C" /* setValue */])(telemetryItem, "time", Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["H" /* toISOString */])(new Date()), null, __WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["r" /* isNotTruthy */]);
                // Common Schema 4.0
                Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["C" /* setValue */])(telemetryItem, "ver", "4.0", null, __WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["s" /* isNullOrUndefined */]);
                if (_self.isInitialized()) {
                    // Process the telemetry plugin chain
                    _self.getProcessTelContext().processNext(telemetryItem);
                }
                else {
                    // Queue events until all extensions are initialized
                    _eventQueue.push(telemetryItem);
                }
            };
            _self.getProcessTelContext = function () {
                var extensions = _self._extensions;
                var thePlugins = extensions;
                // invoke any common telemetry processors before sending through pipeline
                if (!extensions || extensions.length === 0) {
                    // Pass to Channel controller so data is sent to correct channel queues
                    thePlugins = [_channelController];
                }
                return new __WEBPACK_IMPORTED_MODULE_3__ProcessTelemetryContext__["a" /* ProcessTelemetryContext */](thePlugins, _self.config, _self);
            };
            _self.getNotifyMgr = function () {
                if (!_notificationManager) {
                    // Create Dummy notification manager
                    _notificationManager = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["i" /* objCreateFn */])({
                        addNotificationListener: function (listener) { },
                        removeNotificationListener: function (listener) { },
                        eventsSent: function (events) { },
                        eventsDiscarded: function (events, reason) { },
                        eventsSendRequest: function (sendReason, isAsync) { }
                    });
                    // For backward compatibility only
                    _self[strNotificationManager] = _notificationManager;
                }
                return _notificationManager;
            };
            _self.getCookieMgr = function () {
                if (!_cookieManager) {
                    _cookieManager = Object(__WEBPACK_IMPORTED_MODULE_6__CookieMgr__["b" /* createCookieMgr */])(_self.config, _self.logger);
                }
                return _cookieManager;
            };
            _self.setCookieMgr = function (cookieMgr) {
                _cookieManager = cookieMgr;
            };
            _self.getPerfMgr = function () {
                if (!_perfManager) {
                    if (_self.config && _self.config.enablePerfMgr) {
                        _perfManager = new __WEBPACK_IMPORTED_MODULE_5__PerfManager__["a" /* PerfManager */](_self.getNotifyMgr());
                    }
                }
                return _perfManager;
            };
            _self.setPerfMgr = function (perfMgr) {
                _perfManager = perfMgr;
            };
            _self.eventCnt = function () {
                return _eventQueue.length;
            };
            _self.releaseQueue = function () {
                if (_eventQueue.length > 0) {
                    Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["a" /* arrForEach */])(_eventQueue, function (event) {
                        _self.getProcessTelContext().processNext(event);
                    });
                    _eventQueue = [];
                }
            };
        });
    }
// Removed Stub for BaseCore.prototype.initialize.
// Removed Stub for BaseCore.prototype.getTransmissionControls.
// Removed Stub for BaseCore.prototype.track.
// Removed Stub for BaseCore.prototype.getProcessTelContext.
// Removed Stub for BaseCore.prototype.getNotifyMgr.
// Removed Stub for BaseCore.prototype.getCookieMgr.
// Removed Stub for BaseCore.prototype.setCookieMgr.
// Removed Stub for BaseCore.prototype.getPerfMgr.
// Removed Stub for BaseCore.prototype.setPerfMgr.
// Removed Stub for BaseCore.prototype.eventCnt.
// Removed Stub for BaseCore.prototype.releaseQueue.
    return BaseCore;
}());

//# sourceMappingURL=BaseCore.js.map

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseTelemetryPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProcessTelemetryContext__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HelperFuncs__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Constants__ = __webpack_require__(371);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var strGetPlugin = "getPlugin";
/**
 * BaseTelemetryPlugin provides a basic implementation of the ITelemetryPlugin interface so that plugins
 * can avoid implementation the same set of boiler plate code as well as provide a base
 * implementation so that new default implementations can be added without breaking all plugins.
 */
var BaseTelemetryPlugin = /** @class */ (function () {
    function BaseTelemetryPlugin() {
        var _self = this;
        var _isinitialized = false;
        var _rootCtx = null; // Used as the root context, holding the current config and initialized core
        var _nextPlugin = null; // Used for backward compatibility where plugins don't call the main pipeline
        _self.core = null;
        _self.diagLog = function (itemCtx) {
            return _self._getTelCtx(itemCtx).diagLog();
        };
        _self.isInitialized = function () {
            return _isinitialized;
        };
        _self.setInitialized = function (isInitialized) {
            _isinitialized = isInitialized;
        };
        // _self.getNextPlugin = () => DO NOT IMPLEMENT
        // Sub-classes of this base class *should* not be relying on this value and instead
        // should use processNext() function. If you require access to the plugin use the
        // IProcessTelemetryContext.getNext().getPlugin() while in the pipeline, Note getNext() may return null.
        _self.setNextPlugin = function (next) {
            _nextPlugin = next;
        };
        _self.processNext = function (env, itemCtx) {
            if (itemCtx) {
                // Normal core execution sequence
                itemCtx.processNext(env);
            }
            else if (_nextPlugin && Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["p" /* isFunction */])(_nextPlugin.processTelemetry)) {
                // Looks like backward compatibility or out of band processing. And as it looks 
                // like a ITelemetryPlugin or ITelemetryPluginChain, just call processTelemetry
                _nextPlugin.processTelemetry(env, null);
            }
        };
        _self._getTelCtx = function (currentCtx) {
            if (currentCtx === void 0) { currentCtx = null; }
            var itemCtx = currentCtx;
            if (!itemCtx) {
                var rootCtx = _rootCtx || new __WEBPACK_IMPORTED_MODULE_0__ProcessTelemetryContext__["a" /* ProcessTelemetryContext */](null, {}, _self.core);
                // tslint:disable-next-line: prefer-conditional-expression
                if (_nextPlugin && _nextPlugin[strGetPlugin]) {
                    // Looks like a chain object
                    itemCtx = rootCtx.createNew(null, _nextPlugin[strGetPlugin]);
                }
                else {
                    itemCtx = rootCtx.createNew(null, _nextPlugin);
                }
            }
            return itemCtx;
        };
        _self._baseTelInit = function (config, core, extensions, pluginChain) {
            if (config) {
                // Make sure the extensionConfig exists
                Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["C" /* setValue */])(config, __WEBPACK_IMPORTED_MODULE_2__Constants__["a" /* strExtensionConfig */], [], null, __WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["s" /* isNullOrUndefined */]);
            }
            if (!pluginChain && core) {
                // Get the first plugin from the core
                pluginChain = core.getProcessTelContext().getNext();
            }
            var nextPlugin = _nextPlugin;
            if (_nextPlugin && _nextPlugin[strGetPlugin]) {
                // If it looks like a proxy/chain then get the plugin
                nextPlugin = _nextPlugin[strGetPlugin]();
            }
            // Support legacy plugins where core was defined as a property
            _self.core = core;
            _rootCtx = new __WEBPACK_IMPORTED_MODULE_0__ProcessTelemetryContext__["a" /* ProcessTelemetryContext */](pluginChain, config, core, nextPlugin);
            _isinitialized = true;
        };
    }
    BaseTelemetryPlugin.prototype.initialize = function (config, core, extensions, pluginChain) {
        this._baseTelInit(config, core, extensions, pluginChain);
    };
    return BaseTelemetryPlugin;
}());

//# sourceMappingURL=BaseTelemetryPlugin.js.map

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NotificationManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HelperFuncs__ = __webpack_require__(44);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * Class to manage sending notifications to all the listeners.
 */
var NotificationManager = /** @class */ (function () {
    function NotificationManager(config) {
        this.listeners = [];
        var perfEvtsSendAll = !!(config || {}).perfEvtsSendAll;
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__["a" /* default */])(NotificationManager, this, function (_self) {
            _self.addNotificationListener = function (listener) {
                _self.listeners.push(listener);
            };
            /**
             * Removes all instances of the listener.
             * @param {INotificationListener} listener - AWTNotificationListener to remove.
             */
            _self.removeNotificationListener = function (listener) {
                var index = Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["b" /* arrIndexOf */])(_self.listeners, listener);
                while (index > -1) {
                    _self.listeners.splice(index, 1);
                    index = Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["b" /* arrIndexOf */])(_self.listeners, listener);
                }
            };
            /**
             * Notification for events sent.
             * @param {ITelemetryItem[]} events - The array of events that have been sent.
             */
            _self.eventsSent = function (events) {
                Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["a" /* arrForEach */])(_self.listeners, function (listener) {
                    if (listener && listener.eventsSent) {
                        setTimeout(function () { return listener.eventsSent(events); }, 0);
                    }
                });
            };
            /**
             * Notification for events being discarded.
             * @param {ITelemetryItem[]} events - The array of events that have been discarded by the SDK.
             * @param {number} reason           - The reason for which the SDK discarded the events. The EventsDiscardedReason
             * constant should be used to check the different values.
             */
            _self.eventsDiscarded = function (events, reason) {
                Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["a" /* arrForEach */])(_self.listeners, function (listener) {
                    if (listener && listener.eventsDiscarded) {
                        setTimeout(function () { return listener.eventsDiscarded(events, reason); }, 0);
                    }
                });
            };
            /**
             * [Optional] A function called when the events have been requested to be sent to the sever.
             * @param {number} sendReason - The reason why the event batch is being sent.
             * @param {boolean} isAsync   - A flag which identifies whether the requests are being sent in an async or sync manner.
             */
            _self.eventsSendRequest = function (sendReason, isAsync) {
                Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["a" /* arrForEach */])(_self.listeners, function (listener) {
                    if (listener && listener.eventsSendRequest) {
                        if (isAsync) {
                            setTimeout(function () { return listener.eventsSendRequest(sendReason, isAsync); }, 0);
                        }
                        else {
                            try {
                                listener.eventsSendRequest(sendReason, isAsync);
                            }
                            catch (e) {
                                // Catch errors to ensure we don't block sending the requests
                            }
                        }
                    }
                });
            };
            _self.perfEvent = function (perfEvent) {
                if (perfEvent) {
                    // Send all events or only parent events
                    if (perfEvtsSendAll || !perfEvent.isChildEvt()) {
                        Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["a" /* arrForEach */])(_self.listeners, function (listener) {
                            if (listener && listener.perfEvent) {
                                if (perfEvent.isAsync) {
                                    setTimeout(function () { return listener.perfEvent(perfEvent); }, 0);
                                }
                                else {
                                    try {
                                        listener.perfEvent(perfEvent);
                                    }
                                    catch (e) {
                                        // Catch errors to ensure we don't block sending the requests
                                    }
                                }
                            }
                        });
                    }
                }
            };
        });
    }
// Removed Stub for NotificationManager.prototype.addNotificationListener.
// Removed Stub for NotificationManager.prototype.removeNotificationListener.
// Removed Stub for NotificationManager.prototype.eventsSent.
// Removed Stub for NotificationManager.prototype.eventsDiscarded.
// Removed Stub for NotificationManager.prototype.eventsSendRequest.
    return NotificationManager;
}());

//# sourceMappingURL=NotificationManager.js.map

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = randomValue;
/* harmony export (immutable) */ __webpack_exports__["c"] = random32;
/* harmony export (immutable) */ __webpack_exports__["b"] = mwcRandomSeed;
/* harmony export (immutable) */ __webpack_exports__["a"] = mwcRandom32;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EnvUtils__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HelperFuncs__ = __webpack_require__(44);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var UInt32Mask = 0x100000000;
var MaxUInt32 = 0xffffffff;
// MWC based Random generator (for IE)
var _mwcSeeded = false;
var _mwcW = 123456789;
var _mwcZ = 987654321;
// Takes any integer
function _mwcSeed(seedValue) {
    if (seedValue < 0) {
        // Make sure we end up with a positive number and not -ve one.
        seedValue >>>= 0;
    }
    _mwcW = (123456789 + seedValue) & MaxUInt32;
    _mwcZ = (987654321 - seedValue) & MaxUInt32;
    _mwcSeeded = true;
}
function _autoSeedMwc() {
    // Simple initialization using default Math.random() - So we inherit any entropy from the browser
    // and bitwise XOR with the current milliseconds
    try {
        var now = Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["g" /* dateNow */])() & 0x7fffffff;
        _mwcSeed(((Math.random() * UInt32Mask) ^ now) + now);
    }
    catch (e) {
        // Don't crash if something goes wrong
    }
}
/**
 * Generate a random value between 0 and maxValue, max value should be limited to a 32-bit maximum.
 * So maxValue(16) will produce a number from 0..16 (range of 17)
 * @param maxValue
 */
function randomValue(maxValue) {
    if (maxValue > 0) {
        return Math.floor((random32() / MaxUInt32) * (maxValue + 1)) >>> 0;
    }
    return 0;
}
/**
 * generate a random 32-bit number (0x000000..0xFFFFFFFF) or (-0x80000000..0x7FFFFFFF), defaults un-unsigned.
 * @param signed - True to return a signed 32-bit number (-0x80000000..0x7FFFFFFF) otherwise an unsigned one (0x000000..0xFFFFFFFF)
 */
function random32(signed) {
    var value;
    var c = Object(__WEBPACK_IMPORTED_MODULE_0__EnvUtils__["c" /* getCrypto */])() || Object(__WEBPACK_IMPORTED_MODULE_0__EnvUtils__["i" /* getMsCrypto */])();
    if (c && c.getRandomValues) {
        // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
        value = c.getRandomValues(new Uint32Array(1))[0] & MaxUInt32;
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_0__EnvUtils__["o" /* isIE */])()) {
        // For IE 6, 7, 8 (especially on XP) Math.random is not very random
        if (!_mwcSeeded) {
            // Set the seed for the Mwc algorithm
            _autoSeedMwc();
        }
        // Don't use Math.random for IE
        // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
        value = mwcRandom32() & MaxUInt32;
    }
    else {
        // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
        value = Math.floor((UInt32Mask * Math.random()) | 0);
    }
    if (!signed) {
        // Make sure we end up with a positive number and not -ve one.
        value >>>= 0;
    }
    return value;
}
/**
 * Seed the MWC random number generator with the specified seed or a random value
 * @param value - optional the number to used as the seed, if undefined, null or zero a random value will be chosen
 */
function mwcRandomSeed(value) {
    if (!value) {
        _autoSeedMwc();
    }
    else {
        _mwcSeed(value);
    }
}
/**
 * Generate a random 32-bit number between (0x000000..0xFFFFFFFF) or (-0x80000000..0x7FFFFFFF), using MWC (Multiply with carry)
 * instead of Math.random() defaults to un-signed.
 * Used as a replacement random generator for IE to avoid issues with older IE instances.
 * @param signed - True to return a signed 32-bit number (-0x80000000..0x7FFFFFFF) otherwise an unsigned one (0x000000..0xFFFFFFFF)
 */
function mwcRandom32(signed) {
    _mwcZ = (36969 * (_mwcZ & 0xFFFF) + (_mwcZ >> 16)) & MaxUInt32;
    _mwcW = (18000 * (_mwcW & 0xFFFF) + (_mwcW >> 16)) & MaxUInt32;
    var value = (((_mwcZ << 16) + (_mwcW & 0xFFFF)) >>> 0) & MaxUInt32 | 0;
    if (!signed) {
        // Make sure we end up with a positive number and not -ve one.
        value >>>= 0;
    }
    return value;
}
//# sourceMappingURL=RandomHelper.js.map

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TelemetryContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Context_Session__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Context_Application__ = __webpack_require__(1491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Context_Device__ = __webpack_require__(1492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Context_Internal__ = __webpack_require__(1493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Context_User__ = __webpack_require__(1494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Context_Location__ = __webpack_require__(1495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Context_TelemetryTrace__ = __webpack_require__(595);
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
 * TelemetryContext.ts
 * @copyright Microsoft 2018
 */










var strExt = "ext";
var strTags = "tags";
function _removeEmpty(target, name) {
    if (target && target[name] && Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["L" /* objKeys */])(target[name]).length === 0) {
        delete target[name];
    }
}
var TelemetryContext = /** @class */ (function () {
    function TelemetryContext(core, defaultConfig) {
        var _this = this;
        var logger = core.logger;
        this.appId = function () { return null; };
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__["a" /* default */])(TelemetryContext, this, function (_self) {
            _self.application = new __WEBPACK_IMPORTED_MODULE_4__Context_Application__["a" /* Application */]();
            _self.internal = new __WEBPACK_IMPORTED_MODULE_6__Context_Internal__["a" /* Internal */](defaultConfig);
            if (Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["B" /* hasWindow */])()) {
                _self.sessionManager = new __WEBPACK_IMPORTED_MODULE_2__Context_Session__["b" /* _SessionManager */](defaultConfig, core);
                _self.device = new __WEBPACK_IMPORTED_MODULE_5__Context_Device__["a" /* Device */]();
                _self.location = new __WEBPACK_IMPORTED_MODULE_8__Context_Location__["a" /* Location */]();
                _self.user = new __WEBPACK_IMPORTED_MODULE_7__Context_User__["a" /* User */](defaultConfig, core);
                _self.telemetryTrace = new __WEBPACK_IMPORTED_MODULE_9__Context_TelemetryTrace__["a" /* TelemetryTrace */](undefined, undefined, undefined, logger);
                _self.session = new __WEBPACK_IMPORTED_MODULE_2__Context_Session__["a" /* Session */]();
            }
            _self.applySessionContext = function (evt, itemCtx) {
                var session = _self.session;
                var sessionManager = _self.sessionManager;
                // If customer set session info, apply their context; otherwise apply context automatically generated
                if (session && Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["I" /* isString */])(session.id)) {
                    Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["Q" /* setValue */])(Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["z" /* getSetValue */])(evt.ext, __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["c" /* Extensions */].AppExt), "sesId", session.id);
                }
                else if (sessionManager && sessionManager.automaticSession) {
                    Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["Q" /* setValue */])(Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["z" /* getSetValue */])(evt.ext, __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["c" /* Extensions */].AppExt), "sesId", sessionManager.automaticSession.id, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["I" /* isString */]);
                }
            };
            _self.applyOperatingSystemContxt = function (evt, itemCtx) {
                Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["Q" /* setValue */])(evt.ext, __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["c" /* Extensions */].OSExt, _self.os);
            };
            _self.applyApplicationContext = function (evt, itemCtx) {
                var application = _self.application;
                if (application) {
                    // evt.ext.app
                    var tags = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["z" /* getSetValue */])(evt, strTags);
                    Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["Q" /* setValue */])(tags, __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["b" /* CtxTagKeys */].applicationVersion, application.ver, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["I" /* isString */]);
                    Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["Q" /* setValue */])(tags, __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["b" /* CtxTagKeys */].applicationBuild, application.build, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["I" /* isString */]);
                }
            };
            _self.applyDeviceContext = function (evt, itemCtx) {
                var device = _self.device;
                if (device) {
                    // evt.ext.device
                    var extDevice = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["z" /* getSetValue */])(Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["z" /* getSetValue */])(evt, strExt), __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["c" /* Extensions */].DeviceExt);
                    Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["Q" /* setValue */])(extDevice, "localId", device.id, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["I" /* isString */]);
                    Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["Q" /* setValue */])(extDevice, "ip", device.ip, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["I" /* isString */]);
                    Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["Q" /* setValue */])(extDevice, "model", device.model, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["I" /* isString */]);
                    Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["Q" /* setValue */])(extDevice, "deviceClass", device.deviceClass, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["I" /* isString */]);
                }
            };
            _self.applyInternalContext = function (evt, itemCtx) {
                var internal = _self.internal;
                if (internal) {
                    var tags = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["z" /* getSetValue */])(evt, strTags);
                    Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["Q" /* setValue */])(tags, __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["b" /* CtxTagKeys */].internalAgentVersion, internal.agentVersion, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["I" /* isString */]); // not mapped in CS 4.0
                    Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["Q" /* setValue */])(tags, __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["b" /* CtxTagKeys */].internalSdkVersion, internal.sdkVersion, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["I" /* isString */]);
                    if (evt.baseType === __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["c" /* _InternalLogMessage */].dataType || evt.baseType === __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["d" /* PageView */].dataType) {
                        Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["Q" /* setValue */])(tags, __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["b" /* CtxTagKeys */].internalSnippet, internal.snippetVer, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["I" /* isString */]);
                        Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["Q" /* setValue */])(tags, __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["b" /* CtxTagKeys */].internalSdkSrc, internal.sdkSrc, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["I" /* isString */]);
                    }
                }
            };
            _self.applyLocationContext = function (evt, itemCtx) {
                var location = _this.location;
                if (location) {
                    Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["Q" /* setValue */])(Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["z" /* getSetValue */])(evt, strTags, []), __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["b" /* CtxTagKeys */].locationIp, location.ip, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["I" /* isString */]);
                }
            };
            _self.applyOperationContext = function (evt, itemCtx) {
                var telemetryTrace = _self.telemetryTrace;
                if (telemetryTrace) {
                    var extTrace = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["z" /* getSetValue */])(Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["z" /* getSetValue */])(evt, strExt), __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["c" /* Extensions */].TraceExt, { traceID: undefined, parentID: undefined });
                    Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["Q" /* setValue */])(extTrace, "traceID", telemetryTrace.traceID, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["I" /* isString */]);
                    Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["Q" /* setValue */])(extTrace, "name", telemetryTrace.name, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["I" /* isString */]);
                    Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["Q" /* setValue */])(extTrace, "parentID", telemetryTrace.parentID, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["I" /* isString */]);
                }
            };
            _self.applyWebContext = function (evt, itemCtx) {
                var web = _this.web;
                if (web) {
                    Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["Q" /* setValue */])(Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["z" /* getSetValue */])(evt, strExt), __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["c" /* Extensions */].WebExt, web);
                }
            };
            _self.applyUserContext = function (evt, itemCtx) {
                var user = _self.user;
                if (user) {
                    var tags = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["z" /* getSetValue */])(evt, strTags, []);
                    // stays in tags
                    Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["Q" /* setValue */])(tags, __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["b" /* CtxTagKeys */].userAccountId, user.accountId, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["I" /* isString */]);
                    // CS 4.0
                    var extUser = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["z" /* getSetValue */])(Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["z" /* getSetValue */])(evt, strExt), __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["c" /* Extensions */].UserExt);
                    Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["Q" /* setValue */])(extUser, "id", user.id, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["I" /* isString */]);
                    Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["Q" /* setValue */])(extUser, "authId", user.authenticatedId, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["I" /* isString */]);
                }
            };
            _self.cleanUp = function (evt, itemCtx) {
                var ext = evt.ext;
                if (ext) {
                    _removeEmpty(ext, __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["c" /* Extensions */].DeviceExt);
                    _removeEmpty(ext, __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["c" /* Extensions */].UserExt);
                    _removeEmpty(ext, __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["c" /* Extensions */].WebExt);
                    _removeEmpty(ext, __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["c" /* Extensions */].OSExt);
                    _removeEmpty(ext, __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["c" /* Extensions */].AppExt);
                    _removeEmpty(ext, __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__["c" /* Extensions */].TraceExt);
                }
            };
        });
    }
// Removed Stub for TelemetryContext.prototype.applySessionContext.
// Removed Stub for TelemetryContext.prototype.applyOperatingSystemContxt.
// Removed Stub for TelemetryContext.prototype.applyApplicationContext.
// Removed Stub for TelemetryContext.prototype.applyDeviceContext.
// Removed Stub for TelemetryContext.prototype.applyInternalContext.
// Removed Stub for TelemetryContext.prototype.applyLocationContext.
// Removed Stub for TelemetryContext.prototype.applyOperationContext.
// Removed Stub for TelemetryContext.prototype.applyWebContext.
// Removed Stub for TelemetryContext.prototype.applyUserContext.
// Removed Stub for TelemetryContext.prototype.cleanUp.
    return TelemetryContext;
}());

//# sourceMappingURL=TelemetryContext.js.map

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Session; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _SessionManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__ = __webpack_require__(34);
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





var cookieNameConst = 'ai_session';
var Session = /** @class */ (function () {
    function Session() {
    }
    return Session;
}());

var _SessionManager = /** @class */ (function () {
    function _SessionManager(config, core) {
        var self = this;
        var _storageNamePrefix;
        var _cookieUpdatedTimestamp;
        var _logger = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["O" /* safeGetLogger */])(core);
        var _cookieManager = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["N" /* safeGetCookieMgr */])(core);
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__["a" /* default */])(_SessionManager, self, function (_self) {
            if (!config) {
                config = {};
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["F" /* isFunction */])(config.sessionExpirationMs)) {
                config.sessionExpirationMs = function () { return _SessionManager.acquisitionSpan; };
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["F" /* isFunction */])(config.sessionRenewalMs)) {
                config.sessionRenewalMs = function () { return _SessionManager.renewalSpan; };
            }
            _self.config = config;
            _storageNamePrefix = function () { return _self.config.namePrefix && _self.config.namePrefix() ? cookieNameConst + _self.config.namePrefix() : cookieNameConst; };
            _self.automaticSession = new Session();
            _self.update = function () {
                // Always using Date getTime() as there is a bug in older IE instances that causes the performance timings to have the hi-bit set eg 0x800000000 causing
                // the number to be incorrect.
                var nowMs = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["k" /* dateNow */])();
                var isExpired = false;
                var session = _self.automaticSession;
                if (!session.id) {
                    isExpired = !_initializeAutomaticSession(session, nowMs);
                }
                var sessionExpirationMs = _self.config.sessionExpirationMs();
                if (!isExpired && sessionExpirationMs > 0) {
                    var sessionRenewalMs = _self.config.sessionRenewalMs();
                    var timeSinceAcqMs = nowMs - session.acquisitionDate;
                    var timeSinceRenewalMs = nowMs - session.renewalDate;
                    isExpired = timeSinceAcqMs < 0 || timeSinceRenewalMs < 0; // expired if the acquisition or last renewal are in the future
                    isExpired = isExpired || timeSinceAcqMs > sessionExpirationMs; // expired if the time since acquisition is more than session Expiration
                    isExpired = isExpired || timeSinceRenewalMs > sessionRenewalMs; // expired if the time since last renewal is more than renewal period
                }
                // renew if acquisitionSpan or renewalSpan has elapsed
                if (isExpired) {
                    // update automaticSession so session state has correct id
                    _renew(nowMs);
                }
                else {
                    // do not update the cookie more often than cookieUpdateInterval
                    if (!_cookieUpdatedTimestamp || nowMs - _cookieUpdatedTimestamp > _SessionManager.cookieUpdateInterval) {
                        _setCookie(session, nowMs);
                    }
                }
            };
            /**
             *  Record the current state of the automatic session and store it in our cookie string format
             *  into the browser's local storage. This is used to restore the session data when the cookie
             *  expires.
             */
            _self.backup = function () {
                var session = _self.automaticSession;
                _setStorage(session.id, session.acquisitionDate, session.renewalDate);
            };
            /**
             * Use config.namePrefix + ai_session cookie data or local storage data (when the cookie is unavailable) to
             * initialize the automatic session.
             * @returns true if values set otherwise false
             */
            function _initializeAutomaticSession(session, now) {
                var isValid = false;
                var cookieValue = _cookieManager.get(_storageNamePrefix());
                if (cookieValue && Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["F" /* isFunction */])(cookieValue.split)) {
                    isValid = _initializeAutomaticSessionWithData(session, cookieValue);
                }
                else {
                    // There's no cookie, but we might have session data in local storage
                    // This can happen if the session expired or the user actively deleted the cookie
                    // We only want to recover data if the cookie is missing from expiry. We should respect the user's wishes if the cookie was deleted actively.
                    // The User class handles this for us and deletes our local storage object if the persistent user cookie was removed.
                    var storageValue = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["i" /* utlGetLocalStorage */])(_logger, _storageNamePrefix());
                    if (storageValue) {
                        isValid = _initializeAutomaticSessionWithData(session, storageValue);
                    }
                }
                return isValid || !!session.id;
            }
            /**
             * Extract id, acquisitionDate, and renewalDate from an ai_session payload string and
             * use this data to initialize automaticSession.
             *
             * @param {string} sessionData - The string stored in an ai_session cookie or local storage backup
             * @returns true if values set otherwise false
             */
            function _initializeAutomaticSessionWithData(session, sessionData) {
                var isValid = false;
                var sessionReset = ", session will be reset";
                var tokens = sessionData.split("|");
                if (tokens.length >= 2) {
                    try {
                        var acqMs = +tokens[1] || 0;
                        var renewalMs = +tokens[2] || 0;
                        if (isNaN(acqMs) || acqMs <= 0) {
                            _logger.throwInternal(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].SessionRenewalDateIsZero, "AI session acquisition date is 0" + sessionReset);
                        }
                        else if (isNaN(renewalMs) || renewalMs <= 0) {
                            _logger.throwInternal(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].SessionRenewalDateIsZero, "AI session renewal date is 0" + sessionReset);
                        }
                        else if (tokens[0]) {
                            // Everything looks valid so set the values
                            session.id = tokens[0];
                            session.acquisitionDate = acqMs;
                            session.renewalDate = renewalMs;
                            isValid = true;
                        }
                    }
                    catch (e) {
                        _logger.throwInternal(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].ErrorParsingAISessionCookie, "Error parsing ai_session value [" + (sessionData || "") + "]" + sessionReset + " - " + Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["r" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["n" /* dumpObj */])(e) });
                    }
                }
                return isValid;
            }
            function _renew(nowMs) {
                var theConfig = (_self.config || {});
                var getNewId = (theConfig.getNewId ? theConfig.getNewId() : null) || __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["J" /* newId */];
                _self.automaticSession.id = getNewId(theConfig.idLength ? theConfig.idLength() : 22);
                _self.automaticSession.acquisitionDate = nowMs;
                _setCookie(_self.automaticSession, nowMs);
                // If this browser does not support local storage, fire an internal log to keep track of it at this point
                if (!Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["h" /* utlCanUseLocalStorage */])()) {
                    _logger.throwInternal(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].BrowserDoesNotSupportLocalStorage, "Browser does not support local storage. Session durations will be inaccurate.");
                }
            }
            function _setCookie(session, nowMs) {
                var acq = session.acquisitionDate;
                session.renewalDate = nowMs;
                var config = _self.config;
                var renewalPeriodMs = config.sessionRenewalMs();
                // Set cookie to expire after the session expiry time passes or the session renewal deadline, whichever is sooner
                // Expiring the cookie will cause the session to expire even if the user isn't on the page
                var acqTimeLeftMs = (acq + config.sessionExpirationMs()) - nowMs;
                var cookie = [session.id, acq, nowMs];
                var maxAgeSec = 0;
                if (acqTimeLeftMs < renewalPeriodMs) {
                    maxAgeSec = acqTimeLeftMs / 1000;
                }
                else {
                    maxAgeSec = renewalPeriodMs / 1000;
                }
                var cookieDomain = config.cookieDomain ? config.cookieDomain() : null;
                // if sessionExpirationMs is set to 0, it means the expiry is set to 0 for this session cookie
                // A cookie with 0 expiry in the session cookie will never expire for that browser session.  If the browser is closed the cookie expires.  
                // Depending on the browser, another instance does not inherit this cookie, however, another tab will
                _cookieManager.set(_storageNamePrefix(), cookie.join('|'), config.sessionExpirationMs() > 0 ? maxAgeSec : null, cookieDomain);
                _cookieUpdatedTimestamp = nowMs;
            }
            function _setStorage(guid, acq, renewal) {
                // Keep data in local storage to retain the last session id, allowing us to cleanly end the session when it expires
                // Browsers that don't support local storage won't be able to end sessions cleanly from the client
                // The server will notice this and end the sessions itself, with loss of accurate session duration
                Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["k" /* utlSetLocalStorage */])(_logger, _storageNamePrefix(), [guid, acq, renewal].join('|'));
            }
        });
    }
// Removed Stub for _SessionManager.prototype.update.
// Removed Stub for _SessionManager.prototype.backup.
    _SessionManager.acquisitionSpan = 86400000; // 24 hours in ms
    _SessionManager.renewalSpan = 1800000; // 30 minutes in ms
    _SessionManager.cookieUpdateInterval = 60000; // 1 minute in ms
    return _SessionManager;
}());

//# sourceMappingURL=Session.js.map

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isInternalApplicationInsightsEndpoint */
/* unused harmony export Util */
/* unused harmony export UrlHelper */
/* unused harmony export CorrelationIdHelper */
/* harmony export (immutable) */ __webpack_exports__["a"] = AjaxHelperParseDependencyPath;
/* unused harmony export dateTimeUtilsNow */
/* unused harmony export dateTimeUtilsDuration */
/* unused harmony export DateTimeUtils */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RequestResponseHeaders__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Telemetry_Common_DataSanitizer__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DomHelperFuncs__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HelperFuncs__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Constants__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__ = __webpack_require__(590);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */










// listing only non-geo specific locations
var _internalEndpoints = [
    "https://dc.services.visualstudio.com/v2/track",
    "https://breeze.aimon.applicationinsights.io/v2/track",
    "https://dc-int.services.visualstudio.com/v2/track"
];
function isInternalApplicationInsightsEndpoint(endpointUrl) {
    return _internalEndpoints.indexOf(endpointUrl.toLowerCase()) !== -1;
}
var Util = {
    NotSpecified: __WEBPACK_IMPORTED_MODULE_5__Constants__["b" /* strNotSpecified */],
    createDomEvent: __WEBPACK_IMPORTED_MODULE_3__DomHelperFuncs__["a" /* createDomEvent */],
    disableStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["c" /* utlDisableStorage */],
    isInternalApplicationInsightsEndpoint: isInternalApplicationInsightsEndpoint,
    canUseLocalStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["a" /* utlCanUseLocalStorage */],
    getStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["d" /* utlGetLocalStorage */],
    setStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["i" /* utlSetLocalStorage */],
    removeStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["h" /* utlRemoveStorage */],
    canUseSessionStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["b" /* utlCanUseSessionStorage */],
    getSessionStorageKeys: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["f" /* utlGetSessionStorageKeys */],
    getSessionStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["e" /* utlGetSessionStorage */],
    setSessionStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["j" /* utlSetSessionStorage */],
    removeSessionStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["g" /* utlRemoveSessionStorage */],
    disableCookies: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["m" /* disableCookies */],
    canUseCookies: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["i" /* canUseCookies */],
    disallowsSameSiteNone: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["T" /* uaDisallowsSameSiteNone */],
    setCookie: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["P" /* setCookie */],
    stringToBoolOrDefault: __WEBPACK_IMPORTED_MODULE_4__HelperFuncs__["e" /* stringToBoolOrDefault */],
    getCookie: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["p" /* getCookie */],
    deleteCookie: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["l" /* deleteCookie */],
    trim: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["R" /* strTrim */],
    newId: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["J" /* newId */],
    random32: function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["M" /* random32 */])(true);
    },
    generateW3CId: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["o" /* generateW3CId */],
    isArray: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["C" /* isArray */],
    isError: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["E" /* isError */],
    isDate: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["D" /* isDate */],
    toISOStringForIE8: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["S" /* toISOString */],
    getIEVersion: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["u" /* getIEVersion */],
    msToTimeSpan: __WEBPACK_IMPORTED_MODULE_4__HelperFuncs__["d" /* msToTimeSpan */],
    isCrossOriginError: __WEBPACK_IMPORTED_MODULE_4__HelperFuncs__["c" /* isCrossOriginError */],
    dump: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["n" /* dumpObj */],
    getExceptionName: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["r" /* getExceptionName */],
    addEventHandler: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["h" /* attachEvent */],
    IsBeaconApiSupported: __WEBPACK_IMPORTED_MODULE_4__HelperFuncs__["b" /* isBeaconApiSupported */],
    getExtension: __WEBPACK_IMPORTED_MODULE_4__HelperFuncs__["a" /* getExtensionByName */]
};
;
var UrlHelper = {
    parseUrl: __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["f" /* urlParseUrl */],
    getAbsoluteUrl: __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["a" /* urlGetAbsoluteUrl */],
    getPathName: __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["c" /* urlGetPathName */],
    getCompleteUrl: __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["b" /* urlGetCompleteUrl */],
    parseHost: __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["e" /* urlParseHost */],
    parseFullHost: __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["d" /* urlParseFullHost */]
};
var CorrelationIdHelper = {
    correlationIdPrefix: "cid-v1:",
    /**
     * Checks if a request url is not on a excluded domain list and if it is safe to add correlation headers.
     * Headers are always included if the current domain matches the request domain. If they do not match (CORS),
     * they are regex-ed across correlationHeaderDomains and correlationHeaderExcludedDomains to determine if headers are included.
     * Some environments don't give information on currentHost via window.location.host (e.g. Cordova). In these cases, the user must
     * manually supply domains to include correlation headers on. Else, no headers will be included at all.
     */
    canIncludeCorrelationHeader: function (config, requestUrl, currentHost) {
        if (!requestUrl || (config && config.disableCorrelationHeaders)) {
            return false;
        }
        if (config && config.correlationHeaderExcludePatterns) {
            for (var i = 0; i < config.correlationHeaderExcludePatterns.length; i++) {
                if (config.correlationHeaderExcludePatterns[i].test(requestUrl)) {
                    return false;
                }
            }
        }
        var requestHost = Object(__WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["f" /* urlParseUrl */])(requestUrl).host.toLowerCase();
        if (requestHost && (requestHost.indexOf(":443") !== -1 || requestHost.indexOf(":80") !== -1)) {
            // [Bug #1260] IE can include the port even for http and https URLs so if present 
            // try and parse it to remove if it matches the default protocol port
            requestHost = (Object(__WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["d" /* urlParseFullHost */])(requestUrl, true) || "").toLowerCase();
        }
        if ((!config || !config.enableCorsCorrelation) && requestHost !== currentHost) {
            return false;
        }
        var includedDomains = config && config.correlationHeaderDomains;
        if (includedDomains) {
            var matchExists_1;
            Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["e" /* arrForEach */])(includedDomains, function (domain) {
                var regex = new RegExp(domain.toLowerCase().replace(/\./g, "\.").replace(/\*/g, ".*"));
                matchExists_1 = matchExists_1 || regex.test(requestHost);
            });
            if (!matchExists_1) {
                return false;
            }
        }
        var excludedDomains = config && config.correlationHeaderExcludedDomains;
        if (!excludedDomains || excludedDomains.length === 0) {
            return true;
        }
        for (var i = 0; i < excludedDomains.length; i++) {
            var regex = new RegExp(excludedDomains[i].toLowerCase().replace(/\./g, "\.").replace(/\*/g, ".*"));
            if (regex.test(requestHost)) {
                return false;
            }
        }
        // if we don't know anything about the requestHost, require the user to use included/excludedDomains.
        // Previously we always returned false for a falsy requestHost
        return requestHost && requestHost.length > 0;
    },
    /**
     * Combines target appId and target role name from response header.
     */
    getCorrelationContext: function (responseHeader) {
        if (responseHeader) {
            var correlationId = CorrelationIdHelper.getCorrelationContextValue(responseHeader, __WEBPACK_IMPORTED_MODULE_1__RequestResponseHeaders__["a" /* RequestHeaders */].requestContextTargetKey);
            if (correlationId && correlationId !== CorrelationIdHelper.correlationIdPrefix) {
                return correlationId;
            }
        }
    },
    /**
     * Gets key from correlation response header
     */
    getCorrelationContextValue: function (responseHeader, key) {
        if (responseHeader) {
            var keyValues = responseHeader.split(",");
            for (var i = 0; i < keyValues.length; ++i) {
                var keyValue = keyValues[i].split("=");
                if (keyValue.length === 2 && keyValue[0] === key) {
                    return keyValue[1];
                }
            }
        }
    }
};
function AjaxHelperParseDependencyPath(logger, absoluteUrl, method, commandName) {
    var target, name = commandName, data = commandName;
    if (absoluteUrl && absoluteUrl.length > 0) {
        var parsedUrl = Object(__WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["f" /* urlParseUrl */])(absoluteUrl);
        target = parsedUrl.host;
        if (!name) {
            if (parsedUrl.pathname != null) {
                var pathName = (parsedUrl.pathname.length === 0) ? "/" : parsedUrl.pathname;
                if (pathName.charAt(0) !== '/') {
                    pathName = "/" + pathName;
                }
                data = parsedUrl.pathname;
                name = Object(__WEBPACK_IMPORTED_MODULE_2__Telemetry_Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, method ? method + " " + pathName : pathName);
            }
            else {
                name = Object(__WEBPACK_IMPORTED_MODULE_2__Telemetry_Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, absoluteUrl);
            }
        }
    }
    else {
        target = commandName;
        name = commandName;
    }
    return {
        target: target,
        name: name,
        data: data
    };
}
function dateTimeUtilsNow() {
    // returns the window or webworker performance object
    var perf = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["y" /* getPerformance */])();
    if (perf && perf.now && perf.timing) {
        var now = perf.now() + perf.timing.navigationStart;
        // Known issue with IE where this calculation can be negative, so if it is then ignore and fallback
        if (now > 0) {
            return now;
        }
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["k" /* dateNow */])();
}
function dateTimeUtilsDuration(start, end) {
    var result = null;
    if (start !== 0 && end !== 0 && !Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(start) && !Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(end)) {
        result = end - start;
    }
    return result;
}
/**
 * A utility class that helps getting time related parameters
 */
var DateTimeUtils = {
    Now: dateTimeUtilsNow,
    GetDuration: dateTimeUtilsDuration
};
//# sourceMappingURL=Util.js.map

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RequestHeaders; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var RequestHeaders = {
    requestContextHeader: "Request-Context",
    requestContextTargetKey: "appId",
    requestContextAppIdFormat: "appId=cid-v1:",
    requestIdHeader: "Request-Id",
    traceParentHeader: "traceparent",
    traceStateHeader: "tracestate",
    sdkContextHeader: "Sdk-Context",
    sdkContextHeaderAppIdRequest: "appId",
    requestContextHeaderLowerCase: "request-context"
};
//# sourceMappingURL=RequestResponseHeaders.js.map

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createDomEvent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(34);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



function createDomEvent(eventName) {
    var event = null;
    if (Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["F" /* isFunction */])(Event)) {
        event = new Event(eventName);
    }
    else {
        var doc = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["q" /* getDocument */])();
        if (doc && doc.createEvent) {
            event = doc.createEvent("Event");
            event.initEvent(eventName, true, true);
        }
    }
    return event;
}
//# sourceMappingURL=DomHelperFuncs.js.map

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = utlDisableStorage;
/* harmony export (immutable) */ __webpack_exports__["a"] = utlCanUseLocalStorage;
/* harmony export (immutable) */ __webpack_exports__["d"] = utlGetLocalStorage;
/* harmony export (immutable) */ __webpack_exports__["i"] = utlSetLocalStorage;
/* harmony export (immutable) */ __webpack_exports__["h"] = utlRemoveStorage;
/* harmony export (immutable) */ __webpack_exports__["b"] = utlCanUseSessionStorage;
/* harmony export (immutable) */ __webpack_exports__["f"] = utlGetSessionStorageKeys;
/* harmony export (immutable) */ __webpack_exports__["e"] = utlGetSessionStorage;
/* harmony export (immutable) */ __webpack_exports__["j"] = utlSetSessionStorage;
/* harmony export (immutable) */ __webpack_exports__["g"] = utlRemoveSessionStorage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Enums__ = __webpack_require__(589);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var _canUseLocalStorage = undefined;
var _canUseSessionStorage = undefined;
/**
 * Gets the localStorage object if available
 * @return {Storage} - Returns the storage object if available else returns null
 */
function _getLocalStorageObject() {
    if (utlCanUseLocalStorage()) {
        return _getVerifiedStorageObject(__WEBPACK_IMPORTED_MODULE_1__Enums__["a" /* StorageType */].LocalStorage);
    }
    return null;
}
/**
 * Tests storage object (localStorage or sessionStorage) to verify that it is usable
 * More details here: https://mathiasbynens.be/notes/localstorage-pattern
 * @param storageType Type of storage
 * @return {Storage} Returns storage object verified that it is usable
 */
function _getVerifiedStorageObject(storageType) {
    try {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["s" /* getGlobal */])())) {
            return null;
        }
        var uid = new Date;
        var storage = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["t" /* getGlobalInst */])(storageType === __WEBPACK_IMPORTED_MODULE_1__Enums__["a" /* StorageType */].LocalStorage ? "localStorage" : "sessionStorage");
        storage.setItem(uid.toString(), uid.toString());
        var fail = storage.getItem(uid.toString()) !== uid.toString();
        storage.removeItem(uid.toString());
        if (!fail) {
            return storage;
        }
    }
    catch (exception) {
    }
    return null;
}
/**
 * Gets the sessionStorage object if available
 * @return {Storage} - Returns the storage object if available else returns null
 */
function _getSessionStorageObject() {
    if (utlCanUseSessionStorage()) {
        return _getVerifiedStorageObject(__WEBPACK_IMPORTED_MODULE_1__Enums__["a" /* StorageType */].SessionStorage);
    }
    return null;
}
function utlDisableStorage() {
    _canUseLocalStorage = false;
    _canUseSessionStorage = false;
}
function utlCanUseLocalStorage() {
    if (_canUseLocalStorage === undefined) {
        _canUseLocalStorage = !!_getVerifiedStorageObject(__WEBPACK_IMPORTED_MODULE_1__Enums__["a" /* StorageType */].LocalStorage);
    }
    return _canUseLocalStorage;
}
function utlGetLocalStorage(logger, name) {
    var storage = _getLocalStorageObject();
    if (storage !== null) {
        try {
            return storage.getItem(name);
        }
        catch (e) {
            _canUseLocalStorage = false;
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].BrowserCannotReadLocalStorage, "Browser failed read of local storage. " + Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["r" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["n" /* dumpObj */])(e) });
        }
    }
    return null;
}
function utlSetLocalStorage(logger, name, data) {
    var storage = _getLocalStorageObject();
    if (storage !== null) {
        try {
            storage.setItem(name, data);
            return true;
        }
        catch (e) {
            _canUseLocalStorage = false;
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].BrowserCannotWriteLocalStorage, "Browser failed write to local storage. " + Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["r" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["n" /* dumpObj */])(e) });
        }
    }
    return false;
}
function utlRemoveStorage(logger, name) {
    var storage = _getLocalStorageObject();
    if (storage !== null) {
        try {
            storage.removeItem(name);
            return true;
        }
        catch (e) {
            _canUseLocalStorage = false;
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].BrowserFailedRemovalFromLocalStorage, "Browser failed removal of local storage item. " + Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["r" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["n" /* dumpObj */])(e) });
        }
    }
    return false;
}
function utlCanUseSessionStorage() {
    if (_canUseSessionStorage === undefined) {
        _canUseSessionStorage = !!_getVerifiedStorageObject(__WEBPACK_IMPORTED_MODULE_1__Enums__["a" /* StorageType */].SessionStorage);
    }
    return _canUseSessionStorage;
}
function utlGetSessionStorageKeys() {
    var keys = [];
    if (utlCanUseSessionStorage()) {
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["K" /* objForEachKey */])(Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["t" /* getGlobalInst */])("sessionStorage"), function (key) {
            keys.push(key);
        });
    }
    return keys;
}
function utlGetSessionStorage(logger, name) {
    var storage = _getSessionStorageObject();
    if (storage !== null) {
        try {
            return storage.getItem(name);
        }
        catch (e) {
            _canUseSessionStorage = false;
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].BrowserCannotReadSessionStorage, "Browser failed read of session storage. " + Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["r" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["n" /* dumpObj */])(e) });
        }
    }
    return null;
}
function utlSetSessionStorage(logger, name, data) {
    var storage = _getSessionStorageObject();
    if (storage !== null) {
        try {
            storage.setItem(name, data);
            return true;
        }
        catch (e) {
            _canUseSessionStorage = false;
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].BrowserCannotWriteSessionStorage, "Browser failed write to session storage. " + Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["r" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["n" /* dumpObj */])(e) });
        }
    }
    return false;
}
function utlRemoveSessionStorage(logger, name) {
    var storage = _getSessionStorageObject();
    if (storage !== null) {
        try {
            storage.removeItem(name);
            return true;
        }
        catch (e) {
            _canUseSessionStorage = false;
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].BrowserFailedRemovalFromSessionStorage, "Browser failed removal of session storage item. " + Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["r" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["n" /* dumpObj */])(e) });
        }
    }
    return false;
}
//# sourceMappingURL=StorageHelperFuncs.js.map

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StorageType; });
/* unused harmony export DistributedTracingModes */
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * Type of storage to differentiate between local storage and session storage
 */
var StorageType;
(function (StorageType) {
    StorageType[StorageType["LocalStorage"] = 0] = "LocalStorage";
    StorageType[StorageType["SessionStorage"] = 1] = "SessionStorage";
})(StorageType || (StorageType = {}));
;
var DistributedTracingModes;
(function (DistributedTracingModes) {
    /**
     * (Default) Send Application Insights correlation headers
     */
    DistributedTracingModes[DistributedTracingModes["AI"] = 0] = "AI";
    /**
     * Send both W3C Trace Context headers and back-compatibility Application Insights headers
     */
    DistributedTracingModes[DistributedTracingModes["AI_AND_W3C"] = 1] = "AI_AND_W3C";
    /**
     * Send W3C Trace Context headers
     */
    DistributedTracingModes[DistributedTracingModes["W3C"] = 2] = "W3C";
})(DistributedTracingModes || (DistributedTracingModes = {}));
//# sourceMappingURL=Enums.js.map

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = urlParseUrl;
/* harmony export (immutable) */ __webpack_exports__["a"] = urlGetAbsoluteUrl;
/* harmony export (immutable) */ __webpack_exports__["c"] = urlGetPathName;
/* harmony export (immutable) */ __webpack_exports__["b"] = urlGetCompleteUrl;
/* harmony export (immutable) */ __webpack_exports__["e"] = urlParseHost;
/* harmony export (immutable) */ __webpack_exports__["d"] = urlParseFullHost;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(34);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



var _document = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["q" /* getDocument */])() || {};
var _htmlAnchorIdx = 0;
// Use an array of temporary values as it's possible for multiple calls to parseUrl() will be called with different URLs
// Using a cache size of 5 for now as it current depth usage is at least 2, so adding a minor buffer to handle future updates
var _htmlAnchorElement = [null, null, null, null, null];
function urlParseUrl(url) {
    var anchorIdx = _htmlAnchorIdx;
    var anchorCache = _htmlAnchorElement;
    var tempAnchor = anchorCache[anchorIdx];
    if (!_document.createElement) {
        // Always create the temp instance if createElement is not available
        tempAnchor = { host: urlParseHost(url, true) };
    }
    else if (!anchorCache[anchorIdx]) {
        // Create and cache the unattached anchor instance 
        tempAnchor = anchorCache[anchorIdx] = _document.createElement('a');
    }
    tempAnchor.href = url;
    // Move the cache index forward
    anchorIdx++;
    if (anchorIdx >= anchorCache.length) {
        anchorIdx = 0;
    }
    _htmlAnchorIdx = anchorIdx;
    return tempAnchor;
}
function urlGetAbsoluteUrl(url) {
    var result;
    var a = urlParseUrl(url);
    if (a) {
        result = a.href;
    }
    return result;
}
function urlGetPathName(url) {
    var result;
    var a = urlParseUrl(url);
    if (a) {
        result = a.pathname;
    }
    return result;
}
function urlGetCompleteUrl(method, absoluteUrl) {
    if (method) {
        return method.toUpperCase() + " " + absoluteUrl;
    }
    return absoluteUrl;
}
// Fallback method to grab host from url if document.createElement method is not available
function urlParseHost(url, inclPort) {
    var fullHost = urlParseFullHost(url, inclPort);
    if (fullHost) {
        var match = fullHost.match(/(www[0-9]?\.)?(.[^/:]+)(\:[\d]+)?/i);
        if (match != null && match.length > 3 && Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["I" /* isString */])(match[2]) && match[2].length > 0) {
            return match[2] + (match[3] || "");
        }
    }
    return fullHost;
}
function urlParseFullHost(url, inclPort) {
    var result = null;
    if (url) {
        var match = url.match(/(\w*):\/\/(.[^/:]+)(\:[\d]+)?/i);
        if (match != null && match.length > 2 && Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["I" /* isString */])(match[2]) && match[2].length > 0) {
            result = match[2] || "";
            if (inclPort && match.length > 2) {
                var protocol = (match[1] || "").toLowerCase();
                var port = match[3] || "";
                // IE includes the standard port so pass it off if it's the same as the protocol
                if (protocol === "http" && port === ":80") {
                    port = "";
                }
                else if (protocol === "https" && port === ":443") {
                    port = "";
                }
                result += port;
            }
        }
    }
    return result;
}
//# sourceMappingURL=UrlHelperFuncs.js.map

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Data; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Base__ = __webpack_require__(592);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



// THIS FILE WAS AUTOGENERATED

/**
 * Data struct to contain both B and C sections.
 */
var Data = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(Data, _super);
    function Data() {
        return _super.call(this) || this;
    }
    return Data;
}(__WEBPACK_IMPORTED_MODULE_1__Base__["a" /* Base */]));

//# sourceMappingURL=Data.js.map

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Base; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// THIS FILE WAS AUTOGENERATED
/**
 * Data struct to contain only C section with custom fields.
 */
var Base = /** @class */ (function () {
    function Base() {
    }
    return Base;
}());

//# sourceMappingURL=Base.js.map

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventData; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * Instances of Event represent structured event records that can be grouped and searched by their properties. Event data item also creates a metric of event count by name.
 */
var EventData = /** @class */ (function () {
    function EventData() {
        /**
         * Schema version
         */
        this.ver = 2;
        /**
         * Collection of custom properties.
         */
        this.properties = {};
        /**
         * Collection of custom measurements.
         */
        this.measurements = {};
    }
    return EventData;
}());

//# sourceMappingURL=EventData.js.map

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContextTagKeys; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__ = __webpack_require__(34);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




function _aiNameFunc(baseName) {
    var aiName = "ai." + baseName + ".";
    return function (name) {
        return aiName + name;
    };
}
var _aiApplication = _aiNameFunc("application");
var _aiDevice = _aiNameFunc("device");
var _aiLocation = _aiNameFunc("location");
var _aiOperation = _aiNameFunc("operation");
var _aiSession = _aiNameFunc("session");
var _aiUser = _aiNameFunc("user");
var _aiCloud = _aiNameFunc("cloud");
var _aiInternal = _aiNameFunc("internal");
var ContextTagKeys = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(ContextTagKeys, _super);
    function ContextTagKeys() {
        return _super.call(this) || this;
    }
    return ContextTagKeys;
}(Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["j" /* createClassFromInterface */])({
    applicationVersion: _aiApplication("ver"),
    applicationBuild: _aiApplication("build"),
    applicationTypeId: _aiApplication("typeId"),
    applicationId: _aiApplication("applicationId"),
    applicationLayer: _aiApplication("layer"),
    deviceId: _aiDevice("id"),
    deviceIp: _aiDevice("ip"),
    deviceLanguage: _aiDevice("language"),
    deviceLocale: _aiDevice("locale"),
    deviceModel: _aiDevice("model"),
    deviceFriendlyName: _aiDevice("friendlyName"),
    deviceNetwork: _aiDevice("network"),
    deviceNetworkName: _aiDevice("networkName"),
    deviceOEMName: _aiDevice("oemName"),
    deviceOS: _aiDevice("os"),
    deviceOSVersion: _aiDevice("osVersion"),
    deviceRoleInstance: _aiDevice("roleInstance"),
    deviceRoleName: _aiDevice("roleName"),
    deviceScreenResolution: _aiDevice("screenResolution"),
    deviceType: _aiDevice("type"),
    deviceMachineName: _aiDevice("machineName"),
    deviceVMName: _aiDevice("vmName"),
    deviceBrowser: _aiDevice("browser"),
    deviceBrowserVersion: _aiDevice("browserVersion"),
    locationIp: _aiLocation("ip"),
    locationCountry: _aiLocation("country"),
    locationProvince: _aiLocation("province"),
    locationCity: _aiLocation("city"),
    operationId: _aiOperation("id"),
    operationName: _aiOperation("name"),
    operationParentId: _aiOperation("parentId"),
    operationRootId: _aiOperation("rootId"),
    operationSyntheticSource: _aiOperation("syntheticSource"),
    operationCorrelationVector: _aiOperation("correlationVector"),
    sessionId: _aiSession("id"),
    sessionIsFirst: _aiSession("isFirst"),
    sessionIsNew: _aiSession("isNew"),
    userAccountAcquisitionDate: _aiUser("accountAcquisitionDate"),
    userAccountId: _aiUser("accountId"),
    userAgent: _aiUser("userAgent"),
    userId: _aiUser("id"),
    userStoreRegion: _aiUser("storeRegion"),
    userAuthUserId: _aiUser("authUserId"),
    userAnonymousUserAcquisitionDate: _aiUser("anonUserAcquisitionDate"),
    userAuthenticatedUserAcquisitionDate: _aiUser("authUserAcquisitionDate"),
    cloudName: _aiCloud("name"),
    cloudRole: _aiCloud("role"),
    cloudRoleVer: _aiCloud("roleVer"),
    cloudRoleInstance: _aiCloud("roleInstance"),
    cloudEnvironment: _aiCloud("environment"),
    cloudLocation: _aiCloud("location"),
    cloudDeploymentUnit: _aiCloud("deploymentUnit"),
    internalNodeName: _aiInternal("nodeName"),
    internalSdkVersion: _aiInternal("sdkVersion"),
    internalAgentVersion: _aiInternal("agentVersion"),
    internalSnippet: _aiInternal("snippet"),
    internalSdkSrc: _aiInternal("sdkSrc")
})));

//# sourceMappingURL=ContextTagKeys.js.map

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TelemetryTrace; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__ = __webpack_require__(34);
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var TelemetryTrace = /** @class */ (function () {
    function TelemetryTrace(id, parentId, name, logger) {
        var _self = this;
        _self.traceID = id || Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["o" /* generateW3CId */])();
        _self.parentID = parentId;
        _self.name = name;
        var location = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["w" /* getLocation */])();
        if (!name && location && location.pathname) {
            _self.name = location.pathname;
        }
        _self.name = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["f" /* dataSanitizeString */])(logger, _self.name);
    }
    return TelemetryTrace;
}());

//# sourceMappingURL=TelemetryTrace.js.map

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ajax__ = __webpack_require__(1496);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ajax__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ajaxRecord__ = __webpack_require__(613);
/* unused harmony reexport ajaxRecord */
/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




//# sourceMappingURL=applicationinsights-dependencies-js.js.map

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PropertiesPluginIdentifier; });
/* unused harmony export BreezeChannelIdentifier */
/* unused harmony export AnalyticsPluginIdentifier */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Util__ = __webpack_require__(598);
/* unused harmony reexport Util */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Util__["b"]; });
/* unused harmony reexport DateTimeUtils */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_0__Util__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__Util__["c"]; });
/* unused harmony reexport UrlHelper */
/* unused harmony reexport isInternalApplicationInsightsEndpoint */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConnectionStringParser__ = __webpack_require__(1503);
/* unused harmony reexport parseConnectionString */
/* unused harmony reexport ConnectionStringParser */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RequestResponseHeaders__ = __webpack_require__(604);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__RequestResponseHeaders__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Constants__ = __webpack_require__(83);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__Constants__["b"]; });
/* unused harmony reexport ProcessLegacy */
/* unused harmony reexport SampleRate */
/* unused harmony reexport HttpMethod */
/* unused harmony reexport DEFAULT_BREEZE_ENDPOINT */
/* unused harmony reexport strNotSpecified */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Interfaces_Contracts_Generated_Data__ = __webpack_require__(609);
/* unused harmony reexport AIData */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Interfaces_Contracts_Generated_Base__ = __webpack_require__(610);
/* unused harmony reexport AIBase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Telemetry_Common_Envelope__ = __webpack_require__(1504);
/* unused harmony reexport Envelope */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Telemetry_Event__ = __webpack_require__(1506);
/* unused harmony reexport Event */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Telemetry_Exception__ = __webpack_require__(1507);
/* unused harmony reexport Exception */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Telemetry_Metric__ = __webpack_require__(1511);
/* unused harmony reexport Metric */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Telemetry_PageView__ = __webpack_require__(1516);
/* unused harmony reexport PageView */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Interfaces_Contracts_Generated_PageViewData__ = __webpack_require__(379);
/* unused harmony reexport PageViewData */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Telemetry_RemoteDependencyData__ = __webpack_require__(1517);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_12__Telemetry_RemoteDependencyData__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Telemetry_Trace__ = __webpack_require__(1519);
/* unused harmony reexport Trace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Telemetry_PageViewPerformance__ = __webpack_require__(1521);
/* unused harmony reexport PageViewPerformance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Telemetry_Common_Data__ = __webpack_require__(1523);
/* unused harmony reexport Data */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Interfaces_Contracts_Generated_SeverityLevel__ = __webpack_require__(1524);
/* unused harmony reexport SeverityLevel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Interfaces_IConfig__ = __webpack_require__(1525);
/* unused harmony reexport ConfigurationManager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Interfaces_Contracts_Generated_ContextTagKeys__ = __webpack_require__(612);
/* unused harmony reexport ContextTagKeys */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Telemetry_Common_DataSanitizer__ = __webpack_require__(82);
/* unused harmony reexport DataSanitizer */
/* unused harmony reexport dataSanitizeKeyAndAddUniqueness */
/* unused harmony reexport dataSanitizeKey */
/* unused harmony reexport dataSanitizeString */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_19__Telemetry_Common_DataSanitizer__["g"]; });
/* unused harmony reexport dataSanitizeMessage */
/* unused harmony reexport dataSanitizeException */
/* unused harmony reexport dataSanitizeProperties */
/* unused harmony reexport dataSanitizeMeasurements */
/* unused harmony reexport dataSanitizeId */
/* unused harmony reexport dataSanitizeInput */
/* unused harmony reexport dsPadNumber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__TelemetryItemCreator__ = __webpack_require__(1526);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_20__TelemetryItemCreator__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Interfaces_PartAExtensions__ = __webpack_require__(1527);
/* unused harmony reexport CtxTagKeys */
/* unused harmony reexport Extensions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Enums__ = __webpack_require__(607);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_22__Enums__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__HelperFuncs__ = __webpack_require__(254);
/* unused harmony reexport stringToBoolOrDefault */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_23__HelperFuncs__["d"]; });
/* unused harmony reexport isBeaconApiSupported */
/* unused harmony reexport getExtensionByName */
/* unused harmony reexport isCrossOriginError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__DomHelperFuncs__ = __webpack_require__(605);
/* unused harmony reexport createDomEvent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__StorageHelperFuncs__ = __webpack_require__(606);
/* unused harmony reexport utlDisableStorage */
/* unused harmony reexport utlCanUseLocalStorage */
/* unused harmony reexport utlGetLocalStorage */
/* unused harmony reexport utlSetLocalStorage */
/* unused harmony reexport utlRemoveStorage */
/* unused harmony reexport utlCanUseSessionStorage */
/* unused harmony reexport utlGetSessionStorageKeys */
/* unused harmony reexport utlGetSessionStorage */
/* unused harmony reexport utlSetSessionStorage */
/* unused harmony reexport utlRemoveSessionStorage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__UrlHelperFuncs__ = __webpack_require__(608);
/* unused harmony reexport urlParseUrl */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_26__UrlHelperFuncs__["a"]; });
/* unused harmony reexport urlGetPathName */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_26__UrlHelperFuncs__["b"]; });
/* unused harmony reexport urlParseHost */
/* unused harmony reexport urlParseFullHost */
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





























var PropertiesPluginIdentifier = "AppInsightsPropertiesPlugin";
var BreezeChannelIdentifier = "AppInsightsChannelPlugin";
var AnalyticsPluginIdentifier = "ApplicationInsightsAnalytics";
//# sourceMappingURL=applicationinsights-common.js.map

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isInternalApplicationInsightsEndpoint */
/* unused harmony export Util */
/* unused harmony export UrlHelper */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CorrelationIdHelper; });
/* harmony export (immutable) */ __webpack_exports__["a"] = AjaxHelperParseDependencyPath;
/* harmony export (immutable) */ __webpack_exports__["d"] = dateTimeUtilsNow;
/* harmony export (immutable) */ __webpack_exports__["c"] = dateTimeUtilsDuration;
/* unused harmony export DateTimeUtils */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RequestResponseHeaders__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Telemetry_Common_DataSanitizer__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DomHelperFuncs__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HelperFuncs__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Constants__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__ = __webpack_require__(608);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */










// listing only non-geo specific locations
var _internalEndpoints = [
    "https://dc.services.visualstudio.com/v2/track",
    "https://breeze.aimon.applicationinsights.io/v2/track",
    "https://dc-int.services.visualstudio.com/v2/track"
];
function isInternalApplicationInsightsEndpoint(endpointUrl) {
    return _internalEndpoints.indexOf(endpointUrl.toLowerCase()) !== -1;
}
var Util = {
    NotSpecified: __WEBPACK_IMPORTED_MODULE_5__Constants__["c" /* strNotSpecified */],
    createDomEvent: __WEBPACK_IMPORTED_MODULE_3__DomHelperFuncs__["a" /* createDomEvent */],
    disableStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["c" /* utlDisableStorage */],
    isInternalApplicationInsightsEndpoint: isInternalApplicationInsightsEndpoint,
    canUseLocalStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["a" /* utlCanUseLocalStorage */],
    getStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["d" /* utlGetLocalStorage */],
    setStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["i" /* utlSetLocalStorage */],
    removeStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["h" /* utlRemoveStorage */],
    canUseSessionStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["b" /* utlCanUseSessionStorage */],
    getSessionStorageKeys: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["f" /* utlGetSessionStorageKeys */],
    getSessionStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["e" /* utlGetSessionStorage */],
    setSessionStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["j" /* utlSetSessionStorage */],
    removeSessionStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["g" /* utlRemoveSessionStorage */],
    disableCookies: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["o" /* disableCookies */],
    canUseCookies: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["k" /* canUseCookies */],
    disallowsSameSiteNone: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["U" /* uaDisallowsSameSiteNone */],
    setCookie: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["P" /* setCookie */],
    stringToBoolOrDefault: __WEBPACK_IMPORTED_MODULE_4__HelperFuncs__["e" /* stringToBoolOrDefault */],
    getCookie: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["r" /* getCookie */],
    deleteCookie: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["n" /* deleteCookie */],
    trim: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["R" /* strTrim */],
    newId: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["K" /* newId */],
    random32: function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["O" /* random32 */])(true);
    },
    generateW3CId: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["q" /* generateW3CId */],
    isArray: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["C" /* isArray */],
    isError: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["E" /* isError */],
    isDate: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["D" /* isDate */],
    toISOStringForIE8: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["T" /* toISOString */],
    getIEVersion: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["w" /* getIEVersion */],
    msToTimeSpan: __WEBPACK_IMPORTED_MODULE_4__HelperFuncs__["d" /* msToTimeSpan */],
    isCrossOriginError: __WEBPACK_IMPORTED_MODULE_4__HelperFuncs__["c" /* isCrossOriginError */],
    dump: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["p" /* dumpObj */],
    getExceptionName: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["t" /* getExceptionName */],
    addEventHandler: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["j" /* attachEvent */],
    IsBeaconApiSupported: __WEBPACK_IMPORTED_MODULE_4__HelperFuncs__["b" /* isBeaconApiSupported */],
    getExtension: __WEBPACK_IMPORTED_MODULE_4__HelperFuncs__["a" /* getExtensionByName */]
};
;
var UrlHelper = {
    parseUrl: __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["f" /* urlParseUrl */],
    getAbsoluteUrl: __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["a" /* urlGetAbsoluteUrl */],
    getPathName: __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["c" /* urlGetPathName */],
    getCompleteUrl: __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["b" /* urlGetCompleteUrl */],
    parseHost: __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["e" /* urlParseHost */],
    parseFullHost: __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["d" /* urlParseFullHost */]
};
var CorrelationIdHelper = {
    correlationIdPrefix: "cid-v1:",
    /**
     * Checks if a request url is not on a excluded domain list and if it is safe to add correlation headers.
     * Headers are always included if the current domain matches the request domain. If they do not match (CORS),
     * they are regex-ed across correlationHeaderDomains and correlationHeaderExcludedDomains to determine if headers are included.
     * Some environments don't give information on currentHost via window.location.host (e.g. Cordova). In these cases, the user must
     * manually supply domains to include correlation headers on. Else, no headers will be included at all.
     */
    canIncludeCorrelationHeader: function (config, requestUrl, currentHost) {
        if (!requestUrl || (config && config.disableCorrelationHeaders)) {
            return false;
        }
        if (config && config.correlationHeaderExcludePatterns) {
            for (var i = 0; i < config.correlationHeaderExcludePatterns.length; i++) {
                if (config.correlationHeaderExcludePatterns[i].test(requestUrl)) {
                    return false;
                }
            }
        }
        var requestHost = Object(__WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["f" /* urlParseUrl */])(requestUrl).host.toLowerCase();
        if (requestHost && (requestHost.indexOf(":443") !== -1 || requestHost.indexOf(":80") !== -1)) {
            // [Bug #1260] IE can include the port even for http and https URLs so if present 
            // try and parse it to remove if it matches the default protocol port
            requestHost = (Object(__WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["d" /* urlParseFullHost */])(requestUrl, true) || "").toLowerCase();
        }
        if ((!config || !config.enableCorsCorrelation) && requestHost !== currentHost) {
            return false;
        }
        var includedDomains = config && config.correlationHeaderDomains;
        if (includedDomains) {
            var matchExists_1;
            Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["g" /* arrForEach */])(includedDomains, function (domain) {
                var regex = new RegExp(domain.toLowerCase().replace(/\./g, "\.").replace(/\*/g, ".*"));
                matchExists_1 = matchExists_1 || regex.test(requestHost);
            });
            if (!matchExists_1) {
                return false;
            }
        }
        var excludedDomains = config && config.correlationHeaderExcludedDomains;
        if (!excludedDomains || excludedDomains.length === 0) {
            return true;
        }
        for (var i = 0; i < excludedDomains.length; i++) {
            var regex = new RegExp(excludedDomains[i].toLowerCase().replace(/\./g, "\.").replace(/\*/g, ".*"));
            if (regex.test(requestHost)) {
                return false;
            }
        }
        // if we don't know anything about the requestHost, require the user to use included/excludedDomains.
        // Previously we always returned false for a falsy requestHost
        return requestHost && requestHost.length > 0;
    },
    /**
     * Combines target appId and target role name from response header.
     */
    getCorrelationContext: function (responseHeader) {
        if (responseHeader) {
            var correlationId = CorrelationIdHelper.getCorrelationContextValue(responseHeader, __WEBPACK_IMPORTED_MODULE_1__RequestResponseHeaders__["a" /* RequestHeaders */].requestContextTargetKey);
            if (correlationId && correlationId !== CorrelationIdHelper.correlationIdPrefix) {
                return correlationId;
            }
        }
    },
    /**
     * Gets key from correlation response header
     */
    getCorrelationContextValue: function (responseHeader, key) {
        if (responseHeader) {
            var keyValues = responseHeader.split(",");
            for (var i = 0; i < keyValues.length; ++i) {
                var keyValue = keyValues[i].split("=");
                if (keyValue.length === 2 && keyValue[0] === key) {
                    return keyValue[1];
                }
            }
        }
    }
};
function AjaxHelperParseDependencyPath(logger, absoluteUrl, method, commandName) {
    var target, name = commandName, data = commandName;
    if (absoluteUrl && absoluteUrl.length > 0) {
        var parsedUrl = Object(__WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["f" /* urlParseUrl */])(absoluteUrl);
        target = parsedUrl.host;
        if (!name) {
            if (parsedUrl.pathname != null) {
                var pathName = (parsedUrl.pathname.length === 0) ? "/" : parsedUrl.pathname;
                if (pathName.charAt(0) !== '/') {
                    pathName = "/" + pathName;
                }
                data = parsedUrl.pathname;
                name = Object(__WEBPACK_IMPORTED_MODULE_2__Telemetry_Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, method ? method + " " + pathName : pathName);
            }
            else {
                name = Object(__WEBPACK_IMPORTED_MODULE_2__Telemetry_Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, absoluteUrl);
            }
        }
    }
    else {
        target = commandName;
        name = commandName;
    }
    return {
        target: target,
        name: name,
        data: data
    };
}
function dateTimeUtilsNow() {
    // returns the window or webworker performance object
    var perf = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["A" /* getPerformance */])();
    if (perf && perf.now && perf.timing) {
        var now = perf.now() + perf.timing.navigationStart;
        // Known issue with IE where this calculation can be negative, so if it is then ignore and fallback
        if (now > 0) {
            return now;
        }
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["m" /* dateNow */])();
}
function dateTimeUtilsDuration(start, end) {
    var result = null;
    if (start !== 0 && end !== 0 && !Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(start) && !Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(end)) {
        result = end - start;
    }
    return result;
}
/**
 * A utility class that helps getting time related parameters
 */
var DateTimeUtils = {
    Now: dateTimeUtilsNow,
    GetDuration: dateTimeUtilsDuration
};
//# sourceMappingURL=Util.js.map

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventsDiscardedReason; });
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * The EventsDiscardedReason enumeration contains a set of values that specify the reason for discarding an event.
 */
var EventsDiscardedReason = {
    /**
     * Unknown.
     */
    Unknown: 0,
    /**
     * Status set to non-retryable.
     */
    NonRetryableStatus: 1,
    /**
     * The event is invalid.
     */
    InvalidEvent: 2,
    /**
     * The size of the event is too large.
     */
    SizeLimitExceeded: 3,
    /**
     * The server is not accepting events from this instrumentation key.
     */
    KillSwitch: 4,
    /**
     * The event queue is full.
     */
    QueueFull: 5
};
//# sourceMappingURL=EventsDiscardedReason.js.map

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseCore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChannelController__ = __webpack_require__(1499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProcessTelemetryContext__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TelemetryHelpers__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PerfManager__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CookieMgr__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__HelperFuncs__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Constants__ = __webpack_require__(376);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */












var validationError = "Extensions must provide callback to initialize";
var strNotificationManager = "_notificationManager";
var BaseCore = /** @class */ (function () {
    function BaseCore() {
        var _isInitialized = false;
        var _eventQueue;
        var _channelController;
        var _notificationManager;
        var _perfManager;
        var _cookieManager;
        Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__["a" /* default */])(BaseCore, this, function (_self) {
            _self._extensions = new Array();
            _channelController = new __WEBPACK_IMPORTED_MODULE_2__ChannelController__["a" /* ChannelController */]();
            _self.logger = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["i" /* objCreateFn */])({
                throwInternal: function (severity, msgId, msg, properties, isUserAct) {
                    if (isUserAct === void 0) { isUserAct = false; }
                },
                warnToConsole: function (message) { },
                resetInternalMessageCount: function () { }
            });
            _eventQueue = [];
            _self.isInitialized = function () { return _isInitialized; };
            _self.initialize = function (config, extensions, logger, notificationManager) {
                // Make sure core is only initialized once
                if (_self.isInitialized()) {
                    Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["H" /* throwError */])("Core should not be initialized more than once");
                }
                if (!config || Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["s" /* isNullOrUndefined */])(config.instrumentationKey)) {
                    Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["H" /* throwError */])("Please provide instrumentation key");
                }
                _notificationManager = notificationManager;
                // For backward compatibility only
                _self[strNotificationManager] = notificationManager;
                _self.config = config || {};
                config.extensions = Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["s" /* isNullOrUndefined */])(config.extensions) ? [] : config.extensions;
                // add notification to the extensions in the config so other plugins can access it
                var extConfig = Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["j" /* getSetValue */])(config, __WEBPACK_IMPORTED_MODULE_8__Constants__["a" /* strExtensionConfig */]);
                extConfig.NotificationManager = notificationManager;
                if (logger) {
                    _self.logger = logger;
                }
                // Concat all available extensions
                var allExtensions = [];
                allExtensions.push.apply(allExtensions, extensions.concat(config.extensions));
                allExtensions = Object(__WEBPACK_IMPORTED_MODULE_4__TelemetryHelpers__["b" /* sortPlugins */])(allExtensions);
                var coreExtensions = [];
                var channelExtensions = [];
                // Check if any two extensions have the same priority, then warn to console
                // And extract the local extensions from the 
                var extPriorities = {};
                // Extension validation
                Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["a" /* arrForEach */])(allExtensions, function (ext) {
                    if (Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["s" /* isNullOrUndefined */])(ext) || Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["s" /* isNullOrUndefined */])(ext.initialize)) {
                        Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["H" /* throwError */])(validationError);
                    }
                    var extPriority = ext.priority;
                    var identifier = ext.identifier;
                    if (ext && extPriority) {
                        if (!Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["s" /* isNullOrUndefined */])(extPriorities[extPriority])) {
                            logger.warnToConsole("Two extensions have same priority #" + extPriority + " - " + extPriorities[extPriority] + ", " + identifier);
                        }
                        else {
                            // set a value
                            extPriorities[extPriority] = identifier;
                        }
                    }
                    // Split extensions to core and channelController
                    if (!extPriority || extPriority < _channelController.priority) {
                        // Add to core extension that will be managed by BaseCore
                        coreExtensions.push(ext);
                    }
                    else {
                        // Add all other extensions to be managed by the channel controller
                        channelExtensions.push(ext);
                    }
                });
                // Validation complete
                // Add the channelController to the complete extension collection and
                // to the end of the core extensions
                allExtensions.push(_channelController);
                coreExtensions.push(_channelController);
                // Sort the complete set of extensions by priority
                allExtensions = Object(__WEBPACK_IMPORTED_MODULE_4__TelemetryHelpers__["b" /* sortPlugins */])(allExtensions);
                _self._extensions = allExtensions;
                // initialize channel controller first, this will initialize all channel plugins
                Object(__WEBPACK_IMPORTED_MODULE_4__TelemetryHelpers__["a" /* initializePlugins */])(new __WEBPACK_IMPORTED_MODULE_3__ProcessTelemetryContext__["a" /* ProcessTelemetryContext */]([_channelController], config, _self), allExtensions);
                Object(__WEBPACK_IMPORTED_MODULE_4__TelemetryHelpers__["a" /* initializePlugins */])(new __WEBPACK_IMPORTED_MODULE_3__ProcessTelemetryContext__["a" /* ProcessTelemetryContext */](coreExtensions, config, _self), allExtensions);
                // Now reset the extensions to just those being managed by Basecore
                _self._extensions = coreExtensions;
                if (_self.getTransmissionControls().length === 0) {
                    Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["H" /* throwError */])("No channels available");
                }
                _isInitialized = true;
                _self.releaseQueue();
            };
            _self.getTransmissionControls = function () {
                return _channelController.getChannelControls();
            };
            _self.track = function (telemetryItem) {
                // setup default iKey if not passed in
                Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["D" /* setValue */])(telemetryItem, __WEBPACK_IMPORTED_MODULE_8__Constants__["b" /* strIKey */], _self.config.instrumentationKey, null, __WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["r" /* isNotTruthy */]);
                // add default timestamp if not passed in
                Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["D" /* setValue */])(telemetryItem, "time", Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["I" /* toISOString */])(new Date()), null, __WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["r" /* isNotTruthy */]);
                // Common Schema 4.0
                Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["D" /* setValue */])(telemetryItem, "ver", "4.0", null, __WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["s" /* isNullOrUndefined */]);
                if (_self.isInitialized()) {
                    // Process the telemetry plugin chain
                    _self.getProcessTelContext().processNext(telemetryItem);
                }
                else {
                    // Queue events until all extensions are initialized
                    _eventQueue.push(telemetryItem);
                }
            };
            _self.getProcessTelContext = function () {
                var extensions = _self._extensions;
                var thePlugins = extensions;
                // invoke any common telemetry processors before sending through pipeline
                if (!extensions || extensions.length === 0) {
                    // Pass to Channel controller so data is sent to correct channel queues
                    thePlugins = [_channelController];
                }
                return new __WEBPACK_IMPORTED_MODULE_3__ProcessTelemetryContext__["a" /* ProcessTelemetryContext */](thePlugins, _self.config, _self);
            };
            _self.getNotifyMgr = function () {
                if (!_notificationManager) {
                    // Create Dummy notification manager
                    _notificationManager = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["i" /* objCreateFn */])({
                        addNotificationListener: function (listener) { },
                        removeNotificationListener: function (listener) { },
                        eventsSent: function (events) { },
                        eventsDiscarded: function (events, reason) { },
                        eventsSendRequest: function (sendReason, isAsync) { }
                    });
                    // For backward compatibility only
                    _self[strNotificationManager] = _notificationManager;
                }
                return _notificationManager;
            };
            _self.getCookieMgr = function () {
                if (!_cookieManager) {
                    _cookieManager = Object(__WEBPACK_IMPORTED_MODULE_6__CookieMgr__["b" /* createCookieMgr */])(_self.config, _self.logger);
                }
                return _cookieManager;
            };
            _self.setCookieMgr = function (cookieMgr) {
                _cookieManager = cookieMgr;
            };
            _self.getPerfMgr = function () {
                if (!_perfManager) {
                    if (_self.config && _self.config.enablePerfMgr) {
                        _perfManager = new __WEBPACK_IMPORTED_MODULE_5__PerfManager__["a" /* PerfManager */](_self.getNotifyMgr());
                    }
                }
                return _perfManager;
            };
            _self.setPerfMgr = function (perfMgr) {
                _perfManager = perfMgr;
            };
            _self.eventCnt = function () {
                return _eventQueue.length;
            };
            _self.releaseQueue = function () {
                if (_eventQueue.length > 0) {
                    Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["a" /* arrForEach */])(_eventQueue, function (event) {
                        _self.getProcessTelContext().processNext(event);
                    });
                    _eventQueue = [];
                }
            };
        });
    }
// Removed Stub for BaseCore.prototype.initialize.
// Removed Stub for BaseCore.prototype.getTransmissionControls.
// Removed Stub for BaseCore.prototype.track.
// Removed Stub for BaseCore.prototype.getProcessTelContext.
// Removed Stub for BaseCore.prototype.getNotifyMgr.
// Removed Stub for BaseCore.prototype.getCookieMgr.
// Removed Stub for BaseCore.prototype.setCookieMgr.
// Removed Stub for BaseCore.prototype.getPerfMgr.
// Removed Stub for BaseCore.prototype.setPerfMgr.
// Removed Stub for BaseCore.prototype.eventCnt.
// Removed Stub for BaseCore.prototype.releaseQueue.
    return BaseCore;
}());

//# sourceMappingURL=BaseCore.js.map

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseTelemetryPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProcessTelemetryContext__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HelperFuncs__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Constants__ = __webpack_require__(376);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var strGetPlugin = "getPlugin";
/**
 * BaseTelemetryPlugin provides a basic implementation of the ITelemetryPlugin interface so that plugins
 * can avoid implementation the same set of boiler plate code as well as provide a base
 * implementation so that new default implementations can be added without breaking all plugins.
 */
var BaseTelemetryPlugin = /** @class */ (function () {
    function BaseTelemetryPlugin() {
        var _self = this;
        var _isinitialized = false;
        var _rootCtx = null; // Used as the root context, holding the current config and initialized core
        var _nextPlugin = null; // Used for backward compatibility where plugins don't call the main pipeline
        _self.core = null;
        _self.diagLog = function (itemCtx) {
            return _self._getTelCtx(itemCtx).diagLog();
        };
        _self.isInitialized = function () {
            return _isinitialized;
        };
        _self.setInitialized = function (isInitialized) {
            _isinitialized = isInitialized;
        };
        // _self.getNextPlugin = () => DO NOT IMPLEMENT
        // Sub-classes of this base class *should* not be relying on this value and instead
        // should use processNext() function. If you require access to the plugin use the
        // IProcessTelemetryContext.getNext().getPlugin() while in the pipeline, Note getNext() may return null.
        _self.setNextPlugin = function (next) {
            _nextPlugin = next;
        };
        _self.processNext = function (env, itemCtx) {
            if (itemCtx) {
                // Normal core execution sequence
                itemCtx.processNext(env);
            }
            else if (_nextPlugin && Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["p" /* isFunction */])(_nextPlugin.processTelemetry)) {
                // Looks like backward compatibility or out of band processing. And as it looks 
                // like a ITelemetryPlugin or ITelemetryPluginChain, just call processTelemetry
                _nextPlugin.processTelemetry(env, null);
            }
        };
        _self._getTelCtx = function (currentCtx) {
            if (currentCtx === void 0) { currentCtx = null; }
            var itemCtx = currentCtx;
            if (!itemCtx) {
                var rootCtx = _rootCtx || new __WEBPACK_IMPORTED_MODULE_0__ProcessTelemetryContext__["a" /* ProcessTelemetryContext */](null, {}, _self.core);
                // tslint:disable-next-line: prefer-conditional-expression
                if (_nextPlugin && _nextPlugin[strGetPlugin]) {
                    // Looks like a chain object
                    itemCtx = rootCtx.createNew(null, _nextPlugin[strGetPlugin]);
                }
                else {
                    itemCtx = rootCtx.createNew(null, _nextPlugin);
                }
            }
            return itemCtx;
        };
        _self._baseTelInit = function (config, core, extensions, pluginChain) {
            if (config) {
                // Make sure the extensionConfig exists
                Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["D" /* setValue */])(config, __WEBPACK_IMPORTED_MODULE_2__Constants__["a" /* strExtensionConfig */], [], null, __WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["s" /* isNullOrUndefined */]);
            }
            if (!pluginChain && core) {
                // Get the first plugin from the core
                pluginChain = core.getProcessTelContext().getNext();
            }
            var nextPlugin = _nextPlugin;
            if (_nextPlugin && _nextPlugin[strGetPlugin]) {
                // If it looks like a proxy/chain then get the plugin
                nextPlugin = _nextPlugin[strGetPlugin]();
            }
            // Support legacy plugins where core was defined as a property
            _self.core = core;
            _rootCtx = new __WEBPACK_IMPORTED_MODULE_0__ProcessTelemetryContext__["a" /* ProcessTelemetryContext */](pluginChain, config, core, nextPlugin);
            _isinitialized = true;
        };
    }
    BaseTelemetryPlugin.prototype.initialize = function (config, core, extensions, pluginChain) {
        this._baseTelInit(config, core, extensions, pluginChain);
    };
    return BaseTelemetryPlugin;
}());

//# sourceMappingURL=BaseTelemetryPlugin.js.map

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NotificationManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HelperFuncs__ = __webpack_require__(45);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * Class to manage sending notifications to all the listeners.
 */
var NotificationManager = /** @class */ (function () {
    function NotificationManager(config) {
        this.listeners = [];
        var perfEvtsSendAll = !!(config || {}).perfEvtsSendAll;
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__["a" /* default */])(NotificationManager, this, function (_self) {
            _self.addNotificationListener = function (listener) {
                _self.listeners.push(listener);
            };
            /**
             * Removes all instances of the listener.
             * @param {INotificationListener} listener - AWTNotificationListener to remove.
             */
            _self.removeNotificationListener = function (listener) {
                var index = Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["b" /* arrIndexOf */])(_self.listeners, listener);
                while (index > -1) {
                    _self.listeners.splice(index, 1);
                    index = Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["b" /* arrIndexOf */])(_self.listeners, listener);
                }
            };
            /**
             * Notification for events sent.
             * @param {ITelemetryItem[]} events - The array of events that have been sent.
             */
            _self.eventsSent = function (events) {
                Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["a" /* arrForEach */])(_self.listeners, function (listener) {
                    if (listener && listener.eventsSent) {
                        setTimeout(function () { return listener.eventsSent(events); }, 0);
                    }
                });
            };
            /**
             * Notification for events being discarded.
             * @param {ITelemetryItem[]} events - The array of events that have been discarded by the SDK.
             * @param {number} reason           - The reason for which the SDK discarded the events. The EventsDiscardedReason
             * constant should be used to check the different values.
             */
            _self.eventsDiscarded = function (events, reason) {
                Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["a" /* arrForEach */])(_self.listeners, function (listener) {
                    if (listener && listener.eventsDiscarded) {
                        setTimeout(function () { return listener.eventsDiscarded(events, reason); }, 0);
                    }
                });
            };
            /**
             * [Optional] A function called when the events have been requested to be sent to the sever.
             * @param {number} sendReason - The reason why the event batch is being sent.
             * @param {boolean} isAsync   - A flag which identifies whether the requests are being sent in an async or sync manner.
             */
            _self.eventsSendRequest = function (sendReason, isAsync) {
                Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["a" /* arrForEach */])(_self.listeners, function (listener) {
                    if (listener && listener.eventsSendRequest) {
                        if (isAsync) {
                            setTimeout(function () { return listener.eventsSendRequest(sendReason, isAsync); }, 0);
                        }
                        else {
                            try {
                                listener.eventsSendRequest(sendReason, isAsync);
                            }
                            catch (e) {
                                // Catch errors to ensure we don't block sending the requests
                            }
                        }
                    }
                });
            };
            _self.perfEvent = function (perfEvent) {
                if (perfEvent) {
                    // Send all events or only parent events
                    if (perfEvtsSendAll || !perfEvent.isChildEvt()) {
                        Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["a" /* arrForEach */])(_self.listeners, function (listener) {
                            if (listener && listener.perfEvent) {
                                if (perfEvent.isAsync) {
                                    setTimeout(function () { return listener.perfEvent(perfEvent); }, 0);
                                }
                                else {
                                    try {
                                        listener.perfEvent(perfEvent);
                                    }
                                    catch (e) {
                                        // Catch errors to ensure we don't block sending the requests
                                    }
                                }
                            }
                        });
                    }
                }
            };
        });
    }
// Removed Stub for NotificationManager.prototype.addNotificationListener.
// Removed Stub for NotificationManager.prototype.removeNotificationListener.
// Removed Stub for NotificationManager.prototype.eventsSent.
// Removed Stub for NotificationManager.prototype.eventsDiscarded.
// Removed Stub for NotificationManager.prototype.eventsSendRequest.
    return NotificationManager;
}());

//# sourceMappingURL=NotificationManager.js.map

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = randomValue;
/* harmony export (immutable) */ __webpack_exports__["c"] = random32;
/* harmony export (immutable) */ __webpack_exports__["b"] = mwcRandomSeed;
/* harmony export (immutable) */ __webpack_exports__["a"] = mwcRandom32;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EnvUtils__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HelperFuncs__ = __webpack_require__(45);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var UInt32Mask = 0x100000000;
var MaxUInt32 = 0xffffffff;
// MWC based Random generator (for IE)
var _mwcSeeded = false;
var _mwcW = 123456789;
var _mwcZ = 987654321;
// Takes any integer
function _mwcSeed(seedValue) {
    if (seedValue < 0) {
        // Make sure we end up with a positive number and not -ve one.
        seedValue >>>= 0;
    }
    _mwcW = (123456789 + seedValue) & MaxUInt32;
    _mwcZ = (987654321 - seedValue) & MaxUInt32;
    _mwcSeeded = true;
}
function _autoSeedMwc() {
    // Simple initialization using default Math.random() - So we inherit any entropy from the browser
    // and bitwise XOR with the current milliseconds
    try {
        var now = Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["g" /* dateNow */])() & 0x7fffffff;
        _mwcSeed(((Math.random() * UInt32Mask) ^ now) + now);
    }
    catch (e) {
        // Don't crash if something goes wrong
    }
}
/**
 * Generate a random value between 0 and maxValue, max value should be limited to a 32-bit maximum.
 * So maxValue(16) will produce a number from 0..16 (range of 17)
 * @param maxValue
 */
function randomValue(maxValue) {
    if (maxValue > 0) {
        return Math.floor((random32() / MaxUInt32) * (maxValue + 1)) >>> 0;
    }
    return 0;
}
/**
 * generate a random 32-bit number (0x000000..0xFFFFFFFF) or (-0x80000000..0x7FFFFFFF), defaults un-unsigned.
 * @param signed - True to return a signed 32-bit number (-0x80000000..0x7FFFFFFF) otherwise an unsigned one (0x000000..0xFFFFFFFF)
 */
function random32(signed) {
    var value;
    var c = Object(__WEBPACK_IMPORTED_MODULE_0__EnvUtils__["c" /* getCrypto */])() || Object(__WEBPACK_IMPORTED_MODULE_0__EnvUtils__["i" /* getMsCrypto */])();
    if (c && c.getRandomValues) {
        // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
        value = c.getRandomValues(new Uint32Array(1))[0] & MaxUInt32;
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_0__EnvUtils__["n" /* isIE */])()) {
        // For IE 6, 7, 8 (especially on XP) Math.random is not very random
        if (!_mwcSeeded) {
            // Set the seed for the Mwc algorithm
            _autoSeedMwc();
        }
        // Don't use Math.random for IE
        // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
        value = mwcRandom32() & MaxUInt32;
    }
    else {
        // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
        value = Math.floor((UInt32Mask * Math.random()) | 0);
    }
    if (!signed) {
        // Make sure we end up with a positive number and not -ve one.
        value >>>= 0;
    }
    return value;
}
/**
 * Seed the MWC random number generator with the specified seed or a random value
 * @param value - optional the number to used as the seed, if undefined, null or zero a random value will be chosen
 */
function mwcRandomSeed(value) {
    if (!value) {
        _autoSeedMwc();
    }
    else {
        _mwcSeed(value);
    }
}
/**
 * Generate a random 32-bit number between (0x000000..0xFFFFFFFF) or (-0x80000000..0x7FFFFFFF), using MWC (Multiply with carry)
 * instead of Math.random() defaults to un-signed.
 * Used as a replacement random generator for IE to avoid issues with older IE instances.
 * @param signed - True to return a signed 32-bit number (-0x80000000..0x7FFFFFFF) otherwise an unsigned one (0x000000..0xFFFFFFFF)
 */
function mwcRandom32(signed) {
    _mwcZ = (36969 * (_mwcZ & 0xFFFF) + (_mwcZ >> 16)) & MaxUInt32;
    _mwcW = (18000 * (_mwcW & 0xFFFF) + (_mwcW >> 16)) & MaxUInt32;
    var value = (((_mwcZ << 16) + (_mwcW & 0xFFFF)) >>> 0) & MaxUInt32 | 0;
    if (!signed) {
        // Make sure we end up with a positive number and not -ve one.
        value >>>= 0;
    }
    return value;
}
//# sourceMappingURL=RandomHelper.js.map

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RequestHeaders; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var RequestHeaders = {
    requestContextHeader: "Request-Context",
    requestContextTargetKey: "appId",
    requestContextAppIdFormat: "appId=cid-v1:",
    requestIdHeader: "Request-Id",
    traceParentHeader: "traceparent",
    traceStateHeader: "tracestate",
    sdkContextHeader: "Sdk-Context",
    sdkContextHeaderAppIdRequest: "appId",
    requestContextHeaderLowerCase: "request-context"
};
//# sourceMappingURL=RequestResponseHeaders.js.map

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createDomEvent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(35);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



function createDomEvent(eventName) {
    var event = null;
    if (Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["F" /* isFunction */])(Event)) {
        event = new Event(eventName);
    }
    else {
        var doc = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["s" /* getDocument */])();
        if (doc && doc.createEvent) {
            event = doc.createEvent("Event");
            event.initEvent(eventName, true, true);
        }
    }
    return event;
}
//# sourceMappingURL=DomHelperFuncs.js.map

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = utlDisableStorage;
/* harmony export (immutable) */ __webpack_exports__["a"] = utlCanUseLocalStorage;
/* harmony export (immutable) */ __webpack_exports__["d"] = utlGetLocalStorage;
/* harmony export (immutable) */ __webpack_exports__["i"] = utlSetLocalStorage;
/* harmony export (immutable) */ __webpack_exports__["h"] = utlRemoveStorage;
/* harmony export (immutable) */ __webpack_exports__["b"] = utlCanUseSessionStorage;
/* harmony export (immutable) */ __webpack_exports__["f"] = utlGetSessionStorageKeys;
/* harmony export (immutable) */ __webpack_exports__["e"] = utlGetSessionStorage;
/* harmony export (immutable) */ __webpack_exports__["j"] = utlSetSessionStorage;
/* harmony export (immutable) */ __webpack_exports__["g"] = utlRemoveSessionStorage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Enums__ = __webpack_require__(607);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var _canUseLocalStorage = undefined;
var _canUseSessionStorage = undefined;
/**
 * Gets the localStorage object if available
 * @return {Storage} - Returns the storage object if available else returns null
 */
function _getLocalStorageObject() {
    if (utlCanUseLocalStorage()) {
        return _getVerifiedStorageObject(__WEBPACK_IMPORTED_MODULE_1__Enums__["b" /* StorageType */].LocalStorage);
    }
    return null;
}
/**
 * Tests storage object (localStorage or sessionStorage) to verify that it is usable
 * More details here: https://mathiasbynens.be/notes/localstorage-pattern
 * @param storageType Type of storage
 * @return {Storage} Returns storage object verified that it is usable
 */
function _getVerifiedStorageObject(storageType) {
    try {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["u" /* getGlobal */])())) {
            return null;
        }
        var uid = new Date;
        var storage = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["v" /* getGlobalInst */])(storageType === __WEBPACK_IMPORTED_MODULE_1__Enums__["b" /* StorageType */].LocalStorage ? "localStorage" : "sessionStorage");
        storage.setItem(uid.toString(), uid.toString());
        var fail = storage.getItem(uid.toString()) !== uid.toString();
        storage.removeItem(uid.toString());
        if (!fail) {
            return storage;
        }
    }
    catch (exception) {
    }
    return null;
}
/**
 * Gets the sessionStorage object if available
 * @return {Storage} - Returns the storage object if available else returns null
 */
function _getSessionStorageObject() {
    if (utlCanUseSessionStorage()) {
        return _getVerifiedStorageObject(__WEBPACK_IMPORTED_MODULE_1__Enums__["b" /* StorageType */].SessionStorage);
    }
    return null;
}
function utlDisableStorage() {
    _canUseLocalStorage = false;
    _canUseSessionStorage = false;
}
function utlCanUseLocalStorage() {
    if (_canUseLocalStorage === undefined) {
        _canUseLocalStorage = !!_getVerifiedStorageObject(__WEBPACK_IMPORTED_MODULE_1__Enums__["b" /* StorageType */].LocalStorage);
    }
    return _canUseLocalStorage;
}
function utlGetLocalStorage(logger, name) {
    var storage = _getLocalStorageObject();
    if (storage !== null) {
        try {
            return storage.getItem(name);
        }
        catch (e) {
            _canUseLocalStorage = false;
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["e" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["f" /* _InternalMessageId */].BrowserCannotReadLocalStorage, "Browser failed read of local storage. " + Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["t" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["p" /* dumpObj */])(e) });
        }
    }
    return null;
}
function utlSetLocalStorage(logger, name, data) {
    var storage = _getLocalStorageObject();
    if (storage !== null) {
        try {
            storage.setItem(name, data);
            return true;
        }
        catch (e) {
            _canUseLocalStorage = false;
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["e" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["f" /* _InternalMessageId */].BrowserCannotWriteLocalStorage, "Browser failed write to local storage. " + Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["t" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["p" /* dumpObj */])(e) });
        }
    }
    return false;
}
function utlRemoveStorage(logger, name) {
    var storage = _getLocalStorageObject();
    if (storage !== null) {
        try {
            storage.removeItem(name);
            return true;
        }
        catch (e) {
            _canUseLocalStorage = false;
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["e" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["f" /* _InternalMessageId */].BrowserFailedRemovalFromLocalStorage, "Browser failed removal of local storage item. " + Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["t" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["p" /* dumpObj */])(e) });
        }
    }
    return false;
}
function utlCanUseSessionStorage() {
    if (_canUseSessionStorage === undefined) {
        _canUseSessionStorage = !!_getVerifiedStorageObject(__WEBPACK_IMPORTED_MODULE_1__Enums__["b" /* StorageType */].SessionStorage);
    }
    return _canUseSessionStorage;
}
function utlGetSessionStorageKeys() {
    var keys = [];
    if (utlCanUseSessionStorage()) {
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["M" /* objForEachKey */])(Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["v" /* getGlobalInst */])("sessionStorage"), function (key) {
            keys.push(key);
        });
    }
    return keys;
}
function utlGetSessionStorage(logger, name) {
    var storage = _getSessionStorageObject();
    if (storage !== null) {
        try {
            return storage.getItem(name);
        }
        catch (e) {
            _canUseSessionStorage = false;
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["e" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["f" /* _InternalMessageId */].BrowserCannotReadSessionStorage, "Browser failed read of session storage. " + Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["t" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["p" /* dumpObj */])(e) });
        }
    }
    return null;
}
function utlSetSessionStorage(logger, name, data) {
    var storage = _getSessionStorageObject();
    if (storage !== null) {
        try {
            storage.setItem(name, data);
            return true;
        }
        catch (e) {
            _canUseSessionStorage = false;
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["e" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["f" /* _InternalMessageId */].BrowserCannotWriteSessionStorage, "Browser failed write to session storage. " + Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["t" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["p" /* dumpObj */])(e) });
        }
    }
    return false;
}
function utlRemoveSessionStorage(logger, name) {
    var storage = _getSessionStorageObject();
    if (storage !== null) {
        try {
            storage.removeItem(name);
            return true;
        }
        catch (e) {
            _canUseSessionStorage = false;
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["e" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["f" /* _InternalMessageId */].BrowserFailedRemovalFromSessionStorage, "Browser failed removal of session storage item. " + Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["t" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["p" /* dumpObj */])(e) });
        }
    }
    return false;
}
//# sourceMappingURL=StorageHelperFuncs.js.map

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StorageType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DistributedTracingModes; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * Type of storage to differentiate between local storage and session storage
 */
var StorageType;
(function (StorageType) {
    StorageType[StorageType["LocalStorage"] = 0] = "LocalStorage";
    StorageType[StorageType["SessionStorage"] = 1] = "SessionStorage";
})(StorageType || (StorageType = {}));
;
var DistributedTracingModes;
(function (DistributedTracingModes) {
    /**
     * (Default) Send Application Insights correlation headers
     */
    DistributedTracingModes[DistributedTracingModes["AI"] = 0] = "AI";
    /**
     * Send both W3C Trace Context headers and back-compatibility Application Insights headers
     */
    DistributedTracingModes[DistributedTracingModes["AI_AND_W3C"] = 1] = "AI_AND_W3C";
    /**
     * Send W3C Trace Context headers
     */
    DistributedTracingModes[DistributedTracingModes["W3C"] = 2] = "W3C";
})(DistributedTracingModes || (DistributedTracingModes = {}));
//# sourceMappingURL=Enums.js.map

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = urlParseUrl;
/* harmony export (immutable) */ __webpack_exports__["a"] = urlGetAbsoluteUrl;
/* harmony export (immutable) */ __webpack_exports__["c"] = urlGetPathName;
/* harmony export (immutable) */ __webpack_exports__["b"] = urlGetCompleteUrl;
/* harmony export (immutable) */ __webpack_exports__["e"] = urlParseHost;
/* harmony export (immutable) */ __webpack_exports__["d"] = urlParseFullHost;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(35);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



var _document = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["s" /* getDocument */])() || {};
var _htmlAnchorIdx = 0;
// Use an array of temporary values as it's possible for multiple calls to parseUrl() will be called with different URLs
// Using a cache size of 5 for now as it current depth usage is at least 2, so adding a minor buffer to handle future updates
var _htmlAnchorElement = [null, null, null, null, null];
function urlParseUrl(url) {
    var anchorIdx = _htmlAnchorIdx;
    var anchorCache = _htmlAnchorElement;
    var tempAnchor = anchorCache[anchorIdx];
    if (!_document.createElement) {
        // Always create the temp instance if createElement is not available
        tempAnchor = { host: urlParseHost(url, true) };
    }
    else if (!anchorCache[anchorIdx]) {
        // Create and cache the unattached anchor instance 
        tempAnchor = anchorCache[anchorIdx] = _document.createElement('a');
    }
    tempAnchor.href = url;
    // Move the cache index forward
    anchorIdx++;
    if (anchorIdx >= anchorCache.length) {
        anchorIdx = 0;
    }
    _htmlAnchorIdx = anchorIdx;
    return tempAnchor;
}
function urlGetAbsoluteUrl(url) {
    var result;
    var a = urlParseUrl(url);
    if (a) {
        result = a.href;
    }
    return result;
}
function urlGetPathName(url) {
    var result;
    var a = urlParseUrl(url);
    if (a) {
        result = a.pathname;
    }
    return result;
}
function urlGetCompleteUrl(method, absoluteUrl) {
    if (method) {
        return method.toUpperCase() + " " + absoluteUrl;
    }
    return absoluteUrl;
}
// Fallback method to grab host from url if document.createElement method is not available
function urlParseHost(url, inclPort) {
    var fullHost = urlParseFullHost(url, inclPort);
    if (fullHost) {
        var match = fullHost.match(/(www[0-9]?\.)?(.[^/:]+)(\:[\d]+)?/i);
        if (match != null && match.length > 3 && Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["J" /* isString */])(match[2]) && match[2].length > 0) {
            return match[2] + (match[3] || "");
        }
    }
    return fullHost;
}
function urlParseFullHost(url, inclPort) {
    var result = null;
    if (url) {
        var match = url.match(/(\w*):\/\/(.[^/:]+)(\:[\d]+)?/i);
        if (match != null && match.length > 2 && Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["J" /* isString */])(match[2]) && match[2].length > 0) {
            result = match[2] || "";
            if (inclPort && match.length > 2) {
                var protocol = (match[1] || "").toLowerCase();
                var port = match[3] || "";
                // IE includes the standard port so pass it off if it's the same as the protocol
                if (protocol === "http" && port === ":80") {
                    port = "";
                }
                else if (protocol === "https" && port === ":443") {
                    port = "";
                }
                result += port;
            }
        }
    }
    return result;
}
//# sourceMappingURL=UrlHelperFuncs.js.map

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Data; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Base__ = __webpack_require__(610);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



// THIS FILE WAS AUTOGENERATED

/**
 * Data struct to contain both B and C sections.
 */
var Data = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(Data, _super);
    function Data() {
        return _super.call(this) || this;
    }
    return Data;
}(__WEBPACK_IMPORTED_MODULE_1__Base__["a" /* Base */]));

//# sourceMappingURL=Data.js.map

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Base; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// THIS FILE WAS AUTOGENERATED
/**
 * Data struct to contain only C section with custom fields.
 */
var Base = /** @class */ (function () {
    function Base() {
    }
    return Base;
}());

//# sourceMappingURL=Base.js.map

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventData; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * Instances of Event represent structured event records that can be grouped and searched by their properties. Event data item also creates a metric of event count by name.
 */
var EventData = /** @class */ (function () {
    function EventData() {
        /**
         * Schema version
         */
        this.ver = 2;
        /**
         * Collection of custom properties.
         */
        this.properties = {};
        /**
         * Collection of custom measurements.
         */
        this.measurements = {};
    }
    return EventData;
}());

//# sourceMappingURL=EventData.js.map

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContextTagKeys; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__ = __webpack_require__(35);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




function _aiNameFunc(baseName) {
    var aiName = "ai." + baseName + ".";
    return function (name) {
        return aiName + name;
    };
}
var _aiApplication = _aiNameFunc("application");
var _aiDevice = _aiNameFunc("device");
var _aiLocation = _aiNameFunc("location");
var _aiOperation = _aiNameFunc("operation");
var _aiSession = _aiNameFunc("session");
var _aiUser = _aiNameFunc("user");
var _aiCloud = _aiNameFunc("cloud");
var _aiInternal = _aiNameFunc("internal");
var ContextTagKeys = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(ContextTagKeys, _super);
    function ContextTagKeys() {
        return _super.call(this) || this;
    }
    return ContextTagKeys;
}(Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["l" /* createClassFromInterface */])({
    applicationVersion: _aiApplication("ver"),
    applicationBuild: _aiApplication("build"),
    applicationTypeId: _aiApplication("typeId"),
    applicationId: _aiApplication("applicationId"),
    applicationLayer: _aiApplication("layer"),
    deviceId: _aiDevice("id"),
    deviceIp: _aiDevice("ip"),
    deviceLanguage: _aiDevice("language"),
    deviceLocale: _aiDevice("locale"),
    deviceModel: _aiDevice("model"),
    deviceFriendlyName: _aiDevice("friendlyName"),
    deviceNetwork: _aiDevice("network"),
    deviceNetworkName: _aiDevice("networkName"),
    deviceOEMName: _aiDevice("oemName"),
    deviceOS: _aiDevice("os"),
    deviceOSVersion: _aiDevice("osVersion"),
    deviceRoleInstance: _aiDevice("roleInstance"),
    deviceRoleName: _aiDevice("roleName"),
    deviceScreenResolution: _aiDevice("screenResolution"),
    deviceType: _aiDevice("type"),
    deviceMachineName: _aiDevice("machineName"),
    deviceVMName: _aiDevice("vmName"),
    deviceBrowser: _aiDevice("browser"),
    deviceBrowserVersion: _aiDevice("browserVersion"),
    locationIp: _aiLocation("ip"),
    locationCountry: _aiLocation("country"),
    locationProvince: _aiLocation("province"),
    locationCity: _aiLocation("city"),
    operationId: _aiOperation("id"),
    operationName: _aiOperation("name"),
    operationParentId: _aiOperation("parentId"),
    operationRootId: _aiOperation("rootId"),
    operationSyntheticSource: _aiOperation("syntheticSource"),
    operationCorrelationVector: _aiOperation("correlationVector"),
    sessionId: _aiSession("id"),
    sessionIsFirst: _aiSession("isFirst"),
    sessionIsNew: _aiSession("isNew"),
    userAccountAcquisitionDate: _aiUser("accountAcquisitionDate"),
    userAccountId: _aiUser("accountId"),
    userAgent: _aiUser("userAgent"),
    userId: _aiUser("id"),
    userStoreRegion: _aiUser("storeRegion"),
    userAuthUserId: _aiUser("authUserId"),
    userAnonymousUserAcquisitionDate: _aiUser("anonUserAcquisitionDate"),
    userAuthenticatedUserAcquisitionDate: _aiUser("authUserAcquisitionDate"),
    cloudName: _aiCloud("name"),
    cloudRole: _aiCloud("role"),
    cloudRoleVer: _aiCloud("roleVer"),
    cloudRoleInstance: _aiCloud("roleInstance"),
    cloudEnvironment: _aiCloud("environment"),
    cloudLocation: _aiCloud("location"),
    cloudDeploymentUnit: _aiCloud("deploymentUnit"),
    internalNodeName: _aiInternal("nodeName"),
    internalSdkVersion: _aiInternal("sdkVersion"),
    internalAgentVersion: _aiInternal("agentVersion"),
    internalSnippet: _aiInternal("snippet"),
    internalSdkSrc: _aiInternal("sdkSrc")
})));

//# sourceMappingURL=ContextTagKeys.js.map

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export XHRMonitoringState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ajaxRecord; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__microsoft_dynamicproto_js__ = __webpack_require__(118);
/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





var strProperties = "properties";
/** @ignore */
function _calcPerfDuration(resourceEntry, start, end) {
    var result = 0;
    var from = resourceEntry[start];
    var to = resourceEntry[end];
    if (from && to) {
        result = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["i" /* dateTimeUtilsDuration */])(from, to);
    }
    return result;
}
/** @ignore */
function _setPerfDuration(props, name, resourceEntry, start, end) {
    var result = 0;
    var value = _calcPerfDuration(resourceEntry, start, end);
    if (value) {
        result = _setPerfValue(props, name, Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["k" /* msToTimeSpan */])(value));
    }
    return result;
}
/** @ignore */
function _setPerfValue(props, name, value) {
    var strPerf = "ajaxPerf";
    var result = 0;
    if (props && name && value) {
        var perfData = props[strPerf] = (props[strPerf] || {});
        perfData[name] = value;
        result = 1;
    }
    return result;
}
/** @ignore */
function _populatePerfData(ajaxData, dependency) {
    /*
    * https://developer.mozilla.org/en-US/docs/Web/API/Resource_Timing_API/Using_the_Resource_Timing_API
    *  | -startTime
    *  | -redirectStart
    *  |            | -redirectEnd
    *  |            | | -fetchStart
    *  |            | |   | -domainLookupStart
    *  |            | |   |                |- domainLookupEnd
    *  |            | |   |                | | -connectStart
    *  |            | |   |                | |  | -secureConnectionStart
    *  |            | |   |                | |  |        | -connectEnd
    *  |            | |   |                | |  |        | | -requestStart
    *  |            | |   |                | |  |        | |           | | -responseStart
    *  |            | |   |                | |  |        | |           | |            | | -responseEnd
    *  +------------+-+---+----------------+-+--+--------+-+-----------+-+------------+-+
    *  |--redirect--| |---|--domainLookup--| |--connect--| |--request--| |--response--| |
    *  |-------------------networkConnect----------------|
    *  |                                                   |---------sentRequest--------|
    *  |------------------------------------perfTotal-----------------------------------|
    */
    var resourceEntry = ajaxData.perfTiming;
    var props = dependency[strProperties] || {};
    var propsSet = 0;
    var strName = "name";
    var strStart = "Start";
    var strEnd = "End";
    var strDomainLookup = "domainLookup";
    var strConnect = "connect";
    var strRedirect = "redirect";
    var strRequest = "request";
    var strResponse = "response";
    var strDuration = "duration";
    var strStartTime = "startTime";
    var strDomainLookupStart = strDomainLookup + strStart;
    var strDomainLookupEnd = strDomainLookup + strEnd;
    var strConnectStart = strConnect + strStart;
    var strConnectEnd = strConnect + strEnd;
    var strRequestStart = strRequest + strStart;
    var strRequestEnd = strRequest + strEnd;
    var strResponseStart = strResponse + strStart;
    var strResponseEnd = strResponse + strEnd;
    var strRedirectStart = strRedirect + strStart;
    var strRedirectEnd = strRedirect = strEnd;
    var strTransferSize = "transferSize";
    var strEncodedBodySize = "encodedBodySize";
    var strDecodedBodySize = "decodedBodySize";
    var strServerTiming = "serverTiming";
    if (resourceEntry) {
        // redirect
        propsSet |= _setPerfDuration(props, strRedirect, resourceEntry, strRedirectStart, strRedirectEnd);
        // domainLookup
        propsSet |= _setPerfDuration(props, strDomainLookup, resourceEntry, strDomainLookupStart, strDomainLookupEnd);
        // connect
        propsSet |= _setPerfDuration(props, strConnect, resourceEntry, strConnectStart, strConnectEnd);
        // request
        propsSet |= _setPerfDuration(props, strRequest, resourceEntry, strRequestStart, strRequestEnd);
        // response
        propsSet |= _setPerfDuration(props, strResponse, resourceEntry, strResponseStart, strResponseEnd);
        // Network connection time
        propsSet |= _setPerfDuration(props, "networkConnect", resourceEntry, strStartTime, strConnectEnd);
        // Sent Request
        propsSet |= _setPerfDuration(props, "sentRequest", resourceEntry, strRequestStart, strResponseEnd);
        // PerfTotal / Duration
        var duration = resourceEntry[strDuration];
        if (!duration) {
            duration = _calcPerfDuration(resourceEntry, strStartTime, strResponseEnd) || 0;
        }
        propsSet |= _setPerfValue(props, strDuration, duration);
        propsSet |= _setPerfValue(props, "perfTotal", duration);
        var serverTiming = resourceEntry[strServerTiming];
        if (serverTiming) {
            var server_1 = {};
            Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["g" /* arrForEach */])(serverTiming, function (value, idx) {
                var name = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["L" /* normalizeJsName */])(value[strName] || "" + idx);
                var newValue = server_1[name] || {};
                Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["M" /* objForEachKey */])(value, function (key, val) {
                    if (key !== strName && Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["J" /* isString */])(val) || Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["H" /* isNumber */])(val)) {
                        if (newValue[key]) {
                            val = newValue[key] + ";" + val;
                        }
                        if (val || !Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["J" /* isString */])(val)) {
                            // Only set the value if it has a value and it's not an empty string
                            newValue[key] = val;
                        }
                    }
                });
                server_1[name] = newValue;
            });
            propsSet |= _setPerfValue(props, strServerTiming, server_1);
        }
        propsSet |= _setPerfValue(props, strTransferSize, resourceEntry[strTransferSize]);
        propsSet |= _setPerfValue(props, strEncodedBodySize, resourceEntry[strEncodedBodySize]);
        propsSet |= _setPerfValue(props, strDecodedBodySize, resourceEntry[strDecodedBodySize]);
    }
    else {
        if (ajaxData.perfMark) {
            propsSet |= _setPerfValue(props, "missing", ajaxData.perfAttempts);
        }
    }
    if (propsSet) {
        dependency[strProperties] = props;
    }
}
var XHRMonitoringState = /** @class */ (function () {
    function XHRMonitoringState() {
        var self = this;
        self.openDone = false;
        self.setRequestHeaderDone = false;
        self.sendDone = false;
        self.abortDone = false;
        // <summary>True, if onreadyStateChangeCallback function attached to xhr, otherwise false</summary>
        self.stateChangeAttached = false;
    }
    return XHRMonitoringState;
}());

var ajaxRecord = /** @class */ (function () {
    function ajaxRecord(traceID, spanID, logger) {
        var self = this;
        var _logger = logger;
        var strResponseText = "responseText";
        // Assigning the initial/default values within the constructor to avoid typescript from creating a bunch of
        // this.XXXX = null
        self.perfMark = null;
        self.completed = false;
        self.requestHeadersSize = null;
        self.requestHeaders = null;
        self.responseReceivingDuration = null;
        self.callbackDuration = null;
        self.ajaxTotalDuration = null;
        self.aborted = 0;
        self.pageUrl = null;
        self.requestUrl = null;
        self.requestSize = 0;
        self.method = null;
        self.status = null;
        self.requestSentTime = null;
        self.responseStartedTime = null;
        self.responseFinishedTime = null;
        self.callbackFinishedTime = null;
        self.endTime = null;
        self.xhrMonitoringState = new XHRMonitoringState();
        self.clientFailure = 0;
        self.traceID = traceID;
        self.spanID = spanID;
        Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_dynamicproto_js__["a" /* default */])(ajaxRecord, self, function (self) {
            self.getAbsoluteUrl = function () {
                return self.requestUrl ? Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["l" /* urlGetAbsoluteUrl */])(self.requestUrl) : null;
            };
            self.getPathName = function () {
                return self.requestUrl ? Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["h" /* dataSanitizeUrl */])(_logger, Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["m" /* urlGetCompleteUrl */])(self.method, self.requestUrl)) : null;
            };
            self.CreateTrackItem = function (ajaxType, enableRequestHeaderTracking, getResponse) {
                // round to 3 decimal points
                self.ajaxTotalDuration = Math.round(Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["i" /* dateTimeUtilsDuration */])(self.requestSentTime, self.responseFinishedTime) * 1000) / 1000;
                if (self.ajaxTotalDuration < 0) {
                    return null;
                }
                var dependency = (_a = {
                        id: "|" + self.traceID + "." + self.spanID,
                        target: self.getAbsoluteUrl(),
                        name: self.getPathName(),
                        type: ajaxType,
                        startTime: null,
                        duration: self.ajaxTotalDuration,
                        success: (+(self.status)) >= 200 && (+(self.status)) < 400,
                        responseCode: (+(self.status)),
                        method: self.method
                    },
                    _a[strProperties] = { HttpMethod: self.method },
                    _a);
                if (self.requestSentTime) {
                    // Set the correct dependency start time
                    dependency.startTime = new Date();
                    dependency.startTime.setTime(self.requestSentTime);
                }
                // Add Ajax perf details if available
                _populatePerfData(self, dependency);
                if (enableRequestHeaderTracking) {
                    if (Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["N" /* objKeys */])(self.requestHeaders).length > 0) {
                        dependency[strProperties] = dependency[strProperties] || {};
                        dependency[strProperties].requestHeaders = self.requestHeaders;
                    }
                }
                if (getResponse) {
                    var response = getResponse();
                    if (response) {
                        // enrich dependency target with correlation context from the server
                        var correlationContext = response.correlationContext;
                        if (correlationContext) {
                            dependency.correlationContext = /* dependency.target + " | " + */ correlationContext;
                        }
                        if (response.headerMap) {
                            if (Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["N" /* objKeys */])(response.headerMap).length > 0) {
                                dependency[strProperties] = dependency[strProperties] || {};
                                dependency[strProperties].responseHeaders = response.headerMap;
                            }
                        }
                        if (self.status >= 400) {
                            var responseType = response.type;
                            dependency[strProperties] = dependency[strProperties] || {};
                            if (responseType === "" || responseType === "text") {
                                dependency[strProperties][strResponseText] = response[strResponseText] ? response.statusText + " - " + response[strResponseText] : response.statusText;
                            }
                            if (responseType === "json") {
                                dependency[strProperties][strResponseText] = response.response ? response.statusText + " - " + JSON.stringify(response.response) : response.statusText;
                            }
                        }
                    }
                }
                return dependency;
                var _a;
            };
        });
    }
// Removed Stub for ajaxRecord.prototype.getAbsoluteUrl.
// Removed Stub for ajaxRecord.prototype.getPathName.
// Removed Stub for ajaxRecord.prototype.CreateTrackItem.
    return ajaxRecord;
}());

;
//# sourceMappingURL=ajaxRecord.js.map

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isInternalApplicationInsightsEndpoint */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Util; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UrlHelper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CorrelationIdHelper; });
/* harmony export (immutable) */ __webpack_exports__["a"] = AjaxHelperParseDependencyPath;
/* unused harmony export dateTimeUtilsNow */
/* unused harmony export dateTimeUtilsDuration */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DateTimeUtils; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RequestResponseHeaders__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Telemetry_Common_DataSanitizer__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DomHelperFuncs__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HelperFuncs__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Constants__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__ = __webpack_require__(619);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */










// listing only non-geo specific locations
var _internalEndpoints = [
    "https://dc.services.visualstudio.com/v2/track",
    "https://breeze.aimon.applicationinsights.io/v2/track",
    "https://dc-int.services.visualstudio.com/v2/track"
];
function isInternalApplicationInsightsEndpoint(endpointUrl) {
    return _internalEndpoints.indexOf(endpointUrl.toLowerCase()) !== -1;
}
var Util = {
    NotSpecified: __WEBPACK_IMPORTED_MODULE_5__Constants__["f" /* strNotSpecified */],
    createDomEvent: __WEBPACK_IMPORTED_MODULE_3__DomHelperFuncs__["a" /* createDomEvent */],
    disableStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["c" /* utlDisableStorage */],
    isInternalApplicationInsightsEndpoint: isInternalApplicationInsightsEndpoint,
    canUseLocalStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["a" /* utlCanUseLocalStorage */],
    getStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["d" /* utlGetLocalStorage */],
    setStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["i" /* utlSetLocalStorage */],
    removeStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["h" /* utlRemoveStorage */],
    canUseSessionStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["b" /* utlCanUseSessionStorage */],
    getSessionStorageKeys: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["f" /* utlGetSessionStorageKeys */],
    getSessionStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["e" /* utlGetSessionStorage */],
    setSessionStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["j" /* utlSetSessionStorage */],
    removeSessionStorage: __WEBPACK_IMPORTED_MODULE_6__StorageHelperFuncs__["g" /* utlRemoveSessionStorage */],
    disableCookies: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["n" /* disableCookies */],
    canUseCookies: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["j" /* canUseCookies */],
    disallowsSameSiteNone: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["U" /* uaDisallowsSameSiteNone */],
    setCookie: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["Q" /* setCookie */],
    stringToBoolOrDefault: __WEBPACK_IMPORTED_MODULE_4__HelperFuncs__["e" /* stringToBoolOrDefault */],
    getCookie: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["r" /* getCookie */],
    deleteCookie: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["m" /* deleteCookie */],
    trim: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["R" /* strTrim */],
    newId: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["L" /* newId */],
    random32: function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["P" /* random32 */])(true);
    },
    generateW3CId: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["q" /* generateW3CId */],
    isArray: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["D" /* isArray */],
    isError: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["F" /* isError */],
    isDate: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["E" /* isDate */],
    toISOStringForIE8: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["T" /* toISOString */],
    getIEVersion: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["w" /* getIEVersion */],
    msToTimeSpan: __WEBPACK_IMPORTED_MODULE_4__HelperFuncs__["d" /* msToTimeSpan */],
    isCrossOriginError: __WEBPACK_IMPORTED_MODULE_4__HelperFuncs__["c" /* isCrossOriginError */],
    dump: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["p" /* dumpObj */],
    getExceptionName: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["t" /* getExceptionName */],
    addEventHandler: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["i" /* attachEvent */],
    IsBeaconApiSupported: __WEBPACK_IMPORTED_MODULE_4__HelperFuncs__["b" /* isBeaconApiSupported */],
    getExtension: __WEBPACK_IMPORTED_MODULE_4__HelperFuncs__["a" /* getExtensionByName */]
};
;
var UrlHelper = {
    parseUrl: __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["f" /* urlParseUrl */],
    getAbsoluteUrl: __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["a" /* urlGetAbsoluteUrl */],
    getPathName: __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["c" /* urlGetPathName */],
    getCompleteUrl: __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["b" /* urlGetCompleteUrl */],
    parseHost: __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["e" /* urlParseHost */],
    parseFullHost: __WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["d" /* urlParseFullHost */]
};
var CorrelationIdHelper = {
    correlationIdPrefix: "cid-v1:",
    /**
     * Checks if a request url is not on a excluded domain list and if it is safe to add correlation headers.
     * Headers are always included if the current domain matches the request domain. If they do not match (CORS),
     * they are regex-ed across correlationHeaderDomains and correlationHeaderExcludedDomains to determine if headers are included.
     * Some environments don't give information on currentHost via window.location.host (e.g. Cordova). In these cases, the user must
     * manually supply domains to include correlation headers on. Else, no headers will be included at all.
     */
    canIncludeCorrelationHeader: function (config, requestUrl, currentHost) {
        if (!requestUrl || (config && config.disableCorrelationHeaders)) {
            return false;
        }
        if (config && config.correlationHeaderExcludePatterns) {
            for (var i = 0; i < config.correlationHeaderExcludePatterns.length; i++) {
                if (config.correlationHeaderExcludePatterns[i].test(requestUrl)) {
                    return false;
                }
            }
        }
        var requestHost = Object(__WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["f" /* urlParseUrl */])(requestUrl).host.toLowerCase();
        if (requestHost && (requestHost.indexOf(":443") !== -1 || requestHost.indexOf(":80") !== -1)) {
            // [Bug #1260] IE can include the port even for http and https URLs so if present 
            // try and parse it to remove if it matches the default protocol port
            requestHost = (Object(__WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["d" /* urlParseFullHost */])(requestUrl, true) || "").toLowerCase();
        }
        if ((!config || !config.enableCorsCorrelation) && requestHost !== currentHost) {
            return false;
        }
        var includedDomains = config && config.correlationHeaderDomains;
        if (includedDomains) {
            var matchExists_1;
            Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["f" /* arrForEach */])(includedDomains, function (domain) {
                var regex = new RegExp(domain.toLowerCase().replace(/\./g, "\.").replace(/\*/g, ".*"));
                matchExists_1 = matchExists_1 || regex.test(requestHost);
            });
            if (!matchExists_1) {
                return false;
            }
        }
        var excludedDomains = config && config.correlationHeaderExcludedDomains;
        if (!excludedDomains || excludedDomains.length === 0) {
            return true;
        }
        for (var i = 0; i < excludedDomains.length; i++) {
            var regex = new RegExp(excludedDomains[i].toLowerCase().replace(/\./g, "\.").replace(/\*/g, ".*"));
            if (regex.test(requestHost)) {
                return false;
            }
        }
        // if we don't know anything about the requestHost, require the user to use included/excludedDomains.
        // Previously we always returned false for a falsy requestHost
        return requestHost && requestHost.length > 0;
    },
    /**
     * Combines target appId and target role name from response header.
     */
    getCorrelationContext: function (responseHeader) {
        if (responseHeader) {
            var correlationId = CorrelationIdHelper.getCorrelationContextValue(responseHeader, __WEBPACK_IMPORTED_MODULE_1__RequestResponseHeaders__["a" /* RequestHeaders */].requestContextTargetKey);
            if (correlationId && correlationId !== CorrelationIdHelper.correlationIdPrefix) {
                return correlationId;
            }
        }
    },
    /**
     * Gets key from correlation response header
     */
    getCorrelationContextValue: function (responseHeader, key) {
        if (responseHeader) {
            var keyValues = responseHeader.split(",");
            for (var i = 0; i < keyValues.length; ++i) {
                var keyValue = keyValues[i].split("=");
                if (keyValue.length === 2 && keyValue[0] === key) {
                    return keyValue[1];
                }
            }
        }
    }
};
function AjaxHelperParseDependencyPath(logger, absoluteUrl, method, commandName) {
    var target, name = commandName, data = commandName;
    if (absoluteUrl && absoluteUrl.length > 0) {
        var parsedUrl = Object(__WEBPACK_IMPORTED_MODULE_7__UrlHelperFuncs__["f" /* urlParseUrl */])(absoluteUrl);
        target = parsedUrl.host;
        if (!name) {
            if (parsedUrl.pathname != null) {
                var pathName = (parsedUrl.pathname.length === 0) ? "/" : parsedUrl.pathname;
                if (pathName.charAt(0) !== '/') {
                    pathName = "/" + pathName;
                }
                data = parsedUrl.pathname;
                name = Object(__WEBPACK_IMPORTED_MODULE_2__Telemetry_Common_DataSanitizer__["g" /* dataSanitizeString */])(logger, method ? method + " " + pathName : pathName);
            }
            else {
                name = Object(__WEBPACK_IMPORTED_MODULE_2__Telemetry_Common_DataSanitizer__["g" /* dataSanitizeString */])(logger, absoluteUrl);
            }
        }
    }
    else {
        target = commandName;
        name = commandName;
    }
    return {
        target: target,
        name: name,
        data: data
    };
}
function dateTimeUtilsNow() {
    // returns the window or webworker performance object
    var perf = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["z" /* getPerformance */])();
    if (perf && perf.now && perf.timing) {
        var now = perf.now() + perf.timing.navigationStart;
        // Known issue with IE where this calculation can be negative, so if it is then ignore and fallback
        if (now > 0) {
            return now;
        }
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["l" /* dateNow */])();
}
function dateTimeUtilsDuration(start, end) {
    var result = null;
    if (start !== 0 && end !== 0 && !Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["H" /* isNullOrUndefined */])(start) && !Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["H" /* isNullOrUndefined */])(end)) {
        result = end - start;
    }
    return result;
}
/**
 * A utility class that helps getting time related parameters
 */
var DateTimeUtils = {
    Now: dateTimeUtilsNow,
    GetDuration: dateTimeUtilsDuration
};
//# sourceMappingURL=Util.js.map

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RequestHeaders; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var RequestHeaders = {
    requestContextHeader: "Request-Context",
    requestContextTargetKey: "appId",
    requestContextAppIdFormat: "appId=cid-v1:",
    requestIdHeader: "Request-Id",
    traceParentHeader: "traceparent",
    traceStateHeader: "tracestate",
    sdkContextHeader: "Sdk-Context",
    sdkContextHeaderAppIdRequest: "appId",
    requestContextHeaderLowerCase: "request-context"
};
//# sourceMappingURL=RequestResponseHeaders.js.map

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createDomEvent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(39);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



function createDomEvent(eventName) {
    var event = null;
    if (Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["G" /* isFunction */])(Event)) {
        event = new Event(eventName);
    }
    else {
        var doc = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["s" /* getDocument */])();
        if (doc && doc.createEvent) {
            event = doc.createEvent("Event");
            event.initEvent(eventName, true, true);
        }
    }
    return event;
}
//# sourceMappingURL=DomHelperFuncs.js.map

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = utlDisableStorage;
/* harmony export (immutable) */ __webpack_exports__["a"] = utlCanUseLocalStorage;
/* harmony export (immutable) */ __webpack_exports__["d"] = utlGetLocalStorage;
/* harmony export (immutable) */ __webpack_exports__["i"] = utlSetLocalStorage;
/* harmony export (immutable) */ __webpack_exports__["h"] = utlRemoveStorage;
/* harmony export (immutable) */ __webpack_exports__["b"] = utlCanUseSessionStorage;
/* harmony export (immutable) */ __webpack_exports__["f"] = utlGetSessionStorageKeys;
/* harmony export (immutable) */ __webpack_exports__["e"] = utlGetSessionStorage;
/* harmony export (immutable) */ __webpack_exports__["j"] = utlSetSessionStorage;
/* harmony export (immutable) */ __webpack_exports__["g"] = utlRemoveSessionStorage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Enums__ = __webpack_require__(618);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var _canUseLocalStorage = undefined;
var _canUseSessionStorage = undefined;
/**
 * Gets the localStorage object if available
 * @return {Storage} - Returns the storage object if available else returns null
 */
function _getLocalStorageObject() {
    if (utlCanUseLocalStorage()) {
        return _getVerifiedStorageObject(__WEBPACK_IMPORTED_MODULE_1__Enums__["b" /* StorageType */].LocalStorage);
    }
    return null;
}
/**
 * Tests storage object (localStorage or sessionStorage) to verify that it is usable
 * More details here: https://mathiasbynens.be/notes/localstorage-pattern
 * @param storageType Type of storage
 * @return {Storage} Returns storage object verified that it is usable
 */
function _getVerifiedStorageObject(storageType) {
    try {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["H" /* isNullOrUndefined */])(Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["u" /* getGlobal */])())) {
            return null;
        }
        var uid = new Date;
        var storage = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["v" /* getGlobalInst */])(storageType === __WEBPACK_IMPORTED_MODULE_1__Enums__["b" /* StorageType */].LocalStorage ? "localStorage" : "sessionStorage");
        storage.setItem(uid.toString(), uid.toString());
        var fail = storage.getItem(uid.toString()) !== uid.toString();
        storage.removeItem(uid.toString());
        if (!fail) {
            return storage;
        }
    }
    catch (exception) {
    }
    return null;
}
/**
 * Gets the sessionStorage object if available
 * @return {Storage} - Returns the storage object if available else returns null
 */
function _getSessionStorageObject() {
    if (utlCanUseSessionStorage()) {
        return _getVerifiedStorageObject(__WEBPACK_IMPORTED_MODULE_1__Enums__["b" /* StorageType */].SessionStorage);
    }
    return null;
}
function utlDisableStorage() {
    _canUseLocalStorage = false;
    _canUseSessionStorage = false;
}
function utlCanUseLocalStorage() {
    if (_canUseLocalStorage === undefined) {
        _canUseLocalStorage = !!_getVerifiedStorageObject(__WEBPACK_IMPORTED_MODULE_1__Enums__["b" /* StorageType */].LocalStorage);
    }
    return _canUseLocalStorage;
}
function utlGetLocalStorage(logger, name) {
    var storage = _getLocalStorageObject();
    if (storage !== null) {
        try {
            return storage.getItem(name);
        }
        catch (e) {
            _canUseLocalStorage = false;
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].BrowserCannotReadLocalStorage, "Browser failed read of local storage. " + Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["t" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["p" /* dumpObj */])(e) });
        }
    }
    return null;
}
function utlSetLocalStorage(logger, name, data) {
    var storage = _getLocalStorageObject();
    if (storage !== null) {
        try {
            storage.setItem(name, data);
            return true;
        }
        catch (e) {
            _canUseLocalStorage = false;
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].BrowserCannotWriteLocalStorage, "Browser failed write to local storage. " + Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["t" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["p" /* dumpObj */])(e) });
        }
    }
    return false;
}
function utlRemoveStorage(logger, name) {
    var storage = _getLocalStorageObject();
    if (storage !== null) {
        try {
            storage.removeItem(name);
            return true;
        }
        catch (e) {
            _canUseLocalStorage = false;
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].BrowserFailedRemovalFromLocalStorage, "Browser failed removal of local storage item. " + Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["t" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["p" /* dumpObj */])(e) });
        }
    }
    return false;
}
function utlCanUseSessionStorage() {
    if (_canUseSessionStorage === undefined) {
        _canUseSessionStorage = !!_getVerifiedStorageObject(__WEBPACK_IMPORTED_MODULE_1__Enums__["b" /* StorageType */].SessionStorage);
    }
    return _canUseSessionStorage;
}
function utlGetSessionStorageKeys() {
    var keys = [];
    if (utlCanUseSessionStorage()) {
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["M" /* objForEachKey */])(Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["v" /* getGlobalInst */])("sessionStorage"), function (key) {
            keys.push(key);
        });
    }
    return keys;
}
function utlGetSessionStorage(logger, name) {
    var storage = _getSessionStorageObject();
    if (storage !== null) {
        try {
            return storage.getItem(name);
        }
        catch (e) {
            _canUseSessionStorage = false;
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].BrowserCannotReadSessionStorage, "Browser failed read of session storage. " + Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["t" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["p" /* dumpObj */])(e) });
        }
    }
    return null;
}
function utlSetSessionStorage(logger, name, data) {
    var storage = _getSessionStorageObject();
    if (storage !== null) {
        try {
            storage.setItem(name, data);
            return true;
        }
        catch (e) {
            _canUseSessionStorage = false;
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].BrowserCannotWriteSessionStorage, "Browser failed write to session storage. " + Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["t" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["p" /* dumpObj */])(e) });
        }
    }
    return false;
}
function utlRemoveSessionStorage(logger, name) {
    var storage = _getSessionStorageObject();
    if (storage !== null) {
        try {
            storage.removeItem(name);
            return true;
        }
        catch (e) {
            _canUseSessionStorage = false;
            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].BrowserFailedRemovalFromSessionStorage, "Browser failed removal of session storage item. " + Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["t" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["p" /* dumpObj */])(e) });
        }
    }
    return false;
}
//# sourceMappingURL=StorageHelperFuncs.js.map

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StorageType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DistributedTracingModes; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * Type of storage to differentiate between local storage and session storage
 */
var StorageType;
(function (StorageType) {
    StorageType[StorageType["LocalStorage"] = 0] = "LocalStorage";
    StorageType[StorageType["SessionStorage"] = 1] = "SessionStorage";
})(StorageType || (StorageType = {}));
;
var DistributedTracingModes;
(function (DistributedTracingModes) {
    /**
     * (Default) Send Application Insights correlation headers
     */
    DistributedTracingModes[DistributedTracingModes["AI"] = 0] = "AI";
    /**
     * Send both W3C Trace Context headers and back-compatibility Application Insights headers
     */
    DistributedTracingModes[DistributedTracingModes["AI_AND_W3C"] = 1] = "AI_AND_W3C";
    /**
     * Send W3C Trace Context headers
     */
    DistributedTracingModes[DistributedTracingModes["W3C"] = 2] = "W3C";
})(DistributedTracingModes || (DistributedTracingModes = {}));
//# sourceMappingURL=Enums.js.map

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = urlParseUrl;
/* harmony export (immutable) */ __webpack_exports__["a"] = urlGetAbsoluteUrl;
/* harmony export (immutable) */ __webpack_exports__["c"] = urlGetPathName;
/* harmony export (immutable) */ __webpack_exports__["b"] = urlGetCompleteUrl;
/* harmony export (immutable) */ __webpack_exports__["e"] = urlParseHost;
/* harmony export (immutable) */ __webpack_exports__["d"] = urlParseFullHost;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(39);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



var _document = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["s" /* getDocument */])() || {};
var _htmlAnchorIdx = 0;
// Use an array of temporary values as it's possible for multiple calls to parseUrl() will be called with different URLs
// Using a cache size of 5 for now as it current depth usage is at least 2, so adding a minor buffer to handle future updates
var _htmlAnchorElement = [null, null, null, null, null];
function urlParseUrl(url) {
    var anchorIdx = _htmlAnchorIdx;
    var anchorCache = _htmlAnchorElement;
    var tempAnchor = anchorCache[anchorIdx];
    if (!_document.createElement) {
        // Always create the temp instance if createElement is not available
        tempAnchor = { host: urlParseHost(url, true) };
    }
    else if (!anchorCache[anchorIdx]) {
        // Create and cache the unattached anchor instance 
        tempAnchor = anchorCache[anchorIdx] = _document.createElement('a');
    }
    tempAnchor.href = url;
    // Move the cache index forward
    anchorIdx++;
    if (anchorIdx >= anchorCache.length) {
        anchorIdx = 0;
    }
    _htmlAnchorIdx = anchorIdx;
    return tempAnchor;
}
function urlGetAbsoluteUrl(url) {
    var result;
    var a = urlParseUrl(url);
    if (a) {
        result = a.href;
    }
    return result;
}
function urlGetPathName(url) {
    var result;
    var a = urlParseUrl(url);
    if (a) {
        result = a.pathname;
    }
    return result;
}
function urlGetCompleteUrl(method, absoluteUrl) {
    if (method) {
        return method.toUpperCase() + " " + absoluteUrl;
    }
    return absoluteUrl;
}
// Fallback method to grab host from url if document.createElement method is not available
function urlParseHost(url, inclPort) {
    var fullHost = urlParseFullHost(url, inclPort);
    if (fullHost) {
        var match = fullHost.match(/(www[0-9]?\.)?(.[^/:]+)(\:[\d]+)?/i);
        if (match != null && match.length > 3 && Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["K" /* isString */])(match[2]) && match[2].length > 0) {
            return match[2] + (match[3] || "");
        }
    }
    return fullHost;
}
function urlParseFullHost(url, inclPort) {
    var result = null;
    if (url) {
        var match = url.match(/(\w*):\/\/(.[^/:]+)(\:[\d]+)?/i);
        if (match != null && match.length > 2 && Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["K" /* isString */])(match[2]) && match[2].length > 0) {
            result = match[2] || "";
            if (inclPort && match.length > 2) {
                var protocol = (match[1] || "").toLowerCase();
                var port = match[3] || "";
                // IE includes the standard port so pass it off if it's the same as the protocol
                if (protocol === "http" && port === ":80") {
                    port = "";
                }
                else if (protocol === "https" && port === ":443") {
                    port = "";
                }
                result += port;
            }
        }
    }
    return result;
}
//# sourceMappingURL=UrlHelperFuncs.js.map

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Data; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Base__ = __webpack_require__(621);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



// THIS FILE WAS AUTOGENERATED

/**
 * Data struct to contain both B and C sections.
 */
var Data = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(Data, _super);
    function Data() {
        return _super.call(this) || this;
    }
    return Data;
}(__WEBPACK_IMPORTED_MODULE_1__Base__["a" /* Base */]));

//# sourceMappingURL=Data.js.map

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Base; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// THIS FILE WAS AUTOGENERATED
/**
 * Data struct to contain only C section with custom fields.
 */
var Base = /** @class */ (function () {
    function Base() {
    }
    return Base;
}());

//# sourceMappingURL=Base.js.map

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventData; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * Instances of Event represent structured event records that can be grouped and searched by their properties. Event data item also creates a metric of event count by name.
 */
var EventData = /** @class */ (function () {
    function EventData() {
        /**
         * Schema version
         */
        this.ver = 2;
        /**
         * Collection of custom properties.
         */
        this.properties = {};
        /**
         * Collection of custom measurements.
         */
        this.measurements = {};
    }
    return EventData;
}());

//# sourceMappingURL=EventData.js.map

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContextTagKeys; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__ = __webpack_require__(39);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




function _aiNameFunc(baseName) {
    var aiName = "ai." + baseName + ".";
    return function (name) {
        return aiName + name;
    };
}
var _aiApplication = _aiNameFunc("application");
var _aiDevice = _aiNameFunc("device");
var _aiLocation = _aiNameFunc("location");
var _aiOperation = _aiNameFunc("operation");
var _aiSession = _aiNameFunc("session");
var _aiUser = _aiNameFunc("user");
var _aiCloud = _aiNameFunc("cloud");
var _aiInternal = _aiNameFunc("internal");
var ContextTagKeys = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(ContextTagKeys, _super);
    function ContextTagKeys() {
        return _super.call(this) || this;
    }
    return ContextTagKeys;
}(Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["k" /* createClassFromInterface */])({
    applicationVersion: _aiApplication("ver"),
    applicationBuild: _aiApplication("build"),
    applicationTypeId: _aiApplication("typeId"),
    applicationId: _aiApplication("applicationId"),
    applicationLayer: _aiApplication("layer"),
    deviceId: _aiDevice("id"),
    deviceIp: _aiDevice("ip"),
    deviceLanguage: _aiDevice("language"),
    deviceLocale: _aiDevice("locale"),
    deviceModel: _aiDevice("model"),
    deviceFriendlyName: _aiDevice("friendlyName"),
    deviceNetwork: _aiDevice("network"),
    deviceNetworkName: _aiDevice("networkName"),
    deviceOEMName: _aiDevice("oemName"),
    deviceOS: _aiDevice("os"),
    deviceOSVersion: _aiDevice("osVersion"),
    deviceRoleInstance: _aiDevice("roleInstance"),
    deviceRoleName: _aiDevice("roleName"),
    deviceScreenResolution: _aiDevice("screenResolution"),
    deviceType: _aiDevice("type"),
    deviceMachineName: _aiDevice("machineName"),
    deviceVMName: _aiDevice("vmName"),
    deviceBrowser: _aiDevice("browser"),
    deviceBrowserVersion: _aiDevice("browserVersion"),
    locationIp: _aiLocation("ip"),
    locationCountry: _aiLocation("country"),
    locationProvince: _aiLocation("province"),
    locationCity: _aiLocation("city"),
    operationId: _aiOperation("id"),
    operationName: _aiOperation("name"),
    operationParentId: _aiOperation("parentId"),
    operationRootId: _aiOperation("rootId"),
    operationSyntheticSource: _aiOperation("syntheticSource"),
    operationCorrelationVector: _aiOperation("correlationVector"),
    sessionId: _aiSession("id"),
    sessionIsFirst: _aiSession("isFirst"),
    sessionIsNew: _aiSession("isNew"),
    userAccountAcquisitionDate: _aiUser("accountAcquisitionDate"),
    userAccountId: _aiUser("accountId"),
    userAgent: _aiUser("userAgent"),
    userId: _aiUser("id"),
    userStoreRegion: _aiUser("storeRegion"),
    userAuthUserId: _aiUser("authUserId"),
    userAnonymousUserAcquisitionDate: _aiUser("anonUserAcquisitionDate"),
    userAuthenticatedUserAcquisitionDate: _aiUser("authUserAcquisitionDate"),
    cloudName: _aiCloud("name"),
    cloudRole: _aiCloud("role"),
    cloudRoleVer: _aiCloud("roleVer"),
    cloudRoleInstance: _aiCloud("roleInstance"),
    cloudEnvironment: _aiCloud("environment"),
    cloudLocation: _aiCloud("location"),
    cloudDeploymentUnit: _aiCloud("deploymentUnit"),
    internalNodeName: _aiInternal("nodeName"),
    internalSdkVersion: _aiInternal("sdkVersion"),
    internalAgentVersion: _aiInternal("agentVersion"),
    internalSnippet: _aiInternal("snippet"),
    internalSdkSrc: _aiInternal("sdkSrc")
})));

//# sourceMappingURL=ContextTagKeys.js.map

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);


/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);


/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* harmony default export */ __webpack_exports__["default"] = (warning);


/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    throw new Error(prefix + ": " + (message || ''));
}

/* harmony default export */ __webpack_exports__["default"] = (invariant);


/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__buildClassMap__ = __webpack_require__(629);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__buildClassMap__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icons__ = __webpack_require__(634);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__icons__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__icons__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__icons__["b"]; });
/* unused harmony reexport unregisterIcons */
/* unused harmony reexport setIconOptions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getIconClassName__ = __webpack_require__(1621);
/* unused harmony reexport getIconClassName */



//# sourceMappingURL=index.js.map

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildClassMap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MergeStyles__ = __webpack_require__(630);

/**
 * Builds a class names object from a given map.
 *
 * @param styles - Map of unprocessed styles.
 * @returns Map of property name to class name.
 */
function buildClassMap(styles) {
    var classes = {};
    var _loop_1 = function (styleName) {
        if (styles.hasOwnProperty(styleName)) {
            var className_1;
            Object.defineProperty(classes, styleName, {
                get: function () {
                    if (className_1 === undefined) {
                        // tslint:disable-next-line:no-any
                        className_1 = Object(__WEBPACK_IMPORTED_MODULE_0__MergeStyles__["d" /* mergeStyles */])(styles[styleName]).toString();
                    }
                    return className_1;
                },
                enumerable: true,
                configurable: true
            });
        }
    };
    for (var styleName in styles) {
        _loop_1(styleName);
    }
    return classes;
}
//# sourceMappingURL=buildClassMap.js.map

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uifabric_merge_styles__ = __webpack_require__(46);
/* unused harmony reexport InjectionMode */
/* unused harmony reexport Stylesheet */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__uifabric_merge_styles__["b"]; });
/* unused harmony reexport fontFace */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__uifabric_merge_styles__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__uifabric_merge_styles__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__uifabric_merge_styles__["f"]; });

//# sourceMappingURL=MergeStyles.js.map

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = setRTL;
/* unused harmony export getRTL */
/* harmony export (immutable) */ __webpack_exports__["a"] = rtlifyRules;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stylesheet__ = __webpack_require__(146);

var LEFT = 'left';
var RIGHT = 'right';
var NO_FLIP = '@noflip';
var NAME_REPLACEMENTS = (_a = {},
    _a[LEFT] = RIGHT,
    _a[RIGHT] = LEFT,
    _a);
var VALUE_REPLACEMENTS = {
    'w-resize': 'e-resize',
    'sw-resize': 'se-resize',
    'nw-resize': 'ne-resize'
};
var _rtl = getRTL();
/**
 * Sets the current RTL value.
 */
function setRTL(isRTL) {
    if (_rtl !== isRTL) {
        __WEBPACK_IMPORTED_MODULE_0__Stylesheet__["a" /* Stylesheet */].getInstance().resetKeys();
        _rtl = isRTL;
    }
}
/**
 * Gets the current RTL value.
 */
function getRTL() {
    if (_rtl === undefined) {
        _rtl = typeof document !== 'undefined' && !!document.documentElement && document.documentElement.getAttribute('dir') === 'rtl';
    }
    return _rtl;
}
/**
 * RTLifies the rulePair in the array at the current index. This mutates the array for performance
 * reasons.
 */
function rtlifyRules(rulePairs, index) {
    if (getRTL()) {
        var name_1 = rulePairs[index];
        if (!name_1) {
            return;
        }
        var value = rulePairs[index + 1];
        if (typeof value === 'string' && value.indexOf(NO_FLIP) >= 0) {
            rulePairs[index + 1] = value.replace(/\s*(?:\/\*\s*)?\@noflip\b(?:\s*\*\/)?\s*?/g, '');
        }
        else if (name_1.indexOf(LEFT) >= 0) {
            rulePairs[index] = name_1.replace(LEFT, RIGHT);
        }
        else if (name_1.indexOf(RIGHT) >= 0) {
            rulePairs[index] = name_1.replace(RIGHT, LEFT);
        }
        else if (String(value).indexOf(LEFT) >= 0) {
            rulePairs[index + 1] = value.replace(LEFT, RIGHT);
        }
        else if (String(value).indexOf(RIGHT) >= 0) {
            rulePairs[index + 1] = value.replace(RIGHT, LEFT);
        }
        else if (NAME_REPLACEMENTS[name_1]) {
            rulePairs[index] = NAME_REPLACEMENTS[name_1];
        }
        else if (VALUE_REPLACEMENTS[value]) {
            rulePairs[index + 1] = VALUE_REPLACEMENTS[value];
        }
        else {
            switch (name_1) {
                case 'margin':
                case 'padding':
                    rulePairs[index + 1] = flipQuad(value);
                    break;
                case 'box-shadow':
                    rulePairs[index + 1] = negateNum(value, 0);
                    break;
            }
        }
    }
}
/**
 * Given a string value in a space delimited format (e.g. "1 2 3 4"), negates a particular value.
 */
function negateNum(value, partIndex) {
    var parts = value.split(' ');
    var numberVal = parseInt(parts[partIndex], 10);
    parts[0] = parts[0].replace(String(numberVal), String(numberVal * -1));
    return parts.join(' ');
}
/**
 * Given a string quad, flips the left and right values.
 */
function flipQuad(value) {
    if (typeof value === 'string') {
        var parts = value.split(' ');
        if (parts.length === 4) {
            return parts[0] + " " + parts[3] + " " + parts[2] + " " + parts[1];
        }
    }
    return value;
}
var _a;
//# sourceMappingURL=rtlifyRules.js.map

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = extractStyleParts;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stylesheet__ = __webpack_require__(146);

/**
 * Separates the classes and style objects. Any classes that are pre-registered
 * args are auto expanded into objects.
 */
function extractStyleParts() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var classes = [];
    var objects = [];
    var stylesheet = __WEBPACK_IMPORTED_MODULE_0__Stylesheet__["a" /* Stylesheet */].getInstance();
    function _processArgs(argsList) {
        for (var _i = 0, argsList_1 = argsList; _i < argsList_1.length; _i++) {
            var arg = argsList_1[_i];
            if (arg) {
                if (typeof arg === 'string') {
                    if (arg.indexOf(' ') >= 0) {
                        _processArgs(arg.split(' '));
                    }
                    else {
                        var translatedArgs = stylesheet.argsFromClassName(arg);
                        if (translatedArgs) {
                            _processArgs(translatedArgs);
                        }
                        else {
                            // Avoid adding the same class twice.
                            if (classes.indexOf(arg) === -1) {
                                classes.push(arg);
                            }
                        }
                    }
                }
                else if (Array.isArray(arg)) {
                    _processArgs(arg);
                }
                else if (typeof arg === 'object') {
                    objects.push(arg);
                }
            }
        }
    }
    _processArgs(args);
    return {
        classes: classes,
        objects: objects
    };
}
//# sourceMappingURL=extractStyleParts.js.map

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = concatStyleSets;
/**
 * Combine a set of styles together (but does not register css classes).
 * @param styleSets - One or more stylesets to be merged (each param can also be falsy).
 */
function concatStyleSets() {
    var styleSets = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        styleSets[_i] = arguments[_i];
    }
    if (styleSets && styleSets.length === 1 && styleSets[0] && !styleSets[0].subComponentStyles) {
        return styleSets[0];
    }
    var mergedSet = {};
    // We process sub component styles in two phases. First we collect them, then we combine them into 1 style function.
    var workingSubcomponentStyles = {};
    for (var _a = 0, styleSets_1 = styleSets; _a < styleSets_1.length; _a++) {
        var currentSet = styleSets_1[_a];
        if (currentSet) {
            for (var prop in currentSet) {
                if (currentSet.hasOwnProperty(prop)) {
                    if (prop === 'subComponentStyles' && currentSet.subComponentStyles !== undefined) {
                        // subcomponent styles - style functions or objects
                        var currentComponentStyles = currentSet.subComponentStyles;
                        for (var subCompProp in currentComponentStyles) {
                            if (currentComponentStyles.hasOwnProperty(subCompProp)) {
                                if (workingSubcomponentStyles.hasOwnProperty(subCompProp)) {
                                    workingSubcomponentStyles[subCompProp].push(currentComponentStyles[subCompProp]);
                                }
                                else {
                                    workingSubcomponentStyles[subCompProp] = [currentComponentStyles[subCompProp]];
                                }
                            }
                        }
                        continue;
                    }
                    // the as any casts below is a workaround for ts 2.8.
                    // todo: remove cast to any in ts 2.9.
                    var mergedValue = mergedSet[prop];
                    var currentValue = currentSet[prop];
                    if (mergedValue === undefined) {
                        mergedSet[prop] = currentValue;
                    }
                    else {
                        mergedSet[prop] = (Array.isArray(mergedValue) ? mergedValue : [mergedValue]).concat((Array.isArray(currentValue) ? currentValue : [currentValue]));
                    }
                }
            }
        }
    }
    if (Object.keys(workingSubcomponentStyles).length > 0) {
        mergedSet.subComponentStyles = {};
        var mergedSubStyles = mergedSet.subComponentStyles;
        var _loop_1 = function (subCompProp) {
            if (workingSubcomponentStyles.hasOwnProperty(subCompProp)) {
                var workingSet_1 = workingSubcomponentStyles[subCompProp];
                mergedSubStyles[subCompProp] = function (styleProps) {
                    return concatStyleSets.apply(void 0, workingSet_1.map(function (styleFunctionOrObject) {
                        return typeof styleFunctionOrObject === 'function' ? styleFunctionOrObject(styleProps) : styleFunctionOrObject;
                    }));
                };
            }
        };
        // now we process the subcomponent styles if there are any
        for (var subCompProp in workingSubcomponentStyles) {
            _loop_1(subCompProp);
        }
    }
    return mergedSet;
}
//# sourceMappingURL=concatStyleSets.js.map

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = registerIcons;
/* unused harmony export unregisterIcons */
/* harmony export (immutable) */ __webpack_exports__["b"] = registerIconAlias;
/* harmony export (immutable) */ __webpack_exports__["a"] = getIcon;
/* unused harmony export setIconOptions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__uifabric_merge_styles__ = __webpack_require__(46);



var ICON_SETTING_NAME = 'icons';
var _iconSettings = __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["i" /* GlobalSettings */].getValue(ICON_SETTING_NAME, {
    __options: {
        disableWarnings: false,
        warnOnMissingIcons: true
    },
    __remapped: {}
});
// Reset icon registration on stylesheet resets.
var stylesheet = __WEBPACK_IMPORTED_MODULE_2__uifabric_merge_styles__["a" /* Stylesheet */].getInstance();
if (stylesheet && stylesheet.onReset) {
    stylesheet.onReset(function () {
        for (var name_1 in _iconSettings) {
            if (_iconSettings.hasOwnProperty(name_1) && !!_iconSettings[name_1].subset) {
                _iconSettings[name_1].subset.className = undefined;
            }
        }
    });
}
/**
 * Normalizes an icon name for consistent mapping.
 * Current implementation is to convert the icon name to lower case.
 *
 * @param name - Icon name to normalize.
 * @returns {string} Normalized icon name to use for indexing and mapping.
 */
var normalizeIconName = function (name) { return name.toLowerCase(); };
/**
 * Registers a given subset of icons.
 *
 * @param iconSubset - the icon subset definition.
 */
function registerIcons(iconSubset, options) {
    var subset = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, iconSubset, { isRegistered: false, className: undefined });
    var icons = iconSubset.icons;
    // Grab options, optionally mix user provided ones on top.
    options = options ? __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, _iconSettings.__options, options) : _iconSettings.__options;
    for (var iconName in icons) {
        if (icons.hasOwnProperty(iconName)) {
            var code = icons[iconName];
            var normalizedIconName = normalizeIconName(iconName);
            if (_iconSettings[normalizedIconName]) {
                _warnDuplicateIcon(iconName);
            }
            else {
                _iconSettings[normalizedIconName] = {
                    code: code,
                    subset: subset
                };
            }
        }
    }
}
/**
 * Unregisters icons by name.
 *
 * @param iconNames - List of icons to unregister.
 */
function unregisterIcons(iconNames) {
    var options = _iconSettings.__options;
    var _loop_1 = function (iconName) {
        var normalizedIconName = normalizeIconName(iconName);
        if (_iconSettings[normalizedIconName]) {
            delete _iconSettings[normalizedIconName];
        }
        else {
            // Warn that we are trying to delete an icon that doesn't exist
            if (!options.disableWarnings) {
                Object(__WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_44" /* warn */])("The icon \"" + iconName + "\" tried to unregister but was not registered.");
            }
        }
        // Delete any aliases for this iconName
        if (_iconSettings.__remapped[normalizedIconName]) {
            delete _iconSettings.__remapped[normalizedIconName];
        }
        // Delete any items that were an alias for this iconName
        Object.keys(_iconSettings.__remapped).forEach(function (key) {
            if (_iconSettings.__remapped[key] === normalizedIconName) {
                delete _iconSettings.__remapped[key];
            }
        });
    };
    for (var _i = 0, iconNames_1 = iconNames; _i < iconNames_1.length; _i++) {
        var iconName = iconNames_1[_i];
        _loop_1(iconName);
    }
}
/**
 * Remaps one icon name to another.
 */
function registerIconAlias(iconName, mappedToName) {
    _iconSettings.__remapped[normalizeIconName(iconName)] = normalizeIconName(mappedToName);
}
/**
 * Gets an icon definition. If an icon is requested but the subset has yet to be registered,
 * it will get registered immediately.
 *
 * @public
 * @param name - Name of icon.
 */
function getIcon(name) {
    var icon = undefined;
    var options = _iconSettings.__options;
    name = name ? normalizeIconName(name) : '';
    name = _iconSettings.__remapped[name] || name;
    if (name) {
        icon = _iconSettings[name];
        if (icon) {
            var subset = icon.subset;
            if (subset && subset.fontFace) {
                if (!subset.isRegistered) {
                    Object(__WEBPACK_IMPORTED_MODULE_2__uifabric_merge_styles__["c" /* fontFace */])(subset.fontFace);
                    subset.isRegistered = true;
                }
                if (!subset.className) {
                    subset.className = Object(__WEBPACK_IMPORTED_MODULE_2__uifabric_merge_styles__["f" /* mergeStyles */])(subset.style, {
                        fontFamily: subset.fontFace.fontFamily,
                        fontWeight: subset.fontFace.fontWeight || 'normal',
                        fontStyle: subset.fontFace.fontStyle || 'normal'
                    });
                }
            }
        }
        else {
            if (!options.disableWarnings && options.warnOnMissingIcons) {
                Object(__WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_44" /* warn */])("The icon \"" + name + "\" was used but not registered. See http://aka.ms/fabric-icon-usage for more information.");
            }
        }
    }
    return icon;
}
/**
 * Sets the icon options.
 *
 * @public
 */
function setIconOptions(options) {
    _iconSettings.__options = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, _iconSettings.__options, options);
}
var _missingIcons = [];
var _missingIconsTimer = undefined;
function _warnDuplicateIcon(iconName) {
    var options = _iconSettings.__options;
    var warningDelay = 2000;
    var maxIconsInMessage = 10;
    if (!options.disableWarnings) {
        _missingIcons.push(iconName);
        if (_missingIconsTimer === undefined) {
            _missingIconsTimer = setTimeout(function () {
                Object(__WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_44" /* warn */])("Some icons were re-registered. Applications should only call registerIcons for any given " +
                    "icon once. Redefining what an icon is may have unintended consequences. Duplicates " +
                    "include: \n" +
                    _missingIcons.slice(0, maxIconsInMessage).join(', ') +
                    (_missingIcons.length > maxIconsInMessage ? " (+ " + (_missingIcons.length - maxIconsInMessage) + " more)" : ''));
                _missingIconsTimer = undefined;
                _missingIcons = [];
            }, warningDelay);
        }
    }
}
//# sourceMappingURL=icons.js.map

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Async; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_getWindow__ = __webpack_require__(86);

/**
 * Bugs often appear in async code when stuff gets disposed, but async operations don't get canceled.
 * This Async helper class solves these issues by tying async code to the lifetime of a disposable object.
 *
 * Usage: Anything class extending from BaseModel can access this helper via this.async. Otherwise create a
 * new instance of the class and remember to call dispose() during your code's dispose handler.
 *
 * @public
 */
var Async = /** @class */ (function () {
    // tslint:disable-next-line:no-any
    function Async(parent, onError) {
        this._timeoutIds = null;
        this._immediateIds = null;
        this._intervalIds = null;
        this._animationFrameIds = null;
        this._isDisposed = false;
        this._parent = parent || null;
        this._onErrorHandler = onError;
        this._noop = function () {
            /* do nothing */
        };
    }
    /**
     * Dispose function, clears all async operations.
     */
    Async.prototype.dispose = function () {
        var id;
        this._isDisposed = true;
        this._parent = null;
        // Clear timeouts.
        if (this._timeoutIds) {
            for (id in this._timeoutIds) {
                if (this._timeoutIds.hasOwnProperty(id)) {
                    this.clearTimeout(parseInt(id, 10));
                }
            }
            this._timeoutIds = null;
        }
        // Clear immediates.
        if (this._immediateIds) {
            for (id in this._immediateIds) {
                if (this._immediateIds.hasOwnProperty(id)) {
                    this.clearImmediate(parseInt(id, 10));
                }
            }
            this._immediateIds = null;
        }
        // Clear intervals.
        if (this._intervalIds) {
            for (id in this._intervalIds) {
                if (this._intervalIds.hasOwnProperty(id)) {
                    this.clearInterval(parseInt(id, 10));
                }
            }
            this._intervalIds = null;
        }
        // Clear animation frames.
        if (this._animationFrameIds) {
            for (id in this._animationFrameIds) {
                if (this._animationFrameIds.hasOwnProperty(id)) {
                    this.cancelAnimationFrame(parseInt(id, 10));
                }
            }
            this._animationFrameIds = null;
        }
    };
    /**
     * SetTimeout override, which will auto cancel the timeout during dispose.
     * @param callback - Callback to execute.
     * @param duration - Duration in milliseconds.
     * @returns The setTimeout id.
     */
    Async.prototype.setTimeout = function (callback, duration) {
        var _this = this;
        var timeoutId = 0;
        if (!this._isDisposed) {
            if (!this._timeoutIds) {
                this._timeoutIds = {};
            }
            /* tslint:disable:ban-native-functions */
            timeoutId = setTimeout(function () {
                // Time to execute the timeout, enqueue it as a foreground task to be executed.
                try {
                    // Now delete the record and call the callback.
                    if (_this._timeoutIds) {
                        delete _this._timeoutIds[timeoutId];
                    }
                    callback.apply(_this._parent);
                }
                catch (e) {
                    if (_this._onErrorHandler) {
                        _this._onErrorHandler(e);
                    }
                }
            }, duration);
            /* tslint:enable:ban-native-functions */
            this._timeoutIds[timeoutId] = true;
        }
        return timeoutId;
    };
    /**
     * Clears the timeout.
     * @param id - Id to cancel.
     */
    Async.prototype.clearTimeout = function (id) {
        if (this._timeoutIds && this._timeoutIds[id]) {
            /* tslint:disable:ban-native-functions */
            clearTimeout(id);
            delete this._timeoutIds[id];
            /* tslint:enable:ban-native-functions */
        }
    };
    /**
     * SetImmediate override, which will auto cancel the immediate during dispose.
     * @param callback - Callback to execute.
     * @param targetElement - Optional target element to use for identifying the correct window.
     * @returns The setTimeout id.
     */
    Async.prototype.setImmediate = function (callback, targetElement) {
        var _this = this;
        var immediateId = 0;
        var win = Object(__WEBPACK_IMPORTED_MODULE_0__dom_getWindow__["a" /* getWindow */])(targetElement);
        if (!this._isDisposed) {
            if (!this._immediateIds) {
                this._immediateIds = {};
            }
            /* tslint:disable:ban-native-functions */
            var setImmediateCallback = function () {
                // Time to execute the timeout, enqueue it as a foreground task to be executed.
                try {
                    // Now delete the record and call the callback.
                    if (_this._immediateIds) {
                        delete _this._immediateIds[immediateId];
                    }
                    callback.apply(_this._parent);
                }
                catch (e) {
                    _this._logError(e);
                }
            };
            immediateId = win.setTimeout(setImmediateCallback, 0);
            /* tslint:enable:ban-native-functions */
            this._immediateIds[immediateId] = true;
        }
        return immediateId;
    };
    /**
     * Clears the immediate.
     * @param id - Id to cancel.
     * @param targetElement - Optional target element to use for identifying the correct window.
     */
    Async.prototype.clearImmediate = function (id, targetElement) {
        var win = Object(__WEBPACK_IMPORTED_MODULE_0__dom_getWindow__["a" /* getWindow */])(targetElement);
        if (this._immediateIds && this._immediateIds[id]) {
            /* tslint:disable:ban-native-functions */
            win.clearTimeout(id);
            delete this._immediateIds[id];
            /* tslint:enable:ban-native-functions */
        }
    };
    /**
     * SetInterval override, which will auto cancel the timeout during dispose.
     * @param callback - Callback to execute.
     * @param duration - Duration in milliseconds.
     * @returns The setTimeout id.
     */
    Async.prototype.setInterval = function (callback, duration) {
        var _this = this;
        var intervalId = 0;
        if (!this._isDisposed) {
            if (!this._intervalIds) {
                this._intervalIds = {};
            }
            /* tslint:disable:ban-native-functions */
            intervalId = setInterval(function () {
                // Time to execute the interval callback, enqueue it as a foreground task to be executed.
                try {
                    callback.apply(_this._parent);
                }
                catch (e) {
                    _this._logError(e);
                }
            }, duration);
            /* tslint:enable:ban-native-functions */
            this._intervalIds[intervalId] = true;
        }
        return intervalId;
    };
    /**
     * Clears the interval.
     * @param id - Id to cancel.
     */
    Async.prototype.clearInterval = function (id) {
        if (this._intervalIds && this._intervalIds[id]) {
            /* tslint:disable:ban-native-functions */
            clearInterval(id);
            delete this._intervalIds[id];
            /* tslint:enable:ban-native-functions */
        }
    };
    /**
     * Creates a function that, when executed, will only call the func function at most once per
     * every wait milliseconds. Provide an options object to indicate that func should be invoked
     * on the leading and/or trailing edge of the wait timeout. Subsequent calls to the throttled
     * function will return the result of the last func call.
     *
     * Note: If leading and trailing options are true func will be called on the trailing edge of
     * the timeout only if the the throttled function is invoked more than once during the wait timeout.
     *
     * @param func - The function to throttle.
     * @param wait - The number of milliseconds to throttle executions to. Defaults to 0.
     * @param options - The options object.
     * @returns The new throttled function.
     */
    Async.prototype.throttle = function (func, wait, options) {
        var _this = this;
        if (this._isDisposed) {
            return this._noop;
        }
        var waitMS = wait || 0;
        var leading = true;
        var trailing = true;
        var lastExecuteTime = 0;
        var lastResult;
        // tslint:disable-next-line:no-any
        var lastArgs;
        var timeoutId = null;
        if (options && typeof options.leading === 'boolean') {
            leading = options.leading;
        }
        if (options && typeof options.trailing === 'boolean') {
            trailing = options.trailing;
        }
        var callback = function (userCall) {
            var now = new Date().getTime();
            var delta = now - lastExecuteTime;
            var waitLength = leading ? waitMS - delta : waitMS;
            if (delta >= waitMS && (!userCall || leading)) {
                lastExecuteTime = now;
                if (timeoutId) {
                    _this.clearTimeout(timeoutId);
                    timeoutId = null;
                }
                lastResult = func.apply(_this._parent, lastArgs);
            }
            else if (timeoutId === null && trailing) {
                timeoutId = _this.setTimeout(callback, waitLength);
            }
            return lastResult;
        };
        // tslint:disable-next-line:no-any
        var resultFunction = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            lastArgs = args;
            return callback(true);
        };
        return resultFunction;
    };
    /**
     * Creates a function that will delay the execution of func until after wait milliseconds have
     * elapsed since the last time it was invoked. Provide an options object to indicate that func
     * should be invoked on the leading and/or trailing edge of the wait timeout. Subsequent calls
     * to the debounced function will return the result of the last func call.
     *
     * Note: If leading and trailing options are true func will be called on the trailing edge of
     * the timeout only if the the debounced function is invoked more than once during the wait
     * timeout.
     *
     * @param func - The function to debounce.
     * @param wait - The number of milliseconds to delay.
     * @param options - The options object.
     * @returns The new debounced function.
     */
    Async.prototype.debounce = function (func, wait, options) {
        var _this = this;
        if (this._isDisposed) {
            var noOpFunction = (function () {
                /** Do nothing */
            });
            noOpFunction.cancel = function () {
                return;
            };
            /* tslint:disable:no-any */
            noOpFunction.flush = (function () { return null; });
            /* tslint:enable:no-any */
            noOpFunction.pending = function () { return false; };
            return noOpFunction;
        }
        var waitMS = wait || 0;
        var leading = false;
        var trailing = true;
        var maxWait = null;
        var lastCallTime = 0;
        var lastExecuteTime = new Date().getTime();
        var lastResult;
        // tslint:disable-next-line:no-any
        var lastArgs;
        var timeoutId = null;
        if (options && typeof options.leading === 'boolean') {
            leading = options.leading;
        }
        if (options && typeof options.trailing === 'boolean') {
            trailing = options.trailing;
        }
        if (options && typeof options.maxWait === 'number' && !isNaN(options.maxWait)) {
            maxWait = options.maxWait;
        }
        var markExecuted = function (time) {
            if (timeoutId) {
                _this.clearTimeout(timeoutId);
                timeoutId = null;
            }
            lastExecuteTime = time;
        };
        var invokeFunction = function (time) {
            markExecuted(time);
            lastResult = func.apply(_this._parent, lastArgs);
        };
        var callback = function (userCall) {
            var now = new Date().getTime();
            var executeImmediately = false;
            if (userCall) {
                if (leading && now - lastCallTime >= waitMS) {
                    executeImmediately = true;
                }
                lastCallTime = now;
            }
            var delta = now - lastCallTime;
            var waitLength = waitMS - delta;
            var maxWaitDelta = now - lastExecuteTime;
            var maxWaitExpired = false;
            if (maxWait !== null) {
                // maxWait only matters when there is a pending callback
                if (maxWaitDelta >= maxWait && timeoutId) {
                    maxWaitExpired = true;
                }
                else {
                    waitLength = Math.min(waitLength, maxWait - maxWaitDelta);
                }
            }
            if (delta >= waitMS || maxWaitExpired || executeImmediately) {
                invokeFunction(now);
            }
            else if ((timeoutId === null || !userCall) && trailing) {
                timeoutId = _this.setTimeout(callback, waitLength);
            }
            return lastResult;
        };
        var pending = function () {
            return !!timeoutId;
        };
        var cancel = function () {
            if (pending()) {
                // Mark the debounced function as having executed
                markExecuted(new Date().getTime());
            }
        };
        var flush = function () {
            if (pending()) {
                invokeFunction(new Date().getTime());
            }
            return lastResult;
        };
        // tslint:disable-next-line:no-any
        var resultFunction = (function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            lastArgs = args;
            return callback(true);
        });
        resultFunction.cancel = cancel;
        resultFunction.flush = flush;
        resultFunction.pending = pending;
        return resultFunction;
    };
    Async.prototype.requestAnimationFrame = function (callback, targetElement) {
        var _this = this;
        var animationFrameId = 0;
        var win = Object(__WEBPACK_IMPORTED_MODULE_0__dom_getWindow__["a" /* getWindow */])(targetElement);
        if (!this._isDisposed) {
            if (!this._animationFrameIds) {
                this._animationFrameIds = {};
            }
            /* tslint:disable:ban-native-functions */
            var animationFrameCallback = function () {
                try {
                    // Now delete the record and call the callback.
                    if (_this._animationFrameIds) {
                        delete _this._animationFrameIds[animationFrameId];
                    }
                    callback.apply(_this._parent);
                }
                catch (e) {
                    _this._logError(e);
                }
            };
            animationFrameId = win.requestAnimationFrame
                ? win.requestAnimationFrame(animationFrameCallback)
                : win.setTimeout(animationFrameCallback, 0);
            /* tslint:enable:ban-native-functions */
            this._animationFrameIds[animationFrameId] = true;
        }
        return animationFrameId;
    };
    Async.prototype.cancelAnimationFrame = function (id, targetElement) {
        var win = Object(__WEBPACK_IMPORTED_MODULE_0__dom_getWindow__["a" /* getWindow */])(targetElement);
        if (this._animationFrameIds && this._animationFrameIds[id]) {
            /* tslint:disable:ban-native-functions */
            win.cancelAnimationFrame ? win.cancelAnimationFrame(id) : win.clearTimeout(id);
            /* tslint:enable:ban-native-functions */
            delete this._animationFrameIds[id];
        }
    };
    // tslint:disable-next-line:no-any
    Async.prototype._logError = function (e) {
        if (this._onErrorHandler) {
            this._onErrorHandler(e);
        }
    };
    return Async;
}());

//# sourceMappingURL=Async.js.map

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DATA_IS_SCROLLABLE_ATTRIBUTE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return allowScrollOnElement; });
/* harmony export (immutable) */ __webpack_exports__["b"] = disableBodyScroll;
/* harmony export (immutable) */ __webpack_exports__["c"] = enableBodyScroll;
/* harmony export (immutable) */ __webpack_exports__["e"] = getScrollbarWidth;
/* harmony export (immutable) */ __webpack_exports__["d"] = findScrollableParent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_getDocument__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__uifabric_merge_styles__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dom_getWindow__ = __webpack_require__(86);



var _scrollbarWidth;
var _bodyScrollDisabledCount = 0;
var DisabledScrollClassName = Object(__WEBPACK_IMPORTED_MODULE_1__uifabric_merge_styles__["f" /* mergeStyles */])({
    overflow: 'hidden !important'
});
/**
 * Placing this attribute on scrollable divs optimizes detection to know
 * if the div is scrollable or not (given we can avoid expensive operations
 * like getComputedStyle.)
 *
 * @public
 */
var DATA_IS_SCROLLABLE_ATTRIBUTE = 'data-is-scrollable';
/**
 * Allows the user to scroll within a element,
 * while preventing the user from scrolling the body
 */
var allowScrollOnElement = function (element, events) {
    if (!element) {
        return;
    }
    var _previousClientY = 0;
    var _element = null;
    // remember the clientY for future calls of _preventOverscrolling
    var _saveClientY = function (event) {
        if (event.targetTouches.length === 1) {
            _previousClientY = event.targetTouches[0].clientY;
        }
    };
    // prevent the body from scrolling when the user attempts
    // to scroll past the top or bottom of the element
    var _preventOverscrolling = function (event) {
        // only respond to a single-finger touch
        if (event.targetTouches.length !== 1) {
            return;
        }
        // prevent the body touchmove handler from firing
        // so that scrolling is allowed within the element
        event.stopPropagation();
        if (!_element) {
            return;
        }
        var clientY = event.targetTouches[0].clientY - _previousClientY;
        var scrollableParent = findScrollableParent(event.target);
        if (scrollableParent) {
            _element = scrollableParent;
        }
        // if the element is scrolled to the top,
        // prevent the user from scrolling up
        if (_element.scrollTop === 0 && clientY > 0) {
            event.preventDefault();
        }
        // if the element is scrolled to the bottom,
        // prevent the user from scrolling down
        if (_element.scrollHeight - _element.scrollTop <= _element.clientHeight && clientY < 0) {
            event.preventDefault();
        }
    };
    events.on(element, 'touchstart', _saveClientY, { passive: false });
    events.on(element, 'touchmove', _preventOverscrolling, { passive: false });
    _element = element;
};
var _disableIosBodyScroll = function (event) {
    event.preventDefault();
};
/**
 * Disables the body scrolling.
 *
 * @public
 */
function disableBodyScroll() {
    var doc = Object(__WEBPACK_IMPORTED_MODULE_0__dom_getDocument__["a" /* getDocument */])();
    if (doc && doc.body && !_bodyScrollDisabledCount) {
        doc.body.classList.add(DisabledScrollClassName);
        doc.body.addEventListener('touchmove', _disableIosBodyScroll, { passive: false, capture: false });
    }
    _bodyScrollDisabledCount++;
}
/**
 * Enables the body scrolling.
 *
 * @public
 */
function enableBodyScroll() {
    if (_bodyScrollDisabledCount > 0) {
        var doc = Object(__WEBPACK_IMPORTED_MODULE_0__dom_getDocument__["a" /* getDocument */])();
        if (doc && doc.body && _bodyScrollDisabledCount === 1) {
            doc.body.classList.remove(DisabledScrollClassName);
            doc.body.removeEventListener('touchmove', _disableIosBodyScroll);
        }
        _bodyScrollDisabledCount--;
    }
}
/**
 * Calculates the width of a scrollbar for the browser/os.
 *
 * @public
 */
function getScrollbarWidth() {
    if (_scrollbarWidth === undefined) {
        var scrollDiv = document.createElement('div');
        scrollDiv.style.setProperty('width', '100px');
        scrollDiv.style.setProperty('height', '100px');
        scrollDiv.style.setProperty('overflow', 'scroll');
        scrollDiv.style.setProperty('position', 'absolute');
        scrollDiv.style.setProperty('top', '-9999px');
        document.body.appendChild(scrollDiv);
        // Get the scrollbar width
        _scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
        // Delete the DIV
        document.body.removeChild(scrollDiv);
    }
    return _scrollbarWidth;
}
/**
 * Traverses up the DOM for the element with the data-is-scrollable=true attribute, or returns
 * document.body.
 *
 * @public
 */
function findScrollableParent(startingElement) {
    var el = startingElement;
    var doc = Object(__WEBPACK_IMPORTED_MODULE_0__dom_getDocument__["a" /* getDocument */])(startingElement);
    // First do a quick scan for the scrollable attribute.
    while (el && el !== doc.body) {
        if (el.getAttribute(DATA_IS_SCROLLABLE_ATTRIBUTE) === 'true') {
            return el;
        }
        el = el.parentElement;
    }
    // If we haven't found it, the use the slower method: compute styles to evaluate if overflow is set.
    el = startingElement;
    while (el && el !== doc.body) {
        if (el.getAttribute(DATA_IS_SCROLLABLE_ATTRIBUTE) !== 'false') {
            var computedStyles = getComputedStyle(el);
            var overflowY = computedStyles ? computedStyles.getPropertyValue('overflow-y') : '';
            if (overflowY && (overflowY === 'scroll' || overflowY === 'auto')) {
                return el;
            }
        }
        el = el.parentElement;
    }
    // Fall back to window scroll.
    if (!el || el === doc.body) {
        // tslint:disable-next-line:no-any
        el = Object(__WEBPACK_IMPORTED_MODULE_2__dom_getWindow__["a" /* getWindow */])(startingElement);
    }
    return el;
}
//# sourceMappingURL=scroll.js.map

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getRect;
/**
 * Helper to get bounding client rect. Passing in window will get the window size.
 *
 * @public
 */
function getRect(element) {
    var rect;
    if (element) {
        if (element === window) {
            rect = {
                left: 0,
                top: 0,
                width: window.innerWidth,
                height: window.innerHeight,
                right: window.innerWidth,
                bottom: window.innerHeight
            };
        }
        else if (element.getBoundingClientRect) {
            rect = element.getBoundingClientRect();
        }
    }
    return rect;
}
//# sourceMappingURL=getRect.js.map

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warnConditionallyRequiredProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__warn__ = __webpack_require__(259);

/**
 * Warns when props are required if a condition is met.
 *
 * @public
 * @param componentName - The name of the component being used.
 * @param props - The props passed into the component.
 * @param requiredProps - The name of the props that are required when the condition is met.
 * @param conditionalPropName - The name of the prop that the condition is based on.
 * @param condition - Whether the condition is met.
 */
function warnConditionallyRequiredProps(componentName, props, requiredProps, conditionalPropName, condition) {
    if (condition === true && "production" !== 'production') {
        for (var _i = 0, requiredProps_1 = requiredProps; _i < requiredProps_1.length; _i++) {
            var requiredPropName = requiredProps_1[_i];
            if (!(requiredPropName in props)) {
                Object(__WEBPACK_IMPORTED_MODULE_0__warn__["a" /* warn */])(componentName + " property '" + requiredPropName + "' is required when '" + conditionalPropName + "' is used.'");
            }
        }
    }
}
//# sourceMappingURL=warnConditionallyRequiredProps.js.map

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warnMutuallyExclusive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__warn__ = __webpack_require__(259);

/**
 * Warns when two props which are mutually exclusive are both being used.
 *
 * @public
 * @param componentName - The name of the component being used.
 * @param props - The props passed into the component.
 * @param exclusiveMap - A map where the key is a parameter, and the value is the other parameter.
 */
function warnMutuallyExclusive(componentName, props, exclusiveMap) {
    if (false) {
        for (var propName in exclusiveMap) {
            if (props && props[propName] !== undefined) {
                var propInExclusiveMapValue = exclusiveMap[propName];
                if (propInExclusiveMapValue && props[propInExclusiveMapValue] !== undefined) {
                    warn(componentName + " property '" + propName + "' is mutually exclusive with '" + exclusiveMap[propName] + "'. Use one or the other.");
                }
            }
        }
    }
}
//# sourceMappingURL=warnMutuallyExclusive.js.map

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warnDeprecations;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__warn__ = __webpack_require__(259);

/**
 * Warns when a deprecated props are being used.
 *
 * @public
 * @param componentName - The name of the component being used.
 * @param props - The props passed into the component.
 * @param deprecationMap - The map of deprecations, where key is the prop name and the value is
 * either null or a replacement prop name.
 */
function warnDeprecations(componentName, props, deprecationMap) {
    if (false) {
        for (var propName in deprecationMap) {
            if (props && propName in props) {
                var deprecationMessage = componentName + " property '" + propName + "' was used but has been deprecated.";
                var replacementPropName = deprecationMap[propName];
                if (replacementPropName) {
                    deprecationMessage += " Use '" + replacementPropName + "' instead.";
                }
                warn(deprecationMessage);
            }
        }
    }
}
//# sourceMappingURL=warnDeprecations.js.map

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IsFocusVisibleClassName; });
/* harmony export (immutable) */ __webpack_exports__["b"] = initializeFocusRects;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_getWindow__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keyboard__ = __webpack_require__(642);


var IsFocusVisibleClassName = 'ms-Fabric--isFocusVisible';
/**
 * Initializes the logic which:
 *
 * 1. Subscribes keydown and mousedown events. (It will only do it once per window,
 *    so it's safe to call this method multiple times.)
 * 2. When the user presses directional keyboard keys, adds the 'ms-Fabric--isFocusVisible' classname
 *    to the document body.
 * 3. When the user clicks a mouse button, we remove the classname if it exists.
 *
 * This logic allows components on the page to conditionally render focus treatments only
 * if the global classname exists, which simplifies logic overall.
 *
 * @param window - the window used to add the event listeners
 */
function initializeFocusRects(window) {
    var win = (window || Object(__WEBPACK_IMPORTED_MODULE_0__dom_getWindow__["a" /* getWindow */])());
    if (win && !win.__hasInitializeFocusRects__) {
        win.__hasInitializeFocusRects__ = true;
        win.addEventListener('mousedown', _onMouseDown, true);
        win.addEventListener('keydown', _onKeyDown, true);
    }
}
function _onMouseDown(ev) {
    var win = Object(__WEBPACK_IMPORTED_MODULE_0__dom_getWindow__["a" /* getWindow */])(ev.target);
    if (win) {
        var classList = win.document.body.classList;
        if (classList.contains(IsFocusVisibleClassName)) {
            classList.remove(IsFocusVisibleClassName);
        }
    }
}
function _onKeyDown(ev) {
    var win = Object(__WEBPACK_IMPORTED_MODULE_0__dom_getWindow__["a" /* getWindow */])(ev.target);
    if (win) {
        var classList = win.document.body.classList;
        if (Object(__WEBPACK_IMPORTED_MODULE_1__keyboard__["a" /* isDirectionalKeyCode */])(ev.which) && !classList.contains(IsFocusVisibleClassName)) {
            classList.add(IsFocusVisibleClassName);
        }
    }
}
//# sourceMappingURL=initializeFocusRects.js.map

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isDirectionalKeyCode;
/* unused harmony export addDirectionalKeyCode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__KeyCodes__ = __webpack_require__(384);

var DirectionalKeyCodes = (_a = {},
    _a[__WEBPACK_IMPORTED_MODULE_0__KeyCodes__["a" /* KeyCodes */].up] = 1,
    _a[__WEBPACK_IMPORTED_MODULE_0__KeyCodes__["a" /* KeyCodes */].down] = 1,
    _a[__WEBPACK_IMPORTED_MODULE_0__KeyCodes__["a" /* KeyCodes */].left] = 1,
    _a[__WEBPACK_IMPORTED_MODULE_0__KeyCodes__["a" /* KeyCodes */].right] = 1,
    _a[__WEBPACK_IMPORTED_MODULE_0__KeyCodes__["a" /* KeyCodes */].home] = 1,
    _a[__WEBPACK_IMPORTED_MODULE_0__KeyCodes__["a" /* KeyCodes */].end] = 1,
    _a[__WEBPACK_IMPORTED_MODULE_0__KeyCodes__["a" /* KeyCodes */].tab] = 1,
    _a[__WEBPACK_IMPORTED_MODULE_0__KeyCodes__["a" /* KeyCodes */].pageUp] = 1,
    _a[__WEBPACK_IMPORTED_MODULE_0__KeyCodes__["a" /* KeyCodes */].pageDown] = 1,
    _a);
/**
 * Returns true if the keycode is a directional keyboard key.
 */
function isDirectionalKeyCode(which) {
    return !!DirectionalKeyCodes[which];
}
/**
 * Adds a keycode to the list of keys that, when pressed, should cause the focus outlines to be visible.
 * This can be used to add global shortcut keys that directionally move from section to section within
 * an app or between focus trap zones.
 */
function addDirectionalKeyCode(which) {
    DirectionalKeyCodes[which] = 1;
}
var _a;
//# sourceMappingURL=keyboard.js.map

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GlobalSettings; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_getWindow__ = __webpack_require__(86);

/**
 * Storing global state in local module variables has issues when more than one copy
 * if the module gets loaded on the page (due to a bundling error or simply by consuming
 * a prebundled script.)
 *
 * This file contains helpers to deal with the getting and setting local state, and allows
 * callers to get called back when it mutates.
 */
// tslint:disable:no-any
var GLOBAL_SETTINGS_PROP_NAME = '__globalSettings__';
var CALLBACK_STATE_PROP_NAME = '__callbacks__';
var _counter = 0;
/**
 * Global settings helper, which stores settings in the global (window) namespace.
 * If window is not provided, it will store settings in module scope. Provides a
 * way to observe changes as well when their values change.
 *
 * @public
 * {@docCategory GlobalSettings}
 */
var GlobalSettings = /** @class */ (function () {
    function GlobalSettings() {
    }
    GlobalSettings.getValue = function (key, defaultValue) {
        var globalSettings = _getGlobalSettings();
        if (globalSettings[key] === undefined) {
            globalSettings[key] = typeof defaultValue === 'function' ? defaultValue() : defaultValue;
        }
        return globalSettings[key];
    };
    GlobalSettings.setValue = function (key, value) {
        var globalSettings = _getGlobalSettings();
        var callbacks = globalSettings[CALLBACK_STATE_PROP_NAME];
        var oldValue = globalSettings[key];
        if (value !== oldValue) {
            globalSettings[key] = value;
            var changeDescription = {
                oldValue: oldValue,
                value: value,
                key: key
            };
            for (var id in callbacks) {
                if (callbacks.hasOwnProperty(id)) {
                    callbacks[id](changeDescription);
                }
            }
        }
        return value;
    };
    GlobalSettings.addChangeListener = function (cb) {
        // Note: we use generated ids on the callbacks to create a map of the callbacks, which optimizes removal.
        // (It's faster to delete a key than it is to look up the index of an object and splice an array.)
        var id = cb.__id__;
        var callbacks = _getCallbacks();
        if (!id) {
            id = cb.__id__ = String(_counter++);
        }
        callbacks[id] = cb;
    };
    GlobalSettings.removeChangeListener = function (cb) {
        var callbacks = _getCallbacks();
        delete callbacks[cb.__id__];
    };
    return GlobalSettings;
}());

function _getGlobalSettings() {
    var win = Object(__WEBPACK_IMPORTED_MODULE_0__dom_getWindow__["a" /* getWindow */])();
    var globalObj = win || {};
    if (!globalObj[GLOBAL_SETTINGS_PROP_NAME]) {
        globalObj[GLOBAL_SETTINGS_PROP_NAME] = (_a = {},
            _a[CALLBACK_STATE_PROP_NAME] = {},
            _a);
    }
    return globalObj[GLOBAL_SETTINGS_PROP_NAME];
    var _a;
}
function _getCallbacks() {
    var globalSettings = _getGlobalSettings();
    return globalSettings[CALLBACK_STATE_PROP_NAME];
}
//# sourceMappingURL=GlobalSettings.js.map

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = appendFunction;
// tslint:disable:no-any
/**
 * Returns a single function which will call each of the given functions in the context of the
 * parent.
 */
function appendFunction(parent) {
    var functions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        functions[_i - 1] = arguments[_i];
    }
    if (functions.length < 2) {
        return functions[0];
    }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        functions.forEach(function (f) { return f && f.apply(parent, args); });
    };
}
//# sourceMappingURL=appendFunction.js.map

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mergeCustomizations;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mergeSettings__ = __webpack_require__(646);

/**
 * Merge props and customizations giving priority to props over context.
 * NOTE: This function will always perform multiple merge operations. Use with caution.
 * @param props - New settings to merge in.
 * @param parentContext - Context containing current settings.
 * @returns Merged customizations.
 */
function mergeCustomizations(props, parentContext) {
    var _a = (parentContext || {}).customizations, customizations = _a === void 0 ? { settings: {}, scopedSettings: {} } : _a;
    return {
        customizations: {
            settings: Object(__WEBPACK_IMPORTED_MODULE_0__mergeSettings__["b" /* mergeSettings */])(customizations.settings, props.settings),
            scopedSettings: Object(__WEBPACK_IMPORTED_MODULE_0__mergeSettings__["a" /* mergeScopedSettings */])(customizations.scopedSettings, props.scopedSettings),
            inCustomizerContext: true
        }
    };
}
//# sourceMappingURL=mergeCustomizations.js.map

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = mergeSettings;
/* harmony export (immutable) */ __webpack_exports__["a"] = mergeScopedSettings;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);

/**
 * Merge new and old settings, giving priority to new settings.
 * New settings is optional in which case oldSettings is returned as-is.
 * @param oldSettings - Old settings to fall back to.
 * @param newSettings - New settings that will be merged over oldSettings.
 * @returns Merged settings.
 */
function mergeSettings(oldSettings, newSettings) {
    if (oldSettings === void 0) { oldSettings = {}; }
    var mergeSettingsWith = _isSettingsFunction(newSettings) ? newSettings : _settingsMergeWith(newSettings);
    return mergeSettingsWith(oldSettings);
}
function mergeScopedSettings(oldSettings, newSettings) {
    if (oldSettings === void 0) { oldSettings = {}; }
    var mergeSettingsWith = _isSettingsFunction(newSettings) ? newSettings : _scopedSettingsMergeWith(newSettings);
    return mergeSettingsWith(oldSettings);
}
function _isSettingsFunction(settings) {
    return typeof settings === 'function';
}
function _settingsMergeWith(newSettings) {
    return function (settings) { return (newSettings ? __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, settings, newSettings) : settings); };
}
function _scopedSettingsMergeWith(scopedSettingsFromProps) {
    if (scopedSettingsFromProps === void 0) { scopedSettingsFromProps = {}; }
    return function (oldScopedSettings) {
        var newScopedSettings = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, oldScopedSettings);
        for (var scopeName in scopedSettingsFromProps) {
            if (scopedSettingsFromProps.hasOwnProperty(scopeName)) {
                newScopedSettings[scopeName] = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, oldScopedSettings[scopeName], scopedSettingsFromProps[scopeName]);
            }
        }
        return newScopedSettings;
    };
}
//# sourceMappingURL=mergeSettings.js.map

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hoistStatics;
/**
 * Allows you to hoist static functions in components.
 * Created for the purpose of fixing broken static functions in classes
 * that utilize decorators.
 *
 * @public
 * @param source - The object where the methods are hoisted from.
 * @param dest - The object to hoist the methods onto.
 * @returns The dest object with methods added
 */
function hoistStatics(source, dest) {
    for (var name_1 in source) {
        if (source.hasOwnProperty(name_1)) {
            // tslint:disable-next-line:no-any
            dest[name_1] = source[name_1];
        }
    }
    return dest;
}
//# sourceMappingURL=hoistStatics.js.map

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = elementContains;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getParent__ = __webpack_require__(262);

/**
 * Determines whether or not a parent element contains a given child element.
 * If `allowVirtualParents` is true, this method may return `true` if the child
 * has the parent in its virtual element hierarchy.
 *
 * @public
 */
function elementContains(parent, child, allowVirtualParents) {
    if (allowVirtualParents === void 0) { allowVirtualParents = true; }
    var isContained = false;
    if (parent && child) {
        if (allowVirtualParents) {
            isContained = false;
            while (child) {
                var nextParent = Object(__WEBPACK_IMPORTED_MODULE_0__getParent__["a" /* getParent */])(child);
                if (nextParent === parent) {
                    isContained = true;
                    break;
                }
                child = nextParent;
            }
        }
        else if (parent.contains) {
            isContained = parent.contains(child);
        }
    }
    return isContained;
}
//# sourceMappingURL=elementContains.js.map

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getVirtualParent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isVirtualElement__ = __webpack_require__(385);

/**
 * Gets the virtual parent given the child element, if it exists.
 *
 * @public
 */
function getVirtualParent(child) {
    var parent;
    if (child && Object(__WEBPACK_IMPORTED_MODULE_0__isVirtualElement__["a" /* isVirtualElement */])(child)) {
        parent = child._virtual.parent;
    }
    return parent;
}
//# sourceMappingURL=getVirtualParent.js.map

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = elementContainsAttribute;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__findElementRecursive__ = __webpack_require__(386);

/**
 * Determines if an element, or any of its ancestors, contain the given attribute
 * @param element - element to start searching at
 * @param attribute - the attribute to search for
 * @returns the value of the first instance found
 */
function elementContainsAttribute(element, attribute) {
    var elementMatch = Object(__WEBPACK_IMPORTED_MODULE_0__findElementRecursive__["a" /* findElementRecursive */])(element, function (testElement) { return testElement.hasAttribute(attribute); });
    return elementMatch && elementMatch.getAttribute(attribute);
}
//# sourceMappingURL=elementContainsAttribute.js.map

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DATA_PORTAL_ATTRIBUTE; });
/* harmony export (immutable) */ __webpack_exports__["b"] = setPortalAttribute;
var DATA_PORTAL_ATTRIBUTE = 'data-portal-element';
/**
 * Identify element as a portal by setting an attribute.
 * @param element - Element to mark as a portal.
 */
function setPortalAttribute(element) {
    element.setAttribute(DATA_PORTAL_ATTRIBUTE, 'true');
}
//# sourceMappingURL=setPortalAttribute.js.map

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SELECTION_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SelectionMode; });
/* unused harmony export SelectionDirection */
var SELECTION_CHANGE = 'change';
/**
 * {@docCategory Selection}
 */
var SelectionMode;
(function (SelectionMode) {
    SelectionMode[SelectionMode["none"] = 0] = "none";
    SelectionMode[SelectionMode["single"] = 1] = "single";
    SelectionMode[SelectionMode["multiple"] = 2] = "multiple";
})(SelectionMode || (SelectionMode = {}));
/**
 * {@docCategory Selection}
 */
var SelectionDirection;
(function (SelectionDirection) {
    SelectionDirection[SelectionDirection["horizontal"] = 0] = "horizontal";
    SelectionDirection[SelectionDirection["vertical"] = 1] = "vertical";
})(SelectionDirection || (SelectionDirection = {}));
//# sourceMappingURL=Selection.types.js.map

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LocalizedFontNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LocalizedFontFamilies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FontSizes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FontWeights; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IconFontSizes; });
/* harmony export (immutable) */ __webpack_exports__["f"] = createFontStyles;
// Fallback fonts, if specified system or web fonts are unavailable.
var FontFamilyFallbacks = "'Segoe UI', -apple-system, BlinkMacSystemFont, 'Roboto', 'Helvetica Neue', sans-serif";
// Font face names to be registered.
var LocalizedFontNames;
(function (LocalizedFontNames) {
    LocalizedFontNames.Arabic = 'Segoe UI Web (Arabic)';
    LocalizedFontNames.Cyrillic = 'Segoe UI Web (Cyrillic)';
    LocalizedFontNames.EastEuropean = 'Segoe UI Web (East European)';
    LocalizedFontNames.Greek = 'Segoe UI Web (Greek)';
    LocalizedFontNames.Hebrew = 'Segoe UI Web (Hebrew)';
    LocalizedFontNames.Thai = 'Leelawadee UI Web';
    LocalizedFontNames.Vietnamese = 'Segoe UI Web (Vietnamese)';
    LocalizedFontNames.WestEuropean = 'Segoe UI Web (West European)';
    LocalizedFontNames.Selawik = 'Selawik Web';
})(LocalizedFontNames || (LocalizedFontNames = {}));
// Font families with fallbacks, for the general regions.
var LocalizedFontFamilies;
(function (LocalizedFontFamilies) {
    LocalizedFontFamilies.Arabic = "'" + LocalizedFontNames.Arabic + "'";
    LocalizedFontFamilies.ChineseSimplified = "'Microsoft Yahei UI', Verdana, Simsun";
    LocalizedFontFamilies.ChineseTraditional = "'Microsoft Jhenghei UI', Pmingliu";
    LocalizedFontFamilies.Cyrillic = "'" + LocalizedFontNames.Cyrillic + "'";
    LocalizedFontFamilies.EastEuropean = "'" + LocalizedFontNames.EastEuropean + "'";
    LocalizedFontFamilies.Greek = "'" + LocalizedFontNames.Greek + "'";
    LocalizedFontFamilies.Hebrew = "'" + LocalizedFontNames.Hebrew + "'";
    LocalizedFontFamilies.Hindi = "'Nirmala UI'";
    LocalizedFontFamilies.Japanese = "'Yu Gothic UI', 'Meiryo UI', Meiryo, 'MS Pgothic', Osaka";
    LocalizedFontFamilies.Korean = "'Malgun Gothic', Gulim";
    LocalizedFontFamilies.Selawik = "'" + LocalizedFontNames.Selawik + "'";
    LocalizedFontFamilies.Thai = "'Leelawadee UI Web', 'Kmer UI'";
    LocalizedFontFamilies.Vietnamese = "'" + LocalizedFontNames.Vietnamese + "'";
    LocalizedFontFamilies.WestEuropean = "'" + LocalizedFontNames.WestEuropean + "'";
})(LocalizedFontFamilies || (LocalizedFontFamilies = {}));
// By default, we favor system fonts for the default.
// All localized fonts use a web font and never use the system font.
var defaultFontFamily = "'Segoe UI', '" + LocalizedFontNames.WestEuropean + "'";
// Mapping of language prefix to to font family.
var LanguageToFontMap = {
    ar: LocalizedFontFamilies.Arabic,
    bg: LocalizedFontFamilies.Cyrillic,
    cs: LocalizedFontFamilies.EastEuropean,
    el: LocalizedFontFamilies.Greek,
    et: LocalizedFontFamilies.EastEuropean,
    he: LocalizedFontFamilies.Hebrew,
    hi: LocalizedFontFamilies.Hindi,
    hr: LocalizedFontFamilies.EastEuropean,
    hu: LocalizedFontFamilies.EastEuropean,
    ja: LocalizedFontFamilies.Japanese,
    kk: LocalizedFontFamilies.EastEuropean,
    ko: LocalizedFontFamilies.Korean,
    lt: LocalizedFontFamilies.EastEuropean,
    lv: LocalizedFontFamilies.EastEuropean,
    pl: LocalizedFontFamilies.EastEuropean,
    ru: LocalizedFontFamilies.Cyrillic,
    sk: LocalizedFontFamilies.EastEuropean,
    'sr-latn': LocalizedFontFamilies.EastEuropean,
    th: LocalizedFontFamilies.Thai,
    tr: LocalizedFontFamilies.EastEuropean,
    uk: LocalizedFontFamilies.Cyrillic,
    vi: LocalizedFontFamilies.Vietnamese,
    'zh-hans': LocalizedFontFamilies.ChineseSimplified,
    'zh-hant': LocalizedFontFamilies.ChineseTraditional
};
// Standard font sizes.
var FontSizes;
(function (FontSizes) {
    FontSizes.mini = '10px';
    FontSizes.xSmall = '11px';
    FontSizes.small = '12px';
    FontSizes.smallPlus = '13px';
    FontSizes.medium = '14px';
    FontSizes.mediumPlus = '15px';
    FontSizes.icon = '16px';
    FontSizes.large = '17px';
    FontSizes.xLarge = '21px';
    FontSizes.xLargePlus = '21px';
    FontSizes.xxLarge = '28px';
    FontSizes.xxLargePlus = '28px';
    FontSizes.superLarge = '42px';
    FontSizes.mega = '72px';
})(FontSizes || (FontSizes = {}));
// Standard font weights.
var FontWeights;
(function (FontWeights) {
    FontWeights.light = 100;
    FontWeights.semilight = 300;
    FontWeights.regular = 400;
    FontWeights.semibold = 600;
    FontWeights.bold = 700;
})(FontWeights || (FontWeights = {}));
// Standard Icon Sizes.
var IconFontSizes;
(function (IconFontSizes) {
    IconFontSizes.xSmall = '10px';
    IconFontSizes.small = '12px';
    IconFontSizes.medium = '16px';
    IconFontSizes.large = '20px';
})(IconFontSizes || (IconFontSizes = {}));
function _fontFamilyWithFallbacks(fontFamily) {
    return fontFamily + ", " + FontFamilyFallbacks;
}
function createFontStyles(localeCode) {
    var localizedFont = _getLocalizedFontFamily(localeCode);
    var fontFamilyWithFallback = _fontFamilyWithFallbacks(localizedFont);
    var semilightFontFamilyWithFallback = fontFamilyWithFallback;
    // Chrome has a bug where it does not render Segoe UI Semilight correctly, so we force the webfont to be used in that case
    if (localizedFont === defaultFontFamily) {
        semilightFontFamilyWithFallback = _fontFamilyWithFallbacks(LocalizedFontFamilies.WestEuropean);
    }
    var fontStyles = {
        tiny: _createFont(FontSizes.mini, FontWeights.semibold, fontFamilyWithFallback),
        xSmall: _createFont(FontSizes.xSmall, FontWeights.regular, fontFamilyWithFallback),
        small: _createFont(FontSizes.small, FontWeights.regular, fontFamilyWithFallback),
        smallPlus: _createFont(FontSizes.smallPlus, FontWeights.regular, fontFamilyWithFallback),
        medium: _createFont(FontSizes.medium, FontWeights.regular, fontFamilyWithFallback),
        mediumPlus: _createFont(FontSizes.mediumPlus, FontWeights.regular, fontFamilyWithFallback),
        large: _createFont(FontSizes.large, FontWeights.semilight, semilightFontFamilyWithFallback),
        xLarge: _createFont(FontSizes.xLarge, FontWeights.light, fontFamilyWithFallback),
        xLargePlus: _createFont(FontSizes.xLargePlus, FontWeights.light, fontFamilyWithFallback),
        xxLarge: _createFont(FontSizes.xxLarge, FontWeights.light, fontFamilyWithFallback),
        xxLargePlus: _createFont(FontSizes.xxLargePlus, FontWeights.light, fontFamilyWithFallback),
        superLarge: _createFont(FontSizes.superLarge, FontWeights.light, fontFamilyWithFallback),
        mega: _createFont(FontSizes.mega, FontWeights.light, fontFamilyWithFallback)
    };
    return fontStyles;
}
/**
 * If there is a localized font for this language, return that. Returns undefined if there is no localized font for that language.
 */
function _getLocalizedFontFamily(language) {
    for (var lang in LanguageToFontMap) {
        if (LanguageToFontMap.hasOwnProperty(lang) && language && lang.indexOf(language) === 0) {
            // tslint:disable-next-line:no-any
            return LanguageToFontMap[lang];
        }
    }
    return defaultFontFamily;
}
function _createFont(size, weight, fontFamily) {
    return {
        fontFamily: fontFamily,
        MozOsxFontSmoothing: 'grayscale',
        WebkitFontSmoothing: 'antialiased',
        fontSize: size,
        fontWeight: weight
    };
}
//# sourceMappingURL=fonts.js.map

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HighContrastSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HighContrastSelectorWhite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HighContrastSelectorBlack; });
/* unused harmony export ScreenWidthMinSmall */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ScreenWidthMinMedium; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ScreenWidthMinLarge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ScreenWidthMinXLarge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ScreenWidthMinXXLarge; });
/* unused harmony export ScreenWidthMinXXXLarge */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ScreenWidthMaxSmall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ScreenWidthMaxMedium; });
/* unused harmony export ScreenWidthMaxLarge */
/* unused harmony export ScreenWidthMaxXLarge */
/* unused harmony export ScreenWidthMaxXXLarge */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ScreenWidthMinUhfMobile; });
/* harmony export (immutable) */ __webpack_exports__["k"] = getScreenSelector;
var HighContrastSelector = '@media screen and (-ms-high-contrast: active)';
var HighContrastSelectorWhite = '@media screen and (-ms-high-contrast: black-on-white)';
var HighContrastSelectorBlack = '@media screen and (-ms-high-contrast: white-on-black)';
var ScreenWidthMinSmall = 320;
var ScreenWidthMinMedium = 480;
var ScreenWidthMinLarge = 640;
var ScreenWidthMinXLarge = 1024;
var ScreenWidthMinXXLarge = 1366;
var ScreenWidthMinXXXLarge = 1920;
var ScreenWidthMaxSmall = ScreenWidthMinMedium - 1;
var ScreenWidthMaxMedium = ScreenWidthMinLarge - 1;
var ScreenWidthMaxLarge = ScreenWidthMinXLarge - 1;
var ScreenWidthMaxXLarge = ScreenWidthMinXXLarge - 1;
var ScreenWidthMaxXXLarge = ScreenWidthMinXXXLarge - 1;
var ScreenWidthMinUhfMobile = 768;
function getScreenSelector(min, max) {
    return "@media only screen and (min-width: " + min + "px) and (max-width: " + max + "px)";
}
//# sourceMappingURL=CommonStyles.js.map

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ZIndexes; });
var ZIndexes;
(function (ZIndexes) {
    ZIndexes.Nav = 1;
    /**
     * @deprecated ScrollablePane
     */
    ZIndexes.ScrollablePane = 1;
    ZIndexes.FocusStyle = 1;
    ZIndexes.Coachmark = 1000;
    ZIndexes.Layer = 1000000;
    ZIndexes.KeytipLayer = 1000001;
})(ZIndexes || (ZIndexes = {}));
//# sourceMappingURL=zIndexes.js.map

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = trim;
// GA strings need to have leading/trailing whitespace trimmed, and not all
// browsers have String.prototoype.trim().
function trim(s) {
  return s.replace(/^\s+|\s+$/g, '');
}

/***/ }),
/* 657 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

!function t(e,r){if(true)module.exports=r();else if("function"==typeof define&&define.amd)define([],r);else{var n=r();for(var i in n)("object"==typeof exports?exports:e)[i]=n[i]}}(this,(function(){return function(t){var e={};function r(n){if(e[n])return e[n].exports;var i=e[n]={i:n,l:!1,exports:{}};return t[n].call(i.exports,i,i.exports,r),i.l=!0,i.exports}return r.m=t,r.c=e,r.d=function(t,e,n){r.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n})},r.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},r.t=function(t,e){if(1&e&&(t=r(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var i in t)r.d(n,i,function(e){return t[e]}.bind(null,i));return n},r.n=function(t){var e=t&&t.__esModule?function e(){return t.default}:function e(){return t};return r.d(e,"a",e),e},r.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},r.p="",r(r.s=22)}([function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}();var i={debug:function t(){},info:function t(){},warn:function t(){},error:function t(){}},o=void 0,s=void 0;(e.Log=function(){function t(){!function e(t,r){if(!(t instanceof r))throw new TypeError("Cannot call a class as a function")}(this,t)}return t.reset=function t(){s=3,o=i},t.debug=function t(){if(s>=4){for(var e=arguments.length,r=Array(e),n=0;n<e;n++)r[n]=arguments[n];o.debug.apply(o,Array.from(r))}},t.info=function t(){if(s>=3){for(var e=arguments.length,r=Array(e),n=0;n<e;n++)r[n]=arguments[n];o.info.apply(o,Array.from(r))}},t.warn=function t(){if(s>=2){for(var e=arguments.length,r=Array(e),n=0;n<e;n++)r[n]=arguments[n];o.warn.apply(o,Array.from(r))}},t.error=function t(){if(s>=1){for(var e=arguments.length,r=Array(e),n=0;n<e;n++)r[n]=arguments[n];o.error.apply(o,Array.from(r))}},n(t,null,[{key:"NONE",get:function t(){return 0}},{key:"ERROR",get:function t(){return 1}},{key:"WARN",get:function t(){return 2}},{key:"INFO",get:function t(){return 3}},{key:"DEBUG",get:function t(){return 4}},{key:"level",get:function t(){return s},set:function t(e){if(!(0<=e&&e<=4))throw new Error("Invalid log level");s=e}},{key:"logger",get:function t(){return o},set:function t(e){if(!e.debug&&e.info&&(e.debug=e.info),!(e.debug&&e.info&&e.warn&&e.error))throw new Error("Invalid logger");o=e}}]),t}()).reset()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}();var i={setInterval:function(t){function e(e,r){return t.apply(this,arguments)}return e.toString=function(){return t.toString()},e}((function(t,e){return setInterval(t,e)})),clearInterval:function(t){function e(e){return t.apply(this,arguments)}return e.toString=function(){return t.toString()},e}((function(t){return clearInterval(t)}))},o=!1,s=null;e.Global=function(){function t(){!function e(t,r){if(!(t instanceof r))throw new TypeError("Cannot call a class as a function")}(this,t)}return t._testing=function t(){o=!0},t.setXMLHttpRequest=function t(e){s=e},n(t,null,[{key:"location",get:function t(){if(!o)return location}},{key:"localStorage",get:function t(){if(!o&&"undefined"!=typeof window)return localStorage}},{key:"sessionStorage",get:function t(){if(!o&&"undefined"!=typeof window)return sessionStorage}},{key:"XMLHttpRequest",get:function t(){if(!o&&"undefined"!=typeof window)return s||XMLHttpRequest}},{key:"timer",get:function t(){if(!o)return i}}]),t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.MetadataService=void 0;var n=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),i=r(0),o=r(7);function s(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}var a=".well-known/openid-configuration";e.MetadataService=function(){function t(e){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:o.JsonService;if(s(this,t),!e)throw i.Log.error("MetadataService: No settings passed to MetadataService"),new Error("settings");this._settings=e,this._jsonService=new r(["application/jwk-set+json"])}return t.prototype.resetSigningKeys=function t(){this._settings=this._settings||{},this._settings.signingKeys=void 0},t.prototype.getMetadata=function t(){var e=this;return this._settings.metadata?(i.Log.debug("MetadataService.getMetadata: Returning metadata from settings"),Promise.resolve(this._settings.metadata)):this.metadataUrl?(i.Log.debug("MetadataService.getMetadata: getting metadata from",this.metadataUrl),this._jsonService.getJson(this.metadataUrl).then((function(t){i.Log.debug("MetadataService.getMetadata: json received");var r=e._settings.metadataSeed||{};return e._settings.metadata=Object.assign({},r,t),e._settings.metadata}))):(i.Log.error("MetadataService.getMetadata: No authority or metadataUrl configured on settings"),Promise.reject(new Error("No authority or metadataUrl configured on settings")))},t.prototype.getIssuer=function t(){return this._getMetadataProperty("issuer")},t.prototype.getAuthorizationEndpoint=function t(){return this._getMetadataProperty("authorization_endpoint")},t.prototype.getUserInfoEndpoint=function t(){return this._getMetadataProperty("userinfo_endpoint")},t.prototype.getTokenEndpoint=function t(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];return this._getMetadataProperty("token_endpoint",e)},t.prototype.getCheckSessionIframe=function t(){return this._getMetadataProperty("check_session_iframe",!0)},t.prototype.getEndSessionEndpoint=function t(){return this._getMetadataProperty("end_session_endpoint",!0)},t.prototype.getRevocationEndpoint=function t(){return this._getMetadataProperty("revocation_endpoint",!0)},t.prototype.getKeysEndpoint=function t(){return this._getMetadataProperty("jwks_uri",!0)},t.prototype._getMetadataProperty=function t(e){var r=arguments.length>1&&void 0!==arguments[1]&&arguments[1];return i.Log.debug("MetadataService.getMetadataProperty for: "+e),this.getMetadata().then((function(t){if(i.Log.debug("MetadataService.getMetadataProperty: metadata recieved"),void 0===t[e]){if(!0===r)return void i.Log.warn("MetadataService.getMetadataProperty: Metadata does not contain optional property "+e);throw i.Log.error("MetadataService.getMetadataProperty: Metadata does not contain property "+e),new Error("Metadata does not contain property "+e)}return t[e]}))},t.prototype.getSigningKeys=function t(){var e=this;return this._settings.signingKeys?(i.Log.debug("MetadataService.getSigningKeys: Returning signingKeys from settings"),Promise.resolve(this._settings.signingKeys)):this._getMetadataProperty("jwks_uri").then((function(t){return i.Log.debug("MetadataService.getSigningKeys: jwks_uri received",t),e._jsonService.getJson(t).then((function(t){if(i.Log.debug("MetadataService.getSigningKeys: key set received",t),!t.keys)throw i.Log.error("MetadataService.getSigningKeys: Missing keys on keyset"),new Error("Missing keys on keyset");return e._settings.signingKeys=t.keys,e._settings.signingKeys}))}))},n(t,[{key:"metadataUrl",get:function t(){return this._metadataUrl||(this._settings.metadataUrl?this._metadataUrl=this._settings.metadataUrl:(this._metadataUrl=this._settings.authority,this._metadataUrl&&this._metadataUrl.indexOf(a)<0&&("/"!==this._metadataUrl[this._metadataUrl.length-1]&&(this._metadataUrl+="/"),this._metadataUrl+=a))),this._metadataUrl}}]),t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.UrlUtility=void 0;var n=r(0),i=r(1);e.UrlUtility=function(){function t(){!function e(t,r){if(!(t instanceof r))throw new TypeError("Cannot call a class as a function")}(this,t)}return t.addQueryParam=function t(e,r,n){return e.indexOf("?")<0&&(e+="?"),"?"!==e[e.length-1]&&(e+="&"),e+=encodeURIComponent(r),e+="=",e+=encodeURIComponent(n)},t.parseUrlFragment=function t(e){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"#",o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:i.Global;"string"!=typeof e&&(e=o.location.href);var s=e.lastIndexOf(r);s>=0&&(e=e.substr(s+1)),"?"===r&&(s=e.indexOf("#"))>=0&&(e=e.substr(0,s));for(var a,u={},c=/([^&=]+)=([^&]*)/g,h=0;a=c.exec(e);)if(u[decodeURIComponent(a[1])]=decodeURIComponent(a[2].replace(/\+/g," ")),h++>50)return n.Log.error("UrlUtility.parseUrlFragment: response exceeded expected number of parameters",e),{error:"Response exceeded expected number of parameters"};for(var l in u)return u;return{}},t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.JoseUtil=void 0;var n=r(26),i=function o(t){return t&&t.__esModule?t:{default:t}}(r(33));e.JoseUtil=(0,i.default)({jws:n.jws,KeyUtil:n.KeyUtil,X509:n.X509,crypto:n.crypto,hextob64u:n.hextob64u,b64tohex:n.b64tohex,AllowedSigningAlgs:n.AllowedSigningAlgs})},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.OidcClientSettings=void 0;var n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},i=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),o=r(0),s=r(23),a=r(6),u=r(24),c=r(2);function h(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}var l=".well-known/openid-configuration",f="id_token",g="openid",d="client_secret_post";e.OidcClientSettings=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=e.authority,i=e.metadataUrl,o=e.metadata,l=e.signingKeys,p=e.metadataSeed,v=e.client_id,y=e.client_secret,m=e.response_type,_=void 0===m?f:m,S=e.scope,b=void 0===S?g:S,w=e.redirect_uri,F=e.post_logout_redirect_uri,E=e.client_authentication,x=void 0===E?d:E,A=e.prompt,k=e.display,P=e.max_age,C=e.ui_locales,T=e.acr_values,R=e.resource,I=e.response_mode,D=e.filterProtocolClaims,L=void 0===D||D,N=e.loadUserInfo,U=void 0===N||N,B=e.staleStateAge,O=void 0===B?900:B,j=e.clockSkew,M=void 0===j?300:j,H=e.clockService,V=void 0===H?new s.ClockService:H,K=e.userInfoJwtIssuer,q=void 0===K?"OP":K,J=e.mergeClaims,W=void 0!==J&&J,z=e.stateStore,Y=void 0===z?new a.WebStorageStateStore:z,G=e.ResponseValidatorCtor,X=void 0===G?u.ResponseValidator:G,$=e.MetadataServiceCtor,Q=void 0===$?c.MetadataService:$,Z=e.extraQueryParams,tt=void 0===Z?{}:Z,et=e.extraTokenParams,rt=void 0===et?{}:et;h(this,t),this._authority=r,this._metadataUrl=i,this._metadata=o,this._metadataSeed=p,this._signingKeys=l,this._client_id=v,this._client_secret=y,this._response_type=_,this._scope=b,this._redirect_uri=w,this._post_logout_redirect_uri=F,this._client_authentication=x,this._prompt=A,this._display=k,this._max_age=P,this._ui_locales=C,this._acr_values=T,this._resource=R,this._response_mode=I,this._filterProtocolClaims=!!L,this._loadUserInfo=!!U,this._staleStateAge=O,this._clockSkew=M,this._clockService=V,this._userInfoJwtIssuer=q,this._mergeClaims=!!W,this._stateStore=Y,this._validator=new X(this),this._metadataService=new Q(this),this._extraQueryParams="object"===(void 0===tt?"undefined":n(tt))?tt:{},this._extraTokenParams="object"===(void 0===rt?"undefined":n(rt))?rt:{}}return t.prototype.getEpochTime=function t(){return this._clockService.getEpochTime()},i(t,[{key:"client_id",get:function t(){return this._client_id},set:function t(e){if(this._client_id)throw o.Log.error("OidcClientSettings.set_client_id: client_id has already been assigned."),new Error("client_id has already been assigned.");this._client_id=e}},{key:"client_secret",get:function t(){return this._client_secret}},{key:"response_type",get:function t(){return this._response_type}},{key:"scope",get:function t(){return this._scope}},{key:"redirect_uri",get:function t(){return this._redirect_uri}},{key:"post_logout_redirect_uri",get:function t(){return this._post_logout_redirect_uri}},{key:"client_authentication",get:function t(){return this._client_authentication}},{key:"prompt",get:function t(){return this._prompt}},{key:"display",get:function t(){return this._display}},{key:"max_age",get:function t(){return this._max_age}},{key:"ui_locales",get:function t(){return this._ui_locales}},{key:"acr_values",get:function t(){return this._acr_values}},{key:"resource",get:function t(){return this._resource}},{key:"response_mode",get:function t(){return this._response_mode}},{key:"authority",get:function t(){return this._authority},set:function t(e){if(this._authority)throw o.Log.error("OidcClientSettings.set_authority: authority has already been assigned."),new Error("authority has already been assigned.");this._authority=e}},{key:"metadataUrl",get:function t(){return this._metadataUrl||(this._metadataUrl=this.authority,this._metadataUrl&&this._metadataUrl.indexOf(l)<0&&("/"!==this._metadataUrl[this._metadataUrl.length-1]&&(this._metadataUrl+="/"),this._metadataUrl+=l)),this._metadataUrl}},{key:"metadata",get:function t(){return this._metadata},set:function t(e){this._metadata=e}},{key:"metadataSeed",get:function t(){return this._metadataSeed},set:function t(e){this._metadataSeed=e}},{key:"signingKeys",get:function t(){return this._signingKeys},set:function t(e){this._signingKeys=e}},{key:"filterProtocolClaims",get:function t(){return this._filterProtocolClaims}},{key:"loadUserInfo",get:function t(){return this._loadUserInfo}},{key:"staleStateAge",get:function t(){return this._staleStateAge}},{key:"clockSkew",get:function t(){return this._clockSkew}},{key:"userInfoJwtIssuer",get:function t(){return this._userInfoJwtIssuer}},{key:"mergeClaims",get:function t(){return this._mergeClaims}},{key:"stateStore",get:function t(){return this._stateStore}},{key:"validator",get:function t(){return this._validator}},{key:"metadataService",get:function t(){return this._metadataService}},{key:"extraQueryParams",get:function t(){return this._extraQueryParams},set:function t(e){"object"===(void 0===e?"undefined":n(e))?this._extraQueryParams=e:this._extraQueryParams={}}},{key:"extraTokenParams",get:function t(){return this._extraTokenParams},set:function t(e){"object"===(void 0===e?"undefined":n(e))?this._extraTokenParams=e:this._extraTokenParams={}}}]),t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.WebStorageStateStore=void 0;var n=r(0),i=r(1);function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}e.WebStorageStateStore=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=e.prefix,n=void 0===r?"oidc.":r,s=e.store,a=void 0===s?i.Global.localStorage:s;o(this,t),this._store=a,this._prefix=n}return t.prototype.set=function t(e,r){return n.Log.debug("WebStorageStateStore.set",e),e=this._prefix+e,this._store.setItem(e,r),Promise.resolve()},t.prototype.get=function t(e){n.Log.debug("WebStorageStateStore.get",e),e=this._prefix+e;var r=this._store.getItem(e);return Promise.resolve(r)},t.prototype.remove=function t(e){n.Log.debug("WebStorageStateStore.remove",e),e=this._prefix+e;var r=this._store.getItem(e);return this._store.removeItem(e),Promise.resolve(r)},t.prototype.getAllKeys=function t(){n.Log.debug("WebStorageStateStore.getAllKeys");for(var e=[],r=0;r<this._store.length;r++){var i=this._store.key(r);0===i.indexOf(this._prefix)&&e.push(i.substr(this._prefix.length))}return Promise.resolve(e)},t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.JsonService=void 0;var n=r(0),i=r(1);function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}e.JsonService=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:i.Global.XMLHttpRequest,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;o(this,t),e&&Array.isArray(e)?this._contentTypes=e.slice():this._contentTypes=[],this._contentTypes.push("application/json"),n&&this._contentTypes.push("application/jwt"),this._XMLHttpRequest=r,this._jwtHandler=n}return t.prototype.getJson=function t(e,r){var i=this;if(!e)throw n.Log.error("JsonService.getJson: No url passed"),new Error("url");return n.Log.debug("JsonService.getJson, url: ",e),new Promise((function(t,o){var s=new i._XMLHttpRequest;s.open("GET",e);var a=i._contentTypes,u=i._jwtHandler;s.onload=function(){if(n.Log.debug("JsonService.getJson: HTTP response received, status",s.status),200===s.status){var r=s.getResponseHeader("Content-Type");if(r){var i=a.find((function(t){if(r.startsWith(t))return!0}));if("application/jwt"==i)return void u(s).then(t,o);if(i)try{return void t(JSON.parse(s.responseText))}catch(t){return n.Log.error("JsonService.getJson: Error parsing JSON response",t.message),void o(t)}}o(Error("Invalid response Content-Type: "+r+", from URL: "+e))}else o(Error(s.statusText+" ("+s.status+")"))},s.onerror=function(){n.Log.error("JsonService.getJson: network error"),o(Error("Network Error"))},r&&(n.Log.debug("JsonService.getJson: token passed, setting Authorization header"),s.setRequestHeader("Authorization","Bearer "+r)),s.send()}))},t.prototype.postForm=function t(e,r,i){var o=this;if(!e)throw n.Log.error("JsonService.postForm: No url passed"),new Error("url");return n.Log.debug("JsonService.postForm, url: ",e),new Promise((function(t,s){var a=new o._XMLHttpRequest;a.open("POST",e);var u=o._contentTypes;a.onload=function(){if(n.Log.debug("JsonService.postForm: HTTP response received, status",a.status),200!==a.status){if(400===a.status)if(i=a.getResponseHeader("Content-Type"))if(u.find((function(t){if(i.startsWith(t))return!0})))try{var r=JSON.parse(a.responseText);if(r&&r.error)return n.Log.error("JsonService.postForm: Error from server: ",r.error),void s(new Error(r.error))}catch(t){return n.Log.error("JsonService.postForm: Error parsing JSON response",t.message),void s(t)}s(Error(a.statusText+" ("+a.status+")"))}else{var i;if((i=a.getResponseHeader("Content-Type"))&&u.find((function(t){if(i.startsWith(t))return!0})))try{return void t(JSON.parse(a.responseText))}catch(t){return n.Log.error("JsonService.postForm: Error parsing JSON response",t.message),void s(t)}s(Error("Invalid response Content-Type: "+i+", from URL: "+e))}},a.onerror=function(){n.Log.error("JsonService.postForm: network error"),s(Error("Network Error"))};var c="";for(var h in r){var l=r[h];l&&(c.length>0&&(c+="&"),c+=encodeURIComponent(h),c+="=",c+=encodeURIComponent(l))}a.setRequestHeader("Content-Type","application/x-www-form-urlencoded"),void 0!==i&&a.setRequestHeader("Authorization","Basic "+btoa(i)),a.send(c)}))},t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.SigninRequest=void 0;var n=r(0),i=r(3),o=r(13);e.SigninRequest=function(){function t(e){var r=e.url,s=e.client_id,a=e.redirect_uri,u=e.response_type,c=e.scope,h=e.authority,l=e.data,f=e.prompt,g=e.display,d=e.max_age,p=e.ui_locales,v=e.id_token_hint,y=e.login_hint,m=e.acr_values,_=e.resource,S=e.response_mode,b=e.request,w=e.request_uri,F=e.extraQueryParams,E=e.request_type,x=e.client_secret,A=e.extraTokenParams,k=e.skipUserInfo;if(function P(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),!r)throw n.Log.error("SigninRequest.ctor: No url passed"),new Error("url");if(!s)throw n.Log.error("SigninRequest.ctor: No client_id passed"),new Error("client_id");if(!a)throw n.Log.error("SigninRequest.ctor: No redirect_uri passed"),new Error("redirect_uri");if(!u)throw n.Log.error("SigninRequest.ctor: No response_type passed"),new Error("response_type");if(!c)throw n.Log.error("SigninRequest.ctor: No scope passed"),new Error("scope");if(!h)throw n.Log.error("SigninRequest.ctor: No authority passed"),new Error("authority");var C=t.isOidc(u),T=t.isCode(u);S||(S=t.isCode(u)?"query":null),this.state=new o.SigninState({nonce:C,data:l,client_id:s,authority:h,redirect_uri:a,code_verifier:T,request_type:E,response_mode:S,client_secret:x,scope:c,extraTokenParams:A,skipUserInfo:k}),r=i.UrlUtility.addQueryParam(r,"client_id",s),r=i.UrlUtility.addQueryParam(r,"redirect_uri",a),r=i.UrlUtility.addQueryParam(r,"response_type",u),r=i.UrlUtility.addQueryParam(r,"scope",c),r=i.UrlUtility.addQueryParam(r,"state",this.state.id),C&&(r=i.UrlUtility.addQueryParam(r,"nonce",this.state.nonce)),T&&(r=i.UrlUtility.addQueryParam(r,"code_challenge",this.state.code_challenge),r=i.UrlUtility.addQueryParam(r,"code_challenge_method","S256"));var R={prompt:f,display:g,max_age:d,ui_locales:p,id_token_hint:v,login_hint:y,acr_values:m,resource:_,request:b,request_uri:w,response_mode:S};for(var I in R)R[I]&&(r=i.UrlUtility.addQueryParam(r,I,R[I]));for(var D in F)r=i.UrlUtility.addQueryParam(r,D,F[D]);this.url=r}return t.isOidc=function t(e){return!!e.split(/\s+/g).filter((function(t){return"id_token"===t}))[0]},t.isOAuth=function t(e){return!!e.split(/\s+/g).filter((function(t){return"token"===t}))[0]},t.isCode=function t(e){return!!e.split(/\s+/g).filter((function(t){return"code"===t}))[0]},t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.State=void 0;var n=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),i=r(0),o=function s(t){return t&&t.__esModule?t:{default:t}}(r(14));function a(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}e.State=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=e.id,n=e.data,i=e.created,s=e.request_type;a(this,t),this._id=r||(0,o.default)(),this._data=n,this._created="number"==typeof i&&i>0?i:parseInt(Date.now()/1e3),this._request_type=s}return t.prototype.toStorageString=function t(){return i.Log.debug("State.toStorageString"),JSON.stringify({id:this.id,data:this.data,created:this.created,request_type:this.request_type})},t.fromStorageString=function e(r){return i.Log.debug("State.fromStorageString"),new t(JSON.parse(r))},t.clearStaleState=function e(r,n){var o=Date.now()/1e3-n;return r.getAllKeys().then((function(e){i.Log.debug("State.clearStaleState: got keys",e);for(var n=[],s=function s(a){var c=e[a];u=r.get(c).then((function(e){var n=!1;if(e)try{var s=t.fromStorageString(e);i.Log.debug("State.clearStaleState: got item from key: ",c,s.created),s.created<=o&&(n=!0)}catch(t){i.Log.error("State.clearStaleState: Error parsing state for key",c,t.message),n=!0}else i.Log.debug("State.clearStaleState: no item in storage for key: ",c),n=!0;if(n)return i.Log.debug("State.clearStaleState: removed item for key: ",c),r.remove(c)})),n.push(u)},a=0;a<e.length;a++){var u;s(a)}return i.Log.debug("State.clearStaleState: waiting on promise count:",n.length),Promise.all(n)}))},n(t,[{key:"id",get:function t(){return this._id}},{key:"data",get:function t(){return this._data}},{key:"created",get:function t(){return this._created}},{key:"request_type",get:function t(){return this._request_type}}]),t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.OidcClient=void 0;var n=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),i=r(0),o=r(5),s=r(12),a=r(8),u=r(34),c=r(35),h=r(36),l=r(13),f=r(9);function g(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}e.OidcClient=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};g(this,t),e instanceof o.OidcClientSettings?this._settings=e:this._settings=new o.OidcClientSettings(e)}return t.prototype.createSigninRequest=function t(){var e=this,r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=r.response_type,o=r.scope,s=r.redirect_uri,u=r.data,c=r.state,h=r.prompt,l=r.display,f=r.max_age,g=r.ui_locales,d=r.id_token_hint,p=r.login_hint,v=r.acr_values,y=r.resource,m=r.request,_=r.request_uri,S=r.response_mode,b=r.extraQueryParams,w=r.extraTokenParams,F=r.request_type,E=r.skipUserInfo,x=arguments[1];i.Log.debug("OidcClient.createSigninRequest");var A=this._settings.client_id;n=n||this._settings.response_type,o=o||this._settings.scope,s=s||this._settings.redirect_uri,h=h||this._settings.prompt,l=l||this._settings.display,f=f||this._settings.max_age,g=g||this._settings.ui_locales,v=v||this._settings.acr_values,y=y||this._settings.resource,S=S||this._settings.response_mode,b=b||this._settings.extraQueryParams,w=w||this._settings.extraTokenParams;var k=this._settings.authority;return a.SigninRequest.isCode(n)&&"code"!==n?Promise.reject(new Error("OpenID Connect hybrid flow is not supported")):this._metadataService.getAuthorizationEndpoint().then((function(t){i.Log.debug("OidcClient.createSigninRequest: Received authorization endpoint",t);var r=new a.SigninRequest({url:t,client_id:A,redirect_uri:s,response_type:n,scope:o,data:u||c,authority:k,prompt:h,display:l,max_age:f,ui_locales:g,id_token_hint:d,login_hint:p,acr_values:v,resource:y,request:m,request_uri:_,extraQueryParams:b,extraTokenParams:w,request_type:F,response_mode:S,client_secret:e._settings.client_secret,skipUserInfo:E}),P=r.state;return(x=x||e._stateStore).set(P.id,P.toStorageString()).then((function(){return r}))}))},t.prototype.readSigninResponseState=function t(e,r){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];i.Log.debug("OidcClient.readSigninResponseState");var o="query"===this._settings.response_mode||!this._settings.response_mode&&a.SigninRequest.isCode(this._settings.response_type),s=o?"?":"#",c=new u.SigninResponse(e,s);if(!c.state)return i.Log.error("OidcClient.readSigninResponseState: No state in response"),Promise.reject(new Error("No state in response"));r=r||this._stateStore;var h=n?r.remove.bind(r):r.get.bind(r);return h(c.state).then((function(t){if(!t)throw i.Log.error("OidcClient.readSigninResponseState: No matching state found in storage"),new Error("No matching state found in storage");return{state:l.SigninState.fromStorageString(t),response:c}}))},t.prototype.processSigninResponse=function t(e,r){var n=this;return i.Log.debug("OidcClient.processSigninResponse"),this.readSigninResponseState(e,r,!0).then((function(t){var e=t.state,r=t.response;return i.Log.debug("OidcClient.processSigninResponse: Received state from storage; validating response"),n._validator.validateSigninResponse(e,r)}))},t.prototype.createSignoutRequest=function t(){var e=this,r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=r.id_token_hint,o=r.data,s=r.state,a=r.post_logout_redirect_uri,u=r.extraQueryParams,h=r.request_type,l=arguments[1];return i.Log.debug("OidcClient.createSignoutRequest"),a=a||this._settings.post_logout_redirect_uri,u=u||this._settings.extraQueryParams,this._metadataService.getEndSessionEndpoint().then((function(t){if(!t)throw i.Log.error("OidcClient.createSignoutRequest: No end session endpoint url returned"),new Error("no end session endpoint");i.Log.debug("OidcClient.createSignoutRequest: Received end session endpoint",t);var r=new c.SignoutRequest({url:t,id_token_hint:n,post_logout_redirect_uri:a,data:o||s,extraQueryParams:u,request_type:h}),f=r.state;return f&&(i.Log.debug("OidcClient.createSignoutRequest: Signout request has state to persist"),(l=l||e._stateStore).set(f.id,f.toStorageString())),r}))},t.prototype.readSignoutResponseState=function t(e,r){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];i.Log.debug("OidcClient.readSignoutResponseState");var o=new h.SignoutResponse(e);if(!o.state)return i.Log.debug("OidcClient.readSignoutResponseState: No state in response"),o.error?(i.Log.warn("OidcClient.readSignoutResponseState: Response was error: ",o.error),Promise.reject(new s.ErrorResponse(o))):Promise.resolve({state:void 0,response:o});var a=o.state;r=r||this._stateStore;var u=n?r.remove.bind(r):r.get.bind(r);return u(a).then((function(t){if(!t)throw i.Log.error("OidcClient.readSignoutResponseState: No matching state found in storage"),new Error("No matching state found in storage");return{state:f.State.fromStorageString(t),response:o}}))},t.prototype.processSignoutResponse=function t(e,r){var n=this;return i.Log.debug("OidcClient.processSignoutResponse"),this.readSignoutResponseState(e,r,!0).then((function(t){var e=t.state,r=t.response;return e?(i.Log.debug("OidcClient.processSignoutResponse: Received state from storage; validating response"),n._validator.validateSignoutResponse(e,r)):(i.Log.debug("OidcClient.processSignoutResponse: No state from storage; skipping validating response"),r)}))},t.prototype.clearStaleState=function t(e){return i.Log.debug("OidcClient.clearStaleState"),e=e||this._stateStore,f.State.clearStaleState(e,this.settings.staleStateAge)},n(t,[{key:"_stateStore",get:function t(){return this.settings.stateStore}},{key:"_validator",get:function t(){return this.settings.validator}},{key:"_metadataService",get:function t(){return this.settings.metadataService}},{key:"settings",get:function t(){return this._settings}},{key:"metadataService",get:function t(){return this._metadataService}}]),t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.TokenClient=void 0;var n=r(7),i=r(2),o=r(0);function s(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}e.TokenClient=function(){function t(e){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:n.JsonService,a=arguments.length>2&&void 0!==arguments[2]?arguments[2]:i.MetadataService;if(s(this,t),!e)throw o.Log.error("TokenClient.ctor: No settings passed"),new Error("settings");this._settings=e,this._jsonService=new r,this._metadataService=new a(this._settings)}return t.prototype.exchangeCode=function t(){var e=this,r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};(r=Object.assign({},r)).grant_type=r.grant_type||"authorization_code",r.client_id=r.client_id||this._settings.client_id,r.client_secret=r.client_secret||this._settings.client_secret,r.redirect_uri=r.redirect_uri||this._settings.redirect_uri;var n=void 0,i=r._client_authentication||this._settings._client_authentication;return delete r._client_authentication,r.code?r.redirect_uri?r.code_verifier?r.client_id?r.client_secret||"client_secret_basic"!=i?("client_secret_basic"==i&&(n=r.client_id+":"+r.client_secret,delete r.client_id,delete r.client_secret),this._metadataService.getTokenEndpoint(!1).then((function(t){return o.Log.debug("TokenClient.exchangeCode: Received token endpoint"),e._jsonService.postForm(t,r,n).then((function(t){return o.Log.debug("TokenClient.exchangeCode: response received"),t}))}))):(o.Log.error("TokenClient.exchangeCode: No client_secret passed"),Promise.reject(new Error("A client_secret is required"))):(o.Log.error("TokenClient.exchangeCode: No client_id passed"),Promise.reject(new Error("A client_id is required"))):(o.Log.error("TokenClient.exchangeCode: No code_verifier passed"),Promise.reject(new Error("A code_verifier is required"))):(o.Log.error("TokenClient.exchangeCode: No redirect_uri passed"),Promise.reject(new Error("A redirect_uri is required"))):(o.Log.error("TokenClient.exchangeCode: No code passed"),Promise.reject(new Error("A code is required")))},t.prototype.exchangeRefreshToken=function t(){var e=this,r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};(r=Object.assign({},r)).grant_type=r.grant_type||"refresh_token",r.client_id=r.client_id||this._settings.client_id,r.client_secret=r.client_secret||this._settings.client_secret;var n=void 0,i=r._client_authentication||this._settings._client_authentication;return delete r._client_authentication,r.refresh_token?r.client_id?("client_secret_basic"==i&&(n=r.client_id+":"+r.client_secret,delete r.client_id,delete r.client_secret),this._metadataService.getTokenEndpoint(!1).then((function(t){return o.Log.debug("TokenClient.exchangeRefreshToken: Received token endpoint"),e._jsonService.postForm(t,r,n).then((function(t){return o.Log.debug("TokenClient.exchangeRefreshToken: response received"),t}))}))):(o.Log.error("TokenClient.exchangeRefreshToken: No client_id passed"),Promise.reject(new Error("A client_id is required"))):(o.Log.error("TokenClient.exchangeRefreshToken: No refresh_token passed"),Promise.reject(new Error("A refresh_token is required")))},t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.ErrorResponse=void 0;var n=r(0);function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}e.ErrorResponse=function(t){function e(){var r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},s=r.error,a=r.error_description,u=r.error_uri,c=r.state,h=r.session_state;if(i(this,e),!s)throw n.Log.error("No error passed to ErrorResponse"),new Error("error");var l=o(this,t.call(this,a||s));return l.name="ErrorResponse",l.error=s,l.error_description=a,l.error_uri=u,l.state=c,l.session_state=h,l}return function r(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),e}(Error)},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.SigninState=void 0;var n=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),i=r(0),o=r(9),s=r(4),a=function u(t){return t&&t.__esModule?t:{default:t}}(r(14));function c(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function h(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}e.SigninState=function(t){function e(){var r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=r.nonce,i=r.authority,o=r.client_id,u=r.redirect_uri,l=r.code_verifier,f=r.response_mode,g=r.client_secret,d=r.scope,p=r.extraTokenParams,v=r.skipUserInfo;c(this,e);var y=h(this,t.call(this,arguments[0]));if(!0===n?y._nonce=(0,a.default)():n&&(y._nonce=n),!0===l?y._code_verifier=(0,a.default)()+(0,a.default)()+(0,a.default)():l&&(y._code_verifier=l),y.code_verifier){var m=s.JoseUtil.hashString(y.code_verifier,"SHA256");y._code_challenge=s.JoseUtil.hexToBase64Url(m)}return y._redirect_uri=u,y._authority=i,y._client_id=o,y._response_mode=f,y._client_secret=g,y._scope=d,y._extraTokenParams=p,y._skipUserInfo=v,y}return function r(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),e.prototype.toStorageString=function t(){return i.Log.debug("SigninState.toStorageString"),JSON.stringify({id:this.id,data:this.data,created:this.created,request_type:this.request_type,nonce:this.nonce,code_verifier:this.code_verifier,redirect_uri:this.redirect_uri,authority:this.authority,client_id:this.client_id,response_mode:this.response_mode,client_secret:this.client_secret,scope:this.scope,extraTokenParams:this.extraTokenParams,skipUserInfo:this.skipUserInfo})},e.fromStorageString=function t(r){return i.Log.debug("SigninState.fromStorageString"),new e(JSON.parse(r))},n(e,[{key:"nonce",get:function t(){return this._nonce}},{key:"authority",get:function t(){return this._authority}},{key:"client_id",get:function t(){return this._client_id}},{key:"redirect_uri",get:function t(){return this._redirect_uri}},{key:"code_verifier",get:function t(){return this._code_verifier}},{key:"code_challenge",get:function t(){return this._code_challenge}},{key:"response_mode",get:function t(){return this._response_mode}},{key:"client_secret",get:function t(){return this._client_secret}},{key:"scope",get:function t(){return this._scope}},{key:"extraTokenParams",get:function t(){return this._extraTokenParams}},{key:"skipUserInfo",get:function t(){return this._skipUserInfo}}]),e}(o.State)},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default=function n(){return("undefined"!=i&&null!==i&&void 0!==i.getRandomValues?o:s)().replace(/-/g,"")};var i="undefined"!=typeof window?window.crypto||window.msCrypto:null;function o(){return([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g,(function(t){return(t^i.getRandomValues(new Uint8Array(1))[0]&15>>t/4).toString(16)}))}function s(){return([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g,(function(t){return(t^16*Math.random()>>t/4).toString(16)}))}t.exports=e.default},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.User=void 0;var n=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),i=r(0);e.User=function(){function t(e){var r=e.id_token,n=e.session_state,i=e.access_token,o=e.refresh_token,s=e.token_type,a=e.scope,u=e.profile,c=e.expires_at,h=e.state;!function l(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.id_token=r,this.session_state=n,this.access_token=i,this.refresh_token=o,this.token_type=s,this.scope=a,this.profile=u,this.expires_at=c,this.state=h}return t.prototype.toStorageString=function t(){return i.Log.debug("User.toStorageString"),JSON.stringify({id_token:this.id_token,session_state:this.session_state,access_token:this.access_token,refresh_token:this.refresh_token,token_type:this.token_type,scope:this.scope,profile:this.profile,expires_at:this.expires_at})},t.fromStorageString=function e(r){return i.Log.debug("User.fromStorageString"),new t(JSON.parse(r))},n(t,[{key:"expires_in",get:function t(){if(this.expires_at){var e=parseInt(Date.now()/1e3);return this.expires_at-e}},set:function t(e){var r=parseInt(e);if("number"==typeof r&&r>0){var n=parseInt(Date.now()/1e3);this.expires_at=n+r}}},{key:"expired",get:function t(){var e=this.expires_in;if(void 0!==e)return e<=0}},{key:"scopes",get:function t(){return(this.scope||"").split(" ")}}]),t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.AccessTokenEvents=void 0;var n=r(0),i=r(46);function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}e.AccessTokenEvents=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=e.accessTokenExpiringNotificationTime,n=void 0===r?60:r,s=e.accessTokenExpiringTimer,a=void 0===s?new i.Timer("Access token expiring"):s,u=e.accessTokenExpiredTimer,c=void 0===u?new i.Timer("Access token expired"):u;o(this,t),this._accessTokenExpiringNotificationTime=n,this._accessTokenExpiring=a,this._accessTokenExpired=c}return t.prototype.load=function t(e){if(e.access_token&&void 0!==e.expires_in){var r=e.expires_in;if(n.Log.debug("AccessTokenEvents.load: access token present, remaining duration:",r),r>0){var i=r-this._accessTokenExpiringNotificationTime;i<=0&&(i=1),n.Log.debug("AccessTokenEvents.load: registering expiring timer in:",i),this._accessTokenExpiring.init(i)}else n.Log.debug("AccessTokenEvents.load: canceling existing expiring timer becase we're past expiration."),this._accessTokenExpiring.cancel();var o=r+1;n.Log.debug("AccessTokenEvents.load: registering expired timer in:",o),this._accessTokenExpired.init(o)}else this._accessTokenExpiring.cancel(),this._accessTokenExpired.cancel()},t.prototype.unload=function t(){n.Log.debug("AccessTokenEvents.unload: canceling existing access token timers"),this._accessTokenExpiring.cancel(),this._accessTokenExpired.cancel()},t.prototype.addAccessTokenExpiring=function t(e){this._accessTokenExpiring.addHandler(e)},t.prototype.removeAccessTokenExpiring=function t(e){this._accessTokenExpiring.removeHandler(e)},t.prototype.addAccessTokenExpired=function t(e){this._accessTokenExpired.addHandler(e)},t.prototype.removeAccessTokenExpired=function t(e){this._accessTokenExpired.removeHandler(e)},t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.Event=void 0;var n=r(0);e.Event=function(){function t(e){!function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this._name=e,this._callbacks=[]}return t.prototype.addHandler=function t(e){this._callbacks.push(e)},t.prototype.removeHandler=function t(e){var r=this._callbacks.findIndex((function(t){return t===e}));r>=0&&this._callbacks.splice(r,1)},t.prototype.raise=function t(){n.Log.debug("Event: Raising event: "+this._name);for(var e=0;e<this._callbacks.length;e++){var r;(r=this._callbacks)[e].apply(r,arguments)}},t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.SessionMonitor=void 0;var n=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),i=r(0),o=r(19),s=r(1);function a(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}e.SessionMonitor=function(){function t(e){var r=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:o.CheckSessionIFrame,u=arguments.length>2&&void 0!==arguments[2]?arguments[2]:s.Global.timer;if(a(this,t),!e)throw i.Log.error("SessionMonitor.ctor: No user manager passed to SessionMonitor"),new Error("userManager");this._userManager=e,this._CheckSessionIFrameCtor=n,this._timer=u,this._userManager.events.addUserLoaded(this._start.bind(this)),this._userManager.events.addUserUnloaded(this._stop.bind(this)),Promise.resolve(this._userManager.getUser().then((function(t){t?r._start(t):r._settings.monitorAnonymousSession&&r._userManager.querySessionStatus().then((function(t){var e={session_state:t.session_state};t.sub&&t.sid&&(e.profile={sub:t.sub,sid:t.sid}),r._start(e)})).catch((function(t){i.Log.error("SessionMonitor ctor: error from querySessionStatus:",t.message)}))})).catch((function(t){i.Log.error("SessionMonitor ctor: error from getUser:",t.message)})))}return t.prototype._start=function t(e){var r=this,n=e.session_state;n&&(e.profile?(this._sub=e.profile.sub,this._sid=e.profile.sid,i.Log.debug("SessionMonitor._start: session_state:",n,", sub:",this._sub)):(this._sub=void 0,this._sid=void 0,i.Log.debug("SessionMonitor._start: session_state:",n,", anonymous user")),this._checkSessionIFrame?this._checkSessionIFrame.start(n):this._metadataService.getCheckSessionIframe().then((function(t){if(t){i.Log.debug("SessionMonitor._start: Initializing check session iframe");var e=r._client_id,o=r._checkSessionInterval,s=r._stopCheckSessionOnError;r._checkSessionIFrame=new r._CheckSessionIFrameCtor(r._callback.bind(r),e,t,o,s),r._checkSessionIFrame.load().then((function(){r._checkSessionIFrame.start(n)}))}else i.Log.warn("SessionMonitor._start: No check session iframe found in the metadata")})).catch((function(t){i.Log.error("SessionMonitor._start: Error from getCheckSessionIframe:",t.message)})))},t.prototype._stop=function t(){var e=this;if(this._sub=void 0,this._sid=void 0,this._checkSessionIFrame&&(i.Log.debug("SessionMonitor._stop"),this._checkSessionIFrame.stop()),this._settings.monitorAnonymousSession)var r=this._timer.setInterval((function(){e._timer.clearInterval(r),e._userManager.querySessionStatus().then((function(t){var r={session_state:t.session_state};t.sub&&t.sid&&(r.profile={sub:t.sub,sid:t.sid}),e._start(r)})).catch((function(t){i.Log.error("SessionMonitor: error from querySessionStatus:",t.message)}))}),1e3)},t.prototype._callback=function t(){var e=this;this._userManager.querySessionStatus().then((function(t){var r=!0;t?t.sub===e._sub?(r=!1,e._checkSessionIFrame.start(t.session_state),t.sid===e._sid?i.Log.debug("SessionMonitor._callback: Same sub still logged in at OP, restarting check session iframe; session_state:",t.session_state):(i.Log.debug("SessionMonitor._callback: Same sub still logged in at OP, session state has changed, restarting check session iframe; session_state:",t.session_state),e._userManager.events._raiseUserSessionChanged())):i.Log.debug("SessionMonitor._callback: Different subject signed into OP:",t.sub):i.Log.debug("SessionMonitor._callback: Subject no longer signed into OP"),r&&(e._sub?(i.Log.debug("SessionMonitor._callback: SessionMonitor._callback; raising signed out event"),e._userManager.events._raiseUserSignedOut()):(i.Log.debug("SessionMonitor._callback: SessionMonitor._callback; raising signed in event"),e._userManager.events._raiseUserSignedIn()))})).catch((function(t){e._sub&&(i.Log.debug("SessionMonitor._callback: Error calling queryCurrentSigninSession; raising signed out event",t.message),e._userManager.events._raiseUserSignedOut())}))},n(t,[{key:"_settings",get:function t(){return this._userManager.settings}},{key:"_metadataService",get:function t(){return this._userManager.metadataService}},{key:"_client_id",get:function t(){return this._settings.client_id}},{key:"_checkSessionInterval",get:function t(){return this._settings.checkSessionInterval}},{key:"_stopCheckSessionOnError",get:function t(){return this._settings.stopCheckSessionOnError}}]),t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.CheckSessionIFrame=void 0;var n=r(0);function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}e.CheckSessionIFrame=function(){function t(e,r,n,o){var s=!(arguments.length>4&&void 0!==arguments[4])||arguments[4];i(this,t),this._callback=e,this._client_id=r,this._url=n,this._interval=o||2e3,this._stopOnError=s;var a=n.indexOf("/",n.indexOf("//")+2);this._frame_origin=n.substr(0,a),this._frame=window.document.createElement("iframe"),this._frame.style.visibility="hidden",this._frame.style.position="absolute",this._frame.style.display="none",this._frame.width=0,this._frame.height=0,this._frame.src=n}return t.prototype.load=function t(){var e=this;return new Promise((function(t){e._frame.onload=function(){t()},window.document.body.appendChild(e._frame),e._boundMessageEvent=e._message.bind(e),window.addEventListener("message",e._boundMessageEvent,!1)}))},t.prototype._message=function t(e){e.origin===this._frame_origin&&e.source===this._frame.contentWindow&&("error"===e.data?(n.Log.error("CheckSessionIFrame: error message from check session op iframe"),this._stopOnError&&this.stop()):"changed"===e.data?(n.Log.debug("CheckSessionIFrame: changed message from check session op iframe"),this.stop(),this._callback()):n.Log.debug("CheckSessionIFrame: "+e.data+" message from check session op iframe"))},t.prototype.start=function t(e){var r=this;if(this._session_state!==e){n.Log.debug("CheckSessionIFrame.start"),this.stop(),this._session_state=e;var i=function t(){r._frame.contentWindow.postMessage(r._client_id+" "+r._session_state,r._frame_origin)};i(),this._timer=window.setInterval(i,this._interval)}},t.prototype.stop=function t(){this._session_state=null,this._timer&&(n.Log.debug("CheckSessionIFrame.stop"),window.clearInterval(this._timer),this._timer=null)},t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.TokenRevocationClient=void 0;var n=r(0),i=r(2),o=r(1);function s(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}var a="access_token",u="refresh_token";e.TokenRevocationClient=function(){function t(e){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:o.Global.XMLHttpRequest,a=arguments.length>2&&void 0!==arguments[2]?arguments[2]:i.MetadataService;if(s(this,t),!e)throw n.Log.error("TokenRevocationClient.ctor: No settings provided"),new Error("No settings provided.");this._settings=e,this._XMLHttpRequestCtor=r,this._metadataService=new a(this._settings)}return t.prototype.revoke=function t(e,r){var i=this,o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"access_token";if(!e)throw n.Log.error("TokenRevocationClient.revoke: No token provided"),new Error("No token provided.");if(o!==a&&o!=u)throw n.Log.error("TokenRevocationClient.revoke: Invalid token type"),new Error("Invalid token type.");return this._metadataService.getRevocationEndpoint().then((function(t){if(t){n.Log.debug("TokenRevocationClient.revoke: Revoking "+o);var s=i._settings.client_id,a=i._settings.client_secret;return i._revoke(t,s,a,e,o)}if(r)throw n.Log.error("TokenRevocationClient.revoke: Revocation not supported"),new Error("Revocation not supported")}))},t.prototype._revoke=function t(e,r,i,o,s){var a=this;return new Promise((function(t,u){var c=new a._XMLHttpRequestCtor;c.open("POST",e),c.onload=function(){n.Log.debug("TokenRevocationClient.revoke: HTTP response received, status",c.status),200===c.status?t():u(Error(c.statusText+" ("+c.status+")"))},c.onerror=function(){n.Log.debug("TokenRevocationClient.revoke: Network Error."),u("Network Error")};var h="client_id="+encodeURIComponent(r);i&&(h+="&client_secret="+encodeURIComponent(i)),h+="&token_type_hint="+encodeURIComponent(s),h+="&token="+encodeURIComponent(o),c.setRequestHeader("Content-Type","application/x-www-form-urlencoded"),c.send(h)}))},t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.CordovaPopupWindow=void 0;var n=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),i=r(0);e.CordovaPopupWindow=function(){function t(e){var r=this;!function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this._promise=new Promise((function(t,e){r._resolve=t,r._reject=e})),this.features=e.popupWindowFeatures||"location=no,toolbar=no,zoom=no",this.target=e.popupWindowTarget||"_blank",this.redirect_uri=e.startUrl,i.Log.debug("CordovaPopupWindow.ctor: redirect_uri: "+this.redirect_uri)}return t.prototype._isInAppBrowserInstalled=function t(e){return["cordova-plugin-inappbrowser","cordova-plugin-inappbrowser.inappbrowser","org.apache.cordova.inappbrowser"].some((function(t){return e.hasOwnProperty(t)}))},t.prototype.navigate=function t(e){if(e&&e.url){if(!window.cordova)return this._error("cordova is undefined");var r=window.cordova.require("cordova/plugin_list").metadata;if(!1===this._isInAppBrowserInstalled(r))return this._error("InAppBrowser plugin not found");this._popup=cordova.InAppBrowser.open(e.url,this.target,this.features),this._popup?(i.Log.debug("CordovaPopupWindow.navigate: popup successfully created"),this._exitCallbackEvent=this._exitCallback.bind(this),this._loadStartCallbackEvent=this._loadStartCallback.bind(this),this._popup.addEventListener("exit",this._exitCallbackEvent,!1),this._popup.addEventListener("loadstart",this._loadStartCallbackEvent,!1)):this._error("Error opening popup window")}else this._error("No url provided");return this.promise},t.prototype._loadStartCallback=function t(e){0===e.url.indexOf(this.redirect_uri)&&this._success({url:e.url})},t.prototype._exitCallback=function t(e){this._error(e)},t.prototype._success=function t(e){this._cleanup(),i.Log.debug("CordovaPopupWindow: Successful response from cordova popup window"),this._resolve(e)},t.prototype._error=function t(e){this._cleanup(),i.Log.error(e),this._reject(new Error(e))},t.prototype.close=function t(){this._cleanup()},t.prototype._cleanup=function t(){this._popup&&(i.Log.debug("CordovaPopupWindow: cleaning up popup"),this._popup.removeEventListener("exit",this._exitCallbackEvent,!1),this._popup.removeEventListener("loadstart",this._loadStartCallbackEvent,!1),this._popup.close()),this._popup=null},n(t,[{key:"promise",get:function t(){return this._promise}}]),t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=r(0),i=r(10),o=r(5),s=r(6),a=r(37),u=r(38),c=r(16),h=r(2),l=r(48),f=r(49),g=r(19),d=r(20),p=r(18),v=r(1),y=r(15),m=r(50);e.default={Version:m.Version,Log:n.Log,OidcClient:i.OidcClient,OidcClientSettings:o.OidcClientSettings,WebStorageStateStore:s.WebStorageStateStore,InMemoryWebStorage:a.InMemoryWebStorage,UserManager:u.UserManager,AccessTokenEvents:c.AccessTokenEvents,MetadataService:h.MetadataService,CordovaPopupNavigator:l.CordovaPopupNavigator,CordovaIFrameNavigator:f.CordovaIFrameNavigator,CheckSessionIFrame:g.CheckSessionIFrame,TokenRevocationClient:d.TokenRevocationClient,SessionMonitor:p.SessionMonitor,Global:v.Global,User:y.User},t.exports=e.default},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0});e.ClockService=function(){function t(){!function e(t,r){if(!(t instanceof r))throw new TypeError("Cannot call a class as a function")}(this,t)}return t.prototype.getEpochTime=function t(){return Promise.resolve(Date.now()/1e3|0)},t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.ResponseValidator=void 0;var n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},i=r(0),o=r(2),s=r(25),a=r(11),u=r(12),c=r(4);function h(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}var l=["nonce","at_hash","iat","nbf","exp","aud","iss","c_hash"];e.ResponseValidator=function(){function t(e){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:o.MetadataService,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:s.UserInfoService,u=arguments.length>3&&void 0!==arguments[3]?arguments[3]:c.JoseUtil,l=arguments.length>4&&void 0!==arguments[4]?arguments[4]:a.TokenClient;if(h(this,t),!e)throw i.Log.error("ResponseValidator.ctor: No settings passed to ResponseValidator"),new Error("settings");this._settings=e,this._metadataService=new r(this._settings),this._userInfoService=new n(this._settings),this._joseUtil=u,this._tokenClient=new l(this._settings)}return t.prototype.validateSigninResponse=function t(e,r){var n=this;return i.Log.debug("ResponseValidator.validateSigninResponse"),this._processSigninParams(e,r).then((function(t){return i.Log.debug("ResponseValidator.validateSigninResponse: state processed"),n._validateTokens(e,t).then((function(t){return i.Log.debug("ResponseValidator.validateSigninResponse: tokens validated"),n._processClaims(e,t).then((function(t){return i.Log.debug("ResponseValidator.validateSigninResponse: claims processed"),t}))}))}))},t.prototype.validateSignoutResponse=function t(e,r){return e.id!==r.state?(i.Log.error("ResponseValidator.validateSignoutResponse: State does not match"),Promise.reject(new Error("State does not match"))):(i.Log.debug("ResponseValidator.validateSignoutResponse: state validated"),r.state=e.data,r.error?(i.Log.warn("ResponseValidator.validateSignoutResponse: Response was error",r.error),Promise.reject(new u.ErrorResponse(r))):Promise.resolve(r))},t.prototype._processSigninParams=function t(e,r){if(e.id!==r.state)return i.Log.error("ResponseValidator._processSigninParams: State does not match"),Promise.reject(new Error("State does not match"));if(!e.client_id)return i.Log.error("ResponseValidator._processSigninParams: No client_id on state"),Promise.reject(new Error("No client_id on state"));if(!e.authority)return i.Log.error("ResponseValidator._processSigninParams: No authority on state"),Promise.reject(new Error("No authority on state"));if(this._settings.authority){if(this._settings.authority&&this._settings.authority!==e.authority)return i.Log.error("ResponseValidator._processSigninParams: authority mismatch on settings vs. signin state"),Promise.reject(new Error("authority mismatch on settings vs. signin state"))}else this._settings.authority=e.authority;if(this._settings.client_id){if(this._settings.client_id&&this._settings.client_id!==e.client_id)return i.Log.error("ResponseValidator._processSigninParams: client_id mismatch on settings vs. signin state"),Promise.reject(new Error("client_id mismatch on settings vs. signin state"))}else this._settings.client_id=e.client_id;return i.Log.debug("ResponseValidator._processSigninParams: state validated"),r.state=e.data,r.error?(i.Log.warn("ResponseValidator._processSigninParams: Response was error",r.error),Promise.reject(new u.ErrorResponse(r))):e.nonce&&!r.id_token?(i.Log.error("ResponseValidator._processSigninParams: Expecting id_token in response"),Promise.reject(new Error("No id_token in response"))):!e.nonce&&r.id_token?(i.Log.error("ResponseValidator._processSigninParams: Not expecting id_token in response"),Promise.reject(new Error("Unexpected id_token in response"))):e.code_verifier&&!r.code?(i.Log.error("ResponseValidator._processSigninParams: Expecting code in response"),Promise.reject(new Error("No code in response"))):!e.code_verifier&&r.code?(i.Log.error("ResponseValidator._processSigninParams: Not expecting code in response"),Promise.reject(new Error("Unexpected code in response"))):(r.scope||(r.scope=e.scope),Promise.resolve(r))},t.prototype._processClaims=function t(e,r){var n=this;if(r.isOpenIdConnect){if(i.Log.debug("ResponseValidator._processClaims: response is OIDC, processing claims"),r.profile=this._filterProtocolClaims(r.profile),!0!==e.skipUserInfo&&this._settings.loadUserInfo&&r.access_token)return i.Log.debug("ResponseValidator._processClaims: loading user info"),this._userInfoService.getClaims(r.access_token).then((function(t){return i.Log.debug("ResponseValidator._processClaims: user info claims received from user info endpoint"),t.sub!==r.profile.sub?(i.Log.error("ResponseValidator._processClaims: sub from user info endpoint does not match sub in id_token"),Promise.reject(new Error("sub from user info endpoint does not match sub in id_token"))):(r.profile=n._mergeClaims(r.profile,t),i.Log.debug("ResponseValidator._processClaims: user info claims received, updated profile:",r.profile),r)}));i.Log.debug("ResponseValidator._processClaims: not loading user info")}else i.Log.debug("ResponseValidator._processClaims: response is not OIDC, not processing claims");return Promise.resolve(r)},t.prototype._mergeClaims=function t(e,r){var i=Object.assign({},e);for(var o in r){var s=r[o];Array.isArray(s)||(s=[s]);for(var a=0;a<s.length;a++){var u=s[a];i[o]?Array.isArray(i[o])?i[o].indexOf(u)<0&&i[o].push(u):i[o]!==u&&("object"===(void 0===u?"undefined":n(u))&&this._settings.mergeClaims?i[o]=this._mergeClaims(i[o],u):i[o]=[i[o],u]):i[o]=u}}return i},t.prototype._filterProtocolClaims=function t(e){i.Log.debug("ResponseValidator._filterProtocolClaims, incoming claims:",e);var r=Object.assign({},e);return this._settings._filterProtocolClaims?(l.forEach((function(t){delete r[t]})),i.Log.debug("ResponseValidator._filterProtocolClaims: protocol claims filtered",r)):i.Log.debug("ResponseValidator._filterProtocolClaims: protocol claims not filtered"),r},t.prototype._validateTokens=function t(e,r){return r.code?(i.Log.debug("ResponseValidator._validateTokens: Validating code"),this._processCode(e,r)):r.id_token?r.access_token?(i.Log.debug("ResponseValidator._validateTokens: Validating id_token and access_token"),this._validateIdTokenAndAccessToken(e,r)):(i.Log.debug("ResponseValidator._validateTokens: Validating id_token"),this._validateIdToken(e,r)):(i.Log.debug("ResponseValidator._validateTokens: No code to process or id_token to validate"),Promise.resolve(r))},t.prototype._processCode=function t(e,r){var o=this,s={client_id:e.client_id,client_secret:e.client_secret,code:r.code,redirect_uri:e.redirect_uri,code_verifier:e.code_verifier};return e.extraTokenParams&&"object"===n(e.extraTokenParams)&&Object.assign(s,e.extraTokenParams),this._tokenClient.exchangeCode(s).then((function(t){for(var n in t)r[n]=t[n];return r.id_token?(i.Log.debug("ResponseValidator._processCode: token response successful, processing id_token"),o._validateIdTokenAttributes(e,r)):(i.Log.debug("ResponseValidator._processCode: token response successful, returning response"),r)}))},t.prototype._validateIdTokenAttributes=function t(e,r){var n=this;return this._metadataService.getIssuer().then((function(t){var o=e.client_id,s=n._settings.clockSkew;return i.Log.debug("ResponseValidator._validateIdTokenAttributes: Validaing JWT attributes; using clock skew (in seconds) of: ",s),n._settings.getEpochTime().then((function(a){return n._joseUtil.validateJwtAttributes(r.id_token,t,o,s,a).then((function(t){return e.nonce&&e.nonce!==t.nonce?(i.Log.error("ResponseValidator._validateIdTokenAttributes: Invalid nonce in id_token"),Promise.reject(new Error("Invalid nonce in id_token"))):t.sub?(r.profile=t,r):(i.Log.error("ResponseValidator._validateIdTokenAttributes: No sub present in id_token"),Promise.reject(new Error("No sub present in id_token")))}))}))}))},t.prototype._validateIdTokenAndAccessToken=function t(e,r){var n=this;return this._validateIdToken(e,r).then((function(t){return n._validateAccessToken(t)}))},t.prototype._getSigningKeyForJwt=function t(e){var r=this;return this._metadataService.getSigningKeys().then((function(t){var n=e.header.kid;if(!t)return i.Log.error("ResponseValidator._validateIdToken: No signing keys from metadata"),Promise.reject(new Error("No signing keys from metadata"));i.Log.debug("ResponseValidator._validateIdToken: Received signing keys");var o=void 0;if(n)o=t.filter((function(t){return t.kid===n}))[0];else{if((t=r._filterByAlg(t,e.header.alg)).length>1)return i.Log.error("ResponseValidator._validateIdToken: No kid found in id_token and more than one key found in metadata"),Promise.reject(new Error("No kid found in id_token and more than one key found in metadata"));o=t[0]}return Promise.resolve(o)}))},t.prototype._getSigningKeyForJwtWithSingleRetry=function t(e){var r=this;return this._getSigningKeyForJwt(e).then((function(t){return t?Promise.resolve(t):(r._metadataService.resetSigningKeys(),r._getSigningKeyForJwt(e))}))},t.prototype._validateIdToken=function t(e,r){var n=this;if(!e.nonce)return i.Log.error("ResponseValidator._validateIdToken: No nonce on state"),Promise.reject(new Error("No nonce on state"));var o=this._joseUtil.parseJwt(r.id_token);return o&&o.header&&o.payload?e.nonce!==o.payload.nonce?(i.Log.error("ResponseValidator._validateIdToken: Invalid nonce in id_token"),Promise.reject(new Error("Invalid nonce in id_token"))):this._metadataService.getIssuer().then((function(t){return i.Log.debug("ResponseValidator._validateIdToken: Received issuer"),n._getSigningKeyForJwtWithSingleRetry(o).then((function(s){if(!s)return i.Log.error("ResponseValidator._validateIdToken: No key matching kid or alg found in signing keys"),Promise.reject(new Error("No key matching kid or alg found in signing keys"));var a=e.client_id,u=n._settings.clockSkew;return i.Log.debug("ResponseValidator._validateIdToken: Validaing JWT; using clock skew (in seconds) of: ",u),n._joseUtil.validateJwt(r.id_token,s,t,a,u).then((function(){return i.Log.debug("ResponseValidator._validateIdToken: JWT validation successful"),o.payload.sub?(r.profile=o.payload,r):(i.Log.error("ResponseValidator._validateIdToken: No sub present in id_token"),Promise.reject(new Error("No sub present in id_token")))}))}))})):(i.Log.error("ResponseValidator._validateIdToken: Failed to parse id_token",o),Promise.reject(new Error("Failed to parse id_token")))},t.prototype._filterByAlg=function t(e,r){var n=null;if(r.startsWith("RS"))n="RSA";else if(r.startsWith("PS"))n="PS";else{if(!r.startsWith("ES"))return i.Log.debug("ResponseValidator._filterByAlg: alg not supported: ",r),[];n="EC"}return i.Log.debug("ResponseValidator._filterByAlg: Looking for keys that match kty: ",n),e=e.filter((function(t){return t.kty===n})),i.Log.debug("ResponseValidator._filterByAlg: Number of keys that match kty: ",n,e.length),e},t.prototype._validateAccessToken=function t(e){if(!e.profile)return i.Log.error("ResponseValidator._validateAccessToken: No profile loaded from id_token"),Promise.reject(new Error("No profile loaded from id_token"));if(!e.profile.at_hash)return i.Log.error("ResponseValidator._validateAccessToken: No at_hash in id_token"),Promise.reject(new Error("No at_hash in id_token"));if(!e.id_token)return i.Log.error("ResponseValidator._validateAccessToken: No id_token"),Promise.reject(new Error("No id_token"));var r=this._joseUtil.parseJwt(e.id_token);if(!r||!r.header)return i.Log.error("ResponseValidator._validateAccessToken: Failed to parse id_token",r),Promise.reject(new Error("Failed to parse id_token"));var n=r.header.alg;if(!n||5!==n.length)return i.Log.error("ResponseValidator._validateAccessToken: Unsupported alg:",n),Promise.reject(new Error("Unsupported alg: "+n));var o=n.substr(2,3);if(!o)return i.Log.error("ResponseValidator._validateAccessToken: Unsupported alg:",n,o),Promise.reject(new Error("Unsupported alg: "+n));if(256!==(o=parseInt(o))&&384!==o&&512!==o)return i.Log.error("ResponseValidator._validateAccessToken: Unsupported alg:",n,o),Promise.reject(new Error("Unsupported alg: "+n));var s="sha"+o,a=this._joseUtil.hashString(e.access_token,s);if(!a)return i.Log.error("ResponseValidator._validateAccessToken: access_token hash failed:",s),Promise.reject(new Error("Failed to validate at_hash"));var u=a.substr(0,a.length/2),c=this._joseUtil.hexToBase64Url(u);return c!==e.profile.at_hash?(i.Log.error("ResponseValidator._validateAccessToken: Failed to validate at_hash",c,e.profile.at_hash),Promise.reject(new Error("Failed to validate at_hash"))):(i.Log.debug("ResponseValidator._validateAccessToken: success"),Promise.resolve(e))},t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.UserInfoService=void 0;var n=r(7),i=r(2),o=r(0),s=r(4);function a(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}e.UserInfoService=function(){function t(e){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:n.JsonService,u=arguments.length>2&&void 0!==arguments[2]?arguments[2]:i.MetadataService,c=arguments.length>3&&void 0!==arguments[3]?arguments[3]:s.JoseUtil;if(a(this,t),!e)throw o.Log.error("UserInfoService.ctor: No settings passed"),new Error("settings");this._settings=e,this._jsonService=new r(void 0,void 0,this._getClaimsFromJwt.bind(this)),this._metadataService=new u(this._settings),this._joseUtil=c}return t.prototype.getClaims=function t(e){var r=this;return e?this._metadataService.getUserInfoEndpoint().then((function(t){return o.Log.debug("UserInfoService.getClaims: received userinfo url",t),r._jsonService.getJson(t,e).then((function(t){return o.Log.debug("UserInfoService.getClaims: claims received",t),t}))})):(o.Log.error("UserInfoService.getClaims: No token passed"),Promise.reject(new Error("A token is required")))},t.prototype._getClaimsFromJwt=function t(e){var r=this;try{var n=this._joseUtil.parseJwt(e.responseText);if(!n||!n.header||!n.payload)return o.Log.error("UserInfoService._getClaimsFromJwt: Failed to parse JWT",n),Promise.reject(new Error("Failed to parse id_token"));var i=n.header.kid,s=void 0;switch(this._settings.userInfoJwtIssuer){case"OP":s=this._metadataService.getIssuer();break;case"ANY":s=Promise.resolve(n.payload.iss);break;default:s=Promise.resolve(this._settings.userInfoJwtIssuer)}return s.then((function(t){return o.Log.debug("UserInfoService._getClaimsFromJwt: Received issuer:"+t),r._metadataService.getSigningKeys().then((function(s){if(!s)return o.Log.error("UserInfoService._getClaimsFromJwt: No signing keys from metadata"),Promise.reject(new Error("No signing keys from metadata"));o.Log.debug("UserInfoService._getClaimsFromJwt: Received signing keys");var a=void 0;if(i)a=s.filter((function(t){return t.kid===i}))[0];else{if((s=r._filterByAlg(s,n.header.alg)).length>1)return o.Log.error("UserInfoService._getClaimsFromJwt: No kid found in id_token and more than one key found in metadata"),Promise.reject(new Error("No kid found in id_token and more than one key found in metadata"));a=s[0]}if(!a)return o.Log.error("UserInfoService._getClaimsFromJwt: No key matching kid or alg found in signing keys"),Promise.reject(new Error("No key matching kid or alg found in signing keys"));var u=r._settings.client_id,c=r._settings.clockSkew;return o.Log.debug("UserInfoService._getClaimsFromJwt: Validaing JWT; using clock skew (in seconds) of: ",c),r._joseUtil.validateJwt(e.responseText,a,t,u,c,void 0,!0).then((function(){return o.Log.debug("UserInfoService._getClaimsFromJwt: JWT validation successful"),n.payload}))}))}))}catch(t){return o.Log.error("UserInfoService._getClaimsFromJwt: Error parsing JWT response",t.message),void reject(t)}},t.prototype._filterByAlg=function t(e,r){var n=null;if(r.startsWith("RS"))n="RSA";else if(r.startsWith("PS"))n="PS";else{if(!r.startsWith("ES"))return o.Log.debug("UserInfoService._filterByAlg: alg not supported: ",r),[];n="EC"}return o.Log.debug("UserInfoService._filterByAlg: Looking for keys that match kty: ",n),e=e.filter((function(t){return t.kty===n})),o.Log.debug("UserInfoService._filterByAlg: Number of keys that match kty: ",n,e.length),e},t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.AllowedSigningAlgs=e.b64tohex=e.hextob64u=e.crypto=e.X509=e.KeyUtil=e.jws=void 0;var n=r(27);e.jws=n.jws,e.KeyUtil=n.KEYUTIL,e.X509=n.X509,e.crypto=n.crypto,e.hextob64u=n.hextob64u,e.b64tohex=n.b64tohex,e.AllowedSigningAlgs=["RS256","RS384","RS512","PS256","PS384","PS512","ES256","ES384","ES512"]},function(t,e,r){"use strict";(function(t){Object.defineProperty(e,"__esModule",{value:!0});var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},n={userAgent:!1},i={};
/*!
Copyright (c) 2011, Yahoo! Inc. All rights reserved.
Code licensed under the BSD License:
http://developer.yahoo.com/yui/license.html
version: 2.9.0
*/
if(void 0===o)var o={};o.lang={extend:function t(e,r,i){if(!r||!e)throw new Error("YAHOO.lang.extend failed, please check that all dependencies are included.");var o=function t(){};if(o.prototype=r.prototype,e.prototype=new o,e.prototype.constructor=e,e.superclass=r.prototype,r.prototype.constructor==Object.prototype.constructor&&(r.prototype.constructor=r),i){var s;for(s in i)e.prototype[s]=i[s];var a=function t(){},u=["toString","valueOf"];try{/MSIE/.test(n.userAgent)&&(a=function t(e,r){for(s=0;s<u.length;s+=1){var n=u[s],i=r[n];"function"==typeof i&&i!=Object.prototype[n]&&(e[n]=i)}})}catch(t){}a(e.prototype,i)}}};
/*! CryptoJS v3.1.2 core-fix.js
 * code.google.com/p/crypto-js
 * (c) 2009-2013 by Jeff Mott. All rights reserved.
 * code.google.com/p/crypto-js/wiki/License
 * THIS IS FIX of 'core.js' to fix Hmac issue.
 * https://code.google.com/p/crypto-js/issues/detail?id=84
 * https://crypto-js.googlecode.com/svn-history/r667/branches/3.x/src/core.js
 */
var s,a,u,c,h,l,f,g,d,p,v,y=y||(s=Math,u=(a={}).lib={},c=u.Base=function(){function t(){}return{extend:function e(r){t.prototype=this;var n=new t;return r&&n.mixIn(r),n.hasOwnProperty("init")||(n.init=function(){n.$super.init.apply(this,arguments)}),n.init.prototype=n,n.$super=this,n},create:function t(){var e=this.extend();return e.init.apply(e,arguments),e},init:function t(){},mixIn:function t(e){for(var r in e)e.hasOwnProperty(r)&&(this[r]=e[r]);e.hasOwnProperty("toString")&&(this.toString=e.toString)},clone:function t(){return this.init.prototype.extend(this)}}}(),h=u.WordArray=c.extend({init:function t(e,r){e=this.words=e||[],this.sigBytes=null!=r?r:4*e.length},toString:function t(e){return(e||f).stringify(this)},concat:function t(e){var r=this.words,n=e.words,i=this.sigBytes,o=e.sigBytes;if(this.clamp(),i%4)for(var s=0;s<o;s++){var a=n[s>>>2]>>>24-s%4*8&255;r[i+s>>>2]|=a<<24-(i+s)%4*8}else for(s=0;s<o;s+=4)r[i+s>>>2]=n[s>>>2];return this.sigBytes+=o,this},clamp:function t(){var e=this.words,r=this.sigBytes;e[r>>>2]&=4294967295<<32-r%4*8,e.length=s.ceil(r/4)},clone:function t(){var e=c.clone.call(this);return e.words=this.words.slice(0),e},random:function t(e){for(var r=[],n=0;n<e;n+=4)r.push(4294967296*s.random()|0);return new h.init(r,e)}}),l=a.enc={},f=l.Hex={stringify:function t(e){for(var r=e.words,n=e.sigBytes,i=[],o=0;o<n;o++){var s=r[o>>>2]>>>24-o%4*8&255;i.push((s>>>4).toString(16)),i.push((15&s).toString(16))}return i.join("")},parse:function t(e){for(var r=e.length,n=[],i=0;i<r;i+=2)n[i>>>3]|=parseInt(e.substr(i,2),16)<<24-i%8*4;return new h.init(n,r/2)}},g=l.Latin1={stringify:function t(e){for(var r=e.words,n=e.sigBytes,i=[],o=0;o<n;o++){var s=r[o>>>2]>>>24-o%4*8&255;i.push(String.fromCharCode(s))}return i.join("")},parse:function t(e){for(var r=e.length,n=[],i=0;i<r;i++)n[i>>>2]|=(255&e.charCodeAt(i))<<24-i%4*8;return new h.init(n,r)}},d=l.Utf8={stringify:function t(e){try{return decodeURIComponent(escape(g.stringify(e)))}catch(t){throw new Error("Malformed UTF-8 data")}},parse:function t(e){return g.parse(unescape(encodeURIComponent(e)))}},p=u.BufferedBlockAlgorithm=c.extend({reset:function t(){this._data=new h.init,this._nDataBytes=0},_append:function t(e){"string"==typeof e&&(e=d.parse(e)),this._data.concat(e),this._nDataBytes+=e.sigBytes},_process:function t(e){var r=this._data,n=r.words,i=r.sigBytes,o=this.blockSize,a=i/(4*o),u=(a=e?s.ceil(a):s.max((0|a)-this._minBufferSize,0))*o,c=s.min(4*u,i);if(u){for(var l=0;l<u;l+=o)this._doProcessBlock(n,l);var f=n.splice(0,u);r.sigBytes-=c}return new h.init(f,c)},clone:function t(){var e=c.clone.call(this);return e._data=this._data.clone(),e},_minBufferSize:0}),u.Hasher=p.extend({cfg:c.extend(),init:function t(e){this.cfg=this.cfg.extend(e),this.reset()},reset:function t(){p.reset.call(this),this._doReset()},update:function t(e){return this._append(e),this._process(),this},finalize:function t(e){return e&&this._append(e),this._doFinalize()},blockSize:16,_createHelper:function t(e){return function(t,r){return new e.init(r).finalize(t)}},_createHmacHelper:function t(e){return function(t,r){return new v.HMAC.init(e,r).finalize(t)}}}),v=a.algo={},a);!function(t){var e,r=(e=y).lib,n=r.Base,i=r.WordArray;(e=e.x64={}).Word=n.extend({init:function t(e,r){this.high=e,this.low=r}}),e.WordArray=n.extend({init:function t(e,r){e=this.words=e||[],this.sigBytes=null!=r?r:8*e.length},toX32:function t(){for(var e=this.words,r=e.length,n=[],o=0;o<r;o++){var s=e[o];n.push(s.high),n.push(s.low)}return i.create(n,this.sigBytes)},clone:function t(){for(var e=n.clone.call(this),r=e.words=this.words.slice(0),i=r.length,o=0;o<i;o++)r[o]=r[o].clone();return e}})}(),function(){var t=y,e=t.lib.WordArray;t.enc.Base64={stringify:function t(e){var r=e.words,n=e.sigBytes,i=this._map;e.clamp(),e=[];for(var o=0;o<n;o+=3)for(var s=(r[o>>>2]>>>24-o%4*8&255)<<16|(r[o+1>>>2]>>>24-(o+1)%4*8&255)<<8|r[o+2>>>2]>>>24-(o+2)%4*8&255,a=0;4>a&&o+.75*a<n;a++)e.push(i.charAt(s>>>6*(3-a)&63));if(r=i.charAt(64))for(;e.length%4;)e.push(r);return e.join("")},parse:function t(r){var n=r.length,i=this._map;(o=i.charAt(64))&&(-1!=(o=r.indexOf(o))&&(n=o));for(var o=[],s=0,a=0;a<n;a++)if(a%4){var u=i.indexOf(r.charAt(a-1))<<a%4*2,c=i.indexOf(r.charAt(a))>>>6-a%4*2;o[s>>>2]|=(u|c)<<24-s%4*8,s++}return e.create(o,s)},_map:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="}}(),function(t){for(var e=y,r=(i=e.lib).WordArray,n=i.Hasher,i=e.algo,o=[],s=[],a=function t(e){return 4294967296*(e-(0|e))|0},u=2,c=0;64>c;){var h;t:{h=u;for(var l=t.sqrt(h),f=2;f<=l;f++)if(!(h%f)){h=!1;break t}h=!0}h&&(8>c&&(o[c]=a(t.pow(u,.5))),s[c]=a(t.pow(u,1/3)),c++),u++}var g=[];i=i.SHA256=n.extend({_doReset:function t(){this._hash=new r.init(o.slice(0))},_doProcessBlock:function t(e,r){for(var n=this._hash.words,i=n[0],o=n[1],a=n[2],u=n[3],c=n[4],h=n[5],l=n[6],f=n[7],d=0;64>d;d++){if(16>d)g[d]=0|e[r+d];else{var p=g[d-15],v=g[d-2];g[d]=((p<<25|p>>>7)^(p<<14|p>>>18)^p>>>3)+g[d-7]+((v<<15|v>>>17)^(v<<13|v>>>19)^v>>>10)+g[d-16]}p=f+((c<<26|c>>>6)^(c<<21|c>>>11)^(c<<7|c>>>25))+(c&h^~c&l)+s[d]+g[d],v=((i<<30|i>>>2)^(i<<19|i>>>13)^(i<<10|i>>>22))+(i&o^i&a^o&a),f=l,l=h,h=c,c=u+p|0,u=a,a=o,o=i,i=p+v|0}n[0]=n[0]+i|0,n[1]=n[1]+o|0,n[2]=n[2]+a|0,n[3]=n[3]+u|0,n[4]=n[4]+c|0,n[5]=n[5]+h|0,n[6]=n[6]+l|0,n[7]=n[7]+f|0},_doFinalize:function e(){var r=this._data,n=r.words,i=8*this._nDataBytes,o=8*r.sigBytes;return n[o>>>5]|=128<<24-o%32,n[14+(o+64>>>9<<4)]=t.floor(i/4294967296),n[15+(o+64>>>9<<4)]=i,r.sigBytes=4*n.length,this._process(),this._hash},clone:function t(){var e=n.clone.call(this);return e._hash=this._hash.clone(),e}});e.SHA256=n._createHelper(i),e.HmacSHA256=n._createHmacHelper(i)}(Math),function(){function t(){return n.create.apply(n,arguments)}for(var e=y,r=e.lib.Hasher,n=(o=e.x64).Word,i=o.WordArray,o=e.algo,s=[t(1116352408,3609767458),t(1899447441,602891725),t(3049323471,3964484399),t(3921009573,2173295548),t(961987163,4081628472),t(1508970993,3053834265),t(2453635748,2937671579),t(2870763221,3664609560),t(3624381080,2734883394),t(310598401,1164996542),t(607225278,1323610764),t(1426881987,3590304994),t(1925078388,4068182383),t(2162078206,991336113),t(2614888103,633803317),t(3248222580,3479774868),t(3835390401,2666613458),t(4022224774,944711139),t(264347078,2341262773),t(604807628,2007800933),t(770255983,1495990901),t(1249150122,1856431235),t(1555081692,3175218132),t(1996064986,2198950837),t(2554220882,3999719339),t(2821834349,766784016),t(2952996808,2566594879),t(3210313671,3203337956),t(3336571891,1034457026),t(3584528711,2466948901),t(113926993,3758326383),t(338241895,168717936),t(666307205,1188179964),t(773529912,1546045734),t(1294757372,1522805485),t(1396182291,2643833823),t(1695183700,2343527390),t(1986661051,1014477480),t(2177026350,1206759142),t(2456956037,344077627),t(2730485921,1290863460),t(2820302411,3158454273),t(3259730800,3505952657),t(3345764771,106217008),t(3516065817,3606008344),t(3600352804,1432725776),t(4094571909,1467031594),t(275423344,851169720),t(430227734,3100823752),t(506948616,1363258195),t(659060556,3750685593),t(883997877,3785050280),t(958139571,3318307427),t(1322822218,3812723403),t(1537002063,2003034995),t(1747873779,3602036899),t(1955562222,1575990012),t(2024104815,1125592928),t(2227730452,2716904306),t(2361852424,442776044),t(2428436474,593698344),t(2756734187,3733110249),t(3204031479,2999351573),t(3329325298,3815920427),t(3391569614,3928383900),t(3515267271,566280711),t(3940187606,3454069534),t(4118630271,4000239992),t(116418474,1914138554),t(174292421,2731055270),t(289380356,3203993006),t(460393269,320620315),t(685471733,587496836),t(852142971,1086792851),t(1017036298,365543100),t(1126000580,2618297676),t(1288033470,3409855158),t(1501505948,4234509866),t(1607167915,987167468),t(1816402316,1246189591)],a=[],u=0;80>u;u++)a[u]=t();o=o.SHA512=r.extend({_doReset:function t(){this._hash=new i.init([new n.init(1779033703,4089235720),new n.init(3144134277,2227873595),new n.init(1013904242,4271175723),new n.init(2773480762,1595750129),new n.init(1359893119,2917565137),new n.init(2600822924,725511199),new n.init(528734635,4215389547),new n.init(1541459225,327033209)])},_doProcessBlock:function t(e,r){for(var n=(f=this._hash.words)[0],i=f[1],o=f[2],u=f[3],c=f[4],h=f[5],l=f[6],f=f[7],g=n.high,d=n.low,p=i.high,v=i.low,y=o.high,m=o.low,_=u.high,S=u.low,b=c.high,w=c.low,F=h.high,E=h.low,x=l.high,A=l.low,k=f.high,P=f.low,C=g,T=d,R=p,I=v,D=y,L=m,N=_,U=S,B=b,O=w,j=F,M=E,H=x,V=A,K=k,q=P,J=0;80>J;J++){var W=a[J];if(16>J)var z=W.high=0|e[r+2*J],Y=W.low=0|e[r+2*J+1];else{z=((Y=(z=a[J-15]).high)>>>1|(G=z.low)<<31)^(Y>>>8|G<<24)^Y>>>7;var G=(G>>>1|Y<<31)^(G>>>8|Y<<24)^(G>>>7|Y<<25),X=((Y=(X=a[J-2]).high)>>>19|($=X.low)<<13)^(Y<<3|$>>>29)^Y>>>6,$=($>>>19|Y<<13)^($<<3|Y>>>29)^($>>>6|Y<<26),Q=(Y=a[J-7]).high,Z=(tt=a[J-16]).high,tt=tt.low;z=(z=(z=z+Q+((Y=G+Y.low)>>>0<G>>>0?1:0))+X+((Y=Y+$)>>>0<$>>>0?1:0))+Z+((Y=Y+tt)>>>0<tt>>>0?1:0);W.high=z,W.low=Y}Q=B&j^~B&H,tt=O&M^~O&V,W=C&R^C&D^R&D;var et=T&I^T&L^I&L,rt=(G=(C>>>28|T<<4)^(C<<30|T>>>2)^(C<<25|T>>>7),X=(T>>>28|C<<4)^(T<<30|C>>>2)^(T<<25|C>>>7),($=s[J]).high),nt=$.low;Z=K+((B>>>14|O<<18)^(B>>>18|O<<14)^(B<<23|O>>>9))+(($=q+((O>>>14|B<<18)^(O>>>18|B<<14)^(O<<23|B>>>9)))>>>0<q>>>0?1:0),K=H,q=V,H=j,V=M,j=B,M=O,B=N+(Z=(Z=(Z=Z+Q+(($=$+tt)>>>0<tt>>>0?1:0))+rt+(($=$+nt)>>>0<nt>>>0?1:0))+z+(($=$+Y)>>>0<Y>>>0?1:0))+((O=U+$|0)>>>0<U>>>0?1:0)|0,N=D,U=L,D=R,L=I,R=C,I=T,C=Z+(W=G+W+((Y=X+et)>>>0<X>>>0?1:0))+((T=$+Y|0)>>>0<$>>>0?1:0)|0}d=n.low=d+T,n.high=g+C+(d>>>0<T>>>0?1:0),v=i.low=v+I,i.high=p+R+(v>>>0<I>>>0?1:0),m=o.low=m+L,o.high=y+D+(m>>>0<L>>>0?1:0),S=u.low=S+U,u.high=_+N+(S>>>0<U>>>0?1:0),w=c.low=w+O,c.high=b+B+(w>>>0<O>>>0?1:0),E=h.low=E+M,h.high=F+j+(E>>>0<M>>>0?1:0),A=l.low=A+V,l.high=x+H+(A>>>0<V>>>0?1:0),P=f.low=P+q,f.high=k+K+(P>>>0<q>>>0?1:0)},_doFinalize:function t(){var e=this._data,r=e.words,n=8*this._nDataBytes,i=8*e.sigBytes;return r[i>>>5]|=128<<24-i%32,r[30+(i+128>>>10<<5)]=Math.floor(n/4294967296),r[31+(i+128>>>10<<5)]=n,e.sigBytes=4*r.length,this._process(),this._hash.toX32()},clone:function t(){var e=r.clone.call(this);return e._hash=this._hash.clone(),e},blockSize:32}),e.SHA512=r._createHelper(o),e.HmacSHA512=r._createHmacHelper(o)}(),function(){var t=y,e=(i=t.x64).Word,r=i.WordArray,n=(i=t.algo).SHA512,i=i.SHA384=n.extend({_doReset:function t(){this._hash=new r.init([new e.init(3418070365,3238371032),new e.init(1654270250,914150663),new e.init(2438529370,812702999),new e.init(355462360,4144912697),new e.init(1731405415,4290775857),new e.init(2394180231,1750603025),new e.init(3675008525,1694076839),new e.init(1203062813,3204075428)])},_doFinalize:function t(){var e=n._doFinalize.call(this);return e.sigBytes-=16,e}});t.SHA384=n._createHelper(i),t.HmacSHA384=n._createHmacHelper(i)}();
/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
 */
var m,_="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";function S(t){var e,r,n="";for(e=0;e+3<=t.length;e+=3)r=parseInt(t.substring(e,e+3),16),n+=_.charAt(r>>6)+_.charAt(63&r);for(e+1==t.length?(r=parseInt(t.substring(e,e+1),16),n+=_.charAt(r<<2)):e+2==t.length&&(r=parseInt(t.substring(e,e+2),16),n+=_.charAt(r>>2)+_.charAt((3&r)<<4)),"=";(3&n.length)>0;)n+="=";return n}function b(t){var e,r,n,i="",o=0;for(e=0;e<t.length&&"="!=t.charAt(e);++e)(n=_.indexOf(t.charAt(e)))<0||(0==o?(i+=R(n>>2),r=3&n,o=1):1==o?(i+=R(r<<2|n>>4),r=15&n,o=2):2==o?(i+=R(r),i+=R(n>>2),r=3&n,o=3):(i+=R(r<<2|n>>4),i+=R(15&n),o=0));return 1==o&&(i+=R(r<<2)),i}function w(t){var e,r=b(t),n=new Array;for(e=0;2*e<r.length;++e)n[e]=parseInt(r.substring(2*e,2*e+2),16);return n}function F(t,e,r){null!=t&&("number"==typeof t?this.fromNumber(t,e,r):null==e&&"string"!=typeof t?this.fromString(t,256):this.fromString(t,e))}function E(){return new F(null)}"Microsoft Internet Explorer"==n.appName?(F.prototype.am=function x(t,e,r,n,i,o){for(var s=32767&e,a=e>>15;--o>=0;){var u=32767&this[t],c=this[t++]>>15,h=a*u+c*s;i=((u=s*u+((32767&h)<<15)+r[n]+(1073741823&i))>>>30)+(h>>>15)+a*c+(i>>>30),r[n++]=1073741823&u}return i},m=30):"Netscape"!=n.appName?(F.prototype.am=function A(t,e,r,n,i,o){for(;--o>=0;){var s=e*this[t++]+r[n]+i;i=Math.floor(s/67108864),r[n++]=67108863&s}return i},m=26):(F.prototype.am=function k(t,e,r,n,i,o){for(var s=16383&e,a=e>>14;--o>=0;){var u=16383&this[t],c=this[t++]>>14,h=a*u+c*s;i=((u=s*u+((16383&h)<<14)+r[n]+i)>>28)+(h>>14)+a*c,r[n++]=268435455&u}return i},m=28),F.prototype.DB=m,F.prototype.DM=(1<<m)-1,F.prototype.DV=1<<m;F.prototype.FV=Math.pow(2,52),F.prototype.F1=52-m,F.prototype.F2=2*m-52;var P,C,T=new Array;for(P="0".charCodeAt(0),C=0;C<=9;++C)T[P++]=C;for(P="a".charCodeAt(0),C=10;C<36;++C)T[P++]=C;for(P="A".charCodeAt(0),C=10;C<36;++C)T[P++]=C;function R(t){return"0123456789abcdefghijklmnopqrstuvwxyz".charAt(t)}function I(t,e){var r=T[t.charCodeAt(e)];return null==r?-1:r}function D(t){var e=E();return e.fromInt(t),e}function L(t){var e,r=1;return 0!=(e=t>>>16)&&(t=e,r+=16),0!=(e=t>>8)&&(t=e,r+=8),0!=(e=t>>4)&&(t=e,r+=4),0!=(e=t>>2)&&(t=e,r+=2),0!=(e=t>>1)&&(t=e,r+=1),r}function N(t){this.m=t}function U(t){this.m=t,this.mp=t.invDigit(),this.mpl=32767&this.mp,this.mph=this.mp>>15,this.um=(1<<t.DB-15)-1,this.mt2=2*t.t}function B(t,e){return t&e}function O(t,e){return t|e}function j(t,e){return t^e}function M(t,e){return t&~e}function H(t){if(0==t)return-1;var e=0;return 0==(65535&t)&&(t>>=16,e+=16),0==(255&t)&&(t>>=8,e+=8),0==(15&t)&&(t>>=4,e+=4),0==(3&t)&&(t>>=2,e+=2),0==(1&t)&&++e,e}function V(t){for(var e=0;0!=t;)t&=t-1,++e;return e}function K(){}function q(t){return t}function J(t){this.r2=E(),this.q3=E(),F.ONE.dlShiftTo(2*t.t,this.r2),this.mu=this.r2.divide(t),this.m=t}N.prototype.convert=function W(t){return t.s<0||t.compareTo(this.m)>=0?t.mod(this.m):t},N.prototype.revert=function z(t){return t},N.prototype.reduce=function Y(t){t.divRemTo(this.m,null,t)},N.prototype.mulTo=function G(t,e,r){t.multiplyTo(e,r),this.reduce(r)},N.prototype.sqrTo=function X(t,e){t.squareTo(e),this.reduce(e)},U.prototype.convert=function $(t){var e=E();return t.abs().dlShiftTo(this.m.t,e),e.divRemTo(this.m,null,e),t.s<0&&e.compareTo(F.ZERO)>0&&this.m.subTo(e,e),e},U.prototype.revert=function Q(t){var e=E();return t.copyTo(e),this.reduce(e),e},U.prototype.reduce=function Z(t){for(;t.t<=this.mt2;)t[t.t++]=0;for(var e=0;e<this.m.t;++e){var r=32767&t[e],n=r*this.mpl+((r*this.mph+(t[e]>>15)*this.mpl&this.um)<<15)&t.DM;for(t[r=e+this.m.t]+=this.m.am(0,n,t,e,0,this.m.t);t[r]>=t.DV;)t[r]-=t.DV,t[++r]++}t.clamp(),t.drShiftTo(this.m.t,t),t.compareTo(this.m)>=0&&t.subTo(this.m,t)},U.prototype.mulTo=function tt(t,e,r){t.multiplyTo(e,r),this.reduce(r)},U.prototype.sqrTo=function et(t,e){t.squareTo(e),this.reduce(e)},F.prototype.copyTo=function rt(t){for(var e=this.t-1;e>=0;--e)t[e]=this[e];t.t=this.t,t.s=this.s},F.prototype.fromInt=function nt(t){this.t=1,this.s=t<0?-1:0,t>0?this[0]=t:t<-1?this[0]=t+this.DV:this.t=0},F.prototype.fromString=function it(t,e){var r;if(16==e)r=4;else if(8==e)r=3;else if(256==e)r=8;else if(2==e)r=1;else if(32==e)r=5;else{if(4!=e)return void this.fromRadix(t,e);r=2}this.t=0,this.s=0;for(var n=t.length,i=!1,o=0;--n>=0;){var s=8==r?255&t[n]:I(t,n);s<0?"-"==t.charAt(n)&&(i=!0):(i=!1,0==o?this[this.t++]=s:o+r>this.DB?(this[this.t-1]|=(s&(1<<this.DB-o)-1)<<o,this[this.t++]=s>>this.DB-o):this[this.t-1]|=s<<o,(o+=r)>=this.DB&&(o-=this.DB))}8==r&&0!=(128&t[0])&&(this.s=-1,o>0&&(this[this.t-1]|=(1<<this.DB-o)-1<<o)),this.clamp(),i&&F.ZERO.subTo(this,this)},F.prototype.clamp=function ot(){for(var t=this.s&this.DM;this.t>0&&this[this.t-1]==t;)--this.t},F.prototype.dlShiftTo=function st(t,e){var r;for(r=this.t-1;r>=0;--r)e[r+t]=this[r];for(r=t-1;r>=0;--r)e[r]=0;e.t=this.t+t,e.s=this.s},F.prototype.drShiftTo=function at(t,e){for(var r=t;r<this.t;++r)e[r-t]=this[r];e.t=Math.max(this.t-t,0),e.s=this.s},F.prototype.lShiftTo=function ut(t,e){var r,n=t%this.DB,i=this.DB-n,o=(1<<i)-1,s=Math.floor(t/this.DB),a=this.s<<n&this.DM;for(r=this.t-1;r>=0;--r)e[r+s+1]=this[r]>>i|a,a=(this[r]&o)<<n;for(r=s-1;r>=0;--r)e[r]=0;e[s]=a,e.t=this.t+s+1,e.s=this.s,e.clamp()},F.prototype.rShiftTo=function ct(t,e){e.s=this.s;var r=Math.floor(t/this.DB);if(r>=this.t)e.t=0;else{var n=t%this.DB,i=this.DB-n,o=(1<<n)-1;e[0]=this[r]>>n;for(var s=r+1;s<this.t;++s)e[s-r-1]|=(this[s]&o)<<i,e[s-r]=this[s]>>n;n>0&&(e[this.t-r-1]|=(this.s&o)<<i),e.t=this.t-r,e.clamp()}},F.prototype.subTo=function ht(t,e){for(var r=0,n=0,i=Math.min(t.t,this.t);r<i;)n+=this[r]-t[r],e[r++]=n&this.DM,n>>=this.DB;if(t.t<this.t){for(n-=t.s;r<this.t;)n+=this[r],e[r++]=n&this.DM,n>>=this.DB;n+=this.s}else{for(n+=this.s;r<t.t;)n-=t[r],e[r++]=n&this.DM,n>>=this.DB;n-=t.s}e.s=n<0?-1:0,n<-1?e[r++]=this.DV+n:n>0&&(e[r++]=n),e.t=r,e.clamp()},F.prototype.multiplyTo=function lt(t,e){var r=this.abs(),n=t.abs(),i=r.t;for(e.t=i+n.t;--i>=0;)e[i]=0;for(i=0;i<n.t;++i)e[i+r.t]=r.am(0,n[i],e,i,0,r.t);e.s=0,e.clamp(),this.s!=t.s&&F.ZERO.subTo(e,e)},F.prototype.squareTo=function ft(t){for(var e=this.abs(),r=t.t=2*e.t;--r>=0;)t[r]=0;for(r=0;r<e.t-1;++r){var n=e.am(r,e[r],t,2*r,0,1);(t[r+e.t]+=e.am(r+1,2*e[r],t,2*r+1,n,e.t-r-1))>=e.DV&&(t[r+e.t]-=e.DV,t[r+e.t+1]=1)}t.t>0&&(t[t.t-1]+=e.am(r,e[r],t,2*r,0,1)),t.s=0,t.clamp()},F.prototype.divRemTo=function gt(t,e,r){var n=t.abs();if(!(n.t<=0)){var i=this.abs();if(i.t<n.t)return null!=e&&e.fromInt(0),void(null!=r&&this.copyTo(r));null==r&&(r=E());var o=E(),s=this.s,a=t.s,u=this.DB-L(n[n.t-1]);u>0?(n.lShiftTo(u,o),i.lShiftTo(u,r)):(n.copyTo(o),i.copyTo(r));var c=o.t,h=o[c-1];if(0!=h){var l=h*(1<<this.F1)+(c>1?o[c-2]>>this.F2:0),f=this.FV/l,g=(1<<this.F1)/l,d=1<<this.F2,p=r.t,v=p-c,y=null==e?E():e;for(o.dlShiftTo(v,y),r.compareTo(y)>=0&&(r[r.t++]=1,r.subTo(y,r)),F.ONE.dlShiftTo(c,y),y.subTo(o,o);o.t<c;)o[o.t++]=0;for(;--v>=0;){var m=r[--p]==h?this.DM:Math.floor(r[p]*f+(r[p-1]+d)*g);if((r[p]+=o.am(0,m,r,v,0,c))<m)for(o.dlShiftTo(v,y),r.subTo(y,r);r[p]<--m;)r.subTo(y,r)}null!=e&&(r.drShiftTo(c,e),s!=a&&F.ZERO.subTo(e,e)),r.t=c,r.clamp(),u>0&&r.rShiftTo(u,r),s<0&&F.ZERO.subTo(r,r)}}},F.prototype.invDigit=function dt(){if(this.t<1)return 0;var t=this[0];if(0==(1&t))return 0;var e=3&t;return(e=(e=(e=(e=e*(2-(15&t)*e)&15)*(2-(255&t)*e)&255)*(2-((65535&t)*e&65535))&65535)*(2-t*e%this.DV)%this.DV)>0?this.DV-e:-e},F.prototype.isEven=function pt(){return 0==(this.t>0?1&this[0]:this.s)},F.prototype.exp=function vt(t,e){if(t>4294967295||t<1)return F.ONE;var r=E(),n=E(),i=e.convert(this),o=L(t)-1;for(i.copyTo(r);--o>=0;)if(e.sqrTo(r,n),(t&1<<o)>0)e.mulTo(n,i,r);else{var s=r;r=n,n=s}return e.revert(r)},F.prototype.toString=function yt(t){if(this.s<0)return"-"+this.negate().toString(t);var e;if(16==t)e=4;else if(8==t)e=3;else if(2==t)e=1;else if(32==t)e=5;else{if(4!=t)return this.toRadix(t);e=2}var r,n=(1<<e)-1,i=!1,o="",s=this.t,a=this.DB-s*this.DB%e;if(s-- >0)for(a<this.DB&&(r=this[s]>>a)>0&&(i=!0,o=R(r));s>=0;)a<e?(r=(this[s]&(1<<a)-1)<<e-a,r|=this[--s]>>(a+=this.DB-e)):(r=this[s]>>(a-=e)&n,a<=0&&(a+=this.DB,--s)),r>0&&(i=!0),i&&(o+=R(r));return i?o:"0"},F.prototype.negate=function mt(){var t=E();return F.ZERO.subTo(this,t),t},F.prototype.abs=function _t(){return this.s<0?this.negate():this},F.prototype.compareTo=function St(t){var e=this.s-t.s;if(0!=e)return e;var r=this.t;if(0!=(e=r-t.t))return this.s<0?-e:e;for(;--r>=0;)if(0!=(e=this[r]-t[r]))return e;return 0},F.prototype.bitLength=function bt(){return this.t<=0?0:this.DB*(this.t-1)+L(this[this.t-1]^this.s&this.DM)},F.prototype.mod=function wt(t){var e=E();return this.abs().divRemTo(t,null,e),this.s<0&&e.compareTo(F.ZERO)>0&&t.subTo(e,e),e},F.prototype.modPowInt=function Ft(t,e){var r;return r=t<256||e.isEven()?new N(e):new U(e),this.exp(t,r)},F.ZERO=D(0),F.ONE=D(1),K.prototype.convert=q,K.prototype.revert=q,K.prototype.mulTo=function Et(t,e,r){t.multiplyTo(e,r)},K.prototype.sqrTo=function xt(t,e){t.squareTo(e)},J.prototype.convert=function At(t){if(t.s<0||t.t>2*this.m.t)return t.mod(this.m);if(t.compareTo(this.m)<0)return t;var e=E();return t.copyTo(e),this.reduce(e),e},J.prototype.revert=function kt(t){return t},J.prototype.reduce=function Pt(t){for(t.drShiftTo(this.m.t-1,this.r2),t.t>this.m.t+1&&(t.t=this.m.t+1,t.clamp()),this.mu.multiplyUpperTo(this.r2,this.m.t+1,this.q3),this.m.multiplyLowerTo(this.q3,this.m.t+1,this.r2);t.compareTo(this.r2)<0;)t.dAddOffset(1,this.m.t+1);for(t.subTo(this.r2,t);t.compareTo(this.m)>=0;)t.subTo(this.m,t)},J.prototype.mulTo=function Ct(t,e,r){t.multiplyTo(e,r),this.reduce(r)},J.prototype.sqrTo=function Tt(t,e){t.squareTo(e),this.reduce(e)};var Rt=[2,3,5,7,11,13,17,19,23,29,31,37,41,43,47,53,59,61,67,71,73,79,83,89,97,101,103,107,109,113,127,131,137,139,149,151,157,163,167,173,179,181,191,193,197,199,211,223,227,229,233,239,241,251,257,263,269,271,277,281,283,293,307,311,313,317,331,337,347,349,353,359,367,373,379,383,389,397,401,409,419,421,431,433,439,443,449,457,461,463,467,479,487,491,499,503,509,521,523,541,547,557,563,569,571,577,587,593,599,601,607,613,617,619,631,641,643,647,653,659,661,673,677,683,691,701,709,719,727,733,739,743,751,757,761,769,773,787,797,809,811,821,823,827,829,839,853,857,859,863,877,881,883,887,907,911,919,929,937,941,947,953,967,971,977,983,991,997],It=(1<<26)/Rt[Rt.length-1];
/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
 */
function Dt(){this.i=0,this.j=0,this.S=new Array}F.prototype.chunkSize=function Lt(t){return Math.floor(Math.LN2*this.DB/Math.log(t))},F.prototype.toRadix=function Nt(t){if(null==t&&(t=10),0==this.signum()||t<2||t>36)return"0";var e=this.chunkSize(t),r=Math.pow(t,e),n=D(r),i=E(),o=E(),s="";for(this.divRemTo(n,i,o);i.signum()>0;)s=(r+o.intValue()).toString(t).substr(1)+s,i.divRemTo(n,i,o);return o.intValue().toString(t)+s},F.prototype.fromRadix=function Ut(t,e){this.fromInt(0),null==e&&(e=10);for(var r=this.chunkSize(e),n=Math.pow(e,r),i=!1,o=0,s=0,a=0;a<t.length;++a){var u=I(t,a);u<0?"-"==t.charAt(a)&&0==this.signum()&&(i=!0):(s=e*s+u,++o>=r&&(this.dMultiply(n),this.dAddOffset(s,0),o=0,s=0))}o>0&&(this.dMultiply(Math.pow(e,o)),this.dAddOffset(s,0)),i&&F.ZERO.subTo(this,this)},F.prototype.fromNumber=function Bt(t,e,r){if("number"==typeof e)if(t<2)this.fromInt(1);else for(this.fromNumber(t,r),this.testBit(t-1)||this.bitwiseTo(F.ONE.shiftLeft(t-1),O,this),this.isEven()&&this.dAddOffset(1,0);!this.isProbablePrime(e);)this.dAddOffset(2,0),this.bitLength()>t&&this.subTo(F.ONE.shiftLeft(t-1),this);else{var n=new Array,i=7&t;n.length=1+(t>>3),e.nextBytes(n),i>0?n[0]&=(1<<i)-1:n[0]=0,this.fromString(n,256)}},F.prototype.bitwiseTo=function Ot(t,e,r){var n,i,o=Math.min(t.t,this.t);for(n=0;n<o;++n)r[n]=e(this[n],t[n]);if(t.t<this.t){for(i=t.s&this.DM,n=o;n<this.t;++n)r[n]=e(this[n],i);r.t=this.t}else{for(i=this.s&this.DM,n=o;n<t.t;++n)r[n]=e(i,t[n]);r.t=t.t}r.s=e(this.s,t.s),r.clamp()},F.prototype.changeBit=function jt(t,e){var r=F.ONE.shiftLeft(t);return this.bitwiseTo(r,e,r),r},F.prototype.addTo=function Mt(t,e){for(var r=0,n=0,i=Math.min(t.t,this.t);r<i;)n+=this[r]+t[r],e[r++]=n&this.DM,n>>=this.DB;if(t.t<this.t){for(n+=t.s;r<this.t;)n+=this[r],e[r++]=n&this.DM,n>>=this.DB;n+=this.s}else{for(n+=this.s;r<t.t;)n+=t[r],e[r++]=n&this.DM,n>>=this.DB;n+=t.s}e.s=n<0?-1:0,n>0?e[r++]=n:n<-1&&(e[r++]=this.DV+n),e.t=r,e.clamp()},F.prototype.dMultiply=function Ht(t){this[this.t]=this.am(0,t-1,this,0,0,this.t),++this.t,this.clamp()},F.prototype.dAddOffset=function Vt(t,e){if(0!=t){for(;this.t<=e;)this[this.t++]=0;for(this[e]+=t;this[e]>=this.DV;)this[e]-=this.DV,++e>=this.t&&(this[this.t++]=0),++this[e]}},F.prototype.multiplyLowerTo=function Kt(t,e,r){var n,i=Math.min(this.t+t.t,e);for(r.s=0,r.t=i;i>0;)r[--i]=0;for(n=r.t-this.t;i<n;++i)r[i+this.t]=this.am(0,t[i],r,i,0,this.t);for(n=Math.min(t.t,e);i<n;++i)this.am(0,t[i],r,i,0,e-i);r.clamp()},F.prototype.multiplyUpperTo=function qt(t,e,r){--e;var n=r.t=this.t+t.t-e;for(r.s=0;--n>=0;)r[n]=0;for(n=Math.max(e-this.t,0);n<t.t;++n)r[this.t+n-e]=this.am(e-n,t[n],r,0,0,this.t+n-e);r.clamp(),r.drShiftTo(1,r)},F.prototype.modInt=function Jt(t){if(t<=0)return 0;var e=this.DV%t,r=this.s<0?t-1:0;if(this.t>0)if(0==e)r=this[0]%t;else for(var n=this.t-1;n>=0;--n)r=(e*r+this[n])%t;return r},F.prototype.millerRabin=function Wt(t){var e=this.subtract(F.ONE),r=e.getLowestSetBit();if(r<=0)return!1;var n=e.shiftRight(r);(t=t+1>>1)>Rt.length&&(t=Rt.length);for(var i=E(),o=0;o<t;++o){i.fromInt(Rt[Math.floor(Math.random()*Rt.length)]);var s=i.modPow(n,this);if(0!=s.compareTo(F.ONE)&&0!=s.compareTo(e)){for(var a=1;a++<r&&0!=s.compareTo(e);)if(0==(s=s.modPowInt(2,this)).compareTo(F.ONE))return!1;if(0!=s.compareTo(e))return!1}}return!0},F.prototype.clone=
/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
 */
function zt(){var t=E();return this.copyTo(t),t},F.prototype.intValue=function Yt(){if(this.s<0){if(1==this.t)return this[0]-this.DV;if(0==this.t)return-1}else{if(1==this.t)return this[0];if(0==this.t)return 0}return(this[1]&(1<<32-this.DB)-1)<<this.DB|this[0]},F.prototype.byteValue=function Gt(){return 0==this.t?this.s:this[0]<<24>>24},F.prototype.shortValue=function Xt(){return 0==this.t?this.s:this[0]<<16>>16},F.prototype.signum=function $t(){return this.s<0?-1:this.t<=0||1==this.t&&this[0]<=0?0:1},F.prototype.toByteArray=function Qt(){var t=this.t,e=new Array;e[0]=this.s;var r,n=this.DB-t*this.DB%8,i=0;if(t-- >0)for(n<this.DB&&(r=this[t]>>n)!=(this.s&this.DM)>>n&&(e[i++]=r|this.s<<this.DB-n);t>=0;)n<8?(r=(this[t]&(1<<n)-1)<<8-n,r|=this[--t]>>(n+=this.DB-8)):(r=this[t]>>(n-=8)&255,n<=0&&(n+=this.DB,--t)),0!=(128&r)&&(r|=-256),0==i&&(128&this.s)!=(128&r)&&++i,(i>0||r!=this.s)&&(e[i++]=r);return e},F.prototype.equals=function Zt(t){return 0==this.compareTo(t)},F.prototype.min=function te(t){return this.compareTo(t)<0?this:t},F.prototype.max=function ee(t){return this.compareTo(t)>0?this:t},F.prototype.and=function re(t){var e=E();return this.bitwiseTo(t,B,e),e},F.prototype.or=function ne(t){var e=E();return this.bitwiseTo(t,O,e),e},F.prototype.xor=function ie(t){var e=E();return this.bitwiseTo(t,j,e),e},F.prototype.andNot=function oe(t){var e=E();return this.bitwiseTo(t,M,e),e},F.prototype.not=function se(){for(var t=E(),e=0;e<this.t;++e)t[e]=this.DM&~this[e];return t.t=this.t,t.s=~this.s,t},F.prototype.shiftLeft=function ae(t){var e=E();return t<0?this.rShiftTo(-t,e):this.lShiftTo(t,e),e},F.prototype.shiftRight=function ue(t){var e=E();return t<0?this.lShiftTo(-t,e):this.rShiftTo(t,e),e},F.prototype.getLowestSetBit=function ce(){for(var t=0;t<this.t;++t)if(0!=this[t])return t*this.DB+H(this[t]);return this.s<0?this.t*this.DB:-1},F.prototype.bitCount=function he(){for(var t=0,e=this.s&this.DM,r=0;r<this.t;++r)t+=V(this[r]^e);return t},F.prototype.testBit=function le(t){var e=Math.floor(t/this.DB);return e>=this.t?0!=this.s:0!=(this[e]&1<<t%this.DB)},F.prototype.setBit=function fe(t){return this.changeBit(t,O)},F.prototype.clearBit=function ge(t){return this.changeBit(t,M)},F.prototype.flipBit=function de(t){return this.changeBit(t,j)},F.prototype.add=function pe(t){var e=E();return this.addTo(t,e),e},F.prototype.subtract=function ve(t){var e=E();return this.subTo(t,e),e},F.prototype.multiply=function ye(t){var e=E();return this.multiplyTo(t,e),e},F.prototype.divide=function me(t){var e=E();return this.divRemTo(t,e,null),e},F.prototype.remainder=function _e(t){var e=E();return this.divRemTo(t,null,e),e},F.prototype.divideAndRemainder=function Se(t){var e=E(),r=E();return this.divRemTo(t,e,r),new Array(e,r)},F.prototype.modPow=function be(t,e){var r,n,i=t.bitLength(),o=D(1);if(i<=0)return o;r=i<18?1:i<48?3:i<144?4:i<768?5:6,n=i<8?new N(e):e.isEven()?new J(e):new U(e);var s=new Array,a=3,u=r-1,c=(1<<r)-1;if(s[1]=n.convert(this),r>1){var h=E();for(n.sqrTo(s[1],h);a<=c;)s[a]=E(),n.mulTo(h,s[a-2],s[a]),a+=2}var l,f,g=t.t-1,d=!0,p=E();for(i=L(t[g])-1;g>=0;){for(i>=u?l=t[g]>>i-u&c:(l=(t[g]&(1<<i+1)-1)<<u-i,g>0&&(l|=t[g-1]>>this.DB+i-u)),a=r;0==(1&l);)l>>=1,--a;if((i-=a)<0&&(i+=this.DB,--g),d)s[l].copyTo(o),d=!1;else{for(;a>1;)n.sqrTo(o,p),n.sqrTo(p,o),a-=2;a>0?n.sqrTo(o,p):(f=o,o=p,p=f),n.mulTo(p,s[l],o)}for(;g>=0&&0==(t[g]&1<<i);)n.sqrTo(o,p),f=o,o=p,p=f,--i<0&&(i=this.DB-1,--g)}return n.revert(o)},F.prototype.modInverse=function we(t){var e=t.isEven();if(this.isEven()&&e||0==t.signum())return F.ZERO;for(var r=t.clone(),n=this.clone(),i=D(1),o=D(0),s=D(0),a=D(1);0!=r.signum();){for(;r.isEven();)r.rShiftTo(1,r),e?(i.isEven()&&o.isEven()||(i.addTo(this,i),o.subTo(t,o)),i.rShiftTo(1,i)):o.isEven()||o.subTo(t,o),o.rShiftTo(1,o);for(;n.isEven();)n.rShiftTo(1,n),e?(s.isEven()&&a.isEven()||(s.addTo(this,s),a.subTo(t,a)),s.rShiftTo(1,s)):a.isEven()||a.subTo(t,a),a.rShiftTo(1,a);r.compareTo(n)>=0?(r.subTo(n,r),e&&i.subTo(s,i),o.subTo(a,o)):(n.subTo(r,n),e&&s.subTo(i,s),a.subTo(o,a))}return 0!=n.compareTo(F.ONE)?F.ZERO:a.compareTo(t)>=0?a.subtract(t):a.signum()<0?(a.addTo(t,a),a.signum()<0?a.add(t):a):a},F.prototype.pow=function Fe(t){return this.exp(t,new K)},F.prototype.gcd=function Ee(t){var e=this.s<0?this.negate():this.clone(),r=t.s<0?t.negate():t.clone();if(e.compareTo(r)<0){var n=e;e=r,r=n}var i=e.getLowestSetBit(),o=r.getLowestSetBit();if(o<0)return e;for(i<o&&(o=i),o>0&&(e.rShiftTo(o,e),r.rShiftTo(o,r));e.signum()>0;)(i=e.getLowestSetBit())>0&&e.rShiftTo(i,e),(i=r.getLowestSetBit())>0&&r.rShiftTo(i,r),e.compareTo(r)>=0?(e.subTo(r,e),e.rShiftTo(1,e)):(r.subTo(e,r),r.rShiftTo(1,r));return o>0&&r.lShiftTo(o,r),r},F.prototype.isProbablePrime=function xe(t){var e,r=this.abs();if(1==r.t&&r[0]<=Rt[Rt.length-1]){for(e=0;e<Rt.length;++e)if(r[0]==Rt[e])return!0;return!1}if(r.isEven())return!1;for(e=1;e<Rt.length;){for(var n=Rt[e],i=e+1;i<Rt.length&&n<It;)n*=Rt[i++];for(n=r.modInt(n);e<i;)if(n%Rt[e++]==0)return!1}return r.millerRabin(t)},F.prototype.square=function Ae(){var t=E();return this.squareTo(t),t},Dt.prototype.init=function ke(t){var e,r,n;for(e=0;e<256;++e)this.S[e]=e;for(r=0,e=0;e<256;++e)r=r+this.S[e]+t[e%t.length]&255,n=this.S[e],this.S[e]=this.S[r],this.S[r]=n;this.i=0,this.j=0},Dt.prototype.next=function Pe(){var t;return this.i=this.i+1&255,this.j=this.j+this.S[this.i]&255,t=this.S[this.i],this.S[this.i]=this.S[this.j],this.S[this.j]=t,this.S[t+this.S[this.i]&255]};var Ce,Te,Re;
/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
 */function Ie(){!function t(e){Te[Re++]^=255&e,Te[Re++]^=e>>8&255,Te[Re++]^=e>>16&255,Te[Re++]^=e>>24&255,Re>=256&&(Re-=256)}((new Date).getTime())}if(null==Te){var De;if(Te=new Array,Re=0,void 0!==i&&(void 0!==i.crypto||void 0!==i.msCrypto)){var Le=i.crypto||i.msCrypto;if(Le.getRandomValues){var Ne=new Uint8Array(32);for(Le.getRandomValues(Ne),De=0;De<32;++De)Te[Re++]=Ne[De]}else if("Netscape"==n.appName&&n.appVersion<"5"){var Ue=i.crypto.random(32);for(De=0;De<Ue.length;++De)Te[Re++]=255&Ue.charCodeAt(De)}}for(;Re<256;)De=Math.floor(65536*Math.random()),Te[Re++]=De>>>8,Te[Re++]=255&De;Re=0,Ie()}function Be(){if(null==Ce){for(Ie(),(Ce=function t(){return new Dt}()).init(Te),Re=0;Re<Te.length;++Re)Te[Re]=0;Re=0}return Ce.next()}function Oe(){}
/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
 */
function je(t,e){return new F(t,e)}function Me(t,e,r){for(var n="",i=0;n.length<e;)n+=r(String.fromCharCode.apply(String,t.concat([(4278190080&i)>>24,(16711680&i)>>16,(65280&i)>>8,255&i]))),i+=1;return n}function He(){this.n=null,this.e=0,this.d=null,this.p=null,this.q=null,this.dmp1=null,this.dmq1=null,this.coeff=null}
/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
 */
function Ve(t,e){this.x=e,this.q=t}function Ke(t,e,r,n){this.curve=t,this.x=e,this.y=r,this.z=null==n?F.ONE:n,this.zinv=null}function qe(t,e,r){this.q=t,this.a=this.fromBigInteger(e),this.b=this.fromBigInteger(r),this.infinity=new Ke(this,null,null)}Oe.prototype.nextBytes=function Je(t){var e;for(e=0;e<t.length;++e)t[e]=Be()},He.prototype.doPublic=function We(t){return t.modPowInt(this.e,this.n)},He.prototype.setPublic=function ze(t,e){if(this.isPublic=!0,this.isPrivate=!1,"string"!=typeof t)this.n=t,this.e=e;else{if(!(null!=t&&null!=e&&t.length>0&&e.length>0))throw"Invalid RSA public key";this.n=je(t,16),this.e=parseInt(e,16)}},He.prototype.encrypt=function Ye(t){var e=function r(t,e){if(e<t.length+11)throw"Message too long for RSA";for(var r=new Array,n=t.length-1;n>=0&&e>0;){var i=t.charCodeAt(n--);i<128?r[--e]=i:i>127&&i<2048?(r[--e]=63&i|128,r[--e]=i>>6|192):(r[--e]=63&i|128,r[--e]=i>>6&63|128,r[--e]=i>>12|224)}r[--e]=0;for(var o=new Oe,s=new Array;e>2;){for(s[0]=0;0==s[0];)o.nextBytes(s);r[--e]=s[0]}return r[--e]=2,r[--e]=0,new F(r)}(t,this.n.bitLength()+7>>3);if(null==e)return null;var n=this.doPublic(e);if(null==n)return null;var i=n.toString(16);return 0==(1&i.length)?i:"0"+i},He.prototype.encryptOAEP=function Ge(t,e,r){var n=function i(t,e,r,n){var i=br.crypto.MessageDigest,o=br.crypto.Util,s=null;if(r||(r="sha1"),"string"==typeof r&&(s=i.getCanonicalAlgName(r),n=i.getHashLength(s),r=function t(e){return Nr(o.hashHex(Ur(e),s))}),t.length+2*n+2>e)throw"Message too long for RSA";var a,u="";for(a=0;a<e-t.length-2*n-2;a+=1)u+="\0";var c=r("")+u+""+t,h=new Array(n);(new Oe).nextBytes(h);var l=Me(h,c.length,r),f=[];for(a=0;a<c.length;a+=1)f[a]=c.charCodeAt(a)^l.charCodeAt(a);var g=Me(f,h.length,r),d=[0];for(a=0;a<h.length;a+=1)d[a+1]=h[a]^g.charCodeAt(a);return new F(d.concat(f))}(t,this.n.bitLength()+7>>3,e,r);if(null==n)return null;var o=this.doPublic(n);if(null==o)return null;var s=o.toString(16);return 0==(1&s.length)?s:"0"+s},He.prototype.type="RSA",Ve.prototype.equals=function Xe(t){return t==this||this.q.equals(t.q)&&this.x.equals(t.x)},Ve.prototype.toBigInteger=function $e(){return this.x},Ve.prototype.negate=function Qe(){return new Ve(this.q,this.x.negate().mod(this.q))},Ve.prototype.add=function Ze(t){return new Ve(this.q,this.x.add(t.toBigInteger()).mod(this.q))},Ve.prototype.subtract=function tr(t){return new Ve(this.q,this.x.subtract(t.toBigInteger()).mod(this.q))},Ve.prototype.multiply=function er(t){return new Ve(this.q,this.x.multiply(t.toBigInteger()).mod(this.q))},Ve.prototype.square=function rr(){return new Ve(this.q,this.x.square().mod(this.q))},Ve.prototype.divide=function nr(t){return new Ve(this.q,this.x.multiply(t.toBigInteger().modInverse(this.q)).mod(this.q))},Ke.prototype.getX=function ir(){return null==this.zinv&&(this.zinv=this.z.modInverse(this.curve.q)),this.curve.fromBigInteger(this.x.toBigInteger().multiply(this.zinv).mod(this.curve.q))},Ke.prototype.getY=function or(){return null==this.zinv&&(this.zinv=this.z.modInverse(this.curve.q)),this.curve.fromBigInteger(this.y.toBigInteger().multiply(this.zinv).mod(this.curve.q))},Ke.prototype.equals=function sr(t){return t==this||(this.isInfinity()?t.isInfinity():t.isInfinity()?this.isInfinity():!!t.y.toBigInteger().multiply(this.z).subtract(this.y.toBigInteger().multiply(t.z)).mod(this.curve.q).equals(F.ZERO)&&t.x.toBigInteger().multiply(this.z).subtract(this.x.toBigInteger().multiply(t.z)).mod(this.curve.q).equals(F.ZERO))},Ke.prototype.isInfinity=function ar(){return null==this.x&&null==this.y||this.z.equals(F.ZERO)&&!this.y.toBigInteger().equals(F.ZERO)},Ke.prototype.negate=function ur(){return new Ke(this.curve,this.x,this.y.negate(),this.z)},Ke.prototype.add=function cr(t){if(this.isInfinity())return t;if(t.isInfinity())return this;var e=t.y.toBigInteger().multiply(this.z).subtract(this.y.toBigInteger().multiply(t.z)).mod(this.curve.q),r=t.x.toBigInteger().multiply(this.z).subtract(this.x.toBigInteger().multiply(t.z)).mod(this.curve.q);if(F.ZERO.equals(r))return F.ZERO.equals(e)?this.twice():this.curve.getInfinity();var n=new F("3"),i=this.x.toBigInteger(),o=this.y.toBigInteger(),s=(t.x.toBigInteger(),t.y.toBigInteger(),r.square()),a=s.multiply(r),u=i.multiply(s),c=e.square().multiply(this.z),h=c.subtract(u.shiftLeft(1)).multiply(t.z).subtract(a).multiply(r).mod(this.curve.q),l=u.multiply(n).multiply(e).subtract(o.multiply(a)).subtract(c.multiply(e)).multiply(t.z).add(e.multiply(a)).mod(this.curve.q),f=a.multiply(this.z).multiply(t.z).mod(this.curve.q);return new Ke(this.curve,this.curve.fromBigInteger(h),this.curve.fromBigInteger(l),f)},Ke.prototype.twice=function hr(){if(this.isInfinity())return this;if(0==this.y.toBigInteger().signum())return this.curve.getInfinity();var t=new F("3"),e=this.x.toBigInteger(),r=this.y.toBigInteger(),n=r.multiply(this.z),i=n.multiply(r).mod(this.curve.q),o=this.curve.a.toBigInteger(),s=e.square().multiply(t);F.ZERO.equals(o)||(s=s.add(this.z.square().multiply(o)));var a=(s=s.mod(this.curve.q)).square().subtract(e.shiftLeft(3).multiply(i)).shiftLeft(1).multiply(n).mod(this.curve.q),u=s.multiply(t).multiply(e).subtract(i.shiftLeft(1)).shiftLeft(2).multiply(i).subtract(s.square().multiply(s)).mod(this.curve.q),c=n.square().multiply(n).shiftLeft(3).mod(this.curve.q);return new Ke(this.curve,this.curve.fromBigInteger(a),this.curve.fromBigInteger(u),c)},Ke.prototype.multiply=function lr(t){if(this.isInfinity())return this;if(0==t.signum())return this.curve.getInfinity();var e,r=t,n=r.multiply(new F("3")),i=this.negate(),o=this,s=this.curve.q.subtract(t),a=s.multiply(new F("3")),u=new Ke(this.curve,this.x,this.y),c=u.negate();for(e=n.bitLength()-2;e>0;--e){o=o.twice();var h=n.testBit(e);h!=r.testBit(e)&&(o=o.add(h?this:i))}for(e=a.bitLength()-2;e>0;--e){u=u.twice();var l=a.testBit(e);l!=s.testBit(e)&&(u=u.add(l?u:c))}return o},Ke.prototype.multiplyTwo=function fr(t,e,r){var n;n=t.bitLength()>r.bitLength()?t.bitLength()-1:r.bitLength()-1;for(var i=this.curve.getInfinity(),o=this.add(e);n>=0;)i=i.twice(),t.testBit(n)?i=r.testBit(n)?i.add(o):i.add(this):r.testBit(n)&&(i=i.add(e)),--n;return i},qe.prototype.getQ=function gr(){return this.q},qe.prototype.getA=function dr(){return this.a},qe.prototype.getB=function pr(){return this.b},qe.prototype.equals=function vr(t){return t==this||this.q.equals(t.q)&&this.a.equals(t.a)&&this.b.equals(t.b)},qe.prototype.getInfinity=function yr(){return this.infinity},qe.prototype.fromBigInteger=function mr(t){return new Ve(this.q,t)},qe.prototype.decodePointHex=function _r(t){switch(parseInt(t.substr(0,2),16)){case 0:return this.infinity;case 2:case 3:return null;case 4:case 6:case 7:var e=(t.length-2)/2,r=t.substr(2,e),n=t.substr(e+2,e);return new Ke(this,this.fromBigInteger(new F(r,16)),this.fromBigInteger(new F(n,16)));default:return null}},
/*! (c) Stefan Thomas | https://github.com/bitcoinjs/bitcoinjs-lib
 */
Ve.prototype.getByteLength=function(){return Math.floor((this.toBigInteger().bitLength()+7)/8)},Ke.prototype.getEncoded=function(t){var e=function t(e,r){var n=e.toByteArrayUnsigned();if(r<n.length)n=n.slice(n.length-r);else for(;r>n.length;)n.unshift(0);return n},r=this.getX().toBigInteger(),n=this.getY().toBigInteger(),i=e(r,32);return t?n.isEven()?i.unshift(2):i.unshift(3):(i.unshift(4),i=i.concat(e(n,32))),i},Ke.decodeFrom=function(t,e){e[0];var r=e.length-1,n=e.slice(1,1+r/2),i=e.slice(1+r/2,1+r);n.unshift(0),i.unshift(0);var o=new F(n),s=new F(i);return new Ke(t,t.fromBigInteger(o),t.fromBigInteger(s))},Ke.decodeFromHex=function(t,e){e.substr(0,2);var r=e.length-2,n=e.substr(2,r/2),i=e.substr(2+r/2,r/2),o=new F(n,16),s=new F(i,16);return new Ke(t,t.fromBigInteger(o),t.fromBigInteger(s))},Ke.prototype.add2D=function(t){if(this.isInfinity())return t;if(t.isInfinity())return this;if(this.x.equals(t.x))return this.y.equals(t.y)?this.twice():this.curve.getInfinity();var e=t.x.subtract(this.x),r=t.y.subtract(this.y).divide(e),n=r.square().subtract(this.x).subtract(t.x),i=r.multiply(this.x.subtract(n)).subtract(this.y);return new Ke(this.curve,n,i)},Ke.prototype.twice2D=function(){if(this.isInfinity())return this;if(0==this.y.toBigInteger().signum())return this.curve.getInfinity();var t=this.curve.fromBigInteger(F.valueOf(2)),e=this.curve.fromBigInteger(F.valueOf(3)),r=this.x.square().multiply(e).add(this.curve.a).divide(this.y.multiply(t)),n=r.square().subtract(this.x.multiply(t)),i=r.multiply(this.x.subtract(n)).subtract(this.y);return new Ke(this.curve,n,i)},Ke.prototype.multiply2D=function(t){if(this.isInfinity())return this;if(0==t.signum())return this.curve.getInfinity();var e,r=t,n=r.multiply(new F("3")),i=this.negate(),o=this;for(e=n.bitLength()-2;e>0;--e){o=o.twice();var s=n.testBit(e);s!=r.testBit(e)&&(o=o.add2D(s?this:i))}return o},Ke.prototype.isOnCurve=function(){var t=this.getX().toBigInteger(),e=this.getY().toBigInteger(),r=this.curve.getA().toBigInteger(),n=this.curve.getB().toBigInteger(),i=this.curve.getQ(),o=e.multiply(e).mod(i),s=t.multiply(t).multiply(t).add(r.multiply(t)).add(n).mod(i);return o.equals(s)},Ke.prototype.toString=function(){return"("+this.getX().toBigInteger().toString()+","+this.getY().toBigInteger().toString()+")"},Ke.prototype.validate=function(){var t=this.curve.getQ();if(this.isInfinity())throw new Error("Point is at infinity.");var e=this.getX().toBigInteger(),r=this.getY().toBigInteger();if(e.compareTo(F.ONE)<0||e.compareTo(t.subtract(F.ONE))>0)throw new Error("x coordinate out of bounds");if(r.compareTo(F.ONE)<0||r.compareTo(t.subtract(F.ONE))>0)throw new Error("y coordinate out of bounds");if(!this.isOnCurve())throw new Error("Point is not on the curve.");if(this.multiply(t).isInfinity())throw new Error("Point is not a scalar multiple of G.");return!0};
/*! Mike Samuel (c) 2009 | code.google.com/p/json-sans-eval
 */
var Sr=function(){var t=new RegExp('(?:false|true|null|[\\{\\}\\[\\]]|(?:-?\\b(?:0|[1-9][0-9]*)(?:\\.[0-9]+)?(?:[eE][+-]?[0-9]+)?\\b)|(?:"(?:[^\\0-\\x08\\x0a-\\x1f"\\\\]|\\\\(?:["/\\\\bfnrt]|u[0-9A-Fa-f]{4}))*"))',"g"),e=new RegExp("\\\\(?:([^u])|u(.{4}))","g"),n={'"':'"',"/":"/","\\":"\\",b:"\b",f:"\f",n:"\n",r:"\r",t:"\t"};function i(t,e,r){return e?n[e]:String.fromCharCode(parseInt(r,16))}var o=new String(""),s=Object.hasOwnProperty;return function(n,a){var u,c,h=n.match(t),l=h[0],f=!1;"{"===l?u={}:"["===l?u=[]:(u=[],f=!0);for(var g=[u],d=1-f,p=h.length;d<p;++d){var v;switch((l=h[d]).charCodeAt(0)){default:(v=g[0])[c||v.length]=+l,c=void 0;break;case 34:if(-1!==(l=l.substring(1,l.length-1)).indexOf("\\")&&(l=l.replace(e,i)),v=g[0],!c){if(!(v instanceof Array)){c=l||o;break}c=v.length}v[c]=l,c=void 0;break;case 91:v=g[0],g.unshift(v[c||v.length]=[]),c=void 0;break;case 93:g.shift();break;case 102:(v=g[0])[c||v.length]=!1,c=void 0;break;case 110:(v=g[0])[c||v.length]=null,c=void 0;break;case 116:(v=g[0])[c||v.length]=!0,c=void 0;break;case 123:v=g[0],g.unshift(v[c||v.length]={}),c=void 0;break;case 125:g.shift()}}if(f){if(1!==g.length)throw new Error;u=u[0]}else if(g.length)throw new Error;if(a){u=function t(e,n){var i=e[n];if(i&&"object"===(void 0===i?"undefined":r(i))){var o=null;for(var u in i)if(s.call(i,u)&&i!==e){var c=t(i,u);void 0!==c?i[u]=c:(o||(o=[]),o.push(u))}if(o)for(var h=o.length;--h>=0;)delete i[o[h]]}return a.call(e,n,i)}({"":u},"")}return u}}();void 0!==br&&br||(e.KJUR=br={}),void 0!==br.asn1&&br.asn1||(br.asn1={}),br.asn1.ASN1Util=new function(){this.integerToByteHex=function(t){var e=t.toString(16);return e.length%2==1&&(e="0"+e),e},this.bigIntToMinTwosComplementsHex=function(t){var e=t.toString(16);if("-"!=e.substr(0,1))e.length%2==1?e="0"+e:e.match(/^[0-7]/)||(e="00"+e);else{var r=e.substr(1).length;r%2==1?r+=1:e.match(/^[0-7]/)||(r+=2);for(var n="",i=0;i<r;i++)n+="f";e=new F(n,16).xor(t).add(F.ONE).toString(16).replace(/^-/,"")}return e},this.getPEMStringFromHex=function(t,e){return Mr(t,e)},this.newObject=function(t){var e=br.asn1,r=e.ASN1Object,n=e.DERBoolean,i=e.DERInteger,o=e.DERBitString,s=e.DEROctetString,a=e.DERNull,u=e.DERObjectIdentifier,c=e.DEREnumerated,h=e.DERUTF8String,l=e.DERNumericString,f=e.DERPrintableString,g=e.DERTeletexString,d=e.DERIA5String,p=e.DERUTCTime,v=e.DERGeneralizedTime,y=e.DERVisibleString,m=e.DERBMPString,_=e.DERSequence,S=e.DERSet,b=e.DERTaggedObject,w=e.ASN1Util.newObject;if(t instanceof e.ASN1Object)return t;var F=Object.keys(t);if(1!=F.length)throw new Error("key of param shall be only one.");var E=F[0];if(-1==":asn1:bool:int:bitstr:octstr:null:oid:enum:utf8str:numstr:prnstr:telstr:ia5str:utctime:gentime:visstr:bmpstr:seq:set:tag:".indexOf(":"+E+":"))throw new Error("undefined key: "+E);if("bool"==E)return new n(t[E]);if("int"==E)return new i(t[E]);if("bitstr"==E)return new o(t[E]);if("octstr"==E)return new s(t[E]);if("null"==E)return new a(t[E]);if("oid"==E)return new u(t[E]);if("enum"==E)return new c(t[E]);if("utf8str"==E)return new h(t[E]);if("numstr"==E)return new l(t[E]);if("prnstr"==E)return new f(t[E]);if("telstr"==E)return new g(t[E]);if("ia5str"==E)return new d(t[E]);if("utctime"==E)return new p(t[E]);if("gentime"==E)return new v(t[E]);if("visstr"==E)return new y(t[E]);if("bmpstr"==E)return new m(t[E]);if("asn1"==E)return new r(t[E]);if("seq"==E){for(var x=t[E],A=[],k=0;k<x.length;k++){var P=w(x[k]);A.push(P)}return new _({array:A})}if("set"==E){for(x=t[E],A=[],k=0;k<x.length;k++){P=w(x[k]);A.push(P)}return new S({array:A})}if("tag"==E){var C=t[E];if("[object Array]"===Object.prototype.toString.call(C)&&3==C.length){var T=w(C[2]);return new b({tag:C[0],explicit:C[1],obj:T})}return new b(C)}},this.jsonToASN1HEX=function(t){return this.newObject(t).getEncodedHex()}},br.asn1.ASN1Util.oidHexToInt=function(t){for(var e="",r=parseInt(t.substr(0,2),16),n=(e=Math.floor(r/40)+"."+r%40,""),i=2;i<t.length;i+=2){var o=("00000000"+parseInt(t.substr(i,2),16).toString(2)).slice(-8);if(n+=o.substr(1,7),"0"==o.substr(0,1))e=e+"."+new F(n,2).toString(10),n=""}return e},br.asn1.ASN1Util.oidIntToHex=function(t){var e=function t(e){var r=e.toString(16);return 1==r.length&&(r="0"+r),r},r=function t(r){var n="",i=new F(r,10).toString(2),o=7-i.length%7;7==o&&(o=0);for(var s="",a=0;a<o;a++)s+="0";i=s+i;for(a=0;a<i.length-1;a+=7){var u=i.substr(a,7);a!=i.length-7&&(u="1"+u),n+=e(parseInt(u,2))}return n};if(!t.match(/^[0-9.]+$/))throw"malformed oid string: "+t;var n="",i=t.split("."),o=40*parseInt(i[0])+parseInt(i[1]);n+=e(o),i.splice(0,2);for(var s=0;s<i.length;s++)n+=r(i[s]);return n},br.asn1.ASN1Object=function(t){this.params=null,this.getLengthHexFromValue=function(){if(void 0===this.hV||null==this.hV)throw new Error("this.hV is null or undefined");if(this.hV.length%2==1)throw new Error("value hex must be even length: n="+"".length+",v="+this.hV);var t=this.hV.length/2,e=t.toString(16);if(e.length%2==1&&(e="0"+e),t<128)return e;var r=e.length/2;if(r>15)throw"ASN.1 length too long to represent by 8x: n = "+t.toString(16);return(128+r).toString(16)+e},this.getEncodedHex=function(){return(null==this.hTLV||this.isModified)&&(this.hV=this.getFreshValueHex(),this.hL=this.getLengthHexFromValue(),this.hTLV=this.hT+this.hL+this.hV,this.isModified=!1),this.hTLV},this.getValueHex=function(){return this.getEncodedHex(),this.hV},this.getFreshValueHex=function(){return""},this.setByParam=function(t){this.params=t},null!=t&&null!=t.tlv&&(this.hTLV=t.tlv,this.isModified=!1)},br.asn1.DERAbstractString=function(t){br.asn1.DERAbstractString.superclass.constructor.call(this);this.getString=function(){return this.s},this.setString=function(t){this.hTLV=null,this.isModified=!0,this.s=t,this.hV=Dr(this.s).toLowerCase()},this.setStringHex=function(t){this.hTLV=null,this.isModified=!0,this.s=null,this.hV=t},this.getFreshValueHex=function(){return this.hV},void 0!==t&&("string"==typeof t?this.setString(t):void 0!==t.str?this.setString(t.str):void 0!==t.hex&&this.setStringHex(t.hex))},o.lang.extend(br.asn1.DERAbstractString,br.asn1.ASN1Object),br.asn1.DERAbstractTime=function(t){br.asn1.DERAbstractTime.superclass.constructor.call(this);this.localDateToUTC=function(t){var e=t.getTime()+6e4*t.getTimezoneOffset();return new Date(e)},this.formatDate=function(t,e,r){var n=this.zeroPadding,i=this.localDateToUTC(t),o=String(i.getFullYear());"utc"==e&&(o=o.substr(2,2));var s=o+n(String(i.getMonth()+1),2)+n(String(i.getDate()),2)+n(String(i.getHours()),2)+n(String(i.getMinutes()),2)+n(String(i.getSeconds()),2);if(!0===r){var a=i.getMilliseconds();if(0!=a){var u=n(String(a),3);s=s+"."+(u=u.replace(/[0]+$/,""))}}return s+"Z"},this.zeroPadding=function(t,e){return t.length>=e?t:new Array(e-t.length+1).join("0")+t},this.getString=function(){return this.s},this.setString=function(t){this.hTLV=null,this.isModified=!0,this.s=t,this.hV=Pr(t)},this.setByDateValue=function(t,e,r,n,i,o){var s=new Date(Date.UTC(t,e-1,r,n,i,o,0));this.setByDate(s)},this.getFreshValueHex=function(){return this.hV}},o.lang.extend(br.asn1.DERAbstractTime,br.asn1.ASN1Object),br.asn1.DERAbstractStructured=function(t){br.asn1.DERAbstractString.superclass.constructor.call(this);this.setByASN1ObjectArray=function(t){this.hTLV=null,this.isModified=!0,this.asn1Array=t},this.appendASN1Object=function(t){this.hTLV=null,this.isModified=!0,this.asn1Array.push(t)},this.asn1Array=new Array,void 0!==t&&void 0!==t.array&&(this.asn1Array=t.array)},o.lang.extend(br.asn1.DERAbstractStructured,br.asn1.ASN1Object),br.asn1.DERBoolean=function(t){br.asn1.DERBoolean.superclass.constructor.call(this),this.hT="01",this.hTLV=0==t?"010100":"0101ff"},o.lang.extend(br.asn1.DERBoolean,br.asn1.ASN1Object),br.asn1.DERInteger=function(t){br.asn1.DERInteger.superclass.constructor.call(this),this.hT="02",this.setByBigInteger=function(t){this.hTLV=null,this.isModified=!0,this.hV=br.asn1.ASN1Util.bigIntToMinTwosComplementsHex(t)},this.setByInteger=function(t){var e=new F(String(t),10);this.setByBigInteger(e)},this.setValueHex=function(t){this.hV=t},this.getFreshValueHex=function(){return this.hV},void 0!==t&&(void 0!==t.bigint?this.setByBigInteger(t.bigint):void 0!==t.int?this.setByInteger(t.int):"number"==typeof t?this.setByInteger(t):void 0!==t.hex&&this.setValueHex(t.hex))},o.lang.extend(br.asn1.DERInteger,br.asn1.ASN1Object),br.asn1.DERBitString=function(t){if(void 0!==t&&void 0!==t.obj){var e=br.asn1.ASN1Util.newObject(t.obj);t.hex="00"+e.getEncodedHex()}br.asn1.DERBitString.superclass.constructor.call(this),this.hT="03",this.setHexValueIncludingUnusedBits=function(t){this.hTLV=null,this.isModified=!0,this.hV=t},this.setUnusedBitsAndHexValue=function(t,e){if(t<0||7<t)throw"unused bits shall be from 0 to 7: u = "+t;var r="0"+t;this.hTLV=null,this.isModified=!0,this.hV=r+e},this.setByBinaryString=function(t){var e=8-(t=t.replace(/0+$/,"")).length%8;8==e&&(e=0);for(var r=0;r<=e;r++)t+="0";var n="";for(r=0;r<t.length-1;r+=8){var i=t.substr(r,8),o=parseInt(i,2).toString(16);1==o.length&&(o="0"+o),n+=o}this.hTLV=null,this.isModified=!0,this.hV="0"+e+n},this.setByBooleanArray=function(t){for(var e="",r=0;r<t.length;r++)1==t[r]?e+="1":e+="0";this.setByBinaryString(e)},this.newFalseArray=function(t){for(var e=new Array(t),r=0;r<t;r++)e[r]=!1;return e},this.getFreshValueHex=function(){return this.hV},void 0!==t&&("string"==typeof t&&t.toLowerCase().match(/^[0-9a-f]+$/)?this.setHexValueIncludingUnusedBits(t):void 0!==t.hex?this.setHexValueIncludingUnusedBits(t.hex):void 0!==t.bin?this.setByBinaryString(t.bin):void 0!==t.array&&this.setByBooleanArray(t.array))},o.lang.extend(br.asn1.DERBitString,br.asn1.ASN1Object),br.asn1.DEROctetString=function(t){if(void 0!==t&&void 0!==t.obj){var e=br.asn1.ASN1Util.newObject(t.obj);t.hex=e.getEncodedHex()}br.asn1.DEROctetString.superclass.constructor.call(this,t),this.hT="04"},o.lang.extend(br.asn1.DEROctetString,br.asn1.DERAbstractString),br.asn1.DERNull=function(){br.asn1.DERNull.superclass.constructor.call(this),this.hT="05",this.hTLV="0500"},o.lang.extend(br.asn1.DERNull,br.asn1.ASN1Object),br.asn1.DERObjectIdentifier=function(t){br.asn1.DERObjectIdentifier.superclass.constructor.call(this),this.hT="06",this.setValueHex=function(t){this.hTLV=null,this.isModified=!0,this.s=null,this.hV=t},this.setValueOidString=function(t){var e=function r(t){var e=function t(e){var r=e.toString(16);return 1==r.length&&(r="0"+r),r},r=function t(r){var n="",i=parseInt(r,10).toString(2),o=7-i.length%7;7==o&&(o=0);for(var s="",a=0;a<o;a++)s+="0";i=s+i;for(a=0;a<i.length-1;a+=7){var u=i.substr(a,7);a!=i.length-7&&(u="1"+u),n+=e(parseInt(u,2))}return n};try{if(!t.match(/^[0-9.]+$/))return null;var n="",i=t.split("."),o=40*parseInt(i[0],10)+parseInt(i[1],10);n+=e(o),i.splice(0,2);for(var s=0;s<i.length;s++)n+=r(i[s]);return n}catch(t){return null}}(t);if(null==e)throw new Error("malformed oid string: "+t);this.hTLV=null,this.isModified=!0,this.s=null,this.hV=e},this.setValueName=function(t){var e=br.asn1.x509.OID.name2oid(t);if(""===e)throw new Error("DERObjectIdentifier oidName undefined: "+t);this.setValueOidString(e)},this.setValueNameOrOid=function(t){t.match(/^[0-2].[0-9.]+$/)?this.setValueOidString(t):this.setValueName(t)},this.getFreshValueHex=function(){return this.hV},this.setByParam=function(t){"string"==typeof t?this.setValueNameOrOid(t):void 0!==t.oid?this.setValueNameOrOid(t.oid):void 0!==t.name?this.setValueNameOrOid(t.name):void 0!==t.hex&&this.setValueHex(t.hex)},void 0!==t&&this.setByParam(t)},o.lang.extend(br.asn1.DERObjectIdentifier,br.asn1.ASN1Object),br.asn1.DEREnumerated=function(t){br.asn1.DEREnumerated.superclass.constructor.call(this),this.hT="0a",this.setByBigInteger=function(t){this.hTLV=null,this.isModified=!0,this.hV=br.asn1.ASN1Util.bigIntToMinTwosComplementsHex(t)},this.setByInteger=function(t){var e=new F(String(t),10);this.setByBigInteger(e)},this.setValueHex=function(t){this.hV=t},this.getFreshValueHex=function(){return this.hV},void 0!==t&&(void 0!==t.int?this.setByInteger(t.int):"number"==typeof t?this.setByInteger(t):void 0!==t.hex&&this.setValueHex(t.hex))},o.lang.extend(br.asn1.DEREnumerated,br.asn1.ASN1Object),br.asn1.DERUTF8String=function(t){br.asn1.DERUTF8String.superclass.constructor.call(this,t),this.hT="0c"},o.lang.extend(br.asn1.DERUTF8String,br.asn1.DERAbstractString),br.asn1.DERNumericString=function(t){br.asn1.DERNumericString.superclass.constructor.call(this,t),this.hT="12"},o.lang.extend(br.asn1.DERNumericString,br.asn1.DERAbstractString),br.asn1.DERPrintableString=function(t){br.asn1.DERPrintableString.superclass.constructor.call(this,t),this.hT="13"},o.lang.extend(br.asn1.DERPrintableString,br.asn1.DERAbstractString),br.asn1.DERTeletexString=function(t){br.asn1.DERTeletexString.superclass.constructor.call(this,t),this.hT="14"},o.lang.extend(br.asn1.DERTeletexString,br.asn1.DERAbstractString),br.asn1.DERIA5String=function(t){br.asn1.DERIA5String.superclass.constructor.call(this,t),this.hT="16"},o.lang.extend(br.asn1.DERIA5String,br.asn1.DERAbstractString),br.asn1.DERVisibleString=function(t){br.asn1.DERIA5String.superclass.constructor.call(this,t),this.hT="1a"},o.lang.extend(br.asn1.DERVisibleString,br.asn1.DERAbstractString),br.asn1.DERBMPString=function(t){br.asn1.DERBMPString.superclass.constructor.call(this,t),this.hT="1e"},o.lang.extend(br.asn1.DERBMPString,br.asn1.DERAbstractString),br.asn1.DERUTCTime=function(t){br.asn1.DERUTCTime.superclass.constructor.call(this,t),this.hT="17",this.setByDate=function(t){this.hTLV=null,this.isModified=!0,this.date=t,this.s=this.formatDate(this.date,"utc"),this.hV=Pr(this.s)},this.getFreshValueHex=function(){return void 0===this.date&&void 0===this.s&&(this.date=new Date,this.s=this.formatDate(this.date,"utc"),this.hV=Pr(this.s)),this.hV},void 0!==t&&(void 0!==t.str?this.setString(t.str):"string"==typeof t&&t.match(/^[0-9]{12}Z$/)?this.setString(t):void 0!==t.hex?this.setStringHex(t.hex):void 0!==t.date&&this.setByDate(t.date))},o.lang.extend(br.asn1.DERUTCTime,br.asn1.DERAbstractTime),br.asn1.DERGeneralizedTime=function(t){br.asn1.DERGeneralizedTime.superclass.constructor.call(this,t),this.hT="18",this.withMillis=!1,this.setByDate=function(t){this.hTLV=null,this.isModified=!0,this.date=t,this.s=this.formatDate(this.date,"gen",this.withMillis),this.hV=Pr(this.s)},this.getFreshValueHex=function(){return void 0===this.date&&void 0===this.s&&(this.date=new Date,this.s=this.formatDate(this.date,"gen",this.withMillis),this.hV=Pr(this.s)),this.hV},void 0!==t&&(void 0!==t.str?this.setString(t.str):"string"==typeof t&&t.match(/^[0-9]{14}Z$/)?this.setString(t):void 0!==t.hex?this.setStringHex(t.hex):void 0!==t.date&&this.setByDate(t.date),!0===t.millis&&(this.withMillis=!0))},o.lang.extend(br.asn1.DERGeneralizedTime,br.asn1.DERAbstractTime),br.asn1.DERSequence=function(t){br.asn1.DERSequence.superclass.constructor.call(this,t),this.hT="30",this.getFreshValueHex=function(){for(var t="",e=0;e<this.asn1Array.length;e++){t+=this.asn1Array[e].getEncodedHex()}return this.hV=t,this.hV}},o.lang.extend(br.asn1.DERSequence,br.asn1.DERAbstractStructured),br.asn1.DERSet=function(t){br.asn1.DERSet.superclass.constructor.call(this,t),this.hT="31",this.sortFlag=!0,this.getFreshValueHex=function(){for(var t=new Array,e=0;e<this.asn1Array.length;e++){var r=this.asn1Array[e];t.push(r.getEncodedHex())}return 1==this.sortFlag&&t.sort(),this.hV=t.join(""),this.hV},void 0!==t&&void 0!==t.sortflag&&0==t.sortflag&&(this.sortFlag=!1)},o.lang.extend(br.asn1.DERSet,br.asn1.DERAbstractStructured),br.asn1.DERTaggedObject=function(t){br.asn1.DERTaggedObject.superclass.constructor.call(this);var e=br.asn1;this.hT="a0",this.hV="",this.isExplicit=!0,this.asn1Object=null,this.setASN1Object=function(t,e,r){this.hT=e,this.isExplicit=t,this.asn1Object=r,this.isExplicit?(this.hV=this.asn1Object.getEncodedHex(),this.hTLV=null,this.isModified=!0):(this.hV=null,this.hTLV=r.getEncodedHex(),this.hTLV=this.hTLV.replace(/^../,e),this.isModified=!1)},this.getFreshValueHex=function(){return this.hV},this.setByParam=function(t){null!=t.tag&&(this.hT=t.tag),null!=t.explicit&&(this.isExplicit=t.explicit),null!=t.tage&&(this.hT=t.tage,this.isExplicit=!0),null!=t.tagi&&(this.hT=t.tagi,this.isExplicit=!1),null!=t.obj&&(t.obj instanceof e.ASN1Object?(this.asn1Object=t.obj,this.setASN1Object(this.isExplicit,this.hT,this.asn1Object)):"object"==r(t.obj)&&(this.asn1Object=e.ASN1Util.newObject(t.obj),this.setASN1Object(this.isExplicit,this.hT,this.asn1Object)))},null!=t&&this.setByParam(t)},o.lang.extend(br.asn1.DERTaggedObject,br.asn1.ASN1Object);var br,wr,Fr,Er=new function(){};function xr(t){for(var e=new Array,r=0;r<t.length;r++)e[r]=t.charCodeAt(r);return e}function Ar(t){for(var e="",r=0;r<t.length;r++)e+=String.fromCharCode(t[r]);return e}function kr(t){for(var e="",r=0;r<t.length;r++){var n=t[r].toString(16);1==n.length&&(n="0"+n),e+=n}return e}function Pr(t){return kr(xr(t))}function Cr(t){return t=(t=(t=t.replace(/\=/g,"")).replace(/\+/g,"-")).replace(/\//g,"_")}function Tr(t){return t.length%4==2?t+="==":t.length%4==3&&(t+="="),t=(t=t.replace(/-/g,"+")).replace(/_/g,"/")}function Rr(t){return t.length%2==1&&(t="0"+t),Cr(S(t))}function Ir(t){return b(Tr(t))}function Dr(t){return qr(Gr(t))}function Lr(t){return decodeURIComponent(Jr(t))}function Nr(t){for(var e="",r=0;r<t.length-1;r+=2)e+=String.fromCharCode(parseInt(t.substr(r,2),16));return e}function Ur(t){for(var e="",r=0;r<t.length;r++)e+=("0"+t.charCodeAt(r).toString(16)).slice(-2);return e}function Br(t){return S(t)}function Or(t){var e=Br(t).replace(/(.{64})/g,"$1\r\n");return e=e.replace(/\r\n$/,"")}function jr(t){return b(t.replace(/[^0-9A-Za-z\/+=]*/g,""))}function Mr(t,e){return"-----BEGIN "+e+"-----\r\n"+Or(t)+"\r\n-----END "+e+"-----\r\n"}function Hr(t,e){if(-1==t.indexOf("-----BEGIN "))throw"can't find PEM header: "+e;return jr(t=void 0!==e?(t=t.replace(new RegExp("^[^]*-----BEGIN "+e+"-----"),"")).replace(new RegExp("-----END "+e+"-----[^]*$"),""):(t=t.replace(/^[^]*-----BEGIN [^-]+-----/,"")).replace(/-----END [^-]+-----[^]*$/,""))}function Vr(t){var e,r,n,i,o,s,a,u,c,h,l;if(l=t.match(/^(\d{2}|\d{4})(\d\d)(\d\d)(\d\d)(\d\d)(\d\d)(|\.\d+)Z$/))return u=l[1],e=parseInt(u),2===u.length&&(50<=e&&e<100?e=1900+e:0<=e&&e<50&&(e=2e3+e)),r=parseInt(l[2])-1,n=parseInt(l[3]),i=parseInt(l[4]),o=parseInt(l[5]),s=parseInt(l[6]),a=0,""!==(c=l[7])&&(h=(c.substr(1)+"00").substr(0,3),a=parseInt(h)),Date.UTC(e,r,n,i,o,s,a);throw"unsupported zulu format: "+t}function Kr(t){return~~(Vr(t)/1e3)}function qr(t){return t.replace(/%/g,"")}function Jr(t){return t.replace(/(..)/g,"%$1")}function Wr(t){var e="malformed IPv6 address";if(!t.match(/^[0-9A-Fa-f:]+$/))throw e;var r=(t=t.toLowerCase()).split(":").length-1;if(r<2)throw e;var n=":".repeat(7-r+2),i=(t=t.replace("::",n)).split(":");if(8!=i.length)throw e;for(var o=0;o<8;o++)i[o]=("0000"+i[o]).slice(-4);return i.join("")}function zr(t){if(!t.match(/^[0-9A-Fa-f]{32}$/))throw"malformed IPv6 address octet";for(var e=(t=t.toLowerCase()).match(/.{1,4}/g),r=0;r<8;r++)e[r]=e[r].replace(/^0+/,""),""==e[r]&&(e[r]="0");var n=(t=":"+e.join(":")+":").match(/:(0:){2,}/g);if(null===n)return t.slice(1,-1);var i="";for(r=0;r<n.length;r++)n[r].length>i.length&&(i=n[r]);return(t=t.replace(i,"::")).slice(1,-1)}function Yr(t){var e="malformed hex value";if(!t.match(/^([0-9A-Fa-f][0-9A-Fa-f]){1,}$/))throw e;if(8!=t.length)return 32==t.length?zr(t):t;try{return parseInt(t.substr(0,2),16)+"."+parseInt(t.substr(2,2),16)+"."+parseInt(t.substr(4,2),16)+"."+parseInt(t.substr(6,2),16)}catch(t){throw e}}function Gr(t){for(var e=encodeURIComponent(t),r="",n=0;n<e.length;n++)"%"==e[n]?(r+=e.substr(n,3),n+=2):r=r+"%"+Pr(e[n]);return r}function Xr(t){return!(t.length%2!=0||!t.match(/^[0-9a-f]+$/)&&!t.match(/^[0-9A-F]+$/))}function $r(t){return t.length%2==1?"0"+t:t.substr(0,1)>"7"?"00"+t:t}Er.getLblen=function(t,e){if("8"!=t.substr(e+2,1))return 1;var r=parseInt(t.substr(e+3,1));return 0==r?-1:0<r&&r<10?r+1:-2},Er.getL=function(t,e){var r=Er.getLblen(t,e);return r<1?"":t.substr(e+2,2*r)},Er.getVblen=function(t,e){var r;return""==(r=Er.getL(t,e))?-1:("8"===r.substr(0,1)?new F(r.substr(2),16):new F(r,16)).intValue()},Er.getVidx=function(t,e){var r=Er.getLblen(t,e);return r<0?r:e+2*(r+1)},Er.getV=function(t,e){var r=Er.getVidx(t,e),n=Er.getVblen(t,e);return t.substr(r,2*n)},Er.getTLV=function(t,e){return t.substr(e,2)+Er.getL(t,e)+Er.getV(t,e)},Er.getTLVblen=function(t,e){return 2+2*Er.getLblen(t,e)+2*Er.getVblen(t,e)},Er.getNextSiblingIdx=function(t,e){return Er.getVidx(t,e)+2*Er.getVblen(t,e)},Er.getChildIdx=function(t,e){var r,n,i,o=Er,s=[];r=o.getVidx(t,e),n=2*o.getVblen(t,e),"03"==t.substr(e,2)&&(r+=2,n-=2),i=0;for(var a=r;i<=n;){var u=o.getTLVblen(t,a);if((i+=u)<=n&&s.push(a),a+=u,i>=n)break}return s},Er.getNthChildIdx=function(t,e,r){return Er.getChildIdx(t,e)[r]},Er.getIdxbyList=function(t,e,r,n){var i,o,s=Er;return 0==r.length?void 0!==n&&t.substr(e,2)!==n?-1:e:(i=r.shift())>=(o=s.getChildIdx(t,e)).length?-1:s.getIdxbyList(t,o[i],r,n)},Er.getIdxbyListEx=function(t,e,r,n){var i,o,s=Er;if(0==r.length)return void 0!==n&&t.substr(e,2)!==n?-1:e;i=r.shift(),o=s.getChildIdx(t,e);for(var a=0,u=0;u<o.length;u++){var c=t.substr(o[u],2);if("number"==typeof i&&!s.isContextTag(c)&&a==i||"string"==typeof i&&s.isContextTag(c,i))return s.getIdxbyListEx(t,o[u],r,n);s.isContextTag(c)||a++}return-1},Er.getTLVbyList=function(t,e,r,n){var i=Er,o=i.getIdxbyList(t,e,r,n);return-1==o||o>=t.length?null:i.getTLV(t,o)},Er.getTLVbyListEx=function(t,e,r,n){var i=Er,o=i.getIdxbyListEx(t,e,r,n);return-1==o?null:i.getTLV(t,o)},Er.getVbyList=function(t,e,r,n,i){var o,s,a=Er;return-1==(o=a.getIdxbyList(t,e,r,n))||o>=t.length?null:(s=a.getV(t,o),!0===i&&(s=s.substr(2)),s)},Er.getVbyListEx=function(t,e,r,n,i){var o,s,a=Er;return-1==(o=a.getIdxbyListEx(t,e,r,n))?null:(s=a.getV(t,o),"03"==t.substr(o,2)&&!1!==i&&(s=s.substr(2)),s)},Er.getInt=function(t,e,r){null==r&&(r=-1);try{var n=t.substr(e,2);if("02"!=n&&"03"!=n)return r;var i=Er.getV(t,e);return"02"==n?parseInt(i,16):function o(t){try{var e=t.substr(0,2);if("00"==e)return parseInt(t.substr(2),16);var r=parseInt(e,16),n=t.substr(2),i=parseInt(n,16).toString(2);return"0"==i&&(i="00000000"),i=i.slice(0,0-r),parseInt(i,2)}catch(t){return-1}}(i)}catch(t){return r}},Er.getOID=function(t,e,r){null==r&&(r=null);try{return"06"!=t.substr(e,2)?r:function n(t){if(!Xr(t))return null;try{var e=[],r=t.substr(0,2),n=parseInt(r,16);e[0]=new String(Math.floor(n/40)),e[1]=new String(n%40);for(var i=t.substr(2),o=[],s=0;s<i.length/2;s++)o.push(parseInt(i.substr(2*s,2),16));var a=[],u="";for(s=0;s<o.length;s++)128&o[s]?u+=Qr((127&o[s]).toString(2),7):(u+=Qr((127&o[s]).toString(2),7),a.push(new String(parseInt(u,2))),u="");var c=e.join(".");return a.length>0&&(c=c+"."+a.join(".")),c}catch(t){return null}}(Er.getV(t,e))}catch(t){return r}},Er.getOIDName=function(t,e,r){null==r&&(r=null);try{var n=Er.getOID(t,e,r);if(n==r)return r;var i=br.asn1.x509.OID.oid2name(n);return""==i?n:i}catch(t){return r}},Er.getString=function(t,e,r){null==r&&(r=null);try{return Nr(Er.getV(t,e))}catch(t){return r}},Er.hextooidstr=function(t){var e=function t(e,r){return e.length>=r?e:new Array(r-e.length+1).join("0")+e},r=[],n=t.substr(0,2),i=parseInt(n,16);r[0]=new String(Math.floor(i/40)),r[1]=new String(i%40);for(var o=t.substr(2),s=[],a=0;a<o.length/2;a++)s.push(parseInt(o.substr(2*a,2),16));var u=[],c="";for(a=0;a<s.length;a++)128&s[a]?c+=e((127&s[a]).toString(2),7):(c+=e((127&s[a]).toString(2),7),u.push(new String(parseInt(c,2))),c="");var h=r.join(".");return u.length>0&&(h=h+"."+u.join(".")),h},Er.dump=function(t,e,r,n){var i=Er,o=i.getV,s=i.dump,a=i.getChildIdx,u=t;t instanceof br.asn1.ASN1Object&&(u=t.getEncodedHex());var c=function t(e,r){return e.length<=2*r?e:e.substr(0,r)+"..(total "+e.length/2+"bytes).."+e.substr(e.length-r,r)};void 0===e&&(e={ommit_long_octet:32}),void 0===r&&(r=0),void 0===n&&(n="");var h,l=e.ommit_long_octet;if("01"==(h=u.substr(r,2)))return"00"==(f=o(u,r))?n+"BOOLEAN FALSE\n":n+"BOOLEAN TRUE\n";if("02"==h)return n+"INTEGER "+c(f=o(u,r),l)+"\n";if("03"==h){var f=o(u,r);if(i.isASN1HEX(f.substr(2))){var g=n+"BITSTRING, encapsulates\n";return g+=s(f.substr(2),e,0,n+"  ")}return n+"BITSTRING "+c(f,l)+"\n"}if("04"==h){f=o(u,r);if(i.isASN1HEX(f)){g=n+"OCTETSTRING, encapsulates\n";return g+=s(f,e,0,n+"  ")}return n+"OCTETSTRING "+c(f,l)+"\n"}if("05"==h)return n+"NULL\n";if("06"==h){var d=o(u,r),p=br.asn1.ASN1Util.oidHexToInt(d),v=br.asn1.x509.OID.oid2name(p),y=p.replace(/\./g," ");return""!=v?n+"ObjectIdentifier "+v+" ("+y+")\n":n+"ObjectIdentifier ("+y+")\n"}if("0a"==h)return n+"ENUMERATED "+parseInt(o(u,r))+"\n";if("0c"==h)return n+"UTF8String '"+Lr(o(u,r))+"'\n";if("13"==h)return n+"PrintableString '"+Lr(o(u,r))+"'\n";if("14"==h)return n+"TeletexString '"+Lr(o(u,r))+"'\n";if("16"==h)return n+"IA5String '"+Lr(o(u,r))+"'\n";if("17"==h)return n+"UTCTime "+Lr(o(u,r))+"\n";if("18"==h)return n+"GeneralizedTime "+Lr(o(u,r))+"\n";if("1a"==h)return n+"VisualString '"+Lr(o(u,r))+"'\n";if("1e"==h)return n+"BMPString '"+Lr(o(u,r))+"'\n";if("30"==h){if("3000"==u.substr(r,4))return n+"SEQUENCE {}\n";g=n+"SEQUENCE\n";var m=e;if((2==(b=a(u,r)).length||3==b.length)&&"06"==u.substr(b[0],2)&&"04"==u.substr(b[b.length-1],2)){v=i.oidname(o(u,b[0]));var _=JSON.parse(JSON.stringify(e));_.x509ExtName=v,m=_}for(var S=0;S<b.length;S++)g+=s(u,m,b[S],n+"  ");return g}if("31"==h){g=n+"SET\n";var b=a(u,r);for(S=0;S<b.length;S++)g+=s(u,e,b[S],n+"  ");return g}if(0!=(128&(h=parseInt(h,16)))){var w=31&h;if(0!=(32&h)){for(g=n+"["+w+"]\n",b=a(u,r),S=0;S<b.length;S++)g+=s(u,e,b[S],n+"  ");return g}f=o(u,r);if(Er.isASN1HEX(f)){var g=n+"["+w+"]\n";return g+=s(f,e,0,n+"  ")}return("68747470"==f.substr(0,8)||"subjectAltName"===e.x509ExtName&&2==w)&&(f=Lr(f)),g=n+"["+w+"] "+f+"\n"}return n+"UNKNOWN("+h+") "+o(u,r)+"\n"},Er.isContextTag=function(t,e){var r,n;t=t.toLowerCase();try{r=parseInt(t,16)}catch(t){return-1}if(void 0===e)return 128==(192&r);try{return null!=e.match(/^\[[0-9]+\]$/)&&(!((n=parseInt(e.substr(1,e.length-1),10))>31)&&(128==(192&r)&&(31&r)==n))}catch(t){return!1}},Er.isASN1HEX=function(t){var e=Er;if(t.length%2==1)return!1;var r=e.getVblen(t,0),n=t.substr(0,2),i=e.getL(t,0);return t.length-n.length-i.length==2*r},Er.checkStrictDER=function(t,e,r,n,i){var o=Er;if(void 0===r){if("string"!=typeof t)throw new Error("not hex string");if(t=t.toLowerCase(),!br.lang.String.isHex(t))throw new Error("not hex string");r=t.length,i=(n=t.length/2)<128?1:Math.ceil(n.toString(16))+1}if(o.getL(t,e).length>2*i)throw new Error("L of TLV too long: idx="+e);var s=o.getVblen(t,e);if(s>n)throw new Error("value of L too long than hex: idx="+e);var a=o.getTLV(t,e),u=a.length-2-o.getL(t,e).length;if(u!==2*s)throw new Error("V string length and L's value not the same:"+u+"/"+2*s);if(0===e&&t.length!=a.length)throw new Error("total length and TLV length unmatch:"+t.length+"!="+a.length);var c=t.substr(e,2);if("02"===c){var h=o.getVidx(t,e);if("00"==t.substr(h,2)&&t.charCodeAt(h+2)<56)throw new Error("not least zeros for DER INTEGER")}if(32&parseInt(c,16)){for(var l=o.getVblen(t,e),f=0,g=o.getChildIdx(t,e),d=0;d<g.length;d++){f+=o.getTLV(t,g[d]).length,o.checkStrictDER(t,g[d],r,n,i)}if(2*l!=f)throw new Error("sum of children's TLV length and L unmatch: "+2*l+"!="+f)}},Er.oidname=function(t){var e=br.asn1;br.lang.String.isHex(t)&&(t=e.ASN1Util.oidHexToInt(t));var r=e.x509.OID.oid2name(t);return""===r&&(r=t),r},void 0!==br&&br||(e.KJUR=br={}),void 0!==br.lang&&br.lang||(br.lang={}),br.lang.String=function(){},"function"==typeof t?(e.utf8tob64u=wr=function e(r){return Cr(t.from(r,"utf8").toString("base64"))},e.b64utoutf8=Fr=function e(r){return t.from(Tr(r),"base64").toString("utf8")}):(e.utf8tob64u=wr=function t(e){return Rr(qr(Gr(e)))},e.b64utoutf8=Fr=function t(e){return decodeURIComponent(Jr(Ir(e)))}),br.lang.String.isInteger=function(t){return!!t.match(/^[0-9]+$/)||!!t.match(/^-[0-9]+$/)},br.lang.String.isHex=function(t){return Xr(t)},br.lang.String.isBase64=function(t){return!(!(t=t.replace(/\s+/g,"")).match(/^[0-9A-Za-z+\/]+={0,3}$/)||t.length%4!=0)},br.lang.String.isBase64URL=function(t){return!t.match(/[+/=]/)&&(t=Tr(t),br.lang.String.isBase64(t))},br.lang.String.isIntegerArray=function(t){return!!(t=t.replace(/\s+/g,"")).match(/^\[[0-9,]+\]$/)},br.lang.String.isPrintable=function(t){return null!==t.match(/^[0-9A-Za-z '()+,-./:=?]*$/)},br.lang.String.isIA5=function(t){return null!==t.match(/^[\x20-\x21\x23-\x7f]*$/)},br.lang.String.isMail=function(t){return null!==t.match(/^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/)};var Qr=function t(e,r,n){return null==n&&(n="0"),e.length>=r?e:new Array(r-e.length+1).join(n)+e};void 0!==br&&br||(e.KJUR=br={}),void 0!==br.crypto&&br.crypto||(br.crypto={}),br.crypto.Util=new function(){this.DIGESTINFOHEAD={sha1:"3021300906052b0e03021a05000414",sha224:"302d300d06096086480165030402040500041c",sha256:"3031300d060960864801650304020105000420",sha384:"3041300d060960864801650304020205000430",sha512:"3051300d060960864801650304020305000440",md2:"3020300c06082a864886f70d020205000410",md5:"3020300c06082a864886f70d020505000410",ripemd160:"3021300906052b2403020105000414"},this.DEFAULTPROVIDER={md5:"cryptojs",sha1:"cryptojs",sha224:"cryptojs",sha256:"cryptojs",sha384:"cryptojs",sha512:"cryptojs",ripemd160:"cryptojs",hmacmd5:"cryptojs",hmacsha1:"cryptojs",hmacsha224:"cryptojs",hmacsha256:"cryptojs",hmacsha384:"cryptojs",hmacsha512:"cryptojs",hmacripemd160:"cryptojs",MD5withRSA:"cryptojs/jsrsa",SHA1withRSA:"cryptojs/jsrsa",SHA224withRSA:"cryptojs/jsrsa",SHA256withRSA:"cryptojs/jsrsa",SHA384withRSA:"cryptojs/jsrsa",SHA512withRSA:"cryptojs/jsrsa",RIPEMD160withRSA:"cryptojs/jsrsa",MD5withECDSA:"cryptojs/jsrsa",SHA1withECDSA:"cryptojs/jsrsa",SHA224withECDSA:"cryptojs/jsrsa",SHA256withECDSA:"cryptojs/jsrsa",SHA384withECDSA:"cryptojs/jsrsa",SHA512withECDSA:"cryptojs/jsrsa",RIPEMD160withECDSA:"cryptojs/jsrsa",SHA1withDSA:"cryptojs/jsrsa",SHA224withDSA:"cryptojs/jsrsa",SHA256withDSA:"cryptojs/jsrsa",MD5withRSAandMGF1:"cryptojs/jsrsa",SHAwithRSAandMGF1:"cryptojs/jsrsa",SHA1withRSAandMGF1:"cryptojs/jsrsa",SHA224withRSAandMGF1:"cryptojs/jsrsa",SHA256withRSAandMGF1:"cryptojs/jsrsa",SHA384withRSAandMGF1:"cryptojs/jsrsa",SHA512withRSAandMGF1:"cryptojs/jsrsa",RIPEMD160withRSAandMGF1:"cryptojs/jsrsa"},this.CRYPTOJSMESSAGEDIGESTNAME={md5:y.algo.MD5,sha1:y.algo.SHA1,sha224:y.algo.SHA224,sha256:y.algo.SHA256,sha384:y.algo.SHA384,sha512:y.algo.SHA512,ripemd160:y.algo.RIPEMD160},this.getDigestInfoHex=function(t,e){if(void 0===this.DIGESTINFOHEAD[e])throw"alg not supported in Util.DIGESTINFOHEAD: "+e;return this.DIGESTINFOHEAD[e]+t},this.getPaddedDigestInfoHex=function(t,e,r){var n=this.getDigestInfoHex(t,e),i=r/4;if(n.length+22>i)throw"key is too short for SigAlg: keylen="+r+","+e;for(var o="0001",s="00"+n,a="",u=i-o.length-s.length,c=0;c<u;c+=2)a+="ff";return o+a+s},this.hashString=function(t,e){return new br.crypto.MessageDigest({alg:e}).digestString(t)},this.hashHex=function(t,e){return new br.crypto.MessageDigest({alg:e}).digestHex(t)},this.sha1=function(t){return this.hashString(t,"sha1")},this.sha256=function(t){return this.hashString(t,"sha256")},this.sha256Hex=function(t){return this.hashHex(t,"sha256")},this.sha512=function(t){return this.hashString(t,"sha512")},this.sha512Hex=function(t){return this.hashHex(t,"sha512")},this.isKey=function(t){return t instanceof He||t instanceof br.crypto.DSA||t instanceof br.crypto.ECDSA}},br.crypto.Util.md5=function(t){return new br.crypto.MessageDigest({alg:"md5",prov:"cryptojs"}).digestString(t)},br.crypto.Util.ripemd160=function(t){return new br.crypto.MessageDigest({alg:"ripemd160",prov:"cryptojs"}).digestString(t)},br.crypto.Util.SECURERANDOMGEN=new Oe,br.crypto.Util.getRandomHexOfNbytes=function(t){var e=new Array(t);return br.crypto.Util.SECURERANDOMGEN.nextBytes(e),kr(e)},br.crypto.Util.getRandomBigIntegerOfNbytes=function(t){return new F(br.crypto.Util.getRandomHexOfNbytes(t),16)},br.crypto.Util.getRandomHexOfNbits=function(t){var e=t%8,r=new Array((t-e)/8+1);return br.crypto.Util.SECURERANDOMGEN.nextBytes(r),r[0]=(255<<e&255^255)&r[0],kr(r)},br.crypto.Util.getRandomBigIntegerOfNbits=function(t){return new F(br.crypto.Util.getRandomHexOfNbits(t),16)},br.crypto.Util.getRandomBigIntegerZeroToMax=function(t){for(var e=t.bitLength();;){var r=br.crypto.Util.getRandomBigIntegerOfNbits(e);if(-1!=t.compareTo(r))return r}},br.crypto.Util.getRandomBigIntegerMinToMax=function(t,e){var r=t.compareTo(e);if(1==r)throw"biMin is greater than biMax";if(0==r)return t;var n=e.subtract(t);return br.crypto.Util.getRandomBigIntegerZeroToMax(n).add(t)},br.crypto.MessageDigest=function(t){this.setAlgAndProvider=function(t,e){if(null!==(t=br.crypto.MessageDigest.getCanonicalAlgName(t))&&void 0===e&&(e=br.crypto.Util.DEFAULTPROVIDER[t]),-1!=":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(t)&&"cryptojs"==e){try{this.md=br.crypto.Util.CRYPTOJSMESSAGEDIGESTNAME[t].create()}catch(e){throw"setAlgAndProvider hash alg set fail alg="+t+"/"+e}this.updateString=function(t){this.md.update(t)},this.updateHex=function(t){var e=y.enc.Hex.parse(t);this.md.update(e)},this.digest=function(){return this.md.finalize().toString(y.enc.Hex)},this.digestString=function(t){return this.updateString(t),this.digest()},this.digestHex=function(t){return this.updateHex(t),this.digest()}}if(-1!=":sha256:".indexOf(t)&&"sjcl"==e){try{this.md=new sjcl.hash.sha256}catch(e){throw"setAlgAndProvider hash alg set fail alg="+t+"/"+e}this.updateString=function(t){this.md.update(t)},this.updateHex=function(t){var e=sjcl.codec.hex.toBits(t);this.md.update(e)},this.digest=function(){var t=this.md.finalize();return sjcl.codec.hex.fromBits(t)},this.digestString=function(t){return this.updateString(t),this.digest()},this.digestHex=function(t){return this.updateHex(t),this.digest()}}},this.updateString=function(t){throw"updateString(str) not supported for this alg/prov: "+this.algName+"/"+this.provName},this.updateHex=function(t){throw"updateHex(hex) not supported for this alg/prov: "+this.algName+"/"+this.provName},this.digest=function(){throw"digest() not supported for this alg/prov: "+this.algName+"/"+this.provName},this.digestString=function(t){throw"digestString(str) not supported for this alg/prov: "+this.algName+"/"+this.provName},this.digestHex=function(t){throw"digestHex(hex) not supported for this alg/prov: "+this.algName+"/"+this.provName},void 0!==t&&void 0!==t.alg&&(this.algName=t.alg,void 0===t.prov&&(this.provName=br.crypto.Util.DEFAULTPROVIDER[this.algName]),this.setAlgAndProvider(this.algName,this.provName))},br.crypto.MessageDigest.getCanonicalAlgName=function(t){return"string"==typeof t&&(t=(t=t.toLowerCase()).replace(/-/,"")),t},br.crypto.MessageDigest.getHashLength=function(t){var e=br.crypto.MessageDigest,r=e.getCanonicalAlgName(t);if(void 0===e.HASHLENGTH[r])throw"not supported algorithm: "+t;return e.HASHLENGTH[r]},br.crypto.MessageDigest.HASHLENGTH={md5:16,sha1:20,sha224:28,sha256:32,sha384:48,sha512:64,ripemd160:20},br.crypto.Mac=function(t){this.setAlgAndProvider=function(t,e){if(null==(t=t.toLowerCase())&&(t="hmacsha1"),"hmac"!=(t=t.toLowerCase()).substr(0,4))throw"setAlgAndProvider unsupported HMAC alg: "+t;void 0===e&&(e=br.crypto.Util.DEFAULTPROVIDER[t]),this.algProv=t+"/"+e;var r=t.substr(4);if(-1!=":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(r)&&"cryptojs"==e){try{var n=br.crypto.Util.CRYPTOJSMESSAGEDIGESTNAME[r];this.mac=y.algo.HMAC.create(n,this.pass)}catch(t){throw"setAlgAndProvider hash alg set fail hashAlg="+r+"/"+t}this.updateString=function(t){this.mac.update(t)},this.updateHex=function(t){var e=y.enc.Hex.parse(t);this.mac.update(e)},this.doFinal=function(){return this.mac.finalize().toString(y.enc.Hex)},this.doFinalString=function(t){return this.updateString(t),this.doFinal()},this.doFinalHex=function(t){return this.updateHex(t),this.doFinal()}}},this.updateString=function(t){throw"updateString(str) not supported for this alg/prov: "+this.algProv},this.updateHex=function(t){throw"updateHex(hex) not supported for this alg/prov: "+this.algProv},this.doFinal=function(){throw"digest() not supported for this alg/prov: "+this.algProv},this.doFinalString=function(t){throw"digestString(str) not supported for this alg/prov: "+this.algProv},this.doFinalHex=function(t){throw"digestHex(hex) not supported for this alg/prov: "+this.algProv},this.setPassword=function(t){if("string"==typeof t){var e=t;return t.length%2!=1&&t.match(/^[0-9A-Fa-f]+$/)||(e=Ur(t)),void(this.pass=y.enc.Hex.parse(e))}if("object"!=(void 0===t?"undefined":r(t)))throw"KJUR.crypto.Mac unsupported password type: "+t;e=null;if(void 0!==t.hex){if(t.hex.length%2!=0||!t.hex.match(/^[0-9A-Fa-f]+$/))throw"Mac: wrong hex password: "+t.hex;e=t.hex}if(void 0!==t.utf8&&(e=Dr(t.utf8)),void 0!==t.rstr&&(e=Ur(t.rstr)),void 0!==t.b64&&(e=b(t.b64)),void 0!==t.b64u&&(e=Ir(t.b64u)),null==e)throw"KJUR.crypto.Mac unsupported password type: "+t;this.pass=y.enc.Hex.parse(e)},void 0!==t&&(void 0!==t.pass&&this.setPassword(t.pass),void 0!==t.alg&&(this.algName=t.alg,void 0===t.prov&&(this.provName=br.crypto.Util.DEFAULTPROVIDER[this.algName]),this.setAlgAndProvider(this.algName,this.provName)))},br.crypto.Signature=function(t){var e=null;if(this._setAlgNames=function(){var t=this.algName.match(/^(.+)with(.+)$/);t&&(this.mdAlgName=t[1].toLowerCase(),this.pubkeyAlgName=t[2].toLowerCase(),"rsaandmgf1"==this.pubkeyAlgName&&"sha"==this.mdAlgName&&(this.mdAlgName="sha1"))},this._zeroPaddingOfSignature=function(t,e){for(var r="",n=e/4-t.length,i=0;i<n;i++)r+="0";return r+t},this.setAlgAndProvider=function(t,e){if(this._setAlgNames(),"cryptojs/jsrsa"!=e)throw new Error("provider not supported: "+e);if(-1!=":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(this.mdAlgName)){try{this.md=new br.crypto.MessageDigest({alg:this.mdAlgName})}catch(t){throw new Error("setAlgAndProvider hash alg set fail alg="+this.mdAlgName+"/"+t)}this.init=function(t,e){var r=null;try{r=void 0===e?Zr.getKey(t):Zr.getKey(t,e)}catch(t){throw"init failed:"+t}if(!0===r.isPrivate)this.prvKey=r,this.state="SIGN";else{if(!0!==r.isPublic)throw"init failed.:"+r;this.pubKey=r,this.state="VERIFY"}},this.updateString=function(t){this.md.updateString(t)},this.updateHex=function(t){this.md.updateHex(t)},this.sign=function(){if(this.sHashHex=this.md.digest(),void 0===this.prvKey&&void 0!==this.ecprvhex&&void 0!==this.eccurvename&&void 0!==br.crypto.ECDSA&&(this.prvKey=new br.crypto.ECDSA({curve:this.eccurvename,prv:this.ecprvhex})),this.prvKey instanceof He&&"rsaandmgf1"===this.pubkeyAlgName)this.hSign=this.prvKey.signWithMessageHashPSS(this.sHashHex,this.mdAlgName,this.pssSaltLen);else if(this.prvKey instanceof He&&"rsa"===this.pubkeyAlgName)this.hSign=this.prvKey.signWithMessageHash(this.sHashHex,this.mdAlgName);else if(this.prvKey instanceof br.crypto.ECDSA)this.hSign=this.prvKey.signWithMessageHash(this.sHashHex);else{if(!(this.prvKey instanceof br.crypto.DSA))throw"Signature: unsupported private key alg: "+this.pubkeyAlgName;this.hSign=this.prvKey.signWithMessageHash(this.sHashHex)}return this.hSign},this.signString=function(t){return this.updateString(t),this.sign()},this.signHex=function(t){return this.updateHex(t),this.sign()},this.verify=function(t){if(this.sHashHex=this.md.digest(),void 0===this.pubKey&&void 0!==this.ecpubhex&&void 0!==this.eccurvename&&void 0!==br.crypto.ECDSA&&(this.pubKey=new br.crypto.ECDSA({curve:this.eccurvename,pub:this.ecpubhex})),this.pubKey instanceof He&&"rsaandmgf1"===this.pubkeyAlgName)return this.pubKey.verifyWithMessageHashPSS(this.sHashHex,t,this.mdAlgName,this.pssSaltLen);if(this.pubKey instanceof He&&"rsa"===this.pubkeyAlgName)return this.pubKey.verifyWithMessageHash(this.sHashHex,t);if(void 0!==br.crypto.ECDSA&&this.pubKey instanceof br.crypto.ECDSA)return this.pubKey.verifyWithMessageHash(this.sHashHex,t);if(void 0!==br.crypto.DSA&&this.pubKey instanceof br.crypto.DSA)return this.pubKey.verifyWithMessageHash(this.sHashHex,t);throw"Signature: unsupported public key alg: "+this.pubkeyAlgName}}},this.init=function(t,e){throw"init(key, pass) not supported for this alg:prov="+this.algProvName},this.updateString=function(t){throw"updateString(str) not supported for this alg:prov="+this.algProvName},this.updateHex=function(t){throw"updateHex(hex) not supported for this alg:prov="+this.algProvName},this.sign=function(){throw"sign() not supported for this alg:prov="+this.algProvName},this.signString=function(t){throw"digestString(str) not supported for this alg:prov="+this.algProvName},this.signHex=function(t){throw"digestHex(hex) not supported for this alg:prov="+this.algProvName},this.verify=function(t){throw"verify(hSigVal) not supported for this alg:prov="+this.algProvName},this.initParams=t,void 0!==t&&(void 0!==t.alg&&(this.algName=t.alg,void 0===t.prov?this.provName=br.crypto.Util.DEFAULTPROVIDER[this.algName]:this.provName=t.prov,this.algProvName=this.algName+":"+this.provName,this.setAlgAndProvider(this.algName,this.provName),this._setAlgNames()),void 0!==t.psssaltlen&&(this.pssSaltLen=t.psssaltlen),void 0!==t.prvkeypem)){if(void 0!==t.prvkeypas)throw"both prvkeypem and prvkeypas parameters not supported";try{e=Zr.getKey(t.prvkeypem);this.init(e)}catch(t){throw"fatal error to load pem private key: "+t}}},br.crypto.Cipher=function(t){},br.crypto.Cipher.encrypt=function(t,e,r){if(e instanceof He&&e.isPublic){var n=br.crypto.Cipher.getAlgByKeyAndName(e,r);if("RSA"===n)return e.encrypt(t);if("RSAOAEP"===n)return e.encryptOAEP(t,"sha1");var i=n.match(/^RSAOAEP(\d+)$/);if(null!==i)return e.encryptOAEP(t,"sha"+i[1]);throw"Cipher.encrypt: unsupported algorithm for RSAKey: "+r}throw"Cipher.encrypt: unsupported key or algorithm"},br.crypto.Cipher.decrypt=function(t,e,r){if(e instanceof He&&e.isPrivate){var n=br.crypto.Cipher.getAlgByKeyAndName(e,r);if("RSA"===n)return e.decrypt(t);if("RSAOAEP"===n)return e.decryptOAEP(t,"sha1");var i=n.match(/^RSAOAEP(\d+)$/);if(null!==i)return e.decryptOAEP(t,"sha"+i[1]);throw"Cipher.decrypt: unsupported algorithm for RSAKey: "+r}throw"Cipher.decrypt: unsupported key or algorithm"},br.crypto.Cipher.getAlgByKeyAndName=function(t,e){if(t instanceof He){if(-1!=":RSA:RSAOAEP:RSAOAEP224:RSAOAEP256:RSAOAEP384:RSAOAEP512:".indexOf(e))return e;if(null==e)return"RSA";throw"getAlgByKeyAndName: not supported algorithm name for RSAKey: "+e}throw"getAlgByKeyAndName: not supported algorithm name: "+e},br.crypto.OID=new function(){this.oidhex2name={"2a864886f70d010101":"rsaEncryption","2a8648ce3d0201":"ecPublicKey","2a8648ce380401":"dsa","2a8648ce3d030107":"secp256r1","2b8104001f":"secp192k1","2b81040021":"secp224r1","2b8104000a":"secp256k1","2b81040023":"secp521r1","2b81040022":"secp384r1","2a8648ce380403":"SHA1withDSA","608648016503040301":"SHA224withDSA","608648016503040302":"SHA256withDSA"}},void 0!==br&&br||(e.KJUR=br={}),void 0!==br.crypto&&br.crypto||(br.crypto={}),br.crypto.ECDSA=function(t){var e=Error,n=F,i=Ke,o=br.crypto.ECDSA,s=br.crypto.ECParameterDB,a=o.getName,u=Er,c=u.getVbyListEx,h=u.isASN1HEX,l=new Oe;this.type="EC",this.isPrivate=!1,this.isPublic=!1,this.getBigRandom=function(t){return new n(t.bitLength(),l).mod(t.subtract(n.ONE)).add(n.ONE)},this.setNamedCurve=function(t){this.ecparams=s.getByName(t),this.prvKeyHex=null,this.pubKeyHex=null,this.curveName=t},this.setPrivateKeyHex=function(t){this.isPrivate=!0,this.prvKeyHex=t},this.setPublicKeyHex=function(t){this.isPublic=!0,this.pubKeyHex=t},this.getPublicKeyXYHex=function(){var t=this.pubKeyHex;if("04"!==t.substr(0,2))throw"this method supports uncompressed format(04) only";var e=this.ecparams.keylen/4;if(t.length!==2+2*e)throw"malformed public key hex length";var r={};return r.x=t.substr(2,e),r.y=t.substr(2+e),r},this.getShortNISTPCurveName=function(){var t=this.curveName;return"secp256r1"===t||"NIST P-256"===t||"P-256"===t||"prime256v1"===t?"P-256":"secp384r1"===t||"NIST P-384"===t||"P-384"===t?"P-384":null},this.generateKeyPairHex=function(){var t=this.ecparams.n,e=this.getBigRandom(t),r=this.ecparams.G.multiply(e),n=r.getX().toBigInteger(),i=r.getY().toBigInteger(),o=this.ecparams.keylen/4,s=("0000000000"+e.toString(16)).slice(-o),a="04"+("0000000000"+n.toString(16)).slice(-o)+("0000000000"+i.toString(16)).slice(-o);return this.setPrivateKeyHex(s),this.setPublicKeyHex(a),{ecprvhex:s,ecpubhex:a}},this.signWithMessageHash=function(t){return this.signHex(t,this.prvKeyHex)},this.signHex=function(t,e){var r=new n(e,16),i=this.ecparams.n,s=new n(t.substring(0,this.ecparams.keylen/4),16);do{var a=this.getBigRandom(i),u=this.ecparams.G.multiply(a).getX().toBigInteger().mod(i)}while(u.compareTo(n.ZERO)<=0);var c=a.modInverse(i).multiply(s.add(r.multiply(u))).mod(i);return o.biRSSigToASN1Sig(u,c)},this.sign=function(t,e){var r=e,i=this.ecparams.n,o=n.fromByteArrayUnsigned(t);do{var s=this.getBigRandom(i),a=this.ecparams.G.multiply(s).getX().toBigInteger().mod(i)}while(a.compareTo(F.ZERO)<=0);var u=s.modInverse(i).multiply(o.add(r.multiply(a))).mod(i);return this.serializeSig(a,u)},this.verifyWithMessageHash=function(t,e){return this.verifyHex(t,e,this.pubKeyHex)},this.verifyHex=function(t,e,r){try{var s,a,u=o.parseSigHex(e);s=u.r,a=u.s;var c=i.decodeFromHex(this.ecparams.curve,r),h=new n(t.substring(0,this.ecparams.keylen/4),16);return this.verifyRaw(h,s,a,c)}catch(t){return!1}},this.verify=function(t,e,o){var s,a,u;if(Bitcoin.Util.isArray(e)){var c=this.parseSig(e);s=c.r,a=c.s}else{if("object"!==(void 0===e?"undefined":r(e))||!e.r||!e.s)throw"Invalid value for signature";s=e.r,a=e.s}if(o instanceof Ke)u=o;else{if(!Bitcoin.Util.isArray(o))throw"Invalid format for pubkey value, must be byte array or ECPointFp";u=i.decodeFrom(this.ecparams.curve,o)}var h=n.fromByteArrayUnsigned(t);return this.verifyRaw(h,s,a,u)},this.verifyRaw=function(t,e,r,i){var o=this.ecparams.n,s=this.ecparams.G;if(e.compareTo(n.ONE)<0||e.compareTo(o)>=0)return!1;if(r.compareTo(n.ONE)<0||r.compareTo(o)>=0)return!1;var a=r.modInverse(o),u=t.multiply(a).mod(o),c=e.multiply(a).mod(o);return s.multiply(u).add(i.multiply(c)).getX().toBigInteger().mod(o).equals(e)},this.serializeSig=function(t,e){var r=t.toByteArraySigned(),n=e.toByteArraySigned(),i=[];return i.push(2),i.push(r.length),(i=i.concat(r)).push(2),i.push(n.length),(i=i.concat(n)).unshift(i.length),i.unshift(48),i},this.parseSig=function(t){var e;if(48!=t[0])throw new Error("Signature not a valid DERSequence");if(2!=t[e=2])throw new Error("First element in signature must be a DERInteger");var r=t.slice(e+2,e+2+t[e+1]);if(2!=t[e+=2+t[e+1]])throw new Error("Second element in signature must be a DERInteger");var i=t.slice(e+2,e+2+t[e+1]);return e+=2+t[e+1],{r:n.fromByteArrayUnsigned(r),s:n.fromByteArrayUnsigned(i)}},this.parseSigCompact=function(t){if(65!==t.length)throw"Signature has the wrong length";var e=t[0]-27;if(e<0||e>7)throw"Invalid signature type";var r=this.ecparams.n;return{r:n.fromByteArrayUnsigned(t.slice(1,33)).mod(r),s:n.fromByteArrayUnsigned(t.slice(33,65)).mod(r),i:e}},this.readPKCS5PrvKeyHex=function(t){if(!1===h(t))throw new Error("not ASN.1 hex string");var e,r,n;try{e=c(t,0,["[0]",0],"06"),r=c(t,0,[1],"04");try{n=c(t,0,["[1]",0],"03")}catch(t){}}catch(t){throw new Error("malformed PKCS#1/5 plain ECC private key")}if(this.curveName=a(e),void 0===this.curveName)throw"unsupported curve name";this.setNamedCurve(this.curveName),this.setPublicKeyHex(n),this.setPrivateKeyHex(r),this.isPublic=!1},this.readPKCS8PrvKeyHex=function(t){if(!1===h(t))throw new e("not ASN.1 hex string");var r,n,i;try{c(t,0,[1,0],"06"),r=c(t,0,[1,1],"06"),n=c(t,0,[2,0,1],"04");try{i=c(t,0,[2,0,"[1]",0],"03")}catch(t){}}catch(t){throw new e("malformed PKCS#8 plain ECC private key")}if(this.curveName=a(r),void 0===this.curveName)throw new e("unsupported curve name");this.setNamedCurve(this.curveName),this.setPublicKeyHex(i),this.setPrivateKeyHex(n),this.isPublic=!1},this.readPKCS8PubKeyHex=function(t){if(!1===h(t))throw new e("not ASN.1 hex string");var r,n;try{c(t,0,[0,0],"06"),r=c(t,0,[0,1],"06"),n=c(t,0,[1],"03")}catch(t){throw new e("malformed PKCS#8 ECC public key")}if(this.curveName=a(r),null===this.curveName)throw new e("unsupported curve name");this.setNamedCurve(this.curveName),this.setPublicKeyHex(n)},this.readCertPubKeyHex=function(t,r){if(!1===h(t))throw new e("not ASN.1 hex string");var n,i;try{n=c(t,0,[0,5,0,1],"06"),i=c(t,0,[0,5,1],"03")}catch(t){throw new e("malformed X.509 certificate ECC public key")}if(this.curveName=a(n),null===this.curveName)throw new e("unsupported curve name");this.setNamedCurve(this.curveName),this.setPublicKeyHex(i)},void 0!==t&&void 0!==t.curve&&(this.curveName=t.curve),void 0===this.curveName&&(this.curveName="secp256r1"),this.setNamedCurve(this.curveName),void 0!==t&&(void 0!==t.prv&&this.setPrivateKeyHex(t.prv),void 0!==t.pub&&this.setPublicKeyHex(t.pub))},br.crypto.ECDSA.parseSigHex=function(t){var e=br.crypto.ECDSA.parseSigHexInHexRS(t);return{r:new F(e.r,16),s:new F(e.s,16)}},br.crypto.ECDSA.parseSigHexInHexRS=function(t){var e=Er,r=e.getChildIdx,n=e.getV;if(e.checkStrictDER(t,0),"30"!=t.substr(0,2))throw new Error("signature is not a ASN.1 sequence");var i=r(t,0);if(2!=i.length)throw new Error("signature shall have two elements");var o=i[0],s=i[1];if("02"!=t.substr(o,2))throw new Error("1st item not ASN.1 integer");if("02"!=t.substr(s,2))throw new Error("2nd item not ASN.1 integer");return{r:n(t,o),s:n(t,s)}},br.crypto.ECDSA.asn1SigToConcatSig=function(t){var e=br.crypto.ECDSA.parseSigHexInHexRS(t),r=e.r,n=e.s;if("00"==r.substr(0,2)&&r.length%32==2&&(r=r.substr(2)),"00"==n.substr(0,2)&&n.length%32==2&&(n=n.substr(2)),r.length%32==30&&(r="00"+r),n.length%32==30&&(n="00"+n),r.length%32!=0)throw"unknown ECDSA sig r length error";if(n.length%32!=0)throw"unknown ECDSA sig s length error";return r+n},br.crypto.ECDSA.concatSigToASN1Sig=function(t){if(t.length/2*8%128!=0)throw"unknown ECDSA concatinated r-s sig  length error";var e=t.substr(0,t.length/2),r=t.substr(t.length/2);return br.crypto.ECDSA.hexRSSigToASN1Sig(e,r)},br.crypto.ECDSA.hexRSSigToASN1Sig=function(t,e){var r=new F(t,16),n=new F(e,16);return br.crypto.ECDSA.biRSSigToASN1Sig(r,n)},br.crypto.ECDSA.biRSSigToASN1Sig=function(t,e){var r=br.asn1,n=new r.DERInteger({bigint:t}),i=new r.DERInteger({bigint:e});return new r.DERSequence({array:[n,i]}).getEncodedHex()},br.crypto.ECDSA.getName=function(t){return"2b8104001f"===t?"secp192k1":"2a8648ce3d030107"===t?"secp256r1":"2b8104000a"===t?"secp256k1":"2b81040021"===t?"secp224r1":"2b81040022"===t?"secp384r1":-1!=="|secp256r1|NIST P-256|P-256|prime256v1|".indexOf(t)?"secp256r1":-1!=="|secp256k1|".indexOf(t)?"secp256k1":-1!=="|secp224r1|NIST P-224|P-224|".indexOf(t)?"secp224r1":-1!=="|secp384r1|NIST P-384|P-384|".indexOf(t)?"secp384r1":null},void 0!==br&&br||(e.KJUR=br={}),void 0!==br.crypto&&br.crypto||(br.crypto={}),br.crypto.ECParameterDB=new function(){var t={},e={};function r(t){return new F(t,16)}this.getByName=function(r){var n=r;if(void 0!==e[n]&&(n=e[r]),void 0!==t[n])return t[n];throw"unregistered EC curve name: "+n},this.regist=function(n,i,o,s,a,u,c,h,l,f,g,d){t[n]={};var p=r(o),v=r(s),y=r(a),m=r(u),_=r(c),S=new qe(p,v,y),b=S.decodePointHex("04"+h+l);t[n].name=n,t[n].keylen=i,t[n].curve=S,t[n].G=b,t[n].n=m,t[n].h=_,t[n].oid=g,t[n].info=d;for(var w=0;w<f.length;w++)e[f[w]]=n}},br.crypto.ECParameterDB.regist("secp128r1",128,"FFFFFFFDFFFFFFFFFFFFFFFFFFFFFFFF","FFFFFFFDFFFFFFFFFFFFFFFFFFFFFFFC","E87579C11079F43DD824993C2CEE5ED3","FFFFFFFE0000000075A30D1B9038A115","1","161FF7528B899B2D0C28607CA52C5B86","CF5AC8395BAFEB13C02DA292DDED7A83",[],"","secp128r1 : SECG curve over a 128 bit prime field"),br.crypto.ECParameterDB.regist("secp160k1",160,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFAC73","0","7","0100000000000000000001B8FA16DFAB9ACA16B6B3","1","3B4C382CE37AA192A4019E763036F4F5DD4D7EBB","938CF935318FDCED6BC28286531733C3F03C4FEE",[],"","secp160k1 : SECG curve over a 160 bit prime field"),br.crypto.ECParameterDB.regist("secp160r1",160,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF7FFFFFFF","FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF7FFFFFFC","1C97BEFC54BD7A8B65ACF89F81D4D4ADC565FA45","0100000000000000000001F4C8F927AED3CA752257","1","4A96B5688EF573284664698968C38BB913CBFC82","23A628553168947D59DCC912042351377AC5FB32",[],"","secp160r1 : SECG curve over a 160 bit prime field"),br.crypto.ECParameterDB.regist("secp192k1",192,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFEE37","0","3","FFFFFFFFFFFFFFFFFFFFFFFE26F2FC170F69466A74DEFD8D","1","DB4FF10EC057E9AE26B07D0280B7F4341DA5D1B1EAE06C7D","9B2F2F6D9C5628A7844163D015BE86344082AA88D95E2F9D",[]),br.crypto.ECParameterDB.regist("secp192r1",192,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFF","FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFC","64210519E59C80E70FA7E9AB72243049FEB8DEECC146B9B1","FFFFFFFFFFFFFFFFFFFFFFFF99DEF836146BC9B1B4D22831","1","188DA80EB03090F67CBF20EB43A18800F4FF0AFD82FF1012","07192B95FFC8DA78631011ED6B24CDD573F977A11E794811",[]),br.crypto.ECParameterDB.regist("secp224r1",224,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF000000000000000000000001","FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFFFFFFFFFE","B4050A850C04B3ABF54132565044B0B7D7BFD8BA270B39432355FFB4","FFFFFFFFFFFFFFFFFFFFFFFFFFFF16A2E0B8F03E13DD29455C5C2A3D","1","B70E0CBD6BB4BF7F321390B94A03C1D356C21122343280D6115C1D21","BD376388B5F723FB4C22DFE6CD4375A05A07476444D5819985007E34",[]),br.crypto.ECParameterDB.regist("secp256k1",256,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFC2F","0","7","FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141","1","79BE667EF9DCBBAC55A06295CE870B07029BFCDB2DCE28D959F2815B16F81798","483ADA7726A3C4655DA4FBFC0E1108A8FD17B448A68554199C47D08FFB10D4B8",[]),br.crypto.ECParameterDB.regist("secp256r1",256,"FFFFFFFF00000001000000000000000000000000FFFFFFFFFFFFFFFFFFFFFFFF","FFFFFFFF00000001000000000000000000000000FFFFFFFFFFFFFFFFFFFFFFFC","5AC635D8AA3A93E7B3EBBD55769886BC651D06B0CC53B0F63BCE3C3E27D2604B","FFFFFFFF00000000FFFFFFFFFFFFFFFFBCE6FAADA7179E84F3B9CAC2FC632551","1","6B17D1F2E12C4247F8BCE6E563A440F277037D812DEB33A0F4A13945D898C296","4FE342E2FE1A7F9B8EE7EB4A7C0F9E162BCE33576B315ECECBB6406837BF51F5",["NIST P-256","P-256","prime256v1"]),br.crypto.ECParameterDB.regist("secp384r1",384,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFF0000000000000000FFFFFFFF","FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFF0000000000000000FFFFFFFC","B3312FA7E23EE7E4988E056BE3F82D19181D9C6EFE8141120314088F5013875AC656398D8A2ED19D2A85C8EDD3EC2AEF","FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFC7634D81F4372DDF581A0DB248B0A77AECEC196ACCC52973","1","AA87CA22BE8B05378EB1C71EF320AD746E1D3B628BA79B9859F741E082542A385502F25DBF55296C3A545E3872760AB7","3617de4a96262c6f5d9e98bf9292dc29f8f41dbd289a147ce9da3113b5f0b8c00a60b1ce1d7e819d7a431d7c90ea0e5f",["NIST P-384","P-384"]),br.crypto.ECParameterDB.regist("secp521r1",521,"1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF","1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFC","051953EB9618E1C9A1F929A21A0B68540EEA2DA725B99B315F3B8B489918EF109E156193951EC7E937B1652C0BD3BB1BF073573DF883D2C34F1EF451FD46B503F00","1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFA51868783BF2F966B7FCC0148F709A5D03BB5C9B8899C47AEBB6FB71E91386409","1","C6858E06B70404E9CD9E3ECB662395B4429C648139053FB521F828AF606B4D3DBAA14B5E77EFE75928FE1DC127A2FFA8DE3348B3C1856A429BF97E7E31C2E5BD66","011839296a789a3bc0045c8a5fb42c7d1bd998f54449579b446817afbd17273e662c97ee72995ef42640c550b9013fad0761353c7086a272c24088be94769fd16650",["NIST P-521","P-521"]);var Zr=function(){var t=function t(r,n,i){return e(y.AES,r,n,i)},e=function t(e,r,n,i){var o=y.enc.Hex.parse(r),s=y.enc.Hex.parse(n),a=y.enc.Hex.parse(i),u={};u.key=s,u.iv=a,u.ciphertext=o;var c=e.decrypt(u,s,{iv:a});return y.enc.Hex.stringify(c)},r=function t(e,r,i){return n(y.AES,e,r,i)},n=function t(e,r,n,i){var o=y.enc.Hex.parse(r),s=y.enc.Hex.parse(n),a=y.enc.Hex.parse(i),u=e.encrypt(o,s,{iv:a}),c=y.enc.Hex.parse(u.toString());return y.enc.Base64.stringify(c)},i={"AES-256-CBC":{proc:t,eproc:r,keylen:32,ivlen:16},"AES-192-CBC":{proc:t,eproc:r,keylen:24,ivlen:16},"AES-128-CBC":{proc:t,eproc:r,keylen:16,ivlen:16},"DES-EDE3-CBC":{proc:function t(r,n,i){return e(y.TripleDES,r,n,i)},eproc:function t(e,r,i){return n(y.TripleDES,e,r,i)},keylen:24,ivlen:8},"DES-CBC":{proc:function t(r,n,i){return e(y.DES,r,n,i)},eproc:function t(e,r,i){return n(y.DES,e,r,i)},keylen:8,ivlen:8}},o=function t(e){var r={},n=e.match(new RegExp("DEK-Info: ([^,]+),([0-9A-Fa-f]+)","m"));n&&(r.cipher=n[1],r.ivsalt=n[2]);var i=e.match(new RegExp("-----BEGIN ([A-Z]+) PRIVATE KEY-----"));i&&(r.type=i[1]);var o=-1,s=0;-1!=e.indexOf("\r\n\r\n")&&(o=e.indexOf("\r\n\r\n"),s=2),-1!=e.indexOf("\n\n")&&(o=e.indexOf("\n\n"),s=1);var a=e.indexOf("-----END");if(-1!=o&&-1!=a){var u=e.substring(o+2*s,a-s);u=u.replace(/\s+/g,""),r.data=u}return r},s=function t(e,r,n){for(var o=n.substring(0,16),s=y.enc.Hex.parse(o),a=y.enc.Utf8.parse(r),u=i[e].keylen+i[e].ivlen,c="",h=null;;){var l=y.algo.MD5.create();if(null!=h&&l.update(h),l.update(a),l.update(s),h=l.finalize(),(c+=y.enc.Hex.stringify(h)).length>=2*u)break}var f={};return f.keyhex=c.substr(0,2*i[e].keylen),f.ivhex=c.substr(2*i[e].keylen,2*i[e].ivlen),f},a=function t(e,r,n,o){var s=y.enc.Base64.parse(e),a=y.enc.Hex.stringify(s);return(0,i[r].proc)(a,n,o)};return{version:"1.0.0",parsePKCS5PEM:function t(e){return o(e)},getKeyAndUnusedIvByPasscodeAndIvsalt:function t(e,r,n){return s(e,r,n)},decryptKeyB64:function t(e,r,n,i){return a(e,r,n,i)},getDecryptedKeyHex:function t(e,r){var n=o(e),i=(n.type,n.cipher),u=n.ivsalt,c=n.data,h=s(i,r,u).keyhex;return a(c,i,h,u)},getEncryptedPKCS5PEMFromPrvKeyHex:function t(e,r,n,o,a){var u="";if(void 0!==o&&null!=o||(o="AES-256-CBC"),void 0===i[o])throw"KEYUTIL unsupported algorithm: "+o;void 0!==a&&null!=a||(a=function t(e){var r=y.lib.WordArray.random(e);return y.enc.Hex.stringify(r)}(i[o].ivlen).toUpperCase());var c=function t(e,r,n,o){return(0,i[r].eproc)(e,n,o)}(r,o,s(o,n,a).keyhex,a);u="-----BEGIN "+e+" PRIVATE KEY-----\r\n";return u+="Proc-Type: 4,ENCRYPTED\r\n",u+="DEK-Info: "+o+","+a+"\r\n",u+="\r\n",u+=c.replace(/(.{64})/g,"$1\r\n"),u+="\r\n-----END "+e+" PRIVATE KEY-----\r\n"},parseHexOfEncryptedPKCS8:function t(e){var r=Er,n=r.getChildIdx,i=r.getV,o={},s=n(e,0);if(2!=s.length)throw"malformed format: SEQUENCE(0).items != 2: "+s.length;o.ciphertext=i(e,s[1]);var a=n(e,s[0]);if(2!=a.length)throw"malformed format: SEQUENCE(0.0).items != 2: "+a.length;if("2a864886f70d01050d"!=i(e,a[0]))throw"this only supports pkcs5PBES2";var u=n(e,a[1]);if(2!=a.length)throw"malformed format: SEQUENCE(0.0.1).items != 2: "+u.length;var c=n(e,u[1]);if(2!=c.length)throw"malformed format: SEQUENCE(0.0.1.1).items != 2: "+c.length;if("2a864886f70d0307"!=i(e,c[0]))throw"this only supports TripleDES";o.encryptionSchemeAlg="TripleDES",o.encryptionSchemeIV=i(e,c[1]);var h=n(e,u[0]);if(2!=h.length)throw"malformed format: SEQUENCE(0.0.1.0).items != 2: "+h.length;if("2a864886f70d01050c"!=i(e,h[0]))throw"this only supports pkcs5PBKDF2";var l=n(e,h[1]);if(l.length<2)throw"malformed format: SEQUENCE(0.0.1.0.1).items < 2: "+l.length;o.pbkdf2Salt=i(e,l[0]);var f=i(e,l[1]);try{o.pbkdf2Iter=parseInt(f,16)}catch(t){throw"malformed format pbkdf2Iter: "+f}return o},getPBKDF2KeyHexFromParam:function t(e,r){var n=y.enc.Hex.parse(e.pbkdf2Salt),i=e.pbkdf2Iter,o=y.PBKDF2(r,n,{keySize:6,iterations:i});return y.enc.Hex.stringify(o)},_getPlainPKCS8HexFromEncryptedPKCS8PEM:function t(e,r){var n=Hr(e,"ENCRYPTED PRIVATE KEY"),i=this.parseHexOfEncryptedPKCS8(n),o=Zr.getPBKDF2KeyHexFromParam(i,r),s={};s.ciphertext=y.enc.Hex.parse(i.ciphertext);var a=y.enc.Hex.parse(o),u=y.enc.Hex.parse(i.encryptionSchemeIV),c=y.TripleDES.decrypt(s,a,{iv:u});return y.enc.Hex.stringify(c)},getKeyFromEncryptedPKCS8PEM:function t(e,r){var n=this._getPlainPKCS8HexFromEncryptedPKCS8PEM(e,r);return this.getKeyFromPlainPrivatePKCS8Hex(n)},parsePlainPrivatePKCS8Hex:function t(e){var r=Er,n=r.getChildIdx,i=r.getV,o={algparam:null};if("30"!=e.substr(0,2))throw"malformed plain PKCS8 private key(code:001)";var s=n(e,0);if(3!=s.length)throw"malformed plain PKCS8 private key(code:002)";if("30"!=e.substr(s[1],2))throw"malformed PKCS8 private key(code:003)";var a=n(e,s[1]);if(2!=a.length)throw"malformed PKCS8 private key(code:004)";if("06"!=e.substr(a[0],2))throw"malformed PKCS8 private key(code:005)";if(o.algoid=i(e,a[0]),"06"==e.substr(a[1],2)&&(o.algparam=i(e,a[1])),"04"!=e.substr(s[2],2))throw"malformed PKCS8 private key(code:006)";return o.keyidx=r.getVidx(e,s[2]),o},getKeyFromPlainPrivatePKCS8PEM:function t(e){var r=Hr(e,"PRIVATE KEY");return this.getKeyFromPlainPrivatePKCS8Hex(r)},getKeyFromPlainPrivatePKCS8Hex:function t(e){var r,n=this.parsePlainPrivatePKCS8Hex(e);if("2a864886f70d010101"==n.algoid)r=new He;else if("2a8648ce380401"==n.algoid)r=new br.crypto.DSA;else{if("2a8648ce3d0201"!=n.algoid)throw"unsupported private key algorithm";r=new br.crypto.ECDSA}return r.readPKCS8PrvKeyHex(e),r},_getKeyFromPublicPKCS8Hex:function t(e){var r,n=Er.getVbyList(e,0,[0,0],"06");if("2a864886f70d010101"===n)r=new He;else if("2a8648ce380401"===n)r=new br.crypto.DSA;else{if("2a8648ce3d0201"!==n)throw"unsupported PKCS#8 public key hex";r=new br.crypto.ECDSA}return r.readPKCS8PubKeyHex(e),r},parsePublicRawRSAKeyHex:function t(e){var r=Er,n=r.getChildIdx,i=r.getV,o={};if("30"!=e.substr(0,2))throw"malformed RSA key(code:001)";var s=n(e,0);if(2!=s.length)throw"malformed RSA key(code:002)";if("02"!=e.substr(s[0],2))throw"malformed RSA key(code:003)";if(o.n=i(e,s[0]),"02"!=e.substr(s[1],2))throw"malformed RSA key(code:004)";return o.e=i(e,s[1]),o},parsePublicPKCS8Hex:function t(e){var r=Er,n=r.getChildIdx,i=r.getV,o={algparam:null},s=n(e,0);if(2!=s.length)throw"outer DERSequence shall have 2 elements: "+s.length;var a=s[0];if("30"!=e.substr(a,2))throw"malformed PKCS8 public key(code:001)";var u=n(e,a);if(2!=u.length)throw"malformed PKCS8 public key(code:002)";if("06"!=e.substr(u[0],2))throw"malformed PKCS8 public key(code:003)";if(o.algoid=i(e,u[0]),"06"==e.substr(u[1],2)?o.algparam=i(e,u[1]):"30"==e.substr(u[1],2)&&(o.algparam={},o.algparam.p=r.getVbyList(e,u[1],[0],"02"),o.algparam.q=r.getVbyList(e,u[1],[1],"02"),o.algparam.g=r.getVbyList(e,u[1],[2],"02")),"03"!=e.substr(s[1],2))throw"malformed PKCS8 public key(code:004)";return o.key=i(e,s[1]).substr(2),o}}}();Zr.getKey=function(t,e,r){var n=(v=Er).getChildIdx,i=(v.getV,v.getVbyList),o=br.crypto,s=o.ECDSA,a=o.DSA,u=He,c=Hr,h=Zr;if(void 0!==u&&t instanceof u)return t;if(void 0!==s&&t instanceof s)return t;if(void 0!==a&&t instanceof a)return t;if(void 0!==t.curve&&void 0!==t.xy&&void 0===t.d)return new s({pub:t.xy,curve:t.curve});if(void 0!==t.curve&&void 0!==t.d)return new s({prv:t.d,curve:t.curve});if(void 0===t.kty&&void 0!==t.n&&void 0!==t.e&&void 0===t.d)return(P=new u).setPublic(t.n,t.e),P;if(void 0===t.kty&&void 0!==t.n&&void 0!==t.e&&void 0!==t.d&&void 0!==t.p&&void 0!==t.q&&void 0!==t.dp&&void 0!==t.dq&&void 0!==t.co&&void 0===t.qi)return(P=new u).setPrivateEx(t.n,t.e,t.d,t.p,t.q,t.dp,t.dq,t.co),P;if(void 0===t.kty&&void 0!==t.n&&void 0!==t.e&&void 0!==t.d&&void 0===t.p)return(P=new u).setPrivate(t.n,t.e,t.d),P;if(void 0!==t.p&&void 0!==t.q&&void 0!==t.g&&void 0!==t.y&&void 0===t.x)return(P=new a).setPublic(t.p,t.q,t.g,t.y),P;if(void 0!==t.p&&void 0!==t.q&&void 0!==t.g&&void 0!==t.y&&void 0!==t.x)return(P=new a).setPrivate(t.p,t.q,t.g,t.y,t.x),P;if("RSA"===t.kty&&void 0!==t.n&&void 0!==t.e&&void 0===t.d)return(P=new u).setPublic(Ir(t.n),Ir(t.e)),P;if("RSA"===t.kty&&void 0!==t.n&&void 0!==t.e&&void 0!==t.d&&void 0!==t.p&&void 0!==t.q&&void 0!==t.dp&&void 0!==t.dq&&void 0!==t.qi)return(P=new u).setPrivateEx(Ir(t.n),Ir(t.e),Ir(t.d),Ir(t.p),Ir(t.q),Ir(t.dp),Ir(t.dq),Ir(t.qi)),P;if("RSA"===t.kty&&void 0!==t.n&&void 0!==t.e&&void 0!==t.d)return(P=new u).setPrivate(Ir(t.n),Ir(t.e),Ir(t.d)),P;if("EC"===t.kty&&void 0!==t.crv&&void 0!==t.x&&void 0!==t.y&&void 0===t.d){var l=(k=new s({curve:t.crv})).ecparams.keylen/4,f="04"+("0000000000"+Ir(t.x)).slice(-l)+("0000000000"+Ir(t.y)).slice(-l);return k.setPublicKeyHex(f),k}if("EC"===t.kty&&void 0!==t.crv&&void 0!==t.x&&void 0!==t.y&&void 0!==t.d){l=(k=new s({curve:t.crv})).ecparams.keylen/4,f="04"+("0000000000"+Ir(t.x)).slice(-l)+("0000000000"+Ir(t.y)).slice(-l);var g=("0000000000"+Ir(t.d)).slice(-l);return k.setPublicKeyHex(f),k.setPrivateKeyHex(g),k}if("pkcs5prv"===r){var d,p=t,v=Er;if(9===(d=n(p,0)).length)(P=new u).readPKCS5PrvKeyHex(p);else if(6===d.length)(P=new a).readPKCS5PrvKeyHex(p);else{if(!(d.length>2&&"04"===p.substr(d[1],2)))throw"unsupported PKCS#1/5 hexadecimal key";(P=new s).readPKCS5PrvKeyHex(p)}return P}if("pkcs8prv"===r)return P=h.getKeyFromPlainPrivatePKCS8Hex(t);if("pkcs8pub"===r)return h._getKeyFromPublicPKCS8Hex(t);if("x509pub"===r)return on.getPublicKeyFromCertHex(t);if(-1!=t.indexOf("-END CERTIFICATE-",0)||-1!=t.indexOf("-END X509 CERTIFICATE-",0)||-1!=t.indexOf("-END TRUSTED CERTIFICATE-",0))return on.getPublicKeyFromCertPEM(t);if(-1!=t.indexOf("-END PUBLIC KEY-")){var y=Hr(t,"PUBLIC KEY");return h._getKeyFromPublicPKCS8Hex(y)}if(-1!=t.indexOf("-END RSA PRIVATE KEY-")&&-1==t.indexOf("4,ENCRYPTED")){var m=c(t,"RSA PRIVATE KEY");return h.getKey(m,null,"pkcs5prv")}if(-1!=t.indexOf("-END DSA PRIVATE KEY-")&&-1==t.indexOf("4,ENCRYPTED")){var _=i(R=c(t,"DSA PRIVATE KEY"),0,[1],"02"),S=i(R,0,[2],"02"),b=i(R,0,[3],"02"),w=i(R,0,[4],"02"),E=i(R,0,[5],"02");return(P=new a).setPrivate(new F(_,16),new F(S,16),new F(b,16),new F(w,16),new F(E,16)),P}if(-1!=t.indexOf("-END EC PRIVATE KEY-")&&-1==t.indexOf("4,ENCRYPTED")){m=c(t,"EC PRIVATE KEY");return h.getKey(m,null,"pkcs5prv")}if(-1!=t.indexOf("-END PRIVATE KEY-"))return h.getKeyFromPlainPrivatePKCS8PEM(t);if(-1!=t.indexOf("-END RSA PRIVATE KEY-")&&-1!=t.indexOf("4,ENCRYPTED")){var x=h.getDecryptedKeyHex(t,e),A=new He;return A.readPKCS5PrvKeyHex(x),A}if(-1!=t.indexOf("-END EC PRIVATE KEY-")&&-1!=t.indexOf("4,ENCRYPTED")){var k,P=i(R=h.getDecryptedKeyHex(t,e),0,[1],"04"),C=i(R,0,[2,0],"06"),T=i(R,0,[3,0],"03").substr(2);if(void 0===br.crypto.OID.oidhex2name[C])throw"undefined OID(hex) in KJUR.crypto.OID: "+C;return(k=new s({curve:br.crypto.OID.oidhex2name[C]})).setPublicKeyHex(T),k.setPrivateKeyHex(P),k.isPublic=!1,k}if(-1!=t.indexOf("-END DSA PRIVATE KEY-")&&-1!=t.indexOf("4,ENCRYPTED")){var R;_=i(R=h.getDecryptedKeyHex(t,e),0,[1],"02"),S=i(R,0,[2],"02"),b=i(R,0,[3],"02"),w=i(R,0,[4],"02"),E=i(R,0,[5],"02");return(P=new a).setPrivate(new F(_,16),new F(S,16),new F(b,16),new F(w,16),new F(E,16)),P}if(-1!=t.indexOf("-END ENCRYPTED PRIVATE KEY-"))return h.getKeyFromEncryptedPKCS8PEM(t,e);throw new Error("not supported argument")},Zr.generateKeypair=function(t,e){if("RSA"==t){var r=e;(s=new He).generate(r,"10001"),s.isPrivate=!0,s.isPublic=!0;var n=new He,i=s.n.toString(16),o=s.e.toString(16);return n.setPublic(i,o),n.isPrivate=!1,n.isPublic=!0,(a={}).prvKeyObj=s,a.pubKeyObj=n,a}if("EC"==t){var s,a,u=e,c=new br.crypto.ECDSA({curve:u}).generateKeyPairHex();return(s=new br.crypto.ECDSA({curve:u})).setPublicKeyHex(c.ecpubhex),s.setPrivateKeyHex(c.ecprvhex),s.isPrivate=!0,s.isPublic=!1,(n=new br.crypto.ECDSA({curve:u})).setPublicKeyHex(c.ecpubhex),n.isPrivate=!1,n.isPublic=!0,(a={}).prvKeyObj=s,a.pubKeyObj=n,a}throw"unknown algorithm: "+t},Zr.getPEM=function(t,e,r,n,i,o){var s=br,a=s.asn1,u=a.DERObjectIdentifier,c=a.DERInteger,h=a.ASN1Util.newObject,l=a.x509.SubjectPublicKeyInfo,f=s.crypto,g=f.DSA,d=f.ECDSA,p=He;function v(t){return h({seq:[{int:0},{int:{bigint:t.n}},{int:t.e},{int:{bigint:t.d}},{int:{bigint:t.p}},{int:{bigint:t.q}},{int:{bigint:t.dmp1}},{int:{bigint:t.dmq1}},{int:{bigint:t.coeff}}]})}function m(t){return h({seq:[{int:1},{octstr:{hex:t.prvKeyHex}},{tag:["a0",!0,{oid:{name:t.curveName}}]},{tag:["a1",!0,{bitstr:{hex:"00"+t.pubKeyHex}}]}]})}function _(t){return h({seq:[{int:0},{int:{bigint:t.p}},{int:{bigint:t.q}},{int:{bigint:t.g}},{int:{bigint:t.y}},{int:{bigint:t.x}}]})}if((void 0!==p&&t instanceof p||void 0!==g&&t instanceof g||void 0!==d&&t instanceof d)&&1==t.isPublic&&(void 0===e||"PKCS8PUB"==e))return Mr(F=new l(t).getEncodedHex(),"PUBLIC KEY");if("PKCS1PRV"==e&&void 0!==p&&t instanceof p&&(void 0===r||null==r)&&1==t.isPrivate)return Mr(F=v(t).getEncodedHex(),"RSA PRIVATE KEY");if("PKCS1PRV"==e&&void 0!==d&&t instanceof d&&(void 0===r||null==r)&&1==t.isPrivate){var S=new u({name:t.curveName}).getEncodedHex(),b=m(t).getEncodedHex(),w="";return w+=Mr(S,"EC PARAMETERS"),w+=Mr(b,"EC PRIVATE KEY")}if("PKCS1PRV"==e&&void 0!==g&&t instanceof g&&(void 0===r||null==r)&&1==t.isPrivate)return Mr(F=_(t).getEncodedHex(),"DSA PRIVATE KEY");if("PKCS5PRV"==e&&void 0!==p&&t instanceof p&&void 0!==r&&null!=r&&1==t.isPrivate){var F=v(t).getEncodedHex();return void 0===n&&(n="DES-EDE3-CBC"),this.getEncryptedPKCS5PEMFromPrvKeyHex("RSA",F,r,n,o)}if("PKCS5PRV"==e&&void 0!==d&&t instanceof d&&void 0!==r&&null!=r&&1==t.isPrivate){F=m(t).getEncodedHex();return void 0===n&&(n="DES-EDE3-CBC"),this.getEncryptedPKCS5PEMFromPrvKeyHex("EC",F,r,n,o)}if("PKCS5PRV"==e&&void 0!==g&&t instanceof g&&void 0!==r&&null!=r&&1==t.isPrivate){F=_(t).getEncodedHex();return void 0===n&&(n="DES-EDE3-CBC"),this.getEncryptedPKCS5PEMFromPrvKeyHex("DSA",F,r,n,o)}var E=function t(e,r){var n=x(e,r);return new h({seq:[{seq:[{oid:{name:"pkcs5PBES2"}},{seq:[{seq:[{oid:{name:"pkcs5PBKDF2"}},{seq:[{octstr:{hex:n.pbkdf2Salt}},{int:n.pbkdf2Iter}]}]},{seq:[{oid:{name:"des-EDE3-CBC"}},{octstr:{hex:n.encryptionSchemeIV}}]}]}]},{octstr:{hex:n.ciphertext}}]}).getEncodedHex()},x=function t(e,r){var n=y.lib.WordArray.random(8),i=y.lib.WordArray.random(8),o=y.PBKDF2(r,n,{keySize:6,iterations:100}),s=y.enc.Hex.parse(e),a=y.TripleDES.encrypt(s,o,{iv:i})+"",u={};return u.ciphertext=a,u.pbkdf2Salt=y.enc.Hex.stringify(n),u.pbkdf2Iter=100,u.encryptionSchemeAlg="DES-EDE3-CBC",u.encryptionSchemeIV=y.enc.Hex.stringify(i),u};if("PKCS8PRV"==e&&null!=p&&t instanceof p&&1==t.isPrivate){var A=v(t).getEncodedHex();F=h({seq:[{int:0},{seq:[{oid:{name:"rsaEncryption"}},{null:!0}]},{octstr:{hex:A}}]}).getEncodedHex();return void 0===r||null==r?Mr(F,"PRIVATE KEY"):Mr(b=E(F,r),"ENCRYPTED PRIVATE KEY")}if("PKCS8PRV"==e&&void 0!==d&&t instanceof d&&1==t.isPrivate){A=new h({seq:[{int:1},{octstr:{hex:t.prvKeyHex}},{tag:["a1",!0,{bitstr:{hex:"00"+t.pubKeyHex}}]}]}).getEncodedHex(),F=h({seq:[{int:0},{seq:[{oid:{name:"ecPublicKey"}},{oid:{name:t.curveName}}]},{octstr:{hex:A}}]}).getEncodedHex();return void 0===r||null==r?Mr(F,"PRIVATE KEY"):Mr(b=E(F,r),"ENCRYPTED PRIVATE KEY")}if("PKCS8PRV"==e&&void 0!==g&&t instanceof g&&1==t.isPrivate){A=new c({bigint:t.x}).getEncodedHex(),F=h({seq:[{int:0},{seq:[{oid:{name:"dsa"}},{seq:[{int:{bigint:t.p}},{int:{bigint:t.q}},{int:{bigint:t.g}}]}]},{octstr:{hex:A}}]}).getEncodedHex();return void 0===r||null==r?Mr(F,"PRIVATE KEY"):Mr(b=E(F,r),"ENCRYPTED PRIVATE KEY")}throw new Error("unsupported object nor format")},Zr.getKeyFromCSRPEM=function(t){var e=Hr(t,"CERTIFICATE REQUEST");return Zr.getKeyFromCSRHex(e)},Zr.getKeyFromCSRHex=function(t){var e=Zr.parseCSRHex(t);return Zr.getKey(e.p8pubkeyhex,null,"pkcs8pub")},Zr.parseCSRHex=function(t){var e=Er,r=e.getChildIdx,n=e.getTLV,i={},o=t;if("30"!=o.substr(0,2))throw"malformed CSR(code:001)";var s=r(o,0);if(s.length<1)throw"malformed CSR(code:002)";if("30"!=o.substr(s[0],2))throw"malformed CSR(code:003)";var a=r(o,s[0]);if(a.length<3)throw"malformed CSR(code:004)";return i.p8pubkeyhex=n(o,a[2]),i},Zr.getKeyID=function(t){var e=Zr,r=Er;"string"==typeof t&&-1!=t.indexOf("BEGIN ")&&(t=e.getKey(t));var n=Hr(e.getPEM(t)),i=r.getIdxbyList(n,0,[1]),o=r.getV(n,i).substring(2);return br.crypto.Util.hashHex(o,"sha1")},Zr.getJWKFromKey=function(t){var e={};if(t instanceof He&&t.isPrivate)return e.kty="RSA",e.n=Rr(t.n.toString(16)),e.e=Rr(t.e.toString(16)),e.d=Rr(t.d.toString(16)),e.p=Rr(t.p.toString(16)),e.q=Rr(t.q.toString(16)),e.dp=Rr(t.dmp1.toString(16)),e.dq=Rr(t.dmq1.toString(16)),e.qi=Rr(t.coeff.toString(16)),e;if(t instanceof He&&t.isPublic)return e.kty="RSA",e.n=Rr(t.n.toString(16)),e.e=Rr(t.e.toString(16)),e;if(t instanceof br.crypto.ECDSA&&t.isPrivate){if("P-256"!==(n=t.getShortNISTPCurveName())&&"P-384"!==n)throw"unsupported curve name for JWT: "+n;var r=t.getPublicKeyXYHex();return e.kty="EC",e.crv=n,e.x=Rr(r.x),e.y=Rr(r.y),e.d=Rr(t.prvKeyHex),e}if(t instanceof br.crypto.ECDSA&&t.isPublic){var n;if("P-256"!==(n=t.getShortNISTPCurveName())&&"P-384"!==n)throw"unsupported curve name for JWT: "+n;r=t.getPublicKeyXYHex();return e.kty="EC",e.crv=n,e.x=Rr(r.x),e.y=Rr(r.y),e}throw"not supported key object"},He.getPosArrayOfChildrenFromHex=function(t){return Er.getChildIdx(t,0)},He.getHexValueArrayOfChildrenFromHex=function(t){var e,r=Er.getV,n=r(t,(e=He.getPosArrayOfChildrenFromHex(t))[0]),i=r(t,e[1]),o=r(t,e[2]),s=r(t,e[3]),a=r(t,e[4]),u=r(t,e[5]),c=r(t,e[6]),h=r(t,e[7]),l=r(t,e[8]);return(e=new Array).push(n,i,o,s,a,u,c,h,l),e},He.prototype.readPrivateKeyFromPEMString=function(t){var e=Hr(t),r=He.getHexValueArrayOfChildrenFromHex(e);this.setPrivateEx(r[1],r[2],r[3],r[4],r[5],r[6],r[7],r[8])},He.prototype.readPKCS5PrvKeyHex=function(t){var e=He.getHexValueArrayOfChildrenFromHex(t);this.setPrivateEx(e[1],e[2],e[3],e[4],e[5],e[6],e[7],e[8])},He.prototype.readPKCS8PrvKeyHex=function(t){var e,r,n,i,o,s,a,u,c=Er,h=c.getVbyListEx;if(!1===c.isASN1HEX(t))throw new Error("not ASN.1 hex string");try{e=h(t,0,[2,0,1],"02"),r=h(t,0,[2,0,2],"02"),n=h(t,0,[2,0,3],"02"),i=h(t,0,[2,0,4],"02"),o=h(t,0,[2,0,5],"02"),s=h(t,0,[2,0,6],"02"),a=h(t,0,[2,0,7],"02"),u=h(t,0,[2,0,8],"02")}catch(t){throw new Error("malformed PKCS#8 plain RSA private key")}this.setPrivateEx(e,r,n,i,o,s,a,u)},He.prototype.readPKCS5PubKeyHex=function(t){var e=Er,r=e.getV;if(!1===e.isASN1HEX(t))throw new Error("keyHex is not ASN.1 hex string");var n=e.getChildIdx(t,0);if(2!==n.length||"02"!==t.substr(n[0],2)||"02"!==t.substr(n[1],2))throw new Error("wrong hex for PKCS#5 public key");var i=r(t,n[0]),o=r(t,n[1]);this.setPublic(i,o)},He.prototype.readPKCS8PubKeyHex=function(t){var e=Er;if(!1===e.isASN1HEX(t))throw new Error("not ASN.1 hex string");if("06092a864886f70d010101"!==e.getTLVbyListEx(t,0,[0,0]))throw new Error("not PKCS8 RSA public key");var r=e.getTLVbyListEx(t,0,[1,0]);this.readPKCS5PubKeyHex(r)},He.prototype.readCertPubKeyHex=function(t,e){var r,n;(r=new on).readCertHex(t),n=r.getPublicKeyHex(),this.readPKCS8PubKeyHex(n)};var tn=new RegExp("[^0-9a-f]","gi");function en(t,e){for(var r="",n=e/4-t.length,i=0;i<n;i++)r+="0";return r+t}function rn(t,e,r){for(var n="",i=0;n.length<e;)n+=Nr(r(Ur(t+String.fromCharCode.apply(String,[(4278190080&i)>>24,(16711680&i)>>16,(65280&i)>>8,255&i])))),i+=1;return n}function nn(t){for(var e in br.crypto.Util.DIGESTINFOHEAD){var r=br.crypto.Util.DIGESTINFOHEAD[e],n=r.length;if(t.substring(0,n)==r)return[e,t.substring(n)]}return[]}function on(t){var e,r=Er,n=r.getChildIdx,i=r.getV,o=r.getTLV,s=r.getVbyList,a=r.getVbyListEx,u=r.getTLVbyList,c=r.getTLVbyListEx,h=r.getIdxbyList,l=r.getIdxbyListEx,f=r.getVidx,g=r.oidname,d=r.hextooidstr,p=on,v=Hr;try{e=br.asn1.x509.AlgorithmIdentifier.PSSNAME2ASN1TLV}catch(t){}this.HEX2STAG={"0c":"utf8",13:"prn",16:"ia5","1a":"vis","1e":"bmp"},this.hex=null,this.version=0,this.foffset=0,this.aExtInfo=null,this.getVersion=function(){return null===this.hex||0!==this.version?this.version:"a003020102"!==u(this.hex,0,[0,0])?(this.version=1,this.foffset=-1,1):(this.version=3,3)},this.getSerialNumberHex=function(){return a(this.hex,0,[0,0],"02")},this.getSignatureAlgorithmField=function(){var t=c(this.hex,0,[0,1]);return this.getAlgorithmIdentifierName(t)},this.getAlgorithmIdentifierName=function(t){for(var r in e)if(t===e[r])return r;return g(a(t,0,[0],"06"))},this.getIssuer=function(){return this.getX500Name(this.getIssuerHex())},this.getIssuerHex=function(){return u(this.hex,0,[0,3+this.foffset],"30")},this.getIssuerString=function(){return p.hex2dn(this.getIssuerHex())},this.getSubject=function(){return this.getX500Name(this.getSubjectHex())},this.getSubjectHex=function(){return u(this.hex,0,[0,5+this.foffset],"30")},this.getSubjectString=function(){return p.hex2dn(this.getSubjectHex())},this.getNotBefore=function(){var t=s(this.hex,0,[0,4+this.foffset,0]);return t=t.replace(/(..)/g,"%$1"),t=decodeURIComponent(t)},this.getNotAfter=function(){var t=s(this.hex,0,[0,4+this.foffset,1]);return t=t.replace(/(..)/g,"%$1"),t=decodeURIComponent(t)},this.getPublicKeyHex=function(){return r.getTLVbyList(this.hex,0,[0,6+this.foffset],"30")},this.getPublicKeyIdx=function(){return h(this.hex,0,[0,6+this.foffset],"30")},this.getPublicKeyContentIdx=function(){var t=this.getPublicKeyIdx();return h(this.hex,t,[1,0],"30")},this.getPublicKey=function(){return Zr.getKey(this.getPublicKeyHex(),null,"pkcs8pub")},this.getSignatureAlgorithmName=function(){var t=u(this.hex,0,[1],"30");return this.getAlgorithmIdentifierName(t)},this.getSignatureValueHex=function(){return s(this.hex,0,[2],"03",!0)},this.verifySignature=function(t){var e=this.getSignatureAlgorithmField(),r=this.getSignatureValueHex(),n=u(this.hex,0,[0],"30"),i=new br.crypto.Signature({alg:e});return i.init(t),i.updateHex(n),i.verify(r)},this.parseExt=function(t){var e,o,a;if(void 0===t){if(a=this.hex,3!==this.version)return-1;e=h(a,0,[0,7,0],"30"),o=n(a,e)}else{a=Hr(t);var u=h(a,0,[0,3,0,0],"06");if("2a864886f70d01090e"!=i(a,u))return void(this.aExtInfo=new Array);e=h(a,0,[0,3,0,1,0],"30"),o=n(a,e),this.hex=a}this.aExtInfo=new Array;for(var c=0;c<o.length;c++){var l={critical:!1},g=0;3===n(a,o[c]).length&&(l.critical=!0,g=1),l.oid=r.hextooidstr(s(a,o[c],[0],"06"));var d=h(a,o[c],[1+g]);l.vidx=f(a,d),this.aExtInfo.push(l)}},this.getExtInfo=function(t){var e=this.aExtInfo,r=t;if(t.match(/^[0-9.]+$/)||(r=br.asn1.x509.OID.name2oid(t)),""!==r)for(var n=0;n<e.length;n++)if(e[n].oid===r)return e[n]},this.getExtBasicConstraints=function(t,e){if(void 0===t&&void 0===e){var r=this.getExtInfo("basicConstraints");if(void 0===r)return;t=o(this.hex,r.vidx),e=r.critical}var n={extname:"basicConstraints"};if(e&&(n.critical=!0),"3000"===t)return n;if("30030101ff"===t)return n.cA=!0,n;if("30060101ff02"===t.substr(0,12)){var s=i(t,10),a=parseInt(s,16);return n.cA=!0,n.pathLen=a,n}throw new Error("hExtV parse error: "+t)},this.getExtKeyUsage=function(t,e){if(void 0===t&&void 0===e){var r=this.getExtInfo("keyUsage");if(void 0===r)return;t=o(this.hex,r.vidx),e=r.critical}var n={extname:"keyUsage"};return e&&(n.critical=!0),n.names=this.getExtKeyUsageString(t).split(","),n},this.getExtKeyUsageBin=function(t){if(void 0===t){var e=this.getExtInfo("keyUsage");if(void 0===e)return"";t=o(this.hex,e.vidx)}if(8!=t.length&&10!=t.length)throw new Error("malformed key usage value: "+t);var r="000000000000000"+parseInt(t.substr(6),16).toString(2);return 8==t.length&&(r=r.slice(-8)),10==t.length&&(r=r.slice(-16)),""==(r=r.replace(/0+$/,""))&&(r="0"),r},this.getExtKeyUsageString=function(t){for(var e=this.getExtKeyUsageBin(t),r=new Array,n=0;n<e.length;n++)"1"==e.substr(n,1)&&r.push(on.KEYUSAGE_NAME[n]);return r.join(",")},this.getExtSubjectKeyIdentifier=function(t,e){if(void 0===t&&void 0===e){var r=this.getExtInfo("subjectKeyIdentifier");if(void 0===r)return;t=o(this.hex,r.vidx),e=r.critical}var n={extname:"subjectKeyIdentifier"};e&&(n.critical=!0);var s=i(t,0);return n.kid={hex:s},n},this.getExtAuthorityKeyIdentifier=function(t,e){if(void 0===t&&void 0===e){var r=this.getExtInfo("authorityKeyIdentifier");if(void 0===r)return;t=o(this.hex,r.vidx),e=r.critical}var s={extname:"authorityKeyIdentifier"};e&&(s.critical=!0);for(var a=n(t,0),u=0;u<a.length;u++){var c=t.substr(a[u],2);if("80"===c&&(s.kid={hex:i(t,a[u])}),"a1"===c){var h=o(t,a[u]),l=this.getGeneralNames(h);s.issuer=l[0].dn}"82"===c&&(s.sn={hex:i(t,a[u])})}return s},this.getExtExtKeyUsage=function(t,e){if(void 0===t&&void 0===e){var r=this.getExtInfo("extKeyUsage");if(void 0===r)return;t=o(this.hex,r.vidx),e=r.critical}var s={extname:"extKeyUsage",array:[]};e&&(s.critical=!0);for(var a=n(t,0),u=0;u<a.length;u++)s.array.push(g(i(t,a[u])));return s},this.getExtExtKeyUsageName=function(){var t=this.getExtInfo("extKeyUsage");if(void 0===t)return t;var e=new Array,r=o(this.hex,t.vidx);if(""===r)return e;for(var s=n(r,0),a=0;a<s.length;a++)e.push(g(i(r,s[a])));return e},this.getExtSubjectAltName=function(t,e){if(void 0===t&&void 0===e){var r=this.getExtInfo("subjectAltName");if(void 0===r)return;t=o(this.hex,r.vidx),e=r.critical}var n={extname:"subjectAltName",array:[]};return e&&(n.critical=!0),n.array=this.getGeneralNames(t),n},this.getExtIssuerAltName=function(t,e){if(void 0===t&&void 0===e){var r=this.getExtInfo("issuerAltName");if(void 0===r)return;t=o(this.hex,r.vidx),e=r.critical}var n={extname:"issuerAltName",array:[]};return e&&(n.critical=!0),n.array=this.getGeneralNames(t),n},this.getGeneralNames=function(t){for(var e=n(t,0),r=[],i=0;i<e.length;i++){var s=this.getGeneralName(o(t,e[i]));void 0!==s&&r.push(s)}return r},this.getGeneralName=function(t){var e=t.substr(0,2),r=i(t,0),n=Nr(r);return"81"==e?{rfc822:n}:"82"==e?{dns:n}:"86"==e?{uri:n}:"87"==e?{ip:Yr(r)}:"a4"==e?{dn:this.getX500Name(r)}:void 0},this.getExtSubjectAltName2=function(){var t,e,r,s=this.getExtInfo("subjectAltName");if(void 0===s)return s;for(var a=new Array,u=o(this.hex,s.vidx),c=n(u,0),h=0;h<c.length;h++)r=u.substr(c[h],2),t=i(u,c[h]),"81"===r&&(e=Lr(t),a.push(["MAIL",e])),"82"===r&&(e=Lr(t),a.push(["DNS",e])),"84"===r&&(e=on.hex2dn(t,0),a.push(["DN",e])),"86"===r&&(e=Lr(t),a.push(["URI",e])),"87"===r&&(e=Yr(t),a.push(["IP",e]));return a},this.getExtCRLDistributionPoints=function(t,e){if(void 0===t&&void 0===e){var r=this.getExtInfo("cRLDistributionPoints");if(void 0===r)return;t=o(this.hex,r.vidx),e=r.critical}var i={extname:"cRLDistributionPoints",array:[]};e&&(i.critical=!0);for(var s=n(t,0),a=0;a<s.length;a++){var u=o(t,s[a]);i.array.push(this.getDistributionPoint(u))}return i},this.getDistributionPoint=function(t){for(var e={},r=n(t,0),i=0;i<r.length;i++){var s=t.substr(r[i],2),a=o(t,r[i]);"a0"==s&&(e.dpname=this.getDistributionPointName(a))}return e},this.getDistributionPointName=function(t){for(var e={},r=n(t,0),i=0;i<r.length;i++){var s=t.substr(r[i],2),a=o(t,r[i]);"a0"==s&&(e.full=this.getGeneralNames(a))}return e},this.getExtCRLDistributionPointsURI=function(){var t=this.getExtInfo("cRLDistributionPoints");if(void 0===t)return t;for(var e=new Array,r=n(this.hex,t.vidx),i=0;i<r.length;i++)try{var o=Lr(s(this.hex,r[i],[0,0,0],"86"));e.push(o)}catch(t){}return e},this.getExtAIAInfo=function(){var t=this.getExtInfo("authorityInfoAccess");if(void 0===t)return t;for(var e={ocsp:[],caissuer:[]},r=n(this.hex,t.vidx),i=0;i<r.length;i++){var o=s(this.hex,r[i],[0],"06"),a=s(this.hex,r[i],[1],"86");"2b06010505073001"===o&&e.ocsp.push(Lr(a)),"2b06010505073002"===o&&e.caissuer.push(Lr(a))}return e},this.getExtAuthorityInfoAccess=function(t,e){if(void 0===t&&void 0===e){var r=this.getExtInfo("authorityInfoAccess");if(void 0===r)return;t=o(this.hex,r.vidx),e=r.critical}var i={extname:"authorityInfoAccess",array:[]};e&&(i.critical=!0);for(var u=n(t,0),c=0;c<u.length;c++){var h=a(t,u[c],[0],"06"),l=Lr(s(t,u[c],[1],"86"));if("2b06010505073001"==h)i.array.push({ocsp:l});else{if("2b06010505073002"!=h)throw new Error("unknown method: "+h);i.array.push({caissuer:l})}}return i},this.getExtCertificatePolicies=function(t,e){if(void 0===t&&void 0===e){var r=this.getExtInfo("certificatePolicies");if(void 0===r)return;t=o(this.hex,r.vidx),e=r.critical}var i={extname:"certificatePolicies",array:[]};e&&(i.critical=!0);for(var s=n(t,0),a=0;a<s.length;a++){var u=o(t,s[a]),c=this.getPolicyInformation(u);i.array.push(c)}return i},this.getPolicyInformation=function(t){var e={},r=s(t,0,[0],"06");e.policyoid=g(r);var i=l(t,0,[1],"30");if(-1!=i){e.array=[];for(var a=n(t,i),u=0;u<a.length;u++){var c=o(t,a[u]),h=this.getPolicyQualifierInfo(c);e.array.push(h)}}return e},this.getPolicyQualifierInfo=function(t){var e={},r=s(t,0,[0],"06");if("2b06010505070201"===r){var n=a(t,0,[1],"16");e.cps=Nr(n)}else if("2b06010505070202"===r){var i=u(t,0,[1],"30");e.unotice=this.getUserNotice(i)}return e},this.getUserNotice=function(t){for(var e={},r=n(t,0),i=0;i<r.length;i++){var s=o(t,r[i]);"30"!=s.substr(0,2)&&(e.exptext=this.getDisplayText(s))}return e},this.getDisplayText=function(t){var e={};return e.type={"0c":"utf8",16:"ia5","1a":"vis","1e":"bmp"}[t.substr(0,2)],e.str=Nr(i(t,0)),e},this.getExtCRLNumber=function(t,e){var r={extname:"cRLNumber"};if(e&&(r.critical=!0),"02"==t.substr(0,2))return r.num={hex:i(t,0)},r;throw new Error("hExtV parse error: "+t)},this.getExtCRLReason=function(t,e){var r={extname:"cRLReason"};if(e&&(r.critical=!0),"0a"==t.substr(0,2))return r.code=parseInt(i(t,0),16),r;throw new Error("hExtV parse error: "+t)},this.getExtOcspNonce=function(t,e){var r={extname:"ocspNonce"};e&&(r.critical=!0);var n=i(t,0);return r.hex=n,r},this.getExtOcspNoCheck=function(t,e){var r={extname:"ocspNoCheck"};return e&&(r.critical=!0),r},this.getExtAdobeTimeStamp=function(t,e){if(void 0===t&&void 0===e){var r=this.getExtInfo("adobeTimeStamp");if(void 0===r)return;t=o(this.hex,r.vidx),e=r.critical}var i={extname:"adobeTimeStamp"};e&&(i.critical=!0);var s=n(t,0);if(s.length>1){var a=o(t,s[1]),u=this.getGeneralName(a);null!=u.uri&&(i.uri=u.uri)}if(s.length>2){var c=o(t,s[2]);"0101ff"==c&&(i.reqauth=!0),"010100"==c&&(i.reqauth=!1)}return i},this.getX500NameRule=function(t){for(var e=null,r=[],n=0;n<t.length;n++)for(var i=t[n],o=0;o<i.length;o++)r.push(i[o]);for(n=0;n<r.length;n++){var s=r[n],a=s.ds,u=s.value,c=s.type;if(":"+a,"prn"!=a&&"utf8"!=a&&"ia5"!=a)return"mixed";if("ia5"==a){if("CN"!=c)return"mixed";if(br.lang.String.isMail(u))continue;return"mixed"}if("C"==c){if("prn"==a)continue;return"mixed"}if(":"+a,null==e)e=a;else if(e!==a)return"mixed"}return null==e?"prn":e},this.getX500Name=function(t){var e=this.getX500NameArray(t);return{array:e,str:this.dnarraytostr(e)}},this.getX500NameArray=function(t){for(var e=[],r=n(t,0),i=0;i<r.length;i++)e.push(this.getRDN(o(t,r[i])));return e},this.getRDN=function(t){for(var e=[],r=n(t,0),i=0;i<r.length;i++)e.push(this.getAttrTypeAndValue(o(t,r[i])));return e},this.getAttrTypeAndValue=function(t){var e={type:null,value:null,ds:null},r=n(t,0),i=s(t,r[0],[],"06"),o=s(t,r[1],[]),a=br.asn1.ASN1Util.oidHexToInt(i);return e.type=br.asn1.x509.OID.oid2atype(a),e.value=Nr(o),e.ds=this.HEX2STAG[t.substr(r[1],2)],e},this.readCertPEM=function(t){this.readCertHex(v(t))},this.readCertHex=function(t){this.hex=t,this.getVersion();try{h(this.hex,0,[0,7],"a3"),this.parseExt()}catch(t){}},this.getParam=function(){var t={};return t.version=this.getVersion(),t.serial={hex:this.getSerialNumberHex()},t.sigalg=this.getSignatureAlgorithmField(),t.issuer=this.getIssuer(),t.notbefore=this.getNotBefore(),t.notafter=this.getNotAfter(),t.subject=this.getSubject(),t.sbjpubkey=Mr(this.getPublicKeyHex(),"PUBLIC KEY"),this.aExtInfo.length>0&&(t.ext=this.getExtParamArray()),t.sighex=this.getSignatureValueHex(),t},this.getExtParamArray=function(t){null==t&&(-1!=l(this.hex,0,[0,"[3]"])&&(t=c(this.hex,0,[0,"[3]",0],"30")));for(var e=[],r=n(t,0),i=0;i<r.length;i++){var s=o(t,r[i]),a=this.getExtParam(s);null!=a&&e.push(a)}return e},this.getExtParam=function(t){var e=n(t,0).length;if(2!=e&&3!=e)throw new Error("wrong number elements in Extension: "+e+" "+t);var r=d(s(t,0,[0],"06")),i=!1;3==e&&"0101ff"==u(t,0,[1])&&(i=!0);var o=u(t,0,[e-1,0]),a=void 0;if("2.5.29.14"==r?a=this.getExtSubjectKeyIdentifier(o,i):"2.5.29.15"==r?a=this.getExtKeyUsage(o,i):"2.5.29.17"==r?a=this.getExtSubjectAltName(o,i):"2.5.29.18"==r?a=this.getExtIssuerAltName(o,i):"2.5.29.19"==r?a=this.getExtBasicConstraints(o,i):"2.5.29.31"==r?a=this.getExtCRLDistributionPoints(o,i):"2.5.29.32"==r?a=this.getExtCertificatePolicies(o,i):"2.5.29.35"==r?a=this.getExtAuthorityKeyIdentifier(o,i):"2.5.29.37"==r?a=this.getExtExtKeyUsage(o,i):"1.3.6.1.5.5.7.1.1"==r?a=this.getExtAuthorityInfoAccess(o,i):"2.5.29.20"==r?a=this.getExtCRLNumber(o,i):"2.5.29.21"==r?a=this.getExtCRLReason(o,i):"1.3.6.1.5.5.7.48.1.2"==r?a=this.getExtOcspNonce(o,i):"1.3.6.1.5.5.7.48.1.5"==r?a=this.getExtOcspNoCheck(o,i):"1.2.840.113583.1.1.9.1"==r&&(a=this.getExtAdobeTimeStamp(o,i)),null!=a)return a;var c={extname:r,extn:o};return i&&(c.critical=!0),c},this.findExt=function(t,e){for(var r=0;r<t.length;r++)if(t[r].extname==e)return t[r];return null},this.updateExtCDPFullURI=function(t,e){var r=this.findExt(t,"cRLDistributionPoints");if(null!=r&&null!=r.array)for(var n=r.array,i=0;i<n.length;i++)if(null!=n[i].dpname&&null!=n[i].dpname.full)for(var o=n[i].dpname.full,s=0;s<o.length;s++){var a=o[i];null!=a.uri&&(a.uri=e)}},this.updateExtAIAOCSP=function(t,e){var r=this.findExt(t,"authorityInfoAccess");if(null!=r&&null!=r.array)for(var n=r.array,i=0;i<n.length;i++)null!=n[i].ocsp&&(n[i].ocsp=e)},this.updateExtAIACAIssuer=function(t,e){var r=this.findExt(t,"authorityInfoAccess");if(null!=r&&null!=r.array)for(var n=r.array,i=0;i<n.length;i++)null!=n[i].caissuer&&(n[i].caissuer=e)},this.dnarraytostr=function(t){return"/"+t.map((function(t){return function e(t){return t.map((function(t){return function e(t){return t.type+"="+t.value}(t)})).join("+")}(t)})).join("/")},this.getInfo=function(){var t,e,r,n=function t(e){return JSON.stringify(e.array).replace(/[\[\]\{\}\"]/g,"")},i=function t(e){for(var r="",n=e.array,i=0;i<n.length;i++){var o=n[i];if(r+="    policy oid: "+o.policyoid+"\n",void 0!==o.array)for(var s=0;s<o.array.length;s++){var a=o.array[s];void 0!==a.cps&&(r+="    cps: "+a.cps+"\n")}}return r},o=function t(e){for(var r="",n=e.array,i=0;i<n.length;i++){var o=n[i];try{void 0!==o.dpname.full[0].uri&&(r+="    "+o.dpname.full[0].uri+"\n")}catch(t){}try{void 0!==o.dname.full[0].dn.hex&&(r+="    "+on.hex2dn(o.dpname.full[0].dn.hex)+"\n")}catch(t){}}return r},s=function t(e){for(var r="",n=e.array,i=0;i<n.length;i++){var o=n[i];void 0!==o.caissuer&&(r+="    caissuer: "+o.caissuer+"\n"),void 0!==o.ocsp&&(r+="    ocsp: "+o.ocsp+"\n")}return r};if(t="Basic Fields\n",t+="  serial number: "+this.getSerialNumberHex()+"\n",t+="  signature algorithm: "+this.getSignatureAlgorithmField()+"\n",t+="  issuer: "+this.getIssuerString()+"\n",t+="  notBefore: "+this.getNotBefore()+"\n",t+="  notAfter: "+this.getNotAfter()+"\n",t+="  subject: "+this.getSubjectString()+"\n",t+="  subject public key info: \n",t+="    key algorithm: "+(e=this.getPublicKey()).type+"\n","RSA"===e.type&&(t+="    n="+$r(e.n.toString(16)).substr(0,16)+"...\n",t+="    e="+$r(e.e.toString(16))+"\n"),null!=(r=this.aExtInfo)){t+="X509v3 Extensions:\n";for(var a=0;a<r.length;a++){var u=r[a],c=br.asn1.x509.OID.oid2name(u.oid);""===c&&(c=u.oid);var h="";if(!0===u.critical&&(h="CRITICAL"),t+="  "+c+" "+h+":\n","basicConstraints"===c){var l=this.getExtBasicConstraints();void 0===l.cA?t+="    {}\n":(t+="    cA=true",void 0!==l.pathLen&&(t+=", pathLen="+l.pathLen),t+="\n")}else if("keyUsage"===c)t+="    "+this.getExtKeyUsageString()+"\n";else if("subjectKeyIdentifier"===c)t+="    "+this.getExtSubjectKeyIdentifier().kid.hex+"\n";else if("authorityKeyIdentifier"===c){var f=this.getExtAuthorityKeyIdentifier();void 0!==f.kid&&(t+="    kid="+f.kid.hex+"\n")}else{if("extKeyUsage"===c)t+="    "+this.getExtExtKeyUsage().array.join(", ")+"\n";else if("subjectAltName"===c)t+="    "+n(this.getExtSubjectAltName())+"\n";else if("cRLDistributionPoints"===c)t+=o(this.getExtCRLDistributionPoints());else if("authorityInfoAccess"===c)t+=s(this.getExtAuthorityInfoAccess());else"certificatePolicies"===c&&(t+=i(this.getExtCertificatePolicies()))}}}return t+="signature algorithm: "+this.getSignatureAlgorithmName()+"\n",t+="signature: "+this.getSignatureValueHex().substr(0,16)+"...\n"},"string"==typeof t&&(-1!=t.indexOf("-----BEGIN")?this.readCertPEM(t):br.lang.String.isHex(t)&&this.readCertHex(t))}He.prototype.sign=function(t,e){var r=function t(r){return br.crypto.Util.hashString(r,e)}(t);return this.signWithMessageHash(r,e)},He.prototype.signWithMessageHash=function(t,e){var r=je(br.crypto.Util.getPaddedDigestInfoHex(t,e,this.n.bitLength()),16);return en(this.doPrivate(r).toString(16),this.n.bitLength())},He.prototype.signPSS=function(t,e,r){var n=function t(r){return br.crypto.Util.hashHex(r,e)}(Ur(t));return void 0===r&&(r=-1),this.signWithMessageHashPSS(n,e,r)},He.prototype.signWithMessageHashPSS=function(t,e,r){var n,i=Nr(t),o=i.length,s=this.n.bitLength()-1,a=Math.ceil(s/8),u=function t(r){return br.crypto.Util.hashHex(r,e)};if(-1===r||void 0===r)r=o;else if(-2===r)r=a-o-2;else if(r<-2)throw new Error("invalid salt length");if(a<o+r+2)throw new Error("data too long");var c="";r>0&&(c=new Array(r),(new Oe).nextBytes(c),c=String.fromCharCode.apply(String,c));var h=Nr(u(Ur("\0\0\0\0\0\0\0\0"+i+c))),l=[];for(n=0;n<a-r-o-2;n+=1)l[n]=0;var f=String.fromCharCode.apply(String,l)+""+c,g=rn(h,f.length,u),d=[];for(n=0;n<f.length;n+=1)d[n]=f.charCodeAt(n)^g.charCodeAt(n);var p=65280>>8*a-s&255;for(d[0]&=~p,n=0;n<o;n++)d.push(h.charCodeAt(n));return d.push(188),en(this.doPrivate(new F(d)).toString(16),this.n.bitLength())},He.prototype.verify=function(t,e){var r=je(e=(e=e.replace(tn,"")).replace(/[ \n]+/g,""),16);if(r.bitLength()>this.n.bitLength())return 0;var n=nn(this.doPublic(r).toString(16).replace(/^1f+00/,""));if(0==n.length)return!1;var i=n[0];return n[1]==function t(e){return br.crypto.Util.hashString(e,i)}(t)},He.prototype.verifyWithMessageHash=function(t,e){if(e.length!=Math.ceil(this.n.bitLength()/4))return!1;var r=je(e,16);if(r.bitLength()>this.n.bitLength())return 0;var n=nn(this.doPublic(r).toString(16).replace(/^1f+00/,""));if(0==n.length)return!1;n[0];return n[1]==t},He.prototype.verifyPSS=function(t,e,r,n){var i=function t(e){return br.crypto.Util.hashHex(e,r)}(Ur(t));return void 0===n&&(n=-1),this.verifyWithMessageHashPSS(i,e,r,n)},He.prototype.verifyWithMessageHashPSS=function(t,e,r,n){if(e.length!=Math.ceil(this.n.bitLength()/4))return!1;var i,o=new F(e,16),s=function t(e){return br.crypto.Util.hashHex(e,r)},a=Nr(t),u=a.length,c=this.n.bitLength()-1,h=Math.ceil(c/8);if(-1===n||void 0===n)n=u;else if(-2===n)n=h-u-2;else if(n<-2)throw new Error("invalid salt length");if(h<u+n+2)throw new Error("data too long");var l=this.doPublic(o).toByteArray();for(i=0;i<l.length;i+=1)l[i]&=255;for(;l.length<h;)l.unshift(0);if(188!==l[h-1])throw new Error("encoded message does not end in 0xbc");var f=(l=String.fromCharCode.apply(String,l)).substr(0,h-u-1),g=l.substr(f.length,u),d=65280>>8*h-c&255;if(0!=(f.charCodeAt(0)&d))throw new Error("bits beyond keysize not zero");var p=rn(g,f.length,s),v=[];for(i=0;i<f.length;i+=1)v[i]=f.charCodeAt(i)^p.charCodeAt(i);v[0]&=~d;var y=h-u-n-2;for(i=0;i<y;i+=1)if(0!==v[i])throw new Error("leftmost octets not zero");if(1!==v[y])throw new Error("0x01 marker not found");return g===Nr(s(Ur("\0\0\0\0\0\0\0\0"+a+String.fromCharCode.apply(String,v.slice(-n)))))},He.SALT_LEN_HLEN=-1,He.SALT_LEN_MAX=-2,He.SALT_LEN_RECOVER=-2,on.hex2dn=function(t,e){if(void 0===e&&(e=0),"30"!==t.substr(e,2))throw new Error("malformed DN");for(var r=new Array,n=Er.getChildIdx(t,e),i=0;i<n.length;i++)r.push(on.hex2rdn(t,n[i]));return"/"+(r=r.map((function(t){return t.replace("/","\\/")}))).join("/")},on.hex2rdn=function(t,e){if(void 0===e&&(e=0),"31"!==t.substr(e,2))throw new Error("malformed RDN");for(var r=new Array,n=Er.getChildIdx(t,e),i=0;i<n.length;i++)r.push(on.hex2attrTypeValue(t,n[i]));return(r=r.map((function(t){return t.replace("+","\\+")}))).join("+")},on.hex2attrTypeValue=function(t,e){var r=Er,n=r.getV;if(void 0===e&&(e=0),"30"!==t.substr(e,2))throw new Error("malformed attribute type and value");var i=r.getChildIdx(t,e);2!==i.length||t.substr(i[0],2);var o=n(t,i[0]),s=br.asn1.ASN1Util.oidHexToInt(o);return br.asn1.x509.OID.oid2atype(s)+"="+Nr(n(t,i[1]))},on.getPublicKeyFromCertHex=function(t){var e=new on;return e.readCertHex(t),e.getPublicKey()},on.getPublicKeyFromCertPEM=function(t){var e=new on;return e.readCertPEM(t),e.getPublicKey()},on.getPublicKeyInfoPropOfCertPEM=function(t){var e,r,n=Er.getVbyList,i={};return i.algparam=null,(e=new on).readCertPEM(t),r=e.getPublicKeyHex(),i.keyhex=n(r,0,[1],"03").substr(2),i.algoid=n(r,0,[0,0],"06"),"2a8648ce3d0201"===i.algoid&&(i.algparam=n(r,0,[0,1],"06")),i},on.KEYUSAGE_NAME=["digitalSignature","nonRepudiation","keyEncipherment","dataEncipherment","keyAgreement","keyCertSign","cRLSign","encipherOnly","decipherOnly"],void 0!==br&&br||(e.KJUR=br={}),void 0!==br.jws&&br.jws||(br.jws={}),br.jws.JWS=function(){var t=br.jws.JWS.isSafeJSONString;this.parseJWS=function(e,r){if(void 0===this.parsedJWS||!r&&void 0===this.parsedJWS.sigvalH){var n=e.match(/^([^.]+)\.([^.]+)\.([^.]+)$/);if(null==n)throw"JWS signature is not a form of 'Head.Payload.SigValue'.";var i=n[1],o=n[2],s=n[3],a=i+"."+o;if(this.parsedJWS={},this.parsedJWS.headB64U=i,this.parsedJWS.payloadB64U=o,this.parsedJWS.sigvalB64U=s,this.parsedJWS.si=a,!r){var u=Ir(s),c=je(u,16);this.parsedJWS.sigvalH=u,this.parsedJWS.sigvalBI=c}var h=Fr(i),l=Fr(o);if(this.parsedJWS.headS=h,this.parsedJWS.payloadS=l,!t(h,this.parsedJWS,"headP"))throw"malformed JSON string for JWS Head: "+h}}},br.jws.JWS.sign=function(t,e,n,i,o){var s,a,u,c=br,h=c.jws.JWS,l=h.readSafeJSONString,f=h.isSafeJSONString,g=c.crypto,d=(g.ECDSA,g.Mac),p=g.Signature,v=JSON;if("string"!=typeof e&&"object"!=(void 0===e?"undefined":r(e)))throw"spHeader must be JSON string or object: "+e;if("object"==(void 0===e?"undefined":r(e))&&(a=e,s=v.stringify(a)),"string"==typeof e){if(!f(s=e))throw"JWS Head is not safe JSON string: "+s;a=l(s)}if(u=n,"object"==(void 0===n?"undefined":r(n))&&(u=v.stringify(n)),""!=t&&null!=t||void 0===a.alg||(t=a.alg),""!=t&&null!=t&&void 0===a.alg&&(a.alg=t,s=v.stringify(a)),t!==a.alg)throw"alg and sHeader.alg doesn't match: "+t+"!="+a.alg;var y=null;if(void 0===h.jwsalg2sigalg[t])throw"unsupported alg name: "+t;y=h.jwsalg2sigalg[t];var m=wr(s)+"."+wr(u),_="";if("Hmac"==y.substr(0,4)){if(void 0===i)throw"mac key shall be specified for HS* alg";var S=new d({alg:y,prov:"cryptojs",pass:i});S.updateString(m),_=S.doFinal()}else if(-1!=y.indexOf("withECDSA")){(w=new p({alg:y})).init(i,o),w.updateString(m);var b=w.sign();_=br.crypto.ECDSA.asn1SigToConcatSig(b)}else{var w;if("none"!=y)(w=new p({alg:y})).init(i,o),w.updateString(m),_=w.sign()}return m+"."+Rr(_)},br.jws.JWS.verify=function(t,e,n){var i,o=br,s=o.jws.JWS,a=s.readSafeJSONString,u=o.crypto,c=u.ECDSA,h=u.Mac,l=u.Signature;void 0!==r(He)&&(i=He);var f=t.split(".");if(3!==f.length)return!1;var g=f[0]+"."+f[1],d=Ir(f[2]),p=a(Fr(f[0])),v=null,y=null;if(void 0===p.alg)throw"algorithm not specified in header";if((y=(v=p.alg).substr(0,2),null!=n&&"[object Array]"===Object.prototype.toString.call(n)&&n.length>0)&&-1==(":"+n.join(":")+":").indexOf(":"+v+":"))throw"algorithm '"+v+"' not accepted in the list";if("none"!=v&&null===e)throw"key shall be specified to verify.";if("string"==typeof e&&-1!=e.indexOf("-----BEGIN ")&&(e=Zr.getKey(e)),!("RS"!=y&&"PS"!=y||e instanceof i))throw"key shall be a RSAKey obj for RS* and PS* algs";if("ES"==y&&!(e instanceof c))throw"key shall be a ECDSA obj for ES* algs";var m=null;if(void 0===s.jwsalg2sigalg[p.alg])throw"unsupported alg name: "+v;if("none"==(m=s.jwsalg2sigalg[v]))throw"not supported";if("Hmac"==m.substr(0,4)){if(void 0===e)throw"hexadecimal key shall be specified for HMAC";var _=new h({alg:m,pass:e});return _.updateString(g),d==_.doFinal()}if(-1!=m.indexOf("withECDSA")){var S,b=null;try{b=c.concatSigToASN1Sig(d)}catch(t){return!1}return(S=new l({alg:m})).init(e),S.updateString(g),S.verify(b)}return(S=new l({alg:m})).init(e),S.updateString(g),S.verify(d)},br.jws.JWS.parse=function(t){var e,r,n,i=t.split("."),o={};if(2!=i.length&&3!=i.length)throw"malformed sJWS: wrong number of '.' splitted elements";return e=i[0],r=i[1],3==i.length&&(n=i[2]),o.headerObj=br.jws.JWS.readSafeJSONString(Fr(e)),o.payloadObj=br.jws.JWS.readSafeJSONString(Fr(r)),o.headerPP=JSON.stringify(o.headerObj,null,"  "),null==o.payloadObj?o.payloadPP=Fr(r):o.payloadPP=JSON.stringify(o.payloadObj,null,"  "),void 0!==n&&(o.sigHex=Ir(n)),o},br.jws.JWS.verifyJWT=function(t,e,n){var i=br.jws,o=i.JWS,s=o.readSafeJSONString,a=o.inArray,u=o.includedArray,c=t.split("."),h=c[0],l=c[1],f=(Ir(c[2]),s(Fr(h))),g=s(Fr(l));if(void 0===f.alg)return!1;if(void 0===n.alg)throw"acceptField.alg shall be specified";if(!a(f.alg,n.alg))return!1;if(void 0!==g.iss&&"object"===r(n.iss)&&!a(g.iss,n.iss))return!1;if(void 0!==g.sub&&"object"===r(n.sub)&&!a(g.sub,n.sub))return!1;if(void 0!==g.aud&&"object"===r(n.aud))if("string"==typeof g.aud){if(!a(g.aud,n.aud))return!1}else if("object"==r(g.aud)&&!u(g.aud,n.aud))return!1;var d=i.IntDate.getNow();return void 0!==n.verifyAt&&"number"==typeof n.verifyAt&&(d=n.verifyAt),void 0!==n.gracePeriod&&"number"==typeof n.gracePeriod||(n.gracePeriod=0),!(void 0!==g.exp&&"number"==typeof g.exp&&g.exp+n.gracePeriod<d)&&(!(void 0!==g.nbf&&"number"==typeof g.nbf&&d<g.nbf-n.gracePeriod)&&(!(void 0!==g.iat&&"number"==typeof g.iat&&d<g.iat-n.gracePeriod)&&((void 0===g.jti||void 0===n.jti||g.jti===n.jti)&&!!o.verify(t,e,n.alg))))},br.jws.JWS.includedArray=function(t,e){var n=br.jws.JWS.inArray;if(null===t)return!1;if("object"!==(void 0===t?"undefined":r(t)))return!1;if("number"!=typeof t.length)return!1;for(var i=0;i<t.length;i++)if(!n(t[i],e))return!1;return!0},br.jws.JWS.inArray=function(t,e){if(null===e)return!1;if("object"!==(void 0===e?"undefined":r(e)))return!1;if("number"!=typeof e.length)return!1;for(var n=0;n<e.length;n++)if(e[n]==t)return!0;return!1},br.jws.JWS.jwsalg2sigalg={HS256:"HmacSHA256",HS384:"HmacSHA384",HS512:"HmacSHA512",RS256:"SHA256withRSA",RS384:"SHA384withRSA",RS512:"SHA512withRSA",ES256:"SHA256withECDSA",ES384:"SHA384withECDSA",PS256:"SHA256withRSAandMGF1",PS384:"SHA384withRSAandMGF1",PS512:"SHA512withRSAandMGF1",none:"none"},br.jws.JWS.isSafeJSONString=function(t,e,n){var i=null;try{return"object"!=(void 0===(i=Sr(t))?"undefined":r(i))||i.constructor===Array?0:(e&&(e[n]=i),1)}catch(t){return 0}},br.jws.JWS.readSafeJSONString=function(t){var e=null;try{return"object"!=(void 0===(e=Sr(t))?"undefined":r(e))||e.constructor===Array?null:e}catch(t){return null}},br.jws.JWS.getEncodedSignatureValueFromJWS=function(t){var e=t.match(/^[^.]+\.[^.]+\.([^.]+)$/);if(null==e)throw"JWS signature is not a form of 'Head.Payload.SigValue'.";return e[1]},br.jws.JWS.getJWKthumbprint=function(t){if("RSA"!==t.kty&&"EC"!==t.kty&&"oct"!==t.kty)throw"unsupported algorithm for JWK Thumprint";var e="{";if("RSA"===t.kty){if("string"!=typeof t.n||"string"!=typeof t.e)throw"wrong n and e value for RSA key";e+='"e":"'+t.e+'",',e+='"kty":"'+t.kty+'",',e+='"n":"'+t.n+'"}'}else if("EC"===t.kty){if("string"!=typeof t.crv||"string"!=typeof t.x||"string"!=typeof t.y)throw"wrong crv, x and y value for EC key";e+='"crv":"'+t.crv+'",',e+='"kty":"'+t.kty+'",',e+='"x":"'+t.x+'",',e+='"y":"'+t.y+'"}'}else if("oct"===t.kty){if("string"!=typeof t.k)throw"wrong k value for oct(symmetric) key";e+='"kty":"'+t.kty+'",',e+='"k":"'+t.k+'"}'}var r=Ur(e);return Rr(br.crypto.Util.hashHex(r,"sha256"))},br.jws.IntDate={},br.jws.IntDate.get=function(t){var e=br.jws.IntDate,r=e.getNow,n=e.getZulu;if("now"==t)return r();if("now + 1hour"==t)return r()+3600;if("now + 1day"==t)return r()+86400;if("now + 1month"==t)return r()+2592e3;if("now + 1year"==t)return r()+31536e3;if(t.match(/Z$/))return n(t);if(t.match(/^[0-9]+$/))return parseInt(t);throw"unsupported format: "+t},br.jws.IntDate.getZulu=function(t){return Kr(t)},br.jws.IntDate.getNow=function(){return~~(new Date/1e3)},br.jws.IntDate.intDate2UTCString=function(t){return new Date(1e3*t).toUTCString()},br.jws.IntDate.intDate2Zulu=function(t){var e=new Date(1e3*t);return("0000"+e.getUTCFullYear()).slice(-4)+("00"+(e.getUTCMonth()+1)).slice(-2)+("00"+e.getUTCDate()).slice(-2)+("00"+e.getUTCHours()).slice(-2)+("00"+e.getUTCMinutes()).slice(-2)+("00"+e.getUTCSeconds()).slice(-2)+"Z"},e.SecureRandom=Oe,e.rng_seed_time=Ie,e.BigInteger=F,e.RSAKey=He;var sn=br.crypto.EDSA;e.EDSA=sn;var an=br.crypto.DSA;e.DSA=an;var un=br.crypto.Signature;e.Signature=un;var cn=br.crypto.MessageDigest;e.MessageDigest=cn;var hn=br.crypto.Mac;e.Mac=hn;var ln=br.crypto.Cipher;e.Cipher=ln,e.KEYUTIL=Zr,e.ASN1HEX=Er,e.X509=on,e.CryptoJS=y,e.b64tohex=b,e.b64toBA=w,e.stoBA=xr,e.BAtos=Ar,e.BAtohex=kr,e.stohex=Pr,e.stob64=function fn(t){return S(Pr(t))},e.stob64u=function gn(t){return Cr(S(Pr(t)))},e.b64utos=function dn(t){return Ar(w(Tr(t)))},e.b64tob64u=Cr,e.b64utob64=Tr,e.hex2b64=S,e.hextob64u=Rr,e.b64utohex=Ir,e.utf8tob64u=wr,e.b64utoutf8=Fr,e.utf8tob64=function pn(t){return S(qr(Gr(t)))},e.b64toutf8=function vn(t){return decodeURIComponent(Jr(b(t)))},e.utf8tohex=Dr,e.hextoutf8=Lr,e.hextorstr=Nr,e.rstrtohex=Ur,e.hextob64=Br,e.hextob64nl=Or,e.b64nltohex=jr,e.hextopem=Mr,e.pemtohex=Hr,e.hextoArrayBuffer=function yn(t){if(t.length%2!=0)throw"input is not even length";if(null==t.match(/^[0-9A-Fa-f]+$/))throw"input is not hexadecimal";for(var e=new ArrayBuffer(t.length/2),r=new DataView(e),n=0;n<t.length/2;n++)r.setUint8(n,parseInt(t.substr(2*n,2),16));return e},e.ArrayBuffertohex=function mn(t){for(var e="",r=new DataView(t),n=0;n<t.byteLength;n++)e+=("00"+r.getUint8(n).toString(16)).slice(-2);return e},e.zulutomsec=Vr,e.zulutosec=Kr,e.zulutodate=function _n(t){return new Date(Vr(t))},e.datetozulu=function Sn(t,e,r){var n,i=t.getUTCFullYear();if(e){if(i<1950||2049<i)throw"not proper year for UTCTime: "+i;n=(""+i).slice(-2)}else n=("000"+i).slice(-4);if(n+=("0"+(t.getUTCMonth()+1)).slice(-2),n+=("0"+t.getUTCDate()).slice(-2),n+=("0"+t.getUTCHours()).slice(-2),n+=("0"+t.getUTCMinutes()).slice(-2),n+=("0"+t.getUTCSeconds()).slice(-2),r){var o=t.getUTCMilliseconds();0!==o&&(n+="."+(o=(o=("00"+o).slice(-3)).replace(/0+$/g,"")))}return n+="Z"},e.uricmptohex=qr,e.hextouricmp=Jr,e.ipv6tohex=Wr,e.hextoipv6=zr,e.hextoip=Yr,e.iptohex=function bn(t){var e="malformed IP address";if(!(t=t.toLowerCase(t)).match(/^[0-9.]+$/)){if(t.match(/^[0-9a-f:]+$/)&&-1!==t.indexOf(":"))return Wr(t);throw e}var r=t.split(".");if(4!==r.length)throw e;var n="";try{for(var i=0;i<4;i++){n+=("0"+parseInt(r[i]).toString(16)).slice(-2)}return n}catch(t){throw e}},e.encodeURIComponentAll=Gr,e.newline_toUnix=function wn(t){return t=t.replace(/\r\n/gm,"\n")},e.newline_toDos=function Fn(t){return t=(t=t.replace(/\r\n/gm,"\n")).replace(/\n/gm,"\r\n")},e.hextoposhex=$r,e.intarystrtohex=function En(t){t=(t=(t=t.replace(/^\s*\[\s*/,"")).replace(/\s*\]\s*$/,"")).replace(/\s*/g,"");try{return t.split(/,/).map((function(t,e,r){var n=parseInt(t);if(n<0||255<n)throw"integer not in range 0-255";return("00"+n.toString(16)).slice(-2)})).join("")}catch(t){throw"malformed integer array string: "+t}},e.strdiffidx=function t(e,r){var n=e.length;e.length>r.length&&(n=r.length);for(var i=0;i<n;i++)if(e.charCodeAt(i)!=r.charCodeAt(i))return i;return e.length!=r.length?n:-1},e.KJUR=br;var xn=br.crypto;e.crypto=xn;var An=br.asn1;e.asn1=An;var kn=br.jws;e.jws=kn;var Pn=br.lang;e.lang=Pn}).call(this,r(28).Buffer)},function(t,e,r){"use strict";(function(t){
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
var n=r(30),i=r(31),o=r(32);function s(){return u.TYPED_ARRAY_SUPPORT?2147483647:1073741823}function a(t,e){if(s()<e)throw new RangeError("Invalid typed array length");return u.TYPED_ARRAY_SUPPORT?(t=new Uint8Array(e)).__proto__=u.prototype:(null===t&&(t=new u(e)),t.length=e),t}function u(t,e,r){if(!(u.TYPED_ARRAY_SUPPORT||this instanceof u))return new u(t,e,r);if("number"==typeof t){if("string"==typeof e)throw new Error("If encoding is specified then the first argument must be a string");return l(this,t)}return c(this,t,e,r)}function c(t,e,r,n){if("number"==typeof e)throw new TypeError('"value" argument must not be a number');return"undefined"!=typeof ArrayBuffer&&e instanceof ArrayBuffer?function i(t,e,r,n){if(e.byteLength,r<0||e.byteLength<r)throw new RangeError("'offset' is out of bounds");if(e.byteLength<r+(n||0))throw new RangeError("'length' is out of bounds");e=void 0===r&&void 0===n?new Uint8Array(e):void 0===n?new Uint8Array(e,r):new Uint8Array(e,r,n);u.TYPED_ARRAY_SUPPORT?(t=e).__proto__=u.prototype:t=f(t,e);return t}(t,e,r,n):"string"==typeof e?function s(t,e,r){"string"==typeof r&&""!==r||(r="utf8");if(!u.isEncoding(r))throw new TypeError('"encoding" must be a valid string encoding');var n=0|d(e,r),i=(t=a(t,n)).write(e,r);i!==n&&(t=t.slice(0,i));return t}(t,e,r):function c(t,e){if(u.isBuffer(e)){var r=0|g(e.length);return 0===(t=a(t,r)).length||e.copy(t,0,0,r),t}if(e){if("undefined"!=typeof ArrayBuffer&&e.buffer instanceof ArrayBuffer||"length"in e)return"number"!=typeof e.length||function n(t){return t!=t}(e.length)?a(t,0):f(t,e);if("Buffer"===e.type&&o(e.data))return f(t,e.data)}throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.")}(t,e)}function h(t){if("number"!=typeof t)throw new TypeError('"size" argument must be a number');if(t<0)throw new RangeError('"size" argument must not be negative')}function l(t,e){if(h(e),t=a(t,e<0?0:0|g(e)),!u.TYPED_ARRAY_SUPPORT)for(var r=0;r<e;++r)t[r]=0;return t}function f(t,e){var r=e.length<0?0:0|g(e.length);t=a(t,r);for(var n=0;n<r;n+=1)t[n]=255&e[n];return t}function g(t){if(t>=s())throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x"+s().toString(16)+" bytes");return 0|t}function d(t,e){if(u.isBuffer(t))return t.length;if("undefined"!=typeof ArrayBuffer&&"function"==typeof ArrayBuffer.isView&&(ArrayBuffer.isView(t)||t instanceof ArrayBuffer))return t.byteLength;"string"!=typeof t&&(t=""+t);var r=t.length;if(0===r)return 0;for(var n=!1;;)switch(e){case"ascii":case"latin1":case"binary":return r;case"utf8":case"utf-8":case void 0:return K(t).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return 2*r;case"hex":return r>>>1;case"base64":return q(t).length;default:if(n)return K(t).length;e=(""+e).toLowerCase(),n=!0}}function p(t,e,r){var n=!1;if((void 0===e||e<0)&&(e=0),e>this.length)return"";if((void 0===r||r>this.length)&&(r=this.length),r<=0)return"";if((r>>>=0)<=(e>>>=0))return"";for(t||(t="utf8");;)switch(t){case"hex":return I(this,e,r);case"utf8":case"utf-8":return A(this,e,r);case"ascii":return T(this,e,r);case"latin1":case"binary":return R(this,e,r);case"base64":return x(this,e,r);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return D(this,e,r);default:if(n)throw new TypeError("Unknown encoding: "+t);t=(t+"").toLowerCase(),n=!0}}function v(t,e,r){var n=t[e];t[e]=t[r],t[r]=n}function y(t,e,r,n,i){if(0===t.length)return-1;if("string"==typeof r?(n=r,r=0):r>2147483647?r=2147483647:r<-2147483648&&(r=-2147483648),r=+r,isNaN(r)&&(r=i?0:t.length-1),r<0&&(r=t.length+r),r>=t.length){if(i)return-1;r=t.length-1}else if(r<0){if(!i)return-1;r=0}if("string"==typeof e&&(e=u.from(e,n)),u.isBuffer(e))return 0===e.length?-1:m(t,e,r,n,i);if("number"==typeof e)return e&=255,u.TYPED_ARRAY_SUPPORT&&"function"==typeof Uint8Array.prototype.indexOf?i?Uint8Array.prototype.indexOf.call(t,e,r):Uint8Array.prototype.lastIndexOf.call(t,e,r):m(t,[e],r,n,i);throw new TypeError("val must be string, number or Buffer")}function m(t,e,r,n,i){var o,s=1,a=t.length,u=e.length;if(void 0!==n&&("ucs2"===(n=String(n).toLowerCase())||"ucs-2"===n||"utf16le"===n||"utf-16le"===n)){if(t.length<2||e.length<2)return-1;s=2,a/=2,u/=2,r/=2}function c(t,e){return 1===s?t[e]:t.readUInt16BE(e*s)}if(i){var h=-1;for(o=r;o<a;o++)if(c(t,o)===c(e,-1===h?0:o-h)){if(-1===h&&(h=o),o-h+1===u)return h*s}else-1!==h&&(o-=o-h),h=-1}else for(r+u>a&&(r=a-u),o=r;o>=0;o--){for(var l=!0,f=0;f<u;f++)if(c(t,o+f)!==c(e,f)){l=!1;break}if(l)return o}return-1}function _(t,e,r,n){r=Number(r)||0;var i=t.length-r;n?(n=Number(n))>i&&(n=i):n=i;var o=e.length;if(o%2!=0)throw new TypeError("Invalid hex string");n>o/2&&(n=o/2);for(var s=0;s<n;++s){var a=parseInt(e.substr(2*s,2),16);if(isNaN(a))return s;t[r+s]=a}return s}function S(t,e,r,n){return J(K(e,t.length-r),t,r,n)}function b(t,e,r,n){return J(function i(t){for(var e=[],r=0;r<t.length;++r)e.push(255&t.charCodeAt(r));return e}(e),t,r,n)}function w(t,e,r,n){return b(t,e,r,n)}function F(t,e,r,n){return J(q(e),t,r,n)}function E(t,e,r,n){return J(function i(t,e){for(var r,n,i,o=[],s=0;s<t.length&&!((e-=2)<0);++s)n=(r=t.charCodeAt(s))>>8,i=r%256,o.push(i),o.push(n);return o}(e,t.length-r),t,r,n)}function x(t,e,r){return 0===e&&r===t.length?n.fromByteArray(t):n.fromByteArray(t.slice(e,r))}function A(t,e,r){r=Math.min(t.length,r);for(var n=[],i=e;i<r;){var o,s,a,u,c=t[i],h=null,l=c>239?4:c>223?3:c>191?2:1;if(i+l<=r)switch(l){case 1:c<128&&(h=c);break;case 2:128==(192&(o=t[i+1]))&&(u=(31&c)<<6|63&o)>127&&(h=u);break;case 3:o=t[i+1],s=t[i+2],128==(192&o)&&128==(192&s)&&(u=(15&c)<<12|(63&o)<<6|63&s)>2047&&(u<55296||u>57343)&&(h=u);break;case 4:o=t[i+1],s=t[i+2],a=t[i+3],128==(192&o)&&128==(192&s)&&128==(192&a)&&(u=(15&c)<<18|(63&o)<<12|(63&s)<<6|63&a)>65535&&u<1114112&&(h=u)}null===h?(h=65533,l=1):h>65535&&(h-=65536,n.push(h>>>10&1023|55296),h=56320|1023&h),n.push(h),i+=l}return function f(t){var e=t.length;if(e<=C)return String.fromCharCode.apply(String,t);var r="",n=0;for(;n<e;)r+=String.fromCharCode.apply(String,t.slice(n,n+=C));return r}(n)}e.Buffer=u,e.SlowBuffer=function k(t){+t!=t&&(t=0);return u.alloc(+t)},e.INSPECT_MAX_BYTES=50,u.TYPED_ARRAY_SUPPORT=void 0!==t.TYPED_ARRAY_SUPPORT?t.TYPED_ARRAY_SUPPORT:function P(){try{var t=new Uint8Array(1);return t.__proto__={__proto__:Uint8Array.prototype,foo:function(){return 42}},42===t.foo()&&"function"==typeof t.subarray&&0===t.subarray(1,1).byteLength}catch(t){return!1}}(),e.kMaxLength=s(),u.poolSize=8192,u._augment=function(t){return t.__proto__=u.prototype,t},u.from=function(t,e,r){return c(null,t,e,r)},u.TYPED_ARRAY_SUPPORT&&(u.prototype.__proto__=Uint8Array.prototype,u.__proto__=Uint8Array,"undefined"!=typeof Symbol&&Symbol.species&&u[Symbol.species]===u&&Object.defineProperty(u,Symbol.species,{value:null,configurable:!0})),u.alloc=function(t,e,r){return function n(t,e,r,i){return h(e),e<=0?a(t,e):void 0!==r?"string"==typeof i?a(t,e).fill(r,i):a(t,e).fill(r):a(t,e)}(null,t,e,r)},u.allocUnsafe=function(t){return l(null,t)},u.allocUnsafeSlow=function(t){return l(null,t)},u.isBuffer=function t(e){return!(null==e||!e._isBuffer)},u.compare=function t(e,r){if(!u.isBuffer(e)||!u.isBuffer(r))throw new TypeError("Arguments must be Buffers");if(e===r)return 0;for(var n=e.length,i=r.length,o=0,s=Math.min(n,i);o<s;++o)if(e[o]!==r[o]){n=e[o],i=r[o];break}return n<i?-1:i<n?1:0},u.isEncoding=function t(e){switch(String(e).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"latin1":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return!0;default:return!1}},u.concat=function t(e,r){if(!o(e))throw new TypeError('"list" argument must be an Array of Buffers');if(0===e.length)return u.alloc(0);var n;if(void 0===r)for(r=0,n=0;n<e.length;++n)r+=e[n].length;var i=u.allocUnsafe(r),s=0;for(n=0;n<e.length;++n){var a=e[n];if(!u.isBuffer(a))throw new TypeError('"list" argument must be an Array of Buffers');a.copy(i,s),s+=a.length}return i},u.byteLength=d,u.prototype._isBuffer=!0,u.prototype.swap16=function t(){var e=this.length;if(e%2!=0)throw new RangeError("Buffer size must be a multiple of 16-bits");for(var r=0;r<e;r+=2)v(this,r,r+1);return this},u.prototype.swap32=function t(){var e=this.length;if(e%4!=0)throw new RangeError("Buffer size must be a multiple of 32-bits");for(var r=0;r<e;r+=4)v(this,r,r+3),v(this,r+1,r+2);return this},u.prototype.swap64=function t(){var e=this.length;if(e%8!=0)throw new RangeError("Buffer size must be a multiple of 64-bits");for(var r=0;r<e;r+=8)v(this,r,r+7),v(this,r+1,r+6),v(this,r+2,r+5),v(this,r+3,r+4);return this},u.prototype.toString=function t(){var e=0|this.length;return 0===e?"":0===arguments.length?A(this,0,e):p.apply(this,arguments)},u.prototype.equals=function t(e){if(!u.isBuffer(e))throw new TypeError("Argument must be a Buffer");return this===e||0===u.compare(this,e)},u.prototype.inspect=function t(){var r="",n=e.INSPECT_MAX_BYTES;return this.length>0&&(r=this.toString("hex",0,n).match(/.{2}/g).join(" "),this.length>n&&(r+=" ... ")),"<Buffer "+r+">"},u.prototype.compare=function t(e,r,n,i,o){if(!u.isBuffer(e))throw new TypeError("Argument must be a Buffer");if(void 0===r&&(r=0),void 0===n&&(n=e?e.length:0),void 0===i&&(i=0),void 0===o&&(o=this.length),r<0||n>e.length||i<0||o>this.length)throw new RangeError("out of range index");if(i>=o&&r>=n)return 0;if(i>=o)return-1;if(r>=n)return 1;if(this===e)return 0;for(var s=(o>>>=0)-(i>>>=0),a=(n>>>=0)-(r>>>=0),c=Math.min(s,a),h=this.slice(i,o),l=e.slice(r,n),f=0;f<c;++f)if(h[f]!==l[f]){s=h[f],a=l[f];break}return s<a?-1:a<s?1:0},u.prototype.includes=function t(e,r,n){return-1!==this.indexOf(e,r,n)},u.prototype.indexOf=function t(e,r,n){return y(this,e,r,n,!0)},u.prototype.lastIndexOf=function t(e,r,n){return y(this,e,r,n,!1)},u.prototype.write=function t(e,r,n,i){if(void 0===r)i="utf8",n=this.length,r=0;else if(void 0===n&&"string"==typeof r)i=r,n=this.length,r=0;else{if(!isFinite(r))throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");r|=0,isFinite(n)?(n|=0,void 0===i&&(i="utf8")):(i=n,n=void 0)}var o=this.length-r;if((void 0===n||n>o)&&(n=o),e.length>0&&(n<0||r<0)||r>this.length)throw new RangeError("Attempt to write outside buffer bounds");i||(i="utf8");for(var s=!1;;)switch(i){case"hex":return _(this,e,r,n);case"utf8":case"utf-8":return S(this,e,r,n);case"ascii":return b(this,e,r,n);case"latin1":case"binary":return w(this,e,r,n);case"base64":return F(this,e,r,n);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return E(this,e,r,n);default:if(s)throw new TypeError("Unknown encoding: "+i);i=(""+i).toLowerCase(),s=!0}},u.prototype.toJSON=function t(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};var C=4096;function T(t,e,r){var n="";r=Math.min(t.length,r);for(var i=e;i<r;++i)n+=String.fromCharCode(127&t[i]);return n}function R(t,e,r){var n="";r=Math.min(t.length,r);for(var i=e;i<r;++i)n+=String.fromCharCode(t[i]);return n}function I(t,e,r){var n=t.length;(!e||e<0)&&(e=0),(!r||r<0||r>n)&&(r=n);for(var i="",o=e;o<r;++o)i+=V(t[o]);return i}function D(t,e,r){for(var n=t.slice(e,r),i="",o=0;o<n.length;o+=2)i+=String.fromCharCode(n[o]+256*n[o+1]);return i}function L(t,e,r){if(t%1!=0||t<0)throw new RangeError("offset is not uint");if(t+e>r)throw new RangeError("Trying to access beyond buffer length")}function N(t,e,r,n,i,o){if(!u.isBuffer(t))throw new TypeError('"buffer" argument must be a Buffer instance');if(e>i||e<o)throw new RangeError('"value" argument is out of bounds');if(r+n>t.length)throw new RangeError("Index out of range")}function U(t,e,r,n){e<0&&(e=65535+e+1);for(var i=0,o=Math.min(t.length-r,2);i<o;++i)t[r+i]=(e&255<<8*(n?i:1-i))>>>8*(n?i:1-i)}function B(t,e,r,n){e<0&&(e=4294967295+e+1);for(var i=0,o=Math.min(t.length-r,4);i<o;++i)t[r+i]=e>>>8*(n?i:3-i)&255}function O(t,e,r,n,i,o){if(r+n>t.length)throw new RangeError("Index out of range");if(r<0)throw new RangeError("Index out of range")}function j(t,e,r,n,o){return o||O(t,0,r,4),i.write(t,e,r,n,23,4),r+4}function M(t,e,r,n,o){return o||O(t,0,r,8),i.write(t,e,r,n,52,8),r+8}u.prototype.slice=function t(e,r){var n,i=this.length;if((e=~~e)<0?(e+=i)<0&&(e=0):e>i&&(e=i),(r=void 0===r?i:~~r)<0?(r+=i)<0&&(r=0):r>i&&(r=i),r<e&&(r=e),u.TYPED_ARRAY_SUPPORT)(n=this.subarray(e,r)).__proto__=u.prototype;else{var o=r-e;n=new u(o,void 0);for(var s=0;s<o;++s)n[s]=this[s+e]}return n},u.prototype.readUIntLE=function t(e,r,n){e|=0,r|=0,n||L(e,r,this.length);for(var i=this[e],o=1,s=0;++s<r&&(o*=256);)i+=this[e+s]*o;return i},u.prototype.readUIntBE=function t(e,r,n){e|=0,r|=0,n||L(e,r,this.length);for(var i=this[e+--r],o=1;r>0&&(o*=256);)i+=this[e+--r]*o;return i},u.prototype.readUInt8=function t(e,r){return r||L(e,1,this.length),this[e]},u.prototype.readUInt16LE=function t(e,r){return r||L(e,2,this.length),this[e]|this[e+1]<<8},u.prototype.readUInt16BE=function t(e,r){return r||L(e,2,this.length),this[e]<<8|this[e+1]},u.prototype.readUInt32LE=function t(e,r){return r||L(e,4,this.length),(this[e]|this[e+1]<<8|this[e+2]<<16)+16777216*this[e+3]},u.prototype.readUInt32BE=function t(e,r){return r||L(e,4,this.length),16777216*this[e]+(this[e+1]<<16|this[e+2]<<8|this[e+3])},u.prototype.readIntLE=function t(e,r,n){e|=0,r|=0,n||L(e,r,this.length);for(var i=this[e],o=1,s=0;++s<r&&(o*=256);)i+=this[e+s]*o;return i>=(o*=128)&&(i-=Math.pow(2,8*r)),i},u.prototype.readIntBE=function t(e,r,n){e|=0,r|=0,n||L(e,r,this.length);for(var i=r,o=1,s=this[e+--i];i>0&&(o*=256);)s+=this[e+--i]*o;return s>=(o*=128)&&(s-=Math.pow(2,8*r)),s},u.prototype.readInt8=function t(e,r){return r||L(e,1,this.length),128&this[e]?-1*(255-this[e]+1):this[e]},u.prototype.readInt16LE=function t(e,r){r||L(e,2,this.length);var n=this[e]|this[e+1]<<8;return 32768&n?4294901760|n:n},u.prototype.readInt16BE=function t(e,r){r||L(e,2,this.length);var n=this[e+1]|this[e]<<8;return 32768&n?4294901760|n:n},u.prototype.readInt32LE=function t(e,r){return r||L(e,4,this.length),this[e]|this[e+1]<<8|this[e+2]<<16|this[e+3]<<24},u.prototype.readInt32BE=function t(e,r){return r||L(e,4,this.length),this[e]<<24|this[e+1]<<16|this[e+2]<<8|this[e+3]},u.prototype.readFloatLE=function t(e,r){return r||L(e,4,this.length),i.read(this,e,!0,23,4)},u.prototype.readFloatBE=function t(e,r){return r||L(e,4,this.length),i.read(this,e,!1,23,4)},u.prototype.readDoubleLE=function t(e,r){return r||L(e,8,this.length),i.read(this,e,!0,52,8)},u.prototype.readDoubleBE=function t(e,r){return r||L(e,8,this.length),i.read(this,e,!1,52,8)},u.prototype.writeUIntLE=function t(e,r,n,i){(e=+e,r|=0,n|=0,i)||N(this,e,r,n,Math.pow(2,8*n)-1,0);var o=1,s=0;for(this[r]=255&e;++s<n&&(o*=256);)this[r+s]=e/o&255;return r+n},u.prototype.writeUIntBE=function t(e,r,n,i){(e=+e,r|=0,n|=0,i)||N(this,e,r,n,Math.pow(2,8*n)-1,0);var o=n-1,s=1;for(this[r+o]=255&e;--o>=0&&(s*=256);)this[r+o]=e/s&255;return r+n},u.prototype.writeUInt8=function t(e,r,n){return e=+e,r|=0,n||N(this,e,r,1,255,0),u.TYPED_ARRAY_SUPPORT||(e=Math.floor(e)),this[r]=255&e,r+1},u.prototype.writeUInt16LE=function t(e,r,n){return e=+e,r|=0,n||N(this,e,r,2,65535,0),u.TYPED_ARRAY_SUPPORT?(this[r]=255&e,this[r+1]=e>>>8):U(this,e,r,!0),r+2},u.prototype.writeUInt16BE=function t(e,r,n){return e=+e,r|=0,n||N(this,e,r,2,65535,0),u.TYPED_ARRAY_SUPPORT?(this[r]=e>>>8,this[r+1]=255&e):U(this,e,r,!1),r+2},u.prototype.writeUInt32LE=function t(e,r,n){return e=+e,r|=0,n||N(this,e,r,4,4294967295,0),u.TYPED_ARRAY_SUPPORT?(this[r+3]=e>>>24,this[r+2]=e>>>16,this[r+1]=e>>>8,this[r]=255&e):B(this,e,r,!0),r+4},u.prototype.writeUInt32BE=function t(e,r,n){return e=+e,r|=0,n||N(this,e,r,4,4294967295,0),u.TYPED_ARRAY_SUPPORT?(this[r]=e>>>24,this[r+1]=e>>>16,this[r+2]=e>>>8,this[r+3]=255&e):B(this,e,r,!1),r+4},u.prototype.writeIntLE=function t(e,r,n,i){if(e=+e,r|=0,!i){var o=Math.pow(2,8*n-1);N(this,e,r,n,o-1,-o)}var s=0,a=1,u=0;for(this[r]=255&e;++s<n&&(a*=256);)e<0&&0===u&&0!==this[r+s-1]&&(u=1),this[r+s]=(e/a>>0)-u&255;return r+n},u.prototype.writeIntBE=function t(e,r,n,i){if(e=+e,r|=0,!i){var o=Math.pow(2,8*n-1);N(this,e,r,n,o-1,-o)}var s=n-1,a=1,u=0;for(this[r+s]=255&e;--s>=0&&(a*=256);)e<0&&0===u&&0!==this[r+s+1]&&(u=1),this[r+s]=(e/a>>0)-u&255;return r+n},u.prototype.writeInt8=function t(e,r,n){return e=+e,r|=0,n||N(this,e,r,1,127,-128),u.TYPED_ARRAY_SUPPORT||(e=Math.floor(e)),e<0&&(e=255+e+1),this[r]=255&e,r+1},u.prototype.writeInt16LE=function t(e,r,n){return e=+e,r|=0,n||N(this,e,r,2,32767,-32768),u.TYPED_ARRAY_SUPPORT?(this[r]=255&e,this[r+1]=e>>>8):U(this,e,r,!0),r+2},u.prototype.writeInt16BE=function t(e,r,n){return e=+e,r|=0,n||N(this,e,r,2,32767,-32768),u.TYPED_ARRAY_SUPPORT?(this[r]=e>>>8,this[r+1]=255&e):U(this,e,r,!1),r+2},u.prototype.writeInt32LE=function t(e,r,n){return e=+e,r|=0,n||N(this,e,r,4,2147483647,-2147483648),u.TYPED_ARRAY_SUPPORT?(this[r]=255&e,this[r+1]=e>>>8,this[r+2]=e>>>16,this[r+3]=e>>>24):B(this,e,r,!0),r+4},u.prototype.writeInt32BE=function t(e,r,n){return e=+e,r|=0,n||N(this,e,r,4,2147483647,-2147483648),e<0&&(e=4294967295+e+1),u.TYPED_ARRAY_SUPPORT?(this[r]=e>>>24,this[r+1]=e>>>16,this[r+2]=e>>>8,this[r+3]=255&e):B(this,e,r,!1),r+4},u.prototype.writeFloatLE=function t(e,r,n){return j(this,e,r,!0,n)},u.prototype.writeFloatBE=function t(e,r,n){return j(this,e,r,!1,n)},u.prototype.writeDoubleLE=function t(e,r,n){return M(this,e,r,!0,n)},u.prototype.writeDoubleBE=function t(e,r,n){return M(this,e,r,!1,n)},u.prototype.copy=function t(e,r,n,i){if(n||(n=0),i||0===i||(i=this.length),r>=e.length&&(r=e.length),r||(r=0),i>0&&i<n&&(i=n),i===n)return 0;if(0===e.length||0===this.length)return 0;if(r<0)throw new RangeError("targetStart out of bounds");if(n<0||n>=this.length)throw new RangeError("sourceStart out of bounds");if(i<0)throw new RangeError("sourceEnd out of bounds");i>this.length&&(i=this.length),e.length-r<i-n&&(i=e.length-r+n);var o,s=i-n;if(this===e&&n<r&&r<i)for(o=s-1;o>=0;--o)e[o+r]=this[o+n];else if(s<1e3||!u.TYPED_ARRAY_SUPPORT)for(o=0;o<s;++o)e[o+r]=this[o+n];else Uint8Array.prototype.set.call(e,this.subarray(n,n+s),r);return s},u.prototype.fill=function t(e,r,n,i){if("string"==typeof e){if("string"==typeof r?(i=r,r=0,n=this.length):"string"==typeof n&&(i=n,n=this.length),1===e.length){var o=e.charCodeAt(0);o<256&&(e=o)}if(void 0!==i&&"string"!=typeof i)throw new TypeError("encoding must be a string");if("string"==typeof i&&!u.isEncoding(i))throw new TypeError("Unknown encoding: "+i)}else"number"==typeof e&&(e&=255);if(r<0||this.length<r||this.length<n)throw new RangeError("Out of range index");if(n<=r)return this;var s;if(r>>>=0,n=void 0===n?this.length:n>>>0,e||(e=0),"number"==typeof e)for(s=r;s<n;++s)this[s]=e;else{var a=u.isBuffer(e)?e:K(new u(e,i).toString()),c=a.length;for(s=0;s<n-r;++s)this[s+r]=a[s%c]}return this};var H=/[^+\/0-9A-Za-z-_]/g;function V(t){return t<16?"0"+t.toString(16):t.toString(16)}function K(t,e){var r;e=e||1/0;for(var n=t.length,i=null,o=[],s=0;s<n;++s){if((r=t.charCodeAt(s))>55295&&r<57344){if(!i){if(r>56319){(e-=3)>-1&&o.push(239,191,189);continue}if(s+1===n){(e-=3)>-1&&o.push(239,191,189);continue}i=r;continue}if(r<56320){(e-=3)>-1&&o.push(239,191,189),i=r;continue}r=65536+(i-55296<<10|r-56320)}else i&&(e-=3)>-1&&o.push(239,191,189);if(i=null,r<128){if((e-=1)<0)break;o.push(r)}else if(r<2048){if((e-=2)<0)break;o.push(r>>6|192,63&r|128)}else if(r<65536){if((e-=3)<0)break;o.push(r>>12|224,r>>6&63|128,63&r|128)}else{if(!(r<1114112))throw new Error("Invalid code point");if((e-=4)<0)break;o.push(r>>18|240,r>>12&63|128,r>>6&63|128,63&r|128)}}return o}function q(t){return n.toByteArray(function e(t){if((t=function e(t){return t.trim?t.trim():t.replace(/^\s+|\s+$/g,"")}(t).replace(H,"")).length<2)return"";for(;t.length%4!=0;)t+="=";return t}(t))}function J(t,e,r,n){for(var i=0;i<n&&!(i+r>=e.length||i>=t.length);++i)e[i+r]=t[i];return i}}).call(this,r(29))},function(t,e){var r;r=function(){return this}();try{r=r||new Function("return this")()}catch(t){"object"==typeof window&&(r=window)}t.exports=r},function(t,e,r){"use strict";e.byteLength=function n(t){var e=f(t),r=e[0],n=e[1];return 3*(r+n)/4-n},e.toByteArray=function i(t){var e,r,n=f(t),i=n[0],o=n[1],s=new u(function c(t,e,r){return 3*(e+r)/4-r}(0,i,o)),h=0,l=o>0?i-4:i;for(r=0;r<l;r+=4)e=a[t.charCodeAt(r)]<<18|a[t.charCodeAt(r+1)]<<12|a[t.charCodeAt(r+2)]<<6|a[t.charCodeAt(r+3)],s[h++]=e>>16&255,s[h++]=e>>8&255,s[h++]=255&e;2===o&&(e=a[t.charCodeAt(r)]<<2|a[t.charCodeAt(r+1)]>>4,s[h++]=255&e);1===o&&(e=a[t.charCodeAt(r)]<<10|a[t.charCodeAt(r+1)]<<4|a[t.charCodeAt(r+2)]>>2,s[h++]=e>>8&255,s[h++]=255&e);return s},e.fromByteArray=function o(t){for(var e,r=t.length,n=r%3,i=[],o=16383,a=0,u=r-n;a<u;a+=o)i.push(g(t,a,a+o>u?u:a+o));1===n?(e=t[r-1],i.push(s[e>>2]+s[e<<4&63]+"==")):2===n&&(e=(t[r-2]<<8)+t[r-1],i.push(s[e>>10]+s[e>>4&63]+s[e<<2&63]+"="));return i.join("")};for(var s=[],a=[],u="undefined"!=typeof Uint8Array?Uint8Array:Array,c="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",h=0,l=c.length;h<l;++h)s[h]=c[h],a[c.charCodeAt(h)]=h;function f(t){var e=t.length;if(e%4>0)throw new Error("Invalid string. Length must be a multiple of 4");var r=t.indexOf("=");return-1===r&&(r=e),[r,r===e?0:4-r%4]}function g(t,e,r){for(var n,i,o=[],a=e;a<r;a+=3)n=(t[a]<<16&16711680)+(t[a+1]<<8&65280)+(255&t[a+2]),o.push(s[(i=n)>>18&63]+s[i>>12&63]+s[i>>6&63]+s[63&i]);return o.join("")}a["-".charCodeAt(0)]=62,a["_".charCodeAt(0)]=63},function(t,e){
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
e.read=function(t,e,r,n,i){var o,s,a=8*i-n-1,u=(1<<a)-1,c=u>>1,h=-7,l=r?i-1:0,f=r?-1:1,g=t[e+l];for(l+=f,o=g&(1<<-h)-1,g>>=-h,h+=a;h>0;o=256*o+t[e+l],l+=f,h-=8);for(s=o&(1<<-h)-1,o>>=-h,h+=n;h>0;s=256*s+t[e+l],l+=f,h-=8);if(0===o)o=1-c;else{if(o===u)return s?NaN:1/0*(g?-1:1);s+=Math.pow(2,n),o-=c}return(g?-1:1)*s*Math.pow(2,o-n)},e.write=function(t,e,r,n,i,o){var s,a,u,c=8*o-i-1,h=(1<<c)-1,l=h>>1,f=23===i?Math.pow(2,-24)-Math.pow(2,-77):0,g=n?0:o-1,d=n?1:-1,p=e<0||0===e&&1/e<0?1:0;for(e=Math.abs(e),isNaN(e)||e===1/0?(a=isNaN(e)?1:0,s=h):(s=Math.floor(Math.log(e)/Math.LN2),e*(u=Math.pow(2,-s))<1&&(s--,u*=2),(e+=s+l>=1?f/u:f*Math.pow(2,1-l))*u>=2&&(s++,u/=2),s+l>=h?(a=0,s=h):s+l>=1?(a=(e*u-1)*Math.pow(2,i),s+=l):(a=e*Math.pow(2,l-1)*Math.pow(2,i),s=0));i>=8;t[r+g]=255&a,g+=d,a/=256,i-=8);for(s=s<<i|a,c+=i;c>0;t[r+g]=255&s,g+=d,s/=256,c-=8);t[r+g-d]|=128*p}},function(t,e){var r={}.toString;t.exports=Array.isArray||function(t){return"[object Array]"==r.call(t)}},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default=function n(t){var e=t.jws,r=t.KeyUtil,n=t.X509,o=t.crypto,s=t.hextob64u,a=t.b64tohex,u=t.AllowedSigningAlgs;return function(){function t(){!function e(t,r){if(!(t instanceof r))throw new TypeError("Cannot call a class as a function")}(this,t)}return t.parseJwt=function t(r){i.Log.debug("JoseUtil.parseJwt");try{var n=e.JWS.parse(r);return{header:n.headerObj,payload:n.payloadObj}}catch(t){i.Log.error(t)}},t.validateJwt=function e(o,s,u,c,h,l,f){i.Log.debug("JoseUtil.validateJwt");try{if("RSA"===s.kty)if(s.e&&s.n)s=r.getKey(s);else{if(!s.x5c||!s.x5c.length)return i.Log.error("JoseUtil.validateJwt: RSA key missing key material",s),Promise.reject(new Error("RSA key missing key material"));var g=a(s.x5c[0]);s=n.getPublicKeyFromCertHex(g)}else{if("EC"!==s.kty)return i.Log.error("JoseUtil.validateJwt: Unsupported key type",s&&s.kty),Promise.reject(new Error(s.kty));if(!(s.crv&&s.x&&s.y))return i.Log.error("JoseUtil.validateJwt: EC key missing key material",s),Promise.reject(new Error("EC key missing key material"));s=r.getKey(s)}return t._validateJwt(o,s,u,c,h,l,f)}catch(t){return i.Log.error(t&&t.message||t),Promise.reject("JWT validation failed")}},t.validateJwtAttributes=function e(r,n,o,s,a,u){s||(s=0),a||(a=parseInt(Date.now()/1e3));var c=t.parseJwt(r).payload;if(!c.iss)return i.Log.error("JoseUtil._validateJwt: issuer was not provided"),Promise.reject(new Error("issuer was not provided"));if(c.iss!==n)return i.Log.error("JoseUtil._validateJwt: Invalid issuer in token",c.iss),Promise.reject(new Error("Invalid issuer in token: "+c.iss));if(!c.aud)return i.Log.error("JoseUtil._validateJwt: aud was not provided"),Promise.reject(new Error("aud was not provided"));if(!(c.aud===o||Array.isArray(c.aud)&&c.aud.indexOf(o)>=0))return i.Log.error("JoseUtil._validateJwt: Invalid audience in token",c.aud),Promise.reject(new Error("Invalid audience in token: "+c.aud));if(c.azp&&c.azp!==o)return i.Log.error("JoseUtil._validateJwt: Invalid azp in token",c.azp),Promise.reject(new Error("Invalid azp in token: "+c.azp));if(!u){var h=a+s,l=a-s;if(!c.iat)return i.Log.error("JoseUtil._validateJwt: iat was not provided"),Promise.reject(new Error("iat was not provided"));if(h<c.iat)return i.Log.error("JoseUtil._validateJwt: iat is in the future",c.iat),Promise.reject(new Error("iat is in the future: "+c.iat));if(c.nbf&&h<c.nbf)return i.Log.error("JoseUtil._validateJwt: nbf is in the future",c.nbf),Promise.reject(new Error("nbf is in the future: "+c.nbf));if(!c.exp)return i.Log.error("JoseUtil._validateJwt: exp was not provided"),Promise.reject(new Error("exp was not provided"));if(c.exp<l)return i.Log.error("JoseUtil._validateJwt: exp is in the past",c.exp),Promise.reject(new Error("exp is in the past:"+c.exp))}return Promise.resolve(c)},t._validateJwt=function r(n,o,s,a,c,h,l){return t.validateJwtAttributes(n,s,a,c,h,l).then((function(t){try{return e.JWS.verify(n,o,u)?t:(i.Log.error("JoseUtil._validateJwt: signature validation failed"),Promise.reject(new Error("signature validation failed")))}catch(t){return i.Log.error(t&&t.message||t),Promise.reject(new Error("signature validation failed"))}}))},t.hashString=function t(e,r){try{return o.Util.hashString(e,r)}catch(t){i.Log.error(t)}},t.hexToBase64Url=function t(e){try{return s(e)}catch(t){i.Log.error(t)}},t}()};var i=r(0);t.exports=e.default},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.SigninResponse=void 0;var n=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),i=r(3);function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}e.SigninResponse=function(){function t(e){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"#";o(this,t);var n=i.UrlUtility.parseUrlFragment(e,r);this.error=n.error,this.error_description=n.error_description,this.error_uri=n.error_uri,this.code=n.code,this.state=n.state,this.id_token=n.id_token,this.session_state=n.session_state,this.access_token=n.access_token,this.token_type=n.token_type,this.scope=n.scope,this.profile=void 0,this.expires_in=n.expires_in}return n(t,[{key:"expires_in",get:function t(){if(this.expires_at){var e=parseInt(Date.now()/1e3);return this.expires_at-e}},set:function t(e){var r=parseInt(e);if("number"==typeof r&&r>0){var n=parseInt(Date.now()/1e3);this.expires_at=n+r}}},{key:"expired",get:function t(){var e=this.expires_in;if(void 0!==e)return e<=0}},{key:"scopes",get:function t(){return(this.scope||"").split(" ")}},{key:"isOpenIdConnect",get:function t(){return this.scopes.indexOf("openid")>=0||!!this.id_token}}]),t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.SignoutRequest=void 0;var n=r(0),i=r(3),o=r(9);e.SignoutRequest=function t(e){var r=e.url,s=e.id_token_hint,a=e.post_logout_redirect_uri,u=e.data,c=e.extraQueryParams,h=e.request_type;if(function l(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),!r)throw n.Log.error("SignoutRequest.ctor: No url passed"),new Error("url");for(var f in s&&(r=i.UrlUtility.addQueryParam(r,"id_token_hint",s)),a&&(r=i.UrlUtility.addQueryParam(r,"post_logout_redirect_uri",a),u&&(this.state=new o.State({data:u,request_type:h}),r=i.UrlUtility.addQueryParam(r,"state",this.state.id))),c)r=i.UrlUtility.addQueryParam(r,f,c[f]);this.url=r}},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.SignoutResponse=void 0;var n=r(3);e.SignoutResponse=function t(e){!function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t);var i=n.UrlUtility.parseUrlFragment(e,"?");this.error=i.error,this.error_description=i.error_description,this.error_uri=i.error_uri,this.state=i.state}},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.InMemoryWebStorage=void 0;var n=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),i=r(0);e.InMemoryWebStorage=function(){function t(){!function e(t,r){if(!(t instanceof r))throw new TypeError("Cannot call a class as a function")}(this,t),this._data={}}return t.prototype.getItem=function t(e){return i.Log.debug("InMemoryWebStorage.getItem",e),this._data[e]},t.prototype.setItem=function t(e,r){i.Log.debug("InMemoryWebStorage.setItem",e),this._data[e]=r},t.prototype.removeItem=function t(e){i.Log.debug("InMemoryWebStorage.removeItem",e),delete this._data[e]},t.prototype.key=function t(e){return Object.getOwnPropertyNames(this._data)[e]},n(t,[{key:"length",get:function t(){return Object.getOwnPropertyNames(this._data).length}}]),t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.UserManager=void 0;var n=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),i=r(0),o=r(10),s=r(39),a=r(15),u=r(45),c=r(47),h=r(18),l=r(8),f=r(20),g=r(11),d=r(4);function p(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function v(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}e.UserManager=function(t){function e(){var r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:c.SilentRenewService,o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:h.SessionMonitor,a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:f.TokenRevocationClient,l=arguments.length>4&&void 0!==arguments[4]?arguments[4]:g.TokenClient,y=arguments.length>5&&void 0!==arguments[5]?arguments[5]:d.JoseUtil;p(this,e),r instanceof s.UserManagerSettings||(r=new s.UserManagerSettings(r));var m=v(this,t.call(this,r));return m._events=new u.UserManagerEvents(r),m._silentRenewService=new n(m),m.settings.automaticSilentRenew&&(i.Log.debug("UserManager.ctor: automaticSilentRenew is configured, setting up silent renew"),m.startSilentRenew()),m.settings.monitorSession&&(i.Log.debug("UserManager.ctor: monitorSession is configured, setting up session monitor"),m._sessionMonitor=new o(m)),m._tokenRevocationClient=new a(m._settings),m._tokenClient=new l(m._settings),m._joseUtil=y,m}return function r(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),e.prototype.getUser=function t(){var e=this;return this._loadUser().then((function(t){return t?(i.Log.info("UserManager.getUser: user loaded"),e._events.load(t,!1),t):(i.Log.info("UserManager.getUser: user not found in storage"),null)}))},e.prototype.removeUser=function t(){var e=this;return this.storeUser(null).then((function(){i.Log.info("UserManager.removeUser: user removed from storage"),e._events.unload()}))},e.prototype.signinRedirect=function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};(e=Object.assign({},e)).request_type="si:r";var r={useReplaceToNavigate:e.useReplaceToNavigate};return this._signinStart(e,this._redirectNavigator,r).then((function(){i.Log.info("UserManager.signinRedirect: successful")}))},e.prototype.signinRedirectCallback=function t(e){return this._signinEnd(e||this._redirectNavigator.url).then((function(t){return t.profile&&t.profile.sub?i.Log.info("UserManager.signinRedirectCallback: successful, signed in sub: ",t.profile.sub):i.Log.info("UserManager.signinRedirectCallback: no sub"),t}))},e.prototype.signinPopup=function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};(e=Object.assign({},e)).request_type="si:p";var r=e.redirect_uri||this.settings.popup_redirect_uri||this.settings.redirect_uri;return r?(e.redirect_uri=r,e.display="popup",this._signin(e,this._popupNavigator,{startUrl:r,popupWindowFeatures:e.popupWindowFeatures||this.settings.popupWindowFeatures,popupWindowTarget:e.popupWindowTarget||this.settings.popupWindowTarget}).then((function(t){return t&&(t.profile&&t.profile.sub?i.Log.info("UserManager.signinPopup: signinPopup successful, signed in sub: ",t.profile.sub):i.Log.info("UserManager.signinPopup: no sub")),t}))):(i.Log.error("UserManager.signinPopup: No popup_redirect_uri or redirect_uri configured"),Promise.reject(new Error("No popup_redirect_uri or redirect_uri configured")))},e.prototype.signinPopupCallback=function t(e){return this._signinCallback(e,this._popupNavigator).then((function(t){return t&&(t.profile&&t.profile.sub?i.Log.info("UserManager.signinPopupCallback: successful, signed in sub: ",t.profile.sub):i.Log.info("UserManager.signinPopupCallback: no sub")),t})).catch((function(t){i.Log.error(t.message)}))},e.prototype.signinSilent=function t(){var e=this,r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return r=Object.assign({},r),this._loadUser().then((function(t){return t&&t.refresh_token?(r.refresh_token=t.refresh_token,e._useRefreshToken(r)):(r.request_type="si:s",r.id_token_hint=r.id_token_hint||e.settings.includeIdTokenInSilentRenew&&t&&t.id_token,t&&e._settings.validateSubOnSilentRenew&&(i.Log.debug("UserManager.signinSilent, subject prior to silent renew: ",t.profile.sub),r.current_sub=t.profile.sub),e._signinSilentIframe(r))}))},e.prototype._useRefreshToken=function t(){var e=this,r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return this._tokenClient.exchangeRefreshToken(r).then((function(t){return t?t.access_token?e._loadUser().then((function(r){if(r){var n=Promise.resolve();return t.id_token&&(n=e._validateIdTokenFromTokenRefreshToken(r.profile,t.id_token)),n.then((function(){return i.Log.debug("UserManager._useRefreshToken: refresh token response success"),r.id_token=t.id_token||r.id_token,r.access_token=t.access_token,r.refresh_token=t.refresh_token||r.refresh_token,r.expires_in=t.expires_in,e.storeUser(r).then((function(){return e._events.load(r),r}))}))}return null})):(i.Log.error("UserManager._useRefreshToken: No access token returned from token endpoint"),Promise.reject("No access token returned from token endpoint")):(i.Log.error("UserManager._useRefreshToken: No response returned from token endpoint"),Promise.reject("No response returned from token endpoint"))}))},e.prototype._validateIdTokenFromTokenRefreshToken=function t(e,r){var n=this;return this._metadataService.getIssuer().then((function(t){return n.settings.getEpochTime().then((function(o){return n._joseUtil.validateJwtAttributes(r,t,n._settings.client_id,n._settings.clockSkew,o).then((function(t){return t?t.sub!==e.sub?(i.Log.error("UserManager._validateIdTokenFromTokenRefreshToken: sub in id_token does not match current sub"),Promise.reject(new Error("sub in id_token does not match current sub"))):t.auth_time&&t.auth_time!==e.auth_time?(i.Log.error("UserManager._validateIdTokenFromTokenRefreshToken: auth_time in id_token does not match original auth_time"),Promise.reject(new Error("auth_time in id_token does not match original auth_time"))):t.azp&&t.azp!==e.azp?(i.Log.error("UserManager._validateIdTokenFromTokenRefreshToken: azp in id_token does not match original azp"),Promise.reject(new Error("azp in id_token does not match original azp"))):!t.azp&&e.azp?(i.Log.error("UserManager._validateIdTokenFromTokenRefreshToken: azp not in id_token, but present in original id_token"),Promise.reject(new Error("azp not in id_token, but present in original id_token"))):void 0:(i.Log.error("UserManager._validateIdTokenFromTokenRefreshToken: Failed to validate id_token"),Promise.reject(new Error("Failed to validate id_token")))}))}))}))},e.prototype._signinSilentIframe=function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=e.redirect_uri||this.settings.silent_redirect_uri||this.settings.redirect_uri;return r?(e.redirect_uri=r,e.prompt=e.prompt||"none",this._signin(e,this._iframeNavigator,{startUrl:r,silentRequestTimeout:e.silentRequestTimeout||this.settings.silentRequestTimeout}).then((function(t){return t&&(t.profile&&t.profile.sub?i.Log.info("UserManager.signinSilent: successful, signed in sub: ",t.profile.sub):i.Log.info("UserManager.signinSilent: no sub")),t}))):(i.Log.error("UserManager.signinSilent: No silent_redirect_uri configured"),Promise.reject(new Error("No silent_redirect_uri configured")))},e.prototype.signinSilentCallback=function t(e){return this._signinCallback(e,this._iframeNavigator).then((function(t){return t&&(t.profile&&t.profile.sub?i.Log.info("UserManager.signinSilentCallback: successful, signed in sub: ",t.profile.sub):i.Log.info("UserManager.signinSilentCallback: no sub")),t}))},e.prototype.signinCallback=function t(e){var r=this;return this.readSigninResponseState(e).then((function(t){var n=t.state;t.response;return"si:r"===n.request_type?r.signinRedirectCallback(e):"si:p"===n.request_type?r.signinPopupCallback(e):"si:s"===n.request_type?r.signinSilentCallback(e):Promise.reject(new Error("invalid response_type in state"))}))},e.prototype.signoutCallback=function t(e,r){var n=this;return this.readSignoutResponseState(e).then((function(t){var i=t.state,o=t.response;return i?"so:r"===i.request_type?n.signoutRedirectCallback(e):"so:p"===i.request_type?n.signoutPopupCallback(e,r):Promise.reject(new Error("invalid response_type in state")):o}))},e.prototype.querySessionStatus=function t(){var e=this,r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};(r=Object.assign({},r)).request_type="si:s";var n=r.redirect_uri||this.settings.silent_redirect_uri||this.settings.redirect_uri;return n?(r.redirect_uri=n,r.prompt="none",r.response_type=r.response_type||this.settings.query_status_response_type,r.scope=r.scope||"openid",r.skipUserInfo=!0,this._signinStart(r,this._iframeNavigator,{startUrl:n,silentRequestTimeout:r.silentRequestTimeout||this.settings.silentRequestTimeout}).then((function(t){return e.processSigninResponse(t.url).then((function(t){if(i.Log.debug("UserManager.querySessionStatus: got signin response"),t.session_state&&t.profile.sub)return i.Log.info("UserManager.querySessionStatus: querySessionStatus success for sub: ",t.profile.sub),{session_state:t.session_state,sub:t.profile.sub,sid:t.profile.sid};i.Log.info("querySessionStatus successful, user not authenticated")})).catch((function(t){if(t.session_state&&e.settings.monitorAnonymousSession&&("login_required"==t.message||"consent_required"==t.message||"interaction_required"==t.message||"account_selection_required"==t.message))return i.Log.info("UserManager.querySessionStatus: querySessionStatus success for anonymous user"),{session_state:t.session_state};throw t}))}))):(i.Log.error("UserManager.querySessionStatus: No silent_redirect_uri configured"),Promise.reject(new Error("No silent_redirect_uri configured")))},e.prototype._signin=function t(e,r){var n=this,i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return this._signinStart(e,r,i).then((function(t){return n._signinEnd(t.url,e)}))},e.prototype._signinStart=function t(e,r){var n=this,o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return r.prepare(o).then((function(t){return i.Log.debug("UserManager._signinStart: got navigator window handle"),n.createSigninRequest(e).then((function(e){return i.Log.debug("UserManager._signinStart: got signin request"),o.url=e.url,o.id=e.state.id,t.navigate(o)})).catch((function(e){throw t.close&&(i.Log.debug("UserManager._signinStart: Error after preparing navigator, closing navigator window"),t.close()),e}))}))},e.prototype._signinEnd=function t(e){var r=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return this.processSigninResponse(e).then((function(t){i.Log.debug("UserManager._signinEnd: got signin response");var e=new a.User(t);if(n.current_sub){if(n.current_sub!==e.profile.sub)return i.Log.debug("UserManager._signinEnd: current user does not match user returned from signin. sub from signin: ",e.profile.sub),Promise.reject(new Error("login_required"));i.Log.debug("UserManager._signinEnd: current user matches user returned from signin")}return r.storeUser(e).then((function(){return i.Log.debug("UserManager._signinEnd: user stored"),r._events.load(e),e}))}))},e.prototype._signinCallback=function t(e,r){i.Log.debug("UserManager._signinCallback");var n="query"===this._settings.response_mode||!this._settings.response_mode&&l.SigninRequest.isCode(this._settings.response_type)?"?":"#";return r.callback(e,void 0,n)},e.prototype.signoutRedirect=function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};(e=Object.assign({},e)).request_type="so:r";var r=e.post_logout_redirect_uri||this.settings.post_logout_redirect_uri;r&&(e.post_logout_redirect_uri=r);var n={useReplaceToNavigate:e.useReplaceToNavigate};return this._signoutStart(e,this._redirectNavigator,n).then((function(){i.Log.info("UserManager.signoutRedirect: successful")}))},e.prototype.signoutRedirectCallback=function t(e){return this._signoutEnd(e||this._redirectNavigator.url).then((function(t){return i.Log.info("UserManager.signoutRedirectCallback: successful"),t}))},e.prototype.signoutPopup=function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};(e=Object.assign({},e)).request_type="so:p";var r=e.post_logout_redirect_uri||this.settings.popup_post_logout_redirect_uri||this.settings.post_logout_redirect_uri;return e.post_logout_redirect_uri=r,e.display="popup",e.post_logout_redirect_uri&&(e.state=e.state||{}),this._signout(e,this._popupNavigator,{startUrl:r,popupWindowFeatures:e.popupWindowFeatures||this.settings.popupWindowFeatures,popupWindowTarget:e.popupWindowTarget||this.settings.popupWindowTarget}).then((function(){i.Log.info("UserManager.signoutPopup: successful")}))},e.prototype.signoutPopupCallback=function t(e,r){void 0===r&&"boolean"==typeof e&&(r=e,e=null);return this._popupNavigator.callback(e,r,"?").then((function(){i.Log.info("UserManager.signoutPopupCallback: successful")}))},e.prototype._signout=function t(e,r){var n=this,i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return this._signoutStart(e,r,i).then((function(t){return n._signoutEnd(t.url)}))},e.prototype._signoutStart=function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=this,n=arguments[1],o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return n.prepare(o).then((function(t){return i.Log.debug("UserManager._signoutStart: got navigator window handle"),r._loadUser().then((function(n){return i.Log.debug("UserManager._signoutStart: loaded current user from storage"),(r._settings.revokeAccessTokenOnSignout?r._revokeInternal(n):Promise.resolve()).then((function(){var s=e.id_token_hint||n&&n.id_token;return s&&(i.Log.debug("UserManager._signoutStart: Setting id_token into signout request"),e.id_token_hint=s),r.removeUser().then((function(){return i.Log.debug("UserManager._signoutStart: user removed, creating signout request"),r.createSignoutRequest(e).then((function(e){return i.Log.debug("UserManager._signoutStart: got signout request"),o.url=e.url,e.state&&(o.id=e.state.id),t.navigate(o)}))}))}))})).catch((function(e){throw t.close&&(i.Log.debug("UserManager._signoutStart: Error after preparing navigator, closing navigator window"),t.close()),e}))}))},e.prototype._signoutEnd=function t(e){return this.processSignoutResponse(e).then((function(t){return i.Log.debug("UserManager._signoutEnd: got signout response"),t}))},e.prototype.revokeAccessToken=function t(){var e=this;return this._loadUser().then((function(t){return e._revokeInternal(t,!0).then((function(r){if(r)return i.Log.debug("UserManager.revokeAccessToken: removing token properties from user and re-storing"),t.access_token=null,t.refresh_token=null,t.expires_at=null,t.token_type=null,e.storeUser(t).then((function(){i.Log.debug("UserManager.revokeAccessToken: user stored"),e._events.load(t)}))}))})).then((function(){i.Log.info("UserManager.revokeAccessToken: access token revoked successfully")}))},e.prototype._revokeInternal=function t(e,r){var n=this;if(e){var o=e.access_token,s=e.refresh_token;return this._revokeAccessTokenInternal(o,r).then((function(t){return n._revokeRefreshTokenInternal(s,r).then((function(e){return t||e||i.Log.debug("UserManager.revokeAccessToken: no need to revoke due to no token(s), or JWT format"),t||e}))}))}return Promise.resolve(!1)},e.prototype._revokeAccessTokenInternal=function t(e,r){return!e||e.indexOf(".")>=0?Promise.resolve(!1):this._tokenRevocationClient.revoke(e,r).then((function(){return!0}))},e.prototype._revokeRefreshTokenInternal=function t(e,r){return e?this._tokenRevocationClient.revoke(e,r,"refresh_token").then((function(){return!0})):Promise.resolve(!1)},e.prototype.startSilentRenew=function t(){this._silentRenewService.start()},e.prototype.stopSilentRenew=function t(){this._silentRenewService.stop()},e.prototype._loadUser=function t(){return this._userStore.get(this._userStoreKey).then((function(t){return t?(i.Log.debug("UserManager._loadUser: user storageString loaded"),a.User.fromStorageString(t)):(i.Log.debug("UserManager._loadUser: no user storageString"),null)}))},e.prototype.storeUser=function t(e){if(e){i.Log.debug("UserManager.storeUser: storing user");var r=e.toStorageString();return this._userStore.set(this._userStoreKey,r)}return i.Log.debug("storeUser.storeUser: removing user"),this._userStore.remove(this._userStoreKey)},n(e,[{key:"_redirectNavigator",get:function t(){return this.settings.redirectNavigator}},{key:"_popupNavigator",get:function t(){return this.settings.popupNavigator}},{key:"_iframeNavigator",get:function t(){return this.settings.iframeNavigator}},{key:"_userStore",get:function t(){return this.settings.userStore}},{key:"events",get:function t(){return this._events}},{key:"_userStoreKey",get:function t(){return"user:"+this.settings.authority+":"+this.settings.client_id}}]),e}(o.OidcClient)},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.UserManagerSettings=void 0;var n=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),i=(r(0),r(5)),o=r(40),s=r(41),a=r(43),u=r(6),c=r(1),h=r(8);function l(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function f(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}e.UserManagerSettings=function(t){function e(){var r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=r.popup_redirect_uri,i=r.popup_post_logout_redirect_uri,g=r.popupWindowFeatures,d=r.popupWindowTarget,p=r.silent_redirect_uri,v=r.silentRequestTimeout,y=r.automaticSilentRenew,m=void 0!==y&&y,_=r.validateSubOnSilentRenew,S=void 0!==_&&_,b=r.includeIdTokenInSilentRenew,w=void 0===b||b,F=r.monitorSession,E=void 0===F||F,x=r.monitorAnonymousSession,A=void 0!==x&&x,k=r.checkSessionInterval,P=void 0===k?2e3:k,C=r.stopCheckSessionOnError,T=void 0===C||C,R=r.query_status_response_type,I=r.revokeAccessTokenOnSignout,D=void 0!==I&&I,L=r.accessTokenExpiringNotificationTime,N=void 0===L?60:L,U=r.redirectNavigator,B=void 0===U?new o.RedirectNavigator:U,O=r.popupNavigator,j=void 0===O?new s.PopupNavigator:O,M=r.iframeNavigator,H=void 0===M?new a.IFrameNavigator:M,V=r.userStore,K=void 0===V?new u.WebStorageStateStore({store:c.Global.sessionStorage}):V;l(this,e);var q=f(this,t.call(this,arguments[0]));return q._popup_redirect_uri=n,q._popup_post_logout_redirect_uri=i,q._popupWindowFeatures=g,q._popupWindowTarget=d,q._silent_redirect_uri=p,q._silentRequestTimeout=v,q._automaticSilentRenew=m,q._validateSubOnSilentRenew=S,q._includeIdTokenInSilentRenew=w,q._accessTokenExpiringNotificationTime=N,q._monitorSession=E,q._monitorAnonymousSession=A,q._checkSessionInterval=P,q._stopCheckSessionOnError=T,R?q._query_status_response_type=R:arguments[0]&&arguments[0].response_type?q._query_status_response_type=h.SigninRequest.isOidc(arguments[0].response_type)?"id_token":"code":q._query_status_response_type="id_token",q._revokeAccessTokenOnSignout=D,q._redirectNavigator=B,q._popupNavigator=j,q._iframeNavigator=H,q._userStore=K,q}return function r(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),n(e,[{key:"popup_redirect_uri",get:function t(){return this._popup_redirect_uri}},{key:"popup_post_logout_redirect_uri",get:function t(){return this._popup_post_logout_redirect_uri}},{key:"popupWindowFeatures",get:function t(){return this._popupWindowFeatures}},{key:"popupWindowTarget",get:function t(){return this._popupWindowTarget}},{key:"silent_redirect_uri",get:function t(){return this._silent_redirect_uri}},{key:"silentRequestTimeout",get:function t(){return this._silentRequestTimeout}},{key:"automaticSilentRenew",get:function t(){return this._automaticSilentRenew}},{key:"validateSubOnSilentRenew",get:function t(){return this._validateSubOnSilentRenew}},{key:"includeIdTokenInSilentRenew",get:function t(){return this._includeIdTokenInSilentRenew}},{key:"accessTokenExpiringNotificationTime",get:function t(){return this._accessTokenExpiringNotificationTime}},{key:"monitorSession",get:function t(){return this._monitorSession}},{key:"monitorAnonymousSession",get:function t(){return this._monitorAnonymousSession}},{key:"checkSessionInterval",get:function t(){return this._checkSessionInterval}},{key:"stopCheckSessionOnError",get:function t(){return this._stopCheckSessionOnError}},{key:"query_status_response_type",get:function t(){return this._query_status_response_type}},{key:"revokeAccessTokenOnSignout",get:function t(){return this._revokeAccessTokenOnSignout}},{key:"redirectNavigator",get:function t(){return this._redirectNavigator}},{key:"popupNavigator",get:function t(){return this._popupNavigator}},{key:"iframeNavigator",get:function t(){return this._iframeNavigator}},{key:"userStore",get:function t(){return this._userStore}}]),e}(i.OidcClientSettings)},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.RedirectNavigator=void 0;var n=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),i=r(0);e.RedirectNavigator=function(){function t(){!function e(t,r){if(!(t instanceof r))throw new TypeError("Cannot call a class as a function")}(this,t)}return t.prototype.prepare=function t(){return Promise.resolve(this)},t.prototype.navigate=function t(e){return e&&e.url?(e.useReplaceToNavigate?window.location.replace(e.url):window.location=e.url,Promise.resolve()):(i.Log.error("RedirectNavigator.navigate: No url provided"),Promise.reject(new Error("No url provided")))},n(t,[{key:"url",get:function t(){return window.location.href}}]),t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.PopupNavigator=void 0;var n=r(0),i=r(42);e.PopupNavigator=function(){function t(){!function e(t,r){if(!(t instanceof r))throw new TypeError("Cannot call a class as a function")}(this,t)}return t.prototype.prepare=function t(e){var r=new i.PopupWindow(e);return Promise.resolve(r)},t.prototype.callback=function t(e,r,o){n.Log.debug("PopupNavigator.callback");try{return i.PopupWindow.notifyOpener(e,r,o),Promise.resolve()}catch(t){return Promise.reject(t)}},t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.PopupWindow=void 0;var n=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),i=r(0),o=r(3);e.PopupWindow=function(){function t(e){var r=this;!function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this._promise=new Promise((function(t,e){r._resolve=t,r._reject=e}));var o=e.popupWindowTarget||"_blank",s=e.popupWindowFeatures||"location=no,toolbar=no,width=500,height=500,left=100,top=100;";this._popup=window.open("",o,s),this._popup&&(i.Log.debug("PopupWindow.ctor: popup successfully created"),this._checkForPopupClosedTimer=window.setInterval(this._checkForPopupClosed.bind(this),500))}return t.prototype.navigate=function t(e){return this._popup?e&&e.url?(i.Log.debug("PopupWindow.navigate: Setting URL in popup"),this._id=e.id,this._id&&(window["popupCallback_"+e.id]=this._callback.bind(this)),this._popup.focus(),this._popup.window.location=e.url):(this._error("PopupWindow.navigate: no url provided"),this._error("No url provided")):this._error("PopupWindow.navigate: Error opening popup window"),this.promise},t.prototype._success=function t(e){i.Log.debug("PopupWindow.callback: Successful response from popup window"),this._cleanup(),this._resolve(e)},t.prototype._error=function t(e){i.Log.error("PopupWindow.error: ",e),this._cleanup(),this._reject(new Error(e))},t.prototype.close=function t(){this._cleanup(!1)},t.prototype._cleanup=function t(e){i.Log.debug("PopupWindow.cleanup"),window.clearInterval(this._checkForPopupClosedTimer),this._checkForPopupClosedTimer=null,delete window["popupCallback_"+this._id],this._popup&&!e&&this._popup.close(),this._popup=null},t.prototype._checkForPopupClosed=function t(){this._popup&&!this._popup.closed||this._error("Popup window closed")},t.prototype._callback=function t(e,r){this._cleanup(r),e?(i.Log.debug("PopupWindow.callback success"),this._success({url:e})):(i.Log.debug("PopupWindow.callback: Invalid response from popup"),this._error("Invalid response from popup"))},t.notifyOpener=function t(e,r,n){if(window.opener){if(e=e||window.location.href){var s=o.UrlUtility.parseUrlFragment(e,n);if(s.state){var a="popupCallback_"+s.state,u=window.opener[a];u?(i.Log.debug("PopupWindow.notifyOpener: passing url message to opener"),u(e,r)):i.Log.warn("PopupWindow.notifyOpener: no matching callback found on opener")}else i.Log.warn("PopupWindow.notifyOpener: no state found in response url")}}else i.Log.warn("PopupWindow.notifyOpener: no window.opener. Can't complete notification.")},n(t,[{key:"promise",get:function t(){return this._promise}}]),t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.IFrameNavigator=void 0;var n=r(0),i=r(44);e.IFrameNavigator=function(){function t(){!function e(t,r){if(!(t instanceof r))throw new TypeError("Cannot call a class as a function")}(this,t)}return t.prototype.prepare=function t(e){var r=new i.IFrameWindow(e);return Promise.resolve(r)},t.prototype.callback=function t(e){n.Log.debug("IFrameNavigator.callback");try{return i.IFrameWindow.notifyParent(e),Promise.resolve()}catch(t){return Promise.reject(t)}},t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.IFrameWindow=void 0;var n=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),i=r(0);e.IFrameWindow=function(){function t(e){var r=this;!function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this._promise=new Promise((function(t,e){r._resolve=t,r._reject=e})),this._boundMessageEvent=this._message.bind(this),window.addEventListener("message",this._boundMessageEvent,!1),this._frame=window.document.createElement("iframe"),this._frame.style.visibility="hidden",this._frame.style.position="absolute",this._frame.width=0,this._frame.height=0,window.document.body.appendChild(this._frame)}return t.prototype.navigate=function t(e){if(e&&e.url){var r=e.silentRequestTimeout||1e4;i.Log.debug("IFrameWindow.navigate: Using timeout of:",r),this._timer=window.setTimeout(this._timeout.bind(this),r),this._frame.src=e.url}else this._error("No url provided");return this.promise},t.prototype._success=function t(e){this._cleanup(),i.Log.debug("IFrameWindow: Successful response from frame window"),this._resolve(e)},t.prototype._error=function t(e){this._cleanup(),i.Log.error(e),this._reject(new Error(e))},t.prototype.close=function t(){this._cleanup()},t.prototype._cleanup=function t(){this._frame&&(i.Log.debug("IFrameWindow: cleanup"),window.removeEventListener("message",this._boundMessageEvent,!1),window.clearTimeout(this._timer),window.document.body.removeChild(this._frame),this._timer=null,this._frame=null,this._boundMessageEvent=null)},t.prototype._timeout=function t(){i.Log.debug("IFrameWindow.timeout"),this._error("Frame window timed out")},t.prototype._message=function t(e){if(i.Log.debug("IFrameWindow.message"),this._timer&&e.origin===this._origin&&e.source===this._frame.contentWindow&&"string"==typeof e.data&&(e.data.startsWith("http://")||e.data.startsWith("https://"))){var r=e.data;r?this._success({url:r}):this._error("Invalid response from frame")}},t.notifyParent=function t(e){i.Log.debug("IFrameWindow.notifyParent"),(e=e||window.location.href)&&(i.Log.debug("IFrameWindow.notifyParent: posting url message to parent"),window.parent.postMessage(e,location.protocol+"//"+location.host))},n(t,[{key:"promise",get:function t(){return this._promise}},{key:"_origin",get:function t(){return location.protocol+"//"+location.host}}]),t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.UserManagerEvents=void 0;var n=r(0),i=r(16),o=r(17);e.UserManagerEvents=function(t){function e(r){!function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e);var i=function s(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}(this,t.call(this,r));return i._userLoaded=new o.Event("User loaded"),i._userUnloaded=new o.Event("User unloaded"),i._silentRenewError=new o.Event("Silent renew error"),i._userSignedIn=new o.Event("User signed in"),i._userSignedOut=new o.Event("User signed out"),i._userSessionChanged=new o.Event("User session changed"),i}return function r(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),e.prototype.load=function e(r){var i=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];n.Log.debug("UserManagerEvents.load"),t.prototype.load.call(this,r),i&&this._userLoaded.raise(r)},e.prototype.unload=function e(){n.Log.debug("UserManagerEvents.unload"),t.prototype.unload.call(this),this._userUnloaded.raise()},e.prototype.addUserLoaded=function t(e){this._userLoaded.addHandler(e)},e.prototype.removeUserLoaded=function t(e){this._userLoaded.removeHandler(e)},e.prototype.addUserUnloaded=function t(e){this._userUnloaded.addHandler(e)},e.prototype.removeUserUnloaded=function t(e){this._userUnloaded.removeHandler(e)},e.prototype.addSilentRenewError=function t(e){this._silentRenewError.addHandler(e)},e.prototype.removeSilentRenewError=function t(e){this._silentRenewError.removeHandler(e)},e.prototype._raiseSilentRenewError=function t(e){n.Log.debug("UserManagerEvents._raiseSilentRenewError",e.message),this._silentRenewError.raise(e)},e.prototype.addUserSignedIn=function t(e){this._userSignedIn.addHandler(e)},e.prototype.removeUserSignedIn=function t(e){this._userSignedIn.removeHandler(e)},e.prototype._raiseUserSignedIn=function t(){n.Log.debug("UserManagerEvents._raiseUserSignedIn"),this._userSignedIn.raise()},e.prototype.addUserSignedOut=function t(e){this._userSignedOut.addHandler(e)},e.prototype.removeUserSignedOut=function t(e){this._userSignedOut.removeHandler(e)},e.prototype._raiseUserSignedOut=function t(){n.Log.debug("UserManagerEvents._raiseUserSignedOut"),this._userSignedOut.raise()},e.prototype.addUserSessionChanged=function t(e){this._userSessionChanged.addHandler(e)},e.prototype.removeUserSessionChanged=function t(e){this._userSessionChanged.removeHandler(e)},e.prototype._raiseUserSessionChanged=function t(){n.Log.debug("UserManagerEvents._raiseUserSessionChanged"),this._userSessionChanged.raise()},e}(i.AccessTokenEvents)},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.Timer=void 0;var n=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),i=r(0),o=r(1),s=r(17);function a(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function u(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}e.Timer=function(t){function e(r){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:o.Global.timer,i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:void 0;a(this,e);var s=u(this,t.call(this,r));return s._timer=n,s._nowFunc=i||function(){return Date.now()/1e3},s}return function r(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,t),e.prototype.init=function t(e){e<=0&&(e=1),e=parseInt(e);var r=this.now+e;if(this.expiration===r&&this._timerHandle)i.Log.debug("Timer.init timer "+this._name+" skipping initialization since already initialized for expiration:",this.expiration);else{this.cancel(),i.Log.debug("Timer.init timer "+this._name+" for duration:",e),this._expiration=r;var n=5;e<n&&(n=e),this._timerHandle=this._timer.setInterval(this._callback.bind(this),1e3*n)}},e.prototype.cancel=function t(){this._timerHandle&&(i.Log.debug("Timer.cancel: ",this._name),this._timer.clearInterval(this._timerHandle),this._timerHandle=null)},e.prototype._callback=function e(){var r=this._expiration-this.now;i.Log.debug("Timer.callback; "+this._name+" timer expires in:",r),this._expiration<=this.now&&(this.cancel(),t.prototype.raise.call(this))},n(e,[{key:"now",get:function t(){return parseInt(this._nowFunc())}},{key:"expiration",get:function t(){return this._expiration}}]),e}(s.Event)},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.SilentRenewService=void 0;var n=r(0);e.SilentRenewService=function(){function t(e){!function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this._userManager=e}return t.prototype.start=function t(){this._callback||(this._callback=this._tokenExpiring.bind(this),this._userManager.events.addAccessTokenExpiring(this._callback),this._userManager.getUser().then((function(t){})).catch((function(t){n.Log.error("SilentRenewService.start: Error from getUser:",t.message)})))},t.prototype.stop=function t(){this._callback&&(this._userManager.events.removeAccessTokenExpiring(this._callback),delete this._callback)},t.prototype._tokenExpiring=function t(){var e=this;this._userManager.signinSilent().then((function(t){n.Log.debug("SilentRenewService._tokenExpiring: Silent token renewal successful")}),(function(t){n.Log.error("SilentRenewService._tokenExpiring: Error from signinSilent:",t.message),e._userManager.events._raiseSilentRenewError(t)}))},t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.CordovaPopupNavigator=void 0;var n=r(21);e.CordovaPopupNavigator=function(){function t(){!function e(t,r){if(!(t instanceof r))throw new TypeError("Cannot call a class as a function")}(this,t)}return t.prototype.prepare=function t(e){var r=new n.CordovaPopupWindow(e);return Promise.resolve(r)},t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.CordovaIFrameNavigator=void 0;var n=r(21);e.CordovaIFrameNavigator=function(){function t(){!function e(t,r){if(!(t instanceof r))throw new TypeError("Cannot call a class as a function")}(this,t)}return t.prototype.prepare=function t(e){e.popupWindowFeatures="hidden=yes";var r=new n.CordovaPopupWindow(e);return Promise.resolve(r)},t}()},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0});e.Version="1.11.5"}])}));

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DefaultHttpClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Errors__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FetchHttpClient__ = __webpack_require__(1661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HttpClient__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utils__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__XhrHttpClient__ = __webpack_require__(1662);
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





/** Default implementation of {@link @microsoft/signalr.HttpClient}. */
var DefaultHttpClient = /** @class */ (function (_super) {
    __extends(DefaultHttpClient, _super);
    /** Creates a new instance of the {@link @microsoft/signalr.DefaultHttpClient}, using the provided {@link @microsoft/signalr.ILogger} to log messages. */
    function DefaultHttpClient(logger) {
        var _this = _super.call(this) || this;
        if (typeof fetch !== "undefined" || __WEBPACK_IMPORTED_MODULE_3__Utils__["c" /* Platform */].isNode) {
            _this.httpClient = new __WEBPACK_IMPORTED_MODULE_1__FetchHttpClient__["a" /* FetchHttpClient */](logger);
        }
        else if (typeof XMLHttpRequest !== "undefined") {
            _this.httpClient = new __WEBPACK_IMPORTED_MODULE_4__XhrHttpClient__["a" /* XhrHttpClient */](logger);
        }
        else {
            throw new Error("No usable HttpClient found.");
        }
        return _this;
    }
    /** @inheritDoc */
    DefaultHttpClient.prototype.send = function (request) {
        // Check that abort was not signaled before calling send
        if (request.abortSignal && request.abortSignal.aborted) {
            return Promise.reject(new __WEBPACK_IMPORTED_MODULE_0__Errors__["a" /* AbortError */]());
        }
        if (!request.method) {
            return Promise.reject(new Error("No method defined."));
        }
        if (!request.url) {
            return Promise.reject(new Error("No url defined."));
        }
        return this.httpClient.send(request);
    };
    DefaultHttpClient.prototype.getCookieString = function (url) {
        return this.httpClient.getCookieString(url);
    };
    return DefaultHttpClient;
}(__WEBPACK_IMPORTED_MODULE_2__HttpClient__["a" /* HttpClient */]));

//# sourceMappingURL=DefaultHttpClient.js.map

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HubConnectionState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HubConnection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HandshakeProtocol__ = __webpack_require__(1663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__IHubProtocol__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ILogger__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Subject__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utils__ = __webpack_require__(88);
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};





var DEFAULT_TIMEOUT_IN_MS = 30 * 1000;
var DEFAULT_PING_INTERVAL_IN_MS = 15 * 1000;
/** Describes the current state of the {@link HubConnection} to the server. */
var HubConnectionState;
(function (HubConnectionState) {
    /** The hub connection is disconnected. */
    HubConnectionState["Disconnected"] = "Disconnected";
    /** The hub connection is connecting. */
    HubConnectionState["Connecting"] = "Connecting";
    /** The hub connection is connected. */
    HubConnectionState["Connected"] = "Connected";
    /** The hub connection is disconnecting. */
    HubConnectionState["Disconnecting"] = "Disconnecting";
    /** The hub connection is reconnecting. */
    HubConnectionState["Reconnecting"] = "Reconnecting";
})(HubConnectionState || (HubConnectionState = {}));
/** Represents a connection to a SignalR Hub. */
var HubConnection = /** @class */ (function () {
    function HubConnection(connection, logger, protocol, reconnectPolicy) {
        var _this = this;
        this.nextKeepAlive = 0;
        __WEBPACK_IMPORTED_MODULE_4__Utils__["a" /* Arg */].isRequired(connection, "connection");
        __WEBPACK_IMPORTED_MODULE_4__Utils__["a" /* Arg */].isRequired(logger, "logger");
        __WEBPACK_IMPORTED_MODULE_4__Utils__["a" /* Arg */].isRequired(protocol, "protocol");
        this.serverTimeoutInMilliseconds = DEFAULT_TIMEOUT_IN_MS;
        this.keepAliveIntervalInMilliseconds = DEFAULT_PING_INTERVAL_IN_MS;
        this.logger = logger;
        this.protocol = protocol;
        this.connection = connection;
        this.reconnectPolicy = reconnectPolicy;
        this.handshakeProtocol = new __WEBPACK_IMPORTED_MODULE_0__HandshakeProtocol__["a" /* HandshakeProtocol */]();
        this.connection.onreceive = function (data) { return _this.processIncomingData(data); };
        this.connection.onclose = function (error) { return _this.connectionClosed(error); };
        this.callbacks = {};
        this.methods = {};
        this.closedCallbacks = [];
        this.reconnectingCallbacks = [];
        this.reconnectedCallbacks = [];
        this.invocationId = 0;
        this.receivedHandshakeResponse = false;
        this.connectionState = HubConnectionState.Disconnected;
        this.connectionStarted = false;
        this.cachedPingMessage = this.protocol.writeMessage({ type: __WEBPACK_IMPORTED_MODULE_1__IHubProtocol__["a" /* MessageType */].Ping });
    }
    /** @internal */
    // Using a public static factory method means we can have a private constructor and an _internal_
    // create method that can be used by HubConnectionBuilder. An "internal" constructor would just
    // be stripped away and the '.d.ts' file would have no constructor, which is interpreted as a
    // public parameter-less constructor.
    HubConnection.create = function (connection, logger, protocol, reconnectPolicy) {
        return new HubConnection(connection, logger, protocol, reconnectPolicy);
    };
    Object.defineProperty(HubConnection.prototype, "state", {
        /** Indicates the state of the {@link HubConnection} to the server. */
        get: function () {
            return this.connectionState;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HubConnection.prototype, "connectionId", {
        /** Represents the connection id of the {@link HubConnection} on the server. The connection id will be null when the connection is either
         *  in the disconnected state or if the negotiation step was skipped.
         */
        get: function () {
            return this.connection ? (this.connection.connectionId || null) : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HubConnection.prototype, "baseUrl", {
        /** Indicates the url of the {@link HubConnection} to the server. */
        get: function () {
            return this.connection.baseUrl || "";
        },
        /**
         * Sets a new url for the HubConnection. Note that the url can only be changed when the connection is in either the Disconnected or
         * Reconnecting states.
         * @param {string} url The url to connect to.
         */
        set: function (url) {
            if (this.connectionState !== HubConnectionState.Disconnected && this.connectionState !== HubConnectionState.Reconnecting) {
                throw new Error("The HubConnection must be in the Disconnected or Reconnecting state to change the url.");
            }
            if (!url) {
                throw new Error("The HubConnection url must be a valid url.");
            }
            this.connection.baseUrl = url;
        },
        enumerable: true,
        configurable: true
    });
    /** Starts the connection.
     *
     * @returns {Promise<void>} A Promise that resolves when the connection has been successfully established, or rejects with an error.
     */
    HubConnection.prototype.start = function () {
        this.startPromise = this.startWithStateTransitions();
        return this.startPromise;
    };
    HubConnection.prototype.startWithStateTransitions = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.connectionState !== HubConnectionState.Disconnected) {
                            return [2 /*return*/, Promise.reject(new Error("Cannot start a HubConnection that is not in the 'Disconnected' state."))];
                        }
                        this.connectionState = HubConnectionState.Connecting;
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Debug, "Starting HubConnection.");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.startInternal()];
                    case 2:
                        _a.sent();
                        this.connectionState = HubConnectionState.Connected;
                        this.connectionStarted = true;
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Debug, "HubConnection connected successfully.");
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this.connectionState = HubConnectionState.Disconnected;
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Debug, "HubConnection failed to start successfully because of error '" + e_1 + "'.");
                        return [2 /*return*/, Promise.reject(e_1)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    HubConnection.prototype.startInternal = function () {
        return __awaiter(this, void 0, void 0, function () {
            var handshakePromise, handshakeRequest, e_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.stopDuringStartError = undefined;
                        this.receivedHandshakeResponse = false;
                        handshakePromise = new Promise(function (resolve, reject) {
                            _this.handshakeResolver = resolve;
                            _this.handshakeRejecter = reject;
                        });
                        return [4 /*yield*/, this.connection.start(this.protocol.transferFormat)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 5, , 7]);
                        handshakeRequest = {
                            protocol: this.protocol.name,
                            version: this.protocol.version,
                        };
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Debug, "Sending handshake request.");
                        return [4 /*yield*/, this.sendMessage(this.handshakeProtocol.writeHandshakeRequest(handshakeRequest))];
                    case 3:
                        _a.sent();
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Information, "Using HubProtocol '" + this.protocol.name + "'.");
                        // defensively cleanup timeout in case we receive a message from the server before we finish start
                        this.cleanupTimeout();
                        this.resetTimeoutPeriod();
                        this.resetKeepAliveInterval();
                        return [4 /*yield*/, handshakePromise];
                    case 4:
                        _a.sent();
                        // It's important to check the stopDuringStartError instead of just relying on the handshakePromise
                        // being rejected on close, because this continuation can run after both the handshake completed successfully
                        // and the connection was closed.
                        if (this.stopDuringStartError) {
                            // It's important to throw instead of returning a rejected promise, because we don't want to allow any state
                            // transitions to occur between now and the calling code observing the exceptions. Returning a rejected promise
                            // will cause the calling continuation to get scheduled to run later.
                            throw this.stopDuringStartError;
                        }
                        return [3 /*break*/, 7];
                    case 5:
                        e_2 = _a.sent();
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Debug, "Hub handshake failed with error '" + e_2 + "' during start(). Stopping HubConnection.");
                        this.cleanupTimeout();
                        this.cleanupPingTimer();
                        // HttpConnection.stop() should not complete until after the onclose callback is invoked.
                        // This will transition the HubConnection to the disconnected state before HttpConnection.stop() completes.
                        return [4 /*yield*/, this.connection.stop(e_2)];
                    case 6:
                        // HttpConnection.stop() should not complete until after the onclose callback is invoked.
                        // This will transition the HubConnection to the disconnected state before HttpConnection.stop() completes.
                        _a.sent();
                        throw e_2;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /** Stops the connection.
     *
     * @returns {Promise<void>} A Promise that resolves when the connection has been successfully terminated, or rejects with an error.
     */
    HubConnection.prototype.stop = function () {
        return __awaiter(this, void 0, void 0, function () {
            var startPromise, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        startPromise = this.startPromise;
                        this.stopPromise = this.stopInternal();
                        return [4 /*yield*/, this.stopPromise];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        // Awaiting undefined continues immediately
                        return [4 /*yield*/, startPromise];
                    case 3:
                        // Awaiting undefined continues immediately
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        e_3 = _a.sent();
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    HubConnection.prototype.stopInternal = function (error) {
        if (this.connectionState === HubConnectionState.Disconnected) {
            this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Debug, "Call to HubConnection.stop(" + error + ") ignored because it is already in the disconnected state.");
            return Promise.resolve();
        }
        if (this.connectionState === HubConnectionState.Disconnecting) {
            this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Debug, "Call to HttpConnection.stop(" + error + ") ignored because the connection is already in the disconnecting state.");
            return this.stopPromise;
        }
        this.connectionState = HubConnectionState.Disconnecting;
        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Debug, "Stopping HubConnection.");
        if (this.reconnectDelayHandle) {
            // We're in a reconnect delay which means the underlying connection is currently already stopped.
            // Just clear the handle to stop the reconnect loop (which no one is waiting on thankfully) and
            // fire the onclose callbacks.
            this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Debug, "Connection stopped during reconnect delay. Done reconnecting.");
            clearTimeout(this.reconnectDelayHandle);
            this.reconnectDelayHandle = undefined;
            this.completeClose();
            return Promise.resolve();
        }
        this.cleanupTimeout();
        this.cleanupPingTimer();
        this.stopDuringStartError = error || new Error("The connection was stopped before the hub handshake could complete.");
        // HttpConnection.stop() should not complete until after either HttpConnection.start() fails
        // or the onclose callback is invoked. The onclose callback will transition the HubConnection
        // to the disconnected state if need be before HttpConnection.stop() completes.
        return this.connection.stop(error);
    };
    /** Invokes a streaming hub method on the server using the specified name and arguments.
     *
     * @typeparam T The type of the items returned by the server.
     * @param {string} methodName The name of the server method to invoke.
     * @param {any[]} args The arguments used to invoke the server method.
     * @returns {IStreamResult<T>} An object that yields results from the server as they are received.
     */
    HubConnection.prototype.stream = function (methodName) {
        var _this = this;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var _a = this.replaceStreamingParams(args), streams = _a[0], streamIds = _a[1];
        var invocationDescriptor = this.createStreamInvocation(methodName, args, streamIds);
        var promiseQueue;
        var subject = new __WEBPACK_IMPORTED_MODULE_3__Subject__["a" /* Subject */]();
        subject.cancelCallback = function () {
            var cancelInvocation = _this.createCancelInvocation(invocationDescriptor.invocationId);
            delete _this.callbacks[invocationDescriptor.invocationId];
            return promiseQueue.then(function () {
                return _this.sendWithProtocol(cancelInvocation);
            });
        };
        this.callbacks[invocationDescriptor.invocationId] = function (invocationEvent, error) {
            if (error) {
                subject.error(error);
                return;
            }
            else if (invocationEvent) {
                // invocationEvent will not be null when an error is not passed to the callback
                if (invocationEvent.type === __WEBPACK_IMPORTED_MODULE_1__IHubProtocol__["a" /* MessageType */].Completion) {
                    if (invocationEvent.error) {
                        subject.error(new Error(invocationEvent.error));
                    }
                    else {
                        subject.complete();
                    }
                }
                else {
                    subject.next((invocationEvent.item));
                }
            }
        };
        promiseQueue = this.sendWithProtocol(invocationDescriptor)
            .catch(function (e) {
            subject.error(e);
            delete _this.callbacks[invocationDescriptor.invocationId];
        });
        this.launchStreams(streams, promiseQueue);
        return subject;
    };
    HubConnection.prototype.sendMessage = function (message) {
        this.resetKeepAliveInterval();
        return this.connection.send(message);
    };
    /**
     * Sends a js object to the server.
     * @param message The js object to serialize and send.
     */
    HubConnection.prototype.sendWithProtocol = function (message) {
        return this.sendMessage(this.protocol.writeMessage(message));
    };
    /** Invokes a hub method on the server using the specified name and arguments. Does not wait for a response from the receiver.
     *
     * The Promise returned by this method resolves when the client has sent the invocation to the server. The server may still
     * be processing the invocation.
     *
     * @param {string} methodName The name of the server method to invoke.
     * @param {any[]} args The arguments used to invoke the server method.
     * @returns {Promise<void>} A Promise that resolves when the invocation has been successfully sent, or rejects with an error.
     */
    HubConnection.prototype.send = function (methodName) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var _a = this.replaceStreamingParams(args), streams = _a[0], streamIds = _a[1];
        var sendPromise = this.sendWithProtocol(this.createInvocation(methodName, args, true, streamIds));
        this.launchStreams(streams, sendPromise);
        return sendPromise;
    };
    /** Invokes a hub method on the server using the specified name and arguments.
     *
     * The Promise returned by this method resolves when the server indicates it has finished invoking the method. When the promise
     * resolves, the server has finished invoking the method. If the server method returns a result, it is produced as the result of
     * resolving the Promise.
     *
     * @typeparam T The expected return type.
     * @param {string} methodName The name of the server method to invoke.
     * @param {any[]} args The arguments used to invoke the server method.
     * @returns {Promise<T>} A Promise that resolves with the result of the server method (if any), or rejects with an error.
     */
    HubConnection.prototype.invoke = function (methodName) {
        var _this = this;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var _a = this.replaceStreamingParams(args), streams = _a[0], streamIds = _a[1];
        var invocationDescriptor = this.createInvocation(methodName, args, false, streamIds);
        var p = new Promise(function (resolve, reject) {
            // invocationId will always have a value for a non-blocking invocation
            _this.callbacks[invocationDescriptor.invocationId] = function (invocationEvent, error) {
                if (error) {
                    reject(error);
                    return;
                }
                else if (invocationEvent) {
                    // invocationEvent will not be null when an error is not passed to the callback
                    if (invocationEvent.type === __WEBPACK_IMPORTED_MODULE_1__IHubProtocol__["a" /* MessageType */].Completion) {
                        if (invocationEvent.error) {
                            reject(new Error(invocationEvent.error));
                        }
                        else {
                            resolve(invocationEvent.result);
                        }
                    }
                    else {
                        reject(new Error("Unexpected message type: " + invocationEvent.type));
                    }
                }
            };
            var promiseQueue = _this.sendWithProtocol(invocationDescriptor)
                .catch(function (e) {
                reject(e);
                // invocationId will always have a value for a non-blocking invocation
                delete _this.callbacks[invocationDescriptor.invocationId];
            });
            _this.launchStreams(streams, promiseQueue);
        });
        return p;
    };
    /** Registers a handler that will be invoked when the hub method with the specified method name is invoked.
     *
     * @param {string} methodName The name of the hub method to define.
     * @param {Function} newMethod The handler that will be raised when the hub method is invoked.
     */
    HubConnection.prototype.on = function (methodName, newMethod) {
        if (!methodName || !newMethod) {
            return;
        }
        methodName = methodName.toLowerCase();
        if (!this.methods[methodName]) {
            this.methods[methodName] = [];
        }
        // Preventing adding the same handler multiple times.
        if (this.methods[methodName].indexOf(newMethod) !== -1) {
            return;
        }
        this.methods[methodName].push(newMethod);
    };
    HubConnection.prototype.off = function (methodName, method) {
        if (!methodName) {
            return;
        }
        methodName = methodName.toLowerCase();
        var handlers = this.methods[methodName];
        if (!handlers) {
            return;
        }
        if (method) {
            var removeIdx = handlers.indexOf(method);
            if (removeIdx !== -1) {
                handlers.splice(removeIdx, 1);
                if (handlers.length === 0) {
                    delete this.methods[methodName];
                }
            }
        }
        else {
            delete this.methods[methodName];
        }
    };
    /** Registers a handler that will be invoked when the connection is closed.
     *
     * @param {Function} callback The handler that will be invoked when the connection is closed. Optionally receives a single argument containing the error that caused the connection to close (if any).
     */
    HubConnection.prototype.onclose = function (callback) {
        if (callback) {
            this.closedCallbacks.push(callback);
        }
    };
    /** Registers a handler that will be invoked when the connection starts reconnecting.
     *
     * @param {Function} callback The handler that will be invoked when the connection starts reconnecting. Optionally receives a single argument containing the error that caused the connection to start reconnecting (if any).
     */
    HubConnection.prototype.onreconnecting = function (callback) {
        if (callback) {
            this.reconnectingCallbacks.push(callback);
        }
    };
    /** Registers a handler that will be invoked when the connection successfully reconnects.
     *
     * @param {Function} callback The handler that will be invoked when the connection successfully reconnects.
     */
    HubConnection.prototype.onreconnected = function (callback) {
        if (callback) {
            this.reconnectedCallbacks.push(callback);
        }
    };
    HubConnection.prototype.processIncomingData = function (data) {
        this.cleanupTimeout();
        if (!this.receivedHandshakeResponse) {
            data = this.processHandshakeResponse(data);
            this.receivedHandshakeResponse = true;
        }
        // Data may have all been read when processing handshake response
        if (data) {
            // Parse the messages
            var messages = this.protocol.parseMessages(data, this.logger);
            for (var _i = 0, messages_1 = messages; _i < messages_1.length; _i++) {
                var message = messages_1[_i];
                switch (message.type) {
                    case __WEBPACK_IMPORTED_MODULE_1__IHubProtocol__["a" /* MessageType */].Invocation:
                        this.invokeClientMethod(message);
                        break;
                    case __WEBPACK_IMPORTED_MODULE_1__IHubProtocol__["a" /* MessageType */].StreamItem:
                    case __WEBPACK_IMPORTED_MODULE_1__IHubProtocol__["a" /* MessageType */].Completion:
                        var callback = this.callbacks[message.invocationId];
                        if (callback) {
                            if (message.type === __WEBPACK_IMPORTED_MODULE_1__IHubProtocol__["a" /* MessageType */].Completion) {
                                delete this.callbacks[message.invocationId];
                            }
                            callback(message);
                        }
                        break;
                    case __WEBPACK_IMPORTED_MODULE_1__IHubProtocol__["a" /* MessageType */].Ping:
                        // Don't care about pings
                        break;
                    case __WEBPACK_IMPORTED_MODULE_1__IHubProtocol__["a" /* MessageType */].Close:
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Information, "Close message received from server.");
                        var error = message.error ? new Error("Server returned an error on close: " + message.error) : undefined;
                        if (message.allowReconnect === true) {
                            // It feels wrong not to await connection.stop() here, but processIncomingData is called as part of an onreceive callback which is not async,
                            // this is already the behavior for serverTimeout(), and HttpConnection.Stop() should catch and log all possible exceptions.
                            // tslint:disable-next-line:no-floating-promises
                            this.connection.stop(error);
                        }
                        else {
                            // We cannot await stopInternal() here, but subsequent calls to stop() will await this if stopInternal() is still ongoing.
                            this.stopPromise = this.stopInternal(error);
                        }
                        break;
                    default:
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Warning, "Invalid message type: " + message.type + ".");
                        break;
                }
            }
        }
        this.resetTimeoutPeriod();
    };
    HubConnection.prototype.processHandshakeResponse = function (data) {
        var _a;
        var responseMessage;
        var remainingData;
        try {
            _a = this.handshakeProtocol.parseHandshakeResponse(data), remainingData = _a[0], responseMessage = _a[1];
        }
        catch (e) {
            var message = "Error parsing handshake response: " + e;
            this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Error, message);
            var error = new Error(message);
            this.handshakeRejecter(error);
            throw error;
        }
        if (responseMessage.error) {
            var message = "Server returned handshake error: " + responseMessage.error;
            this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Error, message);
            var error = new Error(message);
            this.handshakeRejecter(error);
            throw error;
        }
        else {
            this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Debug, "Server handshake complete.");
        }
        this.handshakeResolver();
        return remainingData;
    };
    HubConnection.prototype.resetKeepAliveInterval = function () {
        if (this.connection.features.inherentKeepAlive) {
            return;
        }
        // Set the time we want the next keep alive to be sent
        // Timer will be setup on next message receive
        this.nextKeepAlive = new Date().getTime() + this.keepAliveIntervalInMilliseconds;
        this.cleanupPingTimer();
    };
    HubConnection.prototype.resetTimeoutPeriod = function () {
        var _this = this;
        if (!this.connection.features || !this.connection.features.inherentKeepAlive) {
            // Set the timeout timer
            this.timeoutHandle = setTimeout(function () { return _this.serverTimeout(); }, this.serverTimeoutInMilliseconds);
            // Set keepAlive timer if there isn't one
            if (this.pingServerHandle === undefined) {
                var nextPing = this.nextKeepAlive - new Date().getTime();
                if (nextPing < 0) {
                    nextPing = 0;
                }
                // The timer needs to be set from a networking callback to avoid Chrome timer throttling from causing timers to run once a minute
                this.pingServerHandle = setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                if (!(this.connectionState === HubConnectionState.Connected)) return [3 /*break*/, 4];
                                _b.label = 1;
                            case 1:
                                _b.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, this.sendMessage(this.cachedPingMessage)];
                            case 2:
                                _b.sent();
                                return [3 /*break*/, 4];
                            case 3:
                                _a = _b.sent();
                                // We don't care about the error. It should be seen elsewhere in the client.
                                // The connection is probably in a bad or closed state now, cleanup the timer so it stops triggering
                                this.cleanupPingTimer();
                                return [3 /*break*/, 4];
                            case 4: return [2 /*return*/];
                        }
                    });
                }); }, nextPing);
            }
        }
    };
    HubConnection.prototype.serverTimeout = function () {
        // The server hasn't talked to us in a while. It doesn't like us anymore ... :(
        // Terminate the connection, but we don't need to wait on the promise. This could trigger reconnecting.
        // tslint:disable-next-line:no-floating-promises
        this.connection.stop(new Error("Server timeout elapsed without receiving a message from the server."));
    };
    HubConnection.prototype.invokeClientMethod = function (invocationMessage) {
        var _this = this;
        var methods = this.methods[invocationMessage.target.toLowerCase()];
        if (methods) {
            try {
                methods.forEach(function (m) { return m.apply(_this, invocationMessage.arguments); });
            }
            catch (e) {
                this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Error, "A callback for the method " + invocationMessage.target.toLowerCase() + " threw error '" + e + "'.");
            }
            if (invocationMessage.invocationId) {
                // This is not supported in v1. So we return an error to avoid blocking the server waiting for the response.
                var message = "Server requested a response, which is not supported in this version of the client.";
                this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Error, message);
                // We don't want to wait on the stop itself.
                this.stopPromise = this.stopInternal(new Error(message));
            }
        }
        else {
            this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Warning, "No client method with the name '" + invocationMessage.target + "' found.");
        }
    };
    HubConnection.prototype.connectionClosed = function (error) {
        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Debug, "HubConnection.connectionClosed(" + error + ") called while in state " + this.connectionState + ".");
        // Triggering this.handshakeRejecter is insufficient because it could already be resolved without the continuation having run yet.
        this.stopDuringStartError = this.stopDuringStartError || error || new Error("The underlying connection was closed before the hub handshake could complete.");
        // If the handshake is in progress, start will be waiting for the handshake promise, so we complete it.
        // If it has already completed, this should just noop.
        if (this.handshakeResolver) {
            this.handshakeResolver();
        }
        this.cancelCallbacksWithError(error || new Error("Invocation canceled due to the underlying connection being closed."));
        this.cleanupTimeout();
        this.cleanupPingTimer();
        if (this.connectionState === HubConnectionState.Disconnecting) {
            this.completeClose(error);
        }
        else if (this.connectionState === HubConnectionState.Connected && this.reconnectPolicy) {
            // tslint:disable-next-line:no-floating-promises
            this.reconnect(error);
        }
        else if (this.connectionState === HubConnectionState.Connected) {
            this.completeClose(error);
        }
        // If none of the above if conditions were true were called the HubConnection must be in either:
        // 1. The Connecting state in which case the handshakeResolver will complete it and stopDuringStartError will fail it.
        // 2. The Reconnecting state in which case the handshakeResolver will complete it and stopDuringStartError will fail the current reconnect attempt
        //    and potentially continue the reconnect() loop.
        // 3. The Disconnected state in which case we're already done.
    };
    HubConnection.prototype.completeClose = function (error) {
        var _this = this;
        if (this.connectionStarted) {
            this.connectionState = HubConnectionState.Disconnected;
            this.connectionStarted = false;
            try {
                this.closedCallbacks.forEach(function (c) { return c.apply(_this, [error]); });
            }
            catch (e) {
                this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Error, "An onclose callback called with error '" + error + "' threw error '" + e + "'.");
            }
        }
    };
    HubConnection.prototype.reconnect = function (error) {
        return __awaiter(this, void 0, void 0, function () {
            var reconnectStartTime, previousReconnectAttempts, retryError, nextRetryDelay, e_4;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        reconnectStartTime = Date.now();
                        previousReconnectAttempts = 0;
                        retryError = error !== undefined ? error : new Error("Attempting to reconnect due to a unknown error.");
                        nextRetryDelay = this.getNextRetryDelay(previousReconnectAttempts++, 0, retryError);
                        if (nextRetryDelay === null) {
                            this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Debug, "Connection not reconnecting because the IRetryPolicy returned null on the first reconnect attempt.");
                            this.completeClose(error);
                            return [2 /*return*/];
                        }
                        this.connectionState = HubConnectionState.Reconnecting;
                        if (error) {
                            this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Information, "Connection reconnecting because of error '" + error + "'.");
                        }
                        else {
                            this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Information, "Connection reconnecting.");
                        }
                        if (this.onreconnecting) {
                            try {
                                this.reconnectingCallbacks.forEach(function (c) { return c.apply(_this, [error]); });
                            }
                            catch (e) {
                                this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Error, "An onreconnecting callback called with error '" + error + "' threw error '" + e + "'.");
                            }
                            // Exit early if an onreconnecting callback called connection.stop().
                            if (this.connectionState !== HubConnectionState.Reconnecting) {
                                this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Debug, "Connection left the reconnecting state in onreconnecting callback. Done reconnecting.");
                                return [2 /*return*/];
                            }
                        }
                        _a.label = 1;
                    case 1:
                        if (!(nextRetryDelay !== null)) return [3 /*break*/, 7];
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Information, "Reconnect attempt number " + previousReconnectAttempts + " will start in " + nextRetryDelay + " ms.");
                        return [4 /*yield*/, new Promise(function (resolve) {
                                _this.reconnectDelayHandle = setTimeout(resolve, nextRetryDelay);
                            })];
                    case 2:
                        _a.sent();
                        this.reconnectDelayHandle = undefined;
                        if (this.connectionState !== HubConnectionState.Reconnecting) {
                            this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Debug, "Connection left the reconnecting state during reconnect delay. Done reconnecting.");
                            return [2 /*return*/];
                        }
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, this.startInternal()];
                    case 4:
                        _a.sent();
                        this.connectionState = HubConnectionState.Connected;
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Information, "HubConnection reconnected successfully.");
                        if (this.onreconnected) {
                            try {
                                this.reconnectedCallbacks.forEach(function (c) { return c.apply(_this, [_this.connection.connectionId]); });
                            }
                            catch (e) {
                                this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Error, "An onreconnected callback called with connectionId '" + this.connection.connectionId + "; threw error '" + e + "'.");
                            }
                        }
                        return [2 /*return*/];
                    case 5:
                        e_4 = _a.sent();
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Information, "Reconnect attempt failed because of error '" + e_4 + "'.");
                        if (this.connectionState !== HubConnectionState.Reconnecting) {
                            this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Debug, "Connection moved to the '" + this.connectionState + "' from the reconnecting state during reconnect attempt. Done reconnecting.");
                            // The TypeScript compiler thinks that connectionState must be Connected here. The TypeScript compiler is wrong.
                            if (this.connectionState === HubConnectionState.Disconnecting) {
                                this.completeClose();
                            }
                            return [2 /*return*/];
                        }
                        retryError = e_4 instanceof Error ? e_4 : new Error(e_4.toString());
                        nextRetryDelay = this.getNextRetryDelay(previousReconnectAttempts++, Date.now() - reconnectStartTime, retryError);
                        return [3 /*break*/, 6];
                    case 6: return [3 /*break*/, 1];
                    case 7:
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Information, "Reconnect retries have been exhausted after " + (Date.now() - reconnectStartTime) + " ms and " + previousReconnectAttempts + " failed attempts. Connection disconnecting.");
                        this.completeClose();
                        return [2 /*return*/];
                }
            });
        });
    };
    HubConnection.prototype.getNextRetryDelay = function (previousRetryCount, elapsedMilliseconds, retryReason) {
        try {
            return this.reconnectPolicy.nextRetryDelayInMilliseconds({
                elapsedMilliseconds: elapsedMilliseconds,
                previousRetryCount: previousRetryCount,
                retryReason: retryReason,
            });
        }
        catch (e) {
            this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Error, "IRetryPolicy.nextRetryDelayInMilliseconds(" + previousRetryCount + ", " + elapsedMilliseconds + ") threw error '" + e + "'.");
            return null;
        }
    };
    HubConnection.prototype.cancelCallbacksWithError = function (error) {
        var callbacks = this.callbacks;
        this.callbacks = {};
        Object.keys(callbacks)
            .forEach(function (key) {
            var callback = callbacks[key];
            callback(null, error);
        });
    };
    HubConnection.prototype.cleanupPingTimer = function () {
        if (this.pingServerHandle) {
            clearTimeout(this.pingServerHandle);
            this.pingServerHandle = undefined;
        }
    };
    HubConnection.prototype.cleanupTimeout = function () {
        if (this.timeoutHandle) {
            clearTimeout(this.timeoutHandle);
        }
    };
    HubConnection.prototype.createInvocation = function (methodName, args, nonblocking, streamIds) {
        if (nonblocking) {
            if (streamIds.length !== 0) {
                return {
                    arguments: args,
                    streamIds: streamIds,
                    target: methodName,
                    type: __WEBPACK_IMPORTED_MODULE_1__IHubProtocol__["a" /* MessageType */].Invocation,
                };
            }
            else {
                return {
                    arguments: args,
                    target: methodName,
                    type: __WEBPACK_IMPORTED_MODULE_1__IHubProtocol__["a" /* MessageType */].Invocation,
                };
            }
        }
        else {
            var invocationId = this.invocationId;
            this.invocationId++;
            if (streamIds.length !== 0) {
                return {
                    arguments: args,
                    invocationId: invocationId.toString(),
                    streamIds: streamIds,
                    target: methodName,
                    type: __WEBPACK_IMPORTED_MODULE_1__IHubProtocol__["a" /* MessageType */].Invocation,
                };
            }
            else {
                return {
                    arguments: args,
                    invocationId: invocationId.toString(),
                    target: methodName,
                    type: __WEBPACK_IMPORTED_MODULE_1__IHubProtocol__["a" /* MessageType */].Invocation,
                };
            }
        }
    };
    HubConnection.prototype.launchStreams = function (streams, promiseQueue) {
        var _this = this;
        if (streams.length === 0) {
            return;
        }
        // Synchronize stream data so they arrive in-order on the server
        if (!promiseQueue) {
            promiseQueue = Promise.resolve();
        }
        var _loop_1 = function (streamId) {
            streams[streamId].subscribe({
                complete: function () {
                    promiseQueue = promiseQueue.then(function () { return _this.sendWithProtocol(_this.createCompletionMessage(streamId)); });
                },
                error: function (err) {
                    var message;
                    if (err instanceof Error) {
                        message = err.message;
                    }
                    else if (err && err.toString) {
                        message = err.toString();
                    }
                    else {
                        message = "Unknown error";
                    }
                    promiseQueue = promiseQueue.then(function () { return _this.sendWithProtocol(_this.createCompletionMessage(streamId, message)); });
                },
                next: function (item) {
                    promiseQueue = promiseQueue.then(function () { return _this.sendWithProtocol(_this.createStreamItemMessage(streamId, item)); });
                },
            });
        };
        // We want to iterate over the keys, since the keys are the stream ids
        // tslint:disable-next-line:forin
        for (var streamId in streams) {
            _loop_1(streamId);
        }
    };
    HubConnection.prototype.replaceStreamingParams = function (args) {
        var streams = [];
        var streamIds = [];
        for (var i = 0; i < args.length; i++) {
            var argument = args[i];
            if (this.isObservable(argument)) {
                var streamId = this.invocationId;
                this.invocationId++;
                // Store the stream for later use
                streams[streamId] = argument;
                streamIds.push(streamId.toString());
                // remove stream from args
                args.splice(i, 1);
            }
        }
        return [streams, streamIds];
    };
    HubConnection.prototype.isObservable = function (arg) {
        // This allows other stream implementations to just work (like rxjs)
        return arg && arg.subscribe && typeof arg.subscribe === "function";
    };
    HubConnection.prototype.createStreamInvocation = function (methodName, args, streamIds) {
        var invocationId = this.invocationId;
        this.invocationId++;
        if (streamIds.length !== 0) {
            return {
                arguments: args,
                invocationId: invocationId.toString(),
                streamIds: streamIds,
                target: methodName,
                type: __WEBPACK_IMPORTED_MODULE_1__IHubProtocol__["a" /* MessageType */].StreamInvocation,
            };
        }
        else {
            return {
                arguments: args,
                invocationId: invocationId.toString(),
                target: methodName,
                type: __WEBPACK_IMPORTED_MODULE_1__IHubProtocol__["a" /* MessageType */].StreamInvocation,
            };
        }
    };
    HubConnection.prototype.createCancelInvocation = function (id) {
        return {
            invocationId: id,
            type: __WEBPACK_IMPORTED_MODULE_1__IHubProtocol__["a" /* MessageType */].CancelInvocation,
        };
    };
    HubConnection.prototype.createStreamItemMessage = function (id, item) {
        return {
            invocationId: id,
            item: item,
            type: __WEBPACK_IMPORTED_MODULE_1__IHubProtocol__["a" /* MessageType */].StreamItem,
        };
    };
    HubConnection.prototype.createCompletionMessage = function (id, error, result) {
        if (error) {
            return {
                error: error,
                invocationId: id,
                type: __WEBPACK_IMPORTED_MODULE_1__IHubProtocol__["a" /* MessageType */].Completion,
            };
        }
        return {
            invocationId: id,
            result: result,
            type: __WEBPACK_IMPORTED_MODULE_1__IHubProtocol__["a" /* MessageType */].Completion,
        };
    };
    return HubConnection;
}());

//# sourceMappingURL=HubConnection.js.map

/***/ }),
/* 661 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TextMessageFormat; });
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
// Not exported from index
/** @private */
var TextMessageFormat = /** @class */ (function () {
    function TextMessageFormat() {
    }
    TextMessageFormat.write = function (output) {
        return "" + output + TextMessageFormat.RecordSeparator;
    };
    TextMessageFormat.parse = function (input) {
        if (input[input.length - 1] !== TextMessageFormat.RecordSeparator) {
            throw new Error("Message is incomplete.");
        }
        var messages = input.split(TextMessageFormat.RecordSeparator);
        messages.pop();
        return messages;
    };
    TextMessageFormat.RecordSeparatorCode = 0x1e;
    TextMessageFormat.RecordSeparator = String.fromCharCode(TextMessageFormat.RecordSeparatorCode);
    return TextMessageFormat;
}());

//# sourceMappingURL=TextMessageFormat.js.map

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subject; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils__ = __webpack_require__(88);
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.

/** Stream implementation to stream items to the server. */
var Subject = /** @class */ (function () {
    function Subject() {
        this.observers = [];
    }
    Subject.prototype.next = function (item) {
        for (var _i = 0, _a = this.observers; _i < _a.length; _i++) {
            var observer = _a[_i];
            observer.next(item);
        }
    };
    Subject.prototype.error = function (err) {
        for (var _i = 0, _a = this.observers; _i < _a.length; _i++) {
            var observer = _a[_i];
            if (observer.error) {
                observer.error(err);
            }
        }
    };
    Subject.prototype.complete = function () {
        for (var _i = 0, _a = this.observers; _i < _a.length; _i++) {
            var observer = _a[_i];
            if (observer.complete) {
                observer.complete();
            }
        }
    };
    Subject.prototype.subscribe = function (observer) {
        this.observers.push(observer);
        return new __WEBPACK_IMPORTED_MODULE_0__Utils__["d" /* SubjectSubscription */](this, observer);
    };
    return Subject;
}());

//# sourceMappingURL=Subject.js.map

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return JsonHubProtocol; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__IHubProtocol__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ILogger__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ITransport__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Loggers__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TextMessageFormat__ = __webpack_require__(662);
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.





var JSON_HUB_PROTOCOL_NAME = "json";
/** Implements the JSON Hub Protocol. */
var JsonHubProtocol = /** @class */ (function () {
    function JsonHubProtocol() {
        /** @inheritDoc */
        this.name = JSON_HUB_PROTOCOL_NAME;
        /** @inheritDoc */
        this.version = 1;
        /** @inheritDoc */
        this.transferFormat = __WEBPACK_IMPORTED_MODULE_2__ITransport__["b" /* TransferFormat */].Text;
    }
    /** Creates an array of {@link @microsoft/signalr.HubMessage} objects from the specified serialized representation.
     *
     * @param {string} input A string containing the serialized representation.
     * @param {ILogger} logger A logger that will be used to log messages that occur during parsing.
     */
    JsonHubProtocol.prototype.parseMessages = function (input, logger) {
        // The interface does allow "ArrayBuffer" to be passed in, but this implementation does not. So let's throw a useful error.
        if (typeof input !== "string") {
            throw new Error("Invalid input for JSON hub protocol. Expected a string.");
        }
        if (!input) {
            return [];
        }
        if (logger === null) {
            logger = __WEBPACK_IMPORTED_MODULE_3__Loggers__["a" /* NullLogger */].instance;
        }
        // Parse the messages
        var messages = __WEBPACK_IMPORTED_MODULE_4__TextMessageFormat__["a" /* TextMessageFormat */].parse(input);
        var hubMessages = [];
        for (var _i = 0, messages_1 = messages; _i < messages_1.length; _i++) {
            var message = messages_1[_i];
            var parsedMessage = JSON.parse(message);
            if (typeof parsedMessage.type !== "number") {
                throw new Error("Invalid payload.");
            }
            switch (parsedMessage.type) {
                case __WEBPACK_IMPORTED_MODULE_0__IHubProtocol__["a" /* MessageType */].Invocation:
                    this.isInvocationMessage(parsedMessage);
                    break;
                case __WEBPACK_IMPORTED_MODULE_0__IHubProtocol__["a" /* MessageType */].StreamItem:
                    this.isStreamItemMessage(parsedMessage);
                    break;
                case __WEBPACK_IMPORTED_MODULE_0__IHubProtocol__["a" /* MessageType */].Completion:
                    this.isCompletionMessage(parsedMessage);
                    break;
                case __WEBPACK_IMPORTED_MODULE_0__IHubProtocol__["a" /* MessageType */].Ping:
                    // Single value, no need to validate
                    break;
                case __WEBPACK_IMPORTED_MODULE_0__IHubProtocol__["a" /* MessageType */].Close:
                    // All optional values, no need to validate
                    break;
                default:
                    // Future protocol changes can add message types, old clients can ignore them
                    logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Information, "Unknown message type '" + parsedMessage.type + "' ignored.");
                    continue;
            }
            hubMessages.push(parsedMessage);
        }
        return hubMessages;
    };
    /** Writes the specified {@link @microsoft/signalr.HubMessage} to a string and returns it.
     *
     * @param {HubMessage} message The message to write.
     * @returns {string} A string containing the serialized representation of the message.
     */
    JsonHubProtocol.prototype.writeMessage = function (message) {
        return __WEBPACK_IMPORTED_MODULE_4__TextMessageFormat__["a" /* TextMessageFormat */].write(JSON.stringify(message));
    };
    JsonHubProtocol.prototype.isInvocationMessage = function (message) {
        this.assertNotEmptyString(message.target, "Invalid payload for Invocation message.");
        if (message.invocationId !== undefined) {
            this.assertNotEmptyString(message.invocationId, "Invalid payload for Invocation message.");
        }
    };
    JsonHubProtocol.prototype.isStreamItemMessage = function (message) {
        this.assertNotEmptyString(message.invocationId, "Invalid payload for StreamItem message.");
        if (message.item === undefined) {
            throw new Error("Invalid payload for StreamItem message.");
        }
    };
    JsonHubProtocol.prototype.isCompletionMessage = function (message) {
        if (message.result && message.error) {
            throw new Error("Invalid payload for Completion message.");
        }
        if (!message.result && message.error) {
            this.assertNotEmptyString(message.error, "Invalid payload for Completion message.");
        }
        this.assertNotEmptyString(message.invocationId, "Invalid payload for Completion message.");
    };
    JsonHubProtocol.prototype.assertNotEmptyString = function (value, errorMessage) {
        if (typeof value !== "string" || value === "") {
            throw new Error(errorMessage);
        }
    };
    return JsonHubProtocol;
}());

//# sourceMappingURL=JsonHubProtocol.js.map

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return upload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return remove; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__request__ = __webpack_require__(18);
var upload=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(_ref){var saleId=_ref.saleId,file=_ref.file,accessToken=_ref.accessToken;var credentials,data,k,options,result;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__request__["d" /* get */])(saleId?'/api/v1/uploads/sign?saleId='+saleId:'/api/v1/uploads/sign/general',accessToken);case 2:credentials=_context.sent;data=new FormData();for(k in credentials.data){data.append(k,credentials.data[k]);}data.append('file',file);options={method:'POST',headers:{Accept:'application/json'},body:data};_context.next=9;return Object(__WEBPACK_IMPORTED_MODULE_1__request__["b" /* default */])(credentials.url,options);case 9:result=_context.sent;return _context.abrupt('return',{id:'v'+result.version+'/'+result.public_id,originalFilename:result.original_filename+'.'+result.format,url:result.secure_url,full:result.original_filename,type:result.original_filename,details:null,uploadedAt:result.created_at,metadata:{deleteToken:result.delete_token}});case 11:case'end':return _context.stop();}}},_callee,this);}));return function upload(_x){return _ref2.apply(this,arguments);};}();var remove=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(_ref3){var saleId=_ref3.saleId,deleteToken=_ref3.deleteToken,accessToken=_ref3.accessToken;var credentials;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__request__["d" /* get */])(saleId?'/api/v1/uploads/sign?saleId='+saleId:'/api/v1/uploads/sign/general',accessToken);case 2:credentials=_context2.sent;_context2.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__request__["e" /* post */])(credentials.deleteUrl,{token:deleteToken});case 5:case'end':return _context2.stop();}}},_callee2,this);}));return function remove(_x2){return _ref4.apply(this,arguments);};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function canAward(_ref){var offers=_ref.offers;return offers.filter(function(o){return o.isValid&&['confirmed','accepted'].includes(o.status);}).length>0;}function canConfirmAward(_ref2){var offers=_ref2.offers;return offers.filter(function(o){return o.status==='awarded';}).length>0&&offers.filter(function(o){return['confirmed','accepted'].includes(o.status);}).length>0;}var actionSelector=function actionSelector(_ref3){var sale=_ref3.sale,round=_ref3.round;var type=round.type,status=round.status;var actions=[];if(sale.hasSalePermissions){actions=[].concat(_toConsumableArray(actions),['duplicate']);if(status==='closed'||type==='simple_offer'){if(type==='sealed_bidding'){actions=[].concat(_toConsumableArray(actions),['counteroffer','increase']);}if(type==='open_bidding'){actions=[].concat(_toConsumableArray(actions));}if(type==='counteroffer_bidding'){actions=[].concat(_toConsumableArray(actions),['counteroffer']);}if(type==='simple_offer'){actions=[].concat(_toConsumableArray(actions),['increase']);}if(canAward({offers:sale.offers.viewModel.offers})){if(sale.round.definition.type==='registration')actions=[].concat(_toConsumableArray(actions),['awardAll']);else actions=[].concat(_toConsumableArray(actions),['award','rejectAll']);}if(canConfirmAward({offers:sale.offers.viewModel.offers})){actions=[].concat(_toConsumableArray(actions),['confirmAward','rejectAll']);}}}else{if(sale.offers.hasAccessibleOffers)actions=[].concat(_toConsumableArray(actions),['notifySeller']);}var saleActions=sale.saleConfig.saleActions.map(function(name){return{name:name};});return saleActions.filter(function(a){return actions.includes(a.name);}).map(function(a){return a.name;});};/* harmony default export */ __webpack_exports__["a"] = (actionSelector);

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CollapseAllVisibility; });
/**
 * {@docCategory GroupedList}
 */
var CollapseAllVisibility;
(function (CollapseAllVisibility) {
    CollapseAllVisibility[CollapseAllVisibility["hidden"] = 0] = "hidden";
    CollapseAllVisibility[CollapseAllVisibility["visible"] = 1] = "visible";
})(CollapseAllVisibility || (CollapseAllVisibility = {}));
//# sourceMappingURL=GroupedList.types.js.map

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DetailsHeader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DetailsHeader_base__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DetailsHeader_styles__ = __webpack_require__(406);



var DetailsHeader = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__DetailsHeader_base__["a" /* DetailsHeaderBase */], __WEBPACK_IMPORTED_MODULE_2__DetailsHeader_styles__["c" /* getStyles */], undefined, { scope: 'DetailsHeader' });
//# sourceMappingURL=DetailsHeader.js.map

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DetailsHeaderBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DetailsList_types__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FocusZone__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icon__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layer__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__GroupedList_GroupSpacer__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__GroupedList__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DetailsRowCheck__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utilities_selection_interfaces__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utilities_dragdrop_index__ = __webpack_require__(1723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_DetailsList_DetailsColumn__ = __webpack_require__(1724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__DetailsHeader_types__ = __webpack_require__(407);
















var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["r" /* classNamesFunction */])();
var MOUSEDOWN_PRIMARY_BUTTON = 0; // for mouse down event we are using ev.button property, 0 means left button
var MOUSEMOVE_PRIMARY_BUTTON = 1; // for mouse move event we are using ev.buttons property, 1 means left button
var NO_COLUMNS = [];
var DetailsHeaderBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](DetailsHeaderBase, _super);
    function DetailsHeaderBase(props) {
        var _this = _super.call(this, props) || this;
        _this._rootComponent = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._draggedColumnIndex = -1;
        _this._dropHintDetails = {};
        _this._updateDroppingState = function (newValue, event) {
            if (_this._draggedColumnIndex >= 0 && event.type !== 'drop') {
                if (!newValue) {
                    _this._resetDropHints();
                }
            }
        };
        _this._onDragOver = function (item, event) {
            if (_this._draggedColumnIndex >= 0) {
                event.stopPropagation();
                _this._computeDropHintToBeShown(event.clientX);
            }
        };
        _this._onDrop = function (item, event) {
            var columnReorderProps = _this.state.columnReorderProps;
            // Target index will not get changed if draggeditem is after target item.
            if (_this._draggedColumnIndex >= 0 && event) {
                var targetIndex = _this._draggedColumnIndex > _this._currentDropHintIndex ? _this._currentDropHintIndex : _this._currentDropHintIndex - 1;
                var isValidDrop = _this._isValidCurrentDropHintIndex();
                event.stopPropagation();
                if (isValidDrop) {
                    _this._onDropIndexInfo.sourceIndex = _this._draggedColumnIndex;
                    _this._onDropIndexInfo.targetIndex = targetIndex;
                    if (columnReorderProps && columnReorderProps.onColumnDrop) {
                        var dragDropDetails = {
                            draggedIndex: _this._draggedColumnIndex,
                            targetIndex: targetIndex
                        };
                        columnReorderProps.onColumnDrop(dragDropDetails);
                    }
                    else if (columnReorderProps && columnReorderProps.handleColumnReorder) {
                        columnReorderProps.handleColumnReorder(_this._draggedColumnIndex, targetIndex);
                    }
                }
            }
            _this._resetDropHints();
            _this._dropHintDetails = {};
            _this._draggedColumnIndex = -1;
        };
        _this._updateDragInfo = function (props, event) {
            var columnReorderProps = _this.state.columnReorderProps;
            var itemIndex = props.itemIndex;
            if (itemIndex >= 0) {
                // Column index is set based on the checkbox
                _this._draggedColumnIndex = _this._isCheckboxColumnHidden() ? itemIndex - 1 : itemIndex - 2;
                _this._getDropHintPositions();
                if (columnReorderProps && columnReorderProps.onColumnDragStart) {
                    columnReorderProps.onColumnDragStart(true);
                }
            }
            else if (event && _this._draggedColumnIndex >= 0) {
                _this._resetDropHints();
                _this._draggedColumnIndex = -1;
                _this._dropHintDetails = {};
                if (columnReorderProps && columnReorderProps.onColumnDragEnd) {
                    var columnDragEndLocation = _this._isEventOnHeader(event);
                    columnReorderProps.onColumnDragEnd({ dropLocation: columnDragEndLocation }, event);
                }
            }
        };
        _this._getDropHintPositions = function () {
            var _a = _this.props.columns, columns = _a === void 0 ? NO_COLUMNS : _a;
            var columnReorderProps = _this.state.columnReorderProps;
            var prevX = 0;
            var prevMid = 0;
            var prevRef;
            var frozenColumnCountFromStart = columnReorderProps && columnReorderProps.frozenColumnCountFromStart ? columnReorderProps.frozenColumnCountFromStart : 0;
            var frozenColumnCountFromEnd = columnReorderProps && columnReorderProps.frozenColumnCountFromEnd ? columnReorderProps.frozenColumnCountFromEnd : 0;
            for (var i = frozenColumnCountFromStart; i < columns.length - frozenColumnCountFromEnd + 1; i++) {
                if (_this._rootElement) {
                    var dropHintElement = _this._rootElement.querySelectorAll('#columnDropHint_' + i)[0];
                    if (dropHintElement) {
                        if (i === frozenColumnCountFromStart) {
                            prevX = dropHintElement.offsetLeft;
                            prevMid = dropHintElement.offsetLeft;
                            prevRef = dropHintElement;
                        }
                        else {
                            var newMid = (dropHintElement.offsetLeft + prevX) / 2;
                            _this._dropHintDetails[i - 1] = {
                                originX: prevX,
                                startX: prevMid,
                                endX: newMid,
                                dropHintElementRef: prevRef
                            };
                            prevMid = newMid;
                            prevRef = dropHintElement;
                            prevX = dropHintElement.offsetLeft;
                            if (i === columns.length - frozenColumnCountFromEnd) {
                                _this._dropHintDetails[i] = {
                                    originX: prevX,
                                    startX: prevMid,
                                    endX: dropHintElement.offsetLeft,
                                    dropHintElementRef: prevRef
                                };
                            }
                        }
                    }
                }
            }
        };
        /**
         * Based on the given cursor position, finds the nearest drop hint and updates the state to make it visible
         *
         */
        _this._computeDropHintToBeShown = function (clientX) {
            if (_this._rootElement) {
                var clientRect = _this._rootElement.getBoundingClientRect();
                var headerOriginX = clientRect.left;
                var eventXRelativePosition = clientX - headerOriginX;
                var currentDropHintIndex = _this._currentDropHintIndex;
                if (_this._isValidCurrentDropHintIndex()) {
                    if (_this._liesBetween(eventXRelativePosition, _this._dropHintDetails[currentDropHintIndex].startX, _this._dropHintDetails[currentDropHintIndex].endX)) {
                        return;
                    }
                }
                var _a = _this.props.columns, columns = _a === void 0 ? NO_COLUMNS : _a;
                var columnReorderProps = _this.state.columnReorderProps;
                var frozenColumnCountFromStart = columnReorderProps && columnReorderProps.frozenColumnCountFromStart ? columnReorderProps.frozenColumnCountFromStart : 0;
                var frozenColumnCountFromEnd = columnReorderProps && columnReorderProps.frozenColumnCountFromEnd ? columnReorderProps.frozenColumnCountFromEnd : 0;
                var currentIndex = frozenColumnCountFromStart;
                var lastValidColumn = columns.length - frozenColumnCountFromEnd;
                var indexToUpdate = -1;
                if (_this._isBefore(eventXRelativePosition, _this._dropHintDetails[currentIndex].endX)) {
                    indexToUpdate = currentIndex;
                }
                else if (_this._isAfter(eventXRelativePosition, _this._dropHintDetails[lastValidColumn].startX)) {
                    indexToUpdate = lastValidColumn;
                }
                else if (_this._isValidCurrentDropHintIndex()) {
                    if (_this._dropHintDetails[currentDropHintIndex + 1] &&
                        _this._liesBetween(eventXRelativePosition, _this._dropHintDetails[currentDropHintIndex + 1].startX, _this._dropHintDetails[currentDropHintIndex + 1].endX)) {
                        indexToUpdate = currentDropHintIndex + 1;
                    }
                    else if (_this._dropHintDetails[currentDropHintIndex - 1] &&
                        _this._liesBetween(eventXRelativePosition, _this._dropHintDetails[currentDropHintIndex - 1].startX, _this._dropHintDetails[currentDropHintIndex - 1].endX)) {
                        indexToUpdate = currentDropHintIndex - 1;
                    }
                }
                if (indexToUpdate === -1) {
                    var startIndex = frozenColumnCountFromStart;
                    var endIndex = lastValidColumn;
                    while (startIndex < endIndex) {
                        var middleIndex = Math.ceil((endIndex + startIndex) / 2);
                        if (_this._liesBetween(eventXRelativePosition, _this._dropHintDetails[middleIndex].startX, _this._dropHintDetails[middleIndex].endX)) {
                            indexToUpdate = middleIndex;
                            break;
                        }
                        else if (_this._isBefore(eventXRelativePosition, _this._dropHintDetails[middleIndex].originX)) {
                            endIndex = middleIndex;
                        }
                        else if (_this._isAfter(eventXRelativePosition, _this._dropHintDetails[middleIndex].originX)) {
                            startIndex = middleIndex;
                        }
                    }
                }
                if (indexToUpdate === _this._draggedColumnIndex || indexToUpdate === _this._draggedColumnIndex + 1) {
                    if (_this._isValidCurrentDropHintIndex()) {
                        _this._resetDropHints();
                    }
                }
                else if (currentDropHintIndex !== indexToUpdate && indexToUpdate >= 0) {
                    _this._resetDropHints();
                    _this._updateDropHintElement(_this._dropHintDetails[indexToUpdate].dropHintElementRef, 'inline-block');
                    _this._currentDropHintIndex = indexToUpdate;
                }
            }
        };
        _this._renderColumnSizer = function (_a) {
            var columnIndex = _a.columnIndex;
            var _b = _this.props.columns, columns = _b === void 0 ? NO_COLUMNS : _b;
            var column = columns[columnIndex];
            var columnResizeDetails = _this.state.columnResizeDetails;
            var classNames = _this._classNames;
            return column.isResizable ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { key: column.key + "_sizer", "aria-hidden": true, role: "button", "data-is-focusable": false, onClick: stopPropagation, "data-sizer-index": columnIndex, onBlur: _this._onSizerBlur, className: Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["t" /* css */])(classNames.cellSizer, columnIndex < columns.length - 1 ? classNames.cellSizerStart : classNames.cellSizerEnd, (_c = {},
                    _c[classNames.cellIsResizing] = columnResizeDetails && columnResizeDetails.columnIndex === columnIndex,
                    _c)), onDoubleClick: _this._onSizerDoubleClick.bind(_this, columnIndex) })) : null;
            var _c;
        };
        _this._onRenderColumnHeaderTooltip = function (tooltipHostProps) {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: tooltipHostProps.hostClassName }, tooltipHostProps.children);
        };
        /**
         * Called when the select all toggle is clicked.
         */
        _this._onSelectAllClicked = function () {
            var selection = _this.props.selection;
            if (selection) {
                selection.toggleAllSelected();
            }
        };
        _this._onRootMouseDown = function (ev) {
            var columnIndexAttr = ev.target.getAttribute('data-sizer-index');
            var columnIndex = Number(columnIndexAttr);
            var _a = _this.props.columns, columns = _a === void 0 ? NO_COLUMNS : _a;
            if (columnIndexAttr === null || ev.button !== MOUSEDOWN_PRIMARY_BUTTON) {
                // Ignore anything except the primary button.
                return;
            }
            _this.setState({
                columnResizeDetails: {
                    columnIndex: columnIndex,
                    columnMinWidth: columns[columnIndex].calculatedWidth,
                    originX: ev.clientX
                }
            });
            ev.preventDefault();
            ev.stopPropagation();
        };
        _this._onRootMouseMove = function (ev) {
            var _a = _this.state, columnResizeDetails = _a.columnResizeDetails, isSizing = _a.isSizing;
            if (columnResizeDetails && !isSizing && ev.clientX !== columnResizeDetails.originX) {
                _this.setState({ isSizing: true });
            }
        };
        _this._onRootRef = function (focusZone) {
            if (focusZone) {
                // Need to resolve the actual DOM node, not the component. The element itself will be used for drag/drop and focusing.
                _this._rootElement = Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(focusZone);
            }
            else {
                _this._rootElement = undefined;
            }
        };
        _this._onRootKeyDown = function (ev) {
            var _a = _this.state, columnResizeDetails = _a.columnResizeDetails, isSizing = _a.isSizing;
            var _b = _this.props, _c = _b.columns, columns = _c === void 0 ? NO_COLUMNS : _c, onColumnResized = _b.onColumnResized;
            var columnIndexAttr = ev.target.getAttribute('data-sizer-index');
            if (!columnIndexAttr || isSizing) {
                return;
            }
            var columnIndex = Number(columnIndexAttr);
            if (!columnResizeDetails) {
                if (ev.which === __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].enter) {
                    _this.setState({
                        columnResizeDetails: {
                            columnIndex: columnIndex,
                            columnMinWidth: columns[columnIndex].calculatedWidth
                        }
                    });
                    ev.preventDefault();
                    ev.stopPropagation();
                }
            }
            else {
                var increment = void 0;
                if (ev.which === __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].enter) {
                    _this.setState({
                        columnResizeDetails: undefined
                    });
                    ev.preventDefault();
                    ev.stopPropagation();
                }
                else if (ev.which === __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].left) {
                    increment = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["V" /* getRTL */])() ? 1 : -1;
                }
                else if (ev.which === __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].right) {
                    increment = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["V" /* getRTL */])() ? -1 : 1;
                }
                if (increment) {
                    if (!ev.shiftKey) {
                        increment *= 10;
                    }
                    _this.setState({
                        columnResizeDetails: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, columnResizeDetails, { columnMinWidth: columnResizeDetails.columnMinWidth + increment })
                    });
                    if (onColumnResized) {
                        onColumnResized(columns[columnIndex], columnResizeDetails.columnMinWidth + increment, columnIndex);
                    }
                    ev.preventDefault();
                    ev.stopPropagation();
                }
            }
        };
        /**
         * mouse move event handler in the header
         * it will set isSizing state to true when user clicked on the sizer and move the mouse.
         *
         * @param ev - mouse move event
         */
        _this._onSizerMouseMove = function (ev) {
            var 
            // use buttons property here since ev.button in some edge case is not upding well during the move.
            // but firefox doesn't support it, so we set the default value when it is not defined.
            buttons = ev.buttons;
            var _a = _this.props, onColumnIsSizingChanged = _a.onColumnIsSizingChanged, onColumnResized = _a.onColumnResized, _b = _a.columns, columns = _b === void 0 ? NO_COLUMNS : _b;
            var columnResizeDetails = _this.state.columnResizeDetails;
            if (buttons !== undefined && buttons !== MOUSEMOVE_PRIMARY_BUTTON) {
                // cancel mouse down event and return early when the primary button is not pressed
                _this._onSizerMouseUp(ev);
                return;
            }
            if (ev.clientX !== columnResizeDetails.originX) {
                if (onColumnIsSizingChanged) {
                    onColumnIsSizingChanged(columns[columnResizeDetails.columnIndex], true);
                }
            }
            if (onColumnResized) {
                var movement = ev.clientX - columnResizeDetails.originX;
                if (Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["V" /* getRTL */])()) {
                    movement = -movement;
                }
                onColumnResized(columns[columnResizeDetails.columnIndex], columnResizeDetails.columnMinWidth + movement, columnResizeDetails.columnIndex);
            }
        };
        _this._onSizerBlur = function (ev) {
            var columnResizeDetails = _this.state.columnResizeDetails;
            if (columnResizeDetails) {
                _this.setState({
                    columnResizeDetails: undefined,
                    isSizing: false
                });
            }
        };
        /**
         * mouse up event handler in the header
         * clear the resize related state.
         * This is to ensure we can catch double click event
         *
         * @param ev - mouse up event
         */
        _this._onSizerMouseUp = function (ev) {
            var _a = _this.props, _b = _a.columns, columns = _b === void 0 ? NO_COLUMNS : _b, onColumnIsSizingChanged = _a.onColumnIsSizingChanged;
            var columnResizeDetails = _this.state.columnResizeDetails;
            _this.setState({
                columnResizeDetails: undefined,
                isSizing: false
            });
            if (onColumnIsSizingChanged) {
                onColumnIsSizingChanged(columns[columnResizeDetails.columnIndex], false);
            }
        };
        _this._onToggleCollapseAll = function () {
            var onToggleCollapseAll = _this.props.onToggleCollapseAll;
            var newCollapsed = !_this.state.isAllCollapsed;
            _this.setState({
                isAllCollapsed: newCollapsed
            });
            if (onToggleCollapseAll) {
                onToggleCollapseAll(newCollapsed);
            }
        };
        Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_5" /* initializeComponentRef */])(_this);
        _this._events = new __WEBPACK_IMPORTED_MODULE_3__Utilities__["e" /* EventGroup */](_this);
        var columnReorderProps = props.columnReorderProps || (props.columnReorderOptions && getLegacyColumnReorderProps(props.columnReorderOptions));
        _this.state = {
            columnReorderProps: columnReorderProps,
            columnResizeDetails: undefined,
            groupNestingDepth: _this.props.groupNestingDepth,
            isAllCollapsed: _this.props.isAllCollapsed,
            isAllSelected: !!_this.props.selection && _this.props.selection.isAllSelected()
        };
        _this._onDropIndexInfo = {
            sourceIndex: -1,
            targetIndex: -1
        };
        _this._id = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["N" /* getId */])('header');
        _this._currentDropHintIndex = -1;
        return _this;
    }
    DetailsHeaderBase.getDerivedStateFromProps = function (newProps, prevState) {
        var columnReorderProps = newProps.columnReorderProps || (newProps.columnReorderOptions && getLegacyColumnReorderProps(newProps.columnReorderOptions));
        var groupNestingDepth = newProps.groupNestingDepth;
        var newState = { columnReorderProps: columnReorderProps, groupNestingDepth: groupNestingDepth };
        if (newProps.isAllCollapsed !== undefined) {
            newState.isAllCollapsed = newProps.isAllCollapsed;
        }
        return newState;
    };
    DetailsHeaderBase.prototype.componentDidMount = function () {
        var selection = this.props.selection;
        var columnReorderProps = this.state.columnReorderProps;
        this._events.on(selection, __WEBPACK_IMPORTED_MODULE_11__utilities_selection_interfaces__["a" /* SELECTION_CHANGE */], this._onSelectionChanged);
        // We need to use native on this to avoid MarqueeSelection from handling the event before us.
        this._events.on(this._rootElement, 'mousedown', this._onRootMouseDown);
        this._events.on(this._rootElement, 'keydown', this._onRootKeyDown);
        if (columnReorderProps && this._dragDropHelper) {
            this._subscriptionObject = this._dragDropHelper.subscribe(this._rootElement, this._events, this._getHeaderDragDropOptions());
        }
    };
    DetailsHeaderBase.prototype.componentDidUpdate = function (prevProps) {
        var columnReorderProps = this.state.columnReorderProps;
        if (!columnReorderProps) {
            if (this._subscriptionObject) {
                this._subscriptionObject.dispose();
                delete this._subscriptionObject;
            }
        }
        else if (!this._subscriptionObject && this._dragDropHelper) {
            this._subscriptionObject = this._dragDropHelper.subscribe(this._rootElement, this._events, this._getHeaderDragDropOptions());
        }
        if (this.props !== prevProps && this._onDropIndexInfo.sourceIndex >= 0 && this._onDropIndexInfo.targetIndex >= 0) {
            var _a = prevProps.columns, previousColumns = _a === void 0 ? NO_COLUMNS : _a;
            var _b = this.props.columns, columns = _b === void 0 ? NO_COLUMNS : _b;
            if (previousColumns[this._onDropIndexInfo.sourceIndex].key === columns[this._onDropIndexInfo.targetIndex].key) {
                this._onDropIndexInfo = {
                    sourceIndex: -1,
                    targetIndex: -1
                };
            }
        }
    };
    DetailsHeaderBase.prototype.componentWillUnmount = function () {
        if (this._subscriptionObject) {
            this._subscriptionObject.dispose();
            delete this._subscriptionObject;
        }
        if (this._dragDropHelper) {
            this._dragDropHelper.dispose();
        }
        this._events.dispose();
    };
    DetailsHeaderBase.prototype.render = function () {
        var _this = this;
        var _a = this.props, _b = _a.columns, columns = _b === void 0 ? NO_COLUMNS : _b, ariaLabel = _a.ariaLabel, ariaLabelForToggleAllGroupsButton = _a.ariaLabelForToggleAllGroupsButton, ariaLabelForSelectAllCheckbox = _a.ariaLabelForSelectAllCheckbox, selectAllVisibility = _a.selectAllVisibility, ariaLabelForSelectionColumn = _a.ariaLabelForSelectionColumn, indentWidth = _a.indentWidth, _c = _a.rowWidth, rowWidth = _c === void 0 ? 0 : _c, onColumnClick = _a.onColumnClick, onColumnContextMenu = _a.onColumnContextMenu, _d = _a.onRenderColumnHeaderTooltip, onRenderColumnHeaderTooltip = _d === void 0 ? this._onRenderColumnHeaderTooltip : _d, styles = _a.styles, theme = _a.theme, onRenderDetailsCheckbox = _a.onRenderDetailsCheckbox, useFastIcons = _a.useFastIcons;
        var _e = this.state, isAllSelected = _e.isAllSelected, columnResizeDetails = _e.columnResizeDetails, isSizing = _e.isSizing, groupNestingDepth = _e.groupNestingDepth, isAllCollapsed = _e.isAllCollapsed, columnReorderProps = _e.columnReorderProps;
        var showCheckbox = selectAllVisibility !== __WEBPACK_IMPORTED_MODULE_14__DetailsHeader_types__["a" /* SelectAllVisibility */].none;
        var isCheckboxHidden = selectAllVisibility === __WEBPACK_IMPORTED_MODULE_14__DetailsHeader_types__["a" /* SelectAllVisibility */].hidden;
        if (!this._dragDropHelper && columnReorderProps) {
            // TODO Do not assign local fields during render.
            // This behavior needs to be moved to the appropriate React lifecycle methods.
            this._dragDropHelper = new __WEBPACK_IMPORTED_MODULE_12__utilities_dragdrop_index__["a" /* DragDropHelper */]({
                selection: {
                    getSelection: function () {
                        return;
                    }
                },
                minimumPixelsForDrag: this.props.minimumPixelsForDrag
            });
        }
        var frozenColumnCountFromStart = columnReorderProps && columnReorderProps.frozenColumnCountFromStart ? columnReorderProps.frozenColumnCountFromStart : 0;
        var frozenColumnCountFromEnd = columnReorderProps && columnReorderProps.frozenColumnCountFromEnd ? columnReorderProps.frozenColumnCountFromEnd : 0;
        this._classNames = getClassNames(styles, {
            theme: theme,
            isAllSelected: isAllSelected,
            isSelectAllHidden: selectAllVisibility === __WEBPACK_IMPORTED_MODULE_14__DetailsHeader_types__["a" /* SelectAllVisibility */].hidden,
            isResizingColumn: !!columnResizeDetails && isSizing,
            isSizing: isSizing,
            isAllCollapsed: isAllCollapsed,
            isCheckboxHidden: isCheckboxHidden
        });
        var classNames = this._classNames;
        var IconComponent = useFastIcons ? __WEBPACK_IMPORTED_MODULE_6__Icon__["FontIcon"] : __WEBPACK_IMPORTED_MODULE_6__Icon__["Icon"];
        var isRTL = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["V" /* getRTL */])();
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__FocusZone__["a" /* FocusZone */], { role: "row", "aria-label": ariaLabel, className: classNames.root, componentRef: this._rootComponent, ref: this._onRootRef, onMouseMove: this._onRootMouseMove, "data-automationid": "DetailsHeader", style: { minWidth: rowWidth }, direction: __WEBPACK_IMPORTED_MODULE_5__FocusZone__["b" /* FocusZoneDirection */].horizontal },
            showCheckbox
                ? [
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { key: "__checkbox", className: classNames.cellIsCheck, "aria-labelledby": this._id + "-check", onClick: !isCheckboxHidden ? this._onSelectAllClicked : undefined, "aria-colindex": 1, role: 'columnheader' }, onRenderColumnHeaderTooltip({
                        hostClassName: classNames.checkTooltip,
                        id: this._id + "-checkTooltip",
                        setAriaDescribedBy: false,
                        content: ariaLabelForSelectAllCheckbox,
                        children: (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__DetailsRowCheck__["a" /* DetailsRowCheck */], { id: this._id + "-check", "aria-label": ariaLabelForSelectionColumn, "aria-describedby": !isCheckboxHidden
                                ? ariaLabelForSelectAllCheckbox && !this.props.onRenderColumnHeaderTooltip
                                    ? this._id + "-checkTooltip"
                                    : undefined
                                : ariaLabelForSelectionColumn && !this.props.onRenderColumnHeaderTooltip
                                    ? this._id + "-checkTooltip"
                                    : undefined, "data-is-focusable": !isCheckboxHidden || undefined, isHeader: true, selected: isAllSelected, anySelected: false, canSelect: !isCheckboxHidden, className: classNames.check, onRenderDetailsCheckbox: onRenderDetailsCheckbox, useFastIcons: useFastIcons }))
                    }, this._onRenderColumnHeaderTooltip)),
                    !this.props.onRenderColumnHeaderTooltip ? (ariaLabelForSelectAllCheckbox && !isCheckboxHidden ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("label", { key: "__checkboxLabel", id: this._id + "-checkTooltip", className: classNames.accessibleLabel, "aria-hidden": true }, ariaLabelForSelectAllCheckbox)) : ariaLabelForSelectionColumn && isCheckboxHidden ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("label", { key: "__checkboxLabel", id: this._id + "-checkTooltip", className: classNames.accessibleLabel, "aria-hidden": true }, ariaLabelForSelectionColumn)) : null) : null
                ]
                : null,
            groupNestingDepth > 0 && this.props.collapseAllVisibility === __WEBPACK_IMPORTED_MODULE_9__GroupedList__["a" /* CollapseAllVisibility */].visible ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.cellIsGroupExpander, onClick: this._onToggleCollapseAll, "data-is-focusable": true, "aria-label": ariaLabelForToggleAllGroupsButton, "aria-expanded": !isAllCollapsed, role: ariaLabelForToggleAllGroupsButton ? 'button' : undefined },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](IconComponent, { className: classNames.collapseButton, iconName: isRTL ? 'ChevronLeftMed' : 'ChevronRightMed' }))) : null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__GroupedList_GroupSpacer__["a" /* GroupSpacer */], { indentWidth: indentWidth, count: groupNestingDepth - 1 }),
            columns.map(function (column, columnIndex) {
                var _isDraggable = columnReorderProps
                    ? columnIndex >= frozenColumnCountFromStart && columnIndex < columns.length - frozenColumnCountFromEnd
                    : false;
                return [
                    columnReorderProps &&
                        (_isDraggable || columnIndex === columns.length - frozenColumnCountFromEnd) &&
                        _this._renderDropHint(columnIndex),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__components_DetailsList_DetailsColumn__["a" /* DetailsColumn */], { column: column, key: column.key, columnIndex: (showCheckbox ? 2 : 1) + columnIndex, parentId: _this._id, isDraggable: _isDraggable, updateDragInfo: _this._updateDragInfo, dragDropHelper: _this._dragDropHelper, onColumnClick: onColumnClick, onColumnContextMenu: onColumnContextMenu, 
                        // Do not render tooltips by default, but allow for override via props.
                        onRenderColumnHeaderTooltip: _this.props.onRenderColumnHeaderTooltip, isDropped: _this._onDropIndexInfo.targetIndex === columnIndex, cellStyleProps: _this.props.cellStyleProps, useFastIcons: useFastIcons }),
                    _this._renderColumnDivider(columnIndex)
                ];
            }),
            columnReorderProps && frozenColumnCountFromEnd === 0 && this._renderDropHint(columns.length),
            isSizing && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Layer__["a" /* Layer */], null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.sizingOverlay, onMouseMove: this._onSizerMouseMove, onMouseUp: this._onSizerMouseUp })))));
    };
    /** Set focus to the active thing in the focus area. */
    DetailsHeaderBase.prototype.focus = function () {
        return Boolean(this._rootComponent.current && this._rootComponent.current.focus());
    };
    DetailsHeaderBase.prototype._getHeaderDragDropOptions = function () {
        var options = {
            selectionIndex: 1,
            context: { data: this, index: 0 },
            canDrag: function () { return false; },
            canDrop: function () { return true; },
            onDragStart: function () { return undefined; },
            updateDropState: this._updateDroppingState,
            onDrop: this._onDrop,
            onDragEnd: function () { return undefined; },
            onDragOver: this._onDragOver
        };
        return options;
    };
    DetailsHeaderBase.prototype._isValidCurrentDropHintIndex = function () {
        return this._currentDropHintIndex >= 0;
    };
    /**
     * @returns whether or not the "Select All" checkbox column is hidden.
     */
    DetailsHeaderBase.prototype._isCheckboxColumnHidden = function () {
        var _a = this.props, selectionMode = _a.selectionMode, checkboxVisibility = _a.checkboxVisibility;
        return selectionMode === __WEBPACK_IMPORTED_MODULE_11__utilities_selection_interfaces__["b" /* SelectionMode */].none || checkboxVisibility === __WEBPACK_IMPORTED_MODULE_4__DetailsList_types__["a" /* CheckboxVisibility */].hidden;
    };
    DetailsHeaderBase.prototype._resetDropHints = function () {
        if (this._currentDropHintIndex >= 0) {
            this._updateDropHintElement(this._dropHintDetails[this._currentDropHintIndex].dropHintElementRef, 'none');
            this._currentDropHintIndex = -1;
        }
    };
    DetailsHeaderBase.prototype._updateDropHintElement = function (element, displayProperty) {
        element.childNodes[1].style.display = displayProperty;
        element.childNodes[0].style.display = displayProperty;
    };
    DetailsHeaderBase.prototype._liesBetween = function (target, left, right) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["V" /* getRTL */])() ? target <= left && target >= right : target >= left && target <= right;
    };
    DetailsHeaderBase.prototype._isBefore = function (a, b) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["V" /* getRTL */])() ? a >= b : a <= b;
    };
    DetailsHeaderBase.prototype._isAfter = function (a, b) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["V" /* getRTL */])() ? a <= b : a >= b;
    };
    DetailsHeaderBase.prototype._isEventOnHeader = function (event) {
        if (this._rootElement) {
            var clientRect = this._rootElement.getBoundingClientRect();
            if (event.clientX > clientRect.left &&
                event.clientX < clientRect.right &&
                event.clientY > clientRect.top &&
                event.clientY < clientRect.bottom) {
                return __WEBPACK_IMPORTED_MODULE_4__DetailsList_types__["c" /* ColumnDragEndLocation */].header;
            }
        }
    };
    DetailsHeaderBase.prototype._renderColumnDivider = function (columnIndex) {
        var _a = this.props.columns, columns = _a === void 0 ? NO_COLUMNS : _a;
        var column = columns[columnIndex];
        var onRenderDivider = column.onRenderDivider;
        return onRenderDivider
            ? onRenderDivider({ column: column, columnIndex: columnIndex }, this._renderColumnSizer)
            : this._renderColumnSizer({ column: column, columnIndex: columnIndex });
    };
    DetailsHeaderBase.prototype._renderDropHint = function (dropHintIndex) {
        var classNames = this._classNames;
        var IconComponent = this.props.useFastIcons ? __WEBPACK_IMPORTED_MODULE_6__Icon__["FontIcon"] : __WEBPACK_IMPORTED_MODULE_6__Icon__["Icon"];
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { key: 'dropHintKey', className: classNames.dropHintStyle, id: "columnDropHint_" + dropHintIndex },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](IconComponent, { key: "dropHintCircleKey", "aria-hidden": true, "data-is-focusable": false, "data-sizer-index": dropHintIndex, className: classNames.dropHintCaretStyle, iconName: 'CircleShapeSolid' }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { key: "dropHintLineKey", "aria-hidden": true, "data-is-focusable": false, "data-sizer-index": dropHintIndex, className: classNames.dropHintLineStyle })));
    };
    /**
     * double click on the column sizer will auto ajust column width
     * to fit the longest content among current rendered rows.
     *
     * @param columnIndex - index of the column user double clicked
     * @param ev - mouse double click event
     */
    DetailsHeaderBase.prototype._onSizerDoubleClick = function (columnIndex, ev) {
        var _a = this.props, onColumnAutoResized = _a.onColumnAutoResized, _b = _a.columns, columns = _b === void 0 ? NO_COLUMNS : _b;
        if (onColumnAutoResized) {
            onColumnAutoResized(columns[columnIndex], columnIndex);
        }
    };
    DetailsHeaderBase.prototype._onSelectionChanged = function () {
        var isAllSelected = !!this.props.selection && this.props.selection.isAllSelected();
        if (this.state.isAllSelected !== isAllSelected) {
            this.setState({
                isAllSelected: isAllSelected
            });
        }
    };
    DetailsHeaderBase.defaultProps = {
        selectAllVisibility: __WEBPACK_IMPORTED_MODULE_14__DetailsHeader_types__["a" /* SelectAllVisibility */].visible,
        collapseAllVisibility: __WEBPACK_IMPORTED_MODULE_9__GroupedList__["a" /* CollapseAllVisibility */].visible
    };
    return DetailsHeaderBase;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

function getLegacyColumnReorderProps(columnReorderOptions) {
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, columnReorderOptions, { onColumnDragEnd: undefined });
}
function stopPropagation(ev) {
    ev.stopPropagation();
}
//# sourceMappingURL=DetailsHeader.base.js.map

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FocusZoneTabbableElements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FocusZoneDirection; });
/**
 * {@docCategory FocusZone}
 */
var FocusZoneTabbableElements = {
    /** Tabbing is not allowed */
    none: 0,
    /** All tabbing action is allowed */
    all: 1,
    /** Tabbing is allowed only on input elements */
    inputOnly: 2
};
/**
 * {@docCategory FocusZone}
 */
var FocusZoneDirection;
(function (FocusZoneDirection) {
    /** Only react to up/down arrows. */
    FocusZoneDirection[FocusZoneDirection["vertical"] = 0] = "vertical";
    /** Only react to left/right arrows. */
    FocusZoneDirection[FocusZoneDirection["horizontal"] = 1] = "horizontal";
    /** React to all arrows. */
    FocusZoneDirection[FocusZoneDirection["bidirectional"] = 2] = "bidirectional";
})(FocusZoneDirection || (FocusZoneDirection = {}));
//# sourceMappingURL=FocusZone.types.js.map

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__(1691);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon_base__ = __webpack_require__(672);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__Icon_base__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Icon_types__ = __webpack_require__(673);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__Icon_types__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FontIcon__ = __webpack_require__(675);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__FontIcon__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__FontIcon__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_3__FontIcon__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ImageIcon__ = __webpack_require__(1693);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__ImageIcon__["a"]; });





//# sourceMappingURL=index.js.map

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IconBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Icon_types__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Image_Image__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Image_Image_types__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FontIcon__ = __webpack_require__(675);







var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["r" /* classNamesFunction */])({
    disableCaching: true
});
var IconBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](IconBase, _super);
    function IconBase(props) {
        var _this = _super.call(this, props) || this;
        _this.onImageLoadingStateChange = function (state) {
            if (_this.props.imageProps && _this.props.imageProps.onLoadingStateChange) {
                _this.props.imageProps.onLoadingStateChange(state);
            }
            if (state === __WEBPACK_IMPORTED_MODULE_4__Image_Image_types__["c" /* ImageLoadState */].error) {
                _this.setState({ imageLoadError: true });
            }
        };
        _this.state = {
            imageLoadError: false
        };
        return _this;
    }
    IconBase.prototype.render = function () {
        var _a = this.props, className = _a.className, styles = _a.styles, iconName = _a.iconName, imageErrorAs = _a.imageErrorAs, theme = _a.theme;
        var isPlaceholder = typeof iconName === 'string' && iconName.length === 0;
        var isImage = this.props.iconType === __WEBPACK_IMPORTED_MODULE_2__Icon_types__["a" /* IconType */].image || this.props.iconType === __WEBPACK_IMPORTED_MODULE_2__Icon_types__["a" /* IconType */].Image || !!this.props.imageProps;
        var _b = Object(__WEBPACK_IMPORTED_MODULE_6__FontIcon__["c" /* getIconContent */])(iconName), iconClassName = _b.iconClassName, children = _b.children;
        var classNames = getClassNames(styles, {
            theme: theme,
            className: className,
            iconClassName: iconClassName,
            isImage: isImage,
            isPlaceholder: isPlaceholder
        });
        var RootType = isImage ? 'div' : 'i';
        var nativeProps = Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["R" /* getNativeProps */])(this.props, __WEBPACK_IMPORTED_MODULE_5__Utilities__["_3" /* htmlElementProperties */], ['aria-label']);
        var imageLoadError = this.state.imageLoadError;
        var imageProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this.props.imageProps, { onLoadingStateChange: this.onImageLoadingStateChange });
        var ImageType = (imageLoadError && imageErrorAs) || __WEBPACK_IMPORTED_MODULE_3__Image_Image__["a" /* Image */];
        var ariaLabel = this.props.ariaLabel || this.props['aria-label'];
        var containerProps = ariaLabel
            ? {
                'aria-label': ariaLabel
            }
            : {
                role: 'presentation',
                'aria-hidden': imageProps.alt || imageProps['aria-labelledby'] ? false : true
            };
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](RootType, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ "data-icon-name": iconName }, containerProps, nativeProps, { className: classNames.root }), isImage ? __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ImageType, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, imageProps)) : children));
    };
    return IconBase;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=Icon.base.js.map

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IconType; });
/**
 * @deprecated Icon type is inferred based on presence of `IIconProps.imageProps`
 */
var IconType;
(function (IconType) {
    /**
     * Render using the fabric icon font.
     * @deprecated Icon type is inferred based on presence of `IIconProps.imageProps`
     */
    IconType[IconType["default"] = 0] = "default";
    /**
     * Render using an image, where imageProps would be used.
     * @deprecated Icon type is inferred based on presence of `IIconProps.imageProps`
     */
    IconType[IconType["image"] = 1] = "image";
    /**
     * Deprecated, use `default`.
     * @deprecated Use `default`.
     */
    IconType[IconType["Default"] = 100000] = "Default";
    /**
     * Deprecated, use `image`.
     * @deprecated Use `image`.
     */
    IconType[IconType["Image"] = 100001] = "Image";
})(IconType || (IconType = {}));
//# sourceMappingURL=Icon.types.js.map

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Image_types__ = __webpack_require__(398);




var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var KEY_PREFIX = 'fabricImage';
var ImageBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ImageBase, _super);
    function ImageBase(props) {
        var _this = _super.call(this, props) || this;
        // Make an initial assumption about the image layout until we can
        // check the rendered element. The value here only takes effect when
        // shouldStartVisible is true.
        _this._coverStyle = __WEBPACK_IMPORTED_MODULE_3__Image_types__["a" /* ImageCoverStyle */].portrait;
        _this._imageElement = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._frameElement = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._onImageLoaded = function (ev) {
            var _a = _this.props, src = _a.src, onLoad = _a.onLoad;
            if (onLoad) {
                onLoad(ev);
            }
            _this._computeCoverStyle(_this.props);
            if (src) {
                _this.setState({
                    loadState: __WEBPACK_IMPORTED_MODULE_3__Image_types__["c" /* ImageLoadState */].loaded
                });
            }
        };
        _this._onImageError = function (ev) {
            if (_this.props.onError) {
                _this.props.onError(ev);
            }
            _this.setState({
                loadState: __WEBPACK_IMPORTED_MODULE_3__Image_types__["c" /* ImageLoadState */].error
            });
        };
        _this.state = {
            loadState: __WEBPACK_IMPORTED_MODULE_3__Image_types__["c" /* ImageLoadState */].notLoaded
        };
        return _this;
    }
    ImageBase.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.src !== this.props.src) {
            this.setState({
                loadState: __WEBPACK_IMPORTED_MODULE_3__Image_types__["c" /* ImageLoadState */].notLoaded
            });
        }
        else if (this.state.loadState === __WEBPACK_IMPORTED_MODULE_3__Image_types__["c" /* ImageLoadState */].loaded) {
            this._computeCoverStyle(nextProps);
        }
    };
    ImageBase.prototype.componentDidUpdate = function (prevProps, prevState) {
        this._checkImageLoaded();
        if (this.props.onLoadingStateChange && prevState.loadState !== this.state.loadState) {
            this.props.onLoadingStateChange(this.state.loadState);
        }
    };
    ImageBase.prototype.render = function () {
        var imageProps = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["R" /* getNativeProps */])(this.props, __WEBPACK_IMPORTED_MODULE_2__Utilities__["_4" /* imageProperties */], ['width', 'height']);
        var _a = this.props, src = _a.src, alt = _a.alt, width = _a.width, height = _a.height, shouldFadeIn = _a.shouldFadeIn, shouldStartVisible = _a.shouldStartVisible, className = _a.className, imageFit = _a.imageFit, role = _a.role, maximizeFrame = _a.maximizeFrame, styles = _a.styles, theme = _a.theme;
        var loadState = this.state.loadState;
        var coverStyle = this.props.coverStyle !== undefined ? this.props.coverStyle : this._coverStyle;
        var classNames = getClassNames(styles, {
            theme: theme,
            className: className,
            width: width,
            height: height,
            maximizeFrame: maximizeFrame,
            shouldFadeIn: shouldFadeIn,
            shouldStartVisible: shouldStartVisible,
            isLoaded: loadState === __WEBPACK_IMPORTED_MODULE_3__Image_types__["c" /* ImageLoadState */].loaded || (loadState === __WEBPACK_IMPORTED_MODULE_3__Image_types__["c" /* ImageLoadState */].notLoaded && this.props.shouldStartVisible),
            isLandscape: coverStyle === __WEBPACK_IMPORTED_MODULE_3__Image_types__["a" /* ImageCoverStyle */].landscape,
            isCenter: imageFit === __WEBPACK_IMPORTED_MODULE_3__Image_types__["b" /* ImageFit */].center,
            isCenterContain: imageFit === __WEBPACK_IMPORTED_MODULE_3__Image_types__["b" /* ImageFit */].centerContain,
            isCenterCover: imageFit === __WEBPACK_IMPORTED_MODULE_3__Image_types__["b" /* ImageFit */].centerCover,
            isContain: imageFit === __WEBPACK_IMPORTED_MODULE_3__Image_types__["b" /* ImageFit */].contain,
            isCover: imageFit === __WEBPACK_IMPORTED_MODULE_3__Image_types__["b" /* ImageFit */].cover,
            isNone: imageFit === __WEBPACK_IMPORTED_MODULE_3__Image_types__["b" /* ImageFit */].none,
            isError: loadState === __WEBPACK_IMPORTED_MODULE_3__Image_types__["c" /* ImageLoadState */].error,
            isNotImageFit: imageFit === undefined
        });
        // If image dimensions aren't specified, the natural size of the image is used.
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.root, style: { width: width, height: height }, ref: this._frameElement },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("img", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, imageProps, { onLoad: this._onImageLoaded, onError: this._onImageError, key: KEY_PREFIX + this.props.src || '', className: classNames.image, ref: this._imageElement, src: src, alt: alt, role: role }))));
    };
    ImageBase.prototype._checkImageLoaded = function () {
        var src = this.props.src;
        var loadState = this.state.loadState;
        if (loadState === __WEBPACK_IMPORTED_MODULE_3__Image_types__["c" /* ImageLoadState */].notLoaded) {
            // testing if naturalWidth and naturalHeight are greater than zero is better than checking
            // .complete, because .complete will also be set to true if the image breaks. However,
            // for some browsers, SVG images do not have a naturalWidth or naturalHeight, so fall back
            // to checking .complete for these images.
            var isLoaded = this._imageElement.current
                ? (src && (this._imageElement.current.naturalWidth > 0 && this._imageElement.current.naturalHeight > 0)) ||
                    (this._imageElement.current.complete && ImageBase._svgRegex.test(src))
                : false;
            if (isLoaded) {
                this._computeCoverStyle(this.props);
                this.setState({
                    loadState: __WEBPACK_IMPORTED_MODULE_3__Image_types__["c" /* ImageLoadState */].loaded
                });
            }
        }
    };
    ImageBase.prototype._computeCoverStyle = function (props) {
        var imageFit = props.imageFit, width = props.width, height = props.height;
        // Do not compute cover style if it was already specified in props
        if ((imageFit === __WEBPACK_IMPORTED_MODULE_3__Image_types__["b" /* ImageFit */].cover ||
            imageFit === __WEBPACK_IMPORTED_MODULE_3__Image_types__["b" /* ImageFit */].contain ||
            imageFit === __WEBPACK_IMPORTED_MODULE_3__Image_types__["b" /* ImageFit */].centerContain ||
            imageFit === __WEBPACK_IMPORTED_MODULE_3__Image_types__["b" /* ImageFit */].centerCover) &&
            this.props.coverStyle === undefined &&
            this._imageElement.current &&
            this._frameElement.current) {
            // Determine the desired ratio using the width and height props.
            // If those props aren't available, measure measure the frame.
            var desiredRatio = void 0;
            if (!!width && !!height && imageFit !== __WEBPACK_IMPORTED_MODULE_3__Image_types__["b" /* ImageFit */].centerContain && imageFit !== __WEBPACK_IMPORTED_MODULE_3__Image_types__["b" /* ImageFit */].centerCover) {
                desiredRatio = width / height;
            }
            else {
                desiredRatio = this._frameElement.current.clientWidth / this._frameElement.current.clientHeight;
            }
            // Examine the source image to determine its original ratio.
            var naturalRatio = this._imageElement.current.naturalWidth / this._imageElement.current.naturalHeight;
            // Should we crop from the top or the sides?
            if (naturalRatio > desiredRatio) {
                this._coverStyle = __WEBPACK_IMPORTED_MODULE_3__Image_types__["a" /* ImageCoverStyle */].landscape;
            }
            else {
                this._coverStyle = __WEBPACK_IMPORTED_MODULE_3__Image_types__["a" /* ImageCoverStyle */].portrait;
            }
        }
    };
    ImageBase.defaultProps = {
        shouldFadeIn: true
    };
    ImageBase._svgRegex = /\.svg$/i;
    return ImageBase;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=Image.base.js.map

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getIconContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FontIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFontIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Icon_styles__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Styling__ = __webpack_require__(5);





var getIconContent = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_15" /* memoizeFunction */])(function (iconName) {
    var iconDefinition = Object(__WEBPACK_IMPORTED_MODULE_4__Styling__["x" /* getIcon */])(iconName) || {
        subset: {
            className: undefined
        },
        code: undefined
    };
    return {
        children: iconDefinition.code,
        iconClassName: iconDefinition.subset.className
    };
});
/**
 * Fast icon component which only supports font glyphs (not images) and isn't themeable.
 * To style the icon, use `className` or reference `ms-Icon` in CSS.
 */
var FontIcon = function (props) {
    var iconName = props.iconName, className = props.className;
    var _a = getIconContent(iconName), iconClassName = _a.iconClassName, children = _a.children;
    var nativeProps = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["R" /* getNativeProps */])(props, __WEBPACK_IMPORTED_MODULE_3__Utilities__["_3" /* htmlElementProperties */]);
    var containerProps = props['aria-label']
        ? {}
        : {
            role: 'presentation',
            'aria-hidden': true
        };
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("i", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ "data-icon-name": iconName }, containerProps, nativeProps, { className: Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["t" /* css */])(__WEBPACK_IMPORTED_MODULE_2__Icon_styles__["a" /* MS_ICON */], __WEBPACK_IMPORTED_MODULE_2__Icon_styles__["b" /* classNames */].root, iconClassName, !iconName && __WEBPACK_IMPORTED_MODULE_2__Icon_styles__["b" /* classNames */].placeholder, className) }), children));
};
/**
 * Memoized helper for rendering a FontIcon.
 * @param iconName - The name of the icon to use from the icon font.
 * @param className - Class name for styling the icon.
 * @param ariaLabel - Label for the icon for the benefit of screen readers.
 */
var getFontIcon = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_15" /* memoizeFunction */])(function (iconName, className, ariaLabel) {
    return FontIcon({ iconName: iconName, className: className, 'aria-label': ariaLabel });
});
//# sourceMappingURL=FontIcon.js.map

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LayerBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Fabric__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Layer_notification__ = __webpack_require__(679);






var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_4__Utilities__["r" /* classNamesFunction */])();
var LayerBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](LayerBase, _super);
    function LayerBase(props) {
        var _this = _super.call(this, props) || this;
        _this._rootRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._createLayerElement = function () {
            var hostId = _this.props.hostId;
            var doc = Object(__WEBPACK_IMPORTED_MODULE_4__Utilities__["I" /* getDocument */])(_this._rootRef.current);
            var host = _this._getHost();
            if (!doc || !host) {
                return;
            }
            // If one was already existing, remove.
            _this._removeLayerElement();
            var layerElement = doc.createElement('div');
            var classNames = _this._getClassNames();
            layerElement.className = classNames.root;
            Object(__WEBPACK_IMPORTED_MODULE_4__Utilities__["_25" /* setPortalAttribute */])(layerElement);
            Object(__WEBPACK_IMPORTED_MODULE_4__Utilities__["_26" /* setVirtualParent */])(layerElement, _this._rootRef.current);
            _this.props.insertFirst ? host.insertBefore(layerElement, host.firstChild) : host.appendChild(layerElement);
            _this.setState({
                hostId: hostId,
                layerElement: layerElement
            }, function () {
                var _a = _this.props, onLayerDidMount = _a.onLayerDidMount, onLayerMounted = _a.onLayerMounted;
                if (onLayerMounted) {
                    onLayerMounted();
                }
                if (onLayerDidMount) {
                    onLayerDidMount();
                }
            });
        };
        _this.state = {};
        if (false) {
            warnDeprecations('Layer', props, {
                onLayerMounted: 'onLayerDidMount'
            });
        }
        return _this;
    }
    LayerBase.prototype.componentDidMount = function () {
        var hostId = this.props.hostId;
        this._createLayerElement();
        if (hostId) {
            Object(__WEBPACK_IMPORTED_MODULE_5__Layer_notification__["c" /* registerLayer */])(hostId, this._createLayerElement);
        }
    };
    LayerBase.prototype.render = function () {
        var layerElement = this.state.layerElement;
        var classNames = this._getClassNames();
        var eventBubblingEnabled = this.props.eventBubblingEnabled;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "ms-layer", ref: this._rootRef }, layerElement &&
            __WEBPACK_IMPORTED_MODULE_2_react_dom__["createPortal"](__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Fabric__["a" /* Fabric */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, (!eventBubblingEnabled && _getFilteredEvents()), { className: classNames.content }), this.props.children), layerElement)));
    };
    LayerBase.prototype.componentDidUpdate = function () {
        if (this.props.hostId !== this.state.hostId) {
            this._createLayerElement();
        }
    };
    LayerBase.prototype.componentWillUnmount = function () {
        var hostId = this.props.hostId;
        this._removeLayerElement();
        if (hostId) {
            Object(__WEBPACK_IMPORTED_MODULE_5__Layer_notification__["d" /* unregisterLayer */])(hostId, this._createLayerElement);
        }
    };
    LayerBase.prototype._removeLayerElement = function () {
        var onLayerWillUnmount = this.props.onLayerWillUnmount;
        var layerElement = this.state.layerElement;
        if (onLayerWillUnmount) {
            onLayerWillUnmount();
        }
        if (layerElement && layerElement.parentNode) {
            var parentNode = layerElement.parentNode;
            if (parentNode) {
                parentNode.removeChild(layerElement);
            }
        }
    };
    LayerBase.prototype._getClassNames = function () {
        var _a = this.props, className = _a.className, styles = _a.styles, theme = _a.theme;
        var classNames = getClassNames(styles, {
            theme: theme,
            className: className,
            isNotHost: !this.props.hostId
        });
        return classNames;
    };
    LayerBase.prototype._getHost = function () {
        var hostId = this.props.hostId;
        var doc = Object(__WEBPACK_IMPORTED_MODULE_4__Utilities__["I" /* getDocument */])(this._rootRef.current);
        if (!doc) {
            return undefined;
        }
        if (hostId) {
            return doc.getElementById(hostId);
        }
        else {
            var defaultHostSelector = Object(__WEBPACK_IMPORTED_MODULE_5__Layer_notification__["a" /* getDefaultTarget */])();
            return defaultHostSelector ? doc.querySelector(defaultHostSelector) : doc.body;
        }
    };
    LayerBase.defaultProps = {
        onLayerDidMount: function () { return undefined; },
        onLayerWillUnmount: function () { return undefined; }
    };
    LayerBase = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_4__Utilities__["u" /* customizable */])('Layer', ['theme', 'hostId'])
    ], LayerBase);
    return LayerBase;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

var _onFilterEvent = function (ev) {
    // We should just be able to check ev.bubble here and only stop events that are bubbling up. However, even though mouseenter and
    //    mouseleave do NOT bubble up, they are showing up as bubbling. Therefore we stop events based on event name rather than ev.bubble.
    if (ev.eventPhase === Event.BUBBLING_PHASE && ev.type !== 'mouseenter' && ev.type !== 'mouseleave') {
        ev.stopPropagation();
    }
};
var _filteredEventProps;
function _getFilteredEvents() {
    if (!_filteredEventProps) {
        _filteredEventProps = {};
        [
            'onClick',
            'onContextMenu',
            'onDoubleClick',
            'onDrag',
            'onDragEnd',
            'onDragEnter',
            'onDragExit',
            'onDragLeave',
            'onDragOver',
            'onDragStart',
            'onDrop',
            'onMouseDown',
            'onMouseEnter',
            'onMouseLeave',
            'onMouseMove',
            'onMouseOver',
            'onMouseOut',
            'onMouseUp',
            'onKeyDown',
            'onKeyPress',
            'onKeyUp',
            'onFocus',
            'onBlur',
            'onChange',
            'onInput',
            'onInvalid',
            'onSubmit'
        ].forEach(function (name) { return (_filteredEventProps[name] = _onFilterEvent); });
    }
    return _filteredEventProps;
}
//# sourceMappingURL=Layer.base.js.map

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FabricBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Fabric_styles__ = __webpack_require__(678);




var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var FabricBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](FabricBase, _super);
    function FabricBase(props) {
        var _this = _super.call(this, props) || this;
        _this._rootElement = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._disposables = [];
        _this._onMouseDown = function (ev) {
            _this.setState({ isFocusVisible: false });
        };
        _this._onKeyDown = function (ev) {
            if (Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_8" /* isDirectionalKeyCode */])(ev.which)) {
                _this.setState({ isFocusVisible: true });
            }
        };
        _this.state = { isFocusVisible: false };
        return _this;
    }
    FabricBase.prototype.render = function () {
        var _a = this.props, className = _a.className, rest = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __rest */](_a, ["className"]);
        var classNames = getClassNames(__WEBPACK_IMPORTED_MODULE_3__Fabric_styles__["a" /* getStyles */], {
            theme: this.props.theme,
            className: className,
            isFocusVisible: this.state.isFocusVisible
        });
        var divProps = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["R" /* getNativeProps */])(rest, __WEBPACK_IMPORTED_MODULE_2__Utilities__["w" /* divProperties */]);
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, divProps, { className: classNames.root, ref: this._rootElement }));
    };
    FabricBase.prototype.componentDidMount = function () {
        var win = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["Z" /* getWindow */])(this._rootElement.current);
        if (win) {
            this._disposables.push(Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_18" /* on */])(win, 'mousedown', this._onMouseDown, true), Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_18" /* on */])(win, 'keydown', this._onKeyDown, true));
        }
    };
    FabricBase.prototype.componentWillUnmount = function () {
        this._disposables.forEach(function (dispose) { return dispose(); });
    };
    return FabricBase;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=Fabric.base.js.map

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var inheritFont = { fontFamily: 'inherit' };
var GlobalClassNames = {
    root: 'ms-Fabric'
};
var getStyles = function (props) {
    var theme = props.theme, className = props.className, isFocusVisible = props.isFocusVisible;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            isFocusVisible && 'is-focusVisible ms-Fabric--isFocusVisible',
            theme.fonts.medium,
            {
                color: theme.palette.neutralPrimary,
                selectors: {
                    '& button': inheritFont,
                    '& input': inheritFont,
                    '& textarea': inheritFont
                }
            },
            className
        ]
    };
};
//# sourceMappingURL=Fabric.styles.js.map

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = registerLayer;
/* harmony export (immutable) */ __webpack_exports__["d"] = unregisterLayer;
/* harmony export (immutable) */ __webpack_exports__["b"] = notifyHostChanged;
/* unused harmony export setDefaultTarget */
/* harmony export (immutable) */ __webpack_exports__["a"] = getDefaultTarget;
var _layersByHostId = {};
var _defaultHostSelector;
/**
 * Register a layer for a given host id
 * @param hostId Id of the layer host
 * @param layer Layer instance
 */
function registerLayer(hostId, callback) {
    if (!_layersByHostId[hostId]) {
        _layersByHostId[hostId] = [];
    }
    _layersByHostId[hostId].push(callback);
}
/**
 * Unregister a layer for a given host id
 * @param hostId Id of the layer host
 * @param layer Layer instance
 */
function unregisterLayer(hostId, callback) {
    if (_layersByHostId[hostId]) {
        var idx = _layersByHostId[hostId].indexOf(callback);
        if (idx >= 0) {
            _layersByHostId[hostId].splice(idx, 1);
            if (_layersByHostId[hostId].length === 0) {
                delete _layersByHostId[hostId];
            }
        }
    }
}
/**
 * Used for notifying applicable Layers that a host is available/unavailable and to re-evaluate Layers that
 * care about the specific host.
 */
function notifyHostChanged(id) {
    if (_layersByHostId[id]) {
        _layersByHostId[id].forEach(function (callback) { return callback(); });
    }
}
/**
 * Sets the default target selector to use when determining the host in which
 * Layered content will be injected into. If not provided, an element will be
 * created at the end of the document body.
 *
 * Passing in a falsey value will clear the default target and reset back to
 * using a created element at the end of document body.
 */
function setDefaultTarget(selector) {
    _defaultHostSelector = selector;
}
/**
 * Get the default target selector when determining a host
 */
function getDefaultTarget() {
    return _defaultHostSelector;
}
//# sourceMappingURL=Layer.notification.js.map

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GroupedListBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GroupedListSection__ = __webpack_require__(1703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__List__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_selection_index__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DetailsList_DetailsRow_styles__ = __webpack_require__(99);







var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var ROW_HEIGHT = __WEBPACK_IMPORTED_MODULE_6__DetailsList_DetailsRow_styles__["b" /* DEFAULT_ROW_HEIGHTS */].rowHeight, COMPACT_ROW_HEIGHT = __WEBPACK_IMPORTED_MODULE_6__DetailsList_DetailsRow_styles__["b" /* DEFAULT_ROW_HEIGHTS */].compactRowHeight;
var GroupedListBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](GroupedListBase, _super);
    function GroupedListBase(props) {
        var _this = _super.call(this, props) || this;
        _this._list = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._renderGroup = function (group, groupIndex) {
            var _a = _this.props, dragDropEvents = _a.dragDropEvents, dragDropHelper = _a.dragDropHelper, eventsToRegister = _a.eventsToRegister, groupProps = _a.groupProps, items = _a.items, listProps = _a.listProps, onRenderCell = _a.onRenderCell, selectionMode = _a.selectionMode, selection = _a.selection, viewport = _a.viewport, onShouldVirtualize = _a.onShouldVirtualize, groups = _a.groups, compact = _a.compact;
            // override group header/footer props as needed
            var dividerProps = {
                onToggleSelectGroup: _this._onToggleSelectGroup,
                onToggleCollapse: _this._onToggleCollapse,
                onToggleSummarize: _this._onToggleSummarize
            };
            var headerProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, groupProps.headerProps, dividerProps);
            var showAllProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, groupProps.showAllProps, dividerProps);
            var footerProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, groupProps.footerProps, dividerProps);
            var groupNestingDepth = _this._getGroupNestingDepth();
            if (!groupProps.showEmptyGroups && group && group.count === 0) {
                return null;
            }
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__GroupedListSection__["a" /* GroupedListSection */], { ref: 'group_' + groupIndex, key: _this._getGroupKey(group, groupIndex), dragDropEvents: dragDropEvents, dragDropHelper: dragDropHelper, eventsToRegister: eventsToRegister, footerProps: footerProps, getGroupItemLimit: groupProps && groupProps.getGroupItemLimit, group: group, groupIndex: groupIndex, groupNestingDepth: groupNestingDepth, groupProps: groupProps, headerProps: headerProps, listProps: listProps, items: items, onRenderCell: onRenderCell, onRenderGroupHeader: groupProps.onRenderHeader, onRenderGroupShowAll: groupProps.onRenderShowAll, onRenderGroupFooter: groupProps.onRenderFooter, selectionMode: selectionMode, selection: selection, showAllProps: showAllProps, viewport: viewport, onShouldVirtualize: onShouldVirtualize, groupedListClassNames: _this._classNames, groups: groups, compact: compact }));
        };
        _this._getDefaultGroupItemLimit = function (group) {
            return group.count;
        };
        _this._getGroupItemLimit = function (group) {
            var groupProps = _this.props.groupProps;
            var getGroupItemLimit = groupProps && groupProps.getGroupItemLimit ? groupProps.getGroupItemLimit : _this._getDefaultGroupItemLimit;
            return getGroupItemLimit(group);
        };
        _this._getGroupHeight = function (group) {
            var rowHeight = _this.props.compact ? COMPACT_ROW_HEIGHT : ROW_HEIGHT;
            return rowHeight + (group.isCollapsed ? 0 : rowHeight * _this._getGroupItemLimit(group));
        };
        _this._getPageHeight = function (itemIndex) {
            var groups = _this.state.groups;
            var _a = _this.props.getGroupHeight, getGroupHeight = _a === void 0 ? _this._getGroupHeight : _a;
            var pageGroup = groups && groups[itemIndex];
            if (pageGroup) {
                return getGroupHeight(pageGroup, itemIndex);
            }
            else {
                return 0;
            }
        };
        _this._onToggleCollapse = function (group) {
            var groupProps = _this.props.groupProps;
            var onToggleCollapse = groupProps && groupProps.headerProps && groupProps.headerProps.onToggleCollapse;
            if (group) {
                if (onToggleCollapse) {
                    onToggleCollapse(group);
                }
                group.isCollapsed = !group.isCollapsed;
                _this._updateIsSomeGroupExpanded();
                _this.forceUpdate();
            }
        };
        _this._onToggleSelectGroup = function (group) {
            if (group) {
                _this.props.selection.toggleRangeSelected(group.startIndex, group.count);
            }
        };
        _this._onToggleSummarize = function (group) {
            var groupProps = _this.props.groupProps;
            var onToggleSummarize = groupProps && groupProps.showAllProps && groupProps.showAllProps.onToggleSummarize;
            if (onToggleSummarize) {
                onToggleSummarize(group);
            }
            else {
                if (group) {
                    group.isShowingAll = !group.isShowingAll;
                }
                _this.forceUpdate();
            }
        };
        _this._getPageSpecification = function (itemIndex) {
            var groups = _this.state.groups;
            var pageGroup = groups && groups[itemIndex];
            return {
                key: pageGroup && pageGroup.key
            };
        };
        _this._isSomeGroupExpanded = _this._computeIsSomeGroupExpanded(props.groups);
        _this.state = {
            lastWidth: 0,
            groups: props.groups
        };
        return _this;
    }
    GroupedListBase.prototype.scrollToIndex = function (index, measureItem, scrollToMode) {
        if (this._list.current) {
            this._list.current.scrollToIndex(index, measureItem, scrollToMode);
        }
    };
    GroupedListBase.prototype.getStartItemIndexInView = function () {
        return this._list.current.getStartItemIndexInView() || 0;
    };
    GroupedListBase.prototype.componentWillReceiveProps = function (newProps) {
        var _a = this.props, groups = _a.groups, selectionMode = _a.selectionMode, compact = _a.compact;
        var shouldForceUpdates = false;
        if (newProps.groups !== groups) {
            this.setState({ groups: newProps.groups });
            shouldForceUpdates = true;
        }
        if (newProps.selectionMode !== selectionMode || newProps.compact !== compact) {
            shouldForceUpdates = true;
        }
        if (shouldForceUpdates) {
            this._forceListUpdates();
        }
    };
    GroupedListBase.prototype.componentDidMount = function () {
        var _a = this.props, groupProps = _a.groupProps, _b = _a.groups, groups = _b === void 0 ? [] : _b;
        if (groupProps && groupProps.isAllGroupsCollapsed) {
            this._setGroupsCollapsedState(groups, groupProps.isAllGroupsCollapsed);
        }
    };
    GroupedListBase.prototype.render = function () {
        var _a = this.props, className = _a.className, usePageCache = _a.usePageCache, onShouldVirtualize = _a.onShouldVirtualize, theme = _a.theme, styles = _a.styles, compact = _a.compact, _b = _a.listProps, listProps = _b === void 0 ? {} : _b;
        var groups = this.state.groups;
        this._classNames = getClassNames(styles, {
            theme: theme,
            className: className,
            compact: compact
        });
        var version = listProps.version;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.root, "data-automationid": "GroupedList", "data-is-scrollable": "false", role: "presentation" }, !groups ? (this._renderGroup(undefined, 0)) : (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__List__["a" /* List */], { ref: this._list, role: "presentation", items: groups, onRenderCell: this._renderGroup, getItemCountForPage: this._returnOne, getPageHeight: this._getPageHeight, getPageSpecification: this._getPageSpecification, usePageCache: usePageCache, onShouldVirtualize: onShouldVirtualize, version: version }))));
    };
    GroupedListBase.prototype.forceUpdate = function () {
        _super.prototype.forceUpdate.call(this);
        this._forceListUpdates();
    };
    GroupedListBase.prototype.toggleCollapseAll = function (allCollapsed) {
        var _a = this.state.groups, groups = _a === void 0 ? [] : _a;
        var groupProps = this.props.groupProps;
        var onToggleCollapseAll = groupProps && groupProps.onToggleCollapseAll;
        if (groups.length > 0) {
            if (onToggleCollapseAll) {
                onToggleCollapseAll(allCollapsed);
            }
            this._setGroupsCollapsedState(groups, allCollapsed);
            this._updateIsSomeGroupExpanded();
            this.forceUpdate();
        }
    };
    GroupedListBase.prototype._setGroupsCollapsedState = function (groups, isCollapsed) {
        for (var groupIndex = 0; groupIndex < groups.length; groupIndex++) {
            groups[groupIndex].isCollapsed = isCollapsed;
        }
    };
    GroupedListBase.prototype._returnOne = function () {
        return 1;
    };
    GroupedListBase.prototype._getGroupKey = function (group, index) {
        return 'group-' + (group && group.key ? group.key : String(index));
    };
    GroupedListBase.prototype._getGroupNestingDepth = function () {
        var groups = this.state.groups;
        var level = 0;
        var groupsInLevel = groups;
        while (groupsInLevel && groupsInLevel.length > 0) {
            level++;
            groupsInLevel = groupsInLevel[0].children;
        }
        return level;
    };
    GroupedListBase.prototype._forceListUpdates = function (groups) {
        groups = groups || this.state.groups;
        var groupCount = groups ? groups.length : 1;
        if (this._list.current) {
            this._list.current.forceUpdate();
            for (var i = 0; i < groupCount; i++) {
                var group = this._list.current.refs['group_' + String(i)];
                if (group) {
                    group.forceListUpdate();
                }
            }
        }
        else {
            var group = this.refs['group_' + String(0)];
            if (group) {
                group.forceListUpdate();
            }
        }
    };
    GroupedListBase.prototype._computeIsSomeGroupExpanded = function (groups) {
        var _this = this;
        return !!(groups && groups.some(function (group) { return (group.children ? _this._computeIsSomeGroupExpanded(group.children) : !group.isCollapsed); }));
    };
    GroupedListBase.prototype._updateIsSomeGroupExpanded = function () {
        var groups = this.state.groups;
        var onGroupExpandStateChanged = this.props.onGroupExpandStateChanged;
        var newIsSomeGroupExpanded = this._computeIsSomeGroupExpanded(groups);
        if (this._isSomeGroupExpanded !== newIsSomeGroupExpanded) {
            if (onGroupExpandStateChanged) {
                onGroupExpandStateChanged(newIsSomeGroupExpanded);
            }
            this._isSomeGroupExpanded = newIsSomeGroupExpanded;
        }
    };
    GroupedListBase.defaultProps = {
        selectionMode: __WEBPACK_IMPORTED_MODULE_5__utilities_selection_index__["c" /* SelectionMode */].multiple,
        isHeaderVisible: true,
        groupProps: {},
        compact: false
    };
    return GroupedListBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=GroupedList.base.js.map

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GroupHeader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GroupHeader_styles__ = __webpack_require__(1704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GroupHeader_base__ = __webpack_require__(1705);



var GroupHeader = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_2__GroupHeader_base__["a" /* GroupHeaderBase */], __WEBPACK_IMPORTED_MODULE_1__GroupHeader_styles__["a" /* getStyles */], undefined, {
    scope: 'GroupHeader'
});
//# sourceMappingURL=GroupHeader.js.map

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CheckBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);



var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var CheckBase = function (props) {
    var _a = props.checked, checked = _a === void 0 ? false : _a, className = props.className, theme = props.theme, styles = props.styles, useFastIcons = props.useFastIcons;
    var classNames = getClassNames(styles, { theme: theme, className: className, checked: checked, useGlobalCheckHostClass: useFastIcons });
    var IconComponent = useFastIcons ? __WEBPACK_IMPORTED_MODULE_1__Icon__["FontIcon"] : __WEBPACK_IMPORTED_MODULE_1__Icon__["Icon"];
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames.root },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](IconComponent, { iconName: "CircleRing", className: classNames.circle }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](IconComponent, { iconName: "StatusCircleCheckmark", className: classNames.check })));
};
//# sourceMappingURL=Check.base.js.map

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SpinnerBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Spinner_types__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utilities__ = __webpack_require__(1);




var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["r" /* classNamesFunction */])();
var SpinnerBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](SpinnerBase, _super);
    function SpinnerBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SpinnerBase.prototype.render = function () {
        var _a = this.props, type = _a.type, size = _a.size, ariaLabel = _a.ariaLabel, ariaLive = _a.ariaLive, styles = _a.styles, label = _a.label, theme = _a.theme, className = _a.className, labelPosition = _a.labelPosition;
        var statusMessage = ariaLabel;
        var nativeProps = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["R" /* getNativeProps */])(this.props, __WEBPACK_IMPORTED_MODULE_3__Utilities__["w" /* divProperties */], ['size']);
        // SpinnerType is deprecated. If someone is still using this property, rather than putting the SpinnerType into the ISpinnerStyleProps,
        // we'll map SpinnerType to its equivalent SpinnerSize and pass that in. Once SpinnerType finally goes away we should delete this.
        var styleSize = size;
        if (styleSize === undefined && type !== undefined) {
            styleSize = type === __WEBPACK_IMPORTED_MODULE_2__Spinner_types__["b" /* SpinnerType */].large ? __WEBPACK_IMPORTED_MODULE_2__Spinner_types__["a" /* SpinnerSize */].large : __WEBPACK_IMPORTED_MODULE_2__Spinner_types__["a" /* SpinnerSize */].medium;
        }
        var classNames = getClassNames(styles, {
            theme: theme,
            size: styleSize,
            className: className,
            labelPosition: labelPosition
        });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, nativeProps, { className: classNames.root }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.circle }),
            label && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.label }, label),
            statusMessage && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { role: "status", "aria-live": ariaLive },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Utilities__["d" /* DelayedRender */], null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.screenReaderText }, statusMessage))))));
    };
    SpinnerBase.defaultProps = {
        size: __WEBPACK_IMPORTED_MODULE_2__Spinner_types__["a" /* SpinnerSize */].medium,
        ariaLive: 'polite',
        labelPosition: 'bottom'
    };
    return SpinnerBase;
}(__WEBPACK_IMPORTED_MODULE_3__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=Spinner.base.js.map

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GroupShowAll; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GroupShowAll_styles__ = __webpack_require__(1711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GroupShowAll_base__ = __webpack_require__(1712);



var GroupShowAll = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_2__GroupShowAll_base__["a" /* GroupShowAllBase */], __WEBPACK_IMPORTED_MODULE_1__GroupShowAll_styles__["a" /* getStyles */], undefined, { scope: 'GroupShowAll' });
//# sourceMappingURL=GroupShowAll.js.map

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinkBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__KeytipData__ = __webpack_require__(89);




var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var LinkBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](LinkBase, _super);
    function LinkBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._link = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._onClick = function (ev) {
            var _a = _this.props, onClick = _a.onClick, disabled = _a.disabled;
            if (disabled) {
                ev.preventDefault();
            }
            else if (onClick) {
                onClick(ev);
            }
        };
        return _this;
    }
    LinkBase.prototype.render = function () {
        var _this = this;
        var _a = this.props, disabled = _a.disabled, children = _a.children, className = _a.className, href = _a.href, theme = _a.theme, styles = _a.styles, keytipProps = _a.keytipProps;
        var classNames = getClassNames(styles, {
            className: className,
            isButton: !href,
            isDisabled: disabled,
            theme: theme
        });
        var RootType = this._getRootType(this.props);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__KeytipData__["a" /* KeytipData */], { keytipProps: keytipProps, ariaDescribedBy: this.props['aria-describedby'], disabled: disabled }, function (keytipAttributes) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](RootType, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, keytipAttributes, _this._adjustPropsForRootType(RootType, _this.props), { className: classNames.root, onClick: _this._onClick, ref: _this._link, "aria-disabled": disabled }), children)); }));
    };
    LinkBase.prototype.focus = function () {
        var current = this._link.current;
        if (current && current.focus) {
            current.focus();
        }
    };
    LinkBase.prototype._adjustPropsForRootType = function (RootType, props) {
        // Deconstruct the props so we remove props like `as`, `theme` and `styles`
        // as those will always be removed. We also take some props that are optional
        // based on the RootType.
        var children = props.children, as = props.as, disabled = props.disabled, target = props.target, href = props.href, theme = props.theme, getStyles = props.getStyles, styles = props.styles, componentRef = props.componentRef, restProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __rest */](props, ["children", "as", "disabled", "target", "href", "theme", "getStyles", "styles", "componentRef"]);
        // RootType will be a string if we're dealing with an html component
        if (typeof RootType === 'string') {
            // Remove the disabled prop for anchor elements
            if (RootType === 'a') {
                return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ target: target, href: disabled ? undefined : href }, restProps);
            }
            // Add the type='button' prop for button elements
            if (RootType === 'button') {
                return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ type: 'button', disabled: disabled }, restProps);
            }
            // Remove the target and href props for all other non anchor elements
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, restProps, { disabled: disabled });
        }
        // Retain all props except 'as' for ReactComponents
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ target: target, href: href, disabled: disabled }, restProps);
    };
    LinkBase.prototype._getRootType = function (props) {
        if (props.as) {
            return props.as;
        }
        if (props.href) {
            return 'a';
        }
        return 'button';
    };
    return LinkBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=Link.base.js.map

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GroupFooter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GroupFooter_styles__ = __webpack_require__(1718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GroupFooter_base__ = __webpack_require__(1719);



var GroupFooter = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_2__GroupFooter_base__["a" /* GroupFooterBase */], __WEBPACK_IMPORTED_MODULE_1__GroupFooter_styles__["a" /* getStyles */], undefined, {
    scope: 'GroupFooter'
});
//# sourceMappingURL=GroupFooter.js.map

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollToMode; });
/**
 * {@docCategory List}
 */
var ScrollToMode = {
    /**
     * Does not make any consideration to where in the viewport the item should align to.
     */
    auto: 0,
    /**
     * Attempts to scroll the list so the top of the desired item is aligned with the top of the viewport.
     */
    top: 1,
    /**
     * Attempts to scroll the list so the bottom of the desired item is aligned with the bottom of the viewport.
     */
    bottom: 2,
    /**
     * Attempts to scroll the list so the desired item is in the exact center of the viewport.
     */
    center: 3
};
//# sourceMappingURL=List.types.js.map

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DragDropHelper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utilities__ = __webpack_require__(1);


var MOUSEDOWN_PRIMARY_BUTTON = 0; // for mouse down event we are using ev.button property, 0 means left button
var MOUSEMOVE_PRIMARY_BUTTON = 1; // for mouse move event we are using ev.buttons property, 1 means left button
var DragDropHelper = /** @class */ (function () {
    function DragDropHelper(params) {
        this._selection = params.selection;
        this._dragEnterCounts = {};
        this._activeTargets = {};
        this._lastId = 0;
        this._events = new __WEBPACK_IMPORTED_MODULE_1__Utilities__["e" /* EventGroup */](this);
        var doc = Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["I" /* getDocument */])();
        // clear drag data when mouse up, use capture event to ensure it will be run
        if (doc) {
            this._events.on(doc.body, 'mouseup', this._onMouseUp.bind(this), true);
            this._events.on(doc, 'mouseup', this._onDocumentMouseUp.bind(this), true);
        }
    }
    DragDropHelper.prototype.dispose = function () {
        this._events.dispose();
    };
    DragDropHelper.prototype.subscribe = function (root, events, dragDropOptions) {
        var _this = this;
        var _a = dragDropOptions.key, key = _a === void 0 ? "" + ++this._lastId : _a;
        var handlers = [];
        var onDragStart;
        var onDragLeave;
        var onDragEnter;
        var onDragEnd;
        var onDrop;
        var onDragOver;
        var onMouseDown;
        var isDraggable;
        var isDroppable;
        var activeTarget;
        if (dragDropOptions && root) {
            var eventMap = dragDropOptions.eventMap, context = dragDropOptions.context, updateDropState_1 = dragDropOptions.updateDropState;
            var dragDropTarget = {
                root: root,
                options: dragDropOptions,
                key: key
            };
            isDraggable = this._isDraggable(dragDropTarget);
            isDroppable = this._isDroppable(dragDropTarget);
            if (isDraggable || isDroppable) {
                if (eventMap) {
                    for (var _i = 0, eventMap_1 = eventMap; _i < eventMap_1.length; _i++) {
                        var event_1 = eventMap_1[_i];
                        var handler = {
                            callback: event_1.callback.bind(null, context),
                            eventName: event_1.eventName
                        };
                        handlers.push(handler);
                        this._events.on(root, handler.eventName, handler.callback);
                    }
                }
            }
            if (isDroppable) {
                // If the target is droppable, wire up global event listeners to track drop-related events.
                onDragLeave = function (event) {
                    if (!event.isHandled) {
                        event.isHandled = true;
                        _this._dragEnterCounts[key]--;
                        if (_this._dragEnterCounts[key] === 0) {
                            updateDropState_1(false /* isDropping */, event);
                        }
                    }
                };
                onDragEnter = function (event) {
                    event.preventDefault(); // needed for IE
                    if (!event.isHandled) {
                        event.isHandled = true;
                        _this._dragEnterCounts[key]++;
                        if (_this._dragEnterCounts[key] === 1) {
                            updateDropState_1(true /* isDropping */, event);
                        }
                    }
                };
                onDragEnd = function (event) {
                    _this._dragEnterCounts[key] = 0;
                    updateDropState_1(false /* isDropping */, event);
                };
                onDrop = function (event) {
                    _this._dragEnterCounts[key] = 0;
                    updateDropState_1(false /* isDropping */, event);
                    if (dragDropOptions.onDrop) {
                        dragDropOptions.onDrop(dragDropOptions.context.data, event);
                    }
                };
                onDragOver = function (event) {
                    event.preventDefault();
                    if (dragDropOptions.onDragOver) {
                        dragDropOptions.onDragOver(dragDropOptions.context.data, event);
                    }
                };
                this._dragEnterCounts[key] = 0;
                // dragenter and dragleave will be fired when hover to the child element
                // but we only want to change state when enter or leave the current element
                // use the count to ensure it.
                events.on(root, 'dragenter', onDragEnter);
                events.on(root, 'dragleave', onDragLeave);
                events.on(root, 'dragend', onDragEnd);
                events.on(root, 'drop', onDrop);
                events.on(root, 'dragover', onDragOver);
            }
            if (isDraggable) {
                // If the target is draggable, wire up local event listeners for mouse events.
                onMouseDown = this._onMouseDown.bind(this, dragDropTarget);
                onDragEnd = this._onDragEnd.bind(this, dragDropTarget);
                // We need to add in data so that on Firefox we show the ghost element when dragging
                onDragStart = function (event) {
                    var options = _this._dragData.dragTarget.options;
                    if (options && options.onDragStart) {
                        options.onDragStart(options.context.data, options.context.index, _this._selection.getSelection(), event);
                    }
                    _this._isDragging = true;
                    if (event.dataTransfer) {
                        event.dataTransfer.setData('id', root.id);
                    }
                };
                events.on(root, 'dragstart', onDragStart);
                events.on(root, 'mousedown', onMouseDown);
                events.on(root, 'dragend', onDragEnd);
            }
            activeTarget = {
                target: dragDropTarget,
                dispose: function () {
                    if (_this._activeTargets[key] === activeTarget) {
                        delete _this._activeTargets[key];
                    }
                    if (root) {
                        for (var _i = 0, handlers_1 = handlers; _i < handlers_1.length; _i++) {
                            var handler = handlers_1[_i];
                            _this._events.off(root, handler.eventName, handler.callback);
                        }
                        if (isDroppable) {
                            events.off(root, 'dragenter', onDragEnter);
                            events.off(root, 'dragleave', onDragLeave);
                            events.off(root, 'dragend', onDragEnd);
                            events.off(root, 'dragover', onDragOver);
                            events.off(root, 'drop', onDrop);
                        }
                        if (isDraggable) {
                            events.off(root, 'dragstart', onDragStart);
                            events.off(root, 'mousedown', onMouseDown);
                            events.off(root, 'dragend', onDragEnd);
                        }
                    }
                }
            };
            this._activeTargets[key] = activeTarget;
        }
        return {
            key: key,
            dispose: function () {
                if (activeTarget) {
                    activeTarget.dispose();
                }
            }
        };
    };
    DragDropHelper.prototype.unsubscribe = function (root, key) {
        var activeTarget = this._activeTargets[key];
        if (activeTarget) {
            activeTarget.dispose();
        }
    };
    DragDropHelper.prototype._onDragEnd = function (target, event) {
        var options = target.options;
        if (options.onDragEnd) {
            options.onDragEnd(options.context.data, event);
        }
    };
    /**
     * clear drag data when mouse up on body
     */
    DragDropHelper.prototype._onMouseUp = function (event) {
        this._isDragging = false;
        if (this._dragData) {
            for (var _i = 0, _a = Object.keys(this._activeTargets); _i < _a.length; _i++) {
                var key = _a[_i];
                var activeTarget = this._activeTargets[key];
                if (activeTarget.target.root) {
                    this._events.off(activeTarget.target.root, 'mousemove');
                    this._events.off(activeTarget.target.root, 'mouseleave');
                }
            }
            if (this._dragData.dropTarget) {
                // raise dragleave event to let dropTarget know it need to remove dropping style
                __WEBPACK_IMPORTED_MODULE_1__Utilities__["e" /* EventGroup */].raise(this._dragData.dropTarget.root, 'dragleave');
                __WEBPACK_IMPORTED_MODULE_1__Utilities__["e" /* EventGroup */].raise(this._dragData.dropTarget.root, 'drop');
            }
        }
        this._dragData = null;
    };
    /**
     * clear drag data when mouse up outside of the document
     */
    DragDropHelper.prototype._onDocumentMouseUp = function (event) {
        var doc = Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["I" /* getDocument */])();
        if (doc && event.target === doc.documentElement) {
            this._onMouseUp(event);
        }
    };
    /**
     * when mouse move over a new drop target while dragging some items,
     * fire dragleave on the old target and fire dragenter to the new target
     * The target will handle style change on dragenter and dragleave events.
     */
    DragDropHelper.prototype._onMouseMove = function (target, event) {
        var 
        // use buttons property here since ev.button in some edge case is not updating well during the move.
        // but firefox doesn't support it, so we set the default value when it is not defined.
        _a = event.buttons, 
        // use buttons property here since ev.button in some edge case is not updating well during the move.
        // but firefox doesn't support it, so we set the default value when it is not defined.
        buttons = _a === void 0 ? MOUSEMOVE_PRIMARY_BUTTON : _a;
        if (this._dragData && buttons !== MOUSEMOVE_PRIMARY_BUTTON) {
            // cancel mouse down event and return early when the primary button is not pressed
            this._onMouseUp(event);
            return;
        }
        var root = target.root, key = target.key;
        if (this._isDragging) {
            if (this._isDroppable(target)) {
                // we can have nested drop targets in the DOM, like a folder inside a group. In that case, when we drag into
                // the inner target (folder), we first set dropTarget to the inner element. But the same event is bubbled to the
                // outer target too, and we need to prevent the outer one from taking over.
                // So, check if the last dropTarget is not a child of the current.
                if (this._dragData) {
                    if (this._dragData.dropTarget && this._dragData.dropTarget.key !== key && !this._isChild(root, this._dragData.dropTarget.root)) {
                        if (this._dragEnterCounts[this._dragData.dropTarget.key] > 0) {
                            __WEBPACK_IMPORTED_MODULE_1__Utilities__["e" /* EventGroup */].raise(this._dragData.dropTarget.root, 'dragleave');
                            __WEBPACK_IMPORTED_MODULE_1__Utilities__["e" /* EventGroup */].raise(root, 'dragenter');
                            this._dragData.dropTarget = target;
                        }
                    }
                }
            }
        }
    };
    /**
     * when mouse leave a target while dragging some items, fire dragleave to the target
     */
    DragDropHelper.prototype._onMouseLeave = function (target, event) {
        if (this._isDragging) {
            if (this._dragData && this._dragData.dropTarget && this._dragData.dropTarget.key === target.key) {
                __WEBPACK_IMPORTED_MODULE_1__Utilities__["e" /* EventGroup */].raise(target.root, 'dragleave');
                this._dragData.dropTarget = undefined;
            }
        }
    };
    /**
     * when mouse down on a draggable item, we start to track dragdata.
     */
    DragDropHelper.prototype._onMouseDown = function (target, event) {
        if (event.button !== MOUSEDOWN_PRIMARY_BUTTON) {
            // Ignore anything except the primary button.
            return;
        }
        if (this._isDraggable(target)) {
            this._dragData = {
                clientX: event.clientX,
                clientY: event.clientY,
                eventTarget: event.target,
                dragTarget: target
            };
            for (var _i = 0, _a = Object.keys(this._activeTargets); _i < _a.length; _i++) {
                var key = _a[_i];
                var activeTarget = this._activeTargets[key];
                if (activeTarget.target.root) {
                    this._events.on(activeTarget.target.root, 'mousemove', this._onMouseMove.bind(this, activeTarget.target));
                    this._events.on(activeTarget.target.root, 'mouseleave', this._onMouseLeave.bind(this, activeTarget.target));
                }
            }
        }
        else {
            this._dragData = null;
        }
    };
    /**
     * determine whether the child target is a descendant of the parent
     */
    DragDropHelper.prototype._isChild = function (parent, child) {
        var parentElement = __WEBPACK_IMPORTED_MODULE_0_react_dom__["findDOMNode"](parent);
        var childElement = __WEBPACK_IMPORTED_MODULE_0_react_dom__["findDOMNode"](child);
        while (childElement && childElement.parentElement) {
            if (childElement.parentElement === parentElement) {
                return true;
            }
            childElement = childElement.parentElement;
        }
        return false;
    };
    DragDropHelper.prototype._isDraggable = function (target) {
        var options = target.options;
        return !!(options.canDrag && options.canDrag(options.context.data));
    };
    DragDropHelper.prototype._isDroppable = function (target) {
        // TODO: take the drag item into consideration to prevent dragging an item into the same group
        var options = target.options;
        var dragContext = this._dragData && this._dragData.dragTarget ? this._dragData.dragTarget.options.context : undefined;
        return !!(options.canDrop && options.canDrop(options.context, dragContext));
    };
    return DragDropHelper;
}());

//# sourceMappingURL=DragDropHelper.js.map

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DetailsColumnBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Icon__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DetailsList_types__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DetailsRow_styles__ = __webpack_require__(99);






var MOUSEDOWN_PRIMARY_BUTTON = 0; // for mouse down event we are using ev.button property, 0 means left button
var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["r" /* classNamesFunction */])();
var TRANSITION_DURATION_DRAG = 200; // ms
var TRANSITION_DURATION_DROP = 1500; // ms
var CLASSNAME_ADD_INTERVAL = 20; // ms
/**
 * Component for rendering columns in a `DetailsList`.
 *
 * {@docCategory DetailsList}
 */
var DetailsColumnBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](DetailsColumnBase, _super);
    function DetailsColumnBase(props) {
        var _this = _super.call(this, props) || this;
        _this._root = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._onRenderColumnHeaderTooltip = function (tooltipHostProps, defaultRender) {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: tooltipHostProps.hostClassName }, tooltipHostProps.children);
        };
        _this._onDragStart = function (item, itemIndex, selectedItems, event) {
            var classNames = _this._classNames;
            if (itemIndex) {
                _this._updateHeaderDragInfo(itemIndex);
                _this._root.current.classList.add(classNames.borderWhileDragging);
                _this._async.setTimeout(function () {
                    if (_this._root.current) {
                        _this._root.current.classList.add(classNames.noBorderWhileDragging);
                    }
                }, CLASSNAME_ADD_INTERVAL);
            }
        };
        _this._onDragEnd = function (item, event) {
            var classNames = _this._classNames;
            if (event) {
                _this._updateHeaderDragInfo(-1, event);
            }
            _this._root.current.classList.remove(classNames.borderWhileDragging);
            _this._root.current.classList.remove(classNames.noBorderWhileDragging);
        };
        _this._updateHeaderDragInfo = function (itemIndex, event) {
            if (_this.props.setDraggedItemIndex) {
                _this.props.setDraggedItemIndex(itemIndex);
            }
            if (_this.props.updateDragInfo) {
                _this.props.updateDragInfo({ itemIndex: itemIndex }, event);
            }
        };
        _this._onRootMouseDown = function (ev) {
            var isDraggable = _this.props.isDraggable;
            // Ignore anything except the primary button.
            if (isDraggable && ev.button === MOUSEDOWN_PRIMARY_BUTTON) {
                ev.stopPropagation();
            }
        };
        Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_5" /* initializeComponentRef */])(_this);
        _this._async = new __WEBPACK_IMPORTED_MODULE_3__Utilities__["a" /* Async */](_this);
        _this._events = new __WEBPACK_IMPORTED_MODULE_3__Utilities__["e" /* EventGroup */](_this);
        return _this;
    }
    DetailsColumnBase.prototype.render = function () {
        var _a = this.props, column = _a.column, columnIndex = _a.columnIndex, parentId = _a.parentId, isDraggable = _a.isDraggable, styles = _a.styles, theme = _a.theme, _b = _a.cellStyleProps, cellStyleProps = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_5__DetailsRow_styles__["a" /* DEFAULT_CELL_STYLE_PROPS */] : _b, useFastIcons = _a.useFastIcons;
        var _c = this.props.onRenderColumnHeaderTooltip, onRenderColumnHeaderTooltip = _c === void 0 ? this._onRenderColumnHeaderTooltip : _c;
        this._classNames = getClassNames(styles, {
            theme: theme,
            headerClassName: column.headerClassName,
            iconClassName: column.iconClassName,
            isActionable: column.columnActionsMode !== __WEBPACK_IMPORTED_MODULE_4__DetailsList_types__["b" /* ColumnActionsMode */].disabled,
            isEmpty: !column.name,
            isIconVisible: column.isSorted || column.isGrouped || column.isFiltered,
            isPadded: column.isPadded,
            isIconOnly: column.isIconOnly,
            cellStyleProps: cellStyleProps,
            transitionDurationDrag: TRANSITION_DURATION_DRAG,
            transitionDurationDrop: TRANSITION_DURATION_DROP
        });
        var classNames = this._classNames;
        var IconComponent = useFastIcons ? __WEBPACK_IMPORTED_MODULE_2__Icon__["FontIcon"] : __WEBPACK_IMPORTED_MODULE_2__Icon__["Icon"];
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { key: column.key, ref: this._root, role: 'columnheader', "aria-sort": column.isSorted ? (column.isSortedDescending ? 'descending' : 'ascending') : 'none', "aria-colindex": columnIndex, className: classNames.root, "data-is-draggable": isDraggable, draggable: isDraggable, style: {
                    width: column.calculatedWidth +
                        cellStyleProps.cellLeftPadding +
                        cellStyleProps.cellRightPadding +
                        (column.isPadded ? cellStyleProps.cellExtraRightPadding : 0)
                }, "data-automationid": 'ColumnsHeaderColumn', "data-item-key": column.key },
                isDraggable && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](IconComponent, { iconName: "GripperBarVertical", className: classNames.gripperBarVerticalStyle }),
                onRenderColumnHeaderTooltip({
                    hostClassName: classNames.cellTooltip,
                    id: parentId + "-" + column.key + "-tooltip",
                    setAriaDescribedBy: false,
                    content: column.columnActionsMode !== __WEBPACK_IMPORTED_MODULE_4__DetailsList_types__["b" /* ColumnActionsMode */].disabled ? column.ariaLabel : '',
                    children: (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { id: parentId + "-" + column.key, "aria-label": column.isIconOnly ? column.name : undefined, "aria-labelledby": column.isIconOnly ? undefined : parentId + "-" + column.key + "-name", className: classNames.cellTitle, "data-is-focusable": column.columnActionsMode !== __WEBPACK_IMPORTED_MODULE_4__DetailsList_types__["b" /* ColumnActionsMode */].disabled, role: column.columnActionsMode !== __WEBPACK_IMPORTED_MODULE_4__DetailsList_types__["b" /* ColumnActionsMode */].disabled &&
                            (column.onColumnClick !== undefined || this.props.onColumnClick !== undefined)
                            ? 'button'
                            : undefined, "aria-describedby": !this.props.onRenderColumnHeaderTooltip && this._hasAccessibleLabel() ? parentId + "-" + column.key + "-tooltip" : undefined, onContextMenu: this._onColumnContextMenu.bind(this, column), onClick: this._onColumnClick.bind(this, column), "aria-haspopup": column.columnActionsMode === __WEBPACK_IMPORTED_MODULE_4__DetailsList_types__["b" /* ColumnActionsMode */].hasDropdown, "aria-expanded": column.columnActionsMode === __WEBPACK_IMPORTED_MODULE_4__DetailsList_types__["b" /* ColumnActionsMode */].hasDropdown ? (column.isMenuOpen ? true : false) : undefined },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { id: parentId + "-" + column.key + "-name", className: classNames.cellName },
                            (column.iconName || column.iconClassName) && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](IconComponent, { className: classNames.iconClassName, iconName: column.iconName })),
                            column.isIconOnly ? __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: classNames.accessibleLabel }, column.name) : column.name),
                        column.isFiltered && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](IconComponent, { className: classNames.nearIcon, iconName: "Filter" }),
                        column.isSorted && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](IconComponent, { className: classNames.sortIcon, iconName: column.isSortedDescending ? 'SortDown' : 'SortUp' })),
                        column.isGrouped && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](IconComponent, { className: classNames.nearIcon, iconName: "GroupedDescending" }),
                        column.columnActionsMode === __WEBPACK_IMPORTED_MODULE_4__DetailsList_types__["b" /* ColumnActionsMode */].hasDropdown && !column.isIconOnly && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](IconComponent, { "aria-hidden": true, className: classNames.filterChevron, iconName: "ChevronDown" }))))
                }, this._onRenderColumnHeaderTooltip)),
            !this.props.onRenderColumnHeaderTooltip ? this._renderAccessibleLabel() : null));
    };
    DetailsColumnBase.prototype.componentDidMount = function () {
        var _this = this;
        if (this._dragDropSubscription) {
            this._dragDropSubscription.dispose();
            delete this._dragDropSubscription;
        }
        if (this.props.dragDropHelper && this.props.isDraggable) {
            this._dragDropSubscription = this.props.dragDropHelper.subscribe(this._root.current, this._events, this._getColumnDragDropOptions());
            // We need to use native on this to avoid MarqueeSelection from handling the event before us.
            this._events.on(this._root.current, 'mousedown', this._onRootMouseDown);
        }
        var classNames = this._classNames;
        if (this.props.isDropped) {
            if (this._root.current) {
                this._root.current.classList.add(classNames.borderAfterDropping);
                this._async.setTimeout(function () {
                    if (_this._root.current) {
                        _this._root.current.classList.add(classNames.noBorderAfterDropping);
                    }
                }, CLASSNAME_ADD_INTERVAL);
            }
            this._async.setTimeout(function () {
                if (_this._root.current) {
                    _this._root.current.classList.remove(classNames.borderAfterDropping);
                    _this._root.current.classList.remove(classNames.noBorderAfterDropping);
                }
            }, TRANSITION_DURATION_DROP + CLASSNAME_ADD_INTERVAL);
        }
    };
    DetailsColumnBase.prototype.componentWillUnmount = function () {
        if (this._dragDropSubscription) {
            this._dragDropSubscription.dispose();
            delete this._dragDropSubscription;
        }
        this._async.dispose();
        this._events.dispose();
    };
    DetailsColumnBase.prototype.componentDidUpdate = function () {
        if (!this._dragDropSubscription && this.props.dragDropHelper && this.props.isDraggable) {
            this._dragDropSubscription = this.props.dragDropHelper.subscribe(this._root.current, this._events, this._getColumnDragDropOptions());
            // We need to use native on this to avoid MarqueeSelection from handling the event before us.
            this._events.on(this._root.current, 'mousedown', this._onRootMouseDown);
        }
        if (this._dragDropSubscription && !this.props.isDraggable) {
            this._dragDropSubscription.dispose();
            this._events.off(this._root.current, 'mousedown');
            delete this._dragDropSubscription;
        }
    };
    DetailsColumnBase.prototype._onColumnClick = function (column, ev) {
        if (column.columnActionsMode === __WEBPACK_IMPORTED_MODULE_4__DetailsList_types__["b" /* ColumnActionsMode */].disabled) {
            return;
        }
        var onColumnClick = this.props.onColumnClick;
        if (column.onColumnClick) {
            column.onColumnClick(ev, column);
        }
        if (onColumnClick) {
            onColumnClick(ev, column);
        }
    };
    DetailsColumnBase.prototype._getColumnDragDropOptions = function () {
        var _this = this;
        var columnIndex = this.props.columnIndex;
        var options = {
            selectionIndex: columnIndex,
            context: { data: columnIndex, index: columnIndex },
            canDrag: function () { return _this.props.isDraggable; },
            canDrop: function () { return false; },
            onDragStart: this._onDragStart,
            updateDropState: function () { return undefined; },
            onDrop: function () { return undefined; },
            onDragEnd: this._onDragEnd
        };
        return options;
    };
    DetailsColumnBase.prototype._hasAccessibleLabel = function () {
        var column = this.props.column;
        return !!(column.ariaLabel ||
            column.filterAriaLabel ||
            column.sortAscendingAriaLabel ||
            column.sortDescendingAriaLabel ||
            column.groupAriaLabel);
    };
    DetailsColumnBase.prototype._renderAccessibleLabel = function () {
        var _a = this.props, column = _a.column, parentId = _a.parentId;
        var classNames = this._classNames;
        return this._hasAccessibleLabel() && !this.props.onRenderColumnHeaderTooltip ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("label", { key: column.key + "_label", id: parentId + "-" + column.key + "-tooltip", className: classNames.accessibleLabel },
            column.ariaLabel,
            (column.isFiltered && column.filterAriaLabel) || null,
            (column.isSorted && (column.isSortedDescending ? column.sortDescendingAriaLabel : column.sortAscendingAriaLabel)) || null,
            (column.isGrouped && column.groupAriaLabel) || null)) : null;
    };
    DetailsColumnBase.prototype._onColumnContextMenu = function (column, ev) {
        var onColumnContextMenu = this.props.onColumnContextMenu;
        if (column.onColumnContextMenu) {
            column.onColumnContextMenu(column, ev);
            ev.preventDefault();
        }
        if (onColumnContextMenu) {
            onColumnContextMenu(column, ev);
            ev.preventDefault();
        }
    };
    return DetailsColumnBase;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=DetailsColumn.base.js.map

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DetailsList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DetailsList_base__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DetailsList_styles__ = __webpack_require__(1729);



var DetailsList = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__DetailsList_base__["a" /* DetailsListBase */], __WEBPACK_IMPORTED_MODULE_2__DetailsList_styles__["a" /* getStyles */], undefined, {
    scope: 'DetailsList'
});
//# sourceMappingURL=DetailsList.js.map

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DetailsListBase; });
/* unused harmony export buildColumns */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DetailsList_DetailsList_types__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DetailsList_DetailsHeader__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DetailsList_DetailsHeader_types__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DetailsList_DetailsRow__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FocusZone__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utilities_selection_index__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utilities_dragdrop_DragDropHelper__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__GroupedList__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__List__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utilities_decorators_withViewport__ = __webpack_require__(1727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utilities_groupedList_GroupedListUtility__ = __webpack_require__(1728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__DetailsRow_styles__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__GroupedList_GroupSpacer__ = __webpack_require__(107);















// For every group level there is a GroupSpacer added. Importing this const to have the source value in one place.

var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var MIN_COLUMN_WIDTH = 100; // this is the global min width
var CHECKBOX_WIDTH = 40;
var DEFAULT_RENDERED_WINDOWS_AHEAD = 2;
var DEFAULT_RENDERED_WINDOWS_BEHIND = 2;
var SHIMMER_INITIAL_ITEMS = 10;
var SHIMMER_ITEMS = new Array(SHIMMER_INITIAL_ITEMS);
var DetailsListBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](DetailsListBase, _super);
    function DetailsListBase(props) {
        var _this = _super.call(this, props) || this;
        _this._root = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._header = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._groupedList = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._list = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._focusZone = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._selectionZone = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._sumColumnWidths = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_15" /* memoizeFunction */])(function (columns) {
            var totalWidth = 0;
            columns.forEach(function (column) { return (totalWidth += column.calculatedWidth || column.minWidth); });
            return totalWidth;
        });
        _this._onRenderRow = function (props, defaultRender) {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__DetailsList_DetailsRow__["a" /* DetailsRow */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, props));
        };
        _this._onRenderDetailsHeader = function (detailsHeaderProps, defaultRender) {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__DetailsList_DetailsHeader__["a" /* DetailsHeader */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, detailsHeaderProps));
        };
        _this._onRenderDetailsFooter = function (detailsFooterProps, defaultRender) {
            return null;
        };
        _this._onRenderListCell = function (nestingDepth) {
            return function (item, itemIndex) {
                return _this._onRenderCell(nestingDepth, item, itemIndex);
            };
        };
        _this._onRenderCell = function (nestingDepth, item, index) {
            var _a = _this.props, compact = _a.compact, dragDropEvents = _a.dragDropEvents, eventsToRegister = _a.rowElementEventMap, onRenderMissingItem = _a.onRenderMissingItem, onRenderItemColumn = _a.onRenderItemColumn, getCellValueKey = _a.getCellValueKey, _b = _a.onRenderRow, onRenderRow = _b === void 0 ? _this._onRenderRow : _b, _c = _a.selectionMode, selectionMode = _c === void 0 ? _this._selection.mode : _c, viewport = _a.viewport, checkboxVisibility = _a.checkboxVisibility, getRowAriaLabel = _a.getRowAriaLabel, getRowAriaDescribedBy = _a.getRowAriaDescribedBy, checkButtonAriaLabel = _a.checkButtonAriaLabel, checkboxCellClassName = _a.checkboxCellClassName, groupProps = _a.groupProps, useReducedRowRenderer = _a.useReducedRowRenderer, indentWidth = _a.indentWidth, _d = _a.cellStyleProps, cellStyleProps = _d === void 0 ? __WEBPACK_IMPORTED_MODULE_14__DetailsRow_styles__["a" /* DEFAULT_CELL_STYLE_PROPS */] : _d, onRenderCheckbox = _a.onRenderCheckbox, enableUpdateAnimations = _a.enableUpdateAnimations, useFastIcons = _a.useFastIcons;
            var collapseAllVisibility = groupProps && groupProps.collapseAllVisibility;
            var selection = _this._selection;
            var dragDropHelper = _this._dragDropHelper;
            var columns = _this.state.adjustedColumns;
            var rowProps = {
                item: item,
                itemIndex: index,
                compact: compact,
                columns: columns,
                groupNestingDepth: nestingDepth,
                selectionMode: selectionMode,
                selection: selection,
                onDidMount: _this._onRowDidMount,
                onWillUnmount: _this._onRowWillUnmount,
                onRenderItemColumn: onRenderItemColumn,
                getCellValueKey: getCellValueKey,
                eventsToRegister: eventsToRegister,
                dragDropEvents: dragDropEvents,
                dragDropHelper: dragDropHelper,
                viewport: viewport,
                checkboxVisibility: checkboxVisibility,
                collapseAllVisibility: collapseAllVisibility,
                getRowAriaLabel: getRowAriaLabel,
                getRowAriaDescribedBy: getRowAriaDescribedBy,
                checkButtonAriaLabel: checkButtonAriaLabel,
                checkboxCellClassName: checkboxCellClassName,
                useReducedRowRenderer: useReducedRowRenderer,
                indentWidth: indentWidth,
                cellStyleProps: cellStyleProps,
                onRenderDetailsCheckbox: onRenderCheckbox,
                enableUpdateAnimations: enableUpdateAnimations,
                rowWidth: _this._sumColumnWidths(columns),
                useFastIcons: useFastIcons
            };
            if (!item) {
                if (onRenderMissingItem) {
                    return onRenderMissingItem(index, rowProps);
                }
                return null;
            }
            return onRenderRow(rowProps, _this._onRenderRow);
        };
        _this._onGroupExpandStateChanged = function (isSomeGroupExpanded) {
            _this.setState({ isSomeGroupExpanded: isSomeGroupExpanded });
        };
        _this._onColumnIsSizingChanged = function (column, isSizing) {
            _this.setState({ isSizing: isSizing });
        };
        _this._onHeaderKeyDown = function (ev) {
            if (ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].down) {
                if (_this._focusZone.current && _this._focusZone.current.focus()) {
                    // select the first item in list after down arrow key event
                    // only if nothing was selected; otherwise start with the already-selected item
                    if (_this._selection.getSelectedIndices().length === 0) {
                        _this._selection.setIndexSelected(0, true, false);
                    }
                    ev.preventDefault();
                    ev.stopPropagation();
                }
            }
        };
        _this._onContentKeyDown = function (ev) {
            if (ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].up && !ev.altKey) {
                if (_this._header.current && _this._header.current.focus()) {
                    ev.preventDefault();
                    ev.stopPropagation();
                }
            }
        };
        _this._onRowDidMount = function (row) {
            var _a = row.props, item = _a.item, itemIndex = _a.itemIndex;
            var itemKey = _this._getItemKey(item, itemIndex);
            _this._activeRows[itemKey] = row; // this is used for column auto resize
            _this._setFocusToRowIfPending(row);
            var onRowDidMount = _this.props.onRowDidMount;
            if (onRowDidMount) {
                onRowDidMount(item, itemIndex);
            }
        };
        _this._onRowWillUnmount = function (row) {
            var onRowWillUnmount = _this.props.onRowWillUnmount;
            var _a = row.props, item = _a.item, itemIndex = _a.itemIndex;
            var itemKey = _this._getItemKey(item, itemIndex);
            delete _this._activeRows[itemKey];
            if (onRowWillUnmount) {
                onRowWillUnmount(item, itemIndex);
            }
        };
        _this._onToggleCollapse = function (collapsed) {
            _this.setState({
                isCollapsed: collapsed
            });
            if (_this._groupedList.current) {
                _this._groupedList.current.toggleCollapseAll(collapsed);
            }
        };
        _this._onColumnDragEnd = function (props, event) {
            var columnReorderOptions = _this.props.columnReorderOptions;
            var finalDropLocation = __WEBPACK_IMPORTED_MODULE_3__DetailsList_DetailsList_types__["c" /* ColumnDragEndLocation */].outside;
            if (columnReorderOptions && columnReorderOptions.onDragEnd) {
                if (props.dropLocation && props.dropLocation !== __WEBPACK_IMPORTED_MODULE_3__DetailsList_DetailsList_types__["c" /* ColumnDragEndLocation */].header) {
                    finalDropLocation = props.dropLocation;
                }
                else if (_this._root.current) {
                    var clientRect = _this._root.current.getBoundingClientRect();
                    if (event.clientX > clientRect.left &&
                        event.clientX < clientRect.right &&
                        event.clientY > clientRect.top &&
                        event.clientY < clientRect.bottom) {
                        finalDropLocation = __WEBPACK_IMPORTED_MODULE_3__DetailsList_DetailsList_types__["c" /* ColumnDragEndLocation */].surface;
                    }
                }
                columnReorderOptions.onDragEnd(finalDropLocation);
            }
        };
        _this._onColumnResized = function (resizingColumn, newWidth, resizingColumnIndex) {
            var newCalculatedWidth = Math.max(resizingColumn.minWidth || MIN_COLUMN_WIDTH, newWidth);
            if (_this.props.onColumnResize) {
                _this.props.onColumnResize(resizingColumn, newCalculatedWidth, resizingColumnIndex);
            }
            _this._rememberCalculatedWidth(resizingColumn, newCalculatedWidth);
            _this._adjustColumns(_this.props, true, resizingColumnIndex);
            _this.setState({
                version: {}
            });
        };
        /**
         * Callback function when double clicked on the details header column resizer
         * which will measure the column cells of all the active rows and resize the
         * column to the max cell width.
         *
         * @param column - double clicked column definition
         * @param columnIndex - double clicked column index
         * TODO: min width 100 should be changed to const value and should be consistent with the
         * value used on _onSizerMove method in DetailsHeader
         */
        _this._onColumnAutoResized = function (column, columnIndex) {
            var max = 0;
            var count = 0;
            var totalCount = Object.keys(_this._activeRows).length;
            for (var key in _this._activeRows) {
                if (_this._activeRows.hasOwnProperty(key)) {
                    var currentRow = _this._activeRows[key];
                    currentRow.measureCell(columnIndex, function (width) {
                        max = Math.max(max, width);
                        count++;
                        if (count === totalCount) {
                            _this._onColumnResized(column, max, columnIndex);
                        }
                    });
                }
            }
        };
        /**
         * Call back function when an element in FocusZone becomes active. It will translate it into item
         * and call onActiveItemChanged callback if specified.
         *
         * @param row - element that became active in Focus Zone
         * @param focus - event from Focus Zone
         */
        _this._onActiveRowChanged = function (el, ev) {
            var _a = _this.props, items = _a.items, onActiveItemChanged = _a.onActiveItemChanged;
            if (!el) {
                return;
            }
            // Check and assign index only if the event was raised from any DetailsRow element
            if (el.getAttribute('data-item-index')) {
                var index = Number(el.getAttribute('data-item-index'));
                if (index >= 0) {
                    if (onActiveItemChanged) {
                        onActiveItemChanged(items[index], index, ev);
                    }
                    _this.setState({
                        focusedItemIndex: index
                    });
                }
            }
        };
        _this._onBlur = function (event) {
            _this.setState({
                focusedItemIndex: -1
            });
        };
        Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_5" /* initializeComponentRef */])(_this);
        Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_6" /* initializeFocusRects */])();
        _this._async = new __WEBPACK_IMPORTED_MODULE_2__Utilities__["a" /* Async */](_this);
        _this._activeRows = {};
        _this._columnOverrides = {};
        _this.state = {
            focusedItemIndex: -1,
            lastWidth: 0,
            adjustedColumns: _this._getAdjustedColumns(props),
            isSizing: false,
            isDropping: false,
            isCollapsed: props.groupProps && props.groupProps.isAllGroupsCollapsed,
            isSomeGroupExpanded: props.groupProps && !props.groupProps.isAllGroupsCollapsed,
            version: {}
        };
        _this._selection = props.selection || new __WEBPACK_IMPORTED_MODULE_8__utilities_selection_index__["b" /* Selection */]({ onSelectionChanged: undefined, getKey: props.getKey });
        if (!_this.props.disableSelectionZone) {
            _this._selection.setItems(props.items, false);
        }
        _this._dragDropHelper = props.dragDropEvents
            ? new __WEBPACK_IMPORTED_MODULE_9__utilities_dragdrop_DragDropHelper__["a" /* DragDropHelper */]({
                selection: _this._selection,
                minimumPixelsForDrag: props.minimumPixelsForDrag
            })
            : undefined;
        _this._initialFocusedIndex = props.initialFocusedIndex;
        return _this;
    }
    DetailsListBase.prototype.scrollToIndex = function (index, measureItem, scrollToMode) {
        this._list.current && this._list.current.scrollToIndex(index, measureItem, scrollToMode);
        this._groupedList.current && this._groupedList.current.scrollToIndex(index, measureItem, scrollToMode);
    };
    DetailsListBase.prototype.focusIndex = function (index, forceIntoFirstElement, measureItem, scrollToMode) {
        if (forceIntoFirstElement === void 0) { forceIntoFirstElement = false; }
        var item = this.props.items[index];
        if (item) {
            this.scrollToIndex(index, measureItem, scrollToMode);
            var itemKey = this._getItemKey(item, index);
            var row = this._activeRows[itemKey];
            if (row) {
                this._setFocusToRow(row, forceIntoFirstElement);
            }
        }
    };
    DetailsListBase.prototype.getStartItemIndexInView = function () {
        if (this._list && this._list.current) {
            return this._list.current.getStartItemIndexInView();
        }
        else if (this._groupedList && this._groupedList.current) {
            return this._groupedList.current.getStartItemIndexInView();
        }
        return 0;
    };
    DetailsListBase.prototype.componentWillUnmount = function () {
        if (this._dragDropHelper) {
            // TODO If the DragDropHelper was passed via props, this will dispose it, which is incorrect behavior.
            this._dragDropHelper.dispose();
        }
        this._async.dispose();
    };
    DetailsListBase.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (this._initialFocusedIndex !== undefined) {
            var item = this.props.items[this._initialFocusedIndex];
            if (item) {
                var itemKey = this._getItemKey(item, this._initialFocusedIndex);
                var row = this._activeRows[itemKey];
                if (row) {
                    this._setFocusToRowIfPending(row);
                }
            }
        }
        if (this.props.items !== prevProps.items &&
            this.props.items.length > 0 &&
            this.state.focusedItemIndex !== -1 &&
            !Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["y" /* elementContains */])(this._root.current, document.activeElement, false)) {
            // Item set has changed and previously-focused item is gone.
            // Set focus to item at index of previously-focused item if it is in range,
            // else set focus to the last item.
            var index = this.state.focusedItemIndex < this.props.items.length ? this.state.focusedItemIndex : this.props.items.length - 1;
            var item = this.props.items[index];
            var itemKey = this._getItemKey(item, this.state.focusedItemIndex);
            var row = this._activeRows[itemKey];
            if (row) {
                this._setFocusToRow(row);
            }
            else {
                this._initialFocusedIndex = index;
            }
        }
        if (this.props.onDidUpdate) {
            this.props.onDidUpdate(this);
        }
    };
    DetailsListBase.prototype.componentWillReceiveProps = function (newProps) {
        var _a = this.props, checkboxVisibility = _a.checkboxVisibility, items = _a.items, setKey = _a.setKey, _b = _a.selectionMode, selectionMode = _b === void 0 ? this._selection.mode : _b, columns = _a.columns, viewport = _a.viewport, compact = _a.compact, dragDropEvents = _a.dragDropEvents;
        var _c = (this.props.groupProps || {}).isAllGroupsCollapsed, isAllGroupsCollapsed = _c === void 0 ? undefined : _c;
        var newViewportWidth = (newProps.viewport && newProps.viewport.width) || 0;
        var oldViewportWidth = (viewport && viewport.width) || 0;
        var shouldResetSelection = newProps.setKey !== setKey || newProps.setKey === undefined;
        var shouldForceUpdates = false;
        if (newProps.layoutMode !== this.props.layoutMode) {
            shouldForceUpdates = true;
        }
        if (shouldResetSelection) {
            this._initialFocusedIndex = newProps.initialFocusedIndex;
            // reset focusedItemIndex when setKey changes
            this.setState({
                focusedItemIndex: this._initialFocusedIndex !== undefined ? this._initialFocusedIndex : -1
            });
        }
        if (!this.props.disableSelectionZone && newProps.items !== items) {
            this._selection.setItems(newProps.items, shouldResetSelection);
        }
        if (newProps.checkboxVisibility !== checkboxVisibility ||
            newProps.columns !== columns ||
            newViewportWidth !== oldViewportWidth ||
            newProps.compact !== compact) {
            shouldForceUpdates = true;
        }
        this._adjustColumns(newProps, true);
        if (newProps.selectionMode !== selectionMode) {
            shouldForceUpdates = true;
        }
        if (isAllGroupsCollapsed === undefined && (newProps.groupProps && newProps.groupProps.isAllGroupsCollapsed !== undefined)) {
            this.setState({
                isCollapsed: newProps.groupProps.isAllGroupsCollapsed,
                isSomeGroupExpanded: !newProps.groupProps.isAllGroupsCollapsed
            });
        }
        if (newProps.dragDropEvents !== dragDropEvents) {
            this._dragDropHelper && this._dragDropHelper.dispose();
            this._dragDropHelper = newProps.dragDropEvents
                ? new __WEBPACK_IMPORTED_MODULE_9__utilities_dragdrop_DragDropHelper__["a" /* DragDropHelper */]({
                    selection: this._selection,
                    minimumPixelsForDrag: newProps.minimumPixelsForDrag
                })
                : undefined;
            shouldForceUpdates = true;
        }
        if (shouldForceUpdates) {
            this.setState({
                version: {}
            });
        }
    };
    DetailsListBase.prototype.render = function () {
        var _a = this.props, ariaLabelForListHeader = _a.ariaLabelForListHeader, ariaLabelForSelectAllCheckbox = _a.ariaLabelForSelectAllCheckbox, ariaLabelForSelectionColumn = _a.ariaLabelForSelectionColumn, className = _a.className, checkboxVisibility = _a.checkboxVisibility, compact = _a.compact, constrainMode = _a.constrainMode, dragDropEvents = _a.dragDropEvents, groups = _a.groups, groupProps = _a.groupProps, indentWidth = _a.indentWidth, items = _a.items, isHeaderVisible = _a.isHeaderVisible, layoutMode = _a.layoutMode, onItemInvoked = _a.onItemInvoked, onItemContextMenu = _a.onItemContextMenu, onColumnHeaderClick = _a.onColumnHeaderClick, onColumnHeaderContextMenu = _a.onColumnHeaderContextMenu, _b = _a.selectionMode, selectionMode = _b === void 0 ? this._selection.mode : _b, selectionPreservedOnEmptyClick = _a.selectionPreservedOnEmptyClick, selectionZoneProps = _a.selectionZoneProps, ariaLabel = _a.ariaLabel, ariaLabelForGrid = _a.ariaLabelForGrid, rowElementEventMap = _a.rowElementEventMap, _c = _a.shouldApplyApplicationRole, shouldApplyApplicationRole = _c === void 0 ? false : _c, getKey = _a.getKey, listProps = _a.listProps, usePageCache = _a.usePageCache, onShouldVirtualize = _a.onShouldVirtualize, enableShimmer = _a.enableShimmer, viewport = _a.viewport, minimumPixelsForDrag = _a.minimumPixelsForDrag, getGroupHeight = _a.getGroupHeight, styles = _a.styles, theme = _a.theme, _d = _a.cellStyleProps, cellStyleProps = _d === void 0 ? __WEBPACK_IMPORTED_MODULE_14__DetailsRow_styles__["a" /* DEFAULT_CELL_STYLE_PROPS */] : _d, onRenderCheckbox = _a.onRenderCheckbox, useFastIcons = _a.useFastIcons;
        var _e = this.state, adjustedColumns = _e.adjustedColumns, isCollapsed = _e.isCollapsed, isSizing = _e.isSizing, isSomeGroupExpanded = _e.isSomeGroupExpanded;
        var _f = this, selection = _f._selection, dragDropHelper = _f._dragDropHelper;
        var groupNestingDepth = this._getGroupNestingDepth();
        var additionalListProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ renderedWindowsAhead: isSizing ? 0 : DEFAULT_RENDERED_WINDOWS_AHEAD, renderedWindowsBehind: isSizing ? 0 : DEFAULT_RENDERED_WINDOWS_BEHIND, getKey: getKey, version: this.state.version }, listProps);
        var selectAllVisibility = __WEBPACK_IMPORTED_MODULE_5__DetailsList_DetailsHeader_types__["a" /* SelectAllVisibility */].none; // for SelectionMode.none
        if (selectionMode === __WEBPACK_IMPORTED_MODULE_8__utilities_selection_index__["c" /* SelectionMode */].single) {
            selectAllVisibility = __WEBPACK_IMPORTED_MODULE_5__DetailsList_DetailsHeader_types__["a" /* SelectAllVisibility */].hidden;
        }
        if (selectionMode === __WEBPACK_IMPORTED_MODULE_8__utilities_selection_index__["c" /* SelectionMode */].multiple) {
            // if isCollapsedGroupSelectVisible is false, disable select all when the list has all collapsed groups
            var isCollapsedGroupSelectVisible = groupProps && groupProps.headerProps && groupProps.headerProps.isCollapsedGroupSelectVisible;
            if (isCollapsedGroupSelectVisible === undefined) {
                isCollapsedGroupSelectVisible = true;
            }
            var isSelectAllVisible = isCollapsedGroupSelectVisible || !groups || isSomeGroupExpanded;
            selectAllVisibility = isSelectAllVisible ? __WEBPACK_IMPORTED_MODULE_5__DetailsList_DetailsHeader_types__["a" /* SelectAllVisibility */].visible : __WEBPACK_IMPORTED_MODULE_5__DetailsList_DetailsHeader_types__["a" /* SelectAllVisibility */].hidden;
        }
        if (checkboxVisibility === __WEBPACK_IMPORTED_MODULE_3__DetailsList_DetailsList_types__["a" /* CheckboxVisibility */].hidden) {
            selectAllVisibility = __WEBPACK_IMPORTED_MODULE_5__DetailsList_DetailsHeader_types__["a" /* SelectAllVisibility */].none;
        }
        var _g = this.props, _h = _g.onRenderDetailsHeader, onRenderDetailsHeader = _h === void 0 ? this._onRenderDetailsHeader : _h, _j = _g.onRenderDetailsFooter, onRenderDetailsFooter = _j === void 0 ? this._onRenderDetailsFooter : _j;
        var detailsFooterProps = this._getDetailsFooterProps();
        var columnReorderProps = this._getColumnReorderProps();
        var rowCount = (isHeaderVisible ? 1 : 0) + Object(__WEBPACK_IMPORTED_MODULE_13__utilities_groupedList_GroupedListUtility__["a" /* GetGroupCount */])(groups) + (items ? items.length : 0);
        var classNames = getClassNames(styles, {
            theme: theme,
            compact: compact,
            isFixed: layoutMode === __WEBPACK_IMPORTED_MODULE_3__DetailsList_DetailsList_types__["e" /* DetailsListLayoutMode */].fixedColumns,
            isHorizontalConstrained: constrainMode === __WEBPACK_IMPORTED_MODULE_3__DetailsList_DetailsList_types__["d" /* ConstrainMode */].horizontalConstrained,
            className: className
        });
        var list = groups ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__GroupedList__["b" /* GroupedList */], { componentRef: this._groupedList, groups: groups, groupProps: groupProps ? this._getGroupProps(groupProps) : undefined, items: items, onRenderCell: this._onRenderCell, selection: selection, selectionMode: checkboxVisibility !== __WEBPACK_IMPORTED_MODULE_3__DetailsList_DetailsList_types__["a" /* CheckboxVisibility */].hidden ? selectionMode : __WEBPACK_IMPORTED_MODULE_8__utilities_selection_index__["c" /* SelectionMode */].none, dragDropEvents: dragDropEvents, dragDropHelper: dragDropHelper, eventsToRegister: rowElementEventMap, listProps: additionalListProps, onGroupExpandStateChanged: this._onGroupExpandStateChanged, usePageCache: usePageCache, onShouldVirtualize: onShouldVirtualize, getGroupHeight: getGroupHeight, compact: compact })) : (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__List__["a" /* List */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ ref: this._list, role: "presentation", items: enableShimmer && !items.length ? SHIMMER_ITEMS : items, onRenderCell: this._onRenderListCell(0), usePageCache: usePageCache, onShouldVirtualize: onShouldVirtualize }, additionalListProps)));
        return (
        // If shouldApplyApplicationRole is true, role application will be applied to make arrow keys work
        // with JAWS.
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ ref: this._root, className: classNames.root, "data-automationid": "DetailsList", "data-is-scrollable": "false", "aria-label": ariaLabel }, (shouldApplyApplicationRole ? { role: 'application' } : {})),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { role: "grid", "aria-label": ariaLabelForGrid, "aria-rowcount": rowCount, "aria-colcount": (selectAllVisibility !== __WEBPACK_IMPORTED_MODULE_5__DetailsList_DetailsHeader_types__["a" /* SelectAllVisibility */].none ? 1 : 0) + (adjustedColumns ? adjustedColumns.length : 0), "aria-readonly": "true" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { onKeyDown: this._onHeaderKeyDown, role: "presentation", className: classNames.headerWrapper }, isHeaderVisible &&
                    onRenderDetailsHeader({
                        componentRef: this._header,
                        selectionMode: selectionMode,
                        layoutMode: layoutMode,
                        selection: selection,
                        columns: adjustedColumns,
                        onColumnClick: onColumnHeaderClick,
                        onColumnContextMenu: onColumnHeaderContextMenu,
                        onColumnResized: this._onColumnResized,
                        onColumnIsSizingChanged: this._onColumnIsSizingChanged,
                        onColumnAutoResized: this._onColumnAutoResized,
                        groupNestingDepth: groupNestingDepth,
                        isAllCollapsed: isCollapsed,
                        onToggleCollapseAll: this._onToggleCollapse,
                        ariaLabel: ariaLabelForListHeader,
                        ariaLabelForSelectAllCheckbox: ariaLabelForSelectAllCheckbox,
                        ariaLabelForSelectionColumn: ariaLabelForSelectionColumn,
                        selectAllVisibility: selectAllVisibility,
                        collapseAllVisibility: groupProps && groupProps.collapseAllVisibility,
                        viewport: viewport,
                        columnReorderProps: columnReorderProps,
                        minimumPixelsForDrag: minimumPixelsForDrag,
                        cellStyleProps: cellStyleProps,
                        checkboxVisibility: checkboxVisibility,
                        indentWidth: indentWidth,
                        onRenderDetailsCheckbox: onRenderCheckbox,
                        rowWidth: this._sumColumnWidths(this.state.adjustedColumns),
                        useFastIcons: useFastIcons
                    }, this._onRenderDetailsHeader)),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { onKeyDown: this._onContentKeyDown, role: "presentation", className: classNames.contentWrapper },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__FocusZone__["a" /* FocusZone */], { componentRef: this._focusZone, className: classNames.focusZone, direction: __WEBPACK_IMPORTED_MODULE_7__FocusZone__["b" /* FocusZoneDirection */].vertical, isInnerZoneKeystroke: isRightArrow, onActiveElementChanged: this._onActiveRowChanged, onBlur: this._onBlur }, !this.props.disableSelectionZone ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__utilities_selection_index__["d" /* SelectionZone */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ ref: this._selectionZone, selection: selection, selectionPreservedOnEmptyClick: selectionPreservedOnEmptyClick, selectionMode: selectionMode, onItemInvoked: onItemInvoked, onItemContextMenu: onItemContextMenu, enterModalOnTouch: this.props.enterModalSelectionOnTouch }, selectionZoneProps || {}), list)) : (list))),
                onRenderDetailsFooter(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, detailsFooterProps), this._onRenderDetailsFooter))));
    };
    DetailsListBase.prototype.forceUpdate = function () {
        _super.prototype.forceUpdate.call(this);
        this._forceListUpdates();
    };
    DetailsListBase.prototype._getGroupNestingDepth = function () {
        var groups = this.props.groups;
        var level = 0;
        var groupsInLevel = groups;
        while (groupsInLevel && groupsInLevel.length > 0) {
            level++;
            groupsInLevel = groupsInLevel[0].children;
        }
        return level;
    };
    DetailsListBase.prototype._setFocusToRowIfPending = function (row) {
        var itemIndex = row.props.itemIndex;
        if (this._initialFocusedIndex !== undefined && itemIndex === this._initialFocusedIndex) {
            this._setFocusToRow(row);
            delete this._initialFocusedIndex;
        }
    };
    DetailsListBase.prototype._setFocusToRow = function (row, forceIntoFirstElement) {
        if (forceIntoFirstElement === void 0) { forceIntoFirstElement = false; }
        if (this._selectionZone.current) {
            this._selectionZone.current.ignoreNextFocus();
        }
        this._async.setTimeout(function () {
            row.focus(forceIntoFirstElement);
        }, 0);
    };
    DetailsListBase.prototype._forceListUpdates = function () {
        if (this._groupedList.current) {
            this._groupedList.current.forceUpdate();
        }
        if (this._list.current) {
            this._list.current.forceUpdate();
        }
    };
    DetailsListBase.prototype._notifyColumnsResized = function () {
        this.state.adjustedColumns.forEach(function (column) {
            if (column.onColumnResize) {
                column.onColumnResize(column.currentWidth);
            }
        });
    };
    DetailsListBase.prototype._adjustColumns = function (newProps, forceUpdate, resizingColumnIndex) {
        var adjustedColumns = this._getAdjustedColumns(newProps, forceUpdate, resizingColumnIndex);
        var viewport = this.props.viewport;
        var viewportWidth = viewport && viewport.width ? viewport.width : 0;
        if (adjustedColumns) {
            this.setState({
                adjustedColumns: adjustedColumns,
                lastWidth: viewportWidth
            }, this._notifyColumnsResized);
        }
    };
    /** Returns adjusted columns, given the viewport size and layout mode. */
    DetailsListBase.prototype._getAdjustedColumns = function (newProps, forceUpdate, resizingColumnIndex) {
        var _this = this;
        var newItems = newProps.items, layoutMode = newProps.layoutMode, selectionMode = newProps.selectionMode, viewport = newProps.viewport;
        var viewportWidth = viewport && viewport.width ? viewport.width : 0;
        var newColumns = newProps.columns;
        var columns = this.props ? this.props.columns : [];
        var lastWidth = this.state ? this.state.lastWidth : -1;
        var lastSelectionMode = this.state ? this.state.lastSelectionMode : undefined;
        if (!forceUpdate && lastWidth === viewportWidth && lastSelectionMode === selectionMode && (!columns || newColumns === columns)) {
            return [];
        }
        newColumns = newColumns || buildColumns(newItems, true);
        var adjustedColumns;
        if (layoutMode === __WEBPACK_IMPORTED_MODULE_3__DetailsList_DetailsList_types__["e" /* DetailsListLayoutMode */].fixedColumns) {
            adjustedColumns = this._getFixedColumns(newColumns);
            // Preserve adjusted column calculated widths.
            adjustedColumns.forEach(function (column) {
                _this._rememberCalculatedWidth(column, column.calculatedWidth);
            });
        }
        else {
            if (resizingColumnIndex !== undefined) {
                adjustedColumns = this._getJustifiedColumnsAfterResize(newColumns, viewportWidth, newProps, resizingColumnIndex);
            }
            else {
                adjustedColumns = this._getJustifiedColumns(newColumns, viewportWidth, newProps, 0);
            }
            adjustedColumns.forEach(function (column) {
                _this._getColumnOverride(column.key).currentWidth = column.calculatedWidth;
            });
        }
        return adjustedColumns;
    };
    /** Builds a set of columns based on the given columns mixed with the current overrides. */
    DetailsListBase.prototype._getFixedColumns = function (newColumns) {
        var _this = this;
        return newColumns.map(function (column) {
            var newColumn = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, column, _this._columnOverrides[column.key]);
            if (!newColumn.calculatedWidth) {
                newColumn.calculatedWidth = newColumn.maxWidth || newColumn.minWidth || MIN_COLUMN_WIDTH;
            }
            return newColumn;
        });
    };
    DetailsListBase.prototype._getJustifiedColumnsAfterResize = function (newColumns, viewportWidth, props, resizingColumnIndex) {
        var _this = this;
        var fixedColumns = newColumns.slice(0, resizingColumnIndex);
        fixedColumns.forEach(function (column) { return (column.calculatedWidth = _this._getColumnOverride(column.key).currentWidth); });
        var fixedWidth = fixedColumns.reduce(function (total, column, i) { return total + getPaddedWidth(column, i === 0, props); }, 0);
        var remainingColumns = newColumns.slice(resizingColumnIndex);
        var remainingWidth = viewportWidth - fixedWidth;
        return fixedColumns.concat(this._getJustifiedColumns(remainingColumns, remainingWidth, props, resizingColumnIndex));
    };
    /** Builds a set of columns to fix within the viewport width. */
    DetailsListBase.prototype._getJustifiedColumns = function (newColumns, viewportWidth, props, firstIndex) {
        var _this = this;
        var _a = props.selectionMode, selectionMode = _a === void 0 ? this._selection.mode : _a, checkboxVisibility = props.checkboxVisibility;
        var rowCheckWidth = selectionMode !== __WEBPACK_IMPORTED_MODULE_8__utilities_selection_index__["c" /* SelectionMode */].none && checkboxVisibility !== __WEBPACK_IMPORTED_MODULE_3__DetailsList_DetailsList_types__["a" /* CheckboxVisibility */].hidden ? CHECKBOX_WIDTH : 0;
        var groupExpandWidth = this._getGroupNestingDepth() * __WEBPACK_IMPORTED_MODULE_15__GroupedList_GroupSpacer__["b" /* SPACER_WIDTH */];
        var totalWidth = 0; // offset because we have one less inner padding.
        var availableWidth = viewportWidth - (rowCheckWidth + groupExpandWidth);
        var adjustedColumns = newColumns.map(function (column, i) {
            var newColumn = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, column, { calculatedWidth: column.minWidth || MIN_COLUMN_WIDTH }, _this._columnOverrides[column.key]);
            var isFirst = i + firstIndex === 0;
            totalWidth += getPaddedWidth(newColumn, isFirst, props);
            return newColumn;
        });
        var lastIndex = adjustedColumns.length - 1;
        // Shrink or remove collapsable columns.
        while (lastIndex > 0 && totalWidth > availableWidth) {
            var column = adjustedColumns[lastIndex];
            var minWidth = column.minWidth || MIN_COLUMN_WIDTH;
            var overflowWidth = totalWidth - availableWidth;
            if (column.calculatedWidth - minWidth >= overflowWidth || !(column.isCollapsable || column.isCollapsible)) {
                var originalWidth = column.calculatedWidth;
                column.calculatedWidth = Math.max(column.calculatedWidth - overflowWidth, minWidth);
                totalWidth -= originalWidth - column.calculatedWidth;
            }
            else {
                totalWidth -= getPaddedWidth(column, false, props);
                adjustedColumns.splice(lastIndex, 1);
            }
            lastIndex--;
        }
        // Then expand columns starting at the beginning, until we've filled the width.
        for (var i = 0; i < adjustedColumns.length && totalWidth < availableWidth; i++) {
            var column = adjustedColumns[i];
            var isLast = i === adjustedColumns.length - 1;
            var overrides = this._columnOverrides[column.key];
            if (overrides && overrides.calculatedWidth && !isLast) {
                continue;
            }
            var spaceLeft = availableWidth - totalWidth;
            var increment = void 0;
            if (isLast) {
                increment = spaceLeft;
            }
            else {
                var maxWidth = column.maxWidth;
                var minWidth = column.minWidth || maxWidth || MIN_COLUMN_WIDTH;
                increment = maxWidth ? Math.min(spaceLeft, maxWidth - minWidth) : spaceLeft;
            }
            column.calculatedWidth = column.calculatedWidth + increment;
            totalWidth += increment;
        }
        return adjustedColumns;
    };
    DetailsListBase.prototype._rememberCalculatedWidth = function (column, newCalculatedWidth) {
        var overrides = this._getColumnOverride(column.key);
        overrides.calculatedWidth = newCalculatedWidth;
        overrides.currentWidth = newCalculatedWidth;
    };
    DetailsListBase.prototype._getColumnOverride = function (key) {
        return (this._columnOverrides[key] = this._columnOverrides[key] || {});
    };
    DetailsListBase.prototype._getItemKey = function (item, itemIndex) {
        var getKey = this.props.getKey;
        var itemKey = undefined;
        if (item) {
            itemKey = item.key;
        }
        if (getKey) {
            itemKey = getKey(item, itemIndex);
        }
        if (!itemKey) {
            itemKey = itemIndex;
        }
        return itemKey;
    };
    DetailsListBase.prototype._getDetailsFooterProps = function () {
        var columns = this.state.adjustedColumns;
        var _a = this.props, viewport = _a.viewport, checkboxVisibility = _a.checkboxVisibility, indentWidth = _a.indentWidth, _b = _a.cellStyleProps, cellStyleProps = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_14__DetailsRow_styles__["a" /* DEFAULT_CELL_STYLE_PROPS */] : _b, _c = _a.selectionMode, selectionMode = _c === void 0 ? this._selection.mode : _c;
        return {
            columns: columns,
            groupNestingDepth: this._getGroupNestingDepth(),
            selection: this._selection,
            selectionMode: selectionMode,
            viewport: viewport,
            checkboxVisibility: checkboxVisibility,
            indentWidth: indentWidth,
            cellStyleProps: cellStyleProps
        };
    };
    DetailsListBase.prototype._getColumnReorderProps = function () {
        var columnReorderOptions = this.props.columnReorderOptions;
        if (columnReorderOptions) {
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, columnReorderOptions, { onColumnDragEnd: this._onColumnDragEnd });
        }
    };
    DetailsListBase.prototype._getGroupProps = function (detailsGroupProps) {
        var _this = this;
        var onRenderDetailsGroupFooter = detailsGroupProps.onRenderFooter, onRenderDetailsGroupHeader = detailsGroupProps.onRenderHeader;
        var columns = this.state.adjustedColumns;
        var _a = this.props, _b = _a.selectionMode, selectionMode = _b === void 0 ? this._selection.mode : _b, viewport = _a.viewport, _c = _a.cellStyleProps, cellStyleProps = _c === void 0 ? __WEBPACK_IMPORTED_MODULE_14__DetailsRow_styles__["a" /* DEFAULT_CELL_STYLE_PROPS */] : _c, checkboxVisibility = _a.checkboxVisibility, indentWidth = _a.indentWidth;
        var groupNestingDepth = this._getGroupNestingDepth();
        var onRenderFooter = onRenderDetailsGroupFooter
            ? function (props, defaultRender) {
                return onRenderDetailsGroupFooter(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, props, { columns: columns, groupNestingDepth: groupNestingDepth, indentWidth: indentWidth, selection: _this._selection, selectionMode: selectionMode, viewport: viewport, checkboxVisibility: checkboxVisibility,
                    cellStyleProps: cellStyleProps }), defaultRender);
            }
            : undefined;
        var onRenderHeader = onRenderDetailsGroupHeader
            ? function (props, defaultRender) {
                return onRenderDetailsGroupHeader(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, props, { columns: columns, groupNestingDepth: groupNestingDepth, indentWidth: indentWidth, selection: _this._selection, selectionMode: selectionMode, viewport: viewport, checkboxVisibility: checkboxVisibility,
                    cellStyleProps: cellStyleProps }), defaultRender);
            }
            : undefined;
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, detailsGroupProps, { onRenderFooter: onRenderFooter,
            onRenderHeader: onRenderHeader });
    };
    DetailsListBase.defaultProps = {
        layoutMode: __WEBPACK_IMPORTED_MODULE_3__DetailsList_DetailsList_types__["e" /* DetailsListLayoutMode */].justified,
        selectionMode: __WEBPACK_IMPORTED_MODULE_8__utilities_selection_index__["c" /* SelectionMode */].multiple,
        constrainMode: __WEBPACK_IMPORTED_MODULE_3__DetailsList_DetailsList_types__["d" /* ConstrainMode */].horizontalConstrained,
        checkboxVisibility: __WEBPACK_IMPORTED_MODULE_3__DetailsList_DetailsList_types__["a" /* CheckboxVisibility */].onHover,
        isHeaderVisible: true,
        enableShimmer: false,
        compact: false
    };
    DetailsListBase = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_12__utilities_decorators_withViewport__["a" /* withViewport */]
    ], DetailsListBase);
    return DetailsListBase;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

function buildColumns(items, canResizeColumns, onColumnClick, sortedColumnKey, isSortedDescending, groupedColumnKey, isMultiline) {
    var columns = [];
    if (items && items.length) {
        var firstItem = items[0];
        for (var propName in firstItem) {
            if (firstItem.hasOwnProperty(propName)) {
                columns.push({
                    key: propName,
                    name: propName,
                    fieldName: propName,
                    minWidth: MIN_COLUMN_WIDTH,
                    maxWidth: 300,
                    isCollapsable: !!columns.length,
                    isCollapsible: !!columns.length,
                    isMultiline: isMultiline === undefined ? false : isMultiline,
                    isSorted: sortedColumnKey === propName,
                    isSortedDescending: !!isSortedDescending,
                    isRowHeader: false,
                    columnActionsMode: __WEBPACK_IMPORTED_MODULE_3__DetailsList_DetailsList_types__["b" /* ColumnActionsMode */].clickable,
                    isResizable: canResizeColumns,
                    onColumnClick: onColumnClick,
                    isGrouped: groupedColumnKey === propName
                });
            }
        }
    }
    return columns;
}
function isRightArrow(event) {
    return event.which === Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["W" /* getRTLSafeKeyCode */])(__WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].right);
}
function getPaddedWidth(column, isFirst, props) {
    var _a = props.cellStyleProps, cellStyleProps = _a === void 0 ? __WEBPACK_IMPORTED_MODULE_14__DetailsRow_styles__["a" /* DEFAULT_CELL_STYLE_PROPS */] : _a;
    return (column.calculatedWidth +
        cellStyleProps.cellLeftPadding +
        cellStyleProps.cellRightPadding +
        (column.isPadded ? cellStyleProps.cellExtraRightPadding : 0));
}
//# sourceMappingURL=DetailsList.base.js.map

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DetailsRow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DetailsRow_base__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DetailsRow_styles__ = __webpack_require__(99);



var DetailsRow = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__DetailsRow_base__["a" /* DetailsRowBase */], __WEBPACK_IMPORTED_MODULE_2__DetailsRow_styles__["c" /* getStyles */], undefined, {
    scope: 'DetailsRow'
});
//# sourceMappingURL=DetailsRow.js.map

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DetailsRowBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DetailsList_types__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DetailsRowCheck__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__GroupedList_GroupSpacer__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DetailsRowFields__ = __webpack_require__(1726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FocusZone__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utilities_selection_interfaces__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__GroupedList__ = __webpack_require__(267);












var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["r" /* classNamesFunction */])();
var DEFAULT_DROPPING_CSS_CLASS = 'is-dropping';
var NO_COLUMNS = [];
var DetailsRowBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](DetailsRowBase, _super);
    function DetailsRowBase(props) {
        var _this = _super.call(this, props) || this;
        _this._cellMeasurer = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._focusZone = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._onSelectionChanged = function () {
            var selectionState = _this._getSelectionState(_this.props);
            if (!Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_27" /* shallowCompare */])(selectionState, _this.state.selectionState)) {
                _this.setState({
                    selectionState: selectionState
                });
            }
        };
        _this._onRootRef = function (focusZone) {
            if (focusZone) {
                // Need to resolve the actual DOM node, not the component. The element itself will be used for drag/drop and focusing.
                _this._root = __WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"](focusZone);
            }
            else {
                _this._root = undefined;
            }
        };
        /**
         * update isDropping state based on the input value, which is used to change style during drag and drop
         *
         * when change to true, that means drag enter. we will add default dropping class name
         * or the custom dropping class name (return result from onDragEnter) to the root elemet.
         *
         * when change to false, that means drag leave. we will remove the dropping class name from root element.
         *
         * @param newValue - New isDropping state value
         * @param event - The event trigger dropping state change which can be dragenter, dragleave etc
         */
        _this._updateDroppingState = function (newValue, event) {
            var _a = _this.state, selectionState = _a.selectionState, isDropping = _a.isDropping;
            var _b = _this.props, dragDropEvents = _b.dragDropEvents, item = _b.item;
            if (!newValue) {
                if (dragDropEvents.onDragLeave) {
                    dragDropEvents.onDragLeave(item, event);
                }
            }
            else {
                if (dragDropEvents.onDragEnter) {
                    _this._droppingClassNames = dragDropEvents.onDragEnter(item, event);
                }
            }
            if (isDropping !== newValue) {
                _this.setState({ selectionState: selectionState, isDropping: newValue });
            }
        };
        Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_5" /* initializeComponentRef */])(_this);
        _this._events = new __WEBPACK_IMPORTED_MODULE_3__Utilities__["e" /* EventGroup */](_this);
        _this.state = {
            selectionState: _this._getSelectionState(props),
            columnMeasureInfo: undefined,
            isDropping: false,
            groupNestingDepth: props.groupNestingDepth
        };
        _this._droppingClassNames = '';
        return _this;
    }
    DetailsRowBase.prototype.componentDidMount = function () {
        var dragDropHelper = this.props.dragDropHelper;
        if (dragDropHelper) {
            this._dragDropSubscription = dragDropHelper.subscribe(this._root, this._events, this._getRowDragDropOptions());
        }
        this._events.on(this.props.selection, __WEBPACK_IMPORTED_MODULE_9__utilities_selection_interfaces__["a" /* SELECTION_CHANGE */], this._onSelectionChanged);
        if (this.props.onDidMount && this.props.item) {
            // If the item appears later, we should wait for it before calling this method.
            this._hasMounted = true;
            this.props.onDidMount(this);
        }
    };
    DetailsRowBase.prototype.componentDidUpdate = function (previousProps) {
        var state = this.state;
        var _a = this.props, item = _a.item, onDidMount = _a.onDidMount;
        var columnMeasureInfo = state.columnMeasureInfo;
        if (this.props.itemIndex !== previousProps.itemIndex ||
            this.props.item !== previousProps.item ||
            this.props.dragDropHelper !== previousProps.dragDropHelper) {
            if (this._dragDropSubscription) {
                this._dragDropSubscription.dispose();
                delete this._dragDropSubscription;
            }
            if (this.props.dragDropHelper) {
                this._dragDropSubscription = this.props.dragDropHelper.subscribe(this._root, this._events, this._getRowDragDropOptions());
            }
        }
        if (columnMeasureInfo && columnMeasureInfo.index >= 0 && this._cellMeasurer.current) {
            var newWidth = this._cellMeasurer.current.getBoundingClientRect().width;
            columnMeasureInfo.onMeasureDone(newWidth);
            this.setState({
                columnMeasureInfo: undefined
            });
        }
        if (item && onDidMount && !this._hasMounted) {
            this._hasMounted = true;
            onDidMount(this);
        }
    };
    DetailsRowBase.prototype.componentWillUnmount = function () {
        var _a = this.props, item = _a.item, onWillUnmount = _a.onWillUnmount;
        // Only call the onWillUnmount callback if we have an item.
        if (onWillUnmount && item) {
            onWillUnmount(this);
        }
        if (this._dragDropSubscription) {
            this._dragDropSubscription.dispose();
            delete this._dragDropSubscription;
        }
        this._events.dispose();
    };
    DetailsRowBase.prototype.componentWillReceiveProps = function (newProps) {
        this.setState({
            selectionState: this._getSelectionState(newProps),
            groupNestingDepth: newProps.groupNestingDepth
        });
    };
    DetailsRowBase.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        if (this.props.useReducedRowRenderer) {
            if (this.state.selectionState) {
                var newSelectionState = this._getSelectionState(nextProps);
                if (this.state.selectionState.isSelected !== newSelectionState.isSelected) {
                    return true;
                }
            }
            return !Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_27" /* shallowCompare */])(this.props, nextProps);
        }
        else {
            return true;
        }
    };
    DetailsRowBase.prototype.render = function () {
        var _a = this.props, className = _a.className, _b = _a.columns, columns = _b === void 0 ? NO_COLUMNS : _b, dragDropEvents = _a.dragDropEvents, item = _a.item, itemIndex = _a.itemIndex, _c = _a.onRenderCheck, onRenderCheck = _c === void 0 ? this._onRenderCheck : _c, onRenderDetailsCheckbox = _a.onRenderDetailsCheckbox, onRenderItemColumn = _a.onRenderItemColumn, getCellValueKey = _a.getCellValueKey, selectionMode = _a.selectionMode, _d = _a.rowWidth, rowWidth = _d === void 0 ? 0 : _d, checkboxVisibility = _a.checkboxVisibility, getRowAriaLabel = _a.getRowAriaLabel, getRowAriaDescribedBy = _a.getRowAriaDescribedBy, checkButtonAriaLabel = _a.checkButtonAriaLabel, checkboxCellClassName = _a.checkboxCellClassName, 
        /** Alias rowFieldsAs as RowFields and default to DetailsRowFields if rowFieldsAs does not exist */
        _e = _a.rowFieldsAs, 
        /** Alias rowFieldsAs as RowFields and default to DetailsRowFields if rowFieldsAs does not exist */
        RowFields = _e === void 0 ? __WEBPACK_IMPORTED_MODULE_7__DetailsRowFields__["a" /* DetailsRowFields */] : _e, selection = _a.selection, indentWidth = _a.indentWidth, shimmer = _a.shimmer, enableUpdateAnimations = _a.enableUpdateAnimations, compact = _a.compact, theme = _a.theme, styles = _a.styles, cellsByColumn = _a.cellsByColumn, useFastIcons = _a.useFastIcons;
        var _f = this.state, columnMeasureInfo = _f.columnMeasureInfo, isDropping = _f.isDropping, groupNestingDepth = _f.groupNestingDepth;
        var _g = this.state.selectionState, _h = _g.isSelected, isSelected = _h === void 0 ? false : _h, _j = _g.isSelectionModal, isSelectionModal = _j === void 0 ? false : _j;
        var isDraggable = dragDropEvents ? !!(dragDropEvents.canDrag && dragDropEvents.canDrag(item)) : undefined;
        var droppingClassName = isDropping ? (this._droppingClassNames ? this._droppingClassNames : DEFAULT_DROPPING_CSS_CLASS) : '';
        var ariaLabel = getRowAriaLabel ? getRowAriaLabel(item) : undefined;
        var ariaDescribedBy = getRowAriaDescribedBy ? getRowAriaDescribedBy(item) : undefined;
        var canSelect = !!selection && selection.canSelectItem(item, itemIndex);
        var isContentUnselectable = selectionMode === __WEBPACK_IMPORTED_MODULE_9__utilities_selection_interfaces__["b" /* SelectionMode */].multiple;
        var showCheckbox = selectionMode !== __WEBPACK_IMPORTED_MODULE_9__utilities_selection_interfaces__["b" /* SelectionMode */].none && checkboxVisibility !== __WEBPACK_IMPORTED_MODULE_4__DetailsList_types__["a" /* CheckboxVisibility */].hidden;
        var ariaSelected = selectionMode === __WEBPACK_IMPORTED_MODULE_9__utilities_selection_interfaces__["b" /* SelectionMode */].none ? undefined : isSelected;
        this._classNames = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._classNames, getClassNames(styles, {
            theme: theme,
            isSelected: isSelected,
            canSelect: !isContentUnselectable,
            anySelected: isSelectionModal,
            checkboxCellClassName: checkboxCellClassName,
            droppingClassName: droppingClassName,
            className: className,
            compact: compact,
            enableUpdateAnimations: enableUpdateAnimations
        }));
        var rowClassNames = {
            isMultiline: this._classNames.isMultiline,
            isRowHeader: this._classNames.isRowHeader,
            shimmerIconPlaceholder: this._classNames.shimmerIconPlaceholder,
            shimmer: this._classNames.shimmer,
            cell: this._classNames.cell,
            cellAnimation: this._classNames.cellAnimation,
            cellPadded: this._classNames.cellPadded,
            cellUnpadded: this._classNames.cellUnpadded,
            fields: this._classNames.fields
        };
        // Only re-assign rowClassNames when classNames have changed.
        // Otherwise, they will cause DetailsRowFields to unnecessarily
        // re-render, see https://github.com/OfficeDev/office-ui-fabric-react/pull/8799.
        // Refactor DetailsRowFields to generate own styles to remove need for this.
        if (!Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_27" /* shallowCompare */])(this._rowClassNames || {}, rowClassNames)) {
            this._rowClassNames = rowClassNames;
        }
        var rowFields = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](RowFields, { rowClassNames: this._rowClassNames, cellsByColumn: cellsByColumn, columns: columns, item: item, itemIndex: itemIndex, columnStartIndex: showCheckbox ? 1 : 0, onRenderItemColumn: onRenderItemColumn, shimmer: shimmer, getCellValueKey: getCellValueKey, enableUpdateAnimations: enableUpdateAnimations }));
        // Rendering Shimmer Animation outside the focus zone
        if (shimmer) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["t" /* css */])(showCheckbox && this._classNames.shimmerLeftBorder, !compact && this._classNames.shimmerBottomBorder) }, rowFields));
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__FocusZone__["a" /* FocusZone */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ "data-is-focusable": true }, Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["R" /* getNativeProps */])(this.props, __WEBPACK_IMPORTED_MODULE_3__Utilities__["w" /* divProperties */]), (typeof isDraggable === 'boolean'
            ? {
                'data-is-draggable': isDraggable,
                draggable: isDraggable
            }
            : {}), { direction: __WEBPACK_IMPORTED_MODULE_8__FocusZone__["b" /* FocusZoneDirection */].horizontal, ref: this._onRootRef, componentRef: this._focusZone, role: "row", "aria-label": ariaLabel, "aria-describedby": ariaDescribedBy, className: this._classNames.root, "data-selection-index": itemIndex, "data-item-index": itemIndex, "aria-rowindex": itemIndex + 1, "data-automationid": "DetailsRow", style: { minWidth: rowWidth }, "aria-selected": ariaSelected, allowFocusRoot: true }),
            showCheckbox && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { role: "gridcell", "aria-colindex": 1, "data-selection-toggle": true, className: this._classNames.checkCell }, onRenderCheck({
                selected: isSelected,
                anySelected: isSelectionModal,
                'aria-label': checkButtonAriaLabel,
                canSelect: canSelect,
                compact: compact,
                className: this._classNames.check,
                theme: theme,
                isVisible: checkboxVisibility === __WEBPACK_IMPORTED_MODULE_4__DetailsList_types__["a" /* CheckboxVisibility */].always,
                onRenderDetailsCheckbox: onRenderDetailsCheckbox,
                useFastIcons: useFastIcons
            }))),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__GroupedList_GroupSpacer__["a" /* GroupSpacer */], { indentWidth: indentWidth, count: groupNestingDepth - (this.props.collapseAllVisibility === __WEBPACK_IMPORTED_MODULE_10__GroupedList__["a" /* CollapseAllVisibility */].hidden ? 1 : 0) }),
            item && rowFields,
            columnMeasureInfo && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { role: "presentation", className: Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["t" /* css */])(this._classNames.cellMeasurer, this._classNames.cell), ref: this._cellMeasurer },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](RowFields, { rowClassNames: this._rowClassNames, columns: [columnMeasureInfo.column], item: item, itemIndex: itemIndex, columnStartIndex: (showCheckbox ? 1 : 0) + columns.length, onRenderItemColumn: onRenderItemColumn, getCellValueKey: getCellValueKey }))),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { role: "checkbox", className: this._classNames.checkCover, "aria-checked": isSelected, "data-selection-toggle": true })));
    };
    /**
     * measure cell at index. and call the call back with the measured cell width when finish measure
     *
     * @param index - The cell index
     * @param onMeasureDone - The call back function when finish measure
     */
    DetailsRowBase.prototype.measureCell = function (index, onMeasureDone) {
        var _a = this.props.columns, columns = _a === void 0 ? NO_COLUMNS : _a;
        var column = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, columns[index]);
        column.minWidth = 0;
        column.maxWidth = 999999;
        delete column.calculatedWidth;
        this.setState({
            columnMeasureInfo: {
                index: index,
                column: column,
                onMeasureDone: onMeasureDone
            }
        });
    };
    DetailsRowBase.prototype.focus = function (forceIntoFirstElement) {
        if (forceIntoFirstElement === void 0) { forceIntoFirstElement = false; }
        return !!this._focusZone.current && this._focusZone.current.focus(forceIntoFirstElement);
    };
    DetailsRowBase.prototype._onRenderCheck = function (props) {
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__DetailsRowCheck__["a" /* DetailsRowCheck */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, props));
    };
    DetailsRowBase.prototype._getSelectionState = function (props) {
        var itemIndex = props.itemIndex, selection = props.selection;
        return {
            isSelected: !!selection && selection.isIndexSelected(itemIndex),
            isSelectionModal: !!selection && !!selection.isModal && selection.isModal()
        };
    };
    DetailsRowBase.prototype._getRowDragDropOptions = function () {
        var _a = this.props, item = _a.item, itemIndex = _a.itemIndex, dragDropEvents = _a.dragDropEvents, eventsToRegister = _a.eventsToRegister;
        var options = {
            eventMap: eventsToRegister,
            selectionIndex: itemIndex,
            context: { data: item, index: itemIndex },
            canDrag: dragDropEvents.canDrag,
            canDrop: dragDropEvents.canDrop,
            onDragStart: dragDropEvents.onDragStart,
            updateDropState: this._updateDroppingState,
            onDrop: dragDropEvents.onDrop,
            onDragEnd: dragDropEvents.onDragEnd
        };
        return options;
    };
    return DetailsRowBase;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=DetailsRow.base.js.map

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseDecorator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utilities__ = __webpack_require__(1);


var BaseDecorator = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](BaseDecorator, _super);
    function BaseDecorator(props) {
        var _this = _super.call(this, props) || this;
        // tslint:disable-next-line:typedef
        _this._skipComponentRefResolution = true;
        _this._updateComposedComponentRef = _this._updateComposedComponentRef.bind(_this);
        return _this;
    }
    /**
     * Updates the ref to the component composed by the decorator, which will also take care of hoisting
     * (and unhoisting as appropriate) methods from said component.
     *
     * Pass this method as the argument to the 'ref' property of the composed component.
     */
    BaseDecorator.prototype._updateComposedComponentRef = function (composedComponentInstance) {
        this._composedComponentInstance = composedComponentInstance;
        if (composedComponentInstance) {
            this._hoisted = Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["_1" /* hoistMethods */])(this, composedComponentInstance);
        }
        else if (this._hoisted) {
            Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["_32" /* unhoistMethods */])(this, this._hoisted);
        }
    };
    return BaseDecorator;
}(__WEBPACK_IMPORTED_MODULE_1__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=BaseDecorator.js.map

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getSubmenuItems */
/* unused harmony export canAnyMenuItemsCheck */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContextualMenuBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ContextualMenu_types__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_DirectionalHint__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FocusZone__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_contextualMenu_index__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utilities_decorators_withResponsiveMode__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Callout__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ContextualMenuItem__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ContextualMenuItemWrapper_index__ = __webpack_require__(1745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ContextualMenu_classNames__ = __webpack_require__(411);














var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["r" /* classNamesFunction */])({
    disableCaching: true
});
var getContextualMenuItemClassNames = Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["r" /* classNamesFunction */])({
    disableCaching: true
});
function getSubmenuItems(item) {
    return item.subMenuProps ? item.subMenuProps.items : item.items;
}
/**
 * Returns true if a list of menu items can contain a checkbox
 */
function canAnyMenuItemsCheck(items) {
    return items.some(function (item) {
        if (item.canCheck) {
            return true;
        }
        // If the item is a section, check if any of the items in the section can check.
        if (item.sectionProps && item.sectionProps.items.some(function (submenuItem) { return submenuItem.canCheck === true; })) {
            return true;
        }
        return false;
    });
}
var NavigationIdleDelay = 250 /* ms */;
var ContextualMenuBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ContextualMenuBase, _super);
    function ContextualMenuBase(props) {
        var _this = _super.call(this, props) || this;
        _this._mounted = false;
        _this.dismiss = function (ev, dismissAll) {
            var onDismiss = _this.props.onDismiss;
            if (onDismiss) {
                onDismiss(ev, dismissAll);
            }
        };
        _this._onRenderMenuList = function (menuListProps, defaultRender) {
            var indexCorrection = 0;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("ul", { className: _this._classNames.list, onKeyDown: _this._onKeyDown, onKeyUp: _this._onKeyUp, role: "menu" }, menuListProps.items.map(function (item, index) {
                var menuItem = _this._renderMenuItem(item, index, indexCorrection, menuListProps.totalItemCount, menuListProps.hasCheckmarks, menuListProps.hasIcons);
                if (item.itemType !== __WEBPACK_IMPORTED_MODULE_2__ContextualMenu_types__["a" /* ContextualMenuItemType */].Divider && item.itemType !== __WEBPACK_IMPORTED_MODULE_2__ContextualMenu_types__["a" /* ContextualMenuItemType */].Header) {
                    var indexIncrease = item.customOnRenderListLength ? item.customOnRenderListLength : 1;
                    indexCorrection += indexIncrease;
                }
                return menuItem;
            })));
        };
        _this._onKeyDown = function (ev) {
            // Take note if we are processing an alt (option) or meta (command) keydown.
            // See comment in _shouldHandleKeyUp for reasoning.
            _this._lastKeyDownWasAltOrMeta = _this._isAltOrMeta(ev);
            // On Mac, pressing escape dismisses all levels of native context menus
            var dismissAllMenus = ev.which === __WEBPACK_IMPORTED_MODULE_5__Utilities__["g" /* KeyCodes */].escape && (Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["_13" /* isMac */])() || Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["_12" /* isIOS */])());
            return _this._keyHandler(ev, _this._shouldHandleKeyDown, dismissAllMenus);
        };
        _this._shouldHandleKeyDown = function (ev) {
            return ev.which === __WEBPACK_IMPORTED_MODULE_5__Utilities__["g" /* KeyCodes */].escape || _this._shouldCloseSubMenu(ev) || (ev.which === __WEBPACK_IMPORTED_MODULE_5__Utilities__["g" /* KeyCodes */].up && (ev.altKey || ev.metaKey));
        };
        _this._onMenuFocusCapture = function (ev) {
            if (_this.props.delayUpdateFocusOnHover) {
                _this._shouldUpdateFocusOnMouseEvent = true;
            }
        };
        _this._onKeyUp = function (ev) {
            return _this._keyHandler(ev, _this._shouldHandleKeyUp, true /* dismissAllMenus */);
        };
        /**
         * We close the menu on key up only if ALL of the following are true:
         * - Most recent key down was alt or meta (command)
         * - The alt/meta key down was NOT followed by some other key (such as down/up arrow to
         *   expand/collapse the menu)
         * - We're not on a Mac (or iOS)
         *
         * This is because on Windows, pressing alt moves focus to the application menu bar or similar,
         * closing any open context menus. There is not a similar behavior on Macs.
         */
        _this._shouldHandleKeyUp = function (ev) {
            var keyPressIsAltOrMetaAlone = _this._lastKeyDownWasAltOrMeta && _this._isAltOrMeta(ev);
            _this._lastKeyDownWasAltOrMeta = false;
            return !!keyPressIsAltOrMetaAlone && !(Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["_12" /* isIOS */])() || Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["_13" /* isMac */])());
        };
        /**
         * Calls `shouldHandleKey` to determine whether the keyboard event should be handled;
         * if so, stops event propagation and dismisses menu(s).
         * @param ev - The keyboard event.
         * @param shouldHandleKey - Returns whether we should handle this keyboard event.
         * @param dismissAllMenus - If true, dismiss all menus. Otherwise, dismiss only the current menu.
         * Only does anything if `shouldHandleKey` returns true.
         * @returns Whether the event was handled.
         */
        _this._keyHandler = function (ev, shouldHandleKey, dismissAllMenus) {
            var handled = false;
            if (shouldHandleKey(ev)) {
                _this._isFocusingPreviousElement = true;
                ev.preventDefault();
                ev.stopPropagation();
                _this.dismiss(ev, dismissAllMenus);
                handled = true;
            }
            return handled;
        };
        /**
         * Checks if the submenu should be closed
         */
        _this._shouldCloseSubMenu = function (ev) {
            var submenuCloseKey = Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["V" /* getRTL */])() ? __WEBPACK_IMPORTED_MODULE_5__Utilities__["g" /* KeyCodes */].right : __WEBPACK_IMPORTED_MODULE_5__Utilities__["g" /* KeyCodes */].left;
            if (ev.which !== submenuCloseKey || !_this.props.isSubMenu) {
                return false;
            }
            return (_this._adjustedFocusZoneProps.direction === __WEBPACK_IMPORTED_MODULE_4__FocusZone__["b" /* FocusZoneDirection */].vertical ||
                (!!_this._adjustedFocusZoneProps.checkForNoWrap && !Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["_28" /* shouldWrapFocus */])(ev.target, 'data-no-horizontal-wrap')));
        };
        _this._onMenuKeyDown = function (ev) {
            // Mark as handled if onKeyDown returns true (for handling collapse cases)
            // or if we are attempting to expand a submenu
            var handled = _this._onKeyDown(ev);
            if (handled || !_this._host) {
                return;
            }
            // If we have a modifier key being pressed, we do not want to move focus.
            // Otherwise, handle up and down keys.
            var hasModifier = !!(ev.altKey || ev.metaKey);
            var isUp = ev.which === __WEBPACK_IMPORTED_MODULE_5__Utilities__["g" /* KeyCodes */].up;
            var isDown = ev.which === __WEBPACK_IMPORTED_MODULE_5__Utilities__["g" /* KeyCodes */].down;
            if (!hasModifier && (isUp || isDown)) {
                var elementToFocus = isUp
                    ? Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["P" /* getLastFocusable */])(_this._host, _this._host.lastChild, true)
                    : Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["K" /* getFirstFocusable */])(_this._host, _this._host.firstChild, true);
                if (elementToFocus) {
                    elementToFocus.focus();
                    ev.preventDefault();
                    ev.stopPropagation();
                }
            }
        };
        /**
         * Scroll handler for the callout to make sure the mouse events
         * for updating focus are not interacting during scroll
         */
        _this._onScroll = function () {
            if (!_this._isScrollIdle && _this._scrollIdleTimeoutId !== undefined) {
                _this._async.clearTimeout(_this._scrollIdleTimeoutId);
                _this._scrollIdleTimeoutId = undefined;
            }
            else {
                _this._isScrollIdle = false;
            }
            _this._scrollIdleTimeoutId = _this._async.setTimeout(function () {
                _this._isScrollIdle = true;
            }, NavigationIdleDelay);
        };
        _this._onItemMouseEnterBase = function (item, ev, target) {
            if (_this._shouldIgnoreMouseEvent()) {
                return;
            }
            _this._updateFocusOnMouseEvent(item, ev, target);
        };
        _this._onItemMouseMoveBase = function (item, ev, target) {
            var targetElement = ev.currentTarget;
            // Always do this check to make sure we record a mouseMove if needed (even if we are timed out)
            if (_this._shouldUpdateFocusOnMouseEvent) {
                _this._gotMouseMove = true;
            }
            else {
                return;
            }
            if (!_this._isScrollIdle ||
                _this._enterTimerId !== undefined ||
                targetElement === _this._targetWindow.document.activeElement) {
                return;
            }
            _this._updateFocusOnMouseEvent(item, ev, target);
        };
        _this._onMouseItemLeave = function (item, ev) {
            if (_this._shouldIgnoreMouseEvent()) {
                return;
            }
            if (_this._enterTimerId !== undefined) {
                _this._async.clearTimeout(_this._enterTimerId);
                _this._enterTimerId = undefined;
            }
            if (_this.state.expandedMenuItemKey !== undefined) {
                return;
            }
            /**
             * IE11 focus() method forces parents to scroll to top of element.
             * Edge and IE expose a setActive() function for focusable divs that
             * sets the page focus but does not scroll the parent element.
             */
            if (_this._host.setActive) {
                try {
                    _this._host.setActive();
                }
                catch (e) {
                    /* no-op */
                }
            }
            else {
                _this._host.focus();
            }
        };
        _this._onItemMouseDown = function (item, ev) {
            if (item.onMouseDown) {
                item.onMouseDown(item, ev);
            }
        };
        _this._onItemClick = function (item, ev) {
            _this._onItemClickBase(item, ev, ev.currentTarget);
        };
        _this._onItemClickBase = function (item, ev, target) {
            var items = getSubmenuItems(item);
            // Cancel a async menu item hover timeout action from being taken and instead
            // just trigger the click event instead.
            _this._cancelSubMenuTimer();
            if (!Object(__WEBPACK_IMPORTED_MODULE_6__utilities_contextualMenu_index__["b" /* hasSubmenu */])(item) && (!items || !items.length)) {
                // This is an item without a menu. Click it.
                _this._executeItemClick(item, ev);
            }
            else {
                if (item.key !== _this.state.expandedMenuItemKey) {
                    // This has a collapsed sub menu. Expand it.
                    _this.setState({
                        // When Edge + Narrator are used together (regardless of if the button is in a form or not), pressing
                        // "Enter" fires this method and not _onMenuKeyDown. Checking ev.nativeEvent.detail differentiates
                        // between a real click event and a keypress event (detail should be the number of mouse clicks).
                        // ...Plot twist! For a real click event in IE 11, detail is always 0 (Edge sets it properly to 1).
                        // So we also check the pointerType property, which both Edge and IE set to "mouse" for real clicks
                        // and "" for pressing "Enter" with Narrator on.
                        expandedByMouseClick: ev.nativeEvent.detail !== 0 || ev.nativeEvent.pointerType === 'mouse'
                    });
                    _this._onItemSubMenuExpand(item, target);
                }
            }
            ev.stopPropagation();
            ev.preventDefault();
        };
        _this._onAnchorClick = function (item, ev) {
            _this._executeItemClick(item, ev);
            ev.stopPropagation();
        };
        _this._executeItemClick = function (item, ev) {
            if (item.disabled || item.isDisabled) {
                return;
            }
            var dismiss = false;
            if (item.onClick) {
                dismiss = !!item.onClick(ev, item);
            }
            else if (_this.props.onItemClick) {
                dismiss = !!_this.props.onItemClick(ev, item);
            }
            (dismiss || !ev.defaultPrevented) && _this.dismiss(ev, true);
        };
        _this._onItemKeyDown = function (item, ev) {
            var openKey = Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["V" /* getRTL */])() ? __WEBPACK_IMPORTED_MODULE_5__Utilities__["g" /* KeyCodes */].left : __WEBPACK_IMPORTED_MODULE_5__Utilities__["g" /* KeyCodes */].right;
            if (!item.disabled &&
                (ev.which === openKey || ev.which === __WEBPACK_IMPORTED_MODULE_5__Utilities__["g" /* KeyCodes */].enter || (ev.which === __WEBPACK_IMPORTED_MODULE_5__Utilities__["g" /* KeyCodes */].down && (ev.altKey || ev.metaKey)))) {
                _this.setState({
                    expandedByMouseClick: false
                });
                _this._onItemSubMenuExpand(item, ev.currentTarget);
                ev.preventDefault();
            }
        };
        // Cancel a async menu item hover timeout action from being taken and instead
        // do new upcoming behavior
        _this._cancelSubMenuTimer = function () {
            if (_this._enterTimerId !== undefined) {
                _this._async.clearTimeout(_this._enterTimerId);
                _this._enterTimerId = undefined;
            }
        };
        _this._onItemSubMenuExpand = function (item, target) {
            if (_this.state.expandedMenuItemKey !== item.key) {
                if (_this.state.expandedMenuItemKey) {
                    _this._onSubMenuDismiss();
                }
                // Focus the target to ensure when we close it, we're focusing on the correct element.
                target.focus();
                _this.setState({
                    expandedMenuItemKey: item.key,
                    submenuTarget: target
                });
            }
        };
        /**
         * This function is called ASYNCHRONOUSLY, and so there is a chance it is called
         * after the component is unmounted. The _mounted property is added to prevent
         * from calling setState() after unmount. Do NOT copy this pattern in synchronous
         * code.
         */
        _this._onSubMenuDismiss = function (ev, dismissAll) {
            if (dismissAll) {
                _this.dismiss(ev, dismissAll);
            }
            else if (_this._mounted) {
                _this.setState({
                    dismissedMenuItemKey: _this.state.expandedMenuItemKey,
                    expandedMenuItemKey: undefined,
                    submenuTarget: undefined
                });
            }
        };
        _this._getSubMenuId = function (item) {
            var subMenuId = _this.state.subMenuId;
            if (item.subMenuProps && item.subMenuProps.id) {
                subMenuId = item.subMenuProps.id;
            }
            return subMenuId;
        };
        _this._onPointerAndTouchEvent = function (ev) {
            _this._cancelSubMenuTimer();
        };
        _this.state = {
            contextualMenuItems: undefined,
            subMenuId: Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["N" /* getId */])('ContextualMenu')
        };
        _this._warnDeprecations({
            getMenuClassNames: 'styles'
        });
        _this._isFocusingPreviousElement = false;
        _this._isScrollIdle = true;
        _this._shouldUpdateFocusOnMouseEvent = !_this.props.delayUpdateFocusOnHover;
        _this._gotMouseMove = false;
        return _this;
    }
    ContextualMenuBase.prototype.shouldComponentUpdate = function (newProps, newState) {
        if (this.props.hidden && newProps.hidden) {
            // Do not update when hidden.
            return false;
        }
        return !Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["_27" /* shallowCompare */])(this.props, newProps) || !Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["_27" /* shallowCompare */])(this.state, newState);
    };
    ContextualMenuBase.prototype.componentWillUpdate = function (newProps) {
        if (newProps.target !== this.props.target) {
            var newTarget = newProps.target;
            this._setTargetWindowAndElement(newTarget);
        }
        if (newProps.hidden !== this.props.hidden) {
            if (newProps.hidden) {
                this._onMenuClosed();
            }
            else {
                this._onMenuOpened();
                this._previousActiveElement = this._targetWindow ? this._targetWindow.document.activeElement : null;
            }
        }
        if (newProps.delayUpdateFocusOnHover !== this.props.delayUpdateFocusOnHover) {
            // update shouldUpdateFocusOnMouseEvent to follow what was passed in
            this._shouldUpdateFocusOnMouseEvent = !newProps.delayUpdateFocusOnHover;
            // If shouldUpdateFocusOnMouseEvent is false, we need to reset gotMouseMove to false
            this._gotMouseMove = this._shouldUpdateFocusOnMouseEvent && this._gotMouseMove;
        }
    };
    // Invoked once, both on the client and server, immediately before the initial rendering occurs.
    ContextualMenuBase.prototype.componentWillMount = function () {
        var target = this.props.target;
        this._setTargetWindowAndElement(target);
        if (!this.props.hidden) {
            this._previousActiveElement = this._targetWindow ? this._targetWindow.document.activeElement : null;
        }
    };
    // Invoked once, only on the client (not on the server), immediately after the initial rendering occurs.
    ContextualMenuBase.prototype.componentDidMount = function () {
        if (!this.props.hidden) {
            this._onMenuOpened();
        }
        this._mounted = true;
    };
    // Invoked immediately before a component is unmounted from the DOM.
    ContextualMenuBase.prototype.componentWillUnmount = function () {
        this._tryFocusPreviousActiveElement();
        if (this.props.onMenuDismissed) {
            this.props.onMenuDismissed(this.props);
        }
        this._events.dispose();
        this._async.dispose();
        this._mounted = false;
    };
    ContextualMenuBase.prototype.render = function () {
        var _this = this;
        var isBeakVisible = this.props.isBeakVisible;
        var _a = this.props, items = _a.items, labelElementId = _a.labelElementId, id = _a.id, className = _a.className, beakWidth = _a.beakWidth, directionalHint = _a.directionalHint, directionalHintForRTL = _a.directionalHintForRTL, alignTargetEdge = _a.alignTargetEdge, gapSpace = _a.gapSpace, coverTarget = _a.coverTarget, ariaLabel = _a.ariaLabel, doNotLayer = _a.doNotLayer, target = _a.target, bounds = _a.bounds, useTargetWidth = _a.useTargetWidth, useTargetAsMinWidth = _a.useTargetAsMinWidth, directionalHintFixed = _a.directionalHintFixed, shouldFocusOnMount = _a.shouldFocusOnMount, shouldFocusOnContainer = _a.shouldFocusOnContainer, title = _a.title, styles = _a.styles, theme = _a.theme, calloutProps = _a.calloutProps, _b = _a.onRenderSubMenu, onRenderSubMenu = _b === void 0 ? this._onRenderSubMenu : _b, _c = _a.onRenderMenuList, onRenderMenuList = _c === void 0 ? this._onRenderMenuList : _c, focusZoneProps = _a.focusZoneProps, getMenuClassNames = _a.getMenuClassNames;
        this._classNames = getMenuClassNames
            ? getMenuClassNames(theme, className)
            : getClassNames(styles, {
                theme: theme,
                className: className
            });
        var hasIcons = itemsHaveIcons(items);
        function itemsHaveIcons(contextualMenuItems) {
            for (var _i = 0, contextualMenuItems_1 = contextualMenuItems; _i < contextualMenuItems_1.length; _i++) {
                var item = contextualMenuItems_1[_i];
                if (!!item.iconProps) {
                    return true;
                }
                if (item.itemType === __WEBPACK_IMPORTED_MODULE_2__ContextualMenu_types__["a" /* ContextualMenuItemType */].Section && item.sectionProps && itemsHaveIcons(item.sectionProps.items)) {
                    return true;
                }
            }
            return false;
        }
        this._adjustedFocusZoneProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, focusZoneProps, { direction: this._getFocusZoneDirection() });
        var hasCheckmarks = canAnyMenuItemsCheck(items);
        var submenuProps = this.state.expandedMenuItemKey && this.props.hidden !== true ? this._getSubmenuProps() : null;
        isBeakVisible = isBeakVisible === undefined ? this.props.responsiveMode <= __WEBPACK_IMPORTED_MODULE_7__utilities_decorators_withResponsiveMode__["a" /* ResponsiveMode */].medium : isBeakVisible;
        /**
         * When useTargetWidth is true, get the width of the target element and apply it for the context menu container
         */
        var contextMenuStyle;
        var targetAsHtmlElement = this._target;
        if ((useTargetWidth || useTargetAsMinWidth) && targetAsHtmlElement && targetAsHtmlElement.offsetWidth) {
            var targetBoundingRect = targetAsHtmlElement.getBoundingClientRect();
            var targetWidth = targetBoundingRect.width - 2 /* Accounts for 1px border */;
            if (useTargetWidth) {
                contextMenuStyle = {
                    width: targetWidth
                };
            }
            else if (useTargetAsMinWidth) {
                contextMenuStyle = {
                    minWidth: targetWidth
                };
            }
        }
        // The menu should only return if items were provided, if no items were provided then it should not appear.
        if (items && items.length > 0) {
            var totalItemCount = 0;
            for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
                var item = items_1[_i];
                if (item.itemType !== __WEBPACK_IMPORTED_MODULE_2__ContextualMenu_types__["a" /* ContextualMenuItemType */].Divider && item.itemType !== __WEBPACK_IMPORTED_MODULE_2__ContextualMenu_types__["a" /* ContextualMenuItemType */].Header) {
                    var itemCount = item.customOnRenderListLength ? item.customOnRenderListLength : 1;
                    totalItemCount += itemCount;
                }
            }
            var calloutStyles = !getMenuClassNames && this._classNames.subComponentStyles
                ? this._classNames.subComponentStyles.callout
                : undefined;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Callout__["a" /* Callout */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ styles: calloutStyles }, calloutProps, { target: target, isBeakVisible: isBeakVisible, beakWidth: beakWidth, directionalHint: directionalHint, directionalHintForRTL: directionalHintForRTL, gapSpace: gapSpace, coverTarget: coverTarget, doNotLayer: doNotLayer, className: Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["t" /* css */])('ms-ContextualMenu-Callout', calloutProps && calloutProps.className), setInitialFocus: shouldFocusOnMount, onDismiss: this.props.onDismiss, onScroll: this._onScroll, bounds: bounds, directionalHintFixed: directionalHintFixed, alignTargetEdge: alignTargetEdge, hidden: this.props.hidden }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { "aria-label": ariaLabel, "aria-labelledby": labelElementId, style: contextMenuStyle, ref: function (host) { return (_this._host = host); }, id: id, className: this._classNames.container, tabIndex: shouldFocusOnContainer ? 0 : -1, onKeyDown: this._onMenuKeyDown, onKeyUp: this._onKeyUp, onFocusCapture: this._onMenuFocusCapture },
                    title && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.title },
                        " ",
                        title,
                        " "),
                    items && items.length ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__FocusZone__["a" /* FocusZone */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._adjustedFocusZoneProps, { className: this._classNames.root, isCircularNavigation: true, handleTabKey: __WEBPACK_IMPORTED_MODULE_4__FocusZone__["c" /* FocusZoneTabbableElements */].all }), onRenderMenuList({
                        items: items,
                        totalItemCount: totalItemCount,
                        hasCheckmarks: hasCheckmarks,
                        hasIcons: hasIcons
                    }, this._onRenderMenuList))) : null,
                    submenuProps && onRenderSubMenu(submenuProps, this._onRenderSubMenu))));
        }
        else {
            return null;
        }
    };
    ContextualMenuBase.prototype._onMenuOpened = function () {
        this._events.on(this._targetWindow, 'resize', this.dismiss);
        this._shouldUpdateFocusOnMouseEvent = !this.props.delayUpdateFocusOnHover;
        this._gotMouseMove = false;
        this.props.onMenuOpened && this.props.onMenuOpened(this.props);
    };
    ContextualMenuBase.prototype._onMenuClosed = function () {
        this._events.off(this._targetWindow, 'resize', this.dismiss);
        this._tryFocusPreviousActiveElement();
        if (this.props.onMenuDismissed) {
            this.props.onMenuDismissed(this.props);
        }
        this._shouldUpdateFocusOnMouseEvent = !this.props.delayUpdateFocusOnHover;
        // We need to dismiss any submenu related state properties,
        // so that when the menu is shown again, the submenu is collapsed
        this.setState({
            expandedByMouseClick: undefined,
            dismissedMenuItemKey: undefined,
            expandedMenuItemKey: undefined,
            submenuTarget: undefined
        });
    };
    ContextualMenuBase.prototype._tryFocusPreviousActiveElement = function () {
        var _this = this;
        if (this._isFocusingPreviousElement && this._previousActiveElement) {
            // This slight delay is required so that we can unwind the stack, const react try to mess with focus, and then
            // apply the correct focus. Without the setTimeout, we end up focusing the correct thing, and then React wants
            // to reset the focus back to the thing it thinks should have been focused.
            // Note: Cannot be replaced by this._async.setTimout because those will be removed by the time this is called.
            setTimeout(function () {
                _this._previousActiveElement && _this._previousActiveElement.focus();
            }, 0);
        }
    };
    /**
     * Gets the focusZoneDirection by using the arrowDirection if specified,
     * the direction specificed in the focusZoneProps, or defaults to FocusZoneDirection.vertical
     */
    ContextualMenuBase.prototype._getFocusZoneDirection = function () {
        var focusZoneProps = this.props.focusZoneProps;
        return focusZoneProps && focusZoneProps.direction !== undefined ? focusZoneProps.direction : __WEBPACK_IMPORTED_MODULE_4__FocusZone__["b" /* FocusZoneDirection */].vertical;
    };
    ContextualMenuBase.prototype._onRenderSubMenu = function (subMenuProps, defaultRender) {
        throw Error('ContextualMenuBase: onRenderSubMenu callback is null or undefined. ' +
            'Please ensure to set `onRenderSubMenu` property either manually or with `styled` helper.');
    };
    ContextualMenuBase.prototype._renderMenuItem = function (item, index, focusableElementIndex, totalItemCount, hasCheckmarks, hasIcons) {
        var renderedItems = [];
        var iconProps = item.iconProps || { iconName: 'None' };
        var getItemClassNames = item.getItemClassNames, itemProps = item.itemProps;
        var styles = itemProps ? itemProps.styles : undefined;
        // We only send a dividerClassName when the item to be rendered is a divider. For all other cases, the default divider style is used.
        var dividerClassName = item.itemType === __WEBPACK_IMPORTED_MODULE_2__ContextualMenu_types__["a" /* ContextualMenuItemType */].Divider ? item.className : undefined;
        var subMenuIconClassName = item.submenuIconProps ? item.submenuIconProps.className : '';
        var itemClassNames;
        // IContextualMenuItem#getItemClassNames for backwards compatibility
        // otherwise uses mergeStyles for class names.
        if (getItemClassNames) {
            itemClassNames = getItemClassNames(this.props.theme, Object(__WEBPACK_IMPORTED_MODULE_6__utilities_contextualMenu_index__["c" /* isItemDisabled */])(item), this.state.expandedMenuItemKey === item.key, !!Object(__WEBPACK_IMPORTED_MODULE_6__utilities_contextualMenu_index__["a" /* getIsChecked */])(item), !!item.href, iconProps.iconName !== 'None', item.className, dividerClassName, iconProps.className, subMenuIconClassName, item.primaryDisabled);
        }
        else {
            var itemStyleProps = {
                theme: this.props.theme,
                disabled: Object(__WEBPACK_IMPORTED_MODULE_6__utilities_contextualMenu_index__["c" /* isItemDisabled */])(item),
                expanded: this.state.expandedMenuItemKey === item.key,
                checked: !!Object(__WEBPACK_IMPORTED_MODULE_6__utilities_contextualMenu_index__["a" /* getIsChecked */])(item),
                isAnchorLink: !!item.href,
                knownIcon: iconProps.iconName !== 'None',
                itemClassName: item.className,
                dividerClassName: dividerClassName,
                iconClassName: iconProps.className,
                subMenuClassName: subMenuIconClassName,
                primaryDisabled: item.primaryDisabled
            };
            var menuItemStyles = this._classNames.subComponentStyles
                ? this._classNames.subComponentStyles.menuItem
                : undefined;
            // We need to generate default styles then override if styles are provided
            // since the ContextualMenu currently handles item classNames.
            itemClassNames = Object(__WEBPACK_IMPORTED_MODULE_11__Styling__["E" /* mergeStyleSets */])(getContextualMenuItemClassNames(__WEBPACK_IMPORTED_MODULE_12__ContextualMenu_classNames__["a" /* getItemStyles */], itemStyleProps), getContextualMenuItemClassNames(menuItemStyles, itemStyleProps), getContextualMenuItemClassNames(styles, itemStyleProps));
        }
        if (item.text === '-' || item.name === '-') {
            item.itemType = __WEBPACK_IMPORTED_MODULE_2__ContextualMenu_types__["a" /* ContextualMenuItemType */].Divider;
        }
        switch (item.itemType) {
            case __WEBPACK_IMPORTED_MODULE_2__ContextualMenu_types__["a" /* ContextualMenuItemType */].Divider:
                renderedItems.push(this._renderSeparator(index, itemClassNames));
                break;
            case __WEBPACK_IMPORTED_MODULE_2__ContextualMenu_types__["a" /* ContextualMenuItemType */].Header:
                renderedItems.push(this._renderSeparator(index, itemClassNames));
                var headerItem = this._renderHeaderMenuItem(item, itemClassNames, index, hasCheckmarks, hasIcons);
                renderedItems.push(this._renderListItem(headerItem, item.key || index, itemClassNames, item.title));
                break;
            case __WEBPACK_IMPORTED_MODULE_2__ContextualMenu_types__["a" /* ContextualMenuItemType */].Section:
                renderedItems.push(this._renderSectionItem(item, itemClassNames, index, hasCheckmarks, hasIcons));
                break;
            default:
                var menuItem = this._renderNormalItem(item, itemClassNames, index, focusableElementIndex, totalItemCount, hasCheckmarks, hasIcons);
                renderedItems.push(this._renderListItem(menuItem, item.key || index, itemClassNames, item.title));
                break;
        }
        return renderedItems;
    };
    ContextualMenuBase.prototype._renderSectionItem = function (sectionItem, menuClassNames, index, hasCheckmarks, hasIcons) {
        var _this = this;
        var sectionProps = sectionItem.sectionProps;
        if (!sectionProps) {
            return;
        }
        var headerItem;
        if (sectionProps.title) {
            var headerContextualMenuItem = {
                key: "section-" + sectionProps.title + "-title",
                itemType: __WEBPACK_IMPORTED_MODULE_2__ContextualMenu_types__["a" /* ContextualMenuItemType */].Header,
                text: sectionProps.title
            };
            headerItem = this._renderHeaderMenuItem(headerContextualMenuItem, menuClassNames, index, hasCheckmarks, hasIcons);
        }
        if (sectionProps.items && sectionProps.items.length > 0) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("li", { role: "presentation", key: sectionProps.key || sectionItem.key || "section-" + index },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { role: "group" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("ul", { className: this._classNames.list },
                        sectionProps.topDivider && this._renderSeparator(index, menuClassNames, true, true),
                        headerItem && this._renderListItem(headerItem, sectionItem.key || index, menuClassNames, sectionItem.title),
                        sectionProps.items.map(function (contextualMenuItem, itemsIndex) {
                            return _this._renderMenuItem(contextualMenuItem, itemsIndex, itemsIndex, sectionProps.items.length, hasCheckmarks, hasIcons);
                        }),
                        sectionProps.bottomDivider && this._renderSeparator(index, menuClassNames, false, true)))));
        }
    };
    ContextualMenuBase.prototype._renderListItem = function (content, key, classNames, title) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("li", { role: "presentation", title: title, key: key, className: classNames.item }, content));
    };
    ContextualMenuBase.prototype._renderSeparator = function (index, classNames, top, fromSection) {
        if (fromSection || index > 0) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("li", { role: "separator", key: 'separator-' + index + (top === undefined ? '' : top ? '-top' : '-bottom'), className: classNames.divider, "aria-hidden": "true" }));
        }
        return null;
    };
    ContextualMenuBase.prototype._renderNormalItem = function (item, classNames, index, focusableElementIndex, totalItemCount, hasCheckmarks, hasIcons) {
        if (item.onRender) {
            return item.onRender(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ 'aria-posinset': focusableElementIndex + 1, 'aria-setsize': totalItemCount }, item), this.dismiss);
        }
        if (item.href) {
            return this._renderAnchorMenuItem(item, classNames, index, focusableElementIndex, totalItemCount, hasCheckmarks, hasIcons);
        }
        if (item.split && Object(__WEBPACK_IMPORTED_MODULE_6__utilities_contextualMenu_index__["b" /* hasSubmenu */])(item)) {
            return this._renderSplitButton(item, classNames, index, focusableElementIndex, totalItemCount, hasCheckmarks, hasIcons);
        }
        return this._renderButtonItem(item, classNames, index, focusableElementIndex, totalItemCount, hasCheckmarks, hasIcons);
    };
    ContextualMenuBase.prototype._renderHeaderMenuItem = function (item, classNames, index, hasCheckmarks, hasIcons) {
        var _a = this.props.contextualMenuItemAs, ChildrenRenderer = _a === void 0 ? __WEBPACK_IMPORTED_MODULE_9__ContextualMenuItem__["a" /* ContextualMenuItem */] : _a;
        var itemProps = item.itemProps;
        var divHtmlProperties = itemProps && Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["R" /* getNativeProps */])(itemProps, __WEBPACK_IMPORTED_MODULE_5__Utilities__["w" /* divProperties */]);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ className: this._classNames.header }, divHtmlProperties, { style: item.style }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ChildrenRenderer, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ item: item, classNames: classNames, index: index, onCheckmarkClick: hasCheckmarks ? this._onItemClick : undefined, hasIcons: hasIcons }, itemProps))));
    };
    ContextualMenuBase.prototype._renderAnchorMenuItem = function (item, classNames, index, focusableElementIndex, totalItemCount, hasCheckmarks, hasIcons) {
        var contextualMenuItemAs = this.props.contextualMenuItemAs;
        var expandedMenuItemKey = this.state.expandedMenuItemKey;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__ContextualMenuItemWrapper_index__["a" /* ContextualMenuAnchor */], { item: item, classNames: classNames, index: index, focusableElementIndex: focusableElementIndex, totalItemCount: totalItemCount, hasCheckmarks: hasCheckmarks, hasIcons: hasIcons, contextualMenuItemAs: contextualMenuItemAs, onItemMouseEnter: this._onItemMouseEnterBase, onItemMouseLeave: this._onMouseItemLeave, onItemMouseMove: this._onItemMouseMoveBase, onItemMouseDown: this._onItemMouseDown, executeItemClick: this._executeItemClick, onItemClick: this._onAnchorClick, onItemKeyDown: this._onItemKeyDown, getSubMenuId: this._getSubMenuId, expandedMenuItemKey: expandedMenuItemKey, openSubMenu: this._onItemSubMenuExpand, dismissSubMenu: this._onSubMenuDismiss, dismissMenu: this.dismiss }));
    };
    ContextualMenuBase.prototype._renderButtonItem = function (item, classNames, index, focusableElementIndex, totalItemCount, hasCheckmarks, hasIcons) {
        var contextualMenuItemAs = this.props.contextualMenuItemAs;
        var expandedMenuItemKey = this.state.expandedMenuItemKey;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__ContextualMenuItemWrapper_index__["b" /* ContextualMenuButton */], { item: item, classNames: classNames, index: index, focusableElementIndex: focusableElementIndex, totalItemCount: totalItemCount, hasCheckmarks: hasCheckmarks, hasIcons: hasIcons, contextualMenuItemAs: contextualMenuItemAs, onItemMouseEnter: this._onItemMouseEnterBase, onItemMouseLeave: this._onMouseItemLeave, onItemMouseMove: this._onItemMouseMoveBase, onItemMouseDown: this._onItemMouseDown, executeItemClick: this._executeItemClick, onItemClick: this._onItemClick, onItemClickBase: this._onItemClickBase, onItemKeyDown: this._onItemKeyDown, getSubMenuId: this._getSubMenuId, expandedMenuItemKey: expandedMenuItemKey, openSubMenu: this._onItemSubMenuExpand, dismissSubMenu: this._onSubMenuDismiss, dismissMenu: this.dismiss }));
    };
    ContextualMenuBase.prototype._renderSplitButton = function (item, classNames, index, focusableElementIndex, totalItemCount, hasCheckmarks, hasIcons) {
        var contextualMenuItemAs = this.props.contextualMenuItemAs;
        var expandedMenuItemKey = this.state.expandedMenuItemKey;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__ContextualMenuItemWrapper_index__["c" /* ContextualMenuSplitButton */], { item: item, classNames: classNames, index: index, focusableElementIndex: focusableElementIndex, totalItemCount: totalItemCount, hasCheckmarks: hasCheckmarks, hasIcons: hasIcons, contextualMenuItemAs: contextualMenuItemAs, onItemMouseEnter: this._onItemMouseEnterBase, onItemMouseLeave: this._onMouseItemLeave, onItemMouseMove: this._onItemMouseMoveBase, onItemMouseDown: this._onItemMouseDown, executeItemClick: this._executeItemClick, onItemClick: this._onItemClick, onItemClickBase: this._onItemClickBase, onItemKeyDown: this._onItemKeyDown, openSubMenu: this._onItemSubMenuExpand, dismissSubMenu: this._onSubMenuDismiss, dismissMenu: this.dismiss, expandedMenuItemKey: expandedMenuItemKey, onTap: this._onPointerAndTouchEvent }));
    };
    /**
     * Returns true if the key for the event is alt (Mac option) or meta (Mac command).
     */
    ContextualMenuBase.prototype._isAltOrMeta = function (ev) {
        return ev.which === __WEBPACK_IMPORTED_MODULE_5__Utilities__["g" /* KeyCodes */].alt || ev.key === 'Meta';
    };
    ContextualMenuBase.prototype._shouldIgnoreMouseEvent = function () {
        return !this._isScrollIdle || !this._gotMouseMove;
    };
    /**
     * Handles updating focus when mouseEnter or mouseMove fire.
     * As part of updating focus, This function will also update
     * the expand/collapse state accordingly.
     */
    ContextualMenuBase.prototype._updateFocusOnMouseEvent = function (item, ev, target) {
        var _this = this;
        var targetElement = target ? target : ev.currentTarget;
        var _a = this.props.subMenuHoverDelay, timeoutDuration = _a === void 0 ? NavigationIdleDelay : _a;
        if (item.key === this.state.expandedMenuItemKey) {
            return;
        }
        if (this._enterTimerId !== undefined) {
            this._async.clearTimeout(this._enterTimerId);
            this._enterTimerId = undefined;
        }
        // If the menu is not expanded we can update focus without any delay
        if (this.state.expandedMenuItemKey === undefined) {
            targetElement.focus();
        }
        // Delay updating expanding/dismissing the submenu
        // and only set focus if we have not already done so
        if (Object(__WEBPACK_IMPORTED_MODULE_6__utilities_contextualMenu_index__["b" /* hasSubmenu */])(item)) {
            ev.stopPropagation();
            this._enterTimerId = this._async.setTimeout(function () {
                targetElement.focus();
                _this.setState({
                    expandedByMouseClick: true
                });
                _this._onItemSubMenuExpand(item, targetElement);
                _this._enterTimerId = undefined;
            }, timeoutDuration);
        }
        else {
            this._enterTimerId = this._async.setTimeout(function () {
                _this._onSubMenuDismiss(ev);
                targetElement.focus();
                _this._enterTimerId = undefined;
            }, timeoutDuration);
        }
    };
    ContextualMenuBase.prototype._getSubmenuProps = function () {
        var _a = this.state, submenuTarget = _a.submenuTarget, expandedMenuItemKey = _a.expandedMenuItemKey;
        var item = this._findItemByKey(expandedMenuItemKey);
        var submenuProps = null;
        if (item) {
            submenuProps = {
                items: getSubmenuItems(item),
                target: submenuTarget,
                onDismiss: this._onSubMenuDismiss,
                isSubMenu: true,
                id: this.state.subMenuId,
                shouldFocusOnMount: true,
                shouldFocusOnContainer: this.state.expandedByMouseClick,
                directionalHint: Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["V" /* getRTL */])() ? __WEBPACK_IMPORTED_MODULE_3__common_DirectionalHint__["a" /* DirectionalHint */].leftTopEdge : __WEBPACK_IMPORTED_MODULE_3__common_DirectionalHint__["a" /* DirectionalHint */].rightTopEdge,
                className: this.props.className,
                gapSpace: 0,
                isBeakVisible: false
            };
            if (item.subMenuProps) {
                Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["n" /* assign */])(submenuProps, item.subMenuProps);
            }
        }
        return submenuProps;
    };
    ContextualMenuBase.prototype._findItemByKey = function (key) {
        var items = this.props.items;
        return this._findItemByKeyFromItems(key, items);
    };
    /**
     * Returns the item that mathes a given key if any.
     * @param key - The key of the item to match
     * @param items - The items to look for the key
     */
    ContextualMenuBase.prototype._findItemByKeyFromItems = function (key, items) {
        for (var _i = 0, items_2 = items; _i < items_2.length; _i++) {
            var item = items_2[_i];
            if (item.itemType === __WEBPACK_IMPORTED_MODULE_2__ContextualMenu_types__["a" /* ContextualMenuItemType */].Section && item.sectionProps) {
                var match = this._findItemByKeyFromItems(key, item.sectionProps.items);
                if (match) {
                    return match;
                }
            }
            else if (item.key && item.key === key) {
                return item;
            }
        }
    };
    ContextualMenuBase.prototype._setTargetWindowAndElement = function (target) {
        var currentElement = this._host;
        if (target) {
            if (typeof target === 'string') {
                var currentDoc = Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["I" /* getDocument */])(currentElement);
                this._target = currentDoc ? currentDoc.querySelector(target) : null;
                this._targetWindow = Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["Z" /* getWindow */])(currentElement);
            }
            else if (target.stopPropagation) {
                this._targetWindow = Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["Z" /* getWindow */])(target.toElement);
                this._target = target;
            }
            else if (target.x !== undefined && target.y !== undefined) {
                this._targetWindow = Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["Z" /* getWindow */])(currentElement);
                this._target = target;
            }
            else {
                var targetElement = target;
                this._targetWindow = Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["Z" /* getWindow */])(targetElement);
                this._target = target;
            }
        }
        else {
            this._targetWindow = Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["Z" /* getWindow */])(currentElement);
        }
    };
    // The default ContextualMenu properties have no items and beak, the default submenu direction is right and top.
    ContextualMenuBase.defaultProps = {
        items: [],
        shouldFocusOnMount: true,
        gapSpace: 0,
        directionalHint: __WEBPACK_IMPORTED_MODULE_3__common_DirectionalHint__["a" /* DirectionalHint */].bottomAutoEdge,
        beakWidth: 16
    };
    ContextualMenuBase = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_7__utilities_decorators_withResponsiveMode__["b" /* withResponsiveMode */]
    ], ContextualMenuBase);
    return ContextualMenuBase;
}(__WEBPACK_IMPORTED_MODULE_5__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=ContextualMenu.base.js.map

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContextualMenuItemType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_DirectionalHint__ = __webpack_require__(36);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__common_DirectionalHint__["a"]; });

/**
 * {@docCategory ContextualMenu}
 */
var ContextualMenuItemType;
(function (ContextualMenuItemType) {
    ContextualMenuItemType[ContextualMenuItemType["Normal"] = 0] = "Normal";
    ContextualMenuItemType[ContextualMenuItemType["Divider"] = 1] = "Divider";
    ContextualMenuItemType[ContextualMenuItemType["Header"] = 2] = "Header";
    ContextualMenuItemType[ContextualMenuItemType["Section"] = 3] = "Section";
})(ContextualMenuItemType || (ContextualMenuItemType = {}));
//# sourceMappingURL=ContextualMenu.types.js.map

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Callout__ = __webpack_require__(698);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Callout__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FocusTrapCallout__ = __webpack_require__(1742);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__FocusTrapCallout__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_DirectionalHint__ = __webpack_require__(36);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__common_DirectionalHint__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Callout; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CalloutContent__ = __webpack_require__(1736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Layer__ = __webpack_require__(135);




var Callout = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](Callout, _super);
    function Callout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Callout.prototype.render = function () {
        var _a = this.props, layerProps = _a.layerProps, rest = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __rest */](_a, ["layerProps"]);
        var content = __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__CalloutContent__["a" /* CalloutContent */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, rest));
        return this.props.doNotLayer ? content : __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Layer__["a" /* Layer */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, layerProps), content);
    };
    return Callout;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=Callout.js.map

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RectangleEdge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Position; });
var RectangleEdge;
(function (RectangleEdge) {
    RectangleEdge[RectangleEdge["top"] = 1] = "top";
    RectangleEdge[RectangleEdge["bottom"] = -1] = "bottom";
    RectangleEdge[RectangleEdge["left"] = 2] = "left";
    RectangleEdge[RectangleEdge["right"] = -2] = "right";
})(RectangleEdge || (RectangleEdge = {}));
var Position;
(function (Position) {
    Position[Position["top"] = 0] = "top";
    Position[Position["bottom"] = 1] = "bottom";
    Position[Position["start"] = 2] = "start";
    Position[Position["end"] = 3] = "end";
})(Position || (Position = {}));
//# sourceMappingURL=positioning.types.js.map

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Popup__ = __webpack_require__(1740);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Popup__["a"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContextualMenuItemBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_contextualMenu_index__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Icon__ = __webpack_require__(12);





var renderItemIcon = function (props) {
    var item = props.item, hasIcons = props.hasIcons, classNames = props.classNames;
    var iconProps = item.iconProps;
    if (!hasIcons) {
        return null;
    }
    if (item.onRenderIcon) {
        return item.onRenderIcon(props);
    }
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Icon__["Icon"], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, iconProps, { className: classNames.icon }));
};
var renderCheckMarkIcon = function (_a) {
    var onCheckmarkClick = _a.onCheckmarkClick, item = _a.item, classNames = _a.classNames;
    var isItemChecked = Object(__WEBPACK_IMPORTED_MODULE_2__utilities_contextualMenu_index__["a" /* getIsChecked */])(item);
    if (onCheckmarkClick) {
        // Ensures that the item is passed as the first argument to the checkmark click callback.
        var onClick = function (e) { return onCheckmarkClick(item, e); };
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Icon__["Icon"], { iconName: isItemChecked ? 'CheckMark' : '', className: classNames.checkmarkIcon, onClick: onClick });
    }
    return null;
};
var renderItemName = function (_a) {
    var item = _a.item, classNames = _a.classNames;
    if (item.text || item.name) {
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: classNames.label }, item.text || item.name);
    }
    return null;
};
var renderSecondaryText = function (_a) {
    var item = _a.item, classNames = _a.classNames;
    if (item.secondaryText) {
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: classNames.secondaryText }, item.secondaryText);
    }
    return null;
};
var renderSubMenuIcon = function (_a) {
    var item = _a.item, classNames = _a.classNames;
    if (Object(__WEBPACK_IMPORTED_MODULE_2__utilities_contextualMenu_index__["b" /* hasSubmenu */])(item)) {
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Icon__["Icon"], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ iconName: Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["V" /* getRTL */])() ? 'ChevronLeft' : 'ChevronRight' }, item.submenuIconProps, { className: classNames.subMenuIcon }));
    }
    return null;
};
var ContextualMenuItemBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ContextualMenuItemBase, _super);
    function ContextualMenuItemBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.openSubMenu = function () {
            var _a = _this.props, item = _a.item, openSubMenu = _a.openSubMenu, getSubmenuTarget = _a.getSubmenuTarget;
            if (getSubmenuTarget) {
                var submenuTarget = getSubmenuTarget();
                if (Object(__WEBPACK_IMPORTED_MODULE_2__utilities_contextualMenu_index__["b" /* hasSubmenu */])(item) && openSubMenu && submenuTarget) {
                    openSubMenu(item, submenuTarget);
                }
            }
        };
        _this.dismissSubMenu = function () {
            var _a = _this.props, item = _a.item, dismissSubMenu = _a.dismissSubMenu;
            if (Object(__WEBPACK_IMPORTED_MODULE_2__utilities_contextualMenu_index__["b" /* hasSubmenu */])(item) && dismissSubMenu) {
                dismissSubMenu();
            }
        };
        _this.dismissMenu = function (dismissAll) {
            var dismissMenu = _this.props.dismissMenu;
            if (dismissMenu) {
                dismissMenu(undefined /* ev */, dismissAll);
            }
        };
        return _this;
    }
    ContextualMenuItemBase.prototype.render = function () {
        var _a = this.props, item = _a.item, classNames = _a.classNames;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: item.split ? classNames.linkContentMenu : classNames.linkContent },
            renderCheckMarkIcon(this.props),
            renderItemIcon(this.props),
            renderItemName(this.props),
            renderSecondaryText(this.props),
            renderSubMenuIcon(this.props)));
    };
    return ContextualMenuItemBase;
}(__WEBPACK_IMPORTED_MODULE_3__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=ContextualMenuItem.base.js.map

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONTEXTUAL_MENU_ITEM_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getMenuItemStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);



var CONTEXTUAL_MENU_ITEM_HEIGHT = '32px';
var MediumScreenSelector = Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["z" /* getScreenSelector */])(0, __WEBPACK_IMPORTED_MODULE_1__Styling__["l" /* ScreenWidthMaxMedium */]);
var getItemHighContrastStyles = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_15" /* memoizeFunction */])(function () {
    return {
        selectors: (_a = {},
            _a[__WEBPACK_IMPORTED_MODULE_1__Styling__["g" /* HighContrastSelector */]] = {
                backgroundColor: 'Highlight',
                borderColor: 'Highlight',
                color: 'HighlightText',
                MsHighContrastAdjust: 'none'
            },
            _a)
    };
    var _a;
});
var getMenuItemStyles = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_15" /* memoizeFunction */])(function (theme) {
    var semanticColors = theme.semanticColors, fonts = theme.fonts;
    var ContextualMenuItemBackgroundHoverColor = semanticColors.menuItemBackgroundHovered;
    var ContextualMenuItemBackgroundSelectedColor = semanticColors.menuItemBackgroundChecked;
    var ContextualMenuItemDividerColor = semanticColors.bodyDivider;
    var menuItemStyles = {
        item: [
            fonts.medium,
            {
                color: semanticColors.bodyText,
                position: 'relative',
                boxSizing: 'border-box'
            }
        ],
        divider: {
            display: 'block',
            height: '1px',
            backgroundColor: ContextualMenuItemDividerColor,
            position: 'relative'
        },
        root: [
            Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["v" /* getFocusStyle */])(theme),
            fonts.medium,
            {
                color: semanticColors.bodyText,
                backgroundColor: 'transparent',
                border: 'none',
                width: '100%',
                height: CONTEXTUAL_MENU_ITEM_HEIGHT,
                lineHeight: CONTEXTUAL_MENU_ITEM_HEIGHT,
                display: 'block',
                cursor: 'pointer',
                padding: '0px 8px 0 4px',
                textAlign: 'left'
            }
        ],
        rootDisabled: {
            color: semanticColors.disabledBodyText,
            cursor: 'default',
            pointerEvents: 'none',
            selectors: (_a = {},
                _a[__WEBPACK_IMPORTED_MODULE_1__Styling__["g" /* HighContrastSelector */]] = {
                    color: 'GrayText',
                    opacity: 1
                },
                _a)
        },
        rootHovered: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ backgroundColor: ContextualMenuItemBackgroundHoverColor }, getItemHighContrastStyles()),
        rootFocused: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ backgroundColor: ContextualMenuItemBackgroundHoverColor }, getItemHighContrastStyles()),
        rootChecked: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, getItemHighContrastStyles()),
        rootPressed: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ backgroundColor: ContextualMenuItemBackgroundSelectedColor }, getItemHighContrastStyles()),
        rootExpanded: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ backgroundColor: ContextualMenuItemBackgroundSelectedColor, color: semanticColors.bodyTextChecked }, getItemHighContrastStyles()),
        linkContent: {
            whiteSpace: 'nowrap',
            height: 'inherit',
            display: 'flex',
            alignItems: 'center',
            maxWidth: '100%'
        },
        anchorLink: {
            padding: '0px 8px 0 4px',
            textRendering: 'auto',
            color: 'inherit',
            letterSpacing: 'normal',
            wordSpacing: 'normal',
            textTransform: 'none',
            textIndent: '0px',
            textShadow: 'none',
            textDecoration: 'none',
            boxSizing: 'border-box'
        },
        label: {
            margin: '0 4px',
            verticalAlign: 'middle',
            display: 'inline-block',
            flexGrow: '1',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap'
        },
        secondaryText: {
            color: theme.palette.neutralSecondary,
            paddingLeft: '20px',
            textAlign: 'right'
        },
        icon: {
            display: 'inline-block',
            minHeight: '1px',
            maxHeight: CONTEXTUAL_MENU_ITEM_HEIGHT,
            width: '14px',
            margin: '0 4px',
            verticalAlign: 'middle',
            flexShrink: '0'
        },
        iconColor: {
            color: semanticColors.menuIcon,
            selectors: (_b = {},
                _b[__WEBPACK_IMPORTED_MODULE_1__Styling__["g" /* HighContrastSelector */]] = {
                    color: 'inherit'
                },
                _b['$root:hover &'] = {
                    selectors: (_c = {},
                        _c[__WEBPACK_IMPORTED_MODULE_1__Styling__["g" /* HighContrastSelector */]] = {
                            color: 'HighlightText'
                        },
                        _c)
                },
                _b['$root:focus &'] = {
                    selectors: (_d = {},
                        _d[__WEBPACK_IMPORTED_MODULE_1__Styling__["g" /* HighContrastSelector */]] = {
                            color: 'HighlightText'
                        },
                        _d)
                },
                _b)
        },
        iconDisabled: {
            color: semanticColors.disabledBodyText
        },
        checkmarkIcon: {
            color: semanticColors.bodySubtext,
            selectors: (_e = {},
                _e[__WEBPACK_IMPORTED_MODULE_1__Styling__["g" /* HighContrastSelector */]] = {
                    color: 'HighlightText'
                },
                _e)
        },
        subMenuIcon: {
            height: CONTEXTUAL_MENU_ITEM_HEIGHT,
            lineHeight: CONTEXTUAL_MENU_ITEM_HEIGHT,
            textAlign: 'center',
            display: 'inline-block',
            verticalAlign: 'middle',
            flexShrink: '0',
            fontSize: __WEBPACK_IMPORTED_MODULE_1__Styling__["e" /* FontSizes */].small,
            selectors: (_f = {},
                _f[MediumScreenSelector] = {
                    fontSize: __WEBPACK_IMPORTED_MODULE_1__Styling__["e" /* FontSizes */].icon // 16px
                },
                _f)
        },
        splitButtonFlexContainer: [
            Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["v" /* getFocusStyle */])(theme),
            {
                display: 'flex',
                height: CONTEXTUAL_MENU_ITEM_HEIGHT,
                flexWrap: 'nowrap',
                justifyContent: 'center',
                alignItems: 'center'
            }
        ]
    };
    return Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["t" /* concatStyleSets */])(menuItemStyles);
    var _a, _b, _c, _d, _e, _f;
});
//# sourceMappingURL=ContextualMenu.cnstyles.js.map

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Divider_index__ = __webpack_require__(1749);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Divider_index__["a"]; });

//# sourceMappingURL=Divider.js.map

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ElementType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonType; });
/**
 * {@docCategory Button}
 */
var ElementType;
(function (ElementType) {
    /** <button> element. */
    ElementType[ElementType["button"] = 0] = "button";
    /** <a> element. */
    ElementType[ElementType["anchor"] = 1] = "anchor";
})(ElementType || (ElementType = {}));
/**
 * {@docCategory Button}
 */
var ButtonType;
(function (ButtonType) {
    ButtonType[ButtonType["normal"] = 0] = "normal";
    ButtonType[ButtonType["primary"] = 1] = "primary";
    ButtonType[ButtonType["hero"] = 2] = "hero";
    ButtonType[ButtonType["compound"] = 3] = "compound";
    ButtonType[ButtonType["command"] = 4] = "command";
    ButtonType[ButtonType["icon"] = 5] = "icon";
    ButtonType[ButtonType["default"] = 6] = "default";
})(ButtonType || (ButtonType = {}));
//# sourceMappingURL=Button.types.js.map

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = standardStyles;
/* harmony export (immutable) */ __webpack_exports__["a"] = primaryStyles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

function standardStyles(theme) {
    var s = theme.semanticColors;
    var buttonBackground = s.buttonBackground;
    var buttonBackgroundChecked = s.buttonBackgroundChecked;
    var buttonBackgroundHovered = s.buttonBackgroundHovered;
    var buttonText = s.buttonText;
    var buttonTextHovered = s.buttonTextHovered;
    var buttonTextChecked = s.buttonTextChecked;
    var buttonTextCheckedHovered = s.buttonTextCheckedHovered;
    return {
        root: {
            backgroundColor: buttonBackground,
            color: buttonText
        },
        rootHovered: {
            backgroundColor: buttonBackgroundHovered,
            color: buttonTextHovered,
            selectors: (_a = {},
                _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                    borderColor: 'Highlight',
                    color: 'Highlight'
                },
                _a)
        },
        rootPressed: {
            backgroundColor: buttonBackgroundChecked,
            color: buttonTextChecked
        },
        rootExpanded: {
            backgroundColor: buttonBackgroundChecked,
            color: buttonTextChecked
        },
        rootChecked: {
            backgroundColor: buttonBackgroundChecked,
            color: buttonTextChecked
        },
        rootCheckedHovered: {
            backgroundColor: theme.palette.neutralLight,
            color: buttonTextCheckedHovered
        },
        // Split button styles
        splitButtonContainer: {
            selectors: (_b = {},
                _b[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                    border: 'none'
                },
                _b)
        },
        splitButtonMenuButton: {
            color: theme.palette.white,
            backgroundColor: theme.palette.neutralLighter,
            selectors: {
                ':hover': {
                    backgroundColor: theme.palette.neutralLight,
                    selectors: (_c = {},
                        _c[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                            color: 'Highlight'
                        },
                        _c)
                }
            }
        },
        splitButtonMenuButtonDisabled: {
            backgroundColor: theme.palette.neutralLighter,
            selectors: {
                ':hover': {
                    backgroundColor: theme.palette.neutralLighter
                }
            }
        },
        splitButtonDivider: {
            backgroundColor: theme.palette.neutralTertiaryAlt,
            position: 'absolute',
            width: 1,
            right: 31,
            top: 8,
            bottom: 8,
            selectors: (_d = {},
                _d[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                    backgroundColor: 'WindowText'
                },
                _d)
        },
        splitButtonDividerDisabled: {
            backgroundColor: theme.palette.neutralTertiaryAlt
        },
        splitButtonMenuButtonChecked: {
            backgroundColor: theme.palette.themePrimary
        },
        splitButtonMenuButtonExpanded: {
            backgroundColor: theme.palette.neutralLight
        },
        splitButtonMenuIcon: {
            color: theme.palette.neutralPrimary
        },
        splitButtonMenuIconDisabled: {
            color: theme.palette.neutralTertiary
        }
    };
    var _a, _b, _c, _d;
}
function primaryStyles(theme) {
    return {
        root: {
            backgroundColor: theme.palette.themePrimary,
            color: theme.palette.white,
            selectors: (_a = {},
                _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                    color: 'Window',
                    backgroundColor: 'WindowText',
                    MsHighContrastAdjust: 'none'
                },
                _a)
        },
        rootHovered: {
            backgroundColor: theme.palette.themeDarkAlt,
            color: theme.palette.white,
            selectors: (_b = {},
                _b[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                    color: 'Window',
                    backgroundColor: 'Highlight'
                },
                _b)
        },
        rootPressed: {
            backgroundColor: theme.palette.themeDark,
            color: theme.palette.white,
            selectors: (_c = {},
                _c[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                    color: 'Window',
                    backgroundColor: 'WindowText',
                    MsHighContrastAdjust: 'none'
                },
                _c)
        },
        rootExpanded: {
            backgroundColor: theme.palette.themeDark,
            color: theme.palette.white
        },
        rootChecked: {
            backgroundColor: theme.palette.themeDark,
            color: theme.palette.white
        },
        rootCheckedHovered: {
            backgroundColor: theme.palette.themePrimary,
            color: theme.palette.white
        },
        rootDisabled: {
            selectors: (_d = {},
                _d[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                    color: 'GrayText',
                    borderColor: 'GrayText',
                    backgroundColor: 'Window'
                },
                _d)
        },
        // Split button styles
        splitButtonContainer: {
            selectors: (_e = {},
                _e[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                    border: 'none'
                },
                _e)
        },
        splitButtonDivider: {
            backgroundColor: theme.palette.white,
            position: 'absolute',
            width: 1,
            right: 31,
            top: 8,
            bottom: 8,
            selectors: (_f = {},
                _f[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                    backgroundColor: 'Window'
                },
                _f)
        },
        splitButtonDividerDisabled: {
            backgroundColor: theme.palette.neutralTertiaryAlt
        },
        splitButtonMenuButton: {
            backgroundColor: theme.palette.themePrimary,
            color: theme.palette.white,
            selectors: (_g = {},
                _g[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                    backgroundColor: 'WindowText'
                },
                _g[':hover'] = {
                    backgroundColor: theme.palette.themeDark,
                    selectors: (_h = {},
                        _h[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                            color: 'Highlight'
                        },
                        _h)
                },
                _g)
        },
        splitButtonMenuButtonDisabled: {
            backgroundColor: theme.palette.neutralLighter,
            selectors: {
                ':hover': {
                    backgroundColor: theme.palette.neutralLighter
                }
            }
        },
        splitButtonMenuButtonChecked: {
            backgroundColor: theme.palette.themeDark
        },
        splitButtonMenuButtonExpanded: {
            backgroundColor: theme.palette.themeDark
        },
        splitButtonMenuIcon: {
            color: theme.palette.white
        },
        splitButtonMenuIconDisabled: {
            color: theme.palette.neutralTertiary
        }
    };
    var _a, _b, _c, _d, _e, _f, _g, _h;
}
//# sourceMappingURL=ButtonThemes.js.map

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseButton_styles__ = __webpack_require__(137);



var DEFAULT_BUTTON_HEIGHT = '40px';
var DEFAULT_PADDING = '0 4px';
var getStyles = Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["_15" /* memoizeFunction */])(function (theme, customStyles) {
    var baseButtonStyles = Object(__WEBPACK_IMPORTED_MODULE_2__BaseButton_styles__["a" /* getStyles */])(theme);
    var actionButtonStyles = {
        root: {
            padding: DEFAULT_PADDING,
            height: DEFAULT_BUTTON_HEIGHT,
            color: theme.palette.neutralPrimary,
            backgroundColor: 'transparent',
            border: '1px solid transparent'
        },
        rootHovered: {
            color: theme.palette.themePrimary,
            selectors: (_a = {},
                _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                    borderColor: 'Highlight',
                    color: 'Highlight'
                },
                _a)
        },
        iconHovered: {
            color: theme.palette.themePrimary
        },
        rootPressed: {
            color: theme.palette.black
        },
        rootExpanded: {
            color: theme.palette.themePrimary
        },
        iconPressed: {
            color: theme.palette.themeDarker
        },
        rootDisabled: {
            color: theme.palette.neutralTertiary,
            backgroundColor: 'transparent'
        },
        rootChecked: {
            color: theme.palette.black
        },
        iconChecked: {
            color: theme.palette.themeDarker
        },
        flexContainer: {
            justifyContent: 'flex-start'
        },
        icon: {
            color: theme.palette.themeDarkAlt
        },
        iconDisabled: {
            color: 'inherit'
        },
        menuIcon: {
            color: theme.palette.neutralSecondary
        },
        textContainer: {
            flexGrow: 0
        }
    };
    return Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["t" /* concatStyleSets */])(baseButtonStyles, actionButtonStyles, customStyles);
    var _a;
});
//# sourceMappingURL=ActionButton.styles.js.map

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompoundButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseButton__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CompoundButton_styles__ = __webpack_require__(1757);





/**
 * {@docCategory Button}
 */
var CompoundButton = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](CompoundButton, _super);
    function CompoundButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Tell BaseComponent to bypass resolution of componentRef.
         */
        _this._skipComponentRefResolution = true;
        return _this;
    }
    CompoundButton.prototype.render = function () {
        var _a = this.props, _b = _a.primary, primary = _b === void 0 ? false : _b, styles = _a.styles, theme = _a.theme;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__BaseButton__["a" /* BaseButton */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this.props, { variantClassName: primary ? 'ms-Button--compoundPrimary' : 'ms-Button--compound', styles: Object(__WEBPACK_IMPORTED_MODULE_4__CompoundButton_styles__["a" /* getStyles */])(theme, styles, primary) })));
    };
    CompoundButton = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["u" /* customizable */])('CompoundButton', ['theme', 'styles'], true)
    ], CompoundButton);
    return CompoundButton;
}(__WEBPACK_IMPORTED_MODULE_3__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=CompoundButton.js.map

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IconButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseButton__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IconButton_styles__ = __webpack_require__(1758);





/**
 * {@docCategory Button}
 */
var IconButton = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](IconButton, _super);
    function IconButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Tell BaseComponent to bypass resolution of componentRef.
         */
        _this._skipComponentRefResolution = true;
        return _this;
    }
    IconButton.prototype.render = function () {
        var _a = this.props, styles = _a.styles, theme = _a.theme;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__BaseButton__["a" /* BaseButton */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this.props, { variantClassName: "ms-Button--icon", styles: Object(__WEBPACK_IMPORTED_MODULE_4__IconButton_styles__["a" /* getStyles */])(theme, styles), onRenderText: __WEBPACK_IMPORTED_MODULE_3__Utilities__["_17" /* nullRender */], onRenderDescription: __WEBPACK_IMPORTED_MODULE_3__Utilities__["_17" /* nullRender */] })));
    };
    IconButton = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["u" /* customizable */])('IconButton', ['theme', 'styles'], true)
    ], IconButton);
    return IconButton;
}(__WEBPACK_IMPORTED_MODULE_3__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=IconButton.js.map

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PrimaryButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DefaultButton_DefaultButton__ = __webpack_require__(273);




/**
 * {@docCategory Button}
 */
var PrimaryButton = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](PrimaryButton, _super);
    function PrimaryButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Set this BaseComponent._skipComponentRefResolution to true, bypassing resolution of componentRef.
         */
        _this._skipComponentRefResolution = true;
        return _this;
    }
    PrimaryButton.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__DefaultButton_DefaultButton__["a" /* DefaultButton */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this.props, { primary: true, onRenderDescription: __WEBPACK_IMPORTED_MODULE_2__Utilities__["_17" /* nullRender */] }));
    };
    PrimaryButton = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["u" /* customizable */])('PrimaryButton', ['theme', 'styles'], true)
    ], PrimaryButton);
    return PrimaryButton;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=PrimaryButton.js.map

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dialog__ = __webpack_require__(1764);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Dialog__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dialog_base__ = __webpack_require__(711);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DialogContent__ = __webpack_require__(717);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DialogContent_base__ = __webpack_require__(718);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DialogFooter__ = __webpack_require__(719);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__DialogFooter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DialogFooter_base__ = __webpack_require__(720);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DialogContent_types__ = __webpack_require__(414);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__DialogContent_types__["a"]; });







//# sourceMappingURL=index.js.map

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DialogContent_types__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modal__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_decorators_withResponsiveMode__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DialogContent__ = __webpack_require__(717);






var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();

var DefaultModalProps = {
    isDarkOverlay: false,
    isBlocking: false,
    className: '',
    containerClassName: '',
    topOffsetFixed: false
};
var DefaultDialogContentProps = {
    type: __WEBPACK_IMPORTED_MODULE_3__DialogContent_types__["a" /* DialogType */].normal,
    className: '',
    topButtonsProps: []
};
var DialogBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](DialogBase, _super);
    function DialogBase(props) {
        var _this = _super.call(this, props) || this;
        _this._getSubTextId = function () {
            var _a = _this.props, ariaDescribedById = _a.ariaDescribedById, modalProps = _a.modalProps, dialogContentProps = _a.dialogContentProps, subText = _a.subText;
            var id = ariaDescribedById || (modalProps && modalProps.subtitleAriaId);
            if (!id) {
                id = (subText || (dialogContentProps && dialogContentProps.subText)) && _this._defaultSubTextId;
            }
            return id;
        };
        _this._getTitleTextId = function () {
            var _a = _this.props, ariaLabelledById = _a.ariaLabelledById, modalProps = _a.modalProps, dialogContentProps = _a.dialogContentProps, title = _a.title;
            var id = ariaLabelledById || (modalProps && modalProps.titleAriaId);
            if (!id) {
                id = (title || (dialogContentProps && dialogContentProps.title)) && _this._defaultTitleTextId;
            }
            return id;
        };
        _this._id = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["N" /* getId */])('Dialog');
        _this._defaultTitleTextId = _this._id + '-title';
        _this._defaultSubTextId = _this._id + '-subText';
        if (false) {
            warnDeprecations('Dialog', props, {
                isOpen: 'hidden',
                type: 'dialogContentProps.type',
                subText: 'dialogContentProps.subText',
                contentClassName: 'dialogContentProps.className',
                topButtonsProps: 'dialogContentProps.topButtonsProps',
                className: 'modalProps.className',
                isDarkOverlay: 'modalProps.isDarkOverlay',
                isBlocking: 'modalProps.isBlocking',
                containerClassName: 'modalProps.containerClassName',
                onDismissed: 'modalProps.onDismissed',
                onLayerDidMount: 'modalProps.layerProps.onLayerDidMount',
                ariaDescribedById: 'modalProps.subtitleAriaId',
                ariaLabelledById: 'modalProps.titleAriaId'
            });
        }
        return _this;
    }
    DialogBase.prototype.render = function () {
        var _a = this.props, className = _a.className, containerClassName = _a.containerClassName, contentClassName = _a.contentClassName, elementToFocusOnDismiss = _a.elementToFocusOnDismiss, firstFocusableSelector = _a.firstFocusableSelector, forceFocusInsideTrap = _a.forceFocusInsideTrap, styles = _a.styles, hidden = _a.hidden, ignoreExternalFocusing = _a.ignoreExternalFocusing, isBlocking = _a.isBlocking, isClickableOutsideFocusTrap = _a.isClickableOutsideFocusTrap, isDarkOverlay = _a.isDarkOverlay, isOpen = _a.isOpen, onDismiss = _a.onDismiss, onDismissed = _a.onDismissed, onLayerDidMount = _a.onLayerDidMount, responsiveMode = _a.responsiveMode, subText = _a.subText, theme = _a.theme, title = _a.title, topButtonsProps = _a.topButtonsProps, type = _a.type, minWidth = _a.minWidth, maxWidth = _a.maxWidth, modalProps = _a.modalProps;
        var mergedLayerProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, (modalProps ? modalProps.layerProps : { onLayerDidMount: onLayerDidMount }));
        if (onLayerDidMount && !mergedLayerProps.onLayerDidMount) {
            mergedLayerProps.onLayerDidMount = onLayerDidMount;
        }
        var dialogDraggableClassName;
        var dragOptions;
        // if we are draggable, make sure we are using the correct
        // draggable classname and selectors
        if (modalProps && modalProps.dragOptions && !modalProps.dragOptions.dragHandleSelector) {
            dialogDraggableClassName = 'ms-Dialog-draggable-header';
            dragOptions = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, modalProps.dragOptions, { dragHandleSelector: "." + dialogDraggableClassName });
        }
        else {
            dragOptions = modalProps && modalProps.dragOptions;
        }
        var mergedModalProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, DefaultModalProps, modalProps, { layerProps: mergedLayerProps, dragOptions: dragOptions });
        var dialogContentProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, DefaultDialogContentProps, this.props.dialogContentProps, { draggableHeaderClassName: dialogDraggableClassName });
        var classNames = getClassNames(styles, {
            theme: theme,
            className: className || mergedModalProps.className,
            containerClassName: containerClassName || mergedModalProps.containerClassName,
            hidden: hidden,
            dialogDefaultMinWidth: minWidth,
            dialogDefaultMaxWidth: maxWidth
        });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Modal__["a" /* Modal */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ elementToFocusOnDismiss: elementToFocusOnDismiss, firstFocusableSelector: firstFocusableSelector, forceFocusInsideTrap: forceFocusInsideTrap, ignoreExternalFocusing: ignoreExternalFocusing, isClickableOutsideFocusTrap: isClickableOutsideFocusTrap, onDismissed: onDismissed, responsiveMode: responsiveMode }, mergedModalProps, { isDarkOverlay: isDarkOverlay !== undefined ? isDarkOverlay : mergedModalProps.isDarkOverlay, isBlocking: isBlocking !== undefined ? isBlocking : mergedModalProps.isBlocking, isOpen: isOpen !== undefined ? isOpen : !hidden, className: classNames.root, containerClassName: classNames.main, onDismiss: onDismiss ? onDismiss : mergedModalProps.onDismiss, subtitleAriaId: this._getSubTextId(), titleAriaId: this._getTitleTextId() }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__DialogContent__["a" /* DialogContent */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ titleId: this._defaultTitleTextId, subTextId: this._defaultSubTextId, title: title, subText: subText, showCloseButton: isBlocking !== undefined ? !isBlocking : !mergedModalProps.isBlocking, topButtonsProps: topButtonsProps ? topButtonsProps : dialogContentProps.topButtonsProps, type: type !== undefined ? type : dialogContentProps.type, onDismiss: onDismiss ? onDismiss : dialogContentProps.onDismiss, className: contentClassName || dialogContentProps.className }, dialogContentProps), this.props.children)));
    };
    DialogBase.defaultProps = {
        hidden: true
    };
    DialogBase = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_5__utilities_decorators_withResponsiveMode__["b" /* withResponsiveMode */]
    ], DialogBase);
    return DialogBase;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=Dialog.base.js.map

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Modal__ = __webpack_require__(1765);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Modal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Modal_base__ = __webpack_require__(713);
/* unused harmony namespace reexport */


//# sourceMappingURL=index.js.map

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FocusTrapZone_index__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modal_styles__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Overlay__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Layer__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Popup_index__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utilities_decorators_withResponsiveMode__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Callout_index__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Icon_index__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utilities_DraggableZone_index__ = __webpack_require__(1769);












// @TODO - need to change this to a panel whenever the breakpoint is under medium (verify the spec)
var DefaultLayerProps = {
    eventBubblingEnabled: false
};
var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var ModalBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ModalBase, _super);
    function ModalBase(props) {
        var _this = _super.call(this, props) || this;
        _this._focusTrapZone = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        // Allow the user to scroll within the modal but not on the body
        _this._allowScrollOnModal = function (elt) {
            if (elt) {
                Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["j" /* allowScrollOnElement */])(elt, _this._events);
            }
            else {
                _this._events.off(_this._scrollableContent);
            }
            _this._scrollableContent = elt;
        };
        _this._onModalContextMenuClose = function () {
            _this.setState({ isModalMenuOpen: false });
        };
        _this._onModalClose = function () {
            _this._lastSetX = 0;
            _this._lastSetY = 0;
            _this.setState({
                isModalMenuOpen: false,
                isInKeyboardMoveMode: false,
                isOpen: false,
                x: 0,
                y: 0
            });
            // Call the onDismiss callback
            if (_this.props.onDismissed) {
                _this.props.onDismissed();
            }
        };
        _this._onDragStart = function () {
            _this.setState({ isModalMenuOpen: false, isInKeyboardMoveMode: false });
        };
        _this._onDrag = function (_, ui) {
            var _a = _this.state, x = _a.x, y = _a.y;
            _this.setState({ x: x + ui.delta.x, y: y + ui.delta.y });
        };
        _this._onDragStop = function () {
            _this.focus();
        };
        _this._onDialogKeyUp = function (event) {
            // Need to handle the CTRL + ALT + SPACE key during keyup due to FireFox bug:
            // https://bugzilla.mozilla.org/show_bug.cgi?id=1220143
            // Otherwise it would continue to fire a click even if the event was cancelled
            // during mouseDown.
            if (event.altKey && event.ctrlKey && event.keyCode === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].space) {
                _this.setState({ isModalMenuOpen: !_this.state.isModalMenuOpen });
                event.preventDefault();
                event.stopPropagation();
            }
        };
        _this._onDialogKeyDown = function (event) {
            if (event.altKey && event.ctrlKey && event.keyCode === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].space) {
                // CTRL + ALT + SPACE is handled during keyUp
                event.preventDefault();
                event.stopPropagation();
                return;
            }
            if (_this.state.isModalMenuOpen && (event.altKey || event.keyCode === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].escape)) {
                _this.setState({ isModalMenuOpen: false });
            }
            if (_this.state.isInKeyboardMoveMode && (event.keyCode === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].escape || event.keyCode === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].enter)) {
                _this.setState({ isInKeyboardMoveMode: false });
                event.preventDefault();
                event.stopPropagation();
            }
            if (_this.state.isInKeyboardMoveMode) {
                var handledEvent = true;
                var delta = _this._getMoveDelta(event);
                switch (event.keyCode) {
                    case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].escape:
                        _this.setState({ x: _this._lastSetX, y: _this._lastSetY });
                    case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].enter: {
                        _this._lastSetX = 0;
                        _this._lastSetY = 0;
                        _this.setState({ isInKeyboardMoveMode: false });
                        break;
                    }
                    case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].up: {
                        _this.setState({
                            y: _this.state.y - delta
                        });
                        break;
                    }
                    case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].down: {
                        _this.setState({
                            y: _this.state.y + delta
                        });
                        break;
                    }
                    case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].left: {
                        _this.setState({
                            x: _this.state.x - delta
                        });
                        break;
                    }
                    case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].right: {
                        _this.setState({
                            x: _this.state.x + delta
                        });
                        break;
                    }
                    default: {
                        handledEvent = false;
                    }
                }
                if (handledEvent) {
                    event.preventDefault();
                    event.stopPropagation();
                }
            }
        };
        _this._onEnterKeyboardMoveMode = function () {
            _this._lastSetX = _this.state.x;
            _this._lastSetY = _this.state.y;
            _this.setState({ isInKeyboardMoveMode: true, isModalMenuOpen: false });
        };
        _this._onExitKeyboardMoveMode = function () {
            _this._lastSetX = 0;
            _this._lastSetY = 0;
            _this.setState({ isInKeyboardMoveMode: false });
        };
        _this.state = {
            id: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["N" /* getId */])('Modal'),
            isOpen: props.isOpen,
            isVisible: props.isOpen,
            hasBeenOpened: props.isOpen,
            x: 0,
            y: 0
        };
        _this._lastSetX = 0;
        _this._lastSetY = 0;
        _this._warnDeprecations({
            onLayerDidMount: 'layerProps.onLayerDidMount'
        });
        return _this;
    }
    ModalBase.prototype.componentWillReceiveProps = function (newProps) {
        clearTimeout(this._onModalCloseTimer);
        // Opening the dialog
        if (newProps.isOpen) {
            if (!this.state.isOpen) {
                // First Open
                this.setState({
                    isOpen: true
                });
            }
            else {
                // Modal has been opened
                // Reopen during closing
                this.setState({
                    hasBeenOpened: true,
                    isVisible: true
                });
                if (newProps.topOffsetFixed) {
                    var dialogMain = document.getElementsByClassName('ms-Dialog-main');
                    var modalRectangle = void 0;
                    if (dialogMain.length > 0) {
                        modalRectangle = dialogMain[0].getBoundingClientRect();
                        this.setState({
                            modalRectangleTop: modalRectangle.top
                        });
                    }
                }
            }
        }
        // Closing the dialog
        if (!newProps.isOpen && this.state.isOpen) {
            this._onModalCloseTimer = this._async.setTimeout(this._onModalClose, parseFloat(__WEBPACK_IMPORTED_MODULE_4__Modal_styles__["a" /* animationDuration */]) * 1000);
            this.setState({
                isVisible: false
            });
        }
    };
    ModalBase.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (!prevProps.isOpen && !prevState.isVisible) {
            this.setState({
                isVisible: true
            });
        }
    };
    ModalBase.prototype.render = function () {
        var _a = this.props, className = _a.className, containerClassName = _a.containerClassName, scrollableContentClassName = _a.scrollableContentClassName, elementToFocusOnDismiss = _a.elementToFocusOnDismiss, firstFocusableSelector = _a.firstFocusableSelector, forceFocusInsideTrap = _a.forceFocusInsideTrap, ignoreExternalFocusing = _a.ignoreExternalFocusing, isBlocking = _a.isBlocking, isClickableOutsideFocusTrap = _a.isClickableOutsideFocusTrap, isDarkOverlay = _a.isDarkOverlay, onDismiss = _a.onDismiss, layerProps = _a.layerProps, responsiveMode = _a.responsiveMode, titleAriaId = _a.titleAriaId, styles = _a.styles, subtitleAriaId = _a.subtitleAriaId, theme = _a.theme, topOffsetFixed = _a.topOffsetFixed, onLayerDidMount = _a.onLayerDidMount, isModeless = _a.isModeless, dragOptions = _a.dragOptions;
        var _b = this.state, isOpen = _b.isOpen, isVisible = _b.isVisible, hasBeenOpened = _b.hasBeenOpened, modalRectangleTop = _b.modalRectangleTop, x = _b.x, y = _b.y, isInKeyboardMoveMode = _b.isInKeyboardMoveMode;
        if (!isOpen) {
            return null;
        }
        var layerClassName = layerProps === undefined ? '' : layerProps.className;
        var classNames = getClassNames(styles, {
            theme: theme,
            className: className,
            containerClassName: containerClassName,
            scrollableContentClassName: scrollableContentClassName,
            isOpen: isOpen,
            isVisible: isVisible,
            hasBeenOpened: hasBeenOpened,
            modalRectangleTop: modalRectangleTop,
            topOffsetFixed: topOffsetFixed,
            isModeless: isModeless,
            layerClassName: layerClassName,
            isDefaultDragHandle: dragOptions && !dragOptions.dragHandleSelector
        });
        var mergedLayerProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, DefaultLayerProps, this.props.layerProps, { onLayerDidMount: layerProps && layerProps.onLayerDidMount ? layerProps.onLayerDidMount : onLayerDidMount, insertFirst: isModeless, className: classNames.layer });
        var modalContent = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__FocusTrapZone_index__["a" /* FocusTrapZone */], { componentRef: this._focusTrapZone, className: classNames.main, elementToFocusOnDismiss: elementToFocusOnDismiss, isClickableOutsideFocusTrap: isModeless || isClickableOutsideFocusTrap || !isBlocking, ignoreExternalFocusing: ignoreExternalFocusing, forceFocusInsideTrap: isModeless ? !isModeless : forceFocusInsideTrap, firstFocusableSelector: firstFocusableSelector, focusPreviouslyFocusedInnerElement: true, onKeyDown: dragOptions ? this._onDialogKeyDown : undefined, onKeyUp: dragOptions ? this._onDialogKeyUp : undefined, onBlur: isInKeyboardMoveMode ? this._onExitKeyboardMoveMode : undefined },
            dragOptions && isInKeyboardMoveMode && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.keyboardMoveIconContainer }, dragOptions.keyboardMoveIconProps ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Icon_index__["b" /* Icon */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, dragOptions.keyboardMoveIconProps))) : (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Icon_index__["b" /* Icon */], { iconName: "move", className: classNames.keyboardMoveIcon })))),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: this._allowScrollOnModal, className: classNames.scrollableContent, "data-is-scrollable": true },
                dragOptions && this.state.isModalMenuOpen && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](dragOptions.menu, { items: [
                        { key: 'move', text: dragOptions.moveMenuItemText, onClick: this._onEnterKeyboardMoveMode },
                        { key: 'close', text: dragOptions.closeMenuItemText, onClick: this._onModalClose }
                    ], onDismiss: this._onModalContextMenuClose, alignTargetEdge: true, coverTarget: true, directionalHint: __WEBPACK_IMPORTED_MODULE_9__Callout_index__["b" /* DirectionalHint */].topLeftEdge, directionalHintFixed: true, shouldFocusOnMount: true, target: this._scrollableContent })),
                this.props.children)));
        // @temp tuatology - Will adjust this to be a panel at certain breakpoints
        if (responsiveMode >= __WEBPACK_IMPORTED_MODULE_8__utilities_decorators_withResponsiveMode__["a" /* ResponsiveMode */].small) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Layer__["a" /* Layer */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, mergedLayerProps),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Popup_index__["a" /* Popup */], { role: isModeless || !isBlocking ? 'dialog' : 'alertdialog', "aria-modal": !isModeless, ariaLabelledBy: titleAriaId, ariaDescribedBy: subtitleAriaId, onDismiss: onDismiss },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.root },
                        !isModeless && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Overlay__["a" /* Overlay */], { isDarkThemed: isDarkOverlay, onClick: isBlocking ? undefined : onDismiss }),
                        dragOptions ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__utilities_DraggableZone_index__["a" /* DraggableZone */], { handleSelector: dragOptions.dragHandleSelector || "." + classNames.main.split(' ')[0], preventDragSelector: "button", onStart: this._onDragStart, onDragChange: this._onDrag, onStop: this._onDragStop, position: { x: x, y: y } }, modalContent)) : (modalContent)))));
        }
        return null;
    };
    ModalBase.prototype.focus = function () {
        if (this._focusTrapZone.current) {
            this._focusTrapZone.current.focus();
        }
    };
    ModalBase.prototype._getMoveDelta = function (event) {
        var delta = 10;
        if (event.shiftKey) {
            if (!event.ctrlKey) {
                delta = 50;
            }
        }
        else if (event.ctrlKey) {
            delta = 1;
        }
        return delta;
    };
    ModalBase.defaultProps = {
        isOpen: false,
        isDarkOverlay: true,
        isBlocking: false,
        className: '',
        containerClassName: ''
    };
    ModalBase = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_8__utilities_decorators_withResponsiveMode__["b" /* withResponsiveMode */]
    ], ModalBase);
    return ModalBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=Modal.base.js.map

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return animationDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var animationDuration = __WEBPACK_IMPORTED_MODULE_0__Styling__["c" /* AnimationVariables */].durationValue2;
var globalClassNames = {
    root: 'ms-Modal',
    main: 'ms-Dialog-main',
    scrollableContent: 'ms-Modal-scrollableContent',
    isOpen: 'is-open',
    layer: 'ms-Modal-Layer'
};
var getStyles = function (props) {
    var className = props.className, containerClassName = props.containerClassName, scrollableContentClassName = props.scrollableContentClassName, isOpen = props.isOpen, isVisible = props.isVisible, hasBeenOpened = props.hasBeenOpened, modalRectangleTop = props.modalRectangleTop, theme = props.theme, topOffsetFixed = props.topOffsetFixed, isModeless = props.isModeless, layerClassName = props.layerClassName, isDefaultDragHandle = props.isDefaultDragHandle;
    var palette = theme.palette;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(globalClassNames, theme);
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            {
                backgroundColor: 'transparent',
                position: isModeless ? 'absolute' : 'fixed',
                height: '100%',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                opacity: 0,
                pointerEvents: 'none',
                transition: "opacity " + animationDuration
            },
            topOffsetFixed &&
                hasBeenOpened && {
                alignItems: 'flex-start'
            },
            isOpen && classNames.isOpen,
            isVisible && {
                opacity: 1,
                pointerEvents: 'auto'
            },
            className
        ],
        main: [
            classNames.main,
            {
                boxShadow: '0 0 5px 0 rgba(0, 0, 0, 0.4)',
                backgroundColor: palette.white,
                boxSizing: 'border-box',
                position: 'relative',
                textAlign: 'left',
                outline: '3px solid transparent',
                maxHeight: '100%',
                overflowY: 'auto',
                zIndex: isModeless ? __WEBPACK_IMPORTED_MODULE_0__Styling__["s" /* ZIndexes */].Layer : undefined
            },
            topOffsetFixed &&
                hasBeenOpened && {
                top: modalRectangleTop
            },
            isDefaultDragHandle && {
                cursor: 'move'
            },
            containerClassName
        ],
        scrollableContent: [
            classNames.scrollableContent,
            {
                overflowY: 'auto',
                flexGrow: 1,
                maxHeight: '100vh',
                selectors: (_a = {},
                    _a['@supports (-webkit-overflow-scrolling: touch)'] = {
                        maxHeight: window.innerHeight
                    },
                    _a)
            },
            scrollableContentClassName
        ],
        layer: isModeless && [
            layerClassName,
            classNames.layer,
            {
                position: 'static',
                width: 'unset',
                height: 'unset'
            }
        ],
        keyboardMoveIconContainer: {
            position: 'absolute',
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            padding: '3px 0px'
        },
        keyboardMoveIcon: {
            fontSize: '24px',
            width: '24px'
        }
    };
    var _a;
};
//# sourceMappingURL=Modal.styles.js.map

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OverlayBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);



var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var OverlayBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](OverlayBase, _super);
    function OverlayBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OverlayBase.prototype.componentDidMount = function () {
        Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["v" /* disableBodyScroll */])();
    };
    OverlayBase.prototype.componentWillUnmount = function () {
        Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["z" /* enableBodyScroll */])();
    };
    OverlayBase.prototype.render = function () {
        var _a = this.props, isDark = _a.isDarkThemed, className = _a.className, theme = _a.theme, styles = _a.styles;
        var divProps = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["R" /* getNativeProps */])(this.props, __WEBPACK_IMPORTED_MODULE_2__Utilities__["w" /* divProperties */]);
        var classNames = getClassNames(styles, {
            theme: theme,
            className: className,
            isDark: isDark
        });
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, divProps, { className: classNames.root }));
    };
    return OverlayBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=Overlay.base.js.map

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getClassNames; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Styling__ = __webpack_require__(5);


var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_15" /* memoizeFunction */])(function (className, isDragging) {
    return {
        root: Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["F" /* mergeStyles */])(className, isDragging && {
            touchAction: 'none',
            selectors: {
                '& *': {
                    userSelect: 'none'
                }
            }
        })
    };
});
//# sourceMappingURL=DraggableZone.styles.js.map

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogContent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DialogContent_base__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DialogContent_styles__ = __webpack_require__(1772);



var DialogContent = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__DialogContent_base__["a" /* DialogContentBase */], __WEBPACK_IMPORTED_MODULE_2__DialogContent_styles__["a" /* getStyles */], undefined, { scope: 'DialogContent' });
//# sourceMappingURL=DialogContent.js.map

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogContentBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DialogContent_types__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DialogFooter__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_decorators_withResponsiveMode__ = __webpack_require__(136);







var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var DialogFooterType = __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__DialogFooter__["a" /* DialogFooter */], null).type;
var DialogContentBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](DialogContentBase, _super);
    function DialogContentBase(props) {
        return _super.call(this, props) || this;
    }
    DialogContentBase.prototype.render = function () {
        var _a = this.props, showCloseButton = _a.showCloseButton, className = _a.className, closeButtonAriaLabel = _a.closeButtonAriaLabel, onDismiss = _a.onDismiss, subTextId = _a.subTextId, subText = _a.subText, titleId = _a.titleId, title = _a.title, type = _a.type, styles = _a.styles, theme = _a.theme, draggableHeaderClassName = _a.draggableHeaderClassName;
        var classNames = getClassNames(styles, {
            theme: theme,
            className: className,
            isLargeHeader: type === __WEBPACK_IMPORTED_MODULE_3__DialogContent_types__["a" /* DialogType */].largeHeader,
            isClose: type === __WEBPACK_IMPORTED_MODULE_3__DialogContent_types__["a" /* DialogType */].close,
            draggableHeaderClassName: draggableHeaderClassName
        });
        var groupings = this._groupChildren();
        var subTextContent;
        if (subText) {
            subTextContent = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", { className: classNames.subText, id: subTextId }, subText));
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.content },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.header },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", { className: classNames.title, id: titleId, role: "heading", "aria-level": 2 }, title),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.topButton },
                    this.props.topButtonsProps.map(function (props, index) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Button__["g" /* IconButton */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ key: props.uniqueId || index }, props))); }),
                    (type === __WEBPACK_IMPORTED_MODULE_3__DialogContent_types__["a" /* DialogType */].close || (showCloseButton && type !== __WEBPACK_IMPORTED_MODULE_3__DialogContent_types__["a" /* DialogType */].largeHeader)) && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Button__["g" /* IconButton */], { className: classNames.button, iconProps: { iconName: 'Cancel' }, ariaLabel: closeButtonAriaLabel, onClick: onDismiss })))),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.inner },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.innerContent },
                    subTextContent,
                    groupings.contents),
                groupings.footers)));
    };
    // @TODO - typing the footers as an array of DialogFooter is difficult because
    // casing "child as DialogFooter" causes a problem because
    // "Neither type 'ReactElement<any>' nor type 'DialogFooter' is assignable to the other."
    DialogContentBase.prototype._groupChildren = function () {
        var groupings = {
            footers: [],
            contents: []
        };
        __WEBPACK_IMPORTED_MODULE_1_react__["Children"].map(this.props.children, function (child) {
            if (typeof child === 'object' && child !== null && child.type === DialogFooterType) {
                groupings.footers.push(child);
            }
            else {
                groupings.contents.push(child);
            }
        });
        return groupings;
    };
    DialogContentBase.defaultProps = {
        showCloseButton: false,
        className: '',
        topButtonsProps: [],
        closeButtonAriaLabel: 'Close'
    };
    DialogContentBase = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_6__utilities_decorators_withResponsiveMode__["b" /* withResponsiveMode */]
    ], DialogContentBase);
    return DialogContentBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=DialogContent.base.js.map

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogFooter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DialogFooter_base__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DialogFooter_styles__ = __webpack_require__(1771);



var DialogFooter = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__DialogFooter_base__["a" /* DialogFooterBase */], __WEBPACK_IMPORTED_MODULE_2__DialogFooter_styles__["a" /* getStyles */], undefined, { scope: 'DialogFooter' });
//# sourceMappingURL=DialogFooter.js.map

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogFooterBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);



var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var DialogFooterBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](DialogFooterBase, _super);
    function DialogFooterBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DialogFooterBase.prototype.render = function () {
        var _a = this.props, className = _a.className, styles = _a.styles, theme = _a.theme;
        this._classNames = getClassNames(styles, {
            theme: theme,
            className: className
        });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.actions },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.actionsRight }, this._renderChildrenAsActions())));
    };
    DialogFooterBase.prototype._renderChildrenAsActions = function () {
        var _this = this;
        return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].map(this.props.children, function (child) { return (child ? __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: _this._classNames.action }, child) : null); });
    };
    return DialogFooterBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=DialogFooter.base.js.map

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tooltip; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tooltip_base__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tooltip_styles__ = __webpack_require__(1775);



var Tooltip = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__Tooltip_base__["a" /* TooltipBase */], __WEBPACK_IMPORTED_MODULE_2__Tooltip_styles__["a" /* getStyles */], undefined, {
    scope: 'Tooltip'
});
//# sourceMappingURL=Tooltip.js.map

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TooltipBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tooltip_types__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Callout__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_DirectionalHint__ = __webpack_require__(36);






var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var TooltipBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](TooltipBase, _super);
    function TooltipBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onRenderContent = function (props) {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", { className: _this._classNames.subText }, props.content);
        };
        return _this;
    }
    TooltipBase.prototype.render = function () {
        var _a = this.props, className = _a.className, calloutProps = _a.calloutProps, delay = _a.delay, directionalHint = _a.directionalHint, directionalHintForRTL = _a.directionalHintForRTL, styles = _a.styles, id = _a.id, maxWidth = _a.maxWidth, _b = _a.onRenderContent, onRenderContent = _b === void 0 ? this._onRenderContent : _b, targetElement = _a.targetElement, theme = _a.theme;
        this._classNames = getClassNames(styles, {
            theme: theme,
            className: className || (calloutProps && calloutProps.className),
            delay: delay,
            beakWidth: calloutProps && calloutProps.beakWidth,
            gapSpace: calloutProps && calloutProps.gapSpace,
            maxWidth: maxWidth
        });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Callout__["a" /* Callout */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ target: targetElement, directionalHint: directionalHint, directionalHintForRTL: directionalHintForRTL }, calloutProps, Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["R" /* getNativeProps */])(this.props, __WEBPACK_IMPORTED_MODULE_2__Utilities__["w" /* divProperties */], ['id']), { className: this._classNames.root }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.content, id: id, role: "tooltip", onMouseEnter: this.props.onMouseEnter, onMouseLeave: this.props.onMouseLeave }, onRenderContent(this.props, this._onRenderContent))));
    };
    // Specify default props values
    TooltipBase.defaultProps = {
        directionalHint: __WEBPACK_IMPORTED_MODULE_5__common_DirectionalHint__["a" /* DirectionalHint */].topCenter,
        delay: __WEBPACK_IMPORTED_MODULE_3__Tooltip_types__["a" /* TooltipDelay */].medium,
        maxWidth: '364px',
        calloutProps: {
            isBeakVisible: true,
            beakWidth: 16,
            gapSpace: 0,
            setInitialFocus: true,
            doNotLayer: false
        }
    };
    return TooltipBase;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=Tooltip.base.js.map

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TooltipHostBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TooltipHost_types__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tooltip__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Tooltip_types__ = __webpack_require__(275);






var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var TooltipHostBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](TooltipHostBase, _super);
    // Constructor
    function TooltipHostBase(props) {
        var _this = _super.call(this, props) || this;
        // The wrapping div that gets the hover events
        _this._tooltipHost = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        // The ID of the setTimeout that will eventually close the tooltip if the
        // the tooltip isn't hovered over.
        _this._closingTimer = -1;
        _this.show = function () {
            _this._toggleTooltip(true);
        };
        _this.dismiss = function () {
            _this._hideTooltip();
        };
        // Show Tooltip
        _this._onTooltipMouseEnter = function (ev) {
            var overflowMode = _this.props.overflowMode;
            if (TooltipHostBase._currentVisibleTooltip && TooltipHostBase._currentVisibleTooltip !== _this) {
                TooltipHostBase._currentVisibleTooltip.dismiss();
            }
            TooltipHostBase._currentVisibleTooltip = _this;
            if (overflowMode !== undefined) {
                var overflowElement = _this._getTargetElement();
                if (overflowElement && !Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_0" /* hasOverflow */])(overflowElement)) {
                    return;
                }
            }
            _this._clearDismissTimer();
            if (ev.target && Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_19" /* portalContainsElement */])(ev.target, _this._getTargetElement())) {
                // Do not show tooltip when target is inside a portal relative to TooltipHost.
                return;
            }
            _this._toggleTooltip(true);
        };
        // Hide Tooltip
        _this._onTooltipMouseLeave = function (ev) {
            if (_this.props.closeDelay) {
                _this._clearDismissTimer();
                _this._closingTimer = _this._async.setTimeout(function () {
                    _this._toggleTooltip(false);
                }, _this.props.closeDelay);
            }
            else {
                _this._toggleTooltip(false);
            }
            if (TooltipHostBase._currentVisibleTooltip === _this) {
                TooltipHostBase._currentVisibleTooltip = undefined;
            }
        };
        _this._onTooltipKeyDown = function (ev) {
            if (ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].escape) {
                _this._hideTooltip();
            }
        };
        _this._clearDismissTimer = function () {
            _this._async.clearTimeout(_this._closingTimer);
        };
        // Hide Tooltip
        _this._hideTooltip = function () {
            _this._toggleTooltip(false);
        };
        _this.state = {
            isTooltipVisible: false
        };
        return _this;
    }
    // Render
    TooltipHostBase.prototype.render = function () {
        var _a = this.props, calloutProps = _a.calloutProps, children = _a.children, content = _a.content, delay = _a.delay, directionalHint = _a.directionalHint, directionalHintForRTL = _a.directionalHintForRTL, className = _a.hostClassName, id = _a.id, _b = _a.setAriaDescribedBy, setAriaDescribedBy = _b === void 0 ? true : _b, tooltipProps = _a.tooltipProps, styles = _a.styles, theme = _a.theme;
        this._classNames = getClassNames(styles, {
            theme: theme,
            className: className
        });
        var isTooltipVisible = this.state.isTooltipVisible;
        var tooltipId = id || Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["N" /* getId */])('tooltip');
        var isContentPresent = !!(content || (tooltipProps && tooltipProps.onRenderContent && tooltipProps.onRenderContent()));
        var showTooltip = isTooltipVisible && isContentPresent;
        var ariaDescribedBy = setAriaDescribedBy && isTooltipVisible && isContentPresent ? tooltipId : undefined;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ className: this._classNames.root, ref: this._tooltipHost }, { onFocusCapture: this._onTooltipMouseEnter }, { onBlurCapture: this._hideTooltip }, { onMouseEnter: this._onTooltipMouseEnter, onMouseLeave: this._onTooltipMouseLeave, onKeyDown: this._onTooltipKeyDown, "aria-describedby": ariaDescribedBy }),
            children,
            showTooltip && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Tooltip__["a" /* Tooltip */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ id: tooltipId, delay: delay, content: content, targetElement: this._getTargetElement(), directionalHint: directionalHint, directionalHintForRTL: directionalHintForRTL, calloutProps: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["n" /* assign */])({}, calloutProps, {
                    onMouseEnter: this._onTooltipMouseEnter,
                    onMouseLeave: this._onTooltipMouseLeave
                }), onMouseEnter: this._onTooltipMouseEnter, onMouseLeave: this._onTooltipMouseLeave }, Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["R" /* getNativeProps */])(this.props, __WEBPACK_IMPORTED_MODULE_2__Utilities__["w" /* divProperties */]), tooltipProps)))));
    };
    TooltipHostBase.prototype.componentWillUnmount = function () {
        if (TooltipHostBase._currentVisibleTooltip && TooltipHostBase._currentVisibleTooltip === this) {
            TooltipHostBase._currentVisibleTooltip = undefined;
        }
    };
    TooltipHostBase.prototype._getTargetElement = function () {
        if (!this._tooltipHost.current) {
            return undefined;
        }
        var overflowMode = this.props.overflowMode;
        // Select target element based on overflow mode. For parent mode, you want to position the tooltip relative
        // to the parent element, otherwise it might look off.
        if (overflowMode !== undefined) {
            switch (overflowMode) {
                case __WEBPACK_IMPORTED_MODULE_3__TooltipHost_types__["a" /* TooltipOverflowMode */].Parent:
                    return this._tooltipHost.current.parentElement;
                case __WEBPACK_IMPORTED_MODULE_3__TooltipHost_types__["a" /* TooltipOverflowMode */].Self:
                    return this._tooltipHost.current;
            }
        }
        return this._tooltipHost.current;
    };
    TooltipHostBase.prototype._toggleTooltip = function (isTooltipVisible) {
        var _this = this;
        if (this.state.isTooltipVisible !== isTooltipVisible) {
            this.setState({ isTooltipVisible: isTooltipVisible }, function () { return _this.props.onTooltipToggle && _this.props.onTooltipToggle(_this.state.isTooltipVisible); });
        }
    };
    TooltipHostBase.defaultProps = {
        delay: __WEBPACK_IMPORTED_MODULE_5__Tooltip_types__["a" /* TooltipDelay */].medium
    };
    return TooltipHostBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=TooltipHost.base.js.map

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TooltipOverflowMode; });
/**
 * {@docCategory Tooltip}
 */
var TooltipOverflowMode;
(function (TooltipOverflowMode) {
    /** Only show tooltip if parent DOM element is overflowing */
    TooltipOverflowMode[TooltipOverflowMode["Parent"] = 0] = "Parent";
    /** Only show tooltip if tooltip host's content is overflowing */
    TooltipOverflowMode[TooltipOverflowMode["Self"] = 1] = "Self";
})(TooltipOverflowMode || (TooltipOverflowMode = {}));
//# sourceMappingURL=TooltipHost.types.js.map

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Toggle_index__ = __webpack_require__(1778);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Toggle_index__["a"]; });

//# sourceMappingURL=Toggle.js.map

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ToggleBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Label__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__KeytipData__ = __webpack_require__(89);





var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var ToggleBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ToggleBase, _super);
    function ToggleBase(props) {
        var _this = _super.call(this, props) || this;
        _this._toggleButton = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._onClick = function (ev) {
            var _a = _this.props, disabled = _a.disabled, checkedProp = _a.checked, onChange = _a.onChange, onChanged = _a.onChanged, onClick = _a.onClick;
            var checked = _this.state.checked;
            if (!disabled) {
                // Only update the state if the user hasn't provided it.
                if (checkedProp === undefined) {
                    _this.setState({
                        checked: !checked
                    });
                }
                if (onChange) {
                    onChange(ev, !checked);
                }
                if (onChanged) {
                    onChanged(!checked);
                }
                if (onClick) {
                    onClick(ev);
                }
            }
        };
        _this._warnMutuallyExclusive({
            checked: 'defaultChecked'
        });
        _this._warnDeprecations({
            onAriaLabel: 'ariaLabel',
            offAriaLabel: undefined,
            onChanged: 'onChange'
        });
        _this.state = {
            checked: !!(props.checked || props.defaultChecked)
        };
        _this._id = props.id || Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["N" /* getId */])('Toggle');
        return _this;
    }
    Object.defineProperty(ToggleBase.prototype, "checked", {
        /**
         * Gets the current checked state of the toggle.
         */
        get: function () {
            return this.state.checked;
        },
        enumerable: true,
        configurable: true
    });
    ToggleBase.prototype.componentWillReceiveProps = function (newProps) {
        if (newProps.checked !== undefined) {
            this.setState({
                checked: !!newProps.checked // convert null to false
            });
        }
    };
    ToggleBase.prototype.render = function () {
        var _this = this;
        var _a = this.props, _b = _a.as, RootType = _b === void 0 ? 'div' : _b, className = _a.className, theme = _a.theme, disabled = _a.disabled, keytipProps = _a.keytipProps, label = _a.label, ariaLabel = _a.ariaLabel, onAriaLabel = _a.onAriaLabel, offAriaLabel = _a.offAriaLabel, offText = _a.offText, onText = _a.onText, styles = _a.styles, inlineLabel = _a.inlineLabel;
        var checked = this.state.checked;
        var stateText = checked ? onText : offText;
        var badAriaLabel = checked ? onAriaLabel : offAriaLabel;
        var toggleNativeProps = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["R" /* getNativeProps */])(this.props, __WEBPACK_IMPORTED_MODULE_2__Utilities__["_7" /* inputProperties */], ['defaultChecked']);
        var classNames = getClassNames(styles, {
            theme: theme,
            className: className,
            disabled: disabled,
            checked: checked,
            inlineLabel: inlineLabel,
            onOffMissing: !onText && !offText
        });
        var labelId = this._id + "-label";
        var stateTextId = this._id + "-stateText";
        // The following properties take priority for what Narrator should read:
        // 1. ariaLabel
        // 2. onAriaLabel (if checked) or offAriaLabel (if not checked)
        // 3. label
        // 4. onText (if checked) or offText (if not checked)
        var labelledById = undefined;
        if (!ariaLabel && !badAriaLabel) {
            if (label) {
                labelledById = labelId;
            }
            else if (stateText) {
                labelledById = stateTextId;
            }
        }
        var ariaRole = this.props.role ? this.props.role : 'switch';
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](RootType, { className: classNames.root, hidden: toggleNativeProps.hidden },
            label && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Label__["a" /* Label */], { htmlFor: this._id, className: classNames.label, id: labelId }, label)),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.container },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__KeytipData__["a" /* KeytipData */], { keytipProps: keytipProps, ariaDescribedBy: toggleNativeProps['aria-describedby'], disabled: disabled }, function (keytipAttributes) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("button", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, toggleNativeProps, keytipAttributes, { className: classNames.pill, disabled: disabled, id: _this._id, type: "button", role: ariaRole, ref: _this._toggleButton, "aria-disabled": disabled, "aria-checked": checked, "aria-label": ariaLabel ? ariaLabel : badAriaLabel, "data-is-focusable": true, onChange: _this._noop, onClick: _this._onClick, "aria-labelledby": labelledById }),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.thumb }))); }),
                stateText && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Label__["a" /* Label */], { htmlFor: this._id, className: classNames.text, id: stateTextId }, stateText)))));
    };
    ToggleBase.prototype.focus = function () {
        if (this._toggleButton.current) {
            this._toggleButton.current.focus();
        }
    };
    ToggleBase.prototype._noop = function () {
        /* no-op */
    };
    return ToggleBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=Toggle.base.js.map

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LabelBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);




var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])({
    disableCaching: true
});
var LabelBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](LabelBase, _super);
    function LabelBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LabelBase.prototype.render = function () {
        var _a = this.props, _b = _a.as, RootType = _b === void 0 ? 'label' : _b, children = _a.children, className = _a.className, disabled = _a.disabled, styles = _a.styles, required = _a.required, theme = _a.theme;
        var classNames = getClassNames(styles, {
            className: className,
            disabled: disabled,
            required: required,
            theme: theme
        });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](RootType, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["R" /* getNativeProps */])(this.props, __WEBPACK_IMPORTED_MODULE_2__Utilities__["w" /* divProperties */]), { className: classNames.root }), children));
    };
    return LabelBase;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=Label.base.js.map

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TextField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TextField_base__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TextField_styles__ = __webpack_require__(1793);



var TextField = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__TextField_base__["a" /* TextFieldBase */], __WEBPACK_IMPORTED_MODULE_2__TextField_styles__["a" /* getStyles */], undefined, {
    scope: 'TextField'
});
//# sourceMappingURL=TextField.js.map

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TextFieldBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Label__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icon__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utilities__ = __webpack_require__(1);





var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_4__Utilities__["r" /* classNamesFunction */])();
var DEFAULT_STATE_VALUE = '';
var TextFieldBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](TextFieldBase, _super);
    function TextFieldBase(props) {
        var _this = _super.call(this, props) || this;
        _this._textElement = Object(__WEBPACK_IMPORTED_MODULE_4__Utilities__["s" /* createRef */])();
        _this._onFocus = function (ev) {
            if (_this.props.onFocus) {
                _this.props.onFocus(ev);
            }
            _this.setState({ isFocused: true });
            if (_this.props.validateOnFocusIn) {
                _this._validate(_this.state.value);
            }
        };
        _this._onBlur = function (ev) {
            if (_this.props.onBlur) {
                _this.props.onBlur(ev);
            }
            _this.setState({ isFocused: false });
            if (_this.props.validateOnFocusOut) {
                _this._validate(_this.state.value);
            }
        };
        _this._onRenderLabel = function (props) {
            var label = props.label, required = props.required;
            // IProcessedStyleSet definition requires casting for what Label expects as its styles prop
            var labelStyles = _this._classNames.subComponentStyles
                ? _this._classNames.subComponentStyles.label
                : undefined;
            if (label) {
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Label__["a" /* Label */], { required: required, htmlFor: _this._id, styles: labelStyles, disabled: props.disabled, id: _this._labelId }, props.label));
            }
            return null;
        };
        _this._onRenderDescription = function (props) {
            if (props.description) {
                return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: _this._classNames.description }, props.description);
            }
            return null;
        };
        _this._onInputChange = function (event) {
            event.persist();
            var element = event.target;
            var value = element.value;
            // Avoid doing unnecessary work when the value has not changed.
            if (value === _this._latestValue) {
                return;
            }
            _this._latestValue = value;
            _this.setState({ value: value }, function () {
                _this._adjustInputHeight();
                if (_this.props.onChange) {
                    _this.props.onChange(event, value);
                }
                if (_this.props.onChanged) {
                    _this.props.onChanged(value);
                }
            });
            if (_shouldValidateAllChanges(_this.props)) {
                _this._delayedValidate(value);
            }
            if (_this.props.onBeforeChange) {
                _this.props.onBeforeChange(value);
            }
        };
        Object(__WEBPACK_IMPORTED_MODULE_4__Utilities__["_5" /* initializeComponentRef */])(_this);
        _this._async = new __WEBPACK_IMPORTED_MODULE_4__Utilities__["a" /* Async */](_this);
        if (false) {
            warnDeprecations('TextField', props, {
                iconClass: 'iconProps',
                addonString: 'prefix',
                onRenderAddon: 'onRenderPrefix',
                onChanged: 'onChange'
            });
            warnMutuallyExclusive('TextField', props, {
                value: 'defaultValue'
            });
        }
        _this._id = props.id || Object(__WEBPACK_IMPORTED_MODULE_4__Utilities__["N" /* getId */])('TextField');
        _this._descriptionId = Object(__WEBPACK_IMPORTED_MODULE_4__Utilities__["N" /* getId */])('TextFieldDescription');
        _this._labelId = Object(__WEBPACK_IMPORTED_MODULE_4__Utilities__["N" /* getId */])('TextFieldLabel');
        if (props.value !== undefined) {
            _this._latestValue = props.value;
        }
        else if (props.defaultValue !== undefined) {
            _this._latestValue = props.defaultValue;
        }
        else {
            _this._latestValue = DEFAULT_STATE_VALUE;
        }
        _this.state = {
            value: _this._latestValue,
            isFocused: false,
            errorMessage: ''
        };
        _this._delayedValidate = _this._async.debounce(_this._validate, _this.props.deferredValidationTime);
        _this._lastValidation = 0;
        return _this;
    }
    Object.defineProperty(TextFieldBase.prototype, "value", {
        /**
         * Gets the current value of the text field.
         */
        get: function () {
            return this.state.value;
        },
        enumerable: true,
        configurable: true
    });
    TextFieldBase.prototype.componentDidMount = function () {
        this._isMounted = true;
        this._adjustInputHeight();
        if (this.props.validateOnLoad) {
            this._validate(this.state.value);
        }
    };
    TextFieldBase.prototype.componentWillReceiveProps = function (newProps) {
        var onBeforeChange = this.props.onBeforeChange;
        // If old value prop was undefined, then component is controlled and we should
        //    respect new undefined value and update state accordingly.
        if (newProps.value !== this.state.value && (newProps.value !== undefined || this.props.value !== undefined)) {
            if (onBeforeChange) {
                onBeforeChange(newProps.value);
            }
            this._id = newProps.id || this._id;
            this._setValue(newProps.value);
            if (_shouldValidateAllChanges(newProps)) {
                this._delayedValidate(newProps.value);
            }
        }
        // If component is not currently controlled and defaultValue changes, set value to new defaultValue.
        if (newProps.defaultValue !== this.props.defaultValue && newProps.value === undefined) {
            this._setValue(newProps.defaultValue);
        }
        // Text field is changing between single- and multi-line. After the change is complete,
        // we'll need to reset focus and selection/cursor.
        if (!!newProps.multiline !== !!this.props.multiline && this.state.isFocused) {
            this._shouldResetFocusAfterRender = true;
            this._selectionBeforeInputTypeChange = [this.selectionStart, this.selectionEnd];
        }
    };
    TextFieldBase.prototype.componentDidUpdate = function () {
        if (this._shouldResetFocusAfterRender) {
            // The text field has just changed between single- and multi-line, so we need to reset focus
            // and selection/cursor.
            this._shouldResetFocusAfterRender = false;
            this.focus();
            if (this._selectionBeforeInputTypeChange) {
                var _a = this._selectionBeforeInputTypeChange, start = _a[0], end = _a[1];
                if (start !== null && end !== null) {
                    this.setSelectionRange(start, end);
                }
            }
        }
    };
    TextFieldBase.prototype.componentWillUnmount = function () {
        this._isMounted = false;
        this._async.dispose();
    };
    TextFieldBase.prototype.render = function () {
        var _a = this.props, borderless = _a.borderless, className = _a.className, disabled = _a.disabled, iconClass = _a.iconClass, iconProps = _a.iconProps, inputClassName = _a.inputClassName, label = _a.label, multiline = _a.multiline, required = _a.required, underlined = _a.underlined, addonString = _a.addonString, // @deprecated
        prefix = _a.prefix, resizable = _a.resizable, suffix = _a.suffix, theme = _a.theme, styles = _a.styles, autoAdjustHeight = _a.autoAdjustHeight, _b = _a.onRenderAddon, onRenderAddon = _b === void 0 ? this._onRenderAddon : _b, // @deprecated
        _c = _a.onRenderPrefix, // @deprecated
        onRenderPrefix = _c === void 0 ? this._onRenderPrefix : _c, _d = _a.onRenderSuffix, onRenderSuffix = _d === void 0 ? this._onRenderSuffix : _d, _e = _a.onRenderLabel, onRenderLabel = _e === void 0 ? this._onRenderLabel : _e, _f = _a.onRenderDescription, onRenderDescription = _f === void 0 ? this._onRenderDescription : _f;
        var isFocused = this.state.isFocused;
        var errorMessage = this._errorMessage;
        this._classNames = getClassNames(styles, {
            theme: theme,
            className: className,
            disabled: disabled,
            focused: isFocused,
            required: required,
            multiline: multiline,
            hasLabel: !!label,
            hasErrorMessage: !!errorMessage,
            borderless: borderless,
            resizable: resizable,
            hasIcon: !!iconProps,
            underlined: underlined,
            iconClass: iconClass,
            inputClassName: inputClassName,
            autoAdjustHeight: autoAdjustHeight
        });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.root },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.wrapper },
                onRenderLabel(this.props, this._onRenderLabel),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.fieldGroup },
                    (addonString !== undefined || this.props.onRenderAddon) && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.prefix }, onRenderAddon(this.props, this._onRenderAddon))),
                    (prefix !== undefined || this.props.onRenderPrefix) && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.prefix }, onRenderPrefix(this.props, this._onRenderPrefix))),
                    multiline ? this._renderTextArea() : this._renderInput(),
                    (iconClass || iconProps) && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Icon__["Icon"], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ className: this._classNames.icon }, iconProps)),
                    (suffix !== undefined || this.props.onRenderSuffix) && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.suffix }, onRenderSuffix(this.props, this._onRenderSuffix))))),
            this._isDescriptionAvailable && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { id: this._descriptionId },
                onRenderDescription(this.props, this._onRenderDescription),
                errorMessage && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { role: "alert" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Utilities__["d" /* DelayedRender */], null,
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", { className: this._classNames.errorMessage },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { "data-automation-id": "error-message" }, errorMessage)))))))));
    };
    /**
     * Sets focus on the text field
     */
    TextFieldBase.prototype.focus = function () {
        if (this._textElement.current) {
            this._textElement.current.focus();
        }
    };
    /**
     * Blurs the text field.
     */
    TextFieldBase.prototype.blur = function () {
        if (this._textElement.current) {
            this._textElement.current.blur();
        }
    };
    /**
     * Selects the text field
     */
    TextFieldBase.prototype.select = function () {
        if (this._textElement.current) {
            this._textElement.current.select();
        }
    };
    /**
     * Sets the selection start of the text field to a specified value
     */
    TextFieldBase.prototype.setSelectionStart = function (value) {
        if (this._textElement.current) {
            this._textElement.current.selectionStart = value;
        }
    };
    /**
     * Sets the selection end of the text field to a specified value
     */
    TextFieldBase.prototype.setSelectionEnd = function (value) {
        if (this._textElement.current) {
            this._textElement.current.selectionEnd = value;
        }
    };
    Object.defineProperty(TextFieldBase.prototype, "selectionStart", {
        /**
         * Gets the selection start of the text field
         */
        get: function () {
            return this._textElement.current ? this._textElement.current.selectionStart : -1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFieldBase.prototype, "selectionEnd", {
        /**
         * Gets the selection end of the text field
         */
        get: function () {
            return this._textElement.current ? this._textElement.current.selectionEnd : -1;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Sets the start and end positions of a selection in a text field.
     * @param start - Index of the start of the selection.
     * @param end - Index of the end of the selection.
     */
    TextFieldBase.prototype.setSelectionRange = function (start, end) {
        if (this._textElement.current) {
            this._textElement.current.setSelectionRange(start, end);
        }
    };
    TextFieldBase.prototype._setValue = function (value) {
        var _this = this;
        this._latestValue = value;
        this.setState({
            value: value || DEFAULT_STATE_VALUE,
            errorMessage: ''
        }, function () {
            _this._adjustInputHeight();
        });
    };
    // @deprecated
    TextFieldBase.prototype._onRenderAddon = function (props) {
        var addonString = props.addonString;
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { style: { paddingBottom: '1px' } }, addonString);
    };
    TextFieldBase.prototype._onRenderPrefix = function (props) {
        var prefix = props.prefix;
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { style: { paddingBottom: '1px' } }, prefix);
    };
    TextFieldBase.prototype._onRenderSuffix = function (props) {
        var suffix = props.suffix;
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { style: { paddingBottom: '1px' } }, suffix);
    };
    Object.defineProperty(TextFieldBase.prototype, "_errorMessage", {
        get: function () {
            var errorMessage = this.state.errorMessage;
            if (!errorMessage && this.props.errorMessage) {
                errorMessage = this.props.errorMessage;
            }
            return errorMessage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextFieldBase.prototype, "_isDescriptionAvailable", {
        /**
         * If a custom description render function is supplied then treat description as always available.
         * Otherwise defer to the presence of description or error message text.
         */
        get: function () {
            var props = this.props;
            return !!(props.onRenderDescription || props.description || this._errorMessage);
        },
        enumerable: true,
        configurable: true
    });
    TextFieldBase.prototype._renderTextArea = function () {
        var textAreaProps = Object(__WEBPACK_IMPORTED_MODULE_4__Utilities__["R" /* getNativeProps */])(this.props, __WEBPACK_IMPORTED_MODULE_4__Utilities__["_30" /* textAreaProperties */], ['defaultValue']);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("textarea", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ id: this._id }, textAreaProps, { ref: this._textElement, value: this.state.value, onInput: this._onInputChange, onChange: this._onInputChange, className: this._classNames.field, "aria-describedby": this._isDescriptionAvailable ? this._descriptionId : this.props['aria-describedby'], "aria-invalid": !!this._errorMessage, "aria-label": this.props.ariaLabel, readOnly: this.props.readOnly, onFocus: this._onFocus, onBlur: this._onBlur })));
    };
    TextFieldBase.prototype._renderInput = function () {
        var inputProps = Object(__WEBPACK_IMPORTED_MODULE_4__Utilities__["R" /* getNativeProps */])(this.props, __WEBPACK_IMPORTED_MODULE_4__Utilities__["_7" /* inputProperties */], ['defaultValue']);
        var ariaLabelledBy = this.props['aria-labelledby'] || (this.props.label ? this._labelId : undefined);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("input", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ type: 'text', id: this._id, "aria-labelledby": ariaLabelledBy }, inputProps, { ref: this._textElement, value: this.state.value, onInput: this._onInputChange, onChange: this._onInputChange, className: this._classNames.field, "aria-label": this.props.ariaLabel, "aria-describedby": this._isDescriptionAvailable ? this._descriptionId : this.props['aria-describedby'], "aria-invalid": !!this._errorMessage, readOnly: this.props.readOnly, onFocus: this._onFocus, onBlur: this._onBlur })));
    };
    TextFieldBase.prototype._validate = function (value) {
        var _this = this;
        // In case of _validate called multi-times during executing validate logic with promise return.
        if (this._latestValidateValue === value && _shouldValidateAllChanges(this.props)) {
            return;
        }
        this._latestValidateValue = value;
        var onGetErrorMessage = this.props.onGetErrorMessage;
        var result = onGetErrorMessage(value || '');
        if (result !== undefined) {
            if (typeof result === 'string' || !('then' in result)) {
                this.setState({ errorMessage: result });
                this._notifyAfterValidate(value, result);
            }
            else {
                var currentValidation_1 = ++this._lastValidation;
                result.then(function (errorMessage) {
                    if (_this._isMounted && currentValidation_1 === _this._lastValidation) {
                        _this.setState({ errorMessage: errorMessage });
                    }
                    _this._notifyAfterValidate(value, errorMessage);
                });
            }
        }
        else {
            this._notifyAfterValidate(value, '');
        }
    };
    TextFieldBase.prototype._notifyAfterValidate = function (value, errorMessage) {
        if (this._isMounted && value === this.state.value && this.props.onNotifyValidationResult) {
            this.props.onNotifyValidationResult(errorMessage, value);
        }
    };
    TextFieldBase.prototype._adjustInputHeight = function () {
        if (this._textElement.current && this.props.autoAdjustHeight && this.props.multiline) {
            var textField = this._textElement.current;
            textField.style.height = '';
            textField.style.height = textField.scrollHeight + 'px';
        }
    };
    TextFieldBase.defaultProps = {
        multiline: false,
        resizable: true,
        autoAdjustHeight: false,
        underlined: false,
        borderless: false,
        onChange: function () {
            /* noop */
        },
        onBeforeChange: function () {
            /* noop */
        },
        onNotifyValidationResult: function () {
            /* noop */
        },
        onGetErrorMessage: function () { return undefined; },
        deferredValidationTime: 200,
        errorMessage: '',
        validateOnFocusIn: false,
        validateOnFocusOut: false,
        validateOnLoad: true
    };
    return TextFieldBase;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

/**
 * If `validateOnFocusIn` or `validateOnFocusOut` is true, validation should run **only** on that event.
 * Otherwise, validation should run on every change.
 */
function _shouldValidateAllChanges(props) {
    return !(props.validateOnFocusIn || props.validateOnFocusOut);
}
//# sourceMappingURL=TextField.base.js.map

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DropdownBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Callout__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Checkbox__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_DirectionalHint__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Dropdown_types__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utilities_DropdownSizePosCache__ = __webpack_require__(1801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FocusZone__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Icon__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Label__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__KeytipData__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Panel__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utilities_decorators_withResponsiveMode__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utilities_selectableOption_index__ = __webpack_require__(419);
















var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var DropdownBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](DropdownBase, _super);
    function DropdownBase(props) {
        var _this = _super.call(this, props) || this;
        _this._host = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._focusZone = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._dropDown = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._scrollIdleDelay = 250 /* ms */;
        _this._sizePosCache = new __WEBPACK_IMPORTED_MODULE_8__utilities_DropdownSizePosCache__["a" /* DropdownSizePosCache */]();
        _this._requestAnimationFrame = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_24" /* safeRequestAnimationFrame */])(_this);
        _this._onChange = function (event, options, index, checked, multiSelect) {
            var _a = _this.props, onChange = _a.onChange, onChanged = _a.onChanged;
            if (onChange) {
                // for single-select, option passed in will always be selected.
                // for multi-select, flip the checked value
                var changedOpt = multiSelect ? __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, options[index], { selected: !checked }) : options[index];
                onChange(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, event, { target: _this._dropDown.current }), changedOpt, index);
            }
            if (onChanged) {
                // for single-select, option passed in will always be selected.
                // for multi-select, flip the checked value
                var changedOpt = multiSelect ? __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, options[index], { selected: !checked }) : options[index];
                onChanged(changedOpt, index);
            }
        };
        /** Render text in dropdown input */
        _this._onRenderTitle = function (items) {
            var _a = _this.props.multiSelectDelimiter, multiSelectDelimiter = _a === void 0 ? ', ' : _a;
            var displayTxt = items.map(function (i) { return i.text; }).join(multiSelectDelimiter);
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", null, displayTxt);
        };
        /** Render placeholder text in dropdown input */
        _this._onRenderPlaceholder = function (props) {
            if (!_this._placeholder) {
                return null;
            }
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", null, _this._placeholder);
        };
        /** Render Callout or Panel container and pass in list */
        _this._onRenderContainer = function (props) {
            var calloutProps = props.calloutProps, panelProps = props.panelProps;
            var _a = _this.props, responsiveMode = _a.responsiveMode, dropdownWidth = _a.dropdownWidth;
            var isSmall = responsiveMode <= __WEBPACK_IMPORTED_MODULE_14__utilities_decorators_withResponsiveMode__["a" /* ResponsiveMode */].medium;
            var panelStyles = _this._classNames.subComponentStyles
                ? _this._classNames.subComponentStyles.panel
                : undefined;
            return isSmall ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__Panel__["a" /* Panel */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ isOpen: true, isLightDismiss: true, onDismissed: _this._onDismiss, hasCloseButton: false, styles: panelStyles }, panelProps), _this._renderFocusableList(props))) : (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Callout__["a" /* Callout */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ isBeakVisible: false, gapSpace: 0, doNotLayer: false, directionalHintFixed: false, directionalHint: __WEBPACK_IMPORTED_MODULE_6__common_DirectionalHint__["a" /* DirectionalHint */].bottomLeftEdge }, calloutProps, { className: _this._classNames.callout, target: _this._dropDown.current, onDismiss: _this._onDismiss, onScroll: _this._onScroll, onPositioned: _this._onPositioned, calloutWidth: dropdownWidth || (_this._dropDown.current ? _this._dropDown.current.clientWidth : 0) }), _this._renderFocusableList(props)));
        };
        /** Render Caret Down Icon */
        _this._onRenderCaretDown = function (props) {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Icon__["Icon"], { className: _this._classNames.caretDown, iconName: "ChevronDown", "aria-hidden": true });
        };
        /** Render List of items */
        _this._onRenderList = function (props) {
            var _a = props.onRenderItem, onRenderItem = _a === void 0 ? _this._onRenderItem : _a;
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null, props.options.map(function (item, index) { return onRenderItem(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, item, { index: index }), _this._onRenderItem); }));
        };
        _this._onRenderItem = function (item) {
            switch (item.itemType) {
                case __WEBPACK_IMPORTED_MODULE_15__utilities_selectableOption_index__["a" /* SelectableOptionMenuItemType */].Divider:
                    return _this._renderSeparator(item);
                case __WEBPACK_IMPORTED_MODULE_15__utilities_selectableOption_index__["a" /* SelectableOptionMenuItemType */].Header:
                    return _this._renderHeader(item);
                default:
                    return _this._renderOption(item);
            }
        };
        _this._renderOption = function (item) {
            var _a = _this.props.onRenderOption, onRenderOption = _a === void 0 ? _this._onRenderOption : _a;
            var _b = _this.state.selectedIndices, selectedIndices = _b === void 0 ? [] : _b;
            var id = _this._id;
            var isItemSelected = item.index !== undefined && selectedIndices ? selectedIndices.indexOf(item.index) > -1 : false;
            // select the right className based on the combination of selected/disabled
            var itemClassName = item.hidden // predicate: item hidden
                ? _this._classNames.dropdownItemHidden
                : isItemSelected && item.disabled === true // predicate: both selected and disabled
                    ? _this._classNames.dropdownItemSelectedAndDisabled
                    : isItemSelected // predicate: selected only
                        ? _this._classNames.dropdownItemSelected
                        : item.disabled === true // predicate: disabled only
                            ? _this._classNames.dropdownItemDisabled
                            : _this._classNames.dropdownItem;
            return !_this.props.multiSelect ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Button__["e" /* CommandButton */], { id: id + '-list' + item.index, key: item.key, "data-index": item.index, "data-is-focusable": !item.disabled, disabled: item.disabled, className: itemClassName, onClick: _this._onItemClick(item), onMouseEnter: _this._onItemMouseEnter.bind(_this, item), onMouseLeave: _this._onMouseItemLeave.bind(_this, item), onMouseMove: _this._onItemMouseMove.bind(_this, item), role: "option", "aria-selected": isItemSelected ? 'true' : 'false', ariaLabel: item.ariaLabel, title: item.title ? item.title : item.text }, onRenderOption(item, _this._onRenderOption))) : (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Checkbox__["a" /* Checkbox */], { id: id + '-list' + item.index, key: item.key, "data-index": item.index, "data-is-focusable": !item.disabled, disabled: item.disabled, onChange: _this._onItemClick(item), inputProps: {
                    onMouseEnter: _this._onItemMouseEnter.bind(_this, item),
                    onMouseLeave: _this._onMouseItemLeave.bind(_this, item),
                    onMouseMove: _this._onItemMouseMove.bind(_this, item)
                }, label: item.text, title: item.title ? item.title : item.text, onRenderLabel: _this._onRenderLabel.bind(_this, item), className: itemClassName, role: "option", "aria-selected": isItemSelected ? 'true' : 'false', checked: isItemSelected }));
        };
        /** Render content of item (i.e. text/icon inside of button) */
        _this._onRenderOption = function (item) {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: _this._classNames.dropdownOptionText }, item.text);
        };
        /** Render custom label for drop down item */
        _this._onRenderLabel = function (item) {
            var _a = _this.props.onRenderOption, onRenderOption = _a === void 0 ? _this._onRenderOption : _a;
            return onRenderOption(item, _this._onRenderOption);
        };
        _this._onPositioned = function (positions) {
            if (_this._focusZone.current) {
                // Focusing an element can trigger a reflow. Making this wait until there is an animation
                // frame can improve perf significantly.
                _this._requestAnimationFrame(function () {
                    var selectedIndices = _this.state.selectedIndices;
                    if (selectedIndices && selectedIndices[0] && !_this.props.options[selectedIndices[0]].disabled) {
                        var element = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["I" /* getDocument */])().querySelector("#" + _this._id + "-list" + selectedIndices[0]);
                        _this._focusZone.current.focusElement(element);
                    }
                    else {
                        _this._focusZone.current.focus();
                    }
                });
            }
            if (!_this.state.calloutRenderEdge || _this.state.calloutRenderEdge !== positions.targetEdge) {
                _this.setState({
                    calloutRenderEdge: positions.targetEdge
                });
            }
        };
        _this._onItemClick = function (item) {
            return function (event) {
                if (!item.disabled) {
                    _this.setSelectedIndex(event, item.index);
                    if (!_this.props.multiSelect) {
                        // only close the callout when it's in single-select mode
                        _this.setState({
                            isOpen: false
                        });
                    }
                }
            };
        };
        /**
         * Scroll handler for the callout to make sure the mouse events
         * for updating focus are not interacting during scroll
         */
        _this._onScroll = function () {
            if (!_this._isScrollIdle && _this._scrollIdleTimeoutId !== undefined) {
                clearTimeout(_this._scrollIdleTimeoutId);
                _this._scrollIdleTimeoutId = undefined;
            }
            else {
                _this._isScrollIdle = false;
            }
            _this._scrollIdleTimeoutId = setTimeout(function () {
                _this._isScrollIdle = true;
            }, _this._scrollIdleDelay);
        };
        _this._onMouseItemLeave = function (item, ev) {
            if (_this._shouldIgnoreMouseEvent()) {
                return;
            }
            /**
             * IE11 focus() method forces parents to scroll to top of element.
             * Edge and IE expose a setActive() function for focusable divs that
             * sets the page focus but does not scroll the parent element.
             */
            if (_this._host.current) {
                if (_this._host.current.setActive) {
                    try {
                        _this._host.current.setActive();
                    }
                    catch (e) {
                        /* no-op */
                    }
                }
                else {
                    _this._host.current.focus();
                }
            }
        };
        _this._onDismiss = function () {
            _this.setState({ isOpen: false });
            if (_this._dropDown.current) {
                _this._dropDown.current.focus();
            }
        };
        _this._onDropdownBlur = function (ev) {
            // If Dropdown disabled do not proceed with this logic.
            var disabled = _this._isDisabled();
            if (disabled) {
                return;
            }
            // hasFocus tracks whether the root element has focus so always update the state.
            _this.setState({ hasFocus: false });
            if (_this.state.isOpen) {
                // Do not onBlur when the callout is opened
                return;
            }
            if (_this.props.onBlur) {
                _this.props.onBlur(ev);
            }
        };
        _this._onDropdownKeyDown = function (ev) {
            // If Dropdown disabled do not process any keyboard events.
            var disabled = _this._isDisabled();
            if (disabled) {
                return;
            }
            // Take note if we are processing an alt (option) or meta (command) keydown.
            // See comment in _shouldHandleKeyUp for reasoning.
            _this._lastKeyDownWasAltOrMeta = _this._isAltOrMeta(ev);
            if (_this.props.onKeyDown) {
                _this.props.onKeyDown(ev);
                if (ev.defaultPrevented) {
                    return;
                }
            }
            var newIndex;
            var selectedIndex = _this.state.selectedIndices.length ? _this.state.selectedIndices[0] : -1;
            var containsExpandCollapseModifier = ev.altKey || ev.metaKey;
            var isOpen = _this.state.isOpen;
            switch (ev.which) {
                case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].enter:
                    _this.setState({
                        isOpen: !isOpen
                    });
                    break;
                case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].escape:
                    if (!isOpen) {
                        return;
                    }
                    _this.setState({
                        isOpen: false
                    });
                    break;
                case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].up:
                    if (containsExpandCollapseModifier) {
                        if (isOpen) {
                            _this.setState({ isOpen: false });
                            break;
                        }
                        return;
                    }
                    if (_this.props.multiSelect) {
                        _this.setState({ isOpen: true });
                    }
                    else if (!_this._isDisabled()) {
                        newIndex = _this._moveIndex(ev, -1, selectedIndex - 1, selectedIndex);
                    }
                    break;
                case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].down:
                    if (containsExpandCollapseModifier) {
                        ev.stopPropagation();
                        ev.preventDefault();
                    }
                    if ((containsExpandCollapseModifier && !isOpen) || _this.props.multiSelect) {
                        _this.setState({ isOpen: true });
                    }
                    else if (!_this._isDisabled()) {
                        newIndex = _this._moveIndex(ev, 1, selectedIndex + 1, selectedIndex);
                    }
                    break;
                case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].home:
                    if (!_this.props.multiSelect) {
                        newIndex = _this._moveIndex(ev, 1, 0, selectedIndex);
                    }
                    break;
                case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].end:
                    if (!_this.props.multiSelect) {
                        newIndex = _this._moveIndex(ev, -1, _this.props.options.length - 1, selectedIndex);
                    }
                    break;
                case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].space:
                    // event handled in _onDropdownKeyUp
                    break;
                default:
                    return;
            }
            if (newIndex !== selectedIndex) {
                ev.stopPropagation();
                ev.preventDefault();
            }
        };
        _this._onDropdownKeyUp = function (ev) {
            // If Dropdown disabled do not process any keyboard events.
            var disabled = _this._isDisabled();
            if (disabled) {
                return;
            }
            var shouldHandleKey = _this._shouldHandleKeyUp(ev);
            var isOpen = _this.state.isOpen;
            if (_this.props.onKeyUp) {
                _this.props.onKeyUp(ev);
                if (ev.preventDefault) {
                    return;
                }
            }
            switch (ev.which) {
                case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].space:
                    _this.setState({
                        isOpen: !isOpen
                    });
                    break;
                default:
                    if (shouldHandleKey && isOpen) {
                        _this.setState({ isOpen: false });
                    }
                    return;
            }
            ev.stopPropagation();
            ev.preventDefault();
        };
        _this._onZoneKeyDown = function (ev) {
            var elementToFocus;
            // Take note if we are processing an alt (option) or meta (command) keydown.
            // See comment in _shouldHandleKeyUp for reasoning.
            _this._lastKeyDownWasAltOrMeta = _this._isAltOrMeta(ev);
            var containsExpandCollapseModifier = ev.altKey || ev.metaKey;
            switch (ev.which) {
                case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].up:
                    if (containsExpandCollapseModifier) {
                        _this.setState({ isOpen: false });
                    }
                    else {
                        if (_this._host.current) {
                            elementToFocus = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["P" /* getLastFocusable */])(_this._host.current, _this._host.current.lastChild, true);
                        }
                    }
                    break;
                // All directional keystrokes should be canceled when the zone is rendered.
                // This avoids the body scroll from reacting and thus dismissing the dropdown.
                case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].home:
                case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].end:
                case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].pageUp:
                case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].pageDown:
                    break;
                case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].down:
                    if (!containsExpandCollapseModifier && _this._host.current) {
                        elementToFocus = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["K" /* getFirstFocusable */])(_this._host.current, _this._host.current.firstChild, true);
                    }
                    break;
                case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].escape:
                    _this.setState({ isOpen: false });
                    break;
                case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].tab:
                    _this.setState({ isOpen: false });
                    return;
                default:
                    return;
            }
            if (elementToFocus) {
                elementToFocus.focus();
            }
            ev.stopPropagation();
            ev.preventDefault();
        };
        _this._onZoneKeyUp = function (ev) {
            var shouldHandleKey = _this._shouldHandleKeyUp(ev);
            if (shouldHandleKey && _this.state.isOpen) {
                _this.setState({ isOpen: false });
                ev.preventDefault();
            }
        };
        _this._onDropdownClick = function (ev) {
            if (_this.props.onClick) {
                _this.props.onClick(ev);
                if (ev.preventDefault) {
                    return;
                }
            }
            var isOpen = _this.state.isOpen;
            var disabled = _this._isDisabled();
            if (!disabled && !_this._shouldOpenOnFocus()) {
                _this.setState({
                    isOpen: !isOpen
                });
            }
            _this._isFocusedByClick = false; // reset
        };
        _this._onDropdownMouseDown = function () {
            _this._isFocusedByClick = true;
        };
        _this._onFocus = function (ev) {
            var _a = _this.state, isOpen = _a.isOpen, selectedIndices = _a.selectedIndices;
            var multiSelect = _this.props.multiSelect;
            var disabled = _this._isDisabled();
            if (!disabled) {
                if (!_this._isFocusedByClick && !isOpen && selectedIndices.length === 0 && !multiSelect) {
                    // Per aria: https://www.w3.org/TR/wai-aria-practices-1.1/#listbox_kbd_interaction
                    _this._moveIndex(ev, 1, 0, -1);
                }
                if (_this.props.onFocus) {
                    _this.props.onFocus(ev);
                }
                var state = { hasFocus: true };
                if (_this._shouldOpenOnFocus()) {
                    state.isOpen = true;
                }
                _this.setState(state);
            }
        };
        /**
         * Because the isDisabled prop is deprecated, we have had to repeat this logic all over the place.
         * This helper method avoids all the repetition.
         */
        _this._isDisabled = function () {
            var disabled = _this.props.disabled;
            var isDisabled = _this.props.isDisabled;
            // Remove this deprecation workaround at 1.0.0
            if (isDisabled !== undefined) {
                disabled = isDisabled;
            }
            return disabled;
        };
        Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_5" /* initializeComponentRef */])(_this);
        if (false) {
            warnDeprecations('Dropdown', props, {
                isDisabled: 'disabled',
                onChanged: 'onChange',
                placeHolder: 'placeholder',
                onRenderPlaceHolder: 'onRenderPlaceholder'
            });
            warnMutuallyExclusive('Dropdown', props, {
                defaultSelectedKey: 'selectedKey',
                defaultSelectedKeys: 'selectedKeys',
                selectedKeys: 'selectedKey',
                multiSelect: 'defaultSelectedKey',
                selectedKey: 'multiSelect'
            });
        }
        _this._id = props.id || Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["N" /* getId */])('Dropdown');
        _this._isScrollIdle = true;
        var selectedIndices;
        if (_this.props.multiSelect) {
            var selectedKeys = props.defaultSelectedKeys !== undefined ? props.defaultSelectedKeys : props.selectedKeys;
            selectedIndices = _this._getSelectedIndexes(props.options, selectedKeys);
        }
        else {
            var selectedKey = props.defaultSelectedKey !== undefined ? props.defaultSelectedKey : props.selectedKey;
            selectedIndices = _this._getSelectedIndexes(props.options, selectedKey);
            _this._sizePosCache.updateOptions(props.options);
        }
        _this.state = {
            isOpen: false,
            selectedIndices: selectedIndices,
            hasFocus: false,
            calloutRenderEdge: undefined
        };
        return _this;
    }
    Object.defineProperty(DropdownBase.prototype, "selectedOptions", {
        /**
         * All selected options
         */
        get: function () {
            var options = this.props.options;
            var selectedIndices = this.state.selectedIndices;
            return Object(__WEBPACK_IMPORTED_MODULE_15__utilities_selectableOption_index__["b" /* getAllSelectedOptions */])(options, selectedIndices);
        },
        enumerable: true,
        configurable: true
    });
    DropdownBase.prototype.componentWillUnmount = function () {
        clearTimeout(this._scrollIdleTimeoutId);
    };
    DropdownBase.prototype.componentWillReceiveProps = function (newProps) {
        // In controlled component usage where selectedKey is provided, update the selectedIndex
        // state if the key or options change.
        var selectedKeyProp;
        // this does a shallow compare (assumes options are pure), for the purposes of determining whether
        // defaultSelectedKey/defaultSelectedKeys are respected.
        var didOptionsChange = newProps.options !== this.props.options;
        if (newProps.multiSelect) {
            if (didOptionsChange && newProps.defaultSelectedKeys !== undefined) {
                selectedKeyProp = 'defaultSelectedKeys';
            }
            else {
                selectedKeyProp = 'selectedKeys';
            }
        }
        else {
            if (didOptionsChange && newProps.defaultSelectedKey !== undefined) {
                selectedKeyProp = 'defaultSelectedKey';
            }
            else {
                selectedKeyProp = 'selectedKey';
            }
        }
        if (newProps[selectedKeyProp] !== undefined && (newProps[selectedKeyProp] !== this.props[selectedKeyProp] || didOptionsChange)) {
            this.setState({
                selectedIndices: this._getSelectedIndexes(newProps.options, newProps[selectedKeyProp])
            });
        }
        if (newProps.options !== this.props.options && // preexisting code assumes purity of the options...
            !newProps.multiSelect // only relevant in single selection
        ) {
            this._sizePosCache.updateOptions(newProps.options);
        }
    };
    DropdownBase.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevState.isOpen === true && this.state.isOpen === false) {
            this._gotMouseMove = false;
            if (this._dropDown.current) {
                this._dropDown.current.focus();
            }
            if (this.props.onDismiss) {
                this.props.onDismiss();
            }
        }
    };
    DropdownBase.prototype.render = function () {
        var _this = this;
        var id = this._id;
        var props = this.props;
        var className = props.className, label = props.label, options = props.options, ariaLabel = props.ariaLabel, required = props.required, errorMessage = props.errorMessage, multiSelect = props.multiSelect, keytipProps = props.keytipProps, propStyles = props.styles, theme = props.theme, panelProps = props.panelProps, calloutProps = props.calloutProps, _a = props.onRenderTitle, onRenderTitle = _a === void 0 ? this._onRenderTitle : _a, _b = props.onRenderContainer, onRenderContainer = _b === void 0 ? this._onRenderContainer : _b, _c = props.onRenderCaretDown, onRenderCaretDown = _c === void 0 ? this._onRenderCaretDown : _c;
        var _d = this.state, isOpen = _d.isOpen, selectedIndices = _d.selectedIndices, hasFocus = _d.hasFocus, calloutRenderEdge = _d.calloutRenderEdge;
        var onRenderPlaceholder = props.onRenderPlaceholder || props.onRenderPlaceHolder || this._onRenderPlaceholder;
        var selectedOptions = Object(__WEBPACK_IMPORTED_MODULE_15__utilities_selectableOption_index__["b" /* getAllSelectedOptions */])(options, selectedIndices);
        var divProps = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["R" /* getNativeProps */])(props, __WEBPACK_IMPORTED_MODULE_2__Utilities__["w" /* divProperties */]);
        var disabled = this._isDisabled();
        var optionId = id + '-option';
        var ariaAttrs = multiSelect || disabled
            ? {
                role: undefined,
                ariaActiveDescendant: undefined,
                childRole: undefined,
                ariaSetSize: undefined,
                ariaPosInSet: undefined,
                ariaSelected: undefined
            }
            : // single select
                {
                    role: 'listbox',
                    ariaActiveDescendant: isOpen && selectedIndices.length === 1 && selectedIndices[0] >= 0 ? this._id + '-list' + selectedIndices[0] : optionId,
                    childRole: 'option',
                    ariaSetSize: this._sizePosCache.optionSetSize,
                    ariaPosInSet: this._sizePosCache.positionInSet(selectedIndices[0]),
                    ariaSelected: selectedIndices[0] === undefined ? undefined : true
                };
        this._classNames = getClassNames(propStyles, {
            theme: theme,
            className: className,
            hasError: !!(errorMessage && errorMessage.length > 0),
            hasLabel: !!label,
            isOpen: isOpen,
            required: required,
            disabled: disabled,
            isRenderingPlaceholder: !selectedOptions.length,
            panelClassName: !!panelProps ? panelProps.className : undefined,
            calloutClassName: !!calloutProps ? calloutProps.className : undefined,
            calloutRenderEdge: calloutRenderEdge
        });
        var labelStyles = this._classNames.subComponentStyles
            ? this._classNames.subComponentStyles.label
            : undefined;
        var hasErrorMessage = !!errorMessage && errorMessage.length > 0;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.root },
            label && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Label__["a" /* Label */], { className: this._classNames.label, id: id + '-label', htmlFor: id, required: required, styles: labelStyles }, label)),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__KeytipData__["a" /* KeytipData */], { keytipProps: keytipProps, disabled: disabled }, function (keytipAttributes) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, keytipAttributes, { "data-is-focusable": !disabled, ref: _this._dropDown, id: id, tabIndex: disabled ? -1 : 0, "aria-expanded": isOpen ? 'true' : 'false', role: ariaAttrs.role, "aria-label": ariaLabel, "aria-labelledby": label && !ariaLabel ? id + '-label' : undefined, "aria-describedby": Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_16" /* mergeAriaAttributeValues */])(optionId, keytipAttributes['aria-describedby']), "aria-activedescendant": isOpen ? ariaAttrs.ariaActiveDescendant : undefined, "aria-required": required, "aria-disabled": disabled, "aria-owns": isOpen ? id + '-list' : undefined }, divProps, { className: _this._classNames.dropdown, onBlur: _this._onDropdownBlur, onKeyDown: _this._onDropdownKeyDown, onKeyUp: _this._onDropdownKeyUp, onClick: _this._onDropdownClick, onFocus: _this._onFocus, onMouseDown: _this._onDropdownMouseDown }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { id: optionId, className: _this._classNames.title, "aria-atomic": true, role: ariaAttrs.childRole, "aria-live": !hasFocus || disabled || multiSelect || isOpen ? 'off' : 'assertive', "aria-label": selectedOptions.length ? selectedOptions[0].text : _this._placeholder, "aria-invalid": hasErrorMessage, "aria-setsize": ariaAttrs.ariaSetSize, "aria-posinset": ariaAttrs.ariaPosInSet, "aria-selected": ariaAttrs.ariaSelected, "aria-describedby": Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_16" /* mergeAriaAttributeValues */])(hasErrorMessage && id + '-errorMessage') }, // If option is selected render title, otherwise render the placeholder text
                selectedOptions.length
                    ? onRenderTitle(selectedOptions, _this._onRenderTitle)
                    : onRenderPlaceholder(props, _this._onRenderPlaceholder)),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: _this._classNames.caretDownWrapper }, onRenderCaretDown(props, _this._onRenderCaretDown)))); }),
            isOpen && onRenderContainer(props, this._onRenderContainer),
            hasErrorMessage && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { id: id + '-errorMessage', className: this._classNames.errorMessage }, errorMessage))));
    };
    DropdownBase.prototype.focus = function (shouldOpenOnFocus) {
        if (this._dropDown.current && this._dropDown.current.tabIndex !== -1) {
            this._dropDown.current.focus();
            if (shouldOpenOnFocus) {
                this.setState({
                    isOpen: true
                });
            }
        }
    };
    DropdownBase.prototype.setSelectedIndex = function (event, index) {
        var _this = this;
        var _a = this.props, options = _a.options, selectedKey = _a.selectedKey, selectedKeys = _a.selectedKeys, multiSelect = _a.multiSelect, notifyOnReselect = _a.notifyOnReselect;
        var _b = this.state.selectedIndices, selectedIndices = _b === void 0 ? [] : _b;
        var checked = selectedIndices ? selectedIndices.indexOf(index) > -1 : false;
        var newIndexes = [];
        index = Math.max(0, Math.min(options.length - 1, index));
        // If this is a controlled component then no state change should take place.
        if (selectedKey !== undefined || selectedKeys !== undefined) {
            this._onChange(event, options, index, checked, multiSelect);
            return;
        }
        if (!multiSelect && !notifyOnReselect && index === selectedIndices[0]) {
            return;
        }
        else if (multiSelect) {
            newIndexes = selectedIndices ? this._copyArray(selectedIndices) : [];
            if (checked) {
                var position = newIndexes.indexOf(index);
                if (position > -1) {
                    // unchecked the current one
                    newIndexes.splice(position, 1);
                }
            }
            else {
                // add the new selected index into the existing one
                newIndexes.push(index);
            }
        }
        else {
            // Set the selected option if this is an uncontrolled component
            newIndexes = [index];
        }
        event.persist();
        // Call onChange after state is updated
        this.setState({
            selectedIndices: newIndexes
        }, function () {
            _this._onChange(event, options, index, checked, multiSelect);
        });
    };
    Object.defineProperty(DropdownBase.prototype, "_placeholder", {
        /** Get either props.placeholder (new name) or props.placeHolder (old name) */
        get: function () {
            return this.props.placeholder || this.props.placeHolder;
        },
        enumerable: true,
        configurable: true
    });
    DropdownBase.prototype._copyArray = function (array) {
        var newArray = [];
        for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
            var element = array_1[_i];
            newArray.push(element);
        }
        return newArray;
    };
    /**
     * Finds the next valid Dropdown option and sets the selected index to it.
     * @param stepValue - Value of how many items the function should traverse.  Should be -1 or 1.
     * @param index - Index of where the search should start
     * @param selectedIndex - The selectedIndex Dropdown's state
     * @returns The next valid dropdown option's index
     */
    DropdownBase.prototype._moveIndex = function (event, stepValue, index, selectedIndex) {
        var options = this.props.options;
        // Return selectedIndex if nothing has changed or options is empty
        if (selectedIndex === index || options.length === 0) {
            return selectedIndex;
        }
        // Set starting index to 0 if index is < 0
        if (index < 0) {
            index = 0;
        }
        // Set starting index to last option index if greater than options.length
        if (index >= options.length) {
            index = options.length - 1;
        }
        var stepCounter = 0;
        // If current index is a header or divider, or disabled, increment by step
        while (options[index].itemType === __WEBPACK_IMPORTED_MODULE_7__Dropdown_types__["a" /* DropdownMenuItemType */].Header ||
            options[index].itemType === __WEBPACK_IMPORTED_MODULE_7__Dropdown_types__["a" /* DropdownMenuItemType */].Divider ||
            options[index].disabled) {
            // If stepCounter exceeds length of options, then return selectedIndex (-1)
            if (stepCounter >= options.length) {
                return selectedIndex;
            }
            // If index + stepValue is out of bounds, wrap around
            if (index + stepValue < 0) {
                index = options.length;
            }
            else if (index + stepValue >= options.length) {
                index = -1;
            }
            index = index + stepValue;
            stepCounter++;
        }
        this.setSelectedIndex(event, index);
        return index;
    };
    /** Wrap item list in a FocusZone */
    DropdownBase.prototype._renderFocusableList = function (props) {
        var _a = props.onRenderList, onRenderList = _a === void 0 ? this._onRenderList : _a, label = props.label, ariaLabel = props.ariaLabel;
        var id = this._id;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.dropdownItemsWrapper, onKeyDown: this._onZoneKeyDown, onKeyUp: this._onZoneKeyUp, ref: this._host, tabIndex: 0 },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__FocusZone__["a" /* FocusZone */], { ref: this._focusZone, direction: __WEBPACK_IMPORTED_MODULE_9__FocusZone__["b" /* FocusZoneDirection */].vertical, id: id + '-list', className: this._classNames.dropdownItems, "aria-label": ariaLabel, "aria-labelledby": label && !ariaLabel ? id + '-label' : undefined, role: "listbox" }, onRenderList(props, this._onRenderList))));
    };
    DropdownBase.prototype._renderSeparator = function (item) {
        var index = item.index, key = item.key;
        if (index > 0) {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { role: "separator", key: key, className: this._classNames.dropdownDivider });
        }
        return null;
    };
    DropdownBase.prototype._renderHeader = function (item) {
        var _a = this.props.onRenderOption, onRenderOption = _a === void 0 ? this._onRenderOption : _a;
        var key = item.key;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { key: key, className: this._classNames.dropdownItemHeader }, onRenderOption(item, this._onRenderOption)));
    };
    DropdownBase.prototype._onItemMouseEnter = function (item, ev) {
        if (this._shouldIgnoreMouseEvent()) {
            return;
        }
        var targetElement = ev.currentTarget;
        targetElement.focus();
    };
    DropdownBase.prototype._onItemMouseMove = function (item, ev) {
        var targetElement = ev.currentTarget;
        this._gotMouseMove = true;
        if (!this._isScrollIdle || document.activeElement === targetElement) {
            return;
        }
        targetElement.focus();
    };
    DropdownBase.prototype._shouldIgnoreMouseEvent = function () {
        return !this._isScrollIdle || !this._gotMouseMove;
    };
    /** Get all selected indexes for multi-select mode */
    DropdownBase.prototype._getSelectedIndexes = function (options, selectedKey) {
        if (selectedKey === undefined) {
            if (this.props.multiSelect) {
                return this._getAllSelectedIndices(options);
            }
            var selectedIndex = this._getSelectedIndex(options, null);
            return selectedIndex !== -1 ? [selectedIndex] : [];
        }
        else if (!Array.isArray(selectedKey)) {
            var selectedIndex = this._getSelectedIndex(options, selectedKey);
            return selectedIndex !== -1 ? [selectedIndex] : [];
        }
        var selectedIndices = [];
        for (var _i = 0, selectedKey_1 = selectedKey; _i < selectedKey_1.length; _i++) {
            var key = selectedKey_1[_i];
            var selectedIndex = this._getSelectedIndex(options, key);
            selectedIndex !== -1 && selectedIndices.push(selectedIndex);
        }
        return selectedIndices;
    };
    DropdownBase.prototype._getAllSelectedIndices = function (options) {
        return options.map(function (option, index) { return (option.selected ? index : -1); }).filter(function (index) { return index !== -1; });
    };
    DropdownBase.prototype._getSelectedIndex = function (options, selectedKey) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["C" /* findIndex */])(options, function (option) {
            // tslint:disable-next-line:triple-equals
            if (selectedKey != null) {
                return option.key === selectedKey;
            }
            else {
                return !!option.isSelected || !!option.selected;
            }
        });
    };
    /**
     * Returns true if the key for the event is alt (Mac option) or meta (Mac command).
     */
    DropdownBase.prototype._isAltOrMeta = function (ev) {
        return ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].alt || ev.key === 'Meta';
    };
    /**
     * We close the menu on key up only if ALL of the following are true:
     * - Most recent key down was alt or meta (command)
     * - The alt/meta key down was NOT followed by some other key (such as down/up arrow to
     *   expand/collapse the menu)
     * - We're not on a Mac (or iOS)
     *
     * This is because on Windows, pressing alt moves focus to the application menu bar or similar,
     * closing any open context menus. There is not a similar behavior on Macs.
     */
    DropdownBase.prototype._shouldHandleKeyUp = function (ev) {
        var keyPressIsAltOrMetaAlone = this._lastKeyDownWasAltOrMeta && this._isAltOrMeta(ev);
        this._lastKeyDownWasAltOrMeta = false;
        return !!keyPressIsAltOrMetaAlone && !(Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_13" /* isMac */])() || Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_12" /* isIOS */])());
    };
    /**
     * Returns true if dropdown should set to open on focus.
     * Otherwise, isOpen state should be toggled on click
     */
    DropdownBase.prototype._shouldOpenOnFocus = function () {
        var hasFocus = this.state.hasFocus;
        var openOnKeyboardFocus = this.props.openOnKeyboardFocus;
        return !this._isFocusedByClick && openOnKeyboardFocus === true && !hasFocus;
    };
    DropdownBase.defaultProps = {
        options: []
    };
    DropdownBase = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_14__utilities_decorators_withResponsiveMode__["b" /* withResponsiveMode */]
    ], DropdownBase);
    return DropdownBase;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=Dropdown.base.js.map

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CheckboxBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icon__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__KeytipData__ = __webpack_require__(89);





var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var CheckboxBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](CheckboxBase, _super);
    /**
     * Initialize a new instance of the Checkbox
     * @param props - Props for the component
     * @param context - Context or initial state for the base component.
     */
    function CheckboxBase(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this._checkBox = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._onFocus = function (ev) {
            var inputProps = _this.props.inputProps;
            if (inputProps && inputProps.onFocus) {
                inputProps.onFocus(ev);
            }
        };
        _this._onBlur = function (ev) {
            var inputProps = _this.props.inputProps;
            if (inputProps && inputProps.onBlur) {
                inputProps.onBlur(ev);
            }
        };
        _this._onChange = function (ev) {
            var _a = _this.props, disabled = _a.disabled, onChange = _a.onChange;
            var isChecked = _this.state.isChecked;
            if (!disabled) {
                if (onChange) {
                    onChange(ev, !isChecked);
                }
                if (_this.props.checked === undefined) {
                    _this.setState({ isChecked: !isChecked });
                }
            }
        };
        _this._onRenderLabel = function (props) {
            var label = props.label;
            return label ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { "aria-hidden": "true", className: _this._classNames.text }, label)) : null;
        };
        Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_5" /* initializeComponentRef */])(_this);
        if (false) {
            warnMutuallyExclusive('Checkbox', props, {
                checked: 'defaultChecked'
            });
        }
        _this._id = _this.props.id || Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["N" /* getId */])('checkbox-');
        _this.state = {
            isChecked: !!(props.checked !== undefined ? props.checked : props.defaultChecked)
        };
        Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_6" /* initializeFocusRects */])();
        return _this;
    }
    CheckboxBase.prototype.componentWillReceiveProps = function (newProps) {
        if (newProps.checked !== undefined) {
            this.setState({
                isChecked: !!newProps.checked // convert null to false
            });
        }
    };
    /**
     * Render the Checkbox based on passed props
     */
    CheckboxBase.prototype.render = function () {
        var _this = this;
        var _a = this.props, checked = _a.checked, className = _a.className, defaultChecked = _a.defaultChecked, disabled = _a.disabled, inputProps = _a.inputProps, name = _a.name, boxSide = _a.boxSide, theme = _a.theme, ariaLabel = _a.ariaLabel, ariaLabelledBy = _a.ariaLabelledBy, ariaDescribedBy = _a.ariaDescribedBy, styles = _a.styles, _b = _a.onRenderLabel, onRenderLabel = _b === void 0 ? this._onRenderLabel : _b, checkmarkIconProps = _a.checkmarkIconProps, ariaPositionInSet = _a.ariaPositionInSet, ariaSetSize = _a.ariaSetSize, keytipProps = _a.keytipProps, title = _a.title, label = _a.label;
        var isChecked = checked === undefined ? this.state.isChecked : checked;
        var isReversed = boxSide !== 'start' ? true : false;
        this._classNames = getClassNames(styles, {
            theme: theme,
            className: className,
            disabled: disabled,
            checked: isChecked,
            reversed: isReversed,
            isUsingCustomLabelRender: onRenderLabel !== this._onRenderLabel
        });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__KeytipData__["a" /* KeytipData */], { keytipProps: keytipProps, disabled: disabled }, function (keytipAttributes) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: _this._classNames.root },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("input", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ type: "checkbox" }, inputProps, { "data-ktp-execute-target": keytipAttributes['data-ktp-execute-target'] }, checked !== undefined && { checked: checked }, defaultChecked !== undefined && { defaultChecked: defaultChecked }, { disabled: disabled, className: _this._classNames.input, ref: _this._checkBox, name: name, id: _this._id, title: title, onChange: _this._onChange, onFocus: _this._onFocus, onBlur: _this._onBlur, "aria-disabled": disabled, "aria-label": ariaLabel || label, "aria-labelledby": ariaLabelledBy, "aria-describedby": Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_16" /* mergeAriaAttributeValues */])(ariaDescribedBy, keytipAttributes['aria-describedby']), "aria-posinset": ariaPositionInSet, "aria-setsize": ariaSetSize })),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("label", { className: _this._classNames.label, htmlFor: _this._id },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: _this._classNames.checkbox, "data-ktp-target": keytipAttributes['data-ktp-target'] },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Icon__["Icon"], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ iconName: "CheckMark" }, checkmarkIconProps, { className: _this._classNames.checkmark }))),
                onRenderLabel(_this.props, _this._onRenderLabel)))); }));
    };
    Object.defineProperty(CheckboxBase.prototype, "checked", {
        get: function () {
            return this.state.isChecked;
        },
        enumerable: true,
        configurable: true
    });
    CheckboxBase.prototype.focus = function () {
        if (this._checkBox.current) {
            this._checkBox.current.focus();
        }
    };
    CheckboxBase.defaultProps = {
        boxSide: 'start'
    };
    return CheckboxBase;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=Checkbox.base.js.map

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DatePickerBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Calendar__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_dateValues_DateValues__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Callout__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_DirectionalHint__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TextField__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utilities_dateMath_DateMath__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FocusTrapZone__ = __webpack_require__(271);










var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var DEFAULT_STRINGS = {
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    shortDays: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
    goToToday: 'Go to today',
    prevMonthAriaLabel: 'Go to previous month',
    nextMonthAriaLabel: 'Go to next month',
    prevYearAriaLabel: 'Go to previous year',
    nextYearAriaLabel: 'Go to next year',
    prevYearRangeAriaLabel: 'Previous year range',
    nextYearRangeAriaLabel: 'Next year range',
    closeButtonAriaLabel: 'Close date picker',
    weekNumberFormatString: 'Week number {0}'
};
var DatePickerBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](DatePickerBase, _super);
    function DatePickerBase(props) {
        var _this = _super.call(this, props) || this;
        _this._calendar = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._datePickerDiv = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._textField = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._onSelectDate = function (date) {
            var _a = _this.props, formatDate = _a.formatDate, onSelectDate = _a.onSelectDate;
            if (_this.props.calendarProps && _this.props.calendarProps.onSelectDate) {
                _this.props.calendarProps.onSelectDate(date);
            }
            _this.setState({
                selectedDate: date,
                formattedDate: formatDate && date ? formatDate(date) : ''
            });
            if (onSelectDate) {
                onSelectDate(date);
            }
            _this._calendarDismissed();
        };
        _this._onCalloutPositioned = function () {
            var shouldFocus = true;
            // If the user has specified that the callout shouldn't use initial focus, then respect
            // that and don't attempt to set focus. That will default to true within the callout
            // so we need to check if it's undefined here.
            if (_this.props.calloutProps && _this.props.calloutProps.setInitialFocus !== undefined) {
                shouldFocus = _this.props.calloutProps.setInitialFocus;
            }
            if (_this._calendar.current && shouldFocus) {
                _this._calendar.current.focus();
            }
        };
        _this._onTextFieldFocus = function (ev) {
            if (_this.props.disableAutoFocus) {
                return;
            }
            if (!_this.props.allowTextInput) {
                if (!_this._preventFocusOpeningPicker) {
                    _this._showDatePickerPopup();
                }
                else {
                    _this._preventFocusOpeningPicker = false;
                }
            }
        };
        _this._onTextFieldBlur = function (ev) {
            _this._validateTextInput();
        };
        _this._onTextFieldChanged = function (ev, newValue) {
            var _a = _this.props, allowTextInput = _a.allowTextInput, textField = _a.textField;
            if (allowTextInput) {
                if (_this.state.isDatePickerShown) {
                    _this._dismissDatePickerPopup();
                }
                var _b = _this.props, isRequired = _b.isRequired, value = _b.value, strings = _b.strings;
                _this.setState({
                    errorMessage: isRequired && !value ? strings.isRequiredErrorMessage || ' ' : undefined,
                    formattedDate: newValue
                });
            }
            if (textField && textField.onChange) {
                textField.onChange(ev, newValue);
            }
        };
        _this._onTextFieldKeyDown = function (ev) {
            switch (ev.which) {
                case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].enter:
                    ev.preventDefault();
                    ev.stopPropagation();
                    if (!_this.state.isDatePickerShown) {
                        _this._validateTextInput();
                        _this._showDatePickerPopup();
                    }
                    else {
                        // When DatePicker allows input date string directly,
                        // it is expected to hit another enter to close the popup
                        if (_this.props.allowTextInput) {
                            _this._dismissDatePickerPopup();
                        }
                    }
                    break;
                case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].escape:
                    _this._handleEscKey(ev);
                    break;
                default:
                    break;
            }
        };
        _this._onTextFieldClick = function (ev) {
            if (!_this.state.isDatePickerShown && !_this.props.disabled) {
                _this._showDatePickerPopup();
            }
            else {
                if (_this.props.allowTextInput) {
                    _this.setState({
                        isDatePickerShown: false
                    });
                }
            }
        };
        _this._onIconClick = function (ev) {
            ev.stopPropagation();
            _this._onTextFieldClick(ev);
        };
        _this._dismissDatePickerPopup = function () {
            if (_this.state.isDatePickerShown) {
                _this.setState({
                    isDatePickerShown: false
                }, function () {
                    // setState is async, so we must call validate in a callback
                    _this._validateTextInput();
                });
            }
        };
        /**
         * Callback for closing the calendar callout
         */
        _this._calendarDismissed = function () {
            _this._preventFocusOpeningPicker = true;
            _this._dismissDatePickerPopup();
            // don't need to focus the text box, if necessary the focusTrapZone will do it
        };
        _this._handleEscKey = function (ev) {
            if (_this.state.isDatePickerShown) {
                ev.stopPropagation();
            }
            _this._calendarDismissed();
        };
        _this._validateTextInput = function () {
            var _a = _this.props, isRequired = _a.isRequired, allowTextInput = _a.allowTextInput, strings = _a.strings, parseDateFromString = _a.parseDateFromString, onSelectDate = _a.onSelectDate, formatDate = _a.formatDate, minDate = _a.minDate, maxDate = _a.maxDate;
            var inputValue = _this.state.formattedDate;
            // Do validation only if DatePicker's popup is dismissed
            if (_this.state.isDatePickerShown) {
                return;
            }
            if (allowTextInput) {
                var date = null;
                if (inputValue) {
                    // Don't parse if the selected date has the same formatted string as what we're about to parse.
                    // The formatted string might be ambiguous (ex: "1/2/3" or "New Year Eve") and the parser might
                    // not be able to come up with the exact same date.
                    if (_this.state.selectedDate && formatDate && formatDate(_this.state.selectedDate) === inputValue) {
                        return;
                    }
                    else {
                        date = parseDateFromString(inputValue);
                        // Check if date is null, or date is Invalid Date
                        if (!date || isNaN(date.getTime())) {
                            // Reset invalid input field, if formatting is available
                            if (formatDate) {
                                date = _this.state.selectedDate;
                                _this.setState({
                                    formattedDate: formatDate(date).toString()
                                });
                            }
                            _this.setState({
                                errorMessage: strings.invalidInputErrorMessage || ' '
                            });
                        }
                        else {
                            // Check against optional date boundaries
                            if (_this._isDateOutOfBounds(date, minDate, maxDate)) {
                                _this.setState({
                                    errorMessage: strings.isOutOfBoundsErrorMessage || ' '
                                });
                            }
                            else {
                                _this.setState({
                                    selectedDate: date,
                                    errorMessage: ''
                                });
                                // When formatting is available. If formatted date is valid, but is different from input, update with formatted date
                                // This occurs when an invalid date is entered twice
                                if (formatDate && formatDate(date) !== inputValue) {
                                    _this.setState({
                                        formattedDate: formatDate(date).toString()
                                    });
                                }
                            }
                        }
                    }
                }
                else {
                    // Only show error for empty inputValue if it is a required field
                    _this.setState({
                        errorMessage: isRequired ? strings.isRequiredErrorMessage || ' ' : ''
                    });
                }
                // Execute onSelectDate callback
                if (onSelectDate) {
                    // If no input date string or input date string is invalid
                    // date variable will be null, callback should expect null value for this case
                    onSelectDate(date);
                }
            }
            else if (isRequired && !inputValue) {
                // Check when DatePicker is a required field but has NO input value
                _this.setState({
                    errorMessage: strings.isRequiredErrorMessage || ' '
                });
            }
        };
        _this.state = _this._getDefaultState();
        _this._id = props.id || Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["N" /* getId */])('DatePicker');
        _this._preventFocusOpeningPicker = false;
        return _this;
    }
    DatePickerBase.prototype.componentWillReceiveProps = function (nextProps) {
        var formatDate = nextProps.formatDate, value = nextProps.value;
        if (Object(__WEBPACK_IMPORTED_MODULE_8__utilities_dateMath_DateMath__["f" /* compareDates */])(this.props.minDate, nextProps.minDate) &&
            Object(__WEBPACK_IMPORTED_MODULE_8__utilities_dateMath_DateMath__["f" /* compareDates */])(this.props.maxDate, nextProps.maxDate) &&
            this.props.isRequired === nextProps.isRequired &&
            Object(__WEBPACK_IMPORTED_MODULE_8__utilities_dateMath_DateMath__["f" /* compareDates */])(this.state.selectedDate, value) &&
            this.props.formatDate === formatDate) {
            // if the props we care about haven't changed, don't run validation or updates
            return;
        }
        this._setErrorMessage(true, nextProps);
        this._id = nextProps.id || this._id;
        // Issue# 1274: Check if the date value changed from old value, i.e., if indeed a new date is being
        // passed in or if the formatting function was modified. We only update the selected date if either of these
        // had a legit change. Note tha the bug will still repro when only the formatDate was passed in props and this
        // is the result of the onSelectDate callback, but this should be a rare scenario.
        var oldValue = this.state.selectedDate;
        if (!Object(__WEBPACK_IMPORTED_MODULE_8__utilities_dateMath_DateMath__["f" /* compareDates */])(oldValue, value) || this.props.formatDate !== formatDate) {
            this.setState({
                selectedDate: value || undefined,
                formattedDate: formatDate && value ? formatDate(value) : ''
            });
        }
    };
    DatePickerBase.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevState.isDatePickerShown && !this.state.isDatePickerShown) {
            // If DatePicker's menu (Calendar) is closed, run onAfterMenuDismiss
            if (this.props.onAfterMenuDismiss) {
                this.props.onAfterMenuDismiss();
            }
        }
    };
    DatePickerBase.prototype.render = function () {
        var _a = this.props, firstDayOfWeek = _a.firstDayOfWeek, strings = _a.strings, label = _a.label, theme = _a.theme, className = _a.className, styles = _a.styles, initialPickerDate = _a.initialPickerDate, isRequired = _a.isRequired, disabled = _a.disabled, ariaLabel = _a.ariaLabel, pickerAriaLabel = _a.pickerAriaLabel, placeholder = _a.placeholder, allowTextInput = _a.allowTextInput, borderless = _a.borderless, minDate = _a.minDate, maxDate = _a.maxDate, showCloseButton = _a.showCloseButton, calendarProps = _a.calendarProps, calloutProps = _a.calloutProps, textFieldProps = _a.textField, underlined = _a.underlined, allFocusable = _a.allFocusable, _b = _a.calendarAs, CalendarType = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_3__Calendar__["a" /* Calendar */] : _b, tabIndex = _a.tabIndex;
        var _c = this.state, isDatePickerShown = _c.isDatePickerShown, formattedDate = _c.formattedDate, selectedDate = _c.selectedDate;
        var classNames = getClassNames(styles, {
            theme: theme,
            className: className,
            disabled: disabled,
            label: !!label,
            isDatePickerShown: isDatePickerShown
        });
        var calloutId = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["N" /* getId */])('DatePicker-Callout');
        var nativeProps = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["R" /* getNativeProps */])(this.props, __WEBPACK_IMPORTED_MODULE_2__Utilities__["w" /* divProperties */], ['value']);
        var iconProps = textFieldProps && textFieldProps.iconProps;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, nativeProps, { className: classNames.root }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: this._datePickerDiv, role: "combobox", "aria-expanded": isDatePickerShown, "aria-haspopup": "true", "aria-owns": isDatePickerShown ? calloutId : undefined },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__TextField__["a" /* TextField */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ label: label, ariaLabel: ariaLabel, "aria-controls": isDatePickerShown ? calloutId : undefined, required: isRequired, disabled: disabled, errorMessage: this._getErrorMessage(), placeholder: placeholder, borderless: borderless, value: formattedDate, componentRef: this._textField, underlined: underlined, tabIndex: tabIndex, readOnly: !allowTextInput }, textFieldProps, { id: this._id + '-label', className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])(classNames.textField, textFieldProps && textFieldProps.className), iconProps: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ iconName: 'Calendar' }, iconProps, { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])(classNames.icon, iconProps && iconProps.className), onClick: this._onIconClick }), onKeyDown: this._onTextFieldKeyDown, onFocus: this._onTextFieldFocus, onBlur: this._onTextFieldBlur, onClick: this._onTextFieldClick, onChange: this._onTextFieldChanged }))),
            isDatePickerShown && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Callout__["a" /* Callout */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ id: calloutId, role: "dialog", ariaLabel: pickerAriaLabel, isBeakVisible: false, gapSpace: 0, doNotLayer: false, target: this._datePickerDiv.current, directionalHint: __WEBPACK_IMPORTED_MODULE_6__common_DirectionalHint__["a" /* DirectionalHint */].bottomLeftEdge }, calloutProps, { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])(classNames.callout, calloutProps && calloutProps.className), onDismiss: this._calendarDismissed, onPositioned: this._onCalloutPositioned }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__FocusTrapZone__["a" /* FocusTrapZone */], { isClickableOutsideFocusTrap: true, disableFirstFocus: this.props.disableAutoFocus, forceFocusInsideTrap: false },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](CalendarType, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, calendarProps, { onSelectDate: this._onSelectDate, onDismiss: this._calendarDismissed, isMonthPickerVisible: this.props.isMonthPickerVisible, showMonthPickerAsOverlay: this.props.showMonthPickerAsOverlay, today: this.props.today, value: selectedDate || initialPickerDate, firstDayOfWeek: firstDayOfWeek, strings: strings, highlightCurrentMonth: this.props.highlightCurrentMonth, highlightSelectedMonth: this.props.highlightSelectedMonth, showWeekNumbers: this.props.showWeekNumbers, firstWeekOfYear: this.props.firstWeekOfYear, showGoToToday: this.props.showGoToToday, dateTimeFormatter: this.props.dateTimeFormatter, minDate: minDate, maxDate: maxDate, componentRef: this._calendar, showCloseButton: showCloseButton, allFocusable: allFocusable })))))));
    };
    DatePickerBase.prototype.focus = function () {
        if (this._textField.current) {
            this._textField.current.focus();
        }
    };
    DatePickerBase.prototype.reset = function () {
        this.setState(this._getDefaultState());
    };
    DatePickerBase.prototype._setErrorMessage = function (setState, nextProps) {
        var _a = nextProps || this.props, isRequired = _a.isRequired, strings = _a.strings, value = _a.value, minDate = _a.minDate, maxDate = _a.maxDate, initialPickerDate = _a.initialPickerDate;
        var errorMessage = !initialPickerDate && isRequired && !value ? strings.isRequiredErrorMessage || ' ' : undefined;
        if (!errorMessage && value) {
            errorMessage = this._isDateOutOfBounds(value, minDate, maxDate) ? strings.isOutOfBoundsErrorMessage || ' ' : undefined;
        }
        if (setState) {
            this.setState({
                errorMessage: errorMessage
            });
        }
        return errorMessage;
    };
    DatePickerBase.prototype._showDatePickerPopup = function () {
        if (!this.state.isDatePickerShown) {
            this._preventFocusOpeningPicker = true;
            this.setState({
                isDatePickerShown: true
            });
        }
    };
    DatePickerBase.prototype._getDefaultState = function (props) {
        if (props === void 0) { props = this.props; }
        return {
            selectedDate: props.value || undefined,
            formattedDate: props.formatDate && props.value ? props.formatDate(props.value) : '',
            isDatePickerShown: false,
            errorMessage: this._setErrorMessage(false)
        };
    };
    DatePickerBase.prototype._isDateOutOfBounds = function (date, minDate, maxDate) {
        return (!!minDate && Object(__WEBPACK_IMPORTED_MODULE_8__utilities_dateMath_DateMath__["e" /* compareDatePart */])(minDate, date) > 0) || (!!maxDate && Object(__WEBPACK_IMPORTED_MODULE_8__utilities_dateMath_DateMath__["e" /* compareDatePart */])(maxDate, date) < 0);
    };
    DatePickerBase.prototype._getErrorMessage = function () {
        if (this.state.isDatePickerShown) {
            return undefined;
        }
        return this.state.errorMessage;
    };
    DatePickerBase.defaultProps = {
        allowTextInput: false,
        formatDate: function (date) {
            if (date) {
                return date.toDateString();
            }
            return '';
        },
        parseDateFromString: function (dateStr) {
            var date = Date.parse(dateStr);
            if (date) {
                return new Date(date);
            }
            return null;
        },
        firstDayOfWeek: __WEBPACK_IMPORTED_MODULE_3__Calendar__["b" /* DayOfWeek */].Sunday,
        initialPickerDate: new Date(),
        isRequired: false,
        isMonthPickerVisible: true,
        showMonthPickerAsOverlay: false,
        strings: DEFAULT_STRINGS,
        highlightCurrentMonth: false,
        highlightSelectedMonth: false,
        borderless: false,
        pickerAriaLabel: 'Calendar',
        showWeekNumbers: false,
        firstWeekOfYear: __WEBPACK_IMPORTED_MODULE_4__utilities_dateValues_DateValues__["c" /* FirstWeekOfYear */].FirstDay,
        showGoToToday: true,
        dateTimeFormatter: undefined,
        showCloseButton: false,
        underlined: false,
        allFocusable: false
    };
    return DatePickerBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=DatePicker.base.js.map

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_dateValues_DateValues__ = __webpack_require__(186);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__utilities_dateValues_DateValues__["b"]; });
/* unused harmony reexport DateRangeType */
/* unused harmony reexport FirstWeekOfYear */


//# sourceMappingURL=Calendar.types.js.map

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ComboBox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Autofill_index__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Callout__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Checkbox__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_DirectionalHint__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ComboBox_styles__ = __webpack_require__(1821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ComboBox_classNames__ = __webpack_require__(1822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__KeytipData__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Label__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utilities_selectableOption_index__ = __webpack_require__(419);













var SearchDirection;
(function (SearchDirection) {
    SearchDirection[SearchDirection["backward"] = -1] = "backward";
    SearchDirection[SearchDirection["none"] = 0] = "none";
    SearchDirection[SearchDirection["forward"] = 1] = "forward";
})(SearchDirection || (SearchDirection = {}));
var HoverStatus;
(function (HoverStatus) {
    /** Used when the user was hovering and has since moused out of the menu items */
    HoverStatus[HoverStatus["clearAll"] = -2] = "clearAll";
    /** Default "normal" state, when no hover has happened or a hover is in progress */
    HoverStatus[HoverStatus["default"] = -1] = "default";
})(HoverStatus || (HoverStatus = {}));
var ScrollIdleDelay = 250 /* ms */;
var TouchIdleDelay = 500; /* ms */
/**
 * This is used to clear any pending autocomplete text (used when autocomplete is true and
 * allowFreeform is false)
 */
var ReadOnlyPendingAutoCompleteTimeout = 1000 /* ms */;
/**
 * Internal class that is used to wrap all ComboBox options.
 * This is used to customize when we want to rerender components,
 * so we don't rerender every option every time render is executed.
 */
var ComboBoxOptionWrapper = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ComboBoxOptionWrapper, _super);
    function ComboBoxOptionWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ComboBoxOptionWrapper.prototype.render = function () {
        return this.props.render();
    };
    ComboBoxOptionWrapper.prototype.shouldComponentUpdate = function (newProps) {
        // The render function will always be different, so we ignore that prop
        return !Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_27" /* shallowCompare */])(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this.props, { render: undefined }), __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, newProps, { render: undefined }));
    };
    return ComboBoxOptionWrapper;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
var ComboBox = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ComboBox, _super);
    function ComboBox(props) {
        var _this = _super.call(this, props) || this;
        _this._root = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        /** The input aspect of the comboBox */
        _this._autofill = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        /** The wrapping div of the input and button */
        _this._comboBoxWrapper = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        /** The callout element */
        _this._comboBoxMenu = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        /** The menu item element that is currently selected */
        _this._selectedElement = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        /**
         * {@inheritdoc}
         */
        _this.focus = function (shouldOpenOnFocus, useFocusAsync) {
            if (_this._autofill.current) {
                if (useFocusAsync) {
                    Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["E" /* focusAsync */])(_this._autofill.current);
                }
                else {
                    _this._autofill.current.focus();
                }
                if (shouldOpenOnFocus) {
                    _this.setState({
                        isOpen: true
                    });
                }
            }
        };
        /**
         * Close menu callout if it is open
         */
        _this.dismissMenu = function () {
            var isOpen = _this.state.isOpen;
            isOpen && _this.setState({ isOpen: false });
        };
        /**
         * componentWillReceiveProps handler for the auto fill component
         * Checks/updates the iput value to set, if needed
         * @param defaultVisibleValue - the defaultVisibleValue that got passed
         *  in to the auto fill's componentWillReceiveProps
         * @returns - the updated value to set, if needed
         */
        _this._onUpdateValueInAutofillWillReceiveProps = function () {
            var comboBox = _this._autofill.current;
            if (!comboBox) {
                return null;
            }
            if (comboBox.value === null || comboBox.value === undefined) {
                return null;
            }
            var visibleValue = _this._normalizeToString(_this._currentVisibleValue);
            if (comboBox.value !== visibleValue) {
                // If visibleValue is empty, make it a zero width space.
                // If we did not do that, the empty string would not get used
                // potentially resulting in an unexpected value being used
                return visibleValue || '​';
            }
            return comboBox.value;
        };
        /**
         * componentDidUpdate handler for the auto fill component
         *
         * @param defaultVisibleValue - the current defaultVisibleValue in the auto fill's componentDidUpdate
         * @param suggestedDisplayValue - the current suggestedDisplayValue in the auto fill's componentDidUpdate
         * @returns - should the full value of the input be selected?
         * True if the defaultVisibleValue equals the suggestedDisplayValue, false otherwise
         */
        _this._onShouldSelectFullInputValueInAutofillComponentDidUpdate = function () {
            return _this._currentVisibleValue === _this.state.suggestedDisplayValue;
        };
        /**
         * Get the correct value to pass to the input
         * to show to the user based off of the current props and state
         * @returns the value to pass to the input
         */
        _this._getVisibleValue = function () {
            var _a = _this.props, text = _a.text, value = _a.value, allowFreeform = _a.allowFreeform, autoComplete = _a.autoComplete;
            var _b = _this.state, selectedIndices = _b.selectedIndices, currentPendingValueValidIndex = _b.currentPendingValueValidIndex, currentOptions = _b.currentOptions, currentPendingValue = _b.currentPendingValue, suggestedDisplayValue = _b.suggestedDisplayValue, isOpen = _b.isOpen, focused = _b.focused;
            var currentPendingIndexValid = _this._indexWithinBounds(currentOptions, currentPendingValueValidIndex);
            // If the user passed is a value prop, use that
            // unless we are open and have a valid current pending index
            if (!(isOpen && currentPendingIndexValid) && (text && (currentPendingValue === null || currentPendingValue === undefined))) {
                return text;
            }
            if (!(isOpen && currentPendingIndexValid) && (value && (currentPendingValue === null || currentPendingValue === undefined))) {
                return value;
            }
            // Values to display in the BaseAutoFill area
            var displayValues = [];
            if (_this.props.multiSelect) {
                // Multi-select
                if (focused) {
                    var index = -1;
                    if (autoComplete === 'on' && currentPendingIndexValid) {
                        index = currentPendingValueValidIndex;
                    }
                    displayValues.push(currentPendingValue !== null && currentPendingValue !== undefined
                        ? currentPendingValue
                        : _this._indexWithinBounds(currentOptions, index)
                            ? currentOptions[index].text
                            : '');
                }
                else {
                    for (var idx = 0; selectedIndices && idx < selectedIndices.length; idx++) {
                        var index = selectedIndices[idx];
                        displayValues.push(_this._indexWithinBounds(currentOptions, index) ? currentOptions[index].text : _this._normalizeToString(suggestedDisplayValue));
                    }
                }
            }
            else {
                // Single-select
                var index = _this._getFirstSelectedIndex();
                if (allowFreeform) {
                    // If we are allowing freeform and autocomplete is also true
                    // and we've got a pending value that matches an option, remember
                    // the matched option's index
                    if (autoComplete === 'on' && currentPendingIndexValid) {
                        index = currentPendingValueValidIndex;
                    }
                    // Since we are allowing freeform, if there is currently a pending value, use that
                    // otherwise use the index determined above (falling back to '' if we did not get a valid index)
                    displayValues.push(currentPendingValue !== null && currentPendingValue !== undefined
                        ? currentPendingValue
                        : _this._indexWithinBounds(currentOptions, index)
                            ? currentOptions[index].text
                            : '');
                }
                else {
                    // If we are not allowing freeform and have a
                    // valid index that matches the pending value,
                    // we know we will need some version of the pending value
                    if (currentPendingIndexValid && autoComplete === 'on') {
                        // If autoComplete is on, return the
                        // raw pending value, otherwise remember
                        // the matched option's index
                        index = currentPendingValueValidIndex;
                        displayValues.push(_this._normalizeToString(currentPendingValue));
                    }
                    else {
                        displayValues.push(_this._indexWithinBounds(currentOptions, index) ? currentOptions[index].text : _this._normalizeToString(suggestedDisplayValue));
                    }
                }
            }
            // If we have a valid index then return the text value of that option,
            // otherwise return the suggestedDisplayValue
            var displayString = '';
            for (var idx = 0; idx < displayValues.length; idx++) {
                if (idx > 0) {
                    displayString += ', ';
                }
                displayString += displayValues[idx];
            }
            return displayString;
        };
        /**
         * Handler for typing changes on the input
         * @param updatedValue - the newly changed value
         */
        _this._onInputChange = function (updatedValue) {
            if (_this.props.disabled) {
                _this._handleInputWhenDisabled(null /* event */);
                return;
            }
            _this.props.allowFreeform ? _this._processInputChangeWithFreeform(updatedValue) : _this._processInputChangeWithoutFreeform(updatedValue);
        };
        /**
         * Focus (and select) the content of the input
         * and set the focused state
         */
        _this._select = function () {
            if (_this._autofill.current && _this._autofill.current.inputElement) {
                _this._autofill.current.inputElement.select();
            }
            if (!_this.state.focused) {
                var state = { focused: true };
                if (_this.props.openOnKeyboardFocus && !_this.state.isOpen && !_this.props.disabled) {
                    state.isOpen = true;
                }
                _this.setState(state);
            }
        };
        /**
         * Callback issued when the options should be resolved, if they have been updated or
         * if they need to be passed in the first time. This only does work if an onResolveOptions
         * callback was passed in
         */
        _this._onResolveOptions = function () {
            if (_this.props.onResolveOptions) {
                // get the options
                var newOptions = _this.props.onResolveOptions(_this.state.currentOptions.slice());
                // Check to see if the returned value is an array, if it is update the state
                // If the returned value is not an array then check to see if it's a promise or PromiseLike. If it is then resolve it asynchronously.
                if (Array.isArray(newOptions)) {
                    _this.setState({
                        currentOptions: newOptions
                    });
                }
                else if (newOptions && newOptions.then) {
                    // Ensure that the promise will only use the callback if it was the most recent one
                    // and update the state when the promise returns
                    var promise_1 = (_this._currentPromise = newOptions);
                    promise_1.then(function (newOptionsFromPromise) {
                        if (promise_1 === _this._currentPromise) {
                            _this.setState({
                                currentOptions: newOptionsFromPromise
                            });
                        }
                    });
                }
            }
        };
        /**
         * OnBlur handler. Set the focused state to false
         * and submit any pending value
         */
        _this._onBlur = function (event) {
            // Do nothing if the blur is coming from something
            // inside the comboBox root or the comboBox menu since
            // it we are not really bluring from the whole comboBox
            var relatedTarget = event.relatedTarget;
            if (event.relatedTarget === null) {
                // In IE11, due to lack of support, event.relatedTarget is always
                // null making every onBlur call to be "outside" of the ComboBox
                // even when it's not. Using document.activeElement is another way
                // for us to be able to get what the relatedTarget without relying
                // on the event
                relatedTarget = document.activeElement;
            }
            if (relatedTarget &&
                // when event coming from withing the comboBox title
                ((_this._root.current && _this._root.current.contains(relatedTarget)) ||
                    // when event coming from within the comboBox list menu
                    (_this._comboBoxMenu.current &&
                        (_this._comboBoxMenu.current.contains(relatedTarget) ||
                            // when event coming from the callout containing the comboBox list menu (ex: when scrollBar of the Callout clicked)
                            // checks if the relatedTarget is a parent of _comboBoxMenu
                            Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["B" /* findElementRecursive */])(_this._comboBoxMenu.current, function (element) { return element === relatedTarget; }))))) {
                event.preventDefault();
                event.stopPropagation();
                return;
            }
            if (_this.state.focused) {
                _this.setState({ focused: false });
                if (!_this.props.multiSelect || _this.props.allowFreeform) {
                    _this._submitPendingValue(event);
                }
            }
        };
        // Render Callout container and pass in list
        _this._onRenderContainer = function (props) {
            var onRenderList = props.onRenderList, calloutProps = props.calloutProps, dropdownWidth = props.dropdownWidth, dropdownMaxWidth = props.dropdownMaxWidth, _a = props.onRenderLowerContent, onRenderLowerContent = _a === void 0 ? _this._onRenderLowerContent : _a, useComboBoxAsMenuWidth = props.useComboBoxAsMenuWidth, persistMenu = props.persistMenu, _b = props.shouldRestoreFocus, shouldRestoreFocus = _b === void 0 ? true : _b;
            var isOpen = _this.state.isOpen;
            var comboBoxMenuWidth = useComboBoxAsMenuWidth && _this._comboBoxWrapper.current ? _this._comboBoxWrapper.current.clientWidth + 2 : undefined;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Callout__["a" /* Callout */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ isBeakVisible: false, gapSpace: 0, doNotLayer: false, directionalHint: __WEBPACK_IMPORTED_MODULE_7__common_DirectionalHint__["a" /* DirectionalHint */].bottomLeftEdge, directionalHintFixed: false }, calloutProps, { onLayerMounted: _this._onLayerMounted, className: Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["t" /* css */])(_this._classNames.callout, calloutProps ? calloutProps.className : undefined), target: _this._comboBoxWrapper.current, onDismiss: _this._onDismiss, onScroll: _this._onScroll, setInitialFocus: false, calloutWidth: useComboBoxAsMenuWidth && _this._comboBoxWrapper.current ? comboBoxMenuWidth && comboBoxMenuWidth : dropdownWidth, calloutMaxWidth: dropdownMaxWidth ? dropdownMaxWidth : comboBoxMenuWidth, hidden: persistMenu ? !isOpen : undefined, shouldRestoreFocus: shouldRestoreFocus }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: _this._classNames.optionsContainerWrapper, ref: _this._comboBoxMenu }, onRenderList(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, props), _this._onRenderList)),
                onRenderLowerContent(_this.props, _this._onRenderLowerContent)));
        };
        _this._onLayerMounted = function () {
            _this._onCalloutLayerMounted();
            if (_this.props.calloutProps && _this.props.calloutProps.onLayerMounted) {
                _this.props.calloutProps.onLayerMounted();
            }
        };
        // Render List of items
        _this._onRenderList = function (props) {
            var onRenderItem = props.onRenderItem, options = props.options;
            var id = _this._id;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { id: id + '-list', className: _this._classNames.optionsContainer, "aria-labelledby": id + '-label', role: "listbox" }, options.map(function (item) { return onRenderItem(item, _this._onRenderItem); })));
        };
        // Render items
        _this._onRenderItem = function (item) {
            switch (item.itemType) {
                case __WEBPACK_IMPORTED_MODULE_12__utilities_selectableOption_index__["a" /* SelectableOptionMenuItemType */].Divider:
                    return _this._renderSeparator(item);
                case __WEBPACK_IMPORTED_MODULE_12__utilities_selectableOption_index__["a" /* SelectableOptionMenuItemType */].Header:
                    return _this._renderHeader(item);
                default:
                    return _this._renderOption(item);
            }
        };
        // Default _onRenderLowerContent function returns nothing
        _this._onRenderLowerContent = function () {
            return null;
        };
        _this._renderOption = function (item) {
            var _a = _this.props.onRenderOption, onRenderOption = _a === void 0 ? _this._onRenderOptionContent : _a;
            var id = _this._id;
            var isSelected = _this._isOptionSelected(item.index);
            var optionStyles = _this._getCurrentOptionStyles(item);
            var optionClassNames = Object(__WEBPACK_IMPORTED_MODULE_9__ComboBox_classNames__["b" /* getComboBoxOptionClassNames */])(_this._getCurrentOptionStyles(item));
            var checkboxStyles = function () {
                return optionStyles;
            };
            var title = _this._getPreviewText(item);
            var getOptionComponent = function () {
                return !_this.props.multiSelect ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Button__["e" /* CommandButton */], { id: id + '-list' + item.index, key: item.key, "data-index": item.index, styles: _this._getCurrentOptionStyles(item), checked: isSelected, className: 'ms-ComboBox-option', onClick: _this._onItemClick(item), onMouseEnter: _this._onOptionMouseEnter.bind(_this, item.index), onMouseMove: _this._onOptionMouseMove.bind(_this, item.index), onMouseLeave: _this._onOptionMouseLeave, role: "option", "aria-selected": isSelected ? 'true' : 'false', ariaLabel: _this._getPreviewText(item), disabled: item.disabled, title: title },
                    ' ',
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: optionClassNames.optionTextWrapper, ref: isSelected ? _this._selectedElement : undefined }, onRenderOption(item, _this._onRenderOptionContent)))) : (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Checkbox__["a" /* Checkbox */], { id: id + '-list' + item.index, ariaLabel: _this._getPreviewText(item), key: item.key, "data-index": item.index, styles: checkboxStyles, className: 'ms-ComboBox-option', "data-is-focusable": true, onChange: _this._onItemClick(item), label: item.text, role: "option", "aria-selected": isSelected ? 'true' : 'false', checked: isSelected, title: title }, onRenderOption(item, _this._onRenderOptionContent)));
            };
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ComboBoxOptionWrapper, { key: item.key, index: item.index, disabled: item.disabled, isSelected: isSelected, text: item.text, render: getOptionComponent, data: item.data }));
        };
        /**
         * Scroll handler for the callout to make sure the mouse events
         * for updating focus are not interacting during scroll
         */
        _this._onScroll = function () {
            if (!_this._isScrollIdle && _this._scrollIdleTimeoutId !== undefined) {
                _this._async.clearTimeout(_this._scrollIdleTimeoutId);
                _this._scrollIdleTimeoutId = undefined;
            }
            else {
                _this._isScrollIdle = false;
            }
            _this._scrollIdleTimeoutId = _this._async.setTimeout(function () {
                _this._isScrollIdle = true;
            }, ScrollIdleDelay);
        };
        _this._onRenderOptionContent = function (item) {
            var optionClassNames = Object(__WEBPACK_IMPORTED_MODULE_9__ComboBox_classNames__["b" /* getComboBoxOptionClassNames */])(_this._getCurrentOptionStyles(item));
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: optionClassNames.optionText }, item.text);
        };
        /**
         * Handles dismissing (cancelling) the menu
         */
        _this._onDismiss = function () {
            var onMenuDismiss = _this.props.onMenuDismiss;
            if (onMenuDismiss) {
                onMenuDismiss();
            }
            // In persistMode we need to simulate callout layer mount
            // since that only happens once. We do it on dismiss since
            // it works either way.
            if (_this.props.persistMenu) {
                _this._onCalloutLayerMounted();
            }
            // close the menu
            _this._setOpenStateAndFocusOnClose(false /* isOpen */, false /* focusInputAfterClose */);
            // reset the selected index
            // to the last value state
            _this._resetSelectedIndex();
        };
        _this._onAfterClearPendingInfo = function () {
            _this._processingClearPendingInfo = false;
        };
        /**
         * Handle keydown on the input
         * @param ev - The keyboard event that was fired
         */
        _this._onInputKeyDown = function (ev) {
            var _a = _this.props, disabled = _a.disabled, allowFreeform = _a.allowFreeform, autoComplete = _a.autoComplete;
            var _b = _this.state, isOpen = _b.isOpen, currentOptions = _b.currentOptions, currentPendingValueValidIndexOnHover = _b.currentPendingValueValidIndexOnHover;
            // Take note if we are processing an alt (option) or meta (command) keydown.
            // See comment in _onInputKeyUp for reasoning.
            _this._lastKeyDownWasAltOrMeta = _this._isAltOrMeta(ev);
            if (disabled) {
                _this._handleInputWhenDisabled(ev);
                return;
            }
            var index = _this._getPendingSelectedIndex(false /* includeCurrentPendingValue */);
            switch (ev.which) {
                case __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].enter:
                    if (_this._autofill.current && _this._autofill.current.inputElement) {
                        _this._autofill.current.inputElement.select();
                    }
                    _this._submitPendingValue(ev);
                    if (_this.props.multiSelect && isOpen) {
                        _this.setState({
                            currentPendingValueValidIndex: index
                        });
                    }
                    else {
                        // On enter submit the pending value
                        if (isOpen ||
                            ((!allowFreeform ||
                                _this.state.currentPendingValue === undefined ||
                                _this.state.currentPendingValue === null ||
                                _this.state.currentPendingValue.length <= 0) &&
                                _this.state.currentPendingValueValidIndex < 0)) {
                            // if we are open or
                            // if we are not allowing freeform or
                            // our we have no pending value
                            // and no valid pending index
                            // flip the open state
                            _this.setState({
                                isOpen: !isOpen
                            });
                        }
                    }
                    break;
                case __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].tab:
                    // On enter submit the pending value
                    if (!_this.props.multiSelect) {
                        _this._submitPendingValue(ev);
                    }
                    // If we are not allowing freeform
                    // or the comboBox is open, flip the open state
                    if (isOpen) {
                        _this._setOpenStateAndFocusOnClose(!isOpen, false /* focusInputAfterClose */);
                    }
                    // Allow TAB to propigate
                    return;
                case __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].escape:
                    // reset the selected index
                    _this._resetSelectedIndex();
                    // Close the menu if opened
                    if (isOpen) {
                        _this.setState({
                            isOpen: false
                        });
                    }
                    else {
                        return;
                    }
                    break;
                case __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].up:
                    // if we are in clearAll state (e.g. the user as hovering
                    // and has since mousedOut of the menu items),
                    // go to the last index
                    if (currentPendingValueValidIndexOnHover === HoverStatus.clearAll) {
                        index = _this.state.currentOptions.length;
                    }
                    if (ev.altKey || ev.metaKey) {
                        // Close the menu if it is open and break so
                        // that the event get stopPropagation and prevent default.
                        // Otherwise, we need to let the event continue to propagate
                        if (isOpen) {
                            _this._setOpenStateAndFocusOnClose(!isOpen, true /* focusInputAfterClose */);
                            break;
                        }
                        return;
                    }
                    // Go to the previous option
                    _this._setPendingInfoFromIndexAndDirection(index, SearchDirection.backward);
                    break;
                case __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].down:
                    // Expand the comboBox on ALT + DownArrow
                    if (ev.altKey || ev.metaKey) {
                        _this._setOpenStateAndFocusOnClose(true /* isOpen */, true /* focusInputAfterClose */);
                    }
                    else {
                        // if we are in clearAll state (e.g. the user as hovering
                        // and has since mousedOut of the menu items),
                        // go to the first index
                        if (currentPendingValueValidIndexOnHover === HoverStatus.clearAll) {
                            index = -1;
                        }
                        // Got to the next option
                        _this._setPendingInfoFromIndexAndDirection(index, SearchDirection.forward);
                    }
                    break;
                case __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].home:
                case __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].end:
                    if (allowFreeform) {
                        return;
                    }
                    // Set the initial values to respond to HOME
                    // which goes to the first selectable option
                    index = -1;
                    var directionToSearch = SearchDirection.forward;
                    // If end, update the values to respond to END
                    // which goes to the last selectable option
                    if (ev.which === __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].end) {
                        index = currentOptions.length;
                        directionToSearch = SearchDirection.backward;
                    }
                    _this._setPendingInfoFromIndexAndDirection(index, directionToSearch);
                    break;
                case __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].space:
                    // event handled in _onComboBoxKeyUp
                    if (!allowFreeform && autoComplete === 'off') {
                        break;
                    }
                default:
                    // are we processing a function key? if so bail out
                    if (ev.which >= 112 /* F1 */ && ev.which <= 123 /* F12 */) {
                        return;
                    }
                    // If we get here and we got either and ALT key
                    // or meta key, let the event propagate
                    if (ev.keyCode === __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].alt || ev.key === 'Meta' /* && isOpen */) {
                        return;
                    }
                    // If we are not allowing freeform and
                    // allowing autoComplete, handle the input here
                    // since we have marked the input as readonly
                    if (!allowFreeform && autoComplete === 'on') {
                        _this._onInputChange(String.fromCharCode(ev.which));
                        break;
                    }
                    // allow the key to propagate by default
                    return;
            }
            ev.stopPropagation();
            ev.preventDefault();
        };
        /**
         * Handle keyup on the input
         * @param ev - the keyboard event that was fired
         */
        _this._onInputKeyUp = function (ev) {
            var _a = _this.props, disabled = _a.disabled, allowFreeform = _a.allowFreeform, autoComplete = _a.autoComplete;
            var isOpen = _this.state.isOpen;
            // We close the menu on key up only if ALL of the following are true:
            // - Most recent key down was alt or meta (command)
            // - The alt/meta key down was NOT followed by some other key (such as down/up arrow to
            //   expand/collapse the menu)
            // - We're not on a Mac (or iOS)
            // This is because on Windows, pressing alt moves focus to the application menu bar or similar,
            // closing any open context menus. There is not a similar behavior on Macs.
            var keyPressIsAltOrMetaAlone = _this._lastKeyDownWasAltOrMeta && _this._isAltOrMeta(ev);
            _this._lastKeyDownWasAltOrMeta = false;
            var shouldHandleKey = keyPressIsAltOrMetaAlone && !(Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_13" /* isMac */])() || Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_12" /* isIOS */])());
            if (disabled) {
                _this._handleInputWhenDisabled(ev);
                return;
            }
            switch (ev.which) {
                case __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].space:
                    // If we are not allowing freeform and are not autoComplete
                    // make space expand/collapse the comboBox
                    // and allow the event to propagate
                    if (!allowFreeform && autoComplete === 'off') {
                        _this._setOpenStateAndFocusOnClose(!isOpen, !!isOpen);
                        return;
                    }
                    break;
                default:
                    if (shouldHandleKey && isOpen) {
                        _this._setOpenStateAndFocusOnClose(!isOpen, true /* focusInputAfterClose */);
                    }
                    return;
            }
            ev.stopPropagation();
            ev.preventDefault();
        };
        _this._onOptionMouseLeave = function () {
            if (_this._shouldIgnoreMouseEvent()) {
                return;
            }
            // Ignore the event in persistMenu mode if the callout has
            // closed. This is to avoid clearing the visuals on item click.
            if (_this.props.persistMenu && !_this.state.isOpen) {
                return;
            }
            _this.setState({
                currentPendingValueValidIndexOnHover: HoverStatus.clearAll
            });
        };
        /**
         * Click handler for the button of the comboBox
         * and the input when not allowing freeform. This
         * toggles the expand/collapse state of the comboBox (if enbled)
         */
        _this._onComboBoxClick = function () {
            var disabled = _this.props.disabled;
            var isOpen = _this.state.isOpen;
            if (!disabled) {
                _this._setOpenStateAndFocusOnClose(!isOpen, false /* focusInputAfterClose */);
                _this.setState({ focused: true });
            }
        };
        /**
         * Click handler for the autofill.
         */
        _this._onAutofillClick = function () {
            if (_this.props.allowFreeform) {
                _this.focus(_this.state.isOpen || _this._processingTouch);
            }
            else {
                _this._onComboBoxClick();
            }
        };
        _this._onTouchStart = function () {
            if (_this._comboBoxWrapper.current && !('onpointerdown' in _this._comboBoxWrapper)) {
                _this._handleTouchAndPointerEvent();
            }
        };
        _this._onPointerDown = function (ev) {
            if (ev.pointerType === 'touch') {
                _this._handleTouchAndPointerEvent();
                ev.preventDefault();
                ev.stopImmediatePropagation();
            }
        };
        _this._warnMutuallyExclusive({
            defaultSelectedKey: 'selectedKey',
            text: 'defaultSelectedKey',
            value: 'defaultSelectedKey',
            selectedKey: 'value',
            dropdownWidth: 'useComboBoxAsMenuWidth'
        });
        _this._warnDeprecations({
            value: 'text',
            onChanged: 'onChange'
        });
        _this._id = props.id || Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["N" /* getId */])('ComboBox');
        var selectedKeys = _this._buildDefaultSelectedKeys(props.defaultSelectedKey, props.selectedKey);
        _this._isScrollIdle = true;
        _this._processingTouch = false;
        _this._gotMouseMove = false;
        _this._processingClearPendingInfo = false;
        var initialSelectedIndices = _this._getSelectedIndices(props.options, selectedKeys);
        _this.state = {
            isOpen: false,
            selectedIndices: initialSelectedIndices,
            focused: false,
            suggestedDisplayValue: undefined,
            currentOptions: _this.props.options,
            currentPendingValueValidIndex: -1,
            currentPendingValue: undefined,
            currentPendingValueValidIndexOnHover: HoverStatus.default
        };
        return _this;
    }
    Object.defineProperty(ComboBox.prototype, "selectedOptions", {
        /**
         * All selected options
         */
        get: function () {
            var _a = this.state, currentOptions = _a.currentOptions, selectedIndices = _a.selectedIndices;
            return Object(__WEBPACK_IMPORTED_MODULE_12__utilities_selectableOption_index__["b" /* getAllSelectedOptions */])(currentOptions, selectedIndices);
        },
        enumerable: true,
        configurable: true
    });
    ComboBox.prototype.componentDidMount = function () {
        if (this._comboBoxWrapper.current) {
            // hook up resolving the options if needed on focus
            this._events.on(this._comboBoxWrapper.current, 'focus', this._onResolveOptions, true);
            if ('onpointerdown' in this._comboBoxWrapper.current) {
                // For ComboBoxes, touching anywhere in the combo box should drop the dropdown, including the input element.
                // This gives more hit target space for touch environments. We're setting the onpointerdown here, because React
                // does not support Pointer events yet.
                this._events.on(this._comboBoxWrapper.current, 'pointerdown', this._onPointerDown, true);
            }
        }
    };
    ComboBox.prototype.componentWillReceiveProps = function (newProps) {
        // Update the selectedIndex and currentOptions state if
        // the selectedKey, value, or options have changed
        if (newProps.selectedKey !== this.props.selectedKey ||
            newProps.text !== this.props.text ||
            newProps.value !== this.props.value ||
            newProps.options !== this.props.options) {
            var selectedKeys = this._buildSelectedKeys(newProps.selectedKey);
            var indices = this._getSelectedIndices(newProps.options, selectedKeys);
            this.setState({
                selectedIndices: indices,
                currentOptions: newProps.options
            });
        }
    };
    ComboBox.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _this = this;
        var _a = this.props, allowFreeform = _a.allowFreeform, text = _a.text, value = _a.value, onMenuOpen = _a.onMenuOpen, onMenuDismissed = _a.onMenuDismissed;
        var _b = this.state, isOpen = _b.isOpen, focused = _b.focused, selectedIndices = _b.selectedIndices, currentPendingValueValidIndex = _b.currentPendingValueValidIndex;
        // If we are newly open or are open and the pending valid index changed,
        // make sure the currently selected/pending option is scrolled into view
        if (isOpen && (!prevState.isOpen || prevState.currentPendingValueValidIndex !== currentPendingValueValidIndex)) {
            // Need this timeout so that the selectedElement ref is correctly updated
            this._async.setTimeout(function () { return _this._scrollIntoView(); }, 0);
        }
        // if an action is taken that put focus in the ComboBox
        // and If we are open or we are just closed, shouldFocusAfterClose is set,
        // but we are not the activeElement set focus on the input
        if (focused &&
            (isOpen ||
                (prevState.isOpen &&
                    !isOpen &&
                    this._focusInputAfterClose &&
                    this._autofill.current &&
                    document.activeElement !== this._autofill.current.inputElement))) {
            this.focus(undefined /*shouldOpenOnFocus*/, true /*useFocusAsync*/);
        }
        // If we should focusAfterClose AND
        //   just opened/closed the menu OR
        //   are focused AND
        //     updated the selectedIndex with the menu closed OR
        //     are not allowing freeform OR
        //     the value changed
        // we need to set selection
        if (this._focusInputAfterClose &&
            ((prevState.isOpen && !isOpen) ||
                (focused &&
                    ((!isOpen &&
                        !this.props.multiSelect &&
                        prevState.selectedIndices &&
                        selectedIndices &&
                        prevState.selectedIndices[0] !== selectedIndices[0]) ||
                        !allowFreeform ||
                        text !== prevProps.text ||
                        value !== prevProps.value)))) {
            this._select();
        }
        this._notifyPendingValueChanged(prevState);
        if (isOpen && !prevState.isOpen && onMenuOpen) {
            onMenuOpen();
        }
        if (!isOpen && prevState.isOpen && onMenuDismissed) {
            onMenuDismissed();
        }
    };
    ComboBox.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        // remove the eventHanlder that was added in componentDidMount
        this._events.off(this._comboBoxWrapper.current);
    };
    // Primary Render
    ComboBox.prototype.render = function () {
        var _this = this;
        var id = this._id;
        var _a = this.props, className = _a.className, label = _a.label, disabled = _a.disabled, ariaLabel = _a.ariaLabel, ariaDescribedBy = _a.ariaDescribedBy, required = _a.required, errorMessage = _a.errorMessage, _b = _a.onRenderContainer, onRenderContainer = _b === void 0 ? this._onRenderContainer : _b, _c = _a.onRenderList, onRenderList = _c === void 0 ? this._onRenderList : _c, _d = _a.onRenderItem, onRenderItem = _d === void 0 ? this._onRenderItem : _d, _e = _a.onRenderOption, onRenderOption = _e === void 0 ? this._onRenderOptionContent : _e, allowFreeform = _a.allowFreeform, buttonIconProps = _a.buttonIconProps, _f = _a.isButtonAriaHidden, isButtonAriaHidden = _f === void 0 ? true : _f, customStyles = _a.styles, theme = _a.theme, title = _a.title, keytipProps = _a.keytipProps, placeholder = _a.placeholder, tabIndex = _a.tabIndex, autofill = _a.autofill, persistMenu = _a.persistMenu;
        var _g = this.state, isOpen = _g.isOpen, focused = _g.focused, suggestedDisplayValue = _g.suggestedDisplayValue;
        this._currentVisibleValue = this._getVisibleValue();
        var divProps = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["R" /* getNativeProps */])(this.props, __WEBPACK_IMPORTED_MODULE_3__Utilities__["w" /* divProperties */], ['onChange', 'value']);
        var hasErrorMessage = errorMessage && errorMessage.length > 0 ? true : false;
        this._classNames = this.props.getClassNames
            ? this.props.getClassNames(theme, !!isOpen, !!disabled, !!required, !!focused, !!allowFreeform, !!hasErrorMessage, className)
            : Object(__WEBPACK_IMPORTED_MODULE_9__ComboBox_classNames__["a" /* getClassNames */])(Object(__WEBPACK_IMPORTED_MODULE_8__ComboBox_styles__["c" /* getStyles */])(theme, customStyles), className, !!isOpen, !!disabled, !!required, !!focused, !!allowFreeform, !!hasErrorMessage);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, divProps, { ref: this._root, className: this._classNames.container }),
            label && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Label__["a" /* Label */], { id: id + '-label', disabled: disabled, required: required, htmlFor: id + '-input', className: this._classNames.label }, label)),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__KeytipData__["a" /* KeytipData */], { keytipProps: keytipProps, disabled: disabled }, function (keytipAttributes) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { "data-ktp-target": keytipAttributes['data-ktp-target'], ref: _this._comboBoxWrapper, id: id + 'wrapper', className: _this._classNames.root },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Autofill_index__["a" /* Autofill */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ "data-ktp-execute-target": keytipAttributes['data-ktp-execute-target'], "data-is-interactable": !disabled, componentRef: _this._autofill, id: id + '-input', className: _this._classNames.input, type: "text", onFocus: _this._select, onBlur: _this._onBlur, onKeyDown: _this._onInputKeyDown, onKeyUp: _this._onInputKeyUp, onClick: _this._onAutofillClick, onTouchStart: _this._onTouchStart, onInputValueChange: _this._onInputChange, "aria-expanded": isOpen, "aria-autocomplete": _this._getAriaAutoCompleteValue(), role: "combobox", readOnly: disabled || !allowFreeform, "aria-labelledby": label && id + '-label', "aria-label": ariaLabel && !label ? ariaLabel : undefined, "aria-describedby": Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_16" /* mergeAriaAttributeValues */])(ariaDescribedBy, keytipAttributes['aria-describedby']), "aria-activedescendant": _this._getAriaActiveDescentValue(), "aria-required": required, "aria-disabled": disabled, "aria-owns": isOpen ? id + '-list' : undefined, spellCheck: false, defaultVisibleValue: _this._currentVisibleValue, suggestedDisplayValue: suggestedDisplayValue, updateValueInWillReceiveProps: _this._onUpdateValueInAutofillWillReceiveProps, shouldSelectFullInputValueInComponentDidUpdate: _this._onShouldSelectFullInputValueInAutofillComponentDidUpdate, title: title, preventValueSelection: !focused, placeholder: placeholder, tabIndex: tabIndex }, autofill)),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Button__["g" /* IconButton */], { className: 'ms-ComboBox-CaretDown-button', styles: _this._getCaretButtonStyles(), role: "presentation", "aria-hidden": isButtonAriaHidden, "data-is-focusable": false, tabIndex: -1, onClick: _this._onComboBoxClick, onBlur: _this._onBlur, iconProps: buttonIconProps, disabled: disabled, checked: isOpen }))); }),
            (persistMenu || isOpen) &&
                onRenderContainer(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this.props, { onRenderList: onRenderList,
                    onRenderItem: onRenderItem,
                    onRenderOption: onRenderOption, options: this.state.currentOptions.map(function (item, index) { return (__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, item, { index: index })); }) }), this._onRenderContainer),
            errorMessage && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.errorMessage }, errorMessage)));
    };
    /**
     * Is the index within the bounds of the array?
     * @param options - options to check if the index is valid for
     * @param index - the index to check
     * @returns - true if the index is valid for the given options, false otherwise
     */
    ComboBox.prototype._indexWithinBounds = function (options, index) {
        if (!options) {
            return false;
        }
        return index >= 0 && index < options.length;
    };
    /**
     * Process the new input's new value when the comboBox
     * allows freeform entry
     * @param updatedValue - the input's newly changed value
     */
    ComboBox.prototype._processInputChangeWithFreeform = function (updatedValue) {
        var _this = this;
        var currentOptions = this.state.currentOptions;
        updatedValue = this._removeZeroWidthSpaces(updatedValue);
        var newCurrentPendingValueValidIndex = -1;
        // if the new value is empty, see if we have an exact match
        // and then set the pending info
        if (updatedValue === '') {
            var items = currentOptions
                .map(function (item, index) {
                return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, item, { index: index });
            })
                .filter(function (option) { return option.itemType !== __WEBPACK_IMPORTED_MODULE_12__utilities_selectableOption_index__["a" /* SelectableOptionMenuItemType */].Header && option.itemType !== __WEBPACK_IMPORTED_MODULE_12__utilities_selectableOption_index__["a" /* SelectableOptionMenuItemType */].Divider; })
                .filter(function (option) { return _this._getPreviewText(option) === updatedValue; });
            // if we found a match remember the index
            if (items.length === 1) {
                newCurrentPendingValueValidIndex = items[0].index;
            }
            this._setPendingInfo(updatedValue, newCurrentPendingValueValidIndex, updatedValue);
            return;
        }
        // Remember the original value and then,
        // make the value lowercase for comparison
        var originalUpdatedValue = updatedValue;
        updatedValue = updatedValue.toLocaleLowerCase();
        var newSuggestedDisplayValue = '';
        // If autoComplete is on, attempt to find a match from the available options
        if (this.props.autoComplete === 'on') {
            // If autoComplete is on, attempt to find a match where the text of an option starts with the updated value
            var items = currentOptions
                .map(function (item, index) {
                return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, item, { index: index });
            })
                .filter(function (option) { return option.itemType !== __WEBPACK_IMPORTED_MODULE_12__utilities_selectableOption_index__["a" /* SelectableOptionMenuItemType */].Header && option.itemType !== __WEBPACK_IMPORTED_MODULE_12__utilities_selectableOption_index__["a" /* SelectableOptionMenuItemType */].Divider; })
                .filter(function (option) {
                return _this._getPreviewText(option)
                    .toLocaleLowerCase()
                    .indexOf(updatedValue) === 0;
            });
            if (items.length > 0) {
                // use ariaLabel as the value when the option is set
                var text = this._getPreviewText(items[0]);
                // If the user typed out the complete option text, we don't need any suggested display text anymore
                newSuggestedDisplayValue = text.toLocaleLowerCase() !== updatedValue ? text : '';
                // remember the index of the match we found
                newCurrentPendingValueValidIndex = items[0].index;
            }
        }
        else {
            // If autoComplete is off, attempt to find a match only when the value is exactly equal to the text of an option
            var items = currentOptions
                .map(function (item, index) {
                return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, item, { index: index });
            })
                .filter(function (option) { return option.itemType !== __WEBPACK_IMPORTED_MODULE_12__utilities_selectableOption_index__["a" /* SelectableOptionMenuItemType */].Header && option.itemType !== __WEBPACK_IMPORTED_MODULE_12__utilities_selectableOption_index__["a" /* SelectableOptionMenuItemType */].Divider; })
                .filter(function (option) { return _this._getPreviewText(option).toLocaleLowerCase() === updatedValue; });
            // if we found a match remember the index
            if (items.length === 1) {
                newCurrentPendingValueValidIndex = items[0].index;
            }
        }
        // Set the updated state
        this._setPendingInfo(originalUpdatedValue, newCurrentPendingValueValidIndex, newSuggestedDisplayValue);
    };
    /**
     * Process the new input's new value when the comboBox
     * does not allow freeform entry
     * @param updatedValue - the input's newly changed value
     */
    ComboBox.prototype._processInputChangeWithoutFreeform = function (updatedValue) {
        var _this = this;
        var _a = this.state, currentPendingValue = _a.currentPendingValue, currentPendingValueValidIndex = _a.currentPendingValueValidIndex, currentOptions = _a.currentOptions;
        updatedValue = this._removeZeroWidthSpaces(updatedValue);
        if (this.props.autoComplete === 'on') {
            // If autoComplete is on while allow freeform is off,
            // we will remember the keypresses and build up a string to attempt to match
            // as long as characters are typed within a the timeout span of each other,
            // otherwise we will clear the string and start building a new one on the next keypress.
            // Also, only do this processing if we have a non-empty value
            if (updatedValue !== '') {
                // If we have a pending autocomplete clearing task,
                // we know that the user is typing with keypresses happening
                // within the timeout of each other so remove the clearing task
                // and continue building the pending value with the udpated value
                if (this._lastReadOnlyAutoCompleteChangeTimeoutId !== undefined) {
                    this._async.clearTimeout(this._lastReadOnlyAutoCompleteChangeTimeoutId);
                    this._lastReadOnlyAutoCompleteChangeTimeoutId = undefined;
                    updatedValue = this._normalizeToString(currentPendingValue) + updatedValue;
                }
                var originalUpdatedValue = updatedValue;
                updatedValue = updatedValue.toLocaleLowerCase();
                // If autoComplete is on, attempt to find a match where the text of an option starts with the updated value
                var items = currentOptions
                    .map(function (item, i) {
                    return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, item, { index: i });
                })
                    .filter(function (option) { return option.itemType !== __WEBPACK_IMPORTED_MODULE_12__utilities_selectableOption_index__["a" /* SelectableOptionMenuItemType */].Header && option.itemType !== __WEBPACK_IMPORTED_MODULE_12__utilities_selectableOption_index__["a" /* SelectableOptionMenuItemType */].Divider; })
                    .filter(function (option) { return option.text.toLocaleLowerCase().indexOf(updatedValue) === 0; });
                // If we found a match, udpdate the state
                if (items.length > 0) {
                    this._setPendingInfo(originalUpdatedValue, items[0].index, this._getPreviewText(items[0]));
                }
                // Schedule a timeout to clear the pending value after the timeout span
                this._lastReadOnlyAutoCompleteChangeTimeoutId = this._async.setTimeout(function () {
                    _this._lastReadOnlyAutoCompleteChangeTimeoutId = undefined;
                }, ReadOnlyPendingAutoCompleteTimeout);
                return;
            }
        }
        // If we get here, either autoComplete is on or we did not find a match with autoComplete on.
        // Remember we are not allowing freeform, so at this point, if we have a pending valid value index
        // use that; otherwise use the selectedIndex
        var index = currentPendingValueValidIndex >= 0 ? currentPendingValueValidIndex : this._getFirstSelectedIndex();
        // Since we are not allowing freeform, we need to
        // set both the pending and suggested values/index
        // to allow us to select all content in the input to
        // give the illusion that we are readonly (e.g. freeform off)
        this._setPendingInfoFromIndex(index);
    };
    ComboBox.prototype._getFirstSelectedIndex = function () {
        return this.state.selectedIndices && this.state.selectedIndices.length > 0 ? this.state.selectedIndices[0] : -1;
    };
    /**
     * Walk along the options starting at the index, stepping by the delta (positive or negative)
     * looking for the next valid selectable index (e.g. skipping headings and dividers)
     * @param index - the index to get the next selectable index from
     * @param delta - optional delta to step by when finding the next index, defaults to 0
     * @returns - the next valid selectable index. If the new index is outside of the bounds,
     * it will snap to the edge of the options array. If delta == 0 and the given index is not selectable
     */
    ComboBox.prototype._getNextSelectableIndex = function (index, searchDirection) {
        var currentOptions = this.state.currentOptions;
        var newIndex = index + searchDirection;
        newIndex = Math.max(0, Math.min(currentOptions.length - 1, newIndex));
        if (!this._indexWithinBounds(currentOptions, newIndex)) {
            return -1;
        }
        var option = currentOptions[newIndex];
        // attempt to skip headers and dividers
        if (option.itemType === __WEBPACK_IMPORTED_MODULE_12__utilities_selectableOption_index__["a" /* SelectableOptionMenuItemType */].Header || option.itemType === __WEBPACK_IMPORTED_MODULE_12__utilities_selectableOption_index__["a" /* SelectableOptionMenuItemType */].Divider) {
            // Should we continue looking for an index to select?
            if (searchDirection !== SearchDirection.none &&
                ((newIndex > 0 && searchDirection < SearchDirection.none) ||
                    (newIndex >= 0 && newIndex < currentOptions.length && searchDirection > SearchDirection.none))) {
                newIndex = this._getNextSelectableIndex(newIndex, searchDirection);
            }
            else {
                // If we cannot perform a useful search just return the index we were given
                return index;
            }
        }
        // We have the next valid selectable index, return it
        return newIndex;
    };
    /**
     * Set the selected index. Note, this is
     * the "real" selected index, not the pending selected index
     * @param index - the index to set (or the index to set from if a search direction is provided)
     * @param searchDirection - the direction to search along the options from the given index
     */
    ComboBox.prototype._setSelectedIndex = function (index, submitPendingValueEvent, searchDirection) {
        var _this = this;
        if (searchDirection === void 0) { searchDirection = SearchDirection.none; }
        var _a = this.props, onChange = _a.onChange, onChanged = _a.onChanged, onPendingValueChanged = _a.onPendingValueChanged;
        var currentOptions = this.state.currentOptions;
        var selectedIndices = this.state.selectedIndices;
        if (!selectedIndices) {
            selectedIndices = [];
        }
        // Find the next selectable index, if searchDirection is none
        // we will get our starting index back
        index = this._getNextSelectableIndex(index, searchDirection);
        if (!this._indexWithinBounds(currentOptions, index)) {
            return;
        }
        // Are we at a new index? If so, update the state, otherwise
        // there is nothing to do
        if (this.props.multiSelect || selectedIndices.length < 1 || (selectedIndices.length === 1 && selectedIndices[0] !== index)) {
            var option_1 = currentOptions[index];
            if (!option_1) {
                return;
            }
            if (this.props.multiSelect) {
                // Setting the initial state of option.selected in Multi-select combobox by checking the
                // selectedIndices array and overriding the undefined issue
                option_1.selected = option_1.selected !== undefined ? !option_1.selected : selectedIndices.indexOf(index) < 0;
                if (option_1.selected && selectedIndices.indexOf(index) < 0) {
                    selectedIndices.push(index);
                }
                else if (!option_1.selected && selectedIndices.indexOf(index) >= 0) {
                    selectedIndices = selectedIndices.filter(function (value) { return value !== index; });
                }
            }
            else {
                selectedIndices[0] = index;
            }
            submitPendingValueEvent.persist();
            // Call onChange after state is updated
            this.setState({
                selectedIndices: selectedIndices
            }, function () {
                // If ComboBox value is changed, revert preview first
                if (_this._hasPendingValue && onPendingValueChanged) {
                    onPendingValueChanged();
                    _this._hasPendingValue = false;
                }
                if (onChange) {
                    onChange(submitPendingValueEvent, option_1, index, undefined);
                }
                if (onChanged) {
                    onChanged(option_1, index, undefined, submitPendingValueEvent);
                }
            });
        }
        // clear all of the pending info
        this._clearPendingInfo();
    };
    /**
     * Submit a pending value if there is one
     */
    ComboBox.prototype._submitPendingValue = function (submitPendingValueEvent) {
        var _a = this.props, onChange = _a.onChange, onChanged = _a.onChanged, allowFreeform = _a.allowFreeform, autoComplete = _a.autoComplete;
        var _b = this.state, currentPendingValue = _b.currentPendingValue, currentPendingValueValidIndex = _b.currentPendingValueValidIndex, currentOptions = _b.currentOptions, currentPendingValueValidIndexOnHover = _b.currentPendingValueValidIndexOnHover;
        var selectedIndices = this.state.selectedIndices;
        // Do not submit any pending value if we
        // have already initiated clearing the pending info
        if (this._processingClearPendingInfo) {
            return;
        }
        // If we allow freeform we need to handle that
        if (allowFreeform) {
            // if currentPendingValue is null or undefined the user did not submit anything
            // (not even empty because we would have stored that as the pending value)
            if (currentPendingValue === null || currentPendingValue === undefined) {
                // if a user did not type anything they may just hovered over an item
                if (currentPendingValueValidIndexOnHover >= 0) {
                    this._setSelectedIndex(currentPendingValueValidIndexOnHover, submitPendingValueEvent);
                    this._clearPendingInfo();
                }
                return;
            }
            // Check to see if the user typed an exact match
            if (this._indexWithinBounds(currentOptions, currentPendingValueValidIndex)) {
                var pendingOptionText = this._getPreviewText(currentOptions[currentPendingValueValidIndex]).toLocaleLowerCase();
                // By exact match, that means: our pending value is the same as the the pending option text OR
                // the pending option starts with the pending value and we have an "autoComplete" selection
                // where the total length is equal to pending option length OR
                // the live value in the underlying input matches the pending option; update the state
                if (currentPendingValue.toLocaleLowerCase() === pendingOptionText ||
                    ((autoComplete &&
                        pendingOptionText.indexOf(currentPendingValue.toLocaleLowerCase()) === 0 &&
                        (this._autofill.current &&
                            this._autofill.current.isValueSelected &&
                            currentPendingValue.length + (this._autofill.current.selectionEnd - this._autofill.current.selectionStart) ===
                                pendingOptionText.length)) ||
                        (this._autofill.current &&
                            this._autofill.current.inputElement &&
                            this._autofill.current.inputElement.value.toLocaleLowerCase() === pendingOptionText))) {
                    this._setSelectedIndex(currentPendingValueValidIndex, submitPendingValueEvent);
                    this._clearPendingInfo();
                    return;
                }
            }
            if (onChange || onChanged) {
                if (onChange) {
                    // trigger onChange to clear value
                    onChange(submitPendingValueEvent, undefined, undefined, currentPendingValue);
                }
                if (onChanged) {
                    // trigger onChanged to clear value
                    onChanged(undefined, undefined, currentPendingValue, submitPendingValueEvent);
                }
            }
            else {
                // If we are not controlled, create a new option
                var newOption = {
                    key: currentPendingValue || Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["N" /* getId */])(),
                    text: this._normalizeToString(currentPendingValue)
                };
                var newOptions = currentOptions.concat([newOption]);
                if (selectedIndices) {
                    if (!this.props.multiSelect) {
                        selectedIndices = [];
                    }
                    selectedIndices.push(newOptions.length - 1);
                }
                this.setState({
                    currentOptions: newOptions,
                    selectedIndices: selectedIndices
                });
            }
        }
        else if (currentPendingValueValidIndex >= 0) {
            // Since we are not allowing freeform, we must have a matching
            // to be able to update state
            this._setSelectedIndex(currentPendingValueValidIndex, submitPendingValueEvent);
        }
        else if (currentPendingValueValidIndexOnHover >= 0) {
            // If all else failed and we were hovering over an item, select it
            this._setSelectedIndex(currentPendingValueValidIndexOnHover, submitPendingValueEvent);
        }
        // Finally, clear the pending info
        this._clearPendingInfo();
    };
    ComboBox.prototype._onCalloutLayerMounted = function () {
        // In persistMenu mode _onLayerMounted is only called once for the lifetime
        // of the component. Any functionality required for callout "on mount" can
        // go here so that we can also call it again during callout dismissal to reset
        // object state.
        this._gotMouseMove = false;
    };
    // Render separator
    ComboBox.prototype._renderSeparator = function (item) {
        var index = item.index, key = item.key;
        if (index && index > 0) {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { role: "separator", key: key, className: this._classNames.divider });
        }
        return null;
    };
    ComboBox.prototype._renderHeader = function (item) {
        var _a = this.props.onRenderOption, onRenderOption = _a === void 0 ? this._onRenderOptionContent : _a;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { key: item.key, className: this._classNames.header }, onRenderOption(item, this._onRenderOptionContent)));
    };
    /**
     * If we are coming from a mouseOut:
     * there is no visible selected option.
     *
     * Else if We are hovering over an item:
     * that gets the selected look.
     *
     * Else:
     * Use the current valid pending index if it exists OR
     * we do not have a valid index and we currently have a pending input value,
     * otherwise use the selected index
     * */
    ComboBox.prototype._isOptionSelected = function (index) {
        var currentPendingValueValidIndexOnHover = this.state.currentPendingValueValidIndexOnHover;
        // If the hover state is set to clearAll, don't show a selected index.
        // Note, this happens when the user moused out of the menu items
        if (currentPendingValueValidIndexOnHover === HoverStatus.clearAll) {
            return false;
        }
        if (!this.props.multiSelect && this._getPendingSelectedIndex(true /* includePendingValue */) === index) {
            return true;
        }
        var idxOfSelectedIndex = -1;
        if (this.props.multiSelect && index !== undefined && this.state.selectedIndices) {
            idxOfSelectedIndex = this.state.selectedIndices.indexOf(index);
        }
        return idxOfSelectedIndex >= 0;
    };
    /**
     * Gets the pending selected index taking into account hover, valueValidIndex, and selectedIndex
     * @param includeCurrentPendingValue - Should we include the currentPendingValue when
     * finding the index
     */
    ComboBox.prototype._getPendingSelectedIndex = function (includeCurrentPendingValue) {
        var _a = this.state, currentPendingValueValidIndexOnHover = _a.currentPendingValueValidIndexOnHover, currentPendingValueValidIndex = _a.currentPendingValueValidIndex, currentPendingValue = _a.currentPendingValue;
        return currentPendingValueValidIndexOnHover >= 0
            ? currentPendingValueValidIndexOnHover
            : currentPendingValueValidIndex >= 0 ||
                (includeCurrentPendingValue && (currentPendingValue !== null && currentPendingValue !== undefined))
                ? currentPendingValueValidIndex
                : this.props.multiSelect
                    ? 0
                    : this._getFirstSelectedIndex();
    };
    /**
     * Scroll the selected element into view
     */
    ComboBox.prototype._scrollIntoView = function () {
        var _a = this.props, onScrollToItem = _a.onScrollToItem, scrollSelectedToTop = _a.scrollSelectedToTop;
        var _b = this.state, currentPendingValueValidIndex = _b.currentPendingValueValidIndex, currentPendingValue = _b.currentPendingValue;
        if (onScrollToItem) {
            // Use the custom scroll handler
            onScrollToItem(currentPendingValueValidIndex >= 0 || currentPendingValue !== '' ? currentPendingValueValidIndex : this._getFirstSelectedIndex());
        }
        else if (this._selectedElement.current && this._selectedElement.current.offsetParent) {
            // We are using refs, scroll the ref into view
            if (scrollSelectedToTop) {
                this._selectedElement.current.offsetParent.scrollIntoView(true);
            }
            else {
                var alignToTop = true;
                if (this._comboBoxMenu.current && this._comboBoxMenu.current.offsetParent) {
                    var scrollableParentRect = this._comboBoxMenu.current.offsetParent.getBoundingClientRect();
                    var selectedElementRect = this._selectedElement.current.offsetParent.getBoundingClientRect();
                    // If we are completely in view then we do not need to scroll
                    if (scrollableParentRect.top <= selectedElementRect.top &&
                        scrollableParentRect.top + scrollableParentRect.height >= selectedElementRect.top + selectedElementRect.height) {
                        return;
                    }
                    // If we are lower than the scrollable parent viewport then we should align to the bottom
                    if (scrollableParentRect.top + scrollableParentRect.height <= selectedElementRect.top + selectedElementRect.height) {
                        alignToTop = false;
                    }
                }
                this._selectedElement.current.offsetParent.scrollIntoView(alignToTop);
            }
        }
    };
    /**
     * Click handler for the menu items
     * to select the item and also close the menu
     * @param index - the index of the item that was clicked
     */
    ComboBox.prototype._onItemClick = function (item) {
        var _this = this;
        var onItemClick = this.props.onItemClick;
        var index = item.index;
        return function (ev) {
            onItemClick && onItemClick(ev, item, index);
            _this._setSelectedIndex(index, ev);
            if (!_this.props.multiSelect) {
                // only close the callout when it's in single-select mode
                _this.setState({
                    isOpen: false
                });
            }
        };
    };
    /**
     * Get the indices of the options that are marked as selected
     * @param options - the comboBox options
     * @param selectedKeys - the known selected keys to find
     * @returns - an array of the indices of the selected options, empty array if nothing is selected
     */
    ComboBox.prototype._getSelectedIndices = function (options, selectedKeys) {
        if (!options || !selectedKeys) {
            return [];
        }
        var selectedIndices = {};
        options.forEach(function (option, index) {
            if (option.selected) {
                selectedIndices[index] = true;
            }
        });
        var _loop_1 = function (selectedKey) {
            var index = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["C" /* findIndex */])(options, function (option) { return option.key === selectedKey; });
            if (index > -1) {
                selectedIndices[index] = true;
            }
        };
        for (var _i = 0, selectedKeys_1 = selectedKeys; _i < selectedKeys_1.length; _i++) {
            var selectedKey = selectedKeys_1[_i];
            _loop_1(selectedKey);
        }
        return Object.keys(selectedIndices)
            .map(Number)
            .sort();
    };
    /**
     * Reset the selected index by clearing the
     * input (of any pending text), clearing the pending state,
     * and setting the suggested display value to the last
     * selected state text
     */
    ComboBox.prototype._resetSelectedIndex = function () {
        var currentOptions = this.state.currentOptions;
        this._clearPendingInfo();
        var selectedIndex = this._getFirstSelectedIndex();
        if (selectedIndex > 0 && selectedIndex < currentOptions.length) {
            this.setState({
                suggestedDisplayValue: currentOptions[selectedIndex].text
            });
        }
        else if (this.props.text || this.props.value) {
            // If we had a value initially, restore it
            this.setState({
                suggestedDisplayValue: this.props.text || this.props.value
            });
        }
    };
    /**
     * Clears the pending info state
     */
    ComboBox.prototype._clearPendingInfo = function () {
        this._processingClearPendingInfo = true;
        this.setState({
            currentPendingValue: undefined,
            currentPendingValueValidIndex: -1,
            suggestedDisplayValue: undefined,
            currentPendingValueValidIndexOnHover: HoverStatus.default
        }, this._onAfterClearPendingInfo);
    };
    /**
     * Set the pending info
     * @param currentPendingValue - new pending value to set
     * @param currentPendingValueValidIndex - new pending value index to set
     * @param suggestedDisplayValue - new suggest display value to set
     */
    ComboBox.prototype._setPendingInfo = function (currentPendingValue, currentPendingValueValidIndex, suggestedDisplayValue) {
        if (currentPendingValueValidIndex === void 0) { currentPendingValueValidIndex = -1; }
        if (this._processingClearPendingInfo) {
            return;
        }
        this.setState({
            currentPendingValue: currentPendingValue && this._removeZeroWidthSpaces(currentPendingValue),
            currentPendingValueValidIndex: currentPendingValueValidIndex,
            suggestedDisplayValue: suggestedDisplayValue,
            currentPendingValueValidIndexOnHover: HoverStatus.default
        });
    };
    /**
     * Set the pending info from the given index
     * @param index - the index to set the pending info from
     */
    ComboBox.prototype._setPendingInfoFromIndex = function (index) {
        var currentOptions = this.state.currentOptions;
        if (index >= 0 && index < currentOptions.length) {
            var option = currentOptions[index];
            this._setPendingInfo(this._getPreviewText(option), index, this._getPreviewText(option));
        }
        else {
            this._clearPendingInfo();
        }
    };
    /**
     * Sets the pending info for the comboBox
     * @param index - the index to search from
     * @param searchDirection - the direction to search
     */
    ComboBox.prototype._setPendingInfoFromIndexAndDirection = function (index, searchDirection) {
        var currentOptions = this.state.currentOptions;
        // update index to allow content to wrap
        if (searchDirection === SearchDirection.forward && index >= currentOptions.length - 1) {
            index = -1;
        }
        else if (searchDirection === SearchDirection.backward && index <= 0) {
            index = currentOptions.length;
        }
        // get the next "valid" index
        var indexUpdate = this._getNextSelectableIndex(index, searchDirection);
        // if the two indicies are equal we didn't move and
        // we should attempt to get  get the first/last "valid" index to use
        // (Note, this takes care of the potential cases where the first/last
        // item is not focusable), otherwise use the updated index
        if (index === indexUpdate) {
            if (searchDirection === SearchDirection.forward) {
                index = this._getNextSelectableIndex(-1, searchDirection);
            }
            else if (searchDirection === SearchDirection.backward) {
                index = this._getNextSelectableIndex(currentOptions.length, searchDirection);
            }
        }
        else {
            index = indexUpdate;
        }
        if (this._indexWithinBounds(currentOptions, index)) {
            this._setPendingInfoFromIndex(index);
        }
    };
    ComboBox.prototype._notifyPendingValueChanged = function (prevState) {
        var onPendingValueChanged = this.props.onPendingValueChanged;
        if (!onPendingValueChanged) {
            return;
        }
        var _a = this.state, currentPendingValue = _a.currentPendingValue, currentOptions = _a.currentOptions, currentPendingValueValidIndex = _a.currentPendingValueValidIndex, currentPendingValueValidIndexOnHover = _a.currentPendingValueValidIndexOnHover;
        var newPendingIndex = undefined;
        var newPendingValue = undefined;
        if (currentPendingValueValidIndexOnHover !== prevState.currentPendingValueValidIndexOnHover &&
            this._indexWithinBounds(currentOptions, currentPendingValueValidIndexOnHover)) {
            // Set new pending index if hover index was changed
            newPendingIndex = currentPendingValueValidIndexOnHover;
        }
        else if (currentPendingValueValidIndex !== prevState.currentPendingValueValidIndex &&
            this._indexWithinBounds(currentOptions, currentPendingValueValidIndex)) {
            // Set new pending index if currentPendingValueValidIndex was changed
            newPendingIndex = currentPendingValueValidIndex;
        }
        else if (currentPendingValue !== prevState.currentPendingValue) {
            // Set pendingValue in the case it was changed and no index was changed
            newPendingValue = currentPendingValue;
        }
        // Notify when there is a new pending index/value. Also, if there is a pending value, it needs to send undefined.
        if (newPendingIndex !== undefined || newPendingValue !== undefined || this._hasPendingValue) {
            onPendingValueChanged(newPendingIndex !== undefined ? currentOptions[newPendingIndex] : undefined, newPendingIndex, newPendingValue);
            this._hasPendingValue = newPendingIndex !== undefined || newPendingValue !== undefined;
        }
    };
    /**
     * Sets the isOpen state and updates focusInputAfterClose
     */
    ComboBox.prototype._setOpenStateAndFocusOnClose = function (isOpen, focusInputAfterClose) {
        this._focusInputAfterClose = focusInputAfterClose;
        this.setState({
            isOpen: isOpen
        });
    };
    /**
     * Returns true if the key for the event is alt (Mac option) or meta (Mac command).
     */
    ComboBox.prototype._isAltOrMeta = function (ev) {
        return ev.which === __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].alt || ev.key === 'Meta';
    };
    ComboBox.prototype._onOptionMouseEnter = function (index) {
        if (this._shouldIgnoreMouseEvent()) {
            return;
        }
        this.setState({
            currentPendingValueValidIndexOnHover: index
        });
    };
    ComboBox.prototype._onOptionMouseMove = function (index) {
        this._gotMouseMove = true;
        if (!this._isScrollIdle || this.state.currentPendingValueValidIndexOnHover === index) {
            return;
        }
        this.setState({
            currentPendingValueValidIndexOnHover: index
        });
    };
    ComboBox.prototype._shouldIgnoreMouseEvent = function () {
        return !this._isScrollIdle || !this._gotMouseMove;
    };
    /**
     * Handle dismissing the menu and
     * eating the required key event when disabled
     * @param ev - the keyboard event that was fired
     */
    ComboBox.prototype._handleInputWhenDisabled = function (ev) {
        // If we are disabled, close the menu (if needed)
        // and eat all keystokes other than TAB or ESC
        if (this.props.disabled) {
            if (this.state.isOpen) {
                this.setState({ isOpen: false });
            }
            // When disabled stop propagation and prevent default
            // of the event unless we have a tab, escape, or function key
            if (ev !== null &&
                ev.which !== __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].tab &&
                ev.which !== __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].escape &&
                (ev.which < 112 /* F1 */ || ev.which > 123) /* F12 */) {
                ev.stopPropagation();
                ev.preventDefault();
            }
        }
    };
    ComboBox.prototype._handleTouchAndPointerEvent = function () {
        var _this = this;
        // If we already have an existing timeeout from a previous touch and pointer event
        // cancel that timeout so we can set a nwe one.
        if (this._lastTouchTimeoutId !== undefined) {
            this._async.clearTimeout(this._lastTouchTimeoutId);
            this._lastTouchTimeoutId = undefined;
        }
        this._processingTouch = true;
        this._lastTouchTimeoutId = this._async.setTimeout(function () {
            _this._processingTouch = false;
            _this._lastTouchTimeoutId = undefined;
        }, TouchIdleDelay);
    };
    /**
     * Get the styles for the current option.
     * @param item - Item props for the current option
     */
    ComboBox.prototype._getCaretButtonStyles = function () {
        var customCaretDownButtonStyles = this.props.caretDownButtonStyles;
        return Object(__WEBPACK_IMPORTED_MODULE_8__ComboBox_styles__["a" /* getCaretDownButtonStyles */])(this.props.theme, customCaretDownButtonStyles);
    };
    /**
     * Get the styles for the current option.
     * @param item - Item props for the current option
     */
    ComboBox.prototype._getCurrentOptionStyles = function (item) {
        var customStylesForAllOptions = this.props.comboBoxOptionStyles;
        var customStylesForCurrentOption = item.styles;
        return Object(__WEBPACK_IMPORTED_MODULE_8__ComboBox_styles__["b" /* getOptionStyles */])(this.props.theme, customStylesForAllOptions, customStylesForCurrentOption, this._isPendingOption(item), item.hidden);
    };
    /**
     * Get the aria-activedescendant value for the comboxbox.
     * @returns the id of the current focused combo item, otherwise the id of the currently selected element, null otherwise
     */
    ComboBox.prototype._getAriaActiveDescentValue = function () {
        var descendantText = this.state.isOpen && this.state.selectedIndices && this.state.selectedIndices.length >= 0
            ? this._id + '-list' + this.state.selectedIndices[0]
            : undefined;
        if (this.state.isOpen && this.state.focused && this.state.currentPendingValueValidIndex !== -1) {
            descendantText = this._id + '-list' + this.state.currentPendingValueValidIndex;
        }
        return descendantText;
    };
    /**
     * Get the aria autocomplete value for the Combobox
     * @returns 'inline' if auto-complete automatically dynamic, 'both' if we have a list of possible values to pick from and can
     * dynamically populate input, and 'none' if auto-complete is not enabled as we can't give user inputs.
     */
    ComboBox.prototype._getAriaAutoCompleteValue = function () {
        var autoComplete = !this.props.disabled && this.props.autoComplete === 'on';
        return autoComplete ? (this.props.allowFreeform ? 'inline' : 'both') : 'none';
    };
    ComboBox.prototype._isPendingOption = function (item) {
        return item && item.index === this.state.currentPendingValueValidIndex;
    };
    /**
     * Given default selected key(s) and selected key(s), return the selected keys(s).
     * When default selected key(s) are available, they take precedence and return them instead of selected key(s).
     *
     * @returns No matter what specific types the input parameters are, always return an array of
     *  either strings or numbers instead of premitive type.  This normlization makes caller's logic easier.
     */
    ComboBox.prototype._buildDefaultSelectedKeys = function (defaultSelectedKey, selectedKey) {
        var selectedKeys = this._buildSelectedKeys(defaultSelectedKey);
        if (selectedKeys.length) {
            return selectedKeys;
        }
        return this._buildSelectedKeys(selectedKey);
    };
    ComboBox.prototype._buildSelectedKeys = function (selectedKey) {
        if (selectedKey === undefined) {
            return [];
        }
        // need to cast here so typescript does not complain
        return (selectedKey instanceof Array ? selectedKey : [selectedKey]);
    };
    // For scenarios where the option's text prop contains embedded styles, we use the option's
    // ariaLabel value as the text in the input and for autocomplete matching. We know to use this
    // when the useAriaLabelAsText prop is set to true
    ComboBox.prototype._getPreviewText = function (item) {
        return item.useAriaLabelAsText && item.ariaLabel ? item.ariaLabel : item.text;
    };
    ComboBox.prototype._normalizeToString = function (value) {
        return value || '';
    };
    ComboBox.prototype._removeZeroWidthSpaces = function (value) {
        // remove any zero width space characters
        return value.replace(RegExp('​', 'g'), '');
    };
    ComboBox.defaultProps = {
        options: [],
        allowFreeform: false,
        autoComplete: 'on',
        buttonIconProps: { iconName: 'ChevronDown' }
    };
    ComboBox = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["u" /* customizable */])('ComboBox', ['theme', 'styles'], true)
    ], ComboBox);
    return ComboBox;
}(__WEBPACK_IMPORTED_MODULE_3__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=ComboBox.js.map

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Autofill; });
/* unused harmony export BaseAutoFill */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);



var SELECTION_FORWARD = 'forward';
var SELECTION_BACKWARD = 'backward';
/**
 * {@docCategory Autofill}
 */
var Autofill = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](Autofill, _super);
    function Autofill(props) {
        var _this = _super.call(this, props) || this;
        _this._inputElement = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._autoFillEnabled = true;
        // Composition events are used when the character/text requires several keystrokes to be completed.
        // Some examples of this are mobile text input and languages like Japanese or Arabic.
        // Find out more at https://developer.mozilla.org/en-US/docs/Web/Events/compositionstart
        _this._onCompositionStart = function (ev) {
            _this._autoFillEnabled = false;
        };
        // Composition events are used when the character/text requires several keystrokes to be completed.
        // Some examples of this are mobile text input and languages like Japanese or Arabic.
        // Find out more at https://developer.mozilla.org/en-US/docs/Web/Events/compositionstart
        _this._onCompositionEnd = function (ev) {
            var inputValue = _this._getCurrentInputValue();
            _this._tryEnableAutofill(inputValue, _this.value, false, true);
            // Korean characters typing issue has been addressed in React 16.5
            // TODO: revert back below lines when we upgrade to React 16.5
            // Find out at https://github.com/facebook/react/pull/12563/commits/06524c6c542c571705c0fd7df61ac48f3d5ce244
            var isKorean = ev.nativeEvent.locale === 'ko';
            // Due to timing, this needs to be async, otherwise no text will be selected.
            _this._async.setTimeout(function () {
                // Call getCurrentInputValue here again since there can be a race condition where this value has changed during the async call
                var updatedInputValue = isKorean ? _this.value : _this._getCurrentInputValue();
                _this._updateValue(updatedInputValue);
            }, 0);
        };
        _this._onClick = function () {
            if (_this._value && _this._value !== '' && _this._autoFillEnabled) {
                _this._autoFillEnabled = false;
            }
        };
        _this._onKeyDown = function (ev) {
            if (_this.props.onKeyDown) {
                _this.props.onKeyDown(ev);
            }
            // If the event is actively being composed, then don't alert autofill.
            // Right now typing does not have isComposing, once that has been fixed any should be removed.
            if (!ev.nativeEvent.isComposing) {
                switch (ev.which) {
                    case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].backspace:
                        _this._autoFillEnabled = false;
                        break;
                    case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].left:
                    case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].right:
                        if (_this._autoFillEnabled) {
                            _this._value = _this.state.displayValue;
                            _this._autoFillEnabled = false;
                        }
                        break;
                    default:
                        if (!_this._autoFillEnabled) {
                            if (_this.props.enableAutofillOnKeyPress.indexOf(ev.which) !== -1) {
                                _this._autoFillEnabled = true;
                            }
                        }
                        break;
                }
            }
        };
        _this._onInputChanged = function (ev) {
            var value = _this._getCurrentInputValue(ev);
            // Right now typing does not have isComposing, once that has been fixed any should be removed.
            _this._tryEnableAutofill(value, _this._value, ev.nativeEvent.isComposing);
            _this._updateValue(value);
        };
        _this._onChanged = function () {
            // Swallow this event, we don't care about it
            // We must provide it because React PropTypes marks it as required, but onInput serves the correct purpose
            return;
        };
        /**
         * Updates the current input value as well as getting a new display value.
         * @param newValue - The new value from the input
         */
        _this._updateValue = function (newValue) {
            // Only proceed if the value is nonempty and is different from the old value
            // This is to work around the fact that, in IE 11, inputs with a placeholder fire an onInput event on focus
            if (!newValue && newValue === _this._value) {
                return;
            }
            _this._value = _this.props.onInputChange ? _this.props.onInputChange(newValue) : newValue;
            _this.setState({
                displayValue: _this._getDisplayValue(_this._value, _this.props.suggestedDisplayValue)
            }, function () { return _this._notifyInputChange(_this._value); });
        };
        _this._value = props.defaultVisibleValue || '';
        _this.state = {
            displayValue: props.defaultVisibleValue || ''
        };
        return _this;
    }
    Object.defineProperty(Autofill.prototype, "cursorLocation", {
        get: function () {
            if (this._inputElement.current) {
                var inputElement = this._inputElement.current;
                if (inputElement.selectionDirection !== SELECTION_FORWARD) {
                    return inputElement.selectionEnd;
                }
                else {
                    return inputElement.selectionStart;
                }
            }
            else {
                return -1;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Autofill.prototype, "isValueSelected", {
        get: function () {
            return Boolean(this.inputElement && this.inputElement.selectionStart !== this.inputElement.selectionEnd);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Autofill.prototype, "value", {
        get: function () {
            return this._value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Autofill.prototype, "selectionStart", {
        get: function () {
            return this._inputElement.current ? this._inputElement.current.selectionStart : -1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Autofill.prototype, "selectionEnd", {
        get: function () {
            return this._inputElement.current ? this._inputElement.current.selectionEnd : -1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Autofill.prototype, "inputElement", {
        get: function () {
            return this._inputElement.current;
        },
        enumerable: true,
        configurable: true
    });
    Autofill.prototype.componentWillReceiveProps = function (nextProps) {
        var newValue;
        if (this.props.updateValueInWillReceiveProps) {
            newValue = this.props.updateValueInWillReceiveProps();
        }
        newValue = this._getDisplayValue(newValue ? newValue : this._value, nextProps.suggestedDisplayValue);
        if (typeof newValue === 'string') {
            this.setState({ displayValue: newValue });
        }
    };
    Autofill.prototype.componentDidUpdate = function () {
        var value = this._value;
        var _a = this.props, suggestedDisplayValue = _a.suggestedDisplayValue, shouldSelectFullInputValueInComponentDidUpdate = _a.shouldSelectFullInputValueInComponentDidUpdate, preventValueSelection = _a.preventValueSelection;
        var differenceIndex = 0;
        if (preventValueSelection) {
            return;
        }
        if (this._autoFillEnabled && value && suggestedDisplayValue && this._doesTextStartWith(suggestedDisplayValue, value)) {
            var shouldSelectFullRange = false;
            if (shouldSelectFullInputValueInComponentDidUpdate) {
                shouldSelectFullRange = shouldSelectFullInputValueInComponentDidUpdate();
            }
            if (shouldSelectFullRange && this._inputElement.current) {
                this._inputElement.current.setSelectionRange(0, suggestedDisplayValue.length, SELECTION_BACKWARD);
            }
            else {
                while (differenceIndex < value.length &&
                    value[differenceIndex].toLocaleLowerCase() === suggestedDisplayValue[differenceIndex].toLocaleLowerCase()) {
                    differenceIndex++;
                }
                if (differenceIndex > 0 && this._inputElement.current) {
                    this._inputElement.current.setSelectionRange(differenceIndex, suggestedDisplayValue.length, SELECTION_BACKWARD);
                }
            }
        }
    };
    Autofill.prototype.render = function () {
        var displayValue = this.state.displayValue;
        var nativeProps = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["R" /* getNativeProps */])(this.props, __WEBPACK_IMPORTED_MODULE_2__Utilities__["_7" /* inputProperties */]);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("input", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ autoCapitalize: "off", autoComplete: "off", "aria-autocomplete": 'both' }, nativeProps, { ref: this._inputElement, value: displayValue, onCompositionStart: this._onCompositionStart, onCompositionEnd: this._onCompositionEnd, onChange: this._onChanged, onInput: this._onInputChanged, onKeyDown: this._onKeyDown, onClick: this.props.onClick ? this.props.onClick : this._onClick, "data-lpignore": true })));
    };
    Autofill.prototype.focus = function () {
        this._inputElement.current && this._inputElement.current.focus();
    };
    Autofill.prototype.clear = function () {
        this._autoFillEnabled = true;
        this._updateValue('');
        this._inputElement.current && this._inputElement.current.setSelectionRange(0, 0);
    };
    Autofill.prototype._getCurrentInputValue = function (ev) {
        if (ev && ev.target && ev.target.value) {
            return ev.target.value;
        }
        else if (this.inputElement && this.inputElement.value) {
            return this.inputElement.value;
        }
        else {
            return '';
        }
    };
    /**
     * Attempts to enable autofill. Whether or not autofill is enabled depends on the input value,
     * whether or not any text is selected, and only if the new input value is longer than the old input value.
     * Autofill should never be set to true if the value is composing. Once compositionEnd is called, then
     * it should be completed.
     * See https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent for more information on composition.
     * @param newValue - new input value
     * @param oldValue - old input value
     * @param isComposing - if true then the text is actively being composed and it has not completed.
     * @param isComposed - if the text is a composed text value.
     */
    Autofill.prototype._tryEnableAutofill = function (newValue, oldValue, isComposing, isComposed) {
        if (!isComposing &&
            newValue &&
            this._inputElement.current &&
            this._inputElement.current.selectionStart === newValue.length &&
            !this._autoFillEnabled &&
            (newValue.length > oldValue.length || isComposed)) {
            this._autoFillEnabled = true;
        }
    };
    Autofill.prototype._notifyInputChange = function (newValue) {
        if (this.props.onInputValueChange) {
            this.props.onInputValueChange(newValue);
        }
    };
    /**
     * Returns a string that should be used as the display value.
     * It evaluates this based on whether or not the suggested value starts with the input value
     * and whether or not autofill is enabled.
     * @param inputValue - the value that the input currently has.
     * @param suggestedDisplayValue - the possible full value
     */
    Autofill.prototype._getDisplayValue = function (inputValue, suggestedDisplayValue) {
        var displayValue = inputValue;
        if (suggestedDisplayValue && inputValue && this._doesTextStartWith(suggestedDisplayValue, displayValue) && this._autoFillEnabled) {
            displayValue = suggestedDisplayValue;
        }
        return displayValue;
    };
    Autofill.prototype._doesTextStartWith = function (text, startWith) {
        if (!text || !startWith) {
            return false;
        }
        return text.toLocaleLowerCase().indexOf(startWith.toLocaleLowerCase()) === 0;
    };
    Autofill.defaultProps = {
        enableAutofillOnKeyPress: [__WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].down, __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].up]
    };
    return Autofill;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

/**
 *  @deprecated do not use.
 * {@docCategory Autofill}
 */
var BaseAutoFill = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](BaseAutoFill, _super);
    function BaseAutoFill() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BaseAutoFill;
}(Autofill));

//# sourceMappingURL=Autofill.js.map

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Persona__ = __webpack_require__(1836);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Persona__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Persona_base__ = __webpack_require__(737);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Persona_types__ = __webpack_require__(152);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__Persona_types__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__Persona_types__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__Persona_types__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PersonaCoin_index__ = __webpack_require__(1843);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__PersonaCoin_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PersonaConsts__ = __webpack_require__(153);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PersonaInitialsColor__ = __webpack_require__(741);
/* unused harmony reexport getPersonaInitialsColor */





// Exporting in case someone would like to track the current color of a persona

//# sourceMappingURL=index.js.map

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PersonaBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tooltip__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PersonaCoin_PersonaCoin__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Persona_types__ = __webpack_require__(152);






var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
/**
 * Persona with no default styles.
 * [Use the `styles` API to add your own styles.](https://github.com/OfficeDev/office-ui-fabric-react/wiki/Styling)
 */
var PersonaBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](PersonaBase, _super);
    function PersonaBase(props) {
        var _this = _super.call(this, props) || this;
        _this._warnDeprecations({ primaryText: 'text' });
        return _this;
    }
    PersonaBase.prototype.render = function () {
        // wrapping default render behavior based on various this.props properties
        var _onRenderPrimaryText = this._onRenderText(this._getText()), _onRenderSecondaryText = this._onRenderText(this.props.secondaryText), _onRenderTertiaryText = this._onRenderText(this.props.tertiaryText), _onRenderOptionalText = this._onRenderText(this.props.optionalText);
        var _a = this.props, hidePersonaDetails = _a.hidePersonaDetails, _b = _a.onRenderOptionalText, onRenderOptionalText = _b === void 0 ? _onRenderOptionalText : _b, _c = _a.onRenderPrimaryText, onRenderPrimaryText = _c === void 0 ? _onRenderPrimaryText : _c, _d = _a.onRenderSecondaryText, onRenderSecondaryText = _d === void 0 ? _onRenderSecondaryText : _d, _e = _a.onRenderTertiaryText, onRenderTertiaryText = _e === void 0 ? _onRenderTertiaryText : _e;
        var size = this.props.size;
        // These properties are to be explicitly passed into PersonaCoin because they are the only props directly used
        var _f = this.props, allowPhoneInitials = _f.allowPhoneInitials, className = _f.className, coinProps = _f.coinProps, showUnknownPersonaCoin = _f.showUnknownPersonaCoin, coinSize = _f.coinSize, styles = _f.styles, imageAlt = _f.imageAlt, imageInitials = _f.imageInitials, imageShouldFadeIn = _f.imageShouldFadeIn, imageShouldStartVisible = _f.imageShouldStartVisible, imageUrl = _f.imageUrl, initialsColor = _f.initialsColor, isOutOfOffice = _f.isOutOfOffice, onPhotoLoadingStateChange = _f.onPhotoLoadingStateChange, onRenderCoin = _f.onRenderCoin, onRenderInitials = _f.onRenderInitials, presence = _f.presence, presenceTitle = _f.presenceTitle, showInitialsUntilImageLoads = _f.showInitialsUntilImageLoads, showSecondaryText = _f.showSecondaryText, theme = _f.theme;
        var personaCoinProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ allowPhoneInitials: allowPhoneInitials,
            showUnknownPersonaCoin: showUnknownPersonaCoin,
            coinSize: coinSize,
            imageAlt: imageAlt,
            imageInitials: imageInitials,
            imageShouldFadeIn: imageShouldFadeIn,
            imageShouldStartVisible: imageShouldStartVisible,
            imageUrl: imageUrl,
            initialsColor: initialsColor,
            onPhotoLoadingStateChange: onPhotoLoadingStateChange,
            onRenderCoin: onRenderCoin,
            onRenderInitials: onRenderInitials,
            presence: presence,
            presenceTitle: presenceTitle,
            showInitialsUntilImageLoads: showInitialsUntilImageLoads,
            size: size, text: this._getText(), isOutOfOffice: isOutOfOffice }, coinProps);
        var classNames = getClassNames(styles, {
            theme: theme,
            className: className,
            showSecondaryText: showSecondaryText,
            presence: presence,
            size: size
        });
        var divProps = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["R" /* getNativeProps */])(this.props, __WEBPACK_IMPORTED_MODULE_2__Utilities__["w" /* divProperties */]);
        var personaDetails = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.details },
            this._renderElement(classNames.primaryText, onRenderPrimaryText, _onRenderPrimaryText),
            this._renderElement(classNames.secondaryText, onRenderSecondaryText, _onRenderSecondaryText),
            this._renderElement(classNames.tertiaryText, onRenderTertiaryText, _onRenderTertiaryText),
            this._renderElement(classNames.optionalText, onRenderOptionalText, _onRenderOptionalText),
            this.props.children));
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, divProps, { className: classNames.root, style: coinSize ? { height: coinSize, minWidth: coinSize } : undefined }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__PersonaCoin_PersonaCoin__["a" /* PersonaCoin */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, personaCoinProps)),
            (!hidePersonaDetails || (size === __WEBPACK_IMPORTED_MODULE_5__Persona_types__["c" /* PersonaSize */].size10 || size === __WEBPACK_IMPORTED_MODULE_5__Persona_types__["c" /* PersonaSize */].tiny)) && personaDetails));
    };
    /**
     * Renders various types of Text (primaryText, secondaryText, etc)
     * based on the classNames passed
     * @param classNames - element className
     * @param renderFunction - render function
     * @param defaultRenderFunction - default render function
     */
    PersonaBase.prototype._renderElement = function (classNames, renderFunction, defaultRenderFunction) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { dir: "auto", className: classNames }, renderFunction && renderFunction(this.props, defaultRenderFunction)));
    };
    /**
     * Deprecation helper for getting text.
     */
    PersonaBase.prototype._getText = function () {
        return this.props.text || this.props.primaryText || '';
    };
    /**
     * using closure to wrap the default render behavior
     * to make it independent of the type of text passed
     * @param text - text to render
     */
    PersonaBase.prototype._onRenderText = function (text) {
        // return default render behaviour for valid text or undefined
        return text
            ? function () {
                // default onRender behaviour
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Tooltip__["b" /* TooltipHost */], { content: text, overflowMode: __WEBPACK_IMPORTED_MODULE_3__Tooltip__["c" /* TooltipOverflowMode */].Parent, directionalHint: __WEBPACK_IMPORTED_MODULE_3__Tooltip__["a" /* DirectionalHint */].topLeftEdge }, text));
            }
            : undefined;
    };
    PersonaBase.defaultProps = {
        size: __WEBPACK_IMPORTED_MODULE_5__Persona_types__["c" /* PersonaSize */].size48,
        presence: __WEBPACK_IMPORTED_MODULE_5__Persona_types__["b" /* PersonaPresence */].none,
        imageAlt: ''
    };
    return PersonaBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=Persona.base.js.map

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PersonaCoin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PersonaCoin_base__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PersonaCoin_styles__ = __webpack_require__(1841);



/**
 * PersonaCoin is used to render an individual's avatar and presence.
 */
var PersonaCoin = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__PersonaCoin_base__["a" /* PersonaCoinBase */], __WEBPACK_IMPORTED_MODULE_2__PersonaCoin_styles__["a" /* getStyles */], undefined, {
    scope: 'PersonaCoin'
});
//# sourceMappingURL=PersonaCoin.js.map

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PersonaCoinBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PersonaPresence_index__ = __webpack_require__(1837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Image__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Persona_types__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PersonaInitialsColor__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PersonaConsts__ = __webpack_require__(153);










var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
/**
 * PersonaCoin with no default styles.
 * [Use the `getStyles` API to add your own styles.](https://github.com/OfficeDev/office-ui-fabric-react/wiki/Styling)
 */
var PersonaCoinBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](PersonaCoinBase, _super);
    function PersonaCoinBase(props) {
        var _this = _super.call(this, props) || this;
        _this._onRenderCoin = function (props) {
            var _a = _this.props, coinSize = _a.coinSize, styles = _a.styles, imageUrl = _a.imageUrl, imageAlt = _a.imageAlt, imageShouldFadeIn = _a.imageShouldFadeIn, imageShouldStartVisible = _a.imageShouldStartVisible, theme = _a.theme, showUnknownPersonaCoin = _a.showUnknownPersonaCoin;
            // Render the Image component only if an image URL is provided
            if (!imageUrl) {
                return null;
            }
            var size = _this.props.size;
            var classNames = getClassNames(styles, {
                theme: theme,
                size: size,
                showUnknownPersonaCoin: showUnknownPersonaCoin
            });
            var dimension = coinSize || __WEBPACK_IMPORTED_MODULE_9__PersonaConsts__["e" /* sizeToPixels */][size];
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Image__["a" /* Image */], { className: classNames.image, imageFit: __WEBPACK_IMPORTED_MODULE_6__Image__["b" /* ImageFit */].cover, src: imageUrl, width: dimension, height: dimension, alt: imageAlt, shouldFadeIn: imageShouldFadeIn, shouldStartVisible: imageShouldStartVisible, onLoadingStateChange: _this._onPhotoLoadingStateChange }));
        };
        _this._onRenderInitials = function (props) {
            var imageInitials = props.imageInitials;
            var allowPhoneInitials = props.allowPhoneInitials, showUnknownPersonaCoin = props.showUnknownPersonaCoin;
            if (showUnknownPersonaCoin) {
                return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Icon__["Icon"], { iconName: "Help" });
            }
            var isRTL = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["V" /* getRTL */])();
            imageInitials = imageInitials || Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["O" /* getInitials */])(_this._getText(), isRTL, allowPhoneInitials);
            return imageInitials !== '' ? __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", null, imageInitials) : __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Icon__["Icon"], { iconName: "Contact" });
        };
        _this._onPhotoLoadingStateChange = function (loadState) {
            _this.setState({
                isImageLoaded: loadState === __WEBPACK_IMPORTED_MODULE_6__Image__["c" /* ImageLoadState */].loaded,
                isImageError: loadState === __WEBPACK_IMPORTED_MODULE_6__Image__["c" /* ImageLoadState */].error
            });
            _this.props.onPhotoLoadingStateChange && _this.props.onPhotoLoadingStateChange(loadState);
        };
        _this._warnDeprecations({ primaryText: 'text' });
        _this.state = {
            isImageLoaded: false,
            isImageError: false
        };
        return _this;
    }
    PersonaCoinBase.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.imageUrl !== this.props.imageUrl) {
            this.setState({
                isImageLoaded: false,
                isImageError: false
            });
        }
    };
    PersonaCoinBase.prototype.render = function () {
        var _a = this.props, className = _a.className, coinProps = _a.coinProps, showUnknownPersonaCoin = _a.showUnknownPersonaCoin, coinSize = _a.coinSize, styles = _a.styles, imageUrl = _a.imageUrl, isOutOfOffice = _a.isOutOfOffice, _b = _a.onRenderCoin, onRenderCoin = _b === void 0 ? this._onRenderCoin : _b, _c = _a.onRenderInitials, onRenderInitials = _c === void 0 ? this._onRenderInitials : _c, presence = _a.presence, presenceTitle = _a.presenceTitle, showInitialsUntilImageLoads = _a.showInitialsUntilImageLoads, theme = _a.theme;
        var size = this.props.size;
        var divProps = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["R" /* getNativeProps */])(this.props, __WEBPACK_IMPORTED_MODULE_2__Utilities__["w" /* divProperties */]);
        var divCoinProps = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["R" /* getNativeProps */])(coinProps || {}, __WEBPACK_IMPORTED_MODULE_2__Utilities__["w" /* divProperties */]);
        var coinSizeStyle = coinSize ? { width: coinSize, height: coinSize } : undefined;
        var hideImage = showUnknownPersonaCoin;
        var personaPresenceProps = {
            coinSize: coinSize,
            isOutOfOffice: isOutOfOffice,
            presence: presence,
            presenceTitle: presenceTitle,
            size: size,
            theme: theme
        };
        // Use getStyles from props, or fall back to getStyles from styles file.
        var classNames = getClassNames(styles, {
            theme: theme,
            className: coinProps && coinProps.className ? coinProps.className : className,
            size: size,
            coinSize: coinSize,
            showUnknownPersonaCoin: showUnknownPersonaCoin
        });
        var shouldRenderInitials = Boolean(!this.state.isImageLoaded && ((showInitialsUntilImageLoads && imageUrl) || !imageUrl || this.state.isImageError || hideImage));
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, divProps, { className: classNames.coin }),
            size !== __WEBPACK_IMPORTED_MODULE_7__Persona_types__["c" /* PersonaSize */].size10 && size !== __WEBPACK_IMPORTED_MODULE_7__Persona_types__["c" /* PersonaSize */].tiny ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, divCoinProps, { className: classNames.imageArea, style: coinSizeStyle }),
                shouldRenderInitials && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: Object(__WEBPACK_IMPORTED_MODULE_3__Styling__["F" /* mergeStyles */])(classNames.initials, !showUnknownPersonaCoin && { backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_8__PersonaInitialsColor__["a" /* getPersonaInitialsColor */])(this.props) }), style: coinSizeStyle, "aria-hidden": "true" }, onRenderInitials(this.props, this._onRenderInitials))),
                !hideImage && onRenderCoin(this.props, this._onRenderCoin),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__PersonaPresence_index__["a" /* PersonaPresence */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, personaPresenceProps)))) : // Otherwise, render just PersonaPresence.
                this.props.presence ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__PersonaPresence_index__["a" /* PersonaPresence */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, personaPresenceProps))) : (
                // Just render Contact Icon if there isn't a Presence prop.
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Icon__["Icon"], { iconName: "Contact", className: classNames.size10WithoutPresenceIcon })),
            this.props.children));
    };
    /**
     * Deprecation helper for getting text.
     */
    PersonaCoinBase.prototype._getText = function () {
        return this.props.text || this.props.primaryText || '';
    };
    PersonaCoinBase.defaultProps = {
        size: __WEBPACK_IMPORTED_MODULE_7__Persona_types__["c" /* PersonaSize */].size48,
        presence: __WEBPACK_IMPORTED_MODULE_7__Persona_types__["b" /* PersonaPresence */].none,
        imageAlt: ''
    };
    return PersonaCoinBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=PersonaCoin.base.js.map

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PersonaPresenceBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icon__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Persona_types__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PersonaConsts__ = __webpack_require__(153);






var coinSizeFontScaleFactor = 6;
var coinSizePresenceScaleFactor = 3;
var presenceMaxSize = 40;
var presenceFontMaxSize = 20;
var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
/**
 * PersonaPresence with no default styles.
 * [Use the `getStyles` API to add your own styles.](https://github.com/OfficeDev/office-ui-fabric-react/wiki/Styling)
 */
var PersonaPresenceBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](PersonaPresenceBase, _super);
    function PersonaPresenceBase(props) {
        var _this = _super.call(this, props) || this;
        _this._onRenderIcon = function (className, style) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Icon__["Icon"], { className: className, iconName: determineIcon(_this.props.presence, _this.props.isOutOfOffice), style: style })); };
        return _this;
    }
    PersonaPresenceBase.prototype.render = function () {
        var _a = this.props, coinSize = _a.coinSize, isOutOfOffice = _a.isOutOfOffice, styles = _a.styles, // Use getStyles from props.
        presence = _a.presence, theme = _a.theme, presenceTitle = _a.presenceTitle;
        var size = Object(__WEBPACK_IMPORTED_MODULE_5__PersonaConsts__["d" /* sizeBoolean */])(this.props.size);
        // Render Presence Icon if Persona is above size 32.
        var renderIcon = !(size.isSize10 || size.isSize16 || size.isSize24 || size.isSize28 || size.isSize32) && (coinSize ? coinSize > 32 : true);
        var presenceHeightWidth = coinSize
            ? coinSize / coinSizePresenceScaleFactor < presenceMaxSize
                ? coinSize / coinSizePresenceScaleFactor + 'px'
                : presenceMaxSize + 'px'
            : '';
        var presenceFontSize = coinSize
            ? coinSize / coinSizeFontScaleFactor < presenceFontMaxSize
                ? coinSize / coinSizeFontScaleFactor + 'px'
                : presenceFontMaxSize + 'px'
            : '';
        var coinSizeWithPresenceIconStyle = coinSize ? { fontSize: presenceFontSize, lineHeight: presenceHeightWidth } : undefined;
        var coinSizeWithPresenceStyle = coinSize ? { width: presenceHeightWidth, height: presenceHeightWidth } : undefined;
        // Use getStyles from props, or fall back to getStyles from styles file.
        var classNames = getClassNames(styles, {
            theme: theme,
            presence: presence,
            size: this.props.size,
            isOutOfOffice: isOutOfOffice
        });
        if (presence === __WEBPACK_IMPORTED_MODULE_4__Persona_types__["b" /* PersonaPresence */].none) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.presence, style: coinSizeWithPresenceStyle, title: presenceTitle }, renderIcon && this._onRenderIcon(classNames.presenceIcon, coinSizeWithPresenceIconStyle)));
    };
    return PersonaPresenceBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

function determineIcon(presence, isOutOfOffice) {
    if (!presence) {
        return undefined;
    }
    var oofIcon = 'SkypeArrow';
    switch (__WEBPACK_IMPORTED_MODULE_4__Persona_types__["b" /* PersonaPresence */][presence]) {
        case 'online':
            return 'SkypeCheck';
        case 'away':
            return isOutOfOffice ? oofIcon : 'SkypeClock';
        case 'dnd':
            return 'SkypeMinus';
        case 'offline':
            return isOutOfOffice ? oofIcon : '';
    }
    return '';
}
//# sourceMappingURL=PersonaPresence.base.js.map

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialsColorPropToColorCode */
/* harmony export (immutable) */ __webpack_exports__["a"] = getPersonaInitialsColor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Persona_types__ = __webpack_require__(152);

/**
 * Following colors are considered reserved colors and can only be set with overrides, so they are excluded from this set:
 * - `gray` and `black` are colors that can result in offensive persona coins with some initials combinations,
 *   so it can only be set with overrides.
 * - `red` is a color that often has a special meaning, so it is considered a reserved color and can only be set with overrides.
 * - `transparent` is not intended to be used with typical initials due to accessibility issues,
 *   its primary use is for Facepile overflow buttons.
 */
var COLOR_SWATCHES_LOOKUP = [
    __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].lightBlue,
    __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].blue,
    __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].darkBlue,
    __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].teal,
    __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].green,
    __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].darkGreen,
    __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].lightPink,
    __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].pink,
    __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].magenta,
    __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].purple,
    __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].orange,
    __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].lightRed,
    __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].darkRed,
    __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].violet,
    __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].gold,
    __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].burgundy,
    __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].warmGray,
    __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].cyan,
    __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].rust,
    __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].coolGray
];
var COLOR_SWATCHES_NUM_ENTRIES = COLOR_SWATCHES_LOOKUP.length;
function getInitialsColorFromName(displayName) {
    var color = __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].blue;
    if (!displayName) {
        return color;
    }
    var hashCode = 0;
    for (var iLen = displayName.length - 1; iLen >= 0; iLen--) {
        var ch = displayName.charCodeAt(iLen);
        var shift = iLen % 8;
        // tslint:disable-next-line:no-bitwise
        hashCode ^= (ch << shift) + (ch >> (8 - shift));
    }
    color = COLOR_SWATCHES_LOOKUP[hashCode % COLOR_SWATCHES_NUM_ENTRIES];
    return color;
}
function personaInitialsColorToHexCode(personaInitialsColor) {
    switch (personaInitialsColor) {
        case __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].lightBlue:
            return '#4F6BED';
        case __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].blue:
            return '#0078D4';
        case __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].darkBlue:
            return '#004E8C';
        case __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].teal:
            return '#038387';
        case __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].lightGreen:
        case __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].green:
            return '#498205';
        case __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].darkGreen:
            return '#0B6A0B';
        case __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].lightPink:
            return '#C239B3';
        case __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].pink:
            return '#E3008C';
        case __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].magenta:
            return '#881798';
        case __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].purple:
            return '#5C2E91';
        case __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].orange:
            return '#CA5010';
        case __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].red:
            return '#EE1111';
        case __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].lightRed:
            return '#D13438';
        case __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].darkRed:
            return '#A4262C';
        case __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].transparent:
            return 'transparent';
        case __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].violet:
            return '#8764B8';
        case __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].gold:
            return '#986F0B';
        case __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].burgundy:
            return '#750B1C';
        case __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].warmGray:
            return '#7A7574';
        case __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].cyan:
            return '#005B70';
        case __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].rust:
            return '#8E562E';
        case __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].coolGray:
            return '#69797E';
        case __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].black:
            return '#1D1D1D';
        case __WEBPACK_IMPORTED_MODULE_0__Persona_types__["a" /* PersonaInitialsColor */].gray:
            return '#393939';
    }
}
/** @deprecated Use `getPersonaInitialsColor` */
function initialsColorPropToColorCode(props) {
    return getPersonaInitialsColor(props);
}
/**
 * Gets the hex color string (prefixed with #) for the given persona props.
 * This is the logic used internally by the Persona control.
 * @param props - Current persona props
 * @returns Hex color string prefixed with #
 */
function getPersonaInitialsColor(props) {
    var primaryText = props.primaryText, text = props.text;
    var initialsColor = props.initialsColor;
    var initialsColorCode;
    if (typeof initialsColor === 'string') {
        initialsColorCode = initialsColor;
    }
    else {
        initialsColor = initialsColor !== undefined ? initialsColor : getInitialsColorFromName(text || primaryText);
        initialsColorCode = personaInitialsColorToHexCode(initialsColor);
    }
    return initialsColorCode;
}
//# sourceMappingURL=PersonaInitialsColor.js.map

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Autofill_index__ = __webpack_require__(421);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Autofill_index__["a"]; });

//# sourceMappingURL=Autofill.js.map

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnnouncedBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);



var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
/**
 * {@docCategory Announced}
 */
var AnnouncedBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](AnnouncedBase, _super);
    function AnnouncedBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnnouncedBase.prototype.render = function () {
        var _a = this.props, message = _a.message, styles = _a.styles;
        this._classNames = getClassNames(styles);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ role: "status" }, Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["R" /* getNativeProps */])(this.props, __WEBPACK_IMPORTED_MODULE_2__Utilities__["w" /* divProperties */])),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Utilities__["d" /* DelayedRender */], null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.screenReaderText }, message))));
    };
    AnnouncedBase.defaultProps = {
        'aria-live': 'assertive'
    };
    return AnnouncedBase;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=Announced.base.js.map

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BreadcrumbBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FocusZone__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Link__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_DirectionalHint__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ResizeGroup__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Tooltip__ = __webpack_require__(108);










var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var OVERFLOW_KEY = 'overflow';
var nullFunction = function () { return null; };
/**
 * {@docCategory Breadcrumb}
 */
var BreadcrumbBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](BreadcrumbBase, _super);
    function BreadcrumbBase(props) {
        var _this = _super.call(this, props) || this;
        _this._focusZone = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._onReduceData = function (data) {
            var renderedItems = data.renderedItems, renderedOverflowItems = data.renderedOverflowItems;
            var overflowIndex = data.props.overflowIndex;
            var movedItem = renderedItems[overflowIndex];
            renderedItems = renderedItems.slice();
            renderedItems.splice(overflowIndex, 1);
            renderedOverflowItems = renderedOverflowItems.concat([movedItem]);
            if (movedItem !== undefined) {
                return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, data, { renderedItems: renderedItems, renderedOverflowItems: renderedOverflowItems });
            }
        };
        _this._onRenderBreadcrumb = function (data) {
            var _a = data.props, ariaLabel = _a.ariaLabel, _b = _a.dividerAs, DividerType = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_5__Icon__["Icon"] : _b, _c = _a.onRenderItem, onRenderItem = _c === void 0 ? _this._onRenderItem : _c, overflowAriaLabel = _a.overflowAriaLabel, overflowIndex = _a.overflowIndex, onRenderOverflowIcon = _a.onRenderOverflowIcon;
            var renderedOverflowItems = data.renderedOverflowItems, renderedItems = data.renderedItems;
            var contextualItems = renderedOverflowItems.map(function (item, index) { return ({
                name: item.text,
                key: item.key,
                onClick: item.onClick ? _this._onBreadcrumbClicked.bind(_this, item) : null,
                href: item.href
            }); });
            // Find index of last rendered item so the divider icon
            // knows not to render on that item
            var lastItemIndex = renderedItems.length - 1;
            var hasOverflowItems = renderedOverflowItems && renderedOverflowItems.length !== 0;
            var itemElements = renderedItems.map(function (item, index) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("li", { className: _this._classNames.listItem, key: item.key || String(index) },
                onRenderItem(item, _this._onRenderItem),
                (index !== lastItemIndex || (hasOverflowItems && index === overflowIndex - 1)) && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](DividerType, { className: _this._classNames.chevron, iconName: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["V" /* getRTL */])() ? 'ChevronLeft' : 'ChevronRight', item: item })))); });
            if (hasOverflowItems) {
                var iconProps = !onRenderOverflowIcon ? { iconName: 'More' } : {};
                var onRenderMenuIcon = onRenderOverflowIcon ? onRenderOverflowIcon : nullFunction;
                itemElements.splice(overflowIndex, 0, __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("li", { className: _this._classNames.overflow, key: OVERFLOW_KEY },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Button__["g" /* IconButton */], { className: _this._classNames.overflowButton, iconProps: iconProps, role: "button", "aria-haspopup": "true", ariaLabel: overflowAriaLabel, onRenderMenuIcon: onRenderMenuIcon, menuProps: {
                            items: contextualItems,
                            directionalHint: __WEBPACK_IMPORTED_MODULE_7__common_DirectionalHint__["a" /* DirectionalHint */].bottomLeftEdge
                        } }),
                    overflowIndex !== lastItemIndex + 1 && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](DividerType, { className: _this._classNames.chevron, iconName: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["V" /* getRTL */])() ? 'ChevronLeft' : 'ChevronRight', item: renderedOverflowItems[renderedOverflowItems.length - 1] }))));
            }
            var nativeProps = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["R" /* getNativeProps */])(_this.props, __WEBPACK_IMPORTED_MODULE_2__Utilities__["_3" /* htmlElementProperties */], ['className']);
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ className: _this._classNames.root, role: "navigation", "aria-label": ariaLabel }, nativeProps),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__FocusZone__["a" /* FocusZone */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ componentRef: _this._focusZone, direction: __WEBPACK_IMPORTED_MODULE_3__FocusZone__["b" /* FocusZoneDirection */].horizontal }, _this.props.focusZoneProps),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("ol", { className: _this._classNames.list }, itemElements))));
        };
        _this._onRenderItem = function (item) {
            if (item.onClick || item.href) {
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Link__["Link"], { className: _this._classNames.itemLink, href: item.href, "aria-current": item.isCurrentItem ? 'page' : undefined, onClick: _this._onBreadcrumbClicked.bind(_this, item) },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Tooltip__["b" /* TooltipHost */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ content: item.text, overflowMode: __WEBPACK_IMPORTED_MODULE_9__Tooltip__["c" /* TooltipOverflowMode */].Parent }, _this.props.tooltipHostProps), item.text)));
            }
            else {
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: _this._classNames.item },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Tooltip__["b" /* TooltipHost */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ content: item.text, overflowMode: __WEBPACK_IMPORTED_MODULE_9__Tooltip__["c" /* TooltipOverflowMode */].Parent }, _this.props.tooltipHostProps), item.text)));
            }
        };
        _this._onBreadcrumbClicked = function (item, ev) {
            if (item.onClick) {
                item.onClick(ev, item);
            }
        };
        _this._validateProps(props);
        return _this;
    }
    /**
     * Sets focus to the first breadcrumb link.
     */
    BreadcrumbBase.prototype.focus = function () {
        if (this._focusZone.current) {
            this._focusZone.current.focus();
        }
    };
    BreadcrumbBase.prototype.render = function () {
        var _a = this.props, _b = _a.onReduceData, onReduceData = _b === void 0 ? this._onReduceData : _b, overflowIndex = _a.overflowIndex, maxDisplayedItems = _a.maxDisplayedItems, items = _a.items, className = _a.className, theme = _a.theme, styles = _a.styles;
        var renderedItems = items.slice();
        var renderedOverflowItems = renderedItems.splice(overflowIndex, renderedItems.length - maxDisplayedItems);
        var breadcrumbData = {
            props: this.props,
            renderedItems: renderedItems,
            renderedOverflowItems: renderedOverflowItems
        };
        this._classNames = getClassNames(styles, {
            className: className,
            theme: theme
        });
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__ResizeGroup__["a" /* ResizeGroup */], { onRenderData: this._onRenderBreadcrumb, onReduceData: onReduceData, data: breadcrumbData });
    };
    BreadcrumbBase.prototype.componentWillReceiveProps = function (nextProps) {
        this._validateProps(nextProps);
    };
    /**
     * Validate incoming props
     * @param props - Props to validate
     */
    BreadcrumbBase.prototype._validateProps = function (props) {
        var maxDisplayedItems = props.maxDisplayedItems, overflowIndex = props.overflowIndex, items = props.items;
        if (overflowIndex < 0 ||
            (maxDisplayedItems > 1 && overflowIndex > maxDisplayedItems - 1) ||
            (items.length > 0 && overflowIndex > items.length - 1)) {
            throw new Error('Breadcrumb: overflowIndex out of range');
        }
    };
    BreadcrumbBase.defaultProps = {
        items: [],
        maxDisplayedItems: 999,
        overflowIndex: 0
    };
    return BreadcrumbBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=Breadcrumb.base.js.map

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getMeasurementCache */
/* unused harmony export getNextResizeGroupStateProvider */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResizeGroupBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ResizeGroup_types__ = __webpack_require__(746);





var RESIZE_DELAY = 16;
/**
 * Returns a simple object is able to store measurements with a given key.
 */
var getMeasurementCache = function () {
    var measurementsCache = {};
    return {
        /**
         * Checks if the provided data has a cacheKey. If it has a cacheKey and there is a
         * corresponding entry in the measurementsCache, then it will return that value.
         * Returns undefined otherwise.
         */
        getCachedMeasurement: function (data) {
            if (data && data.cacheKey && measurementsCache.hasOwnProperty(data.cacheKey)) {
                return measurementsCache[data.cacheKey];
            }
            return undefined;
        },
        /**
         * Should be called whenever there is a new measurement associated with a given data object.
         * If the data has a cacheKey, store that measurement in the measurementsCache.
         */
        addMeasurementToCache: function (data, measurement) {
            if (data.cacheKey) {
                measurementsCache[data.cacheKey] = measurement;
            }
        }
    };
};
/**
 * Returns a function that is able to compute the next state for the ResizeGroup given the current
 * state and any measurement updates.
 */
var getNextResizeGroupStateProvider = function (measurementCache) {
    if (measurementCache === void 0) { measurementCache = getMeasurementCache(); }
    var _measurementCache = measurementCache;
    var _containerDimension;
    /**
     * Gets the width/height of the data rendered in a hidden div.
     * @param measuredData - The data corresponding to the measurement we wish to take.
     * @param getElementToMeasureDimension - A function that returns the measurement of the rendered data. Only called when the measurement
     * is not in the cache.
     */
    function _getMeasuredDimension(measuredData, getElementToMeasureDimension) {
        var cachedDimension = _measurementCache.getCachedMeasurement(measuredData);
        if (cachedDimension !== undefined) {
            return cachedDimension;
        }
        var measuredDimension = getElementToMeasureDimension();
        _measurementCache.addMeasurementToCache(measuredData, measuredDimension);
        return measuredDimension;
    }
    /**
     * Will get the next IResizeGroupState based on the current data while trying to shrink contents
     * to fit in the container.
     * @param data - The initial data point to start measuring.
     * @param onReduceData - Function that transforms the data into something that should render with less width/height.
     * @param getElementToMeasureDimension - A function that returns the measurement of the rendered data. Only called when the measurement
     * is not in the cache.
     */
    function _shrinkContentsUntilTheyFit(data, onReduceData, getElementToMeasureDimension) {
        var dataToMeasure = data;
        var measuredDimension = _getMeasuredDimension(data, getElementToMeasureDimension);
        while (measuredDimension > _containerDimension) {
            var nextMeasuredData = onReduceData(dataToMeasure);
            // We don't want to get stuck in an infinite render loop when there are no more
            // scaling steps, so implementations of onReduceData should return undefined when
            // there are no more scaling states to apply.
            if (nextMeasuredData === undefined) {
                return {
                    renderedData: dataToMeasure,
                    resizeDirection: undefined,
                    dataToMeasure: undefined
                };
            }
            measuredDimension = _measurementCache.getCachedMeasurement(nextMeasuredData);
            // If the measurement isn't in the cache, we need to rerender with some data in a hidden div
            if (measuredDimension === undefined) {
                return {
                    dataToMeasure: nextMeasuredData,
                    resizeDirection: 'shrink'
                };
            }
            dataToMeasure = nextMeasuredData;
        }
        return {
            renderedData: dataToMeasure,
            resizeDirection: undefined,
            dataToMeasure: undefined
        };
    }
    /**
     * This function should be called when the state changes in a manner that might allow for more content to fit
     * on the screen, such as the window width/height growing.
     * @param data - The initial data point to start measuring.
     * @param onGrowData - Function that transforms the data into something that may take up more space when rendering.
     * @param getElementToMeasureDimension - A function that returns the measurement of the rendered data. Only called when the measurement
     * is not in the cache.
     */
    function _growDataUntilItDoesNotFit(data, onGrowData, getElementToMeasureDimension, onReduceData) {
        var dataToMeasure = data;
        var measuredDimension = _getMeasuredDimension(data, getElementToMeasureDimension);
        while (measuredDimension < _containerDimension) {
            var nextMeasuredData = onGrowData(dataToMeasure);
            // We don't want to get stuck in an infinite render loop when there are no more
            // scaling steps, so implementations of onGrowData should return undefined when
            // there are no more scaling states to apply.
            if (nextMeasuredData === undefined) {
                return {
                    renderedData: dataToMeasure,
                    resizeDirection: undefined,
                    dataToMeasure: undefined
                };
            }
            measuredDimension = _measurementCache.getCachedMeasurement(nextMeasuredData);
            // If the measurement isn't in the cache, we need to rerender with some data in a hidden div
            if (measuredDimension === undefined) {
                return {
                    dataToMeasure: nextMeasuredData
                };
            }
            dataToMeasure = nextMeasuredData;
        }
        // Once the loop is done, we should now shrink until the contents fit.
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ resizeDirection: 'shrink' }, _shrinkContentsUntilTheyFit(dataToMeasure, onReduceData, getElementToMeasureDimension));
    }
    /**
     * Handles an update to the container width/eheight. Should only be called when we knew the previous container width/height.
     * @param newDimension - The new width/height of the container.
     * @param fullDimensionData - The initial data passed in as a prop to resizeGroup.
     * @param renderedData - The data that was rendered prior to the container size changing.
     * @param onGrowData - Set to true if the Resize group has an onGrowData function.
     */
    function _updateContainerDimension(newDimension, fullDimensionData, renderedData, onGrowData) {
        var nextState;
        if (newDimension > _containerDimension) {
            if (onGrowData) {
                nextState = {
                    resizeDirection: 'grow',
                    dataToMeasure: onGrowData(renderedData)
                };
            }
            else {
                nextState = {
                    resizeDirection: 'shrink',
                    dataToMeasure: fullDimensionData
                };
            }
        }
        else {
            nextState = {
                resizeDirection: 'shrink',
                dataToMeasure: renderedData
            };
        }
        _containerDimension = newDimension;
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, nextState, { measureContainer: false });
    }
    function getNextState(props, currentState, getElementToMeasureDimension, newContainerDimension) {
        // If there is no new container width/height or data to measure, there is no need for a new state update
        if (newContainerDimension === undefined && currentState.dataToMeasure === undefined) {
            return undefined;
        }
        if (newContainerDimension) {
            // If we know what the last container size was and we rendered data at that width/height, we can do an optimized render
            if (_containerDimension && currentState.renderedData && !currentState.dataToMeasure) {
                return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, currentState, _updateContainerDimension(newContainerDimension, props.data, currentState.renderedData, props.onGrowData));
            }
            // If we are just setting the container width/height for the first time, we can't do any optimizations
            _containerDimension = newContainerDimension;
        }
        var nextState = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, currentState, { measureContainer: false });
        if (currentState.dataToMeasure) {
            if (currentState.resizeDirection === 'grow' && props.onGrowData) {
                nextState = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, nextState, _growDataUntilItDoesNotFit(currentState.dataToMeasure, props.onGrowData, getElementToMeasureDimension, props.onReduceData));
            }
            else {
                nextState = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, nextState, _shrinkContentsUntilTheyFit(currentState.dataToMeasure, props.onReduceData, getElementToMeasureDimension));
            }
        }
        return nextState;
    }
    /** Function that determines if we need to render content for measurement based on the measurement cache contents. */
    function shouldRenderDataForMeasurement(dataToMeasure) {
        if (!dataToMeasure || _measurementCache.getCachedMeasurement(dataToMeasure) !== undefined) {
            return false;
        }
        return true;
    }
    function getInitialResizeGroupState(data) {
        return {
            dataToMeasure: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, data),
            resizeDirection: 'grow',
            measureContainer: true
        };
    }
    return {
        getNextState: getNextState,
        shouldRenderDataForMeasurement: shouldRenderDataForMeasurement,
        getInitialResizeGroupState: getInitialResizeGroupState
    };
};
// Provides a context property that (if true) tells any child components that
// they are only being used for measurement purposes and will not be visible.
var MeasuredContext = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_21" /* provideContext */])({
    isMeasured: __WEBPACK_IMPORTED_MODULE_2_prop_types__["bool"]
}, function () {
    return { isMeasured: true };
});
// Styles for the hidden div used for measurement
var hiddenDivStyles = { position: 'fixed', visibility: 'hidden' };
var hiddenParentStyles = { position: 'relative' };
var ResizeGroupBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ResizeGroupBase, _super);
    function ResizeGroupBase(props) {
        var _this = _super.call(this, props) || this;
        _this._nextResizeGroupStateProvider = getNextResizeGroupStateProvider();
        // The root div which is the container inside of which we are trying to fit content.
        _this._root = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        // A div that can be used for the initial measurement so that we can avoid mounting a second instance
        // of the component being measured for the initial render.
        _this._initialHiddenDiv = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        // A hidden div that is used for mounting a new instance of the component for measurement in a hidden
        // div without unmounting the currently visible content.
        _this._updateHiddenDiv = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        // Tracks if any content has been rendered to the user. This enables us to do some performance optimizations
        // for the initial render.
        _this._hasRenderedContent = false;
        _this.state = _this._nextResizeGroupStateProvider.getInitialResizeGroupState(_this.props.data);
        _this._warnDeprecations({
            styles: 'className'
        });
        return _this;
    }
    ResizeGroupBase.prototype.render = function () {
        var _a = this.props, className = _a.className, onRenderData = _a.onRenderData;
        var _b = this.state, dataToMeasure = _b.dataToMeasure, renderedData = _b.renderedData;
        var divProps = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["R" /* getNativeProps */])(this.props, __WEBPACK_IMPORTED_MODULE_3__Utilities__["w" /* divProperties */], ['data']);
        var dataNeedsMeasuring = this._nextResizeGroupStateProvider.shouldRenderDataForMeasurement(dataToMeasure);
        var isInitialMeasure = !this._hasRenderedContent && dataNeedsMeasuring;
        // We only ever render the final content to the user. All measurements are done in a hidden div.
        // For the initial render, we want this to be as fast as possible, so we need to make sure that we only mount one version of the
        // component for measurement and the final render. For renders that update what is on screen, we want to make sure that
        // there are no jarring effects such as the screen flashing as we apply scaling steps for meassurement. In the update case,
        // we mount a second version of the component just for measurement purposes and leave the rendered content untouched until we know the
        // next state sto show to the user.
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, divProps, { className: className, ref: this._root }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { style: hiddenParentStyles },
                dataNeedsMeasuring && !isInitialMeasure && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { style: hiddenDivStyles, ref: this._updateHiddenDiv },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](MeasuredContext, null, onRenderData(dataToMeasure)))),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: this._initialHiddenDiv, style: isInitialMeasure ? hiddenDivStyles : undefined, "data-automation-id": "visibleContent" }, isInitialMeasure ? onRenderData(dataToMeasure) : renderedData && onRenderData(renderedData)))));
    };
    ResizeGroupBase.prototype.componentDidMount = function () {
        this._afterComponentRendered(this.props.direction);
        this._events.on(window, 'resize', this._async.debounce(this._onResize, RESIZE_DELAY, { leading: true }));
    };
    ResizeGroupBase.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState({
            dataToMeasure: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, nextProps.data),
            resizeDirection: 'grow',
            measureContainer: true // Receiving new props means the parent might rerender and the root width/height might change
        });
    };
    ResizeGroupBase.prototype.componentDidUpdate = function (prevProps) {
        if (this.state.renderedData) {
            this._hasRenderedContent = true;
            if (this.props.dataDidRender) {
                this.props.dataDidRender(this.state.renderedData);
            }
        }
        this._afterComponentRendered(this.props.direction);
    };
    ResizeGroupBase.prototype.remeasure = function () {
        if (this._root.current) {
            this.setState({ measureContainer: true });
        }
    };
    ResizeGroupBase.prototype._afterComponentRendered = function (direction) {
        var _this = this;
        this._async.requestAnimationFrame(function () {
            var containerDimension = undefined;
            if (_this.state.measureContainer && _this._root.current) {
                var boundingRect = _this._root.current.getBoundingClientRect();
                containerDimension = direction && direction === __WEBPACK_IMPORTED_MODULE_4__ResizeGroup_types__["a" /* ResizeGroupDirection */].vertical ? boundingRect.height : boundingRect.width;
            }
            var nextState = _this._nextResizeGroupStateProvider.getNextState(_this.props, _this.state, function () {
                var refToMeasure = !_this._hasRenderedContent ? _this._initialHiddenDiv : _this._updateHiddenDiv;
                if (!refToMeasure.current) {
                    return 0;
                }
                return direction && direction === __WEBPACK_IMPORTED_MODULE_4__ResizeGroup_types__["a" /* ResizeGroupDirection */].vertical
                    ? refToMeasure.current.scrollHeight
                    : refToMeasure.current.scrollWidth;
            }, containerDimension);
            if (nextState) {
                _this.setState(nextState);
            }
        });
    };
    ResizeGroupBase.prototype._onResize = function () {
        if (this._root.current) {
            this.setState({ measureContainer: true });
        }
    };
    return ResizeGroupBase;
}(__WEBPACK_IMPORTED_MODULE_3__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=ResizeGroup.base.js.map

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResizeGroupDirection; });
/**
 * {@docCategory ResizeGroup}
 */
var ResizeGroupDirection;
(function (ResizeGroupDirection) {
    ResizeGroupDirection[ResizeGroupDirection["horizontal"] = 0] = "horizontal";
    ResizeGroupDirection[ResizeGroupDirection["vertical"] = 1] = "vertical";
})(ResizeGroupDirection || (ResizeGroupDirection = {}));
//# sourceMappingURL=ResizeGroup.types.js.map

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChoiceGroupBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Label__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ChoiceGroupOption_index__ = __webpack_require__(423);





var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["r" /* classNamesFunction */])();
/**
 * {@docCategory ChoiceGroup}
 */
var ChoiceGroupBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ChoiceGroupBase, _super);
    function ChoiceGroupBase(props) {
        var _this = _super.call(this, props) || this;
        _this._inputElement = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.focusedVars = {};
        _this.changedVars = {};
        _this._onFocus = function (key) {
            return _this.focusedVars[key]
                ? _this.focusedVars[key]
                : (_this.focusedVars[key] = function (ev, option) {
                    _this.setState({
                        keyFocused: key,
                        keyChecked: _this.state.keyChecked
                    });
                });
        };
        _this._onBlur = function (ev, option) {
            _this.setState({
                keyFocused: undefined,
                keyChecked: _this.state.keyChecked
            });
        };
        _this._onChange = function (key) {
            return _this.changedVars[key]
                ? _this.changedVars[key]
                : (_this.changedVars[key] = function (evt, option) {
                    var _a = _this.props, onChanged = _a.onChanged, onChange = _a.onChange, selectedKey = _a.selectedKey, _b = _a.options, options = _b === void 0 ? [] : _b;
                    // Only manage state in uncontrolled scenarios.
                    if (selectedKey === undefined) {
                        _this.setState({
                            keyChecked: key
                        });
                    }
                    var originalOption = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["A" /* find */])(options, function (value) { return value.key === key; });
                    // TODO: onChanged deprecated, remove else if after 07/17/2017 when onChanged has been removed.
                    if (onChange) {
                        onChange(evt, originalOption);
                    }
                    else if (onChanged) {
                        onChanged(originalOption);
                    }
                });
        };
        Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_5" /* initializeComponentRef */])(_this);
        if (false) {
            warnDeprecations('ChoiceGroup', props, { onChanged: 'onChange' });
            warnMutuallyExclusive('ChoiceGroup', props, {
                selectedKey: 'defaultSelectedKey'
            });
        }
        var validDefaultSelectedKey = !!props.options && props.options.some(function (option) { return option.key === props.defaultSelectedKey; });
        _this.state = {
            keyChecked: props.defaultSelectedKey === undefined || !validDefaultSelectedKey ? _this._getKeyChecked(props) : props.defaultSelectedKey,
            keyFocused: undefined
        };
        _this._id = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["N" /* getId */])('ChoiceGroup');
        _this._labelId = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["N" /* getId */])('ChoiceGroupLabel');
        return _this;
    }
    Object.defineProperty(ChoiceGroupBase.prototype, "checkedOption", {
        /**
         * Gets the current checked option.
         */
        get: function () {
            var _a = this.props.options, options = _a === void 0 ? [] : _a;
            var key = this.state.keyChecked;
            return Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["A" /* find */])(options, function (value) { return value.key === key; });
        },
        enumerable: true,
        configurable: true
    });
    ChoiceGroupBase.prototype.componentWillReceiveProps = function (newProps) {
        var newKeyChecked = this._getKeyChecked(newProps);
        var oldKeyChecked = this._getKeyChecked(this.props);
        if (newKeyChecked !== oldKeyChecked) {
            this.setState({
                keyChecked: newKeyChecked
            });
        }
    };
    ChoiceGroupBase.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, theme = _a.theme, styles = _a.styles, options = _a.options, label = _a.label, required = _a.required, disabled = _a.disabled, name = _a.name, role = _a.role;
        var _b = this.state, keyChecked = _b.keyChecked, keyFocused = _b.keyFocused;
        var divProps = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["R" /* getNativeProps */])(this.props, __WEBPACK_IMPORTED_MODULE_3__Utilities__["w" /* divProperties */], ['onChange', 'className', 'required']);
        var classNames = getClassNames(styles, {
            theme: theme,
            className: className,
            optionsContainIconOrImage: options.some(function (option) { return Boolean(option.iconProps || option.imageSrc); })
        });
        var ariaLabelledBy = this.props.ariaLabelledBy
            ? this.props.ariaLabelledBy
            : label
                ? this._id + '-label'
                : this.props['aria-labelledby'];
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ role: role, className: classNames.applicationRole }, divProps),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ className: classNames.root, role: "radiogroup" }, ariaLabelledBy && { 'aria-labelledby': ariaLabelledBy }),
                label && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Label__["a" /* Label */], { className: classNames.label, required: required, id: this._id + '-label' }, label)),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.flexContainer }, options.map(function (option) {
                    var innerOptionProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, option, { focused: option.key === keyFocused, checked: option.key === keyChecked, disabled: option.disabled || disabled, id: _this._id + "-" + option.key, labelId: _this._labelId + "-" + option.key, name: name || _this._id, required: required });
                    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__ChoiceGroupOption_index__["a" /* ChoiceGroupOption */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ key: option.key, onBlur: _this._onBlur, onFocus: _this._onFocus(option.key), onChange: _this._onChange(option.key) }, innerOptionProps)));
                })))));
    };
    ChoiceGroupBase.prototype.focus = function () {
        var options = this.props.options;
        if (options) {
            for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
                var option = options_1[_i];
                var elementToFocus = document.getElementById(this._id + "-" + option.key);
                if (elementToFocus && elementToFocus.getAttribute('data-is-focusable') === 'true') {
                    elementToFocus.focus(); // focus on checked or default focusable key
                    return;
                }
            }
        }
        if (this._inputElement.current) {
            this._inputElement.current.focus();
        }
    };
    ChoiceGroupBase.prototype._getKeyChecked = function (props) {
        if (props.selectedKey !== undefined) {
            return props.selectedKey;
        }
        var _a = props.options, options = _a === void 0 ? [] : _a;
        var optionsChecked = options.filter(function (option) {
            return option.checked;
        });
        if (optionsChecked.length === 0) {
            return undefined;
        }
        else {
            return optionsChecked[0].key;
        }
    };
    ChoiceGroupBase.defaultProps = {
        options: []
    };
    return ChoiceGroupBase;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=ChoiceGroup.base.js.map

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COACHMARK_WIDTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COACHMARK_HEIGHT; });
/* unused harmony export translateOne */
/* unused harmony export scaleOne */
/* unused harmony export rotateOne */
/* harmony export (immutable) */ __webpack_exports__["c"] = getStyles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utilities__ = __webpack_require__(1);


var COACHMARK_WIDTH = 32;
var COACHMARK_HEIGHT = 32;
var translateOne = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["C" /* keyframes */])({
    '0%': {
        transform: 'translate(0, 0)',
        animationTimingFunction: 'linear'
    },
    '78.57%': {
        transform: 'translate(0, 0)',
        animationTimingFunction: 'cubic-bezier(0.62, 0, 0.56, 1)'
    },
    '82.14%': {
        transform: 'translate(0, -5px)',
        animationTimingFunction: 'cubic-bezier(0.58, 0, 0, 1)'
    },
    '84.88%': {
        transform: 'translate(0, 9px)',
        animationTimingFunction: 'cubic-bezier(1, 0, 0.56, 1)'
    },
    '88.1%': {
        transform: 'translate(0, -2px)',
        animationTimingFunction: 'cubic-bezier(0.58, 0, 0.67, 1)'
    },
    '90.12%': {
        transform: 'translate(0, 0)',
        animationTimingFunction: 'linear'
    },
    '100%': {
        transform: 'translate(0, 0)'
    }
});
var scaleOne = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["C" /* keyframes */])({
    '0%': {
        transform: ' scale(0)',
        animationTimingFunction: 'linear'
    },
    '14.29%': {
        transform: 'scale(0)',
        animationTimingFunction: 'cubic-bezier(0.84, 0, 0.52, 0.99)'
    },
    '16.67%': {
        transform: 'scale(1.15)',
        animationTimingFunction: 'cubic-bezier(0.48, -0.01, 0.52, 1.01)'
    },
    '19.05%': {
        transform: 'scale(0.95)',
        animationTimingFunction: 'cubic-bezier(0.48, 0.02, 0.52, 0.98)'
    },
    '21.43%': {
        transform: 'scale(1)',
        animationTimingFunction: 'linear'
    },
    '42.86%': {
        transform: 'scale(1)',
        animationTimingFunction: 'cubic-bezier(0.48, -0.02, 0.52, 1.02)'
    },
    '45.71%': {
        transform: 'scale(0.8)',
        animationTimingFunction: 'cubic-bezier(0.48, 0.01, 0.52, 0.99)'
    },
    '50%': {
        transform: 'scale(1)',
        animationTimingFunction: 'linear'
    },
    '90.12%': {
        transform: 'scale(1)',
        animationTimingFunction: 'cubic-bezier(0.48, -0.02, 0.52, 1.02)'
    },
    '92.98%': {
        transform: 'scale(0.8)',
        animationTimingFunction: 'cubic-bezier(0.48, 0.01, 0.52, 0.99)'
    },
    '97.26%': {
        transform: 'scale(1)',
        animationTimingFunction: 'linear'
    },
    '100%': {
        transform: 'scale(1)'
    }
});
var rotateOne = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["C" /* keyframes */])({
    '0%': {
        transform: 'rotate(0deg)',
        animationTimingFunction: 'linear'
    },
    '83.33%': {
        transform: ' rotate(0deg)',
        animationTimingFunction: 'cubic-bezier(0.33, 0, 0.67, 1)'
    },
    '83.93%': {
        transform: 'rotate(15deg)',
        animationTimingFunction: 'cubic-bezier(0.33, 0, 0.67, 1)'
    },
    '84.52%': {
        transform: 'rotate(-15deg)',
        animationTimingFunction: 'cubic-bezier(0.33, 0, 0.67, 1)'
    },
    '85.12%': {
        transform: 'rotate(15deg)',
        animationTimingFunction: 'cubic-bezier(0.33, 0, 0.67, 1)'
    },
    '85.71%': {
        transform: 'rotate(-15deg)',
        animationTimingFunction: 'cubic-bezier(0.33, 0, 0.67, 1)'
    },
    '86.31%': {
        transform: 'rotate(0deg)',
        animationTimingFunction: 'linear'
    },
    '100%': {
        transform: 'rotate(0deg)'
    }
});
function getStyles(props) {
    var theme = props.theme, className = props.className, color = props.color, beaconColorOne = props.beaconColorOne, beaconColorTwo = props.beaconColorTwo, delayBeforeCoachmarkAnimation = props.delayBeforeCoachmarkAnimation, isCollapsed = props.isCollapsed, isBeaconAnimating = props.isBeaconAnimating, isMeasuring = props.isMeasuring, isMeasured = props.isMeasured, entityHostHeight = props.entityHostHeight, entityHostWidth = props.entityHostWidth, transformOrigin = props.transformOrigin;
    if (!theme) {
        throw new Error('theme is undefined or null in base Dropdown getStyles function.');
    }
    var animationInnerDimension = '35px';
    var animationOuterDimension = '150px';
    var animationBorderWidth = '10px';
    var ContinuousPulse = __WEBPACK_IMPORTED_MODULE_0__Styling__["k" /* PulsingBeaconAnimationStyles */].continuousPulseAnimationDouble(beaconColorOne ? beaconColorOne : theme.palette.themePrimary, beaconColorTwo ? beaconColorTwo : theme.palette.themeTertiary, animationInnerDimension, animationOuterDimension, animationBorderWidth);
    var ContinuousPulseAnimation = __WEBPACK_IMPORTED_MODULE_0__Styling__["k" /* PulsingBeaconAnimationStyles */].createDefaultAnimation(ContinuousPulse, delayBeforeCoachmarkAnimation);
    return {
        root: [
            theme.fonts.medium,
            {
                position: 'relative'
            },
            className
        ],
        pulsingBeacon: [
            {
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["V" /* getRTL */])() ? 'translate(50%, -50%)' : 'translate(-50%, -50%)',
                width: '0px',
                height: '0px',
                borderRadius: '225px',
                borderStyle: 'solid',
                opacity: '0'
            },
            isCollapsed && isBeaconAnimating && ContinuousPulseAnimation
        ],
        // Translate Animation Layer
        translateAnimationContainer: [
            {
                width: '100%',
                height: '100%'
            },
            isCollapsed && {
                animationDuration: '14s',
                animationTimingFunction: 'linear',
                animationDirection: 'normal',
                animationIterationCount: '1',
                animationDelay: '0s',
                animationFillMode: 'forwards',
                animationName: translateOne,
                transition: 'opacity 0.5s ease-in-out'
            },
            !isCollapsed && {
                opacity: '1'
            }
        ],
        // Scale Animation Layer
        scaleAnimationLayer: [
            {
                width: '100%',
                height: '100%'
            },
            isCollapsed && {
                animationDuration: '14s',
                animationTimingFunction: 'linear',
                animationDirection: 'normal',
                animationIterationCount: '1',
                animationDelay: '0s',
                animationFillMode: 'forwards',
                animationName: scaleOne
            }
        ],
        // Rotate Animation Layer
        rotateAnimationLayer: [
            {
                width: '100%',
                height: '100%'
            },
            isCollapsed && {
                animationDuration: '14s',
                animationTimingFunction: 'linear',
                animationDirection: 'normal',
                animationIterationCount: '1',
                animationDelay: '0s',
                animationFillMode: 'forwards',
                animationName: rotateOne
            },
            !isCollapsed && {
                opacity: '1'
            }
        ],
        // Layer Host, defaults to collapsed
        entityHost: [
            {
                position: 'relative',
                outline: 'none',
                overflow: 'hidden',
                backgroundColor: color,
                borderRadius: COACHMARK_WIDTH,
                transition: 'border-radius 250ms, width 500ms, height 500ms cubic-bezier(0.5, 0, 0, 1)',
                visibility: 'hidden'
            },
            !isMeasuring && {
                width: COACHMARK_WIDTH,
                height: COACHMARK_HEIGHT,
                visibility: 'visible'
            },
            !isCollapsed && {
                borderRadius: '1px',
                opacity: '1',
                width: entityHostWidth,
                height: entityHostHeight
            }
        ],
        entityInnerHost: [
            {
                transition: 'transform 500ms cubic-bezier(0.5, 0, 0, 1)',
                transformOrigin: transformOrigin,
                transform: 'scale(0)'
            },
            !isCollapsed && {
                width: entityHostWidth,
                height: entityHostHeight,
                transform: 'scale(1)'
            },
            !isMeasuring && {
                visibility: 'visible'
            }
        ],
        childrenContainer: [
            {
                display: isMeasured && isCollapsed ? 'none' : 'block'
            }
        ],
        ariaContainer: {
            position: 'fixed',
            opacity: 0,
            height: 0,
            width: 0,
            pointerEvents: 'none'
        }
    };
}
//# sourceMappingURL=Coachmark.styles.js.map

/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export COACHMARK_ATTRIBUTE_NAME */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CoachmarkBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_positioning__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PositioningContainer_index__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Beak_Beak__ = __webpack_require__(1866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_DirectionalHint__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Coachmark_styles__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FocusTrapZone__ = __webpack_require__(271);

// Utilities



// Component Dependencies





var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var COACHMARK_ATTRIBUTE_NAME = 'data-coachmarkid';
var CoachmarkBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](CoachmarkBase, _super);
    function CoachmarkBase(props) {
        var _this = _super.call(this, props) || this;
        /**
         * The cached HTMLElement reference to the Entity Inner Host
         * element.
         */
        _this._entityHost = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._entityInnerHostElement = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._translateAnimationContainer = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._ariaAlertContainer = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._childrenContainer = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._positioningContainer = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.dismiss = function (ev) {
            var onDismiss = _this.props.onDismiss;
            if (onDismiss) {
                onDismiss(ev);
            }
        };
        _this._onKeyDown = function (e) {
            // Open coachmark if user presses ALT + C (arbitrary keypress for now)
            if ((e.altKey && e.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].c) ||
                (e.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].enter &&
                    _this._translateAnimationContainer.current &&
                    _this._translateAnimationContainer.current.contains(e.target))) {
                _this._onFocusHandler();
            }
        };
        _this._onFocusHandler = function () {
            if (_this.state.isCollapsed) {
                _this._openCoachmark();
            }
        };
        _this._onPositioned = function (positionData) {
            _this._async.requestAnimationFrame(function () {
                _this.setState({
                    targetAlignment: positionData.alignmentEdge,
                    targetPosition: positionData.targetEdge
                });
            });
        };
        _this._setBeakPosition = function () {
            var beakLeft;
            var beakTop;
            var beakRight;
            var beakBottom;
            var transformOriginX;
            var transformOriginY;
            var targetAlignment = _this.state.targetAlignment;
            var distanceAdjustment = '3px'; // Adjustment distance for Beak to shift towards Coachmark bubble.
            switch (_this._beakDirection) {
                // If Beak is pointing Up or Down
                case __WEBPACK_IMPORTED_MODULE_3__utilities_positioning__["b" /* RectangleEdge */].top:
                case __WEBPACK_IMPORTED_MODULE_3__utilities_positioning__["b" /* RectangleEdge */].bottom:
                    // If there is no target alignment, then beak is X-axis centered in callout
                    if (!targetAlignment) {
                        beakLeft = "calc(50% - " + __WEBPACK_IMPORTED_MODULE_5__Beak_Beak__["b" /* BEAK_WIDTH */] / 2 + "px)";
                        transformOriginX = 'center';
                    }
                    else {
                        // Beak is aligned to the left of target
                        if (targetAlignment === __WEBPACK_IMPORTED_MODULE_3__utilities_positioning__["b" /* RectangleEdge */].left) {
                            beakLeft = __WEBPACK_IMPORTED_MODULE_7__Coachmark_styles__["b" /* COACHMARK_WIDTH */] / 2 - __WEBPACK_IMPORTED_MODULE_5__Beak_Beak__["b" /* BEAK_WIDTH */] / 2 + "px";
                            transformOriginX = 'left';
                        }
                        else {
                            // Beak is aligned to the right of target
                            beakRight = __WEBPACK_IMPORTED_MODULE_7__Coachmark_styles__["b" /* COACHMARK_WIDTH */] / 2 - __WEBPACK_IMPORTED_MODULE_5__Beak_Beak__["b" /* BEAK_WIDTH */] / 2 + "px";
                            transformOriginX = 'right';
                        }
                    }
                    if (_this._beakDirection === __WEBPACK_IMPORTED_MODULE_3__utilities_positioning__["b" /* RectangleEdge */].top) {
                        beakTop = distanceAdjustment;
                        transformOriginY = 'top';
                    }
                    else {
                        beakBottom = distanceAdjustment;
                        transformOriginY = 'bottom';
                    }
                    break;
                // If Beak is pointing Left or Right
                case __WEBPACK_IMPORTED_MODULE_3__utilities_positioning__["b" /* RectangleEdge */].left:
                case __WEBPACK_IMPORTED_MODULE_3__utilities_positioning__["b" /* RectangleEdge */].right:
                    // If there is no target alignment, then beak is Y-axis centered in callout
                    if (!targetAlignment) {
                        beakTop = "calc(50% - " + __WEBPACK_IMPORTED_MODULE_5__Beak_Beak__["b" /* BEAK_WIDTH */] / 2 + "px)";
                        transformOriginY = "center";
                    }
                    else {
                        // Beak is aligned to the top of target
                        if (targetAlignment === __WEBPACK_IMPORTED_MODULE_3__utilities_positioning__["b" /* RectangleEdge */].top) {
                            beakTop = __WEBPACK_IMPORTED_MODULE_7__Coachmark_styles__["b" /* COACHMARK_WIDTH */] / 2 - __WEBPACK_IMPORTED_MODULE_5__Beak_Beak__["b" /* BEAK_WIDTH */] / 2 + "px";
                            transformOriginY = "top";
                        }
                        else {
                            // Beak is aligned to the bottom of target
                            beakBottom = __WEBPACK_IMPORTED_MODULE_7__Coachmark_styles__["b" /* COACHMARK_WIDTH */] / 2 - __WEBPACK_IMPORTED_MODULE_5__Beak_Beak__["b" /* BEAK_WIDTH */] / 2 + "px";
                            transformOriginY = "bottom";
                        }
                    }
                    if (_this._beakDirection === __WEBPACK_IMPORTED_MODULE_3__utilities_positioning__["b" /* RectangleEdge */].left) {
                        beakLeft = distanceAdjustment;
                        if (Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["V" /* getRTL */])()) {
                            beakRight = distanceAdjustment;
                        }
                        else {
                            beakLeft = distanceAdjustment;
                        }
                        transformOriginX = 'left';
                    }
                    else {
                        beakRight = distanceAdjustment;
                        if (Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["V" /* getRTL */])()) {
                            beakLeft = distanceAdjustment;
                        }
                        else {
                            beakRight = distanceAdjustment;
                        }
                        transformOriginX = 'right';
                    }
                    break;
            }
            _this.setState({
                beakLeft: beakLeft,
                beakRight: beakRight,
                beakBottom: beakBottom,
                beakTop: beakTop,
                transformOrigin: transformOriginX + " " + transformOriginY
            });
        };
        _this._openCoachmark = function () {
            _this.setState({
                isCollapsed: false
            });
            if (_this.props.onAnimationOpenStart) {
                _this.props.onAnimationOpenStart();
            }
            _this._entityInnerHostElement.current &&
                _this._entityInnerHostElement.current.addEventListener('transitionend', function () {
                    // Need setTimeout to trigger narrator
                    _this._async.setTimeout(function () {
                        if (_this._entityInnerHostElement.current) {
                            Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["F" /* focusFirstChild */])(_this._entityInnerHostElement.current);
                        }
                    }, 1000);
                    if (_this.props.onAnimationOpenEnd) {
                        _this.props.onAnimationOpenEnd();
                    }
                });
        };
        _this._warnDeprecations({
            teachingBubbleRef: undefined,
            collapsed: 'isCollapsed',
            beakWidth: undefined,
            beakHeight: undefined,
            width: undefined,
            height: undefined
        });
        // Set defaults for state
        _this.state = {
            isCollapsed: props.isCollapsed,
            isBeaconAnimating: true,
            isMeasuring: true,
            entityInnerHostRect: {
                width: 0,
                height: 0
            },
            isMouseInProximity: false,
            isMeasured: false
        };
        return _this;
    }
    Object.defineProperty(CoachmarkBase.prototype, "_beakDirection", {
        get: function () {
            var targetPosition = this.state.targetPosition;
            if (targetPosition === undefined) {
                return __WEBPACK_IMPORTED_MODULE_3__utilities_positioning__["b" /* RectangleEdge */].bottom;
            }
            return Object(__WEBPACK_IMPORTED_MODULE_3__utilities_positioning__["d" /* getOppositeEdge */])(targetPosition);
        },
        enumerable: true,
        configurable: true
    });
    CoachmarkBase.prototype.render = function () {
        var _a = this.props, children = _a.children, target = _a.target, color = _a.color, positioningContainerProps = _a.positioningContainerProps, ariaDescribedBy = _a.ariaDescribedBy, ariaDescribedByText = _a.ariaDescribedByText, ariaLabelledBy = _a.ariaLabelledBy, ariaLabelledByText = _a.ariaLabelledByText, ariaAlertText = _a.ariaAlertText, delayBeforeCoachmarkAnimation = _a.delayBeforeCoachmarkAnimation, styles = _a.styles, theme = _a.theme, className = _a.className;
        var _b = this.state, beakLeft = _b.beakLeft, beakTop = _b.beakTop, beakRight = _b.beakRight, beakBottom = _b.beakBottom, isCollapsed = _b.isCollapsed, isBeaconAnimating = _b.isBeaconAnimating, isMeasuring = _b.isMeasuring, entityInnerHostRect = _b.entityInnerHostRect, transformOrigin = _b.transformOrigin, alertText = _b.alertText, isMeasured = _b.isMeasured;
        // Defaulting the main background before passing it to the styles because it is used for `Beak` too.
        var defaultColor = color;
        if (!defaultColor && theme) {
            defaultColor = theme.semanticColors.primaryButtonBackground;
        }
        var classNames = getClassNames(styles, {
            theme: theme,
            className: className,
            isCollapsed: isCollapsed,
            isBeaconAnimating: isBeaconAnimating,
            isMeasuring: isMeasuring,
            color: defaultColor,
            transformOrigin: transformOrigin,
            isMeasured: isMeasured,
            entityHostHeight: entityInnerHostRect.height + "px",
            entityHostWidth: entityInnerHostRect.width + "px",
            width: __WEBPACK_IMPORTED_MODULE_7__Coachmark_styles__["b" /* COACHMARK_WIDTH */] + "px",
            height: __WEBPACK_IMPORTED_MODULE_7__Coachmark_styles__["a" /* COACHMARK_HEIGHT */] + "px",
            delayBeforeCoachmarkAnimation: delayBeforeCoachmarkAnimation + "ms"
        });
        var finalHeight = isCollapsed ? __WEBPACK_IMPORTED_MODULE_7__Coachmark_styles__["a" /* COACHMARK_HEIGHT */] : entityInnerHostRect.height;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__PositioningContainer_index__["a" /* PositioningContainer */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ target: target, offsetFromTarget: __WEBPACK_IMPORTED_MODULE_5__Beak_Beak__["a" /* BEAK_HEIGHT */], componentRef: this._positioningContainer, finalHeight: finalHeight, onPositioned: this._onPositioned, bounds: this._getBounds() }, positioningContainerProps),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.root },
                ariaAlertText && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.ariaContainer, role: "alert", ref: this._ariaAlertContainer, "aria-hidden": !isCollapsed }, alertText)),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.pulsingBeacon }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.translateAnimationContainer, ref: this._translateAnimationContainer },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.scaleAnimationLayer },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.rotateAnimationLayer },
                            this._positioningContainer.current && isCollapsed && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Beak_Beak__["c" /* Beak */], { left: beakLeft, top: beakTop, right: beakRight, bottom: beakBottom, direction: this._beakDirection, color: defaultColor })),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.entityHost, ref: this._entityHost, tabIndex: -1, "data-is-focusable": true, role: "dialog", "aria-labelledby": ariaLabelledBy, "aria-describedby": ariaDescribedBy },
                                isCollapsed && [
                                    ariaLabelledBy && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", { id: ariaLabelledBy, key: 0, className: classNames.ariaContainer }, ariaLabelledByText)),
                                    ariaDescribedBy && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", { id: ariaDescribedBy, key: 1, className: classNames.ariaContainer }, ariaDescribedByText))
                                ],
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__FocusTrapZone__["a" /* FocusTrapZone */], { isClickableOutsideFocusTrap: true, forceFocusInsideTrap: false },
                                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.entityInnerHost, ref: this._entityInnerHostElement },
                                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.childrenContainer, ref: this._childrenContainer, "aria-hidden": isCollapsed }, children))))))))));
    };
    CoachmarkBase.prototype.componentWillReceiveProps = function (newProps) {
        if (this.props.isCollapsed && !newProps.isCollapsed) {
            // The coachmark is about to open
            this._openCoachmark();
        }
    };
    CoachmarkBase.prototype.shouldComponentUpdate = function (newProps, newState) {
        return !Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_27" /* shallowCompare */])(newProps, this.props) || !Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_27" /* shallowCompare */])(newState, this.state);
    };
    CoachmarkBase.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevState.targetAlignment !== this.state.targetAlignment || prevState.targetPosition !== this.state.targetPosition) {
            this._setBeakPosition();
        }
        if (prevProps.preventDismissOnLostFocus !== this.props.preventDismissOnLostFocus) {
            this._addListeners();
        }
    };
    CoachmarkBase.prototype.componentDidMount = function () {
        var _this = this;
        this._async.requestAnimationFrame(function () {
            if (_this._entityInnerHostElement.current && _this.state.entityInnerHostRect.width + _this.state.entityInnerHostRect.width === 0) {
                _this.setState({
                    isMeasuring: false,
                    entityInnerHostRect: {
                        width: _this._entityInnerHostElement.current.offsetWidth,
                        height: _this._entityInnerHostElement.current.offsetHeight
                    },
                    isMeasured: true
                });
                _this._setBeakPosition();
                _this.forceUpdate();
            }
            _this._addListeners();
            // We don't want to the user to immediately trigger the Coachmark when it's opened
            _this._async.setTimeout(function () {
                _this._addProximityHandler(_this.props.mouseProximityOffset);
            }, _this.props.delayBeforeMouseOpen);
            // Need to add setTimeout to have narrator read change in alert container
            if (_this.props.ariaAlertText) {
                _this._async.setTimeout(function () {
                    if (_this.props.ariaAlertText && _this._ariaAlertContainer.current) {
                        _this.setState({
                            alertText: _this.props.ariaAlertText
                        });
                    }
                }, 0);
            }
            if (!_this.props.preventFocusOnMount) {
                _this._async.setTimeout(function () {
                    if (_this._entityHost.current) {
                        _this._entityHost.current.focus();
                    }
                }, 1000);
            }
        });
    };
    CoachmarkBase.prototype._addListeners = function () {
        var preventDismissOnLostFocus = this.props.preventDismissOnLostFocus;
        var currentDoc = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["I" /* getDocument */])();
        this._events.off();
        if (currentDoc) {
            this._events.on(currentDoc, 'keydown', this._onKeyDown, true);
            if (!preventDismissOnLostFocus) {
                this._events.on(currentDoc, 'click', this._dismissOnLostFocus, true);
                this._events.on(currentDoc, 'focus', this._dismissOnLostFocus, true);
            }
        }
    };
    CoachmarkBase.prototype._dismissOnLostFocus = function (ev) {
        var clickTarget = ev.target;
        var clickedOutsideCallout = this._translateAnimationContainer.current && !Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["y" /* elementContains */])(this._translateAnimationContainer.current, clickTarget);
        var target = this.props.target;
        if (clickedOutsideCallout && clickTarget !== target && !Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["y" /* elementContains */])(target, clickTarget)) {
            this.dismiss(ev);
        }
    };
    CoachmarkBase.prototype._getBounds = function () {
        var _a = this.props, isPositionForced = _a.isPositionForced, positioningContainerProps = _a.positioningContainerProps;
        if (isPositionForced) {
            // If directionalHint direction is the top or bottom auto edge, then we want to set the left/right bounds
            // to the window x-axis to have auto positioning work correctly.
            if (positioningContainerProps &&
                (positioningContainerProps.directionalHint === __WEBPACK_IMPORTED_MODULE_6__common_DirectionalHint__["a" /* DirectionalHint */].topAutoEdge ||
                    positioningContainerProps.directionalHint === __WEBPACK_IMPORTED_MODULE_6__common_DirectionalHint__["a" /* DirectionalHint */].bottomAutoEdge)) {
                return {
                    left: 0,
                    top: -Infinity,
                    bottom: Infinity,
                    right: window.innerWidth,
                    width: window.innerWidth,
                    height: Infinity
                };
            }
            else {
                return {
                    left: -Infinity,
                    top: -Infinity,
                    bottom: Infinity,
                    right: Infinity,
                    width: Infinity,
                    height: Infinity
                };
            }
        }
        else {
            return undefined;
        }
    };
    CoachmarkBase.prototype._addProximityHandler = function (mouseProximityOffset) {
        var _this = this;
        if (mouseProximityOffset === void 0) { mouseProximityOffset = 0; }
        /**
         * An array of cached ids returned when setTimeout runs during
         * the window resize event trigger.
         */
        var timeoutIds = [];
        // Take the initial measure out of the initial render to prevent
        // an unnecessary render.
        this._async.setTimeout(function () {
            _this._setTargetElementRect();
            // When the window resizes we want to async
            // get the bounding client rectangle.
            // Every time the event is triggered we want to
            // setTimeout and then clear any previous instances
            // of setTimeout.
            _this._events.on(window, 'resize', function () {
                timeoutIds.forEach(function (value) {
                    clearInterval(value);
                });
                timeoutIds.push(_this._async.setTimeout(function () {
                    _this._setTargetElementRect();
                }, 100));
            });
        }, 10);
        // Every time the document's mouse move is triggered
        // we want to check if inside of an element and
        // set the state with the result.
        this._events.on(document, 'mousemove', function (e) {
            if (_this.state.isCollapsed) {
                var mouseY = e.clientY;
                var mouseX = e.clientX;
                _this._setTargetElementRect();
                var isMouseInProximity = _this._isInsideElement(mouseX, mouseY, mouseProximityOffset);
                if (isMouseInProximity !== _this.state.isMouseInProximity) {
                    _this._openCoachmark();
                }
            }
            if (_this.props.onMouseMove) {
                _this.props.onMouseMove(e);
            }
        });
    };
    CoachmarkBase.prototype._setTargetElementRect = function () {
        if (this._translateAnimationContainer && this._translateAnimationContainer.current) {
            this._targetElementRect = this._translateAnimationContainer.current.getBoundingClientRect();
        }
    };
    CoachmarkBase.prototype._isInsideElement = function (mouseX, mouseY, mouseProximityOffset) {
        if (mouseProximityOffset === void 0) { mouseProximityOffset = 0; }
        return (mouseX > this._targetElementRect.left - mouseProximityOffset &&
            mouseX < this._targetElementRect.left + this._targetElementRect.width + mouseProximityOffset &&
            mouseY > this._targetElementRect.top - mouseProximityOffset &&
            mouseY < this._targetElementRect.top + this._targetElementRect.height + mouseProximityOffset);
    };
    CoachmarkBase.defaultProps = {
        isCollapsed: true,
        mouseProximityOffset: 10,
        delayBeforeMouseOpen: 3600,
        delayBeforeCoachmarkAnimation: 0,
        isPositionForced: true,
        positioningContainerProps: {
            directionalHint: __WEBPACK_IMPORTED_MODULE_6__common_DirectionalHint__["a" /* DirectionalHint */].bottomAutoEdge
        }
    };
    return CoachmarkBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=Coachmark.base.js.map

/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PositioningContainer__ = __webpack_require__(1864);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__PositioningContainer__["a"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getColorFromHSV */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hsv2rgb__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hsv2hex__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rgbaOrHexString__ = __webpack_require__(187);




/**
 * Converts an HSV color (and optional alpha value) to a color object.
 * If `a` is not given, a default of 100 is used.
 * Hex in the returned value will *not* be prefixed with #.
 * If `a` is unspecified or 100, the result's `str` property will contain a hex value
 * (*not* prefixed with #)
 */
function getColorFromHSV(hsv, a) {
    var h = hsv.h, s = hsv.s, v = hsv.v;
    a = typeof a === 'number' ? a : __WEBPACK_IMPORTED_MODULE_0__consts__["b" /* MAX_COLOR_ALPHA */];
    var _a = Object(__WEBPACK_IMPORTED_MODULE_1__hsv2rgb__["a" /* hsv2rgb */])(h, s, v), r = _a.r, g = _a.g, b = _a.b;
    var hex = Object(__WEBPACK_IMPORTED_MODULE_2__hsv2hex__["a" /* hsv2hex */])(h, s, v);
    var str = Object(__WEBPACK_IMPORTED_MODULE_3__rgbaOrHexString__["a" /* _rgbaOrHexString */])(r, g, b, a, hex);
    return { a: a, b: b, g: g, h: h, hex: hex, r: r, s: s, str: str, v: v };
}
//# sourceMappingURL=getColorFromHSV.js.map

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export updateRGB */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getColorFromRGBA__ = __webpack_require__(156);

/**
 * Gets a color with a single RGBA component updated to a new value.
 * Does not modify the original `color`. Alpha defaults to 100 if not set.
 */
function updateRGB(color, component, value) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__getColorFromRGBA__["a" /* getColorFromRGBA */])((_a = {
            r: color.r,
            g: color.g,
            b: color.b,
            a: color.a
        },
        _a[component] = value,
        _a));
    var _a;
}
//# sourceMappingURL=updateRGB.js.map

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export correctHSV */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clamp__ = __webpack_require__(155);


/** Corrects an HSV color to fall within the valid range. */
function correctHSV(color) {
    return {
        h: Object(__WEBPACK_IMPORTED_MODULE_1__clamp__["a" /* clamp */])(color.h, __WEBPACK_IMPORTED_MODULE_0__consts__["c" /* MAX_COLOR_HUE */]),
        s: Object(__WEBPACK_IMPORTED_MODULE_1__clamp__["a" /* clamp */])(color.s, __WEBPACK_IMPORTED_MODULE_0__consts__["f" /* MAX_COLOR_SATURATION */]),
        v: Object(__WEBPACK_IMPORTED_MODULE_1__clamp__["a" /* clamp */])(color.v, __WEBPACK_IMPORTED_MODULE_0__consts__["g" /* MAX_COLOR_VALUE */])
    };
}
//# sourceMappingURL=correctHSV.js.map

/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = correctHex;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts__ = __webpack_require__(37);

/**
 * Corrects a hex color to have length 3 or 6. Defaults to white if too short.
 * Does NOT check anything besides the length (such as valid characters) and does NOT handle
 * hex values starting with # sign.
 */
function correctHex(hex) {
    if (!hex || hex.length < __WEBPACK_IMPORTED_MODULE_0__consts__["j" /* MIN_HEX_LENGTH */]) {
        return 'ffffff'; // not a valid color--default to white
    }
    if (hex.length >= __WEBPACK_IMPORTED_MODULE_0__consts__["h" /* MAX_HEX_LENGTH */]) {
        return hex.substring(0, __WEBPACK_IMPORTED_MODULE_0__consts__["h" /* MAX_HEX_LENGTH */]);
    }
    return hex.substring(0, __WEBPACK_IMPORTED_MODULE_0__consts__["j" /* MIN_HEX_LENGTH */]);
}
//# sourceMappingURL=correctHex.js.map

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ColorPickerBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TextField__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ColorRectangle_ColorRectangle__ = __webpack_require__(1874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ColorSlider_ColorSlider__ = __webpack_require__(1877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_color_consts__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utilities_color_getColorFromString__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utilities_color_getColorFromRGBA__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utilities_color_updateA__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utilities_color_updateH__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utilities_color_correctRGB__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utilities_color_correctHex__ = __webpack_require__(754);






// These imports are separated to help with bundling







var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var colorComponents = ['hex', 'r', 'g', 'b', 'a'];
/**
 * {@docCategory ColorPicker}
 */
var ColorPickerBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ColorPickerBase, _super);
    function ColorPickerBase(props) {
        var _this = _super.call(this, props) || this;
        _this._onSVChanged = function (ev, color) {
            _this._updateColor(ev, color);
        };
        _this._onHChanged = function (ev, h) {
            _this._updateColor(ev, Object(__WEBPACK_IMPORTED_MODULE_10__utilities_color_updateH__["a" /* updateH */])(_this.state.color, h));
        };
        _this._onAChanged = function (ev, a) {
            _this._updateColor(ev, Object(__WEBPACK_IMPORTED_MODULE_9__utilities_color_updateA__["a" /* updateA */])(_this.state.color, Math.round(a)));
        };
        _this._onBlur = function (event) {
            var _a = _this.state, color = _a.color, editingColor = _a.editingColor;
            if (!editingColor) {
                return;
            }
            // If there was an intermediate incorrect value (such as too large or empty), correct it.
            var value = editingColor.value, component = editingColor.component;
            var isHex = component === 'hex';
            var minLength = isHex ? __WEBPACK_IMPORTED_MODULE_6__utilities_color_consts__["j" /* MIN_HEX_LENGTH */] : __WEBPACK_IMPORTED_MODULE_6__utilities_color_consts__["k" /* MIN_RGBA_LENGTH */];
            if (value.length >= minLength && (isHex || !isNaN(Number(value)))) {
                // Real value. Clamp to appropriate length (hex) or range (rgba).
                var newColor = void 0;
                if (isHex) {
                    newColor = Object(__WEBPACK_IMPORTED_MODULE_7__utilities_color_getColorFromString__["a" /* getColorFromString */])('#' + Object(__WEBPACK_IMPORTED_MODULE_12__utilities_color_correctHex__["a" /* correctHex */])(value));
                }
                else {
                    newColor = Object(__WEBPACK_IMPORTED_MODULE_8__utilities_color_getColorFromRGBA__["a" /* getColorFromRGBA */])(Object(__WEBPACK_IMPORTED_MODULE_11__utilities_color_correctRGB__["a" /* correctRGB */])(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, color, (_b = {}, _b[component] = Number(value), _b))));
                }
                // Update state and call onChange
                _this._updateColor(event, newColor);
            }
            else {
                // Intermediate value was an empty string, too short (hex only), or just . (alpha only).
                // Just clear the intermediate state and revert to the previous value.
                _this.setState({ editingColor: undefined });
            }
            var _b;
        };
        Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_5" /* initializeComponentRef */])(_this);
        Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_35" /* warnDeprecations */])('ColorPicker', props, {
            onColorChanged: 'onChange'
        });
        _this.state = {
            color: _getColorFromProps(props) || Object(__WEBPACK_IMPORTED_MODULE_7__utilities_color_getColorFromString__["a" /* getColorFromString */])('#ffffff')
        };
        _this._textChangeHandlers = {};
        for (var _i = 0, colorComponents_1 = colorComponents; _i < colorComponents_1.length; _i++) {
            var component = colorComponents_1[_i];
            _this._textChangeHandlers[component] = _this._onTextChange.bind(_this, component);
        }
        _this._textLabels = {
            r: props.redLabel,
            g: props.greenLabel,
            b: props.blueLabel,
            a: props.alphaLabel,
            hex: props.hexLabel
        };
        return _this;
    }
    Object.defineProperty(ColorPickerBase.prototype, "color", {
        get: function () {
            return this.state.color;
        },
        enumerable: true,
        configurable: true
    });
    ColorPickerBase.prototype.componentWillReceiveProps = function (newProps) {
        var color = _getColorFromProps(newProps);
        if (color) {
            this._updateColor(undefined, color);
        }
    };
    ColorPickerBase.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var theme = props.theme, className = props.className, styles = props.styles;
        var color = this.state.color;
        var classNames = getClassNames(styles, {
            theme: theme,
            className: className
        });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.root },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.panel },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__ColorRectangle_ColorRectangle__["a" /* ColorRectangle */], { color: color, onChange: this._onSVChanged }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__ColorSlider_ColorSlider__["a" /* ColorSlider */], { className: "is-hue", minValue: 0, maxValue: __WEBPACK_IMPORTED_MODULE_6__utilities_color_consts__["c" /* MAX_COLOR_HUE */], value: color.h, onChange: this._onHChanged }),
                !props.alphaSliderHidden && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__ColorSlider_ColorSlider__["a" /* ColorSlider */], { className: "is-alpha", isAlpha: true, overlayStyle: { background: "linear-gradient(to right, transparent 0, #" + color.hex + " 100%)" }, minValue: 0, maxValue: __WEBPACK_IMPORTED_MODULE_6__utilities_color_consts__["b" /* MAX_COLOR_ALPHA */], value: color.a, onChange: this._onAChanged })),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("table", { className: classNames.table, cellPadding: "0", cellSpacing: "0" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("thead", null,
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("tr", { className: classNames.tableHeader },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", { className: classNames.tableHexCell }, props.hexLabel),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", null, props.redLabel),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", null, props.greenLabel),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", null, props.blueLabel),
                            !props.alphaSliderHidden && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", null, props.alphaLabel))),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("tbody", null,
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("tr", null, colorComponents.map(function (comp) {
                            if (comp === 'a' && props.alphaSliderHidden) {
                                return null;
                            }
                            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", { key: comp, style: comp === 'hex' ? undefined : { width: '18%' } },
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__TextField__["a" /* TextField */], { className: classNames.input, onChange: _this._textChangeHandlers[comp], onBlur: _this._onBlur, value: _this._getDisplayValue(comp), spellCheck: false, ariaLabel: _this._textLabels[comp] })));
                        })))))));
    };
    ColorPickerBase.prototype._getDisplayValue = function (component) {
        var _a = this.state, color = _a.color, editingColor = _a.editingColor;
        if (editingColor && editingColor.component === component) {
            return editingColor.value;
        }
        if (color[component] === null || color[component] === undefined) {
            return '';
        }
        else {
            return String(color[component]);
        }
    };
    ColorPickerBase.prototype._onTextChange = function (component, event, newValue) {
        var color = this.state.color;
        var isHex = component === 'hex';
        var isAlpha = component === 'a';
        newValue = (newValue || '').substr(0, isHex ? __WEBPACK_IMPORTED_MODULE_6__utilities_color_consts__["h" /* MAX_HEX_LENGTH */] : __WEBPACK_IMPORTED_MODULE_6__utilities_color_consts__["i" /* MAX_RGBA_LENGTH */]);
        // Ignore what the user typed if it contains invalid characters
        var validCharsRegex = isHex ? __WEBPACK_IMPORTED_MODULE_6__utilities_color_consts__["a" /* HEX_REGEX */] : __WEBPACK_IMPORTED_MODULE_6__utilities_color_consts__["l" /* RGBA_REGEX */];
        if (!validCharsRegex.test(newValue)) {
            // Reset the value
            // TODO: once TextField controlled mode works properly, just return without setting state
            this.setState({ color: color });
            return;
        }
        // Determine if the entry is valid (different methods for hex, alpha, and RGB)
        var isValid;
        if (newValue === '') {
            // Empty string is obviously not valid
            isValid = false;
        }
        else if (isHex) {
            // Technically hex values of length 3 are also valid, but committing the value here would
            // cause it to be automatically converted to a value of length 6, which may not be what the
            // user wanted if they're not finished typing. (Values of length 3 will be committed on blur.)
            isValid = newValue.length === __WEBPACK_IMPORTED_MODULE_6__utilities_color_consts__["h" /* MAX_HEX_LENGTH */];
        }
        else if (isAlpha) {
            isValid = Number(newValue) <= __WEBPACK_IMPORTED_MODULE_6__utilities_color_consts__["b" /* MAX_COLOR_ALPHA */];
        }
        else {
            isValid = Number(newValue) <= __WEBPACK_IMPORTED_MODULE_6__utilities_color_consts__["d" /* MAX_COLOR_RGB */];
        }
        if (!isValid) {
            // If the new value is an empty string or other invalid value, save that to display.
            // (if the user still hasn't entered anything on blur, the last value is restored)
            this.setState({ editingColor: { component: component, value: newValue } });
        }
        else if (String(color[component]) === newValue) {
            // If the new value is the same as the current value, mostly ignore it.
            // Exception is that if the user was previously editing the value (but hadn't yet entered
            // a new valid value), we should clear the intermediate value.
            if (this.state.editingColor) {
                this.setState({ editingColor: undefined });
            }
            else {
                // TODO: remove once TextField is properly controlled
                this.setState({ color: color });
            }
        }
        else {
            // Should be a valid color. Update the value.
            var newColor = isHex
                ? Object(__WEBPACK_IMPORTED_MODULE_7__utilities_color_getColorFromString__["a" /* getColorFromString */])('#' + newValue)
                : Object(__WEBPACK_IMPORTED_MODULE_8__utilities_color_getColorFromRGBA__["a" /* getColorFromRGBA */])(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, color, (_a = {}, _a[component] = Number(newValue), _a)));
            this._updateColor(event, newColor);
        }
        var _a;
    };
    /**
     * Update the displayed color and call change handlers if appropriate.
     * @param ev - Event if call was triggered by an event (undefined if triggered by props change)
     * @param newColor - Updated color
     */
    ColorPickerBase.prototype._updateColor = function (ev, newColor) {
        var _this = this;
        if (!newColor) {
            return;
        }
        var _a = this.state, color = _a.color, editingColor = _a.editingColor;
        var isDifferentColor = newColor.h !== color.h || newColor.str !== color.str;
        if (isDifferentColor || editingColor) {
            this.setState({ color: newColor, editingColor: undefined }, function () {
                if (ev && _this.props.onChange) {
                    _this.props.onChange(ev, newColor);
                }
                // To preserve the existing behavior, this one is called even when the change comes from a
                // props update (which is not very useful)
                if (_this.props.onColorChanged) {
                    _this.props.onColorChanged(newColor.str, newColor);
                }
            });
        }
    };
    ColorPickerBase.defaultProps = {
        hexLabel: 'Hex',
        redLabel: 'Red',
        greenLabel: 'Green',
        blueLabel: 'Blue',
        alphaLabel: 'Alpha'
    };
    return ColorPickerBase;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

function _getColorFromProps(props) {
    var color = props.color;
    return typeof color === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_7__utilities_color_getColorFromString__["a" /* getColorFromString */])(color) : color;
}
//# sourceMappingURL=ColorPicker.base.js.map

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CommandBarBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OverflowSet__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ResizeGroup__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FocusZone__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Tooltip__ = __webpack_require__(108);









var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var CommandBarBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](CommandBarBase, _super);
    function CommandBarBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._overflowSet = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._resizeGroup = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._onRenderData = function (data) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__FocusZone__["a" /* FocusZone */], { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])(_this._classNames.root), direction: __WEBPACK_IMPORTED_MODULE_5__FocusZone__["b" /* FocusZoneDirection */].horizontal, role: 'menubar', "aria-label": _this.props.ariaLabel },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__OverflowSet__["a" /* OverflowSet */], { componentRef: _this._resolveRef('_overflowSet'), className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])(_this._classNames.primarySet), doNotContainWithinFocusZone: true, role: 'presentation', items: data.primaryItems, overflowItems: data.overflowItems.length ? data.overflowItems : undefined, onRenderItem: _this._onRenderItem, onRenderOverflowButton: _this._onRenderOverflowButton }),
                data.farItems && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__OverflowSet__["a" /* OverflowSet */], { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])(_this._classNames.secondarySet), doNotContainWithinFocusZone: true, role: 'presentation', items: data.farItems, onRenderItem: _this._onRenderItem, onRenderOverflowButton: __WEBPACK_IMPORTED_MODULE_2__Utilities__["_17" /* nullRender */] }))));
        };
        _this._onRenderItem = function (item) {
            var CommandButtonType = _this.props.buttonAs || item.commandBarButtonAs || __WEBPACK_IMPORTED_MODULE_6__Button__["d" /* CommandBarButton */];
            var itemText = item.text || item.name;
            if (item.onRender) {
                // These are the top level items, there is no relevant menu dismissing function to
                // provide for the IContextualMenuItem onRender function. Pass in a no op function instead.
                return item.onRender(item, function () { return undefined; });
            }
            var commandButtonProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ allowDisabledFocus: true, role: 'menuitem' }, item, { styles: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ root: { height: '100%' }, label: { whiteSpace: 'nowrap' } }, item.buttonStyles), className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-CommandBarItem-link', item.className), text: !item.iconOnly ? itemText : undefined, menuProps: item.subMenuProps, onClick: _this._onButtonClick(item) });
            if (item.iconOnly && itemText !== undefined) {
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Tooltip__["b" /* TooltipHost */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ content: itemText }, item.tooltipHostProps),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](CommandButtonType, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, commandButtonProps, { defaultRender: __WEBPACK_IMPORTED_MODULE_6__Button__["d" /* CommandBarButton */] }))));
            }
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](CommandButtonType, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, commandButtonProps, { defaultRender: __WEBPACK_IMPORTED_MODULE_6__Button__["d" /* CommandBarButton */] }));
        };
        _this._onRenderOverflowButton = function (overflowItems) {
            var _a = _this.props, _b = _a.overflowButtonAs, OverflowButtonType = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_6__Button__["d" /* CommandBarButton */] : _b, _c = _a.overflowButtonProps // assure that props is not empty
            , overflowButtonProps = _c === void 0 ? {} : _c // assure that props is not empty
            ;
            var combinedOverflowItems = (overflowButtonProps.menuProps ? overflowButtonProps.menuProps.items : []).concat(overflowItems);
            var overflowProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, overflowButtonProps, { styles: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ menuIcon: { fontSize: '17px' } }, overflowButtonProps.styles), className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-CommandBar-overflowButton', overflowButtonProps.className), menuProps: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, overflowButtonProps.menuProps, { items: combinedOverflowItems }), menuIconProps: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ iconName: 'More' }, overflowButtonProps.menuIconProps) });
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](OverflowButtonType, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, overflowProps));
        };
        _this._onReduceData = function (data) {
            var _a = _this.props, shiftOnReduce = _a.shiftOnReduce, onDataReduced = _a.onDataReduced;
            var primaryItems = data.primaryItems, overflowItems = data.overflowItems, cacheKey = data.cacheKey;
            // Use first item if shiftOnReduce, otherwise use last item
            var movedItem = primaryItems[shiftOnReduce ? 0 : primaryItems.length - 1];
            if (movedItem !== undefined) {
                movedItem.renderedInOverflow = true;
                overflowItems = [movedItem].concat(overflowItems);
                primaryItems = shiftOnReduce ? primaryItems.slice(1) : primaryItems.slice(0, -1);
                var newData = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, data, { primaryItems: primaryItems, overflowItems: overflowItems });
                cacheKey = _this._computeCacheKey(newData);
                if (onDataReduced) {
                    onDataReduced(movedItem);
                }
                newData.cacheKey = cacheKey;
                return newData;
            }
            return undefined;
        };
        _this._onGrowData = function (data) {
            var _a = _this.props, shiftOnReduce = _a.shiftOnReduce, onDataGrown = _a.onDataGrown;
            var minimumOverflowItems = data.minimumOverflowItems;
            var primaryItems = data.primaryItems, overflowItems = data.overflowItems, cacheKey = data.cacheKey;
            var movedItem = overflowItems[0];
            // Make sure that moved item exists and is not one of the original overflow items
            if (movedItem !== undefined && overflowItems.length > minimumOverflowItems) {
                movedItem.renderedInOverflow = false;
                overflowItems = overflowItems.slice(1);
                // if shiftOnReduce, movedItem goes first, otherwise, last.
                primaryItems = shiftOnReduce ? [movedItem].concat(primaryItems) : primaryItems.concat([movedItem]);
                var newData = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, data, { primaryItems: primaryItems, overflowItems: overflowItems });
                cacheKey = _this._computeCacheKey(newData);
                if (onDataGrown) {
                    onDataGrown(movedItem);
                }
                newData.cacheKey = cacheKey;
                return newData;
            }
            return undefined;
        };
        return _this;
    }
    CommandBarBase.prototype.render = function () {
        var _a = this.props, className = _a.className, items = _a.items, overflowItems = _a.overflowItems, farItems = _a.farItems, styles = _a.styles, theme = _a.theme, dataDidRender = _a.dataDidRender, _b = _a.onReduceData, onReduceData = _b === void 0 ? this._onReduceData : _b, _c = _a.onGrowData, onGrowData = _c === void 0 ? this._onGrowData : _c;
        var commandBarData = {
            primaryItems: items.slice(),
            overflowItems: overflowItems.slice(),
            minimumOverflowItems: overflowItems.slice().length,
            farItems: farItems,
            cacheKey: ''
        };
        this._classNames = getClassNames(styles, { theme: theme });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__ResizeGroup__["a" /* ResizeGroup */], { componentRef: this._resizeGroup, className: className, data: commandBarData, onReduceData: onReduceData, onGrowData: onGrowData, onRenderData: this._onRenderData, dataDidRender: dataDidRender }));
    };
    CommandBarBase.prototype.focus = function () {
        var overflowSet = this._overflowSet.current;
        overflowSet && overflowSet.focus();
    };
    CommandBarBase.prototype.remeasure = function () {
        this._resizeGroup.current && this._resizeGroup.current.remeasure();
    };
    CommandBarBase.prototype._onButtonClick = function (item) {
        return function (ev) {
            // inactive is deprecated. remove check in 7.0
            if (item.inactive) {
                return;
            }
            if (item.onClick) {
                item.onClick(ev, item);
            }
        };
    };
    CommandBarBase.prototype._computeCacheKey = function (data) {
        var primaryItems = data.primaryItems, _a = data.farItems, farItems = _a === void 0 ? [] : _a, overflowItems = data.overflowItems;
        var returnKey = function (acc, current) {
            var _a = current.cacheKey, cacheKey = _a === void 0 ? current.key : _a;
            return acc + cacheKey;
        };
        var primaryKey = primaryItems.reduce(returnKey, '');
        var farKey = farItems.reduce(returnKey, '');
        var overflowKey = !!overflowItems.length ? 'overflow' : '';
        return [primaryKey, farKey, overflowKey].join(' ');
    };
    CommandBarBase.defaultProps = {
        items: [],
        overflowItems: []
    };
    return CommandBarBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=CommandBar.base.js.map

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_OverflowSet_index__ = __webpack_require__(1883);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_OverflowSet_index__["a"]; });

//# sourceMappingURL=OverflowSet.js.map

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OverflowSetBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FocusZone__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_keytips_KeytipManager__ = __webpack_require__(404);





var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["r" /* classNamesFunction */])();
var OverflowSetBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](OverflowSetBase, _super);
    function OverflowSetBase(props) {
        var _this = _super.call(this, props) || this;
        _this._focusZone = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._persistedKeytips = {};
        _this._keytipManager = __WEBPACK_IMPORTED_MODULE_4__utilities_keytips_KeytipManager__["a" /* KeytipManager */].getInstance();
        _this._divContainer = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._onRenderItems = function (items) {
            return items.map(function (item, i) {
                var wrapperDivProps = {
                    className: _this._classNames.item
                };
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ key: item.key }, wrapperDivProps), _this.props.onRenderItem(item)));
            });
        };
        _this._onRenderOverflowButtonWrapper = function (items) {
            var wrapperDivProps = {
                className: _this._classNames.overflowButton
            };
            var overflowKeytipSequences = _this.props.keytipSequences;
            var newOverflowItems = [];
            if (overflowKeytipSequences) {
                items.forEach(function (overflowItem) {
                    var keytip = overflowItem.keytipProps;
                    if (keytip) {
                        // Create persisted keytip
                        var persistedKeytip = {
                            content: keytip.content,
                            keySequences: keytip.keySequences,
                            disabled: keytip.disabled || !!(overflowItem.disabled || overflowItem.isDisabled),
                            hasDynamicChildren: keytip.hasDynamicChildren,
                            hasMenu: keytip.hasMenu
                        };
                        if (keytip.hasDynamicChildren || _this._getSubMenuForItem(overflowItem)) {
                            // If the keytip has a submenu or children nodes, change onExecute to persistedKeytipExecute
                            persistedKeytip.onExecute = _this._keytipManager.menuExecute.bind(_this._keytipManager, overflowKeytipSequences, overflowItem.keytipProps.keySequences);
                        }
                        else {
                            // If the keytip doesn't have a submenu, just execute the original function
                            persistedKeytip.onExecute = keytip.onExecute;
                        }
                        // Add this persisted keytip to our internal list, use a temporary uniqueID (its content)
                        // uniqueID will get updated on register
                        _this._persistedKeytips[persistedKeytip.content] = persistedKeytip;
                        // Add the overflow sequence to this item
                        var newOverflowItem = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, overflowItem, { keytipProps: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, keytip, { overflowSetSequence: overflowKeytipSequences }) });
                        newOverflowItems.push(newOverflowItem);
                    }
                    else {
                        // Nothing to change, add overflowItem to list
                        newOverflowItems.push(overflowItem);
                    }
                });
            }
            else {
                newOverflowItems = items;
            }
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, wrapperDivProps), _this.props.onRenderOverflowButton(newOverflowItems));
        };
        if (props.doNotContainWithinFocusZone) {
            _this._warnMutuallyExclusive({
                doNotContainWithinFocusZone: 'focusZoneProps'
            });
        }
        return _this;
    }
    OverflowSetBase.prototype.render = function () {
        var _a = this.props, items = _a.items, overflowItems = _a.overflowItems, className = _a.className, focusZoneProps = _a.focusZoneProps, styles = _a.styles, vertical = _a.vertical, role = _a.role, doNotContainWithinFocusZone = _a.doNotContainWithinFocusZone;
        this._classNames = getClassNames(styles, { className: className, vertical: vertical });
        var Tag;
        var uniqueComponentProps;
        if (doNotContainWithinFocusZone) {
            Tag = 'div';
            uniqueComponentProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["R" /* getNativeProps */])(this.props, __WEBPACK_IMPORTED_MODULE_3__Utilities__["w" /* divProperties */]), { ref: this._divContainer });
        }
        else {
            Tag = __WEBPACK_IMPORTED_MODULE_2__FocusZone__["a" /* FocusZone */];
            uniqueComponentProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["R" /* getNativeProps */])(this.props, __WEBPACK_IMPORTED_MODULE_3__Utilities__["w" /* divProperties */]), focusZoneProps, { componentRef: this._focusZone, direction: vertical ? __WEBPACK_IMPORTED_MODULE_2__FocusZone__["b" /* FocusZoneDirection */].vertical : __WEBPACK_IMPORTED_MODULE_2__FocusZone__["b" /* FocusZoneDirection */].horizontal });
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Tag, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, uniqueComponentProps, { className: this._classNames.root, role: role }),
            items && this._onRenderItems(items),
            overflowItems && overflowItems.length > 0 && this._onRenderOverflowButtonWrapper(overflowItems)));
    };
    /**
     * Sets focus to the first tabbable item in the OverflowSet.
     * @param forceIntoFirstElement - If true, focus will be forced into the first element,
     * even if focus is already in theOverflowSet
     * @returns True if focus could be set to an active element, false if no operation was taken.
     */
    OverflowSetBase.prototype.focus = function (forceIntoFirstElement) {
        var focusSucceeded = false;
        if (this.props.doNotContainWithinFocusZone) {
            if (this._divContainer.current) {
                focusSucceeded = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["F" /* focusFirstChild */])(this._divContainer.current);
            }
        }
        else if (this._focusZone.current) {
            focusSucceeded = this._focusZone.current.focus(forceIntoFirstElement);
        }
        return focusSucceeded;
    };
    /**
     * Sets focus to a specific child element within the OverflowSet.
     * @param childElement - The child element within the zone to focus.
     * @returns True if focus could be set to an active element, false if no operation was taken.
     */
    OverflowSetBase.prototype.focusElement = function (childElement) {
        var focusSucceeded = false;
        if (!childElement) {
            return false;
        }
        if (this.props.doNotContainWithinFocusZone) {
            if (this._divContainer.current && Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["y" /* elementContains */])(this._divContainer.current, childElement)) {
                childElement.focus();
                focusSucceeded = document.activeElement === childElement;
            }
        }
        else if (this._focusZone.current) {
            focusSucceeded = this._focusZone.current.focusElement(childElement);
        }
        return focusSucceeded;
    };
    // Add keytip register/unregister handlers to lifecycle functions to correctly manage persisted keytips
    OverflowSetBase.prototype.componentDidMount = function () {
        this._registerPersistedKeytips();
    };
    OverflowSetBase.prototype.componentWillUnmount = function () {
        this._unregisterPersistedKeytips();
    };
    OverflowSetBase.prototype.componentWillUpdate = function () {
        this._unregisterPersistedKeytips();
    };
    OverflowSetBase.prototype.componentDidUpdate = function () {
        this._registerPersistedKeytips();
    };
    OverflowSetBase.prototype._registerPersistedKeytips = function () {
        var _this = this;
        Object.keys(this._persistedKeytips).forEach(function (key) {
            var keytip = _this._persistedKeytips[key];
            var uniqueID = _this._keytipManager.register(keytip, true);
            // Update map
            _this._persistedKeytips[uniqueID] = keytip;
            delete _this._persistedKeytips[key];
        });
    };
    OverflowSetBase.prototype._unregisterPersistedKeytips = function () {
        var _this = this;
        // Delete all persisted keytips saved
        Object.keys(this._persistedKeytips).forEach(function (uniqueID) {
            _this._keytipManager.unregister(_this._persistedKeytips[uniqueID], uniqueID, true);
        });
        this._persistedKeytips = {};
    };
    /**
     * Gets the subMenu for an overflow item
     * Checks if itemSubMenuProvider has been defined, if not defaults to subMenuProps
     */
    OverflowSetBase.prototype._getSubMenuForItem = function (item) {
        if (this.props.itemSubMenuProvider) {
            return this.props.itemSubMenuProvider(item);
        }
        if (item.subMenuProps) {
            return item.subMenuProps.items;
        }
        return undefined;
    };
    OverflowSetBase.defaultProps = {
        vertical: false,
        role: 'menubar'
    };
    return OverflowSetBase;
}(__WEBPACK_IMPORTED_MODULE_3__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=OverflowSet.base.js.map

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DocumentCardType; });
/**
 * {@docCategory DocumentCard}
 */
var DocumentCardType;
(function (DocumentCardType) {
    /**
     * Standard DocumentCard.
     */
    DocumentCardType[DocumentCardType["normal"] = 0] = "normal";
    /**
     * Compact layout. Displays the preview beside the details, rather than above.
     */
    DocumentCardType[DocumentCardType["compact"] = 1] = "compact";
})(DocumentCardType || (DocumentCardType = {}));
//# sourceMappingURL=DocumentCard.types.js.map

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DocumentCardPreviewGlobalClassNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var DocumentCardPreviewGlobalClassNames = {
    root: 'ms-DocumentCardPreview',
    icon: 'ms-DocumentCardPreview-icon',
    iconContainer: 'ms-DocumentCardPreview-iconContainer'
};
var getStyles = function (props) {
    var theme = props.theme, className = props.className, isFileList = props.isFileList;
    var palette = theme.palette;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(DocumentCardPreviewGlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            {
                borderBottom: "1px solid " + palette.neutralLight,
                position: 'relative',
                backgroundColor: isFileList ? palette.white : palette.neutralLighterAlt,
                overflow: "hidden"
            },
            className
        ],
        previewIcon: [
            classNames.iconContainer,
            {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%'
            }
        ],
        icon: [
            classNames.icon,
            {
                left: '10px',
                bottom: '10px',
                position: 'absolute'
            }
        ],
        fileList: {
            padding: '16px 16px 0 16px',
            listStyleType: 'none',
            margin: 0,
            selectors: {
                li: {
                    height: '16px',
                    lineHeight: '16px',
                    marginBottom: '8px',
                    overflow: 'hidden',
                    paddingLeft: '24px',
                    position: 'relative',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                },
                a: {
                    fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].small,
                    textDecoration: 'none',
                    color: palette.neutralDark,
                    selectors: {
                        ':hover': {
                            color: palette.themePrimary
                        }
                    }
                }
            }
        },
        fileListIcon: {
            left: 0,
            position: 'absolute',
            top: 0
        },
        fileListOverflowText: {
            padding: '0px 16px 8px 16px',
            display: 'block',
            fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].small
        }
    };
};
//# sourceMappingURL=DocumentCardPreview.styles.js.map

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DocumentCardActivityGlobalClassNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var VERTICAL_PADDING = 8;
var HORIZONTAL_PADDING = 16;
var IMAGE_SIZE = 32;
var PERSONA_TEXT_GUTTER = 8;
var DocumentCardActivityGlobalClassNames = {
    root: 'ms-DocumentCardActivity',
    multiplePeople: 'ms-DocumentCardActivity--multiplePeople',
    details: 'ms-DocumentCardActivity-details',
    name: 'ms-DocumentCardActivity-name',
    activity: 'ms-DocumentCardActivity-activity',
    avatars: 'ms-DocumentCardActivity-avatars',
    avatar: 'ms-DocumentCardActivity-avatar'
};
var getStyles = function (props) {
    var theme = props.theme, className = props.className, multiplePeople = props.multiplePeople;
    var palette = theme.palette;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(DocumentCardActivityGlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            multiplePeople && classNames.multiplePeople,
            {
                padding: VERTICAL_PADDING + "px " + HORIZONTAL_PADDING + "px",
                position: 'relative'
            },
            className
        ],
        avatars: [
            classNames.avatars,
            {
                marginLeft: '-2px',
                height: '32px'
            }
        ],
        avatar: [
            classNames.avatar,
            {
                display: 'inline-block',
                verticalAlign: 'top',
                position: 'relative',
                textAlign: 'center',
                width: IMAGE_SIZE,
                height: IMAGE_SIZE,
                selectors: {
                    '&:after': {
                        content: '" "',
                        position: 'absolute',
                        left: '-1px',
                        top: '-1px',
                        right: '-1px',
                        bottom: '-1px',
                        border: "2px solid " + palette.white,
                        borderRadius: '50%'
                    },
                    ':nth-of-type(2)': multiplePeople && {
                        marginLeft: '-16px'
                    }
                }
            }
        ],
        details: [
            classNames.details,
            {
                left: multiplePeople
                    ? HORIZONTAL_PADDING + IMAGE_SIZE * 1.5 + PERSONA_TEXT_GUTTER + "px"
                    : HORIZONTAL_PADDING + IMAGE_SIZE + PERSONA_TEXT_GUTTER + "px",
                height: IMAGE_SIZE,
                position: 'absolute',
                top: VERTICAL_PADDING,
                width: "calc(100% - " + (HORIZONTAL_PADDING + IMAGE_SIZE + PERSONA_TEXT_GUTTER + HORIZONTAL_PADDING) + "px)"
            }
        ],
        name: [
            classNames.name,
            {
                display: 'block',
                fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].small,
                lineHeight: '15px',
                height: '15px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                color: palette.neutralPrimary,
                fontWeight: __WEBPACK_IMPORTED_MODULE_0__Styling__["f" /* FontWeights */].semibold
            }
        ],
        activity: [
            classNames.activity,
            {
                display: 'block',
                fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].small,
                lineHeight: '15px',
                height: '15px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                color: palette.neutralSecondary
            }
        ]
    };
};
//# sourceMappingURL=DocumentCardActivity.styles.js.map

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DocumentCardTitleGlobalClassNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var DocumentCardTitleGlobalClassNames = {
    root: 'ms-DocumentCardTitle'
};
var getStyles = function (props) {
    var theme = props.theme, className = props.className, showAsSecondaryTitle = props.showAsSecondaryTitle;
    var palette = theme.palette, fonts = theme.fonts;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(DocumentCardTitleGlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            showAsSecondaryTitle ? fonts.medium : fonts.large,
            {
                padding: '8px 16px',
                display: 'block',
                overflow: 'hidden',
                wordWrap: 'break-word',
                height: showAsSecondaryTitle ? '45px' : '38px',
                lineHeight: showAsSecondaryTitle ? '18px' : '21px',
                color: showAsSecondaryTitle ? palette.neutralSecondary : palette.neutralPrimary
            },
            className
        ]
    };
};
//# sourceMappingURL=DocumentCardTitle.styles.js.map

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DocumentCardLocationGlobalClassNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var DocumentCardLocationGlobalClassNames = {
    root: 'ms-DocumentCardLocation'
};
var getStyles = function (props) {
    var theme = props.theme, className = props.className;
    var palette = theme.palette;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(DocumentCardLocationGlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            {
                fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].small,
                color: palette.neutralPrimary,
                display: 'block',
                padding: '8px 16px',
                position: 'relative',
                textDecoration: 'none',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                selectors: {
                    ':hover': {
                        color: palette.themePrimary,
                        cursor: 'pointer'
                    }
                }
            },
            className
        ]
    };
};
//# sourceMappingURL=DocumentCardLocation.styles.js.map

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseExtendedPicker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Autofill__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BaseExtendedPicker_scss__ = __webpack_require__(1917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FocusZone__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Selection__ = __webpack_require__(436);







// tslint:disable-next-line:no-any
var styles = __WEBPACK_IMPORTED_MODULE_4__BaseExtendedPicker_scss__;
var BaseExtendedPicker = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](BaseExtendedPicker, _super);
    function BaseExtendedPicker(basePickerProps) {
        var _this = _super.call(this, basePickerProps) || this;
        _this.floatingPicker = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.selectedItemsList = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.root = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.input = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.onSelectionChange = function () {
            _this.forceUpdate();
        };
        _this.onInputChange = function (value) {
            _this.setState({ queryString: value });
            if (_this.floatingPicker.current) {
                _this.floatingPicker.current.onQueryStringChanged(value);
            }
        };
        _this.onInputFocus = function (ev) {
            if (_this.selectedItemsList.current) {
                _this.selectedItemsList.current.unselectAll();
            }
            if (_this.props.inputProps && _this.props.inputProps.onFocus) {
                _this.props.inputProps.onFocus(ev);
            }
        };
        _this.onInputClick = function (ev) {
            if (_this.selectedItemsList.current) {
                _this.selectedItemsList.current.unselectAll();
            }
            if (_this.floatingPicker.current && _this.inputElement) {
                // Update the value if the input value is empty or it is different than the current inputText from the floatingPicker
                var shoudUpdateValue = _this.inputElement.value === '' || _this.inputElement.value !== _this.floatingPicker.current.inputText;
                _this.floatingPicker.current.showPicker(shoudUpdateValue);
            }
        };
        // This is protected because we may expect the backspace key to work differently in a different kind of picker.
        // This lets the subclass override it and provide it's own onBackspace. For an example see the BasePickerListBelow
        _this.onBackspace = function (ev) {
            if (ev.which !== __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].backspace) {
                return;
            }
            if (_this.selectedItemsList.current && _this.items.length) {
                if (_this.input.current &&
                    !_this.input.current.isValueSelected &&
                    _this.input.current.inputElement === document.activeElement &&
                    _this.input.current.cursorLocation === 0) {
                    if (_this.floatingPicker.current) {
                        _this.floatingPicker.current.hidePicker();
                    }
                    ev.preventDefault();
                    _this.selectedItemsList.current.removeItemAt(_this.items.length - 1);
                    _this._onSelectedItemsChanged();
                }
                else if (_this.selectedItemsList.current.hasSelectedItems()) {
                    if (_this.floatingPicker.current) {
                        _this.floatingPicker.current.hidePicker();
                    }
                    ev.preventDefault();
                    _this.selectedItemsList.current.removeSelectedItems();
                    _this._onSelectedItemsChanged();
                }
            }
        };
        _this.onCopy = function (ev) {
            if (_this.selectedItemsList.current) {
                // Pass it down into the selected items list
                _this.selectedItemsList.current.onCopy(ev);
            }
        };
        _this.onPaste = function (ev) {
            if (_this.props.onPaste) {
                var inputText = ev.clipboardData.getData('Text');
                ev.preventDefault();
                _this.props.onPaste(inputText);
            }
        };
        _this._onSuggestionSelected = function (item) {
            var currentRenderedQueryString = _this.props.currentRenderedQueryString;
            var queryString = _this.state.queryString;
            if (currentRenderedQueryString === undefined || currentRenderedQueryString === queryString) {
                var processedItem = _this.props.onItemSelected ? _this.props.onItemSelected(item) : item;
                if (processedItem === null) {
                    return;
                }
                var processedItemObject = processedItem;
                var processedItemPromiseLike = processedItem;
                var newItem_1;
                if (processedItemPromiseLike && processedItemPromiseLike.then) {
                    processedItemPromiseLike.then(function (resolvedProcessedItem) {
                        newItem_1 = resolvedProcessedItem;
                        _this._addProcessedItem(newItem_1);
                    });
                }
                else {
                    newItem_1 = processedItemObject;
                    _this._addProcessedItem(newItem_1);
                }
            }
        };
        _this._onSelectedItemsChanged = function () {
            _this.focus();
        };
        _this.selection = new __WEBPACK_IMPORTED_MODULE_6__Selection__["a" /* Selection */]({ onSelectionChanged: function () { return _this.onSelectionChange(); } });
        _this.state = {
            queryString: '',
            suggestionItems: _this.props.suggestionItems ? _this.props.suggestionItems : null,
            selectedItems: _this.props.defaultSelectedItems
                ? _this.props.defaultSelectedItems
                : _this.props.selectedItems
                    ? _this.props.selectedItems
                    : null
        };
        _this.floatingPickerProps = _this.props.floatingPickerProps;
        _this.selectedItemsListProps = _this.props.selectedItemsListProps;
        return _this;
    }
    Object.defineProperty(BaseExtendedPicker.prototype, "items", {
        // tslint:disable-next-line:no-any
        get: function () {
            return this.state.selectedItems
                ? this.state.selectedItems
                : this.selectedItemsList.current
                    ? this.selectedItemsList.current.items
                    : null;
        },
        enumerable: true,
        configurable: true
    });
    BaseExtendedPicker.prototype.componentDidMount = function () {
        this.forceUpdate();
    };
    BaseExtendedPicker.prototype.componentWillReceiveProps = function (newProps) {
        if (newProps.floatingPickerProps) {
            this.floatingPickerProps = newProps.floatingPickerProps;
        }
        if (newProps.selectedItemsListProps) {
            this.selectedItemsListProps = newProps.selectedItemsListProps;
        }
        if (newProps.selectedItems) {
            this.setState({ selectedItems: newProps.selectedItems });
        }
    };
    BaseExtendedPicker.prototype.focus = function () {
        if (this.input.current) {
            this.input.current.focus();
        }
    };
    BaseExtendedPicker.prototype.clearInput = function () {
        if (this.input.current) {
            this.input.current.clear();
        }
    };
    Object.defineProperty(BaseExtendedPicker.prototype, "inputElement", {
        get: function () {
            return this.input.current && this.input.current.inputElement;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseExtendedPicker.prototype, "highlightedItems", {
        get: function () {
            return this.selectedItemsList.current ? this.selectedItemsList.current.highlightedItems() : [];
        },
        enumerable: true,
        configurable: true
    });
    BaseExtendedPicker.prototype.render = function () {
        var _a = this.props, className = _a.className, inputProps = _a.inputProps, disabled = _a.disabled, focusZoneProps = _a.focusZoneProps;
        var activeDescendant = this.floatingPicker.current && this.floatingPicker.current.currentSelectedSuggestionIndex !== -1
            ? 'sug-' + this.floatingPicker.current.currentSelectedSuggestionIndex
            : undefined;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: this.root, className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-BasePicker ms-BaseExtendedPicker', className ? className : ''), onKeyDown: this.onBackspace, onCopy: this.onCopy },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__FocusZone__["a" /* FocusZone */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ direction: __WEBPACK_IMPORTED_MODULE_5__FocusZone__["b" /* FocusZoneDirection */].bidirectional }, focusZoneProps),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Selection__["c" /* SelectionZone */], { selection: this.selection, selectionMode: __WEBPACK_IMPORTED_MODULE_6__Selection__["b" /* SelectionMode */].multiple },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-BasePicker-text', styles.pickerText), role: 'list' },
                        this.props.headerComponent,
                        this.renderSelectedItemsList(),
                        this.canAddItems() && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Autofill__["a" /* Autofill */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, inputProps, { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-BasePicker-input', styles.pickerInput), ref: this.input, onFocus: this.onInputFocus, onClick: this.onInputClick, onInputValueChange: this.onInputChange, "aria-activedescendant": activeDescendant, "aria-owns": "suggestion-list", "aria-expanded": this.floatingPicker.current ? this.floatingPicker.current.isSuggestionsShown : false, "aria-haspopup": "true", role: "combobox", disabled: disabled, onPaste: this.onPaste })))))),
            this.renderFloatingPicker()));
    };
    BaseExtendedPicker.prototype.canAddItems = function () {
        var itemLimit = this.props.itemLimit;
        return itemLimit === undefined || this.items.length < itemLimit;
    };
    BaseExtendedPicker.prototype.renderFloatingPicker = function () {
        var FloatingPicker = this.props.onRenderFloatingPicker;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](FloatingPicker, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ componentRef: this.floatingPicker, onChange: this._onSuggestionSelected, inputElement: this.input.current ? this.input.current.inputElement : undefined, selectedItems: this.items, suggestionItems: this.props.suggestionItems ? this.props.suggestionItems : undefined }, this.floatingPickerProps)));
    };
    BaseExtendedPicker.prototype.renderSelectedItemsList = function () {
        var SelectedItems = this.props.onRenderSelectedItems;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](SelectedItems, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ componentRef: this.selectedItemsList, selection: this.selection, selectedItems: this.props.selectedItems ? this.props.selectedItems : undefined, onItemsDeleted: this.props.selectedItems ? this.props.onItemsRemoved : undefined }, this.selectedItemsListProps)));
    };
    BaseExtendedPicker.prototype._addProcessedItem = function (newItem) {
        // If this is a controlled component, call the on item selected callback
        // Otherwise add it to the selectedItemsList
        if (this.props.onItemAdded) {
            this.props.onItemAdded(newItem);
        }
        if (this.selectedItemsList.current) {
            this.selectedItemsList.current.addItems([newItem]);
        }
        if (this.input.current) {
            this.input.current.clear();
        }
        if (this.floatingPicker.current) {
            this.floatingPicker.current.hidePicker();
        }
        this.focus();
    };
    return BaseExtendedPicker;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=BaseExtendedPicker.js.map

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OverflowButtonType; });
/**
 * {@docCategory Facepile}
 */
var OverflowButtonType;
(function (OverflowButtonType) {
    /** No overflow */
    OverflowButtonType[OverflowButtonType["none"] = 0] = "none";
    /** +1 overflow icon */
    OverflowButtonType[OverflowButtonType["descriptive"] = 1] = "descriptive";
    /** More overflow icon */
    OverflowButtonType[OverflowButtonType["more"] = 2] = "more";
    /** Chevron overflow icon */
    OverflowButtonType[OverflowButtonType["downArrow"] = 3] = "downArrow";
})(OverflowButtonType || (OverflowButtonType = {}));
//# sourceMappingURL=Facepile.types.js.map

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FacepileBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Facepile_types__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FacepileButton__ = __webpack_require__(1924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Persona__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PersonaCoin__ = __webpack_require__(435);








var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
/**
 * FacePile with no default styles.
 * [Use the `styles` API to add your own styles.](https://github.com/OfficeDev/office-ui-fabric-react/wiki/Component-Styling)
 */
var FacepileBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](FacepileBase, _super);
    function FacepileBase(props) {
        var _this = _super.call(this, props) || this;
        _this._classNames = getClassNames(_this.props.styles, {
            theme: _this.props.theme,
            className: _this.props.className
        });
        _this._getPersonaControl = function (persona) {
            var _a = _this.props, getPersonaProps = _a.getPersonaProps, personaSize = _a.personaSize;
            var personaStyles = {
                details: {
                    flex: '1 0 auto'
                }
            };
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Persona__["a" /* Persona */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ imageInitials: persona.imageInitials, imageUrl: persona.imageUrl, initialsColor: persona.initialsColor, allowPhoneInitials: persona.allowPhoneInitials, text: persona.personaName, size: personaSize }, (getPersonaProps ? getPersonaProps(persona) : null), { styles: personaStyles })));
        };
        _this._getPersonaCoinControl = function (persona) {
            var _a = _this.props, getPersonaProps = _a.getPersonaProps, personaSize = _a.personaSize;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__PersonaCoin__["a" /* PersonaCoin */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ imageInitials: persona.imageInitials, imageUrl: persona.imageUrl, initialsColor: persona.initialsColor, allowPhoneInitials: persona.allowPhoneInitials, text: persona.personaName, size: personaSize }, (getPersonaProps ? getPersonaProps(persona) : null))));
        };
        _this._ariaDescriptionId = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["N" /* getId */])();
        return _this;
    }
    FacepileBase.prototype.render = function () {
        var overflowButtonProps = this.props.overflowButtonProps;
        var _a = this.props, chevronButtonProps = _a.chevronButtonProps, maxDisplayablePersonas = _a.maxDisplayablePersonas, personas = _a.personas, overflowPersonas = _a.overflowPersonas, showAddButton = _a.showAddButton, ariaLabel = _a.ariaLabel;
        var _classNames = this._classNames;
        // Add a check to make sure maxDisplayalePersonas is defined to cover the edge case of it being 0.
        var numPersonasToShow = typeof maxDisplayablePersonas === 'number' ? Math.min(personas.length, maxDisplayablePersonas) : personas.length;
        // Added for deprecating chevronButtonProps.  Can remove after v1.0
        if (chevronButtonProps && !overflowButtonProps) {
            overflowButtonProps = chevronButtonProps;
        }
        var hasOverflowPersonas = overflowPersonas && overflowPersonas.length > 0;
        var personasPrimary = hasOverflowPersonas ? personas : personas.slice(0, numPersonasToShow);
        var personasOverflow = (hasOverflowPersonas ? overflowPersonas : personas.slice(numPersonasToShow)) || [];
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: _classNames.root },
            this.onRenderAriaDescription(),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: _classNames.itemContainer },
                showAddButton ? this._getAddNewElement() : null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("ul", { className: _classNames.members, role: "listbox", "aria-label": ariaLabel }, this._onRenderVisiblePersonas(personasPrimary, personasOverflow.length === 0 && personas.length === 1)),
                overflowButtonProps ? this._getOverflowElement(personasOverflow) : null)));
    };
    FacepileBase.prototype.onRenderAriaDescription = function () {
        var ariaDescription = this.props.ariaDescription;
        var _classNames = this._classNames;
        // If ariaDescription is given, descriptionId will be assigned to ariaDescriptionSpan,
        // otherwise it will be assigned to descriptionSpan.
        return (ariaDescription && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: _classNames.screenReaderOnly, id: this._ariaDescriptionId }, ariaDescription)));
    };
    FacepileBase.prototype._onRenderVisiblePersonas = function (personas, singlePersona) {
        var _this = this;
        var _a = this.props, _b = _a.onRenderPersona, onRenderPersona = _b === void 0 ? this._getPersonaControl : _b, _c = _a.onRenderPersonaCoin, onRenderPersonaCoin = _c === void 0 ? this._getPersonaCoinControl : _c;
        return personas.map(function (persona, index) {
            var personaControl = singlePersona
                ? onRenderPersona(persona, _this._getPersonaControl)
                : onRenderPersonaCoin(persona, _this._getPersonaCoinControl);
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("li", { role: "option", key: (singlePersona ? 'persona' : 'personaCoin') + "-" + index, className: _this._classNames.member }, persona.onClick
                ? _this._getElementWithOnClickEvent(personaControl, persona, index)
                : _this._getElementWithoutOnClickEvent(personaControl, persona, index)));
        });
    };
    FacepileBase.prototype._getElementWithOnClickEvent = function (personaControl, persona, index) {
        var keytipProps = persona.keytipProps;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__FacepileButton__["a" /* FacepileButton */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["R" /* getNativeProps */])(persona, __WEBPACK_IMPORTED_MODULE_2__Utilities__["p" /* buttonProperties */]), this._getElementProps(persona, index), { keytipProps: keytipProps, onClick: this._onPersonaClick.bind(this, persona) }), personaControl));
    };
    FacepileBase.prototype._getElementWithoutOnClickEvent = function (personaControl, persona, index) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["R" /* getNativeProps */])(persona, __WEBPACK_IMPORTED_MODULE_2__Utilities__["p" /* buttonProperties */]), this._getElementProps(persona, index)), personaControl));
    };
    FacepileBase.prototype._getElementProps = function (persona, index) {
        var _classNames = this._classNames;
        return {
            key: (!!persona.imageUrl ? 'i' : '') + index,
            'data-is-focusable': true,
            role: 'option',
            className: _classNames.itemButton,
            title: persona.personaName,
            onMouseMove: this._onPersonaMouseMove.bind(this, persona),
            onMouseOut: this._onPersonaMouseOut.bind(this, persona)
        };
    };
    FacepileBase.prototype._getOverflowElement = function (personasOverflow) {
        switch (this.props.overflowButtonType) {
            case __WEBPACK_IMPORTED_MODULE_3__Facepile_types__["a" /* OverflowButtonType */].descriptive:
                return this._getDescriptiveOverflowElement(personasOverflow);
            case __WEBPACK_IMPORTED_MODULE_3__Facepile_types__["a" /* OverflowButtonType */].downArrow:
                return this._getIconElement('ChevronDown');
            case __WEBPACK_IMPORTED_MODULE_3__Facepile_types__["a" /* OverflowButtonType */].more:
                return this._getIconElement('More');
            default:
                return null;
        }
    };
    FacepileBase.prototype._getDescriptiveOverflowElement = function (personasOverflow) {
        var personaSize = this.props.personaSize;
        if (!personasOverflow || personasOverflow.length < 1) {
            return null;
        }
        var personaNames = personasOverflow.map(function (p) { return p.personaName; }).join(', ');
        var overflowButtonProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ title: personaNames }, this.props.overflowButtonProps);
        var numPersonasNotPictured = Math.max(personasOverflow.length, 0);
        var _classNames = this._classNames;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__FacepileButton__["a" /* FacepileButton */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, overflowButtonProps, { ariaDescription: overflowButtonProps.title, className: _classNames.descriptiveOverflowButton }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__PersonaCoin__["a" /* PersonaCoin */], { size: personaSize, onRenderInitials: this._renderInitialsNotPictured(numPersonasNotPictured), initialsColor: __WEBPACK_IMPORTED_MODULE_7__PersonaCoin__["b" /* PersonaInitialsColor */].transparent })));
    };
    FacepileBase.prototype._getIconElement = function (icon) {
        var _a = this.props, overflowButtonProps = _a.overflowButtonProps, personaSize = _a.personaSize;
        var overflowInitialsIcon = true;
        var _classNames = this._classNames;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__FacepileButton__["a" /* FacepileButton */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, overflowButtonProps, { className: _classNames.overflowButton }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__PersonaCoin__["a" /* PersonaCoin */], { size: personaSize, onRenderInitials: this._renderInitials(icon, overflowInitialsIcon), initialsColor: __WEBPACK_IMPORTED_MODULE_7__PersonaCoin__["b" /* PersonaInitialsColor */].transparent })));
    };
    FacepileBase.prototype._getAddNewElement = function () {
        var _a = this.props, addButtonProps = _a.addButtonProps, personaSize = _a.personaSize;
        var _classNames = this._classNames;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__FacepileButton__["a" /* FacepileButton */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, addButtonProps, { className: _classNames.addButton }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__PersonaCoin__["a" /* PersonaCoin */], { size: personaSize, onRenderInitials: this._renderInitials('AddFriend') })));
    };
    FacepileBase.prototype._onPersonaClick = function (persona, ev) {
        persona.onClick(ev, persona);
        ev.preventDefault();
        ev.stopPropagation();
    };
    FacepileBase.prototype._onPersonaMouseMove = function (persona, ev) {
        if (!!persona.onMouseMove) {
            persona.onMouseMove(ev, persona);
        }
    };
    FacepileBase.prototype._onPersonaMouseOut = function (persona, ev) {
        if (!!persona.onMouseOut) {
            persona.onMouseOut(ev, persona);
        }
    };
    FacepileBase.prototype._renderInitials = function (iconName, overflowButton) {
        var _classNames = this._classNames;
        return function () {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Icon__["Icon"], { iconName: iconName, className: overflowButton ? _classNames.overflowInitialsIcon : '' });
        };
    };
    FacepileBase.prototype._renderInitialsNotPictured = function (numPersonasNotPictured) {
        var _classNames = this._classNames;
        return function () {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: _classNames.overflowInitialsIcon }, '+' + numPersonasNotPictured);
        };
    };
    FacepileBase.defaultProps = {
        maxDisplayablePersonas: 5,
        personas: [],
        overflowPersonas: [],
        personaSize: __WEBPACK_IMPORTED_MODULE_7__PersonaCoin__["c" /* PersonaSize */].size32
    };
    return FacepileBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=Facepile.base.js.map

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseFloatingPicker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseFloatingPicker_scss__ = __webpack_require__(1930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Callout__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Suggestions_SuggestionsControl__ = __webpack_require__(768);






// tslint:disable-next-line:no-any
var styles = __WEBPACK_IMPORTED_MODULE_2__BaseFloatingPicker_scss__;
var BaseFloatingPicker = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](BaseFloatingPicker, _super);
    function BaseFloatingPicker(basePickerProps) {
        var _this = _super.call(this, basePickerProps) || this;
        _this.root = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.suggestionsControl = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.SuggestionsControlOfProperType = __WEBPACK_IMPORTED_MODULE_5__Suggestions_SuggestionsControl__["a" /* SuggestionsControl */];
        _this.isComponentMounted = false;
        _this.onQueryStringChanged = function (queryString) {
            if (queryString !== _this.state.queryString) {
                _this.setState({
                    queryString: queryString
                });
                if (_this.props.onInputChanged) {
                    _this.props.onInputChanged(queryString);
                }
                _this.updateValue(queryString);
            }
        };
        _this.hidePicker = function () {
            if (_this.props.onSuggestionsHidden && _this.isSuggestionsShown) {
                _this.props.onSuggestionsHidden();
            }
            _this.setState({
                suggestionsVisible: false
            });
        };
        _this.showPicker = function (updateValue) {
            if (updateValue === void 0) { updateValue = false; }
            if (_this.props.onSuggestionsShown && !_this.isSuggestionsShown) {
                _this.props.onSuggestionsShown();
            }
            _this.setState({
                suggestionsVisible: true
            });
            // Update the suggestions if updateValue == true
            var value = _this.props.inputElement ? _this.props.inputElement.value : '';
            if (updateValue) {
                _this.updateValue(value);
            }
        };
        _this.completeSuggestion = function () {
            if (_this.suggestionsControl.current && _this.suggestionsControl.current.hasSuggestionSelected()) {
                _this.onChange(_this.suggestionsControl.current.currentSuggestion.item);
            }
        };
        _this.onSuggestionClick = function (ev, item, index) {
            _this.onChange(item);
            _this._updateSuggestionsVisible(false /*shouldShow*/);
        };
        _this.onSuggestionRemove = function (ev, item, index) {
            if (_this.props.onRemoveSuggestion) {
                _this.props.onRemoveSuggestion(item);
            }
            if (_this.suggestionsControl.current) {
                _this.suggestionsControl.current.removeSuggestion(index);
            }
        };
        _this.onKeyDown = function (ev) {
            if (!_this.state.suggestionsVisible ||
                (_this.props.inputElement && !_this.props.inputElement.contains(ev.target))) {
                return;
            }
            var keyCode = ev.which;
            switch (keyCode) {
                case __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].escape:
                    _this.hidePicker();
                    ev.preventDefault();
                    ev.stopPropagation();
                    break;
                case __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].tab:
                case __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].enter:
                    if (!ev.shiftKey && !ev.ctrlKey && _this.suggestionsControl.current && _this.suggestionsControl.current.handleKeyDown(keyCode)) {
                        ev.preventDefault();
                        ev.stopPropagation();
                    }
                    else {
                        _this._onValidateInput();
                    }
                    break;
                case __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].del:
                    if (_this.props.onRemoveSuggestion &&
                        _this.suggestionsControl.current &&
                        _this.suggestionsControl.current.hasSuggestionSelected &&
                        _this.suggestionsControl.current.currentSuggestion &&
                        ev.shiftKey) {
                        _this.props.onRemoveSuggestion(_this.suggestionsControl.current.currentSuggestion.item);
                        _this.suggestionsControl.current.removeSuggestion();
                        _this.forceUpdate();
                        ev.stopPropagation();
                    }
                    break;
                case __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].up:
                    if (_this.suggestionsControl.current && _this.suggestionsControl.current.handleKeyDown(keyCode)) {
                        ev.preventDefault();
                        ev.stopPropagation();
                        _this._updateActiveDescendant();
                    }
                    break;
                case __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].down:
                    if (_this.suggestionsControl.current && _this.suggestionsControl.current.handleKeyDown(keyCode)) {
                        ev.preventDefault();
                        ev.stopPropagation();
                        _this._updateActiveDescendant();
                    }
                    break;
            }
        };
        _this._onValidateInput = function () {
            if (_this.state.queryString && _this.props.onValidateInput && _this.props.createGenericItem) {
                var itemToConvert = _this.props.createGenericItem(_this.state.queryString, _this.props.onValidateInput(_this.state.queryString));
                var convertedItems = _this.suggestionStore.convertSuggestionsToSuggestionItems([itemToConvert]);
                _this.onChange(convertedItems[0].item);
            }
        };
        _this.suggestionStore = basePickerProps.suggestionsStore;
        _this.state = {
            queryString: '',
            didBind: false
        };
        return _this;
    }
    Object.defineProperty(BaseFloatingPicker.prototype, "inputText", {
        get: function () {
            return this.state.queryString;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseFloatingPicker.prototype, "suggestions", {
        // tslint:disable-next-line:no-any
        get: function () {
            return this.suggestionStore.suggestions;
        },
        enumerable: true,
        configurable: true
    });
    BaseFloatingPicker.prototype.forceResolveSuggestion = function () {
        if (this.suggestionsControl.current && this.suggestionsControl.current.hasSuggestionSelected()) {
            this.completeSuggestion();
        }
        else {
            this._onValidateInput();
        }
    };
    Object.defineProperty(BaseFloatingPicker.prototype, "currentSelectedSuggestionIndex", {
        get: function () {
            return this.suggestionsControl.current ? this.suggestionsControl.current.currentSuggestionIndex : -1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseFloatingPicker.prototype, "isSuggestionsShown", {
        get: function () {
            return this.state.suggestionsVisible === undefined ? false : this.state.suggestionsVisible;
        },
        enumerable: true,
        configurable: true
    });
    BaseFloatingPicker.prototype.componentDidMount = function () {
        this._bindToInputElement();
        this.isComponentMounted = true;
        this._onResolveSuggestions = this._async.debounce(this._onResolveSuggestions, this.props.resolveDelay);
    };
    BaseFloatingPicker.prototype.componentDidUpdate = function () {
        this._bindToInputElement();
    };
    BaseFloatingPicker.prototype.componentWillUnmount = function () {
        this._unbindFromInputElement();
        this.isComponentMounted = false;
    };
    BaseFloatingPicker.prototype.componentWillReceiveProps = function (newProps) {
        if (newProps.suggestionItems) {
            this.updateSuggestions(newProps.suggestionItems);
        }
    };
    BaseFloatingPicker.prototype.updateSuggestions = function (suggestions, forceUpdate) {
        if (forceUpdate === void 0) { forceUpdate = false; }
        this.suggestionStore.updateSuggestions(suggestions);
        if (forceUpdate) {
            this.forceUpdate();
        }
    };
    BaseFloatingPicker.prototype.render = function () {
        var className = this.props.className;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: this.root, className: Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["t" /* css */])('ms-BasePicker ms-BaseFloatingPicker', className ? className : '') }, this.renderSuggestions()));
    };
    BaseFloatingPicker.prototype.renderSuggestions = function () {
        var TypedSuggestionsControl = this.SuggestionsControlOfProperType;
        return this.state.suggestionsVisible ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Callout__["a" /* Callout */], { className: styles.callout, isBeakVisible: false, gapSpace: 5, target: this.props.inputElement, onDismiss: this.hidePicker, directionalHint: __WEBPACK_IMPORTED_MODULE_4__Callout__["b" /* DirectionalHint */].bottomLeftEdge, directionalHintForRTL: __WEBPACK_IMPORTED_MODULE_4__Callout__["b" /* DirectionalHint */].bottomRightEdge, calloutWidth: this.props.calloutWidth ? this.props.calloutWidth : 0 },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](TypedSuggestionsControl, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ onRenderSuggestion: this.props.onRenderSuggestionsItem, onSuggestionClick: this.onSuggestionClick, onSuggestionRemove: this.onSuggestionRemove, suggestions: this.suggestionStore.getSuggestions(), componentRef: this.suggestionsControl, completeSuggestion: this.completeSuggestion, shouldLoopSelection: false }, this.props.pickerSuggestionsProps)))) : null;
    };
    BaseFloatingPicker.prototype.onSelectionChange = function () {
        this.forceUpdate();
    };
    BaseFloatingPicker.prototype.updateValue = function (updatedValue) {
        if (updatedValue === '') {
            this.updateSuggestionWithZeroState();
        }
        else {
            this._onResolveSuggestions(updatedValue);
        }
    };
    BaseFloatingPicker.prototype.updateSuggestionWithZeroState = function () {
        if (this.props.onZeroQuerySuggestion) {
            var onEmptyInputFocus = this.props.onZeroQuerySuggestion;
            var suggestions = onEmptyInputFocus(this.props.selectedItems);
            this.updateSuggestionsList(suggestions);
        }
        else {
            this.hidePicker();
        }
    };
    BaseFloatingPicker.prototype.updateSuggestionsList = function (suggestions) {
        var _this = this;
        var suggestionsArray = suggestions;
        var suggestionsPromiseLike = suggestions;
        // Check to see if the returned value is an array, if it is then just pass it into the next function.
        // If the returned value is not an array then check to see if it's a promise or PromiseLike. If it is then resolve it asynchronously.
        if (Array.isArray(suggestionsArray)) {
            this.updateSuggestions(suggestionsArray, true /*forceUpdate*/);
        }
        else if (suggestionsPromiseLike && suggestionsPromiseLike.then) {
            // Ensure that the promise will only use the callback if it was the most recent one.
            var promise_1 = (this.currentPromise = suggestionsPromiseLike);
            promise_1.then(function (newSuggestions) {
                // Only update if the next promise has not yet resolved and
                // the floating picker is still mounted.
                if (promise_1 === _this.currentPromise && _this.isComponentMounted) {
                    _this.updateSuggestions(newSuggestions, true /*forceUpdate*/);
                }
            });
        }
    };
    BaseFloatingPicker.prototype.onChange = function (item) {
        if (this.props.onChange) {
            this.props.onChange(item);
        }
    };
    BaseFloatingPicker.prototype._updateActiveDescendant = function () {
        if (this.props.inputElement && this.suggestionsControl.current && this.suggestionsControl.current.selectedElement) {
            var selectedElId = this.suggestionsControl.current.selectedElement.getAttribute('id');
            if (selectedElId) {
                this.props.inputElement.setAttribute('aria-activedescendant', selectedElId);
            }
        }
    };
    BaseFloatingPicker.prototype._onResolveSuggestions = function (updatedValue) {
        var suggestions = this.props.onResolveSuggestions(updatedValue, this.props.selectedItems);
        this._updateSuggestionsVisible(true /*shouldShow*/);
        if (suggestions !== null) {
            this.updateSuggestionsList(suggestions);
        }
    };
    BaseFloatingPicker.prototype._updateSuggestionsVisible = function (shouldShow) {
        if (shouldShow) {
            this.showPicker();
        }
        else {
            this.hidePicker();
        }
    };
    BaseFloatingPicker.prototype._bindToInputElement = function () {
        if (this.props.inputElement && !this.state.didBind) {
            this.props.inputElement.addEventListener('keydown', this.onKeyDown);
            this.setState({ didBind: true });
        }
    };
    BaseFloatingPicker.prototype._unbindFromInputElement = function () {
        if (this.props.inputElement && this.state.didBind) {
            this.props.inputElement.removeEventListener('keydown', this.onKeyDown);
            this.setState({ didBind: false });
        }
    };
    return BaseFloatingPicker;
}(__WEBPACK_IMPORTED_MODULE_3__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=BaseFloatingPicker.js.map

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SuggestionItemType */
/* unused harmony export SuggestionsHeaderFooterItem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SuggestionsControl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SuggestionsCore__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SuggestionsControl_scss__ = __webpack_require__(1942);





// tslint:disable-next-line:no-any
var styles = __WEBPACK_IMPORTED_MODULE_4__SuggestionsControl_scss__;
var SuggestionItemType;
(function (SuggestionItemType) {
    SuggestionItemType[SuggestionItemType["header"] = 0] = "header";
    SuggestionItemType[SuggestionItemType["suggestion"] = 1] = "suggestion";
    SuggestionItemType[SuggestionItemType["footer"] = 2] = "footer";
})(SuggestionItemType || (SuggestionItemType = {}));
var SuggestionsHeaderFooterItem = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](SuggestionsHeaderFooterItem, _super);
    function SuggestionsHeaderFooterItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SuggestionsHeaderFooterItem.prototype.render = function () {
        var _a = this.props, renderItem = _a.renderItem, onExecute = _a.onExecute, isSelected = _a.isSelected, id = _a.id, className = _a.className;
        return onExecute ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { id: id, onClick: onExecute, className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-Suggestions-sectionButton', className, styles.actionButton, (_b = {},
                _b['is-selected ' + styles.buttonSelected] = isSelected,
                _b)) }, renderItem())) : (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { id: id, className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-Suggestions-section', className, styles.suggestionsTitle) }, renderItem()));
        var _b;
    };
    return SuggestionsHeaderFooterItem;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

/**
 * Class when used with SuggestionsStore, renders a suggestions control with customizable headers and footers
 */
var SuggestionsControl = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](SuggestionsControl, _super);
    function SuggestionsControl(suggestionsProps) {
        var _this = _super.call(this, suggestionsProps) || this;
        _this.SuggestionsOfProperType = __WEBPACK_IMPORTED_MODULE_3__SuggestionsCore__["a" /* SuggestionsCore */];
        _this.state = {
            selectedHeaderIndex: -1,
            selectedFooterIndex: -1,
            suggestions: suggestionsProps.suggestions
        };
        return _this;
    }
    SuggestionsControl.prototype.componentDidMount = function () {
        this.resetSelectedItem();
    };
    SuggestionsControl.prototype.componentDidUpdate = function () {
        this.scrollSelected();
    };
    SuggestionsControl.prototype.componentWillReceiveProps = function (newProps) {
        var _this = this;
        if (newProps.suggestions) {
            this.setState({ suggestions: newProps.suggestions }, function () {
                _this.resetSelectedItem();
            });
        }
    };
    SuggestionsControl.prototype.componentWillUnmount = function () {
        this._suggestions.deselectAllSuggestions();
    };
    SuggestionsControl.prototype.render = function () {
        var _a = this.props, className = _a.className, headerItemsProps = _a.headerItemsProps, footerItemsProps = _a.footerItemsProps;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-Suggestions', className ? className : '', styles.root) },
            headerItemsProps && this.renderHeaderItems(),
            this._renderSuggestions(),
            footerItemsProps && this.renderFooterItems()));
    };
    Object.defineProperty(SuggestionsControl.prototype, "currentSuggestion", {
        get: function () {
            return this._suggestions && this._suggestions.getCurrentItem();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SuggestionsControl.prototype, "currentSuggestionIndex", {
        get: function () {
            return this._suggestions ? this._suggestions.currentIndex : -1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SuggestionsControl.prototype, "selectedElement", {
        get: function () {
            return this._selectedElement ? this._selectedElement : this._suggestions.selectedElement;
        },
        enumerable: true,
        configurable: true
    });
    SuggestionsControl.prototype.hasSuggestionSelected = function () {
        return this._suggestions && this._suggestions.hasSuggestionSelected();
    };
    SuggestionsControl.prototype.hasSelection = function () {
        var _a = this.state, selectedHeaderIndex = _a.selectedHeaderIndex, selectedFooterIndex = _a.selectedFooterIndex;
        return selectedHeaderIndex !== -1 || this.hasSuggestionSelected() || selectedFooterIndex !== -1;
    };
    SuggestionsControl.prototype.executeSelectedAction = function () {
        var _a = this.props, headerItemsProps = _a.headerItemsProps, footerItemsProps = _a.footerItemsProps;
        var _b = this.state, selectedHeaderIndex = _b.selectedHeaderIndex, selectedFooterIndex = _b.selectedFooterIndex;
        if (headerItemsProps && selectedHeaderIndex !== -1 && selectedHeaderIndex < headerItemsProps.length) {
            var selectedHeaderItem = headerItemsProps[selectedHeaderIndex];
            if (selectedHeaderItem.onExecute) {
                selectedHeaderItem.onExecute();
            }
        }
        else if (this._suggestions.hasSuggestionSelected()) {
            this.props.completeSuggestion();
        }
        else if (footerItemsProps && selectedFooterIndex !== -1 && selectedFooterIndex < footerItemsProps.length) {
            var selectedFooterItem = footerItemsProps[selectedFooterIndex];
            if (selectedFooterItem.onExecute) {
                selectedFooterItem.onExecute();
            }
        }
    };
    SuggestionsControl.prototype.removeSuggestion = function (index) {
        this._suggestions.removeSuggestion(index ? index : this._suggestions.currentIndex);
    };
    /**
     * Handles the key down, returns true, if the event was handled, false otherwise
     * @param keyCode - The keyCode to handle
     */
    SuggestionsControl.prototype.handleKeyDown = function (keyCode) {
        var _a = this.state, selectedHeaderIndex = _a.selectedHeaderIndex, selectedFooterIndex = _a.selectedFooterIndex;
        var isKeyDownHandled = false;
        if (keyCode === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].down) {
            if (selectedHeaderIndex === -1 && !this._suggestions.hasSuggestionSelected() && selectedFooterIndex === -1) {
                this.selectFirstItem();
            }
            else if (selectedHeaderIndex !== -1) {
                this.selectNextItem(SuggestionItemType.header);
                isKeyDownHandled = true;
            }
            else if (this._suggestions.hasSuggestionSelected()) {
                this.selectNextItem(SuggestionItemType.suggestion);
                isKeyDownHandled = true;
            }
            else if (selectedFooterIndex !== -1) {
                this.selectNextItem(SuggestionItemType.footer);
                isKeyDownHandled = true;
            }
        }
        else if (keyCode === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].up) {
            if (selectedHeaderIndex === -1 && !this._suggestions.hasSuggestionSelected() && selectedFooterIndex === -1) {
                this.selectLastItem();
            }
            else if (selectedHeaderIndex !== -1) {
                this.selectPreviousItem(SuggestionItemType.header);
                isKeyDownHandled = true;
            }
            else if (this._suggestions.hasSuggestionSelected()) {
                this.selectPreviousItem(SuggestionItemType.suggestion);
                isKeyDownHandled = true;
            }
            else if (selectedFooterIndex !== -1) {
                this.selectPreviousItem(SuggestionItemType.footer);
                isKeyDownHandled = true;
            }
        }
        else if (keyCode === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].enter || keyCode === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].tab) {
            if (this.hasSelection()) {
                this.executeSelectedAction();
                isKeyDownHandled = true;
            }
        }
        return isKeyDownHandled;
    };
    // TODO get the element to scroll into view properly regardless of direction.
    SuggestionsControl.prototype.scrollSelected = function () {
        if (this._selectedElement) {
            this._selectedElement.scrollIntoView(false);
        }
    };
    SuggestionsControl.prototype.renderHeaderItems = function () {
        var _this = this;
        var _a = this.props, headerItemsProps = _a.headerItemsProps, suggestionsHeaderContainerAriaLabel = _a.suggestionsHeaderContainerAriaLabel;
        var selectedHeaderIndex = this.state.selectedHeaderIndex;
        return headerItemsProps ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-Suggestions-headerContainer', styles.suggestionsContainer), id: "suggestionHeader-list", role: "list", "aria-label": suggestionsHeaderContainerAriaLabel }, headerItemsProps.map(function (headerItemProps, index) {
            var isSelected = selectedHeaderIndex !== -1 && selectedHeaderIndex === index;
            return headerItemProps.shouldShow() ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: _this._resolveRef(isSelected ? '_selectedElement' : ''), id: 'sug-header' + index, key: 'sug-header' + index, role: "listitem", "aria-label": headerItemProps.ariaLabel },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](SuggestionsHeaderFooterItem, { id: 'sug-header-item' + index, isSelected: isSelected, renderItem: headerItemProps.renderItem, onExecute: headerItemProps.onExecute, className: headerItemProps.className }))) : null;
        }))) : null;
    };
    SuggestionsControl.prototype.renderFooterItems = function () {
        var _this = this;
        var _a = this.props, footerItemsProps = _a.footerItemsProps, suggestionsFooterContainerAriaLabel = _a.suggestionsFooterContainerAriaLabel;
        var selectedFooterIndex = this.state.selectedFooterIndex;
        return footerItemsProps ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-Suggestions-footerContainer', styles.suggestionsContainer), id: "suggestionFooter-list", role: "list", "aria-label": suggestionsFooterContainerAriaLabel }, footerItemsProps.map(function (footerItemProps, index) {
            var isSelected = selectedFooterIndex !== -1 && selectedFooterIndex === index;
            return footerItemProps.shouldShow() ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: _this._resolveRef(isSelected ? '_selectedElement' : ''), id: 'sug-footer' + index, key: 'sug-footer' + index, role: "listitem", "aria-label": footerItemProps.ariaLabel },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](SuggestionsHeaderFooterItem, { id: 'sug-footer-item' + index, isSelected: isSelected, renderItem: footerItemProps.renderItem, onExecute: footerItemProps.onExecute, className: footerItemProps.className }))) : null;
        }))) : null;
    };
    SuggestionsControl.prototype._renderSuggestions = function () {
        var TypedSuggestions = this.SuggestionsOfProperType;
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](TypedSuggestions, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ ref: this._resolveRef('_suggestions') }, this.props, { suggestions: this.state.suggestions }));
    };
    /**
     * Selects the next selectable item
     */
    SuggestionsControl.prototype.selectNextItem = function (itemType, originalItemType) {
        // If the recursive calling has not found a selectable item in the other suggestion item type groups
        // And the method is being called again with the original item type,
        // Select the first selectable item of this suggestion item type group (could be the currently selected item)
        if (itemType === originalItemType) {
            this._selectNextItemOfItemType(itemType);
            return;
        }
        var startedItemType = originalItemType !== undefined ? originalItemType : itemType;
        // Try to set the selection to the next selectable item, of the same suggestion item type group
        // If this is the original item type, use the current index
        var selectionChanged = this._selectNextItemOfItemType(itemType, startedItemType === itemType ? this._getCurrentIndexForType(itemType) : undefined);
        // If the selection did not change, try to select from the next suggestion type group
        if (!selectionChanged) {
            this.selectNextItem(this._getNextItemSectionType(itemType), startedItemType);
        }
    };
    /**
     * Selects the previous selectable item
     */
    SuggestionsControl.prototype.selectPreviousItem = function (itemType, originalItemType) {
        // If the recursive calling has not found a selectable item in the other suggestion item type groups
        // And the method is being called again with the original item type,
        // Select the last selectable item of this suggestion item type group (could be the currently selected item)
        if (itemType === originalItemType) {
            this._selectPreviousItemOfItemType(itemType);
            return;
        }
        var startedItemType = originalItemType !== undefined ? originalItemType : itemType;
        // Try to set the selection to the previous selectable item, of the same suggestion item type group
        var selectionChanged = this._selectPreviousItemOfItemType(itemType, startedItemType === itemType ? this._getCurrentIndexForType(itemType) : undefined);
        // If the selection did not change, try to select from the previous suggestion type group
        if (!selectionChanged) {
            this.selectPreviousItem(this._getPreviousItemSectionType(itemType), startedItemType);
        }
    };
    /**
     * Resets the selected state and selects the first selectable item
     */
    SuggestionsControl.prototype.resetSelectedItem = function () {
        this.setState({ selectedHeaderIndex: -1, selectedFooterIndex: -1 });
        this._suggestions.deselectAllSuggestions();
        // Select the first item if the shouldSelectFirstItem prop is not set or it is set and it returns true
        if (this.props.shouldSelectFirstItem === undefined || this.props.shouldSelectFirstItem()) {
            this.selectFirstItem();
        }
    };
    /**
     * Selects the first item
     */
    SuggestionsControl.prototype.selectFirstItem = function () {
        if (this._selectNextItemOfItemType(SuggestionItemType.header)) {
            return;
        }
        if (this._selectNextItemOfItemType(SuggestionItemType.suggestion)) {
            return;
        }
        this._selectNextItemOfItemType(SuggestionItemType.footer);
    };
    /**
     * Selects the last item
     */
    SuggestionsControl.prototype.selectLastItem = function () {
        if (this._selectPreviousItemOfItemType(SuggestionItemType.footer)) {
            return;
        }
        if (this._selectPreviousItemOfItemType(SuggestionItemType.suggestion)) {
            return;
        }
        this._selectPreviousItemOfItemType(SuggestionItemType.header);
    };
    /**
     * Selects the next item in the suggestion item type group, given the current index
     * If none is able to be selected, returns false, otherwise returns true
     * @param itemType - The suggestion item type
     * @param currentIndex - The current index, default is -1
     */
    SuggestionsControl.prototype._selectNextItemOfItemType = function (itemType, currentIndex) {
        if (currentIndex === void 0) { currentIndex = -1; }
        if (itemType === SuggestionItemType.suggestion) {
            if (this.state.suggestions.length > currentIndex + 1) {
                this._suggestions.setSelectedSuggestion(currentIndex + 1);
                this.setState({ selectedHeaderIndex: -1, selectedFooterIndex: -1 });
                return true;
            }
        }
        else {
            var isHeader = itemType === SuggestionItemType.header;
            var itemProps = isHeader ? this.props.headerItemsProps : this.props.footerItemsProps;
            if (itemProps && itemProps.length > currentIndex + 1) {
                for (var i = currentIndex + 1; i < itemProps.length; i++) {
                    var item = itemProps[i];
                    if (item.onExecute && item.shouldShow()) {
                        this.setState({ selectedHeaderIndex: isHeader ? i : -1 });
                        this.setState({ selectedFooterIndex: isHeader ? -1 : i });
                        this._suggestions.deselectAllSuggestions();
                        return true;
                    }
                }
            }
        }
        return false;
    };
    /**
     * Selects the previous item in the suggestion item type group, given the current index
     * If none is able to be selected, returns false, otherwise returns true
     * @param itemType - The suggestion item type
     * @param currentIndex - The current index. If none is provided, the default is the items length of specified type
     */
    SuggestionsControl.prototype._selectPreviousItemOfItemType = function (itemType, currentIndex) {
        if (itemType === SuggestionItemType.suggestion) {
            var index = currentIndex !== undefined ? currentIndex : this.state.suggestions.length;
            if (index > 0) {
                this._suggestions.setSelectedSuggestion(index - 1);
                this.setState({ selectedHeaderIndex: -1, selectedFooterIndex: -1 });
                return true;
            }
        }
        else {
            var isHeader = itemType === SuggestionItemType.header;
            var itemProps = isHeader ? this.props.headerItemsProps : this.props.footerItemsProps;
            if (itemProps) {
                var index = currentIndex !== undefined ? currentIndex : itemProps.length;
                if (index > 0) {
                    for (var i = index - 1; i >= 0; i--) {
                        var item = itemProps[i];
                        if (item.onExecute && item.shouldShow()) {
                            this.setState({ selectedHeaderIndex: isHeader ? i : -1 });
                            this.setState({ selectedFooterIndex: isHeader ? -1 : i });
                            this._suggestions.deselectAllSuggestions();
                            return true;
                        }
                    }
                }
            }
        }
        return false;
    };
    SuggestionsControl.prototype._getCurrentIndexForType = function (itemType) {
        switch (itemType) {
            case SuggestionItemType.header:
                return this.state.selectedHeaderIndex;
            case SuggestionItemType.suggestion:
                return this._suggestions.currentIndex;
            case SuggestionItemType.footer:
                return this.state.selectedFooterIndex;
        }
    };
    SuggestionsControl.prototype._getNextItemSectionType = function (itemType) {
        switch (itemType) {
            case SuggestionItemType.header:
                return SuggestionItemType.suggestion;
            case SuggestionItemType.suggestion:
                return SuggestionItemType.footer;
            case SuggestionItemType.footer:
                return SuggestionItemType.header;
        }
    };
    SuggestionsControl.prototype._getPreviousItemSectionType = function (itemType) {
        switch (itemType) {
            case SuggestionItemType.header:
                return SuggestionItemType.footer;
            case SuggestionItemType.suggestion:
                return SuggestionItemType.header;
            case SuggestionItemType.footer:
                return SuggestionItemType.suggestion;
        }
    };
    return SuggestionsControl;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=SuggestionsControl.js.map

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SuggestionsCore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Pickers__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SuggestionsCore_scss__ = __webpack_require__(1941);





// tslint:disable-next-line:no-any
var styles = __WEBPACK_IMPORTED_MODULE_4__SuggestionsCore_scss__;
/**
 * Class when used with SuggestionsStore, renders a basic suggestions control
 */
var SuggestionsCore = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](SuggestionsCore, _super);
    function SuggestionsCore(suggestionsProps) {
        var _this = _super.call(this, suggestionsProps) || this;
        _this.SuggestionsItemOfProperType = __WEBPACK_IMPORTED_MODULE_3__Pickers__["a" /* SuggestionsItem */];
        _this.currentIndex = -1;
        return _this;
    }
    /**
     * Increments the selected suggestion index
     */
    SuggestionsCore.prototype.nextSuggestion = function () {
        var suggestions = this.props.suggestions;
        if (suggestions && suggestions.length > 0) {
            if (this.currentIndex === -1) {
                this.setSelectedSuggestion(0);
                return true;
            }
            else if (this.currentIndex < suggestions.length - 1) {
                this.setSelectedSuggestion(this.currentIndex + 1);
                return true;
            }
            else if (this.props.shouldLoopSelection && this.currentIndex === suggestions.length - 1) {
                this.setSelectedSuggestion(0);
                return true;
            }
        }
        return false;
    };
    /**
     * Decrements the selected suggestion index
     */
    SuggestionsCore.prototype.previousSuggestion = function () {
        var suggestions = this.props.suggestions;
        if (suggestions && suggestions.length > 0) {
            if (this.currentIndex === -1) {
                this.setSelectedSuggestion(suggestions.length - 1);
                return true;
            }
            else if (this.currentIndex > 0) {
                this.setSelectedSuggestion(this.currentIndex - 1);
                return true;
            }
            else if (this.props.shouldLoopSelection && this.currentIndex === 0) {
                this.setSelectedSuggestion(suggestions.length - 1);
                return true;
            }
        }
        return false;
    };
    Object.defineProperty(SuggestionsCore.prototype, "selectedElement", {
        get: function () {
            return this._selectedElement;
        },
        enumerable: true,
        configurable: true
    });
    SuggestionsCore.prototype.getCurrentItem = function () {
        return this.props.suggestions[this.currentIndex];
    };
    SuggestionsCore.prototype.getSuggestionAtIndex = function (index) {
        return this.props.suggestions[index];
    };
    SuggestionsCore.prototype.hasSuggestionSelected = function () {
        return this.currentIndex !== -1 && this.currentIndex < this.props.suggestions.length;
    };
    SuggestionsCore.prototype.removeSuggestion = function (index) {
        this.props.suggestions.splice(index, 1);
    };
    SuggestionsCore.prototype.deselectAllSuggestions = function () {
        if (this.currentIndex > -1 && this.props.suggestions[this.currentIndex]) {
            this.props.suggestions[this.currentIndex].selected = false;
            this.currentIndex = -1;
            this.forceUpdate();
        }
    };
    SuggestionsCore.prototype.setSelectedSuggestion = function (index) {
        var suggestions = this.props.suggestions;
        if (index > suggestions.length - 1 || index < 0) {
            this.currentIndex = 0;
            this.currentSuggestion.selected = false;
            this.currentSuggestion = suggestions[0];
            this.currentSuggestion.selected = true;
        }
        else {
            if (this.currentIndex > -1 && suggestions[this.currentIndex]) {
                suggestions[this.currentIndex].selected = false;
            }
            suggestions[index].selected = true;
            this.currentIndex = index;
            this.currentSuggestion = suggestions[index];
        }
        this.forceUpdate();
    };
    SuggestionsCore.prototype.componentDidUpdate = function () {
        this.scrollSelected();
    };
    SuggestionsCore.prototype.render = function () {
        var _this = this;
        var _a = this.props, onRenderSuggestion = _a.onRenderSuggestion, suggestionsItemClassName = _a.suggestionsItemClassName, resultsMaximumNumber = _a.resultsMaximumNumber, showRemoveButtons = _a.showRemoveButtons, suggestionsContainerAriaLabel = _a.suggestionsContainerAriaLabel;
        var TypedSuggestionsItem = this.SuggestionsItemOfProperType;
        var suggestions = this.props.suggestions;
        if (resultsMaximumNumber) {
            suggestions = suggestions.slice(0, resultsMaximumNumber);
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-Suggestions-container', styles.suggestionsContainer), id: "suggestion-list", role: "list", "aria-label": suggestionsContainerAriaLabel }, suggestions.map(function (suggestion, index) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: _this._resolveRef(suggestion.selected || index === _this.currentIndex ? '_selectedElement' : ''), 
            // tslint:disable
            key: suggestion.item['key'] ? suggestion.item['key'] : index, 
            // tslint:enable
            id: 'sug-' + index, role: "listitem", "aria-label": suggestion.ariaLabel },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](TypedSuggestionsItem, { id: 'sug-item' + index, suggestionModel: suggestion, 
                // tslint:disable-next-line:no-any
                RenderSuggestion: onRenderSuggestion, onClick: _this._onClickTypedSuggestionsItem(suggestion.item, index), className: suggestionsItemClassName, showRemoveButton: showRemoveButtons, onRemoveItem: _this._onRemoveTypedSuggestionsItem(suggestion.item, index), isSelectedOverride: index === _this.currentIndex }))); })));
    };
    // TODO get the element to scroll into view properly regardless of direction.
    SuggestionsCore.prototype.scrollSelected = function () {
        if (this._selectedElement && this._selectedElement.scrollIntoView !== undefined) {
            this._selectedElement.scrollIntoView(false);
        }
    };
    SuggestionsCore.prototype._onClickTypedSuggestionsItem = function (item, index) {
        var _this = this;
        return function (ev) {
            _this.props.onSuggestionClick(ev, item, index);
        };
    };
    SuggestionsCore.prototype._onRemoveTypedSuggestionsItem = function (item, index) {
        var _this = this;
        return function (ev) {
            var onSuggestionRemove = _this.props.onSuggestionRemove;
            onSuggestionRemove(ev, item, index);
            ev.stopPropagation();
        };
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_2__Utilities__["o" /* autobind */]
    ], SuggestionsCore.prototype, "_onClickTypedSuggestionsItem", null);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_2__Utilities__["o" /* autobind */]
    ], SuggestionsCore.prototype, "_onRemoveTypedSuggestionsItem", null);
    return SuggestionsCore;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=SuggestionsCore.js.map

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pickers_index__ = __webpack_require__(1931);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_pickers_index__["a"]; });

//# sourceMappingURL=Pickers.js.map

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Suggestions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Spinner__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Suggestions_types__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SuggestionsItem__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SuggestionsItem_styles__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Suggestions_scss__ = __webpack_require__(774);









var legacyStyles = __WEBPACK_IMPORTED_MODULE_8__Suggestions_scss__;
var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var StyledSuggestionsItem = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_6__SuggestionsItem__["a" /* SuggestionsItem */], __WEBPACK_IMPORTED_MODULE_7__SuggestionsItem_styles__["b" /* getStyles */], undefined, { scope: 'SuggestionItem' });
/**
 * {@docCategory Pickers}
 */
var Suggestions = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](Suggestions, _super);
    function Suggestions(suggestionsProps) {
        var _this = _super.call(this, suggestionsProps) || this;
        _this._forceResolveButton = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._searchForMoreButton = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._selectedElement = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        /**
         * Returns true if the event was handled, false otherwise
         */
        _this.tryHandleKeyDown = function (keyCode, currentSuggestionIndex) {
            var isEventHandled = false;
            var newSelectedActionType = null;
            var currentSelectedAction = _this.state.selectedActionType;
            var suggestionLength = _this.props.suggestions.length;
            if (keyCode === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].down) {
                switch (currentSelectedAction) {
                    case __WEBPACK_IMPORTED_MODULE_5__Suggestions_types__["a" /* SuggestionActionType */].forceResolve:
                        if (suggestionLength > 0) {
                            _this._refocusOnSuggestions(keyCode);
                            newSelectedActionType = __WEBPACK_IMPORTED_MODULE_5__Suggestions_types__["a" /* SuggestionActionType */].none;
                        }
                        else if (_this._searchForMoreButton.current) {
                            newSelectedActionType = __WEBPACK_IMPORTED_MODULE_5__Suggestions_types__["a" /* SuggestionActionType */].searchMore;
                        }
                        else {
                            newSelectedActionType = __WEBPACK_IMPORTED_MODULE_5__Suggestions_types__["a" /* SuggestionActionType */].forceResolve;
                        }
                        break;
                    case __WEBPACK_IMPORTED_MODULE_5__Suggestions_types__["a" /* SuggestionActionType */].searchMore:
                        if (_this._forceResolveButton.current) {
                            newSelectedActionType = __WEBPACK_IMPORTED_MODULE_5__Suggestions_types__["a" /* SuggestionActionType */].forceResolve;
                        }
                        else if (suggestionLength > 0) {
                            _this._refocusOnSuggestions(keyCode);
                            newSelectedActionType = __WEBPACK_IMPORTED_MODULE_5__Suggestions_types__["a" /* SuggestionActionType */].none;
                        }
                        else {
                            newSelectedActionType = __WEBPACK_IMPORTED_MODULE_5__Suggestions_types__["a" /* SuggestionActionType */].searchMore;
                        }
                        break;
                    case __WEBPACK_IMPORTED_MODULE_5__Suggestions_types__["a" /* SuggestionActionType */].none:
                        if (currentSuggestionIndex === -1 && _this._forceResolveButton.current) {
                            newSelectedActionType = __WEBPACK_IMPORTED_MODULE_5__Suggestions_types__["a" /* SuggestionActionType */].forceResolve;
                        }
                        break;
                }
            }
            else if (keyCode === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].up) {
                switch (currentSelectedAction) {
                    case __WEBPACK_IMPORTED_MODULE_5__Suggestions_types__["a" /* SuggestionActionType */].forceResolve:
                        if (_this._searchForMoreButton.current) {
                            newSelectedActionType = __WEBPACK_IMPORTED_MODULE_5__Suggestions_types__["a" /* SuggestionActionType */].searchMore;
                        }
                        else if (suggestionLength > 0) {
                            _this._refocusOnSuggestions(keyCode);
                            newSelectedActionType = __WEBPACK_IMPORTED_MODULE_5__Suggestions_types__["a" /* SuggestionActionType */].none;
                        }
                        break;
                    case __WEBPACK_IMPORTED_MODULE_5__Suggestions_types__["a" /* SuggestionActionType */].searchMore:
                        if (suggestionLength > 0) {
                            _this._refocusOnSuggestions(keyCode);
                            newSelectedActionType = __WEBPACK_IMPORTED_MODULE_5__Suggestions_types__["a" /* SuggestionActionType */].none;
                        }
                        else if (_this._forceResolveButton.current) {
                            newSelectedActionType = __WEBPACK_IMPORTED_MODULE_5__Suggestions_types__["a" /* SuggestionActionType */].forceResolve;
                        }
                        break;
                    case __WEBPACK_IMPORTED_MODULE_5__Suggestions_types__["a" /* SuggestionActionType */].none:
                        if (currentSuggestionIndex === -1 && _this._searchForMoreButton.current) {
                            newSelectedActionType = __WEBPACK_IMPORTED_MODULE_5__Suggestions_types__["a" /* SuggestionActionType */].searchMore;
                        }
                        break;
                }
            }
            if (newSelectedActionType !== null) {
                _this.setState({ selectedActionType: newSelectedActionType });
                isEventHandled = true;
            }
            return isEventHandled;
        };
        _this._getMoreResults = function () {
            if (_this.props.onGetMoreResults) {
                _this.props.onGetMoreResults();
            }
        };
        _this._forceResolve = function () {
            if (_this.props.createGenericItem) {
                _this.props.createGenericItem();
            }
        };
        _this._shouldShowForceResolve = function () {
            return _this.props.showForceResolve ? _this.props.showForceResolve() : false;
        };
        _this._onClickTypedSuggestionsItem = function (item, index) {
            return function (ev) {
                _this.props.onSuggestionClick(ev, item, index);
            };
        };
        _this._refocusOnSuggestions = function (keyCode) {
            if (typeof _this.props.refocusSuggestions === 'function') {
                _this.props.refocusSuggestions(keyCode);
            }
        };
        _this._onRemoveTypedSuggestionsItem = function (item, index) {
            return function (ev) {
                var onSuggestionRemove = _this.props.onSuggestionRemove;
                onSuggestionRemove(ev, item, index);
                ev.stopPropagation();
            };
        };
        _this.state = {
            selectedActionType: __WEBPACK_IMPORTED_MODULE_5__Suggestions_types__["a" /* SuggestionActionType */].none
        };
        return _this;
    }
    Suggestions.prototype.componentDidMount = function () {
        this.scrollSelected();
        this.activeSelectedElement = this._selectedElement ? this._selectedElement.current : null;
    };
    Suggestions.prototype.componentDidUpdate = function () {
        // Only scroll to selected element if the selected element has changed. Otherwise do nothing.
        // This prevents some odd behavior where scrolling the active element out of view and clicking on a selected element
        // will trigger a focus event and not give the clicked element the click.
        if (this._selectedElement.current && this.activeSelectedElement !== this._selectedElement.current) {
            this.scrollSelected();
            this.activeSelectedElement = this._selectedElement.current;
        }
    };
    Suggestions.prototype.render = function () {
        var _this = this;
        var _a = this.props, forceResolveText = _a.forceResolveText, mostRecentlyUsedHeaderText = _a.mostRecentlyUsedHeaderText, searchForMoreText = _a.searchForMoreText, className = _a.className, moreSuggestionsAvailable = _a.moreSuggestionsAvailable, noResultsFoundText = _a.noResultsFoundText, suggestions = _a.suggestions, isLoading = _a.isLoading, isSearching = _a.isSearching, loadingText = _a.loadingText, onRenderNoResultFound = _a.onRenderNoResultFound, searchingText = _a.searchingText, isMostRecentlyUsedVisible = _a.isMostRecentlyUsedVisible, resultsMaximumNumber = _a.resultsMaximumNumber, resultsFooterFull = _a.resultsFooterFull, resultsFooter = _a.resultsFooter, _b = _a.isResultsFooterVisible, isResultsFooterVisible = _b === void 0 ? true : _b, suggestionsAvailableAlertText = _a.suggestionsAvailableAlertText, suggestionsHeaderText = _a.suggestionsHeaderText, suggestionsClassName = _a.suggestionsClassName, theme = _a.theme, styles = _a.styles;
        // TODO
        // Clean this up by leaving only the first part after removing support for SASS.
        // Currently we can not remove the SASS styles from Suggestions class because it
        // might be used by consumers separately from pickers extending from BasePicker
        // and have not used the new 'styles' prop. Because it's expecting a type parameter,
        // we can not use the 'styled' function without adding some helpers which can break
        // downstream consumers who did not use the new helpers.
        // We check for 'styles' prop which is going to be injected by the 'styled' HOC
        // in BasePicker when the typed Suggestions class is ready to be rendered. If the check
        // passes we can use the CSS-in-JS styles. If the check fails (ex: custom picker),
        // then we just use the old SASS styles instead.
        this._classNames = styles
            ? getClassNames(styles, {
                theme: theme,
                className: className,
                suggestionsClassName: suggestionsClassName,
                forceResolveButtonSelected: this.state.selectedActionType === __WEBPACK_IMPORTED_MODULE_5__Suggestions_types__["a" /* SuggestionActionType */].forceResolve,
                searchForMoreButtonSelected: this.state.selectedActionType === __WEBPACK_IMPORTED_MODULE_5__Suggestions_types__["a" /* SuggestionActionType */].searchMore
            })
            : {
                root: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-Suggestions', className, legacyStyles.root),
                title: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-Suggestions-title', legacyStyles.suggestionsTitle),
                searchForMoreButton: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-SearchMore-button', legacyStyles.actionButton, (_c = {},
                    _c['is-selected ' + legacyStyles.buttonSelected] = this.state.selectedActionType === __WEBPACK_IMPORTED_MODULE_5__Suggestions_types__["a" /* SuggestionActionType */].searchMore,
                    _c)),
                forceResolveButton: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-forceResolve-button', legacyStyles.actionButton, (_d = {},
                    _d['is-selected ' + legacyStyles.buttonSelected] = this.state.selectedActionType === __WEBPACK_IMPORTED_MODULE_5__Suggestions_types__["a" /* SuggestionActionType */].forceResolve,
                    _d)),
                suggestionsAvailable: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-Suggestions-suggestionsAvailable', legacyStyles.suggestionsAvailable),
                suggestionsContainer: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-Suggestions-container', legacyStyles.suggestionsContainer, suggestionsClassName),
                noSuggestions: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-Suggestions-none', legacyStyles.suggestionsNone)
            };
        var spinnerStyles = this._classNames.subComponentStyles
            ? this._classNames.subComponentStyles.spinner
            : undefined;
        // TODO: cleanup after refactor of pickers to composition pattern and remove SASS support.
        var spinnerClassNameOrStyles = styles
            ? { styles: spinnerStyles }
            : { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-Suggestions-spinner', legacyStyles.suggestionsSpinner) };
        var noResults = function () {
            return noResultsFoundText ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { role: "alert", className: _this._classNames.noSuggestions }, noResultsFoundText)) : null;
        };
        // MostRecently Used text should supercede the header text if it's there and available.
        var headerText = suggestionsHeaderText;
        if (isMostRecentlyUsedVisible && mostRecentlyUsedHeaderText) {
            headerText = mostRecentlyUsedHeaderText;
        }
        var footerTitle = undefined;
        if (isResultsFooterVisible) {
            footerTitle = suggestions.length >= resultsMaximumNumber ? resultsFooterFull : resultsFooter;
        }
        var hasNoSuggestions = (!suggestions || !suggestions.length) && !isLoading;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.root },
            headerText ? __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.title }, headerText) : null,
            forceResolveText && this._shouldShowForceResolve() && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Button__["e" /* CommandButton */], { componentRef: this._forceResolveButton, className: this._classNames.forceResolveButton, onClick: this._forceResolve, "data-automationid": 'sug-forceResolve' }, forceResolveText)),
            isLoading && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Spinner__["a" /* Spinner */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, spinnerClassNameOrStyles, { label: loadingText })),
            hasNoSuggestions ? (onRenderNoResultFound ? onRenderNoResultFound(undefined, noResults) : noResults()) : this._renderSuggestions(),
            searchForMoreText && moreSuggestionsAvailable && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Button__["e" /* CommandButton */], { componentRef: this._searchForMoreButton, className: this._classNames.searchForMoreButton, iconProps: { iconName: 'Search' }, onClick: this._getMoreResults }, searchForMoreText)),
            isSearching ? __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Spinner__["a" /* Spinner */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, spinnerClassNameOrStyles, { label: searchingText })) : null,
            footerTitle && !moreSuggestionsAvailable && !isMostRecentlyUsedVisible && !isSearching ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.title }, footerTitle(this.props))) : null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { role: "alert", "aria-live": "polite", className: this._classNames.suggestionsAvailable }, !isLoading && !isSearching && suggestions && suggestions.length > 0 && suggestionsAvailableAlertText
                ? suggestionsAvailableAlertText
                : null)));
        var _c, _d;
    };
    Suggestions.prototype.hasSuggestedAction = function () {
        return this._searchForMoreButton.current !== undefined || this._forceResolveButton.current !== undefined;
    };
    Suggestions.prototype.hasSuggestedActionSelected = function () {
        return this.state.selectedActionType !== __WEBPACK_IMPORTED_MODULE_5__Suggestions_types__["a" /* SuggestionActionType */].none;
    };
    Suggestions.prototype.executeSelectedAction = function () {
        switch (this.state.selectedActionType) {
            case __WEBPACK_IMPORTED_MODULE_5__Suggestions_types__["a" /* SuggestionActionType */].forceResolve:
                this._forceResolve();
                break;
            case __WEBPACK_IMPORTED_MODULE_5__Suggestions_types__["a" /* SuggestionActionType */].searchMore:
                this._getMoreResults();
                break;
        }
    };
    Suggestions.prototype.focusAboveSuggestions = function () {
        if (this._forceResolveButton.current) {
            this.setState({ selectedActionType: __WEBPACK_IMPORTED_MODULE_5__Suggestions_types__["a" /* SuggestionActionType */].forceResolve });
        }
        else if (this._searchForMoreButton.current) {
            this.setState({ selectedActionType: __WEBPACK_IMPORTED_MODULE_5__Suggestions_types__["a" /* SuggestionActionType */].searchMore });
        }
    };
    Suggestions.prototype.focusBelowSuggestions = function () {
        if (this._searchForMoreButton.current) {
            this.setState({ selectedActionType: __WEBPACK_IMPORTED_MODULE_5__Suggestions_types__["a" /* SuggestionActionType */].searchMore });
        }
        else if (this._forceResolveButton.current) {
            this.setState({ selectedActionType: __WEBPACK_IMPORTED_MODULE_5__Suggestions_types__["a" /* SuggestionActionType */].forceResolve });
        }
    };
    Suggestions.prototype.focusSearchForMoreButton = function () {
        if (this._searchForMoreButton.current) {
            this._searchForMoreButton.current.focus();
        }
    };
    // TODO get the element to scroll into view properly regardless of direction.
    Suggestions.prototype.scrollSelected = function () {
        if (this._selectedElement.current && this._selectedElement.current.scrollIntoView !== undefined) {
            this._selectedElement.current.scrollIntoView(false);
        }
    };
    Suggestions.prototype._renderSuggestions = function () {
        var _this = this;
        var _a = this.props, onRenderSuggestion = _a.onRenderSuggestion, removeSuggestionAriaLabel = _a.removeSuggestionAriaLabel, suggestionsItemClassName = _a.suggestionsItemClassName, resultsMaximumNumber = _a.resultsMaximumNumber, showRemoveButtons = _a.showRemoveButtons, suggestionsContainerAriaLabel = _a.suggestionsContainerAriaLabel, suggestionsListId = _a.suggestionsListId;
        var suggestions = this.props.suggestions;
        var StyledTypedSuggestionsItem = StyledSuggestionsItem;
        var selectedIndex = -1;
        suggestions.some(function (element, index) {
            if (element.selected) {
                selectedIndex = index;
                return true;
            }
            return false;
        });
        if (resultsMaximumNumber) {
            suggestions =
                selectedIndex >= resultsMaximumNumber
                    ? suggestions.slice(selectedIndex - resultsMaximumNumber + 1, selectedIndex + 1)
                    : suggestions.slice(0, resultsMaximumNumber);
        }
        if (suggestions.length === 0) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.suggestionsContainer, id: suggestionsListId, role: "listbox", "aria-label": suggestionsContainerAriaLabel }, suggestions.map(function (suggestion, index) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: suggestion.selected ? _this._selectedElement : undefined, 
            // tslint:disable-next-line:no-string-literal
            key: suggestion.item['key'] ? suggestion.item['key'] : index, id: 'sug-' + index, "aria-selected": suggestion.selected, role: "option", "aria-label": suggestion.ariaLabel },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](StyledTypedSuggestionsItem, { suggestionModel: suggestion, RenderSuggestion: onRenderSuggestion, onClick: _this._onClickTypedSuggestionsItem(suggestion.item, index), className: suggestionsItemClassName, showRemoveButton: showRemoveButtons, removeButtonAriaLabel: removeSuggestionAriaLabel, onRemoveItem: _this._onRemoveTypedSuggestionsItem(suggestion.item, index) }))); })));
    };
    return Suggestions;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=Suggestions.js.map

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SuggestionActionType; });
/**
 * Enum to help identify which suggestions action button is selected.
 * {@docCategory Pickers}
 */
var SuggestionActionType;
(function (SuggestionActionType) {
    /** None of the actions is selected. */
    SuggestionActionType[SuggestionActionType["none"] = 0] = "none";
    /** ForceResolve action is selected. */
    SuggestionActionType[SuggestionActionType["forceResolve"] = 1] = "forceResolve";
    /** SearchMore action is selected. */
    SuggestionActionType[SuggestionActionType["searchMore"] = 2] = "searchMore";
})(SuggestionActionType || (SuggestionActionType = {}));
//# sourceMappingURL=Suggestions.types.js.map

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SuggestionsItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Suggestions_scss__ = __webpack_require__(774);





var legacyStyles = __WEBPACK_IMPORTED_MODULE_4__Suggestions_scss__;
var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
/**
 * {@docCategory Pickers}
 */
var SuggestionsItem = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](SuggestionsItem, _super);
    function SuggestionsItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SuggestionsItem.prototype.render = function () {
        var _a = this.props, suggestionModel = _a.suggestionModel, RenderSuggestion = _a.RenderSuggestion, onClick = _a.onClick, className = _a.className, onRemoveItem = _a.onRemoveItem, isSelectedOverride = _a.isSelectedOverride, removeButtonAriaLabel = _a.removeButtonAriaLabel, styles = _a.styles, theme = _a.theme;
        // TODO
        // Clean this up by leaving only the first part after removing support for SASS.
        // Currently we can not remove the SASS styles from SuggestionsItem class because it
        // might be used by consumers separately from pickers extending from BasePicker
        // and have not used the new 'styles' prop. Because it's expecting a type parameter,
        // we can not use the 'styled' function without adding some helpers which can break
        // downstream consumers who did not use the new helpers.
        // We check for 'styles' prop which is going to be injected by the 'styled' HOC
        // in Suggestions when the typed SuggestionsItem class is ready to be rendered. If the
        // check passes we can use the CSS-in-JS styles. If the check fails (ex: custom picker),
        // then we just use the old SASS styles instead.
        var classNames = styles
            ? getClassNames(styles, {
                theme: theme,
                className: className,
                suggested: suggestionModel.selected || isSelectedOverride
            })
            : {
                root: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-Suggestions-item', legacyStyles.suggestionsItem, (_b = {},
                    _b['is-suggested ' + legacyStyles.suggestionsItemIsSuggested] = suggestionModel.selected || isSelectedOverride,
                    _b), className),
                itemButton: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-Suggestions-itemButton', legacyStyles.itemButton),
                closeButton: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-Suggestions-closeButton', legacyStyles.closeButton)
            };
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.root },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Button__["e" /* CommandButton */], { onClick: onClick, className: classNames.itemButton }, RenderSuggestion(suggestionModel.item, this.props)),
            this.props.showRemoveButton ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Button__["g" /* IconButton */], { iconProps: { iconName: 'Cancel', styles: { root: { fontSize: '12px' } } }, title: removeButtonAriaLabel, ariaLabel: removeButtonAriaLabel, onClick: onRemoveItem, className: classNames.closeButton })) : null));
        var _b;
    };
    return SuggestionsItem;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=SuggestionsItem.js.map

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "root", function() { return root; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "suggestionsItem", function() { return suggestionsItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "closeButton", function() { return closeButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "suggestionsItemIsSuggested", function() { return suggestionsItemIsSuggested; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "itemButton", function() { return itemButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actionButton", function() { return actionButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "buttonSelected", function() { return buttonSelected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "suggestionsTitle", function() { return suggestionsTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "suggestionsContainer", function() { return suggestionsContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "suggestionsNone", function() { return suggestionsNone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "suggestionsSpinner", function() { return suggestionsSpinner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "suggestionsAvailable", function() { return suggestionsAvailable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_load_themed_styles__ = __webpack_require__(67);
/* tslint:disable */

Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_load_themed_styles__["a" /* loadStyles */])([{ "rawString": ".root_18d80577{min-width:260px}.suggestionsItem_18d80577{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;-webkit-box-sizing:border-box;box-sizing:border-box;width:100%;position:relative;overflow:hidden}.suggestionsItem_18d80577:hover{background:" }, { "theme": "neutralLighter", "defaultValue": "#f4f4f4" }, { "rawString": "}.suggestionsItem_18d80577:hover .closeButton_18d80577{display:block}.suggestionsItem_18d80577.suggestionsItemIsSuggested_18d80577{background:" }, { "theme": "neutralLight", "defaultValue": "#eaeaea" }, { "rawString": "}.suggestionsItem_18d80577.suggestionsItemIsSuggested_18d80577:hover{background:" }, { "theme": "neutralTertiaryAlt", "defaultValue": "#c8c8c8" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.suggestionsItem_18d80577.suggestionsItemIsSuggested_18d80577:hover{background:Highlight;color:HighlightText}}@media screen and (-ms-high-contrast: active){.suggestionsItem_18d80577.suggestionsItemIsSuggested_18d80577{background:Highlight;color:HighlightText;-ms-high-contrast-adjust:none}}.suggestionsItem_18d80577.suggestionsItemIsSuggested_18d80577 .closeButton_18d80577:hover{background:" }, { "theme": "neutralTertiary", "defaultValue": "#a6a6a6" }, { "rawString": ";color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.suggestionsItem_18d80577.suggestionsItemIsSuggested_18d80577 .itemButton_18d80577{color:HighlightText}}.suggestionsItem_18d80577 .closeButton_18d80577{display:none;color:" }, { "theme": "neutralSecondary", "defaultValue": "#666666" }, { "rawString": "}.suggestionsItem_18d80577 .closeButton_18d80577:hover{background:" }, { "theme": "neutralLight", "defaultValue": "#eaeaea" }, { "rawString": "}.actionButton_18d80577{background:none;background-color:transparent;border:0;cursor:pointer;margin:0;position:relative;border-top:1px solid " }, { "theme": "neutralLight", "defaultValue": "#eaeaea" }, { "rawString": ";height:40px;width:100%;font-size:12px}[dir='ltr'] .actionButton_18d80577{padding-left:8px}[dir='rtl'] .actionButton_18d80577{padding-right:8px}html[dir='ltr'] .actionButton_18d80577{text-align:left}html[dir='rtl'] .actionButton_18d80577{text-align:right}.actionButton_18d80577:hover{background-color:" }, { "theme": "neutralLight", "defaultValue": "#eaeaea" }, { "rawString": ";cursor:pointer}.actionButton_18d80577:focus,.actionButton_18d80577:active{background-color:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": "}.actionButton_18d80577 .ms-Button-icon{font-size:16px;width:25px}.actionButton_18d80577 .ms-Button-label{margin:0 4px 0 9px}html[dir='rtl'] .actionButton_18d80577 .ms-Button-label{margin:0 9px 0 4px}.buttonSelected_18d80577{background-color:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": "}.suggestionsTitle_18d80577{padding:0 12px;color:" }, { "theme": "themePrimary", "defaultValue": "#0078d4" }, { "rawString": ";font-size:12px;line-height:40px;border-bottom:1px solid " }, { "theme": "neutralLight", "defaultValue": "#eaeaea" }, { "rawString": "}.suggestionsContainer_18d80577{overflow-y:auto;overflow-x:hidden;max-height:300px;border-bottom:1px solid " }, { "theme": "neutralLight", "defaultValue": "#eaeaea" }, { "rawString": "}.suggestionsNone_18d80577{text-align:center;color:#767676;font-size:12px;line-height:30px}.suggestionsSpinner_18d80577{margin:5px 0;white-space:nowrap;line-height:20px;font-size:12px}html[dir='ltr'] .suggestionsSpinner_18d80577{padding-left:14px}html[dir='rtl'] .suggestionsSpinner_18d80577{padding-right:14px}html[dir='ltr'] .suggestionsSpinner_18d80577{text-align:left}html[dir='rtl'] .suggestionsSpinner_18d80577{text-align:right}.suggestionsSpinner_18d80577 .ms-Spinner-circle{display:inline-block;vertical-align:middle}.suggestionsSpinner_18d80577 .ms-Spinner-label{display:inline-block;margin:0px 10px 0 16px;vertical-align:middle}html[dir='rtl'] .suggestionsSpinner_18d80577 .ms-Spinner-label{margin:0px 16px 0 10px}.itemButton_18d80577.itemButton_18d80577{width:100%;padding:0px;min-width:0;height:100%}@media screen and (-ms-high-contrast: active){.itemButton_18d80577.itemButton_18d80577{color:WindowText}}.itemButton_18d80577.itemButton_18d80577:hover{color:" }, { "theme": "neutralDark", "defaultValue": "#212121" }, { "rawString": "}.closeButton_18d80577.closeButton_18d80577{padding:0 4px;height:auto;width:32px}@media screen and (-ms-high-contrast: active){.closeButton_18d80577.closeButton_18d80577{color:WindowText}}.closeButton_18d80577.closeButton_18d80577:hover{background:" }, { "theme": "neutralTertiaryAlt", "defaultValue": "#c8c8c8" }, { "rawString": ";color:" }, { "theme": "neutralDark", "defaultValue": "#212121" }, { "rawString": "}.suggestionsAvailable_18d80577{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);border:0}\n" }]);
var root = "root_18d80577";
var suggestionsItem = "suggestionsItem_18d80577";
var closeButton = "closeButton_18d80577";
var suggestionsItemIsSuggested = "suggestionsItemIsSuggested_18d80577";
var itemButton = "itemButton_18d80577";
var actionButton = "actionButton_18d80577";
var buttonSelected = "buttonSelected_18d80577";
var suggestionsTitle = "suggestionsTitle_18d80577";
var suggestionsContainer = "suggestionsContainer_18d80577";
var suggestionsNone = "suggestionsNone_18d80577";
var suggestionsSpinner = "suggestionsSpinner_18d80577";
var suggestionsAvailable = "suggestionsAvailable_18d80577";
//# sourceMappingURL=Suggestions.scss.js.map

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SuggestionsItemGlobalClassNames; });
/* harmony export (immutable) */ __webpack_exports__["b"] = getStyles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var SuggestionsItemGlobalClassNames = {
    root: 'ms-Suggestions-item',
    itemButton: 'ms-Suggestions-itemButton',
    closeButton: 'ms-Suggestions-closeButton',
    isSuggested: 'is-suggested'
};
function getStyles(props) {
    var className = props.className, theme = props.theme, suggested = props.suggested;
    var palette = theme.palette;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(SuggestionsItemGlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            {
                display: 'flex',
                alignItems: 'stretch',
                boxSizing: 'border-box',
                width: '100%',
                position: 'relative',
                selectors: {
                    '&:hover': {
                        background: palette.neutralLighter
                    },
                    '&:hover .ms-Suggestions-closeButton': {
                        display: 'block'
                    }
                }
            },
            className
        ],
        itemButton: [
            classNames.itemButton,
            {
                width: '100%',
                padding: 0,
                border: 'none',
                height: '100%',
                // Force the item button to be collapsible so it can always shrink
                // to accommodate the close button as a peer in its flex container.
                minWidth: 0,
                // Require for IE11 to truncate the component.
                overflow: 'hidden',
                selectors: (_a = {},
                    _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        color: 'WindowText',
                        selectors: {
                            ':hover': {
                                background: 'Highlight',
                                color: 'HighlightText',
                                MsHighContrastAdjust: 'none'
                            }
                        }
                    },
                    _a[':hover'] = {
                        color: palette.neutralDark
                    },
                    _a)
            },
            suggested && [
                classNames.isSuggested,
                {
                    background: palette.neutralLight,
                    selectors: (_b = {
                            ':hover': {
                                background: palette.neutralTertiaryAlt
                            }
                        },
                        _b[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                            background: 'Highlight',
                            color: 'HighlightText',
                            MsHighContrastAdjust: 'none'
                        },
                        _b)
                }
            ]
        ],
        closeButton: [
            classNames.closeButton,
            {
                display: 'none',
                color: palette.neutralSecondary,
                padding: '0 4px',
                height: 'auto',
                width: 32,
                selectors: (_c = {
                        ':hover, :active': {
                            background: palette.neutralTertiaryAlt,
                            color: palette.neutralDark
                        }
                    },
                    _c[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        color: 'WindowText'
                    },
                    _c)
            },
            suggested && {
                selectors: {
                    ':hover, :active': {
                        background: palette.neutralTertiary,
                        color: palette.neutralPrimary
                    }
                }
            }
        ]
    };
    var _a, _b, _c;
}
//# sourceMappingURL=SuggestionsItem.styles.js.map

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SuggestionsController; });
/**
 * {@docCategory Pickers}
 */
var SuggestionsController = /** @class */ (function () {
    function SuggestionsController() {
        var _this = this;
        this._isSuggestionModel = function (value) {
            return value.item !== undefined;
        };
        this._ensureSuggestionModel = function (suggestion) {
            if (_this._isSuggestionModel(suggestion)) {
                return suggestion;
            }
            else {
                return {
                    item: suggestion,
                    selected: false,
                    ariaLabel: suggestion.name || suggestion.primaryText
                };
            }
        };
        this.suggestions = [];
        this.currentIndex = -1;
    }
    SuggestionsController.prototype.updateSuggestions = function (newSuggestions, selectedIndex) {
        if (newSuggestions && newSuggestions.length > 0) {
            this.suggestions = this.convertSuggestionsToSuggestionItems(newSuggestions);
            this.currentIndex = selectedIndex ? selectedIndex : 0;
            if (selectedIndex === -1) {
                this.currentSuggestion = undefined;
            }
            else if (selectedIndex !== undefined) {
                this.suggestions[selectedIndex].selected = true;
                this.currentSuggestion = this.suggestions[selectedIndex];
            }
        }
        else {
            this.suggestions = [];
            this.currentIndex = -1;
            this.currentSuggestion = undefined;
        }
    };
    /**
     * Increments the suggestion index and gets the next suggestion in the list.
     */
    SuggestionsController.prototype.nextSuggestion = function () {
        if (this.suggestions && this.suggestions.length) {
            if (this.currentIndex < this.suggestions.length - 1) {
                this.setSelectedSuggestion(this.currentIndex + 1);
                return true;
            }
            else if (this.currentIndex === this.suggestions.length - 1) {
                this.setSelectedSuggestion(0);
                return true;
            }
        }
        return false;
    };
    /**
     * Decrements the suggestion index and gets the previous suggestion in the list.
     */
    SuggestionsController.prototype.previousSuggestion = function () {
        if (this.suggestions && this.suggestions.length) {
            if (this.currentIndex > 0) {
                this.setSelectedSuggestion(this.currentIndex - 1);
                return true;
            }
            else if (this.currentIndex === 0) {
                this.setSelectedSuggestion(this.suggestions.length - 1);
                return true;
            }
        }
        return false;
    };
    SuggestionsController.prototype.getSuggestions = function () {
        return this.suggestions;
    };
    SuggestionsController.prototype.getCurrentItem = function () {
        return this.currentSuggestion;
    };
    SuggestionsController.prototype.getSuggestionAtIndex = function (index) {
        return this.suggestions[index];
    };
    SuggestionsController.prototype.hasSelectedSuggestion = function () {
        return this.currentSuggestion ? true : false;
    };
    SuggestionsController.prototype.removeSuggestion = function (index) {
        this.suggestions.splice(index, 1);
    };
    SuggestionsController.prototype.createGenericSuggestion = function (itemToConvert) {
        var itemToAdd = this.convertSuggestionsToSuggestionItems([itemToConvert])[0];
        this.currentSuggestion = itemToAdd;
    };
    SuggestionsController.prototype.convertSuggestionsToSuggestionItems = function (suggestions) {
        return Array.isArray(suggestions) ? suggestions.map(this._ensureSuggestionModel) : [];
    };
    SuggestionsController.prototype.deselectAllSuggestions = function () {
        if (this.currentIndex > -1) {
            this.suggestions[this.currentIndex].selected = false;
            this.currentIndex = -1;
        }
    };
    SuggestionsController.prototype.setSelectedSuggestion = function (index) {
        if (index > this.suggestions.length - 1 || index < 0) {
            this.currentIndex = 0;
            this.currentSuggestion.selected = false;
            this.currentSuggestion = this.suggestions[0];
            this.currentSuggestion.selected = true;
        }
        else {
            if (this.currentIndex > -1) {
                this.suggestions[this.currentIndex].selected = false;
            }
            this.suggestions[index].selected = true;
            this.currentIndex = index;
            this.currentSuggestion = this.suggestions[index];
        }
    };
    return SuggestionsController;
}());

//# sourceMappingURL=SuggestionsController.js.map

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PeoplePickerItemBase */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PeoplePickerItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Persona__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BasePicker_types__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PeoplePickerItem_styles__ = __webpack_require__(1936);







var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var PeoplePickerItemBase = function (props) {
    var item = props.item, onRemoveItem = props.onRemoveItem, index = props.index, selected = props.selected, removeButtonAriaLabel = props.removeButtonAriaLabel, styles = props.styles, theme = props.theme, className = props.className, disabled = props.disabled;
    var itemId = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["N" /* getId */])();
    var classNames = getClassNames(styles, {
        theme: theme,
        className: className,
        selected: selected,
        disabled: disabled,
        invalid: item.ValidationState === __WEBPACK_IMPORTED_MODULE_5__BasePicker_types__["a" /* ValidationState */].warning
    });
    var personaStyles = classNames.subComponentStyles
        ? classNames.subComponentStyles.persona
        : undefined;
    var personaCoinStyles = classNames.subComponentStyles
        ? classNames.subComponentStyles.personaCoin
        : undefined;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.root, "data-is-focusable": !disabled, "data-is-sub-focuszone": true, "data-selection-index": index, role: 'listitem', "aria-labelledby": 'selectedItemPersona-' + itemId },
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.itemContent, id: 'selectedItemPersona-' + itemId },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Persona__["a" /* Persona */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ size: __WEBPACK_IMPORTED_MODULE_3__Persona__["d" /* PersonaSize */].size24, styles: personaStyles, coinProps: { styles: personaCoinStyles } }, item))),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Button__["g" /* IconButton */], { onClick: onRemoveItem, disabled: disabled, iconProps: { iconName: 'Cancel', styles: { root: { fontSize: '12px' } } }, className: classNames.removeButton, ariaLabel: removeButtonAriaLabel })));
};
var PeoplePickerItem = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_29" /* styled */])(PeoplePickerItemBase, __WEBPACK_IMPORTED_MODULE_6__PeoplePickerItem_styles__["a" /* getStyles */], undefined, { scope: 'PeoplePickerItem' });
//# sourceMappingURL=PeoplePickerItem.js.map

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PeoplePickerItemSuggestionBase */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PeoplePickerItemSuggestion; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Persona__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PeoplePickerItemSuggestion_styles__ = __webpack_require__(1937);





var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var PeoplePickerItemSuggestionBase = function (props) {
    var personaProps = props.personaProps, suggestionsProps = props.suggestionsProps, compact = props.compact, styles = props.styles, theme = props.theme, className = props.className;
    var classNames = getClassNames(styles, {
        theme: theme,
        className: (suggestionsProps && suggestionsProps.suggestionsItemClassName) || className
    });
    var personaStyles = classNames.subComponentStyles && classNames.subComponentStyles.persona
        ? classNames.subComponentStyles.persona
        : undefined;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.root },
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Persona__["a" /* Persona */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ size: __WEBPACK_IMPORTED_MODULE_3__Persona__["d" /* PersonaSize */].size24, styles: personaStyles, className: classNames.personaWrapper, showSecondaryText: !compact }, personaProps))));
};
var PeoplePickerItemSuggestion = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_29" /* styled */])(PeoplePickerItemSuggestionBase, __WEBPACK_IMPORTED_MODULE_4__PeoplePickerItemSuggestion_styles__["a" /* getStyles */], undefined, { scope: 'PeoplePickerItemSuggestion' });
//# sourceMappingURL=PeoplePickerItemSuggestion.js.map

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStyles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var GlobalClassNames = {
    root: 'ms-BasePicker',
    text: 'ms-BasePicker-text',
    itemsWrapper: 'ms-BasePicker-itemsWrapper',
    input: 'ms-BasePicker-input'
};
function getStyles(props) {
    var className = props.className, theme = props.theme, isFocused = props.isFocused, inputClassName = props.inputClassName, disabled = props.disabled;
    if (!theme) {
        throw new Error('theme is undefined or null in base BasePicker getStyles function.');
    }
    var semanticColors = theme.semanticColors;
    var inputBorder = semanticColors.inputBorder, inputBorderHovered = semanticColors.inputBorderHovered, inputFocusBorderAlt = semanticColors.inputFocusBorderAlt;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    // The following lines are to create a semi-transparent color overlay for the disabled state with designer's approval.
    // @todo: investigate the performance cost of the calculation below and apply if negligible. Replacing with a static color for now.
    // const rgbColor: IRGB | undefined = cssColor(palette.neutralQuaternaryAlt);
    // const disabledOverlayColor = rgbColor ? `rgba(${rgbColor.r}, ${rgbColor.g}, ${rgbColor.b}, 0.29)` : 'transparent';
    var disabledOverlayColor = 'rgba(218, 218, 218, 0.29)';
    return {
        root: [classNames.root, className],
        text: [
            classNames.text,
            {
                display: 'flex',
                position: 'relative',
                flexWrap: 'wrap',
                alignItems: 'center',
                boxSizing: 'border-box',
                minWidth: 180,
                minHeight: 30,
                border: "1px solid " + inputBorder
            },
            !isFocused &&
                !disabled && {
                selectors: {
                    ':hover': {
                        borderColor: inputBorderHovered
                    }
                }
            },
            isFocused &&
                !disabled && {
                borderColor: inputFocusBorderAlt
            },
            disabled && {
                borderColor: 'transparent',
                selectors: (_a = {
                        ':after': {
                            content: '""',
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0,
                            background: disabledOverlayColor
                        }
                    },
                    _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        borderColor: 'GrayText',
                        selectors: {
                            ':after': {
                                background: 'none'
                            }
                        }
                    },
                    _a)
            }
        ],
        itemsWrapper: [
            classNames.itemsWrapper,
            {
                display: 'flex',
                flexWrap: 'wrap',
                maxWidth: '100%'
            }
        ],
        input: [
            classNames.input,
            {
                height: 30,
                border: 'none',
                flexGrow: 1,
                outline: 'none',
                padding: '0 6px 0',
                alignSelf: 'flex-end',
                selectors: {
                    '::-ms-clear': {
                        display: 'none'
                    }
                }
            },
            inputClassName
        ],
        screenReaderText: __WEBPACK_IMPORTED_MODULE_0__Styling__["B" /* hiddenContentStyle */]
    };
    var _a;
}
//# sourceMappingURL=BasePicker.styles.js.map

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TagItemBase */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TagItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TagItem_styles__ = __webpack_require__(1939);




var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["r" /* classNamesFunction */])();
/**
 * {@docCategory TagPicker}
 */
var TagItemBase = function (props) {
    var theme = props.theme, styles = props.styles, selected = props.selected, disabled = props.disabled, enableTagFocusInDisabledPicker = props.enableTagFocusInDisabledPicker, children = props.children, className = props.className, index = props.index, onRemoveItem = props.onRemoveItem, removeButtonAriaLabel = props.removeButtonAriaLabel;
    var classNames = getClassNames(styles, {
        theme: theme,
        className: className,
        selected: selected,
        disabled: disabled
    });
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames.root, role: 'listitem', key: index, "data-selection-index": index, "data-is-focusable": (enableTagFocusInDisabledPicker || !disabled) && true },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: classNames.text, "aria-label": children }, children),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Button__["g" /* IconButton */], { onClick: onRemoveItem, disabled: disabled, iconProps: { iconName: 'Cancel', styles: { root: { fontSize: '12px' } } }, className: classNames.close, ariaLabel: removeButtonAriaLabel })));
};
var TagItem = Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["_29" /* styled */])(TagItemBase, __WEBPACK_IMPORTED_MODULE_3__TagItem_styles__["a" /* getStyles */], undefined, { scope: 'TagItem' });
//# sourceMappingURL=TagItem.js.map

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TagItemSuggestionBase */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TagItemSuggestion; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TagItemSuggestion_styles__ = __webpack_require__(1940);



var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["r" /* classNamesFunction */])();
/**
 * {@docCategory TagPicker}
 */
var TagItemSuggestionBase = function (props) {
    var styles = props.styles, theme = props.theme, children = props.children;
    var classNames = getClassNames(styles, {
        theme: theme
    });
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: classNames.suggestionTextOverflow },
        " ",
        children,
        " ");
};
var TagItemSuggestion = Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["_29" /* styled */])(TagItemSuggestionBase, __WEBPACK_IMPORTED_MODULE_2__TagItemSuggestion_styles__["a" /* getStyles */], undefined, { scope: 'TagItemSuggestion' });
//# sourceMappingURL=TagItemSuggestion.js.map

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export resultContent */
/* unused harmony export resultItem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return peoplePickerPersona; });
/* unused harmony export peoplePicker */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return peoplePickerPersonaContent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_load_themed_styles__ = __webpack_require__(67);
/* tslint:disable */

Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_load_themed_styles__["a" /* loadStyles */])([{ "rawString": ".resultContent_77ff388a{display:table-row}.resultContent_77ff388a .resultItem_77ff388a{display:table-cell;vertical-align:bottom}.peoplePickerPersona_77ff388a{width:180px}.peoplePickerPersona_77ff388a .ms-Persona-details{width:100%}.peoplePicker_77ff388a .ms-BasePicker-text{min-height:40px}.peoplePickerPersonaContent_77ff388a{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:7px 12px}\n" }]);
var resultContent = "resultContent_77ff388a";
var resultItem = "resultItem_77ff388a";
var peoplePickerPersona = "peoplePickerPersona_77ff388a";
var peoplePicker = "peoplePicker_77ff388a";
var peoplePickerPersonaContent = "peoplePickerPersonaContent_77ff388a";
//# sourceMappingURL=PeoplePicker.scss.js.map

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = withSlots;
/* harmony export (immutable) */ __webpack_exports__["a"] = createFactory;
/* harmony export (immutable) */ __webpack_exports__["b"] = getSlots;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__uifabric_styling__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__uifabric_utilities__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities__ = __webpack_require__(784);





// TODO: Is getting only div props for 'root' slots is pretty limiting? Or is it exactly as it needs to be?
//        Another example is getting Toggle state for `label` slot render functions. Should it get Toggle props instead?
//        Needs more usage to rationalize the best approach. If we want component props, component props are passed
//        as each slot as rendered and aren't available when getSlots is called. This would substantially change this approach.
/**
 * This function is required for any module that uses slots.
 *
 * This function is a slot resolver that automatically evaluates slot functions to generate React elements.
 * A byproduct of this resolver is that it removes slots from the React hierarchy by bypassing React.createElement.
 *
 * To use this function on a per-file basis, use the jsx directive targeting withSlots.
 * This directive must be the FIRST LINE in the file to work correctly.
 * Usage of this pragma also requires withSlots import statement.
 *
 * See React.createElement
 */
// Can't use typeof on React.createElement since it's overloaded. Approximate createElement's signature for now and widen as needed.
function withSlots(type, props) {
    // tslint:disable-next-line:missing-optional-annotation
    var children = [];
    for (
    // tslint:disable-next-line:missing-optional-annotation
    var _i = 2; 
    // tslint:disable-next-line:missing-optional-annotation
    _i < arguments.length; 
    // tslint:disable-next-line:missing-optional-annotation
    _i++) {
        // tslint:disable-next-line:missing-optional-annotation
        children[_i - 2] = arguments[_i];
    }
    var slotType = type;
    if (slotType.isSlot) {
        // TODO: There is something weird going on here with children embedded in props vs. rest args.
        // Comment out these lines to see. Make sure this function is doing the right things.
        var numChildren = __WEBPACK_IMPORTED_MODULE_1_react__["Children"].count(children);
        if (numChildren === 0) {
            return slotType(props);
        }
        // Since we are bypassing createElement, use React.Children.toArray to make sure children are properly assigned keys.
        // TODO: should this be mutating? does React mutate children subprop with createElement?
        // TODO: will toArray clobber existing keys?
        // TODO: React generates warnings because it doesn't detect hidden member _store that is set in createElement.
        //        Even children passed to createElement without keys don't generate this warning.
        //        Is there a better way to prevent slots from appearing in hierarchy? toArray doesn't address root issue.
        children = __WEBPACK_IMPORTED_MODULE_1_react__["Children"].toArray(children);
        return slotType(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, props, { children: children }));
    }
    else {
        // TODO: Are there some cases where children should NOT be spread? Also, spreading reraises perf question.
        //        Children had to be spread to avoid breaking KeytipData in Toggle.view:
        //        react-dom.development.js:18931 Uncaught TypeError: children is not a function
        //        Without spread, function child is a child array of one element
        // TODO: is there a reason this can't be:
        // return React.createElement.apply(this, arguments);
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"].apply(__WEBPACK_IMPORTED_MODULE_1_react__, [type, props].concat(children));
    }
}
/**
 * This function creates factories that render ouput depending on the user ISlotProp props passed in.
 * @param ComponentType - Base component to render when not overridden by user props.
 * @param options - Factory options, including defaultProp value for shorthand prop mapping.
 * @returns ISlotFactory function used for rendering slots.
 */
function createFactory(ComponentType, options) {
    if (options === void 0) { options = {}; }
    var _a = options.defaultProp, defaultProp = _a === void 0 ? 'children' : _a;
    var result = function (componentProps, userProps, defaultStyles) {
        // If they passed in raw JSX, just return that.
        if (__WEBPACK_IMPORTED_MODULE_1_react__["isValidElement"](userProps)) {
            return userProps;
        }
        // If we're rendering a function, let the user resolve how to render given the original component and final args.
        if (typeof userProps === 'function') {
            var render = function (slotRenderFunction, renderProps) {
                // TODO: _translateShorthand is returning TProps, so why is the finalProps cast required?
                // TS isn't respecting the difference between props arg type and return type and instead treating both as ISlotPropValue.
                var finalRenderProps = _translateShorthand(defaultProp, renderProps);
                finalRenderProps = _constructFinalProps(defaultStyles, componentProps, finalRenderProps);
                return slotRenderFunction(ComponentType, finalRenderProps);
            };
            return userProps(render);
        }
        userProps = _translateShorthand(defaultProp, userProps);
        // TODO: _translateShorthand is returning TProps, so why is the finalProps cast required?
        // TS isn't respecting the difference between props arg type and return type and instead treating both as ISlotPropValue.
        var finalProps = _constructFinalProps(defaultStyles, componentProps, userProps);
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ComponentType, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, finalProps));
    };
    return result;
}
/**
 * Default factory for components without explicit factories.
 */
var defaultFactory = Object(__WEBPACK_IMPORTED_MODULE_3__uifabric_utilities__["_23" /* memoizeFunction */])(function (type) { return createFactory(type); });
/**
 * This function generates slots that can be used in JSX given a definition of slots and their corresponding types.
 * @param userProps - Props as pass to component.
 * @param slots - Slot definition object defining the default slot component for each slot.
 * @returns A set of created slots that components can render in JSX.
 */
function getSlots(userProps, slots) {
    var result = {};
    // userProps already has default props mixed in by createComponent. Recast here to gain typing for this function.
    var mixedProps = userProps;
    var _loop_1 = function (name_1) {
        if (slots.hasOwnProperty(name_1)) {
            // This closure method requires the use of withSlots to prevent unnecessary rerenders. This is because React detects
            //  each closure as a different component (since it is a new instance) from the previous one and then forces a rerender of the entire
            //  slot subtree. For now, the only way to avoid this is to use withSlots, which bypasses the call to React.createElement.
            var slot = function (componentProps) {
                var args = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    args[_i - 1] = arguments[_i];
                }
                if (args.length > 0) {
                    // If React.createElement is being incorrectly used with slots, there will be additional arguments.
                    // We can detect these additional arguments and error on their presence.
                    throw new Error('Any module using getSlots must use withSlots. Please see withSlots javadoc for more info.');
                }
                return _renderSlot(slots[name_1], 
                // TODO: this cast to any is hiding a relationship issue between the first two args
                componentProps, mixedProps[name_1], 
                // _defaultStyles should always be present, but a check for existence is added to make view tests easier to use.
                mixedProps._defaultStyles && mixedProps._defaultStyles[name_1]);
            };
            slot.isSlot = true;
            result[name_1] = slot;
        }
    };
    for (var name_1 in slots) {
        _loop_1(name_1);
    }
    return result;
}
/**
 * Helper function that constructs a props object when given shorthand props.
 */
function _translateShorthand(defaultProp, props) {
    if (typeof props === 'string' || typeof props === 'number' || typeof props === 'boolean') {
        props = (_a = {},
            _a[defaultProp] = props,
            _a);
    }
    return props;
    var _a;
}
/**
 * Helper function that constructs final styles and props given a series of props ordered by increasing priority.
 */
function _constructFinalProps(defaultStyles) {
    var allProps = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        allProps[_i - 1] = arguments[_i];
    }
    var finalProps = {};
    var classNames = [];
    for (var _a = 0, allProps_1 = allProps; _a < allProps_1.length; _a++) {
        var props = allProps_1[_a];
        classNames.push(props && props.className);
        __WEBPACK_IMPORTED_MODULE_4__utilities__["a" /* assign */].apply(void 0, [finalProps].concat(props));
    }
    finalProps.className = Object(__WEBPACK_IMPORTED_MODULE_2__uifabric_styling__["G" /* mergeStyles */])(defaultStyles, classNames);
    return finalProps;
}
/**
 * Render a slot given component and user props. Uses component factory if available, otherwise falls back
 * to default factory.
 * @param ComponentType Factory component type.
 * @param componentProps The properties passed into slot from within the component.
 * @param userProps The user properties passed in from outside of the component.
 */
function _renderSlot(ComponentType, componentProps, userProps, defaultStyles) {
    if (ComponentType.create !== undefined) {
        return ComponentType.create(componentProps, userProps, defaultStyles);
    }
    else {
        return defaultFactory(ComponentType)(componentProps, userProps, defaultStyles);
    }
}
//# sourceMappingURL=slots.js.map

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return assign; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);

var assign = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */];
//# sourceMappingURL=utilities.js.map

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Grid; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Grid_base__ = __webpack_require__(1952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Grid_styles__ = __webpack_require__(1953);



var Grid = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__Grid_base__["a" /* GridBase */], __WEBPACK_IMPORTED_MODULE_2__Grid_styles__["a" /* getStyles */]);
//# sourceMappingURL=Grid.js.map

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GridCell; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Button__ = __webpack_require__(10);




var GridCell = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](GridCell, _super);
    function GridCell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onClick = function () {
            var _a = _this.props, onClick = _a.onClick, disabled = _a.disabled, item = _a.item;
            if (onClick && !disabled) {
                onClick(item);
            }
        };
        _this._onMouseEnter = function (ev) {
            var _a = _this.props, onHover = _a.onHover, disabled = _a.disabled, item = _a.item, onMouseEnter = _a.onMouseEnter;
            var didUpdateOnEnter = onMouseEnter && onMouseEnter(ev);
            if (!didUpdateOnEnter && onHover && !disabled) {
                onHover(item);
            }
        };
        _this._onMouseMove = function (ev) {
            var _a = _this.props, onHover = _a.onHover, disabled = _a.disabled, item = _a.item, onMouseMove = _a.onMouseMove;
            var didUpdateOnMove = onMouseMove && onMouseMove(ev);
            if (!didUpdateOnMove && onHover && !disabled) {
                onHover(item);
            }
        };
        _this._onMouseLeave = function (ev) {
            var _a = _this.props, onHover = _a.onHover, disabled = _a.disabled, onMouseLeave = _a.onMouseLeave;
            var didUpdateOnLeave = onMouseLeave && onMouseLeave(ev);
            if (!didUpdateOnLeave && onHover && !disabled) {
                onHover();
            }
        };
        _this._onFocus = function () {
            var _a = _this.props, onFocus = _a.onFocus, disabled = _a.disabled, item = _a.item;
            if (onFocus && !disabled) {
                onFocus(item);
            }
        };
        return _this;
    }
    GridCell.prototype.render = function () {
        var _a = this.props, item = _a.item, id = _a.id, className = _a.className, role = _a.role, selected = _a.selected, disabled = _a.disabled, onRenderItem = _a.onRenderItem, cellDisabledStyle = _a.cellDisabledStyle, cellIsSelectedStyle = _a.cellIsSelectedStyle, index = _a.index, label = _a.label, getClassNames = _a.getClassNames;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Button__["e" /* CommandButton */], { id: id, "data-index": index, "data-is-focusable": true, disabled: disabled, className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])(className, (_b = {},
                _b['' + cellIsSelectedStyle] = selected,
                _b['' + cellDisabledStyle] = disabled,
                _b)), onClick: this._onClick, onMouseEnter: this._onMouseEnter, onMouseMove: this._onMouseMove, onMouseLeave: this._onMouseLeave, onFocus: this._onFocus, role: role, "aria-selected": selected, ariaLabel: label, title: label, getClassNames: getClassNames }, onRenderItem(item)));
        var _b;
    };
    GridCell.defaultProps = {
        disabled: false,
        id: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["N" /* getId */])('gridCell')
    };
    return GridCell;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=GridCell.js.map

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HoverCardBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HoverCard_types__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ExpandingCard__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ExpandingCard_types__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PlainCard_PlainCard__ = __webpack_require__(792);







var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var HoverCardBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](HoverCardBase, _super);
    // Constructor
    function HoverCardBase(props) {
        var _this = _super.call(this, props) || this;
        // The wrapping div that gets the hover events
        _this._hoverCard = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["s" /* createRef */])();
        _this.dismiss = function (withTimeOut) {
            _this._async.clearTimeout(_this._openTimerId);
            _this._async.clearTimeout(_this._dismissTimerId);
            if (!withTimeOut) {
                _this._setDismissedState();
            }
            else {
                _this._dismissTimerId = _this._async.setTimeout(function () {
                    _this._setDismissedState();
                }, _this.props.cardDismissDelay);
            }
        };
        // Show HoverCard
        _this._cardOpen = function (ev) {
            if (_this._shouldBlockHoverCard() || (ev.type === 'keydown' && !(ev.which === _this.props.openHotKey))) {
                return;
            }
            _this._async.clearTimeout(_this._dismissTimerId);
            if (ev.type === 'mouseenter') {
                _this._currentMouseTarget = ev.currentTarget;
            }
            _this._executeCardOpen(ev);
        };
        _this._executeCardOpen = function (ev) {
            _this._async.clearTimeout(_this._openTimerId);
            _this._openTimerId = _this._async.setTimeout(function () {
                _this.setState(function (prevState) {
                    if (!prevState.isHoverCardVisible) {
                        return {
                            isHoverCardVisible: true,
                            mode: __WEBPACK_IMPORTED_MODULE_5__ExpandingCard_types__["a" /* ExpandingCardMode */].compact,
                            openMode: ev.type === 'keydown' ? __WEBPACK_IMPORTED_MODULE_3__HoverCard_types__["b" /* OpenCardMode */].hotKey : __WEBPACK_IMPORTED_MODULE_3__HoverCard_types__["b" /* OpenCardMode */].hover
                        };
                    }
                    return prevState;
                });
            }, _this.props.cardOpenDelay);
        };
        /**
         * Hide HoverCard
         * How we dismiss the card depends on where the callback is coming from.
         * This is provided by the `isNativeEvent` argument.
         *  true: Event is coming from event listeners set up in componentDidMount.
         *  false: Event is coming from the `onLeave` prop from the HoverCard component.
         */
        _this._cardDismiss = function (isNativeEvent, ev) {
            if (isNativeEvent) {
                // We expect these to be MouseEvents, If not, return.
                if (!(ev instanceof MouseEvent)) {
                    return;
                }
                if (ev.type === 'keydown' && ev.which !== __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].escape) {
                    return;
                }
                // Dismiss if not sticky and currentTarget is the same element that mouse last entered
                if (!_this.props.sticky && (_this._currentMouseTarget === ev.currentTarget || ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].escape)) {
                    _this.dismiss(true);
                }
            }
            else {
                // If this is a mouseleave event and the component is sticky, do not dismiss.
                if (_this.props.sticky && !(ev instanceof MouseEvent) && ev.nativeEvent instanceof MouseEvent && ev.type === 'mouseleave') {
                    return;
                }
                _this.dismiss(true);
            }
        };
        _this._setDismissedState = function () {
            _this.setState({
                isHoverCardVisible: false,
                mode: __WEBPACK_IMPORTED_MODULE_5__ExpandingCard_types__["a" /* ExpandingCardMode */].compact,
                openMode: __WEBPACK_IMPORTED_MODULE_3__HoverCard_types__["b" /* OpenCardMode */].hover
            });
        };
        _this._instantOpenAsExpanded = function (ev) {
            _this._async.clearTimeout(_this._dismissTimerId);
            _this.setState(function (prevState) {
                if (!prevState.isHoverCardVisible) {
                    return {
                        isHoverCardVisible: true,
                        mode: __WEBPACK_IMPORTED_MODULE_5__ExpandingCard_types__["a" /* ExpandingCardMode */].expanded
                    };
                }
                return prevState;
            });
        };
        _this._setEventListeners = function () {
            var _a = _this.props, trapFocus = _a.trapFocus, instantOpenOnClick = _a.instantOpenOnClick, eventListenerTarget = _a.eventListenerTarget;
            var target = eventListenerTarget ? _this._getTargetElement(eventListenerTarget) : _this._getTargetElement(_this.props.target);
            var nativeEventDismiss = _this._nativeDismissEvent;
            // target can be undefined if ref isn't available, only assign
            // events when defined to avoid throwing exception.
            if (target) {
                _this._events.on(target, 'mouseenter', _this._cardOpen);
                _this._events.on(target, 'mouseleave', nativeEventDismiss);
                if (trapFocus) {
                    _this._events.on(target, 'keydown', _this._cardOpen);
                }
                else {
                    _this._events.on(target, 'focus', _this._cardOpen);
                    _this._events.on(target, 'blur', nativeEventDismiss);
                }
                if (instantOpenOnClick) {
                    _this._events.on(target, 'click', _this._instantOpenAsExpanded);
                }
                else {
                    _this._events.on(target, 'mousedown', nativeEventDismiss);
                    _this._events.on(target, 'keydown', nativeEventDismiss);
                }
            }
        };
        _this._nativeDismissEvent = _this._cardDismiss.bind(_this, true);
        _this._childDismissEvent = _this._cardDismiss.bind(_this, false);
        _this.state = {
            isHoverCardVisible: false,
            mode: __WEBPACK_IMPORTED_MODULE_5__ExpandingCard_types__["a" /* ExpandingCardMode */].compact,
            openMode: __WEBPACK_IMPORTED_MODULE_3__HoverCard_types__["b" /* OpenCardMode */].hover
        };
        return _this;
    }
    HoverCardBase.prototype.componentDidMount = function () {
        this._setEventListeners();
    };
    HoverCardBase.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _this = this;
        if (prevProps.target !== this.props.target) {
            this._events.off();
            this._setEventListeners();
        }
        if (prevState.isHoverCardVisible !== this.state.isHoverCardVisible) {
            if (this.state.isHoverCardVisible) {
                this._async.setTimeout(function () {
                    _this.setState({
                        mode: __WEBPACK_IMPORTED_MODULE_5__ExpandingCard_types__["a" /* ExpandingCardMode */].expanded
                    }, function () {
                        _this.props.onCardExpand && _this.props.onCardExpand();
                    });
                }, this.props.expandedCardOpenDelay);
                this.props.onCardVisible && this.props.onCardVisible();
            }
            else {
                this.setState({
                    mode: __WEBPACK_IMPORTED_MODULE_5__ExpandingCard_types__["a" /* ExpandingCardMode */].compact
                });
                this.props.onCardHide && this.props.onCardHide();
            }
        }
    };
    // Render
    HoverCardBase.prototype.render = function () {
        var _a = this.props, expandingCardProps = _a.expandingCardProps, children = _a.children, id = _a.id, _b = _a.setAriaDescribedBy, setAriaDescribedBy = _b === void 0 ? true : _b, customStyles = _a.styles, theme = _a.theme, className = _a.className, type = _a.type, plainCardProps = _a.plainCardProps, trapFocus = _a.trapFocus, setInitialFocus = _a.setInitialFocus;
        var _c = this.state, isHoverCardVisible = _c.isHoverCardVisible, mode = _c.mode, openMode = _c.openMode;
        var hoverCardId = id || Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["N" /* getId */])('hoverCard');
        this._classNames = getClassNames(customStyles, {
            theme: theme,
            className: className
        });
        // Common props for both card types.
        var commonCardProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["R" /* getNativeProps */])(this.props, __WEBPACK_IMPORTED_MODULE_2__Utilities__["w" /* divProperties */]), { id: hoverCardId, trapFocus: !!trapFocus, firstFocus: setInitialFocus || openMode === __WEBPACK_IMPORTED_MODULE_3__HoverCard_types__["b" /* OpenCardMode */].hotKey, targetElement: this._getTargetElement(this.props.target), onEnter: this._cardOpen, onLeave: this._childDismissEvent });
        var finalExpandedCardProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, expandingCardProps, commonCardProps, { mode: mode });
        var finalPlainCardProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, plainCardProps, commonCardProps);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.host, ref: this._hoverCard, "aria-describedby": setAriaDescribedBy && isHoverCardVisible ? hoverCardId : undefined, "data-is-focusable": !Boolean(this.props.target) },
            children,
            isHoverCardVisible &&
                (type === __WEBPACK_IMPORTED_MODULE_3__HoverCard_types__["a" /* HoverCardType */].expanding ? __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__ExpandingCard__["a" /* ExpandingCard */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, finalExpandedCardProps)) : __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__PlainCard_PlainCard__["a" /* PlainCard */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, finalPlainCardProps)))));
    };
    HoverCardBase.prototype._getTargetElement = function (target) {
        switch (typeof target) {
            case 'string':
                return Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["I" /* getDocument */])().querySelector(target);
            case 'object':
                return target;
            default:
                return this._hoverCard.current || undefined;
        }
    };
    HoverCardBase.prototype._shouldBlockHoverCard = function () {
        return !!(this.props.shouldBlockHoverCard && this.props.shouldBlockHoverCard());
    };
    HoverCardBase.defaultProps = {
        cardOpenDelay: 500,
        cardDismissDelay: 100,
        expandedCardOpenDelay: 1500,
        instantOpenOnClick: false,
        setInitialFocus: false,
        openHotKey: __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].c,
        type: __WEBPACK_IMPORTED_MODULE_3__HoverCard_types__["a" /* HoverCardType */].expanding
    };
    return HoverCardBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=HoverCard.base.js.map

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OpenCardMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HoverCardType; });
/**
 * {@docCategory HoverCard}
 */
var OpenCardMode;
(function (OpenCardMode) {
    /**
     * Open card by hover
     */
    OpenCardMode[OpenCardMode["hover"] = 0] = "hover";
    /**
     * Open card by hot key
     */
    OpenCardMode[OpenCardMode["hotKey"] = 1] = "hotKey";
})(OpenCardMode || (OpenCardMode = {}));
/**
 * {@docCategory HoverCard}
 */
var HoverCardType;
(function (HoverCardType) {
    /**
     * Plain card consisting of one part responsive to the size of content.
     */
    HoverCardType["plain"] = "PlainCard";
    /**
     * File card consisting of two parts: compact and expanded. Has some default sizes if not specified.
     */
    HoverCardType["expanding"] = "ExpandingCard";
})(HoverCardType || (HoverCardType = {}));
//# sourceMappingURL=HoverCard.types.js.map

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExpandingCard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ExpandingCard_styles__ = __webpack_require__(1958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ExpandingCard_base__ = __webpack_require__(790);



var ExpandingCard = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_2__ExpandingCard_base__["a" /* ExpandingCardBase */], __WEBPACK_IMPORTED_MODULE_1__ExpandingCard_styles__["a" /* getStyles */], undefined, {
    scope: 'ExpandingCard'
});
//# sourceMappingURL=ExpandingCard.js.map

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExpandingCardBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ExpandingCard_types__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CardCallout_CardCallout__ = __webpack_require__(791);





var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var ExpandingCardBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ExpandingCardBase, _super);
    function ExpandingCardBase(props) {
        var _this = _super.call(this, props) || this;
        _this._expandedElem = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._onKeyDown = function (ev) {
            if (ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].escape) {
                _this.props.onLeave && _this.props.onLeave(ev);
            }
        };
        _this._onRenderCompactCard = function () {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: _this._classNames.compactCard }, _this.props.onRenderCompactCard(_this.props.renderData));
        };
        _this._onRenderExpandedCard = function () {
            // firstFrameRendered helps in initially setting height of expanded card to 1px, even if
            // mode prop is set to ExpandingCardMode.expanded on first render. This is to make sure transition animation takes place.
            !_this.state.firstFrameRendered &&
                _this._async.requestAnimationFrame(function () {
                    _this.setState({
                        firstFrameRendered: true
                    });
                });
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: _this._classNames.expandedCard, ref: _this._expandedElem },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: _this._classNames.expandedCardScroll }, _this.props.onRenderExpandedCard && _this.props.onRenderExpandedCard(_this.props.renderData))));
        };
        _this._checkNeedsScroll = function () {
            var expandedCardHeight = _this.props.expandedCardHeight;
            _this._async.requestAnimationFrame(function () {
                if (_this._expandedElem.current && _this._expandedElem.current.scrollHeight >= expandedCardHeight) {
                    _this.setState({
                        needsScroll: true
                    });
                }
            });
        };
        _this.state = {
            firstFrameRendered: false,
            needsScroll: false
        };
        return _this;
    }
    ExpandingCardBase.prototype.componentDidMount = function () {
        this._checkNeedsScroll();
    };
    ExpandingCardBase.prototype.componentWillUnmount = function () {
        this._async.dispose();
    };
    ExpandingCardBase.prototype.render = function () {
        var _a = this.props, styles = _a.styles, compactCardHeight = _a.compactCardHeight, expandedCardHeight = _a.expandedCardHeight, theme = _a.theme, mode = _a.mode, className = _a.className;
        var _b = this.state, needsScroll = _b.needsScroll, firstFrameRendered = _b.firstFrameRendered;
        var finalHeight = compactCardHeight + expandedCardHeight;
        this._classNames = getClassNames(styles, {
            theme: theme,
            compactCardHeight: compactCardHeight,
            className: className,
            expandedCardHeight: expandedCardHeight,
            needsScroll: needsScroll,
            expandedCardFirstFrameRendered: mode === __WEBPACK_IMPORTED_MODULE_3__ExpandingCard_types__["a" /* ExpandingCardMode */].expanded && firstFrameRendered
        });
        var content = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { onMouseEnter: this.props.onEnter, onMouseLeave: this.props.onLeave, onKeyDown: this._onKeyDown },
            this._onRenderCompactCard(),
            this._onRenderExpandedCard()));
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__CardCallout_CardCallout__["a" /* CardCallout */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this.props, { content: content, finalHeight: finalHeight, className: this._classNames.root }));
    };
    ExpandingCardBase.defaultProps = {
        compactCardHeight: 156,
        expandedCardHeight: 384,
        directionalHintFixed: true
    };
    return ExpandingCardBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=ExpandingCard.base.js.map

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CardCallout; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Callout__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_DirectionalHint__ = __webpack_require__(36);






var CardCallout = function (props) {
    var _a = props.gapSpace, gapSpace = _a === void 0 ? 0 : _a, _b = props.directionalHint, directionalHint = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_4__common_DirectionalHint__["a" /* DirectionalHint */].bottomLeftEdge : _b, directionalHintFixed = props.directionalHintFixed, targetElement = props.targetElement, firstFocus = props.firstFocus, trapFocus = props.trapFocus, onLeave = props.onLeave, className = props.className, finalHeight = props.finalHeight, content = props.content;
    var calloutProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["R" /* getNativeProps */])(props, __WEBPACK_IMPORTED_MODULE_2__Utilities__["w" /* divProperties */]), { className: className, target: targetElement, isBeakVisible: false, directionalHint: directionalHint, directionalHintFixed: directionalHintFixed, finalHeight: finalHeight, minPagePadding: 24, onDismiss: onLeave, gapSpace: gapSpace });
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null, trapFocus ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Callout__["c" /* FocusTrapCallout */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, calloutProps, { focusTrapProps: {
            forceFocusInsideTrap: false,
            isClickableOutsideFocusTrap: true,
            disableFirstFocus: !firstFocus
        } }), content)) : (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Callout__["a" /* Callout */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, calloutProps), content))));
};
//# sourceMappingURL=CardCallout.js.map

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PlainCard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PlainCard_styles__ = __webpack_require__(1959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PlainCard_base__ = __webpack_require__(793);



var PlainCard = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_2__PlainCard_base__["a" /* PlainCardBase */], __WEBPACK_IMPORTED_MODULE_1__PlainCard_styles__["a" /* getStyles */], undefined, {
    scope: 'PlainCard'
});
//# sourceMappingURL=PlainCard.js.map

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PlainCardBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CardCallout_CardCallout__ = __webpack_require__(791);




var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var PlainCardBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](PlainCardBase, _super);
    function PlainCardBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onKeyDown = function (ev) {
            if (ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].escape) {
                _this.props.onLeave && _this.props.onLeave(ev);
            }
        };
        return _this;
    }
    PlainCardBase.prototype.render = function () {
        var _a = this.props, styles = _a.styles, theme = _a.theme, className = _a.className;
        this._classNames = getClassNames(styles, {
            theme: theme,
            className: className
        });
        var content = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { onMouseEnter: this.props.onEnter, onMouseLeave: this.props.onLeave, onKeyDown: this._onKeyDown }, this.props.onRenderPlainCard(this.props.renderData)));
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__CardCallout_CardCallout__["a" /* CardCallout */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this.props, { content: content, className: this._classNames.root }));
    };
    return PlainCardBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=PlainCard.base.js.map

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initializeIcons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fabric_icons__ = __webpack_require__(1961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fabric_icons_0__ = __webpack_require__(1962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fabric_icons_1__ = __webpack_require__(1963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fabric_icons_2__ = __webpack_require__(1964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fabric_icons_3__ = __webpack_require__(1965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fabric_icons_4__ = __webpack_require__(1966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fabric_icons_5__ = __webpack_require__(1967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fabric_icons_6__ = __webpack_require__(1968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fabric_icons_7__ = __webpack_require__(1969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fabric_icons_8__ = __webpack_require__(1970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fabric_icons_9__ = __webpack_require__(1971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__fabric_icons_10__ = __webpack_require__(1972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__fabric_icons_11__ = __webpack_require__(1973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__fabric_icons_12__ = __webpack_require__(1974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__fabric_icons_13__ = __webpack_require__(1975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__fabric_icons_14__ = __webpack_require__(1976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__fabric_icons_15__ = __webpack_require__(1977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__fabric_icons_16__ = __webpack_require__(1978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__iconAliases__ = __webpack_require__(1979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__version__ = __webpack_require__(1980);



















var DEFAULT_BASE_URL = 'https://spoprod-a.akamaihd.net/files/fabric/assets/icons/';
function initializeIcons(baseUrl, options) {
    if (baseUrl === void 0) { baseUrl = DEFAULT_BASE_URL; }
    [__WEBPACK_IMPORTED_MODULE_0__fabric_icons__["a" /* initializeIcons */], __WEBPACK_IMPORTED_MODULE_1__fabric_icons_0__["a" /* initializeIcons */], __WEBPACK_IMPORTED_MODULE_2__fabric_icons_1__["a" /* initializeIcons */], __WEBPACK_IMPORTED_MODULE_3__fabric_icons_2__["a" /* initializeIcons */], __WEBPACK_IMPORTED_MODULE_4__fabric_icons_3__["a" /* initializeIcons */], __WEBPACK_IMPORTED_MODULE_5__fabric_icons_4__["a" /* initializeIcons */], __WEBPACK_IMPORTED_MODULE_6__fabric_icons_5__["a" /* initializeIcons */], __WEBPACK_IMPORTED_MODULE_7__fabric_icons_6__["a" /* initializeIcons */], __WEBPACK_IMPORTED_MODULE_8__fabric_icons_7__["a" /* initializeIcons */], __WEBPACK_IMPORTED_MODULE_9__fabric_icons_8__["a" /* initializeIcons */], __WEBPACK_IMPORTED_MODULE_10__fabric_icons_9__["a" /* initializeIcons */], __WEBPACK_IMPORTED_MODULE_11__fabric_icons_10__["a" /* initializeIcons */], __WEBPACK_IMPORTED_MODULE_12__fabric_icons_11__["a" /* initializeIcons */], __WEBPACK_IMPORTED_MODULE_13__fabric_icons_12__["a" /* initializeIcons */], __WEBPACK_IMPORTED_MODULE_14__fabric_icons_13__["a" /* initializeIcons */], __WEBPACK_IMPORTED_MODULE_15__fabric_icons_14__["a" /* initializeIcons */], __WEBPACK_IMPORTED_MODULE_16__fabric_icons_15__["a" /* initializeIcons */], __WEBPACK_IMPORTED_MODULE_17__fabric_icons_16__["a" /* initializeIcons */]].forEach(function (initialize) { return initialize(baseUrl, options); });
    Object(__WEBPACK_IMPORTED_MODULE_18__iconAliases__["a" /* registerIconAliases */])();
}

//# sourceMappingURL=index.js.map

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Keytip_index__ = __webpack_require__(1981);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Keytip_index__["a"]; });

//# sourceMappingURL=Keytip.js.map

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCalloutStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCalloutOffsetStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var getStyles = function (props) {
    var theme = props.theme, disabled = props.disabled, visible = props.visible;
    return {
        container: [
            {
                backgroundColor: theme.palette.neutralDark
            },
            disabled && {
                opacity: 0.5,
                selectors: (_a = {},
                    _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        color: 'GrayText',
                        opacity: 1
                    },
                    _a)
            },
            !visible && {
                visibility: 'hidden'
            }
        ],
        root: [
            theme.fonts.medium,
            {
                textAlign: 'center',
                paddingLeft: '3px',
                paddingRight: '3px',
                backgroundColor: theme.palette.neutralDark,
                color: theme.palette.neutralLight,
                minWidth: '11px',
                lineHeight: '17px',
                height: '17px',
                display: 'inline-block'
            },
            disabled && {
                color: theme.palette.neutralTertiaryAlt
            }
        ]
    };
    var _a;
};
var getCalloutStyles = function (props) {
    return {
        container: [],
        root: [
            {
                border: 'none',
                boxShadow: 'none'
            }
        ],
        beak: [],
        beakCurtain: [],
        calloutMain: [
            {
                backgroundColor: 'transparent'
            }
        ]
    };
};
var getCalloutOffsetStyles = function (offset) {
    return function (props) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["E" /* mergeStyleSets */])(getCalloutStyles(props), {
            root: [
                {
                    marginLeft: offset.x,
                    marginTop: offset.y
                }
            ]
        });
    };
};
//# sourceMappingURL=Keytip.styles.js.map

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KeytipLayerBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__KeytipLayer_styles__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Keytip__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layer__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_keytips_KeytipManager__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__KeytipTree__ = __webpack_require__(1988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utilities_keytips_KeytipUtils__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utilities_keytips_IKeytipTransitionKey__ = __webpack_require__(1989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utilities_keytips_KeytipConstants__ = __webpack_require__(268);











// Default sequence is Alt-Windows (Alt-Meta) in Windows, Option-Control (Alt-Control) in Mac
var defaultStartSequence = {
    key: Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["_13" /* isMac */])() ? 'Control' : 'Meta',
    modifierKeys: [__WEBPACK_IMPORTED_MODULE_9__utilities_keytips_IKeytipTransitionKey__["a" /* KeytipTransitionModifier */].alt]
};
// Default exit sequence is the same as the start sequence
var defaultExitSequence = defaultStartSequence;
// Default return sequence is Escape
var defaultReturnSequence = {
    key: 'Escape'
};
var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["r" /* classNamesFunction */])();
/**
 * A layer that holds all keytip items
 * {@docCategory Keytips}
 */
var KeytipLayerBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](KeytipLayerBase, _super);
    // tslint:disable-next-line:no-any
    function KeytipLayerBase(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this._keytipManager = __WEBPACK_IMPORTED_MODULE_6__utilities_keytips_KeytipManager__["a" /* KeytipManager */].getInstance();
        _this._delayedKeytipQueue = [];
        _this._keyHandled = false;
        _this._onDismiss = function (ev) {
            // if we are in keytip mode, then exit keytip mode
            if (_this.state.inKeytipMode) {
                _this._exitKeytipMode(ev);
            }
        };
        _this._onKeyDown = function (ev) {
            _this._keyHandled = false;
            // using key since which has been deprecated and key is now widely suporrted.
            // See: https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/which
            var key = ev.key;
            switch (key) {
                case 'Alt':
                    // ALT puts focus in the browser bar, so it should not be used as a key for keytips.
                    // It can be used as a modifier
                    break;
                case 'Tab':
                case 'Enter':
                case 'Spacebar':
                case ' ':
                case 'ArrowUp':
                case 'Up':
                case 'ArrowDown':
                case 'Down':
                case 'ArrowLeft':
                case 'Left':
                case 'ArrowRight':
                case 'Right':
                    if (_this.state.inKeytipMode) {
                        _this._keyHandled = true;
                        _this._exitKeytipMode(ev);
                    }
                    break;
                default:
                    // Special cases for browser-specific keys that are not at standard
                    // (according to http://www.w3.org/TR/uievents-key/#keys-navigation)
                    if (key === 'Esc') {
                        // Edge: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/5290772/
                        key = 'Escape';
                    }
                    else if (key === 'OS' || key === 'Win') {
                        // Firefox: https://bugzilla.mozilla.org/show_bug.cgi?id=1232918
                        // Edge: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8860571/
                        // and https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/16424492/
                        key = 'Meta';
                    }
                    var transitionKey = { key: key };
                    transitionKey.modifierKeys = _this._getModifierKey(key, ev);
                    _this.processTransitionInput(transitionKey, ev);
                    break;
            }
        };
        _this._onKeyPress = function (ev) {
            if (_this.state.inKeytipMode && !_this._keyHandled) {
                // Call processInput
                _this.processInput(ev.key.toLocaleLowerCase(), ev);
                ev.preventDefault();
                ev.stopPropagation();
            }
        };
        _this._onKeytipAdded = function (eventArgs) {
            var keytipProps = eventArgs.keytip;
            var uniqueID = eventArgs.uniqueID;
            _this._keytipTree.addNode(keytipProps, uniqueID);
            _this._setKeytips();
            // Add the keytip to the queue to show later
            if (_this._keytipTree.isCurrentKeytipParent(keytipProps)) {
                _this._addKeytipToQueue(Object(__WEBPACK_IMPORTED_MODULE_8__utilities_keytips_KeytipUtils__["e" /* sequencesToID */])(keytipProps.keySequences));
                // Check to make sure that child of currentKeytip is successfully added to currentKeytip's children and update it if not
                // Note: Added this condition because KeytipTree.addNode was not always reflecting updates made to a parent node in currentKeytip
                // when that parent is the currentKeytip
                if (_this._keytipTree.currentKeytip &&
                    _this._keytipTree.currentKeytip.hasDynamicChildren &&
                    _this._keytipTree.currentKeytip.children.indexOf(keytipProps.id) < 0) {
                    _this._keytipTree.currentKeytip = _this._keytipTree.getNode(_this._keytipTree.currentKeytip.id);
                }
            }
            if (_this._newCurrentKeytipSequences && Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["l" /* arraysEqual */])(keytipProps.keySequences, _this._newCurrentKeytipSequences)) {
                _this._triggerKeytipImmediately(keytipProps);
            }
            if (_this._isCurrentKeytipAnAlias(keytipProps)) {
                var keytipSequence = keytipProps.keySequences;
                if (keytipProps.overflowSetSequence) {
                    keytipSequence = Object(__WEBPACK_IMPORTED_MODULE_8__utilities_keytips_KeytipUtils__["d" /* mergeOverflows */])(keytipSequence, keytipProps.overflowSetSequence);
                }
                _this._keytipTree.currentKeytip = _this._keytipTree.getNode(Object(__WEBPACK_IMPORTED_MODULE_8__utilities_keytips_KeytipUtils__["e" /* sequencesToID */])(keytipSequence));
            }
        };
        _this._onKeytipUpdated = function (eventArgs) {
            var keytipProps = eventArgs.keytip;
            var uniqueID = eventArgs.uniqueID;
            _this._keytipTree.updateNode(keytipProps, uniqueID);
            _this._setKeytips();
        };
        _this._onKeytipRemoved = function (eventArgs) {
            var keytipProps = eventArgs.keytip;
            var uniqueID = eventArgs.uniqueID;
            // Remove keytip from the delayed queue
            _this._removeKeytipFromQueue(Object(__WEBPACK_IMPORTED_MODULE_8__utilities_keytips_KeytipUtils__["e" /* sequencesToID */])(keytipProps.keySequences));
            // Remove the node from the Tree
            _this._keytipTree.removeNode(keytipProps, uniqueID);
            _this._setKeytips();
        };
        _this._onPersistedKeytipAdded = function (eventArgs) {
            var keytipProps = eventArgs.keytip;
            var uniqueID = eventArgs.uniqueID;
            _this._keytipTree.addNode(keytipProps, uniqueID, true);
        };
        _this._onPersistedKeytipRemoved = function (eventArgs) {
            var keytipProps = eventArgs.keytip;
            var uniqueID = eventArgs.uniqueID;
            _this._keytipTree.removeNode(keytipProps, uniqueID);
        };
        _this._onPersistedKeytipExecute = function (eventArgs) {
            _this._persistedKeytipExecute(eventArgs.overflowButtonSequences, eventArgs.keytipSequences);
        };
        /**
         * Sets if we are in keytip mode.
         * Note, this sets both the state for the layer as well as
         * the value that the manager will expose externally.
         * @param inKeytipMode - Boolean so set whether we are in keytip mode or not
         */
        _this._setInKeytipMode = function (inKeytipMode) {
            _this.setState({ inKeytipMode: inKeytipMode });
            _this._keytipManager.inKeytipMode = inKeytipMode;
        };
        /**
         * Emits a warning if duplicate keytips are found for the children of the current keytip
         */
        _this._warnIfDuplicateKeytips = function () {
            var duplicateKeytips = _this._getDuplicateIds(_this._keytipTree.getChildren());
            if (duplicateKeytips.length) {
                Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["_34" /* warn */])('Duplicate keytips found for ' + duplicateKeytips.join(', '));
            }
        };
        /**
         * Returns duplicates among keytip IDs
         * If the returned array is empty, no duplicates were found
         *
         * @param keytipIds - Array of keytip IDs to find duplicates for
         * @returns - Array of duplicates that were found. If multiple duplicates were found it will only be added once to this array
         */
        _this._getDuplicateIds = function (keytipIds) {
            var seenIds = {};
            return keytipIds.filter(function (keytipId) {
                seenIds[keytipId] = seenIds[keytipId] ? seenIds[keytipId] + 1 : 1;
                // Only add the first duplicate keytip seen
                return seenIds[keytipId] === 2;
            });
        };
        var managerKeytips = _this._keytipManager.getKeytips().slice();
        _this.state = {
            inKeytipMode: false,
            // Get the initial set of keytips
            keytips: managerKeytips,
            visibleKeytips: _this._getVisibleKeytips(managerKeytips)
        };
        _this._keytipTree = new __WEBPACK_IMPORTED_MODULE_7__KeytipTree__["a" /* KeytipTree */]();
        // Add regular and persisted keytips to the tree
        for (var _i = 0, _a = _this._keytipManager.keytips.concat(_this._keytipManager.persistedKeytips); _i < _a.length; _i++) {
            var uniqueKeytip = _a[_i];
            _this._keytipTree.addNode(uniqueKeytip.keytip, uniqueKeytip.uniqueID);
        }
        _this._currentSequence = '';
        // Add keytip listeners
        _this._events.on(_this._keytipManager, __WEBPACK_IMPORTED_MODULE_10__utilities_keytips_KeytipConstants__["g" /* KeytipEvents */].KEYTIP_ADDED, _this._onKeytipAdded);
        _this._events.on(_this._keytipManager, __WEBPACK_IMPORTED_MODULE_10__utilities_keytips_KeytipConstants__["g" /* KeytipEvents */].KEYTIP_UPDATED, _this._onKeytipUpdated);
        _this._events.on(_this._keytipManager, __WEBPACK_IMPORTED_MODULE_10__utilities_keytips_KeytipConstants__["g" /* KeytipEvents */].KEYTIP_REMOVED, _this._onKeytipRemoved);
        _this._events.on(_this._keytipManager, __WEBPACK_IMPORTED_MODULE_10__utilities_keytips_KeytipConstants__["g" /* KeytipEvents */].PERSISTED_KEYTIP_ADDED, _this._onPersistedKeytipAdded);
        _this._events.on(_this._keytipManager, __WEBPACK_IMPORTED_MODULE_10__utilities_keytips_KeytipConstants__["g" /* KeytipEvents */].PERSISTED_KEYTIP_REMOVED, _this._onPersistedKeytipRemoved);
        _this._events.on(_this._keytipManager, __WEBPACK_IMPORTED_MODULE_10__utilities_keytips_KeytipConstants__["g" /* KeytipEvents */].PERSISTED_KEYTIP_EXECUTE, _this._onPersistedKeytipExecute);
        return _this;
    }
    KeytipLayerBase.prototype.render = function () {
        var _this = this;
        var _a = this.props, content = _a.content, styles = _a.styles;
        var _b = this.state, keytips = _b.keytips, visibleKeytips = _b.visibleKeytips;
        this._classNames = getClassNames(styles, {});
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Layer__["a" /* Layer */], { styles: __WEBPACK_IMPORTED_MODULE_2__KeytipLayer_styles__["a" /* getLayerStyles */] },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { id: __WEBPACK_IMPORTED_MODULE_10__utilities_keytips_KeytipConstants__["d" /* KTP_LAYER_ID */], className: this._classNames.innerContent }, "" + content + __WEBPACK_IMPORTED_MODULE_10__utilities_keytips_KeytipConstants__["c" /* KTP_ARIA_SEPARATOR */]),
            keytips &&
                keytips.map(function (keytipProps, index) {
                    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { key: index, id: Object(__WEBPACK_IMPORTED_MODULE_8__utilities_keytips_KeytipUtils__["e" /* sequencesToID */])(keytipProps.keySequences), className: _this._classNames.innerContent }, keytipProps.keySequences.join(__WEBPACK_IMPORTED_MODULE_10__utilities_keytips_KeytipConstants__["c" /* KTP_ARIA_SEPARATOR */])));
                }),
            visibleKeytips &&
                visibleKeytips.map(function (visibleKeytipProps) {
                    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Keytip__["a" /* Keytip */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ key: Object(__WEBPACK_IMPORTED_MODULE_8__utilities_keytips_KeytipUtils__["e" /* sequencesToID */])(visibleKeytipProps.keySequences) }, visibleKeytipProps));
                })));
    };
    KeytipLayerBase.prototype.componentDidMount = function () {
        // Add window listeners
        this._events.on(window, 'mouseup', this._onDismiss, true /* useCapture */);
        this._events.on(window, 'pointerup', this._onDismiss, true /* useCapture */);
        this._events.on(window, 'resize', this._onDismiss);
        this._events.on(window, 'keydown', this._onKeyDown, true /* useCapture */);
        this._events.on(window, 'keypress', this._onKeyPress, true /* useCapture */);
        this._events.on(window, 'scroll', this._onDismiss, true /* useCapture */);
        // Add keytip listeners
        this._events.on(this._keytipManager, __WEBPACK_IMPORTED_MODULE_10__utilities_keytips_KeytipConstants__["g" /* KeytipEvents */].ENTER_KEYTIP_MODE, this._enterKeytipMode);
        this._events.on(this._keytipManager, __WEBPACK_IMPORTED_MODULE_10__utilities_keytips_KeytipConstants__["g" /* KeytipEvents */].EXIT_KEYTIP_MODE, this._exitKeytipMode);
    };
    KeytipLayerBase.prototype.componentWillUnmount = function () {
        // Remove window listeners
        this._events.off(window, 'mouseup', this._onDismiss, true /* useCapture */);
        this._events.off(window, 'pointerup', this._onDismiss, true /* useCapture */);
        this._events.off(window, 'resize', this._onDismiss);
        this._events.off(window, 'keydown', this._onKeyDown, true /* useCapture */);
        this._events.off(window, 'keypress', this._onKeyPress, true /* useCapture */);
        this._events.off(window, 'scroll', this._onDismiss, true /* useCapture */);
        // Remove keytip listeners
        this._events.off(this._keytipManager, __WEBPACK_IMPORTED_MODULE_10__utilities_keytips_KeytipConstants__["g" /* KeytipEvents */].KEYTIP_ADDED, this._onKeytipAdded);
        this._events.off(this._keytipManager, __WEBPACK_IMPORTED_MODULE_10__utilities_keytips_KeytipConstants__["g" /* KeytipEvents */].KEYTIP_UPDATED, this._onKeytipUpdated);
        this._events.off(this._keytipManager, __WEBPACK_IMPORTED_MODULE_10__utilities_keytips_KeytipConstants__["g" /* KeytipEvents */].KEYTIP_REMOVED, this._onKeytipRemoved);
        this._events.off(this._keytipManager, __WEBPACK_IMPORTED_MODULE_10__utilities_keytips_KeytipConstants__["g" /* KeytipEvents */].PERSISTED_KEYTIP_ADDED, this._onPersistedKeytipAdded);
        this._events.off(this._keytipManager, __WEBPACK_IMPORTED_MODULE_10__utilities_keytips_KeytipConstants__["g" /* KeytipEvents */].PERSISTED_KEYTIP_REMOVED, this._onPersistedKeytipRemoved);
        this._events.off(this._keytipManager, __WEBPACK_IMPORTED_MODULE_10__utilities_keytips_KeytipConstants__["g" /* KeytipEvents */].PERSISTED_KEYTIP_EXECUTE, this._onPersistedKeytipExecute);
        this._events.off(this._keytipManager, __WEBPACK_IMPORTED_MODULE_10__utilities_keytips_KeytipConstants__["g" /* KeytipEvents */].ENTER_KEYTIP_MODE, this._enterKeytipMode);
        this._events.off(this._keytipManager, __WEBPACK_IMPORTED_MODULE_10__utilities_keytips_KeytipConstants__["g" /* KeytipEvents */].EXIT_KEYTIP_MODE, this._exitKeytipMode);
    };
    // The below public functions are only public for testing purposes
    // They are not intended to be used in app code by using a KeytipLayer reference
    KeytipLayerBase.prototype.getCurrentSequence = function () {
        return this._currentSequence;
    };
    KeytipLayerBase.prototype.getKeytipTree = function () {
        return this._keytipTree;
    };
    /**
     * Processes an IKeytipTransitionKey entered by the user
     *
     * @param transitionKey - IKeytipTransitionKey received by the layer to process
     */
    KeytipLayerBase.prototype.processTransitionInput = function (transitionKey, ev) {
        var currKtp = this._keytipTree.currentKeytip;
        if (Object(__WEBPACK_IMPORTED_MODULE_9__utilities_keytips_IKeytipTransitionKey__["b" /* transitionKeysContain */])(this.props.keytipExitSequences, transitionKey) && currKtp) {
            // If key sequence is in 'exit sequences', exit keytip mode
            this._keyHandled = true;
            this._exitKeytipMode(ev);
        }
        else if (Object(__WEBPACK_IMPORTED_MODULE_9__utilities_keytips_IKeytipTransitionKey__["b" /* transitionKeysContain */])(this.props.keytipReturnSequences, transitionKey)) {
            // If key sequence is in return sequences, move currentKeytip to parent (or if currentKeytip is the root, exit)
            if (currKtp) {
                this._keyHandled = true;
                if (currKtp.id === this._keytipTree.root.id) {
                    // We are at the root, exit keytip mode
                    this._exitKeytipMode(ev);
                }
                else {
                    // If this keytip has a onReturn prop, we execute the func.
                    if (currKtp.onReturn) {
                        currKtp.onReturn(this._getKtpExecuteTarget(currKtp), this._getKtpTarget(currKtp));
                    }
                    // Reset currentSequence
                    this._currentSequence = '';
                    // Return pointer to its parent
                    this._keytipTree.currentKeytip = this._keytipTree.getNode(currKtp.parent);
                    // Show children keytips of the new currentKeytip
                    this.showKeytips(this._keytipTree.getChildren());
                    this._warnIfDuplicateKeytips();
                }
            }
        }
        else if (Object(__WEBPACK_IMPORTED_MODULE_9__utilities_keytips_IKeytipTransitionKey__["b" /* transitionKeysContain */])(this.props.keytipStartSequences, transitionKey) && !currKtp) {
            // If key sequence is in 'entry sequences' and currentKeytip is null, we enter keytip mode
            this._keyHandled = true;
            this._enterKeytipMode();
            this._warnIfDuplicateKeytips();
        }
    };
    /**
     * Processes inputs from the document listener and traverse the keytip tree
     *
     * @param key - Key pressed by the user
     */
    KeytipLayerBase.prototype.processInput = function (key, ev) {
        // Concat the input key with the current sequence
        var currSequence = this._currentSequence + key;
        var currKtp = this._keytipTree.currentKeytip;
        // currentKeytip must be defined, otherwise we haven't entered keytip mode yet
        if (currKtp) {
            var node = this._keytipTree.getExactMatchedNode(currSequence, currKtp);
            if (node) {
                this._keytipTree.currentKeytip = currKtp = node;
                var currKtpChildren = this._keytipTree.getChildren();
                // Execute this node's onExecute if defined
                if (currKtp.onExecute) {
                    currKtp.onExecute(this._getKtpExecuteTarget(currKtp), this._getKtpTarget(currKtp));
                    // Reset currKtp, this might have changed from the onExecute
                    currKtp = this._keytipTree.currentKeytip;
                }
                // To exit keytipMode after executing the keytip it must not have a menu or have dynamic children
                if (currKtpChildren.length === 0 && !(currKtp.hasDynamicChildren || currKtp.hasMenu)) {
                    this._exitKeytipMode(ev);
                }
                else {
                    // Show all children keytips
                    this.showKeytips(currKtpChildren);
                    this._warnIfDuplicateKeytips();
                }
                // Clear currentSequence
                this._currentSequence = '';
                return;
            }
            var partialNodes = this._keytipTree.getPartiallyMatchedNodes(currSequence, currKtp);
            if (partialNodes.length > 0) {
                // We found nodes that partially match the sequence, so we show only those
                // Omit showing persisted nodes here
                var ids = partialNodes
                    .filter(function (partialNode) {
                    return !partialNode.persisted;
                })
                    .map(function (partialNode) {
                    return partialNode.id;
                });
                this.showKeytips(ids);
                // Save currentSequence
                this._currentSequence = currSequence;
            }
        }
    };
    /**
     * Show the given keytips and hide all others
     *
     * @param ids - Keytip IDs to show
     */
    KeytipLayerBase.prototype.showKeytips = function (ids) {
        // Update the visible prop in the manager
        for (var _i = 0, _a = this._keytipManager.getKeytips(); _i < _a.length; _i++) {
            var keytip = _a[_i];
            var keytipId = Object(__WEBPACK_IMPORTED_MODULE_8__utilities_keytips_KeytipUtils__["e" /* sequencesToID */])(keytip.keySequences);
            if (ids.indexOf(keytipId) >= 0) {
                keytip.visible = true;
            }
            else if (keytip.overflowSetSequence &&
                ids.indexOf(Object(__WEBPACK_IMPORTED_MODULE_8__utilities_keytips_KeytipUtils__["e" /* sequencesToID */])(Object(__WEBPACK_IMPORTED_MODULE_8__utilities_keytips_KeytipUtils__["d" /* mergeOverflows */])(keytip.keySequences, keytip.overflowSetSequence))) >= 0) {
                // Check if the ID with the overflow is the keytip we're looking for
                keytip.visible = true;
            }
            else {
                keytip.visible = false;
            }
        }
        // Apply the manager changes to the Layer state
        this._setKeytips();
    };
    /**
     * Enters keytip mode for this layer
     */
    KeytipLayerBase.prototype._enterKeytipMode = function () {
        if (this._keytipManager.shouldEnterKeytipMode) {
            this._keytipTree.currentKeytip = this._keytipTree.root;
            // Show children of root
            this.showKeytips(this._keytipTree.getChildren());
            this._setInKeytipMode(true /* inKeytipMode */);
            if (this.props.onEnterKeytipMode) {
                this.props.onEnterKeytipMode();
            }
        }
    };
    /**
     * Exits keytip mode for this layer
     */
    KeytipLayerBase.prototype._exitKeytipMode = function (ev) {
        this._keytipTree.currentKeytip = undefined;
        this._currentSequence = '';
        // Hide all keytips
        this.showKeytips([]);
        // Reset the delayed keytips if any
        this._delayedQueueTimeout && this._async.clearTimeout(this._delayedQueueTimeout);
        this._delayedKeytipQueue = [];
        this._setInKeytipMode(false /* inKeytipMode */);
        if (this.props.onExitKeytipMode) {
            this.props.onExitKeytipMode(ev);
        }
    };
    /**
     * Sets the keytips state property
     *
     * @param keytipProps - Keytips to set in this layer
     */
    KeytipLayerBase.prototype._setKeytips = function (keytipProps) {
        if (keytipProps === void 0) { keytipProps = this._keytipManager.getKeytips(); }
        this.setState({ keytips: keytipProps, visibleKeytips: this._getVisibleKeytips(keytipProps) });
    };
    /**
     * Callback function to use for persisted keytips
     *
     * @param overflowButtonSequences - The overflow button sequence to execute
     * @param keytipSequences - The keytip that should become the 'currentKeytip' when it is registered
     */
    KeytipLayerBase.prototype._persistedKeytipExecute = function (overflowButtonSequences, keytipSequences) {
        // Save newCurrentKeytip for later
        this._newCurrentKeytipSequences = keytipSequences;
        // Execute the overflow button's onExecute
        var overflowKeytipNode = this._keytipTree.getNode(Object(__WEBPACK_IMPORTED_MODULE_8__utilities_keytips_KeytipUtils__["e" /* sequencesToID */])(overflowButtonSequences));
        if (overflowKeytipNode && overflowKeytipNode.onExecute) {
            overflowKeytipNode.onExecute(this._getKtpExecuteTarget(overflowKeytipNode), this._getKtpTarget(overflowKeytipNode));
        }
    };
    KeytipLayerBase.prototype._getVisibleKeytips = function (keytips) {
        // Filter out non-visible keytips and duplicates
        var seenIds = {};
        return keytips.filter(function (keytip) {
            var keytipId = Object(__WEBPACK_IMPORTED_MODULE_8__utilities_keytips_KeytipUtils__["e" /* sequencesToID */])(keytip.keySequences);
            seenIds[keytipId] = seenIds[keytipId] ? seenIds[keytipId] + 1 : 1;
            return keytip.visible && seenIds[keytipId] === 1;
        });
    };
    /**
     * Gets the ModifierKeyCodes based on the keyboard event
     *
     * @param ev - React.KeyboardEvent
     * @returns List of ModifierKeyCodes that were pressed
     */
    KeytipLayerBase.prototype._getModifierKey = function (key, ev) {
        var modifierKeys = [];
        if (ev.altKey && key !== 'Alt') {
            modifierKeys.push(__WEBPACK_IMPORTED_MODULE_9__utilities_keytips_IKeytipTransitionKey__["a" /* KeytipTransitionModifier */].alt);
        }
        if (ev.ctrlKey && key !== 'Control') {
            modifierKeys.push(__WEBPACK_IMPORTED_MODULE_9__utilities_keytips_IKeytipTransitionKey__["a" /* KeytipTransitionModifier */].ctrl);
        }
        if (ev.shiftKey && key !== 'Shift') {
            modifierKeys.push(__WEBPACK_IMPORTED_MODULE_9__utilities_keytips_IKeytipTransitionKey__["a" /* KeytipTransitionModifier */].shift);
        }
        if (ev.metaKey && key !== 'Meta') {
            modifierKeys.push(__WEBPACK_IMPORTED_MODULE_9__utilities_keytips_IKeytipTransitionKey__["a" /* KeytipTransitionModifier */].meta);
        }
        return modifierKeys.length ? modifierKeys : undefined;
    };
    /**
     * Trigger a keytip immediately and set it as the current keytip
     *
     * @param keytipProps - Keytip to trigger immediately
     */
    KeytipLayerBase.prototype._triggerKeytipImmediately = function (keytipProps) {
        // This keytip should become the currentKeytip and should execute right away
        var keytipSequence = keytipProps.keySequences.slice();
        if (keytipProps.overflowSetSequence) {
            keytipSequence = Object(__WEBPACK_IMPORTED_MODULE_8__utilities_keytips_KeytipUtils__["d" /* mergeOverflows */])(keytipSequence, keytipProps.overflowSetSequence);
        }
        // Set currentKeytip
        this._keytipTree.currentKeytip = this._keytipTree.getNode(Object(__WEBPACK_IMPORTED_MODULE_8__utilities_keytips_KeytipUtils__["e" /* sequencesToID */])(keytipSequence));
        if (this._keytipTree.currentKeytip) {
            // Show all children keytips if any
            var children = this._keytipTree.getChildren();
            if (children.length) {
                this.showKeytips(children);
            }
            if (this._keytipTree.currentKeytip.onExecute) {
                this._keytipTree.currentKeytip.onExecute(this._getKtpExecuteTarget(this._keytipTree.currentKeytip), this._getKtpTarget(this._keytipTree.currentKeytip));
            }
        }
        // Unset _newCurrKtpSequences
        this._newCurrentKeytipSequences = undefined;
    };
    KeytipLayerBase.prototype._addKeytipToQueue = function (keytipID) {
        var _this = this;
        // Add keytip
        this._delayedKeytipQueue.push(keytipID);
        // Clear timeout
        this._delayedQueueTimeout && this._async.clearTimeout(this._delayedQueueTimeout);
        // Reset timeout
        this._delayedQueueTimeout = this._async.setTimeout(function () {
            if (_this._delayedKeytipQueue.length) {
                _this.showKeytips(_this._delayedKeytipQueue);
                _this._delayedKeytipQueue = [];
            }
        }, 300);
    };
    KeytipLayerBase.prototype._removeKeytipFromQueue = function (keytipID) {
        var _this = this;
        var index = this._delayedKeytipQueue.indexOf(keytipID);
        if (index >= 0) {
            // Remove keytip
            this._delayedKeytipQueue.splice(index, 1);
            // Clear timeout
            this._delayedQueueTimeout && this._async.clearTimeout(this._delayedQueueTimeout);
            // Reset timeout
            this._delayedQueueTimeout = this._async.setTimeout(function () {
                if (_this._delayedKeytipQueue.length) {
                    _this.showKeytips(_this._delayedKeytipQueue);
                    _this._delayedKeytipQueue = [];
                }
            }, 300);
        }
    };
    KeytipLayerBase.prototype._getKtpExecuteTarget = function (currKtp) {
        return Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["I" /* getDocument */])().querySelector(Object(__WEBPACK_IMPORTED_MODULE_8__utilities_keytips_KeytipUtils__["b" /* ktpTargetFromId */])(currKtp.id));
    };
    KeytipLayerBase.prototype._getKtpTarget = function (currKtp) {
        return Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["I" /* getDocument */])().querySelector(Object(__WEBPACK_IMPORTED_MODULE_8__utilities_keytips_KeytipUtils__["c" /* ktpTargetFromSequences */])(currKtp.keySequences));
    };
    /**
     * Returns T/F if the keytipProps keySequences match the currentKeytip, and the currentKeytip is in an overflow well
     * This will make 'keytipProps' the new currentKeytip
     *
     * @param keytipProps - Keytip props to check
     * @returns - T/F if this keytip should become the currentKeytip
     */
    KeytipLayerBase.prototype._isCurrentKeytipAnAlias = function (keytipProps) {
        var currKtp = this._keytipTree.currentKeytip;
        if (currKtp && (currKtp.overflowSetSequence || currKtp.persisted) && Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["l" /* arraysEqual */])(keytipProps.keySequences, currKtp.keySequences)) {
            return true;
        }
        return false;
    };
    KeytipLayerBase.defaultProps = {
        keytipStartSequences: [defaultStartSequence],
        keytipExitSequences: [defaultExitSequence],
        keytipReturnSequences: [defaultReturnSequence],
        content: ''
    };
    return KeytipLayerBase;
}(__WEBPACK_IMPORTED_MODULE_5__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=KeytipLayer.base.js.map

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLayerStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var getLayerStyles = function (props) {
    return {
        root: [
            {
                // Prioritize the Keytips above all other Layers
                zIndex: __WEBPACK_IMPORTED_MODULE_0__Styling__["s" /* ZIndexes */].KeytipLayer
            }
        ]
    };
};
var getStyles = function (props) {
    return {
        innerContent: [
            {
                position: 'absolute',
                width: 0,
                height: 0,
                margin: 0,
                padding: 0,
                border: 0,
                overflow: 'hidden',
                visibility: 'hidden'
            }
        ]
    };
};
//# sourceMappingURL=KeytipLayer.styles.js.map

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MessageBarBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Icon__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MessageBar_types__ = __webpack_require__(439);






var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var MessageBarBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](MessageBarBase, _super);
    function MessageBarBase(props) {
        var _this = _super.call(this, props) || this;
        _this.ICON_MAP = (_a = {},
            _a[__WEBPACK_IMPORTED_MODULE_5__MessageBar_types__["a" /* MessageBarType */].info] = 'Info',
            _a[__WEBPACK_IMPORTED_MODULE_5__MessageBar_types__["a" /* MessageBarType */].warning] = 'Info',
            _a[__WEBPACK_IMPORTED_MODULE_5__MessageBar_types__["a" /* MessageBarType */].error] = 'ErrorBadge',
            _a[__WEBPACK_IMPORTED_MODULE_5__MessageBar_types__["a" /* MessageBarType */].blocked] = 'Blocked2',
            _a[__WEBPACK_IMPORTED_MODULE_5__MessageBar_types__["a" /* MessageBarType */].remove] = 'Blocked',
            _a[__WEBPACK_IMPORTED_MODULE_5__MessageBar_types__["a" /* MessageBarType */].severeWarning] = 'Warning',
            _a[__WEBPACK_IMPORTED_MODULE_5__MessageBar_types__["a" /* MessageBarType */].success] = 'Completed',
            _a);
        _this._onClick = function (ev) {
            _this.setState({ expandSingleLine: !_this.state.expandSingleLine });
        };
        _this.state = {
            labelId: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["N" /* getId */])('MessageBar'),
            showContent: false,
            expandSingleLine: false
        };
        return _this;
        var _a;
    }
    MessageBarBase.prototype.render = function () {
        var isMultiline = this.props.isMultiline;
        this._classNames = this._getClassNames();
        return isMultiline ? this._renderMultiLine() : this._renderSingleLine();
    };
    MessageBarBase.prototype._getActionsDiv = function () {
        if (this.props.actions) {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.actions }, this.props.actions);
        }
        return null;
    };
    MessageBarBase.prototype._getDismissDiv = function () {
        if (this.props.onDismiss) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Button__["g" /* IconButton */], { disabled: false, className: this._classNames.dismissal, onClick: this.props.onDismiss, iconProps: { iconName: 'Clear' }, ariaLabel: this.props.dismissButtonAriaLabel }));
        }
        return null;
    };
    MessageBarBase.prototype._getDismissSingleLine = function () {
        if (this.props.onDismiss) {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.dismissSingleLine }, this._getDismissDiv());
        }
        return null;
    };
    MessageBarBase.prototype._getExpandSingleLine = function () {
        if (!this.props.actions && this.props.truncated) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.expandSingleLine },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Button__["g" /* IconButton */], { disabled: false, className: this._classNames.expand, onClick: this._onClick, iconProps: { iconName: this.state.expandSingleLine ? 'DoubleChevronUp' : 'DoubleChevronDown' }, ariaLabel: this.props.overflowButtonAriaLabel, "aria-expanded": this.state.expandSingleLine, "aria-controls": this.state.labelId })));
        }
        return null;
    };
    MessageBarBase.prototype._getIconSpan = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.iconContainer, "aria-hidden": true },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Icon__["Icon"], { iconName: this.ICON_MAP[this.props.messageBarType], className: this._classNames.icon })));
    };
    MessageBarBase.prototype._renderMultiLine = function () {
        var theme = this.props.theme;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { style: { background: theme.semanticColors.bodyBackground } },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.root },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.content },
                    this._getIconSpan(),
                    this._renderInnerText(),
                    this._getDismissDiv()),
                this._getActionsDiv())));
    };
    MessageBarBase.prototype._renderSingleLine = function () {
        var theme = this.props.theme;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { style: { background: theme.semanticColors.bodyBackground } },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.root },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.content },
                    this._getIconSpan(),
                    this._renderInnerText(),
                    this._getExpandSingleLine(),
                    this._getActionsDiv(),
                    this._getDismissSingleLine()))));
    };
    MessageBarBase.prototype._renderInnerText = function () {
        var nativeProps = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["R" /* getNativeProps */])(this.props, __WEBPACK_IMPORTED_MODULE_2__Utilities__["_3" /* htmlElementProperties */], ['className']);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.text, id: this.state.labelId },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ className: this._classNames.innerText, role: "status", "aria-live": this._getAnnouncementPriority() }, nativeProps),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Utilities__["d" /* DelayedRender */], null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", null, this.props.children)))));
    };
    MessageBarBase.prototype._getClassNames = function () {
        var _a = this.props, theme = _a.theme, className = _a.className, messageBarType = _a.messageBarType, onDismiss = _a.onDismiss, actions = _a.actions, truncated = _a.truncated, isMultiline = _a.isMultiline;
        var expandSingleLine = this.state.expandSingleLine;
        return getClassNames(this.props.styles, {
            theme: theme,
            messageBarType: messageBarType || __WEBPACK_IMPORTED_MODULE_5__MessageBar_types__["a" /* MessageBarType */].info,
            onDismiss: onDismiss !== undefined,
            actions: actions !== undefined,
            truncated: truncated,
            isMultiline: isMultiline,
            expandSingleLine: expandSingleLine,
            className: className
        });
    };
    MessageBarBase.prototype._getAnnouncementPriority = function () {
        switch (this.props.messageBarType) {
            case __WEBPACK_IMPORTED_MODULE_5__MessageBar_types__["a" /* MessageBarType */].blocked:
            case __WEBPACK_IMPORTED_MODULE_5__MessageBar_types__["a" /* MessageBarType */].error:
            case __WEBPACK_IMPORTED_MODULE_5__MessageBar_types__["a" /* MessageBarType */].severeWarning:
                return 'assertive';
        }
        return 'polite';
    };
    MessageBarBase.defaultProps = {
        messageBarType: __WEBPACK_IMPORTED_MODULE_5__MessageBar_types__["a" /* MessageBarType */].info,
        onDismiss: undefined,
        isMultiline: true
    };
    return MessageBarBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=MessageBar.base.js.map

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isRelativeUrl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NavBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FocusZone__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Nav_styles__ = __webpack_require__(801);







// The number pixels per indentation level for Nav links.
var _indentationSize = 14;
// The number of pixels of left margin
var _baseIndent = 3;
// global var used in _isLinkSelectedKey
var _urlResolver;
function isRelativeUrl(url) {
    // A URL is relative if it has no protocol.
    return !!url && !/^[a-z0-9+-.]:\/\//i.test(url);
}
var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var NavBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](NavBase, _super);
    function NavBase(props) {
        var _this = _super.call(this, props) || this;
        _this._onRenderLink = function (link) {
            var _a = _this.props, styles = _a.styles, groups = _a.groups, theme = _a.theme;
            var classNames = getClassNames(styles, { theme: theme, groups: groups });
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.linkText }, link.name);
        };
        _this._renderGroup = function (group, groupIndex) {
            var _a = _this.props, styles = _a.styles, groups = _a.groups, theme = _a.theme, _b = _a.onRenderGroupHeader, onRenderGroupHeader = _b === void 0 ? _this._renderGroupHeader : _b;
            var classNames = getClassNames(styles, {
                theme: theme,
                isGroup: true,
                isExpanded: _this._isGroupExpanded(group),
                groups: groups
            });
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { key: groupIndex, className: classNames.group },
                group.name ? onRenderGroupHeader(group, _this._renderGroupHeader) : null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.groupContent }, _this._renderLinks(group.links, 0 /* nestingLevel */))));
        };
        _this._renderGroupHeader = function (group) {
            var _a = _this.props, styles = _a.styles, groups = _a.groups, theme = _a.theme, expandButtonAriaLabel = _a.expandButtonAriaLabel;
            var classNames = getClassNames(styles, {
                theme: theme,
                isGroup: true,
                isExpanded: _this._isGroupExpanded(group),
                groups: groups
            });
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("button", { className: classNames.chevronButton, onClick: _this._onGroupHeaderClicked.bind(_this, group), "aria-label": expandButtonAriaLabel, "aria-expanded": _this._isGroupExpanded(group) },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Icon__["Icon"], { className: classNames.chevronIcon, iconName: "ChevronDown" }),
                group.name));
        };
        _this.state = {
            isGroupCollapsed: {},
            isLinkExpandStateChanged: false,
            selectedKey: props.initialSelectedKey || props.selectedKey
        };
        return _this;
    }
    NavBase.prototype.render = function () {
        var _a = this.props, styles = _a.styles, groups = _a.groups, className = _a.className, isOnTop = _a.isOnTop, theme = _a.theme;
        if (!groups) {
            return null;
        }
        var groupElements = groups.map(this._renderGroup);
        var classNames = getClassNames(styles, { theme: theme, className: className, isOnTop: isOnTop, groups: groups });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__FocusZone__["a" /* FocusZone */], { direction: __WEBPACK_IMPORTED_MODULE_3__FocusZone__["b" /* FocusZoneDirection */].vertical },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("nav", { role: "navigation", className: classNames.root, "aria-label": this.props.ariaLabel }, groupElements)));
    };
    Object.defineProperty(NavBase.prototype, "selectedKey", {
        get: function () {
            return this.state.selectedKey;
        },
        enumerable: true,
        configurable: true
    });
    NavBase.prototype._renderNavLink = function (link, linkIndex, nestingLevel) {
        var _a = this.props, styles = _a.styles, groups = _a.groups, theme = _a.theme, _b = _a.onRenderLink, onRenderLink = _b === void 0 ? this._onRenderLink : _b, _c = _a.linkAs, LinkAs = _c === void 0 ? __WEBPACK_IMPORTED_MODULE_4__Button__["a" /* ActionButton */] : _c, selectedAriaLabel = _a.selectedAriaLabel;
        var isLinkWithIcon = link.icon || link.iconProps;
        var isSelectedLink = this._isLinkSelected(link);
        var classNames = getClassNames(styles, {
            theme: theme,
            isSelected: isSelectedLink,
            isDisabled: link.disabled,
            isButtonEntry: link.onClick && !link.forceAnchor,
            leftPadding: _indentationSize * nestingLevel + _baseIndent + (isLinkWithIcon ? 0 : 24),
            groups: groups
        });
        // Prevent hijacking of the parent window if link.target is defined
        var rel = link.url && link.target && !isRelativeUrl(link.url) ? 'noopener noreferrer' : undefined;
        var selectedStateAriaLabel = isSelectedLink && selectedAriaLabel ? selectedAriaLabel : undefined;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](LinkAs, { className: classNames.link, styles: __WEBPACK_IMPORTED_MODULE_6__Nav_styles__["a" /* buttonStyles */], href: link.url || (link.forceAnchor ? 'javascript:' : undefined), iconProps: link.iconProps || { iconName: link.icon }, onClick: link.onClick ? this._onNavButtonLinkClicked.bind(this, link) : this._onNavAnchorLinkClicked.bind(this, link), title: link.title || link.name, target: link.target, rel: rel, disabled: link.disabled, "aria-label": link.ariaLabel && selectedStateAriaLabel
                ? link.ariaLabel + " " + selectedStateAriaLabel
                : selectedStateAriaLabel
                    ? selectedStateAriaLabel
                    : link.ariaLabel
                        ? link.ariaLabel
                        : undefined }, onRenderLink(link, this._onRenderLink)));
    };
    NavBase.prototype._renderCompositeLink = function (link, linkIndex, nestingLevel) {
        var divProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["R" /* getNativeProps */])(link, __WEBPACK_IMPORTED_MODULE_2__Utilities__["w" /* divProperties */], ['onClick']));
        var _a = this.props, expandButtonAriaLabel = _a.expandButtonAriaLabel, styles = _a.styles, groups = _a.groups, theme = _a.theme;
        var classNames = getClassNames(styles, {
            theme: theme,
            isExpanded: !!link.isExpanded,
            isSelected: this._isLinkSelected(link),
            isLink: true,
            isDisabled: link.disabled,
            position: _indentationSize * nestingLevel + 1,
            groups: groups
        });
        var finalExpandBtnAriaLabel = expandButtonAriaLabel ? link.name + " " + expandButtonAriaLabel : link.name;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, divProps, { key: link.key || linkIndex, className: classNames.compositeLink }),
            link.links && link.links.length > 0 ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("button", { className: classNames.chevronButton, onClick: this._onLinkExpandClicked.bind(this, link), "aria-label": finalExpandBtnAriaLabel, "aria-expanded": link.isExpanded ? 'true' : 'false' },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Icon__["Icon"], { className: classNames.chevronIcon, iconName: "ChevronDown" }))) : null,
            this._renderNavLink(link, linkIndex, nestingLevel)));
    };
    NavBase.prototype._renderLink = function (link, linkIndex, nestingLevel) {
        var _a = this.props, styles = _a.styles, groups = _a.groups, theme = _a.theme;
        var classNames = getClassNames(styles, { theme: theme, groups: groups });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("li", { key: link.key || linkIndex, role: "listitem", className: classNames.navItem },
            this._renderCompositeLink(link, linkIndex, nestingLevel),
            link.isExpanded ? this._renderLinks(link.links, ++nestingLevel) : null));
    };
    NavBase.prototype._renderLinks = function (links, nestingLevel) {
        var _this = this;
        if (!links || !links.length) {
            return null;
        }
        var linkElements = links.map(function (link, linkIndex) {
            return _this._renderLink(link, linkIndex, nestingLevel);
        });
        var _a = this.props, styles = _a.styles, groups = _a.groups, theme = _a.theme;
        var classNames = getClassNames(styles, { theme: theme, groups: groups });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("ul", { role: "list", className: classNames.navItems }, linkElements));
    };
    NavBase.prototype._onGroupHeaderClicked = function (group, ev) {
        if (group.onHeaderClick) {
            group.onHeaderClick(ev, this._isGroupExpanded(group));
        }
        this._toggleCollapsed(group);
        ev.preventDefault();
        ev.stopPropagation();
    };
    NavBase.prototype._onLinkExpandClicked = function (link, ev) {
        var onLinkExpandClick = this.props.onLinkExpandClick;
        if (onLinkExpandClick) {
            onLinkExpandClick(ev, link);
        }
        if (!ev.defaultPrevented) {
            link.isExpanded = !link.isExpanded;
            this.setState({ isLinkExpandStateChanged: true });
        }
        ev.preventDefault();
        ev.stopPropagation();
    };
    NavBase.prototype._onNavAnchorLinkClicked = function (link, ev) {
        if (this.props.onLinkClick) {
            this.props.onLinkClick(ev, link);
        }
        if (!link.url && link.links && link.links.length > 0) {
            this._onLinkExpandClicked(link, ev);
        }
        this.setState({ selectedKey: link.key });
    };
    NavBase.prototype._onNavButtonLinkClicked = function (link, ev) {
        if (link.onClick) {
            link.onClick(ev, link);
        }
        if (!link.url && link.links && link.links.length > 0) {
            this._onLinkExpandClicked(link, ev);
        }
        this.setState({ selectedKey: link.key });
    };
    NavBase.prototype._isLinkSelected = function (link) {
        // if caller passes in selectedKey, use it as first choice or
        // if current state.selectedKey (from addressbar) is match to the link or
        // check if URL is matching location.href (if link.url exists)
        if (this.props.selectedKey !== undefined) {
            return link.key === this.props.selectedKey;
        }
        else if (this.state.selectedKey !== undefined) {
            return link.key === this.state.selectedKey;
        }
        else if (typeof Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["Z" /* getWindow */])() === 'undefined' || !link.url) {
            // resolve is not supported for ssr
            return false;
        }
        else {
            // If selectedKey is undefined in props and state, then check URL
            _urlResolver = _urlResolver || document.createElement('a');
            _urlResolver.href = link.url || '';
            var target = _urlResolver.href;
            if (location.href === target) {
                return true;
            }
            // If selectedKey is not defined in state, then check URL to determine link selected status
            if (location.protocol + '//' + location.host + location.pathname === target) {
                return true;
            }
            if (location.hash) {
                // Match the hash to the url.
                if (location.hash === link.url) {
                    return true;
                }
                // Match a rebased url. (e.g. #foo becomes http://hostname/foo)
                _urlResolver.href = location.hash.substring(1);
                return _urlResolver.href === target;
            }
        }
        return false;
    };
    NavBase.prototype._isGroupExpanded = function (group) {
        if (group.name && this.state.isGroupCollapsed.hasOwnProperty(group.name)) {
            return !this.state.isGroupCollapsed[group.name];
        }
        if (group.collapseByDefault !== undefined) {
            return !group.collapseByDefault;
        }
        return true;
    };
    NavBase.prototype._toggleCollapsed = function (group) {
        if (group.name) {
            var newGroupCollapsed = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this.state.isGroupCollapsed, (_a = {}, _a[group.name] = this._isGroupExpanded(group) // sic - presently open will be collapsed after setState
            , _a));
            this.setState({ isGroupCollapsed: newGroupCollapsed });
        }
        var _a;
    };
    NavBase.defaultProps = {
        groups: null
    };
    return NavBase;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=Nav.base.js.map

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buttonStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var GlobalClassNames = {
    root: 'ms-Nav',
    linkText: 'ms-Nav-linkText',
    compositeLink: 'ms-Nav-compositeLink',
    link: 'ms-Nav-link',
    chevronButton: 'ms-Nav-chevronButton',
    chevronIcon: 'ms-Nav-chevron',
    navItem: 'ms-Nav-navItem',
    navItems: 'ms-Nav-navItems',
    group: 'ms-Nav-group',
    groupContent: 'ms-Nav-groupContent'
};
var buttonStyles = {
    textContainer: {
        overflow: 'hidden'
    },
    label: {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        lineHeight: '36px'
    }
};
var getStyles = function (props) {
    var className = props.className, theme = props.theme, isOnTop = props.isOnTop, isExpanded = props.isExpanded, isGroup = props.isGroup, isLink = props.isLink, isSelected = props.isSelected, isDisabled = props.isDisabled, isButtonEntry = props.isButtonEntry, _a = props.navHeight, navHeight = _a === void 0 ? 36 : _a, position = props.position, _b = props.leftPadding, leftPadding = _b === void 0 ? 20 : _b, _c = props.leftPaddingExpanded, leftPaddingExpanded = _c === void 0 ? 28 : _c, _d = props.rightPadding, rightPadding = _d === void 0 ? 20 : _d;
    var palette = theme.palette, semanticColors = theme.semanticColors;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            className,
            theme.fonts.medium,
            {
                overflowY: 'auto',
                userSelect: 'none',
                WebkitOverflowScrolling: 'touch'
            },
            isOnTop && [
                {
                    position: 'absolute'
                },
                __WEBPACK_IMPORTED_MODULE_0__Styling__["a" /* AnimationClassNames */].slideRightIn40
            ]
        ],
        linkText: [
            classNames.linkText,
            {
                margin: '0 4px',
                overflow: 'hidden',
                verticalAlign: 'middle',
                textAlign: 'left',
                textOverflow: 'ellipsis'
            }
        ],
        compositeLink: [
            classNames.compositeLink,
            {
                display: 'block',
                position: 'relative',
                color: semanticColors.bodyText,
                backgroundColor: semanticColors.bodyBackground
            },
            isExpanded && 'is-expanded',
            isSelected && 'is-selected',
            isDisabled && 'is-disabled',
            isDisabled && {
                color: semanticColors.disabledText
            }
        ],
        link: [
            classNames.link,
            Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["v" /* getFocusStyle */])(theme),
            {
                display: 'block',
                position: 'relative',
                height: navHeight + "px",
                width: '100%',
                lineHeight: navHeight + "px",
                textDecoration: 'none',
                cursor: 'pointer',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                paddingLeft: leftPadding,
                paddingRight: rightPadding,
                color: semanticColors.bodyText,
                selectors: !isDisabled
                    ? {
                        '.ms-Nav-compositeLink:hover &': {
                            backgroundColor: palette.neutralLighterAlt,
                            color: semanticColors.bodyText
                        }
                    }
                    : {}
            },
            isSelected && {
                color: palette.themePrimary,
                backgroundColor: palette.neutralLighter,
                selectors: {
                    '&:after': {
                        borderLeft: "2px solid " + palette.themePrimary,
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        pointerEvents: 'none'
                    }
                }
            },
            isDisabled && {
                color: semanticColors.disabledText
            },
            isButtonEntry && {
                color: palette.themePrimary
            }
        ],
        chevronButton: [
            classNames.chevronButton,
            Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["v" /* getFocusStyle */])(theme),
            {
                display: 'block',
                fontWeight: __WEBPACK_IMPORTED_MODULE_0__Styling__["f" /* FontWeights */].regular,
                fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].small,
                textAlign: 'left',
                lineHeight: navHeight + "px",
                margin: '5px 0',
                padding: "0px, " + rightPadding + "px, 0px, " + leftPaddingExpanded + "px",
                border: 'none',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                cursor: 'pointer',
                color: semanticColors.bodyText,
                backgroundColor: 'transparent',
                selectors: {
                    '&:visited': {
                        color: 'inherit'
                    },
                    '&:hover': {
                        color: semanticColors.bodyText,
                        backgroundColor: palette.neutralLighterAlt
                    },
                    '$compositeLink:hover &': {
                        color: semanticColors.bodyText,
                        backgroundColor: palette.neutralLighterAlt
                    }
                }
            },
            isGroup && [
                {
                    width: '100%',
                    height: navHeight + "px",
                    borderBottom: "1px solid " + semanticColors.bodyDivider
                },
                __WEBPACK_IMPORTED_MODULE_0__Styling__["d" /* DefaultFontStyles */].large
            ],
            isLink && [
                {
                    display: 'block',
                    width: leftPaddingExpanded - 2 + "px",
                    height: navHeight - 2 + "px",
                    position: 'absolute',
                    top: '1px',
                    left: position + "px",
                    zIndex: __WEBPACK_IMPORTED_MODULE_0__Styling__["s" /* ZIndexes */].Nav,
                    padding: 0,
                    margin: 0
                }
            ],
            isSelected && {
                color: palette.themePrimary,
                backgroundColor: palette.neutralLighterAlt,
                selectors: {
                    '&:after': {
                        borderLeft: "2px solid " + palette.themePrimary,
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        pointerEvents: 'none'
                    }
                }
            }
        ],
        chevronIcon: [
            classNames.chevronIcon,
            {
                position: 'absolute',
                left: '8px',
                height: navHeight + "px",
                lineHeight: navHeight + "px",
                fontSize: '12px',
                transition: 'transform .1s linear'
            },
            isExpanded && {
                transform: 'rotate(-180deg)'
            },
            isLink && {
                top: 0
            }
        ],
        navItem: [
            classNames.navItem,
            {
                padding: 0
            }
        ],
        navItems: [
            classNames.navItems,
            {
                listStyleType: 'none',
                padding: 0
            }
        ],
        group: [classNames.group, isExpanded && 'is-expanded'],
        groupContent: [
            classNames.groupContent,
            {
                display: 'none',
                marginBottom: '40px'
            },
            __WEBPACK_IMPORTED_MODULE_0__Styling__["a" /* AnimationClassNames */].slideDownIn20,
            isExpanded && {
                display: 'block'
            }
        ]
    };
};
//# sourceMappingURL=Nav.styles.js.map

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PivotBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FocusZone__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PivotItem__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Pivot_types__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Icon__ = __webpack_require__(12);









var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var PivotItemType = __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__PivotItem__["a" /* PivotItem */], null).type;
/**
 *  Usage:
 *
 *     <Pivot>
 *       <PivotItem headerText="Foo">
 *         <Label>Pivot #1</Label>
 *       </PivotItem>
 *       <PivotItem headerText="Bar">
 *         <Label>Pivot #2</Label>
 *       </PivotItem>
 *       <PivotItem headerText="Bas">
 *         <Label>Pivot #3</Label>
 *       </PivotItem>
 *     </Pivot>
 */
var PivotBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](PivotBase, _super);
    function PivotBase(props) {
        var _this = _super.call(this, props) || this;
        _this._focusZone = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._renderPivotLink = function (linkCollection, link, selectedKey) {
            var itemKey = link.itemKey, headerButtonProps = link.headerButtonProps;
            var tabId = linkCollection.keyToTabIdMapping[itemKey];
            var onRenderItemLink = link.onRenderItemLink;
            var linkContent;
            var isSelected = selectedKey === itemKey;
            if (onRenderItemLink) {
                linkContent = onRenderItemLink(link, _this._renderLinkContent);
            }
            else {
                linkContent = _this._renderLinkContent(link);
            }
            var contentString = link.headerText || '';
            contentString += link.itemCount ? ' (' + link.itemCount + ')' : '';
            // Adding space supplementary for icon
            contentString += link.itemIcon ? ' xx' : '';
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Button__["e" /* CommandButton */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, headerButtonProps, { id: tabId, key: itemKey, className: isSelected ? _this._classNames.linkIsSelected : _this._classNames.link, onClick: _this._onLinkClick.bind(_this, itemKey), onKeyPress: _this._onKeyPress.bind(_this, itemKey), ariaLabel: link.ariaLabel, role: "tab", "aria-selected": isSelected, name: link.headerText, keytipProps: link.keytipProps, "data-content": contentString }), linkContent));
        };
        _this._renderLinkContent = function (link) {
            var itemCount = link.itemCount, itemIcon = link.itemIcon, headerText = link.headerText;
            var classNames = _this._classNames;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: classNames.linkContent },
                itemIcon !== undefined && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: classNames.icon },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Icon__["Icon"], { iconName: itemIcon }))),
                headerText !== undefined && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: classNames.text },
                    " ",
                    link.headerText),
                itemCount !== undefined && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: classNames.count },
                    " (",
                    itemCount,
                    ")")));
        };
        _this._warnDeprecations({
            initialSelectedKey: 'defaultSelectedKey',
            initialSelectedIndex: 'defaultSelectedIndex'
        });
        _this._pivotId = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["N" /* getId */])('Pivot');
        var links = _this._getPivotLinks(props).links;
        var _a = props.defaultSelectedKey, defaultSelectedKey = _a === void 0 ? props.initialSelectedKey : _a, _b = props.defaultSelectedIndex, defaultSelectedIndex = _b === void 0 ? props.initialSelectedIndex : _b;
        var selectedKey;
        if (defaultSelectedKey) {
            selectedKey = defaultSelectedKey;
        }
        else if (typeof defaultSelectedIndex === 'number') {
            selectedKey = links[defaultSelectedIndex].itemKey;
        }
        else if (links.length) {
            selectedKey = links[0].itemKey;
        }
        _this.state = {
            selectedKey: selectedKey
        };
        return _this;
    }
    /**
     * Sets focus to the first pivot tab.
     */
    PivotBase.prototype.focus = function () {
        if (this._focusZone.current) {
            this._focusZone.current.focus();
        }
    };
    PivotBase.prototype.render = function () {
        var linkCollection = this._getPivotLinks(this.props);
        var selectedKey = this._getSelectedKey(linkCollection);
        var divProps = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["R" /* getNativeProps */])(this.props, __WEBPACK_IMPORTED_MODULE_2__Utilities__["w" /* divProperties */]);
        this._classNames = this._getClassNames(this.props);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, divProps),
            this._renderPivotLinks(linkCollection, selectedKey),
            selectedKey && this._renderPivotItem(linkCollection, selectedKey)));
    };
    PivotBase.prototype._getSelectedKey = function (linkCollection) {
        var propsSelectedKey = this.props.selectedKey;
        if (this._isKeyValid(linkCollection, propsSelectedKey) || propsSelectedKey === null) {
            return propsSelectedKey;
        }
        var stateSelectedKey = this.state.selectedKey;
        if (this._isKeyValid(linkCollection, stateSelectedKey)) {
            return stateSelectedKey;
        }
        if (linkCollection.links.length) {
            return linkCollection.links[0].itemKey;
        }
        return undefined;
    };
    /**
     * Renders the set of links to route between pivots
     */
    PivotBase.prototype._renderPivotLinks = function (linkCollection, selectedKey) {
        var _this = this;
        var items = linkCollection.links.map(function (l) { return _this._renderPivotLink(linkCollection, l, selectedKey); });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__FocusZone__["a" /* FocusZone */], { componentRef: this._focusZone, direction: __WEBPACK_IMPORTED_MODULE_4__FocusZone__["b" /* FocusZoneDirection */].horizontal },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.root, role: "tablist" }, items)));
    };
    /**
     * Renders the current Pivot Item
     */
    PivotBase.prototype._renderPivotItem = function (linkCollection, itemKey) {
        if (this.props.headersOnly || !itemKey) {
            return null;
        }
        var index = linkCollection.keyToIndexMapping[itemKey];
        var selectedTabId = linkCollection.keyToTabIdMapping[itemKey];
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { role: "tabpanel", "aria-labelledby": selectedTabId, className: this._classNames.itemContainer }, __WEBPACK_IMPORTED_MODULE_1_react__["Children"].toArray(this.props.children)[index]));
    };
    /**
     * Gets the set of PivotLinks as array of IPivotItemProps
     * The set of Links is determined by child components of type PivotItem
     */
    PivotBase.prototype._getPivotLinks = function (props) {
        var _this = this;
        var result = {
            links: [],
            keyToIndexMapping: {},
            keyToTabIdMapping: {}
        };
        __WEBPACK_IMPORTED_MODULE_1_react__["Children"].map(__WEBPACK_IMPORTED_MODULE_1_react__["Children"].toArray(props.children), function (child, index) {
            if (typeof child === 'object' && child.type === PivotItemType) {
                var pivotItem = child;
                var _a = pivotItem.props, linkText = _a.linkText, pivotItemProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __rest */](_a, ["linkText"]);
                var itemKey = pivotItem.props.itemKey || index.toString();
                result.links.push(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ 
                    // Use linkText (deprecated) if headerText is not provided
                    headerText: linkText }, pivotItemProps, { itemKey: itemKey }));
                result.keyToIndexMapping[itemKey] = index;
                result.keyToTabIdMapping[itemKey] = _this._getTabId(itemKey, index);
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_34" /* warn */])('The children of a Pivot component must be of type PivotItem to be rendered.');
            }
        });
        return result;
    };
    /**
     * Generates the Id for the tab button.
     */
    PivotBase.prototype._getTabId = function (itemKey, index) {
        if (this.props.getTabId) {
            return this.props.getTabId(itemKey, index);
        }
        return this._pivotId + ("-Tab" + index);
    };
    /**
     * whether the key exists in the pivot items.
     */
    PivotBase.prototype._isKeyValid = function (linkCollection, itemKey) {
        return itemKey !== undefined && itemKey !== null && linkCollection.keyToIndexMapping[itemKey] !== undefined;
    };
    /**
     * Handles the onClick event on PivotLinks
     */
    PivotBase.prototype._onLinkClick = function (itemKey, ev) {
        ev.preventDefault();
        this._updateSelectedItem(itemKey, ev);
    };
    /**
     * Handle the onKeyPress eventon the PivotLinks
     */
    PivotBase.prototype._onKeyPress = function (itemKey, ev) {
        if (ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].enter) {
            ev.preventDefault();
            this._updateSelectedItem(itemKey);
        }
    };
    /**
     * Updates the state with the new selected index
     */
    PivotBase.prototype._updateSelectedItem = function (itemKey, ev) {
        this.setState({
            selectedKey: itemKey
        });
        var linkCollection = this._getPivotLinks(this.props);
        if (this.props.onLinkClick && linkCollection.keyToIndexMapping[itemKey] >= 0) {
            var index = linkCollection.keyToIndexMapping[itemKey];
            // React.Element<any> cannot directly convert to PivotItem.
            var item = __WEBPACK_IMPORTED_MODULE_1_react__["Children"].toArray(this.props.children)[index];
            if (typeof item === 'object' && item.type === PivotItemType) {
                this.props.onLinkClick(item, ev);
            }
        }
    };
    PivotBase.prototype._getClassNames = function (props) {
        var theme = props.theme;
        var rootIsLarge = props.linkSize === __WEBPACK_IMPORTED_MODULE_6__Pivot_types__["b" /* PivotLinkSize */].large;
        var rootIsTabs = props.linkFormat === __WEBPACK_IMPORTED_MODULE_6__Pivot_types__["a" /* PivotLinkFormat */].tabs;
        return getClassNames(props.styles, {
            theme: theme,
            rootIsLarge: rootIsLarge,
            rootIsTabs: rootIsTabs
        });
    };
    return PivotBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=Pivot.base.js.map

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PivotItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);



var PivotItem = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](PivotItem, _super);
    function PivotItem(props) {
        var _this = _super.call(this, props) || this;
        _this._warnDeprecations({
            linkText: 'headerText'
        });
        return _this;
    }
    PivotItem.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["R" /* getNativeProps */])(this.props, __WEBPACK_IMPORTED_MODULE_2__Utilities__["w" /* divProperties */])), this.props.children);
    };
    return PivotItem;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=PivotItem.js.map

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProgressIndicatorBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);



var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
// if the percentComplete is near 0, don't animate it.
// This prevents animations on reset to 0 scenarios
var ZERO_THRESHOLD = 0.01;
/**
 * ProgressIndicator with no default styles.
 * [Use the `styles` API to add your own styles.](https://github.com/OfficeDev/office-ui-fabric-react/wiki/Styling)
 */
var ProgressIndicatorBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ProgressIndicatorBase, _super);
    function ProgressIndicatorBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onRenderProgress = function (props) {
            var _a = _this.props, ariaValueText = _a.ariaValueText, barHeight = _a.barHeight, className = _a.className, styles = _a.styles, theme = _a.theme;
            var percentComplete = typeof _this.props.percentComplete === 'number' ? Math.min(100, Math.max(0, _this.props.percentComplete * 100)) : undefined;
            var classNames = getClassNames(styles, {
                theme: theme,
                className: className,
                barHeight: barHeight,
                indeterminate: percentComplete === undefined ? true : false
            });
            var progressBarStyles = {
                width: percentComplete !== undefined ? percentComplete + '%' : undefined,
                transition: percentComplete !== undefined && percentComplete < ZERO_THRESHOLD ? 'none' : undefined
            };
            var ariaValueMin = percentComplete !== undefined ? 0 : undefined;
            var ariaValueMax = percentComplete !== undefined ? 100 : undefined;
            var ariaValueNow = percentComplete !== undefined ? Math.floor(percentComplete) : undefined;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.itemProgress },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.progressTrack }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.progressBar, style: progressBarStyles, role: "progressbar", "aria-valuemin": ariaValueMin, "aria-valuemax": ariaValueMax, "aria-valuenow": ariaValueNow, "aria-valuetext": ariaValueText })));
        };
        return _this;
    }
    ProgressIndicatorBase.prototype.render = function () {
        var _a = this.props, barHeight = _a.barHeight, className = _a.className, _b = _a.label, label = _b === void 0 ? this.props.title : _b, // Fall back to deprecated value.
        description = _a.description, styles = _a.styles, theme = _a.theme, progressHidden = _a.progressHidden, _c = _a.onRenderProgress, onRenderProgress = _c === void 0 ? this._onRenderProgress : _c;
        var percentComplete = typeof this.props.percentComplete === 'number' ? Math.min(100, Math.max(0, this.props.percentComplete * 100)) : undefined;
        var classNames = getClassNames(styles, {
            theme: theme,
            className: className,
            barHeight: barHeight,
            indeterminate: percentComplete === undefined ? true : false
        });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.root },
            label ? __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.itemName }, label) : null,
            !progressHidden
                ? onRenderProgress(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this.props, { percentComplete: percentComplete }), this._onRenderProgress)
                : null,
            description ? __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.itemDescription }, description) : null));
    };
    ProgressIndicatorBase.defaultProps = {
        label: '',
        description: '',
        width: 180
    };
    return ProgressIndicatorBase;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=ProgressIndicator.base.js.map

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RatingBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icon__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FocusZone__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Rating_types__ = __webpack_require__(806);






var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var RatingStar = function (props) {
    var icon = props.icon || 'FavoriteStarFill';
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: props.classNames.ratingStar, key: props.id },
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Icon__["Icon"], { className: props.classNames.ratingStarBack, iconName: icon }),
        !props.disabled && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Icon__["Icon"], { className: props.classNames.ratingStarFront, iconName: icon, style: { width: props.fillPercentage + '%' } }))));
};
var RatingBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](RatingBase, _super);
    function RatingBase(props) {
        var _this = _super.call(this, props) || this;
        _this._warnDeprecations({
            onChanged: 'onChange'
        });
        _this._id = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["N" /* getId */])('Rating');
        _this._min = _this.props.allowZeroStars ? 0 : 1;
        if (_this.props.min !== undefined && _this.props.min !== 1) {
            _this._min = _this.props.min;
        }
        _this._labelId = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["N" /* getId */])('RatingLabel');
        _this.state = {
            rating: _this._getInitialValue(props)
        };
        return _this;
    }
    RatingBase.prototype.componentWillReceiveProps = function (nextProps) {
        if (typeof nextProps.rating !== 'undefined' && nextProps.rating !== this.state.rating) {
            this.setState({
                rating: this._getClampedRating(nextProps.rating)
            });
        }
    };
    RatingBase.prototype.render = function () {
        var id = this._id;
        var stars = [];
        var starIds = [];
        var _a = this.props, disabled = _a.disabled, getAriaLabel = _a.getAriaLabel, styles = _a.styles, max = _a.max, rating = _a.rating, readOnly = _a.readOnly, size = _a.size, theme = _a.theme, _b = _a.icon, icon = _b === void 0 ? 'FavoriteStarFill' : _b, _c = _a.unselectedIcon, unselectedIcon = _c === void 0 ? 'FavoriteStar' : _c;
        var divProps = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["R" /* getNativeProps */])(this.props, __WEBPACK_IMPORTED_MODULE_2__Utilities__["w" /* divProperties */]);
        this._classNames = getClassNames(styles, {
            disabled: disabled,
            readOnly: readOnly,
            theme: theme
        });
        for (var i = this._min; i <= max; i++) {
            if (i !== 0) {
                var fillPercentage = this._getFillingPercentage(i);
                var ratingStarProps = {
                    fillPercentage: fillPercentage,
                    disabled: disabled ? true : false,
                    readOnly: readOnly ? true : false,
                    classNames: this._classNames,
                    icon: fillPercentage > 0 ? icon : unselectedIcon
                };
                starIds.push(this._getStarId(i - 1));
                stars.push(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("button", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])(this._classNames.ratingButton, (_d = {},
                        _d[this._classNames.ratingStarIsLarge] = size === __WEBPACK_IMPORTED_MODULE_5__Rating_types__["a" /* RatingSize */].Large,
                        _d[this._classNames.ratingStarIsSmall] = size !== __WEBPACK_IMPORTED_MODULE_5__Rating_types__["a" /* RatingSize */].Large,
                        _d)), id: starIds[i - 1], key: i }, (i === Math.ceil(this.state.rating) ? { 'data-is-current': true } : {}), { onFocus: this._onFocus.bind(this, i), onClick: this._onFocus.bind(this, i), disabled: disabled || readOnly ? true : false, role: "presentation", type: "button" }),
                    this._getLabel(i),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](RatingStar, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ key: i + 'rating' }, ratingStarProps))));
            }
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-Rating-star', this._classNames.root, (_e = {},
                _e[this._classNames.rootIsLarge] = size === __WEBPACK_IMPORTED_MODULE_5__Rating_types__["a" /* RatingSize */].Large,
                _e[this._classNames.rootIsSmall] = size !== __WEBPACK_IMPORTED_MODULE_5__Rating_types__["a" /* RatingSize */].Large,
                _e)), "aria-label": getAriaLabel ? getAriaLabel(this.state.rating ? this.state.rating : 0, this.props.max) : '', id: id }, divProps),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__FocusZone__["a" /* FocusZone */], { direction: __WEBPACK_IMPORTED_MODULE_4__FocusZone__["b" /* FocusZoneDirection */].horizontal, tabIndex: readOnly ? 0 : -1, className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])(this._classNames.ratingFocusZone, (_f = {},
                    _f[this._classNames.rootIsLarge] = size === __WEBPACK_IMPORTED_MODULE_5__Rating_types__["a" /* RatingSize */].Large,
                    _f[this._classNames.rootIsSmall] = size !== __WEBPACK_IMPORTED_MODULE_5__Rating_types__["a" /* RatingSize */].Large,
                    _f)), "data-is-focusable": readOnly ? true : false, defaultActiveElement: rating ? starIds[rating - 1] && '#' + starIds[rating - 1] : undefined }, stars)));
        var _d, _e, _f;
    };
    RatingBase.prototype._getStarId = function (index) {
        return this._id + '-star-' + index;
    };
    RatingBase.prototype._onFocus = function (value, ev) {
        if (this.state.rating !== value) {
            this.setState({
                rating: value
            });
            var _a = this.props, onChange = _a.onChange, onChanged = _a.onChanged;
            if (onChange) {
                onChange(ev, value);
            }
            if (onChanged) {
                onChanged(value);
            }
        }
    };
    RatingBase.prototype._getLabel = function (rating) {
        var text = this.props.ariaLabelFormat || '';
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { id: this._labelId + "-" + rating, className: this._classNames.labelText }, Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["G" /* format */])(text, rating, this.props.max)));
    };
    RatingBase.prototype._getInitialValue = function (props) {
        if (typeof props.rating === 'undefined') {
            return this._min;
        }
        if (props.rating === null) {
            return undefined;
        }
        return this._getClampedRating(props.rating);
    };
    RatingBase.prototype._getClampedRating = function (rating) {
        return Math.min(Math.max(rating, this._min), this.props.max);
    };
    RatingBase.prototype._getFillingPercentage = function (starPosition) {
        var ceilValue = Math.ceil(this.state.rating);
        var fillPercentage = 100;
        if (starPosition === this.state.rating) {
            fillPercentage = 100;
        }
        else if (starPosition === ceilValue) {
            fillPercentage = 100 * (this.state.rating % 1);
        }
        else if (starPosition > ceilValue) {
            fillPercentage = 0;
        }
        return fillPercentage;
    };
    RatingBase.defaultProps = {
        min: 1,
        max: 5
    };
    return RatingBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=Rating.base.js.map

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RatingSize; });
/**
 * {@docCategory Rating}
 */
var RatingSize;
(function (RatingSize) {
    RatingSize[RatingSize["Small"] = 0] = "Small";
    RatingSize[RatingSize["Large"] = 1] = "Large";
})(RatingSize || (RatingSize = {}));
//# sourceMappingURL=Rating.types.js.map

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollablePaneBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utilities__ = __webpack_require__(1);




var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["r" /* classNamesFunction */])();
var ScrollablePaneBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ScrollablePaneBase, _super);
    function ScrollablePaneBase(props) {
        var _this = _super.call(this, props) || this;
        _this._root = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._stickyAboveRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._stickyBelowRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._contentContainer = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.subscribe = function (handler) {
            _this._subscribers.add(handler);
        };
        _this.unsubscribe = function (handler) {
            _this._subscribers.delete(handler);
        };
        _this.addSticky = function (sticky) {
            _this._stickies.add(sticky);
            // If ScrollablePane is mounted, then sort sticky in correct place
            if (_this.contentContainer) {
                sticky.setDistanceFromTop(_this.contentContainer);
                _this.sortSticky(sticky);
            }
        };
        _this.removeSticky = function (sticky) {
            _this._stickies.delete(sticky);
            _this._removeStickyFromContainers(sticky);
            _this.notifySubscribers();
        };
        _this.sortSticky = function (sticky, sortAgain) {
            if (_this.stickyAbove && _this.stickyBelow) {
                if (sortAgain) {
                    _this._removeStickyFromContainers(sticky);
                }
                if (sticky.canStickyTop && sticky.stickyContentTop) {
                    _this._addToStickyContainer(sticky, _this.stickyAbove, sticky.stickyContentTop);
                }
                if (sticky.canStickyBottom && sticky.stickyContentBottom) {
                    _this._addToStickyContainer(sticky, _this.stickyBelow, sticky.stickyContentBottom);
                }
            }
        };
        _this.updateStickyRefHeights = function () {
            var stickyItems = _this._stickies;
            var stickyTopHeight = 0;
            var stickyBottomHeight = 0;
            stickyItems.forEach(function (sticky) {
                var _a = sticky.state, isStickyTop = _a.isStickyTop, isStickyBottom = _a.isStickyBottom;
                if (sticky.nonStickyContent) {
                    if (isStickyTop) {
                        stickyTopHeight += sticky.nonStickyContent.offsetHeight;
                    }
                    if (isStickyBottom) {
                        stickyBottomHeight += sticky.nonStickyContent.offsetHeight;
                    }
                    _this._checkStickyStatus(sticky);
                }
            });
            _this.setState({
                stickyTopHeight: stickyTopHeight,
                stickyBottomHeight: stickyBottomHeight
            });
        };
        _this.notifySubscribers = function () {
            if (_this.contentContainer) {
                _this._subscribers.forEach(function (handle) {
                    // this.stickyBelow is passed in for calculating distance to determine Sticky status
                    handle(_this.contentContainer, _this.stickyBelow);
                });
            }
        };
        _this.getScrollPosition = function () {
            if (_this.contentContainer) {
                return _this.contentContainer.scrollTop;
            }
            return 0;
        };
        _this.syncScrollSticky = function (sticky) {
            if (sticky && _this.contentContainer) {
                sticky.syncScroll(_this.contentContainer);
            }
        };
        _this._addToStickyContainer = function (sticky, stickyContainer, stickyContentToAdd) {
            // If there's no children, append child to list, otherwise, sort though array and append at correct position
            if (!stickyContainer.children.length) {
                stickyContainer.appendChild(stickyContentToAdd);
            }
            else {
                // If stickyContentToAdd isn't a child element of target container, then append
                if (!stickyContainer.contains(stickyContentToAdd)) {
                    var stickyChildrenElements_1 = [].slice.call(stickyContainer.children);
                    var stickyList_1 = [];
                    // Get stickies.  Filter by canStickyTop/Bottom, then sort by distance from top, and then
                    // filter by elements that are in the stickyContainer already.
                    _this._stickies.forEach(function (stickyItem) {
                        if (stickyContainer === _this.stickyAbove && sticky.canStickyTop) {
                            stickyList_1.push(stickyItem);
                        }
                        else if (sticky.canStickyBottom) {
                            stickyList_1.push(stickyItem);
                        }
                    });
                    var stickyListSorted = stickyList_1
                        .sort(function (a, b) {
                        return (a.state.distanceFromTop || 0) - (b.state.distanceFromTop || 0);
                    })
                        .filter(function (item) {
                        var stickyContent = stickyContainer === _this.stickyAbove ? item.stickyContentTop : item.stickyContentBottom;
                        if (stickyContent) {
                            return stickyChildrenElements_1.indexOf(stickyContent) > -1;
                        }
                    });
                    // Get first element that has a distance from top that is further than our sticky that is being added
                    var targetStickyToAppendBefore = undefined;
                    for (var i in stickyListSorted) {
                        if ((stickyListSorted[i].state.distanceFromTop || 0) >= (sticky.state.distanceFromTop || 0)) {
                            targetStickyToAppendBefore = stickyListSorted[i];
                            break;
                        }
                    }
                    // If target element to append before is known, then grab respective stickyContentTop/Bottom element and insert before
                    var targetContainer = null;
                    if (targetStickyToAppendBefore) {
                        targetContainer =
                            stickyContainer === _this.stickyAbove
                                ? targetStickyToAppendBefore.stickyContentTop
                                : targetStickyToAppendBefore.stickyContentBottom;
                    }
                    stickyContainer.insertBefore(stickyContentToAdd, targetContainer);
                }
            }
        };
        _this._removeStickyFromContainers = function (sticky) {
            if (_this.stickyAbove && sticky.stickyContentTop && _this.stickyAbove.contains(sticky.stickyContentTop)) {
                _this.stickyAbove.removeChild(sticky.stickyContentTop);
            }
            if (_this.stickyBelow && sticky.stickyContentBottom && _this.stickyBelow.contains(sticky.stickyContentBottom)) {
                _this.stickyBelow.removeChild(sticky.stickyContentBottom);
            }
        };
        _this._onWindowResize = function () {
            var scrollbarWidth = _this._getScrollbarWidth();
            var scrollbarHeight = _this._getScrollbarHeight();
            _this.setState({
                scrollbarWidth: scrollbarWidth,
                scrollbarHeight: scrollbarHeight
            });
            _this.notifySubscribers();
        };
        _this._getStickyContainerStyle = function (height, isTop) {
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ height: height }, (Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["V" /* getRTL */])()
                ? {
                    right: '0',
                    left: (_this.state.scrollbarWidth || _this._getScrollbarWidth() || 0) + "px"
                }
                : {
                    left: '0',
                    right: (_this.state.scrollbarWidth || _this._getScrollbarWidth() || 0) + "px"
                }), (isTop
                ? {
                    top: '0'
                }
                : {
                    bottom: (_this.state.scrollbarHeight || _this._getScrollbarHeight() || 0) + "px"
                }));
        };
        _this._onScroll = function () {
            var contentContainer = _this.contentContainer;
            if (contentContainer) {
                _this._stickies.forEach(function (sticky) {
                    sticky.syncScroll(contentContainer);
                });
            }
            _this._notifyThrottled();
        };
        _this._subscribers = new Set();
        _this._stickies = new Set();
        _this.state = {
            stickyTopHeight: 0,
            stickyBottomHeight: 0,
            scrollbarWidth: 0,
            scrollbarHeight: 0
        };
        _this._notifyThrottled = _this._async.throttle(_this.notifySubscribers, 50);
        return _this;
    }
    Object.defineProperty(ScrollablePaneBase.prototype, "root", {
        get: function () {
            return this._root.current;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScrollablePaneBase.prototype, "stickyAbove", {
        get: function () {
            return this._stickyAboveRef.current;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScrollablePaneBase.prototype, "stickyBelow", {
        get: function () {
            return this._stickyBelowRef.current;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScrollablePaneBase.prototype, "contentContainer", {
        get: function () {
            return this._contentContainer.current;
        },
        enumerable: true,
        configurable: true
    });
    ScrollablePaneBase.prototype.getChildContext = function () {
        return {
            scrollablePane: {
                subscribe: this.subscribe,
                unsubscribe: this.unsubscribe,
                addSticky: this.addSticky,
                removeSticky: this.removeSticky,
                updateStickyRefHeights: this.updateStickyRefHeights,
                sortSticky: this.sortSticky,
                notifySubscribers: this.notifySubscribers,
                syncScrollSticky: this.syncScrollSticky
            }
        };
    };
    ScrollablePaneBase.prototype.componentDidMount = function () {
        var _this = this;
        var initialScrollPosition = this.props.initialScrollPosition;
        this._events.on(this.contentContainer, 'scroll', this._onScroll);
        this._events.on(window, 'resize', this._onWindowResize);
        if (this.contentContainer && initialScrollPosition) {
            this.contentContainer.scrollTop = initialScrollPosition;
        }
        // Set sticky distances from top property, then sort in correct order and notify subscribers
        this.setStickiesDistanceFromTop();
        this._stickies.forEach(function (sticky) {
            _this.sortSticky(sticky);
        });
        this.notifySubscribers();
        if ('MutationObserver' in window) {
            this._mutationObserver = new MutationObserver(function (mutation) {
                // Function to check if mutation is occuring in stickyAbove or stickyBelow
                function checkIfMutationIsSticky(mutationRecord) {
                    if (this.stickyAbove !== null && this.stickyBelow !== null) {
                        return this.stickyAbove.contains(mutationRecord.target) || this.stickyBelow.contains(mutationRecord.target);
                    }
                    return false;
                }
                // Compute the scrollbar height which might have changed due to change in width of the content which might cause overflow
                var scrollbarHeight = _this._getScrollbarHeight();
                // check if the scroll bar height has changed and update the state so that it's postioned correctly below sticky footer
                if (scrollbarHeight !== _this.state.scrollbarHeight) {
                    _this.setState({
                        scrollbarHeight: scrollbarHeight
                    });
                }
                // Notify subscribers again to re-check whether Sticky should be Sticky'd or not
                _this.notifySubscribers();
                // If mutation occurs in sticky header or footer, then update sticky top/bottom heights
                if (mutation.some(checkIfMutationIsSticky.bind(_this))) {
                    _this.updateStickyRefHeights();
                }
                else {
                    // If mutation occurs in scrollable region, then find Sticky it belongs to and force update
                    var stickyList_2 = [];
                    _this._stickies.forEach(function (sticky) {
                        if (sticky.root && sticky.root.contains(mutation[0].target)) {
                            stickyList_2.push(sticky);
                        }
                    });
                    if (stickyList_2.length) {
                        stickyList_2.forEach(function (sticky) {
                            sticky.forceUpdate();
                        });
                    }
                }
            });
            if (this.root) {
                this._mutationObserver.observe(this.root, {
                    childList: true,
                    attributes: true,
                    subtree: true,
                    characterData: true
                });
            }
        }
    };
    ScrollablePaneBase.prototype.componentWillUnmount = function () {
        this._events.off(this.contentContainer);
        this._events.off(window);
        if (this._mutationObserver) {
            this._mutationObserver.disconnect();
        }
    };
    // Only updates if props/state change, just to prevent excessive setState with updateStickyRefHeights
    ScrollablePaneBase.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return (this.props.children !== nextProps.children ||
            this.props.initialScrollPosition !== nextProps.initialScrollPosition ||
            this.props.className !== nextProps.className ||
            this.state.stickyTopHeight !== nextState.stickyTopHeight ||
            this.state.stickyBottomHeight !== nextState.stickyBottomHeight ||
            this.state.scrollbarWidth !== nextState.scrollbarWidth ||
            this.state.scrollbarHeight !== nextState.scrollbarHeight);
    };
    ScrollablePaneBase.prototype.componentDidUpdate = function (prevProps, prevState) {
        var initialScrollPosition = this.props.initialScrollPosition;
        if (this.contentContainer && typeof initialScrollPosition === 'number' && prevProps.initialScrollPosition !== initialScrollPosition) {
            this.contentContainer.scrollTop = initialScrollPosition;
        }
        // Update subscribers when stickyTopHeight/stickyBottomHeight changes
        if (prevState.stickyTopHeight !== this.state.stickyTopHeight || prevState.stickyBottomHeight !== this.state.stickyBottomHeight) {
            this.notifySubscribers();
        }
        this._async.setTimeout(this._onWindowResize, 0);
    };
    ScrollablePaneBase.prototype.render = function () {
        var _a = this.props, className = _a.className, theme = _a.theme, styles = _a.styles;
        var _b = this.state, stickyTopHeight = _b.stickyTopHeight, stickyBottomHeight = _b.stickyBottomHeight;
        var classNames = getClassNames(styles, {
            theme: theme,
            className: className,
            scrollbarVisibility: this.props.scrollbarVisibility
        });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["R" /* getNativeProps */])(this.props, __WEBPACK_IMPORTED_MODULE_3__Utilities__["w" /* divProperties */]), { ref: this._root, className: classNames.root }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: this._contentContainer, className: classNames.contentContainer, "data-is-scrollable": true }, this.props.children),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: this._stickyAboveRef, className: classNames.stickyAbove, style: this._getStickyContainerStyle(stickyTopHeight, true) }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.stickyBelow, style: this._getStickyContainerStyle(stickyBottomHeight, false) },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: this._stickyBelowRef, className: classNames.stickyBelowItems }))));
    };
    ScrollablePaneBase.prototype.setStickiesDistanceFromTop = function () {
        var _this = this;
        if (this.contentContainer) {
            this._stickies.forEach(function (sticky) {
                sticky.setDistanceFromTop(_this.contentContainer);
            });
        }
    };
    ScrollablePaneBase.prototype.forceLayoutUpdate = function () {
        this._onWindowResize();
    };
    ScrollablePaneBase.prototype._checkStickyStatus = function (sticky) {
        if (this.stickyAbove && this.stickyBelow && this.contentContainer && sticky.nonStickyContent) {
            // If sticky is sticky, then append content to appropriate container
            if (sticky.state.isStickyTop || sticky.state.isStickyBottom) {
                if (sticky.state.isStickyTop && !this.stickyAbove.contains(sticky.nonStickyContent) && sticky.stickyContentTop) {
                    sticky.addSticky(sticky.stickyContentTop);
                }
                if (sticky.state.isStickyBottom && !this.stickyBelow.contains(sticky.nonStickyContent) && sticky.stickyContentBottom) {
                    sticky.addSticky(sticky.stickyContentBottom);
                }
            }
            else if (!this.contentContainer.contains(sticky.nonStickyContent)) {
                // Reset sticky if it's not sticky and not in the contentContainer element
                sticky.resetSticky();
            }
        }
    };
    ScrollablePaneBase.prototype._getScrollbarWidth = function () {
        var contentContainer = this.contentContainer;
        return contentContainer ? contentContainer.offsetWidth - contentContainer.clientWidth : 0;
    };
    ScrollablePaneBase.prototype._getScrollbarHeight = function () {
        var contentContainer = this.contentContainer;
        return contentContainer ? contentContainer.offsetHeight - contentContainer.clientHeight : 0;
    };
    ScrollablePaneBase.childContextTypes = {
        scrollablePane: __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"]
    };
    return ScrollablePaneBase;
}(__WEBPACK_IMPORTED_MODULE_3__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=ScrollablePane.base.js.map

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchBoxBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Icon__ = __webpack_require__(12);





var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var SearchBoxBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](SearchBoxBase, _super);
    function SearchBoxBase(props) {
        var _this = _super.call(this, props) || this;
        _this._rootElement = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._inputElement = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._onClickFocus = function () {
            var inputElement = _this._inputElement.current;
            if (inputElement) {
                _this.focus();
                inputElement.selectionStart = inputElement.selectionEnd = 0;
            }
        };
        _this._onFocusCapture = function (ev) {
            _this.setState({
                hasFocus: true
            });
            _this._events.on(ev.currentTarget, 'blur', _this._onBlur, true);
            if (_this.props.onFocus) {
                _this.props.onFocus(ev);
            }
        };
        _this._onClearClick = function (ev) {
            var clearButtonProps = _this.props.clearButtonProps;
            if (clearButtonProps && clearButtonProps.onClick) {
                clearButtonProps.onClick(ev);
            }
            if (!ev.defaultPrevented) {
                _this._onClear(ev);
            }
        };
        _this._onKeyDown = function (ev) {
            switch (ev.which) {
                case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].escape:
                    _this.props.onEscape && _this.props.onEscape(ev);
                    if (!ev.defaultPrevented) {
                        _this._onClear(ev);
                    }
                    break;
                case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].enter:
                    if (_this.props.onSearch) {
                        _this.props.onSearch(_this.state.value);
                        break;
                    }
                    // if we don't handle the enter press then we shouldn't prevent default
                    return;
                default:
                    _this.props.onKeyDown && _this.props.onKeyDown(ev);
                    if (!ev.defaultPrevented) {
                        return;
                    }
            }
            // We only get here if the keypress has been handled,
            // or preventDefault was called in case of default keyDown handler
            ev.preventDefault();
            ev.stopPropagation();
        };
        _this._onBlur = function (ev) {
            _this._events.off(_this._rootElement.current, 'blur');
            _this.setState({
                hasFocus: false
            });
            if (_this.props.onBlur) {
                _this.props.onBlur(ev);
            }
        };
        _this._onInputChange = function (ev) {
            var value = ev.target.value;
            if (value === _this._latestValue) {
                return;
            }
            _this._latestValue = value;
            _this.setState({ value: value });
            _this._callOnChange(value);
        };
        _this._warnDeprecations({
            labelText: 'placeholder',
            defaultValue: 'value'
        });
        _this._latestValue = props.value || '';
        _this.state = {
            value: _this._latestValue,
            hasFocus: false,
            id: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["N" /* getId */])('SearchBox')
        };
        return _this;
    }
    SearchBoxBase.prototype.componentWillReceiveProps = function (newProps) {
        if (newProps.value !== undefined) {
            this._latestValue = newProps.value;
            // If the user passes in null, substitute an empty string
            // (passing null is not allowed per typings, but users might do it anyway)
            this.setState({
                value: newProps.value || ''
            });
        }
    };
    SearchBoxBase.prototype.render = function () {
        var _a = this.props, ariaLabel = _a.ariaLabel, placeholder = _a.placeholder, className = _a.className, disabled = _a.disabled, underlined = _a.underlined, styles = _a.styles, labelText = _a.labelText, theme = _a.theme, clearButtonProps = _a.clearButtonProps, disableAnimation = _a.disableAnimation, iconProps = _a.iconProps;
        var _b = this.state, value = _b.value, hasFocus = _b.hasFocus, id = _b.id;
        var placeholderValue = labelText === undefined ? placeholder : labelText;
        var classNames = getClassNames(styles, {
            theme: theme,
            className: className,
            underlined: underlined,
            hasFocus: hasFocus,
            disabled: disabled,
            hasInput: value.length > 0,
            disableAnimation: disableAnimation
        });
        var nativeProps = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["R" /* getNativeProps */])(this.props, __WEBPACK_IMPORTED_MODULE_2__Utilities__["_7" /* inputProperties */], ['id', 'className', 'placeholder', 'onFocus', 'onBlur', 'value']);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: this._rootElement, className: classNames.root, onFocusCapture: this._onFocusCapture },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.iconContainer, onClick: this._onClickFocus, "aria-hidden": true },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Icon__["Icon"], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ iconName: "Search" }, iconProps, { className: classNames.icon }))),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("input", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, nativeProps, { id: id, className: classNames.field, placeholder: placeholderValue, onChange: this._onInputChange, onInput: this._onInputChange, onKeyDown: this._onKeyDown, value: value, disabled: disabled, "aria-label": ariaLabel ? ariaLabel : placeholder, ref: this._inputElement })),
            value.length > 0 && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.clearButton },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Button__["g" /* IconButton */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ styles: { root: { height: 'auto' }, icon: { fontSize: '12px' } }, iconProps: { iconName: 'Clear' } }, clearButtonProps, { onClick: this._onClearClick }))))));
    };
    /**
     * Sets focus to the search box input field
     */
    SearchBoxBase.prototype.focus = function () {
        if (this._inputElement.current) {
            this._inputElement.current.focus();
        }
    };
    /**
     * Returns whether or not the SearchBox has focus
     */
    SearchBoxBase.prototype.hasFocus = function () {
        return !!this.state.hasFocus;
    };
    SearchBoxBase.prototype._onClear = function (ev) {
        this.props.onClear && this.props.onClear(ev);
        if (!ev.defaultPrevented) {
            this._latestValue = '';
            this.setState({
                value: ''
            });
            this._callOnChange('');
            ev.stopPropagation();
            ev.preventDefault();
            this.focus();
        }
    };
    SearchBoxBase.prototype._callOnChange = function (newValue) {
        var _a = this.props, onChange = _a.onChange, onChanged = _a.onChanged;
        // Call @deprecated method.
        if (onChanged) {
            onChanged(newValue);
        }
        if (onChange) {
            onChange(newValue);
        }
    };
    SearchBoxBase.defaultProps = {
        disableAnimation: false,
        clearButtonProps: { ariaLabel: 'Clear text' }
    };
    return SearchBoxBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=SearchBox.base.js.map

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseSelectedItemsList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Selection__ = __webpack_require__(436);



var BaseSelectedItemsList = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](BaseSelectedItemsList, _super);
    function BaseSelectedItemsList(basePickerProps) {
        var _this = _super.call(this, basePickerProps) || this;
        _this.addItems = function (items) {
            // tslint:disable-next-line:no-any
            var processedItems = _this.props.onItemSelected ? _this.props.onItemSelected(items) : items;
            var processedItemObjects = processedItems;
            var processedItemPromiseLikes = processedItems;
            if (processedItemPromiseLikes && processedItemPromiseLikes.then) {
                processedItemPromiseLikes.then(function (resolvedProcessedItems) {
                    var newItems = _this.state.items.concat(resolvedProcessedItems);
                    _this.updateItems(newItems);
                });
            }
            else {
                var newItems = _this.state.items.concat(processedItemObjects);
                _this.updateItems(newItems);
            }
        };
        _this.removeItemAt = function (index) {
            var items = _this.state.items;
            if (_this._canRemoveItem(items[index])) {
                if (index > -1) {
                    if (_this.props.onItemsDeleted) {
                        _this.props.onItemsDeleted([items[index]]);
                    }
                    var newItems = items.slice(0, index).concat(items.slice(index + 1));
                    _this.updateItems(newItems);
                }
            }
        };
        _this.removeItem = function (item) {
            var items = _this.state.items;
            var index = items.indexOf(item);
            _this.removeItemAt(index);
        };
        _this.replaceItem = function (itemToReplace, itemsToReplaceWith) {
            var items = _this.state.items;
            var index = items.indexOf(itemToReplace);
            if (index > -1) {
                var newItems = items
                    .slice(0, index)
                    .concat(itemsToReplaceWith)
                    .concat(items.slice(index + 1));
                _this.updateItems(newItems);
            }
        };
        // tslint:disable-next-line:no-any
        _this.removeItems = function (itemsToRemove) {
            var items = _this.state.items;
            var itemsCanRemove = itemsToRemove.filter(function (item) { return _this._canRemoveItem(item); });
            // tslint:disable-next-line:no-any
            var newItems = items.filter(function (item) { return itemsCanRemove.indexOf(item) === -1; });
            var firstItemToRemove = itemsCanRemove[0];
            var index = items.indexOf(firstItemToRemove);
            if (_this.props.onItemsDeleted) {
                _this.props.onItemsDeleted(itemsCanRemove);
            }
            _this.updateItems(newItems, index);
        };
        _this.onCopy = function (ev) {
            if (_this.props.onCopyItems && _this.selection.getSelectedCount() > 0) {
                var selectedItems = _this.selection.getSelection();
                _this.copyItems(selectedItems);
            }
        };
        _this.renderItems = function () {
            var removeButtonAriaLabel = _this.props.removeButtonAriaLabel;
            var onRenderItem = _this.props.onRenderItem;
            var items = _this.state.items;
            // tslint:disable-next-line:no-any
            return items.map(function (item, index) {
                return onRenderItem({
                    item: item,
                    index: index,
                    key: item.key ? item.key : index,
                    selected: _this.selection.isIndexSelected(index),
                    onRemoveItem: function () { return _this.removeItem(item); },
                    onItemChange: _this.onItemChange,
                    removeButtonAriaLabel: removeButtonAriaLabel,
                    onCopyItem: function (itemToCopy) { return _this.copyItems([itemToCopy]); }
                });
            });
        };
        _this.onSelectionChanged = function () {
            _this.forceUpdate();
        };
        _this.onItemChange = function (changedItem, index) {
            var items = _this.state.items;
            if (index >= 0) {
                var newItems = items;
                newItems[index] = changedItem;
                _this.updateItems(newItems);
            }
        };
        var items = basePickerProps.selectedItems || basePickerProps.defaultSelectedItems || [];
        _this.state = {
            items: items
        };
        // Create a new selection if one is not specified
        _this.selection = _this.props.selection
            ? _this.props.selection
            : new __WEBPACK_IMPORTED_MODULE_2__Selection__["a" /* Selection */]({ onSelectionChanged: _this.onSelectionChanged });
        return _this;
    }
    Object.defineProperty(BaseSelectedItemsList.prototype, "items", {
        get: function () {
            return this.state.items;
        },
        enumerable: true,
        configurable: true
    });
    BaseSelectedItemsList.prototype.removeSelectedItems = function () {
        if (this.state.items.length && this.selection.getSelectedCount() > 0) {
            this.removeItems(this.selection.getSelection());
        }
    };
    /**
     * Controls what happens whenever there is an action that impacts the selected items.
     * If selectedItems is provided as a property then this will act as a controlled component and it will not update it's own state.
     */
    BaseSelectedItemsList.prototype.updateItems = function (items, focusIndex) {
        var _this = this;
        if (this.props.selectedItems) {
            // If the component is a controlled component then the controlling component will need to pass the new props
            this.onChange(items);
        }
        else {
            this.setState({ items: items }, function () {
                _this._onSelectedItemsUpdated(items, focusIndex);
            });
        }
    };
    BaseSelectedItemsList.prototype.hasSelectedItems = function () {
        return this.selection.getSelectedCount() > 0;
    };
    BaseSelectedItemsList.prototype.unselectAll = function () {
        this.selection.setAllSelected(false);
    };
    BaseSelectedItemsList.prototype.highlightedItems = function () {
        return this.selection.getSelection();
    };
    BaseSelectedItemsList.prototype.componentWillUpdate = function (newProps, newState) {
        if (newState.items && newState.items !== this.state.items) {
            this.selection.setItems(newState.items);
        }
    };
    BaseSelectedItemsList.prototype.componentDidMount = function () {
        this.selection.setItems(this.state.items);
    };
    BaseSelectedItemsList.prototype.componentWillReceiveProps = function (newProps) {
        var newItems = newProps.selectedItems;
        if (newItems) {
            this.setState({ items: newItems });
        }
        if (newProps.selection) {
            this.selection = newProps.selection;
        }
    };
    // tslint:disable-next-line:no-any
    BaseSelectedItemsList.prototype.render = function () {
        return this.renderItems();
    };
    BaseSelectedItemsList.prototype.onChange = function (items) {
        if (this.props.onChange) {
            this.props.onChange(items);
        }
    };
    BaseSelectedItemsList.prototype.copyItems = function (items) {
        if (this.props.onCopyItems) {
            // tslint:disable-next-line:no-any
            var copyText = this.props.onCopyItems(items);
            var copyInput = document.createElement('input');
            document.body.appendChild(copyInput);
            try {
                // Try to copy the text directly to the clipboard
                copyInput.value = copyText;
                copyInput.select();
                if (!document.execCommand('copy')) {
                    // The command failed. Fallback to the method below.
                    throw new Error();
                }
            }
            catch (err) {
                // no op
            }
            finally {
                document.body.removeChild(copyInput);
            }
        }
    };
    BaseSelectedItemsList.prototype._onSelectedItemsUpdated = function (items, focusIndex) {
        this.onChange(items);
    };
    BaseSelectedItemsList.prototype._canRemoveItem = function (item) {
        return !this.props.canRemoveItem || this.props.canRemoveItem(item);
    };
    return BaseSelectedItemsList;
}(__WEBPACK_IMPORTED_MODULE_1__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=BaseSelectedItemsList.js.map

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExtendedSelectedItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Persona__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ExtendedSelectedItem_scss__ = __webpack_require__(2026);

/* tslint:disable */

/* tslint:enable */




// tslint:disable-next-line:no-any
var styles = __WEBPACK_IMPORTED_MODULE_5__ExtendedSelectedItem_scss__;
var ExtendedSelectedItem = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ExtendedSelectedItem, _super);
    function ExtendedSelectedItem(props) {
        var _this = _super.call(this, props) || this;
        _this.persona = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.state = { contextualMenuVisible: false };
        return _this;
    }
    ExtendedSelectedItem.prototype.render = function () {
        var _a = this.props, item = _a.item, onExpandItem = _a.onExpandItem, onRemoveItem = _a.onRemoveItem, removeButtonAriaLabel = _a.removeButtonAriaLabel, index = _a.index, selected = _a.selected;
        var itemId = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["N" /* getId */])();
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: this.persona, className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-PickerPersona-container', styles.personaContainer, (_b = {}, _b['is-selected ' + styles.personaContainerIsSelected] = selected, _b), (_c = {}, _c['is-invalid ' + styles.validationError] = !item.isValid, _c)), "data-is-focusable": true, "data-is-sub-focuszone": true, "data-selection-index": index, role: 'listitem', "aria-labelledby": 'selectedItemPersona-' + itemId },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { hidden: !item.canExpand || onExpandItem === undefined },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Button__["g" /* IconButton */], { onClick: this._onClickIconButton(onExpandItem), iconProps: { iconName: 'Add', style: { fontSize: '14px' } }, className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-PickerItem-removeButton', styles.expandButton, styles.actionButton), ariaLabel: removeButtonAriaLabel })),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])(styles.personaWrapper) },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-PickerItem-content', styles.itemContent), id: 'selectedItemPersona-' + itemId },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Persona__["a" /* Persona */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, item, { onRenderCoin: this.props.renderPersonaCoin, onRenderPrimaryText: this.props.renderPrimaryText, size: __WEBPACK_IMPORTED_MODULE_3__Persona__["d" /* PersonaSize */].size32 }))),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Button__["g" /* IconButton */], { onClick: this._onClickIconButton(onRemoveItem), iconProps: { iconName: 'Cancel', style: { fontSize: '14px' } }, className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-PickerItem-removeButton', styles.removeButton, styles.actionButton), ariaLabel: removeButtonAriaLabel }))));
        var _b, _c;
    };
    ExtendedSelectedItem.prototype._onClickIconButton = function (action) {
        return function (ev) {
            ev.stopPropagation();
            ev.preventDefault();
            if (action) {
                action();
            }
        };
    };
    return ExtendedSelectedItem;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=ExtendedSelectedItem.js.map

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SeparatorBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utilities__ = __webpack_require__(1);


var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["r" /* classNamesFunction */])();
var SeparatorBase = function (props) {
    var styles = props.styles, theme = props.theme, className = props.className, vertical = props.vertical, alignContent = props.alignContent;
    var _classNames = getClassNames(styles, {
        theme: theme,
        className: className,
        alignContent: alignContent,
        vertical: vertical
    });
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: _classNames.root },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", { className: _classNames.content, role: "separator", "aria-orientation": vertical ? 'vertical' : 'horizontal' }, props.children)));
};
//# sourceMappingURL=Separator.base.js.map

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Shimmer_index__ = __webpack_require__(2034);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Shimmer_index__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Shimmer_index__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Shimmer_index__["c"]; });

//# sourceMappingURL=Shimmer.js.map

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShimmerBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ShimmerElementsGroup_ShimmerElementsGroup__ = __webpack_require__(814);




var TRANSITION_ANIMATION_INTERVAL = 200; /* ms */
var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
/**
 * {@docCategory Shimmer}
 */
var ShimmerBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ShimmerBase, _super);
    function ShimmerBase(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            contentLoaded: props.isDataLoaded
        };
        return _this;
    }
    ShimmerBase.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        var isDataLoaded = nextProps.isDataLoaded;
        if (this._lastTimeoutId !== undefined) {
            this._async.clearTimeout(this._lastTimeoutId);
            this._lastTimeoutId = undefined;
        }
        if (isDataLoaded) {
            this._lastTimeoutId = this._async.setTimeout(function () {
                _this.setState({
                    contentLoaded: isDataLoaded
                });
                _this._lastTimeoutId = undefined;
            }, TRANSITION_ANIMATION_INTERVAL);
        }
        else {
            this.setState({
                contentLoaded: isDataLoaded
            });
        }
    };
    ShimmerBase.prototype.render = function () {
        var _a = this.props, styles = _a.styles, shimmerElements = _a.shimmerElements, children = _a.children, isDataLoaded = _a.isDataLoaded, width = _a.width, className = _a.className, customElementsGroup = _a.customElementsGroup, theme = _a.theme, ariaLabel = _a.ariaLabel, shimmerColors = _a.shimmerColors;
        var contentLoaded = this.state.contentLoaded;
        this._classNames = getClassNames(styles, {
            theme: theme,
            isDataLoaded: isDataLoaded,
            className: className,
            transitionAnimationInterval: TRANSITION_ANIMATION_INTERVAL,
            shimmerColor: shimmerColors && shimmerColors.shimmer,
            shimmerWaveColor: shimmerColors && shimmerColors.shimmerWave
        });
        var divProps = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["R" /* getNativeProps */])(this.props, __WEBPACK_IMPORTED_MODULE_2__Utilities__["w" /* divProperties */]);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, divProps, { className: this._classNames.root }),
            !contentLoaded && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { style: { width: width ? width : '100%' }, className: this._classNames.shimmerWrapper }, customElementsGroup ? (customElementsGroup) : (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__ShimmerElementsGroup_ShimmerElementsGroup__["a" /* ShimmerElementsGroup */], { shimmerElements: shimmerElements, backgroundColor: shimmerColors && shimmerColors.background })))),
            children && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.dataWrapper }, children),
            ariaLabel && !isDataLoaded && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { role: "status", "aria-live": "polite" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Utilities__["d" /* DelayedRender */], null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.screenReaderText }, ariaLabel))))));
    };
    ShimmerBase.defaultProps = {
        isDataLoaded: false
    };
    return ShimmerBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=Shimmer.base.js.map

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShimmerElementsGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ShimmerElementsGroup_base__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShimmerElementsGroup_styles__ = __webpack_require__(2040);



var ShimmerElementsGroup = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__ShimmerElementsGroup_base__["a" /* ShimmerElementsGroupBase */], __WEBPACK_IMPORTED_MODULE_2__ShimmerElementsGroup_styles__["a" /* getStyles */], undefined, { scope: 'ShimmerElementsGroup' });
//# sourceMappingURL=ShimmerElementsGroup.js.map

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShimmerElementsGroupBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shimmer_types__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ShimmerLine_ShimmerLine__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ShimmerGap_ShimmerGap__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ShimmerCircle_ShimmerCircle__ = __webpack_require__(821);







var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
/**
 * {@docCategory Shimmer}
 */
var ShimmerElementsGroupBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ShimmerElementsGroupBase, _super);
    function ShimmerElementsGroupBase(props) {
        var _this = _super.call(this, props) || this;
        _this._getRenderedElements = function (shimmerElements, rowHeight) {
            var renderedElements = shimmerElements ? (shimmerElements.map(function (elem, index) {
                var type = elem.type, filteredElem = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __rest */](elem, ["type"]);
                switch (elem.type) {
                    case __WEBPACK_IMPORTED_MODULE_3__Shimmer_types__["a" /* ShimmerElementType */].circle:
                        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__ShimmerCircle_ShimmerCircle__["a" /* ShimmerCircle */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ key: index }, filteredElem, { styles: _this._getStyles(elem, rowHeight) }));
                    case __WEBPACK_IMPORTED_MODULE_3__Shimmer_types__["a" /* ShimmerElementType */].gap:
                        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__ShimmerGap_ShimmerGap__["a" /* ShimmerGap */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ key: index }, filteredElem, { styles: _this._getStyles(elem, rowHeight) }));
                    case __WEBPACK_IMPORTED_MODULE_3__Shimmer_types__["a" /* ShimmerElementType */].line:
                        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__ShimmerLine_ShimmerLine__["a" /* ShimmerLine */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ key: index }, filteredElem, { styles: _this._getStyles(elem, rowHeight) }));
                }
            })) : (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__ShimmerLine_ShimmerLine__["a" /* ShimmerLine */], { height: __WEBPACK_IMPORTED_MODULE_3__Shimmer_types__["b" /* ShimmerElementsDefaultHeights */].line, styles: { root: [{ borderWidth: '0px' }] } }));
            return renderedElements;
        };
        _this._getStyles = function (elem, rowHeight) {
            var backgroundColor = _this.props.backgroundColor;
            var verticalAlign = elem.verticalAlign, type = elem.type;
            var elemHeight = elem.height;
            var dif = rowHeight && elemHeight ? rowHeight - elemHeight : 0;
            var borderStyle;
            if (!verticalAlign || verticalAlign === 'center') {
                borderStyle = {
                    borderBottomWidth: (dif ? Math.floor(dif / 2) : 0) + "px",
                    borderTopWidth: (dif ? Math.ceil(dif / 2) : 0) + "px"
                };
            }
            else if (verticalAlign && verticalAlign === 'top') {
                borderStyle = {
                    borderBottomWidth: (dif ? dif : 0) + "px",
                    borderTopWidth: "0px"
                };
            }
            else if (verticalAlign && verticalAlign === 'bottom') {
                borderStyle = {
                    borderBottomWidth: "0px",
                    borderTopWidth: (dif ? dif : 0) + "px"
                };
            }
            if (backgroundColor) {
                switch (type) {
                    case __WEBPACK_IMPORTED_MODULE_3__Shimmer_types__["a" /* ShimmerElementType */].circle:
                        return {
                            root: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, borderStyle, { borderColor: backgroundColor }),
                            svg: { fill: backgroundColor }
                        };
                    case __WEBPACK_IMPORTED_MODULE_3__Shimmer_types__["a" /* ShimmerElementType */].gap:
                        return {
                            root: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, borderStyle, { borderColor: backgroundColor, backgroundColor: backgroundColor })
                        };
                    case __WEBPACK_IMPORTED_MODULE_3__Shimmer_types__["a" /* ShimmerElementType */].line:
                        return {
                            root: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, borderStyle, { borderColor: backgroundColor }),
                            topLeftCorner: { fill: backgroundColor },
                            topRightCorner: { fill: backgroundColor },
                            bottomLeftCorner: { fill: backgroundColor },
                            bottomRightCorner: { fill: backgroundColor }
                        };
                }
            }
            return {
                root: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, borderStyle)
            };
        };
        /**
         * User should not worry to provide which of the elements is the highest, we do the calculation for him.
         * Plus if user forgot to specify the height we assign their defaults.
         */
        _this._findMaxElementHeight = function (elements) {
            var itemsDefaulted = elements.map(function (elem) {
                switch (elem.type) {
                    case __WEBPACK_IMPORTED_MODULE_3__Shimmer_types__["a" /* ShimmerElementType */].circle:
                        if (!elem.height) {
                            elem.height = __WEBPACK_IMPORTED_MODULE_3__Shimmer_types__["b" /* ShimmerElementsDefaultHeights */].circle;
                        }
                    case __WEBPACK_IMPORTED_MODULE_3__Shimmer_types__["a" /* ShimmerElementType */].line:
                        if (!elem.height) {
                            elem.height = __WEBPACK_IMPORTED_MODULE_3__Shimmer_types__["b" /* ShimmerElementsDefaultHeights */].line;
                        }
                    case __WEBPACK_IMPORTED_MODULE_3__Shimmer_types__["a" /* ShimmerElementType */].gap:
                        if (!elem.height) {
                            elem.height = __WEBPACK_IMPORTED_MODULE_3__Shimmer_types__["b" /* ShimmerElementsDefaultHeights */].gap;
                        }
                }
                return elem;
            });
            var rowHeight = itemsDefaulted.reduce(function (acc, next) {
                return next.height ? (next.height > acc ? next.height : acc) : acc;
            }, 0);
            return rowHeight;
        };
        return _this;
    }
    ShimmerElementsGroupBase.prototype.render = function () {
        var _a = this.props, styles = _a.styles, width = _a.width, shimmerElements = _a.shimmerElements, rowHeight = _a.rowHeight, flexWrap = _a.flexWrap, theme = _a.theme;
        this._classNames = getClassNames(styles, {
            theme: theme,
            flexWrap: flexWrap
        });
        var height = rowHeight ? rowHeight : this._findMaxElementHeight(shimmerElements ? shimmerElements : []);
        return (
        // tslint:disable-next-line:jsx-ban-props
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { style: { width: width ? width : 'auto' }, className: this._classNames.root }, this._getRenderedElements(shimmerElements, height)));
    };
    ShimmerElementsGroupBase.defaultProps = {
        flexWrap: false
    };
    return ShimmerElementsGroupBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=ShimmerElementsGroup.base.js.map

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShimmerElementType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ShimmerElementsDefaultHeights; });
/**
 * Describes the possible types for shimmer elements used.
 * {@docCategory Shimmer}
 */
var ShimmerElementType;
(function (ShimmerElementType) {
    /**
     * Line element type
     */
    ShimmerElementType[ShimmerElementType["line"] = 1] = "line";
    /**
     * Circle element type
     */
    ShimmerElementType[ShimmerElementType["circle"] = 2] = "circle";
    /**
     * Gap element type
     */
    ShimmerElementType[ShimmerElementType["gap"] = 3] = "gap";
})(ShimmerElementType || (ShimmerElementType = {}));
/**
 * Describes the default heights for shimmer elements when omitted in implementation.
 * {@docCategory Shimmer}
 */
var ShimmerElementsDefaultHeights;
(function (ShimmerElementsDefaultHeights) {
    /**
     * Default height of the line element when not provided by user: 16px
     */
    ShimmerElementsDefaultHeights[ShimmerElementsDefaultHeights["line"] = 16] = "line";
    /**
     * Default height of the gap element when not provided by user: 16px
     */
    ShimmerElementsDefaultHeights[ShimmerElementsDefaultHeights["gap"] = 16] = "gap";
    /**
     * Default height of the circle element when not provided by user: 24px
     */
    ShimmerElementsDefaultHeights[ShimmerElementsDefaultHeights["circle"] = 24] = "circle";
})(ShimmerElementsDefaultHeights || (ShimmerElementsDefaultHeights = {}));
//# sourceMappingURL=Shimmer.types.js.map

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShimmerLine; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ShimmerLine_base__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShimmerLine_styles__ = __webpack_require__(2037);



var ShimmerLine = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__ShimmerLine_base__["a" /* ShimmerLineBase */], __WEBPACK_IMPORTED_MODULE_2__ShimmerLine_styles__["a" /* getStyles */], undefined, {
    scope: 'ShimmerLine'
});
//# sourceMappingURL=ShimmerLine.js.map

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShimmerLineBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);



var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
/**
 * {@docCategory Shimmer}
 */
var ShimmerLineBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ShimmerLineBase, _super);
    function ShimmerLineBase(props) {
        return _super.call(this, props) || this;
    }
    ShimmerLineBase.prototype.render = function () {
        var _a = this.props, height = _a.height, styles = _a.styles, width = _a.width, borderStyle = _a.borderStyle, theme = _a.theme;
        this._classNames = getClassNames(styles, {
            theme: theme,
            height: height,
            borderStyle: borderStyle
        });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { style: { width: width ? width : '100%', minWidth: typeof width === 'number' ? width + "px" : 'auto' }, className: this._classNames.root },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", { width: "2", height: "2", className: this._classNames.topLeftCorner },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M0 2 A 2 2, 0, 0, 1, 2 0 L 0 0 Z" })),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", { width: "2", height: "2", className: this._classNames.topRightCorner },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M0 0 A 2 2, 0, 0, 1, 2 2 L 2 0 Z" })),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", { width: "2", height: "2", className: this._classNames.bottomRightCorner },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M2 0 A 2 2, 0, 0, 1, 0 2 L 2 2 Z" })),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", { width: "2", height: "2", className: this._classNames.bottomLeftCorner },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { d: "M2 2 A 2 2, 0, 0, 1, 0 0 L 0 2 Z" }))));
    };
    return ShimmerLineBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=ShimmerLine.base.js.map

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShimmerGap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ShimmerGap_base__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShimmerGap_styles__ = __webpack_require__(2038);



var ShimmerGap = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__ShimmerGap_base__["a" /* ShimmerGapBase */], __WEBPACK_IMPORTED_MODULE_2__ShimmerGap_styles__["a" /* getStyles */], undefined, {
    scope: 'ShimmerGap'
});
//# sourceMappingURL=ShimmerGap.js.map

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShimmerGapBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);



var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
/**
 * {@docCategory Shimmer}
 */
var ShimmerGapBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ShimmerGapBase, _super);
    function ShimmerGapBase(props) {
        return _super.call(this, props) || this;
    }
    ShimmerGapBase.prototype.render = function () {
        var _a = this.props, height = _a.height, styles = _a.styles, width = _a.width, borderStyle = _a.borderStyle, theme = _a.theme;
        this._classNames = getClassNames(styles, {
            theme: theme,
            height: height,
            borderStyle: borderStyle
        });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { style: { width: width ? width : '10px', minWidth: typeof width === 'number' ? width + "px" : 'auto' }, className: this._classNames.root }));
    };
    return ShimmerGapBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=ShimmerGap.base.js.map

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShimmerCircle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ShimmerCircle_styles__ = __webpack_require__(2039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShimmerCircle_base__ = __webpack_require__(822);



var ShimmerCircle = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_2__ShimmerCircle_base__["a" /* ShimmerCircleBase */], __WEBPACK_IMPORTED_MODULE_1__ShimmerCircle_styles__["a" /* getStyles */], undefined, { scope: 'ShimmerCircle' });
//# sourceMappingURL=ShimmerCircle.js.map

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShimmerCircleBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);



var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var ShimmerCircleBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ShimmerCircleBase, _super);
    function ShimmerCircleBase(props) {
        return _super.call(this, props) || this;
    }
    ShimmerCircleBase.prototype.render = function () {
        var _a = this.props, height = _a.height, styles = _a.styles, borderStyle = _a.borderStyle, theme = _a.theme;
        this._classNames = getClassNames(styles, {
            theme: theme,
            height: height,
            borderStyle: borderStyle
        });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.root },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", { viewBox: "0 0 10 10", width: height, height: height, className: this._classNames.svg },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path", { 
                    // tslint:disable-next-line:max-line-length
                    d: "M0,0 L10,0 L10,10 L0,10 L0,0 Z M0,5 C0,7.76142375 2.23857625,10 5,10 C7.76142375,10 10,7.76142375 10,5 C10,2.23857625 7.76142375,2.22044605e-16 5,0 C2.23857625,-2.22044605e-16 0,2.23857625 0,5 L0,5 Z" }))));
    };
    return ShimmerCircleBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=ShimmerCircle.base.js.map

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShimmeredDetailsListBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_selection_interfaces__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DetailsList__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shimmer__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DetailsList_types__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DetailsRow_styles__ = __webpack_require__(99);








var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var SHIMMER_INITIAL_ITEMS = 10;
var DEFAULT_SHIMMER_HEIGHT = 7;
var SHIMMER_LINE_VS_CELL_WIDTH_RATIO = 0.95;
var ShimmeredDetailsListBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ShimmeredDetailsListBase, _super);
    function ShimmeredDetailsListBase(props) {
        var _this = _super.call(this, props) || this;
        _this._onRenderShimmerPlaceholder = function (index, rowProps) {
            var onRenderCustomPlaceholder = _this.props.onRenderCustomPlaceholder;
            var placeholderElements = onRenderCustomPlaceholder
                ? onRenderCustomPlaceholder(rowProps)
                : _this._renderDefaultShimmerPlaceholder(rowProps);
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Shimmer__["a" /* Shimmer */], { customElementsGroup: placeholderElements });
        };
        _this._renderDefaultShimmerPlaceholder = function (rowProps) {
            var columns = rowProps.columns, compact = rowProps.compact, selectionMode = rowProps.selectionMode, checkboxVisibility = rowProps.checkboxVisibility, _a = rowProps.cellStyleProps, cellStyleProps = _a === void 0 ? __WEBPACK_IMPORTED_MODULE_7__DetailsRow_styles__["a" /* DEFAULT_CELL_STYLE_PROPS */] : _a;
            var rowHeight = __WEBPACK_IMPORTED_MODULE_7__DetailsRow_styles__["b" /* DEFAULT_ROW_HEIGHTS */].rowHeight, compactRowHeight = __WEBPACK_IMPORTED_MODULE_7__DetailsRow_styles__["b" /* DEFAULT_ROW_HEIGHTS */].compactRowHeight;
            var gapHeight = compact ? compactRowHeight : rowHeight + 1; // 1px to take into account the border-bottom of DetailsRow.
            var shimmerElementsRow = [];
            var showCheckbox = selectionMode !== __WEBPACK_IMPORTED_MODULE_3__utilities_selection_interfaces__["b" /* SelectionMode */].none && checkboxVisibility !== __WEBPACK_IMPORTED_MODULE_6__DetailsList_types__["a" /* CheckboxVisibility */].hidden;
            if (showCheckbox) {
                shimmerElementsRow.push(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Shimmer__["c" /* ShimmerElementsGroup */], { key: 'checkboxGap', shimmerElements: [{ type: __WEBPACK_IMPORTED_MODULE_5__Shimmer__["b" /* ShimmerElementType */].gap, width: '40px', height: gapHeight }] }));
            }
            columns.map(function (column, columnIdx) {
                var shimmerElements = [];
                var groupWidth = cellStyleProps.cellLeftPadding +
                    cellStyleProps.cellRightPadding +
                    column.calculatedWidth +
                    (column.isPadded ? cellStyleProps.cellExtraRightPadding : 0);
                shimmerElements.push({
                    type: __WEBPACK_IMPORTED_MODULE_5__Shimmer__["b" /* ShimmerElementType */].gap,
                    width: cellStyleProps.cellLeftPadding,
                    height: gapHeight
                });
                if (column.isIconOnly) {
                    shimmerElements.push({
                        type: __WEBPACK_IMPORTED_MODULE_5__Shimmer__["b" /* ShimmerElementType */].line,
                        width: column.calculatedWidth,
                        height: column.calculatedWidth
                    });
                    shimmerElements.push({
                        type: __WEBPACK_IMPORTED_MODULE_5__Shimmer__["b" /* ShimmerElementType */].gap,
                        width: cellStyleProps.cellRightPadding,
                        height: gapHeight
                    });
                }
                else {
                    shimmerElements.push({
                        type: __WEBPACK_IMPORTED_MODULE_5__Shimmer__["b" /* ShimmerElementType */].line,
                        width: column.calculatedWidth * SHIMMER_LINE_VS_CELL_WIDTH_RATIO,
                        height: DEFAULT_SHIMMER_HEIGHT
                    });
                    shimmerElements.push({
                        type: __WEBPACK_IMPORTED_MODULE_5__Shimmer__["b" /* ShimmerElementType */].gap,
                        width: cellStyleProps.cellRightPadding +
                            (column.calculatedWidth - column.calculatedWidth * SHIMMER_LINE_VS_CELL_WIDTH_RATIO) +
                            (column.isPadded ? cellStyleProps.cellExtraRightPadding : 0),
                        height: gapHeight
                    });
                }
                shimmerElementsRow.push(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Shimmer__["c" /* ShimmerElementsGroup */], { key: columnIdx, width: groupWidth + "px", shimmerElements: shimmerElements }));
            });
            // When resizing the window from narrow to wider, we need to cover the exposed Shimmer wave until the column resizing logic is done.
            shimmerElementsRow.push(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Shimmer__["c" /* ShimmerElementsGroup */], { key: 'endGap', width: '100%', shimmerElements: [{ type: __WEBPACK_IMPORTED_MODULE_5__Shimmer__["b" /* ShimmerElementType */].gap, width: '100%', height: gapHeight }] }));
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { style: { display: 'flex' } }, shimmerElementsRow);
        };
        _this._shimmerItems = props.shimmerLines ? new Array(props.shimmerLines) : new Array(SHIMMER_INITIAL_ITEMS);
        return _this;
    }
    ShimmeredDetailsListBase.prototype.render = function () {
        var _a = this.props, detailsListStyles = _a.detailsListStyles, enableShimmer = _a.enableShimmer, items = _a.items, listProps = _a.listProps, onRenderCustomPlaceholder = _a.onRenderCustomPlaceholder, removeFadingOverlay = _a.removeFadingOverlay, shimmerLines = _a.shimmerLines, styles = _a.styles, theme = _a.theme, restProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __rest */](_a, ["detailsListStyles", "enableShimmer", "items", "listProps", "onRenderCustomPlaceholder", "removeFadingOverlay", "shimmerLines", "styles", "theme"]);
        var listClassName = listProps && listProps.className;
        this._classNames = getClassNames(styles, {
            theme: theme,
            className: listClassName,
            enableShimmer: enableShimmer
        });
        var newListProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, listProps, { 
            // Adds to the optional listProp className a fading out overlay className only when shimmer enabled.
            className: enableShimmer && !removeFadingOverlay ? this._classNames.root : listClassName });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__DetailsList__["a" /* DetailsList */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, restProps, { items: enableShimmer ? this._shimmerItems : items, onRenderMissingItem: this._onRenderShimmerPlaceholder, listProps: newListProps, styles: detailsListStyles })));
    };
    return ShimmeredDetailsListBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=ShimmeredDetailsList.base.js.map

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ValuePosition */
/* unused harmony export ONKEYDOWN_TIMEOUT_DURATION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SliderBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Label__ = __webpack_require__(109);





/**
 * @deprecated Unused.
 */
var ValuePosition;
(function (ValuePosition) {
    ValuePosition[ValuePosition["Previous"] = 0] = "Previous";
    ValuePosition[ValuePosition["Next"] = 1] = "Next";
})(ValuePosition || (ValuePosition = {}));
var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var ONKEYDOWN_TIMEOUT_DURATION = 1000;
var SliderBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](SliderBase, _super);
    function SliderBase(props) {
        var _this = _super.call(this, props) || this;
        _this._sliderLine = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._thumb = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._onKeyDownTimer = -1;
        _this._getAriaValueText = function (value) {
            if (_this.props.ariaValueText && value !== undefined) {
                return _this.props.ariaValueText(value);
            }
        };
        _this._onMouseDownOrTouchStart = function (event) {
            if (event.type === 'mousedown') {
                _this._events.on(window, 'mousemove', _this._onMouseMoveOrTouchMove, true);
                _this._events.on(window, 'mouseup', _this._onMouseUpOrTouchEnd, true);
            }
            else if (event.type === 'touchstart') {
                _this._events.on(window, 'touchmove', _this._onMouseMoveOrTouchMove, true);
                _this._events.on(window, 'touchend', _this._onMouseUpOrTouchEnd, true);
            }
            _this._onMouseMoveOrTouchMove(event, true);
        };
        _this._onMouseMoveOrTouchMove = function (event, suppressEventCancelation) {
            if (!_this._sliderLine.current) {
                return;
            }
            var _a = _this.props, max = _a.max, min = _a.min, step = _a.step;
            var steps = (max - min) / step;
            var sliderPositionRect = _this._sliderLine.current.getBoundingClientRect();
            var sliderLength = !_this.props.vertical ? sliderPositionRect.width : sliderPositionRect.height;
            var stepLength = sliderLength / steps;
            var currentSteps;
            var distance;
            if (!_this.props.vertical) {
                var left = _this._getPosition(event, _this.props.vertical);
                distance = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["V" /* getRTL */])() ? sliderPositionRect.right - left : left - sliderPositionRect.left;
                currentSteps = distance / stepLength;
            }
            else {
                var bottom = _this._getPosition(event, _this.props.vertical);
                distance = sliderPositionRect.bottom - bottom;
                currentSteps = distance / stepLength;
            }
            var currentValue;
            var renderedValue;
            // The value shouldn't be bigger than max or be smaller than min.
            if (currentSteps > Math.floor(steps)) {
                renderedValue = currentValue = max;
            }
            else if (currentSteps < 0) {
                renderedValue = currentValue = min;
            }
            else {
                renderedValue = min + step * currentSteps;
                currentValue = min + step * Math.round(currentSteps);
            }
            _this._updateValue(currentValue, renderedValue);
            if (!suppressEventCancelation) {
                event.preventDefault();
                event.stopPropagation();
            }
        };
        _this._onMouseUpOrTouchEnd = function (event) {
            // Synchronize the renderedValue to the actual value.
            _this.setState({
                renderedValue: _this.state.value
            });
            if (_this.props.onChanged) {
                _this.props.onChanged(event, _this.state.value);
            }
            _this._events.off();
        };
        _this._onKeyDown = function (event) {
            var value = _this.state.value;
            var _a = _this.props, max = _a.max, min = _a.min, step = _a.step;
            var diff = 0;
            switch (event.which) {
                case Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["W" /* getRTLSafeKeyCode */])(__WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].left):
                case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].down:
                    diff = -step;
                    _this._clearOnKeyDownTimer();
                    _this._setOnKeyDownTimer(event);
                    break;
                case Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["W" /* getRTLSafeKeyCode */])(__WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].right):
                case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].up:
                    diff = step;
                    _this._clearOnKeyDownTimer();
                    _this._setOnKeyDownTimer(event);
                    break;
                case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].home:
                    value = min;
                    break;
                case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].end:
                    value = max;
                    break;
                default:
                    return;
            }
            var newValue = Math.min(max, Math.max(min, value + diff));
            _this._updateValue(newValue, newValue);
            event.preventDefault();
            event.stopPropagation();
        };
        _this._clearOnKeyDownTimer = function () {
            _this._async.clearTimeout(_this._onKeyDownTimer);
        };
        _this._setOnKeyDownTimer = function (event) {
            // what is this for?
            _this._onKeyDownTimer = _this._async.setTimeout(function () {
                if (_this.props.onChanged) {
                    _this.props.onChanged(event, _this.state.value);
                }
            }, ONKEYDOWN_TIMEOUT_DURATION);
        };
        _this._warnMutuallyExclusive({
            value: 'defaultValue'
        });
        _this._id = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["N" /* getId */])('Slider');
        var value = props.value !== undefined ? props.value : props.defaultValue !== undefined ? props.defaultValue : props.min;
        _this.state = {
            value: value,
            renderedValue: value
        };
        return _this;
    }
    /**
     * Invoked when a component is receiving new props. This method is not called for the initial render.
     */
    SliderBase.prototype.componentWillReceiveProps = function (newProps) {
        if (newProps.value !== undefined) {
            var value = Math.max(newProps.min, Math.min(newProps.max, newProps.value));
            this.setState({
                value: value,
                renderedValue: value
            });
        }
    };
    SliderBase.prototype.render = function () {
        var _a = this.props, ariaLabel = _a.ariaLabel, className = _a.className, disabled = _a.disabled, label = _a.label, max = _a.max, min = _a.min, showValue = _a.showValue, buttonProps = _a.buttonProps, vertical = _a.vertical, valueFormat = _a.valueFormat, styles = _a.styles, theme = _a.theme, originFromZero = _a.originFromZero;
        var _b = this.state, value = _b.value, renderedValue = _b.renderedValue;
        var thumbOffsetPercent = min === max ? 0 : ((renderedValue - min) / (max - min)) * 100;
        var zeroOffsetPercent = min >= 0 ? 0 : (-min / (max - min)) * 100;
        var lengthString = vertical ? 'height' : 'width';
        var onMouseDownProp = disabled ? {} : { onMouseDown: this._onMouseDownOrTouchStart };
        var onTouchStartProp = disabled ? {} : { onTouchStart: this._onMouseDownOrTouchStart };
        var onKeyDownProp = disabled ? {} : { onKeyDown: this._onKeyDown };
        var classNames = getClassNames(styles, {
            className: className,
            disabled: disabled,
            vertical: vertical,
            showTransitions: renderedValue === value,
            showValue: showValue,
            theme: theme
        });
        var divButtonProps = buttonProps ? Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["R" /* getNativeProps */])(buttonProps, __WEBPACK_IMPORTED_MODULE_2__Utilities__["w" /* divProperties */]) : undefined;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.root },
            label && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Label__["a" /* Label */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ className: classNames.titleLabel }, (ariaLabel ? {} : { htmlFor: this._id })), label)),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.container },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ "aria-valuenow": value, "aria-valuemin": min, "aria-valuemax": max, "aria-valuetext": this._getAriaValueText(value), "aria-label": ariaLabel || label, "aria-disabled": disabled }, onMouseDownProp, onTouchStartProp, onKeyDownProp, divButtonProps, { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])(classNames.slideBox, buttonProps.className), id: this._id, role: "slider", tabIndex: disabled ? undefined : 0, "data-is-focusable": !disabled }),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: this._sliderLine, className: classNames.line },
                        originFromZero && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])(classNames.zeroTick), style: this._getStyleUsingOffsetPercent(vertical, zeroOffsetPercent) })),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { ref: this._thumb, className: classNames.thumb, style: this._getStyleUsingOffsetPercent(vertical, thumbOffsetPercent) }),
                        originFromZero ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])(classNames.lineContainer, classNames.inactiveSection), style: (_c = {}, _c[lengthString] = Math.min(thumbOffsetPercent, zeroOffsetPercent) + '%', _c) }),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])(classNames.lineContainer, classNames.activeSection), style: (_d = {}, _d[lengthString] = Math.abs(zeroOffsetPercent - thumbOffsetPercent) + '%', _d) }),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])(classNames.lineContainer, classNames.inactiveSection), style: (_e = {}, _e[lengthString] = Math.min(100 - thumbOffsetPercent, 100 - zeroOffsetPercent) + '%', _e) }))) : (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])(classNames.lineContainer, classNames.activeSection), style: (_f = {}, _f[lengthString] = thumbOffsetPercent + '%', _f) }),
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])(classNames.lineContainer, classNames.inactiveSection), style: (_g = {}, _g[lengthString] = 100 - thumbOffsetPercent + '%', _g) }))))),
                showValue && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Label__["a" /* Label */], { className: classNames.valueLabel }, valueFormat ? valueFormat(value) : value))));
        var _c, _d, _e, _f, _g;
    };
    SliderBase.prototype.focus = function () {
        if (this._thumb.current) {
            this._thumb.current.focus();
        }
    };
    Object.defineProperty(SliderBase.prototype, "value", {
        get: function () {
            return this.state.value;
        },
        enumerable: true,
        configurable: true
    });
    SliderBase.prototype._getStyleUsingOffsetPercent = function (vertical, thumbOffsetPercent) {
        var direction = vertical ? 'bottom' : Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["V" /* getRTL */])() ? 'right' : 'left';
        return _a = {},
            _a[direction] = thumbOffsetPercent + '%',
            _a;
        var _a;
    };
    SliderBase.prototype._getPosition = function (event, vertical) {
        var currentPosition;
        switch (event.type) {
            case 'mousedown':
            case 'mousemove':
                currentPosition = !vertical ? event.clientX : event.clientY;
                break;
            case 'touchstart':
            case 'touchmove':
                currentPosition = !vertical ? event.touches[0].clientX : event.touches[0].clientY;
                break;
        }
        return currentPosition;
    };
    SliderBase.prototype._updateValue = function (value, renderedValue) {
        var _this = this;
        var step = this.props.step;
        var numDec = 0;
        if (isFinite(step)) {
            while (Math.round(step * Math.pow(10, numDec)) / Math.pow(10, numDec) !== step) {
                numDec++;
            }
        }
        // Make sure value has correct number of decimal places based on number of decimals in step
        var roundedValue = parseFloat(value.toFixed(numDec));
        var valueChanged = roundedValue !== this.state.value;
        this.setState({
            value: roundedValue,
            renderedValue: renderedValue
        }, function () {
            if (valueChanged && _this.props.onChange) {
                _this.props.onChange(_this.state.value);
            }
        });
    };
    SliderBase.defaultProps = {
        step: 1,
        min: 0,
        max: 10,
        showValue: true,
        disabled: false,
        vertical: false,
        buttonProps: {},
        originFromZero: false
    };
    return SliderBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=Slider.base.js.map

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Stack_index__ = __webpack_require__(2053);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Stack_index__["a"]; });

//# sourceMappingURL=Stack.js.map

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StackItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Foundation__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StackItem_styles__ = __webpack_require__(2054);
/** @jsx withSlots */



var view = function (props) {
    var children = props.children;
    if (__WEBPACK_IMPORTED_MODULE_0_react__["Children"].count(children) < 1) {
        return null;
    }
    var Slots = Object(__WEBPACK_IMPORTED_MODULE_1__Foundation__["b" /* getSlots */])(props, {
        root: 'div'
    });
    return Object(__WEBPACK_IMPORTED_MODULE_1__Foundation__["c" /* withSlots */])(Slots.root, null, children);
};
var StackItem = Object(__WEBPACK_IMPORTED_MODULE_1__Foundation__["a" /* createComponent */])({
    displayName: 'StackItem',
    styles: __WEBPACK_IMPORTED_MODULE_2__StackItem_styles__["a" /* StackItemStyles */],
    view: view
});
/* harmony default export */ __webpack_exports__["a"] = (StackItem);
//# sourceMappingURL=StackItem.js.map

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StickyPositionType; });
var StickyPositionType;
(function (StickyPositionType) {
    StickyPositionType[StickyPositionType["Both"] = 0] = "Both";
    StickyPositionType[StickyPositionType["Header"] = 1] = "Header";
    StickyPositionType[StickyPositionType["Footer"] = 2] = "Footer";
})(StickyPositionType || (StickyPositionType = {}));
//# sourceMappingURL=Sticky.types.js.map

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SwatchColorPickerBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_grid_Grid__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ColorPickerGridCell__ = __webpack_require__(829);





var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var SwatchColorPickerBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](SwatchColorPickerBase, _super);
    function SwatchColorPickerBase(props) {
        var _this = _super.call(this, props) || this;
        _this.navigationIdleDelay = 250 /* ms */;
        /**
         * When the whole swatchColorPicker is blurred,
         * make sure to clear the pending focused stated
         */
        _this._onSwatchColorPickerBlur = function () {
            if (_this.props.onCellFocused) {
                _this._cellFocused = false;
                _this.props.onCellFocused();
            }
        };
        /**
         * Render a color cell
         * @param item - The item to render
         * @returns - Element representing the item
         */
        _this._renderOption = function (item) {
            var id = _this._id;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__ColorPickerGridCell__["a" /* ColorPickerGridCell */], { item: item, id: id, color: item.color, styles: _this.props.getColorGridCellStyles, disabled: _this.props.disabled, onClick: _this._onCellClick, onHover: _this._onGridCellHovered, onFocus: _this._onGridCellFocused, selected: _this.state.selectedIndex !== undefined && _this.state.selectedIndex === item.index, circle: _this.props.cellShape === 'circle', label: item.label, onMouseEnter: _this._onMouseEnter, onMouseMove: _this._onMouseMove, onMouseLeave: _this._onMouseLeave, onWheel: _this._onWheel, onKeyDown: _this._onKeyDown, height: _this.props.cellHeight, width: _this.props.cellWidth, borderWidth: _this.props.cellBorderWidth }));
        };
        /**
         * Callback passed to the GridCell that will manage triggering the onCellHovered callback for mouseEnter
         */
        _this._onMouseEnter = function (ev) {
            if (!_this.props.focusOnHover) {
                if (!_this.isNavigationIdle || _this.props.disabled) {
                    return true;
                }
                return false;
            }
            if (_this.isNavigationIdle && !_this.props.disabled) {
                ev.currentTarget.focus();
            }
            return true;
        };
        /**
         * Callback passed to the GridCell that will manage Hover/Focus updates
         */
        _this._onMouseMove = function (ev) {
            if (!_this.props.focusOnHover) {
                if (!_this.isNavigationIdle || _this.props.disabled) {
                    return true;
                }
                return false;
            }
            var targetElement = ev.currentTarget;
            // If navigation is idle and the targetElement is the focused element bail out
            // if (!this.isNavigationIdle || (document && targetElement === (document.activeElement as HTMLElement))) {
            if (_this.isNavigationIdle && !(document && targetElement === document.activeElement)) {
                targetElement.focus();
            }
            return true;
        };
        /**
         * Callback passed to the GridCell that will manage Hover/Focus updates
         */
        _this._onMouseLeave = function (ev) {
            var parentSelector = _this.props.mouseLeaveParentSelector;
            if (!_this.props.focusOnHover || !parentSelector || !_this.isNavigationIdle || _this.props.disabled) {
                return;
            }
            // Get the the elements that math the given selector
            var elements = document.querySelectorAll(parentSelector);
            // iterate over the elements return to make sure it is a parent of the target and focus it
            for (var index = 0; index < elements.length; index += 1) {
                if (elements[index].contains(ev.currentTarget)) {
                    /**
                     * IE11 focus() method forces parents to scroll to top of element.
                     * Edge and IE expose a setActive() function for focusable divs that
                     * sets the page focus but does not scroll the parent element.
                     */
                    if (elements[index].setActive) {
                        try {
                            elements[index].setActive();
                        }
                        catch (e) {
                            /* no-op */
                        }
                    }
                    else {
                        elements[index].focus();
                    }
                    break;
                }
            }
        };
        /**
         * Callback to make sure we don't update the hovered element during mouse wheel
         */
        _this._onWheel = function () {
            _this.setNavigationTimeout();
        };
        /**
         * Callback that
         */
        _this._onKeyDown = function (ev) {
            if (ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].up || ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].down || ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].left || ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].right) {
                _this.setNavigationTimeout();
            }
        };
        /**
         * Sets a timeout so we won't process any mouse "hover" events
         * while navigating (via mouseWheel or arrowKeys)
         */
        _this.setNavigationTimeout = function () {
            if (!_this.isNavigationIdle && _this.navigationIdleTimeoutId !== undefined) {
                _this.async.clearTimeout(_this.navigationIdleTimeoutId);
                _this.navigationIdleTimeoutId = undefined;
            }
            else {
                _this.isNavigationIdle = false;
            }
            _this.navigationIdleTimeoutId = _this.async.setTimeout(function () {
                _this.isNavigationIdle = true;
            }, _this.navigationIdleDelay);
        };
        /**
         * Callback passed to the GridCell class that will trigger the onCellHovered callback of the SwatchColorPicker
         * NOTE: This will not be triggered if shouldFocusOnHover === true
         */
        _this._onGridCellHovered = function (item) {
            var onCellHovered = _this.props.onCellHovered;
            if (onCellHovered) {
                return item ? onCellHovered(item.id, item.color) : onCellHovered();
            }
        };
        /**
         * Callback passed to the GridCell class that will trigger the onCellFocus callback of the SwatchColorPicker
         */
        _this._onGridCellFocused = function (item) {
            var onCellFocused = _this.props.onCellFocused;
            if (onCellFocused) {
                if (item) {
                    _this._cellFocused = true;
                    return onCellFocused(item.id, item.color);
                }
                else {
                    _this._cellFocused = false;
                    return onCellFocused();
                }
            }
        };
        /**
         * Handle the click on a cell
         * @param item - The cell that the click was fired against
         */
        _this._onCellClick = function (item) {
            if (_this.props.disabled) {
                return;
            }
            var index = item.index;
            // If we have a valid index and it is not already
            // selected, select it
            if (index >= 0 && index !== _this.state.selectedIndex) {
                if (_this.props.onCellFocused && _this._cellFocused) {
                    _this._cellFocused = false;
                    _this.props.onCellFocused();
                }
                if (_this.props.onColorChanged) {
                    _this.props.onColorChanged(item.id, item.color);
                }
                // Update internal state only if the component is uncontrolled
                if (_this.props.isControlled !== true) {
                    _this.setState({
                        selectedIndex: index
                    });
                }
            }
        };
        _this._id = props.id || Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["N" /* getId */])('swatchColorPicker');
        if (false) {
            warnMutuallyExclusive('SwatchColorPicker', _this.props, {
                focusOnHover: 'onHover'
            });
            warnConditionallyRequiredProps('SwatchColorPicker', _this.props, ['focusOnHover'], 'mouseLeaveParentSelector', !!_this.props.mouseLeaveParentSelector);
        }
        _this.isNavigationIdle = true;
        _this.async = new __WEBPACK_IMPORTED_MODULE_2__Utilities__["a" /* Async */](_this);
        var selectedIndex;
        if (props.selectedId) {
            selectedIndex = _this._getSelectedIndex(props.colorCells, props.selectedId);
        }
        _this.state = {
            selectedIndex: selectedIndex
        };
        return _this;
    }
    SwatchColorPickerBase.prototype.componentWillReceiveProps = function (newProps) {
        if (newProps.selectedId !== undefined) {
            this.setState({
                selectedIndex: this._getSelectedIndex(newProps.colorCells, newProps.selectedId)
            });
        }
    };
    SwatchColorPickerBase.prototype.componentWillUnmount = function () {
        if (this.props.onCellFocused && this._cellFocused) {
            this._cellFocused = false;
            this.props.onCellFocused();
        }
    };
    SwatchColorPickerBase.prototype.render = function () {
        var _a = this.props, colorCells = _a.colorCells, columnCount = _a.columnCount, positionInSet = _a.positionInSet, setSize = _a.setSize, shouldFocusCircularNavigate = _a.shouldFocusCircularNavigate, className = _a.className, doNotContainWithinFocusZone = _a.doNotContainWithinFocusZone, styles = _a.styles, cellMargin = _a.cellMargin;
        var classNames = getClassNames(styles, {
            theme: this.props.theme,
            className: className,
            cellMargin: cellMargin
        });
        if (colorCells.length < 1 || columnCount < 1) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__utilities_grid_Grid__["a" /* Grid */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this.props, { items: colorCells.map(function (item, index) {
                return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, item, { index: index });
            }), columnCount: columnCount, onRenderItem: this._renderOption, positionInSet: positionInSet && positionInSet, setSize: setSize && setSize, shouldFocusCircularNavigate: shouldFocusCircularNavigate, doNotContainWithinFocusZone: doNotContainWithinFocusZone, onBlur: this._onSwatchColorPickerBlur, theme: this.props.theme, 
            // tslint:disable-next-line:jsx-no-lambda
            styles: function (props) { return ({
                root: classNames.root,
                tableCell: classNames.tableCell,
                focusedContainer: classNames.focusedContainer
            }); } })));
    };
    /**
     * Get the selected item's index
     * @param items - The items to search
     * @param selectedId - The selected item's id to find
     * @returns - The index of the selected item's id, -1 if there was no match
     */
    SwatchColorPickerBase.prototype._getSelectedIndex = function (items, selectedId) {
        var selectedIndex = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["C" /* findIndex */])(items, function (item) { return item.id === selectedId; });
        return selectedIndex >= 0 ? selectedIndex : undefined;
    };
    SwatchColorPickerBase.defaultProps = {
        cellShape: 'circle',
        disabled: false,
        shouldFocusCircularNavigate: true,
        cellMargin: 10
    };
    return SwatchColorPickerBase;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=SwatchColorPicker.base.js.map

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ColorPickerGridCell; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ColorPickerGridCell_base__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ColorPickerGridCell_styles__ = __webpack_require__(2064);



var ColorPickerGridCell = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__ColorPickerGridCell_base__["a" /* ColorPickerGridCellBase */], __WEBPACK_IMPORTED_MODULE_2__ColorPickerGridCell_styles__["a" /* getStyles */], undefined, { scope: 'ColorPickerGridCell' });
//# sourceMappingURL=ColorPickerGridCell.js.map

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ColorPickerGridCellBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_color_getColorFromString__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_grid_GridCell__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Button_ActionButton_ActionButton_styles__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Utilities__ = __webpack_require__(1);







var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_6__Utilities__["r" /* classNamesFunction */])();
var ColorCell = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ColorCell, _super);
    function ColorCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ColorCell;
}(__WEBPACK_IMPORTED_MODULE_3__utilities_grid_GridCell__["a" /* GridCell */]));
var ColorPickerGridCellBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ColorPickerGridCellBase, _super);
    function ColorPickerGridCellBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Render the core of a color cell
         * @returns - Element representing the core of the item
         */
        _this._onRenderColorOption = function (colorOption) {
            // Build an SVG for the cell with the given shape and color properties
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", { className: _this._classNames.svg, viewBox: "0 0 20 20", fill: Object(__WEBPACK_IMPORTED_MODULE_2__utilities_color_getColorFromString__["a" /* getColorFromString */])(colorOption.color).str }, _this.props.circle ? __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("circle", { cx: "50%", cy: "50%", r: "50%" }) : __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("rect", { width: "100%", height: "100%" })));
        };
        /**
         * Method to override the getClassNames func in a button.
         */
        _this._getClassNames = function (theme, className, variantClassName, iconClassName, menuIconClassName, disabled, checked, expanded, isSplit) {
            var styles = Object(__WEBPACK_IMPORTED_MODULE_4__Button_ActionButton_ActionButton_styles__["a" /* getStyles */])(theme);
            return Object(__WEBPACK_IMPORTED_MODULE_5__Styling__["E" /* mergeStyleSets */])(_this._classNames, {
                root: [
                    'ms-Button',
                    styles.root,
                    variantClassName,
                    className,
                    checked && ['is-checked', styles.rootChecked],
                    disabled && ['is-disabled', styles.rootDisabled],
                    !disabled &&
                        !checked && {
                        selectors: {
                            ':hover': styles.rootHovered,
                            ':focus': styles.rootFocused,
                            ':active': styles.rootPressed
                        }
                    },
                    disabled && checked && [styles.rootCheckedDisabled],
                    !disabled &&
                        checked && {
                        selectors: {
                            ':hover': styles.rootCheckedHovered,
                            ':active': styles.rootCheckedPressed
                        }
                    }
                ],
                flexContainer: ['ms-Button-flexContainer', styles.flexContainer]
            });
        };
        return _this;
    }
    ColorPickerGridCellBase.prototype.render = function () {
        var _a = this.props, item = _a.item, id = _a.id, selected = _a.selected, disabled = _a.disabled, styles = _a.styles, theme = _a.theme, circle = _a.circle, color = _a.color, onClick = _a.onClick, onHover = _a.onHover, onFocus = _a.onFocus, onMouseEnter = _a.onMouseEnter, onMouseMove = _a.onMouseMove, onMouseLeave = _a.onMouseLeave, onWheel = _a.onWheel, onKeyDown = _a.onKeyDown, height = _a.height, width = _a.width, borderWidth = _a.borderWidth;
        this._classNames = getClassNames(styles, {
            theme: theme,
            disabled: disabled,
            selected: selected,
            circle: circle,
            isWhite: this._isWhiteCell(color),
            height: height,
            width: width,
            borderWidth: borderWidth
        });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ColorCell, { item: item, id: id + "-" + item.id + "-" + item.index, key: item.id, disabled: disabled, role: 'gridcell', onRenderItem: this._onRenderColorOption, selected: selected, onClick: onClick, onHover: onHover, onFocus: onFocus, label: item.label, className: this._classNames.colorCell, getClassNames: this._getClassNames, index: item.index, onMouseEnter: onMouseEnter, onMouseMove: onMouseMove, onMouseLeave: onMouseLeave, onWheel: onWheel, onKeyDown: onKeyDown }));
    };
    /**
     * Validate if the cell's color is white or not to apply whiteCell style
     * @param inputColor - The color of the current cell
     * @returns - Whether the cell's color is white or not.
     */
    ColorPickerGridCellBase.prototype._isWhiteCell = function (inputColor) {
        var color = Object(__WEBPACK_IMPORTED_MODULE_2__utilities_color_getColorFromString__["a" /* getColorFromString */])(inputColor);
        return color.hex === 'ffffff';
    };
    ColorPickerGridCellBase.defaultProps = {
        circle: true,
        disabled: false,
        selected: false
    };
    return ColorPickerGridCellBase;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=ColorPickerGridCell.base.js.map

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TeachingBubbleBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TeachingBubbleContent__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Callout__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_DirectionalHint__ = __webpack_require__(36);






var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var TeachingBubbleBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](TeachingBubbleBase, _super);
    // Constructor
    function TeachingBubbleBase(props) {
        var _this = _super.call(this, props) || this;
        _this.rootElement = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.state = {};
        _this._defaultCalloutProps = {
            beakWidth: 16,
            gapSpace: 0,
            setInitialFocus: true,
            doNotLayer: false,
            directionalHint: __WEBPACK_IMPORTED_MODULE_5__common_DirectionalHint__["a" /* DirectionalHint */].rightCenter
        };
        return _this;
    }
    TeachingBubbleBase.prototype.focus = function () {
        if (this.rootElement.current) {
            this.rootElement.current.focus();
        }
    };
    TeachingBubbleBase.prototype.render = function () {
        var _a = this.props, setCalloutProps = _a.calloutProps, targetElement = _a.targetElement, onDismiss = _a.onDismiss, isWide = _a.isWide, styles = _a.styles, theme = _a.theme, target = _a.target;
        var calloutProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._defaultCalloutProps, setCalloutProps);
        var stylesProps = {
            theme: theme,
            isWide: isWide,
            calloutClassName: calloutProps ? calloutProps.className : undefined
        };
        var classNames = getClassNames(styles, stylesProps);
        var calloutStyles = classNames.subComponentStyles
            ? classNames.subComponentStyles.callout
            : undefined;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Callout__["a" /* Callout */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ target: target || targetElement, onDismiss: onDismiss }, calloutProps, { className: classNames.root, styles: calloutStyles, hideOverflow: true }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: this.rootElement },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__TeachingBubbleContent__["a" /* TeachingBubbleContent */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this.props)))));
    };
    TeachingBubbleBase.defaultProps = {
        /**
         * Default calloutProps is deprecated in favor of private `_defaultCalloutProps`.
         * Remove in next release.
         * @deprecated In favor of private `_defaultCalloutProps`.
         */
        calloutProps: {
            beakWidth: 16,
            gapSpace: 0,
            setInitialFocus: true,
            doNotLayer: false,
            directionalHint: __WEBPACK_IMPORTED_MODULE_5__common_DirectionalHint__["a" /* DirectionalHint */].rightCenter
        }
    };
    return TeachingBubbleBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=TeachingBubble.base.js.map

/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TeachingBubbleContent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TeachingBubbleContent_base__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TeachingBubble_styles__ = __webpack_require__(834);



var TeachingBubbleContent = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__TeachingBubbleContent_base__["a" /* TeachingBubbleContentBase */], __WEBPACK_IMPORTED_MODULE_2__TeachingBubble_styles__["a" /* getStyles */], undefined, { scope: 'TeachingBubbleContent' });
//# sourceMappingURL=TeachingBubbleContent.js.map

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TeachingBubbleContentBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Image__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Stack__ = __webpack_require__(825);






var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var TeachingBubbleContentBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](TeachingBubbleContentBase, _super);
    function TeachingBubbleContentBase(props) {
        var _this = _super.call(this, props) || this;
        _this.rootElement = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._onKeyDown = function (e) {
            if (_this.props.onDismiss) {
                if (e.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].escape) {
                    _this.props.onDismiss();
                }
            }
        };
        _this.state = {};
        return _this;
    }
    TeachingBubbleContentBase.prototype.componentDidMount = function () {
        if (this.props.onDismiss) {
            document.addEventListener('keydown', this._onKeyDown, false);
        }
    };
    TeachingBubbleContentBase.prototype.componentWillUnmount = function () {
        if (this.props.onDismiss) {
            document.removeEventListener('keydown', this._onKeyDown);
        }
    };
    TeachingBubbleContentBase.prototype.focus = function () {
        if (this.rootElement.current) {
            this.rootElement.current.focus();
        }
    };
    TeachingBubbleContentBase.prototype.render = function () {
        var _a = this.props, children = _a.children, illustrationImage = _a.illustrationImage, primaryButtonProps = _a.primaryButtonProps, secondaryButtonProps = _a.secondaryButtonProps, headline = _a.headline, hasCondensedHeadline = _a.hasCondensedHeadline, hasCloseIcon = _a.hasCloseIcon, onDismiss = _a.onDismiss, closeButtonAriaLabel = _a.closeButtonAriaLabel, hasSmallHeadline = _a.hasSmallHeadline, isWide = _a.isWide, styles = _a.styles, theme = _a.theme, ariaDescribedBy = _a.ariaDescribedBy, ariaLabelledBy = _a.ariaLabelledBy, customFooterContent = _a.footerContent;
        var imageContent;
        var headerContent;
        var bodyContent;
        var footerContent;
        var closeButton;
        var classNames = getClassNames(styles, {
            theme: theme,
            hasCondensedHeadline: hasCondensedHeadline,
            hasSmallHeadline: hasSmallHeadline,
            isWide: isWide,
            primaryButtonClassName: primaryButtonProps ? primaryButtonProps.className : undefined,
            secondaryButtonClassName: secondaryButtonProps ? secondaryButtonProps.className : undefined
        });
        if (illustrationImage && illustrationImage.src) {
            imageContent = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.imageContent },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Image__["a" /* Image */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, illustrationImage))));
        }
        if (headline) {
            var HeaderWrapperAs = typeof headline === 'string' ? 'p' : 'div';
            headerContent = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.header },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](HeaderWrapperAs, { className: classNames.headline, id: ariaLabelledBy }, headline)));
        }
        if (children) {
            var BodyContentWrapperAs = typeof children === 'string' ? 'p' : 'div';
            bodyContent = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.body },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](BodyContentWrapperAs, { className: classNames.subText, id: ariaDescribedBy }, children)));
        }
        if (primaryButtonProps || secondaryButtonProps || customFooterContent) {
            footerContent = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Stack__["a" /* Stack */], { className: classNames.footer, horizontal: true, horizontalAlign: customFooterContent ? 'space-between' : 'end' },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Stack__["a" /* Stack */].Item, { align: "center" }, __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", null, customFooterContent)),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Stack__["a" /* Stack */].Item, null,
                    secondaryButtonProps && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Button__["f" /* DefaultButton */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, secondaryButtonProps, { className: classNames.secondaryButton })),
                    primaryButtonProps && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Button__["h" /* PrimaryButton */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, primaryButtonProps, { className: classNames.primaryButton })))));
        }
        if (hasCloseIcon) {
            closeButton = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Button__["g" /* IconButton */], { className: classNames.closeButton, iconProps: { iconName: 'Cancel' }, title: closeButtonAriaLabel, ariaLabel: closeButtonAriaLabel, onClick: onDismiss }));
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.content, ref: this.rootElement, role: 'dialog', tabIndex: -1, "aria-labelledby": ariaLabelledBy, "aria-describedby": ariaDescribedBy, "data-is-focusable": true },
            imageContent,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.bodyContent },
                headerContent,
                bodyContent,
                footerContent,
                closeButton)));
    };
    // Specify default props values
    TeachingBubbleContentBase.defaultProps = {
        hasCondensedHeadline: false,
        imageProps: {
            imageFit: __WEBPACK_IMPORTED_MODULE_4__Image__["b" /* ImageFit */].cover,
            width: 364,
            height: 130
        }
    };
    return TeachingBubbleContentBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=TeachingBubbleContent.base.js.map

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var globalClassNames = {
    root: 'ms-TeachingBubble',
    body: 'ms-TeachingBubble-body',
    bodyContent: 'ms-TeachingBubble-bodycontent',
    closeButton: 'ms-TeachingBubble-closebutton',
    content: 'ms-TeachingBubble-content',
    footer: 'ms-TeachingBubble-footer',
    header: 'ms-TeachingBubble-header',
    headerIsCondensed: 'ms-TeachingBubble-header--condensed',
    headerIsSmall: 'ms-TeachingBubble-header--small',
    headerIsLarge: 'ms-TeachingBubble-header--large',
    headline: 'ms-TeachingBubble-headline',
    image: 'ms-TeachingBubble-image',
    primaryButton: 'ms-TeachingBubble-primaryButton',
    secondaryButton: 'ms-TeachingBubble-secondaryButton',
    subText: 'ms-TeachingBubble-subText',
    // TODO: Button global class name usage should be converted to a styles function once
    //        Button supports JS styling, which means these button names can be removed.
    button: 'ms-Button',
    buttonLabel: 'ms-Button-label'
};
var opacityFadeIn = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["C" /* keyframes */])({
    '0%': {
        opacity: 0,
        animationTimingFunction: __WEBPACK_IMPORTED_MODULE_0__Styling__["c" /* AnimationVariables */].easeFunction1,
        transform: 'scale3d(.90,.90,.90)'
    },
    '100%': {
        opacity: 1,
        transform: 'scale3d(1,1,1)'
    }
});
var rootStyle = function (isWide) {
    return [
        {
            display: 'block',
            maxWidth: 364,
            border: 0,
            outline: 'transparent',
            boxShadow: 'none !important',
            width: 'calc(100% + 1px)',
            animationName: "" + opacityFadeIn,
            animationDuration: '300ms',
            animationTimingFunction: 'linear',
            animationFillMode: 'both'
        },
        isWide && {
            maxWidth: '456px'
        }
    ];
};
var headerStyle = function (classNames, hasCondensedHeadline, hasSmallHeadline) {
    if (hasCondensedHeadline) {
        return [
            classNames.headerIsCondensed,
            {
                marginBottom: 14
            }
        ];
    }
    if (hasSmallHeadline) {
        return [
            classNames.headerIsSmall,
            {
                selectors: {
                    ':not(:last-child)': {
                        marginBottom: '14px'
                    }
                }
            }
        ];
    }
    // Large headline is default
    return [
        classNames.headerIsLarge,
        {
            selectors: {
                ':not(:last-child)': {
                    marginBottom: '14px'
                }
            }
        }
    ];
};
var getStyles = function (props) {
    var calloutClassName = props.calloutClassName, hasCondensedHeadline = props.hasCondensedHeadline, hasSmallHeadline = props.hasSmallHeadline, isWide = props.isWide, primaryButtonClassName = props.primaryButtonClassName, secondaryButtonClassName = props.secondaryButtonClassName, theme = props.theme;
    var hasLargeHeadline = !hasCondensedHeadline && !hasSmallHeadline;
    var palette = theme.palette;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(globalClassNames, theme);
    return {
        root: [classNames.root, theme.fonts.medium, calloutClassName],
        body: [
            classNames.body,
            {
                selectors: {
                    ':not(:last-child)': {
                        marginBottom: '20px'
                    }
                }
            }
        ],
        bodyContent: [
            classNames.bodyContent,
            {
                padding: '20px 24px 20px 24px'
            }
        ],
        closeButton: [
            classNames.closeButton,
            {
                position: 'absolute',
                right: 0,
                top: 0,
                margin: '15px 15px 0 0',
                borderRadius: 0,
                color: palette.white,
                fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].small,
                selectors: {
                    ':hover': {
                        background: 'transparent'
                    }
                }
            }
        ],
        content: [
            classNames.content
        ].concat(rootStyle(isWide), [
            isWide && {
                display: 'flex'
            }
        ]),
        footer: [
            classNames.footer,
            {
                display: 'flex',
                flex: 'auto',
                alignItems: 'center',
                color: palette.white,
                selectors: (_a = {},
                    // TODO: global class name usage should be converted to a button styles function once Button supports JS styling
                    _a["." + classNames.button + ":not(:first-child)"] = {
                        marginLeft: 10
                    },
                    _a)
            }
        ],
        header: [
            classNames.header
        ].concat(headerStyle(classNames, hasCondensedHeadline, hasSmallHeadline), [
            (hasCondensedHeadline || hasSmallHeadline) && [
                __WEBPACK_IMPORTED_MODULE_0__Styling__["d" /* DefaultFontStyles */].medium,
                {
                    marginRight: 24,
                    fontWeight: __WEBPACK_IMPORTED_MODULE_0__Styling__["f" /* FontWeights */].semibold
                }
            ]
        ]),
        headline: [
            classNames.headline,
            {
                margin: 0,
                color: palette.white
            },
            hasLargeHeadline && [
                __WEBPACK_IMPORTED_MODULE_0__Styling__["d" /* DefaultFontStyles */].xxLarge,
                {
                    fontWeight: __WEBPACK_IMPORTED_MODULE_0__Styling__["f" /* FontWeights */].light
                }
            ]
        ],
        imageContent: [
            classNames.header,
            classNames.image,
            isWide && {
                display: 'flex',
                alignItems: 'center',
                maxWidth: 154
            }
        ],
        primaryButton: [
            classNames.primaryButton,
            primaryButtonClassName,
            {
                backgroundColor: palette.white,
                borderColor: palette.white,
                whiteSpace: 'nowrap',
                selectors: (_b = {},
                    // TODO: global class name usage should be converted to a button styles function once Button supports JS styling
                    _b["." + classNames.buttonLabel] = [
                        __WEBPACK_IMPORTED_MODULE_0__Styling__["d" /* DefaultFontStyles */].medium,
                        {
                            color: palette.themePrimary
                        }
                    ],
                    _b[':hover'] = {
                        backgroundColor: palette.themeLighter,
                        borderColor: palette.themeLighter
                    },
                    _b[':focus'] = {
                        backgroundColor: palette.themeLighter,
                        borderColor: palette.white
                    },
                    _b[':active'] = {
                        backgroundColor: palette.white,
                        borderColor: palette.white
                    },
                    _b)
            }
        ],
        secondaryButton: [
            classNames.secondaryButton,
            secondaryButtonClassName,
            {
                backgroundColor: palette.themePrimary,
                borderColor: palette.white,
                whiteSpace: 'nowrap',
                selectors: (_c = {},
                    // TODO: global class name usage should be converted to a button styles function once Button supports JS styling
                    _c["." + classNames.buttonLabel] = [
                        __WEBPACK_IMPORTED_MODULE_0__Styling__["d" /* DefaultFontStyles */].medium,
                        {
                            color: palette.white
                        }
                    ],
                    _c['&:hover, &:focus'] = {
                        backgroundColor: palette.themeDarkAlt,
                        borderColor: palette.white
                    },
                    _c[':active'] = {
                        backgroundColor: palette.themePrimary,
                        borderColor: palette.white
                    },
                    _c)
            }
        ],
        subText: [
            classNames.subText,
            {
                margin: 0,
                fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].medium,
                color: palette.white,
                fontWeight: __WEBPACK_IMPORTED_MODULE_0__Styling__["f" /* FontWeights */].regular
            }
        ],
        subComponentStyles: {
            callout: {
                root: rootStyle(isWide).concat([theme.fonts.medium]),
                beak: [
                    {
                        background: palette.themePrimary
                    }
                ],
                calloutMain: [
                    {
                        background: palette.themePrimary
                    }
                ]
            }
        }
    };
    var _a, _b, _c;
};
//# sourceMappingURL=TeachingBubble.styles.js.map

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TextView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Foundation__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);

/** @jsx withSlots */


var TextView = function (props) {
    if (!props.children) {
        return null;
    }
    var block = props.block, className = props.className, _a = props.as, RootType = _a === void 0 ? 'span' : _a, variant = props.variant, nowrap = props.nowrap, rest = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __rest */](props, ["block", "className", "as", "variant", "nowrap"]);
    var Slots = Object(__WEBPACK_IMPORTED_MODULE_1__Foundation__["b" /* getSlots */])(props, {
        root: RootType
    });
    return Object(__WEBPACK_IMPORTED_MODULE_1__Foundation__["c" /* withSlots */])(Slots.root, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["R" /* getNativeProps */])(rest, __WEBPACK_IMPORTED_MODULE_2__Utilities__["_3" /* htmlElementProperties */])));
};
//# sourceMappingURL=Text.view.js.map

/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TextStyles; });
var TextStyles = function (props, theme) {
    var as = props.as, className = props.className, block = props.block, nowrap = props.nowrap, variant = props.variant;
    var fonts = theme.fonts;
    var variantObject = fonts[variant || 'medium'];
    return {
        root: [
            theme.fonts.medium,
            {
                display: block ? (as === 'td' ? 'table-cell' : 'block') : 'inline',
                fontFamily: (variantObject && variantObject.fontFamily) || 'inherit',
                fontSize: (variantObject && variantObject.fontSize) || 'inherit',
                fontWeight: (variantObject && variantObject.fontWeight) || 'inherit',
                color: (variantObject && variantObject.color) || 'inherit',
                mozOsxFontSmoothing: variantObject && variantObject.MozOsxFontSmoothing,
                webkitFontSmoothing: variantObject && variantObject.WebkitFontSmoothing
            },
            nowrap && {
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            },
            className
        ]
    };
};
//# sourceMappingURL=Text.styles.js.map

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return biddingStepsDefinitions; });
var biddingStepsDefinitions={0:{values:[200,500,1000,2000,3000,5000],default:1000},100000:{values:[500,1000,2000,3000,4000,6000],default:1000},200000:{values:[1000,2000,3000,4000,5000,10000],default:2000},300000:{values:[1000,2000,3000,4000,5000,10000],default:3000},400000:{values:[2000,3000,4000,5000,8000,12000],default:4000},500000:{values:[2000,3000,5000,7000,10000,15000],default:5000},600000:{values:[3000,5000,6000,8000,10000,15000],default:5000},800000:{values:[4000,5000,8000,10000,15000,20000],default:5000},1000000:{values:[5000,7000,10000,15000,20000,25000],default:10000},1500000:{values:[5000,10000,15000,20000,25000,30000],default:10000},2000000:{values:[5000,10000,15000,20000,30000,40000],default:15000},3000000:{values:[10000,15000,20000,30000,40000,50000],default:20000},5000000:{values:[10000,20000,30000,40000,50000,100000],default:30000},10000000:{values:[30000,50000,70000,100000,150000],default:50000}};

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(2078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_styles__ = __webpack_require__(2080);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint prefer-template: 0 */






var Dropzone = function (_React$Component) {
  _inherits(Dropzone, _React$Component);

  function Dropzone(props, context) {
    _classCallCheck(this, Dropzone);

    var _this = _possibleConstructorReturn(this, (Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).call(this, props, context));

    _this.renderChildren = function (children, isDragActive, isDragAccept, isDragReject) {
      if (typeof children === 'function') {
        return children(_extends({}, _this.state, {
          isDragActive: isDragActive,
          isDragAccept: isDragAccept,
          isDragReject: isDragReject
        }));
      }
      return children;
    };

    _this.composeHandlers = _this.composeHandlers.bind(_this);
    _this.onClick = _this.onClick.bind(_this);
    _this.onDocumentDrop = _this.onDocumentDrop.bind(_this);
    _this.onDragEnter = _this.onDragEnter.bind(_this);
    _this.onDragLeave = _this.onDragLeave.bind(_this);
    _this.onDragOver = _this.onDragOver.bind(_this);
    _this.onDragStart = _this.onDragStart.bind(_this);
    _this.onDrop = _this.onDrop.bind(_this);
    _this.onFileDialogCancel = _this.onFileDialogCancel.bind(_this);
    _this.onInputElementClick = _this.onInputElementClick.bind(_this);

    _this.setRef = _this.setRef.bind(_this);
    _this.setRefs = _this.setRefs.bind(_this);

    _this.isFileDialogActive = false;

    _this.state = {
      draggedFiles: [],
      acceptedFiles: [],
      rejectedFiles: []
    };
    return _this;
  }

  _createClass(Dropzone, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var preventDropOnDocument = this.props.preventDropOnDocument;

      this.dragTargets = [];

      if (preventDropOnDocument) {
        document.addEventListener('dragover', __WEBPACK_IMPORTED_MODULE_2__utils__["f" /* onDocumentDragOver */], false);
        document.addEventListener('drop', this.onDocumentDrop, false);
      }
      this.fileInputEl.addEventListener('click', this.onInputElementClick, false);
      window.addEventListener('focus', this.onFileDialogCancel, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var preventDropOnDocument = this.props.preventDropOnDocument;

      if (preventDropOnDocument) {
        document.removeEventListener('dragover', __WEBPACK_IMPORTED_MODULE_2__utils__["f" /* onDocumentDragOver */]);
        document.removeEventListener('drop', this.onDocumentDrop);
      }
      if (this.fileInputEl != null) {
        this.fileInputEl.removeEventListener('click', this.onInputElementClick, false);
      }
      window.removeEventListener('focus', this.onFileDialogCancel, false);
    }
  }, {
    key: 'composeHandlers',
    value: function composeHandlers(handler) {
      if (this.props.disabled) {
        return null;
      }

      return handler;
    }
  }, {
    key: 'onDocumentDrop',
    value: function onDocumentDrop(evt) {
      if (this.node && this.node.contains(evt.target)) {
        // if we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
      }
      evt.preventDefault();
      this.dragTargets = [];
    }
  }, {
    key: 'onDragStart',
    value: function onDragStart(evt) {
      if (this.props.onDragStart) {
        this.props.onDragStart.call(this, evt);
      }
    }
  }, {
    key: 'onDragEnter',
    value: function onDragEnter(evt) {
      var _this2 = this;

      evt.preventDefault();

      // Count the dropzone and any children that are entered.
      if (this.dragTargets.indexOf(evt.target) === -1) {
        this.dragTargets.push(evt.target);
      }

      Promise.resolve(this.props.getDataTransferItems(evt)).then(function (draggedFiles) {
        _this2.setState({
          isDragActive: true, // Do not rely on files for the drag state. It doesn't work in Safari.
          draggedFiles: draggedFiles
        });
      });
      if (this.props.onDragEnter) {
        this.props.onDragEnter.call(this, evt);
      }
    }
  }, {
    key: 'onDragOver',
    value: function onDragOver(evt) {
      // eslint-disable-line class-methods-use-this
      evt.preventDefault();
      evt.stopPropagation();
      try {
        // The file dialog on Chrome allows users to drag files from the dialog onto
        // the dropzone, causing the browser the crash when the file dialog is closed.
        // A drop effect of 'none' prevents the file from being dropped
        evt.dataTransfer.dropEffect = this.isFileDialogActive ? 'none' : 'copy'; // eslint-disable-line no-param-reassign
      } catch (err) {
        // continue regardless of error
      }

      if (this.props.onDragOver) {
        this.props.onDragOver.call(this, evt);
      }
      return false;
    }
  }, {
    key: 'onDragLeave',
    value: function onDragLeave(evt) {
      var _this3 = this;

      evt.preventDefault();

      // Only deactivate once the dropzone and all children have been left.
      this.dragTargets = this.dragTargets.filter(function (el) {
        return el !== evt.target && _this3.node.contains(el);
      });
      if (this.dragTargets.length > 0) {
        return;
      }

      // Clear dragging files state
      this.setState({
        isDragActive: false,
        draggedFiles: []
      });

      if (this.props.onDragLeave) {
        this.props.onDragLeave.call(this, evt);
      }
    }
  }, {
    key: 'onDrop',
    value: function onDrop(evt) {
      var _this4 = this;

      var _props = this.props,
          onDrop = _props.onDrop,
          onDropAccepted = _props.onDropAccepted,
          onDropRejected = _props.onDropRejected,
          multiple = _props.multiple,
          disablePreview = _props.disablePreview,
          accept = _props.accept,
          getDataTransferItems = _props.getDataTransferItems;

      // Stop default browser behavior

      evt.preventDefault();

      // Reset the counter along with the drag on a drop.
      this.dragTargets = [];
      this.isFileDialogActive = false;

      // Clear files value
      this.draggedFiles = null;

      // Reset drag state
      this.setState({
        isDragActive: false,
        draggedFiles: []
      });

      Promise.resolve(getDataTransferItems(evt)).then(function (fileList) {
        var acceptedFiles = [];
        var rejectedFiles = [];

        fileList.forEach(function (file) {
          if (!disablePreview) {
            try {
              file.preview = window.URL.createObjectURL(file); // eslint-disable-line no-param-reassign
            } catch (err) {
              if (false) {
                console.error('Failed to generate preview for file', file, err); // eslint-disable-line no-console
              }
            }
          }

          if (Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* fileAccepted */])(file, accept) && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* fileMatchSize */])(file, _this4.props.maxSize, _this4.props.minSize)) {
            acceptedFiles.push(file);
          } else {
            rejectedFiles.push(file);
          }
        });

        if (!multiple) {
          // if not in multi mode add any extra accepted files to rejected.
          // This will allow end users to easily ignore a multi file drop in "single" mode.
          rejectedFiles.push.apply(rejectedFiles, _toConsumableArray(acceptedFiles.splice(1)));
        }

        if (onDrop) {
          onDrop.call(_this4, acceptedFiles, rejectedFiles, evt);
        }

        if (rejectedFiles.length > 0 && onDropRejected) {
          onDropRejected.call(_this4, rejectedFiles, evt);
        }

        if (acceptedFiles.length > 0 && onDropAccepted) {
          onDropAccepted.call(_this4, acceptedFiles, evt);
        }
      });
    }
  }, {
    key: 'onClick',
    value: function onClick(evt) {
      var _props2 = this.props,
          onClick = _props2.onClick,
          disableClick = _props2.disableClick;

      if (!disableClick) {
        evt.stopPropagation();

        if (onClick) {
          onClick.call(this, evt);
        }

        // in IE11/Edge the file-browser dialog is blocking, ensure this is behind setTimeout
        // this is so react can handle state changes in the onClick prop above above
        // see: https://github.com/react-dropzone/react-dropzone/issues/450
        if (Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* isIeOrEdge */])()) {
          setTimeout(this.open.bind(this), 0);
        } else {
          this.open();
        }
      }
    }
  }, {
    key: 'onInputElementClick',
    value: function onInputElementClick(evt) {
      evt.stopPropagation();
      if (this.props.inputProps && this.props.inputProps.onClick) {
        this.props.inputProps.onClick();
      }
    }
  }, {
    key: 'onFileDialogCancel',
    value: function onFileDialogCancel() {
      var _this5 = this;

      // timeout will not recognize context of this method
      var onFileDialogCancel = this.props.onFileDialogCancel;
      // execute the timeout only if the FileDialog is opened in the browser

      if (this.isFileDialogActive) {
        setTimeout(function () {
          if (_this5.fileInputEl != null) {
            // Returns an object as FileList
            var files = _this5.fileInputEl.files;


            if (!files.length) {
              _this5.isFileDialogActive = false;
            }
          }

          if (typeof onFileDialogCancel === 'function') {
            onFileDialogCancel();
          }
        }, 300);
      }
    }
  }, {
    key: 'setRef',
    value: function setRef(ref) {
      this.node = ref;
    }
  }, {
    key: 'setRefs',
    value: function setRefs(ref) {
      this.fileInputEl = ref;
    }
    /**
     * Open system file upload dialog.
     *
     * @public
     */

  }, {
    key: 'open',
    value: function open() {
      this.isFileDialogActive = true;
      this.fileInputEl.value = null;
      this.fileInputEl.click();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          accept = _props3.accept,
          acceptClassName = _props3.acceptClassName,
          activeClassName = _props3.activeClassName,
          children = _props3.children,
          disabled = _props3.disabled,
          disabledClassName = _props3.disabledClassName,
          inputProps = _props3.inputProps,
          multiple = _props3.multiple,
          name = _props3.name,
          rejectClassName = _props3.rejectClassName,
          rest = _objectWithoutProperties(_props3, ['accept', 'acceptClassName', 'activeClassName', 'children', 'disabled', 'disabledClassName', 'inputProps', 'multiple', 'name', 'rejectClassName']);

      var acceptStyle = rest.acceptStyle,
          activeStyle = rest.activeStyle,
          _rest$className = rest.className,
          className = _rest$className === undefined ? '' : _rest$className,
          disabledStyle = rest.disabledStyle,
          rejectStyle = rest.rejectStyle,
          style = rest.style,
          props = _objectWithoutProperties(rest, ['acceptStyle', 'activeStyle', 'className', 'disabledStyle', 'rejectStyle', 'style']);

      var _state = this.state,
          isDragActive = _state.isDragActive,
          draggedFiles = _state.draggedFiles;

      var filesCount = draggedFiles.length;
      var isMultipleAllowed = multiple || filesCount <= 1;
      var isDragAccept = filesCount > 0 && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* allFilesAccepted */])(draggedFiles, this.props.accept);
      var isDragReject = filesCount > 0 && (!isDragAccept || !isMultipleAllowed);
      var noStyles = !className && !style && !activeStyle && !acceptStyle && !rejectStyle && !disabledStyle;

      if (isDragActive && activeClassName) {
        className += ' ' + activeClassName;
      }
      if (isDragAccept && acceptClassName) {
        className += ' ' + acceptClassName;
      }
      if (isDragReject && rejectClassName) {
        className += ' ' + rejectClassName;
      }
      if (disabled && disabledClassName) {
        className += ' ' + disabledClassName;
      }

      if (noStyles) {
        style = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].default;
        activeStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].active;
        acceptStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].active;
        rejectStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].rejected;
        disabledStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].disabled;
      }

      var appliedStyle = _extends({ position: 'relative' }, style);
      if (activeStyle && isDragActive) {
        appliedStyle = _extends({}, appliedStyle, activeStyle);
      }
      if (acceptStyle && isDragAccept) {
        appliedStyle = _extends({}, appliedStyle, acceptStyle);
      }
      if (rejectStyle && isDragReject) {
        appliedStyle = _extends({}, appliedStyle, rejectStyle);
      }
      if (disabledStyle && disabled) {
        appliedStyle = _extends({}, appliedStyle, disabledStyle);
      }

      var inputAttributes = {
        accept: accept,
        disabled: disabled,
        type: 'file',
        style: _extends({
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          opacity: 0.00001,
          pointerEvents: 'none'
        }, inputProps.style),
        multiple: __WEBPACK_IMPORTED_MODULE_2__utils__["g" /* supportMultiple */] && multiple,
        ref: this.setRefs,
        onChange: this.onDrop,
        autoComplete: 'off'
      };

      if (name && name.length) {
        inputAttributes.name = name;
      }

      // Destructure custom props away from props used for the div element

      var acceptedFiles = props.acceptedFiles,
          preventDropOnDocument = props.preventDropOnDocument,
          disablePreview = props.disablePreview,
          disableClick = props.disableClick,
          onDropAccepted = props.onDropAccepted,
          onDropRejected = props.onDropRejected,
          onFileDialogCancel = props.onFileDialogCancel,
          maxSize = props.maxSize,
          minSize = props.minSize,
          getDataTransferItems = props.getDataTransferItems,
          divProps = _objectWithoutProperties(props, ['acceptedFiles', 'preventDropOnDocument', 'disablePreview', 'disableClick', 'onDropAccepted', 'onDropRejected', 'onFileDialogCancel', 'maxSize', 'minSize', 'getDataTransferItems']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({
          className: className,
          style: appliedStyle
        }, divProps /* expand user provided props first so event handlers are never overridden */, {
          onClick: this.composeHandlers(this.onClick),
          onDragStart: this.composeHandlers(this.onDragStart),
          onDragEnter: this.composeHandlers(this.onDragEnter),
          onDragOver: this.composeHandlers(this.onDragOver),
          onDragLeave: this.composeHandlers(this.onDragLeave),
          onDrop: this.composeHandlers(this.onDrop),
          ref: this.setRef,
          'aria-disabled': disabled
        }),
        this.renderChildren(children, isDragActive, isDragAccept, isDragReject),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({}, inputProps /* expand user provided inputProps first so inputAttributes override them */, inputAttributes))
      );
    }
  }]);

  return Dropzone;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Dropzone);

Dropzone.propTypes = {
  /**
   * Allow specific types of files. See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */
  accept: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]),

  /**
   * Contents of the dropzone
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),

  /**
   * Disallow clicking on the dropzone container to open file dialog
   */
  disableClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Enable/disable the dropzone entirely
   */
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Enable/disable preview generation
   */
  disablePreview: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Pass additional attributes to the `<input type="file"/>` tag
   */
  inputProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * Allow dropping multiple files
   */
  multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * `name` attribute for the input tag
   */
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * Minimum file size (in bytes)
   */
  minSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * className
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when drag is active
   */
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when drop will be accepted
   */
  acceptClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when drop will be rejected
   */
  rejectClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when dropzone is disabled
   */
  disabledClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * CSS styles to apply
   */
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drag is active
   */
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drop will be accepted
   */
  acceptStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drop will be rejected
   */
  rejectStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when dropzone is disabled
   */
  disabledStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * getDataTransferItems handler
   * @param {Event} event
   * @returns {Array} array of File objects
   */
  getDataTransferItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onClick callback
   * @param {Event} event
   */
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDrop callback
   */
  onDrop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDropAccepted callback
   */
  onDropAccepted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDropRejected callback
   */
  onDropRejected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragStart callback
   */
  onDragStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragEnter callback
   */
  onDragEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragOver callback
   */
  onDragOver: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragLeave callback
   */
  onDragLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Provide a callback on clicking the cancel button of the file dialog
   */
  onFileDialogCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

Dropzone.defaultProps = {
  preventDropOnDocument: true,
  disabled: false,
  disablePreview: false,
  disableClick: false,
  inputProps: {},
  multiple: true,
  maxSize: Infinity,
  minSize: 0,
  getDataTransferItems: __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* getDataTransferItems */]
};

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_src_app_components_RoundDateDisplay__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_src_app_components_Money__ = __webpack_require__(69);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SaleWizardRoundInfo=(_dec=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["d" /* inject */])('app'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_2__build_src_app_components_Localization__["a" /* localizable */])(_class=(_temp=_class2=function(_Component){_inherits(SaleWizardRoundInfo,_Component);function SaleWizardRoundInfo(){_classCallCheck(this,SaleWizardRoundInfo);return _possibleConstructorReturn(this,(SaleWizardRoundInfo.__proto__||Object.getPrototypeOf(SaleWizardRoundInfo)).apply(this,arguments));}_createClass(SaleWizardRoundInfo,[{key:'render',value:function render(){var _props=this.props,round=_props.round,t=_props.t;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'ms-font-l ms-fontWeight-semibold',style:{color:'#003da5'}},t('roundtype::'+round.type)),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',null,t('Ends'),':',' ',__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_src_app_components_RoundDateDisplay__["a" /* default */],{end:round.endsAt,duration:round.durationInDays})),(!!round.offerValidityUntil||!!round.offerValidityInDays)&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',null,t('Offer validity'),':',' ',__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_src_app_components_RoundDateDisplay__["a" /* default */],{end:round.offerValidityUntil,duration:round.offerValidityInDays})),round.estimate&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',null,t('Estimate'),':',' ',__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_src_app_components_Money__["a" /* default */],{value:round.estimate,currency:this.props.app.currency.code,locale:this.props.intl.locale})),round.startPrice&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',null,round.type==='sealed_bidding'?t('Minimum price'):t('Start price'),':',' ',__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_src_app_components_Money__["a" /* default */],{value:round.startPrice,currency:this.props.app.currency.code,locale:this.props.intl.locale})),round.redButtonPrice&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',null,t('Red button price'),':',' ',__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_src_app_components_Money__["a" /* default */],{value:round.redButtonPrice,currency:this.props.app.currency.code,locale:this.props.intl.locale})));}}]);return SaleWizardRoundInfo;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class2.displayName='SaleWizardRoundInfo',_temp))||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (SaleWizardRoundInfo);

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react_intl__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Localization__ = __webpack_require__(8);
var RoundDateDisplay=function RoundDateDisplay(_ref){var end=_ref.end,duration=_ref.duration,_ref$preposition=_ref.preposition,preposition=_ref$preposition===undefined?'until':_ref$preposition,_ref$format=_ref.format,format=_ref$format===undefined?'ddd ll HH:mm':_ref$format;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react_intl__["a" /* FormattedMessage */],{id:'RoundDateDisplay::format',values:{preposition:preposition,hasEnd:!!end,end:!end?null:end.toFormatedDateString(format),duration:duration}});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__Localization__["a" /* localizable */])(RoundDateDisplay));

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AuctionFinalsStore__ = __webpack_require__(2100);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AuctionFinalsStore__["a"]; });


/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
// store = SaleWizardStore
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var store=_ref.store,t=_ref.t;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',null,store.source.item.number,': ',store.source.item.title),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',null,t('salepropertytype::'+store.source.saleEdit.offerData.object_type),',',' ',store.source.saleEdit.offerData.object_address));});

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(2132);
/* unused harmony reexport BrowserRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(2133);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(844);
/* unused harmony reexport Link */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(2134);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(2135);
/* unused harmony reexport NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(2137);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(2138);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(846);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(474);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_8__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(2139);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(2140);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(2141);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(2142);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(2143);
/* unused harmony reexport withRouter */





























/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(157);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(281);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(475);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(2136)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(476);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(281);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(282);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(2144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(475);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_src_app_components_dynamicImport__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_Checkbox__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_Dropdown__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__build_node_modules_office_ui_fabric_react_lib_Image__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__build_node_modules_office_ui_fabric_react_lib_Label__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__build_node_modules_office_ui_fabric_react_lib_MessageBar__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__build_node_modules_office_ui_fabric_react_lib_Panel__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__build_node_modules_react_dropzone__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__BehalfOfAgentsDropdown__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__TermsLabel__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__stores_SaleCreateStore__ = __webpack_require__(2152);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_class3,_temp;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var SaleCreatePanelContent=Object(__WEBPACK_IMPORTED_MODULE_1__build_src_app_components_dynamicImport__["b" /* default */])({component:'/containers/Overview/SaleCreatePanelContent'});var previewProperties={imageFit:__WEBPACK_IMPORTED_MODULE_8__build_node_modules_office_ui_fabric_react_lib_Image__["b" /* ImageFit */].contain,width:350,height:350};var SaleCreatePanel=(_dec=Object(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_mobx_react__["d" /* inject */])('sale','user','app'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_2__build_src_app_components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_mobx_react__["e" /* observer */])(_class=(_class2=(_temp=_class3=function(_Component){_inherits(SaleCreatePanel,_Component);function SaleCreatePanel(props){_classCallCheck(this,SaleCreatePanel);var _this=_possibleConstructorReturn(this,(SaleCreatePanel.__proto__||Object.getPrototypeOf(SaleCreatePanel)).call(this,props));_initDefineProp(_this,'image',_descriptor,_this);_initDefineProp(_this,'dropzoneState',_descriptor2,_this);_initDefineProp(_this,'uploadError',_descriptor3,_this);_initDefineProp(_this,'data',_descriptor4,_this);_initDefineProp(_this,'isContentValid',_descriptor5,_this);_initDefineProp(_this,'toc',_descriptor6,_this);_this.localHandleChange=function(field){return function(ev,option,index,value){_this.handleChanged(field,option,index,value);};};_this.handleChanged=function(field,option,index,value){if(typeof index==='undefined'&&typeof value==='undefined'){_this.data[field]=option;// textbox
}else{if(option){_this.data[field]=option.key;// dropdown
}else if(value){_this.data[field]=value;// combobox
}}};_this.handleContentIsValidChanged=function(isValid){_this.isContentValid=isValid;};_this.handleTocChange=function(_,isChecked){_this.toc=isChecked;};_this.handleSaleTestChange=function(_,isChecked){_this.sale.isTest=isChecked;};_this.handleClose=function(){var onClose=_this.props.onClose;if(onClose)onClose();};_this.handleCreate=function(){var app=_this.props.app;var imageUrl=_this.image?_this.image.url:null;var data=Object.assign(_this.data,{image:imageUrl,images:imageUrl?[{url:imageUrl}]:[],currency_code:app.currency.code,inviteOnly:_this.data.inviteOnly&&_this.canInviteOnly});if(app.data&&app.data.sale_country)data.sale_country=app.data.sale_country;_this.sale.start(data);};_this.handleAgentChanged=function(e){_this.sale.selectedAgent=e;};_this.handleInviteOnly=function(_,inviteOnly){_this.data.inviteOnly=inviteOnly;};_this.handleIsMasterSale=function(_,value){_this.sale.isMasterSale=value;};_this.handleMasterSaleId=function(_,option){console.log('🚀 ~ SaleCreatePanel ~ option:',option);_this.sale.masterSaleId=option.key;};_this.handleSelfRegistration=function(_,value){_this.sale.selfRegistration=value;};_this.sale=new __WEBPACK_IMPORTED_MODULE_16__stores_SaleCreateStore__["a" /* SaleCreateStore */](props.user,props.sale,props.app);// this.sale.selectedAgent = props.user.profile;
_this.sale.isTest=props.isTest;var config=_this.sale.config;Object(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["e" /* extendObservable */])(_this.data,{mls:config.mlsTypes&&config.mlsTypes.length>0?config.mlsTypes[0]:''});return _this;}_createClass(SaleCreatePanel,[{key:'componentDidMount',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return this.sale.loadAgents();case 2:if(!!this.sale.agents&&this.sale.agents.length===1){this.sale.selectedAgent=this.sale.agents[0];}case 3:case'end':return _context.stop();}}},_callee,this);}));function componentDidMount(){return _ref.apply(this,arguments);}return componentDidMount;}()},{key:'handleUpload',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(files){var file;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:this.uploadError=null;this.dropzoneState.uploadInProgress=true;file=files[0];// upload in case of multiselect, upload only the first file
_context2.prev=3;_context2.next=6;return this.sale.upload(file);case 6:this.image=_context2.sent;_context2.next=12;break;case 9:_context2.prev=9;_context2.t0=_context2['catch'](3);this.uploadError=this.parseUploadError(_context2.t0);case 12:this.dropzoneState.uploadInProgress=false;case 13:case'end':return _context2.stop();}}},_callee2,this,[[3,9]]);}));function handleUpload(_x){return _ref2.apply(this,arguments);}return handleUpload;}()},{key:'parseUploadError',value:function parseUploadError(error){var t=this.props.t;if(typeof error.response!=='undefined'&&typeof error.response.error!=='undefined'&&typeof error.response.error.message!=='undefined'){// try to detect known errors
var res=/Raw file format ([^\s]+) not allowed/i.exec(error.response.error.message);if(res!==null)return t('File extension is not supported',{extension:res[1]});res=/File size too large. Got ([\d]+). Maximum is ([\d]+)/i.exec(error.response.error.message);if(res!==null)return t('File size exceeds allowed limit',{size:res[1],allowed:res[2]});// no luck, use the raw error message from Cloudinary
return error.response.error.message;}// fallback to the error object
return error.message;}},{key:'generatePreviewUrl',value:function generatePreviewUrl(_ref3){var id=_ref3.id;return'https://res.cloudinary.com/auctiontech/image/upload/c_pad,b_white,h_'+previewProperties.height+',w_'+previewProperties.width+'/'+id+'.jpg';}},{key:'handleRemoveImage',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3(){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.prev=0;_context3.next=3;return this.sale.remove(this.image.metadata.deleteToken);case 3:_context3.next=7;break;case 5:_context3.prev=5;_context3.t0=_context3['catch'](0);case 7:this.image=null;case 8:case'end':return _context3.stop();}}},_callee3,this,[[0,5]]);}));function handleRemoveImage(){return _ref4.apply(this,arguments);}return handleRemoveImage;}()},{key:'render',value:function render(){var _this2=this;var _props=this.props,isTest=_props.isTest,t=_props.t,intl=_props.intl,app=_props.app,user=_props.user;var valid=this.isValid;var config=this.sale.config;return __WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__build_node_modules_office_ui_fabric_react_lib_Panel__["a" /* Panel */],{headerText:isTest?t('Start new test sale'):t('Start new sale'),type:__WEBPACK_IMPORTED_MODULE_11__build_node_modules_office_ui_fabric_react_lib_Panel__["b" /* PanelType */].medium,isOpen:true,onRenderFooterContent:function onRenderFooterContent(){return __WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid'},!_this2.tocDisabled&&__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12'},__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_Checkbox__["a" /* Checkbox */],{onChange:_this2.handleTocChange,label:t('I agree with terms and conditions'),onRenderLabel:function onRenderLabel(){return __WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__TermsLabel__["a" /* TermsLabel */],{app:app,t:t,user:user});}})),__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12 ',style:{paddingTop:'15px'}},__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Button__["f" /* DefaultButton */],{onClick:_this2.handleClose,style:{marginRight:'8px'}},t('Cancel')),__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Button__["h" /* PrimaryButton */],{onClick:_this2.handleCreate,disabled:!valid},t('Add')))));},isFooterAtBottom:true,onDismiss:this.handleClose},__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid'},isTest&&__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12 ms-lg12'},__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__build_node_modules_office_ui_fabric_react_lib_MessageBar__["a" /* MessageBar */],null,t('test_sale_explanation')))),__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12'},!this.image&&__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__build_node_modules_react_dropzone__["a" /* default */],{disableClick:true,className:'ms-Grid',ref:function ref(node){_this2.dropzoneRef=node;},accept:'image/jpeg, image/png',onDrop:this.handleUpload.bind(this)},__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12'},__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__build_node_modules_office_ui_fabric_react_lib_Label__["a" /* Label */],{required:true},t('Image')))),__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row',style:{marginBottom:'0.5em'}},__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-lg12'},__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Button__["h" /* PrimaryButton */],{disabled:this.dropzoneState.uploadInProgress,onClick:function onClick(){return _this2.dropzoneRef.open();}},this.dropzoneState.uploadInProgress?t('Uploading')+'...':t('Upload')))),this.uploadError&&__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__build_node_modules_office_ui_fabric_react_lib_MessageBar__["a" /* MessageBar */],{messageBarType:__WEBPACK_IMPORTED_MODULE_10__build_node_modules_office_ui_fabric_react_lib_MessageBar__["b" /* MessageBarType */].error},this.uploadError)),this.image&&__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__build_node_modules_office_ui_fabric_react_lib_Image__["a" /* Image */],Object.assign({src:this.generatePreviewUrl(this.image)},previewProperties))),__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Button__["f" /* DefaultButton */],{onClick:this.handleRemoveImage.bind(this)},t('Remove')))))),__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement(SaleCreatePanelContent,{data:this.data,onChanged:this.handleChanged,onIsValidChanged:this.handleContentIsValidChanged,intl:intl,t:t}),app.canMls&&__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12'},__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_Dropdown__["a" /* Dropdown */],{label:t('MLS'),selectedKey:this.data['mls'],onChange:this.localHandleChange('mls'),options:config.mlsTypes.map(function(key){return{key:key,text:t('mls::'+key)};}),required:true}))),__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12'},__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_Checkbox__["a" /* Checkbox */],{onChange:this.handleInviteOnly,label:t('Invite only'),disabled:!this.canInviteOnly})))),__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12 ms-lg12'},__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__BehalfOfAgentsDropdown__["a" /* default */],{agents:this.sale.agents,selectedAgent:this.sale.selectedAgent,onAgentChanged:this.handleAgentChanged}))),this.sale.config.features.packageAuctions&&__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12'},__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_Dropdown__["a" /* Dropdown */],{label:t('Select master sale'),selectedKey:this.sale.masterSaleId,onChange:this.handleMasterSaleId,options:[{text:t('not part of master sale'),key:''},{text:t('is master sale'),key:'master'}].concat(_toConsumableArray(this.sale.masterSales))}))),this.sale.config.features.allowSelfRegistration&&(!this.sale.masterSaleId||this.sale.masterSaleId==='master')&&__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12'},__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_Checkbox__["a" /* Checkbox */],{onChange:this.handleSelfRegistration,value:this.sale.selfRegistration,label:t('Self registration')})))));}},{key:'tocDisabled',get:function get(){var config=this.sale.config;if(!config.saleCreateRequireTC){return true;}return typeof config.disableSaleToC!=='undefined'&&config.disableSaleToC.includes(this.props.user.profile.tenant);}},{key:'canInviteOnly',get:function get(){return this.data.mls==='tenant'||this.data.mls==='everyone';}},{key:'isValid',get:function get(){return(this.image||this.sale.isTest)&&this.isContentValid&&(this.tocDisabled||this.toc)&&this.sale.canCreateSale&&this.sale.selectedAgent;}}]);return SaleCreatePanel;}(__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react__["Component"]),_class3.displayName='SaleCreatePanel',_temp),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'image',[__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:null}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,'dropzoneState',[__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return{active:false,uploadInProgress:false};}}),_descriptor3=_applyDecoratedDescriptor(_class2.prototype,'uploadError',[__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:null}),_descriptor4=_applyDecoratedDescriptor(_class2.prototype,'data',[__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor5=_applyDecoratedDescriptor(_class2.prototype,'isContentValid',[__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor6=_applyDecoratedDescriptor(_class2.prototype,'toc',[__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:null}),_applyDecoratedDescriptor(_class2.prototype,'tocDisabled',[__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class2.prototype,'tocDisabled'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'canInviteOnly',[__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class2.prototype,'canInviteOnly'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'isValid',[__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class2.prototype,'isValid'),_class2.prototype)),_class2))||_class)||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (SaleCreatePanel);

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Dropdown__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_desc,_value,_class2,_descriptor,_class3,_temp2;function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var BehalfOfAgentsDropdown=Object(__WEBPACK_IMPORTED_MODULE_0__build_src_app_components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__["e" /* observer */])(_class=(_class2=(_temp2=_class3=function(_Component){_inherits(BehalfOfAgentsDropdown,_Component);function BehalfOfAgentsDropdown(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BehalfOfAgentsDropdown);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BehalfOfAgentsDropdown.__proto__||Object.getPrototypeOf(BehalfOfAgentsDropdown)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'selectedAgent',_descriptor,_this),_this.agentOfficeName=function(agent){return(agent.office?agent.office.friendly_name:undefined)||agent.agency_friendly_name||(agent.office?agent.office.name:undefined)||agent.agency_name;},_this.agentKey=function(agent){if(!agent)return;var office=(!agent.office?undefined:agent.office.name)||agent.office_id;return office?agent.sub+'---'+office:agent.sub;},_this.agentDisplayName=function(agent){var office=_this.agentOfficeName(agent);return''+agent.name+(office?' ('+office+')':'');},_this.handleAgentChanged=function(e){var _this$props=_this.props,onAgentChanged=_this$props.onAgentChanged,agents=_this$props.agents;if(!onAgentChanged)return;var agent=agents.find(function(a){return _this.agentKey(a)===e.key;});_this.selectedAgent=agent;onAgentChanged(agent);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BehalfOfAgentsDropdown,[{key:'componentDidMount',value:function componentDidMount(){var selectedAgent=this.props.selectedAgent;this.selectedAgent=selectedAgent;}},{key:'render',value:function render(){var _this2=this;var _props=this.props,t=_props.t,selectedAgent=_props.selectedAgent,agents=_props.agents;var selectedAgentKey=this.agentKey(selectedAgent);return __WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Dropdown__["a" /* Dropdown */],{label:t('Behalf of'),selectedKey:selectedAgentKey,onChanged:this.handleAgentChanged,options:agents.map(function(agent){return{key:_this2.agentKey(agent),text:_this2.agentDisplayName(agent)};}),required:true}),!!this.selectedAgent&&this.selectedAgent.name&&__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement('p',null,this.selectedAgent.agency_name&&__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement('div',null,this.selectedAgent.agency_name),this.selectedAgent.email&&__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement('div',null,t('email'),': ',this.selectedAgent.email),this.selectedAgent.phone_number&&__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement('div',null,t('phone_number'),': ',this.selectedAgent.phone_number))));}}]);return BehalfOfAgentsDropdown;}(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react__["Component"]),_class3.displayName='BehalfOfAgentsDropdown',_temp2),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'selectedAgent',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return{};}})),_class2))||_class)||_class;/* harmony default export */ __webpack_exports__["a"] = (BehalfOfAgentsDropdown);

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_styled_components__ = __webpack_require__(47);
var _templateObject=_taggedTemplateLiteral(['\n  align-items: center;\n  bottom: 0;\n  display: flex;\n  font-size: 10vmin;\n  font-weight: bold;\n  height: 100%;\n  justify-content: center;\n  opacity: 0.1;\n  pointer-events: none;\n  position: fixed;\n  top: 0;\n  transform: rotateZ(-45deg);\n  user-select: none;\n  width: 100%;\n  z-index: 9999;\n'],['\n  align-items: center;\n  bottom: 0;\n  display: flex;\n  font-size: 10vmin;\n  font-weight: bold;\n  height: 100%;\n  justify-content: center;\n  opacity: 0.1;\n  pointer-events: none;\n  position: fixed;\n  top: 0;\n  transform: rotateZ(-45deg);\n  user-select: none;\n  width: 100%;\n  z-index: 9999;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Watermark=__WEBPACK_IMPORTED_MODULE_0__build_node_modules_styled_components__["a" /* default */].div(_templateObject);/* harmony default export */ __webpack_exports__["a"] = (Watermark);

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = websocketsUri;
function websocketsUri(path){var loc=window.location;var protocol=void 0;if(loc.protocol==='https:'){protocol='wss:';}else{protocol='ws:';}return protocol+'//'+loc.host+path;}

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ActionWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_styled_components__ = __webpack_require__(47);
var _templateObject=_taggedTemplateLiteral(['\n  display: flex;\n  flex-flow: row wrap;\n\n  justify-content: center;\n  padding: 0 5vw;\n  font-size: clamp(14px, 1.4vw, 21px);\n'],['\n  display: flex;\n  flex-flow: row wrap;\n\n  justify-content: center;\n  padding: 0 5vw;\n  font-size: clamp(14px, 1.4vw, 21px);\n']),_templateObject2=_taggedTemplateLiteral(['\n  flex: 1 1;\n  margin: .5em;\n  cursor: pointer;\n  max-width: 30rem;\n\n  border: solid 2px ',';\n  background: ','00;\n  transition: background-color 0.5s;\n\n  display: flex;\n  flex-direction: column;\n\n  > .header {\n    background: ',';\n    color: #fff;\n    font-weight: bold;\n    padding: 0.5em 0;\n    text-align: center;\n    position: relative;\n    min-height: 4.9rem;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n\n    .badge {\n      background: #fff;\n      border-radius: 8px;\n      border: solid 2px ',';\n      color: #000;\n      font-size: .6em;\n      font-weight: normal;\n      padding: 0.3em 0.5em;\n      position: absolute;\n      top: -15px;\n      right: -15px;\n      text-transform: uppercase;\n    }\n\n    h2 {\n      font-size: 1em;\n      margin: 0\n      padding: 0\n    }\n\n    .subtitle {\n      font-size: 0.8em;\n      font-style: italic;\n    }\n  }\n\n  > .description {\n    font-size: 0.7em;\n    padding: .5em;\n    text-align: left;\n    font-weight: normal;\n    ul {\n      margin: .5em 0;\n      padding: 0 0 0 1.5em;\n    }\n    ul {\n      list-style: square;\n    }\n  }\n\n  &:hover {\n    background: ','11;\n    box-shadow: 0 0 20px #777;\n  }\n'],['\n  flex: 1 1;\n  margin: .5em;\n  cursor: pointer;\n  max-width: 30rem;\n\n  border: solid 2px ',';\n  background: ','00;\n  transition: background-color 0.5s;\n\n  display: flex;\n  flex-direction: column;\n\n  > .header {\n    background: ',';\n    color: #fff;\n    font-weight: bold;\n    padding: 0.5em 0;\n    text-align: center;\n    position: relative;\n    min-height: 4.9rem;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n\n    .badge {\n      background: #fff;\n      border-radius: 8px;\n      border: solid 2px ',';\n      color: #000;\n      font-size: .6em;\n      font-weight: normal;\n      padding: 0.3em 0.5em;\n      position: absolute;\n      top: -15px;\n      right: -15px;\n      text-transform: uppercase;\n    }\n\n    h2 {\n      font-size: 1em;\n      margin: 0\n      padding: 0\n    }\n\n    .subtitle {\n      font-size: 0.8em;\n      font-style: italic;\n    }\n  }\n\n  > .description {\n    font-size: 0.7em;\n    padding: .5em;\n    text-align: left;\n    font-weight: normal;\n    ul {\n      margin: .5em 0;\n      padding: 0 0 0 1.5em;\n    }\n    ul {\n      list-style: square;\n    }\n  }\n\n  &:hover {\n    background: ','11;\n    box-shadow: 0 0 20px #777;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ActionWrapper=__WEBPACK_IMPORTED_MODULE_0__build_node_modules_styled_components__["a" /* default */].section(_templateObject);var ActionItem=__WEBPACK_IMPORTED_MODULE_0__build_node_modules_styled_components__["a" /* default */].a(_templateObject2,function(props){return props.theme.palette.themePrimary;},function(props){return props.theme.palette.themePrimary;},function(props){return props.theme.palette.themePrimary;},function(props){return props.theme.palette.themePrimary;},function(props){return props.theme.palette.themePrimary;});

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_Modal__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_request__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_css__ = __webpack_require__(2167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2,_descriptor,_class3,_temp2;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var OfferPreview=(_dec=Object(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_mobx_react__["d" /* inject */])('user','app'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_mobx_react__["e" /* observer */])(_class=(_class2=(_temp2=_class3=function(_React$Component){_inherits(OfferPreview,_React$Component);function OfferPreview(){var _ref;var _temp,_this,_ret;_classCallCheck(this,OfferPreview);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=OfferPreview.__proto__||Object.getPrototypeOf(OfferPreview)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'url',_descriptor,_this),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(OfferPreview,[{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.closePanel();}},{key:'componentDidMount',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(){var _props,data,user,url,res;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_props=this.props,data=_props.data,user=_props.user,url=_props.url;if(!url){_context.next=3;break;}return _context.abrupt('return');case 3:_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_3__services_request__["e" /* post */])('/api/v1/sign',data,user.accessToken);case 5:res=_context.sent;this.url=res.url;case 7:case'end':return _context.stop();}}},_callee,this);}));function componentDidMount(){return _ref2.apply(this,arguments);}return componentDidMount;}()},{key:'render',value:function render(){var _props2=this.props,closePanel=_props2.closePanel,url=_props2.url;var pageUrl=this.url||url;return __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_Modal__["a" /* Modal */],{isOpen:true,onDismiss:closePanel,isBlocking:false,containerClassName:'sale--preview--modal'},pageUrl?__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('iframe',{src:pageUrl,title:'preview'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('a',{href:pageUrl,target:'_blank'},'\xD6ffnen')):null);}}]);return OfferPreview;}(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.Component),_class3.displayName='OfferPreview',_temp2),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'url',[__WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return'';}})),_class2))||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (OfferPreview);

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var pna = __webpack_require__(284);
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__(661);
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__(477).EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(860);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(285).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = Object.create(__webpack_require__(212));
util.inherits = __webpack_require__(158);
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(2173);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __webpack_require__(2174);
var destroyImpl = __webpack_require__(861);
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__(138);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__(862).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__(138);

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__(862).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, unpipeInfo);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33), __webpack_require__(147)))

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(477).EventEmitter;


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

var pna = __webpack_require__(284);
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
      pna.nextTick(emitErrorNT, this, err);
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      pna.nextTick(emitErrorNT, _this, err);
      if (_this._writableState) {
        _this._writableState.errorEmitted = true;
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = __webpack_require__(285).Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__(138);

/*<replacement>*/
var util = Object.create(__webpack_require__(212));
util.inherits = __webpack_require__(158);
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_react_virtualized__ = __webpack_require__(2185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Checkbox__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_TextField__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_Dropdown__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__build_node_modules_office_ui_fabric_react_lib_ComboBox__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__build_node_modules_office_ui_fabric_react_lib_Icon__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__build_src_app_helpers_emailValidator__ = __webpack_require__(294);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var config=__webpack_require__(104).default;/*

props.store = BulkRegistrationStore()
props.store.items = [{
  _selected,
  firstName: item.first_name,
  lastName: item.last_name,
  email,
  phone,
  salutation,
  title,
  offerViewing,
  _additional: {
    buyer_street,
    buyer_zip,
    buyer_city,
    buyer_country,
  },
  optionalUploads: [...],
  requiredUploads: [...],
}, ...]

props.t

*/var BulkRegistrationTable=Object(__WEBPACK_IMPORTED_MODULE_10__build_src_app_components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["e" /* observer */])(_class=(_temp2=_class2=function(_Component){_inherits(BulkRegistrationTable,_Component);function BulkRegistrationTable(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BulkRegistrationTable);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BulkRegistrationTable.__proto__||Object.getPrototypeOf(BulkRegistrationTable)).call.apply(_ref,[this].concat(args))),_this),_this.renderColumnHeader=function(column){var t=_this.props.t;if(column.key==='_select'){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Checkbox__["a" /* Checkbox */],{defaultChecked:true,onChange:_this.handleColumnHeaderSelectCheckboxChanged(),title:t('Select / unselect all')});}else if(column.key.startsWith('uploadtype-')){var type=column.key.substr('uploadtype-'.length);return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Checkbox__["a" /* Checkbox */],{label:__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',{style:{fontWeight:'bold'}},t('uploadtype::'+type).substr(0,1)),column.footnote_index&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('sup',{style:{marginLeft:'4px',fontSize:'x-small'}},column.footnote_index,')')),defaultChecked:!column.optional&&config.defaultUploadTypes.includes(type),disabled:config.requiredUploadTypes.includes(type),onChange:_this.handleColumnHeaderUploadTypeCheckboxChanged(type,column.optional),title:t('uploadtype::'+type),styles:{label:{paddingRight:'10px'}}});}else return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,column.title,' ',column.required&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('sup',{style:{color:'Red'}},'*'),column.footnote&&column.footnote_index&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('sup',{style:{marginLeft:'4px',fontSize:'x-small'}},column.footnote_index,')'));},_this.handleColumnHeaderSelectCheckboxChanged=function(){return function(ev,isChecked){var store=_this.props.store;for(var i=0;i<store.count;i++){store.change(i,'_selected',isChecked);}};},_this.handleColumnHeaderUploadTypeCheckboxChanged=function(type,optional){return function(ev,isChecked){var store=_this.props.store;for(var i=0;i<store.count;i++){_this.handleUploadsChanged(i,type,optional,isChecked);}};},_this.renderItemColumn=function(item,index,column){var _this$props=_this.props,store=_this$props.store,t=_this$props.t;if(column.key==='_validation'){var errors=[];store.columns.forEach(function(_column){if(!_column.key.startsWith('_')&&_column.fieldName&&!_column.readonly){var error=_this.fieldValidation(_column)(item[_column.fieldName]);if(error)errors.push(_column.title+': '+error);}});if(item._error)errors.push(t('Saving error')+': '+item._error);if(errors.length>0)return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_Button__["g" /* IconButton */],{iconProps:{iconName:'Warning'},title:errors.join('\n'),styles:{root:{color:'#a80000'}},tabIndex:-1});return'';}else if(column.key==='_remove'){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_Button__["g" /* IconButton */],{iconProps:{iconName:'Clear'},title:'Remove',ariaLabel:'Remove',onClick:_this.handleRemove(index),tabIndex:-1});}else if(column.key==='_select'){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Checkbox__["a" /* Checkbox */],{checked:item._selected,onChange:_this.handleSelectCheckboxChanged(index)});}else if(column.key==='_additional'){var additional=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.map(store.additionalFields,function(field,key){return field.title&&!!item[key]?field.title+': '+item[key]:null;});var content=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.filter(additional,function(value){return!!value;}).join('\n');return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__build_node_modules_office_ui_fabric_react_lib_Icon__["Icon"],{iconName:'More',title:content});}else if(column.key.startsWith('uploadtype-')){var type=column.key.substr('uploadtype-'.length);return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Checkbox__["a" /* Checkbox */],{checked:column.optional?item.optionalUploads.includes(type):item.requiredUploads.includes(type),disabled:config.requiredUploadTypes.includes(type),onChange:_this.handleUploadsCheckboxChanged(index,type,column.optional)});}else{var _content=item[column.fieldName];var name='row['+index+'].'+column.key;if(column.readonly){if(column.type==='checkbox')return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{style:{width:'100%',textAlign:'center'}},_content?__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__build_node_modules_office_ui_fabric_react_lib_Icon__["Icon"],{iconName:'SkypeCheck'}):'');var text=column.options&&_content?t(column.fieldName+'::'+_content):_content;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{style:{width:'100%',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'},title:text},text);}return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,column.type==='dropdown'&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_Dropdown__["a" /* Dropdown */],{name:name,defaultSelectedKey:_content,onChange:_this.handleDropdownChange(index,column.fieldName),options:[{key:'',text:''}].concat(column.options.map(function(key){return{key:key,text:t(column.fieldName+'::'+key)};}))}),column.type==='combobox'&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__build_node_modules_office_ui_fabric_react_lib_ComboBox__["a" /* ComboBox */],{name:name,allowFreeform:true,autoComplete:'nope',onChange:_this.handleComboBoxChange(index,column.fieldName),text:_content?t(column.fieldName+'::'+_content):'',options:[{key:'',text:''}].concat(column.options.map(function(key){return{key:key,text:t(column.fieldName+'::'+key)};}))}),column.type==='checkbox'&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Checkbox__["a" /* Checkbox */],{name:name,autoComplete:'nope',defaultChecked:_content,onChange:_this.handleCheckboxChange(index,column.fieldName)}),(column.type==='textfield'||column.type==='email'||column.type==='phone')&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_TextField__["a" /* TextField */],{name:name,onChange:_this.handleChange(index,column.fieldName),defaultValue:_content,styles:{fieldGroup:{borderColor:_this.fieldValidation(column)(_content)?'#A80000':''}},autoComplete:'nope'}));}},_this.fieldValidation=function(column){if(column.type==='email')return _this.emailValidation;return function(){return'';};},_this.emailValidation=function(value){if(!value)return'';var _this$props2=_this.props,t=_this$props2.t,usedEmails=_this$props2.store.usedEmails;if(!Object(__WEBPACK_IMPORTED_MODULE_11__build_src_app_helpers_emailValidator__["a" /* default */])(value))return t('Invalid email');if(usedEmails&&usedEmails.includes(value))return t('Already registered');return'';},_this.handleRemove=function(index){return function(){var store=_this.props.store;store.remove(index);};},_this.handleChange=function(index,fieldName){return function(ev,value){var store=_this.props.store;store.change(index,fieldName,value);};},_this.handleSelectCheckboxChanged=function(index){return function(ev,isChecked){var store=_this.props.store;store.change(index,'_selected',isChecked);};},_this.handleDropdownChange=function(index,fieldName){return function(ev,option,_index,value){var store=_this.props.store;if(option)store.change(index,fieldName,option.key);else if(value)store.change(index,fieldName,value);};},_this.handleComboBoxChange=function(index,fieldName){return function(ev,option,_index,value){var store=_this.props.store;if(option)store.change(index,fieldName,option.key);else if(value)store.change(index,fieldName,value);};},_this.handleCheckboxChange=function(index,fieldName){return function(ev,isChecked){var store=_this.props.store;store.change(index,fieldName,isChecked);};},_this.handleUploadsCheckboxChanged=function(index,type,optional){return function(ev,isChecked){if(!config.requiredUploadTypes.includes(type))_this.handleUploadsChanged(index,type,optional,isChecked);};},_this.handleUploadsChanged=function(index,type,optional,isSelected){var store=_this.props.store;store.changeUploads(index,type,optional,isSelected);},_this.handleResize=function(size){_this.width=size.width;_this.ensureColumnWidths();if(_this.multiGrid)_this.multiGrid.recomputeGridSize();},_this.handleSave=function(){_this.ensureColumnWidths();if(_this.multiGrid)_this.multiGrid.recomputeGridSize();},_this.ensureColumnWidths=function(){var width=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var store=_this.props.store;if(width)_this.width=width;var columns=store.columns.map(function(column){return{width:column.width,minWidth:column.minWidth||0};});var desiredWidth=_this.width-30;// scrollBarWidth
var currentWidth=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.sumBy(columns,'width');if(currentWidth<desiredWidth){// extend columns
columns.forEach(function(column){column.width=Math.trunc(column.width/currentWidth*desiredWidth);});}else{var _loop=function _loop(){// remove columns that are already at their minimal width
var count=0;var desiredWidth2=desiredWidth;var currentWidth2=0;columns.forEach(function(column){if(column.width>column.minWidth){// column can still be shrinked
count++;currentWidth2+=column.width;}else{// column already at minimum width -> exclude it from further calculation
desiredWidth2-=column.width;}});if(count===0)return'break';// no more shrinkable column left
// now shrink all shrinkable columns
columns.forEach(function(column){if(column.width>column.minWidth)column.width=Math.max(Math.trunc(column.width/currentWidth2*desiredWidth2),column.minWidth);});currentWidth=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.sumBy(columns,'width');};// shrink columns
while(currentWidth>desiredWidth){var _ret2=_loop();if(_ret2==='break')break;}}_this.columnWidths=columns.map(function(column){return column.width;});},_this.getColor=function(item){var store=_this.props.store;if(!store.isItemComplete(item)){return'#ffb3b3';}if(store.isItemDuplicate(item)){return'#ffff99';}return'#dff6dd';},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BulkRegistrationTable,[{key:'componentDidMount',value:function componentDidMount(){var store=this.props.store;store.onSave=this.handleSave;}},{key:'render',value:function render(){var _this2=this;var store=this.props.store;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{style:{width:'100%',height:'99%'}},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react_virtualized__["a" /* AutoSizer */],{onResize:this.handleResize},function(_ref2){var height=_ref2.height,width=_ref2.width;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react_virtualized__["b" /* MultiGrid */],{ref:function ref(element){return _this2.multiGrid=element;},width:width,height:height,columnCount:store.columns.length,columnWidth:function columnWidth(_ref3){var index=_ref3.index;_this2.ensureColumnWidths(width);return _this2.columnWidths[index];},fixedRowCount:1,rowCount:store.count+1,rowHeight:function rowHeight(_ref4){var index=_ref4.index;// if (index === 0) return 40;
//if (this.emailValidation(store.items[index - 1].email))
//  return 80;
return 40;},estimatedRowSize:40,cellRenderer:function cellRenderer(_ref5){var columnIndex=_ref5.columnIndex,key=_ref5.key,rowIndex=_ref5.rowIndex,style=_ref5.style;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["a" /* Observer */],{key:key,render:function render(){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,rowIndex===0&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{style:style},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{style:{padding:'5px'}},_this2.renderColumnHeader(store.columns[columnIndex]))),rowIndex>0&&rowIndex<=store.items.length&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{style:__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.assign({},style,{backgroundColor:_this2.getColor(store.items[rowIndex-1])})},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{style:{padding:'5px'}},_this2.renderItemColumn(store.items[rowIndex-1],rowIndex-1,store.columns[columnIndex]))));}});}});}));}}]);return BulkRegistrationTable;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class2.displayName='BulkRegistrationTable',_temp2))||_class)||_class;/* harmony default export */ __webpack_exports__["a"] = (BulkRegistrationTable);

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_lifecycles_compat__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Grid__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__types__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);








var _class, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



/**
 * This HOC decorates a virtualized component and responds to arrow-key events by scrolling one row or column at a time.
 */

var ArrowKeyStepper = (_temp = _class =
/*#__PURE__*/
function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(ArrowKeyStepper, _React$PureComponent);

  function ArrowKeyStepper() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, ArrowKeyStepper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(ArrowKeyStepper)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      scrollToColumn: 0,
      scrollToRow: 0,
      instanceProps: {
        prevScrollToColumn: 0,
        prevScrollToRow: 0
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_columnStartIndex", 0);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_columnStopIndex", 0);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_rowStartIndex", 0);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_rowStopIndex", 0);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_onKeyDown", function (event) {
      var _this$props = _this.props,
          columnCount = _this$props.columnCount,
          disabled = _this$props.disabled,
          mode = _this$props.mode,
          rowCount = _this$props.rowCount;

      if (disabled) {
        return;
      }

      var _this$_getScrollState = _this._getScrollState(),
          scrollToColumnPrevious = _this$_getScrollState.scrollToColumn,
          scrollToRowPrevious = _this$_getScrollState.scrollToRow;

      var _this$_getScrollState2 = _this._getScrollState(),
          scrollToColumn = _this$_getScrollState2.scrollToColumn,
          scrollToRow = _this$_getScrollState2.scrollToRow; // The above cases all prevent default event event behavior.
      // This is to keep the grid from scrolling after the snap-to update.


      switch (event.key) {
        case 'ArrowDown':
          scrollToRow = mode === 'cells' ? Math.min(scrollToRow + 1, rowCount - 1) : Math.min(_this._rowStopIndex + 1, rowCount - 1);
          break;

        case 'ArrowLeft':
          scrollToColumn = mode === 'cells' ? Math.max(scrollToColumn - 1, 0) : Math.max(_this._columnStartIndex - 1, 0);
          break;

        case 'ArrowRight':
          scrollToColumn = mode === 'cells' ? Math.min(scrollToColumn + 1, columnCount - 1) : Math.min(_this._columnStopIndex + 1, columnCount - 1);
          break;

        case 'ArrowUp':
          scrollToRow = mode === 'cells' ? Math.max(scrollToRow - 1, 0) : Math.max(_this._rowStartIndex - 1, 0);
          break;
      }

      if (scrollToColumn !== scrollToColumnPrevious || scrollToRow !== scrollToRowPrevious) {
        event.preventDefault();

        _this._updateScrollState({
          scrollToColumn: scrollToColumn,
          scrollToRow: scrollToRow
        });
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_onSectionRendered", function (_ref) {
      var columnStartIndex = _ref.columnStartIndex,
          columnStopIndex = _ref.columnStopIndex,
          rowStartIndex = _ref.rowStartIndex,
          rowStopIndex = _ref.rowStopIndex;
      _this._columnStartIndex = columnStartIndex;
      _this._columnStopIndex = columnStopIndex;
      _this._rowStartIndex = rowStartIndex;
      _this._rowStopIndex = rowStopIndex;
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ArrowKeyStepper, [{
    key: "setScrollIndexes",
    value: function setScrollIndexes(_ref2) {
      var scrollToColumn = _ref2.scrollToColumn,
          scrollToRow = _ref2.scrollToRow;
      this.setState({
        scrollToRow: scrollToRow,
        scrollToColumn: scrollToColumn
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          children = _this$props2.children;

      var _this$_getScrollState3 = this._getScrollState(),
          scrollToColumn = _this$_getScrollState3.scrollToColumn,
          scrollToRow = _this$_getScrollState3.scrollToRow;

      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        className: className,
        onKeyDown: this._onKeyDown
      }, children({
        onSectionRendered: this._onSectionRendered,
        scrollToColumn: scrollToColumn,
        scrollToRow: scrollToRow
      }));
    }
  }, {
    key: "_getScrollState",
    value: function _getScrollState() {
      return this.props.isControlled ? this.props : this.state;
    }
  }, {
    key: "_updateScrollState",
    value: function _updateScrollState(_ref3) {
      var scrollToColumn = _ref3.scrollToColumn,
          scrollToRow = _ref3.scrollToRow;
      var _this$props3 = this.props,
          isControlled = _this$props3.isControlled,
          onScrollToChange = _this$props3.onScrollToChange;

      if (typeof onScrollToChange === 'function') {
        onScrollToChange({
          scrollToColumn: scrollToColumn,
          scrollToRow: scrollToRow
        });
      }

      if (!isControlled) {
        this.setState({
          scrollToColumn: scrollToColumn,
          scrollToRow: scrollToRow
        });
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.isControlled) {
        return {};
      }

      if (nextProps.scrollToColumn !== prevState.instanceProps.prevScrollToColumn || nextProps.scrollToRow !== prevState.instanceProps.prevScrollToRow) {
        return _objectSpread({}, prevState, {
          scrollToColumn: nextProps.scrollToColumn,
          scrollToRow: nextProps.scrollToRow,
          instanceProps: {
            prevScrollToColumn: nextProps.scrollToColumn,
            prevScrollToRow: nextProps.scrollToRow
          }
        });
      }

      return {};
    }
  }]);

  return ArrowKeyStepper;
}(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"]), __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(_class, "propTypes",  true ? null : {
  "children": PropTypes.func.isRequired,
  "className": PropTypes.string,
  "columnCount": PropTypes.number.isRequired,
  "disabled": PropTypes.bool.isRequired,
  "isControlled": PropTypes.bool.isRequired,
  "mode": PropTypes.oneOf(["cells", "edges"]).isRequired,
  "onScrollToChange": PropTypes.func,
  "rowCount": PropTypes.number.isRequired,
  "scrollToColumn": PropTypes.number.isRequired,
  "scrollToRow": PropTypes.number.isRequired
}), _temp);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(ArrowKeyStepper, "defaultProps", {
  disabled: false,
  isControlled: false,
  mode: 'edges',
  scrollToColumn: 0,
  scrollToRow: 0
});

Object(__WEBPACK_IMPORTED_MODULE_8_react_lifecycles_compat__["a" /* polyfill */])(ArrowKeyStepper);
/* unused harmony default export */ var _unused_webpack_default_export = (ArrowKeyStepper);




/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_SCROLLING_RESET_TIME_INTERVAL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_clsx__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_calculateSizeAndPositionDataAndUpdateScrollOffset__ = __webpack_require__(2189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_ScalingCellSizeAndPositionManager__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_createCallbackMemoizer__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__defaultOverscanIndicesGetter__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_updateScrollIndexHelper__ = __webpack_require__(2193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__defaultCellRangeRenderer__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_dom_helpers_scrollbarSize__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_lifecycles_compat__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_requestAnimationTimeout__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_prop_types__);









var _class, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */

var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;
/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */

var SCROLL_POSITION_CHANGE_REASONS = {
  OBSERVED: 'observed',
  REQUESTED: 'requested'
};

var renderNull = function renderNull() {
  return null;
};

/**
 * Renders tabular data with virtualization along the vertical and horizontal axes.
 * Row heights and column widths must be known ahead of time and specified as properties.
 */
var Grid = (_temp = _class =
/*#__PURE__*/
function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Grid, _React$PureComponent);

  // Invokes onSectionRendered callback only when start/stop row or column indices change
  function Grid(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Grid);

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Grid).call(this, props));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_onGridRenderedMemoizer", Object(__WEBPACK_IMPORTED_MODULE_12__utils_createCallbackMemoizer__["a" /* default */])());

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_onScrollMemoizer", Object(__WEBPACK_IMPORTED_MODULE_12__utils_createCallbackMemoizer__["a" /* default */])(false));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_deferredInvalidateColumnIndex", null);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_deferredInvalidateRowIndex", null);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_recomputeScrollLeftFlag", false);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_recomputeScrollTopFlag", false);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_horizontalScrollBarSize", 0);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_verticalScrollBarSize", 0);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_scrollbarPresenceChanged", false);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_scrollingContainer", void 0);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_childrenToDisplay", void 0);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_columnStartIndex", void 0);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_columnStopIndex", void 0);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_rowStartIndex", void 0);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_rowStopIndex", void 0);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_renderedColumnStartIndex", 0);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_renderedColumnStopIndex", 0);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_renderedRowStartIndex", 0);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_renderedRowStopIndex", 0);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_initialScrollTop", void 0);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_initialScrollLeft", void 0);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_disablePointerEventsTimeoutId", void 0);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_styleCache", {});

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_cellCache", {});

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_debounceScrollEndedCallback", function () {
      _this._disablePointerEventsTimeoutId = null; // isScrolling is used to determine if we reset styleCache

      _this.setState({
        isScrolling: false,
        needToResetStyleCache: false
      });
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_invokeOnGridRenderedHelper", function () {
      var onSectionRendered = _this.props.onSectionRendered;

      _this._onGridRenderedMemoizer({
        callback: onSectionRendered,
        indices: {
          columnOverscanStartIndex: _this._columnStartIndex,
          columnOverscanStopIndex: _this._columnStopIndex,
          columnStartIndex: _this._renderedColumnStartIndex,
          columnStopIndex: _this._renderedColumnStopIndex,
          rowOverscanStartIndex: _this._rowStartIndex,
          rowOverscanStopIndex: _this._rowStopIndex,
          rowStartIndex: _this._renderedRowStartIndex,
          rowStopIndex: _this._renderedRowStopIndex
        }
      });
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_setScrollingContainerRef", function (ref) {
      _this._scrollingContainer = ref;
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_onScroll", function (event) {
      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
      // See issue #404 for more information.
      if (event.target === _this._scrollingContainer) {
        _this.handleScrollEvent(event.target);
      }
    });

    var columnSizeAndPositionManager = new __WEBPACK_IMPORTED_MODULE_11__utils_ScalingCellSizeAndPositionManager__["a" /* default */]({
      cellCount: props.columnCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return Grid._wrapSizeGetter(props.columnWidth)(params);
      },
      estimatedCellSize: Grid._getEstimatedColumnSize(props)
    });
    var rowSizeAndPositionManager = new __WEBPACK_IMPORTED_MODULE_11__utils_ScalingCellSizeAndPositionManager__["a" /* default */]({
      cellCount: props.rowCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return Grid._wrapSizeGetter(props.rowHeight)(params);
      },
      estimatedCellSize: Grid._getEstimatedRowSize(props)
    });
    _this.state = {
      instanceProps: {
        columnSizeAndPositionManager: columnSizeAndPositionManager,
        rowSizeAndPositionManager: rowSizeAndPositionManager,
        prevColumnWidth: props.columnWidth,
        prevRowHeight: props.rowHeight,
        prevColumnCount: props.columnCount,
        prevRowCount: props.rowCount,
        prevIsScrolling: props.isScrolling === true,
        prevScrollToColumn: props.scrollToColumn,
        prevScrollToRow: props.scrollToRow,
        scrollbarSize: 0,
        scrollbarSizeMeasured: false
      },
      isScrolling: false,
      scrollDirectionHorizontal: __WEBPACK_IMPORTED_MODULE_13__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */],
      scrollDirectionVertical: __WEBPACK_IMPORTED_MODULE_13__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */],
      scrollLeft: 0,
      scrollTop: 0,
      scrollPositionChangeReason: null,
      needToResetStyleCache: false
    };

    if (props.scrollToRow > 0) {
      _this._initialScrollTop = _this._getCalculatedScrollTop(props, _this.state);
    }

    if (props.scrollToColumn > 0) {
      _this._initialScrollLeft = _this._getCalculatedScrollLeft(props, _this.state);
    }

    return _this;
  }
  /**
   * Gets offsets for a given cell and alignment.
   */


  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Grid, [{
    key: "getOffsetForCell",
    value: function getOffsetForCell() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$alignment = _ref.alignment,
          alignment = _ref$alignment === void 0 ? this.props.scrollToAlignment : _ref$alignment,
          _ref$columnIndex = _ref.columnIndex,
          columnIndex = _ref$columnIndex === void 0 ? this.props.scrollToColumn : _ref$columnIndex,
          _ref$rowIndex = _ref.rowIndex,
          rowIndex = _ref$rowIndex === void 0 ? this.props.scrollToRow : _ref$rowIndex;

      var offsetProps = _objectSpread({}, this.props, {
        scrollToAlignment: alignment,
        scrollToColumn: columnIndex,
        scrollToRow: rowIndex
      });

      return {
        scrollLeft: this._getCalculatedScrollLeft(offsetProps),
        scrollTop: this._getCalculatedScrollTop(offsetProps)
      };
    }
    /**
     * Gets estimated total rows' height.
     */

  }, {
    key: "getTotalRowsHeight",
    value: function getTotalRowsHeight() {
      return this.state.instanceProps.rowSizeAndPositionManager.getTotalSize();
    }
    /**
     * Gets estimated total columns' width.
     */

  }, {
    key: "getTotalColumnsWidth",
    value: function getTotalColumnsWidth() {
      return this.state.instanceProps.columnSizeAndPositionManager.getTotalSize();
    }
    /**
     * This method handles a scroll event originating from an external scroll control.
     * It's an advanced method and should probably not be used unless you're implementing a custom scroll-bar solution.
     */

  }, {
    key: "handleScrollEvent",
    value: function handleScrollEvent(_ref2) {
      var _ref2$scrollLeft = _ref2.scrollLeft,
          scrollLeftParam = _ref2$scrollLeft === void 0 ? 0 : _ref2$scrollLeft,
          _ref2$scrollTop = _ref2.scrollTop,
          scrollTopParam = _ref2$scrollTop === void 0 ? 0 : _ref2$scrollTop;

      // On iOS, we can arrive at negative offsets by swiping past the start.
      // To prevent flicker here, we make playing in the negative offset zone cause nothing to happen.
      if (scrollTopParam < 0) {
        return;
      } // Prevent pointer events from interrupting a smooth scroll


      this._debounceScrollEnded();

      var _this$props = this.props,
          autoHeight = _this$props.autoHeight,
          autoWidth = _this$props.autoWidth,
          height = _this$props.height,
          width = _this$props.width;
      var instanceProps = this.state.instanceProps; // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.

      var scrollbarSize = instanceProps.scrollbarSize;
      var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
      var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
      var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), scrollLeftParam);
      var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), scrollTopParam); // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.

      if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
        // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
        // Don't change direction for an axis unless scroll offset has changed.
        var scrollDirectionHorizontal = scrollLeft !== this.state.scrollLeft ? scrollLeft > this.state.scrollLeft ? __WEBPACK_IMPORTED_MODULE_13__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] : __WEBPACK_IMPORTED_MODULE_13__defaultOverscanIndicesGetter__["a" /* SCROLL_DIRECTION_BACKWARD */] : this.state.scrollDirectionHorizontal;
        var scrollDirectionVertical = scrollTop !== this.state.scrollTop ? scrollTop > this.state.scrollTop ? __WEBPACK_IMPORTED_MODULE_13__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] : __WEBPACK_IMPORTED_MODULE_13__defaultOverscanIndicesGetter__["a" /* SCROLL_DIRECTION_BACKWARD */] : this.state.scrollDirectionVertical;
        var newState = {
          isScrolling: true,
          scrollDirectionHorizontal: scrollDirectionHorizontal,
          scrollDirectionVertical: scrollDirectionVertical,
          scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.OBSERVED
        };

        if (!autoHeight) {
          newState.scrollTop = scrollTop;
        }

        if (!autoWidth) {
          newState.scrollLeft = scrollLeft;
        }

        newState.needToResetStyleCache = false;
        this.setState(newState);
      }

      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        totalColumnsWidth: totalColumnsWidth,
        totalRowsHeight: totalRowsHeight
      });
    }
    /**
     * Invalidate Grid size and recompute visible cells.
     * This is a deferred wrapper for recomputeGridSize().
     * It sets a flag to be evaluated on cDM/cDU to avoid unnecessary renders.
     * This method is intended for advanced use-cases like CellMeasurer.
     */
    // @TODO (bvaughn) Add automated test coverage for this.

  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender(_ref3) {
      var columnIndex = _ref3.columnIndex,
          rowIndex = _ref3.rowIndex;
      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
    }
    /**
     * Pre-measure all columns and rows in a Grid.
     * Typically cells are only measured as needed and estimated sizes are used for cells that have not yet been measured.
     * This method ensures that the next call to getTotalSize() returns an exact size (as opposed to just an estimated one).
     */

  }, {
    key: "measureAllCells",
    value: function measureAllCells() {
      var _this$props2 = this.props,
          columnCount = _this$props2.columnCount,
          rowCount = _this$props2.rowCount;
      var instanceProps = this.state.instanceProps;
      instanceProps.columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
      instanceProps.rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
    }
    /**
     * Forced recompute of row heights and column widths.
     * This function should be called if dynamic column or row sizes have changed but nothing else has.
     * Since Grid only receives :columnCount and :rowCount it has no way of detecting when the underlying data changes.
     */

  }, {
    key: "recomputeGridSize",
    value: function recomputeGridSize() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$columnIndex = _ref4.columnIndex,
          columnIndex = _ref4$columnIndex === void 0 ? 0 : _ref4$columnIndex,
          _ref4$rowIndex = _ref4.rowIndex,
          rowIndex = _ref4$rowIndex === void 0 ? 0 : _ref4$rowIndex;

      var _this$props3 = this.props,
          scrollToColumn = _this$props3.scrollToColumn,
          scrollToRow = _this$props3.scrollToRow;
      var instanceProps = this.state.instanceProps;
      instanceProps.columnSizeAndPositionManager.resetCell(columnIndex);
      instanceProps.rowSizeAndPositionManager.resetCell(rowIndex); // Cell sizes may be determined by a function property.
      // In this case the cDU handler can't know if they changed.
      // Store this flag to let the next cDU pass know it needs to recompute the scroll offset.

      this._recomputeScrollLeftFlag = scrollToColumn >= 0 && (this.state.scrollDirectionHorizontal === __WEBPACK_IMPORTED_MODULE_13__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] ? columnIndex <= scrollToColumn : columnIndex >= scrollToColumn);
      this._recomputeScrollTopFlag = scrollToRow >= 0 && (this.state.scrollDirectionVertical === __WEBPACK_IMPORTED_MODULE_13__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] ? rowIndex <= scrollToRow : rowIndex >= scrollToRow); // Clear cell cache in case we are scrolling;
      // Invalid row heights likely mean invalid cached content as well.

      this._styleCache = {};
      this._cellCache = {};
      this.forceUpdate();
    }
    /**
     * Ensure column and row are visible.
     */

  }, {
    key: "scrollToCell",
    value: function scrollToCell(_ref5) {
      var columnIndex = _ref5.columnIndex,
          rowIndex = _ref5.rowIndex;
      var columnCount = this.props.columnCount;
      var props = this.props; // Don't adjust scroll offset for single-column grids (eg List, Table).
      // This can cause a funky scroll offset because of the vertical scrollbar width.

      if (columnCount > 1 && columnIndex !== undefined) {
        this._updateScrollLeftForScrollToColumn(_objectSpread({}, props, {
          scrollToColumn: columnIndex
        }));
      }

      if (rowIndex !== undefined) {
        this._updateScrollTopForScrollToRow(_objectSpread({}, props, {
          scrollToRow: rowIndex
        }));
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props4 = this.props,
          getScrollbarSize = _this$props4.getScrollbarSize,
          height = _this$props4.height,
          scrollLeft = _this$props4.scrollLeft,
          scrollToColumn = _this$props4.scrollToColumn,
          scrollTop = _this$props4.scrollTop,
          scrollToRow = _this$props4.scrollToRow,
          width = _this$props4.width;
      var instanceProps = this.state.instanceProps; // Reset initial offsets to be ignored in browser

      this._initialScrollTop = 0;
      this._initialScrollLeft = 0; // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
      // We must do this at the start of the method as we may calculate and update scroll position below.

      this._handleInvalidatedGridSize(); // If this component was first rendered server-side, scrollbar size will be undefined.
      // In that event we need to remeasure.


      if (!instanceProps.scrollbarSizeMeasured) {
        this.setState(function (prevState) {
          var stateUpdate = _objectSpread({}, prevState, {
            needToResetStyleCache: false
          });

          stateUpdate.instanceProps.scrollbarSize = getScrollbarSize();
          stateUpdate.instanceProps.scrollbarSizeMeasured = true;
          return stateUpdate;
        });
      }

      if (typeof scrollLeft === 'number' && scrollLeft >= 0 || typeof scrollTop === 'number' && scrollTop >= 0) {
        var stateUpdate = Grid._getScrollToPositionStateUpdate({
          prevState: this.state,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        });

        if (stateUpdate) {
          stateUpdate.needToResetStyleCache = false;
          this.setState(stateUpdate);
        }
      } // refs don't work in `react-test-renderer`


      if (this._scrollingContainer) {
        // setting the ref's scrollLeft and scrollTop.
        // Somehow in MultiGrid the main grid doesn't trigger a update on mount.
        if (this._scrollingContainer.scrollLeft !== this.state.scrollLeft) {
          this._scrollingContainer.scrollLeft = this.state.scrollLeft;
        }

        if (this._scrollingContainer.scrollTop !== this.state.scrollTop) {
          this._scrollingContainer.scrollTop = this.state.scrollTop;
        }
      } // Don't update scroll offset if the size is 0; we don't render any cells in this case.
      // Setting a state may cause us to later thing we've updated the offce when we haven't.


      var sizeIsBiggerThanZero = height > 0 && width > 0;

      if (scrollToColumn >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollLeftForScrollToColumn();
      }

      if (scrollToRow >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollTopForScrollToRow();
      } // Update onRowsRendered callback


      this._invokeOnGridRenderedHelper(); // Initialize onScroll callback


      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft || 0,
        scrollTop: scrollTop || 0,
        totalColumnsWidth: instanceProps.columnSizeAndPositionManager.getTotalSize(),
        totalRowsHeight: instanceProps.rowSizeAndPositionManager.getTotalSize()
      });

      this._maybeCallOnScrollbarPresenceChange();
    }
    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) New scroll-to-cell props have been set
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var _this$props5 = this.props,
          autoHeight = _this$props5.autoHeight,
          autoWidth = _this$props5.autoWidth,
          columnCount = _this$props5.columnCount,
          height = _this$props5.height,
          rowCount = _this$props5.rowCount,
          scrollToAlignment = _this$props5.scrollToAlignment,
          scrollToColumn = _this$props5.scrollToColumn,
          scrollToRow = _this$props5.scrollToRow,
          width = _this$props5.width;
      var _this$state = this.state,
          scrollLeft = _this$state.scrollLeft,
          scrollPositionChangeReason = _this$state.scrollPositionChangeReason,
          scrollTop = _this$state.scrollTop,
          instanceProps = _this$state.instanceProps; // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
      // We must do this at the start of the method as we may calculate and update scroll position below.

      this._handleInvalidatedGridSize(); // Handle edge case where column or row count has only just increased over 0.
      // In this case we may have to restore a previously-specified scroll offset.
      // For more info see bvaughn/react-virtualized/issues/218


      var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0; // Make sure requested changes to :scrollLeft or :scrollTop get applied.
      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
      // So we only set these when we require an adjustment of the scroll position.
      // See issue #2 for more information.

      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
        // @TRICKY :autoHeight and :autoWidth properties instructs Grid to leave :scrollTop and :scrollLeft management to an external HOC (eg WindowScroller).
        // In this case we should avoid checking scrollingContainer.scrollTop and scrollingContainer.scrollLeft since it forces layout/flow.
        if (!autoWidth && scrollLeft >= 0 && (scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollLeft = scrollLeft;
        }

        if (!autoHeight && scrollTop >= 0 && (scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollTop = scrollTop;
        }
      } // Special case where the previous size was 0:
      // In this case we don't show any windowed cells at all.
      // So we should always recalculate offset afterwards.


      var sizeJustIncreasedFromZero = (prevProps.width === 0 || prevProps.height === 0) && height > 0 && width > 0; // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
      // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?

      if (this._recomputeScrollLeftFlag) {
        this._recomputeScrollLeftFlag = false;

        this._updateScrollLeftForScrollToColumn(this.props);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_14__utils_updateScrollIndexHelper__["a" /* default */])({
          cellSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
          previousCellsCount: prevProps.columnCount,
          previousCellSize: prevProps.columnWidth,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToColumn,
          previousSize: prevProps.width,
          scrollOffset: scrollLeft,
          scrollToAlignment: scrollToAlignment,
          scrollToIndex: scrollToColumn,
          size: width,
          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback() {
            return _this2._updateScrollLeftForScrollToColumn(_this2.props);
          }
        });
      }

      if (this._recomputeScrollTopFlag) {
        this._recomputeScrollTopFlag = false;

        this._updateScrollTopForScrollToRow(this.props);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_14__utils_updateScrollIndexHelper__["a" /* default */])({
          cellSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
          previousCellsCount: prevProps.rowCount,
          previousCellSize: prevProps.rowHeight,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToRow,
          previousSize: prevProps.height,
          scrollOffset: scrollTop,
          scrollToAlignment: scrollToAlignment,
          scrollToIndex: scrollToRow,
          size: height,
          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback() {
            return _this2._updateScrollTopForScrollToRow(_this2.props);
          }
        });
      } // Update onRowsRendered callback if start/stop indices have changed


      this._invokeOnGridRenderedHelper(); // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners


      if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
        var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
        var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();

        this._invokeOnScrollMemoizer({
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          totalColumnsWidth: totalColumnsWidth,
          totalRowsHeight: totalRowsHeight
        });
      }

      this._maybeCallOnScrollbarPresenceChange();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._disablePointerEventsTimeoutId) {
        Object(__WEBPACK_IMPORTED_MODULE_18__utils_requestAnimationTimeout__["a" /* cancelAnimationTimeout */])(this._disablePointerEventsTimeoutId);
      }
    }
    /**
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          autoContainerWidth = _this$props6.autoContainerWidth,
          autoHeight = _this$props6.autoHeight,
          autoWidth = _this$props6.autoWidth,
          className = _this$props6.className,
          containerProps = _this$props6.containerProps,
          containerRole = _this$props6.containerRole,
          containerStyle = _this$props6.containerStyle,
          height = _this$props6.height,
          id = _this$props6.id,
          noContentRenderer = _this$props6.noContentRenderer,
          role = _this$props6.role,
          style = _this$props6.style,
          tabIndex = _this$props6.tabIndex,
          width = _this$props6.width;
      var _this$state2 = this.state,
          instanceProps = _this$state2.instanceProps,
          needToResetStyleCache = _this$state2.needToResetStyleCache;

      var isScrolling = this._isScrolling();

      var gridStyle = {
        boxSizing: 'border-box',
        direction: 'ltr',
        height: autoHeight ? 'auto' : height,
        position: 'relative',
        width: autoWidth ? 'auto' : width,
        WebkitOverflowScrolling: 'touch',
        willChange: 'transform'
      };

      if (needToResetStyleCache) {
        this._styleCache = {};
      } // calculate _styleCache here
      // if state.isScrolling (not from _isScrolling) then reset


      if (!this.state.isScrolling) {
        this._resetStyleCache();
      } // calculate children to render here


      this._calculateChildrenToRender(this.props, this.state);

      var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
      var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize(); // Force browser to hide scrollbars when we know they aren't necessary.
      // Otherwise once scrollbars appear they may not disappear again.
      // For more info see issue #116

      var verticalScrollBarSize = totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
      var horizontalScrollBarSize = totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;

      if (horizontalScrollBarSize !== this._horizontalScrollBarSize || verticalScrollBarSize !== this._verticalScrollBarSize) {
        this._horizontalScrollBarSize = horizontalScrollBarSize;
        this._verticalScrollBarSize = verticalScrollBarSize;
        this._scrollbarPresenceChanged = true;
      } // Also explicitly init styles to 'auto' if scrollbars are required.
      // This works around an obscure edge case where external CSS styles have not yet been loaded,
      // But an initial scroll index of offset is set as an external prop.
      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
      // This was originally reported via clauderic/react-infinite-calendar/issues/23


      gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
      gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
      var childrenToDisplay = this._childrenToDisplay;
      var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;
      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
        ref: this._setScrollingContainerRef
      }, containerProps, {
        "aria-label": this.props['aria-label'],
        "aria-readonly": this.props['aria-readonly'],
        className: Object(__WEBPACK_IMPORTED_MODULE_9_clsx__["a" /* default */])('ReactVirtualized__Grid', className),
        id: id,
        onScroll: this._onScroll,
        role: role,
        style: _objectSpread({}, gridStyle, {}, style),
        tabIndex: tabIndex
      }), childrenToDisplay.length > 0 && __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
        className: "ReactVirtualized__Grid__innerScrollContainer",
        role: containerRole,
        style: _objectSpread({
          width: autoContainerWidth ? 'auto' : totalColumnsWidth,
          height: totalRowsHeight,
          maxWidth: totalColumnsWidth,
          maxHeight: totalRowsHeight,
          overflow: 'hidden',
          pointerEvents: isScrolling ? 'none' : '',
          position: 'relative'
        }, containerStyle)
      }, childrenToDisplay), showNoContentRenderer && noContentRenderer());
    }
    /* ---------------------------- Helper methods ---------------------------- */

  }, {
    key: "_calculateChildrenToRender",
    value: function _calculateChildrenToRender() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var cellRenderer = props.cellRenderer,
          cellRangeRenderer = props.cellRangeRenderer,
          columnCount = props.columnCount,
          deferredMeasurementCache = props.deferredMeasurementCache,
          height = props.height,
          overscanColumnCount = props.overscanColumnCount,
          overscanIndicesGetter = props.overscanIndicesGetter,
          overscanRowCount = props.overscanRowCount,
          rowCount = props.rowCount,
          width = props.width,
          isScrollingOptOut = props.isScrollingOptOut;
      var scrollDirectionHorizontal = state.scrollDirectionHorizontal,
          scrollDirectionVertical = state.scrollDirectionVertical,
          instanceProps = state.instanceProps;
      var scrollTop = this._initialScrollTop > 0 ? this._initialScrollTop : state.scrollTop;
      var scrollLeft = this._initialScrollLeft > 0 ? this._initialScrollLeft : state.scrollLeft;

      var isScrolling = this._isScrolling(props, state);

      this._childrenToDisplay = []; // Render only enough columns and rows to cover the visible area of the grid.

      if (height > 0 && width > 0) {
        var visibleColumnIndices = instanceProps.columnSizeAndPositionManager.getVisibleCellRange({
          containerSize: width,
          offset: scrollLeft
        });
        var visibleRowIndices = instanceProps.rowSizeAndPositionManager.getVisibleCellRange({
          containerSize: height,
          offset: scrollTop
        });
        var horizontalOffsetAdjustment = instanceProps.columnSizeAndPositionManager.getOffsetAdjustment({
          containerSize: width,
          offset: scrollLeft
        });
        var verticalOffsetAdjustment = instanceProps.rowSizeAndPositionManager.getOffsetAdjustment({
          containerSize: height,
          offset: scrollTop
        }); // Store for _invokeOnGridRenderedHelper()

        this._renderedColumnStartIndex = visibleColumnIndices.start;
        this._renderedColumnStopIndex = visibleColumnIndices.stop;
        this._renderedRowStartIndex = visibleRowIndices.start;
        this._renderedRowStopIndex = visibleRowIndices.stop;
        var overscanColumnIndices = overscanIndicesGetter({
          direction: 'horizontal',
          cellCount: columnCount,
          overscanCellsCount: overscanColumnCount,
          scrollDirection: scrollDirectionHorizontal,
          startIndex: typeof visibleColumnIndices.start === 'number' ? visibleColumnIndices.start : 0,
          stopIndex: typeof visibleColumnIndices.stop === 'number' ? visibleColumnIndices.stop : -1
        });
        var overscanRowIndices = overscanIndicesGetter({
          direction: 'vertical',
          cellCount: rowCount,
          overscanCellsCount: overscanRowCount,
          scrollDirection: scrollDirectionVertical,
          startIndex: typeof visibleRowIndices.start === 'number' ? visibleRowIndices.start : 0,
          stopIndex: typeof visibleRowIndices.stop === 'number' ? visibleRowIndices.stop : -1
        }); // Store for _invokeOnGridRenderedHelper()

        var columnStartIndex = overscanColumnIndices.overscanStartIndex;
        var columnStopIndex = overscanColumnIndices.overscanStopIndex;
        var rowStartIndex = overscanRowIndices.overscanStartIndex;
        var rowStopIndex = overscanRowIndices.overscanStopIndex; // Advanced use-cases (eg CellMeasurer) require batched measurements to determine accurate sizes.

        if (deferredMeasurementCache) {
          // If rows have a dynamic height, scan the rows we are about to render.
          // If any have not yet been measured, then we need to render all columns initially,
          // Because the height of the row is equal to the tallest cell within that row,
          // (And so we can't know the height without measuring all column-cells first).
          if (!deferredMeasurementCache.hasFixedHeight()) {
            for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
              if (!deferredMeasurementCache.has(rowIndex, 0)) {
                columnStartIndex = 0;
                columnStopIndex = columnCount - 1;
                break;
              }
            }
          } // If columns have a dynamic width, scan the columns we are about to render.
          // If any have not yet been measured, then we need to render all rows initially,
          // Because the width of the column is equal to the widest cell within that column,
          // (And so we can't know the width without measuring all row-cells first).


          if (!deferredMeasurementCache.hasFixedWidth()) {
            for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
              if (!deferredMeasurementCache.has(0, columnIndex)) {
                rowStartIndex = 0;
                rowStopIndex = rowCount - 1;
                break;
              }
            }
          }
        }

        this._childrenToDisplay = cellRangeRenderer({
          cellCache: this._cellCache,
          cellRenderer: cellRenderer,
          columnSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
          columnStartIndex: columnStartIndex,
          columnStopIndex: columnStopIndex,
          deferredMeasurementCache: deferredMeasurementCache,
          horizontalOffsetAdjustment: horizontalOffsetAdjustment,
          isScrolling: isScrolling,
          isScrollingOptOut: isScrollingOptOut,
          parent: this,
          rowSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
          rowStartIndex: rowStartIndex,
          rowStopIndex: rowStopIndex,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          styleCache: this._styleCache,
          verticalOffsetAdjustment: verticalOffsetAdjustment,
          visibleColumnIndices: visibleColumnIndices,
          visibleRowIndices: visibleRowIndices
        }); // update the indices

        this._columnStartIndex = columnStartIndex;
        this._columnStopIndex = columnStopIndex;
        this._rowStartIndex = rowStartIndex;
        this._rowStopIndex = rowStopIndex;
      }
    }
    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Grid.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */

  }, {
    key: "_debounceScrollEnded",
    value: function _debounceScrollEnded() {
      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;

      if (this._disablePointerEventsTimeoutId) {
        Object(__WEBPACK_IMPORTED_MODULE_18__utils_requestAnimationTimeout__["a" /* cancelAnimationTimeout */])(this._disablePointerEventsTimeoutId);
      }

      this._disablePointerEventsTimeoutId = Object(__WEBPACK_IMPORTED_MODULE_18__utils_requestAnimationTimeout__["b" /* requestAnimationTimeout */])(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
    }
  }, {
    key: "_handleInvalidatedGridSize",

    /**
     * Check for batched CellMeasurer size invalidations.
     * This will occur the first time one or more previously unmeasured cells are rendered.
     */
    value: function _handleInvalidatedGridSize() {
      if (typeof this._deferredInvalidateColumnIndex === 'number' && typeof this._deferredInvalidateRowIndex === 'number') {
        var columnIndex = this._deferredInvalidateColumnIndex;
        var rowIndex = this._deferredInvalidateRowIndex;
        this._deferredInvalidateColumnIndex = null;
        this._deferredInvalidateRowIndex = null;
        this.recomputeGridSize({
          columnIndex: columnIndex,
          rowIndex: rowIndex
        });
      }
    }
  }, {
    key: "_invokeOnScrollMemoizer",
    value: function _invokeOnScrollMemoizer(_ref6) {
      var _this3 = this;

      var scrollLeft = _ref6.scrollLeft,
          scrollTop = _ref6.scrollTop,
          totalColumnsWidth = _ref6.totalColumnsWidth,
          totalRowsHeight = _ref6.totalRowsHeight;

      this._onScrollMemoizer({
        callback: function callback(_ref7) {
          var scrollLeft = _ref7.scrollLeft,
              scrollTop = _ref7.scrollTop;
          var _this3$props = _this3.props,
              height = _this3$props.height,
              onScroll = _this3$props.onScroll,
              width = _this3$props.width;
          onScroll({
            clientHeight: height,
            clientWidth: width,
            scrollHeight: totalRowsHeight,
            scrollLeft: scrollLeft,
            scrollTop: scrollTop,
            scrollWidth: totalColumnsWidth
          });
        },
        indices: {
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        }
      });
    }
  }, {
    key: "_isScrolling",
    value: function _isScrolling() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      // If isScrolling is defined in props, use it to override the value in state
      // This is a performance optimization for WindowScroller + Grid
      return Object.hasOwnProperty.call(props, 'isScrolling') ? Boolean(props.isScrolling) : Boolean(state.isScrolling);
    }
  }, {
    key: "_maybeCallOnScrollbarPresenceChange",
    value: function _maybeCallOnScrollbarPresenceChange() {
      if (this._scrollbarPresenceChanged) {
        var onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;
        this._scrollbarPresenceChanged = false;
        onScrollbarPresenceChange({
          horizontal: this._horizontalScrollBarSize > 0,
          size: this.state.instanceProps.scrollbarSize,
          vertical: this._verticalScrollBarSize > 0
        });
      }
    }
  }, {
    key: "scrollToPosition",

    /**
     * Scroll to the specified offset(s).
     * Useful for animating position changes.
     */
    value: function scrollToPosition(_ref8) {
      var scrollLeft = _ref8.scrollLeft,
          scrollTop = _ref8.scrollTop;

      var stateUpdate = Grid._getScrollToPositionStateUpdate({
        prevState: this.state,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      });

      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }, {
    key: "_getCalculatedScrollLeft",
    value: function _getCalculatedScrollLeft() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      return Grid._getCalculatedScrollLeft(props, state);
    }
  }, {
    key: "_updateScrollLeftForScrollToColumn",
    value: function _updateScrollLeftForScrollToColumn() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      var stateUpdate = Grid._getScrollLeftForScrollToColumnStateUpdate(props, state);

      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }, {
    key: "_getCalculatedScrollTop",
    value: function _getCalculatedScrollTop() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      return Grid._getCalculatedScrollTop(props, state);
    }
  }, {
    key: "_resetStyleCache",
    value: function _resetStyleCache() {
      var styleCache = this._styleCache;
      var cellCache = this._cellCache;
      var isScrollingOptOut = this.props.isScrollingOptOut; // Reset cell and style caches once scrolling stops.
      // This makes Grid simpler to use (since cells commonly change).
      // And it keeps the caches from growing too large.
      // Performance is most sensitive when a user is scrolling.
      // Don't clear visible cells from cellCache if isScrollingOptOut is specified.
      // This keeps the cellCache to a resonable size.

      this._cellCache = {};
      this._styleCache = {}; // Copy over the visible cell styles so avoid unnecessary re-render.

      for (var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++) {
        for (var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++) {
          var key = "".concat(rowIndex, "-").concat(columnIndex);
          this._styleCache[key] = styleCache[key];

          if (isScrollingOptOut) {
            this._cellCache[key] = cellCache[key];
          }
        }
      }
    }
  }, {
    key: "_updateScrollTopForScrollToRow",
    value: function _updateScrollTopForScrollToRow() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      var stateUpdate = Grid._getScrollTopForScrollToRowStateUpdate(props, state);

      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var newState = {};

      if (nextProps.columnCount === 0 && prevState.scrollLeft !== 0 || nextProps.rowCount === 0 && prevState.scrollTop !== 0) {
        newState.scrollLeft = 0;
        newState.scrollTop = 0; // only use scroll{Left,Top} from props if scrollTo{Column,Row} isn't specified
        // scrollTo{Column,Row} should override scroll{Left,Top}
      } else if (nextProps.scrollLeft !== prevState.scrollLeft && nextProps.scrollToColumn < 0 || nextProps.scrollTop !== prevState.scrollTop && nextProps.scrollToRow < 0) {
        Object.assign(newState, Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: nextProps.scrollLeft,
          scrollTop: nextProps.scrollTop
        }));
      }

      var instanceProps = prevState.instanceProps; // Initially we should not clearStyleCache

      newState.needToResetStyleCache = false;

      if (nextProps.columnWidth !== instanceProps.prevColumnWidth || nextProps.rowHeight !== instanceProps.prevRowHeight) {
        // Reset cache. set it to {} in render
        newState.needToResetStyleCache = true;
      }

      instanceProps.columnSizeAndPositionManager.configure({
        cellCount: nextProps.columnCount,
        estimatedCellSize: Grid._getEstimatedColumnSize(nextProps),
        cellSizeGetter: Grid._wrapSizeGetter(nextProps.columnWidth)
      });
      instanceProps.rowSizeAndPositionManager.configure({
        cellCount: nextProps.rowCount,
        estimatedCellSize: Grid._getEstimatedRowSize(nextProps),
        cellSizeGetter: Grid._wrapSizeGetter(nextProps.rowHeight)
      });

      if (instanceProps.prevColumnCount === 0 || instanceProps.prevRowCount === 0) {
        instanceProps.prevColumnCount = 0;
        instanceProps.prevRowCount = 0;
      } // If scrolling is controlled outside this component, clear cache when scrolling stops


      if (nextProps.autoHeight && nextProps.isScrolling === false && instanceProps.prevIsScrolling === true) {
        Object.assign(newState, {
          isScrolling: false
        });
      }

      var maybeStateA;
      var maybeStateB;
      Object(__WEBPACK_IMPORTED_MODULE_10__utils_calculateSizeAndPositionDataAndUpdateScrollOffset__["a" /* default */])({
        cellCount: instanceProps.prevColumnCount,
        cellSize: typeof instanceProps.prevColumnWidth === 'number' ? instanceProps.prevColumnWidth : null,
        computeMetadataCallback: function computeMetadataCallback() {
          return instanceProps.columnSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.columnCount,
        nextCellSize: typeof nextProps.columnWidth === 'number' ? nextProps.columnWidth : null,
        nextScrollToIndex: nextProps.scrollToColumn,
        scrollToIndex: instanceProps.prevScrollToColumn,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          maybeStateA = Grid._getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState);
        }
      });
      Object(__WEBPACK_IMPORTED_MODULE_10__utils_calculateSizeAndPositionDataAndUpdateScrollOffset__["a" /* default */])({
        cellCount: instanceProps.prevRowCount,
        cellSize: typeof instanceProps.prevRowHeight === 'number' ? instanceProps.prevRowHeight : null,
        computeMetadataCallback: function computeMetadataCallback() {
          return instanceProps.rowSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.rowCount,
        nextCellSize: typeof nextProps.rowHeight === 'number' ? nextProps.rowHeight : null,
        nextScrollToIndex: nextProps.scrollToRow,
        scrollToIndex: instanceProps.prevScrollToRow,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          maybeStateB = Grid._getScrollTopForScrollToRowStateUpdate(nextProps, prevState);
        }
      });
      instanceProps.prevColumnCount = nextProps.columnCount;
      instanceProps.prevColumnWidth = nextProps.columnWidth;
      instanceProps.prevIsScrolling = nextProps.isScrolling === true;
      instanceProps.prevRowCount = nextProps.rowCount;
      instanceProps.prevRowHeight = nextProps.rowHeight;
      instanceProps.prevScrollToColumn = nextProps.scrollToColumn;
      instanceProps.prevScrollToRow = nextProps.scrollToRow; // getting scrollBarSize (moved from componentWillMount)

      instanceProps.scrollbarSize = nextProps.getScrollbarSize();

      if (instanceProps.scrollbarSize === undefined) {
        instanceProps.scrollbarSizeMeasured = false;
        instanceProps.scrollbarSize = 0;
      } else {
        instanceProps.scrollbarSizeMeasured = true;
      }

      newState.instanceProps = instanceProps;
      return _objectSpread({}, newState, {}, maybeStateA, {}, maybeStateB);
    }
  }, {
    key: "_getEstimatedColumnSize",
    value: function _getEstimatedColumnSize(props) {
      return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
    }
  }, {
    key: "_getEstimatedRowSize",
    value: function _getEstimatedRowSize(props) {
      return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
    }
  }, {
    key: "_getScrollToPositionStateUpdate",

    /**
     * Get the updated state after scrolling to
     * scrollLeft and scrollTop
     */
    value: function _getScrollToPositionStateUpdate(_ref9) {
      var prevState = _ref9.prevState,
          scrollLeft = _ref9.scrollLeft,
          scrollTop = _ref9.scrollTop;
      var newState = {
        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
      };

      if (typeof scrollLeft === 'number' && scrollLeft >= 0) {
        newState.scrollDirectionHorizontal = scrollLeft > prevState.scrollLeft ? __WEBPACK_IMPORTED_MODULE_13__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] : __WEBPACK_IMPORTED_MODULE_13__defaultOverscanIndicesGetter__["a" /* SCROLL_DIRECTION_BACKWARD */];
        newState.scrollLeft = scrollLeft;
      }

      if (typeof scrollTop === 'number' && scrollTop >= 0) {
        newState.scrollDirectionVertical = scrollTop > prevState.scrollTop ? __WEBPACK_IMPORTED_MODULE_13__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] : __WEBPACK_IMPORTED_MODULE_13__defaultOverscanIndicesGetter__["a" /* SCROLL_DIRECTION_BACKWARD */];
        newState.scrollTop = scrollTop;
      }

      if (typeof scrollLeft === 'number' && scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft || typeof scrollTop === 'number' && scrollTop >= 0 && scrollTop !== prevState.scrollTop) {
        return newState;
      }

      return {};
    }
  }, {
    key: "_wrapSizeGetter",
    value: function _wrapSizeGetter(value) {
      return typeof value === 'function' ? value : function () {
        return value;
      };
    }
  }, {
    key: "_getCalculatedScrollLeft",
    value: function _getCalculatedScrollLeft(nextProps, prevState) {
      var columnCount = nextProps.columnCount,
          height = nextProps.height,
          scrollToAlignment = nextProps.scrollToAlignment,
          scrollToColumn = nextProps.scrollToColumn,
          width = nextProps.width;
      var scrollLeft = prevState.scrollLeft,
          instanceProps = prevState.instanceProps;

      if (columnCount > 0) {
        var finalColumn = columnCount - 1;
        var targetIndex = scrollToColumn < 0 ? finalColumn : Math.min(finalColumn, scrollToColumn);
        var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
        var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
        return instanceProps.columnSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: width - scrollBarSize,
          currentOffset: scrollLeft,
          targetIndex: targetIndex
        });
      }

      return 0;
    }
  }, {
    key: "_getScrollLeftForScrollToColumnStateUpdate",
    value: function _getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState) {
      var scrollLeft = prevState.scrollLeft;

      var calculatedScrollLeft = Grid._getCalculatedScrollLeft(nextProps, prevState);

      if (typeof calculatedScrollLeft === 'number' && calculatedScrollLeft >= 0 && scrollLeft !== calculatedScrollLeft) {
        return Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: calculatedScrollLeft,
          scrollTop: -1
        });
      }

      return {};
    }
  }, {
    key: "_getCalculatedScrollTop",
    value: function _getCalculatedScrollTop(nextProps, prevState) {
      var height = nextProps.height,
          rowCount = nextProps.rowCount,
          scrollToAlignment = nextProps.scrollToAlignment,
          scrollToRow = nextProps.scrollToRow,
          width = nextProps.width;
      var scrollTop = prevState.scrollTop,
          instanceProps = prevState.instanceProps;

      if (rowCount > 0) {
        var finalRow = rowCount - 1;
        var targetIndex = scrollToRow < 0 ? finalRow : Math.min(finalRow, scrollToRow);
        var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
        var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
        return instanceProps.rowSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: height - scrollBarSize,
          currentOffset: scrollTop,
          targetIndex: targetIndex
        });
      }

      return 0;
    }
  }, {
    key: "_getScrollTopForScrollToRowStateUpdate",
    value: function _getScrollTopForScrollToRowStateUpdate(nextProps, prevState) {
      var scrollTop = prevState.scrollTop;

      var calculatedScrollTop = Grid._getCalculatedScrollTop(nextProps, prevState);

      if (typeof calculatedScrollTop === 'number' && calculatedScrollTop >= 0 && scrollTop !== calculatedScrollTop) {
        return Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: -1,
          scrollTop: calculatedScrollTop
        });
      }

      return {};
    }
  }]);

  return Grid;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]), __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_class, "propTypes",  true ? null : {
  "aria-label": PropTypes.string.isRequired,
  "aria-readonly": PropTypes.bool,

  /**
   * Set the width of the inner scrollable container to 'auto'.
   * This is useful for single-column Grids to ensure that the column doesn't extend below a vertical scrollbar.
   */
  "autoContainerWidth": PropTypes.bool.isRequired,

  /**
   * Removes fixed height from the scrollingContainer so that the total height of rows can stretch the window.
   * Intended for use with WindowScroller
   */
  "autoHeight": PropTypes.bool.isRequired,

  /**
   * Removes fixed width from the scrollingContainer so that the total width of rows can stretch the window.
   * Intended for use with WindowScroller
   */
  "autoWidth": PropTypes.bool.isRequired,

  /** Responsible for rendering a cell given an row and column index.  */
  "cellRenderer": function cellRenderer() {
    return (typeof bpfrpt_proptype_CellRenderer === "function" ? bpfrpt_proptype_CellRenderer.isRequired ? bpfrpt_proptype_CellRenderer.isRequired : bpfrpt_proptype_CellRenderer : PropTypes.shape(bpfrpt_proptype_CellRenderer).isRequired).apply(this, arguments);
  },

  /** Responsible for rendering a group of cells given their index ranges.  */
  "cellRangeRenderer": function cellRangeRenderer() {
    return (typeof bpfrpt_proptype_CellRangeRenderer === "function" ? bpfrpt_proptype_CellRangeRenderer.isRequired ? bpfrpt_proptype_CellRangeRenderer.isRequired : bpfrpt_proptype_CellRangeRenderer : PropTypes.shape(bpfrpt_proptype_CellRangeRenderer).isRequired).apply(this, arguments);
  },

  /** Optional custom CSS class name to attach to root Grid element.  */
  "className": PropTypes.string,

  /** Number of columns in grid.  */
  "columnCount": PropTypes.number.isRequired,

  /** Either a fixed column width (number) or a function that returns the width of a column given its index.  */
  "columnWidth": function columnWidth() {
    return (typeof bpfrpt_proptype_CellSize === "function" ? bpfrpt_proptype_CellSize.isRequired ? bpfrpt_proptype_CellSize.isRequired : bpfrpt_proptype_CellSize : PropTypes.shape(bpfrpt_proptype_CellSize).isRequired).apply(this, arguments);
  },

  /** Unfiltered props for the Grid container. */
  "containerProps": PropTypes.object,

  /** ARIA role for the cell-container.  */
  "containerRole": PropTypes.string.isRequired,

  /** Optional inline style applied to inner cell-container */
  "containerStyle": PropTypes.object.isRequired,

  /**
   * If CellMeasurer is used to measure this Grid's children, this should be a pointer to its CellMeasurerCache.
   * A shared CellMeasurerCache reference enables Grid and CellMeasurer to share measurement data.
   */
  "deferredMeasurementCache": PropTypes.object,

  /**
   * Used to estimate the total width of a Grid before all of its columns have actually been measured.
   * The estimated total width is adjusted as columns are rendered.
   */
  "estimatedColumnSize": PropTypes.number.isRequired,

  /**
   * Used to estimate the total height of a Grid before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  "estimatedRowSize": PropTypes.number.isRequired,

  /** Exposed for testing purposes only.  */
  "getScrollbarSize": PropTypes.func.isRequired,

  /** Height of Grid; this property determines the number of visible (vs virtualized) rows.  */
  "height": PropTypes.number.isRequired,

  /** Optional custom id to attach to root Grid element.  */
  "id": PropTypes.string,

  /**
   * Override internal is-scrolling state tracking.
   * This property is primarily intended for use with the WindowScroller component.
   */
  "isScrolling": PropTypes.bool,

  /**
   * Opt-out of isScrolling param passed to cellRangeRenderer.
   * To avoid the extra render when scroll stops.
   */
  "isScrollingOptOut": PropTypes.bool.isRequired,

  /** Optional renderer to be used in place of rows when either :rowCount or :columnCount is 0.  */
  "noContentRenderer": function noContentRenderer() {
    return (typeof bpfrpt_proptype_NoContentRenderer === "function" ? bpfrpt_proptype_NoContentRenderer.isRequired ? bpfrpt_proptype_NoContentRenderer.isRequired : bpfrpt_proptype_NoContentRenderer : PropTypes.shape(bpfrpt_proptype_NoContentRenderer).isRequired).apply(this, arguments);
  },

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   */
  "onScroll": PropTypes.func.isRequired,

  /**
   * Called whenever a horizontal or vertical scrollbar is added or removed.
   * This prop is not intended for end-user use;
   * It is used by MultiGrid to support fixed-row/fixed-column scroll syncing.
   */
  "onScrollbarPresenceChange": PropTypes.func.isRequired,

  /** Callback invoked with information about the section of the Grid that was just rendered.  */
  "onSectionRendered": PropTypes.func.isRequired,

  /**
   * Number of columns to render before/after the visible section of the grid.
   * These columns can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   */
  "overscanColumnCount": PropTypes.number.isRequired,

  /**
   * Calculates the number of cells to overscan before and after a specified range.
   * This function ensures that overscanning doesn't exceed the available cells.
   */
  "overscanIndicesGetter": function overscanIndicesGetter() {
    return (typeof bpfrpt_proptype_OverscanIndicesGetter === "function" ? bpfrpt_proptype_OverscanIndicesGetter.isRequired ? bpfrpt_proptype_OverscanIndicesGetter.isRequired : bpfrpt_proptype_OverscanIndicesGetter : PropTypes.shape(bpfrpt_proptype_OverscanIndicesGetter).isRequired).apply(this, arguments);
  },

  /**
   * Number of rows to render above/below the visible section of the grid.
   * These rows can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   */
  "overscanRowCount": PropTypes.number.isRequired,

  /** ARIA role for the grid element.  */
  "role": PropTypes.string.isRequired,

  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * Should implement the following interface: ({ index: number }): number
   */
  "rowHeight": function rowHeight() {
    return (typeof bpfrpt_proptype_CellSize === "function" ? bpfrpt_proptype_CellSize.isRequired ? bpfrpt_proptype_CellSize.isRequired : bpfrpt_proptype_CellSize : PropTypes.shape(bpfrpt_proptype_CellSize).isRequired).apply(this, arguments);
  },

  /** Number of rows in grid.  */
  "rowCount": PropTypes.number.isRequired,

  /** Wait this amount of time after the last scroll event before resetting Grid `pointer-events`. */
  "scrollingResetTimeInterval": PropTypes.number.isRequired,

  /** Horizontal offset. */
  "scrollLeft": PropTypes.number,

  /**
   * Controls scroll-to-cell behavior of the Grid.
   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
   */
  "scrollToAlignment": function scrollToAlignment() {
    return (typeof bpfrpt_proptype_Alignment === "function" ? bpfrpt_proptype_Alignment.isRequired ? bpfrpt_proptype_Alignment.isRequired : bpfrpt_proptype_Alignment : PropTypes.shape(bpfrpt_proptype_Alignment).isRequired).apply(this, arguments);
  },

  /** Column index to ensure visible (by forcefully scrolling if necessary) */
  "scrollToColumn": PropTypes.number.isRequired,

  /** Vertical offset. */
  "scrollTop": PropTypes.number,

  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  "scrollToRow": PropTypes.number.isRequired,

  /** Optional inline style */
  "style": PropTypes.object.isRequired,

  /** Tab index for focus */
  "tabIndex": PropTypes.number,

  /** Width of Grid; this property determines the number of visible (vs virtualized) columns.  */
  "width": PropTypes.number.isRequired
}), _temp);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Grid, "defaultProps", {
  'aria-label': 'grid',
  'aria-readonly': true,
  autoContainerWidth: false,
  autoHeight: false,
  autoWidth: false,
  cellRangeRenderer: __WEBPACK_IMPORTED_MODULE_15__defaultCellRangeRenderer__["a" /* default */],
  containerRole: 'rowgroup',
  containerStyle: {},
  estimatedColumnSize: 100,
  estimatedRowSize: 30,
  getScrollbarSize: __WEBPACK_IMPORTED_MODULE_16_dom_helpers_scrollbarSize__["a" /* default */],
  noContentRenderer: renderNull,
  onScroll: function onScroll() {},
  onScrollbarPresenceChange: function onScrollbarPresenceChange() {},
  onSectionRendered: function onSectionRendered() {},
  overscanColumnCount: 0,
  overscanIndicesGetter: __WEBPACK_IMPORTED_MODULE_13__defaultOverscanIndicesGetter__["c" /* default */],
  overscanRowCount: 10,
  role: 'grid',
  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
  scrollToAlignment: 'auto',
  scrollToColumn: -1,
  scrollToRow: -1,
  style: {},
  tabIndex: 0,
  isScrollingOptOut: false
});

Object(__WEBPACK_IMPORTED_MODULE_17_react_lifecycles_compat__["a" /* polyfill */])(Grid);
/* harmony default export */ __webpack_exports__["a"] = (Grid);
















/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(2190);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SCROLL_DIRECTION_BACKWARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SCROLL_DIRECTION_FORWARD; });
/* unused harmony export SCROLL_DIRECTION_HORIZONTAL */
/* unused harmony export SCROLL_DIRECTION_VERTICAL */
/* harmony export (immutable) */ __webpack_exports__["c"] = defaultOverscanIndicesGetter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(15);
var SCROLL_DIRECTION_BACKWARD = -1;
var SCROLL_DIRECTION_FORWARD = 1;
var SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var SCROLL_DIRECTION_VERTICAL = 'vertical';
/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */

function defaultOverscanIndicesGetter(_ref) {
  var cellCount = _ref.cellCount,
      overscanCellsCount = _ref.overscanCellsCount,
      scrollDirection = _ref.scrollDirection,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;

  if (scrollDirection === SCROLL_DIRECTION_FORWARD) {
    return {
      overscanStartIndex: Math.max(0, startIndex),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  } else {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex)
    };
  }
}



/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultCellRangeRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(15);
/**
 * Default implementation of cellRangeRenderer used by Grid.
 * This renderer supports cell-caching while the user is scrolling.
 */
function defaultCellRangeRenderer(_ref) {
  var cellCache = _ref.cellCache,
      cellRenderer = _ref.cellRenderer,
      columnSizeAndPositionManager = _ref.columnSizeAndPositionManager,
      columnStartIndex = _ref.columnStartIndex,
      columnStopIndex = _ref.columnStopIndex,
      deferredMeasurementCache = _ref.deferredMeasurementCache,
      horizontalOffsetAdjustment = _ref.horizontalOffsetAdjustment,
      isScrolling = _ref.isScrolling,
      isScrollingOptOut = _ref.isScrollingOptOut,
      parent = _ref.parent,
      rowSizeAndPositionManager = _ref.rowSizeAndPositionManager,
      rowStartIndex = _ref.rowStartIndex,
      rowStopIndex = _ref.rowStopIndex,
      styleCache = _ref.styleCache,
      verticalOffsetAdjustment = _ref.verticalOffsetAdjustment,
      visibleColumnIndices = _ref.visibleColumnIndices,
      visibleRowIndices = _ref.visibleRowIndices;
  var renderedCells = []; // Browsers have native size limits for elements (eg Chrome 33M pixels, IE 1.5M pixes).
  // User cannot scroll beyond these size limitations.
  // In order to work around this, ScalingCellSizeAndPositionManager compresses offsets.
  // We should never cache styles for compressed offsets though as this can lead to bugs.
  // See issue #576 for more.

  var areOffsetsAdjusted = columnSizeAndPositionManager.areOffsetsAdjusted() || rowSizeAndPositionManager.areOffsetsAdjusted();
  var canCacheStyle = !isScrolling && !areOffsetsAdjusted;

  for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
    var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);

    for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
      var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
      var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
      var key = "".concat(rowIndex, "-").concat(columnIndex);
      var style = void 0; // Cache style objects so shallow-compare doesn't re-render unnecessarily.

      if (canCacheStyle && styleCache[key]) {
        style = styleCache[key];
      } else {
        // In deferred mode, cells will be initially rendered before we know their size.
        // Don't interfere with CellMeasurer's measurements by setting an invalid size.
        if (deferredMeasurementCache && !deferredMeasurementCache.has(rowIndex, columnIndex)) {
          // Position not-yet-measured cells at top/left 0,0,
          // And give them width/height of 'auto' so they can grow larger than the parent Grid if necessary.
          // Positioning them further to the right/bottom influences their measured size.
          style = {
            height: 'auto',
            left: 0,
            position: 'absolute',
            top: 0,
            width: 'auto'
          };
        } else {
          style = {
            height: rowDatum.size,
            left: columnDatum.offset + horizontalOffsetAdjustment,
            position: 'absolute',
            top: rowDatum.offset + verticalOffsetAdjustment,
            width: columnDatum.size
          };
          styleCache[key] = style;
        }
      }

      var cellRendererParams = {
        columnIndex: columnIndex,
        isScrolling: isScrolling,
        isVisible: isVisible,
        key: key,
        parent: parent,
        rowIndex: rowIndex,
        style: style
      };
      var renderedCell = void 0; // Avoid re-creating cells while scrolling.
      // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
      // If a scroll is in progress- cache and reuse cells.
      // This cache will be thrown away once scrolling completes.
      // However if we are scaling scroll positions and sizes, we should also avoid caching.
      // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
      // For more info refer to issue #395
      //
      // If isScrollingOptOut is specified, we always cache cells.
      // For more info refer to issue #1028

      if ((isScrollingOptOut || isScrolling) && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
        if (!cellCache[key]) {
          cellCache[key] = cellRenderer(cellRendererParams);
        }

        renderedCell = cellCache[key]; // If the user is no longer scrolling, don't cache cells.
        // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
      } else {
        renderedCell = cellRenderer(cellRendererParams);
      }

      if (renderedCell == null || renderedCell === false) {
        continue;
      }

      if (false) {
        warnAboutMissingStyle(parent, renderedCell);
      }

      renderedCells.push(renderedCell);
    }
  }

  return renderedCells;
}

function warnAboutMissingStyle(parent, renderedCell) {
  if (false) {
    if (renderedCell) {
      // If the direct child is a CellMeasurer, then we should check its child
      // See issue #611
      if (renderedCell.type && renderedCell.type.__internalCellMeasurerFlag) {
        renderedCell = renderedCell.props.children;
      }

      if (renderedCell && renderedCell.props && renderedCell.props.style === undefined && parent.__warnedAboutMissingStyle !== true) {
        parent.__warnedAboutMissingStyle = true;
        console.warn('Rendered cell should include style property for positioning.');
      }
    }
  }
}



/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scrollbarSize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__canUseDOM__ = __webpack_require__(2194);

var size;
function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (__WEBPACK_IMPORTED_MODULE_0__canUseDOM__["a" /* default */]) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bpfrpt_proptype_ScrollIndices */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var bpfrpt_proptype_ScrollIndices =  true ? null : {
  "scrollToColumn": PropTypes.number.isRequired,
  "scrollToRow": PropTypes.number.isRequired
};



/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AutoSizer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vendor_detectElementResize__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);








var _class, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



var AutoSizer = (_temp = _class =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(AutoSizer, _React$Component);

  function AutoSizer() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, AutoSizer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(AutoSizer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      height: _this.props.defaultHeight || 0,
      width: _this.props.defaultWidth || 0
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_parentNode", void 0);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_autoSizer", void 0);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_window", void 0);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_detectElementResize", void 0);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_onResize", function () {
      var _this$props = _this.props,
          disableHeight = _this$props.disableHeight,
          disableWidth = _this$props.disableWidth,
          onResize = _this$props.onResize;

      if (_this._parentNode) {
        // Guard against AutoSizer component being removed from the DOM immediately after being added.
        // This can result in invalid style values which can result in NaN values if we don't handle them.
        // See issue #150 for more context.
        var height = _this._parentNode.offsetHeight || 0;
        var width = _this._parentNode.offsetWidth || 0;
        var win = _this._window || window;
        var style = win.getComputedStyle(_this._parentNode) || {};
        var paddingLeft = parseInt(style.paddingLeft, 10) || 0;
        var paddingRight = parseInt(style.paddingRight, 10) || 0;
        var paddingTop = parseInt(style.paddingTop, 10) || 0;
        var paddingBottom = parseInt(style.paddingBottom, 10) || 0;
        var newHeight = height - paddingTop - paddingBottom;
        var newWidth = width - paddingLeft - paddingRight;

        if (!disableHeight && _this.state.height !== newHeight || !disableWidth && _this.state.width !== newWidth) {
          _this.setState({
            height: height - paddingTop - paddingBottom,
            width: width - paddingLeft - paddingRight
          });

          onResize({
            height: height,
            width: width
          });
        }
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_setRef", function (autoSizer) {
      _this._autoSizer = autoSizer;
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(AutoSizer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var nonce = this.props.nonce;

      if (this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement) {
        // Delay access of parentNode until mount.
        // This handles edge-cases where the component has already been unmounted before its ref has been set,
        // As well as libraries like react-lite which have a slightly different lifecycle.
        this._parentNode = this._autoSizer.parentNode;
        this._window = this._autoSizer.parentNode.ownerDocument.defaultView; // Defer requiring resize handler in order to support server-side rendering.
        // See issue #41

        this._detectElementResize = Object(__WEBPACK_IMPORTED_MODULE_8__vendor_detectElementResize__["a" /* default */])(nonce, this._window);

        this._detectElementResize.addResizeListener(this._parentNode, this._onResize);

        this._onResize();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._detectElementResize && this._parentNode) {
        this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          className = _this$props2.className,
          disableHeight = _this$props2.disableHeight,
          disableWidth = _this$props2.disableWidth,
          style = _this$props2.style;
      var _this$state = this.state,
          height = _this$state.height,
          width = _this$state.width; // Outer div should not force width/height since that may prevent containers from shrinking.
      // Inner component should overflow and use calculated width/height.
      // See issue #68 for more information.

      var outerStyle = {
        overflow: 'visible'
      };
      var childParams = {};

      if (!disableHeight) {
        outerStyle.height = 0;
        childParams.height = height;
      }

      if (!disableWidth) {
        outerStyle.width = 0;
        childParams.width = width;
      }
      /**
       * TODO: Avoid rendering children before the initial measurements have been collected.
       * At best this would just be wasting cycles.
       * Add this check into version 10 though as it could break too many ref callbacks in version 9.
       * Note that if default width/height props were provided this would still work with SSR.
      if (
        height !== 0 &&
        width !== 0
      ) {
        child = children({ height, width })
      }
      */


      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        className: className,
        ref: this._setRef,
        style: _objectSpread({}, outerStyle, {}, style)
      }, children(childParams));
    }
  }]);

  return AutoSizer;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]), __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(_class, "propTypes",  true ? null : {
  /** Function responsible for rendering children.*/
  "children": PropTypes.func.isRequired,

  /** Optional custom CSS class name to attach to root AutoSizer element.  */
  "className": PropTypes.string,

  /** Default height to use for initial render; useful for SSR */
  "defaultHeight": PropTypes.number,

  /** Default width to use for initial render; useful for SSR */
  "defaultWidth": PropTypes.number,

  /** Disable dynamic :height property */
  "disableHeight": PropTypes.bool.isRequired,

  /** Disable dynamic :width property */
  "disableWidth": PropTypes.bool.isRequired,

  /** Nonce of the inlined stylesheet for Content Security Policy */
  "nonce": PropTypes.string,

  /** Callback to be invoked on-resize */
  "onResize": PropTypes.func.isRequired,

  /** Optional inline style */
  "style": PropTypes.object
}), _temp);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(AutoSizer, "defaultProps", {
  onResize: function onResize() {},
  disableHeight: false,
  disableWidth: false,
  style: {}
});




/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["a"] = createDetectElementResize;
/**
 * Detect Element Resize.
 * https://github.com/sdecima/javascript-detect-element-resize
 * Sebastian Decima
 *
 * Forked from version 0.5.3; includes the following modifications:
 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
 * 4) Add nonce for style element.
 * 5) Added support for injecting custom window object
 **/
function createDetectElementResize(nonce, hostWindow) {
  // Check `document` and `window` in case of server-side rendering
  var _window;

  if (typeof hostWindow !== 'undefined') {
    _window = hostWindow;
  } else if (typeof window !== 'undefined') {
    _window = window;
  } else if (typeof self !== 'undefined') {
    _window = self;
  } else {
    _window = global;
  }

  var attachEvent = typeof _window.document !== 'undefined' && _window.document.attachEvent;

  if (!attachEvent) {
    var requestFrame = function () {
      var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
        return _window.setTimeout(fn, 20);
      };

      return function (fn) {
        return raf(fn);
      };
    }();

    var cancelFrame = function () {
      var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
      return function (id) {
        return cancel(id);
      };
    }();

    var resetTriggers = function resetTriggers(element) {
      var triggers = element.__resizeTriggers__,
          expand = triggers.firstElementChild,
          contract = triggers.lastElementChild,
          expandChild = expand.firstElementChild;
      contract.scrollLeft = contract.scrollWidth;
      contract.scrollTop = contract.scrollHeight;
      expandChild.style.width = expand.offsetWidth + 1 + 'px';
      expandChild.style.height = expand.offsetHeight + 1 + 'px';
      expand.scrollLeft = expand.scrollWidth;
      expand.scrollTop = expand.scrollHeight;
    };

    var checkTriggers = function checkTriggers(element) {
      return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
    };

    var scrollListener = function scrollListener(e) {
      // Don't measure (which forces) reflow for scrolls that happen inside of children!
      if (e.target.className && typeof e.target.className.indexOf === 'function' && e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) {
        return;
      }

      var element = this;
      resetTriggers(this);

      if (this.__resizeRAF__) {
        cancelFrame(this.__resizeRAF__);
      }

      this.__resizeRAF__ = requestFrame(function () {
        if (checkTriggers(element)) {
          element.__resizeLast__.width = element.offsetWidth;
          element.__resizeLast__.height = element.offsetHeight;

          element.__resizeListeners__.forEach(function (fn) {
            fn.call(element, e);
          });
        }
      });
    };
    /* Detect CSS Animations support to detect element display/re-attach */


    var animation = false,
        keyframeprefix = '',
        animationstartevent = 'animationstart',
        domPrefixes = 'Webkit Moz O ms'.split(' '),
        startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
        pfx = '';
    {
      var elm = _window.document.createElement('fakeelement');

      if (elm.style.animationName !== undefined) {
        animation = true;
      }

      if (animation === false) {
        for (var i = 0; i < domPrefixes.length; i++) {
          if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
            pfx = domPrefixes[i];
            keyframeprefix = '-' + pfx.toLowerCase() + '-';
            animationstartevent = startEvents[i];
            animation = true;
            break;
          }
        }
      }
    }
    var animationName = 'resizeanim';
    var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
    var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
  }

  var createStyles = function createStyles(doc) {
    if (!doc.getElementById('detectElementResize')) {
      //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
      var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
          head = doc.head || doc.getElementsByTagName('head')[0],
          style = doc.createElement('style');
      style.id = 'detectElementResize';
      style.type = 'text/css';

      if (nonce != null) {
        style.setAttribute('nonce', nonce);
      }

      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(doc.createTextNode(css));
      }

      head.appendChild(style);
    }
  };

  var addResizeListener = function addResizeListener(element, fn) {
    if (attachEvent) {
      element.attachEvent('onresize', fn);
    } else {
      if (!element.__resizeTriggers__) {
        var doc = element.ownerDocument;

        var elementStyle = _window.getComputedStyle(element);

        if (elementStyle && elementStyle.position == 'static') {
          element.style.position = 'relative';
        }

        createStyles(doc);
        element.__resizeLast__ = {};
        element.__resizeListeners__ = [];
        (element.__resizeTriggers__ = doc.createElement('div')).className = 'resize-triggers';
        var resizeTriggersHtml = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';

        if (window.trustedTypes) {
          var staticPolicy = trustedTypes.createPolicy('react-virtualized-auto-sizer', {
            createHTML: function createHTML() {
              return resizeTriggersHtml;
            }
          });
          element.__resizeTriggers__.innerHTML = staticPolicy.createHTML('');
        } else {
          element.__resizeTriggers__.innerHTML = resizeTriggersHtml;
        }

        element.appendChild(element.__resizeTriggers__);
        resetTriggers(element);
        element.addEventListener('scroll', scrollListener, true);
        /* Listen for a css animation to detect element display/re-attach */

        if (animationstartevent) {
          element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
            if (e.animationName == animationName) {
              resetTriggers(element);
            }
          };

          element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
        }
      }

      element.__resizeListeners__.push(fn);
    }
  };

  var removeResizeListener = function removeResizeListener(element, fn) {
    if (attachEvent) {
      element.detachEvent('onresize', fn);
    } else {
      element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);

      if (!element.__resizeListeners__.length) {
        element.removeEventListener('scroll', scrollListener, true);

        if (element.__resizeTriggers__.__animationListener__) {
          element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);

          element.__resizeTriggers__.__animationListener__ = null;
        }

        try {
          element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
        } catch (e) {// Preact compat; see developit/preact-compat/issues/228
        }
      }
    }
  };

  return {
    addResizeListener: addResizeListener,
    removeResizeListener: removeResizeListener
  };
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(33)))

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CellMeasurer__ = __webpack_require__(2198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CellMeasurerCache__ = __webpack_require__(2199);
/* unused harmony reexport CellMeasurer */
/* unused harmony reexport CellMeasurerCache */


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__CellMeasurer__["a" /* default */]);


/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bpfrpt_proptype_CellMeasureCache */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var bpfrpt_proptype_CellMeasureCache =  true ? null : {
  "hasFixedWidth": PropTypes.func.isRequired,
  "hasFixedHeight": PropTypes.func.isRequired,
  "has": PropTypes.func.isRequired,
  "set": PropTypes.func.isRequired,
  "getHeight": PropTypes.func.isRequired,
  "getWidth": PropTypes.func.isRequired
};



/***/ }),
/* 876 */
/***/ (function(module, exports) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(876);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Grid__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_clsx__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__types__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);









var _class, _temp;




/**
 * It is inefficient to create and manage a large list of DOM elements within a scrolling container
 * if only a few of those elements are visible. The primary purpose of this component is to improve
 * performance by only rendering the DOM nodes that a user is able to see based on their current
 * scroll position.
 *
 * This component renders a virtualized list of elements with either fixed or dynamic heights.
 */

var List = (_temp = _class =
/*#__PURE__*/
function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(List, _React$PureComponent);

  function List() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, List);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(List)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "Grid", void 0);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_cellRenderer", function (_ref) {
      var parent = _ref.parent,
          rowIndex = _ref.rowIndex,
          style = _ref.style,
          isScrolling = _ref.isScrolling,
          isVisible = _ref.isVisible,
          key = _ref.key;
      var rowRenderer = _this.props.rowRenderer; // TRICKY The style object is sometimes cached by Grid.
      // This prevents new style objects from bypassing shallowCompare().
      // However as of React 16, style props are auto-frozen (at least in dev mode)
      // Check to make sure we can still modify the style before proceeding.
      // https://github.com/facebook/react/commit/977357765b44af8ff0cfea327866861073095c12#commitcomment-20648713

      var widthDescriptor = Object.getOwnPropertyDescriptor(style, 'width');

      if (widthDescriptor && widthDescriptor.writable) {
        // By default, List cells should be 100% width.
        // This prevents them from flowing under a scrollbar (if present).
        style.width = '100%';
      }

      return rowRenderer({
        index: rowIndex,
        style: style,
        isScrolling: isScrolling,
        isVisible: isVisible,
        key: key,
        parent: parent
      });
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_setRef", function (ref) {
      _this.Grid = ref;
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_onScroll", function (_ref2) {
      var clientHeight = _ref2.clientHeight,
          scrollHeight = _ref2.scrollHeight,
          scrollTop = _ref2.scrollTop;
      var onScroll = _this.props.onScroll;
      onScroll({
        clientHeight: clientHeight,
        scrollHeight: scrollHeight,
        scrollTop: scrollTop
      });
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_onSectionRendered", function (_ref3) {
      var rowOverscanStartIndex = _ref3.rowOverscanStartIndex,
          rowOverscanStopIndex = _ref3.rowOverscanStopIndex,
          rowStartIndex = _ref3.rowStartIndex,
          rowStopIndex = _ref3.rowStopIndex;
      var onRowsRendered = _this.props.onRowsRendered;
      onRowsRendered({
        overscanStartIndex: rowOverscanStartIndex,
        overscanStopIndex: rowOverscanStopIndex,
        startIndex: rowStartIndex,
        stopIndex: rowStopIndex
      });
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(List, [{
    key: "forceUpdateGrid",
    value: function forceUpdateGrid() {
      if (this.Grid) {
        this.Grid.forceUpdate();
      }
    }
    /** See Grid#getOffsetForCell */

  }, {
    key: "getOffsetForRow",
    value: function getOffsetForRow(_ref4) {
      var alignment = _ref4.alignment,
          index = _ref4.index;

      if (this.Grid) {
        var _this$Grid$getOffsetF = this.Grid.getOffsetForCell({
          alignment: alignment,
          rowIndex: index,
          columnIndex: 0
        }),
            scrollTop = _this$Grid$getOffsetF.scrollTop;

        return scrollTop;
      }

      return 0;
    }
    /** CellMeasurer compatibility */

  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender(_ref5) {
      var columnIndex = _ref5.columnIndex,
          rowIndex = _ref5.rowIndex;

      if (this.Grid) {
        this.Grid.invalidateCellSizeAfterRender({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }
    /** See Grid#measureAllCells */

  }, {
    key: "measureAllRows",
    value: function measureAllRows() {
      if (this.Grid) {
        this.Grid.measureAllCells();
      }
    }
    /** CellMeasurer compatibility */

  }, {
    key: "recomputeGridSize",
    value: function recomputeGridSize() {
      var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref6$columnIndex = _ref6.columnIndex,
          columnIndex = _ref6$columnIndex === void 0 ? 0 : _ref6$columnIndex,
          _ref6$rowIndex = _ref6.rowIndex,
          rowIndex = _ref6$rowIndex === void 0 ? 0 : _ref6$rowIndex;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }
    /** See Grid#recomputeGridSize */

  }, {
    key: "recomputeRowHeights",
    value: function recomputeRowHeights() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: index,
          columnIndex: 0
        });
      }
    }
    /** See Grid#scrollToPosition */

  }, {
    key: "scrollToPosition",
    value: function scrollToPosition() {
      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToPosition({
          scrollTop: scrollTop
        });
      }
    }
    /** See Grid#scrollToCell */

  }, {
    key: "scrollToRow",
    value: function scrollToRow() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToCell({
          columnIndex: 0,
          rowIndex: index
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          noRowsRenderer = _this$props.noRowsRenderer,
          scrollToIndex = _this$props.scrollToIndex,
          width = _this$props.width;
      var classNames = Object(__WEBPACK_IMPORTED_MODULE_10_clsx__["a" /* default */])('ReactVirtualized__List', className);
      return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Grid__["b" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, this.props, {
        autoContainerWidth: true,
        cellRenderer: this._cellRenderer,
        className: classNames,
        columnWidth: width,
        columnCount: 1,
        noContentRenderer: noRowsRenderer,
        onScroll: this._onScroll,
        onSectionRendered: this._onSectionRendered,
        ref: this._setRef,
        scrollToRow: scrollToIndex
      }));
    }
  }]);

  return List;
}(__WEBPACK_IMPORTED_MODULE_9_react__["PureComponent"]), __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_class, "propTypes",  true ? null : {
  "aria-label": PropTypes.string,

  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  "autoHeight": PropTypes.bool.isRequired,

  /** Optional CSS class name */
  "className": PropTypes.string,

  /**
   * Used to estimate the total height of a List before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  "estimatedRowSize": PropTypes.number.isRequired,

  /** Height constraint for list (determines how many actual rows are rendered) */
  "height": PropTypes.number.isRequired,

  /** Optional renderer to be used in place of rows when rowCount is 0 */
  "noRowsRenderer": function noRowsRenderer() {
    return (typeof bpfrpt_proptype_NoContentRenderer === "function" ? bpfrpt_proptype_NoContentRenderer.isRequired ? bpfrpt_proptype_NoContentRenderer.isRequired : bpfrpt_proptype_NoContentRenderer : PropTypes.shape(bpfrpt_proptype_NoContentRenderer).isRequired).apply(this, arguments);
  },

  /** Callback invoked with information about the slice of rows that were just rendered.  */
  "onRowsRendered": PropTypes.func.isRequired,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   */
  "onScroll": PropTypes.func.isRequired,

  /** See Grid#overscanIndicesGetter */
  "overscanIndicesGetter": function overscanIndicesGetter() {
    return (typeof bpfrpt_proptype_OverscanIndicesGetter === "function" ? bpfrpt_proptype_OverscanIndicesGetter.isRequired ? bpfrpt_proptype_OverscanIndicesGetter.isRequired : bpfrpt_proptype_OverscanIndicesGetter : PropTypes.shape(bpfrpt_proptype_OverscanIndicesGetter).isRequired).apply(this, arguments);
  },

  /**
   * Number of rows to render above/below the visible bounds of the list.
   * These rows can help for smoother scrolling on touch devices.
   */
  "overscanRowCount": PropTypes.number.isRequired,

  /** Either a fixed row height (number) or a function that returns the height of a row given its index.  */
  "rowHeight": function rowHeight() {
    return (typeof bpfrpt_proptype_CellSize === "function" ? bpfrpt_proptype_CellSize.isRequired ? bpfrpt_proptype_CellSize.isRequired : bpfrpt_proptype_CellSize : PropTypes.shape(bpfrpt_proptype_CellSize).isRequired).apply(this, arguments);
  },

  /** Responsible for rendering a row given an index; ({ index: number }): node */
  "rowRenderer": function rowRenderer() {
    return (typeof bpfrpt_proptype_RowRenderer === "function" ? bpfrpt_proptype_RowRenderer.isRequired ? bpfrpt_proptype_RowRenderer.isRequired : bpfrpt_proptype_RowRenderer : PropTypes.shape(bpfrpt_proptype_RowRenderer).isRequired).apply(this, arguments);
  },

  /** Number of rows in list. */
  "rowCount": PropTypes.number.isRequired,

  /** See Grid#scrollToAlignment */
  "scrollToAlignment": function scrollToAlignment() {
    return (typeof bpfrpt_proptype_Alignment === "function" ? bpfrpt_proptype_Alignment.isRequired ? bpfrpt_proptype_Alignment.isRequired : bpfrpt_proptype_Alignment : PropTypes.shape(bpfrpt_proptype_Alignment).isRequired).apply(this, arguments);
  },

  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  "scrollToIndex": PropTypes.number.isRequired,

  /** Vertical offset. */
  "scrollTop": PropTypes.number,

  /** Optional inline style */
  "style": PropTypes.object.isRequired,

  /** Tab index for focus */
  "tabIndex": PropTypes.number,

  /** Width of list */
  "width": PropTypes.number.isRequired
}), _temp);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(List, "defaultProps", {
  autoHeight: false,
  estimatedRowSize: 30,
  onScroll: function onScroll() {},
  noRowsRenderer: function noRowsRenderer() {
    return null;
  },
  onRowsRendered: function onRowsRendered() {},
  overscanIndicesGetter: __WEBPACK_IMPORTED_MODULE_8__Grid__["a" /* accessibilityOverscanIndicesGetter */],
  overscanRowCount: 10,
  scrollToAlignment: 'auto',
  scrollToIndex: -1,
  style: {}
});















/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultCellDataGetter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(215);
/**
 * Default accessor for returning a cell value for a given attribute.
 * This function expects to operate on either a vanilla Object or an Immutable Map.
 * You should override the column's cellDataGetter if your data is some other type of object.
 */
function defaultCellDataGetter(_ref) {
  var dataKey = _ref.dataKey,
      rowData = _ref.rowData;

  if (typeof rowData.get === 'function') {
    return rowData.get(dataKey);
  } else {
    return rowData[dataKey];
  }
}


/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultCellRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(215);
/**
 * Default cell renderer that displays an attribute as a simple string
 * You should override the column's cellRenderer if your data is some other type of object.
 */
function defaultCellRenderer(_ref) {
  var cellData = _ref.cellData;

  if (cellData == null) {
    return '';
  } else {
    return String(cellData);
  }
}


/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultHeaderRowRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);

function defaultHeaderRowRenderer(_ref) {
  var className = _ref.className,
      columns = _ref.columns,
      style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
    className: className,
    role: "row",
    style: style
  }, columns);
}
defaultHeaderRowRenderer.propTypes =  true ? null : bpfrpt_proptype_HeaderRowRendererParams === PropTypes.any ? {} : bpfrpt_proptype_HeaderRowRendererParams;



/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultHeaderRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SortIndicator__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);



/**
 * Default table header renderer.
 */
function defaultHeaderRenderer(_ref) {
  var dataKey = _ref.dataKey,
      label = _ref.label,
      sortBy = _ref.sortBy,
      sortDirection = _ref.sortDirection;
  var showSortIndicator = sortBy === dataKey;
  var children = [__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", {
    className: "ReactVirtualized__Table__headerTruncatedText",
    key: "label",
    title: typeof label === 'string' ? label : null
  }, label)];

  if (showSortIndicator) {
    children.push(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__SortIndicator__["a" /* default */], {
      key: "SortIndicator",
      sortDirection: sortDirection
    }));
  }

  return children;
}
defaultHeaderRenderer.propTypes =  true ? null : bpfrpt_proptype_HeaderRendererParams === PropTypes.any ? {} : bpfrpt_proptype_HeaderRendererParams;



/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SortIndicator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_clsx__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SortDirection__ = __webpack_require__(287);




/**
 * Displayed beside a header to indicate that a Table is currently sorted by this column.
 */

function SortIndicator(_ref) {
  var sortDirection = _ref.sortDirection;
  var classNames = Object(__WEBPACK_IMPORTED_MODULE_0_clsx__["a" /* default */])('ReactVirtualized__Table__sortableHeaderIcon', {
    'ReactVirtualized__Table__sortableHeaderIcon--ASC': sortDirection === __WEBPACK_IMPORTED_MODULE_3__SortDirection__["a" /* default */].ASC,
    'ReactVirtualized__Table__sortableHeaderIcon--DESC': sortDirection === __WEBPACK_IMPORTED_MODULE_3__SortDirection__["a" /* default */].DESC
  });
  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("svg", {
    className: classNames,
    width: 18,
    height: 18,
    viewBox: "0 0 24 24"
  }, sortDirection === __WEBPACK_IMPORTED_MODULE_3__SortDirection__["a" /* default */].ASC ? __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("path", {
    d: "M7 14l5-5 5 5z"
  }) : __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("path", {
    d: "M7 10l5 5 5-5z"
  }), __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}
SortIndicator.propTypes =  false ? {
  sortDirection: PropTypes.oneOf([SortDirection.ASC, SortDirection.DESC])
} : {};

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultRowRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);



/**
 * Default row renderer for Table.
 */
function defaultRowRenderer(_ref) {
  var className = _ref.className,
      columns = _ref.columns,
      index = _ref.index,
      key = _ref.key,
      onRowClick = _ref.onRowClick,
      onRowDoubleClick = _ref.onRowDoubleClick,
      onRowMouseOut = _ref.onRowMouseOut,
      onRowMouseOver = _ref.onRowMouseOver,
      onRowRightClick = _ref.onRowRightClick,
      rowData = _ref.rowData,
      style = _ref.style;
  var a11yProps = {
    'aria-rowindex': index + 1
  };

  if (onRowClick || onRowDoubleClick || onRowMouseOut || onRowMouseOver || onRowRightClick) {
    a11yProps['aria-label'] = 'row';
    a11yProps.tabIndex = 0;

    if (onRowClick) {
      a11yProps.onClick = function (event) {
        return onRowClick({
          event: event,
          index: index,
          rowData: rowData
        });
      };
    }

    if (onRowDoubleClick) {
      a11yProps.onDoubleClick = function (event) {
        return onRowDoubleClick({
          event: event,
          index: index,
          rowData: rowData
        });
      };
    }

    if (onRowMouseOut) {
      a11yProps.onMouseOut = function (event) {
        return onRowMouseOut({
          event: event,
          index: index,
          rowData: rowData
        });
      };
    }

    if (onRowMouseOver) {
      a11yProps.onMouseOver = function (event) {
        return onRowMouseOver({
          event: event,
          index: index,
          rowData: rowData
        });
      };
    }

    if (onRowRightClick) {
      a11yProps.onContextMenu = function (event) {
        return onRowRightClick({
          event: event,
          index: index,
          rowData: rowData
        });
      };
    }
  }

  return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, a11yProps, {
    className: className,
    key: key,
    role: "row",
    style: style
  }), columns);
}
defaultRowRenderer.propTypes =  true ? null : bpfrpt_proptype_RowRendererParams === PropTypes.any ? {} : bpfrpt_proptype_RowRendererParams;



/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inherits__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__defaultHeaderRenderer__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__defaultCellRenderer__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__defaultCellDataGetter__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SortDirection__ = __webpack_require__(287);











/**
 * Describes the header and cell contents of a table column.
 */

var Column =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inherits___default()(Column, _React$Component);

  function Column() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Column);

    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_getPrototypeOf___default()(Column).apply(this, arguments));
  }

  return Column;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(Column, "defaultProps", {
  cellDataGetter: __WEBPACK_IMPORTED_MODULE_9__defaultCellDataGetter__["a" /* default */],
  cellRenderer: __WEBPACK_IMPORTED_MODULE_8__defaultCellRenderer__["a" /* default */],
  defaultSortDirection: __WEBPACK_IMPORTED_MODULE_10__SortDirection__["a" /* default */].ASC,
  flexGrow: 0,
  flexShrink: 1,
  headerRenderer: __WEBPACK_IMPORTED_MODULE_7__defaultHeaderRenderer__["a" /* default */],
  style: {}
});


Column.propTypes =  false ? {
  /** Optional aria-label value to set on the column header */
  'aria-label': PropTypes.string,

  /**
   * Callback responsible for returning a cell's data, given its :dataKey
   * ({ columnData: any, dataKey: string, rowData: any }): any
   */
  cellDataGetter: PropTypes.func,

  /**
   * Callback responsible for rendering a cell's contents.
   * ({ cellData: any, columnData: any, dataKey: string, rowData: any, rowIndex: number }): node
   */
  cellRenderer: PropTypes.func,

  /** Optional CSS class to apply to cell */
  className: PropTypes.string,

  /** Optional additional data passed to this column's :cellDataGetter */
  columnData: PropTypes.object,

  /** Uniquely identifies the row-data attribute corresponding to this cell */
  dataKey: PropTypes.any.isRequired,

  /** Optional direction to be used when clicked the first time */
  defaultSortDirection: PropTypes.oneOf([SortDirection.ASC, SortDirection.DESC]),

  /** If sort is enabled for the table at large, disable it for this column */
  disableSort: PropTypes.bool,

  /** Flex grow style; defaults to 0 */
  flexGrow: PropTypes.number,

  /** Flex shrink style; defaults to 1 */
  flexShrink: PropTypes.number,

  /** Optional CSS class to apply to this column's header */
  headerClassName: PropTypes.string,

  /**
   * Optional callback responsible for rendering a column header contents.
   * ({ columnData: object, dataKey: string, disableSort: boolean, label: node, sortBy: string, sortDirection: string }): PropTypes.node
   */
  headerRenderer: PropTypes.func.isRequired,

  /** Optional inline style to apply to this column's header */
  headerStyle: PropTypes.object,

  /** Optional id to set on the column header */
  id: PropTypes.string,

  /** Header label for this column */
  label: PropTypes.node,

  /** Maximum width of column; this property will only be used if :flexGrow is > 0. */
  maxWidth: PropTypes.number,

  /** Minimum width of column. */
  minWidth: PropTypes.number,

  /** Optional inline style to apply to cell */
  style: PropTypes.object,

  /** Flex basis (width) for this column; This value can grow or shrink based on :flexGrow and :flexShrink properties. */
  width: PropTypes.number.isRequired
} : {};

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IS_SCROLLING_TIMEOUT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WindowScroller; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_onScroll__ = __webpack_require__(2234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_dimensions__ = __webpack_require__(2235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__vendor_detectElementResize__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);








var _class, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







/**
 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var IS_SCROLLING_TIMEOUT = 150;

var getWindow = function getWindow() {
  return typeof window !== 'undefined' ? window : undefined;
};

var WindowScroller = (_temp = _class =
/*#__PURE__*/
function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(WindowScroller, _React$PureComponent);

  function WindowScroller() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, WindowScroller);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(WindowScroller)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_window", getWindow());

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_isMounted", false);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_positionFromTop", 0);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_positionFromLeft", 0);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_detectElementResize", void 0);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_child", void 0);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", _objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_10__utils_dimensions__["a" /* getDimensions */])(_this.props.scrollElement, _this.props), {
      isScrolling: false,
      scrollLeft: 0,
      scrollTop: 0
    }));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_registerChild", function (element) {
      if (element && !(element instanceof Element)) {
        console.warn('WindowScroller registerChild expects to be passed Element or null');
      }

      _this._child = element;

      _this.updatePosition();
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_onChildScroll", function (_ref) {
      var scrollTop = _ref.scrollTop;

      if (_this.state.scrollTop === scrollTop) {
        return;
      }

      var scrollElement = _this.props.scrollElement;

      if (scrollElement) {
        if (typeof scrollElement.scrollTo === 'function') {
          scrollElement.scrollTo(0, scrollTop + _this._positionFromTop);
        } else {
          scrollElement.scrollTop = scrollTop + _this._positionFromTop;
        }
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_registerResizeListener", function (element) {
      if (element === window) {
        window.addEventListener('resize', _this._onResize, false);
      } else {
        _this._detectElementResize.addResizeListener(element, _this._onResize);
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_unregisterResizeListener", function (element) {
      if (element === window) {
        window.removeEventListener('resize', _this._onResize, false);
      } else if (element) {
        _this._detectElementResize.removeResizeListener(element, _this._onResize);
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_onResize", function () {
      _this.updatePosition();
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "__handleWindowScrollEvent", function () {
      if (!_this._isMounted) {
        return;
      }

      var onScroll = _this.props.onScroll;
      var scrollElement = _this.props.scrollElement;

      if (scrollElement) {
        var scrollOffset = Object(__WEBPACK_IMPORTED_MODULE_10__utils_dimensions__["c" /* getScrollOffset */])(scrollElement);
        var scrollLeft = Math.max(0, scrollOffset.left - _this._positionFromLeft);
        var scrollTop = Math.max(0, scrollOffset.top - _this._positionFromTop);

        _this.setState({
          isScrolling: true,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        });

        onScroll({
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        });
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "__resetIsScrolling", function () {
      _this.setState({
        isScrolling: false
      });
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(WindowScroller, [{
    key: "updatePosition",
    value: function updatePosition() {
      var scrollElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.scrollElement;
      var onResize = this.props.onResize;
      var _this$state = this.state,
          height = _this$state.height,
          width = _this$state.width;
      var thisNode = this._child || __WEBPACK_IMPORTED_MODULE_8_react_dom__["findDOMNode"](this);

      if (thisNode instanceof Element && scrollElement) {
        var offset = Object(__WEBPACK_IMPORTED_MODULE_10__utils_dimensions__["b" /* getPositionOffset */])(thisNode, scrollElement);
        this._positionFromTop = offset.top;
        this._positionFromLeft = offset.left;
      }

      var dimensions = Object(__WEBPACK_IMPORTED_MODULE_10__utils_dimensions__["a" /* getDimensions */])(scrollElement, this.props);

      if (height !== dimensions.height || width !== dimensions.width) {
        this.setState({
          height: dimensions.height,
          width: dimensions.width
        });
        onResize({
          height: dimensions.height,
          width: dimensions.width
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var scrollElement = this.props.scrollElement;
      this._detectElementResize = Object(__WEBPACK_IMPORTED_MODULE_11__vendor_detectElementResize__["a" /* default */])();
      this.updatePosition(scrollElement);

      if (scrollElement) {
        Object(__WEBPACK_IMPORTED_MODULE_9__utils_onScroll__["a" /* registerScrollListener */])(this, scrollElement);

        this._registerResizeListener(scrollElement);
      }

      this._isMounted = true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var scrollElement = this.props.scrollElement;
      var prevScrollElement = prevProps.scrollElement;

      if (prevScrollElement !== scrollElement && prevScrollElement != null && scrollElement != null) {
        this.updatePosition(scrollElement);
        Object(__WEBPACK_IMPORTED_MODULE_9__utils_onScroll__["b" /* unregisterScrollListener */])(this, prevScrollElement);
        Object(__WEBPACK_IMPORTED_MODULE_9__utils_onScroll__["a" /* registerScrollListener */])(this, scrollElement);

        this._unregisterResizeListener(prevScrollElement);

        this._registerResizeListener(scrollElement);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var scrollElement = this.props.scrollElement;

      if (scrollElement) {
        Object(__WEBPACK_IMPORTED_MODULE_9__utils_onScroll__["b" /* unregisterScrollListener */])(this, scrollElement);

        this._unregisterResizeListener(scrollElement);
      }

      this._isMounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var _this$state2 = this.state,
          isScrolling = _this$state2.isScrolling,
          scrollTop = _this$state2.scrollTop,
          scrollLeft = _this$state2.scrollLeft,
          height = _this$state2.height,
          width = _this$state2.width;
      return children({
        onChildScroll: this._onChildScroll,
        registerChild: this._registerChild,
        height: height,
        isScrolling: isScrolling,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        width: width
      });
    }
  }]);

  return WindowScroller;
}(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"]), __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(_class, "propTypes",  true ? null : {
  /**
   * Function responsible for rendering children.
   * This function should implement the following signature:
   * ({ height, isScrolling, scrollLeft, scrollTop, width }) => PropTypes.element
   */
  "children": PropTypes.func.isRequired,

  /** Callback to be invoked on-resize: ({ height, width }) */
  "onResize": PropTypes.func.isRequired,

  /** Callback to be invoked on-scroll: ({ scrollLeft, scrollTop }) */
  "onScroll": PropTypes.func.isRequired,

  /** Element to attach scroll event listeners. Defaults to window. */
  "scrollElement": PropTypes.oneOfType([PropTypes.any, function () {
    return (typeof Element === "function" ? PropTypes.instanceOf(Element) : PropTypes.any).apply(this, arguments);
  }]),

  /**
   * Wait this amount of time after the last scroll event before resetting child `pointer-events`.
   */
  "scrollingResetTimeInterval": PropTypes.number.isRequired,

  /** Height used for server-side rendering */
  "serverHeight": PropTypes.number.isRequired,

  /** Width used for server-side rendering */
  "serverWidth": PropTypes.number.isRequired
}), _temp);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(WindowScroller, "defaultProps", {
  onResize: function onResize() {},
  onScroll: function onScroll() {},
  scrollingResetTimeInterval: IS_SCROLLING_TIMEOUT,
  scrollElement: getWindow(),
  serverHeight: 0,
  serverWidth: 0
});




/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_lodash__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_src_app_components_PanelFooter__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_Spinner__ = __webpack_require__(100);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}/*

props.onClose()

*/var BulkRegistrationPanelBase=(_class=function(_Component){_inherits(BulkRegistrationPanelBase,_Component);function BulkRegistrationPanelBase(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,BulkRegistrationPanelBase);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BulkRegistrationPanelBase.__proto__||Object.getPrototypeOf(BulkRegistrationPanelBase)).call.apply(_ref,[this].concat(args))),_this),_this.store=null,_initDefineProp(_this,'editing',_descriptor,_this),_this.handleClose=function(){_this.store.abort();var onClose=_this.props.onClose;if(onClose)onClose();},_this.handleSave=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(){var onClose;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:onClose=_this.props.onClose;_context.next=3;return _this.store.save();case 3:// if nothing's left -> close the panel
if(!__WEBPACK_IMPORTED_MODULE_4__build_node_modules_lodash___default.a.find(_this.store.items,function(item){return!_this.store.isItemEmpty(item);})){if(onClose)onClose();// only if there's no item left
}case 4:case'end':return _context.stop();}}},_callee,_this2);})),_this.renderRegistrationResult=function(){if(!_this.store){return null;}var t=_this.props.t;var _this$store=_this.store,successfulRegistrations=_this$store.successfulRegistrations,failedRegistrations=_this$store.failedRegistrations;return __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{style:{display:'flex',gap:'5px'}},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__["Fragment"],null,failedRegistrations.length>0&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{style:{backgroundColor:_this.store.itemColorMap['invalid'],padding:'5px',marginRight:0}},t('failed_registrations',{count:failedRegistrations.length})),successfulRegistrations.length>0&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{style:{backgroundColor:_this.store.itemColorMap['valid'],padding:'5px',marginLeft:0}},t('successful_registrations',{count:successfulRegistrations.length}))));},_this.renderPanelFooterContentAdditional=function(){return null;},_this.renderPanelFooterContent=function(){var t=_this.props.t;var successfulRegistrations=_this.store&&_this.store.successfulRegistrations.length>0&&_this.store.failedRegistrations.length===0;return __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx_react__["a" /* Observer */],{render:function render(){return __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_src_app_components_PanelFooter__["a" /* FooterContainer */],null,_this.editing&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{style:{display:'flex',marginRight:'auto',fontSize:'small',flexDirection:'column'}},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{style:{display:'flex',fontSize:'small',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_4__build_node_modules_lodash___default.a.filter(_this.store.columns,function(column){return column.footnote;}).map(function(column){return __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('span',{key:column.footnote_index,style:{marginLeft:column.footnote_index>1?'8px':'0'}},column.footnote_index,') ',column.footnote);})),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{style:{display:'flex',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{style:{backgroundColor:_this.store.itemColorMap['valid'],padding:'5px',margin:'5px',marginLeft:0}},t('valid_description')),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{style:{backgroundColor:_this.store.itemColorMap['duplicate'],padding:'5px',margin:'5px'}},t('duplicate_description')),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{style:{backgroundColor:_this.store.itemColorMap['invalid'],padding:'5px',margin:'5px',marginRight:0}},t('invalid_description'))))),_this.renderPanelFooterContentAdditional(),successfulRegistrations?__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Button__["f" /* DefaultButton */],{onClick:_this.handleSave,style:{marginRight:'8px',alignSelf:'flex-end'},disabled:!_this.canSave},_this.store.saving?t('Registering')+'...':t('Register')+(' ('+_this.store.validItemsCount+')'),_this.store.saving&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_Spinner__["a" /* Spinner */],{size:__WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_Spinner__["b" /* SpinnerSize */].xSmall,style:{paddingLeft:'10px'}})),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Button__["h" /* PrimaryButton */],{onClick:_this.handleClose,style:{alignSelf:'flex-end'}},t('Close'))):__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Button__["h" /* PrimaryButton */],{onClick:_this.handleSave,style:{marginRight:'8px',alignSelf:'flex-end'},disabled:!_this.canSave},_this.store.saving?t('Registering')+'...':t('Register')+(' ('+_this.store.validItemsCount+')'),_this.store.saving&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_Spinner__["a" /* Spinner */],{size:__WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_Spinner__["b" /* SpinnerSize */].xSmall,style:{paddingLeft:'10px'}})),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Button__["f" /* DefaultButton */],{onClick:_this.handleClose,style:{alignSelf:'flex-end'}},t('Cancel'))));}});},_temp),_possibleConstructorReturn(_this,_ret);}// BulkRegistrationStore()
_createClass(BulkRegistrationPanelBase,[{key:'canSave',get:function get(){return this.editing&&!this.store.saving&&this.store.validItemsCount>0;}}]);return BulkRegistrationPanelBase;}(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__["Component"]),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'editing',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_applyDecoratedDescriptor(_class.prototype,'canSave',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'canSave'),_class.prototype)),_class);/* harmony default export */ __webpack_exports__["a"] = (BulkRegistrationPanelBase);

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BulkRegistrationStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_src_app_helpers_emailValidator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_src_app_services_request__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value2,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var BulkRegistrationStore=(_class=function(){_createClass(BulkRegistrationStore,[{key:'mainFields',get:function get(){return __WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.pickBy(this.fields,function(field){return!field.additional;});}},{key:'additionalFields',get:function get(){return __WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.pickBy(this.fields,function(field){return field.additional;});}},{key:'hasAdditional',get:function get(){return __WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.some(this.fields,function(field){return field.additional;});}},{key:'count',get:function get(){return this.items.length;}// = new AbortController()
}]);function BulkRegistrationStore(user,sale,round,usedEmails,t){var _this=this;_classCallCheck(this,BulkRegistrationStore);this.fields={};this.columns=[];_initDefineProp(this,'items',_descriptor,this);_initDefineProp(this,'saving',_descriptor2,this);_initDefineProp(this,'saved',_descriptor3,this);_initDefineProp(this,'error',_descriptor4,this);_initDefineProp(this,'successfulRegistrations',_descriptor5,this);_initDefineProp(this,'failedRegistrations',_descriptor6,this);this.successfullyRegistered=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */])([]);this.failedRegistrations=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */])([]);this.isItemEmpty=this.isItemEmpty.bind(this);this.isItemValid=this.isItemValid.bind(this);this.user=user;this.sale=sale;this.round=round;this.usedEmails=usedEmails;this.t=t;var config=sale.root.saleConfig;this.fields=config.getRegistrationScheme.call(config,sale,t);this.columns=[{key:'_validation',width:25,minWidth:25}];if(config.bulkRegistrationEnableCheckboxes)this.columns.push({key:'_select',width:30,minWidth:30});else this.columns.push({key:'_remove',width:30,minWidth:30});__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.forOwn(this.mainFields,function(definition,fieldName){_this.columns.push(Object.assign({key:fieldName,fieldName:fieldName},_this.getColumnDefaultProps(definition),{title:t('field::'+fieldName)},definition));});if(this.hasAdditional){this.columns.push({key:'_additional',width:40,minWidth:40});}this.columns=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.concat(this.columns,config.uploadTypes.map(function(type,index){return{key:'uploadtype-'+type,title:t('uploadtype::'+type).substring(0,1),required:config.requiredUploadTypes.includes(type),index:index,width:60,minWidth:60,footnote:t('uploadtype::'+type)};}));if(config.enableOptionalUploads){this.columns=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.concat(this.columns,config.uploadTypes.map(function(type,index){return{key:'uploadtype-'+type,title:t('uploadtype::'+type).substring(0,1),optional:true,index:index,width:60,minWidth:60,footnote:t('uploadtype::'+type)+(' ('+t('Optional')+')')};}));}// assign footnotes indexes
var footnote=0;this.columns.forEach(function(column){column.footnote_index=column.footnote?++footnote:0;});}_createClass(BulkRegistrationStore,[{key:'getColumnDefaultProps',value:function getColumnDefaultProps(definition){switch(definition.type){case'combobox':case'dropdown':return{width:100,minWidth:60};case'checkbox':return{width:40,minWidth:40};default:return{width:200,minWidth:100};}}},{key:'reset',value:function reset(){this.successfullyRegistered.clear();this.failedRegistrations.clear();this.items.clear();this.saving=false;this.saved=false;this.error=false;}},{key:'abort',value:function abort(){if(this.savingAbortController)this.savingAbortController.abort();this.savingAbortController=null;}},{key:'save',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(){var _this2=this;var indexes,validItems,config,_sale$root,isMls,saleAgentData,offers,response,i;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:indexes=[];// indexes of valid items
this.items.forEach(function(item){item._error='';item._remove=false;});this.saved=false;this.error=false;validItems=this.validItems;validItems.forEach(function(item){return indexes.push(item._index);});this.savingAbortController=typeof window.AbortController!=='undefined'?new window.AbortController():null;config=this.sale.root.saleConfig;this.saving=true;this.successfullyRegistered.clear();_context.prev=10;_sale$root=this.sale.root,isMls=_sale$root.isMls,saleAgentData=_sale$root.saleAgentData;offers=validItems.map(function(item){// start with the base empty offer
var offer=config.createOffer.call(config,_this2.sale,_this2.round);// construct input offer values from the input row (=item)
var inputOffer={buyerData:{},offerData:{//TODO: offer_viewing: '',
optional_uploads:item.optionalUploads,required_uploads:item.requiredUploads},agentData:isMls?_this2.user.agentData():saleAgentData};if(item.integrations)inputOffer.integrations=item.integrations;/* example
          integrations = {
            onoffice: {
              id: 39,
              customer_name: "AuctionTech"
            }
          }
          */// process each field
__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.forOwn(_this2.fields,function(field,key){var targetArray=typeof field.target==='undefined'?[key]:Array.isArray(field.target)?field.target:[field.target];var value=typeof field.transform==='function'?field.transform(item[key],item)// transform the value if needed
:item[key];if(!!value||!field.additional){// do not send empty additional fields
targetArray.forEach(function(target){__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.set(inputOffer,target,value);});}});// merge it
return __WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.merge(offer,inputOffer);});_context.next=15;return Object(__WEBPACK_IMPORTED_MODULE_4__build_src_app_services_request__["e" /* post */])('/api/v2/registrations/bulk/'+this.sale.root.saleId,offers,this.sale.root.user.accessToken,this.savingAbortController?this.savingAbortController.signal:null);case 15:response=_context.sent;if(!this.savingAbortController||!this.savingAbortController.signal.aborted){// response = [{ successful: true|false, error: '' }, ...]
//console.log(response);
response.forEach(function(itemResponse,responseIndex){var index=indexes[responseIndex];if(itemResponse.successful){_this2.items[index]._remove=true;_this2.usedEmails.push(_this2.items[index].email);// add emails of successfully registered customers
_this2.successfulRegistrations.push(_this2.items[index]);}else{_this2.items[index]._error=itemResponse.error||'unknown';_this2.error=true;_this2.failedRegistrations.push(_this2.items[index]);}});i=0;while(i<this.items.length){if(this.items[i]._remove)this.remove(i);else i++;}}case 17:_context.prev=17;this.saving=false;this.saved=true;this.savingAbortController=null;if(this.onSave)this.onSave();return _context.finish(17);case 23:case'end':return _context.stop();}}},_callee,this,[[10,,17,23]]);}));function save(){return _ref.apply(this,arguments);}return save;}()},{key:'agentData',value:function agentData(){var user=this.root.user;var _user$claims=user.claims,name=_user$claims.name,family_name=_user$claims.family_name,given_name=_user$claims.given_name;var userName=family_name?given_name+' '+family_name:name;return{id:user.claims.agent_id,name:userName,signature:user.claims.signature||userName,email:user.claims.email,phone:user.claims.phone_number,locale:user.claims.locale,agency_name:user.claims.agency_name,agency_street:user.claims.agency_street,agency_house_number:user.claims.agency_house_number,agency_zip:user.claims.agency_zip,agency_city:user.claims.agency_city,office_id:user.claims.office_ids_allowed,sub:user.claims.sub,tenant:user.claims.tenant};}},{key:'isItemEmpty',value:function isItemEmpty(item){return!__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.find(this.columns,function(column){return column.fieldName&&item[column.fieldName]==='';});}},{key:'isItemValid',value:function isItemValid(item){// check required fields
return this.isItemComplete(item)&&!this.isItemDuplicate(item);}},{key:'isItemComplete',value:function isItemComplete(item){var _this3=this;// check required fields
if(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.find(Object.keys(this.fields),function(column){return _this3.fields[column].required&&!item[column];}))return false;// check email validity
if(!Object(__WEBPACK_IMPORTED_MODULE_3__build_src_app_helpers_emailValidator__["a" /* default */])(item.email))return false;return true;}},{key:'isItemDuplicate',value:function isItemDuplicate(item){if(this.usedEmails&&this.usedEmails.includes(item.email))return true;return __WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.find(this.items,function(_item,_index){return _item.email&&item.email&&_item.email.toLowerCase()===item.email.toLowerCase()&&_item._index<item._index;});}},{key:'clear',value:function clear(){this.items.clear();}},{key:'add',value:function add(){var _this4=this;var item=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.forOwn(this.fields,function(field,key){if(!item[key]){item[key]='';if(field.required){if(field.default)item[key]=field.default;else if(field.options&&field.options.length>0)item[key]=field.options[0];}}// for enumerations try to translate from localized values to keys
if(item[key]&&field.options){var _value=item[key].toString().toUpperCase();field.options.forEach(function(option){if(_value===option.toString().toUpperCase()||_value===_this4.t((field.localizationPrefixOverride||key)+'::'+option).toUpperCase())item[key]=option;});}});if(typeof item.optionalUploads==='undefined')item.optionalUploads=[];if(typeof item.requiredUploads==='undefined')item.requiredUploads=[];if(typeof item._selected==='undefined')item._selected=true;item._error='';item._index=this.items.length;var _item=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */])(item);this.items.push(_item);}},{key:'remove',value:function remove(index){this.items.splice(index,1);this.items.forEach(function(item,index){item._index=index;});}},{key:'change',value:function change(index,fieldName,value){this.items[index][fieldName]=value;}},{key:'changeUploads',value:function changeUploads(index,type,optional,isSelected){this._changeUploads(index,type,optional,isSelected);if(isSelected)this._changeUploads(index,type,!optional,!isSelected);}},{key:'_changeUploads',value:function _changeUploads(index,type,optional,isSelected){var uploads=optional?this.items[index].optionalUploads:this.items[index].requiredUploads;var i=uploads.indexOf(type);if(isSelected){if(i<0)uploads.push(type);}else if(i>=0)uploads.splice(i,1);}},{key:'itemColorMap',get:function get(){return{valid:'#dff6dd',duplicate:'#ffff99',invalid:'#ffb3b3'};}},{key:'validItems',get:function get(){var _this5=this;return __WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.filter(this.items,function(item){return item._selected&&_this5.isItemValid(item);});}},{key:'validItemsCount',get:function get(){var _this6=this;var count=0;this.items.forEach(function(item){if(item._selected&&_this6.isItemValid(item))count++;});return count;}}]);return BulkRegistrationStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'items',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */])([]);}}),_applyDecoratedDescriptor(_class.prototype,'count',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'count'),_class.prototype),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'saving',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'saved',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'error',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'successfulRegistrations',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */])([]);}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'failedRegistrations',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */])([]);}}),_applyDecoratedDescriptor(_class.prototype,'save',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'save'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'validItems',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'validItems'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'validItemsCount',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'validItemsCount'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'clear',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'clear'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'add',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'add'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'remove',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'remove'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'change',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'change'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'changeUploads',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'changeUploads'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'_changeUploads',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'_changeUploads'),_class.prototype)),_class);

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_office_ui_fabric_react_lib_Overlay__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_Icon__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_css__ = __webpack_require__(2277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_css__);
var OverlayMessage=function OverlayMessage(_ref){var iconName=_ref.iconName,_ref$message=_ref.message,message=_ref$message===undefined?'':_ref$message,buttonLabel=_ref.buttonLabel,t=_ref.t,_ref$onClick=_ref.onClick,onClick=_ref$onClick===undefined?function(){}:_ref$onClick;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_office_ui_fabric_react_lib_Overlay__["a" /* Overlay */],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'overlay'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'overlay-line'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_Icon__["Icon"],{iconName:iconName,className:'overlay-icon '+iconName})),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'overlay-line'},message),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'overlay-line'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Button__["h" /* PrimaryButton */],{onClick:onClick},buttonLabel||t('close')))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__build_src_app_components_Localization__["a" /* localizable */])(OverlayMessage));

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__de_json__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__de_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__de_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__de_AT_json__ = __webpack_require__(2282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__de_AT_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__de_AT_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__en_json__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__en_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__en_GB_json__ = __webpack_require__(2283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__en_GB_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__en_GB_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__en_US_json__ = __webpack_require__(2284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__en_US_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__en_US_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__en_ZA_json__ = __webpack_require__(2285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__en_ZA_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__en_ZA_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__es_json__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__es_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__es_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fi_json__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fi_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__fi_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fr_json__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fr_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__fr_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__it_CH_json__ = __webpack_require__(2286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__it_CH_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__it_CH_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__it_json__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__it_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__it_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ro_json__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ro_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ro_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__sl_json__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__sl_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__sl_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__en_BS_json__ = __webpack_require__(2287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__en_BS_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__en_BS_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__en_PR_json__ = __webpack_require__(2288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__en_PR_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__en_PR_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__de__ = __webpack_require__(2289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__en__ = __webpack_require__(2290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__en_ZA__ = __webpack_require__(2291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__es__ = __webpack_require__(2292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__fi__ = __webpack_require__(2293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__fr__ = __webpack_require__(2294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__it__ = __webpack_require__(2295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ro__ = __webpack_require__(2296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__sl__ = __webpack_require__(2297);
var messages={en:__WEBPACK_IMPORTED_MODULE_2__en_json___default.a,'en-GB':__WEBPACK_IMPORTED_MODULE_3__en_GB_json___default.a,'en-US':__WEBPACK_IMPORTED_MODULE_4__en_US_json___default.a,'en-ZA':__WEBPACK_IMPORTED_MODULE_5__en_ZA_json___default.a,'en-BS':__WEBPACK_IMPORTED_MODULE_13__en_BS_json___default.a,'en-PR':__WEBPACK_IMPORTED_MODULE_14__en_PR_json___default.a,de:__WEBPACK_IMPORTED_MODULE_0__de_json___default.a,'de-AT':__WEBPACK_IMPORTED_MODULE_1__de_AT_json___default.a,es:__WEBPACK_IMPORTED_MODULE_6__es_json___default.a,'es-ES':__WEBPACK_IMPORTED_MODULE_6__es_json___default.a,fi:__WEBPACK_IMPORTED_MODULE_7__fi_json___default.a,fr:__WEBPACK_IMPORTED_MODULE_8__fr_json___default.a,it:__WEBPACK_IMPORTED_MODULE_10__it_json___default.a,'it-CH':__WEBPACK_IMPORTED_MODULE_9__it_CH_json___default.a,ro:__WEBPACK_IMPORTED_MODULE_11__ro_json___default.a,sl:__WEBPACK_IMPORTED_MODULE_12__sl_json___default.a};var locales={en:__WEBPACK_IMPORTED_MODULE_16__en__["a" /* default */],'en-ZA':__WEBPACK_IMPORTED_MODULE_17__en_ZA__["a" /* default */],de:__WEBPACK_IMPORTED_MODULE_15__de__["a" /* default */],es:__WEBPACK_IMPORTED_MODULE_18__es__["a" /* default */],'es-ES':__WEBPACK_IMPORTED_MODULE_18__es__["a" /* default */],fi:__WEBPACK_IMPORTED_MODULE_19__fi__["a" /* default */],fr:__WEBPACK_IMPORTED_MODULE_20__fr__["a" /* default */],it:__WEBPACK_IMPORTED_MODULE_21__it__["a" /* default */],ro:__WEBPACK_IMPORTED_MODULE_22__ro__["a" /* default */],sl:__WEBPACK_IMPORTED_MODULE_23__sl__["a" /* default */]};/* harmony default export */ __webpack_exports__["a"] = ({messages:messages,locales:locales});

/***/ }),
/* 891 */
/***/ (function(module, exports) {

module.exports = {"active":"Aktiv","add":"Hinzufügen","additional_address":"Adresszusatz","additional_description":"Sonstige Beschreibung und wichtige Hinweise","additional_information_text":"Zusätzlicher Hinweistext","address":"Adresse","agent":"Makler","AgentProvisionForm::agent_commission":"Maklerprovision","AgentProvisionForm::fixed_amount":"Fix Betrag","AgentProvisionForm::fixed_amount_excluding_vat":"Fix Betrag (ohne MwSt)","AgentProvisionForm::no_commission":"Provisionsfrei","AgentProvisionForm::percentage":"Prozentsatz","AgentProvisionForm::percentage_excluding_vat":"Prozentsatz (ohne MwSt)","AgentProvisionForm::standard":"Standard","allowed_file_formats":"Bitte beachten Sie, dass nur die folgenden Dateiformate zugelassen sind: PDF, JPG und PNG.","and":"und","App::initializing":"Initialisierung","are_you_sure_this_action_cannot_be_undone":"Sind Sie sicher? Diese Aktion kann nicht rückgängig gemacht werden.","area_unit":"m²","auction_finals":"Auktionsfinale","AuctionFinalsList::no_offer_selected_for_awardwing_go_back_to_the_matrix_and_pick_some":"Kein Angebot für Awardwing ausgewählt, gehe zurück zur Matrix und wähle einige aus.","AuctionFinalsList::object_no":"Objekt-Nr.","AuctionFinalsList::selected_buyer":"Ausgewählter Käufer","AuctionFinalsList::total":"Gesamt","AuctionFinalsMatrix::awarded":"Zugewiesen","AuctionFinalsMatrix::clear_selection":"Auswahl löschen","AuctionFinalsMatrix::for_each_property_pick_the_best_available_offer":"Für jede Immobilie das beste verfügbare Angebot auswählen","AuctionFinalsMatrix::for_each_property_pick_the_highest_offer_if_it_is_the_most_preferred_offer_of_the_highest_bidder":"Für jede Immobilie das höchste Angebot auswählen, wenn es das am meisten bevorzugte Angebot des Höchstbietenden ist","AuctionFinalsMatrix::for_each_property_pick_the_highest_offer_if_the_highest_bidder_has_not_been_assigned_to_another_property_yet":"Wählen Sie für jede Immobilie das höchste Angebot aus, wenn der Höchstbietende nicht einer anderen Immobilie zugewiesen wurde","AuctionFinalsMatrix::position":"Position","AuctionFinalsMatrix::preference":"Präferenz","AuctionFinalsMatrix::property":"Eigenschaft","AuctionFinalsMatrix::select_best_offers":"Beste Angebote auswählen","AuctionFinalsMatrix::select_highest_offers":"Wählen Sie die höchsten Angebote aus","AuctionFinalsMatrix::select_preferred_highest_offers":"Wählen Sie die bevorzugten höchsten Angebote aus","AuctionFinalsMatrix::this_is_the_highest_offer_for_this_property_but_its_not_selected":"Dies ist das höchste Angebot für dieses Objekt, aber es ist nicht ausgewählt","AuctionFinalsMatrix::this_is_the_most_preferred_offer_for_this_buyer_but_its_not_selected":"Dies ist das am meisten bevorzugte Angebot für diesen Käufer, aber es ist nicht ausgewählt","AuctionFinalsPanel::confirm":"Bestätigen","AuctionFinalsPanel::continue":"Weiter","AuctionFinalsPanel::error_loading_data_from_server":"Fehler beim Laden der Daten vom Server","AuctionFinalsPanel::failed":"Gescheitert","AuctionFinalsPanel::report":"Bericht","AuctionFinalsPanel::review_winners":"Gewinner bewerten","AuctionFinalsPanel::select_winners":"Gewinner auswählen","AuctionFinalsPanel::succeeded":"Erfolgreich","AuctionFinalsTotals::awarded":"Zugewiesen","AuctionFinalsTotals::selected":"Ausgewählt","AuctionFinalsTotals::total":"Gesamt","audiencetype::bidders":"Bieter","audiencetype::everyone":"Alle","audiencetype::item_bidders":"Bieter","audiencetype::no_wishlist":"Ohne Wunschliste","audiencetype::non_bidders":"Nichtbieter","audiencetype::non_item_bidders":"Nichtbieter","audiencetype::wishlist":"Mit Wunschliste","AwardAllStep1::loading_offers_please_wait":"Angebote werden geladen, bitte warten","AwardStep1::choose_a_winner":"Wählen Sie den Käufer","AwardStep1::expiration_date":"Angebotsgültigkeit","AwardStep2::expiration_date":"Angebotsgültigkeit","AwardStep2::select_customers_to_reject_theirs_offer":"Wählen Sie diejenigen Angebote aus, die Sie endgültig ablehnen möchten.\nDiese abgelehnten Kunden erhalten automatisch eine entsprechende Benachrichtigung.\nAlle anderen Kunden, deren Angebot nicht abgelehnt wurde, erhalten bis zur Bestätigung des endgültigen Käufers keine weitere Nachricht. ","AwardStep2::this_text_will_appear_as_an_additional_note":"Dieser Text wird als zusätzlicher Hinweis in der Benachrichtigung an den Käufer angezeigt:","AwardStep4::reject_message":"Zusatznachricht an abgelehnte Kaufinteressenten","AwardStep4::this_text_will_appear_as_an_additional_note":"Dieser Text wird als zusätzlicher Hinweis in der Benachrichtigung angezeigt","AwardSummary::if_you_click_finish_you_confirm_the_winner":"Wenn Sie \"Abschließen\" klicken, wählen Sie den Käufer aus. Die ausgewählten Kaufinteressenten die Sie ausgewählt haben werden darüber benachrichtigt.","AwardSummary::rejected_customers_offers":"Abgelehnte Angebote","AwardSummary::selected_winner":"Ausgewählter Käufer","back":"Zurück","behalf_of":"Im Auftrag von","bid_amount":"Gebotshöhe","bidding_type":"Verfahrenstyp","BiddingSection::highest_bidder":"Höchstbietende","BiddingSection::round_opens_on":"Runde eröffnet am","BiddingSection::the_highest_offer":"Das höchste Angebot","BiddingSection::the_next_minimum_offer":"Das nächste mindest Angebot","BlockDialog::block":"Ablehnen","BlockDialog::block_agent":"Teilnahme ablehnen","BlockDialog::reason":"Grund für die Ablehnung","BulkRegistrationCsvPanel::back_to_mapping":"Zurück zum Mapping","BulkRegistrationCsvPanel::duplicate_description":"Datensatz bereits vorhanden","BulkRegistrationCsvPanel::import_from_csv_file":"CSV Upload","BulkRegistrationCsvPanel::invalid_description":"Datensatz unvollständig","BulkRegistrationCsvPanel::total_number_of_rows_count":"Gesamtzahl der Zeilen: {count}","BulkRegistrationCsvPanel::valid_description":"Datensatz vollständig","BulkRegistrationInventoryPanel::duplicate_description":"Datensatz bereits vorhanden","BulkRegistrationInventoryPanel::entries_with_duplicate_emails_count":"Bereits eingeladene Kaufinteressenten: {count}","BulkRegistrationInventoryPanel::importing":"Importieren","BulkRegistrationInventoryPanel::invalid_description":"Datensatz unvollständig","BulkRegistrationInventoryPanel::invalid_entries_count":"Ungültige Einträge: {count}","BulkRegistrationInventoryPanel::total_number_of_entries_count":"Gesamtzahl der Einträge: {count}","BulkRegistrationInventoryPanel::valid_description":"Datensatz vollständig","BulkRegistrationTable::already_registered":"Bereits registriert","BulkRegistrationTable::invalid_email":"Ungültige E-Mail","BulkRegistrationTable::saving_error":"Fehler beim Hochladen","BulkRegistrationTable::select__unselect_all":"Alle auswählen / abwählen","BuyerDocumentSelector::none":"Keine","BuyerDocumentSelector::not_required":"Nicht erforderlich","BuyerDocumentSelector::optional":"Optional","BuyerDocumentSelector::required":"Pflicht","buyertype::company":"Juristische Person","buyertype::entrepreneurs":"Einzelunternehmer","buyertype::private":"Privatperson","CallbackComponent::redirecting":"Umleitung","cancel":"Abbrechen","citizenship":"Staatsbürgerschaft","city":"Ort","close":"Schliessen","combobox_placeholder_free_text":"Wählen Sie eine Option aus der Liste oder geben Sie Ihre eigene an","Commands::accept":"Für weitere Runde bestätigen","Commands::all_offers":"Alle Angebote","Commands::approve":"Zum Verfahren zulassen","Commands::approveregistration":"Kunden freischalten","Commands::are_you_sure_this_action_can_not_be_undone":"Sind Sie sicher? Diese Aktion kann nicht rückgängig gemacht werden.","Commands::are_you_sure_to_block_user":"Sind Sie sicher? Hiermit wird der Kunde aus dem System ausgesperrt!","Commands::are_you_sure_to_close_the_sale":"Sind Sie sicher? Das Verfahren wird endgültig geschlossen.","Commands::are_you_sure_to_end_round_early":"Sind Sie sicher? Wenn Sie die Runde beenden können keine Angebote mehr abgegeben werden.","Commands::are_you_sure_to_end_round_early_sealed":"Sind Sie sicher? Wenn Sie die Runde beenden können keine Angebote mehr abgegeben und Angebotshöhe wird offengelegt.","Commands::award":"Kaufangebot annehmen","Commands::blank_offer":"Blankoangebot PDF","Commands::block_user":"Benutzer sperren","Commands::close_sale":"Angebotsverfahren schliessen","Commands::confirm":"Für den Kunden bestätigen (TAN)","Commands::delete_sale":"Angebotsverfahren löschen","Commands::download_documents":"Unterlagen runterladen","Commands::end_round_early":"Runde vorzeitig beenden","Commands::import_registrations_from_crm":"Import aus CRM","Commands::import_registrations_from_csv_file":"CSV Upload","Commands::import_registrations_from_onoffice":"onOffice Import","Commands::import_registrations_from_propstack":"Propstack Import","Commands::import_registrations_from_propup":"PropUp Import","Commands::invite_seller":"Verkäufer einladen","Commands::messaging":"Nachricht senden","Commands::new":"Neue Runde starten","Commands::offer":"Angebote","Commands::pdf_export":"Ausdrucken (PDF)","Commands::refuse":"Zurückweisen, weil mangelhaft","Commands::refuseregistration":"Kunden ablehnen","Commands::register_new_user":"Manuelle Eingabe","Commands::registration":"Anmeldungen","Commands::reject":"Endgültig ablehnen","Commands::round_close":"Vorzeitig beenden","Commands::round_open":"Runde öffnen","Commands::sale":"Angebotsverfahren","Commands::sale_wizard":"Rundenassistent","Commands::update_contact":"Kontakt aktualisieren","Commands::upload":"Angebot im Namen von Kunden hochladen","Commands::whitelisting":"MLS Konfiguration","company":"Firma","company_court":"Amtsgericht","company_id":"FN","company_name":"Firmenwortlaut","Confirmation::confirmation_expired":"Eingegebene TAN ist falsch oder abgelaufen","Confirmation::invalid_bid_value":"Kaufpreis ist zu niedrig","Confirmation::invalid_confirmation":"Eingegebene TAN ist falsch oder abgelaufen","Confirmation::sale_round_not_opened":"Ihr Angebot kann nicht angenommen werden, da die Runde bereits geschlossen ist","ConfirmAwardStep1::choose_a_winner":"Käufer auswählen","ConfirmAwardStep1::expiration_date":"Angebotsgültigkeit","ConfirmAwardStep1::reject_message":"Zusatznachricht an abgelehnte Kaufinteressenten","ConfirmAwardStep1::this_text_will_appear_as_an_additional_note":"Dieser Text wird als zusätzlicher Hinweis in der Benachrichtigung angezeigt","ConfirmAwardSummary::if_you_click_finish_you_confirm_the_winner":"Wenn Sie \"Abschließen\" klicken, bestätigen Sie den Käufer. Alle anderen Angebote werden zurückgewiesen und die Kunden benachrichtigt.","ConfirmAwardSummary::rejected_customers_offers":"Abgelehnte Angebote","ConfirmAwardSummary::selected_winner":"Ausgewählter Käufer","ContactPanel::update_contact":"Kontakt aktualisieren","costs":"Kosten","Countdown::das_verfahren_ist_beendet":"Das Verfahren ist beendet","CounterofferStep2:: please_define_the_next_round":"Bitte definieren Sie die nächste Runde","CounterofferStep2::validity_of_offers_set_to_the_same_value":"Gültigkeit von Angeboten auf denselben Wert gesetzt","CounterofferSummary::click_finish_to_start_a_new_round":"Klicken Sie auf Fertig stellen, um eine neue Runde zu beginnen","CounterofferSummary::customers_for_the_next_round":"Kunden auswählen, die an der nächsten Runde teilnehmen sollen","CounterofferSummary::customers_not_participating_in_the_next_round":"Kunden auswählen, die nicht an der nächsten Runde teilnehmen sollen","CounterofferSummary::round_details":"Rundendetails","country":"Land","created_on":"Erstellt am","CsvMappingTable::do_not_import":"nicht importieren","customer":"Kaufinteressent","customer_buyer_reference_of_name":"Kaufinteressent {buyer_reference} von {name}","customer_name":"Kundenname","customer_of_name":"Kaufinteressent von {name}","Dashboard::authorization_in_progress":"Authorizierung","Dashboard::customer_service_contact":"Kundenservice","Dashboard::customer_service_email":"support@propnow.com","Dashboard::customer_service_p":"Bei Fragen oder Problemen können Sie uns wie folgt erreichen:","Dashboard::customer_service_telephone":"+49 30 959992518","Dashboard::customer_service_telephone_href":"+49 30 959992518","Dashboard::do_you_really_want_to_log_out":"Wollen Sie sich wirklich abmelden?","Dashboard::log_out":"Abmelden","Dashboard::tel__sms__whatsapp":"Telefon","date":"Datum","date_of_birth":"Geburtsdatum","DateField::dateformat":"dd.mm.jjjj","DateField::invalid_date":"Ungültiges Datum","days":"Tage","delete":"Löschen","deposit_payment_deadline":"Reservationszahlung überweisen bis","depositRequired::false":"Nein","depositRequired::true":"Ja","doc_from":"vom","Doc::from":"vom","Doc::no_type":"Bitte Dokumentenart zuweisen","Doc::original_name":"Hochgeladen als {originalFilename} am {uploadedAt, date, medium} {uploadedAt, time, medium}","documents":"Unterlagen","documenttype::annual_statement":"Jahresabrechnung","documenttype::appraisal":"Nutzwertgutachten","documenttype::area_allocation_plan":"Flächenwidmungsplan","documenttype::building_permit":"Baubewilligung","documenttype::completion_display":"Fertigstellungsanzeige","documenttype::condominium_contract":"Wohnungseigentumsvertrag","documenttype::energy_certificate":"Energieausweis","documenttype::expose":"Exposé","documenttype::expose_long":"Immobilienbeschreibung (Exposé)","documenttype::land_register":"Grundbuchauszug","documenttype::loan_agreement":"Darlehensvertrag","documenttype::operating_costs":"Betriebskosten","documenttype::operating_costs_long":"Betriebskosten/Erhaltungs - und Verbesserungskosten-Vorausschau im Sinne § 20 Abs. 2 WEG","documenttype::promissory_note":"Schuldschein","documenttype::running_costs":"Vorschreibung der laufenden Kosten","documenttype::usage_permit":"Benützungsbewilligung","DuplicateStep1::agbs":"AGBs","DuplicateStep1::duplicating_sale":"Duplizieren des Angebotsverfahrens","DuplicateStep1::hint1":"Alle Angebotsformular-Bezogene Daten und Unterlagen werden übernommen","DuplicateStep1::hint2":"Danach können Sie die Angaben anpassen, Runde definieren und neue Interessenten einladen","DuplicateStep1::i_agree_to_the_link":"Ich stimme den {agbs} zu","DuplicateStep1::i_agree_with_terms_and_conditions":"Ich stimme den AGBs zu","DuplicateSummary::duplicating_sale":"Duplizieren des Angebotsverfahrens","duration":"Dauer","duration_type":"Fristen","durationtype::fixed":"Fix (Datum)","durationtype::flexible":"Flexibel (Dauer)","edit":"Bearbeiten","EditPanel::edit_offer_form":"Kaufangebotsformular vorbereiten","email":"E-Mail","email_failed":"E-Mail Benacharichtigung konnte nicht zugestellt werden","EmailField::invalid_email":"Die E-Mail Adresse ist nicht korrekt","encoding":"Codierung","Error::blocked":"Die Seite die Sie versuchen aufzurufen scheint nicht vorhanden zu sein, Entweder haben sie einen falschen Link oder das digital Angebotsverfahren wurde schon abgeschlossen. Weiter Objekte finden Sie unter:","failed_registrations":"Fehlgeschlagene Einladungen: {count}","false":"Nein","field::depositrequired":"Deposit","field::email":"E-Mail","field::firstname":"Vorname","field::lastname":"Nachname","field::locale":"Sprache","field::phone":"Mobilnummer","field::salutation":"Anrede","field::title":"Titel","fill_required_fields":"Bitte alle Pflichtfelder ausfüllen!","financing_required":"Finanzierung erforderlich","financing_secured":"Finanzierung gesichert","first_name":"Vorname","handover":"Übergabetermin","handovertype::key_handover":"Bei Schlüsselübergabe","handovertype::land_register":"Nach Eintrag im Grundbuchauszug","handovertype::money_transfer":"Nach Überweisung des Kaufpreises auf vordefiniertes Konto","handovertype::sale_contract":"Gemäß Kaufvertrag","hidden":"verdeckt","house_number":"Hausnummer","iban":"IBAN","iban_is_not_valid":"IBAN ist ungültig","image":"Bild","import":"Importieren","IncreaseStep1::all_other_offers_will_be_rejected":"Alle anderen Angebote werden abgelehnt und haben nicht die Möglichkeit an einer weiteren Runde teilzunehmen.","IncreaseStep1::expiration_date":"Angebotsgültigkeit","IncreaseStep1::invite_more_customers_after_start_of_next_round":"Nach Anfang der nächsten Runde werden Sie die Möglichkeit haben, weitere Interessenten einzuladen.","IncreaseStep1::select_customers":"Wählen Sie die Kunden aus, die an der nächsten Runde teilnehmen sollen.","IncreaseStep2::please_define_the_next_round":"Bitte definieren Sie die nächste Runde.","IncreaseStep2::validity_of_offers_set_to_the_same_value":"Der Zeitpunkt der Gültigkeit der Kaufangebote für die weiteren Angebote wurde automatisch auf den gleichen Wert wie bei der vorherigen Runde gesetzt.","IncreaseStep3::this_text_will_appear_as_an_additional_note":"Dieser Text wird als zusätzlicher Hinweis in der Benachrichtigung an den Kunden angezeigt:","IncreaseSummary::click_finish_to_start_a_new_round":"Wenn Sie \"Abschließen\" klicken, wird eine neue Runde gestartet und die Kunden werden informiert.","IncreaseSummary::customers_for_the_next_round":"Kunden für die nächste Runde","IncreaseSummary::customers_not_participating_in_the_next_round":"Kunden die nicht an der nächsten Runde teilnehmen","IncreaseSummary::round_details":"Rundendetails","is_master_sale":"(Projekt - Hauptverfahren / Anmeldung)","last_name":"Nachname","legal_entity":"juristische Person","legal_form":"Rechtsform","ListingsOverview::add_new_listing":"Neue Immobilie hinzufügen","ListingsOverview::agent":"Makler","ListingsOverview::approved_offers":"Zugelassene Interessenten","ListingsOverview::create_new_listing":"Neue Immobilie anlegen","ListingsOverview::end_date":"Enddatum","ListingsOverview::guide__you_should_add_a_new_listing":"Um ein Angebotsverfahren zu starten, müssen Sie zuerst eine Immobilie auswählen.","ListingsOverview::loading_listings":"Immobilien werden geladen","ListingsOverview::my_listings_overview":"Meine Angebotsverfahren","ListingsOverview::number":"Objekt Nr","ListingsOverview::pending_offers":"Offene Angebote","ListingsOverview::start_date":"Startdatum","loading":"Wird geladen","locale":"Sprache","locale::de":"Deutsch","locale::deat":"Deutsch","locale::dech":"Deutsch","locale::dede":"Deutsch","locale::en":"Englisch","locale::es":"Spanisch","locale::eses":"Spanisch","locale::fi":"Finnisch","locale::fifi":"Finnisch","locale::fr":"Französisch","locale::frch":"Französisch","locale::frlu":"Französisch","locale::it":"Italienisch","locale::itch":"Italienisch","locale::ro":"Rumänisch","locale::roro":"Rumänisch","locale::sl":"Slowenisch","locale::slsi":"Slowenisch","manage":"Verwalten","ManagePanel::administration":"Verwaltung","ManagePanel::my_data":"Meine Daten","ManagePanel::object_supervisor":"Objekt Betreuer","marital_status":"Familienstand","maritalstatus::divorced":"Geschieden","maritalstatus::married":"Verheiratet","maritalstatus::none":" ","maritalstatus::single":"Ledig","maritalstatus::widowed":"Verwitwet","message":"Nachricht","MessagingPanel::audience":"Empfänger","MessagingPanel::failed_to_send_the_message":"Die Nachricht konnte nicht gesendet werden","MessagingPanel::messaging":"Senden Sie eine benutzerdefinierte Nachricht","MessagingPanel::no_message_has_been_sent":"Es wurde keine Nachricht gesendet","MessagingPanel::number_of_failed_messages":"Anzahl fehlgeschlagener Nachrichten","MessagingPanel::number_of_successfully_sent_messages":"Anzahl erfolgreich gesendeter Nachrichten","MessagingPanel::subject":"Betreff","MessagingPanel::template":"Vorlage","MessagingPanel::text":"Text","mls":"MLS","mls::everyone":"MLS - für alle Makler verfügbar","Mls::loading_mls":"Laden von MLS Angebotsverfahren","Mls::no_sale_for_mls":"Derzeit ist kein Verkauf verfügbar","mls::none":"Verfahren nicht Teil von MLS","Mls::request_access":"An Angebotsverfahren teilnehmen","Mls::request_access_description":"Wollen Sie Zugang zu diesen Angebotsverfahren anfragen um Ihre Interessenten einladen zu können. Ihre Zugangsanfrage wird dann in Kürze vom Listing Agent bearbeitet und Sie werden per E-Mail sowie im Dashboard informiert.","mls::tenant":"MLS - nur für eigene Makler verfügbar","more":"mehr","name":"Name","next":"Weiter","no":"Nein","not_entered":"Nicht ausgefüllt","not_part_of_master_sale":"(kein Projekt - Individuelles Verfahren)","notary":"Vertragserrichter","notificationcaption::all_customers":"Alle Kunden","notificationcaption::customer":"Kunde","notificationcaption::customers_invited_to_the_next_round":"Kunden für die nächste Runde","notificationcaption::other_customers":"Andere Kunden","notificationcaption::seller":"Verkäufer","notificationcaption::winner":"Gewinner","notificationemailtemplate::cust_bid_refused":"Angebot zurückgewiesen","notificationemailtemplate::cust_highest_bidder":"Höchstbieter","notificationemailtemplate::cust_highest_bidder_changed":"Neues Höchstgebot","notificationemailtemplate::cust_invited":"Einladung","notificationemailtemplate::cust_message":"Nachricht","notificationemailtemplate::cust_offer_awarded":"Käufer ausgewählt","notificationemailtemplate::cust_offer_placed":"Angebot abgegeben","notificationemailtemplate::cust_offer_raised":"Angebot erhöht","notificationemailtemplate::cust_offer_refused":"Angebot zurückgewiesen","notificationemailtemplate::cust_outbid":"Angebot überboten","notificationemailtemplate::cust_outbid_antisniping":"Angebot überboten","notificationemailtemplate::cust_outbid_others":"Neues Höchstgebot","notificationemailtemplate::cust_phase_invite_closing":"Erinnerung - Registrationsphase","notificationemailtemplate::cust_phase_offer_starting":"Erinerrung - Angetbotsabgabe gestartet","notificationemailtemplate::cust_phase_wishlist_closing":"Erinnerung - Objektauswahl endet","notificationemailtemplate::cust_rejected_round_closed":"Angebot abgelehnt","notificationemailtemplate::cust_rejected_sold":"Angebot abgelehnt","notificationemailtemplate::cust_rejected_unsold":"Angebot abgelehnt","notificationemailtemplate::cust_round_closed":"Runde beendet","notificationemailtemplate::cust_round_closing":"Erinnerung","notificationemailtemplate::cust_round_edited":"Runde angepasst","notificationemailtemplate::cust_round_opened":"Runde geöffnet","NotificationPreview::no_notification_defined_for_the_selected_action":"Für die ausgewählte Aktion wird keine Benachrichtigung gesendet","notifications":"Benachrichtigungen","notificationservicestatus::delivered":"Zugestellt","notificationservicestatus::failed":"Gescheitert","notificationservicestatus::pending":"Anstehend","notificationservicestatus::sent":"Gesendet","NotificationsPanel::explanation":"Wenn Sie über die Aktivitäten zum Angebotsverfahren dieses Objektes per E-Mail und SMS benachrichtigt werden wollen, aktivieren Sie bitte die Funktion:","NotifySellerSummary::description":"Kaufangebote von folgenden Kunden werden direkt per E-Mail an den Verkäufer gesendet:","now":"Jetzt","null":"Nicht verfügbar","number":"Nummer","offer":"Angebot","offer_viewing":"Besichtigungstermin erfolgte am","offer_viewing_help":"Bitte leerlassen, falls noch nicht erfolgt","OfferDetailsForm::agreement_installer__lawyer":"Vertragserrichter/Rechtsanwalt","OfferDetailsForm::other_agreements":"Sonstige Vereinbarungen","OfferDetailsForm::purchase_offer_valid_until":"Kaufangebot gültig bis","OfferDetailsForm::purchase_price_gross":"Kaufpreis (lastenfrei)","OfferNotificationDetails::service_data":"Servicedaten","OfferNotificationsList::created_on":"Versendet am","OfferNotificationsList::error_loading":"Das Laden der Benachrichtigungsliste ist fehlgeschlagen","OfferNotificationsList::recipient":"Empfänger","OfferNotificationsList::service_status":"Servicestatus","OfferNotificationsList::template":"Betreff","OffersSection::hidden":"derzeit verdeckt","OffersSection::increase_offer_on_behalf_of_the_customer":"Angebot im Namen des Kunden erhöhen","OffersSection::invited_on":"Eingeladen am","OffersSection::submitted_at":"Abgegeben am","OffersSection::submitted_value":"Gebotshöhe","OffersSection::upload_offer_on_behalf_of_a_customer":"Angebot im Namen des Kunden abgeben","offerstatus::accepted":"Bestätigt","offerstatus::approved":"Zugelassen","offerstatus::awarded":"Angenommen","offerstatus::confirmed":"Abgegeben","offerstatus::invited":"Eingeladen","offerstatus::refused":"Zurückgewiesen","offerstatus::registrationconfirmed":"Warten auf Freischaltung","offerstatus::registrationsubmitted":"Registrierung","offerstatus::rejected":"Abgelehnt","offerstatus::submitted":"Vorbereitet","offerstatus::updated":"In Bearbeitung","ok":"OK","open":"Öffnen","optional":"Optional","other_agreements":"Sonstige Vereinbarungen","overview":"Übersicht","ownership":"Eigentumsform","ownershiptype::residential":"Wohnungseigentum","ownershiptype::share":"Anteilseigentum","ownershiptype::sole":"Alleineigentum","page_title":"PropNow - {friendly_name}","Page1::area":"Fläche","Page1::construction_year":"Baujahr","Page1::deed":"Grundbuch","Page1::deed_kg":"KG","Page1::energy_certificate":"Energieausweis","Page1::housing_subsidies":"Wohnbauförderung","Page1::object_number":"Objekt Nummer","Page1::ownership_share":"Anteil","Page1::ownership_total":"Gesamt","Page1::parcel_number":"GSt.Nr.","Page1::register_number":"Einlagezahl","Page1::usage_rules":"Benutzungsregelung","Page2::date_of_delivery_warranty":"Übergabetermin, Gewährleistung","Page2::date_of_delivery_warranty_contract":"Übergabetermin, Gewährleistung, Vertragserricher","Page2::exceptions":"Ausnahmen der Lastenfreiheit","Page2::handover_date":"Übergabetermin","Page2::mortgage":"Übernommene Lasten","Page2::mortgage_detail":"Übernommene Geldlasten bei","Page2::notary":"Vertragserrichter/Rechtsanwalt","Page2::vatliable_purchase":"MwSt.-pflichtiger Kauf","Page3::all_documents_must_have_a_type_set":"Bei einer oder mehreren Unterlagen wurde noch keine Dokumentenart zugewiesen.","Page3::choose_a_document_type_or_enter_description":"Bitte entsprechende Dokumentenart auswählen oder eigene Bezeichnung eintragen","Page3::document_type":"Unterlagenart","Page3::upload_following_documents":"Bitte mindestens folgende Unterlagen hochladen","peptype::family":"PEP-Familienmitglied","peptype::no":"Nein","peptype::related":"Hat ein Naheverhältnis zu einer PEP","peptype::yes":"Kaufinterresent ist eine PEP","person":"Person","phone_number":"Handynummer","phone_number_placeholder":"+49 150 0000 0000","phonenumbererror::invalid":"Die Telefonnummer ist ungültig","phonenumbererror::notmobile":"Bitte gültige Mobilnummer eintragen","place_of_birth":"Geburtsort","politically_exposed_person_pep":"Politisch exponierte Person (PEP)","post_code":"Postleitzahl","postal_code":"Postleitzahl","preview":"Vorschau","previous":"Zurück","previous_round":"Vorherige Runde","price_on_offer":"Preis gegen Angebot","price_on_request":"Preis auf Anfrage","private_person":"Privatperson","processing":"Wird bearbeitet","property_for_sale":"Kaufobjekt","provision":"Käuferprovision","ProvisionAck::i_have_taken_note_of_the_following_important_information":"Ich habe folgende wichtige Hinweise zur Kenntnis genommen","provisiontype::default":"Standard","provisiontype::fixed_amount":"Fix Betrag (ohne MwSt)","provisiontype::fixed_percentage":"Prozentsatz (ohne MwSt)","provisiontype::none":"Provisionsfrei","purchase_price":"Kaufpreis","recipient":"Empfänger","refresh":"Aktualisierung","RefuseDialog::explanation":"Informieren Sie den Interessenten über den Grund der Zurückweisung.","RefuseDialog::reason":"Begründung","RefuseDialog::refuse_an_offer":"Angebot zurückweisen","register":"Einladen","registering":"Lade ein","registration_disabled":"Einladung von Kaufinteressenten in dieses Angebotsverfahren ist zur Zeit nicht erlaubt (Einladungen sind nur in ein laufendes Angebotsverfahren möglich)","RegistrationPanel::already_registered":"Sie haben schon einen Kunden mit dieser E-Mail Adresse eingeladen!","RegistrationPanel::offer_viewing":"Immobilie wurde besichtigt am","RegistrationPanel::place_at":"Eingegangen am","RegistrationPanel::purchase_price_gross":"Kaufpreis (lastenfrei)","RegistrationPanel::register_new_user":"Neuen Interessenten einladen","RegistrationPanel::send_the_invitation_again":"Einladung erneut versenden","RegistrationPanel::upload_an_offer":"Angebot (im Kundennamen) hochladen","RegistrationPanel::upload_new_offer":"Neues Angebot im Namen des Kunden hochladen","RegistrationPanel::upload_offer":"Angebot hochladen","RejectSummary::click_finish_to_reject_all_offers":"Wenn Sie \"Abschließen\" klicken, werden alle Angebote abgelehnt und die Kunden informiert.","remove":"Entfernen","required_documents":"Erforderliche Unterlagen","round":"Runde","RoundEdit::allow_bidding_below_starting_price":"Angebote unter Startpreis zulassen","RoundEdit::allow_bidding_below_starting_price__tooltip":"Im offenen Verfahren können Interessenten normalerweise erst ab Startpreis bieten, was dazu führen kann, dass preissensiblere Kunden häufig nicht mitbieten. Mit dieser Option bieten Sie Interessenten die Möglichkeit, ein Angebot auch <u>unterhalb</u> des Startpreises abzugeben – aber oberhalb des vom Makler festgelegten (zunächst verdeckten) Mindestpreises. Dies hat den Vorteil, dass mehr Interessenten ein Angebot abgeben, da auch geringerpreisige Angebote zugelassen werden. Dies schafft ein breiteres Bieterfeld und kann dadurch die Verkaufschancen erhöhen. Alle Angebote unterhalb des Startpreises sind für andere Interessenten verdeckt, um einen negativen Anker-Effekt zu vermeiden. Erst Gebote ab Startpreis werden standardmäßig angezeigt, es sei denn, Sie aktivieren die Option „Angebote unter Startpreis anderen Bietern anzeigen“.","RoundEdit::allow_bidding_below_starting_price_hidden":"Angebote unter Startpreis zulassen (verdeckt)","RoundEdit::antisniping_notice":"Das Ende der Angebotsfrist wird automatisch um 15 Minuten verlängert, wenn innerhalb der letzten 15 Minuten vor Ende ein neues Angebot eingeht. Diese Verlängerung wiederholt sich solange, bis 15 Minuten lang kein weiteres Angebot mehr abgegeben wird.","RoundEdit::bidding_steps":"Mindestbietschritt","RoundEdit::bidding_steps__standard":"Standard Staffelung von Bietschritten","RoundEdit::bidding_steps__tooltip":"Dies ist der Mindesterhöhungsbetrag bei neuen Kaufangeboten. Jedes neue Angebot muss um mindestens diesen Betrag höher sein als das aktuelle Höchstgebot. Sollten Sie die Option „Gebote unter Höchstgebot zulassen“ gewählt haben, so bezieht sich der Mindestbietschritt auf das vorige Angebot des einzelnen Kunden, sollte dieser bereits ein Angebot abgegeben haben (weitere Information siehe Infobutton: „Gebote unter Höchstgebot zulassen“)","RoundEdit::bidding_type_tooltip":"Wählen Sie die Gebotsart","RoundEdit::counteroffer_value":"Vorgeschlagener Gegenangebotswert","RoundEdit::end_date_changed":"Alle eingeladenen Kunden und Makler werden über die Änderung des Endes des Angebotsverfahrens per E-Mail informiert.","RoundEdit::ends_at":"Ende des Angebotsverfahrens","RoundEdit::ends_at__tooltip":"Für das Ende des Angebotsverfahrens ist zu empfehlen, einen Zeitpunkt zu wählen, an welchem, die Interessenten verfügbar sind und sich an einem Ort mit guter Internetanbindung befinden (z.B. zu Hause). Frühe Abendstunden oder Wochenendtage funktionieren hier erfahrungsgemäss sehr gut. Bitte beachten Sie allerdings Feiertage oder Brückentage, wo Interessenten möglicherweise unterwegs sein könnten. Ausserdem ist es wichtig, Interessenten über den zeitlichen Ablauf zu informieren. Zum Ende der Bietzeit werden 72 Stunden, 24 Stunden und 60 Minuten vor geplantem Ablauf Erinnerungen an die eingeladenen Interessenten versendet. Wir empfehlen ebenfalls, dass Sie als Makler während der letzten Stunde vor Ende des Angebotsverfahrens telefonisch erreichbar sind und ggf. das Angebotsverfahren auch live über ihren Laptop oder Tablet mitverfolgen, damit Sie Interessenten bei möglichen Fragen oder Problemen (z.B. schlechte Internetverbindung des Interessenten) unterstützen können.","RoundEdit::estimate":"Richtpreis","RoundEdit::estimate__tooltip":"Der Richtpreis ist ein Preis, der dem Kaufinteressenten als Richtwert kommuniziert wird. Dies dient als Hilfestellung bei der Festlegung seines eigenen Angebotspreises. Wichtig: Der Richtpreis stellt keinen Mindestpreis dar. D.h. der Interessent kann auch ein Angebot unterhalb des Richtpreises abgeben.","RoundEdit::estimate_lower_than_startprice":"Minimumpreis kann nicht höher sein als der Richtpreis","RoundEdit::flexible_bidding":"Gebote unter Höchstgebot zulassen","RoundEdit::flexible_bidding__tooltip":"Im offenen Verfahren müssen Interessenten normalerweise mit jedem neuen Angebot immer auch ein neues Höchstgebot abgeben, was dazu führen kann, dass einzelne Interessenten frühzeitig aussteigen oder vielleicht gar nicht erst mitbieten. Mit Auswahl dieser flexiblen Biet-Option hat der Interessent die Möglichkeit, ein Angebot auch <u>unterhalb</u> des aktuellen Höchstgebotes abzugeben. Das neue Gebot muss allerdings <u>über</u> dem vorigen Gebotspreis des entsprechenden Kunden liegen, sollte dieser bereits ein Angebot abgegeben haben. Hierbei ist der Mindestbietschritt maßgeblich und wird nur <b>auf sein eigenes Gebot</b> angewendet. Vorteil dieser Biet-Option ist es, dass dadurch einzelne Interessenten häufiger bieten und ein stärkeres Mittelfeld entsteht, da Bieter nicht vorzeitig aussteigen. Dies kann die Verkaufschancen erhöhen, insbesondere bei wenigen Interessenten bzw. wenn der Startpreis etwas zu hoch ist.","RoundEdit::hide_highest_bid__bid_history_for_nonbidders":"Andere Angebote erst <strong>nach</strong> eigener Angebotsabgabe anzeigen","RoundEdit::hide_highest_bid__bid_history_for_nonbidders__tooltip":"Aus Gründen der Transparenz werden normalerweise im offenen Verfahren das aktuelle Höchstgebot, sowie alle abgegebenen Kaufangebote, allen Eingeladenen von vornherein angezeigt – auch bevor sie selbst ein Angebot abgeben haben. Dies kann in Einzelfällen dazu führen, dass einzelne Interessenten, abgeschreckt durch bereits sehr hohe Gebotspreise, erst gar kein Angebot abgeben, obwohl sie gerne ein Angebot abgegeben hätten. Um dies zu vermeiden und jeden Kaufwilligen zu motivieren ebenfalls ein Kaufangebot abzugeben, kann diese Biet-Option hilfreich sein.","RoundEdit::invalid_starting_price":"Bitte geben Sie einen gültigen Startpreis ein","RoundEdit::min_price":"Mindestpreis","RoundEdit::min_price__tooltip":"Mindestkaufpreis, den Interessent bieten muss. Wird nur angezeigt, wenn Interessent ein Angebot unterhalb dieses Preises abgeben möchte.","RoundEdit::min_price_lower_than_start":"Mindestpreis muss niedriger als Starpreis sein","RoundEdit::minimum_price":"Mindestpreis","RoundEdit::offer_validity":"Gültigkeit der Kaufangebote (Befristung)","RoundEdit::open_round_warning":"Im offenen Angebotsverfahren ist nur eine Runde vorgesehen und die Gebote werden für Alle offengelegt.","RoundEdit::please_enter_a_starting_price":"Bitte geben Sie einen Preis >0 an","RoundEdit::red_button_price":"Interner Reservepreis","RoundEdit::red_button_price__tooltip":"Dies ist der (geschätzte) Mindestpreis, bei dem der Eigentümer willens ist zu verkaufen. Dies ist ein rein interner Preis, der dem Kunden nicht kommuniziert wird und nur für den Makler sichtbar ist. Bei Erreichen dieses Preises wird der Makler sofort informiert.","RoundEdit::select_a_bidding_type":"Wählen Sie einen Verfahrenstyp aus","RoundEdit::show_bids_below_starting_price":"Angebote unter Startpreis anderen Bietern anzeigen","RoundEdit::show_bids_below_starting_price__tooltip":"Erst Gebote <u>ab</u> Startpreis werden standardmäßig angezeigt, es sei denn Sie aktivieren diese Option. Dann werden auch Gebote <u>unterhalb</u> des Startpreises angezeigt und Sie haben eine erhöhte Transparenz im weiteren Verkaufsprozess.","RoundEdit::simple_offer_duration_suggestion_notice":"Dies ist die vorgeschlagene befristete Gültigkeit der Kaufangebote. Der Kaufinteressent kann diese allerdings bei Abgabe seines Angebotes ändern","RoundEdit::start":"Start des Angebotsverfahrens","RoundEdit::start__tooltip":"Sollten Sie die Interessenten <u>vor</u> Start des Angebotsverfahrens (Bietfrist) einladen, können diese bereits Ihre Daten eintragen, die Objektunterlagen einsehen und ein Angebot <u>vorbereiten</u>. Das Angebot kann aber noch <u>nicht abgegeben</u> werden! Sobald der Startzeitpunkt erreicht ist und die Bietfrist des Angebotsverfahrens begonnen hat, erhalten alle eingeladenen Interessenten eine Benachrichtigung und können dann beginnen, ihre Kaufangebote abzugeben.<br /><br /> Tipp: Die durchschnittliche Länge des Angebotsverfahrens, also der Zeitraum, in dem Angebote abgegeben werden können (Bietfrist), beträgt ca. 5-7 Tage. Dies schafft ausreichend Momentum und stellt gleichzeitig sicher, dass einzelne Interessenten nicht das Interesse an der Immobilie verlieren (was im Falle einer zu lang gewählten Bietzeit geschehen kann). Der Zeitraum von 5-7 Tagen setzt allerdings auch voraus, dass alle Interessenten zum Startzeitpunkt des Angebotsverfahrens bereits von Ihnen als Makler ausreichend vorqualifiziert worden sind, inkl. Besichtigung der Immobilie und Abklärung der Finanzierungsmöglichkeiten. Sollte allerdings bei der Mehrzahl der Interessenten die Finanzierung noch unklar sein und Sie daher die Option „Finanzierungsbestätigung“ hochladen beim Einladen der Interessenten wählen, so wählen Sie dann ebenfalls eine etwas längere Laufzeit des Angebotsverfahrens, um Interessenten genügend Zeit zu geben, auch während des laufenden Verfahrens noch ihre Finanzierung abzuklären. Bei weiteren Fragen hierzu kontaktieren Sie gerne unser Team.","RoundEdit::starting_price":"Startpreis","RoundEdit::starting_price__tooltip":"Preis, den der Kaufinteressent bei Abgabe des ersten Angebotes mindestens bieten muss.","RoundEdit::time_of_day":"Uhrzeit","RoundInfo::ends":"Angebotsverfahren endet","RoundInfo::offer_validity":"Kaufangebote gültig","RoundInfo::starts":"Angebotsverfahren startet","RoundItem::badge_free":"Kostenlos","RoundItem::badge_new":"Neu","RoundItem::badge_separator":" & ","RoundItem::how_it_works":"So funktioniert’s","RoundItem::incremental_auction_costs":"","RoundItem::incremental_auction_howitworkspoints":"- Offene Gebote ab Startpreis\n- Mehrfaches Bieten möglich\n- Automatische Verlängerung bei Last-Minute Geboten\n<b>Neue flexible Bietmöglichkeiten:</b>\n- Möglichkeit, Gebote <u>unter Startpreis</u> zuzulassen\n- Gebotshöhe <u>frei wählbar</u> (oberhalb von Mindestpreis)\n- Nur Gebote über Startpreis werden angezeigt\n- Fester Start- und Endtermin","RoundItem::incremental_auction_subtitle":"mit flexiblem Bieten","RoundItem::incremental_auction_title":"Offenes Angebotsverfahren","RoundItem::incremental_auction_whentouseitpoints":"Wie normales „offenes“ Angebotsverfahren aber auch wenn:\n- Geringere Nachfrage\n- Preissensible Kunden\n- Startpreis weniger attraktiv\n- Preissteigerung unklar\n- Kunden mehr Flexibilität geben","RoundItem::open_bidding_costs":"","RoundItem::open_bidding_howitworkspoints":"- Der erste Bieter muss mindestens den Startpreis bieten\n- Jedes Gebot <b>muss höher sein als alle vorigen Angebote</b>\n- Jeder Kunde kann sein Angebot verbessern\n- Alle <b>Angebote sind sichtbar</b>\n- Kundennamen für andere Kunden anonymisiert\n- Expliziter Start und Ende der Verfahrens","RoundItem::open_bidding_subtitle":"mit aufsteigenden Geboten","RoundItem::open_bidding_title":"Offenes Angebotsverfahren","RoundItem::open_bidding_whentouseitpoints":"- Attraktiver Startpreis\n- Hohe Nachfrage\n- Marktwert der Immobilie über Startpreis\n- Preiserhöhung erwartet","RoundItem::sealed_bidding_costs":"","RoundItem::sealed_bidding_howitworkspoints":"- Richtpreis kein Mindestpreis\n- Gebotshöhe <u>frei wählbar</u> \n- Jeder Kunde kann nur <u>ein</u> Angebot abgeben\n- Bieter und Gebote <u>verdeckt</u>\n- Fester Endtermin\n- <u>Keine</u> automatische Verlängerung bei Last-Minute Geboten","RoundItem::sealed_bidding_subtitle":"mit versteckten Angeboten","RoundItem::sealed_bidding_title":"Geschlossenes Angebotsverfahren","RoundItem::sealed_bidding_whentouseitpoints":"- Geringe/unklare Nachfrage\n- Marktfeedback einholen\n- Vertrauliche Verkäufe, öffentliche Hand\n- Objekt schwer einwertbar","RoundItem::simple_offer_costs":"","RoundItem::simple_offer_howitworkspoints":"- Einfache digitale Angebotsabgabe\n- Listingpreis = Referenz\n- Angebotspreis <u>frei</u> wählbar\n- Kunde kann nur <u>ein</u> Angebot abgeben\n- Keine Information zu möglichen anderen Interessenten\n- Kein fester Endtermin\n- Möglichkeit, flexibel ins Offene Angebotsverfahren zu wechseln, wenn mehrere Kunden Angebote abgeben","RoundItem::simple_offer_subtitle":" ","RoundItem::simple_offer_title":"Digitales Kaufangebot","RoundItem::simple_offer_whentouseitpoints":"- Wenig Interessenten\n- Langer Verkaufsprozess\n- Kaufbereitschaft testen\n- Möglichkeit, Angebot unter Vorbehalt abzugeben","RoundItem::when_to_use_it":"Wann wird es genutzt","RoundPanel::round":"Runde bearbeiten","roundstatus::closed":"Beendet","roundstatus::opened":"Geöffnet","roundstatus::started":"Neu","roundtype::allow_conditions":"Angebotsabgabe unter Vorbehalt zulassen","roundtype::counteroffer_bidding":"Gegenangebot","roundtype::incremental_auction":"Offenes Angebotsverfahren","roundtype::open_bidding":"Offenes Angebotsverfahren","roundtype::sealed_bidding":"Geschlossenes Angebotsverfahren","roundtype::show_invited_customers_count":"Anzahl der Interessenten anzeigen","roundtype::show_invited_customers_count_tooltip":"Die Gesamtanzahl aller eingeladenen Kaufinteressenten wird jedem teilnehmenden Kunden angezeigt.","roundtype::simple_offer":"Digitales Kaufangebot","Sale::all_information_entered_by_customer_will_be_overwritten":"Alle Angaben die der Kunde schon gemacht hat werden überschrieben.","Sale::already_confirmed":"Dieser Kunde hat ein Kaufangebot abgegeben. Ein weiteres Angebot im Kundennamen ist nicht möglich.","Sale::billing_notice":" ","Sale::cannot_update_documents_for_open_round__documents_uploaded":"Folgende Unterlagen wurden hochgeladen:","Sale::cannot_update_documents_for_open_round__no_documents":"Sie haben keine Unterlagen hochgeladen.","Sale::do_you_want_to_open_the_round":"Wollen Sie die Runde öffnen?","Sale::guide__define_offer_form":"Im ersten Schritt müssen Sie die Objektdaten vervollständigen.","Sale::guide__edit_round":"Falls Sie vor Start noch etwas ändern möchten, können Sie dies hier tun:","Sale::guide__import_users_csv":"Sie können jetzt Kunden aus der CSV-Datei importieren","Sale::guide__invite_users":"Um einen Interessenten einzuladen, brauchen Sie seinen vollen Namen, seine E-Mail-Adresse und seine Handynummer.","Sale::guide__missing_mandatory_offer_form":"Bitte alle Pflichtfelder ausfüllen!","Sale::guide__open_round":"Um das digitale Angebotsverfahren zu starten und einzelne Kunden einzuladen, müssen Sie die Runde öffnen:","Sale::guide__start_round":"Als Nächstes bitte die Art der digitalen Kaufangebotsabgabe auswählen","Sale::guide__start_round_edit_sale":"Sie haben alle Pflichtfelder des Angebotsformulars ausgefüllt. Hier können Sie diese ggf. nochmal kontrollieren oder bearbeiten.","Sale::guide_action__edit_round":"Daten ändern","Sale::guide_action__edit_sale":"Kaufangebotsformular vorbereiten","Sale::guide_action__import_users_csv":"Kunden importieren","Sale::guide_action__invite_bidders":"Neuen Interessenten einladen","Sale::guide_action__open_round":"Runde öffnen","Sale::guide_action__start_round":"Neue Runde starten","Sale::guide_action__start_round_edit":"Kaufangebotsformular bearbeiten","Sale::guides__manage_the_sale":"Rundenassistent","Sale::guides__offers_present":"Sie können nun die \"Übersicht\" der Angebote mit dem Verkäufer besprechen und seine Entscheidung dann im \"Rundenassistenten\" eingeben.","Sale::guides__round_closed":"Die Angebotszeit ist beendet. Sie können nun die \"Übersicht\" der Angebote mit dem Verkäufer besprechen und seine Entscheidung dann im \"Rundenassistenten\" eingeben.","Sale::guides__show_overview":"Übersicht","Sale::guides__start_open_process":"Zum Angebotsverfahren wechseln","Sale::guides__upgrade":"Sie haben mehrere Angebote erhalten. Um das Verkaufsergebnis zu optimieren, können Sie zum Angebotsverfahren wechseln","Sale::invalid_bid_value":"Dieses Angebot kann nicht angenommen werden. Es liegt bereits ein höheres oder gleichwertiges vor. Bitte benachrichtigen Sie den Kunden, damit er sein Angebot anpassen kann.","Sale::loading_sale":"Die Immobilie wird geladen","Sale::no_estimate":"kein Richtpreis","Sale::no_starting_price":"kein Startpreis","Sale::open_round_deadline_today":"Ihr Verfahren endet schon voraussichtlich heute. Wollen Sie die Runde wirklich öffnen?","Sale::open_round_deadline_too_long":"Ihr Verfahren endet erst voraussichtlich in {durationInDays} Tagen. Wollen Sie die Runde wirklich öffnen?","Sale::open_round_info_invalid_duration":"Die Eröffnung eines Verfahrens, welches in der Vergangenheit endet, ist nicht möglich. Bitte passen Sie die Rundendaten an.","Sale::open_round_info_notice_incremental_auction_fixed":"Sie öffnen eine <strong>offene Runde</strong> mit <strong>Startpreis von {startPrice}</strong> die <strong>{duration}</strong> am {date} <strong>um {time} endet.</strong>","Sale::open_round_info_notice_incremental_auction_fixed_withstart":"Sie öffnen eine <strong>offene Runde </strong> mit <strong>Startpreis von {startPrice}</strong> und Bietstart <strong>{start}</strong> am <strong>{startDate} um {startTime}</strong>, die am <strong>{date} um {time}</strong> <strong>{biddingDuration}</strong> endet.","Sale::open_round_info_notice_incremental_auction_flexible":"Sie öffnen eine <strong>flexible</strong> Runde mit <strong>Startpreis von {startPrice}</strong> die <strong>{duration} Tagen</strong> nach Eingang vom ersten Angebot endet.</strong>","Sale::open_round_info_notice_openbidding_fixed":"Sie öffnen eine <strong>offene</strong> Runde mit <strong>Startpreis von {startPrice}</strong> die <strong>{duration}</strong> am {date} <strong>um {time} endet.</strong>","Sale::open_round_info_notice_openbidding_fixed_withstart":"Sie öffnen eine <strong>offene Runde</strong> mit <strong>Startpreis von {startPrice}</strong> und Bietstart <strong>{start}</strong> am <strong>{startDate} um {startTime}</strong>, die am <strong>{date} um {time}</strong> <strong>{biddingDuration}</strong> endet.","Sale::open_round_info_notice_openbidding_flexible":"Sie öffnen eine <strong>offene</strong> Runde mit <strong>Startpreis von {startPrice}</strong> die <strong>{duration} Tagen</strong> nach Eingang vom ersten Angebot endet.</strong>","Sale::open_round_info_notice_sealedbidding_fixed":"Sie öffnen eine <strong>geschlossene</strong> Runde mit <strong>Richtpreis von {estimate}</strong> die <strong>{duration}</strong> am {date} <strong>um {time} endet.</strong>","Sale::open_round_info_notice_sealedbidding_fixed_withstart":"Sie öffnen eine <strong>geschlossene </strong> Runde mit <strong>Richtpreis von {estimate}</strong> und Bietstart <strong>{start}</strong> am <strong>{startDate} um {startTime}</strong>, die am <strong>{date} um {time}</strong> <strong>{biddingDuration}</strong> endet.","Sale::open_round_info_notice_sealedbidding_flexible":"Sie öffnen eine <strong>geschlossene</strong> Runde mit <strong>Richtpreis von {estimate}</strong> die <strong>{duration} Tagen</strong> nach Eingang vom ersten Angebot endet.</strong>","Sale::open_round_info_notice_simple_offer_fixed":"Sie öffnen eine <strong>Digitale Kaufangebotsrunde</strong>.","Sale::open_round_info_notice_simple_offer_flexible":"Sie öffnen eine <strong>Digitale Kaufangebotsrunde</strong>.","Sale::sale_connection_unavailable":"Die Verbindung zu diesem Angebotsverfahren wurde unterbrochen. Bitte laden Sie die Seite neu.","Sale::sale_not_found":"Dieses Angebotsverfahren konnte nicht gefunden werden.","Sale::you_are_about_to_upload_offer_in_the_name_of_customer":"Sie sind dabei das Kaufangebot im Namen des Kunden hochzuladen. Somit kann der Kunde sein Kaufangebot nicht mehr online abgeben. Unbedingt das original Angebotsformular aufheben!","SaleCreatePanel::agbs":"AGBs","SaleCreatePanel::behalf_of":"Im Auftrag von","SaleCreatePanel::create_new_listing":"Neue Immobilie anlegen","SaleCreatePanel::i_agree_to_the_link":"Ich stimme den {agbs} zu","SaleCreatePanel::i_agree_with_terms_and_conditions":"Ich stimme den AGBs zu","SaleCreatePanel::image":"Titelbild des Objektes","SaleCreatePanel::invite_only":"Teilnahme nur für freigegebene Makler","SaleCreatePanel::number":"Objekt-Nr.","SaleCreatePanel::price":"Angebotspreis laut Exposé","SaleCreatePanel::title":"Titel des Objektes","salepropertytype::business":"Geschäftslokal","salepropertytype::flat":"Wohnung","salepropertytype::house":"Haus","salepropertytype::mixed":"Wohn- und Geschäftshaus","salepropertytype::office":"Büro","salepropertytype::property":"Grundstück","SaleWizard::accept_tc_title":"AGBs akzeptieren","SaleWizard::action_functionality":"Diese Funktion bietet die folgenden Möglichkeiten:","SaleWizard::award":"Sie können den vom Verkäufer favorisierten Käufer über die Annahme seines Angebotes  informieren, inkl. persönlicher Nachricht.\nSie können Interessenten, deren Angebot definitiv abgelehnt wurde,  informieren. Diese werden dann vom weiteren Prozess ausgeschlossen.\nAlle sonstigen Bieter, die weder der Favorit sind, noch zu den definitiv abgelehnten Bietern gehören, bleiben hier zur Absicherung als mögliche „Ersatzkäufer“ bis zum endgültigen Verkaufsabschluss im Prozess.","SaleWizard::award_subtitle":"Nutzen Sie diese Funktion, wenn es einen favorisierten Käufer gibt, Sie aber vorerst weitere Bieter als Absicherung im Rennen halten möchten.","SaleWizard::award_title":"Favorisierten Käufer auswählen","SaleWizard::awardall":"Wählen Sie den Gewinner für jede Immobilie","SaleWizard::awardall_subtitle":"Wählen Sie den Gewinner für jede Immobilie","SaleWizard::awardall_title":"Gewinner auswählen","SaleWizard::choose_a_winner_title":"Käufer auswählen","SaleWizard::choose_offers_for_next_round_title":"Angebote auswählen","SaleWizard::choose_offers_to_reject_title":"Ablehnungen","SaleWizard::choose_winners_title":"Gewinner auswählen","SaleWizard::confirmaward":"Sie können nach erfolgreich abgeschlossenem Verkauf den Käufer bestätigen.\nAlle verbliebenen Interessenten werden automatisch über den Verkauf informiert und deren Angebote endgültig abgelehnt.\nDas Verfahren wird geschlossen.","SaleWizard::confirmaward_subtitle":"Nutzen Sie diese Funktion, sobald Sie den endgültigen Käufer bestätigen möchten.","SaleWizard::confirmaward_title":"Endgültigen Käufer bestätigen","SaleWizard::counteroffer":"Wenn der Käufer den Wert des Gegenangebots annimmt, wird er als Käufer bestätigt und das Angebot von der Verkäuferseite ist bindend\nSie können einen Käufer auswählen, der bereits ein Angebot abgegeben hat\nDann können Sie ein Gegenangebot angeben Wert und die Frist, bis zu der der Käufer entscheiden muss\nDer Käufer kann entweder:\nden Wert annehmen und wird dann sofort als ausgewählter Käufer ausgewählt\nein Angebot abgeben, das höher ist als sein vorheriges Gebot, aber niedriger als das Gegenangebot, in dem Falls die Runde geschlossen wird und Sie es dann mit dem Verkäufer klären können\nTun Sie nichts und die Runde wird wie geplant geschlossen","SaleWizard::counteroffer_subtitle":"Verwenden Sie diese Funktion, wenn Sie einem potenziellen Käufer ein Gegenangebot machen möchten.","SaleWizard::counteroffer_title":"Gegenangebot","SaleWizard::duplicate":"Alle bereits hinterlegten Daten und Unterlagen der Immobilie werden automatisch übernommen.\nDanach können Sie die Angaben anpassen, die Eckdaten für die neue Runde definieren, das Verfahren eröffnen und neue Interessenten einladen.","SaleWizard::duplicate_subtitle":"Nutzen Sie diese Funktion, wenn Sie ein neues Verfahren mit dieser Immobilie starten möchten.","SaleWizard::duplicate_title":"Neues Verfahren starten","SaleWizard::increase":"Sie können eine weitere Angebotsrunde starten (mit ggf. neuem Richtpreis), um dadurch einen besseren Preis zu erzielen.\nAlle (bzw. ausgewählte) Bieter der letzten Runde können daran teilnehmen und ihr bestehendes Angebot erhöhen; sie erhalten automatisch eine Benachrichtigung.\nAußerdem können neue Interessenten eingeladen werden, die bisher noch nicht teilgenommen haben.\nAlle bisherigen Bieter, die nicht in die neue Runde eingeladen worden sind, erhalten automatisch eine Benachrichtigung mit der Ablehnung ihres bestehenden Angebotes.","SaleWizard::increase_subtitle":"Nutzen Sie diese Funktion, wenn Sie den Kaufinteressenten die Möglichkeit geben wollen, ihr Angebot zu erhöhen.","SaleWizard::increase_title":"Weitere Angebotsrunde starten","SaleWizard::message_to_buyers_title":"Zusätzliche Nachricht","SaleWizard::message_to_rejected_title":"Nachricht für abgelehnte Angebote","SaleWizard::message_to_winner_title":"Zusätzliche Nachricht","SaleWizard::next_round_details_title":"Nächste Runde","SaleWizard::notifyseller":"Informieren Sie den Verkäufer über die Angebote Ihrer Kunden","SaleWizard::notifyseller_subtitle":"Angebotsübersicht an Verkäufer senden Send","SaleWizard::notifyseller_title":"Verkäufer benachrichtigen","SaleWizard::rejectall":"Alle Interessenten, die ein Angebot abgegeben haben, werden über die ablehnende Entscheidung des Verkäufers informiert.\nDas Verfahren wird geschlossen.","SaleWizard::rejectall_subtitle":"Nutzen Sie diese Funktion, wenn der Verkäufer keines der Angebote annehmen und auch das Verfahren nicht fortführen möchte.","SaleWizard::rejectall_title":"Alle Angebote ablehnen","SaleWizard::results_title":"Bestätigung","SaleWizard::review_title":"Zusammenfassung","SaleWizard::review_winners_title":"Bewertungsgewinner","SaleWizard::sale_wizard":"Rundenassistent","SaleWizard::select_action_title":"Wie wollen sie weiter vorgehen?","SaleWizardResult::back_to_sale":"Zurück zum Angebotsverfahren","SaleWizardResult::confirmation":"Bestätigung","SaleWizardResult::continue_to_the_duplicated_sale":"Weiter zum duplizierten Angebotsverfahren","SaleWizardResult::successful":"Wir haben Ihre Eingaben entgegengenommen. Innerhalb einer Minute sind die Anpassungen im System sichtbar.","SaleWizardRoundInfo::ends":"Angebotsverfahren endet","SaleWizardRoundInfo::estimate":"Richtpreis","SaleWizardRoundInfo::minimum_price":"Mindestpreis","SaleWizardRoundInfo::offer_validity":"Kaufangebote gültig","SaleWizardRoundInfo::red_button_price":"Red-Button-Preis","SaleWizardRoundInfo::start_price":"Startpreis","salutation":"Anrede","salutation::miss":"Frau","salutation::mr":"Herr","salutation::mrs":"Frau","salutation::ms":"Frau","save":"Speichern","Search::add_new_listing":"Immobilie hinzufügen","Search::address":"Adresse","Search::agbs":"AGBs","Search::agent_not_found":"Sie haben nicht die Berechtigung Angebotsverfahren für diesen Makler zu starten!","Search::area":"Fläche","Search::create_new_listing":"Neue Immobilie anlegen","Search::creating":"Erstellen","Search::error_loading_objects":"Fehler beim Laden von Objekten.","Search::error_retrieving_file":"Fehler beim Abrufen oder Speichern der Datei","Search::guide_no_objects":"Es scheint, als hätten Sie im Moment keine aktiven Objekte.","Search::i_agree_to_the_link":"Ich stimme den {agbs} zu","Search::i_agree_with_terms_and_conditions":"Ich stimme den AGBs zu","Search::loading_details":"Die Immobilie wird geladen","Search::loading_properties":"Immobilien werden geladen","Search::my_listings_overview":"Zu meinen Angebotsverfahren","Search::number":"Objekt Nr","Search::price":"Preis","Search::this_object_is_already_active":"Dieses Objekt ist bereits aktiv","select_master_sale":"Projekt","self_registration":"Selbstregistrierung","seller":"Eigentümer","SellerInviteSection::block":"Block","SellerInviteSection::invite":"Einladen","SellerInviteSection::invite_seller":"Verkäufer einladen","send":"Abschicken","sms":"SMS","sms_failed":"SMS Benachrichtigung konnte nicht zugestellt werden","start_new_sale":"Neues Angebotsverfahren anlegen","start_new_test_sale":"Neues Testverfahren anlegen","status":"Status","street":"Strasse","street_and_house_number":"Strasse und Hausnummer","submit":"Abschließen","submitted_on":"Abgegeben am","submitted_value":"Gebotshöhe","successful_registrations":"Erfolgreiche Einladungen: {count}","summary":"Zusammenfassung","swiss_residential_status":"Schweizer Aufenthaltsstatus","template::cust_message":"Allgemeine Nachricht","test_sale_explanation":"Bitte nutzen Sie das Testverfahren ausschließlich für interne Trainings- und Präsentationszwecke. Sie können es auch als Unterstützung bei Akquise-Gesprächen nutzen, um potenziellen Verkäufern den Ablauf und die Vorteile des Angebotsverfahrens live vorzustellen. Die Nutzung des Testverfahrens ist kostenfrei and alle Webseiten und Benachrichtigungen werden als \"Test\" markiert. Die Nutzung für echte Angebotsverfahren mit Einbindung reeller Kaufinteressenten ist untersagt.","test_sale_watermark":"Testverfahren","this_action_cannot_be_undone":"Dieser Schritt kann nicht rückgängig gemacht werden.","title":"Titel","title::doctor":"Dr.","title::master":"Mag.","title::professor":"Prof.","true":"Ja","type_of_property":"Art der Immobilie","updated_on":"Aktualisiert am","upload":"Hochladen","upload_more":"Weitere Dokumente hochladen","uploading":"Hochladen","uploads":"Hochgeladene Dateien","uploadtype::identification_document":"Ausweispapiere","uploadtype::misc":"Verschiedenes","value_must_be_between_min_and_max":"Der Wert muss zwischen {min} und {max} sein","WhitelistingPanel::accept":"Freigeben","WhitelistingPanel::action":"Aktion","WhitelistingPanel::block":"Ablehnen","WhitelistingPanel::blocked":"Abgelehnt","WhitelistingPanel::requested":"Angefragt","WhitelistingPanel::whitelisted":"Freigegeben","WhitelistingPanel::whitelisting":"Überblick MLS Konfiguration","would_you_like_to_continue":"Wollen Sie fortfahren?","yes":"Ja","zip_code":"PLZ"}

/***/ }),
/* 892 */
/***/ (function(module, exports) {

module.exports = {"active":"Active","add":"Add","additional_address":"Additional address","additional_description":"Other description and important information","additional_information_text":"Additional information","address":"Address","agent":"Agent","AgentProvisionForm::agent_commission":"Agent commission","AgentProvisionForm::fixed_amount":"Fixed amount","AgentProvisionForm::fixed_amount_excluding_vat":"Fixed amount (excluding VAT)","AgentProvisionForm::no_commission":"No commission","AgentProvisionForm::percentage":"Percentage","AgentProvisionForm::percentage_excluding_vat":"Percentage (excluding VAT)","AgentProvisionForm::standard":"Standard","allowed_file_formats":"Please note that only the following file formats are allowed: PDF, JPG and PNG.","and":"and","App::initializing":"Initializing","are_you_sure_this_action_cannot_be_undone":"Are you sure? This action cannot be undone.","area_unit":"m²","auction_finals":"Auction Finals","AuctionFinalsList::no_offer_selected_for_awardwing_go_back_to_the_matrix_and_pick_some":"No offer selected for awardwing, go back to the matrix and pick some.","AuctionFinalsList::object_no":"Object no.","AuctionFinalsList::selected_buyer":"Selected buyer","AuctionFinalsList::total":"Total","AuctionFinalsMatrix::awarded":"Awarded","AuctionFinalsMatrix::clear_selection":"Clear selection","AuctionFinalsMatrix::for_each_property_pick_the_best_available_offer":"For each property pick the best available offer","AuctionFinalsMatrix::for_each_property_pick_the_highest_offer_if_it_is_the_most_preferred_offer_of_the_highest_bidder":"For each property pick the highest offer if it is the most preferred offer of the highest bidder","AuctionFinalsMatrix::for_each_property_pick_the_highest_offer_if_the_highest_bidder_has_not_been_assigned_to_another_property_yet":"For each property pick the highest offer if the highest bidder has not been assigned to another property ye","AuctionFinalsMatrix::position":"Position","AuctionFinalsMatrix::preference":"Preference","AuctionFinalsMatrix::property":"Property","AuctionFinalsMatrix::select_best_offers":"Select best offers","AuctionFinalsMatrix::select_highest_offers":"Select highest offers","AuctionFinalsMatrix::select_preferred_highest_offers":"Select preferred highest offers","AuctionFinalsMatrix::this_is_the_highest_offer_for_this_property_but_its_not_selected":"This is the highest offer for this property, but it's not selected","AuctionFinalsMatrix::this_is_the_most_preferred_offer_for_this_buyer_but_its_not_selected":"This is the most preferred offer for this buyer, but it's not selected","AuctionFinalsPanel::awarded":"Awarded","AuctionFinalsPanel::confirm":"Confirm","AuctionFinalsPanel::continue":"Continue","AuctionFinalsPanel::error_loading_data_from_server":"Error loading data from server","AuctionFinalsPanel::failed":"Failed","AuctionFinalsPanel::report":"Report","AuctionFinalsPanel::review_winners":"Review winners","AuctionFinalsPanel::select_winners":"Select winners","AuctionFinalsPanel::selected":"Selected","AuctionFinalsPanel::succeeded":"Succeeded","AuctionFinalsPanel::total":"Total","AuctionFinalsTotals::awarded":"Previously awarded","AuctionFinalsTotals::selected":"Currently selected","AuctionFinalsTotals::total":"Total","audiencetype::bidders":"Bidders","audiencetype::everyone":"Everyone","audiencetype::non_bidders":"Non-bidders","AwardAllStep1::loading_offers_please_wait":"Loading offers, please wait","AwardStep1::choose_a_winner":"Choose a winner","AwardStep1::expiration_date":"Choose period","AwardStep2::expiration_date":"Offer validity","AwardStep2::select_customers_to_reject_theirs_offer":"Select offers that you want to reject immediately.\nThese customers will immediately receive a notification of cancellation.\nAll other customers will not be notified at the moment if you want to choose another buyer later.","AwardStep2::this_text_will_appear_as_an_additional_note":"This text will appear as an additional note in the notification to the winner:","AwardStep4::reject_message":"Additional message to rejected prospective buyers","AwardStep4::this_text_will_appear_as_an_additional_note":"This text will appear as an additional note in the notification","AwardSummary::if_you_click_finish_you_confirm_the_winner":"If you click \"Finish\", you confirm the winner. The selected prospective buyers will be notified. This step cannot be undone.","AwardSummary::rejected_customers_offers":"Rejected offers","AwardSummary::selected_winner":"Selected winner","back":"Back","behalf_of":"On behalf of agent","bid_amount":"Offer amount","bidding_type":"Bidding type","BiddingSection::highest_bidder":"Highest bidder","BiddingSection::round_opens_on":"Round opens on","BiddingSection::the_highest_offer":"The highest offer","BiddingSection::the_next_minimum_offer":"The next minimum offer","BlockDialog::block":"Block","BlockDialog::block_agent":"Deny request","BlockDialog::reason":"Reason for the decision","BulkRegistrationCsvPanel::back_to_mapping":"Back to mapping","BulkRegistrationCsvPanel::duplicate_description":"Record already exists","BulkRegistrationCsvPanel::import_from_csv_file":"Import from CSV file","BulkRegistrationCsvPanel::invalid_description":"Incomplete record","BulkRegistrationCsvPanel::total_number_of_rows_count":"Total number of rows: {count}","BulkRegistrationCsvPanel::valid_description":"Record complete","BulkRegistrationInventoryPanel::duplicate_description":"Record already exists","BulkRegistrationInventoryPanel::entries_with_duplicate_emails_count":"Entries with duplicate e-mails: {count}","BulkRegistrationInventoryPanel::failed_registrations":"Failed registrations: {count}","BulkRegistrationInventoryPanel::importing":"Importing","BulkRegistrationInventoryPanel::invalid_description":"Incomplete record","BulkRegistrationInventoryPanel::invalid_entries_count":"Invalid entries: {count}","BulkRegistrationInventoryPanel::successful_registrations":"Successful registrations: {count}","BulkRegistrationInventoryPanel::total_number_of_entries_count":"Total number of entries: {count}","BulkRegistrationInventoryPanel::valid_description":"Record complete","BulkRegistrationTable::already_registered":"Already registered","BulkRegistrationTable::invalid_email":"Invalid E-mail","BulkRegistrationTable::saving_error":"Upload error","BulkRegistrationTable::select__unselect_all":"Select / unselect all","BuyerDocumentSelector::none":"None","BuyerDocumentSelector::not_required":"Not required","BuyerDocumentSelector::optional":"Optional","BuyerDocumentSelector::required":"Required","buyertype::company":"Company","buyertype::entrepreneurs":"Individual entrepreneur (Einzelunternehmer)","buyertype::private":"Private person","CallbackComponent::redirecting":"Redirecting","cancel":"Cancel","citizenship":"Nationality","city":"City","close":"Close","combobox_placeholder_free_text":"Choose an option from the list or provide your own","Commands::accept":"Confirm for next round","Commands::all_offers":"All offers","Commands::approve":"Approve","Commands::approveregistration":"Activate customers","Commands::are_you_sure_this_action_can_not_be_undone":"Are you sure? This action can not be undone.","Commands::are_you_sure_to_block_user":"Are you sure? The customer will be blocked from the system!","Commands::are_you_sure_to_close_the_sale":"Are you sure? The bidding process will be terminated immediatelly.","Commands::are_you_sure_to_end_round_early":"Are you sure? If you close the process no more offers can be submitted.","Commands::are_you_sure_to_end_round_early_sealed":"Are you sure? If you close the process no more offers can be submitted and all offer prices will be revealed.","Commands::award":"Accept offer","Commands::blank_offer":"Blank offer PDF","Commands::block_user":"Block customer","Commands::close_sale":"Terminate bidding process","Commands::confirm":"Confirm for the customer (TAN)","Commands::delete_sale":"Delete bidding process","Commands::download_documents":"Download documents","Commands::end_round_early":"Terminate round prematurely","Commands::import_registrations_from_crm":"Import from CRM","Commands::import_registrations_from_csv_file":"Import from CSV file","Commands::import_registrations_from_onoffice":"Import from onOffice","Commands::import_registrations_from_propstack":"Import from Propstack","Commands::import_registrations_from_propup":"Import from PropUp","Commands::invite_seller":"Invite seller","Commands::messaging":"Send message","Commands::new":"Start new round","Commands::offer":"Offers","Commands::pdf_export":"Print (PDF)","Commands::refuse":"Rejecting because deficient","Commands::refuseregistration":"Reject customers","Commands::register_new_user":"Invite new customer","Commands::registration":"Registrations","Commands::reject":"Reject","Commands::round_close":"Terminate prematurely","Commands::round_open":"Open round","Commands::sale":"Bidding process","Commands::sale_wizard":"Sale wizard","Commands::update_contact":"Update contact","Commands::upload":"Upload offer on behalf of customer","Commands::whitelisting":"MLS configuration","company":"Company","company_court":"District court","company_id":"Id","company_name":"Company name","Confirmation::confirmation_expired":"Entered TAN is wrong or has expired","Confirmation::invalid_bid_value":"Purchase price is too low","Confirmation::invalid_confirmation":"Entered TAN is wrong or has expired","Confirmation::sale_round_not_opened":"Your offer cannot be accepted because the round is already closed","ConfirmAwardStep1::choose_a_winner":"Choose a winner","ConfirmAwardStep1::expiration_date":"Offer validity","ConfirmAwardStep1::reject_message":"Additional message to rejected prospective buyers","ConfirmAwardStep1::this_text_will_appear_as_an_additional_note":"This text will appear as an additional note in the notification","ConfirmAwardSummary::if_you_click_finish_you_confirm_the_winner":"When you click \"Finish\", you confirm the buyer. All other offers are rejected and customers are notified.\nThis step cannot be undone.","ConfirmAwardSummary::rejected_customers_offers":"Rejected offers","ConfirmAwardSummary::selected_winner":"Selected winner","ContactPanel::update_contact":"Update contact","costs":"Costs","Countdown::das_verfahren_ist_beendet":"The offer process is closed","CounterofferStep2:: please_define_the_next_round":"Please specify the next round","CounterofferStep2::please_define_the_next_round":"Please define next round","CounterofferStep2::validity_of_offers_set_to_the_same_value":"Validity of offers set to the same value","CounterofferSummary::click_finish_to_start_a_new_round":"Click finish to start a new round","CounterofferSummary::customers_for_the_next_round":"Select customers that should participate in the next round","CounterofferSummary::customers_not_participating_in_the_next_round":"Select customers that should not participate in the next round","CounterofferSummary::round_details":"Round details","country":"Country","created_on":"Created on","CsvMappingTable::do_not_import":"do not import","customer":"Customer","customer_buyer_reference_of_name":"Customer {buyer_reference} from {name}","customer_name":"Customer name","customer_of_name":"Customer from {name}","Dashboard::authorization_in_progress":"Authorization in progress","Dashboard::customer_service_contact":"Customer service contact","Dashboard::customer_service_email":"support@propnow.com","Dashboard::customer_service_p":"For questions or problems you can contact us as follows:","Dashboard::customer_service_telephone":"+49 30 959992518","Dashboard::customer_service_telephone_href":"+49 30 959992518","Dashboard::do_you_really_want_to_log_out":"Do you really want to log out?","Dashboard::log_out":"Log out","Dashboard::tel__sms__whatsapp":"Phone","date":"Date","date_of_birth":"Date of birth","DateField::dateformat":"dd.mm.yyyy","DateField::invalid_date":"Invalid date","days":"Days","delete":"Delete","deposit_payment_deadline":"Deposit payment deadline","depositRequired::false":"No","depositRequired::true":"Yes","doc_from":"from","Doc::from":"from","Doc::no_type":"Please assign document type","Doc::original_name":"Uploaded as {originalFilename} on {uploadedAt, date, medium} {uploadedAt, time, medium}","documents":"Documents","documenttype::annual_statement":"Annual statement","documenttype::appraisal":"Value appraisal","documenttype::area_allocation_plan":"Area allocation plan","documenttype::building_permit":"Building permit","documenttype::completion_display":"Completion display","documenttype::condominium_contract":"Condominium contract","documenttype::energy_certificate":"Energy performance certificate","documenttype::expose":"Brochure","documenttype::expose_long":"Description of property (Brochure)","documenttype::land_register":"Excerpt from the land register","documenttype::loan_agreement":"Loan agreement","documenttype::operating_costs":"Operating costs","documenttype::operating_costs_long":"Operating costs / maintenance and improvement costs forecast within the meaning of § 20 Abs. 2 WEG","documenttype::promissory_note":"Promissory note","documenttype::running_costs":"Requirement of running costs","documenttype::usage_permit":"Usage permit","DuplicateStep1::agbs":"T&C","DuplicateStep1::duplicating_sale":"Duplicating sale","DuplicateStep1::hint1":"All data and documents related to the offer form are copied","DuplicateStep1::hint2":"You can then adjust the information, define the round and invite new prospective buyers","DuplicateStep1::i_agree_to_the_link":"I agree to the {agbs}","DuplicateStep1::i_agree_with_terms_and_conditions":"I agree with terms and conditions","DuplicateSummary::duplicating_sale":"Duplicating sale","duration":"Duration","duration_type":"Validity of the purchase offers","durationtype::fixed":"Fixed","durationtype::flexible":"Flexible","edit":"Edit","EditPanel::edit_offer_form":"Prepare data for offer letter","email":"E-mail","email_failed":"Email notification could not be delivered","EmailField::invalid_email":"The e-mail address is not correct","encoding":"Encoding","Error::blocked":"The page you are trying to access does not exist. Either you have a wrong link or the digital offer process has already been completed. You can find more objects under:","false":"No","field::depositrequired":"Deposit","field::email":"E-mail","field::firstname":"First name","field::lastname":"Last name","field::locale":"Language","field::phone":"Mobile number","field::salutation":"Salutation","field::title":"Title","fill_required_fields":"Please fill in all required fields!","financing_required":"Financing required","financing_secured":"Financing secured","first_name":"First name","handover":"Handover","handovertype::key_handover":"After key handover","handovertype::land_register":"After entry in the land register excerpt","handovertype::money_transfer":"After transfer of the purchase price to a predefined account","handovertype::sale_contract":"According to the sales contract","hidden":"hidden","house_number":"Number","iban":"IBAN","iban_is_not_valid":"IBAN is invalid","image":"Image","import":"Import","IncreaseStep1::all_other_offers_will_be_rejected":"All other offers will be rejected and do not have the opportunity to participate in another round.","IncreaseStep1::expiration_date":"Choose period","IncreaseStep1::invite_more_customers_after_start_of_next_round":"After the start of the next round, you will have the opportunity to invite more interested customers.","IncreaseStep1::select_customers":"Select the customers to attend the next round.","IncreaseStep2::please_define_the_next_round":"Please define the next round.","IncreaseStep2::validity_of_offers_set_to_the_same_value":"The time of validity of the purchase offers for the other offers was automatically set to the same value as in the previous round.","IncreaseStep3::this_text_will_appear_as_an_additional_note":"This text will appear as an additional note in the notification to the customer:","IncreaseSummary::click_finish_to_start_a_new_round":"If you click \"Finish\", a new round will be started and the customers will be informed.","IncreaseSummary::customers_for_the_next_round":"Customers for the next round","IncreaseSummary::customers_not_participating_in_the_next_round":"Customers not participating in the next round","IncreaseSummary::round_details":"Round details","is_master_sale":"(Project - Main process / Registration)","last_name":"Last name","legal_entity":"legal entity","legal_form":"Legal form","ListingsOverview::add_new_listing":"Add new listing","ListingsOverview::agent":"Agent","ListingsOverview::approved_offers":"Approved customers","ListingsOverview::create_new_listing":"Create new listing","ListingsOverview::end_date":"End date","ListingsOverview::guide__you_should_add_a_new_listing":"To start a bidding process, you must first select a property.","ListingsOverview::loading_listings":"Loading listings","ListingsOverview::my_listings_overview":"My listings overview","ListingsOverview::number":"Property ID","ListingsOverview::pending_offers":"Pending offers","ListingsOverview::start_date":"Start date","loading":"Loading","locale":"Language","locale::de":"German","locale::deat":"German","locale::dech":"German","locale::dede":"German","locale::en":"English","locale::es":"Spanish","locale::eses":"Spanish","locale::fi":"Finnish","locale::fifi":"Finnish","locale::fr":"French","locale::frch":"French","locale::frlu":"French","locale::it":"Italian","locale::itch":"Italian","locale::itit":"Italian","locale::ro":"Romanian","locale::roro":"Romanian","locale::sl":"Slovenian","locale::slsi":"Slovenian","manage":"Manage","ManagePanel::administration":"Administration","ManagePanel::my_data":"My data","ManagePanel::object_supervisor":"Object supervisor","marital_status":"Marital status","maritalstatus::divorced":"Divorced","maritalstatus::married":"Married","maritalstatus::none":" n/a","maritalstatus::single":"Single","maritalstatus::widowed":"Widowed","message":"Message","MessagingPanel::audience":"Recipients","MessagingPanel::failed_to_send_the_message":"Failed to send the message","MessagingPanel::messaging":"Send custom message","MessagingPanel::no_message_has_been_sent":"No message has been sent","MessagingPanel::number_of_failed_messages":"Number of failed messages","MessagingPanel::number_of_successfully_sent_messages":"Number of successfully sent messages","MessagingPanel::subject":"Subject","MessagingPanel::template":"Template","MessagingPanel::text":"Text","mls":"MLS","mls::everyone":"Free MLS","Mls::loading_mls":"Loading MLS offer processes","Mls::no_sale_for_mls":"There is currently no sale available","mls::none":"No MLS","Mls::request_access":"Participate in the digital bidding process","Mls::request_access_description":"Do you want to participate on this digital bidding process and invite your buyers. Your request will be reviewed by the listing agent and you will get a answer via e-mail and in the dashboard soon.","mls::tenant":"MLS only within tenant","more":"more","name":"Name","next":"Next","no":"No","not_entered":"Not entered","not_part_of_master_sale":"(no Project - Independent Process)","notary":"Notary","notificationcaption::all_customers":"All customers","notificationcaption::customer":"Customer","notificationcaption::customers_invited_to_the_next_round":"Customers invited to the next round","notificationcaption::other_customers":"Other customers","notificationcaption::seller":"Seller","notificationcaption::winner":"Winner","notificationemailtemplate::cust_bid_refused":"Offer refused","notificationemailtemplate::cust_highest_bidder":"Highest bidder","notificationemailtemplate::cust_highest_bidder_changed":"New highest bid","notificationemailtemplate::cust_invited":"Invite customers","notificationemailtemplate::cust_message":"Message","notificationemailtemplate::cust_offer_awarded":"Offer accepted","notificationemailtemplate::cust_offer_placed":"Offer submitted","notificationemailtemplate::cust_offer_raised":"Increase offer","notificationemailtemplate::cust_offer_refused":"Reject offer","notificationemailtemplate::cust_outbid":"Offer overbid","notificationemailtemplate::cust_outbid_antisniping":"Offer overbid","notificationemailtemplate::cust_outbid_others":"New highest bid","notificationemailtemplate::cust_phase_invite_closing":"Reminder - registration phase","notificationemailtemplate::cust_phase_offer_starting":"Reminder - bid submission started","notificationemailtemplate::cust_phase_wishlist_closing":"Reminder - object selection ends","notificationemailtemplate::cust_rejected_round_closed":"Offer rejected","notificationemailtemplate::cust_rejected_sold":"Offer rejected","notificationemailtemplate::cust_rejected_unsold":"Offer rejected","notificationemailtemplate::cust_round_closed":"Round has ended","notificationemailtemplate::cust_round_closing":"Reminder","notificationemailtemplate::cust_round_edited":"Round adjusted","notificationemailtemplate::cust_round_opened":"New round started","NotificationPreview::no_notification_defined_for_the_selected_action":"No notification will be sent for the selected action","notifications":"Notifications","notificationservicestatus::delivered":"Delivered","notificationservicestatus::failed":"Failed","notificationservicestatus::pending":"Pending","notificationservicestatus::sent":"Sent","NotificationsPanel::explanation":"If you want to be notified about the activities for the  Offer process for this object by e-mail and SMS, please activate the function:","NotifySellerSummary::description":"Purchase offers from the following customers will be sent directly to seller by e-mail:","now":"Now","null":"N/A","number":"Number","offer":"Offer","offer_viewing":"Property visited on","offer_viewing_help":"Please leave empty if there was no viewing","OfferDetailsForm::agreement_installer__lawyer":"Agreement installer / lawyer","OfferDetailsForm::other_agreements":"Other agreements","OfferDetailsForm::purchase_offer_valid_until":"Purchase offer valid until","OfferDetailsForm::purchase_price_gross":"Purchase price (gross)","OfferNotificationDetails::service_data":"Service data","OfferNotificationsList::created_on":"Dispatched on ","OfferNotificationsList::error_loading":"Failed to load the notification list","OfferNotificationsList::recipient":"Recipient","OfferNotificationsList::service_status":"Service status","OfferNotificationsList::template":"Template","OffersSection::hidden":"Currently hidden","OffersSection::increase_offer_on_behalf_of_the_customer":"Increase offer on behalf of the customer","OffersSection::invited_on":"Invited on","OffersSection::submitted_at":"Submitted on","OffersSection::submitted_value":"Offer amount","OffersSection::upload_offer_on_behalf_of_a_customer":"Upload offer on behalf of the customer","offerstatus::accepted":"Confirmed","offerstatus::approved":"Approved","offerstatus::awarded":"Accepted","offerstatus::confirmed":"Submitted","offerstatus::invited":"Invited","offerstatus::refused":"Refused","offerstatus::registrationconfirmed":"Waiting for activation","offerstatus::registrationsubmitted":"Registration submitted","offerstatus::rejected":"Rejected","offerstatus::submitted":"Prepared (without TAN)","offerstatus::updated":"In progress","ok":"OK","open":"Open","optional":"Optional","other_agreements":"Other agreements","overview":"Overview","ownership":"Ownership type","ownershiptype::residential":"Residential property","ownershiptype::share":"Share ownership","ownershiptype::sole":"Sole ownership","page_title":"PropNow - {friendly_name}","Page1::area":"Area","Page1::construction_year":"Construction year","Page1::deed":"Land Registry","Page1::deed_kg":"KG","Page1::energy_certificate":"Energy certificate","Page1::housing_subsidies":"Housing subsidies","Page1::object_number":"Object Nummer","Page1::ownership_share":"Share","Page1::ownership_total":"Total","Page1::parcel_number":"Parc.Nr.","Page1::register_number":"Register number","Page1::usage_rules":"Usage rules","Page2::date_of_delivery_warranty":"Handover date, warranty","Page2::date_of_delivery_warranty_contract":"Date of delivery, warranty, contract","Page2::exceptions":"Exceptions","Page2::handover_date":"Handover date","Page2::mortgage":"Mortgage","Page2::mortgage_detail":"Mortgage details","Page2::notary":"Notary","Page2::vatliable_purchase":"VAT-liable purchase","Page3::all_documents_must_have_a_type_set":"All documents must have a type specified","Page3::choose_a_document_type_or_enter_description":"Choose a document type or enter description","Page3::document_type":"Document type","Page3::section__property":"Other documents about the property","Page3::upload_following_documents":"Please upload at least the following documents","peptype::family":"PEP family member","peptype::no":"No","peptype::related":"Close relationship with a PEP","peptype::yes":"Buyer is a PEP","person":"Person","phone_number":"Mobile number","phone_number_placeholder":"+49 150 0000 0000","phonenumbererror::invalid":"Phone number is not valid","phonenumbererror::notmobile":"Phone number is not a mobile number","place_of_birth":"Place of birth","politically_exposed_person_pep":"Politically exposed person (PEP)","post_code":"Postcode","postal_code":"Postal code","preview":"Preview","previous":"Previous","previous_round":"Previous round","price_on_offer":"Price on offer","price_on_request":"Price on request","private_person":"Private person","processing":"Processing","property_for_sale":"Property for sale","provision":"Buyer's commission","ProvisionAck::i_have_taken_note_of_the_following_important_information":"I have taken note of the following important information","provisiontype::default":"Standard","provisiontype::fixed_amount":"Fixed amount (excluding VAT)","provisiontype::fixed_percentage":"Percentage (excluding VAT)","provisiontype::none":"No commission","purchase_price":"Purchase price","recipient":"Recipient","refresh":"Refresh","RefuseDialog::explanation":"Inform the customer about the reason for the rejection.","RefuseDialog::reason":"Reason","RefuseDialog::refuse_an_offer":"Refuse an offer","register":"Invite","registering":"Invitando","registration_disabled":"Inviting new customers not allowed for an offer process in its current state (Inivitations are only possible in running offer processes)","RegistrationPanel::already_registered":"You have already invited a customer with this e-mail address!","RegistrationPanel::offer_viewing":"Property visited on","RegistrationPanel::place_at":"Received on","RegistrationPanel::purchase_price_gross":"Purchase price (gross)","RegistrationPanel::register_new_user":"Invite new prospects","RegistrationPanel::send_the_invitation_again":"Send invitation again","RegistrationPanel::upload_an_offer":"Upload offer (in the customer name)","RegistrationPanel::upload_new_offer":"Upload a new offer on behalf of the customer","RegistrationPanel::upload_offer":"Upload offer","RejectSummary::click_finish_to_reject_all_offers":"If you click \"Finish\", all offers will be rejected and customers will be informed.","remove":"Remove","required_documents":"Required documents","round":"Round","RoundEdit::allow_bidding_below_starting_price":"Allow offers below starting price","RoundEdit::allow_bidding_below_starting_price__tooltip":"In the open offer process, interested parties can normally only bid from the starting price, which can mean that more price-sensitive customers often do not bid. With this option, you offer interested parties the opportunity to submit an offer <u>below</u> the starting price - but above the (initially hidden) minimum price set by the broker. This has the advantage that more interested parties submit an offer, as lower-priced offers are also permitted. This creates a broader field of bidders and can therefore increase the chance of a sale. All offers below the starting price are hidden from other interested parties to avoid a negative anchor effect. Only bids from the starting price are displayed by default, unless you activate the option \"Show offers below starting price to other bidders\".","RoundEdit::allow_bidding_below_starting_price_hidden":"Allow offers below starting price (hidden)","RoundEdit::antisniping_notice":"The end of the offer period is automatically extended by 15 minutes if a new offer is received within the last 15 minutes before the end of the offer. This extension is repeated until no further offers are made for 15 minutes.","RoundEdit::bidding_steps":"Minimum offer increase","RoundEdit::bidding_steps__standard":"Standard predefined offer increments","RoundEdit::bidding_steps__tooltip":"This is the minimum increase amount for new offers. Each new offer must be at least this amount higher than the current highest bid. If you have selected the option \"Allow offers under highest offer\", the minimum bid increment refers to the previous offer of the individual customer if they have already made an offer (for further information see the info button: \"Allow offers under highest offer\")","RoundEdit::bidding_type_tooltip":"Choose the bidding type","RoundEdit::counteroffer_value":"Proposed counteroffer value","RoundEdit::end_date_changed":"All invited buyers and agents will be notified about the change of the end of the bidding process via e-mail.","RoundEdit::ends_at":"End of the bidding period","RoundEdit::ends_at__tooltip":"For the end of the bidding process, we recommend choosing a time when interested parties are available and in a place with a good internet connection (e.g. at home). Experience has shown that early evenings or weekends work very well here. However, please note public holidays or long weekends when interested parties may be out and about. It is also important to inform interested parties about the schedule. At the end of the bidding period, reminders will be sent to the invited interested parties 72 hours, 24 hours and 60 minutes before the scheduled end. We also recommend that you as an agent are available by phone during the last hour before the end of the bidding process and, if necessary, follow the bidding process live on your laptop or tablet so that you can support interested parties with any questions or problems (e.g. poor internet connection of the interested party).","RoundEdit::estimate":"Estimate","RoundEdit::estimate__tooltip":"The target price is a reference price, which is communicated to the prospective buyer as a guideline to help him determine his own offer price. Important: the target price does not represent a minimum price; i.e. the interested party can also submit an offer below the target price.","RoundEdit::estimate_lower_than_startprice":"The estimate can't be lower than the minimum price","RoundEdit::flexible_bidding":"Allow offers under highest offer","RoundEdit::flexible_bidding__tooltip":"In the open offer process, interested parties must normally submit a new maximum bid with each new offer, which can result in individual interested parties dropping out early or perhaps not bidding at all. By selecting this flexible bidding option, the interested party has the option of submitting an offer <u>below</u> the current maximum bid. However, the new bid must be <u>above</u> the previous bid price of the corresponding customer if they have already submitted an offer. The minimum bid increment is decisive here and is only applied <b>to their own bid</b>. The advantage of this bidding option is that individual interested parties bid more frequently and a stronger middle field is created because bidders do not drop out early. This can increase the chances of a sale, particularly when there are only a few interested parties or if the starting price is a little too high.","RoundEdit::hide_highest_bid__bid_history_for_nonbidders":"Display other offers <strong>after</strong> customers submits own offer","RoundEdit::hide_highest_bid__bid_history_for_nonbidders__tooltip":"For transparency reasons, the current highest bid, as well as all purchase offers submitted, are normally displayed to all those invited in the open process from the outset - even before they have submitted an offer themselves. In individual cases, this can lead to individual interested parties, being deterred by the already very high bid prices, not even submitting an offer although they would have liked to submit an offer. This bidding option can be helpful to avoid this and to motivate anyone who is willing to buy to also submit a purchase offer.","RoundEdit::invalid_starting_price":"Please enter a valid starting price","RoundEdit::min_price":"Minimum price","RoundEdit::min_price__tooltip":"Minimum purchase price that customer must offer. Only displayed, if prospect wants to bid below this price.","RoundEdit::min_price_lower_than_start":"Minimum price must be lower than starting price","RoundEdit::minimum_price":"Minimum price","RoundEdit::offer_validity":"Validity of the purchase offers","RoundEdit::open_round_warning":"In the open offer process, only one round is provided and the bids are revealed to all.","RoundEdit::please_enter_a_starting_price":"Please enter a price >0","RoundEdit::red_button_price":"Red button price","RoundEdit::red_button_price__tooltip":"This is the (estimated) minimum price at which the owner is willing to sell. This is a purely internal price that is not communicated to the customer and only visible to the agent. Upon reaching the Red button price, the agent is informed immediately.","RoundEdit::select_a_bidding_type":"Select a bidding type","RoundEdit::show_bids_below_starting_price":"Show bids below starting price to other bidders","RoundEdit::show_bids_below_starting_price__tooltip":"Only bids <u>from</u> the starting price are displayed by default, unless you activate this option. Then bids <u>below</u> the starting price are also displayed and you have increased transparency in the offer process.","RoundEdit::simple_offer_duration_suggestion_notice":"This is the proposed offer validity of the purchase offer. However, the prospective buyer can change this when submitting their offer","RoundEdit::start":"Start of the bidding period","RoundEdit::start__tooltip":"If you invite interested parties <u>before</u> the start of the offer process (bidding period), they can already enter their data, view the property documents and <u>prepare</u> an offer. However, the offer cannot yet be submitted! As soon as the start time is reached and the bidding period of the offer process has begun, all invited interested parties will receive a notification and can then begin submitting their purchase offers.<br /><br />Tip: The average length of the offer process, i.e. the period in which offers can be submitted (bidding period), is around 5-7 days. This creates sufficient momentum and at the same time ensures that individual interested parties do not lose interest in the property (which can happen if the bidding period is too long). However, the period of 5-7 days also assumes that all interested parties have already been sufficiently pre-qualified by you as the broker at the start of the offer process, including viewing the property and clarification of financing options. However, if the financing is still unclear for the majority of interested parties and you therefore choose the \"financing confirmation\" option when inviting interested parties, then you should also choose a slightly longer duration for the offer process to give interested parties enough time to clarify their financing while the process is ongoing. If you have any further questions, please feel free to contact our team.","RoundEdit::starting_price":"Starting price","RoundEdit::starting_price__tooltip":"Price that the prospective buyer must at least offer when submitting the first offer.","RoundEdit::time_of_day":"Time of day","RoundInfo::ends":"Bidding procedure ends","RoundInfo::offer_validity":"Validity of the purchase offers","RoundInfo::starts":"Bidding procedure starts","RoundItem::badge_free":"Free","RoundItem::badge_new":"New","RoundItem::badge_separator":" & ","RoundItem::how_it_works":"How it works","RoundItem::incremental_auction_costs":"","RoundItem::incremental_auction_howitworkspoints":"- Open bids from starting price\n- Multiple bids possible\n- Automatic extension for last minute bids\n<b>New flexible bidding options:</b>\n- Ability to allow bids <u>below starting price</u>\n- Bid height <u>freely selectable</u> (above minimum price)\n- Only bids above the starting price are displayed\n- Fixed start and end date","RoundItem::incremental_auction_subtitle":"with flexible bidding","RoundItem::incremental_auction_title":"Open offer process","RoundItem::incremental_auction_whentouseitpoints":"As normal \"open\" offer process but also if: \n- Lower demand \n- Price sensitive customers \n- Starting price less attractive \n- Price increase unclear \n- Giving customers more flexibility","RoundItem::open_bidding_costs":"","RoundItem::open_bidding_howitworkspoints":"Starting price = minimum price for first bidder\nEach bidder <b>must</b> always submit a <b>new highest bid</b>\nMultiple bids per customer possible\nAll bids and <b>prices visible</b>\nBidder names anonymized\nFormal start and finish date","RoundItem::open_bidding_subtitle":"with ascending bids","RoundItem::open_bidding_title":"Open offer process","RoundItem::open_bidding_whentouseitpoints":"Attractive starting price\nHigh demand\nMarket value of property above starting price\nPrice increase expected","RoundItem::sealed_bidding_costs":"","RoundItem::sealed_bidding_howitworkspoints":"- Reference price, no minimum price\n- Bid amount <u>freely selectable</u>\n- Each customer can only make <u>one</u> offer\n- Bidders and bids are <u>hidden</u>\n- Fixed end date\n- <u>No</u> automatic extension for last minute bids","RoundItem::sealed_bidding_subtitle":"with sealed bids","RoundItem::sealed_bidding_title":"Sealed offer process","RoundItem::sealed_bidding_whentouseitpoints":"- Low/unclear demand\n- Get market feedback\n- Confidential sales, public sector\n- Object difficult to assess","RoundItem::simple_offer_costs":"","RoundItem::simple_offer_howitworkspoints":"- Simple digital bidding\n- Listing price = reference\n- Offer price <u>free</u> selectable\n- Customer can only make <u>one</u> offer\n- No information about possible other interested parties\n- No fixed end date\n- Possibility to flexibly switch to the open offer process if several customers submit offers","RoundItem::simple_offer_subtitle":" ","RoundItem::simple_offer_title":"Digital offer","RoundItem::simple_offer_whentouseitpoints":"- Few potential buyers\n- Long sales process\n- Test readiness to buy\n- Possibility to submit an offer with conditions","RoundItem::when_to_use_it":"When to use it","RoundPanel::round":"Edit round","roundstatus::closed":"Closed","roundstatus::opened":"Opened","roundstatus::started":"New","roundtype::allow_conditions":"Allow conditions","roundtype::counteroffer_bidding":"Counteroffer bidding","roundtype::incremental_auction":"Open bidding","roundtype::open_bidding":"Open bidding","roundtype::sealed_bidding":"Sealed offer process","roundtype::show_invited_customers_count":"Show number of invited customers","roundtype::show_invited_customers_count_tooltip":"Show total number of all invited prospects to each participating customer.","roundtype::simple_offer":"Digital offer","Sale::all_information_entered_by_customer_will_be_overwritten":"All information that the customer has already made will be overwritten.","Sale::already_confirmed":"This customer has already submitted a purchase offer. Submitting another offer on behalf of the customer is not possible.","Sale::billing_notice":"","Sale::cannot_update_documents_for_open_round__documents_uploaded":"The following documents have been uploaded:","Sale::cannot_update_documents_for_open_round__no_documents":"You have not uploaded any documents.","Sale::do_you_want_to_open_the_round":"Do you want to open the round?","Sale::guide__define_offer_form":"The first step is to complete all missing property data.","Sale::guide__edit_round":"If the round data is not correct, adjust it","Sale::guide__import_users_csv":"Import users from CSV file","Sale::guide__invite_users":"To invite interested customers, you need their name, e-mail and mobile number.","Sale::guide__missing_mandatory_offer_form":"Please fill in all required fields!","Sale::guide__open_round":"To publicly open the bidding process and invite individual customers, you must open the round.","Sale::guide__start_round":"You can now select the offer process type and its parameters","Sale::guide__start_round_edit_sale":"You filled out all the mandatory fields in the offer form. You can review or edit them here.","Sale::guide_action__edit_round":"Adjust","Sale::guide_action__edit_sale":"Prepare data for offer letter","Sale::guide_action__import_users_csv":"Import users","Sale::guide_action__invite_bidders":"Invite new customer","Sale::guide_action__open_round":"Open round","Sale::guide_action__start_round":"Start a new round","Sale::guide_action__start_round_edit":"Edit offer form","Sale::guides__manage_the_sale":"Sale wizard","Sale::guides__offers_present":"You can now discuss the \"overview\" of the offers with the seller and then enter his decision in the \"round wizard\".","Sale::guides__round_closed":"This round has now ended. You can prepare the offer overview for the owner and enter the result.","Sale::guides__show_overview":"Overview","Sale::guides__start_open_process":"Switch to Digital offer process","Sale::guides__upgrade":"You have received multiple offers. To optimize the sales result, you can switch to the Digital offer process","Sale::invalid_bid_value":"This offer cannot be accepted. A higher or equivalent offer already exists. Please inform the customer, so that he can adjust his offer.","Sale::loading_sale":"The property is loading","Sale::no_estimate":"no estimate","Sale::no_starting_price":"no starting price","Sale::open_round_deadline_today":"Your Round is expected to end today. Do you really want to open the round?","Sale::open_round_deadline_too_long":"Your round is scheduled to end in {durationInDays} days? Are you sure you want to open the round?","Sale::open_round_info_invalid_duration":"You can't open a round that should end in the past. Please edit the round details.","Sale::open_round_info_notice_incremental_auction_fixed":"You are about to open an <strong>open round with flexible bidding</strong> with <strong>starting price of {startPrice}</strong> which ends <strong>{duration}</strong> on {date} <strong3>at {time}.</strong3>","Sale::open_round_info_notice_incremental_auction_fixed_withstart":"You are about to open an <strong>open round with flexible bidding</strong> with <strong>starting price of {startPrice}</strong> and bidding period starting <strong>{start}</strong> on <strong3>{startDate} at {startTime}</ strong3>, which ends on <strong4>{date} at {time}</strong4> in <strong5>{biddingDuration}</strong5>.","Sale::open_round_info_notice_incremental_auction_flexible":"You are about to open a <strong>open round with flexible bidding</strong> with <strong>starting price of {startPrice}</strong> which ends <strong>{duration} days</strong> after receipt of the first offer.</strong3>","Sale::open_round_info_notice_openbidding_fixed":"You are about to open an <strong>Open</strong> round with <strong>starting price of {startPrice}</strong> that ends <strong>{duration}</strong> on {date} <strong>at {time}.</strong>","Sale::open_round_info_notice_openbidding_fixed_withstart":"You are about to open an <strong>Open</strong> round with <strong>starting price of {startPrice}</strong> that starts <strong>{start}</strong> on <strong>{startDate} at {startTime}</strong> and ends <strong>{duration}</strong> on <strong>{date} at {time}</strong> with a bidding period of <strong>{biddingDuration}</strong>.","Sale::open_round_info_notice_openbidding_flexible":"You are about to open an <strong>Open</strong> round with <strong>starting price of {startPrice}</strong> that ends <strong>{duration} days</strong> after a first offer comes in.","Sale::open_round_info_notice_sealedbidding_fixed":"You are about to open a <strong>sealed</strong> round with <strong>estimate price of {estimate}</strong> that ends <strong>{duration}</strong> on {date} <strong>at {time}.</strong>","Sale::open_round_info_notice_sealedbidding_fixed_withstart":"You are about to open a <strong>sealed</strong> round with <strong>estimate price of {estimate}</strong> that starts <strong>{start}</strong> on <strong>{startDate} at {startTime}</strong> and ends <strong>{duration}</strong> on <strong>{date} at {time}</strong> with a bidding period of <strong>{biddingDuration}</strong>","Sale::open_round_info_notice_sealedbidding_flexible":"You are about to open a <strong>sealed</strong> round with <strong>estimate price of {estimate}</strong> that ends <strong>{duration} days</strong> after a first offer comes in.","Sale::open_round_info_notice_simple_offer_fixed":"You are about to open a <strong>Digital purchase offer round</strong>.","Sale::open_round_info_notice_simple_offer_flexible":"You are about to open a <strong>Digital purchase offer round</strong>.","Sale::sale_connection_unavailable":"Lost the connection to this sale. Please reload the page.","Sale::sale_not_found":"This sale could not be found.","Sale::you_are_about_to_upload_offer_in_the_name_of_customer":"You are uploading the purchase offer on behalf of the customer. Thus, the customer can no longer submit his purchase offer online. It is absolutely necessary to keep the original offer form!","SaleCreatePanel::address":"Address","SaleCreatePanel::agbs":"T&C","SaleCreatePanel::behalf_of":"On behalf of (agent)","SaleCreatePanel::create_new_listing":"Create new listing","SaleCreatePanel::i_agree_to_the_link":"I agree to the {agbs}","SaleCreatePanel::i_agree_with_terms_and_conditions":"I agree with terms and conditions","SaleCreatePanel::image":"Front image of the property","SaleCreatePanel::invite_only":"Participation only for approved agents","SaleCreatePanel::number":"Property ID","SaleCreatePanel::price":"Asking price","SaleCreatePanel::title":"Property description","salepropertytype::business":"Business premises","salepropertytype::flat":"Apartment","salepropertytype::house":"House","salepropertytype::mixed":"Residential and commercial","salepropertytype::office":"Office building","salepropertytype::property":"Property (land plot)","SaleWizard::accept_tc_title":"Accept T&C","SaleWizard::action_functionality":"This function offers the following options:","SaleWizard::award":"You can inform the seller's favoured buyer about the acceptance of his offer, incl. a personal message.\nYou can inform other prospect buyers whose offer has definitely been rejected. These will then be excluded from the further process.\nAll other bidders who are neither the favourite nor among the definitely rejected bidders remain in the process as possible \"substitute buyers\" until the final conclusion of the sale.","SaleWizard::award_subtitle":"Use this function if there is a favoured buyer but you want to keep other bidders in the race as a hedge for the time being.","SaleWizard::award_title":"Select favourite buyer","SaleWizard::awardall":"Choose winner for each property","SaleWizard::awardall_subtitle":"Choose winner for each property","SaleWizard::awardall_title":"Choose winners","SaleWizard::choose_a_winner_title":"Select winner","SaleWizard::choose_offers_for_next_round_title":"Select offers","SaleWizard::choose_offers_to_reject_title":"Rejections","SaleWizard::choose_winners_title":"Choose winners","SaleWizard::confirmaward":"You can confirm the buyer after the  successful completion of the sale.\nAll remaining prospect buyers are automatically informed about the closing of the sale and their offers are finally rejected.\nThe offer process is closed.","SaleWizard::confirmaward_subtitle":"Use this function as soon as you want to confirm the final buyer.","SaleWizard::confirmaward_title":"Confirm final buyer","SaleWizard::counteroffer":"When the buyer accepts the counter-offer value he is confirmed as a buyer and the offer is binding from the seller side\nYou can select one buyer which already submitted an offer\nThen you can specify a counteroffer value and the deadline until which the buyer needs to decide\nThe buyer can either:\nAccept the value and then he is immediately chosen as a selected buyer\nMake a offer that is higher than his previous bid but lower then the counteroffer, in which case the round will be closed and you can then resolve it with the seller\nDo nothing and the round will closed as scheduled","SaleWizard::counteroffer_subtitle":"Use this functionality when you want to make a counter-offer to one potential buyer.","SaleWizard::counteroffer_title":"Counteroffer","SaleWizard::duplicate":"All data and documents already stored for the property are automatically transferred.\nYou can then adjust the details, define the parameters the new process, open the offer round and invite new prospect buyers.","SaleWizard::duplicate_subtitle":"Use this function if you want to start a new offer process with this property.","SaleWizard::duplicate_title":"Start new offer process","SaleWizard::increase":"You can start another offer round (with a new reference price, if applicable) in order to achieve a better final price.\nAll (or selected) bidders of the last round can participate and increase their existing offer; they will be notified  automatically.\nIn addition, new prospect buyers who have not yet participated can be invited.\nAll other previous bidders who have not been selected for this new round will automatically receive a notification with the rejection of their existing offer.","SaleWizard::increase_subtitle":"Use this function if you want to give prospective buyers the opportunity to increase their offer.","SaleWizard::increase_title":"Launch another round of offers","SaleWizard::message_to_buyers_title":"Additional message","SaleWizard::message_to_rejected_title":"Message for rejected offers","SaleWizard::message_to_winner_title":"Additional message","SaleWizard::next_round_details_title":"Next round","SaleWizard::notifyseller":"Let the seller know about the offers of your customers","SaleWizard::notifyseller_subtitle":"Send offer overview to the seller","SaleWizard::notifyseller_title":"Notify Seller","SaleWizard::rejectall":"All prospect buyers who have submitted an offer will be informed of the seller's negative decision.\nThe offer process is closed.","SaleWizard::rejectall_subtitle":"Use this function if the seller does not want to accept any of the offers nor want to continue the offer process.","SaleWizard::rejectall_title":"Reject all offers","SaleWizard::results_title":"Confirmation","SaleWizard::review_title":"Summary","SaleWizard::review_winners_title":"Review winners","SaleWizard::sale_wizard":"Sale wizard","SaleWizard::select_action_title":"How do you want to proceed?","SaleWizardResult::back_to_sale":"Back to offer process","SaleWizardResult::confirmation":"Confirmation","SaleWizardResult::continue_to_the_duplicated_sale":"Continue to the duplicated sale","SaleWizardResult::successful":"We have received your input, within a minute the adjustments are visible in the system.","SaleWizardRoundInfo::ends":"Offer process ends","SaleWizardRoundInfo::estimate":"Estimate","SaleWizardRoundInfo::minimum_price":"Minimum price","SaleWizardRoundInfo::offer_validity":"Purchase offer is valid","SaleWizardRoundInfo::red_button_price":"Red button price","SaleWizardRoundInfo::start_price":"Start price","salutation":"Salutation","salutation::miss":"Miss","salutation::mr":"Mr.","salutation::mrs":"Mrs.","salutation::ms":"Ms.","save":"Save","Search::add_new_listing":"Add new listing","Search::address":"Address","Search::agbs":"T&C","Search::agent_not_found":"You do not have permission to start the offer process for this agent!","Search::area":"Area","Search::avv":"","Search::create_new_listing":"Create new listing","Search::creating":"Creating","Search::dataprotection":"","Search::error_loading_objects":"Error loading objects.","Search::error_retrieving_file":"Error retrieving or storing the file","Search::guide_no_objects":"It seems that there are no available properties at the moment.","Search::i_agree_to_the_link":"I agree to the {agbs}","Search::i_agree_with_terms_and_conditions":"I agree with terms and conditions","Search::loading_details":"Loading details","Search::loading_properties":"Loading properties","Search::my_listings_overview":"To my offer process","Search::number":"Object No","Search::price":"Price","Search::this_object_is_already_active":"There is already an open offer process for this listing","select_master_sale":"Project / development","self_registration":"Self registration by customers","seller":"Seller","seller_type":"Type of seller","SellerInviteSection::block":"Block","SellerInviteSection::invite":"Invite","SellerInviteSection::invite_seller":"Invite seller","send":"Send","sms":"SMS","sms_failed":"SMS notification could not be delivered","start_new_sale":"Start new sale","start_new_test_sale":"Start new test sale","status":"Status","street":"Street","street_and_house_number":"Street name and house number","submit":"Submit","submitted_on":"Submitted on","submitted_value":"Offer value","summary":"Summary","swiss_residential_status":"Swiss residential status","tax_code_is_incorrect":"Tax code is incorrect","template::cust_message":"Generic message","test_sale_explanation":"Use the test sale process if you want to test an offer procedure internally. You will not be charged for this sale. Do not invite external real customers into the sale. All pages and notifications will be marked as \"Test\".","test_sale_watermark":"Demo sale","this_action_cannot_be_undone":"This action cannot be undone.","title":"Title","title::doctor":"Ph.D.","title::master":"Mag.","title::professor":"Prof.","true":"Yes","type_of_property":"Type of property","updated_on":"Updated on","upload":"Upload","upload_more":"Upload more","uploading":"Uploading","uploads":"Uploads","uploadtype::identification_document":"Identification documents","uploadtype::misc":"Miscellaneous","value_must_be_between_min_and_max":"Value must be between {min} and {max}","Whitelisting::whitelisting_done":"MLS participation request accepted","WhitelistingPanel::accept":"Accept","WhitelistingPanel::action":"Action","WhitelistingPanel::block":"Block","WhitelistingPanel::blocked":"Blocked","WhitelistingPanel::requested":"Requested","WhitelistingPanel::whitelisted":"Accepted","WhitelistingPanel::whitelisting":"MLS configuration overview","would_you_like_to_continue":"Would you like to continue?","yes":"Yes","zip_code":"ZIP code"}

/***/ }),
/* 893 */
/***/ (function(module, exports) {

module.exports = {"active":"Activo","add":"Añadir","additional_address":"Dirección adicional","additional_description":"Descripción e información adicional","additional_information_text":"Información adicional","address":"Dirección","agent":"Agente","AgentProvisionForm::agent_commission":"Comisión del agente","AgentProvisionForm::fixed_amount":"Importe fijo","AgentProvisionForm::fixed_amount_excluding_vat":"Importe fijo (sin IVA)","AgentProvisionForm::no_commission":"Sin comisión","AgentProvisionForm::percentage":"Porcentaje","AgentProvisionForm::percentage_excluding_vat":"Porcentaje (sin IVA)","AgentProvisionForm::standard":"Estándar","allowed_file_formats":"Tenga en cuenta que sólo se admiten los siguientes formatos de archivo: PDF, JPG y PNG.","and":"y","App::initializing":"Inicializando","are_you_sure_this_action_cannot_be_undone":"¿Está seguro? Esta acción no se puede deshacer.","auction_finals":"Fin de la subasta","AuctionFinalsList::no_offer_selected_for_awardwing_go_back_to_the_matrix_and_pick_some":"No se ha seleccionado ninguna oferta para la adjudicación; vuelva atrás y elija una.","AuctionFinalsList::object_no":"Nº de objeto","AuctionFinalsList::selected_buyer":"Comprador seleccionado","AuctionFinalsList::total":"Total","AuctionFinalsMatrix::awarded":"Concedido","AuctionFinalsMatrix::clear_selection":"Borrar selección","AuctionFinalsMatrix::for_each_property_pick_the_best_available_offer":"Para cada propiedad elija la mejor oferta disponible","AuctionFinalsMatrix::for_each_property_pick_the_highest_offer_if_it_is_the_most_preferred_offer_of_the_highest_bidder":"Para cada propiedad elija la oferta más alta si es la preferida por el mejor ofertante","AuctionFinalsMatrix::for_each_property_pick_the_highest_offer_if_the_highest_bidder_has_not_been_assigned_to_another_property_yet":"Para cada propiedad, elija la oferta más alta si el mejor ofertante aún no ha sido asignado a otra propiedad.","AuctionFinalsMatrix::position":"Posición","AuctionFinalsMatrix::preference":"Preferencia","AuctionFinalsMatrix::property":"Propiedad","AuctionFinalsMatrix::select_best_offers":"Seleccione las mejores ofertas","AuctionFinalsMatrix::select_highest_offers":"Seleccione las ofertas más altas","AuctionFinalsMatrix::select_preferred_highest_offers":"Seleccione las ofertas preferentes más altas","AuctionFinalsMatrix::this_is_the_highest_offer_for_this_property_but_its_not_selected":"Esta es la oferta más alta para esta propiedad, pero no está seleccionada","AuctionFinalsMatrix::this_is_the_most_preferred_offer_for_this_buyer_but_its_not_selected":"Esta es la oferta más preferida por este comprador, pero no está seleccionada","AuctionFinalsPanel::awarded":"Concedido","AuctionFinalsPanel::confirm":"Confirme","AuctionFinalsPanel::continue":"Continúe en","AuctionFinalsPanel::error_loading_data_from_server":"Error al cargar datos del servidor","AuctionFinalsPanel::failed":"Fallida","AuctionFinalsPanel::report":"Informe","AuctionFinalsPanel::review_winners":"Ganadores de la revisión","AuctionFinalsPanel::select_winners":"Seleccionar ganadores","AuctionFinalsPanel::selected":"Selección","AuctionFinalsPanel::succeeded":"Ha tenido éxito","AuctionFinalsPanel::total":"Total","AuctionFinalsTotals::awarded":"Concedido anteriormente","AuctionFinalsTotals::selected":"Actualmente seleccionado","AuctionFinalsTotals::total":"Total","AwardAllStep1::loading_offers_please_wait":"Cargando ofertas, por favor espere","AwardStep1::choose_a_winner":"Elija un ganador","AwardStep1::expiration_date":"Elija el periodo","AwardStep2::expiration_date":"Periodo de validez de la oferta","AwardStep2::select_customers_to_reject_theirs_offer":"Seleccione las ofertas que desee rechazar inmediatamente. \nEstos clientes recibirán inmediatamente una notificación de anulación. \nEl resto de clientes no recibirán ninguna notificación por el momento por si desea elegir otro comprador más adelante.","AwardStep2::this_text_will_appear_as_an_additional_note":"Este texto aparecerá como nota adicional en la notificación al ganador:","AwardStep4::reject_message":"Mensaje adicional para los compradores potenciales rechazados","AwardStep4::this_text_will_appear_as_an_additional_note":"Este texto aparecerá como nota adicional en la notificación","AwardSummary::if_you_click_finish_you_confirm_the_winner":"Si hace clic en \"Finalizar\", confirma el ganador. El comprador seleccionado recibirá una notificación. Este paso no se puede deshacer.","AwardSummary::rejected_customers_offers":"Ofertas rechazadas","AwardSummary::selected_winner":"Ganador seleccionado","back":"Volver","behalf_of":"En nombre de","bid_amount":"Importe de la oferta","bidding_type":"Tipo de proceso de oferta","BiddingSection::highest_bidder":"Mejor ofertante","BiddingSection::round_opens_on":"El proceso de oferta se abre el","BiddingSection::the_highest_offer":"La oferta más alta","BiddingSection::the_next_minimum_offer":"La siguiente oferta mínima","BlockDialog::block":"Bloquear","BlockDialog::block_agent":"Denegar la solicitud","BlockDialog::reason":"Motivo de la decisión","BulkRegistrationCsvPanel::back_to_mapping":"Volver a la selección","BulkRegistrationCsvPanel::duplicate_description":"El registro ya existe","BulkRegistrationCsvPanel::import_from_csv_file":"Importar desde archivo CSV","BulkRegistrationCsvPanel::invalid_description":"Registro incompleto","BulkRegistrationCsvPanel::total_number_of_rows_count":"Número total de filas: {count}","BulkRegistrationCsvPanel::valid_description":"Registro completo","BulkRegistrationInventoryPanel::duplicate_description":"El registro ya existe","BulkRegistrationInventoryPanel::entries_with_duplicate_emails_count":"Entradas con correos duplicados: {count}","BulkRegistrationInventoryPanel::failed_registrations":"Registros fallidos: {conteo}","BulkRegistrationInventoryPanel::importing":"Importando datos","BulkRegistrationInventoryPanel::invalid_description":"Registro incompleto","BulkRegistrationInventoryPanel::invalid_entries_count":"Entradas no válidas: {count}","BulkRegistrationInventoryPanel::successful_registrations":"Inscripciones con éxito: {count}","BulkRegistrationInventoryPanel::total_number_of_entries_count":"Número total de entradas: {count}","BulkRegistrationInventoryPanel::valid_description":"Registro completo","BulkRegistrationTable::already_registered":"Ya está registrado","BulkRegistrationTable::invalid_email":"Correo electrónico no válido","BulkRegistrationTable::saving_error":"Error al cargar los datos","BulkRegistrationTable::select__unselect_all":"Seleccionar / deseleccionar todo","BuyerDocumentSelector::none":"Ninguno","BuyerDocumentSelector::not_required":"No es necesario","BuyerDocumentSelector::optional":"Opcional","BuyerDocumentSelector::required":"Obligatorio","buyertype::company":"Empresa","buyertype::entrepreneurs":"Empresario individual","buyertype::private":"Particular","CallbackComponent::redirecting":"Estoy redirigiendo","cancel":"Cancelar","citizenship":"Nacionalidad","city":"Ciudad","close":"Cerrar","combobox_placeholder_free_text":"Elija una opción de la lista o proporcione la suya propia","Commands::accept":"Confirmar para la próxima ronda","Commands::all_offers":"Todas las ofertas","Commands::approve":"Aprobar","Commands::approveregistration":"Activar clientes","Commands::are_you_sure_this_action_can_not_be_undone":"¿Está seguro? Esta acción no se puede deshacer.","Commands::are_you_sure_to_block_user":"¿Está seguro? ¡El cliente será bloqueado del sistema!","Commands::are_you_sure_to_close_the_sale":"¿Está seguro? El proceso de licitación finalizará inmediatamente.","Commands::are_you_sure_to_end_round_early":"¿Está seguro? Si cierra el proceso no se podrán presentar más ofertas.","Commands::are_you_sure_to_end_round_early_sealed":"¿Está seguro? Si cierra el proceso no se podrán presentar más ofertas y se revelarán todos los precios de oferta.","Commands::award":"Aceptar la oferta","Commands::blank_offer":"Oferta en blanco PDF","Commands::block_user":"Bloquear al cliente","Commands::close_sale":"Terminar el proceso de oferta","Commands::confirm":"Confirmar para el cliente (TAN)","Commands::delete_sale":"Eliminar el proceso de oferta","Commands::download_documents":"Descargar documentos","Commands::end_round_early":"Terminar el proceso de oferta prematuramente","Commands::import_registrations_from_crm":"Importar desde CRM","Commands::import_registrations_from_csv_file":"Importar desde archivo CSV","Commands::import_registrations_from_onoffice":"Importar desde onOffice","Commands::import_registrations_from_propstack":"Importar desde Propstack","Commands::import_registrations_from_propup":"Importar desde PropUp","Commands::invite_seller":"Invitar al vendedor","Commands::new":"Comenzar nueva ronda","Commands::offer":"Ofertas","Commands::pdf_export":"Imprimir (PDF)","Commands::refuse":"Rechazar por deficiente","Commands::refuseregistration":"Rechazar clientes","Commands::register_new_user":"Invitar a un nuevo cliente","Commands::registration":"Inscripciones","Commands::reject":"Rechazar","Commands::round_close":"Terminar prematuramente","Commands::round_open":"Proceso abierta","Commands::sale":"Proceso de oferta","Commands::sale_wizard":"Asistente","Commands::upload":"Cargar la oferta en nombre del cliente","Commands::whitelisting":"Configuración MLS","company":"Empresa","company_court":"Tribunal local","company_id":"ID","company_name":"Nombre de la empresa","Confirmation::confirmation_expired":"El TAN introducido es incorrecto o ha caducado","Confirmation::invalid_bid_value":"El precio de compra es demasiado bajo","Confirmation::invalid_confirmation":"El TAN introducido es incorrecto o ha caducado","Confirmation::sale_round_not_opened":"Su oferta no puede ser aceptada porque el periodo de oferta ha terminado","ConfirmAwardStep1::choose_a_winner":"Elija un ganador","ConfirmAwardStep1::expiration_date":"Periodo de validez de la oferta","ConfirmAwardStep1::reject_message":"Mensaje adicional para los compradores potenciales rechazados","ConfirmAwardStep1::this_text_will_appear_as_an_additional_note":"Este texto aparecerá como nota adicional en la notificación","ConfirmAwardSummary::if_you_click_finish_you_confirm_the_winner":"Al hacer clic en \"Finalizar\", confirma al comprador. Todas las demás ofertas se rechazan y se notifica a los clientes. \nEste paso no se puede deshacer.","ConfirmAwardSummary::rejected_customers_offers":"Ofertas rechazadas","ConfirmAwardSummary::selected_winner":"Ganador seleccionado","costs":"Costes","Countdown::das_verfahren_ist_beendet":"El proceso de oferta está cerrado","CounterofferStep2:: please_define_the_next_round":"Por favor, defina el siguiente proceso de oferta","CounterofferStep2::please_define_the_next_round":"Por favor, defina el siguiente proceso de oferta","CounterofferStep2::validity_of_offers_set_to_the_same_value":"Validez de las ofertas fijadas en el mismo valor","CounterofferSummary::click_finish_to_start_a_new_round":"Haga clic en \"Finalizar\" para iniciar un nuevo proceso de oferta","CounterofferSummary::customers_for_the_next_round":"Seleccionar a los clientes que deben participar en el siguiente proceso de oferta","CounterofferSummary::customers_not_participating_in_the_next_round":"Seleccionar a los clientes que no deben participar en el siguiente proceso de oferta","CounterofferSummary::round_details":"Detalles del proceso de oferta","country":"País","created_on":"Creado el","CsvMappingTable::do_not_import":"No importar","customer":"Cliente","customer_buyer_reference_of_name":"Cliente {referencia_comprador} de {nombre}","customer_name":"Nombre del cliente","customer_of_name":"Cliente de {nombre}","Dashboard::authorization_in_progress":"Autorización en curso","Dashboard::customer_service_contact":"Contacto del servicio de atención al cliente","Dashboard::customer_service_email":"support@propnow.com","Dashboard::customer_service_p":"Si tiene preguntas o problemas, puede ponerse en contacto con nosotros de la siguiente manera:","Dashboard::customer_service_telephone":"+49 30 959992518","Dashboard::customer_service_telephone_href":"+49 30 959992518","Dashboard::do_you_really_want_to_log_out":"¿De verdad quiere cerrar la sesión?","Dashboard::log_out":"Cerrar sesión","Dashboard::tel__sms__whatsapp":"Teléfono","date":"Fecha","date_of_birth":"Fecha de nacimiento","DateField::dateformat":"dd.mm.aaaa","DateField::invalid_date":"Fecha no válida","days":"Días","delete":"Borrar","deposit_payment_deadline":"Fecha límite de pago del depósito","depositRequired::false":"No","depositRequired::true":"Sí","doc_from":"de","Doc::from":"de","Doc::no_type":"Por favor, asigne el tipo de documento","Doc::original_name":"Cargado como {originalFilename} el {uploadedAt, date, medium} {uploadedAt, time, medium}","documents":"Documentos","documenttype::annual_statement":"Declaración anual","documenttype::appraisal":"Valoración","documenttype::area_allocation_plan":"Plan de asignación de zonas","documenttype::building_permit":"Permiso de construcción","documenttype::completion_display":"Pantalla de finalización","documenttype::condominium_contract":"Contrato de condominio","documenttype::energy_certificate":"Certificado de eficiencia energética","documenttype::expose":"Folleto de la propiedad","documenttype::expose_long":"Descripción de la propiedad (Folleto)","documenttype::land_register":"Extracto del Registro de la Propiedad","documenttype::loan_agreement":"Acuerdo de préstamo","documenttype::operating_costs":"Costes de explotación","documenttype::operating_costs_long":"Costes de explotación / costes de mantenimiento y mejora previstos ","documenttype::promissory_note":"Pagaré","documenttype::running_costs":"Exigencia de gastos de funcionamiento","documenttype::usage_permit":"Permiso de uso","DuplicateStep1::agbs":"Condiciones de Uso","DuplicateStep1::duplicating_sale":"Duplicar los datos de la venta","DuplicateStep1::hint1":"Todos los datos y documentos relacionados con la oferta se copian","DuplicateStep1::hint2":"A continuación, puede ajustar la información, definir los detalles del nuevo proceso de oferta e invitar a nuevos clientes","DuplicateStep1::i_agree_to_the_link":"Estoy de acuerdo con los {agbs}","DuplicateStep1::i_agree_with_terms_and_conditions":"Estoy de acuerdo con los Condiciones de Uso","DuplicateSummary::duplicating_sale":"Duplicar los datos de la venta","duration":"Duración","duration_type":"Periodo de validez de las ofertas","durationtype::fixed":"Fijo","durationtype::flexible":"Flexible","edit":"Modificar","EditPanel::edit_offer_form":"Preparar los datos para la oferta de compra","email":"Correo electrónico","email_failed":"No se ha podido entregar la notificación por correo electrónico","EmailField::invalid_email":"La dirección de correo electrónico no es correcta","encoding":"Codificación","Error::blocked":"La página a la que intenta acceder no existe. O bien se ha equivocado de enlace o el proceso de oferta digital ya ha finalizado. Encontrará más propriedades en:","false":"No","field::depositrequired":"Depósito","field::email":"Correo electrónico","field::firstname":"Nombre","field::lastname":"Apellido","field::locale":"Idioma preferido","field::phone":"Número de móvil","field::salutation":"Saludo","field::title":"Título","fill_required_fields":"Rellene todos los campos obligatorios","financing_required":"Financiación necesaria","financing_secured":"Financiación asegurada","first_name":"Nombre","handover":"Entrega","handovertype::key_handover":"Tras la entrega de llaves","handovertype::land_register":"Tras la inscripción en el Registro de la Propiedad","handovertype::money_transfer":"Tras la transferencia del precio de compra a una cuenta predefinida","handovertype::sale_contract":"Según el contrato de compraventa","hidden":"oculto","house_number":"Número","iban":"IBAN","iban_is_not_valid":"IBAN es incorrecta","image":"Imagen","import":"Importar","IncreaseStep1::all_other_offers_will_be_rejected":"Todas las demás ofertas serán rechazadas y no tendrán la oportunidad de participar en otro proceso de oferta.","IncreaseStep1::expiration_date":"Elija el periodo","IncreaseStep1::invite_more_customers_after_start_of_next_round":"Tras el inicio del siguiente proceso de oferta, tendrá la oportunidad de invitar a más clientes interesados.","IncreaseStep1::select_customers":"Seleccione los clientes que participarán en el siguiente proceso de oferta.","IncreaseStep2::please_define_the_next_round":"Por favor, defina la siguiente ronda del proceso de oferta.","IncreaseStep2::validity_of_offers_set_to_the_same_value":"El tiempo de validez de las ofertas de compra de las demás ofertas se fijó automáticamente en el mismo valor que en el proceso anterior.","IncreaseStep3::this_text_will_appear_as_an_additional_note":"Este texto aparecerá como nota adicional en la notificación al cliente:","IncreaseSummary::click_finish_to_start_a_new_round":"Si pulsa \"Finalizar\", se iniciará una nueva ronda del proceso de oferta y se informará a los clientes.","IncreaseSummary::customers_for_the_next_round":"Clientes para la próxima ronda del proceso de oferta","IncreaseSummary::customers_not_participating_in_the_next_round":"Clientes que no participan en la siguiente ronda del proceso de oferta","IncreaseSummary::round_details":"Detalles de la próxima ronda del proceso de oferta","last_name":"Apellido","legal_entity":"Entidad jurídica","legal_form":"Forma jurídica","ListingsOverview::add_new_listing":"Añadir nueva propiedad","ListingsOverview::agent":"Agente","ListingsOverview::approved_offers":"Clientes aprobados","ListingsOverview::create_new_listing":"Crear una nueva propiedad","ListingsOverview::end_date":"Fecha final","ListingsOverview::guide__you_should_add_a_new_listing":"Para iniciar un proceso de oferta, primero debe seleccionar una propiedad.","ListingsOverview::loading_listings":"Cargando propriedades","ListingsOverview::my_listings_overview":"Mis propiedades","ListingsOverview::number":"Propriedad nº","ListingsOverview::pending_offers":"Ofertas pendientes","ListingsOverview::start_date":"Fecha de inicio","loading":"Cargando","locale":"Idioma preferido","locale::de":"Alemán","locale::dech":"Alemán","locale::dede":"Alemán","locale::en":"Inglés","locale::es":"Español","locale::eses":"Español","locale::fi":"Finlandes","locale::fifi":"Finlandes","locale::fr":"Francés","locale::frch":"Francés","locale::frlu":"Francés","locale::it":"Italiano","locale::itch":"Italiano","locale::itit":"Italiano","locale::ro":"Rumano","locale::roro":"Rumano","locale::sl":"Esloveno","locale::slsi":"Esloveno","manage":"Gestionar","ManagePanel::administration":"Administración","ManagePanel::my_data":"Mis datos","ManagePanel::object_supervisor":"Supervisor de la propriedad","marital_status":"Estado civil","maritalstatus::divorced":"Divorciado","maritalstatus::married":"Casado","maritalstatus::none":"No aplicable","maritalstatus::single":"Soltero","maritalstatus::widowed":"Viuda","message":"Mensaje","mls":"MLS","mls::everyone":"MLS gratuito","Mls::loading_mls":"Cargando los procesos de oferta MLS","Mls::no_sale_for_mls":"Actualmente no hay ninguna venta disponible","mls::none":"No MLS","Mls::request_access":"Participar en el proceso de oferta digital","Mls::request_access_description":"¿Desea participar en este proceso de oferta digital e invitar a sus clientes interesados? Su solicitud será revisada por el agente de ventas y en breve recibirá una respuesta por correo electrónico y en su Dashboard.","mls::tenant":"MLS sólo dentro de la propia red","more":"más","name":"Nombre","next":"Siguiente","no":"No","not_entered":"No introducido","notary":"Notario","notificationcaption::all_customers":"Todos los clientes","notificationcaption::customer":"Cliente","notificationcaption::customers_invited_to_the_next_round":"Clientes invitados a la siguiente ronda del proceso de oferta","notificationcaption::other_customers":"Otros clientes","notificationcaption::seller":"Vendedor","notificationcaption::winner":"Ganador","notificationemailtemplate::cust_bid_refused":"Oferta rechazada","notificationemailtemplate::cust_highest_bidder":"Cliente con oferta más alta","notificationemailtemplate::cust_highest_bidder_changed":"Nueva oferta más alta","notificationemailtemplate::cust_invited":"Invitar a los clientes","notificationemailtemplate::cust_message":"Mensaje","notificationemailtemplate::cust_offer_awarded":"Oferta aceptada","notificationemailtemplate::cust_offer_placed":"Oferta presentada","notificationemailtemplate::cust_offer_raised":"Aumentar la oferta","notificationemailtemplate::cust_offer_refused":"Rechazar la oferta","notificationemailtemplate::cust_outbid":"Oferta sobrepujada","notificationemailtemplate::cust_outbid_antisniping":"Oferta fue superada","notificationemailtemplate::cust_outbid_others":"Nueva oferta más alta","notificationemailtemplate::cust_phase_invite_closing":"Recordatorio - fase de inscripción","notificationemailtemplate::cust_phase_offer_starting":"Recordatorio - ha comenzado la presentación de ofertas","notificationemailtemplate::cust_phase_wishlist_closing":"Recordatorio - finaliza la selección de propriedades","notificationemailtemplate::cust_rejected_round_closed":"Oferta rechazada","notificationemailtemplate::cust_rejected_sold":"Oferta rechazada","notificationemailtemplate::cust_rejected_unsold":"Oferta rechazada","notificationemailtemplate::cust_round_closed":"Proceso de oferta ha terminado","notificationemailtemplate::cust_round_closing":"Recordatorio","notificationemailtemplate::cust_round_edited":"Proceso de oferta fue modificado","notificationemailtemplate::cust_round_opened":"Nueva ronda del proceso de oferta iniciada","NotificationPreview::no_notification_defined_for_the_selected_action":"No se enviará ninguna notificación para la acción seleccionada","notifications":"Notificaciones","notificationservicestatus::delivered":"Entregado","notificationservicestatus::failed":"Fallida","notificationservicestatus::pending":"Pendiente","notificationservicestatus::sent":"Enviado","NotificationsPanel::explanation":"Si desea recibir notificaciones por correo electrónico y SMS sobre las actividades del proceso de oferta de esta propiedad, active la función:","NotifySellerSummary::description":"Las ofertas de compra de los siguientes clientes se enviarán directamente al vendedor por correo electrónico:","now":"Ahora","null":"N/A","number":"Número","offer":"Oferta","offer_viewing":"Propiedad visitada el","offer_viewing_help":"Por favor, déjelo vacío si no ha habido ninguna visita","OfferDetailsForm::agreement_installer__lawyer":"Notario/Abogado","OfferDetailsForm::other_agreements":"Otros acuerdos","OfferDetailsForm::purchase_offer_valid_until":"Oferta de compra válida hasta el","OfferDetailsForm::purchase_price_gross":"Precio de compra (bruto)","OfferNotificationDetails::service_data":"Datos del servicio","OfferNotificationsList::created_on":"Enviado el ","OfferNotificationsList::error_loading":"Fallo al cargar la lista de notificaciones","OfferNotificationsList::recipient":"Destinatario","OfferNotificationsList::service_status":"Estado del servicio","OfferNotificationsList::template":"Plantilla","OffersSection::hidden":"Actualmente oculto","OffersSection::increase_offer_on_behalf_of_the_customer":"Aumentar la oferta en nombre del cliente","OffersSection::invited_on":"Invitado el","OffersSection::submitted_at":"Entregado el","OffersSection::submitted_value":"Precio de oferta","OffersSection::upload_offer_on_behalf_of_a_customer":"Cargar la oferta en nombre del cliente","offerstatus::accepted":"Confirmado","offerstatus::approved":"Aprobado","offerstatus::awarded":"Aceptado","offerstatus::confirmed":"Entregado","offerstatus::invited":"Invitado","offerstatus::refused":"Rechazado","offerstatus::registrationconfirmed":"A la espera de la activación","offerstatus::registrationsubmitted":"Inscripción presentada","offerstatus::rejected":"Rechazado","offerstatus::submitted":"Preparado (sin TAN)","offerstatus::updated":"En curso","ok":"OK","open":"Abierto","optional":"Opcional","other_agreements":"Otros acuerdos","overview":"Resumen","ownership":"Tipo de titularidad","ownershiptype::residential":"Residencial","ownershiptype::share":"Titularidad parcial","ownershiptype::sole":"Titularidad conjunta","Page1::area":"Superficie","Page1::construction_year":"Año de construcción","Page1::deed":"Registro de la propiedad","Page1::deed_kg":"KG","Page1::energy_certificate":"Certificado energético","Page1::housing_subsidies":"Subvenciones a la vivienda","Page1::object_number":"Número de objeto","Page1::ownership_share":"Cuota","Page1::ownership_total":"Total","Page1::register_number":"Número de registro","Page1::usage_rules":"Normas de uso","Page2::date_of_delivery_warranty":"Fecha de entrega, garantía","Page2::date_of_delivery_warranty_contract":"Fecha de entrega, garantía, contrato","Page2::exceptions":"Excepciones","Page2::handover_date":"Fecha de entrega","Page2::mortgage":"Hipoteca","Page2::mortgage_detail":"Detalles de la hipoteca","Page2::notary":"Notario","Page2::vatliable_purchase":"Compra sujeta al IVA","Page3::all_documents_must_have_a_type_set":"Todos los documentos deben tener un tipo especificado","Page3::choose_a_document_type_or_enter_description":"Elija un tipo de documento o introduzca la descripción","Page3::document_type":"Tipo de documento","Page3::section__property":"Otros documentos sobre la propiedad","Page3::upload_following_documents":"Por favor, cargue al menos los siguientes documentos","peptype::family":"Miembro de familia de un PEP","peptype::no":"No","peptype::related":"Relación cercana con un PEP","peptype::yes":"El comprador es un PEP","person":"Persona","phone_number":"Número de móvil","phone_number_placeholder":"+34 xxx xxxx xxxx","phonenumbererror::invalid":"El número de teléfono no es válido","phonenumbererror::notmobile":"El número de teléfono no es de un móvil","place_of_birth":"Lugar de nacimiento","politically_exposed_person_pep":"Persona políticamente expuesta (PEP)","post_code":"Código postal","postal_code":"Código postal","preview":"Vista previa","previous":"Volver","previous_round":"Proceso de oferta previo","price_on_offer":"Precio contra oferta","price_on_request":"Precio a consultar","private_person":"Particular","processing":"En proceso","property_for_sale":"Propiedad en venta","provision":"Comisión del comprador","ProvisionAck::i_have_taken_note_of_the_following_important_information":"He tomado nota de la siguiente información importante","provisiontype::default":"Estándar","provisiontype::fixed_amount":"Importe fijo (sin IVA)","provisiontype::fixed_percentage":"Porcentaje (sin IVA)","provisiontype::none":"Sin comisión","purchase_price":"Precio de compra","recipient":"Destinatario","refresh":"Actualizar","RefuseDialog::explanation":"Informe al cliente del motivo del rechazo.","RefuseDialog::reason":"Razón","RefuseDialog::refuse_an_offer":"Rechazar una oferta","register":"Invitar","registering":"Invitando","RegistrationPanel::already_registered":"¡Ya ha invitado a un cliente con esta dirección de correo electrónico!","RegistrationPanel::offer_viewing":"Propiedad visitada el","RegistrationPanel::place_at":"Recibido el","RegistrationPanel::purchase_price_gross":"Precio de compra (bruto)","RegistrationPanel::register_new_user":"Invitar a nuevos clientes","RegistrationPanel::send_the_invitation_again":"Enviar invitación de nuevo","RegistrationPanel::upload_an_offer":"Cargar oferta (en nombre del cliente)","RegistrationPanel::upload_new_offer":"Cargar una nueva oferta en nombre del cliente","RegistrationPanel::upload_offer":"Cargar oferta","RejectSummary::click_finish_to_reject_all_offers":"Si pulsa \"Finalizar\", se rechazarán todas las ofertas y se informará a los clientes.","remove":"Eliminar","required_documents":"Documentos necesarios","round":"Ronda","RoundEdit::allow_bidding_below_starting_price":"Permitir ofertas por debajo del precio inicial","RoundEdit::allow_bidding_below_starting_price__tooltip":"En el proceso de oferta abierta, los interesados normalmente sólo pueden pujar a partir del precio de salida, lo que puede significar que los clientes más sensibles al precio a menudo no pujen. Con esta opción, usted ofrece a los interesados la oportunidad de presentar una oferta <u>por debajo de</u> el precio de salida - pero por encima del precio mínimo (inicialmente oculto) fijado por el intermediario. Esto tiene la ventaja de que más partes interesadas presentan una oferta, ya que también se permiten ofertas de menor precio. Esto crea un campo más amplio de licitadores y, por tanto, puede aumentar las posibilidades de venta. Todas las ofertas por debajo del precio de salida se ocultan a los demás interesados para evitar un efecto ancla negativo. Por defecto, sólo se muestran las ofertas a partir del precio de salida, a menos que active la opción \"Mostrar ofertas por debajo del precio de salida a otros licitadores\".","RoundEdit::allow_bidding_below_starting_price_hidden":"Permitir ofertas por debajo del precio inicial","RoundEdit::antisniping_notice":"El final del periodo de oferta se prorroga automáticamente 15 minutos si se recibe una nueva oferta en los últimos 15 minutos antes del final previsto. Esta prórroga se repite hasta que no se reciban más ofertas durante 15 minutos.","RoundEdit::bidding_steps":"Aumento mínimo de la oferta","RoundEdit::bidding_steps__standard":"Incrementos de oferta estándar predefinidos","RoundEdit::bidding_steps__tooltip":"Esta es la cantidad mínima de incremento para las nuevas ofertas. Cada nueva oferta debe ser al menos esta cantidad superior a la oferta más alta actual. Si ha seleccionado la opción \"Permitir ofertas por debajo de la oferta más alta\", el incremento mínimo de la puja se refiere a la oferta anterior del cliente individual si ya ha realizado una oferta (para más información, consulte el botón info: \"Permitir ofertas por debajo de la oferta más alta\")","RoundEdit::bidding_type_tooltip":"Elija el tipo de proceso de oferta","RoundEdit::counteroffer_value":"Valor de la contraoferta propuesta","RoundEdit::end_date_changed":"Todos los clientes y agentes serán notificados del cambio del final del proceso de oferta por correo electrónico.","RoundEdit::ends_at":"Fin del proceso de oferta","RoundEdit::ends_at__tooltip":"Para el final del proceso de licitación, recomendamos elegir una hora en la que los interesados estén disponibles y en un lugar con una buena conexión a Internet (por ejemplo, en casa). La experiencia ha demostrado que las primeras horas de la tarde o los fines de semana funcionan muy bien en este caso. No obstante, tenga en cuenta los días festivos o los puentes cuando los interesados puedan estar fuera de casa. También es importante informar a los interesados sobre el horario. Al final del periodo de licitación, se enviarán recordatorios a los interesados invitados 72 horas, 24 horas y 60 minutos antes del final previsto. También le recomendamos que, como agente, esté disponible por teléfono durante la última hora antes del final de la puja y, si es necesario, siga el proceso de puja en directo en su ordenador portátil o tableta para poder ayudar a los interesados con cualquier pregunta o problema (por ejemplo, una mala conexión a Internet del interesado).","RoundEdit::estimate":"Valor estimado","RoundEdit::estimate__tooltip":"El precio objetivo es un precio de referencia que se comunica al posible comprador como orientación para ayudarle a determinar su propio precio de oferta. Importante: el precio objetivo no representa un precio mínimo; es decir, el interesado también puede presentar una oferta por debajo del precio objetivo.","RoundEdit::estimate_lower_than_startprice":"El valor estimado no puede ser inferior al precio mínimo","RoundEdit::flexible_bidding":"Permitir ofertas por debajo de la oferta más alta","RoundEdit::flexible_bidding__tooltip":"En el proceso de oferta abierta, las partes interesadas deben presentar normalmente una nueva oferta máxima con cada nueva oferta, lo que puede dar lugar a que algunas partes interesadas abandonen antes de tiempo o tal vez no pujen en absoluto. Al seleccionar esta opción de oferta flexible, la parte interesada tiene la opción de presentar una oferta <u>por debajo de</u> la oferta máxima actual. Sin embargo, la nueva oferta debe ser <u>superior a</u> el precio de la oferta anterior del cliente correspondiente si ya ha presentado una oferta. El incremento mínimo de la oferta es decisivo en este caso y sólo se aplica <b>a su propia oferta</b>. La ventaja de esta opción de puja es que los interesados individuales pujan con más frecuencia y se crea un campo intermedio más fuerte porque los pujadores no abandonan antes de tiempo. Esto puede aumentar las posibilidades de venta, sobre todo cuando sólo hay unos pocos interesados o si el precio de salida es un poco demasiado alto.","RoundEdit::hide_highest_bid__bid_history_for_nonbidders":"Mostrar otras ofertas sólo <strong>después</strong> de que el cliente haya enviado su propia oferta","RoundEdit::hide_highest_bid__bid_history_for_nonbidders__tooltip":"Por razones de transparencia, la oferta más alta, así como todas las ofertas de compra presentadas, se muestran normalmente a todos los invitados en el proceso de oferta abierta desde el principio, incluso antes de que ellos mismos hayan presentado una oferta. En algunos casos, esto puede llevar a que algunos interesados, disuadidos por los ya muy altos precios de las ofertas, ni siquiera presenten una oferta aunque les hubiera gustado hacerlo. Esta opción de oferta puede ser útil para evitarlo y para motivar a cualquiera que esté dispuesto a comprar a presentar también una oferta de compra.","RoundEdit::invalid_starting_price":"Introduzca un precio inicial válido","RoundEdit::min_price":"Precio mínimo","RoundEdit::min_price__tooltip":"Precio mínimo de compra que el cliente debe ofrecer. Sólo se muestra, si el cliente quiere poner una oferta por debajo de este precio.","RoundEdit::minimum_price":"Precio mínimo","RoundEdit::offer_validity":"Validez de las ofertas de compra","RoundEdit::open_round_warning":"En el proceso de oferta abierta, sólo se realiza una ronda y los precios ofertados se revelan a todos.","RoundEdit::please_enter_a_starting_price":"Introduzca un precio superior a cero","RoundEdit::red_button_price":"Precio mínimo del vendedor","RoundEdit::red_button_price__tooltip":"Es el precio mínimo (estimado) al que el propietario está dispuesto a vender. Se trata de un precio puramente interno que no se comunica a los clientes y sólo es visible para el agente. Al alcanzar este precio, se informa inmediatamente al agente.","RoundEdit::select_a_bidding_type":"Seleccione un tipo de proceso de oferta","RoundEdit::show_bids_below_starting_price":"Mostrar ofertas por debajo del precio de salida a otros licitadores","RoundEdit::show_bids_below_starting_price__tooltip":"Por defecto, sólo se muestran las ofertas <u>a partir de</u> el precio de salida, a menos que active esta opción. Entonces también se muestran las ofertas <u>por debajo de</u> el precio de salida y usted tiene una mayor transparencia en el proceso de oferta.","RoundEdit::simple_offer_duration_suggestion_notice":"Esta es la propuesta de validez de la oferta de compra. No obstante, el comprador puede modificarla al presentar su oferta","RoundEdit::start":"Inicio del proceso de oferta","RoundEdit::start__tooltip":"Si invita a los interesados <u>antes de</u> el inicio del proceso de oferta (periodo de licitación), ya pueden introducir sus datos, ver los documentos del inmueble y <u>preparar</u> una oferta. Sin embargo, ¡todavía no se puede presentar la oferta! En cuanto llegue la hora de inicio y haya comenzado el periodo de presentación de ofertas del proceso de oferta, todos los interesados invitados recibirán una notificación y podrán empezar a presentar sus ofertas de compra.<br /><br />Consejo: La duración media del proceso de oferta, es decir, el periodo en el que se pueden presentar ofertas (periodo de presentación de ofertas), es de unos 5-7 días. Esto crea el impulso suficiente y, al mismo tiempo, garantiza que los interesados no pierdan el interés por la propiedad (lo que puede ocurrir si el periodo de presentación de ofertas es demasiado largo). Sin embargo, el periodo de 5-7 días también supone que todas las partes interesadas ya han sido suficientemente precalificadas por usted como agente al inicio del proceso de oferta, incluyendo la visita a la propiedad y la aclaración de las opciones de financiación. Sin embargo, si la financiación aún no está clara para la mayoría de los interesados y, por tanto, usted elige la opción de \"confirmación de la financiación\" al invitar a los interesados, entonces también deberá elegir una duración ligeramente superior para el proceso de oferta a fin de dar a los interesados tiempo suficiente para aclarar su financiación mientras el proceso está en curso. Si tiene más preguntas, no dude en ponerse en contacto con nuestro equipo.","RoundEdit::starting_price":"Precio inicial","RoundEdit::starting_price__tooltip":"Precio que el cliente debe ofrecer como mínimo al presentar la primera oferta.","RoundEdit::time_of_day":"Hora del día","RoundInfo::ends":"Fin del proceso de oferta","RoundInfo::offer_validity":"Validez de ofertas de compra","RoundInfo::starts":"Inicio del proceso de oferta","RoundItem::badge_free":"Gratis","RoundItem::badge_new":"Nuevo","RoundItem::badge_separator":" y ","RoundItem::how_it_works":"Cómo funciona","RoundItem::incremental_auction_howitworkspoints":"- Ofertas abiertas a partir del precio inicial \n- Posibilidad de hacer ofertas múltiples \n- Ampliación automática de la duración en caso de ofertas de última hora\n<b>Nuevas opciones flexibles:</b>\n- Posibilidad de permitir ofertas <u>por debajo del precio inicial</u>\n- Altura de la oferta <u>libremente seleccionable</u> (por encima del precio mínimo) \n- Sólo se muestran las ofertas por encima del precio inicial \n- Fecha de inicio y fin fija","RoundItem::incremental_auction_subtitle":"con ofertas flexibles","RoundItem::incremental_auction_title":"Proceso de oferta abierta","RoundItem::incremental_auction_whentouseitpoints":"Como proceso normal de oferta \"abierta\" pero también si: \n- Menor demanda \n- Clientes sensibles al precio \n- Precio inicial menos atractivo \n- Aumento del precio poco claro \n- Dar más flexibilidad a los clientes","RoundItem::open_bidding_howitworkspoints":"- Precio inicial = precio mínimo para el primer ofertante \n- Cada ofertante <b>debe</b> presentar siempre una <b>nueva oferta más alta</b>\n- Posibilidad de múltiples ofertas por cliente \n- Todas las ofertas y <b>precios visibles</b>\n- Nombres de los ofertantes anonimizados \n- Fecha formal de inicio y fin","RoundItem::open_bidding_subtitle":"con ofertas ascendentes","RoundItem::open_bidding_title":"Proceso de oferta abierta","RoundItem::open_bidding_whentouseitpoints":"- Precio inicial atractivo \n- Alta demanda \n- Valor de mercado de la propiedad por encima del precio inicial\n- Se espera un aumento del precio","RoundItem::sealed_bidding_howitworkspoints":"- Precio de referencia (no precio mínimo)\n- Importe de la oferta <u>libremente seleccionable</u>\n- Cada cliente sólo puede hacer <u>una</u> oferta\n- Los interesados sólo ven sus propias ofertas, pero no las de los demás\n- Fecha de finalización fija (sin prórroga automática para en caso de ofertas de última hora)","RoundItem::sealed_bidding_subtitle":"con precios sellados","RoundItem::sealed_bidding_title":"Proceso de oferta cerrada","RoundItem::sealed_bidding_whentouseitpoints":"- Demanda baja/no clara\n- Obtener información del mercado\n- Ventas confidenciales; sector público\n- Propiedad difícil de evaluar","RoundItem::simple_offer_howitworkspoints":"- Fácil de hacer una oferta online\n- Precio oficial de venta = referencia \n- Precio de oferta <u>libremente</u> seleccionable \n- El cliente sólo puede hacer <u>una</u> oferta\n- No hay información sobre otros participantes\n- Sin fecha de finalización fija \n- Posibilidad de pasar de forma flexible al proceso de oferta abierta para optimizar los precios (si varios clientes presentan ofertas)","RoundItem::simple_offer_title":"Oferta digital","RoundItem::simple_offer_whentouseitpoints":"- Pocos interesados\n- Proceso de venta largo \n- Prueba de disposición a comprar \n- Posibilidad de presentar una oferta con condiciones","RoundItem::when_to_use_it":"Cuándo utilizarlo","RoundPanel::round":"Modificar datos del proceso","roundstatus::closed":"Terminado","roundstatus::opened":"Abierto","roundstatus::started":"Nuevo","roundtype::counteroffer_bidding":"Contraoferta","roundtype::incremental_auction":"Ofertas abiertas","roundtype::open_bidding":"Ofertas abiertas","roundtype::sealed_bidding":"Ofertas cerrada","roundtype::show_invited_customers_count":"Mostrar el número de invitados","roundtype::show_invited_customers_count_tooltip":"Muestre el número total de todos los invitados a cada cliente participante.","roundtype::simple_offer":"Oferta digital","Sale::all_information_entered_by_customer_will_be_overwritten":"Toda la información que el cliente ya haya realizado se sobrescribirá.","Sale::already_confirmed":"Toda la información que el cliente ya haya facilitado se sobrescribirá.","Sale::cannot_update_documents_for_open_round__documents_uploaded":"Se han cargado los siguientes documentos:","Sale::cannot_update_documents_for_open_round__no_documents":"No ha cargado ningún documento.","Sale::do_you_want_to_open_the_round":"¿Quiere abrir el proceso de oferta?","Sale::guide__define_offer_form":"Primero hay que completar todos los datos de la propiedad que faltan.","Sale::guide__edit_round":"Si los datos del proceso de oferta no son correctos, modifícalos","Sale::guide__import_users_csv":"Importar clientes desde un archivo CSV","Sale::guide__invite_users":"Para invitar a los clientes interesados, necesita su nombre, correo electrónico y número de móvil.","Sale::guide__missing_mandatory_offer_form":"Rellene todos los campos obligatorios","Sale::guide__open_round":"Para abrir el proceso de oferta e invitar a clientes, debe abrir esta ronda de ofertas.","Sale::guide__start_round":"Ahora puede seleccionar el tipo de proceso de oferta y sus parámetros","Sale::guide__start_round_edit_sale":"Ha rellenado todos los campos obligatorios del formulario de oferta de compra. Puede revisarlos o modificarlos aquí.","Sale::guide_action__edit_round":"Modificar","Sale::guide_action__edit_sale":"Preparar los datos para la oferta de compra","Sale::guide_action__import_users_csv":"Importar clientes","Sale::guide_action__invite_bidders":"Invitar nuevo cliente","Sale::guide_action__open_round":"Abrir proceso","Sale::guide_action__start_round":"Comenzar nuevo proceso","Sale::guide_action__start_round_edit":"Modificar formulario de oferta","Sale::guides__manage_the_sale":"Asistente","Sale::guides__offers_present":"Ahora puede discutir el \"resumen\" de las ofertas con el vendedor y después introducir su decisión en el \"Asistente\".","Sale::guides__round_closed":"Este proceso ha terminado. Puede preparar el resumen de todas las ofertas para el vendedor e introducir el resultado.","Sale::guides__show_overview":"Resumen","Sale::guides__start_open_process":"Proceder al proceso de oferta","Sale::guides__upgrade":"Ha recibido varias ofertas. Para optimizar el precio y resultado de la venta, puede pasar al proceso de oferta digital","Sale::invalid_bid_value":"Esta oferta no puede ser aceptada. Ya existe una oferta superior o equivalente. Por favor, informe al cliente para que pueda ajustar su oferta.","Sale::loading_sale":"La propiedad se está cargando","Sale::no_estimate":"sin valor estimado","Sale::no_starting_price":"sin precio inicial","Sale::open_round_deadline_today":"Está previsto que su proceso finalice hoy. ¿Realmente quiere abrir este nuevo proceso ahora?","Sale::open_round_deadline_too_long":"¿Su proceso actual está programado para finalizar en {durationInDays} días? ¿Está seguro de que desea abrir este nuevo proceso?","Sale::open_round_info_invalid_duration":"No puedes abrir un proceso que debería terminar en el pasado. Por favor, modifique la fecha de finalización.","Sale::open_round_info_notice_incremental_auction_fixed":"Está a punto de abrir un proceso de <strong0>oferta abierta</strong0> con <strong1>precio inicial de {startPrice}</strong1> que termina en <strong2>{duration}</strong2> el {date} <strong3>a las {time}.</strong3>","Sale::open_round_info_notice_incremental_auction_fixed_withstart":"Está a punto de abrir un proceso de <strong0>oferta abierta </strong0> con <strong1>precio inicial de {startPrice}</strong1> que comienza <strong2>{start}</strong2> el <strong3>{startDate} a las {startTime}</ strong3>, y que finaliza el <strong4>{date} a las {time}</strong4> en <strong5>{biddingDuration}</strong5>.","Sale::open_round_info_notice_incremental_auction_flexible":"Está a punto de abrir un proceso de <strong0>oferta flexible</strong0> con un precio inicial de <strong1>{startPrice}</strong1> que termina <strong2>{duration} días</strong2> despues de la recepción de la primera oferta.</strong3>","Sale::open_round_info_notice_openbidding_fixed":"Está a punto de abrir un proceso de <strong>oferta abierta</strong> con <strong>precio inicial de {startPrice}</strong> que termina en <strong>{duration}</strong> el {date} <strong>a las {time}.</strong>","Sale::open_round_info_notice_openbidding_fixed_withstart":"Está a punto de abrir un proceso de <strong>oferta abierta</strong> con <strong>precio inicial de {startPrice}</strong> que comienza <strong>{start}</strong> el <strong>{startDate} a las {startTime}</strong> y termina <strong>{duration}</strong> el <strong>{date} a las {time}</strong> en la que periodo de oferta durará <strong>{biddingDuration}</strong>.","Sale::open_round_info_notice_openbidding_flexible":"Está a punto de abrir un proceso de <strong>oferta abierta</strong> con <strong>precio inicial de {startPrice}</strong> que termina <strong>{duration} días</strong> después de que entre una primera oferta.","Sale::open_round_info_notice_sealedbidding_fixed":"Está a punto de abrir un proceso de <strong>oferta cerrada</strong> con <strong>precio estimado de {estimado}</strong> que finaliza <strong>{duración}</strong> el {día} <strong>a las {hora}.</strong>","Sale::open_round_info_notice_sealedbidding_fixed_withstart":"Está a punto de abrir un proceso de <strong>oferta cerrada</strong> con <strong>precio estimado de {estimado}</strong> que comienza <strong>{comienza}</strong> el <strong>{startDate} a las {startTime}</strong> y termina <strong>{duration}</strong> el <strong>{date} a las {time}</strong> en la que el periodo de oferta durará <strong>{biddingDuration}</strong>","Sale::open_round_info_notice_sealedbidding_flexible":"Está a punto de abrir un proceso de <strong>oferta cerrada</strong> con <strong>precio estimado de {estimado}</strong> que finaliza <strong>en {duración} días</strong> después de que llegue una primera oferta.","Sale::open_round_info_notice_simple_offer_fixed":"Está a punto de abrir una <strong0>oferta digital</strong0> de compra.","Sale::open_round_info_notice_simple_offer_flexible":"Está a punto de abrir una <strong0>oferta digital</strong0> de compra.","Sale::sale_connection_unavailable":"Se ha perdido la conexión con este proceso de oferta. Por favor, recargue la página.","Sale::sale_not_found":"No se ha encontrado este proceso de oferta.","Sale::you_are_about_to_upload_offer_in_the_name_of_customer":"Usted está cargando la oferta de compra en nombre del cliente. Por lo tanto, el cliente ya no puede enviar su oferta de compra en línea.","SaleCreatePanel::address":"Dirección (incl. código postal)","SaleCreatePanel::agbs":"Condiciones de uso","SaleCreatePanel::behalf_of":"En nombre de (agente)","SaleCreatePanel::create_new_listing":"Crear nueva propiedad","SaleCreatePanel::i_agree_to_the_link":"Estoy de acuerdo con los {agbs}","SaleCreatePanel::i_agree_with_terms_and_conditions":"Estoy de acuerdo con los Condiciones de uso","SaleCreatePanel::image":"Foto principal de la propiedad","SaleCreatePanel::invite_only":"Participación sólo para agentes autorizados","SaleCreatePanel::number":"Propriedad nº","SaleCreatePanel::price":"Precio de venta oficial","SaleCreatePanel::title":"Descripción de la propiedad","salepropertytype::business":"Locales comerciales","salepropertytype::flat":"Apartamento","salepropertytype::house":"Casa","salepropertytype::mixed":"Residencial y comercial","salepropertytype::office":"Edificio de oficinas","salepropertytype::property":"Propiedad (parcela)","SaleWizard::accept_tc_title":"Aceptar los Condiciones de uso","SaleWizard::action_functionality":"Esta función ofrece las siguientes opciones:","SaleWizard::award":"Puede informar al comprador favorito del vendedor sobre la aceptación de su oferta, incluyendo un mensaje personal. \nTambién puede informar a otros posibles compradores cuya oferta haya sido definitivamente rechazada. Éstos quedarán excluidos del proceso posterior. \nTodos los demás ofertantes que no figuren ni entre los favoritos ni entre los definitivamente rechazados permanecerán en el proceso como posibles \"compradores sustitutos\" hasta la conclusión definitiva de la venta.","SaleWizard::award_subtitle":"Utilice esta función si hay un comprador favorecido pero quiere mantener a otros clientes en el proceso come comprador alternativo.","SaleWizard::award_title":"Seleccionar comprador favorito","SaleWizard::awardall":"Elegir ganador para cada propiedad","SaleWizard::awardall_subtitle":"Elegir ganador para cada propiedad","SaleWizard::awardall_title":"Elegir ganadores","SaleWizard::choose_a_winner_title":"Seleccionar ganador","SaleWizard::choose_offers_for_next_round_title":"Seleccionar ofertas","SaleWizard::choose_offers_to_reject_title":"Rechazos","SaleWizard::choose_winners_title":"Elegir ganadores","SaleWizard::confirmaward":"Puede confirmar al comprador después de completar con éxito la venta.\nTodos los interesados restantes son informados automáticamente del cierre de la venta y sus ofertas son finalmente rechazadas. \nEl proceso de oferta queda cerrado.","SaleWizard::confirmaward_subtitle":"Utilice esta función en cuanto desee confirmar el comprador final.","SaleWizard::confirmaward_title":"Confirmar comprador final","SaleWizard::counteroffer":"Cuando el comprador acepta el valor de la contraoferta queda confirmado como comprador y la oferta es vinculante por parte del vendedor. \nPuede seleccionar un comprador que ya haya presentado una oferta. \nA continuación, puede especificar un valor de contraoferta y el plazo hasta el que el comprador debe decidir. \nEl comprador puede: \nAceptar el valor e inmediatamente será elegido como comprador seleccionado \nHacer una oferta superior a su oferta anterior pero inferior a la contraoferta, en cuyo caso se cerrará el proceso y podrá resolverlo con el vendedor \nNo hacer nada y el proceso de oferta se cerrará según lo previsto","SaleWizard::counteroffer_subtitle":"Utilice esta funcionalidad cuando quiera hacer una contraoferta a un comprador potencial.","SaleWizard::counteroffer_title":"Contraoferta","SaleWizard::duplicate":"Todos los datos y documentos ya almacenados para la propiedad se transfieren automáticamente. \nA continuación, puede modificar los detalles, definir los parámetros del nuevo proceso, comenzar el proce de oferta e invitar a nuevos clientes.","SaleWizard::duplicate_subtitle":"Utilice esta función si desea iniciar un nuevo proceso de oferta con esta propiedad.","SaleWizard::duplicate_title":"Iniciar nuevo proceso de oferta","SaleWizard::increase":"Puede iniciar otra ronda del proceso de oferta (con un nuevo precio de referencia si es necesario) para conseguir un mejor precio de venta. \nTodos los participantes (o los seleccionados) de la última ronda del proceso de oferta pueden participar y aumentar su oferta existente; se les notificará automáticamente. \nAdemás, se puede invitar a nuevos clientes interesados que aún no hayan participado. \nTodos los demás clientes anteriores que no hayan sido seleccionados para este nuevo proceso recibirán automáticamente una notificación con el rechazo de su oferta existente.","SaleWizard::increase_subtitle":"Utilice esta función si desea dar a los clientes la oportunidad de aumentar su oferta.","SaleWizard::increase_title":"Lanzar otra ronda de ofertas","SaleWizard::message_to_buyers_title":"Mensaje adicional","SaleWizard::message_to_rejected_title":"Mensaje para ofertas rechazadas","SaleWizard::message_to_winner_title":"Mensaje adicional","SaleWizard::next_round_details_title":"Próxima ronda","SaleWizard::notifyseller":"Informe al vendedor de las ofertas de sus clientes","SaleWizard::notifyseller_subtitle":"Enviar resumen de las ofertas al vendedor","SaleWizard::notifyseller_title":"Notificar al vendedor","SaleWizard::rejectall":"Todos los clientes que hayan presentado una oferta serán informados de la decisión negativa del vendedor. \nEl proceso de oferta queda cerrado.","SaleWizard::rejectall_subtitle":"Utilice esta función si el vendedor no desea aceptar ninguna de las ofertas ni desea continuar con el proceso de oferta.","SaleWizard::rejectall_title":"Rechazar todas las ofertas","SaleWizard::results_title":"Confirmación","SaleWizard::review_title":"Resumen","SaleWizard::review_winners_title":"Revisar todos los ganadores","SaleWizard::sale_wizard":"Asistente","SaleWizard::select_action_title":"¿Cómo quiere proceder?","SaleWizardResult::back_to_sale":"Volver al proceso de oferta","SaleWizardResult::confirmation":"Confirmación","SaleWizardResult::continue_to_the_duplicated_sale":"Continuar con el proceso duplicado","SaleWizardResult::successful":"Hemos recibido su entrada. En un minuto los modificaciones son visibles en el sistema.","SaleWizardRoundInfo::ends":"Proceso de oferta termina","SaleWizardRoundInfo::estimate":"Valor estimado","SaleWizardRoundInfo::minimum_price":"Precio mínimo","SaleWizardRoundInfo::offer_validity":"Oferta de compra es válida","SaleWizardRoundInfo::red_button_price":"Precio mínimo del vendedor","SaleWizardRoundInfo::start_price":"Precio de partida","salutation":"Saludo","salutation::miss":"Sra.","salutation::mr":"Sr.","salutation::mrs":"Sra.","salutation::ms":"Sra.","save":"Guardar","Search::add_new_listing":"Añadir nueva propriedad","Search::address":"Dirección","Search::agbs":"Condiciones de uso","Search::agent_not_found":"¡No tiene permiso para iniciar el proceso de oferta para este agente!","Search::area":"Superficie","Search::create_new_listing":"Crear nueva propriedad","Search::creating":"Creación en curso","Search::error_loading_objects":"Error al cargar los propriedades","Search::error_retrieving_file":"Error al recuperar o almacenar el archivo","Search::guide_no_objects":"Parece que no hay propiedades disponibles en este momento.","Search::i_agree_to_the_link":"Estoy de acuerdo con los {agbs}","Search::i_agree_with_terms_and_conditions":"Estoy de acuerdo con los Condiciones de uso","Search::loading_details":"Cargar todos los detalles","Search::loading_properties":"Cargando las propiedades","Search::my_listings_overview":"A mi proceso de oferta","Search::number":"Objeto No","Search::price":"Precio","Search::this_object_is_already_active":"Ya hay un proceso de oferta en curso para esta propriedad","seller":"Vendedor","seller_type":"Tipo de vendedor","SellerInviteSection::block":"Bloquear","SellerInviteSection::invite":"Invitar","SellerInviteSection::invite_seller":"Invitar al vendedor","send":"Enviar","sms":"SMS","sms_failed":"No se ha podido entregar la notificación SMS","start_new_sale":"Iniciar nuevo proceso","start_new_test_sale":"Iniciar nuevo test","status":"Estado","street":"Calle","street_and_house_number":"Nombre de la calle y número de la casa","submit":"Enviar","submitted_on":"Enviado el","submitted_value":"Valor de la oferta","summary":"Resumen","swiss_residential_status":"Estatuto de residente suizo","test_sale_explanation":"Utilice el proceso \"test\" si desea probar internamente un proceso de oferta. No se le cobrará por este proceso test. No invite a clientes reales externos a este proceso. Todas las páginas y notificaciones se marcarán como \"Test\".","test_sale_watermark":"Venta de demostración","this_action_cannot_be_undone":"Esta acción no puede deshacerse.","title":"Título","title::doctor":"Doctorado","title::master":"Mag.","title::professor":"Prof.","true":"Sí","type_of_property":"Tipo de propiedad","updated_on":"Actualizado el","upload":"Cargar","upload_more":"Cargar más","uploading":"Cargando","uploads":"Documentos cargados","uploadtype::identification_document":"Documentos de identificación","uploadtype::misc":"Varios","value_must_be_between_min_and_max":"El valor debe estar entre {min} y {max}","Whitelisting::whitelisting_done":"Solicitud de participación en el MLS aceptada","WhitelistingPanel::accept":"Aceptar","WhitelistingPanel::action":"Acción","WhitelistingPanel::block":"Bloquear","WhitelistingPanel::blocked":"Bloqueado","WhitelistingPanel::requested":"Solicitado","WhitelistingPanel::whitelisted":"Aceptado","WhitelistingPanel::whitelisting":"Resumen de la configuración MLS","would_you_like_to_continue":"¿Desea continuar?","yes":"Sí","zip_code":"Código postal"}

/***/ }),
/* 894 */
/***/ (function(module, exports) {

module.exports = {"active":"Aktiivinen","add":"Lisää","additional_address":"Lisäosoite","additional_description":"Muu kuvaus ja tärkeitä tietoja","additional_information_text":"Lisätietoja","address":"Osoite","agent":"Välittäjä","AgentProvisionForm::agent_commission":"Välittäjäpalkkio","AgentProvisionForm::fixed_amount":"Kiinteä määrä","AgentProvisionForm::fixed_amount_excluding_vat":"Kiinteä määrä (ilman alv:tä)","AgentProvisionForm::no_commission":"Ei provisiota","AgentProvisionForm::percentage":"Prosenttiosuus","AgentProvisionForm::percentage_excluding_vat":"Prosenttiosuus (ilman alv:tä)","AgentProvisionForm::standard":"Standardi","allowed_file_formats":"Huomaa, että vain seuraavat tiedostomuodot ovat sallittuja: PDF, JPG ja PNG.","App::initializing":"Alustaminen","are_you_sure_this_action_cannot_be_undone":"Oletko varma? Tätä toimenpidettä ei voi perua.","auction_finals":"Huutokaupan finaalit","AuctionFinalsList::no_offer_selected_for_awardwing_go_back_to_the_matrix_and_pick_some":"Awardwingille ei ole valittu tarjousta, palaa takaisin matriisiin ja valitse jokin.","AuctionFinalsList::object_no":"Esine nro.","AuctionFinalsList::selected_buyer":"Valittu ostaja","AuctionFinalsList::total":"Yhteensä","AuctionFinalsMatrix::awarded":"Myönnetty","AuctionFinalsMatrix::clear_selection":"Tyhjennä valinta","AuctionFinalsMatrix::for_each_property_pick_the_best_available_offer":"Valitse kustakin kohteesta paras saatavilla oleva tarjous","AuctionFinalsMatrix::for_each_property_pick_the_highest_offer_if_it_is_the_most_preferred_offer_of_the_highest_bidder":"Valitse kunkin kohteesta osalta korkein tarjous, jos se on korkeimman tarjouksen tekijän mieluisin tarjous","AuctionFinalsMatrix::for_each_property_pick_the_highest_offer_if_the_highest_bidder_has_not_been_assigned_to_another_property_yet":"Valitse kunkin kohteen osalta korkein tarjous, jos korkeimman tarjouksen tekijää ei ole valittu toiseen kohteeseen","AuctionFinalsMatrix::position":"Asema","AuctionFinalsMatrix::preference":"Etusija","AuctionFinalsMatrix::property":"Kohde","AuctionFinalsMatrix::select_best_offers":"Valitse parhaat tarjoukset","AuctionFinalsMatrix::select_highest_offers":"Valitse korkeimmat tarjoukset","AuctionFinalsMatrix::select_preferred_highest_offers":"Valitse ensisijaiset korkeimmat tarjoukset","AuctionFinalsMatrix::this_is_the_highest_offer_for_this_property_but_its_not_selected":"Tämä on korkein tarjous tästä kohteesta, mutta sitä ei ole valittu, -","AuctionFinalsMatrix::this_is_the_most_preferred_offer_for_this_buyer_but_its_not_selected":"Tämä on tämän ostajan mieluisin tarjous, mutta sitä ei ole valittu","AuctionFinalsPanel::confirm":"Vahvista","AuctionFinalsPanel::continue":"Jatka","AuctionFinalsPanel::error_loading_data_from_server":"Virhe tietojen lataamisessa palvelimelta","AuctionFinalsPanel::failed":"Epäonnistunut","AuctionFinalsPanel::report":"Raportti","AuctionFinalsPanel::review_winners":"Arvostelun voittajat","AuctionFinalsPanel::select_winners":"Valitse voittajat","AuctionFinalsPanel::succeeded":"Menestyi","AuctionFinalsTotals::awarded":"Aiemmin myönnetty","AuctionFinalsTotals::selected":"Tällä hetkellä valittu","AuctionFinalsTotals::total":"Yhteensä","AwardAllStep1::loading_offers_please_wait":"Tarjousten lataaminen, odota","AwardStep1::choose_a_winner":"Valitse voittaja","AwardStep1::expiration_date":"Valitse ajanjakso","AwardStep2::expiration_date":"Tarjouksen voimassaolo","AwardStep2::select_customers_to_reject_theirs_offer":"Valitse tarjoukset, jotka haluat hylätä välittömästi.\nNämä asiakkaat saavat välittömästi ilmoituksen peruutuksesta.\nKaikki muut asiakkaat eivät saa ilmoitusta tällä hetkellä, jos haluat valita toisen ostajan myöhemmin.","AwardStep2::this_text_will_appear_as_an_additional_note":"Tämä teksti ilmestyy lisähuomautuksena voittajalle lähetettävään ilmoitukseen:","AwardSummary::if_you_click_finish_you_confirm_the_winner":"Jos napsautat \"Valmis\", vahvistat voittajan. Valituille mahdollisille ostajille ilmoitetaan. Tätä vaihetta ei voi perua.","AwardSummary::rejected_customers_offers":"Hylätyt tarjoukset","AwardSummary::selected_winner":"Valittu voittaja","back":"Takaisin","behalf_of":"Seuraavien puolesta","bid_amount":"Tarjouksen määrä","bidding_type":"Tarjouskilpailun tyyppi","BiddingSection::highest_bidder":"Eniten tarjoava","BiddingSection::round_opens_on":"Kierros avataan","BiddingSection::the_highest_offer":"Korkein tarjous","BiddingSection::the_next_minimum_offer":"Seuraava vähimmäistarjous","BlockDialog::block":"Lasku","BlockDialog::block_agent":"Osallistumisen väheneminen","BlockDialog::reason":"Epäämisen syy","BulkRegistrationCsvPanel::back_to_mapping":"Takaisin kartoitukseen","BulkRegistrationCsvPanel::duplicate_description":"Tietue on jo olemassa","BulkRegistrationCsvPanel::import_from_csv_file":"Tuo CSV-tiedostosta","BulkRegistrationCsvPanel::invalid_description":"Puutteellinen tietue","BulkRegistrationCsvPanel::total_number_of_rows_count":"Rivien kokonaismäärä: {count}","BulkRegistrationCsvPanel::valid_description":"Tietue valmis","BulkRegistrationInventoryPanel::duplicate_description":"Tietue on jo olemassa","BulkRegistrationInventoryPanel::entries_with_duplicate_emails_count":"Merkinnät, joissa on päällekkäisiä sähköposteja: {count}","BulkRegistrationInventoryPanel::failed_registrations":"Epäonnistuneet rekisteröinnit: {count}","BulkRegistrationInventoryPanel::importing":"Tuo","BulkRegistrationInventoryPanel::invalid_description":"Puutteellinen tietue","BulkRegistrationInventoryPanel::invalid_entries_count":"Virheelliset merkinnät: {count}","BulkRegistrationInventoryPanel::successful_registrations":"Onnistuneet rekisteröinnit: {count}","BulkRegistrationInventoryPanel::total_number_of_entries_count":"Merkintöjen kokonaismäärä: {count}","BulkRegistrationInventoryPanel::valid_description":"Tietue valmis","BulkRegistrationTable::already_registered":"Jo rekisteröitynyt","BulkRegistrationTable::invalid_email":"Virheellinen sähköpostiosoite","BulkRegistrationTable::saving_error":"Latausvirhe","BulkRegistrationTable::select__unselect_all":"Valitse / poista kaikki","BuyerDocumentSelector::none":"Ei ole","BuyerDocumentSelector::not_required":"Ei vaadita","BuyerDocumentSelector::optional":"Valinnainen","BuyerDocumentSelector::required":"Vaadittu","buyertype::company":"Yritys","buyertype::entrepreneurs":"Yksityisyrittäjä","buyertype::private":"Yksityishenkilö","CallbackComponent::redirecting":"Uudelleenohjaus","cancel":"Peruuta","citizenship":"Kansalaisuus","city":"Kaupunki","close":"Sulje","combobox_placeholder_free_text":"Valitse vaihtoehto luettelosta tai anna oma vaihtoehtosi","Commands::accept":"Vahvista seuraavaa kierrosta varten","Commands::all_offers":"Kaikki tarjoukset","Commands::approve":"Hyväksy","Commands::approveregistration":"Aktivoi asiakkaat","Commands::are_you_sure_this_action_can_not_be_undone":"Oletko varma? Tätä toimenpidettä ei voi perua.","Commands::are_you_sure_to_block_user":"Oletko varma? Tämä sulkee asiakkaan ulos järjestelmästä!","Commands::are_you_sure_to_close_the_sale":"Oletko varma? Tarjouskilpailu suljetaan.","Commands::are_you_sure_to_end_round_early":"Oletko varma? Jos lopetat kierroksen, uusia tarjouksia ei voi tehdä.","Commands::are_you_sure_to_end_round_early_sealed":"Oletko varma? Jos lopetat kierroksen, uusia tarjouksia ei voi tehdä, ja tarjousten määrät julkistetaan.","Commands::award":"Hyväksy tarjous","Commands::blank_offer":"Tyhjä tarjousmalli PDF","Commands::block_user":"Asiakkaan estäminen","Commands::close_sale":"Tarjouskilpailun päättäminen","Commands::confirm":"Vahvista asiakkaalle (vahvistuskoodi)","Commands::delete_sale":"Tarjouskilpailumenettelyn poistaminen","Commands::download_documents":"Lataa asiakirjoja","Commands::end_round_early":"Sulje kierros ennenaikaisesti","Commands::import_registrations_from_crm":"Tuo CRM:stä","Commands::import_registrations_from_csv_file":"Tuo CSV-tiedostosta","Commands::import_registrations_from_onoffice":"Tuo OnOfficesta","Commands::import_registrations_from_propstack":"Propstack tuonti","Commands::import_registrations_from_propup":"Tuo PropUpista","Commands::invite_seller":"Kutsu myyjä","Commands::new":"Aloita uusi kierros","Commands::offer":"Tarjoukset","Commands::pdf_export":"PDF-vienti","Commands::refuse":"Hylkääminen puutteellisena","Commands::refuseregistration":"Hylkää asiakkaat","Commands::register_new_user":"Kutsu uusi asiakas","Commands::registration":"Rekisteröinnit","Commands::reject":"Hylkää","Commands::round_close":"Sulje ennenaikaisesti","Commands::round_open":"Avoin kierros","Commands::sale":"Tarjouskilpailumenettely","Commands::sale_wizard":"Myyntiavustaja","Commands::update_contact":"Päivitä yhteystieto","Commands::upload":"Lataa tarjous asiakkaan puolesta","Commands::whitelisting":"MLS-konfiguraatio","company":"Yritys","company_court":"Käräjäoikeus","company_id":"FN","company_name":"Yrityksen nimi","Confirmation::confirmation_expired":"Syötetty vahvistuskoodi on väärä tai vanhentunut","Confirmation::invalid_bid_value":"Ostohinta on liian alhainen","Confirmation::invalid_confirmation":"Syötetty vahvistuskoodi on väärä tai vanhentunut","Confirmation::sale_round_not_opened":"Tarjoustasi ei voida hyväksyä, koska kierros on jo päättynyt","ConfirmAwardStep1::choose_a_winner":"Valitse voittaja","ConfirmAwardStep1::expiration_date":"Tarjouksen voimassaolo","ConfirmAwardSummary::if_you_click_finish_you_confirm_the_winner":"Kun napsautat \"Valmis\", vahvistat ostajan. Kaikki muut tarjoukset hylätään ja asiakkaille ilmoitetaan asiasta.\nTätä vaihetta ei voi perua.","ConfirmAwardSummary::rejected_customers_offers":"Hylätyt tarjoukset","ConfirmAwardSummary::selected_winner":"Valittu voittaja","ContactPanel::update_contact":"Päivitä yhteystieto","costs":"Kustannukset","Countdown::das_verfahren_ist_beendet":"Tarjousprosessi on päättynyt","CounterofferStep2:: please_define_the_next_round":"Määrittele seuraava kierros","CounterofferStep2::validity_of_offers_set_to_the_same_value":"Samaan arvoon asetettujen tarjousten voimassaolo","CounterofferSummary::click_finish_to_start_a_new_round":"Aloita uusi kierros napsauttamalla Finish","CounterofferSummary::customers_for_the_next_round":"Valitaan asiakkaat, jotka osallistuvat seuraavalle kierrokselle","CounterofferSummary::customers_not_participating_in_the_next_round":"Valitaan asiakkaat, jotka eivät osallistu seuraavalle kierrokselle","CounterofferSummary::round_details":"Pyöreät yksityiskohdat","country":"Maa","created_on":"Luotu","CsvMappingTable::do_not_import":"älä tuo","customer":"Asiakas","customer_buyer_reference_of_name":"Asiakas {buyer_reference} alkaen {name}","customer_name":"Asiakkaan nimi","customer_of_name":"Asiakas {name}","Dashboard::authorization_in_progress":"Käynnissä oleva valtuutus","Dashboard::customer_service_contact":"Asiakaspalvelun yhteystiedot","Dashboard::customer_service_email":"support@propnow.com","Dashboard::customer_service_p":"Jos sinulla on kysyttävää tai ongelmia, voit ottaa meihin yhteyttä seuraavasti:","Dashboard::customer_service_telephone":"+49 30 959992518","Dashboard::customer_service_telephone_href":"+49 30 959992518","Dashboard::do_you_really_want_to_log_out":"Haluatko todella kirjautua ulos?","Dashboard::log_out":"Kirjaudu ulos","Dashboard::tel__sms__whatsapp":"Puhelin","date":"Päivämäärä","date_of_birth":"Syntymäaika","DateField::dateformat":"dd.mm.yyyy","DateField::invalid_date":"Virheellinen päivämäärä","days":"Päivät","delete":"Poista","deposit_payment_deadline":"Käsirahan maksun määräaika","depositRequired::false":"Ei","depositRequired::true":"Kyllä","doc_from":"osoitteesta","Doc::from":"osoitteesta","Doc::no_type":"Määritä asiakirjan tyyppi","Doc::original_name":"Ladattu nimellä {originalFilename} päivänä {uploadedAt, date, medium} {uploadedAt, time, medium}","documents":"Asiakirjat","documenttype::annual_statement":"Vuosittainen selvitys","documenttype::appraisal":"Arvon arviointi","documenttype::area_allocation_plan":"Kaavoitussuunnitelma","documenttype::building_permit":"Rakennuslupa","documenttype::completion_display":"Valmistumisnäyttö","documenttype::condominium_contract":"Asunto-osakeyhtiösopimus","documenttype::energy_certificate":"Energiatehokkuustodistus","documenttype::expose":"Esite","documenttype::expose_long":"Kohteen kuvaus (Esite)","documenttype::land_register":"Ote maarekisteristä","documenttype::loan_agreement":"Lainasopimus","documenttype::operating_costs":"Käyttökustannukset","documenttype::operating_costs_long":"20 Abs. §:n mukaiset käyttökustannukset / kunnossapito- ja parannuskustannusennusteet. 2 WEG","documenttype::promissory_note":"Velkakirja","documenttype::running_costs":"Juoksevien kustannusten vaatimus","documenttype::usage_permit":"Käyttölupa","DuplicateStep1::agbs":"AGBs","DuplicateStep1::duplicating_sale":"Tarjouskierroksen monistaminen","DuplicateStep1::hint1":"Kaikki tarjouslomakkeeseen liittyvät tiedot ja asiakirjat kopioidaan","DuplicateStep1::hint2":"Voit sitten mukauttaa tietoja, määritellä kierroksen ja kutsua uusia ostajaehdokkaita","DuplicateStep1::i_agree_to_the_link":"Olen samaa mieltä {agbs}","DuplicateStep1::i_agree_with_terms_and_conditions":"Hyväksyn ehdot ja edellytykset","DuplicateSummary::duplicating_sale":"Tarjouskierroksen monistaminen","duration":"Kesto","duration_type":"Keston tyyppi","durationtype::fixed":"Korjattu","durationtype::flexible":"Joustava","edit":"Muokkaa","EditPanel::edit_offer_form":"Valmistele tiedot tarjouskirjettä varten","email":"Sähköposti","email_failed":"Sähköposti-ilmoitusta ei voitu toimittaa","EmailField::invalid_email":"Sähköpostiosoite ei ole oikea","encoding":"Koodaus","Error::blocked":"Sivua, jota yrität käyttää, ei ole olemassa. Joko sinulla on väärä linkki tai digitaalinen tarjousprosessi on jo suoritettu loppuun. Löydät lisää kohteita kohdasta:","field::depositrequired":"Talletus","field::email":"Sähköposti","field::firstname":"Etunimi","field::lastname":"Sukunimi","field::locale":"Kieli","field::phone":"Matkapuhelinnumero","field::salutation":"Tervehdys","field::title":"Otsikko","fill_required_fields":"Täytä kaikki pakolliset kentät!","first_name":"Etunimi","handover":"Luovutus","handovertype::key_handover":"Avaimen luovutuksen jälkeen","handovertype::land_register":"Kiinteistörekisteriin merkitsemisen jälkeen ote","handovertype::money_transfer":"Kun kauppahinta on siirretty ennalta määritetylle tilille","handovertype::sale_contract":"Myyntisopimuksen mukaan","hidden":"piilotettu","house_number":"Numero","iban":"IBAN","image":"Kuva","import":"Tuo","IncreaseStep1::all_other_offers_will_be_rejected":"Kaikki muut tarjoukset hylätään, eikä niillä ole mahdollisuutta osallistua toiselle kierrokselle.","IncreaseStep1::expiration_date":"Valitse ajanjakso","IncreaseStep1::invite_more_customers_after_start_of_next_round":"Seuraavan kierroksen alettua sinulla on mahdollisuus kutsua lisää kiinnostuneita asiakkaita.","IncreaseStep1::select_customers":"Valitse asiakkaat, jotka osallistuvat seuraavalle kierrokselle.","IncreaseStep2::please_define_the_next_round":"Määrittele seuraava kierros.","IncreaseStep2::validity_of_offers_set_to_the_same_value":"Muiden tarjousten ostotarjousten voimassaoloaika asetettiin automaattisesti samaan arvoon kuin edellisellä kierroksella.","IncreaseStep3::this_text_will_appear_as_an_additional_note":"Tämä teksti näkyy lisähuomautuksena asiakkaalle lähetettävässä ilmoituksessa:","IncreaseSummary::click_finish_to_start_a_new_round":"Jos napsautat \"Valmis\", uusi kierros käynnistyy ja asiakkaille ilmoitetaan asiasta.","IncreaseSummary::customers_for_the_next_round":"Seuraavan kierroksen asiakkaat","IncreaseSummary::customers_not_participating_in_the_next_round":"Asiakkaat, jotka eivät osallistu seuraavalle kierrokselle","IncreaseSummary::round_details":"Kierroksen yksityiskohdat","last_name":"Sukunimi","legal_entity":"oikeushenkilö","legal_form":"Oikeudellinen muoto","ListingsOverview::add_new_listing":"Lisää uusi kohde","ListingsOverview::agent":"Välittäjä","ListingsOverview::approved_offers":"Hyväksytyt asiakkaat","ListingsOverview::create_new_listing":"Luo uusi kohde","ListingsOverview::end_date":"Lopetuspäivä","ListingsOverview::guide__you_should_add_a_new_listing":"Tarjouskilpailun aloittaminen edellyttää, että valitset ensin kohteen.","ListingsOverview::loading_listings":"Lataa kohteita","ListingsOverview::my_listings_overview":"Kohteiden yhteenveto","ListingsOverview::number":"Kohde nro","ListingsOverview::pending_offers":"Avoimet tarjoukset","ListingsOverview::start_date":"Aloituspäivä","loading":"Ladataan","locale":"Kieli","locale::de":"Saksan","locale::dech":"Saksan","locale::dede":"Saksan","locale::en":"Englanti","locale::fi":"Suomalainen","locale::fifi":"Suomalainen","locale::fr":"Ranskan","locale::frch":"Ranskan","locale::frlu":"Ranskan","locale::it":"Italian","locale::itch":"Italian","locale::ro":"Romanian","locale::roro":"Romanian","locale::sl":"Slovenian","locale::slsi":"Slovenian","manage":"Hallitse","ManagePanel::administration":"Hallinto","ManagePanel::my_data":"Minun tietoni","ManagePanel::object_supervisor":"Kohteen valvoja","marital_status":"Siviilisääty","maritalstatus::divorced":"Eronnut","maritalstatus::married":"Naimisissa","maritalstatus::single":"Naimaton","maritalstatus::widowed":"Leski","message":"Viesti","mls":"MLS","mls::everyone":"Vapaa MLS","Mls::loading_mls":"MLS-tarjousmenettelyn lataaminen","Mls::no_sale_for_mls":"Tällä hetkellä ei ole myynnissä","mls::none":"Ei MLS","Mls::request_access":"Osallistuminen tarjouskilpailumenettelyihin","Mls::request_access_description":"Jos haluat pyytää pääsyä näihin listausmenettelyihin kutsuaksesi potentiaalisia asiakkaitasi, Listalleottoagentti käsittelee pääsyä koskevan pyyntösi pian, ja sinulle ilmoitetaan siitä sähköpostitse sekä Dashboardissa.","mls::tenant":"MLS vain vuokralaisen sisällä","more":"lisää","name":"Nimi","next":"Seuraava","no":"Ei","not_entered":"Ei merkitty","notary":"Notaari","notificationcaption::all_customers":"Kaikki asiakkaat","notificationcaption::customer":"Asiakas","notificationcaption::customers_invited_to_the_next_round":"Seuraavalle kierrokselle kutsutut asiakkaat","notificationcaption::other_customers":"Muut asiakkaat","notificationcaption::seller":"Myyjä","notificationcaption::winner":"Voittaja","notificationemailtemplate::cust_bid_refused":"Tarjous hylätty","notificationemailtemplate::cust_highest_bidder":"Eniten tarjoava","notificationemailtemplate::cust_highest_bidder_changed":"Uusi korkein tarjous","notificationemailtemplate::cust_invited":"Kutsu asiakkaat","notificationemailtemplate::cust_message":"Viesti","notificationemailtemplate::cust_offer_awarded":"Tarjous hyväksytty","notificationemailtemplate::cust_offer_placed":"Tarjous jätetty","notificationemailtemplate::cust_offer_raised":"Lisää tarjous","notificationemailtemplate::cust_offer_refused":"Hylkää tarjous","notificationemailtemplate::cust_outbid":"Tarjous ylitetty","notificationemailtemplate::cust_outbid_antisniping":"Tarjous ylitetty","notificationemailtemplate::cust_outbid_others":"Uusi korkein tarjous","notificationemailtemplate::cust_phase_invite_closing":"Muistutus - Rekisteröintivaihe","notificationemailtemplate::cust_phase_offer_starting":"Muistutus - huutokauppa alkoi","notificationemailtemplate::cust_phase_wishlist_closing":"Muistutus - kohteen valinta päättyy","notificationemailtemplate::cust_rejected_round_closed":"Tarjous hylätty","notificationemailtemplate::cust_rejected_sold":"Tarjous hylätty","notificationemailtemplate::cust_rejected_unsold":"Tarjous hylätty","notificationemailtemplate::cust_round_closed":"Kierros on päättynyt","notificationemailtemplate::cust_round_closing":"Muistutussähköposti","notificationemailtemplate::cust_round_edited":"Pyöreä säädetty","notificationemailtemplate::cust_round_opened":"Uusi kierros alkoi","NotificationPreview::no_notification_defined_for_the_selected_action":"Valitusta toiminnosta ei lähetetä ilmoitusta","notifications":"Ilmoitukset","notificationservicestatus::delivered":"Toimitettu","notificationservicestatus::failed":"Epäonnistunut","notificationservicestatus::pending":"Vireillä","notificationservicestatus::sent":"Lähetetty","NotificationsPanel::explanation":"Jos haluat saada ilmoituksen tämän kohteen tarjousprosessiin liittyvistä toimista sähköpostitse ja tekstiviestillä, aktivoi toiminto:","NotifySellerSummary::description":"Seuraavien asiakkaiden ostotarjoukset lähetetään suoraan myyjälle sähköpostitse:","now":"Nyt","number":"Numero","offer":"Tarjous","offer_viewing":"Kohteessa käyty","offer_viewing_help":"Jätä tyhjäksi, jos asiakas ei ole käynyt kohteessa","OfferDetailsForm::agreement_installer__lawyer":"Sopimuksen asentaja / asianajaja","OfferDetailsForm::other_agreements":"Muut sopimukset","OfferDetailsForm::purchase_offer_valid_until":"Ostotarjous voimassa asti","OfferDetailsForm::purchase_price_gross":"Ostohinta (brutto)","OfferNotificationDetails::service_data":"Palvelutiedot","OfferNotificationsList::created_on":"Lähetetty ","OfferNotificationsList::error_loading":"Ilmoitusluettelon lataaminen epäonnistui","OfferNotificationsList::recipient":"Vastaanottaja","OfferNotificationsList::service_status":"Palvelun tila","OfferNotificationsList::template":"Malli","OffersSection::hidden":"Tällä hetkellä piilotettu","OffersSection::increase_offer_on_behalf_of_the_customer":"Korota tarjousta asiakkaan puolesta","OffersSection::invited_on":"Kutsuttu","OffersSection::submitted_at":"Lähetetty","OffersSection::submitted_value":"Tarjouksen määrä","OffersSection::upload_offer_on_behalf_of_a_customer":"Lataa tarjous asiakkaan puolesta","offerstatus::accepted":"Vahvistettu","offerstatus::approved":"Hyväksytty","offerstatus::awarded":"Hyväksytty","offerstatus::confirmed":"Lähetetty","offerstatus::invited":"Kutsuttu","offerstatus::refused":"Kieltäytyi","offerstatus::registrationconfirmed":"Odotetaan aktivointia","offerstatus::registrationsubmitted":"Rekisteröinti toimitettu","offerstatus::rejected":"Hylätyt","offerstatus::submitted":"Valmisteltu (ilman vahvistuskoodia)","offerstatus::updated":"Käynnissä","ok":"OK","open":"Avaa","optional":"Valinnainen","other_agreements":"Muut sopimukset","overview":"Yleiskatsaus","ownership":"Omistustyyppi","ownershiptype::residential":"Asuinkiinteistöt","ownershiptype::share":"Osakeomistus","ownershiptype::sole":"Yksinomainen omistus","Page1::area":"Alue","Page1::construction_year":"Rakennusvuosi","Page1::deed":"Kiinteistörekisteri","Page1::deed_kg":"KG","Page1::energy_certificate":"Energiatodistus","Page1::housing_subsidies":"Asuntotuet","Page1::object_number":"Kohteen numero","Page1::ownership_share":"Jaa","Page1::ownership_total":"Yhteensä","Page1::parcel_number":"Parc.Nr.","Page1::register_number":"Rekisterin numero","Page1::usage_rules":"Käyttösäännöt","Page2::date_of_delivery_warranty":"Luovutuspäivä, takuu","Page2::date_of_delivery_warranty_contract":"Toimituspäivä, takuu, sopimus","Page2::exceptions":"Poikkeukset","Page2::handover_date":"Hallintaoikeuden siirtyminen / huoneiston vapautuminen ostajalle","Page2::mortgage":"Kiinnitys","Page2::mortgage_detail":"Kiinnityksen tiedot","Page2::notary":"Notaari","Page2::vatliable_purchase":"Arvonlisäverovelvollinen hankinta","Page3::all_documents_must_have_a_type_set":"Kaikille asiakirjoille on määriteltävä tyyppi","Page3::choose_a_document_type_or_enter_description":"Valitse asiakirjatyyppi tai anna kuvaus","Page3::document_type":"Asiakirjan tyyppi","Page3::upload_following_documents":"Lataa vähintään seuraavat asiakirjat","peptype::family":"Poliittisesti vaikutusvaltainen henkilön perheenjäsen","peptype::no":"Ei","peptype::related":"Läheinen suhdepoliittisesti vaikutusvaltainen henkilöön","peptype::yes":"Ostaja on poliittisesti vaikutusvaltainen henkilö","person":"Henkilö","phone_number":"Matkapuhelinnumero","phone_number_placeholder":"+358 1 222 333","phonenumbererror::invalid":"Puhelinnumero ei ole voimassa","phonenumbererror::notmobile":"Puhelinnumero ei ole matkapuhelinnumero","place_of_birth":"Syntymäpaikka","politically_exposed_person_pep":"Poliittisesti vaikutusvaltainen henkilö (PEP)","post_code":"Postinumero","postal_code":"Postinumero","preview":"Esikatselu","previous":"Edellinen","previous_round":"Edellinen kierros","price_on_offer":"Hinta tarjousta vastaan","price_on_request":"Hinta pyynnöstä","private_person":"Yksityishenkilö","processing":"Käsittely","property_for_sale":"Myytävä kohde","provision":"Ostajan palkkio","ProvisionAck::i_have_taken_note_of_the_following_important_information":"Olen ottanut huomioon seuraavat tärkeät tiedot","provisiontype::default":"Standardi","provisiontype::fixed_amount":"Kiinteä määrä (ilman alv:tä)","provisiontype::fixed_percentage":"Prosenttiosuus (ilman alv:tä)","provisiontype::none":"Provisiovapaa","purchase_price":"Ostohinta","recipient":"Vastaanottaja","refresh":"Päivitä","RefuseDialog::explanation":"Ilmoita asiakkaalle hylkäämisen syy.","RefuseDialog::reason":"Syy","RefuseDialog::refuse_an_offer":"Hylkää tarjous","register":"Kutsu","registering":"Invitando","RegistrationPanel::already_registered":"Olet jo kutsunut asiakkaan tällä sähköpostiosoitteella!","RegistrationPanel::offer_viewing":"Kiinteistö tarkastettiin","RegistrationPanel::place_at":"Vastaanotettu","RegistrationPanel::purchase_price_gross":"Ostohinta (brutto)","RegistrationPanel::register_new_user":"Kutsu uusia potentiaalisia asiakkaita","RegistrationPanel::send_the_invitation_again":"Lähetä kutsu uudelleen","RegistrationPanel::upload_an_offer":"Lataa tarjous (asiakkaan nimissä)","RegistrationPanel::upload_new_offer":"Lataa uusi tarjous asiakkaan puolesta","RegistrationPanel::upload_offer":"Lataa tarjous","RejectSummary::click_finish_to_reject_all_offers":"Jos napsautat \"Valmis\", kaikki tarjoukset hylätään ja asiakkaille ilmoitetaan asiasta.","remove":"Poista","required_documents":"Tarvittavat asiakirjat","round":"Kierros","RoundEdit::allow_bidding_below_starting_price":"Salli tarjoukset alle lähtöhinnan","RoundEdit::allow_bidding_below_starting_price__tooltip":"Avoimessa tarjousmenettelyssä kiinnostuneet osapuolet voivat yleensä tehdä tarjouksen vain lähtöhinnasta, mikä voi tarkoittaa sitä, että hintaherkemmät asiakkaat jättävät usein tarjouksen tekemättä. Tässä vaihtoehdossa tarjoat kiinnostuneille osapuolille mahdollisuuden tehdä tarjouksen <u></u> lähtöhinnan alapuolelle - mutta välittäjän asettaman (aluksi piilotetun) vähimmäishinnan yläpuolelle. Tästä on se etu, että useammat kiinnostuneet jättävät tarjouksen, koska myös halvemmat tarjoukset ovat sallittuja. Näin tarjoajien joukko laajenee, mikä voi lisätä myyntimahdollisuuksia. Kaikki lähtöhintaa alhaisemmat tarjoukset salataan muilta kiinnostuneilta osapuolilta negatiivisen ankkurivaikutuksen välttämiseksi. Oletusarvoisesti näytetään vain lähtöhinnan alittavat tarjoukset, ellet aktivoi vaihtoehtoa \"Näytä lähtöhinnan alittavat tarjoukset muille tarjoajille\".","RoundEdit::allow_bidding_below_starting_price_hidden":"Salli tarjoukset alle lähtöhinnan (piilotettu)","RoundEdit::antisniping_notice":"Tarjousajan päättymistä jatketaan automaattisesti 15 minuutilla, jos uusi tarjous vastaanotetaan viimeisten 15 minuutin aikana ennen päättymistä. Tätä jatkoaikaa jatketaan, kunnes uutta tarjousta ei ole jätetty 15 minuuttiin mennessä.","RoundEdit::bidding_steps":"Tarjouksen vähimmäiskorotus","RoundEdit::bidding_steps__standard":"Tavalliset ennalta määritellyt tarjouksen lisäykset","RoundEdit::bidding_steps__tooltip":"Tämä on uusien tarjousten vähimmäiskorotusmäärä. Jokaisen uuden tarjouksen on oltava vähintään tämän verran korkeampi kuin nykyinen korkein tarjous. Jos olet valinnut vaihtoehdon \"Salli tarjoukset alle korkeimman tarjouksen\", vähimmäiskorotus viittaa yksittäisen asiakkaan edelliseen tarjoukseen, jos hän on jo tehnyt tarjouksen (lisätietoja on infopainikkeessa: \"Allow offers under highest offer\")","RoundEdit::bidding_type_tooltip":"Valitse tarjoustyyppi","RoundEdit::counteroffer_value":"Ehdotettu vastatarjouksen arvo","RoundEdit::end_date_changed":"Kaikille kutsutuille ostajille ja välittäjille ilmoitetaan sähköpostitse tarjouskilpailun päättymisen muutoksesta.","RoundEdit::ends_at":"Tarjouskilpailuajan päättyminen","RoundEdit::ends_at__tooltip":"Suosittelemme, että tarjousten tekemisen päättämiseksi valitaan aika, jolloin kiinnostuneet ovat saatavilla ja paikassa, jossa on hyvä internet-yhteys (esim. kotona). Kokemus on osoittanut, että alkuillat tai viikonloput toimivat tässä hyvin. Huomioi kuitenkin yleiset vapaapäivät tai pitkät viikonloput, jolloin kiinnostuneet voivat olla poissa. On myös tärkeää, että kiinnostuneille kerrotaan aikataulusta. Tarjousajan päättyessä kutsutuille kiinnostuneille lähetetään muistutukset 72 tuntia, 24 tuntia ja 60 minuuttia ennen aikataulun mukaista päättymistä. Suosittelemme myös, että olet välittäjänä tavoitettavissa puhelimitse viimeisen tunnin ajan ennen tarjousajan päättymistä ja tarvittaessa seuraat tarjousprosessia suorana lähetyksenä kannettavasta tietokoneesta tai tabletista, jotta voit tukea kiinnostuneita osapuolia mahdollisissa kysymyksissä tai ongelmissa (esim. kiinnostuneen osapuolen huono internetyhteys).","RoundEdit::estimate":"Arvio","RoundEdit::estimate__tooltip":"Tavoitehinta on viitehinta, joka ilmoitetaan mahdolliselle ostajalle ohjeena, joka auttaa häntä määrittämään oman tarjoushintansa. Tärkeää: tavoitehinta ei ole vähimmäishinta, eli kiinnostunut osapuoli voi tehdä myös tavoitehintaa alhaisemman tarjouksen.","RoundEdit::estimate_lower_than_startprice":"Arvio ei voi olla vähimmäishintaa alhaisempi","RoundEdit::flexible_bidding":"Salli korkeimman tarjouksen alittavat tarjoukset","RoundEdit::flexible_bidding__tooltip":"Avoimessa tarjousmenettelyssä asianomaisten osapuolten on tavallisesti tehtävä uusi enimmäistarjous jokaisen uuden tarjouksen yhteydessä, mikä voi johtaa siihen, että yksittäiset asianomaiset osapuolet luopuvat ennenaikaisesti tarjouksesta tai jättävät sen kokonaan tekemättä. Valitsemalla tämän joustavan tarjousvaihtoehdon kiinnostuneella on mahdollisuus tehdä tarjous <u></u> voimassa olevaa enimmäistarjousta alhaisempi tarjous. Uuden tarjouksen on kuitenkin oltava <u></u> vastaavan asiakkaan edellisen tarjoushinnan yläpuolella, jos tämä on jo tehnyt tarjouksen. Minimitarjouskorotus on tässä ratkaiseva, ja sitä sovelletaan vain <b>omaan tarjoukseen</b>. Tämän tarjousvaihtoehdon etuna on se, että yksittäiset kiinnostuneet osapuolet tekevät useammin tarjouksia ja keskikenttä vahvistuu, koska tarjoajat eivät keskeytä tarjousta ennenaikaisesti. Tämä voi lisätä myyntimahdollisuuksia erityisesti silloin, kun kiinnostuneita osapuolia on vain muutama tai jos lähtöhinta on hieman liian korkea.","RoundEdit::hide_highest_bid__bid_history_for_nonbidders":"Näytä muut tarjoukset vasta oman tarjouksen jättämisen <strong>jälkeen</strong> ","RoundEdit::hide_highest_bid__bid_history_for_nonbidders__tooltip":"Avoimuuden vuoksi korkein tarjous ja kaikki tehdyt tarjoukset näytetään yleensä kaikille kutsutuille avoimessa menettelyssä alusta alkaen - jo ennen kuin he ovat itse tehneet tarjouksen. Yksittäistapauksissa tämä voi johtaa siihen, että yksittäiset kiinnostuneet osapuolet, joita jo erittäin korkeat tarjoushinnat pelottavat, eivät tee lainkaan tarjousta, vaikka olisivat halunneet tehdä tarjouksen. Tämän välttämiseksi ja kaikkien ostohalukkaiden motivoimiseksi jättämään tarjouksen, tämä tarjouksen tekemistä koskeva mahdollisuus voi olla hyödyllinen.","RoundEdit::invalid_starting_price":"Anna kelvollinen aloitushinta","RoundEdit::min_price":"Vähimmäishinta","RoundEdit::min_price__tooltip":"Vähimmäisostohinta, joka asianomaisen osapuolen on tarjottava. Näytetään vain, jos asianomainen osapuoli haluaa tehdä tarjouksen alle tämän hinnan.","RoundEdit::min_price_lower_than_start":"Minimihinnan on oltava alempi kuin aloitushinta","RoundEdit::minimum_price":"Vähimmäishinta","RoundEdit::offer_validity":"Ostotarjousten voimassaolo","RoundEdit::open_round_warning":"Avoimessa tarjouskilpailussa järjestetään vain yksi kierros, ja tarjoukset ovat kaikille avoimia.","RoundEdit::please_enter_a_starting_price":"Anna hinta &gt;0","RoundEdit::red_button_price":"Sisäinen varaushinta","RoundEdit::red_button_price__tooltip":"Tämä on (arvioitu) vähimmäishinta, jolla omistaja on valmis myymään. Tämä on puhtaasti sisäinen hinta, jota ei ilmoiteta asiakkaalle ja joka näkyy vain välittäjälle. Kun punaisen painikkeen hinta saavutetaan, välittäjälle ilmoitetaan siitä välittömästi.","RoundEdit::select_a_bidding_type":"Valitse tarjoustyyppi","RoundEdit::show_bids_below_starting_price":"Näytä lähtöhinnan alapuolella olevat tarjoukset muille tarjoajille","RoundEdit::show_bids_below_starting_price__tooltip":"Oletusarvoisesti näytetään vain tarjoukset <u>osoitteesta</u> lähtöhinta, ellet aktivoi tätä vaihtoehtoa. Silloin myös <u>tarjoukset, jotka ovat alle</u> lähtöhinnan, näytetään, ja tarjousprosessin läpinäkyvyys lisääntyy.","RoundEdit::simple_offer_duration_suggestion_notice":"Tämä on ostotarjousten ehdotettu rajoitettu voimassaoloaika. Ostajaehdokas voi kuitenkin muuttaa tätä tarjousta jättäessään","RoundEdit::start":"Tarjouskilpailun aloittaminen","RoundEdit::start__tooltip":"Jos kutsut kiinnostuneet osapuolet <u>ennen</u> tarjousprosessin alkamista (tarjousaika), he voivat jo syöttää tietonsa, tarkastella kiinteistöasiakirjoja ja <u>valmistella</u> tarjouksen. Tarjousta ei kuitenkaan voi vielä jättää! Heti kun aloitusaika on saavutettu ja tarjousprosessin tarjousaika on alkanut, kaikki kutsutut kiinnostuneet osapuolet saavat ilmoituksen ja voivat sen jälkeen aloittaa ostotarjoustensa jättämisen.<br /><br />Vinkki: Tarjousprosessin eli ajanjakson, jonka aikana tarjouksia voi jättää (tarjousaika), keskimääräinen pituus on noin 5-7 päivää. Tämä luo riittävästi vauhtia ja varmistaa samalla, että yksittäiset kiinnostuneet osapuolet eivät menetä kiinnostustaan kiinteistöä kohtaan (mikä voi tapahtua, jos tarjousaika on liian pitkä). 5-7 päivän ajanjakso edellyttää kuitenkin myös, että olet välittäjänä jo riittävästi esivalmistellut kaikki kiinnostuneet osapuolet tarjousprosessin alussa, mukaan lukien kiinteistön katselu ja rahoitusvaihtoehtojen selvittäminen. Jos rahoitus on kuitenkin suurimmalle osalle kiinnostuneista vielä epäselvä ja valitset siksi kiinnostuneita osapuolia kutsuessasi vaihtoehdon \"rahoituksen vahvistaminen\", sinun kannattaa myös valita tarjousprosessille hieman pidempi kesto, jotta kiinnostuneilla osapuolilla on riittävästi aikaa selvittää rahoituksensa prosessin ollessa käynnissä. Jos sinulla on lisäkysymyksiä, ota rohkeasti yhteyttä tiimiimme.","RoundEdit::starting_price":"Lähtöhinta","RoundEdit::starting_price__tooltip":"Hinta, jota mahdollisen ostajan on vähintään tarjottava ensimmäistä tarjousta tehdessään.","RoundEdit::time_of_day":"Kellonaika","RoundInfo::ends":"Tarjouskilpailumenettely päättyy","RoundInfo::offer_validity":"Ostotarjousten voimassaolo","RoundInfo::starts":"Tarjouskilpailumenettely alkaa","RoundItem::badge_free":"Maksuton","RoundItem::badge_new":"Uusi","RoundItem::badge_separator":"&amp ","RoundItem::how_it_works":"Miten se toimii","RoundItem::incremental_auction_howitworkspoints":"- Avoimet tarjoukset alkuhinnasta alkaen\n- Monta tarjousta mahdollista\n- Automaattinen pidennys viime hetken tarjouksille\n<b>Uudet joustavat tarjousvaihtoehdot:</b>\n- Mahdollisuus sallia <u>alle alkuhinnan olevat</u> tarjoukset \n- Tarjoustaso <u>vapaasti valittavissa</u> (yli minimihinnan) \n- Vain alkuhinnan ylittävät tarjoukset näytetään \n- Kiinteä alku- ja loppupäivä","RoundItem::incremental_auction_subtitle":"joustava tarjouspyyntö","RoundItem::incremental_auction_title":"Avoin tarjouskilpailumenettely","RoundItem::incremental_auction_whentouseitpoints":"Kuten normaali \"avoin\" tarjouskilpailu, mutta myös jos: \n- Kysyntä on vähäisempää \n- Hintaherkät asiakkaat \n- Lähtöhinta ei ole yhtä houkutteleva \n- Hinnankorotus on epäselvä \n- Asiakkaille annetaan enemmän joustavuutta","RoundItem::open_bidding_howitworkspoints":"- Ensimmäisen tarjoajan on tarjottava vähintään lähtöhinta - Jokaisen tarjouksen <b>on oltava korkeampi kuin kaikki aiemmat tarjoukset</b>- Jokainen asiakas voi parantaa tarjoustaan - Kaikki <b>tarjoukset ovat näkyvissä</b>- Asiakkaiden nimet anonymisoidaan muita asiakkaita varten - Menettelyn selkeä alku ja loppu","RoundItem::open_bidding_subtitle":"nousevilla tarjouksilla","RoundItem::open_bidding_title":"Avoin tarjouskilpailumenettely","RoundItem::sealed_bidding_howitworkspoints":"- Ohjeellinen hinta ei vähimmäishintaa \n- Tarjouksen määrä <u>vapaasti valittavissa</u> \n- Kukin asiakas voi tehdä vain <u>yhden</u> tarjouksen \n- Tarjoajat ja tarjoukset <u>piilotettu</u> \n- Kiinteä päättymispäivä \n- <u>Ei</u> automaattista pidennystä viime hetken tarjouksille","RoundItem::sealed_bidding_subtitle":"piilotettuja tarjouksia","RoundItem::sealed_bidding_title":"Suljettu tarjouskilpailumenettelyn","RoundItem::sealed_bidding_whentouseitpoints":"- Vähäinen/epäselvä kysyntä \n- Markkinapalautteen hankkiminen \n- Luottamuksellinen myynti, julkinen sektori \n- Kiinteistöä on vaikea markkinoida","RoundItem::simple_offer_howitworkspoints":"- Yksinkertainen digitaalinen tarjouksen jättäminen \n- Tarjoushinta = viitehinta \n- Tarjoushinta <u>vapaasti</u> valittavissa \n- Asiakas voi jättää vain <u>yhden</u> tarjouksen \n- Ei tietoa mahdollisista muista kiinnostuneista \n- Ei kiinteää määräaikaa \n- Mahdollisuus siirtyä joustavasti tarjouskilpailumenettelyn -tilaan, jos useat asiakkaat jättävät tarjouksia","RoundItem::simple_offer_subtitle":" ","RoundItem::simple_offer_title":"Digitaalinen ostotarjous","RoundItem::simple_offer_whentouseitpoints":"- Harvat kiinnostuneet osapuolet \n- Pitkä myyntiprosessi \n- Ostohalukkuuden testaaminen \n- Mahdollisuus tehdä varauksellinen tarjous","roundstatus::closed":"Suljettu","roundstatus::opened":"Avattu","roundstatus::started":"Uusi","roundtype::counteroffer_bidding":"Vastatarjousten tekeminen","roundtype::incremental_auction":"Avoin tarjouskilpailu","roundtype::open_bidding":"Avoin tarjouskilpailu","roundtype::sealed_bidding":"Suljettu tarjouskilpailu","roundtype::show_invited_customers_count":"Näytä asianosaisten määrä","roundtype::show_invited_customers_count_tooltip":"Kullekin osallistuvalle asiakkaalle näytetään kaikkien kutsuttujen ostajaehdokkaiden kokonaismäärä.","roundtype::simple_offer":"Digitaalinen ostotarjous","Sale::all_information_entered_by_customer_will_be_overwritten":"Kaikki asiakkaan jo tekemät tiedot korvataan.","Sale::already_confirmed":"Tämä asiakas on jo tehnyt ostotarjouksen. Uuden tarjouksen tekeminen asiakkaan puolesta ei ole mahdollista.","Sale::do_you_want_to_open_the_round":"Haluatko avata kierroksen?","Sale::guide__define_offer_form":"Ensimmäinen vaihe on täydentää kaikki puuttuvat kohdetiedot.","Sale::guide__edit_round":"Jos kierroksen tiedot eivät ole oikein, säädä niitä","Sale::guide__import_users_csv":"Käyttäjien tuominen CSV-tiedostosta","Sale::guide__missing_mandatory_offer_form":"Täytä kaikki pakolliset kentät!","Sale::guide__start_round":"Nyt sinun täytyy syöttää parametrit tarjouskierroksella","Sale::guide__start_round_edit_sale":"Olet täyttänyt kaikki pakolliset kentät tarjouslomakkeessa. Voit tarkistaa tai muokata niitä täällä.","Sale::guide_action__edit_round":"Säädä","Sale::guide_action__edit_sale":"Valmistele tiedot tarjouskirjettä varten","Sale::guide_action__import_users_csv":"Käyttäjien tuonti","Sale::guide_action__invite_bidders":"Kutsu uusi asiakas","Sale::guide_action__open_round":"Avaa kierros","Sale::guide_action__start_round":"Aloita uusi kierros","Sale::guide_action__start_round_edit":"Muokkaa tarjouslomaketta","Sale::guides__manage_the_sale":"Myyntiavustaja","Sale::guides__round_closed":"Tämä kierros on nyt päättynyt. Voit laatia omistajalle tarjouksen yleiskatsauksen ja syöttää tuloksen.","Sale::guides__show_overview":"Yleiskatsaus","Sale::invalid_bid_value":"Tätä tarjousta ei voida hyväksyä. Korkeampi tai vastaava tarjous on jo olemassa. Ilmoittakaa tästä asiakkaalle, jotta hän voi mukauttaa tarjoustaan.","Sale::loading_sale":"Kohde latautuu","Sale::no_estimate":"ei arviota","Sale::no_starting_price":"ei lähtöhintaa","Sale::open_round_deadline_today":"Kierroksenne on määrä päättyä tänään. Haluatko todella avata kierroksen?","Sale::open_round_deadline_too_long":"Kierroksesi on määrä päättyä {durationInDays} päivän kuluttua? Haluatko varmasti avata kierroksen?","Sale::open_round_info_invalid_duration":"Et voi avata kierrosta, jonka pitäisi päättyä menneisyyteen. Muokkaa kierroksen tietoja.","Sale::open_round_info_notice_incremental_auction_fixed":"Avaat <strong>avoimen kierroksen</strong>, jonka <strong>aloituskurssi on {startPrice}</strong> ja joka päättyy <strong>{duration}</strong> {date} <strong>at {time}</strong>","Sale::open_round_info_notice_incremental_auction_fixed_withstart":"Avaat <strong>avoimen kierroksen </strong>, jonka <strong>aloitushinta on {startPrice}</strong> ja tarjousten aloitus <strong>{start}</strong> <strong>{startDate} klo {startTime}</strong>, ja joka päättyy <strong>{biddingDuration}</strong> <strong>{date} {time}</strong>.","Sale::open_round_info_notice_incremental_auction_flexible":"Avaat <strong>joustavan</strong> kierroksen, jonka <strong>lähtöhinta on {lähtöhinta}</strong> ja joka päättyy <strong>{kesto} päivän</strong> kuluttua ensimmäisen tarjouksen vastaanottamisesta.</strong>","Sale::open_round_info_notice_openbidding_fixed":"Aiot avata <strong>avoimen</strong> kierroksen, jonka <strong>aloituskurssi on {startPrice}</strong> ja joka päättyy <strong>{duration}</strong> {date} <strong>klo {time}</strong>.","Sale::open_round_info_notice_openbidding_fixed_withstart":"Avaat <strong>avoimen kierroksen</strong>, jonka <strong>lähtöhinta on {startPrice}</strong> ja tarjousten aloitus <strong>{start}</strong> <strong>{startDate} klo {startTime}</strong>, ja joka päättyy <strong>{biddingDuration}</strong> <strong>{date} {time}</strong>.","Sale::open_round_info_notice_openbidding_flexible":"Aiot avata <strong>avoimen</strong> kierroksen, jonka <strong>aloitushinta on {startPrice}</strong> ja joka päättyy <strong>{duration} päivän</strong> kuluttua ensimmäisen tarjouksen saapumisesta.","Sale::open_round_info_notice_sealedbidding_fixed":"Olet avaamassa <strong>Suljetun</strong> kierroksen, jonka <strong>hinta on {estimate}</strong> ja joka päättyy <strong>{duration}</strong> {date} <strong>{time}</strong>.","Sale::open_round_info_notice_sealedbidding_fixed_withstart":"Avaat <strong>suljetun </strong>-kierroksen, jonka <strong>ohjeellinen hinta on {estimate}</strong> ja tarjousten aloitus <strong>{start}</strong> <strong>{startDate} klo {startTime}</strong>, ja joka päättyy <strong>{biddingDuration}</strong>-aikaan <strong>{date} {time}</strong>.","Sale::open_round_info_notice_sealedbidding_flexible":"Olet avaamassa <strong>Suljetun</strong> kierroksen, jonka <strong>arvioitu hinta on {estimate}</strong> ja joka päättyy <strong>{duration} päivän</strong> kuluttua ensimmäisen tarjouksen saapumisesta.","Sale::open_round_info_notice_simple_offer_fixed":"Avaat <strong>Digitaalisen ostotarjouksen kierroksen</strong>.","Sale::open_round_info_notice_simple_offer_flexible":"Avaat <strong>Digitaalisen ostotarjouksen kierroksen</strong>.","Sale::sale_connection_unavailable":"Yhteys tähän tarjouskilpailumenettelyyn katkesi. Lataa sivu uudelleen.","Sale::sale_not_found":"Tätä tarjouskilpailumenettelyä ei löytynyt.","SaleCreatePanel::address":"Osoite (postinumero mukaan lukien)","SaleCreatePanel::agbs":"AGBs","SaleCreatePanel::create_new_listing":"Luo uusi kohde","SaleCreatePanel::i_agree_to_the_link":"Olen samaa mieltä {agbs}","SaleCreatePanel::i_agree_with_terms_and_conditions":"Hyväksyn ehdot ja edellytykset","SaleCreatePanel::image":"Kuva kohteen etupuolelta","SaleCreatePanel::number":"Kohteen tunnus","SaleCreatePanel::price":"Hintapyyntö","SaleCreatePanel::title":"Kohteen kuvaus","salepropertytype::business":"Toimitilat","salepropertytype::flat":"Asunto-osake","salepropertytype::house":"Talo","salepropertytype::mixed":"Asuin- ja liikehuoneistot","salepropertytype::office":"Toimistorakennus","salepropertytype::property":"Kiinteistö (tontti)","SaleWizard::accept_tc_title":"Hyväksy ehdot","SaleWizard::action_functionality":"Tämä toiminto tarjoaa seuraavat vaihtoehdot:","SaleWizard::award":"Voit ilmoittaa myyjän suosimalle ostajalle hänen tarjouksensa hyväksymisestä henkilökohtaisella viestillä.\nVoit ilmoittaa muille mahdollisille ostajille, joiden tarjous on lopullisesti hylätty. Nämä suljetaan tällöin jatkoprosessin ulkopuolelle.\nKaikki muut tarjoajat, jotka eivät ole suosikkeja eivätkä lopullisesti hylättyjen tarjoajien joukossa, pysyvät mukana prosessissa mahdollisina \"korvaavina ostajina\", kunnes myynti on lopullisesti päätetty.","SaleWizard::award_subtitle":"Käytä tätä toimintoa, jos on olemassa suosikkiostaja, mutta haluat pitää muut tarjoajat mukana kilpailussa suojautumisena toistaiseksi.","SaleWizard::award_title":"Valitse suosikki ostaja","SaleWizard::awardall":"Valitse voittaja kullekin kohteelle","SaleWizard::awardall_subtitle":"Valitse voittaja kullekin kohteelle","SaleWizard::awardall_title":"Valitse voittajat","SaleWizard::choose_a_winner_title":"Valitse voittaja","SaleWizard::choose_offers_for_next_round_title":"Valitse tarjoukset","SaleWizard::choose_offers_to_reject_title":"Hylkäykset","SaleWizard::choose_winners_title":"Valitse voittajat","SaleWizard::confirmaward":"Voit vahvistaa ostajan sen jälkeen, kun myynti on saatu onnistuneesti päätökseen.\nKaikille jäljellä oleville ostajaehdokkaille ilmoitetaan automaattisesti myynnin päättymisestä ja heidän tarjouksensa hylätään lopullisesti.\nTarjousprosessi on päättynyt.","SaleWizard::confirmaward_subtitle":"Käytä tätä toimintoa heti, kun haluat vahvistaa lopullisen ostajan.","SaleWizard::confirmaward_title":"Vahvista lopullinen ostaja","SaleWizard::counteroffer":"Käytä tätä toimintoa, kun haluat tehdä vastatarjouksen yhdelle mahdolliselle ostajalle\nKun ostaja hyväksyy vastatarjouksen arvon, hänet vahvistetaan ostajaksi ja tarjous on sitova myyjän puolelta\nVoit valita yhden ostajan, joka on jo tehnyt tarjouksen\nVoit määrittää vastatarjouksen arvon ja määräajan, johon mennessä ostajan on tehtävä päätös\nOstaja voi joko:\nHyväksyä arvon, jolloin hänet valitaan välittömästi valituksi ostajaksi\nTekee tarjouksen, joka on korkeampi kuin hänen edellinen tarjouksensa mutta alhaisempi kuin vastatarjous, jolloin kierros suljetaan ja voit ratkaista asian myyjän kanssa\nEi tee mitään, jolloin kierros suljetaan aikataulun mukaisesti","SaleWizard::counteroffer_title":"Vastatarjous","SaleWizard::duplicate":"Kaikki kohdetta varten jo tallennetut tiedot ja asiakirjat siirretään automaattisesti.\nTämän jälkeen voit mukauttaa tietoja, määritellä uuden prosessin parametrit, avata tarjouskierroksen ja kutsua uusia ostajaehdokkaita.","SaleWizard::duplicate_subtitle":"Käytä tätä toimintoa, jos haluat aloittaa uuden tarjousprosessin tämän kohteen osalta.","SaleWizard::duplicate_title":"Aloita uusi tarjousprosessi","SaleWizard::increase":"Voit aloittaa uuden tarjouskierroksen (tarvittaessa uudella viitehinnalla) saadaksesi paremman lopullisen hinnan.\nKaikki (tai valitut) edellisen kierroksen tarjoajat voivat osallistua ja korottaa olemassa olevaa tarjoustaan; heille ilmoitetaan asiasta automaattisesti.\nLisäksi voidaan kutsua uusia ostajaehdokkaita, jotka eivät ole vielä osallistuneet tarjouskilpailuun.\nKaikki muut aiemmat tarjouksen tekijät, joita ei ole valittu tälle uudelle kierrokselle, saavat automaattisesti ilmoituksen, jossa heidän nykyinen tarjouksensa hylätään.","SaleWizard::increase_subtitle":"Käytä tätä toimintoa, jos haluat antaa mahdollisille ostajille mahdollisuuden korottaa tarjoustaan.","SaleWizard::increase_title":"Käynnistetään toinen tarjouskierros","SaleWizard::message_to_buyers_title":"Lisäviesti","SaleWizard::message_to_winner_title":"Lisäviesti","SaleWizard::next_round_details_title":"Seuraava kierros","SaleWizard::notifyseller":"Kerro myyjälle asiakkaidesi tarjouksista","SaleWizard::notifyseller_subtitle":"Lähetä tarjouksen yleiskatsaus myyjälle","SaleWizard::notifyseller_title":"Ilmoita myyjälle","SaleWizard::rejectall":"Kaikille tarjouksen tehneille ostajille ilmoitetaan myyjän kielteisestä päätöksestä.\nTarjousprosessi on päättynyt.","SaleWizard::rejectall_subtitle":"Käytä tätä toimintoa, jos myyjä ei halua hyväksyä yhtään tarjousta eikä jatkaa tarjousprosessia.","SaleWizard::rejectall_title":"Hylkää kaikki tarjoukset","SaleWizard::results_title":"Vahvistus","SaleWizard::review_title":"Yhteenveto","SaleWizard::review_winners_title":"Arvostelun voittajat","SaleWizard::sale_wizard":"Myynti velho","SaleWizard::select_action_title":"Miten haluatte edetä?","SaleWizardResult::back_to_sale":"Takaisin tarjousprosessiin","SaleWizardResult::confirmation":"Vahvistus","SaleWizardResult::continue_to_the_duplicated_sale":"Jatka kopioituun kierrokseen","SaleWizardResult::successful":"Olemme vastaanottaneet syötteesi, ja muutokset näkyvät järjestelmässä minuutin kuluessa.","SaleWizardRoundInfo::ends":"Tarjousprosessi päättyy","SaleWizardRoundInfo::estimate":"Arvio","SaleWizardRoundInfo::minimum_price":"Vähimmäishinta","SaleWizardRoundInfo::offer_validity":"Ostotarjous on voimassa","SaleWizardRoundInfo::red_button_price":"Punaisen painikkeen hinta","SaleWizardRoundInfo::start_price":"Aloitushinta","salutation":"Tervehdys","salutation::miss":"Rouva","salutation::mr":"Herra","salutation::mrs":"Rouva","salutation::ms":"Rouva","save":"Tallenna","Search::add_new_listing":"Lisää uusi listaus","Search::address":"Osoite","Search::agbs":"Käyttäjäsopimus","Search::area":"Alue","Search::avv":"Sopimus tilausten k￤sittelyst￤","Search::create_new_listing":"Luo uusi listaus","Search::creating":"Luominen","Search::dataprotection":"Tietosuoja","Search::error_loading_objects":"Ominaisuuksien lataamisessa tapahtui virhe","Search::error_retrieving_file":"Virhe tiedoston hakemisessa tai tallentamisessa","Search::guide_no_objects":"Näyttää siltä, että tällä hetkellä ei ole vapaita kiinteistöjä.","Search::i_agree_to_the_link":"Olen lukenut {agbs} ja {dataprotection} ja hyväksyn ne.","Search::i_agree_with_terms_and_conditions":"Hyväksyn ehdot ja edellytykset","Search::loading_details":"Latauksen yksityiskohdat","Search::loading_properties":"Latausominaisuudet","Search::my_listings_overview":"Tarjousprosessiini","Search::number":"Kohde Ei","Search::price":"Hinta","Search::this_object_is_already_active":"On jo avattu tarjousprosessi tätä listaa varten","seller":"Myyjä","SellerInviteSection::block":"Lohko","SellerInviteSection::invite":"Kutsu","SellerInviteSection::invite_seller":"Kutsu myyjä","send":"Lähetä","sms":"Tekstiviesti","sms_failed":"Tekstiviesti-ilmoitusta ei voitu toimittaa","start_new_sale":"Aloita uusi tarjouskierros","start_new_test_sale":"Aloita uusi testitarjouskierros","status":"Tila","street":"Katu","street_and_house_number":"Kadun nimi ja talon numero","submit":"Lähetä","submitted_on":"Lähetetty","submitted_value":"Tarjouksen summa","summary":"Yhteenveto","swiss_residential_status":"Sveitsin asuinpaikka","test_sale_explanation":"Käytä testimyyntiprosessia, jos haluat testata tarjousmenettelyä sisäisesti. Tästä myynnistä ei veloiteta. Älä kutsu ulkopuolisia oikeita asiakkaita myyntiin. Kaikki sivut ja ilmoitukset merkitään muotoon \"Testi\".","test_sale_watermark":"Demo myynti","this_action_cannot_be_undone":"Tätä toimenpidettä ei voi perua.","title":"Titteli","title::doctor":"Ph.D.","title::master":"Mag.","title::professor":"Prof.","type_of_property":"Kohteen tyyppi","updated_on":"Päivitetty","upload":"Lataa","upload_more":"Lataa lisää","uploading":"Lataaminen","uploads":"Uploads","uploadtype::identification_document":"Henkilöllisyystodistukset","uploadtype::misc":"Sekalaiset","value_must_be_between_min_and_max":"Arvon on oltava {min} ja {max} välillä","WhitelistingPanel::accept":"Jaa","WhitelistingPanel::block":"Lasku","WhitelistingPanel::blocked":"Hylätyt","would_you_like_to_continue":"Haluatko jatkaa?","yes":"Kyllä","zip_code":"Postinumero"}

/***/ }),
/* 895 */
/***/ (function(module, exports) {

module.exports = {"active":"Actif","add":"Ajouter","additional_address":"Complément d’adresse","additional_description":"Description supplémentaire et informations importantes","additional_information_text":"Message supplémentaire","address":"Adresse","AgencyDataForm::agency_address":"Adresse de l'agence","AgencyDataForm::agency_name":"Nom d'agence","AgencyDataForm::agent_name":"Nom du conseiller","AgencyDataForm::bic":"BIC","AgencyDataForm::iban":"IBAN","agent":"Conseiller","AgentProvisionForm::agent_commission":"Commission de courtage","AgentProvisionForm::fixed_amount":"Montant fixe","AgentProvisionForm::percentage":"Pourcentage","allowed_file_formats":"Pour un meilleur affichage sur tous les appareils des clients, seuls les fichiers au format PDF et JPG peuvent être téléchargés, avec une taille maximale de 20 MB.","App::initializing":"Initialisation","are_you_sure_this_action_cannot_be_undone":"En êtes-vous sûr°? Cette action ne peut pas être annulée.","auction_finals":"Finales des enchères","AuctionFinalsList::no_offer_selected_for_awardwing_go_back_to_the_matrix_and_pick_some":"No offer selected for awardwing, go back to the matrix and pick some.","AuctionFinalsList::object_no":"Object no.","AuctionFinalsList::selected_buyer":"Selected buyer","AuctionFinalsList::total":"Total","AuctionFinalsMatrix::awarded":"Awarded","AuctionFinalsMatrix::clear_selection":"Clear selection","AuctionFinalsMatrix::for_each_property_pick_the_best_available_offer":"For each property pick the best available offer","AuctionFinalsMatrix::for_each_property_pick_the_highest_offer_if_it_is_the_most_preferred_offer_of_the_highest_bidder":"For each property pick the highest offer if it is the most preferred offer of the highest bidder","AuctionFinalsMatrix::for_each_property_pick_the_highest_offer_if_the_highest_bidder_has_not_been_assigned_to_another_property_yet":"For each property pick the highest offer if the highest bidder has not been assigned to another property ye","AuctionFinalsMatrix::position":"Position","AuctionFinalsMatrix::preference":"Preference","AuctionFinalsMatrix::property":"Property","AuctionFinalsMatrix::select_best_offers":"Select best offers","AuctionFinalsMatrix::select_highest_offers":"Select highest offers","AuctionFinalsMatrix::select_preferred_highest_offers":"Select preferred highest offers","AuctionFinalsMatrix::this_is_the_highest_offer_for_this_property_but_its_not_selected":"This is the highest offer for this property, but it's not selected","AuctionFinalsMatrix::this_is_the_most_preferred_offer_for_this_buyer_but_its_not_selected":"This is the most preferred offer for this buyer, but it's not selected","AuctionFinalsPanel::confirm":"Confirm","AuctionFinalsPanel::continue":"Continue","AuctionFinalsPanel::error_loading_data_from_server":"Error loading data from server","AuctionFinalsPanel::failed":"Failed","AuctionFinalsPanel::report":"Report","AuctionFinalsPanel::review_winners":"Review winners","AuctionFinalsPanel::select_winners":"Select winners","AuctionFinalsPanel::succeeded":"Succeeded","AuctionFinalsTotals::awarded":"Awarded","AuctionFinalsTotals::selected":"Selected","AuctionFinalsTotals::total":"Awarded","audiencetype::bidders":"Enchérisseurs","audiencetype::everyone":"Toutes les personnes","audiencetype::non_bidders":"Non-enchérisseurs","AwardAllStep1::loading_offers_please_wait":"Loading offers, please wait","AwardStep1::choose_a_winner":"Choisissez un gagnant","AwardStep1::expiration_date":"Validité de l’offre","AwardStep2::expiration_date":"Validité de l'offre","AwardStep2::select_customers_to_reject_theirs_offer":"Sélectionnez les offres que vous souhaitez rejeter immédiatement.\nCes clients recevront immédiatement une notification d'annulation.\nTous les autres clients ne seront pas informés pour le moment s'ils souhaitent choisir un autre acheteur plus tard.","AwardStep2::this_text_will_appear_as_an_additional_note":"Ce texte s’affiche en guise d’indication supplémentaire dans l’avis au gagnant°:","AwardStep4::reject_message":"Message supplémentaire pour les acheteurs potentiels rejetés","AwardStep4::this_text_will_appear_as_an_additional_note":"Ce texte apparaîtra comme note supplémentaire dans la notification","AwardSummary::if_you_click_finish_you_confirm_the_winner":"Si vous cliquez sur «°Terminer°», vous confirmez le gagnant. Toutes les autres offres sont rejetées et les clients sont avisés.","AwardSummary::rejected_customers_offers":"Offres refusées","AwardSummary::selected_winner":"Gagnant sélectionné","back":"Retour","behalf_of":"Pour le compte de","bid_amount":"Montant de l’offre","bidding_type":"Type de processus d'offre","BiddingSection::highest_bidder":"Le plus offrant","BiddingSection::round_opens_on":"Tour ouvert le","BiddingSection::the_highest_offer":"L’offre la plus élevée","BiddingSection::the_next_minimum_offer":"L’offre minimale suivante","BulkRegistrationCsvPanel::back_to_mapping":"Retour","BulkRegistrationCsvPanel::duplicate_description":"L'enregistrement existe déjà","BulkRegistrationCsvPanel::import_from_csv_file":"Importer à partir d'un fichier CSV","BulkRegistrationCsvPanel::invalid_description":"Dossier incomplet","BulkRegistrationCsvPanel::total_number_of_rows_count":"Nombre total de lignes: {count}","BulkRegistrationCsvPanel::valid_description":"Enregistrement terminé","BulkRegistrationInventoryPanel::duplicate_description":"L'enregistrement existe déjà","BulkRegistrationInventoryPanel::entries_with_duplicate_emails_count":"Entrées avec e-mails en double: {count}","BulkRegistrationInventoryPanel::failed_registrations":"Enregistrements échoués : {count}","BulkRegistrationInventoryPanel::importing":"Importer","BulkRegistrationInventoryPanel::invalid_description":"Dossier incomplet","BulkRegistrationInventoryPanel::invalid_entries_count":"Entrées non valides: {count}","BulkRegistrationInventoryPanel::successful_registrations":"Enregistrements réussis : {count}","BulkRegistrationInventoryPanel::total_number_of_entries_count":"Nombre total d'entrées: {count}","BulkRegistrationInventoryPanel::valid_description":"Enregistrement terminé","BulkRegistrationTable::already_registered":"Déjà enregistré","BulkRegistrationTable::invalid_email":"Email invalide","BulkRegistrationTable::saving_error":"Erreur de téléversement","BulkRegistrationTable::select__unselect_all":"Tout sélectionner / désélectionner","BuyerDataForm::acting_organ__function":"Organe négociant - fonction","BuyerDocumentSelector::none":"Aucun","BuyerDocumentSelector::not_required":"Non nécessaire","BuyerDocumentSelector::optional":"Optionnel","BuyerDocumentSelector::required":"Obligation","buyertype::company":"Personne morale","buyertype::entrepreneurs":"Entrepreneur individuel","buyertype::private":"Personne privée","CallbackComponent::redirecting":"Déviation","cancel":"Annuler","citizenship":"Nationalité","city":"Lieu","close":"Fermer","Commands::accept":"Confirmer pour le tour suivant","Commands::all_offers":"Toutes les offres","Commands::approve":"Admettre à la procédure","Commands::approveregistration":"Activer les clients","Commands::are_you_sure_this_action_can_not_be_undone":"En êtes-vous sûr°? Cette action ne peut pas être annulée.","Commands::are_you_sure_to_block_user":"En êtes-vous sûr°? Le client est ainsi bloqué par le système°!","Commands::are_you_sure_to_close_the_sale":"En êtes-vous sûr°? La procédure est définitivement close.","Commands::are_you_sure_to_end_round_early":"En êtes-vous sûr°? Si vous mettez fin au tour, plus aucune offre ne peut être soumise.","Commands::are_you_sure_to_end_round_early_sealed":"En êtes-vous sûr°? Si vous mettez fin au tour, plus aucune offre ne peut être soumise et le montant de l’offre est en outre divulgué.","Commands::award":"Accepter l’offre d’achat","Commands::blank_offer":"Offre en blanc PDF","Commands::block_user":"Bloquer l’utilisateur","Commands::close_sale":"Clore la procédure d’offre","Commands::confirm":"Confirmer pour le client (TAN)","Commands::delete_sale":"Supprimer la procédure d’offre","Commands::download_documents":"Télécharger les documents","Commands::end_round_early":"Terminer le tour prématurément","Commands::import_registrations_from_csv_file":"Importer à partir d'un fichier CSV","Commands::import_registrations_from_onoffice":"Importer depuis onOffice","Commands::import_registrations_from_propup":"Importer depuis PropUp","Commands::invite_seller":"Inviter le vendeur","Commands::messaging":"Envoyer un message","Commands::new":"Lancer un nouveau tour","Commands::offer":"Offres","Commands::pdf_export":"Exportation pdf","Commands::refuse":"Rejet, car insuffisante","Commands::refuseregistration":"Rejeter les clients","Commands::register_new_user":"Convier de nouvelles personnes intéressées","Commands::registration":"Inscriptions","Commands::reject":"Refus définitif","Commands::round_close":"Cessation prématurée","Commands::round_open":"Ouvrir le tour","Commands::sale":"Objet","Commands::sale_wizard":"Assistant","Commands::update_contact":"Contact de mise à jour","Commands::upload":"Télécharger l’offre au nom du client","company":"Entreprise","company_court":"Tribunal de district","company_id":"FN","company_name":"Raison sociale","companylegalform::cooperative":"Société coopérative","companylegalform::foundation":"Fondation","companylegalform::general_partnership":"Société en nom collectif","companylegalform::jointstock_company":"Société anonyme (SA)","companylegalform::kommanditaktiengesellschaft":"Société en commandite par actions","companylegalform::limited_liability_company":"Société à responsabilité limitée (Sàrl)","companylegalform::limited_partnership":"Société en commandite","companylegalform::other":"Autres","companylegalform::simple_society":"Société simple","companylegalform::society":"Société","Confirmation::confirmation_expired":"Le TAN saisi est erroné ou a expiré","Confirmation::invalid_bid_value":"Le prix d’achat est trop faible","Confirmation::invalid_confirmation":"Le TAN saisi est erroné ou a expiré","Confirmation::sale_round_not_opened":"Votre offre ne peut pas être acceptée, car le tour est déjà terminé","ConfirmAwardStep1::choose_a_winner":"Choisissez un gagnant","ConfirmAwardStep1::expiration_date":"Validité de l'offre","ConfirmAwardStep1::reject_message":"Message supplémentaire pour les acheteurs potentiels rejetés","ConfirmAwardStep1::this_text_will_appear_as_an_additional_note":"Ce texte apparaîtra comme note supplémentaire dans la notification","ConfirmAwardSummary::if_you_click_finish_you_confirm_the_winner":"Lorsque vous cliquez sur \"Terminer\", vous confirmez l'acheteur. Toutes les autres offres sont rejetées et les clients sont informés.\nCette étape ne peut pas être annulée.","ConfirmAwardSummary::rejected_customers_offers":"Offres refusées","ContactPanel::update_contact":"Contact de mise à jour","costs":"Frais","costsoption::contract":"frais de contrat","costsoption::notary":"frais d’instrumentation de l’acte","costsoption::registry":"frais du registre foncier","costsoption::reservation":"frais de traitement de l’acompte de réservation","costsparty::buyer":"Acheteur potentiel","costsparty::seller":"Propriétaire","costsparty::split":"Partage à parts égales","Countdown::das_verfahren_ist_beendet":"La procédure est terminée","CounterofferStep2::please_define_the_next_round":"Veuillez définir le tour suivant","CounterofferStep2::validity_of_offers_set_to_the_same_value":"Validité des offres définies sur la même valeur","CounterofferSummary::click_finish_to_start_a_new_round":"Cliquez sur terminer pour commencer un nouveau tour","CounterofferSummary::customers_for_the_next_round":"Sélectionnez les clients qui devraient participer au prochain tour","CounterofferSummary::customers_not_participating_in_the_next_round":"Sélectionnez les clients qui ne devraient pas participer au prochain tour","CounterofferSummary::round_details":"Détails ronds","country":"Pays","created_on":"Créé le","CsvMappingTable::do_not_import":"n'importez pas","customer":"Client","customer_buyer_reference_of_name":"Client {buyer_reference} de {name}","customer_name":"Nom du client","customer_of_name":"Client de {name}","Dashboard::authorization_in_progress":"Autorisation","Dashboard::customer_service_contact":"Service à la clientèle","Dashboard::customer_service_email":"support@propnow.com","Dashboard::customer_service_p":"Pour tout problème ou question, vous pouvez nous joindre aux coordonnées suivantes°:","Dashboard::customer_service_telephone":"+49 30 959992518","Dashboard::customer_service_telephone_href":"+4930959992518","Dashboard::do_you_really_want_to_log_out":"Voulez-vous vraiment vous déconnecter°?","Dashboard::log_out":"Déconnexion","Dashboard::tel__sms__whatsapp":"Tél.","date":"Date","date_of_birth":"Date de naissance","DateField::dateformat":"jj.mm.aaaa","DateField::invalid_date":"Date invalide","days":"Jours","delete":"Effacer","deposit_payment_deadline":"Délai de paiement de l'acompte","depositRequired::false":"Non","depositRequired::true":"Oui","deposittype::fixed_amount":"Montant fixe","deposittype::none":"Aucun","deposittype::percentage":"Pourcentage","doc_from":"du","Doc::from":"du","Doc::no_type":"Veuillez attribuer un type de document","Doc::original_name":"Téléchargé en tant que {originalFilename} le {uploadedAt, date, medium} {uploadedAt, time, medium}","documents":"Documents","documenttype::annual_statement":"Décompte annuel","documenttype::appraisal":"Expertise de la valeur d’usage","documenttype::area_allocation_plan":"Plan d’occupation des sols","documenttype::building_permit":"Permis de construire","documenttype::completion_display":"Avis d’achèvement","documenttype::condominium_contract":"Contrat relatif à la propriété du logement","documenttype::energy_certificate":"Certificat énergétique","documenttype::expose":"Description du bien immobilier","documenttype::expose_long":"Description du bien immobilier (plaquette)","documenttype::land_register":"Extrait du registre foncier","documenttype::loan_agreement":"Contrat de prêt","documenttype::operating_costs":"Coûts d’exploitation","documenttype::operating_costs_long":"Coûts d’exploitation / prévision des coûts de préservation et d’amélioration au sens du § 20, al. 2 WEG","documenttype::promissory_note":"Titre de créance","documenttype::running_costs":"Prescription des frais courants","documenttype::usage_permit":"Autorisation d’utilisation","DuplicateStep1::agbs":"CG","DuplicateStep1::duplicating_sale":"Procédure d'offre Duplication","DuplicateStep1::hint1":"Toutes les données et documents liés au formulaire d'offre sont adoptés","DuplicateStep1::hint2":"Vous pouvez ensuite ajuster les informations, définir la visite et inviter de nouveaux clients potentiels","DuplicateStep1::i_agree_to_the_link":"J’approuve le {agbs}","DuplicateStep1::i_agree_with_terms_and_conditions":"J’approuve les CG","DuplicateSummary::duplicating_sale":"Procédure d'offre Duplication","duration":"Durée","duration_type":"Délais","durationtype::fixed":"Fixe","durationtype::flexible":"Flexible","edit":"Modifier","EditPanel::edit_offer_form":"Préparer le formulaire d’offre d’achat","email":"E-mail","email_failed":"La notification par e-mail n'a pas pu être envoyée","EmailField::invalid_email":"L’adresse e-mail n’est pas correcte","encoding":"Codage","Error::blocked":"La page que vous tentez de consulter semble ne pas exister. Soit votre lien est erroné, soit la procédure d’offre numérique est déjà terminée. Vous trouverez d’autres objets sous°:","field::depositrequired":"Dépôt","field::email":"E-mail","field::firstname":"Prénom","field::lastname":"Nom","field::locale":"Langue","field::phone":"Numéro de portable","field::salutation":"Salutation","field::title":"Titre","fill_required_fields":"Veuillez compléter tous les champs obligatoires°!","financing_required":"Financement requis","financing_secured":"Financement sécurisé","first_name":"Prénom","handover":"Date de remise","handovertype::contract":"Selon le contrat d'achat","handovertype::key_handover":"Après la remise des clés","handovertype::land_register":"Après l’inscription sur l’extrait du registre foncier","handovertype::money_transfer":"Après le virement du prix d’achat sur le compte prédéfini","handovertype::sale_contract":"Selon le contrat de vente","hidden":"masqué","house_number":"Numéro","iban":"IBAN","image":"Image","import":"Importer","IncreaseStep1::all_other_offers_will_be_rejected":"Toutes les autres offres sont rejetées et n’ont pas la possibilité de participer à un tour supplémentaire.","IncreaseStep1::expiration_date":"Validité de l’offre","IncreaseStep1::invite_more_customers_after_start_of_next_round":"Après le début du tour suivant, vous aurez la possibilité de convier d’autres personnes intéressées.","IncreaseStep1::select_customers":"Choisissez les clients qui doivent participer au prochain tour.","IncreaseStep2::please_define_the_next_round":"Veuillez définir le prochain tour.","IncreaseStep2::validity_of_offers_set_to_the_same_value":"La date de validité des offres d’achat pour les offres supplémentaires a automatiquement été fixée à la même valeur que lors du tour précédent.","IncreaseStep3::this_text_will_appear_as_an_additional_note":"Ce texte s’affiche en guise d’indication supplémentaire dans l’avis au client°:","IncreaseSummary::click_finish_to_start_a_new_round":"Si vous cliquez sur «°Terminer°», un nouveau tour est lancé et les clients en sont informés.","IncreaseSummary::customers_for_the_next_round":"Clients pour le prochain tour","IncreaseSummary::customers_not_participating_in_the_next_round":"Clients qui ne participent pas au prochain tour","IncreaseSummary::round_details":"Détails du tour","last_name":"Nom","legal_form":"Forme juridique","ListingsOverview::add_new_listing":"Ajouter un nouveau bien immobilier","ListingsOverview::agent":"Conseiller","ListingsOverview::approved_offers":"Personnes intéressées admises","ListingsOverview::create_new_listing":"Créer un nouveau bien immobilier","ListingsOverview::end_date":"Échéance","ListingsOverview::guide__you_should_add_a_new_listing":"Pour lancer la procédure d’offre, vous devez d’abord sélectionner un bien immobilier.","ListingsOverview::loading_listings":"Les biens immobiliers sont chargés","ListingsOverview::my_listings_overview":"Mes procédures d'offres","ListingsOverview::number":"N° d’objet","ListingsOverview::pending_offers":"Offres en cours","ListingsOverview::start_date":"Date de début","loading":"Téléchargement en cours","locale":"Langue","locale::de":"Allemand","locale::dech":"Allemand","locale::dede":"Allemand","locale::en":"Anglais","locale::fr":"Français","locale::frch":"Français","locale::frlu":"Français","locale::it":"Italien","locale::itch":"Italien","locale::ro":"Roumain","locale::roro":"Roumain","locale::sl":"Slovène","locale::slsi":"Slovène","manage":"Administrer","ManagePanel::administration":"Administration","ManagePanel::my_data":"Mes données","ManagePanel::object_supervisor":"Gestionnaire d’objet","marital_status":"Situation familiale","maritalstatus::divorced":"Divorcé(e)","maritalstatus::married":"Marié(e)","maritalstatus::none":" ","maritalstatus::single":"Célibataire","maritalstatus::widowed":"Veuf/veuve","message":"Message","MessagingPanel::audience":"Récipiendaires","MessagingPanel::failed_to_send_the_message":"Impossible d'envoyer le message","MessagingPanel::messaging":"Envoyer un message personnalisé","MessagingPanel::no_message_has_been_sent":"Aucun message n'a été envoyé","MessagingPanel::number_of_failed_messages":"Nombre de messages ayant échoué","MessagingPanel::number_of_successfully_sent_messages":"Nombre de messages envoyés avec succès","MessagingPanel::subject":"Sujet","MessagingPanel::template":"Modèle","MessagingPanel::text":"Texte","mls":"MLS","mls::everyone":"MLS gratuit","Mls::no_sale_for_mls":"Il n'y a actuellement aucun processus de vente disponible","mls::none":"Pas de MLS","mls::tenant":"MLS uniquement au sein de votre locataire","more":"plus","name":"Nom","next":"Continuer","no":"Non","not_entered":"Non complété","notary":"Rédacteur du contrat","notificationemailtemplate::cust_bid_refused":"Offre rejetée","notificationemailtemplate::cust_highest_bidder":"Le plus offrant","notificationemailtemplate::cust_highest_bidder_changed":"Nouvelle enchère maximale","notificationemailtemplate::cust_invited":"Convier des personnes intéressées","notificationemailtemplate::cust_message":"Message","notificationemailtemplate::cust_offer_awarded":"Offre d’achat acceptée","notificationemailtemplate::cust_offer_placed":"Offre remise","notificationemailtemplate::cust_offer_raised":"Augmenter l’offre d’achat","notificationemailtemplate::cust_offer_refused":"Rejeter l’offre d’achat","notificationemailtemplate::cust_outbid":"Offre remise","notificationemailtemplate::cust_outbid_antisniping":"Offre remise","notificationemailtemplate::cust_outbid_others":"Nouvelle enchère maximale","notificationemailtemplate::cust_phase_invite_closing":"Rappel - Phase d'inscription","notificationemailtemplate::cust_phase_offer_starting":"Rappel - Lancement de l'appel d'offres","notificationemailtemplate::cust_phase_wishlist_closing":"Rappel - Fin de la sélection des objets","notificationemailtemplate::cust_rejected_round_closed":"Offre d’achat rejetée","notificationemailtemplate::cust_rejected_sold":"Offre d’achat rejetée","notificationemailtemplate::cust_rejected_unsold":"Offre d’achat rejetée","notificationemailtemplate::cust_round_closed":"Le tour est terminé","notificationemailtemplate::cust_round_closing":"E-mail de rappel","notificationemailtemplate::cust_round_edited":"Tour ajusté","notificationemailtemplate::cust_round_opened":"Nouveau tour commencé","NotificationPreview::no_notification_defined_for_the_selected_action":"Aucune notification ne sera envoyée pour l'action sélectionnée","notifications":"Notifications","notificationservicestatus::delivered":"Livré","notificationservicestatus::failed":"Échec","notificationservicestatus::pending":"Imminent","notificationservicestatus::sent":"Envoyé","NotificationsPanel::explanation":"Veuillez activer cette fonction, si vous souhaitez être informé des activités relatives à la procédure d’offre de cet objet par e-mail et SMS°:","NotifySellerSummary::description":"Les offres d'achat des clients suivants seront envoyées directement au vendeur par e-mail:","now":"Maintenant","number":"Numéro","offer":"Offre","offer_viewing":"État de la visite du","offer_viewing_help":"Veuillez laisser vide si ce n'est pas déjà fait","OfferDetailsForm::agreement_installer__lawyer":"Rédacteur du contrat / avocat","OfferDetailsForm::other_agreements":"Autres accords","OfferDetailsForm::purchase_offer_valid_until":"Offre d’achat valable jusqu’au","OfferDetailsForm::purchase_price_gross":"Prix d’achat (libre de charges)","OfferNotificationDetails::service_data":"Données de service","OfferNotificationsList::created_on":"Envoyé le","OfferNotificationsList::error_loading":"Le chargement de la liste de notification a échoué","OfferNotificationsList::recipient":"Destinataire","OfferNotificationsList::service_status":"Statut du service","OfferNotificationsList::template":"Objet","OffersSection::hidden":"actuellement masqué","OffersSection::increase_offer_on_behalf_of_the_customer":"Augmenter l’offre au nom du client","OffersSection::invited_on":"Invité le","OffersSection::submitted_at":"Remise le","OffersSection::submitted_value":"Montant de l’offre","OffersSection::upload_offer_on_behalf_of_a_customer":"Télécharger l'offre au nom du client","offerstatus::accepted":"Confirmé","offerstatus::approved":"Autorisé","offerstatus::awarded":"Accepté","offerstatus::confirmed":"Remis","offerstatus::invited":"Invité","offerstatus::refused":"Rejeté","offerstatus::registrationconfirmed":"En attente d'activation","offerstatus::registrationsubmitted":"Inscription soumise","offerstatus::rejected":"Refusé","offerstatus::submitted":"Préparé","offerstatus::updated":"En cours","ok":"OK","open":"Ouvrir","optional":"Optionnel","other_agreements":"Autres accords","overview":"Liste d'offres","ownership":"Forme de propriété","ownershiptype::joint":"Propriété commune","ownershiptype::residential":"Propriété du logement","ownershiptype::share":"Copropriété","ownershiptype::sole":"Propriété individuelle","Page1::area":"Surface","Page1::construction_year":"Année de construction","Page1::deed":"Registre foncier","Page1::deed_kg":"KG","Page1::energy_certificate":"Certificat énergétique","Page1::housing_subsidies":"Promotion de la construction de logements","Page1::lot":"Lots","Page1::object_number":"Numéro d’objet","Page1::other_reference":"Contenance","Page1::ownership_share":"Part","Page1::ownership_total":"Total","Page1::parcel_number":"N° de parcelle","Page1::register_number":"Numéro cadastral","Page1::section":"Section","Page1::usage_rules":"Règles d’utilisation","Page2::agency":"Agence RE/MAX","Page2::agent_commission":"Commission de courtage d'acheteur (hors TVA)","Page2::date_of_delivery_warranty":"Date de remise, garantie","Page2::date_of_delivery_warranty_contract":"Date de remise, garantie, rédacteur du contrat","Page2::deferred_sale":"Vente différée","Page2::deposit":"Acompte de réservation","Page2::exceptions":"Exceptions","Page2::from_offer_value":"du prix de l’offre","Page2::handover_date":"Date d’entrée dans les lieux","Page2::has_mortgage":"Hypothèque à reprendre","Page2::mortgage":"Charges acceptées","Page2::mortgage_condition":"Conditions","Page2::mortgage_condition_tooltip":"Consigner ici les conditions déterminantes, telles que le taux d’intérêt, la durée de vie résiduelle, etc.","Page2::mortgage_detail":"Charges acceptées chez","Page2::mortgage_tooltip":"Inscrivez ici le montant de l’hypothèque actuellement dû","Page2::notary":"Rédacteur du contrat / avocat","Page2::notary_address":"Adresse du notaire","Page2::notary_date":"Date du notaire","Page2::notary_name":"Nom du notaire","Page2::proof_of_financing_deadline":"Date limite de preuve de financement","Page2::refusal_of_financing_notification_deadline":"Date limite pour notifier un refus de financement","Page2::seller":"Vendeur","Page2::time_of_day":"Heure","Page2::vatliable_purchase":"Achat soumis à la TVA","Page3::all_documents_must_have_a_type_set":"Aucun type de document n’a encore été attribué pour un ou plusieurs documents.","Page3::choose_a_document_type_or_enter_description":"Veuillez sélectionner le type de document correspondant ou inscrire votre propre désignation.","Page3::document_type":"Type de document","Page3::upload_following_documents":"Veuillez télécharger au moins les documents suivants","peptype::family":"membre de la famille PEP","peptype::no":"Non","peptype::related":"A une relation étroite avec une PEP","peptype::yes":"L'acheteur est un PEP","person":"La personne","phone_number":"Numéro de portable","phone_number_placeholder":"+49 150 0000 0000","phonenumbererror::invalid":"Le numéro de téléphone n'est pas valide","phonenumbererror::notmobile":"Le numéro de téléphone n'est pas un numéro de mobile","place_of_birth":"Lieu de naissance","politically_exposed_person_pep":"Personne politiquement exposée (PEP)","post_code":"NPA","postal_code":"NPA","preview":"Aperçu","previous":"Retour","previous_round":"Tour précédent","price_on_offer":"Prix par rapport à l'offre","price_on_request":"Prix sur demande","processing":"En traitement","property_for_sale":"Objet en vente","provision":"Commission d'acheteur","ProvisionAck::i_have_taken_note_of_the_following_important_information":"J'ai pris note des informations importantes suivantes","provisiontype::default":"Standard","provisiontype::fixed_amount":"Montant fixe (hors TVA)","provisiontype::fixed_percentage":"Pourcentage (hors TVA)","provisiontype::none":"Sans commission","purchase_price":"Prix d’achat","recipient":"Destinataire","refresh":"Mise à jour","RefuseDialog::explanation":"Informez la personne intéressée du motif de rejet.","RefuseDialog::optional_documents":"Documents optionnels","RefuseDialog::reason":"Justification","RefuseDialog::refuse_an_offer":"Rejeter l’offre","RefuseDialog::required_documents":"Documents requis","register":"Inviter","registering":"J'invite","RegistrationPanel::already_registered":"Vous avez déjà invité un client avec cette adresse e-mail°!","RegistrationPanel::locale":"Langue préférée","RegistrationPanel::offer_viewing":"État de la visite du","RegistrationPanel::optional_documents":"Documents optionnels","RegistrationPanel::place_at":"Reçu le","RegistrationPanel::purchase_price_gross":"Prix d’achat (libre de charges)","RegistrationPanel::register_new_user":"Convier de nouvelles personnes intéressées","RegistrationPanel::required_documents":"Documents requis","RegistrationPanel::send_the_invitation_again":"Renvoyer l’invitation","RegistrationPanel::upload_an_offer":"Télécharger l’offre (au nom du client)","RegistrationPanel::upload_new_offer":"Télécharger une nouvelle offre au nom du client","RegistrationPanel::upload_offer":"Télécharger l’offre","RejectSummary::click_finish_to_reject_all_offers":"Si vous cliquez sur «°Terminer°», toutes les offres sont rejetées et les clients en sont informés.","remove":"Retirer","required_documents":"Documents requis","round":"Tour","RoundEdit::allow_bidding_below_starting_price":"Autoriser les enchères inférieures au prix de départ","RoundEdit::allow_bidding_below_starting_price__tooltip":"Dans la procédure d'offre ouverte, les parties intéressées ne peuvent normalement faire une offre qu'à partir du prix de départ, ce qui peut signifier que les clients les plus sensibles au prix ne font souvent pas d'offre. Avec cette option, vous offrez aux parties intéressées la possibilité de soumettre une offre <u>en dessous de</u> le prix de départ - mais au-dessus du prix minimum (initialement caché) fixé par le courtier. L'avantage est qu'un plus grand nombre de parties intéressées soumettent une offre, étant donné que des offres à un prix inférieur sont également autorisées. Cela permet d'élargir le champ des soumissionnaires et d'augmenter les chances de vente. Toutes les offres inférieures au prix de départ sont cachées aux autres parties intéressées afin d'éviter un effet d'ancrage négatif. Seules les offres à partir du prix de départ sont affichées par défaut, à moins que vous n'activiez l'option \"Montrer les offres inférieures au prix de départ aux autres soumissionnaires\".","RoundEdit::allow_bidding_below_starting_price_hidden":"Autoriser les enchères inférieures au prix de départ (masqué)","RoundEdit::antisniping_notice":"La fin de la période de l'offre est automatiquement prolongée de 15 minutes si une nouvelle offre est reçue dans les 15 minutes précédant la fin de l'offre. Cette prolongation est répétée jusqu'à ce qu'aucune autre offre ne soit faite pendant 15 minutes.","RoundEdit::bidding_steps":"Incrément d'offre minimum","RoundEdit::bidding_steps__standard":"Étalage standard des étapes d'enchères","RoundEdit::bidding_steps__tooltip":"Il s'agit du montant minimum d'augmentation pour les nouvelles offres. Chaque nouvelle offre doit être supérieure d'au moins ce montant à l'offre la plus élevée. Si vous avez sélectionné l'option \"Autoriser les offres inférieures à l'offre la plus élevée\", l'augmentation minimale de l'offre se réfère à l'offre précédente du client individuel s'il a déjà fait une offre (pour plus d'informations, voir le bouton d'information : \"Autoriser les offres sous l'offre la plus élevée\")","RoundEdit::bidding_type_tooltip":"Choisissez le type d'enchère","RoundEdit::counteroffer_value":"Valeur de la contre-offre proposée","RoundEdit::end_date_changed":"All invited buyers and agents will be notified about the change of the end of the bidding process via e-mail.","RoundEdit::ends_at":"Fin du processus d’offre","RoundEdit::ends_at__tooltip":"Pour la fin de la procédure d'appel d'offres, nous vous recommandons de choisir un moment où les personnes intéressées sont disponibles et se trouvent dans un endroit disposant d'une bonne connexion internet (par exemple, chez elles). L'expérience a montré que les débuts de soirée ou les week-ends fonctionnent très bien dans ce cas. Toutefois, veuillez tenir compte des jours fériés et des week-ends prolongés pendant lesquels les personnes intéressées peuvent être absentes. Il est également important d'informer les parties intéressées du calendrier. À la fin de la période d'enchères, des rappels seront envoyés aux parties intéressées invitées 72 heures, 24 heures et 60 minutes avant la fin prévue. Nous vous recommandons également, en tant qu'agent, d'être joignable par téléphone pendant la dernière heure avant la fin de la procédure d'appel d'offres et, si nécessaire, de suivre la procédure d'appel d'offres en direct sur votre ordinateur portable ou votre tablette afin de pouvoir aider les parties intéressées en cas de questions ou de problèmes (par exemple, en cas de mauvaise connexion à l'internet de la partie intéressée).","RoundEdit::estimate":"Prix indicatif","RoundEdit::estimate__tooltip":"Le prix indicatif est un prix communiqué à la personne intéressée en guise de valeur de référence. Il aide à fixer le propre prix de l’offre. Important°: le prix indicatif ne constitue pas un prix minimum. Autrement dit, la personne intéressée peut également remettre une offre inférieure au prix indicatif.","RoundEdit::estimate_lower_than_startprice":"Le prix indicatif ne peut être inférieur au prix minimum","RoundEdit::flexible_bidding":"Autoriser les enchères inférieures à l'enchère maximale","RoundEdit::flexible_bidding__tooltip":"Dans la procédure d'offre ouverte, les parties intéressées doivent normalement soumettre une nouvelle offre maximale à chaque nouvelle offre, ce qui peut conduire certaines parties intéressées à abandonner prématurément, voire à ne pas faire d'offre du tout. En choisissant cette option d'offre flexible, la partie intéressée a la possibilité de soumettre une offre <u>inférieure à</u> l'offre maximale actuelle. Toutefois, la nouvelle offre doit être <u>supérieure à</u> au prix de l'offre précédente du client correspondant s'il a déjà soumis une offre. L'incrément minimum de l'offre est ici décisif et n'est appliqué que <b>à sa propre offre</b>. L'avantage de cette option est que les parties intéressées enchérissent plus fréquemment et qu'un terrain d'entente plus fort est créé parce que les soumissionnaires n'abandonnent pas prématurément. Cela peut augmenter les chances de vente, en particulier lorsqu'il n'y a que quelques parties intéressées ou si le prix de départ est un peu trop élevé.","RoundEdit::hide_highest_bid__bid_history_for_nonbidders":"Afficher les autres offres uniquement <strong>après</strong> avoir soumis votre propre offre","RoundEdit::hide_highest_bid__bid_history_for_nonbidders__tooltip":"Pour des raisons de transparence, l'offre la plus élevée actuelle ainsi que toutes les offres d'achat soumises sont normalement affichées dès le début à toutes les personnes invitées dans le processus ouvert - avant même qu'elles n'aient elles-mêmes soumis une offre. Dans certains cas, cela peut conduire certaines parties intéressées, dissuadées par des prix d'offre déjà très élevés, à ne pas faire d'offre du tout, alors qu'elles auraient souhaité faire une offre. faites également une offre d'achat, cette option d'enchère peut être utile.","RoundEdit::listing_price":"Prix de vente selon mandat","RoundEdit::min_price":"Prix minimum","RoundEdit::min_price__tooltip":"Prix d'achat minimum que l'intéressé doit proposer. Affiché uniquement si l'intéressé souhaite faire une offre en dessous de ce prix.","RoundEdit::min_price_lower_than_start":"Le prix minimum doit être inférieur au prix initial","RoundEdit::minimum_price":"Prix minimum","RoundEdit::offer_validity":"Validité des offres d’achat","RoundEdit::open_round_warning":"Seul un tour est prévu dans la procédure d’offre ouverte et les offres sont divulguées à tous.","RoundEdit::please_enter_a_starting_price":"Veuillez saisir un prix >0","RoundEdit::red_button_price":"Prix red button","RoundEdit::red_button_price__tooltip":"Il s’agit du prix minimum (estimé) auquel le propriétaire est disposé à vendre. Il s’agit d’un prix purement interne qui n’est pas communiqué au client et que seul le courtier peut voir. Le courtier est immédiatement informé lors que le prix red button est atteint.","RoundEdit::select_a_bidding_type":"Choisissez un type de procédure","RoundEdit::show_bids_below_starting_price":"Montrer les offres inférieures au prix de départ aux autres enchérisseurs","RoundEdit::show_bids_below_starting_price__tooltip":"Seules les offres <u>à partir de</u> le prix de départ sont affichées par défaut, à moins que vous n'activiez cette option. Dans ce cas, les offres <u>en dessous de</u> du prix de départ sont également affichées et vous bénéficiez d'une plus grande transparence dans le processus d'offre.","RoundEdit::simple_offer_duration_suggestion_notice":"Il s'agit de la validité limitée proposée pour les offres d'achat. Cependant, l'acheteur potentiel peut la modifier lors de la soumission de son offre","RoundEdit::start":"Début du processus d’offre","RoundEdit::start__tooltip":"Si vous invitez des personnes intéressées <u>avant</u> le début de la procédure d'offre (période d'offre), elles peuvent déjà saisir leurs données, consulter les documents relatifs au bien immobilier et <u>préparer</u> une offre. Toutefois, l'offre ne peut pas encore être soumise ! Dès que l'heure de début est atteinte et que la période d'offre a commencé, toutes les parties intéressées invitées reçoivent une notification et peuvent alors commencer à soumettre leurs offres d'achat.<br /><br />Conseil : la durée moyenne de la procédure d'offre, c'est-à-dire la période pendant laquelle les offres peuvent être soumises (période d'offre), est d'environ 5 à 7 jours. Cela permet de créer une dynamique suffisante tout en évitant que les personnes intéressées ne se désintéressent du bien (ce qui peut arriver si la période d'offre est trop longue). Cependant, la période de 5 à 7 jours suppose également que toutes les parties intéressées ont déjà été suffisamment présélectionnées par vous en tant que courtier au début du processus d'offre, y compris la visite du bien et la clarification des options de financement. Toutefois, si le financement n'est pas encore clair pour la majorité des parties intéressées et que vous choisissez donc l'option \"confirmation du financement\" lorsque vous invitez les parties intéressées, vous devriez également choisir une durée légèrement plus longue pour le processus d'offre afin de donner aux parties intéressées suffisamment de temps pour clarifier leur financement pendant que le processus est en cours. Si vous avez d'autres questions, n'hésitez pas à contacter notre équipe.","RoundEdit::starting_price":"Prix initial","RoundEdit::starting_price__tooltip":"Prix que la personne intéressée doit au minimum proposer lors de la remise de l’offre initiale.","RoundEdit::time_of_day":"Heure","RoundInfo::ends":"La procédure d’offre se termine","RoundInfo::offer_validity":"Offre d’achat valable","RoundInfo::starts":"La procédure d’offre commence","RoundItem::badge_free":"Gratuit","RoundItem::badge_new":"Nouveau","RoundItem::badge_separator":" et ","RoundItem::how_it_works":"Comment ça marche","RoundItem::incremental_auction_howitworkspoints":"- Offres ouvertes à partir du prix de départ\n- Possibilité de faire plusieurs offres\n- Extension automatique pour les offres de dernière minute\nNouvelles options d'offres flexibles :\n- Possibilité de placer des offres <u>en dessous du prix de départ</u>\n- Montant de l'offre <u>librement sélectionnable</u> (au-dessus du prix minimum)\n- Seules les offres supérieures au prix de départ sont affichées\n- Date de début et de fin fixes","RoundItem::incremental_auction_subtitle":"avec des offres flexibles","RoundItem::incremental_auction_title":"Processus d'offre ouvert","RoundItem::incremental_auction_whentouseitpoints":"Comme un processus d'offre \"ouvert\" normal, mais aussi si :\n- Demande plus faible\n- Clients sensibles au prix\n- Prix de départ moins attractif\n- Augmentation des prix peu claire\n- Offrir plus de flexibilité aux clients","RoundItem::open_bidding_howitworkspoints":"- Le premier enchérisseur doit proposer au moins le prix de départ\n- Chaque offre <b>doit être supérieure à toutes les offres précédentes</b>\n- Chaque client peut améliorer son offre\n- Toutes les < b>Offres sont visibles</b>\n- Les noms des clients sont anonymisés pour les autres clients\n- Début et fin explicites du processus","RoundItem::open_bidding_subtitle":"avec enchères croissantes","RoundItem::open_bidding_title":"Processus d'offre ouvert","RoundItem::open_bidding_whentouseitpoints":"- Prix de départ attractif\n- Forte demande\n- Valeur marchande de la propriété supérieure au prix de départ\n- Augmentation de prix attendue","RoundItem::sealed_bidding_howitworkspoints":"- Prix indicatif, pas de prix minimum\n- Montant de l'offre <u>librement sélectionnable</u>\n- Chaque client ne peut soumettre qu'<u>une</u> offre\n- Nombre de clients et montants des offres cachées\n- Date de fin fixe\n- <u>Pas</u> de prolongation automatique pour les offres de dernière minute","RoundItem::sealed_bidding_subtitle":"avec des offres cachées","RoundItem::sealed_bidding_title":"Processus d'offre fermé","RoundItem::sealed_bidding_whentouseitpoints":"- Demande faible ou peu claire\n- Déterminer le prix du marché ou le niveau de la demande\n- Ventes confidentielles, secteur public\n- Propriété difficile à évaluer","RoundItem::simple_offer_howitworkspoints":"- Placer des offres uniques (sans concurrence) \n- Prix de vente officiel comme référence \n- Client peut choisir librement le prix\n- Client ne peut soumettre qu'<u>une</u> offre\n- Aucune information sur d'éventuelles autres clients intéressées\n- Pas de date de fin fixe\n- Possibilité de passer au processus d'offre si plusieurs clients soumettent des offres","RoundItem::simple_offer_subtitle":"pour les offres uniques","RoundItem::simple_offer_title":"Offre digitale","RoundItem::simple_offer_whentouseitpoints":"- Peu de clients intéressées\n- Long cycle de vente\n- Test de volonté d'achat\n- Possibilité de soumettre une offre sous réservation","RoundItem::when_to_use_it":"Quand sera-t-il utilisé","RoundPanel::round":"Paramètres du processus d'offre","roundstatus::closed":"Terminé","roundstatus::opened":"Ouvert","roundstatus::started":"Nouveau","roundtype::counteroffer_bidding":"Procédure de contre-offre","roundtype::incremental_auction":"Procédure d’offre ouverte","roundtype::open_bidding":"Procédure d’offre ouverte","roundtype::sealed_bidding":"Procédure d’offre fermée","roundtype::show_invited_customers_count":"Afficher le nombre de personnes intéressées","roundtype::show_invited_customers_count_tooltip":"Le nombre total de tous les acheteurs potentiels invités est affiché pour chaque client participant.","roundtype::simple_offer":"Offre digitale pour les offres uniques","Sale::all_information_entered_by_customer_will_be_overwritten":"Toutes les indications que le client a déjà fournies sont écrasées.","Sale::already_confirmed":"Ce client a remis une offre d’achat. Une offre supplémentaire au nom du client est impossible.","Sale::billing_notice":"Les coûts de cette procédure d'offre représentant 0,11% de la plus haute enchère reçue seront à la charge du conseiller RE/MAX à la mise en service.","Sale::cannot_update_documents_for_open_round__documents_uploaded":"Les documents suivants ont été téléchargés°:","Sale::cannot_update_documents_for_open_round__no_documents":"Vous n’avez pas téléchargé de documents.","Sale::do_you_want_to_open_the_round":"Voulez-vous ouvrir le tour°?","Sale::guide__define_offer_form":"Vous devez compléter les données d’objet dans un premier temps.","Sale::guide__edit_round":"Si les données du tour sont incorrectes, ajustez-les","Sale::guide__import_users_csv":"Importer des utilisateurs à partir d'un fichier CSV","Sale::guide__invite_users":"Pour inviter la première personne intéressée, vous avez besoin de son adresse e-mail, de son nom complet et de son numéro de mobile.","Sale::guide__missing_mandatory_offer_form":"Veuillez compléter tous les champs obligatoires°!","Sale::guide__open_round":"Pour lancer la procédure d’offre numérique et inviter certains clients, vous devez ouvrir le tour.","Sale::guide__start_round":"Vous devez à présent saisir les données de référence concernant le déroulement du tour.","Sale::guide__start_round_edit_sale":"Vous avez rempli tous les champs obligatoires du formulaire d'offre. Vous pouvez les consulter ou les modifier ici.","Sale::guide_action__edit_round":"Ajuster","Sale::guide_action__edit_sale":"Préparer le formulaire d’offre d’achat","Sale::guide_action__import_users_csv":"Importer des utilisateurs","Sale::guide_action__invite_bidders":"Convier de nouvelles personnes intéressées","Sale::guide_action__open_round":"Ouvrir le tour","Sale::guide_action__start_round":"Lancer un nouveau tour","Sale::guide_action__start_round_edit":"Modifier le formulaire d'offre","Sale::guides__manage_the_sale":"Assistant","Sale::guides__offers_present":"Vous pouvez maintenant discuter de \"aperçu\" des offres avec le vendeur, puis saisir sa décision dans \"Assistant\".","Sale::guides__round_closed":"Votre tour est à présent terminé. Vous pouvez préparer la vue d’ensemble pour le vendeur et saisir le résultat du tour.","Sale::guides__show_overview":"Liste d'offres","Sale::guides__start_open_process":"Passer au processus d'offre","Sale::guides__upgrade":"Vous avez reçu plusieurs offres. Pour optimiser le résultat des ventes, vous pouvez passer au processus d'offre","Sale::invalid_bid_value":"Cette offre ne peut pas être acceptée. Il existe déjà une offre plus élevée ou équivalente. Veuillez informer le client pour qu’il puisse adapter son offre.","Sale::loading_sale":"Le bien immobilier est chargé","Sale::no_estimate":"pas d'estimation","Sale::no_starting_price":"pas de prix de départ","Sale::open_round_deadline_today":"Votre tour devrait se terminer aujourd'hui. Voulez-vous vraiment ouvrir la manche ?","Sale::open_round_deadline_too_long":"Votre tour doit se terminer dans {durationInDays} jours ? Êtes-vous sûr de vouloir ouvrir le tour ?","Sale::open_round_info_invalid_duration":"Vous ne pouvez pas ouvrir une manche qui devrait se terminer dans le passé. Veuillez modifier les détails du tour.","Sale::open_round_info_notice_incremental_auction_fixed":"Vous ouvrez un tour <strong>flexible</strong> avec un <strong>prix initial de {startPrice}</strong> qui <strong>{duration}</strong> se termine le {date} <strong>à {time}.</strong>","Sale::open_round_info_notice_incremental_auction_fixed_withstart":"Vous ouvrez un tour <strong>flexible</strong> avec un <strong>prix initial de {startPrice}</strong> qui commence <strong>{start}</strong> le <strong>{startDate} à {startTime}</strong> et se termine <strong>{duration}</strong> le <strong>{date} à {time}</strong> au cours de laquelle l'enchère durera <strong>{biddingDuration}</strong>.","Sale::open_round_info_notice_incremental_auction_flexible":"Vous ouvrez un tour <strong>flexible</strong> avec un <strong>prix initial de {startPrice}</strong> qui <strong>termine en {duration} jours</strong>.","Sale::open_round_info_notice_openbidding_fixed":"Vous ouvrez un tour <strong>ouvert</strong> avec un <strong>prix initial de {startPrice}</strong> qui <strong>{duration}</strong> se termine le {date} <strong>à {time}.</strong>","Sale::open_round_info_notice_openbidding_fixed_withstart":"Vous ouvrez un tour <strong>ouvert</strong> avec un <strong>prix initial de {startPrice}</strong> qui commence <strong>{start}</strong> le <strong>{startDate} à {startTime}</strong> et se termine <strong>{duration}</strong> le <strong>{date} à {time}</strong> au cours de laquelle l'enchère durera <strong>{biddingDuration}</strong>.","Sale::open_round_info_notice_openbidding_flexible":"Vous ouvrez un tour <strong>ouvert</strong> avec un <strong>prix initial de {startPrice}</strong> qui <strong>termine en {duration} jours</strong>.","Sale::open_round_info_notice_sealedbidding_fixed":"Vous ouvrez un tour <strong>fermé</strong> avec un <strong>prix indicatif de {estimate}</strong> qui <strong>{duration}</strong> se termine le {date} <strong>à {time}.</strong>","Sale::open_round_info_notice_sealedbidding_fixed_withstart":"Vous ouvrez un tour <strong>fermé</strong> avec un <strong>prix indicatif de {estimate}</strong>  qui commence <strong>{start}</strong> le <strong>{startDate} à {startTime}</strong> et se termine <strong>{duration}</strong> le <strong>{date} à {time}</strong> au cours de laquelle l'enchère durera <strong>{biddingDuration}</strong>.","Sale::open_round_info_notice_sealedbidding_flexible":"Vous ouvrez un tour <strong>fermé</strong> avec un <strong>prix indicatif de {estimate}</strong> qui <strong>termine en {duration} jours</strong>.","Sale::open_round_info_notice_simple_offer_fixed":"Vous ouvrez une <strong>offre d'achat numérique</strong>.","Sale::open_round_info_notice_simple_offer_flexible":"Vous ouvrez une <strong>offre d'achat numérique</strong>.","Sale::sale_connection_unavailable":"La connexion à cette procédure d'offre a été perdue. Veuillez recharger la page.","Sale::sale_not_found":"Cette procédure d'offre est introuvable.","Sale::you_are_about_to_upload_offer_in_the_name_of_customer":"Vous êtes en train de charger l’offre d’achat au nom du client. Le client ne peut ainsi plus remettre son offre d’achat en ligne. Vous devez impérativement conserver le formulaire d’offre original°!","SaleCreatePanel::agbs":"CG","SaleCreatePanel::create_new_listing":"Créer un nouveau bien immobilier","SaleCreatePanel::i_agree_to_the_link":"J’approuve le {agbs}","SaleCreatePanel::i_agree_with_terms_and_conditions":"J’approuve les CG","SaleCreatePanel::image":"Photo titre de la propriété","SaleCreatePanel::number":"Numéro de propriété","SaleCreatePanel::price":"Prix de vente selon mandat","SaleCreatePanel::title":"Titre de propriété","salepropertytype::business":"Local commercial","salepropertytype::flat":"Appartement","salepropertytype::house":"Maison","salepropertytype::mixed":"Immeuble résidentiel et commercial","salepropertytype::office":"Bureau","salepropertytype::property":"Terrain","SaleWizard::accept_tc_title":"Approuver les CG","SaleWizard::action_functionality":"Cette fonction offre les options suivantes:","SaleWizard::award":"Vous pouvez informer l'acheteur privilégié du vendeur de l'acceptation de son offre.\nUn Compromis de Vente est alors établi pour l'acheteur sélectionné. Il doit être signé physiquement par l'acheteur et le vendeur avant d'être déposé au bureau de enregistrement.\nVous pouvez également sélectionner les participants dont l'offre doit être définitivement rejetée.","SaleWizard::award_subtitle":"Utilisez cette fonction pour sélectionner votre acheteur préféré.","SaleWizard::award_title":"Accepter une offre","SaleWizard::awardall":"Choose winner for each property","SaleWizard::awardall_subtitle":"Choose winner for each property","SaleWizard::awardall_title":"Choose winners","SaleWizard::choose_a_winner_title":"Sélectionner le gagnant","SaleWizard::choose_offers_for_next_round_title":"Sélectionner les offres","SaleWizard::choose_offers_to_reject_title":"Les rejets","SaleWizard::choose_winners_title":"Choose winners","SaleWizard::confirmaward":"Vous pouvez confirmer l'acheteur après que la vente ait été conclue avec succès.\nTous les participants restants seront automatiquement informées de la vente et leurs offres sont finalement rejetées.\nLe processus d’offre est clos.","SaleWizard::confirmaward_subtitle":"Utilisez cette fonction dès que vous souhaitez confirmer l'acheteur final.","SaleWizard::confirmaward_title":"Confirmer l'acheteur final","SaleWizard::counteroffer":"L'acheteur sélectionné peut alors soit accepter ce prix plus élevé, soit faire une autre contre-offre au vendeur.\nCela continue jusqu'à ce qu'une offre soit acceptée ou finalement rejetée.\nTous les autres participants recevront automatiquement un message indiquant que leur offre a été rejetée.","SaleWizard::counteroffer_subtitle":"Vous pouvez choisir un acheteur et lui faire une contre-offre plus élevée à laquelle le vendeur est prêt à vendre","SaleWizard::counteroffer_title":"Faire une contre-offre","SaleWizard::duplicate":"Toutes les données et documents du bien immobilier déjà déposés sont repris automatiquement.\nVous pouvez ensuite modifier les détails, définir les paramètres du nouveau processus d’offre et inviter de nouveaux participants.","SaleWizard::duplicate_subtitle":"Utilisez cette fonction si vous souhaitez lancer un nouveau processus d’offre avec cette propriété.","SaleWizard::duplicate_title":"Lancer un nouveau processus d’offres","SaleWizard::increase":"Vous pouvez lancer une nouvelle série d’offres (avec un nouveau prix indicatif, si nécessaire) afin d'obtenir un meilleur prix.\nLes participants sélectionnés de la dernière série d’offres peuvent participer et augmenter leur offre existante ; ils sont automatiquement informées.\nTous les participants existants qui n'ont pas été invités à la nouvelle série d’offres recevront automatiquement une notification avec le rejet de leur offre existante.","SaleWizard::increase_subtitle":"Utilisez cette fonction pour commencer une autre série d’offres avec des participants sélectionnés.","SaleWizard::increase_title":"Lancer une nouvelle série d'offres","SaleWizard::message_to_buyers_title":"Message supplémentaire","SaleWizard::message_to_rejected_title":"Message pour les offres rejetées","SaleWizard::message_to_winner_title":"Message supplémentaire","SaleWizard::next_round_details_title":"Tour suivant","SaleWizard::notifyseller":"Informez le vendeur des offres de vos clients","SaleWizard::notifyseller_subtitle":"Envoyer un aperçu de l'offre au vendeur","SaleWizard::notifyseller_title":"Avertir le vendeur","SaleWizard::rejectall":"Tous les participants qui ont soumis une offre seront informés de la décision de rejet du vendeur.\nLe processus d‘offre est clos.","SaleWizard::rejectall_subtitle":"Utilisez cette fonction si le vendeur ne veut accepter aucune des offres et ne veut pas non plus poursuivre le processus d’offre.","SaleWizard::rejectall_title":"Rejeter toutes les offres","SaleWizard::results_title":"Confirmation","SaleWizard::review_title":"Synthèse","SaleWizard::review_winners_title":"Review winners","SaleWizard::sale_wizard":"Assistant","SaleWizard::select_action_title":"Comment voulez-vous procéder°?","SaleWizardResult::back_to_sale":"Retour à la procédure d’offre","SaleWizardResult::confirmation":"Confirmation","SaleWizardResult::continue_to_the_duplicated_sale":"Passez à la procédure d'offre dupliquée","SaleWizardResult::successful":"Nous avons reçu votre saisie, les adaptations sont visibles dans le système dans une minute.","SaleWizardRoundInfo::ends":"La procédure d’offre se termine","SaleWizardRoundInfo::estimate":"Prix indicatif","SaleWizardRoundInfo::minimum_price":"Prix minimum","SaleWizardRoundInfo::offer_validity":"Offre d’achat valable","SaleWizardRoundInfo::red_button_price":"Prix red button","SaleWizardRoundInfo::start_price":"Prix initial","salutation":"Salutation","salutation::miss":"Madame","salutation::mr":"Monsieur","salutation::mrs":"Madame","salutation::ms":"Madame","save":"Enregistrer","Search::add_new_listing":"Ajouter un bien immobilier","Search::address":"Adresse","Search::agbs":"CG","Search::area":"Surface","Search::create_new_listing":"Créer une nouvelle procédure","Search::creating":"Créer","Search::error_loading_objects":"Erreur lors du chargement des objets.","Search::error_retrieving_file":"Erreur lors de la récupération ou du stockage du fichier","Search::guide_no_objects":"Il semblerait que vous n’ayez pas d’objets actifs actuellement.","Search::i_agree_to_the_link":"J’approuve le {agbs}","Search::i_agree_with_terms_and_conditions":"J’approuve les CG","Search::loading_details":"Le bien immobilier est chargé","Search::loading_properties":"Les biens immobiliers sont chargés","Search::my_listings_overview":"Mes procédures d'offres","Search::number":"N° d’objet","Search::price":"Prix","Search::this_object_is_already_active":"Un processus d'offre a déjà été lancé pour cet objet","seller":"Vendeur","seller_type":"Type de vendeur","SellerInviteSection::block":"Bloquer","SellerInviteSection::invite":"Inviter","SellerInviteSection::invite_seller":"Inviter le vendeur","sellertype::company":"Personne morale","sellertype::private":"Personne privée","send":"Envoyer","sms":"SMS","sms_failed":"La notification par SMS n'a pas pu être envoyée","start_new_sale":"Commencer une nouvelle vente","start_new_test_sale":"Commencer une nouvelle vente test","status":"Statut","street":"Rue","street_and_house_number":"Rue et numéro","submit":"Conclure","submitted_on":"Remise le","submitted_value":"Montant de l’offre","summary":"Synthèse","swiss_residential_status":"Statut de séjour suisse","template::cust_message":"Message générique","test_sale_explanation":"Veuillez utiliser la procédure de test exclusivement à des fins de formation interne et de présentation. Vous pouvez également l'utiliser pour soutenir les discussions d'acquisition afin de présenter en direct le processus et les avantages du processus d'offre aux vendeurs potentiels. L'utilisation du test la procédure est gratuite. Tous les sites Web et notifications sont marqués comme \"test\". Leur utilisation pour des processus d'offres réelles impliquant de vrais acheteurs potentiels est interdite.","test_sale_watermark":"Vente de démonstration","this_action_cannot_be_undone":"Cette action ne peut pas être annulée.","title":"Titre","title::doctor":"Dr","title::master":"Me","title::professor":"Prof","type_of_property":"Type de bien immobilier","updated_on":"Mis à jour le","upload":"Télécharger","upload_more":"Télécharger plus","uploading":"Télécharger","uploads":"Téléchargements","uploadtype::identification_document":"Documents d’identité","uploadtype::identity_document":"Attestation d’identité","uploadtype::misc":"Divers","uploadtype::proof_of_financial_resources":"Attestation de financement","uploadtype::residence_permit":"Permis de séjour","value_must_be_between_min_and_max":"La valeur doit être comprise entre {min} et {max}","would_you_like_to_continue":"Voulez-vous continuer°?","yes":"Oui","zip_code":"NPA"}

/***/ }),
/* 896 */
/***/ (function(module, exports) {

module.exports = {"active":"Attivo","add":"Aggiungi","additional_address":"Complemento d'indirizzo","additional_description":"Avvisi e termini aggiuntivi per il venditore","additional_information_text":"Informazioni aggiuntive","address":"Indirizzo","agent":"Consulente","AgentProvisionForm::agent_commission":"Provvigione consulente","AgentProvisionForm::fixed_amount":"Importo fisso","AgentProvisionForm::percentage":"Percentuale","allowed_file_formats":"Si noti che sono consentiti solo i seguenti formati di file: PDF, JPG e PNG.","and":"e","App::initializing":"Inizializzazione","are_you_sure_this_action_cannot_be_undone":"Continuare? Quest'azione non può essere annullata.","auction_finals":"Finali dell'asta","AuctionFinalsList::no_offer_selected_for_awardwing_go_back_to_the_matrix_and_pick_some":"No offer selected for awardwing, go back to the matrix and pick some.","AuctionFinalsList::object_no":"Object no.","AuctionFinalsList::selected_buyer":"Selected buyer","AuctionFinalsList::total":"Total","AuctionFinalsMatrix::awarded":"Awarded","AuctionFinalsMatrix::clear_selection":"Clear selection","AuctionFinalsMatrix::for_each_property_pick_the_best_available_offer":"For each property pick the best available offer","AuctionFinalsMatrix::for_each_property_pick_the_highest_offer_if_it_is_the_most_preferred_offer_of_the_highest_bidder":"For each property pick the highest offer if it is the most preferred offer of the highest bidder","AuctionFinalsMatrix::for_each_property_pick_the_highest_offer_if_the_highest_bidder_has_not_been_assigned_to_another_property_yet":"For each property pick the highest offer if the highest bidder has not been assigned to another property ye","AuctionFinalsMatrix::position":"Position","AuctionFinalsMatrix::preference":"Preference","AuctionFinalsMatrix::property":"Property","AuctionFinalsMatrix::select_best_offers":"Select best offers","AuctionFinalsMatrix::select_highest_offers":"Select highest offers","AuctionFinalsMatrix::select_preferred_highest_offers":"Select preferred highest offers","AuctionFinalsMatrix::this_is_the_highest_offer_for_this_property_but_its_not_selected":"This is the highest offer for this property, but it's not selected","AuctionFinalsMatrix::this_is_the_most_preferred_offer_for_this_buyer_but_its_not_selected":"This is the most preferred offer for this buyer, but it's not selected","AuctionFinalsPanel::awarded":"Awarded","AuctionFinalsPanel::confirm":"Confirm","AuctionFinalsPanel::continue":"Continue","AuctionFinalsPanel::error_loading_data_from_server":"Error loading data from server","AuctionFinalsPanel::failed":"Failed","AuctionFinalsPanel::report":"Report","AuctionFinalsPanel::review_winners":"Review winners","AuctionFinalsPanel::select_winners":"Select winners","AuctionFinalsPanel::selected":"Selected","AuctionFinalsPanel::succeeded":"Succeeded","AuctionFinalsPanel::total":"Total","AuctionFinalsTotals::awarded":"Awarded","AuctionFinalsTotals::selected":"Selected","AuctionFinalsTotals::total":"Awarded","audiencetype::bidders":"Offerenti","audiencetype::everyone":"Tutti","audiencetype::non_bidders":"Non offerenti","AwardAllStep1::loading_offers_please_wait":"Loading offers, please wait","AwardStep1::choose_a_winner":"Selezionare un vincitore","AwardStep1::expiration_date":"Validità dell'offerta","AwardStep2::expiration_date":"Validità dell'offerta","AwardStep2::select_customers_to_reject_theirs_offer":"Seleziona le offerte che desideri rifiutare immediatamente.\nQuesti clienti riceveranno immediatamente una notifica di cancellazione.\nTutti gli altri clienti non verranno avvisati al momento se vogliono scegliere un altro acquirente in un secondo momento.","AwardStep2::this_text_will_appear_as_an_additional_note":"Questo testo verrà visualizzato come informazione aggiuntiva nella notifica al vincitore:","AwardStep4::reject_message":"Messaggio aggiuntivo per i potenziali acquirenti rifiutati","AwardStep4::this_text_will_appear_as_an_additional_note":"Questo testo apparirà come nota aggiuntiva nella notifica","AwardSummary::if_you_click_finish_you_confirm_the_winner":"Cliccare su \"Termina\" per confermare il vincitore. Tutte le altre offerte saranno respinte e i clienti informati.","AwardSummary::rejected_customers_offers":"Offerte rifiutate","AwardSummary::selected_winner":"Vincitore selezionato","back":"Indietro","behalf_of":"Per conto di","bid_amount":"Importo offerta","bidding_type":"Tipo di procedura","BiddingSection::highest_bidder":"Offerta più alta","BiddingSection::round_opens_on":"Sessione aperta il","BiddingSection::the_highest_offer":"Offerta massima","BiddingSection::the_next_minimum_offer":"Offerta minima successiva","BlockDialog::block":"Bloccare","BlockDialog::block_agent":"Rifiutare la richiesta","BlockDialog::reason":"Motivo della decisione","BulkRegistrationCsvPanel::back_to_mapping":"Torna alla mappatura","BulkRegistrationCsvPanel::duplicate_description":"Il record esiste già","BulkRegistrationCsvPanel::import_from_csv_file":"Importa da file CSV","BulkRegistrationCsvPanel::invalid_description":"Registrazione incompleta","BulkRegistrationCsvPanel::total_number_of_rows_count":"Numero totale di righe: {count}","BulkRegistrationCsvPanel::valid_description":"Registrazione completata","BulkRegistrationInventoryPanel::duplicate_description":"Il record esiste già","BulkRegistrationInventoryPanel::entries_with_duplicate_emails_count":"Voci con e-mail duplicate: {count}","BulkRegistrationInventoryPanel::failed_registrations":"Registrazioni fallite: {conteggio}","BulkRegistrationInventoryPanel::importing":"Importazione da onOffice","BulkRegistrationInventoryPanel::invalid_description":"Registrazione incompleta","BulkRegistrationInventoryPanel::invalid_entries_count":"Voci non valide: {count}","BulkRegistrationInventoryPanel::successful_registrations":"Registrazioni riuscite: {conteggio}","BulkRegistrationInventoryPanel::total_number_of_entries_count":"Numero totale di voci: {count}","BulkRegistrationInventoryPanel::valid_description":"Registrazione completata","BulkRegistrationTable::already_registered":"Già registrato","BulkRegistrationTable::invalid_email":"E-mail non valido","BulkRegistrationTable::saving_error":"Errore di caricamento","BulkRegistrationTable::select__unselect_all":"Seleziona/deseleziona tutto","BuyerDocumentSelector::none":"Nessuno","BuyerDocumentSelector::not_required":"Non richiesto","BuyerDocumentSelector::optional":"Opzionale","BuyerDocumentSelector::required":"Richiesto","buyertype::company":"Persona giuridica","buyertype::entrepreneurs":"Ditta individuale","buyertype::private":"Privato","CallbackComponent::redirecting":"Inoltro","cancel":"Annulla","citizenship":"Nazionalità","city":"Luogo","close":"Chiudi","combobox_placeholder_free_text":"Scegli un'opzione dall'elenco o fornisci la tua","Commands::accept":"Conferma per la prossima sessione","Commands::all_offers":"Tutte le offerte","Commands::approve":"Ammetti alla procedura","Commands::approveregistration":"Attiva i clienti","Commands::are_you_sure_this_action_can_not_be_undone":"Continuare? Questa azione non può essere annullata.","Commands::are_you_sure_to_block_user":"Continuare? In questo modo il cliente viene escluso dal sistema!","Commands::are_you_sure_to_close_the_sale":"Continuare? La procedura viene conclusa definitivamente.","Commands::are_you_sure_to_end_round_early":"Continuare? Concludendo la sessione non sarà più possibile presentare altre offerte.","Commands::are_you_sure_to_end_round_early_sealed":"Continuare? Concludendo la sessione non sarà più possibile presentare altre offerte e l'importo delle offerte sarà reso noto.","Commands::award":"Accetta offerta d'acquisto","Commands::blank_offer":"Offerta in bianco PDF","Commands::block_user":"Blocca utente","Commands::close_sale":"Concludi procedura d'offerta","Commands::confirm":"Conferma per il cliente (OTP)","Commands::delete_sale":"Elimina procedura d'offerta","Commands::download_documents":"Scarica documentazione","Commands::end_round_early":"Termina sessione anticipatamente","Commands::import_registrations_from_crm":"Importazione dal CRM","Commands::import_registrations_from_csv_file":"Importa da file CSV","Commands::import_registrations_from_onoffice":"Importa da onOffice","Commands::import_registrations_from_propstack":"Importazione di Propstack","Commands::import_registrations_from_propup":"Importa da PropUp","Commands::invite_seller":"Invita il venditore","Commands::messaging":"Invia messaggio","Commands::new":"Avvia nuova sessione","Commands::offer":"Offerte","Commands::pdf_export":"Esportazione PDF","Commands::refuse":"Respingi perché incompleta","Commands::refuseregistration":"Rifiuta i clienti","Commands::register_new_user":"Invita interessati","Commands::registration":"Iscrizioni","Commands::reject":"Rifiuta definitivamente","Commands::round_close":"Termina anticipatamente","Commands::round_open":"Apri la sessione","Commands::sale":"Procedura d'offerta","Commands::sale_wizard":"Assistente sessione","Commands::update_contact":"Aggiorna contatto","Commands::upload":"Carica offerta per conto del cliente","Commands::whitelisting":"Collaborazione","company":"Azienda","company_court":"Tribunale distrettuale","company_id":"FN","company_name":"Nome dell'azienda","Confirmation::confirmation_expired":"Il OTP inserito è errato o scaduto","Confirmation::invalid_bid_value":"Il prezzo d'acquisto è troppo basso","Confirmation::invalid_confirmation":"Il OTP inserito è errato o scaduto","Confirmation::sale_round_not_opened":"L'offerta non può essere accettata perché la sessione è già conclusa","ConfirmAwardStep1::choose_a_winner":"Selezionare un vincitore","ConfirmAwardStep1::expiration_date":"Validità dell'offerta","ConfirmAwardStep1::reject_message":"Messaggio aggiuntivo per i potenziali acquirenti rifiutati","ConfirmAwardStep1::this_text_will_appear_as_an_additional_note":"Questo testo apparirà come nota aggiuntiva nella notifica","ConfirmAwardSummary::if_you_click_finish_you_confirm_the_winner":"Cliccare su \"Termina\" per confermare il vincitore, confermi l'acquirente. Tutte le altre offerte vengono rifiutate e i clienti vengono avvisati.\nQuesto passaggio non può essere annullato.","ConfirmAwardSummary::rejected_customers_offers":"Offerte rifiutate","ConfirmAwardSummary::selected_winner":"Vincitore selezionato","ContactPanel::update_contact":"Aggiorna contatto","costs":"Costi","Countdown::das_verfahren_ist_beendet":"Procedura completata","CounterofferStep2:: please_define_the_next_round":"Si prega di definire il prossimo round","CounterofferStep2::validity_of_offers_set_to_the_same_value":"Validità delle offerte impostate sullo stesso valore","CounterofferSummary::click_finish_to_start_a_new_round":"Clicchi su Fine per iniziare un nuovo round","CounterofferSummary::customers_for_the_next_round":"Seleziona i clienti che parteciperanno al ciclo successivo","CounterofferSummary::customers_not_participating_in_the_next_round":"Seleziona i clienti che non parteciperanno al turno successivo","CounterofferSummary::round_details":"Dettagli rotondi","country":"Nazione","created_on":"Data creazione","CsvMappingTable::do_not_import":"non importare","customer":"Cliente","customer_buyer_reference_of_name":"Cliente {buyer_reference} da {name}","customer_name":"Nome cliente","customer_of_name":"Cliente da {name}","Dashboard::authorization_in_progress":"Autorizzazione","Dashboard::customer_service_contact":"Servizio clienti","Dashboard::customer_service_email":"sales@propnow.com","Dashboard::customer_service_p":"In caso di domande o problemi, siamo reperibili come segue:","Dashboard::customer_service_telephone":"+39 02 3858 5482","Dashboard::customer_service_telephone_href":"+390238585482","Dashboard::do_you_really_want_to_log_out":"Uscire veramente?","Dashboard::log_out":"Esci","Dashboard::tel__sms__whatsapp":"Tel.","date":"Data","date_of_birth":"Data di nascita","DateField::dateformat":"gg/mm/aaaa","DateField::invalid_date":"Data non valida","days":"giorni","delete":"Cancella","deposit_payment_deadline":"Termine di pagamento del deposito","depositRequired::false":"No","depositRequired::true":"Sì","doc_from":"del","Doc::from":"del","Doc::no_type":"Assegnare il tipo di documento","Doc::original_name":"Caricato come {originalFilename} il {uploadedAt, date, medium} {uploadedAt, time, medium}","documents":"Documentazione","documenttype::annual_statement":"Bilancio annuale","documenttype::appraisal":"Perizia del valore d'uso","documenttype::area_allocation_plan":"Piano di attribuzione superfici","documenttype::building_permit":"Autorizzazione edilizia","documenttype::completion_display":"Avviso di completamento","documenttype::condominium_contract":"Contratto condominiale","documenttype::energy_certificate":"Certificato energetico","documenttype::expose":"Exposé","documenttype::expose_long":"Descrizione dell'immobile (exposé)","documenttype::land_register":"Estratto del registro fondiario","documenttype::loan_agreement":"Contratto di prestito","documenttype::operating_costs":"Costi d'esercizio","documenttype::operating_costs_long":"Costi d'esercizio/ Panoramica dei costi di manutenzione e miglioramento ai sensi del § 20 cpv. 2 Legge austriaca sul condominio","documenttype::promissory_note":"Certificato di debito","documenttype::running_costs":"Prescrizione dei costi correnti","documenttype::usage_permit":"Autorizzazione d'uso","DuplicateStep1::agbs":"T&C","DuplicateStep1::duplicating_sale":"Duplicazione della procedura di offerta","DuplicateStep1::hint1":"Vengono adottati tutti i dati e i documenti relativi al modulo di offerta","DuplicateStep1::hint2":"È quindi possibile regolare le informazioni, definire il round e invitare nuovi potenziali clienti","DuplicateStep1::i_agree_to_the_link":"Accetta {agbs}","DuplicateStep1::i_agree_with_terms_and_conditions":"Accetto i termini e le condizioni","DuplicateSummary::duplicating_sale":"Duplicazione della procedura di offerta","duration":"Durata","duration_type":"Scadenze","durationtype::fixed":"Fisso (Data)","durationtype::flexible":"Flessibile (Durata del tempo)","edit":"Modifica","EditPanel::edit_offer_form":"Prepara modulo per offerta d'acquisto","email":"E-mail","email_failed":"Non è stato possibile recapitare la notifica e-mail","EmailField::invalid_email":"L'indirizzo e-mail non è corretto","encoding":"Codifica","Error::blocked":"La pagina richiamata non esiste. Il link utilizzato potrebbe essere errato oppure la procedura di offerta digitale è già stata conclusa. Ulteriori oggetti sono disponibili su:","field::depositrequired":"Depositare","field::email":"E-mail","field::firstname":"Nome","field::lastname":"Cognome","field::locale":"Lingua","field::phone":"Numero di cellulare","field::salutation":"Saluto","field::title":"Titolo","fill_required_fields":"Compilare tutti i campi obbligatori!","financing_required":"Finanziamento necessario","financing_secured":"Finanziamento assicurato","first_name":"Nome","handover":"Data Atto di Compravendita","handovertype::key_handover":"Dopo la consegna delle chiavi","handovertype::land_register":"Dopo l'iscrizione nell'estratto del registro fondiario","handovertype::money_transfer":"Dopo il versamento del prezzo d'acquisto su un conto predefinito","handovertype::sale_contract":"Secondo il contratto di vendita","hidden":"nascosto","house_number":"Numero civico","iban":"IBAN","iban_is_not_valid":"L'IBAN non è corretto. Si prega di verificare","image":"Immagine","import":"Importare","IncreaseStep1::all_other_offers_will_be_rejected":"Tutte le altre offerte saranno rifiutate e non avranno la possibilità di partecipare a un'altra sessione.","IncreaseStep1::expiration_date":"Validità dell'offerta","IncreaseStep1::invite_more_customers_after_start_of_next_round":"Dopo l'inizio della prossima sessione, è possibile invitare altri interessati.","IncreaseStep1::select_customers":"Selezionare i clienti da ammettere alla prossima sessione.","IncreaseStep2::please_define_the_next_round":"Definire la prossima sessione.","IncreaseStep2::validity_of_offers_set_to_the_same_value":"La validità delle ulteriori offerte d'acquisto è stata impostata automaticamente allo stesso valore della sessione precedente.","IncreaseStep3::this_text_will_appear_as_an_additional_note":"Questo testo verrà visualizzato come informazione aggiuntiva nella notifica al cliente:","IncreaseSummary::click_finish_to_start_a_new_round":"Cliccare su \"Termina\" per avviare una nuova sessione e informare i clienti.","IncreaseSummary::customers_for_the_next_round":"Clienti per la prossima sessione","IncreaseSummary::customers_not_participating_in_the_next_round":"Clienti non ammessi alla prossima sessione","IncreaseSummary::round_details":"Dettagli sessione","invite_buyer_agent":"Invita agente immobiliare acquirente","last_name":"Cognome","legal_entity":"Persona giuridica","legal_form":"Forma giuridica","ListingsOverview::add_new_listing":"Aggiungi nuovo immobile","ListingsOverview::agent":"Consulente","ListingsOverview::approved_offers":"Interessati ammessi","ListingsOverview::create_new_listing":"Crea una nuova proprietà","ListingsOverview::end_date":"Data finale","ListingsOverview::guide__you_should_add_a_new_listing":"Per avviare una procedura di offerta, è necessario innanzitutto selezionare un immobile.","ListingsOverview::loading_listings":"Caricamento degli immobili in corso","ListingsOverview::my_listings_overview":"Le mie procedure d'offerta","ListingsOverview::number":"Num. oggetto","ListingsOverview::pending_offers":"Offerte in corso","ListingsOverview::start_date":"Data iniziale","loading":"Caricamento in corso","locale":"Lingua","locale::de":"Tedesco","locale::deat":"Tedesco","locale::dech":"Tedesco","locale::dede":"Tedesco","locale::en":"Inglese","locale::fi":"Finlandese","locale::fifi":"Finlandese","locale::fr":"Francese","locale::frch":"Francese","locale::frlu":"Francese","locale::it":"Italiano","locale::itch":"Italiano","locale::itit":"Italiano","locale::ro":"Rumeno","locale::roro":"Rumeno","locale::sl":"Sloveno","locale::slsi":"Sloveno","manage":"Gestisci","ManagePanel::administration":"Amministrazione","ManagePanel::my_data":"I miei dati","ManagePanel::object_supervisor":"Supervisore oggetto","marital_status":"Stato civile","maritalstatus::divorced":"Divorziato/a","maritalstatus::married":"Coniugato/a","maritalstatus::none":" ","maritalstatus::single":"Celibe/Nubile","maritalstatus::widowed":"Vedovo/a","message":"Messaggio","MessagingPanel::audience":"Pubblico","MessagingPanel::failed_to_send_the_message":"Impossibile inviare il messaggio","MessagingPanel::messaging":"Invia messaggio personalizzato","MessagingPanel::no_message_has_been_sent":"Nessun messaggio è stato inviato","MessagingPanel::number_of_failed_messages":"Numero di messaggi non riusciti","MessagingPanel::number_of_successfully_sent_messages":"Numero di messaggi inviati con successo","MessagingPanel::subject":"Oggetto","MessagingPanel::template":"Modello","MessagingPanel::text":"Testo","mls":"Collaborazione","mls::everyone":"Collaborazione libera","Mls::loading_mls":"Loading MLS offer processes","Mls::no_sale_for_mls":"Al momento non ci sono saldi disponibili","mls::none":"Senza collaborazione","Mls::request_access":"Partecipa al processo di offerta digitale","Mls::request_access_description":"Vuoi partecipare al processo di offerta digitale e invitare a tuoi acquirenti? La tua richiesta sarà curata dall'agente del venditore e riceverai una risposta via e-mail e anche sul panello di controllo.","mls::tenant":"Collaborazione solo con agenti della stessa rete","more":"più","name":"Nome","next":"Avanti","no":"No","not_entered":"Non compilato","notary":"Addetto alla stesura del contratto","notificationcaption::all_customers":"Tutti i clienti","notificationcaption::customer":"Cliente","notificationcaption::customers_invited_to_the_next_round":"Clienti per il prossimo round","notificationcaption::other_customers":"Altri clienti","notificationcaption::seller":"Venditore","notificationcaption::winner":"Vincitore","notificationemailtemplate::cust_bid_refused":"Offerta rifiutata","notificationemailtemplate::cust_highest_bidder":"Il miglior offerente","notificationemailtemplate::cust_highest_bidder_changed":"Nuova offerta più alta","notificationemailtemplate::cust_invited":"Invita interessati","notificationemailtemplate::cust_message":"Messaggio","notificationemailtemplate::cust_offer_awarded":"Offerta d'acquisto accettata","notificationemailtemplate::cust_offer_placed":"Offerta presentata","notificationemailtemplate::cust_offer_raised":"Aumenta offerta d'acquisto","notificationemailtemplate::cust_offer_refused":"Respingi offerta d'acquisto","notificationemailtemplate::cust_outbid":"Nuova offerta ricevuta","notificationemailtemplate::cust_outbid_antisniping":"Nuova offerta ricevuta","notificationemailtemplate::cust_outbid_others":"Nuova offerta più alta","notificationemailtemplate::cust_phase_invite_closing":"Promemoria - Fase di registrazione","notificationemailtemplate::cust_phase_offer_starting":"Promemoria - le offerte sono iniziate","notificationemailtemplate::cust_phase_wishlist_closing":"Promemoria - La selezione degli oggetti termina","notificationemailtemplate::cust_rejected_round_closed":"Offerta d'acquisto rifiutata","notificationemailtemplate::cust_rejected_sold":"Offerta d'acquisto rifiutata","notificationemailtemplate::cust_rejected_unsold":"Offerta d'acquisto rifiutata","notificationemailtemplate::cust_round_closed":"Sessione terminata","notificationemailtemplate::cust_round_closing":"Mail promemoria","notificationemailtemplate::cust_round_edited":"Aggiustato in tondo","notificationemailtemplate::cust_round_opened":"Nuova sessione avviata","NotificationPreview::no_notification_defined_for_the_selected_action":"Nessuna notifica verrà inviata per l'azione selezionata","notifications":"Avvisi","notificationservicestatus::delivered":"Recapitato","notificationservicestatus::failed":"Non riuscito","notificationservicestatus::pending":"In sospeso","notificationservicestatus::sent":"Inviato","NotificationsPanel::explanation":"Per ricevere notifiche via e-mail e SMS sulle attività relative alla procedura d'offerta per questo oggetto, attivare la relativa funzione:","NotifySellerSummary::description":"Le offerte di acquisto dei seguenti clienti verranno inviate direttamente al venditore tramite e-mail:","now":"Ora","number":"Numero","offer":"Offerta","offer_viewing":"Immobile visionato il","offer_viewing_help":"Lasci in bianco se non è già stato fatto","OfferDetailsForm::agreement_installer__lawyer":"Avvocato/Addetto alla stesura del contratto","OfferDetailsForm::other_agreements":"Altri accordi","OfferDetailsForm::purchase_offer_valid_until":"Offerta d'acquisto valida fino al","OfferDetailsForm::purchase_price_gross":"Prezzo d'acquisto (esente da oneri)","OfferNotificationDetails::service_data":"Dati di servizio","OfferNotificationsList::created_on":"Inviato il","OfferNotificationsList::error_loading":"Errore durante il caricamento della lista delle notifiche","OfferNotificationsList::recipient":"Destinatario","OfferNotificationsList::service_status":"Stato del servizio","OfferNotificationsList::template":"Oggetto","OffersSection::hidden":"attualmente nascosto","OffersSection::increase_offer_on_behalf_of_the_customer":"Aumenta offerta per conto del cliente","OffersSection::invited_on":"Invitato il","OffersSection::submitted_at":"Presentato il","OffersSection::submitted_value":"Importo offerta","OffersSection::upload_offer_on_behalf_of_a_customer":"Carica l'offerta per conto del cliente","offerstatus::accepted":"Confermato","offerstatus::approved":"Ammesso","offerstatus::awarded":"Accettato","offerstatus::confirmed":"Presentato","offerstatus::invited":"Invitato","offerstatus::refused":"Respinto","offerstatus::registrationconfirmed":"In attesa di attivazione","offerstatus::registrationsubmitted":"Registrazione inviata","offerstatus::rejected":"Rifiutato","offerstatus::submitted":"Preparato","offerstatus::updated":"In corso","ok":"OK","open":"Apri","optional":"Opzionale","other_agreements":"Altri accordi","overview":"Riepilogo","ownership":"Forma di proprietà","ownershiptype::residential":"Proprietà residenziale","ownershiptype::share":"Comproprietà","ownershiptype::sole":"Proprietà individuale","Page1::area":"Superficie","Page1::construction_year":"Anno di edificazione","Page1::deed":"Registro fondiario","Page1::deed_kg":"KG","Page1::energy_certificate":"Certificato energetico","Page1::housing_subsidies":"Promozione della costruzione di abitazioni","Page1::object_number":"Numero oggetto","Page1::ownership_share":"Quota","Page1::ownership_total":"Totale","Page1::parcel_number":"Num. fondo","Page1::register_number":"Numero di registro","Page1::usage_rules":"Regolamento d'uso","Page2::date_of_delivery_warranty":"Data di consegna, garanzia","Page2::date_of_delivery_warranty_contract":"Data di consegna, garanzia, addetto alla stesura del contratto","Page2::exceptions":"Eccezioni","Page2::handover_date":"Data del passaggio di consegne","Page2::mortgage":"Oneri assunti","Page2::mortgage_detail":"Oneri assunti da","Page2::notary":"Avvocato/Addetto alla stesura del contratto","Page2::vatliable_purchase":"Acquisto soggetto a IVA","Page3::all_documents_must_have_a_type_set":"Tipo di documento non ancora assegnato a uno o più documenti.","Page3::choose_a_document_type_or_enter_description":"Selezionare il tipo di documento corrispondente o inserire una denominazione","Page3::document_type":"Tipo di documento","Page3::section__property":"Altri documenti sulla proprietà","Page3::upload_following_documents":"Carica almeno i seguenti documenti","peptype::family":"Membro della famiglia PEP","peptype::no":"No","peptype::related":"Ha uno stretto rapporto con un PEP","peptype::yes":"L'acquirente è un PEP","person":"Persona","phone_number":"Numero cellulare","phone_number_placeholder":"+49 150 0000 0000","phonenumbererror::invalid":"Il numero di telefono non è valido","phonenumbererror::notmobile":"Il numero di telefono non è un numero di cellulare","place_of_birth":"Luogo di nascita","politically_exposed_person_pep":"Persona politicamente esposta (PEP)","post_code":"NPA","postal_code":"NPA","preview":"Anteprima","previous":"Indietro","previous_round":"Sessione precedente","price_on_offer":"Prezzo rispetto all'offerta","price_on_request":"Prezzo su richiesta","processing":"Elaborazione in corso","property_for_sale":"Oggetto d'acquisto","provision":"Commissione dell'acquirente","ProvisionAck::i_have_taken_note_of_the_following_important_information":"Ho preso nota delle seguenti importanti informazioni","provisiontype::default":"Standard","provisiontype::fixed_amount":"Importo fisso (senza IVA)","provisiontype::fixed_percentage":"Percentuale (senza IVA)","provisiontype::none":"Senza provvigione","purchase_price":"Prezzo d'acquisto","recipient":"Destinatario","refresh":"Aggiornamento","RefuseDialog::explanation":"Informare l'interessato del motivo del rifiuto.","RefuseDialog::reason":"Motivazione","RefuseDialog::refuse_an_offer":"Respingi offerta","register":"Invita","registering":"Invita","RegistrationPanel::already_registered":"È già stato invitato un cliente con questo indirizzo e-mail!","RegistrationPanel::offer_viewing":"Immobile visionato il","RegistrationPanel::place_at":"Pervenuta il","RegistrationPanel::purchase_price_gross":"Prezzo d'acquisto (esente da oneri)","RegistrationPanel::register_new_user":"Invita interessati","RegistrationPanel::send_the_invitation_again":"Invia nuovamente l'invito","RegistrationPanel::upload_an_offer":"Carica offerta (per conto del cliente)","RegistrationPanel::upload_new_offer":"Carica nuova offerta per conto del cliente","RegistrationPanel::upload_offer":"Carica offerta","RejectSummary::click_finish_to_reject_all_offers":"Cliccare su \"Termina\" per rifiutare tutte le offerte e informare i clienti.","remove":"Elimina","required_documents":"Documenti richiesti","round":"Sessione","RoundEdit::allow_bidding_below_starting_price":"Consente offerte al di sotto del prezzo di partenza","RoundEdit::allow_bidding_below_starting_price__tooltip":"Nel processo di offerta aperta, le parti interessate possono normalmente fare offerte solo a partire dal prezzo iniziale, il che può significare che i clienti più sensibili al prezzo spesso non fanno offerte. Con questa opzione, lei offre agli interessati l'opportunità di presentare un'offerta <u>al di sotto</u> del prezzo iniziale - ma al di sopra del prezzo minimo (inizialmente nascosto) stabilito dal broker. Questo ha il vantaggio di far sì che un maggior numero di parti interessate presenti un'offerta, in quanto sono ammesse anche offerte a prezzi inferiori. Questo crea un campo più ampio di offerenti e può quindi aumentare le possibilità di vendita. Tutte le offerte al di sotto del prezzo iniziale vengono nascoste agli altri interessati, per evitare un effetto ancoraggio negativo. Per impostazione predefinita, vengono visualizzate solo le offerte a partire dal prezzo iniziale, a meno che non attivi l'opzione \"Mostra le offerte al di sotto del prezzo iniziale agli altri offerenti\".","RoundEdit::allow_bidding_below_starting_price_hidden":"Consente offerte al di sotto del prezzo di partenza (nascosto)","RoundEdit::antisniping_notice":"La fine del periodo dell'offerta viene automaticamente prorogata di 15 minuti se viene ricevuta una nuova offerta negli ultimi 15 minuti prima della fine dell'offerta. Questa estensione viene ripetuta fino a quando non vengono presentate ulteriori offerte per 15 minuti.","RoundEdit::bidding_steps":"Aumento dell'offerta minima","RoundEdit::bidding_steps__standard":"Scaglionamento predeterminato delle fasi di offerta","RoundEdit::bidding_steps__tooltip":"Questo è l'importo minimo di aumento per le nuove offerte. Ogni nuova offerta deve essere superiore di almeno questo importo rispetto all'attuale offerta più alta. Se ha selezionato l'opzione \"Consenti offerte sotto l'offerta più alta\", l'incremento minimo dell'offerta si riferisce all'offerta precedente del singolo cliente, se ha già fatto un'offerta (per ulteriori informazioni, veda il pulsante informativo: \"Consenti offerte sotto l'offerta più alta\")","RoundEdit::bidding_type_tooltip":"Selezioni il tipo di offerta","RoundEdit::counteroffer_value":"Valore della controfferta proposta","RoundEdit::end_date_changed":"Tutti gli acquirenti e gli agenti invitati saranno informati della modifica della fine del processo di offerta via e-mail.","RoundEdit::ends_at":"Fine della procedura d'offerta","RoundEdit::ends_at__tooltip":"Per la conclusione del processo di candidatura, consigliamo di scegliere un momento in cui le persone interessate sono disponibili e in un luogo con una buona connessione internet (ad esempio, a casa). L'esperienza ha dimostrato che la sera presto o il fine settimana funzionano molto bene. Tuttavia, tenga presente i giorni festivi o i fine settimana lunghi, quando gli interessati potrebbero essere fuori casa. È inoltre importante informare gli interessati sugli orari. Al termine del periodo di offerta, verranno inviati dei promemoria alle parti interessate invitate 72 ore, 24 ore e 60 minuti prima del termine previsto. Le consigliamo inoltre, in qualità di agente, di essere disponibile telefonicamente durante l'ultima ora prima del termine del processo di offerta e, se necessario, di seguire il processo di offerta in diretta sul suo computer portatile o tablet, in modo da poter assistere gli interessati in caso di domande o problemi (ad esempio, scarsa connessione internet dell'interessato).","RoundEdit::estimate":"Prezzo di riferimento","RoundEdit::estimate__tooltip":"Il prezzo di riferimento è l'importo da comunicare al potenziale acquirente come valore indicativo per aiutarlo a stabilire il prezzo della sua offerta. Importante: il prezzo di riferimento non rappresenta un prezzo minimo. Pertanto, l'interessato può presentare un'offerta anche inferiore al prezzo di riferimento.","RoundEdit::estimate_lower_than_startprice":"Il prezzo di riferimento non può essere inferiore al prezzo minimo","RoundEdit::flexible_bidding":"Consentire offerte inferiori all'offerta più alta","RoundEdit::flexible_bidding__tooltip":"Nel processo di offerta aperta, le parti interessate devono normalmente presentare una nuova offerta massima ad ogni nuova offerta, il che può comportare l'abbandono precoce da parte di singole parti interessate o forse la mancata presentazione di un'offerta. Selezionando questa opzione di offerta flessibile, l'interessato ha la possibilità di presentare un'offerta <u>inferiore</u> all'offerta massima corrente. Tuttavia, la nuova offerta deve essere <u>superiore</u> al prezzo dell'offerta precedente del cliente corrispondente, se ha già presentato un'offerta. L'incremento minimo dell'offerta è decisivo in questo caso e viene applicato solo <b>alla propria offerta</b>. Il vantaggio di questa opzione di offerta è che le singole parti interessate fanno offerte più frequenti e si crea un campo intermedio più forte, perché gli offerenti non si ritirano presto. Questo può aumentare le possibilità di vendita, soprattutto quando ci sono pochi interessati o se il prezzo di partenza è un po' troppo alto.","RoundEdit::hide_highest_bid__bid_history_for_nonbidders":"Mostra altre offerte solo <strong>dopo l'</strong> invio della propria offerta","RoundEdit::hide_highest_bid__bid_history_for_nonbidders__tooltip":"Per motivi di trasparenza, l'attuale offerta più alta e tutte le offerte presentate vengono normalmente mostrate a tutti gli invitati fin dall'inizio della procedura aperta, anche prima che essi stessi presentino un'offerta. In alcuni casi, questo può portare singoli interessati, scoraggiati da prezzi d'offerta già molto alti, a non presentare affatto un'offerta, anche se avrebbero voluto farlo. Per evitare questo e per motivare tutti coloro che sono disposti ad acquistare a presentare un'offerta, questa opzione di offerta può essere utile.","RoundEdit::invalid_starting_price":"Inserisci un prezzo di partenza valido","RoundEdit::min_price":"Prezzo minimo","RoundEdit::min_price__tooltip":"Prezzo minimo di acquisto che la parte interessata deve offrire. Viene visualizzato solo se la parte interessata desidera presentare un'offerta al di sotto di questo prezzo.","RoundEdit::min_price_lower_than_start":"Il prezzo minimo deve essere inferiore al prezzo iniziale","RoundEdit::minimum_price":"Prezzo minimo","RoundEdit::offer_validity":"Termine d'irrevocabilità della proposta","RoundEdit::open_round_warning":"Nella procedura di offerta aperta è prevista una sola sessione e le offerte saranno rese note a tutti.","RoundEdit::please_enter_a_starting_price":"Per favore inserisci un prezzo >0","RoundEdit::red_button_price":"Prezzo red button","RoundEdit::red_button_price__tooltip":"Prezzo minimo (stimato) al quale il proprietario è disposto a vendere. Si tratta di un prezzo puramente interno che non viene comunicato al cliente ed visibile solo al consulente. Al raggiungimento del prezzo red button, il consulente viene informato immediatamente.","RoundEdit::select_a_bidding_type":"Selezionare un tipo di procedura","RoundEdit::show_bids_below_starting_price":"Mostra le offerte al di sotto del prezzo iniziale agli altri offerenti","RoundEdit::show_bids_below_starting_price__tooltip":"Per impostazione predefinita, vengono visualizzate solo le offerte <u>a partire da</u> il prezzo di partenza, a meno che non attivi questa opzione. In tal caso, vengono visualizzate anche le offerte <u>inferiori a</u> prezzo di partenza e si ottiene una maggiore trasparenza nel processo di offerta.","RoundEdit::simple_offer_duration_suggestion_notice":"Questa è la proposta di validità limitata delle offerte d'acquisto. Tuttavia, il potenziale acquirente può modificarla al momento della presentazione dell'offerta","RoundEdit::start":"Inizio della procedura d'offerta","RoundEdit::start__tooltip":"Se invita gli interessati <u>prima</u> dell'inizio del processo di offerta (periodo di offerta), possono già inserire i loro dati, visualizzare i documenti dell'immobile e <u>preparare</u> un'offerta. Tuttavia, l'offerta non può ancora essere presentata! Non appena viene raggiunto l'orario di inizio e il periodo di offerta del processo di offerta è iniziato, tutte le parti interessate invitate riceveranno una notifica e potranno iniziare a presentare le loro offerte di acquisto.<br /><br />Suggerimento: la durata media del processo di offerta, cioè il periodo in cui è possibile presentare le offerte (periodo di offerta), è di circa 5-7 giorni. Questo crea uno slancio sufficiente e allo stesso tempo garantisce che i singoli interessati non perdano interesse per l'immobile (cosa che può accadere se il periodo di offerta è troppo lungo). Tuttavia, il periodo di 5-7 giorni presuppone anche che tutte le parti interessate siano già state sufficientemente pre-qualificate da lei, in qualità di broker, all'inizio del processo di offerta, compresa la visione dell'immobile e il chiarimento delle opzioni di finanziamento. Tuttavia, se il finanziamento non è ancora chiaro per la maggior parte degli interessati e quindi sceglie l'opzione \"conferma del finanziamento\" al momento di invitare gli interessati, dovrebbe anche scegliere una durata leggermente più lunga per il processo di offerta, per dare agli interessati il tempo sufficiente per chiarire il loro finanziamento mentre il processo è in corso. Se ha ulteriori domande, non esiti a contattare il nostro team.","RoundEdit::starting_price":"Prezzo di partenza","RoundEdit::starting_price__tooltip":"Prezzo minimo che il potenziale acquirente deve offrire alla presentazione della prima offerta.","RoundEdit::time_of_day":"Orario","RoundInfo::ends":"La procedura d'offerta termina","RoundInfo::offer_validity":"Offerte d'acquisto valide","RoundInfo::starts":"La procedura d'offerta inizia","RoundItem::badge_free":"Gratuito","RoundItem::badge_new":"Nuovo","RoundItem::badge_separator":"e","RoundItem::how_it_works":"Come funziona","RoundItem::incremental_auction_howitworkspoints":"- Possibilità di aprire le offerte a partire dal prezzo iniziale \n- Possibilità di offerte multiple \n- Estensione automatica per le offerte dell'ultimo minuto\n<b>Nuove opzioni flessibili per le offerte:</b>\n- Possibilità di consentire offerte <u>al di sotto del prezzo iniziale</u> \n- Livello di offerta <u>liberamente selezionabile</u> (al di sopra del prezzo minimo) \n- Vengono visualizzate solo le offerte al di sopra del prezzo iniziale \n- Data di inizio e fine fissa","RoundItem::incremental_auction_subtitle":"con offerte flessibili","RoundItem::incremental_auction_title":"Procedura di offerta aperta","RoundItem::incremental_auction_whentouseitpoints":"Come la normale procedura di offerta \"aperta\", ma anche se: \n- Domanda più bassa \n- Clienti sensibili al prezzo \n- Prezzo di partenza meno attraente \n- Aumento del prezzo poco chiaro \n- Offrire ai clienti maggiore flessibilità","RoundItem::open_bidding_howitworkspoints":"- Il primo offerente deve offrire almeno il prezzo iniziale \n- Ogni offerta <b>deve essere superiore a tutte le offerte precedenti</b>\n- Ogni cliente può migliorare la sua offerta \n- Tutte le <b>offerte sono visibili</b>\n- I nomi dei clienti sono anonimizzati per gli altri clienti \n- Inizio e fine espliciti della procedura","RoundItem::open_bidding_subtitle":"con offerte ascendenti","RoundItem::open_bidding_title":"Procedura di offerta aperta","RoundItem::open_bidding_whentouseitpoints":"- Prezzo di partenza interessante \n- Alta domanda \n- Valore di mercato dell'immobile superiore al prezzo di partenza \n- Aumento di prezzo previsto","RoundItem::sealed_bidding_howitworkspoints":"- Prezzo indicativo nessun prezzo minimo \n- Importo dell'offerta <u>liberamente selezionabile</u>\n- Ogni cliente può presentare <u>una</u> sola offerta \n- Offerenti e offerte <u>nascoste</u>\n- Scadenza fissa \n- <u>Nessuna</u> proroga automatica per le offerte dell'ultimo minuto","RoundItem::sealed_bidding_subtitle":"con offerte nascoste","RoundItem::sealed_bidding_title":"Procedura di offerta chiusa","RoundItem::sealed_bidding_whentouseitpoints":"- Domanda bassa/non chiara \n- Ottenere un feedback dal mercato \n- Vendite riservate, settore pubblico \n- Proprietà difficile da commercializzare","RoundItem::simple_offer_howitworkspoints":"- Semplice presentazione digitale delle offerte \n- Prezzo di listino = riferimento \n- Prezzo dell'offerta <u>liberamente</u> selezionabile \n- Il cliente può presentare solo <u>un'</u> offerta \n- Nessuna informazione su eventuali altri interessati \n- Nessuna scadenza fissa \n- Possibilità di passare in modo flessibile alla procedura di offerta aperta se più clienti presentano offerte","RoundItem::simple_offer_title":"Offerta di acquisto digitale","RoundItem::simple_offer_whentouseitpoints":"- Pochi interessati \n- Processo di vendita lungo \n- Verifica della disponibilità all'acquisto \n- Possibilità di fare un'offerta soggetta a riserva","RoundItem::when_to_use_it":"Quando viene utilizzato","RoundPanel::round":"Modifica sessione","roundstatus::closed":"Terminato","roundstatus::opened":"Aperto","roundstatus::started":"Nuovo","roundtype::counteroffer_bidding":"Controfferta","roundtype::incremental_auction":"Procedura di offerta aperta","roundtype::open_bidding":"Procedura di offerta aperta","roundtype::sealed_bidding":"Procedura di offerta chiusa","roundtype::show_invited_customers_count":"Mostra il numero di parti interessate","roundtype::show_invited_customers_count_tooltip":"Il numero totale di tutti i potenziali acquirenti invitati viene mostrato a ciascun cliente partecipante.","roundtype::simple_offer":"Offerta di acquisto digitale","Sale::all_information_entered_by_customer_will_be_overwritten":"Tutte le informazioni fornite dal cliente saranno sovrascritte.","Sale::already_confirmed":"Questo cliente ha già presentato un'offerta d'acquisto. Non è possibile presentare un'altra offerta per conto del cliente.","Sale::cannot_update_documents_for_open_round__documents_uploaded":"Sono stati caricati i seguenti documenti:","Sale::cannot_update_documents_for_open_round__no_documents":"Non è stato caricato NESSUN documento.","Sale::do_you_want_to_open_the_round":"Aprire la sessione?","Sale::guide__define_offer_form":"Innanzitutto è necessario completare i dati dell'oggetto.","Sale::guide__edit_round":"Se i dati inseriti non sono corretti clicca qui per modificarli","Sale::guide__import_users_csv":"Importa utenti da file CSV","Sale::guide__invite_users":"Per invitare i primi interessati, sono necessari i relativi indirizzi e-mail, nomi completi e numeri di cellulare.","Sale::guide__missing_mandatory_offer_form":"Compilare tutti i campi obbligatori!","Sale::guide__open_round":"Aprire la sessione per avviare processo digitale e invitare singoli clienti.","Sale::guide__start_round":"Inserire ora i parametri per la sessione.","Sale::guide__start_round_edit_sale":"Hai compilato tutti i campi obbligatori del modulo di offerta. Qui puoi controllarli o modificarli di nuovo se necessario.","Sale::guide_action__edit_round":"Modifica","Sale::guide_action__edit_sale":"Prepara modulo per offerta d'acquisto","Sale::guide_action__import_users_csv":"Importa utenti","Sale::guide_action__invite_bidders":"Invita interessati","Sale::guide_action__open_round":"Apri la sessione","Sale::guide_action__start_round":"Avvia nuova sessione","Sale::guide_action__start_round_edit":"Modifica offerta per acquistare modulo","Sale::guides__manage_the_sale":"Assistente sessione","Sale::guides__offers_present":"Ora può discutere la \"panoramica\" delle offerte con il venditore e poi inserire la sua decisione nel \"Assistente sessione\".","Sale::guides__round_closed":"La sessione è terminata. È possibile quindi preparare il riepilogo dell'offerta per il venditore e inserire il risultato della sessione.","Sale::guides__show_overview":"Riepilogo","Sale::guides__start_open_process":"Passa alla procedura di quotazione","Sale::guides__upgrade":"Ha ricevuto diverse offerte. Per ottimizzare il risultato delle vendite, può passare alla procedura di offerta","Sale::invalid_bid_value":"Questa offerta non può essere accettata perché è già presente un'offerta maggiore o uguale. Informare il cliente affinché possa modificare la sua offerta.","Sale::loading_sale":"Caricamento dell'immobile in corso","Sale::no_estimate":"nessun prezzo indicativo","Sale::no_starting_price":"nessun prezzo di partenza","Sale::open_round_deadline_today":"Il round dovrebbe finire oggi. Sei sicuro di voler aprire la procedura?","Sale::open_round_deadline_too_long":"Il tuo round dovrebbe terminare tra {durationInDays} giorni? Sei sicuro di voler aprire la procedura?","Sale::open_round_info_invalid_duration":"On si può aprire un'asta che è già conclusa. Per favore modificare i dettagli dell’offerta.","Sale::open_round_info_notice_incremental_auction_fixed":"Lei apre un <strong>round aperto</strong> con un <strong>prezzo iniziale di {startPrice}</strong> che <strong>{duration}</strong> <strong>termina</strong> alla {date} <strong>all'{time}</strong>.","Sale::open_round_info_notice_incremental_auction_fixed_withstart":"Lei apre un <strong>round aperto </strong> con un <strong>prezzo di partenza di {startPrice}</strong> e l'inizio dell'offerta <strong>{start}</strong> in <strong>{startDate} a {startTime}</strong>, che termina in <strong>{date} a {time}</strong> in <strong>{biddingDuration}</strong>.","Sale::open_round_info_notice_incremental_auction_flexible":"Lei apre un ciclo <strong>flessibile</strong> con un <strong>prezzo iniziale di {startPrice}</strong> che termina <strong>tra {duration} giorni</strong> dal ricevimento della prima offerta.</strong>","Sale::open_round_info_notice_openbidding_fixed":"Si apre una sessione <strong>aperta</strong> con <strong>prezzo di partenza di {startPrice}</strong>, la quale termina <strong>{duration}</strong> il {date} <strong>alle {time}.</strong>","Sale::open_round_info_notice_openbidding_fixed_withstart":"Si apre una sessione <strong>aperta</strong> con <strong>prezzo di partenza di {startPrice}</strong>che inizia <strong>{start}</strong> il <strong>{startDate} alle {startTime}</strong> e termina <strong>{duration}</strong> il <strong>{date} alle {time}</strong> in cui l'offerta durerà <strong>{biddingDuration}</strong>.","Sale::open_round_info_notice_openbidding_flexible":"Si apre una sessione <strong>aperta</strong> con <strong>prezzo di partenza di {startPrice}</strong>, la quale  <strong>termina in {duration} giorni</strong>.","Sale::open_round_info_notice_sealedbidding_fixed":"Si apre una sessione <strong>chiusa</strong> con <strong>prezzo di riferimento di {estimate}</strong>, la quale termina <strong>{duration}</strong> il {date} <strong>alle {time}.</strong>","Sale::open_round_info_notice_sealedbidding_fixed_withstart":"Si apre una sessione <strong>chiusa</strong> con <strong>prezzo di riferimento di {estimate}</strong> che inizia <strong>{start}</strong> il <strong>{startDate} alle {startTime}</strong> e termina <strong>{duration}</strong> il <strong>{date} alle {time}</strong> in cui l'offerta durerà <strong>{biddingDuration}</strong>.","Sale::open_round_info_notice_sealedbidding_flexible":"Si apre una sessione <strong>chiusa</strong> con <strong>prezzo di riferimento di {estimate}</strong>, la quale  <strong>termina in {duration} giorni</strong>.","Sale::open_round_info_notice_simple_offer_fixed":"Lei apre un <strong>giro di offerte di acquisto digitale</strong>.","Sale::open_round_info_notice_simple_offer_flexible":"Lei apre un <strong>giro di offerte di acquisto digitale</strong>.","Sale::sale_connection_unavailable":"La connessione a questa procedura d'offerta è stata persa. Si prega di ricaricare la pagina.","Sale::sale_not_found":"Questa procedura d'offerta non è stata trovata.","Sale::you_are_about_to_upload_offer_in_the_name_of_customer":"L'offerta di acquisto per conto del cliente sta per essere caricata. In questo modo, il cliente non potrà più presentare la sua offerta di acquisto online. Si raccomanda di conservare il modulo di offerta originale!","SaleCreatePanel::address":"Indirizzo n. civico, città, provincia, CAP","SaleCreatePanel::agbs":"T&C","SaleCreatePanel::create_new_listing":"Crea una nuova proprietà","SaleCreatePanel::i_agree_to_the_link":"Accetta {agbs}","SaleCreatePanel::image":"Foto dell'immobile","SaleCreatePanel::invite_only":"Partecipazione solo per agenti autorizzati","SaleCreatePanel::number":"ID Immobile","SaleCreatePanel::price":"Prezzo di listino","SaleCreatePanel::title":"Titolo dell'annuncio","salepropertytype::business":"Locale commerciale","salepropertytype::flat":"Appartamento","salepropertytype::house":"Villa","salepropertytype::mixed":"Edificio residenziale e commerciale","salepropertytype::office":"Ufficio","salepropertytype::property":"Terreno","SaleWizard::accept_tc_title":"Accetta il CGC","SaleWizard::action_functionality":"Funzionalità dell’azione","SaleWizard::award":"Utilizza questa funzione se desideri informare una parte interessata dell'accettazione della sua offerta.\nNella fase successiva è possibile scegliere quali altre offerte devono essere rifiutate immediatamente.\nÈ possibile scrivere un messaggio personale all'acquirente.","SaleWizard::award_subtitle":"Usa questa funzione se c'è un acquirente preferito ma vuoi mantenere altri offerenti in gara come copertura per il momento.","SaleWizard::award_title":"Offerta d'acquisto accettata","SaleWizard::awardall":"Choose winner for each property","SaleWizard::awardall_subtitle":"Choose winner for each property","SaleWizard::awardall_title":"Choose winners","SaleWizard::choose_a_winner_title":"Seleziona vincitore","SaleWizard::choose_offers_for_next_round_title":"Seleziona offerte","SaleWizard::choose_offers_to_reject_title":"Rifiuti","SaleWizard::choose_winners_title":"Choose winners","SaleWizard::confirmaward":"Utilizzare questa funzione quando la vendita è già stata completata.\nUn rifiuto verrà inviato a tutti i potenziali acquirenti rimanenti.\nIl procedimento è chiuso.","SaleWizard::confirmaward_subtitle":"Utilizzare questa funzione non appena si desidera confermare l'acquirente finale.","SaleWizard::confirmaward_title":"Conferma dell'acquirente","SaleWizard::counteroffer_title":"Controfferta","SaleWizard::duplicate":"Utilizzare questa funzione se si desidera riavviare il processo.\nVengono adottati tutti i dati e i documenti relativi al modulo di offerta.\nÈ quindi possibile regolare le informazioni, definire il round e invitare nuovi potenziali clienti.","SaleWizard::duplicate_subtitle":"Utilizzare questa funzione se si desidera avviare un nuovo processo di offerta con questo annuncio immobiliare","SaleWizard::duplicate_title":"Duplica la procedura di offerta","SaleWizard::increase":"Utilizzare questa funzione per dare all'acquirente la possibilità di aumentare l'offerta.\nSarà definita e aperta una nuova sessione (con nuovo prezzo di riferimento e prezzo red button).\nDopo l'apertura della prossima sessione è possibile invitare altri interessati.\nGli interessati che hanno già presentato un'offerta d'acquisto possono aumentarla.\nTra le offerte già presentate, quelle selezionate possono passare alla prossima sessione.\nTutti gli interessati le cui offerte non sono state selezionate saranno rifiutate e i clienti riceveranno una notifica.\nAnche i clienti accettati riceveranno una notifica ed è possibile inoltre definire un testo aggiuntivo per tali clienti.","SaleWizard::increase_subtitle":"Utilizzare questa funzione se si desidera offrire ai potenziali acquirenti l'opportunità di aumentare la propria offerta","SaleWizard::increase_title":"Avvia altre sessioni d'offerta","SaleWizard::message_to_buyers_title":"Messaggio aggiuntivo","SaleWizard::message_to_rejected_title":"Messaggio per le offerte rifiutate","SaleWizard::message_to_winner_title":"Messaggio aggiuntivo","SaleWizard::next_round_details_title":"Prossima sessione","SaleWizard::notifyseller":"Fai conoscere al venditore le offerte dei tuoi clienti","SaleWizard::notifyseller_subtitle":"Invia la panoramica dell'offerta al venditore","SaleWizard::notifyseller_title":"Avvisare il venditore","SaleWizard::rejectall":"Utilizzare questa funzione se l'offerente non desidera continuare la procedura e se nessuna offerta d'acquisto è stata accettata.\nTutti gli interessati che hanno presentato un'offerta ricevono una notifica.\nLa procedura viene conclusa, in modo da escludere qualunque ulteriore azione.","SaleWizard::rejectall_subtitle":"Utilizzare questa funzione se il venditore non desidera accettare nessuna delle offerte né continuare il processo di offerta.","SaleWizard::rejectall_title":"Rifiuta tutte le offerte","SaleWizard::results_title":"Conferma","SaleWizard::review_title":"Riepilogo","SaleWizard::review_winners_title":"Review winners","SaleWizard::sale_wizard":"Assistente sessione","SaleWizard::select_action_title":"Come procedere?","SaleWizardResult::back_to_sale":"Torna alla procedura d'offerta","SaleWizardResult::confirmation":"Conferma","SaleWizardResult::continue_to_the_duplicated_sale":"Passare alla procedura di offerta duplicata","SaleWizardResult::successful":"Abbiamo ricevuto i suoi dati; entro un minuto le modifiche saranno visibili nel sistema.","SaleWizardRoundInfo::ends":"La procedura d'offerta termina","SaleWizardRoundInfo::estimate":"Prezzo di riferimento","SaleWizardRoundInfo::minimum_price":"Prezzo minimo","SaleWizardRoundInfo::offer_validity":"Offerte d'acquisto valide","SaleWizardRoundInfo::red_button_price":"Prezzo red button","SaleWizardRoundInfo::start_price":"Prezzo di partenza","salutation":"Appellativo","salutation::miss":"Signora","salutation::mr":"Signor","salutation::mrs":"Signora","salutation::ms":"Signora","save":"Salva","Search::add_new_listing":"Aggiungi immobile","Search::address":"Indirizzo","Search::agbs":"T&C","Search::agent_not_found":"Non avete l'autorizzazione per avviare le procedure di offerta per questo broker!","Search::area":"Superficie","Search::create_new_listing":"Inizia una nuova vendita","Search::creating":"Creazione","Search::error_loading_objects":"Errore durante il caricamento degli oggetti.","Search::error_retrieving_file":"Errore durante il recupero o l'archiviazione del file","Search::guide_no_objects":"Al momento non ci sono oggetti attivi.","Search::i_agree_to_the_link":"Accetta {agbs}","Search::i_agree_with_terms_and_conditions":"Accetta T&C","Search::loading_details":"Caricamento dell'immobile in corso","Search::loading_properties":"Caricamento degli immobili in corso","Search::my_listings_overview":"Vai alle mie procedure d'offerta","Search::number":"Num. oggetto","Search::price":"Prezzo","Search::this_object_is_already_active":"È già stato avviato un processo di offerta per questo oggetto","seller":"Venditore","SellerInviteSection::block":"Bloccare","SellerInviteSection::invite":"Invitare","SellerInviteSection::invite_seller":"Invita il venditore","send":"Invia","sms":"SMS","sms_failed":"Non è stato possibile recapitare la notifica SMS","start_new_sale":"Inizia una nuova vendita","start_new_test_sale":"Inizia una nuova vendita di prova","status":"Stato","street":"Indirizzo","street_and_house_number":"Indirizzo e numero civico","submit":"Termina","submitted_on":"Presentato il","submitted_value":"Importo offerta","summary":"Sintesi","swiss_residential_status":"Stato di residenza in Svizzera","tax_code_is_incorrect":"Il codice fiscale non è corretto","template::cust_message":"Messaggio generico","test_sale_explanation":"Utilizzare il processo di vendita di prova se si desidera testare internamente una procedura di offerta. Non ti verrà addebitato alcun importo per questa vendita. Non invitare alla vendita clienti reali esterni. Tutte le pagine e le notifiche verranno contrassegnate come \"Vendita dimostrativa\".","test_sale_watermark":"Vendita dimostrativa","this_action_cannot_be_undone":"Quest'azione non può essere annullata.","title":"Titolo","title::doctor":"Dr.","title::master":"Mag.","title::professor":"Prof","type_of_property":"Tipo di immobile","updated_on":"Aggiornato il","upload":"Carica","upload_more":"Carica di più","uploading":"Carica","uploads":"Caricamenti","uploadtype::identification_document":"Documenti d'identità","uploadtype::misc":"Varie","value_must_be_between_min_and_max":"Il valore deve essere compreso tra {min} e {max}","Whitelisting::whitelisting_done":"Richiesta di collaborazione accettata","WhitelistingPanel::accept":"Accettare","WhitelistingPanel::action":"Azione","WhitelistingPanel::block":"Bloccare","WhitelistingPanel::blocked":"Bloccato","WhitelistingPanel::requested":"Richiesto","WhitelistingPanel::whitelisted":"Accettato","WhitelistingPanel::whitelisting":"Configurazione della Collaborazione","would_you_like_to_continue":"Continuare?","yes":"Sì","zip_code":"NPA"}

/***/ }),
/* 897 */
/***/ (function(module, exports) {

module.exports = {"active":"Activă","add":"Adaugă","additional_address":"Adresa aditională","additional_description":"Alte descrieri si informatii importante","additional_information_text":"Informatii aditionale","address":"Adresa","agent":"Agent","AgentProvisionForm::agent_commission":"Comision Agent","AgentProvisionForm::fixed_amount":"Sumă fixă","AgentProvisionForm::fixed_amount_excluding_vat":"Sumă fixă (exclus TVA)","AgentProvisionForm::no_commission":"Fără comision","AgentProvisionForm::percentage":"Procent","AgentProvisionForm::percentage_excluding_vat":"Procent (exclus TVA)","AgentProvisionForm::standard":"Standard","allowed_file_formats":"Vă rugăm să rețineți că numai următoarele formate de fișiere sunt permise: PDF, JPG și PNG.","and":"și","App::initializing":"Initializare","are_you_sure_this_action_cannot_be_undone":"Esti sigur? Acestă actiune nu poate fi reluată.","area_unit":"m²","auction_finals":"Finale de licitație","AuctionFinalsList::no_offer_selected_for_awardwing_go_back_to_the_matrix_and_pick_some":"No offer selected for awardwing, go back to the matrix and pick some.","AuctionFinalsList::object_no":"Object no.","AuctionFinalsList::selected_buyer":"Selected buyer","AuctionFinalsList::total":"Total","AuctionFinalsMatrix::awarded":"Awarded","AuctionFinalsMatrix::clear_selection":"Clear selection","AuctionFinalsMatrix::for_each_property_pick_the_best_available_offer":"For each property pick the best available offer","AuctionFinalsMatrix::for_each_property_pick_the_highest_offer_if_it_is_the_most_preferred_offer_of_the_highest_bidder":"For each property pick the highest offer if it is the most preferred offer of the highest bidder","AuctionFinalsMatrix::for_each_property_pick_the_highest_offer_if_the_highest_bidder_has_not_been_assigned_to_another_property_yet":"For each property pick the highest offer if the highest bidder has not been assigned to another property ye","AuctionFinalsMatrix::position":"Position","AuctionFinalsMatrix::preference":"Preference","AuctionFinalsMatrix::property":"Property","AuctionFinalsMatrix::select_best_offers":"Select best offers","AuctionFinalsMatrix::select_highest_offers":"Select highest offers","AuctionFinalsMatrix::select_preferred_highest_offers":"Select preferred highest offers","AuctionFinalsMatrix::this_is_the_highest_offer_for_this_property_but_its_not_selected":"This is the highest offer for this property, but it's not selected","AuctionFinalsMatrix::this_is_the_most_preferred_offer_for_this_buyer_but_its_not_selected":"This is the most preferred offer for this buyer, but it's not selected","AuctionFinalsPanel::confirm":"Confirm","AuctionFinalsPanel::continue":"Continue","AuctionFinalsPanel::error_loading_data_from_server":"Error loading data from server","AuctionFinalsPanel::failed":"Failed","AuctionFinalsPanel::report":"Report","AuctionFinalsPanel::review_winners":"Review winners","AuctionFinalsPanel::select_winners":"Select winners","AuctionFinalsPanel::succeeded":"Succeeded","AuctionFinalsTotals::awarded":"Awarded","AuctionFinalsTotals::selected":"Selected","AuctionFinalsTotals::total":"Awarded","audiencetype::bidders":"Ofertanții","audiencetype::everyone":"Toata lumea","audiencetype::item_bidders":"Ofertanți","audiencetype::no_wishlist":"Fără listă de dorințe","audiencetype::non_bidders":"Non-ofertanți","audiencetype::non_item_bidders":"Non-ofertanți","audiencetype::wishlist":"Cu listă de dorințe","AwardAllStep1::loading_offers_please_wait":"Loading offers, please wait","AwardStep1::choose_a_winner":"Alege un câstigător","AwardStep1::expiration_date":"Alege perioadă","AwardStep2::expiration_date":"Valabilitatea ofertei","AwardStep2::select_customers_to_reject_theirs_offer":"Selectați ofertele pe care doriți să le respingeți imediat. Acești clienți vor primi imediat o notificare de anulare. Toți ceilalți clienți nu vor fi anunțați în acest moment dacă doriți să alegeți alt cumpărător mai târziu.","AwardStep2::this_text_will_appear_as_an_additional_note":"Acest text va apărea ca o notă suplimentară în notificarea către câștigător:","AwardStep4::reject_message":"Mesaj suplimentar pentru cumpărătorii respinși","AwardStep4::this_text_will_appear_as_an_additional_note":"Acest text va apărea ca o notă suplimentară în notificare","AwardSummary::if_you_click_finish_you_confirm_the_winner":"Dacă faceți clic pe „Finalizare”, confirmați câștigătorul.  Cumpărătorii potențiali selectați vor fi anunțați.  Acest pas nu poate fi reluat.","AwardSummary::rejected_customers_offers":"Oferte respinse","AwardSummary::selected_winner":"Câstigătorul selectat","back":"Inapoi","behalf_of":"În numele","bid_amount":"Suma ofertată.","bidding_type":"Tip licitatie","BiddingSection::highest_bidder":"Cel mai mare ofertant","BiddingSection::round_opens_on":"Runda se deschide la ","BiddingSection::the_highest_offer":"Offerta cea mai mare","BiddingSection::the_next_minimum_offer":"Următoarea ofertă minimă","BlockDialog::block":"Respinge","BlockDialog::block_agent":"Respinge participarea","BlockDialog::reason":"Motivul respingerii","BulkRegistrationCsvPanel::back_to_mapping":"Înapoi la cartografiere","BulkRegistrationCsvPanel::duplicate_description":"Înregistrarea există deja","BulkRegistrationCsvPanel::import_from_csv_file":"Importă din fisierul CSV","BulkRegistrationCsvPanel::invalid_description":"Înregistrare incompletă","BulkRegistrationCsvPanel::total_number_of_rows_count":"Numar total de linii: {count}","BulkRegistrationCsvPanel::valid_description":"Înregistrare finalizată","BulkRegistrationInventoryPanel::duplicate_description":"Înregistrarea există deja","BulkRegistrationInventoryPanel::entries_with_duplicate_emails_count":"Intrări cu e-mailuri duplicate:{count}","BulkRegistrationInventoryPanel::failed_registrations":"Înregistrări eșuate: {număr}","BulkRegistrationInventoryPanel::importing":"Se importă","BulkRegistrationInventoryPanel::invalid_description":"Înregistrare incompletă","BulkRegistrationInventoryPanel::invalid_entries_count":"Intrări invalide:{count}","BulkRegistrationInventoryPanel::successful_registrations":"Înregistrări reușite: {număr}","BulkRegistrationInventoryPanel::total_number_of_entries_count":"Numărul total de intrări:{count}","BulkRegistrationInventoryPanel::valid_description":"Înregistrare finalizată","BulkRegistrationTable::already_registered":"Deja înregistrat","BulkRegistrationTable::invalid_email":"E-mail invalid","BulkRegistrationTable::saving_error":"Eroare de încărcare","BulkRegistrationTable::select__unselect_all":"Selectați / deselectați toate","BuyerDocumentSelector::none":"Nici unul","BuyerDocumentSelector::not_required":"Nu e solicitat","BuyerDocumentSelector::optional":"Optional","BuyerDocumentSelector::required":"Solicitat","buyertype::company":"Companie","buyertype::entrepreneurs":"Persoana Fizică Autorizată","buyertype::private":"Persoana fizică","CallbackComponent::redirecting":"Redirectionare","cancel":"Anulare","citizenship":"Nationalitate","city":"Localitate","close":"Inchide","combobox_placeholder_free_text":"Selectați o opțiune din listă sau introduceți propria opțiune","Commands::accept":"Confirmă pentru runda următoare","Commands::all_offers":"Toate ofertele","Commands::approve":"Aprobă","Commands::approveregistration":"Activați clienții","Commands::are_you_sure_this_action_can_not_be_undone":"Esti sigur?  Această acțiune nu poate fi anulată.","Commands::are_you_sure_to_block_user":"Esti sigur? Clientul va fi blocat din sistem!","Commands::are_you_sure_to_close_the_sale":"Esti sigur?  Procesul de oferatre digitală va fi închis.","Commands::are_you_sure_to_end_round_early":"Sunteți sigur?  Dacă închideți runda, nu mai pot fi trimise oferte.","Commands::are_you_sure_to_end_round_early_sealed":"Sunteți sigur?  Dacă închideți runda, nu mai pot fi trimise oferte și toate prețurile ofertei vor fi dezvăluite.","Commands::award":"Acceptă oferta","Commands::blank_offer":"Formular de ofertă gol","Commands::block_user":"Blochează clientul","Commands::close_sale":"Inchide procesul de ofertare","Commands::confirm":"Confirmă pentru client (cod de verificare TAN)","Commands::delete_sale":"Sterge procesul de ofertare","Commands::download_documents":"Descarcă documente","Commands::end_round_early":"Inchide runda prematur","Commands::import_registrations_from_crm":"Import din CRM","Commands::import_registrations_from_csv_file":"Importă din fisierul CSV","Commands::import_registrations_from_onoffice":"Importă din onOffice","Commands::import_registrations_from_propstack":"Import Propstack","Commands::import_registrations_from_propup":"Importă din PropUp","Commands::invite_seller":"Invita vanzatorul","Commands::messaging":"Trimite mesaj","Commands::new":"Incepe o rundă nouă","Commands::offer":"Oferte","Commands::pdf_export":"Exportă PDF","Commands::refuse":"Respins ca deficitar","Commands::refuseregistration":"Respinge clienții","Commands::register_new_user":"Invită clienti noi","Commands::registration":"Înregistrări","Commands::reject":"Respinge","Commands::round_close":"Inchide prematur","Commands::round_open":"Deschide runda","Commands::sale":"Procesul de ofertare","Commands::sale_wizard":"Setări de vânzare","Commands::update_contact":"Actualizați contactul","Commands::upload":"Incarcă o ofertă in numele clientului","Commands::whitelisting":"Configurare MLS","company":"Companie","company_court":"Instanta de judecată","company_id":"Carte Identitate","company_name":"Nume Companie","Confirmation::confirmation_expired":"Codul de verificare (TAN) introdus este greșit sau a expirat","Confirmation::invalid_bid_value":"Pretul de cumpărare e prea mic","Confirmation::invalid_confirmation":"Codul de verificare (TAN) introdus este greșit sau a expirat","Confirmation::sale_round_not_opened":"Oferta dvs. nu poate fi acceptată deoarece runda este deja închisă","ConfirmAwardStep1::choose_a_winner":"Alege un câstigător","ConfirmAwardStep1::expiration_date":"Valabilitatea ofertei","ConfirmAwardStep1::reject_message":"Mesaj suplimentar pentru cumpărătorii respinși","ConfirmAwardStep1::this_text_will_appear_as_an_additional_note":"Acest text va apărea ca o notă suplimentară în notificare","ConfirmAwardSummary::if_you_click_finish_you_confirm_the_winner":"Când dați click pe „Finalizare”, confirmați cumpărătorul.  Toate celelalte oferte sunt respinse și clienții sunt notificați. Acest pas nu poate fi reluat.\n\n","ConfirmAwardSummary::rejected_customers_offers":"Respinge oferte","ConfirmAwardSummary::selected_winner":"Câstigătorul selectat","ContactPanel::update_contact":"Actualizați contactul","costs":"Costuri","Countdown::das_verfahren_ist_beendet":"Procesul de ofertare e inchis","CounterofferStep2:: please_define_the_next_round":"Vă rugăm să definiți runda următoare","CounterofferStep2::validity_of_offers_set_to_the_same_value":"Valabilitatea ofertelor setată la aceeași valoare","CounterofferSummary::click_finish_to_start_a_new_round":"Dacă dați click pe „Finalizare”, va începe o nouă rundă","CounterofferSummary::customers_for_the_next_round":"Clienți pentru runda următoare","CounterofferSummary::customers_not_participating_in_the_next_round":"Clienți care nu participă la runda următoare","CounterofferSummary::round_details":"Detalii rundă","country":"Tară","created_on":"Creat la","CsvMappingTable::do_not_import":"Nu importa!","customer":"Client","customer_buyer_reference_of_name":"Client {buyer_reference} de la {name}","customer_name":"Nume client","customer_of_name":"Client de la {name}","Dashboard::authorization_in_progress":"Autorizare in progres","Dashboard::customer_service_contact":"Contact Customer Service","Dashboard::customer_service_email":"support@propnow.com","Dashboard::customer_service_p":"Pentru intrebaări sau probleme ne puteti contacta aici:","Dashboard::customer_service_telephone":"+49 30 959992518","Dashboard::customer_service_telephone_href":"+49 30 959992518","Dashboard::do_you_really_want_to_log_out":"Esti sigur că vrei să te deconectezi?","Dashboard::log_out":"Deconectare","Dashboard::tel__sms__whatsapp":"Telefon","date":"Data","date_of_birth":"Data de nastere","DateField::dateformat":"ZZ.LL.AAAA","DateField::invalid_date":"Date invalide","days":"Zile","delete":"Sterge","deposit_payment_deadline":"Termenul de plată a depozitului","depositRequired::false":"Nu","depositRequired::true":"Da","doc_from":"De la ","Doc::from":"De la ","Doc::no_type":"Vă rugăm să atribuiți tipul de document","Doc::original_name":"Incărcat ca {originalFilename} la {uploadedAt, date, medium}{uploadedAt, time, medium}","documents":"Documente","documenttype::annual_statement":"Declaratie anuală","documenttype::appraisal":"Valoare de evaluare","documenttype::area_allocation_plan":"Planuri de zonă","documenttype::building_permit":"Autorizație de construire","documenttype::completion_display":"Afisare finalizare","documenttype::condominium_contract":"Contract de administrare","documenttype::energy_certificate":"Certificat de performanță energetică","documenttype::expose":"Prezentare","documenttype::expose_long":"Prezentarea proprietătii","documenttype::land_register":"Extras CF","documenttype::loan_agreement":"Contract de inchiriere","documenttype::operating_costs":"Costuri operationale","documenttype::operating_costs_long":"Costuri operare/inretinere si renovări in sensul Art. 20","documenttype::promissory_note":"Bilet la ordin","documenttype::running_costs":"Costuri de operare","documenttype::usage_permit":"Autorizatie","DuplicateStep1::agbs":"T&C","DuplicateStep1::duplicating_sale":"Duplicarea vânzării","DuplicateStep1::hint1":"Toate datele și documentele legate de formularul de ofertă sunt copiate","DuplicateStep1::hint2":"Apoi puteți ajusta informațiile, defini runda și invita noi cumpărători potențiali","DuplicateStep1::i_agree_to_the_link":"De acord cu {agbs}","DuplicateStep1::i_agree_with_terms_and_conditions":"Sunt de acord cu termenii si conditiile","DuplicateSummary::duplicating_sale":"Duplicarea vânzării","duration":"Durată","duration_type":"Durata","durationtype::fixed":"Fixat","durationtype::flexible":"Flexibil","edit":"Editează","EditPanel::edit_offer_form":"Pregăteste formularul de ofertă","email":"Email","email_failed":"Notificarea prin e-mail nu a putut fi livrată","EmailField::invalid_email":"Adresa de email nu e corectă","encoding":"Codificare","Error::blocked":"Pagina pe care încercați să o accesați nu există.  Fie aveți un link greșit, fie procesul de ofertă digitală a fost deja finalizat.  Puteți găsi mai multe obiecte în:","failed_registrations":"Invitații eșuate: {count}","false":"Nu","field::depositrequired":"Depozit","field::email":"Email","field::firstname":"Prenume","field::lastname":"Nume ","field::locale":"Limba","field::phone":"Tel mobil","field::salutation":"Forma de adresare","field::title":"Titlu","fill_required_fields":"Te rugam completeaza câmpurile obligatorii!","financing_required":"Finanțare necesară","financing_secured":"Finanțare asigurată","first_name":"Prenume","handover":"Predare","handovertype::key_handover":"După predarea cheii","handovertype::land_register":"După predarea la Cadastru","handovertype::money_transfer":"După transferul pretului de achizitie in contul predefinit","handovertype::sale_contract":"Conform contractului de vânzare","hidden":"Ascuns","house_number":"Numar","iban":"IBAN","iban_is_not_valid":"IBAN-ul nu este valid","image":"Imagine","import":"Import","IncreaseStep1::all_other_offers_will_be_rejected":"Toate celelalte oferte vor fi respinse și nu au posibilitatea de a participa la o altă rundă.","IncreaseStep1::expiration_date":"Alege perioadă","IncreaseStep1::invite_more_customers_after_start_of_next_round":"După începerea următoarei runde, veți avea ocazia să invitați mai mulți clienți interesați.","IncreaseStep1::select_customers":"Selectați clienții pentru a participa la următoarea rundă.","IncreaseStep2::please_define_the_next_round":"Defineste următoarea rundă","IncreaseStep2::validity_of_offers_set_to_the_same_value":"Timpul de valabilitate a ofertelor de cumpărare pentru celelalte oferte a fost setat automat la aceeași valoare ca în runda precedentă.","IncreaseStep3::this_text_will_appear_as_an_additional_note":"Acest text va apărea ca o notă suplimentară în notificarea către client:","IncreaseSummary::click_finish_to_start_a_new_round":"Dacă dați click pe „Finalizare”, va începe o nouă rundă și clienții vor fi informați.","IncreaseSummary::customers_for_the_next_round":"Clienți pentru runda următoare","IncreaseSummary::customers_not_participating_in_the_next_round":"Clienti car enu participă la următoarea rundă","IncreaseSummary::round_details":"Detalii rundă","is_master_sale":"(Proiect - Procedură principală / Înregistrare)","last_name":"Nume ","legal_entity":"Entitate legală","legal_form":"Formă legală","ListingsOverview::add_new_listing":"Adaugă listare nouă","ListingsOverview::agent":"Agent","ListingsOverview::approved_offers":"Clienti aprobati","ListingsOverview::create_new_listing":"Crează listare nouă","ListingsOverview::end_date":"Dată incheiere","ListingsOverview::guide__you_should_add_a_new_listing":"Pentru a începe un proces de ofertare, trebuie mai întâi să selectați o proprietate.","ListingsOverview::loading_listings":"Incarcă listari","ListingsOverview::my_listings_overview":"Prezentarea listărilor mele","ListingsOverview::number":"ID Proprietate","ListingsOverview::pending_offers":"Oferte in asteptare","ListingsOverview::start_date":"Dată start","loading":"Incarcă","locale":"Limbă","locale::de":"German","locale::deat":"Germană","locale::dech":"German","locale::dede":"German","locale::en":"Engleză","locale::es":"Spaniolă","locale::eses":"Spaniolă","locale::fi":"Finlandeză","locale::fifi":"Finlandeză","locale::fr":"Franceză","locale::frch":"Franceză","locale::frlu":"Franceză","locale::it":"Italiană","locale::itch":"Italiană","locale::ro":"Română","locale::roro":"Română","locale::sl":"Slovenă","locale::slsi":"Slovenă","manage":"Administrare","ManagePanel::administration":"Administrstie","ManagePanel::my_data":"Datele mele","ManagePanel::object_supervisor":"Supraveghetor de obiecte","marital_status":"Starea civilă","maritalstatus::divorced":"Divortat(ă)","maritalstatus::married":"Căsătorit","maritalstatus::none":" ","maritalstatus::single":"Necăsătorit","maritalstatus::widowed":"Vaduv(ă)","message":"Mesaj","MessagingPanel::audience":"Beneficiari","MessagingPanel::failed_to_send_the_message":"Trimiterea mesajului a eșuat","MessagingPanel::messaging":"Trimiteți mesaj personalizat","MessagingPanel::no_message_has_been_sent":"Nu a fost trimis niciun mesaj","MessagingPanel::number_of_failed_messages":"Numărul de mesaje eșuate","MessagingPanel::number_of_successfully_sent_messages":"Numărul de mesaje trimise cu succes","MessagingPanel::subject":"Subiectul","MessagingPanel::template":"Șablon","MessagingPanel::text":"Text","mls":"MLS","mls::everyone":"MLS - disponibil pentru toți agenții","Mls::loading_mls":"Încărcare proceduri MLS de ofertare","Mls::no_sale_for_mls":"Momentan nu există nicio vânzare disponibilă","mls::none":"Procedura nu face parte din MLS","Mls::request_access":"Participați la procedura de ofertare","Mls::request_access_description":"Doriți să solicitați acces la această procedură de ofertare pentru a putea invita clienții dvs. interesați. Cererea dvs. de acces va fi procesată în curând de agentul de listare și veți fi informat prin e-mail și în tabloul de bord.","mls::tenant":"MLS - disponibil doar pentru agenții proprii","more":"Mai mult","name":"Nume","next":"Următorul","no":"Nu","not_entered":"Neintrodus","not_part_of_master_sale":"(niciun proiect - Procedură individuală)","notary":"Notar","notificationcaption::all_customers":"Toți clienții","notificationcaption::customer":"Client","notificationcaption::customers_invited_to_the_next_round":"Clienți pentru runda următoare","notificationcaption::other_customers":"Alți clienți","notificationcaption::seller":"Vânzător","notificationcaption::winner":"Câștigător","notificationemailtemplate::cust_bid_refused":"Ofertă respinsă","notificationemailtemplate::cust_highest_bidder":"Cel mai mare ofertant","notificationemailtemplate::cust_highest_bidder_changed":"Nouă ofertă maximă","notificationemailtemplate::cust_invited":"Invită clienti","notificationemailtemplate::cust_message":"Mesaj","notificationemailtemplate::cust_offer_awarded":"Ofertă acceptată","notificationemailtemplate::cust_offer_placed":"Ofertă depusă","notificationemailtemplate::cust_offer_raised":"Mărește oferta","notificationemailtemplate::cust_offer_refused":"Respinge oferta","notificationemailtemplate::cust_outbid":"Ofertă sublicitată","notificationemailtemplate::cust_outbid_antisniping":"Ofertă supralicitată","notificationemailtemplate::cust_outbid_others":"Nouă ofertă maximă","notificationemailtemplate::cust_phase_invite_closing":"Reamintire - Faza de înregistrare","notificationemailtemplate::cust_phase_offer_starting":"Reamintire - Depunerea ofertei a început","notificationemailtemplate::cust_phase_wishlist_closing":"Reamintire - Selecția proprietăților se încheie","notificationemailtemplate::cust_rejected_round_closed":"Ofertă respinsă","notificationemailtemplate::cust_rejected_sold":"Ofertă respinsă","notificationemailtemplate::cust_rejected_unsold":"Ofertă respinsă","notificationemailtemplate::cust_round_closed":"Runda s-a incheiat","notificationemailtemplate::cust_round_closing":"Reaminteste email","notificationemailtemplate::cust_round_edited":"Rundă modificată","notificationemailtemplate::cust_round_opened":"Rundă noua incepută","NotificationPreview::no_notification_defined_for_the_selected_action":"Nu va fi trimisă nicio notificare pentru acțiunea selectată","notifications":"Notificări","notificationservicestatus::delivered":"Livrat","notificationservicestatus::failed":"Esuat","notificationservicestatus::pending":"In asteptare","notificationservicestatus::sent":"Trimis","NotificationsPanel::explanation":"Dacă doriți să fiți informat despre activitățile pentru procesul de ofertă pentru acest imobil prin e-mail și SMS, vă rugăm să activați funcția:","NotifySellerSummary::description":"Ofertele de cumpărare de la următorii clienți vor fi trimise direct vânzătorului prin e-mail:","now":"Acum","null":"Indisponibil","number":"Număr","offer":"Ofertă","offer_viewing":"Proprietate vizionată la ","offer_viewing_help":"Vă rugăm să lăsați necompletat dacă nu a avut loc încă","OfferDetailsForm::agreement_installer__lawyer":"Agreement installer / lawyer","OfferDetailsForm::other_agreements":"Alte intelegeri scrise","OfferDetailsForm::purchase_offer_valid_until":"Ofertă de cumpărare valabilă până la","OfferDetailsForm::purchase_price_gross":"Pret achizitie (brut)","OfferNotificationDetails::service_data":"Date de service","OfferNotificationsList::created_on":"Expediat pe","OfferNotificationsList::error_loading":"Nu s-a încărcat lista de notificări","OfferNotificationsList::recipient":"Destinatar","OfferNotificationsList::service_status":"Starea serviciului","OfferNotificationsList::template":"Sablon","OffersSection::hidden":"Ascuns acum","OffersSection::increase_offer_on_behalf_of_the_customer":"Creșteți oferta in numele clientului","OffersSection::invited_on":"Invitat la","OffersSection::submitted_at":"Trmis pe","OffersSection::submitted_value":"Valoare ofertă","OffersSection::upload_offer_on_behalf_of_a_customer":"Incarcă oferta in numele clientului","offerstatus::accepted":"Confirmat","offerstatus::approved":"Propbată","offerstatus::awarded":"Accptat","offerstatus::confirmed":"Depusă","offerstatus::invited":"Invitat","offerstatus::refused":"Refuzat","offerstatus::registrationconfirmed":"Se așteaptă activarea","offerstatus::registrationsubmitted":"Înregistrare depusă","offerstatus::rejected":"Respins","offerstatus::submitted":"Pregătit (fără cod de verificare TAN)","offerstatus::updated":"In progres","ok":"OK","open":"Deschis","optional":"Optional","other_agreements":"Alte intelegeri","overview":"Prezentare generală","ownership":"Tip de proprietate","ownershiptype::residential":"Proprietate rezidentială","ownershiptype::share":"Proprietate in cotă","ownershiptype::sole":"Proprietar exclusiv","page_title":"PropNow - {friendly_name}","Page1::area":"Suprafată utila","Page1::construction_year":"An constructie","Page1::deed":"Număr CF","Page1::deed_kg":"KG","Page1::energy_certificate":"Certificat energetic","Page1::housing_subsidies":"Subvenții pentru locuințe","Page1::object_number":"RMX","Page1::ownership_share":"Cotă parte","Page1::ownership_total":"Total","Page1::parcel_number":"Numar parcelă","Page1::register_number":"Numar inregistrare","Page1::usage_rules":"Reguli de utilizare","Page2::date_of_delivery_warranty":"Dată predare, garantii","Page2::date_of_delivery_warranty_contract":"Data livrării, garanție, contract","Page2::exceptions":"Exceptii","Page2::handover_date":"Dată predare","Page2::mortgage":"Ipotecă","Page2::mortgage_detail":"Detalii ipotecă","Page2::notary":"Notariat","Page2::vatliable_purchase":"Achizitie cu TVA","Page3::all_documents_must_have_a_type_set":"Toate documentele trebuie să aibă un tip specificat","Page3::choose_a_document_type_or_enter_description":"Alegeți un tip de document sau introduceți descrierea","Page3::document_type":"Tip document","Page3::upload_following_documents":"Vă rugăm incărcati următoarele documente","peptype::family":"Membru al familiei PEP","peptype::no":"Nu","peptype::related":"Are o relație strânsă cu un PEP","peptype::yes":"Cumpărătorul este un PEP","person":"Persoană","phone_number":"Tel mobil","phone_number_placeholder":"+40 00 000 000","phonenumbererror::invalid":"Numarul de telefon nu e valid","phonenumbererror::notmobile":"Numărul de telefon nu e pentru mobil","place_of_birth":"Locul nasterii","politically_exposed_person_pep":"Persoană expusă politic (PEP)","post_code":"Cod postal","postal_code":"Cod postal","preview":"Previzualizare","previous":"Anteriorul","previous_round":"Runda anterioară","price_on_offer":"Preț față de ofertă","price_on_request":"Preț la cerere","private_person":"Persoană fizică","processing":"Procesare","property_for_sale":"Proprietate de vânzare","provision":"Comisionul cumparatorului","ProvisionAck::i_have_taken_note_of_the_following_important_information":"Am luat act de următoarele informații importante","provisiontype::default":"Standard","provisiontype::fixed_amount":"Sumă fixă (exclus TVA)","provisiontype::fixed_percentage":"Procentaj (exclus TVA)","provisiontype::none":"Fără comision","purchase_price":"Pret de achizitie","recipient":"Chitantă","refresh":"Refresh","RefuseDialog::explanation":"Informați clientul despre motivul respingerii.","RefuseDialog::reason":"Motiv","RefuseDialog::refuse_an_offer":"Refuză o ofertă","register":"Invită","registering":"Invitând","registration_disabled":"Invitarea cumpărătorilor interesați în această procedură de ofertare nu este permisă în prezent (invitațiile sunt posibile doar într-o procedură de ofertare în curs)","RegistrationPanel::already_registered":"Ați invitat deja un client cu această adresă de e-mail!","RegistrationPanel::offer_viewing":"Proprietate vizitată la ","RegistrationPanel::place_at":"Primit la ","RegistrationPanel::purchase_price_gross":"Pretul de cumpărare (brut)","RegistrationPanel::register_new_user":"Invita potențiali cumpărători","RegistrationPanel::send_the_invitation_again":"Retrimite invitatia","RegistrationPanel::upload_an_offer":"Incarcă oferta (in numele clientului)","RegistrationPanel::upload_new_offer":"Incarcă o ofertă nouă in numele clientului","RegistrationPanel::upload_offer":"Incarcă oferta","RejectSummary::click_finish_to_reject_all_offers":"Dacă dați click pe „Finalizare”, toate ofertele vor fi respinse și clienții vor fi informați.","remove":"Mutati","required_documents":"Documente necesare","round":"Rundă","RoundEdit::allow_bidding_below_starting_price":"Permiteți oferte sub prețul de pornire","RoundEdit::allow_bidding_below_starting_price__tooltip":"În procesul de ofertă deschisă, părțile interesate pot, în mod normal, să liciteze doar de la prețul de pornire, ceea ce poate însemna că, adesea, clienții mai sensibili la preț nu licitează. Cu această opțiune, oferiți părților interesate posibilitatea de a depune o ofertă <u>sub</u> prețul de pornire - dar peste prețul minim (inițial ascuns) stabilit de broker. Acest lucru are avantajul că mai multe părți interesate depun o ofertă, deoarece sunt permise și oferte la prețuri mai mici. Acest lucru creează un număr mai mare de ofertanți și, prin urmare, poate crește șansele de vânzare. Toate ofertele sub prețul de pornire sunt ascunse de celelalte părți interesate pentru a evita un efect de ancoră negativ. În mod implicit, sunt afișate numai ofertele de la prețul de pornire, cu excepția cazului în care activați opțiunea \"Afișarea ofertelor sub prețul de pornire pentru alți ofertanți\".","RoundEdit::allow_bidding_below_starting_price_hidden":"Permiteți oferte sub prețul de pornire (ascuns)","RoundEdit::antisniping_notice":"Sfârșitul perioadei ofertei se prelungește automat cu 15 minute dacă o nouă ofertă este primită în ultimele 15 minute înainte de încheierea ofertei. Această prelungire se repetă până când nu se mai fac oferte timp de 15 minute.","RoundEdit::bidding_steps":"Creșterea minimă a ofertei","RoundEdit::bidding_steps__standard":"Pași de licitare standard","RoundEdit::bidding_steps__tooltip":"Aceasta este suma minimă de creștere pentru ofertele noi. Fiecare ofertă nouă trebuie să fie cu cel puțin această sumă mai mare decât cea mai mare ofertă curentă. Dacă ați selectat opțiunea \"Allow offers under highest offer\", creșterea minimă a ofertei se referă la oferta anterioară a clientului individual, dacă acesta a făcut deja o ofertă (pentru informații suplimentare, consultați butonul info: \"Allow offers under highest offer\")","RoundEdit::bidding_type_tooltip":"Selectați tipul de licitație","RoundEdit::counteroffer_value":"Valoarea propusă a contraofertei","RoundEdit::end_date_changed":"Toți cumpărătorii și agenții invitați vor fi informați despre schimbarea sfârșitului procesului de licitare prin e-mail.","RoundEdit::ends_at":"Finalul procesului de ofertare digitala","RoundEdit::ends_at__tooltip":"Pentru sfârșitul procesului de licitație, vă recomandăm să alegeți un moment în care părțile interesate sunt disponibile și într-un loc cu o conexiune bună la internet (de exemplu, acasă). Experiența a arătat că seara devreme sau la sfârșit de săptămână funcționează foarte bine în acest caz. Cu toate acestea, vă rugăm să luați în considerare sărbătorile legale sau weekend-urile prelungite, când părțile interesate ar putea fi plecate. De asemenea, este important să informați părțile interesate cu privire la program. La sfârșitul perioadei de licitație, vor fi trimise memento-uri părților interesate invitate cu 72 de ore, 24 de ore și 60 de minute înainte de sfârșitul programat. De asemenea, vă recomandăm ca dumneavoastră, în calitate de agent, să fiți disponibil la telefon în ultima oră înainte de încheierea procesului de licitație și, dacă este necesar, să urmăriți procesul de licitație în direct pe laptop sau tabletă, astfel încât să puteți sprijini părțile interesate cu orice întrebări sau probleme (de exemplu, o conexiune slabă la internet a părții interesate).","RoundEdit::estimate":"Estimare","RoundEdit::estimate__tooltip":"Prețul țintă este un preț de referință, care este comunicat potențialului cumpărător ca un ghid pentru a-l ajuta să își determine propriul preț de ofertă.  Important: prețul țintă nu reprezintă un preț minim;  adică partea interesată poate trimite, de asemenea, o ofertă sub prețul țintă.","RoundEdit::estimate_lower_than_startprice":"Estimarea nu poate fi mai mică decât prețul minim","RoundEdit::flexible_bidding":"Permiteți oferte sub oferta maximă","RoundEdit::flexible_bidding__tooltip":"În procesul de ofertă deschisă, părțile interesate trebuie, în mod normal, să depună o nouă ofertă maximă cu fiecare nouă ofertă, ceea ce poate determina părțile interesate să renunțe mai devreme sau chiar să nu depună nicio ofertă. Prin selectarea acestei opțiuni flexibile de ofertare, partea interesată are posibilitatea de a depune o ofertă <u>sub</u> oferta maximă curentă. Cu toate acestea, noua ofertă trebuie să fie <u>peste</u> prețul ofertei anterioare a clientului corespunzător, în cazul în care acesta a depus deja o ofertă. Creșterea minimă a ofertei este decisivă în acest caz și se aplică numai <b>propriei oferte</b>. Avantajul acestei opțiuni de licitație este că părțile interesate individuale licitează mai frecvent și se creează un mediu mai puternic, deoarece ofertanții nu renunță mai devreme. Acest lucru poate crește șansele de vânzare, în special atunci când există doar câteva părți interesate sau dacă prețul de pornire este puțin prea ridicat.","RoundEdit::hide_highest_bid__bid_history_for_nonbidders":"Afișați alte oferte doar <strong>după</strong> depunerea propriei oferte","RoundEdit::hide_highest_bid__bid_history_for_nonbidders__tooltip":"Din motive de transparență, în procedura deschisă, oferta maximă curentă și toate ofertele depuse sunt afișate implicit tuturor invitaților – chiar înainte ca aceștia să fi depus o ofertă. Acest lucru poate determina uneori ca anumite persoane interesate, descurajate de prețuri deja foarte mari, să nu depună nicio ofertă, deși ar fi dorit. Pentru a evita acest lucru și a motiva fiecare cumpărător interesat să depună o ofertă, această opțiune de licitare poate fi utilă.","RoundEdit::invalid_starting_price":"Vă rugăm să introduceți un preț de pornire valid","RoundEdit::min_price":"Preț minim","RoundEdit::min_price__tooltip":"Prețul minim de achiziție pe care partea interesată trebuie să îl ofere. Este afișat numai dacă partea interesată dorește să depună o ofertă sub acest preț.","RoundEdit::min_price_lower_than_start":"Prețul minim trebuie să fie mai mic decât prețul de pornire","RoundEdit::minimum_price":"Pret minim","RoundEdit::offer_validity":"Termen limită pentru semnarea contractului","RoundEdit::open_round_warning":"În procesul de licitație deschisă, este furnizată o singură rundă și ofertele sunt dezvăluite tuturor.","RoundEdit::please_enter_a_starting_price":"Vă rugăm să introduceți un preț >0","RoundEdit::red_button_price":"Pretul “buton rosu”","RoundEdit::red_button_price__tooltip":"Acesta este prețul minim (estimat) la care proprietarul este dispus să vândă.  Acesta este un preț pur intern care nu este comunicat clientului și vizibil doar agentului.  La atingerea prețului “buton roșu”, agentul este informat imediat.","RoundEdit::select_a_bidding_type":"Selecteaza tipul licitatiei","RoundEdit::show_bids_below_starting_price":"Afișați ofertele sub prețul de pornire pentru alți ofertanți","RoundEdit::show_bids_below_starting_price__tooltip":"Numai ofertele <u>de la</u> prețul de pornire sunt afișate în mod implicit, cu excepția cazului în care activați această opțiune. Atunci sunt afișate și ofertele <u>sub</u> prețul de pornire și aveți o transparență sporită în procesul de ofertare.","RoundEdit::simple_offer_duration_suggestion_notice":"Aceasta este valabilitatea propusă pe durată limitată a ofertelor de cumpărare. Cu toate acestea, cumpărătorul interesat o poate modifica la depunerea ofertei sale.","RoundEdit::start":"Începutul procesului de ofertare digitala","RoundEdit::start__tooltip":"Dacă invitați părțile interesate <u>înainte de</u> începerea procesului de ofertare (perioada de licitație), acestea își pot introduce deja datele, vizualiza documentele proprietății și <u>pregăti</u> o ofertă. Cu toate acestea, oferta nu poate fi încă depusă! De îndată ce ora de începere este atinsă și perioada de depunere a ofertelor din cadrul procesului de ofertare a început, toate părțile interesate invitate vor primi o notificare și pot începe apoi să își depună ofertele de cumpărare.<br /><br />Sfat: Durata medie a procesului de ofertare, adică perioada în care pot fi depuse oferte (perioada de depunere a ofertelor), este de aproximativ 5-7 zile. Aceasta creează un impuls suficient și, în același timp, asigură că părțile interesate individuale nu își pierd interesul pentru proprietate (ceea ce se poate întâmpla dacă perioada de depunere a ofertelor este prea lungă). Cu toate acestea, perioada de 5-7 zile presupune, de asemenea, că toate părțile interesate au fost deja precalificate suficient de către dumneavoastră, în calitate de broker, la începutul procesului de ofertare, inclusiv vizionarea proprietății și clarificarea opțiunilor de finanțare. Cu toate acestea, dacă finanțarea este încă neclară pentru majoritatea părților interesate și, prin urmare, alegeți opțiunea \"confirmare finanțare\" atunci când invitați părțile interesate, atunci ar trebui să alegeți, de asemenea, o durată puțin mai lungă pentru procesul de ofertare, pentru a acorda părților interesate suficient timp pentru a-și clarifica finanțarea în timp ce procesul este în curs. Dacă aveți întrebări suplimentare, vă rugăm să nu ezitați să contactați echipa noastră.","RoundEdit::starting_price":"Pret de start","RoundEdit::starting_price__tooltip":"Preț pe care potențialul cumpărător trebuie să îl ofere cel puțin atunci când depune prima ofertă.","RoundEdit::time_of_day":"Ora din zi","RoundInfo::ends":"Procesul de ofertare se incheie","RoundInfo::offer_validity":"Termen limită pentru semnarea contractului","RoundInfo::starts":"Începe procesul de licitație","RoundItem::badge_free":"Gratuit","RoundItem::badge_new":"Nou","RoundItem::badge_separator":" & ","RoundItem::how_it_works":"Cum funcționează","RoundItem::incremental_auction_howitworkspoints":"- Oferte deschise de la prețul de pornire\n- Licitare multiplă posibilă\n- Prelungire automată la oferte de ultimă oră\n<b>Noi posibilități flexibile de licitare:</b>\n- Posibilitatea de a permite oferte <u>sub prețul de pornire</u>\n- Valoarea ofertei <u>liberă</u> (deasupra prețului minim)\n- Sunt afișate doar ofertele peste prețul de pornire\n- Dată de start și de sfârșit fixe","RoundItem::incremental_auction_subtitle":"cu licitare flexibilă","RoundItem::incremental_auction_title":"Procedură de ofertare deschisă","RoundItem::incremental_auction_whentouseitpoints":"Ca o procedură normală \"deschisă\" dar și când:\n- Cerere mai mică\n- Clienți sensibili la preț\n- Prețul de pornire mai puțin atractiv\n- Creșterea prețului neclară\n- Oferirea mai multă flexibilitate clienților","RoundItem::open_bidding_howitworkspoints":"- Primul ofertant trebuie să ofere cel puțin prețul de pornire\n- Fiecare ofertă <b>trebuie să fie mai mare decât toate ofertele anterioare</b>\n- Fiecare client își poate îmbunătăți oferta\n- Toate <b>ofertele sunt vizibile</b>\n- Numele clienților sunt anonimizate pentru ceilalți clienți\n- Start și sfârșit explicit al procedurii","RoundItem::open_bidding_subtitle":"cu oferte crescătoare","RoundItem::open_bidding_title":"Procedură de ofertare deschisă","RoundItem::open_bidding_whentouseitpoints":"- Preț de pornire atractiv\n- Cerere mare\n- Valoarea de piață a proprietății peste prețul de pornire\n- Creștere de preț așteptată","RoundItem::sealed_bidding_howitworkspoints":"- Prețul de referință nu este prețul minim\n- Valoarea ofertei <u>liberă</u> \n- Fiecare client poate depune doar <u>o singură</u> ofertă\n- Ofertanții și ofertele sunt <u>ascunse</u>\n- Dată de sfârșit fixă\n- <u>Nicio</u> prelungire automată la oferte de ultimă oră","RoundItem::sealed_bidding_subtitle":"cu oferte ascunse","RoundItem::sealed_bidding_title":"Procedură de ofertare închisă","RoundItem::sealed_bidding_whentouseitpoints":"- Cerere mică/neclară\n- Obținerea feedback-ului de piață\n- Vânzări confidențiale, sector public\n- Proprietate dificil de evaluat","RoundItem::simple_offer_howitworkspoints":"- Depunere digitală simplă a ofertei\n- Prețul de listare = Referință\n- Prețul ofertei <u>liber</u> de ales\n- Clientul poate depune doar <u>o singură</u> ofertă\n- Nicio informație despre posibili alți interesați\n- Nicio dată de sfârșit fixă\n- Posibilitatea de a trece flexibil la procedura de ofertare deschisă atunci când mai mulți clienți depun oferte","RoundItem::simple_offer_subtitle":" ","RoundItem::simple_offer_title":"Ofertă de cumpărare digitală","RoundItem::simple_offer_whentouseitpoints":"- Puțini interesați\n- Proces de vânzare lung\n- Testarea disponibilității de cumpărare\n- Posibilitatea de a depune o ofertă sub rezervă","RoundItem::when_to_use_it":"Când se folosește","RoundPanel::round":"Editează runda","roundstatus::closed":"Inchisă","roundstatus::opened":"Deschisă","roundstatus::started":"Nou","roundtype::allow_conditions":"Permiteți depunerea ofertei sub rezervă","roundtype::counteroffer_bidding":"Licitarea contraofertelor","roundtype::incremental_auction":"Licitatie deschisă","roundtype::open_bidding":"Licitatie deschisă","roundtype::sealed_bidding":"Licitatie inchisă","roundtype::show_invited_customers_count":"Indicați numărul de părți interesate","roundtype::show_invited_customers_count_tooltip":"Numărul total al tuturor potențialilor cumpărători invitați este afișat pentru fiecare client participant.","roundtype::simple_offer":"Ofertă de cumpărare digitală","Sale::all_information_entered_by_customer_will_be_overwritten":"Toate informațiile pe care le-a făcut deja clientul vor fi suprascrise","Sale::already_confirmed":"Acest client a trimis deja o ofertă de cumpărare.  Nu este posibilă trimiterea unei alte oferte în numele clientului.","Sale::billing_notice":" ","Sale::cannot_update_documents_for_open_round__documents_uploaded":"Următoarele documente au fost incărcate:","Sale::cannot_update_documents_for_open_round__no_documents":"Nu ati incărcat niciun document.","Sale::do_you_want_to_open_the_round":"Doriti sa deschideti runda?","Sale::guide__define_offer_form":"Incepe prin a completa datele proprietătii.","Sale::guide__edit_round":"Dacă datele turului nu sunt corecte, reglați-le","Sale::guide__import_users_csv":"Acum puteți importa clienți din fișierul CSV","Sale::guide__invite_users":"Pentru a invita clienții interesați, aveți nevoie de numele acestora, de e-mail și de numărul de telefon mobil.","Sale::guide__missing_mandatory_offer_form":"Te rugăm completează toate câmpurile cerute!","Sale::guide__open_round":"Pentru a deschide public procesul de ofertare și pentru a invita clienți, trebuie să deschideți runda.","Sale::guide__start_round":"Acum trebuie să introduceți parametrii rundei de licitație","Sale::guide__start_round_edit_sale":"Ați completat toate câmpurile obligatorii din formularul de ofertă.  Le puteți examina sau edita aici.","Sale::guide_action__edit_round":"Reglați","Sale::guide_action__edit_sale":"Pregătește formularul de ofertă","Sale::guide_action__import_users_csv":"Importă clienți","Sale::guide_action__invite_bidders":"Invită clienti noi","Sale::guide_action__open_round":"Deschide runda","Sale::guide_action__start_round":"Start rundă nouă","Sale::guide_action__start_round_edit":"Editează formularul de ofertă","Sale::guides__manage_the_sale":"Setările de vânzare","Sale::guides__offers_present":"Acum puteți discuta \"prezentarea generală\" a ofertelor cu vânzătorul și puteți introduce decizia sa în \"Asistentul de rundă\".","Sale::guides__round_closed":"Această rundă s-a încheiat acum.  Puteți pregăti prezentarea generală a ofertei pentru proprietar și puteți introduce rezultatul.","Sale::guides__show_overview":"Prezentare generală","Sale::guides__start_open_process":"Treceți la procedura de ofertare","Sale::guides__upgrade":"Ați primit mai multe oferte. Pentru a optimiza rezultatul vânzării, puteți trece la procedura de ofertare.","Sale::invalid_bid_value":"Această ofertă nu poate fi acceptată.  Există deja o ofertă mai mare sau echivalentă.  Vă rugăm să informați clientul, astfel încât acesta să își poată ajusta oferta.","Sale::loading_sale":"Proprietatea se incarca","Sale::no_estimate":"Fără estimare","Sale::no_starting_price":"Fără pret de pornire","Sale::open_round_deadline_today":"Runda dvs. este de așteptat să se încheie astăzi. Chiar vrei să deschizi runda?","Sale::open_round_deadline_too_long":"Runda dvs. este programată să se încheie în {durationInDays} zile? Ești sigur că vrei să deschizi runda?","Sale::open_round_info_invalid_duration":"Nu poți deschide o rundă care ar trebui să se termine în trecut. Vă rugăm să editați detaliile rundei.","Sale::open_round_info_notice_incremental_auction_fixed":"Deschideți o <strong>rundă deschisă</strong> cu <strong>preț de pornire de {startPrice}</strong> care se termină <strong>{duration}</strong> pe {date} <strong>la {time}.</strong>","Sale::open_round_info_notice_incremental_auction_fixed_withstart":"Deschideți o <strong>rundă deschisă</strong> cu <strong>preț de pornire de {startPrice}</strong> și start licitație <strong>{start}</strong> pe <strong>{startDate} la {startTime}</strong>, care se termină pe <strong>{date} la {time}</strong> <strong>{biddingDuration}</strong>.","Sale::open_round_info_notice_incremental_auction_flexible":"Deschideți o rundă <strong>flexibilă</strong> cu <strong>preț de pornire de {startPrice}</strong> care se termină <strong>în {duration} zile</strong> după primirea primei oferte.","Sale::open_round_info_notice_openbidding_fixed":"Ești pe cale sa inițiezi o licitație <strong>Deschisă</strong> cu <strong>preț de start de {startPrice}</strong> care incetează <strong>{duration}</strong> adică {date} <strong>la {time}</strong>.","Sale::open_round_info_notice_openbidding_fixed_withstart":"Ești pe cale sa inițiezi o licitație <strong>Deschisă</strong> cu <strong>preț de start de {startPrice}</strong> care începe <strong>{start}</strong> pe <strong>{startDate} la {startTime}</strong> și se termină <strong>{duration}</strong> pe <strong>{date} la {time}</strong> în care licitarea va dura <strong>{biddingDuration}</strong>.","Sale::open_round_info_notice_openbidding_flexible":"Ești pe cale să inițiezi o licitație  <strong>Inchisă</strong> cu <strong>pre de start de {startPrice}</strong> care incetează <strong>in {duration} zile</strong> după primirea primei oferte.","Sale::open_round_info_notice_sealedbidding_fixed":"Ești pe cale să inițiezi o licitație <strong>Inchisă</strong> cu <strong>un preț de {estimate}</strong> care se încheie <strong>{duration}</strong> adică {date} <strong>la {time}</strong>.","Sale::open_round_info_notice_sealedbidding_fixed_withstart":"Ești pe cale să inițiezi o licitație <strong>Inchisă</strong> cu <strong>un preț de {estimate}</strong> care începe <strong>{start}</strong> pe <strong>{startDate} la {startTime}</strong> și se termină <strong>{duration}</strong> pe <strong>{date} la {time}</strong> în care licitarea va dura <strong>{biddingDuration}</strong>.","Sale::open_round_info_notice_sealedbidding_flexible":"Ești pe cale sa inițiezi o licitație <strong>Inchisă</strong> cu <strong>preț estimat de {estimate}</strong>care incetează </strong>in {duration} zile<strong> după primirea primei oferte.","Sale::open_round_info_notice_simple_offer_fixed":"Deschideți o <strong>rundă de ofertă de cumpărare digitală</strong>.","Sale::open_round_info_notice_simple_offer_flexible":"Deschideți o <strong>rundă de ofertă de cumpărare digitală</strong>.","Sale::sale_connection_unavailable":"Conexiunea la acest proces de ofertare a fost pierdută. Vă rugăm să reîncărcați pagina.","Sale::sale_not_found":"Acest proces de ofertare nu a putut fi găsit.","Sale::you_are_about_to_upload_offer_in_the_name_of_customer":"Încărcați oferta de cumpărare în numele clientului.  Astfel, clientul nu-și mai poate depune oferta de cumpărare online.  Este absolut necesar să păstrați formularul original de ofertă!","SaleCreatePanel::agbs":"T&C","SaleCreatePanel::behalf_of":"În numele","SaleCreatePanel::create_new_listing":"Creazâ listare noua","SaleCreatePanel::i_agree_to_the_link":"Sunt de acord cu {agbs}","SaleCreatePanel::i_agree_with_terms_and_conditions":"Sunt de acord cu termenii si conditiile","SaleCreatePanel::image":"Fotografia de titlu a proprietății","SaleCreatePanel::invite_only":"Participare doar pentru agenți autorizați","SaleCreatePanel::number":"Numarul proprietătii\n","SaleCreatePanel::price":"Pret oficial","SaleCreatePanel::title":"Titlul proprietătii","salepropertytype::business":"Conditii de afaceri","salepropertytype::flat":"Apartament","salepropertytype::house":"Casă","salepropertytype::mixed":"Cladire rezidentiala si comerciala","salepropertytype::office":"Clădire biroruri","salepropertytype::property":"Proprietate (parcelă teren)","SaleWizard::accept_tc_title":"Accept T&C","SaleWizard::action_functionality":"Această functie oferă următoarele optiuni:","SaleWizard::award":"Puteți informa cumpărătorul favorizat al vânzătorului cu privire la acceptarea ofertei sale, incl.  un mesaj personal. Puteți informa alți potențiali cumpărători a căror ofertă a fost respinsă definitiv.  Acestea vor fi excluse din procesul ulterior. Toți ceilalți ofertanți care nu sunt nici favoriti, nici printre ofertanții respinși definitiv, rămân în proces ca posibili „cumpărători suplinitori” până la încheierea finală a vânzării.","SaleWizard::award_subtitle":"Utilizați această funcție dacă există un cumpărător favorizat, dar doriți să păstrați alți ofertanți în cursă ca sigurantă.","SaleWizard::award_title":"Selecteaza cumpărătorul favorit","SaleWizard::awardall":"Choose winner for each property","SaleWizard::awardall_subtitle":"Choose winner for each property","SaleWizard::awardall_title":"Choose winners","SaleWizard::choose_a_winner_title":"Selectează câstigătorul","SaleWizard::choose_offers_for_next_round_title":"Selectează oferte","SaleWizard::choose_offers_to_reject_title":"Respigeri","SaleWizard::choose_winners_title":"Choose winners","SaleWizard::confirmaward":"Puteți confirma cumpărătorul după finalizarea cu succes a vânzării. Toți potențialii cumpărători rămași sunt informați automat despre închiderea vânzării, iar ofertele lor au fost în final respinse. Procesul de ofertă este închis.","SaleWizard::confirmaward_subtitle":"Utilizați această funcție imediat ce doriți să confirmați cumpărătorul final.","SaleWizard::confirmaward_title":"Confirmă cumpărătorul final","SaleWizard::counteroffer":"Utilizați această funcționalitate atunci când doriți să faceți o contraofertă unui potențial cumpărător. Când cumpărătorul acceptă valoarea contraofertei, acesta este confirmat ca si cumpărător iar oferta devine obligatorie/angajantă din partea vânzătorului. Puteți selecta un cumpărător care a depus deja o ofertă. Apoi puteți  specifica o valoare de contraofertă și termenul până la care cumpărătorul trebuie să decidă. Cumpărătorul poate: \nSă accepte valoarea și apoi este ales imediat ca cumpărător selectat. \nSă facă o ofertă mai mare decât oferta sa anterioară, dar mai mică decât contraoferta, caz în care  runda va fi închisă și o puteți rezolva cu vânzătorul.\nNu faceți nimic și runda se va închide conform programării.","SaleWizard::counteroffer_subtitle":"Utilizați această funcție dacă doriți să faceți o contraofertă unui potențial cumpărător.","SaleWizard::counteroffer_title":"Contraofertă","SaleWizard::duplicate":"Toate datele și documentele deja stocate pentru proprietate sunt transferate automat. Puteți apoi să ajustați detaliile, să definiți parametrii noului proces, să deschideți runda de ofertă și să invitați noi cumpărători potențiali.","SaleWizard::duplicate_subtitle":"Utilizați această funcție dacă doriți să începeți un nou proces de ofertare pentru această proprietate.","SaleWizard::duplicate_title":"Incepe un nou proces de ofertare","SaleWizard::increase":"Puteți începe o altă rundă de ofertă (cu un nou preț de referință, dacă este cazul) pentru a obține un preț final mai bun. Toți ofertanții (selectați) din ultima rundă pot participa și își pot crește oferta existentă;  vor fi anunțați automat. În plus, pot fi invitați noi potențiali cumpărători care nu au participat încă. Toți ceilalți ofertanți anteriori care nu au fost selectați pentru această nouă rundă vor primi automat o notificare cu respingerea ofertei lor existente.","SaleWizard::increase_subtitle":"Utilizați această funcție dacă doriți să oferiți potențialilor cumpărători posibilitatea de a-și mări oferta.","SaleWizard::increase_title":"Lansați o altă rundă de oferte","SaleWizard::message_to_buyers_title":"Mesaj aditional","SaleWizard::message_to_rejected_title":"Mesaj pentru ofertele respinse","SaleWizard::message_to_winner_title":"Mesaj aditional","SaleWizard::next_round_details_title":"Runda următoare","SaleWizard::notifyseller":"Anunțați vânzătorul despre ofertele clienților dvs.","SaleWizard::notifyseller_subtitle":"Trimiteți vânzătorului o prezentare generală a ofertei","SaleWizard::notifyseller_title":"Anunță vânzătorul","SaleWizard::rejectall":"Toți cumpărătorii potențiali care au depus o ofertă vor fi informați cu privire la decizia negativă a vânzătorului. Procesul de ofertă este închis.","SaleWizard::rejectall_subtitle":"Utilizați această funcție dacă vânzătorul nu dorește să accepte niciuna dintre oferte și nici nu dorește să continue procesul de ofertă.","SaleWizard::rejectall_title":"Respinge toate ofertele","SaleWizard::results_title":"Confirmare","SaleWizard::review_title":"Sumar","SaleWizard::review_winners_title":"Review winners","SaleWizard::sale_wizard":"Setările de vânzare","SaleWizard::select_action_title":"Cum doriți să continuați?","SaleWizardResult::back_to_sale":"Inapoi la procesul de ofertare","SaleWizardResult::confirmation":"Confirmare","SaleWizardResult::continue_to_the_duplicated_sale":"Continuați cu vânzarea duplicată","SaleWizardResult::successful":"Am primit informațiile dvs si într-un minut ajustările sunt vizibile în sistem.","SaleWizardRoundInfo::ends":"Procesul de ofertare se incheie","SaleWizardRoundInfo::estimate":"Estimat","SaleWizardRoundInfo::minimum_price":"Pret minim","SaleWizardRoundInfo::offer_validity":"Oferta de cumpărare este validă","SaleWizardRoundInfo::red_button_price":"Pretul “buton ROSU”","SaleWizardRoundInfo::start_price":"Pret de start","salutation":"Adesare/titlu","salutation::miss":"D-na.","salutation::mr":"Dl.","salutation::mrs":"D-na.","salutation::ms":"D-na.","save":"Salvează","Search::add_new_listing":"Adaugă listare nouă","Search::address":"Adresă","Search::agbs":"T&C","Search::agent_not_found":"Nu aveți permisiunea de a iniția proceduri de ofertare pentru acest agent!","Search::area":"Suprafată","Search::create_new_listing":"Crează listare nouă","Search::creating":"Se crează","Search::error_loading_objects":"Eroare la incarcare.","Search::error_retrieving_file":"Eroare la recuperarea sau stocarea fișierului","Search::guide_no_objects":"Se pare că nu aveți obiecte active în acest moment.","Search::i_agree_to_the_link":"Sunt de acord cu {agbs}","Search::i_agree_with_terms_and_conditions":"Sunt de acord cu termenii si conditiile","Search::loading_details":"Incarcă detalii","Search::loading_properties":"Incarcă proprietăti","Search::my_listings_overview":"Către procesul meu de ofertare","Search::number":"RMX","Search::price":"Pret","Search::this_object_is_already_active":"Este deja o licitatie deschisă pt această listare","select_master_sale":"Proiect","self_registration":"Autoînregistrare","seller":"Vânzător","SellerInviteSection::block":"Bloc","SellerInviteSection::invite":"Invita","SellerInviteSection::invite_seller":"Invita vanzatorul","send":"Trimite","sms":"SMS","sms_failed":"Notificarea prin SMS nu a putut fi livrată","start_new_sale":"Începe o nouă vânzare","start_new_test_sale":"Începeți o nouă vânzare de probă","status":"Status","street":"Stradă","street_and_house_number":"Strada și numărul","submit":"Trimite","submitted_on":"Trimis in","submitted_value":"Valoarea ofertei","successful_registrations":"Invitații reușite: {count}","summary":"Sumar","swiss_residential_status":"Statut de reședință elvețian","template::cust_message":"Mesaj generic","test_sale_explanation":"Vă rugăm să folosiți procedura de testare exclusiv în scopuri interne de instruire și prezentare. O puteți folosi și ca sprijin în conversațiile de prospectare, pentru a prezenta în direct potențialilor vânzători fluxul și avantajele procedurii de ofertare. Utilizarea procedurii de testare este gratuită și toate paginile web și notificările sunt marcate ca \"Test\". Utilizarea pentru proceduri reale de ofertare cu implicarea unor cumpărători reali este interzisă.","test_sale_watermark":"Test de vânzare","this_action_cannot_be_undone":"Această actiune nu poate fi reluată.","title":"Titlu","title::doctor":"Licentiat","title::master":"Dr.","title::professor":"Profesor","true":"Da","type_of_property":"Tipul proprietătii","updated_on":"Incărcat la ","upload":"Incarcă","upload_more":"Incarcă mai mult","uploading":"Se incarcă","uploads":"Incărcări","uploadtype::identification_document":"Dicumente de identificare","uploadtype::misc":"Diverse","value_must_be_between_min_and_max":"Valorile trebuie să fie intre {min} si {max}","WhitelistingPanel::accept":"Aprobă","WhitelistingPanel::action":"Acțiune","WhitelistingPanel::block":"Respinge","WhitelistingPanel::blocked":"Respins","WhitelistingPanel::requested":"Solicitat","WhitelistingPanel::whitelisted":"Aprobat","WhitelistingPanel::whitelisting":"Prezentare generală configurare MLS","would_you_like_to_continue":"Ai vrea să continui?","yes":"Da","zip_code":"Cod poștal"}

/***/ }),
/* 898 */
/***/ (function(module, exports) {

module.exports = {"active":"Aktiven","add":"Dodaj","additional_address":"Dodatni naslov","additional_description":"Drugi opis in pomembne informacije","additional_information_text":"Dodatne informacije","address":"Naslov","agent":"Nepremičninski posrednik","AgentProvisionForm::agent_commission":"Posredniška provizija","AgentProvisionForm::fixed_amount":"Fiksni znesek","AgentProvisionForm::fixed_amount_excluding_vat":"Fiksni znesen (brez DDV)","AgentProvisionForm::no_commission":"Brez provizije","AgentProvisionForm::percentage":"Procent prodajne vrednosti","AgentProvisionForm::percentage_excluding_vat":"Procent prodajne vrednosti (brez DDV)","AgentProvisionForm::standard":"Standard","allowed_file_formats":"Dovoljeni so samo sledeči formati dokumentov: PDF, JPG in PNG.","App::initializing":"V teku","are_you_sure_this_action_cannot_be_undone":"Ste prepričani? Te aktivnosti ne morete razveljaviti.","auction_finals":"Finale dražbe","audiencetype::bidders":"Ponudniki","audiencetype::everyone":"Vsi","audiencetype::non_bidders":"Neponudniki","AwardStep1::choose_a_winner":"Izberi zmagovalca","AwardStep1::expiration_date":"Izberi obdobje","AwardStep2::expiration_date":"Veljavnost ponudbe","AwardStep2::select_customers_to_reject_theirs_offer":"Izberite ponudbe, ki jih želite takoj zavrniti.\nTe stranke bodo nemudoma prejele obvestilo o zavrnitvi. \nVsi ostali ponudniki o vaši izbiri ne bodo obveščeni, saj ostajajo v postopku kot \"nadomestni\" oziroma \"rezervni\" kupci.","AwardStep2::this_text_will_appear_as_an_additional_note":"To besedilo bo v obvestilu zmagovalcu prikazano kot dodatna opomba:","AwardSummary::if_you_click_finish_you_confirm_the_winner":"Če kliknete \"Končaj\", potrdite zmagovalca in izbrani potencialni kupci bodo o tem obveščeni. Tega koraka ni mogoče razveljaviti.","AwardSummary::rejected_customers_offers":"Zavrnjene ponudbe","AwardSummary::selected_winner":"Izberi zmagovalca","back":"Nazaj","behalf_of":"V imenu","bid_amount":"Znesek ponudbe","bidding_type":"Vrsta ponudbe","BiddingSection::highest_bidder":"Ponudnik najvišje ponudbe","BiddingSection::round_opens_on":"Krog dražbe se prične ","BiddingSection::the_highest_offer":"Najvišja ponudba","BiddingSection::the_next_minimum_offer":"Naslednja minimalna ponudba","BulkRegistrationCsvPanel::back_to_mapping":"Nazaj k urejanju podatkov","BulkRegistrationCsvPanel::duplicate_description":"Zapis že obstaja","BulkRegistrationCsvPanel::import_from_csv_file":"Uvozi iz CSV datoteke","BulkRegistrationCsvPanel::invalid_description":"Nepopoln zapis","BulkRegistrationCsvPanel::total_number_of_rows_count":"Skupno število vrstic: {count}","BulkRegistrationCsvPanel::valid_description":"Snemanje končano","BulkRegistrationInventoryPanel::duplicate_description":"Zapis že obstaja","BulkRegistrationInventoryPanel::entries_with_duplicate_emails_count":"Vnosi s podvojenimi e-maili: {count}","BulkRegistrationInventoryPanel::failed_registrations":"Neuspešne registracije: {count}","BulkRegistrationInventoryPanel::importing":"Uvažanje","BulkRegistrationInventoryPanel::invalid_description":"Nepopoln zapis","BulkRegistrationInventoryPanel::invalid_entries_count":"Neveljavni vnosi: {count}","BulkRegistrationInventoryPanel::successful_registrations":"Uspešne registracije: {število}","BulkRegistrationInventoryPanel::total_number_of_entries_count":"Skupno število vnosov: {count}","BulkRegistrationInventoryPanel::valid_description":"Snemanje končano","BulkRegistrationTable::already_registered":"Že registrirano","BulkRegistrationTable::invalid_email":"Neveljavny e-mail","BuyerDocumentSelector::none":"Nobena","BuyerDocumentSelector::not_required":"Ni zahtevano","BuyerDocumentSelector::optional":"Neobvezno","BuyerDocumentSelector::required":"Zahtevano","buyertype::company":"Podjetje","buyertype::entrepreneurs":"Samostojni podjetnik","buyertype::private":"Fizična oseba","CallbackComponent::redirecting":"Preusmerjanje","cancel":"Prekliči","citizenship":"Državljanstvo","city":"Mesto","close":"Zapri","Commands::accept":"Potrdi naslednji krog dražbe","Commands::all_offers":"Vse ponudbe","Commands::approve":"Odobri","Commands::approveregistration":"Aktivirajte stranke","Commands::are_you_sure_this_action_can_not_be_undone":"Ste prepričani? Te aktivnosti ne gre razveljaviti.","Commands::are_you_sure_to_block_user":"Ste prepričani? Stranka bo v sistemu blokirana!","Commands::are_you_sure_to_close_the_sale":"Ste prepričani? Postopek zbiranja ponudb se bo zaprl.","Commands::are_you_sure_to_end_round_early":"Ste prepričani? Če zaprete krog dražbe, ne boste mogli prejeti novih ponudb.","Commands::are_you_sure_to_end_round_early_sealed":"Ste prepričani? Če zaprete krog dražbe, ne boste mogli prejeti novih ponudb in cene bodo razkrite.","Commands::award":"Sprejmi ponudbo","Commands::blank_offer":"Vzorec obrazca za oddajo ponudbe (PDF)","Commands::block_user":"Blokiraj stranko","Commands::close_sale":"Zapri postopek zbiranja ponudb","Commands::confirm":"Potrdi v imenu stranke (SMS žeton)","Commands::delete_sale":"Izbriši postopek zbiranja ponudb","Commands::download_documents":"Snemi dokumente","Commands::end_round_early":"Predčasno zaprite krog dražbe","Commands::import_registrations_from_csv_file":"Uvozi iz datoteke CSV","Commands::import_registrations_from_onoffice":"Uvozi iz onOffice","Commands::import_registrations_from_propstack":"Propstack Import","Commands::import_registrations_from_propup":"Uvozi iz PropUp","Commands::messaging":"Pošlji sporočilo","Commands::new":"Začni novi krog dražbe","Commands::offer":"Ponudbe","Commands::pdf_export":"PDF izvoz","Commands::refuse":"Zavrnitev zaradi pomankljivosti","Commands::refuseregistration":"Zavrni stranke","Commands::register_new_user":"Povabi nove stranke","Commands::registration":"Registracije","Commands::reject":"Zavrni","Commands::round_close":"Predčasno zaprite","Commands::round_open":"Odpri krog dražbe","Commands::sale":"Postopek zbiranja ponudb","Commands::sale_wizard":"Čarovnik za prodajo","Commands::update_contact":"Posodobi stik","Commands::upload":"Naloži ponudbo v imenu stranke","company":"Podjetje","company_court":"Pristojno sodišče","company_id":"ID","company_name":"Naziv podjetja","Confirmation::confirmation_expired":"Vnesen SMS žeton je napačen oziroma je potekel.","Confirmation::invalid_bid_value":"Ponujena nakupna cena je prenizka","Confirmation::invalid_confirmation":"Vnesen SMS žeton je napačen oziroma je potekel.","Confirmation::sale_round_not_opened":"Vaše ponudbe ne moremo sprejeti, saj je krog dražbe že zaključen","ConfirmAwardStep1::choose_a_winner":"Izberite zmagovalca","ConfirmAwardStep1::expiration_date":"Veljavnost ponudbe","ConfirmAwardSummary::if_you_click_finish_you_confirm_the_winner":"Ko kliknete \"Končaj\", potrdite zmagovalca. Vse ostale ponudbe so zavrnjene in njihovi ponudniki obveščeni o vaši izbiri. \nTega koraka ni mogoče razveljaviti.","ConfirmAwardSummary::rejected_customers_offers":"Zavrnjene ponudbe","ConfirmAwardSummary::selected_winner":"Izbran zmagovalec","ContactPanel::update_contact":"Posodobi stik","costs":"Stroški","Countdown::das_verfahren_ist_beendet":"Postopek zbiranja ponudb je zaključen","country":"Država","created_on":"Ustvarjeno dne","CsvMappingTable::do_not_import":"ne uvozi","customer":"Stranka","customer_buyer_reference_of_name":"Stranka {buyer_reference} iz podjetja {name}","customer_name":"Ime stranke","customer_of_name":"Stranka iz podjetja {name}","Dashboard::authorization_in_progress":"Avtorizacija v teku","Dashboard::customer_service_contact":"Kontakt službe za pomoč","Dashboard::customer_service_email":"info@maxdrazbe.si","Dashboard::customer_service_p":"V primeru težav in vprašanj nas lahko kontaktirate:","Dashboard::customer_service_telephone":"386 41 765 555","Dashboard::customer_service_telephone_href":"386 41 765 555","Dashboard::do_you_really_want_to_log_out":"Ste prepričani, da se želite odjaviti?","Dashboard::log_out":"Odjava","Dashboard::tel__sms__whatsapp":"Telefon","date":"Datum","date_of_birth":"Datum rojstva","DateField::dateformat":"dd.mm.llll","DateField::invalid_date":"Neveljaven datum","days":"Dni","delete":"Izbriši","deposit_payment_deadline":"Rok za plačilo varščine/are","depositRequired::false":"Ne","depositRequired::true":"Da","doc_from":"iz dne","Doc::from":"iz dne","Doc::no_type":"Prosim izberite vrsto dokumenta","Doc::original_name":"Naloženo kot {originalFilename}, {uploadedAt, date, medium}{uploadedAt, time, medium}","documents":"Dokumenti","documenttype::annual_statement":"Obračun stroškov","documenttype::appraisal":"Ocena vrednosti","documenttype::area_allocation_plan":"Prostorski načrt","documenttype::building_permit":"Gradbeno dovoljenje","documenttype::completion_display":"Načrt projekta ","documenttype::condominium_contract":"Dogovor etažnih lastnikov","documenttype::energy_certificate":"Energetska izkaznica","documenttype::expose":"Ekspoze","documenttype::expose_long":"Opis nepremičnine ","documenttype::land_register":"Izpis iz zemljiške knjige","documenttype::loan_agreement":"Pogodba o kreditiranju","documenttype::operating_costs":"Fiksni stroški","documenttype::operating_costs_long":"Planirani stroški vzdrževalnih del / planiranih investicij ","documenttype::promissory_note":"Hipoteka","documenttype::running_costs":"Variabilni stroški","documenttype::usage_permit":"Uporabno dovoljenje","DuplicateStep1::agbs":"pogoje uporabe","DuplicateStep1::duplicating_sale":"Podvajanje prodaje","DuplicateStep1::hint1":"Vse podatki in dokumenti povezani z obrazecem ponudbe so kopirani","DuplicateStep1::hint2":"Nato lahko spremenite podatke, definirate krog dražbe in povabite nove potencialne kupce.","DuplicateStep1::i_agree_to_the_link":"Strinjam se s {agbs}","DuplicateStep1::i_agree_with_terms_and_conditions":"Strinjam se s pogoji in pravili","DuplicateSummary::duplicating_sale":"Podvajanje prodaje","duration":"Trajanje","duration_type":"Čas veljavnosti","durationtype::fixed":"Fiksna","durationtype::flexible":"Variabilna","edit":"Uredi","EditPanel::edit_offer_form":"Pripravite obrazec za oddajo ponudbe","email":"E-mail","email_failed":"E-poštnega obvestila ni bilo mogoče dostaviti","EmailField::invalid_email":"Elektronski naslov je napačen","encoding":"Šifriranje","Error::blocked":"Stran do katere želite dostopati ne obstaja. Morda imate napačno povezavo, ali pa je postopek oddaje ponudbe že zaključen. Več nepremičnin najdete:","field::depositrequired":"Varščina/ara","field::email":"E-mail","field::firstname":"Ime","field::lastname":"Priimek","field::locale":"Jezik","field::phone":"Mobilna telefonska številka","field::salutation":"Nagovor","field::title":"Naziv","fill_required_fields":"Prosimo izpolnite zahtevana polja!","first_name":"Ime","handover":"Primopredaja","handovertype::key_handover":"Po podpisu kupoprodajne pogodbe","handovertype::land_register":"Po notarski overitvi kupoprodajne pogodbe","handovertype::money_transfer":"Po plačilu kupnine","handovertype::sale_contract":"Po pridobitvi uporabnega dovoljenja","hidden":"skrito","house_number":"Številka","iban":"Transakcijski račun (IBAN)","image":"Slika","import":"Uvozi","IncreaseStep1::all_other_offers_will_be_rejected":"Vse preostale ponudbe bodo zavrnjene in ponudniki ne bodo imeli priložnosti sodelovati v naslednjem krogu dražbe.","IncreaseStep1::expiration_date":"Izberite obdobje","IncreaseStep1::invite_more_customers_after_start_of_next_round":"Po začetku novega kroga dražbe boste imeli priložnost povabiti več zainteresiranih kupcev.","IncreaseStep1::select_customers":"Izberite stranke, ki se bodo udeležile naslednjega kroga dražbe.","IncreaseStep2::please_define_the_next_round":"Prosimo, definirajte naslednji krog dražbe.","IncreaseStep2::validity_of_offers_set_to_the_same_value":"Čas veljavnosti ponudb  je bil samodejno nastavljen na isto vrednost kot v prejšnjem krogu dražbe.","IncreaseStep3::this_text_will_appear_as_an_additional_note":"To besedilo bo v obvestilu stranki prikazano kot dodatna opomba:","IncreaseSummary::click_finish_to_start_a_new_round":"Če kliknete \"Končaj\", se bo začel nov krog dražbe in stranke bodo o tem obveščene.","IncreaseSummary::customers_for_the_next_round":"Stranke za sodelovanje v naslednjem krogu dražbe.","IncreaseSummary::customers_not_participating_in_the_next_round":"Stranke, ki ne bodo sodelovale v naslednjem krogu dražbe.","IncreaseSummary::round_details":"Več informacij o krogu dražbe","last_name":"Priimek","legal_entity":"Pravna oseba","legal_form":"Pravna oblika","ListingsOverview::add_new_listing":"Dodaj novo nepremičnino","ListingsOverview::agent":"Nepremičninski posrednik","ListingsOverview::approved_offers":"Odobrene stranke","ListingsOverview::create_new_listing":"Ustvari novo nepremičnino","ListingsOverview::end_date":"Datum konca","ListingsOverview::guide__you_should_add_a_new_listing":"Za pričetek zbiranja ponudb je potrebno najprej izbrati nepremičnino","ListingsOverview::loading_listings":"Oglasi se nalagajo","ListingsOverview::my_listings_overview":"Pregled mojih nepremičnin","ListingsOverview::number":"ID nepremičnine","ListingsOverview::pending_offers":"Ponudbe na čakanju","ListingsOverview::start_date":"Datum začetka","loading":"Nalaganje","locale":"Jezik","locale::de":"Nemščina","locale::dech":"Nemščina","locale::dede":"Nemščina","locale::en":"Angleščina","locale::fr":"Francoščina","locale::frch":"Francoščina","locale::frlu":"Francoščina","locale::it":"Italijanščina","locale::itch":"Italijanščina","locale::ro":"Romunščina","locale::roro":"Romunščina","manage":"Uredi","ManagePanel::administration":"Administracija","ManagePanel::my_data":"Moji podatki","ManagePanel::object_supervisor":"Nadzornik objektov","marital_status":"Zakonski stan","maritalstatus::divorced":"Ločen","maritalstatus::married":"Poročen","maritalstatus::none":"/","maritalstatus::single":"Samski","maritalstatus::widowed":"Vdovec","message":"Sporočilo","MessagingPanel::audience":"Prejemniki","MessagingPanel::failed_to_send_the_message":"Sporočila ni bilo mogoče poslati","MessagingPanel::messaging":"Pošlji sporočilo po meri","MessagingPanel::no_message_has_been_sent":"Nobeno sporočilo ni bilo poslano","MessagingPanel::number_of_failed_messages":"Število neuspešnih sporočil","MessagingPanel::number_of_successfully_sent_messages":"Število uspešno poslanih sporočil","MessagingPanel::subject":"Zadeva","MessagingPanel::template":"Predloga","MessagingPanel::text":"Besedilo","mls":"ID oglasa","mls::everyone":"ID nepremičnine","Mls::no_sale_for_mls":"Trenutno ni aktivnega postopka zbiranja ponudb","mls::none":"Brez ID oglasa","mls::tenant":"ID nepremičnine","more":"več","name":"Ime","next":"Naprej","no":"Ne","not_entered":"Ni vnosa","notary":"Notar","notificationemailtemplate::cust_invited":"Povabi stranke","notificationemailtemplate::cust_offer_awarded":"Ponudba prejeta","notificationemailtemplate::cust_offer_placed":"Ponudba poslana","notificationemailtemplate::cust_offer_raised":"Zvišaj ponudbo","notificationemailtemplate::cust_offer_refused":"Zavrni ponudbo","notificationemailtemplate::cust_outbid":"Ponudba je večja od pričakovane","notificationemailtemplate::cust_outbid_antisniping":"Ponudba je večja od pričakovane","notificationemailtemplate::cust_rejected_round_closed":"Ponudba je zavrnjena","notificationemailtemplate::cust_rejected_sold":"Ponudba je zavrnjena","notificationemailtemplate::cust_rejected_unsold":"Ponudba je zavrnjena","notificationemailtemplate::cust_round_closed":"Krog draženja se je zaključil","notificationemailtemplate::cust_round_closing":"E-mail opomnik","notificationemailtemplate::cust_round_opened":"Nov krog draženja se je pričel","NotificationPreview::no_notification_defined_for_the_selected_action":"Za to aktivnost ne bo poslano nobeno obvestilo","notifications":"Obvestila","notificationservicestatus::delivered":"Dostavljeno","notificationservicestatus::failed":"Ni uspelo","notificationservicestatus::pending":"V teku","notificationservicestatus::sent":"Poslano","NotificationsPanel::explanation":"Če želite biti obveščeni o aktivnostih v postopku zbiranja ponudb za ta predmet preko elektronske pošte in SMS sporočila, aktivirajte funkcije:","NotifySellerSummary::description":"Nakupne ponudbe naslednjih strank bodo poslane neposredno prodajalcu po e-pošti:","now":"Zdaj","number":"Število","offer":"Ponudba","offer_viewing":"Ogled nepremičnine se je izvedel na dan","OfferDetailsForm::agreement_installer__lawyer":"Pogodbo je pripravil / pravnik","OfferDetailsForm::other_agreements":"Drugi dogovori","OfferDetailsForm::purchase_offer_valid_until":"Ponudba je veljavna do","OfferDetailsForm::purchase_price_gross":"Nakupna cena (bruto)","OfferNotificationDetails::service_data":"Podatki storitve","OfferNotificationsList::created_on":"Odpremljeno dne","OfferNotificationsList::error_loading":"Seznama obvestil ni mogoče naložiti","OfferNotificationsList::recipient":"Prejemnik","OfferNotificationsList::service_status":"Status storitve","OfferNotificationsList::template":"Predloga","OffersSection::hidden":"Trenutno skrito","OffersSection::increase_offer_on_behalf_of_the_customer":"Zvišaj ponudbo v imenu stranke","OffersSection::invited_on":"Povabljen dne","OffersSection::submitted_at":"Oddano dne","OffersSection::submitted_value":"Znesek ponudbe","OffersSection::upload_offer_on_behalf_of_a_customer":"Naloži ponudbo v imenu stranke","offerstatus::accepted":"Potrjeno","offerstatus::approved":"Odobreno","offerstatus::awarded":"Sprejeto","offerstatus::confirmed":"Poslano","offerstatus::invited":"Povabljen/a","offerstatus::refused":"Zavrnjeno","offerstatus::registrationconfirmed":"Čakanje na aktivacijo","offerstatus::registrationsubmitted":"Prijava oddana","offerstatus::rejected":"Zavrnjeno","offerstatus::submitted":"Pripravljeno (brez SMS žetona)","offerstatus::updated":"V teku","ok":"OK","open":"Odpri","optional":"Neobvezno","other_agreements":"Drugi dogovori","overview":"Pregled","ownership":"Tip lastništva","ownershiptype::residential":"Stanovanjska nepremičnine","ownershiptype::share":"2 ali več lastnikov ","ownershiptype::sole":"En lastnik","Page1::area":"Območje","Page1::construction_year":"Leto izgradnje","Page1::deed":"Identifikacijska oznaka nepremičnine (št.parcele, k.o.)","Page1::deed_kg":"KG","Page1::energy_certificate":"Energetska izkaznica","Page1::housing_subsidies":"Stanovanjske subvencije","Page1::object_number":"ID nepremičnine","Page1::ownership_share":"Deli","Page1::ownership_total":"Skupaj","Page1::parcel_number":"Zemljišče","Page1::register_number":"Registrska številka","Page1::usage_rules":"Uporabniška navodila","Page2::date_of_delivery_warranty":"Primopredaja","Page2::date_of_delivery_warranty_contract":"Datum predaje, garancije in pogodbe","Page2::exceptions":"Izjeme","Page2::handover_date":"Datum primopredaje","Page2::mortgage":"Hipoteka","Page2::mortgage_detail":"Podrobnosti hipoteke","Page2::notary":"Notar","Page2::vatliable_purchase":"Nakup z DDV","Page3::all_documents_must_have_a_type_set":"Za vsak dokument morate izbrati vrsto dokumenta (klik na ikono kulija).","Page3::choose_a_document_type_or_enter_description":"Izberite vrsto dokumenta in dodajte opis","Page3::document_type":"Vrsta dokumenta","Page3::upload_following_documents":"Prosimo, da naložite sledeče dokukumente","peptype::family":"Družinski član kupca je politično izpostavljena oseba","peptype::no":"Ne","peptype::related":"Ožji znanec/sodelavec kupca je politično izpostavljena oseba ","peptype::yes":"Kupec je politično izpostavljena oseba","person":"Oseba","phone_number":"Mobilna telefonska številka","phone_number_placeholder":"+386 11 222 333","phonenumbererror::invalid":"Telefonska številka ni veljavna","phonenumbererror::notmobile":"Telefonska številka ni mobilna številka","place_of_birth":"Kraj rojstva","politically_exposed_person_pep":"Politično izpostavljena oseba ","post_code":"Poštna številka","postal_code":"Poštna številka","preview":"Predogled","previous":"Prejšnji","previous_round":"Prejšnji krog draženja","price_on_offer":"Cena glede na ponudbo","price_on_request":"Cena na zahtevo","private_person":"Fizična oseba","processing":"V teku","property_for_sale":"Nepremičnina za prodajo","provision":"Provizija kupca","ProvisionAck::i_have_taken_note_of_the_following_important_information":"Upošteval sem naslednje pomembne informacije","provisiontype::default":"Standard","provisiontype::fixed_amount":"Fiksna vrednost (brez DDV)","provisiontype::fixed_percentage":"Odstotek (brez DDV)","provisiontype::none":"Brez provizije","purchase_price":"Nakupna cena","recipient":"Račun","refresh":"Osveži","RefuseDialog::explanation":"Obvesti stranke o razlogu zavrnitve.","RefuseDialog::reason":"Razlog","RefuseDialog::refuse_an_offer":"Zavrni ponudbo","register":"Povabi","registering":"Povabi","RegistrationPanel::already_registered":"Stranko s tem elektronskim naslovom ste že povabili.","RegistrationPanel::offer_viewing":"Ogled je bil izveden dne","RegistrationPanel::place_at":"Prejeto dne","RegistrationPanel::purchase_price_gross":"Nakupna cena (bruto)","RegistrationPanel::register_new_user":"Povabi nove potencialne stranke","RegistrationPanel::send_the_invitation_again":"Ponovno pošlji vabilo","RegistrationPanel::upload_an_offer":"Naloži ponudbo (v imenu stranke)","RegistrationPanel::upload_new_offer":"Naložite novo ponudbo v imenu stranke.","RegistrationPanel::upload_offer":"Naloži ponudbo","RejectSummary::click_finish_to_reject_all_offers":"Če kliknete \"Končaj\", bodo vse ponudbe zavrnjene in stranke bodo o tem obveščene.","remove":"Odstrani sliko","required_documents":"Zahtevani dokumenti","round":"Krog dražbe","RoundEdit::allow_bidding_below_starting_price":"Dovoli ponudbe pod začetno ceno","RoundEdit::allow_bidding_below_starting_price__tooltip":"V postopku odprte ponudbe lahko zainteresirane stranke običajno ponudijo le začetno ceno, kar lahko pomeni, da cenovno občutljivejše stranke pogosto ne oddajo ponudbe. S to možnostjo zainteresiranim strankam ponudite možnost, da oddajo ponudbo <u>pod</u> začetno ceno - vendar nad (sprva skrito) najnižjo ceno, ki jo določi posrednik. Prednost tega je, da ponudbo predloži več zainteresiranih strank, saj so dovoljene tudi ponudbe z nižjo ceno. S tem se ustvari širše polje ponudnikov, kar lahko poveča možnost prodaje. Vse ponudbe, ki so nižje od izhodiščne cene, so skrite pred drugimi zainteresiranimi strankami, da se prepreči negativni učinek sidra. Privzeto so prikazane samo ponudbe z izhodiščno ceno, razen če aktivirate možnost \"Ponudbe pod izhodiščno ceno prikaži drugim ponudnikom\".","RoundEdit::allow_bidding_below_starting_price_hidden":"Dovoli ponudbe pod začetno ceno (skrito)","RoundEdit::antisniping_notice":"Konec ponudbenega obdobja se samodejno podaljša za 15 minut, če v zadnjih 15 minutah pred koncem ponudbe prejmete novo ponudbo. To podaljšanje se ponavlja, dokler ni več ponudb 15 minut.","RoundEdit::bidding_steps":"Minimalno zvišanje ponudbe","RoundEdit::bidding_steps__standard":"Standardno razporejanje korakov ponudb","RoundEdit::bidding_steps__tooltip":"To je najnižji znesek povečanja za nove ponudbe. Vsaka nova ponudba mora biti vsaj za ta znesek višja od trenutne najvišje ponudbe. Če ste izbrali možnost \"Dovoli ponudbe pod najvišjo ponudbo\", se najmanjše povečanje ponudbe nanaša na prejšnjo ponudbo posamezne stranke, če je ta že oddala ponudbo (za dodatne informacije glejte gumb info: \"Dovoli ponudbe pod najvišjo ponudbo\")","RoundEdit::bidding_type_tooltip":"Izberite vrsto ponudbe","RoundEdit::counteroffer_value":"Predlagana vrednost nasprotne ponudbe","RoundEdit::end_date_changed":"Vsi povabljeni kupci in posredniki bodo obveščeni o spremembi/zaključku postopka preko elektronske pošte.","RoundEdit::ends_at":"Konec postopka zbiranja ponudb","RoundEdit::ends_at__tooltip":"Za zaključek postopka zbiranja ponudb priporočamo, da izberete čas, ko so zainteresirane stranke na voljo in v prostoru z dobro internetno povezavo (npr. doma). Izkušnje so pokazale, da se pri tem zelo dobro obnesejo zgodnji večeri ali vikendi. Vendar upoštevajte državne praznike ali podaljšane vikende, ko zainteresiranih strank morda ni doma. Prav tako je pomembno, da zainteresirane stranke obvestite o urniku. Ob koncu razpisnega obdobja bodo povabljenim zainteresiranim strankam poslani opomniki 72 ur, 24 ur in 60 minut pred predvidenim koncem. Priporočamo tudi, da ste kot agent zadnjo uro pred koncem licitacijskega postopka na voljo po telefonu in po potrebi licitacijski postopek spremljate v živo na svojem prenosnem računalniku ali tabličnem računalniku, tako da lahko zainteresiranim strankam pomagate pri morebitnih vprašanjih ali težavah (npr. slaba internetna povezava zainteresirane stranke).","RoundEdit::estimate":"Okvirna cena","RoundEdit::estimate__tooltip":"Okvirna cena je predlagana cena, ki se sporoči potencialnemu kupcu in velja kot vodilo, ki kupcu pomaga določiti lastno ponudbeno ceno. Pomembno: okvirna cena ne predstavlja minimalne cene; torej lahko kupec odda ponudbo pod okvirno ceno.\n","RoundEdit::estimate_lower_than_startprice":"Okvirna cena ne sme biti nižja od minimalne cene.","RoundEdit::flexible_bidding":"Dovoli ponudbe pod najvišjo ponudbo","RoundEdit::flexible_bidding__tooltip":"V postopku odprte ponudbe morajo zainteresirane stranke z vsako novo ponudbo običajno predložiti novo najvišjo ponudbo, zaradi česar lahko posamezne zainteresirane stranke predčasno odstopijo ali morda sploh ne oddajo ponudbe. Z izbiro te prožne možnosti oddajanja ponudb ima zainteresirana stranka možnost predložiti ponudbo <u>pod</u> trenutno najvišjo ponudbo. Vendar mora biti nova ponudba <u>nad</u> prejšnjo ponudbeno ceno ustrezne stranke, če je ta že oddala ponudbo. Pri tem je odločilen minimalni prirastek ponudbe, ki se uporablja samo <b>za njihovo lastno ponudbo</b>. Prednost te možnosti licitiranja je, da posamezne zainteresirane stranke pogosteje licitirajo in da se ustvari močnejše srednje polje, saj ponudniki ne odstopijo predčasno. To lahko poveča možnosti za prodajo, zlasti če je zainteresiranih strank le nekaj ali če je začetna cena nekoliko previsoka.","RoundEdit::hide_highest_bid__bid_history_for_nonbidders":"Druge ponudbe prikaži šele po oddaji lastne ponudbe","RoundEdit::hide_highest_bid__bid_history_for_nonbidders__tooltip":"Zaradi preglednosti so trenutna najvišja ponudba in vse oddane ponudbe za nakup običajno prikazane vsem povabljenim v odprtem postopku že od samega začetka - še preden sami oddajo ponudbo. V posameznih primerih lahko to privede do tega, da posamezni interesenti, ki jih odvrnejo že tako visoke ponudbene cene, sploh ne oddajo ponudbe, čeprav bi jo radi dali, da bi se temu izognili in motivirali vse, ki bi bili pripravljeni kupiti, da oddate tudi ponudbo za nakup, je ta možnost ponujanja lahko v pomoč.","RoundEdit::invalid_starting_price":"Prosimo, vnesite veljavno začetno ceno","RoundEdit::min_price":"Najmanjša cena","RoundEdit::min_price__tooltip":"Najnižja nakupna cena, ki jo mora ponuditi zainteresirana stranka. Prikazano samo, če zainteresirana stranka želi dati ponudbo pod to ceno.","RoundEdit::min_price_lower_than_start":"Najnižja cena mora biti nižja od začetne cene","RoundEdit::minimum_price":"Minimalna cena","RoundEdit::offer_validity":"Veljavnost ponudb","RoundEdit::open_round_warning":"V odprtem postopku zbiranja ponudb je predviden samo en krog dražbe in vsi sodelujoči vidijo ponudbe.","RoundEdit::please_enter_a_starting_price":"Prosimo vnesite ceno >0","RoundEdit::red_button_price":"Cena rdečega gumba","RoundEdit::red_button_price__tooltip":"To je (predvidena) najnižja cena, po kateri je lastnik pripravljen prodati nepremičnino.  Ta cena je interne narave in ni sporočena potencialnim kupcem ter je vidna samo nepremičninskem posredniku. Ko se doseže cena rdečega gumba, je posrednik takoj obveščen.","RoundEdit::select_a_bidding_type":"Izberi vrsto postopka oddaje ponudb","RoundEdit::show_bids_below_starting_price":"Prikaži ponudbe pod začetno ceno drugim ponudnikom","RoundEdit::show_bids_below_starting_price__tooltip":"Privzeto so prikazane samo ponudbe <u>od</u> začetne cene, razen če ne aktivirate te možnosti. Takrat se prikažejo tudi ponudbe <u>pod</u> izhodiščno ceno in povečate preglednost postopka ponudbe.","RoundEdit::simple_offer_duration_suggestion_notice":"To je predlagana začasna veljavnost ponudb za nakup. Vendar pa lahko bodoči kupec to spremeni, ko odda svojo ponudbo","RoundEdit::start":"Začetek postopka zbiranja ponudb","RoundEdit::start__tooltip":"Če povabite zainteresirane stranke <u>pred začetkom</u> ponudbenega postopka (ponudbenega obdobja), lahko že vnesejo svoje podatke, si ogledajo dokumente o nepremičnini in <u>pripravijo</u> ponudbo. Vendar ponudbe še ni mogoče oddati! Takoj ko je dosežen čas začetka in se je začelo obdobje za oddajo ponudb v ponudbenem postopku, bodo vse povabljene zainteresirane stranke prejele obvestilo in lahko nato začnejo oddajati svoje ponudbe za nakup.<br /><br />Nasvet: Povprečna dolžina ponudbenega postopka, tj. obdobja, v katerem je mogoče oddati ponudbe (obdobje za oddajo ponudb), je približno 5-7 dni. To ustvari zadosten zagon in hkrati zagotavlja, da posamezni interesenti ne izgubijo zanimanja za nepremičnino (kar se lahko zgodi, če je ponudbeno obdobje predolgo). Vendar obdobje 5-7 dni predpostavlja tudi, da ste vse zainteresirane stranke kot posrednik že dovolj predhodno usposobili na začetku ponudbenega postopka, vključno z ogledom nepremičnine in pojasnitvijo možnosti financiranja. Če pa je financiranje za večino zainteresiranih strank še vedno nejasno in zato pri povabilu zainteresiranim strankam izberete možnost \"potrditev financiranja\", potem morate izbrati tudi nekoliko daljše trajanje ponudbenega postopka, da bodo imele zainteresirane stranke dovolj časa za razjasnitev financiranja med potekom postopka. Če imate dodatna vprašanja, se lahko obrnete na našo ekipo.","RoundEdit::starting_price":"Izklicna cena","RoundEdit::starting_price__tooltip":"Minimalna cena, ki jo mora potencialni kupec ponuditi pri predložitvi prve ponudbe.","RoundEdit::time_of_day":"Čas v dnevu","RoundInfo::ends":"Postopek zbiranja ponudb se konča","RoundInfo::offer_validity":"Veljavnost ponudb","RoundInfo::starts":"Postopek zbiranja ponudb se začne","RoundItem::incremental_auction_howitworkspoints":"- Odprite ponudbe od začetne cene\n- Možno je več ponudb\n- Samodejno podaljšanje za ponudbe v zadnjem trenutku\n<b>Nove prilagodljive možnosti ponudb:</b>\n- Možnost dovoljene ponudbe <u >pod začetno ceno</u>\n- Višina ponudbe <u>prosto izbrana</u> (nad najnižjo ceno)\n- Prikazane so samo ponudbe nad začetno ceno\n- Fiksni začetni in končni datum ","RoundItem::incremental_auction_subtitle":"s prilagodljivimi ponudbami","RoundItem::incremental_auction_title":"Postopek odprte ponudbe","RoundItem::incremental_auction_whentouseitpoints":"Kot običajni \"odprti\" postopek zbiranja ponudb, vendar tudi, če:\n- Manjše povpraševanje\n- Stranke, občutljive na ceno\n- Začetna cena je manj privlačna\n- Zvišanje cene ni jasno\n- Dajte strankam več prilagodljivost","RoundItem::open_bidding_howitworkspoints":"- Prvi dražitelj mora ponuditi vsaj začetno ceno\n- Vsaka ponudba <b>mora biti višja od vseh prejšnjih ponudb</b>\n- Vsaka stranka lahko izboljša svojo ponudbo\n- Vse < b>Ponudbe so vidne</b>\n- Imena strank so anonimizirana za druge stranke\n- Ekspliciten začetek in konec postopka","RoundItem::open_bidding_subtitle":"z naraščajočimi ponudbami","RoundItem::open_bidding_title":"Odprti postopek ponudb","RoundItem::open_bidding_whentouseitpoints":"- Privlačna začetna cena\n- Veliko povpraševanje\n- Tržna vrednost nepremičnine je višja od začetne cene\n- Pričakuje se zvišanje cene","RoundItem::sealed_bidding_howitworkspoints":"- Orientacijska cena brez najnižje cene\n- Višina ponudbe je poljubno izbrana</u> \n- Vsaka stranka lahko odda samo <u>eno</u> ponudbo\n- Ponudniki in ponudbe <u>skrit</u>\n- Fiksni končni datum\n- <u>Brez</u> samodejnega podaljšanja za ponudbe v zadnjem trenutku","RoundItem::sealed_bidding_subtitle":"s skritimi ponudbami","RoundItem::sealed_bidding_title":"Zaprt postopek ponudb","RoundItem::sealed_bidding_whentouseitpoints":"- Nizko/nejasno povpraševanje\n- Pridobite povratne informacije s trga\n- Zaupna prodaja, javni sektor\n- Nepremičnine je težko oceniti","RoundItem::simple_offer_howitworkspoints":"- Preprosta oddaja digitalne ponudbe\n- Cena na seznamu = referenca\n- Ponudbena cena je <u>brezplačna</u> izbrana\n- Stranka lahko odda samo <u>eno</u> ponudbo \n- Ni podatkov o morebitnih drugih interesentih\n- Ni določenega končnega datuma\n- Možnost fleksibilnega prehoda na postopek odprte ponudbe, če ponudbe odda več strank","RoundItem::simple_offer_subtitle":" ","RoundItem::simple_offer_title":"Ponudba za digitalni nakup","RoundItem::simple_offer_whentouseitpoints":"- Malo interesentov\n- Dolg prodajni proces\n- Test pripravljenosti za nakup\n- Možnost oddaje ponudbe pod rezervacijo","RoundItem::when_to_use_it":"Kdaj bo uporabljen","RoundPanel::round":"Uredi krog dražbe","roundstatus::closed":"Zaprt","roundstatus::opened":"Odprti","roundstatus::started":"Nov","roundtype::counteroffer_bidding":"Protiponudba","roundtype::incremental_auction":"Odprti postopek zbiranja ponudb","roundtype::open_bidding":"Odprti postopek zbiranja ponudb","roundtype::sealed_bidding":"Zaprti postopek zbiranja ponudb","roundtype::show_invited_customers_count":"Prikaži število zainteresiranih strank","roundtype::show_invited_customers_count_tooltip":"Skupno število vseh povabljenih potencialnih kupcev se prikaže vsaki sodelujoči stranki.","Sale::all_information_entered_by_customer_will_be_overwritten":"Vse informacije, ki jih je stranka že dala, bodo izbrisane/zamenjane.","Sale::already_confirmed":"Ta stranka je že oddala svojo ponudbo. Predložitev druge ponudbe v imenu te stranke ni mogoča.","Sale::cannot_update_documents_for_open_round__documents_uploaded":"Naloženi so naslednji dokumenti:","Sale::cannot_update_documents_for_open_round__no_documents":"Naloženi so naslednji dokumenti: Niste naložili nobenega dokumenta.","Sale::do_you_want_to_open_the_round":"Želite začeti krog dražbe?","Sale::guide__define_offer_form":"V prvem koraku vnesite vse podatke o nepremičnini.","Sale::guide__edit_round":"Če podatki o krogu dražbe niso pravilni, jih prilagodite","Sale::guide__import_users_csv":"Uvozi kontakte iz CSV datoteke","Sale::guide__invite_users":"Da pošljete vabilo zainteresiranim strankam, potrebujete njihovo ime, elektronski naslov in telefonsko številko.","Sale::guide__missing_mandatory_offer_form":"Prosimo, izpolnite zahtevana polja!","Sale::guide__open_round":"Če želite javno odpreti postopek zbiranja ponudb in poslati vabilo posameznim strankam, morate odpreti krog dražbe.","Sale::guide__start_round":"Sedaj izberite način izvedbe elektronske dražbe.","Sale::guide__start_round_edit_sale":"Izpolnili ste vsa obvezna polja v obrazcu ponudbe. Tukaj jih lahko pregledate ali uredite.","Sale::guide_action__edit_round":"Prilagodi","Sale::guide_action__edit_sale":"Pripravi obrazec za oddajo ponudbe","Sale::guide_action__import_users_csv":"Uvozi kontakte","Sale::guide_action__invite_bidders":"Povabi novo stranko","Sale::guide_action__open_round":"Krog dražbe","Sale::guide_action__start_round":"Pripravi nov krog dražbe","Sale::guide_action__start_round_edit":"Uredi obrazec ponudbe","Sale::guides__manage_the_sale":"Čarovnik za prodajo","Sale::guides__round_closed":"Ta krog dražbe se je zaključil. Pripravite lahko pregled ponudb za prodajalca in vnesete rezultate.","Sale::guides__show_overview":"Pregled","Sale::invalid_bid_value":"Ta ponudba ne more biti sprejeta, saj obstaja enaka ali višja ponudba. Prosim obvestite kupca, da lahko svojo ponudbo prilagodi.","Sale::loading_sale":"Nepremičnina se nalaga","Sale::no_estimate":"brez okvirne cene","Sale::no_starting_price":"brez začetne cene","Sale::open_round_deadline_today":"Vaš krog se bo predvidoma končal danes. Ali res želite odpreti krog?","Sale::open_round_deadline_too_long":"Vaš krog se bo končal čez {durationInDays} dni? Ali ste prepričani, da želite odpreti krog?","Sale::open_round_info_invalid_duration":"Ne morete odpreti kroga, ki bi se moral končati v preteklosti. Prosimo, uredite podrobnosti kroga.","Sale::open_round_info_notice_incremental_auction_fixed":"Odprete <strong>odprti krog</strong> z <strong>začetno ceno {startPrice}</strong> in <strong>{duration}</strong> dne {date} močno konča se <strong>ob {time}.</strong>","Sale::open_round_info_notice_incremental_auction_fixed_withstart":"Odprete <strong>odprti krog </strong> z <strong>začetno ceno {startPrice}</strong> in začetkom ponudb <strong>{start}</strong> dne <strong>{startDate} ob {startTime}</strong>, ki se konča <strong>{date} ob {time}</strong> <strong>{biddingDuration}</strong>.","Sale::open_round_info_notice_incremental_auction_flexible":"Odprete <strong>fleksibilni</strong> krog z <strong>začetno ceno {startPrice}</strong> <strong>{duration} dni</strong> po prejemu prva ponudba se konča.</strong>","Sale::open_round_info_notice_openbidding_fixed":"Začeli boste s postopkom <strong>odprtega</strong> kroga dražbe z <strong>izklicno ceno {startPrice}</strong>, ki se zaključi: V <strong>{date} ob {time}</strong>.","Sale::open_round_info_notice_openbidding_fixed_withstart":"Začeli boste s postopkom <strong>odprtega</strong> kroga dražbe z <strong>izklicno ceno {startPrice}</strong>, ki se začne <strong>{start}</strong> dne <strong>{startDate} ob {startTime}</strong> in se konča <strong>{duration}</strong> dne <strong>{date} ob {time}</strong>, v katerem bo ponudba trajala <strong>{biddingDuration}</strong>.","Sale::open_round_info_notice_openbidding_flexible":"Začeli boste s postopkom <strong>odprtega</strong> kroga dražbe z <strong> izklicno ceno {startPrice}</strong>, ki se zaključi <strong>čez {duration} dni</strong> po prejeti prvi ponudbi.","Sale::open_round_info_notice_sealedbidding_fixed":"Začeli boste s postopkom <strong>zaprtega</strong> tipa oddaje ponudb z <strong> okvirno ceno {estimate}</strong>, ki se zaključi: V <strong>{date} ob {time}</strong>.","Sale::open_round_info_notice_sealedbidding_fixed_withstart":"Začeli boste s postopkom <strong>zaprtega</strong> tipa oddaje ponudb z <strong> okvirno ceno {estimate}</strong>, ki se začne <strong>{start}</strong> dne <strong>{startDate} ob {startTime}</strong> in se konča <strong>{duration}</strong> dne <strong>{date} ob {time}</strong>, v katerem bo ponudba trajala <strong>{biddingDuration}</strong>.","Sale::open_round_info_notice_sealedbidding_flexible":"Začeli boste s postopkom <strong>zaprtega</strong> tipa oddaje ponudb z<strong> okvirno ceno {estimate}</strong>, ki se zaključi <strong>čez {duration} dni </strong>po prvi prejeti ponudbi.","Sale::open_round_info_notice_simple_offer_fixed":"Odpirate <strong>Krog ponudbe za digitalni nakup</strong>.","Sale::open_round_info_notice_simple_offer_flexible":"Odpirate <strong>Krog ponudbe za digitalni nakup</strong>.","Sale::sale_connection_unavailable":"Povezava s tem postopkom zbiranja ponudb je prekinjena. Prosimo, osvežite stran.","Sale::sale_not_found":"Tega postopka zbiranja ponudb ni bilo mogoče najti.","Sale::you_are_about_to_upload_offer_in_the_name_of_customer":"Nakupno ponudbo oddajate v imenu stranke. Ta stranka preko spleta več ne more oddati svoje ponudbe za nakup. Pomembno je, da ohranite prvotni obrazec ponudbe!","SaleCreatePanel::agbs":"pogoje uporabe","SaleCreatePanel::create_new_listing":"Kreiraj nov oglas","SaleCreatePanel::i_agree_to_the_link":"Strinjam se s {agbs}","SaleCreatePanel::i_agree_with_terms_and_conditions":"Strinjam se s pogoji in pravili","SaleCreatePanel::image":"Naslovna fotografija nepremičnine","SaleCreatePanel::number":"ID nepremičnine","SaleCreatePanel::price":"Izklicna cena","SaleCreatePanel::title":"Naziv nepremičnine","salepropertytype::business":"Poslovni prostor","salepropertytype::flat":"Stanovanje","salepropertytype::house":"Hiša","salepropertytype::mixed":"Stanovanjska in poslovna stavba","salepropertytype::office":"Poslovna stavba","salepropertytype::property":"Zemljišče","SaleWizard::accept_tc_title":"Sprejmi pogoje","SaleWizard::action_functionality":"Ta funkcija omogoča sledeče možnosti:","SaleWizard::award":"Ko je prodajalec sprejel kupčevo ponudbo, lahko kupca o tem obvestite tekom elektronske pošte in SMS sporočila. Obvestilo lahko prav tako pošljete ponudnikom, katerih ponudbe so bile zavrnjene. Ti ponudniki bodo izključeni iz nadaljnjega postopka. Vsi drugi ponudniki; torej ti, ki niso bili izbrani in niso bili zavrnjeni, ostajajo v postopku kot \"nadomestni kupci\" do dokončne prodaje.","SaleWizard::award_subtitle":"To funkcijo uporabite, če imate izbranega najprimernejšega kupca in kljub temu želite ohraniti preostale kupce kot “rezervo” v primeru, da posel z izbranim kupcem ne bo realiziran.","SaleWizard::award_title":"Izberite najprimernejšega kupca","SaleWizard::choose_a_winner_title":"Izberi zmagovalca","SaleWizard::choose_offers_for_next_round_title":"Izberi ponudbe","SaleWizard::choose_offers_to_reject_title":"Zavrnitve","SaleWizard::confirmaward":"Kupca lahko potrdite po uspešno zaključeni prodaji. Vsi preostali potencialni kupci so samodejno obveščeni o zaključku prodaje in njihove ponudbe so dokončno zavrnjene. Postopek ponudbe je končan.","SaleWizard::confirmaward_subtitle":"Uporabite to funkcijo, takoj ko želite potrditi končnega kupca","SaleWizard::confirmaward_title":"Potrdi končnega kupca","SaleWizard::counteroffer":"Uporabite to funkcijo, če želite dati protiponudbo enemu izmed potencialnih kupcev. Ko kupec sprejme vrednost protiponudbe, je potrjen kot kupec in je ponudba s strani prodajalca zavezujoča.\nIzberete lahko enega kupca, ki je že predložil ponudbo. \nDoločite vrednost protiponudbe in rok, do katerega se mora kupec odločiti. \nKupec lahko:  \n- Sprejme vrednost protiponudbe in nato takoj postane izbran kupec.\n- Lahko odda ponudbo, ki je  višja od njegove prejšnje ponudbe, vendar nižja od nasprotne ponudbe, kar pomeni, da se krog draženja zapre in se po tem naprej dogovarjate s prodajalcem.\n- Ne naredi nič in v tem primeru se krog dražbe zaključi kot je planirano.","SaleWizard::counteroffer_title":"Protiponudba","SaleWizard::duplicate":"Vsi podatki in dokumenti, ki pripadajo nepremičnini, so shranjeni in avtomatsko preneseni. Uredite in spremenite lahko dodatne informacije, določite parametre dražbe, odprete novi krog dražbe in povabite potencialne kupce.","SaleWizard::duplicate_subtitle":"Uporabite to funkcijo, če želite začeti z novim postopkom zbiranja ponudb za to nepremičnino.","SaleWizard::duplicate_title":"Začni z novim postopkom zbiranja ponudb.","SaleWizard::increase":"Lahko začnete nov krog dražb (z novo referenčno ceno) z namenom, da dosežete višjo ceno. Vsi (ali izbrani) dražitelji v predhodnem krogu dražb lahko sodelujejo in višajo svoje obstoječe ponudbe; o tem bodo avtomatsko obveščeni.\nDodatno lahko v nov krog povabite nove dražitelje. \nVsi dražitelji iz predhodnega kroga, ki niso bili povabljeni v novi krog, bodo avtomatsko obveščeni o zavrnitvi njihove ponudbe.","SaleWizard::increase_subtitle":"To funkcijo uporabite, če želite potencialnim kupcem ponuditi možnost, da povečajo svojo ponudbo.","SaleWizard::increase_title":"Začnite še en krog dražb.","SaleWizard::message_to_buyers_title":"Dodatno sporočilo","SaleWizard::message_to_winner_title":"Dodatno sporočilo","SaleWizard::next_round_details_title":"Naslednji krog dražbe","SaleWizard::rejectall":"Vsi potencialni kupci, ki so oddali ponudbo bodo obveščeni o negativni odločitvi prodajalca. Postopek ponudbe je končan.","SaleWizard::rejectall_subtitle":"To funkcijo uporabite, če prodajalec ne želi sprejeti nobene ponudbe in ne želi nadaljevati z postopkom zbiranja ponudb.","SaleWizard::rejectall_title":"Zavrni vse ponudbe","SaleWizard::results_title":"Potrditev","SaleWizard::review_title":"Povzetek","SaleWizard::sale_wizard":"Čarovnik za prodajo","SaleWizard::select_action_title":"Kako želite nadaljevati?","SaleWizardResult::back_to_sale":"Nazaj v postopek zbiranja ponudb","SaleWizardResult::confirmation":"Potrditev","SaleWizardResult::continue_to_the_duplicated_sale":"Nadaljuj vse do podvojene prodaje","SaleWizardResult::successful":"Prejeli smo vaš vnos, ki bo v roku minute viden v sistemu.","SaleWizardRoundInfo::ends":"Postopek zbiranja ponudb se zaključi","SaleWizardRoundInfo::estimate":"Okvirna cena","SaleWizardRoundInfo::minimum_price":"Minimalna cena","SaleWizardRoundInfo::offer_validity":"Ponudba za nakup je veljavna","SaleWizardRoundInfo::red_button_price":"Cena rdečega gumba","SaleWizardRoundInfo::start_price":"Izklicna cena","salutation":"Nagovor","salutation::miss":"Ga.","salutation::mr":"G.","salutation::mrs":"Ga.","salutation::ms":"Ga.","save":"Shrani","Search::add_new_listing":"Dodaj novo nepremičnino","Search::address":"Naslov","Search::agbs":"pogoje uporabe","Search::area":"Območje","Search::create_new_listing":"Ustvari novo nepremičnino","Search::creating":"Ustvarjanje","Search::error_loading_objects":"Napaka pri nalaganju predmeta","Search::error_retrieving_file":"Napaka pri pridobivanju oz. shranjevanju datoteke","Search::guide_no_objects":"Izgleda, da ta trenutek nimate aktivnih predmetov","Search::i_agree_to_the_link":"Strinjam se s {agbs}","Search::i_agree_with_terms_and_conditions":"Strinjam se s pogoji in pravili","Search::loading_details":"Nalaganja podrobnih informacij","Search::loading_properties":"Nalaganje nepremičnin","Search::my_listings_overview":"Na moj postopek zbiranja ponudb","Search::number":"Objekt št.","Search::price":"Cena","Search::this_object_is_already_active":"Za to nepremičnino je že odprt postopek zbiranja ponudb v Max dražbi","seller":"Prodajalec","send":"Pošlji","sms":"SMS","sms_failed":"SMS obvestila ni bilo mogoče dostaviti","start_new_sale":"Začnite novo prodajo","start_new_test_sale":"Začnite novo testno prodajo","status":"Status","street":"Ulica","street_and_house_number":"Ulica in hišna številka","submit":"Potrdi","submitted_on":"Potrjeno dne","submitted_value":"Vrednost ponudbe","summary":"Povzetek","template::cust_message":"Splošno sporočilo","test_sale_explanation":"Uporabite preskusni postopek, če želite interno preizkusiti postopek ponudbe. Ta postopek ni izračunan. V proces ne vabite zunanjih resničnih strank. Vse strani in obvestila so označena kot \"Test\".","test_sale_watermark":"Testna prodaja","this_action_cannot_be_undone":"Ta aktivnost ne more biti razveljavljena.","title":"Naziv","title::doctor":"Dr.","title::master":"Mag.","title::professor":"Dipl.","type_of_property":"Vrsta nepremičnine","updated_on":"Posodobljeno dne","upload":"Naloži","upload_more":"Naloži več","uploading":"Nalaganje","uploads":"Nalaganja","uploadtype::identification_document":"Identifikacijski dokumenti","uploadtype::misc":"Razno","value_must_be_between_min_and_max":"Vrednost mora znašati med {min} in {max}","would_you_like_to_continue":"Želite nadaljevati?","yes":"Da","zip_code":"Poštna številka"}

/***/ }),
/* 899 */
/***/ (function(module, exports) {

module.exports = {"AF":"Afghanistan","AX":"Åland Islands","AL":"Albania","DZ":"Algeria","AS":"American Samoa","AD":"Andorra","AO":"Angola","AI":"Anguilla","AQ":"Antarctica","AG":"Antigua & Barbuda","AR":"Argentina","AM":"Armenia","AW":"Aruba","AC":"Ascension Island","AU":"Australia","AT":"Austria","AZ":"Azerbaijan","BS":"Bahamas","BH":"Bahrain","BD":"Bangladesh","BB":"Barbados","BY":"Belarus","BE":"Belgium","BZ":"Belize","BJ":"Benin","BM":"Bermuda","BT":"Bhutan","BO":"Bolivia","BA":"Bosnia & Herzegovina","BW":"Botswana","BR":"Brazil","IO":"British Indian Ocean Territory","VG":"British Virgin Islands","BN":"Brunei","BG":"Bulgaria","BF":"Burkina Faso","BI":"Burundi","KH":"Cambodia","CM":"Cameroon","CA":"Canada","IC":"Canary Islands","CV":"Cape Verde","BQ":"Caribbean Netherlands","KY":"Cayman Islands","CF":"Central African Republic","EA":"Ceuta & Melilla","TD":"Chad","CL":"Chile","CN":"China","CX":"Christmas Island","CC":"Cocos (Keeling) Islands","CO":"Colombia","KM":"Comoros","CG":"Congo - Brazzaville","CD":"Congo - Kinshasa","CK":"Cook Islands","CR":"Costa Rica","CI":"Côte d’Ivoire","HR":"Croatia","CU":"Cuba","CW":"Curaçao","CY":"Cyprus","CZ":"Czech Republic","DK":"Denmark","DG":"Diego Garcia","DJ":"Djibouti","DM":"Dominica","DO":"Dominican Republic","EC":"Ecuador","EG":"Egypt","SV":"El Salvador","GQ":"Equatorial Guinea","ER":"Eritrea","EE":"Estonia","ET":"Ethiopia","FK":"Falkland Islands","FO":"Faroe Islands","FJ":"Fiji","FI":"Finland","FR":"France","GF":"French Guiana","PF":"French Polynesia","TF":"French Southern Territories","GA":"Gabon","GM":"Gambia","GE":"Georgia","DE":"Germany","GH":"Ghana","GI":"Gibraltar","GR":"Greece","GL":"Greenland","GD":"Grenada","GP":"Guadeloupe","GU":"Guam","GT":"Guatemala","GG":"Guernsey","GN":"Guinea","GW":"Guinea-Bissau","GY":"Guyana","HT":"Haiti","HN":"Honduras","HK":"Hong Kong SAR China","HU":"Hungary","IS":"Iceland","IN":"India","ID":"Indonesia","IR":"Iran","IQ":"Iraq","IE":"Ireland","IM":"Isle of Man","IL":"Israel","IT":"Italy","JM":"Jamaica","JP":"Japan","JE":"Jersey","JO":"Jordan","KZ":"Kazakhstan","KE":"Kenya","KI":"Kiribati","XK":"Kosovo","KW":"Kuwait","KG":"Kyrgyzstan","LA":"Laos","LV":"Latvia","LB":"Lebanon","LS":"Lesotho","LR":"Liberia","LY":"Libya","LI":"Liechtenstein","LT":"Lithuania","LU":"Luxembourg","MO":"Macau SAR China","MK":"Macedonia","MG":"Madagascar","MW":"Malawi","MY":"Malaysia","MV":"Maldives","ML":"Mali","MT":"Malta","MH":"Marshall Islands","MQ":"Martinique","MR":"Mauritania","MU":"Mauritius","YT":"Mayotte","MX":"Mexico","FM":"Micronesia","MD":"Moldova","MC":"Monaco","MN":"Mongolia","ME":"Montenegro","MS":"Montserrat","MA":"Morocco","MZ":"Mozambique","MM":"Myanmar (Burma)","NA":"Namibia","NR":"Nauru","NP":"Nepal","NL":"Netherlands","NC":"New Caledonia","NZ":"New Zealand","NI":"Nicaragua","NE":"Niger","NG":"Nigeria","NU":"Niue","NF":"Norfolk Island","KP":"North Korea","MP":"Northern Mariana Islands","NO":"Norway","OM":"Oman","PK":"Pakistan","PW":"Palau","PS":"Palestinian Territories","PA":"Panama","PG":"Papua New Guinea","PY":"Paraguay","PE":"Peru","PH":"Philippines","PN":"Pitcairn Islands","PL":"Poland","PT":"Portugal","PR":"Puerto Rico","QA":"Qatar","RE":"Réunion","RO":"Romania","RU":"Russia","RW":"Rwanda","WS":"Samoa","SM":"San Marino","ST":"São Tomé & Príncipe","SA":"Saudi Arabia","SN":"Senegal","RS":"Serbia","SC":"Seychelles","SL":"Sierra Leone","SG":"Singapore","SX":"Sint Maarten","SK":"Slovakia","SI":"Slovenia","SB":"Solomon Islands","SO":"Somalia","ZA":"South Africa","GS":"South Georgia & South Sandwich Islands","KR":"South Korea","SS":"South Sudan","ES":"Spain","LK":"Sri Lanka","BL":"St. Barthélemy","SH":"St. Helena","KN":"St. Kitts & Nevis","LC":"St. Lucia","MF":"St. Martin","PM":"St. Pierre & Miquelon","VC":"St. Vincent & Grenadines","SD":"Sudan","SR":"Suriname","SJ":"Svalbard & Jan Mayen","SZ":"Swaziland","SE":"Sweden","CH":"Switzerland","SY":"Syria","TW":"Taiwan","TJ":"Tajikistan","TZ":"Tanzania","TH":"Thailand","TL":"Timor-Leste","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trinidad & Tobago","TA":"Tristan da Cunha","TN":"Tunisia","TR":"Turkey","TM":"Turkmenistan","TC":"Turks & Caicos Islands","TV":"Tuvalu","UM":"U.S. Outlying Islands","VI":"U.S. Virgin Islands","UG":"Uganda","UA":"Ukraine","AE":"United Arab Emirates","GB":"United Kingdom","US":"United States","UY":"Uruguay","UZ":"Uzbekistan","VU":"Vanuatu","VA":"Vatican City","VE":"Venezuela","VN":"Vietnam","WF":"Wallis & Futuna","EH":"Western Sahara","YE":"Yemen","ZM":"Zambia","ZW":"Zimbabwe"}

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_moment_timezone__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_moment_timezone__);
var _class;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BaseSaleFormComponent=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["e" /* observer */])(_class=function(_Component){_inherits(BaseSaleFormComponent,_Component);function BaseSaleFormComponent(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BaseSaleFormComponent);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BaseSaleFormComponent.__proto__||Object.getPrototypeOf(BaseSaleFormComponent)).call.apply(_ref,[this].concat(args))),_this),_this.handleValidation=function(value){var _this$props=_this.props,t=_this$props.t,isRoundStarted=_this$props.isRoundStarted;if(isRoundStarted&&!value){return t('Fill required fields');}return'';},_this.getFieldName=function(field){return''+_this.fieldPrefix+field;},_this.handleChanged=function(field){return function(value){var offerData=_this.props.offerData;offerData[field]=value;};},_this.handleChange=function(field){return function(ev,value){var offerData=_this.props.offerData;offerData[field]=value;};},_this.handleChangedPair=function(field,value){var offerData=_this.props.offerData;offerData[field]=value;},_this.handleChangedOptionKey=function(field){return function(option,index,value){var offerData=_this.props.offerData;if(option)offerData[field]=option.key;else offerData[field]=value;};},_this.handleChangeOptionKey=function(field){return function(ev,option,index,value){var offerData=_this.props.offerData;if(option)offerData[field]=option.key;else offerData[field]=value;};},_this.handleChangeOptionKeyAndCleanWhenEmpty=function(field,fieldsToClean){return function(ev,option,index,value){var offerData=_this.props.offerData;var v=!!option?option.key:value;offerData[field]=v;if(!!fieldsToClean&&(!v||v==='none')){fieldsToClean.forEach(function(f){offerData[f]='';});}};},_this.handleToggleChanged=function(field){return function(_,value){var offerData=_this.props.offerData;offerData[field]=value;};},_this.handleChangeMultiOptionKey=function(field){return function(ev,option){var offerData=_this.props.offerData;var items=[].concat(_toConsumableArray(offerData[field]));if(option.selected){items.push(option.key);}else{var currIndex=items.indexOf(option.key);if(currIndex>-1){items.splice(currIndex,1);}}offerData[field]=items;};},_this.handleChangedOptionText=function(field){return function(option,index,value){var offerData=_this.props.offerData;if(option){offerData[field]=option.text;}else if(value){offerData[field]=value;}};},_this.handleChangedEnum=function(field){return function(item){var offerData=_this.props.offerData;offerData[field]=item.key;};},_this.handleChangedBool=function(field){return function(ev,checked){var offerData=_this.props.offerData;offerData[field]=checked;};},_this.handleArrayItemChanged=function(array,index,field){return function(value){var offerData=_this.props.offerData;offerData[array][index][field]=value;};},_this.handleDateChanged=function(field){return function(value){var offerData=_this.props.offerData;value=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_moment_timezone___default()(value).hour(12).minute(0).toDate();offerData[field]=value;};},_this.handleTimeChange=function(field){return function(ev,option){var offerData=_this.props.offerData;var duration=option.key;var h=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_moment_timezone___default.a.duration(duration,'minutes').hours();var m=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_moment_timezone___default.a.duration(duration,'minutes').minutes();offerData[field]=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_moment_timezone___default()(offerData[field]).hour(h).minute(m).toDate();};},_this.handleChangedDate=function(field){return function(value){var offerData=_this.props.offerData;if(value)value=value.toFormatedDateString('DD.MM.YYYY');offerData[field]=value;};},_this.handleCountryChange=function(field){return function(ev,option,index,value){var offerData=_this.props.offerData;offerData[field]=option.text;offerData[field+'_code']=option.key;};},_this.renderFormatedDate=function(date){return new Date(date).toFormatedDateString('L');},_this.parseDateFromString=function(value){return!!value?__WEBPACK_IMPORTED_MODULE_2__build_node_modules_moment_timezone___default()(value,'L').toDate():value;},_temp),_possibleConstructorReturn(_this,_ret);}return BaseSaleFormComponent;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]))||_class;/* harmony default export */ __webpack_exports__["a"] = (BaseSaleFormComponent);

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_localized_countries__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_localized_countries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_localized_countries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_localized_countries_data_de__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_localized_countries_data_de___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_localized_countries_data_de__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_moment_timezone__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_moment_timezone__);
var env="production";var countries=__WEBPACK_IMPORTED_MODULE_0__build_node_modules_localized_countries___default()(env==='test'?'de':__WEBPACK_IMPORTED_MODULE_1__build_node_modules_localized_countries_data_de___default.a);/* harmony default export */ __webpack_exports__["a"] = ({localeCodes:['de'],currency:{code:'EUR',symbol:'€'},saleCommands:['whitelisting','edit','preview','previewPdf','delete','close','overview','download','manage','notifications','settings','messaging','inviteSeller'],roundCommands:['bidding-history','start','edit','open','stop'],durationTypes:['fixed','flexible'],roundTypes:['open_bidding','sealed_bidding'],// roundTypeBadges: {
//   incremental_auction: ['new'],
//   simple_offer: ['new'],
// },
roundCostHighlight:{},roundHideValidity:false,roundCanChangeDurationType:false,roundDefaultPreviewDays:1,roundDefaultDurationInDays:7,roundDefaultOfferValidityExtensionInDays:7,roundShowInvitedCustomersCount:true,roundShowRedButtonPrice:false,roundShowBidSteps:true,roundShowDefaultBidSteps:true,roundAllowShowBidsBelowStartingPrice:true,salutationTypes:['mr','mrs'],titleTypes:['doctor','master'],salePropertyTypes:['house','flat','property','office','business'],maritalStatuses:['none','single','married','divorced','widowed'],provisionTypes:['default','none','fixed_amount','fixed_percentage'],depositTypes:['none','fixed_amount','percentage'],handoverTypes:['land_register','money_transfer','key_handover','sale_contract'],pepTypes:['no','yes','family','related'],moneyFieldFixedDecimalZeroes:0,uploadTypes:[],// all available upload types
defaultUploadTypes:[],// default preselected upload types
requiredUploadTypes:[],// required upload types (=always selected, cannot be unselected)
enableOptionalUploads:false,saleCreateRequireTC:true,// require T&C checkbox on sale import/create panel
saleActions:['award','awardAll','confirmAward','increase','rejectAll','duplicate'],// total number of pages in sale edit
saleEditTotalPages:3,// if true than the last page is docs, otherwise all of them are content only
saleEditDocs:true,hideSaleEditGuide:false,csvImportDefaultEncoding:null,mlsTypes:['none'],bulkRegistrationEnableCheckboxes:true,messagingTemplates:{cust_message:['subject','text']},messagingAudienceTypes:['everyone','bidders','non_bidders'],defaultSaleOfferData:{},// sale = SaleEditStore
getRequiredDocumentTypes:function getRequiredDocumentTypes(sale,offerData){return[];},getRegistrationScheme:function getRegistrationScheme(sale,t){var scheme={email:{title:t('Email'),type:'email',required:true,target:'buyerData.buyer_email',headers:[t('Email'),'email','e-mail']},phone:{title:t('Phone number'),type:'phone',target:'buyerData.buyer_phone',headers:[t('Phone number'),'phone']},salutation:{title:t('Salutation'),type:'dropdown',options:this.salutationTypes,required:true,target:'buyerData.buyer_salutation',headers:[t('Salutation'),'salutation']},title:{title:t('Title'),type:'combobox',options:this.titleTypes,target:'buyerData.buyer_title',headers:[t('Title'),'title']},firstName:{title:t('First name'),type:'textfield',required:true,target:'buyerData.buyer_firstName',headers:[t('First name'),'first name','given name']},lastName:{title:t('Last name'),type:'textfield',required:true,target:'buyerData.buyer_lastName',headers:[t('Last name'),'last name','surname']}};if(this.localeCodes.length>1){scheme.locale={title:t('Locale'),type:'dropdown',options:this.localeCodes,required:true,target:'buyerData.buyer_locale'};}return scheme;},createOffer:function createOffer(sale,round){var withBuyerData=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;var buyerData=withBuyerData?{buyer_locale:sale?sale.locale:this.localeCodes[0],buyer_country:countries.get('DE'),buyer_country_code:'DE'}:{};return{locale:sale?sale.locale:this.localeCodes[0],buyerData:buyerData,offerData:{offer_validity:sale&&round&&round.definition.offerValidityUntil?__WEBPACK_IMPORTED_MODULE_2__build_node_modules_moment_timezone___default()(round.definition.offerValidityUntil).toDate():undefined,currency_code:sale.currencyCode,required_uploads:[],optional_uploads:[]},triggerNotification:false,bidPlacedAt:null};}});

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NumericTextField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_TextField__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Icon__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Tooltip__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_src_app_helpers_numberFormatting__ = __webpack_require__(488);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NumericTextField=(_temp2=_class=function(_Component){_inherits(NumericTextField,_Component);function NumericTextField(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NumericTextField);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NumericTextField.__proto__||Object.getPrototypeOf(NumericTextField)).call.apply(_ref,[this].concat(args))),_this),_this.hostId=Object(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Utilities__["N" /* getId */])('tooltipHost'),_this.handleChange=function(ev,value){},_this.change=function(e){var number=_this.toNumber(e.target.value);var onChanged=_this.props.onChanged;_this.field.setState({value:number.formatted});if(onChanged){onChanged(number.value);}},_this.toNumber=function(value){if(value===''||value===null||(typeof value==='undefined'?'undefined':_typeof(value))===undefined)return{value:_this.props.defaultValue,formatted:_this.props.defaultValue!==null?Intl.NumberFormat(_this.props.locale).format(_this.props.defaultValue):''};var number=typeof value==='number'?value:Object(__WEBPACK_IMPORTED_MODULE_6__build_src_app_helpers_numberFormatting__["c" /* parseFormattedNumberValue */])(value,_this.props.locale);return{value:number,formatted:Intl.NumberFormat(_this.props.locale).format(number)};},_this.onRenderLabel=function(){var _this$props=_this.props,label=_this$props.label,tooltip=_this$props.tooltip,required=_this$props.required;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('label',{className:'ms-Label',required:required||false,htmlFor:_this.id,style:{paddingTop:'5px',paddingBottom:'5px',display:'inline-block'}},label,tooltip&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,' ',__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Tooltip__["b" /* TooltipHost */],{content:tooltip,id:_this.hostId,calloutProps:{gapSpace:0}},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Icon__["Icon"],{iconName:'Info'}))));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NumericTextField,[{key:'render',value:function render(){var _this2=this;var _props=this.props,value=_props.value,tooltip=_props.tooltip;var number=this.toNumber(value);var onRenderLabel=tooltip?this.onRenderLabel:undefined;var forwardedProps=__WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash___default.a.omit(this.props,['value','defaultValue','onRenderLabel','onChanged','onChange','onBlur','componentRef','inputMode']);return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_TextField__["a" /* TextField */],Object.assign({},forwardedProps,{onRenderLabel:onRenderLabel,value:number.formatted,onChange:this.handleChange,onBlur:this.change,componentRef:function componentRef(t){return _this2.field=t;},inputMode:'decimal'}));}}]);return NumericTextField;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class.displayName='NumericTextField',_class.defaultProps={defaultValue:null,format:'0,0'},_temp2);

/***/ }),
/* 903 */,
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OnlyRequired__ = __webpack_require__(1824);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__OnlyRequired__["a"]; });


/***/ }),
/* 905 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */
/***/ (function(module, exports) {

module.exports = {"AF":"Afghanistan","ZA":"Afrique du Sud","AL":"Albanie","DZ":"Algérie","DE":"Allemagne","AD":"Andorre","AO":"Angola","AI":"Anguilla","AQ":"Antarctique","AG":"Antigua-et-Barbuda","SA":"Arabie saoudite","AR":"Argentine","AM":"Arménie","AW":"Aruba","AU":"Australie","AT":"Autriche","AZ":"Azerbaïdjan","BS":"Bahamas","BH":"Bahreïn","BD":"Bangladesh","BB":"Barbade","BE":"Belgique","BZ":"Belize","BJ":"Bénin","BM":"Bermudes","BT":"Bhoutan","BY":"Biélorussie","BO":"Bolivie","BA":"Bosnie-Herzégovine","BW":"Botswana","BR":"Brésil","BN":"Brunéi Darussalam","BG":"Bulgarie","BF":"Burkina Faso","BI":"Burundi","KH":"Cambodge","CM":"Cameroun","CA":"Canada","CV":"Cap-Vert","EA":"Ceuta et Melilla","CL":"Chili","CN":"Chine","CY":"Chypre","CO":"Colombie","KM":"Comores","CG":"Congo-Brazzaville","CD":"Congo-Kinshasa","KP":"Corée du Nord","KR":"Corée du Sud","CR":"Costa Rica","CI":"Côte d’Ivoire","HR":"Croatie","CU":"Cuba","CW":"Curaçao","DK":"Danemark","DG":"Diego Garcia","DJ":"Djibouti","DM":"Dominique","EG":"Égypte","SV":"El Salvador","AE":"Émirats arabes unis","EC":"Équateur","ER":"Érythrée","ES":"Espagne","EE":"Estonie","VA":"État de la Cité du Vatican","FM":"États fédérés de Micronésie","US":"États-Unis","ET":"Éthiopie","FJ":"Fidji","FI":"Finlande","FR":"France","GA":"Gabon","GM":"Gambie","GE":"Géorgie","GH":"Ghana","GI":"Gibraltar","GR":"Grèce","GD":"Grenade","GL":"Groenland","GP":"Guadeloupe","GU":"Guam","GT":"Guatemala","GG":"Guernesey","GN":"Guinée","GQ":"Guinée équatoriale","GW":"Guinée-Bissau","GY":"Guyana","GF":"Guyane française","HT":"Haïti","HN":"Honduras","HU":"Hongrie","CX":"Île Christmas","AC":"Île de l’Ascension","IM":"Île de Man","NF":"Île Norfolk","AX":"Îles Åland","KY":"Îles Caïmans","IC":"Îles Canaries","CC":"Îles Cocos","CK":"Îles Cook","FO":"Îles Féroé","GS":"Îles Géorgie du Sud et Sandwich du Sud","FK":"Îles Malouines","MP":"Îles Mariannes du Nord","MH":"Îles Marshall","UM":"Îles mineures éloignées des États-Unis","SB":"Îles Salomon","TC":"Îles Turques-et-Caïques","VG":"Îles Vierges britanniques","VI":"Îles Vierges des États-Unis","IN":"Inde","ID":"Indonésie","IQ":"Irak","IR":"Iran","IE":"Irlande","IS":"Islande","IL":"Israël","IT":"Italie","JM":"Jamaïque","JP":"Japon","JE":"Jersey","JO":"Jordanie","KZ":"Kazakhstan","KE":"Kenya","KG":"Kirghizistan","KI":"Kiribati","XK":"Kosovo","KW":"Koweït","RE":"La Réunion","LA":"Laos","LS":"Lesotho","LV":"Lettonie","LB":"Liban","LR":"Libéria","LY":"Libye","LI":"Liechtenstein","LT":"Lituanie","LU":"Luxembourg","MK":"Macédoine","MG":"Madagascar","MY":"Malaisie","MW":"Malawi","MV":"Maldives","ML":"Mali","MT":"Malte","MA":"Maroc","MQ":"Martinique","MU":"Maurice","MR":"Mauritanie","YT":"Mayotte","MX":"Mexique","MD":"Moldavie","MC":"Monaco","MN":"Mongolie","ME":"Monténégro","MS":"Montserrat","MZ":"Mozambique","MM":"Myanmar","NA":"Namibie","NR":"Nauru","NP":"Népal","NI":"Nicaragua","NE":"Niger","NG":"Nigéria","NU":"Niue","NO":"Norvège","NC":"Nouvelle-Calédonie","NZ":"Nouvelle-Zélande","OM":"Oman","UG":"Ouganda","UZ":"Ouzbékistan","PK":"Pakistan","PW":"Palaos","PA":"Panama","PG":"Papouasie-Nouvelle-Guinée","PY":"Paraguay","NL":"Pays-Bas","BQ":"Pays-Bas caribéens","PE":"Pérou","PH":"Philippines","PN":"Pitcairn","PL":"Pologne","PF":"Polynésie française","PR":"Porto Rico","PT":"Portugal","QA":"Qatar","HK":"R.A.S. chinoise de Hong Kong","MO":"R.A.S. chinoise de Macao","CF":"République centrafricaine","DO":"République dominicaine","CZ":"République tchèque","RO":"Roumanie","GB":"Royaume-Uni","RU":"Russie","RW":"Rwanda","EH":"Sahara occidental","BL":"Saint-Barthélemy","KN":"Saint-Christophe-et-Niévès","SM":"Saint-Marin","MF":"Saint-Martin (partie française)","SX":"Saint-Martin (partie néerlandaise)","PM":"Saint-Pierre-et-Miquelon","VC":"Saint-Vincent-et-les-Grenadines","SH":"Sainte-Hélène","LC":"Sainte-Lucie","WS":"Samoa","AS":"Samoa américaines","ST":"Sao Tomé-et-Principe","SN":"Sénégal","RS":"Serbie","SC":"Seychelles","SL":"Sierra Leone","SG":"Singapour","SK":"Slovaquie","SI":"Slovénie","SO":"Somalie","SD":"Soudan","SS":"Soudan du Sud","LK":"Sri Lanka","SE":"Suède","CH":"Suisse","SR":"Suriname","SJ":"Svalbard et Jan Mayen","SZ":"Swaziland","SY":"Syrie","TJ":"Tadjikistan","TW":"Taïwan","TZ":"Tanzanie","TD":"Tchad","TF":"Terres australes françaises","IO":"Territoire britannique de l’océan Indien","PS":"Territoires palestiniens","TH":"Thaïlande","TL":"Timor oriental","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trinité-et-Tobago","TA":"Tristan da Cunha","TN":"Tunisie","TM":"Turkménistan","TR":"Turquie","TV":"Tuvalu","UA":"Ukraine","UY":"Uruguay","VU":"Vanuatu","VE":"Venezuela","VN":"Vietnam","WF":"Wallis-et-Futuna","YE":"Yémen","ZM":"Zambie","ZW":"Zimbabwe"}

/***/ }),
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_moment_timezone__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_lodash__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_node_modules_react_dropzone__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_ComboBox__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__build_node_modules_office_ui_fabric_react_lib_Dialog__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__build_node_modules_office_ui_fabric_react_lib_Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__build_node_modules_office_ui_fabric_react_lib_MessageBar__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__build_src_app_components_SaleForm_BaseSaleFormComponent__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Doc__ = __webpack_require__(2081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__build_src_app_components_DatePicker__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__DocRequiredInfo__ = __webpack_require__(2084);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_desc,_value,_class2,_descriptor,_descriptor2,_descriptor3,_class3,_temp2;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var Page3=Object(__WEBPACK_IMPORTED_MODULE_11__build_src_app_components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx_react__["e" /* observer */])(_class=(_class2=(_temp2=_class3=function(_BaseSaleFormComponen){_inherits(Page3,_BaseSaleFormComponen);function Page3(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,Page3);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Page3.__proto__||Object.getPrototypeOf(Page3)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'currentDoc',_descriptor,_this),_initDefineProp(_this,'dropzoneState',_descriptor2,_this),_initDefineProp(_this,'uploadErrors',_descriptor3,_this),_this.isValid=function(){var docs=_this.props.docs;return!__WEBPACK_IMPORTED_MODULE_5__build_node_modules_lodash___default.a.some(docs,function(d){return!d.type;});},_this.itemHandlers={handleDelete:function handleDelete(d){return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(){var _this$props,docs,deleteDoc;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this$props=_this.props,docs=_this$props.docs,deleteDoc=_this$props.deleteDoc;if(d.metadata&&d.metadata.deleteToken){deleteDoc(d.metadata.deleteToken);}docs.splice(docs.indexOf(d),1);case 3:case'end':return _context.stop();}}},_callee,_this2);}));},handleEdit:function handleEdit(d){return function(){_this.selectDoc(d);};},handleMoveUp:function handleMoveUp(d){return function(){var docs=_this.props.docs;var index=docs.indexOf(d);if(index<=0)return;docs[index]=docs[index-1];docs[index-1]=d;};},handleMoveDown:function handleMoveDown(d){return function(){var docs=_this.props.docs;var index=docs.indexOf(d);if(index>=docs.length-1)return;docs[index]=docs[index+1];docs[index+1]=d;};}},_this.formatDate=function(date){return!!date?date.toFormatedDateString('L'):null;},_this.parseDateFromString=function(value){return!!value?__WEBPACK_IMPORTED_MODULE_4__build_node_modules_moment_timezone___default()(value,'L').toDate():value;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Page3,[{key:'customFileName',value:function customFileName(name){return name.toLowerCase().replace('ä','ae').replace('ö','oe').replace('ü','ue').replace('ß','ss').normalize('NFD').replace(/[\s]+/g,'_').replace(/[^\w0-9_]+/g,'');}},{key:'applyFileCopyData',value:function applyFileCopyData(doc,type){var t=this.props.t;Object.assign(doc,{type:type,short:t('documenttype::'+type),full:t('documenttype::'+type+'_long',{},'documenttype::'+type),fileName:this.customFileName(type)});}// onDragEnter() {
//   this.dropzoneState.active = true;
// }
// onDragLeave() {
//   this.dropzoneState.active = false;
// }
// onDrop(files) {
//   this.dropzoneState.active = false;
// }
},{key:'setDocType',value:function setDocType(option,_,value){this.currentDoc.type=option?option.key:value;this.applyFileCopyData(this.currentDoc,option?option.key:value);}},{key:'setDocDetail',value:function setDocDetail(value){this.currentDoc.details=value;}},{key:'selectDoc',value:function selectDoc(d){this.currentDoc=Object.assign({},d);}},{key:'updateDoc',value:function updateDoc(){var _this3=this;var docs=this.props.docs;var d=__WEBPACK_IMPORTED_MODULE_5__build_node_modules_lodash___default.a.find(docs,function(d){return d.id===_this3.currentDoc.id;});if(d){Object.assign(d,this.currentDoc);}this.currentDoc={};}},{key:'cancelDoc',value:function cancelDoc(){this.currentDoc={};}},{key:'handleUpload',value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(files){var _props,uploadDoc,docs,_iteratorNormalCompletion,_didIteratorError,_iteratorError,_iterator,_step,file,uploaded;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_props=this.props,uploadDoc=_props.uploadDoc,docs=_props.docs;this.uploadErrors.clear();this.dropzoneState.uploadInProgress=true;_iteratorNormalCompletion=true;_didIteratorError=false;_iteratorError=undefined;_context2.prev=6;_iterator=files[Symbol.iterator]();case 8:if(_iteratorNormalCompletion=(_step=_iterator.next()).done){_context2.next=23;break;}file=_step.value;_context2.prev=10;_context2.next=13;return uploadDoc(file);case 13:uploaded=_context2.sent;docs.push(uploaded);_context2.next=20;break;case 17:_context2.prev=17;_context2.t0=_context2['catch'](10);this.uploadErrors.push({file:file,error:this.parseUploadError(_context2.t0)});case 20:_iteratorNormalCompletion=true;_context2.next=8;break;case 23:_context2.next=29;break;case 25:_context2.prev=25;_context2.t1=_context2['catch'](6);_didIteratorError=true;_iteratorError=_context2.t1;case 29:_context2.prev=29;_context2.prev=30;if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}case 32:_context2.prev=32;if(!_didIteratorError){_context2.next=35;break;}throw _iteratorError;case 35:return _context2.finish(32);case 36:return _context2.finish(29);case 37:this.dropzoneState.uploadInProgress=false;case 38:case'end':return _context2.stop();}}},_callee2,this,[[6,25,29,37],[10,17],[30,,32,36]]);}));function handleUpload(_x){return _ref3.apply(this,arguments);}return handleUpload;}()},{key:'parseUploadError',value:function parseUploadError(error){var t=this.props.t;if(typeof error.response!=='undefined'&&typeof error.response.error!=='undefined'&&typeof error.response.error.message!=='undefined'){// try to detect known errors
var res=/Raw file format ([^\s]+) not allowed/i.exec(error.response.error.message);if(res!==null)return t('File extension is not supported',{extension:res[1]});res=/File size too large. Got ([\d]+). Maximum is ([\d]+)/i.exec(error.response.error.message);if(res!==null)return t('File size exceeds allowed limit',{size:res[1],allowed:res[2]});// no luck, use the raw error message from Cloudinary
return error.response.error.message;}// fallback to the error object
return error;}},{key:'render',value:function render(){var _this4=this;var _props2=this.props,sale=_props2.sale,offerData=_props2.offerData,docs=_props2.docs,t=_props2.t,config=_props2.config;return __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_react_dropzone__["a" /* default */],{disableClick:true,className:'ms-Grid',ref:function ref(node){_this4.dropzoneRef=node;},accept:'image/jpeg, application/pdf, image/png',onDrop:this.handleUpload.bind(this)},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('h3',{className:'ms-Grid-col ms-lg12'},t('Documents'))),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__DocRequiredInfo__["a" /* default */],{sale:sale,offerData:offerData,docs:docs,t:t,config:config}),docs&&docs.map(function(d,i){return __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Doc__["a" /* default */],Object.assign({key:d.id,d:d,i:i},_this4.itemHandlers));}),!this.isValid()&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__build_node_modules_office_ui_fabric_react_lib_MessageBar__["a" /* MessageBar */],{messageBarType:__WEBPACK_IMPORTED_MODULE_10__build_node_modules_office_ui_fabric_react_lib_MessageBar__["b" /* MessageBarType */].error},t('All documents must have a type set')),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row',style:{marginTop:'0.5em',marginBottom:'0.5em'}},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-lg12'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__build_node_modules_office_ui_fabric_react_lib_Button__["h" /* PrimaryButton */],{disabled:this.dropzoneState.uploadInProgress,onClick:function onClick(){return _this4.dropzoneRef.open();}},this.dropzoneState.uploadInProgress?t('Uploading')+'...':docs&&docs.length>0?t('Upload more'):t('Upload')),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-font-xs',style:{paddingTop:'0.5em'}},t('Allowed file formats')))),this.uploadErrors.length>0&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__build_node_modules_office_ui_fabric_react_lib_MessageBar__["a" /* MessageBar */],{messageBarType:__WEBPACK_IMPORTED_MODULE_10__build_node_modules_office_ui_fabric_react_lib_MessageBar__["b" /* MessageBarType */].error},this.uploadErrors.map(function(error){return __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{key:error.file.name},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('strong',null,error.file.name),': ',error.error);})),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__build_node_modules_office_ui_fabric_react_lib_Dialog__["a" /* Dialog */],{hidden:!this.currentDoc.id,onDismiss:this._closeDialog,dialogContentProps:{type:__WEBPACK_IMPORTED_MODULE_8__build_node_modules_office_ui_fabric_react_lib_Dialog__["c" /* DialogType */].largeHeader,title:t('Edit')},modalProps:{isBlocking:true}},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('form',null,__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('p',null,t('Choose a document type or enter description'),':'),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_ComboBox__["a" /* ComboBox */],{label:t('Document type'),name:'type',allowFreeform:true,autoComplete:'on',onChanged:this.setDocType.bind(this),value:this.currentDoc.type?t('documenttype::'+this.currentDoc.type+'_long',{},'documenttype::'+this.currentDoc.type):'',options:[{key:'',text:''}].concat(this.props.documentTypes.map(function(key){return{key:key,text:t('documenttype::'+key+'_long',{},'documenttype::'+key)};}))}),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__build_src_app_components_DatePicker__["a" /* default */],{label:t('Date'),allowTextInput:true,value:this.currentDoc.details?new Date(this.currentDoc.details):null,onSelectDate:this.setDocDetail.bind(this),formatDate:this.formatDate,parseDateFromString:this.parseDateFromString}),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__build_node_modules_office_ui_fabric_react_lib_Dialog__["b" /* DialogFooter */],null,__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__build_node_modules_office_ui_fabric_react_lib_Button__["h" /* PrimaryButton */],{onClick:this.updateDoc.bind(this),text:t('Save')}),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__build_node_modules_office_ui_fabric_react_lib_Button__["f" /* DefaultButton */],{onClick:this.cancelDoc.bind(this),text:t('Cancel')})))));}}]);return Page3;}(__WEBPACK_IMPORTED_MODULE_12__build_src_app_components_SaleForm_BaseSaleFormComponent__["a" /* default */]),_class3.displayName='Page3',_temp2),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'currentDoc',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,'dropzoneState',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return{active:false,uploadInProgress:false};}}),_descriptor3=_applyDecoratedDescriptor(_class2.prototype,'uploadErrors',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}})),_class2))||_class)||_class;/* harmony default export */ __webpack_exports__["a"] = (Page3);

/***/ }),
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */
/***/ (function(module, exports) {

module.exports = {"AF":"Afganistan","AX":"Ålandski otoki","AL":"Albanija","DZ":"Alžirija","AS":"Ameriška Samoa","VI":"Ameriški Deviški otoki","AD":"Andora","AO":"Angola","AI":"Angvila","AQ":"Antarktika","AG":"Antigva in Barbuda","AR":"Argentina","AM":"Armenija","AW":"Aruba","AU":"Avstralija","AT":"Avstrija","AZ":"Azerbajdžan","BS":"Bahami","BH":"Bahrajn","BD":"Bangladeš","BB":"Barbados","BE":"Belgija","BZ":"Belize","BY":"Belorusija","BJ":"Benin","BM":"Bermudi","BW":"Bocvana","BG":"Bolgarija","BO":"Bolivija","BA":"Bosna in Hercegovina","CX":"Božični otok","BR":"Brazilija","VG":"Britanski Deviški otoki","IO":"Britansko ozemlje v Indijskem oceanu","BN":"Brunej","BF":"Burkina Faso","BI":"Burundi","BT":"Butan","CF":"Centralnoafriška republika","EA":"Ceuta in Melilla","CY":"Ciper","CK":"Cookovi otoki","CW":"Curaçao","TD":"Čad","CZ":"Češka","CL":"Čile","ME":"Črna gora","DK":"Danska","CD":"Demokratična republika Kongo","DG":"Diego Garcia","DM":"Dominika","DO":"Dominikanska republika","UM":"Druga ameriška ozemlja v Tihem oceanu","DJ":"Džibuti","EG":"Egipt","EC":"Ekvador","GQ":"Ekvatorialna Gvineja","ER":"Eritreja","EE":"Estonija","ET":"Etiopija","FK":"Falklandski otoki","FO":"Ferski otoki","FJ":"Fidži","PH":"Filipini","FI":"Finska","FR":"Francija","GF":"Francoska Gvajana","PF":"Francoska Polinezija","TF":"Francosko južno ozemlje","GA":"Gabon","GM":"Gambija","GH":"Gana","GI":"Gibraltar","GR":"Grčija","GD":"Grenada","GL":"Grenlandija","GE":"Gruzija","GU":"Guam","GG":"Guernsey","GP":"Gvadalupe","GY":"Gvajana","GT":"Gvatemala","GN":"Gvineja","GW":"Gvineja Bissau","HT":"Haiti","HN":"Honduras","HR":"Hrvaška","IN":"Indija","ID":"Indonezija","IQ":"Irak","IR":"Iran","IE":"Irska","IS":"Islandija","IT":"Italija","IL":"Izrael","JM":"Jamajka","JP":"Japonska","YE":"Jemen","JE":"Jersey","JO":"Jordanija","GS":"Južna Georgia in Južni Sandwichevi otoki","KR":"Južna Koreja","SS":"Južni Sudan","ZA":"Južnoafriška republika","KY":"Kajmanski otoki","KH":"Kambodža","CM":"Kamerun","CA":"Kanada","IC":"Kanarski otoki","QA":"Katar","KZ":"Kazahstan","KE":"Kenija","KG":"Kirgizistan","KI":"Kiribati","CN":"Kitajska","CC":"Kokosovi otoki","CO":"Kolumbija","KM":"Komori","CG":"Kongo - Brazzaville","XK":"Kosovo","CR":"Kostarika","CU":"Kuba","KW":"Kuvajt","LA":"Laos","LV":"Latvija","LS":"Lesoto","LB":"Libanon","LR":"Liberija","LY":"Libija","LI":"Lihtenštajn","LT":"Litva","LU":"Luksemburg","MG":"Madagaskar","HU":"Madžarska","MK":"Makedonija","MW":"Malavi","MV":"Maldivi","MY":"Malezija","ML":"Mali","MT":"Malta","MA":"Maroko","MH":"Marshallovi otoki","MQ":"Martinik","MU":"Mauritius","MR":"Mavretanija","YT":"Mayotte","MX":"Mehika","FM":"Mikronezija","MM":"Mjanmar (Burma)","MD":"Moldavija","MC":"Monako","MN":"Mongolija","MS":"Montserrat","MZ":"Mozambik","NA":"Namibija","NR":"Nauru","DE":"Nemčija","NP":"Nepal","NE":"Niger","NG":"Nigerija","NI":"Nikaragva","NU":"Niue","NL":"Nizozemska","BQ":"Nizozemski Karibi","NF":"Norfolški otok","NO":"Norveška","NC":"Nova Kaledonija","NZ":"Nova Zelandija","OM":"Oman","TC":"Otočji Turks in Caicos","AC":"Otok Ascension","IM":"Otok Man","PK":"Pakistan","PW":"Palau","PS":"Palestinsko ozemlje","PA":"Panama","PG":"Papua Nova Gvineja","PY":"Paragvaj","PE":"Peru","PN":"Pitcairn","PL":"Poljska","PR":"Portoriko","PT":"Portugalska","HK":"Posebno administrativno območje LR Kitajske Hong Kong","MO":"Posebno administrativno območje LR Kitajske Macao","RE":"Reunion","RO":"Romunija","RW":"Ruanda","RU":"Rusija","BL":"Saint Barthélemy","KN":"Saint Kitts in Nevis","LC":"Saint Lucia","MF":"Saint Martin","PM":"Saint Pierre in Miquelon","VC":"Saint Vincent in Grenadine","SB":"Salomonovi otoki","SV":"Salvador","WS":"Samoa","SM":"San Marino","ST":"Sao Tome in Principe","SA":"Saudova Arabija","SC":"Sejšeli","SN":"Senegal","KP":"Severna Koreja","MP":"Severni Marianski otoki","SL":"Sierra Leone","SG":"Singapur","SX":"Sint Maarten","SY":"Sirija","CI":"Slonokoščena obala","SK":"Slovaška","SI":"Slovenija","SO":"Somalija","RS":"Srbija","SD":"Sudan","SR":"Surinam","SJ":"Svalbard in Jan Mayen","SZ":"Svazi","SH":"Sveta Helena","ES":"Španija","LK":"Šrilanka","SE":"Švedska","CH":"Švica","TJ":"Tadžikistan","TH":"Tajska","TW":"Tajvan","TZ":"Tanzanija","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trinidad in Tobago","TA":"Tristan da Cunha","TN":"Tunizija","TR":"Turčija","TM":"Turkmenistan","TV":"Tuvalu","UG":"Uganda","UA":"Ukrajina","UY":"Urugvaj","UZ":"Uzbekistan","VU":"Vanuatu","VA":"Vatikan","GB":"Velika Britanija","VE":"Venezuela","VN":"Vietnam","TL":"Vzhodni Timor","WF":"Wallis in Futuna","EH":"Zahodna Sahara","ZM":"Zambija","US":"Združene države Amerike","AE":"Združeni arabski emirati","CV":"Zelenortski otoki","ZW":"Zimbabve"}

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

module.exports = {"AF":"Afganistan","ZA":"Africa de Sud","AL":"Albania","DZ":"Algeria","AD":"Andorra","AO":"Angola","AI":"Anguilla","AQ":"Antarctica","AG":"Antigua și Barbuda","SA":"Arabia Saudită","AR":"Argentina","AM":"Armenia","AW":"Aruba","AU":"Australia","AT":"Austria","AZ":"Azerbaidjan","BS":"Bahamas","BH":"Bahrain","BD":"Bangladesh","BB":"Barbados","BY":"Belarus","BE":"Belgia","BZ":"Belize","BJ":"Benin","BM":"Bermuda","BT":"Bhutan","BO":"Bolivia","BA":"Bosnia și Herțegovina","BW":"Botswana","BR":"Brazilia","BN":"Brunei","BG":"Bulgaria","BF":"Burkina Faso","BI":"Burundi","KH":"Cambodgia","CM":"Camerun","CA":"Canada","CV":"Capul Verde","EA":"Ceuta și Melilla","CL":"Chile","CN":"China","TD":"Ciad","CY":"Cipru","CO":"Columbia","KM":"Comore","CG":"Congo - Brazzaville","CD":"Congo - Kinshasa","KP":"Coreea de Nord","KR":"Coreea de Sud","CR":"Costa Rica","CI":"Côte d’Ivoire","HR":"Croația","CU":"Cuba","CW":"Curaçao","DK":"Danemarca","DG":"Diego Garcia","DJ":"Djibouti","DM":"Dominica","EC":"Ecuador","EG":"Egipt","SV":"El Salvador","CH":"Elveția","AE":"Emiratele Arabe Unite","ER":"Eritreea","EE":"Estonia","ET":"Etiopia","FJ":"Fiji","PH":"Filipine","FI":"Finlanda","FR":"Franța","GA":"Gabon","GM":"Gambia","GE":"Georgia","GS":"Georgia de Sud și Insulele Sandwich de Sud","DE":"Germania","GH":"Ghana","GI":"Gibraltar","GR":"Grecia","GD":"Grenada","GL":"Groenlanda","GP":"Guadelupa","GU":"Guam","GT":"Guatemala","GG":"Guernsey","GN":"Guineea","GQ":"Guineea Ecuatorială","GW":"Guineea-Bissau","GY":"Guyana","GF":"Guyana Franceză","HT":"Haiti","HN":"Honduras","IN":"India","ID":"Indonezia","AC":"Insula Ascension","CX":"Insula Christmas","IM":"Insula Man","AX":"Insulele Åland","IC":"Insulele Canare","BQ":"Insulele Caraibe Olandeze","KY":"Insulele Cayman","CC":"Insulele Cocos (Keeling)","CK":"Insulele Cook","FK":"Insulele Falkland","FO":"Insulele Feroe","UM":"Insulele Îndepărtate ale S.U.A.","MP":"Insulele Mariane de Nord","MH":"Insulele Marshall","NF":"Insulele Norfolk","PN":"Insulele Pitcairn","SB":"Insulele Solomon","TC":"Insulele Turks și Caicos","VG":"Insulele Virgine Britanice","VI":"Insulele Virgine S.U.A.","JO":"Iordania","IQ":"Irak","IR":"Iran","IE":"Irlanda","IS":"Islanda","IL":"Israel","IT":"Italia","JM":"Jamaica","JP":"Japonia","JE":"Jersey","KZ":"Kazahstan","KG":"Kârgâzstan","KE":"Kenya","KI":"Kiribati","XK":"Kosovo","KW":"Kuweit","LA":"Laos","LS":"Lesotho","LV":"Letonia","LB":"Liban","LR":"Liberia","LY":"Libia","LI":"Liechtenstein","LT":"Lituania","LU":"Luxemburg","MK":"Macedonia","MG":"Madagascar","MY":"Malaezia","MW":"Malawi","MV":"Maldive","ML":"Mali","MT":"Malta","MA":"Maroc","MQ":"Martinica","MR":"Mauritania","MU":"Mauritius","YT":"Mayotte","MX":"Mexic","FM":"Micronezia","MC":"Monaco","MN":"Mongolia","MS":"Montserrat","MZ":"Mozambic","ME":"Muntenegru","MM":"Myanmar (Birmania)","NA":"Namibia","NR":"Nauru","NP":"Nepal","NI":"Nicaragua","NE":"Niger","NG":"Nigeria","NU":"Niue","NO":"Norvegia","NC":"Noua Caledonie","NZ":"Noua Zeelandă","OM":"Oman","PK":"Pakistan","PW":"Palau","PA":"Panama","PG":"Papua-Noua Guinee","PY":"Paraguay","PE":"Peru","PF":"Polinezia Franceză","PL":"Polonia","PT":"Portugalia","PR":"Puerto Rico","QA":"Qatar","HK":"R.A.S. Hong Kong a Chinei","MO":"R.A.S. Macao a Chinei","GB":"Regatul Unit","CZ":"Republica Cehă","CF":"Republica Centrafricană","DO":"Republica Dominicană","MD":"Republica Moldova","RE":"Réunion","RO":"România","RU":"Rusia","RW":"Rwanda","EH":"Sahara Occidentală","KN":"Saint Kitts și Nevis","VC":"Saint Vincent și Grenadine","PM":"Saint-Pierre și Miquelon","WS":"Samoa","AS":"Samoa Americană","SM":"San Marino","ST":"Sao Tome și Principe","SN":"Senegal","RS":"Serbia","SC":"Seychelles","SH":"Sfânta Elena","LC":"Sfânta Lucia","BL":"Sfântul Bartolomeu","MF":"Sfântul Martin","SL":"Sierra Leone","SG":"Singapore","SX":"Sint-Maarten","SY":"Siria","SK":"Slovacia","SI":"Slovenia","SO":"Somalia","ES":"Spania","LK":"Sri Lanka","US":"Statele Unite ale Americii","VA":"Statul Cetății Vaticanului","SD":"Sudan","SS":"Sudanul de Sud","SE":"Suedia","SR":"Surinam","SJ":"Svalbard și Jan Mayen","SZ":"Swaziland","TJ":"Tadjikistan","TW":"Taiwan","TZ":"Tanzania","TF":"Teritoriile Australe și Antarctice Franceze","PS":"Teritoriile Palestiniene","IO":"Teritoriul Britanic din Oceanul Indian","TH":"Thailanda","TL":"Timorul de Est","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trinidad și Tobago","TA":"Tristan da Cunha","TN":"Tunisia","TR":"Turcia","TM":"Turkmenistan","TV":"Tuvalu","NL":"Țările de Jos","UA":"Ucraina","UG":"Uganda","HU":"Ungaria","UY":"Uruguay","UZ":"Uzbekistan","VU":"Vanuatu","VE":"Venezuela","VN":"Vietnam","WF":"Wallis și Futuna","YE":"Yemen","ZM":"Zambia","ZW":"Zimbabwe"}

/***/ }),
/* 1012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_src_app_components_MoneyField__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Dropdown__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__biddingStepsDefinitions__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__IncrementalAuction__ = __webpack_require__(2076);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2,_class3,_temp2;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}var RoundPriceEdit=(_dec=Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__["d" /* inject */])('app','sale'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__["e" /* observer */])(_class=(_class2=(_temp2=_class3=function(_Component){_inherits(RoundPriceEdit,_Component);function RoundPriceEdit(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RoundPriceEdit);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RoundPriceEdit.__proto__||Object.getPrototypeOf(RoundPriceEdit)).call.apply(_ref,[this].concat(args))),_this),_this.handleFieldChanged=function(field){return function(value){var round=_this.props.store.round;round[field]=value;};},_this.handleStartPriceChange=function(value){var round=_this.props.store.round;round['startPrice']=value;var bid=_this.selectedStepValue(value,true);round['biddingSteps']=bid==='default'?null:'0=0;1='+bid;},_this.handleBidStepChanged=function(option){var round=_this.props.store.round;round['biddingSteps']=option.key==='default'?null:'0=0;1='+option.key;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RoundPriceEdit,[{key:'render',value:function render(){var _this2=this;var _props=this.props,t=_props.t,round=_props.store.round;var step=this.biddingSteps(round.startPrice);if(round.type==='incremental_auction'){return __WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__IncrementalAuction__["a" /* default */],this.props);}return __WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react__["Fragment"],null,round.type!=='counteroffer_bidding'&&__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_src_app_components_MoneyField__["a" /* default */],{label:round.type==='open_bidding'?t('Starting price'):t('Minimum price'),currency:this.props.app.currency.code,locale:this.props.intl.locale,value:round.startPrice,onChanged:this.handleStartPriceChange,tooltip:t('Starting price - tooltip'),autoComplete:'off',errorMessage:!this.startPriceError?undefined:t(this.startPriceError)})),round.type!=='open_bidding'&&__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_src_app_components_MoneyField__["a" /* default */],{label:round.type==='counteroffer_bidding'?t('Counteroffer value'):t('Estimate'),currency:this.props.app.currency.code,locale:this.props.intl.locale,value:round.estimate,onChanged:this.handleFieldChanged('estimate'),tooltip:t('Estimate - tooltip'),autoComplete:'off'})),this.props.sale.saleConfig.roundShowRedButtonPrice&&round.type!=='counteroffer_bidding'&&__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_src_app_components_MoneyField__["a" /* default */],{label:t('Red button price'),currency:this.props.app.currency.code,locale:this.props.intl.locale,value:round.redButtonPrice,onChanged:this.handleFieldChanged('redButtonPrice'),tooltip:t('Red button price - tooltip'),autoComplete:'off'})),this.props.sale.saleConfig.roundShowBidSteps&&round.type==='open_bidding'&&__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Dropdown__["a" /* Dropdown */],{onChanged:this.handleBidStepChanged,label:__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react__["Fragment"],null,t('Bidding steps'),' ',__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react__["i" /* TooltipHost */],{content:t('Bidding steps - tooltip')},__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react__["f" /* Icon */],{iconName:'Info'}))),selectedKey:this.selectedStepValue(round.startPrice),options:[].concat(_toConsumableArray(this.props.sale.saleConfig.roundShowDefaultBidSteps?[{key:'default',text:t('Bidding steps - standard')}]:[]),_toConsumableArray(step.values.map(function(v){var str=v.toString();return{key:str,text:v.toFormattedMoney(_this2.props.intl.locale,_this2.props.app.currency.code,0)};})))})));}},{key:'isStartingPriceValid',get:function get(){return this.props.store.isStartingPriceValid;}},{key:'startPriceError',get:function get(){var _props2=this.props,t=_props2.t,store=_props2.store;var error=store.startPriceError;return error===''?error:t(error);}},{key:'biddingSteps',get:function get(){return function(startingPrice){var key=0;Object.keys(__WEBPACK_IMPORTED_MODULE_6__biddingStepsDefinitions__["a" /* biddingStepsDefinitions */]).forEach(function(b){if(b<=startingPrice){key=b;}if(b>startingPrice)return;});return __WEBPACK_IMPORTED_MODULE_6__biddingStepsDefinitions__["a" /* biddingStepsDefinitions */][key];};}},{key:'currentBidStep',get:function get(){var round=this.props.store.round;if(!round.biddingSteps){return undefined;}return round.biddingSteps.replace('0=0;1=','');}},{key:'selectedStepValue',get:function get(){var _this3=this;return function(startPrice,useStepDefaultValue){var step=_this3.biddingSteps(startPrice);var stepValue=_this3.currentBidStep;var result=stepValue&&step.values.some(function(v){return v.toString()===stepValue;})?stepValue:useStepDefaultValue?step.default.toString():'default';//step.default.toString();
return result;};}}]);return RoundPriceEdit;}(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react__["Component"]),_class3.displayName='RoundPriceEdit',_temp2),(_applyDecoratedDescriptor(_class2.prototype,'isStartingPriceValid',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class2.prototype,'isStartingPriceValid'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'startPriceError',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class2.prototype,'startPriceError'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'biddingSteps',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class2.prototype,'biddingSteps'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'currentBidStep',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class2.prototype,'currentBidStep'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'selectedStepValue',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class2.prototype,'selectedStepValue'),_class2.prototype)),_class2))||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (RoundPriceEdit);

/***/ }),
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! Moment Duration Format v2.2.2
 *  https://github.com/jsmreese/moment-duration-format
 *  Date: 2018-02-16
 *
 *  Duration format plugin function for the Moment.js library
 *  http://momentjs.com/
 *
 *  Copyright 2018 John Madhavan-Reese
 *  Released under the MIT license
 */

(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(102)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object') {
        // Node. Does not work with strict CommonJS, but only CommonJS-like
        // enviroments that support module.exports, like Node.
        try {
            module.exports = factory(require('moment'));
        } catch (e) {
            // If moment is not available, leave the setup up to the user.
            // Like when using moment-timezone or similar moment-based package.
            module.exports = factory;
        }
    }

    if (root) {
        // Globals.
        root.momentDurationFormatSetup = root.moment ? factory(root.moment) : factory;
    }
})(this, function (moment) {
    // `Number#tolocaleString` is tested on plugin initialization.
    // If the feature test passes, `toLocaleStringWorks` will be set to `true` and the
    // native function will be used to generate formatted output. If the feature
    // test fails, the fallback format function internal to this plugin will be
    // used.
    var toLocaleStringWorks = false;

    // `Number#toLocaleString` rounds incorrectly for select numbers in Microsoft
    // environments (Edge, IE11, Windows Phone) and possibly other environments.
    // If the rounding test fails and `toLocaleString` will be used for formatting,
    // the plugin will "pre-round" number values using the fallback number format
    // function before passing them to `toLocaleString` for final formatting.
    var toLocaleStringRoundingWorks = false;

    // `Intl.NumberFormat#format` is tested on plugin initialization.
    // If the feature test passes, `intlNumberFormatRoundingWorks` will be set to
    // `true` and the native function will be used to generate formatted output.
    // If the feature test fails, either `Number#tolocaleString` (if
    // `toLocaleStringWorks` is `true`), or the fallback format function internal
    //  to this plugin will be used.
    var intlNumberFormatWorks = false;

    // `Intl.NumberFormat#format` rounds incorrectly for select numbers in Microsoft
    // environments (Edge, IE11, Windows Phone) and possibly other environments.
    // If the rounding test fails and `Intl.NumberFormat#format` will be used for
    // formatting, the plugin will "pre-round" number values using the fallback number
    // format function before passing them to `Intl.NumberFormat#format` for final
    // formatting.
    var intlNumberFormatRoundingWorks = false;

    // Token type names in order of descending magnitude.
    var types = "escape years months weeks days hours minutes seconds milliseconds general".split(" ");

    var bubbles = [
        {
            type: "seconds",
            targets: [
                { type: "minutes", value: 60 },
                { type: "hours", value: 3600 },
                { type: "days", value: 86400 },
                { type: "weeks", value: 604800 },
                { type: "months", value: 2678400 },
                { type: "years", value: 31536000 }
            ]
        },
        {
            type: "minutes",
            targets: [
                { type: "hours", value: 60 },
                { type: "days", value: 1440 },
                { type: "weeks", value: 10080 },
                { type: "months", value: 44640 },
                { type: "years", value: 525600 }
            ]
        },
        {
            type: "hours",
            targets: [
                { type: "days", value: 24 },
                { type: "weeks", value: 168 },
                { type: "months", value: 744 },
                { type: "years", value: 8760 }
            ]
        },
        {
            type: "days",
            targets: [
                { type: "weeks", value: 7 },
                { type: "months", value: 31 },
                { type: "years", value: 365 }
            ]
        },
        {
            type: "months",
            targets: [
                { type: "years", value: 12 }
            ]
        }
    ];

    // stringIncludes
    function stringIncludes(str, search) {
        if (search.length > str.length) {
          return false;
        }

        return str.indexOf(search) !== -1;
    }

    // repeatZero(qty)
    // Returns "0" repeated `qty` times.
    // `qty` must be a integer >= 0.
    function repeatZero(qty) {
        var result = "";

        while (qty) {
            result += "0";
            qty -= 1;
        }

        return result;
    }

    function stringRound(digits) {
        var digitsArray = digits.split("").reverse();
        var i = 0;
        var carry = true;

        while (carry && i < digitsArray.length) {
            if (i) {
                if (digitsArray[i] === "9") {
                    digitsArray[i] = "0";
                } else {
                    digitsArray[i] = (parseInt(digitsArray[i], 10) + 1).toString();
                    carry = false;
                }
            } else {
                if (parseInt(digitsArray[i], 10) < 5) {
                    carry = false;
                }

                digitsArray[i] = "0";
            }

            i += 1;
        }

        if (carry) {
            digitsArray.push("1");
        }

        return digitsArray.reverse().join("");
    }

    // cachedNumberFormat
    // Returns an `Intl.NumberFormat` instance for the given locale and configuration.
    // On first use of a particular configuration, the instance is cached for fast
    // repeat access.
    function cachedNumberFormat(locale, options) {
        // Create a sorted, stringified version of `options`
        // for use as part of the cache key
        var optionsString = map(
            keys(options).sort(),
            function(key) {
                return key + ':' + options[key];
            }
        ).join(',');

        // Set our cache key
        var cacheKey = locale + '+' + optionsString;

        // If we don't have this configuration cached, configure and cache it
        if (!cachedNumberFormat.cache[cacheKey]) {
            cachedNumberFormat.cache[cacheKey] = Intl.NumberFormat(locale, options);
        }

        // Return the cached version of this configuration
        return cachedNumberFormat.cache[cacheKey];
    }
    cachedNumberFormat.cache = {};

    // formatNumber
    // Formats any number greater than or equal to zero using these options:
    // - userLocale
    // - useToLocaleString
    // - useGrouping
    // - grouping
    // - maximumSignificantDigits
    // - minimumIntegerDigits
    // - fractionDigits
    // - groupingSeparator
    // - decimalSeparator
    //
    // `useToLocaleString` will use `Intl.NumberFormat` or `toLocaleString` for formatting.
    // `userLocale` option is passed through to the formatting function.
    // `fractionDigits` is passed through to `maximumFractionDigits` and `minimumFractionDigits`
    // Using `maximumSignificantDigits` will override `minimumIntegerDigits` and `fractionDigits`.
    function formatNumber(number, options, userLocale) {
        var useToLocaleString = options.useToLocaleString;
        var useGrouping = options.useGrouping;
        var grouping = useGrouping && options.grouping.slice();
        var maximumSignificantDigits = options.maximumSignificantDigits;
        var minimumIntegerDigits = options.minimumIntegerDigits || 1;
        var fractionDigits = options.fractionDigits || 0;
        var groupingSeparator = options.groupingSeparator;
        var decimalSeparator = options.decimalSeparator;

        if (useToLocaleString && userLocale) {
            var localeStringOptions = {
                minimumIntegerDigits: minimumIntegerDigits,
                useGrouping: useGrouping
            };

            if (fractionDigits) {
                localeStringOptions.maximumFractionDigits = fractionDigits;
                localeStringOptions.minimumFractionDigits = fractionDigits;
            }

            // toLocaleString output is "0.0" instead of "0" for HTC browsers
            // when maximumSignificantDigits is set. See #96.
            if (maximumSignificantDigits && number > 0) {
                localeStringOptions.maximumSignificantDigits = maximumSignificantDigits;
            }

            if (intlNumberFormatWorks) {
                if (!intlNumberFormatRoundingWorks) {
                    var roundingOptions = extend({}, options);
                    roundingOptions.useGrouping = false;
                    roundingOptions.decimalSeparator = ".";
                    number = parseFloat(formatNumber(number, roundingOptions), 10);
                }

                return cachedNumberFormat(userLocale, localeStringOptions).format(number);
            } else {
                if (!toLocaleStringRoundingWorks) {
                    var roundingOptions = extend({}, options);
                    roundingOptions.useGrouping = false;
                    roundingOptions.decimalSeparator = ".";
                    number = parseFloat(formatNumber(number, roundingOptions), 10);
                }

                return number.toLocaleString(userLocale, localeStringOptions);
            }
        }

        var numberString;

        // Add 1 to digit output length for floating point errors workaround. See below.
        if (maximumSignificantDigits) {
            numberString = number.toPrecision(maximumSignificantDigits + 1);
        } else {
            numberString = number.toFixed(fractionDigits + 1);
        }

        var integerString;
        var fractionString;
        var exponentString;

        var temp = numberString.split("e");

        exponentString = temp[1] || "";

        temp = temp[0].split(".");

        fractionString = temp[1] || "";
        integerString = temp[0] || "";

        // Workaround for floating point errors in `toFixed` and `toPrecision`.
        // (3.55).toFixed(1); --> "3.5"
        // (123.55 - 120).toPrecision(2); --> "3.5"
        // (123.55 - 120); --> 3.549999999999997
        // (123.55 - 120).toFixed(2); --> "3.55"
        // Round by examing the string output of the next digit.

        // *************** Implement String Rounding here ***********************
        // Check integerString + fractionString length of toPrecision before rounding.
        // Check length of fractionString from toFixed output before rounding.
        var integerLength = integerString.length;
        var fractionLength = fractionString.length;
        var digitCount = integerLength + fractionLength;
        var digits = integerString + fractionString;

        if (maximumSignificantDigits && digitCount === (maximumSignificantDigits + 1) || !maximumSignificantDigits && fractionLength === (fractionDigits + 1)) {
            // Round digits.
            digits = stringRound(digits);

            if (digits.length === digitCount + 1) {
                integerLength = integerLength + 1;
            }

            // Discard final fractionDigit.
            if (fractionLength) {
                digits = digits.slice(0, -1);
            }

            // Separate integer and fraction.
            integerString = digits.slice(0, integerLength);
            fractionString = digits.slice(integerLength);
        }

        // Trim trailing zeroes from fractionString because toPrecision outputs
        // precision, not significant digits.
        if (maximumSignificantDigits) {
            fractionString = fractionString.replace(/0*$/, "");
        }

        // Handle exponent.
        var exponent = parseInt(exponentString, 10);

        if (exponent > 0) {
            if (fractionString.length <= exponent) {
                fractionString = fractionString + repeatZero(exponent - fractionString.length);

                integerString = integerString + fractionString;
                fractionString = "";
            } else {
                integerString = integerString + fractionString.slice(0, exponent);
                fractionString = fractionString.slice(exponent);
            }
        } else if (exponent < 0) {
            fractionString = (repeatZero(Math.abs(exponent) - integerString.length) + integerString + fractionString);

            integerString = "0";
        }

        if (!maximumSignificantDigits) {
            // Trim or pad fraction when not using maximumSignificantDigits.
            fractionString = fractionString.slice(0, fractionDigits);

            if (fractionString.length < fractionDigits) {
                fractionString = fractionString + repeatZero(fractionDigits - fractionString.length);
            }

            // Pad integer when using minimumIntegerDigits
            // and not using maximumSignificantDigits.
            if (integerString.length < minimumIntegerDigits) {
                integerString = repeatZero(minimumIntegerDigits - integerString.length) + integerString;
            }
        }

        var formattedString = "";

        // Handle grouping.
        if (useGrouping) {
            temp = integerString;
            var group;

            while (temp.length) {
                if (grouping.length) {
                    group = grouping.shift();
                }

                if (formattedString) {
                    formattedString = groupingSeparator + formattedString;
                }

                formattedString = temp.slice(-group) + formattedString;

                temp = temp.slice(0, -group);
            }
        } else {
            formattedString = integerString;
        }

        // Add decimalSeparator and fraction.
        if (fractionString) {
            formattedString = formattedString + decimalSeparator + fractionString;
        }

        return formattedString;
    }

    // durationLabelCompare
    function durationLabelCompare(a, b) {
        if (a.label.length > b.label.length) {
            return -1;
        }

        if (a.label.length < b.label.length) {
            return 1;
        }

        // a must be equal to b
        return 0;
    }

    // durationGetLabels
    function durationGetLabels(token, localeData) {
        var labels = [];

        each(keys(localeData), function (localeDataKey) {
            if (localeDataKey.slice(0, 15) !== "_durationLabels") {
                return;
            }

            var labelType = localeDataKey.slice(15).toLowerCase();

            each(keys(localeData[localeDataKey]), function (labelKey) {
                if (labelKey.slice(0, 1) === token) {
                    labels.push({
                        type: labelType,
                        key: labelKey,
                        label: localeData[localeDataKey][labelKey]
                    });
                }
            });
        });

        return labels;
    }

    // durationPluralKey
    function durationPluralKey(token, integerValue, decimalValue) {
        // Singular for a value of `1`, but not for `1.0`.
        if (integerValue === 1 && decimalValue === null) {
            return token;
        }

        return token + token;
    }

    var engLocale = {
        durationLabelsStandard: {
            S: 'millisecond',
            SS: 'milliseconds',
            s: 'second',
            ss: 'seconds',
            m: 'minute',
            mm: 'minutes',
            h: 'hour',
            hh: 'hours',
            d: 'day',
            dd: 'days',
            w: 'week',
            ww: 'weeks',
            M: 'month',
            MM: 'months',
            y: 'year',
            yy: 'years'
        },
        durationLabelsShort: {
            S: 'msec',
            SS: 'msecs',
            s: 'sec',
            ss: 'secs',
            m: 'min',
            mm: 'mins',
            h: 'hr',
            hh: 'hrs',
            d: 'dy',
            dd: 'dys',
            w: 'wk',
            ww: 'wks',
            M: 'mo',
            MM: 'mos',
            y: 'yr',
            yy: 'yrs'
        },
        durationTimeTemplates: {
            HMS: 'h:mm:ss',
            HM: 'h:mm',
            MS: 'm:ss'
        },
        durationLabelTypes: [
            { type: "standard", string: "__" },
            { type: "short", string: "_" }
        ],
        durationPluralKey: durationPluralKey
    };

    // isArray
    function isArray(array) {
        return Object.prototype.toString.call(array) === "[object Array]";
    }

    // isObject
    function isObject(obj) {
        return Object.prototype.toString.call(obj) === "[object Object]";
    }

    // findLast
    function findLast(array, callback) {
        var index = array.length;

        while (index -= 1) {
            if (callback(array[index])) { return array[index]; }
        }
    }

    // find
    function find(array, callback) {
        var index = 0;

        var max = array && array.length || 0;

        var match;

        if (typeof callback !== "function") {
            match = callback;
            callback = function (item) {
                return item === match;
            };
        }

        while (index < max) {
            if (callback(array[index])) { return array[index]; }
            index += 1;
        }
    }

    // each
    function each(array, callback) {
        var index = 0,
            max = array.length;

        if (!array || !max) { return; }

        while (index < max) {
            if (callback(array[index], index) === false) { return; }
            index += 1;
        }
    }

    // map
    function map(array, callback) {
        var index = 0,
            max = array.length,
            ret = [];

        if (!array || !max) { return ret; }

        while (index < max) {
            ret[index] = callback(array[index], index);
            index += 1;
        }

        return ret;
    }

    // pluck
    function pluck(array, prop) {
        return map(array, function (item) {
            return item[prop];
        });
    }

    // compact
    function compact(array) {
        var ret = [];

        each(array, function (item) {
            if (item) { ret.push(item); }
        });

        return ret;
    }

    // unique
    function unique(array) {
        var ret = [];

        each(array, function (_a) {
            if (!find(ret, _a)) { ret.push(_a); }
        });

        return ret;
    }

    // intersection
    function intersection(a, b) {
        var ret = [];

        each(a, function (_a) {
            each(b, function (_b) {
                if (_a === _b) { ret.push(_a); }
            });
        });

        return unique(ret);
    }

    // rest
    function rest(array, callback) {
        var ret = [];

        each(array, function (item, index) {
            if (!callback(item)) {
                ret = array.slice(index);
                return false;
            }
        });

        return ret;
    }

    // initial
    function initial(array, callback) {
        var reversed = array.slice().reverse();

        return rest(reversed, callback).reverse();
    }

    // extend
    function extend(a, b) {
        for (var key in b) {
            if (b.hasOwnProperty(key)) { a[key] = b[key]; }
        }

        return a;
    }

    // keys
    function keys(a) {
        var ret = [];

        for (var key in a) {
            if (a.hasOwnProperty(key)) { ret.push(key); }
        }

        return ret;
    }

    // any
    function any(array, callback) {
        var index = 0,
            max = array.length;

        if (!array || !max) { return false; }

        while (index < max) {
            if (callback(array[index], index) === true) { return true; }
            index += 1;
        }

        return false;
    }

    // flatten
    function flatten(array) {
        var ret = [];

        each(array, function(child) {
            ret = ret.concat(child);
        });

        return ret;
    }

    function toLocaleStringSupportsLocales() {
        var number = 0;
        try {
            number.toLocaleString('i');
        } catch (e) {
            return e.name === 'RangeError';
        }
        return false;
    }

    function featureTestFormatterRounding(formatter) {
        return formatter(3.55, "en", {
            useGrouping: false,
            minimumIntegerDigits: 1,
            minimumFractionDigits: 1,
            maximumFractionDigits: 1
        }) === "3.6";
    }

    function featureTestFormatter(formatter) {
        var passed = true;

        // Test minimumIntegerDigits.
        passed = passed && formatter(1, "en", { minimumIntegerDigits: 1 }) === "1";
        passed = passed && formatter(1, "en", { minimumIntegerDigits: 2 }) === "01";
        passed = passed && formatter(1, "en", { minimumIntegerDigits: 3 }) === "001";
        if (!passed) { return false; }

        // Test maximumFractionDigits and minimumFractionDigits.
        passed = passed && formatter(99.99, "en", { maximumFractionDigits: 0, minimumFractionDigits: 0 }) === "100";
        passed = passed && formatter(99.99, "en", { maximumFractionDigits: 1, minimumFractionDigits: 1 }) === "100.0";
        passed = passed && formatter(99.99, "en", { maximumFractionDigits: 2, minimumFractionDigits: 2 }) === "99.99";
        passed = passed && formatter(99.99, "en", { maximumFractionDigits: 3, minimumFractionDigits: 3 }) === "99.990";
        if (!passed) { return false; }

        // Test maximumSignificantDigits.
        passed = passed && formatter(99.99, "en", { maximumSignificantDigits: 1 }) === "100";
        passed = passed && formatter(99.99, "en", { maximumSignificantDigits: 2 }) === "100";
        passed = passed && formatter(99.99, "en", { maximumSignificantDigits: 3 }) === "100";
        passed = passed && formatter(99.99, "en", { maximumSignificantDigits: 4 }) === "99.99";
        passed = passed && formatter(99.99, "en", { maximumSignificantDigits: 5 }) === "99.99";
        if (!passed) { return false; }

        // Test grouping.
        passed = passed && formatter(1000, "en", { useGrouping: true }) === "1,000";
        passed = passed && formatter(1000, "en", { useGrouping: false }) === "1000";
        if (!passed) { return false; }

        return true;
    }

    // durationsFormat(durations [, template] [, precision] [, settings])
    function durationsFormat() {
        var args = [].slice.call(arguments);
        var settings = {};
        var durations;

        // Parse arguments.
        each(args, function (arg, index) {
            if (!index) {
                if (!isArray(arg)) {
                    throw "Expected array as the first argument to durationsFormat.";
                }

                durations = arg;
            }

            if (typeof arg === "string" || typeof arg === "function") {
                settings.template = arg;
                return;
            }

            if (typeof arg === "number") {
                settings.precision = arg;
                return;
            }

            if (isObject(arg)) {
                extend(settings, arg);
            }
        });

        if (!durations || !durations.length) {
            return [];
        }

        settings.returnMomentTypes = true;

        var formattedDurations = map(durations, function (dur) {
            return dur.format(settings);
        });

        // Merge token types from all durations.
        var outputTypes = intersection(types, unique(pluck(flatten(formattedDurations), "type")));

        var largest = settings.largest;

        if (largest) {
            outputTypes = outputTypes.slice(0, largest);
        }

        settings.returnMomentTypes = false;
        settings.outputTypes = outputTypes;

        return map(durations, function (dur) {
            return dur.format(settings);
        });
    }

    // durationFormat([template] [, precision] [, settings])
    function durationFormat() {

        var args = [].slice.call(arguments);
        var settings = extend({}, this.format.defaults);

        // Keep a shadow copy of this moment for calculating remainders.
        // Perform all calculations on positive duration value, handle negative
        // sign at the very end.
        var asMilliseconds = this.asMilliseconds();
        var asMonths = this.asMonths();

        // Treat invalid durations as having a value of 0 milliseconds.
        if (typeof this.isValid === "function" && this.isValid() === false) {
            asMilliseconds = 0;
            asMonths = 0;
        }

        var isNegative = asMilliseconds < 0;

        // Two shadow copies are needed because of the way moment.js handles
        // duration arithmetic for years/months and for weeks/days/hours/minutes/seconds.
        var remainder = moment.duration(Math.abs(asMilliseconds), "milliseconds");
        var remainderMonths = moment.duration(Math.abs(asMonths), "months");

        // Parse arguments.
        each(args, function (arg) {
            if (typeof arg === "string" || typeof arg === "function") {
                settings.template = arg;
                return;
            }

            if (typeof arg === "number") {
                settings.precision = arg;
                return;
            }

            if (isObject(arg)) {
                extend(settings, arg);
            }
        });

        var momentTokens = {
            years: "y",
            months: "M",
            weeks: "w",
            days: "d",
            hours: "h",
            minutes: "m",
            seconds: "s",
            milliseconds: "S"
        };

        var tokenDefs = {
            escape: /\[(.+?)\]/,
            years: /\*?[Yy]+/,
            months: /\*?M+/,
            weeks: /\*?[Ww]+/,
            days: /\*?[Dd]+/,
            hours: /\*?[Hh]+/,
            minutes: /\*?m+/,
            seconds: /\*?s+/,
            milliseconds: /\*?S+/,
            general: /.+?/
        };

        // Types array is available in the template function.
        settings.types = types;

        var typeMap = function (token) {
            return find(types, function (type) {
                return tokenDefs[type].test(token);
            });
        };

        var tokenizer = new RegExp(map(types, function (type) {
            return tokenDefs[type].source;
        }).join("|"), "g");

        // Current duration object is available in the template function.
        settings.duration = this;

        // Eval template function and cache template string.
        var template = typeof settings.template === "function" ? settings.template.apply(settings) : settings.template;

        // outputTypes and returnMomentTypes are settings to support durationsFormat().

        // outputTypes is an array of moment token types that determines
        // the tokens returned in formatted output. This option overrides
        // trim, largest, stopTrim, etc.
        var outputTypes = settings.outputTypes;

        // returnMomentTypes is a boolean that sets durationFormat to return
        // the processed momentTypes instead of formatted output.
        var returnMomentTypes = settings.returnMomentTypes;

        var largest = settings.largest;

        // Setup stopTrim array of token types.
        var stopTrim = [];

        if (!outputTypes) {
            if (isArray(settings.stopTrim)) {
                settings.stopTrim = settings.stopTrim.join("");
            }

            // Parse stopTrim string to create token types array.
            if (settings.stopTrim) {
                each(settings.stopTrim.match(tokenizer), function (token) {
                    var type = typeMap(token);

                    if (type === "escape" || type === "general") {
                        return;
                    }

                    stopTrim.push(type);
                });
            }
        }

        // Cache moment's locale data.
        var localeData = moment.localeData();

        if (!localeData) {
            localeData = {};
        }

        // Fall back to this plugin's `eng` extension.
        each(keys(engLocale), function (key) {
            if (typeof engLocale[key] === "function") {
                if (!localeData[key]) {
                    localeData[key] = engLocale[key];
                }

                return;
            }

            if (!localeData["_" + key]) {
                localeData["_" + key] = engLocale[key];
            }
        });

        // Replace Duration Time Template strings.
        // For locale `eng`: `_HMS_`, `_HM_`, and `_MS_`.
        each(keys(localeData._durationTimeTemplates), function (item) {
            template = template.replace("_" + item + "_", localeData._durationTimeTemplates[item]);
        });

        // Determine user's locale.
        var userLocale = settings.userLocale || moment.locale();

        var useLeftUnits = settings.useLeftUnits;
        var usePlural = settings.usePlural;
        var precision = settings.precision;
        var forceLength = settings.forceLength;
        var useGrouping = settings.useGrouping;
        var trunc = settings.trunc;

        // Use significant digits only when precision is greater than 0.
        var useSignificantDigits = settings.useSignificantDigits && precision > 0;
        var significantDigits = useSignificantDigits ? settings.precision : 0;
        var significantDigitsCache = significantDigits;

        var minValue = settings.minValue;
        var isMinValue = false;

        var maxValue = settings.maxValue;
        var isMaxValue = false;

        // formatNumber fallback options.
        var useToLocaleString = settings.useToLocaleString;
        var groupingSeparator = settings.groupingSeparator;
        var decimalSeparator = settings.decimalSeparator;
        var grouping = settings.grouping;

        useToLocaleString = useToLocaleString && (toLocaleStringWorks || intlNumberFormatWorks);

        // Trim options.
        var trim = settings.trim;

        if (isArray(trim)) {
            trim = trim.join(" ");
        }

        if (trim === null && (largest || maxValue || useSignificantDigits)) {
            trim = "all";
        }

        if (trim === null || trim === true || trim === "left" || trim === "right") {
            trim = "large";
        }

        if (trim === false) {
            trim = "";
        }

        var trimIncludes = function (item) {
            return item.test(trim);
        };

        var rLarge = /large/;
        var rSmall = /small/;
        var rBoth = /both/;
        var rMid = /mid/;
        var rAll = /^all|[^sm]all/;
        var rFinal = /final/;

        var trimLarge = largest > 0 || any([rLarge, rBoth, rAll], trimIncludes);
        var trimSmall = any([rSmall, rBoth, rAll], trimIncludes);
        var trimMid = any([rMid, rAll], trimIncludes);
        var trimFinal = any([rFinal, rAll], trimIncludes);

        // Parse format string to create raw tokens array.
        var rawTokens = map(template.match(tokenizer), function (token, index) {
            var type = typeMap(token);

            if (token.slice(0, 1) === "*") {
                token = token.slice(1);

                if (type !== "escape" && type !== "general") {
                    stopTrim.push(type);
                }
            }

            return {
                index: index,
                length: token.length,
                text: "",

                // Replace escaped tokens with the non-escaped token text.
                token: (type === "escape" ? token.replace(tokenDefs.escape, "$1") : token),

                // Ignore type on non-moment tokens.
                type: ((type === "escape" || type === "general") ? null : type)
            };
        });

        // Associate text tokens with moment tokens.
        var currentToken = {
            index: 0,
            length: 0,
            token: "",
            text: "",
            type: null
        };

        var tokens = [];

        if (useLeftUnits) {
            rawTokens.reverse();
        }

        each(rawTokens, function (token) {
            if (token.type) {
                if (currentToken.type || currentToken.text) {
                    tokens.push(currentToken);
                }

                currentToken = token;

                return;
            }

            if (useLeftUnits) {
                currentToken.text = token.token + currentToken.text;
            } else {
                currentToken.text += token.token;
            }
        });

        if (currentToken.type || currentToken.text) {
            tokens.push(currentToken);
        }

        if (useLeftUnits) {
            tokens.reverse();
        }

        // Find unique moment token types in the template in order of
        // descending magnitude.
        var momentTypes = intersection(types, unique(compact(pluck(tokens, "type"))));

        // Exit early if there are no moment token types.
        if (!momentTypes.length) {
            return pluck(tokens, "text").join("");
        }

        // Calculate values for each moment type in the template.
        // For processing the settings, values are associated with moment types.
        // Values will be assigned to tokens at the last step in order to
        // assume nothing about frequency or order of tokens in the template.
        momentTypes = map(momentTypes, function (momentType, index) {
            // Is this the least-magnitude moment token found?
            var isSmallest = ((index + 1) === momentTypes.length);

            // Is this the greatest-magnitude moment token found?
            var isLargest = (!index);

            // Get the raw value in the current units.
            var rawValue;

            if (momentType === "years" || momentType === "months") {
                rawValue = remainderMonths.as(momentType);
            } else {
                rawValue = remainder.as(momentType);
            }

            var wholeValue = Math.floor(rawValue);
            var decimalValue = rawValue - wholeValue;

            var token = find(tokens, function (token) {
                return momentType === token.type;
            });

            if (isLargest && maxValue && rawValue > maxValue) {
                isMaxValue = true;
            }

            if (isSmallest && minValue && Math.abs(settings.duration.as(momentType)) < minValue) {
                isMinValue = true;
            }

            // Note the length of the largest-magnitude moment token:
            // if it is greater than one and forceLength is not set,
            // then default forceLength to `true`.
            //
            // Rationale is this: If the template is "h:mm:ss" and the
            // moment value is 5 minutes, the user-friendly output is
            // "5:00", not "05:00". We shouldn't pad the `minutes` token
            // even though it has length of two if the template is "h:mm:ss";
            //
            // If the minutes output should always include the leading zero
            // even when the hour is trimmed then set `{ forceLength: true }`
            // to output "05:00". If the template is "hh:mm:ss", the user
            // clearly wanted everything padded so we should output "05:00";
            //
            // If the user wants the full padded output, they can use
            // template "hh:mm:ss" and set `{ trim: false }` to output
            // "00:05:00".
            if (isLargest && forceLength === null && token.length > 1) {
                forceLength = true;
            }

            // Update remainder.
            remainder.subtract(wholeValue, momentType);
            remainderMonths.subtract(wholeValue, momentType);

            return {
                rawValue: rawValue,
                wholeValue: wholeValue,
                // Decimal value is only retained for the least-magnitude
                // moment type in the format template.
                decimalValue: isSmallest ? decimalValue : 0,
                isSmallest: isSmallest,
                isLargest: isLargest,
                type: momentType,
                // Tokens can appear multiple times in a template string,
                // but all instances must share the same length.
                tokenLength: token.length
            };
        });

        var truncMethod = trunc ? Math.floor : Math.round;
        var truncate = function (value, places) {
            var factor = Math.pow(10, places);
            return truncMethod(value * factor) / factor;
        };

        var foundFirst = false;
        var bubbled = false;

        var formatValue = function (momentType, index) {
            var formatOptions = {
                useGrouping: useGrouping,
                groupingSeparator: groupingSeparator,
                decimalSeparator: decimalSeparator,
                grouping: grouping,
                useToLocaleString: useToLocaleString
            };

            if (useSignificantDigits) {
                if (significantDigits <= 0) {
                    momentType.rawValue = 0;
                    momentType.wholeValue = 0;
                    momentType.decimalValue = 0;
                } else {
                    formatOptions.maximumSignificantDigits = significantDigits;
                    momentType.significantDigits = significantDigits;
                }
            }

            if (isMaxValue && !bubbled) {
                if (momentType.isLargest) {
                    momentType.wholeValue = maxValue;
                    momentType.decimalValue = 0;
                } else {
                    momentType.wholeValue = 0;
                    momentType.decimalValue = 0;
                }
            }

            if (isMinValue && !bubbled) {
                if (momentType.isSmallest) {
                    momentType.wholeValue = minValue;
                    momentType.decimalValue = 0;
                } else {
                    momentType.wholeValue = 0;
                    momentType.decimalValue = 0;
                }
            }

            if (momentType.isSmallest || momentType.significantDigits && momentType.significantDigits - momentType.wholeValue.toString().length <= 0) {
                // Apply precision to least significant token value.
                if (precision < 0) {
                    momentType.value = truncate(momentType.wholeValue, precision);
                } else if (precision === 0) {
                    momentType.value = truncMethod(momentType.wholeValue + momentType.decimalValue);
                } else { // precision > 0
                    if (useSignificantDigits) {
                        if (trunc) {
                            momentType.value = truncate(momentType.rawValue, significantDigits - momentType.wholeValue.toString().length);
                        } else {
                            momentType.value = momentType.rawValue;
                        }

                        if (momentType.wholeValue) {
                            significantDigits -= momentType.wholeValue.toString().length;
                        }
                    } else {
                        formatOptions.fractionDigits = precision;

                        if (trunc) {
                            momentType.value = momentType.wholeValue + truncate(momentType.decimalValue, precision);
                        } else {
                            momentType.value = momentType.wholeValue + momentType.decimalValue;
                        }
                    }
                }
            } else {
                if (useSignificantDigits && momentType.wholeValue) {
                    // Outer Math.round required here to handle floating point errors.
                    momentType.value = Math.round(truncate(momentType.wholeValue, momentType.significantDigits - momentType.wholeValue.toString().length));

                    significantDigits -= momentType.wholeValue.toString().length;
                } else {
                    momentType.value = momentType.wholeValue;
                }
            }

            if (momentType.tokenLength > 1 && (forceLength || foundFirst)) {
                formatOptions.minimumIntegerDigits = momentType.tokenLength;

                if (bubbled && formatOptions.maximumSignificantDigits < momentType.tokenLength) {
                    delete formatOptions.maximumSignificantDigits;
                }
            }

            if (!foundFirst && (momentType.value > 0 || trim === "" /* trim: false */ || find(stopTrim, momentType.type) || find(outputTypes, momentType.type))) {
                foundFirst = true;
            }

            momentType.formattedValue = formatNumber(momentType.value, formatOptions, userLocale);

            formatOptions.useGrouping = false;
            formatOptions.decimalSeparator = ".";
            momentType.formattedValueEn = formatNumber(momentType.value, formatOptions, "en");

            if (momentType.tokenLength === 2 && momentType.type === "milliseconds") {
                momentType.formattedValueMS = formatNumber(momentType.value, {
                    minimumIntegerDigits: 3,
                    useGrouping: false
                }, "en").slice(0, 2);
            }

            return momentType;
        };

        // Calculate formatted values.
        momentTypes = map(momentTypes, formatValue);
        momentTypes = compact(momentTypes);

        // Bubble rounded values.
        if (momentTypes.length > 1) {
            var findType = function (type) {
                return find(momentTypes, function (momentType) {
                    return momentType.type === type;
                });
            };

            var bubbleTypes = function (bubble) {
                var bubbleMomentType = findType(bubble.type);

                if (!bubbleMomentType) {
                    return;
                }

                each(bubble.targets, function (target) {
                    var targetMomentType = findType(target.type);

                    if (!targetMomentType) {
                        return;
                    }

                    if (parseInt(bubbleMomentType.formattedValueEn, 10) === target.value) {
                        bubbleMomentType.rawValue = 0;
                        bubbleMomentType.wholeValue = 0;
                        bubbleMomentType.decimalValue = 0;
                        targetMomentType.rawValue += 1;
                        targetMomentType.wholeValue += 1;
                        targetMomentType.decimalValue = 0;
                        targetMomentType.formattedValueEn = targetMomentType.wholeValue.toString();
                        bubbled = true;
                    }
                });
            };

            each(bubbles, bubbleTypes);
        }

        // Recalculate formatted values.
        if (bubbled) {
            foundFirst = false;
            significantDigits = significantDigitsCache;
            momentTypes = map(momentTypes, formatValue);
            momentTypes = compact(momentTypes);
        }

        if (outputTypes && !(isMaxValue && !settings.trim)) {
            momentTypes = map(momentTypes, function (momentType) {
                if (find(outputTypes, function (outputType) {
                    return momentType.type === outputType;
                })) {
                    return momentType;
                }

                return null;
            });

            momentTypes = compact(momentTypes);
        } else {
            // Trim Large.
            if (trimLarge) {
                momentTypes = rest(momentTypes, function (momentType) {
                    // Stop trimming on:
                    // - the smallest moment type
                    // - a type marked for stopTrim
                    // - a type that has a whole value
                    return !momentType.isSmallest && !momentType.wholeValue && !find(stopTrim, momentType.type);
                });
            }

            // Largest.
            if (largest && momentTypes.length) {
                momentTypes = momentTypes.slice(0, largest);
            }

            // Trim Small.
            if (trimSmall && momentTypes.length > 1) {
                momentTypes = initial(momentTypes, function (momentType) {
                    // Stop trimming on:
                    // - a type marked for stopTrim
                    // - a type that has a whole value
                    // - the largest momentType
                    return !momentType.wholeValue && !find(stopTrim, momentType.type) && !momentType.isLargest;
                });
            }

            // Trim Mid.
            if (trimMid) {
                momentTypes = map(momentTypes, function (momentType, index) {
                    if (index > 0 && index < momentTypes.length - 1 && !momentType.wholeValue) {
                        return null;
                    }

                    return momentType;
                });

                momentTypes = compact(momentTypes);
            }

            // Trim Final.
            if (trimFinal && momentTypes.length === 1 && !momentTypes[0].wholeValue && !(!trunc && momentTypes[0].isSmallest && momentTypes[0].rawValue < minValue)) {
                momentTypes = [];
            }
        }

        if (returnMomentTypes) {
            return momentTypes;
        }

        // Localize and pluralize unit labels.
        each(tokens, function (token) {
            var key = momentTokens[token.type];

            var momentType = find(momentTypes, function (momentType) {
                return momentType.type === token.type;
            });

            if (!key || !momentType) {
                return;
            }

            var values = momentType.formattedValueEn.split(".");

            values[0] = parseInt(values[0], 10);

            if (values[1]) {
                values[1] = parseFloat("0." + values[1], 10);
            } else {
                values[1] = null;
            }

            var pluralKey = localeData.durationPluralKey(key, values[0], values[1]);

            var labels = durationGetLabels(key, localeData);

            var autoLocalized = false;

            var pluralizedLabels = {};

            // Auto-Localized unit labels.
            each(localeData._durationLabelTypes, function (labelType) {
                var label = find(labels, function (label) {
                    return label.type === labelType.type && label.key === pluralKey;
                });

                if (label) {
                    pluralizedLabels[label.type] = label.label;

                    if (stringIncludes(token.text, labelType.string)) {
                        token.text = token.text.replace(labelType.string, label.label);
                        autoLocalized = true;
                    }
                }
            });

            // Auto-pluralized unit labels.
            if (usePlural && !autoLocalized) {
                labels.sort(durationLabelCompare);

                each(labels, function (label) {
                    if (pluralizedLabels[label.type] === label.label) {
                        if (stringIncludes(token.text, label.label)) {
                            // Stop checking this token if its label is already
                            // correctly pluralized.
                            return false;
                        }

                        // Skip this label if it is correct, but not present in
                        // the token's text.
                        return;
                    }

                    if (stringIncludes(token.text, label.label)) {
                        // Replece this token's label and stop checking.
                        token.text = token.text.replace(label.label, pluralizedLabels[label.type]);
                        return false;
                    }
                });
            }
        });

        // Build ouptut.
        tokens = map(tokens, function (token) {
            if (!token.type) {
                return token.text;
            }

            var momentType = find(momentTypes, function (momentType) {
                return momentType.type === token.type;
            });

            if (!momentType) {
                return "";
            }

            var out = "";

            if (useLeftUnits) {
                out += token.text;
            }

            if (isNegative && isMaxValue || !isNegative && isMinValue) {
                out += "< ";
                isMaxValue = false;
                isMinValue = false;
            }

            if (isNegative && isMinValue || !isNegative && isMaxValue) {
                out += "> ";
                isMaxValue = false;
                isMinValue = false;
            }

            if (isNegative && (momentType.value > 0 || trim === "" || find(stopTrim, momentType.type) || find(outputTypes, momentType.type))) {
                out += "-";
                isNegative = false;
            }

            if (token.type === "milliseconds" && momentType.formattedValueMS) {
                out += momentType.formattedValueMS;
            } else {
                out += momentType.formattedValue;
            }

            if (!useLeftUnits) {
                out += token.text;
            }

            return out;
        });

        // Trim leading and trailing comma, space, colon, and dot.
        return tokens.join("").replace(/(,| |:|\.)*$/, "").replace(/^(,| |:|\.)*/, "");
    }

    // defaultFormatTemplate
    function defaultFormatTemplate() {
        var dur = this.duration;

        var findType = function findType(type) {
            return dur._data[type];
        };

        var firstType = find(this.types, findType);

        var lastType = findLast(this.types, findType);

        // Default template strings for each duration dimension type.
        switch (firstType) {
            case "milliseconds":
                return "S __";
            case "seconds": // Fallthrough.
            case "minutes":
                return "*_MS_";
            case "hours":
                return "_HMS_";
            case "days": // Possible Fallthrough.
                if (firstType === lastType) {
                    return "d __";
                }
            case "weeks":
                if (firstType === lastType) {
                    return "w __";
                }

                if (this.trim === null) {
                    this.trim = "both";
                }

                return "w __, d __, h __";
            case "months": // Possible Fallthrough.
                if (firstType === lastType) {
                    return "M __";
                }
            case "years":
                if (firstType === lastType) {
                    return "y __";
                }

                if (this.trim === null) {
                    this.trim = "both";
                }

                return "y __, M __, d __";
            default:
                if (this.trim === null) {
                    this.trim = "both";
                }

                return "y __, d __, h __, m __, s __";
        }
    }

    // init
    function init(context) {
        if (!context) {
            throw "Moment Duration Format init cannot find moment instance.";
        }

        context.duration.format = durationsFormat;
        context.duration.fn.format = durationFormat;

        context.duration.fn.format.defaults = {
            // Many options are defaulted to `null` to distinguish between
            // 'not set' and 'set to `false`'

            // trim
            // Can be a string, a delimited list of strings, an array of strings,
            // or a boolean.
            // "large" - will trim largest-magnitude zero-value tokens until
            // finding a token with a value, a token identified as 'stopTrim', or
            // the final token of the format string.
            // "small" - will trim smallest-magnitude zero-value tokens until
            // finding a token with a value, a token identified as 'stopTrim', or
            // the final token of the format string.
            // "both" - will execute "large" trim then "small" trim.
            // "mid" - will trim any zero-value tokens that are not the first or
            // last tokens. Usually used in conjunction with "large" or "both".
            // e.g. "large mid" or "both mid".
            // "final" - will trim the final token if it is zero-value. Use this
            // option with "large" or "both" to output an empty string when
            // formatting a zero-value duration. e.g. "large final" or "both final".
            // "all" - Will trim all zero-value tokens. Shorthand for "both mid final".
            // "left" - maps to "large" to support plugin's version 1 API.
            // "right" - maps to "large" to support plugin's version 1 API.
            // `false` - template tokens are not trimmed.
            // `true` - treated as "large".
            // `null` - treated as "large".
            trim: null,

            // stopTrim
            // A moment token string, a delimited set of moment token strings,
            // or an array of moment token strings. Trimming will stop when a token
            // listed in this option is reached. A "*" character in the format
            // template string will also mark a moment token as stopTrim.
            // e.g. "d [days] *h:mm:ss" will always stop trimming at the 'hours' token.
            stopTrim: null,

            // largest
            // Set to a positive integer to output only the "n" largest-magnitude
            // moment tokens that have a value. All lesser-magnitude moment tokens
            // will be ignored. This option takes effect even if `trim` is set
            // to `false`.
            largest: null,

            // maxValue
            // Use `maxValue` to render generalized output for large duration values,
            // e.g. `"> 60 days"`. `maxValue` must be a positive integer and is
            /// applied to the greatest-magnitude moment token in the format template.
            maxValue: null,

            // minValue
            // Use `minValue` to render generalized output for small duration values,
            // e.g. `"< 5 minutes"`. `minValue` must be a positive integer and is
            // applied to the least-magnitude moment token in the format template.
            minValue: null,

            // precision
            // If a positive integer, number of decimal fraction digits to render.
            // If a negative integer, number of integer place digits to truncate to 0.
            // If `useSignificantDigits` is set to `true` and `precision` is a positive
            // integer, sets the maximum number of significant digits used in the
            // formatted output.
            precision: 0,

            // trunc
            // Default behavior rounds final token value. Set to `true` to
            // truncate final token value, which was the default behavior in
            // version 1 of this plugin.
            trunc: false,

            // forceLength
            // Force first moment token with a value to render at full length
            // even when template is trimmed and first moment token has length of 1.
            forceLength: null,

            // userLocale
            // Formatted numerical output is rendered using `toLocaleString`
            // and the locale of the user's environment. Set this option to render
            // numerical output using a different locale. Unit names are rendered
            // and detected using the locale set in moment.js, which can be different
            // from the locale of user's environment.
            userLocale: null,

            // usePlural
            // Will automatically singularize or pluralize unit names when they
            // appear in the text associated with each moment token. Standard and
            // short unit labels are singularized and pluralized, based on locale.
            // e.g. in english, "1 second" or "1 sec" would be rendered instead
            // of "1 seconds" or "1 secs". The default pluralization function
            // renders a plural label for a value with decimal precision.
            // e.g. "1.0 seconds" is never rendered as "1.0 second".
            // Label types and pluralization function are configurable in the
            // localeData extensions.
            usePlural: true,

            // useLeftUnits
            // The text to the right of each moment token in a format string
            // is treated as that token's units for the purposes of trimming,
            // singularizing, and auto-localizing.
            // e.g. "h [hours], m [minutes], s [seconds]".
            // To properly singularize or localize a format string such as
            // "[hours] h, [minutes] m, [seconds] s", where the units appear
            // to the left of each moment token, set useLeftUnits to `true`.
            // This plugin is not tested in the context of rtl text.
            useLeftUnits: false,

            // useGrouping
            // Enables locale-based digit grouping in the formatted output. See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString
            useGrouping: true,

            // useSignificantDigits
            // Treat the `precision` option as the maximum significant digits
            // to be rendered. Precision must be a positive integer. Significant
            // digits extend across unit types,
            // e.g. "6 hours 37.5 minutes" represents 4 significant digits.
            // Enabling this option causes token length to be ignored. See  https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString
            useSignificantDigits: false,

            // template
            // The template string used to format the duration. May be a function
            // or a string. Template functions are executed with the `this` binding
            // of the settings object so that template strings may be dynamically
            // generated based on the duration object (accessible via `this.duration`)
            // or any of the other settings. Leading and trailing space, comma,
            // period, and colon characters are trimmed from the resulting string.
            template: defaultFormatTemplate,

            // useToLocaleString
            // Set this option to `false` to ignore the `toLocaleString` feature
            // test and force the use of the `formatNumber` fallback function
            // included in this plugin.
            useToLocaleString: true,

            // formatNumber fallback options.
            // When `toLocaleString` is detected and passes the feature test, the
            // following options will have no effect: `toLocaleString` will be used
            // for formatting and the grouping separator, decimal separator, and
            // integer digit grouping will be determined by the user locale.

            // groupingSeparator
            // The integer digit grouping separator used when using the fallback
            // formatNumber function.
            groupingSeparator: ",",

            // decimalSeparator
            // The decimal separator used when using the fallback formatNumber
            // function.
            decimalSeparator: ".",

            // grouping
            // The integer digit grouping used when using the fallback formatNumber
            // function. Must be an array. The default value of `[3]` gives the
            // standard 3-digit thousand/million/billion digit groupings for the
            // "en" locale. Setting this option to `[3, 2]` would generate the
            // thousand/lakh/crore digit groupings used in the "en-IN" locale.
            grouping: [3]
        };

        context.updateLocale('en', engLocale);
    }

    // Run feature tests for `Number#toLocaleString`.
    var toLocaleStringFormatter = function(number, locale, options) {
        return number.toLocaleString(locale, options);
    };

    toLocaleStringWorks = toLocaleStringSupportsLocales() && featureTestFormatter(toLocaleStringFormatter);
    toLocaleStringRoundingWorks = toLocaleStringWorks && featureTestFormatterRounding(toLocaleStringFormatter);

    // Run feature tests for `Intl.NumberFormat#format`.
    var intlNumberFormatFormatter = function(number, locale, options) {
        if (typeof window !== 'undefined' && window && window.Intl && window.Intl.NumberFormat) {
            return window.Intl.NumberFormat(locale, options).format(number);
        }
    };

    intlNumberFormatWorks = featureTestFormatter(intlNumberFormatFormatter);
    intlNumberFormatRoundingWorks = intlNumberFormatWorks && featureTestFormatterRounding(intlNumberFormatFormatter);

    // Initialize duration format on the global moment instance.
    init(moment);

    // Return the init function so that duration format can be
    // initialized on other moment instances.
    return init;
});


/***/ }),
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SellerInviteSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_src_app_components_EmailField__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_src_app_components_NotificationPreview__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_src_app_components_PanelFooter__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_ComboBox__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__build_node_modules_office_ui_fabric_react_lib_Dropdown__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__build_node_modules_office_ui_fabric_react_lib_Panel__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__build_node_modules_office_ui_fabric_react_lib_TextField__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__build_node_modules_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp2;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var defaultData={email:'',phoneNumber:'',salutation:'mr',title:'',firstName:'',lastName:''};var SellerInviteSection=Object(__WEBPACK_IMPORTED_MODULE_2__build_src_app_components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx_react__["e" /* observer */])(_class=(_temp2=_class2=function(_Component){_inherits(SellerInviteSection,_Component);function SellerInviteSection(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,SellerInviteSection);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SellerInviteSection.__proto__||Object.getPrototypeOf(SellerInviteSection)).call.apply(_ref,[this].concat(args))),_this),_this.handleInvite=function(){var seller=_this.props.seller;seller.invite();},_this.handleBlock=function(){var seller=_this.props.seller;seller.block();},_this.handleCancel=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(){var seller;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:seller=_this.props.seller;seller.close();case 2:case'end':return _context.stop();}}},_callee,_this2);})),_this.handleChanged=function(field){return function(value,_,customValue){var seller=_this.props.seller;seller.propChanged(field,value,customValue);};},_this.handleTitleChanged=function(option,_,value){var seller=_this.props.seller;seller.titleChanged(option,value);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SellerInviteSection,[{key:'componentDidMount',value:function componentDidMount(){var seller=this.props.seller;seller.setData(defaultData);}},{key:'render',value:function render(){var _this3=this;var _props=this.props,sale=_props.sale,seller=_props.seller,t=_props.t;var config=sale.saleConfig;return __WEBPACK_IMPORTED_MODULE_11__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_11__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__build_node_modules_office_ui_fabric_react_lib_Panel__["a" /* Panel */],{headerText:t('Invite Seller'),type:__WEBPACK_IMPORTED_MODULE_9__build_node_modules_office_ui_fabric_react_lib_Panel__["b" /* PanelType */].medium,onDismiss:this.handleCancel,isOpen:true,isFooterAtBottom:true,closeButtonAriaLabel:'Close',onRenderFooterContent:function onRenderFooterContent(){return __WEBPACK_IMPORTED_MODULE_11__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_src_app_components_PanelFooter__["a" /* FooterContainer */],null,__WEBPACK_IMPORTED_MODULE_11__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_Button__["f" /* DefaultButton */],{text:t('Block'),onClick:_this3.handleBlock}),__WEBPACK_IMPORTED_MODULE_11__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_Button__["h" /* PrimaryButton */],{text:t('Invite'),onClick:_this3.handleInvite}),__WEBPACK_IMPORTED_MODULE_11__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx_react__["a" /* Observer */],{render:function render(){return __WEBPACK_IMPORTED_MODULE_11__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_src_app_components_NotificationPreview__["a" /* default */],{action:'/api/v1/sellers/invite/notifications',trigger:'button',query:{locale:_this3.props.intl.locale},data:{saleId:sale.saleId,data:seller.data}});}}),__WEBPACK_IMPORTED_MODULE_11__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_Button__["f" /* DefaultButton */],{text:t('Cancel'),onClick:_this3.handleCancel}));}},__WEBPACK_IMPORTED_MODULE_11__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid'},__WEBPACK_IMPORTED_MODULE_11__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_11__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-lg6 ms-md12 ms-sm12'},__WEBPACK_IMPORTED_MODULE_11__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_src_app_components_EmailField__["a" /* default */],{label:t('Email'),value:seller.data.email,iconProps:{iconName:'Mail'},required:true,onChanged:this.handleChanged('email'),validateOnLoad:false,autoComplete:'nope',validateOnFocusOut:true})),__WEBPACK_IMPORTED_MODULE_11__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-lg6 ms-md12 ms-sm12'},__WEBPACK_IMPORTED_MODULE_11__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__build_node_modules_office_ui_fabric_react_lib_TextField__["a" /* TextField */],{label:t('Phone number'),placeholder:'+49 150 0000 0000',value:seller.data.phoneNumber,iconProps:{iconName:'Phone'},onChanged:this.handleChanged('phoneNumber'),validateOnLoad:false,errorMessage:seller.phoneNumberError===''?seller.phoneNumberError:t(seller.phoneNumberError),validateOnFocusIn:true,validateOnFocusOut:true,autoComplete:'nope',inputMode:'tel'}))),__WEBPACK_IMPORTED_MODULE_11__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_11__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-md12 ms-sm12 ms-lg6'},__WEBPACK_IMPORTED_MODULE_11__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_ComboBox__["a" /* ComboBox */],{label:t('Salutation'),name:'salutation',required:true,allowFreeform:false,autoComplete:'nope',onChanged:this.handleChanged('salutation'),value:seller.data.salutation?t('salutation::'+seller.data.salutation):'',options:config.salutationTypes.map(function(key){return{key:key,text:t('salutation::'+key)};})})),__WEBPACK_IMPORTED_MODULE_11__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-md12 ms-sm12 ms-lg6'},__WEBPACK_IMPORTED_MODULE_11__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_ComboBox__["a" /* ComboBox */],{label:t('Title'),name:'title',allowFreeform:true,autoComplete:'nope',onChanged:this.handleTitleChanged,value:seller.data.title?t('title::'+seller.data.title):'',options:[{key:'',text:''}].concat(config.titleTypes.map(function(key){return{key:key,text:t('title::'+key)};}))}))),__WEBPACK_IMPORTED_MODULE_11__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_11__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-md12 ms-sm12 ms-lg6'},__WEBPACK_IMPORTED_MODULE_11__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__build_node_modules_office_ui_fabric_react_lib_TextField__["a" /* TextField */],{label:t('First name'),value:seller.data.firstName,onChanged:this.handleChanged('firstName'),required:true,validateOnLoad:false,onGetErrorMessage:this.requiredValidation,validateOnFocusOut:true,autoComplete:'nope'})),__WEBPACK_IMPORTED_MODULE_11__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-md12 ms-sm12 ms-lg6'},__WEBPACK_IMPORTED_MODULE_11__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__build_node_modules_office_ui_fabric_react_lib_TextField__["a" /* TextField */],{label:t('Last name'),value:seller.data.lastName,onChanged:this.handleChanged('lastName'),required:true,validateOnLoad:false,onGetErrorMessage:this.requiredValidation,validateOnFocusOut:true,autoComplete:'nope'}))),config.localeCodes.length>1&&__WEBPACK_IMPORTED_MODULE_11__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_11__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-lg12 ms-md12 ms-sm12'},__WEBPACK_IMPORTED_MODULE_11__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__build_node_modules_office_ui_fabric_react_lib_Dropdown__["a" /* Dropdown */],{label:t('Locale'),selectedKey:seller.data.locale,onChanged:this.handleChanged('locale'),options:config.localeCodes.map(function(key){return{key:key,text:t('locale::'+key)};})}))),seller.isBlocked&&__WEBPACK_IMPORTED_MODULE_11__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row',style:{color:'rgb(168, 0, 0)',marginTop:'15px'}},__WEBPACK_IMPORTED_MODULE_11__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-md12 ms-sm12 ms-lg6'},t('Blocked'))))));}}]);return SellerInviteSection;}(__WEBPACK_IMPORTED_MODULE_11__build_node_modules_react__["Component"]),_class2.displayName='SellerInviteSection',_temp2))||_class)||_class;

/***/ }),
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_styled_components__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_src_app_components_Prompt__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2,_descriptor,_class3,_temp2;var _templateObject=_taggedTemplateLiteral(['\n  font-size: 120%;\n\n  text-align: center;\n\n  & strong {\n    white-space: nowrap;\n  }\n'],['\n  font-size: 120%;\n\n  text-align: center;\n\n  & strong {\n    white-space: nowrap;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  & strong {\n    color: red;\n    font-weight: bold;\n  }\n'],['\n  & strong {\n    color: red;\n    font-weight: bold;\n  }\n']);function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var OpenPromptNotice=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_styled_components__["a" /* default */].p(_templateObject);var BillingNotice=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_styled_components__["a" /* default */].p(_templateObject2);function getBillingNotice(t,roundType){var keys=['billing_notice_'+roundType,'billing_notice'];var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=keys[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var key=_step.value;var result=t(key);if(result!==key&&result.trim()!=='')return result;}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return'';}var OpenRoundConfirmation=(_dec=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["d" /* inject */])('app'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["e" /* observer */])(_class=(_class2=(_temp2=_class3=function(_Component){_inherits(OpenRoundConfirmation,_Component);function OpenRoundConfirmation(){var _ref;var _temp,_this,_ret;_classCallCheck(this,OpenRoundConfirmation);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=OpenRoundConfirmation.__proto__||Object.getPrototypeOf(OpenRoundConfirmation)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'confirm',_descriptor,_this),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(OpenRoundConfirmation,[{key:'render',value:function render(){var _this2=this;var _props=this.props,sale=_props.sale,t=_props.t,locale=_props.locale;var duration=sale.round.definition.durationType==='flexible'?!!sale.round.definition.durationInDays?__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default.a.duration(sale.round.definition.durationInDays,'days'):null:!!sale.round.definition.endsAt?__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default.a.duration(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default()(sale.round.definition.endsAt)-__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default()()):null;var data=Object.assign({duration:!!duration?duration.humanize(true):null,date:__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default()(sale.round.definition.endsAt).format('dddd, ll'),time:__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default()(sale.round.definition.endsAt).format('LT')},sale.round.definition.type==='sealed_bidding'?{estimate:!!sale.round.definition.estimate?sale.round.definition.estimate.toFormattedMoney(locale,this.props.app.currency.code):t('No estimate')}:{startPrice:!!sale.round.definition.startPrice?sale.round.definition.startPrice.toFormattedMoney(locale,this.props.app.currency.code):t('No starting price')},sale.round.definition.startsAt&&__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default()(sale.round.definition.startsAt).isAfter(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default()())?{start:__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default.a.duration(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default()(sale.round.definition.startsAt)-__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default()()).humanize(true),startDate:__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default()(sale.round.definition.startsAt).format('dddd, ll'),startTime:__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default()(sale.round.definition.startsAt).format('LT'),biddingDuration:__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default.a.duration(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default()(sale.round.definition.endsAt)-__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default()(sale.round.definition.startsAt)).humanize(true)}:{});function getRoundType(_ref2){var type=_ref2.type,enableFlexibleBidding=_ref2.enableFlexibleBidding;switch(sale.round.definition.type){case'incremental_auction':return enableFlexibleBidding?'incremental_auction':'openBidding';case'sealed_bidding':return'sealedBidding';case'open_bidding':return'openBidding';default:return type;}}var durationInDays=!duration?null:duration.asDays().toFixed(0);// days()
var canOpen=sale.round.definition.type==='simple_offer'||duration===null||duration.asMinutes()>=0;var localizationKey=!canOpen?'open_round_info_invalid_duration':['open_round_info_notice',getRoundType(sale.round.definition),sale.round.definition.durationType,data.start?'withstart':undefined].filter(Boolean).join('_');var haveToConfirm=!!durationInDays&&(durationInDays<1||durationInDays>14);var confirmationKey=durationInDays>14?'too_long':'today';return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_src_app_components_Prompt__["a" /* default */],Object.assign({},sale.ui.prompt,{onSubmit:function onSubmit(){if(haveToConfirm){_this2.confirm=true;return;}return sale.ui.prompt.onSubmit();},opened:sale.ui.prompt.opened,dialogProps:{maxWidth:'500px'},showPrimaryButton:canOpen,defaultButtonText:canOpen?null:t('close')}),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_src_app_components_Prompt__["a" /* default */],Object.assign({},sale.ui.prompt,{opened:this.confirm,onSubmit:function onSubmit(){_this2.confirm=false;return sale.ui.prompt.onSubmit();},onClose:function onClose(){_this2.confirm=false;return sale.ui.prompt.onClose();},dialogProps:{maxWidth:'500px'}}),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(OpenPromptNotice,{dangerouslySetInnerHTML:{__html:t('open_round_deadline_'+confirmationKey,{durationInDays:durationInDays})}})),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(OpenPromptNotice,{dangerouslySetInnerHTML:{__html:t(localizationKey,data)}}),canOpen&&sale.round.definition.number===1&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(BillingNotice,{dangerouslySetInnerHTML:{__html:getBillingNotice(t,sale.round.definition.type)}}),canOpen&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',null,t('Do you want to open the round?')));}}]);return OpenRoundConfirmation;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class3.displayName='OpenRoundConfirmation',_temp2),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'confirm',[__WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}})),_class2))||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (OpenRoundConfirmation);

/***/ }),
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1126);
module.exports = __webpack_require__(1130);


/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(1127).enable();
  window.Promise = __webpack_require__(1129);
}

// fetch() polyfill for making API calls.
__webpack_require__(494);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(217);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
  require('jest-localstorage-mock');
}


/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(493);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)))

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(493);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 1130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app__ = __webpack_require__(1131);


/***/ }),
/* 1131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_polyfill__ = __webpack_require__(1132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_react_dom__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_react_intl__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_react_intl_locale_data_en__ = __webpack_require__(1358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_react_intl_locale_data_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react_intl_locale_data_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_node_modules_react_intl_locale_data_de__ = __webpack_require__(1359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_node_modules_react_intl_locale_data_de___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_react_intl_locale_data_de__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__build_node_modules_react_intl_locale_data_es__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__build_node_modules_react_intl_locale_data_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__build_node_modules_react_intl_locale_data_es__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__build_node_modules_react_intl_locale_data_fi__ = __webpack_require__(1361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__build_node_modules_react_intl_locale_data_fi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__build_node_modules_react_intl_locale_data_fi__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__build_node_modules_react_intl_locale_data_fr__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__build_node_modules_react_intl_locale_data_fr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react_intl_locale_data_fr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__build_node_modules_react_intl_locale_data_it__ = __webpack_require__(1363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__build_node_modules_react_intl_locale_data_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__build_node_modules_react_intl_locale_data_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__build_node_modules_react_intl_locale_data_ro__ = __webpack_require__(1364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__build_node_modules_react_intl_locale_data_ro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__build_node_modules_react_intl_locale_data_ro__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__build_node_modules_react_intl_locale_data_sl__ = __webpack_require__(1365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__build_node_modules_react_intl_locale_data_sl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react_intl_locale_data_sl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__build_node_modules_react_intl_locale_data_bs__ = __webpack_require__(1366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__build_node_modules_react_intl_locale_data_bs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__build_node_modules_react_intl_locale_data_bs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__stores__ = __webpack_require__(1367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__containers_App__ = __webpack_require__(2130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__helpers_extensions__ = __webpack_require__(2313);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}// import 'moment/locale/de';
// import 'moment/locale/fr';
// import 'moment/locale/it';
var render=function render(Component){Object(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react_intl__["c" /* addLocaleData */])([].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react_intl_locale_data_en___default.a),_toConsumableArray(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_react_intl_locale_data_de___default.a),_toConsumableArray(__WEBPACK_IMPORTED_MODULE_7__build_node_modules_react_intl_locale_data_es___default.a),_toConsumableArray(__WEBPACK_IMPORTED_MODULE_8__build_node_modules_react_intl_locale_data_fi___default.a),_toConsumableArray(__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react_intl_locale_data_fr___default.a),_toConsumableArray(__WEBPACK_IMPORTED_MODULE_10__build_node_modules_react_intl_locale_data_it___default.a),_toConsumableArray(__WEBPACK_IMPORTED_MODULE_11__build_node_modules_react_intl_locale_data_ro___default.a),_toConsumableArray(__WEBPACK_IMPORTED_MODULE_12__build_node_modules_react_intl_locale_data_sl___default.a),_toConsumableArray(__WEBPACK_IMPORTED_MODULE_13__build_node_modules_react_intl_locale_data_bs___default.a)));__WEBPACK_IMPORTED_MODULE_2__build_node_modules_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx_react__["c" /* Provider */],__WEBPACK_IMPORTED_MODULE_14__stores__["a" /* default */],__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(Component,null)),document.getElementById('app'));};render(__WEBPACK_IMPORTED_MODULE_15__containers_App__["a" /* default */]);

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(1133);

__webpack_require__(1330);

__webpack_require__(1331);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)))

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1134);
__webpack_require__(1137);
__webpack_require__(1138);
__webpack_require__(1139);
__webpack_require__(1140);
__webpack_require__(1141);
__webpack_require__(1142);
__webpack_require__(1143);
__webpack_require__(1144);
__webpack_require__(1145);
__webpack_require__(1146);
__webpack_require__(1147);
__webpack_require__(1148);
__webpack_require__(1149);
__webpack_require__(1150);
__webpack_require__(1151);
__webpack_require__(1152);
__webpack_require__(1153);
__webpack_require__(1154);
__webpack_require__(1155);
__webpack_require__(1156);
__webpack_require__(1157);
__webpack_require__(1158);
__webpack_require__(1159);
__webpack_require__(1160);
__webpack_require__(1161);
__webpack_require__(1162);
__webpack_require__(1163);
__webpack_require__(1164);
__webpack_require__(1165);
__webpack_require__(1166);
__webpack_require__(1167);
__webpack_require__(1168);
__webpack_require__(1169);
__webpack_require__(1170);
__webpack_require__(1171);
__webpack_require__(1172);
__webpack_require__(1173);
__webpack_require__(1174);
__webpack_require__(1175);
__webpack_require__(1176);
__webpack_require__(1177);
__webpack_require__(1178);
__webpack_require__(1179);
__webpack_require__(1180);
__webpack_require__(1181);
__webpack_require__(1182);
__webpack_require__(1183);
__webpack_require__(1184);
__webpack_require__(1185);
__webpack_require__(1186);
__webpack_require__(1187);
__webpack_require__(1188);
__webpack_require__(1189);
__webpack_require__(1190);
__webpack_require__(1191);
__webpack_require__(1192);
__webpack_require__(1193);
__webpack_require__(1194);
__webpack_require__(1195);
__webpack_require__(1196);
__webpack_require__(1197);
__webpack_require__(1198);
__webpack_require__(1199);
__webpack_require__(1200);
__webpack_require__(1201);
__webpack_require__(1202);
__webpack_require__(1203);
__webpack_require__(1204);
__webpack_require__(1205);
__webpack_require__(1206);
__webpack_require__(1207);
__webpack_require__(1208);
__webpack_require__(1209);
__webpack_require__(1210);
__webpack_require__(1211);
__webpack_require__(1212);
__webpack_require__(1214);
__webpack_require__(1215);
__webpack_require__(1217);
__webpack_require__(1218);
__webpack_require__(1219);
__webpack_require__(1220);
__webpack_require__(1221);
__webpack_require__(1222);
__webpack_require__(1223);
__webpack_require__(1225);
__webpack_require__(1226);
__webpack_require__(1227);
__webpack_require__(1228);
__webpack_require__(1229);
__webpack_require__(1230);
__webpack_require__(1231);
__webpack_require__(1232);
__webpack_require__(1233);
__webpack_require__(1234);
__webpack_require__(1235);
__webpack_require__(1236);
__webpack_require__(1237);
__webpack_require__(343);
__webpack_require__(1238);
__webpack_require__(514);
__webpack_require__(1239);
__webpack_require__(515);
__webpack_require__(1240);
__webpack_require__(1241);
__webpack_require__(1242);
__webpack_require__(1243);
__webpack_require__(1244);
__webpack_require__(518);
__webpack_require__(520);
__webpack_require__(521);
__webpack_require__(1245);
__webpack_require__(1246);
__webpack_require__(1247);
__webpack_require__(1248);
__webpack_require__(1249);
__webpack_require__(1250);
__webpack_require__(1251);
__webpack_require__(1252);
__webpack_require__(1253);
__webpack_require__(1254);
__webpack_require__(1255);
__webpack_require__(1256);
__webpack_require__(1257);
__webpack_require__(1258);
__webpack_require__(1259);
__webpack_require__(1260);
__webpack_require__(1261);
__webpack_require__(1262);
__webpack_require__(1263);
__webpack_require__(1264);
__webpack_require__(1265);
__webpack_require__(1266);
__webpack_require__(1267);
__webpack_require__(1268);
__webpack_require__(1269);
__webpack_require__(1270);
__webpack_require__(1271);
__webpack_require__(1272);
__webpack_require__(1273);
__webpack_require__(1274);
__webpack_require__(1275);
__webpack_require__(1276);
__webpack_require__(1277);
__webpack_require__(1278);
__webpack_require__(1279);
__webpack_require__(1280);
__webpack_require__(1281);
__webpack_require__(1282);
__webpack_require__(1283);
__webpack_require__(1284);
__webpack_require__(1285);
__webpack_require__(1286);
__webpack_require__(1287);
__webpack_require__(1288);
__webpack_require__(1289);
__webpack_require__(1290);
__webpack_require__(1291);
__webpack_require__(1292);
__webpack_require__(1293);
__webpack_require__(1294);
__webpack_require__(1295);
__webpack_require__(1296);
__webpack_require__(1297);
__webpack_require__(1298);
__webpack_require__(1299);
__webpack_require__(1300);
__webpack_require__(1301);
__webpack_require__(1302);
__webpack_require__(1303);
__webpack_require__(1304);
__webpack_require__(1305);
__webpack_require__(1306);
__webpack_require__(1307);
__webpack_require__(1308);
__webpack_require__(1309);
__webpack_require__(1310);
__webpack_require__(1311);
__webpack_require__(1312);
__webpack_require__(1313);
__webpack_require__(1314);
__webpack_require__(1315);
__webpack_require__(1316);
__webpack_require__(1317);
__webpack_require__(1318);
__webpack_require__(1319);
__webpack_require__(1320);
__webpack_require__(1321);
__webpack_require__(1322);
__webpack_require__(1323);
__webpack_require__(1324);
__webpack_require__(1325);
__webpack_require__(1326);
__webpack_require__(1327);
__webpack_require__(1328);
__webpack_require__(1329);
module.exports = __webpack_require__(70);


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(14);
var has = __webpack_require__(63);
var DESCRIPTORS = __webpack_require__(23);
var $export = __webpack_require__(3);
var redefine = __webpack_require__(59);
var META = __webpack_require__(114).KEY;
var $fails = __webpack_require__(16);
var shared = __webpack_require__(164);
var setToStringTag = __webpack_require__(139);
var uid = __webpack_require__(125);
var wks = __webpack_require__(20);
var wksExt = __webpack_require__(496);
var wksDefine = __webpack_require__(324);
var enumKeys = __webpack_require__(1136);
var isArray = __webpack_require__(220);
var anObject = __webpack_require__(13);
var isObject = __webpack_require__(17);
var toObject = __webpack_require__(27);
var toIObject = __webpack_require__(64);
var toPrimitive = __webpack_require__(92);
var createDesc = __webpack_require__(124);
var _create = __webpack_require__(128);
var gOPNExt = __webpack_require__(499);
var $GOPD = __webpack_require__(65);
var $GOPS = __webpack_require__(219);
var $DP = __webpack_require__(25);
var $keys = __webpack_require__(126);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(129).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(166).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(113)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(58)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(164)('native-function-to-string', Function.toString);


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(126);
var gOPS = __webpack_require__(219);
var pIE = __webpack_require__(166);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(128) });


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(23), 'Object', { defineProperty: __webpack_require__(25).f });


/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(23), 'Object', { defineProperties: __webpack_require__(498) });


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(64);
var $getOwnPropertyDescriptor = __webpack_require__(65).f;

__webpack_require__(94)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(27);
var $getPrototypeOf = __webpack_require__(66);

__webpack_require__(94)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(27);
var $keys = __webpack_require__(126);

__webpack_require__(94)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(94)('getOwnPropertyNames', function () {
  return __webpack_require__(499).f;
});


/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(17);
var meta = __webpack_require__(114).onFreeze;

__webpack_require__(94)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(17);
var meta = __webpack_require__(114).onFreeze;

__webpack_require__(94)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(17);
var meta = __webpack_require__(114).onFreeze;

__webpack_require__(94)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(17);

__webpack_require__(94)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(17);

__webpack_require__(94)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(17);

__webpack_require__(94)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(3);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(500) });


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(3);
$export($export.S, 'Object', { is: __webpack_require__(501) });


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(3);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(328).set });


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(140);
var test = {};
test[__webpack_require__(20)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(59)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(3);

$export($export.P, 'Function', { bind: __webpack_require__(502) });


/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(25).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(23) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(17);
var getPrototypeOf = __webpack_require__(66);
var HAS_INSTANCE = __webpack_require__(20)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(25).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var $parseInt = __webpack_require__(504);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var $parseFloat = __webpack_require__(505);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(14);
var has = __webpack_require__(63);
var cof = __webpack_require__(72);
var inheritIfRequired = __webpack_require__(330);
var toPrimitive = __webpack_require__(92);
var fails = __webpack_require__(16);
var gOPN = __webpack_require__(129).f;
var gOPD = __webpack_require__(65).f;
var dP = __webpack_require__(25).f;
var $trim = __webpack_require__(141).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(128)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(23) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(59)(global, NUMBER, $Number);
}


/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var toInteger = __webpack_require__(73);
var aNumberValue = __webpack_require__(506);
var repeat = __webpack_require__(331);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(16)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $fails = __webpack_require__(16);
var aNumberValue = __webpack_require__(506);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(3);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(3);
var _isFinite = __webpack_require__(14).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(3);

$export($export.S, 'Number', { isInteger: __webpack_require__(507) });


/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(3);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(3);
var isInteger = __webpack_require__(507);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(3);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(3);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var $parseFloat = __webpack_require__(505);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var $parseInt = __webpack_require__(504);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(3);
var log1p = __webpack_require__(508);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(3);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(3);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(3);
var sign = __webpack_require__(332);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(3);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(3);
var $expm1 = __webpack_require__(333);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', { fround: __webpack_require__(509) });


/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(3);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(3);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(16)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', { log1p: __webpack_require__(508) });


/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', { sign: __webpack_require__(332) });


/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(3);
var expm1 = __webpack_require__(333);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(16)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(3);
var expm1 = __webpack_require__(333);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var toAbsoluteIndex = __webpack_require__(127);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var toIObject = __webpack_require__(64);
var toLength = __webpack_require__(21);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(141)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(221)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(334)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $at = __webpack_require__(221)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(3);
var toLength = __webpack_require__(21);
var context = __webpack_require__(336);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(337)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(3);
var context = __webpack_require__(336);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(337)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(331)
});


/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(3);
var toLength = __webpack_require__(21);
var context = __webpack_require__(336);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(337)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(60)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(60)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(60)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(60)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(60)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(60)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(60)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(60)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(60)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(60)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(60)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(60)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(60)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(3);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var toObject = __webpack_require__(27);
var toPrimitive = __webpack_require__(92);

$export($export.P + $export.F * __webpack_require__(16)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(3);
var toISOString = __webpack_require__(1213);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(16);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(59)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(20)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(58)(proto, TO_PRIMITIVE, __webpack_require__(1216));


/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(13);
var toPrimitive = __webpack_require__(92);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(3);

$export($export.S, 'Array', { isArray: __webpack_require__(220) });


/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(71);
var $export = __webpack_require__(3);
var toObject = __webpack_require__(27);
var call = __webpack_require__(510);
var isArrayIter = __webpack_require__(338);
var toLength = __webpack_require__(21);
var createProperty = __webpack_require__(339);
var getIterFn = __webpack_require__(340);

$export($export.S + $export.F * !__webpack_require__(223)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var createProperty = __webpack_require__(339);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(16)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(3);
var toIObject = __webpack_require__(64);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(165) != Object || !__webpack_require__(74)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var html = __webpack_require__(327);
var cof = __webpack_require__(72);
var toAbsoluteIndex = __webpack_require__(127);
var toLength = __webpack_require__(21);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(16)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var aFunction = __webpack_require__(48);
var toObject = __webpack_require__(27);
var fails = __webpack_require__(16);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(74)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $forEach = __webpack_require__(95)(0);
var STRICT = __webpack_require__(74)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17);
var isArray = __webpack_require__(220);
var SPECIES = __webpack_require__(20)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $map = __webpack_require__(95)(1);

$export($export.P + $export.F * !__webpack_require__(74)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $filter = __webpack_require__(95)(2);

$export($export.P + $export.F * !__webpack_require__(74)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $some = __webpack_require__(95)(3);

$export($export.P + $export.F * !__webpack_require__(74)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $every = __webpack_require__(95)(4);

$export($export.P + $export.F * !__webpack_require__(74)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $reduce = __webpack_require__(511);

$export($export.P + $export.F * !__webpack_require__(74)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $reduce = __webpack_require__(511);

$export($export.P + $export.F * !__webpack_require__(74)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $indexOf = __webpack_require__(218)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(74)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var toIObject = __webpack_require__(64);
var toInteger = __webpack_require__(73);
var toLength = __webpack_require__(21);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(74)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(3);

$export($export.P, 'Array', { copyWithin: __webpack_require__(512) });

__webpack_require__(115)('copyWithin');


/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(3);

$export($export.P, 'Array', { fill: __webpack_require__(342) });

__webpack_require__(115)('fill');


/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(3);
var $find = __webpack_require__(95)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(115)(KEY);


/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(3);
var $find = __webpack_require__(95)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(115)(KEY);


/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(130)('Array');


/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(14);
var inheritIfRequired = __webpack_require__(330);
var dP = __webpack_require__(25).f;
var gOPN = __webpack_require__(129).f;
var isRegExp = __webpack_require__(222);
var $flags = __webpack_require__(167);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(23) && (!CORRECT_NEW || __webpack_require__(16)(function () {
  re2[__webpack_require__(20)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(59)(global, 'RegExp', $RegExp);
}

__webpack_require__(130)('RegExp');


/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(515);
var anObject = __webpack_require__(13);
var $flags = __webpack_require__(167);
var DESCRIPTORS = __webpack_require__(23);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(59)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(16)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(13);
var toLength = __webpack_require__(21);
var advanceStringIndex = __webpack_require__(345);
var regExpExec = __webpack_require__(224);

// @@match logic
__webpack_require__(225)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(13);
var toObject = __webpack_require__(27);
var toLength = __webpack_require__(21);
var toInteger = __webpack_require__(73);
var advanceStringIndex = __webpack_require__(345);
var regExpExec = __webpack_require__(224);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(225)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(13);
var sameValue = __webpack_require__(501);
var regExpExec = __webpack_require__(224);

// @@search logic
__webpack_require__(225)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(222);
var anObject = __webpack_require__(13);
var speciesConstructor = __webpack_require__(168);
var advanceStringIndex = __webpack_require__(345);
var toLength = __webpack_require__(21);
var callRegExpExec = __webpack_require__(224);
var regexpExec = __webpack_require__(344);
var fails = __webpack_require__(16);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(225)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(113);
var global = __webpack_require__(14);
var ctx = __webpack_require__(71);
var classof = __webpack_require__(140);
var $export = __webpack_require__(3);
var isObject = __webpack_require__(17);
var aFunction = __webpack_require__(48);
var anInstance = __webpack_require__(131);
var forOf = __webpack_require__(132);
var speciesConstructor = __webpack_require__(168);
var task = __webpack_require__(346).set;
var microtask = __webpack_require__(347)();
var newPromiseCapabilityModule = __webpack_require__(348);
var perform = __webpack_require__(516);
var userAgent = __webpack_require__(226);
var promiseResolve = __webpack_require__(517);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(20)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(133)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(139)($Promise, PROMISE);
__webpack_require__(130)(PROMISE);
Wrapper = __webpack_require__(70)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(223)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(522);
var validate = __webpack_require__(134);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(227)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $typed = __webpack_require__(228);
var buffer = __webpack_require__(349);
var anObject = __webpack_require__(13);
var toAbsoluteIndex = __webpack_require__(127);
var toLength = __webpack_require__(21);
var isObject = __webpack_require__(17);
var ArrayBuffer = __webpack_require__(14).ArrayBuffer;
var speciesConstructor = __webpack_require__(168);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(16)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(130)(ARRAY_BUFFER);


/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
$export($export.G + $export.W + $export.F * !__webpack_require__(228).ABV, {
  DataView: __webpack_require__(349).DataView
});


/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(105)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(105)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(105)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(105)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(105)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(105)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(105)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(105)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(105)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(3);
var aFunction = __webpack_require__(48);
var anObject = __webpack_require__(13);
var rApply = (__webpack_require__(14).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(16)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(3);
var create = __webpack_require__(128);
var aFunction = __webpack_require__(48);
var anObject = __webpack_require__(13);
var isObject = __webpack_require__(17);
var fails = __webpack_require__(16);
var bind = __webpack_require__(502);
var rConstruct = (__webpack_require__(14).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(25);
var $export = __webpack_require__(3);
var anObject = __webpack_require__(13);
var toPrimitive = __webpack_require__(92);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(16)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(3);
var gOPD = __webpack_require__(65).f;
var anObject = __webpack_require__(13);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(3);
var anObject = __webpack_require__(13);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(335)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(65);
var getPrototypeOf = __webpack_require__(66);
var has = __webpack_require__(63);
var $export = __webpack_require__(3);
var isObject = __webpack_require__(17);
var anObject = __webpack_require__(13);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(65);
var $export = __webpack_require__(3);
var anObject = __webpack_require__(13);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(3);
var getProto = __webpack_require__(66);
var anObject = __webpack_require__(13);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(3);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(3);
var anObject = __webpack_require__(13);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(3);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(524) });


/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(3);
var anObject = __webpack_require__(13);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(25);
var gOPD = __webpack_require__(65);
var getPrototypeOf = __webpack_require__(66);
var has = __webpack_require__(63);
var $export = __webpack_require__(3);
var createDesc = __webpack_require__(124);
var anObject = __webpack_require__(13);
var isObject = __webpack_require__(17);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(3);
var setProto = __webpack_require__(328);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(3);
var $includes = __webpack_require__(218)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(115)('includes');


/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(3);
var flattenIntoArray = __webpack_require__(525);
var toObject = __webpack_require__(27);
var toLength = __webpack_require__(21);
var aFunction = __webpack_require__(48);
var arraySpeciesCreate = __webpack_require__(341);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(115)('flatMap');


/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(3);
var flattenIntoArray = __webpack_require__(525);
var toObject = __webpack_require__(27);
var toLength = __webpack_require__(21);
var toInteger = __webpack_require__(73);
var arraySpeciesCreate = __webpack_require__(341);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(115)('flatten');


/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(3);
var $at = __webpack_require__(221)(true);
var $fails = __webpack_require__(16);

var FORCED = $fails(function () {
  return '𠮷'.at(0) !== '𠮷';
});

$export($export.P + $export.F * FORCED, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(3);
var $pad = __webpack_require__(526);
var userAgent = __webpack_require__(226);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(3);
var $pad = __webpack_require__(526);
var userAgent = __webpack_require__(226);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(141)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(141)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(3);
var defined = __webpack_require__(93);
var toLength = __webpack_require__(21);
var isRegExp = __webpack_require__(222);
var getFlags = __webpack_require__(167);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(335)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(324)('asyncIterator');


/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(324)('observable');


/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(3);
var ownKeys = __webpack_require__(524);
var toIObject = __webpack_require__(64);
var gOPD = __webpack_require__(65);
var createProperty = __webpack_require__(339);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(3);
var $values = __webpack_require__(527)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(3);
var $entries = __webpack_require__(527)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var toObject = __webpack_require__(27);
var aFunction = __webpack_require__(48);
var $defineProperty = __webpack_require__(25);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(23) && $export($export.P + __webpack_require__(229), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var toObject = __webpack_require__(27);
var aFunction = __webpack_require__(48);
var $defineProperty = __webpack_require__(25);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(23) && $export($export.P + __webpack_require__(229), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var toObject = __webpack_require__(27);
var toPrimitive = __webpack_require__(92);
var getPrototypeOf = __webpack_require__(66);
var getOwnPropertyDescriptor = __webpack_require__(65).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(23) && $export($export.P + __webpack_require__(229), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var toObject = __webpack_require__(27);
var toPrimitive = __webpack_require__(92);
var getPrototypeOf = __webpack_require__(66);
var getOwnPropertyDescriptor = __webpack_require__(65).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(23) && $export($export.P + __webpack_require__(229), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(3);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(528)('Map') });


/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(3);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(528)('Set') });


/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(230)('Map');


/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(230)('Set');


/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(230)('WeakMap');


/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(230)('WeakSet');


/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(231)('Map');


/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(231)('Set');


/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(231)('WeakMap');


/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(231)('WeakSet');


/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(3);

$export($export.G, { global: __webpack_require__(14) });


/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(3);

$export($export.S, 'System', { global: __webpack_require__(14) });


/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(3);
var cof = __webpack_require__(72);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(3);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(3);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(3);
var scale = __webpack_require__(530);
var fround = __webpack_require__(509);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(3);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(3);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(3);

$export($export.S, 'Math', { scale: __webpack_require__(530) });


/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(3);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(3);
var core = __webpack_require__(70);
var global = __webpack_require__(14);
var speciesConstructor = __webpack_require__(168);
var promiseResolve = __webpack_require__(517);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(3);
var newPromiseCapability = __webpack_require__(348);
var perform = __webpack_require__(516);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(106);
var anObject = __webpack_require__(13);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(106);
var anObject = __webpack_require__(13);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(106);
var anObject = __webpack_require__(13);
var getPrototypeOf = __webpack_require__(66);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(520);
var from = __webpack_require__(529);
var metadata = __webpack_require__(106);
var anObject = __webpack_require__(13);
var getPrototypeOf = __webpack_require__(66);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(106);
var anObject = __webpack_require__(13);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(106);
var anObject = __webpack_require__(13);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(106);
var anObject = __webpack_require__(13);
var getPrototypeOf = __webpack_require__(66);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(106);
var anObject = __webpack_require__(13);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(106);
var anObject = __webpack_require__(13);
var aFunction = __webpack_require__(48);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(3);
var microtask = __webpack_require__(347)();
var process = __webpack_require__(14).process;
var isNode = __webpack_require__(72)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(3);
var global = __webpack_require__(14);
var core = __webpack_require__(70);
var microtask = __webpack_require__(347)();
var OBSERVABLE = __webpack_require__(20)('observable');
var aFunction = __webpack_require__(48);
var anObject = __webpack_require__(13);
var anInstance = __webpack_require__(131);
var redefineAll = __webpack_require__(133);
var hide = __webpack_require__(58);
var forOf = __webpack_require__(132);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(130)('Observable');


/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(14);
var $export = __webpack_require__(3);
var userAgent = __webpack_require__(226);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var $task = __webpack_require__(346);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(343);
var getKeys = __webpack_require__(126);
var redefine = __webpack_require__(59);
var global = __webpack_require__(14);
var hide = __webpack_require__(58);
var Iterators = __webpack_require__(142);
var wks = __webpack_require__(20);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)))

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1332);
module.exports = __webpack_require__(70).RegExp.escape;


/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(3);
var $re = __webpack_require__(1333)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 1333 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(217),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(217),r=__webpack_require__(1336);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1337);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 1338 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(1340), src$en$$ = __webpack_require__(1345);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(532), src$es5$$ = __webpack_require__(1341), src$compiler$$ = __webpack_require__(1342), intl$messageformat$parser$$ = __webpack_require__(1343);
exports["default"] = MessageFormat;

// -- MessageFormat --------------------------------------------------------

function MessageFormat(message, locales, formats) {
    // Parse string messages into an AST.
    var ast = typeof message === 'string' ?
            MessageFormat.__parse(message) : message;

    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new TypeError('A message must be provided as a String or AST.');
    }

    // Creates a new object with the specified `formats` merged with the default
    // formats.
    formats = this._mergeFormats(MessageFormat.formats, formats);

    // Defined first because it's used to build the format pattern.
    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});

    // Compile the `ast` to a pattern that is highly optimized for repeated
    // `format()` invocations. **Note:** This passes the `locales` set provided
    // to the constructor instead of just the resolved locale.
    var pluralFn = this._findPluralRuleFunction(this._locale);
    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var messageFormat = this;
    this.format = function (values) {
      try {
        return messageFormat._format(pattern, values);
      } catch (e) {
        if (e.variableId) {
          throw new Error(
            'The intl string context variable \'' + e.variableId + '\'' +
            ' was not provided to the string \'' + message + '\''
          );
        } else {
          throw e;
        }
      }
    };
}

// Default format options used as the prototype of the `formats` provided to the
// constructor. These are used when constructing the internal Intl.NumberFormat
// and Intl.DateTimeFormat instances.
src$es5$$.defineProperty(MessageFormat, 'formats', {
    enumerable: true,

    value: {
        number: {
            'currency': {
                style: 'currency'
            },

            'percent': {
                style: 'percent'
            }
        },

        date: {
            'short': {
                month: 'numeric',
                day  : 'numeric',
                year : '2-digit'
            },

            'medium': {
                month: 'short',
                day  : 'numeric',
                year : 'numeric'
            },

            'long': {
                month: 'long',
                day  : 'numeric',
                year : 'numeric'
            },

            'full': {
                weekday: 'long',
                month  : 'long',
                day    : 'numeric',
                year   : 'numeric'
            }
        },

        time: {
            'short': {
                hour  : 'numeric',
                minute: 'numeric'
            },

            'medium':  {
                hour  : 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },

            'long': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            },

            'full': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            }
        }
    }
});

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlMessageFormat is missing a ' +
            '`locale` property'
        );
    }

    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
}});

// Defines `__parse()` static method as an exposed private.
src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});

// Define public `defaultLocale` property which defaults to English, but can be
// set by the developer.
src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

MessageFormat.prototype.resolvedOptions = function () {
    // TODO: Provide anything else?
    return {
        locale: this._locale
    };
};

MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
    return compiler.compile(ast);
};

MessageFormat.prototype._findPluralRuleFunction = function (locale) {
    var localeData = MessageFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find a `pluralRuleFunction` to return.
    while (data) {
        if (data.pluralRuleFunction) {
            return data.pluralRuleFunction;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlMessageFormat is missing a ' +
        '`pluralRuleFunction` for :' + locale
    );
};

MessageFormat.prototype._format = function (pattern, values) {
    var result = '',
        i, len, part, id, value, err;

    for (i = 0, len = pattern.length; i < len; i += 1) {
        part = pattern[i];

        // Exist early for string parts.
        if (typeof part === 'string') {
            result += part;
            continue;
        }

        id = part.id;

        // Enforce that all required values are provided by the caller.
        if (!(values && src$utils$$.hop.call(values, id))) {
          err = new Error('A value must be provided for: ' + id);
          err.variableId = id;
          throw err;
        }

        value = values[id];

        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (part.options) {
            result += this._format(part.getOption(value), values);
        } else {
            result += part.format(value);
        }
    }

    return result;
};

MessageFormat.prototype._mergeFormats = function (defaults, formats) {
    var mergedFormats = {},
        type, mergedType;

    for (type in defaults) {
        if (!src$utils$$.hop.call(defaults, type)) { continue; }

        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);

        if (formats && src$utils$$.hop.call(formats, type)) {
            src$utils$$.extend(mergedType, formats[type]);
        }
    }

    return mergedFormats;
};

MessageFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(MessageFormat.defaultLocale);

    var localeData = MessageFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlMessageFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(532);

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (src$utils$$.hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports["default"] = Compiler;

function Compiler(locales, formats, pluralFn) {
    this.locales  = locales;
    this.formats  = formats;
    this.pluralFn = pluralFn;
}

Compiler.prototype.compile = function (ast) {
    this.pluralStack        = [];
    this.currentPlural      = null;
    this.pluralNumberFormat = null;

    return this.compileMessage(ast);
};

Compiler.prototype.compileMessage = function (ast) {
    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new Error('Message AST is not of type: "messageFormatPattern"');
    }

    var elements = ast.elements,
        pattern  = [];

    var i, len, element;

    for (i = 0, len = elements.length; i < len; i += 1) {
        element = elements[i];

        switch (element.type) {
            case 'messageTextElement':
                pattern.push(this.compileMessageText(element));
                break;

            case 'argumentElement':
                pattern.push(this.compileArgument(element));
                break;

            default:
                throw new Error('Message element does not have a valid type');
        }
    }

    return pattern;
};

Compiler.prototype.compileMessageText = function (element) {
    // When this `element` is part of plural sub-pattern and its value contains
    // an unescaped '#', use a `PluralOffsetString` helper to properly output
    // the number with the correct offset in the string.
    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
        // Create a cache a NumberFormat instance that can be reused for any
        // PluralOffsetString instance in this message.
        if (!this.pluralNumberFormat) {
            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
        }

        return new PluralOffsetString(
                this.currentPlural.id,
                this.currentPlural.format.offset,
                this.pluralNumberFormat,
                element.value);
    }

    // Unescape the escaped '#'s in the message text.
    return element.value.replace(/\\#/g, '#');
};

Compiler.prototype.compileArgument = function (element) {
    var format = element.format;

    if (!format) {
        return new StringFormat(element.id);
    }

    var formats  = this.formats,
        locales  = this.locales,
        pluralFn = this.pluralFn,
        options;

    switch (format.type) {
        case 'numberFormat':
            options = formats.number[format.style];
            return {
                id    : element.id,
                format: new Intl.NumberFormat(locales, options).format
            };

        case 'dateFormat':
            options = formats.date[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'timeFormat':
            options = formats.time[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'pluralFormat':
            options = this.compileOptions(element);
            return new PluralFormat(
                element.id, format.ordinal, format.offset, options, pluralFn
            );

        case 'selectFormat':
            options = this.compileOptions(element);
            return new SelectFormat(element.id, options);

        default:
            throw new Error('Message element does not have a valid format type');
    }
};

Compiler.prototype.compileOptions = function (element) {
    var format      = element.format,
        options     = format.options,
        optionsHash = {};

    // Save the current plural element, if any, then set it to a new value when
    // compiling the options sub-patterns. This conforms the spec's algorithm
    // for handling `"#"` syntax in message text.
    this.pluralStack.push(this.currentPlural);
    this.currentPlural = format.type === 'pluralFormat' ? element : null;

    var i, len, option;

    for (i = 0, len = options.length; i < len; i += 1) {
        option = options[i];

        // Compile the sub-pattern and save it under the options's selector.
        optionsHash[option.selector] = this.compileMessage(option.value);
    }

    // Pop the plural stack to put back the original current plural value.
    this.currentPlural = this.pluralStack.pop();

    return optionsHash;
};

// -- Compiler Helper Classes --------------------------------------------------

function StringFormat(id) {
    this.id = id;
}

StringFormat.prototype.format = function (value) {
    if (!value && typeof value !== 'number') {
        return '';
    }

    return typeof value === 'string' ? value : String(value);
};

function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
    this.id         = id;
    this.useOrdinal = useOrdinal;
    this.offset     = offset;
    this.options    = options;
    this.pluralFn   = pluralFn;
}

PluralFormat.prototype.getOption = function (value) {
    var options = this.options;

    var option = options['=' + value] ||
            options[this.pluralFn(value - this.offset, this.useOrdinal)];

    return option || options.other;
};

function PluralOffsetString(id, offset, numberFormat, string) {
    this.id           = id;
    this.offset       = offset;
    this.numberFormat = numberFormat;
    this.string       = string;
}

PluralOffsetString.prototype.format = function (value) {
    var number = this.numberFormat.format(value - this.offset);

    return this.string
            .replace(/(^|[^\\])#/g, '$1' + number)
            .replace(/\\#/g, '#');
};

function SelectFormat(id, options) {
    this.id      = id;
    this.options = options;
}

SelectFormat.prototype.getOption = function (value) {
    var options = this.options;
    return options[value] || options.other;
};

//# sourceMappingURL=compiler.js.map

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(1344)['default'];
exports['default'] = exports;


/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports["default"] = (function() {
  "use strict";

  /*
   * Generated by PEG.js 0.9.0.
   *
   * http://pegjs.org/
   */

  function peg$subclass(child, parent) {
    function ctor() { this.constructor = child; }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
  }

  function peg$SyntaxError(message, expected, found, location) {
    this.message  = message;
    this.expected = expected;
    this.found    = found;
    this.location = location;
    this.name     = "SyntaxError";

    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, peg$SyntaxError);
    }
  }

  peg$subclass(peg$SyntaxError, Error);

  function peg$parse(input) {
    var options = arguments.length > 1 ? arguments[1] : {},
        parser  = this,

        peg$FAILED = {},

        peg$startRuleFunctions = { start: peg$parsestart },
        peg$startRuleFunction  = peg$parsestart,

        peg$c0 = function(elements) {
                return {
                    type    : 'messageFormatPattern',
                    elements: elements,
                    location: location()
                };
            },
        peg$c1 = function(text) {
                var string = '',
                    i, j, outerLen, inner, innerLen;

                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
                    inner = text[i];

                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
                        string += inner[j];
                    }
                }

                return string;
            },
        peg$c2 = function(messageText) {
                return {
                    type : 'messageTextElement',
                    value: messageText,
                    location: location()
                };
            },
        peg$c3 = /^[^ \t\n\r,.+={}#]/,
        peg$c4 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
        peg$c5 = "{",
        peg$c6 = { type: "literal", value: "{", description: "\"{\"" },
        peg$c7 = ",",
        peg$c8 = { type: "literal", value: ",", description: "\",\"" },
        peg$c9 = "}",
        peg$c10 = { type: "literal", value: "}", description: "\"}\"" },
        peg$c11 = function(id, format) {
                return {
                    type  : 'argumentElement',
                    id    : id,
                    format: format && format[2],
                    location: location()
                };
            },
        peg$c12 = "number",
        peg$c13 = { type: "literal", value: "number", description: "\"number\"" },
        peg$c14 = "date",
        peg$c15 = { type: "literal", value: "date", description: "\"date\"" },
        peg$c16 = "time",
        peg$c17 = { type: "literal", value: "time", description: "\"time\"" },
        peg$c18 = function(type, style) {
                return {
                    type : type + 'Format',
                    style: style && style[2],
                    location: location()
                };
            },
        peg$c19 = "plural",
        peg$c20 = { type: "literal", value: "plural", description: "\"plural\"" },
        peg$c21 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: false,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                };
            },
        peg$c22 = "selectordinal",
        peg$c23 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
        peg$c24 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: true,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                }
            },
        peg$c25 = "select",
        peg$c26 = { type: "literal", value: "select", description: "\"select\"" },
        peg$c27 = function(options) {
                return {
                    type   : 'selectFormat',
                    options: options,
                    location: location()
                };
            },
        peg$c28 = "=",
        peg$c29 = { type: "literal", value: "=", description: "\"=\"" },
        peg$c30 = function(selector, pattern) {
                return {
                    type    : 'optionalFormatPattern',
                    selector: selector,
                    value   : pattern,
                    location: location()
                };
            },
        peg$c31 = "offset:",
        peg$c32 = { type: "literal", value: "offset:", description: "\"offset:\"" },
        peg$c33 = function(number) {
                return number;
            },
        peg$c34 = function(offset, options) {
                return {
                    type   : 'pluralFormat',
                    offset : offset,
                    options: options,
                    location: location()
                };
            },
        peg$c35 = { type: "other", description: "whitespace" },
        peg$c36 = /^[ \t\n\r]/,
        peg$c37 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
        peg$c38 = { type: "other", description: "optionalWhitespace" },
        peg$c39 = /^[0-9]/,
        peg$c40 = { type: "class", value: "[0-9]", description: "[0-9]" },
        peg$c41 = /^[0-9a-f]/i,
        peg$c42 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
        peg$c43 = "0",
        peg$c44 = { type: "literal", value: "0", description: "\"0\"" },
        peg$c45 = /^[1-9]/,
        peg$c46 = { type: "class", value: "[1-9]", description: "[1-9]" },
        peg$c47 = function(digits) {
            return parseInt(digits, 10);
        },
        peg$c48 = /^[^{}\\\0-\x1F \t\n\r]/,
        peg$c49 = { type: "class", value: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]" },
        peg$c50 = "\\\\",
        peg$c51 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
        peg$c52 = function() { return '\\'; },
        peg$c53 = "\\#",
        peg$c54 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
        peg$c55 = function() { return '\\#'; },
        peg$c56 = "\\{",
        peg$c57 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
        peg$c58 = function() { return '\u007B'; },
        peg$c59 = "\\}",
        peg$c60 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
        peg$c61 = function() { return '\u007D'; },
        peg$c62 = "\\u",
        peg$c63 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
        peg$c64 = function(digits) {
                return String.fromCharCode(parseInt(digits, 16));
            },
        peg$c65 = function(chars) { return chars.join(''); },

        peg$currPos          = 0,
        peg$savedPos         = 0,
        peg$posDetailsCache  = [{ line: 1, column: 1, seenCR: false }],
        peg$maxFailPos       = 0,
        peg$maxFailExpected  = [],
        peg$silentFails      = 0,

        peg$result;

    if ("startRule" in options) {
      if (!(options.startRule in peg$startRuleFunctions)) {
        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
      }

      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }

    function text() {
      return input.substring(peg$savedPos, peg$currPos);
    }

    function location() {
      return peg$computeLocation(peg$savedPos, peg$currPos);
    }

    function expected(description) {
      throw peg$buildException(
        null,
        [{ type: "other", description: description }],
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function error(message) {
      throw peg$buildException(
        message,
        null,
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function peg$computePosDetails(pos) {
      var details = peg$posDetailsCache[pos],
          p, ch;

      if (details) {
        return details;
      } else {
        p = pos - 1;
        while (!peg$posDetailsCache[p]) {
          p--;
        }

        details = peg$posDetailsCache[p];
        details = {
          line:   details.line,
          column: details.column,
          seenCR: details.seenCR
        };

        while (p < pos) {
          ch = input.charAt(p);
          if (ch === "\n") {
            if (!details.seenCR) { details.line++; }
            details.column = 1;
            details.seenCR = false;
          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
            details.line++;
            details.column = 1;
            details.seenCR = true;
          } else {
            details.column++;
            details.seenCR = false;
          }

          p++;
        }

        peg$posDetailsCache[pos] = details;
        return details;
      }
    }

    function peg$computeLocation(startPos, endPos) {
      var startPosDetails = peg$computePosDetails(startPos),
          endPosDetails   = peg$computePosDetails(endPos);

      return {
        start: {
          offset: startPos,
          line:   startPosDetails.line,
          column: startPosDetails.column
        },
        end: {
          offset: endPos,
          line:   endPosDetails.line,
          column: endPosDetails.column
        }
      };
    }

    function peg$fail(expected) {
      if (peg$currPos < peg$maxFailPos) { return; }

      if (peg$currPos > peg$maxFailPos) {
        peg$maxFailPos = peg$currPos;
        peg$maxFailExpected = [];
      }

      peg$maxFailExpected.push(expected);
    }

    function peg$buildException(message, expected, found, location) {
      function cleanupExpected(expected) {
        var i = 1;

        expected.sort(function(a, b) {
          if (a.description < b.description) {
            return -1;
          } else if (a.description > b.description) {
            return 1;
          } else {
            return 0;
          }
        });

        while (i < expected.length) {
          if (expected[i - 1] === expected[i]) {
            expected.splice(i, 1);
          } else {
            i++;
          }
        }
      }

      function buildMessage(expected, found) {
        function stringEscape(s) {
          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }

          return s
            .replace(/\\/g,   '\\\\')
            .replace(/"/g,    '\\"')
            .replace(/\x08/g, '\\b')
            .replace(/\t/g,   '\\t')
            .replace(/\n/g,   '\\n')
            .replace(/\f/g,   '\\f')
            .replace(/\r/g,   '\\r')
            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
            .replace(/[\u0100-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
            .replace(/[\u1000-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
        }

        var expectedDescs = new Array(expected.length),
            expectedDesc, foundDesc, i;

        for (i = 0; i < expected.length; i++) {
          expectedDescs[i] = expected[i].description;
        }

        expectedDesc = expected.length > 1
          ? expectedDescs.slice(0, -1).join(", ")
              + " or "
              + expectedDescs[expected.length - 1]
          : expectedDescs[0];

        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";

        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
      }

      if (expected !== null) {
        cleanupExpected(expected);
      }

      return new peg$SyntaxError(
        message !== null ? message : buildMessage(expected, found),
        expected,
        found,
        location
      );
    }

    function peg$parsestart() {
      var s0;

      s0 = peg$parsemessageFormatPattern();

      return s0;
    }

    function peg$parsemessageFormatPattern() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsemessageFormatElement();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsemessageFormatElement();
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c0(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsemessageFormatElement() {
      var s0;

      s0 = peg$parsemessageTextElement();
      if (s0 === peg$FAILED) {
        s0 = peg$parseargumentElement();
      }

      return s0;
    }

    function peg$parsemessageText() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$currPos;
      s3 = peg$parse_();
      if (s3 !== peg$FAILED) {
        s4 = peg$parsechars();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse_();
          if (s5 !== peg$FAILED) {
            s3 = [s3, s4, s5];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$currPos;
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            s4 = peg$parsechars();
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s3 = [s3, s4, s5];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$FAILED;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c1(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsews();
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parsemessageTextElement() {
      var s0, s1;

      s0 = peg$currPos;
      s1 = peg$parsemessageText();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c2(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parseargument() {
      var s0, s1, s2;

      s0 = peg$parsenumber();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = [];
        if (peg$c3.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c4); }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            if (peg$c3.test(input.charAt(peg$currPos))) {
              s2 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c4); }
            }
          }
        } else {
          s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parseargumentElement() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 123) {
        s1 = peg$c5;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c6); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseargument();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$currPos;
              if (input.charCodeAt(peg$currPos) === 44) {
                s6 = peg$c7;
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c8); }
              }
              if (s6 !== peg$FAILED) {
                s7 = peg$parse_();
                if (s7 !== peg$FAILED) {
                  s8 = peg$parseelementFormat();
                  if (s8 !== peg$FAILED) {
                    s6 = [s6, s7, s8];
                    s5 = s6;
                  } else {
                    peg$currPos = s5;
                    s5 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s5;
                  s5 = peg$FAILED;
                }
              } else {
                peg$currPos = s5;
                s5 = peg$FAILED;
              }
              if (s5 === peg$FAILED) {
                s5 = null;
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 125) {
                    s7 = peg$c9;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c10); }
                  }
                  if (s7 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c11(s3, s5);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseelementFormat() {
      var s0;

      s0 = peg$parsesimpleFormat();
      if (s0 === peg$FAILED) {
        s0 = peg$parsepluralFormat();
        if (s0 === peg$FAILED) {
          s0 = peg$parseselectOrdinalFormat();
          if (s0 === peg$FAILED) {
            s0 = peg$parseselectFormat();
          }
        }
      }

      return s0;
    }

    function peg$parsesimpleFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c12) {
        s1 = peg$c12;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c13); }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 4) === peg$c14) {
          s1 = peg$c14;
          peg$currPos += 4;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c15); }
        }
        if (s1 === peg$FAILED) {
          if (input.substr(peg$currPos, 4) === peg$c16) {
            s1 = peg$c16;
            peg$currPos += 4;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c17); }
          }
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 44) {
            s4 = peg$c7;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();
            if (s5 !== peg$FAILED) {
              s6 = peg$parsechars();
              if (s6 !== peg$FAILED) {
                s4 = [s4, s5, s6];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
          if (s3 === peg$FAILED) {
            s3 = null;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c18(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c19) {
        s1 = peg$c19;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c20); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c21(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectOrdinalFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 13) === peg$c22) {
        s1 = peg$c22;
        peg$currPos += 13;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c23); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c24(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c25) {
        s1 = peg$c25;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c26); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = [];
              s6 = peg$parseoptionalFormatPattern();
              if (s6 !== peg$FAILED) {
                while (s6 !== peg$FAILED) {
                  s5.push(s6);
                  s6 = peg$parseoptionalFormatPattern();
                }
              } else {
                s5 = peg$FAILED;
              }
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c27(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselector() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      s1 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 61) {
        s2 = peg$c28;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c29); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parsenumber();
        if (s3 !== peg$FAILED) {
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$parsechars();
      }

      return s0;
    }

    function peg$parseoptionalFormatPattern() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      s1 = peg$parse_();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseselector();
        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 123) {
              s4 = peg$c5;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c6); }
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s6 = peg$parsemessageFormatPattern();
                if (s6 !== peg$FAILED) {
                  s7 = peg$parse_();
                  if (s7 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 125) {
                      s8 = peg$c9;
                      peg$currPos++;
                    } else {
                      s8 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$c10); }
                    }
                    if (s8 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s1 = peg$c30(s2, s6);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseoffset() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 7) === peg$c31) {
        s1 = peg$c31;
        peg$currPos += 7;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c32); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parsenumber();
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c33(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralStyle() {
      var s0, s1, s2, s3, s4;

      s0 = peg$currPos;
      s1 = peg$parseoffset();
      if (s1 === peg$FAILED) {
        s1 = null;
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = peg$parseoptionalFormatPattern();
          if (s4 !== peg$FAILED) {
            while (s4 !== peg$FAILED) {
              s3.push(s4);
              s4 = peg$parseoptionalFormatPattern();
            }
          } else {
            s3 = peg$FAILED;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c34(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsews() {
      var s0, s1;

      peg$silentFails++;
      s0 = [];
      if (peg$c36.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c37); }
      }
      if (s1 !== peg$FAILED) {
        while (s1 !== peg$FAILED) {
          s0.push(s1);
          if (peg$c36.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c37); }
          }
        }
      } else {
        s0 = peg$FAILED;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c35); }
      }

      return s0;
    }

    function peg$parse_() {
      var s0, s1, s2;

      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsews();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsews();
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c38); }
      }

      return s0;
    }

    function peg$parsedigit() {
      var s0;

      if (peg$c39.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c40); }
      }

      return s0;
    }

    function peg$parsehexDigit() {
      var s0;

      if (peg$c41.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c42); }
      }

      return s0;
    }

    function peg$parsenumber() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 48) {
        s1 = peg$c43;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c44); }
      }
      if (s1 === peg$FAILED) {
        s1 = peg$currPos;
        s2 = peg$currPos;
        if (peg$c45.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c46); }
        }
        if (s3 !== peg$FAILED) {
          s4 = [];
          s5 = peg$parsedigit();
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parsedigit();
          }
          if (s4 !== peg$FAILED) {
            s3 = [s3, s4];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c47(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsechar() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      if (peg$c48.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c49); }
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c50) {
          s1 = peg$c50;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c51); }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c52();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c53) {
            s1 = peg$c53;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c54); }
          }
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c55();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c56) {
              s1 = peg$c56;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c57); }
            }
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c58();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input.substr(peg$currPos, 2) === peg$c59) {
                s1 = peg$c59;
                peg$currPos += 2;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c60); }
              }
              if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c61();
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c62) {
                  s1 = peg$c62;
                  peg$currPos += 2;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$c63); }
                }
                if (s1 !== peg$FAILED) {
                  s2 = peg$currPos;
                  s3 = peg$currPos;
                  s4 = peg$parsehexDigit();
                  if (s4 !== peg$FAILED) {
                    s5 = peg$parsehexDigit();
                    if (s5 !== peg$FAILED) {
                      s6 = peg$parsehexDigit();
                      if (s6 !== peg$FAILED) {
                        s7 = peg$parsehexDigit();
                        if (s7 !== peg$FAILED) {
                          s4 = [s4, s5, s6, s7];
                          s3 = s4;
                        } else {
                          peg$currPos = s3;
                          s3 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s3;
                      s3 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                  }
                  if (s3 !== peg$FAILED) {
                    s2 = input.substring(s2, peg$currPos);
                  } else {
                    s2 = s3;
                  }
                  if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c64(s2);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parsechars() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsechar();
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$parsechar();
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c65(s1);
      }
      s0 = s1;

      return s0;
    }

    peg$result = peg$startRuleFunction();

    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
      return peg$result;
    } else {
      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
        peg$fail({ type: "end", description: "end of input" });
      }

      throw peg$buildException(
        null,
        peg$maxFailExpected,
        peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
        peg$maxFailPos < input.length
          ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
          : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
      );
    }
  }

  return {
    SyntaxError: peg$SyntaxError,
    parse:       peg$parse
  };
})();

//# sourceMappingURL=parser.js.map

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 1346 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlRelativeFormat = __webpack_require__(1348)['default'];

// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(1353);

// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlRelativeFormat;
exports['default'] = exports;


/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* jslint esnext: true */
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(1349);
var en_1 = __webpack_require__(1352);
core_1.default.__addLocaleData(en_1.default);
core_1.default.defaultLocale = 'en';
exports.default = core_1.default;
//# sourceMappingURL=main.js.map

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
Object.defineProperty(exports, "__esModule", { value: true });
/* jslint esnext: true */
var intl_messageformat_1 = __webpack_require__(531);
var diff_1 = __webpack_require__(1350);
var es5_1 = __webpack_require__(1351);
exports.default = RelativeFormat;
// -----------------------------------------------------------------------------
var FIELDS = [
    'second', 'second-short',
    'minute', 'minute-short',
    'hour', 'hour-short',
    'day', 'day-short',
    'month', 'month-short',
    'year', 'year-short'
];
var STYLES = ['best fit', 'numeric'];
// -- RelativeFormat -----------------------------------------------------------
function RelativeFormat(locales, options) {
    options = options || {};
    // Make a copy of `locales` if it's an array, so that it doesn't change
    // since it's used lazily.
    if (es5_1.isArray(locales)) {
        locales = locales.concat();
    }
    es5_1.defineProperty(this, '_locale', { value: this._resolveLocale(locales) });
    es5_1.defineProperty(this, '_options', { value: {
            style: this._resolveStyle(options.style),
            units: this._isValidUnits(options.units) && options.units
        } });
    es5_1.defineProperty(this, '_locales', { value: locales });
    es5_1.defineProperty(this, '_fields', { value: this._findFields(this._locale) });
    es5_1.defineProperty(this, '_messages', { value: es5_1.objCreate(null) });
    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var relativeFormat = this;
    this.format = function format(date, options) {
        return relativeFormat._format(date, options);
    };
}
// Define internal private properties for dealing with locale data.
es5_1.defineProperty(RelativeFormat, '__localeData__', { value: es5_1.objCreate(null) });
es5_1.defineProperty(RelativeFormat, '__addLocaleData', { value: function () {
        for (var i = 0; i < arguments.length; i++) {
            var datum = arguments[i];
            if (!(datum && datum.locale)) {
                throw new Error('Locale data provided to IntlRelativeFormat is missing a ' +
                    '`locale` property value');
            }
            RelativeFormat.__localeData__[datum.locale.toLowerCase()] = datum;
            // Add data to IntlMessageFormat.
            intl_messageformat_1.default.__addLocaleData(datum);
        }
    } });
// Define public `defaultLocale` property which can be set by the developer, or
// it will be set when the first RelativeFormat instance is created by
// leveraging the resolved locale from `Intl`.
es5_1.defineProperty(RelativeFormat, 'defaultLocale', {
    enumerable: true,
    writable: true,
    value: undefined
});
// Define public `thresholds` property which can be set by the developer, and
// defaults to relative time thresholds from moment.js.
es5_1.defineProperty(RelativeFormat, 'thresholds', {
    enumerable: true,
    value: {
        second: 45, 'second-short': 45,
        minute: 45, 'minute-short': 45,
        hour: 22, 'hour-short': 22,
        day: 26, 'day-short': 26,
        month: 11, 'month-short': 11 // months to year
    }
});
RelativeFormat.prototype.resolvedOptions = function () {
    return {
        locale: this._locale,
        style: this._options.style,
        units: this._options.units
    };
};
RelativeFormat.prototype._compileMessage = function (units) {
    // `this._locales` is the original set of locales the user specified to the
    // constructor, while `this._locale` is the resolved root locale.
    var locales = this._locales;
    var resolvedLocale = this._locale;
    var field = this._fields[units];
    var relativeTime = field.relativeTime;
    var future = '';
    var past = '';
    var i;
    for (i in relativeTime.future) {
        if (relativeTime.future.hasOwnProperty(i)) {
            future += ' ' + i + ' {' +
                relativeTime.future[i].replace('{0}', '#') + '}';
        }
    }
    for (i in relativeTime.past) {
        if (relativeTime.past.hasOwnProperty(i)) {
            past += ' ' + i + ' {' +
                relativeTime.past[i].replace('{0}', '#') + '}';
        }
    }
    var message = '{when, select, future {{0, plural, ' + future + '}}' +
        'past {{0, plural, ' + past + '}}}';
    // Create the synthetic IntlMessageFormat instance using the original
    // locales value specified by the user when constructing the the parent
    // IntlRelativeFormat instance.
    return new intl_messageformat_1.default(message, locales);
};
RelativeFormat.prototype._getMessage = function (units) {
    var messages = this._messages;
    // Create a new synthetic message based on the locale data from CLDR.
    if (!messages[units]) {
        messages[units] = this._compileMessage(units);
    }
    return messages[units];
};
RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
    var field = this._fields[units];
    if (field.relative) {
        return field.relative[diff];
    }
};
RelativeFormat.prototype._findFields = function (locale) {
    var localeData = RelativeFormat.__localeData__;
    var data = localeData[locale.toLowerCase()];
    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find `fields` to return.
    while (data) {
        if (data.fields) {
            return data.fields;
        }
        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }
    throw new Error('Locale data added to IntlRelativeFormat is missing `fields` for :' +
        locale);
};
RelativeFormat.prototype._format = function (date, options) {
    var now = options && options.now !== undefined ? options.now : es5_1.dateNow();
    if (date === undefined) {
        date = now;
    }
    // Determine if the `date` and optional `now` values are valid, and throw a
    // similar error to what `Intl.DateTimeFormat#format()` would throw.
    if (!isFinite(now)) {
        throw new RangeError('The `now` option provided to IntlRelativeFormat#format() is not ' +
            'in valid range.');
    }
    if (!isFinite(date)) {
        throw new RangeError('The date value provided to IntlRelativeFormat#format() is not ' +
            'in valid range.');
    }
    var diffReport = diff_1.default(now, date);
    var units = this._options.units || this._selectUnits(diffReport);
    var diffInUnits = diffReport[units];
    if (this._options.style !== 'numeric') {
        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
        if (relativeUnits) {
            return relativeUnits;
        }
    }
    return this._getMessage(units).format({
        '0': Math.abs(diffInUnits),
        when: diffInUnits < 0 ? 'past' : 'future'
    });
};
RelativeFormat.prototype._isValidUnits = function (units) {
    if (!units || es5_1.arrIndexOf.call(FIELDS, units) >= 0) {
        return true;
    }
    if (typeof units === 'string') {
        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
        if (suggestion && es5_1.arrIndexOf.call(FIELDS, suggestion) >= 0) {
            throw new Error('"' + units + '" is not a valid IntlRelativeFormat `units` ' +
                'value, did you mean: ' + suggestion);
        }
    }
    throw new Error('"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
        'must be one of: "' + FIELDS.join('", "') + '"');
};
RelativeFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }
    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(RelativeFormat.defaultLocale);
    var localeData = RelativeFormat.__localeData__;
    var i, len, localeParts, data;
    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');
        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }
            localeParts.pop();
        }
    }
    var defaultLocale = locales.pop();
    throw new Error('No locale data has been added to IntlRelativeFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale);
};
RelativeFormat.prototype._resolveStyle = function (style) {
    // Default to "best fit" style.
    if (!style) {
        return STYLES[0];
    }
    if (es5_1.arrIndexOf.call(STYLES, style) >= 0) {
        return style;
    }
    throw new Error('"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
        'must be one of: "' + STYLES.join('", "') + '"');
};
RelativeFormat.prototype._selectUnits = function (diffReport) {
    var i, l, units;
    var fields = FIELDS.filter(function (field) {
        return field.indexOf('-short') < 1;
    });
    for (i = 0, l = fields.length; i < l; i += 1) {
        units = fields[i];
        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
            break;
        }
    }
    return units;
};
//# sourceMappingURL=core.js.map

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
Object.defineProperty(exports, "__esModule", { value: true });
/* jslint esnext: true */
var round = Math.round;
function daysToYears(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    return days * 400 / 146097;
}
// Thanks to date-fns
// https://github.com/date-fns/date-fns
// MIT © Sasha Koss
var MILLISECONDS_IN_MINUTE = 60000;
var MILLISECONDS_IN_DAY = 86400000;
function startOfDay(dirtyDate) {
    var date = new Date(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
    var startOfDayLeft = startOfDay(dirtyDateLeft);
    var startOfDayRight = startOfDay(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() -
        startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
    var timestampRight = startOfDayRight.getTime() -
        startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}
function default_1(from, to) {
    // Convert to ms timestamps.
    from = +from;
    to = +to;
    var millisecond = round(to - from), second = round(millisecond / 1000), minute = round(second / 60), hour = round(minute / 60);
    // We expect a more precision in rounding when dealing with
    // days as it feels wrong when something happended 13 hours ago and
    // is regarded as "yesterday" even if the time was this morning.
    var day = differenceInCalendarDays(to, from);
    var week = round(day / 7);
    var rawYears = daysToYears(day), month = round(rawYears * 12), year = round(rawYears);
    return {
        millisecond: millisecond,
        second: second,
        'second-short': second,
        minute: minute,
        'minute-short': minute,
        hour: hour,
        'hour-short': hour,
        day: day,
        'day-short': day,
        week: week,
        'week-short': week,
        month: month,
        'month-short': month,
        year: year,
        'year-short': year
    };
}
exports.default = default_1;
//# sourceMappingURL=diff.js.map

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
Object.defineProperty(exports, "__esModule", { value: true });
/* jslint esnext: true */
// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License
var hop = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;
var realDefineProp = (function () {
    try {
        return !!Object.defineProperty({}, 'a', {});
    }
    catch (e) {
        return false;
    }
})();
var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
var defineProperty = realDefineProp ? Object.defineProperty :
    function (obj, name, desc) {
        if ('get' in desc && obj.__defineGetter__) {
            obj.__defineGetter__(name, desc.get);
        }
        else if (!hop.call(obj, name) || 'value' in desc) {
            obj[name] = desc.value;
        }
    };
exports.defineProperty = defineProperty;
var objCreate = Object.create || function (proto, props) {
    var obj, k;
    function F() { }
    F.prototype = proto;
    obj = new F();
    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }
    return obj;
};
exports.objCreate = objCreate;
var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
    /*jshint validthis:true */
    var arr = this;
    if (!arr.length) {
        return -1;
    }
    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
        if (arr[i] === search) {
            return i;
        }
    }
    return -1;
};
exports.arrIndexOf = arrIndexOf;
var isArray = Array.isArray || function (obj) {
    return toString.call(obj) === '[object Array]';
};
exports.isArray = isArray;
var dateNow = Date.now || function () {
    return new Date().getTime();
};
exports.dateNow = dateNow;
//# sourceMappingURL=es5.js.map

/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* @generated */
exports.default = { "locale": "en", "pluralRuleFunction": function (n, ord) {
        var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
        if (ord)
            return (n10 == 1 && n100 != 11) ? 'one'
                : (n10 == 2 && n100 != 12) ? 'two'
                    : (n10 == 3 && n100 != 13) ? 'few'
                        : 'other';
        return (n == 1 && v0) ? 'one' : 'other';
    }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "year-short": { "displayName": "yr.", "relative": { "0": "this yr.", "1": "next yr.", "-1": "last yr." }, "relativeTime": { "future": { "one": "in {0} yr.", "other": "in {0} yr." }, "past": { "one": "{0} yr. ago", "other": "{0} yr. ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "month-short": { "displayName": "mo.", "relative": { "0": "this mo.", "1": "next mo.", "-1": "last mo." }, "relativeTime": { "future": { "one": "in {0} mo.", "other": "in {0} mo." }, "past": { "one": "{0} mo. ago", "other": "{0} mo. ago" } } }, "week": { "displayName": "week", "relativePeriod": "the week of {0}", "relative": { "0": "this week", "1": "next week", "-1": "last week" }, "relativeTime": { "future": { "one": "in {0} week", "other": "in {0} weeks" }, "past": { "one": "{0} week ago", "other": "{0} weeks ago" } } }, "week-short": { "displayName": "wk.", "relativePeriod": "the week of {0}", "relative": { "0": "this wk.", "1": "next wk.", "-1": "last wk." }, "relativeTime": { "future": { "one": "in {0} wk.", "other": "in {0} wk." }, "past": { "one": "{0} wk. ago", "other": "{0} wk. ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "day-short": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "hour-short": { "displayName": "hr.", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hr.", "other": "in {0} hr." }, "past": { "one": "{0} hr. ago", "other": "{0} hr. ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "minute-short": { "displayName": "min.", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} min.", "other": "in {0} min." }, "past": { "one": "{0} min. ago", "other": "{0} min. ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } }, "second-short": { "displayName": "sec.", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} sec.", "other": "in {0} sec." }, "past": { "one": "{0} sec. ago", "other": "{0} sec. ago" } } } } };
//# sourceMappingURL=en.js.map

/***/ }),
/* 1353 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1355);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 1357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
var RelativeTimeFormat;
// -- Utilities ----------------------------------------------------------------
function getCacheId(inputs) {
    return JSON.stringify(inputs.map(function (input) {
        return input && typeof input === 'object' ? orderedProps(input) : input;
    }));
}
function orderedProps(obj) {
    return Object.keys(obj)
        .sort()
        .map(function (k) {
        var _a;
        return (_a = {}, _a[k] = obj[k], _a);
    });
}
var memoizeFormatConstructor = function (FormatConstructor, cache) {
    if (cache === void 0) { cache = {}; }
    return function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var cacheId = getCacheId(args);
        var format = cacheId && cache[cacheId];
        if (!format) {
            format = new ((_a = FormatConstructor).bind.apply(_a, [void 0].concat(args)))();
            if (cacheId) {
                cache[cacheId] = format;
            }
        }
        return format;
    };
};
/* harmony default export */ __webpack_exports__["a"] = (memoizeFormatConstructor);
//# sourceMappingURL=index.js.map

/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.en=a())}(this,function(){"use strict";return[{locale:"en",pluralRuleFunction:function(e,a){var t=String(e).split("."),o=!t[1],n=Number(t[0])==e,r=n&&t[0].slice(-1),i=n&&t[0].slice(-2);return a?1==r&&11!=i?"one":2==r&&12!=i?"two":3==r&&13!=i?"few":"other":1==e&&o?"one":"other"},fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr.",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr.",other:"in {0} yr."},past:{one:"{0} yr. ago",other:"{0} yr. ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo.",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo.",other:"in {0} mo."},past:{one:"{0} mo. ago",other:"{0} mo. ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr.",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr.",other:"in {0} hr."},past:{one:"{0} hr. ago",other:"{0} hr. ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min.",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min.",other:"in {0} min."},past:{one:"{0} min. ago",other:"{0} min. ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec.",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec.",other:"in {0} sec."},past:{one:"{0} sec. ago",other:"{0} sec. ago"}}}}},{locale:"en-001",parentLocale:"en",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr",other:"in {0} yr"},past:{one:"{0} yr ago",other:"{0} yr ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo",other:"in {0} mo"},past:{one:"{0} mo ago",other:"{0} mo ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr",other:"in {0} hr"},past:{one:"{0} hr ago",other:"{0} hr ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min",other:"in {0} min"},past:{one:"{0} min ago",other:"{0} min ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec",other:"in {0} sec"},past:{one:"{0} sec ago",other:"{0} sec ago"}}}}},{locale:"en-150",parentLocale:"en-001"},{locale:"en-AG",parentLocale:"en-001"},{locale:"en-AI",parentLocale:"en-001"},{locale:"en-AS",parentLocale:"en"},{locale:"en-AT",parentLocale:"en-150"},{locale:"en-AU",parentLocale:"en-001",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr",other:"in {0} yrs"},past:{one:"{0} yr ago",other:"{0} yrs ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo.",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo.",other:"in {0} mo."},past:{one:"{0} mo. ago",other:"{0} mo. ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"h",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr",other:"in {0} hrs"},past:{one:"{0} hr ago",other:"{0} hrs ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min.",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min.",other:"in {0} mins"},past:{one:"{0} min. ago",other:"{0} mins ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec.",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec.",other:"in {0} secs"},past:{one:"{0} sec. ago",other:"{0} secs ago"}}}}},{locale:"en-BB",parentLocale:"en-001"},{locale:"en-BE",parentLocale:"en-001"},{locale:"en-BI",parentLocale:"en"},{locale:"en-BM",parentLocale:"en-001"},{locale:"en-BS",parentLocale:"en-001"},{locale:"en-BW",parentLocale:"en-001"},{locale:"en-BZ",parentLocale:"en-001"},{locale:"en-CA",parentLocale:"en-001",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr.",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr.",other:"in {0} yrs."},past:{one:"{0} yr. ago",other:"{0} yrs. ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo.",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo.",other:"in {0} mos."},past:{one:"{0} mo. ago",other:"{0} mos. ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr.",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr.",other:"in {0} hrs."},past:{one:"{0} hr. ago",other:"{0} hrs. ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min.",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min.",other:"in {0} mins."},past:{one:"{0} min. ago",other:"{0} mins. ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec.",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec.",other:"in {0} secs."},past:{one:"{0} sec. ago",other:"{0} secs. ago"}}}}},{locale:"en-CC",parentLocale:"en-001"},{locale:"en-CH",parentLocale:"en-150"},{locale:"en-CK",parentLocale:"en-001"},{locale:"en-CM",parentLocale:"en-001"},{locale:"en-CX",parentLocale:"en-001"},{locale:"en-CY",parentLocale:"en-001"},{locale:"en-DE",parentLocale:"en-150"},{locale:"en-DG",parentLocale:"en-001"},{locale:"en-DK",parentLocale:"en-150"},{locale:"en-DM",parentLocale:"en-001"},{locale:"en-Dsrt",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},"year-short":{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},"month-short":{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},"day-short":{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},"hour-short":{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},"minute-short":{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}},"second-short":{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-ER",parentLocale:"en-001"},{locale:"en-FI",parentLocale:"en-150"},{locale:"en-FJ",parentLocale:"en-001"},{locale:"en-FK",parentLocale:"en-001"},{locale:"en-FM",parentLocale:"en-001"},{locale:"en-GB",parentLocale:"en-001"},{locale:"en-GD",parentLocale:"en-001"},{locale:"en-GG",parentLocale:"en-001"},{locale:"en-GH",parentLocale:"en-001"},{locale:"en-GI",parentLocale:"en-001"},{locale:"en-GM",parentLocale:"en-001"},{locale:"en-GU",parentLocale:"en"},{locale:"en-GY",parentLocale:"en-001"},{locale:"en-HK",parentLocale:"en-001"},{locale:"en-IE",parentLocale:"en-001"},{locale:"en-IL",parentLocale:"en-001"},{locale:"en-IM",parentLocale:"en-001"},{locale:"en-IN",parentLocale:"en-001"},{locale:"en-IO",parentLocale:"en-001"},{locale:"en-JE",parentLocale:"en-001"},{locale:"en-JM",parentLocale:"en-001"},{locale:"en-KE",parentLocale:"en-001"},{locale:"en-KI",parentLocale:"en-001"},{locale:"en-KN",parentLocale:"en-001"},{locale:"en-KY",parentLocale:"en-001"},{locale:"en-LC",parentLocale:"en-001"},{locale:"en-LR",parentLocale:"en-001"},{locale:"en-LS",parentLocale:"en-001"},{locale:"en-MG",parentLocale:"en-001"},{locale:"en-MH",parentLocale:"en"},{locale:"en-MO",parentLocale:"en-001"},{locale:"en-MP",parentLocale:"en"},{locale:"en-MS",parentLocale:"en-001"},{locale:"en-MT",parentLocale:"en-001"},{locale:"en-MU",parentLocale:"en-001"},{locale:"en-MW",parentLocale:"en-001"},{locale:"en-MY",parentLocale:"en-001"},{locale:"en-NA",parentLocale:"en-001"},{locale:"en-NF",parentLocale:"en-001"},{locale:"en-NG",parentLocale:"en-001"},{locale:"en-NL",parentLocale:"en-150"},{locale:"en-NR",parentLocale:"en-001"},{locale:"en-NU",parentLocale:"en-001"},{locale:"en-NZ",parentLocale:"en-001"},{locale:"en-PG",parentLocale:"en-001"},{locale:"en-PH",parentLocale:"en-001"},{locale:"en-PK",parentLocale:"en-001"},{locale:"en-PN",parentLocale:"en-001"},{locale:"en-PR",parentLocale:"en"},{locale:"en-PW",parentLocale:"en-001"},{locale:"en-RW",parentLocale:"en-001"},{locale:"en-SB",parentLocale:"en-001"},{locale:"en-SC",parentLocale:"en-001"},{locale:"en-SD",parentLocale:"en-001"},{locale:"en-SE",parentLocale:"en-150"},{locale:"en-SG",parentLocale:"en-001",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr",relative:{0:"this yr",1:"next yr","-1":"last yr"},relativeTime:{future:{one:"in {0} yr",other:"in {0} yr"},past:{one:"{0} yr ago",other:"{0} yr ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mth",relative:{0:"this mth",1:"next mth","-1":"last mth"},relativeTime:{future:{one:"in {0} mth",other:"in {0} mth"},past:{one:"{0} mth ago",other:"{0} mth ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr",other:"in {0} hr"},past:{one:"{0} hr ago",other:"{0} hr ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min",other:"in {0} min"},past:{one:"{0} min ago",other:"{0} min ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec",other:"in {0} sec"},past:{one:"{0} sec ago",other:"{0} sec ago"}}}}},{locale:"en-SH",parentLocale:"en-001"},{locale:"en-SI",parentLocale:"en-150"},{locale:"en-SL",parentLocale:"en-001"},{locale:"en-SS",parentLocale:"en-001"},{locale:"en-SX",parentLocale:"en-001"},{locale:"en-SZ",parentLocale:"en-001"},{locale:"en-Shaw",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},"year-short":{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},"month-short":{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},"day-short":{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},"hour-short":{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},"minute-short":{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}},"second-short":{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-TC",parentLocale:"en-001"},{locale:"en-TK",parentLocale:"en-001"},{locale:"en-TO",parentLocale:"en-001"},{locale:"en-TT",parentLocale:"en-001"},{locale:"en-TV",parentLocale:"en-001"},{locale:"en-TZ",parentLocale:"en-001"},{locale:"en-UG",parentLocale:"en-001"},{locale:"en-UM",parentLocale:"en"},{locale:"en-US",parentLocale:"en"},{locale:"en-VC",parentLocale:"en-001"},{locale:"en-VG",parentLocale:"en-001"},{locale:"en-VI",parentLocale:"en"},{locale:"en-VU",parentLocale:"en-001"},{locale:"en-WS",parentLocale:"en-001"},{locale:"en-ZA",parentLocale:"en-001"},{locale:"en-ZM",parentLocale:"en-001"},{locale:"en-ZW",parentLocale:"en-001"}]});


/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.de=t())}(this,function(){"use strict";return[{locale:"de",pluralRuleFunction:function(e,t){var n=!String(e).split(".")[1];return t?"other":1==e&&n?"one":"other"},fields:{year:{displayName:"Jahr",relative:{0:"dieses Jahr",1:"nächstes Jahr","-1":"letztes Jahr"},relativeTime:{future:{one:"in {0} Jahr",other:"in {0} Jahren"},past:{one:"vor {0} Jahr",other:"vor {0} Jahren"}}},"year-short":{displayName:"Jahr",relative:{0:"dieses Jahr",1:"nächstes Jahr","-1":"letztes Jahr"},relativeTime:{future:{one:"in {0} Jahr",other:"in {0} Jahren"},past:{one:"vor {0} Jahr",other:"vor {0} Jahren"}}},month:{displayName:"Monat",relative:{0:"diesen Monat",1:"nächsten Monat","-1":"letzten Monat"},relativeTime:{future:{one:"in {0} Monat",other:"in {0} Monaten"},past:{one:"vor {0} Monat",other:"vor {0} Monaten"}}},"month-short":{displayName:"Monat",relative:{0:"diesen Monat",1:"nächsten Monat","-1":"letzten Monat"},relativeTime:{future:{one:"in {0} Monat",other:"in {0} Monaten"},past:{one:"vor {0} Monat",other:"vor {0} Monaten"}}},day:{displayName:"Tag",relative:{0:"heute",1:"morgen",2:"übermorgen","-2":"vorgestern","-1":"gestern"},relativeTime:{future:{one:"in {0} Tag",other:"in {0} Tagen"},past:{one:"vor {0} Tag",other:"vor {0} Tagen"}}},"day-short":{displayName:"Tag",relative:{0:"heute",1:"morgen",2:"übermorgen","-2":"vorgestern","-1":"gestern"},relativeTime:{future:{one:"in {0} Tag",other:"in {0} Tagen"},past:{one:"vor {0} Tag",other:"vor {0} Tagen"}}},hour:{displayName:"Stunde",relative:{0:"in dieser Stunde"},relativeTime:{future:{one:"in {0} Stunde",other:"in {0} Stunden"},past:{one:"vor {0} Stunde",other:"vor {0} Stunden"}}},"hour-short":{displayName:"Std.",relative:{0:"in dieser Stunde"},relativeTime:{future:{one:"in {0} Std.",other:"in {0} Std."},past:{one:"vor {0} Std.",other:"vor {0} Std."}}},minute:{displayName:"Minute",relative:{0:"in dieser Minute"},relativeTime:{future:{one:"in {0} Minute",other:"in {0} Minuten"},past:{one:"vor {0} Minute",other:"vor {0} Minuten"}}},"minute-short":{displayName:"Min.",relative:{0:"in dieser Minute"},relativeTime:{future:{one:"in {0} Min.",other:"in {0} Min."},past:{one:"vor {0} Min.",other:"vor {0} Min."}}},second:{displayName:"Sekunde",relative:{0:"jetzt"},relativeTime:{future:{one:"in {0} Sekunde",other:"in {0} Sekunden"},past:{one:"vor {0} Sekunde",other:"vor {0} Sekunden"}}},"second-short":{displayName:"Sek.",relative:{0:"jetzt"},relativeTime:{future:{one:"in {0} Sek.",other:"in {0} Sek."},past:{one:"vor {0} Sek.",other:"vor {0} Sek."}}}}},{locale:"de-AT",parentLocale:"de"},{locale:"de-BE",parentLocale:"de"},{locale:"de-CH",parentLocale:"de"},{locale:"de-IT",parentLocale:"de"},{locale:"de-LI",parentLocale:"de"},{locale:"de-LU",parentLocale:"de"}]});


/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.es=a())}(this,function(){"use strict";return[{locale:"es",pluralRuleFunction:function(e,a){return a?"other":1==e?"one":"other"},fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-419",parentLocale:"es"},{locale:"es-AR",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} días",other:"dentro de {0} días"},past:{one:"hace {0} días",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"seg.",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} seg.",other:"dentro de {0} seg."},past:{one:"hace {0} seg.",other:"hace {0} seg."}}}}},{locale:"es-BO",parentLocale:"es-419"},{locale:"es-BR",parentLocale:"es-419"},{locale:"es-BZ",parentLocale:"es-419"},{locale:"es-CL",parentLocale:"es-419"},{locale:"es-CO",parentLocale:"es-419"},{locale:"es-CR",parentLocale:"es-419"},{locale:"es-CU",parentLocale:"es-419"},{locale:"es-DO",parentLocale:"es-419",fields:{year:{displayName:"Año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"Mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"Día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"Minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"Segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-EA",parentLocale:"es"},{locale:"es-EC",parentLocale:"es-419"},{locale:"es-GQ",parentLocale:"es"},{locale:"es-GT",parentLocale:"es-419"},{locale:"es-HN",parentLocale:"es-419"},{locale:"es-IC",parentLocale:"es"},{locale:"es-MX",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el año próximo","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"en {0} a",other:"en {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el mes próximo","-1":"el mes pasado"},relativeTime:{future:{one:"en {0} mes",other:"en {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"en {0} m",other:"en {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"en {0} día",other:"en {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"en {0} h",other:"en {0} n"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"en {0} min",other:"en {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"en {0} s",other:"en {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-NI",parentLocale:"es-419"},{locale:"es-PA",parentLocale:"es-419"},{locale:"es-PE",parentLocale:"es-419"},{locale:"es-PH",parentLocale:"es"},{locale:"es-PR",parentLocale:"es-419"},{locale:"es-PY",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"seg.",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} seg.",other:"dentro de {0} seg."},past:{one:"hace {0} seg.",other:"hace {0} seg."}}}}},{locale:"es-SV",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-US",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el año próximo","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},"year-short":{displayName:"a",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} a",other:"dentro de {0} a"},past:{one:"hace {0} a",other:"hace {0} a"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el mes próximo","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},"month-short":{displayName:"m",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} m",other:"dentro de {0} m"},past:{one:"hace {0} m",other:"hace {0} m"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},"day-short":{displayName:"d",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},"hour-short":{displayName:"h",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} h",other:"dentro de {0} h"},past:{one:"hace {0} h",other:"hace {0} h"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},"minute-short":{displayName:"min",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} min",other:"dentro de {0} min"},past:{one:"hace {0} min",other:"hace {0} min"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}},"second-short":{displayName:"s",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} s",other:"dentro de {0} s"},past:{one:"hace {0} s",other:"hace {0} s"}}}}},{locale:"es-UY",parentLocale:"es-419"},{locale:"es-VE",parentLocale:"es-419"}]});


/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define(e):(t.ReactIntlLocaleData=t.ReactIntlLocaleData||{},t.ReactIntlLocaleData.fi=e())}(this,function(){"use strict";return[{locale:"fi",pluralRuleFunction:function(t,e){var i=!String(t).split(".")[1];return e?"other":1==t&&i?"one":"other"},fields:{year:{displayName:"vuosi",relative:{0:"tänä vuonna",1:"ensi vuonna","-1":"viime vuonna"},relativeTime:{future:{one:"{0} vuoden päästä",other:"{0} vuoden päästä"},past:{one:"{0} vuosi sitten",other:"{0} vuotta sitten"}}},"year-short":{displayName:"v",relative:{0:"tänä v",1:"ensi v","-1":"viime v"},relativeTime:{future:{one:"{0} v päästä",other:"{0} v päästä"},past:{one:"{0} v sitten",other:"{0} v sitten"}}},month:{displayName:"kuukausi",relative:{0:"tässä kuussa",1:"ensi kuussa","-1":"viime kuussa"},relativeTime:{future:{one:"{0} kuukauden päästä",other:"{0} kuukauden päästä"},past:{one:"{0} kuukausi sitten",other:"{0} kuukautta sitten"}}},"month-short":{displayName:"kk",relative:{0:"tässä kk",1:"ensi kk","-1":"viime kk"},relativeTime:{future:{one:"{0} kk päästä",other:"{0} kk päästä"},past:{one:"{0} kk sitten",other:"{0} kk sitten"}}},day:{displayName:"päivä",relative:{0:"tänään",1:"huomenna",2:"ylihuomenna","-2":"toissa päivänä","-1":"eilen"},relativeTime:{future:{one:"{0} päivän päästä",other:"{0} päivän päästä"},past:{one:"{0} päivä sitten",other:"{0} päivää sitten"}}},"day-short":{displayName:"pv",relative:{0:"tänään",1:"huom.",2:"ylihuom.","-2":"toissap.","-1":"eilen"},relativeTime:{future:{one:"{0} pv päästä",other:"{0} pv päästä"},past:{one:"{0} pv sitten",other:"{0} pv sitten"}}},hour:{displayName:"tunti",relative:{0:"tämän tunnin aikana"},relativeTime:{future:{one:"{0} tunnin päästä",other:"{0} tunnin päästä"},past:{one:"{0} tunti sitten",other:"{0} tuntia sitten"}}},"hour-short":{displayName:"t",relative:{0:"tunnin sisällä"},relativeTime:{future:{one:"{0} t päästä",other:"{0} t päästä"},past:{one:"{0} t sitten",other:"{0} t sitten"}}},minute:{displayName:"minuutti",relative:{0:"tämän minuutin aikana"},relativeTime:{future:{one:"{0} minuutin päästä",other:"{0} minuutin päästä"},past:{one:"{0} minuutti sitten",other:"{0} minuuttia sitten"}}},"minute-short":{displayName:"min",relative:{0:"minuutin sisällä"},relativeTime:{future:{one:"{0} min päästä",other:"{0} min päästä"},past:{one:"{0} min sitten",other:"{0} min sitten"}}},second:{displayName:"sekunti",relative:{0:"nyt"},relativeTime:{future:{one:"{0} sekunnin päästä",other:"{0} sekunnin päästä"},past:{one:"{0} sekunti sitten",other:"{0} sekuntia sitten"}}},"second-short":{displayName:"s",relative:{0:"nyt"},relativeTime:{future:{one:"{0} s päästä",other:"{0} s päästä"},past:{one:"{0} s sitten",other:"{0} s sitten"}}}}}]});


/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.fr=a())}(this,function(){"use strict";return[{locale:"fr",pluralRuleFunction:function(e,a){return a?1==e?"one":"other":e>=0&&e<2?"one":"other"},fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} an",other:"dans {0} ans"},past:{one:"il y a {0} an",other:"il y a {0} ans"}}},"year-short":{displayName:"an",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} a",other:"dans {0} a"},past:{one:"il y a {0} a",other:"il y a {0} a"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},"month-short":{displayName:"m.",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} m.",other:"dans {0} m."},past:{one:"il y a {0} m.",other:"il y a {0} m."}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},"day-short":{displayName:"j",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} j",other:"dans {0} j"},past:{one:"il y a {0} j",other:"il y a {0} j"}}},hour:{displayName:"heure",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},"hour-short":{displayName:"h",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} h",other:"dans {0} h"},past:{one:"il y a {0} h",other:"il y a {0} h"}}},minute:{displayName:"minute",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} minute",other:"dans {0} minutes"},past:{one:"il y a {0} minute",other:"il y a {0} minutes"}}},"minute-short":{displayName:"min",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} min",other:"dans {0} min"},past:{one:"il y a {0} min",other:"il y a {0} min"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}},"second-short":{displayName:"s",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} s",other:"dans {0} s"},past:{one:"il y a {0} s",other:"il y a {0} s"}}}}},{locale:"fr-BE",parentLocale:"fr"},{locale:"fr-BF",parentLocale:"fr"},{locale:"fr-BI",parentLocale:"fr"},{locale:"fr-BJ",parentLocale:"fr"},{locale:"fr-BL",parentLocale:"fr"},{locale:"fr-CA",parentLocale:"fr",fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"Dans {0} an",other:"Dans {0} ans"},past:{one:"Il y a {0} an",other:"Il y a {0} ans"}}},"year-short":{displayName:"a",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} a",other:"dans {0} a"},past:{one:"il y a {0} a",other:"il y a {0} a"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},"month-short":{displayName:"m.",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} m.",other:"dans {0} m."},past:{one:"il y a {0} m.",other:"il y a {0} m."}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},"day-short":{displayName:"j",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} j",other:"dans {0} j"},past:{one:"il y a {0} j",other:"il y a {0} j"}}},hour:{displayName:"heure",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},"hour-short":{displayName:"h",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} h",other:"dans {0} h"},past:{one:"il y a {0} h",other:"il y a {0} h"}}},minute:{displayName:"minute",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} minute",other:"dans {0} minutes"},past:{one:"il y a {0} minute",other:"il y a {0} minutes"}}},"minute-short":{displayName:"min",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} min",other:"dans {0} min"},past:{one:"il y a {0} min",other:"il y a {0} min"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}},"second-short":{displayName:"s",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} s",other:"dans {0} s"},past:{one:"il y a {0} s",other:"il y a {0} s"}}}}},{locale:"fr-CD",parentLocale:"fr"},{locale:"fr-CF",parentLocale:"fr"},{locale:"fr-CG",parentLocale:"fr"},{locale:"fr-CH",parentLocale:"fr"},{locale:"fr-CI",parentLocale:"fr"},{locale:"fr-CM",parentLocale:"fr"},{locale:"fr-DJ",parentLocale:"fr"},{locale:"fr-DZ",parentLocale:"fr"},{locale:"fr-GA",parentLocale:"fr"},{locale:"fr-GF",parentLocale:"fr"},{locale:"fr-GN",parentLocale:"fr"},{locale:"fr-GP",parentLocale:"fr"},{locale:"fr-GQ",parentLocale:"fr"},{locale:"fr-HT",parentLocale:"fr",fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} an",other:"dans {0} ans"},past:{one:"il y a {0} an",other:"il y a {0} ans"}}},"year-short":{displayName:"an",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} a",other:"dans {0} a"},past:{one:"il y a {0} a",other:"il y a {0} a"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},"month-short":{displayName:"m.",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} m.",other:"dans {0} m."},past:{one:"il y a {0} m.",other:"il y a {0} m."}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},"day-short":{displayName:"jr.",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} j",other:"dans {0} j"},past:{one:"il y a {0} j",other:"il y a {0} j"}}},hour:{displayName:"heure",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},"hour-short":{displayName:"hr",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} h",other:"dans {0} h"},past:{one:"il y a {0} h",other:"il y a {0} h"}}},minute:{displayName:"minute",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} minute",other:"dans {0} minutes"},past:{one:"il y a {0} minute",other:"il y a {0} minutes"}}},"minute-short":{displayName:"min.",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} min",other:"dans {0} min"},past:{one:"il y a {0} min",other:"il y a {0} min"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}},"second-short":{displayName:"s",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} s",other:"dans {0} s"},past:{one:"il y a {0} s",other:"il y a {0} s"}}}}},{locale:"fr-KM",parentLocale:"fr"},{locale:"fr-LU",parentLocale:"fr"},{locale:"fr-MA",parentLocale:"fr"},{locale:"fr-MC",parentLocale:"fr"},{locale:"fr-MF",parentLocale:"fr"},{locale:"fr-MG",parentLocale:"fr"},{locale:"fr-ML",parentLocale:"fr"},{locale:"fr-MQ",parentLocale:"fr"},{locale:"fr-MR",parentLocale:"fr"},{locale:"fr-MU",parentLocale:"fr"},{locale:"fr-NC",parentLocale:"fr"},{locale:"fr-NE",parentLocale:"fr"},{locale:"fr-PF",parentLocale:"fr"},{locale:"fr-PM",parentLocale:"fr"},{locale:"fr-RE",parentLocale:"fr"},{locale:"fr-RW",parentLocale:"fr"},{locale:"fr-SC",parentLocale:"fr"},{locale:"fr-SN",parentLocale:"fr"},{locale:"fr-SY",parentLocale:"fr"},{locale:"fr-TD",parentLocale:"fr"},{locale:"fr-TG",parentLocale:"fr"},{locale:"fr-TN",parentLocale:"fr"},{locale:"fr-VU",parentLocale:"fr"},{locale:"fr-WF",parentLocale:"fr"},{locale:"fr-YT",parentLocale:"fr"}]});


/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.it=a())}(this,function(){"use strict";return[{locale:"it",pluralRuleFunction:function(e,a){var t=!String(e).split(".")[1];return a?11==e||8==e||80==e||800==e?"many":"other":1==e&&t?"one":"other"},fields:{year:{displayName:"anno",relative:{0:"quest’anno",1:"anno prossimo","-1":"anno scorso"},relativeTime:{future:{one:"tra {0} anno",other:"tra {0} anni"},past:{one:"{0} anno fa",other:"{0} anni fa"}}},"year-short":{displayName:"anno",relative:{0:"quest’anno",1:"anno prossimo","-1":"anno scorso"},relativeTime:{future:{one:"tra {0} anno",other:"tra {0} anni"},past:{one:"{0} anno fa",other:"{0} anni fa"}}},month:{displayName:"mese",relative:{0:"questo mese",1:"mese prossimo","-1":"mese scorso"},relativeTime:{future:{one:"tra {0} mese",other:"tra {0} mesi"},past:{one:"{0} mese fa",other:"{0} mesi fa"}}},"month-short":{displayName:"mese",relative:{0:"questo mese",1:"mese prossimo","-1":"mese scorso"},relativeTime:{future:{one:"tra {0} mese",other:"tra {0} mesi"},past:{one:"{0} mese fa",other:"{0} mesi fa"}}},day:{displayName:"giorno",relative:{0:"oggi",1:"domani",2:"dopodomani","-2":"l’altro ieri","-1":"ieri"},relativeTime:{future:{one:"tra {0} giorno",other:"tra {0} giorni"},past:{one:"{0} giorno fa",other:"{0} giorni fa"}}},"day-short":{displayName:"g",relative:{0:"oggi",1:"domani",2:"dopodomani","-2":"l’altro ieri","-1":"ieri"},relativeTime:{future:{one:"tra {0} g",other:"tra {0} gg"},past:{one:"{0} g fa",other:"{0} gg fa"}}},hour:{displayName:"ora",relative:{0:"quest’ora"},relativeTime:{future:{one:"tra {0} ora",other:"tra {0} ore"},past:{one:"{0} ora fa",other:"{0} ore fa"}}},"hour-short":{displayName:"h.",relative:{0:"quest’ora"},relativeTime:{future:{one:"tra {0} h",other:"tra {0} h"},past:{one:"{0} h fa",other:"{0} h fa"}}},minute:{displayName:"minuto",relative:{0:"questo minuto"},relativeTime:{future:{one:"tra {0} minuto",other:"tra {0} minuti"},past:{one:"{0} minuto fa",other:"{0} minuti fa"}}},"minute-short":{displayName:"min",relative:{0:"questo minuto"},relativeTime:{future:{one:"tra {0} min",other:"tra {0} min"},past:{one:"{0} min fa",other:"{0} min fa"}}},second:{displayName:"secondo",relative:{0:"ora"},relativeTime:{future:{one:"tra {0} secondo",other:"tra {0} secondi"},past:{one:"{0} secondo fa",other:"{0} secondi fa"}}},"second-short":{displayName:"s",relative:{0:"ora"},relativeTime:{future:{one:"tra {0} s",other:"tra {0} sec."},past:{one:"{0} s fa",other:"{0} sec. fa"}}}}},{locale:"it-CH",parentLocale:"it"},{locale:"it-SM",parentLocale:"it"},{locale:"it-VA",parentLocale:"it"}]});


/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.ro=t())}(this,function(){"use strict";return[{locale:"ro",pluralRuleFunction:function(e,t){var a=String(e).split("."),i=!a[1],u=Number(a[0])==e&&a[0].slice(-2);return t?1==e?"one":"other":1==e&&i?"one":!i||0==e||1!=e&&u>=1&&u<=19?"few":"other"},fields:{year:{displayName:"an",relative:{0:"anul acesta",1:"anul viitor","-1":"anul trecut"},relativeTime:{future:{one:"peste {0} an",few:"peste {0} ani",other:"peste {0} de ani"},past:{one:"acum {0} an",few:"acum {0} ani",other:"acum {0} de ani"}}},"year-short":{displayName:"an",relative:{0:"anul acesta",1:"anul viitor","-1":"anul trecut"},relativeTime:{future:{one:"peste {0} an",few:"peste {0} ani",other:"peste {0} de ani"},past:{one:"acum {0} an",few:"acum {0} ani",other:"acum {0} de ani"}}},month:{displayName:"lună",relative:{0:"luna aceasta",1:"luna viitoare","-1":"luna trecută"},relativeTime:{future:{one:"peste {0} lună",few:"peste {0} luni",other:"peste {0} de luni"},past:{one:"acum {0} lună",few:"acum {0} luni",other:"acum {0} de luni"}}},"month-short":{displayName:"lună",relative:{0:"luna aceasta",1:"luna viitoare","-1":"luna trecută"},relativeTime:{future:{one:"peste {0} lună",few:"peste {0} luni",other:"peste {0} luni"},past:{one:"acum {0} lună",few:"acum {0} luni",other:"acum {0} luni"}}},day:{displayName:"zi",relative:{0:"azi",1:"mâine",2:"poimâine","-2":"alaltăieri","-1":"ieri"},relativeTime:{future:{one:"peste {0} zi",few:"peste {0} zile",other:"peste {0} de zile"},past:{one:"acum {0} zi",few:"acum {0} zile",other:"acum {0} de zile"}}},"day-short":{displayName:"zi",relative:{0:"azi",1:"mâine",2:"poimâine","-2":"alaltăieri","-1":"ieri"},relativeTime:{future:{one:"peste {0} zi",few:"peste {0} zile",other:"peste {0} de zile"},past:{one:"acum {0} zi",few:"acum {0} zile",other:"acum {0} de zile"}}},hour:{displayName:"oră",relative:{0:"ora aceasta"},relativeTime:{future:{one:"peste {0} oră",few:"peste {0} ore",other:"peste {0} de ore"},past:{one:"acum {0} oră",few:"acum {0} ore",other:"acum {0} de ore"}}},"hour-short":{displayName:"h",relative:{0:"ora aceasta"},relativeTime:{future:{one:"peste {0} h",few:"peste {0} h",other:"peste {0} h"},past:{one:"acum {0} h",few:"acum {0} h",other:"acum {0} h"}}},minute:{displayName:"minut",relative:{0:"minutul acesta"},relativeTime:{future:{one:"peste {0} minut",few:"peste {0} minute",other:"peste {0} de minute"},past:{one:"acum {0} minut",few:"acum {0} minute",other:"acum {0} de minute"}}},"minute-short":{displayName:"min.",relative:{0:"minutul acesta"},relativeTime:{future:{one:"peste {0} min.",few:"peste {0} min.",other:"peste {0} min."},past:{one:"acum {0} min.",few:"acum {0} min.",other:"acum {0} min."}}},second:{displayName:"secundă",relative:{0:"acum"},relativeTime:{future:{one:"peste {0} secundă",few:"peste {0} secunde",other:"peste {0} de secunde"},past:{one:"acum {0} secundă",few:"acum {0} secunde",other:"acum {0} de secunde"}}},"second-short":{displayName:"sec.",relative:{0:"acum"},relativeTime:{future:{one:"peste {0} sec.",few:"peste {0} sec.",other:"peste {0} sec."},past:{one:"acum {0} sec.",few:"acum {0} sec.",other:"acum {0} sec."}}}}},{locale:"ro-MD",parentLocale:"ro"}]});


/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.sl=t())}(this,function(){"use strict";return[{locale:"sl",pluralRuleFunction:function(e,t){var r=String(e).split("."),o=r[0],a=!r[1],i=o.slice(-2);return t?"other":a&&1==i?"one":a&&2==i?"two":a&&(3==i||4==i)||!a?"few":"other"},fields:{year:{displayName:"leto",relative:{0:"letos",1:"naslednje leto","-1":"lani"},relativeTime:{future:{one:"čez {0} leto",two:"čez {0} leti",few:"čez {0} leta",other:"čez {0} let"},past:{one:"pred {0} letom",two:"pred {0} letoma",few:"pred {0} leti",other:"pred {0} leti"}}},"year-short":{displayName:"leto",relative:{0:"letos",1:"naslednje leto","-1":"lani"},relativeTime:{future:{one:"čez {0} leto",two:"čez {0} leti",few:"čez {0} leta",other:"čez {0} let"},past:{one:"pred {0} letom",two:"pred {0} letoma",few:"pred {0} leti",other:"pred {0} leti"}}},month:{displayName:"mesec",relative:{0:"ta mesec",1:"naslednji mesec","-1":"prejšnji mesec"},relativeTime:{future:{one:"čez {0} mesec",two:"čez {0} meseca",few:"čez {0} mesece",other:"čez {0} mesecev"},past:{one:"pred {0} mesecem",two:"pred {0} mesecema",few:"pred {0} meseci",other:"pred {0} meseci"}}},"month-short":{displayName:"mes.",relative:{0:"ta mesec",1:"naslednji mesec","-1":"prejšnji mesec"},relativeTime:{future:{one:"čez {0} mes.",two:"čez {0} mes.",few:"čez {0} mes.",other:"čez {0} mes."},past:{one:"pred {0} mes.",two:"pred {0} mes.",few:"pred {0} mes.",other:"pred {0} mes."}}},day:{displayName:"dan",relative:{0:"danes",1:"jutri",2:"pojutrišnjem","-2":"predvčerajšnjim","-1":"včeraj"},relativeTime:{future:{one:"čez {0} dan",two:"čez {0} dneva",few:"čez {0} dni",other:"čez {0} dni"},past:{one:"pred {0} dnevom",two:"pred {0} dnevoma",few:"pred {0} dnevi",other:"pred {0} dnevi"}}},"day-short":{displayName:"dan",relative:{0:"danes",1:"jutri",2:"pojutrišnjem","-2":"predvčerajšnjim","-1":"včeraj"},relativeTime:{future:{one:"čez {0} dan",two:"čez {0} dneva",few:"čez {0} dni",other:"čez {0} dni"},past:{one:"pred {0} dnevom",two:"pred {0} dnevoma",few:"pred {0} dnevi",other:"pred {0} dnevi"}}},hour:{displayName:"ura",relative:{0:"v tej uri"},relativeTime:{future:{one:"čez {0} uro",two:"čez {0} uri",few:"čez {0} ure",other:"čez {0} ur"},past:{one:"pred {0} uro",two:"pred {0} urama",few:"pred {0} urami",other:"pred {0} urami"}}},"hour-short":{displayName:"ura",relative:{0:"v tej uri"},relativeTime:{future:{one:"čez {0} uro",two:"čez {0} uri",few:"čez {0} ure",other:"čez {0} ur"},past:{one:"pred {0} uro",two:"pred {0} urama",few:"pred {0} urami",other:"pred {0} urami"}}},minute:{displayName:"minuta",relative:{0:"to minuto"},relativeTime:{future:{one:"čez {0} minuto",two:"čez {0} minuti",few:"čez {0} minute",other:"čez {0} minut"},past:{one:"pred {0} minuto",two:"pred {0} minutama",few:"pred {0} minutami",other:"pred {0} minutami"}}},"minute-short":{displayName:"min.",relative:{0:"to minuto"},relativeTime:{future:{one:"čez {0} min.",two:"čez {0} min.",few:"čez {0} min.",other:"čez {0} min."},past:{one:"pred {0} min.",two:"pred {0} min.",few:"pred {0} min.",other:"pred {0} min."}}},second:{displayName:"sekunda",relative:{0:"zdaj"},relativeTime:{future:{one:"čez {0} sekundo",two:"čez {0} sekundi",few:"čez {0} sekunde",other:"čez {0} sekund"},past:{one:"pred {0} sekundo",two:"pred {0} sekundama",few:"pred {0} sekundami",other:"pred {0} sekundami"}}},"second-short":{displayName:"sek.",relative:{0:"zdaj"},relativeTime:{future:{one:"čez {0} s",two:"čez {0} s",few:"čez {0} s",other:"čez {0} s"},past:{one:"pred {0} s",two:"pred {0} s",few:"pred {0} s",other:"pred {0} s"}}}}}]});


/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.bs=a())}(this,function(){"use strict";return[{locale:"bs",pluralRuleFunction:function(e,a){var t=String(e).split("."),r=t[0],i=t[1]||"",o=!t[1],n=r.slice(-1),s=r.slice(-2),l=i.slice(-1),u=i.slice(-2);return a?"other":o&&1==n&&11!=s||1==l&&11!=u?"one":o&&n>=2&&n<=4&&(s<12||s>14)||l>=2&&l<=4&&(u<12||u>14)?"few":"other"},fields:{year:{displayName:"godina",relative:{0:"ove godine",1:"sljedeće godine","-1":"prošle godine"},relativeTime:{future:{one:"za {0} godinu",few:"za {0} godine",other:"za {0} godina"},past:{one:"prije {0} godinu",few:"prije {0} godine",other:"prije {0} godina"}}},"year-short":{displayName:"god.",relative:{0:"ove godine",1:"sljedeće godine","-1":"prošle godine"},relativeTime:{future:{one:"za {0} god.",few:"za {0} god.",other:"za {0} god."},past:{one:"prije {0} god.",few:"prije {0} god.",other:"prije {0} god."}}},month:{displayName:"mjesec",relative:{0:"ovaj mjesec",1:"sljedeći mjesec","-1":"prošli mjesec"},relativeTime:{future:{one:"za {0} mjesec",few:"za {0} mjeseca",other:"za {0} mjeseci"},past:{one:"prije {0} mjesec",few:"prije {0} mjeseca",other:"prije {0} mjeseci"}}},"month-short":{displayName:"mj.",relative:{0:"ovaj mjesec",1:"sljedeći mjesec","-1":"prošli mjesec"},relativeTime:{future:{one:"za {0} mj.",few:"za {0} mj.",other:"za {0} mj."},past:{one:"prije {0} mj.",few:"prije {0} mj.",other:"prije {0} mj."}}},day:{displayName:"dan",relative:{0:"danas",1:"sutra",2:"prekosutra","-2":"prekjučer","-1":"jučer"},relativeTime:{future:{one:"za {0} dan",few:"za {0} dana",other:"za {0} dana"},past:{one:"prije {0} dan",few:"prije {0} dana",other:"prije {0} dana"}}},"day-short":{displayName:"dan",relative:{0:"danas",1:"sutra",2:"prekosutra","-2":"prekjučer","-1":"jučer"},relativeTime:{future:{one:"za {0} d.",few:"za {0} d.",other:"za {0} d."},past:{one:"prije {0} d.",few:"prije {0} d.",other:"prije {0} d."}}},hour:{displayName:"sat",relative:{0:"ovaj sat"},relativeTime:{future:{one:"za {0} sat",few:"za {0} sata",other:"za {0} sati"},past:{one:"prije {0} sat",few:"prije {0} sata",other:"prije {0} sati"}}},"hour-short":{displayName:"h",relative:{0:"ovaj sat"},relativeTime:{future:{one:"za {0} sat",few:"za {0} sata",other:"za {0} sati"},past:{one:"prije {0} sat",few:"prije {0} sata",other:"prije {0} sati"}}},minute:{displayName:"minuta",relative:{0:"ova minuta"},relativeTime:{future:{one:"za {0} minutu",few:"za {0} minute",other:"za {0} minuta"},past:{one:"prije {0} minutu",few:"prije {0} minute",other:"prije {0} minuta"}}},"minute-short":{displayName:"min.",relative:{0:"ova minuta"},relativeTime:{future:{one:"za {0} min.",few:"za {0} min.",other:"za {0} min."},past:{one:"prije {0} min.",few:"prije {0} min.",other:"prije {0} min."}}},second:{displayName:"sekunda",relative:{0:"sada"},relativeTime:{future:{one:"za {0} sekundu",few:"za {0} sekunde",other:"za {0} sekundi"},past:{one:"prije {0} sekundu",few:"prije {0} sekunde",other:"prije {0} sekundi"}}},"second-short":{displayName:"sek.",relative:{0:"sada"},relativeTime:{future:{one:"za {0} sek.",few:"za {0} sek.",other:"za {0} sek."},past:{one:"prije {0} sek.",few:"prije {0} sek.",other:"prije {0} sek."}}}}},{locale:"bs-Cyrl",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"година",relative:{0:"Ове године",1:"Следеће године","-1":"Прошле године"},relativeTime:{future:{one:"за {0} годину",few:"за {0} године",other:"за {0} година"},past:{one:"пре {0} годину",few:"пре {0} године",other:"пре {0} година"}}},"year-short":{displayName:"година",relative:{0:"Ове године",1:"Следеће године","-1":"Прошле године"},relativeTime:{future:{one:"за {0} годину",few:"за {0} године",other:"за {0} година"},past:{one:"пре {0} годину",few:"пре {0} године",other:"пре {0} година"}}},month:{displayName:"месец",relative:{0:"Овог месеца",1:"Следећег месеца","-1":"Прошлог месеца"},relativeTime:{future:{one:"за {0} месец",few:"за {0} месеца",other:"за {0} месеци"},past:{one:"пре {0} месец",few:"пре {0} месеца",other:"пре {0} месеци"}}},"month-short":{displayName:"месец",relative:{0:"Овог месеца",1:"Следећег месеца","-1":"Прошлог месеца"},relativeTime:{future:{one:"за {0} месец",few:"за {0} месеца",other:"за {0} месеци"},past:{one:"пре {0} месец",few:"пре {0} месеца",other:"пре {0} месеци"}}},day:{displayName:"дан",relative:{0:"данас",1:"сутра",2:"прекосутра","-2":"прекјуче","-1":"јуче"},relativeTime:{future:{one:"за {0} дан",few:"за {0} дана",other:"за {0} дана"},past:{one:"пре {0} дан",few:"пре {0} дана",other:"пре {0} дана"}}},"day-short":{displayName:"дан",relative:{0:"данас",1:"сутра",2:"прекосутра","-2":"прекјуче","-1":"јуче"},relativeTime:{future:{one:"за {0} дан",few:"за {0} дана",other:"за {0} дана"},past:{one:"пре {0} дан",few:"пре {0} дана",other:"пре {0} дана"}}},hour:{displayName:"час",relative:{0:"this hour"},relativeTime:{future:{one:"за {0} сат",few:"за {0} сата",other:"за {0} сати"},past:{one:"пре {0} сат",few:"пре {0} сата",other:"пре {0} сати"}}},"hour-short":{displayName:"час",relative:{0:"this hour"},relativeTime:{future:{one:"за {0} сат",few:"за {0} сата",other:"за {0} сати"},past:{one:"пре {0} сат",few:"пре {0} сата",other:"пре {0} сати"}}},minute:{displayName:"минут",relative:{0:"this minute"},relativeTime:{future:{one:"за {0} минут",few:"за {0} минута",other:"за {0} минута"},past:{one:"пре {0} минут",few:"пре {0} минута",other:"пре {0} минута"}}},"minute-short":{displayName:"минут",relative:{0:"this minute"},relativeTime:{future:{one:"за {0} минут",few:"за {0} минута",other:"за {0} минута"},past:{one:"пре {0} минут",few:"пре {0} минута",other:"пре {0} минута"}}},second:{displayName:"секунд",relative:{0:"now"},relativeTime:{future:{one:"за {0} секунд",few:"за {0} секунде",other:"за {0} секунди"},past:{one:"пре {0} секунд",few:"пре {0} секунде",other:"пре {0} секунди"}}},"second-short":{displayName:"секунд",relative:{0:"now"},relativeTime:{future:{one:"за {0} секунд",few:"за {0} секунде",other:"за {0} секунди"},past:{one:"пре {0} секунд",few:"пре {0} секунде",other:"пре {0} секунди"}}}}},{locale:"bs-Latn",parentLocale:"bs"}]});


/***/ }),
/* 1367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_App_stores_AppStore__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_App_stores_UserStore__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Search_stores_InventoryStore__ = __webpack_require__(1658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Overview_stores_ListingsStore__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Overview_stores_MlsStore__ = __webpack_require__(1682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_Sale_stores_SaleStore__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_SaleWizard_stores_SaleWizardStore__ = __webpack_require__(1683);
var stores={app:__WEBPACK_IMPORTED_MODULE_0__containers_App_stores_AppStore__["a" /* default */],user:__WEBPACK_IMPORTED_MODULE_1__containers_App_stores_UserStore__["a" /* default */],inventory:__WEBPACK_IMPORTED_MODULE_2__containers_Search_stores_InventoryStore__["a" /* default */],listings:__WEBPACK_IMPORTED_MODULE_3__containers_Overview_stores_ListingsStore__["a" /* default */],mls:__WEBPACK_IMPORTED_MODULE_4__containers_Overview_stores_MlsStore__["a" /* default */],sale:__WEBPACK_IMPORTED_MODULE_5__containers_Sale_stores_SaleStore__["a" /* default */],saleWizard:__WEBPACK_IMPORTED_MODULE_6__containers_SaleWizard_stores_SaleWizardStore__["a" /* default */]};/* harmony default export */ __webpack_exports__["a"] = (stores);

/***/ }),
/* 1368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ReactPlugin__ = __webpack_require__(1369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__withAITracking__ = __webpack_require__(1376);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ReactPlugin__["a"]; });
/* unused harmony reexport withAITracking */
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.



//# sourceMappingURL=applicationinsights-react-js.js.map

/***/ }),
/* 1369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__ = __webpack_require__(1370);
/**
 * ReactPlugin.ts
 * @copyright Microsoft 2019
 */


var ReactPlugin = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ReactPlugin, _super);
    function ReactPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.priority = 185;
        _this.identifier = 'ReactPlugin';
        return _this;
    }
    ReactPlugin.prototype.initialize = function (config, core, extensions, pluginChain) {
        var _this = this;
        _super.prototype.initialize.call(this, config, core, extensions, pluginChain);
        this._extensionConfig =
            config.extensionConfig && config.extensionConfig[this.identifier]
                ? config.extensionConfig[this.identifier]
                : { history: null };
        __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["b" /* CoreUtils */].arrForEach(extensions, function (ext) {
            var identifier = ext.identifier;
            if (identifier === 'ApplicationInsightsAnalytics') {
                _this._analyticsPlugin = ext;
            }
        });
        if (this._extensionConfig.history) {
            this.addHistoryListener(this._extensionConfig.history);
            var pageViewTelemetry = {
                uri: this._extensionConfig.history.location.pathname
            };
            this.trackPageView(pageViewTelemetry);
        }
    };
    /**
     * Add Part A fields to the event
     * @param event The event that needs to be processed
     */
    ReactPlugin.prototype.processTelemetry = function (event, itemCtx) {
        this.processNext(event, itemCtx);
    };
    ReactPlugin.prototype.trackMetric = function (metric, customProperties) {
        if (this._analyticsPlugin) {
            this._analyticsPlugin.trackMetric(metric, customProperties);
        }
        else {
            this.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].TelemetryInitializerFailed, "Analytics plugin is not available, React plugin telemetry will not be sent: ");
        }
    };
    ReactPlugin.prototype.trackPageView = function (pageView) {
        if (this._analyticsPlugin) {
            this._analyticsPlugin.trackPageView(pageView);
        }
        else {
            this.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].TelemetryInitializerFailed, "Analytics plugin is not available, React plugin telemetry will not be sent: ");
        }
    };
    ReactPlugin.prototype.addHistoryListener = function (history) {
        var _this = this;
        var locationListener = function (location, action) {
            // Timeout to ensure any changes to the DOM made by route changes get included in pageView telemetry
            setTimeout(function () {
                var pageViewTelemetry = { uri: location.pathname };
                _this.trackPageView(pageViewTelemetry);
            }, 500);
        };
        history.listen(locationListener);
    };
    return ReactPlugin;
}(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["a" /* BaseTelemetryPlugin */]));
/* harmony default export */ __webpack_exports__["a"] = (ReactPlugin);
//# sourceMappingURL=ReactPlugin.js.map

/***/ }),
/* 1370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__JavaScriptSDK_Interfaces_IChannelControls__ = __webpack_require__(1371);
/* unused harmony reexport MinChannelPriorty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JavaScriptSDK_Enums_EventsDiscardedReason__ = __webpack_require__(534);
/* unused harmony reexport EventsDiscardedReason */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JavaScriptSDK_AppInsightsCore__ = __webpack_require__(1372);
/* unused harmony reexport AppInsightsCore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__JavaScriptSDK_BaseCore__ = __webpack_require__(535);
/* unused harmony reexport BaseCore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__JavaScriptSDK_BaseTelemetryPlugin__ = __webpack_require__(536);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__JavaScriptSDK_BaseTelemetryPlugin__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__JavaScriptSDK_CoreUtils__ = __webpack_require__(75);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__JavaScriptSDK_CoreUtils__["a"]; });
/* unused harmony reexport EventHelper */
/* unused harmony reexport Undefined */
/* unused harmony reexport normalizeJsName */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__JavaScriptSDK_EnvUtils__ = __webpack_require__(232);
/* unused harmony reexport getGlobal */
/* unused harmony reexport getGlobalInst */
/* unused harmony reexport hasWindow */
/* unused harmony reexport getWindow */
/* unused harmony reexport hasDocument */
/* unused harmony reexport getDocument */
/* unused harmony reexport hasNavigator */
/* unused harmony reexport getNavigator */
/* unused harmony reexport hasHistory */
/* unused harmony reexport getHistory */
/* unused harmony reexport getLocation */
/* unused harmony reexport getPerformance */
/* unused harmony reexport hasJSON */
/* unused harmony reexport getJSON */
/* unused harmony reexport strUndefined */
/* unused harmony reexport strObject */
/* unused harmony reexport strPrototype */
/* unused harmony reexport strFunction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__JavaScriptSDK_NotificationManager__ = __webpack_require__(537);
/* unused harmony reexport NotificationManager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__JavaScriptSDK_DiagnosticLogger__ = __webpack_require__(352);
/* unused harmony reexport DiagnosticLogger */
/* unused harmony reexport _InternalLogMessage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__JavaScriptSDK_ProcessTelemetryContext__ = __webpack_require__(233);
/* unused harmony reexport ProcessTelemetryContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__JavaScriptSDK_TelemetryHelpers__ = __webpack_require__(354);
/* unused harmony reexport initializePlugins */
/* unused harmony reexport sortPlugins */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__JavaScriptSDK_Enums_LoggingEnums__ = __webpack_require__(353);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_11__JavaScriptSDK_Enums_LoggingEnums__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_11__JavaScriptSDK_Enums_LoggingEnums__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__JavaScriptSDK_InstrumentHooks__ = __webpack_require__(1375);
/* unused harmony reexport InstrumentProto */
/* unused harmony reexport InstrumentProtos */
/* unused harmony reexport InstrumentFunc */
/* unused harmony reexport InstrumentFuncs */













//# sourceMappingURL=applicationinsights-core-js.js.map

/***/ }),
/* 1371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MinChannelPriorty */

var MinChannelPriorty = 100;
//# sourceMappingURL=IChannelControls.js.map

/***/ }),
/* 1372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AppInsightsCore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseCore__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JavaScriptSDK_Enums_EventsDiscardedReason__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NotificationManager__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CoreUtils__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DiagnosticLogger__ = __webpack_require__(352);






"use strict";
var AppInsightsCore = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](AppInsightsCore, _super);
    function AppInsightsCore() {
        return _super.call(this) || this;
    }
    AppInsightsCore.prototype.initialize = function (config, extensions) {
        var _self = this;
        _self._notificationManager = new __WEBPACK_IMPORTED_MODULE_3__NotificationManager__["a" /* NotificationManager */]();
        _self.logger = new __WEBPACK_IMPORTED_MODULE_5__DiagnosticLogger__["a" /* DiagnosticLogger */](config);
        _self.config = config;
        _super.prototype.initialize.call(this, config, extensions, _self.logger, _self._notificationManager);
    };
    AppInsightsCore.prototype.getTransmissionControls = function () {
        return _super.prototype.getTransmissionControls.call(this);
    };
    AppInsightsCore.prototype.track = function (telemetryItem) {
        if (telemetryItem === null) {
            this._notifyInvalidEvent(telemetryItem);
            // throw error
            throw Error("Invalid telemetry item");
        }
        // do basic validation before sending it through the pipeline
        this._validateTelemetryItem(telemetryItem);
        _super.prototype.track.call(this, telemetryItem);
    };
    /**
     * Adds a notification listener. The SDK calls methods on the listener when an appropriate notification is raised.
     * The added plugins must raise notifications. If the plugins do not implement the notifications, then no methods will be
     * called.
     * @param {INotificationListener} listener - An INotificationListener object.
     */
    AppInsightsCore.prototype.addNotificationListener = function (listener) {
        if (this._notificationManager) {
            this._notificationManager.addNotificationListener(listener);
        }
    };
    /**
     * Removes all instances of the listener.
     * @param {INotificationListener} listener - INotificationListener to remove.
     */
    AppInsightsCore.prototype.removeNotificationListener = function (listener) {
        if (this._notificationManager) {
            this._notificationManager.removeNotificationListener(listener);
        }
    };
    /**
     * Periodically check logger.queue for
     */
    AppInsightsCore.prototype.pollInternalLogs = function (eventName) {
        var _this = this;
        var interval = this.config.diagnosticLogInterval;
        if (!interval || !(interval > 0)) {
            interval = 10000;
        }
        return setInterval(function () {
            var _self = _this;
            var queue = _self.logger ? _self.logger.queue : [];
            __WEBPACK_IMPORTED_MODULE_4__CoreUtils__["a" /* CoreUtils */].arrForEach(queue, function (logMessage) {
                var item = {
                    name: eventName ? eventName : "InternalMessageId: " + logMessage.messageId,
                    iKey: _self.config.instrumentationKey,
                    time: __WEBPACK_IMPORTED_MODULE_4__CoreUtils__["a" /* CoreUtils */].toISOString(new Date()),
                    baseType: __WEBPACK_IMPORTED_MODULE_5__DiagnosticLogger__["b" /* _InternalLogMessage */].dataType,
                    baseData: { message: logMessage.message }
                };
                _self.track(item);
            });
            queue.length = 0;
        }, interval);
    };
    AppInsightsCore.prototype._validateTelemetryItem = function (telemetryItem) {
        if (__WEBPACK_IMPORTED_MODULE_4__CoreUtils__["a" /* CoreUtils */].isNullOrUndefined(telemetryItem.name)) {
            this._notifyInvalidEvent(telemetryItem);
            throw Error("telemetry name required");
        }
    };
    AppInsightsCore.prototype._notifyInvalidEvent = function (telemetryItem) {
        if (this._notificationManager) {
            this._notificationManager.eventsDiscarded([telemetryItem], __WEBPACK_IMPORTED_MODULE_2__JavaScriptSDK_Enums_EventsDiscardedReason__["a" /* EventsDiscardedReason */].InvalidEvent);
        }
    };
    return AppInsightsCore;
}(__WEBPACK_IMPORTED_MODULE_1__BaseCore__["a" /* BaseCore */]));

//# sourceMappingURL=AppInsightsCore.js.map

/***/ }),
/* 1373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChannelController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CoreUtils__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseTelemetryPlugin__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProcessTelemetryContext__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TelemetryHelpers__ = __webpack_require__(354);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.






var ChannelControllerPriority = 500;
var ChannelValidationMessage = "Channel has invalid priority";
var _arrForEach = __WEBPACK_IMPORTED_MODULE_1__CoreUtils__["a" /* CoreUtils */].arrForEach;
var _objDefineAccessors = __WEBPACK_IMPORTED_MODULE_1__CoreUtils__["a" /* CoreUtils */].objDefineAccessors;
function _checkQueuePriority(queue) {
    _arrForEach(queue, function (queueItem) {
        if (queueItem.priority < ChannelControllerPriority) {
            throw Error(ChannelValidationMessage + queueItem.identifier);
        }
    });
}
function _addChannelQueue(channelQueues, queue) {
    if (queue && queue.length > 0) {
        queue = queue.sort(function (a, b) {
            return a.priority - b.priority;
        });
        _checkQueuePriority(queue);
        channelQueues.push(queue);
    }
}
function _createChannelQueues(channels, extensions) {
    var channelQueues = [];
    if (channels) {
        // Add and sort the configuration channel queues
        _arrForEach(channels, function (queue) { return _addChannelQueue(channelQueues, queue); });
    }
    if (extensions) {
        // Create a new channel queue for any extensions with a priority > the ChannelControllerPriority
        var extensionQueue_1 = [];
        _arrForEach(extensions, function (plugin) {
            if (plugin.priority > ChannelControllerPriority) {
                extensionQueue_1.push(plugin);
            }
        });
        _addChannelQueue(channelQueues, extensionQueue_1);
    }
    return channelQueues;
}
var ChannelController = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ChannelController, _super);
    function ChannelController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.identifier = "ChannelControllerPlugin";
        _this.priority = ChannelControllerPriority; // in reserved range 100 to 200
        return _this;
    }
    ChannelController.prototype.processTelemetry = function (item, itemCtx) {
        var _this = this;
        if (this._channelQueue) {
            _arrForEach(this._channelQueue, function (queues) {
                // pass on to first item in queue
                if (queues.length > 0) {
                    // Copying the item context as we could have mutiple chains that are executing asynchronously
                    // and calling _getDefTelCtx as it's possible that the caller doesn't pass any context
                    var chainCtx = _this._getTelCtx(itemCtx).createNew(queues);
                    chainCtx.processNext(item);
                }
            });
        }
    };
    ;
    ChannelController.prototype.getChannelControls = function () {
        return this._channelQueue;
    };
    ChannelController.prototype.initialize = function (config, core, extensions) {
        var _self = this;
        if (_self.isInitialized()) {
            // already initialized
            return;
        }
        _super.prototype.initialize.call(this, config, core, extensions);
        if (config.isCookieUseDisabled) {
            __WEBPACK_IMPORTED_MODULE_1__CoreUtils__["a" /* CoreUtils */].disableCookies();
        }
        var channelQueue = _self._channelQueue = _createChannelQueues((config || {}).channels, extensions);
        // Initialize the Queues
        _arrForEach(channelQueue, function (queue) { return Object(__WEBPACK_IMPORTED_MODULE_4__TelemetryHelpers__["a" /* initializePlugins */])(new __WEBPACK_IMPORTED_MODULE_3__ProcessTelemetryContext__["a" /* ProcessTelemetryContext */](queue, config, core), extensions); });
    };
    /**
     * Static constructor, attempt to create accessors
     */
    // tslint:disable-next-line
    ChannelController._staticInit = (function () {
        // Dynamically create get/set property accessors
        _objDefineAccessors(ChannelController.prototype, "ChannelControls", ChannelController.prototype.getChannelControls);
        _objDefineAccessors(ChannelController.prototype, "channelQueue", ChannelController.prototype.getChannelControls);
    })();
    return ChannelController;
}(__WEBPACK_IMPORTED_MODULE_2__BaseTelemetryPlugin__["a" /* BaseTelemetryPlugin */]));

//# sourceMappingURL=ChannelController.js.map

/***/ }),
/* 1374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TelemetryPluginChain; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CoreUtils__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JavaScriptSDK_Enums_LoggingEnums__ = __webpack_require__(353);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.



var _isFunction = __WEBPACK_IMPORTED_MODULE_0__CoreUtils__["a" /* CoreUtils */].isFunction;
var TelemetryPluginChain = /** @class */ (function () {
    function TelemetryPluginChain(plugin, defItemCtx) {
        var _self = this;
        var _nextProxy = null;
        var _hasProcessTelemetry = _isFunction(plugin.processTelemetry);
        var _hasSetNext = _isFunction(plugin.setNextPlugin);
        _self._hasRun = false;
        _self.getPlugin = function () {
            return plugin;
        };
        _self.getNext = function () {
            return _nextProxy;
        };
        _self.setNext = function (nextPlugin) {
            _nextProxy = nextPlugin;
        };
        _self.processTelemetry = function (env, itemCtx) {
            if (!itemCtx) {
                // Looks like a plugin didn't pass the (optional) context, so restore to the default
                itemCtx = defItemCtx;
            }
            if (plugin && _hasProcessTelemetry) {
                _self._hasRun = true;
                try {
                    // Ensure that we keep the context in sync (for processNext()), just in case a plugin
                    // doesn't calls processTelemetry() instead of itemContext.processNext() or some 
                    // other form of error occurred
                    itemCtx.setNext(_nextProxy);
                    if (_hasSetNext) {
                        // Backward compatibility setting the next plugin on the instance
                        plugin.setNextPlugin(_nextProxy);
                    }
                    // Set a flag on the next plugin so we know if it was attempted to be executed
                    _nextProxy && (_nextProxy._hasRun = false);
                    plugin.processTelemetry(env, itemCtx);
                }
                catch (error) {
                    var hasRun = _nextProxy && _nextProxy._hasRun;
                    if (!_nextProxy || !hasRun) {
                        // Either we have no next plugin or the current one did not attempt to call the next plugin
                        // Which means the current one is the root of the failure so log/report this failure
                        itemCtx.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_1__JavaScriptSDK_Enums_LoggingEnums__["a" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_1__JavaScriptSDK_Enums_LoggingEnums__["b" /* _InternalMessageId */].PluginException, "Plugin [" + plugin.identifier + "] failed during processTelemetry - " + error);
                    }
                    if (_nextProxy && !hasRun) {
                        // As part of the failure the current plugin did not attempt to call the next plugin in the cahin
                        // So rather than leave the pipeline dead in the water we call the next plugin
                        _nextProxy.processTelemetry(env, itemCtx);
                    }
                }
            }
            else if (_nextProxy) {
                _self._hasRun = true;
                // The underlying plugin is either not defined or does not have a processTelemetry implementation
                // so we still want the next plugin to be executed.
                _nextProxy.processTelemetry(env, itemCtx);
            }
        };
    }
    return TelemetryPluginChain;
}());

//# sourceMappingURL=TelemetryPluginChain.js.map

/***/ }),
/* 1375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InstrumentProto */
/* unused harmony export InstrumentProtos */
/* unused harmony export InstrumentFunc */
/* unused harmony export InstrumentFuncs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EnvUtils__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CoreUtils__ = __webpack_require__(75);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.


var aiInstrumentHooks = "_aiHooks";
;
var cbNames = [
    "req", "rsp", "hkErr", "fnErr"
];
/** @ignore */
function _arrLoop(arr, fn) {
    if (arr) {
        for (var lp = 0; lp < arr.length; lp++) {
            if (fn(arr[lp], lp)) {
                break;
            }
        }
    }
}
/** @ignore */
function _doCallbacks(hooks, callDetails, cbArgs, hookCtx, type) {
    if (type >= 0 /* Request */ && type <= 2 /* HookError */) {
        _arrLoop(hooks, function (hook, idx) {
            var cbks = hook.cbks;
            var cb = cbks[cbNames[type]];
            if (cb) {
                // Set the specific hook context implementation using a lazy creation pattern
                callDetails.ctx = function () {
                    var ctx = hookCtx[idx] = (hookCtx[idx] || {});
                    return ctx;
                };
                try {
                    cb.apply(callDetails.inst, cbArgs);
                }
                catch (err) {
                    var orgEx = callDetails.err;
                    try {
                        // Report Hook error via the callback
                        var hookErrorCb = cbks[cbNames[2 /* HookError */]];
                        if (hookErrorCb) {
                            callDetails.err = err;
                            hookErrorCb.apply(callDetails.inst, cbArgs);
                        }
                    }
                    catch (e) {
                        // Not much we can do here -- swallowing the exception to avoid crashing the hosting app
                    }
                    finally {
                        // restore the original exception (if any)
                        callDetails.err = orgEx;
                    }
                }
            }
        });
    }
}
/** @ignore */
function _createFunctionHook(aiHook) {
    // Define a temporary method that queues-up a the real method call
    return function () {
        var funcThis = this;
        // Capture the original arguments passed to the method
        var orgArgs = arguments;
        var hooks = aiHook.h;
        var funcArgs = {
            name: aiHook.n,
            inst: funcThis,
            ctx: null,
            set: _replaceArg
        };
        var hookCtx = [];
        var cbArgs = _createArgs([funcArgs], orgArgs);
        function _createArgs(target, theArgs) {
            _arrLoop(theArgs, function (arg) {
                target.push(arg);
            });
            return target;
        }
        function _replaceArg(idx, value) {
            orgArgs = _createArgs([], orgArgs);
            orgArgs[idx] = value;
            cbArgs = _createArgs([funcArgs], orgArgs);
        }
        // Call the pre-request hooks
        _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 0 /* Request */);
        // Call the original function was called
        var theFunc = aiHook.f;
        try {
            funcArgs.rslt = theFunc.apply(funcThis, orgArgs);
        }
        catch (err) {
            // Report the request callback
            funcArgs.err = err;
            _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 3 /* FunctionError */);
            // rethrow the original exception so anyone listening for it can catch the exception
            throw err;
        }
        // Call the post-request hooks
        _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 1 /* Response */);
        return funcArgs.rslt;
    };
}
/** @ignore */
function _getOwner(target, name, checkPrototype) {
    var owner = null;
    if (target) {
        if (__WEBPACK_IMPORTED_MODULE_1__CoreUtils__["a" /* CoreUtils */].hasOwnProperty(target, name)) {
            owner = target;
        }
        else if (checkPrototype) {
            owner = _getOwner(target[__WEBPACK_IMPORTED_MODULE_0__EnvUtils__["g" /* strPrototype */]], name, false);
        }
    }
    return owner;
}
/**
 * Intercept the named prototype functions for the target class / object
 * @param target - The target object
 * @param funcName - The function name
 * @param callbacks - The callbacks to configure and call whenever the function is called
 */
function InstrumentProto(target, funcName, callbacks) {
    if (target) {
        return InstrumentFunc(target[__WEBPACK_IMPORTED_MODULE_0__EnvUtils__["g" /* strPrototype */]], funcName, callbacks, false);
    }
    return null;
}
/**
 * Intercept the named prototype functions for the target class / object
 * @param target - The target object
 * @param funcNames - The function names to intercept and call
 * @param callbacks - The callbacks to configure and call whenever the function is called
 */
function InstrumentProtos(target, funcNames, callbacks) {
    if (target) {
        return InstrumentFuncs(target[__WEBPACK_IMPORTED_MODULE_0__EnvUtils__["g" /* strPrototype */]], funcNames, callbacks, false);
    }
    return null;
}
/**
 * Intercept the named prototype functions for the target class / object
 * @param target - The target object
 * @param funcName - The function name
 * @param callbacks - The callbacks to configure and call whenever the function is called
 * @param checkPrototype - If the function doesn't exist on the target should it attempt to hook the prototype function
 */
function InstrumentFunc(target, funcName, callbacks, checkPrototype) {
    if (checkPrototype === void 0) { checkPrototype = true; }
    if (target && funcName && callbacks) {
        var owner = _getOwner(target, funcName, checkPrototype);
        var fn = owner[funcName];
        if (typeof fn === __WEBPACK_IMPORTED_MODULE_0__EnvUtils__["e" /* strFunction */]) {
            var aiHook_1 = fn[aiInstrumentHooks];
            if (!aiHook_1) {
                // Only hook the function once
                aiHook_1 = {
                    i: 0,
                    n: funcName,
                    f: fn,
                    h: []
                };
                // Override (hook) the original function
                var newFunc = _createFunctionHook(aiHook_1);
                newFunc[aiInstrumentHooks] = aiHook_1; // Tag and store the function hooks
                owner[funcName] = newFunc;
            }
            var theHook = {
                // tslint:disable:object-literal-shorthand
                id: aiHook_1.i,
                cbks: callbacks,
                rm: function () {
                    // DO NOT Use () => { shorthand for the function as the this gets replaced
                    // with the outer this and not the this for theHook instance.
                    var id = this.id;
                    _arrLoop(aiHook_1.h, function (hook, idx) {
                        if (hook.id === id) {
                            aiHook_1.h.splice(idx, 1);
                            return 1;
                        }
                    });
                }
                // tslint:enable:object-literal-shorthand
            };
            aiHook_1.i++;
            aiHook_1.h.push(theHook);
            return theHook;
        }
    }
    return null;
}
/**
 * Intercept the named functions for the target class / object
 * @param target - The target object
 * @param funcNames - The function names to intercept and call
 * @param callbacks - The callbacks to configure and call whenever the function is called
 * @param checkPrototype - If the function doesn't exist on the target should it attempt to hook the prototype function
 */
function InstrumentFuncs(target, funcNames, callbacks, checkPrototype) {
    if (checkPrototype === void 0) { checkPrototype = true; }
    var hooks = null;
    _arrLoop(funcNames, function (funcName) {
        var hook = InstrumentFunc(target, funcName, callbacks, checkPrototype);
        if (hook) {
            if (!hooks) {
                hooks = [];
            }
            hooks.push(hook);
        }
    });
    return hooks;
}
//# sourceMappingURL=InstrumentHooks.js.map

/***/ }),
/* 1376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.


/**
 * Higher-order component function to hook Application Insights tracking
 * in a React component's lifecycle.
 *
 * @param reactPlugin ReactPlugin instance
 * @param Component the React component to be instrumented
 * @param componentName (optional) component name
 * @param className (optional) className of the HOC div
 */
function withAITracking(reactPlugin, Component, componentName, className) {
    if (componentName === undefined || componentName === null || typeof componentName !== 'string') {
        componentName = Component.prototype.constructor.name;
    }
    if (className === undefined || className === null || typeof className !== 'string') {
        className = '';
    }
    return /** @class */ (function (_super) {
        __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](class_1, _super);
        function class_1() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this._mountTimestamp = 0;
            _this._firstActiveTimestamp = 0;
            _this._idleStartTimestamp = 0;
            _this._lastActiveTimestamp = 0;
            _this._totalIdleTime = 0;
            _this._idleCount = 0;
            _this._idleTimeout = 5000;
            _this.trackActivity = function (e) {
                if (_this._firstActiveTimestamp === 0) {
                    _this._firstActiveTimestamp = Date.now();
                    _this._lastActiveTimestamp = _this._firstActiveTimestamp;
                }
                else {
                    _this._lastActiveTimestamp = Date.now();
                }
                if (_this._idleStartTimestamp > 0) {
                    var lastIdleTime = _this._lastActiveTimestamp - _this._idleStartTimestamp;
                    _this._totalIdleTime += lastIdleTime;
                    _this._idleStartTimestamp = 0;
                }
            };
            return _this;
        }
        class_1.prototype.componentDidMount = function () {
            var _this = this;
            this._mountTimestamp = Date.now();
            this._firstActiveTimestamp = 0;
            this._totalIdleTime = 0;
            this._lastActiveTimestamp = 0;
            this._idleStartTimestamp = 0;
            this._idleCount = 0;
            this._intervalId = setInterval(function () {
                if (_this._lastActiveTimestamp > 0 && _this._idleStartTimestamp === 0 && Date.now() - _this._lastActiveTimestamp >= _this._idleTimeout) {
                    _this._idleStartTimestamp = Date.now();
                    _this._idleCount++;
                }
            }, 100);
        };
        class_1.prototype.componentWillUnmount = function () {
            if (this._mountTimestamp === 0) {
                throw new Error('withAITracking:componentWillUnmount: mountTimestamp is not initialized.');
            }
            if (this._intervalId) {
                clearInterval(this._intervalId);
            }
            if (this._firstActiveTimestamp === 0) {
                return;
            }
            var engagementTime = this.getEngagementTimeSeconds();
            var metricData = {
                average: engagementTime,
                name: 'React Component Engaged Time (seconds)',
                sampleCount: 1
            };
            var additionalProperties = { 'Component Name': componentName };
            reactPlugin.trackMetric(metricData, additionalProperties);
        };
        class_1.prototype.render = function () {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { onKeyDown: this.trackActivity, onMouseMove: this.trackActivity, onScroll: this.trackActivity, onMouseDown: this.trackActivity, onTouchStart: this.trackActivity, onTouchMove: this.trackActivity, className: className },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Component, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this.props))));
        };
        class_1.prototype.getEngagementTimeSeconds = function () {
            return (Date.now() - this._firstActiveTimestamp - this._totalIdleTime - this._idleCount * this._idleTimeout) / 1000;
        };
        return class_1;
    }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
}
//# sourceMappingURL=withAITracking.js.map

/***/ }),
/* 1377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Initialization__ = __webpack_require__(538);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Initialization__["a"]; });
/* unused harmony reexport Telemetry */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ApplicationInsightsContainer__ = __webpack_require__(1555);
/* unused harmony reexport ApplicationInsightsContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__ = __webpack_require__(39);
/* unused harmony reexport AppInsightsCore */
/* unused harmony reexport LoggingSeverity */
/* unused harmony reexport _InternalMessageId */
/* unused harmony reexport PerfEvent */
/* unused harmony reexport PerfManager */
/* unused harmony reexport doPerf */
/* unused harmony reexport NotificationManager */
/* unused harmony reexport BaseTelemetryPlugin */
/* unused harmony reexport BaseCore */
/* unused harmony reexport CoreUtils */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_common__ = __webpack_require__(380);
/* unused harmony reexport Util */
/* unused harmony reexport SeverityLevel */
/* unused harmony reexport Event */
/* unused harmony reexport Exception */
/* unused harmony reexport Metric */
/* unused harmony reexport PageView */
/* unused harmony reexport PageViewPerformance */
/* unused harmony reexport RemoteDependencyData */
/* unused harmony reexport Trace */
/* unused harmony reexport DistributedTracingModes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_channel_js__ = __webpack_require__(561);
/* unused harmony reexport Sender */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_analytics_js__ = __webpack_require__(545);
/* unused harmony reexport ApplicationAnalytics */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__microsoft_applicationinsights_properties_js__ = __webpack_require__(577);
/* unused harmony reexport PropertiesPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__microsoft_applicationinsights_dependencies_js__ = __webpack_require__(596);
/* unused harmony reexport DependenciesPlugin */
/*
 * Application Insights JavaScript SDK - Web, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// Re-exports






//# sourceMappingURL=applicationinsights-web.js.map

/***/ }),
/* 1378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MinChannelPriorty */
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var MinChannelPriorty = 100;
//# sourceMappingURL=IChannelControls.js.map

/***/ }),
/* 1379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppInsightsCore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseCore__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JavaScriptSDK_Enums_EventsDiscardedReason__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NotificationManager__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PerfManager__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DiagnosticLogger__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__microsoft_dynamicproto_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__HelperFuncs__ = __webpack_require__(40);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */








"use strict";
var AppInsightsCore = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(AppInsightsCore, _super);
    function AppInsightsCore() {
        var _this = _super.call(this) || this;
        Object(__WEBPACK_IMPORTED_MODULE_6__microsoft_dynamicproto_js__["a" /* default */])(AppInsightsCore, _this, function (_self, _base) {
            _self.initialize = function (config, extensions, logger, notificationManager) {
                _base.initialize(config, extensions, logger || new __WEBPACK_IMPORTED_MODULE_5__DiagnosticLogger__["a" /* DiagnosticLogger */](config), notificationManager || new __WEBPACK_IMPORTED_MODULE_3__NotificationManager__["a" /* NotificationManager */](config));
            };
            _self.track = function (telemetryItem) {
                Object(__WEBPACK_IMPORTED_MODULE_4__PerfManager__["b" /* doPerf */])(_self.getPerfMgr(), function () { return "AppInsightsCore:track"; }, function () {
                    if (telemetryItem === null) {
                        _notifyInvalidEvent(telemetryItem);
                        // throw error
                        Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["H" /* throwError */])("Invalid telemetry item");
                    }
                    // do basic validation before sending it through the pipeline
                    _validateTelemetryItem(telemetryItem);
                    _base.track(telemetryItem);
                }, function () { return ({ item: telemetryItem }); }, !(telemetryItem.sync));
            };
            /**
             * Adds a notification listener. The SDK calls methods on the listener when an appropriate notification is raised.
             * The added plugins must raise notifications. If the plugins do not implement the notifications, then no methods will be
             * called.
             * @param {INotificationListener} listener - An INotificationListener object.
             */
            _self.addNotificationListener = function (listener) {
                var manager = _self.getNotifyMgr();
                if (manager) {
                    manager.addNotificationListener(listener);
                }
            };
            /**
             * Removes all instances of the listener.
             * @param {INotificationListener} listener - INotificationListener to remove.
             */
            _self.removeNotificationListener = function (listener) {
                var manager = _self.getNotifyMgr();
                if (manager) {
                    manager.removeNotificationListener(listener);
                }
            };
            /**
             * Periodically check logger.queue for
             */
            _self.pollInternalLogs = function (eventName) {
                var interval = _self.config.diagnosticLogInterval;
                if (!interval || !(interval > 0)) {
                    interval = 10000;
                }
                return setInterval(function () {
                    var queue = _self.logger ? _self.logger.queue : [];
                    Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["a" /* arrForEach */])(queue, function (logMessage) {
                        var item = {
                            name: eventName ? eventName : "InternalMessageId: " + logMessage.messageId,
                            iKey: _self.config.instrumentationKey,
                            time: Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["I" /* toISOString */])(new Date()),
                            baseType: __WEBPACK_IMPORTED_MODULE_5__DiagnosticLogger__["b" /* _InternalLogMessage */].dataType,
                            baseData: { message: logMessage.message }
                        };
                        _self.track(item);
                    });
                    queue.length = 0;
                }, interval);
            };
            function _validateTelemetryItem(telemetryItem) {
                if (Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["s" /* isNullOrUndefined */])(telemetryItem.name)) {
                    _notifyInvalidEvent(telemetryItem);
                    throw Error("telemetry name required");
                }
            }
            function _notifyInvalidEvent(telemetryItem) {
                var manager = _self.getNotifyMgr();
                if (manager) {
                    manager.eventsDiscarded([telemetryItem], __WEBPACK_IMPORTED_MODULE_2__JavaScriptSDK_Enums_EventsDiscardedReason__["a" /* EventsDiscardedReason */].InvalidEvent);
                }
            }
        });
        return _this;
    }
// Removed Stub for AppInsightsCore.prototype.initialize.
// Removed Stub for AppInsightsCore.prototype.track.
// Removed Stub for AppInsightsCore.prototype.addNotificationListener.
// Removed Stub for AppInsightsCore.prototype.removeNotificationListener.
// Removed Stub for AppInsightsCore.prototype.pollInternalLogs.
    return AppInsightsCore;
}(__WEBPACK_IMPORTED_MODULE_1__BaseCore__["a" /* BaseCore */]));

//# sourceMappingURL=AppInsightsCore.js.map

/***/ }),
/* 1380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __exposeGlobalTsLib */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Helpers__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TsLibShims__ = __webpack_require__(540);
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.



function __exposeGlobalTsLib() {
    var globalObj = Object(__WEBPACK_IMPORTED_MODULE_1__Helpers__["a" /* getGlobal */])() || {};
    // tslint:disable: only-arrow-functions
    (function (root, assignFn, extendsFn, createBindingFn) {
        // Assign the globally scoped versions of the functions -- used when consuming individual ts files
        // If check is to support NativeScript where these are marked as readonly
        if (!root.__assign) {
            root.__assign = __WEBPACK_IMPORTED_MODULE_0__Constants__["a" /* ObjAssign */] || assignFn;
        }
        if (!root.__extends) {
            root.__extends = extendsFn;
        }
        if (!root.__createBinding) {
            root.__createBinding = createBindingFn;
        }
    })(globalObj, __WEBPACK_IMPORTED_MODULE_2__TsLibShims__["a" /* __assignFn */], __WEBPACK_IMPORTED_MODULE_2__TsLibShims__["c" /* __extendsFn */], __WEBPACK_IMPORTED_MODULE_2__TsLibShims__["b" /* __createBindingFn */]);
    // Assign local variables that will be used for embedded scenarios, if check is to support NativeScript where these are marked as readonly
    if (!__assign) {
        __assign = globalObj.__assign;
    }
    if (!__extends) {
        __extends = globalObj.__extends;
    }
    if (!__createBinding) {
        __createBinding = globalObj.__createBinding;
    }
}
//# sourceMappingURL=TsLibGlobals.js.map

/***/ }),
/* 1381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChannelController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseTelemetryPlugin__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProcessTelemetryContext__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TelemetryHelpers__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HelperFuncs__ = __webpack_require__(40);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */









var ChannelControllerPriority = 500;
var ChannelValidationMessage = "Channel has invalid priority";
var ChannelController = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(ChannelController, _super);
    function ChannelController() {
        var _this = _super.call(this) || this;
        _this.identifier = "ChannelControllerPlugin";
        _this.priority = ChannelControllerPriority; // in reserved range 100 to 200
        var _channelQueue;
        Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__["a" /* default */])(ChannelController, _this, function (_self, _base) {
            _self.setNextPlugin = function (next) {
                // The Channel controller is last in pipeline
            };
            _self.processTelemetry = function (item, itemCtx) {
                if (_channelQueue) {
                    Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["a" /* arrForEach */])(_channelQueue, function (queues) {
                        // pass on to first item in queue
                        if (queues.length > 0) {
                            // Copying the item context as we could have mutiple chains that are executing asynchronously
                            // and calling _getDefTelCtx as it's possible that the caller doesn't pass any context
                            var chainCtx = _this._getTelCtx(itemCtx).createNew(queues);
                            chainCtx.processNext(item);
                        }
                    });
                }
            };
            _self.getChannelControls = function () {
                return _channelQueue;
            };
            _self.initialize = function (config, core, extensions) {
                if (_self.isInitialized()) {
                    // already initialized
                    return;
                }
                _base.initialize(config, core, extensions);
                _createChannelQueues((config || {}).channels, extensions);
                // Initialize the Queues
                Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["a" /* arrForEach */])(_channelQueue, function (queue) { return Object(__WEBPACK_IMPORTED_MODULE_4__TelemetryHelpers__["a" /* initializePlugins */])(new __WEBPACK_IMPORTED_MODULE_3__ProcessTelemetryContext__["a" /* ProcessTelemetryContext */](queue, config, core), extensions); });
            };
        });
        function _checkQueuePriority(queue) {
            Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["a" /* arrForEach */])(queue, function (queueItem) {
                if (queueItem.priority < ChannelControllerPriority) {
                    Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["H" /* throwError */])(ChannelValidationMessage + queueItem.identifier);
                }
            });
        }
        function _addChannelQueue(queue) {
            if (queue && queue.length > 0) {
                queue = queue.sort(function (a, b) {
                    return a.priority - b.priority;
                });
                _checkQueuePriority(queue);
                _channelQueue.push(queue);
            }
        }
        function _createChannelQueues(channels, extensions) {
            _channelQueue = [];
            if (channels) {
                // Add and sort the configuration channel queues
                Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["a" /* arrForEach */])(channels, function (queue) { return _addChannelQueue(queue); });
            }
            if (extensions) {
                // Create a new channel queue for any extensions with a priority > the ChannelControllerPriority
                var extensionQueue_1 = [];
                Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["a" /* arrForEach */])(extensions, function (plugin) {
                    if (plugin.priority > ChannelControllerPriority) {
                        extensionQueue_1.push(plugin);
                    }
                });
                _addChannelQueue(extensionQueue_1);
            }
        }
        return _this;
    }
// Removed Stub for ChannelController.prototype.processTelemetry.
    ;
// Removed Stub for ChannelController.prototype.getChannelControls.
// Removed Stub for ChannelController.prototype.initialize.
    /**
     * Static constructor, attempt to create accessors
     */
    // tslint:disable-next-line
    ChannelController._staticInit = (function () {
        var proto = ChannelController.prototype;
        // Dynamically create get/set property accessors
        Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["z" /* objDefineAccessors */])(proto, "ChannelControls", proto.getChannelControls);
        Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["z" /* objDefineAccessors */])(proto, "channelQueue", proto.getChannelControls);
    })();
    return ChannelController;
}(__WEBPACK_IMPORTED_MODULE_2__BaseTelemetryPlugin__["a" /* BaseTelemetryPlugin */]));

//# sourceMappingURL=ChannelController.js.map

/***/ }),
/* 1382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TelemetryPluginChain; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PerfManager__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JavaScriptSDK_Enums_LoggingEnums__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__ = __webpack_require__(40);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var TelemetryPluginChain = /** @class */ (function () {
    function TelemetryPluginChain(plugin, defItemCtx) {
        var _self = this;
        var _nextProxy = null;
        var _hasProcessTelemetry = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["p" /* isFunction */])(plugin.processTelemetry);
        var _hasSetNext = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["p" /* isFunction */])(plugin.setNextPlugin);
        _self._hasRun = false;
        _self.getPlugin = function () {
            return plugin;
        };
        _self.getNext = function () {
            return _nextProxy;
        };
        _self.setNext = function (nextPlugin) {
            _nextProxy = nextPlugin;
        };
        _self.processTelemetry = function (env, itemCtx) {
            if (!itemCtx) {
                // Looks like a plugin didn't pass the (optional) context, so restore to the default
                itemCtx = defItemCtx;
            }
            var identifier = plugin ? plugin.identifier : "TelemetryPluginChain";
            Object(__WEBPACK_IMPORTED_MODULE_0__PerfManager__["b" /* doPerf */])(itemCtx ? itemCtx.core() : null, function () { return identifier + ":processTelemetry"; }, function () {
                if (plugin && _hasProcessTelemetry) {
                    _self._hasRun = true;
                    try {
                        // Ensure that we keep the context in sync (for processNext()), just in case a plugin
                        // doesn't calls processTelemetry() instead of itemContext.processNext() or some 
                        // other form of error occurred
                        itemCtx.setNext(_nextProxy);
                        if (_hasSetNext) {
                            // Backward compatibility setting the next plugin on the instance
                            plugin.setNextPlugin(_nextProxy);
                        }
                        // Set a flag on the next plugin so we know if it was attempted to be executed
                        _nextProxy && (_nextProxy._hasRun = false);
                        plugin.processTelemetry(env, itemCtx);
                    }
                    catch (error) {
                        var hasRun = _nextProxy && _nextProxy._hasRun;
                        if (!_nextProxy || !hasRun) {
                            // Either we have no next plugin or the current one did not attempt to call the next plugin
                            // Which means the current one is the root of the failure so log/report this failure
                            itemCtx.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_1__JavaScriptSDK_Enums_LoggingEnums__["a" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_1__JavaScriptSDK_Enums_LoggingEnums__["b" /* _InternalMessageId */].PluginException, "Plugin [" + plugin.identifier + "] failed during processTelemetry - " + error);
                        }
                        if (_nextProxy && !hasRun) {
                            // As part of the failure the current plugin did not attempt to call the next plugin in the cahin
                            // So rather than leave the pipeline dead in the water we call the next plugin
                            _nextProxy.processTelemetry(env, itemCtx);
                        }
                    }
                }
                else if (_nextProxy) {
                    _self._hasRun = true;
                    // The underlying plugin is either not defined or does not have a processTelemetry implementation
                    // so we still want the next plugin to be executed.
                    _nextProxy.processTelemetry(env, itemCtx);
                }
            }, function () { return ({ item: env }); }, !(env.sync));
        };
    }
    return TelemetryPluginChain;
}());

//# sourceMappingURL=TelemetryPluginChain.js.map

/***/ }),
/* 1383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Undefined */
/* harmony export (immutable) */ __webpack_exports__["b"] = addEventHandler;
/* unused harmony export newGuid */
/* unused harmony export perfNow */
/* harmony export (immutable) */ __webpack_exports__["h"] = newId;
/* unused harmony export strEndsWith */
/* harmony export (immutable) */ __webpack_exports__["f"] = generateW3CId;
/* unused harmony export CoreUtils */
/* unused harmony export EventHelper */
/* harmony export (immutable) */ __webpack_exports__["a"] = _legacyCookieMgr;
/* harmony export (immutable) */ __webpack_exports__["e"] = disableCookies;
/* harmony export (immutable) */ __webpack_exports__["c"] = canUseCookies;
/* harmony export (immutable) */ __webpack_exports__["g"] = getCookie;
/* harmony export (immutable) */ __webpack_exports__["i"] = setCookie;
/* harmony export (immutable) */ __webpack_exports__["d"] = deleteCookie;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CookieMgr__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EnvUtils__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RandomHelper__ = __webpack_require__(544);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */








var _cookieMgrs = null;
var _canUseCookies; // legacy supported config
// Added to help with minfication
var Undefined = __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["m" /* strShimUndefined */];
/**
 * Trys to add an event handler for the specified event to the window, body and document
 * @param eventName {string} - The name of the event
 * @param callback {any} - The callback function that needs to be executed for the given event
 * @return {boolean} - true if the handler was successfully added
 */
function addEventHandler(eventName, callback) {
    var result = false;
    var w = Object(__WEBPACK_IMPORTED_MODULE_2__EnvUtils__["l" /* getWindow */])();
    if (w) {
        result = Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["e" /* attachEvent */])(w, eventName, callback);
        result = Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["e" /* attachEvent */])(w["body"], eventName, callback) || result;
    }
    var doc = Object(__WEBPACK_IMPORTED_MODULE_2__EnvUtils__["d" /* getDocument */])();
    if (doc) {
        result = EventHelper.Attach(doc, eventName, callback) || result;
    }
    return result;
}
function newGuid() {
    function randomHexDigit() {
        return Object(__WEBPACK_IMPORTED_MODULE_4__RandomHelper__["d" /* randomValue */])(15); // Get a random value from 0..15
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(GuidRegex, function (c) {
        var r = (randomHexDigit() | 0), v = (c === 'x' ? r : r & 0x3 | 0x8);
        return v.toString(16);
    });
}
/**
 * Return the current value of the Performance Api now() function (if available) and fallback to dateNow() if it is unavailable (IE9 or less)
 * https://caniuse.com/#search=performance.now
 */
function perfNow() {
    var perf = Object(__WEBPACK_IMPORTED_MODULE_2__EnvUtils__["k" /* getPerformance */])();
    if (perf && perf.now) {
        return perf.now();
    }
    return Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["g" /* dateNow */])();
}
/**
 * Generate random base64 id string.
 * The default length is 22 which is 132-bits so almost the same as a GUID but as base64 (the previous default was 5)
 * @param maxLength - Optional value to specify the length of the id to be generated, defaults to 22
 */
function newId(maxLength) {
    if (maxLength === void 0) { maxLength = 22; }
    var base64chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Start with an initial random number, consuming the value in reverse byte order
    var number = Object(__WEBPACK_IMPORTED_MODULE_4__RandomHelper__["c" /* random32 */])() >>> 0; // Make sure it's a +ve number
    var chars = 0;
    var result = "";
    while (result.length < maxLength) {
        chars++;
        result += base64chars.charAt(number & 0x3F);
        number >>>= 6; // Zero fill with right shift
        if (chars === 5) {
            // 5 base64 characters === 30 bits so we don't have enough bits for another base64 char
            // So add on another 30 bits and make sure it's +ve
            number = (((Object(__WEBPACK_IMPORTED_MODULE_4__RandomHelper__["c" /* random32 */])() << 2) & 0xFFFFFFFF) | (number & 0x03)) >>> 0;
            chars = 0; // We need to reset the number every 5 chars (30 bits)
        }
    }
    return result;
}
/**
 * The strEndsWith() method determines whether a string ends with the characters of a specified string, returning true or false as appropriate.
 * @param value - The value to check whether it ends with the search value.
 * @param search - The characters to be searched for at the end of the value.
 * @returns true if the given search value is found at the end of the string, otherwise false.
 */
function strEndsWith(value, search) {
    if (value && search) {
        var len = value.length;
        var start = len - search.length;
        return value.substring(start >= 0 ? start : 0, len) === search;
    }
    return false;
}
/**
 * generate W3C trace id
 */
function generateW3CId() {
    var hexValues = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
    // rfc4122 version 4 UUID without dashes and with lowercase letters
    var oct = "", tmp;
    for (var a = 0; a < 4; a++) {
        tmp = Object(__WEBPACK_IMPORTED_MODULE_4__RandomHelper__["c" /* random32 */])();
        oct +=
            hexValues[tmp & 0xF] +
                hexValues[tmp >> 4 & 0xF] +
                hexValues[tmp >> 8 & 0xF] +
                hexValues[tmp >> 12 & 0xF] +
                hexValues[tmp >> 16 & 0xF] +
                hexValues[tmp >> 20 & 0xF] +
                hexValues[tmp >> 24 & 0xF] +
                hexValues[tmp >> 28 & 0xF];
    }
    // "Set the two most significant bits (bits 6 and 7) of the clock_seq_hi_and_reserved to zero and one, respectively"
    var clockSequenceHi = hexValues[8 + (Object(__WEBPACK_IMPORTED_MODULE_4__RandomHelper__["c" /* random32 */])() & 0x03) | 0];
    return oct.substr(0, 8) + oct.substr(9, 4) + "4" + oct.substr(13, 3) + clockSequenceHi + oct.substr(16, 3) + oct.substr(19, 12);
}
/**
 * Provides a collection of utility functions, included for backward compatibility with previous releases.
 * @deprecated Marking this instance as deprecated in favor of direct usage of the helper functions
 * as direct usage provides better tree-shaking and minification by avoiding the inclusion of the unused items
 * in your resulting code.
 */
var CoreUtils = {
    _canUseCookies: undefined,
    isTypeof: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["x" /* isTypeof */],
    isUndefined: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["y" /* isUndefined */],
    isNullOrUndefined: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["s" /* isNullOrUndefined */],
    hasOwnProperty: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["k" /* hasOwnProperty */],
    isFunction: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["p" /* isFunction */],
    isObject: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["u" /* isObject */],
    isDate: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["n" /* isDate */],
    isArray: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["l" /* isArray */],
    isError: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["o" /* isError */],
    isString: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["v" /* isString */],
    isNumber: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["t" /* isNumber */],
    isBoolean: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["m" /* isBoolean */],
    toISOString: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["I" /* toISOString */],
    arrForEach: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["a" /* arrForEach */],
    arrIndexOf: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["b" /* arrIndexOf */],
    arrMap: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["c" /* arrMap */],
    arrReduce: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["d" /* arrReduce */],
    strTrim: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["G" /* strTrim */],
    objCreate: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["i" /* objCreateFn */],
    objKeys: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["B" /* objKeys */],
    objDefineAccessors: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["z" /* objDefineAccessors */],
    addEventHandler: addEventHandler,
    dateNow: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["g" /* dateNow */],
    isIE: __WEBPACK_IMPORTED_MODULE_2__EnvUtils__["p" /* isIE */],
    disableCookies: disableCookies,
    newGuid: newGuid,
    perfNow: perfNow,
    newId: newId,
    randomValue: __WEBPACK_IMPORTED_MODULE_4__RandomHelper__["d" /* randomValue */],
    random32: __WEBPACK_IMPORTED_MODULE_4__RandomHelper__["c" /* random32 */],
    mwcRandomSeed: __WEBPACK_IMPORTED_MODULE_4__RandomHelper__["b" /* mwcRandomSeed */],
    mwcRandom32: __WEBPACK_IMPORTED_MODULE_4__RandomHelper__["a" /* mwcRandom32 */],
    generateW3CId: generateW3CId
};
var GuidRegex = /[xy]/g;
var EventHelper = {
    Attach: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["e" /* attachEvent */],
    AttachEvent: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["e" /* attachEvent */],
    Detach: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["h" /* detachEvent */],
    DetachEvent: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["h" /* detachEvent */]
};
/**
 * Helper to support backward compatibility for users that use the legacy cookie handling functions and the use the internal
 * CoreUtils._canUseCookies global flag to enable/disable cookies usage.
 * Note: This has the following deliberate side-effects
 * - Creates the global (legacy) cookie manager if it does not already exist
 * - Attempts to add "listeners" to the CoreUtils._canUseCookies property to support the legacy usage
 * @param config
 * @param logger
 * @returns
 */
function _legacyCookieMgr(config, logger) {
    var cookieMgr = Object(__WEBPACK_IMPORTED_MODULE_1__CookieMgr__["a" /* _gblCookieMgr */])(config, logger);
    var legacyCanUseCookies = CoreUtils._canUseCookies;
    if (_cookieMgrs === null) {
        _cookieMgrs = [];
        _canUseCookies = legacyCanUseCookies;
        // Dynamically create get/set property accessors for backward compatibility for enabling / disabling cookies
        // this WILL NOT work for ES3 browsers (< IE8)
        Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["z" /* objDefineAccessors */])(CoreUtils, "_canUseCookies", function () {
            return _canUseCookies;
        }, function (value) {
            _canUseCookies = value;
            Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["a" /* arrForEach */])(_cookieMgrs, function (mgr) {
                mgr.setEnabled(value);
            });
        });
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["b" /* arrIndexOf */])(_cookieMgrs, cookieMgr) === -1) {
        _cookieMgrs.push(cookieMgr);
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["m" /* isBoolean */])(legacyCanUseCookies)) {
        cookieMgr.setEnabled(legacyCanUseCookies);
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["m" /* isBoolean */])(_canUseCookies)) {
        cookieMgr.setEnabled(_canUseCookies);
    }
    return cookieMgr;
}
/**
 * @deprecated - Use the core.getCookieMgr().disable()
 * Force the SDK not to store and read any data from cookies.
 */
function disableCookies() {
    _legacyCookieMgr().setEnabled(false);
}
/**
 * @deprecated - Use the core.getCookieMgr().isEnabled()
 * Helper method to tell if document.cookie object is available and whether it can be used.
 */
function canUseCookies(logger) {
    return _legacyCookieMgr(null, logger).isEnabled();
}
/**
 * @deprecated - Use the core.getCookieMgr().get()
 * helper method to access userId and sessionId cookie
 */
function getCookie(logger, name) {
    return _legacyCookieMgr(null, logger).get(name);
}
/**
 * @deprecated - Use the core.getCookieMgr().set()
 * helper method to set userId and sessionId cookie
 */
function setCookie(logger, name, value, domain) {
    _legacyCookieMgr(null, logger).set(name, value, null, domain);
}
/**
 * @deprecated - Use the core.getCookieMgr().del()
 * Deletes a cookie by setting it's expiration time in the past.
 * @param name - The name of the cookie to delete.
 */
function deleteCookie(logger, name) {
    return _legacyCookieMgr(null, logger).del(name);
}
//# sourceMappingURL=CoreUtils.js.map

/***/ }),
/* 1384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InstrumentProto */
/* unused harmony export InstrumentProtos */
/* unused harmony export InstrumentFunc */
/* unused harmony export InstrumentFuncs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HelperFuncs__ = __webpack_require__(40);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var aiInstrumentHooks = "_aiHooks";
;
var cbNames = [
    "req", "rsp", "hkErr", "fnErr"
];
/**
 * Constant string defined to support minimization
 * @ignore
 */
var str__Proto = "__proto__";
/**
 * Constant string defined to support minimization
 * @ignore
 */
var strConstructor = "constructor";
/** @ignore */
function _arrLoop(arr, fn) {
    if (arr) {
        for (var lp = 0; lp < arr.length; lp++) {
            if (fn(arr[lp], lp)) {
                break;
            }
        }
    }
}
/** @ignore */
function _doCallbacks(hooks, callDetails, cbArgs, hookCtx, type) {
    if (type >= 0 /* Request */ && type <= 2 /* HookError */) {
        _arrLoop(hooks, function (hook, idx) {
            var cbks = hook.cbks;
            var cb = cbks[cbNames[type]];
            if (cb) {
                // Set the specific hook context implementation using a lazy creation pattern
                callDetails.ctx = function () {
                    var ctx = hookCtx[idx] = (hookCtx[idx] || {});
                    return ctx;
                };
                try {
                    cb.apply(callDetails.inst, cbArgs);
                }
                catch (err) {
                    var orgEx = callDetails.err;
                    try {
                        // Report Hook error via the callback
                        var hookErrorCb = cbks[cbNames[2 /* HookError */]];
                        if (hookErrorCb) {
                            callDetails.err = err;
                            hookErrorCb.apply(callDetails.inst, cbArgs);
                        }
                    }
                    catch (e) {
                        // Not much we can do here -- swallowing the exception to avoid crashing the hosting app
                    }
                    finally {
                        // restore the original exception (if any)
                        callDetails.err = orgEx;
                    }
                }
            }
        });
    }
}
/** @ignore */
function _createFunctionHook(aiHook) {
    // Define a temporary method that queues-up a the real method call
    return function () {
        var funcThis = this;
        // Capture the original arguments passed to the method
        var orgArgs = arguments;
        var hooks = aiHook.h;
        var funcArgs = {
            name: aiHook.n,
            inst: funcThis,
            ctx: null,
            set: _replaceArg
        };
        var hookCtx = [];
        var cbArgs = _createArgs([funcArgs], orgArgs);
        function _createArgs(target, theArgs) {
            _arrLoop(theArgs, function (arg) {
                target.push(arg);
            });
            return target;
        }
        function _replaceArg(idx, value) {
            orgArgs = _createArgs([], orgArgs);
            orgArgs[idx] = value;
            cbArgs = _createArgs([funcArgs], orgArgs);
        }
        // Call the pre-request hooks
        _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 0 /* Request */);
        // Call the original function was called
        var theFunc = aiHook.f;
        try {
            funcArgs.rslt = theFunc.apply(funcThis, orgArgs);
        }
        catch (err) {
            // Report the request callback
            funcArgs.err = err;
            _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 3 /* FunctionError */);
            // rethrow the original exception so anyone listening for it can catch the exception
            throw err;
        }
        // Call the post-request hooks
        _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 1 /* Response */);
        return funcArgs.rslt;
    };
}
/**
 * Pre-lookup to check if we are running on a modern browser (i.e. not IE8)
 * @ignore
 */
var _objGetPrototypeOf = Object["getPrototypeOf"];
/**
 * Helper used to get the prototype of the target object as getPrototypeOf is not available in an ES3 environment.
 * @ignore
 */
function _getObjProto(target) {
    if (target) {
        // This method doesn't existing in older browsers (e.g. IE8)
        if (_objGetPrototypeOf) {
            return _objGetPrototypeOf(target);
        }
        // target[Constructor] May break if the constructor has been changed or removed
        var newProto = target[str__Proto] || target[__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["l" /* strShimPrototype */]] || target[strConstructor];
        if (newProto) {
            return newProto;
        }
    }
    return null;
}
/** @ignore */
function _getOwner(target, name, checkPrototype) {
    var owner = null;
    if (target) {
        if (Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["k" /* hasOwnProperty */])(target, name)) {
            owner = target;
        }
        else if (checkPrototype) {
            owner = _getOwner(_getObjProto(target), name, false);
        }
    }
    return owner;
}
/**
 * Intercept the named prototype functions for the target class / object
 * @param target - The target object
 * @param funcName - The function name
 * @param callbacks - The callbacks to configure and call whenever the function is called
 */
function InstrumentProto(target, funcName, callbacks) {
    if (target) {
        return InstrumentFunc(target[__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["l" /* strShimPrototype */]], funcName, callbacks, false);
    }
    return null;
}
/**
 * Intercept the named prototype functions for the target class / object
 * @param target - The target object
 * @param funcNames - The function names to intercept and call
 * @param callbacks - The callbacks to configure and call whenever the function is called
 */
function InstrumentProtos(target, funcNames, callbacks) {
    if (target) {
        return InstrumentFuncs(target[__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["l" /* strShimPrototype */]], funcNames, callbacks, false);
    }
    return null;
}
/**
 * Intercept the named prototype functions for the target class / object
 * @param target - The target object
 * @param funcName - The function name
 * @param callbacks - The callbacks to configure and call whenever the function is called
 * @param checkPrototype - If the function doesn't exist on the target should it attempt to hook the prototype function
 */
function InstrumentFunc(target, funcName, callbacks, checkPrototype) {
    if (checkPrototype === void 0) { checkPrototype = true; }
    if (target && funcName && callbacks) {
        var owner = _getOwner(target, funcName, checkPrototype);
        if (owner) {
            var fn = owner[funcName];
            if (typeof fn === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["j" /* strShimFunction */]) {
                var aiHook_1 = fn[aiInstrumentHooks];
                if (!aiHook_1) {
                    // Only hook the function once
                    aiHook_1 = {
                        i: 0,
                        n: funcName,
                        f: fn,
                        h: []
                    };
                    // Override (hook) the original function
                    var newFunc = _createFunctionHook(aiHook_1);
                    newFunc[aiInstrumentHooks] = aiHook_1; // Tag and store the function hooks
                    owner[funcName] = newFunc;
                }
                var theHook = {
                    // tslint:disable:object-literal-shorthand
                    id: aiHook_1.i,
                    cbks: callbacks,
                    rm: function () {
                        // DO NOT Use () => { shorthand for the function as the this gets replaced
                        // with the outer this and not the this for theHook instance.
                        var id = this.id;
                        _arrLoop(aiHook_1.h, function (hook, idx) {
                            if (hook.id === id) {
                                aiHook_1.h.splice(idx, 1);
                                return 1;
                            }
                        });
                    }
                    // tslint:enable:object-literal-shorthand
                };
                aiHook_1.i++;
                aiHook_1.h.push(theHook);
                return theHook;
            }
        }
    }
    return null;
}
/**
 * Intercept the named functions for the target class / object
 * @param target - The target object
 * @param funcNames - The function names to intercept and call
 * @param callbacks - The callbacks to configure and call whenever the function is called
 * @param checkPrototype - If the function doesn't exist on the target should it attempt to hook the prototype function
 */
function InstrumentFuncs(target, funcNames, callbacks, checkPrototype) {
    if (checkPrototype === void 0) { checkPrototype = true; }
    var hooks = null;
    _arrLoop(funcNames, function (funcName) {
        var hook = InstrumentFunc(target, funcName, callbacks, checkPrototype);
        if (hook) {
            if (!hooks) {
                hooks = [];
            }
            hooks.push(hook);
        }
    });
    return hooks;
}
//# sourceMappingURL=InstrumentHooks.js.map

/***/ }),
/* 1385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApplicationInsights; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Telemetry_PageViewManager__ = __webpack_require__(1417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Telemetry_PageVisitTimeManager__ = __webpack_require__(1418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Telemetry_PageViewPerformanceManager__ = __webpack_require__(1419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__microsoft_dynamicproto_js__ = __webpack_require__(117);
/*
 * Application Insights JavaScript SDK - Web Analytics, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
 * ApplicationInsights.ts
 * @copyright Microsoft 2018
 */







"use strict";
var durationProperty = "duration";
var strEvent = "event";
function _dispatchEvent(target, evnt) {
    if (target && target.dispatchEvent && evnt) {
        target.dispatchEvent(evnt);
    }
}
var ApplicationInsights = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(ApplicationInsights, _super);
    function ApplicationInsights() {
        var _this = _super.call(this) || this;
        _this.identifier = __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["a" /* AnalyticsPluginIdentifier */]; // do not change name or priority
        _this.priority = 180; // take from reserved priority range 100- 200
        _this.autoRoutePVDelay = 500; // ms; Time to wait after a route change before triggering a pageview to allow DOM changes to take place
        var _eventTracking;
        var _pageTracking;
        var _properties;
        // Counts number of trackAjax invocations.
        // By default we only monitor X ajax call per view to avoid too much load.
        // Default value is set in config.
        // This counter keeps increasing even after the limit is reached.
        var _trackAjaxAttempts = 0;
        // array with max length of 2 that store current url and previous url for SPA page route change trackPageview use.
        var _prevUri; // Assigned in the constructor
        var _currUri;
        Object(__WEBPACK_IMPORTED_MODULE_6__microsoft_dynamicproto_js__["a" /* default */])(ApplicationInsights, _this, function (_self, _base) {
            var location = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["x" /* getLocation */])(true);
            _prevUri = location && location.href || "";
            _self.getCookieMgr = function () {
                return Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["N" /* safeGetCookieMgr */])(_self.core);
            };
            _self.processTelemetry = function (env, itemCtx) {
                Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["m" /* doPerf */])(_self.core, function () { return _self.identifier + ":processTelemetry"; }, function () {
                    var doNotSendItem = false;
                    var telemetryInitializersCount = _self._telemetryInitializers.length;
                    itemCtx = _self._getTelCtx(itemCtx);
                    for (var i = 0; i < telemetryInitializersCount; ++i) {
                        var telemetryInitializer = _self._telemetryInitializers[i];
                        if (telemetryInitializer) {
                            try {
                                if (telemetryInitializer.apply(null, [env]) === false) {
                                    doNotSendItem = true;
                                    break;
                                }
                            }
                            catch (e) {
                                // log error but dont stop executing rest of the telemetry initializers
                                // doNotSendItem = true;
                                itemCtx.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].TelemetryInitializerFailed, "One of telemetry initializers failed, telemetry item will not be sent: " + Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["r" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["n" /* dumpObj */])(e) }, true);
                            }
                        }
                    }
                    if (!doNotSendItem) {
                        _self.processNext(env, itemCtx);
                    }
                }, function () { return ({ item: env }); }, !(env.sync));
            };
            _self.trackEvent = function (event, customProperties) {
                try {
                    var telemetryItem = __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["j" /* TelemetryItemCreator */].create(event, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["b" /* Event */].dataType, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["b" /* Event */].envelopeType, _self.diagLog(), customProperties);
                    _self.core.track(telemetryItem);
                }
                catch (e) {
                    _self.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].TrackTraceFailed, "trackTrace failed, trace will not be collected: " + Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["r" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["n" /* dumpObj */])(e) });
                }
            };
            /**
             * Start timing an extended event. Call `stopTrackEvent` to log the event when it ends.
             * @param   name    A string that identifies this event uniquely within the document.
             */
            _self.startTrackEvent = function (name) {
                try {
                    _eventTracking.start(name);
                }
                catch (e) {
                    _self.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].StartTrackEventFailed, "startTrackEvent failed, event will not be collected: " + Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["r" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["n" /* dumpObj */])(e) });
                }
            };
            /**
             * Log an extended event that you started timing with `startTrackEvent`.
             * @param   name    The string you used to identify this event in `startTrackEvent`.
             * @param   properties  map[string, string] - additional data used to filter events and metrics in the portal. Defaults to empty.
             * @param   measurements    map[string, number] - metrics associated with this event, displayed in Metrics Explorer on the portal. Defaults to empty.
             */
            _self.stopTrackEvent = function (name, properties, measurements) {
                try {
                    _eventTracking.stop(name, undefined, properties); // Todo: Fix to pass measurements once type is updated
                }
                catch (e) {
                    _self.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].StopTrackEventFailed, "stopTrackEvent failed, event will not be collected: " + Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["r" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["n" /* dumpObj */])(e) });
                }
            };
            /**
             * @description Log a diagnostic message
             * @param {ITraceTelemetry} trace
             * @param ICustomProperties.
             * @memberof ApplicationInsights
             */
            _self.trackTrace = function (trace, customProperties) {
                try {
                    var telemetryItem = __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["j" /* TelemetryItemCreator */].create(trace, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["k" /* Trace */].dataType, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["k" /* Trace */].envelopeType, _self.diagLog(), customProperties);
                    _self.core.track(telemetryItem);
                }
                catch (e) {
                    _self.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].TrackTraceFailed, "trackTrace failed, trace will not be collected: " + Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["r" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["n" /* dumpObj */])(e) });
                }
            };
            /**
             * @description Log a numeric value that is not associated with a specific event. Typically
             * used to send regular reports of performance indicators. To send single measurement, just
             * use the name and average fields of {@link IMetricTelemetry}. If you take measurements
             * frequently, you can reduce the telemetry bandwidth by aggregating multiple measurements
             * and sending the resulting average at intervals
             * @param {IMetricTelemetry} metric input object argument. Only name and average are mandatory.
             * @param {{[key: string]: any}} customProperties additional data used to filter metrics in the
             * portal. Defaults to empty.
             * @memberof ApplicationInsights
             */
            _self.trackMetric = function (metric, customProperties) {
                try {
                    var telemetryItem = __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["j" /* TelemetryItemCreator */].create(metric, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["d" /* Metric */].dataType, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["d" /* Metric */].envelopeType, _self.diagLog(), customProperties);
                    _self.core.track(telemetryItem);
                }
                catch (e) {
                    _self.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].TrackMetricFailed, "trackMetric failed, metric will not be collected: " + Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["r" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["n" /* dumpObj */])(e) });
                }
            };
            /**
             * Logs that a page or other item was viewed.
             * @param IPageViewTelemetry The string you used as the name in startTrackPage. Defaults to the document title.
             * @param customProperties Additional data used to filter events and metrics. Defaults to empty.
             * If a user wants to provide duration for pageLoad, it'll have to be in pageView.properties.duration
             */
            _self.trackPageView = function (pageView, customProperties) {
                try {
                    var inPv = pageView || {};
                    _self._pageViewManager.trackPageView(inPv, Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["f" /* __assignFn */])({}, inPv.properties, inPv.measurements, customProperties));
                    if (_self.config.autoTrackPageVisitTime) {
                        _self._pageVisitTimeManager.trackPreviousPageVisit(inPv.name, inPv.uri);
                    }
                }
                catch (e) {
                    _self.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].TrackPVFailed, "trackPageView failed, page view will not be collected: " + Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["r" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["n" /* dumpObj */])(e) });
                }
            };
            /**
             * Create a page view telemetry item and send it to the SDK pipeline through the core.track API
             * @param pageView Page view item to be sent
             * @param properties Custom properties (Part C) that a user can add to the telemetry item
             * @param systemProperties System level properties (Part A) that a user can add to the telemetry item
             */
            _self.sendPageViewInternal = function (pageView, properties, systemProperties) {
                var doc = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["q" /* getDocument */])();
                if (doc) {
                    pageView.refUri = pageView.refUri === undefined ? doc.referrer : pageView.refUri;
                }
                var telemetryItem = __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["j" /* TelemetryItemCreator */].create(pageView, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["e" /* PageView */].dataType, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["e" /* PageView */].envelopeType, _self.diagLog(), properties, systemProperties);
                _self.core.track(telemetryItem);
                // reset ajaxes counter
                _trackAjaxAttempts = 0;
            };
            /**
             * @ignore INTERNAL ONLY
             * @param pageViewPerformance
             * @param properties
             */
            _self.sendPageViewPerformanceInternal = function (pageViewPerformance, properties, systemProperties) {
                var telemetryItem = __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["j" /* TelemetryItemCreator */].create(pageViewPerformance, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["f" /* PageViewPerformance */].dataType, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["f" /* PageViewPerformance */].envelopeType, _self.diagLog(), properties, systemProperties);
                _self.core.track(telemetryItem);
            };
            /**
             * Send browser performance metrics.
             * @param pageViewPerformance
             * @param customProperties
             */
            _self.trackPageViewPerformance = function (pageViewPerformance, customProperties) {
                try {
                    _self._pageViewPerformanceManager.populatePageViewPerformanceEvent(pageViewPerformance);
                    _self.sendPageViewPerformanceInternal(pageViewPerformance, customProperties);
                }
                catch (e) {
                    _self.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].TrackPVFailed, "trackPageViewPerformance failed, page view will not be collected: " + Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["r" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["n" /* dumpObj */])(e) });
                }
            };
            /**
             * Starts the timer for tracking a page load time. Use this instead of `trackPageView` if you want to control when the page view timer starts and stops,
             * but don't want to calculate the duration yourself. This method doesn't send any telemetry. Call `stopTrackPage` to log the end of the page view
             * and send the event.
             * @param name A string that idenfities this item, unique within this HTML document. Defaults to the document title.
             */
            _self.startTrackPage = function (name) {
                try {
                    if (typeof name !== "string") {
                        var doc = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["q" /* getDocument */])();
                        name = doc && doc.title || "";
                    }
                    _pageTracking.start(name);
                }
                catch (e) {
                    _self.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].StartTrackFailed, "startTrackPage failed, page view may not be collected: " + Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["r" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["n" /* dumpObj */])(e) });
                }
            };
            /**
             * Stops the timer that was started by calling `startTrackPage` and sends the pageview load time telemetry with the specified properties and measurements.
             * The duration of the page view will be the time between calling `startTrackPage` and `stopTrackPage`.
             * @param   name  The string you used as the name in startTrackPage. Defaults to the document title.
             * @param   url   String - a relative or absolute URL that identifies the page or other item. Defaults to the window location.
             * @param   properties  map[string, string] - additional data used to filter pages and metrics in the portal. Defaults to empty.
             * @param   measurements    map[string, number] - metrics associated with this page, displayed in Metrics Explorer on the portal. Defaults to empty.
             */
            _self.stopTrackPage = function (name, url, properties, measurement) {
                try {
                    if (typeof name !== "string") {
                        var doc = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["q" /* getDocument */])();
                        name = doc && doc.title || "";
                    }
                    if (typeof url !== "string") {
                        var loc = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["x" /* getLocation */])();
                        url = loc && loc.href || "";
                    }
                    _pageTracking.stop(name, url, properties, measurement);
                    if (_self.config.autoTrackPageVisitTime) {
                        _self._pageVisitTimeManager.trackPreviousPageVisit(name, url);
                    }
                }
                catch (e) {
                    _self.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].StopTrackFailed, "stopTrackPage failed, page view will not be collected: " + Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["r" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["n" /* dumpObj */])(e) });
                }
            };
            /**
             * @ignore INTERNAL ONLY
             * @param exception
             * @param properties
             * @param systemProperties
             */
            _self.sendExceptionInternal = function (exception, customProperties, systemProperties) {
                var theError = exception.exception || exception.error || new Error(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["p" /* strNotSpecified */]);
                var exceptionPartB = new __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["c" /* Exception */](_self.diagLog(), theError, exception.properties || customProperties, exception.measurements, exception.severityLevel, exception.id).toInterface();
                var telemetryItem = __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["j" /* TelemetryItemCreator */].create(exceptionPartB, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["c" /* Exception */].dataType, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["c" /* Exception */].envelopeType, _self.diagLog(), customProperties, systemProperties);
                _self.core.track(telemetryItem);
            };
            /**
             * Log an exception you have caught.
             *
             * @param {IExceptionTelemetry} exception   Object which contains exception to be sent
             * @param {{[key: string]: any}} customProperties   Additional data used to filter pages and metrics in the portal. Defaults to empty.
             *
             * Any property of type double will be considered a measurement, and will be treated by Application Insights as a metric.
             * @memberof ApplicationInsights
             */
            _self.trackException = function (exception, customProperties) {
                try {
                    _self.sendExceptionInternal(exception, customProperties);
                }
                catch (e) {
                    _self.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].TrackExceptionFailed, "trackException failed, exception will not be collected: " + Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["r" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["n" /* dumpObj */])(e) });
                }
            };
            /**
             * @description Custom error handler for Application Insights Analytics
             * @param {IAutoExceptionTelemetry} exception
             * @memberof ApplicationInsights
             */
            _self._onerror = function (exception) {
                var error = exception && exception.error;
                var evt = exception && exception.evt;
                try {
                    if (!evt) {
                        var _window = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["A" /* getWindow */])();
                        if (_window) {
                            evt = _window[strEvent];
                        }
                    }
                    var url = (exception && exception.url) || (Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["q" /* getDocument */])() || {}).URL;
                    // If no error source is provided assume the default window.onerror handler
                    var errorSrc = exception.errorSrc || "window.onerror@" + url + ":" + (exception.lineNumber || 0) + ":" + (exception.columnNumber || 0);
                    var properties = {
                        errorSrc: errorSrc,
                        url: url,
                        lineNumber: exception.lineNumber || 0,
                        columnNumber: exception.columnNumber || 0,
                        message: exception.message
                    };
                    if (Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["n" /* isCrossOriginError */])(exception.message, exception.url, exception.lineNumber, exception.columnNumber, exception.error)) {
                        _sendCORSException(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["c" /* Exception */].CreateAutoException("Script error: The browser's same-origin policy prevents us from getting the details of this exception. Consider using the 'crossorigin' attribute.", url, exception.lineNumber || 0, exception.columnNumber || 0, error, evt, null, errorSrc), properties);
                    }
                    else {
                        if (!exception.errorSrc) {
                            exception.errorSrc = errorSrc;
                        }
                        _self.trackException({ exception: exception, severityLevel: __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["i" /* SeverityLevel */].Error }, properties);
                    }
                }
                catch (e) {
                    var errorString = error ? (error.name + ", " + error.message) : "null";
                    _self.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].ExceptionWhileLoggingError, "_onError threw exception while logging error, error will not be collected: "
                        + Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["r" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["n" /* dumpObj */])(e), errorString: errorString });
                }
            };
            _self.addTelemetryInitializer = function (telemetryInitializer) {
                _self._telemetryInitializers.push(telemetryInitializer);
            };
            _self.initialize = function (config, core, extensions, pluginChain) {
                if (_self.isInitialized()) {
                    return;
                }
                if (Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(core)) {
                    throw Error("Error initializing");
                }
                _base.initialize(config, core, extensions, pluginChain);
                _self.setInitialized(false); // resetting the initialized state, just in case the following fails
                var ctx = _self._getTelCtx();
                var identifier = _self.identifier;
                _self.config = ctx.getExtCfg(identifier);
                // load default values if specified
                var defaults = ApplicationInsights.getDefaultConfig(config);
                if (defaults !== undefined) {
                    Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["K" /* objForEachKey */])(defaults, function (field, value) {
                        // for each unspecified field, set the default value
                        _self.config[field] = ctx.getConfig(identifier, field, value);
                        if (_self.config[field] === undefined) {
                            _self.config[field] = value;
                        }
                    });
                }
                // Todo: move this out of static state
                if (_self.config.isStorageUseDisabled) {
                    Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["s" /* utlDisableStorage */])();
                }
                var configGetters = {
                    instrumentationKey: function () { return config.instrumentationKey; },
                    accountId: function () { return _self.config.accountId || config.accountId; },
                    sessionRenewalMs: function () { return _self.config.sessionRenewalMs || config.sessionRenewalMs; },
                    sessionExpirationMs: function () { return _self.config.sessionExpirationMs || config.sessionExpirationMs; },
                    sampleRate: function () { return _self.config.samplingPercentage || config.samplingPercentage; },
                    sdkExtension: function () { return _self.config.sdkExtension || config.sdkExtension; },
                    isBrowserLinkTrackingEnabled: function () { return _self.config.isBrowserLinkTrackingEnabled || config.isBrowserLinkTrackingEnabled; },
                    appId: function () { return _self.config.appId || config.appId; }
                };
                _self._pageViewPerformanceManager = new __WEBPACK_IMPORTED_MODULE_5__Telemetry_PageViewPerformanceManager__["a" /* PageViewPerformanceManager */](_self.core);
                _self._pageViewManager = new __WEBPACK_IMPORTED_MODULE_3__Telemetry_PageViewManager__["a" /* PageViewManager */](_this, _self.config.overridePageViewDuration, _self.core, _self._pageViewPerformanceManager);
                _self._pageVisitTimeManager = new __WEBPACK_IMPORTED_MODULE_4__Telemetry_PageVisitTimeManager__["a" /* PageVisitTimeManager */](_self.diagLog(), function (pageName, pageUrl, pageVisitTime) { return trackPageVisitTime(pageName, pageUrl, pageVisitTime); });
                _self._telemetryInitializers = _self._telemetryInitializers || [];
                _addDefaultTelemetryInitializers(configGetters);
                _eventTracking = new Timing(_self.diagLog(), "trackEvent");
                _eventTracking.action =
                    function (name, url, duration, properties) {
                        if (!properties) {
                            properties = {};
                        }
                        properties[durationProperty] = duration.toString();
                        _self.trackEvent({ name: name, properties: properties });
                    };
                // initialize page view timing
                _pageTracking = new Timing(_self.diagLog(), "trackPageView");
                _pageTracking.action = function (name, url, duration, properties, measurements) {
                    // duration must be a custom property in order for the collector to extract it
                    if (Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(properties)) {
                        properties = {};
                    }
                    properties[durationProperty] = duration.toString();
                    var pageViewItem = {
                        name: name,
                        uri: url,
                        properties: properties,
                        measurements: measurements
                    };
                    _self.sendPageViewInternal(pageViewItem, properties);
                };
                var _window = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["A" /* getWindow */])();
                var _history = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["u" /* getHistory */])();
                var _location = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["x" /* getLocation */])(true);
                var instance = _this;
                if (_self.config.disableExceptionTracking === false &&
                    !_self.config.autoExceptionInstrumented && _window) {
                    // We want to enable exception auto collection and it has not been done so yet
                    var onerror_1 = "onerror";
                    var originalOnError_1 = _window[onerror_1];
                    _window.onerror = function (message, url, lineNumber, columnNumber, error) {
                        var evt = _window[strEvent];
                        var handled = originalOnError_1 && originalOnError_1(message, url, lineNumber, columnNumber, error);
                        if (handled !== true) {
                            instance._onerror(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["c" /* Exception */].CreateAutoException(message, url, lineNumber, columnNumber, error, evt));
                        }
                        return handled;
                    };
                    _self.config.autoExceptionInstrumented = true;
                }
                if (_self.config.disableExceptionTracking === false &&
                    _self.config.enableUnhandledPromiseRejectionTracking === true &&
                    !_self.config.autoUnhandledPromiseInstrumented && _window) {
                    // We want to enable exception auto collection and it has not been done so yet
                    var onunhandledrejection = "onunhandledrejection";
                    var originalOnUnhandledRejection_1 = _window[onunhandledrejection];
                    _window[onunhandledrejection] = function (error) {
                        var evt = _window[strEvent];
                        var handled = originalOnUnhandledRejection_1 && originalOnUnhandledRejection_1.call(_window, error);
                        if (handled !== true) {
                            instance._onerror(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["c" /* Exception */].CreateAutoException(error.reason.toString(), _location ? _location.href : "", 0, 0, error, evt));
                        }
                        return handled;
                    };
                    _self.config.autoUnhandledPromiseInstrumented = true;
                }
                /**
                 * Create a custom "locationchange" event which is triggered each time the history object is changed
                 */
                if (_self.config.enableAutoRouteTracking === true
                    && _history && Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["F" /* isFunction */])(_history.pushState) && Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["F" /* isFunction */])(_history.replaceState)
                    && _window
                    && typeof Event !== "undefined") {
                    var _self_1 = _this;
                    // Find the properties plugin
                    Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["d" /* arrForEach */])(extensions, function (extension) {
                        if (extension.identifier === __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["g" /* PropertiesPluginIdentifier */]) {
                            _properties = extension;
                        }
                    });
                    _history.pushState = (function (f) { return function pushState() {
                        var ret = f.apply(this, arguments);
                        _dispatchEvent(_window, Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["l" /* createDomEvent */])(_self_1.config.namePrefix + "pushState"));
                        _dispatchEvent(_window, Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["l" /* createDomEvent */])(_self_1.config.namePrefix + "locationchange"));
                        return ret;
                    }; })(_history.pushState);
                    _history.replaceState = (function (f) { return function replaceState() {
                        var ret = f.apply(this, arguments);
                        _dispatchEvent(_window, Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["l" /* createDomEvent */])(_self_1.config.namePrefix + "replaceState"));
                        _dispatchEvent(_window, Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["l" /* createDomEvent */])(_self_1.config.namePrefix + "locationchange"));
                        return ret;
                    }; })(_history.replaceState);
                    if (_window.addEventListener) {
                        _window.addEventListener(_self_1.config.namePrefix + "popstate", function () {
                            _dispatchEvent(_window, Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["l" /* createDomEvent */])(_self_1.config.namePrefix + "locationchange"));
                        });
                        _window.addEventListener(_self_1.config.namePrefix + "locationchange", function () {
                            if (_properties && _properties.context && _properties.context.telemetryTrace) {
                                _properties.context.telemetryTrace.traceID = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["o" /* generateW3CId */])();
                                var traceLocationName = "_unknown_";
                                if (_location && _location.pathname) {
                                    traceLocationName = _location.pathname + (_location.hash || "");
                                }
                                _properties.context.telemetryTrace.name = traceLocationName;
                            }
                            if (_currUri) {
                                _prevUri = _currUri;
                                _currUri = _location && _location.href || "";
                            }
                            else {
                                _currUri = _location && _location.href || "";
                            }
                            setTimeout((function (uri) {
                                // todo: override start time so that it is not affected by autoRoutePVDelay
                                _self_1.trackPageView({ refUri: uri, properties: { duration: 0 } }); // SPA route change loading durations are undefined, so send 0
                            }).bind(_this, _prevUri), _self_1.autoRoutePVDelay);
                        });
                    }
                }
                _self.setInitialized(true);
            };
            /**
             * Log a page visit time
             * @param    pageName    Name of page
             * @param    pageVisitDuration Duration of visit to the page in milleseconds
             */
            function trackPageVisitTime(pageName, pageUrl, pageVisitTime) {
                var properties = { PageName: pageName, PageUrl: pageUrl };
                _self.trackMetric({
                    name: "PageVisitTime",
                    average: pageVisitTime,
                    max: pageVisitTime,
                    min: pageVisitTime,
                    sampleCount: 1
                }, properties);
            }
            function _addDefaultTelemetryInitializers(configGetters) {
                if (!configGetters.isBrowserLinkTrackingEnabled()) {
                    var browserLinkPaths_1 = ['/browserLinkSignalR/', '/__browserLink/'];
                    var dropBrowserLinkRequests = function (envelope) {
                        if (envelope.baseType === __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["h" /* RemoteDependencyData */].dataType) {
                            var remoteData = envelope.baseData;
                            if (remoteData) {
                                for (var i = 0; i < browserLinkPaths_1.length; i++) {
                                    if (remoteData.target && remoteData.target.indexOf(browserLinkPaths_1[i]) >= 0) {
                                        return false;
                                    }
                                }
                            }
                        }
                        return true;
                    };
                    _addTelemetryInitializer(dropBrowserLinkRequests);
                }
            }
            function _addTelemetryInitializer(telemetryInitializer) {
                _self._telemetryInitializers.push(telemetryInitializer);
            }
            function _sendCORSException(exception, properties) {
                var telemetryItem = __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["j" /* TelemetryItemCreator */].create(exception, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["c" /* Exception */].dataType, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["c" /* Exception */].envelopeType, _self.diagLog(), properties);
                _self.core.track(telemetryItem);
            }
        });
        return _this;
    }
    ApplicationInsights.getDefaultConfig = function (config) {
        if (!config) {
            config = {};
        }
        // set default values
        config.sessionRenewalMs = 30 * 60 * 1000;
        config.sessionExpirationMs = 24 * 60 * 60 * 1000;
        config.disableExceptionTracking = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["q" /* stringToBoolOrDefault */])(config.disableExceptionTracking);
        config.autoTrackPageVisitTime = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["q" /* stringToBoolOrDefault */])(config.autoTrackPageVisitTime);
        config.overridePageViewDuration = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["q" /* stringToBoolOrDefault */])(config.overridePageViewDuration);
        config.enableUnhandledPromiseRejectionTracking = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["q" /* stringToBoolOrDefault */])(config.enableUnhandledPromiseRejectionTracking);
        if (isNaN(config.samplingPercentage) || config.samplingPercentage <= 0 || config.samplingPercentage >= 100) {
            config.samplingPercentage = 100;
        }
        config.isStorageUseDisabled = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["q" /* stringToBoolOrDefault */])(config.isStorageUseDisabled);
        config.isBrowserLinkTrackingEnabled = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["q" /* stringToBoolOrDefault */])(config.isBrowserLinkTrackingEnabled);
        config.enableAutoRouteTracking = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["q" /* stringToBoolOrDefault */])(config.enableAutoRouteTracking);
        config.namePrefix = config.namePrefix || "";
        config.enableDebug = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["q" /* stringToBoolOrDefault */])(config.enableDebug);
        config.disableFlushOnBeforeUnload = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["q" /* stringToBoolOrDefault */])(config.disableFlushOnBeforeUnload);
        config.disableFlushOnUnload = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["q" /* stringToBoolOrDefault */])(config.disableFlushOnUnload, config.disableFlushOnBeforeUnload);
        return config;
    };
// Removed Stub for ApplicationInsights.prototype.getCookieMgr.
// Removed Stub for ApplicationInsights.prototype.processTelemetry.
// Removed Stub for ApplicationInsights.prototype.trackEvent.
// Removed Stub for ApplicationInsights.prototype.startTrackEvent.
// Removed Stub for ApplicationInsights.prototype.stopTrackEvent.
// Removed Stub for ApplicationInsights.prototype.trackTrace.
// Removed Stub for ApplicationInsights.prototype.trackMetric.
// Removed Stub for ApplicationInsights.prototype.trackPageView.
// Removed Stub for ApplicationInsights.prototype.sendPageViewInternal.
// Removed Stub for ApplicationInsights.prototype.sendPageViewPerformanceInternal.
// Removed Stub for ApplicationInsights.prototype.trackPageViewPerformance.
// Removed Stub for ApplicationInsights.prototype.startTrackPage.
// Removed Stub for ApplicationInsights.prototype.stopTrackPage.
// Removed Stub for ApplicationInsights.prototype.sendExceptionInternal.
// Removed Stub for ApplicationInsights.prototype.trackException.
// Removed Stub for ApplicationInsights.prototype._onerror.
// Removed Stub for ApplicationInsights.prototype.addTelemetryInitializer.
// Removed Stub for ApplicationInsights.prototype.initialize.
    ApplicationInsights.Version = "2.6.3"; // Not currently used anywhere
    return ApplicationInsights;
}(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["a" /* BaseTelemetryPlugin */]));

/**
 * Used to record timed events and page views.
 */
var Timing = /** @class */ (function () {
    function Timing(logger, name) {
        var _self = this;
        var _events = {};
        _self.start = function (name) {
            if (typeof _events[name] !== "undefined") {
                logger.throwInternal(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].StartCalledMoreThanOnce, "start was called more than once for this event without calling stop.", { name: name, key: name }, true);
            }
            _events[name] = +new Date;
        };
        _self.stop = function (name, url, properties, measurements) {
            var start = _events[name];
            if (isNaN(start)) {
                logger.throwInternal(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].StopCalledWithoutStart, "stop was called without a corresponding start.", { name: name, key: name }, true);
            }
            else {
                var end = +new Date;
                var duration = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["m" /* dateTimeUtilsDuration */])(start, end);
                _self.action(name, url, duration, properties, measurements);
            }
            delete _events[name];
            _events[name] = undefined;
        };
    }
    return Timing;
}());
//# sourceMappingURL=ApplicationInsights.js.map

/***/ }),
/* 1386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MinChannelPriorty */
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var MinChannelPriorty = 100;
//# sourceMappingURL=IChannelControls.js.map

/***/ }),
/* 1387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AppInsightsCore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseCore__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JavaScriptSDK_Enums_EventsDiscardedReason__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NotificationManager__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PerfManager__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DiagnosticLogger__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__microsoft_dynamicproto_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__HelperFuncs__ = __webpack_require__(42);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */








"use strict";
var AppInsightsCore = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(AppInsightsCore, _super);
    function AppInsightsCore() {
        var _this = _super.call(this) || this;
        Object(__WEBPACK_IMPORTED_MODULE_6__microsoft_dynamicproto_js__["a" /* default */])(AppInsightsCore, _this, function (_self, _base) {
            _self.initialize = function (config, extensions, logger, notificationManager) {
                _base.initialize(config, extensions, logger || new __WEBPACK_IMPORTED_MODULE_5__DiagnosticLogger__["a" /* DiagnosticLogger */](config), notificationManager || new __WEBPACK_IMPORTED_MODULE_3__NotificationManager__["a" /* NotificationManager */](config));
            };
            _self.track = function (telemetryItem) {
                Object(__WEBPACK_IMPORTED_MODULE_4__PerfManager__["b" /* doPerf */])(_self.getPerfMgr(), function () { return "AppInsightsCore:track"; }, function () {
                    if (telemetryItem === null) {
                        _notifyInvalidEvent(telemetryItem);
                        // throw error
                        Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["G" /* throwError */])("Invalid telemetry item");
                    }
                    // do basic validation before sending it through the pipeline
                    _validateTelemetryItem(telemetryItem);
                    _base.track(telemetryItem);
                }, function () { return ({ item: telemetryItem }); }, !(telemetryItem.sync));
            };
            /**
             * Adds a notification listener. The SDK calls methods on the listener when an appropriate notification is raised.
             * The added plugins must raise notifications. If the plugins do not implement the notifications, then no methods will be
             * called.
             * @param {INotificationListener} listener - An INotificationListener object.
             */
            _self.addNotificationListener = function (listener) {
                var manager = _self.getNotifyMgr();
                if (manager) {
                    manager.addNotificationListener(listener);
                }
            };
            /**
             * Removes all instances of the listener.
             * @param {INotificationListener} listener - INotificationListener to remove.
             */
            _self.removeNotificationListener = function (listener) {
                var manager = _self.getNotifyMgr();
                if (manager) {
                    manager.removeNotificationListener(listener);
                }
            };
            /**
             * Periodically check logger.queue for
             */
            _self.pollInternalLogs = function (eventName) {
                var interval = _self.config.diagnosticLogInterval;
                if (!interval || !(interval > 0)) {
                    interval = 10000;
                }
                return setInterval(function () {
                    var queue = _self.logger ? _self.logger.queue : [];
                    Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["a" /* arrForEach */])(queue, function (logMessage) {
                        var item = {
                            name: eventName ? eventName : "InternalMessageId: " + logMessage.messageId,
                            iKey: _self.config.instrumentationKey,
                            time: Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["H" /* toISOString */])(new Date()),
                            baseType: __WEBPACK_IMPORTED_MODULE_5__DiagnosticLogger__["b" /* _InternalLogMessage */].dataType,
                            baseData: { message: logMessage.message }
                        };
                        _self.track(item);
                    });
                    queue.length = 0;
                }, interval);
            };
            function _validateTelemetryItem(telemetryItem) {
                if (Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["s" /* isNullOrUndefined */])(telemetryItem.name)) {
                    _notifyInvalidEvent(telemetryItem);
                    throw Error("telemetry name required");
                }
            }
            function _notifyInvalidEvent(telemetryItem) {
                var manager = _self.getNotifyMgr();
                if (manager) {
                    manager.eventsDiscarded([telemetryItem], __WEBPACK_IMPORTED_MODULE_2__JavaScriptSDK_Enums_EventsDiscardedReason__["a" /* EventsDiscardedReason */].InvalidEvent);
                }
            }
        });
        return _this;
    }
// Removed Stub for AppInsightsCore.prototype.initialize.
// Removed Stub for AppInsightsCore.prototype.track.
// Removed Stub for AppInsightsCore.prototype.addNotificationListener.
// Removed Stub for AppInsightsCore.prototype.removeNotificationListener.
// Removed Stub for AppInsightsCore.prototype.pollInternalLogs.
    return AppInsightsCore;
}(__WEBPACK_IMPORTED_MODULE_1__BaseCore__["a" /* BaseCore */]));

//# sourceMappingURL=AppInsightsCore.js.map

/***/ }),
/* 1388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChannelController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseTelemetryPlugin__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProcessTelemetryContext__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TelemetryHelpers__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HelperFuncs__ = __webpack_require__(42);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */









var ChannelControllerPriority = 500;
var ChannelValidationMessage = "Channel has invalid priority";
var ChannelController = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(ChannelController, _super);
    function ChannelController() {
        var _this = _super.call(this) || this;
        _this.identifier = "ChannelControllerPlugin";
        _this.priority = ChannelControllerPriority; // in reserved range 100 to 200
        var _channelQueue;
        Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__["a" /* default */])(ChannelController, _this, function (_self, _base) {
            _self.setNextPlugin = function (next) {
                // The Channel controller is last in pipeline
            };
            _self.processTelemetry = function (item, itemCtx) {
                if (_channelQueue) {
                    Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["a" /* arrForEach */])(_channelQueue, function (queues) {
                        // pass on to first item in queue
                        if (queues.length > 0) {
                            // Copying the item context as we could have mutiple chains that are executing asynchronously
                            // and calling _getDefTelCtx as it's possible that the caller doesn't pass any context
                            var chainCtx = _this._getTelCtx(itemCtx).createNew(queues);
                            chainCtx.processNext(item);
                        }
                    });
                }
            };
            _self.getChannelControls = function () {
                return _channelQueue;
            };
            _self.initialize = function (config, core, extensions) {
                if (_self.isInitialized()) {
                    // already initialized
                    return;
                }
                _base.initialize(config, core, extensions);
                _createChannelQueues((config || {}).channels, extensions);
                // Initialize the Queues
                Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["a" /* arrForEach */])(_channelQueue, function (queue) { return Object(__WEBPACK_IMPORTED_MODULE_4__TelemetryHelpers__["a" /* initializePlugins */])(new __WEBPACK_IMPORTED_MODULE_3__ProcessTelemetryContext__["a" /* ProcessTelemetryContext */](queue, config, core), extensions); });
            };
        });
        function _checkQueuePriority(queue) {
            Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["a" /* arrForEach */])(queue, function (queueItem) {
                if (queueItem.priority < ChannelControllerPriority) {
                    Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["G" /* throwError */])(ChannelValidationMessage + queueItem.identifier);
                }
            });
        }
        function _addChannelQueue(queue) {
            if (queue && queue.length > 0) {
                queue = queue.sort(function (a, b) {
                    return a.priority - b.priority;
                });
                _checkQueuePriority(queue);
                _channelQueue.push(queue);
            }
        }
        function _createChannelQueues(channels, extensions) {
            _channelQueue = [];
            if (channels) {
                // Add and sort the configuration channel queues
                Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["a" /* arrForEach */])(channels, function (queue) { return _addChannelQueue(queue); });
            }
            if (extensions) {
                // Create a new channel queue for any extensions with a priority > the ChannelControllerPriority
                var extensionQueue_1 = [];
                Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["a" /* arrForEach */])(extensions, function (plugin) {
                    if (plugin.priority > ChannelControllerPriority) {
                        extensionQueue_1.push(plugin);
                    }
                });
                _addChannelQueue(extensionQueue_1);
            }
        }
        return _this;
    }
// Removed Stub for ChannelController.prototype.processTelemetry.
    ;
// Removed Stub for ChannelController.prototype.getChannelControls.
// Removed Stub for ChannelController.prototype.initialize.
    /**
     * Static constructor, attempt to create accessors
     */
    // tslint:disable-next-line
    ChannelController._staticInit = (function () {
        var proto = ChannelController.prototype;
        // Dynamically create get/set property accessors
        Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["z" /* objDefineAccessors */])(proto, "ChannelControls", proto.getChannelControls);
        Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["z" /* objDefineAccessors */])(proto, "channelQueue", proto.getChannelControls);
    })();
    return ChannelController;
}(__WEBPACK_IMPORTED_MODULE_2__BaseTelemetryPlugin__["a" /* BaseTelemetryPlugin */]));

//# sourceMappingURL=ChannelController.js.map

/***/ }),
/* 1389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TelemetryPluginChain; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PerfManager__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JavaScriptSDK_Enums_LoggingEnums__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__ = __webpack_require__(42);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var TelemetryPluginChain = /** @class */ (function () {
    function TelemetryPluginChain(plugin, defItemCtx) {
        var _self = this;
        var _nextProxy = null;
        var _hasProcessTelemetry = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["p" /* isFunction */])(plugin.processTelemetry);
        var _hasSetNext = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["p" /* isFunction */])(plugin.setNextPlugin);
        _self._hasRun = false;
        _self.getPlugin = function () {
            return plugin;
        };
        _self.getNext = function () {
            return _nextProxy;
        };
        _self.setNext = function (nextPlugin) {
            _nextProxy = nextPlugin;
        };
        _self.processTelemetry = function (env, itemCtx) {
            if (!itemCtx) {
                // Looks like a plugin didn't pass the (optional) context, so restore to the default
                itemCtx = defItemCtx;
            }
            var identifier = plugin ? plugin.identifier : "TelemetryPluginChain";
            Object(__WEBPACK_IMPORTED_MODULE_0__PerfManager__["b" /* doPerf */])(itemCtx ? itemCtx.core() : null, function () { return identifier + ":processTelemetry"; }, function () {
                if (plugin && _hasProcessTelemetry) {
                    _self._hasRun = true;
                    try {
                        // Ensure that we keep the context in sync (for processNext()), just in case a plugin
                        // doesn't calls processTelemetry() instead of itemContext.processNext() or some 
                        // other form of error occurred
                        itemCtx.setNext(_nextProxy);
                        if (_hasSetNext) {
                            // Backward compatibility setting the next plugin on the instance
                            plugin.setNextPlugin(_nextProxy);
                        }
                        // Set a flag on the next plugin so we know if it was attempted to be executed
                        _nextProxy && (_nextProxy._hasRun = false);
                        plugin.processTelemetry(env, itemCtx);
                    }
                    catch (error) {
                        var hasRun = _nextProxy && _nextProxy._hasRun;
                        if (!_nextProxy || !hasRun) {
                            // Either we have no next plugin or the current one did not attempt to call the next plugin
                            // Which means the current one is the root of the failure so log/report this failure
                            itemCtx.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_1__JavaScriptSDK_Enums_LoggingEnums__["a" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_1__JavaScriptSDK_Enums_LoggingEnums__["b" /* _InternalMessageId */].PluginException, "Plugin [" + plugin.identifier + "] failed during processTelemetry - " + error);
                        }
                        if (_nextProxy && !hasRun) {
                            // As part of the failure the current plugin did not attempt to call the next plugin in the cahin
                            // So rather than leave the pipeline dead in the water we call the next plugin
                            _nextProxy.processTelemetry(env, itemCtx);
                        }
                    }
                }
                else if (_nextProxy) {
                    _self._hasRun = true;
                    // The underlying plugin is either not defined or does not have a processTelemetry implementation
                    // so we still want the next plugin to be executed.
                    _nextProxy.processTelemetry(env, itemCtx);
                }
            }, function () { return ({ item: env }); }, !(env.sync));
        };
    }
    return TelemetryPluginChain;
}());

//# sourceMappingURL=TelemetryPluginChain.js.map

/***/ }),
/* 1390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Undefined */
/* unused harmony export addEventHandler */
/* unused harmony export newGuid */
/* unused harmony export perfNow */
/* harmony export (immutable) */ __webpack_exports__["f"] = newId;
/* unused harmony export strEndsWith */
/* harmony export (immutable) */ __webpack_exports__["d"] = generateW3CId;
/* unused harmony export CoreUtils */
/* unused harmony export EventHelper */
/* unused harmony export _legacyCookieMgr */
/* harmony export (immutable) */ __webpack_exports__["c"] = disableCookies;
/* harmony export (immutable) */ __webpack_exports__["a"] = canUseCookies;
/* harmony export (immutable) */ __webpack_exports__["e"] = getCookie;
/* harmony export (immutable) */ __webpack_exports__["g"] = setCookie;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteCookie;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CookieMgr__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EnvUtils__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RandomHelper__ = __webpack_require__(551);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */








var _cookieMgrs = null;
var _canUseCookies; // legacy supported config
// Added to help with minfication
var Undefined = __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["m" /* strShimUndefined */];
/**
 * Trys to add an event handler for the specified event to the window, body and document
 * @param eventName {string} - The name of the event
 * @param callback {any} - The callback function that needs to be executed for the given event
 * @return {boolean} - true if the handler was successfully added
 */
function addEventHandler(eventName, callback) {
    var result = false;
    var w = Object(__WEBPACK_IMPORTED_MODULE_2__EnvUtils__["m" /* getWindow */])();
    if (w) {
        result = Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["e" /* attachEvent */])(w, eventName, callback);
        result = Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["e" /* attachEvent */])(w["body"], eventName, callback) || result;
    }
    var doc = Object(__WEBPACK_IMPORTED_MODULE_2__EnvUtils__["d" /* getDocument */])();
    if (doc) {
        result = EventHelper.Attach(doc, eventName, callback) || result;
    }
    return result;
}
function newGuid() {
    function randomHexDigit() {
        return Object(__WEBPACK_IMPORTED_MODULE_4__RandomHelper__["d" /* randomValue */])(15); // Get a random value from 0..15
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(GuidRegex, function (c) {
        var r = (randomHexDigit() | 0), v = (c === 'x' ? r : r & 0x3 | 0x8);
        return v.toString(16);
    });
}
/**
 * Return the current value of the Performance Api now() function (if available) and fallback to dateNow() if it is unavailable (IE9 or less)
 * https://caniuse.com/#search=performance.now
 */
function perfNow() {
    var perf = Object(__WEBPACK_IMPORTED_MODULE_2__EnvUtils__["l" /* getPerformance */])();
    if (perf && perf.now) {
        return perf.now();
    }
    return Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["g" /* dateNow */])();
}
/**
 * Generate random base64 id string.
 * The default length is 22 which is 132-bits so almost the same as a GUID but as base64 (the previous default was 5)
 * @param maxLength - Optional value to specify the length of the id to be generated, defaults to 22
 */
function newId(maxLength) {
    if (maxLength === void 0) { maxLength = 22; }
    var base64chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Start with an initial random number, consuming the value in reverse byte order
    var number = Object(__WEBPACK_IMPORTED_MODULE_4__RandomHelper__["c" /* random32 */])() >>> 0; // Make sure it's a +ve number
    var chars = 0;
    var result = "";
    while (result.length < maxLength) {
        chars++;
        result += base64chars.charAt(number & 0x3F);
        number >>>= 6; // Zero fill with right shift
        if (chars === 5) {
            // 5 base64 characters === 30 bits so we don't have enough bits for another base64 char
            // So add on another 30 bits and make sure it's +ve
            number = (((Object(__WEBPACK_IMPORTED_MODULE_4__RandomHelper__["c" /* random32 */])() << 2) & 0xFFFFFFFF) | (number & 0x03)) >>> 0;
            chars = 0; // We need to reset the number every 5 chars (30 bits)
        }
    }
    return result;
}
/**
 * The strEndsWith() method determines whether a string ends with the characters of a specified string, returning true or false as appropriate.
 * @param value - The value to check whether it ends with the search value.
 * @param search - The characters to be searched for at the end of the value.
 * @returns true if the given search value is found at the end of the string, otherwise false.
 */
function strEndsWith(value, search) {
    if (value && search) {
        var len = value.length;
        var start = len - search.length;
        return value.substring(start >= 0 ? start : 0, len) === search;
    }
    return false;
}
/**
 * generate W3C trace id
 */
function generateW3CId() {
    var hexValues = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
    // rfc4122 version 4 UUID without dashes and with lowercase letters
    var oct = "", tmp;
    for (var a = 0; a < 4; a++) {
        tmp = Object(__WEBPACK_IMPORTED_MODULE_4__RandomHelper__["c" /* random32 */])();
        oct +=
            hexValues[tmp & 0xF] +
                hexValues[tmp >> 4 & 0xF] +
                hexValues[tmp >> 8 & 0xF] +
                hexValues[tmp >> 12 & 0xF] +
                hexValues[tmp >> 16 & 0xF] +
                hexValues[tmp >> 20 & 0xF] +
                hexValues[tmp >> 24 & 0xF] +
                hexValues[tmp >> 28 & 0xF];
    }
    // "Set the two most significant bits (bits 6 and 7) of the clock_seq_hi_and_reserved to zero and one, respectively"
    var clockSequenceHi = hexValues[8 + (Object(__WEBPACK_IMPORTED_MODULE_4__RandomHelper__["c" /* random32 */])() & 0x03) | 0];
    return oct.substr(0, 8) + oct.substr(9, 4) + "4" + oct.substr(13, 3) + clockSequenceHi + oct.substr(16, 3) + oct.substr(19, 12);
}
/**
 * Provides a collection of utility functions, included for backward compatibility with previous releases.
 * @deprecated Marking this instance as deprecated in favor of direct usage of the helper functions
 * as direct usage provides better tree-shaking and minification by avoiding the inclusion of the unused items
 * in your resulting code.
 */
var CoreUtils = {
    _canUseCookies: undefined,
    isTypeof: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["x" /* isTypeof */],
    isUndefined: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["y" /* isUndefined */],
    isNullOrUndefined: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["s" /* isNullOrUndefined */],
    hasOwnProperty: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["k" /* hasOwnProperty */],
    isFunction: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["p" /* isFunction */],
    isObject: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["u" /* isObject */],
    isDate: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["n" /* isDate */],
    isArray: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["l" /* isArray */],
    isError: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["o" /* isError */],
    isString: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["v" /* isString */],
    isNumber: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["t" /* isNumber */],
    isBoolean: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["m" /* isBoolean */],
    toISOString: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["H" /* toISOString */],
    arrForEach: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["a" /* arrForEach */],
    arrIndexOf: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["b" /* arrIndexOf */],
    arrMap: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["c" /* arrMap */],
    arrReduce: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["d" /* arrReduce */],
    strTrim: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["F" /* strTrim */],
    objCreate: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["i" /* objCreateFn */],
    objKeys: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["B" /* objKeys */],
    objDefineAccessors: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["z" /* objDefineAccessors */],
    addEventHandler: addEventHandler,
    dateNow: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["g" /* dateNow */],
    isIE: __WEBPACK_IMPORTED_MODULE_2__EnvUtils__["o" /* isIE */],
    disableCookies: disableCookies,
    newGuid: newGuid,
    perfNow: perfNow,
    newId: newId,
    randomValue: __WEBPACK_IMPORTED_MODULE_4__RandomHelper__["d" /* randomValue */],
    random32: __WEBPACK_IMPORTED_MODULE_4__RandomHelper__["c" /* random32 */],
    mwcRandomSeed: __WEBPACK_IMPORTED_MODULE_4__RandomHelper__["b" /* mwcRandomSeed */],
    mwcRandom32: __WEBPACK_IMPORTED_MODULE_4__RandomHelper__["a" /* mwcRandom32 */],
    generateW3CId: generateW3CId
};
var GuidRegex = /[xy]/g;
var EventHelper = {
    Attach: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["e" /* attachEvent */],
    AttachEvent: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["e" /* attachEvent */],
    Detach: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["h" /* detachEvent */],
    DetachEvent: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["h" /* detachEvent */]
};
/**
 * Helper to support backward compatibility for users that use the legacy cookie handling functions and the use the internal
 * CoreUtils._canUseCookies global flag to enable/disable cookies usage.
 * Note: This has the following deliberate side-effects
 * - Creates the global (legacy) cookie manager if it does not already exist
 * - Attempts to add "listeners" to the CoreUtils._canUseCookies property to support the legacy usage
 * @param config
 * @param logger
 * @returns
 */
function _legacyCookieMgr(config, logger) {
    var cookieMgr = Object(__WEBPACK_IMPORTED_MODULE_1__CookieMgr__["a" /* _gblCookieMgr */])(config, logger);
    var legacyCanUseCookies = CoreUtils._canUseCookies;
    if (_cookieMgrs === null) {
        _cookieMgrs = [];
        _canUseCookies = legacyCanUseCookies;
        // Dynamically create get/set property accessors for backward compatibility for enabling / disabling cookies
        // this WILL NOT work for ES3 browsers (< IE8)
        Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["z" /* objDefineAccessors */])(CoreUtils, "_canUseCookies", function () {
            return _canUseCookies;
        }, function (value) {
            _canUseCookies = value;
            Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["a" /* arrForEach */])(_cookieMgrs, function (mgr) {
                mgr.setEnabled(value);
            });
        });
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["b" /* arrIndexOf */])(_cookieMgrs, cookieMgr) === -1) {
        _cookieMgrs.push(cookieMgr);
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["m" /* isBoolean */])(legacyCanUseCookies)) {
        cookieMgr.setEnabled(legacyCanUseCookies);
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["m" /* isBoolean */])(_canUseCookies)) {
        cookieMgr.setEnabled(_canUseCookies);
    }
    return cookieMgr;
}
/**
 * @deprecated - Use the core.getCookieMgr().disable()
 * Force the SDK not to store and read any data from cookies.
 */
function disableCookies() {
    _legacyCookieMgr().setEnabled(false);
}
/**
 * @deprecated - Use the core.getCookieMgr().isEnabled()
 * Helper method to tell if document.cookie object is available and whether it can be used.
 */
function canUseCookies(logger) {
    return _legacyCookieMgr(null, logger).isEnabled();
}
/**
 * @deprecated - Use the core.getCookieMgr().get()
 * helper method to access userId and sessionId cookie
 */
function getCookie(logger, name) {
    return _legacyCookieMgr(null, logger).get(name);
}
/**
 * @deprecated - Use the core.getCookieMgr().set()
 * helper method to set userId and sessionId cookie
 */
function setCookie(logger, name, value, domain) {
    _legacyCookieMgr(null, logger).set(name, value, null, domain);
}
/**
 * @deprecated - Use the core.getCookieMgr().del()
 * Deletes a cookie by setting it's expiration time in the past.
 * @param name - The name of the cookie to delete.
 */
function deleteCookie(logger, name) {
    return _legacyCookieMgr(null, logger).del(name);
}
//# sourceMappingURL=CoreUtils.js.map

/***/ }),
/* 1391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InstrumentProto */
/* unused harmony export InstrumentProtos */
/* unused harmony export InstrumentFunc */
/* unused harmony export InstrumentFuncs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HelperFuncs__ = __webpack_require__(42);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var aiInstrumentHooks = "_aiHooks";
;
var cbNames = [
    "req", "rsp", "hkErr", "fnErr"
];
/**
 * Constant string defined to support minimization
 * @ignore
 */
var str__Proto = "__proto__";
/**
 * Constant string defined to support minimization
 * @ignore
 */
var strConstructor = "constructor";
/** @ignore */
function _arrLoop(arr, fn) {
    if (arr) {
        for (var lp = 0; lp < arr.length; lp++) {
            if (fn(arr[lp], lp)) {
                break;
            }
        }
    }
}
/** @ignore */
function _doCallbacks(hooks, callDetails, cbArgs, hookCtx, type) {
    if (type >= 0 /* Request */ && type <= 2 /* HookError */) {
        _arrLoop(hooks, function (hook, idx) {
            var cbks = hook.cbks;
            var cb = cbks[cbNames[type]];
            if (cb) {
                // Set the specific hook context implementation using a lazy creation pattern
                callDetails.ctx = function () {
                    var ctx = hookCtx[idx] = (hookCtx[idx] || {});
                    return ctx;
                };
                try {
                    cb.apply(callDetails.inst, cbArgs);
                }
                catch (err) {
                    var orgEx = callDetails.err;
                    try {
                        // Report Hook error via the callback
                        var hookErrorCb = cbks[cbNames[2 /* HookError */]];
                        if (hookErrorCb) {
                            callDetails.err = err;
                            hookErrorCb.apply(callDetails.inst, cbArgs);
                        }
                    }
                    catch (e) {
                        // Not much we can do here -- swallowing the exception to avoid crashing the hosting app
                    }
                    finally {
                        // restore the original exception (if any)
                        callDetails.err = orgEx;
                    }
                }
            }
        });
    }
}
/** @ignore */
function _createFunctionHook(aiHook) {
    // Define a temporary method that queues-up a the real method call
    return function () {
        var funcThis = this;
        // Capture the original arguments passed to the method
        var orgArgs = arguments;
        var hooks = aiHook.h;
        var funcArgs = {
            name: aiHook.n,
            inst: funcThis,
            ctx: null,
            set: _replaceArg
        };
        var hookCtx = [];
        var cbArgs = _createArgs([funcArgs], orgArgs);
        function _createArgs(target, theArgs) {
            _arrLoop(theArgs, function (arg) {
                target.push(arg);
            });
            return target;
        }
        function _replaceArg(idx, value) {
            orgArgs = _createArgs([], orgArgs);
            orgArgs[idx] = value;
            cbArgs = _createArgs([funcArgs], orgArgs);
        }
        // Call the pre-request hooks
        _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 0 /* Request */);
        // Call the original function was called
        var theFunc = aiHook.f;
        try {
            funcArgs.rslt = theFunc.apply(funcThis, orgArgs);
        }
        catch (err) {
            // Report the request callback
            funcArgs.err = err;
            _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 3 /* FunctionError */);
            // rethrow the original exception so anyone listening for it can catch the exception
            throw err;
        }
        // Call the post-request hooks
        _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 1 /* Response */);
        return funcArgs.rslt;
    };
}
/**
 * Pre-lookup to check if we are running on a modern browser (i.e. not IE8)
 * @ignore
 */
var _objGetPrototypeOf = Object["getPrototypeOf"];
/**
 * Helper used to get the prototype of the target object as getPrototypeOf is not available in an ES3 environment.
 * @ignore
 */
function _getObjProto(target) {
    if (target) {
        // This method doesn't existing in older browsers (e.g. IE8)
        if (_objGetPrototypeOf) {
            return _objGetPrototypeOf(target);
        }
        // target[Constructor] May break if the constructor has been changed or removed
        var newProto = target[str__Proto] || target[__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["l" /* strShimPrototype */]] || target[strConstructor];
        if (newProto) {
            return newProto;
        }
    }
    return null;
}
/** @ignore */
function _getOwner(target, name, checkPrototype) {
    var owner = null;
    if (target) {
        if (Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["k" /* hasOwnProperty */])(target, name)) {
            owner = target;
        }
        else if (checkPrototype) {
            owner = _getOwner(_getObjProto(target), name, false);
        }
    }
    return owner;
}
/**
 * Intercept the named prototype functions for the target class / object
 * @param target - The target object
 * @param funcName - The function name
 * @param callbacks - The callbacks to configure and call whenever the function is called
 */
function InstrumentProto(target, funcName, callbacks) {
    if (target) {
        return InstrumentFunc(target[__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["l" /* strShimPrototype */]], funcName, callbacks, false);
    }
    return null;
}
/**
 * Intercept the named prototype functions for the target class / object
 * @param target - The target object
 * @param funcNames - The function names to intercept and call
 * @param callbacks - The callbacks to configure and call whenever the function is called
 */
function InstrumentProtos(target, funcNames, callbacks) {
    if (target) {
        return InstrumentFuncs(target[__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["l" /* strShimPrototype */]], funcNames, callbacks, false);
    }
    return null;
}
/**
 * Intercept the named prototype functions for the target class / object
 * @param target - The target object
 * @param funcName - The function name
 * @param callbacks - The callbacks to configure and call whenever the function is called
 * @param checkPrototype - If the function doesn't exist on the target should it attempt to hook the prototype function
 */
function InstrumentFunc(target, funcName, callbacks, checkPrototype) {
    if (checkPrototype === void 0) { checkPrototype = true; }
    if (target && funcName && callbacks) {
        var owner = _getOwner(target, funcName, checkPrototype);
        if (owner) {
            var fn = owner[funcName];
            if (typeof fn === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["j" /* strShimFunction */]) {
                var aiHook_1 = fn[aiInstrumentHooks];
                if (!aiHook_1) {
                    // Only hook the function once
                    aiHook_1 = {
                        i: 0,
                        n: funcName,
                        f: fn,
                        h: []
                    };
                    // Override (hook) the original function
                    var newFunc = _createFunctionHook(aiHook_1);
                    newFunc[aiInstrumentHooks] = aiHook_1; // Tag and store the function hooks
                    owner[funcName] = newFunc;
                }
                var theHook = {
                    // tslint:disable:object-literal-shorthand
                    id: aiHook_1.i,
                    cbks: callbacks,
                    rm: function () {
                        // DO NOT Use () => { shorthand for the function as the this gets replaced
                        // with the outer this and not the this for theHook instance.
                        var id = this.id;
                        _arrLoop(aiHook_1.h, function (hook, idx) {
                            if (hook.id === id) {
                                aiHook_1.h.splice(idx, 1);
                                return 1;
                            }
                        });
                    }
                    // tslint:enable:object-literal-shorthand
                };
                aiHook_1.i++;
                aiHook_1.h.push(theHook);
                return theHook;
            }
        }
    }
    return null;
}
/**
 * Intercept the named functions for the target class / object
 * @param target - The target object
 * @param funcNames - The function names to intercept and call
 * @param callbacks - The callbacks to configure and call whenever the function is called
 * @param checkPrototype - If the function doesn't exist on the target should it attempt to hook the prototype function
 */
function InstrumentFuncs(target, funcNames, callbacks, checkPrototype) {
    if (checkPrototype === void 0) { checkPrototype = true; }
    var hooks = null;
    _arrLoop(funcNames, function (funcName) {
        var hook = InstrumentFunc(target, funcName, callbacks, checkPrototype);
        if (hook) {
            if (!hooks) {
                hooks = [];
            }
            hooks.push(hook);
        }
    });
    return hooks;
}
//# sourceMappingURL=InstrumentHooks.js.map

/***/ }),
/* 1392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export parseConnectionString */
/* unused harmony export ConnectionStringParser */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__ = __webpack_require__(41);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var _FIELDS_SEPARATOR = ";";
var _FIELD_KEY_VALUE_SEPARATOR = "=";
function parseConnectionString(connectionString) {
    if (!connectionString) {
        return {};
    }
    var kvPairs = connectionString.split(_FIELDS_SEPARATOR);
    var result = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["f" /* arrReduce */])(kvPairs, function (fields, kv) {
        var kvParts = kv.split(_FIELD_KEY_VALUE_SEPARATOR);
        if (kvParts.length === 2) {
            var key = kvParts[0].toLowerCase();
            var value = kvParts[1];
            fields[key] = value;
        }
        return fields;
    }, {});
    if (Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["L" /* objKeys */])(result).length > 0) {
        // this is a valid connection string, so parse the results
        if (result.endpointsuffix) {
            // use endpoint suffix where overrides are not provided
            var locationPrefix = result.location ? result.location + "." : "";
            result.ingestionendpoint = result.ingestionendpoint || ("https://" + locationPrefix + "dc." + result.endpointsuffix);
        }
        // apply the default endpoints
        result.ingestionendpoint = result.ingestionendpoint || __WEBPACK_IMPORTED_MODULE_0__Constants__["a" /* DEFAULT_BREEZE_ENDPOINT */];
    }
    return result;
}
var ConnectionStringParser = {
    parse: parseConnectionString
};
//# sourceMappingURL=ConnectionStringParser.js.map

/***/ }),
/* 1393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Envelope */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_Envelope__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DataSanitizer__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Constants__ = __webpack_require__(77);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







var Envelope = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(Envelope, _super);
    /**
     * Constructs a new instance of telemetry data.
     */
    function Envelope(logger, data, name) {
        var _this = _super.call(this) || this;
        _this.name = Object(__WEBPACK_IMPORTED_MODULE_2__DataSanitizer__["f" /* dataSanitizeString */])(logger, name) || __WEBPACK_IMPORTED_MODULE_4__Constants__["b" /* strNotSpecified */];
        _this.data = data;
        _this.time = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["R" /* toISOString */])(new Date());
        _this.aiDataContract = {
            time: 1 /* Required */,
            iKey: 1 /* Required */,
            name: 1 /* Required */,
            sampleRate: function () {
                return (_this.sampleRate === 100) ? 4 /* Hidden */ : 1 /* Required */;
            },
            tags: 1 /* Required */,
            data: 1 /* Required */
        };
        return _this;
    }
    return Envelope;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_Envelope__["a" /* Envelope */]));

//# sourceMappingURL=Envelope.js.map

/***/ }),
/* 1394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Envelope; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * System variables for a telemetry item.
 */
var Envelope = /** @class */ (function () {
    function Envelope() {
        /**
         * Envelope version. For internal use only. By assigning this the default, it will not be serialized within the payload unless changed to a value other than #1.
         */
        this.ver = 1;
        /**
         * Sampling rate used in application. This telemetry item represents 1 / sampleRate actual telemetry items.
         */
        this.sampleRate = 100.0;
        /**
         * Key/value collection of context properties. See ContextTagKeys for information on available properties.
         */
        this.tags = {};
    }
    return Envelope;
}());

//# sourceMappingURL=Envelope.js.map

/***/ }),
/* 1395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Event; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_EventData__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Constants__ = __webpack_require__(77);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var Event = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(Event, _super);
    /**
     * Constructs a new instance of the EventTelemetry object
     */
    function Event(logger, name, properties, measurements) {
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            ver: 1 /* Required */,
            name: 1 /* Required */,
            properties: 0 /* Default */,
            measurements: 0 /* Default */
        };
        _this.name = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, name) || __WEBPACK_IMPORTED_MODULE_3__Constants__["b" /* strNotSpecified */];
        _this.properties = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["e" /* dataSanitizeProperties */])(logger, properties);
        _this.measurements = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["c" /* dataSanitizeMeasurements */])(logger, measurements);
        return _this;
    }
    Event.envelopeType = "Microsoft.ApplicationInsights.{0}.Event";
    Event.dataType = "EventData";
    return Event;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_EventData__["a" /* EventData */]));

//# sourceMappingURL=Event.js.map

/***/ }),
/* 1396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export _formatErrorCode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Exception; });
/* unused harmony export _ExceptionDetails */
/* unused harmony export _StackFrame */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_StackFrame__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Interfaces_Contracts_Generated_ExceptionData__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Interfaces_Contracts_Generated_ExceptionDetails__ = __webpack_require__(1399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Common_DataSanitizer__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Constants__ = __webpack_require__(77);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */









var NoMethod = "<no_method>";
var strError = "error";
var strStack = "stack";
var strStackDetails = "stackDetails";
var strErrorSrc = "errorSrc";
var strMessage = "message";
var strDescription = "description";
function _stringify(value, convertToString) {
    var result = value;
    if (result && !Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["I" /* isString */])(result)) {
        if (JSON && JSON.stringify) {
            result = JSON.stringify(value);
            if (convertToString && (!result || result === "{}")) {
                if (Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["F" /* isFunction */])(value.toString)) {
                    result = value.toString();
                }
                else {
                    result = "" + value;
                }
            }
        }
        else {
            result = "" + value + " - (Missing JSON.stringify)";
        }
    }
    return result || "";
}
function _formatMessage(theEvent, errorType) {
    var evtMessage = theEvent;
    if (theEvent) {
        evtMessage = theEvent[strMessage] || theEvent[strDescription] || "";
        // Make sure the message is a string
        if (evtMessage && !Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["I" /* isString */])(evtMessage)) {
            // tslint:disable-next-line: prefer-conditional-expression
            evtMessage = _stringify(evtMessage, true);
        }
        if (theEvent["filename"]) {
            // Looks like an event object with filename
            evtMessage = evtMessage + " @" + (theEvent["filename"] || "") + ":" + (theEvent["lineno"] || "?") + ":" + (theEvent["colno"] || "?");
        }
    }
    // Automatically add the error type to the message if it does already appear to be present
    if (errorType && errorType !== "String" && errorType !== "Object" && errorType !== "Error" && (evtMessage || "").indexOf(errorType) === -1) {
        evtMessage = errorType + ": " + evtMessage;
    }
    return evtMessage || "";
}
function _isExceptionDetailsInternal(value) {
    if (Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["H" /* isObject */])(value)) {
        return "hasFullStack" in value && "typeName" in value;
    }
    return false;
}
function _isExceptionInternal(value) {
    if (Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["H" /* isObject */])(value)) {
        return ("ver" in value && "exceptions" in value && "properties" in value);
    }
    return false;
}
function _isStackDetails(details) {
    return details && details.src && Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["I" /* isString */])(details.src) && details.obj && Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["C" /* isArray */])(details.obj);
}
function _convertStackObj(errorStack) {
    var src = errorStack || "";
    if (!Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["I" /* isString */])(src)) {
        if (Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["I" /* isString */])(src[strStack])) {
            src = src[strStack];
        }
        else {
            src = "" + src;
        }
    }
    var items = src.split("\n");
    return {
        src: src,
        obj: items
    };
}
function _getOperaStack(errorMessage) {
    var stack = [];
    var lines = errorMessage.split("\n");
    for (var lp = 0; lp < lines.length; lp++) {
        var entry = lines[lp];
        if (lines[lp + 1]) {
            entry += "@" + lines[lp + 1];
            lp++;
        }
        stack.push(entry);
    }
    return {
        src: errorMessage,
        obj: stack
    };
}
function _getStackFromErrorObj(errorObj) {
    var details = null;
    if (errorObj) {
        try {
            /* Using bracket notation is support older browsers (IE 7/8 -- dont remember the version) that throw when using dot
            notation for undefined objects and we don't want to loose the error from being reported */
            if (errorObj[strStack]) {
                // Chrome/Firefox
                details = _convertStackObj(errorObj[strStack]);
            }
            else if (errorObj[strError] && errorObj[strError][strStack]) {
                // Edge error event provides the stack and error object
                details = _convertStackObj(errorObj[strError][strStack]);
            }
            else if (errorObj['exception'] && errorObj.exception[strStack]) {
                details = _convertStackObj(errorObj.exception[strStack]);
            }
            else if (_isStackDetails(errorObj)) {
                details = errorObj;
            }
            else if (_isStackDetails(errorObj[strStackDetails])) {
                details = errorObj[strStackDetails];
            }
            else if (window['opera'] && errorObj[strMessage]) {
                // Opera
                details = _getOperaStack(errorObj.message);
            }
            else if (Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["I" /* isString */])(errorObj)) {
                details = _convertStackObj(errorObj);
            }
            else {
                var evtMessage = errorObj[strMessage] || errorObj[strDescription] || "";
                if (Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["I" /* isString */])(errorObj[strErrorSrc])) {
                    if (evtMessage) {
                        evtMessage += "\n";
                    }
                    evtMessage += " from " + errorObj[strErrorSrc];
                }
                if (evtMessage) {
                    details = _convertStackObj(evtMessage);
                }
            }
        }
        catch (e) {
            // something unexpected happened so to avoid failing to report any error lets swallow the exception 
            // and fallback to the callee/caller method
            details = _convertStackObj(e);
        }
    }
    return details || {
        src: "",
        obj: null
    };
}
function _formatStackTrace(stackDetails) {
    var stack = "";
    if (stackDetails) {
        if (stackDetails.obj) {
            Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["d" /* arrForEach */])(stackDetails.obj, function (entry) {
                stack += entry + "\n";
            });
        }
        else {
            stack = stackDetails.src || "";
        }
    }
    return stack;
}
function _parseStack(stack) {
    var parsedStack;
    var frames = stack.obj;
    if (frames && frames.length > 0) {
        parsedStack = [];
        var level_1 = 0;
        var totalSizeInBytes_1 = 0;
        Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["d" /* arrForEach */])(frames, function (frame) {
            var theFrame = frame.toString();
            if (_StackFrame.regex.test(theFrame)) {
                var parsedFrame = new _StackFrame(theFrame, level_1++);
                totalSizeInBytes_1 += parsedFrame.sizeInBytes;
                parsedStack.push(parsedFrame);
            }
        });
        // DP Constraint - exception parsed stack must be < 32KB
        // remove frames from the middle to meet the threshold
        var exceptionParsedStackThreshold = 32 * 1024;
        if (totalSizeInBytes_1 > exceptionParsedStackThreshold) {
            var left = 0;
            var right = parsedStack.length - 1;
            var size = 0;
            var acceptedLeft = left;
            var acceptedRight = right;
            while (left < right) {
                // check size
                var lSize = parsedStack[left].sizeInBytes;
                var rSize = parsedStack[right].sizeInBytes;
                size += lSize + rSize;
                if (size > exceptionParsedStackThreshold) {
                    // remove extra frames from the middle
                    var howMany = acceptedRight - acceptedLeft + 1;
                    parsedStack.splice(acceptedLeft, howMany);
                    break;
                }
                // update pointers
                acceptedLeft = left;
                acceptedRight = right;
                left++;
                right--;
            }
        }
    }
    return parsedStack;
}
function _getErrorType(errorType) {
    // Gets the Error Type by passing the constructor (used to get the true type of native error object).
    var typeName = "";
    if (errorType) {
        typeName = errorType.typeName || errorType.name || "";
        if (!typeName) {
            try {
                var funcNameRegex = /function (.{1,})\(/;
                var results = (funcNameRegex).exec((errorType).constructor.toString());
                typeName = (results && results.length > 1) ? results[1] : "";
            }
            catch (e) {
                // Ignore
            }
        }
    }
    return typeName;
}
/**
 * Formats the provided errorObj for display and reporting, it may be a String, Object, integer or undefined depending on the browser.
 * @param errorObj The supplied errorObj
 */
function _formatErrorCode(errorObj) {
    if (errorObj) {
        try {
            if (!Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["I" /* isString */])(errorObj)) {
                var errorType = _getErrorType(errorObj);
                var result = _stringify(errorObj, false);
                if (!result || result === "{}") {
                    if (errorObj[strError]) {
                        // Looks like an MS Error Event
                        errorObj = errorObj[strError];
                        errorType = _getErrorType(errorObj);
                    }
                    result = _stringify(errorObj, true);
                }
                if (result.indexOf(errorType) !== 0 && errorType !== "String") {
                    return errorType + ":" + result;
                }
                return result;
            }
        }
        catch (e) {
        }
    }
    // Fallback to just letting the object format itself into a string
    return "" + (errorObj || "");
}
var Exception = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(Exception, _super);
    /**
     * Constructs a new instance of the ExceptionTelemetry object
     */
    function Exception(logger, exception, properties, measurements, severityLevel, id) {
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            ver: 1 /* Required */,
            exceptions: 1 /* Required */,
            severityLevel: 0 /* Default */,
            properties: 0 /* Default */,
            measurements: 0 /* Default */
        };
        if (!_isExceptionInternal(exception)) {
            if (!properties) {
                properties = {};
            }
            _this.exceptions = [new _ExceptionDetails(logger, exception, properties)];
            _this.properties = Object(__WEBPACK_IMPORTED_MODULE_4__Common_DataSanitizer__["e" /* dataSanitizeProperties */])(logger, properties);
            _this.measurements = Object(__WEBPACK_IMPORTED_MODULE_4__Common_DataSanitizer__["c" /* dataSanitizeMeasurements */])(logger, measurements);
            if (severityLevel) {
                _this.severityLevel = severityLevel;
            }
            if (id) {
                _this.id = id;
            }
        }
        else {
            _this.exceptions = exception.exceptions;
            _this.properties = exception.properties;
            _this.measurements = exception.measurements;
            if (exception.severityLevel) {
                _this.severityLevel = exception.severityLevel;
            }
            if (exception.id) {
                _this.id = exception.id;
            }
            if (exception.problemGroup) {
                _this.problemGroup = exception.problemGroup;
            }
            // bool/int types, use isNullOrUndefined
            _this.ver = 2; // TODO: handle the CS"4.0" ==> breeze 2 conversion in a better way
            if (!Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(exception.isManual)) {
                _this.isManual = exception.isManual;
            }
        }
        return _this;
    }
    Exception.CreateAutoException = function (message, url, lineNumber, columnNumber, error, evt, stack, errorSrc) {
        var errorType = _getErrorType(error || evt || message);
        return {
            message: _formatMessage(message, errorType),
            url: url,
            lineNumber: lineNumber,
            columnNumber: columnNumber,
            error: _formatErrorCode(error || evt || message),
            evt: _formatErrorCode(evt || message),
            typeName: errorType,
            stackDetails: _getStackFromErrorObj(stack || error || evt),
            errorSrc: errorSrc
        };
    };
    Exception.CreateFromInterface = function (logger, exception, properties, measurements) {
        var exceptions = exception.exceptions
            && Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["e" /* arrMap */])(exception.exceptions, function (ex) { return _ExceptionDetails.CreateFromInterface(logger, ex); });
        var exceptionData = new Exception(logger, Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["f" /* __assignFn */])({}, exception, { exceptions: exceptions }), properties, measurements);
        return exceptionData;
    };
    Exception.prototype.toInterface = function () {
        var _a = this, exceptions = _a.exceptions, properties = _a.properties, measurements = _a.measurements, severityLevel = _a.severityLevel, ver = _a.ver, problemGroup = _a.problemGroup, id = _a.id, isManual = _a.isManual;
        var exceptionDetailsInterface = exceptions instanceof Array
            && Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["e" /* arrMap */])(exceptions, function (exception) { return exception.toInterface(); })
            || undefined;
        return {
            ver: "4.0",
            exceptions: exceptionDetailsInterface,
            severityLevel: severityLevel,
            properties: properties,
            measurements: measurements,
            problemGroup: problemGroup,
            id: id,
            isManual: isManual
        };
    };
    /**
     * Creates a simple exception with 1 stack frame. Useful for manual constracting of exception.
     */
    Exception.CreateSimpleException = function (message, typeName, assembly, fileName, details, line) {
        return {
            exceptions: [
                {
                    hasFullStack: true,
                    message: message,
                    stack: details,
                    typeName: typeName
                }
            ]
        };
    };
    Exception.envelopeType = "Microsoft.ApplicationInsights.{0}.Exception";
    Exception.dataType = "ExceptionData";
    Exception.formatError = _formatErrorCode;
    return Exception;
}(__WEBPACK_IMPORTED_MODULE_2__Interfaces_Contracts_Generated_ExceptionData__["a" /* ExceptionData */]));

var _ExceptionDetails = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(_ExceptionDetails, _super);
    function _ExceptionDetails(logger, exception, properties) {
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            id: 0 /* Default */,
            outerId: 0 /* Default */,
            typeName: 1 /* Required */,
            message: 1 /* Required */,
            hasFullStack: 0 /* Default */,
            stack: 0 /* Default */,
            parsedStack: 2 /* Array */
        };
        if (!_isExceptionDetailsInternal(exception)) {
            var error = exception;
            var evt = error && error.evt;
            if (!Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["E" /* isError */])(error)) {
                error = error[strError] || evt || error;
            }
            _this.typeName = Object(__WEBPACK_IMPORTED_MODULE_4__Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, _getErrorType(error)) || __WEBPACK_IMPORTED_MODULE_6__Constants__["b" /* strNotSpecified */];
            _this.message = Object(__WEBPACK_IMPORTED_MODULE_4__Common_DataSanitizer__["d" /* dataSanitizeMessage */])(logger, _formatMessage(exception || error, _this.typeName)) || __WEBPACK_IMPORTED_MODULE_6__Constants__["b" /* strNotSpecified */];
            var stack = exception[strStackDetails] || _getStackFromErrorObj(exception);
            _this.parsedStack = _parseStack(stack);
            _this[strStack] = Object(__WEBPACK_IMPORTED_MODULE_4__Common_DataSanitizer__["a" /* dataSanitizeException */])(logger, _formatStackTrace(stack));
            _this.hasFullStack = Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["C" /* isArray */])(_this.parsedStack) && _this.parsedStack.length > 0;
            if (properties) {
                properties.typeName = properties.typeName || _this.typeName;
            }
        }
        else {
            _this.typeName = exception.typeName;
            _this.message = exception.message;
            _this[strStack] = exception[strStack];
            _this.parsedStack = exception.parsedStack;
            _this.hasFullStack = exception.hasFullStack;
        }
        return _this;
    }
    _ExceptionDetails.prototype.toInterface = function () {
        var parsedStack = this.parsedStack instanceof Array
            && Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["e" /* arrMap */])(this.parsedStack, function (frame) { return frame.toInterface(); });
        var exceptionDetailsInterface = {
            id: this.id,
            outerId: this.outerId,
            typeName: this.typeName,
            message: this.message,
            hasFullStack: this.hasFullStack,
            stack: this[strStack],
            parsedStack: parsedStack || undefined
        };
        return exceptionDetailsInterface;
    };
    _ExceptionDetails.CreateFromInterface = function (logger, exception) {
        var parsedStack = (exception.parsedStack instanceof Array
            && Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["e" /* arrMap */])(exception.parsedStack, function (frame) { return _StackFrame.CreateFromInterface(frame); }))
            || exception.parsedStack;
        var exceptionDetails = new _ExceptionDetails(logger, Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["f" /* __assignFn */])({}, exception, { parsedStack: parsedStack }));
        return exceptionDetails;
    };
    return _ExceptionDetails;
}(__WEBPACK_IMPORTED_MODULE_3__Interfaces_Contracts_Generated_ExceptionDetails__["a" /* ExceptionDetails */]));

var _StackFrame = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(_StackFrame, _super);
    function _StackFrame(sourceFrame, level) {
        var _this = _super.call(this) || this;
        _this.sizeInBytes = 0;
        _this.aiDataContract = {
            level: 1 /* Required */,
            method: 1 /* Required */,
            assembly: 0 /* Default */,
            fileName: 0 /* Default */,
            line: 0 /* Default */
        };
        // Not converting this to isString() as typescript uses this logic to "understand" the different
        // types for the 2 different code paths
        if (typeof sourceFrame === "string") {
            var frame = sourceFrame;
            _this.level = level;
            _this.method = NoMethod;
            _this.assembly = Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["P" /* strTrim */])(frame);
            _this.fileName = "";
            _this.line = 0;
            var matches = frame.match(_StackFrame.regex);
            if (matches && matches.length >= 5) {
                _this.method = Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["P" /* strTrim */])(matches[2]) || _this.method;
                _this.fileName = Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["P" /* strTrim */])(matches[4]);
                _this.line = parseInt(matches[5]) || 0;
            }
        }
        else {
            _this.level = sourceFrame.level;
            _this.method = sourceFrame.method;
            _this.assembly = sourceFrame.assembly;
            _this.fileName = sourceFrame.fileName;
            _this.line = sourceFrame.line;
            _this.sizeInBytes = 0;
        }
        _this.sizeInBytes += _this.method.length;
        _this.sizeInBytes += _this.fileName.length;
        _this.sizeInBytes += _this.assembly.length;
        // todo: these might need to be removed depending on how the back-end settles on their size calculation
        _this.sizeInBytes += _StackFrame.baseSize;
        _this.sizeInBytes += _this.level.toString().length;
        _this.sizeInBytes += _this.line.toString().length;
        return _this;
    }
    _StackFrame.CreateFromInterface = function (frame) {
        return new _StackFrame(frame, null /* level is available in frame interface */);
    };
    _StackFrame.prototype.toInterface = function () {
        return {
            level: this.level,
            method: this.method,
            assembly: this.assembly,
            fileName: this.fileName,
            line: this.line
        };
    };
    // regex to match stack frames from ie/chrome/ff
    // methodName=$2, fileName=$4, lineNo=$5, column=$6
    _StackFrame.regex = /^([\s]+at)?[\s]*([^\@\()]+?)[\s]*(\@|\()([^\(\n]+):([0-9]+):([0-9]+)(\)?)$/;
    _StackFrame.baseSize = 58; // '{"method":"","level":,"assembly":"","fileName":"","line":}'.length
    return _StackFrame;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_StackFrame__["a" /* StackFrame */]));

//# sourceMappingURL=Exception.js.map

/***/ }),
/* 1397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StackFrame; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// THIS FILE WAS AUTOGENERATED
/**
 * Stack frame information.
 */
var StackFrame = /** @class */ (function () {
    function StackFrame() {
    }
    return StackFrame;
}());

//# sourceMappingURL=StackFrame.js.map

/***/ }),
/* 1398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExceptionData; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * An instance of Exception represents a handled or unhandled exception that occurred during execution of the monitored application.
 */
var ExceptionData = /** @class */ (function () {
    function ExceptionData() {
        /**
         * Schema version
         */
        this.ver = 2;
        /**
         * Exception chain - list of inner exceptions.
         */
        this.exceptions = [];
        /**
         * Collection of custom properties.
         */
        this.properties = {};
        /**
         * Collection of custom measurements.
         */
        this.measurements = {};
    }
    return ExceptionData;
}());

//# sourceMappingURL=ExceptionData.js.map

/***/ }),
/* 1399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExceptionDetails; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * Exception details of the exception in a chain.
 */
var ExceptionDetails = /** @class */ (function () {
    function ExceptionDetails() {
        /**
         * Indicates if full exception stack is provided in the exception. The stack may be trimmed, such as in the case of a StackOverflow exception.
         */
        this.hasFullStack = true;
        /**
         * List of stack frames. Either stack or parsedStack should have a value.
         */
        this.parsedStack = [];
    }
    return ExceptionDetails;
}());

//# sourceMappingURL=ExceptionDetails.js.map

/***/ }),
/* 1400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Metric; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_MetricData__ = __webpack_require__(1401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Common_DataPoint__ = __webpack_require__(1402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Constants__ = __webpack_require__(77);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







var Metric = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(Metric, _super);
    /**
     * Constructs a new instance of the MetricTelemetry object
     */
    function Metric(logger, name, value, count, min, max, properties, measurements) {
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            ver: 1 /* Required */,
            metrics: 1 /* Required */,
            properties: 0 /* Default */
        };
        var dataPoint = new __WEBPACK_IMPORTED_MODULE_3__Common_DataPoint__["a" /* DataPoint */]();
        dataPoint.count = count > 0 ? count : undefined;
        dataPoint.max = isNaN(max) || max === null ? undefined : max;
        dataPoint.min = isNaN(min) || min === null ? undefined : min;
        dataPoint.name = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, name) || __WEBPACK_IMPORTED_MODULE_4__Constants__["b" /* strNotSpecified */];
        dataPoint.value = value;
        _this.metrics = [dataPoint];
        _this.properties = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["e" /* dataSanitizeProperties */])(logger, properties);
        _this.measurements = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["c" /* dataSanitizeMeasurements */])(logger, measurements);
        return _this;
    }
    Metric.envelopeType = "Microsoft.ApplicationInsights.{0}.Metric";
    Metric.dataType = "MetricData";
    return Metric;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_MetricData__["a" /* MetricData */]));

//# sourceMappingURL=Metric.js.map

/***/ }),
/* 1401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MetricData; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * An instance of the Metric item is a list of measurements (single data points) and/or aggregations.
 */
var MetricData = /** @class */ (function () {
    function MetricData() {
        /**
         * Schema version
         */
        this.ver = 2;
        /**
         * List of metrics. Only one metric in the list is currently supported by Application Insights storage. If multiple data points were sent only the first one will be used.
         */
        this.metrics = [];
        /**
         * Collection of custom properties.
         */
        this.properties = {};
        /**
         * Collection of custom measurements.
         */
        this.measurements = {};
    }
    return MetricData;
}());

//# sourceMappingURL=MetricData.js.map

/***/ }),
/* 1402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataPoint; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_DataPoint__ = __webpack_require__(1403);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var DataPoint = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(DataPoint, _super);
    function DataPoint() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * The data contract for serializing this object.
         */
        _this.aiDataContract = {
            name: 1 /* Required */,
            kind: 0 /* Default */,
            value: 1 /* Required */,
            count: 0 /* Default */,
            min: 0 /* Default */,
            max: 0 /* Default */,
            stdDev: 0 /* Default */
        };
        return _this;
    }
    return DataPoint;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_DataPoint__["a" /* DataPoint */]));

//# sourceMappingURL=DataPoint.js.map

/***/ }),
/* 1403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataPoint; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataPointType__ = __webpack_require__(1404);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



/**
 * Metric data single measurement.
 */
var DataPoint = /** @class */ (function () {
    function DataPoint() {
        /**
         * Metric type. Single measurement or the aggregated value.
         */
        this.kind = __WEBPACK_IMPORTED_MODULE_0__DataPointType__["a" /* DataPointType */].Measurement;
    }
    return DataPoint;
}());

//# sourceMappingURL=DataPoint.js.map

/***/ }),
/* 1404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataPointType; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// THIS FILE WAS AUTOGENERATED
/**
 * Type of the metric data measurement.
 */
var DataPointType;
(function (DataPointType) {
    DataPointType[DataPointType["Measurement"] = 0] = "Measurement";
    DataPointType[DataPointType["Aggregation"] = 1] = "Aggregation";
})(DataPointType || (DataPointType = {}));
//# sourceMappingURL=DataPointType.js.map

/***/ }),
/* 1405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_PageViewData__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Constants__ = __webpack_require__(77);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







var PageView = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(PageView, _super);
    /**
     * Constructs a new instance of the PageEventTelemetry object
     */
    function PageView(logger, name, url, durationMs, properties, measurements, id) {
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            ver: 1 /* Required */,
            name: 0 /* Default */,
            url: 0 /* Default */,
            duration: 0 /* Default */,
            properties: 0 /* Default */,
            measurements: 0 /* Default */,
            id: 0 /* Default */
        };
        _this.id = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["b" /* dataSanitizeId */])(logger, id);
        _this.url = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["g" /* dataSanitizeUrl */])(logger, url);
        _this.name = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, name) || __WEBPACK_IMPORTED_MODULE_4__Constants__["b" /* strNotSpecified */];
        if (!isNaN(durationMs)) {
            _this.duration = Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["d" /* msToTimeSpan */])(durationMs);
        }
        _this.properties = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["e" /* dataSanitizeProperties */])(logger, properties);
        _this.measurements = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["c" /* dataSanitizeMeasurements */])(logger, measurements);
        return _this;
    }
    PageView.envelopeType = "Microsoft.ApplicationInsights.{0}.Pageview";
    PageView.dataType = "PageviewData";
    return PageView;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_PageViewData__["a" /* PageViewData */]));

//# sourceMappingURL=PageView.js.map

/***/ }),
/* 1406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RemoteDependencyData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Common_DataSanitizer__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Util__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Interfaces_Contracts_Generated_RemoteDependencyData__ = __webpack_require__(1407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HelperFuncs__ = __webpack_require__(242);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







var RemoteDependencyData = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(RemoteDependencyData, _super);
    /**
     * Constructs a new instance of the RemoteDependencyData object
     */
    function RemoteDependencyData(logger, id, absoluteUrl, commandName, value, success, resultCode, method, requestAPI, correlationContext, properties, measurements) {
        if (requestAPI === void 0) { requestAPI = "Ajax"; }
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            id: 1 /* Required */,
            ver: 1 /* Required */,
            name: 0 /* Default */,
            resultCode: 0 /* Default */,
            duration: 0 /* Default */,
            success: 0 /* Default */,
            data: 0 /* Default */,
            target: 0 /* Default */,
            type: 0 /* Default */,
            properties: 0 /* Default */,
            measurements: 0 /* Default */,
            kind: 0 /* Default */,
            value: 0 /* Default */,
            count: 0 /* Default */,
            min: 0 /* Default */,
            max: 0 /* Default */,
            stdDev: 0 /* Default */,
            dependencyKind: 0 /* Default */,
            dependencySource: 0 /* Default */,
            commandName: 0 /* Default */,
            dependencyTypeName: 0 /* Default */
        };
        _this.id = id;
        _this.duration = Object(__WEBPACK_IMPORTED_MODULE_4__HelperFuncs__["d" /* msToTimeSpan */])(value);
        _this.success = success;
        _this.resultCode = resultCode + "";
        _this.type = Object(__WEBPACK_IMPORTED_MODULE_1__Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, requestAPI);
        var dependencyFields = Object(__WEBPACK_IMPORTED_MODULE_2__Util__["a" /* AjaxHelperParseDependencyPath */])(logger, absoluteUrl, method, commandName);
        _this.data = Object(__WEBPACK_IMPORTED_MODULE_1__Common_DataSanitizer__["g" /* dataSanitizeUrl */])(logger, commandName) || dependencyFields.data; // get a value from hosturl if commandName not available
        _this.target = Object(__WEBPACK_IMPORTED_MODULE_1__Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, dependencyFields.target);
        if (correlationContext) {
            _this.target = _this.target + " | " + correlationContext;
        }
        _this.name = Object(__WEBPACK_IMPORTED_MODULE_1__Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, dependencyFields.name);
        _this.properties = Object(__WEBPACK_IMPORTED_MODULE_1__Common_DataSanitizer__["e" /* dataSanitizeProperties */])(logger, properties);
        _this.measurements = Object(__WEBPACK_IMPORTED_MODULE_1__Common_DataSanitizer__["c" /* dataSanitizeMeasurements */])(logger, measurements);
        return _this;
    }
    RemoteDependencyData.envelopeType = "Microsoft.ApplicationInsights.{0}.RemoteDependency";
    RemoteDependencyData.dataType = "RemoteDependencyData";
    return RemoteDependencyData;
}(__WEBPACK_IMPORTED_MODULE_3__Interfaces_Contracts_Generated_RemoteDependencyData__["a" /* RemoteDependencyData */]));

//# sourceMappingURL=RemoteDependencyData.js.map

/***/ }),
/* 1407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RemoteDependencyData; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * An instance of Remote Dependency represents an interaction of the monitored component with a remote component/service like SQL or an HTTP endpoint.
 */
var RemoteDependencyData = /** @class */ (function () {
    function RemoteDependencyData() {
        /**
         * Schema version
         */
        this.ver = 2;
        /**
         * Indication of successful or unsuccessful call.
         */
        this.success = true;
        /**
         * Collection of custom properties.
         */
        this.properties = {};
        /**
         * Collection of custom measurements.
         */
        this.measurements = {};
    }
    return RemoteDependencyData;
}());

//# sourceMappingURL=RemoteDependencyData.js.map

/***/ }),
/* 1408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Trace; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_MessageData__ = __webpack_require__(1409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Constants__ = __webpack_require__(77);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var Trace = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(Trace, _super);
    /**
     * Constructs a new instance of the TraceTelemetry object
     */
    function Trace(logger, message, severityLevel, properties, measurements) {
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            ver: 1 /* Required */,
            message: 1 /* Required */,
            severityLevel: 0 /* Default */,
            properties: 0 /* Default */
        };
        message = message || __WEBPACK_IMPORTED_MODULE_3__Constants__["b" /* strNotSpecified */];
        _this.message = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["d" /* dataSanitizeMessage */])(logger, message);
        _this.properties = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["e" /* dataSanitizeProperties */])(logger, properties);
        _this.measurements = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["c" /* dataSanitizeMeasurements */])(logger, measurements);
        if (severityLevel) {
            _this.severityLevel = severityLevel;
        }
        return _this;
    }
    Trace.envelopeType = "Microsoft.ApplicationInsights.{0}.Message";
    Trace.dataType = "MessageData";
    return Trace;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_MessageData__["a" /* MessageData */]));

//# sourceMappingURL=Trace.js.map

/***/ }),
/* 1409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MessageData; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * Instances of Message represent printf-like trace statements that are text-searched. Log4Net, NLog and other text-based log file entries are translated into intances of this type. The message does not have measurements.
 */
var MessageData = /** @class */ (function () {
    function MessageData() {
        /**
         * Schema version
         */
        this.ver = 2;
        /**
         * Collection of custom properties.
         */
        this.properties = {};
        /**
         * Collection of custom measurements.
         */
        this.measurements = {};
    }
    return MessageData;
}());

//# sourceMappingURL=MessageData.js.map

/***/ }),
/* 1410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageViewPerformance; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_PageViewPerfData__ = __webpack_require__(1411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Constants__ = __webpack_require__(77);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var PageViewPerformance = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(PageViewPerformance, _super);
    /**
     * Constructs a new instance of the PageEventTelemetry object
     */
    function PageViewPerformance(logger, name, url, unused, properties, measurements, cs4BaseData) {
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            ver: 1 /* Required */,
            name: 0 /* Default */,
            url: 0 /* Default */,
            duration: 0 /* Default */,
            perfTotal: 0 /* Default */,
            networkConnect: 0 /* Default */,
            sentRequest: 0 /* Default */,
            receivedResponse: 0 /* Default */,
            domProcessing: 0 /* Default */,
            properties: 0 /* Default */,
            measurements: 0 /* Default */
        };
        _this.url = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["g" /* dataSanitizeUrl */])(logger, url);
        _this.name = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, name) || __WEBPACK_IMPORTED_MODULE_3__Constants__["b" /* strNotSpecified */];
        _this.properties = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["e" /* dataSanitizeProperties */])(logger, properties);
        _this.measurements = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["c" /* dataSanitizeMeasurements */])(logger, measurements);
        if (cs4BaseData) {
            _this.domProcessing = cs4BaseData.domProcessing;
            _this.duration = cs4BaseData.duration;
            _this.networkConnect = cs4BaseData.networkConnect;
            _this.perfTotal = cs4BaseData.perfTotal;
            _this.receivedResponse = cs4BaseData.receivedResponse;
            _this.sentRequest = cs4BaseData.sentRequest;
        }
        return _this;
    }
    PageViewPerformance.envelopeType = "Microsoft.ApplicationInsights.{0}.PageviewPerformance";
    PageViewPerformance.dataType = "PageviewPerformanceData";
    return PageViewPerformance;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_PageViewPerfData__["a" /* PageViewPerfData */]));

//# sourceMappingURL=PageViewPerformance.js.map

/***/ }),
/* 1411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageViewPerfData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PageViewData__ = __webpack_require__(364);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



// THIS FILE WAS AUTOGENERATED

/**
 * An instance of PageViewPerf represents: a page view with no performance data, a page view with performance data, or just the performance data of an earlier page request.
 */
var PageViewPerfData = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(PageViewPerfData, _super);
    function PageViewPerfData() {
        var _this = _super.call(this) || this;
        /**
         * Schema version
         */
        _this.ver = 2;
        /**
         * Collection of custom properties.
         */
        _this.properties = {};
        /**
         * Collection of custom measurements.
         */
        _this.measurements = {};
        return _this;
    }
    return PageViewPerfData;
}(__WEBPACK_IMPORTED_MODULE_1__PageViewData__["a" /* PageViewData */]));

//# sourceMappingURL=PageViewPerfData.js.map

/***/ }),
/* 1412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Data */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_Data__ = __webpack_require__(557);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var Data = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(Data, _super);
    /**
     * Constructs a new instance of telemetry data.
     */
    function Data(baseType, data) {
        var _this = _super.call(this) || this;
        /**
         * The data contract for serializing this object.
         */
        _this.aiDataContract = {
            baseType: 1 /* Required */,
            baseData: 1 /* Required */
        };
        _this.baseType = baseType;
        _this.baseData = data;
        return _this;
    }
    return Data;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_Data__["a" /* Data */]));

//# sourceMappingURL=Data.js.map

/***/ }),
/* 1413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SeverityLevel; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// THIS FILE WAS AUTOGENERATED
/**
 * Defines the level of severity for the event.
 */
var SeverityLevel;
(function (SeverityLevel) {
    SeverityLevel[SeverityLevel["Verbose"] = 0] = "Verbose";
    SeverityLevel[SeverityLevel["Information"] = 1] = "Information";
    SeverityLevel[SeverityLevel["Warning"] = 2] = "Warning";
    SeverityLevel[SeverityLevel["Error"] = 3] = "Error";
    SeverityLevel[SeverityLevel["Critical"] = 4] = "Critical";
})(SeverityLevel || (SeverityLevel = {}));
//# sourceMappingURL=SeverityLevel.js.map

/***/ }),
/* 1414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ConfigurationManager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(41);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



var ConfigurationManager = /** @class */ (function () {
    function ConfigurationManager() {
    }
    ConfigurationManager.getConfig = function (config, field, identifier, defaultValue) {
        if (defaultValue === void 0) { defaultValue = false; }
        var configValue;
        if (identifier && config.extensionConfig && config.extensionConfig[identifier] && !Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(config.extensionConfig[identifier][field])) {
            configValue = config.extensionConfig[identifier][field];
        }
        else {
            configValue = config[field];
        }
        return !Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(configValue) ? configValue : defaultValue;
    };
    return ConfigurationManager;
}());

//# sourceMappingURL=IConfig.js.map

/***/ }),
/* 1415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TelemetryItemCreator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Telemetry_Common_DataSanitizer__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Constants__ = __webpack_require__(77);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





var TelemetryItemCreator = /** @class */ (function () {
    function TelemetryItemCreator() {
    }
    /**
     * Create a telemetry item that the 1DS channel understands
     * @param item domain specific properties; part B
     * @param baseType telemetry item type. ie PageViewData
     * @param envelopeName name of the envelope. ie Microsoft.ApplicationInsights.<instrumentation key>.PageView
     * @param customProperties user defined custom properties; part C
     * @param systemProperties system properties that are added to the context; part A
     * @returns ITelemetryItem that is sent to channel
     */
    TelemetryItemCreator.create = function (item, baseType, envelopeName, logger, customProperties, systemProperties) {
        envelopeName = Object(__WEBPACK_IMPORTED_MODULE_0__Telemetry_Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, envelopeName) || __WEBPACK_IMPORTED_MODULE_2__Constants__["b" /* strNotSpecified */];
        if (Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(item) ||
            Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(baseType) ||
            Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(envelopeName)) {
            throw Error("Input doesn't contain all required fields");
        }
        var telemetryItem = {
            name: envelopeName,
            time: Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["R" /* toISOString */])(new Date()),
            iKey: "",
            ext: systemProperties ? systemProperties : {},
            tags: [],
            data: {},
            baseType: baseType,
            baseData: item // Part B
        };
        // Part C
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(customProperties)) {
            Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["K" /* objForEachKey */])(customProperties, function (prop, value) {
                telemetryItem.data[prop] = value;
            });
        }
        return telemetryItem;
    };
    return TelemetryItemCreator;
}());

//# sourceMappingURL=TelemetryItemCreator.js.map

/***/ }),
/* 1416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Extensions */
/* unused harmony export CtxTagKeys */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Contracts_Generated_ContextTagKeys__ = __webpack_require__(560);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var Extensions = {
    UserExt: "user",
    DeviceExt: "device",
    TraceExt: "trace",
    WebExt: "web",
    AppExt: "app",
    OSExt: "os",
    SessionExt: "ses",
    SDKExt: "sdk"
};
var CtxTagKeys = new __WEBPACK_IMPORTED_MODULE_0__Contracts_Generated_ContextTagKeys__["a" /* ContextTagKeys */]();
//# sourceMappingURL=PartAExtensions.js.map

/***/ }),
/* 1417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageViewManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__microsoft_dynamicproto_js__ = __webpack_require__(117);
/*
 * Application Insights JavaScript SDK - Web Analytics, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





/**
 * Class encapsulates sending page views and page view performance telemetry.
 */
var PageViewManager = /** @class */ (function () {
    function PageViewManager(appInsights, overridePageViewDuration, core, pageViewPerformanceManager) {
        Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_dynamicproto_js__["a" /* default */])(PageViewManager, this, function (_self) {
            var intervalHandle = null;
            var itemQueue = [];
            var pageViewPerformanceSent = false;
            var _logger;
            if (core) {
                _logger = core.logger;
            }
            function _flushChannels() {
                if (core) {
                    Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["d" /* arrForEach */])(core.getTransmissionControls(), function (queues) {
                        Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["d" /* arrForEach */])(queues, function (q) { return q.flush(true); });
                    });
                }
            }
            function _addQueue(cb) {
                itemQueue.push(cb);
                if (!intervalHandle) {
                    intervalHandle = setInterval((function () {
                        var allItems = itemQueue.slice(0);
                        var doFlush = false;
                        itemQueue = [];
                        Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["d" /* arrForEach */])(allItems, function (item) {
                            if (!item()) {
                                // Not processed so rescheduled
                                itemQueue.push(item);
                            }
                            else {
                                doFlush = true;
                            }
                        });
                        if (itemQueue.length === 0) {
                            clearInterval(intervalHandle);
                            intervalHandle = null;
                        }
                        if (doFlush) {
                            // We process at least one item so flush the queue
                            _flushChannels();
                        }
                    }), 100);
                }
            }
            _self.trackPageView = function (pageView, customProperties) {
                var name = pageView.name;
                if (Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(name) || typeof name !== "string") {
                    var doc = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["q" /* getDocument */])();
                    name = pageView.name = doc && doc.title || "";
                }
                var uri = pageView.uri;
                if (Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(uri) || typeof uri !== "string") {
                    var location_1 = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["x" /* getLocation */])();
                    uri = pageView.uri = location_1 && location_1.href || "";
                }
                // case 1a. if performance timing is not supported by the browser, send the page view telemetry with the duration provided by the user. If the user
                // do not provide the duration, set duration to undefined
                // Also this is case 4
                if (!pageViewPerformanceManager.isPerformanceTimingSupported()) {
                    appInsights.sendPageViewInternal(pageView, customProperties);
                    _flushChannels();
                    // no navigation timing (IE 8, iOS Safari 8.4, Opera Mini 8 - see http://caniuse.com/#feat=nav-timing)
                    _logger.throwInternal(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].NavigationTimingNotSupported, "trackPageView: navigation timing API used for calculation of page duration is not supported in this browser. This page view will be collected without duration and timing info.");
                    return;
                }
                var pageViewSent = false;
                var customDuration;
                // if the performance timing is supported by the browser, calculate the custom duration
                var start = pageViewPerformanceManager.getPerformanceTiming().navigationStart;
                if (start > 0) {
                    customDuration = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["m" /* dateTimeUtilsDuration */])(start, +new Date);
                    if (!pageViewPerformanceManager.shouldCollectDuration(customDuration)) {
                        customDuration = undefined;
                    }
                }
                // if the user has provided duration, send a page view telemetry with the provided duration. Otherwise, if
                // overridePageViewDuration is set to true, send a page view telemetry with the custom duration calculated earlier
                var duration;
                if (!Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(customProperties) &&
                    !Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(customProperties.duration)) {
                    duration = customProperties.duration;
                }
                if (overridePageViewDuration || !isNaN(duration)) {
                    if (isNaN(duration)) {
                        // case 3
                        if (!customProperties) {
                            customProperties = {};
                        }
                        customProperties["duration"] = customDuration;
                    }
                    // case 2
                    appInsights.sendPageViewInternal(pageView, customProperties);
                    _flushChannels();
                    pageViewSent = true;
                }
                // now try to send the page view performance telemetry
                var maxDurationLimit = 60000;
                if (!customProperties) {
                    customProperties = {};
                }
                // Queue the event for processing
                _addQueue(function () {
                    var processed = false;
                    try {
                        if (pageViewPerformanceManager.isPerformanceTimingDataReady()) {
                            processed = true;
                            var pageViewPerformance = {
                                name: name,
                                uri: uri
                            };
                            pageViewPerformanceManager.populatePageViewPerformanceEvent(pageViewPerformance);
                            if (!pageViewPerformance.isValid && !pageViewSent) {
                                // If navigation timing gives invalid numbers, then go back to "override page view duration" mode.
                                // That's the best value we can get that makes sense.
                                customProperties["duration"] = customDuration;
                                appInsights.sendPageViewInternal(pageView, customProperties);
                            }
                            else {
                                if (!pageViewSent) {
                                    customProperties["duration"] = pageViewPerformance.durationMs;
                                    appInsights.sendPageViewInternal(pageView, customProperties);
                                }
                                if (!pageViewPerformanceSent) {
                                    appInsights.sendPageViewPerformanceInternal(pageViewPerformance, customProperties);
                                    pageViewPerformanceSent = true;
                                }
                            }
                        }
                        else if (start > 0 && Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["m" /* dateTimeUtilsDuration */])(start, +new Date) > maxDurationLimit) {
                            // if performance timings are not ready but we exceeded the maximum duration limit, just log a page view telemetry
                            // with the maximum duration limit. Otherwise, keep waiting until performance timings are ready
                            processed = true;
                            if (!pageViewSent) {
                                customProperties["duration"] = maxDurationLimit;
                                appInsights.sendPageViewInternal(pageView, customProperties);
                            }
                        }
                    }
                    catch (e) {
                        _logger.throwInternal(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].TrackPVFailedCalc, "trackPageView failed on page load calculation: " + Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["r" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["n" /* dumpObj */])(e) });
                    }
                    return processed;
                });
            };
        });
    }
// Removed Stub for PageViewManager.prototype.trackPageView.
    return PageViewManager;
}());

//# sourceMappingURL=PageViewManager.js.map

/***/ }),
/* 1418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageVisitTimeManager; });
/* unused harmony export PageVisitData */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__ = __webpack_require__(41);
/*
 * Application Insights JavaScript SDK - Web Analytics, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




/**
 * Used to track page visit durations
 */
var PageVisitTimeManager = /** @class */ (function () {
    /**
     * Creates a new instance of PageVisitTimeManager
     * @param pageVisitTimeTrackingHandler Delegate that will be called to send telemetry data to AI (when trackPreviousPageVisit is called)
     * @returns {}
     */
    function PageVisitTimeManager(logger, pageVisitTimeTrackingHandler) {
        this.prevPageVisitDataKeyName = "prevPageVisitData";
        this.pageVisitTimeTrackingHandler = pageVisitTimeTrackingHandler;
        this._logger = logger;
    }
    /**
     * Tracks the previous page visit time telemetry (if exists) and starts timing of new page visit time
     * @param currentPageName Name of page to begin timing for visit duration
     * @param currentPageUrl Url of page to begin timing for visit duration
     */
    PageVisitTimeManager.prototype.trackPreviousPageVisit = function (currentPageName, currentPageUrl) {
        try {
            // Restart timer for new page view
            var prevPageVisitTimeData = this.restartPageVisitTimer(currentPageName, currentPageUrl);
            // If there was a page already being timed, track the visit time for it now.
            if (prevPageVisitTimeData) {
                this.pageVisitTimeTrackingHandler(prevPageVisitTimeData.pageName, prevPageVisitTimeData.pageUrl, prevPageVisitTimeData.pageVisitTime);
            }
        }
        catch (e) {
            this._logger.warnToConsole("Auto track page visit time failed, metric will not be collected: " + Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["n" /* dumpObj */])(e));
        }
    };
    /**
     * Stops timing of current page (if exists) and starts timing for duration of visit to pageName
     * @param pageName Name of page to begin timing visit duration
     * @returns {PageVisitData} Page visit data (including duration) of pageName from last call to start or restart, if exists. Null if not.
     */
    PageVisitTimeManager.prototype.restartPageVisitTimer = function (pageName, pageUrl) {
        try {
            var prevPageVisitData = this.stopPageVisitTimer();
            this.startPageVisitTimer(pageName, pageUrl);
            return prevPageVisitData;
        }
        catch (e) {
            this._logger.warnToConsole("Call to restart failed: " + Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["n" /* dumpObj */])(e));
            return null;
        }
    };
    /**
     * Starts timing visit duration of pageName
     * @param pageName
     * @returns {}
     */
    PageVisitTimeManager.prototype.startPageVisitTimer = function (pageName, pageUrl) {
        try {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["r" /* utlCanUseSessionStorage */])()) {
                if (Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["t" /* utlGetSessionStorage */])(this._logger, this.prevPageVisitDataKeyName) != null) {
                    Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["Q" /* throwError */])("Cannot call startPageVisit consecutively without first calling stopPageVisit");
                }
                var currPageVisitData = new PageVisitData(pageName, pageUrl);
                var currPageVisitDataStr = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["w" /* getJSON */])().stringify(currPageVisitData);
                Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["v" /* utlSetSessionStorage */])(this._logger, this.prevPageVisitDataKeyName, currPageVisitDataStr);
            }
        }
        catch (e) {
            // TODO: Remove this catch in next phase, since if start is called twice in a row the exception needs to be propagated out
            this._logger.warnToConsole("Call to start failed: " + Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["n" /* dumpObj */])(e));
        }
    };
    /**
     * Stops timing of current page, if exists.
     * @returns {PageVisitData} Page visit data (including duration) of pageName from call to start, if exists. Null if not.
     */
    PageVisitTimeManager.prototype.stopPageVisitTimer = function () {
        try {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["r" /* utlCanUseSessionStorage */])()) {
                // Define end time of page's visit
                var pageVisitEndTime = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["j" /* dateNow */])();
                // Try to retrieve  page name and start time from session storage
                var pageVisitDataJsonStr = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["t" /* utlGetSessionStorage */])(this._logger, this.prevPageVisitDataKeyName);
                if (pageVisitDataJsonStr && Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["B" /* hasJSON */])()) {
                    // if previous page data exists, set end time of visit
                    var prevPageVisitData = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["w" /* getJSON */])().parse(pageVisitDataJsonStr);
                    prevPageVisitData.pageVisitTime = pageVisitEndTime - prevPageVisitData.pageVisitStartTime;
                    // Remove data from storage since we already used it
                    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["u" /* utlRemoveSessionStorage */])(this._logger, this.prevPageVisitDataKeyName);
                    // Return page visit data
                    return prevPageVisitData;
                }
                else {
                    return null;
                }
            }
            return null;
        }
        catch (e) {
            this._logger.warnToConsole("Stop page visit timer failed: " + Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["n" /* dumpObj */])(e));
            return null;
        }
    };
    return PageVisitTimeManager;
}());

var PageVisitData = /** @class */ (function () {
    function PageVisitData(pageName, pageUrl) {
        this.pageVisitStartTime = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["j" /* dateNow */])();
        this.pageName = pageName;
        this.pageUrl = pageUrl;
    }
    return PageVisitData;
}());

//# sourceMappingURL=PageVisitTimeManager.js.map

/***/ }),
/* 1419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageViewPerformanceManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__ = __webpack_require__(41);
/*
 * Application Insights JavaScript SDK - Web Analytics, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




/**
 * Class encapsulates sending page view performance telemetry.
 */
var PageViewPerformanceManager = /** @class */ (function () {
    function PageViewPerformanceManager(core) {
        this.MAX_DURATION_ALLOWED = 3600000; // 1h
        if (core) {
            this._logger = core.logger;
        }
    }
    PageViewPerformanceManager.prototype.populatePageViewPerformanceEvent = function (pageViewPerformance) {
        pageViewPerformance.isValid = false;
        /*
         * http://www.w3.org/TR/navigation-timing/#processing-model
         *  |-navigationStart
         *  |             |-connectEnd
         *  |             ||-requestStart
         *  |             ||             |-responseStart
         *  |             ||             |              |-responseEnd
         *  |             ||             |              |
         *  |             ||             |              |         |-loadEventEnd
         *  |---network---||---request---|---response---|---dom---|
         *  |--------------------------total----------------------|
         *
         *  total = The difference between the load event of the current document is completed and the first recorded timestamp of the performance entry : https://developer.mozilla.org/en-US/docs/Web/Performance/Navigation_and_resource_timings#duration
         *  network = Redirect time + App Cache + DNS lookup time + TCP connection time
         *  request = Request time : https://developer.mozilla.org/en-US/docs/Web/Performance/Navigation_and_resource_timings#request_time
         *  response = Response time
         *  dom = Document load time : https://html.spec.whatwg.org/multipage/dom.html#document-load-timing-info
         *      = Document processing time : https://developers.google.com/web/fundamentals/performance/navigation-and-resource-timing/#document_processing
         *      + Loading time : https://developers.google.com/web/fundamentals/performance/navigation-and-resource-timing/#loading
         */
        var navigationTiming = this.getPerformanceNavigationTiming();
        var timing = this.getPerformanceTiming();
        var total = 0;
        var network = 0;
        var request = 0;
        var response = 0;
        var dom = 0;
        if (navigationTiming || timing) {
            if (navigationTiming) {
                total = navigationTiming.duration;
                /**
                 * support both cases:
                 * - startTime is always zero: https://developer.mozilla.org/en-US/docs/Web/API/PerformanceNavigationTiming
                 * - for older browsers where the startTime is not zero
                 */
                network = navigationTiming.startTime === 0 ? navigationTiming.connectEnd : Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["m" /* dateTimeUtilsDuration */])(navigationTiming.startTime, navigationTiming.connectEnd);
                request = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["m" /* dateTimeUtilsDuration */])(navigationTiming.requestStart, navigationTiming.responseStart);
                response = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["m" /* dateTimeUtilsDuration */])(navigationTiming.responseStart, navigationTiming.responseEnd);
                dom = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["m" /* dateTimeUtilsDuration */])(navigationTiming.responseEnd, navigationTiming.loadEventEnd);
            }
            else {
                total = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["m" /* dateTimeUtilsDuration */])(timing.navigationStart, timing.loadEventEnd);
                network = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["m" /* dateTimeUtilsDuration */])(timing.navigationStart, timing.connectEnd);
                request = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["m" /* dateTimeUtilsDuration */])(timing.requestStart, timing.responseStart);
                response = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["m" /* dateTimeUtilsDuration */])(timing.responseStart, timing.responseEnd);
                dom = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["m" /* dateTimeUtilsDuration */])(timing.responseEnd, timing.loadEventEnd);
            }
            if (total === 0) {
                this._logger.throwInternal(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].ErrorPVCalc, "error calculating page view performance.", { total: total, network: network, request: request, response: response, dom: dom });
            }
            else if (!this.shouldCollectDuration(total, network, request, response, dom)) {
                this._logger.throwInternal(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].InvalidDurationValue, "Invalid page load duration value. Browser perf data won't be sent.", { total: total, network: network, request: request, response: response, dom: dom });
            }
            else if (total < Math.floor(network) + Math.floor(request) + Math.floor(response) + Math.floor(dom)) {
                // some browsers may report individual components incorrectly so that the sum of the parts will be bigger than total PLT
                // in this case, don't report client performance from this page
                this._logger.throwInternal(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["c" /* _InternalMessageId */].ClientPerformanceMathError, "client performance math error.", { total: total, network: network, request: request, response: response, dom: dom });
            }
            else {
                pageViewPerformance.durationMs = total;
                // // convert to timespans
                pageViewPerformance.perfTotal = pageViewPerformance.duration = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["o" /* msToTimeSpan */])(total);
                pageViewPerformance.networkConnect = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["o" /* msToTimeSpan */])(network);
                pageViewPerformance.sentRequest = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["o" /* msToTimeSpan */])(request);
                pageViewPerformance.receivedResponse = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["o" /* msToTimeSpan */])(response);
                pageViewPerformance.domProcessing = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["o" /* msToTimeSpan */])(dom);
                pageViewPerformance.isValid = true;
            }
        }
    };
    PageViewPerformanceManager.prototype.getPerformanceTiming = function () {
        if (this.isPerformanceTimingSupported()) {
            return Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["z" /* getPerformance */])().timing;
        }
        return null;
    };
    PageViewPerformanceManager.prototype.getPerformanceNavigationTiming = function () {
        if (this.isPerformanceNavigationTimingSupported()) {
            return Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["z" /* getPerformance */])().getEntriesByType("navigation")[0];
        }
        return null;
    };
    /**
     * Returns true is window PerformanceNavigationTiming API is supported, false otherwise.
     */
    PageViewPerformanceManager.prototype.isPerformanceNavigationTimingSupported = function () {
        var perf = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["z" /* getPerformance */])();
        return perf && perf.getEntriesByType && perf.getEntriesByType("navigation").length > 0;
    };
    /**
     * Returns true is window performance timing API is supported, false otherwise.
     */
    PageViewPerformanceManager.prototype.isPerformanceTimingSupported = function () {
        var perf = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["z" /* getPerformance */])();
        return perf && perf.timing;
    };
    /**
     * As page loads different parts of performance timing numbers get set. When all of them are set we can report it.
     * Returns true if ready, false otherwise.
     */
    PageViewPerformanceManager.prototype.isPerformanceTimingDataReady = function () {
        var perf = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["z" /* getPerformance */])();
        var timing = perf ? perf.timing : 0;
        return timing
            && timing.domainLookupStart > 0
            && timing.navigationStart > 0
            && timing.responseStart > 0
            && timing.requestStart > 0
            && timing.loadEventEnd > 0
            && timing.responseEnd > 0
            && timing.connectEnd > 0
            && timing.domLoading > 0;
    };
    /**
     * This method tells if given durations should be excluded from collection.
     */
    PageViewPerformanceManager.prototype.shouldCollectDuration = function () {
        var durations = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            durations[_i] = arguments[_i];
        }
        var _navigator = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["y" /* getNavigator */])() || {};
        // a full list of Google crawlers user agent strings - https://support.google.com/webmasters/answer/1061943?hl=en
        var botAgentNames = ['googlebot', 'adsbot-google', 'apis-google', 'mediapartners-google'];
        var userAgent = _navigator.userAgent;
        var isGoogleBot = false;
        if (userAgent) {
            for (var i = 0; i < botAgentNames.length; i++) {
                isGoogleBot = isGoogleBot || userAgent.toLowerCase().indexOf(botAgentNames[i]) !== -1;
            }
        }
        if (isGoogleBot) {
            // Don't report durations for GoogleBot, it is returning invalid values in performance.timing API.
            return false;
        }
        else {
            // for other page views, don't report if it's outside of a reasonable range
            for (var i = 0; i < durations.length; i++) {
                if (durations[i] < 0 || durations[i] >= this.MAX_DURATION_ALLOWED) {
                    return false;
                }
            }
        }
        return true;
    };
    return PageViewPerformanceManager;
}());

//# sourceMappingURL=PageViewPerformanceManager.js.map

/***/ }),
/* 1420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Sender; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SendBuffer__ = __webpack_require__(1421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EnvelopeCreator__ = __webpack_require__(1453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Serializer__ = __webpack_require__(1454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_common__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Offline__ = __webpack_require__(1455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TelemetryProcessors_Sample__ = __webpack_require__(1456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__microsoft_dynamicproto_js__ = __webpack_require__(97);
/*
 * Application Insights JavaScript SDK - Channel, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



 // todo move to channel





function _getResponseText(xhr) {
    try {
        return xhr.responseText;
    }
    catch (e) {
        // Best effort, as XHR may throw while XDR wont so just ignore
    }
    return null;
}
var Sender = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(Sender, _super);
    function Sender() {
        var _this = _super.call(this) || this;
        _this.priority = 1001;
        _this.identifier = __WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_common__["a" /* BreezeChannelIdentifier */];
        /**
         * Whether XMLHttpRequest object is supported. Older version of IE (8,9) do not support it.
         */
        _this._XMLHttpRequestSupported = false;
        /**
         * How many times in a row a retryable error condition has occurred.
         */
        var _consecutiveErrors;
        /**
         * The time to retry at in milliseconds from 1970/01/01 (this makes the timer calculation easy).
         */
        var _retryAt;
        /**
         * The time of the last send operation.
         */
        var _lastSend;
        /**
         * Handle to the timer for delayed sending of batches of data.
         */
        var _timeoutHandle;
        var _serializer;
        var _stamp_specific_redirects;
        var _headers = {};
        Object(__WEBPACK_IMPORTED_MODULE_8__microsoft_dynamicproto_js__["a" /* default */])(Sender, _this, function (_self, _base) {
            function _notImplemented() {
                Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["U" /* throwError */])("Method not implemented.");
            }
            _self.pause = _notImplemented;
            _self.resume = _notImplemented;
            _self.flush = function () {
                try {
                    _self.triggerSend(true, null, 1 /* ManualFlush */);
                }
                catch (e) {
                    _self.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].FlushFailed, "flush failed, telemetry will not be collected: " + Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["s" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["o" /* dumpObj */])(e) });
                }
            };
            _self.onunloadFlush = function () {
                if ((_self._senderConfig.onunloadDisableBeacon() === false || _self._senderConfig.isBeaconApiDisabled() === false) && Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_common__["r" /* isBeaconApiSupported */])()) {
                    try {
                        _self.triggerSend(true, _beaconSender, 2 /* Unload */);
                    }
                    catch (e) {
                        _self.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].FailedToSendQueuedTelemetry, "failed to flush with beacon sender on page unload, telemetry will not be collected: " + Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["s" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["o" /* dumpObj */])(e) });
                    }
                }
                else {
                    _self.flush();
                }
            };
            _self.teardown = _notImplemented;
            _self.addHeader = function (name, value) {
                _headers[name] = value;
            };
            _self.initialize = function (config, core, extensions, pluginChain) {
                _base.initialize(config, core, extensions, pluginChain);
                var ctx = _self._getTelCtx();
                var identifier = _self.identifier;
                _serializer = new __WEBPACK_IMPORTED_MODULE_3__Serializer__["a" /* Serializer */](core.logger);
                _consecutiveErrors = 0;
                _retryAt = null;
                _lastSend = 0;
                _self._sender = null;
                _stamp_specific_redirects = 0;
                var defaultConfig = Sender._getDefaultAppInsightsChannelConfig();
                _self._senderConfig = Sender._getEmptyAppInsightsChannelConfig();
                Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["M" /* objForEachKey */])(defaultConfig, function (field, value) {
                    _self._senderConfig[field] = function () { return ctx.getConfig(identifier, field, value()); };
                });
                _self._buffer = (_self._senderConfig.enableSessionStorageBuffer() && Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_common__["t" /* utlCanUseSessionStorage */])())
                    ? new __WEBPACK_IMPORTED_MODULE_1__SendBuffer__["b" /* SessionStorageSendBuffer */](_self.diagLog(), _self._senderConfig) : new __WEBPACK_IMPORTED_MODULE_1__SendBuffer__["a" /* ArraySendBuffer */](_self._senderConfig);
                _self._sample = new __WEBPACK_IMPORTED_MODULE_7__TelemetryProcessors_Sample__["a" /* Sample */](_self._senderConfig.samplingPercentage(), _self.diagLog());
                if (!_validateInstrumentationKey(config)) {
                    _self.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].InvalidInstrumentationKey, "Invalid Instrumentation key " + config.instrumentationKey);
                }
                if (!Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_common__["s" /* isInternalApplicationInsightsEndpoint */])(_self._senderConfig.endpointUrl()) && _self._senderConfig.customHeaders() && _self._senderConfig.customHeaders().length > 0) {
                    Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["e" /* arrForEach */])(_self._senderConfig.customHeaders(), function (customHeader) {
                        _this.addHeader(customHeader.header, customHeader.value);
                    });
                }
                if (!_self._senderConfig.isBeaconApiDisabled() && Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_common__["r" /* isBeaconApiSupported */])()) {
                    _self._sender = _beaconSender;
                }
                else {
                    var xhr = Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["u" /* getGlobalInst */])("XMLHttpRequest");
                    if (xhr) {
                        var testXhr = new xhr();
                        if ("withCredentials" in testXhr) {
                            _self._sender = _xhrSender;
                            _self._XMLHttpRequestSupported = true;
                        }
                        else if (typeof XDomainRequest !== undefined) {
                            _self._sender = _xdrSender; // IE 8 and 9
                        }
                    }
                    else {
                        var fetch_1 = Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["u" /* getGlobalInst */])("fetch");
                        if (fetch_1) {
                            _self._sender = _fetchSender;
                        }
                    }
                }
            };
            _self.processTelemetry = function (telemetryItem, itemCtx) {
                itemCtx = _self._getTelCtx(itemCtx);
                try {
                    // if master off switch is set, don't send any data
                    if (_self._senderConfig.disableTelemetry()) {
                        // Do not send/save data
                        return;
                    }
                    // validate input
                    if (!telemetryItem) {
                        itemCtx.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].CannotSendEmptyTelemetry, "Cannot send empty telemetry");
                        return;
                    }
                    // validate event
                    if (telemetryItem.baseData && !telemetryItem.baseType) {
                        itemCtx.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].InvalidEvent, "Cannot send telemetry without baseData and baseType");
                        return;
                    }
                    if (!telemetryItem.baseType) {
                        // Default
                        telemetryItem.baseType = "EventData";
                    }
                    // ensure a sender was constructed
                    if (!_self._sender) {
                        itemCtx.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].SenderNotInitialized, "Sender was not initialized");
                        return;
                    }
                    // check if this item should be sampled in, else add sampleRate tag
                    if (!_isSampledIn(telemetryItem)) {
                        // Item is sampled out, do not send it
                        itemCtx.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].TelemetrySampledAndNotSent, "Telemetry item was sampled out and not sent", { SampleRate: _self._sample.sampleRate });
                        return;
                    }
                    else {
                        telemetryItem[__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_common__["p" /* SampleRate */]] = _self._sample.sampleRate;
                    }
                    // construct an envelope that Application Insights endpoint can understand
                    var aiEnvelope_1 = Sender.constructEnvelope(telemetryItem, _self._senderConfig.instrumentationKey(), itemCtx.diagLog());
                    if (!aiEnvelope_1) {
                        itemCtx.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].CreateEnvelopeError, "Unable to create an AppInsights envelope");
                        return;
                    }
                    var doNotSendItem_1 = false;
                    // this is for running in legacy mode, where customer may already have a custom initializer present
                    if (telemetryItem.tags && telemetryItem.tags[__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_common__["m" /* ProcessLegacy */]]) {
                        Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["e" /* arrForEach */])(telemetryItem.tags[__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_common__["m" /* ProcessLegacy */]], function (callBack) {
                            try {
                                if (callBack && callBack(aiEnvelope_1) === false) {
                                    doNotSendItem_1 = true;
                                    itemCtx.diagLog().warnToConsole("Telemetry processor check returns false");
                                }
                            }
                            catch (e) {
                                // log error but dont stop executing rest of the telemetry initializers
                                // doNotSendItem = true;
                                itemCtx.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].TelemetryInitializerFailed, "One of telemetry initializers failed, telemetry item will not be sent: " + Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["s" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["o" /* dumpObj */])(e) }, true);
                            }
                        });
                        delete telemetryItem.tags[__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_common__["m" /* ProcessLegacy */]];
                    }
                    if (doNotSendItem_1) {
                        return; // do not send, no need to execute next plugin
                    }
                    // check if the incoming payload is too large, truncate if necessary
                    var payload = _serializer.serialize(aiEnvelope_1);
                    // flush if we would exceed the max-size limit by adding this item
                    var bufferPayload = _self._buffer.getItems();
                    var batch = _self._buffer.batchPayloads(bufferPayload);
                    if (batch && (batch.length + payload.length > _self._senderConfig.maxBatchSizeInBytes())) {
                        _self.triggerSend(true, null, 10 /* MaxBatchSize */);
                    }
                    // enqueue the payload
                    _self._buffer.enqueue(payload);
                    // ensure an invocation timeout is set
                    _setupTimer();
                }
                catch (e) {
                    itemCtx.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].FailedAddingTelemetryToBuffer, "Failed adding telemetry to the sender's buffer, some telemetry will be lost: " + Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["s" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["o" /* dumpObj */])(e) });
                }
                // hand off the telemetry item to the next plugin
                _self.processNext(telemetryItem, itemCtx);
            };
            /**
             * xhr state changes
             */
            _self._xhrReadyStateChange = function (xhr, payload, countOfItemsInPayload) {
                if (xhr.readyState === 4) {
                    _checkResponsStatus(xhr.status, payload, xhr.responseURL, countOfItemsInPayload, _formatErrorMessageXhr(xhr), _getResponseText(xhr) || xhr.response);
                }
            };
            /**
             * Immediately send buffered data
             * @param async {boolean} - Indicates if the events should be sent asynchronously
             * @param forcedSender {SenderFunction} - Indicates the forcedSender, undefined if not passed
             */
            _self.triggerSend = function (async, forcedSender, sendReason) {
                if (async === void 0) { async = true; }
                try {
                    // Send data only if disableTelemetry is false
                    if (!_self._senderConfig.disableTelemetry()) {
                        if (_self._buffer.count() > 0) {
                            var payload = _self._buffer.getItems();
                            _notifySendRequest(sendReason || 0 /* Undefined */, async);
                            // invoke send
                            if (forcedSender) {
                                forcedSender.call(_this, payload, async);
                            }
                            else {
                                _self._sender(payload, async);
                            }
                        }
                        // update lastSend time to enable throttling
                        _lastSend = +new Date;
                    }
                    else {
                        _self._buffer.clear();
                    }
                    clearTimeout(_timeoutHandle);
                    _timeoutHandle = null;
                    _retryAt = null;
                }
                catch (e) {
                    /* Ignore this error for IE under v10 */
                    var ieVer = Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["v" /* getIEVersion */])();
                    if (!ieVer || ieVer > 9) {
                        _self.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].TransmissionFailed, "Telemetry transmission failed, some telemetry will be lost: " + Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["s" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["o" /* dumpObj */])(e) });
                    }
                }
            };
            /**
             * error handler
             */
            _self._onError = function (payload, message, event) {
                _self.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].OnError, "Failed to send telemetry.", { message: message });
                _self._buffer.clearSent(payload);
            };
            /**
             * partial success handler
             */
            _self._onPartialSuccess = function (payload, results) {
                var failed = [];
                var retry = [];
                // Iterate through the reversed array of errors so that splicing doesn't have invalid indexes after the first item.
                var errors = results.errors.reverse();
                for (var _i = 0, errors_1 = errors; _i < errors_1.length; _i++) {
                    var error = errors_1[_i];
                    var extracted = payload.splice(error.index, 1)[0];
                    if (_isRetriable(error.statusCode)) {
                        retry.push(extracted);
                    }
                    else {
                        // All other errors, including: 402 (Monthly quota exceeded) and 439 (Too many requests and refresh cache).
                        failed.push(extracted);
                    }
                }
                if (payload.length > 0) {
                    _self._onSuccess(payload, results.itemsAccepted);
                }
                if (failed.length > 0) {
                    _self._onError(failed, _formatErrorMessageXhr(null, ['partial success', results.itemsAccepted, 'of', results.itemsReceived].join(' ')));
                }
                if (retry.length > 0) {
                    _resendPayload(retry);
                    _self.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].TransmissionFailed, "Partial success. " +
                        "Delivered: " + payload.length + ", Failed: " + failed.length +
                        ". Will retry to send " + retry.length + " our of " + results.itemsReceived + " items");
                }
            };
            /**
             * success handler
             */
            _self._onSuccess = function (payload, countOfItemsInPayload) {
                _self._buffer.clearSent(payload);
            };
            /**
             * xdr state changes
             */
            _self._xdrOnLoad = function (xdr, payload) {
                var responseText = _getResponseText(xdr);
                if (xdr && (responseText + "" === "200" || responseText === "")) {
                    _consecutiveErrors = 0;
                    _self._onSuccess(payload, 0);
                }
                else {
                    var results = _parseResponse(responseText);
                    if (results && results.itemsReceived && results.itemsReceived > results.itemsAccepted
                        && !_self._senderConfig.isRetryDisabled()) {
                        _self._onPartialSuccess(payload, results);
                    }
                    else {
                        _self._onError(payload, _formatErrorMessageXdr(xdr));
                    }
                }
            };
            function _isSampledIn(envelope) {
                return _self._sample.isSampledIn(envelope);
            }
            function _checkResponsStatus(status, payload, responseUrl, countOfItemsInPayload, errorMessage, res) {
                var response = null;
                if (!_self._appId) {
                    response = _parseResponse(res);
                    if (response && response.appId) {
                        _self._appId = response.appId;
                    }
                }
                if ((status < 200 || status >= 300) && status !== 0) {
                    // Update End Point url if permanent redirect or moved permanently
                    // Updates the end point url before retry
                    if (status === 301 || status === 308) {
                        if (!_checkAndUpdateEndPointUrl(responseUrl)) {
                            _self._onError(payload, errorMessage);
                            return;
                        }
                    }
                    if (!_self._senderConfig.isRetryDisabled() && _isRetriable(status)) {
                        _resendPayload(payload);
                        _self.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].TransmissionFailed, ". " +
                            "Response code " + status + ". Will retry to send " + payload.length + " items.");
                    }
                    else {
                        _self._onError(payload, errorMessage);
                    }
                }
                else if (__WEBPACK_IMPORTED_MODULE_6__Offline__["a" /* Offline */].isOffline()) {
                    // Note: Don't check for status == 0, since adblock gives this code
                    if (!_self._senderConfig.isRetryDisabled()) {
                        var offlineBackOffMultiplier = 10; // arbritrary number
                        _resendPayload(payload, offlineBackOffMultiplier);
                        _self.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].TransmissionFailed, ". Offline - Response Code: " + status + ". Offline status: " + __WEBPACK_IMPORTED_MODULE_6__Offline__["a" /* Offline */].isOffline() + ". Will retry to send " + payload.length + " items.");
                    }
                }
                else {
                    // check if the xhr's responseURL or fetch's response.url is same as endpoint url
                    // TODO after 10 redirects force send telemetry with 'redirect=false' as query parameter.
                    _checkAndUpdateEndPointUrl(responseUrl);
                    if (status === 206) {
                        if (!response) {
                            response = _parseResponse(res);
                        }
                        if (response && !_self._senderConfig.isRetryDisabled()) {
                            _self._onPartialSuccess(payload, response);
                        }
                        else {
                            _self._onError(payload, errorMessage);
                        }
                    }
                    else {
                        _consecutiveErrors = 0;
                        _self._onSuccess(payload, countOfItemsInPayload);
                    }
                }
            }
            function _checkAndUpdateEndPointUrl(responseUrl) {
                // Maximum stamp specific redirects allowed(uncomment this when breeze is ready with not allowing redirects feature)
                if (_stamp_specific_redirects >= 10) {
                    //  _self._senderConfig.endpointUrl = () => Sender._getDefaultAppInsightsChannelConfig().endpointUrl()+"/?redirect=false";
                    //  _stamp_specific_redirects = 0;
                    return false;
                }
                if (!Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["F" /* isNullOrUndefined */])(responseUrl) && responseUrl !== '') {
                    if (responseUrl !== _self._senderConfig.endpointUrl()) {
                        _self._senderConfig.endpointUrl = function () { return responseUrl; };
                        ++_stamp_specific_redirects;
                        return true;
                    }
                }
                return false;
            }
            /**
             * Send Beacon API request
             * @param payload {string} - The data payload to be sent.
             * @param isAsync {boolean} - not used
             * Note: Beacon API does not support custom headers and we are not able to get
             * appId from the backend for the correct correlation.
             */
            function _beaconSender(payload, isAsync) {
                var url = _self._senderConfig.endpointUrl();
                var batch = _self._buffer.batchPayloads(payload);
                // Chrome only allows CORS-safelisted values for the sendBeacon data argument
                // see: https://bugs.chromium.org/p/chromium/issues/detail?id=720283
                var plainTextBatch = new Blob([batch], { type: 'text/plain;charset=UTF-8' });
                // The sendBeacon method returns true if the user agent is able to successfully queue the data for transfer. Otherwise it returns false.
                var queued = Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["x" /* getNavigator */])().sendBeacon(url, plainTextBatch);
                if (queued) {
                    _self._buffer.markAsSent(payload);
                    // no response from beaconSender, clear buffer
                    _self._onSuccess(payload, payload.length);
                }
                else {
                    _xhrSender(payload, true);
                    _self.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].TransmissionFailed, ". " + "Failed to send telemetry with Beacon API, retried with xhrSender.");
                }
            }
            /**
             * Send XMLHttpRequest
             * @param payload {string} - The data payload to be sent.
             * @param isAsync {boolean} - Indicates if the request should be sent asynchronously
             */
            function _xhrSender(payload, isAsync) {
                var xhr = new XMLHttpRequest();
                var endPointUrl = _self._senderConfig.endpointUrl();
                try {
                    xhr[__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_common__["e" /* DisabledPropertyName */]] = true;
                }
                catch (e) {
                    // If the environment has locked down the XMLHttpRequest (preventExtensions and/or freeze), this would
                    // cause the request to fail and we no telemetry would be sent
                }
                xhr.open("POST", endPointUrl, isAsync);
                xhr.setRequestHeader("Content-type", "application/json");
                // append Sdk-Context request header only in case of breeze endpoint
                if (Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_common__["s" /* isInternalApplicationInsightsEndpoint */])(endPointUrl)) {
                    xhr.setRequestHeader(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_common__["o" /* RequestHeaders */].sdkContextHeader, __WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_common__["o" /* RequestHeaders */].sdkContextHeaderAppIdRequest);
                }
                Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["e" /* arrForEach */])(Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["N" /* objKeys */])(_headers), function (headerName) {
                    xhr.setRequestHeader(headerName, _headers[headerName]);
                });
                xhr.onreadystatechange = function () { return _self._xhrReadyStateChange(xhr, payload, payload.length); };
                xhr.onerror = function (event) { return _self._onError(payload, _formatErrorMessageXhr(xhr), event); };
                // compose an array of payloads
                var batch = _self._buffer.batchPayloads(payload);
                xhr.send(batch);
                _self._buffer.markAsSent(payload);
            }
            /**
             * Send fetch API request
             * @param payload {string} - The data payload to be sent.
             * @param isAsync {boolean} - not used
             */
            function _fetchSender(payload, isAsync) {
                var endPointUrl = _self._senderConfig.endpointUrl();
                var batch = _self._buffer.batchPayloads(payload);
                var plainTextBatch = new Blob([batch], { type: 'text/plain;charset=UTF-8' });
                var requestHeaders = new Headers();
                // append Sdk-Context request header only in case of breeze endpoint
                if (Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_common__["s" /* isInternalApplicationInsightsEndpoint */])(endPointUrl)) {
                    requestHeaders.append(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_common__["o" /* RequestHeaders */].sdkContextHeader, __WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_common__["o" /* RequestHeaders */].sdkContextHeaderAppIdRequest);
                }
                Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["e" /* arrForEach */])(Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["N" /* objKeys */])(_headers), function (headerName) {
                    requestHeaders.append(headerName, _headers[headerName]);
                });
                var init = {
                    method: "POST",
                    headers: requestHeaders,
                    body: plainTextBatch
                };
                var request = new Request(endPointUrl, init);
                fetch(request).then(function (response) {
                    /**
                     * The Promise returned from fetch() won’t reject on HTTP error status even if the response is an HTTP 404 or 500.
                     * Instead, it will resolve normally (with ok status set to false), and it will only reject on network failure
                     * or if anything prevented the request from completing.
                     */
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }
                    else {
                        response.text().then(function (text) {
                            _checkResponsStatus(response.status, payload, response.url, payload.length, response.statusText, text);
                        });
                        _self._buffer.markAsSent(payload);
                    }
                })["catch"](function (error) {
                    _self._onError(payload, error.message);
                });
            }
            /**
             * Parses the response from the backend.
             * @param response - XMLHttpRequest or XDomainRequest response
             */
            function _parseResponse(response) {
                try {
                    if (response && response !== "") {
                        var result = Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["w" /* getJSON */])().parse(response);
                        if (result && result.itemsReceived && result.itemsReceived >= result.itemsAccepted &&
                            result.itemsReceived - result.itemsAccepted === result.errors.length) {
                            return result;
                        }
                    }
                }
                catch (e) {
                    _self.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].InvalidBackendResponse, "Cannot parse the response. " + Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["s" /* getExceptionName */])(e), {
                        response: response
                    });
                }
                return null;
            }
            /**
             * Resend payload. Adds payload back to the send buffer and setup a send timer (with exponential backoff).
             * @param payload
             */
            function _resendPayload(payload, linearFactor) {
                if (linearFactor === void 0) { linearFactor = 1; }
                if (!payload || payload.length === 0) {
                    return;
                }
                _self._buffer.clearSent(payload);
                _consecutiveErrors++;
                for (var _i = 0, payload_1 = payload; _i < payload_1.length; _i++) {
                    var item = payload_1[_i];
                    _self._buffer.enqueue(item);
                }
                // setup timer
                _setRetryTime(linearFactor);
                _setupTimer();
            }
            /**
             * Calculates the time to wait before retrying in case of an error based on
             * http://en.wikipedia.org/wiki/Exponential_backoff
             */
            function _setRetryTime(linearFactor) {
                var SlotDelayInSeconds = 10;
                var delayInSeconds;
                if (_consecutiveErrors <= 1) {
                    delayInSeconds = SlotDelayInSeconds;
                }
                else {
                    var backOffSlot = (Math.pow(2, _consecutiveErrors) - 1) / 2;
                    // tslint:disable-next-line:insecure-random
                    var backOffDelay = Math.floor(Math.random() * backOffSlot * SlotDelayInSeconds) + 1;
                    backOffDelay = linearFactor * backOffDelay;
                    delayInSeconds = Math.max(Math.min(backOffDelay, 3600), SlotDelayInSeconds);
                }
                // TODO: Log the backoff time like the C# version does.
                var retryAfterTimeSpan = Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["l" /* dateNow */])() + (delayInSeconds * 1000);
                // TODO: Log the retry at time like the C# version does.
                _retryAt = retryAfterTimeSpan;
            }
            /**
             * Sets up the timer which triggers actually sending the data.
             */
            function _setupTimer() {
                if (!_timeoutHandle) {
                    var retryInterval = _retryAt ? Math.max(0, _retryAt - Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["l" /* dateNow */])()) : 0;
                    var timerValue = Math.max(_self._senderConfig.maxBatchInterval(), retryInterval);
                    _timeoutHandle = setTimeout(function () {
                        _self.triggerSend(true, null, 1 /* NormalSchedule */);
                    }, timerValue);
                }
            }
            /**
             * Checks if the SDK should resend the payload after receiving this status code from the backend.
             * @param statusCode
             */
            function _isRetriable(statusCode) {
                return statusCode === 408 // Timeout
                    || statusCode === 429 // Too many requests.
                    || statusCode === 500 // Internal server error.
                    || statusCode === 503; // Service unavailable.
            }
            function _formatErrorMessageXhr(xhr, message) {
                if (xhr) {
                    return "XMLHttpRequest,Status:" + xhr.status + ",Response:" + _getResponseText(xhr) || xhr.response || "";
                }
                return message;
            }
            /**
             * Send XDomainRequest
             * @param payload {string} - The data payload to be sent.
             * @param isAsync {boolean} - Indicates if the request should be sent asynchronously
             *
             * Note: XDomainRequest does not support sync requests. This 'isAsync' parameter is added
             * to maintain consistency with the xhrSender's contract
             * Note: XDomainRequest does not support custom headers and we are not able to get
             * appId from the backend for the correct correlation.
             */
            function _xdrSender(payload, isAsync) {
                var _window = Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["z" /* getWindow */])();
                var xdr = new XDomainRequest();
                xdr.onload = function () { return _self._xdrOnLoad(xdr, payload); };
                xdr.onerror = function (event) { return _self._onError(payload, _formatErrorMessageXdr(xdr), event); };
                // XDomainRequest requires the same protocol as the hosting page.
                // If the protocol doesn't match, we can't send the telemetry :(.
                var hostingProtocol = _window && _window.location && _window.location.protocol || "";
                if (_self._senderConfig.endpointUrl().lastIndexOf(hostingProtocol, 0) !== 0) {
                    _self.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].TransmissionFailed, ". " +
                        "Cannot send XDomain request. The endpoint URL protocol doesn't match the hosting page protocol.");
                    _self._buffer.clear();
                    return;
                }
                var endpointUrl = _self._senderConfig.endpointUrl().replace(/^(https?:)/, "");
                xdr.open('POST', endpointUrl);
                // compose an array of payloads
                var batch = _self._buffer.batchPayloads(payload);
                xdr.send(batch);
                _self._buffer.markAsSent(payload);
            }
            function _formatErrorMessageXdr(xdr, message) {
                if (xdr) {
                    return "XDomainRequest,Response:" + _getResponseText(xdr) || "";
                }
                return message;
            }
            // Using function lookups for backward compatibility as the getNotifyMgr() did not exist until after v2.5.6
            function _getNotifyMgr() {
                var func = 'getNotifyMgr';
                if (_self.core[func]) {
                    return _self.core[func]();
                }
                // using _self.core['_notificationManager'] for backward compatibility
                return _self.core['_notificationManager'];
            }
            function _notifySendRequest(sendRequest, isAsync) {
                var manager = _getNotifyMgr();
                if (manager && manager.eventsSendRequest) {
                    try {
                        manager.eventsSendRequest(sendRequest, isAsync);
                    }
                    catch (e) {
                        _self.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].NotificationException, "send request notification failed: " + Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["s" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["o" /* dumpObj */])(e) });
                    }
                }
            }
            /**
             * Validate UUID Format
             * Specs taken from https://tools.ietf.org/html/rfc4122 and breeze repo
             */
            function _validateInstrumentationKey(config) {
                var disableIKeyValidationFlag = Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["F" /* isNullOrUndefined */])(config.disableInstrumentationKeyValidation) ? false : config.disableInstrumentationKeyValidation;
                if (disableIKeyValidationFlag) {
                    return true;
                }
                var UUID_Regex = '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$';
                var regexp = new RegExp(UUID_Regex);
                return regexp.test(config.instrumentationKey);
            }
        });
        return _this;
    }
    Sender.constructEnvelope = function (orig, iKey, logger) {
        var envelope;
        if (iKey !== orig.iKey && !Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["F" /* isNullOrUndefined */])(iKey)) {
            envelope = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["f" /* __assignFn */])({}, orig, { iKey: iKey });
        }
        else {
            envelope = orig;
        }
        switch (envelope.baseType) {
            case __WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_common__["g" /* Event */].dataType:
                return __WEBPACK_IMPORTED_MODULE_2__EnvelopeCreator__["b" /* EventEnvelopeCreator */].EventEnvelopeCreator.Create(logger, envelope);
            case __WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_common__["q" /* Trace */].dataType:
                return __WEBPACK_IMPORTED_MODULE_2__EnvelopeCreator__["g" /* TraceEnvelopeCreator */].TraceEnvelopeCreator.Create(logger, envelope);
            case __WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_common__["k" /* PageView */].dataType:
                return __WEBPACK_IMPORTED_MODULE_2__EnvelopeCreator__["e" /* PageViewEnvelopeCreator */].PageViewEnvelopeCreator.Create(logger, envelope);
            case __WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_common__["l" /* PageViewPerformance */].dataType:
                return __WEBPACK_IMPORTED_MODULE_2__EnvelopeCreator__["f" /* PageViewPerformanceEnvelopeCreator */].PageViewPerformanceEnvelopeCreator.Create(logger, envelope);
            case __WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_common__["h" /* Exception */].dataType:
                return __WEBPACK_IMPORTED_MODULE_2__EnvelopeCreator__["c" /* ExceptionEnvelopeCreator */].ExceptionEnvelopeCreator.Create(logger, envelope);
            case __WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_common__["j" /* Metric */].dataType:
                return __WEBPACK_IMPORTED_MODULE_2__EnvelopeCreator__["d" /* MetricEnvelopeCreator */].MetricEnvelopeCreator.Create(logger, envelope);
            case __WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_common__["n" /* RemoteDependencyData */].dataType:
                return __WEBPACK_IMPORTED_MODULE_2__EnvelopeCreator__["a" /* DependencyEnvelopeCreator */].DependencyEnvelopeCreator.Create(logger, envelope);
            default:
                return __WEBPACK_IMPORTED_MODULE_2__EnvelopeCreator__["b" /* EventEnvelopeCreator */].EventEnvelopeCreator.Create(logger, envelope);
        }
    };
    Sender._getDefaultAppInsightsChannelConfig = function () {
        // set default values
        return {
            endpointUrl: function () { return "https://dc.services.visualstudio.com/v2/track"; },
            emitLineDelimitedJson: function () { return false; },
            maxBatchInterval: function () { return 15000; },
            maxBatchSizeInBytes: function () { return 102400; },
            disableTelemetry: function () { return false; },
            enableSessionStorageBuffer: function () { return true; },
            isRetryDisabled: function () { return false; },
            isBeaconApiDisabled: function () { return true; },
            onunloadDisableBeacon: function () { return false; },
            instrumentationKey: function () { return undefined; },
            namePrefix: function () { return undefined; },
            samplingPercentage: function () { return 100; },
            customHeaders: function () { return undefined; }
        };
    };
    Sender._getEmptyAppInsightsChannelConfig = function () {
        return {
            endpointUrl: undefined,
            emitLineDelimitedJson: undefined,
            maxBatchInterval: undefined,
            maxBatchSizeInBytes: undefined,
            disableTelemetry: undefined,
            enableSessionStorageBuffer: undefined,
            isRetryDisabled: undefined,
            isBeaconApiDisabled: undefined,
            onunloadDisableBeacon: undefined,
            instrumentationKey: undefined,
            namePrefix: undefined,
            samplingPercentage: undefined,
            customHeaders: undefined
        };
    };
// Removed Stub for Sender.prototype.pause.
// Removed Stub for Sender.prototype.resume.
// Removed Stub for Sender.prototype.flush.
// Removed Stub for Sender.prototype.onunloadFlush.
// Removed Stub for Sender.prototype.teardown.
// Removed Stub for Sender.prototype.initialize.
// Removed Stub for Sender.prototype.processTelemetry.
// Removed Stub for Sender.prototype._xhrReadyStateChange.
// Removed Stub for Sender.prototype.triggerSend.
// Removed Stub for Sender.prototype._onError.
// Removed Stub for Sender.prototype._onPartialSuccess.
// Removed Stub for Sender.prototype._onSuccess.
// Removed Stub for Sender.prototype._xdrOnLoad.
// Removed Stub for Sender.prototype.addHeader.
    return Sender;
}(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["a" /* BaseTelemetryPlugin */]));

//# sourceMappingURL=Sender.js.map

/***/ }),
/* 1421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ArraySendBuffer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SessionStorageSendBuffer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__microsoft_dynamicproto_js__ = __webpack_require__(97);
/*
 * Application Insights JavaScript SDK - Channel, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



/*
 * An array based send buffer.
 */
var ArraySendBuffer = /** @class */ (function () {
    function ArraySendBuffer(config) {
        var _buffer = [];
        Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_dynamicproto_js__["a" /* default */])(ArraySendBuffer, this, function (_self) {
            _self.enqueue = function (payload) {
                _buffer.push(payload);
            };
            _self.count = function () {
                return _buffer.length;
            };
            _self.clear = function () {
                _buffer.length = 0;
            };
            _self.getItems = function () {
                return _buffer.slice(0);
            };
            _self.batchPayloads = function (payload) {
                if (payload && payload.length > 0) {
                    var batch = config.emitLineDelimitedJson() ?
                        payload.join("\n") :
                        "[" + payload.join(",") + "]";
                    return batch;
                }
                return null;
            };
            _self.markAsSent = function (payload) {
                _self.clear();
            };
            _self.clearSent = function (payload) {
                // not supported
            };
        });
    }
// Removed Stub for ArraySendBuffer.prototype.enqueue.
// Removed Stub for ArraySendBuffer.prototype.count.
// Removed Stub for ArraySendBuffer.prototype.clear.
// Removed Stub for ArraySendBuffer.prototype.getItems.
// Removed Stub for ArraySendBuffer.prototype.batchPayloads.
// Removed Stub for ArraySendBuffer.prototype.markAsSent.
// Removed Stub for ArraySendBuffer.prototype.clearSent.
    return ArraySendBuffer;
}());

/*
 * Session storage buffer holds a copy of all unsent items in the browser session storage.
 */
var SessionStorageSendBuffer = /** @class */ (function () {
    function SessionStorageSendBuffer(logger, config) {
        var _bufferFullMessageSent = false;
        // An in-memory copy of the buffer. A copy is saved to the session storage on enqueue() and clear().
        // The buffer is restored in a constructor and contains unsent events from a previous page.
        var _buffer;
        Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_dynamicproto_js__["a" /* default */])(SessionStorageSendBuffer, this, function (_self) {
            var bufferItems = _getBuffer(SessionStorageSendBuffer.BUFFER_KEY);
            var notDeliveredItems = _getBuffer(SessionStorageSendBuffer.SENT_BUFFER_KEY);
            _buffer = bufferItems.concat(notDeliveredItems);
            // If the buffer has too many items, drop items from the end.
            if (_buffer.length > SessionStorageSendBuffer.MAX_BUFFER_SIZE) {
                _buffer.length = SessionStorageSendBuffer.MAX_BUFFER_SIZE;
            }
            _setBuffer(SessionStorageSendBuffer.SENT_BUFFER_KEY, []);
            _setBuffer(SessionStorageSendBuffer.BUFFER_KEY, _buffer);
            _self.enqueue = function (payload) {
                if (_buffer.length >= SessionStorageSendBuffer.MAX_BUFFER_SIZE) {
                    // sent internal log only once per page view
                    if (!_bufferFullMessageSent) {
                        logger.throwInternal(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].SessionStorageBufferFull, "Maximum buffer size reached: " + _buffer.length, true);
                        _bufferFullMessageSent = true;
                    }
                    return;
                }
                _buffer.push(payload);
                _setBuffer(SessionStorageSendBuffer.BUFFER_KEY, _buffer);
            };
            _self.count = function () {
                return _buffer.length;
            };
            _self.clear = function () {
                _buffer = [];
                _setBuffer(SessionStorageSendBuffer.BUFFER_KEY, []);
                _setBuffer(SessionStorageSendBuffer.SENT_BUFFER_KEY, []);
                _bufferFullMessageSent = false;
            };
            _self.getItems = function () {
                return _buffer.slice(0);
            };
            _self.batchPayloads = function (payload) {
                if (payload && payload.length > 0) {
                    var batch = config.emitLineDelimitedJson() ?
                        payload.join("\n") :
                        "[" + payload.join(",") + "]";
                    return batch;
                }
                return null;
            };
            _self.markAsSent = function (payload) {
                _buffer = _removePayloadsFromBuffer(payload, _buffer);
                _setBuffer(SessionStorageSendBuffer.BUFFER_KEY, _buffer);
                var sentElements = _getBuffer(SessionStorageSendBuffer.SENT_BUFFER_KEY);
                if (sentElements instanceof Array && payload instanceof Array) {
                    sentElements = sentElements.concat(payload);
                    if (sentElements.length > SessionStorageSendBuffer.MAX_BUFFER_SIZE) {
                        // We send telemetry normally. If the SENT_BUFFER is too big we don't add new elements
                        // until we receive a response from the backend and the buffer has free space again (see clearSent method)
                        logger.throwInternal(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].SessionStorageBufferFull, "Sent buffer reached its maximum size: " + sentElements.length, true);
                        sentElements.length = SessionStorageSendBuffer.MAX_BUFFER_SIZE;
                    }
                    _setBuffer(SessionStorageSendBuffer.SENT_BUFFER_KEY, sentElements);
                }
            };
            _self.clearSent = function (payload) {
                var sentElements = _getBuffer(SessionStorageSendBuffer.SENT_BUFFER_KEY);
                sentElements = _removePayloadsFromBuffer(payload, sentElements);
                _setBuffer(SessionStorageSendBuffer.SENT_BUFFER_KEY, sentElements);
            };
            function _removePayloadsFromBuffer(payloads, buffer) {
                var remaining = [];
                Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["e" /* arrForEach */])(buffer, function (value) {
                    if (!Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["E" /* isFunction */])(value) && Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["f" /* arrIndexOf */])(payloads, value) === -1) {
                        remaining.push(value);
                    }
                });
                return remaining;
            }
            function _getBuffer(key) {
                var prefixedKey = key;
                try {
                    prefixedKey = config.namePrefix && config.namePrefix() ? config.namePrefix() + "_" + prefixedKey : prefixedKey;
                    var bufferJson = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["u" /* utlGetSessionStorage */])(logger, prefixedKey);
                    if (bufferJson) {
                        var buffer = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["w" /* getJSON */])().parse(bufferJson);
                        if (Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["I" /* isString */])(buffer)) {
                            // When using some version prototype.js the stringify / parse cycle does not decode array's correctly
                            buffer = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["w" /* getJSON */])().parse(buffer);
                        }
                        if (buffer && Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["B" /* isArray */])(buffer)) {
                            return buffer;
                        }
                    }
                }
                catch (e) {
                    logger.throwInternal(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].FailedToRestoreStorageBuffer, " storage key: " + prefixedKey + ", " + Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["s" /* getExceptionName */])(e), { exception: Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["o" /* dumpObj */])(e) });
                }
                return [];
            }
            function _setBuffer(key, buffer) {
                var prefixedKey = key;
                try {
                    prefixedKey = config.namePrefix && config.namePrefix() ? config.namePrefix() + "_" + prefixedKey : prefixedKey;
                    var bufferJson = JSON.stringify(buffer);
                    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["v" /* utlSetSessionStorage */])(logger, prefixedKey, bufferJson);
                }
                catch (e) {
                    // if there was an error, clear the buffer
                    // telemetry is stored in the _buffer array so we won't loose any items
                    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["v" /* utlSetSessionStorage */])(logger, prefixedKey, JSON.stringify([]));
                    logger.throwInternal(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].FailedToSetStorageBuffer, " storage key: " + prefixedKey + ", " + Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["s" /* getExceptionName */])(e) + ". Buffer cleared", { exception: Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["o" /* dumpObj */])(e) });
                }
            }
        });
    }
// Removed Stub for SessionStorageSendBuffer.prototype.enqueue.
// Removed Stub for SessionStorageSendBuffer.prototype.count.
// Removed Stub for SessionStorageSendBuffer.prototype.clear.
// Removed Stub for SessionStorageSendBuffer.prototype.getItems.
// Removed Stub for SessionStorageSendBuffer.prototype.batchPayloads.
// Removed Stub for SessionStorageSendBuffer.prototype.markAsSent.
// Removed Stub for SessionStorageSendBuffer.prototype.clearSent.
    SessionStorageSendBuffer.BUFFER_KEY = "AI_buffer";
    SessionStorageSendBuffer.SENT_BUFFER_KEY = "AI_sentBuffer";
    // Maximum number of payloads stored in the buffer. If the buffer is full, new elements will be dropped.
    SessionStorageSendBuffer.MAX_BUFFER_SIZE = 2000;
    return SessionStorageSendBuffer;
}());

//# sourceMappingURL=SendBuffer.js.map

/***/ }),
/* 1422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MinChannelPriorty */
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var MinChannelPriorty = 100;
//# sourceMappingURL=IChannelControls.js.map

/***/ }),
/* 1423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AppInsightsCore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseCore__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JavaScriptSDK_Enums_EventsDiscardedReason__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NotificationManager__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PerfManager__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DiagnosticLogger__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__microsoft_dynamicproto_js__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__HelperFuncs__ = __webpack_require__(43);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */








"use strict";
var AppInsightsCore = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(AppInsightsCore, _super);
    function AppInsightsCore() {
        var _this = _super.call(this) || this;
        Object(__WEBPACK_IMPORTED_MODULE_6__microsoft_dynamicproto_js__["a" /* default */])(AppInsightsCore, _this, function (_self, _base) {
            _self.initialize = function (config, extensions, logger, notificationManager) {
                _base.initialize(config, extensions, logger || new __WEBPACK_IMPORTED_MODULE_5__DiagnosticLogger__["a" /* DiagnosticLogger */](config), notificationManager || new __WEBPACK_IMPORTED_MODULE_3__NotificationManager__["a" /* NotificationManager */](config));
            };
            _self.track = function (telemetryItem) {
                Object(__WEBPACK_IMPORTED_MODULE_4__PerfManager__["b" /* doPerf */])(_self.getPerfMgr(), function () { return "AppInsightsCore:track"; }, function () {
                    if (telemetryItem === null) {
                        _notifyInvalidEvent(telemetryItem);
                        // throw error
                        Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["H" /* throwError */])("Invalid telemetry item");
                    }
                    // do basic validation before sending it through the pipeline
                    _validateTelemetryItem(telemetryItem);
                    _base.track(telemetryItem);
                }, function () { return ({ item: telemetryItem }); }, !(telemetryItem.sync));
            };
            /**
             * Adds a notification listener. The SDK calls methods on the listener when an appropriate notification is raised.
             * The added plugins must raise notifications. If the plugins do not implement the notifications, then no methods will be
             * called.
             * @param {INotificationListener} listener - An INotificationListener object.
             */
            _self.addNotificationListener = function (listener) {
                var manager = _self.getNotifyMgr();
                if (manager) {
                    manager.addNotificationListener(listener);
                }
            };
            /**
             * Removes all instances of the listener.
             * @param {INotificationListener} listener - INotificationListener to remove.
             */
            _self.removeNotificationListener = function (listener) {
                var manager = _self.getNotifyMgr();
                if (manager) {
                    manager.removeNotificationListener(listener);
                }
            };
            /**
             * Periodically check logger.queue for
             */
            _self.pollInternalLogs = function (eventName) {
                var interval = _self.config.diagnosticLogInterval;
                if (!interval || !(interval > 0)) {
                    interval = 10000;
                }
                return setInterval(function () {
                    var queue = _self.logger ? _self.logger.queue : [];
                    Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["a" /* arrForEach */])(queue, function (logMessage) {
                        var item = {
                            name: eventName ? eventName : "InternalMessageId: " + logMessage.messageId,
                            iKey: _self.config.instrumentationKey,
                            time: Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["I" /* toISOString */])(new Date()),
                            baseType: __WEBPACK_IMPORTED_MODULE_5__DiagnosticLogger__["b" /* _InternalLogMessage */].dataType,
                            baseData: { message: logMessage.message }
                        };
                        _self.track(item);
                    });
                    queue.length = 0;
                }, interval);
            };
            function _validateTelemetryItem(telemetryItem) {
                if (Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["s" /* isNullOrUndefined */])(telemetryItem.name)) {
                    _notifyInvalidEvent(telemetryItem);
                    throw Error("telemetry name required");
                }
            }
            function _notifyInvalidEvent(telemetryItem) {
                var manager = _self.getNotifyMgr();
                if (manager) {
                    manager.eventsDiscarded([telemetryItem], __WEBPACK_IMPORTED_MODULE_2__JavaScriptSDK_Enums_EventsDiscardedReason__["a" /* EventsDiscardedReason */].InvalidEvent);
                }
            }
        });
        return _this;
    }
// Removed Stub for AppInsightsCore.prototype.initialize.
// Removed Stub for AppInsightsCore.prototype.track.
// Removed Stub for AppInsightsCore.prototype.addNotificationListener.
// Removed Stub for AppInsightsCore.prototype.removeNotificationListener.
// Removed Stub for AppInsightsCore.prototype.pollInternalLogs.
    return AppInsightsCore;
}(__WEBPACK_IMPORTED_MODULE_1__BaseCore__["a" /* BaseCore */]));

//# sourceMappingURL=AppInsightsCore.js.map

/***/ }),
/* 1424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChannelController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseTelemetryPlugin__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProcessTelemetryContext__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TelemetryHelpers__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HelperFuncs__ = __webpack_require__(43);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */









var ChannelControllerPriority = 500;
var ChannelValidationMessage = "Channel has invalid priority";
var ChannelController = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(ChannelController, _super);
    function ChannelController() {
        var _this = _super.call(this) || this;
        _this.identifier = "ChannelControllerPlugin";
        _this.priority = ChannelControllerPriority; // in reserved range 100 to 200
        var _channelQueue;
        Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__["a" /* default */])(ChannelController, _this, function (_self, _base) {
            _self.setNextPlugin = function (next) {
                // The Channel controller is last in pipeline
            };
            _self.processTelemetry = function (item, itemCtx) {
                if (_channelQueue) {
                    Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["a" /* arrForEach */])(_channelQueue, function (queues) {
                        // pass on to first item in queue
                        if (queues.length > 0) {
                            // Copying the item context as we could have mutiple chains that are executing asynchronously
                            // and calling _getDefTelCtx as it's possible that the caller doesn't pass any context
                            var chainCtx = _this._getTelCtx(itemCtx).createNew(queues);
                            chainCtx.processNext(item);
                        }
                    });
                }
            };
            _self.getChannelControls = function () {
                return _channelQueue;
            };
            _self.initialize = function (config, core, extensions) {
                if (_self.isInitialized()) {
                    // already initialized
                    return;
                }
                _base.initialize(config, core, extensions);
                _createChannelQueues((config || {}).channels, extensions);
                // Initialize the Queues
                Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["a" /* arrForEach */])(_channelQueue, function (queue) { return Object(__WEBPACK_IMPORTED_MODULE_4__TelemetryHelpers__["a" /* initializePlugins */])(new __WEBPACK_IMPORTED_MODULE_3__ProcessTelemetryContext__["a" /* ProcessTelemetryContext */](queue, config, core), extensions); });
            };
        });
        function _checkQueuePriority(queue) {
            Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["a" /* arrForEach */])(queue, function (queueItem) {
                if (queueItem.priority < ChannelControllerPriority) {
                    Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["H" /* throwError */])(ChannelValidationMessage + queueItem.identifier);
                }
            });
        }
        function _addChannelQueue(queue) {
            if (queue && queue.length > 0) {
                queue = queue.sort(function (a, b) {
                    return a.priority - b.priority;
                });
                _checkQueuePriority(queue);
                _channelQueue.push(queue);
            }
        }
        function _createChannelQueues(channels, extensions) {
            _channelQueue = [];
            if (channels) {
                // Add and sort the configuration channel queues
                Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["a" /* arrForEach */])(channels, function (queue) { return _addChannelQueue(queue); });
            }
            if (extensions) {
                // Create a new channel queue for any extensions with a priority > the ChannelControllerPriority
                var extensionQueue_1 = [];
                Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["a" /* arrForEach */])(extensions, function (plugin) {
                    if (plugin.priority > ChannelControllerPriority) {
                        extensionQueue_1.push(plugin);
                    }
                });
                _addChannelQueue(extensionQueue_1);
            }
        }
        return _this;
    }
// Removed Stub for ChannelController.prototype.processTelemetry.
    ;
// Removed Stub for ChannelController.prototype.getChannelControls.
// Removed Stub for ChannelController.prototype.initialize.
    /**
     * Static constructor, attempt to create accessors
     */
    // tslint:disable-next-line
    ChannelController._staticInit = (function () {
        var proto = ChannelController.prototype;
        // Dynamically create get/set property accessors
        Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["z" /* objDefineAccessors */])(proto, "ChannelControls", proto.getChannelControls);
        Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["z" /* objDefineAccessors */])(proto, "channelQueue", proto.getChannelControls);
    })();
    return ChannelController;
}(__WEBPACK_IMPORTED_MODULE_2__BaseTelemetryPlugin__["a" /* BaseTelemetryPlugin */]));

//# sourceMappingURL=ChannelController.js.map

/***/ }),
/* 1425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TelemetryPluginChain; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PerfManager__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JavaScriptSDK_Enums_LoggingEnums__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__ = __webpack_require__(43);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var TelemetryPluginChain = /** @class */ (function () {
    function TelemetryPluginChain(plugin, defItemCtx) {
        var _self = this;
        var _nextProxy = null;
        var _hasProcessTelemetry = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["p" /* isFunction */])(plugin.processTelemetry);
        var _hasSetNext = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["p" /* isFunction */])(plugin.setNextPlugin);
        _self._hasRun = false;
        _self.getPlugin = function () {
            return plugin;
        };
        _self.getNext = function () {
            return _nextProxy;
        };
        _self.setNext = function (nextPlugin) {
            _nextProxy = nextPlugin;
        };
        _self.processTelemetry = function (env, itemCtx) {
            if (!itemCtx) {
                // Looks like a plugin didn't pass the (optional) context, so restore to the default
                itemCtx = defItemCtx;
            }
            var identifier = plugin ? plugin.identifier : "TelemetryPluginChain";
            Object(__WEBPACK_IMPORTED_MODULE_0__PerfManager__["b" /* doPerf */])(itemCtx ? itemCtx.core() : null, function () { return identifier + ":processTelemetry"; }, function () {
                if (plugin && _hasProcessTelemetry) {
                    _self._hasRun = true;
                    try {
                        // Ensure that we keep the context in sync (for processNext()), just in case a plugin
                        // doesn't calls processTelemetry() instead of itemContext.processNext() or some 
                        // other form of error occurred
                        itemCtx.setNext(_nextProxy);
                        if (_hasSetNext) {
                            // Backward compatibility setting the next plugin on the instance
                            plugin.setNextPlugin(_nextProxy);
                        }
                        // Set a flag on the next plugin so we know if it was attempted to be executed
                        _nextProxy && (_nextProxy._hasRun = false);
                        plugin.processTelemetry(env, itemCtx);
                    }
                    catch (error) {
                        var hasRun = _nextProxy && _nextProxy._hasRun;
                        if (!_nextProxy || !hasRun) {
                            // Either we have no next plugin or the current one did not attempt to call the next plugin
                            // Which means the current one is the root of the failure so log/report this failure
                            itemCtx.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_1__JavaScriptSDK_Enums_LoggingEnums__["a" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_1__JavaScriptSDK_Enums_LoggingEnums__["b" /* _InternalMessageId */].PluginException, "Plugin [" + plugin.identifier + "] failed during processTelemetry - " + error);
                        }
                        if (_nextProxy && !hasRun) {
                            // As part of the failure the current plugin did not attempt to call the next plugin in the cahin
                            // So rather than leave the pipeline dead in the water we call the next plugin
                            _nextProxy.processTelemetry(env, itemCtx);
                        }
                    }
                }
                else if (_nextProxy) {
                    _self._hasRun = true;
                    // The underlying plugin is either not defined or does not have a processTelemetry implementation
                    // so we still want the next plugin to be executed.
                    _nextProxy.processTelemetry(env, itemCtx);
                }
            }, function () { return ({ item: env }); }, !(env.sync));
        };
    }
    return TelemetryPluginChain;
}());

//# sourceMappingURL=TelemetryPluginChain.js.map

/***/ }),
/* 1426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Undefined */
/* unused harmony export addEventHandler */
/* unused harmony export newGuid */
/* unused harmony export perfNow */
/* harmony export (immutable) */ __webpack_exports__["g"] = newId;
/* unused harmony export strEndsWith */
/* harmony export (immutable) */ __webpack_exports__["e"] = generateW3CId;
/* unused harmony export CoreUtils */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventHelper; });
/* unused harmony export _legacyCookieMgr */
/* harmony export (immutable) */ __webpack_exports__["d"] = disableCookies;
/* harmony export (immutable) */ __webpack_exports__["b"] = canUseCookies;
/* harmony export (immutable) */ __webpack_exports__["f"] = getCookie;
/* harmony export (immutable) */ __webpack_exports__["h"] = setCookie;
/* harmony export (immutable) */ __webpack_exports__["c"] = deleteCookie;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CookieMgr__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EnvUtils__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RandomHelper__ = __webpack_require__(567);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */








var _cookieMgrs = null;
var _canUseCookies; // legacy supported config
// Added to help with minfication
var Undefined = __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["m" /* strShimUndefined */];
/**
 * Trys to add an event handler for the specified event to the window, body and document
 * @param eventName {string} - The name of the event
 * @param callback {any} - The callback function that needs to be executed for the given event
 * @return {boolean} - true if the handler was successfully added
 */
function addEventHandler(eventName, callback) {
    var result = false;
    var w = Object(__WEBPACK_IMPORTED_MODULE_2__EnvUtils__["l" /* getWindow */])();
    if (w) {
        result = Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["e" /* attachEvent */])(w, eventName, callback);
        result = Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["e" /* attachEvent */])(w["body"], eventName, callback) || result;
    }
    var doc = Object(__WEBPACK_IMPORTED_MODULE_2__EnvUtils__["d" /* getDocument */])();
    if (doc) {
        result = EventHelper.Attach(doc, eventName, callback) || result;
    }
    return result;
}
function newGuid() {
    function randomHexDigit() {
        return Object(__WEBPACK_IMPORTED_MODULE_4__RandomHelper__["d" /* randomValue */])(15); // Get a random value from 0..15
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(GuidRegex, function (c) {
        var r = (randomHexDigit() | 0), v = (c === 'x' ? r : r & 0x3 | 0x8);
        return v.toString(16);
    });
}
/**
 * Return the current value of the Performance Api now() function (if available) and fallback to dateNow() if it is unavailable (IE9 or less)
 * https://caniuse.com/#search=performance.now
 */
function perfNow() {
    var perf = Object(__WEBPACK_IMPORTED_MODULE_2__EnvUtils__["k" /* getPerformance */])();
    if (perf && perf.now) {
        return perf.now();
    }
    return Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["g" /* dateNow */])();
}
/**
 * Generate random base64 id string.
 * The default length is 22 which is 132-bits so almost the same as a GUID but as base64 (the previous default was 5)
 * @param maxLength - Optional value to specify the length of the id to be generated, defaults to 22
 */
function newId(maxLength) {
    if (maxLength === void 0) { maxLength = 22; }
    var base64chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Start with an initial random number, consuming the value in reverse byte order
    var number = Object(__WEBPACK_IMPORTED_MODULE_4__RandomHelper__["c" /* random32 */])() >>> 0; // Make sure it's a +ve number
    var chars = 0;
    var result = "";
    while (result.length < maxLength) {
        chars++;
        result += base64chars.charAt(number & 0x3F);
        number >>>= 6; // Zero fill with right shift
        if (chars === 5) {
            // 5 base64 characters === 30 bits so we don't have enough bits for another base64 char
            // So add on another 30 bits and make sure it's +ve
            number = (((Object(__WEBPACK_IMPORTED_MODULE_4__RandomHelper__["c" /* random32 */])() << 2) & 0xFFFFFFFF) | (number & 0x03)) >>> 0;
            chars = 0; // We need to reset the number every 5 chars (30 bits)
        }
    }
    return result;
}
/**
 * The strEndsWith() method determines whether a string ends with the characters of a specified string, returning true or false as appropriate.
 * @param value - The value to check whether it ends with the search value.
 * @param search - The characters to be searched for at the end of the value.
 * @returns true if the given search value is found at the end of the string, otherwise false.
 */
function strEndsWith(value, search) {
    if (value && search) {
        var len = value.length;
        var start = len - search.length;
        return value.substring(start >= 0 ? start : 0, len) === search;
    }
    return false;
}
/**
 * generate W3C trace id
 */
function generateW3CId() {
    var hexValues = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
    // rfc4122 version 4 UUID without dashes and with lowercase letters
    var oct = "", tmp;
    for (var a = 0; a < 4; a++) {
        tmp = Object(__WEBPACK_IMPORTED_MODULE_4__RandomHelper__["c" /* random32 */])();
        oct +=
            hexValues[tmp & 0xF] +
                hexValues[tmp >> 4 & 0xF] +
                hexValues[tmp >> 8 & 0xF] +
                hexValues[tmp >> 12 & 0xF] +
                hexValues[tmp >> 16 & 0xF] +
                hexValues[tmp >> 20 & 0xF] +
                hexValues[tmp >> 24 & 0xF] +
                hexValues[tmp >> 28 & 0xF];
    }
    // "Set the two most significant bits (bits 6 and 7) of the clock_seq_hi_and_reserved to zero and one, respectively"
    var clockSequenceHi = hexValues[8 + (Object(__WEBPACK_IMPORTED_MODULE_4__RandomHelper__["c" /* random32 */])() & 0x03) | 0];
    return oct.substr(0, 8) + oct.substr(9, 4) + "4" + oct.substr(13, 3) + clockSequenceHi + oct.substr(16, 3) + oct.substr(19, 12);
}
/**
 * Provides a collection of utility functions, included for backward compatibility with previous releases.
 * @deprecated Marking this instance as deprecated in favor of direct usage of the helper functions
 * as direct usage provides better tree-shaking and minification by avoiding the inclusion of the unused items
 * in your resulting code.
 */
var CoreUtils = {
    _canUseCookies: undefined,
    isTypeof: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["x" /* isTypeof */],
    isUndefined: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["y" /* isUndefined */],
    isNullOrUndefined: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["s" /* isNullOrUndefined */],
    hasOwnProperty: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["k" /* hasOwnProperty */],
    isFunction: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["p" /* isFunction */],
    isObject: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["u" /* isObject */],
    isDate: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["n" /* isDate */],
    isArray: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["l" /* isArray */],
    isError: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["o" /* isError */],
    isString: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["v" /* isString */],
    isNumber: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["t" /* isNumber */],
    isBoolean: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["m" /* isBoolean */],
    toISOString: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["I" /* toISOString */],
    arrForEach: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["a" /* arrForEach */],
    arrIndexOf: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["b" /* arrIndexOf */],
    arrMap: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["c" /* arrMap */],
    arrReduce: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["d" /* arrReduce */],
    strTrim: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["G" /* strTrim */],
    objCreate: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["i" /* objCreateFn */],
    objKeys: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["B" /* objKeys */],
    objDefineAccessors: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["z" /* objDefineAccessors */],
    addEventHandler: addEventHandler,
    dateNow: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["g" /* dateNow */],
    isIE: __WEBPACK_IMPORTED_MODULE_2__EnvUtils__["n" /* isIE */],
    disableCookies: disableCookies,
    newGuid: newGuid,
    perfNow: perfNow,
    newId: newId,
    randomValue: __WEBPACK_IMPORTED_MODULE_4__RandomHelper__["d" /* randomValue */],
    random32: __WEBPACK_IMPORTED_MODULE_4__RandomHelper__["c" /* random32 */],
    mwcRandomSeed: __WEBPACK_IMPORTED_MODULE_4__RandomHelper__["b" /* mwcRandomSeed */],
    mwcRandom32: __WEBPACK_IMPORTED_MODULE_4__RandomHelper__["a" /* mwcRandom32 */],
    generateW3CId: generateW3CId
};
var GuidRegex = /[xy]/g;
var EventHelper = {
    Attach: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["e" /* attachEvent */],
    AttachEvent: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["e" /* attachEvent */],
    Detach: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["h" /* detachEvent */],
    DetachEvent: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["h" /* detachEvent */]
};
/**
 * Helper to support backward compatibility for users that use the legacy cookie handling functions and the use the internal
 * CoreUtils._canUseCookies global flag to enable/disable cookies usage.
 * Note: This has the following deliberate side-effects
 * - Creates the global (legacy) cookie manager if it does not already exist
 * - Attempts to add "listeners" to the CoreUtils._canUseCookies property to support the legacy usage
 * @param config
 * @param logger
 * @returns
 */
function _legacyCookieMgr(config, logger) {
    var cookieMgr = Object(__WEBPACK_IMPORTED_MODULE_1__CookieMgr__["a" /* _gblCookieMgr */])(config, logger);
    var legacyCanUseCookies = CoreUtils._canUseCookies;
    if (_cookieMgrs === null) {
        _cookieMgrs = [];
        _canUseCookies = legacyCanUseCookies;
        // Dynamically create get/set property accessors for backward compatibility for enabling / disabling cookies
        // this WILL NOT work for ES3 browsers (< IE8)
        Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["z" /* objDefineAccessors */])(CoreUtils, "_canUseCookies", function () {
            return _canUseCookies;
        }, function (value) {
            _canUseCookies = value;
            Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["a" /* arrForEach */])(_cookieMgrs, function (mgr) {
                mgr.setEnabled(value);
            });
        });
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["b" /* arrIndexOf */])(_cookieMgrs, cookieMgr) === -1) {
        _cookieMgrs.push(cookieMgr);
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["m" /* isBoolean */])(legacyCanUseCookies)) {
        cookieMgr.setEnabled(legacyCanUseCookies);
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["m" /* isBoolean */])(_canUseCookies)) {
        cookieMgr.setEnabled(_canUseCookies);
    }
    return cookieMgr;
}
/**
 * @deprecated - Use the core.getCookieMgr().disable()
 * Force the SDK not to store and read any data from cookies.
 */
function disableCookies() {
    _legacyCookieMgr().setEnabled(false);
}
/**
 * @deprecated - Use the core.getCookieMgr().isEnabled()
 * Helper method to tell if document.cookie object is available and whether it can be used.
 */
function canUseCookies(logger) {
    return _legacyCookieMgr(null, logger).isEnabled();
}
/**
 * @deprecated - Use the core.getCookieMgr().get()
 * helper method to access userId and sessionId cookie
 */
function getCookie(logger, name) {
    return _legacyCookieMgr(null, logger).get(name);
}
/**
 * @deprecated - Use the core.getCookieMgr().set()
 * helper method to set userId and sessionId cookie
 */
function setCookie(logger, name, value, domain) {
    _legacyCookieMgr(null, logger).set(name, value, null, domain);
}
/**
 * @deprecated - Use the core.getCookieMgr().del()
 * Deletes a cookie by setting it's expiration time in the past.
 * @param name - The name of the cookie to delete.
 */
function deleteCookie(logger, name) {
    return _legacyCookieMgr(null, logger).del(name);
}
//# sourceMappingURL=CoreUtils.js.map

/***/ }),
/* 1427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InstrumentProto */
/* unused harmony export InstrumentProtos */
/* unused harmony export InstrumentFunc */
/* unused harmony export InstrumentFuncs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HelperFuncs__ = __webpack_require__(43);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var aiInstrumentHooks = "_aiHooks";
;
var cbNames = [
    "req", "rsp", "hkErr", "fnErr"
];
/**
 * Constant string defined to support minimization
 * @ignore
 */
var str__Proto = "__proto__";
/**
 * Constant string defined to support minimization
 * @ignore
 */
var strConstructor = "constructor";
/** @ignore */
function _arrLoop(arr, fn) {
    if (arr) {
        for (var lp = 0; lp < arr.length; lp++) {
            if (fn(arr[lp], lp)) {
                break;
            }
        }
    }
}
/** @ignore */
function _doCallbacks(hooks, callDetails, cbArgs, hookCtx, type) {
    if (type >= 0 /* Request */ && type <= 2 /* HookError */) {
        _arrLoop(hooks, function (hook, idx) {
            var cbks = hook.cbks;
            var cb = cbks[cbNames[type]];
            if (cb) {
                // Set the specific hook context implementation using a lazy creation pattern
                callDetails.ctx = function () {
                    var ctx = hookCtx[idx] = (hookCtx[idx] || {});
                    return ctx;
                };
                try {
                    cb.apply(callDetails.inst, cbArgs);
                }
                catch (err) {
                    var orgEx = callDetails.err;
                    try {
                        // Report Hook error via the callback
                        var hookErrorCb = cbks[cbNames[2 /* HookError */]];
                        if (hookErrorCb) {
                            callDetails.err = err;
                            hookErrorCb.apply(callDetails.inst, cbArgs);
                        }
                    }
                    catch (e) {
                        // Not much we can do here -- swallowing the exception to avoid crashing the hosting app
                    }
                    finally {
                        // restore the original exception (if any)
                        callDetails.err = orgEx;
                    }
                }
            }
        });
    }
}
/** @ignore */
function _createFunctionHook(aiHook) {
    // Define a temporary method that queues-up a the real method call
    return function () {
        var funcThis = this;
        // Capture the original arguments passed to the method
        var orgArgs = arguments;
        var hooks = aiHook.h;
        var funcArgs = {
            name: aiHook.n,
            inst: funcThis,
            ctx: null,
            set: _replaceArg
        };
        var hookCtx = [];
        var cbArgs = _createArgs([funcArgs], orgArgs);
        function _createArgs(target, theArgs) {
            _arrLoop(theArgs, function (arg) {
                target.push(arg);
            });
            return target;
        }
        function _replaceArg(idx, value) {
            orgArgs = _createArgs([], orgArgs);
            orgArgs[idx] = value;
            cbArgs = _createArgs([funcArgs], orgArgs);
        }
        // Call the pre-request hooks
        _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 0 /* Request */);
        // Call the original function was called
        var theFunc = aiHook.f;
        try {
            funcArgs.rslt = theFunc.apply(funcThis, orgArgs);
        }
        catch (err) {
            // Report the request callback
            funcArgs.err = err;
            _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 3 /* FunctionError */);
            // rethrow the original exception so anyone listening for it can catch the exception
            throw err;
        }
        // Call the post-request hooks
        _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 1 /* Response */);
        return funcArgs.rslt;
    };
}
/**
 * Pre-lookup to check if we are running on a modern browser (i.e. not IE8)
 * @ignore
 */
var _objGetPrototypeOf = Object["getPrototypeOf"];
/**
 * Helper used to get the prototype of the target object as getPrototypeOf is not available in an ES3 environment.
 * @ignore
 */
function _getObjProto(target) {
    if (target) {
        // This method doesn't existing in older browsers (e.g. IE8)
        if (_objGetPrototypeOf) {
            return _objGetPrototypeOf(target);
        }
        // target[Constructor] May break if the constructor has been changed or removed
        var newProto = target[str__Proto] || target[__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["l" /* strShimPrototype */]] || target[strConstructor];
        if (newProto) {
            return newProto;
        }
    }
    return null;
}
/** @ignore */
function _getOwner(target, name, checkPrototype) {
    var owner = null;
    if (target) {
        if (Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["k" /* hasOwnProperty */])(target, name)) {
            owner = target;
        }
        else if (checkPrototype) {
            owner = _getOwner(_getObjProto(target), name, false);
        }
    }
    return owner;
}
/**
 * Intercept the named prototype functions for the target class / object
 * @param target - The target object
 * @param funcName - The function name
 * @param callbacks - The callbacks to configure and call whenever the function is called
 */
function InstrumentProto(target, funcName, callbacks) {
    if (target) {
        return InstrumentFunc(target[__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["l" /* strShimPrototype */]], funcName, callbacks, false);
    }
    return null;
}
/**
 * Intercept the named prototype functions for the target class / object
 * @param target - The target object
 * @param funcNames - The function names to intercept and call
 * @param callbacks - The callbacks to configure and call whenever the function is called
 */
function InstrumentProtos(target, funcNames, callbacks) {
    if (target) {
        return InstrumentFuncs(target[__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["l" /* strShimPrototype */]], funcNames, callbacks, false);
    }
    return null;
}
/**
 * Intercept the named prototype functions for the target class / object
 * @param target - The target object
 * @param funcName - The function name
 * @param callbacks - The callbacks to configure and call whenever the function is called
 * @param checkPrototype - If the function doesn't exist on the target should it attempt to hook the prototype function
 */
function InstrumentFunc(target, funcName, callbacks, checkPrototype) {
    if (checkPrototype === void 0) { checkPrototype = true; }
    if (target && funcName && callbacks) {
        var owner = _getOwner(target, funcName, checkPrototype);
        if (owner) {
            var fn = owner[funcName];
            if (typeof fn === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["j" /* strShimFunction */]) {
                var aiHook_1 = fn[aiInstrumentHooks];
                if (!aiHook_1) {
                    // Only hook the function once
                    aiHook_1 = {
                        i: 0,
                        n: funcName,
                        f: fn,
                        h: []
                    };
                    // Override (hook) the original function
                    var newFunc = _createFunctionHook(aiHook_1);
                    newFunc[aiInstrumentHooks] = aiHook_1; // Tag and store the function hooks
                    owner[funcName] = newFunc;
                }
                var theHook = {
                    // tslint:disable:object-literal-shorthand
                    id: aiHook_1.i,
                    cbks: callbacks,
                    rm: function () {
                        // DO NOT Use () => { shorthand for the function as the this gets replaced
                        // with the outer this and not the this for theHook instance.
                        var id = this.id;
                        _arrLoop(aiHook_1.h, function (hook, idx) {
                            if (hook.id === id) {
                                aiHook_1.h.splice(idx, 1);
                                return 1;
                            }
                        });
                    }
                    // tslint:enable:object-literal-shorthand
                };
                aiHook_1.i++;
                aiHook_1.h.push(theHook);
                return theHook;
            }
        }
    }
    return null;
}
/**
 * Intercept the named functions for the target class / object
 * @param target - The target object
 * @param funcNames - The function names to intercept and call
 * @param callbacks - The callbacks to configure and call whenever the function is called
 * @param checkPrototype - If the function doesn't exist on the target should it attempt to hook the prototype function
 */
function InstrumentFuncs(target, funcNames, callbacks, checkPrototype) {
    if (checkPrototype === void 0) { checkPrototype = true; }
    var hooks = null;
    _arrLoop(funcNames, function (funcName) {
        var hook = InstrumentFunc(target, funcName, callbacks, checkPrototype);
        if (hook) {
            if (!hooks) {
                hooks = [];
            }
            hooks.push(hook);
        }
    });
    return hooks;
}
//# sourceMappingURL=InstrumentHooks.js.map

/***/ }),
/* 1428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export parseConnectionString */
/* unused harmony export ConnectionStringParser */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__ = __webpack_require__(30);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var _FIELDS_SEPARATOR = ";";
var _FIELD_KEY_VALUE_SEPARATOR = "=";
function parseConnectionString(connectionString) {
    if (!connectionString) {
        return {};
    }
    var kvPairs = connectionString.split(_FIELDS_SEPARATOR);
    var result = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["h" /* arrReduce */])(kvPairs, function (fields, kv) {
        var kvParts = kv.split(_FIELD_KEY_VALUE_SEPARATOR);
        if (kvParts.length === 2) {
            var key = kvParts[0].toLowerCase();
            var value = kvParts[1];
            fields[key] = value;
        }
        return fields;
    }, {});
    if (Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["N" /* objKeys */])(result).length > 0) {
        // this is a valid connection string, so parse the results
        if (result.endpointsuffix) {
            // use endpoint suffix where overrides are not provided
            var locationPrefix = result.location ? result.location + "." : "";
            result.ingestionendpoint = result.ingestionendpoint || ("https://" + locationPrefix + "dc." + result.endpointsuffix);
        }
        // apply the default endpoints
        result.ingestionendpoint = result.ingestionendpoint || __WEBPACK_IMPORTED_MODULE_0__Constants__["a" /* DEFAULT_BREEZE_ENDPOINT */];
    }
    return result;
}
var ConnectionStringParser = {
    parse: parseConnectionString
};
//# sourceMappingURL=ConnectionStringParser.js.map

/***/ }),
/* 1429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Envelope; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_Envelope__ = __webpack_require__(1430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DataSanitizer__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Constants__ = __webpack_require__(79);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







var Envelope = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(Envelope, _super);
    /**
     * Constructs a new instance of telemetry data.
     */
    function Envelope(logger, data, name) {
        var _this = _super.call(this) || this;
        _this.name = Object(__WEBPACK_IMPORTED_MODULE_2__DataSanitizer__["f" /* dataSanitizeString */])(logger, name) || __WEBPACK_IMPORTED_MODULE_4__Constants__["f" /* strNotSpecified */];
        _this.data = data;
        _this.time = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["V" /* toISOString */])(new Date());
        _this.aiDataContract = {
            time: 1 /* Required */,
            iKey: 1 /* Required */,
            name: 1 /* Required */,
            sampleRate: function () {
                return (_this.sampleRate === 100) ? 4 /* Hidden */ : 1 /* Required */;
            },
            tags: 1 /* Required */,
            data: 1 /* Required */
        };
        return _this;
    }
    return Envelope;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_Envelope__["a" /* Envelope */]));

//# sourceMappingURL=Envelope.js.map

/***/ }),
/* 1430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Envelope; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * System variables for a telemetry item.
 */
var Envelope = /** @class */ (function () {
    function Envelope() {
        /**
         * Envelope version. For internal use only. By assigning this the default, it will not be serialized within the payload unless changed to a value other than #1.
         */
        this.ver = 1;
        /**
         * Sampling rate used in application. This telemetry item represents 1 / sampleRate actual telemetry items.
         */
        this.sampleRate = 100.0;
        /**
         * Key/value collection of context properties. See ContextTagKeys for information on available properties.
         */
        this.tags = {};
    }
    return Envelope;
}());

//# sourceMappingURL=Envelope.js.map

/***/ }),
/* 1431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Event; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_EventData__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Constants__ = __webpack_require__(79);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var Event = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(Event, _super);
    /**
     * Constructs a new instance of the EventTelemetry object
     */
    function Event(logger, name, properties, measurements) {
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            ver: 1 /* Required */,
            name: 1 /* Required */,
            properties: 0 /* Default */,
            measurements: 0 /* Default */
        };
        _this.name = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, name) || __WEBPACK_IMPORTED_MODULE_3__Constants__["f" /* strNotSpecified */];
        _this.properties = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["e" /* dataSanitizeProperties */])(logger, properties);
        _this.measurements = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["c" /* dataSanitizeMeasurements */])(logger, measurements);
        return _this;
    }
    Event.envelopeType = "Microsoft.ApplicationInsights.{0}.Event";
    Event.dataType = "EventData";
    return Event;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_EventData__["a" /* EventData */]));

//# sourceMappingURL=Event.js.map

/***/ }),
/* 1432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export _formatErrorCode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Exception; });
/* unused harmony export _ExceptionDetails */
/* unused harmony export _StackFrame */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_StackFrame__ = __webpack_require__(1433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Interfaces_Contracts_Generated_ExceptionData__ = __webpack_require__(1434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Interfaces_Contracts_Generated_ExceptionDetails__ = __webpack_require__(1435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Common_DataSanitizer__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Constants__ = __webpack_require__(79);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */









var NoMethod = "<no_method>";
var strError = "error";
var strStack = "stack";
var strStackDetails = "stackDetails";
var strErrorSrc = "errorSrc";
var strMessage = "message";
var strDescription = "description";
function _stringify(value, convertToString) {
    var result = value;
    if (result && !Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["I" /* isString */])(result)) {
        if (JSON && JSON.stringify) {
            result = JSON.stringify(value);
            if (convertToString && (!result || result === "{}")) {
                if (Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["E" /* isFunction */])(value.toString)) {
                    result = value.toString();
                }
                else {
                    result = "" + value;
                }
            }
        }
        else {
            result = "" + value + " - (Missing JSON.stringify)";
        }
    }
    return result || "";
}
function _formatMessage(theEvent, errorType) {
    var evtMessage = theEvent;
    if (theEvent) {
        evtMessage = theEvent[strMessage] || theEvent[strDescription] || "";
        // Make sure the message is a string
        if (evtMessage && !Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["I" /* isString */])(evtMessage)) {
            // tslint:disable-next-line: prefer-conditional-expression
            evtMessage = _stringify(evtMessage, true);
        }
        if (theEvent["filename"]) {
            // Looks like an event object with filename
            evtMessage = evtMessage + " @" + (theEvent["filename"] || "") + ":" + (theEvent["lineno"] || "?") + ":" + (theEvent["colno"] || "?");
        }
    }
    // Automatically add the error type to the message if it does already appear to be present
    if (errorType && errorType !== "String" && errorType !== "Object" && errorType !== "Error" && (evtMessage || "").indexOf(errorType) === -1) {
        evtMessage = errorType + ": " + evtMessage;
    }
    return evtMessage || "";
}
function _isExceptionDetailsInternal(value) {
    if (Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["H" /* isObject */])(value)) {
        return "hasFullStack" in value && "typeName" in value;
    }
    return false;
}
function _isExceptionInternal(value) {
    if (Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["H" /* isObject */])(value)) {
        return ("ver" in value && "exceptions" in value && "properties" in value);
    }
    return false;
}
function _isStackDetails(details) {
    return details && details.src && Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["I" /* isString */])(details.src) && details.obj && Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["B" /* isArray */])(details.obj);
}
function _convertStackObj(errorStack) {
    var src = errorStack || "";
    if (!Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["I" /* isString */])(src)) {
        if (Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["I" /* isString */])(src[strStack])) {
            src = src[strStack];
        }
        else {
            src = "" + src;
        }
    }
    var items = src.split("\n");
    return {
        src: src,
        obj: items
    };
}
function _getOperaStack(errorMessage) {
    var stack = [];
    var lines = errorMessage.split("\n");
    for (var lp = 0; lp < lines.length; lp++) {
        var entry = lines[lp];
        if (lines[lp + 1]) {
            entry += "@" + lines[lp + 1];
            lp++;
        }
        stack.push(entry);
    }
    return {
        src: errorMessage,
        obj: stack
    };
}
function _getStackFromErrorObj(errorObj) {
    var details = null;
    if (errorObj) {
        try {
            /* Using bracket notation is support older browsers (IE 7/8 -- dont remember the version) that throw when using dot
            notation for undefined objects and we don't want to loose the error from being reported */
            if (errorObj[strStack]) {
                // Chrome/Firefox
                details = _convertStackObj(errorObj[strStack]);
            }
            else if (errorObj[strError] && errorObj[strError][strStack]) {
                // Edge error event provides the stack and error object
                details = _convertStackObj(errorObj[strError][strStack]);
            }
            else if (errorObj['exception'] && errorObj.exception[strStack]) {
                details = _convertStackObj(errorObj.exception[strStack]);
            }
            else if (_isStackDetails(errorObj)) {
                details = errorObj;
            }
            else if (_isStackDetails(errorObj[strStackDetails])) {
                details = errorObj[strStackDetails];
            }
            else if (window['opera'] && errorObj[strMessage]) {
                // Opera
                details = _getOperaStack(errorObj.message);
            }
            else if (Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["I" /* isString */])(errorObj)) {
                details = _convertStackObj(errorObj);
            }
            else {
                var evtMessage = errorObj[strMessage] || errorObj[strDescription] || "";
                if (Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["I" /* isString */])(errorObj[strErrorSrc])) {
                    if (evtMessage) {
                        evtMessage += "\n";
                    }
                    evtMessage += " from " + errorObj[strErrorSrc];
                }
                if (evtMessage) {
                    details = _convertStackObj(evtMessage);
                }
            }
        }
        catch (e) {
            // something unexpected happened so to avoid failing to report any error lets swallow the exception 
            // and fallback to the callee/caller method
            details = _convertStackObj(e);
        }
    }
    return details || {
        src: "",
        obj: null
    };
}
function _formatStackTrace(stackDetails) {
    var stack = "";
    if (stackDetails) {
        if (stackDetails.obj) {
            Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["e" /* arrForEach */])(stackDetails.obj, function (entry) {
                stack += entry + "\n";
            });
        }
        else {
            stack = stackDetails.src || "";
        }
    }
    return stack;
}
function _parseStack(stack) {
    var parsedStack;
    var frames = stack.obj;
    if (frames && frames.length > 0) {
        parsedStack = [];
        var level_1 = 0;
        var totalSizeInBytes_1 = 0;
        Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["e" /* arrForEach */])(frames, function (frame) {
            var theFrame = frame.toString();
            if (_StackFrame.regex.test(theFrame)) {
                var parsedFrame = new _StackFrame(theFrame, level_1++);
                totalSizeInBytes_1 += parsedFrame.sizeInBytes;
                parsedStack.push(parsedFrame);
            }
        });
        // DP Constraint - exception parsed stack must be < 32KB
        // remove frames from the middle to meet the threshold
        var exceptionParsedStackThreshold = 32 * 1024;
        if (totalSizeInBytes_1 > exceptionParsedStackThreshold) {
            var left = 0;
            var right = parsedStack.length - 1;
            var size = 0;
            var acceptedLeft = left;
            var acceptedRight = right;
            while (left < right) {
                // check size
                var lSize = parsedStack[left].sizeInBytes;
                var rSize = parsedStack[right].sizeInBytes;
                size += lSize + rSize;
                if (size > exceptionParsedStackThreshold) {
                    // remove extra frames from the middle
                    var howMany = acceptedRight - acceptedLeft + 1;
                    parsedStack.splice(acceptedLeft, howMany);
                    break;
                }
                // update pointers
                acceptedLeft = left;
                acceptedRight = right;
                left++;
                right--;
            }
        }
    }
    return parsedStack;
}
function _getErrorType(errorType) {
    // Gets the Error Type by passing the constructor (used to get the true type of native error object).
    var typeName = "";
    if (errorType) {
        typeName = errorType.typeName || errorType.name || "";
        if (!typeName) {
            try {
                var funcNameRegex = /function (.{1,})\(/;
                var results = (funcNameRegex).exec((errorType).constructor.toString());
                typeName = (results && results.length > 1) ? results[1] : "";
            }
            catch (e) {
                // Ignore
            }
        }
    }
    return typeName;
}
/**
 * Formats the provided errorObj for display and reporting, it may be a String, Object, integer or undefined depending on the browser.
 * @param errorObj The supplied errorObj
 */
function _formatErrorCode(errorObj) {
    if (errorObj) {
        try {
            if (!Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["I" /* isString */])(errorObj)) {
                var errorType = _getErrorType(errorObj);
                var result = _stringify(errorObj, false);
                if (!result || result === "{}") {
                    if (errorObj[strError]) {
                        // Looks like an MS Error Event
                        errorObj = errorObj[strError];
                        errorType = _getErrorType(errorObj);
                    }
                    result = _stringify(errorObj, true);
                }
                if (result.indexOf(errorType) !== 0 && errorType !== "String") {
                    return errorType + ":" + result;
                }
                return result;
            }
        }
        catch (e) {
        }
    }
    // Fallback to just letting the object format itself into a string
    return "" + (errorObj || "");
}
var Exception = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(Exception, _super);
    /**
     * Constructs a new instance of the ExceptionTelemetry object
     */
    function Exception(logger, exception, properties, measurements, severityLevel, id) {
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            ver: 1 /* Required */,
            exceptions: 1 /* Required */,
            severityLevel: 0 /* Default */,
            properties: 0 /* Default */,
            measurements: 0 /* Default */
        };
        if (!_isExceptionInternal(exception)) {
            if (!properties) {
                properties = {};
            }
            _this.exceptions = [new _ExceptionDetails(logger, exception, properties)];
            _this.properties = Object(__WEBPACK_IMPORTED_MODULE_4__Common_DataSanitizer__["e" /* dataSanitizeProperties */])(logger, properties);
            _this.measurements = Object(__WEBPACK_IMPORTED_MODULE_4__Common_DataSanitizer__["c" /* dataSanitizeMeasurements */])(logger, measurements);
            if (severityLevel) {
                _this.severityLevel = severityLevel;
            }
            if (id) {
                _this.id = id;
            }
        }
        else {
            _this.exceptions = exception.exceptions;
            _this.properties = exception.properties;
            _this.measurements = exception.measurements;
            if (exception.severityLevel) {
                _this.severityLevel = exception.severityLevel;
            }
            if (exception.id) {
                _this.id = exception.id;
            }
            if (exception.problemGroup) {
                _this.problemGroup = exception.problemGroup;
            }
            // bool/int types, use isNullOrUndefined
            _this.ver = 2; // TODO: handle the CS"4.0" ==> breeze 2 conversion in a better way
            if (!Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["F" /* isNullOrUndefined */])(exception.isManual)) {
                _this.isManual = exception.isManual;
            }
        }
        return _this;
    }
    Exception.CreateAutoException = function (message, url, lineNumber, columnNumber, error, evt, stack, errorSrc) {
        var errorType = _getErrorType(error || evt || message);
        return {
            message: _formatMessage(message, errorType),
            url: url,
            lineNumber: lineNumber,
            columnNumber: columnNumber,
            error: _formatErrorCode(error || evt || message),
            evt: _formatErrorCode(evt || message),
            typeName: errorType,
            stackDetails: _getStackFromErrorObj(stack || error || evt),
            errorSrc: errorSrc
        };
    };
    Exception.CreateFromInterface = function (logger, exception, properties, measurements) {
        var exceptions = exception.exceptions
            && Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["g" /* arrMap */])(exception.exceptions, function (ex) { return _ExceptionDetails.CreateFromInterface(logger, ex); });
        var exceptionData = new Exception(logger, Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["f" /* __assignFn */])({}, exception, { exceptions: exceptions }), properties, measurements);
        return exceptionData;
    };
    Exception.prototype.toInterface = function () {
        var _a = this, exceptions = _a.exceptions, properties = _a.properties, measurements = _a.measurements, severityLevel = _a.severityLevel, ver = _a.ver, problemGroup = _a.problemGroup, id = _a.id, isManual = _a.isManual;
        var exceptionDetailsInterface = exceptions instanceof Array
            && Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["g" /* arrMap */])(exceptions, function (exception) { return exception.toInterface(); })
            || undefined;
        return {
            ver: "4.0",
            exceptions: exceptionDetailsInterface,
            severityLevel: severityLevel,
            properties: properties,
            measurements: measurements,
            problemGroup: problemGroup,
            id: id,
            isManual: isManual
        };
    };
    /**
     * Creates a simple exception with 1 stack frame. Useful for manual constracting of exception.
     */
    Exception.CreateSimpleException = function (message, typeName, assembly, fileName, details, line) {
        return {
            exceptions: [
                {
                    hasFullStack: true,
                    message: message,
                    stack: details,
                    typeName: typeName
                }
            ]
        };
    };
    Exception.envelopeType = "Microsoft.ApplicationInsights.{0}.Exception";
    Exception.dataType = "ExceptionData";
    Exception.formatError = _formatErrorCode;
    return Exception;
}(__WEBPACK_IMPORTED_MODULE_2__Interfaces_Contracts_Generated_ExceptionData__["a" /* ExceptionData */]));

var _ExceptionDetails = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(_ExceptionDetails, _super);
    function _ExceptionDetails(logger, exception, properties) {
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            id: 0 /* Default */,
            outerId: 0 /* Default */,
            typeName: 1 /* Required */,
            message: 1 /* Required */,
            hasFullStack: 0 /* Default */,
            stack: 0 /* Default */,
            parsedStack: 2 /* Array */
        };
        if (!_isExceptionDetailsInternal(exception)) {
            var error = exception;
            var evt = error && error.evt;
            if (!Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["D" /* isError */])(error)) {
                error = error[strError] || evt || error;
            }
            _this.typeName = Object(__WEBPACK_IMPORTED_MODULE_4__Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, _getErrorType(error)) || __WEBPACK_IMPORTED_MODULE_6__Constants__["f" /* strNotSpecified */];
            _this.message = Object(__WEBPACK_IMPORTED_MODULE_4__Common_DataSanitizer__["d" /* dataSanitizeMessage */])(logger, _formatMessage(exception || error, _this.typeName)) || __WEBPACK_IMPORTED_MODULE_6__Constants__["f" /* strNotSpecified */];
            var stack = exception[strStackDetails] || _getStackFromErrorObj(exception);
            _this.parsedStack = _parseStack(stack);
            _this[strStack] = Object(__WEBPACK_IMPORTED_MODULE_4__Common_DataSanitizer__["a" /* dataSanitizeException */])(logger, _formatStackTrace(stack));
            _this.hasFullStack = Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["B" /* isArray */])(_this.parsedStack) && _this.parsedStack.length > 0;
            if (properties) {
                properties.typeName = properties.typeName || _this.typeName;
            }
        }
        else {
            _this.typeName = exception.typeName;
            _this.message = exception.message;
            _this[strStack] = exception[strStack];
            _this.parsedStack = exception.parsedStack;
            _this.hasFullStack = exception.hasFullStack;
        }
        return _this;
    }
    _ExceptionDetails.prototype.toInterface = function () {
        var parsedStack = this.parsedStack instanceof Array
            && Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["g" /* arrMap */])(this.parsedStack, function (frame) { return frame.toInterface(); });
        var exceptionDetailsInterface = {
            id: this.id,
            outerId: this.outerId,
            typeName: this.typeName,
            message: this.message,
            hasFullStack: this.hasFullStack,
            stack: this[strStack],
            parsedStack: parsedStack || undefined
        };
        return exceptionDetailsInterface;
    };
    _ExceptionDetails.CreateFromInterface = function (logger, exception) {
        var parsedStack = (exception.parsedStack instanceof Array
            && Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["g" /* arrMap */])(exception.parsedStack, function (frame) { return _StackFrame.CreateFromInterface(frame); }))
            || exception.parsedStack;
        var exceptionDetails = new _ExceptionDetails(logger, Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["f" /* __assignFn */])({}, exception, { parsedStack: parsedStack }));
        return exceptionDetails;
    };
    return _ExceptionDetails;
}(__WEBPACK_IMPORTED_MODULE_3__Interfaces_Contracts_Generated_ExceptionDetails__["a" /* ExceptionDetails */]));

var _StackFrame = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(_StackFrame, _super);
    function _StackFrame(sourceFrame, level) {
        var _this = _super.call(this) || this;
        _this.sizeInBytes = 0;
        _this.aiDataContract = {
            level: 1 /* Required */,
            method: 1 /* Required */,
            assembly: 0 /* Default */,
            fileName: 0 /* Default */,
            line: 0 /* Default */
        };
        // Not converting this to isString() as typescript uses this logic to "understand" the different
        // types for the 2 different code paths
        if (typeof sourceFrame === "string") {
            var frame = sourceFrame;
            _this.level = level;
            _this.method = NoMethod;
            _this.assembly = Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["T" /* strTrim */])(frame);
            _this.fileName = "";
            _this.line = 0;
            var matches = frame.match(_StackFrame.regex);
            if (matches && matches.length >= 5) {
                _this.method = Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["T" /* strTrim */])(matches[2]) || _this.method;
                _this.fileName = Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["T" /* strTrim */])(matches[4]);
                _this.line = parseInt(matches[5]) || 0;
            }
        }
        else {
            _this.level = sourceFrame.level;
            _this.method = sourceFrame.method;
            _this.assembly = sourceFrame.assembly;
            _this.fileName = sourceFrame.fileName;
            _this.line = sourceFrame.line;
            _this.sizeInBytes = 0;
        }
        _this.sizeInBytes += _this.method.length;
        _this.sizeInBytes += _this.fileName.length;
        _this.sizeInBytes += _this.assembly.length;
        // todo: these might need to be removed depending on how the back-end settles on their size calculation
        _this.sizeInBytes += _StackFrame.baseSize;
        _this.sizeInBytes += _this.level.toString().length;
        _this.sizeInBytes += _this.line.toString().length;
        return _this;
    }
    _StackFrame.CreateFromInterface = function (frame) {
        return new _StackFrame(frame, null /* level is available in frame interface */);
    };
    _StackFrame.prototype.toInterface = function () {
        return {
            level: this.level,
            method: this.method,
            assembly: this.assembly,
            fileName: this.fileName,
            line: this.line
        };
    };
    // regex to match stack frames from ie/chrome/ff
    // methodName=$2, fileName=$4, lineNo=$5, column=$6
    _StackFrame.regex = /^([\s]+at)?[\s]*([^\@\()]+?)[\s]*(\@|\()([^\(\n]+):([0-9]+):([0-9]+)(\)?)$/;
    _StackFrame.baseSize = 58; // '{"method":"","level":,"assembly":"","fileName":"","line":}'.length
    return _StackFrame;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_StackFrame__["a" /* StackFrame */]));

//# sourceMappingURL=Exception.js.map

/***/ }),
/* 1433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StackFrame; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// THIS FILE WAS AUTOGENERATED
/**
 * Stack frame information.
 */
var StackFrame = /** @class */ (function () {
    function StackFrame() {
    }
    return StackFrame;
}());

//# sourceMappingURL=StackFrame.js.map

/***/ }),
/* 1434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExceptionData; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * An instance of Exception represents a handled or unhandled exception that occurred during execution of the monitored application.
 */
var ExceptionData = /** @class */ (function () {
    function ExceptionData() {
        /**
         * Schema version
         */
        this.ver = 2;
        /**
         * Exception chain - list of inner exceptions.
         */
        this.exceptions = [];
        /**
         * Collection of custom properties.
         */
        this.properties = {};
        /**
         * Collection of custom measurements.
         */
        this.measurements = {};
    }
    return ExceptionData;
}());

//# sourceMappingURL=ExceptionData.js.map

/***/ }),
/* 1435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExceptionDetails; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * Exception details of the exception in a chain.
 */
var ExceptionDetails = /** @class */ (function () {
    function ExceptionDetails() {
        /**
         * Indicates if full exception stack is provided in the exception. The stack may be trimmed, such as in the case of a StackOverflow exception.
         */
        this.hasFullStack = true;
        /**
         * List of stack frames. Either stack or parsedStack should have a value.
         */
        this.parsedStack = [];
    }
    return ExceptionDetails;
}());

//# sourceMappingURL=ExceptionDetails.js.map

/***/ }),
/* 1436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Metric; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_MetricData__ = __webpack_require__(1437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Common_DataPoint__ = __webpack_require__(1438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Constants__ = __webpack_require__(79);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







var Metric = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(Metric, _super);
    /**
     * Constructs a new instance of the MetricTelemetry object
     */
    function Metric(logger, name, value, count, min, max, properties, measurements) {
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            ver: 1 /* Required */,
            metrics: 1 /* Required */,
            properties: 0 /* Default */
        };
        var dataPoint = new __WEBPACK_IMPORTED_MODULE_3__Common_DataPoint__["a" /* DataPoint */]();
        dataPoint.count = count > 0 ? count : undefined;
        dataPoint.max = isNaN(max) || max === null ? undefined : max;
        dataPoint.min = isNaN(min) || min === null ? undefined : min;
        dataPoint.name = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, name) || __WEBPACK_IMPORTED_MODULE_4__Constants__["f" /* strNotSpecified */];
        dataPoint.value = value;
        _this.metrics = [dataPoint];
        _this.properties = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["e" /* dataSanitizeProperties */])(logger, properties);
        _this.measurements = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["c" /* dataSanitizeMeasurements */])(logger, measurements);
        return _this;
    }
    Metric.envelopeType = "Microsoft.ApplicationInsights.{0}.Metric";
    Metric.dataType = "MetricData";
    return Metric;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_MetricData__["a" /* MetricData */]));

//# sourceMappingURL=Metric.js.map

/***/ }),
/* 1437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MetricData; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * An instance of the Metric item is a list of measurements (single data points) and/or aggregations.
 */
var MetricData = /** @class */ (function () {
    function MetricData() {
        /**
         * Schema version
         */
        this.ver = 2;
        /**
         * List of metrics. Only one metric in the list is currently supported by Application Insights storage. If multiple data points were sent only the first one will be used.
         */
        this.metrics = [];
        /**
         * Collection of custom properties.
         */
        this.properties = {};
        /**
         * Collection of custom measurements.
         */
        this.measurements = {};
    }
    return MetricData;
}());

//# sourceMappingURL=MetricData.js.map

/***/ }),
/* 1438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataPoint; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_DataPoint__ = __webpack_require__(1439);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var DataPoint = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(DataPoint, _super);
    function DataPoint() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * The data contract for serializing this object.
         */
        _this.aiDataContract = {
            name: 1 /* Required */,
            kind: 0 /* Default */,
            value: 1 /* Required */,
            count: 0 /* Default */,
            min: 0 /* Default */,
            max: 0 /* Default */,
            stdDev: 0 /* Default */
        };
        return _this;
    }
    return DataPoint;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_DataPoint__["a" /* DataPoint */]));

//# sourceMappingURL=DataPoint.js.map

/***/ }),
/* 1439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataPoint; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataPointType__ = __webpack_require__(1440);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



/**
 * Metric data single measurement.
 */
var DataPoint = /** @class */ (function () {
    function DataPoint() {
        /**
         * Metric type. Single measurement or the aggregated value.
         */
        this.kind = __WEBPACK_IMPORTED_MODULE_0__DataPointType__["a" /* DataPointType */].Measurement;
    }
    return DataPoint;
}());

//# sourceMappingURL=DataPoint.js.map

/***/ }),
/* 1440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataPointType; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// THIS FILE WAS AUTOGENERATED
/**
 * Type of the metric data measurement.
 */
var DataPointType;
(function (DataPointType) {
    DataPointType[DataPointType["Measurement"] = 0] = "Measurement";
    DataPointType[DataPointType["Aggregation"] = 1] = "Aggregation";
})(DataPointType || (DataPointType = {}));
//# sourceMappingURL=DataPointType.js.map

/***/ }),
/* 1441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_PageViewData__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Constants__ = __webpack_require__(79);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







var PageView = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(PageView, _super);
    /**
     * Constructs a new instance of the PageEventTelemetry object
     */
    function PageView(logger, name, url, durationMs, properties, measurements, id) {
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            ver: 1 /* Required */,
            name: 0 /* Default */,
            url: 0 /* Default */,
            duration: 0 /* Default */,
            properties: 0 /* Default */,
            measurements: 0 /* Default */,
            id: 0 /* Default */
        };
        _this.id = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["b" /* dataSanitizeId */])(logger, id);
        _this.url = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["g" /* dataSanitizeUrl */])(logger, url);
        _this.name = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, name) || __WEBPACK_IMPORTED_MODULE_4__Constants__["f" /* strNotSpecified */];
        if (!isNaN(durationMs)) {
            _this.duration = Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["d" /* msToTimeSpan */])(durationMs);
        }
        _this.properties = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["e" /* dataSanitizeProperties */])(logger, properties);
        _this.measurements = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["c" /* dataSanitizeMeasurements */])(logger, measurements);
        return _this;
    }
    PageView.envelopeType = "Microsoft.ApplicationInsights.{0}.Pageview";
    PageView.dataType = "PageviewData";
    return PageView;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_PageViewData__["a" /* PageViewData */]));

//# sourceMappingURL=PageView.js.map

/***/ }),
/* 1442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RemoteDependencyData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Common_DataSanitizer__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Util__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Interfaces_Contracts_Generated_RemoteDependencyData__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HelperFuncs__ = __webpack_require__(246);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







var RemoteDependencyData = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(RemoteDependencyData, _super);
    /**
     * Constructs a new instance of the RemoteDependencyData object
     */
    function RemoteDependencyData(logger, id, absoluteUrl, commandName, value, success, resultCode, method, requestAPI, correlationContext, properties, measurements) {
        if (requestAPI === void 0) { requestAPI = "Ajax"; }
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            id: 1 /* Required */,
            ver: 1 /* Required */,
            name: 0 /* Default */,
            resultCode: 0 /* Default */,
            duration: 0 /* Default */,
            success: 0 /* Default */,
            data: 0 /* Default */,
            target: 0 /* Default */,
            type: 0 /* Default */,
            properties: 0 /* Default */,
            measurements: 0 /* Default */,
            kind: 0 /* Default */,
            value: 0 /* Default */,
            count: 0 /* Default */,
            min: 0 /* Default */,
            max: 0 /* Default */,
            stdDev: 0 /* Default */,
            dependencyKind: 0 /* Default */,
            dependencySource: 0 /* Default */,
            commandName: 0 /* Default */,
            dependencyTypeName: 0 /* Default */
        };
        _this.id = id;
        _this.duration = Object(__WEBPACK_IMPORTED_MODULE_4__HelperFuncs__["d" /* msToTimeSpan */])(value);
        _this.success = success;
        _this.resultCode = resultCode + "";
        _this.type = Object(__WEBPACK_IMPORTED_MODULE_1__Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, requestAPI);
        var dependencyFields = Object(__WEBPACK_IMPORTED_MODULE_2__Util__["a" /* AjaxHelperParseDependencyPath */])(logger, absoluteUrl, method, commandName);
        _this.data = Object(__WEBPACK_IMPORTED_MODULE_1__Common_DataSanitizer__["g" /* dataSanitizeUrl */])(logger, commandName) || dependencyFields.data; // get a value from hosturl if commandName not available
        _this.target = Object(__WEBPACK_IMPORTED_MODULE_1__Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, dependencyFields.target);
        if (correlationContext) {
            _this.target = _this.target + " | " + correlationContext;
        }
        _this.name = Object(__WEBPACK_IMPORTED_MODULE_1__Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, dependencyFields.name);
        _this.properties = Object(__WEBPACK_IMPORTED_MODULE_1__Common_DataSanitizer__["e" /* dataSanitizeProperties */])(logger, properties);
        _this.measurements = Object(__WEBPACK_IMPORTED_MODULE_1__Common_DataSanitizer__["c" /* dataSanitizeMeasurements */])(logger, measurements);
        return _this;
    }
    RemoteDependencyData.envelopeType = "Microsoft.ApplicationInsights.{0}.RemoteDependency";
    RemoteDependencyData.dataType = "RemoteDependencyData";
    return RemoteDependencyData;
}(__WEBPACK_IMPORTED_MODULE_3__Interfaces_Contracts_Generated_RemoteDependencyData__["a" /* RemoteDependencyData */]));

//# sourceMappingURL=RemoteDependencyData.js.map

/***/ }),
/* 1443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RemoteDependencyData; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * An instance of Remote Dependency represents an interaction of the monitored component with a remote component/service like SQL or an HTTP endpoint.
 */
var RemoteDependencyData = /** @class */ (function () {
    function RemoteDependencyData() {
        /**
         * Schema version
         */
        this.ver = 2;
        /**
         * Indication of successful or unsuccessful call.
         */
        this.success = true;
        /**
         * Collection of custom properties.
         */
        this.properties = {};
        /**
         * Collection of custom measurements.
         */
        this.measurements = {};
    }
    return RemoteDependencyData;
}());

//# sourceMappingURL=RemoteDependencyData.js.map

/***/ }),
/* 1444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Trace; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_MessageData__ = __webpack_require__(1445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Constants__ = __webpack_require__(79);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var Trace = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(Trace, _super);
    /**
     * Constructs a new instance of the TraceTelemetry object
     */
    function Trace(logger, message, severityLevel, properties, measurements) {
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            ver: 1 /* Required */,
            message: 1 /* Required */,
            severityLevel: 0 /* Default */,
            properties: 0 /* Default */
        };
        message = message || __WEBPACK_IMPORTED_MODULE_3__Constants__["f" /* strNotSpecified */];
        _this.message = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["d" /* dataSanitizeMessage */])(logger, message);
        _this.properties = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["e" /* dataSanitizeProperties */])(logger, properties);
        _this.measurements = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["c" /* dataSanitizeMeasurements */])(logger, measurements);
        if (severityLevel) {
            _this.severityLevel = severityLevel;
        }
        return _this;
    }
    Trace.envelopeType = "Microsoft.ApplicationInsights.{0}.Message";
    Trace.dataType = "MessageData";
    return Trace;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_MessageData__["a" /* MessageData */]));

//# sourceMappingURL=Trace.js.map

/***/ }),
/* 1445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MessageData; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * Instances of Message represent printf-like trace statements that are text-searched. Log4Net, NLog and other text-based log file entries are translated into intances of this type. The message does not have measurements.
 */
var MessageData = /** @class */ (function () {
    function MessageData() {
        /**
         * Schema version
         */
        this.ver = 2;
        /**
         * Collection of custom properties.
         */
        this.properties = {};
        /**
         * Collection of custom measurements.
         */
        this.measurements = {};
    }
    return MessageData;
}());

//# sourceMappingURL=MessageData.js.map

/***/ }),
/* 1446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageViewPerformance; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_PageViewPerfData__ = __webpack_require__(1447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Constants__ = __webpack_require__(79);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var PageViewPerformance = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(PageViewPerformance, _super);
    /**
     * Constructs a new instance of the PageEventTelemetry object
     */
    function PageViewPerformance(logger, name, url, unused, properties, measurements, cs4BaseData) {
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            ver: 1 /* Required */,
            name: 0 /* Default */,
            url: 0 /* Default */,
            duration: 0 /* Default */,
            perfTotal: 0 /* Default */,
            networkConnect: 0 /* Default */,
            sentRequest: 0 /* Default */,
            receivedResponse: 0 /* Default */,
            domProcessing: 0 /* Default */,
            properties: 0 /* Default */,
            measurements: 0 /* Default */
        };
        _this.url = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["g" /* dataSanitizeUrl */])(logger, url);
        _this.name = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, name) || __WEBPACK_IMPORTED_MODULE_3__Constants__["f" /* strNotSpecified */];
        _this.properties = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["e" /* dataSanitizeProperties */])(logger, properties);
        _this.measurements = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["c" /* dataSanitizeMeasurements */])(logger, measurements);
        if (cs4BaseData) {
            _this.domProcessing = cs4BaseData.domProcessing;
            _this.duration = cs4BaseData.duration;
            _this.networkConnect = cs4BaseData.networkConnect;
            _this.perfTotal = cs4BaseData.perfTotal;
            _this.receivedResponse = cs4BaseData.receivedResponse;
            _this.sentRequest = cs4BaseData.sentRequest;
        }
        return _this;
    }
    PageViewPerformance.envelopeType = "Microsoft.ApplicationInsights.{0}.PageviewPerformance";
    PageViewPerformance.dataType = "PageviewPerformanceData";
    return PageViewPerformance;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_PageViewPerfData__["a" /* PageViewPerfData */]));

//# sourceMappingURL=PageViewPerformance.js.map

/***/ }),
/* 1447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageViewPerfData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PageViewData__ = __webpack_require__(369);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



// THIS FILE WAS AUTOGENERATED

/**
 * An instance of PageViewPerf represents: a page view with no performance data, a page view with performance data, or just the performance data of an earlier page request.
 */
var PageViewPerfData = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(PageViewPerfData, _super);
    function PageViewPerfData() {
        var _this = _super.call(this) || this;
        /**
         * Schema version
         */
        _this.ver = 2;
        /**
         * Collection of custom properties.
         */
        _this.properties = {};
        /**
         * Collection of custom measurements.
         */
        _this.measurements = {};
        return _this;
    }
    return PageViewPerfData;
}(__WEBPACK_IMPORTED_MODULE_1__PageViewData__["a" /* PageViewData */]));

//# sourceMappingURL=PageViewPerfData.js.map

/***/ }),
/* 1448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Data; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_Data__ = __webpack_require__(573);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var Data = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(Data, _super);
    /**
     * Constructs a new instance of telemetry data.
     */
    function Data(baseType, data) {
        var _this = _super.call(this) || this;
        /**
         * The data contract for serializing this object.
         */
        _this.aiDataContract = {
            baseType: 1 /* Required */,
            baseData: 1 /* Required */
        };
        _this.baseType = baseType;
        _this.baseData = data;
        return _this;
    }
    return Data;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_Data__["a" /* Data */]));

//# sourceMappingURL=Data.js.map

/***/ }),
/* 1449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SeverityLevel */
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// THIS FILE WAS AUTOGENERATED
/**
 * Defines the level of severity for the event.
 */
var SeverityLevel;
(function (SeverityLevel) {
    SeverityLevel[SeverityLevel["Verbose"] = 0] = "Verbose";
    SeverityLevel[SeverityLevel["Information"] = 1] = "Information";
    SeverityLevel[SeverityLevel["Warning"] = 2] = "Warning";
    SeverityLevel[SeverityLevel["Error"] = 3] = "Error";
    SeverityLevel[SeverityLevel["Critical"] = 4] = "Critical";
})(SeverityLevel || (SeverityLevel = {}));
//# sourceMappingURL=SeverityLevel.js.map

/***/ }),
/* 1450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ConfigurationManager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(30);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



var ConfigurationManager = /** @class */ (function () {
    function ConfigurationManager() {
    }
    ConfigurationManager.getConfig = function (config, field, identifier, defaultValue) {
        if (defaultValue === void 0) { defaultValue = false; }
        var configValue;
        if (identifier && config.extensionConfig && config.extensionConfig[identifier] && !Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["F" /* isNullOrUndefined */])(config.extensionConfig[identifier][field])) {
            configValue = config.extensionConfig[identifier][field];
        }
        else {
            configValue = config[field];
        }
        return !Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["F" /* isNullOrUndefined */])(configValue) ? configValue : defaultValue;
    };
    return ConfigurationManager;
}());

//# sourceMappingURL=IConfig.js.map

/***/ }),
/* 1451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TelemetryItemCreator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Telemetry_Common_DataSanitizer__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Constants__ = __webpack_require__(79);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





var TelemetryItemCreator = /** @class */ (function () {
    function TelemetryItemCreator() {
    }
    /**
     * Create a telemetry item that the 1DS channel understands
     * @param item domain specific properties; part B
     * @param baseType telemetry item type. ie PageViewData
     * @param envelopeName name of the envelope. ie Microsoft.ApplicationInsights.<instrumentation key>.PageView
     * @param customProperties user defined custom properties; part C
     * @param systemProperties system properties that are added to the context; part A
     * @returns ITelemetryItem that is sent to channel
     */
    TelemetryItemCreator.create = function (item, baseType, envelopeName, logger, customProperties, systemProperties) {
        envelopeName = Object(__WEBPACK_IMPORTED_MODULE_0__Telemetry_Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, envelopeName) || __WEBPACK_IMPORTED_MODULE_2__Constants__["f" /* strNotSpecified */];
        if (Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["F" /* isNullOrUndefined */])(item) ||
            Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["F" /* isNullOrUndefined */])(baseType) ||
            Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["F" /* isNullOrUndefined */])(envelopeName)) {
            throw Error("Input doesn't contain all required fields");
        }
        var telemetryItem = {
            name: envelopeName,
            time: Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["V" /* toISOString */])(new Date()),
            iKey: "",
            ext: systemProperties ? systemProperties : {},
            tags: [],
            data: {},
            baseType: baseType,
            baseData: item // Part B
        };
        // Part C
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["F" /* isNullOrUndefined */])(customProperties)) {
            Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["M" /* objForEachKey */])(customProperties, function (prop, value) {
                telemetryItem.data[prop] = value;
            });
        }
        return telemetryItem;
    };
    return TelemetryItemCreator;
}());

//# sourceMappingURL=TelemetryItemCreator.js.map

/***/ }),
/* 1452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Extensions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CtxTagKeys; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Contracts_Generated_ContextTagKeys__ = __webpack_require__(576);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var Extensions = {
    UserExt: "user",
    DeviceExt: "device",
    TraceExt: "trace",
    WebExt: "web",
    AppExt: "app",
    OSExt: "os",
    SessionExt: "ses",
    SDKExt: "sdk"
};
var CtxTagKeys = new __WEBPACK_IMPORTED_MODULE_0__Contracts_Generated_ContextTagKeys__["a" /* ContextTagKeys */]();
//# sourceMappingURL=PartAExtensions.js.map

/***/ }),
/* 1453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EnvelopeCreator */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DependencyEnvelopeCreator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EventEnvelopeCreator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ExceptionEnvelopeCreator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MetricEnvelopeCreator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PageViewEnvelopeCreator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PageViewPerformanceEnvelopeCreator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TraceEnvelopeCreator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__ = __webpack_require__(30);
/*
 * Application Insights JavaScript SDK - Channel, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



// these two constants are used to filter out properties not needed when trying to extract custom properties and measurements from the incoming payload
var strBaseType = 'baseType';
var strBaseData = 'baseData';
var strProperties = 'properties';
var strTrue = 'true';
function _setValueIf(target, field, value) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["S" /* setValue */])(target, field, value, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["J" /* isTruthy */]);
}
var EnvelopeCreator = /** @class */ (function () {
    function EnvelopeCreator() {
    }
    EnvelopeCreator.extractPropsAndMeasurements = function (data, properties, measurements) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["F" /* isNullOrUndefined */])(data)) {
            Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["M" /* objForEachKey */])(data, function (key, value) {
                if (Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["G" /* isNumber */])(value)) {
                    measurements[key] = value;
                }
                else if (Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["I" /* isString */])(value)) {
                    properties[key] = value;
                }
                else if (Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["A" /* hasJSON */])()) {
                    properties[key] = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["w" /* getJSON */])().stringify(value);
                }
            });
        }
    };
    // TODO: Do we want this to take logger as arg or use this._logger as nonstatic?
    EnvelopeCreator.createEnvelope = function (logger, envelopeType, telemetryItem, data) {
        var envelope = new __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["f" /* Envelope */](logger, data, envelopeType);
        _setValueIf(envelope, 'sampleRate', telemetryItem[__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["p" /* SampleRate */]]);
        if ((telemetryItem[strBaseData] || {}).startTime) {
            envelope.time = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["V" /* toISOString */])(telemetryItem[strBaseData].startTime);
        }
        envelope.iKey = telemetryItem.iKey;
        var iKeyNoDashes = telemetryItem.iKey.replace(/-/g, "");
        envelope.name = envelope.name.replace("{0}", iKeyNoDashes);
        // extract all extensions from ctx
        EnvelopeCreator.extractPartAExtensions(telemetryItem, envelope);
        // loop through the envelope tags (extension of Part A) and pick out the ones that should go in outgoing envelope tags
        telemetryItem.tags = telemetryItem.tags || [];
        return Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["O" /* optimizeObject */])(envelope);
    };
    /*
     * Maps Part A data from CS 4.0
     */
    EnvelopeCreator.extractPartAExtensions = function (item, env) {
        // todo: switch to keys from common in this method
        var envTags = env.tags = env.tags || {};
        var itmExt = item.ext = item.ext || {};
        var itmTags = item.tags = item.tags || [];
        var extUser = itmExt.user;
        if (extUser) {
            _setValueIf(envTags, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["c" /* CtxTagKeys */].userAuthUserId, extUser.authId);
            _setValueIf(envTags, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["c" /* CtxTagKeys */].userId, extUser.id || extUser.localId);
        }
        var extApp = itmExt.app;
        if (extApp) {
            _setValueIf(envTags, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["c" /* CtxTagKeys */].sessionId, extApp.sesId);
        }
        var extDevice = itmExt.device;
        if (extDevice) {
            _setValueIf(envTags, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["c" /* CtxTagKeys */].deviceId, extDevice.id || extDevice.localId);
            _setValueIf(envTags, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["c" /* CtxTagKeys */].deviceType, extDevice.deviceClass);
            _setValueIf(envTags, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["c" /* CtxTagKeys */].deviceIp, extDevice.ip);
            _setValueIf(envTags, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["c" /* CtxTagKeys */].deviceModel, extDevice.model);
            _setValueIf(envTags, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["c" /* CtxTagKeys */].deviceType, extDevice.deviceType);
        }
        var web = item.ext.web;
        if (web) {
            _setValueIf(envTags, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["c" /* CtxTagKeys */].deviceLanguage, web.browserLang);
            _setValueIf(envTags, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["c" /* CtxTagKeys */].deviceBrowserVersion, web.browserVer);
            _setValueIf(envTags, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["c" /* CtxTagKeys */].deviceBrowser, web.browser);
            var envData = env.data = env.data || {};
            var envBaseData = envData[strBaseData] = envData[strBaseData] || {};
            var envProps = envBaseData[strProperties] = envBaseData[strProperties] || {};
            _setValueIf(envProps, 'domain', web.domain);
            _setValueIf(envProps, 'isManual', web.isManual ? strTrue : null);
            _setValueIf(envProps, 'screenRes', web.screenRes);
            _setValueIf(envProps, 'userConsent', web.userConsent ? strTrue : null);
        }
        var extOs = itmExt.os;
        if (extOs) {
            _setValueIf(envTags, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["c" /* CtxTagKeys */].deviceOS, extOs.name);
        }
        // No support for mapping Trace.traceState to 2.0 as it is currently empty
        var extTrace = itmExt.trace;
        if (extTrace) {
            _setValueIf(envTags, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["c" /* CtxTagKeys */].operationParentId, extTrace.parentID);
            _setValueIf(envTags, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["c" /* CtxTagKeys */].operationName, extTrace.name);
            _setValueIf(envTags, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["c" /* CtxTagKeys */].operationId, extTrace.traceID);
        }
        // Sample 4.0 schema
        //  {
        //     "time" : "2018-09-05T22:51:22.4936Z",
        //     "name" : "MetricWithNamespace",
        //     "iKey" : "ABC-5a4cbd20-e601-4ef5-a3c6-5d6577e4398e",
        //     "ext": {  "cloud": {
        //          "role": "WATSON3",
        //          "roleInstance": "CO4AEAP00000260"
        //      },
        //      "device": {}, "correlation": {} },
        //      "tags": [
        //        { "amazon.region" : "east2" },
        //        { "os.expid" : "wp:02df239" }
        //     ]
        //   }
        var tgs = {};
        // deals with tags.push({object})
        for (var i = itmTags.length - 1; i >= 0; i--) {
            var tg = itmTags[i];
            Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["M" /* objForEachKey */])(tg, function (key, value) {
                tgs[key] = value;
            });
            itmTags.splice(i, 1);
        }
        // deals with tags[key]=value (and handles hasOwnProperty)
        Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["M" /* objForEachKey */])(itmTags, function (tg, value) {
            tgs[tg] = value;
        });
        var theTags = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["f" /* __assignFn */])({}, envTags, tgs);
        if (!theTags[__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["c" /* CtxTagKeys */].internalSdkVersion]) {
            // Append a version in case it is not already set
            theTags[__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["c" /* CtxTagKeys */].internalSdkVersion] = "javascript:" + EnvelopeCreator.Version;
        }
        env.tags = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["O" /* optimizeObject */])(theTags);
    };
    EnvelopeCreator.prototype.Init = function (logger, telemetryItem) {
        this._logger = logger;
        if (Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["F" /* isNullOrUndefined */])(telemetryItem[strBaseData])) {
            this._logger.throwInternal(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].TelemetryEnvelopeInvalid, "telemetryItem.baseData cannot be null.");
        }
    };
    EnvelopeCreator.Version = "2.6.3";
    return EnvelopeCreator;
}());

var DependencyEnvelopeCreator = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(DependencyEnvelopeCreator, _super);
    function DependencyEnvelopeCreator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DependencyEnvelopeCreator.prototype.Create = function (logger, telemetryItem) {
        _super.prototype.Init.call(this, logger, telemetryItem);
        var customMeasurements = telemetryItem[strBaseData].measurements || {};
        var customProperties = telemetryItem[strBaseData][strProperties] || {};
        EnvelopeCreator.extractPropsAndMeasurements(telemetryItem.data, customProperties, customMeasurements);
        var bd = telemetryItem[strBaseData];
        if (Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["F" /* isNullOrUndefined */])(bd)) {
            logger.warnToConsole("Invalid input for dependency data");
            return null;
        }
        var method = bd[strProperties] && bd[strProperties][__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["i" /* HttpMethod */]] ? bd[strProperties][__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["i" /* HttpMethod */]] : "GET";
        var remoteDepData = new __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["n" /* RemoteDependencyData */](logger, bd.id, bd.target, bd.name, bd.duration, bd.success, bd.responseCode, method, bd.type, bd.correlationContext, customProperties, customMeasurements);
        var data = new __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["d" /* Data */](__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["n" /* RemoteDependencyData */].dataType, remoteDepData);
        return EnvelopeCreator.createEnvelope(logger, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["n" /* RemoteDependencyData */].envelopeType, telemetryItem, data);
    };
    DependencyEnvelopeCreator.DependencyEnvelopeCreator = new DependencyEnvelopeCreator();
    return DependencyEnvelopeCreator;
}(EnvelopeCreator));

var EventEnvelopeCreator = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(EventEnvelopeCreator, _super);
    function EventEnvelopeCreator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EventEnvelopeCreator.prototype.Create = function (logger, telemetryItem) {
        _super.prototype.Init.call(this, logger, telemetryItem);
        var customProperties = {};
        var customMeasurements = {};
        if (telemetryItem[strBaseType] !== __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["g" /* Event */].dataType) {
            customProperties['baseTypeSource'] = telemetryItem[strBaseType]; // save the passed in base type as a property
        }
        if (telemetryItem[strBaseType] === __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["g" /* Event */].dataType) {
            customProperties = telemetryItem[strBaseData][strProperties] || {};
            customMeasurements = telemetryItem[strBaseData].measurements || {};
        }
        else {
            if (telemetryItem[strBaseData]) {
                EnvelopeCreator.extractPropsAndMeasurements(telemetryItem[strBaseData], customProperties, customMeasurements);
            }
        }
        // Extract root level properties from part C telemetryItem.data
        EnvelopeCreator.extractPropsAndMeasurements(telemetryItem.data, customProperties, customMeasurements);
        var eventName = telemetryItem[strBaseData].name;
        var eventData = new __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["g" /* Event */](logger, eventName, customProperties, customMeasurements);
        var data = new __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["d" /* Data */](__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["g" /* Event */].dataType, eventData);
        return EnvelopeCreator.createEnvelope(logger, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["g" /* Event */].envelopeType, telemetryItem, data);
    };
    EventEnvelopeCreator.EventEnvelopeCreator = new EventEnvelopeCreator();
    return EventEnvelopeCreator;
}(EnvelopeCreator));

var ExceptionEnvelopeCreator = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(ExceptionEnvelopeCreator, _super);
    function ExceptionEnvelopeCreator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExceptionEnvelopeCreator.prototype.Create = function (logger, telemetryItem) {
        _super.prototype.Init.call(this, logger, telemetryItem);
        // Extract root level properties from part C telemetryItem.data
        var customMeasurements = telemetryItem[strBaseData].measurements || {};
        var customProperties = telemetryItem[strBaseData][strProperties] || {};
        EnvelopeCreator.extractPropsAndMeasurements(telemetryItem.data, customProperties, customMeasurements);
        var bd = telemetryItem[strBaseData];
        var exData = __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["h" /* Exception */].CreateFromInterface(logger, bd, customProperties, customMeasurements);
        var data = new __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["d" /* Data */](__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["h" /* Exception */].dataType, exData);
        return EnvelopeCreator.createEnvelope(logger, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["h" /* Exception */].envelopeType, telemetryItem, data);
    };
    ExceptionEnvelopeCreator.ExceptionEnvelopeCreator = new ExceptionEnvelopeCreator();
    return ExceptionEnvelopeCreator;
}(EnvelopeCreator));

var MetricEnvelopeCreator = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(MetricEnvelopeCreator, _super);
    function MetricEnvelopeCreator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MetricEnvelopeCreator.prototype.Create = function (logger, telemetryItem) {
        _super.prototype.Init.call(this, logger, telemetryItem);
        var baseData = telemetryItem[strBaseData];
        var props = baseData[strProperties] || {};
        var measurements = baseData.measurements || {};
        EnvelopeCreator.extractPropsAndMeasurements(telemetryItem.data, props, measurements);
        var baseMetricData = new __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["j" /* Metric */](logger, baseData.name, baseData.average, baseData.sampleCount, baseData.min, baseData.max, props, measurements);
        var data = new __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["d" /* Data */](__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["j" /* Metric */].dataType, baseMetricData);
        return EnvelopeCreator.createEnvelope(logger, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["j" /* Metric */].envelopeType, telemetryItem, data);
    };
    MetricEnvelopeCreator.MetricEnvelopeCreator = new MetricEnvelopeCreator();
    return MetricEnvelopeCreator;
}(EnvelopeCreator));

var PageViewEnvelopeCreator = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(PageViewEnvelopeCreator, _super);
    function PageViewEnvelopeCreator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PageViewEnvelopeCreator.prototype.Create = function (logger, telemetryItem) {
        _super.prototype.Init.call(this, logger, telemetryItem);
        // Since duration is not part of the domain properties in Common Schema, extract it from part C
        var strDuration = "duration";
        var duration;
        var baseData = telemetryItem[strBaseData];
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["F" /* isNullOrUndefined */])(baseData) &&
            !Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["F" /* isNullOrUndefined */])(baseData[strProperties]) &&
            !Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["F" /* isNullOrUndefined */])(baseData[strProperties][strDuration])) {
            duration = baseData[strProperties][strDuration];
            delete baseData[strProperties][strDuration];
        }
        else if (!Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["F" /* isNullOrUndefined */])(telemetryItem.data) &&
            !Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["F" /* isNullOrUndefined */])(telemetryItem.data[strDuration])) {
            duration = telemetryItem.data[strDuration];
            delete telemetryItem.data[strDuration];
        }
        var bd = telemetryItem[strBaseData];
        // special case: pageview.id is grabbed from current operation id. Analytics plugin is decoupled from properties plugin, so this is done here instead. This can be made a default telemetry intializer instead if needed to be decoupled from channel
        var currentContextId;
        if (((telemetryItem.ext || {}).trace || {}).traceID) {
            currentContextId = telemetryItem.ext.trace.traceID;
        }
        var id = bd.id || currentContextId;
        var name = bd.name;
        var url = bd.uri;
        var properties = bd[strProperties] || {};
        var measurements = bd.measurements || {};
        // refUri is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["F" /* isNullOrUndefined */])(bd.refUri)) {
            properties["refUri"] = bd.refUri;
        }
        // pageType is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["F" /* isNullOrUndefined */])(bd.pageType)) {
            properties["pageType"] = bd.pageType;
        }
        // isLoggedIn is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["F" /* isNullOrUndefined */])(bd.isLoggedIn)) {
            properties["isLoggedIn"] = bd.isLoggedIn.toString();
        }
        // pageTags is a field that Breeze still does not recognize as part of Part B. For now, put it in Part C until it supports it as a domain property
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["F" /* isNullOrUndefined */])(bd[strProperties])) {
            var pageTags = bd[strProperties];
            Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["M" /* objForEachKey */])(pageTags, function (key, value) {
                properties[key] = value;
            });
        }
        EnvelopeCreator.extractPropsAndMeasurements(telemetryItem.data, properties, measurements);
        var pageViewData = new __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["k" /* PageView */](logger, name, url, duration, properties, measurements, id);
        var data = new __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["d" /* Data */](__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["k" /* PageView */].dataType, pageViewData);
        return EnvelopeCreator.createEnvelope(logger, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["k" /* PageView */].envelopeType, telemetryItem, data);
    };
    PageViewEnvelopeCreator.PageViewEnvelopeCreator = new PageViewEnvelopeCreator();
    return PageViewEnvelopeCreator;
}(EnvelopeCreator));

var PageViewPerformanceEnvelopeCreator = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(PageViewPerformanceEnvelopeCreator, _super);
    function PageViewPerformanceEnvelopeCreator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PageViewPerformanceEnvelopeCreator.prototype.Create = function (logger, telemetryItem) {
        _super.prototype.Init.call(this, logger, telemetryItem);
        var bd = telemetryItem[strBaseData];
        var name = bd.name;
        var url = bd.uri || bd.url;
        var properties = bd[strProperties] || {};
        var measurements = bd.measurements || {};
        EnvelopeCreator.extractPropsAndMeasurements(telemetryItem.data, properties, measurements);
        var baseData = new __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["l" /* PageViewPerformance */](logger, name, url, undefined, properties, measurements, bd);
        var data = new __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["d" /* Data */](__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["l" /* PageViewPerformance */].dataType, baseData);
        return EnvelopeCreator.createEnvelope(logger, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["l" /* PageViewPerformance */].envelopeType, telemetryItem, data);
    };
    PageViewPerformanceEnvelopeCreator.PageViewPerformanceEnvelopeCreator = new PageViewPerformanceEnvelopeCreator();
    return PageViewPerformanceEnvelopeCreator;
}(EnvelopeCreator));

var TraceEnvelopeCreator = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(TraceEnvelopeCreator, _super);
    function TraceEnvelopeCreator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TraceEnvelopeCreator.prototype.Create = function (logger, telemetryItem) {
        _super.prototype.Init.call(this, logger, telemetryItem);
        var message = telemetryItem[strBaseData].message;
        var severityLevel = telemetryItem[strBaseData].severityLevel;
        var props = telemetryItem[strBaseData][strProperties] || {};
        var measurements = telemetryItem[strBaseData].measurements || {};
        EnvelopeCreator.extractPropsAndMeasurements(telemetryItem.data, props, measurements);
        var baseData = new __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["q" /* Trace */](logger, message, severityLevel, props, measurements);
        var data = new __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["d" /* Data */](__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["q" /* Trace */].dataType, baseData);
        return EnvelopeCreator.createEnvelope(logger, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["q" /* Trace */].envelopeType, telemetryItem, data);
    };
    TraceEnvelopeCreator.TraceEnvelopeCreator = new TraceEnvelopeCreator();
    return TraceEnvelopeCreator;
}(EnvelopeCreator));

//# sourceMappingURL=EnvelopeCreator.js.map

/***/ }),
/* 1454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Serializer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__ = __webpack_require__(97);
/*
 * Application Insights JavaScript SDK - Channel, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var Serializer = /** @class */ (function () {
    function Serializer(logger) {
        Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__["a" /* default */])(Serializer, this, function (_self) {
            /**
             * Serializes the current object to a JSON string.
             */
            _self.serialize = function (input) {
                var output = _serializeObject(input, "root");
                try {
                    return Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["w" /* getJSON */])().stringify(output);
                }
                catch (e) {
                    // if serialization fails return an empty string
                    logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].CannotSerializeObject, (e && Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["E" /* isFunction */])(e.toString)) ? e.toString() : "Error serializing object", null, true);
                }
            };
            function _serializeObject(source, name) {
                var circularReferenceCheck = "__aiCircularRefCheck";
                var output = {};
                if (!source) {
                    logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].CannotSerializeObject, "cannot serialize object because it is null or undefined", { name: name }, true);
                    return output;
                }
                if (source[circularReferenceCheck]) {
                    logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].CircularReferenceDetected, "Circular reference detected while serializing object", { name: name }, true);
                    return output;
                }
                if (!source.aiDataContract) {
                    // special case for measurements/properties/tags
                    if (name === "measurements") {
                        output = _serializeStringMap(source, "number", name);
                    }
                    else if (name === "properties") {
                        output = _serializeStringMap(source, "string", name);
                    }
                    else if (name === "tags") {
                        output = _serializeStringMap(source, "string", name);
                    }
                    else if (Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["B" /* isArray */])(source)) {
                        output = _serializeArray(source, name);
                    }
                    else {
                        logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].CannotSerializeObjectNonSerializable, "Attempting to serialize an object which does not implement ISerializable", { name: name }, true);
                        try {
                            // verify that the object can be stringified
                            Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["w" /* getJSON */])().stringify(source);
                            output = source;
                        }
                        catch (e) {
                            // if serialization fails return an empty string
                            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].CannotSerializeObject, (e && Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["E" /* isFunction */])(e.toString)) ? e.toString() : "Error serializing object", null, true);
                        }
                    }
                    return output;
                }
                source[circularReferenceCheck] = true;
                Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["M" /* objForEachKey */])(source.aiDataContract, function (field, contract) {
                    var isRequired = (Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["E" /* isFunction */])(contract)) ? (contract() & 1 /* Required */) : (contract & 1 /* Required */);
                    var isHidden = (Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["E" /* isFunction */])(contract)) ? (contract() & 4 /* Hidden */) : (contract & 4 /* Hidden */);
                    var isArray = contract & 2 /* Array */;
                    var isPresent = source[field] !== undefined;
                    var isObj = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["H" /* isObject */])(source[field]) && source[field] !== null;
                    if (isRequired && !isPresent && !isArray) {
                        logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].MissingRequiredFieldSpecification, "Missing required field specification. The field is required but not present on source", { field: field, name: name });
                        // If not in debug mode, continue and hope the error is permissible
                    }
                    else if (!isHidden) {
                        var value = void 0;
                        if (isObj) {
                            if (isArray) {
                                // special case; recurse on each object in the source array
                                value = _serializeArray(source[field], field);
                            }
                            else {
                                // recurse on the source object in this field
                                value = _serializeObject(source[field], field);
                            }
                        }
                        else {
                            // assign the source field to the output even if undefined or required
                            value = source[field];
                        }
                        // only emit this field if the value is defined
                        if (value !== undefined) {
                            output[field] = value;
                        }
                    }
                });
                delete source[circularReferenceCheck];
                return output;
            }
            function _serializeArray(sources, name) {
                var output;
                if (!!sources) {
                    if (!Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["B" /* isArray */])(sources)) {
                        logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].ItemNotInArray, "This field was specified as an array in the contract but the item is not an array.\r\n", { name: name }, true);
                    }
                    else {
                        output = [];
                        for (var i = 0; i < sources.length; i++) {
                            var source = sources[i];
                            var item = _serializeObject(source, name + "[" + i + "]");
                            output.push(item);
                        }
                    }
                }
                return output;
            }
            function _serializeStringMap(map, expectedType, name) {
                var output;
                if (map) {
                    output = {};
                    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["M" /* objForEachKey */])(map, function (field, value) {
                        if (expectedType === "string") {
                            if (value === undefined) {
                                output[field] = "undefined";
                            }
                            else if (value === null) {
                                output[field] = "null";
                            }
                            else if (!value.toString) {
                                output[field] = "invalid field: toString() is not defined.";
                            }
                            else {
                                output[field] = value.toString();
                            }
                        }
                        else if (expectedType === "number") {
                            if (value === undefined) {
                                output[field] = "undefined";
                            }
                            else if (value === null) {
                                output[field] = "null";
                            }
                            else {
                                var num = parseFloat(value);
                                if (isNaN(num)) {
                                    output[field] = "NaN";
                                }
                                else {
                                    output[field] = num;
                                }
                            }
                        }
                        else {
                            output[field] = "invalid field: " + name + " is of unknown type.";
                            logger.throwInternal(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].CRITICAL, output[field], null, true);
                        }
                    });
                }
                return output;
            }
        });
    }
// Removed Stub for Serializer.prototype.serialize.
    return Serializer;
}());

//# sourceMappingURL=Serializer.js.map

/***/ }),
/* 1455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OfflineListener */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Offline; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__ = __webpack_require__(97);
/*
 * Application Insights JavaScript SDK - Channel, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * @description Monitors browser for offline events
 * @export default - Offline: Static instance of OfflineListener
 * @class OfflineListener
 */
var OfflineListener = /** @class */ (function () {
    function OfflineListener() {
        var _window = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["z" /* getWindow */])();
        var _document = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["r" /* getDocument */])();
        var isListening = false;
        var _onlineStatus = true;
        Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__["a" /* default */])(OfflineListener, this, function (_self) {
            try {
                if (_window) {
                    if (__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b" /* EventHelper */].Attach(_window, 'online', _setOnline)) {
                        __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b" /* EventHelper */].Attach(_window, 'offline', _setOffline);
                        isListening = true;
                    }
                }
                if (_document) {
                    // Also attach to the document.body or document
                    var target = _document.body || _document;
                    if (!Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["K" /* isUndefined */])(target.ononline)) {
                        target.ononline = _setOnline;
                        target.onoffline = _setOffline;
                        isListening = true;
                    }
                }
                if (isListening) {
                    // We are listening to events so lets set the current status rather than assuming we are online #1538
                    var _navigator = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["x" /* getNavigator */])(); // Gets the window.navigator or workerNavigator depending on the global
                    if (_navigator && !Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["F" /* isNullOrUndefined */])(_navigator.onLine)) {
                        _onlineStatus = _navigator.onLine;
                    }
                }
            }
            catch (e) {
                // this makes react-native less angry
                isListening = false;
            }
            _self.isListening = isListening;
            _self.isOnline = function () {
                var result = true;
                var _navigator = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["x" /* getNavigator */])();
                if (isListening) {
                    result = _onlineStatus;
                }
                else if (_navigator && !Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["F" /* isNullOrUndefined */])(_navigator.onLine)) {
                    result = _navigator.onLine;
                }
                return result;
            };
            _self.isOffline = function () {
                return !_self.isOnline();
            };
            function _setOnline() {
                _onlineStatus = true;
            }
            function _setOffline() {
                _onlineStatus = false;
            }
        });
    }
// Removed Stub for OfflineListener.prototype.isOnline.
// Removed Stub for OfflineListener.prototype.isOffline.
    OfflineListener.Offline = new OfflineListener;
    return OfflineListener;
}());

var Offline = OfflineListener.Offline;
//# sourceMappingURL=Offline.js.map

/***/ }),
/* 1456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Sample; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SamplingScoreGenerators_SamplingScoreGenerator__ = __webpack_require__(1457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__ = __webpack_require__(30);
/*
 * Application Insights JavaScript SDK - Channel, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





var Sample = /** @class */ (function () {
    function Sample(sampleRate, logger) {
        // We're using 32 bit math, hence max value is (2^31 - 1)
        this.INT_MAX_VALUE = 2147483647;
        this._logger = logger || Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["Q" /* safeGetLogger */])(null);
        if (sampleRate > 100 || sampleRate < 0) {
            this._logger.throwInternal(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["c" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].SampleRateOutOfRange, "Sampling rate is out of range (0..100). Sampling will be disabled, you may be sending too much data which may affect your AI service level.", { samplingRate: sampleRate }, true);
            this.sampleRate = 100;
        }
        this.sampleRate = sampleRate;
        this.samplingScoreGenerator = new __WEBPACK_IMPORTED_MODULE_0__SamplingScoreGenerators_SamplingScoreGenerator__["a" /* SamplingScoreGenerator */]();
    }
    /**
     * Determines if an envelope is sampled in (i.e. will be sent) or not (i.e. will be dropped).
     */
    Sample.prototype.isSampledIn = function (envelope) {
        var samplingPercentage = this.sampleRate; // 0 - 100
        var isSampledIn = false;
        if (samplingPercentage === null || samplingPercentage === undefined || samplingPercentage >= 100) {
            return true;
        }
        else if (envelope.baseType === __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["j" /* Metric */].dataType) {
            // exclude MetricData telemetry from sampling
            return true;
        }
        isSampledIn = this.samplingScoreGenerator.getSamplingScore(envelope) < samplingPercentage;
        return isSampledIn;
    };
    return Sample;
}());

//# sourceMappingURL=Sample.js.map

/***/ }),
/* 1457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SamplingScoreGenerator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HashCodeScoreGenerator__ = __webpack_require__(1458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__ = __webpack_require__(171);
/*
 * Application Insights JavaScript SDK - Channel, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var SamplingScoreGenerator = /** @class */ (function () {
    function SamplingScoreGenerator() {
        this.hashCodeGeneragor = new __WEBPACK_IMPORTED_MODULE_0__HashCodeScoreGenerator__["a" /* HashCodeScoreGenerator */]();
        this.keys = new __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["b" /* ContextTagKeys */]();
    }
    SamplingScoreGenerator.prototype.getSamplingScore = function (item) {
        var score = 0;
        if (item.tags && item.tags[this.keys.userId]) {
            score = this.hashCodeGeneragor.getHashCodeScore(item.tags[this.keys.userId]);
        }
        else if (item.ext && item.ext.user && item.ext.user.id) {
            score = this.hashCodeGeneragor.getHashCodeScore(item.ext.user.id);
        }
        else if (item.tags && item.tags[this.keys.operationId]) {
            score = this.hashCodeGeneragor.getHashCodeScore(item.tags[this.keys.operationId]);
        }
        else if (item.ext && item.ext.telemetryTrace && item.ext.telemetryTrace.traceID) {
            score = this.hashCodeGeneragor.getHashCodeScore(item.ext.telemetryTrace.traceID);
        }
        else {
            // tslint:disable-next-line:insecure-random
            score = (Math.random() * 100);
        }
        return score;
    };
    return SamplingScoreGenerator;
}());

//# sourceMappingURL=SamplingScoreGenerator.js.map

/***/ }),
/* 1458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HashCodeScoreGenerator; });
/*
 * Application Insights JavaScript SDK - Channel, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var HashCodeScoreGenerator = /** @class */ (function () {
    function HashCodeScoreGenerator() {
    }
    HashCodeScoreGenerator.prototype.getHashCodeScore = function (key) {
        var score = this.getHashCode(key) / HashCodeScoreGenerator.INT_MAX_VALUE;
        return score * 100;
    };
    HashCodeScoreGenerator.prototype.getHashCode = function (input) {
        if (input === "") {
            return 0;
        }
        while (input.length < HashCodeScoreGenerator.MIN_INPUT_LENGTH) {
            input = input.concat(input);
        }
        // 5381 is a magic number: http://stackoverflow.com/questions/10696223/reason-for-5381-number-in-djb-hash-function
        var hash = 5381;
        for (var i = 0; i < input.length; ++i) {
            hash = ((hash << 5) + hash) + input.charCodeAt(i);
            // 'hash' is of number type which means 53 bit integer (http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types-number-type)
            // 'hash & hash' will keep it 32 bit integer - just to make it clearer what the result is.
            hash = hash & hash;
        }
        return Math.abs(hash);
    };
    // We're using 32 bit math, hence max value is (2^31 - 1)
    HashCodeScoreGenerator.INT_MAX_VALUE = 2147483647;
    // (Magic number) DJB algorithm can't work on shorter strings (results in poor distribution
    HashCodeScoreGenerator.MIN_INPUT_LENGTH = 8;
    return HashCodeScoreGenerator;
}());

//# sourceMappingURL=HashCodeScoreGenerator.js.map

/***/ }),
/* 1459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TelemetryContext__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_common__ = __webpack_require__(174);
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
 * PropertiesPlugin.ts
 * @copyright Microsoft 2018
 */





var PropertiesPlugin = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(PropertiesPlugin, _super);
    function PropertiesPlugin() {
        var _this = _super.call(this) || this;
        _this.priority = 110;
        _this.identifier = __WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_common__["e" /* PropertiesPluginIdentifier */];
        var _breezeChannel; // optional. If exists, grab appId from it
        var _extensionConfig;
        Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__["a" /* default */])(PropertiesPlugin, _this, function (_self, _base) {
            _self.initialize = function (config, core, extensions, pluginChain) {
                _base.initialize(config, core, extensions, pluginChain);
                var ctx = _self._getTelCtx();
                var identifier = _self.identifier;
                var defaultConfig = PropertiesPlugin.getDefaultConfig();
                _extensionConfig = _extensionConfig || {};
                Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["K" /* objForEachKey */])(defaultConfig, function (field, value) {
                    _extensionConfig[field] = function () { return ctx.getConfig(identifier, field, value()); };
                });
                _self.context = new __WEBPACK_IMPORTED_MODULE_3__TelemetryContext__["a" /* TelemetryContext */](core, _extensionConfig);
                _breezeChannel = Object(__WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_common__["g" /* getExtensionByName */])(extensions, __WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_common__["a" /* BreezeChannelIdentifier */]);
                _self.context.appId = function () { return _breezeChannel ? _breezeChannel["_appId"] : null; };
                // Test hook to allow accessing the internal values -- explicitly not defined as an available property on the class
                _self["_extConfig"] = _extensionConfig;
            };
            /**
             * Add Part A fields to the event
             * @param event The event that needs to be processed
             */
            _self.processTelemetry = function (event, itemCtx) {
                if (Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(event)) {
                    // TODO(barustum): throw an internal event once we have support for internal logging
                }
                else {
                    itemCtx = _self._getTelCtx(itemCtx);
                    // If the envelope is PageView, reset the internal message count so that we can send internal telemetry for the new page.
                    if (event.name === __WEBPACK_IMPORTED_MODULE_4__microsoft_applicationinsights_common__["d" /* PageView */].envelopeType) {
                        itemCtx.diagLog().resetInternalMessageCount();
                    }
                    var theContext = (_self.context || {});
                    if (theContext.session) {
                        // If customer did not provide custom session id update the session manager
                        if (typeof _self.context.session.id !== "string" && theContext.sessionManager) {
                            theContext.sessionManager.update();
                        }
                    }
                    _processTelemetryInternal(event, itemCtx);
                    if (theContext.user && theContext.user.isNewUser) {
                        theContext.user.isNewUser = false;
                        var message = new __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["c" /* _InternalLogMessage */](__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].SendBrowserInfoOnUserInit, ((Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["x" /* getNavigator */])() || {}).userAgent || ""));
                        itemCtx.diagLog().logInternalMessage(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].CRITICAL, message);
                    }
                    _self.processNext(event, itemCtx);
                }
            };
            function _processTelemetryInternal(evt, itemCtx) {
                // Set Part A fields
                Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["z" /* getSetValue */])(evt, "tags", []);
                Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["z" /* getSetValue */])(evt, "ext", {});
                var ctx = _self.context;
                ctx.applySessionContext(evt, itemCtx);
                ctx.applyApplicationContext(evt, itemCtx);
                ctx.applyDeviceContext(evt, itemCtx);
                ctx.applyOperationContext(evt, itemCtx);
                ctx.applyUserContext(evt, itemCtx);
                ctx.applyOperatingSystemContxt(evt, itemCtx);
                ctx.applyWebContext(evt, itemCtx);
                ctx.applyLocationContext(evt, itemCtx); // legacy tags
                ctx.applyInternalContext(evt, itemCtx); // legacy tags
                ctx.cleanUp(evt, itemCtx);
            }
        });
        return _this;
    }
    PropertiesPlugin.getDefaultConfig = function () {
        var defaultConfig = {
            instrumentationKey: function () { return undefined; },
            accountId: function () { return null; },
            sessionRenewalMs: function () { return 30 * 60 * 1000; },
            samplingPercentage: function () { return 100; },
            sessionExpirationMs: function () { return 24 * 60 * 60 * 1000; },
            cookieDomain: function () { return null; },
            sdkExtension: function () { return null; },
            isBrowserLinkTrackingEnabled: function () { return false; },
            appId: function () { return null; },
            namePrefix: function () { return undefined; },
            idLength: function () { return 22; },
            getNewId: function () { return null; }
        };
        return defaultConfig;
    };
// Removed Stub for PropertiesPlugin.prototype.initialize.
// Removed Stub for PropertiesPlugin.prototype.processTelemetry.
    return PropertiesPlugin;
}(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["a" /* BaseTelemetryPlugin */]));
/* harmony default export */ __webpack_exports__["a"] = (PropertiesPlugin);
//# sourceMappingURL=PropertiesPlugin.js.map

/***/ }),
/* 1460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MinChannelPriorty */
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var MinChannelPriorty = 100;
//# sourceMappingURL=IChannelControls.js.map

/***/ }),
/* 1461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AppInsightsCore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseCore__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JavaScriptSDK_Enums_EventsDiscardedReason__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NotificationManager__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PerfManager__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DiagnosticLogger__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__microsoft_dynamicproto_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__HelperFuncs__ = __webpack_require__(44);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */








"use strict";
var AppInsightsCore = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(AppInsightsCore, _super);
    function AppInsightsCore() {
        var _this = _super.call(this) || this;
        Object(__WEBPACK_IMPORTED_MODULE_6__microsoft_dynamicproto_js__["a" /* default */])(AppInsightsCore, _this, function (_self, _base) {
            _self.initialize = function (config, extensions, logger, notificationManager) {
                _base.initialize(config, extensions, logger || new __WEBPACK_IMPORTED_MODULE_5__DiagnosticLogger__["a" /* DiagnosticLogger */](config), notificationManager || new __WEBPACK_IMPORTED_MODULE_3__NotificationManager__["a" /* NotificationManager */](config));
            };
            _self.track = function (telemetryItem) {
                Object(__WEBPACK_IMPORTED_MODULE_4__PerfManager__["b" /* doPerf */])(_self.getPerfMgr(), function () { return "AppInsightsCore:track"; }, function () {
                    if (telemetryItem === null) {
                        _notifyInvalidEvent(telemetryItem);
                        // throw error
                        Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["G" /* throwError */])("Invalid telemetry item");
                    }
                    // do basic validation before sending it through the pipeline
                    _validateTelemetryItem(telemetryItem);
                    _base.track(telemetryItem);
                }, function () { return ({ item: telemetryItem }); }, !(telemetryItem.sync));
            };
            /**
             * Adds a notification listener. The SDK calls methods on the listener when an appropriate notification is raised.
             * The added plugins must raise notifications. If the plugins do not implement the notifications, then no methods will be
             * called.
             * @param {INotificationListener} listener - An INotificationListener object.
             */
            _self.addNotificationListener = function (listener) {
                var manager = _self.getNotifyMgr();
                if (manager) {
                    manager.addNotificationListener(listener);
                }
            };
            /**
             * Removes all instances of the listener.
             * @param {INotificationListener} listener - INotificationListener to remove.
             */
            _self.removeNotificationListener = function (listener) {
                var manager = _self.getNotifyMgr();
                if (manager) {
                    manager.removeNotificationListener(listener);
                }
            };
            /**
             * Periodically check logger.queue for
             */
            _self.pollInternalLogs = function (eventName) {
                var interval = _self.config.diagnosticLogInterval;
                if (!interval || !(interval > 0)) {
                    interval = 10000;
                }
                return setInterval(function () {
                    var queue = _self.logger ? _self.logger.queue : [];
                    Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["a" /* arrForEach */])(queue, function (logMessage) {
                        var item = {
                            name: eventName ? eventName : "InternalMessageId: " + logMessage.messageId,
                            iKey: _self.config.instrumentationKey,
                            time: Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["H" /* toISOString */])(new Date()),
                            baseType: __WEBPACK_IMPORTED_MODULE_5__DiagnosticLogger__["b" /* _InternalLogMessage */].dataType,
                            baseData: { message: logMessage.message }
                        };
                        _self.track(item);
                    });
                    queue.length = 0;
                }, interval);
            };
            function _validateTelemetryItem(telemetryItem) {
                if (Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["s" /* isNullOrUndefined */])(telemetryItem.name)) {
                    _notifyInvalidEvent(telemetryItem);
                    throw Error("telemetry name required");
                }
            }
            function _notifyInvalidEvent(telemetryItem) {
                var manager = _self.getNotifyMgr();
                if (manager) {
                    manager.eventsDiscarded([telemetryItem], __WEBPACK_IMPORTED_MODULE_2__JavaScriptSDK_Enums_EventsDiscardedReason__["a" /* EventsDiscardedReason */].InvalidEvent);
                }
            }
        });
        return _this;
    }
// Removed Stub for AppInsightsCore.prototype.initialize.
// Removed Stub for AppInsightsCore.prototype.track.
// Removed Stub for AppInsightsCore.prototype.addNotificationListener.
// Removed Stub for AppInsightsCore.prototype.removeNotificationListener.
// Removed Stub for AppInsightsCore.prototype.pollInternalLogs.
    return AppInsightsCore;
}(__WEBPACK_IMPORTED_MODULE_1__BaseCore__["a" /* BaseCore */]));

//# sourceMappingURL=AppInsightsCore.js.map

/***/ }),
/* 1462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChannelController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseTelemetryPlugin__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProcessTelemetryContext__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TelemetryHelpers__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HelperFuncs__ = __webpack_require__(44);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */









var ChannelControllerPriority = 500;
var ChannelValidationMessage = "Channel has invalid priority";
var ChannelController = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(ChannelController, _super);
    function ChannelController() {
        var _this = _super.call(this) || this;
        _this.identifier = "ChannelControllerPlugin";
        _this.priority = ChannelControllerPriority; // in reserved range 100 to 200
        var _channelQueue;
        Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__["a" /* default */])(ChannelController, _this, function (_self, _base) {
            _self.setNextPlugin = function (next) {
                // The Channel controller is last in pipeline
            };
            _self.processTelemetry = function (item, itemCtx) {
                if (_channelQueue) {
                    Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["a" /* arrForEach */])(_channelQueue, function (queues) {
                        // pass on to first item in queue
                        if (queues.length > 0) {
                            // Copying the item context as we could have mutiple chains that are executing asynchronously
                            // and calling _getDefTelCtx as it's possible that the caller doesn't pass any context
                            var chainCtx = _this._getTelCtx(itemCtx).createNew(queues);
                            chainCtx.processNext(item);
                        }
                    });
                }
            };
            _self.getChannelControls = function () {
                return _channelQueue;
            };
            _self.initialize = function (config, core, extensions) {
                if (_self.isInitialized()) {
                    // already initialized
                    return;
                }
                _base.initialize(config, core, extensions);
                _createChannelQueues((config || {}).channels, extensions);
                // Initialize the Queues
                Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["a" /* arrForEach */])(_channelQueue, function (queue) { return Object(__WEBPACK_IMPORTED_MODULE_4__TelemetryHelpers__["a" /* initializePlugins */])(new __WEBPACK_IMPORTED_MODULE_3__ProcessTelemetryContext__["a" /* ProcessTelemetryContext */](queue, config, core), extensions); });
            };
        });
        function _checkQueuePriority(queue) {
            Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["a" /* arrForEach */])(queue, function (queueItem) {
                if (queueItem.priority < ChannelControllerPriority) {
                    Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["G" /* throwError */])(ChannelValidationMessage + queueItem.identifier);
                }
            });
        }
        function _addChannelQueue(queue) {
            if (queue && queue.length > 0) {
                queue = queue.sort(function (a, b) {
                    return a.priority - b.priority;
                });
                _checkQueuePriority(queue);
                _channelQueue.push(queue);
            }
        }
        function _createChannelQueues(channels, extensions) {
            _channelQueue = [];
            if (channels) {
                // Add and sort the configuration channel queues
                Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["a" /* arrForEach */])(channels, function (queue) { return _addChannelQueue(queue); });
            }
            if (extensions) {
                // Create a new channel queue for any extensions with a priority > the ChannelControllerPriority
                var extensionQueue_1 = [];
                Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["a" /* arrForEach */])(extensions, function (plugin) {
                    if (plugin.priority > ChannelControllerPriority) {
                        extensionQueue_1.push(plugin);
                    }
                });
                _addChannelQueue(extensionQueue_1);
            }
        }
        return _this;
    }
// Removed Stub for ChannelController.prototype.processTelemetry.
    ;
// Removed Stub for ChannelController.prototype.getChannelControls.
// Removed Stub for ChannelController.prototype.initialize.
    /**
     * Static constructor, attempt to create accessors
     */
    // tslint:disable-next-line
    ChannelController._staticInit = (function () {
        var proto = ChannelController.prototype;
        // Dynamically create get/set property accessors
        Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["z" /* objDefineAccessors */])(proto, "ChannelControls", proto.getChannelControls);
        Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["z" /* objDefineAccessors */])(proto, "channelQueue", proto.getChannelControls);
    })();
    return ChannelController;
}(__WEBPACK_IMPORTED_MODULE_2__BaseTelemetryPlugin__["a" /* BaseTelemetryPlugin */]));

//# sourceMappingURL=ChannelController.js.map

/***/ }),
/* 1463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TelemetryPluginChain; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PerfManager__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JavaScriptSDK_Enums_LoggingEnums__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__ = __webpack_require__(44);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var TelemetryPluginChain = /** @class */ (function () {
    function TelemetryPluginChain(plugin, defItemCtx) {
        var _self = this;
        var _nextProxy = null;
        var _hasProcessTelemetry = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["p" /* isFunction */])(plugin.processTelemetry);
        var _hasSetNext = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["p" /* isFunction */])(plugin.setNextPlugin);
        _self._hasRun = false;
        _self.getPlugin = function () {
            return plugin;
        };
        _self.getNext = function () {
            return _nextProxy;
        };
        _self.setNext = function (nextPlugin) {
            _nextProxy = nextPlugin;
        };
        _self.processTelemetry = function (env, itemCtx) {
            if (!itemCtx) {
                // Looks like a plugin didn't pass the (optional) context, so restore to the default
                itemCtx = defItemCtx;
            }
            var identifier = plugin ? plugin.identifier : "TelemetryPluginChain";
            Object(__WEBPACK_IMPORTED_MODULE_0__PerfManager__["b" /* doPerf */])(itemCtx ? itemCtx.core() : null, function () { return identifier + ":processTelemetry"; }, function () {
                if (plugin && _hasProcessTelemetry) {
                    _self._hasRun = true;
                    try {
                        // Ensure that we keep the context in sync (for processNext()), just in case a plugin
                        // doesn't calls processTelemetry() instead of itemContext.processNext() or some 
                        // other form of error occurred
                        itemCtx.setNext(_nextProxy);
                        if (_hasSetNext) {
                            // Backward compatibility setting the next plugin on the instance
                            plugin.setNextPlugin(_nextProxy);
                        }
                        // Set a flag on the next plugin so we know if it was attempted to be executed
                        _nextProxy && (_nextProxy._hasRun = false);
                        plugin.processTelemetry(env, itemCtx);
                    }
                    catch (error) {
                        var hasRun = _nextProxy && _nextProxy._hasRun;
                        if (!_nextProxy || !hasRun) {
                            // Either we have no next plugin or the current one did not attempt to call the next plugin
                            // Which means the current one is the root of the failure so log/report this failure
                            itemCtx.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_1__JavaScriptSDK_Enums_LoggingEnums__["a" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_1__JavaScriptSDK_Enums_LoggingEnums__["b" /* _InternalMessageId */].PluginException, "Plugin [" + plugin.identifier + "] failed during processTelemetry - " + error);
                        }
                        if (_nextProxy && !hasRun) {
                            // As part of the failure the current plugin did not attempt to call the next plugin in the cahin
                            // So rather than leave the pipeline dead in the water we call the next plugin
                            _nextProxy.processTelemetry(env, itemCtx);
                        }
                    }
                }
                else if (_nextProxy) {
                    _self._hasRun = true;
                    // The underlying plugin is either not defined or does not have a processTelemetry implementation
                    // so we still want the next plugin to be executed.
                    _nextProxy.processTelemetry(env, itemCtx);
                }
            }, function () { return ({ item: env }); }, !(env.sync));
        };
    }
    return TelemetryPluginChain;
}());

//# sourceMappingURL=TelemetryPluginChain.js.map

/***/ }),
/* 1464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Undefined */
/* unused harmony export addEventHandler */
/* unused harmony export newGuid */
/* unused harmony export perfNow */
/* harmony export (immutable) */ __webpack_exports__["f"] = newId;
/* unused harmony export strEndsWith */
/* harmony export (immutable) */ __webpack_exports__["d"] = generateW3CId;
/* unused harmony export CoreUtils */
/* unused harmony export EventHelper */
/* unused harmony export _legacyCookieMgr */
/* harmony export (immutable) */ __webpack_exports__["c"] = disableCookies;
/* harmony export (immutable) */ __webpack_exports__["a"] = canUseCookies;
/* harmony export (immutable) */ __webpack_exports__["e"] = getCookie;
/* harmony export (immutable) */ __webpack_exports__["g"] = setCookie;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteCookie;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CookieMgr__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EnvUtils__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RandomHelper__ = __webpack_require__(582);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */








var _cookieMgrs = null;
var _canUseCookies; // legacy supported config
// Added to help with minfication
var Undefined = __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["m" /* strShimUndefined */];
/**
 * Trys to add an event handler for the specified event to the window, body and document
 * @param eventName {string} - The name of the event
 * @param callback {any} - The callback function that needs to be executed for the given event
 * @return {boolean} - true if the handler was successfully added
 */
function addEventHandler(eventName, callback) {
    var result = false;
    var w = Object(__WEBPACK_IMPORTED_MODULE_2__EnvUtils__["l" /* getWindow */])();
    if (w) {
        result = Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["e" /* attachEvent */])(w, eventName, callback);
        result = Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["e" /* attachEvent */])(w["body"], eventName, callback) || result;
    }
    var doc = Object(__WEBPACK_IMPORTED_MODULE_2__EnvUtils__["d" /* getDocument */])();
    if (doc) {
        result = EventHelper.Attach(doc, eventName, callback) || result;
    }
    return result;
}
function newGuid() {
    function randomHexDigit() {
        return Object(__WEBPACK_IMPORTED_MODULE_4__RandomHelper__["d" /* randomValue */])(15); // Get a random value from 0..15
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(GuidRegex, function (c) {
        var r = (randomHexDigit() | 0), v = (c === 'x' ? r : r & 0x3 | 0x8);
        return v.toString(16);
    });
}
/**
 * Return the current value of the Performance Api now() function (if available) and fallback to dateNow() if it is unavailable (IE9 or less)
 * https://caniuse.com/#search=performance.now
 */
function perfNow() {
    var perf = Object(__WEBPACK_IMPORTED_MODULE_2__EnvUtils__["k" /* getPerformance */])();
    if (perf && perf.now) {
        return perf.now();
    }
    return Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["g" /* dateNow */])();
}
/**
 * Generate random base64 id string.
 * The default length is 22 which is 132-bits so almost the same as a GUID but as base64 (the previous default was 5)
 * @param maxLength - Optional value to specify the length of the id to be generated, defaults to 22
 */
function newId(maxLength) {
    if (maxLength === void 0) { maxLength = 22; }
    var base64chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Start with an initial random number, consuming the value in reverse byte order
    var number = Object(__WEBPACK_IMPORTED_MODULE_4__RandomHelper__["c" /* random32 */])() >>> 0; // Make sure it's a +ve number
    var chars = 0;
    var result = "";
    while (result.length < maxLength) {
        chars++;
        result += base64chars.charAt(number & 0x3F);
        number >>>= 6; // Zero fill with right shift
        if (chars === 5) {
            // 5 base64 characters === 30 bits so we don't have enough bits for another base64 char
            // So add on another 30 bits and make sure it's +ve
            number = (((Object(__WEBPACK_IMPORTED_MODULE_4__RandomHelper__["c" /* random32 */])() << 2) & 0xFFFFFFFF) | (number & 0x03)) >>> 0;
            chars = 0; // We need to reset the number every 5 chars (30 bits)
        }
    }
    return result;
}
/**
 * The strEndsWith() method determines whether a string ends with the characters of a specified string, returning true or false as appropriate.
 * @param value - The value to check whether it ends with the search value.
 * @param search - The characters to be searched for at the end of the value.
 * @returns true if the given search value is found at the end of the string, otherwise false.
 */
function strEndsWith(value, search) {
    if (value && search) {
        var len = value.length;
        var start = len - search.length;
        return value.substring(start >= 0 ? start : 0, len) === search;
    }
    return false;
}
/**
 * generate W3C trace id
 */
function generateW3CId() {
    var hexValues = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
    // rfc4122 version 4 UUID without dashes and with lowercase letters
    var oct = "", tmp;
    for (var a = 0; a < 4; a++) {
        tmp = Object(__WEBPACK_IMPORTED_MODULE_4__RandomHelper__["c" /* random32 */])();
        oct +=
            hexValues[tmp & 0xF] +
                hexValues[tmp >> 4 & 0xF] +
                hexValues[tmp >> 8 & 0xF] +
                hexValues[tmp >> 12 & 0xF] +
                hexValues[tmp >> 16 & 0xF] +
                hexValues[tmp >> 20 & 0xF] +
                hexValues[tmp >> 24 & 0xF] +
                hexValues[tmp >> 28 & 0xF];
    }
    // "Set the two most significant bits (bits 6 and 7) of the clock_seq_hi_and_reserved to zero and one, respectively"
    var clockSequenceHi = hexValues[8 + (Object(__WEBPACK_IMPORTED_MODULE_4__RandomHelper__["c" /* random32 */])() & 0x03) | 0];
    return oct.substr(0, 8) + oct.substr(9, 4) + "4" + oct.substr(13, 3) + clockSequenceHi + oct.substr(16, 3) + oct.substr(19, 12);
}
/**
 * Provides a collection of utility functions, included for backward compatibility with previous releases.
 * @deprecated Marking this instance as deprecated in favor of direct usage of the helper functions
 * as direct usage provides better tree-shaking and minification by avoiding the inclusion of the unused items
 * in your resulting code.
 */
var CoreUtils = {
    _canUseCookies: undefined,
    isTypeof: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["x" /* isTypeof */],
    isUndefined: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["y" /* isUndefined */],
    isNullOrUndefined: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["s" /* isNullOrUndefined */],
    hasOwnProperty: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["k" /* hasOwnProperty */],
    isFunction: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["p" /* isFunction */],
    isObject: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["u" /* isObject */],
    isDate: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["n" /* isDate */],
    isArray: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["l" /* isArray */],
    isError: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["o" /* isError */],
    isString: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["v" /* isString */],
    isNumber: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["t" /* isNumber */],
    isBoolean: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["m" /* isBoolean */],
    toISOString: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["H" /* toISOString */],
    arrForEach: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["a" /* arrForEach */],
    arrIndexOf: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["b" /* arrIndexOf */],
    arrMap: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["c" /* arrMap */],
    arrReduce: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["d" /* arrReduce */],
    strTrim: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["F" /* strTrim */],
    objCreate: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["i" /* objCreateFn */],
    objKeys: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["B" /* objKeys */],
    objDefineAccessors: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["z" /* objDefineAccessors */],
    addEventHandler: addEventHandler,
    dateNow: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["g" /* dateNow */],
    isIE: __WEBPACK_IMPORTED_MODULE_2__EnvUtils__["o" /* isIE */],
    disableCookies: disableCookies,
    newGuid: newGuid,
    perfNow: perfNow,
    newId: newId,
    randomValue: __WEBPACK_IMPORTED_MODULE_4__RandomHelper__["d" /* randomValue */],
    random32: __WEBPACK_IMPORTED_MODULE_4__RandomHelper__["c" /* random32 */],
    mwcRandomSeed: __WEBPACK_IMPORTED_MODULE_4__RandomHelper__["b" /* mwcRandomSeed */],
    mwcRandom32: __WEBPACK_IMPORTED_MODULE_4__RandomHelper__["a" /* mwcRandom32 */],
    generateW3CId: generateW3CId
};
var GuidRegex = /[xy]/g;
var EventHelper = {
    Attach: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["e" /* attachEvent */],
    AttachEvent: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["e" /* attachEvent */],
    Detach: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["h" /* detachEvent */],
    DetachEvent: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["h" /* detachEvent */]
};
/**
 * Helper to support backward compatibility for users that use the legacy cookie handling functions and the use the internal
 * CoreUtils._canUseCookies global flag to enable/disable cookies usage.
 * Note: This has the following deliberate side-effects
 * - Creates the global (legacy) cookie manager if it does not already exist
 * - Attempts to add "listeners" to the CoreUtils._canUseCookies property to support the legacy usage
 * @param config
 * @param logger
 * @returns
 */
function _legacyCookieMgr(config, logger) {
    var cookieMgr = Object(__WEBPACK_IMPORTED_MODULE_1__CookieMgr__["a" /* _gblCookieMgr */])(config, logger);
    var legacyCanUseCookies = CoreUtils._canUseCookies;
    if (_cookieMgrs === null) {
        _cookieMgrs = [];
        _canUseCookies = legacyCanUseCookies;
        // Dynamically create get/set property accessors for backward compatibility for enabling / disabling cookies
        // this WILL NOT work for ES3 browsers (< IE8)
        Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["z" /* objDefineAccessors */])(CoreUtils, "_canUseCookies", function () {
            return _canUseCookies;
        }, function (value) {
            _canUseCookies = value;
            Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["a" /* arrForEach */])(_cookieMgrs, function (mgr) {
                mgr.setEnabled(value);
            });
        });
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["b" /* arrIndexOf */])(_cookieMgrs, cookieMgr) === -1) {
        _cookieMgrs.push(cookieMgr);
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["m" /* isBoolean */])(legacyCanUseCookies)) {
        cookieMgr.setEnabled(legacyCanUseCookies);
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["m" /* isBoolean */])(_canUseCookies)) {
        cookieMgr.setEnabled(_canUseCookies);
    }
    return cookieMgr;
}
/**
 * @deprecated - Use the core.getCookieMgr().disable()
 * Force the SDK not to store and read any data from cookies.
 */
function disableCookies() {
    _legacyCookieMgr().setEnabled(false);
}
/**
 * @deprecated - Use the core.getCookieMgr().isEnabled()
 * Helper method to tell if document.cookie object is available and whether it can be used.
 */
function canUseCookies(logger) {
    return _legacyCookieMgr(null, logger).isEnabled();
}
/**
 * @deprecated - Use the core.getCookieMgr().get()
 * helper method to access userId and sessionId cookie
 */
function getCookie(logger, name) {
    return _legacyCookieMgr(null, logger).get(name);
}
/**
 * @deprecated - Use the core.getCookieMgr().set()
 * helper method to set userId and sessionId cookie
 */
function setCookie(logger, name, value, domain) {
    _legacyCookieMgr(null, logger).set(name, value, null, domain);
}
/**
 * @deprecated - Use the core.getCookieMgr().del()
 * Deletes a cookie by setting it's expiration time in the past.
 * @param name - The name of the cookie to delete.
 */
function deleteCookie(logger, name) {
    return _legacyCookieMgr(null, logger).del(name);
}
//# sourceMappingURL=CoreUtils.js.map

/***/ }),
/* 1465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InstrumentProto */
/* unused harmony export InstrumentProtos */
/* unused harmony export InstrumentFunc */
/* unused harmony export InstrumentFuncs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HelperFuncs__ = __webpack_require__(44);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var aiInstrumentHooks = "_aiHooks";
;
var cbNames = [
    "req", "rsp", "hkErr", "fnErr"
];
/**
 * Constant string defined to support minimization
 * @ignore
 */
var str__Proto = "__proto__";
/**
 * Constant string defined to support minimization
 * @ignore
 */
var strConstructor = "constructor";
/** @ignore */
function _arrLoop(arr, fn) {
    if (arr) {
        for (var lp = 0; lp < arr.length; lp++) {
            if (fn(arr[lp], lp)) {
                break;
            }
        }
    }
}
/** @ignore */
function _doCallbacks(hooks, callDetails, cbArgs, hookCtx, type) {
    if (type >= 0 /* Request */ && type <= 2 /* HookError */) {
        _arrLoop(hooks, function (hook, idx) {
            var cbks = hook.cbks;
            var cb = cbks[cbNames[type]];
            if (cb) {
                // Set the specific hook context implementation using a lazy creation pattern
                callDetails.ctx = function () {
                    var ctx = hookCtx[idx] = (hookCtx[idx] || {});
                    return ctx;
                };
                try {
                    cb.apply(callDetails.inst, cbArgs);
                }
                catch (err) {
                    var orgEx = callDetails.err;
                    try {
                        // Report Hook error via the callback
                        var hookErrorCb = cbks[cbNames[2 /* HookError */]];
                        if (hookErrorCb) {
                            callDetails.err = err;
                            hookErrorCb.apply(callDetails.inst, cbArgs);
                        }
                    }
                    catch (e) {
                        // Not much we can do here -- swallowing the exception to avoid crashing the hosting app
                    }
                    finally {
                        // restore the original exception (if any)
                        callDetails.err = orgEx;
                    }
                }
            }
        });
    }
}
/** @ignore */
function _createFunctionHook(aiHook) {
    // Define a temporary method that queues-up a the real method call
    return function () {
        var funcThis = this;
        // Capture the original arguments passed to the method
        var orgArgs = arguments;
        var hooks = aiHook.h;
        var funcArgs = {
            name: aiHook.n,
            inst: funcThis,
            ctx: null,
            set: _replaceArg
        };
        var hookCtx = [];
        var cbArgs = _createArgs([funcArgs], orgArgs);
        function _createArgs(target, theArgs) {
            _arrLoop(theArgs, function (arg) {
                target.push(arg);
            });
            return target;
        }
        function _replaceArg(idx, value) {
            orgArgs = _createArgs([], orgArgs);
            orgArgs[idx] = value;
            cbArgs = _createArgs([funcArgs], orgArgs);
        }
        // Call the pre-request hooks
        _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 0 /* Request */);
        // Call the original function was called
        var theFunc = aiHook.f;
        try {
            funcArgs.rslt = theFunc.apply(funcThis, orgArgs);
        }
        catch (err) {
            // Report the request callback
            funcArgs.err = err;
            _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 3 /* FunctionError */);
            // rethrow the original exception so anyone listening for it can catch the exception
            throw err;
        }
        // Call the post-request hooks
        _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 1 /* Response */);
        return funcArgs.rslt;
    };
}
/**
 * Pre-lookup to check if we are running on a modern browser (i.e. not IE8)
 * @ignore
 */
var _objGetPrototypeOf = Object["getPrototypeOf"];
/**
 * Helper used to get the prototype of the target object as getPrototypeOf is not available in an ES3 environment.
 * @ignore
 */
function _getObjProto(target) {
    if (target) {
        // This method doesn't existing in older browsers (e.g. IE8)
        if (_objGetPrototypeOf) {
            return _objGetPrototypeOf(target);
        }
        // target[Constructor] May break if the constructor has been changed or removed
        var newProto = target[str__Proto] || target[__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["l" /* strShimPrototype */]] || target[strConstructor];
        if (newProto) {
            return newProto;
        }
    }
    return null;
}
/** @ignore */
function _getOwner(target, name, checkPrototype) {
    var owner = null;
    if (target) {
        if (Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["k" /* hasOwnProperty */])(target, name)) {
            owner = target;
        }
        else if (checkPrototype) {
            owner = _getOwner(_getObjProto(target), name, false);
        }
    }
    return owner;
}
/**
 * Intercept the named prototype functions for the target class / object
 * @param target - The target object
 * @param funcName - The function name
 * @param callbacks - The callbacks to configure and call whenever the function is called
 */
function InstrumentProto(target, funcName, callbacks) {
    if (target) {
        return InstrumentFunc(target[__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["l" /* strShimPrototype */]], funcName, callbacks, false);
    }
    return null;
}
/**
 * Intercept the named prototype functions for the target class / object
 * @param target - The target object
 * @param funcNames - The function names to intercept and call
 * @param callbacks - The callbacks to configure and call whenever the function is called
 */
function InstrumentProtos(target, funcNames, callbacks) {
    if (target) {
        return InstrumentFuncs(target[__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["l" /* strShimPrototype */]], funcNames, callbacks, false);
    }
    return null;
}
/**
 * Intercept the named prototype functions for the target class / object
 * @param target - The target object
 * @param funcName - The function name
 * @param callbacks - The callbacks to configure and call whenever the function is called
 * @param checkPrototype - If the function doesn't exist on the target should it attempt to hook the prototype function
 */
function InstrumentFunc(target, funcName, callbacks, checkPrototype) {
    if (checkPrototype === void 0) { checkPrototype = true; }
    if (target && funcName && callbacks) {
        var owner = _getOwner(target, funcName, checkPrototype);
        if (owner) {
            var fn = owner[funcName];
            if (typeof fn === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["j" /* strShimFunction */]) {
                var aiHook_1 = fn[aiInstrumentHooks];
                if (!aiHook_1) {
                    // Only hook the function once
                    aiHook_1 = {
                        i: 0,
                        n: funcName,
                        f: fn,
                        h: []
                    };
                    // Override (hook) the original function
                    var newFunc = _createFunctionHook(aiHook_1);
                    newFunc[aiInstrumentHooks] = aiHook_1; // Tag and store the function hooks
                    owner[funcName] = newFunc;
                }
                var theHook = {
                    // tslint:disable:object-literal-shorthand
                    id: aiHook_1.i,
                    cbks: callbacks,
                    rm: function () {
                        // DO NOT Use () => { shorthand for the function as the this gets replaced
                        // with the outer this and not the this for theHook instance.
                        var id = this.id;
                        _arrLoop(aiHook_1.h, function (hook, idx) {
                            if (hook.id === id) {
                                aiHook_1.h.splice(idx, 1);
                                return 1;
                            }
                        });
                    }
                    // tslint:enable:object-literal-shorthand
                };
                aiHook_1.i++;
                aiHook_1.h.push(theHook);
                return theHook;
            }
        }
    }
    return null;
}
/**
 * Intercept the named functions for the target class / object
 * @param target - The target object
 * @param funcNames - The function names to intercept and call
 * @param callbacks - The callbacks to configure and call whenever the function is called
 * @param checkPrototype - If the function doesn't exist on the target should it attempt to hook the prototype function
 */
function InstrumentFuncs(target, funcNames, callbacks, checkPrototype) {
    if (checkPrototype === void 0) { checkPrototype = true; }
    var hooks = null;
    _arrLoop(funcNames, function (funcName) {
        var hook = InstrumentFunc(target, funcName, callbacks, checkPrototype);
        if (hook) {
            if (!hooks) {
                hooks = [];
            }
            hooks.push(hook);
        }
    });
    return hooks;
}
//# sourceMappingURL=InstrumentHooks.js.map

/***/ }),
/* 1466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export parseConnectionString */
/* unused harmony export ConnectionStringParser */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__ = __webpack_require__(34);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var _FIELDS_SEPARATOR = ";";
var _FIELD_KEY_VALUE_SEPARATOR = "=";
function parseConnectionString(connectionString) {
    if (!connectionString) {
        return {};
    }
    var kvPairs = connectionString.split(_FIELDS_SEPARATOR);
    var result = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["g" /* arrReduce */])(kvPairs, function (fields, kv) {
        var kvParts = kv.split(_FIELD_KEY_VALUE_SEPARATOR);
        if (kvParts.length === 2) {
            var key = kvParts[0].toLowerCase();
            var value = kvParts[1];
            fields[key] = value;
        }
        return fields;
    }, {});
    if (Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["L" /* objKeys */])(result).length > 0) {
        // this is a valid connection string, so parse the results
        if (result.endpointsuffix) {
            // use endpoint suffix where overrides are not provided
            var locationPrefix = result.location ? result.location + "." : "";
            result.ingestionendpoint = result.ingestionendpoint || ("https://" + locationPrefix + "dc." + result.endpointsuffix);
        }
        // apply the default endpoints
        result.ingestionendpoint = result.ingestionendpoint || __WEBPACK_IMPORTED_MODULE_0__Constants__["a" /* DEFAULT_BREEZE_ENDPOINT */];
    }
    return result;
}
var ConnectionStringParser = {
    parse: parseConnectionString
};
//# sourceMappingURL=ConnectionStringParser.js.map

/***/ }),
/* 1467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Envelope */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_Envelope__ = __webpack_require__(1468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DataSanitizer__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Constants__ = __webpack_require__(81);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







var Envelope = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(Envelope, _super);
    /**
     * Constructs a new instance of telemetry data.
     */
    function Envelope(logger, data, name) {
        var _this = _super.call(this) || this;
        _this.name = Object(__WEBPACK_IMPORTED_MODULE_2__DataSanitizer__["f" /* dataSanitizeString */])(logger, name) || __WEBPACK_IMPORTED_MODULE_4__Constants__["b" /* strNotSpecified */];
        _this.data = data;
        _this.time = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["S" /* toISOString */])(new Date());
        _this.aiDataContract = {
            time: 1 /* Required */,
            iKey: 1 /* Required */,
            name: 1 /* Required */,
            sampleRate: function () {
                return (_this.sampleRate === 100) ? 4 /* Hidden */ : 1 /* Required */;
            },
            tags: 1 /* Required */,
            data: 1 /* Required */
        };
        return _this;
    }
    return Envelope;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_Envelope__["a" /* Envelope */]));

//# sourceMappingURL=Envelope.js.map

/***/ }),
/* 1468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Envelope; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * System variables for a telemetry item.
 */
var Envelope = /** @class */ (function () {
    function Envelope() {
        /**
         * Envelope version. For internal use only. By assigning this the default, it will not be serialized within the payload unless changed to a value other than #1.
         */
        this.ver = 1;
        /**
         * Sampling rate used in application. This telemetry item represents 1 / sampleRate actual telemetry items.
         */
        this.sampleRate = 100.0;
        /**
         * Key/value collection of context properties. See ContextTagKeys for information on available properties.
         */
        this.tags = {};
    }
    return Envelope;
}());

//# sourceMappingURL=Envelope.js.map

/***/ }),
/* 1469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Event */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_EventData__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Constants__ = __webpack_require__(81);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var Event = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(Event, _super);
    /**
     * Constructs a new instance of the EventTelemetry object
     */
    function Event(logger, name, properties, measurements) {
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            ver: 1 /* Required */,
            name: 1 /* Required */,
            properties: 0 /* Default */,
            measurements: 0 /* Default */
        };
        _this.name = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, name) || __WEBPACK_IMPORTED_MODULE_3__Constants__["b" /* strNotSpecified */];
        _this.properties = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["e" /* dataSanitizeProperties */])(logger, properties);
        _this.measurements = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["c" /* dataSanitizeMeasurements */])(logger, measurements);
        return _this;
    }
    Event.envelopeType = "Microsoft.ApplicationInsights.{0}.Event";
    Event.dataType = "EventData";
    return Event;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_EventData__["a" /* EventData */]));

//# sourceMappingURL=Event.js.map

/***/ }),
/* 1470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export _formatErrorCode */
/* unused harmony export Exception */
/* unused harmony export _ExceptionDetails */
/* unused harmony export _StackFrame */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_StackFrame__ = __webpack_require__(1471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Interfaces_Contracts_Generated_ExceptionData__ = __webpack_require__(1472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Interfaces_Contracts_Generated_ExceptionDetails__ = __webpack_require__(1473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Common_DataSanitizer__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Constants__ = __webpack_require__(81);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */









var NoMethod = "<no_method>";
var strError = "error";
var strStack = "stack";
var strStackDetails = "stackDetails";
var strErrorSrc = "errorSrc";
var strMessage = "message";
var strDescription = "description";
function _stringify(value, convertToString) {
    var result = value;
    if (result && !Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["I" /* isString */])(result)) {
        if (JSON && JSON.stringify) {
            result = JSON.stringify(value);
            if (convertToString && (!result || result === "{}")) {
                if (Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["F" /* isFunction */])(value.toString)) {
                    result = value.toString();
                }
                else {
                    result = "" + value;
                }
            }
        }
        else {
            result = "" + value + " - (Missing JSON.stringify)";
        }
    }
    return result || "";
}
function _formatMessage(theEvent, errorType) {
    var evtMessage = theEvent;
    if (theEvent) {
        evtMessage = theEvent[strMessage] || theEvent[strDescription] || "";
        // Make sure the message is a string
        if (evtMessage && !Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["I" /* isString */])(evtMessage)) {
            // tslint:disable-next-line: prefer-conditional-expression
            evtMessage = _stringify(evtMessage, true);
        }
        if (theEvent["filename"]) {
            // Looks like an event object with filename
            evtMessage = evtMessage + " @" + (theEvent["filename"] || "") + ":" + (theEvent["lineno"] || "?") + ":" + (theEvent["colno"] || "?");
        }
    }
    // Automatically add the error type to the message if it does already appear to be present
    if (errorType && errorType !== "String" && errorType !== "Object" && errorType !== "Error" && (evtMessage || "").indexOf(errorType) === -1) {
        evtMessage = errorType + ": " + evtMessage;
    }
    return evtMessage || "";
}
function _isExceptionDetailsInternal(value) {
    if (Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["H" /* isObject */])(value)) {
        return "hasFullStack" in value && "typeName" in value;
    }
    return false;
}
function _isExceptionInternal(value) {
    if (Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["H" /* isObject */])(value)) {
        return ("ver" in value && "exceptions" in value && "properties" in value);
    }
    return false;
}
function _isStackDetails(details) {
    return details && details.src && Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["I" /* isString */])(details.src) && details.obj && Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["C" /* isArray */])(details.obj);
}
function _convertStackObj(errorStack) {
    var src = errorStack || "";
    if (!Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["I" /* isString */])(src)) {
        if (Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["I" /* isString */])(src[strStack])) {
            src = src[strStack];
        }
        else {
            src = "" + src;
        }
    }
    var items = src.split("\n");
    return {
        src: src,
        obj: items
    };
}
function _getOperaStack(errorMessage) {
    var stack = [];
    var lines = errorMessage.split("\n");
    for (var lp = 0; lp < lines.length; lp++) {
        var entry = lines[lp];
        if (lines[lp + 1]) {
            entry += "@" + lines[lp + 1];
            lp++;
        }
        stack.push(entry);
    }
    return {
        src: errorMessage,
        obj: stack
    };
}
function _getStackFromErrorObj(errorObj) {
    var details = null;
    if (errorObj) {
        try {
            /* Using bracket notation is support older browsers (IE 7/8 -- dont remember the version) that throw when using dot
            notation for undefined objects and we don't want to loose the error from being reported */
            if (errorObj[strStack]) {
                // Chrome/Firefox
                details = _convertStackObj(errorObj[strStack]);
            }
            else if (errorObj[strError] && errorObj[strError][strStack]) {
                // Edge error event provides the stack and error object
                details = _convertStackObj(errorObj[strError][strStack]);
            }
            else if (errorObj['exception'] && errorObj.exception[strStack]) {
                details = _convertStackObj(errorObj.exception[strStack]);
            }
            else if (_isStackDetails(errorObj)) {
                details = errorObj;
            }
            else if (_isStackDetails(errorObj[strStackDetails])) {
                details = errorObj[strStackDetails];
            }
            else if (window['opera'] && errorObj[strMessage]) {
                // Opera
                details = _getOperaStack(errorObj.message);
            }
            else if (Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["I" /* isString */])(errorObj)) {
                details = _convertStackObj(errorObj);
            }
            else {
                var evtMessage = errorObj[strMessage] || errorObj[strDescription] || "";
                if (Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["I" /* isString */])(errorObj[strErrorSrc])) {
                    if (evtMessage) {
                        evtMessage += "\n";
                    }
                    evtMessage += " from " + errorObj[strErrorSrc];
                }
                if (evtMessage) {
                    details = _convertStackObj(evtMessage);
                }
            }
        }
        catch (e) {
            // something unexpected happened so to avoid failing to report any error lets swallow the exception 
            // and fallback to the callee/caller method
            details = _convertStackObj(e);
        }
    }
    return details || {
        src: "",
        obj: null
    };
}
function _formatStackTrace(stackDetails) {
    var stack = "";
    if (stackDetails) {
        if (stackDetails.obj) {
            Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["e" /* arrForEach */])(stackDetails.obj, function (entry) {
                stack += entry + "\n";
            });
        }
        else {
            stack = stackDetails.src || "";
        }
    }
    return stack;
}
function _parseStack(stack) {
    var parsedStack;
    var frames = stack.obj;
    if (frames && frames.length > 0) {
        parsedStack = [];
        var level_1 = 0;
        var totalSizeInBytes_1 = 0;
        Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["e" /* arrForEach */])(frames, function (frame) {
            var theFrame = frame.toString();
            if (_StackFrame.regex.test(theFrame)) {
                var parsedFrame = new _StackFrame(theFrame, level_1++);
                totalSizeInBytes_1 += parsedFrame.sizeInBytes;
                parsedStack.push(parsedFrame);
            }
        });
        // DP Constraint - exception parsed stack must be < 32KB
        // remove frames from the middle to meet the threshold
        var exceptionParsedStackThreshold = 32 * 1024;
        if (totalSizeInBytes_1 > exceptionParsedStackThreshold) {
            var left = 0;
            var right = parsedStack.length - 1;
            var size = 0;
            var acceptedLeft = left;
            var acceptedRight = right;
            while (left < right) {
                // check size
                var lSize = parsedStack[left].sizeInBytes;
                var rSize = parsedStack[right].sizeInBytes;
                size += lSize + rSize;
                if (size > exceptionParsedStackThreshold) {
                    // remove extra frames from the middle
                    var howMany = acceptedRight - acceptedLeft + 1;
                    parsedStack.splice(acceptedLeft, howMany);
                    break;
                }
                // update pointers
                acceptedLeft = left;
                acceptedRight = right;
                left++;
                right--;
            }
        }
    }
    return parsedStack;
}
function _getErrorType(errorType) {
    // Gets the Error Type by passing the constructor (used to get the true type of native error object).
    var typeName = "";
    if (errorType) {
        typeName = errorType.typeName || errorType.name || "";
        if (!typeName) {
            try {
                var funcNameRegex = /function (.{1,})\(/;
                var results = (funcNameRegex).exec((errorType).constructor.toString());
                typeName = (results && results.length > 1) ? results[1] : "";
            }
            catch (e) {
                // Ignore
            }
        }
    }
    return typeName;
}
/**
 * Formats the provided errorObj for display and reporting, it may be a String, Object, integer or undefined depending on the browser.
 * @param errorObj The supplied errorObj
 */
function _formatErrorCode(errorObj) {
    if (errorObj) {
        try {
            if (!Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["I" /* isString */])(errorObj)) {
                var errorType = _getErrorType(errorObj);
                var result = _stringify(errorObj, false);
                if (!result || result === "{}") {
                    if (errorObj[strError]) {
                        // Looks like an MS Error Event
                        errorObj = errorObj[strError];
                        errorType = _getErrorType(errorObj);
                    }
                    result = _stringify(errorObj, true);
                }
                if (result.indexOf(errorType) !== 0 && errorType !== "String") {
                    return errorType + ":" + result;
                }
                return result;
            }
        }
        catch (e) {
        }
    }
    // Fallback to just letting the object format itself into a string
    return "" + (errorObj || "");
}
var Exception = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(Exception, _super);
    /**
     * Constructs a new instance of the ExceptionTelemetry object
     */
    function Exception(logger, exception, properties, measurements, severityLevel, id) {
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            ver: 1 /* Required */,
            exceptions: 1 /* Required */,
            severityLevel: 0 /* Default */,
            properties: 0 /* Default */,
            measurements: 0 /* Default */
        };
        if (!_isExceptionInternal(exception)) {
            if (!properties) {
                properties = {};
            }
            _this.exceptions = [new _ExceptionDetails(logger, exception, properties)];
            _this.properties = Object(__WEBPACK_IMPORTED_MODULE_4__Common_DataSanitizer__["e" /* dataSanitizeProperties */])(logger, properties);
            _this.measurements = Object(__WEBPACK_IMPORTED_MODULE_4__Common_DataSanitizer__["c" /* dataSanitizeMeasurements */])(logger, measurements);
            if (severityLevel) {
                _this.severityLevel = severityLevel;
            }
            if (id) {
                _this.id = id;
            }
        }
        else {
            _this.exceptions = exception.exceptions;
            _this.properties = exception.properties;
            _this.measurements = exception.measurements;
            if (exception.severityLevel) {
                _this.severityLevel = exception.severityLevel;
            }
            if (exception.id) {
                _this.id = exception.id;
            }
            if (exception.problemGroup) {
                _this.problemGroup = exception.problemGroup;
            }
            // bool/int types, use isNullOrUndefined
            _this.ver = 2; // TODO: handle the CS"4.0" ==> breeze 2 conversion in a better way
            if (!Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(exception.isManual)) {
                _this.isManual = exception.isManual;
            }
        }
        return _this;
    }
    Exception.CreateAutoException = function (message, url, lineNumber, columnNumber, error, evt, stack, errorSrc) {
        var errorType = _getErrorType(error || evt || message);
        return {
            message: _formatMessage(message, errorType),
            url: url,
            lineNumber: lineNumber,
            columnNumber: columnNumber,
            error: _formatErrorCode(error || evt || message),
            evt: _formatErrorCode(evt || message),
            typeName: errorType,
            stackDetails: _getStackFromErrorObj(stack || error || evt),
            errorSrc: errorSrc
        };
    };
    Exception.CreateFromInterface = function (logger, exception, properties, measurements) {
        var exceptions = exception.exceptions
            && Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["f" /* arrMap */])(exception.exceptions, function (ex) { return _ExceptionDetails.CreateFromInterface(logger, ex); });
        var exceptionData = new Exception(logger, Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["f" /* __assignFn */])({}, exception, { exceptions: exceptions }), properties, measurements);
        return exceptionData;
    };
    Exception.prototype.toInterface = function () {
        var _a = this, exceptions = _a.exceptions, properties = _a.properties, measurements = _a.measurements, severityLevel = _a.severityLevel, ver = _a.ver, problemGroup = _a.problemGroup, id = _a.id, isManual = _a.isManual;
        var exceptionDetailsInterface = exceptions instanceof Array
            && Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["f" /* arrMap */])(exceptions, function (exception) { return exception.toInterface(); })
            || undefined;
        return {
            ver: "4.0",
            exceptions: exceptionDetailsInterface,
            severityLevel: severityLevel,
            properties: properties,
            measurements: measurements,
            problemGroup: problemGroup,
            id: id,
            isManual: isManual
        };
    };
    /**
     * Creates a simple exception with 1 stack frame. Useful for manual constracting of exception.
     */
    Exception.CreateSimpleException = function (message, typeName, assembly, fileName, details, line) {
        return {
            exceptions: [
                {
                    hasFullStack: true,
                    message: message,
                    stack: details,
                    typeName: typeName
                }
            ]
        };
    };
    Exception.envelopeType = "Microsoft.ApplicationInsights.{0}.Exception";
    Exception.dataType = "ExceptionData";
    Exception.formatError = _formatErrorCode;
    return Exception;
}(__WEBPACK_IMPORTED_MODULE_2__Interfaces_Contracts_Generated_ExceptionData__["a" /* ExceptionData */]));

var _ExceptionDetails = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(_ExceptionDetails, _super);
    function _ExceptionDetails(logger, exception, properties) {
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            id: 0 /* Default */,
            outerId: 0 /* Default */,
            typeName: 1 /* Required */,
            message: 1 /* Required */,
            hasFullStack: 0 /* Default */,
            stack: 0 /* Default */,
            parsedStack: 2 /* Array */
        };
        if (!_isExceptionDetailsInternal(exception)) {
            var error = exception;
            var evt = error && error.evt;
            if (!Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["E" /* isError */])(error)) {
                error = error[strError] || evt || error;
            }
            _this.typeName = Object(__WEBPACK_IMPORTED_MODULE_4__Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, _getErrorType(error)) || __WEBPACK_IMPORTED_MODULE_6__Constants__["b" /* strNotSpecified */];
            _this.message = Object(__WEBPACK_IMPORTED_MODULE_4__Common_DataSanitizer__["d" /* dataSanitizeMessage */])(logger, _formatMessage(exception || error, _this.typeName)) || __WEBPACK_IMPORTED_MODULE_6__Constants__["b" /* strNotSpecified */];
            var stack = exception[strStackDetails] || _getStackFromErrorObj(exception);
            _this.parsedStack = _parseStack(stack);
            _this[strStack] = Object(__WEBPACK_IMPORTED_MODULE_4__Common_DataSanitizer__["a" /* dataSanitizeException */])(logger, _formatStackTrace(stack));
            _this.hasFullStack = Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["C" /* isArray */])(_this.parsedStack) && _this.parsedStack.length > 0;
            if (properties) {
                properties.typeName = properties.typeName || _this.typeName;
            }
        }
        else {
            _this.typeName = exception.typeName;
            _this.message = exception.message;
            _this[strStack] = exception[strStack];
            _this.parsedStack = exception.parsedStack;
            _this.hasFullStack = exception.hasFullStack;
        }
        return _this;
    }
    _ExceptionDetails.prototype.toInterface = function () {
        var parsedStack = this.parsedStack instanceof Array
            && Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["f" /* arrMap */])(this.parsedStack, function (frame) { return frame.toInterface(); });
        var exceptionDetailsInterface = {
            id: this.id,
            outerId: this.outerId,
            typeName: this.typeName,
            message: this.message,
            hasFullStack: this.hasFullStack,
            stack: this[strStack],
            parsedStack: parsedStack || undefined
        };
        return exceptionDetailsInterface;
    };
    _ExceptionDetails.CreateFromInterface = function (logger, exception) {
        var parsedStack = (exception.parsedStack instanceof Array
            && Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["f" /* arrMap */])(exception.parsedStack, function (frame) { return _StackFrame.CreateFromInterface(frame); }))
            || exception.parsedStack;
        var exceptionDetails = new _ExceptionDetails(logger, Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["f" /* __assignFn */])({}, exception, { parsedStack: parsedStack }));
        return exceptionDetails;
    };
    return _ExceptionDetails;
}(__WEBPACK_IMPORTED_MODULE_3__Interfaces_Contracts_Generated_ExceptionDetails__["a" /* ExceptionDetails */]));

var _StackFrame = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(_StackFrame, _super);
    function _StackFrame(sourceFrame, level) {
        var _this = _super.call(this) || this;
        _this.sizeInBytes = 0;
        _this.aiDataContract = {
            level: 1 /* Required */,
            method: 1 /* Required */,
            assembly: 0 /* Default */,
            fileName: 0 /* Default */,
            line: 0 /* Default */
        };
        // Not converting this to isString() as typescript uses this logic to "understand" the different
        // types for the 2 different code paths
        if (typeof sourceFrame === "string") {
            var frame = sourceFrame;
            _this.level = level;
            _this.method = NoMethod;
            _this.assembly = Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["R" /* strTrim */])(frame);
            _this.fileName = "";
            _this.line = 0;
            var matches = frame.match(_StackFrame.regex);
            if (matches && matches.length >= 5) {
                _this.method = Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["R" /* strTrim */])(matches[2]) || _this.method;
                _this.fileName = Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["R" /* strTrim */])(matches[4]);
                _this.line = parseInt(matches[5]) || 0;
            }
        }
        else {
            _this.level = sourceFrame.level;
            _this.method = sourceFrame.method;
            _this.assembly = sourceFrame.assembly;
            _this.fileName = sourceFrame.fileName;
            _this.line = sourceFrame.line;
            _this.sizeInBytes = 0;
        }
        _this.sizeInBytes += _this.method.length;
        _this.sizeInBytes += _this.fileName.length;
        _this.sizeInBytes += _this.assembly.length;
        // todo: these might need to be removed depending on how the back-end settles on their size calculation
        _this.sizeInBytes += _StackFrame.baseSize;
        _this.sizeInBytes += _this.level.toString().length;
        _this.sizeInBytes += _this.line.toString().length;
        return _this;
    }
    _StackFrame.CreateFromInterface = function (frame) {
        return new _StackFrame(frame, null /* level is available in frame interface */);
    };
    _StackFrame.prototype.toInterface = function () {
        return {
            level: this.level,
            method: this.method,
            assembly: this.assembly,
            fileName: this.fileName,
            line: this.line
        };
    };
    // regex to match stack frames from ie/chrome/ff
    // methodName=$2, fileName=$4, lineNo=$5, column=$6
    _StackFrame.regex = /^([\s]+at)?[\s]*([^\@\()]+?)[\s]*(\@|\()([^\(\n]+):([0-9]+):([0-9]+)(\)?)$/;
    _StackFrame.baseSize = 58; // '{"method":"","level":,"assembly":"","fileName":"","line":}'.length
    return _StackFrame;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_StackFrame__["a" /* StackFrame */]));

//# sourceMappingURL=Exception.js.map

/***/ }),
/* 1471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StackFrame; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// THIS FILE WAS AUTOGENERATED
/**
 * Stack frame information.
 */
var StackFrame = /** @class */ (function () {
    function StackFrame() {
    }
    return StackFrame;
}());

//# sourceMappingURL=StackFrame.js.map

/***/ }),
/* 1472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExceptionData; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * An instance of Exception represents a handled or unhandled exception that occurred during execution of the monitored application.
 */
var ExceptionData = /** @class */ (function () {
    function ExceptionData() {
        /**
         * Schema version
         */
        this.ver = 2;
        /**
         * Exception chain - list of inner exceptions.
         */
        this.exceptions = [];
        /**
         * Collection of custom properties.
         */
        this.properties = {};
        /**
         * Collection of custom measurements.
         */
        this.measurements = {};
    }
    return ExceptionData;
}());

//# sourceMappingURL=ExceptionData.js.map

/***/ }),
/* 1473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExceptionDetails; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * Exception details of the exception in a chain.
 */
var ExceptionDetails = /** @class */ (function () {
    function ExceptionDetails() {
        /**
         * Indicates if full exception stack is provided in the exception. The stack may be trimmed, such as in the case of a StackOverflow exception.
         */
        this.hasFullStack = true;
        /**
         * List of stack frames. Either stack or parsedStack should have a value.
         */
        this.parsedStack = [];
    }
    return ExceptionDetails;
}());

//# sourceMappingURL=ExceptionDetails.js.map

/***/ }),
/* 1474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Metric */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_MetricData__ = __webpack_require__(1475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Common_DataPoint__ = __webpack_require__(1476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Constants__ = __webpack_require__(81);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







var Metric = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(Metric, _super);
    /**
     * Constructs a new instance of the MetricTelemetry object
     */
    function Metric(logger, name, value, count, min, max, properties, measurements) {
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            ver: 1 /* Required */,
            metrics: 1 /* Required */,
            properties: 0 /* Default */
        };
        var dataPoint = new __WEBPACK_IMPORTED_MODULE_3__Common_DataPoint__["a" /* DataPoint */]();
        dataPoint.count = count > 0 ? count : undefined;
        dataPoint.max = isNaN(max) || max === null ? undefined : max;
        dataPoint.min = isNaN(min) || min === null ? undefined : min;
        dataPoint.name = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, name) || __WEBPACK_IMPORTED_MODULE_4__Constants__["b" /* strNotSpecified */];
        dataPoint.value = value;
        _this.metrics = [dataPoint];
        _this.properties = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["e" /* dataSanitizeProperties */])(logger, properties);
        _this.measurements = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["c" /* dataSanitizeMeasurements */])(logger, measurements);
        return _this;
    }
    Metric.envelopeType = "Microsoft.ApplicationInsights.{0}.Metric";
    Metric.dataType = "MetricData";
    return Metric;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_MetricData__["a" /* MetricData */]));

//# sourceMappingURL=Metric.js.map

/***/ }),
/* 1475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MetricData; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * An instance of the Metric item is a list of measurements (single data points) and/or aggregations.
 */
var MetricData = /** @class */ (function () {
    function MetricData() {
        /**
         * Schema version
         */
        this.ver = 2;
        /**
         * List of metrics. Only one metric in the list is currently supported by Application Insights storage. If multiple data points were sent only the first one will be used.
         */
        this.metrics = [];
        /**
         * Collection of custom properties.
         */
        this.properties = {};
        /**
         * Collection of custom measurements.
         */
        this.measurements = {};
    }
    return MetricData;
}());

//# sourceMappingURL=MetricData.js.map

/***/ }),
/* 1476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataPoint; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_DataPoint__ = __webpack_require__(1477);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var DataPoint = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(DataPoint, _super);
    function DataPoint() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * The data contract for serializing this object.
         */
        _this.aiDataContract = {
            name: 1 /* Required */,
            kind: 0 /* Default */,
            value: 1 /* Required */,
            count: 0 /* Default */,
            min: 0 /* Default */,
            max: 0 /* Default */,
            stdDev: 0 /* Default */
        };
        return _this;
    }
    return DataPoint;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_DataPoint__["a" /* DataPoint */]));

//# sourceMappingURL=DataPoint.js.map

/***/ }),
/* 1477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataPoint; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataPointType__ = __webpack_require__(1478);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



/**
 * Metric data single measurement.
 */
var DataPoint = /** @class */ (function () {
    function DataPoint() {
        /**
         * Metric type. Single measurement or the aggregated value.
         */
        this.kind = __WEBPACK_IMPORTED_MODULE_0__DataPointType__["a" /* DataPointType */].Measurement;
    }
    return DataPoint;
}());

//# sourceMappingURL=DataPoint.js.map

/***/ }),
/* 1478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataPointType; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// THIS FILE WAS AUTOGENERATED
/**
 * Type of the metric data measurement.
 */
var DataPointType;
(function (DataPointType) {
    DataPointType[DataPointType["Measurement"] = 0] = "Measurement";
    DataPointType[DataPointType["Aggregation"] = 1] = "Aggregation";
})(DataPointType || (DataPointType = {}));
//# sourceMappingURL=DataPointType.js.map

/***/ }),
/* 1479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_PageViewData__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Constants__ = __webpack_require__(81);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







var PageView = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(PageView, _super);
    /**
     * Constructs a new instance of the PageEventTelemetry object
     */
    function PageView(logger, name, url, durationMs, properties, measurements, id) {
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            ver: 1 /* Required */,
            name: 0 /* Default */,
            url: 0 /* Default */,
            duration: 0 /* Default */,
            properties: 0 /* Default */,
            measurements: 0 /* Default */,
            id: 0 /* Default */
        };
        _this.id = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["b" /* dataSanitizeId */])(logger, id);
        _this.url = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["g" /* dataSanitizeUrl */])(logger, url);
        _this.name = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, name) || __WEBPACK_IMPORTED_MODULE_4__Constants__["b" /* strNotSpecified */];
        if (!isNaN(durationMs)) {
            _this.duration = Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["d" /* msToTimeSpan */])(durationMs);
        }
        _this.properties = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["e" /* dataSanitizeProperties */])(logger, properties);
        _this.measurements = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["c" /* dataSanitizeMeasurements */])(logger, measurements);
        return _this;
    }
    PageView.envelopeType = "Microsoft.ApplicationInsights.{0}.Pageview";
    PageView.dataType = "PageviewData";
    return PageView;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_PageViewData__["a" /* PageViewData */]));

//# sourceMappingURL=PageView.js.map

/***/ }),
/* 1480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RemoteDependencyData */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Common_DataSanitizer__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Util__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Interfaces_Contracts_Generated_RemoteDependencyData__ = __webpack_require__(1481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HelperFuncs__ = __webpack_require__(250);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







var RemoteDependencyData = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(RemoteDependencyData, _super);
    /**
     * Constructs a new instance of the RemoteDependencyData object
     */
    function RemoteDependencyData(logger, id, absoluteUrl, commandName, value, success, resultCode, method, requestAPI, correlationContext, properties, measurements) {
        if (requestAPI === void 0) { requestAPI = "Ajax"; }
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            id: 1 /* Required */,
            ver: 1 /* Required */,
            name: 0 /* Default */,
            resultCode: 0 /* Default */,
            duration: 0 /* Default */,
            success: 0 /* Default */,
            data: 0 /* Default */,
            target: 0 /* Default */,
            type: 0 /* Default */,
            properties: 0 /* Default */,
            measurements: 0 /* Default */,
            kind: 0 /* Default */,
            value: 0 /* Default */,
            count: 0 /* Default */,
            min: 0 /* Default */,
            max: 0 /* Default */,
            stdDev: 0 /* Default */,
            dependencyKind: 0 /* Default */,
            dependencySource: 0 /* Default */,
            commandName: 0 /* Default */,
            dependencyTypeName: 0 /* Default */
        };
        _this.id = id;
        _this.duration = Object(__WEBPACK_IMPORTED_MODULE_4__HelperFuncs__["d" /* msToTimeSpan */])(value);
        _this.success = success;
        _this.resultCode = resultCode + "";
        _this.type = Object(__WEBPACK_IMPORTED_MODULE_1__Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, requestAPI);
        var dependencyFields = Object(__WEBPACK_IMPORTED_MODULE_2__Util__["a" /* AjaxHelperParseDependencyPath */])(logger, absoluteUrl, method, commandName);
        _this.data = Object(__WEBPACK_IMPORTED_MODULE_1__Common_DataSanitizer__["g" /* dataSanitizeUrl */])(logger, commandName) || dependencyFields.data; // get a value from hosturl if commandName not available
        _this.target = Object(__WEBPACK_IMPORTED_MODULE_1__Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, dependencyFields.target);
        if (correlationContext) {
            _this.target = _this.target + " | " + correlationContext;
        }
        _this.name = Object(__WEBPACK_IMPORTED_MODULE_1__Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, dependencyFields.name);
        _this.properties = Object(__WEBPACK_IMPORTED_MODULE_1__Common_DataSanitizer__["e" /* dataSanitizeProperties */])(logger, properties);
        _this.measurements = Object(__WEBPACK_IMPORTED_MODULE_1__Common_DataSanitizer__["c" /* dataSanitizeMeasurements */])(logger, measurements);
        return _this;
    }
    RemoteDependencyData.envelopeType = "Microsoft.ApplicationInsights.{0}.RemoteDependency";
    RemoteDependencyData.dataType = "RemoteDependencyData";
    return RemoteDependencyData;
}(__WEBPACK_IMPORTED_MODULE_3__Interfaces_Contracts_Generated_RemoteDependencyData__["a" /* RemoteDependencyData */]));

//# sourceMappingURL=RemoteDependencyData.js.map

/***/ }),
/* 1481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RemoteDependencyData; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * An instance of Remote Dependency represents an interaction of the monitored component with a remote component/service like SQL or an HTTP endpoint.
 */
var RemoteDependencyData = /** @class */ (function () {
    function RemoteDependencyData() {
        /**
         * Schema version
         */
        this.ver = 2;
        /**
         * Indication of successful or unsuccessful call.
         */
        this.success = true;
        /**
         * Collection of custom properties.
         */
        this.properties = {};
        /**
         * Collection of custom measurements.
         */
        this.measurements = {};
    }
    return RemoteDependencyData;
}());

//# sourceMappingURL=RemoteDependencyData.js.map

/***/ }),
/* 1482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Trace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_MessageData__ = __webpack_require__(1483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Constants__ = __webpack_require__(81);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var Trace = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(Trace, _super);
    /**
     * Constructs a new instance of the TraceTelemetry object
     */
    function Trace(logger, message, severityLevel, properties, measurements) {
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            ver: 1 /* Required */,
            message: 1 /* Required */,
            severityLevel: 0 /* Default */,
            properties: 0 /* Default */
        };
        message = message || __WEBPACK_IMPORTED_MODULE_3__Constants__["b" /* strNotSpecified */];
        _this.message = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["d" /* dataSanitizeMessage */])(logger, message);
        _this.properties = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["e" /* dataSanitizeProperties */])(logger, properties);
        _this.measurements = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["c" /* dataSanitizeMeasurements */])(logger, measurements);
        if (severityLevel) {
            _this.severityLevel = severityLevel;
        }
        return _this;
    }
    Trace.envelopeType = "Microsoft.ApplicationInsights.{0}.Message";
    Trace.dataType = "MessageData";
    return Trace;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_MessageData__["a" /* MessageData */]));

//# sourceMappingURL=Trace.js.map

/***/ }),
/* 1483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MessageData; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * Instances of Message represent printf-like trace statements that are text-searched. Log4Net, NLog and other text-based log file entries are translated into intances of this type. The message does not have measurements.
 */
var MessageData = /** @class */ (function () {
    function MessageData() {
        /**
         * Schema version
         */
        this.ver = 2;
        /**
         * Collection of custom properties.
         */
        this.properties = {};
        /**
         * Collection of custom measurements.
         */
        this.measurements = {};
    }
    return MessageData;
}());

//# sourceMappingURL=MessageData.js.map

/***/ }),
/* 1484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PageViewPerformance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_PageViewPerfData__ = __webpack_require__(1485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Constants__ = __webpack_require__(81);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var PageViewPerformance = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(PageViewPerformance, _super);
    /**
     * Constructs a new instance of the PageEventTelemetry object
     */
    function PageViewPerformance(logger, name, url, unused, properties, measurements, cs4BaseData) {
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            ver: 1 /* Required */,
            name: 0 /* Default */,
            url: 0 /* Default */,
            duration: 0 /* Default */,
            perfTotal: 0 /* Default */,
            networkConnect: 0 /* Default */,
            sentRequest: 0 /* Default */,
            receivedResponse: 0 /* Default */,
            domProcessing: 0 /* Default */,
            properties: 0 /* Default */,
            measurements: 0 /* Default */
        };
        _this.url = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["g" /* dataSanitizeUrl */])(logger, url);
        _this.name = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, name) || __WEBPACK_IMPORTED_MODULE_3__Constants__["b" /* strNotSpecified */];
        _this.properties = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["e" /* dataSanitizeProperties */])(logger, properties);
        _this.measurements = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["c" /* dataSanitizeMeasurements */])(logger, measurements);
        if (cs4BaseData) {
            _this.domProcessing = cs4BaseData.domProcessing;
            _this.duration = cs4BaseData.duration;
            _this.networkConnect = cs4BaseData.networkConnect;
            _this.perfTotal = cs4BaseData.perfTotal;
            _this.receivedResponse = cs4BaseData.receivedResponse;
            _this.sentRequest = cs4BaseData.sentRequest;
        }
        return _this;
    }
    PageViewPerformance.envelopeType = "Microsoft.ApplicationInsights.{0}.PageviewPerformance";
    PageViewPerformance.dataType = "PageviewPerformanceData";
    return PageViewPerformance;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_PageViewPerfData__["a" /* PageViewPerfData */]));

//# sourceMappingURL=PageViewPerformance.js.map

/***/ }),
/* 1485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageViewPerfData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PageViewData__ = __webpack_require__(374);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



// THIS FILE WAS AUTOGENERATED

/**
 * An instance of PageViewPerf represents: a page view with no performance data, a page view with performance data, or just the performance data of an earlier page request.
 */
var PageViewPerfData = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(PageViewPerfData, _super);
    function PageViewPerfData() {
        var _this = _super.call(this) || this;
        /**
         * Schema version
         */
        _this.ver = 2;
        /**
         * Collection of custom properties.
         */
        _this.properties = {};
        /**
         * Collection of custom measurements.
         */
        _this.measurements = {};
        return _this;
    }
    return PageViewPerfData;
}(__WEBPACK_IMPORTED_MODULE_1__PageViewData__["a" /* PageViewData */]));

//# sourceMappingURL=PageViewPerfData.js.map

/***/ }),
/* 1486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Data */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_Data__ = __webpack_require__(591);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var Data = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(Data, _super);
    /**
     * Constructs a new instance of telemetry data.
     */
    function Data(baseType, data) {
        var _this = _super.call(this) || this;
        /**
         * The data contract for serializing this object.
         */
        _this.aiDataContract = {
            baseType: 1 /* Required */,
            baseData: 1 /* Required */
        };
        _this.baseType = baseType;
        _this.baseData = data;
        return _this;
    }
    return Data;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_Data__["a" /* Data */]));

//# sourceMappingURL=Data.js.map

/***/ }),
/* 1487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SeverityLevel */
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// THIS FILE WAS AUTOGENERATED
/**
 * Defines the level of severity for the event.
 */
var SeverityLevel;
(function (SeverityLevel) {
    SeverityLevel[SeverityLevel["Verbose"] = 0] = "Verbose";
    SeverityLevel[SeverityLevel["Information"] = 1] = "Information";
    SeverityLevel[SeverityLevel["Warning"] = 2] = "Warning";
    SeverityLevel[SeverityLevel["Error"] = 3] = "Error";
    SeverityLevel[SeverityLevel["Critical"] = 4] = "Critical";
})(SeverityLevel || (SeverityLevel = {}));
//# sourceMappingURL=SeverityLevel.js.map

/***/ }),
/* 1488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ConfigurationManager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(34);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



var ConfigurationManager = /** @class */ (function () {
    function ConfigurationManager() {
    }
    ConfigurationManager.getConfig = function (config, field, identifier, defaultValue) {
        if (defaultValue === void 0) { defaultValue = false; }
        var configValue;
        if (identifier && config.extensionConfig && config.extensionConfig[identifier] && !Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(config.extensionConfig[identifier][field])) {
            configValue = config.extensionConfig[identifier][field];
        }
        else {
            configValue = config[field];
        }
        return !Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(configValue) ? configValue : defaultValue;
    };
    return ConfigurationManager;
}());

//# sourceMappingURL=IConfig.js.map

/***/ }),
/* 1489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TelemetryItemCreator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Telemetry_Common_DataSanitizer__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Constants__ = __webpack_require__(81);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





var TelemetryItemCreator = /** @class */ (function () {
    function TelemetryItemCreator() {
    }
    /**
     * Create a telemetry item that the 1DS channel understands
     * @param item domain specific properties; part B
     * @param baseType telemetry item type. ie PageViewData
     * @param envelopeName name of the envelope. ie Microsoft.ApplicationInsights.<instrumentation key>.PageView
     * @param customProperties user defined custom properties; part C
     * @param systemProperties system properties that are added to the context; part A
     * @returns ITelemetryItem that is sent to channel
     */
    TelemetryItemCreator.create = function (item, baseType, envelopeName, logger, customProperties, systemProperties) {
        envelopeName = Object(__WEBPACK_IMPORTED_MODULE_0__Telemetry_Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, envelopeName) || __WEBPACK_IMPORTED_MODULE_2__Constants__["b" /* strNotSpecified */];
        if (Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(item) ||
            Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(baseType) ||
            Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(envelopeName)) {
            throw Error("Input doesn't contain all required fields");
        }
        var telemetryItem = {
            name: envelopeName,
            time: Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["S" /* toISOString */])(new Date()),
            iKey: "",
            ext: systemProperties ? systemProperties : {},
            tags: [],
            data: {},
            baseType: baseType,
            baseData: item // Part B
        };
        // Part C
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(customProperties)) {
            Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["K" /* objForEachKey */])(customProperties, function (prop, value) {
                telemetryItem.data[prop] = value;
            });
        }
        return telemetryItem;
    };
    return TelemetryItemCreator;
}());

//# sourceMappingURL=TelemetryItemCreator.js.map

/***/ }),
/* 1490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Extensions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CtxTagKeys; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Contracts_Generated_ContextTagKeys__ = __webpack_require__(594);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var Extensions = {
    UserExt: "user",
    DeviceExt: "device",
    TraceExt: "trace",
    WebExt: "web",
    AppExt: "app",
    OSExt: "os",
    SessionExt: "ses",
    SDKExt: "sdk"
};
var CtxTagKeys = new __WEBPACK_IMPORTED_MODULE_0__Contracts_Generated_ContextTagKeys__["a" /* ContextTagKeys */]();
//# sourceMappingURL=PartAExtensions.js.map

/***/ }),
/* 1491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Application; });
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var Application = /** @class */ (function () {
    function Application() {
    }
    return Application;
}());

//# sourceMappingURL=Application.js.map

/***/ }),
/* 1492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Device; });
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var Device = /** @class */ (function () {
    /**
     * Constructs a new instance of the Device class
     */
    function Device() {
        // don't attempt to fingerprint browsers
        this.id = "browser";
        // Device type is a dimension in our data platform
        // Setting it to 'Browser' allows to separate client and server dependencies/exceptions
        this.deviceClass = "Browser";
    }
    return Device;
}());

//# sourceMappingURL=Device.js.map

/***/ }),
/* 1493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Internal; });
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var Version = "2.6.3";
var Internal = /** @class */ (function () {
    /**
     * Constructs a new instance of the internal telemetry data class.
     */
    function Internal(config) {
        this.sdkVersion = (config.sdkExtension && config.sdkExtension() ? config.sdkExtension() + "_" : "") + "javascript:" + Version;
    }
    return Internal;
}());

//# sourceMappingURL=Internal.js.map

/***/ }),
/* 1494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return User; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__ = __webpack_require__(34);
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





function _validateUserInput(id) {
    // Validate:
    // 1. Id is a non-empty string.
    // 2. It does not contain special characters for cookies.
    if (typeof id !== 'string' ||
        !id ||
        id.match(/,|;|=| |\|/)) {
        return false;
    }
    return true;
}
var User = /** @class */ (function () {
    function User(config, core) {
        this.isNewUser = false;
        var _logger = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["O" /* safeGetLogger */])(core);
        var _cookieManager = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["N" /* safeGetCookieMgr */])(core);
        Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_dynamicproto_js__["a" /* default */])(User, this, function (_self) {
            // get userId or create new one if none exists
            var cookie = _cookieManager.get(User.userCookieName);
            if (cookie) {
                _self.isNewUser = false;
                var params = cookie.split(User.cookieSeparator);
                if (params.length > 0) {
                    _self.id = params[0];
                }
            }
            _self.config = config;
            if (!_self.id) {
                var theConfig = (config || {});
                var getNewId = (theConfig.getNewId ? theConfig.getNewId() : null) || __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["J" /* newId */];
                _self.id = getNewId(theConfig.idLength ? config.idLength() : 22);
                // without expiration, cookies expire at the end of the session
                // set it to 365 days from now
                // 365 * 24 * 60 * 60 = 31536000 
                var oneYear = 31536000;
                var acqStr = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["S" /* toISOString */])(new Date());
                _self.accountAcquisitionDate = acqStr;
                _self.isNewUser = true;
                var newCookie = [_self.id, acqStr];
                _cookieManager.set(User.userCookieName, newCookie.join(User.cookieSeparator), oneYear);
                // If we have an config.namePrefix() + ai_session in local storage this means the user actively removed our cookies.
                // We should respect their wishes and clear ourselves from local storage
                var name_1 = config.namePrefix && config.namePrefix() ? config.namePrefix() + 'ai_session' : 'ai_session';
                Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["j" /* utlRemoveStorage */])(_logger, name_1);
            }
            // We still take the account id from the ctor param for backward compatibility. 
            // But if the the customer set the accountId through the newer setAuthenticatedUserContext API, we will override it.
            _self.accountId = config.accountId ? config.accountId() : undefined;
            // Get the auth user id and account id from the cookie if exists
            // Cookie is in the pattern: <authenticatedId>|<accountId>
            var authCookie = _cookieManager.get(User.authUserCookieName);
            if (authCookie) {
                authCookie = decodeURI(authCookie);
                var authCookieString = authCookie.split(User.cookieSeparator);
                if (authCookieString[0]) {
                    _self.authenticatedId = authCookieString[0];
                }
                if (authCookieString.length > 1 && authCookieString[1]) {
                    _self.accountId = authCookieString[1];
                }
            }
            _self.setAuthenticatedUserContext = function (authenticatedUserId, accountId, storeInCookie) {
                if (storeInCookie === void 0) { storeInCookie = false; }
                // Validate inputs to ensure no cookie control characters.
                var isInvalidInput = !_validateUserInput(authenticatedUserId) || (accountId && !_validateUserInput(accountId));
                if (isInvalidInput) {
                    _logger.throwInternal(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["b" /* LoggingSeverity */].WARNING, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["d" /* _InternalMessageId */].SetAuthContextFailedAccountName, "Setting auth user context failed. " +
                        "User auth/account id should be of type string, and not contain commas, semi-colons, equal signs, spaces, or vertical-bars.", true);
                    return;
                }
                // Create cookie string.
                _self.authenticatedId = authenticatedUserId;
                var authCookie = _self.authenticatedId;
                if (accountId) {
                    _self.accountId = accountId;
                    authCookie = [_self.authenticatedId, _self.accountId].join(User.cookieSeparator);
                }
                if (storeInCookie) {
                    // Set the cookie. No expiration date because this is a session cookie (expires when browser closed).
                    // Encoding the cookie to handle unexpected unicode characters.
                    _cookieManager.set(User.authUserCookieName, encodeURI(authCookie));
                }
            };
            /**
             * Clears the authenticated user id and the account id from the user context.
             * @returns {}
             */
            _self.clearAuthenticatedUserContext = function () {
                _self.authenticatedId = null;
                _self.accountId = null;
                _cookieManager.del(User.authUserCookieName);
            };
        });
    }
// Removed Stub for User.prototype.setAuthenticatedUserContext.
// Removed Stub for User.prototype.clearAuthenticatedUserContext.
    User.cookieSeparator = '|';
    User.userCookieName = 'ai_user';
    User.authUserCookieName = 'ai_authUser';
    return User;
}());

//# sourceMappingURL=User.js.map

/***/ }),
/* 1495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Location; });
/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var Location = /** @class */ (function () {
    function Location() {
    }
    return Location;
}());

//# sourceMappingURL=Location.js.map

/***/ }),
/* 1496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AjaxMonitor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ajaxRecord__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ajaxUtils__ = __webpack_require__(1528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TraceParent__ = __webpack_require__(1529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__microsoft_dynamicproto_js__ = __webpack_require__(118);
/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */









var AJAX_MONITOR_PREFIX = "ai.ajxmn.";
var strDiagLog = "diagLog";
var strAjaxData = "ajaxData";
var strThrowInternal = "throwInternal";
var strFetch = "fetch";
// Using a global value so that to handle same iKey with multiple app insights instances (mostly for testing)
var _markCount = 0;
/** @Ignore */
function _supportsFetch() {
    var _global = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["u" /* getGlobal */])();
    if (!_global ||
        Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(_global.Request) ||
        Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(_global.Request[__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["Q" /* strPrototype */]]) ||
        Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(_global[strFetch])) {
        return null;
    }
    return _global[strFetch];
}
/**
 * Determines whether ajax monitoring can be enabled on this document
 * @returns True if Ajax monitoring is supported on this page, otherwise false
 * @ignore
 */
function _supportsAjaxMonitoring(ajaxMonitorInstance) {
    var result = false;
    if (typeof XMLHttpRequest !== __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["S" /* strUndefined */] && !Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(XMLHttpRequest)) {
        var proto = XMLHttpRequest[__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["Q" /* strPrototype */]];
        result = !Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(proto) &&
            !Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(proto.open) &&
            !Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(proto.send) &&
            !Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(proto.abort);
    }
    var ieVer = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["w" /* getIEVersion */])();
    if (ieVer && ieVer < 9) {
        result = false;
    }
    if (result) {
        // Disable if the XmlHttpRequest can't be extended or hooked
        try {
            var xhr = new XMLHttpRequest();
            xhr[strAjaxData] = {};
            // Check that we can update the prototype
            var theOpen = XMLHttpRequest[__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["Q" /* strPrototype */]].open;
            XMLHttpRequest[__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["Q" /* strPrototype */]].open = theOpen;
        }
        catch (e) {
            // We can't decorate the xhr object so disable monitoring
            result = false;
            _throwInternalCritical(ajaxMonitorInstance, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["f" /* _InternalMessageId */].FailedMonitorAjaxOpen, "Failed to enable XMLHttpRequest monitoring, extension is not supported", {
                exception: Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["p" /* dumpObj */])(e)
            });
        }
    }
    return result;
}
/** @Ignore */
function _getFailedAjaxDiagnosticsMessage(xhr) {
    var result = "";
    try {
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(xhr) &&
            !Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(xhr[strAjaxData]) &&
            !Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(xhr[strAjaxData].requestUrl)) {
            result += "(url: '" + xhr[strAjaxData].requestUrl + "')";
        }
    }
    catch (e) { }
    return result;
}
/** @ignore */
function _throwInternalCritical(ajaxMonitorInstance, msgId, message, properties, isUserAct) {
    ajaxMonitorInstance[strDiagLog]()[strThrowInternal](__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["e" /* LoggingSeverity */].CRITICAL, msgId, message, properties, isUserAct);
}
/** @ignore */
function _throwInternalWarning(ajaxMonitorInstance, msgId, message, properties, isUserAct) {
    ajaxMonitorInstance[strDiagLog]()[strThrowInternal](__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["e" /* LoggingSeverity */].WARNING, msgId, message, properties, isUserAct);
}
/** @Ignore */
function _createErrorCallbackFunc(ajaxMonitorInstance, internalMessage, message) {
    // tslint:disable-next-line
    return function (args) {
        _throwInternalCritical(ajaxMonitorInstance, internalMessage, message, {
            ajaxDiagnosticsMessage: _getFailedAjaxDiagnosticsMessage(args.inst),
            exception: Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["p" /* dumpObj */])(args.err)
        });
    };
}
function _indexOf(value, match) {
    if (value && match) {
        return value.indexOf(match);
    }
    return -1;
}
var AjaxMonitor = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(AjaxMonitor, _super);
    function AjaxMonitor() {
        var _this = _super.call(this) || this;
        _this.identifier = AjaxMonitor.identifier;
        _this.priority = 120;
        var strTrackDependencyDataInternal = "trackDependencyDataInternal"; // Using string to help with minification
        var location = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["y" /* getLocation */])();
        var _fetchInitialized = false; // fetch monitoring initialized
        var _xhrInitialized = false; // XHR monitoring initialized
        var _currentWindowHost = location && location.host && location.host.toLowerCase();
        var _config = AjaxMonitor.getEmptyConfig();
        var _enableRequestHeaderTracking = false;
        var _trackAjaxAttempts = 0;
        var _context;
        var _isUsingW3CHeaders;
        var _isUsingAIHeaders;
        var _markPrefix;
        var _enableAjaxPerfTracking = false;
        var _maxAjaxCallsPerView = 0;
        var _enableResponseHeaderTracking = false;
        var _hooks = [];
        var _disabledUrls = {};
        Object(__WEBPACK_IMPORTED_MODULE_6__microsoft_dynamicproto_js__["a" /* default */])(AjaxMonitor, _this, function (_self, base) {
            _self.initialize = function (config, core, extensions, pluginChain) {
                if (!_self.isInitialized()) {
                    base.initialize(config, core, extensions, pluginChain);
                    var ctx_1 = _self._getTelCtx();
                    var defaultConfig = AjaxMonitor.getDefaultConfig();
                    Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["M" /* objForEachKey */])(defaultConfig, function (field, value) {
                        _config[field] = ctx_1.getConfig(AjaxMonitor.identifier, field, value);
                    });
                    var distributedTracingMode = _config.distributedTracingMode;
                    _enableRequestHeaderTracking = _config.enableRequestHeaderTracking;
                    _enableAjaxPerfTracking = _config.enableAjaxPerfTracking;
                    _maxAjaxCallsPerView = _config.maxAjaxCallsPerView;
                    _enableResponseHeaderTracking = _config.enableResponseHeaderTracking;
                    _isUsingAIHeaders = distributedTracingMode === __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["c" /* DistributedTracingModes */].AI || distributedTracingMode === __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["c" /* DistributedTracingModes */].AI_AND_W3C;
                    _isUsingW3CHeaders = distributedTracingMode === __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["c" /* DistributedTracingModes */].AI_AND_W3C || distributedTracingMode === __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["c" /* DistributedTracingModes */].W3C;
                    if (_enableAjaxPerfTracking) {
                        var iKey = config.instrumentationKey || "unkwn";
                        if (iKey.length > 5) {
                            _markPrefix = AJAX_MONITOR_PREFIX + iKey.substring(iKey.length - 5) + ".";
                        }
                        else {
                            _markPrefix = AJAX_MONITOR_PREFIX + iKey + ".";
                        }
                    }
                    if (_config.disableAjaxTracking === false) {
                        _instrumentXhr();
                    }
                    _instrumentFetch();
                    if (extensions.length > 0 && extensions) {
                        var propExt = void 0, extIx = 0;
                        while (!propExt && extIx < extensions.length) {
                            if (extensions[extIx] && extensions[extIx].identifier === __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["d" /* PropertiesPluginIdentifier */]) {
                                propExt = extensions[extIx];
                            }
                            extIx++;
                        }
                        if (propExt) {
                            _context = propExt.context; // we could move IPropertiesPlugin to common as well
                        }
                    }
                }
            };
            _self.teardown = function () {
                // Remove all instrumentation hooks
                Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["g" /* arrForEach */])(_hooks, function (fn) {
                    fn.rm();
                });
                _hooks = [];
                _fetchInitialized = false;
                _xhrInitialized = false;
                _self.setInitialized(false);
            };
            _self.trackDependencyData = function (dependency, properties) {
                _self[strTrackDependencyDataInternal](dependency, properties);
            };
            _self.includeCorrelationHeaders = function (ajaxData, input, init, xhr) {
                // Test Hook to allow the overriding of the location host
                var currentWindowHost = _self["_currentWindowHost"] || _currentWindowHost;
                if (input) {
                    if (__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["a" /* CorrelationIdHelper */].canIncludeCorrelationHeader(_config, ajaxData.getAbsoluteUrl(), currentWindowHost)) {
                        if (!init) {
                            init = {};
                        }
                        // init headers override original request headers
                        // so, if they exist use only them, otherwise use request's because they should have been applied in the first place
                        // not using original request headers will result in them being lost
                        init.headers = new Headers(init.headers || (input instanceof Request ? (input.headers || {}) : {}));
                        if (_isUsingAIHeaders) {
                            var id = "|" + ajaxData.traceID + "." + ajaxData.spanID;
                            init.headers.set(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["f" /* RequestHeaders */].requestIdHeader, id);
                            if (_enableRequestHeaderTracking) {
                                ajaxData.requestHeaders[__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["f" /* RequestHeaders */].requestIdHeader] = id;
                            }
                        }
                        var appId = _config.appId || (_context && _context.appId());
                        if (appId) {
                            init.headers.set(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["f" /* RequestHeaders */].requestContextHeader, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["f" /* RequestHeaders */].requestContextAppIdFormat + appId);
                            if (_enableRequestHeaderTracking) {
                                ajaxData.requestHeaders[__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["f" /* RequestHeaders */].requestContextHeader] = __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["f" /* RequestHeaders */].requestContextAppIdFormat + appId;
                            }
                        }
                        if (_isUsingW3CHeaders) {
                            var traceparent = new __WEBPACK_IMPORTED_MODULE_5__TraceParent__["a" /* Traceparent */](ajaxData.traceID, ajaxData.spanID);
                            init.headers.set(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["f" /* RequestHeaders */].traceParentHeader, traceparent.toString());
                            if (_enableRequestHeaderTracking) {
                                ajaxData.requestHeaders[__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["f" /* RequestHeaders */].traceParentHeader] = traceparent.toString();
                            }
                        }
                    }
                    return init;
                }
                else if (xhr) {
                    if (__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["a" /* CorrelationIdHelper */].canIncludeCorrelationHeader(_config, ajaxData.getAbsoluteUrl(), currentWindowHost)) {
                        if (_isUsingAIHeaders) {
                            var id = "|" + ajaxData.traceID + "." + ajaxData.spanID;
                            xhr.setRequestHeader(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["f" /* RequestHeaders */].requestIdHeader, id);
                            if (_enableRequestHeaderTracking) {
                                ajaxData.requestHeaders[__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["f" /* RequestHeaders */].requestIdHeader] = id;
                            }
                        }
                        var appId = _config.appId || (_context && _context.appId());
                        if (appId) {
                            xhr.setRequestHeader(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["f" /* RequestHeaders */].requestContextHeader, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["f" /* RequestHeaders */].requestContextAppIdFormat + appId);
                            if (_enableRequestHeaderTracking) {
                                ajaxData.requestHeaders[__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["f" /* RequestHeaders */].requestContextHeader] = __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["f" /* RequestHeaders */].requestContextAppIdFormat + appId;
                            }
                        }
                        if (_isUsingW3CHeaders) {
                            var traceparent = new __WEBPACK_IMPORTED_MODULE_5__TraceParent__["a" /* Traceparent */](ajaxData.traceID, ajaxData.spanID);
                            xhr.setRequestHeader(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["f" /* RequestHeaders */].traceParentHeader, traceparent.toString());
                            if (_enableRequestHeaderTracking) {
                                ajaxData.requestHeaders[__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["f" /* RequestHeaders */].traceParentHeader] = traceparent.toString();
                            }
                        }
                    }
                    return xhr;
                }
                return undefined;
            };
            _self[strTrackDependencyDataInternal] = function (dependency, properties, systemProperties) {
                if (_maxAjaxCallsPerView === -1 || _trackAjaxAttempts < _maxAjaxCallsPerView) {
                    // Hack since expected format in w3c mode is |abc.def.
                    // Non-w3c format is |abc.def
                    // @todo Remove if better solution is available, e.g. handle in portal
                    if ((_config.distributedTracingMode === __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["c" /* DistributedTracingModes */].W3C
                        || _config.distributedTracingMode === __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["c" /* DistributedTracingModes */].AI_AND_W3C)
                        && typeof dependency.id === "string" && dependency.id[dependency.id.length - 1] !== ".") {
                        dependency.id += ".";
                    }
                    if (Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(dependency.startTime)) {
                        dependency.startTime = new Date();
                    }
                    var item = __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["g" /* TelemetryItemCreator */].create(dependency, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["e" /* RemoteDependencyData */].dataType, __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["e" /* RemoteDependencyData */].envelopeType, _self[strDiagLog](), properties, systemProperties);
                    _self.core.track(item);
                }
                else if (_trackAjaxAttempts === _maxAjaxCallsPerView) {
                    _throwInternalCritical(_self, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["f" /* _InternalMessageId */].MaxAjaxPerPVExceeded, "Maximum ajax per page view limit reached, ajax monitoring is paused until the next trackPageView(). In order to increase the limit set the maxAjaxCallsPerView configuration parameter.", true);
                }
                ++_trackAjaxAttempts;
            };
            // discard the header if it's defined as ignoreHeaders in ICorrelationConfig
            function _canIncludeHeaders(header) {
                var rlt = true;
                if (header || _config.ignoreHeaders) {
                    Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["g" /* arrForEach */])(_config.ignoreHeaders, (function (key) {
                        if (key.toLowerCase() === header.toLowerCase()) {
                            rlt = false;
                            return -1;
                        }
                    }));
                }
                return rlt;
            }
            // Fetch Stuff
            function _instrumentFetch() {
                var fetch = _supportsFetch();
                if (!fetch) {
                    return;
                }
                var global = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["u" /* getGlobal */])();
                var isPolyfill = fetch.polyfill;
                if (_config.disableFetchTracking === false) {
                    _hooks.push(Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["c" /* InstrumentFunc */])(global, strFetch, {
                        // Add request hook
                        req: function (callDetails, input, init) {
                            var fetchData;
                            if (_fetchInitialized &&
                                !_isDisabledRequest(null, input, init) &&
                                // If we have a polyfil and XHR instrumented then let XHR report otherwise we get duplicates
                                !(isPolyfill && _xhrInitialized)) {
                                var ctx = callDetails.ctx();
                                fetchData = _createFetchRecord(input, init);
                                var newInit = _self.includeCorrelationHeaders(fetchData, input, init);
                                if (newInit !== init) {
                                    callDetails.set(1, newInit);
                                }
                                ctx.data = fetchData;
                            }
                        },
                        rsp: function (callDetails, input) {
                            var fetchData = callDetails.ctx().data;
                            if (fetchData) {
                                // Replace the result with the new promise from this code
                                callDetails.rslt = callDetails.rslt.then(function (response) {
                                    _reportFetchMetrics(callDetails, (response || {}).status, response, fetchData, function () {
                                        var ajaxResponse = {
                                            statusText: response.statusText,
                                            headerMap: null,
                                            correlationContext: _getFetchCorrelationContext(response)
                                        };
                                        if (_enableResponseHeaderTracking) {
                                            var responseHeaderMap_1 = {};
                                            response.headers.forEach(function (value, name) {
                                                if (_canIncludeHeaders(name)) {
                                                    responseHeaderMap_1[name] = value;
                                                }
                                            });
                                            ajaxResponse.headerMap = responseHeaderMap_1;
                                        }
                                        return ajaxResponse;
                                    });
                                    return response;
                                })["catch"](function (reason) {
                                    _reportFetchMetrics(callDetails, 0, input, fetchData, null, { error: reason.message });
                                    throw reason;
                                });
                            }
                        },
                        // Create an error callback to report any hook errors
                        hkErr: _createErrorCallbackFunc(_self, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["f" /* _InternalMessageId */].FailedMonitorAjaxOpen, "Failed to monitor Window.fetch, monitoring data for this fetch call may be incorrect.")
                    }));
                    _fetchInitialized = true;
                }
                else if (isPolyfill) {
                    // If fetch is a polyfill we need to capture the request to ensure that we correctly track
                    // disabled request URLS (i.e. internal urls) to ensure we don't end up in a constant loop
                    // of reporting ourselves, for example React Native uses a polyfill for fetch
                    // Note: Polyfill implementations that don't support the "poyyfill" tag are not supported
                    // the workaround is to add a polyfill property to your fetch implementation before initializing
                    // App Insights
                    _hooks.push(Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["c" /* InstrumentFunc */])(global, strFetch, {
                        req: function (callDetails, input, init) {
                            // Just call so that we record any disabled URL
                            _isDisabledRequest(null, input, init);
                        }
                    }));
                }
                if (isPolyfill) {
                    // retag the instrumented fetch with the same polyfill settings this is mostly for testing
                    // But also supports multiple App Insights usages
                    global[strFetch].polyfill = isPolyfill;
                }
            }
            function _hookProto(target, funcName, callbacks) {
                _hooks.push(Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["d" /* InstrumentProto */])(target, funcName, callbacks));
            }
            function _instrumentXhr() {
                if (_supportsAjaxMonitoring(_self) && !_xhrInitialized) {
                    // Instrument open
                    _hookProto(XMLHttpRequest, "open", {
                        req: function (args, method, url, async) {
                            var xhr = args.inst;
                            var ajaxData = xhr[strAjaxData];
                            if (!_isDisabledRequest(xhr, url) && _isMonitoredXhrInstance(xhr, true) &&
                                (!ajaxData || !ajaxData.xhrMonitoringState.openDone)) {
                                _openHandler(xhr, method, url, async);
                            }
                        },
                        hkErr: _createErrorCallbackFunc(_self, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["f" /* _InternalMessageId */].FailedMonitorAjaxOpen, "Failed to monitor XMLHttpRequest.open, monitoring data for this ajax call may be incorrect.")
                    });
                    // Instrument send
                    _hookProto(XMLHttpRequest, "send", {
                        req: function (args, context) {
                            var xhr = args.inst;
                            var ajaxData = xhr[strAjaxData];
                            if (_isMonitoredXhrInstance(xhr) && !ajaxData.xhrMonitoringState.sendDone) {
                                _createMarkId("xhr", ajaxData);
                                ajaxData.requestSentTime = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["j" /* dateTimeUtilsNow */])();
                                xhr = _self.includeCorrelationHeaders(ajaxData, undefined, undefined, xhr);
                                ajaxData.xhrMonitoringState.sendDone = true;
                            }
                        },
                        hkErr: _createErrorCallbackFunc(_self, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["f" /* _InternalMessageId */].FailedMonitorAjaxSend, "Failed to monitor XMLHttpRequest, monitoring data for this ajax call may be incorrect.")
                    });
                    // Instrument abort
                    _hookProto(XMLHttpRequest, "abort", {
                        req: function (args) {
                            var xhr = args.inst;
                            var ajaxData = xhr[strAjaxData];
                            if (_isMonitoredXhrInstance(xhr) && !ajaxData.xhrMonitoringState.abortDone) {
                                ajaxData.aborted = 1;
                                ajaxData.xhrMonitoringState.abortDone = true;
                            }
                        },
                        hkErr: _createErrorCallbackFunc(_self, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["f" /* _InternalMessageId */].FailedMonitorAjaxAbort, "Failed to monitor XMLHttpRequest.abort, monitoring data for this ajax call may be incorrect.")
                    });
                    // Instrument setRequestHeader
                    if (_enableRequestHeaderTracking) {
                        _hookProto(XMLHttpRequest, "setRequestHeader", {
                            req: function (args, header, value) {
                                var xhr = args.inst;
                                if (_isMonitoredXhrInstance(xhr) && _canIncludeHeaders(header)) {
                                    xhr[strAjaxData].requestHeaders[header] = value;
                                }
                            },
                            hkErr: _createErrorCallbackFunc(_self, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["f" /* _InternalMessageId */].FailedMonitorAjaxSetRequestHeader, "Failed to monitor XMLHttpRequest.setRequestHeader, monitoring data for this ajax call may be incorrect.")
                        });
                    }
                    _xhrInitialized = true;
                }
            }
            function _isDisabledRequest(xhr, request, init) {
                var isDisabled = false;
                var theUrl = ((!Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["J" /* isString */])(request) ? (request || {}).url || "" : request) || "").toLowerCase();
                var idx = _indexOf(theUrl, "?");
                var idx2 = _indexOf(theUrl, "#");
                if (idx === -1 || (idx2 !== -1 && idx2 < idx)) {
                    idx = idx2;
                }
                if (idx !== -1) {
                    // Strip off any Query string
                    theUrl = theUrl.substring(0, idx);
                }
                // check that this instance is not not used by ajax call performed inside client side monitoring to send data to collector
                if (!Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(xhr)) {
                    // Look on the XMLHttpRequest of the URL string value
                    isDisabled = xhr[__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["b" /* DisabledPropertyName */]] === true || theUrl[__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["b" /* DisabledPropertyName */]] === true;
                }
                else if (!Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(request)) {
                    // Look for DisabledPropertyName in either Request or RequestInit
                    isDisabled = (typeof request === 'object' ? request[__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["b" /* DisabledPropertyName */]] === true : false) ||
                        (init ? init[__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["b" /* DisabledPropertyName */]] === true : false);
                }
                if (isDisabled) {
                    // Add the disabled url if not present
                    if (!_disabledUrls[theUrl]) {
                        _disabledUrls[theUrl] = 1;
                    }
                }
                else {
                    // Check to see if the url is listed as disabled
                    if (_disabledUrls[theUrl]) {
                        isDisabled = true;
                    }
                }
                return isDisabled;
            }
            /// <summary>Verifies that particalar instance of XMLHttpRequest needs to be monitored</summary>
            /// <param name="excludeAjaxDataValidation">Optional parameter. True if ajaxData must be excluded from verification</param>
            /// <returns type="bool">True if instance needs to be monitored, otherwise false</returns>
            function _isMonitoredXhrInstance(xhr, excludeAjaxDataValidation) {
                var ajaxValidation = true;
                var initialized = _xhrInitialized;
                if (!Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(xhr)) {
                    ajaxValidation = excludeAjaxDataValidation === true || !Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(xhr[strAjaxData]);
                }
                // checking to see that all interested functions on xhr were instrumented
                return initialized
                    // checking on ajaxData to see that it was not removed in user code
                    && ajaxValidation;
            }
            function _openHandler(xhr, method, url, async) {
                var traceID = (_context && _context.telemetryTrace && _context.telemetryTrace.traceID) || Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["q" /* generateW3CId */])();
                var spanID = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["q" /* generateW3CId */])().substr(0, 16);
                var ajaxData = new __WEBPACK_IMPORTED_MODULE_3__ajaxRecord__["a" /* ajaxRecord */](traceID, spanID, _self[strDiagLog]());
                ajaxData.method = method;
                ajaxData.requestUrl = url;
                ajaxData.xhrMonitoringState.openDone = true;
                ajaxData.requestHeaders = {};
                ajaxData.async = async;
                xhr[strAjaxData] = ajaxData;
                _attachToOnReadyStateChange(xhr);
            }
            function _attachToOnReadyStateChange(xhr) {
                xhr[strAjaxData].xhrMonitoringState.stateChangeAttached = __WEBPACK_IMPORTED_MODULE_4__ajaxUtils__["a" /* EventHelper */].Attach(xhr, "readystatechange", function () {
                    try {
                        if (xhr && xhr.readyState === 4 && _isMonitoredXhrInstance(xhr)) {
                            _onAjaxComplete(xhr);
                        }
                    }
                    catch (e) {
                        var exceptionText = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["p" /* dumpObj */])(e);
                        // ignore messages with c00c023f, as this a known IE9 XHR abort issue
                        if (!exceptionText || _indexOf(exceptionText.toLowerCase(), "c00c023f") === -1) {
                            _throwInternalCritical(_self, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["f" /* _InternalMessageId */].FailedMonitorAjaxRSC, "Failed to monitor XMLHttpRequest 'readystatechange' event handler, monitoring data for this ajax call may be incorrect.", {
                                ajaxDiagnosticsMessage: _getFailedAjaxDiagnosticsMessage(xhr),
                                exception: exceptionText
                            });
                        }
                    }
                });
            }
            function _getResponseText(xhr) {
                try {
                    var responseType = xhr.responseType;
                    if (responseType === "" || responseType === "text") {
                        // As per the specification responseText is only valid if the type is an empty string or "text"
                        return xhr.responseText;
                    }
                }
                catch (e) {
                    // This shouldn't happend because of the above check -- but just in case, so just ignore
                }
                return null;
            }
            function _onAjaxComplete(xhr) {
                var ajaxData = xhr[strAjaxData];
                ajaxData.responseFinishedTime = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["j" /* dateTimeUtilsNow */])();
                ajaxData.status = xhr.status;
                function _reportXhrError(e, failedProps) {
                    var errorProps = failedProps || {};
                    errorProps["ajaxDiagnosticsMessage"] = _getFailedAjaxDiagnosticsMessage(xhr);
                    if (e) {
                        errorProps["exception"] = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["p" /* dumpObj */])(e);
                    }
                    _throwInternalWarning(_self, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["f" /* _InternalMessageId */].FailedMonitorAjaxDur, "Failed to calculate the duration of the ajax call, monitoring data for this ajax call won't be sent.", errorProps);
                }
                _findPerfResourceEntry("xmlhttprequest", ajaxData, function () {
                    try {
                        var dependency = ajaxData.CreateTrackItem("Ajax", _enableRequestHeaderTracking, function () {
                            var ajaxResponse = {
                                statusText: xhr.statusText,
                                headerMap: null,
                                correlationContext: _getAjaxCorrelationContext(xhr),
                                type: xhr.responseType,
                                responseText: _getResponseText(xhr),
                                response: xhr.response
                            };
                            if (_enableResponseHeaderTracking) {
                                var headers = xhr.getAllResponseHeaders();
                                if (headers) {
                                    // xhr.getAllResponseHeaders() method returns all the response headers, separated by CRLF, as a string or null
                                    // the regex converts the header string into an array of individual headers
                                    var arr = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["R" /* strTrim */])(headers).split(/[\r\n]+/);
                                    var responseHeaderMap_2 = {};
                                    Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["g" /* arrForEach */])(arr, function (line) {
                                        var parts = line.split(': ');
                                        var header = parts.shift();
                                        var value = parts.join(': ');
                                        if (_canIncludeHeaders(header)) {
                                            responseHeaderMap_2[header] = value;
                                        }
                                    });
                                    ajaxResponse.headerMap = responseHeaderMap_2;
                                }
                            }
                            return ajaxResponse;
                        });
                        if (dependency) {
                            _self[strTrackDependencyDataInternal](dependency);
                        }
                        else {
                            _reportXhrError(null, {
                                requestSentTime: ajaxData.requestSentTime,
                                responseFinishedTime: ajaxData.responseFinishedTime
                            });
                        }
                    }
                    finally {
                        // cleanup telemetry data
                        try {
                            xhr[strAjaxData] = null;
                        }
                        catch (e) {
                            // May throw in environments that prevent extension or freeze xhr
                        }
                    }
                }, function (e) {
                    _reportXhrError(e, null);
                });
            }
            function _getAjaxCorrelationContext(xhr) {
                try {
                    var responseHeadersString = xhr.getAllResponseHeaders();
                    if (responseHeadersString !== null) {
                        var index = _indexOf(responseHeadersString.toLowerCase(), __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["f" /* RequestHeaders */].requestContextHeaderLowerCase);
                        if (index !== -1) {
                            var responseHeader = xhr.getResponseHeader(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["f" /* RequestHeaders */].requestContextHeader);
                            return __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["a" /* CorrelationIdHelper */].getCorrelationContext(responseHeader);
                        }
                    }
                }
                catch (e) {
                    _throwInternalWarning(_self, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["f" /* _InternalMessageId */].FailedMonitorAjaxGetCorrelationHeader, "Failed to get Request-Context correlation header as it may be not included in the response or not accessible.", {
                        ajaxDiagnosticsMessage: _getFailedAjaxDiagnosticsMessage(xhr),
                        exception: Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["p" /* dumpObj */])(e)
                    });
                }
            }
            function _createMarkId(type, ajaxData) {
                if (ajaxData.requestUrl && _markPrefix && _enableAjaxPerfTracking) {
                    var performance_1 = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["A" /* getPerformance */])();
                    if (performance_1 && Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["F" /* isFunction */])(performance_1.mark)) {
                        _markCount++;
                        var markId = _markPrefix + type + "#" + _markCount;
                        performance_1.mark(markId);
                        var entries = performance_1.getEntriesByName(markId);
                        if (entries && entries.length === 1) {
                            ajaxData.perfMark = entries[0];
                        }
                    }
                }
            }
            function _findPerfResourceEntry(initiatorType, ajaxData, trackCallback, reportError) {
                var perfMark = ajaxData.perfMark;
                var performance = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["A" /* getPerformance */])();
                var maxAttempts = _config.maxAjaxPerfLookupAttempts;
                var retryDelay = _config.ajaxPerfLookupDelay;
                var requestUrl = ajaxData.requestUrl;
                var attempt = 0;
                (function locateResourceTiming() {
                    try {
                        if (performance && perfMark) {
                            attempt++;
                            var perfTiming = null;
                            var entries = performance.getEntries();
                            for (var lp = entries.length - 1; lp >= 0; lp--) {
                                var entry = entries[lp];
                                if (entry) {
                                    if (entry.entryType === "resource") {
                                        if (entry.initiatorType === initiatorType &&
                                            (_indexOf(entry.name, requestUrl) !== -1 || _indexOf(requestUrl, entry.name) !== -1)) {
                                            perfTiming = entry;
                                        }
                                    }
                                    else if (entry.entryType === "mark" && entry.name === perfMark.name) {
                                        // We hit the start event
                                        ajaxData.perfTiming = perfTiming;
                                        break;
                                    }
                                    if (entry.startTime < perfMark.startTime - 1000) {
                                        // Fallback to try and reduce the time spent looking for the perf entry
                                        break;
                                    }
                                }
                            }
                        }
                        if (!perfMark || // - we don't have a perfMark or
                            ajaxData.perfTiming || // - we have not found the perf entry or
                            attempt >= maxAttempts || // - we have tried too many attempts or
                            ajaxData.async === false) {
                            if (perfMark && Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["F" /* isFunction */])(performance.clearMarks)) {
                                // Remove the mark so we don't fill up the performance resources too much
                                performance.clearMarks(perfMark.name);
                            }
                            ajaxData.perfAttempts = attempt;
                            // just continue and report the track event
                            trackCallback();
                        }
                        else {
                            // We need to wait for the browser to populate the window.performance entry
                            // This needs to be at least 1ms as waiting <= 1 (on firefox) is not enough time for fetch or xhr,
                            // this is a scheduling issue for the browser implementation
                            setTimeout(locateResourceTiming, retryDelay);
                        }
                    }
                    catch (e) {
                        reportError(e);
                    }
                })();
            }
            function _createFetchRecord(input, init) {
                var traceID = (_context && _context.telemetryTrace && _context.telemetryTrace.traceID) || Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["q" /* generateW3CId */])();
                var spanID = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["q" /* generateW3CId */])().substr(0, 16);
                var ajaxData = new __WEBPACK_IMPORTED_MODULE_3__ajaxRecord__["a" /* ajaxRecord */](traceID, spanID, _self[strDiagLog]());
                ajaxData.requestSentTime = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["j" /* dateTimeUtilsNow */])();
                if (input instanceof Request) {
                    ajaxData.requestUrl = input ? input.url : "";
                }
                else {
                    ajaxData.requestUrl = input;
                }
                var method = "GET";
                if (init && init.method) {
                    method = init.method;
                }
                else if (input && input instanceof Request) {
                    method = input.method;
                }
                ajaxData.method = method;
                var requestHeaders = {};
                if (_enableRequestHeaderTracking) {
                    var headers = new Headers((init ? init.headers : 0) || (input instanceof Request ? (input.headers || {}) : {}));
                    headers.forEach(function (value, key) {
                        if (_canIncludeHeaders(key)) {
                            requestHeaders[key] = value;
                        }
                    });
                }
                ajaxData.requestHeaders = requestHeaders;
                _createMarkId("fetch", ajaxData);
                return ajaxData;
            }
            function _getFailedFetchDiagnosticsMessage(input) {
                var result = "";
                try {
                    if (!Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(input)) {
                        if (typeof (input) === "string") {
                            result += "(url: '" + input + "')";
                        }
                        else {
                            result += "(url: '" + input.url + "')";
                        }
                    }
                }
                catch (e) {
                    _throwInternalCritical(_self, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["f" /* _InternalMessageId */].FailedMonitorAjaxOpen, "Failed to grab failed fetch diagnostics message", { exception: Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["p" /* dumpObj */])(e) });
                }
                return result;
            }
            function _reportFetchMetrics(callDetails, status, input, ajaxData, getResponse, properties) {
                if (!ajaxData) {
                    return;
                }
                function _reportFetchError(msgId, e, failedProps) {
                    var errorProps = failedProps || {};
                    errorProps["fetchDiagnosticsMessage"] = _getFailedFetchDiagnosticsMessage(input);
                    if (e) {
                        errorProps["exception"] = Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["p" /* dumpObj */])(e);
                    }
                    _throwInternalWarning(_self, msgId, "Failed to calculate the duration of the fetch call, monitoring data for this fetch call won't be sent.", errorProps);
                }
                ajaxData.responseFinishedTime = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["j" /* dateTimeUtilsNow */])();
                ajaxData.status = status;
                _findPerfResourceEntry("fetch", ajaxData, function () {
                    var dependency = ajaxData.CreateTrackItem("Fetch", _enableRequestHeaderTracking, getResponse);
                    if (dependency) {
                        _self[strTrackDependencyDataInternal](dependency);
                    }
                    else {
                        _reportFetchError(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["f" /* _InternalMessageId */].FailedMonitorAjaxDur, null, {
                            requestSentTime: ajaxData.requestSentTime,
                            responseFinishedTime: ajaxData.responseFinishedTime
                        });
                    }
                }, function (e) {
                    _reportFetchError(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["f" /* _InternalMessageId */].FailedMonitorAjaxGetCorrelationHeader, e, null);
                });
            }
            function _getFetchCorrelationContext(response) {
                if (response && response.headers) {
                    try {
                        var responseHeader = response.headers.get(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["f" /* RequestHeaders */].requestContextHeader);
                        return __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["a" /* CorrelationIdHelper */].getCorrelationContext(responseHeader);
                    }
                    catch (e) {
                        _throwInternalWarning(_self, __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["f" /* _InternalMessageId */].FailedMonitorAjaxGetCorrelationHeader, "Failed to get Request-Context correlation header as it may be not included in the response or not accessible.", {
                            fetchDiagnosticsMessage: _getFailedFetchDiagnosticsMessage(response),
                            exception: Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["p" /* dumpObj */])(e)
                        });
                    }
                }
            }
        });
        return _this;
    }
    AjaxMonitor.getDefaultConfig = function () {
        var config = {
            maxAjaxCallsPerView: 500,
            disableAjaxTracking: false,
            disableFetchTracking: true,
            disableCorrelationHeaders: false,
            distributedTracingMode: __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_common__["c" /* DistributedTracingModes */].AI_AND_W3C,
            correlationHeaderExcludedDomains: [
                "*.blob.core.windows.net",
                "*.blob.core.chinacloudapi.cn",
                "*.blob.core.cloudapi.de",
                "*.blob.core.usgovcloudapi.net"
            ],
            correlationHeaderDomains: undefined,
            correlationHeaderExcludePatterns: undefined,
            appId: undefined,
            enableCorsCorrelation: false,
            enableRequestHeaderTracking: false,
            enableResponseHeaderTracking: false,
            enableAjaxErrorStatusText: false,
            enableAjaxPerfTracking: false,
            maxAjaxPerfLookupAttempts: 3,
            ajaxPerfLookupDelay: 25,
            ignoreHeaders: [
                "Authorization",
                "X-API-Key",
                "WWW-Authenticate"
            ]
        };
        return config;
    };
    AjaxMonitor.getEmptyConfig = function () {
        var emptyConfig = this.getDefaultConfig();
        Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["M" /* objForEachKey */])(emptyConfig, function (value) {
            emptyConfig[value] = undefined;
        });
        return emptyConfig;
    };
// Removed Stub for AjaxMonitor.prototype.initialize.
// Removed Stub for AjaxMonitor.prototype.teardown.
    AjaxMonitor.prototype.processTelemetry = function (item, itemCtx) {
        this.processNext(item, itemCtx);
    };
// Removed Stub for AjaxMonitor.prototype.trackDependencyData.
// Removed Stub for AjaxMonitor.prototype.includeCorrelationHeaders.
// Removed Stub for AjaxMonitor.prototype.trackDependencyDataInternal.
    AjaxMonitor.identifier = "AjaxDependencyPlugin";
    return AjaxMonitor;
}(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["a" /* BaseTelemetryPlugin */]));

//# sourceMappingURL=ajax.js.map

/***/ }),
/* 1497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MinChannelPriorty */
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var MinChannelPriorty = 100;
//# sourceMappingURL=IChannelControls.js.map

/***/ }),
/* 1498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AppInsightsCore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseCore__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JavaScriptSDK_Enums_EventsDiscardedReason__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NotificationManager__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PerfManager__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DiagnosticLogger__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__microsoft_dynamicproto_js__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__HelperFuncs__ = __webpack_require__(45);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */








"use strict";
var AppInsightsCore = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(AppInsightsCore, _super);
    function AppInsightsCore() {
        var _this = _super.call(this) || this;
        Object(__WEBPACK_IMPORTED_MODULE_6__microsoft_dynamicproto_js__["a" /* default */])(AppInsightsCore, _this, function (_self, _base) {
            _self.initialize = function (config, extensions, logger, notificationManager) {
                _base.initialize(config, extensions, logger || new __WEBPACK_IMPORTED_MODULE_5__DiagnosticLogger__["a" /* DiagnosticLogger */](config), notificationManager || new __WEBPACK_IMPORTED_MODULE_3__NotificationManager__["a" /* NotificationManager */](config));
            };
            _self.track = function (telemetryItem) {
                Object(__WEBPACK_IMPORTED_MODULE_4__PerfManager__["b" /* doPerf */])(_self.getPerfMgr(), function () { return "AppInsightsCore:track"; }, function () {
                    if (telemetryItem === null) {
                        _notifyInvalidEvent(telemetryItem);
                        // throw error
                        Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["H" /* throwError */])("Invalid telemetry item");
                    }
                    // do basic validation before sending it through the pipeline
                    _validateTelemetryItem(telemetryItem);
                    _base.track(telemetryItem);
                }, function () { return ({ item: telemetryItem }); }, !(telemetryItem.sync));
            };
            /**
             * Adds a notification listener. The SDK calls methods on the listener when an appropriate notification is raised.
             * The added plugins must raise notifications. If the plugins do not implement the notifications, then no methods will be
             * called.
             * @param {INotificationListener} listener - An INotificationListener object.
             */
            _self.addNotificationListener = function (listener) {
                var manager = _self.getNotifyMgr();
                if (manager) {
                    manager.addNotificationListener(listener);
                }
            };
            /**
             * Removes all instances of the listener.
             * @param {INotificationListener} listener - INotificationListener to remove.
             */
            _self.removeNotificationListener = function (listener) {
                var manager = _self.getNotifyMgr();
                if (manager) {
                    manager.removeNotificationListener(listener);
                }
            };
            /**
             * Periodically check logger.queue for
             */
            _self.pollInternalLogs = function (eventName) {
                var interval = _self.config.diagnosticLogInterval;
                if (!interval || !(interval > 0)) {
                    interval = 10000;
                }
                return setInterval(function () {
                    var queue = _self.logger ? _self.logger.queue : [];
                    Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["a" /* arrForEach */])(queue, function (logMessage) {
                        var item = {
                            name: eventName ? eventName : "InternalMessageId: " + logMessage.messageId,
                            iKey: _self.config.instrumentationKey,
                            time: Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["I" /* toISOString */])(new Date()),
                            baseType: __WEBPACK_IMPORTED_MODULE_5__DiagnosticLogger__["b" /* _InternalLogMessage */].dataType,
                            baseData: { message: logMessage.message }
                        };
                        _self.track(item);
                    });
                    queue.length = 0;
                }, interval);
            };
            function _validateTelemetryItem(telemetryItem) {
                if (Object(__WEBPACK_IMPORTED_MODULE_7__HelperFuncs__["s" /* isNullOrUndefined */])(telemetryItem.name)) {
                    _notifyInvalidEvent(telemetryItem);
                    throw Error("telemetry name required");
                }
            }
            function _notifyInvalidEvent(telemetryItem) {
                var manager = _self.getNotifyMgr();
                if (manager) {
                    manager.eventsDiscarded([telemetryItem], __WEBPACK_IMPORTED_MODULE_2__JavaScriptSDK_Enums_EventsDiscardedReason__["a" /* EventsDiscardedReason */].InvalidEvent);
                }
            }
        });
        return _this;
    }
// Removed Stub for AppInsightsCore.prototype.initialize.
// Removed Stub for AppInsightsCore.prototype.track.
// Removed Stub for AppInsightsCore.prototype.addNotificationListener.
// Removed Stub for AppInsightsCore.prototype.removeNotificationListener.
// Removed Stub for AppInsightsCore.prototype.pollInternalLogs.
    return AppInsightsCore;
}(__WEBPACK_IMPORTED_MODULE_1__BaseCore__["a" /* BaseCore */]));

//# sourceMappingURL=AppInsightsCore.js.map

/***/ }),
/* 1499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChannelController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseTelemetryPlugin__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProcessTelemetryContext__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TelemetryHelpers__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HelperFuncs__ = __webpack_require__(45);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */









var ChannelControllerPriority = 500;
var ChannelValidationMessage = "Channel has invalid priority";
var ChannelController = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(ChannelController, _super);
    function ChannelController() {
        var _this = _super.call(this) || this;
        _this.identifier = "ChannelControllerPlugin";
        _this.priority = ChannelControllerPriority; // in reserved range 100 to 200
        var _channelQueue;
        Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_dynamicproto_js__["a" /* default */])(ChannelController, _this, function (_self, _base) {
            _self.setNextPlugin = function (next) {
                // The Channel controller is last in pipeline
            };
            _self.processTelemetry = function (item, itemCtx) {
                if (_channelQueue) {
                    Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["a" /* arrForEach */])(_channelQueue, function (queues) {
                        // pass on to first item in queue
                        if (queues.length > 0) {
                            // Copying the item context as we could have mutiple chains that are executing asynchronously
                            // and calling _getDefTelCtx as it's possible that the caller doesn't pass any context
                            var chainCtx = _this._getTelCtx(itemCtx).createNew(queues);
                            chainCtx.processNext(item);
                        }
                    });
                }
            };
            _self.getChannelControls = function () {
                return _channelQueue;
            };
            _self.initialize = function (config, core, extensions) {
                if (_self.isInitialized()) {
                    // already initialized
                    return;
                }
                _base.initialize(config, core, extensions);
                _createChannelQueues((config || {}).channels, extensions);
                // Initialize the Queues
                Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["a" /* arrForEach */])(_channelQueue, function (queue) { return Object(__WEBPACK_IMPORTED_MODULE_4__TelemetryHelpers__["a" /* initializePlugins */])(new __WEBPACK_IMPORTED_MODULE_3__ProcessTelemetryContext__["a" /* ProcessTelemetryContext */](queue, config, core), extensions); });
            };
        });
        function _checkQueuePriority(queue) {
            Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["a" /* arrForEach */])(queue, function (queueItem) {
                if (queueItem.priority < ChannelControllerPriority) {
                    Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["H" /* throwError */])(ChannelValidationMessage + queueItem.identifier);
                }
            });
        }
        function _addChannelQueue(queue) {
            if (queue && queue.length > 0) {
                queue = queue.sort(function (a, b) {
                    return a.priority - b.priority;
                });
                _checkQueuePriority(queue);
                _channelQueue.push(queue);
            }
        }
        function _createChannelQueues(channels, extensions) {
            _channelQueue = [];
            if (channels) {
                // Add and sort the configuration channel queues
                Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["a" /* arrForEach */])(channels, function (queue) { return _addChannelQueue(queue); });
            }
            if (extensions) {
                // Create a new channel queue for any extensions with a priority > the ChannelControllerPriority
                var extensionQueue_1 = [];
                Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["a" /* arrForEach */])(extensions, function (plugin) {
                    if (plugin.priority > ChannelControllerPriority) {
                        extensionQueue_1.push(plugin);
                    }
                });
                _addChannelQueue(extensionQueue_1);
            }
        }
        return _this;
    }
// Removed Stub for ChannelController.prototype.processTelemetry.
    ;
// Removed Stub for ChannelController.prototype.getChannelControls.
// Removed Stub for ChannelController.prototype.initialize.
    /**
     * Static constructor, attempt to create accessors
     */
    // tslint:disable-next-line
    ChannelController._staticInit = (function () {
        var proto = ChannelController.prototype;
        // Dynamically create get/set property accessors
        Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["A" /* objDefineAccessors */])(proto, "ChannelControls", proto.getChannelControls);
        Object(__WEBPACK_IMPORTED_MODULE_5__HelperFuncs__["A" /* objDefineAccessors */])(proto, "channelQueue", proto.getChannelControls);
    })();
    return ChannelController;
}(__WEBPACK_IMPORTED_MODULE_2__BaseTelemetryPlugin__["a" /* BaseTelemetryPlugin */]));

//# sourceMappingURL=ChannelController.js.map

/***/ }),
/* 1500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TelemetryPluginChain; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PerfManager__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JavaScriptSDK_Enums_LoggingEnums__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HelperFuncs__ = __webpack_require__(45);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var TelemetryPluginChain = /** @class */ (function () {
    function TelemetryPluginChain(plugin, defItemCtx) {
        var _self = this;
        var _nextProxy = null;
        var _hasProcessTelemetry = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["p" /* isFunction */])(plugin.processTelemetry);
        var _hasSetNext = Object(__WEBPACK_IMPORTED_MODULE_2__HelperFuncs__["p" /* isFunction */])(plugin.setNextPlugin);
        _self._hasRun = false;
        _self.getPlugin = function () {
            return plugin;
        };
        _self.getNext = function () {
            return _nextProxy;
        };
        _self.setNext = function (nextPlugin) {
            _nextProxy = nextPlugin;
        };
        _self.processTelemetry = function (env, itemCtx) {
            if (!itemCtx) {
                // Looks like a plugin didn't pass the (optional) context, so restore to the default
                itemCtx = defItemCtx;
            }
            var identifier = plugin ? plugin.identifier : "TelemetryPluginChain";
            Object(__WEBPACK_IMPORTED_MODULE_0__PerfManager__["b" /* doPerf */])(itemCtx ? itemCtx.core() : null, function () { return identifier + ":processTelemetry"; }, function () {
                if (plugin && _hasProcessTelemetry) {
                    _self._hasRun = true;
                    try {
                        // Ensure that we keep the context in sync (for processNext()), just in case a plugin
                        // doesn't calls processTelemetry() instead of itemContext.processNext() or some 
                        // other form of error occurred
                        itemCtx.setNext(_nextProxy);
                        if (_hasSetNext) {
                            // Backward compatibility setting the next plugin on the instance
                            plugin.setNextPlugin(_nextProxy);
                        }
                        // Set a flag on the next plugin so we know if it was attempted to be executed
                        _nextProxy && (_nextProxy._hasRun = false);
                        plugin.processTelemetry(env, itemCtx);
                    }
                    catch (error) {
                        var hasRun = _nextProxy && _nextProxy._hasRun;
                        if (!_nextProxy || !hasRun) {
                            // Either we have no next plugin or the current one did not attempt to call the next plugin
                            // Which means the current one is the root of the failure so log/report this failure
                            itemCtx.diagLog().throwInternal(__WEBPACK_IMPORTED_MODULE_1__JavaScriptSDK_Enums_LoggingEnums__["a" /* LoggingSeverity */].CRITICAL, __WEBPACK_IMPORTED_MODULE_1__JavaScriptSDK_Enums_LoggingEnums__["b" /* _InternalMessageId */].PluginException, "Plugin [" + plugin.identifier + "] failed during processTelemetry - " + error);
                        }
                        if (_nextProxy && !hasRun) {
                            // As part of the failure the current plugin did not attempt to call the next plugin in the cahin
                            // So rather than leave the pipeline dead in the water we call the next plugin
                            _nextProxy.processTelemetry(env, itemCtx);
                        }
                    }
                }
                else if (_nextProxy) {
                    _self._hasRun = true;
                    // The underlying plugin is either not defined or does not have a processTelemetry implementation
                    // so we still want the next plugin to be executed.
                    _nextProxy.processTelemetry(env, itemCtx);
                }
            }, function () { return ({ item: env }); }, !(env.sync));
        };
    }
    return TelemetryPluginChain;
}());

//# sourceMappingURL=TelemetryPluginChain.js.map

/***/ }),
/* 1501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Undefined */
/* unused harmony export addEventHandler */
/* unused harmony export newGuid */
/* unused harmony export perfNow */
/* harmony export (immutable) */ __webpack_exports__["g"] = newId;
/* unused harmony export strEndsWith */
/* harmony export (immutable) */ __webpack_exports__["e"] = generateW3CId;
/* unused harmony export CoreUtils */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventHelper; });
/* unused harmony export _legacyCookieMgr */
/* harmony export (immutable) */ __webpack_exports__["d"] = disableCookies;
/* harmony export (immutable) */ __webpack_exports__["b"] = canUseCookies;
/* harmony export (immutable) */ __webpack_exports__["f"] = getCookie;
/* harmony export (immutable) */ __webpack_exports__["h"] = setCookie;
/* harmony export (immutable) */ __webpack_exports__["c"] = deleteCookie;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CookieMgr__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EnvUtils__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RandomHelper__ = __webpack_require__(603);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */








var _cookieMgrs = null;
var _canUseCookies; // legacy supported config
// Added to help with minfication
var Undefined = __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["m" /* strShimUndefined */];
/**
 * Trys to add an event handler for the specified event to the window, body and document
 * @param eventName {string} - The name of the event
 * @param callback {any} - The callback function that needs to be executed for the given event
 * @return {boolean} - true if the handler was successfully added
 */
function addEventHandler(eventName, callback) {
    var result = false;
    var w = Object(__WEBPACK_IMPORTED_MODULE_2__EnvUtils__["l" /* getWindow */])();
    if (w) {
        result = Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["e" /* attachEvent */])(w, eventName, callback);
        result = Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["e" /* attachEvent */])(w["body"], eventName, callback) || result;
    }
    var doc = Object(__WEBPACK_IMPORTED_MODULE_2__EnvUtils__["d" /* getDocument */])();
    if (doc) {
        result = EventHelper.Attach(doc, eventName, callback) || result;
    }
    return result;
}
function newGuid() {
    function randomHexDigit() {
        return Object(__WEBPACK_IMPORTED_MODULE_4__RandomHelper__["d" /* randomValue */])(15); // Get a random value from 0..15
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(GuidRegex, function (c) {
        var r = (randomHexDigit() | 0), v = (c === 'x' ? r : r & 0x3 | 0x8);
        return v.toString(16);
    });
}
/**
 * Return the current value of the Performance Api now() function (if available) and fallback to dateNow() if it is unavailable (IE9 or less)
 * https://caniuse.com/#search=performance.now
 */
function perfNow() {
    var perf = Object(__WEBPACK_IMPORTED_MODULE_2__EnvUtils__["k" /* getPerformance */])();
    if (perf && perf.now) {
        return perf.now();
    }
    return Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["g" /* dateNow */])();
}
/**
 * Generate random base64 id string.
 * The default length is 22 which is 132-bits so almost the same as a GUID but as base64 (the previous default was 5)
 * @param maxLength - Optional value to specify the length of the id to be generated, defaults to 22
 */
function newId(maxLength) {
    if (maxLength === void 0) { maxLength = 22; }
    var base64chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Start with an initial random number, consuming the value in reverse byte order
    var number = Object(__WEBPACK_IMPORTED_MODULE_4__RandomHelper__["c" /* random32 */])() >>> 0; // Make sure it's a +ve number
    var chars = 0;
    var result = "";
    while (result.length < maxLength) {
        chars++;
        result += base64chars.charAt(number & 0x3F);
        number >>>= 6; // Zero fill with right shift
        if (chars === 5) {
            // 5 base64 characters === 30 bits so we don't have enough bits for another base64 char
            // So add on another 30 bits and make sure it's +ve
            number = (((Object(__WEBPACK_IMPORTED_MODULE_4__RandomHelper__["c" /* random32 */])() << 2) & 0xFFFFFFFF) | (number & 0x03)) >>> 0;
            chars = 0; // We need to reset the number every 5 chars (30 bits)
        }
    }
    return result;
}
/**
 * The strEndsWith() method determines whether a string ends with the characters of a specified string, returning true or false as appropriate.
 * @param value - The value to check whether it ends with the search value.
 * @param search - The characters to be searched for at the end of the value.
 * @returns true if the given search value is found at the end of the string, otherwise false.
 */
function strEndsWith(value, search) {
    if (value && search) {
        var len = value.length;
        var start = len - search.length;
        return value.substring(start >= 0 ? start : 0, len) === search;
    }
    return false;
}
/**
 * generate W3C trace id
 */
function generateW3CId() {
    var hexValues = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
    // rfc4122 version 4 UUID without dashes and with lowercase letters
    var oct = "", tmp;
    for (var a = 0; a < 4; a++) {
        tmp = Object(__WEBPACK_IMPORTED_MODULE_4__RandomHelper__["c" /* random32 */])();
        oct +=
            hexValues[tmp & 0xF] +
                hexValues[tmp >> 4 & 0xF] +
                hexValues[tmp >> 8 & 0xF] +
                hexValues[tmp >> 12 & 0xF] +
                hexValues[tmp >> 16 & 0xF] +
                hexValues[tmp >> 20 & 0xF] +
                hexValues[tmp >> 24 & 0xF] +
                hexValues[tmp >> 28 & 0xF];
    }
    // "Set the two most significant bits (bits 6 and 7) of the clock_seq_hi_and_reserved to zero and one, respectively"
    var clockSequenceHi = hexValues[8 + (Object(__WEBPACK_IMPORTED_MODULE_4__RandomHelper__["c" /* random32 */])() & 0x03) | 0];
    return oct.substr(0, 8) + oct.substr(9, 4) + "4" + oct.substr(13, 3) + clockSequenceHi + oct.substr(16, 3) + oct.substr(19, 12);
}
/**
 * Provides a collection of utility functions, included for backward compatibility with previous releases.
 * @deprecated Marking this instance as deprecated in favor of direct usage of the helper functions
 * as direct usage provides better tree-shaking and minification by avoiding the inclusion of the unused items
 * in your resulting code.
 */
var CoreUtils = {
    _canUseCookies: undefined,
    isTypeof: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["x" /* isTypeof */],
    isUndefined: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["y" /* isUndefined */],
    isNullOrUndefined: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["s" /* isNullOrUndefined */],
    hasOwnProperty: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["k" /* hasOwnProperty */],
    isFunction: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["p" /* isFunction */],
    isObject: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["u" /* isObject */],
    isDate: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["n" /* isDate */],
    isArray: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["l" /* isArray */],
    isError: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["o" /* isError */],
    isString: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["v" /* isString */],
    isNumber: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["t" /* isNumber */],
    isBoolean: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["m" /* isBoolean */],
    toISOString: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["I" /* toISOString */],
    arrForEach: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["a" /* arrForEach */],
    arrIndexOf: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["b" /* arrIndexOf */],
    arrMap: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["c" /* arrMap */],
    arrReduce: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["d" /* arrReduce */],
    strTrim: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["G" /* strTrim */],
    objCreate: __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["i" /* objCreateFn */],
    objKeys: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["C" /* objKeys */],
    objDefineAccessors: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["A" /* objDefineAccessors */],
    addEventHandler: addEventHandler,
    dateNow: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["g" /* dateNow */],
    isIE: __WEBPACK_IMPORTED_MODULE_2__EnvUtils__["n" /* isIE */],
    disableCookies: disableCookies,
    newGuid: newGuid,
    perfNow: perfNow,
    newId: newId,
    randomValue: __WEBPACK_IMPORTED_MODULE_4__RandomHelper__["d" /* randomValue */],
    random32: __WEBPACK_IMPORTED_MODULE_4__RandomHelper__["c" /* random32 */],
    mwcRandomSeed: __WEBPACK_IMPORTED_MODULE_4__RandomHelper__["b" /* mwcRandomSeed */],
    mwcRandom32: __WEBPACK_IMPORTED_MODULE_4__RandomHelper__["a" /* mwcRandom32 */],
    generateW3CId: generateW3CId
};
var GuidRegex = /[xy]/g;
var EventHelper = {
    Attach: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["e" /* attachEvent */],
    AttachEvent: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["e" /* attachEvent */],
    Detach: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["h" /* detachEvent */],
    DetachEvent: __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["h" /* detachEvent */]
};
/**
 * Helper to support backward compatibility for users that use the legacy cookie handling functions and the use the internal
 * CoreUtils._canUseCookies global flag to enable/disable cookies usage.
 * Note: This has the following deliberate side-effects
 * - Creates the global (legacy) cookie manager if it does not already exist
 * - Attempts to add "listeners" to the CoreUtils._canUseCookies property to support the legacy usage
 * @param config
 * @param logger
 * @returns
 */
function _legacyCookieMgr(config, logger) {
    var cookieMgr = Object(__WEBPACK_IMPORTED_MODULE_1__CookieMgr__["a" /* _gblCookieMgr */])(config, logger);
    var legacyCanUseCookies = CoreUtils._canUseCookies;
    if (_cookieMgrs === null) {
        _cookieMgrs = [];
        _canUseCookies = legacyCanUseCookies;
        // Dynamically create get/set property accessors for backward compatibility for enabling / disabling cookies
        // this WILL NOT work for ES3 browsers (< IE8)
        Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["A" /* objDefineAccessors */])(CoreUtils, "_canUseCookies", function () {
            return _canUseCookies;
        }, function (value) {
            _canUseCookies = value;
            Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["a" /* arrForEach */])(_cookieMgrs, function (mgr) {
                mgr.setEnabled(value);
            });
        });
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["b" /* arrIndexOf */])(_cookieMgrs, cookieMgr) === -1) {
        _cookieMgrs.push(cookieMgr);
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["m" /* isBoolean */])(legacyCanUseCookies)) {
        cookieMgr.setEnabled(legacyCanUseCookies);
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["m" /* isBoolean */])(_canUseCookies)) {
        cookieMgr.setEnabled(_canUseCookies);
    }
    return cookieMgr;
}
/**
 * @deprecated - Use the core.getCookieMgr().disable()
 * Force the SDK not to store and read any data from cookies.
 */
function disableCookies() {
    _legacyCookieMgr().setEnabled(false);
}
/**
 * @deprecated - Use the core.getCookieMgr().isEnabled()
 * Helper method to tell if document.cookie object is available and whether it can be used.
 */
function canUseCookies(logger) {
    return _legacyCookieMgr(null, logger).isEnabled();
}
/**
 * @deprecated - Use the core.getCookieMgr().get()
 * helper method to access userId and sessionId cookie
 */
function getCookie(logger, name) {
    return _legacyCookieMgr(null, logger).get(name);
}
/**
 * @deprecated - Use the core.getCookieMgr().set()
 * helper method to set userId and sessionId cookie
 */
function setCookie(logger, name, value, domain) {
    _legacyCookieMgr(null, logger).set(name, value, null, domain);
}
/**
 * @deprecated - Use the core.getCookieMgr().del()
 * Deletes a cookie by setting it's expiration time in the past.
 * @param name - The name of the cookie to delete.
 */
function deleteCookie(logger, name) {
    return _legacyCookieMgr(null, logger).del(name);
}
//# sourceMappingURL=CoreUtils.js.map

/***/ }),
/* 1502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = InstrumentProto;
/* unused harmony export InstrumentProtos */
/* harmony export (immutable) */ __webpack_exports__["a"] = InstrumentFunc;
/* unused harmony export InstrumentFuncs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HelperFuncs__ = __webpack_require__(45);
/*
 * Application Insights JavaScript SDK - Core, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var aiInstrumentHooks = "_aiHooks";
;
var cbNames = [
    "req", "rsp", "hkErr", "fnErr"
];
/**
 * Constant string defined to support minimization
 * @ignore
 */
var str__Proto = "__proto__";
/**
 * Constant string defined to support minimization
 * @ignore
 */
var strConstructor = "constructor";
/** @ignore */
function _arrLoop(arr, fn) {
    if (arr) {
        for (var lp = 0; lp < arr.length; lp++) {
            if (fn(arr[lp], lp)) {
                break;
            }
        }
    }
}
/** @ignore */
function _doCallbacks(hooks, callDetails, cbArgs, hookCtx, type) {
    if (type >= 0 /* Request */ && type <= 2 /* HookError */) {
        _arrLoop(hooks, function (hook, idx) {
            var cbks = hook.cbks;
            var cb = cbks[cbNames[type]];
            if (cb) {
                // Set the specific hook context implementation using a lazy creation pattern
                callDetails.ctx = function () {
                    var ctx = hookCtx[idx] = (hookCtx[idx] || {});
                    return ctx;
                };
                try {
                    cb.apply(callDetails.inst, cbArgs);
                }
                catch (err) {
                    var orgEx = callDetails.err;
                    try {
                        // Report Hook error via the callback
                        var hookErrorCb = cbks[cbNames[2 /* HookError */]];
                        if (hookErrorCb) {
                            callDetails.err = err;
                            hookErrorCb.apply(callDetails.inst, cbArgs);
                        }
                    }
                    catch (e) {
                        // Not much we can do here -- swallowing the exception to avoid crashing the hosting app
                    }
                    finally {
                        // restore the original exception (if any)
                        callDetails.err = orgEx;
                    }
                }
            }
        });
    }
}
/** @ignore */
function _createFunctionHook(aiHook) {
    // Define a temporary method that queues-up a the real method call
    return function () {
        var funcThis = this;
        // Capture the original arguments passed to the method
        var orgArgs = arguments;
        var hooks = aiHook.h;
        var funcArgs = {
            name: aiHook.n,
            inst: funcThis,
            ctx: null,
            set: _replaceArg
        };
        var hookCtx = [];
        var cbArgs = _createArgs([funcArgs], orgArgs);
        function _createArgs(target, theArgs) {
            _arrLoop(theArgs, function (arg) {
                target.push(arg);
            });
            return target;
        }
        function _replaceArg(idx, value) {
            orgArgs = _createArgs([], orgArgs);
            orgArgs[idx] = value;
            cbArgs = _createArgs([funcArgs], orgArgs);
        }
        // Call the pre-request hooks
        _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 0 /* Request */);
        // Call the original function was called
        var theFunc = aiHook.f;
        try {
            funcArgs.rslt = theFunc.apply(funcThis, orgArgs);
        }
        catch (err) {
            // Report the request callback
            funcArgs.err = err;
            _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 3 /* FunctionError */);
            // rethrow the original exception so anyone listening for it can catch the exception
            throw err;
        }
        // Call the post-request hooks
        _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 1 /* Response */);
        return funcArgs.rslt;
    };
}
/**
 * Pre-lookup to check if we are running on a modern browser (i.e. not IE8)
 * @ignore
 */
var _objGetPrototypeOf = Object["getPrototypeOf"];
/**
 * Helper used to get the prototype of the target object as getPrototypeOf is not available in an ES3 environment.
 * @ignore
 */
function _getObjProto(target) {
    if (target) {
        // This method doesn't existing in older browsers (e.g. IE8)
        if (_objGetPrototypeOf) {
            return _objGetPrototypeOf(target);
        }
        // target[Constructor] May break if the constructor has been changed or removed
        var newProto = target[str__Proto] || target[__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["l" /* strShimPrototype */]] || target[strConstructor];
        if (newProto) {
            return newProto;
        }
    }
    return null;
}
/** @ignore */
function _getOwner(target, name, checkPrototype) {
    var owner = null;
    if (target) {
        if (Object(__WEBPACK_IMPORTED_MODULE_1__HelperFuncs__["k" /* hasOwnProperty */])(target, name)) {
            owner = target;
        }
        else if (checkPrototype) {
            owner = _getOwner(_getObjProto(target), name, false);
        }
    }
    return owner;
}
/**
 * Intercept the named prototype functions for the target class / object
 * @param target - The target object
 * @param funcName - The function name
 * @param callbacks - The callbacks to configure and call whenever the function is called
 */
function InstrumentProto(target, funcName, callbacks) {
    if (target) {
        return InstrumentFunc(target[__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["l" /* strShimPrototype */]], funcName, callbacks, false);
    }
    return null;
}
/**
 * Intercept the named prototype functions for the target class / object
 * @param target - The target object
 * @param funcNames - The function names to intercept and call
 * @param callbacks - The callbacks to configure and call whenever the function is called
 */
function InstrumentProtos(target, funcNames, callbacks) {
    if (target) {
        return InstrumentFuncs(target[__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["l" /* strShimPrototype */]], funcNames, callbacks, false);
    }
    return null;
}
/**
 * Intercept the named prototype functions for the target class / object
 * @param target - The target object
 * @param funcName - The function name
 * @param callbacks - The callbacks to configure and call whenever the function is called
 * @param checkPrototype - If the function doesn't exist on the target should it attempt to hook the prototype function
 */
function InstrumentFunc(target, funcName, callbacks, checkPrototype) {
    if (checkPrototype === void 0) { checkPrototype = true; }
    if (target && funcName && callbacks) {
        var owner = _getOwner(target, funcName, checkPrototype);
        if (owner) {
            var fn = owner[funcName];
            if (typeof fn === __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["j" /* strShimFunction */]) {
                var aiHook_1 = fn[aiInstrumentHooks];
                if (!aiHook_1) {
                    // Only hook the function once
                    aiHook_1 = {
                        i: 0,
                        n: funcName,
                        f: fn,
                        h: []
                    };
                    // Override (hook) the original function
                    var newFunc = _createFunctionHook(aiHook_1);
                    newFunc[aiInstrumentHooks] = aiHook_1; // Tag and store the function hooks
                    owner[funcName] = newFunc;
                }
                var theHook = {
                    // tslint:disable:object-literal-shorthand
                    id: aiHook_1.i,
                    cbks: callbacks,
                    rm: function () {
                        // DO NOT Use () => { shorthand for the function as the this gets replaced
                        // with the outer this and not the this for theHook instance.
                        var id = this.id;
                        _arrLoop(aiHook_1.h, function (hook, idx) {
                            if (hook.id === id) {
                                aiHook_1.h.splice(idx, 1);
                                return 1;
                            }
                        });
                    }
                    // tslint:enable:object-literal-shorthand
                };
                aiHook_1.i++;
                aiHook_1.h.push(theHook);
                return theHook;
            }
        }
    }
    return null;
}
/**
 * Intercept the named functions for the target class / object
 * @param target - The target object
 * @param funcNames - The function names to intercept and call
 * @param callbacks - The callbacks to configure and call whenever the function is called
 * @param checkPrototype - If the function doesn't exist on the target should it attempt to hook the prototype function
 */
function InstrumentFuncs(target, funcNames, callbacks, checkPrototype) {
    if (checkPrototype === void 0) { checkPrototype = true; }
    var hooks = null;
    _arrLoop(funcNames, function (funcName) {
        var hook = InstrumentFunc(target, funcName, callbacks, checkPrototype);
        if (hook) {
            if (!hooks) {
                hooks = [];
            }
            hooks.push(hook);
        }
    });
    return hooks;
}
//# sourceMappingURL=InstrumentHooks.js.map

/***/ }),
/* 1503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export parseConnectionString */
/* unused harmony export ConnectionStringParser */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__ = __webpack_require__(35);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var _FIELDS_SEPARATOR = ";";
var _FIELD_KEY_VALUE_SEPARATOR = "=";
function parseConnectionString(connectionString) {
    if (!connectionString) {
        return {};
    }
    var kvPairs = connectionString.split(_FIELDS_SEPARATOR);
    var result = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["i" /* arrReduce */])(kvPairs, function (fields, kv) {
        var kvParts = kv.split(_FIELD_KEY_VALUE_SEPARATOR);
        if (kvParts.length === 2) {
            var key = kvParts[0].toLowerCase();
            var value = kvParts[1];
            fields[key] = value;
        }
        return fields;
    }, {});
    if (Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["N" /* objKeys */])(result).length > 0) {
        // this is a valid connection string, so parse the results
        if (result.endpointsuffix) {
            // use endpoint suffix where overrides are not provided
            var locationPrefix = result.location ? result.location + "." : "";
            result.ingestionendpoint = result.ingestionendpoint || ("https://" + locationPrefix + "dc." + result.endpointsuffix);
        }
        // apply the default endpoints
        result.ingestionendpoint = result.ingestionendpoint || __WEBPACK_IMPORTED_MODULE_0__Constants__["a" /* DEFAULT_BREEZE_ENDPOINT */];
    }
    return result;
}
var ConnectionStringParser = {
    parse: parseConnectionString
};
//# sourceMappingURL=ConnectionStringParser.js.map

/***/ }),
/* 1504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Envelope */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_Envelope__ = __webpack_require__(1505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DataSanitizer__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Constants__ = __webpack_require__(83);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







var Envelope = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(Envelope, _super);
    /**
     * Constructs a new instance of telemetry data.
     */
    function Envelope(logger, data, name) {
        var _this = _super.call(this) || this;
        _this.name = Object(__WEBPACK_IMPORTED_MODULE_2__DataSanitizer__["f" /* dataSanitizeString */])(logger, name) || __WEBPACK_IMPORTED_MODULE_4__Constants__["c" /* strNotSpecified */];
        _this.data = data;
        _this.time = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["T" /* toISOString */])(new Date());
        _this.aiDataContract = {
            time: 1 /* Required */,
            iKey: 1 /* Required */,
            name: 1 /* Required */,
            sampleRate: function () {
                return (_this.sampleRate === 100) ? 4 /* Hidden */ : 1 /* Required */;
            },
            tags: 1 /* Required */,
            data: 1 /* Required */
        };
        return _this;
    }
    return Envelope;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_Envelope__["a" /* Envelope */]));

//# sourceMappingURL=Envelope.js.map

/***/ }),
/* 1505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Envelope; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * System variables for a telemetry item.
 */
var Envelope = /** @class */ (function () {
    function Envelope() {
        /**
         * Envelope version. For internal use only. By assigning this the default, it will not be serialized within the payload unless changed to a value other than #1.
         */
        this.ver = 1;
        /**
         * Sampling rate used in application. This telemetry item represents 1 / sampleRate actual telemetry items.
         */
        this.sampleRate = 100.0;
        /**
         * Key/value collection of context properties. See ContextTagKeys for information on available properties.
         */
        this.tags = {};
    }
    return Envelope;
}());

//# sourceMappingURL=Envelope.js.map

/***/ }),
/* 1506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Event */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_EventData__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Constants__ = __webpack_require__(83);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var Event = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(Event, _super);
    /**
     * Constructs a new instance of the EventTelemetry object
     */
    function Event(logger, name, properties, measurements) {
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            ver: 1 /* Required */,
            name: 1 /* Required */,
            properties: 0 /* Default */,
            measurements: 0 /* Default */
        };
        _this.name = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, name) || __WEBPACK_IMPORTED_MODULE_3__Constants__["c" /* strNotSpecified */];
        _this.properties = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["e" /* dataSanitizeProperties */])(logger, properties);
        _this.measurements = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["c" /* dataSanitizeMeasurements */])(logger, measurements);
        return _this;
    }
    Event.envelopeType = "Microsoft.ApplicationInsights.{0}.Event";
    Event.dataType = "EventData";
    return Event;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_EventData__["a" /* EventData */]));

//# sourceMappingURL=Event.js.map

/***/ }),
/* 1507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export _formatErrorCode */
/* unused harmony export Exception */
/* unused harmony export _ExceptionDetails */
/* unused harmony export _StackFrame */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_StackFrame__ = __webpack_require__(1508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Interfaces_Contracts_Generated_ExceptionData__ = __webpack_require__(1509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Interfaces_Contracts_Generated_ExceptionDetails__ = __webpack_require__(1510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Common_DataSanitizer__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Constants__ = __webpack_require__(83);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */









var NoMethod = "<no_method>";
var strError = "error";
var strStack = "stack";
var strStackDetails = "stackDetails";
var strErrorSrc = "errorSrc";
var strMessage = "message";
var strDescription = "description";
function _stringify(value, convertToString) {
    var result = value;
    if (result && !Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["J" /* isString */])(result)) {
        if (JSON && JSON.stringify) {
            result = JSON.stringify(value);
            if (convertToString && (!result || result === "{}")) {
                if (Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["F" /* isFunction */])(value.toString)) {
                    result = value.toString();
                }
                else {
                    result = "" + value;
                }
            }
        }
        else {
            result = "" + value + " - (Missing JSON.stringify)";
        }
    }
    return result || "";
}
function _formatMessage(theEvent, errorType) {
    var evtMessage = theEvent;
    if (theEvent) {
        evtMessage = theEvent[strMessage] || theEvent[strDescription] || "";
        // Make sure the message is a string
        if (evtMessage && !Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["J" /* isString */])(evtMessage)) {
            // tslint:disable-next-line: prefer-conditional-expression
            evtMessage = _stringify(evtMessage, true);
        }
        if (theEvent["filename"]) {
            // Looks like an event object with filename
            evtMessage = evtMessage + " @" + (theEvent["filename"] || "") + ":" + (theEvent["lineno"] || "?") + ":" + (theEvent["colno"] || "?");
        }
    }
    // Automatically add the error type to the message if it does already appear to be present
    if (errorType && errorType !== "String" && errorType !== "Object" && errorType !== "Error" && (evtMessage || "").indexOf(errorType) === -1) {
        evtMessage = errorType + ": " + evtMessage;
    }
    return evtMessage || "";
}
function _isExceptionDetailsInternal(value) {
    if (Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["I" /* isObject */])(value)) {
        return "hasFullStack" in value && "typeName" in value;
    }
    return false;
}
function _isExceptionInternal(value) {
    if (Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["I" /* isObject */])(value)) {
        return ("ver" in value && "exceptions" in value && "properties" in value);
    }
    return false;
}
function _isStackDetails(details) {
    return details && details.src && Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["J" /* isString */])(details.src) && details.obj && Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["C" /* isArray */])(details.obj);
}
function _convertStackObj(errorStack) {
    var src = errorStack || "";
    if (!Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["J" /* isString */])(src)) {
        if (Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["J" /* isString */])(src[strStack])) {
            src = src[strStack];
        }
        else {
            src = "" + src;
        }
    }
    var items = src.split("\n");
    return {
        src: src,
        obj: items
    };
}
function _getOperaStack(errorMessage) {
    var stack = [];
    var lines = errorMessage.split("\n");
    for (var lp = 0; lp < lines.length; lp++) {
        var entry = lines[lp];
        if (lines[lp + 1]) {
            entry += "@" + lines[lp + 1];
            lp++;
        }
        stack.push(entry);
    }
    return {
        src: errorMessage,
        obj: stack
    };
}
function _getStackFromErrorObj(errorObj) {
    var details = null;
    if (errorObj) {
        try {
            /* Using bracket notation is support older browsers (IE 7/8 -- dont remember the version) that throw when using dot
            notation for undefined objects and we don't want to loose the error from being reported */
            if (errorObj[strStack]) {
                // Chrome/Firefox
                details = _convertStackObj(errorObj[strStack]);
            }
            else if (errorObj[strError] && errorObj[strError][strStack]) {
                // Edge error event provides the stack and error object
                details = _convertStackObj(errorObj[strError][strStack]);
            }
            else if (errorObj['exception'] && errorObj.exception[strStack]) {
                details = _convertStackObj(errorObj.exception[strStack]);
            }
            else if (_isStackDetails(errorObj)) {
                details = errorObj;
            }
            else if (_isStackDetails(errorObj[strStackDetails])) {
                details = errorObj[strStackDetails];
            }
            else if (window['opera'] && errorObj[strMessage]) {
                // Opera
                details = _getOperaStack(errorObj.message);
            }
            else if (Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["J" /* isString */])(errorObj)) {
                details = _convertStackObj(errorObj);
            }
            else {
                var evtMessage = errorObj[strMessage] || errorObj[strDescription] || "";
                if (Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["J" /* isString */])(errorObj[strErrorSrc])) {
                    if (evtMessage) {
                        evtMessage += "\n";
                    }
                    evtMessage += " from " + errorObj[strErrorSrc];
                }
                if (evtMessage) {
                    details = _convertStackObj(evtMessage);
                }
            }
        }
        catch (e) {
            // something unexpected happened so to avoid failing to report any error lets swallow the exception 
            // and fallback to the callee/caller method
            details = _convertStackObj(e);
        }
    }
    return details || {
        src: "",
        obj: null
    };
}
function _formatStackTrace(stackDetails) {
    var stack = "";
    if (stackDetails) {
        if (stackDetails.obj) {
            Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["g" /* arrForEach */])(stackDetails.obj, function (entry) {
                stack += entry + "\n";
            });
        }
        else {
            stack = stackDetails.src || "";
        }
    }
    return stack;
}
function _parseStack(stack) {
    var parsedStack;
    var frames = stack.obj;
    if (frames && frames.length > 0) {
        parsedStack = [];
        var level_1 = 0;
        var totalSizeInBytes_1 = 0;
        Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["g" /* arrForEach */])(frames, function (frame) {
            var theFrame = frame.toString();
            if (_StackFrame.regex.test(theFrame)) {
                var parsedFrame = new _StackFrame(theFrame, level_1++);
                totalSizeInBytes_1 += parsedFrame.sizeInBytes;
                parsedStack.push(parsedFrame);
            }
        });
        // DP Constraint - exception parsed stack must be < 32KB
        // remove frames from the middle to meet the threshold
        var exceptionParsedStackThreshold = 32 * 1024;
        if (totalSizeInBytes_1 > exceptionParsedStackThreshold) {
            var left = 0;
            var right = parsedStack.length - 1;
            var size = 0;
            var acceptedLeft = left;
            var acceptedRight = right;
            while (left < right) {
                // check size
                var lSize = parsedStack[left].sizeInBytes;
                var rSize = parsedStack[right].sizeInBytes;
                size += lSize + rSize;
                if (size > exceptionParsedStackThreshold) {
                    // remove extra frames from the middle
                    var howMany = acceptedRight - acceptedLeft + 1;
                    parsedStack.splice(acceptedLeft, howMany);
                    break;
                }
                // update pointers
                acceptedLeft = left;
                acceptedRight = right;
                left++;
                right--;
            }
        }
    }
    return parsedStack;
}
function _getErrorType(errorType) {
    // Gets the Error Type by passing the constructor (used to get the true type of native error object).
    var typeName = "";
    if (errorType) {
        typeName = errorType.typeName || errorType.name || "";
        if (!typeName) {
            try {
                var funcNameRegex = /function (.{1,})\(/;
                var results = (funcNameRegex).exec((errorType).constructor.toString());
                typeName = (results && results.length > 1) ? results[1] : "";
            }
            catch (e) {
                // Ignore
            }
        }
    }
    return typeName;
}
/**
 * Formats the provided errorObj for display and reporting, it may be a String, Object, integer or undefined depending on the browser.
 * @param errorObj The supplied errorObj
 */
function _formatErrorCode(errorObj) {
    if (errorObj) {
        try {
            if (!Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["J" /* isString */])(errorObj)) {
                var errorType = _getErrorType(errorObj);
                var result = _stringify(errorObj, false);
                if (!result || result === "{}") {
                    if (errorObj[strError]) {
                        // Looks like an MS Error Event
                        errorObj = errorObj[strError];
                        errorType = _getErrorType(errorObj);
                    }
                    result = _stringify(errorObj, true);
                }
                if (result.indexOf(errorType) !== 0 && errorType !== "String") {
                    return errorType + ":" + result;
                }
                return result;
            }
        }
        catch (e) {
        }
    }
    // Fallback to just letting the object format itself into a string
    return "" + (errorObj || "");
}
var Exception = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(Exception, _super);
    /**
     * Constructs a new instance of the ExceptionTelemetry object
     */
    function Exception(logger, exception, properties, measurements, severityLevel, id) {
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            ver: 1 /* Required */,
            exceptions: 1 /* Required */,
            severityLevel: 0 /* Default */,
            properties: 0 /* Default */,
            measurements: 0 /* Default */
        };
        if (!_isExceptionInternal(exception)) {
            if (!properties) {
                properties = {};
            }
            _this.exceptions = [new _ExceptionDetails(logger, exception, properties)];
            _this.properties = Object(__WEBPACK_IMPORTED_MODULE_4__Common_DataSanitizer__["e" /* dataSanitizeProperties */])(logger, properties);
            _this.measurements = Object(__WEBPACK_IMPORTED_MODULE_4__Common_DataSanitizer__["c" /* dataSanitizeMeasurements */])(logger, measurements);
            if (severityLevel) {
                _this.severityLevel = severityLevel;
            }
            if (id) {
                _this.id = id;
            }
        }
        else {
            _this.exceptions = exception.exceptions;
            _this.properties = exception.properties;
            _this.measurements = exception.measurements;
            if (exception.severityLevel) {
                _this.severityLevel = exception.severityLevel;
            }
            if (exception.id) {
                _this.id = exception.id;
            }
            if (exception.problemGroup) {
                _this.problemGroup = exception.problemGroup;
            }
            // bool/int types, use isNullOrUndefined
            _this.ver = 2; // TODO: handle the CS"4.0" ==> breeze 2 conversion in a better way
            if (!Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(exception.isManual)) {
                _this.isManual = exception.isManual;
            }
        }
        return _this;
    }
    Exception.CreateAutoException = function (message, url, lineNumber, columnNumber, error, evt, stack, errorSrc) {
        var errorType = _getErrorType(error || evt || message);
        return {
            message: _formatMessage(message, errorType),
            url: url,
            lineNumber: lineNumber,
            columnNumber: columnNumber,
            error: _formatErrorCode(error || evt || message),
            evt: _formatErrorCode(evt || message),
            typeName: errorType,
            stackDetails: _getStackFromErrorObj(stack || error || evt),
            errorSrc: errorSrc
        };
    };
    Exception.CreateFromInterface = function (logger, exception, properties, measurements) {
        var exceptions = exception.exceptions
            && Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["h" /* arrMap */])(exception.exceptions, function (ex) { return _ExceptionDetails.CreateFromInterface(logger, ex); });
        var exceptionData = new Exception(logger, Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["f" /* __assignFn */])({}, exception, { exceptions: exceptions }), properties, measurements);
        return exceptionData;
    };
    Exception.prototype.toInterface = function () {
        var _a = this, exceptions = _a.exceptions, properties = _a.properties, measurements = _a.measurements, severityLevel = _a.severityLevel, ver = _a.ver, problemGroup = _a.problemGroup, id = _a.id, isManual = _a.isManual;
        var exceptionDetailsInterface = exceptions instanceof Array
            && Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["h" /* arrMap */])(exceptions, function (exception) { return exception.toInterface(); })
            || undefined;
        return {
            ver: "4.0",
            exceptions: exceptionDetailsInterface,
            severityLevel: severityLevel,
            properties: properties,
            measurements: measurements,
            problemGroup: problemGroup,
            id: id,
            isManual: isManual
        };
    };
    /**
     * Creates a simple exception with 1 stack frame. Useful for manual constracting of exception.
     */
    Exception.CreateSimpleException = function (message, typeName, assembly, fileName, details, line) {
        return {
            exceptions: [
                {
                    hasFullStack: true,
                    message: message,
                    stack: details,
                    typeName: typeName
                }
            ]
        };
    };
    Exception.envelopeType = "Microsoft.ApplicationInsights.{0}.Exception";
    Exception.dataType = "ExceptionData";
    Exception.formatError = _formatErrorCode;
    return Exception;
}(__WEBPACK_IMPORTED_MODULE_2__Interfaces_Contracts_Generated_ExceptionData__["a" /* ExceptionData */]));

var _ExceptionDetails = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(_ExceptionDetails, _super);
    function _ExceptionDetails(logger, exception, properties) {
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            id: 0 /* Default */,
            outerId: 0 /* Default */,
            typeName: 1 /* Required */,
            message: 1 /* Required */,
            hasFullStack: 0 /* Default */,
            stack: 0 /* Default */,
            parsedStack: 2 /* Array */
        };
        if (!_isExceptionDetailsInternal(exception)) {
            var error = exception;
            var evt = error && error.evt;
            if (!Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["E" /* isError */])(error)) {
                error = error[strError] || evt || error;
            }
            _this.typeName = Object(__WEBPACK_IMPORTED_MODULE_4__Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, _getErrorType(error)) || __WEBPACK_IMPORTED_MODULE_6__Constants__["c" /* strNotSpecified */];
            _this.message = Object(__WEBPACK_IMPORTED_MODULE_4__Common_DataSanitizer__["d" /* dataSanitizeMessage */])(logger, _formatMessage(exception || error, _this.typeName)) || __WEBPACK_IMPORTED_MODULE_6__Constants__["c" /* strNotSpecified */];
            var stack = exception[strStackDetails] || _getStackFromErrorObj(exception);
            _this.parsedStack = _parseStack(stack);
            _this[strStack] = Object(__WEBPACK_IMPORTED_MODULE_4__Common_DataSanitizer__["a" /* dataSanitizeException */])(logger, _formatStackTrace(stack));
            _this.hasFullStack = Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["C" /* isArray */])(_this.parsedStack) && _this.parsedStack.length > 0;
            if (properties) {
                properties.typeName = properties.typeName || _this.typeName;
            }
        }
        else {
            _this.typeName = exception.typeName;
            _this.message = exception.message;
            _this[strStack] = exception[strStack];
            _this.parsedStack = exception.parsedStack;
            _this.hasFullStack = exception.hasFullStack;
        }
        return _this;
    }
    _ExceptionDetails.prototype.toInterface = function () {
        var parsedStack = this.parsedStack instanceof Array
            && Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["h" /* arrMap */])(this.parsedStack, function (frame) { return frame.toInterface(); });
        var exceptionDetailsInterface = {
            id: this.id,
            outerId: this.outerId,
            typeName: this.typeName,
            message: this.message,
            hasFullStack: this.hasFullStack,
            stack: this[strStack],
            parsedStack: parsedStack || undefined
        };
        return exceptionDetailsInterface;
    };
    _ExceptionDetails.CreateFromInterface = function (logger, exception) {
        var parsedStack = (exception.parsedStack instanceof Array
            && Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["h" /* arrMap */])(exception.parsedStack, function (frame) { return _StackFrame.CreateFromInterface(frame); }))
            || exception.parsedStack;
        var exceptionDetails = new _ExceptionDetails(logger, Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["f" /* __assignFn */])({}, exception, { parsedStack: parsedStack }));
        return exceptionDetails;
    };
    return _ExceptionDetails;
}(__WEBPACK_IMPORTED_MODULE_3__Interfaces_Contracts_Generated_ExceptionDetails__["a" /* ExceptionDetails */]));

var _StackFrame = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(_StackFrame, _super);
    function _StackFrame(sourceFrame, level) {
        var _this = _super.call(this) || this;
        _this.sizeInBytes = 0;
        _this.aiDataContract = {
            level: 1 /* Required */,
            method: 1 /* Required */,
            assembly: 0 /* Default */,
            fileName: 0 /* Default */,
            line: 0 /* Default */
        };
        // Not converting this to isString() as typescript uses this logic to "understand" the different
        // types for the 2 different code paths
        if (typeof sourceFrame === "string") {
            var frame = sourceFrame;
            _this.level = level;
            _this.method = NoMethod;
            _this.assembly = Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["R" /* strTrim */])(frame);
            _this.fileName = "";
            _this.line = 0;
            var matches = frame.match(_StackFrame.regex);
            if (matches && matches.length >= 5) {
                _this.method = Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["R" /* strTrim */])(matches[2]) || _this.method;
                _this.fileName = Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["R" /* strTrim */])(matches[4]);
                _this.line = parseInt(matches[5]) || 0;
            }
        }
        else {
            _this.level = sourceFrame.level;
            _this.method = sourceFrame.method;
            _this.assembly = sourceFrame.assembly;
            _this.fileName = sourceFrame.fileName;
            _this.line = sourceFrame.line;
            _this.sizeInBytes = 0;
        }
        _this.sizeInBytes += _this.method.length;
        _this.sizeInBytes += _this.fileName.length;
        _this.sizeInBytes += _this.assembly.length;
        // todo: these might need to be removed depending on how the back-end settles on their size calculation
        _this.sizeInBytes += _StackFrame.baseSize;
        _this.sizeInBytes += _this.level.toString().length;
        _this.sizeInBytes += _this.line.toString().length;
        return _this;
    }
    _StackFrame.CreateFromInterface = function (frame) {
        return new _StackFrame(frame, null /* level is available in frame interface */);
    };
    _StackFrame.prototype.toInterface = function () {
        return {
            level: this.level,
            method: this.method,
            assembly: this.assembly,
            fileName: this.fileName,
            line: this.line
        };
    };
    // regex to match stack frames from ie/chrome/ff
    // methodName=$2, fileName=$4, lineNo=$5, column=$6
    _StackFrame.regex = /^([\s]+at)?[\s]*([^\@\()]+?)[\s]*(\@|\()([^\(\n]+):([0-9]+):([0-9]+)(\)?)$/;
    _StackFrame.baseSize = 58; // '{"method":"","level":,"assembly":"","fileName":"","line":}'.length
    return _StackFrame;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_StackFrame__["a" /* StackFrame */]));

//# sourceMappingURL=Exception.js.map

/***/ }),
/* 1508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StackFrame; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// THIS FILE WAS AUTOGENERATED
/**
 * Stack frame information.
 */
var StackFrame = /** @class */ (function () {
    function StackFrame() {
    }
    return StackFrame;
}());

//# sourceMappingURL=StackFrame.js.map

/***/ }),
/* 1509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExceptionData; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * An instance of Exception represents a handled or unhandled exception that occurred during execution of the monitored application.
 */
var ExceptionData = /** @class */ (function () {
    function ExceptionData() {
        /**
         * Schema version
         */
        this.ver = 2;
        /**
         * Exception chain - list of inner exceptions.
         */
        this.exceptions = [];
        /**
         * Collection of custom properties.
         */
        this.properties = {};
        /**
         * Collection of custom measurements.
         */
        this.measurements = {};
    }
    return ExceptionData;
}());

//# sourceMappingURL=ExceptionData.js.map

/***/ }),
/* 1510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExceptionDetails; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * Exception details of the exception in a chain.
 */
var ExceptionDetails = /** @class */ (function () {
    function ExceptionDetails() {
        /**
         * Indicates if full exception stack is provided in the exception. The stack may be trimmed, such as in the case of a StackOverflow exception.
         */
        this.hasFullStack = true;
        /**
         * List of stack frames. Either stack or parsedStack should have a value.
         */
        this.parsedStack = [];
    }
    return ExceptionDetails;
}());

//# sourceMappingURL=ExceptionDetails.js.map

/***/ }),
/* 1511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Metric */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_MetricData__ = __webpack_require__(1512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Common_DataPoint__ = __webpack_require__(1513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Constants__ = __webpack_require__(83);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







var Metric = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(Metric, _super);
    /**
     * Constructs a new instance of the MetricTelemetry object
     */
    function Metric(logger, name, value, count, min, max, properties, measurements) {
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            ver: 1 /* Required */,
            metrics: 1 /* Required */,
            properties: 0 /* Default */
        };
        var dataPoint = new __WEBPACK_IMPORTED_MODULE_3__Common_DataPoint__["a" /* DataPoint */]();
        dataPoint.count = count > 0 ? count : undefined;
        dataPoint.max = isNaN(max) || max === null ? undefined : max;
        dataPoint.min = isNaN(min) || min === null ? undefined : min;
        dataPoint.name = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, name) || __WEBPACK_IMPORTED_MODULE_4__Constants__["c" /* strNotSpecified */];
        dataPoint.value = value;
        _this.metrics = [dataPoint];
        _this.properties = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["e" /* dataSanitizeProperties */])(logger, properties);
        _this.measurements = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["c" /* dataSanitizeMeasurements */])(logger, measurements);
        return _this;
    }
    Metric.envelopeType = "Microsoft.ApplicationInsights.{0}.Metric";
    Metric.dataType = "MetricData";
    return Metric;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_MetricData__["a" /* MetricData */]));

//# sourceMappingURL=Metric.js.map

/***/ }),
/* 1512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MetricData; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * An instance of the Metric item is a list of measurements (single data points) and/or aggregations.
 */
var MetricData = /** @class */ (function () {
    function MetricData() {
        /**
         * Schema version
         */
        this.ver = 2;
        /**
         * List of metrics. Only one metric in the list is currently supported by Application Insights storage. If multiple data points were sent only the first one will be used.
         */
        this.metrics = [];
        /**
         * Collection of custom properties.
         */
        this.properties = {};
        /**
         * Collection of custom measurements.
         */
        this.measurements = {};
    }
    return MetricData;
}());

//# sourceMappingURL=MetricData.js.map

/***/ }),
/* 1513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataPoint; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_DataPoint__ = __webpack_require__(1514);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var DataPoint = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(DataPoint, _super);
    function DataPoint() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * The data contract for serializing this object.
         */
        _this.aiDataContract = {
            name: 1 /* Required */,
            kind: 0 /* Default */,
            value: 1 /* Required */,
            count: 0 /* Default */,
            min: 0 /* Default */,
            max: 0 /* Default */,
            stdDev: 0 /* Default */
        };
        return _this;
    }
    return DataPoint;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_DataPoint__["a" /* DataPoint */]));

//# sourceMappingURL=DataPoint.js.map

/***/ }),
/* 1514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataPoint; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataPointType__ = __webpack_require__(1515);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



/**
 * Metric data single measurement.
 */
var DataPoint = /** @class */ (function () {
    function DataPoint() {
        /**
         * Metric type. Single measurement or the aggregated value.
         */
        this.kind = __WEBPACK_IMPORTED_MODULE_0__DataPointType__["a" /* DataPointType */].Measurement;
    }
    return DataPoint;
}());

//# sourceMappingURL=DataPoint.js.map

/***/ }),
/* 1515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataPointType; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// THIS FILE WAS AUTOGENERATED
/**
 * Type of the metric data measurement.
 */
var DataPointType;
(function (DataPointType) {
    DataPointType[DataPointType["Measurement"] = 0] = "Measurement";
    DataPointType[DataPointType["Aggregation"] = 1] = "Aggregation";
})(DataPointType || (DataPointType = {}));
//# sourceMappingURL=DataPointType.js.map

/***/ }),
/* 1516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PageView */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_PageViewData__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Constants__ = __webpack_require__(83);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







var PageView = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(PageView, _super);
    /**
     * Constructs a new instance of the PageEventTelemetry object
     */
    function PageView(logger, name, url, durationMs, properties, measurements, id) {
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            ver: 1 /* Required */,
            name: 0 /* Default */,
            url: 0 /* Default */,
            duration: 0 /* Default */,
            properties: 0 /* Default */,
            measurements: 0 /* Default */,
            id: 0 /* Default */
        };
        _this.id = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["b" /* dataSanitizeId */])(logger, id);
        _this.url = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["g" /* dataSanitizeUrl */])(logger, url);
        _this.name = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, name) || __WEBPACK_IMPORTED_MODULE_4__Constants__["c" /* strNotSpecified */];
        if (!isNaN(durationMs)) {
            _this.duration = Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["d" /* msToTimeSpan */])(durationMs);
        }
        _this.properties = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["e" /* dataSanitizeProperties */])(logger, properties);
        _this.measurements = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["c" /* dataSanitizeMeasurements */])(logger, measurements);
        return _this;
    }
    PageView.envelopeType = "Microsoft.ApplicationInsights.{0}.Pageview";
    PageView.dataType = "PageviewData";
    return PageView;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_PageViewData__["a" /* PageViewData */]));

//# sourceMappingURL=PageView.js.map

/***/ }),
/* 1517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RemoteDependencyData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Common_DataSanitizer__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Util__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Interfaces_Contracts_Generated_RemoteDependencyData__ = __webpack_require__(1518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HelperFuncs__ = __webpack_require__(254);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







var RemoteDependencyData = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(RemoteDependencyData, _super);
    /**
     * Constructs a new instance of the RemoteDependencyData object
     */
    function RemoteDependencyData(logger, id, absoluteUrl, commandName, value, success, resultCode, method, requestAPI, correlationContext, properties, measurements) {
        if (requestAPI === void 0) { requestAPI = "Ajax"; }
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            id: 1 /* Required */,
            ver: 1 /* Required */,
            name: 0 /* Default */,
            resultCode: 0 /* Default */,
            duration: 0 /* Default */,
            success: 0 /* Default */,
            data: 0 /* Default */,
            target: 0 /* Default */,
            type: 0 /* Default */,
            properties: 0 /* Default */,
            measurements: 0 /* Default */,
            kind: 0 /* Default */,
            value: 0 /* Default */,
            count: 0 /* Default */,
            min: 0 /* Default */,
            max: 0 /* Default */,
            stdDev: 0 /* Default */,
            dependencyKind: 0 /* Default */,
            dependencySource: 0 /* Default */,
            commandName: 0 /* Default */,
            dependencyTypeName: 0 /* Default */
        };
        _this.id = id;
        _this.duration = Object(__WEBPACK_IMPORTED_MODULE_4__HelperFuncs__["d" /* msToTimeSpan */])(value);
        _this.success = success;
        _this.resultCode = resultCode + "";
        _this.type = Object(__WEBPACK_IMPORTED_MODULE_1__Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, requestAPI);
        var dependencyFields = Object(__WEBPACK_IMPORTED_MODULE_2__Util__["a" /* AjaxHelperParseDependencyPath */])(logger, absoluteUrl, method, commandName);
        _this.data = Object(__WEBPACK_IMPORTED_MODULE_1__Common_DataSanitizer__["g" /* dataSanitizeUrl */])(logger, commandName) || dependencyFields.data; // get a value from hosturl if commandName not available
        _this.target = Object(__WEBPACK_IMPORTED_MODULE_1__Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, dependencyFields.target);
        if (correlationContext) {
            _this.target = _this.target + " | " + correlationContext;
        }
        _this.name = Object(__WEBPACK_IMPORTED_MODULE_1__Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, dependencyFields.name);
        _this.properties = Object(__WEBPACK_IMPORTED_MODULE_1__Common_DataSanitizer__["e" /* dataSanitizeProperties */])(logger, properties);
        _this.measurements = Object(__WEBPACK_IMPORTED_MODULE_1__Common_DataSanitizer__["c" /* dataSanitizeMeasurements */])(logger, measurements);
        return _this;
    }
    RemoteDependencyData.envelopeType = "Microsoft.ApplicationInsights.{0}.RemoteDependency";
    RemoteDependencyData.dataType = "RemoteDependencyData";
    return RemoteDependencyData;
}(__WEBPACK_IMPORTED_MODULE_3__Interfaces_Contracts_Generated_RemoteDependencyData__["a" /* RemoteDependencyData */]));

//# sourceMappingURL=RemoteDependencyData.js.map

/***/ }),
/* 1518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RemoteDependencyData; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * An instance of Remote Dependency represents an interaction of the monitored component with a remote component/service like SQL or an HTTP endpoint.
 */
var RemoteDependencyData = /** @class */ (function () {
    function RemoteDependencyData() {
        /**
         * Schema version
         */
        this.ver = 2;
        /**
         * Indication of successful or unsuccessful call.
         */
        this.success = true;
        /**
         * Collection of custom properties.
         */
        this.properties = {};
        /**
         * Collection of custom measurements.
         */
        this.measurements = {};
    }
    return RemoteDependencyData;
}());

//# sourceMappingURL=RemoteDependencyData.js.map

/***/ }),
/* 1519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Trace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_MessageData__ = __webpack_require__(1520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Constants__ = __webpack_require__(83);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var Trace = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(Trace, _super);
    /**
     * Constructs a new instance of the TraceTelemetry object
     */
    function Trace(logger, message, severityLevel, properties, measurements) {
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            ver: 1 /* Required */,
            message: 1 /* Required */,
            severityLevel: 0 /* Default */,
            properties: 0 /* Default */
        };
        message = message || __WEBPACK_IMPORTED_MODULE_3__Constants__["c" /* strNotSpecified */];
        _this.message = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["d" /* dataSanitizeMessage */])(logger, message);
        _this.properties = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["e" /* dataSanitizeProperties */])(logger, properties);
        _this.measurements = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["c" /* dataSanitizeMeasurements */])(logger, measurements);
        if (severityLevel) {
            _this.severityLevel = severityLevel;
        }
        return _this;
    }
    Trace.envelopeType = "Microsoft.ApplicationInsights.{0}.Message";
    Trace.dataType = "MessageData";
    return Trace;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_MessageData__["a" /* MessageData */]));

//# sourceMappingURL=Trace.js.map

/***/ }),
/* 1520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MessageData; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * Instances of Message represent printf-like trace statements that are text-searched. Log4Net, NLog and other text-based log file entries are translated into intances of this type. The message does not have measurements.
 */
var MessageData = /** @class */ (function () {
    function MessageData() {
        /**
         * Schema version
         */
        this.ver = 2;
        /**
         * Collection of custom properties.
         */
        this.properties = {};
        /**
         * Collection of custom measurements.
         */
        this.measurements = {};
    }
    return MessageData;
}());

//# sourceMappingURL=MessageData.js.map

/***/ }),
/* 1521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PageViewPerformance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_PageViewPerfData__ = __webpack_require__(1522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Constants__ = __webpack_require__(83);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var PageViewPerformance = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(PageViewPerformance, _super);
    /**
     * Constructs a new instance of the PageEventTelemetry object
     */
    function PageViewPerformance(logger, name, url, unused, properties, measurements, cs4BaseData) {
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            ver: 1 /* Required */,
            name: 0 /* Default */,
            url: 0 /* Default */,
            duration: 0 /* Default */,
            perfTotal: 0 /* Default */,
            networkConnect: 0 /* Default */,
            sentRequest: 0 /* Default */,
            receivedResponse: 0 /* Default */,
            domProcessing: 0 /* Default */,
            properties: 0 /* Default */,
            measurements: 0 /* Default */
        };
        _this.url = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["g" /* dataSanitizeUrl */])(logger, url);
        _this.name = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, name) || __WEBPACK_IMPORTED_MODULE_3__Constants__["c" /* strNotSpecified */];
        _this.properties = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["e" /* dataSanitizeProperties */])(logger, properties);
        _this.measurements = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["c" /* dataSanitizeMeasurements */])(logger, measurements);
        if (cs4BaseData) {
            _this.domProcessing = cs4BaseData.domProcessing;
            _this.duration = cs4BaseData.duration;
            _this.networkConnect = cs4BaseData.networkConnect;
            _this.perfTotal = cs4BaseData.perfTotal;
            _this.receivedResponse = cs4BaseData.receivedResponse;
            _this.sentRequest = cs4BaseData.sentRequest;
        }
        return _this;
    }
    PageViewPerformance.envelopeType = "Microsoft.ApplicationInsights.{0}.PageviewPerformance";
    PageViewPerformance.dataType = "PageviewPerformanceData";
    return PageViewPerformance;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_PageViewPerfData__["a" /* PageViewPerfData */]));

//# sourceMappingURL=PageViewPerformance.js.map

/***/ }),
/* 1522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageViewPerfData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PageViewData__ = __webpack_require__(379);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



// THIS FILE WAS AUTOGENERATED

/**
 * An instance of PageViewPerf represents: a page view with no performance data, a page view with performance data, or just the performance data of an earlier page request.
 */
var PageViewPerfData = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(PageViewPerfData, _super);
    function PageViewPerfData() {
        var _this = _super.call(this) || this;
        /**
         * Schema version
         */
        _this.ver = 2;
        /**
         * Collection of custom properties.
         */
        _this.properties = {};
        /**
         * Collection of custom measurements.
         */
        _this.measurements = {};
        return _this;
    }
    return PageViewPerfData;
}(__WEBPACK_IMPORTED_MODULE_1__PageViewData__["a" /* PageViewData */]));

//# sourceMappingURL=PageViewPerfData.js.map

/***/ }),
/* 1523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Data */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_Data__ = __webpack_require__(609);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var Data = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(Data, _super);
    /**
     * Constructs a new instance of telemetry data.
     */
    function Data(baseType, data) {
        var _this = _super.call(this) || this;
        /**
         * The data contract for serializing this object.
         */
        _this.aiDataContract = {
            baseType: 1 /* Required */,
            baseData: 1 /* Required */
        };
        _this.baseType = baseType;
        _this.baseData = data;
        return _this;
    }
    return Data;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_Data__["a" /* Data */]));

//# sourceMappingURL=Data.js.map

/***/ }),
/* 1524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SeverityLevel */
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// THIS FILE WAS AUTOGENERATED
/**
 * Defines the level of severity for the event.
 */
var SeverityLevel;
(function (SeverityLevel) {
    SeverityLevel[SeverityLevel["Verbose"] = 0] = "Verbose";
    SeverityLevel[SeverityLevel["Information"] = 1] = "Information";
    SeverityLevel[SeverityLevel["Warning"] = 2] = "Warning";
    SeverityLevel[SeverityLevel["Error"] = 3] = "Error";
    SeverityLevel[SeverityLevel["Critical"] = 4] = "Critical";
})(SeverityLevel || (SeverityLevel = {}));
//# sourceMappingURL=SeverityLevel.js.map

/***/ }),
/* 1525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ConfigurationManager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(35);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



var ConfigurationManager = /** @class */ (function () {
    function ConfigurationManager() {
    }
    ConfigurationManager.getConfig = function (config, field, identifier, defaultValue) {
        if (defaultValue === void 0) { defaultValue = false; }
        var configValue;
        if (identifier && config.extensionConfig && config.extensionConfig[identifier] && !Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(config.extensionConfig[identifier][field])) {
            configValue = config.extensionConfig[identifier][field];
        }
        else {
            configValue = config[field];
        }
        return !Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(configValue) ? configValue : defaultValue;
    };
    return ConfigurationManager;
}());

//# sourceMappingURL=IConfig.js.map

/***/ }),
/* 1526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TelemetryItemCreator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Telemetry_Common_DataSanitizer__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Constants__ = __webpack_require__(83);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





var TelemetryItemCreator = /** @class */ (function () {
    function TelemetryItemCreator() {
    }
    /**
     * Create a telemetry item that the 1DS channel understands
     * @param item domain specific properties; part B
     * @param baseType telemetry item type. ie PageViewData
     * @param envelopeName name of the envelope. ie Microsoft.ApplicationInsights.<instrumentation key>.PageView
     * @param customProperties user defined custom properties; part C
     * @param systemProperties system properties that are added to the context; part A
     * @returns ITelemetryItem that is sent to channel
     */
    TelemetryItemCreator.create = function (item, baseType, envelopeName, logger, customProperties, systemProperties) {
        envelopeName = Object(__WEBPACK_IMPORTED_MODULE_0__Telemetry_Common_DataSanitizer__["f" /* dataSanitizeString */])(logger, envelopeName) || __WEBPACK_IMPORTED_MODULE_2__Constants__["c" /* strNotSpecified */];
        if (Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(item) ||
            Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(baseType) ||
            Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(envelopeName)) {
            throw Error("Input doesn't contain all required fields");
        }
        var telemetryItem = {
            name: envelopeName,
            time: Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["T" /* toISOString */])(new Date()),
            iKey: "",
            ext: systemProperties ? systemProperties : {},
            tags: [],
            data: {},
            baseType: baseType,
            baseData: item // Part B
        };
        // Part C
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(customProperties)) {
            Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["M" /* objForEachKey */])(customProperties, function (prop, value) {
                telemetryItem.data[prop] = value;
            });
        }
        return telemetryItem;
    };
    return TelemetryItemCreator;
}());

//# sourceMappingURL=TelemetryItemCreator.js.map

/***/ }),
/* 1527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Extensions */
/* unused harmony export CtxTagKeys */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Contracts_Generated_ContextTagKeys__ = __webpack_require__(612);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var Extensions = {
    UserExt: "user",
    DeviceExt: "device",
    TraceExt: "trace",
    WebExt: "web",
    AppExt: "app",
    OSExt: "os",
    SessionExt: "ses",
    SDKExt: "sdk"
};
var CtxTagKeys = new __WEBPACK_IMPORTED_MODULE_0__Contracts_Generated_ContextTagKeys__["a" /* ContextTagKeys */]();
//# sourceMappingURL=PartAExtensions.js.map

/***/ }),
/* 1528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export stringUtils */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(35);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["b"]; });
/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var stringUtils = /** @class */ (function () {
    function stringUtils() {
    }
    stringUtils.GetLength = function (strObject) {
        var res = 0;
        if (!Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["G" /* isNullOrUndefined */])(strObject)) {
            var stringified = "";
            try {
                stringified = strObject.toString();
            }
            catch (ex) {
                // some troubles with complex object
            }
            res = stringified.length;
            res = isNaN(res) ? 0 : res;
        }
        return res;
    };
    return stringUtils;
}());

//# sourceMappingURL=ajaxUtils.js.map

/***/ }),
/* 1529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Traceparent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(35);
/*
 * Application Insights JavaScript SDK - Dependencies Plugin, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var Traceparent = /** @class */ (function () {
    function Traceparent(traceId, spanId) {
        var self = this;
        self.traceFlag = Traceparent.DEFAULT_TRACE_FLAG;
        self.version = Traceparent.DEFAULT_VERSION;
        if (traceId && Traceparent.isValidTraceId(traceId)) {
            self.traceId = traceId;
        }
        else {
            self.traceId = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["q" /* generateW3CId */])();
        }
        if (spanId && Traceparent.isValidSpanId(spanId)) {
            self.spanId = spanId;
        }
        else {
            self.spanId = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["q" /* generateW3CId */])().substr(0, 16);
        }
    }
    Traceparent.isValidTraceId = function (id) {
        return id.match(/^[0-9a-f]{32}$/) && id !== "00000000000000000000000000000000";
    };
    Traceparent.isValidSpanId = function (id) {
        return id.match(/^[0-9a-f]{16}$/) && id !== "0000000000000000";
    };
    Traceparent.prototype.toString = function () {
        var self = this;
        return self.version + "-" + self.traceId + "-" + self.spanId + "-" + self.traceFlag;
    };
    Traceparent.DEFAULT_TRACE_FLAG = "01";
    Traceparent.DEFAULT_VERSION = "00";
    return Traceparent;
}());

//# sourceMappingURL=TraceParent.js.map

/***/ }),
/* 1530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = parseConnectionString;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConnectionStringParser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__ = __webpack_require__(39);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var _FIELDS_SEPARATOR = ";";
var _FIELD_KEY_VALUE_SEPARATOR = "=";
function parseConnectionString(connectionString) {
    if (!connectionString) {
        return {};
    }
    var kvPairs = connectionString.split(_FIELDS_SEPARATOR);
    var result = Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["h" /* arrReduce */])(kvPairs, function (fields, kv) {
        var kvParts = kv.split(_FIELD_KEY_VALUE_SEPARATOR);
        if (kvParts.length === 2) {
            var key = kvParts[0].toLowerCase();
            var value = kvParts[1];
            fields[key] = value;
        }
        return fields;
    }, {});
    if (Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["N" /* objKeys */])(result).length > 0) {
        // this is a valid connection string, so parse the results
        if (result.endpointsuffix) {
            // use endpoint suffix where overrides are not provided
            var locationPrefix = result.location ? result.location + "." : "";
            result.ingestionendpoint = result.ingestionendpoint || ("https://" + locationPrefix + "dc." + result.endpointsuffix);
        }
        // apply the default endpoints
        result.ingestionendpoint = result.ingestionendpoint || __WEBPACK_IMPORTED_MODULE_0__Constants__["a" /* DEFAULT_BREEZE_ENDPOINT */];
    }
    return result;
}
var ConnectionStringParser = {
    parse: parseConnectionString
};
//# sourceMappingURL=ConnectionStringParser.js.map

/***/ }),
/* 1531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Envelope; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_Envelope__ = __webpack_require__(1532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DataSanitizer__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Constants__ = __webpack_require__(85);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







var Envelope = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(Envelope, _super);
    /**
     * Constructs a new instance of telemetry data.
     */
    function Envelope(logger, data, name) {
        var _this = _super.call(this) || this;
        _this.name = Object(__WEBPACK_IMPORTED_MODULE_2__DataSanitizer__["g" /* dataSanitizeString */])(logger, name) || __WEBPACK_IMPORTED_MODULE_4__Constants__["f" /* strNotSpecified */];
        _this.data = data;
        _this.time = Object(__WEBPACK_IMPORTED_MODULE_3__microsoft_applicationinsights_core_js__["T" /* toISOString */])(new Date());
        _this.aiDataContract = {
            time: 1 /* Required */,
            iKey: 1 /* Required */,
            name: 1 /* Required */,
            sampleRate: function () {
                return (_this.sampleRate === 100) ? 4 /* Hidden */ : 1 /* Required */;
            },
            tags: 1 /* Required */,
            data: 1 /* Required */
        };
        return _this;
    }
    return Envelope;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_Envelope__["a" /* Envelope */]));

//# sourceMappingURL=Envelope.js.map

/***/ }),
/* 1532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Envelope; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * System variables for a telemetry item.
 */
var Envelope = /** @class */ (function () {
    function Envelope() {
        /**
         * Envelope version. For internal use only. By assigning this the default, it will not be serialized within the payload unless changed to a value other than #1.
         */
        this.ver = 1;
        /**
         * Sampling rate used in application. This telemetry item represents 1 / sampleRate actual telemetry items.
         */
        this.sampleRate = 100.0;
        /**
         * Key/value collection of context properties. See ContextTagKeys for information on available properties.
         */
        this.tags = {};
    }
    return Envelope;
}());

//# sourceMappingURL=Envelope.js.map

/***/ }),
/* 1533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Event; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_EventData__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Constants__ = __webpack_require__(85);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var Event = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(Event, _super);
    /**
     * Constructs a new instance of the EventTelemetry object
     */
    function Event(logger, name, properties, measurements) {
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            ver: 1 /* Required */,
            name: 1 /* Required */,
            properties: 0 /* Default */,
            measurements: 0 /* Default */
        };
        _this.name = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["g" /* dataSanitizeString */])(logger, name) || __WEBPACK_IMPORTED_MODULE_3__Constants__["f" /* strNotSpecified */];
        _this.properties = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["f" /* dataSanitizeProperties */])(logger, properties);
        _this.measurements = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["d" /* dataSanitizeMeasurements */])(logger, measurements);
        return _this;
    }
    Event.envelopeType = "Microsoft.ApplicationInsights.{0}.Event";
    Event.dataType = "EventData";
    return Event;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_EventData__["a" /* EventData */]));

//# sourceMappingURL=Event.js.map

/***/ }),
/* 1534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export _formatErrorCode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Exception; });
/* unused harmony export _ExceptionDetails */
/* unused harmony export _StackFrame */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_StackFrame__ = __webpack_require__(1535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Interfaces_Contracts_Generated_ExceptionData__ = __webpack_require__(1536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Interfaces_Contracts_Generated_ExceptionDetails__ = __webpack_require__(1537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Common_DataSanitizer__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Constants__ = __webpack_require__(85);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */









var NoMethod = "<no_method>";
var strError = "error";
var strStack = "stack";
var strStackDetails = "stackDetails";
var strErrorSrc = "errorSrc";
var strMessage = "message";
var strDescription = "description";
function _stringify(value, convertToString) {
    var result = value;
    if (result && !Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["K" /* isString */])(result)) {
        if (JSON && JSON.stringify) {
            result = JSON.stringify(value);
            if (convertToString && (!result || result === "{}")) {
                if (Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["G" /* isFunction */])(value.toString)) {
                    result = value.toString();
                }
                else {
                    result = "" + value;
                }
            }
        }
        else {
            result = "" + value + " - (Missing JSON.stringify)";
        }
    }
    return result || "";
}
function _formatMessage(theEvent, errorType) {
    var evtMessage = theEvent;
    if (theEvent) {
        evtMessage = theEvent[strMessage] || theEvent[strDescription] || "";
        // Make sure the message is a string
        if (evtMessage && !Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["K" /* isString */])(evtMessage)) {
            // tslint:disable-next-line: prefer-conditional-expression
            evtMessage = _stringify(evtMessage, true);
        }
        if (theEvent["filename"]) {
            // Looks like an event object with filename
            evtMessage = evtMessage + " @" + (theEvent["filename"] || "") + ":" + (theEvent["lineno"] || "?") + ":" + (theEvent["colno"] || "?");
        }
    }
    // Automatically add the error type to the message if it does already appear to be present
    if (errorType && errorType !== "String" && errorType !== "Object" && errorType !== "Error" && (evtMessage || "").indexOf(errorType) === -1) {
        evtMessage = errorType + ": " + evtMessage;
    }
    return evtMessage || "";
}
function _isExceptionDetailsInternal(value) {
    if (Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["I" /* isObject */])(value)) {
        return "hasFullStack" in value && "typeName" in value;
    }
    return false;
}
function _isExceptionInternal(value) {
    if (Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["I" /* isObject */])(value)) {
        return ("ver" in value && "exceptions" in value && "properties" in value);
    }
    return false;
}
function _isStackDetails(details) {
    return details && details.src && Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["K" /* isString */])(details.src) && details.obj && Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["D" /* isArray */])(details.obj);
}
function _convertStackObj(errorStack) {
    var src = errorStack || "";
    if (!Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["K" /* isString */])(src)) {
        if (Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["K" /* isString */])(src[strStack])) {
            src = src[strStack];
        }
        else {
            src = "" + src;
        }
    }
    var items = src.split("\n");
    return {
        src: src,
        obj: items
    };
}
function _getOperaStack(errorMessage) {
    var stack = [];
    var lines = errorMessage.split("\n");
    for (var lp = 0; lp < lines.length; lp++) {
        var entry = lines[lp];
        if (lines[lp + 1]) {
            entry += "@" + lines[lp + 1];
            lp++;
        }
        stack.push(entry);
    }
    return {
        src: errorMessage,
        obj: stack
    };
}
function _getStackFromErrorObj(errorObj) {
    var details = null;
    if (errorObj) {
        try {
            /* Using bracket notation is support older browsers (IE 7/8 -- dont remember the version) that throw when using dot
            notation for undefined objects and we don't want to loose the error from being reported */
            if (errorObj[strStack]) {
                // Chrome/Firefox
                details = _convertStackObj(errorObj[strStack]);
            }
            else if (errorObj[strError] && errorObj[strError][strStack]) {
                // Edge error event provides the stack and error object
                details = _convertStackObj(errorObj[strError][strStack]);
            }
            else if (errorObj['exception'] && errorObj.exception[strStack]) {
                details = _convertStackObj(errorObj.exception[strStack]);
            }
            else if (_isStackDetails(errorObj)) {
                details = errorObj;
            }
            else if (_isStackDetails(errorObj[strStackDetails])) {
                details = errorObj[strStackDetails];
            }
            else if (window['opera'] && errorObj[strMessage]) {
                // Opera
                details = _getOperaStack(errorObj.message);
            }
            else if (Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["K" /* isString */])(errorObj)) {
                details = _convertStackObj(errorObj);
            }
            else {
                var evtMessage = errorObj[strMessage] || errorObj[strDescription] || "";
                if (Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["K" /* isString */])(errorObj[strErrorSrc])) {
                    if (evtMessage) {
                        evtMessage += "\n";
                    }
                    evtMessage += " from " + errorObj[strErrorSrc];
                }
                if (evtMessage) {
                    details = _convertStackObj(evtMessage);
                }
            }
        }
        catch (e) {
            // something unexpected happened so to avoid failing to report any error lets swallow the exception 
            // and fallback to the callee/caller method
            details = _convertStackObj(e);
        }
    }
    return details || {
        src: "",
        obj: null
    };
}
function _formatStackTrace(stackDetails) {
    var stack = "";
    if (stackDetails) {
        if (stackDetails.obj) {
            Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["f" /* arrForEach */])(stackDetails.obj, function (entry) {
                stack += entry + "\n";
            });
        }
        else {
            stack = stackDetails.src || "";
        }
    }
    return stack;
}
function _parseStack(stack) {
    var parsedStack;
    var frames = stack.obj;
    if (frames && frames.length > 0) {
        parsedStack = [];
        var level_1 = 0;
        var totalSizeInBytes_1 = 0;
        Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["f" /* arrForEach */])(frames, function (frame) {
            var theFrame = frame.toString();
            if (_StackFrame.regex.test(theFrame)) {
                var parsedFrame = new _StackFrame(theFrame, level_1++);
                totalSizeInBytes_1 += parsedFrame.sizeInBytes;
                parsedStack.push(parsedFrame);
            }
        });
        // DP Constraint - exception parsed stack must be < 32KB
        // remove frames from the middle to meet the threshold
        var exceptionParsedStackThreshold = 32 * 1024;
        if (totalSizeInBytes_1 > exceptionParsedStackThreshold) {
            var left = 0;
            var right = parsedStack.length - 1;
            var size = 0;
            var acceptedLeft = left;
            var acceptedRight = right;
            while (left < right) {
                // check size
                var lSize = parsedStack[left].sizeInBytes;
                var rSize = parsedStack[right].sizeInBytes;
                size += lSize + rSize;
                if (size > exceptionParsedStackThreshold) {
                    // remove extra frames from the middle
                    var howMany = acceptedRight - acceptedLeft + 1;
                    parsedStack.splice(acceptedLeft, howMany);
                    break;
                }
                // update pointers
                acceptedLeft = left;
                acceptedRight = right;
                left++;
                right--;
            }
        }
    }
    return parsedStack;
}
function _getErrorType(errorType) {
    // Gets the Error Type by passing the constructor (used to get the true type of native error object).
    var typeName = "";
    if (errorType) {
        typeName = errorType.typeName || errorType.name || "";
        if (!typeName) {
            try {
                var funcNameRegex = /function (.{1,})\(/;
                var results = (funcNameRegex).exec((errorType).constructor.toString());
                typeName = (results && results.length > 1) ? results[1] : "";
            }
            catch (e) {
                // Ignore
            }
        }
    }
    return typeName;
}
/**
 * Formats the provided errorObj for display and reporting, it may be a String, Object, integer or undefined depending on the browser.
 * @param errorObj The supplied errorObj
 */
function _formatErrorCode(errorObj) {
    if (errorObj) {
        try {
            if (!Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["K" /* isString */])(errorObj)) {
                var errorType = _getErrorType(errorObj);
                var result = _stringify(errorObj, false);
                if (!result || result === "{}") {
                    if (errorObj[strError]) {
                        // Looks like an MS Error Event
                        errorObj = errorObj[strError];
                        errorType = _getErrorType(errorObj);
                    }
                    result = _stringify(errorObj, true);
                }
                if (result.indexOf(errorType) !== 0 && errorType !== "String") {
                    return errorType + ":" + result;
                }
                return result;
            }
        }
        catch (e) {
        }
    }
    // Fallback to just letting the object format itself into a string
    return "" + (errorObj || "");
}
var Exception = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(Exception, _super);
    /**
     * Constructs a new instance of the ExceptionTelemetry object
     */
    function Exception(logger, exception, properties, measurements, severityLevel, id) {
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            ver: 1 /* Required */,
            exceptions: 1 /* Required */,
            severityLevel: 0 /* Default */,
            properties: 0 /* Default */,
            measurements: 0 /* Default */
        };
        if (!_isExceptionInternal(exception)) {
            if (!properties) {
                properties = {};
            }
            _this.exceptions = [new _ExceptionDetails(logger, exception, properties)];
            _this.properties = Object(__WEBPACK_IMPORTED_MODULE_4__Common_DataSanitizer__["f" /* dataSanitizeProperties */])(logger, properties);
            _this.measurements = Object(__WEBPACK_IMPORTED_MODULE_4__Common_DataSanitizer__["d" /* dataSanitizeMeasurements */])(logger, measurements);
            if (severityLevel) {
                _this.severityLevel = severityLevel;
            }
            if (id) {
                _this.id = id;
            }
        }
        else {
            _this.exceptions = exception.exceptions;
            _this.properties = exception.properties;
            _this.measurements = exception.measurements;
            if (exception.severityLevel) {
                _this.severityLevel = exception.severityLevel;
            }
            if (exception.id) {
                _this.id = exception.id;
            }
            if (exception.problemGroup) {
                _this.problemGroup = exception.problemGroup;
            }
            // bool/int types, use isNullOrUndefined
            _this.ver = 2; // TODO: handle the CS"4.0" ==> breeze 2 conversion in a better way
            if (!Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["H" /* isNullOrUndefined */])(exception.isManual)) {
                _this.isManual = exception.isManual;
            }
        }
        return _this;
    }
    Exception.CreateAutoException = function (message, url, lineNumber, columnNumber, error, evt, stack, errorSrc) {
        var errorType = _getErrorType(error || evt || message);
        return {
            message: _formatMessage(message, errorType),
            url: url,
            lineNumber: lineNumber,
            columnNumber: columnNumber,
            error: _formatErrorCode(error || evt || message),
            evt: _formatErrorCode(evt || message),
            typeName: errorType,
            stackDetails: _getStackFromErrorObj(stack || error || evt),
            errorSrc: errorSrc
        };
    };
    Exception.CreateFromInterface = function (logger, exception, properties, measurements) {
        var exceptions = exception.exceptions
            && Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["g" /* arrMap */])(exception.exceptions, function (ex) { return _ExceptionDetails.CreateFromInterface(logger, ex); });
        var exceptionData = new Exception(logger, Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["f" /* __assignFn */])({}, exception, { exceptions: exceptions }), properties, measurements);
        return exceptionData;
    };
    Exception.prototype.toInterface = function () {
        var _a = this, exceptions = _a.exceptions, properties = _a.properties, measurements = _a.measurements, severityLevel = _a.severityLevel, ver = _a.ver, problemGroup = _a.problemGroup, id = _a.id, isManual = _a.isManual;
        var exceptionDetailsInterface = exceptions instanceof Array
            && Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["g" /* arrMap */])(exceptions, function (exception) { return exception.toInterface(); })
            || undefined;
        return {
            ver: "4.0",
            exceptions: exceptionDetailsInterface,
            severityLevel: severityLevel,
            properties: properties,
            measurements: measurements,
            problemGroup: problemGroup,
            id: id,
            isManual: isManual
        };
    };
    /**
     * Creates a simple exception with 1 stack frame. Useful for manual constracting of exception.
     */
    Exception.CreateSimpleException = function (message, typeName, assembly, fileName, details, line) {
        return {
            exceptions: [
                {
                    hasFullStack: true,
                    message: message,
                    stack: details,
                    typeName: typeName
                }
            ]
        };
    };
    Exception.envelopeType = "Microsoft.ApplicationInsights.{0}.Exception";
    Exception.dataType = "ExceptionData";
    Exception.formatError = _formatErrorCode;
    return Exception;
}(__WEBPACK_IMPORTED_MODULE_2__Interfaces_Contracts_Generated_ExceptionData__["a" /* ExceptionData */]));

var _ExceptionDetails = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(_ExceptionDetails, _super);
    function _ExceptionDetails(logger, exception, properties) {
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            id: 0 /* Default */,
            outerId: 0 /* Default */,
            typeName: 1 /* Required */,
            message: 1 /* Required */,
            hasFullStack: 0 /* Default */,
            stack: 0 /* Default */,
            parsedStack: 2 /* Array */
        };
        if (!_isExceptionDetailsInternal(exception)) {
            var error = exception;
            var evt = error && error.evt;
            if (!Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["F" /* isError */])(error)) {
                error = error[strError] || evt || error;
            }
            _this.typeName = Object(__WEBPACK_IMPORTED_MODULE_4__Common_DataSanitizer__["g" /* dataSanitizeString */])(logger, _getErrorType(error)) || __WEBPACK_IMPORTED_MODULE_6__Constants__["f" /* strNotSpecified */];
            _this.message = Object(__WEBPACK_IMPORTED_MODULE_4__Common_DataSanitizer__["e" /* dataSanitizeMessage */])(logger, _formatMessage(exception || error, _this.typeName)) || __WEBPACK_IMPORTED_MODULE_6__Constants__["f" /* strNotSpecified */];
            var stack = exception[strStackDetails] || _getStackFromErrorObj(exception);
            _this.parsedStack = _parseStack(stack);
            _this[strStack] = Object(__WEBPACK_IMPORTED_MODULE_4__Common_DataSanitizer__["b" /* dataSanitizeException */])(logger, _formatStackTrace(stack));
            _this.hasFullStack = Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["D" /* isArray */])(_this.parsedStack) && _this.parsedStack.length > 0;
            if (properties) {
                properties.typeName = properties.typeName || _this.typeName;
            }
        }
        else {
            _this.typeName = exception.typeName;
            _this.message = exception.message;
            _this[strStack] = exception[strStack];
            _this.parsedStack = exception.parsedStack;
            _this.hasFullStack = exception.hasFullStack;
        }
        return _this;
    }
    _ExceptionDetails.prototype.toInterface = function () {
        var parsedStack = this.parsedStack instanceof Array
            && Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["g" /* arrMap */])(this.parsedStack, function (frame) { return frame.toInterface(); });
        var exceptionDetailsInterface = {
            id: this.id,
            outerId: this.outerId,
            typeName: this.typeName,
            message: this.message,
            hasFullStack: this.hasFullStack,
            stack: this[strStack],
            parsedStack: parsedStack || undefined
        };
        return exceptionDetailsInterface;
    };
    _ExceptionDetails.CreateFromInterface = function (logger, exception) {
        var parsedStack = (exception.parsedStack instanceof Array
            && Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["g" /* arrMap */])(exception.parsedStack, function (frame) { return _StackFrame.CreateFromInterface(frame); }))
            || exception.parsedStack;
        var exceptionDetails = new _ExceptionDetails(logger, Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["f" /* __assignFn */])({}, exception, { parsedStack: parsedStack }));
        return exceptionDetails;
    };
    return _ExceptionDetails;
}(__WEBPACK_IMPORTED_MODULE_3__Interfaces_Contracts_Generated_ExceptionDetails__["a" /* ExceptionDetails */]));

var _StackFrame = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(_StackFrame, _super);
    function _StackFrame(sourceFrame, level) {
        var _this = _super.call(this) || this;
        _this.sizeInBytes = 0;
        _this.aiDataContract = {
            level: 1 /* Required */,
            method: 1 /* Required */,
            assembly: 0 /* Default */,
            fileName: 0 /* Default */,
            line: 0 /* Default */
        };
        // Not converting this to isString() as typescript uses this logic to "understand" the different
        // types for the 2 different code paths
        if (typeof sourceFrame === "string") {
            var frame = sourceFrame;
            _this.level = level;
            _this.method = NoMethod;
            _this.assembly = Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["R" /* strTrim */])(frame);
            _this.fileName = "";
            _this.line = 0;
            var matches = frame.match(_StackFrame.regex);
            if (matches && matches.length >= 5) {
                _this.method = Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["R" /* strTrim */])(matches[2]) || _this.method;
                _this.fileName = Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_applicationinsights_core_js__["R" /* strTrim */])(matches[4]);
                _this.line = parseInt(matches[5]) || 0;
            }
        }
        else {
            _this.level = sourceFrame.level;
            _this.method = sourceFrame.method;
            _this.assembly = sourceFrame.assembly;
            _this.fileName = sourceFrame.fileName;
            _this.line = sourceFrame.line;
            _this.sizeInBytes = 0;
        }
        _this.sizeInBytes += _this.method.length;
        _this.sizeInBytes += _this.fileName.length;
        _this.sizeInBytes += _this.assembly.length;
        // todo: these might need to be removed depending on how the back-end settles on their size calculation
        _this.sizeInBytes += _StackFrame.baseSize;
        _this.sizeInBytes += _this.level.toString().length;
        _this.sizeInBytes += _this.line.toString().length;
        return _this;
    }
    _StackFrame.CreateFromInterface = function (frame) {
        return new _StackFrame(frame, null /* level is available in frame interface */);
    };
    _StackFrame.prototype.toInterface = function () {
        return {
            level: this.level,
            method: this.method,
            assembly: this.assembly,
            fileName: this.fileName,
            line: this.line
        };
    };
    // regex to match stack frames from ie/chrome/ff
    // methodName=$2, fileName=$4, lineNo=$5, column=$6
    _StackFrame.regex = /^([\s]+at)?[\s]*([^\@\()]+?)[\s]*(\@|\()([^\(\n]+):([0-9]+):([0-9]+)(\)?)$/;
    _StackFrame.baseSize = 58; // '{"method":"","level":,"assembly":"","fileName":"","line":}'.length
    return _StackFrame;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_StackFrame__["a" /* StackFrame */]));

//# sourceMappingURL=Exception.js.map

/***/ }),
/* 1535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StackFrame; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// THIS FILE WAS AUTOGENERATED
/**
 * Stack frame information.
 */
var StackFrame = /** @class */ (function () {
    function StackFrame() {
    }
    return StackFrame;
}());

//# sourceMappingURL=StackFrame.js.map

/***/ }),
/* 1536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExceptionData; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * An instance of Exception represents a handled or unhandled exception that occurred during execution of the monitored application.
 */
var ExceptionData = /** @class */ (function () {
    function ExceptionData() {
        /**
         * Schema version
         */
        this.ver = 2;
        /**
         * Exception chain - list of inner exceptions.
         */
        this.exceptions = [];
        /**
         * Collection of custom properties.
         */
        this.properties = {};
        /**
         * Collection of custom measurements.
         */
        this.measurements = {};
    }
    return ExceptionData;
}());

//# sourceMappingURL=ExceptionData.js.map

/***/ }),
/* 1537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExceptionDetails; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * Exception details of the exception in a chain.
 */
var ExceptionDetails = /** @class */ (function () {
    function ExceptionDetails() {
        /**
         * Indicates if full exception stack is provided in the exception. The stack may be trimmed, such as in the case of a StackOverflow exception.
         */
        this.hasFullStack = true;
        /**
         * List of stack frames. Either stack or parsedStack should have a value.
         */
        this.parsedStack = [];
    }
    return ExceptionDetails;
}());

//# sourceMappingURL=ExceptionDetails.js.map

/***/ }),
/* 1538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Metric; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_MetricData__ = __webpack_require__(1539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Common_DataPoint__ = __webpack_require__(1540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Constants__ = __webpack_require__(85);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







var Metric = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(Metric, _super);
    /**
     * Constructs a new instance of the MetricTelemetry object
     */
    function Metric(logger, name, value, count, min, max, properties, measurements) {
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            ver: 1 /* Required */,
            metrics: 1 /* Required */,
            properties: 0 /* Default */
        };
        var dataPoint = new __WEBPACK_IMPORTED_MODULE_3__Common_DataPoint__["a" /* DataPoint */]();
        dataPoint.count = count > 0 ? count : undefined;
        dataPoint.max = isNaN(max) || max === null ? undefined : max;
        dataPoint.min = isNaN(min) || min === null ? undefined : min;
        dataPoint.name = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["g" /* dataSanitizeString */])(logger, name) || __WEBPACK_IMPORTED_MODULE_4__Constants__["f" /* strNotSpecified */];
        dataPoint.value = value;
        _this.metrics = [dataPoint];
        _this.properties = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["f" /* dataSanitizeProperties */])(logger, properties);
        _this.measurements = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["d" /* dataSanitizeMeasurements */])(logger, measurements);
        return _this;
    }
    Metric.envelopeType = "Microsoft.ApplicationInsights.{0}.Metric";
    Metric.dataType = "MetricData";
    return Metric;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_MetricData__["a" /* MetricData */]));

//# sourceMappingURL=Metric.js.map

/***/ }),
/* 1539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MetricData; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * An instance of the Metric item is a list of measurements (single data points) and/or aggregations.
 */
var MetricData = /** @class */ (function () {
    function MetricData() {
        /**
         * Schema version
         */
        this.ver = 2;
        /**
         * List of metrics. Only one metric in the list is currently supported by Application Insights storage. If multiple data points were sent only the first one will be used.
         */
        this.metrics = [];
        /**
         * Collection of custom properties.
         */
        this.properties = {};
        /**
         * Collection of custom measurements.
         */
        this.measurements = {};
    }
    return MetricData;
}());

//# sourceMappingURL=MetricData.js.map

/***/ }),
/* 1540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataPoint; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_DataPoint__ = __webpack_require__(1541);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var DataPoint = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(DataPoint, _super);
    function DataPoint() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * The data contract for serializing this object.
         */
        _this.aiDataContract = {
            name: 1 /* Required */,
            kind: 0 /* Default */,
            value: 1 /* Required */,
            count: 0 /* Default */,
            min: 0 /* Default */,
            max: 0 /* Default */,
            stdDev: 0 /* Default */
        };
        return _this;
    }
    return DataPoint;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_DataPoint__["a" /* DataPoint */]));

//# sourceMappingURL=DataPoint.js.map

/***/ }),
/* 1541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataPoint; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataPointType__ = __webpack_require__(1542);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



/**
 * Metric data single measurement.
 */
var DataPoint = /** @class */ (function () {
    function DataPoint() {
        /**
         * Metric type. Single measurement or the aggregated value.
         */
        this.kind = __WEBPACK_IMPORTED_MODULE_0__DataPointType__["a" /* DataPointType */].Measurement;
    }
    return DataPoint;
}());

//# sourceMappingURL=DataPoint.js.map

/***/ }),
/* 1542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataPointType; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// THIS FILE WAS AUTOGENERATED
/**
 * Type of the metric data measurement.
 */
var DataPointType;
(function (DataPointType) {
    DataPointType[DataPointType["Measurement"] = 0] = "Measurement";
    DataPointType[DataPointType["Aggregation"] = 1] = "Aggregation";
})(DataPointType || (DataPointType = {}));
//# sourceMappingURL=DataPointType.js.map

/***/ }),
/* 1543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_PageViewData__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HelperFuncs__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Constants__ = __webpack_require__(85);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







var PageView = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(PageView, _super);
    /**
     * Constructs a new instance of the PageEventTelemetry object
     */
    function PageView(logger, name, url, durationMs, properties, measurements, id) {
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            ver: 1 /* Required */,
            name: 0 /* Default */,
            url: 0 /* Default */,
            duration: 0 /* Default */,
            properties: 0 /* Default */,
            measurements: 0 /* Default */,
            id: 0 /* Default */
        };
        _this.id = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["c" /* dataSanitizeId */])(logger, id);
        _this.url = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["h" /* dataSanitizeUrl */])(logger, url);
        _this.name = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["g" /* dataSanitizeString */])(logger, name) || __WEBPACK_IMPORTED_MODULE_4__Constants__["f" /* strNotSpecified */];
        if (!isNaN(durationMs)) {
            _this.duration = Object(__WEBPACK_IMPORTED_MODULE_3__HelperFuncs__["d" /* msToTimeSpan */])(durationMs);
        }
        _this.properties = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["f" /* dataSanitizeProperties */])(logger, properties);
        _this.measurements = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["d" /* dataSanitizeMeasurements */])(logger, measurements);
        return _this;
    }
    PageView.envelopeType = "Microsoft.ApplicationInsights.{0}.Pageview";
    PageView.dataType = "PageviewData";
    return PageView;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_PageViewData__["a" /* PageViewData */]));

//# sourceMappingURL=PageView.js.map

/***/ }),
/* 1544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RemoteDependencyData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Common_DataSanitizer__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Util__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Interfaces_Contracts_Generated_RemoteDependencyData__ = __webpack_require__(1545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HelperFuncs__ = __webpack_require__(255);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */







var RemoteDependencyData = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(RemoteDependencyData, _super);
    /**
     * Constructs a new instance of the RemoteDependencyData object
     */
    function RemoteDependencyData(logger, id, absoluteUrl, commandName, value, success, resultCode, method, requestAPI, correlationContext, properties, measurements) {
        if (requestAPI === void 0) { requestAPI = "Ajax"; }
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            id: 1 /* Required */,
            ver: 1 /* Required */,
            name: 0 /* Default */,
            resultCode: 0 /* Default */,
            duration: 0 /* Default */,
            success: 0 /* Default */,
            data: 0 /* Default */,
            target: 0 /* Default */,
            type: 0 /* Default */,
            properties: 0 /* Default */,
            measurements: 0 /* Default */,
            kind: 0 /* Default */,
            value: 0 /* Default */,
            count: 0 /* Default */,
            min: 0 /* Default */,
            max: 0 /* Default */,
            stdDev: 0 /* Default */,
            dependencyKind: 0 /* Default */,
            dependencySource: 0 /* Default */,
            commandName: 0 /* Default */,
            dependencyTypeName: 0 /* Default */
        };
        _this.id = id;
        _this.duration = Object(__WEBPACK_IMPORTED_MODULE_4__HelperFuncs__["d" /* msToTimeSpan */])(value);
        _this.success = success;
        _this.resultCode = resultCode + "";
        _this.type = Object(__WEBPACK_IMPORTED_MODULE_1__Common_DataSanitizer__["g" /* dataSanitizeString */])(logger, requestAPI);
        var dependencyFields = Object(__WEBPACK_IMPORTED_MODULE_2__Util__["a" /* AjaxHelperParseDependencyPath */])(logger, absoluteUrl, method, commandName);
        _this.data = Object(__WEBPACK_IMPORTED_MODULE_1__Common_DataSanitizer__["h" /* dataSanitizeUrl */])(logger, commandName) || dependencyFields.data; // get a value from hosturl if commandName not available
        _this.target = Object(__WEBPACK_IMPORTED_MODULE_1__Common_DataSanitizer__["g" /* dataSanitizeString */])(logger, dependencyFields.target);
        if (correlationContext) {
            _this.target = _this.target + " | " + correlationContext;
        }
        _this.name = Object(__WEBPACK_IMPORTED_MODULE_1__Common_DataSanitizer__["g" /* dataSanitizeString */])(logger, dependencyFields.name);
        _this.properties = Object(__WEBPACK_IMPORTED_MODULE_1__Common_DataSanitizer__["f" /* dataSanitizeProperties */])(logger, properties);
        _this.measurements = Object(__WEBPACK_IMPORTED_MODULE_1__Common_DataSanitizer__["d" /* dataSanitizeMeasurements */])(logger, measurements);
        return _this;
    }
    RemoteDependencyData.envelopeType = "Microsoft.ApplicationInsights.{0}.RemoteDependency";
    RemoteDependencyData.dataType = "RemoteDependencyData";
    return RemoteDependencyData;
}(__WEBPACK_IMPORTED_MODULE_3__Interfaces_Contracts_Generated_RemoteDependencyData__["a" /* RemoteDependencyData */]));

//# sourceMappingURL=RemoteDependencyData.js.map

/***/ }),
/* 1545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RemoteDependencyData; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * An instance of Remote Dependency represents an interaction of the monitored component with a remote component/service like SQL or an HTTP endpoint.
 */
var RemoteDependencyData = /** @class */ (function () {
    function RemoteDependencyData() {
        /**
         * Schema version
         */
        this.ver = 2;
        /**
         * Indication of successful or unsuccessful call.
         */
        this.success = true;
        /**
         * Collection of custom properties.
         */
        this.properties = {};
        /**
         * Collection of custom measurements.
         */
        this.measurements = {};
    }
    return RemoteDependencyData;
}());

//# sourceMappingURL=RemoteDependencyData.js.map

/***/ }),
/* 1546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Trace; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_MessageData__ = __webpack_require__(1547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Constants__ = __webpack_require__(85);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var Trace = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(Trace, _super);
    /**
     * Constructs a new instance of the TraceTelemetry object
     */
    function Trace(logger, message, severityLevel, properties, measurements) {
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            ver: 1 /* Required */,
            message: 1 /* Required */,
            severityLevel: 0 /* Default */,
            properties: 0 /* Default */
        };
        message = message || __WEBPACK_IMPORTED_MODULE_3__Constants__["f" /* strNotSpecified */];
        _this.message = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["e" /* dataSanitizeMessage */])(logger, message);
        _this.properties = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["f" /* dataSanitizeProperties */])(logger, properties);
        _this.measurements = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["d" /* dataSanitizeMeasurements */])(logger, measurements);
        if (severityLevel) {
            _this.severityLevel = severityLevel;
        }
        return _this;
    }
    Trace.envelopeType = "Microsoft.ApplicationInsights.{0}.Message";
    Trace.dataType = "MessageData";
    return Trace;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_MessageData__["a" /* MessageData */]));

//# sourceMappingURL=Trace.js.map

/***/ }),
/* 1547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MessageData; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


/**
 * Instances of Message represent printf-like trace statements that are text-searched. Log4Net, NLog and other text-based log file entries are translated into intances of this type. The message does not have measurements.
 */
var MessageData = /** @class */ (function () {
    function MessageData() {
        /**
         * Schema version
         */
        this.ver = 2;
        /**
         * Collection of custom properties.
         */
        this.properties = {};
        /**
         * Collection of custom measurements.
         */
        this.measurements = {};
    }
    return MessageData;
}());

//# sourceMappingURL=MessageData.js.map

/***/ }),
/* 1548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageViewPerformance; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_PageViewPerfData__ = __webpack_require__(1549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Constants__ = __webpack_require__(85);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */






var PageViewPerformance = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(PageViewPerformance, _super);
    /**
     * Constructs a new instance of the PageEventTelemetry object
     */
    function PageViewPerformance(logger, name, url, unused, properties, measurements, cs4BaseData) {
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            ver: 1 /* Required */,
            name: 0 /* Default */,
            url: 0 /* Default */,
            duration: 0 /* Default */,
            perfTotal: 0 /* Default */,
            networkConnect: 0 /* Default */,
            sentRequest: 0 /* Default */,
            receivedResponse: 0 /* Default */,
            domProcessing: 0 /* Default */,
            properties: 0 /* Default */,
            measurements: 0 /* Default */
        };
        _this.url = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["h" /* dataSanitizeUrl */])(logger, url);
        _this.name = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["g" /* dataSanitizeString */])(logger, name) || __WEBPACK_IMPORTED_MODULE_3__Constants__["f" /* strNotSpecified */];
        _this.properties = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["f" /* dataSanitizeProperties */])(logger, properties);
        _this.measurements = Object(__WEBPACK_IMPORTED_MODULE_2__Common_DataSanitizer__["d" /* dataSanitizeMeasurements */])(logger, measurements);
        if (cs4BaseData) {
            _this.domProcessing = cs4BaseData.domProcessing;
            _this.duration = cs4BaseData.duration;
            _this.networkConnect = cs4BaseData.networkConnect;
            _this.perfTotal = cs4BaseData.perfTotal;
            _this.receivedResponse = cs4BaseData.receivedResponse;
            _this.sentRequest = cs4BaseData.sentRequest;
        }
        return _this;
    }
    PageViewPerformance.envelopeType = "Microsoft.ApplicationInsights.{0}.PageviewPerformance";
    PageViewPerformance.dataType = "PageviewPerformanceData";
    return PageViewPerformance;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_PageViewPerfData__["a" /* PageViewPerfData */]));

//# sourceMappingURL=PageViewPerformance.js.map

/***/ }),
/* 1549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageViewPerfData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PageViewData__ = __webpack_require__(381);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



// THIS FILE WAS AUTOGENERATED

/**
 * An instance of PageViewPerf represents: a page view with no performance data, a page view with performance data, or just the performance data of an earlier page request.
 */
var PageViewPerfData = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(PageViewPerfData, _super);
    function PageViewPerfData() {
        var _this = _super.call(this) || this;
        /**
         * Schema version
         */
        _this.ver = 2;
        /**
         * Collection of custom properties.
         */
        _this.properties = {};
        /**
         * Collection of custom measurements.
         */
        _this.measurements = {};
        return _this;
    }
    return PageViewPerfData;
}(__WEBPACK_IMPORTED_MODULE_1__PageViewData__["a" /* PageViewData */]));

//# sourceMappingURL=PageViewPerfData.js.map

/***/ }),
/* 1550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Data; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_Data__ = __webpack_require__(620);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */




var Data = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_shims__["g" /* __extendsFn */])(Data, _super);
    /**
     * Constructs a new instance of telemetry data.
     */
    function Data(baseType, data) {
        var _this = _super.call(this) || this;
        /**
         * The data contract for serializing this object.
         */
        _this.aiDataContract = {
            baseType: 1 /* Required */,
            baseData: 1 /* Required */
        };
        _this.baseType = baseType;
        _this.baseData = data;
        return _this;
    }
    return Data;
}(__WEBPACK_IMPORTED_MODULE_1__Interfaces_Contracts_Generated_Data__["a" /* Data */]));

//# sourceMappingURL=Data.js.map

/***/ }),
/* 1551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SeverityLevel; });
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// THIS FILE WAS AUTOGENERATED
/**
 * Defines the level of severity for the event.
 */
var SeverityLevel;
(function (SeverityLevel) {
    SeverityLevel[SeverityLevel["Verbose"] = 0] = "Verbose";
    SeverityLevel[SeverityLevel["Information"] = 1] = "Information";
    SeverityLevel[SeverityLevel["Warning"] = 2] = "Warning";
    SeverityLevel[SeverityLevel["Error"] = 3] = "Error";
    SeverityLevel[SeverityLevel["Critical"] = 4] = "Critical";
})(SeverityLevel || (SeverityLevel = {}));
//# sourceMappingURL=SeverityLevel.js.map

/***/ }),
/* 1552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConfigurationManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__ = __webpack_require__(39);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



var ConfigurationManager = /** @class */ (function () {
    function ConfigurationManager() {
    }
    ConfigurationManager.getConfig = function (config, field, identifier, defaultValue) {
        if (defaultValue === void 0) { defaultValue = false; }
        var configValue;
        if (identifier && config.extensionConfig && config.extensionConfig[identifier] && !Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["H" /* isNullOrUndefined */])(config.extensionConfig[identifier][field])) {
            configValue = config.extensionConfig[identifier][field];
        }
        else {
            configValue = config[field];
        }
        return !Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_core_js__["H" /* isNullOrUndefined */])(configValue) ? configValue : defaultValue;
    };
    return ConfigurationManager;
}());

//# sourceMappingURL=IConfig.js.map

/***/ }),
/* 1553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TelemetryItemCreator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Telemetry_Common_DataSanitizer__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Constants__ = __webpack_require__(85);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */





var TelemetryItemCreator = /** @class */ (function () {
    function TelemetryItemCreator() {
    }
    /**
     * Create a telemetry item that the 1DS channel understands
     * @param item domain specific properties; part B
     * @param baseType telemetry item type. ie PageViewData
     * @param envelopeName name of the envelope. ie Microsoft.ApplicationInsights.<instrumentation key>.PageView
     * @param customProperties user defined custom properties; part C
     * @param systemProperties system properties that are added to the context; part A
     * @returns ITelemetryItem that is sent to channel
     */
    TelemetryItemCreator.create = function (item, baseType, envelopeName, logger, customProperties, systemProperties) {
        envelopeName = Object(__WEBPACK_IMPORTED_MODULE_0__Telemetry_Common_DataSanitizer__["g" /* dataSanitizeString */])(logger, envelopeName) || __WEBPACK_IMPORTED_MODULE_2__Constants__["f" /* strNotSpecified */];
        if (Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["H" /* isNullOrUndefined */])(item) ||
            Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["H" /* isNullOrUndefined */])(baseType) ||
            Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["H" /* isNullOrUndefined */])(envelopeName)) {
            throw Error("Input doesn't contain all required fields");
        }
        var telemetryItem = {
            name: envelopeName,
            time: Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["T" /* toISOString */])(new Date()),
            iKey: "",
            ext: systemProperties ? systemProperties : {},
            tags: [],
            data: {},
            baseType: baseType,
            baseData: item // Part B
        };
        // Part C
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["H" /* isNullOrUndefined */])(customProperties)) {
            Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["M" /* objForEachKey */])(customProperties, function (prop, value) {
                telemetryItem.data[prop] = value;
            });
        }
        return telemetryItem;
    };
    return TelemetryItemCreator;
}());

//# sourceMappingURL=TelemetryItemCreator.js.map

/***/ }),
/* 1554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Extensions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CtxTagKeys; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Contracts_Generated_ContextTagKeys__ = __webpack_require__(623);
/*
 * Application Insights JavaScript SDK - Common, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

var Extensions = {
    UserExt: "user",
    DeviceExt: "device",
    TraceExt: "trace",
    WebExt: "web",
    AppExt: "app",
    OSExt: "os",
    SessionExt: "ses",
    SDKExt: "sdk"
};
var CtxTagKeys = new __WEBPACK_IMPORTED_MODULE_0__Contracts_Generated_ContextTagKeys__["a" /* ContextTagKeys */]();
//# sourceMappingURL=PartAExtensions.js.map

/***/ }),
/* 1555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ApplicationInsightsContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ApplicationInsightsDeprecated__ = __webpack_require__(1556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Initialization__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__ = __webpack_require__(39);
/*
 * Application Insights JavaScript SDK - Web, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */



var ApplicationInsightsContainer = /** @class */ (function () {
    function ApplicationInsightsContainer() {
    }
    ApplicationInsightsContainer.getAppInsights = function (snippet, version) {
        var initialization = new __WEBPACK_IMPORTED_MODULE_1__Initialization__["a" /* Initialization */](snippet);
        var legacyMode = version !== 2.0 ? true : false;
        // Side effect is to create, initialize and listen to the CoreUtils._canUseCookies changes
        // Called here to support backward compatibility
        Object(__WEBPACK_IMPORTED_MODULE_2__microsoft_applicationinsights_core_js__["d" /* _legacyCookieMgr */])();
        // Two target scenarios:
        // 1. Customer runs v1 snippet + runtime. If customer updates just cdn location to new SDK, it will run in compat mode so old apis work
        // 2. Customer updates to new snippet (that uses cdn location to new SDK. This is same as a new customer onboarding
        // and all api signatures are expected to map to new SDK. Note new snippet specifies version
        if (version === 2.0) {
            initialization.updateSnippetDefinitions(snippet);
            initialization.loadAppInsights(legacyMode);
            return initialization; // default behavior with new snippet
        }
        else {
            var legacy = new __WEBPACK_IMPORTED_MODULE_0__ApplicationInsightsDeprecated__["a" /* AppInsightsDeprecated */](snippet, initialization); // target scenario old snippet + updated endpoint
            legacy.updateSnippetDefinitions(snippet);
            initialization.loadAppInsights(legacyMode);
            return legacy;
        }
    };
    return ApplicationInsightsContainer;
}());

//# sourceMappingURL=ApplicationInsightsContainer.js.map

/***/ }),
/* 1556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppInsightsDeprecated; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__ = __webpack_require__(39);
/*
 * Application Insights JavaScript SDK - Web, 2.6.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// This is an exclude list of properties that should not be updated during initialization
// They include a combination of private and internal property names
var _ignoreUpdateSnippetProperties = [
    "snippet", "getDefaultConfig", "_hasLegacyInitializers", "_queue", "_processLegacyInitializers"
];
// ToDo: fix properties and measurements once updates are done to common
var AppInsightsDeprecated = /** @class */ (function () {
    function AppInsightsDeprecated(snippet, appInsightsNew) {
        this._hasLegacyInitializers = false;
        this._queue = [];
        this.config = AppInsightsDeprecated.getDefaultConfig(snippet.config);
        this.appInsightsNew = appInsightsNew;
        this.context = { addTelemetryInitializer: this.addTelemetryInitializers.bind(this) };
    }
    AppInsightsDeprecated.getDefaultConfig = function (config) {
        if (!config) {
            config = {};
        }
        // set default values
        config.endpointUrl = config.endpointUrl || "https://dc.services.visualstudio.com/v2/track";
        config.sessionRenewalMs = 30 * 60 * 1000;
        config.sessionExpirationMs = 24 * 60 * 60 * 1000;
        config.maxBatchSizeInBytes = config.maxBatchSizeInBytes > 0 ? config.maxBatchSizeInBytes : 102400; // 100kb
        config.maxBatchInterval = !isNaN(config.maxBatchInterval) ? config.maxBatchInterval : 15000;
        config.enableDebug = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["J" /* stringToBoolOrDefault */])(config.enableDebug);
        config.disableExceptionTracking = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["J" /* stringToBoolOrDefault */])(config.disableExceptionTracking);
        config.disableTelemetry = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["J" /* stringToBoolOrDefault */])(config.disableTelemetry);
        config.verboseLogging = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["J" /* stringToBoolOrDefault */])(config.verboseLogging);
        config.emitLineDelimitedJson = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["J" /* stringToBoolOrDefault */])(config.emitLineDelimitedJson);
        config.diagnosticLogInterval = config.diagnosticLogInterval || 10000;
        config.autoTrackPageVisitTime = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["J" /* stringToBoolOrDefault */])(config.autoTrackPageVisitTime);
        if (isNaN(config.samplingPercentage) || config.samplingPercentage <= 0 || config.samplingPercentage >= 100) {
            config.samplingPercentage = 100;
        }
        config.disableAjaxTracking = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["J" /* stringToBoolOrDefault */])(config.disableAjaxTracking);
        config.maxAjaxCallsPerView = !isNaN(config.maxAjaxCallsPerView) ? config.maxAjaxCallsPerView : 500;
        config.isBeaconApiDisabled = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["J" /* stringToBoolOrDefault */])(config.isBeaconApiDisabled, true);
        config.disableCorrelationHeaders = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["J" /* stringToBoolOrDefault */])(config.disableCorrelationHeaders);
        config.correlationHeaderExcludedDomains = config.correlationHeaderExcludedDomains || [
            "*.blob.core.windows.net",
            "*.blob.core.chinacloudapi.cn",
            "*.blob.core.cloudapi.de",
            "*.blob.core.usgovcloudapi.net"
        ];
        config.disableFlushOnBeforeUnload = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["J" /* stringToBoolOrDefault */])(config.disableFlushOnBeforeUnload);
        config.disableFlushOnUnload = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["J" /* stringToBoolOrDefault */])(config.disableFlushOnUnload, config.disableFlushOnBeforeUnload);
        config.enableSessionStorageBuffer = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["J" /* stringToBoolOrDefault */])(config.enableSessionStorageBuffer, true);
        config.isRetryDisabled = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["J" /* stringToBoolOrDefault */])(config.isRetryDisabled);
        config.isCookieUseDisabled = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["J" /* stringToBoolOrDefault */])(config.isCookieUseDisabled);
        config.isStorageUseDisabled = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["J" /* stringToBoolOrDefault */])(config.isStorageUseDisabled);
        config.isBrowserLinkTrackingEnabled = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["J" /* stringToBoolOrDefault */])(config.isBrowserLinkTrackingEnabled);
        config.enableCorsCorrelation = Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["J" /* stringToBoolOrDefault */])(config.enableCorsCorrelation);
        return config;
    };
    /**
     * The array of telemetry initializers to call before sending each telemetry item.
     */
    AppInsightsDeprecated.prototype.addTelemetryInitializers = function (callBack) {
        var _this = this;
        // Add initializer to current processing only if there is any old telemetry initializer
        if (!this._hasLegacyInitializers) {
            this.appInsightsNew.addTelemetryInitializer(function (item) {
                _this._processLegacyInitializers(item); // setup call back for each legacy processor
            });
            this._hasLegacyInitializers = true;
        }
        this._queue.push(callBack);
    };
    /**
     * Get the current cookie manager for this instance
     */
    AppInsightsDeprecated.prototype.getCookieMgr = function () {
        return this.appInsightsNew.getCookieMgr();
    };
    AppInsightsDeprecated.prototype.startTrackPage = function (name) {
        this.appInsightsNew.startTrackPage(name);
    };
    AppInsightsDeprecated.prototype.stopTrackPage = function (name, url, properties, measurements) {
        this.appInsightsNew.stopTrackPage(name, url, properties); // update
    };
    AppInsightsDeprecated.prototype.trackPageView = function (name, url, properties, measurements, duration) {
        var telemetry = {
            name: name,
            uri: url,
            properties: properties,
            measurements: measurements
        };
        // fix for props, measurements, duration
        this.appInsightsNew.trackPageView(telemetry);
    };
    AppInsightsDeprecated.prototype.trackEvent = function (name, properties, measurements) {
        this.appInsightsNew.trackEvent({ name: name });
    };
    AppInsightsDeprecated.prototype.trackDependency = function (id, method, absoluteUrl, pathName, totalTime, success, resultCode) {
        this.appInsightsNew.trackDependencyData({
            id: id,
            target: absoluteUrl,
            type: pathName,
            duration: totalTime,
            properties: { HttpMethod: method },
            success: success,
            responseCode: resultCode
        });
    };
    AppInsightsDeprecated.prototype.trackException = function (exception, handledAt, properties, measurements, severityLevel) {
        this.appInsightsNew.trackException({
            exception: exception
        });
    };
    AppInsightsDeprecated.prototype.trackMetric = function (name, average, sampleCount, min, max, properties) {
        this.appInsightsNew.trackMetric({ name: name, average: average, sampleCount: sampleCount, min: min, max: max });
    };
    AppInsightsDeprecated.prototype.trackTrace = function (message, properties, severityLevel) {
        this.appInsightsNew.trackTrace({ message: message, severityLevel: severityLevel });
    };
    AppInsightsDeprecated.prototype.flush = function (async) {
        this.appInsightsNew.flush(async);
    };
    AppInsightsDeprecated.prototype.setAuthenticatedUserContext = function (authenticatedUserId, accountId, storeInCookie) {
        this.appInsightsNew.context.user.setAuthenticatedUserContext(authenticatedUserId, accountId, storeInCookie);
    };
    AppInsightsDeprecated.prototype.clearAuthenticatedUserContext = function () {
        this.appInsightsNew.context.user.clearAuthenticatedUserContext();
    };
    AppInsightsDeprecated.prototype._onerror = function (message, url, lineNumber, columnNumber, error) {
        this.appInsightsNew._onerror({ message: message, url: url, lineNumber: lineNumber, columnNumber: columnNumber, error: error });
    };
    AppInsightsDeprecated.prototype.startTrackEvent = function (name) {
        this.appInsightsNew.startTrackEvent(name);
    };
    AppInsightsDeprecated.prototype.stopTrackEvent = function (name, properties, measurements) {
        this.appInsightsNew.stopTrackEvent(name, properties, measurements);
    };
    AppInsightsDeprecated.prototype.downloadAndSetup = function (config) {
        Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["S" /* throwError */])("downloadAndSetup not implemented in web SKU");
    };
    AppInsightsDeprecated.prototype.updateSnippetDefinitions = function (snippet) {
        // apply full appInsights to the global instance
        // Note: This must be called before loadAppInsights is called
        Object(__WEBPACK_IMPORTED_MODULE_1__microsoft_applicationinsights_core_js__["O" /* proxyAssign */])(snippet, this, function (name) {
            // Not excluding names prefixed with "_" as we need to proxy some functions like _onError
            return name && _ignoreUpdateSnippetProperties.indexOf(name) === -1;
        });
    };
    // note: these are split into methods to enable unit tests
    AppInsightsDeprecated.prototype.loadAppInsights = function () {
        // initialize global instance of appInsights
        // var appInsights = new Microsoft.ApplicationInsights.AppInsights(this.config);
        var _this = this;
        // implement legacy version of trackPageView for 0.10<
        if (this.config["iKey"]) {
            var originalTrackPageView_1 = this.trackPageView;
            this.trackPageView = function (pagePath, properties, measurements) {
                originalTrackPageView_1.apply(_this, [null, pagePath, properties, measurements]);
            };
        }
        // implement legacy pageView interface if it is present in the snippet
        var legacyPageView = "logPageView";
        if (typeof this.snippet[legacyPageView] === "function") {
            this[legacyPageView] = function (pagePath, properties, measurements) {
                _this.trackPageView(null, pagePath, properties, measurements);
            };
        }
        // implement legacy event interface if it is present in the snippet
        var legacyEvent = "logEvent";
        if (typeof this.snippet[legacyEvent] === "function") {
            this[legacyEvent] = function (name, props, measurements) {
                _this.trackEvent(name, props, measurements);
            };
        }
        return this;
    };
    AppInsightsDeprecated.prototype._processLegacyInitializers = function (item) {
        // instead of mapping new to legacy and then back again and repeating in channel, attach callback for channel to call
        item.tags[__WEBPACK_IMPORTED_MODULE_0__microsoft_applicationinsights_common__["y" /* ProcessLegacy */]] = this._queue;
        return item;
    };
    return AppInsightsDeprecated;
}());

//# sourceMappingURL=ApplicationInsightsDeprecated.js.map

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(1558)('createBrowserHistory');
module.exports = __webpack_require__(1559).createBrowserHistory;


/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var printWarning = function() {};

if (false) {
  printWarning = function(format, subs) {
    var index = 0;
    var message =
      'Warning: ' +
      (subs.length > 0
        ? format.replace(/%s/g, function() {
            return subs[index++];
          })
        : format);

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging history ---
      // This error was thrown as a convenience so that you can use the
      // stack trace to find the callsite that triggered this warning.
      throw new Error(message);
    } catch (e) {}
  };
}

module.exports = function(member) {
  printWarning(
    'Please use `require("history").%s` instead of `require("history/%s")`. ' +
      'Support for the latter will be removed in the next major release.',
    [member, member]
  );
};


/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1560);
} else {
  module.exports = require('./cjs/history.js');
}


/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var resolvePathname=_interopDefault(__webpack_require__(624)),valueEqual=_interopDefault(__webpack_require__(625));__webpack_require__(626);var invariant=_interopDefault(__webpack_require__(627));function _extends(){return(_extends=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var a in e)Object.prototype.hasOwnProperty.call(e,a)&&(t[a]=e[a])}return t}).apply(this,arguments)}function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function stripLeadingSlash(t){return"/"===t.charAt(0)?t.substr(1):t}function hasBasename(t,n){return 0===t.toLowerCase().indexOf(n.toLowerCase())&&-1!=="/?#".indexOf(t.charAt(n.length))}function stripBasename(t,n){return hasBasename(t,n)?t.substr(n.length):t}function stripTrailingSlash(t){return"/"===t.charAt(t.length-1)?t.slice(0,-1):t}function parsePath(t){var n=t||"/",e="",a="",r=n.indexOf("#");-1!==r&&(a=n.substr(r),n=n.substr(0,r));var o=n.indexOf("?");return-1!==o&&(e=n.substr(o),n=n.substr(0,o)),{pathname:n,search:"?"===e?"":e,hash:"#"===a?"":a}}function createPath(t){var n=t.pathname,e=t.search,a=t.hash,r=n||"/";return e&&"?"!==e&&(r+="?"===e.charAt(0)?e:"?"+e),a&&"#"!==a&&(r+="#"===a.charAt(0)?a:"#"+a),r}function createLocation(t,n,e,a){var r;"string"==typeof t?(r=parsePath(t)).state=n:(void 0===(r=_extends({},t)).pathname&&(r.pathname=""),r.search?"?"!==r.search.charAt(0)&&(r.search="?"+r.search):r.search="",r.hash?"#"!==r.hash.charAt(0)&&(r.hash="#"+r.hash):r.hash="",void 0!==n&&void 0===r.state&&(r.state=n));try{r.pathname=decodeURI(r.pathname)}catch(t){throw t instanceof URIError?new URIError('Pathname "'+r.pathname+'" could not be decoded. This is likely caused by an invalid percent-encoding.'):t}return e&&(r.key=e),a?r.pathname?"/"!==r.pathname.charAt(0)&&(r.pathname=resolvePathname(r.pathname,a.pathname)):r.pathname=a.pathname:r.pathname||(r.pathname="/"),r}function locationsAreEqual(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash&&t.key===n.key&&valueEqual(t.state,n.state)}function createTransitionManager(){var o=null;var a=[];return{setPrompt:function(t){return o=t,function(){o===t&&(o=null)}},confirmTransitionTo:function(t,n,e,a){if(null!=o){var r="function"==typeof o?o(t,n):o;"string"==typeof r?"function"==typeof e?e(r,a):a(!0):a(!1!==r)}else a(!0)},appendListener:function(t){var n=!0;function e(){n&&t.apply(void 0,arguments)}return a.push(e),function(){n=!1,a=a.filter(function(t){return t!==e})}},notifyListeners:function(){for(var t=arguments.length,n=new Array(t),e=0;e<t;e++)n[e]=arguments[e];a.forEach(function(t){return t.apply(void 0,n)})}}}var canUseDOM=!("undefined"==typeof window||!window.document||!window.document.createElement);function getConfirmation(t,n){n(window.confirm(t))}function supportsHistory(){var t=window.navigator.userAgent;return(-1===t.indexOf("Android 2.")&&-1===t.indexOf("Android 4.0")||-1===t.indexOf("Mobile Safari")||-1!==t.indexOf("Chrome")||-1!==t.indexOf("Windows Phone"))&&(window.history&&"pushState"in window.history)}function supportsPopStateOnHashChange(){return-1===window.navigator.userAgent.indexOf("Trident")}function supportsGoWithoutReloadUsingHash(){return-1===window.navigator.userAgent.indexOf("Firefox")}function isExtraneousPopstateEvent(t){return void 0===t.state&&-1===navigator.userAgent.indexOf("CriOS")}var PopStateEvent="popstate",HashChangeEvent="hashchange";function getHistoryState(){try{return window.history.state||{}}catch(t){return{}}}function createBrowserHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var s=window.history,c=supportsHistory(),n=!supportsPopStateOnHashChange(),e=t,a=e.forceRefresh,h=void 0!==a&&a,r=e.getUserConfirmation,u=void 0===r?getConfirmation:r,o=e.keyLength,i=void 0===o?6:o,f=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"";function l(t){var n=t||{},e=n.key,a=n.state,r=window.location,o=r.pathname+r.search+r.hash;return f&&(o=stripBasename(o,f)),createLocation(o,a,e)}function d(){return Math.random().toString(36).substr(2,i)}var v=createTransitionManager();function p(t){_extends(T,t),T.length=s.length,v.notifyListeners(T.location,T.action)}function g(t){isExtraneousPopstateEvent(t)||w(l(t.state))}function P(){w(l(getHistoryState()))}var m=!1;function w(n){if(m)m=!1,p();else{v.confirmTransitionTo(n,"POP",u,function(t){t?p({action:"POP",location:n}):function(t){var n=T.location,e=H.indexOf(n.key);-1===e&&(e=0);var a=H.indexOf(t.key);-1===a&&(a=0);var r=e-a;r&&(m=!0,L(r))}(n)})}}var y=l(getHistoryState()),H=[y.key];function x(t){return f+createPath(t)}function L(t){s.go(t)}var O=0;function E(t){1===(O+=t)&&1===t?(window.addEventListener(PopStateEvent,g),n&&window.addEventListener(HashChangeEvent,P)):0===O&&(window.removeEventListener(PopStateEvent,g),n&&window.removeEventListener(HashChangeEvent,P))}var S=!1;var T={length:s.length,action:"POP",location:y,createHref:x,push:function(t,n){var i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,"PUSH",u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.pushState({key:e,state:a},null,n),h)window.location.href=n;else{var r=H.indexOf(T.location.key),o=H.slice(0,r+1);o.push(i.key),H=o,p({action:"PUSH",location:i})}else window.location.href=n}})},replace:function(t,n){var o="REPLACE",i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,o,u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.replaceState({key:e,state:a},null,n),h)window.location.replace(n);else{var r=H.indexOf(T.location.key);-1!==r&&(H[r]=i.key),p({action:o,location:i})}else window.location.replace(n)}})},go:L,goBack:function(){L(-1)},goForward:function(){L(1)},block:function(t){void 0===t&&(t=!1);var n=v.setPrompt(t);return S||(E(1),S=!0),function(){return S&&(S=!1,E(-1)),n()}},listen:function(t){var n=v.appendListener(t);return E(1),function(){E(-1),n()}}};return T}var HashChangeEvent$1="hashchange",HashPathCoders={hashbang:{encodePath:function(t){return"!"===t.charAt(0)?t:"!/"+stripLeadingSlash(t)},decodePath:function(t){return"!"===t.charAt(0)?t.substr(1):t}},noslash:{encodePath:stripLeadingSlash,decodePath:addLeadingSlash},slash:{encodePath:addLeadingSlash,decodePath:addLeadingSlash}};function stripHash(t){var n=t.indexOf("#");return-1===n?t:t.slice(0,n)}function getHashPath(){var t=window.location.href,n=t.indexOf("#");return-1===n?"":t.substring(n+1)}function pushHashPath(t){window.location.hash=t}function replaceHashPath(t){window.location.replace(stripHash(window.location.href)+"#"+t)}function createHashHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var n=window.history,e=(supportsGoWithoutReloadUsingHash(),t),a=e.getUserConfirmation,i=void 0===a?getConfirmation:a,r=e.hashType,o=void 0===r?"slash":r,s=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"",c=HashPathCoders[o],h=c.encodePath,u=c.decodePath;function f(){var t=u(getHashPath());return s&&(t=stripBasename(t,s)),createLocation(t)}var l=createTransitionManager();function d(t){_extends(E,t),E.length=n.length,l.notifyListeners(E.location,E.action)}var v=!1,p=null;function g(){var t=getHashPath(),n=h(t);if(t!==n)replaceHashPath(n);else{var e=f(),a=E.location;if(!v&&function(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash}(a,e))return;if(p===createPath(e))return;p=null,function(n){if(v)v=!1,d();else{l.confirmTransitionTo(n,"POP",i,function(t){t?d({action:"POP",location:n}):function(t){var n=E.location,e=y.lastIndexOf(createPath(n));-1===e&&(e=0);var a=y.lastIndexOf(createPath(t));-1===a&&(a=0);var r=e-a;r&&(v=!0,H(r))}(n)})}}(e)}}var P=getHashPath(),m=h(P);P!==m&&replaceHashPath(m);var w=f(),y=[createPath(w)];function H(t){n.go(t)}var x=0;function L(t){1===(x+=t)&&1===t?window.addEventListener(HashChangeEvent$1,g):0===x&&window.removeEventListener(HashChangeEvent$1,g)}var O=!1;var E={length:n.length,action:"POP",location:w,createHref:function(t){var n=document.querySelector("base"),e="";return n&&n.getAttribute("href")&&(e=stripHash(window.location.href)),e+"#"+h(s+createPath(t))},push:function(t,n){var o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,"PUSH",i,function(t){if(t){var n=createPath(o),e=h(s+n);if(getHashPath()!==e){p=n,pushHashPath(e);var a=y.lastIndexOf(createPath(E.location)),r=y.slice(0,a+1);r.push(n),y=r,d({action:"PUSH",location:o})}else d()}})},replace:function(t,n){var r="REPLACE",o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,r,i,function(t){if(t){var n=createPath(o),e=h(s+n);getHashPath()!==e&&(p=n,replaceHashPath(e));var a=y.indexOf(createPath(E.location));-1!==a&&(y[a]=n),d({action:r,location:o})}})},go:H,goBack:function(){H(-1)},goForward:function(){H(1)},block:function(t){void 0===t&&(t=!1);var n=l.setPrompt(t);return O||(L(1),O=!0),function(){return O&&(O=!1,L(-1)),n()}},listen:function(t){var n=l.appendListener(t);return L(1),function(){L(-1),n()}}};return E}function clamp(t,n,e){return Math.min(Math.max(t,n),e)}function createMemoryHistory(t){void 0===t&&(t={});var n=t,r=n.getUserConfirmation,e=n.initialEntries,a=void 0===e?["/"]:e,o=n.initialIndex,i=void 0===o?0:o,s=n.keyLength,c=void 0===s?6:s,h=createTransitionManager();function u(t){_extends(g,t),g.length=g.entries.length,h.notifyListeners(g.location,g.action)}function f(){return Math.random().toString(36).substr(2,c)}var l=clamp(i,0,a.length-1),d=a.map(function(t){return createLocation(t,void 0,"string"==typeof t?f():t.key||f())}),v=createPath;function p(t){var n=clamp(g.index+t,0,g.entries.length-1),e=g.entries[n];h.confirmTransitionTo(e,"POP",r,function(t){t?u({action:"POP",location:e,index:n}):u()})}var g={length:d.length,action:"POP",location:d[l],index:l,entries:d,createHref:v,push:function(t,n){var a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,"PUSH",r,function(t){if(t){var n=g.index+1,e=g.entries.slice(0);e.length>n?e.splice(n,e.length-n,a):e.push(a),u({action:"PUSH",location:a,index:n,entries:e})}})},replace:function(t,n){var e="REPLACE",a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,e,r,function(t){t&&(g.entries[g.index]=a,u({action:e,location:a}))})},go:p,goBack:function(){p(-1)},goForward:function(){p(1)},canGo:function(t){var n=g.index+t;return 0<=n&&n<g.entries.length},block:function(t){return void 0===t&&(t=!1),h.setPrompt(t)},listen:function(t){return h.appendListener(t)}};return g}exports.createBrowserHistory=createBrowserHistory,exports.createHashHistory=createHashHistory,exports.createMemoryHistory=createMemoryHistory,exports.createLocation=createLocation,exports.locationsAreEqual=locationsAreEqual,exports.parsePath=parsePath,exports.createPath=createPath;


/***/ }),
/* 1561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setVersion;
// A packages cache that makes sure that we don't inject the same packageName twice in the same bundle -
// this cache is local to the module closure inside this bundle
var packagesCache = {};
function setVersion(packageName, packageVersion) {
    if (typeof window !== 'undefined') {
        // tslint:disable-next-line:no-any
        var packages = (window.__packages__ = window.__packages__ || {});
        // We allow either the global packages or local packages caches to invalidate so testing can just clear the global to set this state
        if (!packages[packageName] || !packagesCache[packageName]) {
            packagesCache[packageName] = packageVersion;
            var versions = (packages[packageName] = packages[packageName] || []);
            versions.push(packageVersion);
        }
    }
}
//# sourceMappingURL=setVersion.js.map

/***/ }),
/* 1562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnimationClassNames__ = __webpack_require__(1563);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AnimationClassNames__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FontClassNames__ = __webpack_require__(1634);
/* unused harmony reexport FontClassNames */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ColorClassNames__ = __webpack_require__(1635);
/* unused harmony reexport ColorClassNames */



//# sourceMappingURL=index.js.map

/***/ }),
/* 1563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnimationClassNames; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_index__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_index__ = __webpack_require__(387);


/**
 * {@docCategory AnimationClassNames}
 */
var AnimationClassNames = Object(__WEBPACK_IMPORTED_MODULE_0__utilities_index__["a" /* buildClassMap */])(__WEBPACK_IMPORTED_MODULE_1__styles_index__["a" /* AnimationStyles */]);
//# sourceMappingURL=AnimationClassNames.js.map

/***/ }),
/* 1564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mergeStyles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styleToClassName__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__extractStyleParts__ = __webpack_require__(632);


/**
 * Concatination helper, which can merge class names together. Skips over falsey values.
 *
 * @public
 */
function mergeStyles() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var _a = Object(__WEBPACK_IMPORTED_MODULE_1__extractStyleParts__["a" /* extractStyleParts */])(args), classes = _a.classes, objects = _a.objects;
    if (objects.length) {
        classes.push(Object(__WEBPACK_IMPORTED_MODULE_0__styleToClassName__["c" /* styleToClassName */])(objects));
    }
    return classes.join(' ');
}
//# sourceMappingURL=mergeStyles.js.map

/***/ }),
/* 1565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = kebabRules;
var rules = {
    MozOsxFontSmoothing: '-moz-osx-font-smoothing',
    MsHighContrastAdjust: '-ms-high-contrast-adjust',
    WebkitFontSmoothing: '-webkit-font-smoothing',
    WebkitOverflowScrolling: '-webkit-overflow-scrolling',
    WebkitTapHighlightColor: '-webkit-tap-highlight-color',
    alignContent: 'align-content',
    alignItems: 'align-items',
    alignSelf: 'align-self',
    animation: 'animation',
    animationDelay: 'animation-delay',
    animationDirection: 'animation-direction',
    animationDuration: 'animation-duration',
    animationFillMode: 'animation-fill-mode',
    animationIterationCount: 'animation-iteration-count',
    animationName: 'animation-name',
    animationTimingFunction: 'animation-timing-function',
    background: 'background',
    backgroundClip: 'background-clip',
    backgroundColor: 'background-color',
    backgroundImage: 'background-image',
    backgroundPosition: 'background-position',
    border: 'border',
    borderBottom: 'border-bottom',
    borderBottomColor: 'border-bottom-color',
    borderBottomStyle: 'border-bottom-style',
    borderBottomWidth: 'border-bottom-width',
    borderCollapse: 'border-collapse',
    borderColor: 'border-color',
    borderLeft: 'border-left',
    borderRadius: 'border-radius',
    borderRight: 'border-right',
    borderStyle: 'border-style',
    borderTop: 'border-top',
    borderTopColor: 'border-top-color',
    borderTopLeftRadius: 'border-top-left-radius',
    borderTopRightRadius: 'border-top-right-radius',
    borderTopStyle: 'border-top-style',
    borderTopWidth: 'border-top-width',
    borderWidth: 'border-width',
    bordercolor: 'bordercolor',
    bottom: 'bottom',
    boxShadow: 'box-shadow',
    boxSizing: 'box-sizing',
    clear: 'clear',
    color: 'color',
    content: 'content',
    cursor: 'cursor',
    display: 'display',
    fill: 'fill',
    flex: 'flex',
    flexBasis: 'flex-basis',
    flexDirection: 'flex-direction',
    flexGrow: 'flex-grow',
    flexShrink: 'flex-shrink',
    flexWrap: 'flex-wrap',
    float: 'float',
    font: 'font',
    fontFamily: 'font-family',
    fontSize: 'font-size',
    fontStyle: 'font-style',
    fontWeight: 'font-weight',
    height: 'height',
    justifyContent: 'justify-content',
    left: 'left',
    lineHeight: 'line-height',
    listStyle: 'list-style',
    listStyleType: 'list-style-type',
    marginBottom: 'margin-bottom',
    marginLeft: 'margin-left',
    marginRight: 'margin-right',
    marginTop: 'margin-top',
    maxHeight: 'max-height',
    maxWidth: 'max-width',
    minHeight: 'min-height',
    minWidth: 'min-width',
    mozOsxFontSmoothing: 'moz-osx-font-smoothing',
    objectFit: 'object-fit',
    opacity: 'opacity',
    order: 'order',
    outline: 'outline',
    outlineColor: 'outline-color',
    outlineOffset: 'outline-offset',
    overflow: 'overflow',
    overflowWrap: 'overflow-wrap',
    overflowX: 'overflow-x',
    overflowY: 'overflow-y',
    paddingBottom: 'padding-bottom',
    paddingLeft: 'padding-left',
    paddingRight: 'padding-right',
    paddingTop: 'padding-top',
    perspective: 'perspective',
    pointerEvents: 'pointer-events',
    position: 'position',
    resize: 'resize',
    right: 'right',
    speak: 'speak',
    src: 'src',
    tableLayout: 'table-layout',
    textAlign: 'text-align',
    textDecoration: 'text-decoration',
    textOverflow: 'text-overflow',
    textTransform: 'text-transform',
    top: 'top',
    transform: 'transform',
    transformOrigin: 'transform-origin',
    transition: 'transition',
    transitionDelay: 'transition-delay',
    transitionDuration: 'transition-duration',
    transitionProperty: 'transition-property',
    transitionTimingFunction: 'transition-timing-function',
    userSelect: 'user-select',
    verticalAlign: 'vertical-align',
    visibility: 'visibility',
    webkitFontSmoothing: 'webkit-font-smoothing',
    whiteSpace: 'white-space',
    width: 'width',
    wordBreak: 'word-break',
    wordWrap: 'word-wrap',
    zIndex: 'z-index'
};
function kebabRules(rulePairs, index) {
    var rule = rulePairs[index];
    rulePairs[index] = rules[rule] = rules[rule] || rule.replace(/([A-Z])/g, '-$1').toLowerCase();
}
//# sourceMappingURL=kebabRules.js.map

/***/ }),
/* 1566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = prefixRules;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getVendorSettings__ = __webpack_require__(1567);

var autoPrefixNames = {
    'user-select': 1
};
function prefixRules(rulePairs, index) {
    var vendorSettings = Object(__WEBPACK_IMPORTED_MODULE_0__getVendorSettings__["a" /* getVendorSettings */])();
    var name = rulePairs[index];
    if (autoPrefixNames[name]) {
        var value = rulePairs[index + 1];
        if (autoPrefixNames[name]) {
            if (vendorSettings.isWebkit) {
                rulePairs.push('-webkit-' + name, value);
            }
            if (vendorSettings.isMoz) {
                rulePairs.push('-moz-' + name, value);
            }
            if (vendorSettings.isMs) {
                rulePairs.push('-ms-' + name, value);
            }
            if (vendorSettings.isOpera) {
                rulePairs.push('-o-' + name, value);
            }
        }
    }
}
//# sourceMappingURL=prefixRules.js.map

/***/ }),
/* 1567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getVendorSettings;
/* unused harmony export setVendorSettings */
var _vendorSettings;
function getVendorSettings() {
    if (!_vendorSettings) {
        var doc = typeof document !== 'undefined' ? document : undefined;
        var nav = typeof navigator !== 'undefined' ? navigator : undefined;
        var userAgent = nav ? nav.userAgent.toLowerCase() : undefined;
        if (!doc) {
            _vendorSettings = {
                isWebkit: true,
                isMoz: true,
                isOpera: true,
                isMs: true
            };
        }
        else {
            _vendorSettings = {
                isWebkit: !!(doc && 'WebkitAppearance' in doc.documentElement.style),
                isMoz: !!(userAgent && userAgent.indexOf('firefox') > -1),
                isOpera: !!(userAgent && userAgent.indexOf('opera') > -1),
                isMs: !!(nav && (/rv:11.0/i.test(nav.userAgent) || /Edge\/\d./i.test(navigator.userAgent)))
            };
        }
    }
    return _vendorSettings;
}
/**
 * Sets the vendor settings for prefixing and vendor specific operations.
 */
function setVendorSettings(vendorSettings) {
    _vendorSettings = vendorSettings;
}
//# sourceMappingURL=getVendorSettings.js.map

/***/ }),
/* 1568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = provideUnits;
var NON_PIXEL_NUMBER_PROPS = [
    'column-count',
    'font-weight',
    'flex-basis',
    'flex',
    'flex-grow',
    'flex-shrink',
    'fill-opacity',
    'opacity',
    'order',
    'z-index',
    'zoom'
];
function provideUnits(rulePairs, index) {
    var name = rulePairs[index];
    var value = rulePairs[index + 1];
    if (typeof value === 'number') {
        var unit = NON_PIXEL_NUMBER_PROPS.indexOf(name) === -1 ? 'px' : '';
        rulePairs[index + 1] = "" + value + unit;
    }
}
//# sourceMappingURL=provideUnits.js.map

/***/ }),
/* 1569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mergeStyleSets;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__extractStyleParts__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__concatStyleSets__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styleToClassName__ = __webpack_require__(257);



/**
 * Takes in one or more style set objects, each consisting of a set of areas,
 * each which will produce a class name. Using this is analogous to calling
 * `mergeStyles` for each property in the object, but ensures we maintain the
 * set ordering when multiple style sets are merged.
 *
 * @param styleSets - One or more style sets to be merged.
 */
function mergeStyleSets() {
    var styleSets = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        styleSets[_i] = arguments[_i];
    }
    // tslint:disable-next-line:no-any
    var classNameSet = { subComponentStyles: {} };
    var classMap = {};
    var styleSet = styleSets[0];
    if (!styleSet && styleSets.length <= 1) {
        return { subComponentStyles: {} };
    }
    var concatenatedStyleSet = 
    // we have guarded against falsey values just above.
    styleSet;
    concatenatedStyleSet = __WEBPACK_IMPORTED_MODULE_1__concatStyleSets__["a" /* concatStyleSets */].apply(void 0, styleSets);
    var registrations = [];
    for (var styleSetArea in concatenatedStyleSet) {
        if (concatenatedStyleSet.hasOwnProperty(styleSetArea)) {
            if (styleSetArea === 'subComponentStyles') {
                classNameSet.subComponentStyles = concatenatedStyleSet.subComponentStyles || {};
                continue;
            }
            var styles = concatenatedStyleSet[styleSetArea];
            var _a = Object(__WEBPACK_IMPORTED_MODULE_0__extractStyleParts__["a" /* extractStyleParts */])(styles), classes = _a.classes, objects = _a.objects;
            var registration = Object(__WEBPACK_IMPORTED_MODULE_2__styleToClassName__["d" /* styleToRegistration */])({ displayName: styleSetArea }, objects);
            registrations.push(registration);
            if (registration) {
                classMap[styleSetArea] = registration.className;
                // as any cast not needed in ts >=2.9
                classNameSet[styleSetArea] = classes.concat([registration.className]).join(' ');
            }
        }
    }
    for (var _b = 0, registrations_1 = registrations; _b < registrations_1.length; _b++) {
        var registration = registrations_1[_b];
        if (registration) {
            Object(__WEBPACK_IMPORTED_MODULE_2__styleToClassName__["a" /* applyRegistration */])(registration, classMap);
        }
    }
    return classNameSet;
}
//# sourceMappingURL=mergeStyleSets.js.map

/***/ }),
/* 1570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fontFace;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stylesheet__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styleToClassName__ = __webpack_require__(257);


/**
 * Registers a font face.
 * @public
 */
function fontFace(font) {
    __WEBPACK_IMPORTED_MODULE_0__Stylesheet__["a" /* Stylesheet */].getInstance().insertRule("@font-face{" + Object(__WEBPACK_IMPORTED_MODULE_1__styleToClassName__["b" /* serializeRuleEntries */])(font) + "}", true);
}
//# sourceMappingURL=fontFace.js.map

/***/ }),
/* 1571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = keyframes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stylesheet__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styleToClassName__ = __webpack_require__(257);


/**
 * Registers keyframe definitions.
 *
 * @public
 */
function keyframes(timeline) {
    var stylesheet = __WEBPACK_IMPORTED_MODULE_0__Stylesheet__["a" /* Stylesheet */].getInstance();
    var name = stylesheet.getClassName();
    var rulesArray = [];
    for (var prop in timeline) {
        if (timeline.hasOwnProperty(prop)) {
            rulesArray.push(prop, '{', Object(__WEBPACK_IMPORTED_MODULE_1__styleToClassName__["b" /* serializeRuleEntries */])(timeline[prop]), '}');
        }
    }
    var rules = rulesArray.join('');
    stylesheet.insertRule("@keyframes " + name + "{" + rules + "}", true);
    stylesheet.cacheClassName(name, rules, [], ['keyframes', rules]);
    return name;
}
//# sourceMappingURL=keyframes.js.map

/***/ }),
/* 1572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uifabric_set_version__ = __webpack_require__(145);
// @uifabric/merge-styles@6.19.3
// Do not modify this file, the file is generated as part of publish. The checked in version is a placeholder only.

Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_set_version__["a" /* setVersion */])('@uifabric/merge-styles', '6.19.3');
//# sourceMappingURL=version.js.map

/***/ }),
/* 1573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AutoScroll; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EventGroup__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scroll__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dom_getRect__ = __webpack_require__(637);



var SCROLL_ITERATION_DELAY = 16;
var SCROLL_GUTTER_HEIGHT = 100;
var MAX_SCROLL_VELOCITY = 15;
/**
 * AutoScroll simply hooks up mouse events given a parent element, and scrolls the container
 * up/down depending on how close the mouse is to the top/bottom of the container.
 *
 * Once you don't want autoscroll any more, just dispose the helper and it will unhook events.
 *
 * @public
 * {@docCategory AutoScroll}
 */
var AutoScroll = /** @class */ (function () {
    function AutoScroll(element) {
        this._events = new __WEBPACK_IMPORTED_MODULE_0__EventGroup__["a" /* EventGroup */](this);
        this._scrollableParent = Object(__WEBPACK_IMPORTED_MODULE_1__scroll__["d" /* findScrollableParent */])(element);
        this._incrementScroll = this._incrementScroll.bind(this);
        this._scrollRect = Object(__WEBPACK_IMPORTED_MODULE_2__dom_getRect__["a" /* getRect */])(this._scrollableParent);
        // tslint:disable-next-line:no-any
        if (this._scrollableParent === window) {
            this._scrollableParent = document.body;
        }
        if (this._scrollableParent) {
            this._events.on(window, 'mousemove', this._onMouseMove, true);
            this._events.on(window, 'touchmove', this._onTouchMove, true);
        }
    }
    AutoScroll.prototype.dispose = function () {
        this._events.dispose();
        this._stopScroll();
    };
    AutoScroll.prototype._onMouseMove = function (ev) {
        this._computeScrollVelocity(ev.clientY);
    };
    AutoScroll.prototype._onTouchMove = function (ev) {
        if (ev.touches.length > 0) {
            this._computeScrollVelocity(ev.touches[0].clientY);
        }
    };
    AutoScroll.prototype._computeScrollVelocity = function (clientY) {
        if (!this._scrollRect) {
            return;
        }
        var scrollRectTop = this._scrollRect.top;
        var scrollClientBottom = scrollRectTop + this._scrollRect.height - SCROLL_GUTTER_HEIGHT;
        if (clientY < scrollRectTop + SCROLL_GUTTER_HEIGHT) {
            this._scrollVelocity = Math.max(-MAX_SCROLL_VELOCITY, -MAX_SCROLL_VELOCITY * ((SCROLL_GUTTER_HEIGHT - (clientY - scrollRectTop)) / SCROLL_GUTTER_HEIGHT));
        }
        else if (clientY > scrollClientBottom) {
            this._scrollVelocity = Math.min(MAX_SCROLL_VELOCITY, MAX_SCROLL_VELOCITY * ((clientY - scrollClientBottom) / SCROLL_GUTTER_HEIGHT));
        }
        else {
            this._scrollVelocity = 0;
        }
        if (this._scrollVelocity) {
            this._startScroll();
        }
        else {
            this._stopScroll();
        }
    };
    AutoScroll.prototype._startScroll = function () {
        if (!this._timeoutId) {
            this._incrementScroll();
        }
    };
    AutoScroll.prototype._incrementScroll = function () {
        if (this._scrollableParent) {
            this._scrollableParent.scrollTop += Math.round(this._scrollVelocity);
        }
        this._timeoutId = setTimeout(this._incrementScroll, SCROLL_ITERATION_DELAY);
    };
    AutoScroll.prototype._stopScroll = function () {
        if (this._timeoutId) {
            clearTimeout(this._timeoutId);
            delete this._timeoutId;
        }
    };
    return AutoScroll;
}());

//# sourceMappingURL=AutoScroll.js.map

/***/ }),
/* 1574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseComponent; });
/* harmony export (immutable) */ __webpack_exports__["b"] = nullRender;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Async__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EventGroup__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__warn_warnConditionallyRequiredProps__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__warn_warnMutuallyExclusive__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__warn_warnDeprecations__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__initializeFocusRects__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__initializeDir__ = __webpack_require__(1575);









/**
 * BaseComponent class, which provides basic helpers for all components.
 *
 * @public
 * {@docCategory BaseComponent}
 */
var BaseComponent = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](BaseComponent, _super);
    // tslint:enable:variable-name
    /**
     * BaseComponent constructor
     * @param props - The props for the component.
     * @param context - The context for the component.
     */
    // tslint:disable-next-line:no-any
    function BaseComponent(props, context) {
        var _this = _super.call(this, props, context) || this;
        // Ensure basic assumptions about the environment.
        Object(__WEBPACK_IMPORTED_MODULE_7__initializeFocusRects__["b" /* initializeFocusRects */])();
        Object(__WEBPACK_IMPORTED_MODULE_8__initializeDir__["a" /* initializeDir */])();
        _makeAllSafe(_this, BaseComponent.prototype, [
            'componentDidMount',
            'shouldComponentUpdate',
            'getSnapshotBeforeUpdate',
            'render',
            'componentDidUpdate',
            'componentWillUnmount'
        ]);
        return _this;
    }
    /**
     * When the component receives props, make sure the componentRef is updated.
     */
    BaseComponent.prototype.componentDidUpdate = function (prevProps, prevState) {
        this._updateComponentRef(prevProps, this.props);
    };
    /**
     * When the component has mounted, update the componentRef.
     */
    BaseComponent.prototype.componentDidMount = function () {
        this._setComponentRef(this.props.componentRef, this);
    };
    /**
     * If we have disposables, dispose them automatically on unmount.
     */
    BaseComponent.prototype.componentWillUnmount = function () {
        this._setComponentRef(this.props.componentRef, null);
        if (this.__disposables) {
            for (var i = 0, len = this._disposables.length; i < len; i++) {
                var disposable = this.__disposables[i];
                if (disposable.dispose) {
                    disposable.dispose();
                }
            }
            this.__disposables = null;
        }
    };
    Object.defineProperty(BaseComponent.prototype, "className", {
        /**
         * Gets the object's class name.
         */
        get: function () {
            if (!this.__className) {
                var funcNameRegex = /function (.{1,})\(/;
                var results = funcNameRegex.exec(this.constructor.toString());
                this.__className = results && results.length > 1 ? results[1] : '';
            }
            return this.__className;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseComponent.prototype, "_disposables", {
        /**
         * Allows subclasses to push things to this._disposables to be auto disposed.
         */
        get: function () {
            if (!this.__disposables) {
                this.__disposables = [];
            }
            return this.__disposables;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseComponent.prototype, "_async", {
        /**
         * Gets the async instance associated with the component, created on demand. The async instance gives
         * subclasses a way to execute setTimeout/setInterval async calls safely, where the callbacks
         * will be cleared/ignored automatically after unmounting. The helpers within the async object also
         * preserve the this pointer so that you don't need to "bind" the callbacks.
         */
        get: function () {
            if (!this.__async) {
                this.__async = new __WEBPACK_IMPORTED_MODULE_2__Async__["a" /* Async */](this);
                this._disposables.push(this.__async);
            }
            return this.__async;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseComponent.prototype, "_events", {
        /**
         * Gets the event group instance assocaited with the component, created on demand. The event instance
         * provides on/off methods for listening to DOM (or regular javascript object) events. The event callbacks
         * will be automatically disconnected after unmounting. The helpers within the events object also
         * preserve the this reference so that you don't need to "bind" the callbacks.
         */
        get: function () {
            if (!this.__events) {
                this.__events = new __WEBPACK_IMPORTED_MODULE_3__EventGroup__["a" /* EventGroup */](this);
                this._disposables.push(this.__events);
            }
            return this.__events;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Helper to return a memoized ref resolver function.
     * @param refName - Name of the member to assign the ref to.
     * @returns A function instance keyed from the given refname.
     * @deprecated Use `createRef` from React.createRef.
     */
    BaseComponent.prototype._resolveRef = function (refName) {
        var _this = this;
        if (!this.__resolves) {
            this.__resolves = {};
        }
        if (!this.__resolves[refName]) {
            // tslint:disable-next-line:no-any
            this.__resolves[refName] = function (ref) {
                // tslint:disable-next-line:no-any
                return (_this[refName] = ref);
            };
        }
        return this.__resolves[refName];
    };
    /**
     * Updates the componentRef (by calling it with "this" when necessary.)
     */
    BaseComponent.prototype._updateComponentRef = function (currentProps, newProps) {
        if (newProps === void 0) { newProps = {}; }
        // currentProps *should* always be defined, but verify that just in case a subclass is manually
        // calling a lifecycle method with no parameters (which has happened) or other odd usage.
        if (currentProps && newProps && currentProps.componentRef !== newProps.componentRef) {
            this._setComponentRef(currentProps.componentRef, null);
            this._setComponentRef(newProps.componentRef, this);
        }
    };
    /**
     * Warns when a deprecated props are being used.
     *
     * @param deprecationMap - The map of deprecations, where key is the prop name and the value is
     * either null or a replacement prop name.
     */
    BaseComponent.prototype._warnDeprecations = function (deprecationMap) {
        Object(__WEBPACK_IMPORTED_MODULE_6__warn_warnDeprecations__["a" /* warnDeprecations */])(this.className, this.props, deprecationMap);
    };
    /**
     * Warns when props which are mutually exclusive with each other are both used.
     *
     * @param mutuallyExclusiveMap - The map of mutually exclusive props.
     */
    BaseComponent.prototype._warnMutuallyExclusive = function (mutuallyExclusiveMap) {
        Object(__WEBPACK_IMPORTED_MODULE_5__warn_warnMutuallyExclusive__["a" /* warnMutuallyExclusive */])(this.className, this.props, mutuallyExclusiveMap);
    };
    /**
     * Warns when props are required if a condition is met.
     *
     * @param requiredProps - The name of the props that are required when the condition is met.
     * @param conditionalPropName - The name of the prop that the condition is based on.
     * @param condition - Whether the condition is met.
     */
    BaseComponent.prototype._warnConditionallyRequiredProps = function (requiredProps, conditionalPropName, condition) {
        Object(__WEBPACK_IMPORTED_MODULE_4__warn_warnConditionallyRequiredProps__["a" /* warnConditionallyRequiredProps */])(this.className, this.props, requiredProps, conditionalPropName, condition);
    };
    BaseComponent.prototype._setComponentRef = function (ref, value) {
        if (!this._skipComponentRefResolution && ref) {
            if (typeof ref === 'function') {
                ref(value);
            }
            if (typeof ref === 'object') {
                // tslint:disable:no-any
                ref.current = value;
            }
        }
    };
    return BaseComponent;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

/**
 * Helper to override a given method with a wrapper method that can try/catch the original, but also
 * ensures that the BaseComponent's methods are called before the subclass's. This ensures that
 * componentWillUnmount in the base is called and that things in the _disposables array are disposed.
 */
function _makeAllSafe(obj, prototype, methodNames) {
    for (var i = 0, len = methodNames.length; i < len; i++) {
        _makeSafe(obj, prototype, methodNames[i]);
    }
}
function _makeSafe(obj, prototype, methodName) {
    // tslint:disable:no-any
    var classMethod = obj[methodName];
    var prototypeMethod = prototype[methodName];
    // tslint:enable:no-any
    if (classMethod || prototypeMethod) {
        // tslint:disable-next-line:no-any
        obj[methodName] = function () {
            var retVal;
            if (prototypeMethod) {
                retVal = prototypeMethod.apply(this, arguments);
            }
            if (classMethod !== prototypeMethod) {
                retVal = classMethod.apply(this, arguments);
            }
            return retVal;
        };
    }
}
/**
 * Simple constant function for returning null, used to render empty templates in JSX.
 *
 * @public
 */
function nullRender() {
    return null;
}
//# sourceMappingURL=BaseComponent.js.map

/***/ }),
/* 1575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initializeDir;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_getWindow__ = __webpack_require__(86);

function initializeDir(win) {
    var w = (win || Object(__WEBPACK_IMPORTED_MODULE_0__dom_getWindow__["a" /* getWindow */])());
    if (w && !w.__hasInitializedDir__) {
        w.__hasInitializedDir__ = true;
        // Ensure that the documentElement has a 'dir' attribute.
        var documentElement = w.document.documentElement;
        if (!documentElement.hasAttribute('dir')) {
            documentElement.setAttribute('dir', 'ltr');
        }
    }
}
//# sourceMappingURL=initializeDir.js.map

/***/ }),
/* 1576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = provideContext;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


/**
 * @deprecated This function uses the legacy context API, which is deprecated and should not be
 * used in new code. Please migrate to the new context API. https://reactjs.org/docs/context.html
 */
function provideContext(contextTypes, mapPropsToContext) {
    var Provider = /** @class */ (function (_super) {
        __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](Provider, _super);
        function Provider() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Provider.prototype.getChildContext = function () {
            return mapPropsToContext(this.props);
        };
        Provider.prototype.render = function () {
            return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
        };
        Provider.childContextTypes = contextTypes;
        return Provider;
    }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
    return Provider;
}
//# sourceMappingURL=Context.js.map

/***/ }),
/* 1577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DelayedRender; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


/**
 * Utility component for delaying the render of a child component after a given delay. This component
 * requires a single child component; don't pass in many components. Wrap multiple components in a DIV
 * if necessary.
 *
 * @public
 * {@docCategory DelayedRender}
 */
var DelayedRender = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](DelayedRender, _super);
    function DelayedRender(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isRendered: false
        };
        return _this;
    }
    DelayedRender.prototype.componentDidMount = function () {
        var _this = this;
        var delay = this.props.delay;
        this._timeoutId = setTimeout(function () {
            _this.setState({
                isRendered: true
            });
        }, delay);
    };
    DelayedRender.prototype.componentWillUnmount = function () {
        if (this._timeoutId) {
            clearTimeout(this._timeoutId);
        }
    };
    DelayedRender.prototype.render = function () {
        return this.state.isRendered ? __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children) : null;
    };
    DelayedRender.defaultProps = {
        delay: 0
    };
    return DelayedRender;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=DelayedRender.js.map

/***/ }),
/* 1578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FabricPerformance */
var now = function () { return (typeof performance !== 'undefined' && !!performance.now ? performance.now() : Date.now()); };
var RESET_INTERVAL = 3 * 60 * 1000; // auto reset every 3 minutes
/**
 * Performance helper class for measuring things.
 *
 * @public
 * {@docCategory FabricPerformance}
 */
var FabricPerformance = /** @class */ (function () {
    function FabricPerformance() {
    }
    /**
     * Measures execution time of the given syncronous function. If the same logic is executed multiple times,
     * each individual measurement will be collected as well the overall numbers.
     * @param name - The name of this measurement
     * @param func - The logic to be measured for execution time
     */
    FabricPerformance.measure = function (name, func) {
        if (FabricPerformance._timeoutId) {
            FabricPerformance.setPeriodicReset();
        }
        var start = now();
        func();
        var end = now();
        var measurement = FabricPerformance.summary[name] || {
            totalDuration: 0,
            count: 0,
            all: []
        };
        var duration = end - start;
        measurement.totalDuration += duration;
        measurement.count++;
        measurement.all.push({
            duration: duration,
            timeStamp: end
        });
        FabricPerformance.summary[name] = measurement;
    };
    FabricPerformance.reset = function () {
        FabricPerformance.summary = {};
        clearTimeout(FabricPerformance._timeoutId);
        FabricPerformance._timeoutId = NaN;
    };
    FabricPerformance.setPeriodicReset = function () {
        FabricPerformance._timeoutId = setTimeout(function () { return FabricPerformance.reset(); }, RESET_INTERVAL);
    };
    FabricPerformance.summary = {};
    return FabricPerformance;
}());

//# sourceMappingURL=FabricPerformance.js.map

/***/ }),
/* 1579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Rectangle; });
/**
 * Rectangle helper class.
 *
 * @public
 * {@docCategory Rectangle}
 */
var Rectangle = /** @class */ (function () {
    function Rectangle(left, right, top, bottom) {
        if (left === void 0) { left = 0; }
        if (right === void 0) { right = 0; }
        if (top === void 0) { top = 0; }
        if (bottom === void 0) { bottom = 0; }
        this.top = top;
        this.bottom = bottom;
        this.left = left;
        this.right = right;
    }
    Object.defineProperty(Rectangle.prototype, "width", {
        /**
         * Calculated automatically by subtracting the right from left
         */
        get: function () {
            return this.right - this.left;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Rectangle.prototype, "height", {
        /**
         * Calculated automatically by subtracting the bottom from top.
         */
        get: function () {
            return this.bottom - this.top;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Tests if another rect is approximately equal to this rect (within 4 decimal places.)
     */
    Rectangle.prototype.equals = function (rect) {
        // I'm fixing it to 4 decimal places because it allows enough precision and will handle cases when something should be rounded,
        // like .999999 should round to 1.
        return (parseFloat(this.top.toFixed(4)) === parseFloat(rect.top.toFixed(4)) &&
            parseFloat(this.bottom.toFixed(4)) === parseFloat(rect.bottom.toFixed(4)) &&
            parseFloat(this.left.toFixed(4)) === parseFloat(rect.left.toFixed(4)) &&
            parseFloat(this.right.toFixed(4)) === parseFloat(rect.right.toFixed(4)));
    };
    return Rectangle;
}());

//# sourceMappingURL=Rectangle.js.map

/***/ }),
/* 1580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mergeAriaAttributeValues;
/**
 * ARIA helper to concatenate attributes, returning undefined if all attributes
 * are undefined. (Empty strings are not a valid ARIA attribute value.)
 *
 * @param ariaAttributes - ARIA attributes to merge
 */
function mergeAriaAttributeValues() {
    var ariaAttributes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        ariaAttributes[_i] = arguments[_i];
    }
    var mergedAttribute = ariaAttributes
        .filter(function (arg) { return arg; })
        .join(' ')
        .trim();
    return mergedAttribute === '' ? undefined : mergedAttribute;
}
//# sourceMappingURL=aria.js.map

/***/ }),
/* 1581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = findIndex;
/* harmony export (immutable) */ __webpack_exports__["c"] = find;
/* unused harmony export createArray */
/* harmony export (immutable) */ __webpack_exports__["f"] = toMatrix;
/* unused harmony export removeIndex */
/* harmony export (immutable) */ __webpack_exports__["e"] = replaceElement;
/* harmony export (immutable) */ __webpack_exports__["a"] = addElementAtIndex;
/* unused harmony export flatten */
/* harmony export (immutable) */ __webpack_exports__["b"] = arraysEqual;
/**
 * Helper to find the index of an item within an array, using a callback to
 * determine the match.
 *
 * @public
 * @param array - Array to search.
 * @param cb - Callback which returns true on matches.
 */
function findIndex(array, cb) {
    var index = -1;
    for (var i = 0; array && i < array.length; i++) {
        if (cb(array[i], i)) {
            index = i;
            break;
        }
    }
    return index;
}
/**
 * Helper to find the first item within an array that satisfies the callback.
 * @param array - Array to search
 * @param cb - Callback which returns true on matches
 */
function find(array, cb) {
    var index = findIndex(array, cb);
    if (index < 0) {
        return undefined;
    }
    return array[index];
}
/**
 * Creates an array of a given size and helper method to populate.
 *
 * @public
 * @param size - Size of array.
 * @param getItem - Callback to populate given cell index.
 */
function createArray(size, getItem) {
    var array = [];
    for (var i = 0; i < size; i++) {
        array.push(getItem(i));
    }
    return array;
}
/**
 * Convert the given array to a matrix with columnCount number
 * of columns.
 *
 * @public
 * @param items - The array to convert
 * @param columnCount - The number of columns for the resulting matrix
 * @returns A matrix of items
 */
function toMatrix(items, columnCount) {
    return items.reduce(function (rows, currentValue, index) {
        if (index % columnCount === 0) {
            rows.push([currentValue]);
        }
        else {
            rows[rows.length - 1].push(currentValue);
        }
        return rows;
    }, []);
}
/**
 * Given an array, it returns a new array that does not contain the item at the given index.
 * @param array - The array to operate on
 * @param index - The index of the element to remove
 */
function removeIndex(array, index) {
    return array.filter(function (_, i) { return index !== i; });
}
/**
 * Given an array, this function returns a new array where the element at a given index has been replaced.
 * @param array - The array to operate on
 * @param newElement - The element that will be placed in the new array
 * @param index - The index of the element that should be replaced
 */
function replaceElement(array, newElement, index) {
    var copy = array.slice();
    copy[index] = newElement;
    return copy;
}
/**
 * Given an array, this function returns a new array where an element has been inserted at the given index.
 * @param array - The array to operate on
 * @param index - The index where an element should be inserted
 * @param itemToAdd - The element to insert
 */
function addElementAtIndex(array, index, itemToAdd) {
    var copy = array.slice();
    copy.splice(index, 0, itemToAdd);
    return copy;
}
/**
 * Given an array where each element is of type T or T[], flatten it into an array of T
 * @param array - The array where each element can optionally also be an array
 */
function flatten(array) {
    var result = [];
    array.forEach(function (item) { return (result = result.concat(item)); });
    return result;
}
/**
 * Returns a boolean indicating if the two given arrays are equal in length and values.
 *
 * @param array1 - First array to compare
 * @param array2 - Second array to compare
 * @returns True if the arrays are the same length and have the same values in the same positions, false otherwise.
 */
function arraysEqual(array1, array2) {
    if (array1.length !== array2.length) {
        return false;
    }
    for (var i = 0; i < array1.length; i++) {
        if (array1[i] !== array2[i]) {
            return false;
        }
    }
    return true;
}
//# sourceMappingURL=array.js.map

/***/ }),
/* 1582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export asAsync */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/**
 * asAsync - a HOC for async loading components.
 *
 * Usage:
 *
 * const AsyncDialog = asAsync({
 *   load: () => import('Dialog').then(result => result.default),
 * });
 *
 * React.render(domElement, <AsyncDialog asyncPlaceholder={ () => <Spinner/> } { ...dialogProps } />);
 *
 * Note the `asyncPlaceholder` prop will be respected when rendering the async component and it hasn't
 * been loaded yet.
 */


/**
 * If possible, use a WeakMap to maintain a cache of loaded components.
 * This can be used to synchronously render components that have already been loaded,
 * rather than having to wait for at least one async tick.
 */
var _syncModuleCache = typeof WeakMap !== 'undefined'
    ? // tslint:disable-next-line:no-any
        new WeakMap()
    : undefined;
/**
 * Produces a component which internally loads the target component before first mount.
 * The component passes all props through to the loaded component.
 *
 * This overload accepts a module with a default export for the component.
 */
function asAsync(options) {
    var Async = /** @class */ (function (_super) {
        __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](Async, _super);
        function Async() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.state = {
                Component: _syncModuleCache ? _syncModuleCache.get(options.load) : undefined
            };
            return _this;
        }
        Async.prototype.render = function () {
            // Typescript issue: the rest can't be pulled without the any cast, as TypeScript fails with rest on generics.
            // tslint:disable-next-line:no-any
            var _a = this.props, forwardedRef = _a.forwardedRef, Placeholder = _a.asyncPlaceholder, rest = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __rest */](_a, ["forwardedRef", "asyncPlaceholder"]);
            var Component = this.state.Component;
            return Component ? __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Component, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ ref: forwardedRef }, rest)) : Placeholder ? __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Placeholder, null) : null;
        };
        Async.prototype.componentDidMount = function () {
            var _this = this;
            var Component = this.state.Component;
            if (!Component) {
                options
                    .load()
                    .then(function (LoadedComponent) {
                    if (LoadedComponent) {
                        // Cache component for future reference.
                        _syncModuleCache && _syncModuleCache.set(options.load, LoadedComponent);
                        // Set state.
                        _this.setState({
                            Component: LoadedComponent
                        }, options.onLoad);
                    }
                })
                    .catch(options.onError);
            }
        };
        return Async;
    }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
    return __WEBPACK_IMPORTED_MODULE_1_react__["forwardRef"](function (props, ref) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Async, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, props, { forwardedRef: ref }))); });
}
//# sourceMappingURL=asAsync.js.map

/***/ }),
/* 1583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = assertNever;
/**
 * AssertNever is a utility function that can be used for exhaustiveness checks in switch statements.
 *
 * @public
 */
function assertNever(x) {
    throw new Error('Unexpected object: ' + x);
}
//# sourceMappingURL=assertNever.js.map

/***/ }),
/* 1584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = autobind;
/**
 * Autobind is a utility for binding methods in a class. This simplifies tagging methods as being "bound" to the this pointer
 * so that they can be used in scenarios that simply require a function callback.
 * @deprecated This has been deprecated in favor of using arrow function properties
 */
function autobind(
// tslint:disable-next-line:no-any
target, key, descriptor) {
    var fn = descriptor.value;
    var defining = false;
    return {
        configurable: true,
        get: function () {
            if (defining || (fn && this === fn.prototype) || this.hasOwnProperty(key)) {
                return fn;
            }
            // Bind method only once, and update the property to return the bound value from now on
            var fnBound = fn && fn.bind(this);
            defining = true;
            Object.defineProperty(this, key, {
                configurable: true,
                writable: true,
                enumerable: true,
                value: fnBound
            });
            defining = false;
            return fnBound;
        },
        // tslint:disable-next-line:no-any
        set: function (newValue) {
            Object.defineProperty(this, key, {
                configurable: true,
                writable: true,
                enumerable: true,
                value: newValue
            });
        }
    };
}
//# sourceMappingURL=autobind.js.map

/***/ }),
/* 1585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = classNamesFunction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uifabric_merge_styles__ = __webpack_require__(46);

var MAX_CACHE_COUNT = 50;
var _memoizedClassNames = 0;
var stylesheet = __WEBPACK_IMPORTED_MODULE_0__uifabric_merge_styles__["a" /* Stylesheet */].getInstance();
if (stylesheet && stylesheet.onReset) {
    stylesheet.onReset(function () { return _memoizedClassNames++; });
}
// Note that because of the caching nature within the classNames memoization,
// I've disabled this rule to simply be able to work with any types.
// tslint:disable:no-any
// This represents a prop we attach to each Map to indicate the cached return value
// associated with the graph node.
var RetVal = '__retval__';
/**
 * Creates a getClassNames function which calls getStyles given the props, and injects them
 * into mergeStyleSets.
 *
 * Note that the props you pass in on every render should be in the same order and
 * immutable (numbers, strings, and booleans). This will allow the results to be memoized. Violating
 * these will cause extra recalcs to occur.
 */
function classNamesFunction(options) {
    // We build a trie where each node is a Map. The map entry key represents an argument
    // value, and the entry value is another node (Map). Each node has a `__retval__`
    // property which is used to hold the cached response.
    if (options === void 0) { options = {}; }
    // To derive the response, we can simply ensure the arguments are added or already
    // exist in the trie. At the last node, if there is a `__retval__` we return that. Otherwise
    // we call the `getStyles` api to evaluate, cache on the property, and return that.
    var map = new Map();
    var resultCount = 0;
    var currentMemoizedClassNames = _memoizedClassNames;
    var getClassNames = function (styleFunctionOrObject, styleProps) {
        if (styleProps === void 0) { styleProps = {}; }
        var current = map;
        var disableCaching = options.disableCaching;
        // On reset of our stylesheet, reset memoized cache.
        if (currentMemoizedClassNames !== _memoizedClassNames) {
            currentMemoizedClassNames = _memoizedClassNames;
            map = new Map();
            resultCount = 0;
        }
        if (!options.disableCaching) {
            current = _traverseMap(map, styleFunctionOrObject);
            current = _traverseMap(current, styleProps);
        }
        if (disableCaching || !current[RetVal]) {
            if (styleFunctionOrObject === undefined) {
                current[RetVal] = {};
            }
            else {
                current[RetVal] = Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_merge_styles__["e" /* mergeStyleSets */])(typeof styleFunctionOrObject === 'function' ? styleFunctionOrObject(styleProps) : styleFunctionOrObject);
            }
            if (!disableCaching) {
                resultCount++;
            }
        }
        if (resultCount > MAX_CACHE_COUNT) {
            map.clear();
            resultCount = 0;
            // Mutate the options passed in, that's all we can do.
            options.disableCaching = true;
            // Note: this code is great for debugging problems with styles being recaculated, but commenting it out
            // to avoid confusing consumers.
            // if (process.env.NODE_ENV !== 'production') {
            //  console.log('Styles are being recalculated far too frequently. Something is mutating the class over and over.');
            //  // tslint:disable-next-line:no-console
            //  console.trace();
            // }
        }
        // Note: the RetVal is an attached property on the Map; not a key in the Map. We use this attached property to
        // cache the return value for this branch of the graph.
        return current[RetVal];
    };
    return getClassNames;
}
function _derive(obj) {
    return typeof obj === 'function' ? obj(this) : obj;
}
function _traverseEdge(current, value) {
    value = _normalizeValue(value);
    if (!current.has(value)) {
        current.set(value, new Map());
    }
    return current.get(value);
}
function _traverseMap(current, inputs) {
    // The styled helper will generate the styles function and will attach the cached
    // inputs (consisting of the default styles, customzied styles, and user provided styles.)
    // These should be used as cache keys for deriving the memoized value.
    if (typeof inputs === 'function' && inputs.__cachedInputs__) {
        for (var _i = 0, _a = inputs.__cachedInputs__; _i < _a.length; _i++) {
            var input = _a[_i];
            current = _traverseEdge(current, input);
        }
    }
    else if (typeof inputs === 'object') {
        for (var propName in inputs) {
            if (inputs.hasOwnProperty(propName)) {
                current = _traverseEdge(current, inputs[propName]);
            }
        }
    }
    return current;
}
function _normalizeValue(value) {
    switch (value) {
        case undefined:
            return '__undefined__';
        case null:
            return '__null__';
        default:
            return value;
    }
}
//# sourceMappingURL=classNamesFunction.js.map

/***/ }),
/* 1586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRef;
/**
 * @deprecated Use React.createRef.
 * May be removed in 6 months (Jan '19).
 */
function createRef() {
    var refObject = (function (element) {
        refObject.current = element;
    });
    // This getter is here to support the deprecated value prop on the refObject.
    Object.defineProperty(refObject, 'value', {
        get: function () {
            return refObject.current;
        }
    });
    refObject.current = null;
    return refObject;
}
//# sourceMappingURL=createRef.js.map

/***/ }),
/* 1587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = css;
/**
 * Concatination helper, which can merge class names together. Skips over falsey values.
 *
 * @public
 */
function css() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var classes = [];
    for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
        var arg = args_1[_a];
        if (arg) {
            if (typeof arg === 'string') {
                classes.push(arg);
            }
            else if (arg.hasOwnProperty('toString') && typeof arg.toString === 'function') {
                classes.push(arg.toString());
            }
            else {
                // tslint:disable-next-line:no-any
                for (var key in arg) {
                    // tslint:disable-next-line:no-any
                    if (arg[key]) {
                        classes.push(key);
                    }
                }
            }
        }
    }
    return classes.join(' ');
}
//# sourceMappingURL=css.js.map

/***/ }),
/* 1588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Customizer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Customizations__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CustomizerContext__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeCustomizations__ = __webpack_require__(645);





/**
 * The Customizer component allows for default props to be mixed into components which
 * are decorated with the customizable() decorator, or use the styled HOC. This enables
 * injection scenarios like:
 *
 * 1. render svg icons instead of the icon font within all buttons
 * 2. inject a custom theme object into a component
 *
 * Props are provided via the settings prop which should be one of the following:
 * - A json map which contains 1 or more name/value pairs representing injectable props.
 * - A function that receives the current settings and returns the new ones that apply to the scope
 *
 * @public
 */
var Customizer = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](Customizer, _super);
    function Customizer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onCustomizationChange = function () { return _this.forceUpdate(); };
        return _this;
    }
    Customizer.prototype.componentDidMount = function () {
        __WEBPACK_IMPORTED_MODULE_2__Customizations__["a" /* Customizations */].observe(this._onCustomizationChange);
    };
    Customizer.prototype.componentWillUnmount = function () {
        __WEBPACK_IMPORTED_MODULE_2__Customizations__["a" /* Customizations */].unobserve(this._onCustomizationChange);
    };
    Customizer.prototype.render = function () {
        var _this = this;
        var contextTransform = this.props.contextTransform;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__CustomizerContext__["a" /* CustomizerContext */].Consumer, null, function (parentContext) {
            var newContext = Object(__WEBPACK_IMPORTED_MODULE_4__mergeCustomizations__["a" /* mergeCustomizations */])(_this.props, parentContext);
            if (contextTransform) {
                newContext = contextTransform(newContext);
            }
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__CustomizerContext__["a" /* CustomizerContext */].Provider, { value: newContext }, _this.props.children);
        }));
    };
    return Customizer;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=Customizer.js.map

/***/ }),
/* 1589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = customizable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Customizations__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hoistStatics__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CustomizerContext__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__uifabric_merge_styles__ = __webpack_require__(46);






function customizable(scope, fields, concatStyles
// tslint:disable-next-line:no-any
) {
    // tslint:disable-next-line:no-shadowed-variable
    return function customizableFactory(
    // tslint:disable-next-line:no-any
    ComposedComponent
    // tslint:disable-next-line:no-any
    ) {
        var resultClass = (_a = /** @class */ (function (_super) {
                __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ComponentWithInjectedProps, _super);
                // tslint:disable-next-line:no-any
                function ComponentWithInjectedProps(props) {
                    var _this = _super.call(this, props) || this;
                    _this._onSettingChanged = _this._onSettingChanged.bind(_this);
                    return _this;
                }
                ComponentWithInjectedProps.prototype.componentDidMount = function () {
                    __WEBPACK_IMPORTED_MODULE_2__Customizations__["a" /* Customizations */].observe(this._onSettingChanged);
                };
                ComponentWithInjectedProps.prototype.componentWillUnmount = function () {
                    __WEBPACK_IMPORTED_MODULE_2__Customizations__["a" /* Customizations */].unobserve(this._onSettingChanged);
                };
                ComponentWithInjectedProps.prototype.render = function () {
                    var _this = this;
                    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__CustomizerContext__["a" /* CustomizerContext */].Consumer, null, function (context) {
                        var defaultProps = __WEBPACK_IMPORTED_MODULE_2__Customizations__["a" /* Customizations */].getSettings(fields, scope, context.customizations);
                        // tslint:disable-next-line:no-any
                        var componentProps = _this.props;
                        // If defaultProps.styles is a function, evaluate it before calling concatStyleSets
                        if (defaultProps.styles && typeof defaultProps.styles === 'function') {
                            defaultProps.styles = defaultProps.styles(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, defaultProps, componentProps));
                        }
                        // If concatStyles is true and custom styles have been defined compute those styles
                        if (concatStyles && (defaultProps.styles || componentProps.styles)) {
                            var mergedStyles = Object(__WEBPACK_IMPORTED_MODULE_5__uifabric_merge_styles__["b" /* concatStyleSets */])(defaultProps.styles, componentProps.styles);
                            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ComposedComponent, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, defaultProps, componentProps, { styles: mergedStyles }));
                        }
                        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ComposedComponent, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, defaultProps, componentProps));
                    }));
                };
                ComponentWithInjectedProps.prototype._onSettingChanged = function () {
                    this.forceUpdate();
                };
                return ComponentWithInjectedProps;
            }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"])),
            _a.displayName = 'Customized' + scope,
            _a);
        return Object(__WEBPACK_IMPORTED_MODULE_3__hoistStatics__["a" /* hoistStatics */])(ComposedComponent, resultClass);
        var _a;
    };
}
//# sourceMappingURL=customizable.js.map

/***/ }),
/* 1590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_elementContains__ = __webpack_require__(648);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__dom_elementContains__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_elementContainsAttribute__ = __webpack_require__(650);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dom_findElementRecursive__ = __webpack_require__(386);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__dom_findElementRecursive__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dom_getChildren__ = __webpack_require__(1591);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dom_getDocument__ = __webpack_require__(176);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__dom_getDocument__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dom_getParent__ = __webpack_require__(262);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__dom_getParent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dom_getRect__ = __webpack_require__(637);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_6__dom_getRect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dom_getVirtualParent__ = __webpack_require__(649);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dom_getWindow__ = __webpack_require__(86);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_8__dom_getWindow__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dom_isVirtualElement__ = __webpack_require__(385);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dom_on__ = __webpack_require__(1592);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_10__dom_on__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dom_portalContainsElement__ = __webpack_require__(1593);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_11__dom_portalContainsElement__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__dom_raiseClick__ = __webpack_require__(1594);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_12__dom_raiseClick__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__dom_setPortalAttribute__ = __webpack_require__(651);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_13__dom_setPortalAttribute__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__dom_setVirtualParent__ = __webpack_require__(1595);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_14__dom_setVirtualParent__["a"]; });















//# sourceMappingURL=dom.js.map

/***/ }),
/* 1591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getChildren */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isVirtualElement__ = __webpack_require__(385);

/**
 * Gets the elements which are child elements of the given element.
 * If `allowVirtualChildren` is `true`, this method enumerates virtual child elements
 * after the original children.
 * @param parent - The element to get the children of.
 * @param allowVirtualChildren - true if the method should enumerate virtual child elements.
 */
function getChildren(parent, allowVirtualChildren) {
    if (allowVirtualChildren === void 0) { allowVirtualChildren = true; }
    var children = [];
    if (parent) {
        for (var i = 0; i < parent.children.length; i++) {
            children.push(parent.children.item(i));
        }
        if (allowVirtualChildren && Object(__WEBPACK_IMPORTED_MODULE_0__isVirtualElement__["a" /* isVirtualElement */])(parent)) {
            children.push.apply(children, parent._virtual.children);
        }
    }
    return children;
}
//# sourceMappingURL=getChildren.js.map

/***/ }),
/* 1592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = on;
function on(element, eventName, callback, options) {
    element.addEventListener(eventName, callback, options);
    return function () { return element.removeEventListener(eventName, callback, options); };
}
//# sourceMappingURL=on.js.map

/***/ }),
/* 1593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = portalContainsElement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__findElementRecursive__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setPortalAttribute__ = __webpack_require__(651);


/**
 * Determine whether a target is within a portal from perspective of root or optional parent.
 * This function only works against portal components that use the setPortalAttribute function.
 * If both parent and child are within the same portal this function will return false.
 * @param target - Element to query portal containment status of.
 * @param parent - Optional parent perspective. Search for containing portal stops at parent (or root if parent is undefined or invalid.)
 */
function portalContainsElement(target, parent) {
    var elementMatch = Object(__WEBPACK_IMPORTED_MODULE_0__findElementRecursive__["a" /* findElementRecursive */])(target, function (testElement) { return parent === testElement || testElement.hasAttribute(__WEBPACK_IMPORTED_MODULE_1__setPortalAttribute__["a" /* DATA_PORTAL_ATTRIBUTE */]); });
    return elementMatch !== null && elementMatch.hasAttribute(__WEBPACK_IMPORTED_MODULE_1__setPortalAttribute__["a" /* DATA_PORTAL_ATTRIBUTE */]);
}
//# sourceMappingURL=portalContainsElement.js.map

/***/ }),
/* 1594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = raiseClick;
/** Raises a click event. */
function raiseClick(target) {
    var event = createNewEvent('MouseEvents');
    event.initEvent('click', true, true);
    target.dispatchEvent(event);
}
function createNewEvent(eventName) {
    var event;
    if (typeof Event === 'function') {
        // Chrome, Opera, Firefox
        event = new Event(eventName);
    }
    else {
        // IE
        event = document.createEvent('Event');
        event.initEvent(eventName, true, true);
    }
    return event;
}
//# sourceMappingURL=raiseClick.js.map

/***/ }),
/* 1595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setVirtualParent;
/**
 * Sets the virtual parent of an element.
 * Pass `undefined` as the `parent` to clear the virtual parent.
 *
 * @public
 */
function setVirtualParent(child, parent) {
    var virtualChild = child;
    var virtualParent = parent;
    if (!virtualChild._virtual) {
        virtualChild._virtual = {
            children: []
        };
    }
    var oldParent = virtualChild._virtual.parent;
    if (oldParent && oldParent !== parent) {
        // Remove the child from its old parent.
        var index = oldParent._virtual.children.indexOf(virtualChild);
        if (index > -1) {
            oldParent._virtual.children.splice(index, 1);
        }
    }
    virtualChild._virtual.parent = virtualParent || undefined;
    if (virtualParent) {
        if (!virtualParent._virtual) {
            virtualParent._virtual = {
                children: []
            };
        }
        virtualParent._virtual.children.push(virtualChild);
    }
}
//# sourceMappingURL=setVirtualParent.js.map

/***/ }),
/* 1596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = getFirstFocusable;
/* harmony export (immutable) */ __webpack_exports__["h"] = getLastFocusable;
/* harmony export (immutable) */ __webpack_exports__["f"] = getFirstTabbable;
/* harmony export (immutable) */ __webpack_exports__["i"] = getLastTabbable;
/* harmony export (immutable) */ __webpack_exports__["c"] = focusFirstChild;
/* harmony export (immutable) */ __webpack_exports__["k"] = getPreviousElement;
/* harmony export (immutable) */ __webpack_exports__["j"] = getNextElement;
/* unused harmony export isElementVisible */
/* harmony export (immutable) */ __webpack_exports__["n"] = isElementTabbable;
/* harmony export (immutable) */ __webpack_exports__["m"] = isElementFocusZone;
/* harmony export (immutable) */ __webpack_exports__["l"] = isElementFocusSubZone;
/* harmony export (immutable) */ __webpack_exports__["a"] = doesElementContainFocus;
/* harmony export (immutable) */ __webpack_exports__["o"] = shouldWrapFocus;
/* harmony export (immutable) */ __webpack_exports__["b"] = focusAsync;
/* harmony export (immutable) */ __webpack_exports__["g"] = getFocusableByIndexPath;
/* harmony export (immutable) */ __webpack_exports__["d"] = getElementIndexPath;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_elementContainsAttribute__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_elementContains__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dom_getParent__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dom_getWindow__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dom_getDocument__ = __webpack_require__(176);





var IS_FOCUSABLE_ATTRIBUTE = 'data-is-focusable';
var IS_VISIBLE_ATTRIBUTE = 'data-is-visible';
var FOCUSZONE_ID_ATTRIBUTE = 'data-focuszone-id';
var FOCUSZONE_SUB_ATTRIBUTE = 'data-is-sub-focuszone';
/**
 * Gets the first focusable element.
 *
 * @public
 */
function getFirstFocusable(rootElement, currentElement, includeElementsInFocusZones) {
    return getNextElement(rootElement, currentElement, true /*checkNode*/, false /*suppressParentTraversal*/, false /*suppressChildTraversal*/, includeElementsInFocusZones);
}
/**
 * Gets the last focusable element.
 *
 * @public
 */
function getLastFocusable(rootElement, currentElement, includeElementsInFocusZones) {
    return getPreviousElement(rootElement, currentElement, true /*checkNode*/, false /*suppressParentTraversal*/, true /*traverseChildren*/, includeElementsInFocusZones);
}
/**
 * Gets the first tabbable element.
 * The difference between focusable and tabbable is that tabbable elements are focusable elements that also have tabIndex != -1.
 * @param rootElement - The parent element to search beneath.
 * @param currentElement - The descendant of rootElement to start the search at.  This element is the first one checked,
 * and iteration continues forward.  Typical use passes rootElement.firstChild.
 * @param includeElementsInFocusZones - true if traversal should go into FocusZone descendants.
 * @param checkNode - Include currentElement in search when true. Defaults to true.
 * @public
 */
function getFirstTabbable(rootElement, currentElement, includeElementsInFocusZones, checkNode) {
    if (checkNode === void 0) { checkNode = true; }
    return getNextElement(rootElement, currentElement, checkNode, false /*suppressParentTraversal*/, false /*suppressChildTraversal*/, includeElementsInFocusZones, false /*allowFocusRoot*/, true /*tabbable*/);
}
/**
 * Gets the last tabbable element.
 * The difference between focusable and tabbable is that tabbable elements are focusable elements that also have tabIndex != -1.
 * @param rootElement - The parent element to search beneath.
 * @param currentElement - The descendant of rootElement to start the search at.  This element is the first one checked,
 * and iteration continues in reverse.  Typical use passes rootElement.lastChild.
 * @param includeElementsInFocusZones - true if traversal should go into FocusZone descendants.
 * @param checkNode - Include currentElement in search when true. Defaults to true.
 * @public
 */
function getLastTabbable(rootElement, currentElement, includeElementsInFocusZones, checkNode) {
    if (checkNode === void 0) { checkNode = true; }
    return getPreviousElement(rootElement, currentElement, checkNode, false /*suppressParentTraversal*/, true /*traverseChildren*/, includeElementsInFocusZones, false /*allowFocusRoot*/, true /*tabbable*/);
}
/**
 * Attempts to focus the first focusable element that is a child or child's child of the rootElement.
 *
 * @public
 * @param rootElement - Element to start the search for a focusable child.
 * @returns True if focus was set, false if it was not.
 */
function focusFirstChild(rootElement) {
    var element = getNextElement(rootElement, rootElement, true, false, false, true);
    if (element) {
        focusAsync(element);
        return true;
    }
    return false;
}
/**
 * Traverse to find the previous element.
 * If tabbable is true, the element must have tabIndex != -1.
 *
 * @public
 */
function getPreviousElement(rootElement, currentElement, checkNode, suppressParentTraversal, traverseChildren, includeElementsInFocusZones, allowFocusRoot, tabbable) {
    if (!currentElement || (!allowFocusRoot && currentElement === rootElement)) {
        return null;
    }
    var isCurrentElementVisible = isElementVisible(currentElement);
    // Check its children.
    if (traverseChildren &&
        isCurrentElementVisible &&
        (includeElementsInFocusZones || !(isElementFocusZone(currentElement) || isElementFocusSubZone(currentElement)))) {
        var childMatch = getPreviousElement(rootElement, currentElement.lastElementChild, true, true, true, includeElementsInFocusZones, allowFocusRoot, tabbable);
        if (childMatch) {
            if ((tabbable && isElementTabbable(childMatch, true)) || !tabbable) {
                return childMatch;
            }
            var childMatchSiblingMatch = getPreviousElement(rootElement, childMatch.previousElementSibling, true, true, true, includeElementsInFocusZones, allowFocusRoot, tabbable);
            if (childMatchSiblingMatch) {
                return childMatchSiblingMatch;
            }
            var childMatchParent = childMatch.parentElement;
            // At this point if we have not found any potential matches
            // start looking at the rest of the subtree under the currentParent.
            // NOTE: We do not want to recurse here because doing so could
            // cause elements to get skipped.
            while (childMatchParent && childMatchParent !== currentElement) {
                var childMatchParentMatch = getPreviousElement(rootElement, childMatchParent.previousElementSibling, true, true, true, includeElementsInFocusZones, allowFocusRoot, tabbable);
                if (childMatchParentMatch) {
                    return childMatchParentMatch;
                }
                childMatchParent = childMatchParent.parentElement;
            }
        }
    }
    // Check the current node, if it's not the first traversal.
    if (checkNode && isCurrentElementVisible && isElementTabbable(currentElement, tabbable)) {
        return currentElement;
    }
    // Check its previous sibling.
    var siblingMatch = getPreviousElement(rootElement, currentElement.previousElementSibling, true, true, true, includeElementsInFocusZones, allowFocusRoot, tabbable);
    if (siblingMatch) {
        return siblingMatch;
    }
    // Check its parent.
    if (!suppressParentTraversal) {
        return getPreviousElement(rootElement, currentElement.parentElement, true, false, false, includeElementsInFocusZones, allowFocusRoot, tabbable);
    }
    return null;
}
/**
 * Traverse to find the next focusable element.
 * If tabbable is true, the element must have tabIndex != -1.
 *
 * @public
 * @param checkNode - Include currentElement in search when true.
 */
function getNextElement(rootElement, currentElement, checkNode, suppressParentTraversal, suppressChildTraversal, includeElementsInFocusZones, allowFocusRoot, tabbable) {
    if (!currentElement || (currentElement === rootElement && suppressChildTraversal && !allowFocusRoot)) {
        return null;
    }
    var isCurrentElementVisible = isElementVisible(currentElement);
    // Check the current node, if it's not the first traversal.
    if (checkNode && isCurrentElementVisible && isElementTabbable(currentElement, tabbable)) {
        return currentElement;
    }
    // Check its children.
    if (!suppressChildTraversal &&
        isCurrentElementVisible &&
        (includeElementsInFocusZones || !(isElementFocusZone(currentElement) || isElementFocusSubZone(currentElement)))) {
        var childMatch = getNextElement(rootElement, currentElement.firstElementChild, true, true, false, includeElementsInFocusZones, allowFocusRoot, tabbable);
        if (childMatch) {
            return childMatch;
        }
    }
    if (currentElement === rootElement) {
        return null;
    }
    // Check its sibling.
    var siblingMatch = getNextElement(rootElement, currentElement.nextElementSibling, true, true, false, includeElementsInFocusZones, allowFocusRoot, tabbable);
    if (siblingMatch) {
        return siblingMatch;
    }
    if (!suppressParentTraversal) {
        return getNextElement(rootElement, currentElement.parentElement, false, false, true, includeElementsInFocusZones, allowFocusRoot, tabbable);
    }
    return null;
}
/**
 * Determines if an element is visible.
 *
 * @public
 */
function isElementVisible(element) {
    // If the element is not valid, return false.
    if (!element || !element.getAttribute) {
        return false;
    }
    var visibilityAttribute = element.getAttribute(IS_VISIBLE_ATTRIBUTE);
    // If the element is explicitly marked with the visibility attribute, return that value as boolean.
    if (visibilityAttribute !== null && visibilityAttribute !== undefined) {
        return visibilityAttribute === 'true';
    }
    // Fallback to other methods of determining actual visibility.
    return (element.offsetHeight !== 0 ||
        element.offsetParent !== null ||
        // tslint:disable-next-line:no-any
        element.isVisible === true); // used as a workaround for testing.
}
/**
 * Determines if an element can receive focus programmatically or via a mouse click.
 * If checkTabIndex is true, additionally checks to ensure the element can be focused with the tab key, meaning tabIndex != -1.
 *
 * @public
 */
function isElementTabbable(element, checkTabIndex) {
    // If this element is null or is disabled, it is not considered tabbable.
    if (!element || element.disabled) {
        return false;
    }
    var tabIndex = 0;
    var tabIndexAttributeValue = null;
    if (element && element.getAttribute) {
        tabIndexAttributeValue = element.getAttribute('tabIndex');
        if (tabIndexAttributeValue) {
            tabIndex = parseInt(tabIndexAttributeValue, 10);
        }
    }
    var isFocusableAttribute = element.getAttribute ? element.getAttribute(IS_FOCUSABLE_ATTRIBUTE) : null;
    var isTabIndexSet = tabIndexAttributeValue !== null && tabIndex >= 0;
    var result = !!element &&
        isFocusableAttribute !== 'false' &&
        (element.tagName === 'A' ||
            element.tagName === 'BUTTON' ||
            element.tagName === 'INPUT' ||
            element.tagName === 'TEXTAREA' ||
            isFocusableAttribute === 'true' ||
            isTabIndexSet);
    return checkTabIndex ? tabIndex !== -1 && result : result;
}
/**
 * Determines if a given element is a focus zone.
 *
 * @public
 */
function isElementFocusZone(element) {
    return !!(element && element.getAttribute && !!element.getAttribute(FOCUSZONE_ID_ATTRIBUTE));
}
/**
 * Determines if a given element is a focus sub zone.
 *
 * @public
 */
function isElementFocusSubZone(element) {
    return !!(element && element.getAttribute && element.getAttribute(FOCUSZONE_SUB_ATTRIBUTE) === 'true');
}
/**
 * Determines if an element, or any of its children, contain focus.
 *
 * @public
 */
function doesElementContainFocus(element) {
    var document = Object(__WEBPACK_IMPORTED_MODULE_4__dom_getDocument__["a" /* getDocument */])(element);
    var currentActiveElement = document && document.activeElement;
    if (currentActiveElement && Object(__WEBPACK_IMPORTED_MODULE_1__dom_elementContains__["a" /* elementContains */])(element, currentActiveElement)) {
        return true;
    }
    return false;
}
/**
 * Determines if an, or any of its ancestors, sepcificies that it doesn't want focus to wrap
 * @param element - element to start searching from
 * @param noWrapDataAttribute - the no wrap data attribute to match (either)
 * @returns true if focus should wrap, false otherwise
 */
function shouldWrapFocus(element, noWrapDataAttribute) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__dom_elementContainsAttribute__["a" /* elementContainsAttribute */])(element, noWrapDataAttribute) === 'true' ? false : true;
}
var targetToFocusOnNextRepaint = undefined;
/**
 * Sets focus to an element asynchronously. The focus will be set at the next browser repaint,
 * meaning it won't cause any extra recalculations. If more than one focusAsync is called during one frame,
 * only the latest called focusAsync element will actually be focused
 * @param element - The element to focus
 */
function focusAsync(element) {
    if (element) {
        // An element was already queued to be focused, so replace that one with the new element
        if (targetToFocusOnNextRepaint) {
            targetToFocusOnNextRepaint = element;
            return;
        }
        targetToFocusOnNextRepaint = element;
        var win = Object(__WEBPACK_IMPORTED_MODULE_3__dom_getWindow__["a" /* getWindow */])(element);
        if (win) {
            // element.focus() is a no-op if the element is no longer in the DOM, meaning this is always safe
            win.requestAnimationFrame(function () {
                targetToFocusOnNextRepaint && targetToFocusOnNextRepaint.focus();
                // We are done focusing for this frame, so reset the queued focus element
                targetToFocusOnNextRepaint = undefined;
            });
        }
    }
}
/**
 * Finds the closest focusable element via an index path from a parent. See
 * `getElementIndexPath` for getting an index path from an element to a child.
 */
function getFocusableByIndexPath(parent, path) {
    var element = parent;
    for (var _i = 0, path_1 = path; _i < path_1.length; _i++) {
        var index = path_1[_i];
        var nextChild = element.children[Math.min(index, element.children.length - 1)];
        if (!nextChild) {
            break;
        }
        element = nextChild;
    }
    element =
        isElementTabbable(element) && isElementVisible(element)
            ? element
            : getNextElement(parent, element, true) || getPreviousElement(parent, element);
    return element;
}
/**
 * Finds the element index path from a parent element to a child element.
 *
 * If you had this node structure: "A has children [B, C] and C has child D",
 * the index path from A to D would be [1, 0], or `parent.chidren[1].children[0]`.
 */
function getElementIndexPath(fromElement, toElement) {
    var path = [];
    while (toElement && fromElement && toElement !== fromElement) {
        var parent_1 = Object(__WEBPACK_IMPORTED_MODULE_2__dom_getParent__["a" /* getParent */])(toElement, true);
        if (parent_1 === null) {
            return [];
        }
        path.unshift(Array.prototype.indexOf.call(parent_1.children, toElement));
        toElement = parent_1;
    }
    return path;
}
//# sourceMappingURL=focus.js.map

/***/ }),
/* 1597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hoistMethods;
/* harmony export (immutable) */ __webpack_exports__["b"] = unhoistMethods;
var REACT_LIFECYCLE_EXCLUSIONS = [
    'setState',
    'render',
    'componentWillMount',
    'UNSAFE_componentWillMount',
    'componentDidMount',
    'componentWillReceiveProps',
    'UNSAFE_componentWillReceiveProps',
    'shouldComponentUpdate',
    'componentWillUpdate',
    'getSnapshotBeforeUpdate',
    'UNSAFE_componentWillUpdate',
    'componentDidUpdate',
    'componentWillUnmount'
];
/**
 * Allows you to hoist methods, except those in an exclusion set from a source object into a destination object.
 *
 * @public
 * @param destination - The instance of the object to hoist the methods onto.
 * @param source - The instance of the object where the methods are hoisted from.
 * @param exclusions - (Optional) What methods to exclude from being hoisted.
 * @returns An array of names of methods that were hoisted.
 */
function hoistMethods(
// tslint:disable-next-line:no-any
destination, 
// tslint:disable-next-line:no-any
source, exclusions) {
    if (exclusions === void 0) { exclusions = REACT_LIFECYCLE_EXCLUSIONS; }
    var hoisted = [];
    var _loop_1 = function (methodName) {
        if (typeof source[methodName] === 'function' &&
            destination[methodName] === undefined &&
            (!exclusions || exclusions.indexOf(methodName) === -1)) {
            hoisted.push(methodName);
            /* tslint:disable:no-function-expression */
            destination[methodName] = function () {
                source[methodName].apply(source, arguments);
            };
            /* tslint:enable */
        }
    };
    for (var methodName in source) {
        _loop_1(methodName);
    }
    return hoisted;
}
/**
 * Provides a method for convenience to unhoist hoisted methods.
 *
 * @public
 * @param source - The source object upon which methods were hoisted.
 * @param methodNames - An array of method names to unhoist.
 */
// tslint:disable-next-line:no-any
function unhoistMethods(source, methodNames) {
    methodNames.forEach(function (methodName) { return delete source[methodName]; });
}
//# sourceMappingURL=hoist.js.map

/***/ }),
/* 1598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initializeComponentRef;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__extendComponent__ = __webpack_require__(263);

/**
 * Helper to manage componentRef resolution. Internally appends logic to
 * lifetime methods to resolve componentRef to the passed in object.
 *
 * Usage: call initializeComponentRef(this) in the constructor,
 */
function initializeComponentRef(obj) {
    Object(__WEBPACK_IMPORTED_MODULE_0__extendComponent__["a" /* extendComponent */])(obj, {
        componentDidMount: _onMount,
        componentDidUpdate: _onUpdate,
        componentWillUnmount: _onUnmount
    });
}
function _onMount() {
    _setComponentRef(this.props.componentRef, this);
}
function _onUpdate(prevProps) {
    if (prevProps.componentRef !== this.props.componentRef) {
        // tslint:disable-next-line:no-any
        _setComponentRef(prevProps.componentRef, null);
        _setComponentRef(this.props.componentRef, this);
    }
}
function _onUnmount() {
    _setComponentRef(this.props.componentRef, null);
}
function _setComponentRef(componentRef, value) {
    if (componentRef) {
        if (typeof componentRef === 'object') {
            componentRef.current = value;
        }
        else if (typeof componentRef === 'function') {
            componentRef(value);
        }
    }
}
//# sourceMappingURL=initializeComponentRef.js.map

/***/ }),
/* 1599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getInitials;
/**
 * Regular expression matching characters to ignore when calculating the initials.
 * The first part matches characters within parenthesis, including the parenthesis.
 * The second part matches special ASCII characters except space, plus some unicode special characters.
 */
var UNWANTED_CHARS_REGEX = /\([^)]*\)|[\0-\u001F\!-/:-@\[-`\{-\u00BF\u0250-\u036F\uD800-\uFFFF]/g;
/**
 * Regular expression matching phone numbers. Applied after chars matching UNWANTED_CHARS_REGEX have been removed
 * and number has been trimmed for whitespaces
 */
var PHONENUMBER_REGEX = /^\d+[\d\s]*(:?ext|x|)\s*\d+$/i;
/** Regular expression matching one or more spaces. */
var MULTIPLE_WHITESPACES_REGEX = /\s+/g;
/**
 * Regular expression matching languages for which we currently don't support initials.
 * Arabic:   Arabic, Arabic Supplement, Arabic Extended-A.
 * Korean:   Hangul Jamo, Hangul Compatibility Jamo, Hangul Jamo Extended-A, Hangul Syllables, Hangul Jamo Extended-B.
 * Japanese: Hiragana, Katakana.
 * CJK:      CJK Unified Ideographs Extension A, CJK Unified Ideographs, CJK Compatibility Ideographs, CJK Unified Ideographs Extension B
 */
/* tslint:disable:max-line-length */
var UNSUPPORTED_TEXT_REGEX = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\u1100-\u11FF\u3130-\u318F\uA960-\uA97F\uAC00-\uD7AF\uD7B0-\uD7FF\u3040-\u309F\u30A0-\u30FF\u3400-\u4DBF\u4E00-\u9FFF\uF900-\uFAFF]|[\uD840-\uD869][\uDC00-\uDED6]/;
/* tslint:enable:max-line-length */
function getInitialsLatin(displayName, isRtl) {
    var initials = '';
    var splits = displayName.split(' ');
    if (splits.length === 2) {
        initials += splits[0].charAt(0).toUpperCase();
        initials += splits[1].charAt(0).toUpperCase();
    }
    else if (splits.length === 3) {
        initials += splits[0].charAt(0).toUpperCase();
        initials += splits[2].charAt(0).toUpperCase();
    }
    else if (splits.length !== 0) {
        initials += splits[0].charAt(0).toUpperCase();
    }
    if (isRtl && initials.length > 1) {
        return initials.charAt(1) + initials.charAt(0);
    }
    return initials;
}
function cleanupDisplayName(displayName) {
    displayName = displayName.replace(UNWANTED_CHARS_REGEX, '');
    displayName = displayName.replace(MULTIPLE_WHITESPACES_REGEX, ' ');
    displayName = displayName.trim();
    return displayName;
}
/**
 * Get (up to 2 characters) initials based on display name of the persona.
 *
 * @public
 */
function getInitials(displayName, isRtl, allowPhoneInitials) {
    if (!displayName) {
        return '';
    }
    displayName = cleanupDisplayName(displayName);
    // For names containing CJK characters, and phone numbers, we don't display initials
    if (UNSUPPORTED_TEXT_REGEX.test(displayName) || (!allowPhoneInitials && PHONENUMBER_REGEX.test(displayName))) {
        return '';
    }
    return getInitialsLatin(displayName, isRtl);
}
//# sourceMappingURL=initials.js.map

/***/ }),
/* 1600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getLanguage;
/* unused harmony export setLanguage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_getDocument__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__localStorage__ = __webpack_require__(1601);


// Default to undefined so that we initialize on first read.
var _language;
/**
 * Gets the rtl state of the page (returns true if in rtl.)
 *
 * @public
 */
function getLanguage() {
    if (_language === undefined) {
        var doc = Object(__WEBPACK_IMPORTED_MODULE_0__dom_getDocument__["a" /* getDocument */])();
        var savedLanguage = Object(__WEBPACK_IMPORTED_MODULE_1__localStorage__["a" /* getItem */])('language');
        if (savedLanguage !== null) {
            _language = savedLanguage;
        }
        if (_language === undefined && doc) {
            _language = doc.documentElement.getAttribute('lang');
        }
        if (_language === undefined) {
            _language = 'en';
        }
    }
    return _language;
}
/**
 * Sets the rtl state of the page (by adjusting the dir attribute of the html element.)
 *
 * @public
 */
function setLanguage(language, avoidPersisting) {
    if (avoidPersisting === void 0) { avoidPersisting = false; }
    var doc = Object(__WEBPACK_IMPORTED_MODULE_0__dom_getDocument__["a" /* getDocument */])();
    if (doc) {
        doc.documentElement.setAttribute('lang', language);
    }
    if (!avoidPersisting) {
        Object(__WEBPACK_IMPORTED_MODULE_1__localStorage__["b" /* setItem */])('language', language);
    }
    _language = language;
}
//# sourceMappingURL=language.js.map

/***/ }),
/* 1601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getItem;
/* harmony export (immutable) */ __webpack_exports__["b"] = setItem;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_getWindow__ = __webpack_require__(86);

/**
 * Fetches an item from local storage without throwing an exception
 * @param key The key of the item to fetch from local storage
 */
function getItem(key) {
    var result = null;
    try {
        var win = Object(__WEBPACK_IMPORTED_MODULE_0__dom_getWindow__["a" /* getWindow */])();
        result = win ? win.localStorage.getItem(key) : null;
    }
    catch (e) {
        /* Eat the exception */
    }
    return result;
}
/**
 * Inserts an item into local storage without throwing an exception
 * @param key The key of the item to add to local storage
 * @param data The data to put into local storage
 */
function setItem(key, data) {
    try {
        var win = Object(__WEBPACK_IMPORTED_MODULE_0__dom_getWindow__["a" /* getWindow */])();
        win && win.localStorage.setItem(key, data);
    }
    catch (e) {
        /* Eat the exception */
    }
}
//# sourceMappingURL=localStorage.js.map

/***/ }),
/* 1602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getDistanceBetweenPoints;
/* unused harmony export fitContentToBounds */
/* harmony export (immutable) */ __webpack_exports__["a"] = calculatePrecision;
/* harmony export (immutable) */ __webpack_exports__["c"] = precisionRound;
/**
 * Determines the distance between two points.
 *
 * @public
 */
function getDistanceBetweenPoints(point1, point2) {
    var distance = Math.sqrt(Math.pow(point1.x - point2.x, 2) + Math.pow(point1.y - point2.y, 2));
    return distance;
}
/**
 * Produces a proportionally-scaled version of an input content size when fit to a bounding size.
 * Given a `contentSize` and a `boundsSize`, this function scales `contentSize` proportionally
 * using either `contain` or `cover` fit behaviors.
 * Use this function to pre-calculate the layout for the CSS `object-fit` and `background-fit` behaviors.
 * With `contain`, the output size must be the largest it can be while completely within the `boundsSize`.
 * With `cover`, the output size must be the smallest it can be while completely around the `boundsSize`.
 * By default, there is a `maxScale` value of 1, which prevents the `contentSize` from being scaled larger.
 *
 * @param options - the options for the bounds fit operation
 */
function fitContentToBounds(options) {
    var contentSize = options.contentSize, boundsSize = options.boundsSize, _a = options.mode, mode = _a === void 0 ? 'contain' : _a, _b = options.maxScale, maxScale = _b === void 0 ? 1 : _b;
    var contentAspectRatio = contentSize.width / contentSize.height;
    var boundsAspectRatio = boundsSize.width / boundsSize.height;
    var scale;
    if (mode === 'contain' ? contentAspectRatio > boundsAspectRatio : contentAspectRatio < boundsAspectRatio) {
        scale = boundsSize.width / contentSize.width;
    }
    else {
        scale = boundsSize.height / contentSize.height;
    }
    var finalScale = Math.min(maxScale, scale);
    return {
        width: contentSize.width * finalScale,
        height: contentSize.height * finalScale
    };
}
/**
 * Calculates a number's precision based on the number of trailing
 * zeros if the number does not have a decimal indicated by a negative
 * precision. Otherwise, it calculates the number of digits after
 * the decimal point indicated by a positive precision.
 * @param value - the value to determine the precision of
 */
function calculatePrecision(value) {
    /**
     * Group 1:
     * [1-9]([0]+$) matches trailing zeros
     * Group 2:
     * \.([0-9]*) matches all digits after a decimal point.
     */
    var groups = /[1-9]([0]+$)|\.([0-9]*)/.exec(String(value));
    if (!groups) {
        return 0;
    }
    if (groups[1]) {
        return -groups[1].length;
    }
    if (groups[2]) {
        return groups[2].length;
    }
    return 0;
}
/**
 * Rounds a number to a certain level of precision. Accepts negative precision.
 * @param value - The value that is being rounded.
 * @param precision - The number of decimal places to round the number to
 */
function precisionRound(value, precision, base) {
    if (base === void 0) { base = 10; }
    var exp = Math.pow(base, precision);
    return Math.round(value * exp) / exp;
}
//# sourceMappingURL=math.js.map

/***/ }),
/* 1603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setMemoizeWeakMap */
/* unused harmony export resetMemoizations */
/* unused harmony export memoize */
/* harmony export (immutable) */ __webpack_exports__["a"] = memoizeFunction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uifabric_merge_styles__ = __webpack_require__(46);

var stylesheet = __WEBPACK_IMPORTED_MODULE_0__uifabric_merge_styles__["a" /* Stylesheet */].getInstance();
if (stylesheet && stylesheet.onReset) {
    __WEBPACK_IMPORTED_MODULE_0__uifabric_merge_styles__["a" /* Stylesheet */].getInstance().onReset(resetMemoizations);
}
var _resetCounter = 0;
var _emptyObject = { empty: true };
var _dictionary = {};
var _weakMap = typeof WeakMap === 'undefined' ? null : WeakMap;
/**
 *  Test utility for providing a custom weakmap.
 *
 * @internal
 * */
function setMemoizeWeakMap(weakMap) {
    _weakMap = weakMap;
}
/**
 * Reset memoizations.
 */
function resetMemoizations() {
    _resetCounter++;
}
/**
 * Memoize decorator to be used on class methods. WARNING: the `this` reference
 * will be inaccessible within a memoized method, given that a cached method's `this`
 * would not be instance-specific.
 *
 * @public
 */
function memoize(target, key, descriptor) {
    // We bind to "null" to prevent people from inadvertently pulling values from "this",
    // rather than passing them in as input values which can be memoized.
    var fn = memoizeFunction(descriptor.value && descriptor.value.bind(null));
    return {
        configurable: true,
        get: function () {
            return fn;
        }
    };
}
/**
 * Memoizes a function; when you pass in the same parameters multiple times, it returns a cached result.
 * Be careful when passing in objects, you need to pass in the same INSTANCE for caching to work. Otherwise
 * it will grow the cache unnecessarily. Also avoid using default values that evaluate functions; passing in
 * undefined for a value and relying on a default function will execute it the first time, but will not
 * re-evaluate subsequent times which may have been unexpected.
 *
 * By default, the cache will reset after 100 permutations, to avoid abuse cases where the function is
 * unintendedly called with unique objects. Without a reset, the cache could grow infinitely, so we safeguard
 * by resetting. To override this behavior, pass a value of 0 to the maxCacheSize parameter.
 *
 * @public
 * @param cb - The function to memoize.
 * @param maxCacheSize - Max results to cache. If the cache exceeds this value, it will reset on the next call.
 * @returns A memoized version of the function.
 */
function memoizeFunction(cb, maxCacheSize) {
    if (maxCacheSize === void 0) { maxCacheSize = 100; }
    // Avoid breaking scenarios which don't have weak map.
    if (!_weakMap) {
        return cb;
    }
    var rootNode;
    var cacheSize = 0;
    var localResetCounter = _resetCounter;
    // tslint:disable-next-line:no-function-expression
    return function memoizedFunction() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var currentNode = rootNode;
        if (rootNode === undefined || localResetCounter !== _resetCounter || (maxCacheSize > 0 && cacheSize > maxCacheSize)) {
            rootNode = _createNode();
            cacheSize = 0;
            localResetCounter = _resetCounter;
        }
        currentNode = rootNode;
        // Traverse the tree until we find the match.
        for (var i = 0; i < args.length; i++) {
            var arg = _normalizeArg(args[i]);
            if (!currentNode.map.has(arg)) {
                currentNode.map.set(arg, _createNode());
            }
            currentNode = currentNode.map.get(arg);
        }
        if (!currentNode.hasOwnProperty('value')) {
            currentNode.value = cb.apply(void 0, args);
            cacheSize++;
        }
        return currentNode.value;
    };
}
function _normalizeArg(val) {
    if (!val) {
        return _emptyObject;
    }
    else if (typeof val === 'object' || typeof val === 'function') {
        return val;
    }
    else if (!_dictionary[val]) {
        _dictionary[val] = { val: val };
    }
    return _dictionary[val];
}
function _createNode() {
    return {
        map: _weakMap ? new _weakMap() : null
    };
}
//# sourceMappingURL=memoize.js.map

/***/ }),
/* 1604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = merge;
/**
 * Simple deep merge function. Takes all arguments and returns a deep copy of the objects merged
 * together in the order provided. If an object creates a circular reference, it will assign the
 * original reference.
 */
function merge(target) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
        var arg = args_1[_a];
        _merge(target || {}, arg);
    }
    return target;
}
/**
 * The _merge helper iterates through all props on source and assigns them to target.
 * When the value is an object, we will create a deep clone of the object. However if
 * there is a circular reference, the value will not be deep cloned and will persist
 * the reference.
 */
// tslint:disable-next-line:no-any
function _merge(target, source, circularReferences) {
    if (circularReferences === void 0) { circularReferences = []; }
    circularReferences.push(source);
    for (var name_1 in source) {
        if (source.hasOwnProperty(name_1)) {
            var value = source[name_1];
            if (typeof value === 'object') {
                var isCircularReference = circularReferences.indexOf(value) > -1;
                // tslint:disable-next-line:no-any
                target[name_1] = isCircularReference ? value : _merge(target[name_1] || {}, value, circularReferences);
            }
            else {
                target[name_1] = value;
            }
        }
    }
    circularReferences.pop();
    return target;
}
//# sourceMappingURL=merge.js.map

/***/ }),
/* 1605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isIOS; });
/**
 * Returns true if and only if the user is on a iOS device.
 * Used to determine whether iOS-specific behavior should be applied.
 */
var isIOS = function () {
    if (!window || !window.navigator || !window.navigator.userAgent) {
        return false;
    }
    return /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
};
//# sourceMappingURL=mobileDetector.js.map

/***/ }),
/* 1606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isMac;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_getWindow__ = __webpack_require__(86);

var isMacResult;
/**
 * Returns true if the user is on a Mac. Caches the result value.
 * @param reset - Reset the cached result value (mainly for testing).
 */
function isMac(reset) {
    if (typeof isMacResult === 'undefined' || reset) {
        var win = Object(__WEBPACK_IMPORTED_MODULE_0__dom_getWindow__["a" /* getWindow */])();
        var userAgent = win && win.navigator.userAgent;
        isMacResult = !!userAgent && userAgent.indexOf('Macintosh') !== -1;
    }
    return !!isMacResult;
}
//# sourceMappingURL=osDetector.js.map

/***/ }),
/* 1607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hasHorizontalOverflow */
/* unused harmony export hasVerticalOverflow */
/* harmony export (immutable) */ __webpack_exports__["a"] = hasOverflow;
/**
 * Detects whether an element's content has horizontal overflow
 *
 * @public
 * @param element - Element to check for overflow
 * @returns True if element's content overflows
 */
function hasHorizontalOverflow(element) {
    return element.clientWidth < element.scrollWidth;
}
/**
 * Detects whether an element's content has vertical overflow
 *
 * @public
 * @param element - Element to check for overflow
 * @returns True if element's content overflows
 */
function hasVerticalOverflow(element) {
    return element.clientHeight < element.scrollHeight;
}
/**
 * Detects whether an element's content has overflow in any direction
 *
 * @public
 * @param element - Element to check for overflow
 * @returns True if element's content overflows
 */
function hasOverflow(element) {
    return hasHorizontalOverflow(element) || hasVerticalOverflow(element);
}
//# sourceMappingURL=overflow.js.map

/***/ }),
/* 1608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export baseElementEvents */
/* unused harmony export baseElementProperties */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return htmlElementProperties; });
/* unused harmony export labelProperties */
/* unused harmony export audioProperties */
/* unused harmony export videoProperties */
/* unused harmony export olProperties */
/* unused harmony export liProperties */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return anchorProperties; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return buttonProperties; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return inputProperties; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return textAreaProperties; });
/* unused harmony export selectProperties */
/* unused harmony export optionProperties */
/* unused harmony export tableProperties */
/* unused harmony export trProperties */
/* unused harmony export thProperties */
/* unused harmony export tdProperties */
/* unused harmony export colGroupProperties */
/* unused harmony export colProperties */
/* unused harmony export formProperties */
/* unused harmony export iframeProperties */
/* unused harmony export imgProperties */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return imageProperties; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return divProperties; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getNativeProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__object__ = __webpack_require__(383);

/**
 * An array of events that are allowed on every html element type.
 *
 * @public
 */
var baseElementEvents = [
    'onCopy',
    'onCut',
    'onPaste',
    'onCompositionEnd',
    'onCompositionStart',
    'onCompositionUpdate',
    'onFocus',
    'onFocusCapture',
    'onBlur',
    'onBlurCapture',
    'onChange',
    'onInput',
    'onSubmit',
    'onLoad',
    'onError',
    'onKeyDown',
    'onKeyDownCapture',
    'onKeyPress',
    'onKeyUp',
    'onAbort',
    'onCanPlay',
    'onCanPlayThrough',
    'onDurationChange',
    'onEmptied',
    'onEncrypted',
    'onEnded',
    'onLoadedData',
    'onLoadedMetadata',
    'onLoadStart',
    'onPause',
    'onPlay',
    'onPlaying',
    'onProgress',
    'onRateChange',
    'onSeeked',
    'onSeeking',
    'onStalled',
    'onSuspend',
    'onTimeUpdate',
    'onVolumeChange',
    'onWaiting',
    'onClick',
    'onClickCapture',
    'onContextMenu',
    'onDoubleClick',
    'onDrag',
    'onDragEnd',
    'onDragEnter',
    'onDragExit',
    'onDragLeave',
    'onDragOver',
    'onDragStart',
    'onDrop',
    'onMouseDown',
    'onMouseDownCapture',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseOut',
    'onMouseOver',
    'onMouseUp',
    'onMouseUpCapture',
    'onSelect',
    'onTouchCancel',
    'onTouchEnd',
    'onTouchMove',
    'onTouchStart',
    'onScroll',
    'onWheel',
    'onPointerCancel',
    'onPointerDown',
    'onPointerEnter',
    'onPointerLeave',
    'onPointerMove',
    'onPointerOut',
    'onPointerOver',
    'onPointerUp',
    'onGotPointerCapture',
    'onLostPointerCapture'
];
/**
 * An array of element attributes which are allowed on every html element type.
 *
 * @public
 */
var baseElementProperties = [
    'accessKey',
    'children',
    'className',
    'contentEditable',
    'dir',
    'draggable',
    'hidden',
    'htmlFor',
    'id',
    'lang',
    'role',
    'style',
    'tabIndex',
    'title',
    'translate',
    'spellCheck',
    'name' // global
];
/**
 * An array of HTML element properties and events.
 *
 * @public
 */
var htmlElementProperties = baseElementProperties.concat(baseElementEvents);
/**
 * An array of LABEL tag properties and events.
 *
 * @public
 */
var labelProperties = htmlElementProperties.concat([
    'form' // button, fieldset, input, label, meter, object, output, select, textarea
]);
/**
 * An array of AUDIO tag properties and events.
 *
 * @public
 */
var audioProperties = htmlElementProperties.concat([
    'height',
    'loop',
    'muted',
    'preload',
    'src',
    'width' // canvas, embed, iframe, img, input, object, video
]);
/**
 * An array of VIDEO tag properties and events.
 *
 * @public
 */
var videoProperties = audioProperties.concat([
    'poster' // video
]);
/**
 * An array of OL tag properties and events.
 *
 * @public
 */
var olProperties = htmlElementProperties.concat([
    'start' // ol
]);
/**
 * An array of LI tag properties and events.
 *
 * @public
 */
var liProperties = htmlElementProperties.concat([
    'value' // button, input, li, option, meter, progress, param
]);
/**
 * An array of A tag properties and events.
 *
 * @public
 */
var anchorProperties = htmlElementProperties.concat([
    'download',
    'href',
    'hrefLang',
    'media',
    'rel',
    'target',
    'type' // a, button, input, link, menu, object, script, source, style
]);
/**
 * An array of BUTTON tag properties and events.
 *
 * @public
 */
var buttonProperties = htmlElementProperties.concat([
    'autoFocus',
    'disabled',
    'form',
    'formAction',
    'formEncType',
    'formMethod',
    'formNoValidate',
    'formTarget',
    'type',
    'value' // button, input, li, option, meter, progress, param,
]);
/**
 * An array of INPUT tag properties and events.
 *
 * @public
 */
var inputProperties = buttonProperties.concat([
    'accept',
    'alt',
    'autoComplete',
    'checked',
    'dirname',
    'form',
    'height',
    'inputMode',
    'list',
    'max',
    'maxLength',
    'min',
    'multiple',
    'pattern',
    'placeholder',
    'readOnly',
    'required',
    'src',
    'step',
    'size',
    'type',
    'value',
    'width' // canvas, embed, iframe, img, input, object, video
]);
/**
 * An array of TEXTAREA tag properties and events.
 *
 * @public
 */
var textAreaProperties = buttonProperties.concat([
    'cols',
    'dirname',
    'form',
    'maxLength',
    'placeholder',
    'readOnly',
    'required',
    'rows',
    'wrap' // textarea
]);
/**
 * An array of SELECT tag properties and events.
 *
 * @public
 */
var selectProperties = buttonProperties.concat([
    'form',
    'multiple',
    'required' // input, select, textarea
]);
var optionProperties = htmlElementProperties.concat([
    'selected',
    'value' // button, input, li, option, meter, progress, param
]);
/**
 * An array of TABLE tag properties and events.
 *
 * @public
 */
var tableProperties = htmlElementProperties.concat([
    'cellPadding',
    'cellSpacing' // table
]);
/**
 * An array of TR tag properties and events.
 *
 * @public
 */
var trProperties = htmlElementProperties;
/**
 * An array of TH tag properties and events.
 *
 * @public
 */
var thProperties = htmlElementProperties.concat([
    'rowSpan',
    'scope' // th
]);
/**
 * An array of TD tag properties and events.
 *
 * @public
 */
var tdProperties = htmlElementProperties.concat([
    'colSpan',
    'headers',
    'rowSpan',
    'scope' // th
]);
var colGroupProperties = htmlElementProperties.concat([
    'span' // col, colgroup
]);
var colProperties = htmlElementProperties.concat([
    'span' // col, colgroup
]);
/**
 * An array of FORM tag properties and events.
 *
 * @public
 */
var formProperties = htmlElementProperties.concat([
    'acceptCharset',
    'action',
    'encType',
    'encType',
    'method',
    'noValidate',
    'target' // form
]);
/**
 * An array of IFRAME tag properties and events.
 *
 * @public
 */
var iframeProperties = htmlElementProperties.concat([
    'allow',
    'allowFullScreen',
    'allowPaymentRequest',
    'allowTransparency',
    'csp',
    'height',
    'importance',
    'referrerPolicy',
    'sandbox',
    'src',
    'srcDoc',
    'width' // canvas, embed, iframe, img, input, object, video,
]);
/**
 * An array of IMAGE tag properties and events.
 *
 * @public
 */
var imgProperties = htmlElementProperties.concat([
    'alt',
    'crossOrigin',
    'height',
    'src',
    'srcSet',
    'useMap',
    'width' // canvas, embed, iframe, img, input, object, video
]);
/**
 * @deprecated Use imgProperties for img elements.
 */
var imageProperties = imgProperties;
/**
 * An array of DIV tag properties and events.
 *
 * @public
 */
var divProperties = htmlElementProperties;
/**
 * Gets native supported props for an html element provided the allowance set. Use one of the property
 * sets defined (divProperties, buttonPropertes, etc) to filter out supported properties from a given
 * props set. Note that all data- and aria- prefixed attributes will be allowed.
 * NOTE: getNativeProps should always be applied first when adding props to a react component. The
 * non-native props should be applied second. This will prevent getNativeProps from overriding your custom props.
 * For example, if props passed to getNativeProps has an onClick function and getNativeProps is added to
 * the component after an onClick function is added, then the getNativeProps onClick will override it.
 *
 * @public
 * @param props - The unfiltered input props
 * @param allowedPropsNames-  The array of allowed propnames.
 * @returns The filtered props
 */
function getNativeProps(props, allowedPropNames, excludedPropNames) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__object__["b" /* filteredAssign */])(function (propName) {
        return ((!excludedPropNames || excludedPropNames.indexOf(propName) < 0) &&
            (propName.indexOf('data-') === 0 || propName.indexOf('aria-') === 0 || allowedPropNames.indexOf(propName) >= 0));
    }, {}, props);
}
//# sourceMappingURL=properties.js.map

/***/ }),
/* 1609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getResourceUrl */
/* unused harmony export setBaseUrl */
var _baseUrl = '';
/** Sets the current base url used for fetching images. */
function getResourceUrl(url) {
    return _baseUrl + url;
}
/** Gets the current base url used for fetching images. */
function setBaseUrl(baseUrl) {
    _baseUrl = baseUrl;
}
//# sourceMappingURL=resources.js.map

/***/ }),
/* 1610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getRTL;
/* unused harmony export setRTL */
/* harmony export (immutable) */ __webpack_exports__["b"] = getRTLSafeKeyCode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__KeyCodes__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_getDocument__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sessionStorage__ = __webpack_require__(1611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__uifabric_merge_styles__ = __webpack_require__(46);




var RTL_LOCAL_STORAGE_KEY = 'isRTL';
// Default to undefined so that we initialize on first read.
var _isRTL;
/**
 * Gets the rtl state of the page (returns true if in rtl.)
 */
function getRTL() {
    if (_isRTL === undefined) {
        // Fabric supports persisting the RTL setting between page refreshes via session storage
        var savedRTL = Object(__WEBPACK_IMPORTED_MODULE_2__sessionStorage__["a" /* getItem */])(RTL_LOCAL_STORAGE_KEY);
        if (savedRTL !== null) {
            _isRTL = savedRTL === '1';
            setRTL(_isRTL);
        }
        var doc = Object(__WEBPACK_IMPORTED_MODULE_1__dom_getDocument__["a" /* getDocument */])();
        if (_isRTL === undefined && doc) {
            _isRTL = ((doc.body && doc.body.getAttribute('dir')) || doc.documentElement.getAttribute('dir')) === 'rtl';
            Object(__WEBPACK_IMPORTED_MODULE_3__uifabric_merge_styles__["g" /* setRTL */])(_isRTL);
        }
    }
    return !!_isRTL;
}
/**
 * Sets the rtl state of the page (by adjusting the dir attribute of the html element.)
 */
function setRTL(isRTL, persistSetting) {
    if (persistSetting === void 0) { persistSetting = false; }
    var doc = Object(__WEBPACK_IMPORTED_MODULE_1__dom_getDocument__["a" /* getDocument */])();
    if (doc) {
        doc.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr');
    }
    if (persistSetting) {
        Object(__WEBPACK_IMPORTED_MODULE_2__sessionStorage__["b" /* setItem */])(RTL_LOCAL_STORAGE_KEY, isRTL ? '1' : '0');
    }
    _isRTL = isRTL;
    Object(__WEBPACK_IMPORTED_MODULE_3__uifabric_merge_styles__["g" /* setRTL */])(_isRTL);
}
/**
 * Returns the given key, but flips right/left arrows if necessary.
 */
function getRTLSafeKeyCode(key) {
    if (getRTL()) {
        if (key === __WEBPACK_IMPORTED_MODULE_0__KeyCodes__["a" /* KeyCodes */].left) {
            key = __WEBPACK_IMPORTED_MODULE_0__KeyCodes__["a" /* KeyCodes */].right;
        }
        else if (key === __WEBPACK_IMPORTED_MODULE_0__KeyCodes__["a" /* KeyCodes */].right) {
            key = __WEBPACK_IMPORTED_MODULE_0__KeyCodes__["a" /* KeyCodes */].left;
        }
    }
    return key;
}
//# sourceMappingURL=rtl.js.map

/***/ }),
/* 1611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getItem;
/* harmony export (immutable) */ __webpack_exports__["b"] = setItem;
/**
 * Fetches an item from session storage without throwing an exception
 * @param key The key of the item to fetch from session storage
 */
function getItem(key) {
    var result = null;
    try {
        result = window.sessionStorage.getItem(key);
    }
    catch (e) {
        /* Eat the exception */
    }
    return result;
}
/**
 * Inserts an item into session storage without throwing an exception
 * @param key The key of the item to add to session storage
 * @param data The data to put into session storage
 */
function setItem(key, data) {
    try {
        window.sessionStorage.setItem(key, data);
    }
    catch (e) {
        /* Eat the exception */
    }
}
//# sourceMappingURL=sessionStorage.js.map

/***/ }),
/* 1612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return safeRequestAnimationFrame; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__extendComponent__ = __webpack_require__(263);

/**
 * Generates a function to be attached to a React component, which can be called
 * as a replacement to RAF. In-flight async calls will be auto canceled if the component
 * is unmounting before the async code is executed, preventing bugs where code
 * accesses things within the component after being unmounted.
 */
var safeRequestAnimationFrame = function (component) {
    var activeTimeouts;
    return function (cb) {
        if (!activeTimeouts) {
            activeTimeouts = new Set();
            Object(__WEBPACK_IMPORTED_MODULE_0__extendComponent__["a" /* extendComponent */])(component, {
                componentWillUnmount: function () {
                    activeTimeouts.forEach(function (id) { return cancelAnimationFrame(id); });
                }
            });
        }
        var timeoutId = requestAnimationFrame(function () {
            activeTimeouts.delete(timeoutId);
            cb();
        });
        activeTimeouts.add(timeoutId);
    };
};
//# sourceMappingURL=safeRequestAnimationFrame.js.map

/***/ }),
/* 1613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export safeSetTimeout */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__extendComponent__ = __webpack_require__(263);

/**
 * Generates a function to be attached to a React component, which can be called
 * as a replacement to setTimeout. In-flight async calls will be auto canceled if the component
 * is unmounting before the async code is executed, preventing bugs where code
 * accesses things within the component after being unmounted.
 */
var safeSetTimeout = function (component) {
    var activeTimeouts;
    return function (cb, duration) {
        if (!activeTimeouts) {
            activeTimeouts = new Set();
            Object(__WEBPACK_IMPORTED_MODULE_0__extendComponent__["a" /* extendComponent */])(component, {
                componentWillUnmount: function () {
                    activeTimeouts.forEach(function (id) { return clearTimeout(id); });
                }
            });
        }
        var timeoutId = setTimeout(function () {
            activeTimeouts.delete(timeoutId);
            cb();
        }, duration);
        activeTimeouts.add(timeoutId);
    };
};
//# sourceMappingURL=safeSetTimeout.js.map

/***/ }),
/* 1614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Selection_types__ = __webpack_require__(652);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Selection_types__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__Selection_types__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Selection__ = __webpack_require__(1615);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Selection__["a"]; });


//# sourceMappingURL=index.js.map

/***/ }),
/* 1615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Selection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Selection_types__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventGroup__ = __webpack_require__(258);


/**
 * {@docCategory Selection}
 */
var Selection = /** @class */ (function () {
    function Selection(options) {
        if (options === void 0) { options = {}; }
        var onSelectionChanged = options.onSelectionChanged, getKey = options.getKey, _a = options.canSelectItem, canSelectItem = _a === void 0 ? function (item) { return true; } : _a, _b = options.selectionMode, selectionMode = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_0__Selection_types__["b" /* SelectionMode */].multiple : _b;
        this.mode = selectionMode;
        this._getKey = getKey || defaultGetKey;
        this._changeEventSuppressionCount = 0;
        this._exemptedCount = 0;
        this._anchoredIndex = 0;
        this._unselectableCount = 0;
        this._onSelectionChanged = onSelectionChanged;
        this._canSelectItem = canSelectItem;
        this._isModal = false;
        this.setItems([], true);
        this.count = this.getSelectedCount();
    }
    Selection.prototype.canSelectItem = function (item, index) {
        if (typeof index === 'number' && index < 0) {
            return false;
        }
        return this._canSelectItem(item, index);
    };
    Selection.prototype.getKey = function (item, index) {
        var key = this._getKey(item, index);
        return typeof key === 'number' || key ? "" + key : '';
    };
    Selection.prototype.setChangeEvents = function (isEnabled, suppressChange) {
        this._changeEventSuppressionCount += isEnabled ? -1 : 1;
        if (this._changeEventSuppressionCount === 0 && this._hasChanged) {
            this._hasChanged = false;
            if (!suppressChange) {
                this._change();
            }
        }
    };
    Selection.prototype.isModal = function () {
        return this._isModal;
    };
    Selection.prototype.setModal = function (isModal) {
        if (this._isModal !== isModal) {
            this.setChangeEvents(false);
            this._isModal = isModal;
            if (!isModal) {
                this.setAllSelected(false);
            }
            this._change();
            this.setChangeEvents(true);
        }
    };
    /**
     * Selection needs the items, call this method to set them. If the set
     * of items is the same, this will re-evaluate selection and index maps.
     * Otherwise, shouldClear should be set to true, so that selection is
     * cleared.
     */
    Selection.prototype.setItems = function (items, shouldClear) {
        if (shouldClear === void 0) { shouldClear = true; }
        var newKeyToIndexMap = {};
        var newUnselectableIndices = {};
        var hasSelectionChanged = false;
        this.setChangeEvents(false);
        // Reset the unselectable count.
        this._unselectableCount = 0;
        // Build lookup table for quick selection evaluation.
        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            if (item) {
                var key = this.getKey(item, i);
                if (key) {
                    newKeyToIndexMap[key] = i;
                }
            }
            newUnselectableIndices[i] = item && !this.canSelectItem(item);
            if (newUnselectableIndices[i]) {
                this._unselectableCount++;
            }
        }
        if (shouldClear || items.length === 0) {
            this._setAllSelected(false, true);
        }
        // Check the exemption list for discrepencies.
        var newExemptedIndicies = {};
        var newExemptedCount = 0;
        for (var indexProperty in this._exemptedIndices) {
            if (this._exemptedIndices.hasOwnProperty(indexProperty)) {
                var index = Number(indexProperty);
                var item = this._items[index];
                var exemptKey = item ? this.getKey(item, Number(index)) : undefined;
                var newIndex = exemptKey ? newKeyToIndexMap[exemptKey] : index;
                if (newIndex === undefined) {
                    // The item has likely been replaced or removed.
                    hasSelectionChanged = true;
                }
                else {
                    // We know the new index of the item. update the existing exemption table.
                    newExemptedIndicies[newIndex] = true;
                    newExemptedCount++;
                    hasSelectionChanged = hasSelectionChanged || newIndex !== index;
                }
            }
        }
        if (this._items && this._exemptedCount === 0 && items.length !== this._items.length && this._isAllSelected) {
            // If everything was selected but the number of items has changed, selection has changed.
            hasSelectionChanged = true;
        }
        this._exemptedIndices = newExemptedIndicies;
        this._exemptedCount = newExemptedCount;
        this._keyToIndexMap = newKeyToIndexMap;
        this._unselectableIndices = newUnselectableIndices;
        this._items = items;
        this._selectedItems = null;
        if (hasSelectionChanged) {
            this._updateCount();
            this._change();
        }
        this.setChangeEvents(true);
    };
    Selection.prototype.getItems = function () {
        return this._items;
    };
    Selection.prototype.getSelection = function () {
        if (!this._selectedItems) {
            this._selectedItems = [];
            var items = this._items;
            if (items) {
                for (var i = 0; i < items.length; i++) {
                    if (this.isIndexSelected(i)) {
                        this._selectedItems.push(items[i]);
                    }
                }
            }
        }
        return this._selectedItems;
    };
    Selection.prototype.getSelectedCount = function () {
        return this._isAllSelected ? this._items.length - this._exemptedCount - this._unselectableCount : this._exemptedCount;
    };
    Selection.prototype.getSelectedIndices = function () {
        if (!this._selectedIndices) {
            this._selectedIndices = [];
            var items = this._items;
            if (items) {
                for (var i = 0; i < items.length; i++) {
                    if (this.isIndexSelected(i)) {
                        this._selectedIndices.push(i);
                    }
                }
            }
        }
        return this._selectedIndices;
    };
    Selection.prototype.isRangeSelected = function (fromIndex, count) {
        if (count === 0) {
            return false;
        }
        var endIndex = fromIndex + count;
        for (var i = fromIndex; i < endIndex; i++) {
            if (!this.isIndexSelected(i)) {
                return false;
            }
        }
        return true;
    };
    Selection.prototype.isAllSelected = function () {
        var selectableCount = this._items.length - this._unselectableCount;
        // In single mode, we can only have a max of 1 item.
        if (this.mode === __WEBPACK_IMPORTED_MODULE_0__Selection_types__["b" /* SelectionMode */].single) {
            selectableCount = Math.min(selectableCount, 1);
        }
        return ((this.count > 0 && (this._isAllSelected && this._exemptedCount === 0)) ||
            (!this._isAllSelected && this._exemptedCount === selectableCount && selectableCount > 0));
    };
    Selection.prototype.isKeySelected = function (key) {
        var index = this._keyToIndexMap[key];
        return this.isIndexSelected(index);
    };
    Selection.prototype.isIndexSelected = function (index) {
        return !!((this.count > 0 && (this._isAllSelected && !this._exemptedIndices[index] && !this._unselectableIndices[index])) ||
            (!this._isAllSelected && this._exemptedIndices[index]));
    };
    Selection.prototype.setAllSelected = function (isAllSelected) {
        if (isAllSelected && this.mode !== __WEBPACK_IMPORTED_MODULE_0__Selection_types__["b" /* SelectionMode */].multiple) {
            return;
        }
        var selectableCount = this._items ? this._items.length - this._unselectableCount : 0;
        this.setChangeEvents(false);
        if (selectableCount > 0 && (this._exemptedCount > 0 || isAllSelected !== this._isAllSelected)) {
            this._exemptedIndices = {};
            if (isAllSelected !== this._isAllSelected || this._exemptedCount > 0) {
                this._exemptedCount = 0;
                this._isAllSelected = isAllSelected;
                this._change();
            }
            this._updateCount();
        }
        this.setChangeEvents(true);
    };
    Selection.prototype.setKeySelected = function (key, isSelected, shouldAnchor) {
        var index = this._keyToIndexMap[key];
        if (index >= 0) {
            this.setIndexSelected(index, isSelected, shouldAnchor);
        }
    };
    Selection.prototype.setIndexSelected = function (index, isSelected, shouldAnchor) {
        if (this.mode === __WEBPACK_IMPORTED_MODULE_0__Selection_types__["b" /* SelectionMode */].none) {
            return;
        }
        // Clamp the index.
        index = Math.min(Math.max(0, index), this._items.length - 1);
        // No-op on out of bounds selections.
        if (index < 0 || index >= this._items.length) {
            return;
        }
        this.setChangeEvents(false);
        var isExempt = this._exemptedIndices[index];
        var canSelect = !this._unselectableIndices[index];
        if (canSelect) {
            if (isSelected && this.mode === __WEBPACK_IMPORTED_MODULE_0__Selection_types__["b" /* SelectionMode */].single) {
                // If this is single-select, the previous selection should be removed.
                this._setAllSelected(false, true);
            }
            // Determine if we need to remove the exemption.
            if (isExempt && ((isSelected && this._isAllSelected) || (!isSelected && !this._isAllSelected))) {
                delete this._exemptedIndices[index];
                this._exemptedCount--;
            }
            // Determine if we need to add the exemption.
            if (!isExempt && ((isSelected && !this._isAllSelected) || (!isSelected && this._isAllSelected))) {
                this._exemptedIndices[index] = true;
                this._exemptedCount++;
            }
            if (shouldAnchor) {
                this._anchoredIndex = index;
            }
        }
        this._updateCount();
        this.setChangeEvents(true);
    };
    Selection.prototype.selectToKey = function (key, clearSelection) {
        this.selectToIndex(this._keyToIndexMap[key], clearSelection);
    };
    Selection.prototype.selectToIndex = function (index, clearSelection) {
        if (this.mode === __WEBPACK_IMPORTED_MODULE_0__Selection_types__["b" /* SelectionMode */].none) {
            return;
        }
        if (this.mode === __WEBPACK_IMPORTED_MODULE_0__Selection_types__["b" /* SelectionMode */].single) {
            this.setIndexSelected(index, true, true);
            return;
        }
        var anchorIndex = this._anchoredIndex || 0;
        var startIndex = Math.min(index, anchorIndex);
        var endIndex = Math.max(index, anchorIndex);
        this.setChangeEvents(false);
        if (clearSelection) {
            this._setAllSelected(false, true);
        }
        for (; startIndex <= endIndex; startIndex++) {
            this.setIndexSelected(startIndex, true, false);
        }
        this.setChangeEvents(true);
    };
    Selection.prototype.toggleAllSelected = function () {
        this.setAllSelected(!this.isAllSelected());
    };
    Selection.prototype.toggleKeySelected = function (key) {
        this.setKeySelected(key, !this.isKeySelected(key), true);
    };
    Selection.prototype.toggleIndexSelected = function (index) {
        this.setIndexSelected(index, !this.isIndexSelected(index), true);
    };
    Selection.prototype.toggleRangeSelected = function (fromIndex, count) {
        if (this.mode === __WEBPACK_IMPORTED_MODULE_0__Selection_types__["b" /* SelectionMode */].none) {
            return;
        }
        var isRangeSelected = this.isRangeSelected(fromIndex, count);
        var endIndex = fromIndex + count;
        if (this.mode === __WEBPACK_IMPORTED_MODULE_0__Selection_types__["b" /* SelectionMode */].single && count > 1) {
            return;
        }
        this.setChangeEvents(false);
        for (var i = fromIndex; i < endIndex; i++) {
            this.setIndexSelected(i, !isRangeSelected, false);
        }
        this.setChangeEvents(true);
    };
    Selection.prototype._updateCount = function (preserveModalState) {
        if (preserveModalState === void 0) { preserveModalState = false; }
        var count = this.getSelectedCount();
        if (count !== this.count) {
            this.count = count;
            this._change();
        }
        if (!this.count && !preserveModalState) {
            this.setModal(false);
        }
    };
    Selection.prototype._setAllSelected = function (isAllSelected, preserveModalState) {
        if (preserveModalState === void 0) { preserveModalState = false; }
        if (isAllSelected && this.mode !== __WEBPACK_IMPORTED_MODULE_0__Selection_types__["b" /* SelectionMode */].multiple) {
            return;
        }
        var selectableCount = this._items ? this._items.length - this._unselectableCount : 0;
        this.setChangeEvents(false);
        if (selectableCount > 0 && (this._exemptedCount > 0 || isAllSelected !== this._isAllSelected)) {
            this._exemptedIndices = {};
            if (isAllSelected !== this._isAllSelected || this._exemptedCount > 0) {
                this._exemptedCount = 0;
                this._isAllSelected = isAllSelected;
                this._change();
            }
            this._updateCount(preserveModalState);
        }
        this.setChangeEvents(true);
    };
    Selection.prototype._change = function () {
        if (this._changeEventSuppressionCount === 0) {
            this._selectedItems = null;
            this._selectedIndices = undefined;
            __WEBPACK_IMPORTED_MODULE_1__EventGroup__["a" /* EventGroup */].raise(this, __WEBPACK_IMPORTED_MODULE_0__Selection_types__["a" /* SELECTION_CHANGE */]);
            if (this._onSelectionChanged) {
                this._onSelectionChanged();
            }
        }
        else {
            this._hasChanged = true;
        }
    };
    return Selection;
}());

function defaultGetKey(item, index) {
    return item && item.key ? item.key : "" + index;
}
//# sourceMappingURL=Selection.js.map

/***/ }),
/* 1616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = format;
// Regex that finds { and } so they can be removed on a lookup for string format
var FORMAT_ARGS_REGEX = /[\{\}]/g;
// Regex that finds {#} so it can be replaced by the arguments in string format
var FORMAT_REGEX = /\{\d+\}/g;
/**
 * String format method, used for scenarios where at runtime you
 * need to evaluate a formatted string given a tokenized string. This
 * usually only is needed in localization scenarios.

 * @example
 * ```tsx
 * "I love {0} every {1}".format("CXP")
 * ```
 * will result in a Debug Exception.
 *
 * @public
 */
// tslint:disable-next-line:no-any
function format(s) {
    'use strict';
    var values = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        values[_i - 1] = arguments[_i];
    }
    var args = values;
    // Callback match function
    function replace_func(match) {
        // looks up in the args
        // tslint:disable-next-line:no-any
        var replacement = args[match.replace(FORMAT_ARGS_REGEX, '')];
        // catches undefined in nondebug and null in debug and nondebug
        if (replacement === null || replacement === undefined) {
            replacement = '';
        }
        return replacement;
    }
    return s.replace(FORMAT_REGEX, replace_func);
}
//# sourceMappingURL=string.js.map

/***/ }),
/* 1617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = styled;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__uifabric_merge_styles__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__customizations_Customizations__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__customizations_CustomizerContext__ = __webpack_require__(261);





var DefaultFields = ['theme', 'styles'];
/**
 * The styled HOC wrapper allows you to create a functional wrapper around a given component which will resolve
 * getStyles functional props, and mix customized props passed in using concatStyleSets.
 *
 * @example
 * ```tsx
 * export const Toggle = styled(
 *   ToggleBase,
 *   props => ({ root: { background: 'red' }})
 * );
 * ```
 * @param Component - The unstyled base component to render, which receives styles.
 * @param baseStyles - The styles which should be curried with the component.
 * @param getProps - A helper which provides default props.
 * @param customizable - An object which defines which props can be customized using the Customizer.
 * @param pure - A boolean indicating if the component should avoid re-rendering when props haven't changed.
 * Note that pure should not be used on components which allow children, or take in complex objects or
 * arrays as props which could mutate on every render.
 */
function styled(Component, baseStyles, getProps, customizable, pure) {
    customizable = customizable || { scope: '', fields: undefined };
    var scope = customizable.scope, _a = customizable.fields, fields = _a === void 0 ? DefaultFields : _a;
    var ParentComponent = pure ? __WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"] : __WEBPACK_IMPORTED_MODULE_1_react__["Component"];
    var Wrapped = /** @class */ (function (_super) {
        __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](Wrapped, _super);
        function Wrapped() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this._inCustomizerContext = false;
            _this._renderContent = function (context) {
                _this._inCustomizerContext = !!context.customizations.inCustomizerContext;
                var settings = __WEBPACK_IMPORTED_MODULE_3__customizations_Customizations__["a" /* Customizations */].getSettings(fields, scope, context.customizations);
                var customizedStyles = settings.styles, dir = settings.dir, rest = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __rest */](settings, ["styles", "dir"]);
                var additionalProps = getProps ? getProps(_this.props) : undefined;
                _this._updateStyles(customizedStyles);
                return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Component, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, rest, additionalProps, _this.props, { styles: _this._styles }));
            };
            _this._onSettingsChanged = function () { return _this.forceUpdate(); };
            return _this;
        }
        Wrapped.prototype.render = function () {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__customizations_CustomizerContext__["a" /* CustomizerContext */].Consumer, null, this._renderContent);
        };
        Wrapped.prototype.componentDidMount = function () {
            if (!this._inCustomizerContext) {
                __WEBPACK_IMPORTED_MODULE_3__customizations_Customizations__["a" /* Customizations */].observe(this._onSettingsChanged);
            }
        };
        Wrapped.prototype.componentWillUnmount = function () {
            if (!this._inCustomizerContext) {
                __WEBPACK_IMPORTED_MODULE_3__customizations_Customizations__["a" /* Customizations */].unobserve(this._onSettingsChanged);
            }
        };
        Wrapped.prototype._updateStyles = function (customizedStyles) {
            var _this = this;
            // tslint:disable-next-line:no-any
            if (!this._styles || customizedStyles !== this._styles.__cachedInputs__[1] || !!this.props.styles) {
                // Cache the customized styles.
                // this._customizedStyles = customizedStyles;
                // Using styled components as the Component arg will result in nested styling arrays.
                this._styles = function (styleProps) { return _resolve(styleProps, baseStyles, customizedStyles, _this.props.styles); };
                // The __cachedInputs__ array is attached to the function and consumed by the
                // classNamesFunction as a list of keys to include for memoizing classnames.
                // tslint:disable-next-line:no-any
                this._styles.__cachedInputs__ = [baseStyles, customizedStyles, this.props.styles];
            }
        };
        // Function.prototype.name is an ES6 feature, so the cast to any is required until we're
        // able to drop IE 11 support and compile with ES6 libs
        // tslint:disable-next-line:no-any
        Wrapped.displayName = "Styled" + (Component.displayName || Component.name);
        return Wrapped;
    }(ParentComponent));
    // This preserves backwards compatibility.
    // tslint:disable-next-line:no-any
    return Wrapped;
}
function _resolve(styleProps) {
    var allStyles = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        allStyles[_i - 1] = arguments[_i];
    }
    var result = [];
    for (var _a = 0, allStyles_1 = allStyles; _a < allStyles_1.length; _a++) {
        var styles = allStyles_1[_a];
        if (styles) {
            result.push(typeof styles === 'function' ? styles(styleProps) : styles);
        }
    }
    if (result.length === 1) {
        return result[0];
    }
    else if (result.length) {
        // cliffkoh: I cannot figure out how to avoid the cast to any here.
        // It is something to do with the use of Omit in IStyleSet.
        // It might not be necessary once  Omit becomes part of lib.d.ts (when we remove our own Omit and rely on
        // the official version).
        // tslint:disable-next-line:no-any
        return __WEBPACK_IMPORTED_MODULE_2__uifabric_merge_styles__["b" /* concatStyleSets */].apply(void 0, result);
    }
    return {};
}
//# sourceMappingURL=styled.js.map

/***/ }),
/* 1618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__warn_warn__ = __webpack_require__(259);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__warn_warn__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warn_warnConditionallyRequiredProps__ = __webpack_require__(638);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__warn_warnDeprecations__ = __webpack_require__(640);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__warn_warnDeprecations__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__warn_warnMutuallyExclusive__ = __webpack_require__(639);
/* unused harmony namespace reexport */




//# sourceMappingURL=warn.js.map

/***/ }),
/* 1619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IsFocusVisibleClassName */
/* unused harmony export setFocusVisibility */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_getWindow__ = __webpack_require__(86);

var IsFocusVisibleClassName = 'ms-Fabric--isFocusVisible';
/**
 * Sets the visibility of focus styling.
 * By default, focus styling (the box surrounding a focused Button, for example) only show up when navigational
 * keypresses occur (through TAB, arrows, pgup/down, home and end), and are hidden when mouse interactions occur.
 * This API provides an imperative way to turn them on/off.
 * A use case might be when you have a keypress like ctrl-f6 navigate to a particular region on the page, and want focus to show up.
 *
 * @param enabled - whether to remove or add focus
 * @param target - optional target
 */
function setFocusVisibility(enabled, target) {
    var win = target ? Object(__WEBPACK_IMPORTED_MODULE_0__dom_getWindow__["a" /* getWindow */])(target) : Object(__WEBPACK_IMPORTED_MODULE_0__dom_getWindow__["a" /* getWindow */])();
    if (win) {
        var classList = win.document.body.classList;
        if (enabled) {
            classList.add(IsFocusVisibleClassName);
        }
        else {
            classList.remove(IsFocusVisibleClassName);
        }
    }
}
//# sourceMappingURL=setFocusVisibility.js.map

/***/ }),
/* 1620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uifabric_set_version__ = __webpack_require__(145);
// @uifabric/utilities@6.45.1
// Do not modify this file, the file is generated as part of publish. The checked in version is a placeholder only.

Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_set_version__["a" /* setVersion */])('@uifabric/utilities', '6.45.1');
//# sourceMappingURL=version.js.map

/***/ }),
/* 1621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getIconClassName */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uifabric_merge_styles__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icons__ = __webpack_require__(634);


var defaultIconStyles = {
    display: 'inline-block'
};
/**
 * Gets an icon classname. You should be able to add this classname to an I tag with no
 * additional classnames, and render the icon.
 *
 * @public
 */
function getIconClassName(name) {
    var className = '';
    var icon = Object(__WEBPACK_IMPORTED_MODULE_1__icons__["a" /* getIcon */])(name);
    if (icon) {
        className = Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_merge_styles__["f" /* mergeStyles */])(icon.subset.className, defaultIconStyles, {
            selectors: {
                '::before': {
                    content: "\"" + icon.code + "\""
                }
            }
        });
    }
    return className;
}
//# sourceMappingURL=getIconClassName.js.map

/***/ }),
/* 1622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AnimationVariables; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnimationStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uifabric_merge_styles__ = __webpack_require__(46);

/* Register the keyframes */
var EASING_FUNCTION_1 = 'cubic-bezier(.1,.9,.2,1)';
var EASING_FUNCTION_2 = 'cubic-bezier(.1,.25,.75,.9)';
var DURATION_1 = '0.167s';
var DURATION_2 = '0.267s';
var DURATION_3 = '0.367s';
var DURATION_4 = '0.467s';
var FADE_IN = Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_merge_styles__["d" /* keyframes */])({
    from: { opacity: 0 },
    to: { opacity: 1 }
});
var FADE_OUT = Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_merge_styles__["d" /* keyframes */])({
    from: { opacity: 1 },
    to: { opacity: 0 }
});
var SLIDE_RIGHT_IN10 = _createSlideInX(-10);
var SLIDE_RIGHT_IN20 = _createSlideInX(-20);
var SLIDE_RIGHT_IN40 = _createSlideInX(-40);
var SLIDE_RIGHT_IN400 = _createSlideInX(-400);
var SLIDE_LEFT_IN10 = _createSlideInX(10);
var SLIDE_LEFT_IN20 = _createSlideInX(20);
var SLIDE_LEFT_IN40 = _createSlideInX(40);
var SLIDE_LEFT_IN400 = _createSlideInX(400);
var SLIDE_UP_IN10 = _createSlideInY(10);
var SLIDE_UP_IN20 = _createSlideInY(20);
var SLIDE_DOWN_IN10 = _createSlideInY(-10);
var SLIDE_DOWN_IN20 = _createSlideInY(-20);
var SLIDE_RIGHT_OUT10 = _createSlideOutX(10);
var SLIDE_RIGHT_OUT20 = _createSlideOutX(20);
var SLIDE_RIGHT_OUT40 = _createSlideOutX(40);
var SLIDE_RIGHT_OUT400 = _createSlideOutX(400);
var SLIDE_LEFT_OUT10 = _createSlideOutX(-10);
var SLIDE_LEFT_OUT20 = _createSlideOutX(-20);
var SLIDE_LEFT_OUT40 = _createSlideOutX(-40);
var SLIDE_LEFT_OUT400 = _createSlideOutX(-400);
var SLIDE_UP_OUT10 = _createSlideOutY(-10);
var SLIDE_UP_OUT20 = _createSlideOutY(-20);
var SLIDE_DOWN_OUT10 = _createSlideOutY(10);
var SLIDE_DOWN_OUT20 = _createSlideOutY(20);
var SCALE_UP100 = Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_merge_styles__["d" /* keyframes */])({
    from: { transform: 'scale3d(.98,.98,1)' },
    to: { transform: 'scale3d(1,1,1)' }
});
var SCALE_DOWN98 = Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_merge_styles__["d" /* keyframes */])({
    from: { transform: 'scale3d(1,1,1)' },
    to: { transform: 'scale3d(.98,.98,1)' }
});
var SCALE_DOWN100 = Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_merge_styles__["d" /* keyframes */])({
    from: { transform: 'scale3d(1.03,1.03,1)' },
    to: { transform: 'scale3d(1,1,1)' }
});
var SCALE_UP103 = Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_merge_styles__["d" /* keyframes */])({
    from: { transform: 'scale3d(1,1,1)' },
    to: { transform: 'scale3d(1.03,1.03,1)' }
});
var ROTATE90 = Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_merge_styles__["d" /* keyframes */])({
    from: { transform: 'rotateZ(0deg)' },
    to: { transform: 'rotateZ(90deg)' }
});
var ROTATE_N90 = Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_merge_styles__["d" /* keyframes */])({
    from: { transform: 'rotateZ(0deg)' },
    to: { transform: 'rotateZ(-90deg)' }
});
/**
 * Exporting raw duraction values and easing functions to be used in custom animations
 */
var AnimationVariables = {
    easeFunction1: EASING_FUNCTION_1,
    easeFunction2: EASING_FUNCTION_2,
    durationValue1: DURATION_1,
    durationValue2: DURATION_2,
    durationValue3: DURATION_3,
    durationValue4: DURATION_4
};
/**
 * All Fabric standard animations, exposed as json objects referencing predefined
 * keyframes. These objects can be mixed in with other class definitions.
 */
var AnimationStyles = {
    slideRightIn10: _createAnimation(FADE_IN + "," + SLIDE_RIGHT_IN10, DURATION_3, EASING_FUNCTION_1),
    slideRightIn20: _createAnimation(FADE_IN + "," + SLIDE_RIGHT_IN20, DURATION_3, EASING_FUNCTION_1),
    slideRightIn40: _createAnimation(FADE_IN + "," + SLIDE_RIGHT_IN40, DURATION_3, EASING_FUNCTION_1),
    slideRightIn400: _createAnimation(FADE_IN + "," + SLIDE_RIGHT_IN400, DURATION_3, EASING_FUNCTION_1),
    slideLeftIn10: _createAnimation(FADE_IN + "," + SLIDE_LEFT_IN10, DURATION_3, EASING_FUNCTION_1),
    slideLeftIn20: _createAnimation(FADE_IN + "," + SLIDE_LEFT_IN20, DURATION_3, EASING_FUNCTION_1),
    slideLeftIn40: _createAnimation(FADE_IN + "," + SLIDE_LEFT_IN40, DURATION_3, EASING_FUNCTION_1),
    slideLeftIn400: _createAnimation(FADE_IN + "," + SLIDE_LEFT_IN400, DURATION_3, EASING_FUNCTION_1),
    slideUpIn10: _createAnimation(FADE_IN + "," + SLIDE_UP_IN10, DURATION_3, EASING_FUNCTION_1),
    slideUpIn20: _createAnimation(FADE_IN + "," + SLIDE_UP_IN20, DURATION_3, EASING_FUNCTION_1),
    slideDownIn10: _createAnimation(FADE_IN + "," + SLIDE_DOWN_IN10, DURATION_3, EASING_FUNCTION_1),
    slideDownIn20: _createAnimation(FADE_IN + "," + SLIDE_DOWN_IN20, DURATION_3, EASING_FUNCTION_1),
    slideRightOut10: _createAnimation(FADE_OUT + "," + SLIDE_RIGHT_OUT10, DURATION_3, EASING_FUNCTION_1),
    slideRightOut20: _createAnimation(FADE_OUT + "," + SLIDE_RIGHT_OUT20, DURATION_3, EASING_FUNCTION_1),
    slideRightOut40: _createAnimation(FADE_OUT + "," + SLIDE_RIGHT_OUT40, DURATION_3, EASING_FUNCTION_1),
    slideRightOut400: _createAnimation(FADE_OUT + "," + SLIDE_RIGHT_OUT400, DURATION_3, EASING_FUNCTION_1),
    slideLeftOut10: _createAnimation(FADE_OUT + "," + SLIDE_LEFT_OUT10, DURATION_3, EASING_FUNCTION_1),
    slideLeftOut20: _createAnimation(FADE_OUT + "," + SLIDE_LEFT_OUT20, DURATION_3, EASING_FUNCTION_1),
    slideLeftOut40: _createAnimation(FADE_OUT + "," + SLIDE_LEFT_OUT40, DURATION_3, EASING_FUNCTION_1),
    slideLeftOut400: _createAnimation(FADE_OUT + "," + SLIDE_LEFT_OUT400, DURATION_3, EASING_FUNCTION_1),
    slideUpOut10: _createAnimation(FADE_OUT + "," + SLIDE_UP_OUT10, DURATION_3, EASING_FUNCTION_1),
    slideUpOut20: _createAnimation(FADE_OUT + "," + SLIDE_UP_OUT20, DURATION_3, EASING_FUNCTION_1),
    slideDownOut10: _createAnimation(FADE_OUT + "," + SLIDE_DOWN_OUT10, DURATION_3, EASING_FUNCTION_1),
    slideDownOut20: _createAnimation(FADE_OUT + "," + SLIDE_DOWN_OUT20, DURATION_3, EASING_FUNCTION_1),
    scaleUpIn100: _createAnimation(FADE_IN + "," + SCALE_UP100, DURATION_3, EASING_FUNCTION_1),
    scaleDownIn100: _createAnimation(FADE_IN + "," + SCALE_DOWN100, DURATION_3, EASING_FUNCTION_1),
    scaleUpOut103: _createAnimation(FADE_OUT + "," + SCALE_UP103, DURATION_1, EASING_FUNCTION_2),
    scaleDownOut98: _createAnimation(FADE_OUT + "," + SCALE_DOWN98, DURATION_1, EASING_FUNCTION_2),
    fadeIn100: _createAnimation(FADE_IN, DURATION_1, EASING_FUNCTION_2),
    fadeIn200: _createAnimation(FADE_IN, DURATION_2, EASING_FUNCTION_2),
    fadeIn400: _createAnimation(FADE_IN, DURATION_3, EASING_FUNCTION_2),
    fadeIn500: _createAnimation(FADE_IN, DURATION_4, EASING_FUNCTION_2),
    fadeOut100: _createAnimation(FADE_OUT, DURATION_1, EASING_FUNCTION_2),
    fadeOut200: _createAnimation(FADE_OUT, DURATION_2, EASING_FUNCTION_2),
    fadeOut400: _createAnimation(FADE_OUT, DURATION_3, EASING_FUNCTION_2),
    fadeOut500: _createAnimation(FADE_OUT, DURATION_4, EASING_FUNCTION_2),
    rotate90deg: _createAnimation(ROTATE90, '0.1s', EASING_FUNCTION_2),
    rotateN90deg: _createAnimation(ROTATE_N90, '0.1s', EASING_FUNCTION_2)
    // expandCollapse 100/200/400, delay 100/200
};
function _createAnimation(animationName, animationDuration, animationTimingFunction) {
    return {
        animationName: animationName,
        animationDuration: animationDuration,
        animationTimingFunction: animationTimingFunction,
        animationFillMode: 'both'
    };
}
function _createSlideInX(fromX) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_merge_styles__["d" /* keyframes */])({
        from: { transform: "translate3d(" + fromX + "px,0,0)" },
        to: { transform: "translate3d(0,0,0)" }
    });
}
function _createSlideInY(fromY) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_merge_styles__["d" /* keyframes */])({
        from: { transform: "translate3d(0," + fromY + "px,0)" },
        to: { transform: "translate3d(0,0,0)" }
    });
}
function _createSlideOutX(toX) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_merge_styles__["d" /* keyframes */])({
        from: { transform: "translate3d(0,0,0)" },
        to: { transform: "translate3d(" + toX + "px,0,0)" }
    });
}
function _createSlideOutY(toY) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_merge_styles__["d" /* keyframes */])({
        from: { transform: "translate3d(0,0,0)" },
        to: { transform: "translate3d(0," + toY + "px,0)" }
    });
}
//# sourceMappingURL=AnimationStyles.js.map

/***/ }),
/* 1623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getFocusStyle;
/* harmony export (immutable) */ __webpack_exports__["a"] = focusClear;
/* unused harmony export getFocusOutlineStyle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CommonStyles__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__zIndexes__ = __webpack_require__(655);



function getFocusStyle(theme, insetOrOptions, position, highContrastStyle, borderColor, outlineColor, isFocusedOnly) {
    if (typeof insetOrOptions === 'number' || !insetOrOptions) {
        return _getFocusStyleInternal(theme, { inset: insetOrOptions, position: position, highContrastStyle: highContrastStyle, borderColor: borderColor, outlineColor: outlineColor, isFocusedOnly: isFocusedOnly });
    }
    else {
        return _getFocusStyleInternal(theme, insetOrOptions);
    }
}
function _getFocusStyleInternal(theme, options) {
    if (options === void 0) { options = {}; }
    var _a = options.inset, inset = _a === void 0 ? 0 : _a, _b = options.width, width = _b === void 0 ? 1 : _b, _c = options.position, position = _c === void 0 ? 'relative' : _c, highContrastStyle = options.highContrastStyle, _d = options.borderColor, borderColor = _d === void 0 ? theme.palette.white : _d, _e = options.outlineColor, outlineColor = _e === void 0 ? theme.palette.neutralSecondary : _e, _f = options.isFocusedOnly, isFocusedOnly = _f === void 0 ? true : _f;
    return {
        // Clear browser-specific focus styles and use 'transparent' as placeholder for focus style.
        outline: 'transparent',
        // Requirement because pseudo-element is absolutely positioned.
        position: position,
        selectors: (_g = {
                // Clear the focus border in Firefox.
                // Reference: http://stackoverflow.com/a/199319/1436671
                '::-moz-focus-inner': {
                    border: '0'
                }
            },
            // When the element that uses this mixin is in a :focus state, add a pseudo-element to
            // create a border.
            _g["." + __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["j" /* IsFocusVisibleClassName */] + " &" + (isFocusedOnly ? ':focus' : '') + ":after"] = {
                content: '""',
                position: 'absolute',
                left: inset + 1,
                top: inset + 1,
                bottom: inset + 1,
                right: inset + 1,
                border: width + "px solid " + borderColor,
                outline: width + "px solid " + outlineColor,
                zIndex: __WEBPACK_IMPORTED_MODULE_2__zIndexes__["a" /* ZIndexes */].FocusStyle,
                selectors: (_h = {},
                    _h[__WEBPACK_IMPORTED_MODULE_0__CommonStyles__["a" /* HighContrastSelector */]] = highContrastStyle,
                    _h)
            },
            _g)
    };
    var _g, _h;
}
/**
 * Generates style to clear browser specific focus styles.
 */
function focusClear() {
    return {
        selectors: {
            '&::-moz-focus-inner': {
                // Clear the focus border in Firefox. Reference: http://stackoverflow.com/a/199319/1436671
                border: 0
            },
            '&': {
                // Clear browser specific focus styles and use transparent as placeholder for focus style
                outline: 'transparent'
            }
        }
    };
}
/**
 * Generates a style which can be used to set a border on focus.
 *
 * @param theme - The theme object to use.
 * @param inset - The number of pixels to inset the border (default 0)
 * @param width - The border width in pixels (default 1)
 * @param color - Color of the outline (default `theme.palette.neutralSecondary`)
 * @returns The style object.
 */
function getFocusOutlineStyle(theme, inset, width, color) {
    if (inset === void 0) { inset = 0; }
    if (width === void 0) { width = 1; }
    return {
        selectors: (_a = {},
            _a[":global(" + __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["j" /* IsFocusVisibleClassName */] + ") &:focus"] = {
                outline: width + " solid " + (color || theme.palette.neutralSecondary),
                outlineOffset: -inset + "px"
            },
            _a)
    };
    var _a;
}
//# sourceMappingURL=getFocusStyle.js.map

/***/ }),
/* 1624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hiddenContentStyle; });
var hiddenContentStyle = {
    position: 'absolute',
    width: 1,
    height: 1,
    margin: -1,
    padding: 0,
    border: 0,
    overflow: 'hidden'
};
//# sourceMappingURL=hiddenContentStyle.js.map

/***/ }),
/* 1625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PulsingBeaconAnimationStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__uifabric_merge_styles__ = __webpack_require__(46);


var DEFAULT_DURATION = '14s';
var DEFAULT_DELAY = '2s';
var DEFAULT_ITERATION_COUNT = '1';
function _continuousPulseStepOne(beaconColorOne, innerDimension) {
    return {
        borderColor: beaconColorOne,
        borderWidth: '0px',
        width: innerDimension,
        height: innerDimension
    };
}
function _continuousPulseStepTwo(borderWidth) {
    return {
        opacity: 1,
        borderWidth: borderWidth
    };
}
function _continuousPulseStepThree() {
    return {
        opacity: 1
    };
}
function _continuousPulseStepFour(beaconColorTwo, outerDimension) {
    return {
        borderWidth: '0',
        width: outerDimension,
        height: outerDimension,
        opacity: 0,
        borderColor: beaconColorTwo
    };
}
function _continuousPulseStepFive(beaconColorOne, innerDimension) {
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, _continuousPulseStepOne(beaconColorOne, innerDimension), {
        opacity: 0
    });
}
function _continuousPulseAnimationDouble(beaconColorOne, beaconColorTwo, innerDimension, outerDimension, borderWidth) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__uifabric_merge_styles__["d" /* keyframes */])({
        '0%': _continuousPulseStepOne(beaconColorOne, innerDimension),
        '1.42%': _continuousPulseStepTwo(borderWidth),
        '3.57%': _continuousPulseStepThree(),
        '7.14%': _continuousPulseStepFour(beaconColorTwo, outerDimension),
        '8%': _continuousPulseStepFive(beaconColorOne, innerDimension),
        '29.99%': _continuousPulseStepFive(beaconColorOne, innerDimension),
        '30%': _continuousPulseStepOne(beaconColorOne, innerDimension),
        '31.42%': _continuousPulseStepTwo(borderWidth),
        '33.57%': _continuousPulseStepThree(),
        '37.14%': _continuousPulseStepFour(beaconColorTwo, outerDimension),
        '38%': _continuousPulseStepFive(beaconColorOne, innerDimension),
        '79.42%': _continuousPulseStepFive(beaconColorOne, innerDimension),
        '79.43': _continuousPulseStepOne(beaconColorOne, innerDimension),
        '81.85': _continuousPulseStepTwo(borderWidth),
        '83.42': _continuousPulseStepThree(),
        '87%': _continuousPulseStepFour(beaconColorTwo, outerDimension),
        '100%': {}
    });
}
function _continuousPulseAnimationSingle(beaconColorOne, beaconColorTwo, innerDimension, outerDimension, borderWidth) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__uifabric_merge_styles__["d" /* keyframes */])({
        '0%': _continuousPulseStepOne(beaconColorOne, innerDimension),
        '14.2%': _continuousPulseStepTwo(borderWidth),
        '35.7%': _continuousPulseStepThree(),
        '71.4%': _continuousPulseStepFour(beaconColorTwo, outerDimension),
        '100%': {}
    });
}
function _createDefaultAnimation(animationName, delayLength) {
    return {
        animationName: animationName,
        animationIterationCount: DEFAULT_ITERATION_COUNT,
        animationDuration: DEFAULT_DURATION,
        animationDelay: delayLength || DEFAULT_DELAY
    };
}
var PulsingBeaconAnimationStyles = {
    continuousPulseAnimationDouble: _continuousPulseAnimationDouble,
    continuousPulseAnimationSingle: _continuousPulseAnimationSingle,
    createDefaultAnimation: _createDefaultAnimation
};
//# sourceMappingURL=PulsingBeaconAnimationStyles.js.map

/***/ }),
/* 1626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getGlobalClassNames;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uifabric_merge_styles__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__ = __webpack_require__(61);


/**
 * Internal memoized function which simply takes in the class map and the
 * disable boolean. These immutable values can be memoized.
 */
var _getGlobalClassNames = Object(__WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_23" /* memoizeFunction */])(function (classNames, disableGlobalClassNames) {
    var styleSheet = __WEBPACK_IMPORTED_MODULE_0__uifabric_merge_styles__["a" /* Stylesheet */].getInstance();
    if (disableGlobalClassNames) {
        // disable global classnames
        return Object.keys(classNames).reduce(function (acc, className) {
            acc[className] = styleSheet.getClassName(classNames[className]);
            return acc;
        }, {});
    }
    // use global classnames
    return classNames;
});
/**
 * Checks for the `disableGlobalClassNames` property on the `theme` to determine if it should return `classNames`
 * Note that calls to this function are memoized.
 *
 * @param classNames - The collection of global class names that apply when the flag is false. Make sure to pass in
 * the same instance on each call to benefit from memoization.
 * @param theme - The theme to check the flag on
 * @param disableGlobalClassNames - Optional. Explicitly opt in/out of disabling global classnames. Defaults to false.
 */
function getGlobalClassNames(classNames, theme, disableGlobalClassNames) {
    return _getGlobalClassNames(classNames, disableGlobalClassNames !== undefined ? disableGlobalClassNames : theme.disableGlobalClassNames);
}
//# sourceMappingURL=getGlobalClassNames.js.map

/***/ }),
/* 1627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getThemedContext;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uifabric_utilities__ = __webpack_require__(61);

/**
 * @internal
 * This function is still in experimental phase in support of Foundation experimental development. Its API signature and existence
 * are subject to change.
 *
 * Modify context to activate the specified scheme or theme. For schemes, look in context (if available) and fall back to global
 * Customizations. If both scheme and theme are specified, scheme will be looked up in theme. In this case, scheme must be
 * present in theme arg, otherwise new context will default to theme arg (there is no fallback to settings to look up scheme.)
 *
 * @param context - Context in which to get schemed customizations.
 * @param scheme - Scheme to get customizations for from theme arg (if supplied) OR from context and global settings.
 * @param theme - Theme to merge into context.
 * @returns modified schemed context if scheme is valid and not already applied, unmodified context otherwise.
 */
function getThemedContext(context, scheme, theme) {
    var newContext = context;
    var newSettings;
    // Only fall back to context and customizations when theme arg is not provided.
    var schemeSource = theme || __WEBPACK_IMPORTED_MODULE_0__uifabric_utilities__["d" /* Customizations */].getSettings(['theme'], undefined, context.customizations).theme;
    if (theme) {
        newSettings = { theme: theme };
    }
    var schemeTheme = scheme && schemeSource && schemeSource.schemes && schemeSource.schemes[scheme];
    // These first two checks are logically redundant but TS doesn't infer schemeSource.schemes is defined when schemeTheme is defined.
    if (schemeSource && schemeTheme && schemeSource !== schemeTheme) {
        newSettings = { theme: schemeTheme };
        newSettings.theme.schemes = schemeSource.schemes;
    }
    if (newSettings) {
        newContext = {
            customizations: {
                settings: Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_utilities__["_26" /* mergeSettings */])(context.customizations.settings, newSettings),
                scopedSettings: context.customizations.scopedSettings
            }
        };
    }
    return newContext;
}
//# sourceMappingURL=scheme.js.map

/***/ }),
/* 1628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ThemeSettingName */
/* harmony export (immutable) */ __webpack_exports__["a"] = getTheme;
/* unused harmony export registerOnThemeChangeCallback */
/* unused harmony export removeOnThemeChangeCallback */
/* harmony export (immutable) */ __webpack_exports__["b"] = loadTheme;
/* unused harmony export createTheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DefaultFontStyles__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DefaultPalette__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DefaultSpacing__ = __webpack_require__(1629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__microsoft_load_themed_styles__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DefaultEffects__ = __webpack_require__(1630);







var _theme = createTheme({
    palette: __WEBPACK_IMPORTED_MODULE_3__DefaultPalette__["a" /* DefaultPalette */],
    semanticColors: _makeSemanticColorsFromPalette(__WEBPACK_IMPORTED_MODULE_3__DefaultPalette__["a" /* DefaultPalette */], false, false),
    fonts: __WEBPACK_IMPORTED_MODULE_2__DefaultFontStyles__["a" /* DefaultFontStyles */],
    isInverted: false,
    disableGlobalClassNames: false
});
var _onThemeChangeCallbacks = [];
var ThemeSettingName = 'theme';
if (!__WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["d" /* Customizations */].getSettings([ThemeSettingName]).theme) {
    var win = Object(__WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_7" /* getWindow */])();
    // tslint:disable:no-string-literal no-any
    if (win && win['FabricConfig'] && win['FabricConfig'].theme) {
        _theme = createTheme(win['FabricConfig'].theme);
    }
    // tslint:enable:no-string-literal no-any
    // Set the default theme.
    __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["d" /* Customizations */].applySettings((_a = {}, _a[ThemeSettingName] = _theme, _a));
}
/**
 * Gets the theme object
 * @param depComments - Whether to include deprecated tags as comments for deprecated slots.
 */
function getTheme(depComments) {
    if (depComments === void 0) { depComments = false; }
    if (depComments === true) {
        _theme = createTheme({}, depComments);
    }
    return _theme;
}
/**
 * Registers a callback that gets called whenever the theme changes.
 * This should only be used when the component cannot automatically get theme changes through its state.
 * This will not register duplicate callbacks.
 */
function registerOnThemeChangeCallback(callback) {
    if (_onThemeChangeCallbacks.indexOf(callback) === -1) {
        _onThemeChangeCallbacks.push(callback);
    }
}
/**
 * See registerOnThemeChangeCallback().
 * Removes previously registered callbacks.
 */
function removeOnThemeChangeCallback(callback) {
    var i = _onThemeChangeCallbacks.indexOf(callback);
    if (i === -1) {
        return;
    }
    _onThemeChangeCallbacks.splice(i, 1);
}
/**
 * Applies the theme, while filling in missing slots.
 * @param theme - Partial theme object.
 * @param depComments - Whether to include deprecated tags as comments for deprecated slots.
 */
function loadTheme(theme, depComments) {
    if (depComments === void 0) { depComments = false; }
    _theme = createTheme(theme, depComments);
    // Invoke the legacy method of theming the page as well.
    Object(__WEBPACK_IMPORTED_MODULE_5__microsoft_load_themed_styles__["b" /* loadTheme */])(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, _theme.palette, _theme.semanticColors, _theme.effects, _loadFonts(_theme)));
    __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["d" /* Customizations */].applySettings((_a = {}, _a[ThemeSettingName] = _theme, _a));
    _onThemeChangeCallbacks.forEach(function (callback) {
        try {
            callback(_theme);
        }
        catch (e) {
            // don't let a bad callback break everything else
        }
    });
    return _theme;
    var _a;
}
/**
 * Loads font variables into a JSON object.
 * @param theme - The theme object
 */
function _loadFonts(theme) {
    var lines = {};
    for (var _i = 0, _a = Object.keys(theme.fonts); _i < _a.length; _i++) {
        var fontName = _a[_i];
        var font = theme.fonts[fontName];
        for (var _b = 0, _c = Object.keys(font); _b < _c.length; _b++) {
            var propName = _c[_b];
            var name_1 = fontName + propName.charAt(0).toUpperCase() + propName.slice(1);
            var value = font[propName];
            if (propName === 'fontSize' && typeof value === 'number') {
                value = value + 'px';
            }
            lines[name_1] = value;
        }
    }
    return lines;
}
/**
 * Creates a custom theme definition which can be used with the Customizer.
 * @param theme - Partial theme object.
 * @param depComments - Whether to include deprecated tags as comments for deprecated slots.
 */
function createTheme(theme, depComments) {
    if (depComments === void 0) { depComments = false; }
    var newPalette = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, __WEBPACK_IMPORTED_MODULE_3__DefaultPalette__["a" /* DefaultPalette */], theme.palette);
    if (!theme.palette || !theme.palette.accent) {
        newPalette.accent = newPalette.themePrimary;
    }
    // mix in custom overrides with good slots first, since custom overrides might be used in fixing deprecated slots
    var newSemanticColors = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, _makeSemanticColorsFromPalette(newPalette, !!theme.isInverted, depComments), theme.semanticColors);
    var defaultFontStyles = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, __WEBPACK_IMPORTED_MODULE_2__DefaultFontStyles__["a" /* DefaultFontStyles */]);
    if (theme.defaultFontStyle) {
        for (var _i = 0, _a = Object.keys(defaultFontStyles); _i < _a.length; _i++) {
            var fontStyle = _a[_i];
            defaultFontStyles[fontStyle] = Object(__WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_24" /* merge */])({}, defaultFontStyles[fontStyle], theme.defaultFontStyle);
        }
    }
    if (theme.fonts) {
        for (var _b = 0, _c = Object.keys(theme.fonts); _b < _c.length; _b++) {
            var fontStyle = _c[_b];
            defaultFontStyles[fontStyle] = Object(__WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_24" /* merge */])({}, defaultFontStyles[fontStyle], theme.fonts[fontStyle]);
        }
    }
    return {
        palette: newPalette,
        fonts: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, defaultFontStyles),
        semanticColors: newSemanticColors,
        isInverted: !!theme.isInverted,
        disableGlobalClassNames: !!theme.disableGlobalClassNames,
        spacing: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, __WEBPACK_IMPORTED_MODULE_4__DefaultSpacing__["a" /* DefaultSpacing */], theme.spacing),
        effects: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, __WEBPACK_IMPORTED_MODULE_6__DefaultEffects__["a" /* DefaultEffects */], theme.effects)
    };
}
/**
 * Helper to pull a given property name from a given set of sources, in order, if available. Otherwise returns the property name.
 */
function _expandFrom(propertyName) {
    var maps = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        maps[_i - 1] = arguments[_i];
    }
    if (propertyName) {
        for (var _a = 0, maps_1 = maps; _a < maps_1.length; _a++) {
            var map = maps_1[_a];
            if (map[propertyName]) {
                return map[propertyName];
            }
        }
    }
    return propertyName;
}
// Generates all the semantic slot colors based on the Fabric palette.
// We'll use these as fallbacks for semantic slots that the passed in theme did not define.
function _makeSemanticColorsFromPalette(p, isInverted, depComments) {
    var toReturn = {
        bodyBackground: p.white,
        bodyStandoutBackground: p.neutralLighterAlt,
        bodyFrameBackground: p.white,
        bodyFrameDivider: p.neutralLight,
        bodyText: p.neutralPrimary,
        bodyTextChecked: p.black,
        bodySubtext: p.neutralSecondary,
        bodyDivider: p.neutralLight,
        disabledBackground: p.neutralLighter,
        disabledText: p.neutralTertiary,
        disabledBodyText: p.neutralTertiary,
        disabledSubtext: p.neutralQuaternary,
        disabledBodySubtext: p.neutralTertiaryAlt,
        focusBorder: p.neutralSecondary,
        variantBorder: p.neutralLight,
        variantBorderHovered: p.neutralTertiary,
        defaultStateBackground: p.neutralLighterAlt,
        errorText: !isInverted ? p.redDark : '#ff5f5f',
        warningText: !isInverted ? '#333333' : '#ffffff',
        successText: !isInverted ? '#107C10' : '#92c353',
        errorBackground: !isInverted ? 'rgba(232, 17, 35, .2)' : 'rgba(232, 17, 35, .5)',
        blockingBackground: !isInverted ? 'rgba(234, 67, 0, .2)' : 'rgba(234, 67, 0, .5)',
        warningBackground: !isInverted ? 'rgba(255, 185, 0, .2)' : 'rgba(255, 251, 0, .6)',
        warningHighlight: !isInverted ? '#ffb900' : '#fff100',
        successBackground: !isInverted ? 'rgba(186, 216, 10, .2)' : 'rgba(186, 216, 10, .4)',
        inputBorder: p.neutralTertiary,
        inputBorderHovered: p.neutralPrimary,
        inputBackground: p.white,
        inputBackgroundChecked: p.themePrimary,
        inputBackgroundCheckedHovered: p.themeDarkAlt,
        inputForegroundChecked: p.white,
        inputFocusBorderAlt: p.themePrimary,
        smallInputBorder: p.neutralSecondary,
        inputText: p.neutralPrimary,
        inputTextHovered: p.neutralDark,
        inputPlaceholderText: p.neutralSecondary,
        buttonBackground: p.neutralLighter,
        buttonBackgroundChecked: p.neutralTertiaryAlt,
        buttonBackgroundHovered: p.neutralLight,
        buttonBackgroundCheckedHovered: p.neutralLight,
        buttonBackgroundPressed: p.neutralLight,
        buttonBackgroundDisabled: p.neutralLighter,
        buttonBorder: 'transparent',
        buttonText: p.neutralPrimary,
        buttonTextHovered: p.neutralDark,
        buttonTextChecked: p.neutralDark,
        buttonTextCheckedHovered: p.black,
        buttonTextPressed: p.neutralDark,
        buttonTextDisabled: p.neutralTertiary,
        buttonBorderDisabled: 'transparent',
        primaryButtonBackground: p.themePrimary,
        primaryButtonBackgroundHovered: p.themeDarkAlt,
        primaryButtonBackgroundPressed: p.themeDark,
        primaryButtonBackgroundDisabled: p.neutralLighter,
        primaryButtonBorder: 'transparent',
        primaryButtonText: p.white,
        primaryButtonTextHovered: p.white,
        primaryButtonTextPressed: p.white,
        primaryButtonTextDisabled: p.neutralQuaternary,
        accentButtonBackground: p.accent,
        accentButtonText: p.white,
        menuBackground: p.white,
        menuDivider: p.neutralTertiaryAlt,
        menuIcon: p.themePrimary,
        menuHeader: p.themePrimary,
        menuItemBackgroundHovered: p.neutralLighter,
        menuItemBackgroundPressed: p.neutralLight,
        menuItemText: p.neutralPrimary,
        menuItemTextHovered: p.neutralDark,
        listBackground: p.white,
        listText: p.neutralPrimary,
        listItemBackgroundHovered: p.neutralLighter,
        listItemBackgroundChecked: p.neutralLight,
        listItemBackgroundCheckedHovered: p.neutralQuaternaryAlt,
        listHeaderBackgroundHovered: p.neutralLighter,
        listHeaderBackgroundPressed: p.neutralLight,
        actionLink: p.neutralPrimary,
        actionLinkHovered: p.neutralDark,
        link: p.themePrimary,
        linkHovered: p.themeDarker,
        // Deprecated slots, second pass by _fixDeprecatedSlots() later for self-referential slots
        listTextColor: '',
        menuItemBackgroundChecked: p.neutralLight
    };
    return _fixDeprecatedSlots(toReturn, depComments);
}
function _fixDeprecatedSlots(s, depComments) {
    // Add @deprecated tag as comment if enabled
    var dep = '';
    if (depComments === true) {
        dep = ' /* @deprecated */';
    }
    s.listTextColor = s.listText + dep;
    s.menuItemBackgroundChecked += dep;
    return s;
}
var _a;
//# sourceMappingURL=theme.js.map

/***/ }),
/* 1629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DefaultSpacing; });
var DefaultSpacing = {
    s2: '4px',
    s1: '8px',
    m: '16px',
    l1: '20px',
    l2: '32px'
};
//# sourceMappingURL=DefaultSpacing.js.map

/***/ }),
/* 1630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DefaultEffects; });
var DefaultEffects = {
    // commented values are the defaults for Fluent
    elevation4: '0 0 5px 0 rgba(0,0,0,.4)',
    elevation8: '0 0 5px 0 rgba(0,0,0,.4)',
    elevation16: '0 0 5px 0 rgba(0,0,0,.4)',
    elevation64: '0 0 5px 0 rgba(0,0,0,.4)',
    roundedCorner2: '0px' // 2
};
//# sourceMappingURL=DefaultEffects.js.map

/***/ }),
/* 1631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return normalize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return noWrap; });
// This file mimics styles and mixins from _General.Mixins.scss
var normalize = {
    boxShadow: 'none',
    margin: 0,
    padding: 0,
    boxSizing: 'border-box'
};
var noWrap = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
};
//# sourceMappingURL=GeneralStyles.js.map

/***/ }),
/* 1632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getFadedOverflowStyle */
var DEFAULT_HEIGHT = '50%';
var DEFAULT_WIDTH = 20;
/**
 * - Generates a style used to fade out an overflowing content by defining a style for an :after pseudo element.
 * - Apply it to the :after selector for all combination of states the parent of content might have (normal, hover, selected, focus).
 * - Requires the target to have position set to relative and overflow set to hidden.
 *
 * @example
 * ```tsx
 * // Assuming the following DOM structure and the different background colors coming from the parent holding the content.
 * <div className={classNames.parent}>
 *   <span className={classNames.content}>Overflown Content</span>
 * </div>
 * ```
 * ```ts
 * // This is how the style set would look in Component.styles.ts
 * const { bodyBackground } = theme.semanticColors;
 * const { neutralLighter } = theme.palette;
 *
 * // The second argument of getFadedOverflowStyle function is a string representing a key of ISemanticColors or IPalette.
 *
 * const styles = {
 *   parent: [
 *     backgroundColor: bodyBackground,
 *     selectors: {
 *       '&:hover: {
 *         backgroundColor: neutralLighter
 *       },
 *       '$content:after': {
 *         ...getFadedOverflowStyle(theme, 'bodyBackground')
 *       },
 *       '&:hover $content:after': {
 *         ...getFadedOverflowStyle(theme, 'neutralLighter')
 *       }
 *     }
 *   ],
 *   content: [
 *     width: '100%',
 *     display: 'inline-block',
 *     position: 'relative',
 *     overflow: 'hidden'
 *   ]
 * }
 * ```
 * @param theme - The theme object to use.
 * @param color - The background color to fade out to. Accepts only keys of ISemanticColors or IPalette. Defaults to 'bodyBackground'.
 * @param direction - The direction of the overflow. Defaults to horizontal.
 * @param width - The width of the fading overflow. Vertical direction defaults it to 100% vs 20px when horizontal.
 * @param height - The Height of the fading overflow. Vertical direction defaults it to 50% vs 100% when horizontal.
 * @returns The style object.
 */
function getFadedOverflowStyle(theme, color, direction, width, height) {
    if (color === void 0) { color = 'bodyBackground'; }
    if (direction === void 0) { direction = 'horizontal'; }
    if (width === void 0) { width = getDefaultValue('width', direction); }
    if (height === void 0) { height = getDefaultValue('height', direction); }
    // Get the color value string from the theme semanticColors or palette.
    var colorValue = theme.semanticColors[color] || theme.palette[color];
    // Get the red, green, blue values of the colorValue.
    var rgbColor = color2rgb(colorValue);
    // Apply opacity 0 to serve as a start color of the gradient.
    var rgba = "rgba(" + rgbColor.r + ", " + rgbColor.g + ", " + rgbColor.b + ", 0)";
    // Get the direction of the gradient.
    var gradientDirection = direction === 'vertical' ? 'to bottom' : 'to right'; // mergeStyles take care of RTL direction.
    return {
        content: '""',
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: width,
        height: height,
        pointerEvents: 'none',
        backgroundImage: "linear-gradient(" + gradientDirection + ", " + rgba + " 0%, " + colorValue + " 100%)"
    };
}
// TODO consider moving this to a separate module along with some more color functions from OUFR/utilities.
/**
 * Helper function to convert a string hex color to an RGB object.
 *
 * @param colorValue - Color to be converted from hex to rgba.
 */
function color2rgb(colorValue) {
    if (colorValue[0] === '#') {
        // If it's a hex code
        return {
            r: parseInt(colorValue.slice(1, 3), 16),
            g: parseInt(colorValue.slice(3, 5), 16),
            b: parseInt(colorValue.slice(5, 7), 16)
        };
    }
    else if (colorValue.indexOf('rgba(') === 0) {
        // If it's an rgba color string
        colorValue = colorValue.match(/rgba\(([^)]+)\)/)[1];
        var parts = colorValue.split(/ *, */).map(Number);
        return {
            r: parts[0],
            g: parts[1],
            b: parts[2]
        };
    }
    // The only remaining possibility is transparent.
    return {
        r: 255,
        g: 255,
        b: 255
    };
}
/**
 * Helper function to get the default values for parameters of main function.
 *
 * @param style - Which style to get the default value for.
 * @param direction - What direction to take into consideration.
 */
function getDefaultValue(style, direction) {
    if (style === 'width') {
        return direction === 'horizontal' ? DEFAULT_WIDTH : '100%';
    }
    else {
        return direction === 'vertical' ? DEFAULT_HEIGHT : '100%';
    }
}
//# sourceMappingURL=getFadedOverflowStyle.js.map

/***/ }),
/* 1633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getPlaceholderStyles;
/**
 * Generates placeholder style for each of the browsers supported by office-ui-fabric-react.
 * @param styles - The style to use.
 * @returns The placeholder style object for each browser depending on the placeholder directive it uses.
 */
function getPlaceholderStyles(styles) {
    return {
        selectors: {
            '::placeholder': styles,
            ':-ms-input-placeholder': styles,
            '::-ms-input-placeholder': styles // Edge
        }
    };
}
//# sourceMappingURL=getPlaceholderStyles.js.map

/***/ }),
/* 1634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FontClassNames */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_buildClassMap__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_DefaultFontStyles__ = __webpack_require__(389);


/**
 * {@docCategory FontClassNames}
 */
var FontClassNames = Object(__WEBPACK_IMPORTED_MODULE_0__utilities_buildClassMap__["a" /* buildClassMap */])(__WEBPACK_IMPORTED_MODULE_1__styles_DefaultFontStyles__["a" /* DefaultFontStyles */]);
//# sourceMappingURL=FontClassNames.js.map

/***/ }),
/* 1635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ColorClassNames */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uifabric_merge_styles__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_DefaultPalette__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_index__ = __webpack_require__(387);



var ColorClassNames = {};
for (var colorName in __WEBPACK_IMPORTED_MODULE_1__styles_DefaultPalette__["a" /* DefaultPalette */]) {
    if (__WEBPACK_IMPORTED_MODULE_1__styles_DefaultPalette__["a" /* DefaultPalette */].hasOwnProperty(colorName)) {
        // Foreground color
        _defineGetter(ColorClassNames, colorName, '', false, 'color');
        // Hover color
        _defineGetter(ColorClassNames, colorName, 'Hover', true, 'color');
        // Background color
        _defineGetter(ColorClassNames, colorName, 'Background', false, 'background');
        // Background hover
        _defineGetter(ColorClassNames, colorName, 'BackgroundHover', true, 'background');
        // Border color
        _defineGetter(ColorClassNames, colorName, 'Border', false, 'borderColor');
        // Border hover color
        _defineGetter(ColorClassNames, colorName, 'BorderHover', true, 'borderColor');
    }
}
/**
 * Defines a getter for the given class configuration.
 */
function _defineGetter(obj, colorName, suffix, isHover, cssProperty) {
    Object.defineProperty(obj, colorName + suffix, {
        get: function () {
            // tslint:disable-next-line:no-any
            var style = (_a = {}, _a[cssProperty] = Object(__WEBPACK_IMPORTED_MODULE_2__styles_index__["x" /* getTheme */])().palette[colorName], _a);
            return Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_merge_styles__["f" /* mergeStyles */])(isHover ? { selectors: { ':hover': style } } : style).toString();
            var _a;
        },
        enumerable: true,
        configurable: true
    });
}
//# sourceMappingURL=ColorClassNames.js.map

/***/ }),
/* 1636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uifabric_set_version__ = __webpack_require__(145);
// @uifabric/styling@6.50.6
// Do not modify this file, the file is generated as part of publish. The checked in version is a placeholder only.

Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_set_version__["a" /* setVersion */])('@uifabric/styling', '6.50.6');
//# sourceMappingURL=version.js.map

/***/ }),
/* 1637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialize */
/* unused harmony export ga */
/* unused harmony export set */
/* unused harmony export send */
/* unused harmony export pageview */
/* unused harmony export modalview */
/* unused harmony export timing */
/* unused harmony export event */
/* unused harmony export exception */
/* unused harmony export plugin */
/* unused harmony export outboundLink */
/* unused harmony export testModeAPI */
/* unused harmony export OutboundLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__ = __webpack_require__(1638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core__ = __webpack_require__(1639);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var initialize = __WEBPACK_IMPORTED_MODULE_1__core__["initialize"];
var ga = __WEBPACK_IMPORTED_MODULE_1__core__["ga"];
var set = __WEBPACK_IMPORTED_MODULE_1__core__["set"];
var send = __WEBPACK_IMPORTED_MODULE_1__core__["send"];
var pageview = __WEBPACK_IMPORTED_MODULE_1__core__["pageview"];
var modalview = __WEBPACK_IMPORTED_MODULE_1__core__["modalview"];
var timing = __WEBPACK_IMPORTED_MODULE_1__core__["timing"];
var event = __WEBPACK_IMPORTED_MODULE_1__core__["event"];
var exception = __WEBPACK_IMPORTED_MODULE_1__core__["exception"];
var plugin = __WEBPACK_IMPORTED_MODULE_1__core__["plugin"];
var outboundLink = __WEBPACK_IMPORTED_MODULE_1__core__["outboundLink"];
var testModeAPI = __WEBPACK_IMPORTED_MODULE_1__core__["testModeAPI"];
__WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__["a" /* default */].origTrackLink = __WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__["a" /* default */].trackLink;
__WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__["a" /* default */].trackLink = __WEBPACK_IMPORTED_MODULE_1__core__["outboundLink"];
var OutboundLink = __WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (_objectSpread({}, __WEBPACK_IMPORTED_MODULE_1__core__, {
  OutboundLink: OutboundLink
}));

/***/ }),
/* 1638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OutboundLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_console_warn__ = __webpack_require__(390);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var NEWTAB = '_blank';
var MIDDLECLICK = 1;

var OutboundLink =
/*#__PURE__*/
function (_Component) {
  _inherits(OutboundLink, _Component);

  function OutboundLink() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, OutboundLink);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(OutboundLink)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
      var _this$props = _this.props,
          target = _this$props.target,
          eventLabel = _this$props.eventLabel,
          to = _this$props.to,
          onClick = _this$props.onClick,
          trackerNames = _this$props.trackerNames;
      var eventMeta = {
        label: eventLabel
      };
      var sameTarget = target !== NEWTAB;
      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);

      if (sameTarget && normalClick) {
        event.preventDefault();
        OutboundLink.trackLink(eventMeta, function () {
          window.location.href = to;
        }, trackerNames);
      } else {
        OutboundLink.trackLink(eventMeta, function () {}, trackerNames);
      }

      if (onClick) {
        onClick(event);
      }
    });

    return _this;
  }

  _createClass(OutboundLink, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          href = _this$props2.to,
          oldProps = _objectWithoutProperties(_this$props2, ["to"]);

      var props = _objectSpread({}, oldProps, {
        href: href,
        onClick: this.handleClick
      });

      if (this.props.target === NEWTAB) {
        props.rel = 'noopener noreferrer';
      }

      delete props.eventLabel;
      delete props.trackerNames;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', props);
    }
  }]);

  return OutboundLink;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(OutboundLink, "trackLink", function () {
  Object(__WEBPACK_IMPORTED_MODULE_2__utils_console_warn__["a" /* default */])('ga tracking not enabled');
});

_defineProperty(OutboundLink, "propTypes", {
  eventLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  trackerNames: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)
});

_defineProperty(OutboundLink, "defaultProps", {
  target: null,
  to: null,
  onClick: null,
  trackerNames: null
});



/***/ }),
/* 1639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["initialize"] = initialize;
/* harmony export (immutable) */ __webpack_exports__["ga"] = ga;
/* harmony export (immutable) */ __webpack_exports__["set"] = set;
/* harmony export (immutable) */ __webpack_exports__["send"] = send;
/* harmony export (immutable) */ __webpack_exports__["pageview"] = pageview;
/* harmony export (immutable) */ __webpack_exports__["modalview"] = modalview;
/* harmony export (immutable) */ __webpack_exports__["timing"] = timing;
/* harmony export (immutable) */ __webpack_exports__["event"] = event;
/* harmony export (immutable) */ __webpack_exports__["exception"] = exception;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "plugin", function() { return plugin; });
/* harmony export (immutable) */ __webpack_exports__["outboundLink"] = outboundLink;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "testModeAPI", function() { return testModeAPI; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_format__ = __webpack_require__(1640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_removeLeadingSlash__ = __webpack_require__(1643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_trim__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_loadGA__ = __webpack_require__(1644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_console_warn__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_console_log__ = __webpack_require__(1645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__ = __webpack_require__(1646);
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

/**
 * React Google Analytics Module
 *
 * @package react-ga
 * @author  Adam Lofting <adam@mozillafoundation.org>
 *          Atul Varma <atul@mozillafoundation.org>
 */

/**
 * Utilities
 */








var _isNotBrowser = typeof window === 'undefined' || typeof document === 'undefined';

var _debug = false;
var _titleCase = true;
var _testMode = false;
var _alwaysSendToDefaultTracker = true;

var internalGa = function internalGa() {
  var _window;

  if (_testMode) return __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */].ga.apply(__WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */], arguments);
  if (_isNotBrowser) return false;
  if (!window.ga) return Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
  return (_window = window).ga.apply(_window, arguments);
};

function _format(s) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_format__["a" /* default */])(s, _titleCase);
}

function _gaCommand(trackerNames) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var command = args[0];

  if (typeof internalGa === 'function') {
    if (typeof command !== 'string') {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('ga command must be a string');
      return;
    }

    if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) internalGa.apply(void 0, args);

    if (Array.isArray(trackerNames)) {
      trackerNames.forEach(function (name) {
        internalGa.apply(void 0, _toConsumableArray(["".concat(name, ".").concat(command)].concat(args.slice(1))));
      });
    }
  }
}

function _initialize(gaTrackingID, options) {
  if (!gaTrackingID) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('gaTrackingID is required in initialize()');
    return;
  }

  if (options) {
    if (options.debug && options.debug === true) {
      _debug = true;
    }

    if (options.titleCase === false) {
      _titleCase = false;
    }

    if (options.useExistingGa) {
      return;
    }
  }

  if (options && options.gaOptions) {
    internalGa('create', gaTrackingID, options.gaOptions);
  } else {
    internalGa('create', gaTrackingID, 'auto');
  }
}

function initialize(configsOrTrackingId, options) {
  if (options && options.testMode === true) {
    _testMode = true;
  } else {
    if (_isNotBrowser) {
      return false;
    }

    if (!options || options.standardImplementation !== true) Object(__WEBPACK_IMPORTED_MODULE_3__utils_loadGA__["a" /* default */])(options);
  }

  _alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;

  if (Array.isArray(configsOrTrackingId)) {
    configsOrTrackingId.forEach(function (config) {
      if (_typeof(config) !== 'object') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('All configs must be an object');
        return;
      }

      _initialize(config.trackingId, config);
    });
  } else {
    _initialize(configsOrTrackingId, options);
  }

  return true;
}
/**
 * ga:
 * Returns the original GA object.
 */

function ga() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (args.length > 0) {
    internalGa.apply(void 0, args);

    if (_debug) {
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'arguments\');');
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with arguments: ".concat(JSON.stringify(args)));
    }
  }

  return window.ga;
}
/**
 * set:
 * GA tracker set method
 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function set(fieldsObject, trackerNames) {
  if (!fieldsObject) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`fieldsObject` is required in .set()');
    return;
  }

  if (_typeof(fieldsObject) !== 'object') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `fieldsObject` arg to be an Object');
    return;
  }

  if (Object.keys(fieldsObject).length === 0) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('empty `fieldsObject` given to .set()');
  }

  _gaCommand(trackerNames, 'set', fieldsObject);

  if (_debug) {
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'set\', fieldsObject);');
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with fieldsObject: ".concat(JSON.stringify(fieldsObject)));
  }
}
/**
 * send:
 * Clone of the low level `ga.send` method
 * WARNING: No validations will be applied to this
 * @param  {Object} fieldObject - field object for tracking different analytics
 * @param  {Array} trackerNames - trackers to send the command to
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function send(fieldObject, trackerNames) {
  _gaCommand(trackerNames, 'send', fieldObject);

  if (_debug) {
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'send\', fieldObject);');
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with fieldObject: ".concat(JSON.stringify(fieldObject)));
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with trackers: ".concat(JSON.stringify(trackerNames)));
  }
}
/**
 * pageview:
 * Basic GA pageview tracking
 * @param  {String} path - the current page page e.g. '/about'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 * @param {String} title - (optional) the page title e. g. 'My Website'
 */

function pageview(rawPath, trackerNames, title) {
  if (!rawPath) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('path is required in .pageview()');
    return;
  }

  var path = Object(__WEBPACK_IMPORTED_MODULE_2__utils_trim__["a" /* default */])(rawPath);

  if (path === '') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('path cannot be an empty string in .pageview()');
    return;
  }

  var extraFields = {};

  if (title) {
    extraFields.title = title;
  }

  if (typeof ga === 'function') {
    _gaCommand(trackerNames, 'send', _objectSpread({
      hitType: 'pageview',
      page: path
    }, extraFields));

    if (_debug) {
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'send\', \'pageview\', path);');
      var extraLog = '';

      if (title) {
        extraLog = " and title: ".concat(title);
      }

      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with path: ".concat(path).concat(extraLog));
    }
  }
}
/**
 * modalview:
 * a proxy to basic GA pageview tracking to consistently track
 * modal views that are an equivalent UX to a traditional pageview
 * @param  {String} modalName e.g. 'add-or-edit-club'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function modalview(rawModalName, trackerNames) {
  if (!rawModalName) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('modalName is required in .modalview(modalName)');
    return;
  }

  var modalName = Object(__WEBPACK_IMPORTED_MODULE_1__utils_removeLeadingSlash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_trim__["a" /* default */])(rawModalName));

  if (modalName === '') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('modalName cannot be an empty string or a single / in .modalview()');
    return;
  }

  if (typeof ga === 'function') {
    var path = "/modal/".concat(modalName);

    _gaCommand(trackerNames, 'send', 'pageview', path);

    if (_debug) {
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'send\', \'pageview\', path);');
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with path: ".concat(path));
    }
  }
}
/**
 * timing:
 * GA timing
 * @param args.category {String} required
 * @param args.variable {String} required
 * @param args.value  {Int}  required
 * @param args.label  {String} required
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function timing() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref.category,
      variable = _ref.variable,
      value = _ref.value,
      label = _ref.label;

  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof ga === 'function') {
    if (!category || !variable || !value || typeof value !== 'number') {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'timing',
      timingCategory: _format(category),
      timingVar: _format(variable),
      timingValue: value
    };

    if (label) {
      fieldObject.timingLabel = _format(label);
    }

    send(fieldObject, trackerNames);
  }
}
/**
 * event:
 * GA event tracking
 * @param args.category {String} required
 * @param args.action {String} required
 * @param args.label {String} optional
 * @param args.value {Int} optional
 * @param args.nonInteraction {boolean} optional
 * @param args.transport {string} optional
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function event() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref2.category,
      action = _ref2.action,
      label = _ref2.label,
      value = _ref2.value,
      nonInteraction = _ref2.nonInteraction,
      transport = _ref2.transport,
      args = _objectWithoutProperties(_ref2, ["category", "action", "label", "value", "nonInteraction", "transport"]);

  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof ga === 'function') {
    // Simple Validation
    if (!category || !action) {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('args.category AND args.action are required in event()');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'event',
      eventCategory: _format(category),
      eventAction: _format(action)
    }; // Optional Fields

    if (label) {
      fieldObject.eventLabel = _format(label);
    }

    if (typeof value !== 'undefined') {
      if (typeof value !== 'number') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `args.value` arg to be a Number.');
      } else {
        fieldObject.eventValue = value;
      }
    }

    if (typeof nonInteraction !== 'undefined') {
      if (typeof nonInteraction !== 'boolean') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.nonInteraction` must be a boolean.');
      } else {
        fieldObject.nonInteraction = nonInteraction;
      }
    }

    if (typeof transport !== 'undefined') {
      if (typeof transport !== 'string') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.transport` must be a string.');
      } else {
        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
          Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
        }

        fieldObject.transport = transport;
      }
    }

    Object.keys(args).filter(function (key) {
      return key.substr(0, 'dimension'.length) === 'dimension';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    });
    Object.keys(args).filter(function (key) {
      return key.substr(0, 'metric'.length) === 'metric';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    }); // Send to GA

    send(fieldObject, trackerNames);
  }
}
/**
 * exception:
 * GA exception tracking
 * @param args.description {String} optional
 * @param args.fatal {boolean} optional
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function exception(_ref3, trackerNames) {
  var description = _ref3.description,
      fatal = _ref3.fatal;

  if (typeof ga === 'function') {
    // Required Fields
    var fieldObject = {
      hitType: 'exception'
    }; // Optional Fields

    if (description) {
      fieldObject.exDescription = _format(description);
    }

    if (typeof fatal !== 'undefined') {
      if (typeof fatal !== 'boolean') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.fatal` must be a boolean.');
      } else {
        fieldObject.exFatal = fatal;
      }
    } // Send to GA


    send(fieldObject, trackerNames);
  }
}
var plugin = {
  /**
   * require:
   * GA requires a plugin
   * @param name {String} e.g. 'ecommerce' or 'myplugin'
   * @param options {Object} optional e.g {path: '/log', debug: true}
   * @param trackerName {String} optional e.g 'trackerName'
   */
  require: function require(rawName, options, trackerName) {
    if (typeof ga === 'function') {
      // Required Fields
      if (!rawName) {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`name` is required in .require()');
        return;
      }

      var name = Object(__WEBPACK_IMPORTED_MODULE_2__utils_trim__["a" /* default */])(rawName);

      if (name === '') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`name` cannot be an empty string in .require()');
        return;
      }

      var requireString = trackerName ? "".concat(trackerName, ".require") : 'require'; // Optional Fields

      if (options) {
        if (_typeof(options) !== 'object') {
          Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `options` arg to be an Object');
          return;
        }

        if (Object.keys(options).length === 0) {
          Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Empty `options` given to .require()');
        }

        ga(requireString, name, options);

        if (_debug) {
          Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('require', '".concat(name, "', ").concat(JSON.stringify(options)));
        }
      } else {
        ga(requireString, name);

        if (_debug) {
          Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('require', '".concat(name, "');"));
        }
      }
    }
  },

  /**
   * execute:
   * GA execute action for plugin
   * Takes variable number of arguments
   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
   * @param action {String} e.g. 'addItem' or 'myCustomAction'
   * @param actionType {String} optional e.g. 'detail'
   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
   */
  execute: function execute(pluginName, action) {
    var payload;
    var actionType;

    if ((arguments.length <= 2 ? 0 : arguments.length - 2) === 1) {
      payload = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      actionType = arguments.length <= 2 ? undefined : arguments[2];
      payload = arguments.length <= 3 ? undefined : arguments[3];
    }

    if (typeof ga === 'function') {
      if (typeof pluginName !== 'string') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `pluginName` arg to be a String.');
      } else if (typeof action !== 'string') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `action` arg to be a String.');
      } else {
        var command = "".concat(pluginName, ":").concat(action);
        payload = payload || null;

        if (actionType && payload) {
          ga(command, actionType, payload);

          if (_debug) {
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('".concat(command, "');"));
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("actionType: \"".concat(actionType, "\" with payload: ").concat(JSON.stringify(payload)));
          }
        } else if (payload) {
          ga(command, payload);

          if (_debug) {
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('".concat(command, "');"));
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with payload: ".concat(JSON.stringify(payload)));
          }
        } else {
          ga(command);

          if (_debug) {
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('".concat(command, "');"));
          }
        }
      }
    }
  }
};
/**
 * outboundLink:
 * GA outboundLink tracking
 * @param args.label {String} e.g. url, or 'Create an Account'
 * @param {function} hitCallback - Called after processing a hit.
 */

function outboundLink(args, hitCallback, trackerNames) {
  if (typeof hitCallback !== 'function') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('hitCallback function is required');
    return;
  }

  if (typeof ga === 'function') {
    // Simple Validation
    if (!args || !args.label) {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('args.label is required in outboundLink()');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'event',
      eventCategory: 'Outbound',
      eventAction: 'Click',
      eventLabel: _format(args.label)
    };
    var safetyCallbackCalled = false;

    var safetyCallback = function safetyCallback() {
      // This prevents a delayed response from GA
      // causing hitCallback from being fired twice
      safetyCallbackCalled = true;
      hitCallback();
    }; // Using a timeout to ensure the execution of critical application code
    // in the case when the GA server might be down
    // or an ad blocker prevents sending the data
    // register safety net timeout:


    var t = setTimeout(safetyCallback, 250);

    var clearableCallbackForGA = function clearableCallbackForGA() {
      clearTimeout(t);

      if (!safetyCallbackCalled) {
        hitCallback();
      }
    };

    fieldObject.hitCallback = clearableCallbackForGA; // Send to GA

    send(fieldObject, trackerNames);
  } else {
    // if ga is not defined, return the callback so the application
    // continues to work as expected
    setTimeout(hitCallback, 0);
  }
}
var testModeAPI = __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */];
/* harmony default export */ __webpack_exports__["default"] = ({
  initialize: initialize,
  ga: ga,
  set: set,
  send: send,
  pageview: pageview,
  modalview: modalview,
  timing: timing,
  event: event,
  exception: exception,
  plugin: plugin,
  outboundLink: outboundLink,
  testModeAPI: __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */]
});

/***/ }),
/* 1640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = format;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mightBeEmail__ = __webpack_require__(1641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toTitleCase__ = __webpack_require__(1642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__console_warn__ = __webpack_require__(390);



var redacted = 'REDACTED (Potential Email Address)';
function format(s, titleCase) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__mightBeEmail__["a" /* default */])(s)) {
    Object(__WEBPACK_IMPORTED_MODULE_2__console_warn__["a" /* default */])('This arg looks like an email address, redacting.');
    return redacted;
  }

  if (titleCase) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__toTitleCase__["a" /* default */])(s);
  }

  return s;
}

/***/ }),
/* 1641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mightBeEmail;
// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function mightBeEmail(s) {
  // There's no point trying to validate rfc822 fully, just look for ...@...
  return typeof s === 'string' && s.indexOf('@') !== -1;
}

/***/ }),
/* 1642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toTitleCase;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__trim__ = __webpack_require__(656);
/**
 * To Title Case 2.1 - http://individed.com/code/to-title-case/
 * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
 * https://github.com/gouch/to-title-case
 */

var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
function toTitleCase(string) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__trim__["a" /* default */])(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
      return match.toLowerCase();
    }

    if (match.substr(1).search(/[A-Z]|\../) > -1) {
      return match;
    }

    return match.charAt(0).toUpperCase() + match.substr(1);
  });
}

/***/ }),
/* 1643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = removeLeadingSlash;
function removeLeadingSlash(string) {
  if (string.substring(0, 1) === '/') {
    return string.substring(1);
  }

  return string;
}

/***/ }),
/* 1644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (options) {
  var gaAddress = 'https://www.google-analytics.com/analytics.js';

  if (options && options.gaAddress) {
    gaAddress = options.gaAddress;
  } else if (options && options.debug) {
    gaAddress = 'https://www.google-analytics.com/analytics_debug.js';
  } // https://developers.google.com/analytics/devguides/collection/analyticsjs/

  /* eslint-disable */


  (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments);
    }, i[r].l = 1 * new Date();
    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
  })(window, document, 'script', gaAddress, 'ga');
  /* eslint-enable */

});

/***/ }),
/* 1645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = log;
function log(s) {
  console.info('[react-ga]', s);
}

/***/ }),
/* 1646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gaCalls */
var gaCalls = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  calls: gaCalls,
  ga: function ga() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    gaCalls.push([].concat(args));
  },
  resetCalls: function resetCalls() {
    gaCalls.length = 0;
  }
});

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(1648);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 1648 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(1650);
var bytesToUuid = __webpack_require__(1651);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),
/* 1650 */
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),
/* 1651 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]]
  ]).join('');
}

module.exports = bytesToUuid;


/***/ }),
/* 1652 */
/***/ (function(module, exports) {

module.exports = {"AF":"Afganistán","AL":"Albania","DE":"Alemania","AD":"Andorra","AO":"Angola","AI":"Anguila","AQ":"Antártida","AG":"Antigua y Barbuda","SA":"Arabia Saudí","DZ":"Argelia","AR":"Argentina","AM":"Armenia","AW":"Aruba","AU":"Australia","AT":"Austria","AZ":"Azerbaiyán","BS":"Bahamas","BD":"Bangladés","BB":"Barbados","BH":"Baréin","BE":"Bélgica","BZ":"Belice","BJ":"Benín","BM":"Bermudas","BY":"Bielorrusia","BO":"Bolivia","BA":"Bosnia-Herzegovina","BW":"Botsuana","BR":"Brasil","BN":"Brunéi","BG":"Bulgaria","BF":"Burkina Faso","BI":"Burundi","BT":"Bután","CV":"Cabo Verde","KH":"Camboya","CM":"Camerún","CA":"Canadá","BQ":"Caribe neerlandés","QA":"Catar","EA":"Ceuta y Melilla","TD":"Chad","CL":"Chile","CN":"China","CY":"Chipre","VA":"Ciudad del Vaticano","CO":"Colombia","KM":"Comoras","KP":"Corea del Norte","KR":"Corea del Sur","CI":"Costa de Marfil","CR":"Costa Rica","HR":"Croacia","CU":"Cuba","CW":"Curazao","DG":"Diego García","DK":"Dinamarca","DM":"Dominica","EC":"Ecuador","EG":"Egipto","SV":"El Salvador","AE":"Emiratos Árabes Unidos","ER":"Eritrea","SK":"Eslovaquia","SI":"Eslovenia","ES":"España","US":"Estados Unidos","EE":"Estonia","ET":"Etiopía","PH":"Filipinas","FI":"Finlandia","FJ":"Fiyi","FR":"Francia","GA":"Gabón","GM":"Gambia","GE":"Georgia","GH":"Ghana","GI":"Gibraltar","GD":"Granada","GR":"Grecia","GL":"Groenlandia","GP":"Guadalupe","GU":"Guam","GT":"Guatemala","GF":"Guayana Francesa","GG":"Guernesey","GN":"Guinea","GQ":"Guinea Ecuatorial","GW":"Guinea-Bisáu","GY":"Guyana","HT":"Haití","HN":"Honduras","HU":"Hungría","IN":"India","ID":"Indonesia","IR":"Irán","IQ":"Iraq","IE":"Irlanda","CX":"Isla Christmas","AC":"Isla de la Ascensión","IM":"Isla de Man","NU":"Isla Niue","NF":"Isla Norfolk","IS":"Islandia","AX":"Islas Åland","KY":"Islas Caimán","IC":"islas Canarias","CC":"Islas Cocos","CK":"Islas Cook","FO":"Islas Feroe","GS":"Islas Georgia del Sur y Sandwich del Sur","FK":"Islas Malvinas","MP":"Islas Marianas del Norte","MH":"Islas Marshall","UM":"Islas menores alejadas de EE. UU.","PN":"Islas Pitcairn","SB":"Islas Salomón","TC":"Islas Turcas y Caicos","VG":"Islas Vírgenes Británicas","VI":"Islas Vírgenes de EE. UU.","IL":"Israel","IT":"Italia","JM":"Jamaica","JP":"Japón","JE":"Jersey","JO":"Jordania","KZ":"Kazajistán","KE":"Kenia","KG":"Kirguistán","KI":"Kiribati","XK":"Kosovo","KW":"Kuwait","LA":"Laos","LS":"Lesoto","LV":"Letonia","LB":"Líbano","LR":"Liberia","LY":"Libia","LI":"Liechtenstein","LT":"Lituania","LU":"Luxemburgo","MK":"Macedonia","MG":"Madagascar","MY":"Malasia","MW":"Malaui","MV":"Maldivas","ML":"Mali","MT":"Malta","MA":"Marruecos","MQ":"Martinica","MU":"Mauricio","MR":"Mauritania","YT":"Mayotte","MX":"México","FM":"Micronesia","MD":"Moldavia","MC":"Mónaco","MN":"Mongolia","ME":"Montenegro","MS":"Montserrat","MZ":"Mozambique","MM":"Myanmar (Birmania)","NA":"Namibia","NR":"Nauru","NP":"Nepal","NI":"Nicaragua","NE":"Níger","NG":"Nigeria","NO":"Noruega","NC":"Nueva Caledonia","NZ":"Nueva Zelanda","OM":"Omán","NL":"Países Bajos","PK":"Pakistán","PW":"Palau","PA":"Panamá","PG":"Papúa Nueva Guinea","PY":"Paraguay","PE":"Perú","PF":"Polinesia Francesa","PL":"Polonia","PT":"Portugal","PR":"Puerto Rico","HK":"RAE de Hong Kong (China)","MO":"RAE de Macao (China)","GB":"Reino Unido","CF":"República Centroafricana","CZ":"República Checa","CG":"República del Congo","CD":"República Democrática del Congo","DO":"República Dominicana","RE":"Reunión","RW":"Ruanda","RO":"Rumanía","RU":"Rusia","EH":"Sáhara Occidental","WS":"Samoa","AS":"Samoa Americana","BL":"San Bartolomé","KN":"San Cristóbal y Nieves","SM":"San Marino","MF":"San Martín","PM":"San Pedro y Miquelón","VC":"San Vicente y las Granadinas","SH":"Santa Elena","LC":"Santa Lucía","ST":"Santo Tomé y Príncipe","SN":"Senegal","RS":"Serbia","SC":"Seychelles","SL":"Sierra Leona","SG":"Singapur","SX":"Sint Maarten","SY":"Siria","SO":"Somalia","LK":"Sri Lanka","SZ":"Suazilandia","ZA":"Sudáfrica","SD":"Sudán","SS":"Sudán del Sur","SE":"Suecia","CH":"Suiza","SR":"Surinam","SJ":"Svalbard y Jan Mayen","TH":"Tailandia","TW":"Taiwán","TZ":"Tanzania","TJ":"Tayikistán","IO":"Territorio Británico del Océano Índico","TF":"Territorios Australes Franceses","PS":"Territorios Palestinos","TL":"Timor Oriental","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trinidad y Tobago","TA":"Tristán da Cunha","TN":"Túnez","TM":"Turkmenistán","TR":"Turquía","TV":"Tuvalu","UA":"Ucrania","UG":"Uganda","UY":"Uruguay","UZ":"Uzbekistán","VU":"Vanuatu","VE":"Venezuela","VN":"Vietnam","WF":"Wallis y Futuna","YE":"Yemen","DJ":"Yibuti","ZM":"Zambia","ZW":"Zimbabue"}

/***/ }),
/* 1653 */
/***/ (function(module, exports) {

module.exports = {"AF":"Afganistan","AX":"Ahvenanmaa","NL":"Alankomaat","AL":"Albania","DZ":"Algeria","AS":"Amerikan Samoa","AD":"Andorra","AO":"Angola","AI":"Anguilla","AQ":"Antarktis","AG":"Antigua ja Barbuda","AE":"Arabiemiirikunnat","AR":"Argentiina","AM":"Armenia","AW":"Aruba","AC":"Ascension-saari","AU":"Australia","AZ":"Azerbaidžan","BS":"Bahama","BH":"Bahrain","BD":"Bangladesh","BB":"Barbados","BE":"Belgia","BZ":"Belize","BJ":"Benin","BM":"Bermuda","BT":"Bhutan","BO":"Bolivia","BA":"Bosnia ja Hertsegovina","BW":"Botswana","BR":"Brasilia","IO":"Brittiläinen Intian valtameren alue","VG":"Brittiläiset Neitsytsaaret","BN":"Brunei","BG":"Bulgaria","BF":"Burkina Faso","BI":"Burundi","KY":"Caymansaaret","EA":"Ceuta ja Melilla","CL":"Chile","CK":"Cookinsaaret","CR":"Costa Rica","CW":"Curaçao","DG":"Diego Garcia","DJ":"Djibouti","DM":"Dominica","DO":"Dominikaaninen tasavalta","EC":"Ecuador","EG":"Egypti","SV":"El Salvador","ER":"Eritrea","ES":"Espanja","ZA":"Etelä-Afrikka","GS":"Etelä-Georgia ja Eteläiset Sandwichsaaret","KR":"Etelä-Korea","SS":"Etelä-Sudan","ET":"Etiopia","FK":"Falklandinsaaret","FJ":"Fidži","PH":"Filippiinit","FO":"Färsaaret","GA":"Gabon","GM":"Gambia","GE":"Georgia","GH":"Ghana","GI":"Gibraltar","GD":"Grenada","GL":"Grönlanti","GP":"Guadeloupe","GU":"Guam","GT":"Guatemala","GG":"Guernsey","GN":"Guinea","GW":"Guinea-Bissau","GY":"Guyana","HT":"Haiti","HN":"Honduras","HK":"Hongkong – Kiinan e.h.a.","SJ":"Huippuvuoret ja Jan Mayen","ID":"Indonesia","IN":"Intia","IQ":"Irak","IR":"Iran","IE":"Irlanti","IS":"Islanti","IL":"Israel","IT":"Italia","TL":"Itä-Timor","AT":"Itävalta","JM":"Jamaika","JP":"Japani","YE":"Jemen","JE":"Jersey","JO":"Jordania","CX":"Joulusaari","KH":"Kambodža","CM":"Kamerun","CA":"Kanada","IC":"Kanariansaaret","CV":"Kap Verde","BQ":"Karibian Alankomaat","KZ":"Kazakstan","KE":"Kenia","CF":"Keski-Afrikan tasavalta","CN":"Kiina","KG":"Kirgisia","KI":"Kiribati","CO":"Kolumbia","KM":"Komorit","CD":"Kongon demokraattinen tasavalta","CG":"Kongon tasavalta","CC":"Kookossaaret (Keelingsaaret)","XK":"Kosovo","GR":"Kreikka","HR":"Kroatia","CU":"Kuuba","KW":"Kuwait","CY":"Kypros","LA":"Laos","LV":"Latvia","LS":"Lesotho","LB":"Libanon","LR":"Liberia","LY":"Libya","LI":"Liechtenstein","LT":"Liettua","LU":"Luxemburg","EH":"Länsi-Sahara","MO":"Macao – Kiinan e.h.a.","MG":"Madagaskar","MK":"Makedonia","MW":"Malawi","MV":"Malediivit","MY":"Malesia","ML":"Mali","MT":"Malta","IM":"Mansaari","MA":"Marokko","MH":"Marshallinsaaret","MQ":"Martinique","MR":"Mauritania","MU":"Mauritius","YT":"Mayotte","MX":"Meksiko","FM":"Mikronesian liittovaltio","MD":"Moldova","MC":"Monaco","MN":"Mongolia","ME":"Montenegro","MS":"Montserrat","MZ":"Mosambik","MM":"Myanmar (Burma)","NA":"Namibia","NR":"Nauru","NP":"Nepal","NI":"Nicaragua","NE":"Niger","NG":"Nigeria","NU":"Niue","NF":"Norfolkinsaari","NO":"Norja","CI":"Norsunluurannikko","OM":"Oman","PK":"Pakistan","PW":"Palau","PS":"Palestiinalaisalueet","PA":"Panama","PG":"Papua-Uusi-Guinea","PY":"Paraguay","PE":"Peru","PN":"Pitcairn","KP":"Pohjois-Korea","MP":"Pohjois-Mariaanit","PT":"Portugali","PR":"Puerto Rico","PL":"Puola","GQ":"Päiväntasaajan Guinea","QA":"Qatar","FR":"Ranska","GF":"Ranskan Guayana","PF":"Ranskan Polynesia","TF":"Ranskan ulkopuoliset eteläiset alueet","RE":"Réunion","RO":"Romania","RW":"Ruanda","SE":"Ruotsi","SH":"Saint Helena","KN":"Saint Kitts ja Nevis","LC":"Saint Lucia","VC":"Saint Vincent ja Grenadiinit","BL":"Saint-Barthélemy","MF":"Saint-Martin","PM":"Saint-Pierre ja Miquelon","DE":"Saksa","SB":"Salomonsaaret","ZM":"Sambia","WS":"Samoa","SM":"San Marino","ST":"São Tomé ja Príncipe","SA":"Saudi-Arabia","SN":"Senegal","RS":"Serbia","SC":"Seychellit","SL":"Sierra Leone","SG":"Singapore","SX":"Sint Maarten","SK":"Slovakia","SI":"Slovenia","SO":"Somalia","LK":"Sri Lanka","SD":"Sudan","FI":"Suomi","SR":"Surinam","CH":"Sveitsi","SZ":"Swazimaa","SY":"Syyria","TJ":"Tadžikistan","TW":"Taiwan","TZ":"Tansania","DK":"Tanska","TH":"Thaimaa","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trinidad ja Tobago","TA":"Tristan da Cunha","TD":"Tšad","CZ":"Tšekki","TN":"Tunisia","TR":"Turkki","TM":"Turkmenistan","TC":"Turks- ja Caicossaaret","TV":"Tuvalu","UG":"Uganda","UA":"Ukraina","HU":"Unkari","UY":"Uruguay","NC":"Uusi-Kaledonia","NZ":"Uusi-Seelanti","UZ":"Uzbekistan","BY":"Valko-Venäjä","VU":"Vanuatu","VA":"Vatikaani","VE":"Venezuela","RU":"Venäjä","VN":"Vietnam","EE":"Viro","WF":"Wallis ja Futuna","GB":"Yhdistynyt kuningaskunta","US":"Yhdysvallat","UM":"Yhdysvaltain erillissaaret","VI":"Yhdysvaltain Neitsytsaaret","ZW":"Zimbabwe"}

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
//! version : 0.5.34
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone

(function (root, factory) {
	"use strict";

	/*global define*/
	if (typeof module === 'object' && module.exports) {
		module.exports = factory(__webpack_require__(102)); // Node
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(102)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
	} else {
		factory(root.moment);                        // Browser
	}
}(this, function (moment) {
	"use strict";

	// Resolves es6 module loading issue
	if (moment.version === undefined && moment.default) {
		moment = moment.default;
	}

	// Do not load moment-timezone a second time.
	// if (moment.tz !== undefined) {
	// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
	// 	return moment;
	// }

	var VERSION = "0.5.34",
		zones = {},
		links = {},
		countries = {},
		names = {},
		guesses = {},
		cachedGuess;

	if (!moment || typeof moment.version !== 'string') {
		logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
	}

	var momentVersion = moment.version.split('.'),
		major = +momentVersion[0],
		minor = +momentVersion[1];

	// Moment.js version check
	if (major < 2 || (major === 2 && minor < 6)) {
		logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
	}

	/************************************
		Unpacking
	************************************/

	function charCodeToInt(charCode) {
		if (charCode > 96) {
			return charCode - 87;
		} else if (charCode > 64) {
			return charCode - 29;
		}
		return charCode - 48;
	}

	function unpackBase60(string) {
		var i = 0,
			parts = string.split('.'),
			whole = parts[0],
			fractional = parts[1] || '',
			multiplier = 1,
			num,
			out = 0,
			sign = 1;

		// handle negative numbers
		if (string.charCodeAt(0) === 45) {
			i = 1;
			sign = -1;
		}

		// handle digits before the decimal
		for (i; i < whole.length; i++) {
			num = charCodeToInt(whole.charCodeAt(i));
			out = 60 * out + num;
		}

		// handle digits after the decimal
		for (i = 0; i < fractional.length; i++) {
			multiplier = multiplier / 60;
			num = charCodeToInt(fractional.charCodeAt(i));
			out += num * multiplier;
		}

		return out * sign;
	}

	function arrayToInt (array) {
		for (var i = 0; i < array.length; i++) {
			array[i] = unpackBase60(array[i]);
		}
	}

	function intToUntil (array, length) {
		for (var i = 0; i < length; i++) {
			array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
		}

		array[length - 1] = Infinity;
	}

	function mapIndices (source, indices) {
		var out = [], i;

		for (i = 0; i < indices.length; i++) {
			out[i] = source[indices[i]];
		}

		return out;
	}

	function unpack (string) {
		var data = string.split('|'),
			offsets = data[2].split(' '),
			indices = data[3].split(''),
			untils  = data[4].split(' ');

		arrayToInt(offsets);
		arrayToInt(indices);
		arrayToInt(untils);

		intToUntil(untils, indices.length);

		return {
			name       : data[0],
			abbrs      : mapIndices(data[1].split(' '), indices),
			offsets    : mapIndices(offsets, indices),
			untils     : untils,
			population : data[5] | 0
		};
	}

	/************************************
		Zone object
	************************************/

	function Zone (packedString) {
		if (packedString) {
			this._set(unpack(packedString));
		}
	}

	Zone.prototype = {
		_set : function (unpacked) {
			this.name       = unpacked.name;
			this.abbrs      = unpacked.abbrs;
			this.untils     = unpacked.untils;
			this.offsets    = unpacked.offsets;
			this.population = unpacked.population;
		},

		_index : function (timestamp) {
			var target = +timestamp,
				untils = this.untils,
				i;

			for (i = 0; i < untils.length; i++) {
				if (target < untils[i]) {
					return i;
				}
			}
		},

		countries : function () {
			var zone_name = this.name;
			return Object.keys(countries).filter(function (country_code) {
				return countries[country_code].zones.indexOf(zone_name) !== -1;
			});
		},

		parse : function (timestamp) {
			var target  = +timestamp,
				offsets = this.offsets,
				untils  = this.untils,
				max     = untils.length - 1,
				offset, offsetNext, offsetPrev, i;

			for (i = 0; i < max; i++) {
				offset     = offsets[i];
				offsetNext = offsets[i + 1];
				offsetPrev = offsets[i ? i - 1 : i];

				if (offset < offsetNext && tz.moveAmbiguousForward) {
					offset = offsetNext;
				} else if (offset > offsetPrev && tz.moveInvalidForward) {
					offset = offsetPrev;
				}

				if (target < untils[i] - (offset * 60000)) {
					return offsets[i];
				}
			}

			return offsets[max];
		},

		abbr : function (mom) {
			return this.abbrs[this._index(mom)];
		},

		offset : function (mom) {
			logError("zone.offset has been deprecated in favor of zone.utcOffset");
			return this.offsets[this._index(mom)];
		},

		utcOffset : function (mom) {
			return this.offsets[this._index(mom)];
		}
	};

	/************************************
		Country object
	************************************/

	function Country (country_name, zone_names) {
		this.name = country_name;
		this.zones = zone_names;
	}

	/************************************
		Current Timezone
	************************************/

	function OffsetAt(at) {
		var timeString = at.toTimeString();
		var abbr = timeString.match(/\([a-z ]+\)/i);
		if (abbr && abbr[0]) {
			// 17:56:31 GMT-0600 (CST)
			// 17:56:31 GMT-0600 (Central Standard Time)
			abbr = abbr[0].match(/[A-Z]/g);
			abbr = abbr ? abbr.join('') : undefined;
		} else {
			// 17:56:31 CST
			// 17:56:31 GMT+0800 (台北標準時間)
			abbr = timeString.match(/[A-Z]{3,5}/g);
			abbr = abbr ? abbr[0] : undefined;
		}

		if (abbr === 'GMT') {
			abbr = undefined;
		}

		this.at = +at;
		this.abbr = abbr;
		this.offset = at.getTimezoneOffset();
	}

	function ZoneScore(zone) {
		this.zone = zone;
		this.offsetScore = 0;
		this.abbrScore = 0;
	}

	ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
		this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
		if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
			this.abbrScore++;
		}
	};

	function findChange(low, high) {
		var mid, diff;

		while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
			mid = new OffsetAt(new Date(low.at + diff));
			if (mid.offset === low.offset) {
				low = mid;
			} else {
				high = mid;
			}
		}

		return low;
	}

	function userOffsets() {
		var startYear = new Date().getFullYear() - 2,
			last = new OffsetAt(new Date(startYear, 0, 1)),
			offsets = [last],
			change, next, i;

		for (i = 1; i < 48; i++) {
			next = new OffsetAt(new Date(startYear, i, 1));
			if (next.offset !== last.offset) {
				change = findChange(last, next);
				offsets.push(change);
				offsets.push(new OffsetAt(new Date(change.at + 6e4)));
			}
			last = next;
		}

		for (i = 0; i < 4; i++) {
			offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
			offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
		}

		return offsets;
	}

	function sortZoneScores (a, b) {
		if (a.offsetScore !== b.offsetScore) {
			return a.offsetScore - b.offsetScore;
		}
		if (a.abbrScore !== b.abbrScore) {
			return a.abbrScore - b.abbrScore;
		}
		if (a.zone.population !== b.zone.population) {
			return b.zone.population - a.zone.population;
		}
		return b.zone.name.localeCompare(a.zone.name);
	}

	function addToGuesses (name, offsets) {
		var i, offset;
		arrayToInt(offsets);
		for (i = 0; i < offsets.length; i++) {
			offset = offsets[i];
			guesses[offset] = guesses[offset] || {};
			guesses[offset][name] = true;
		}
	}

	function guessesForUserOffsets (offsets) {
		var offsetsLength = offsets.length,
			filteredGuesses = {},
			out = [],
			i, j, guessesOffset;

		for (i = 0; i < offsetsLength; i++) {
			guessesOffset = guesses[offsets[i].offset] || {};
			for (j in guessesOffset) {
				if (guessesOffset.hasOwnProperty(j)) {
					filteredGuesses[j] = true;
				}
			}
		}

		for (i in filteredGuesses) {
			if (filteredGuesses.hasOwnProperty(i)) {
				out.push(names[i]);
			}
		}

		return out;
	}

	function rebuildGuess () {

		// use Intl API when available and returning valid time zone
		try {
			var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
			if (intlName && intlName.length > 3) {
				var name = names[normalizeName(intlName)];
				if (name) {
					return name;
				}
				logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
			}
		} catch (e) {
			// Intl unavailable, fall back to manual guessing.
		}

		var offsets = userOffsets(),
			offsetsLength = offsets.length,
			guesses = guessesForUserOffsets(offsets),
			zoneScores = [],
			zoneScore, i, j;

		for (i = 0; i < guesses.length; i++) {
			zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
			for (j = 0; j < offsetsLength; j++) {
				zoneScore.scoreOffsetAt(offsets[j]);
			}
			zoneScores.push(zoneScore);
		}

		zoneScores.sort(sortZoneScores);

		return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
	}

	function guess (ignoreCache) {
		if (!cachedGuess || ignoreCache) {
			cachedGuess = rebuildGuess();
		}
		return cachedGuess;
	}

	/************************************
		Global Methods
	************************************/

	function normalizeName (name) {
		return (name || '').toLowerCase().replace(/\//g, '_');
	}

	function addZone (packed) {
		var i, name, split, normalized;

		if (typeof packed === "string") {
			packed = [packed];
		}

		for (i = 0; i < packed.length; i++) {
			split = packed[i].split('|');
			name = split[0];
			normalized = normalizeName(name);
			zones[normalized] = packed[i];
			names[normalized] = name;
			addToGuesses(normalized, split[2].split(' '));
		}
	}

	function getZone (name, caller) {

		name = normalizeName(name);

		var zone = zones[name];
		var link;

		if (zone instanceof Zone) {
			return zone;
		}

		if (typeof zone === 'string') {
			zone = new Zone(zone);
			zones[name] = zone;
			return zone;
		}

		// Pass getZone to prevent recursion more than 1 level deep
		if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
			zone = zones[name] = new Zone();
			zone._set(link);
			zone.name = names[name];
			return zone;
		}

		return null;
	}

	function getNames () {
		var i, out = [];

		for (i in names) {
			if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
				out.push(names[i]);
			}
		}

		return out.sort();
	}

	function getCountryNames () {
		return Object.keys(countries);
	}

	function addLink (aliases) {
		var i, alias, normal0, normal1;

		if (typeof aliases === "string") {
			aliases = [aliases];
		}

		for (i = 0; i < aliases.length; i++) {
			alias = aliases[i].split('|');

			normal0 = normalizeName(alias[0]);
			normal1 = normalizeName(alias[1]);

			links[normal0] = normal1;
			names[normal0] = alias[0];

			links[normal1] = normal0;
			names[normal1] = alias[1];
		}
	}

	function addCountries (data) {
		var i, country_code, country_zones, split;
		if (!data || !data.length) return;
		for (i = 0; i < data.length; i++) {
			split = data[i].split('|');
			country_code = split[0].toUpperCase();
			country_zones = split[1].split(' ');
			countries[country_code] = new Country(
				country_code,
				country_zones
			);
		}
	}

	function getCountry (name) {
		name = name.toUpperCase();
		return countries[name] || null;
	}

	function zonesForCountry(country, with_offset) {
		country = getCountry(country);

		if (!country) return null;

		var zones = country.zones.sort();

		if (with_offset) {
			return zones.map(function (zone_name) {
				var zone = getZone(zone_name);
				return {
					name: zone_name,
					offset: zone.utcOffset(new Date())
				};
			});
		}

		return zones;
	}

	function loadData (data) {
		addZone(data.zones);
		addLink(data.links);
		addCountries(data.countries);
		tz.dataVersion = data.version;
	}

	function zoneExists (name) {
		if (!zoneExists.didShowError) {
			zoneExists.didShowError = true;
				logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
		}
		return !!getZone(name);
	}

	function needsOffset (m) {
		var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
		return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
	}

	function logError (message) {
		if (typeof console !== 'undefined' && typeof console.error === 'function') {
			console.error(message);
		}
	}

	/************************************
		moment.tz namespace
	************************************/

	function tz (input) {
		var args = Array.prototype.slice.call(arguments, 0, -1),
			name = arguments[arguments.length - 1],
			zone = getZone(name),
			out  = moment.utc.apply(null, args);

		if (zone && !moment.isMoment(input) && needsOffset(out)) {
			out.add(zone.parse(out), 'minutes');
		}

		out.tz(name);

		return out;
	}

	tz.version      = VERSION;
	tz.dataVersion  = '';
	tz._zones       = zones;
	tz._links       = links;
	tz._names       = names;
	tz._countries	= countries;
	tz.add          = addZone;
	tz.link         = addLink;
	tz.load         = loadData;
	tz.zone         = getZone;
	tz.zoneExists   = zoneExists; // deprecated in 0.1.0
	tz.guess        = guess;
	tz.names        = getNames;
	tz.Zone         = Zone;
	tz.unpack       = unpack;
	tz.unpackBase60 = unpackBase60;
	tz.needsOffset  = needsOffset;
	tz.moveInvalidForward   = true;
	tz.moveAmbiguousForward = false;
	tz.countries    = getCountryNames;
	tz.zonesForCountry = zonesForCountry;

	/************************************
		Interface with Moment.js
	************************************/

	var fn = moment.fn;

	moment.tz = tz;

	moment.defaultZone = null;

	moment.updateOffset = function (mom, keepTime) {
		var zone = moment.defaultZone,
			offset;

		if (mom._z === undefined) {
			if (zone && needsOffset(mom) && !mom._isUTC) {
				mom._d = moment.utc(mom._a)._d;
				mom.utc().add(zone.parse(mom), 'minutes');
			}
			mom._z = zone;
		}
		if (mom._z) {
			offset = mom._z.utcOffset(mom);
			if (Math.abs(offset) < 16) {
				offset = offset / 60;
			}
			if (mom.utcOffset !== undefined) {
				var z = mom._z;
				mom.utcOffset(-offset, keepTime);
				mom._z = z;
			} else {
				mom.zone(offset, keepTime);
			}
		}
	};

	fn.tz = function (name, keepTime) {
		if (name) {
			if (typeof name !== 'string') {
				throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
			}
			this._z = getZone(name);
			if (this._z) {
				moment.updateOffset(this, keepTime);
			} else {
				logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
			}
			return this;
		}
		if (this._z) { return this._z.name; }
	};

	function abbrWrap (old) {
		return function () {
			if (this._z) { return this._z.abbr(this); }
			return old.call(this);
		};
	}

	function resetZoneWrap (old) {
		return function () {
			this._z = null;
			return old.apply(this, arguments);
		};
	}

	function resetZoneWrap2 (old) {
		return function () {
			if (arguments.length > 0) this._z = null;
			return old.apply(this, arguments);
		};
	}

	fn.zoneName  = abbrWrap(fn.zoneName);
	fn.zoneAbbr  = abbrWrap(fn.zoneAbbr);
	fn.utc       = resetZoneWrap(fn.utc);
	fn.local     = resetZoneWrap(fn.local);
	fn.utcOffset = resetZoneWrap2(fn.utcOffset);

	moment.tz.setDefault = function(name) {
		if (major < 2 || (major === 2 && minor < 9)) {
			logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
		}
		moment.defaultZone = name ? getZone(name) : null;
		return moment;
	};

	// Cloning a moment should include the _z property.
	var momentProperties = moment.momentProperties;
	if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
		// moment 2.8.1+
		momentProperties.push('_z');
		momentProperties.push('_a');
	} else if (momentProperties) {
		// moment 2.7.0
		momentProperties._z = null;
	}

	// INJECT DATA

	return moment;
}));


/***/ }),
/* 1655 */
/***/ (function(module, exports) {

module.exports = {"version":"2021e","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|0121|-2le00 4i6N0 2q00|","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT AST ADT -0330|3W.t 40 30 3u|0121213121212121|-2m4k1.v 1eAN1.v RB0 1Bz0 Op0 1rb0 11d0 1jJc0 IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|010102304056565656565656565656565656565656565656565656565656565656565656565656565656565656567|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|0121212121212121212121212121212121212121212121212121212121212121212121212132121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -04 -0345 -03|3Q.D 40 3J 30|01231|-2mf87.l 8Hc7.l 2r7bJ Ey0f|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010401054541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|01203030303030303030303030303030304545450454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|010102304056565656565656565656565656565656565656565656565656565656565656565656565656565656567|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212121212|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Pacific/Port_Moresby|+10|-a0|0||25e4","Antarctica/Macquarie|AEST AEDT -00|-a0 -b0 0|010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00 LA0 1C00 Oo0 1zc0 Oo0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 Oo0 1zc0 Oo0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 Oo0 1C00 LA0 1C00|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|01010101010101010101010101010|-23uw0 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101010123232323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2o0 MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1qo0 Xc0 1qo0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101012323232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2o0 MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1qo0 Xc0 1qo0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +03 +04|-1U.U -20 -30 -30 -40|0121212121212121212121212121212121212121212121234312121212121212121212121212121212121212121212121212121212121212123|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212121321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|PST PDT JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|0121212121212121212121212121212121212121212123212321232123212121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|BMT BST AST ADT|4j.i 3j.i 40 30|010102323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28p7E.G 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|0121212121212121212121212121212121212121212123212321232123212121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Hobart|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293iJ xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293i0 xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0||","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Etc/GMT-0|GMT|0|0||","Etc/GMT-1|+01|-10|0||","Etc/GMT-11|+11|-b0|0||","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0||","Etc/GMT-14|+14|-e0|0||","Etc/GMT-2|+02|-20|0||","Etc/GMT-3|+03|-30|0||","Etc/GMT-4|+04|-40|0||","Etc/GMT-5|+05|-50|0||","Etc/GMT-6|+06|-60|0||","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0||","Pacific/Palau|+09|-90|0||21e3","Etc/GMT+1|-01|10|0||","Etc/GMT+10|-10|a0|0||","Etc/GMT+11|-11|b0|0||","Etc/GMT+12|-12|c0|0||","Etc/GMT+3|-03|30|0||","Etc/GMT+4|-04|40|0||","Etc/GMT+5|-05|50|0||","Etc/GMT+6|-06|60|0||","Etc/GMT+7|-07|70|0||","Etc/GMT+8|-08|80|0||","Etc/GMT+9|-09|90|0||","Etc/UTC|UTC|0|0||","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST EET EEST MSK MSD +03|-10 -20 -20 -30 -30 -40 -30|01010101010101232454545454545454543232323232323232323232323232323232323232323262|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2n5c9.l cFX9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|0123232323232323212121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0||","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2xorF.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 +10 +09 -12 +12|-b0 -a0 -90 c0 -c0|012034|-1kln0 akp0 6Up0 12ry0 Wan0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","MST|MST|70|0||","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Chuuk|+10 +09|-a0 -90|01010|-2ewy0 axB0 RVX0 axd0|49e3","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-00 -12 -11 +13|0 c0 b0 -d0|0123|-1iIo0 1GsA0 B7X0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|01212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0 4q00 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST +09 GDT ChST|-a0 -90 -b0 -a0|01020202020202020203|-18jK0 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4","Pacific/Honolulu|HST HDT HWT HPT HST|au 9u 9u 9u a0|0102304|-1thLu 8x0 lef0 8wWu iAu 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2","Pacific/Kosrae|+11 +09 +10 +12|-b0 -90 -a0 -c0|01021030|-2ewz0 axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2","Pacific/Majuro|+11 +09 +10 +12|-b0 -90 -a0 -c0|0102103|-2ewz0 axC0 HBy0 akp0 6RB0 12um0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3","Pacific/Niue|LMT -1120 -11|bj.E bk b0|012|-FScE.k suo0.k|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11 +12|-bc -bu -cu -b0 -c0|012134343434343434343434343434343434343434|-Kgbc W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Pohnpei|+11 +09 +10|-b0 -90 -a0|010210|-2ewz0 axC0 HBy0 akp0 axd0|34e3","Pacific/Rarotonga|LMT -1030 -0930 -10|aD.4 au 9u a0|0123232323232323232323232323|-FSdk.U 13tbO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|LMT +1220 +13 +14|-cj.c -ck -d0 -e0|01232323232|-XbMj.c BgLX.c 1yndk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|"],"links":["Africa/Abidjan|Africa/Accra","Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Chicago|US/Central","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Godthab|America/Nuuk","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Atikokan","America/Panama|America/Cayman","America/Panama|America/Coral_Harbour","America/Phoenix|America/Creston","America/Phoenix|US/Arizona","America/Puerto_Rico|America/Anguilla","America/Puerto_Rico|America/Antigua","America/Puerto_Rico|America/Aruba","America/Puerto_Rico|America/Blanc-Sablon","America/Puerto_Rico|America/Curacao","America/Puerto_Rico|America/Dominica","America/Puerto_Rico|America/Grenada","America/Puerto_Rico|America/Guadeloupe","America/Puerto_Rico|America/Kralendijk","America/Puerto_Rico|America/Lower_Princes","America/Puerto_Rico|America/Marigot","America/Puerto_Rico|America/Montserrat","America/Puerto_Rico|America/Port_of_Spain","America/Puerto_Rico|America/St_Barthelemy","America/Puerto_Rico|America/St_Kitts","America/Puerto_Rico|America/St_Lucia","America/Puerto_Rico|America/St_Thomas","America/Puerto_Rico|America/St_Vincent","America/Puerto_Rico|America/Tortola","America/Puerto_Rico|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|America/Nassau","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Antarctica/Syowa","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Currie","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UTC|Etc/UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UCT","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Chuuk|Pacific/Truk","Pacific/Chuuk|Pacific/Yap","Pacific/Easter|Chile/EasterIsland","Pacific/Enderbury|Pacific/Kanton","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Antarctica/DumontDUrville","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"],"countries":["AD|Europe/Andorra","AE|Asia/Dubai","AF|Asia/Kabul","AG|America/Port_of_Spain America/Antigua","AI|America/Port_of_Spain America/Anguilla","AL|Europe/Tirane","AM|Asia/Yerevan","AO|Africa/Lagos Africa/Luanda","AQ|Antarctica/Casey Antarctica/Davis Antarctica/DumontDUrville Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Syowa Antarctica/Troll Antarctica/Vostok Pacific/Auckland Antarctica/McMurdo","AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia","AS|Pacific/Pago_Pago","AT|Europe/Vienna","AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla","AW|America/Curacao America/Aruba","AX|Europe/Helsinki Europe/Mariehamn","AZ|Asia/Baku","BA|Europe/Belgrade Europe/Sarajevo","BB|America/Barbados","BD|Asia/Dhaka","BE|Europe/Brussels","BF|Africa/Abidjan Africa/Ouagadougou","BG|Europe/Sofia","BH|Asia/Qatar Asia/Bahrain","BI|Africa/Maputo Africa/Bujumbura","BJ|Africa/Lagos Africa/Porto-Novo","BL|America/Port_of_Spain America/St_Barthelemy","BM|Atlantic/Bermuda","BN|Asia/Brunei","BO|America/La_Paz","BQ|America/Curacao America/Kralendijk","BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco","BS|America/Nassau","BT|Asia/Thimphu","BW|Africa/Maputo Africa/Gaborone","BY|Europe/Minsk","BZ|America/Belize","CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Blanc-Sablon America/Toronto America/Nipigon America/Thunder_Bay America/Iqaluit America/Pangnirtung America/Atikokan America/Winnipeg America/Rainy_River America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Yellowknife America/Inuvik America/Creston America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver","CC|Indian/Cocos","CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi","CF|Africa/Lagos Africa/Bangui","CG|Africa/Lagos Africa/Brazzaville","CH|Europe/Zurich","CI|Africa/Abidjan","CK|Pacific/Rarotonga","CL|America/Santiago America/Punta_Arenas Pacific/Easter","CM|Africa/Lagos Africa/Douala","CN|Asia/Shanghai Asia/Urumqi","CO|America/Bogota","CR|America/Costa_Rica","CU|America/Havana","CV|Atlantic/Cape_Verde","CW|America/Curacao","CX|Indian/Christmas","CY|Asia/Nicosia Asia/Famagusta","CZ|Europe/Prague","DE|Europe/Zurich Europe/Berlin Europe/Busingen","DJ|Africa/Nairobi Africa/Djibouti","DK|Europe/Copenhagen","DM|America/Port_of_Spain America/Dominica","DO|America/Santo_Domingo","DZ|Africa/Algiers","EC|America/Guayaquil Pacific/Galapagos","EE|Europe/Tallinn","EG|Africa/Cairo","EH|Africa/El_Aaiun","ER|Africa/Nairobi Africa/Asmara","ES|Europe/Madrid Africa/Ceuta Atlantic/Canary","ET|Africa/Nairobi Africa/Addis_Ababa","FI|Europe/Helsinki","FJ|Pacific/Fiji","FK|Atlantic/Stanley","FM|Pacific/Chuuk Pacific/Pohnpei Pacific/Kosrae","FO|Atlantic/Faroe","FR|Europe/Paris","GA|Africa/Lagos Africa/Libreville","GB|Europe/London","GD|America/Port_of_Spain America/Grenada","GE|Asia/Tbilisi","GF|America/Cayenne","GG|Europe/London Europe/Guernsey","GH|Africa/Accra","GI|Europe/Gibraltar","GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule","GM|Africa/Abidjan Africa/Banjul","GN|Africa/Abidjan Africa/Conakry","GP|America/Port_of_Spain America/Guadeloupe","GQ|Africa/Lagos Africa/Malabo","GR|Europe/Athens","GS|Atlantic/South_Georgia","GT|America/Guatemala","GU|Pacific/Guam","GW|Africa/Bissau","GY|America/Guyana","HK|Asia/Hong_Kong","HN|America/Tegucigalpa","HR|Europe/Belgrade Europe/Zagreb","HT|America/Port-au-Prince","HU|Europe/Budapest","ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura","IE|Europe/Dublin","IL|Asia/Jerusalem","IM|Europe/London Europe/Isle_of_Man","IN|Asia/Kolkata","IO|Indian/Chagos","IQ|Asia/Baghdad","IR|Asia/Tehran","IS|Atlantic/Reykjavik","IT|Europe/Rome","JE|Europe/London Europe/Jersey","JM|America/Jamaica","JO|Asia/Amman","JP|Asia/Tokyo","KE|Africa/Nairobi","KG|Asia/Bishkek","KH|Asia/Bangkok Asia/Phnom_Penh","KI|Pacific/Tarawa Pacific/Enderbury Pacific/Kiritimati","KM|Africa/Nairobi Indian/Comoro","KN|America/Port_of_Spain America/St_Kitts","KP|Asia/Pyongyang","KR|Asia/Seoul","KW|Asia/Riyadh Asia/Kuwait","KY|America/Panama America/Cayman","KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral","LA|Asia/Bangkok Asia/Vientiane","LB|Asia/Beirut","LC|America/Port_of_Spain America/St_Lucia","LI|Europe/Zurich Europe/Vaduz","LK|Asia/Colombo","LR|Africa/Monrovia","LS|Africa/Johannesburg Africa/Maseru","LT|Europe/Vilnius","LU|Europe/Luxembourg","LV|Europe/Riga","LY|Africa/Tripoli","MA|Africa/Casablanca","MC|Europe/Monaco","MD|Europe/Chisinau","ME|Europe/Belgrade Europe/Podgorica","MF|America/Port_of_Spain America/Marigot","MG|Africa/Nairobi Indian/Antananarivo","MH|Pacific/Majuro Pacific/Kwajalein","MK|Europe/Belgrade Europe/Skopje","ML|Africa/Abidjan Africa/Bamako","MM|Asia/Yangon","MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan","MO|Asia/Macau","MP|Pacific/Guam Pacific/Saipan","MQ|America/Martinique","MR|Africa/Abidjan Africa/Nouakchott","MS|America/Port_of_Spain America/Montserrat","MT|Europe/Malta","MU|Indian/Mauritius","MV|Indian/Maldives","MW|Africa/Maputo Africa/Blantyre","MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Mazatlan America/Chihuahua America/Ojinaga America/Hermosillo America/Tijuana America/Bahia_Banderas","MY|Asia/Kuala_Lumpur Asia/Kuching","MZ|Africa/Maputo","NA|Africa/Windhoek","NC|Pacific/Noumea","NE|Africa/Lagos Africa/Niamey","NF|Pacific/Norfolk","NG|Africa/Lagos","NI|America/Managua","NL|Europe/Amsterdam","NO|Europe/Oslo","NP|Asia/Kathmandu","NR|Pacific/Nauru","NU|Pacific/Niue","NZ|Pacific/Auckland Pacific/Chatham","OM|Asia/Dubai Asia/Muscat","PA|America/Panama","PE|America/Lima","PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier","PG|Pacific/Port_Moresby Pacific/Bougainville","PH|Asia/Manila","PK|Asia/Karachi","PL|Europe/Warsaw","PM|America/Miquelon","PN|Pacific/Pitcairn","PR|America/Puerto_Rico","PS|Asia/Gaza Asia/Hebron","PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores","PW|Pacific/Palau","PY|America/Asuncion","QA|Asia/Qatar","RE|Indian/Reunion","RO|Europe/Bucharest","RS|Europe/Belgrade","RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr","RW|Africa/Maputo Africa/Kigali","SA|Asia/Riyadh","SB|Pacific/Guadalcanal","SC|Indian/Mahe","SD|Africa/Khartoum","SE|Europe/Stockholm","SG|Asia/Singapore","SH|Africa/Abidjan Atlantic/St_Helena","SI|Europe/Belgrade Europe/Ljubljana","SJ|Europe/Oslo Arctic/Longyearbyen","SK|Europe/Prague Europe/Bratislava","SL|Africa/Abidjan Africa/Freetown","SM|Europe/Rome Europe/San_Marino","SN|Africa/Abidjan Africa/Dakar","SO|Africa/Nairobi Africa/Mogadishu","SR|America/Paramaribo","SS|Africa/Juba","ST|Africa/Sao_Tome","SV|America/El_Salvador","SX|America/Curacao America/Lower_Princes","SY|Asia/Damascus","SZ|Africa/Johannesburg Africa/Mbabane","TC|America/Grand_Turk","TD|Africa/Ndjamena","TF|Indian/Reunion Indian/Kerguelen","TG|Africa/Abidjan Africa/Lome","TH|Asia/Bangkok","TJ|Asia/Dushanbe","TK|Pacific/Fakaofo","TL|Asia/Dili","TM|Asia/Ashgabat","TN|Africa/Tunis","TO|Pacific/Tongatapu","TR|Europe/Istanbul","TT|America/Port_of_Spain","TV|Pacific/Funafuti","TW|Asia/Taipei","TZ|Africa/Nairobi Africa/Dar_es_Salaam","UA|Europe/Simferopol Europe/Kiev Europe/Uzhgorod Europe/Zaporozhye","UG|Africa/Nairobi Africa/Kampala","UM|Pacific/Pago_Pago Pacific/Wake Pacific/Honolulu Pacific/Midway","US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu","UY|America/Montevideo","UZ|Asia/Samarkand Asia/Tashkent","VA|Europe/Rome Europe/Vatican","VC|America/Port_of_Spain America/St_Vincent","VE|America/Caracas","VG|America/Port_of_Spain America/Tortola","VI|America/Port_of_Spain America/St_Thomas","VN|Asia/Bangkok Asia/Ho_Chi_Minh","VU|Pacific/Efate","WF|Pacific/Wallis","WS|Pacific/Apia","YE|Asia/Riyadh Asia/Aden","YT|Africa/Nairobi Indian/Mayotte","ZA|Africa/Johannesburg","ZM|Africa/Maputo Africa/Lusaka","ZW|Africa/Maputo Africa/Harare"]}

/***/ }),
/* 1656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createUserManager;
var Oidc=__webpack_require__(658);Oidc.Log.logger=console;var UserManager=void 0;try{UserManager=__webpack_require__(658).UserManager;}catch(a){throw new Error("Could not find dependency: 'oidc-client'.");}function createUserManager(config){var managerConfig=config;if(config.user_endpoint){managerConfig=Object.assign({},config,{metadata:{issuer:config.authority,authorization_endpoint:config.authority+'/authorize',userinfo_endpoint:config.user_endpoint,end_session_endpoint:'',jwks_uri:''}});}else{managerConfig=Object.assign({},config,{loadUserInfo:false// includeIdTokenInSilentRenew: false,
});}return new UserManager(managerConfig);}

/***/ }),
/* 1657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storage; });
function hasLocalStorage(){try{return'localStorage'in window&&window['localStorage']!==null;}catch(e){return false;}}var storage=hasLocalStorage()?localStorage:sessionStorage;

/***/ }),
/* 1658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InventoryStore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_request__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_stores_AppStore__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App_stores_UserStore__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Overview_stores_ListingsStore__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Sale_stores_SaleStore__ = __webpack_require__(264);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_dec2,_dec3,_desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var byDefaultDoNothing=function byDefaultDoNothing(){};var overviewColumns=function overviewColumns(t){var onClick=arguments.length>1&&arguments[1]!==undefined?arguments[1]:byDefaultDoNothing;return[{key:'image',fieldName:'image',maxWidth:100},{key:'referenceNumber',name:t('Number'),fieldName:'referenceNumber',minWidth:50,maxWidth:130,onColumnClick:onClick,isSorted:false,isSortedDescending:false,isResizable:true},{key:'title',name:t('Title'),fieldName:'title',minWidth:200,maxWidth:600,onColumnClick:onClick,isSorted:false,isSortedDescending:false,isResizable:true},{key:'address',name:t('Address'),fieldName:'address',minWidth:200,isResizable:true},{key:'price',name:t('Price'),fieldName:'price',className:'ms-textAlignRight',headerClassName:'ms-textAlignRight',maxWidth:100,isResizable:true},{key:'area',name:t('Area')+' ('+t('Area_unit')+')',fieldName:'area',className:'ms-textAlignCenter',headerClassName:'ms-textAlignCenter',maxWidth:100,isResizable:true}];};var InventoryStore=(_dec=__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */].bound,_dec2=__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */].bound,_dec3=__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */].bound,(_class=function(){function InventoryStore(app,sale,user,listings){_classCallCheck(this,InventoryStore);_initDefineProp(this,'items',_descriptor,this);_initDefineProp(this,'columns',_descriptor2,this);_initDefineProp(this,'selectedItem',_descriptor3,this);_initDefineProp(this,'fetching',_descriptor4,this);_initDefineProp(this,'error',_descriptor5,this);_initDefineProp(this,'fetchingItem',_descriptor6,this);_initDefineProp(this,'selectedAgent',_descriptor7,this);_initDefineProp(this,'agents',_descriptor8,this);this.app=app;this.sale=sale;this.user=user;this.listings=listings;}_createClass(InventoryStore,[{key:'findListing',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(number){var filtered;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:filtered=this.listings.items.filter(function(i){return i.status!=='Resolved'&&i.itemNumber===number;});return _context.abrupt('return',filtered.length>0?filtered[0]:null);case 2:case'end':return _context.stop();}}},_callee,this);}));function findListing(_x2){return _ref.apply(this,arguments);}return findListing;}()},{key:'loadAgents',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(){var _this=this;var um,result;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;um=this.app.config&&this.app.config.userManagement&&this.app.config.userManagement.url?this.app.config.userManagement.url:'';_context2.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2__services_request__["d" /* get */])(um+'/users/lookup',this.user.accessToken);case 4:result=_context2.sent;Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["l" /* runInAction */])(function(){return _this.agents=result;});_context2.next=10;break;case 8:_context2.prev=8;_context2.t0=_context2['catch'](0);case 10:case'end':return _context2.stop();}}},_callee2,this,[[0,8]]);}));function loadAgents(){return _ref2.apply(this,arguments);}return loadAgents;}()},{key:'initColumns',value:function initColumns(t,onClick){this.columns=overviewColumns(t,onClick);}},{key:'sortBy',value:function sortBy(field){var index=this.columns.findIndex(function(c){return c.key===field;});var column=this.columns[index];this.items=this.items.sortBy(field,column.isSortedDescending);this.columns=this.columns.map(function(c,i){if(i!==index){c.isSorted=false;c.isSortedDescending=false;}else{c.isSorted=true;c.isSortedDescending=!c.isSortedDescending;}return c;});}},{key:'select',value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3(item){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return this.get(item.id);case 2:case'end':return _context3.stop();}}},_callee3,this);}));function select(_x3){return _ref3.apply(this,arguments);}return select;}()},{key:'deselect',value:function deselect(item){this.selectedItem=null;}},{key:'search',value:function search(){this.fetching=true;this.error=null;if(!__WEBPACK_IMPORTED_MODULE_5__Overview_stores_ListingsStore__["a" /* default */].loaded){__WEBPACK_IMPORTED_MODULE_5__Overview_stores_ListingsStore__["a" /* default */].load();}Object(__WEBPACK_IMPORTED_MODULE_2__services_request__["d" /* get */])(this.app.config.inventory.url,this.user.accessToken).then(this.searchSuccess,this.onError);}},{key:'get',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee4(id){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:this.fetchingItem=true;_context4.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__services_request__["d" /* get */])(''+this.app.config.inventory.url+(this.app.config.inventory.url.endsWith('/')?'':'/')+encodeURIComponent(id),this.user.accessToken).then(function(item){return _this2.getSuccess(Object.assign(item,{inventoryId:id}));},this.onError);case 3:case'end':return _context4.stop();}}},_callee4,this);}));function get(_x4){return _ref4.apply(this,arguments);}return get;}()},{key:'getExistingSale',value:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee5(id){var result;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.prev=0;_context5.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__services_request__["d" /* get */])('/api/v1/sales/find-by-integration-id?id='+encodeURIComponent(id),this.user.accessToken);case 3:result=_context5.sent;return _context5.abrupt('return',result?result.saleIds.at(0):null);case 7:_context5.prev=7;_context5.t0=_context5['catch'](0);return _context5.abrupt('return',null);case 10:case'end':return _context5.stop();}}},_callee5,this,[[0,7]]);}));function getExistingSale(_x5){return _ref5.apply(this,arguments);}return getExistingSale;}()},{key:'searchSuccess',value:function searchSuccess(items){this.items=items;this.fetching=false;this.error=null;}},{key:'getSuccess',value:function getSuccess(item){var supportedLocales=this.user.userConfig.localeCodes;var locale=supportedLocales.indexOf(__WEBPACK_IMPORTED_MODULE_4__App_stores_UserStore__["a" /* default */].claims.locale)>=0?__WEBPACK_IMPORTED_MODULE_4__App_stores_UserStore__["a" /* default */].claims.locale:supportedLocales[0];item.public=Object.assign({currency_code:this.app.currency.code,locale:locale},item.public);this.selectedItem=item;this.fetchingItem=false;}},{key:'onError',value:function onError(error){this.items=[];this.fetching=false;this.error=error;}},{key:'listBuyers',value:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee6(id,saleId,contacts){var query;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:query=contacts?'?contacts='+contacts:'';return _context6.abrupt('return',Object(__WEBPACK_IMPORTED_MODULE_2__services_request__["d" /* get */])(''+this.app.config.inventory.url+(this.app.config.inventory.url.endsWith('/')?'':'/')+(encodeURIComponent(id)||'empty')+'/buyers'+query,this.user.accessToken,{saleId:saleId}));case 2:case'end':return _context6.stop();}}},_callee6,this);}));function listBuyers(_x6,_x7,_x8){return _ref6.apply(this,arguments);}return listBuyers;}()},{key:'delete',value:function _delete(id){return Object(__WEBPACK_IMPORTED_MODULE_2__services_request__["c" /* del */])(''+this.app.config.inventory.url+(this.app.config.inventory.url.endsWith('/')?'':'/')+encodeURIComponent(id),this.user.accessToken);}},{key:'saleAgent',get:function get(){var agent=this.selectedItem.public.agent;return this.selectedAgent||this.agents.find(function(a){return String(a.sub)===String(agent.sub);})||this.agents.find(function(a){return(String(a.id)||String(a.agent_id))===String(agent.id)&&(!a.office_id&&!agent.office_id||String(a.office_id)===String(agent.office_id));})||(this.agents.length===1?this.agents[0]:undefined);}},{key:'agentsForSelectedItem',get:function get(){var office_id=!!this.selectedItem&&!!this.selectedItem.private?this.selectedItem.private.office_id:null;if(!office_id)return this.agents;return this.agents.filter(function(a){return!a.office_id||String(a.office_id)===String(office_id);});}},{key:'masterSales',get:function get(){var filtered=this.listings.items.filter(function(i){return!!(i.features||{}).isMasterSale;}).map(function(s){return{key:s.id,text:s.title};});return filtered;}},{key:'redirect',get:function get(){var _sale$response=this.sale.response,commandType=_sale$response.commandType,result=_sale$response.result;if(commandType!=='StartSaleProcess'){return false;}if(!result||!result.successful){return false;}return true;}},{key:'isListed',get:function get(){return this.listed!==null;}},{key:'listed',get:function get(){if(!this.selectedItem)return null;var selected=this.selectedItem.private.objectno;var filtered=this.listings.items.filter(function(i){return i.status!=='Resolved'&&i.itemNumber===selected;});return filtered.length>0?filtered[0]:null;}},{key:'startedSale',get:function get(){var command=this.sale.response.command;return command?command.saleId:undefined;}}]);return InventoryStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'items',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'columns',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'selectedItem',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'fetching',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'error',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'fetchingItem',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'selectedAgent',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:null}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'agents',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}}),_applyDecoratedDescriptor(_class.prototype,'saleAgent',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'saleAgent'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'agentsForSelectedItem',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'agentsForSelectedItem'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'masterSales',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'masterSales'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'redirect',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'redirect'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isListed',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isListed'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'listed',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'listed'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'startedSale',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'startedSale'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'loadAgents',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'loadAgents'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'initColumns',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'initColumns'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'sortBy',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'sortBy'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'select',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'select'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'deselect',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'deselect'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'search',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'search'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'get',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'get'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getExistingSale',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'getExistingSale'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'searchSuccess',[_dec],Object.getOwnPropertyDescriptor(_class.prototype,'searchSuccess'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getSuccess',[_dec2],Object.getOwnPropertyDescriptor(_class.prototype,'getSuccess'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onError',[_dec3],Object.getOwnPropertyDescriptor(_class.prototype,'onError'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'listBuyers',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'listBuyers'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'delete',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'delete'),_class.prototype)),_class));var inventory=new InventoryStore(__WEBPACK_IMPORTED_MODULE_3__App_stores_AppStore__["a" /* default */],__WEBPACK_IMPORTED_MODULE_6__Sale_stores_SaleStore__["a" /* default */],__WEBPACK_IMPORTED_MODULE_4__App_stores_UserStore__["a" /* default */],__WEBPACK_IMPORTED_MODULE_5__Overview_stores_ListingsStore__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (inventory);

/***/ }),
/* 1659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MAX_NOT_FOUND_RETRIES */
/* unused harmony export NOT_FOUND_RETRY_DELAY */
/* unused harmony export MAX_CONNECT_ATTEMPTS */
/* unused harmony export MAX_ACCESS_RETRIES */
/* unused harmony export ACCESS_RETRY_DELAY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WebSocketStore; });
/* unused harmony export BoundedRetryPolicy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_microsoft_signalr__ = __webpack_require__(1660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__ = __webpack_require__(7);
var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var logLevel= true?__WEBPACK_IMPORTED_MODULE_1__build_node_modules_microsoft_signalr__["c" /* LogLevel */].None:signalr.LogLevel.Information;// A stream that answers `notFound` is answering about a specific sid. Retrying
// is only worth it for the short window where the sale has not propagated yet;
// past that the sid is simply not a sale and the loop has to end.
var MAX_NOT_FOUND_RETRIES=10;var NOT_FOUND_RETRY_DELAY=500;// Transport-level failures get a bounded, jittered backoff instead of a flat
// interval, so a fleet of stale tabs cannot turn into a thundering herd.
var MAX_CONNECT_ATTEMPTS=10;// A permissions miss is re-checked a bounded number of times (whitelisting can
// land moments after the sale payload) and then becomes terminal.
var MAX_ACCESS_RETRIES=10;var ACCESS_RETRY_DELAY=500;var CONNECT_RETRY_DELAY=5000;var MAX_CONNECT_RETRY_DELAY=30000;function backoffDelay(attempt){var delay=Math.min(CONNECT_RETRY_DELAY*Math.pow(2,attempt),MAX_CONNECT_RETRY_DELAY);return delay+Math.floor(Math.random()*1000);}var BoundedRetryPolicy=function(){function BoundedRetryPolicy(){_classCallCheck(this,BoundedRetryPolicy);}_createClass(BoundedRetryPolicy,[{key:'nextRetryDelayInMilliseconds',value:function nextRetryDelayInMilliseconds(retryContext){if(retryContext.previousRetryCount>=MAX_CONNECT_ATTEMPTS){console.error('[ws] automatic reconnect exhausted, giving up');return null;}return backoffDelay(retryContext.previousRetryCount);}}]);return BoundedRetryPolicy;}();var WebSocketStore=(_class=function(){function WebSocketStore(user){var _this=this;_classCallCheck(this,WebSocketStore);_initDefineProp(this,'connected',_descriptor,this);_initDefineProp(this,'forbidden',_descriptor2,this);_initDefineProp(this,'notFound',_descriptor3,this);_initDefineProp(this,'unavailable',_descriptor4,this);this.notFoundRetries=0;this.accessRetries=0;this.connectAttempts=0;this.stopped=false;this.retryTimer=null;this.disconnect=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.stopped=true;_this.clearRetryTimer();if(_this.connection){_context.next=4;break;}return _context.abrupt('return');case 4:_context.next=6;return _this.connection.stop();case 6:case'end':return _context.stop();}}},_callee,_this);}));this.reconnect=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.disconnect();case 2:_context2.next=4;return _this.connect(_this.uri);case 4:case'end':return _context2.stop();}}},_callee2,_this);}));this.tryConnect=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3(){var delay;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:if(!_this.stopped){_context3.next=2;break;}return _context3.abrupt('return');case 2:_context3.prev=2;_context3.next=5;return _this.connection.start();case 5:_this.connectAttempts=0;_context3.next=23;break;case 8:_context3.prev=8;_context3.t0=_context3['catch'](2);if(!_this.stopped){_context3.next=12;break;}return _context3.abrupt('return');case 12:if(_this.hasValidToken()){_context3.next=16;break;}console.error('[ws] no usable access token, not retrying');_this.onUnavailable();return _context3.abrupt('return');case 16:if(!(_this.connectAttempts>=MAX_CONNECT_ATTEMPTS)){_context3.next=20;break;}console.error('[ws] connect attempts exhausted, giving up');_this.onUnavailable();return _context3.abrupt('return');case 20:delay=backoffDelay(_this.connectAttempts);_this.connectAttempts+=1;_this.scheduleRetry(delay,_this.tryConnect);case 23:case'end':return _context3.stop();}}},_callee3,_this,[[2,8]]);}));this.received=function(message){};this.user=user;}// Retry budgets are keyed to the target uri, not to the connection: a
// reconnect against the same sid must not replenish them, or the loop is
// unbounded again.
_createClass(WebSocketStore,[{key:'hasValidToken',value:function hasValidToken(){if(!this.user){return true;}return!!this.user.accessToken&&!(this.user.data&&this.user.data.expired);}},{key:'clearRetryTimer',value:function clearRetryTimer(){if(this.retryTimer!==null){clearTimeout(this.retryTimer);this.retryTimer=null;}}},{key:'scheduleRetry',value:function scheduleRetry(delay,callback){var _this2=this;this.clearRetryTimer();this.retryTimer=setTimeout(function(){_this2.retryTimer=null;if(_this2.stopped){return;}callback();},delay);}},{key:'connect',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee4(uri){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:if(!this.connected){_context4.next=2;break;}return _context4.abrupt('return');case 2:if(uri!==this.uri){this.notFoundRetries=0;this.accessRetries=0;}this.forbidden=false;this.notFound=false;this.unavailable=false;this.stopped=false;this.connectAttempts=0;this.clearRetryTimer();this.uri=uri;this.connection=new __WEBPACK_IMPORTED_MODULE_1__build_node_modules_microsoft_signalr__["b" /* HubConnectionBuilder */]().withUrl(uri,{skipNegotiation:true,transport:__WEBPACK_IMPORTED_MODULE_1__build_node_modules_microsoft_signalr__["a" /* HttpTransportType */].WebSockets,accessTokenFactory:function accessTokenFactory(){return _this3.user.accessToken;}}).withAutomaticReconnect(new BoundedRetryPolicy()).configureLogging(logLevel).build();this.connection.onclose(function(err){return _this3.onDisconnect(err);});this.connection.on('connected',function(_){return _this3.onConnected();});this.connection.on('update',function(data){return _this3.onUpdate(data);});this.connection.on('error',function(data){return _this3.onError(data);});_context4.next=17;return this.tryConnect();case 17:case'end':return _context4.stop();}}},_callee4,this);}));function connect(_x){return _ref4.apply(this,arguments);}return connect;}()},{key:'onUpdate',value:function onUpdate(data){// Real payload for this sid: the sale exists, so the notFound budget is
// spent on a genuinely transient condition and can be released.
this.notFoundRetries=0;this.received(data.payload,data.timestamp);}},{key:'onError',value:function onError(err){console.error(err);if(err.status==='notFound'){this.onNotFound();}if(err.status==='forbidden'){this.forbidden=true;}}},{key:'onNotFound',value:function onNotFound(){if(this.notFoundRetries>=MAX_NOT_FOUND_RETRIES){console.error('[ws] sale not found after '+this.notFoundRetries+' retries');this.notFound=true;this.disconnect();return;}this.notFoundRetries+=1;this.scheduleRetry(NOT_FOUND_RETRY_DELAY,this.reconnect);}},{key:'onAccessDenied',value:function onAccessDenied(){if(this.accessRetries>=MAX_ACCESS_RETRIES){console.error('[ws] access denied after '+this.accessRetries+' retries');this.forbidden=true;this.disconnect();return;}this.accessRetries+=1;this.scheduleRetry(ACCESS_RETRY_DELAY,this.reconnect);}},{key:'onUnavailable',value:function onUnavailable(){this.unavailable=true;this.disconnect();}},{key:'onConnected',value:function onConnected(){this.connected=true;this.connectAttempts=0;}},{key:'onDisconnect',value:function onDisconnect(err){this.connected=false;}}]);return WebSocketStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'connected',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'forbidden',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'notFound',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'unavailable',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_applyDecoratedDescriptor(_class.prototype,'connect',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'connect'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onNotFound',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'onNotFound'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onAccessDenied',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'onAccessDenied'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onUnavailable',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'onUnavailable'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onConnected',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'onConnected'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'onDisconnect',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'onDisconnect'),_class.prototype)),_class);var websocket=new WebSocketStore();/* unused harmony default export */ var _unused_webpack_default_export = (websocket);

/***/ }),
/* 1660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Errors__ = __webpack_require__(179);
/* unused harmony reexport AbortError */
/* unused harmony reexport HttpError */
/* unused harmony reexport TimeoutError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HttpClient__ = __webpack_require__(265);
/* unused harmony reexport HttpClient */
/* unused harmony reexport HttpResponse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DefaultHttpClient__ = __webpack_require__(659);
/* unused harmony reexport DefaultHttpClient */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HubConnection__ = __webpack_require__(660);
/* unused harmony reexport HubConnection */
/* unused harmony reexport HubConnectionState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HubConnectionBuilder__ = __webpack_require__(1666);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__HubConnectionBuilder__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IHubProtocol__ = __webpack_require__(396);
/* unused harmony reexport MessageType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ILogger__ = __webpack_require__(87);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__ILogger__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ITransport__ = __webpack_require__(148);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_7__ITransport__["a"]; });
/* unused harmony reexport TransferFormat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Loggers__ = __webpack_require__(266);
/* unused harmony reexport NullLogger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__JsonHubProtocol__ = __webpack_require__(664);
/* unused harmony reexport JsonHubProtocol */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Subject__ = __webpack_require__(663);
/* unused harmony reexport Subject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Utils__ = __webpack_require__(88);
/* unused harmony reexport VERSION */
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.












//# sourceMappingURL=index.js.map

/***/ }),
/* 1661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FetchHttpClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Errors__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HttpClient__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ILogger__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utils__ = __webpack_require__(88);
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};




var FetchHttpClient = /** @class */ (function (_super) {
    __extends(FetchHttpClient, _super);
    function FetchHttpClient(logger) {
        var _this = _super.call(this) || this;
        _this.logger = logger;
        if (typeof fetch === "undefined") {
            // In order to ignore the dynamic require in webpack builds we need to do this magic
            // @ts-ignore: TS doesn't know about these names
            var requireFunc =  true ? require : require;
            // Cookies aren't automatically handled in Node so we need to add a CookieJar to preserve cookies across requests
            _this.jar = new (requireFunc("tough-cookie")).CookieJar();
            _this.fetchType = requireFunc("node-fetch");
            // node-fetch doesn't have a nice API for getting and setting cookies
            // fetch-cookie will wrap a fetch implementation with a default CookieJar or a provided one
            _this.fetchType = requireFunc("fetch-cookie")(_this.fetchType, _this.jar);
            // Node needs EventListener methods on AbortController which our custom polyfill doesn't provide
            _this.abortControllerType = requireFunc("abort-controller");
        }
        else {
            _this.fetchType = fetch.bind(self);
            _this.abortControllerType = AbortController;
        }
        return _this;
    }
    /** @inheritDoc */
    FetchHttpClient.prototype.send = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var abortController, error, timeoutId, msTimeout, response, e_1, content, payload;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Check that abort was not signaled before calling send
                        if (request.abortSignal && request.abortSignal.aborted) {
                            throw new __WEBPACK_IMPORTED_MODULE_0__Errors__["a" /* AbortError */]();
                        }
                        if (!request.method) {
                            throw new Error("No method defined.");
                        }
                        if (!request.url) {
                            throw new Error("No url defined.");
                        }
                        abortController = new this.abortControllerType();
                        // Hook our abortSignal into the abort controller
                        if (request.abortSignal) {
                            request.abortSignal.onabort = function () {
                                abortController.abort();
                                error = new __WEBPACK_IMPORTED_MODULE_0__Errors__["a" /* AbortError */]();
                            };
                        }
                        timeoutId = null;
                        if (request.timeout) {
                            msTimeout = request.timeout;
                            timeoutId = setTimeout(function () {
                                abortController.abort();
                                _this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Warning, "Timeout from HTTP request.");
                                error = new __WEBPACK_IMPORTED_MODULE_0__Errors__["c" /* TimeoutError */]();
                            }, msTimeout);
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.fetchType(request.url, {
                                body: request.content,
                                cache: "no-cache",
                                credentials: request.withCredentials === true ? "include" : "same-origin",
                                headers: __assign({ "Content-Type": "text/plain;charset=UTF-8", "X-Requested-With": "XMLHttpRequest" }, request.headers),
                                method: request.method,
                                mode: "cors",
                                redirect: "manual",
                                signal: abortController.signal,
                            })];
                    case 2:
                        response = _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        if (error) {
                            throw error;
                        }
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Warning, "Error from HTTP request. " + e_1 + ".");
                        throw e_1;
                    case 4:
                        if (timeoutId) {
                            clearTimeout(timeoutId);
                        }
                        if (request.abortSignal) {
                            request.abortSignal.onabort = null;
                        }
                        return [7 /*endfinally*/];
                    case 5:
                        if (!response.ok) {
                            throw new __WEBPACK_IMPORTED_MODULE_0__Errors__["b" /* HttpError */](response.statusText, response.status);
                        }
                        content = deserializeContent(response, request.responseType);
                        return [4 /*yield*/, content];
                    case 6:
                        payload = _a.sent();
                        return [2 /*return*/, new __WEBPACK_IMPORTED_MODULE_1__HttpClient__["b" /* HttpResponse */](response.status, response.statusText, payload)];
                }
            });
        });
    };
    FetchHttpClient.prototype.getCookieString = function (url) {
        var cookies = "";
        if (__WEBPACK_IMPORTED_MODULE_3__Utils__["c" /* Platform */].isNode && this.jar) {
            // @ts-ignore: unused variable
            this.jar.getCookies(url, function (e, c) { return cookies = c.join("; "); });
        }
        return cookies;
    };
    return FetchHttpClient;
}(__WEBPACK_IMPORTED_MODULE_1__HttpClient__["a" /* HttpClient */]));

function deserializeContent(response, responseType) {
    var content;
    switch (responseType) {
        case "arraybuffer":
            content = response.arrayBuffer();
            break;
        case "text":
            content = response.text();
            break;
        case "blob":
        case "document":
        case "json":
            throw new Error(responseType + " is not supported.");
        default:
            content = response.text();
            break;
    }
    return content;
}
//# sourceMappingURL=FetchHttpClient.js.map

/***/ }),
/* 1662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return XhrHttpClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Errors__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HttpClient__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ILogger__ = __webpack_require__(87);
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var XhrHttpClient = /** @class */ (function (_super) {
    __extends(XhrHttpClient, _super);
    function XhrHttpClient(logger) {
        var _this = _super.call(this) || this;
        _this.logger = logger;
        return _this;
    }
    /** @inheritDoc */
    XhrHttpClient.prototype.send = function (request) {
        var _this = this;
        // Check that abort was not signaled before calling send
        if (request.abortSignal && request.abortSignal.aborted) {
            return Promise.reject(new __WEBPACK_IMPORTED_MODULE_0__Errors__["a" /* AbortError */]());
        }
        if (!request.method) {
            return Promise.reject(new Error("No method defined."));
        }
        if (!request.url) {
            return Promise.reject(new Error("No url defined."));
        }
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open(request.method, request.url, true);
            xhr.withCredentials = request.withCredentials === undefined ? true : request.withCredentials;
            xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
            // Explicitly setting the Content-Type header for React Native on Android platform.
            xhr.setRequestHeader("Content-Type", "text/plain;charset=UTF-8");
            var headers = request.headers;
            if (headers) {
                Object.keys(headers)
                    .forEach(function (header) {
                    xhr.setRequestHeader(header, headers[header]);
                });
            }
            if (request.responseType) {
                xhr.responseType = request.responseType;
            }
            if (request.abortSignal) {
                request.abortSignal.onabort = function () {
                    xhr.abort();
                    reject(new __WEBPACK_IMPORTED_MODULE_0__Errors__["a" /* AbortError */]());
                };
            }
            if (request.timeout) {
                xhr.timeout = request.timeout;
            }
            xhr.onload = function () {
                if (request.abortSignal) {
                    request.abortSignal.onabort = null;
                }
                if (xhr.status >= 200 && xhr.status < 300) {
                    resolve(new __WEBPACK_IMPORTED_MODULE_1__HttpClient__["b" /* HttpResponse */](xhr.status, xhr.statusText, xhr.response || xhr.responseText));
                }
                else {
                    reject(new __WEBPACK_IMPORTED_MODULE_0__Errors__["b" /* HttpError */](xhr.statusText, xhr.status));
                }
            };
            xhr.onerror = function () {
                _this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Warning, "Error from HTTP request. " + xhr.status + ": " + xhr.statusText + ".");
                reject(new __WEBPACK_IMPORTED_MODULE_0__Errors__["b" /* HttpError */](xhr.statusText, xhr.status));
            };
            xhr.ontimeout = function () {
                _this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Warning, "Timeout from HTTP request.");
                reject(new __WEBPACK_IMPORTED_MODULE_0__Errors__["c" /* TimeoutError */]());
            };
            xhr.send(request.content || "");
        });
    };
    return XhrHttpClient;
}(__WEBPACK_IMPORTED_MODULE_1__HttpClient__["a" /* HttpClient */]));

//# sourceMappingURL=XhrHttpClient.js.map

/***/ }),
/* 1663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HandshakeProtocol; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TextMessageFormat__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utils__ = __webpack_require__(88);
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.


/** @private */
var HandshakeProtocol = /** @class */ (function () {
    function HandshakeProtocol() {
    }
    // Handshake request is always JSON
    HandshakeProtocol.prototype.writeHandshakeRequest = function (handshakeRequest) {
        return __WEBPACK_IMPORTED_MODULE_0__TextMessageFormat__["a" /* TextMessageFormat */].write(JSON.stringify(handshakeRequest));
    };
    HandshakeProtocol.prototype.parseHandshakeResponse = function (data) {
        var responseMessage;
        var messageData;
        var remainingData;
        if (Object(__WEBPACK_IMPORTED_MODULE_1__Utils__["h" /* isArrayBuffer */])(data) || (typeof Buffer !== "undefined" && data instanceof Buffer)) {
            // Format is binary but still need to read JSON text from handshake response
            var binaryData = new Uint8Array(data);
            var separatorIndex = binaryData.indexOf(__WEBPACK_IMPORTED_MODULE_0__TextMessageFormat__["a" /* TextMessageFormat */].RecordSeparatorCode);
            if (separatorIndex === -1) {
                throw new Error("Message is incomplete.");
            }
            // content before separator is handshake response
            // optional content after is additional messages
            var responseLength = separatorIndex + 1;
            messageData = String.fromCharCode.apply(null, binaryData.slice(0, responseLength));
            remainingData = (binaryData.byteLength > responseLength) ? binaryData.slice(responseLength).buffer : null;
        }
        else {
            var textData = data;
            var separatorIndex = textData.indexOf(__WEBPACK_IMPORTED_MODULE_0__TextMessageFormat__["a" /* TextMessageFormat */].RecordSeparator);
            if (separatorIndex === -1) {
                throw new Error("Message is incomplete.");
            }
            // content before separator is handshake response
            // optional content after is additional messages
            var responseLength = separatorIndex + 1;
            messageData = textData.substring(0, responseLength);
            remainingData = (textData.length > responseLength) ? textData.substring(responseLength) : null;
        }
        // At this point we should have just the single handshake message
        var messages = __WEBPACK_IMPORTED_MODULE_0__TextMessageFormat__["a" /* TextMessageFormat */].parse(messageData);
        var response = JSON.parse(messages[0]);
        if (response.type) {
            throw new Error("Expected a handshake response from the server.");
        }
        responseMessage = response;
        // multiple messages could have arrived with handshake
        // return additional data to be parsed as usual, or null if all parsed
        return [remainingData, responseMessage];
    };
    return HandshakeProtocol;
}());

//# sourceMappingURL=HandshakeProtocol.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(395).Buffer))

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 1665 */
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 1666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HubConnectionBuilder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DefaultReconnectPolicy__ = __webpack_require__(1667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HttpConnection__ = __webpack_require__(1668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HubConnection__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ILogger__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__JsonHubProtocol__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Loggers__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Utils__ = __webpack_require__(88);
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};







// tslint:disable:object-literal-sort-keys
var LogLevelNameMapping = {
    trace: __WEBPACK_IMPORTED_MODULE_3__ILogger__["a" /* LogLevel */].Trace,
    debug: __WEBPACK_IMPORTED_MODULE_3__ILogger__["a" /* LogLevel */].Debug,
    info: __WEBPACK_IMPORTED_MODULE_3__ILogger__["a" /* LogLevel */].Information,
    information: __WEBPACK_IMPORTED_MODULE_3__ILogger__["a" /* LogLevel */].Information,
    warn: __WEBPACK_IMPORTED_MODULE_3__ILogger__["a" /* LogLevel */].Warning,
    warning: __WEBPACK_IMPORTED_MODULE_3__ILogger__["a" /* LogLevel */].Warning,
    error: __WEBPACK_IMPORTED_MODULE_3__ILogger__["a" /* LogLevel */].Error,
    critical: __WEBPACK_IMPORTED_MODULE_3__ILogger__["a" /* LogLevel */].Critical,
    none: __WEBPACK_IMPORTED_MODULE_3__ILogger__["a" /* LogLevel */].None,
};
function parseLogLevel(name) {
    // Case-insensitive matching via lower-casing
    // Yes, I know case-folding is a complicated problem in Unicode, but we only support
    // the ASCII strings defined in LogLevelNameMapping anyway, so it's fine -anurse.
    var mapping = LogLevelNameMapping[name.toLowerCase()];
    if (typeof mapping !== "undefined") {
        return mapping;
    }
    else {
        throw new Error("Unknown log level: " + name);
    }
}
/** A builder for configuring {@link @microsoft/signalr.HubConnection} instances. */
var HubConnectionBuilder = /** @class */ (function () {
    function HubConnectionBuilder() {
    }
    HubConnectionBuilder.prototype.configureLogging = function (logging) {
        __WEBPACK_IMPORTED_MODULE_6__Utils__["a" /* Arg */].isRequired(logging, "logging");
        if (isLogger(logging)) {
            this.logger = logging;
        }
        else if (typeof logging === "string") {
            var logLevel = parseLogLevel(logging);
            this.logger = new __WEBPACK_IMPORTED_MODULE_6__Utils__["b" /* ConsoleLogger */](logLevel);
        }
        else {
            this.logger = new __WEBPACK_IMPORTED_MODULE_6__Utils__["b" /* ConsoleLogger */](logging);
        }
        return this;
    };
    HubConnectionBuilder.prototype.withUrl = function (url, transportTypeOrOptions) {
        __WEBPACK_IMPORTED_MODULE_6__Utils__["a" /* Arg */].isRequired(url, "url");
        __WEBPACK_IMPORTED_MODULE_6__Utils__["a" /* Arg */].isNotEmpty(url, "url");
        this.url = url;
        // Flow-typing knows where it's at. Since HttpTransportType is a number and IHttpConnectionOptions is guaranteed
        // to be an object, we know (as does TypeScript) this comparison is all we need to figure out which overload was called.
        if (typeof transportTypeOrOptions === "object") {
            this.httpConnectionOptions = __assign({}, this.httpConnectionOptions, transportTypeOrOptions);
        }
        else {
            this.httpConnectionOptions = __assign({}, this.httpConnectionOptions, { transport: transportTypeOrOptions });
        }
        return this;
    };
    /** Configures the {@link @microsoft/signalr.HubConnection} to use the specified Hub Protocol.
     *
     * @param {IHubProtocol} protocol The {@link @microsoft/signalr.IHubProtocol} implementation to use.
     */
    HubConnectionBuilder.prototype.withHubProtocol = function (protocol) {
        __WEBPACK_IMPORTED_MODULE_6__Utils__["a" /* Arg */].isRequired(protocol, "protocol");
        this.protocol = protocol;
        return this;
    };
    HubConnectionBuilder.prototype.withAutomaticReconnect = function (retryDelaysOrReconnectPolicy) {
        if (this.reconnectPolicy) {
            throw new Error("A reconnectPolicy has already been set.");
        }
        if (!retryDelaysOrReconnectPolicy) {
            this.reconnectPolicy = new __WEBPACK_IMPORTED_MODULE_0__DefaultReconnectPolicy__["a" /* DefaultReconnectPolicy */]();
        }
        else if (Array.isArray(retryDelaysOrReconnectPolicy)) {
            this.reconnectPolicy = new __WEBPACK_IMPORTED_MODULE_0__DefaultReconnectPolicy__["a" /* DefaultReconnectPolicy */](retryDelaysOrReconnectPolicy);
        }
        else {
            this.reconnectPolicy = retryDelaysOrReconnectPolicy;
        }
        return this;
    };
    /** Creates a {@link @microsoft/signalr.HubConnection} from the configuration options specified in this builder.
     *
     * @returns {HubConnection} The configured {@link @microsoft/signalr.HubConnection}.
     */
    HubConnectionBuilder.prototype.build = function () {
        // If httpConnectionOptions has a logger, use it. Otherwise, override it with the one
        // provided to configureLogger
        var httpConnectionOptions = this.httpConnectionOptions || {};
        // If it's 'null', the user **explicitly** asked for null, don't mess with it.
        if (httpConnectionOptions.logger === undefined) {
            // If our logger is undefined or null, that's OK, the HttpConnection constructor will handle it.
            httpConnectionOptions.logger = this.logger;
        }
        // Now create the connection
        if (!this.url) {
            throw new Error("The 'HubConnectionBuilder.withUrl' method must be called before building the connection.");
        }
        var connection = new __WEBPACK_IMPORTED_MODULE_1__HttpConnection__["a" /* HttpConnection */](this.url, httpConnectionOptions);
        return __WEBPACK_IMPORTED_MODULE_2__HubConnection__["a" /* HubConnection */].create(connection, this.logger || __WEBPACK_IMPORTED_MODULE_5__Loggers__["a" /* NullLogger */].instance, this.protocol || new __WEBPACK_IMPORTED_MODULE_4__JsonHubProtocol__["a" /* JsonHubProtocol */](), this.reconnectPolicy);
    };
    return HubConnectionBuilder;
}());

function isLogger(logger) {
    return logger.log !== undefined;
}
//# sourceMappingURL=HubConnectionBuilder.js.map

/***/ }),
/* 1667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DefaultReconnectPolicy; });
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
// 0, 2, 10, 30 second delays before reconnect attempts.
var DEFAULT_RETRY_DELAYS_IN_MILLISECONDS = [0, 2000, 10000, 30000, null];
/** @private */
var DefaultReconnectPolicy = /** @class */ (function () {
    function DefaultReconnectPolicy(retryDelays) {
        this.retryDelays = retryDelays !== undefined ? retryDelays.concat([null]) : DEFAULT_RETRY_DELAYS_IN_MILLISECONDS;
    }
    DefaultReconnectPolicy.prototype.nextRetryDelayInMilliseconds = function (retryContext) {
        return this.retryDelays[retryContext.previousRetryCount];
    };
    return DefaultReconnectPolicy;
}());

//# sourceMappingURL=DefaultReconnectPolicy.js.map

/***/ }),
/* 1668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HttpConnection; });
/* unused harmony export TransportSendQueue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DefaultHttpClient__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ILogger__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ITransport__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LongPollingTransport__ = __webpack_require__(1669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ServerSentEventsTransport__ = __webpack_require__(1671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Utils__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__WebSocketTransport__ = __webpack_require__(1672);
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};







var MAX_REDIRECTS = 100;
/** @private */
var HttpConnection = /** @class */ (function () {
    function HttpConnection(url, options) {
        if (options === void 0) { options = {}; }
        this.stopPromiseResolver = function () { };
        this.features = {};
        this.negotiateVersion = 1;
        __WEBPACK_IMPORTED_MODULE_5__Utils__["a" /* Arg */].isRequired(url, "url");
        this.logger = Object(__WEBPACK_IMPORTED_MODULE_5__Utils__["e" /* createLogger */])(options.logger);
        this.baseUrl = this.resolveUrl(url);
        options = options || {};
        options.logMessageContent = options.logMessageContent === undefined ? false : options.logMessageContent;
        if (typeof options.withCredentials === "boolean" || options.withCredentials === undefined) {
            options.withCredentials = options.withCredentials === undefined ? true : options.withCredentials;
        }
        else {
            throw new Error("withCredentials option was not a 'boolean' or 'undefined' value");
        }
        var webSocketModule = null;
        var eventSourceModule = null;
        if (__WEBPACK_IMPORTED_MODULE_5__Utils__["c" /* Platform */].isNode && "function" !== "undefined") {
            // In order to ignore the dynamic require in webpack builds we need to do this magic
            // @ts-ignore: TS doesn't know about these names
            var requireFunc =  true ? require : require;
            webSocketModule = requireFunc("ws");
            eventSourceModule = requireFunc("eventsource");
        }
        if (!__WEBPACK_IMPORTED_MODULE_5__Utils__["c" /* Platform */].isNode && typeof WebSocket !== "undefined" && !options.WebSocket) {
            options.WebSocket = WebSocket;
        }
        else if (__WEBPACK_IMPORTED_MODULE_5__Utils__["c" /* Platform */].isNode && !options.WebSocket) {
            if (webSocketModule) {
                options.WebSocket = webSocketModule;
            }
        }
        if (!__WEBPACK_IMPORTED_MODULE_5__Utils__["c" /* Platform */].isNode && typeof EventSource !== "undefined" && !options.EventSource) {
            options.EventSource = EventSource;
        }
        else if (__WEBPACK_IMPORTED_MODULE_5__Utils__["c" /* Platform */].isNode && !options.EventSource) {
            if (typeof eventSourceModule !== "undefined") {
                options.EventSource = eventSourceModule;
            }
        }
        this.httpClient = options.httpClient || new __WEBPACK_IMPORTED_MODULE_0__DefaultHttpClient__["a" /* DefaultHttpClient */](this.logger);
        this.connectionState = "Disconnected" /* Disconnected */;
        this.connectionStarted = false;
        this.options = options;
        this.onreceive = null;
        this.onclose = null;
    }
    HttpConnection.prototype.start = function (transferFormat) {
        return __awaiter(this, void 0, void 0, function () {
            var message, message;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        transferFormat = transferFormat || __WEBPACK_IMPORTED_MODULE_2__ITransport__["b" /* TransferFormat */].Binary;
                        __WEBPACK_IMPORTED_MODULE_5__Utils__["a" /* Arg */].isIn(transferFormat, __WEBPACK_IMPORTED_MODULE_2__ITransport__["b" /* TransferFormat */], "transferFormat");
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Debug, "Starting connection with transfer format '" + __WEBPACK_IMPORTED_MODULE_2__ITransport__["b" /* TransferFormat */][transferFormat] + "'.");
                        if (this.connectionState !== "Disconnected" /* Disconnected */) {
                            return [2 /*return*/, Promise.reject(new Error("Cannot start an HttpConnection that is not in the 'Disconnected' state."))];
                        }
                        this.connectionState = "Connecting" /* Connecting */;
                        this.startInternalPromise = this.startInternal(transferFormat);
                        return [4 /*yield*/, this.startInternalPromise];
                    case 1:
                        _a.sent();
                        if (!(this.connectionState === "Disconnecting" /* Disconnecting */)) return [3 /*break*/, 3];
                        message = "Failed to start the HttpConnection before stop() was called.";
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Error, message);
                        // We cannot await stopPromise inside startInternal since stopInternal awaits the startInternalPromise.
                        return [4 /*yield*/, this.stopPromise];
                    case 2:
                        // We cannot await stopPromise inside startInternal since stopInternal awaits the startInternalPromise.
                        _a.sent();
                        return [2 /*return*/, Promise.reject(new Error(message))];
                    case 3:
                        if (this.connectionState !== "Connected" /* Connected */) {
                            message = "HttpConnection.startInternal completed gracefully but didn't enter the connection into the connected state!";
                            this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Error, message);
                            return [2 /*return*/, Promise.reject(new Error(message))];
                        }
                        _a.label = 4;
                    case 4:
                        this.connectionStarted = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    HttpConnection.prototype.send = function (data) {
        if (this.connectionState !== "Connected" /* Connected */) {
            return Promise.reject(new Error("Cannot send data if the connection is not in the 'Connected' State."));
        }
        if (!this.sendQueue) {
            this.sendQueue = new TransportSendQueue(this.transport);
        }
        // Transport will not be null if state is connected
        return this.sendQueue.send(data);
    };
    HttpConnection.prototype.stop = function (error) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.connectionState === "Disconnected" /* Disconnected */) {
                            this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Debug, "Call to HttpConnection.stop(" + error + ") ignored because the connection is already in the disconnected state.");
                            return [2 /*return*/, Promise.resolve()];
                        }
                        if (this.connectionState === "Disconnecting" /* Disconnecting */) {
                            this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Debug, "Call to HttpConnection.stop(" + error + ") ignored because the connection is already in the disconnecting state.");
                            return [2 /*return*/, this.stopPromise];
                        }
                        this.connectionState = "Disconnecting" /* Disconnecting */;
                        this.stopPromise = new Promise(function (resolve) {
                            // Don't complete stop() until stopConnection() completes.
                            _this.stopPromiseResolver = resolve;
                        });
                        // stopInternal should never throw so just observe it.
                        return [4 /*yield*/, this.stopInternal(error)];
                    case 1:
                        // stopInternal should never throw so just observe it.
                        _a.sent();
                        return [4 /*yield*/, this.stopPromise];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    HttpConnection.prototype.stopInternal = function (error) {
        return __awaiter(this, void 0, void 0, function () {
            var e_1, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Set error as soon as possible otherwise there is a race between
                        // the transport closing and providing an error and the error from a close message
                        // We would prefer the close message error.
                        this.stopError = error;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.startInternalPromise];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        return [3 /*break*/, 4];
                    case 4:
                        if (!this.transport) return [3 /*break*/, 9];
                        _a.label = 5;
                    case 5:
                        _a.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, this.transport.stop()];
                    case 6:
                        _a.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        e_2 = _a.sent();
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Error, "HttpConnection.transport.stop() threw error '" + e_2 + "'.");
                        this.stopConnection();
                        return [3 /*break*/, 8];
                    case 8:
                        this.transport = undefined;
                        return [3 /*break*/, 10];
                    case 9:
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Debug, "HttpConnection.transport is undefined in HttpConnection.stop() because start() failed.");
                        _a.label = 10;
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    HttpConnection.prototype.startInternal = function (transferFormat) {
        return __awaiter(this, void 0, void 0, function () {
            var url, negotiateResponse, redirects, _loop_1, this_1, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.baseUrl;
                        this.accessTokenFactory = this.options.accessTokenFactory;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 12, , 13]);
                        if (!this.options.skipNegotiation) return [3 /*break*/, 5];
                        if (!(this.options.transport === __WEBPACK_IMPORTED_MODULE_2__ITransport__["a" /* HttpTransportType */].WebSockets)) return [3 /*break*/, 3];
                        // No need to add a connection ID in this case
                        this.transport = this.constructTransport(__WEBPACK_IMPORTED_MODULE_2__ITransport__["a" /* HttpTransportType */].WebSockets);
                        // We should just call connect directly in this case.
                        // No fallback or negotiate in this case.
                        return [4 /*yield*/, this.startTransport(url, transferFormat)];
                    case 2:
                        // We should just call connect directly in this case.
                        // No fallback or negotiate in this case.
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3: throw new Error("Negotiation can only be skipped when using the WebSocket transport directly.");
                    case 4: return [3 /*break*/, 11];
                    case 5:
                        negotiateResponse = null;
                        redirects = 0;
                        _loop_1 = function () {
                            var accessToken_1;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this_1.getNegotiationResponse(url)];
                                    case 1:
                                        negotiateResponse = _a.sent();
                                        // the user tries to stop the connection when it is being started
                                        if (this_1.connectionState === "Disconnecting" /* Disconnecting */ || this_1.connectionState === "Disconnected" /* Disconnected */) {
                                            throw new Error("The connection was stopped during negotiation.");
                                        }
                                        if (negotiateResponse.error) {
                                            throw new Error(negotiateResponse.error);
                                        }
                                        if (negotiateResponse.ProtocolVersion) {
                                            throw new Error("Detected a connection attempt to an ASP.NET SignalR Server. This client only supports connecting to an ASP.NET Core SignalR Server. See https://aka.ms/signalr-core-differences for details.");
                                        }
                                        if (negotiateResponse.url) {
                                            url = negotiateResponse.url;
                                        }
                                        if (negotiateResponse.accessToken) {
                                            accessToken_1 = negotiateResponse.accessToken;
                                            this_1.accessTokenFactory = function () { return accessToken_1; };
                                        }
                                        redirects++;
                                        return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        _a.label = 6;
                    case 6: return [5 /*yield**/, _loop_1()];
                    case 7:
                        _a.sent();
                        _a.label = 8;
                    case 8:
                        if (negotiateResponse.url && redirects < MAX_REDIRECTS) return [3 /*break*/, 6];
                        _a.label = 9;
                    case 9:
                        if (redirects === MAX_REDIRECTS && negotiateResponse.url) {
                            throw new Error("Negotiate redirection limit exceeded.");
                        }
                        return [4 /*yield*/, this.createTransport(url, this.options.transport, negotiateResponse, transferFormat)];
                    case 10:
                        _a.sent();
                        _a.label = 11;
                    case 11:
                        if (this.transport instanceof __WEBPACK_IMPORTED_MODULE_3__LongPollingTransport__["a" /* LongPollingTransport */]) {
                            this.features.inherentKeepAlive = true;
                        }
                        if (this.connectionState === "Connecting" /* Connecting */) {
                            // Ensure the connection transitions to the connected state prior to completing this.startInternalPromise.
                            // start() will handle the case when stop was called and startInternal exits still in the disconnecting state.
                            this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Debug, "The HttpConnection connected successfully.");
                            this.connectionState = "Connected" /* Connected */;
                        }
                        return [3 /*break*/, 13];
                    case 12:
                        e_3 = _a.sent();
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Error, "Failed to start the connection: " + e_3);
                        this.connectionState = "Disconnected" /* Disconnected */;
                        this.transport = undefined;
                        // if start fails, any active calls to stop assume that start will complete the stop promise
                        this.stopPromiseResolver();
                        return [2 /*return*/, Promise.reject(e_3)];
                    case 13: return [2 /*return*/];
                }
            });
        });
    };
    HttpConnection.prototype.getNegotiationResponse = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var headers, token, _a, name, value, negotiateUrl, response, negotiateResponse, e_4;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        headers = {};
                        if (!this.accessTokenFactory) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.accessTokenFactory()];
                    case 1:
                        token = _b.sent();
                        if (token) {
                            headers["Authorization"] = "Bearer " + token;
                        }
                        _b.label = 2;
                    case 2:
                        _a = Object(__WEBPACK_IMPORTED_MODULE_5__Utils__["g" /* getUserAgentHeader */])(), name = _a[0], value = _a[1];
                        headers[name] = value;
                        negotiateUrl = this.resolveNegotiateUrl(url);
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Debug, "Sending negotiation request: " + negotiateUrl + ".");
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, this.httpClient.post(negotiateUrl, {
                                content: "",
                                headers: __assign({}, headers, this.options.headers),
                                withCredentials: this.options.withCredentials,
                            })];
                    case 4:
                        response = _b.sent();
                        if (response.statusCode !== 200) {
                            return [2 /*return*/, Promise.reject(new Error("Unexpected status code returned from negotiate '" + response.statusCode + "'"))];
                        }
                        negotiateResponse = JSON.parse(response.content);
                        if (!negotiateResponse.negotiateVersion || negotiateResponse.negotiateVersion < 1) {
                            // Negotiate version 0 doesn't use connectionToken
                            // So we set it equal to connectionId so all our logic can use connectionToken without being aware of the negotiate version
                            negotiateResponse.connectionToken = negotiateResponse.connectionId;
                        }
                        return [2 /*return*/, negotiateResponse];
                    case 5:
                        e_4 = _b.sent();
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Error, "Failed to complete negotiation with the server: " + e_4);
                        return [2 /*return*/, Promise.reject(e_4)];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    HttpConnection.prototype.createConnectUrl = function (url, connectionToken) {
        if (!connectionToken) {
            return url;
        }
        return url + (url.indexOf("?") === -1 ? "?" : "&") + ("id=" + connectionToken);
    };
    HttpConnection.prototype.createTransport = function (url, requestedTransport, negotiateResponse, requestedTransferFormat) {
        return __awaiter(this, void 0, void 0, function () {
            var connectUrl, transportExceptions, transports, negotiate, _i, transports_1, endpoint, transportOrError, ex_1, ex_2, message;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        connectUrl = this.createConnectUrl(url, negotiateResponse.connectionToken);
                        if (!this.isITransport(requestedTransport)) return [3 /*break*/, 2];
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Debug, "Connection was provided an instance of ITransport, using that directly.");
                        this.transport = requestedTransport;
                        return [4 /*yield*/, this.startTransport(connectUrl, requestedTransferFormat)];
                    case 1:
                        _a.sent();
                        this.connectionId = negotiateResponse.connectionId;
                        return [2 /*return*/];
                    case 2:
                        transportExceptions = [];
                        transports = negotiateResponse.availableTransports || [];
                        negotiate = negotiateResponse;
                        _i = 0, transports_1 = transports;
                        _a.label = 3;
                    case 3:
                        if (!(_i < transports_1.length)) return [3 /*break*/, 13];
                        endpoint = transports_1[_i];
                        transportOrError = this.resolveTransportOrError(endpoint, requestedTransport, requestedTransferFormat);
                        if (!(transportOrError instanceof Error)) return [3 /*break*/, 4];
                        // Store the error and continue, we don't want to cause a re-negotiate in these cases
                        transportExceptions.push(endpoint.transport + " failed: " + transportOrError);
                        return [3 /*break*/, 12];
                    case 4:
                        if (!this.isITransport(transportOrError)) return [3 /*break*/, 12];
                        this.transport = transportOrError;
                        if (!!negotiate) return [3 /*break*/, 9];
                        _a.label = 5;
                    case 5:
                        _a.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, this.getNegotiationResponse(url)];
                    case 6:
                        negotiate = _a.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        ex_1 = _a.sent();
                        return [2 /*return*/, Promise.reject(ex_1)];
                    case 8:
                        connectUrl = this.createConnectUrl(url, negotiate.connectionToken);
                        _a.label = 9;
                    case 9:
                        _a.trys.push([9, 11, , 12]);
                        return [4 /*yield*/, this.startTransport(connectUrl, requestedTransferFormat)];
                    case 10:
                        _a.sent();
                        this.connectionId = negotiate.connectionId;
                        return [2 /*return*/];
                    case 11:
                        ex_2 = _a.sent();
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Error, "Failed to start the transport '" + endpoint.transport + "': " + ex_2);
                        negotiate = undefined;
                        transportExceptions.push(endpoint.transport + " failed: " + ex_2);
                        if (this.connectionState !== "Connecting" /* Connecting */) {
                            message = "Failed to select transport before stop() was called.";
                            this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Debug, message);
                            return [2 /*return*/, Promise.reject(new Error(message))];
                        }
                        return [3 /*break*/, 12];
                    case 12:
                        _i++;
                        return [3 /*break*/, 3];
                    case 13:
                        if (transportExceptions.length > 0) {
                            return [2 /*return*/, Promise.reject(new Error("Unable to connect to the server with any of the available transports. " + transportExceptions.join(" ")))];
                        }
                        return [2 /*return*/, Promise.reject(new Error("None of the transports supported by the client are supported by the server."))];
                }
            });
        });
    };
    HttpConnection.prototype.constructTransport = function (transport) {
        switch (transport) {
            case __WEBPACK_IMPORTED_MODULE_2__ITransport__["a" /* HttpTransportType */].WebSockets:
                if (!this.options.WebSocket) {
                    throw new Error("'WebSocket' is not supported in your environment.");
                }
                return new __WEBPACK_IMPORTED_MODULE_6__WebSocketTransport__["a" /* WebSocketTransport */](this.httpClient, this.accessTokenFactory, this.logger, this.options.logMessageContent || false, this.options.WebSocket, this.options.headers || {});
            case __WEBPACK_IMPORTED_MODULE_2__ITransport__["a" /* HttpTransportType */].ServerSentEvents:
                if (!this.options.EventSource) {
                    throw new Error("'EventSource' is not supported in your environment.");
                }
                return new __WEBPACK_IMPORTED_MODULE_4__ServerSentEventsTransport__["a" /* ServerSentEventsTransport */](this.httpClient, this.accessTokenFactory, this.logger, this.options.logMessageContent || false, this.options.EventSource, this.options.withCredentials, this.options.headers || {});
            case __WEBPACK_IMPORTED_MODULE_2__ITransport__["a" /* HttpTransportType */].LongPolling:
                return new __WEBPACK_IMPORTED_MODULE_3__LongPollingTransport__["a" /* LongPollingTransport */](this.httpClient, this.accessTokenFactory, this.logger, this.options.logMessageContent || false, this.options.withCredentials, this.options.headers || {});
            default:
                throw new Error("Unknown transport: " + transport + ".");
        }
    };
    HttpConnection.prototype.startTransport = function (url, transferFormat) {
        var _this = this;
        this.transport.onreceive = this.onreceive;
        this.transport.onclose = function (e) { return _this.stopConnection(e); };
        return this.transport.connect(url, transferFormat);
    };
    HttpConnection.prototype.resolveTransportOrError = function (endpoint, requestedTransport, requestedTransferFormat) {
        var transport = __WEBPACK_IMPORTED_MODULE_2__ITransport__["a" /* HttpTransportType */][endpoint.transport];
        if (transport === null || transport === undefined) {
            this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Debug, "Skipping transport '" + endpoint.transport + "' because it is not supported by this client.");
            return new Error("Skipping transport '" + endpoint.transport + "' because it is not supported by this client.");
        }
        else {
            if (transportMatches(requestedTransport, transport)) {
                var transferFormats = endpoint.transferFormats.map(function (s) { return __WEBPACK_IMPORTED_MODULE_2__ITransport__["b" /* TransferFormat */][s]; });
                if (transferFormats.indexOf(requestedTransferFormat) >= 0) {
                    if ((transport === __WEBPACK_IMPORTED_MODULE_2__ITransport__["a" /* HttpTransportType */].WebSockets && !this.options.WebSocket) ||
                        (transport === __WEBPACK_IMPORTED_MODULE_2__ITransport__["a" /* HttpTransportType */].ServerSentEvents && !this.options.EventSource)) {
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Debug, "Skipping transport '" + __WEBPACK_IMPORTED_MODULE_2__ITransport__["a" /* HttpTransportType */][transport] + "' because it is not supported in your environment.'");
                        return new Error("'" + __WEBPACK_IMPORTED_MODULE_2__ITransport__["a" /* HttpTransportType */][transport] + "' is not supported in your environment.");
                    }
                    else {
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Debug, "Selecting transport '" + __WEBPACK_IMPORTED_MODULE_2__ITransport__["a" /* HttpTransportType */][transport] + "'.");
                        try {
                            return this.constructTransport(transport);
                        }
                        catch (ex) {
                            return ex;
                        }
                    }
                }
                else {
                    this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Debug, "Skipping transport '" + __WEBPACK_IMPORTED_MODULE_2__ITransport__["a" /* HttpTransportType */][transport] + "' because it does not support the requested transfer format '" + __WEBPACK_IMPORTED_MODULE_2__ITransport__["b" /* TransferFormat */][requestedTransferFormat] + "'.");
                    return new Error("'" + __WEBPACK_IMPORTED_MODULE_2__ITransport__["a" /* HttpTransportType */][transport] + "' does not support " + __WEBPACK_IMPORTED_MODULE_2__ITransport__["b" /* TransferFormat */][requestedTransferFormat] + ".");
                }
            }
            else {
                this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Debug, "Skipping transport '" + __WEBPACK_IMPORTED_MODULE_2__ITransport__["a" /* HttpTransportType */][transport] + "' because it was disabled by the client.");
                return new Error("'" + __WEBPACK_IMPORTED_MODULE_2__ITransport__["a" /* HttpTransportType */][transport] + "' is disabled by the client.");
            }
        }
    };
    HttpConnection.prototype.isITransport = function (transport) {
        return transport && typeof (transport) === "object" && "connect" in transport;
    };
    HttpConnection.prototype.stopConnection = function (error) {
        var _this = this;
        this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Debug, "HttpConnection.stopConnection(" + error + ") called while in state " + this.connectionState + ".");
        this.transport = undefined;
        // If we have a stopError, it takes precedence over the error from the transport
        error = this.stopError || error;
        this.stopError = undefined;
        if (this.connectionState === "Disconnected" /* Disconnected */) {
            this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Debug, "Call to HttpConnection.stopConnection(" + error + ") was ignored because the connection is already in the disconnected state.");
            return;
        }
        if (this.connectionState === "Connecting" /* Connecting */) {
            this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Warning, "Call to HttpConnection.stopConnection(" + error + ") was ignored because the connection is still in the connecting state.");
            throw new Error("HttpConnection.stopConnection(" + error + ") was called while the connection is still in the connecting state.");
        }
        if (this.connectionState === "Disconnecting" /* Disconnecting */) {
            // A call to stop() induced this call to stopConnection and needs to be completed.
            // Any stop() awaiters will be scheduled to continue after the onclose callback fires.
            this.stopPromiseResolver();
        }
        if (error) {
            this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Error, "Connection disconnected with error '" + error + "'.");
        }
        else {
            this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Information, "Connection disconnected.");
        }
        if (this.sendQueue) {
            this.sendQueue.stop().catch(function (e) {
                _this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Error, "TransportSendQueue.stop() threw error '" + e + "'.");
            });
            this.sendQueue = undefined;
        }
        this.connectionId = undefined;
        this.connectionState = "Disconnected" /* Disconnected */;
        if (this.connectionStarted) {
            this.connectionStarted = false;
            try {
                if (this.onclose) {
                    this.onclose(error);
                }
            }
            catch (e) {
                this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Error, "HttpConnection.onclose(" + error + ") threw error '" + e + "'.");
            }
        }
    };
    HttpConnection.prototype.resolveUrl = function (url) {
        // startsWith is not supported in IE
        if (url.lastIndexOf("https://", 0) === 0 || url.lastIndexOf("http://", 0) === 0) {
            return url;
        }
        if (!__WEBPACK_IMPORTED_MODULE_5__Utils__["c" /* Platform */].isBrowser || !window.document) {
            throw new Error("Cannot resolve '" + url + "'.");
        }
        // Setting the url to the href propery of an anchor tag handles normalization
        // for us. There are 3 main cases.
        // 1. Relative path normalization e.g "b" -> "http://localhost:5000/a/b"
        // 2. Absolute path normalization e.g "/a/b" -> "http://localhost:5000/a/b"
        // 3. Networkpath reference normalization e.g "//localhost:5000/a/b" -> "http://localhost:5000/a/b"
        var aTag = window.document.createElement("a");
        aTag.href = url;
        this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Information, "Normalizing '" + url + "' to '" + aTag.href + "'.");
        return aTag.href;
    };
    HttpConnection.prototype.resolveNegotiateUrl = function (url) {
        var index = url.indexOf("?");
        var negotiateUrl = url.substring(0, index === -1 ? url.length : index);
        if (negotiateUrl[negotiateUrl.length - 1] !== "/") {
            negotiateUrl += "/";
        }
        negotiateUrl += "negotiate";
        negotiateUrl += index === -1 ? "" : url.substring(index);
        if (negotiateUrl.indexOf("negotiateVersion") === -1) {
            negotiateUrl += index === -1 ? "?" : "&";
            negotiateUrl += "negotiateVersion=" + this.negotiateVersion;
        }
        return negotiateUrl;
    };
    return HttpConnection;
}());

function transportMatches(requestedTransport, actualTransport) {
    return !requestedTransport || ((actualTransport & requestedTransport) !== 0);
}
/** @private */
var TransportSendQueue = /** @class */ (function () {
    function TransportSendQueue(transport) {
        this.transport = transport;
        this.buffer = [];
        this.executing = true;
        this.sendBufferedData = new PromiseSource();
        this.transportResult = new PromiseSource();
        this.sendLoopPromise = this.sendLoop();
    }
    TransportSendQueue.prototype.send = function (data) {
        this.bufferData(data);
        if (!this.transportResult) {
            this.transportResult = new PromiseSource();
        }
        return this.transportResult.promise;
    };
    TransportSendQueue.prototype.stop = function () {
        this.executing = false;
        this.sendBufferedData.resolve();
        return this.sendLoopPromise;
    };
    TransportSendQueue.prototype.bufferData = function (data) {
        if (this.buffer.length && typeof (this.buffer[0]) !== typeof (data)) {
            throw new Error("Expected data to be of type " + typeof (this.buffer) + " but was of type " + typeof (data));
        }
        this.buffer.push(data);
        this.sendBufferedData.resolve();
    };
    TransportSendQueue.prototype.sendLoop = function () {
        return __awaiter(this, void 0, void 0, function () {
            var transportResult, data, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (false) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.sendBufferedData.promise];
                    case 1:
                        _a.sent();
                        if (!this.executing) {
                            if (this.transportResult) {
                                this.transportResult.reject("Connection stopped.");
                            }
                            return [3 /*break*/, 6];
                        }
                        this.sendBufferedData = new PromiseSource();
                        transportResult = this.transportResult;
                        this.transportResult = undefined;
                        data = typeof (this.buffer[0]) === "string" ?
                            this.buffer.join("") :
                            TransportSendQueue.concatBuffers(this.buffer);
                        this.buffer.length = 0;
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this.transport.send(data)];
                    case 3:
                        _a.sent();
                        transportResult.resolve();
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        transportResult.reject(error_1);
                        return [3 /*break*/, 5];
                    case 5: return [3 /*break*/, 0];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    TransportSendQueue.concatBuffers = function (arrayBuffers) {
        var totalLength = arrayBuffers.map(function (b) { return b.byteLength; }).reduce(function (a, b) { return a + b; });
        var result = new Uint8Array(totalLength);
        var offset = 0;
        for (var _i = 0, arrayBuffers_1 = arrayBuffers; _i < arrayBuffers_1.length; _i++) {
            var item = arrayBuffers_1[_i];
            result.set(new Uint8Array(item), offset);
            offset += item.byteLength;
        }
        return result.buffer;
    };
    return TransportSendQueue;
}());

var PromiseSource = /** @class */ (function () {
    function PromiseSource() {
        var _this = this;
        this.promise = new Promise(function (resolve, reject) {
            var _a;
            return _a = [resolve, reject], _this.resolver = _a[0], _this.rejecter = _a[1], _a;
        });
    }
    PromiseSource.prototype.resolve = function () {
        this.resolver();
    };
    PromiseSource.prototype.reject = function (reason) {
        this.rejecter(reason);
    };
    return PromiseSource;
}());
//# sourceMappingURL=HttpConnection.js.map

/***/ }),
/* 1669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LongPollingTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AbortController__ = __webpack_require__(1670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Errors__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ILogger__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ITransport__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utils__ = __webpack_require__(88);
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};





// Not exported from 'index', this type is internal.
/** @private */
var LongPollingTransport = /** @class */ (function () {
    function LongPollingTransport(httpClient, accessTokenFactory, logger, logMessageContent, withCredentials, headers) {
        this.httpClient = httpClient;
        this.accessTokenFactory = accessTokenFactory;
        this.logger = logger;
        this.pollAbort = new __WEBPACK_IMPORTED_MODULE_0__AbortController__["a" /* AbortController */]();
        this.logMessageContent = logMessageContent;
        this.withCredentials = withCredentials;
        this.headers = headers;
        this.running = false;
        this.onreceive = null;
        this.onclose = null;
    }
    Object.defineProperty(LongPollingTransport.prototype, "pollAborted", {
        // This is an internal type, not exported from 'index' so this is really just internal.
        get: function () {
            return this.pollAbort.aborted;
        },
        enumerable: true,
        configurable: true
    });
    LongPollingTransport.prototype.connect = function (url, transferFormat) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, name, value, headers, pollOptions, token, pollUrl, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        __WEBPACK_IMPORTED_MODULE_4__Utils__["a" /* Arg */].isRequired(url, "url");
                        __WEBPACK_IMPORTED_MODULE_4__Utils__["a" /* Arg */].isRequired(transferFormat, "transferFormat");
                        __WEBPACK_IMPORTED_MODULE_4__Utils__["a" /* Arg */].isIn(transferFormat, __WEBPACK_IMPORTED_MODULE_3__ITransport__["b" /* TransferFormat */], "transferFormat");
                        this.url = url;
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Trace, "(LongPolling transport) Connecting.");
                        // Allow binary format on Node and Browsers that support binary content (indicated by the presence of responseType property)
                        if (transferFormat === __WEBPACK_IMPORTED_MODULE_3__ITransport__["b" /* TransferFormat */].Binary &&
                            (typeof XMLHttpRequest !== "undefined" && typeof new XMLHttpRequest().responseType !== "string")) {
                            throw new Error("Binary protocols over XmlHttpRequest not implementing advanced features are not supported.");
                        }
                        _b = Object(__WEBPACK_IMPORTED_MODULE_4__Utils__["g" /* getUserAgentHeader */])(), name = _b[0], value = _b[1];
                        headers = __assign((_a = {}, _a[name] = value, _a), this.headers);
                        pollOptions = {
                            abortSignal: this.pollAbort.signal,
                            headers: headers,
                            timeout: 100000,
                            withCredentials: this.withCredentials,
                        };
                        if (transferFormat === __WEBPACK_IMPORTED_MODULE_3__ITransport__["b" /* TransferFormat */].Binary) {
                            pollOptions.responseType = "arraybuffer";
                        }
                        return [4 /*yield*/, this.getAccessToken()];
                    case 1:
                        token = _c.sent();
                        this.updateHeaderToken(pollOptions, token);
                        pollUrl = url + "&_=" + Date.now();
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Trace, "(LongPolling transport) polling: " + pollUrl + ".");
                        return [4 /*yield*/, this.httpClient.get(pollUrl, pollOptions)];
                    case 2:
                        response = _c.sent();
                        if (response.statusCode !== 200) {
                            this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Error, "(LongPolling transport) Unexpected response code: " + response.statusCode + ".");
                            // Mark running as false so that the poll immediately ends and runs the close logic
                            this.closeError = new __WEBPACK_IMPORTED_MODULE_1__Errors__["b" /* HttpError */](response.statusText || "", response.statusCode);
                            this.running = false;
                        }
                        else {
                            this.running = true;
                        }
                        this.receiving = this.poll(this.url, pollOptions);
                        return [2 /*return*/];
                }
            });
        });
    };
    LongPollingTransport.prototype.getAccessToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.accessTokenFactory) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.accessTokenFactory()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [2 /*return*/, null];
                }
            });
        });
    };
    LongPollingTransport.prototype.updateHeaderToken = function (request, token) {
        if (!request.headers) {
            request.headers = {};
        }
        if (token) {
            // tslint:disable-next-line:no-string-literal
            request.headers["Authorization"] = "Bearer " + token;
            return;
        }
        // tslint:disable-next-line:no-string-literal
        if (request.headers["Authorization"]) {
            // tslint:disable-next-line:no-string-literal
            delete request.headers["Authorization"];
        }
    };
    LongPollingTransport.prototype.poll = function (url, pollOptions) {
        return __awaiter(this, void 0, void 0, function () {
            var token, pollUrl, response, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, , 8, 9]);
                        _a.label = 1;
                    case 1:
                        if (!this.running) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.getAccessToken()];
                    case 2:
                        token = _a.sent();
                        this.updateHeaderToken(pollOptions, token);
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 5, , 6]);
                        pollUrl = url + "&_=" + Date.now();
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Trace, "(LongPolling transport) polling: " + pollUrl + ".");
                        return [4 /*yield*/, this.httpClient.get(pollUrl, pollOptions)];
                    case 4:
                        response = _a.sent();
                        if (response.statusCode === 204) {
                            this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Information, "(LongPolling transport) Poll terminated by server.");
                            this.running = false;
                        }
                        else if (response.statusCode !== 200) {
                            this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Error, "(LongPolling transport) Unexpected response code: " + response.statusCode + ".");
                            // Unexpected status code
                            this.closeError = new __WEBPACK_IMPORTED_MODULE_1__Errors__["b" /* HttpError */](response.statusText || "", response.statusCode);
                            this.running = false;
                        }
                        else {
                            // Process the response
                            if (response.content) {
                                this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Trace, "(LongPolling transport) data received. " + Object(__WEBPACK_IMPORTED_MODULE_4__Utils__["f" /* getDataDetail */])(response.content, this.logMessageContent) + ".");
                                if (this.onreceive) {
                                    this.onreceive(response.content);
                                }
                            }
                            else {
                                // This is another way timeout manifest.
                                this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Trace, "(LongPolling transport) Poll timed out, reissuing.");
                            }
                        }
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        if (!this.running) {
                            // Log but disregard errors that occur after stopping
                            this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Trace, "(LongPolling transport) Poll errored after shutdown: " + e_1.message);
                        }
                        else {
                            if (e_1 instanceof __WEBPACK_IMPORTED_MODULE_1__Errors__["c" /* TimeoutError */]) {
                                // Ignore timeouts and reissue the poll.
                                this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Trace, "(LongPolling transport) Poll timed out, reissuing.");
                            }
                            else {
                                // Close the connection with the error as the result.
                                this.closeError = e_1;
                                this.running = false;
                            }
                        }
                        return [3 /*break*/, 6];
                    case 6: return [3 /*break*/, 1];
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Trace, "(LongPolling transport) Polling complete.");
                        // We will reach here with pollAborted==false when the server returned a response causing the transport to stop.
                        // If pollAborted==true then client initiated the stop and the stop method will raise the close event after DELETE is sent.
                        if (!this.pollAborted) {
                            this.raiseOnClose();
                        }
                        return [7 /*endfinally*/];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    LongPollingTransport.prototype.send = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.running) {
                    return [2 /*return*/, Promise.reject(new Error("Cannot send until the transport is connected"))];
                }
                return [2 /*return*/, Object(__WEBPACK_IMPORTED_MODULE_4__Utils__["i" /* sendMessage */])(this.logger, "LongPolling", this.httpClient, this.url, this.accessTokenFactory, data, this.logMessageContent, this.withCredentials, this.headers)];
            });
        });
    };
    LongPollingTransport.prototype.stop = function () {
        return __awaiter(this, void 0, void 0, function () {
            var headers, _a, name_1, value, deleteOptions, token;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Trace, "(LongPolling transport) Stopping polling.");
                        // Tell receiving loop to stop, abort any current request, and then wait for it to finish
                        this.running = false;
                        this.pollAbort.abort();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, , 5, 6]);
                        return [4 /*yield*/, this.receiving];
                    case 2:
                        _b.sent();
                        // Send DELETE to clean up long polling on the server
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Trace, "(LongPolling transport) sending DELETE request to " + this.url + ".");
                        headers = {};
                        _a = Object(__WEBPACK_IMPORTED_MODULE_4__Utils__["g" /* getUserAgentHeader */])(), name_1 = _a[0], value = _a[1];
                        headers[name_1] = value;
                        deleteOptions = {
                            headers: __assign({}, headers, this.headers),
                            withCredentials: this.withCredentials,
                        };
                        return [4 /*yield*/, this.getAccessToken()];
                    case 3:
                        token = _b.sent();
                        this.updateHeaderToken(deleteOptions, token);
                        return [4 /*yield*/, this.httpClient.delete(this.url, deleteOptions)];
                    case 4:
                        _b.sent();
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Trace, "(LongPolling transport) DELETE request sent.");
                        return [3 /*break*/, 6];
                    case 5:
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Trace, "(LongPolling transport) Stop finished.");
                        // Raise close event here instead of in polling
                        // It needs to happen after the DELETE request is sent
                        this.raiseOnClose();
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    LongPollingTransport.prototype.raiseOnClose = function () {
        if (this.onclose) {
            var logMessage = "(LongPolling transport) Firing onclose event.";
            if (this.closeError) {
                logMessage += " Error: " + this.closeError;
            }
            this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Trace, logMessage);
            this.onclose(this.closeError);
        }
    };
    return LongPollingTransport;
}());

//# sourceMappingURL=LongPollingTransport.js.map

/***/ }),
/* 1670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AbortController; });
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
// Rough polyfill of https://developer.mozilla.org/en-US/docs/Web/API/AbortController
// We don't actually ever use the API being polyfilled, we always use the polyfill because
// it's a very new API right now.
// Not exported from index.
/** @private */
var AbortController = /** @class */ (function () {
    function AbortController() {
        this.isAborted = false;
        this.onabort = null;
    }
    AbortController.prototype.abort = function () {
        if (!this.isAborted) {
            this.isAborted = true;
            if (this.onabort) {
                this.onabort();
            }
        }
    };
    Object.defineProperty(AbortController.prototype, "signal", {
        get: function () {
            return this;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbortController.prototype, "aborted", {
        get: function () {
            return this.isAborted;
        },
        enumerable: true,
        configurable: true
    });
    return AbortController;
}());

//# sourceMappingURL=AbortController.js.map

/***/ }),
/* 1671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ServerSentEventsTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ILogger__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ITransport__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utils__ = __webpack_require__(88);
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



/** @private */
var ServerSentEventsTransport = /** @class */ (function () {
    function ServerSentEventsTransport(httpClient, accessTokenFactory, logger, logMessageContent, eventSourceConstructor, withCredentials, headers) {
        this.httpClient = httpClient;
        this.accessTokenFactory = accessTokenFactory;
        this.logger = logger;
        this.logMessageContent = logMessageContent;
        this.withCredentials = withCredentials;
        this.eventSourceConstructor = eventSourceConstructor;
        this.headers = headers;
        this.onreceive = null;
        this.onclose = null;
    }
    ServerSentEventsTransport.prototype.connect = function (url, transferFormat) {
        return __awaiter(this, void 0, void 0, function () {
            var token;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        __WEBPACK_IMPORTED_MODULE_2__Utils__["a" /* Arg */].isRequired(url, "url");
                        __WEBPACK_IMPORTED_MODULE_2__Utils__["a" /* Arg */].isRequired(transferFormat, "transferFormat");
                        __WEBPACK_IMPORTED_MODULE_2__Utils__["a" /* Arg */].isIn(transferFormat, __WEBPACK_IMPORTED_MODULE_1__ITransport__["b" /* TransferFormat */], "transferFormat");
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_0__ILogger__["a" /* LogLevel */].Trace, "(SSE transport) Connecting.");
                        // set url before accessTokenFactory because this.url is only for send and we set the auth header instead of the query string for send
                        this.url = url;
                        if (!this.accessTokenFactory) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.accessTokenFactory()];
                    case 1:
                        token = _a.sent();
                        if (token) {
                            url += (url.indexOf("?") < 0 ? "?" : "&") + ("access_token=" + encodeURIComponent(token));
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/, new Promise(function (resolve, reject) {
                            var opened = false;
                            if (transferFormat !== __WEBPACK_IMPORTED_MODULE_1__ITransport__["b" /* TransferFormat */].Text) {
                                reject(new Error("The Server-Sent Events transport only supports the 'Text' transfer format"));
                                return;
                            }
                            var eventSource;
                            if (__WEBPACK_IMPORTED_MODULE_2__Utils__["c" /* Platform */].isBrowser || __WEBPACK_IMPORTED_MODULE_2__Utils__["c" /* Platform */].isWebWorker) {
                                eventSource = new _this.eventSourceConstructor(url, { withCredentials: _this.withCredentials });
                            }
                            else {
                                // Non-browser passes cookies via the dictionary
                                var cookies = _this.httpClient.getCookieString(url);
                                var headers = {};
                                headers.Cookie = cookies;
                                var _a = Object(__WEBPACK_IMPORTED_MODULE_2__Utils__["g" /* getUserAgentHeader */])(), name_1 = _a[0], value = _a[1];
                                headers[name_1] = value;
                                eventSource = new _this.eventSourceConstructor(url, { withCredentials: _this.withCredentials, headers: __assign({}, headers, _this.headers) });
                            }
                            try {
                                eventSource.onmessage = function (e) {
                                    if (_this.onreceive) {
                                        try {
                                            _this.logger.log(__WEBPACK_IMPORTED_MODULE_0__ILogger__["a" /* LogLevel */].Trace, "(SSE transport) data received. " + Object(__WEBPACK_IMPORTED_MODULE_2__Utils__["f" /* getDataDetail */])(e.data, _this.logMessageContent) + ".");
                                            _this.onreceive(e.data);
                                        }
                                        catch (error) {
                                            _this.close(error);
                                            return;
                                        }
                                    }
                                };
                                eventSource.onerror = function (e) {
                                    var error = new Error(e.data || "Error occurred");
                                    if (opened) {
                                        _this.close(error);
                                    }
                                    else {
                                        reject(error);
                                    }
                                };
                                eventSource.onopen = function () {
                                    _this.logger.log(__WEBPACK_IMPORTED_MODULE_0__ILogger__["a" /* LogLevel */].Information, "SSE connected to " + _this.url);
                                    _this.eventSource = eventSource;
                                    opened = true;
                                    resolve();
                                };
                            }
                            catch (e) {
                                reject(e);
                                return;
                            }
                        })];
                }
            });
        });
    };
    ServerSentEventsTransport.prototype.send = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.eventSource) {
                    return [2 /*return*/, Promise.reject(new Error("Cannot send until the transport is connected"))];
                }
                return [2 /*return*/, Object(__WEBPACK_IMPORTED_MODULE_2__Utils__["i" /* sendMessage */])(this.logger, "SSE", this.httpClient, this.url, this.accessTokenFactory, data, this.logMessageContent, this.withCredentials, this.headers)];
            });
        });
    };
    ServerSentEventsTransport.prototype.stop = function () {
        this.close();
        return Promise.resolve();
    };
    ServerSentEventsTransport.prototype.close = function (e) {
        if (this.eventSource) {
            this.eventSource.close();
            this.eventSource = undefined;
            if (this.onclose) {
                this.onclose(e);
            }
        }
    };
    return ServerSentEventsTransport;
}());

//# sourceMappingURL=ServerSentEventsTransport.js.map

/***/ }),
/* 1672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WebSocketTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ILogger__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ITransport__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utils__ = __webpack_require__(88);
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



/** @private */
var WebSocketTransport = /** @class */ (function () {
    function WebSocketTransport(httpClient, accessTokenFactory, logger, logMessageContent, webSocketConstructor, headers) {
        this.logger = logger;
        this.accessTokenFactory = accessTokenFactory;
        this.logMessageContent = logMessageContent;
        this.webSocketConstructor = webSocketConstructor;
        this.httpClient = httpClient;
        this.onreceive = null;
        this.onclose = null;
        this.headers = headers;
    }
    WebSocketTransport.prototype.connect = function (url, transferFormat) {
        return __awaiter(this, void 0, void 0, function () {
            var token;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        __WEBPACK_IMPORTED_MODULE_2__Utils__["a" /* Arg */].isRequired(url, "url");
                        __WEBPACK_IMPORTED_MODULE_2__Utils__["a" /* Arg */].isRequired(transferFormat, "transferFormat");
                        __WEBPACK_IMPORTED_MODULE_2__Utils__["a" /* Arg */].isIn(transferFormat, __WEBPACK_IMPORTED_MODULE_1__ITransport__["b" /* TransferFormat */], "transferFormat");
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_0__ILogger__["a" /* LogLevel */].Trace, "(WebSockets transport) Connecting.");
                        if (!this.accessTokenFactory) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.accessTokenFactory()];
                    case 1:
                        token = _a.sent();
                        if (token) {
                            url += (url.indexOf("?") < 0 ? "?" : "&") + ("access_token=" + encodeURIComponent(token));
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/, new Promise(function (resolve, reject) {
                            url = url.replace(/^http/, "ws");
                            var webSocket;
                            var cookies = _this.httpClient.getCookieString(url);
                            var opened = false;
                            if (__WEBPACK_IMPORTED_MODULE_2__Utils__["c" /* Platform */].isNode) {
                                var headers = {};
                                var _a = Object(__WEBPACK_IMPORTED_MODULE_2__Utils__["g" /* getUserAgentHeader */])(), name_1 = _a[0], value = _a[1];
                                headers[name_1] = value;
                                if (cookies) {
                                    headers["Cookie"] = "" + cookies;
                                }
                                // Only pass headers when in non-browser environments
                                webSocket = new _this.webSocketConstructor(url, undefined, {
                                    headers: __assign({}, headers, _this.headers),
                                });
                            }
                            if (!webSocket) {
                                // Chrome is not happy with passing 'undefined' as protocol
                                webSocket = new _this.webSocketConstructor(url);
                            }
                            if (transferFormat === __WEBPACK_IMPORTED_MODULE_1__ITransport__["b" /* TransferFormat */].Binary) {
                                webSocket.binaryType = "arraybuffer";
                            }
                            // tslint:disable-next-line:variable-name
                            webSocket.onopen = function (_event) {
                                _this.logger.log(__WEBPACK_IMPORTED_MODULE_0__ILogger__["a" /* LogLevel */].Information, "WebSocket connected to " + url + ".");
                                _this.webSocket = webSocket;
                                opened = true;
                                resolve();
                            };
                            webSocket.onerror = function (event) {
                                var error = null;
                                // ErrorEvent is a browser only type we need to check if the type exists before using it
                                if (typeof ErrorEvent !== "undefined" && event instanceof ErrorEvent) {
                                    error = event.error;
                                }
                                else {
                                    error = new Error("There was an error with the transport.");
                                }
                                reject(error);
                            };
                            webSocket.onmessage = function (message) {
                                _this.logger.log(__WEBPACK_IMPORTED_MODULE_0__ILogger__["a" /* LogLevel */].Trace, "(WebSockets transport) data received. " + Object(__WEBPACK_IMPORTED_MODULE_2__Utils__["f" /* getDataDetail */])(message.data, _this.logMessageContent) + ".");
                                if (_this.onreceive) {
                                    try {
                                        _this.onreceive(message.data);
                                    }
                                    catch (error) {
                                        _this.close(error);
                                        return;
                                    }
                                }
                            };
                            webSocket.onclose = function (event) {
                                // Don't call close handler if connection was never established
                                // We'll reject the connect call instead
                                if (opened) {
                                    _this.close(event);
                                }
                                else {
                                    var error = null;
                                    // ErrorEvent is a browser only type we need to check if the type exists before using it
                                    if (typeof ErrorEvent !== "undefined" && event instanceof ErrorEvent) {
                                        error = event.error;
                                    }
                                    else {
                                        error = new Error("There was an error with the transport.");
                                    }
                                    reject(error);
                                }
                            };
                        })];
                }
            });
        });
    };
    WebSocketTransport.prototype.send = function (data) {
        if (this.webSocket && this.webSocket.readyState === this.webSocketConstructor.OPEN) {
            this.logger.log(__WEBPACK_IMPORTED_MODULE_0__ILogger__["a" /* LogLevel */].Trace, "(WebSockets transport) sending data. " + Object(__WEBPACK_IMPORTED_MODULE_2__Utils__["f" /* getDataDetail */])(data, this.logMessageContent) + ".");
            this.webSocket.send(data);
            return Promise.resolve();
        }
        return Promise.reject("WebSocket is not in the OPEN state");
    };
    WebSocketTransport.prototype.stop = function () {
        if (this.webSocket) {
            // Manually invoke onclose callback inline so we know the HttpConnection was closed properly before returning
            // This also solves an issue where websocket.onclose could take 18+ seconds to trigger during network disconnects
            this.close(undefined);
        }
        return Promise.resolve();
    };
    WebSocketTransport.prototype.close = function (event) {
        // webSocket will be null if the transport did not start successfully
        if (this.webSocket) {
            // Clear websocket handlers because we are considering the socket closed now
            this.webSocket.onclose = function () { };
            this.webSocket.onmessage = function () { };
            this.webSocket.onerror = function () { };
            this.webSocket.close();
            this.webSocket = undefined;
        }
        this.logger.log(__WEBPACK_IMPORTED_MODULE_0__ILogger__["a" /* LogLevel */].Trace, "(WebSockets transport) socket closed.");
        if (this.onclose) {
            if (this.isCloseEvent(event) && (event.wasClean === false || event.code !== 1000)) {
                this.onclose(new Error("WebSocket closed with status code: " + event.code + " (" + event.reason + ")."));
            }
            else if (event instanceof Error) {
                this.onclose(event);
            }
            else {
                this.onclose();
            }
        }
    };
    WebSocketTransport.prototype.isCloseEvent = function (event) {
        return event && typeof event.wasClean === "boolean" && typeof event.code === "number";
    };
    return WebSocketTransport;
}());

//# sourceMappingURL=WebSocketTransport.js.map

/***/ }),
/* 1673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SaleUiStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PromptStore__ = __webpack_require__(1674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LoadingScreenStore__ = __webpack_require__(1675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_request__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var SaleUiStore=(_class=function(){_createClass(SaleUiStore,[{key:'showUpgrade',get:function get(){var _root=this.root,round=_root.round,offers=_root.offers;var submittedOffers=!!offers.viewModel&&!!offers.viewModel.offers&&offers.viewModel.offers.filter(function(a){return a.status==='confirmed';}).length;if(round.definition&&round.definition.type==='simple_offer'&&submittedOffers>=2){return true;}return false;}},{key:'guideNext',get:function get(){var _root2=this.root,saleEdit=_root2.saleEdit,round=_root2.round,offers=_root2.offers,isComplete=_root2.isComplete,status=_root2.status;var hasOffers=!!offers.viewModel&&!!offers.viewModel.offers&&offers.viewModel.offers.length>0;var hasSubmittedOffers=!!offers.viewModel&&!!offers.viewModel.offers&&offers.viewModel.offers.filter(function(a){return a.status==='confirmed';}).length>0;if(round.definition&&round.definition.type==='simple_offer'&&status==='started'&&hasOffers){if(hasSubmittedOffers){return'saleSimpleWizard';}return null;}if(round.definition&&round.definition.status==='closed'||hasOffers){if(round.definition&&round.definition.status==='closed'&&status==='started'){return'saleWizard';}return null;}if(saleEdit.offerData&&Object.keys(saleEdit.offerData).length<4||!(round.isStarted||isComplete)){return'saleEdit';}if(round.definition&&round.definition.status==='notStarted'&&round.definition.canStart)return'roundStart';if(round.definition&&round.definition.status==='started')return'roundOpen';if(!hasOffers){return'registration';}return null;}}]);function SaleUiStore(_ref){var _this=this;var root=_ref.root;_classCallCheck(this,SaleUiStore);_initDefineProp(this,'currentPanel',_descriptor,this);this.manage=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */])(function(){_this.currentPanel='saleManage';});this.notifications=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */])(function(){_this.currentPanel='saleNotifications';});this.messaging=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */])(function(){_this.currentPanel='saleMessaging';});this.showSalePreview=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */])(function(){_this.currentPanel='salePreview';});this.openOverview=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */])(_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(){var res;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_4__services_request__["e" /* post */])('/api/v1/sign',{saleId:_this.root.saleId,template:'/api/v1/offers/{saleId}/overview?contenttype=pdf&locale='+_this.root.user.claims.locale},_this.root.user.accessToken);case 2:res=_context.sent;window.open(res.url);case 4:case'end':return _context.stop();}}},_callee,_this);})));this.showPreviewPdf=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */])(function(){window.open('/api/v1/sales/'+_this.root.saleId+'/preview?contenttype=pdf&locale='+_this.root.user.claims.locale);});this.showSaleWizard=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */])(function(action){window.location.href='/dashboard/'+_this.root.saleId+'/wizard?'+(action?'action='+action:'');});_initDefineProp(this,'auctionFinals',_descriptor2,this);this.root=root;this.prompt=new __WEBPACK_IMPORTED_MODULE_2__PromptStore__["a" /* default */]();this.loading=new __WEBPACK_IMPORTED_MODULE_3__LoadingScreenStore__["a" /* default */]();}_createClass(SaleUiStore,[{key:'editSale',value:function editSale(){this.currentPanel='saleEdit';}},{key:'whitelisting',value:function whitelisting(){this.currentPanel='whitelisting';}},{key:'inviteSeller',value:function inviteSeller(){this.currentPanel='inviteSeller';}},{key:'inviteBuyerAgent',value:function inviteBuyerAgent(){this.currentPanel='inviteBuyerAgent';}},{key:'startRound',value:function startRound(){this.currentPanel='roundStart';}},{key:'registerUser',value:function registerUser(){this.currentPanel='registration';}},{key:'bulkRegistrationCsv',value:function bulkRegistrationCsv(){this.currentPanel='bulkRegistrationCsv';}},{key:'bulkRegistrationOnOffice',value:function bulkRegistrationOnOffice(){this.currentPanel='bulkRegistrationOnOffice';}},{key:'bulkRegistrationPropUp',value:function bulkRegistrationPropUp(){this.currentPanel='bulkRegistrationPropUp';}},{key:'bulkRegistrationPropstack',value:function bulkRegistrationPropstack(){this.currentPanel='bulkRegistrationPropstack';}},{key:'bulkRegistrationCrm',value:function bulkRegistrationCrm(){this.currentPanel='bulkRegistrationCrm';}},{key:'registerOnBehalf',value:function registerOnBehalf(){this.currentPanel='registerOnBehalf';}},{key:'editOffer',value:function editOffer(){this.currentPanel='editOffer';}},{key:'refuseOffer',value:function refuseOffer(){this.currentPanel='refuse';}},{key:'approveRegistration',value:function approveRegistration(){this.currentPanel='registrationApproval';}},{key:'offerNotifications',value:function offerNotifications(){this.currentPanel='offerNotifications';}},{key:'closePanel',value:function closePanel(){this.currentPanel='none';}},{key:'updateContact',value:function updateContact(){this.currentPanel='updateContact';}},{key:'showOfferPreview',value:function showOfferPreview(){this.currentPanel='offerPreview';}},{key:'showBiddingHistory',value:function showBiddingHistory(){this.currentPanel='biddingHistory';}},{key:'printOffer',value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(){var res;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_4__services_request__["e" /* post */])('/api/v1/sign',{saleId:this.root.saleId,offerId:this.root.offers.selectedOffer.buyerId,template:'/api/v1/offers/{saleId}/{offerId}/preview?contenttype=pdf&locale='+this.root.user.claims.locale},this.root.user.accessToken);case 2:res=_context2.sent;window.open(res.url);case 4:case'end':return _context2.stop();}}},_callee2,this);}));function printOffer(){return _ref3.apply(this,arguments);}return printOffer;}()}]);return SaleUiStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'currentPanel',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return'';}}),_applyDecoratedDescriptor(_class.prototype,'showUpgrade',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'showUpgrade'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'guideNext',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'guideNext'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'editSale',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'editSale'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'whitelisting',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'whitelisting'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'inviteSeller',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'inviteSeller'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'inviteBuyerAgent',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'inviteBuyerAgent'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'startRound',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'startRound'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'registerUser',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'registerUser'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'bulkRegistrationCsv',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'bulkRegistrationCsv'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'bulkRegistrationOnOffice',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'bulkRegistrationOnOffice'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'bulkRegistrationPropUp',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'bulkRegistrationPropUp'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'bulkRegistrationPropstack',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'bulkRegistrationPropstack'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'bulkRegistrationCrm',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'bulkRegistrationCrm'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'registerOnBehalf',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'registerOnBehalf'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'editOffer',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'editOffer'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'refuseOffer',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'refuseOffer'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'approveRegistration',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'approveRegistration'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'offerNotifications',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'offerNotifications'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'closePanel',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'closePanel'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateContact',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'updateContact'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'showOfferPreview',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'showOfferPreview'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'showBiddingHistory',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'showBiddingHistory'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'printOffer',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'printOffer'),_class.prototype),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'auctionFinals',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this2=this;return Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */])(function(){_this2.currentPanel='auctionFinals';});}})),_class);

/***/ }),
/* 1674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PromptStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5;function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var PromptStore=(_class=function(){_createClass(PromptStore,[{key:'openRound',get:function get(){return this.content==='openRound';}},{key:'block',get:function get(){return this.content==='block';}},{key:'upload',get:function get(){return this.content==='upload';}}]);function PromptStore(){var _this=this;_classCallCheck(this,PromptStore);_initDefineProp(this,'title',_descriptor,this);_initDefineProp(this,'message',_descriptor2,this);_initDefineProp(this,'opened',_descriptor3,this);_initDefineProp(this,'action',_descriptor4,this);_initDefineProp(this,'content',_descriptor5,this);this.onSubmit=function(data){return _this.submit(data);};this.onClose=function(){return _this.close();};}_createClass(PromptStore,[{key:'open',value:function open(_ref){var title=_ref.title,message=_ref.message,action=_ref.action,content=_ref.content;this.title=title;this.message=message;this.action=action;this.opened=true;this.content=content;}},{key:'close',value:function close(){this.opened=false;this.title='';this.message='';this.action=undefined;this.content='';}},{key:'submit',value:function submit(data){if(this.action){this.action(data);}this.close();}}]);return PromptStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'title',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'message',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'opened',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'action',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return undefined;}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'content',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return'';}}),_applyDecoratedDescriptor(_class.prototype,'openRound',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'openRound'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'block',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'block'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'upload',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'upload'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'open',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'open'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'close',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'close'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'submit',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'submit'),_class.prototype)),_class);

/***/ }),
/* 1675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReqStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var ReqStore=(_class=function(){function ReqStore(){_classCallCheck(this,ReqStore);_initDefineProp(this,'processing',_descriptor,this);_initDefineProp(this,'penddingActions',_descriptor2,this);var store=this;Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["k" /* reaction */])(function(){return store.hasPenddingActions;},function(){if(store.hasPenddingActions){store.penddingActions.shift();}},{fireImmediately:false,delay:10000});}_createClass(ReqStore,[{key:'start',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(asyncAction){var _this=this;var response;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;this.processing=true;_context.next=4;return asyncAction();case 4:response=_context.sent;Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["l" /* runInAction */])(function(){_this.process(response);});case 6:_context.prev=6;Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["l" /* runInAction */])(function(){_this.processing=false;});return _context.finish(6);case 9:case'end':return _context.stop();}}},_callee,this,[[0,,6,9]]);}));function start(_x){return _ref.apply(this,arguments);}return start;}()},{key:'process',value:function process(response){if(!response||!response.result||!response.result.successful){return;}var command=response.command;if(!!command&&!!command.correlationId){this.penddingActions.push(command.correlationId);}}},{key:'done',value:function done(correlationId){this.penddingActions.remove(correlationId);}},{key:'clear',value:function clear(){this.penddingActions.clear();}},{key:'hasPenddingActions',get:function get(){return this.processing||this.penddingActions.length>0;}}]);return ReqStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'processing',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'penddingActions',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}}),_applyDecoratedDescriptor(_class.prototype,'hasPenddingActions',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'hasPenddingActions'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'start',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'start'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'process',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'process'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'done',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'done'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'clear',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'clear'),_class.prototype)),_class);

/***/ }),
/* 1676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SaleEditStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_request__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_lodash__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_moment_timezone__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_cloudinary__ = __webpack_require__(665);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7;function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var SaleEditStore=(_class=function(){function SaleEditStore(_ref){var root=_ref.root;_classCallCheck(this,SaleEditStore);_initDefineProp(this,'currencyCode',_descriptor,this);_initDefineProp(this,'locale',_descriptor2,this);_initDefineProp(this,'offerData',_descriptor3,this);_initDefineProp(this,'agentData',_descriptor4,this);_initDefineProp(this,'docs',_descriptor5,this);_initDefineProp(this,'notifications',_descriptor6,this);_initDefineProp(this,'invitedSeller',_descriptor7,this);this.root=root;}_createClass(SaleEditStore,[{key:'inviteSeller',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(data){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__services_request__["e" /* post */])('/api/v1/sellers/invite',{saleId:this.root.saleId,data:data},this.root.user.accessToken);case 2:case'end':return _context.stop();}}},_callee,this);}));function inviteSeller(_x){return _ref2.apply(this,arguments);}return inviteSeller;}()},{key:'blockSeller',value:function blockSeller(data){Object(__WEBPACK_IMPORTED_MODULE_2__services_request__["f" /* put */])('/api/v1/sellers/block',{saleId:this.root.saleId},this.root.user.accessToken).then(this.root.success,this.root.failed);}},{key:'inviteBuyerAgent',value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(data){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__services_request__["e" /* post */])('/api/v1/sales/'+this.root.saleId+'/whitelist/invite',Object.assign({},data),this.root.user.accessToken);case 2:case'end':return _context2.stop();}}},_callee2,this);}));function inviteBuyerAgent(_x2){return _ref3.apply(this,arguments);}return inviteBuyerAgent;}()},{key:'close',value:function close(){Object(__WEBPACK_IMPORTED_MODULE_2__services_request__["f" /* put */])('/api/v1/sales/'+this.root.saleId+'/close',{},this.root.user.accessToken).then(this.root.success,this.root.failed);}},{key:'delete',value:function _delete(){Object(__WEBPACK_IMPORTED_MODULE_2__services_request__["c" /* del */])('/api/v1/sales/'+this.root.saleId,this.root.user.accessToken).then(this.root.success,this.root.failed);}},{key:'update',value:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3(_ref4){var offerData=_ref4.offerData;var adjusted;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:adjusted=this.adjustOfferData(offerData);_context3.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__services_request__["f" /* put */])('/api/v1/sales/'+this.root.saleId,Object.assign({},{offerData:adjusted}),this.root.user.accessToken).then(this.root.success,this.root.failed);case 3:case'end':return _context3.stop();}}},_callee3,this);}));function update(_x3){return _ref5.apply(this,arguments);}return update;}()},{key:'adjustOfferData',value:function adjustOfferData(offerData){var onUpdate=__WEBPACK_IMPORTED_MODULE_3__build_node_modules_lodash___default.a.get(this.root,'saleConfig.offerData.onUpdate',null);if(!onUpdate)return offerData;var adjusted=offerData;__WEBPACK_IMPORTED_MODULE_3__build_node_modules_lodash___default.a.forOwn(onUpdate,function(rules,sourceField){var sourceValue=offerData[sourceField];var targets=rules[sourceValue];if(!targets&&rules.else)targets=rules.else;if(!targets)return;if(adjusted===offerData)adjusted=Object.assign({},offerData);__WEBPACK_IMPORTED_MODULE_3__build_node_modules_lodash___default.a.assign(adjusted,targets);});return adjusted;}},{key:'updateDocs',value:function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee4(_ref6){var docs=_ref6.docs;var cleaned;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:// strip client only metadata
cleaned=__WEBPACK_IMPORTED_MODULE_3__build_node_modules_lodash___default.a.map(docs,function(i){var metadata=i.metadata,rest=_objectWithoutProperties(i,['metadata']);if(!!rest.details)rest.details=__WEBPACK_IMPORTED_MODULE_4__build_node_modules_moment_timezone___default()(rest.details).format('YYYY-MM-DD');return rest;});_context4.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__services_request__["e" /* post */])('/api/v1/sales/'+this.root.saleId+'/docs',Object.assign({},{docs:cleaned}),this.root.user.accessToken).then(this.root.success,this.root.failed);case 3:case'end':return _context4.stop();}}},_callee4,this);}));function updateDocs(_x4){return _ref7.apply(this,arguments);}return updateDocs;}()},{key:'upload',value:function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee5(file){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_5__services_cloudinary__["b" /* upload */])({saleId:this.root.saleId,file:file,accessToken:this.root.user.accessToken});case 2:return _context5.abrupt('return',_context5.sent);case 3:case'end':return _context5.stop();}}},_callee5,this);}));function upload(_x5){return _ref8.apply(this,arguments);}return upload;}()},{key:'remove',value:function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee6(deleteToken){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return Object(__WEBPACK_IMPORTED_MODULE_5__services_cloudinary__["a" /* remove */])({saleId:this.root.saleId,deleteToken:deleteToken,accessToken:this.root.user.accessToken});case 2:return _context6.abrupt('return',_context6.sent);case 3:case'end':return _context6.stop();}}},_callee6,this);}));function remove(_x6){return _ref9.apply(this,arguments);}return remove;}()},{key:'changeNotificationSettings',value:function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee7(){var data;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:data=this.notifications.filter(function(n){return n.enabled;}).map(function(n){return[{name:n.name,role:n.role,channel:'email',address:n.email,locale:n.locale},{name:n.name,role:n.role,channel:'sms',address:n.phoneNumber,locale:n.locale}];}).flatten();_context7.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2__services_request__["e" /* post */])('/api/v1/sales/'+this.root.saleId+'/notifications',Object.assign({},{definitions:data}),this.root.user.accessToken).then(this.root.success,this.root.failed);case 3:case'end':return _context7.stop();}}},_callee7,this);}));function changeNotificationSettings(){return _ref10.apply(this,arguments);}return changeNotificationSettings;}()},{key:'sendNotification',value:function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee8(data){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__services_request__["f" /* put */])('/api/v1/notifications',Object.assign({saleId:this.root.saleId},data),this.root.user.accessToken);case 2:return _context8.abrupt('return',_context8.sent);case 3:case'end':return _context8.stop();}}},_callee8,this);}));function sendNotification(_x7){return _ref11.apply(this,arguments);}return sendNotification;}()},{key:'reset',value:function reset(){this.docs=[];}}]);return SaleEditStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'currencyCode',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'locale',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'offerData',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'agentData',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'docs',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'notifications',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'invitedSeller',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return{data:{},blocked:false};}}),_applyDecoratedDescriptor(_class.prototype,'inviteSeller',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'inviteSeller'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'blockSeller',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'blockSeller'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'inviteBuyerAgent',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'inviteBuyerAgent'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'close',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'close'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'delete',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'delete'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'update',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'update'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateDocs',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'updateDocs'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'upload',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'upload'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'remove',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'remove'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'changeNotificationSettings',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'changeNotificationSettings'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'sendNotification',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'sendNotification'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'reset',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'reset'),_class.prototype)),_class);

/***/ }),
/* 1677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OffersStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_request__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var OffersStore=(_class=function(){_createClass(OffersStore,[{key:'emails',get:function get(){if(!this.viewModel){return[];}return this.viewModel.offers.filter(function(a){return!a.buyerIsBlocked;}).map(function(o){return o.buyer.buyer_email;});}},{key:'isOfferSelected',get:function get(){return!!this.selectedOffer;}},{key:'hasWinner',get:function get(){return!!this.viewModel&&this.viewModel.hasAwardedContract;}},{key:'hasAccessibleOffers',get:function get(){return this.accessibleOffers.length>0;}},{key:'accessibleOffers',get:function get(){var _this=this;if(!this.viewModel)return[];return(this.viewModel.offers||[]).filter(function(offer){return _this.root.user.hasPermissions(offer.agentData);});}}]);function OffersStore(_ref){var root=_ref.root;_classCallCheck(this,OffersStore);_initDefineProp(this,'viewModel',_descriptor,this);_initDefineProp(this,'selectedOffer',_descriptor2,this);this.root=root;}_createClass(OffersStore,[{key:'sortOffersByBuyerName',value:function sortOffersByBuyerName(desc){if(!this.viewModel.offers||this.viewModel.offers.length===0){return;}this.viewModel.offers=this.viewModel.offers.concat([]).sort(function(a,b){var firstValue=a.buyer.buyer_lastName;var secondValue=b.buyer.buyer_lastName;if(firstValue===secondValue){return 0;}if(desc){return firstValue>secondValue?1:-1;}else{return firstValue>secondValue?-1:1;}});}},{key:'getByBuyerId',value:function getByBuyerId(buyerId){if(!this.viewModel){return null;}return this.viewModel.offers.filter(function(o){return o.buyerId===buyerId;})[0];}},{key:'update',value:function update(viewModel){this.viewModel=viewModel;this.sortOffersByBuyerName(true);}},{key:'select',value:function select(offer){this.selectedOffer=offer;}},{key:'reset',value:function reset(){this.viewModel=undefined;this.selectedOffer=undefined;}},{key:'register',value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(_ref2){var _this2=this;var buyerData=_ref2.buyerData,offerData=_ref2.offerData,agentData=_ref2.agentData;var url,_root,user,isMls,saleAgentData,agent;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:url='/api/v2/registrations/'+this.root.saleId;_root=this.root,user=_root.user,isMls=_root.isMls,saleAgentData=_root.saleAgentData;agent=isMls?agentData?agentData:user.agentData():saleAgentData;_context2.next=5;return this.root.ui.loading.start(_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__services_request__["e" /* post */])(url,{buyerData:buyerData,offerData:offerData,agentData:agent},_this2.root.user.accessToken);case 2:return _context.abrupt('return',_context.sent);case 3:case'end':return _context.stop();}}},_callee,_this2);})));case 5:case'end':return _context2.stop();}}},_callee2,this);}));function register(_x){return _ref3.apply(this,arguments);}return register;}()},{key:'updateBuyer',value:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3(_ref5){var email=_ref5.email,phoneNumber=_ref5.phoneNumber,salutation=_ref5.salutation,title=_ref5.title,firstName=_ref5.firstName,lastName=_ref5.lastName,locale=_ref5.locale,offerData=_ref5.offerData,agentData=_ref5.agentData,_ref5$triggerNotifica=_ref5.triggerNotification,triggerNotification=_ref5$triggerNotifica===undefined?false:_ref5$triggerNotifica;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__services_request__["f" /* put */])('/api/v1/offers/'+this.selectedOffer.buyerId+'/buyer',{saleId:this.root.saleId,email:email,phoneNumber:phoneNumber,salutation:salutation,title:title,firstName:firstName,lastName:lastName,locale:locale,offerData:offerData,triggerNotification:triggerNotification,agentData:agentData},this.root.user.accessToken);case 2:case'end':return _context3.stop();}}},_callee3,this);}));function updateBuyer(_x2){return _ref6.apply(this,arguments);}return updateBuyer;}()},{key:'updateContact',value:function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee4(_ref7){var email=_ref7.email,phoneNumber=_ref7.phoneNumber;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__services_request__["e" /* post */])('/api/v1/offers/'+this.selectedOffer.buyerId+'/contact',{saleId:this.root.saleId,email:email,phoneNumber:phoneNumber},this.root.user.accessToken);case 2:case'end':return _context4.stop();}}},_callee4,this);}));function updateContact(_x3){return _ref8.apply(this,arguments);}return updateContact;}()},{key:'uploadOffer',value:function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee5(offer){var _ref10,_ref10$buyerId,buyerId,_root2,user,isMls,saleAgentData,agentData;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_ref10=this.selectedOffer||{},_ref10$buyerId=_ref10.buyerId,buyerId=_ref10$buyerId===undefined?null:_ref10$buyerId;_root2=this.root,user=_root2.user,isMls=_root2.isMls,saleAgentData=_root2.saleAgentData;agentData=isMls?user.agentData():saleAgentData;_context5.next=5;return Object(__WEBPACK_IMPORTED_MODULE_2__services_request__["e" /* post */])('/api/v1/offers/upload',Object.assign({buyerId:buyerId,saleId:this.root.saleId,agentData:agentData},offer),this.root.user.accessToken);case 5:case'end':return _context5.stop();}}},_callee5,this);}));function uploadOffer(_x4){return _ref9.apply(this,arguments);}return uploadOffer;}()},{key:'increaseOffer',value:function increaseOffer(offer){var _ref11=this.selectedOffer||{},_ref11$buyerId=_ref11.buyerId,buyerId=_ref11$buyerId===undefined?null:_ref11$buyerId;Object(__WEBPACK_IMPORTED_MODULE_2__services_request__["f" /* put */])('/api/v1/offers/'+buyerId+'/increase-on-behalf',Object.assign({saleId:this.root.saleId},offer),this.root.user.accessToken).then(this.root.success,this.root.failed);}},{key:'block',value:function block(_ref12){var reason=_ref12.reason;Object(__WEBPACK_IMPORTED_MODULE_2__services_request__["f" /* put */])('/api/v1/registrations/'+this.selectedOffer.buyerId+'/block',{saleId:this.selectedOffer.saleId,reason:reason},this.root.user.accessToken).then(this.root.success,this.root.failed);}},{key:'confirmOnBehalf',value:function confirmOnBehalf(){this._offer('confirm-on-behalf');}},{key:'approve',value:function approve(){this._offer('approve');}},{key:'refuse',value:function refuse(reason,offer){this._offer('refuse',Object.assign({reason:reason},offer));}},{key:'award',value:function award(){Object(__WEBPACK_IMPORTED_MODULE_2__services_request__["f" /* put */])('/api/v1/contracts/'+this.selectedOffer.buyerId+'/award',{saleId:this.selectedOffer.saleId},this.root.user.accessToken).then(this.root.success,this.root.failed);}},{key:'accept',value:function accept(){this._offer('accept');}},{key:'reject',value:function reject(){this._offer('reject');}},{key:'approveRegistration',value:function approveRegistration(offerData){this._registration('approve',{offerData:offerData});}},{key:'refuseRegistration',value:function refuseRegistration(){this._registration('refuse');}},{key:'_registration',value:function _registration(action){var offer=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var url='/api/v2/registrations/'+this.selectedOffer.saleId+'/'+this.selectedOffer.buyerId+'/'+action;Object(__WEBPACK_IMPORTED_MODULE_2__services_request__["e" /* post */])(url,offer,this.root.user.accessToken).then(this.root.success,this.root.failed);}},{key:'_offer',value:function _offer(action){var data=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};Object(__WEBPACK_IMPORTED_MODULE_2__services_request__["f" /* put */])('/api/v1/offers/'+this.selectedOffer.buyerId+'/'+action,Object.assign({saleId:this.selectedOffer.saleId},data),this.root.user.accessToken).then(this.root.success,this.root.failed);}}]);return OffersStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'viewModel',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return undefined;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'selectedOffer',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return undefined;}}),_applyDecoratedDescriptor(_class.prototype,'emails',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'emails'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isOfferSelected',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isOfferSelected'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'hasWinner',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'hasWinner'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'hasAccessibleOffers',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'hasAccessibleOffers'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'accessibleOffers',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'accessibleOffers'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'sortOffersByBuyerName',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'sortOffersByBuyerName'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'getByBuyerId',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'getByBuyerId'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'update',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'update'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'select',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'select'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'reset',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'reset'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'register',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'register'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateBuyer',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'updateBuyer'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateContact',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'updateContact'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'uploadOffer',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'uploadOffer'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'increaseOffer',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'increaseOffer'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'block',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'block'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'confirmOnBehalf',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'confirmOnBehalf'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'approve',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'approve'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'refuse',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'refuse'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'award',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'award'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'accept',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'accept'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'reject',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'reject'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'approveRegistration',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'approveRegistration'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'refuseRegistration',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'refuseRegistration'),_class.prototype)),_class);

/***/ }),
/* 1678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RoundStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_request__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor;function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var config=__webpack_require__(104).default;var RoundStore=(_class=function(){function RoundStore(_ref){var root=_ref.root;_classCallCheck(this,RoundStore);_initDefineProp(this,'definition',_descriptor,this);this.root=root;}_createClass(RoundStore,[{key:'start',value:function start(_ref2){var saleId=_ref2.saleId,round=_objectWithoutProperties(_ref2,['saleId']);Object(__WEBPACK_IMPORTED_MODULE_1__services_request__["f" /* put */])('/api/v1/sales/'+this.root.saleId+'/startround',round,this.root.user.accessToken).then(this.root.success,this.root.failed);}},{key:'edit',value:function edit(_ref3){var saleId=_ref3.saleId,round=_objectWithoutProperties(_ref3,['saleId']);var data=Object.assign({},round,{biddingSteps:round.biddingSteps?round.biddingSteps.toString():null});Object(__WEBPACK_IMPORTED_MODULE_1__services_request__["f" /* put */])('/api/v1/sales/'+this.root.saleId+'/editround',data,this.root.user.accessToken).then(this.root.success,this.root.failed);}},{key:'open',value:function open(){Object(__WEBPACK_IMPORTED_MODULE_1__services_request__["f" /* put */])('/api/v1/sales/'+this.root.saleId+'/openround',{},this.root.user.accessToken).then(this.root.success,this.root.failed);}},{key:'close',value:function close(){Object(__WEBPACK_IMPORTED_MODULE_1__services_request__["f" /* put */])('/api/v1/sales/'+this.root.saleId+'/closeround',{},this.root.user.accessToken).then(this.root.success,this.root.failed);}},{key:'reset',value:function reset(){this.definition={};this.reqError=null;}},{key:'mode',get:function get(){return this.definition.status&&(this.definition.status==='notStarted'||this.definition.status==='closed')?'new':'edit';}},{key:'canChangeType',get:function get(){var result=!!this.definition.number&&(this.definition.number<=1||config.canChangeRoundType)&&!this.isOpen;return result;}},{key:'isStarted',get:function get(){return!!this.definition.status&&this.definition.status==='started';}},{key:'isOpen',get:function get(){return!!this.definition.status&&this.definition.status==='opened';}},{key:'isClosed',get:function get(){return!!this.definition.status&&this.definition.status==='closed';}},{key:'type',get:function get(){return!!this.definition.type?this.definition.type:undefined;}},{key:'isOpenBidding',get:function get(){return this.type==='open_bidding';}},{key:'isSimpleOffer',get:function get(){return this.type==='simple_offer';}}]);return RoundStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'definition',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return{};}}),_applyDecoratedDescriptor(_class.prototype,'mode',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'mode'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'canChangeType',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'canChangeType'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isStarted',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isStarted'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isOpen',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isOpen'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isClosed',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isClosed'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'type',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'type'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isOpenBidding',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isOpenBidding'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isSimpleOffer',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isSimpleOffer'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'start',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'start'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'edit',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'edit'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'open',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'open'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'close',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'close'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'reset',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'reset'),_class.prototype)),_class);

/***/ }),
/* 1679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CommandBarStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SaleWizard_stores_actionSelector__ = __webpack_require__(666);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}var config=__webpack_require__(104).default;var CommandBarStore=(_class=function(){function CommandBarStore(_ref){var root=_ref.root;_classCallCheck(this,CommandBarStore);this.sale=root;}_createClass(CommandBarStore,[{key:'isMls',get:function get(){return this.sale.isMls;}},{key:'agentData',get:function get(){return this.sale.saleEdit.agentData;}},{key:'hasSalePermissions',get:function get(){return this.sale.hasSalePermissions;}},{key:'hasOfferPermissions',get:function get(){return this.sale.hasOfferPermissions;}},{key:'hasExclusiveOfferPermissions',get:function get(){return this.sale.hasExclusiveOfferPermissions;}// sale permissions
},{key:'saleEditEnabled',get:function get(){return!this.sale.isDeleted&&!this.sale.isClosed&&this.hasSalePermissions;}},{key:'inviteSellerEnabled',get:function get(){return!this.sale.isDeleted&&!this.sale.isClosed&&this.hasSalePermissions;}},{key:'inviteBuyerAgentEnabled',get:function get(){return!this.sale.isDeleted&&!this.sale.isClosed&&this.hasSalePermissions&&this.isMls;}// sale permissions
},{key:'saleCloseEnabled',get:function get(){return!this.sale.isDeleted&&!this.sale.isClosed&&!this.sale.round.isOpen&&this.hasSalePermissions;}// sale permissions
},{key:'saleDeleteEnabled',get:function get(){return(this.sale.isClosed||!this.sale.isDeleted&&!this.sale.round.isOpen&&!this.sale.round.isClosed||config.allowDeleteEmptySale&&this.sale.offers.viewModel.offers.length===0)&&this.hasSalePermissions;}// sale permissions
},{key:'whitelistingEnabled',get:function get(){return!this.sale.isDeleted&&!this.sale.isClosed&&this.hasSalePermissions;}},{key:'whitelistingVisible',get:function get(){return this.sale.inviteOnly;}// sale permissions
},{key:'roundStartEnabled',get:function get(){return this.sale.isComplete&&!!this.sale.round.definition&&this.sale.round.definition.canStart&&this.hasSalePermissions;}// sale permissions
},{key:'roundEditEnabled',get:function get(){return!!this.sale.round.definition&&this.sale.round.definition.canEdit&&this.hasSalePermissions;}// sale permissions
},{key:'roundOpenEnabled',get:function get(){return!!this.sale.round.definition&&this.sale.round.definition.canOpen&&this.hasSalePermissions;}// sale permissions
},{key:'roundCloseEnabled',get:function get(){return!!this.sale.round.definition&&this.sale.round.definition.canClose&&this.hasSalePermissions;}// none
},{key:'userRegistrationEnabled',get:function get(){return!this.sale.isDeleted&&!this.sale.isClosed&&this.sale.round.isOpen&&(this.hasOfferPermissions||this.isMls)&&this.sale.round.type!=='counteroffer_bidding';}// sale permissions
},{key:'userBlockingEnabled',get:function get(){return!this.registrationEnabled&&!this.sale.isDeleted&&this.sale.offers.isOfferSelected&&!this.sale.offers.selectedOffer.buyerIsBlocked&&(this.hasExclusiveOfferPermissions||this.hasSalePermissions);}// sale permissions
},{key:'registrationEnabled',get:function get(){var offer=this.sale.offers.selectedOffer;return offer&&(offer.status==='registrationConfirmed'||offer.status==='registrationSubmitted')&&this.hasSalePermissions;}// ??
},{key:'offerUploadEnabled',get:function get(){var res=!this.sale.isDeleted&&!this.sale.isClosed&&this.sale.round.isOpen&&!this.sale.offers.isOfferSelected;return(res||this.offerUploadExistingEnabled||this.isIncreaseBidInOpenRound)&&(this.hasOfferPermissions||!this.sale.offers.isOfferSelected&&this.isMls);}// ??
},{key:'offerUploadExistingEnabled',get:function get(){var res=!this.sale.isDeleted&&!this.sale.isClosed&&this.sale.round.isOpen&&this.sale.offers.isOfferSelected&&!this.sale.offers.selectedOffer.buyerIsBlocked;//&&
// (this.sale.offers.selectedOffer.status === 'invited' ||
//   this.sale.offers.selectedOffer.status === 'submitted' ||
//   this.sale.offers.selectedOffer.status === 'refused' ||
//   this.sale.offers.selectedOffer.status === 'accepted');
return res;}// ??
},{key:'isIncreaseBidInOpenRound',get:function get(){var res=!this.sale.isDeleted&&!this.sale.isClosed&&this.sale.round.isOpen&&this.sale.round.isOpenBidding&&this.sale.offers.isOfferSelected&&(this.sale.offers.selectedOffer.status==='confirmed'||this.sale.offers.selectedOffer.status==='accepted'||this.sale.offers.selectedOffer.status==='submitted'&&this.sale.offers.selectedOffer.isValid);return res;}},{key:'offerApproveEnabled',get:function get(){return!this.sale.isDeleted&&!this.sale.isClosed&&this.sale.offers.isOfferSelected&&this.sale.offers.selectedOffer.canApprove&&this.hasSalePermissions;}// offer permissions
},{key:'offerRefuseEnabled',get:function get(){return!this.sale.isDeleted&&!this.sale.isClosed&&!this.sale.round.isClosed&&this.sale.offers.isOfferSelected&&this.sale.offers.selectedOffer.canRefuse&&this.hasExclusiveOfferPermissions;}// sale permissions
},{key:'offerAwardEnabled',get:function get(){return!this.sale.isDeleted&&!this.sale.isClosed&&this.sale.round.isClosed&&!this.sale.offers.hasWinner&&this.sale.offers.isOfferSelected&&this.sale.offers.selectedOffer.canAward&&this.hasSalePermissions;}// sale permissions
},{key:'offerAcceptEnabled',get:function get(){return!this.sale.isDeleted&&!this.sale.isClosed&&this.sale.round.isClosed&&this.sale.offers.isOfferSelected&&this.sale.offers.selectedOffer.canAccept&&this.hasSalePermissions;}// sale permissions
},{key:'offerRejectEnabled',get:function get(){return!this.sale.isDeleted&&!this.sale.isClosed&&this.sale.round.isClosed&&this.sale.offers.isOfferSelected&&this.sale.offers.selectedOffer.canReject&&this.hasSalePermissions;}// offer permissions
},{key:'offerConfirmOnBehalfEnabled',get:function get(){return!this.sale.isDeleted&&!this.sale.isClosed&&this.sale.round.isOpen&&this.sale.offers.isOfferSelected&&this.sale.offers.selectedOffer.canConfirmOnBehalf&&this.hasOfferPermissions;}// offer exclusive permissions
},{key:'offerPreviewEnabled',get:function get(){var _this=this;return!this.sale.isDeleted&&this.sale.offers.isOfferSelected&&this.sale.offers.selectedOffer.isValid&&!['invited','submitted','refused'].some(function(s){return s===_this.sale.offers.selectedOffer.status;})&&this.hasExclusiveOfferPermissions;}},{key:'updateContactEnabled',get:function get(){return!this.sale.isDeleted&&!this.sale.isClosed&&this.sale.offers.isOfferSelected&&this.hasOfferPermissions;}},{key:'saleWizardEnabled',get:function get(){// const { round } = this.sale;
var hasSelector=Object(__WEBPACK_IMPORTED_MODULE_1__SaleWizard_stores_actionSelector__["a" /* default */])({sale:this.sale,round:this.sale.round.definition}).length>0;return hasSelector;//;|| (round.isSimpleOffer && round.isOpen);
}}]);return CommandBarStore;}(),(_applyDecoratedDescriptor(_class.prototype,'isMls',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isMls'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'agentData',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'agentData'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'hasSalePermissions',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'hasSalePermissions'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'hasOfferPermissions',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'hasOfferPermissions'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'hasExclusiveOfferPermissions',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'hasExclusiveOfferPermissions'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'saleEditEnabled',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'saleEditEnabled'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'inviteSellerEnabled',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'inviteSellerEnabled'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'inviteBuyerAgentEnabled',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'inviteBuyerAgentEnabled'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'saleCloseEnabled',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'saleCloseEnabled'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'saleDeleteEnabled',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'saleDeleteEnabled'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'whitelistingEnabled',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'whitelistingEnabled'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'whitelistingVisible',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'whitelistingVisible'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'roundStartEnabled',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'roundStartEnabled'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'roundEditEnabled',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'roundEditEnabled'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'roundOpenEnabled',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'roundOpenEnabled'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'roundCloseEnabled',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'roundCloseEnabled'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'userRegistrationEnabled',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'userRegistrationEnabled'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'userBlockingEnabled',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'userBlockingEnabled'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'registrationEnabled',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'registrationEnabled'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'offerUploadEnabled',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'offerUploadEnabled'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'offerUploadExistingEnabled',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'offerUploadExistingEnabled'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isIncreaseBidInOpenRound',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isIncreaseBidInOpenRound'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'offerApproveEnabled',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'offerApproveEnabled'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'offerRefuseEnabled',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'offerRefuseEnabled'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'offerAwardEnabled',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'offerAwardEnabled'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'offerAcceptEnabled',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'offerAcceptEnabled'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'offerRejectEnabled',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'offerRejectEnabled'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'offerConfirmOnBehalfEnabled',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'offerConfirmOnBehalfEnabled'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'offerPreviewEnabled',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'offerPreviewEnabled'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'updateContactEnabled',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'updateContactEnabled'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'saleWizardEnabled',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'saleWizardEnabled'),_class.prototype)),_class);

/***/ }),
/* 1680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BiddingStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor;function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var BiddingStore=(_class=function(){_createClass(BiddingStore,[{key:'history',get:function get(){var _this=this;if(!this.vm||!this.vm.history){return[];}return this.vm.history.map(function(b){var offer=_this.offers.getByBuyerId(b.buyerId);if(!offer){return Object.assign({name:''},b);}return Object.assign({name:offer.buyer.buyer_lastName+', '+offer.buyer.buyer_firstName},b);}).sortBy('createdAt',false);}},{key:'highestBidder',get:function get(){if(!this.vm.highestBidderId){return'';}var offer=this.offers.getByBuyerId(this.vm.highestBidderId);if(!offer){return'';}return offer.buyer.buyer_lastName+', '+offer.buyer.buyer_firstName;}}]);function BiddingStore(_ref){var offers=_ref.offers;_classCallCheck(this,BiddingStore);_initDefineProp(this,'vm',_descriptor,this);this.offers=offers;}_createClass(BiddingStore,[{key:'update',value:function update(data){this.vm=data;}},{key:'reset',value:function reset(){this.vm=undefined;}}]);return BiddingStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'vm',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return undefined;}}),_applyDecoratedDescriptor(_class.prototype,'history',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'history'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'highestBidder',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'highestBidder'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'update',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'update'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'reset',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'reset'),_class.prototype)),_class);

/***/ }),
/* 1681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WhitelistingStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_request__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var WhitelistingStore=(_class=function(){_createClass(WhitelistingStore,[{key:'whitelist',get:function get(){var _this=this;return Object.keys(this.vm.whitelist).map(function(k){return _this.vm.whitelist[k];});}},{key:'pendingRequests',get:function get(){var vm=this.vm;if(!vm)return 0;return Object.keys(vm.whitelist).filter(function(k){return vm.whitelist[k].status==='requested';}).length;}}]);function WhitelistingStore(_ref){var root=_ref.root;_classCallCheck(this,WhitelistingStore);_initDefineProp(this,'vm',_descriptor,this);this.root=root;}_createClass(WhitelistingStore,[{key:'update',value:function update(data){this.vm=data;}},{key:'reset',value:function reset(){this.vm=undefined;}},{key:'accept',value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(_ref2){var userId=_ref2.userId,saleId=_ref2.saleId;var res;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__services_request__["e" /* post */])('/api/v1/sales/'+(saleId||this.root.saleId)+'/whitelist',{userId:userId},this.root.user.accessToken);case 2:res=_context.sent;return _context.abrupt('return',res&&res.result&&res.result.successful);case 4:case'end':return _context.stop();}}},_callee,this);}));function accept(_x){return _ref3.apply(this,arguments);}return accept;}()},{key:'block',value:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4){var userId=_ref4.userId,saleId=_ref4.saleId,reason=_ref4.reason;var res;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__services_request__["e" /* post */])('/api/v1/sales/'+(saleId||this.root.saleId)+'/whitelist/block',{userId:userId,reason:reason},this.root.user.accessToken);case 2:res=_context2.sent;return _context2.abrupt('return',res&&res.result&&res.result.successful);case 4:case'end':return _context2.stop();}}},_callee2,this);}));function block(_x2){return _ref5.apply(this,arguments);}return block;}()}]);return WhitelistingStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'vm',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return undefined;}}),_applyDecoratedDescriptor(_class.prototype,'whitelist',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'whitelist'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'pendingRequests',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'pendingRequests'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'update',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'update'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'reset',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'reset'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'accept',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'accept'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'block',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'block'),_class.prototype)),_class);

/***/ }),
/* 1682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MlsStore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_stores_UserStore__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_request__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_dec2,_desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var byDefaultDoNothing=function byDefaultDoNothing(){};var overviewColumns=function overviewColumns(t){var onClick=arguments.length>1&&arguments[1]!==undefined?arguments[1]:byDefaultDoNothing;return[{key:'itemNumber',name:t('Number'),fieldName:'itemNumber',maxWidth:100,onColumnClick:onClick,isSorted:false,isSortedDescending:false},{key:'agentName',name:t('Agent'),fieldName:'agentName',minWidth:100,maxWidth:200,onColumnClick:onClick,isSorted:false,isSortedDescending:false},{key:'title',name:t('Title'),fieldName:'title',minWidth:200,maxWidth:450,onColumnClick:onClick,isSorted:false,isSortedDescending:false},{key:'address',name:t('Address'),fieldName:'address',minWidth:200,maxWidth:800,isSorted:false,isSortedDescending:false},{key:'status',name:t('Status'),fieldName:'status',minWidth:200,maxWidth:600,isSorted:false,isSortedDescending:false}];};var MlsStore=(_dec=__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */].bound,_dec2=__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */].bound,(_class=function(){function MlsStore(user){_classCallCheck(this,MlsStore);_initDefineProp(this,'items',_descriptor,this);_initDefineProp(this,'columns',_descriptor2,this);_initDefineProp(this,'fetching',_descriptor3,this);_initDefineProp(this,'loaded',_descriptor4,this);this.user=user;}_createClass(MlsStore,[{key:'sortBy',value:function sortBy(field){var index=this.columns.findIndex(function(c){return c.key===field;});var column=this.columns[index];this.items=this.items.sortBy(field,column.isSortedDescending);this.columns=this.columns.map(function(c,i){if(i!==index){c.isSorted=false;c.isSortedDescending=false;}else{c.isSorted=true;c.isSortedDescending=!c.isSortedDescending;}return c;});}},{key:'load',value:function load(){this.fetching=true;Object(__WEBPACK_IMPORTED_MODULE_3__services_request__["d" /* get */])('/api/v1/sales/mls',this.user.accessToken).then(this.loadListingsOverviewSuccess,this.loadListingsOverviewError);}},{key:'initColumns',value:function initColumns(t,onClick){this.columns=overviewColumns(t,onClick);}},{key:'loadListingsOverviewSuccess',value:function loadListingsOverviewSuccess(data){this.items=data.objects.sortBy('startAt',false);this.fetching=false;this.loaded=true;}},{key:'loadListingsOverviewError',value:function loadListingsOverviewError(error){this.fetching=false;}},{key:'requestAccess',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(_ref){var saleId=_ref.saleId,userId=_ref.userId,agent=_ref.agent;var res;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3__services_request__["e" /* post */])('/api/v1/sales/'+saleId+'/whitelist/request',{userId:userId,agent:agent},this.user.accessToken);case 2:res=_context.sent;return _context.abrupt('return',res&&res.result&&res.result.successful);case 4:case'end':return _context.stop();}}},_callee,this);}));function requestAccess(_x2){return _ref2.apply(this,arguments);}return requestAccess;}()}]);return MlsStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'items',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'columns',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'fetching',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'loaded',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_applyDecoratedDescriptor(_class.prototype,'sortBy',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'sortBy'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'load',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'load'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'initColumns',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'initColumns'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'loadListingsOverviewSuccess',[_dec],Object.getOwnPropertyDescriptor(_class.prototype,'loadListingsOverviewSuccess'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'loadListingsOverviewError',[_dec2],Object.getOwnPropertyDescriptor(_class.prototype,'loadListingsOverviewError'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'requestAccess',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'requestAccess'),_class.prototype)),_class));var mls=new MlsStore(__WEBPACK_IMPORTED_MODULE_2__App_stores_UserStore__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (mls);

/***/ }),
/* 1683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SaleWizardStore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sale_stores_SaleStore__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Increase__ = __webpack_require__(1684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Award__ = __webpack_require__(2093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AwardAll__ = __webpack_require__(2099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Duplicate__ = __webpack_require__(2110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ConfirmAward__ = __webpack_require__(2114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RejectSelected__ = __webpack_require__(2117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Reject__ = __webpack_require__(2120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Counteroffer__ = __webpack_require__(2122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__NotifySeller__ = __webpack_require__(2127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actionSelector__ = __webpack_require__(666);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var ACTIONS={increase:{implementation:__WEBPACK_IMPORTED_MODULE_3__Increase__["a" /* default */]},reject:{implementation:__WEBPACK_IMPORTED_MODULE_8__RejectSelected__["a" /* default */]},rejectAll:{implementation:__WEBPACK_IMPORTED_MODULE_9__Reject__["a" /* default */]},award:{implementation:__WEBPACK_IMPORTED_MODULE_4__Award__["a" /* default */]},awardAll:{implementation:__WEBPACK_IMPORTED_MODULE_5__AwardAll__["a" /* default */]},duplicate:{implementation:__WEBPACK_IMPORTED_MODULE_6__Duplicate__["a" /* default */]},confirmAward:{implementation:__WEBPACK_IMPORTED_MODULE_7__ConfirmAward__["a" /* default */]},counteroffer:{implementation:__WEBPACK_IMPORTED_MODULE_10__Counteroffer__["a" /* default */]},notifySeller:{implementation:__WEBPACK_IMPORTED_MODULE_11__NotifySeller__["a" /* default */]},edit:{},abort:{},reset:{},close:{}};var SaleWizardStore=(_class=function(){_createClass(SaleWizardStore,[{key:'currentStepValidChanged',value:function currentStepValidChanged(valid){this.currentStepValid=valid;}},{key:'availableActions',get:function get(){var _source$round$definit=this.source.round.definition,type=_source$round$definit.type,status=_source$round$definit.status;return Object(__WEBPACK_IMPORTED_MODULE_12__actionSelector__["a" /* default */])({sale:this.source,round:{type:type,status:status}}).filter(function(a){return!!ACTIONS[a].implementation;});}},{key:'isInitialStep',get:function get(){return this.currentStep===0;}},{key:'isConfirmationStep',get:function get(){return this.steps&&this.currentStep===this.steps.length+1;}},{key:'isActionStep',get:function get(){return this.steps&&this.currentStep>0&&this.currentStep<=this.steps.length;}},{key:'isResultsStep',get:function get(){return this.steps&&this.currentStep===this.steps.length+2;}},{key:'breadcrumbs',get:function get(){if(!this.steps){return['Select Action'];}return['Select Action'].concat(_toConsumableArray(this.steps.map(function(i){return i.title;})),['Review','Results']);}},{key:'currentActionStep',get:function get(){if(!this.isActionStep)return null;return this.steps[this.currentStep-1].implementation;}},{key:'currentActionInfo',get:function get(){if(!this.isActionStep)return null;return this.steps[this.currentStep-1].info;}},{key:'isCurrentStepValid',get:function get(){return!this.currentActionStep||this.currentStepValid;}},{key:'showPrevious',get:function get(){return this.isActionStep||this.isConfirmationStep;}},{key:'showNext',get:function get(){return this.isActionStep&&this.isCurrentStepValid;}},{key:'showSubmit',get:function get(){return this.isConfirmationStep;}}]);function SaleWizardStore(_ref){var _this=this;var sale=_ref.sale;_classCallCheck(this,SaleWizardStore);_initDefineProp(this,'currentAction',_descriptor,this);_initDefineProp(this,'currentStep',_descriptor2,this);_initDefineProp(this,'currentStepValid',_descriptor3,this);_initDefineProp(this,'actionStore',_descriptor4,this);_initDefineProp(this,'steps',_descriptor5,this);_initDefineProp(this,'summaryClass',_descriptor6,this);_initDefineProp(this,'resultsClass',_descriptor7,this);_initDefineProp(this,'submitting',_descriptor8,this);this.source={};this.handleSelectAction=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */])(function(actionKey){return function(){_this.selectActionByKey(actionKey);};});this.handleNext=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */])(function(){_this.currentStep++;});this.handlePrevious=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */])(function(){_this.currentStep--;});this.handleSubmit=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */])(_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.submitting=true;_context.prev=1;_context.next=4;return _this.actionStore.submit(_this.source.saleId,_this.source.user.accessToken);case 4:_this.currentStep++;case 5:_context.prev=5;_this.submitting=false;return _context.finish(5);case 8:case'end':return _context.stop();}}},_callee,_this,[[1,,5,8]]);})));this.source=sale;}_createClass(SaleWizardStore,[{key:'selectActionByKey',value:function selectActionByKey(actionKey){var a=ACTIONS[actionKey];if(!a||!a.implementation)return;this.currentAction=actionKey;this.selectAction(a.implementation);}},{key:'selectAction',value:function selectAction(store){if(!store){return;}this.currentStep=1;this.actionStore=new store(this);this.steps=!!this.actionStore.getSteps?this.actionStore.getSteps():this.actionStore.steps;this.summaryClass=this.actionStore.summaryClass;this.resultsClass=this.actionStore.resultsClass;}}]);return SaleWizardStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'currentAction',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'currentStep',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'currentStepValid',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'actionStore',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'steps',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'summaryClass',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'resultsClass',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'submitting',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_applyDecoratedDescriptor(_class.prototype,'availableActions',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'availableActions'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isInitialStep',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isInitialStep'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isConfirmationStep',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isConfirmationStep'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isActionStep',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isActionStep'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isResultsStep',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isResultsStep'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'breadcrumbs',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'breadcrumbs'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'currentActionStep',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'currentActionStep'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'currentActionInfo',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'currentActionInfo'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'currentStepValidChanged',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'currentStepValidChanged'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isCurrentStepValid',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isCurrentStepValid'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'showPrevious',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'showPrevious'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'showNext',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'showNext'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'showSubmit',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'showSubmit'),_class.prototype)),_class);var saleWizard=new SaleWizardStore({sale:__WEBPACK_IMPORTED_MODULE_2__Sale_stores_SaleStore__["a" /* default */]});/* harmony default export */ __webpack_exports__["a"] = (saleWizard);

/***/ }),
/* 1684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Step1__ = __webpack_require__(1685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Step2__ = __webpack_require__(1731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Step3__ = __webpack_require__(2091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Summary__ = __webpack_require__(2092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_src_app_services_request__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__build_src_app_containers_Sale_RoundSection_stores_RoundEditStore__ = __webpack_require__(473);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var Store=(_class=function(){_createClass(Store,[{key:'rejectedOffers',get:function get(){var _this=this;return this.offers.filter(function(item){return!_this.acceptedOffers.some(function(i){return item.buyerId===i;});}).map(function(i){return i.buyerId;});}},{key:'acceptedOfferDetails',get:function get(){var lookup=this.offers.reduce(function(acc,i){acc[i.buyerId]=i;return acc;},{});return this.acceptedOffers.map(function(o){return lookup[o];});}},{key:'rejectedOfferDetails',get:function get(){var lookup=this.offers.reduce(function(acc,i){acc[i.buyerId]=i;return acc;},{});return this.rejectedOffers.map(function(o){return lookup[o];});}}]);function Store(management){var _this2=this;_classCallCheck(this,Store);_initDefineProp(this,'offers',_descriptor,this);_initDefineProp(this,'eligibleOffers',_descriptor2,this);_initDefineProp(this,'acceptedOffers',_descriptor3,this);_initDefineProp(this,'buyerMessage',_descriptor4,this);this.roundEditStore=null;this.steps=[{key:'offers',title:'Choose offers for next round',implementation:__WEBPACK_IMPORTED_MODULE_2__Step1__["a" /* default */]},{key:'round',title:'Next round details',implementation:__WEBPACK_IMPORTED_MODULE_3__Step2__["a" /* default */]},{key:'message',title:'Message to buyers',implementation:__WEBPACK_IMPORTED_MODULE_4__Step3__["a" /* default */]}];this.summaryClass=__WEBPACK_IMPORTED_MODULE_5__Summary__["a" /* default */];this.handleBuyerMessageChange=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */])(function(value){_this2.buyerMessage=value;});this.offers=management.source.offers.viewModel.offers.map(function(item){return{item:item,buyerId:item.buyerId,name:item.buyer.buyer_lastName+', '+item.buyer.buyer_firstName,submittedValue:item.submittedValue,validity:item.data.offer_validity,status:item.status};});this.eligibleOffers=this.offers.filter(function(item){return item.status!=='block'&&item.status!=='rejected';}).sort(function(a,b){return b.submittedValue-a.submittedValue;});var round=management.source.round.definition;this.roundEditStore=new __WEBPACK_IMPORTED_MODULE_7__build_src_app_containers_Sale_RoundSection_stores_RoundEditStore__["a" /* default */](round,management.source.saleEdit.root.saleConfig,management.source.saleEdit.offerData.timezone,true);}_createClass(Store,[{key:'submit',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(saleId,token){var lookup,round,accepted;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:lookup=this.offers.reduce(function(acc,i){acc[i.buyerId]=i;return acc;},{});round=this.roundEditStore.saveableRound;accepted=this.acceptedOffers.map(function(o){return lookup[o];}).filter(function(o){return o.status==='confirmed'||o.status==='accepted';}).map(function(o){return o.buyerId;});_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_6__build_src_app_services_request__["e" /* post */])('/api/v1/wizard/'+saleId+'/increase',{round:Object.assign({},round,{message:this.buyerMessage}),acceptOffers:accepted,rejectOffers:this.rejectedOffers},token);case 5:case'end':return _context.stop();}}},_callee,this);}));function submit(_x,_x2){return _ref.apply(this,arguments);}return submit;}()}]);return Store;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'offers',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:null}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'eligibleOffers',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:null}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'acceptedOffers',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}}),_applyDecoratedDescriptor(_class.prototype,'rejectedOffers',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'rejectedOffers'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'acceptedOfferDetails',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'acceptedOfferDetails'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'rejectedOfferDetails',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'rejectedOfferDetails'),_class.prototype),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'buyerMessage',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return'';}}),_applyDecoratedDescriptor(_class.prototype,'submit',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'submit'),_class.prototype)),_class);

/***/ }),
/* 1685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_DetailsList__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_src_app_components_Money__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_BaseStep__ = __webpack_require__(68);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var columns=function columns(t){return[{key:'name',name:t('Name'),fieldName:'name',minWidth:150,maxWidth:400,isSorted:true,isSortedDescending:false},{key:'submittedValue',name:t('Submitted value'),fieldName:'submittedValue',minWidth:100,maxWidth:150,isSorted:false,isSortedDescending:false},{key:'validity',name:t('Expiration date'),fieldName:'validity',minWidth:100,maxWidth:150,isSorted:false,isSortedDescending:false}];};var IncreaseStep1=(_dec=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["d" /* inject */])('app'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_4__build_src_app_components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["e" /* observer */])(_class=(_temp=_class2=function(_BaseStep){_inherits(IncreaseStep1,_BaseStep);function IncreaseStep1(props){_classCallCheck(this,IncreaseStep1);var _this=_possibleConstructorReturn(this,(IncreaseStep1.__proto__||Object.getPrototypeOf(IncreaseStep1)).call(this,props));_this.handleRenderItemColumn=function(item,_,column){var t=_this.props.t;var content=item[column.fieldName];switch(column.key){case'name':return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',null,_this.renderBuyerName(item.item));case'validity':return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,content?content.toFormatedDateString():'');case'submittedValue':return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_src_app_components_Money__["a" /* default */],{value:content,defaultValue:content==='hidden'?t(content):content,currency:_this.props.app.currency.code,locale:_this.props.intl.locale});default:return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',null,content);}};_this.handleSelectionChanged=function(){var store=_this.props.store;store.acceptedOffers=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.flatten(_this.selection.getSelection()).map(function(i){return i.buyerId;});};_this.selection=new __WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_DetailsList__["d" /* Selection */]({onSelectionChanged:_this.handleSelectionChanged});_this.selection.setModal(true);return _this;}_createClass(IncreaseStep1,[{key:'render',value:function render(){var _props=this.props,store=_props.store,t=_props.t;var eligibleOffers=store.eligibleOffers;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('ul',{className:'hint'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',null,t('Select customers')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',null,t('All other offers will be rejected')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',null,t('Invite more customers after start of next round'))),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_DetailsList__["b" /* DetailsList */],{columns:columns(t),items:eligibleOffers||[],selection:this.selection,onRenderItemColumn:this.handleRenderItemColumn,enterModalSelectionOnTouch:true,selectionPreservedOnEmptyClick:true,compact:true,layoutMode:__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_DetailsList__["c" /* DetailsListLayoutMode */].justified,selectionMode:__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_DetailsList__["e" /* SelectionMode */].multiple})));}}]);return IncreaseStep1;}(__WEBPACK_IMPORTED_MODULE_6__components_BaseStep__["a" /* default */]),_class2.displayName='IncreaseStep1',_temp))||_class)||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (IncreaseStep1);

/***/ }),
/* 1686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_selection_index__ = __webpack_require__(119);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__utilities_selection_index__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__utilities_selection_index__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GroupedList_GroupedList_types__ = __webpack_require__(667);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DetailsHeader__ = __webpack_require__(668);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DetailsHeader_base__ = __webpack_require__(669);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DetailsHeader_types__ = __webpack_require__(407);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DetailsList__ = __webpack_require__(690);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__DetailsList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DetailsList_base__ = __webpack_require__(691);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DetailsList_types__ = __webpack_require__(149);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_7__DetailsList_types__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__DetailsList_types__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DetailsRow__ = __webpack_require__(692);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DetailsRow_base__ = __webpack_require__(693);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DetailsRowCheck__ = __webpack_require__(405);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DetailsColumn_base__ = __webpack_require__(689);
/* unused harmony namespace reexport */












//# sourceMappingURL=index.js.map

/***/ }),
/* 1687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uifabric_utilities__ = __webpack_require__(61);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__uifabric_utilities__["n"]; });

//# sourceMappingURL=Selection.js.map

/***/ }),
/* 1688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectionZone; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__interfaces__ = __webpack_require__(180);




// Selection definitions:
//
// Anchor index: the point from which a range selection starts.
// Focus index: the point from which layout movement originates from.
//
// These two can differ. Tests:
//
// If you start at index 5
// Shift click to index 10
//    The focus is 10, the anchor is 5.
// If you shift click at index 0
//    The anchor remains at 5, the items between 0 and 5 are selected and everything else is cleared.
// If you click index 8
//    The anchor and focus are set to 8.
var SELECTION_DISABLED_ATTRIBUTE_NAME = 'data-selection-disabled';
var SELECTION_INDEX_ATTRIBUTE_NAME = 'data-selection-index';
var SELECTION_TOGGLE_ATTRIBUTE_NAME = 'data-selection-toggle';
var SELECTION_INVOKE_ATTRIBUTE_NAME = 'data-selection-invoke';
var SELECTALL_TOGGLE_ALL_ATTRIBUTE_NAME = 'data-selection-all-toggle';
var SELECTION_SELECT_ATTRIBUTE_NAME = 'data-selection-select';
/**
 * {@docCategory Selection}
 */
var SelectionZone = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](SelectionZone, _super);
    function SelectionZone() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._root = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        /**
         * In some cases, the consuming scenario requires to set focus on a row without having SelectionZone
         * react to the event. Note that focus events in IE \<= 11 will occur asynchronously after .focus() has
         * been called on an element, so we need a flag to store the idea that we will bypass the "next"
         * focus event that occurs. This method does that.
         */
        _this.ignoreNextFocus = function () {
            _this._handleNextFocus(false);
        };
        _this._onMouseDownCapture = function (ev) {
            if (document.activeElement !== ev.target && !Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["y" /* elementContains */])(document.activeElement, ev.target)) {
                _this.ignoreNextFocus();
                return;
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["y" /* elementContains */])(ev.target, _this._root.current)) {
                return;
            }
            var target = ev.target;
            while (target !== _this._root.current) {
                if (_this._hasAttribute(target, SELECTION_INVOKE_ATTRIBUTE_NAME)) {
                    _this.ignoreNextFocus();
                    break;
                }
                target = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["T" /* getParent */])(target);
            }
        };
        /**
         * When we focus an item, for single/multi select scenarios, we should try to select it immediately
         * as long as the focus did not originate from a mouse down/touch event. For those cases, we handle them
         * specially.
         */
        _this._onFocus = function (ev) {
            var target = ev.target;
            var selection = _this.props.selection;
            var isToggleModifierPressed = _this._isCtrlPressed || _this._isMetaPressed;
            var selectionMode = _this._getSelectionMode();
            if (_this._shouldHandleFocus && selectionMode !== __WEBPACK_IMPORTED_MODULE_3__interfaces__["b" /* SelectionMode */].none) {
                var isToggle = _this._hasAttribute(target, SELECTION_TOGGLE_ATTRIBUTE_NAME);
                var itemRoot = _this._findItemRoot(target);
                if (!isToggle && itemRoot) {
                    var index = _this._getItemIndex(itemRoot);
                    if (isToggleModifierPressed) {
                        // set anchor only.
                        selection.setIndexSelected(index, selection.isIndexSelected(index), true);
                        if (_this.props.enterModalOnTouch && _this._isTouch && selection.setModal) {
                            selection.setModal(true);
                            _this._setIsTouch(false);
                        }
                    }
                    else {
                        if (_this.props.isSelectedOnFocus) {
                            _this._onItemSurfaceClick(ev, index);
                        }
                    }
                }
            }
            _this._handleNextFocus(false);
        };
        _this._onMouseDown = function (ev) {
            _this._updateModifiers(ev);
            var target = ev.target;
            var itemRoot = _this._findItemRoot(target);
            // No-op if selection is disabled
            if (_this._isSelectionDisabled(target)) {
                return;
            }
            while (target !== _this._root.current) {
                if (_this._hasAttribute(target, SELECTALL_TOGGLE_ALL_ATTRIBUTE_NAME)) {
                    break;
                }
                else if (itemRoot) {
                    if (_this._hasAttribute(target, SELECTION_TOGGLE_ATTRIBUTE_NAME)) {
                        break;
                    }
                    else if (_this._hasAttribute(target, SELECTION_INVOKE_ATTRIBUTE_NAME)) {
                        break;
                    }
                    else if ((target === itemRoot || _this._shouldAutoSelect(target)) &&
                        !_this._isShiftPressed &&
                        !_this._isCtrlPressed &&
                        !_this._isMetaPressed) {
                        _this._onInvokeMouseDown(ev, _this._getItemIndex(itemRoot));
                        break;
                    }
                    else if (_this.props.disableAutoSelectOnInputElements &&
                        (target.tagName === 'A' || target.tagName === 'BUTTON' || target.tagName === 'INPUT')) {
                        return;
                    }
                }
                target = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["T" /* getParent */])(target);
            }
        };
        _this._onTouchStartCapture = function (ev) {
            _this._setIsTouch(true);
        };
        _this._onClick = function (ev) {
            _this._updateModifiers(ev);
            var target = ev.target;
            var itemRoot = _this._findItemRoot(target);
            var isSelectionDisabled = _this._isSelectionDisabled(target);
            while (target !== _this._root.current) {
                if (_this._hasAttribute(target, SELECTALL_TOGGLE_ALL_ATTRIBUTE_NAME)) {
                    if (!isSelectionDisabled) {
                        _this._onToggleAllClick(ev);
                    }
                    break;
                }
                else if (itemRoot) {
                    var index = _this._getItemIndex(itemRoot);
                    if (_this._hasAttribute(target, SELECTION_TOGGLE_ATTRIBUTE_NAME)) {
                        if (!isSelectionDisabled) {
                            if (_this._isShiftPressed) {
                                _this._onItemSurfaceClick(ev, index);
                            }
                            else {
                                _this._onToggleClick(ev, index);
                            }
                        }
                        break;
                    }
                    else if (_this._hasAttribute(target, SELECTION_INVOKE_ATTRIBUTE_NAME)) {
                        // Items should be invokable even if selection is disabled.
                        _this._onInvokeClick(ev, index);
                        break;
                    }
                    else if (target === itemRoot) {
                        if (!isSelectionDisabled) {
                            _this._onItemSurfaceClick(ev, index);
                        }
                        break;
                    }
                    else if (target.tagName === 'A' || target.tagName === 'BUTTON' || target.tagName === 'INPUT') {
                        return;
                    }
                }
                target = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["T" /* getParent */])(target);
            }
        };
        _this._onContextMenu = function (ev) {
            var target = ev.target;
            var _a = _this.props, onItemContextMenu = _a.onItemContextMenu, selection = _a.selection;
            if (onItemContextMenu) {
                var itemRoot = _this._findItemRoot(target);
                if (itemRoot) {
                    var index = _this._getItemIndex(itemRoot);
                    _this._onInvokeMouseDown(ev, index);
                    var skipPreventDefault = onItemContextMenu(selection.getItems()[index], index, ev.nativeEvent);
                    // In order to keep back compat, if the value here is undefined, then we should still
                    // call preventDefault(). Only in the case where true is explicitly returned should
                    // the call be skipped.
                    if (!skipPreventDefault) {
                        ev.preventDefault();
                    }
                }
            }
        };
        /**
         * In multi selection, if you double click within an item's root (but not within the invoke element or input elements),
         * we should execute the invoke handler.
         */
        _this._onDoubleClick = function (ev) {
            var target = ev.target;
            var onItemInvoked = _this.props.onItemInvoked;
            var itemRoot = _this._findItemRoot(target);
            if (itemRoot && onItemInvoked && !_this._isInputElement(target)) {
                var index = _this._getItemIndex(itemRoot);
                while (target !== _this._root.current) {
                    if (_this._hasAttribute(target, SELECTION_TOGGLE_ATTRIBUTE_NAME) || _this._hasAttribute(target, SELECTION_INVOKE_ATTRIBUTE_NAME)) {
                        break;
                    }
                    else if (target === itemRoot) {
                        _this._onInvokeClick(ev, index);
                        break;
                    }
                    target = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["T" /* getParent */])(target);
                }
                target = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["T" /* getParent */])(target);
            }
        };
        _this._onKeyDownCapture = function (ev) {
            _this._updateModifiers(ev);
            _this._handleNextFocus(true);
        };
        _this._onKeyDown = function (ev) {
            _this._updateModifiers(ev);
            var target = ev.target;
            var isSelectionDisabled = _this._isSelectionDisabled(target);
            var selection = _this.props.selection;
            var isSelectAllKey = ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].a && (_this._isCtrlPressed || _this._isMetaPressed);
            var isClearSelectionKey = ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].escape;
            // Ignore key downs from input elements.
            if (_this._isInputElement(target)) {
                // A key was pressed while an item in this zone was focused.
                return;
            }
            var selectionMode = _this._getSelectionMode();
            // If ctrl-a is pressed, select all (if all are not already selected.)
            if (isSelectAllKey && selectionMode === __WEBPACK_IMPORTED_MODULE_3__interfaces__["b" /* SelectionMode */].multiple && !selection.isAllSelected()) {
                if (!isSelectionDisabled) {
                    selection.setAllSelected(true);
                }
                ev.stopPropagation();
                ev.preventDefault();
                return;
            }
            // If escape is pressed, clear selection (if any are selected.)
            if (isClearSelectionKey && selection.getSelectedCount() > 0) {
                if (!isSelectionDisabled) {
                    selection.setAllSelected(false);
                }
                ev.stopPropagation();
                ev.preventDefault();
                return;
            }
            var itemRoot = _this._findItemRoot(target);
            // If a key was pressed within an item, we should treat "enters" as invokes and "space" as toggle
            if (itemRoot) {
                var index = _this._getItemIndex(itemRoot);
                while (target !== _this._root.current) {
                    if (_this._hasAttribute(target, SELECTION_TOGGLE_ATTRIBUTE_NAME)) {
                        // For toggle elements, assuming they are rendered as buttons, they will generate a click event,
                        // so we can no-op for any keydowns in this case.
                        break;
                    }
                    else if (_this._shouldAutoSelect(target)) {
                        if (!isSelectionDisabled) {
                            // If the event went to an element which should trigger auto-select, select it and then let
                            // the default behavior kick in.
                            _this._onInvokeMouseDown(ev, index);
                        }
                        break;
                    }
                    else if ((ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].enter || ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].space) &&
                        (target.tagName === 'BUTTON' || target.tagName === 'A' || target.tagName === 'INPUT')) {
                        return false;
                    }
                    else if (target === itemRoot) {
                        if (ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].enter) {
                            // Items should be invokable even if selection is disabled.
                            _this._onInvokeClick(ev, index);
                            ev.preventDefault();
                            return;
                        }
                        else if (ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].space) {
                            if (!isSelectionDisabled) {
                                _this._onToggleClick(ev, index);
                            }
                            ev.preventDefault();
                            return;
                        }
                        break;
                    }
                    target = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["T" /* getParent */])(target);
                }
            }
        };
        return _this;
    }
    SelectionZone.prototype.componentDidMount = function () {
        var win = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["Z" /* getWindow */])(this._root.current);
        // Track the latest modifier keys globally.
        this._events.on(win, 'keydown, keyup', this._updateModifiers, true);
        this._events.on(document, 'click', this._findScrollParentAndTryClearOnEmptyClick);
        this._events.on(document.body, 'touchstart', this._onTouchStartCapture, true);
        this._events.on(document.body, 'touchend', this._onTouchStartCapture, true);
    };
    SelectionZone.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ className: "ms-SelectionZone", ref: this._root, onKeyDown: this._onKeyDown, onMouseDown: this._onMouseDown, onKeyDownCapture: this._onKeyDownCapture, onClick: this._onClick, role: "presentation", onDoubleClick: this._onDoubleClick, onContextMenu: this._onContextMenu }, {
            onMouseDownCapture: this._onMouseDownCapture,
            onFocusCapture: this._onFocus
        }), this.props.children));
    };
    SelectionZone.prototype._isSelectionDisabled = function (target) {
        if (this._getSelectionMode() === __WEBPACK_IMPORTED_MODULE_3__interfaces__["b" /* SelectionMode */].none) {
            return true;
        }
        while (target !== this._root.current) {
            if (this._hasAttribute(target, SELECTION_DISABLED_ATTRIBUTE_NAME)) {
                return true;
            }
            target = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["T" /* getParent */])(target);
        }
        return false;
    };
    SelectionZone.prototype._onToggleAllClick = function (ev) {
        var selection = this.props.selection;
        var selectionMode = this._getSelectionMode();
        if (selectionMode === __WEBPACK_IMPORTED_MODULE_3__interfaces__["b" /* SelectionMode */].multiple) {
            selection.toggleAllSelected();
            ev.stopPropagation();
            ev.preventDefault();
        }
    };
    SelectionZone.prototype._onToggleClick = function (ev, index) {
        var selection = this.props.selection;
        var selectionMode = this._getSelectionMode();
        selection.setChangeEvents(false);
        if (this.props.enterModalOnTouch && this._isTouch && !selection.isIndexSelected(index) && selection.setModal) {
            selection.setModal(true);
            this._setIsTouch(false);
        }
        if (selectionMode === __WEBPACK_IMPORTED_MODULE_3__interfaces__["b" /* SelectionMode */].multiple) {
            selection.toggleIndexSelected(index);
        }
        else if (selectionMode === __WEBPACK_IMPORTED_MODULE_3__interfaces__["b" /* SelectionMode */].single) {
            var isSelected = selection.isIndexSelected(index);
            var isModal = selection.isModal && selection.isModal();
            selection.setAllSelected(false);
            selection.setIndexSelected(index, !isSelected, true);
            if (isModal && selection.setModal) {
                // Since the above call to setAllSelected(false) clears modal state,
                // restore it. This occurs because the SelectionMode of the Selection
                // may differ from the SelectionZone.
                selection.setModal(true);
            }
        }
        else {
            selection.setChangeEvents(true);
            return;
        }
        selection.setChangeEvents(true);
        ev.stopPropagation();
        // NOTE: ev.preventDefault is not called for toggle clicks, because this will kill the browser behavior
        // for checkboxes if you use a checkbox for the toggle.
    };
    SelectionZone.prototype._onInvokeClick = function (ev, index) {
        var _a = this.props, selection = _a.selection, onItemInvoked = _a.onItemInvoked;
        if (onItemInvoked) {
            onItemInvoked(selection.getItems()[index], index, ev.nativeEvent);
            ev.preventDefault();
            ev.stopPropagation();
        }
    };
    SelectionZone.prototype._onItemSurfaceClick = function (ev, index) {
        var selection = this.props.selection;
        var isToggleModifierPressed = this._isCtrlPressed || this._isMetaPressed;
        var selectionMode = this._getSelectionMode();
        if (selectionMode === __WEBPACK_IMPORTED_MODULE_3__interfaces__["b" /* SelectionMode */].multiple) {
            if (this._isShiftPressed && !this._isTabPressed) {
                selection.selectToIndex(index, !isToggleModifierPressed);
            }
            else if (isToggleModifierPressed) {
                selection.toggleIndexSelected(index);
            }
            else {
                this._clearAndSelectIndex(index);
            }
        }
        else if (selectionMode === __WEBPACK_IMPORTED_MODULE_3__interfaces__["b" /* SelectionMode */].single) {
            this._clearAndSelectIndex(index);
        }
    };
    SelectionZone.prototype._onInvokeMouseDown = function (ev, index) {
        var selection = this.props.selection;
        // Only do work if item is not selected.
        if (selection.isIndexSelected(index)) {
            return;
        }
        this._clearAndSelectIndex(index);
    };
    /**
     * To avoid high startup cost of traversing the DOM on component mount,
     * defer finding the scrollable parent until a click interaction.
     *
     * The styles will probably already calculated since we're running in a click handler,
     * so this is less likely to cause layout thrashing then doing it in mount.
     */
    SelectionZone.prototype._findScrollParentAndTryClearOnEmptyClick = function (ev) {
        var scrollParent = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["D" /* findScrollableParent */])(this._root.current);
        // unbind this handler and replace binding with a binding on the actual scrollable parent
        this._events.off(document, 'click', this._findScrollParentAndTryClearOnEmptyClick);
        this._events.on(scrollParent, 'click', this._tryClearOnEmptyClick);
        // If we clicked inside the scrollable parent, call through to the handler on this click.
        if ((scrollParent && ev.target instanceof Node && scrollParent.contains(ev.target)) || scrollParent === ev.target) {
            this._tryClearOnEmptyClick(ev);
        }
    };
    SelectionZone.prototype._tryClearOnEmptyClick = function (ev) {
        if (!this.props.selectionPreservedOnEmptyClick && this._isNonHandledClick(ev.target)) {
            this.props.selection.setAllSelected(false);
        }
    };
    SelectionZone.prototype._clearAndSelectIndex = function (index) {
        var selection = this.props.selection;
        var isAlreadySingleSelected = selection.getSelectedCount() === 1 && selection.isIndexSelected(index);
        if (!isAlreadySingleSelected) {
            selection.setChangeEvents(false);
            selection.setAllSelected(false);
            selection.setIndexSelected(index, true, true);
            if (this.props.enterModalOnTouch && this._isTouch && selection.setModal) {
                selection.setModal(true);
                this._setIsTouch(false);
            }
            selection.setChangeEvents(true);
        }
    };
    /**
     * We need to track the modifier key states so that when focus events occur, which do not contain
     * modifier states in the Event object, we know how to behave.
     */
    SelectionZone.prototype._updateModifiers = function (ev) {
        this._isShiftPressed = ev.shiftKey;
        this._isCtrlPressed = ev.ctrlKey;
        this._isMetaPressed = ev.metaKey;
        var keyCode = ev.keyCode;
        this._isTabPressed = keyCode ? keyCode === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].tab : false;
    };
    SelectionZone.prototype._findItemRoot = function (target) {
        var selection = this.props.selection;
        while (target !== this._root.current) {
            var indexValue = target.getAttribute(SELECTION_INDEX_ATTRIBUTE_NAME);
            var index = Number(indexValue);
            if (indexValue !== null && index >= 0 && index < selection.getItems().length) {
                break;
            }
            target = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["T" /* getParent */])(target);
        }
        if (target === this._root.current) {
            return undefined;
        }
        return target;
    };
    SelectionZone.prototype._getItemIndex = function (itemRoot) {
        return Number(itemRoot.getAttribute(SELECTION_INDEX_ATTRIBUTE_NAME));
    };
    SelectionZone.prototype._shouldAutoSelect = function (element) {
        return this._hasAttribute(element, SELECTION_SELECT_ATTRIBUTE_NAME);
    };
    SelectionZone.prototype._hasAttribute = function (element, attributeName) {
        var isToggle = false;
        while (!isToggle && element !== this._root.current) {
            isToggle = element.getAttribute(attributeName) === 'true';
            element = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["T" /* getParent */])(element);
        }
        return isToggle;
    };
    SelectionZone.prototype._isInputElement = function (element) {
        return element.tagName === 'INPUT' || element.tagName === 'TEXTAREA';
    };
    SelectionZone.prototype._isNonHandledClick = function (element) {
        var doc = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["I" /* getDocument */])();
        if (doc && element) {
            while (element && element !== doc.documentElement) {
                if (Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_11" /* isElementTabbable */])(element)) {
                    return false;
                }
                element = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["T" /* getParent */])(element);
            }
        }
        return true;
    };
    SelectionZone.prototype._handleNextFocus = function (handleFocus) {
        var _this = this;
        if (this._shouldHandleFocusTimeoutId) {
            this._async.clearTimeout(this._shouldHandleFocusTimeoutId);
            this._shouldHandleFocusTimeoutId = undefined;
        }
        this._shouldHandleFocus = handleFocus;
        if (handleFocus) {
            this._async.setTimeout(function () {
                _this._shouldHandleFocus = false;
            }, 100);
        }
    };
    SelectionZone.prototype._setIsTouch = function (isTouch) {
        var _this = this;
        if (this._isTouchTimeoutId) {
            this._async.clearTimeout(this._isTouchTimeoutId);
            this._isTouchTimeoutId = undefined;
        }
        this._isTouch = true;
        if (isTouch) {
            this._async.setTimeout(function () {
                _this._isTouch = false;
            }, 300);
        }
    };
    SelectionZone.prototype._getSelectionMode = function () {
        var selection = this.props.selection;
        var _a = this.props.selectionMode, selectionMode = _a === void 0 ? selection ? selection.mode : __WEBPACK_IMPORTED_MODULE_3__interfaces__["b" /* SelectionMode */].none : _a;
        return selectionMode;
    };
    SelectionZone.defaultProps = {
        isMultiSelectEnabled: true,
        isSelectedOnFocus: true,
        selectionMode: __WEBPACK_IMPORTED_MODULE_3__interfaces__["b" /* SelectionMode */].multiple
    };
    return SelectionZone;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=SelectionZone.js.map

/***/ }),
/* 1689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FocusZone__ = __webpack_require__(1690);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__FocusZone__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FocusZone_types__ = __webpack_require__(670);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__FocusZone_types__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__FocusZone_types__["b"]; });


//# sourceMappingURL=index.js.map

/***/ }),
/* 1690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FocusZone; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FocusZone_types__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__uifabric_merge_styles__ = __webpack_require__(46);





var IS_FOCUSABLE_ATTRIBUTE = 'data-is-focusable';
var IS_ENTER_DISABLED_ATTRIBUTE = 'data-disable-click-on-enter';
var FOCUSZONE_ID_ATTRIBUTE = 'data-focuszone-id';
var TABINDEX = 'tabindex';
var NO_VERTICAL_WRAP = 'data-no-vertical-wrap';
var NO_HORIZONTAL_WRAP = 'data-no-horizontal-wrap';
var LARGE_DISTANCE_FROM_CENTER = 999999999;
var LARGE_NEGATIVE_DISTANCE_FROM_CENTER = -999999999;
var focusZoneStyles;
var focusZoneClass = 'ms-FocusZone';
// Helper function that will return a class for when the root is focused
function getRootClass() {
    if (!focusZoneStyles) {
        focusZoneStyles = Object(__WEBPACK_IMPORTED_MODULE_4__uifabric_merge_styles__["f" /* mergeStyles */])({
            selectors: {
                ':focus': {
                    outline: 'none',
                },
            },
        }, focusZoneClass);
    }
    return focusZoneStyles;
}
var _allInstances = {};
var _outerZones = new Set();
var ALLOWED_INPUT_TYPES = ['text', 'number', 'password', 'email', 'tel', 'url', 'search'];
var ALLOW_VIRTUAL_ELEMENTS = false;
var FocusZone = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](FocusZone, _super);
    function FocusZone(props) {
        var _this = _super.call(this, props) || this;
        _this._disposables = [];
        _this._root = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._onFocus = function (ev) {
            if (_this._portalContainsElement(ev.target)) {
                // If the event target is inside a portal do not process the event.
                return;
            }
            var _a = _this.props, onActiveElementChanged = _a.onActiveElementChanged, doNotAllowFocusEventToPropagate = _a.doNotAllowFocusEventToPropagate, onFocusNotification = _a.onFocusNotification;
            var isImmediateDescendant = _this._isImmediateDescendantOfZone(ev.target);
            var newActiveElement;
            if (onFocusNotification) {
                onFocusNotification();
            }
            if (isImmediateDescendant) {
                newActiveElement = ev.target;
            }
            else {
                var parentElement = ev.target;
                while (parentElement && parentElement !== _this._root.current) {
                    if (Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_11" /* isElementTabbable */])(parentElement) && _this._isImmediateDescendantOfZone(parentElement)) {
                        newActiveElement = parentElement;
                        break;
                    }
                    parentElement = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["T" /* getParent */])(parentElement, ALLOW_VIRTUAL_ELEMENTS);
                }
            }
            var initialElementFocused = !_this._activeElement;
            // If the new active element is a child of this zone and received focus,
            // update alignment an immediate descendant
            if (newActiveElement && newActiveElement !== _this._activeElement) {
                if (isImmediateDescendant || initialElementFocused) {
                    _this._setFocusAlignment(newActiveElement, initialElementFocused);
                }
                _this._activeElement = newActiveElement;
                if (initialElementFocused) {
                    _this._updateTabIndexes();
                }
            }
            if (onActiveElementChanged) {
                onActiveElementChanged(_this._activeElement, ev);
            }
            if (doNotAllowFocusEventToPropagate) {
                ev.stopPropagation();
            }
        };
        _this._onBlur = function () {
            _this._setParkedFocus(false);
        };
        _this._onMouseDown = function (ev) {
            if (_this._portalContainsElement(ev.target)) {
                // If the event target is inside a portal do not process the event.
                return;
            }
            var disabled = _this.props.disabled;
            if (disabled) {
                return;
            }
            var target = ev.target;
            var path = [];
            while (target && target !== _this._root.current) {
                path.push(target);
                target = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["T" /* getParent */])(target, ALLOW_VIRTUAL_ELEMENTS);
            }
            while (path.length) {
                target = path.pop();
                if (target && Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_11" /* isElementTabbable */])(target)) {
                    _this._setActiveElement(target, true);
                }
                if (Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_10" /* isElementFocusZone */])(target)) {
                    // Stop here since the focus zone will take care of its own children.
                    break;
                }
            }
        };
        /**
         * Handle the keystrokes.
         */
        _this._onKeyDown = function (ev) {
            if (_this._portalContainsElement(ev.target)) {
                // If the event target is inside a portal do not process the event.
                return;
            }
            var _a = _this.props, direction = _a.direction, disabled = _a.disabled, isInnerZoneKeystroke = _a.isInnerZoneKeystroke;
            if (disabled) {
                return;
            }
            if (_this.props.onKeyDown) {
                _this.props.onKeyDown(ev);
            }
            // If the default has been prevented, do not process keyboard events.
            if (ev.isDefaultPrevented()) {
                return;
            }
            if (document.activeElement === _this._root.current && _this._isInnerZone) {
                // If this element has focus, it is being controlled by a parent.
                // Ignore the keystroke.
                return;
            }
            if (isInnerZoneKeystroke && isInnerZoneKeystroke(ev) && _this._isImmediateDescendantOfZone(ev.target)) {
                // Try to focus
                var innerZone = _this._getFirstInnerZone();
                if (innerZone) {
                    if (!innerZone.focus(true)) {
                        return;
                    }
                }
                else if (Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_9" /* isElementFocusSubZone */])(ev.target)) {
                    if (!_this.focusElement(Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["S" /* getNextElement */])(ev.target, ev.target.firstChild, true))) {
                        return;
                    }
                }
                else {
                    return;
                }
            }
            else if (ev.altKey) {
                return;
            }
            else {
                switch (ev.which) {
                    case __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].space:
                        if (_this._tryInvokeClickForFocusable(ev.target)) {
                            break;
                        }
                        return;
                    case __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].left:
                        if (direction !== __WEBPACK_IMPORTED_MODULE_2__FocusZone_types__["a" /* FocusZoneDirection */].vertical && _this._moveFocusLeft()) {
                            break;
                        }
                        return;
                    case __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].right:
                        if (direction !== __WEBPACK_IMPORTED_MODULE_2__FocusZone_types__["a" /* FocusZoneDirection */].vertical && _this._moveFocusRight()) {
                            break;
                        }
                        return;
                    case __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].up:
                        if (direction !== __WEBPACK_IMPORTED_MODULE_2__FocusZone_types__["a" /* FocusZoneDirection */].horizontal && _this._moveFocusUp()) {
                            break;
                        }
                        return;
                    case __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].down:
                        if (direction !== __WEBPACK_IMPORTED_MODULE_2__FocusZone_types__["a" /* FocusZoneDirection */].horizontal && _this._moveFocusDown()) {
                            break;
                        }
                        return;
                    case __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].pageDown:
                        if (_this._moveFocusPaging(true)) {
                            break;
                        }
                        return;
                    case __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].pageUp:
                        if (_this._moveFocusPaging(false)) {
                            break;
                        }
                        return;
                    case __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].tab:
                        if (_this.props.allowTabKey ||
                            _this.props.handleTabKey === __WEBPACK_IMPORTED_MODULE_2__FocusZone_types__["b" /* FocusZoneTabbableElements */].all ||
                            (_this.props.handleTabKey === __WEBPACK_IMPORTED_MODULE_2__FocusZone_types__["b" /* FocusZoneTabbableElements */].inputOnly && _this._isElementInput(ev.target))) {
                            var focusChanged = false;
                            _this._processingTabKey = true;
                            if (direction === __WEBPACK_IMPORTED_MODULE_2__FocusZone_types__["a" /* FocusZoneDirection */].vertical ||
                                !_this._shouldWrapFocus(_this._activeElement, NO_HORIZONTAL_WRAP)) {
                                focusChanged = ev.shiftKey ? _this._moveFocusUp() : _this._moveFocusDown();
                            }
                            else if (direction === __WEBPACK_IMPORTED_MODULE_2__FocusZone_types__["a" /* FocusZoneDirection */].horizontal || direction === __WEBPACK_IMPORTED_MODULE_2__FocusZone_types__["a" /* FocusZoneDirection */].bidirectional) {
                                var tabWithDirection = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["V" /* getRTL */])() ? !ev.shiftKey : ev.shiftKey;
                                focusChanged = tabWithDirection ? _this._moveFocusLeft() : _this._moveFocusRight();
                            }
                            _this._processingTabKey = false;
                            if (focusChanged) {
                                break;
                            }
                        }
                        return;
                    case __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].home:
                        if (_this._isElementInput(ev.target) && !_this._shouldInputLoseFocus(ev.target, false)) {
                            return false;
                        }
                        var firstChild = _this._root.current && _this._root.current.firstChild;
                        if (_this._root.current && firstChild && _this.focusElement(Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["S" /* getNextElement */])(_this._root.current, firstChild, true))) {
                            break;
                        }
                        return;
                    case __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].end:
                        if (_this._isElementInput(ev.target) && !_this._shouldInputLoseFocus(ev.target, true)) {
                            return false;
                        }
                        var lastChild = _this._root.current && _this._root.current.lastChild;
                        if (_this._root.current && _this.focusElement(Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["U" /* getPreviousElement */])(_this._root.current, lastChild, true, true, true))) {
                            break;
                        }
                        return;
                    case __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].enter:
                        if (_this._tryInvokeClickForFocusable(ev.target)) {
                            break;
                        }
                        return;
                    default:
                        return;
                }
            }
            ev.preventDefault();
            ev.stopPropagation();
        };
        _this._getHorizontalDistanceFromCenter = function (isForward, activeRect, targetRect) {
            var leftAlignment = _this._focusAlignment.x;
            // ClientRect values can be floats that differ by very small fractions of a decimal.
            // If the difference between top and bottom are within a pixel then we should treat
            // them as equivalent by using Math.floor. For instance 5.2222 and 5.222221 should be equivalent,
            // but without Math.Floor they will be handled incorrectly
            var targetRectTop = Math.floor(targetRect.top);
            var activeRectBottom = Math.floor(activeRect.bottom);
            var targetRectBottom = Math.floor(targetRect.bottom);
            var activeRectTop = Math.floor(activeRect.top);
            var isValidCandidateOnpagingDown = isForward && targetRectTop > activeRectBottom;
            var isValidCandidateOnpagingUp = !isForward && targetRectBottom < activeRectTop;
            if (isValidCandidateOnpagingDown || isValidCandidateOnpagingUp) {
                if (leftAlignment >= targetRect.left && leftAlignment <= targetRect.left + targetRect.width) {
                    return 0;
                }
                return Math.abs(targetRect.left + targetRect.width / 2 - leftAlignment);
            }
            else {
                if (!_this._shouldWrapFocus(_this._activeElement, NO_VERTICAL_WRAP)) {
                    return LARGE_NEGATIVE_DISTANCE_FROM_CENTER;
                }
                return LARGE_DISTANCE_FROM_CENTER;
            }
        };
        // Manage componentRef resolution.
        Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_5" /* initializeComponentRef */])(_this);
        if (false) {
            warnDeprecations('FocusZone', props, {
                rootProps: undefined,
                allowTabKey: 'handleTabKey',
                elementType: 'as',
                ariaDescribedBy: 'aria-describedby',
                ariaLabelledBy: 'aria-labelledby',
            });
        }
        _this._id = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["N" /* getId */])('FocusZone');
        _this._focusAlignment = {
            x: 0,
            y: 0,
        };
        _this._processingTabKey = false;
        return _this;
    }
    /** Used for testing purposes only. */
    FocusZone.getOuterZones = function () {
        return _outerZones.size;
    };
    /**
     * Handle global tab presses so that we can patch tabindexes on the fly.
     * HEADS UP: This must not be an arrow function in order to be referentially equal among instances
     * for ref counting to work correctly!
     */
    FocusZone._onKeyDownCapture = function (ev) {
        if (ev.which === __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].tab) {
            _outerZones.forEach(function (zone) { return zone._updateTabIndexes(); });
        }
    };
    FocusZone.prototype.componentDidMount = function () {
        var root = this._root.current;
        _allInstances[this._id] = this;
        if (root) {
            var windowElement = root.ownerDocument.defaultView;
            var parentElement = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["T" /* getParent */])(root, ALLOW_VIRTUAL_ELEMENTS);
            while (parentElement && parentElement !== document.body && parentElement.nodeType === 1) {
                if (Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_10" /* isElementFocusZone */])(parentElement)) {
                    this._isInnerZone = true;
                    break;
                }
                parentElement = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["T" /* getParent */])(parentElement, ALLOW_VIRTUAL_ELEMENTS);
            }
            if (!this._isInnerZone) {
                _outerZones.add(this);
                if (windowElement && _outerZones.size === 1) {
                    this._disposables.push(Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_18" /* on */])(windowElement, 'keydown', FocusZone._onKeyDownCapture, true));
                }
            }
            this._disposables.push(Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_18" /* on */])(root, 'blur', this._onBlur, true));
            // Assign initial tab indexes so that we can set initial focus as appropriate.
            this._updateTabIndexes();
            if (this.props.defaultActiveElement) {
                this._activeElement = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["I" /* getDocument */])().querySelector(this.props.defaultActiveElement);
                this.focus();
            }
        }
    };
    FocusZone.prototype.componentDidUpdate = function () {
        var root = this._root.current;
        var doc = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["I" /* getDocument */])(root);
        if (doc && this._lastIndexPath && (doc.activeElement === doc.body || doc.activeElement === root)) {
            // The element has been removed after the render, attempt to restore focus.
            var elementToFocus = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["M" /* getFocusableByIndexPath */])(root, this._lastIndexPath);
            if (elementToFocus) {
                this._setActiveElement(elementToFocus, true);
                elementToFocus.focus();
                this._setParkedFocus(false);
            }
            else {
                // We had a focus path to restore, but now that path is unresolvable. Park focus
                // on the container until we can try again.
                this._setParkedFocus(true);
            }
        }
    };
    FocusZone.prototype.componentWillUnmount = function () {
        delete _allInstances[this._id];
        if (!this._isInnerZone) {
            _outerZones.delete(this);
        }
        // Dispose all events.
        this._disposables.forEach(function (d) { return d(); });
        // Clear function references so their closures can be garbage-collected.
        delete this._disposables;
    };
    FocusZone.prototype.render = function () {
        var _a = this.props, rootProps = _a.rootProps, ariaDescribedBy = _a.ariaDescribedBy, ariaLabelledBy = _a.ariaLabelledBy, className = _a.className;
        var divProps = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["R" /* getNativeProps */])(this.props, __WEBPACK_IMPORTED_MODULE_3__Utilities__["_3" /* htmlElementProperties */]);
        var Tag = this.props.as || this.props.elementType || 'div';
        // Note, right before rendering/reconciling proceeds, we need to record if focus
        // was in the zone before the update. This helper will track this and, if focus
        // was actually in the zone, what the index path to the element is at this time.
        // Then, later in componentDidUpdate, we can evaluate if we need to restore it in
        // the case the element was removed.
        this._evaluateFocusBeforeRender();
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Tag, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ role: "presentation", "aria-labelledby": ariaLabelledBy, "aria-describedby": ariaDescribedBy }, divProps, rootProps, { 
            // Once the getClassName correctly memoizes inputs this should
            // be replaced so that className is passed to getRootClass and is included there so
            // the class names will always be in the same order.
            className: Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["t" /* css */])(getRootClass(), className), ref: this._root, "data-focuszone-id": this._id, onKeyDown: this._onKeyDown, onFocus: this._onFocus, onMouseDownCapture: this._onMouseDown }), this.props.children));
    };
    /**
     * Sets focus to the first tabbable item in the zone.
     * @param forceIntoFirstElement - If true, focus will be forced into the first element, even
     * if focus is already in the focus zone.
     * @returns True if focus could be set to an active element, false if no operation was taken.
     */
    FocusZone.prototype.focus = function (forceIntoFirstElement) {
        if (forceIntoFirstElement === void 0) { forceIntoFirstElement = false; }
        if (this._root.current) {
            if (!forceIntoFirstElement && this._root.current.getAttribute(IS_FOCUSABLE_ATTRIBUTE) === 'true' && this._isInnerZone) {
                var ownerZoneElement = this._getOwnerZone(this._root.current);
                if (ownerZoneElement !== this._root.current) {
                    var ownerZone = _allInstances[ownerZoneElement.getAttribute(FOCUSZONE_ID_ATTRIBUTE)];
                    return !!ownerZone && ownerZone.focusElement(this._root.current);
                }
                return false;
            }
            else if (!forceIntoFirstElement &&
                this._activeElement &&
                Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["y" /* elementContains */])(this._root.current, this._activeElement) &&
                Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_11" /* isElementTabbable */])(this._activeElement)) {
                this._activeElement.focus();
                return true;
            }
            else {
                var firstChild = this._root.current.firstChild;
                return this.focusElement(Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["S" /* getNextElement */])(this._root.current, firstChild, true));
            }
        }
        return false;
    };
    /**
     * Sets focus to a specific child element within the zone. This can be used in conjunction with
     * onBeforeFocus to created delayed focus scenarios (like animate the scroll position to the correct
     * location and then focus.)
     * @param element - The child element within the zone to focus.
     * @returns True if focus could be set to an active element, false if no operation was taken.
     */
    FocusZone.prototype.focusElement = function (element) {
        var onBeforeFocus = this.props.onBeforeFocus;
        if (onBeforeFocus && !onBeforeFocus(element)) {
            return false;
        }
        if (element) {
            // when we Set focus to a specific child, we should recalculate the alignment depend on its position
            this._setActiveElement(element);
            if (this._activeElement) {
                this._activeElement.focus();
            }
            return true;
        }
        return false;
    };
    /**
     * Forces horizontal alignment in the context of vertical arrowing to use specific point as the reference, rather than a center based on
     * the last horizontal motion.
     * @param point - the new reference point.
     */
    FocusZone.prototype.setFocusAlignment = function (point) {
        this._focusAlignment = point;
    };
    FocusZone.prototype._evaluateFocusBeforeRender = function () {
        var root = this._root.current;
        var doc = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["I" /* getDocument */])(root);
        if (doc) {
            var focusedElement = doc.activeElement;
            // Only update the index path if we are not parked on the root.
            if (focusedElement !== root) {
                var shouldRestoreFocus = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["y" /* elementContains */])(root, focusedElement, false);
                this._lastIndexPath = shouldRestoreFocus ? Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["J" /* getElementIndexPath */])(root, doc.activeElement) : undefined;
            }
        }
    };
    /**
     * When focus is in the zone at render time but then all focusable elements are removed,
     * we "park" focus temporarily on the root. Once we update with focusable children, we restore
     * focus to the closest path from previous. If the user tabs away from the parked container,
     * we restore focusability to the pre-parked state.
     */
    FocusZone.prototype._setParkedFocus = function (isParked) {
        var root = this._root.current;
        if (root && this._isParked !== isParked) {
            this._isParked = isParked;
            if (isParked) {
                if (!this.props.allowFocusRoot) {
                    this._parkedTabIndex = root.getAttribute('tabindex');
                    root.setAttribute('tabindex', '-1');
                }
                root.focus();
            }
            else {
                if (!this.props.allowFocusRoot) {
                    if (this._parkedTabIndex) {
                        root.setAttribute('tabindex', this._parkedTabIndex);
                        this._parkedTabIndex = undefined;
                    }
                    else {
                        root.removeAttribute('tabindex');
                    }
                }
            }
        }
    };
    FocusZone.prototype._setActiveElement = function (element, forceAlignment) {
        var previousActiveElement = this._activeElement;
        this._activeElement = element;
        if (previousActiveElement) {
            if (Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_10" /* isElementFocusZone */])(previousActiveElement)) {
                this._updateTabIndexes(previousActiveElement);
            }
            previousActiveElement.tabIndex = -1;
        }
        if (this._activeElement) {
            if (!this._focusAlignment || forceAlignment) {
                this._setFocusAlignment(element, true, true);
            }
            this._activeElement.tabIndex = 0;
        }
    };
    /**
     * Walk up the dom try to find a focusable element.
     */
    FocusZone.prototype._tryInvokeClickForFocusable = function (target) {
        if (target === this._root.current) {
            return false;
        }
        do {
            if (target.tagName === 'BUTTON' || target.tagName === 'A' || target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') {
                return false;
            }
            if (this._isImmediateDescendantOfZone(target) &&
                target.getAttribute(IS_FOCUSABLE_ATTRIBUTE) === 'true' &&
                target.getAttribute(IS_ENTER_DISABLED_ATTRIBUTE) !== 'true') {
                Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_22" /* raiseClick */])(target);
                return true;
            }
            target = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["T" /* getParent */])(target, ALLOW_VIRTUAL_ELEMENTS);
        } while (target !== this._root.current);
        return false;
    };
    /**
     * Traverse to find first child zone.
     */
    FocusZone.prototype._getFirstInnerZone = function (rootElement) {
        rootElement = rootElement || this._activeElement || this._root.current;
        if (!rootElement) {
            return null;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_10" /* isElementFocusZone */])(rootElement)) {
            return _allInstances[rootElement.getAttribute(FOCUSZONE_ID_ATTRIBUTE)];
        }
        var child = rootElement.firstElementChild;
        while (child) {
            if (Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_10" /* isElementFocusZone */])(child)) {
                return _allInstances[child.getAttribute(FOCUSZONE_ID_ATTRIBUTE)];
            }
            var match = this._getFirstInnerZone(child);
            if (match) {
                return match;
            }
            child = child.nextElementSibling;
        }
        return null;
    };
    FocusZone.prototype._moveFocus = function (isForward, getDistanceFromCenter, ev, useDefaultWrap) {
        if (useDefaultWrap === void 0) { useDefaultWrap = true; }
        var element = this._activeElement;
        var candidateDistance = -1;
        var candidateElement = undefined;
        var changedFocus = false;
        var isBidirectional = this.props.direction === __WEBPACK_IMPORTED_MODULE_2__FocusZone_types__["a" /* FocusZoneDirection */].bidirectional;
        if (!element || !this._root.current) {
            return false;
        }
        if (this._isElementInput(element)) {
            if (!this._shouldInputLoseFocus(element, isForward)) {
                return false;
            }
        }
        var activeRect = isBidirectional ? element.getBoundingClientRect() : null;
        do {
            element = (isForward ? Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["S" /* getNextElement */])(this._root.current, element) : Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["U" /* getPreviousElement */])(this._root.current, element));
            if (isBidirectional) {
                if (element) {
                    var targetRect = element.getBoundingClientRect();
                    var elementDistance = getDistanceFromCenter(activeRect, targetRect);
                    if (elementDistance === -1 && candidateDistance === -1) {
                        candidateElement = element;
                        break;
                    }
                    if (elementDistance > -1 && (candidateDistance === -1 || elementDistance < candidateDistance)) {
                        candidateDistance = elementDistance;
                        candidateElement = element;
                    }
                    if (candidateDistance >= 0 && elementDistance < 0) {
                        break;
                    }
                }
            }
            else {
                candidateElement = element;
                break;
            }
        } while (element);
        // Focus the closest candidate
        if (candidateElement && candidateElement !== this._activeElement) {
            changedFocus = true;
            this.focusElement(candidateElement);
        }
        else if (this.props.isCircularNavigation && useDefaultWrap) {
            if (isForward) {
                return this.focusElement(Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["S" /* getNextElement */])(this._root.current, this._root.current.firstElementChild, true));
            }
            else {
                return this.focusElement(Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["U" /* getPreviousElement */])(this._root.current, this._root.current.lastElementChild, true, true, true));
            }
        }
        return changedFocus;
    };
    FocusZone.prototype._moveFocusDown = function () {
        var _this = this;
        var targetTop = -1;
        var leftAlignment = this._focusAlignment.x;
        if (this._moveFocus(true, function (activeRect, targetRect) {
            var distance = -1;
            // ClientRect values can be floats that differ by very small fractions of a decimal.
            // If the difference between top and bottom are within a pixel then we should treat
            // them as equivalent by using Math.floor. For instance 5.2222 and 5.222221 should be equivalent,
            // but without Math.Floor they will be handled incorrectly.
            var targetRectTop = Math.floor(targetRect.top);
            var activeRectBottom = Math.floor(activeRect.bottom);
            if (targetRectTop < activeRectBottom) {
                if (!_this._shouldWrapFocus(_this._activeElement, NO_VERTICAL_WRAP)) {
                    return LARGE_NEGATIVE_DISTANCE_FROM_CENTER;
                }
                return LARGE_DISTANCE_FROM_CENTER;
            }
            if ((targetTop === -1 && targetRectTop >= activeRectBottom) || targetRectTop === targetTop) {
                targetTop = targetRectTop;
                if (leftAlignment >= targetRect.left && leftAlignment <= targetRect.left + targetRect.width) {
                    distance = 0;
                }
                else {
                    distance = Math.abs(targetRect.left + targetRect.width / 2 - leftAlignment);
                }
            }
            return distance;
        })) {
            this._setFocusAlignment(this._activeElement, false, true);
            return true;
        }
        return false;
    };
    FocusZone.prototype._moveFocusUp = function () {
        var _this = this;
        var targetTop = -1;
        var leftAlignment = this._focusAlignment.x;
        if (this._moveFocus(false, function (activeRect, targetRect) {
            var distance = -1;
            // ClientRect values can be floats that differ by very small fractions of a decimal.
            // If the difference between top and bottom are within a pixel then we should treat
            // them as equivalent by using Math.floor. For instance 5.2222 and 5.222221 should be equivalent,
            // but without Math.Floor they will be handled incorrectly.
            var targetRectBottom = Math.floor(targetRect.bottom);
            var targetRectTop = Math.floor(targetRect.top);
            var activeRectTop = Math.floor(activeRect.top);
            if (targetRectBottom > activeRectTop) {
                if (!_this._shouldWrapFocus(_this._activeElement, NO_VERTICAL_WRAP)) {
                    return LARGE_NEGATIVE_DISTANCE_FROM_CENTER;
                }
                return LARGE_DISTANCE_FROM_CENTER;
            }
            if ((targetTop === -1 && targetRectBottom <= activeRectTop) || targetRectTop === targetTop) {
                targetTop = targetRectTop;
                if (leftAlignment >= targetRect.left && leftAlignment <= targetRect.left + targetRect.width) {
                    distance = 0;
                }
                else {
                    distance = Math.abs(targetRect.left + targetRect.width / 2 - leftAlignment);
                }
            }
            return distance;
        })) {
            this._setFocusAlignment(this._activeElement, false, true);
            return true;
        }
        return false;
    };
    FocusZone.prototype._moveFocusLeft = function () {
        var _this = this;
        var shouldWrap = this._shouldWrapFocus(this._activeElement, NO_HORIZONTAL_WRAP);
        if (this._moveFocus(Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["V" /* getRTL */])(), function (activeRect, targetRect) {
            var distance = -1;
            var topBottomComparison;
            if (Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["V" /* getRTL */])()) {
                // When in RTL, this comparison should be the same as the one in _moveFocusRight for LTR.
                // Going left at a leftmost rectangle will go down a line instead of up a line like in LTR.
                // This is important, because we want to be comparing the top of the target rect
                // with the bottom of the active rect.
                topBottomComparison = targetRect.top.toFixed(3) < activeRect.bottom.toFixed(3);
            }
            else {
                topBottomComparison = targetRect.bottom.toFixed(3) > activeRect.top.toFixed(3);
            }
            if (topBottomComparison && targetRect.right <= activeRect.right && _this.props.direction !== __WEBPACK_IMPORTED_MODULE_2__FocusZone_types__["a" /* FocusZoneDirection */].vertical) {
                distance = activeRect.right - targetRect.right;
            }
            else {
                if (!shouldWrap) {
                    distance = LARGE_NEGATIVE_DISTANCE_FROM_CENTER;
                }
            }
            return distance;
        }, undefined /*ev*/, shouldWrap)) {
            this._setFocusAlignment(this._activeElement, true, false);
            return true;
        }
        return false;
    };
    FocusZone.prototype._moveFocusRight = function () {
        var _this = this;
        var shouldWrap = this._shouldWrapFocus(this._activeElement, NO_HORIZONTAL_WRAP);
        if (this._moveFocus(!Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["V" /* getRTL */])(), function (activeRect, targetRect) {
            var distance = -1;
            var topBottomComparison;
            if (Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["V" /* getRTL */])()) {
                // When in RTL, this comparison should be the same as the one in _moveFocusLeft for LTR.
                // Going right at a rightmost rectangle will go up a line instead of down a line like in LTR.
                // This is important, because we want to be comparing the bottom of the target rect
                // with the top of the active rect.
                topBottomComparison = targetRect.bottom.toFixed(3) > activeRect.top.toFixed(3);
            }
            else {
                topBottomComparison = targetRect.top.toFixed(3) < activeRect.bottom.toFixed(3);
            }
            if (topBottomComparison && targetRect.left >= activeRect.left && _this.props.direction !== __WEBPACK_IMPORTED_MODULE_2__FocusZone_types__["a" /* FocusZoneDirection */].vertical) {
                distance = targetRect.left - activeRect.left;
            }
            else if (!shouldWrap) {
                distance = LARGE_NEGATIVE_DISTANCE_FROM_CENTER;
            }
            return distance;
        }, undefined /*ev*/, shouldWrap)) {
            this._setFocusAlignment(this._activeElement, true, false);
            return true;
        }
        return false;
    };
    FocusZone.prototype._moveFocusPaging = function (isForward, useDefaultWrap) {
        if (useDefaultWrap === void 0) { useDefaultWrap = true; }
        if (useDefaultWrap === void 0) {
            useDefaultWrap = true;
        }
        var element = this._activeElement;
        if (!element || !this._root.current) {
            return false;
        }
        if (this._isElementInput(element)) {
            if (!this._shouldInputLoseFocus(element, isForward)) {
                return false;
            }
        }
        var scrollableParent = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["D" /* findScrollableParent */])(element);
        if (!scrollableParent) {
            return false;
        }
        var candidateDistance = -1;
        var candidateElement = undefined;
        var targetTop = -1;
        var targetBottom = -1;
        var pagesize = scrollableParent.clientHeight;
        var activeRect = element.getBoundingClientRect();
        do {
            element = isForward ? Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["S" /* getNextElement */])(this._root.current, element) : Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["U" /* getPreviousElement */])(this._root.current, element);
            if (element) {
                var targetRect = element.getBoundingClientRect();
                var targetRectTop = Math.floor(targetRect.top);
                var activeRectBottom = Math.floor(activeRect.bottom);
                var targetRectBottom = Math.floor(targetRect.bottom);
                var activeRectTop = Math.floor(activeRect.top);
                var elementDistance = this._getHorizontalDistanceFromCenter(isForward, activeRect, targetRect);
                var isElementPassedPageSizeOnPagingDown = isForward && targetRectTop > activeRectBottom + pagesize;
                var isElementPassedPageSizeOnPagingUp = !isForward && targetRectBottom < activeRectTop - pagesize;
                if (isElementPassedPageSizeOnPagingDown || isElementPassedPageSizeOnPagingUp) {
                    break;
                }
                if (elementDistance > -1) {
                    // for paging down
                    if (isForward && targetRectTop > targetTop) {
                        targetTop = targetRectTop;
                        candidateDistance = elementDistance;
                        candidateElement = element;
                    }
                    else if (!isForward && targetRectBottom < targetBottom) {
                        // for paging up
                        targetBottom = targetRectBottom;
                        candidateDistance = elementDistance;
                        candidateElement = element;
                    }
                    else {
                        if (candidateDistance === -1 || elementDistance <= candidateDistance) {
                            candidateDistance = elementDistance;
                            candidateElement = element;
                        }
                    }
                }
            }
        } while (element);
        var changedFocus = false;
        // Focus the closest candidate
        if (candidateElement && candidateElement !== this._activeElement) {
            changedFocus = true;
            this.focusElement(candidateElement);
            this._setFocusAlignment(candidateElement, false, true);
        }
        else if (this.props.isCircularNavigation && useDefaultWrap) {
            if (isForward) {
                return this.focusElement(Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["S" /* getNextElement */])(this._root.current, this._root.current.firstElementChild, true));
            }
            return this.focusElement(Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["U" /* getPreviousElement */])(this._root.current, this._root.current.lastElementChild, true, true, true));
        }
        return changedFocus;
    };
    FocusZone.prototype._setFocusAlignment = function (element, isHorizontal, isVertical) {
        if (this.props.direction === __WEBPACK_IMPORTED_MODULE_2__FocusZone_types__["a" /* FocusZoneDirection */].bidirectional && (!this._focusAlignment || isHorizontal || isVertical)) {
            var rect = element.getBoundingClientRect();
            var left = rect.left + rect.width / 2;
            var top_1 = rect.top + rect.height / 2;
            if (!this._focusAlignment) {
                this._focusAlignment = {
                    x: left,
                    y: top_1,
                };
            }
            if (isHorizontal) {
                this._focusAlignment.x = left;
            }
            if (isVertical) {
                this._focusAlignment.y = top_1;
            }
        }
    };
    FocusZone.prototype._isImmediateDescendantOfZone = function (element) {
        return this._getOwnerZone(element) === this._root.current;
    };
    FocusZone.prototype._getOwnerZone = function (element) {
        var parentElement = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["T" /* getParent */])(element, ALLOW_VIRTUAL_ELEMENTS);
        while (parentElement && parentElement !== this._root.current && parentElement !== document.body) {
            if (Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_10" /* isElementFocusZone */])(parentElement)) {
                return parentElement;
            }
            parentElement = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["T" /* getParent */])(parentElement, ALLOW_VIRTUAL_ELEMENTS);
        }
        return parentElement;
    };
    FocusZone.prototype._updateTabIndexes = function (element) {
        if (!element && this._root.current) {
            this._defaultFocusElement = null;
            element = this._root.current;
            if (this._activeElement && !Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["y" /* elementContains */])(element, this._activeElement)) {
                this._activeElement = null;
            }
        }
        // If active element changes state to disabled, set it to null.
        // Otherwise, we lose keyboard accessibility to other elements in focus zone.
        if (this._activeElement && !Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_11" /* isElementTabbable */])(this._activeElement)) {
            this._activeElement = null;
        }
        var childNodes = element && element.children;
        for (var childIndex = 0; childNodes && childIndex < childNodes.length; childIndex++) {
            var child = childNodes[childIndex];
            if (!Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_10" /* isElementFocusZone */])(child)) {
                // If the item is explicitly set to not be focusable then TABINDEX needs to be set to -1.
                if (child.getAttribute && child.getAttribute(IS_FOCUSABLE_ATTRIBUTE) === 'false') {
                    child.setAttribute(TABINDEX, '-1');
                }
                if (Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_11" /* isElementTabbable */])(child)) {
                    if (this.props.disabled) {
                        child.setAttribute(TABINDEX, '-1');
                    }
                    else if (!this._isInnerZone && ((!this._activeElement && !this._defaultFocusElement) || this._activeElement === child)) {
                        this._defaultFocusElement = child;
                        if (child.getAttribute(TABINDEX) !== '0') {
                            child.setAttribute(TABINDEX, '0');
                        }
                    }
                    else if (child.getAttribute(TABINDEX) !== '-1') {
                        child.setAttribute(TABINDEX, '-1');
                    }
                }
                else if (child.tagName === 'svg' && child.getAttribute('focusable') !== 'false') {
                    // Disgusting IE hack. Sad face.
                    child.setAttribute('focusable', 'false');
                }
            }
            else if (child.getAttribute(IS_FOCUSABLE_ATTRIBUTE) === 'true') {
                if (!this._isInnerZone && ((!this._activeElement && !this._defaultFocusElement) || this._activeElement === child)) {
                    this._defaultFocusElement = child;
                    if (child.getAttribute(TABINDEX) !== '0') {
                        child.setAttribute(TABINDEX, '0');
                    }
                }
                else if (child.getAttribute(TABINDEX) !== '-1') {
                    child.setAttribute(TABINDEX, '-1');
                }
            }
            this._updateTabIndexes(child);
        }
    };
    FocusZone.prototype._isElementInput = function (element) {
        if (element && element.tagName && (element.tagName.toLowerCase() === 'input' || element.tagName.toLowerCase() === 'textarea')) {
            return true;
        }
        return false;
    };
    FocusZone.prototype._shouldInputLoseFocus = function (element, isForward) {
        // If a tab was used, we want to focus on the next element.
        if (!this._processingTabKey && element && element.type && ALLOWED_INPUT_TYPES.indexOf(element.type.toLowerCase()) > -1) {
            var selectionStart = element.selectionStart;
            var selectionEnd = element.selectionEnd;
            var isRangeSelected = selectionStart !== selectionEnd;
            var inputValue = element.value;
            // We shouldn't lose focus in the following cases:
            // 1. There is range selected.
            // 2. When selection start is larger than 0 and it is backward.
            // 3. when selection start is not the end of length and it is forward.
            // 4. We press any of the arrow keys when our handleTabKey isn't none or undefined (only losing focus if we hit tab)
            // and if shouldInputLoseFocusOnArrowKey is defined, if scenario prefers to not loose the focus which is determined by calling the
            // callback shouldInputLoseFocusOnArrowKey
            if (isRangeSelected ||
                (selectionStart > 0 && !isForward) ||
                (selectionStart !== inputValue.length && isForward) ||
                (!!this.props.handleTabKey && !(this.props.shouldInputLoseFocusOnArrowKey && this.props.shouldInputLoseFocusOnArrowKey(element)))) {
                return false;
            }
        }
        return true;
    };
    FocusZone.prototype._shouldWrapFocus = function (element, noWrapDataAttribute) {
        return !!this.props.checkForNoWrap ? Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_28" /* shouldWrapFocus */])(element, noWrapDataAttribute) : true;
    };
    /**
     * Returns true if the element is a descendant of the FocusZone through a React portal.
     */
    FocusZone.prototype._portalContainsElement = function (element) {
        return element && !!this._root.current && Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_19" /* portalContainsElement */])(element, this._root.current);
    };
    FocusZone.defaultProps = {
        isCircularNavigation: false,
        direction: __WEBPACK_IMPORTED_MODULE_2__FocusZone_types__["a" /* FocusZoneDirection */].bidirectional,
    };
    return FocusZone;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=FocusZone.js.map

/***/ }),
/* 1691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Icon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icon_base__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Icon_styles__ = __webpack_require__(399);



/**
 * Icons are used for rendering an individual's avatar, presence and details.
 * They are used within the PeoplePicker components.
 */
var Icon = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__Icon_base__["a" /* IconBase */], __WEBPACK_IMPORTED_MODULE_2__Icon_styles__["c" /* getStyles */], undefined, {
    scope: 'Icon'
}, true);
//# sourceMappingURL=Icon.js.map

/***/ }),
/* 1692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utilities__ = __webpack_require__(1);


var GlobalClassNames = {
    root: 'ms-Image',
    rootMaximizeFrame: 'ms-Image--maximizeFrame',
    image: 'ms-Image-image',
    imageCenter: 'ms-Image-image--center',
    imageContain: 'ms-Image-image--contain',
    imageCover: 'ms-Image-image--cover',
    imageCenterContain: 'ms-Image-image--centerContain',
    imageCenterCover: 'ms-Image-image--centerCover',
    imageNone: 'ms-Image-image--none',
    imageLandscape: 'ms-Image-image--landscape',
    imagePortrait: 'ms-Image-image--portrait'
};
var getStyles = function (props) {
    var className = props.className, width = props.width, height = props.height, maximizeFrame = props.maximizeFrame, isLoaded = props.isLoaded, shouldFadeIn = props.shouldFadeIn, shouldStartVisible = props.shouldStartVisible, isLandscape = props.isLandscape, isCenter = props.isCenter, isContain = props.isContain, isCover = props.isCover, isCenterContain = props.isCenterContain, isCenterCover = props.isCenterCover, isNone = props.isNone, isError = props.isError, isNotImageFit = props.isNotImageFit, theme = props.theme;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    var ImageFitStyles = {
        position: 'absolute',
        left: '50% /* @noflip */',
        top: '50%',
        transform: 'translate(-50%,-50%)' // @todo test RTL renders transform: translate(50%,-50%);
    };
    // Cut the mustard using msMaxTouchPoints to detect IE11 which does not support CSS object-fit
    var window = Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["Z" /* getWindow */])();
    var supportsObjectFit = window !== undefined && window.navigator.msMaxTouchPoints === undefined;
    var fallbackObjectFitStyles = (isContain && isLandscape) || (isCover && !isLandscape) ? { width: '100%', height: 'auto' } : { width: 'auto', height: '100%' };
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            {
                overflow: 'hidden'
            },
            maximizeFrame && [
                classNames.rootMaximizeFrame,
                {
                    height: '100%',
                    width: '100%'
                }
            ],
            isLoaded && shouldFadeIn && !shouldStartVisible && __WEBPACK_IMPORTED_MODULE_0__Styling__["a" /* AnimationClassNames */].fadeIn400,
            (isCenter || isContain || isCover || isCenterContain || isCenterCover) && {
                position: 'relative'
            },
            className
        ],
        image: [
            classNames.image,
            {
                display: 'block',
                opacity: 0
            },
            isLoaded && [
                'is-loaded',
                {
                    opacity: 1
                }
            ],
            isCenter && [classNames.imageCenter, ImageFitStyles],
            isContain && [
                classNames.imageContain,
                supportsObjectFit && {
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain'
                },
                !supportsObjectFit && fallbackObjectFitStyles,
                ImageFitStyles
            ],
            isCover && [
                classNames.imageCover,
                supportsObjectFit && {
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                },
                !supportsObjectFit && fallbackObjectFitStyles,
                ImageFitStyles
            ],
            isCenterContain && [
                classNames.imageCenterContain,
                isLandscape && {
                    maxWidth: '100%'
                },
                !isLandscape && {
                    maxHeight: '100%'
                },
                ImageFitStyles
            ],
            isCenterCover && [
                classNames.imageCenterCover,
                isLandscape && {
                    maxHeight: '100%'
                },
                !isLandscape && {
                    maxWidth: '100%'
                },
                ImageFitStyles
            ],
            isNone && [
                classNames.imageNone,
                {
                    width: 'auto',
                    height: 'auto'
                }
            ],
            isNotImageFit && [
                !!width &&
                    !height && {
                    height: 'auto',
                    width: '100%'
                },
                !width &&
                    !!height && {
                    height: '100%',
                    width: 'auto'
                },
                !!width &&
                    !!height && {
                    height: '100%',
                    width: '100%'
                }
            ],
            isLandscape && classNames.imageLandscape,
            !isLandscape && classNames.imagePortrait,
            !isLoaded && 'is-notLoaded',
            shouldFadeIn && 'is-fadeIn',
            isError && 'is-error'
        ]
    };
};
//# sourceMappingURL=Image.styles.js.map

/***/ }),
/* 1693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Image_Image__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Icon_styles__ = __webpack_require__(399);





var ImageIcon = function (props) {
    var className = props.className, imageProps = props.imageProps;
    var nativeProps = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["R" /* getNativeProps */])(props, __WEBPACK_IMPORTED_MODULE_3__Utilities__["_3" /* htmlElementProperties */]);
    var containerProps = props['aria-label']
        ? {}
        : {
            role: 'presentation',
            'aria-hidden': imageProps.alt || imageProps['aria-labelledby'] ? false : true
        };
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, containerProps, nativeProps, { className: Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["t" /* css */])(__WEBPACK_IMPORTED_MODULE_4__Icon_styles__["a" /* MS_ICON */], __WEBPACK_IMPORTED_MODULE_4__Icon_styles__["b" /* classNames */].root, __WEBPACK_IMPORTED_MODULE_4__Icon_styles__["b" /* classNames */].image, className) }),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Image_Image__["a" /* Image */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, imageProps))));
};
//# sourceMappingURL=ImageIcon.js.map

/***/ }),
/* 1694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Layer__ = __webpack_require__(1695);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Layer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Layer_base__ = __webpack_require__(676);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LayerHost__ = __webpack_require__(1699);
/* unused harmony namespace reexport */



//# sourceMappingURL=index.js.map

/***/ }),
/* 1695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Layer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Layer_base__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Layer_styles__ = __webpack_require__(1698);



var Layer = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__Layer_base__["a" /* LayerBase */], __WEBPACK_IMPORTED_MODULE_2__Layer_styles__["a" /* getStyles */], undefined, {
    scope: 'Layer',
    fields: ['hostId', 'theme', 'styles']
});
//# sourceMappingURL=Layer.js.map

/***/ }),
/* 1696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Fabric__ = __webpack_require__(1697);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Fabric__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Fabric_base__ = __webpack_require__(677);
/* unused harmony namespace reexport */


//# sourceMappingURL=index.js.map

/***/ }),
/* 1697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Fabric; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Fabric_base__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Fabric_styles__ = __webpack_require__(678);



var Fabric = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__Fabric_base__["a" /* FabricBase */], __WEBPACK_IMPORTED_MODULE_2__Fabric_styles__["a" /* getStyles */], undefined, {
    scope: 'Fabric'
});
//# sourceMappingURL=Fabric.js.map

/***/ }),
/* 1698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var GlobalClassNames = {
    root: 'ms-Layer',
    rootNoHost: 'ms-Layer--fixed',
    content: 'ms-Layer-content'
};
var getStyles = function (props) {
    var className = props.className, isNotHost = props.isNotHost, theme = props.theme;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            isNotHost && [
                classNames.rootNoHost,
                {
                    position: 'fixed',
                    zIndex: __WEBPACK_IMPORTED_MODULE_0__Styling__["s" /* ZIndexes */].Layer,
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    visibility: 'hidden'
                }
            ],
            className
        ],
        content: [
            classNames.content,
            {
                visibility: 'visible'
            }
        ]
    };
};
//# sourceMappingURL=Layer.styles.js.map

/***/ }),
/* 1699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LayerHost */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Layer_notification__ = __webpack_require__(679);




var LayerHost = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](LayerHost, _super);
    function LayerHost() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LayerHost.prototype.shouldComponentUpdate = function () {
        return false;
    };
    LayerHost.prototype.componentDidMount = function () {
        Object(__WEBPACK_IMPORTED_MODULE_3__Layer_notification__["b" /* notifyHostChanged */])(this.props.id);
    };
    LayerHost.prototype.componentWillUnmount = function () {
        Object(__WEBPACK_IMPORTED_MODULE_3__Layer_notification__["b" /* notifyHostChanged */])(this.props.id);
    };
    LayerHost.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this.props, { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-LayerHost', this.props.className) }));
    };
    return LayerHost;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=LayerHost.js.map

/***/ }),
/* 1700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GroupedList__ = __webpack_require__(1701);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__GroupedList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GroupedList_base__ = __webpack_require__(680);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GroupedList_types__ = __webpack_require__(667);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__GroupedList_types__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GroupHeader__ = __webpack_require__(681);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GroupFooter__ = __webpack_require__(686);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__GroupShowAll__ = __webpack_require__(684);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__GroupSpacer__ = __webpack_require__(107);
/* unused harmony reexport GroupSpacer */







//# sourceMappingURL=index.js.map

/***/ }),
/* 1701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GroupedList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GroupedList_styles__ = __webpack_require__(1702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GroupedList_base__ = __webpack_require__(680);



var GroupedList = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_2__GroupedList_base__["a" /* GroupedListBase */], __WEBPACK_IMPORTED_MODULE_1__GroupedList_styles__["a" /* getStyles */], undefined, {
    scope: 'GroupedList'
});
//# sourceMappingURL=GroupedList.js.map

/***/ }),
/* 1702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var GlobalClassNames = {
    root: 'ms-GroupedList',
    compact: 'ms-GroupedList--Compact',
    group: 'ms-GroupedList-group',
    link: 'ms-Link',
    listCell: 'ms-List-cell'
};
var beziers = {
    easeInOutSine: 'cubic-bezier(0.445, 0.050, 0.550, 0.950)'
};
var getStyles = function (props) {
    var theme = props.theme, className = props.className, compact = props.compact;
    var palette = theme.palette;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            {
                position: 'relative',
                fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].small,
                selectors: (_a = {},
                    _a["." + classNames.listCell] = {
                        minHeight: 38 // be consistent with DetailsList styles
                    },
                    _a)
            },
            compact && [
                classNames.compact,
                {
                    selectors: (_b = {},
                        _b["." + classNames.listCell] = {
                            minHeight: 32 // be consistent with DetailsList styles
                        },
                        _b)
                }
            ],
            className
        ],
        group: [
            classNames.group,
            {
                transition: "background-color " + __WEBPACK_IMPORTED_MODULE_0__Styling__["c" /* AnimationVariables */].durationValue2 + " " + beziers.easeInOutSine
            }
        ],
        groupIsDropping: [
            {
                backgroundColor: palette.neutralLight
            }
        ]
    };
    var _a, _b;
};
//# sourceMappingURL=GroupedList.styles.js.map

/***/ }),
/* 1703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GroupedListSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_selection_index__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GroupHeader__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__GroupShowAll__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__GroupFooter__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__List__ = __webpack_require__(181);









var DEFAULT_DROPPING_CSS_CLASS = 'is-dropping';
var GroupedListSection = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](GroupedListSection, _super);
    function GroupedListSection(props) {
        var _this = _super.call(this, props) || this;
        _this._root = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._list = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._onRenderGroupHeader = function (props) {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__GroupHeader__["a" /* GroupHeader */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, props));
        };
        _this._onRenderGroupShowAll = function (props) {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__GroupShowAll__["a" /* GroupShowAll */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, props));
        };
        _this._onRenderGroupFooter = function (props) {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__GroupFooter__["a" /* GroupFooter */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, props));
        };
        _this._renderSubGroup = function (subGroup, subGroupIndex) {
            var _a = _this.props, dragDropEvents = _a.dragDropEvents, dragDropHelper = _a.dragDropHelper, eventsToRegister = _a.eventsToRegister, getGroupItemLimit = _a.getGroupItemLimit, groupNestingDepth = _a.groupNestingDepth, groupProps = _a.groupProps, items = _a.items, headerProps = _a.headerProps, showAllProps = _a.showAllProps, footerProps = _a.footerProps, listProps = _a.listProps, onRenderCell = _a.onRenderCell, selection = _a.selection, selectionMode = _a.selectionMode, viewport = _a.viewport, onRenderGroupHeader = _a.onRenderGroupHeader, onRenderGroupShowAll = _a.onRenderGroupShowAll, onRenderGroupFooter = _a.onRenderGroupFooter, onShouldVirtualize = _a.onShouldVirtualize, group = _a.group, compact = _a.compact;
            return !subGroup || subGroup.count > 0 || (groupProps && groupProps.showEmptyGroups) ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](GroupedListSection, { ref: 'subGroup_' + subGroupIndex, key: _this._getGroupKey(subGroup, subGroupIndex), dragDropEvents: dragDropEvents, dragDropHelper: dragDropHelper, eventsToRegister: eventsToRegister, footerProps: footerProps, getGroupItemLimit: getGroupItemLimit, group: subGroup, groupIndex: subGroupIndex, groupNestingDepth: groupNestingDepth, groupProps: groupProps, headerProps: headerProps, items: items, listProps: listProps, onRenderCell: onRenderCell, selection: selection, selectionMode: selectionMode, showAllProps: showAllProps, viewport: viewport, onRenderGroupHeader: onRenderGroupHeader, onRenderGroupShowAll: onRenderGroupShowAll, onRenderGroupFooter: onRenderGroupFooter, onShouldVirtualize: onShouldVirtualize, groups: group.children, compact: compact })) : null;
        };
        /**
         * collect all the data we need to enable drag/drop for a group
         */
        _this._getGroupDragDropOptions = function () {
            var _a = _this.props, group = _a.group, groupIndex = _a.groupIndex, dragDropEvents = _a.dragDropEvents, eventsToRegister = _a.eventsToRegister;
            var options = {
                eventMap: eventsToRegister,
                selectionIndex: -1,
                context: { data: group, index: groupIndex, isGroup: true },
                canDrag: function () { return false; },
                canDrop: dragDropEvents.canDrop,
                updateDropState: _this._updateDroppingState
            };
            return options;
        };
        /**
         * update groupIsDropping state based on the input value, which is used to change style during drag and drop
         *
         * @param newValue - new isDropping state value
         * @param event - the event trigger dropping state change which can be dragenter, dragleave etc
         */
        _this._updateDroppingState = function (newIsDropping, event) {
            var isDropping = _this.state.isDropping;
            var dragDropEvents = _this.props.dragDropEvents;
            if (!isDropping) {
                if (dragDropEvents && dragDropEvents.onDragLeave) {
                    dragDropEvents.onDragLeave(event, undefined);
                }
            }
            else {
                if (dragDropEvents && dragDropEvents.onDragEnter) {
                    dragDropEvents.onDragEnter(event, undefined);
                }
            }
            if (isDropping !== newIsDropping) {
                _this.setState({ isDropping: newIsDropping });
            }
        };
        var selection = props.selection, group = props.group;
        _this._id = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["N" /* getId */])('GroupedListSection');
        _this.state = {
            isDropping: false,
            isSelected: selection && group ? selection.isRangeSelected(group.startIndex, group.count) : false
        };
        return _this;
    }
    GroupedListSection.prototype.componentDidMount = function () {
        var _a = this.props, dragDropHelper = _a.dragDropHelper, selection = _a.selection;
        if (dragDropHelper && this._root.current) {
            this._dragDropSubscription = dragDropHelper.subscribe(this._root.current, this._events, this._getGroupDragDropOptions());
        }
        if (selection) {
            this._events.on(selection, __WEBPACK_IMPORTED_MODULE_3__utilities_selection_index__["a" /* SELECTION_CHANGE */], this._onSelectionChange);
        }
    };
    GroupedListSection.prototype.componentWillUnmount = function () {
        if (this._dragDropSubscription) {
            this._dragDropSubscription.dispose();
        }
    };
    GroupedListSection.prototype.componentDidUpdate = function (previousProps) {
        if (this.props.group !== previousProps.group ||
            this.props.groupIndex !== previousProps.groupIndex ||
            this.props.dragDropHelper !== previousProps.dragDropHelper) {
            if (this._dragDropSubscription) {
                this._dragDropSubscription.dispose();
                delete this._dragDropSubscription;
            }
            if (this.props.dragDropHelper && this._root.current) {
                this._dragDropSubscription = this.props.dragDropHelper.subscribe(this._root.current, this._events, this._getGroupDragDropOptions());
            }
        }
    };
    GroupedListSection.prototype.render = function () {
        var _a = this.props, getGroupItemLimit = _a.getGroupItemLimit, group = _a.group, groupIndex = _a.groupIndex, headerProps = _a.headerProps, showAllProps = _a.showAllProps, footerProps = _a.footerProps, viewport = _a.viewport, selectionMode = _a.selectionMode, _b = _a.onRenderGroupHeader, onRenderGroupHeader = _b === void 0 ? this._onRenderGroupHeader : _b, _c = _a.onRenderGroupShowAll, onRenderGroupShowAll = _c === void 0 ? this._onRenderGroupShowAll : _c, _d = _a.onRenderGroupFooter, onRenderGroupFooter = _d === void 0 ? this._onRenderGroupFooter : _d, onShouldVirtualize = _a.onShouldVirtualize, groupedListClassNames = _a.groupedListClassNames, groups = _a.groups, compact = _a.compact, _e = _a.listProps, listProps = _e === void 0 ? {} : _e;
        var isSelected = this.state.isSelected;
        var renderCount = group && getGroupItemLimit ? getGroupItemLimit(group) : Infinity;
        var isShowAllVisible = group && !group.children && !group.isCollapsed && !group.isShowingAll && (group.count > renderCount || group.hasMoreData);
        var hasNestedGroups = group && group.children && group.children.length > 0;
        var version = listProps.version;
        var dividerProps = {
            group: group,
            groupIndex: groupIndex,
            groupLevel: group ? group.level : 0,
            isSelected: isSelected,
            viewport: viewport,
            selectionMode: selectionMode,
            groups: groups,
            compact: compact
        };
        var ariaControlsProps = {
            groupedListId: this._id
        };
        var groupHeaderProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, headerProps, dividerProps, ariaControlsProps);
        var groupShowAllProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, showAllProps, dividerProps);
        var groupFooterProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, footerProps, dividerProps);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: this._root, className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])(groupedListClassNames && groupedListClassNames.group, this._getDroppingClassName()), role: "presentation" },
            onRenderGroupHeader(groupHeaderProps, this._onRenderGroupHeader),
            group && group.isCollapsed ? null : hasNestedGroups ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__List__["a" /* List */], { role: "presentation", ref: this._list, items: group.children, onRenderCell: this._renderSubGroup, getItemCountForPage: this._returnOne, onShouldVirtualize: onShouldVirtualize, version: version, id: this._id })) : (this._onRenderGroup(renderCount)),
            group && group.isCollapsed ? null : isShowAllVisible && onRenderGroupShowAll(groupShowAllProps, this._onRenderGroupShowAll),
            onRenderGroupFooter(groupFooterProps, this._onRenderGroupFooter)));
    };
    GroupedListSection.prototype.forceUpdate = function () {
        _super.prototype.forceUpdate.call(this);
        this.forceListUpdate();
    };
    GroupedListSection.prototype.forceListUpdate = function () {
        var group = this.props.group;
        if (this._list.current) {
            this._list.current.forceUpdate();
            if (group && group.children && group.children.length > 0) {
                var subGroupCount = group.children.length;
                for (var i = 0; i < subGroupCount; i++) {
                    var subGroup = this._list.current.refs['subGroup_' + String(i)];
                    if (subGroup) {
                        subGroup.forceListUpdate();
                    }
                }
            }
        }
        else {
            var subGroup = this.refs['subGroup_' + String(0)];
            if (subGroup) {
                subGroup.forceListUpdate();
            }
        }
    };
    GroupedListSection.prototype._onSelectionChange = function () {
        var _a = this.props, group = _a.group, selection = _a.selection;
        var isSelected = selection.isRangeSelected(group.startIndex, group.count);
        if (isSelected !== this.state.isSelected) {
            this.setState({ isSelected: isSelected });
        }
    };
    GroupedListSection.prototype._onRenderGroupCell = function (onRenderCell, groupNestingDepth) {
        return function (item, itemIndex) {
            return onRenderCell(groupNestingDepth, item, itemIndex);
        };
    };
    GroupedListSection.prototype._onRenderGroup = function (renderCount) {
        var _a = this.props, group = _a.group, items = _a.items, onRenderCell = _a.onRenderCell, listProps = _a.listProps, groupNestingDepth = _a.groupNestingDepth, onShouldVirtualize = _a.onShouldVirtualize;
        var count = group && !group.isShowingAll ? group.count : items.length;
        var startIndex = group ? group.startIndex : 0;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__List__["a" /* List */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ role: "grid", items: items, onRenderCell: this._onRenderGroupCell(onRenderCell, groupNestingDepth), ref: this._list, renderCount: Math.min(count, renderCount), startIndex: startIndex, onShouldVirtualize: onShouldVirtualize, id: this._id }, listProps)));
    };
    GroupedListSection.prototype._returnOne = function () {
        return 1;
    };
    GroupedListSection.prototype._getGroupKey = function (group, index) {
        return 'group-' + (group && group.key ? group.key : String(group.level) + String(index));
    };
    /**
     * get the correct css class to reflect the dropping state for a given group
     *
     * If the group is the current drop target, return the default dropping class name
     * Otherwise, return '';
     *
     */
    GroupedListSection.prototype._getDroppingClassName = function () {
        var isDropping = this.state.isDropping;
        var _a = this.props, group = _a.group, groupedListClassNames = _a.groupedListClassNames;
        isDropping = !!(group && isDropping);
        return Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])(isDropping && DEFAULT_DROPPING_CSS_CLASS, isDropping && groupedListClassNames && groupedListClassNames.groupIsDropping);
    };
    return GroupedListSection;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=GroupedListSection.js.map

/***/ }),
/* 1704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DetailsList_DetailsRow_styles__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GroupSpacer__ = __webpack_require__(107);


// For every group level there is a GroupSpacer added. Importing this const to have the source value in one place.

var GlobalClassNames = {
    root: 'ms-GroupHeader',
    compact: 'ms-GroupHeader--compact',
    check: 'ms-GroupHeader-check',
    dropIcon: 'ms-GroupHeader-dropIcon',
    expand: 'ms-GroupHeader-expand',
    isCollapsed: 'is-collapsed',
    title: 'ms-GroupHeader-title',
    isSelected: 'is-selected',
    iconTag: 'ms-Icon--Tag',
    group: 'ms-GroupedList-group',
    isDropping: 'is-dropping'
};
var beziers = {
    easeOutCirc: 'cubic-bezier(0.075, 0.820, 0.165, 1.000)',
    easeOutSine: 'cubic-bezier(0.390, 0.575, 0.565, 1.000)',
    easeInBack: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)'
};
var getStyles = function (props) {
    var theme = props.theme, className = props.className, selected = props.selected, isCollapsed = props.isCollapsed, compact = props.compact;
    var rowHeight = __WEBPACK_IMPORTED_MODULE_1__DetailsList_DetailsRow_styles__["b" /* DEFAULT_ROW_HEIGHTS */].rowHeight, compactRowHeight = __WEBPACK_IMPORTED_MODULE_1__DetailsList_DetailsRow_styles__["b" /* DEFAULT_ROW_HEIGHTS */].compactRowHeight;
    var cellLeftPadding = __WEBPACK_IMPORTED_MODULE_1__DetailsList_DetailsRow_styles__["a" /* DEFAULT_CELL_STYLE_PROPS */].cellLeftPadding; // padding from the source to align GroupHeader title with DetailsRow's first cell.
    var finalRowHeight = compact ? compactRowHeight : rowHeight;
    var semanticColors = theme.semanticColors, palette = theme.palette;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    var checkExpandResetStyles = [
        Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["v" /* getFocusStyle */])(theme),
        {
            cursor: 'default',
            background: 'none',
            backgroundColor: 'transparent',
            border: 'none',
            padding: 0 // cancel default <button> padding
        }
    ];
    return {
        root: [
            classNames.root,
            Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["v" /* getFocusStyle */])(theme),
            theme.fonts.medium,
            {
                borderBottom: "1px solid " + semanticColors.listBackground,
                cursor: 'default',
                userSelect: 'none',
                selectors: (_a = {
                        ':hover': {
                            background: semanticColors.listItemBackgroundHovered
                        },
                        ':hover $check': {
                            opacity: 1
                        },
                        ':focus $check': {
                            opacity: 1
                        }
                    },
                    _a[":global(." + classNames.group + "." + classNames.isDropping + ")"] = {
                        selectors: {
                            '> $root $dropIcon': {
                                transition: "transform " + __WEBPACK_IMPORTED_MODULE_0__Styling__["c" /* AnimationVariables */].durationValue4 + " " + beziers.easeOutCirc + " opacity " + __WEBPACK_IMPORTED_MODULE_0__Styling__["c" /* AnimationVariables */].durationValue1 + " " + beziers.easeOutSine,
                                transitionDelay: __WEBPACK_IMPORTED_MODULE_0__Styling__["c" /* AnimationVariables */].durationValue3,
                                opacity: 1,
                                transform: "rotate(0.2deg) scale(1);" // rotation prevents jittery motion in IE
                            },
                            $check: {
                                opacity: 0
                            }
                        }
                    },
                    _a)
            },
            selected && [
                classNames.isSelected,
                {
                    background: semanticColors.listItemBackgroundChecked,
                    selectors: {
                        ':hover': {
                            background: semanticColors.listItemBackgroundCheckedHovered
                        },
                        $check: {
                            opacity: 1
                        }
                    }
                }
            ],
            compact && [classNames.compact, { border: 'none' }],
            className
        ],
        groupHeaderContainer: [
            {
                display: 'flex',
                alignItems: 'center',
                height: finalRowHeight
            }
        ],
        headerCount: [
            {
                padding: '0px 4px'
            }
        ],
        check: [
            classNames.check,
            checkExpandResetStyles,
            {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                // paddingTop and marginTop brought from the DetailsRow.styles.ts with explanation below.
                // Ensure that the check cell covers the top border of the cell.
                // This ensures the click target does not leave a spot which would
                // cause other items to be deselected.
                paddingTop: 1,
                marginTop: -1,
                opacity: 0,
                width: '40px',
                height: finalRowHeight,
                selectors: {
                    ':focus': {
                        opacity: 1
                    }
                }
            }
        ],
        expand: [
            classNames.expand,
            checkExpandResetStyles,
            {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: compact ? __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].mediumPlus : 18,
                width: __WEBPACK_IMPORTED_MODULE_2__GroupSpacer__["b" /* SPACER_WIDTH */],
                height: finalRowHeight,
                color: selected ? palette.neutralPrimary : palette.neutralSecondary,
                selectors: {
                    ':hover': {
                        backgroundColor: selected ? palette.neutralQuaternary : palette.neutralLight
                    },
                    ':active': {
                        backgroundColor: selected ? palette.neutralTertiaryAlt : palette.neutralQuaternaryAlt
                    }
                }
            }
        ],
        expandIsCollapsed: [
            isCollapsed
                ? [
                    classNames.isCollapsed,
                    {
                        transform: 'rotate(0deg)',
                        transformOrigin: '50% 50%',
                        transition: 'transform .1s linear'
                    }
                ]
                : {
                    transform: 'rotate(90deg)',
                    transformOrigin: '50% 50%',
                    transition: 'transform .1s linear'
                }
        ],
        title: [
            classNames.title,
            {
                paddingLeft: cellLeftPadding,
                fontSize: compact ? __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].large : __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].xLarge,
                fontWeight: __WEBPACK_IMPORTED_MODULE_0__Styling__["f" /* FontWeights */].semilight,
                cursor: 'pointer',
                outline: 0,
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis'
            }
        ],
        dropIcon: [
            classNames.dropIcon,
            {
                position: 'absolute',
                left: -26,
                fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["j" /* IconFontSizes */].large,
                color: palette.neutralSecondary,
                transition: "transform " + __WEBPACK_IMPORTED_MODULE_0__Styling__["c" /* AnimationVariables */].durationValue2 + " " + beziers.easeInBack + ", opacity " + __WEBPACK_IMPORTED_MODULE_0__Styling__["c" /* AnimationVariables */].durationValue4 + " " + beziers.easeOutSine,
                opacity: 0,
                transform: 'rotate(0.2deg) scale(0.65)',
                transformOrigin: '10px 10px',
                selectors: (_b = {},
                    _b[":global(." + classNames.iconTag + ")"] = {
                        position: 'absolute'
                    },
                    _b)
            }
        ]
    };
    var _a, _b;
};
//# sourceMappingURL=GroupHeader.styles.js.map

/***/ }),
/* 1705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GroupHeaderBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_selection_index__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Check__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__GroupSpacer__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Spinner__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FocusZone__ = __webpack_require__(28);









var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var GroupHeaderBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](GroupHeaderBase, _super);
    function GroupHeaderBase(props) {
        var _this = _super.call(this, props) || this;
        _this._onToggleCollapse = function (ev) {
            var _a = _this.props, group = _a.group, onToggleCollapse = _a.onToggleCollapse, isGroupLoading = _a.isGroupLoading;
            var isCollapsed = _this.state.isCollapsed;
            var newCollapsed = !isCollapsed;
            var newLoadingVisible = !newCollapsed && isGroupLoading && isGroupLoading(group);
            _this.setState({
                isCollapsed: newCollapsed,
                isLoadingVisible: newLoadingVisible
            });
            if (onToggleCollapse) {
                onToggleCollapse(group);
            }
            ev.stopPropagation();
            ev.preventDefault();
        };
        _this._onToggleSelectGroupClick = function (ev) {
            var _a = _this.props, onToggleSelectGroup = _a.onToggleSelectGroup, group = _a.group;
            if (onToggleSelectGroup) {
                onToggleSelectGroup(group);
            }
            ev.preventDefault();
            ev.stopPropagation();
        };
        _this._onHeaderClick = function () {
            var _a = _this.props, group = _a.group, onGroupHeaderClick = _a.onGroupHeaderClick, onToggleSelectGroup = _a.onToggleSelectGroup;
            if (onGroupHeaderClick) {
                onGroupHeaderClick(group);
            }
            else if (onToggleSelectGroup) {
                onToggleSelectGroup(group);
            }
        };
        _this._onRenderTitle = function (props) {
            var group = props.group;
            if (!group) {
                return null;
            }
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: _this._classNames.title },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", null, group.name),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: _this._classNames.headerCount },
                    "(",
                    group.count,
                    group.hasMoreData && '+',
                    ")")));
        };
        _this.state = {
            isCollapsed: (_this.props.group && _this.props.group.isCollapsed),
            isLoadingVisible: false
        };
        return _this;
    }
    GroupHeaderBase.prototype.componentWillReceiveProps = function (newProps) {
        if (newProps.group) {
            var newCollapsed = newProps.group.isCollapsed;
            var isGroupLoading = newProps.isGroupLoading;
            var newLoadingVisible = !newCollapsed && isGroupLoading && isGroupLoading(newProps.group);
            this.setState({
                isCollapsed: newCollapsed || false,
                isLoadingVisible: newLoadingVisible || false
            });
        }
    };
    GroupHeaderBase.prototype.render = function () {
        var _a = this.props, group = _a.group, groupLevel = _a.groupLevel, viewport = _a.viewport, selectionMode = _a.selectionMode, loadingText = _a.loadingText, _b = _a.isSelected, isSelected = _b === void 0 ? false : _b, _c = _a.selected, selected = _c === void 0 ? false : _c, indentWidth = _a.indentWidth, _d = _a.onRenderTitle, onRenderTitle = _d === void 0 ? this._onRenderTitle : _d, _e = _a.isCollapsedGroupSelectVisible, isCollapsedGroupSelectVisible = _e === void 0 ? true : _e, expandButtonProps = _a.expandButtonProps, selectAllButtonProps = _a.selectAllButtonProps, theme = _a.theme, styles = _a.styles, className = _a.className, groupedListId = _a.groupedListId, compact = _a.compact;
        var _f = this.state, isCollapsed = _f.isCollapsed, isLoadingVisible = _f.isLoadingVisible;
        var canSelectGroup = selectionMode === __WEBPACK_IMPORTED_MODULE_3__utilities_selection_index__["c" /* SelectionMode */].multiple;
        var isSelectionCheckVisible = canSelectGroup && (isCollapsedGroupSelectVisible || !(group && group.isCollapsed));
        var currentlySelected = isSelected || selected;
        var isRTL = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["V" /* getRTL */])();
        this._classNames = getClassNames(styles, {
            theme: theme,
            className: className,
            selected: currentlySelected,
            isCollapsed: isCollapsed,
            compact: compact
        });
        if (!group) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.root, style: viewport ? { minWidth: viewport.width } : {}, onClick: this._onHeaderClick, "aria-label": group.ariaLabel || group.name, "data-is-focusable": true },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__FocusZone__["a" /* FocusZone */], { className: this._classNames.groupHeaderContainer, direction: __WEBPACK_IMPORTED_MODULE_8__FocusZone__["b" /* FocusZoneDirection */].horizontal },
                isSelectionCheckVisible ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("button", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ type: "button", className: this._classNames.check, role: "checkbox", "aria-checked": currentlySelected, "data-selection-toggle": true, onClick: this._onToggleSelectGroupClick }, selectAllButtonProps),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Check__["a" /* Check */], { checked: currentlySelected }))) : (selectionMode !== __WEBPACK_IMPORTED_MODULE_3__utilities_selection_index__["c" /* SelectionMode */].none && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__GroupSpacer__["a" /* GroupSpacer */], { indentWidth: indentWidth, count: 1 })),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__GroupSpacer__["a" /* GroupSpacer */], { indentWidth: indentWidth, count: groupLevel }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.dropIcon },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Icon__["Icon"], { iconName: "Tag" })),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("button", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ type: "button", className: this._classNames.expand, onClick: this._onToggleCollapse, "aria-expanded": group ? !group.isCollapsed : undefined, "aria-controls": group && !group.isCollapsed ? groupedListId : undefined }, expandButtonProps),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Icon__["Icon"], { className: this._classNames.expandIsCollapsed, iconName: isRTL ? 'ChevronLeftMed' : 'ChevronRightMed' })),
                onRenderTitle(this.props, this._onRenderTitle),
                isLoadingVisible && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Spinner__["a" /* Spinner */], { label: loadingText }))));
    };
    GroupHeaderBase.defaultProps = {
        expandButtonProps: { 'aria-label': 'expand collapse group' }
    };
    return GroupHeaderBase;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=GroupHeader.base.js.map

/***/ }),
/* 1706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Check__ = __webpack_require__(1707);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Check__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Check__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Check_base__ = __webpack_require__(682);
/* unused harmony namespace reexport */


//# sourceMappingURL=index.js.map

/***/ }),
/* 1707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Check; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCheck; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Check_base__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Check_styles__ = __webpack_require__(402);




var Check = Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_2__Check_base__["a" /* CheckBase */], __WEBPACK_IMPORTED_MODULE_3__Check_styles__["b" /* getStyles */], undefined, {
    scope: 'Check'
}, true);
/**
 * Memoized helper for rendering a Check. Always uses fast icons.
 * @param theme - Theme, so the check can be re-rendered if it changes.
 * @param checked - Whether the check is checked.
 * @param className - Class name for styling the check.
 */
var getCheck = Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["_15" /* memoizeFunction */])(function (theme, checked, className) {
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Check, { theme: theme, checked: checked, className: className, useFastIcons: true });
});
//# sourceMappingURL=Check.js.map

/***/ }),
/* 1708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Spinner__ = __webpack_require__(1709);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Spinner__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Spinner_base__ = __webpack_require__(683);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Spinner_types__ = __webpack_require__(403);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Spinner_types__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 1709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Spinner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Spinner_base__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Spinner_styles__ = __webpack_require__(1710);



var Spinner = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__Spinner_base__["a" /* SpinnerBase */], __WEBPACK_IMPORTED_MODULE_2__Spinner_styles__["a" /* getStyles */], undefined, { scope: 'Spinner' });
//# sourceMappingURL=Spinner.js.map

/***/ }),
/* 1710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Spinner_types__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Styling__ = __webpack_require__(5);


var GlobalClassNames = {
    root: 'ms-Spinner',
    circle: 'ms-Spinner-circle',
    label: 'ms-Spinner-label'
};
var spinAnimation = Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["C" /* keyframes */])({
    '0%': {
        transform: 'rotate(0deg)'
    },
    '100%': {
        transform: 'rotate(360deg)'
    }
});
var getStyles = function (props) {
    var theme = props.theme, size = props.size, className = props.className, labelPosition = props.labelPosition;
    var palette = theme.palette;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
            },
            labelPosition === 'top' && {
                flexDirection: 'column-reverse'
            },
            labelPosition === 'right' && {
                flexDirection: 'row'
            },
            labelPosition === 'left' && {
                flexDirection: 'row-reverse'
            },
            className
        ],
        circle: [
            classNames.circle,
            {
                boxSizing: 'border-box',
                borderRadius: '50%',
                border: '1.5px solid ' + palette.themeLight,
                borderTopColor: palette.themePrimary,
                animationName: spinAnimation,
                animationDuration: '1.3s',
                animationIterationCount: 'infinite',
                animationTimingFunction: 'cubic-bezier(.53,.21,.29,.67)',
                selectors: (_a = {},
                    _a[__WEBPACK_IMPORTED_MODULE_1__Styling__["g" /* HighContrastSelector */]] = {
                        borderTopColor: 'Highlight'
                    },
                    _a)
            },
            size === __WEBPACK_IMPORTED_MODULE_0__Spinner_types__["a" /* SpinnerSize */].xSmall && [
                'ms-Spinner--xSmall',
                {
                    width: 12,
                    height: 12
                }
            ],
            size === __WEBPACK_IMPORTED_MODULE_0__Spinner_types__["a" /* SpinnerSize */].small && [
                'ms-Spinner--small',
                {
                    width: 16,
                    height: 16
                }
            ],
            size === __WEBPACK_IMPORTED_MODULE_0__Spinner_types__["a" /* SpinnerSize */].medium && [
                'ms-Spinner--medium',
                {
                    width: 20,
                    height: 20
                }
            ],
            size === __WEBPACK_IMPORTED_MODULE_0__Spinner_types__["a" /* SpinnerSize */].large && [
                'ms-Spinner--large',
                {
                    width: 28,
                    height: 28
                }
            ]
        ],
        label: [
            classNames.label,
            {
                color: palette.themePrimary,
                margin: '10px 0 0',
                textAlign: 'center'
            },
            labelPosition === 'top' && {
                margin: '0 0 10px'
            },
            labelPosition === 'right' && {
                margin: '0 0 0 10px'
            },
            labelPosition === 'left' && {
                margin: '0 10px 0 0'
            }
        ],
        screenReaderText: __WEBPACK_IMPORTED_MODULE_1__Styling__["B" /* hiddenContentStyle */]
    };
    var _a;
};
//# sourceMappingURL=Spinner.styles.js.map

/***/ }),
/* 1711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var GlobalClassNames = {
    root: 'ms-GroupShowAll',
    link: 'ms-Link'
};
var getStyles = function (props) {
    var theme = props.theme;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            {
                position: 'relative',
                padding: '10px 84px',
                cursor: 'pointer',
                selectors: (_a = {},
                    _a["." + classNames.link] = {
                        fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].small
                    },
                    _a)
            }
        ]
    };
    var _a;
};
//# sourceMappingURL=GroupShowAll.styles.js.map

/***/ }),
/* 1712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GroupShowAllBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GroupSpacer__ = __webpack_require__(107);





var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var GroupShowAllBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](GroupShowAllBase, _super);
    function GroupShowAllBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onSummarizeClick = function (ev) {
            _this.props.onToggleSummarize(_this.props.group);
            ev.stopPropagation();
            ev.preventDefault();
        };
        return _this;
    }
    GroupShowAllBase.prototype.render = function () {
        var _a = this.props, group = _a.group, groupLevel = _a.groupLevel, showAllLinkText = _a.showAllLinkText, styles = _a.styles, theme = _a.theme;
        var classNames = getClassNames(styles, { theme: theme });
        if (group) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.root },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__GroupSpacer__["a" /* GroupSpacer */], { count: groupLevel }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Link__["Link"], { onClick: this._onSummarizeClick }, showAllLinkText)));
        }
        return null;
    };
    GroupShowAllBase.defaultProps = {
        showAllLinkText: 'Show All'
    };
    return GroupShowAllBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=GroupShowAll.base.js.map

/***/ }),
/* 1713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Link__ = __webpack_require__(1714);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Link_base__ = __webpack_require__(685);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Link_base__["a"]; });


//# sourceMappingURL=index.js.map

/***/ }),
/* 1714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Link; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Link_base__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link_styles__ = __webpack_require__(1717);



var Link = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__Link_base__["a" /* LinkBase */], __WEBPACK_IMPORTED_MODULE_2__Link_styles__["a" /* getStyles */], undefined, {
    scope: 'Link'
});
//# sourceMappingURL=Link.js.map

/***/ }),
/* 1715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__KeytipData__ = __webpack_require__(1716);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__KeytipData__["a"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 1716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KeytipData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_keytips_KeytipManager__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_keytips_KeytipUtils__ = __webpack_require__(269);





/**
 * A small element to help the target component correctly read out its aria-describedby for its Keytip
 * {@docCategory Keytips}
 */
var KeytipData = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](KeytipData, _super);
    function KeytipData() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._keytipManager = __WEBPACK_IMPORTED_MODULE_3__utilities_keytips_KeytipManager__["a" /* KeytipManager */].getInstance();
        return _this;
    }
    KeytipData.prototype.componentDidMount = function () {
        // Register Keytip in KeytipManager
        if (this.props.keytipProps) {
            this._uniqueId = this._keytipManager.register(this._getKtpProps());
        }
    };
    KeytipData.prototype.componentWillUnmount = function () {
        // Unregister Keytip in KeytipManager
        this.props.keytipProps && this._keytipManager.unregister(this._getKtpProps(), this._uniqueId);
    };
    KeytipData.prototype.componentDidUpdate = function () {
        // Update Keytip in KeytipManager
        this.props.keytipProps && this._keytipManager.update(this._getKtpProps(), this._uniqueId);
    };
    KeytipData.prototype.render = function () {
        var _a = this.props, children = _a.children, keytipProps = _a.keytipProps, ariaDescribedBy = _a.ariaDescribedBy;
        var nativeKeytipProps = {};
        if (keytipProps) {
            nativeKeytipProps = this._getKtpAttrs(keytipProps, ariaDescribedBy);
        }
        return children(nativeKeytipProps);
    };
    KeytipData.prototype._getKtpProps = function () {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ disabled: this.props.disabled }, this.props.keytipProps);
    };
    /**
     * Gets the aria- and data- attributes to attach to the component
     * @param keytipProps - props for Keytip
     * @param describedByPrepend - ariaDescribedBy value to prepend
     */
    KeytipData.prototype._getKtpAttrs = function (keytipProps, describedByPrepend) {
        if (keytipProps) {
            // Add the parent overflow sequence if necessary
            var newKeytipProps = this._keytipManager.addParentOverflow(keytipProps);
            // Construct aria-describedby and data-ktp-id attributes and return
            var ariaDescribedBy = Object(__WEBPACK_IMPORTED_MODULE_4__utilities_keytips_KeytipUtils__["a" /* getAriaDescribedBy */])(newKeytipProps.keySequences);
            var keySequences = newKeytipProps.keySequences.slice();
            if (newKeytipProps.overflowSetSequence) {
                keySequences = Object(__WEBPACK_IMPORTED_MODULE_4__utilities_keytips_KeytipUtils__["d" /* mergeOverflows */])(keySequences, newKeytipProps.overflowSetSequence);
            }
            var ktpId = Object(__WEBPACK_IMPORTED_MODULE_4__utilities_keytips_KeytipUtils__["e" /* sequencesToID */])(keySequences);
            return {
                'aria-describedby': Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_16" /* mergeAriaAttributeValues */])(describedByPrepend, ariaDescribedBy),
                'data-ktp-target': ktpId,
                'data-ktp-execute-target': ktpId
            };
        }
        return undefined;
    };
    return KeytipData;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=KeytipData.js.map

/***/ }),
/* 1717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var GlobalClassNames = {
    root: 'ms-Link'
};
var getStyles = function (props) {
    var className = props.className, isButton = props.isButton, isDisabled = props.isDisabled, theme = props.theme;
    var semanticColors = theme.semanticColors;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            {
                color: semanticColors.link,
                outline: 'none',
                fontSize: 'inherit',
                fontWeight: 'inherit',
                selectors: (_a = {
                        '.ms-Fabric--isFocusVisible &:focus': {
                            // Can't use getFocusStyle because it doesn't support wrapping links
                            // https://github.com/OfficeDev/office-ui-fabric-react/issues/4883#issuecomment-406743543
                            // A box-shadow allows the focus rect to wrap links that span multiple lines
                            // and helps the focus rect avoid getting clipped.
                            boxShadow: "0 0 0 1px " + theme.palette.neutralSecondary + " inset",
                            selectors: (_b = {},
                                _b[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                                    outline: '1px solid WindowText'
                                },
                                _b)
                        }
                    },
                    _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        // For IE high contrast mode
                        borderBottom: 'none'
                    },
                    _a)
            },
            isButton && {
                background: 'none',
                backgroundColor: 'transparent',
                border: 'none',
                cursor: 'pointer',
                display: 'inline',
                margin: 0,
                overflow: 'inherit',
                padding: 0,
                textAlign: 'left',
                textOverflow: 'inherit',
                userSelect: 'text',
                borderBottom: '1px solid transparent',
                selectors: (_c = {},
                    _c[__WEBPACK_IMPORTED_MODULE_0__Styling__["h" /* HighContrastSelectorBlack */]] = {
                        color: '#FFFF00'
                    },
                    _c[__WEBPACK_IMPORTED_MODULE_0__Styling__["i" /* HighContrastSelectorWhite */]] = {
                        color: '#00009F'
                    },
                    _c)
            },
            !isButton && {
                textDecoration: 'none'
            },
            isDisabled && [
                'is-disabled',
                {
                    color: semanticColors.disabledText,
                    cursor: 'default'
                },
                {
                    selectors: {
                        '&:link, &:visited': {
                            pointerEvents: 'none'
                        }
                    }
                }
            ],
            !isDisabled && {
                selectors: {
                    '&:active, &:hover, &:active:hover': {
                        color: semanticColors.linkHovered,
                        selectors: (_d = {},
                            _d[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                                textDecoration: 'underline'
                            },
                            _d)
                    },
                    '&:focus': {
                        color: semanticColors.link
                    }
                }
            },
            classNames.root,
            className
        ]
    };
    var _a, _b, _c, _d;
};
//# sourceMappingURL=Link.styles.js.map

/***/ }),
/* 1718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var GlobalClassNames = {
    root: 'ms-groupFooter'
};
var getStyles = function (props) {
    var theme = props.theme, className = props.className;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    return {
        root: [
            theme.fonts.medium,
            classNames.root,
            {
                position: 'relative',
                padding: '5px 38px'
            },
            className
        ]
    };
};
//# sourceMappingURL=GroupFooter.styles.js.map

/***/ }),
/* 1719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GroupFooterBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GroupSpacer__ = __webpack_require__(107);




var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var GroupFooterBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](GroupFooterBase, _super);
    function GroupFooterBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GroupFooterBase.prototype.render = function () {
        var _a = this.props, group = _a.group, groupLevel = _a.groupLevel, footerText = _a.footerText, indentWidth = _a.indentWidth, styles = _a.styles, theme = _a.theme;
        var classNames = getClassNames(styles, { theme: theme });
        if (group && footerText) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.root },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__GroupSpacer__["a" /* GroupSpacer */], { indentWidth: indentWidth, count: groupLevel }),
                footerText));
        }
        return null;
    };
    return GroupFooterBase;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=GroupFooter.base.js.map

/***/ }),
/* 1720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List__ = __webpack_require__(1721);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__List__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__List_types__ = __webpack_require__(687);
/* unused harmony namespace reexport */


//# sourceMappingURL=index.js.map

/***/ }),
/* 1721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return List; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__List_types__ = __webpack_require__(687);




var RESIZE_DELAY = 16;
var MIN_SCROLL_UPDATE_DELAY = 100;
var MAX_SCROLL_UPDATE_DELAY = 500;
var IDLE_DEBOUNCE_DELAY = 200;
// The amount of time to wait before declaring that the list isn't scrolling
var DONE_SCROLLING_WAIT = 500;
var DEFAULT_ITEMS_PER_PAGE = 10;
var DEFAULT_PAGE_HEIGHT = 30;
var DEFAULT_RENDERED_WINDOWS_BEHIND = 2;
var DEFAULT_RENDERED_WINDOWS_AHEAD = 2;
var PAGE_KEY_PREFIX = 'page-';
var SPACER_KEY_PREFIX = 'spacer-';
var EMPTY_RECT = {
    top: -1,
    bottom: -1,
    left: -1,
    right: -1,
    width: 0,
    height: 0
};
// Naming expensive measures so that they're named in profiles.
var _measurePageRect = function (element) { return element.getBoundingClientRect(); };
var _measureSurfaceRect = _measurePageRect;
var _measureScrollRect = _measurePageRect;
/**
 * The List renders virtualized pages of items. Each page's item count is determined by the getItemCountForPage callback if
 * provided by the caller, or 10 as default. Each page's height is determined by the getPageHeight callback if provided by
 * the caller, or by cached measurements if available, or by a running average, or a default fallback.
 *
 * The algorithm for rendering pages works like this:
 *
 * 1. Predict visible pages based on "current measure data" (page heights, surface position, visible window)
 * 2. If changes are necessary, apply changes (add/remove pages)
 * 3. For pages that are added, measure the page heights if we need to using getBoundingClientRect
 * 4. If measurements don't match predictions, update measure data and goto step 1 asynchronously
 *
 * Measuring too frequently can pull performance down significantly. To compensate, we cache measured values so that
 * we can avoid re-measuring during operations that should not alter heights, like scrolling.
 *
 * To optimize glass rendering performance, onShouldVirtualize can be set. When onShouldVirtualize return false,
 * List will run in fast mode (not virtualized) to render all items without any measurements to improve page load time. And we
 * start doing measurements and rendering in virtualized mode when items grows larger than this threshold.
 *
 * However, certain operations can make measure data stale. For example, resizing the list, or passing in new props,
 * or forcing an update change cause pages to shrink/grow. When these operations occur, we increment a measureVersion
 * number, which we associate with cached measurements and use to determine if a remeasure should occur.
 */
var List = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](List, _super);
    function List(props) {
        var _this = _super.call(this, props) || this;
        _this._root = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._surface = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._onRenderPage = function (pageProps, defaultRender) {
            var _a = _this.props, onRenderCell = _a.onRenderCell, role = _a.role;
            var _b = pageProps.page, _c = _b.items, items = _c === void 0 ? [] : _c, startIndex = _b.startIndex, divProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __rest */](pageProps, ["page"]);
            // only assign list item role if no role is assigned
            var cellRole = role === undefined ? 'listitem' : 'presentation';
            var cells = [];
            for (var i = 0; i < items.length; i++) {
                var index = startIndex + i;
                var item = items[i];
                var itemKey = _this.props.getKey ? _this.props.getKey(item, index) : item && item.key;
                if (itemKey === null || itemKey === undefined) {
                    itemKey = index;
                }
                cells.push(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { role: cellRole, className: 'ms-List-cell', key: itemKey, "data-list-index": index, "data-automationid": "ListCell" }, onRenderCell && onRenderCell(item, index, _this.state.isScrolling)));
            }
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, divProps), cells);
        };
        _this.state = {
            pages: [],
            isScrolling: false
        };
        _this._estimatedPageHeight = 0;
        _this._totalEstimates = 0;
        _this._requiredWindowsAhead = 0;
        _this._requiredWindowsBehind = 0;
        // Track the measure version for everything.
        _this._measureVersion = 0;
        // Ensure that scrolls are lazy updated.
        _this._onAsyncScroll = _this._async.debounce(_this._onAsyncScroll, MIN_SCROLL_UPDATE_DELAY, {
            leading: false,
            maxWait: MAX_SCROLL_UPDATE_DELAY
        });
        _this._onAsyncIdle = _this._async.debounce(_this._onAsyncIdle, IDLE_DEBOUNCE_DELAY, {
            leading: false
        });
        _this._onAsyncResize = _this._async.debounce(_this._onAsyncResize, RESIZE_DELAY, {
            leading: false
        });
        _this._onScrollingDone = _this._async.debounce(_this._onScrollingDone, DONE_SCROLLING_WAIT, {
            leading: false
        });
        _this._cachedPageHeights = {};
        _this._estimatedPageHeight = 0;
        _this._focusedIndex = -1;
        _this._pageCache = {};
        return _this;
    }
    /**
     * Scroll to the given index. By default will bring the page the specified item is on into the view. If a callback
     * to measure the height of an individual item is specified, will only scroll to bring the specific item into view.
     *
     * Note: with items of variable height and no passed in `getPageHeight` method, the list might jump after scrolling
     * when windows before/ahead are being rendered, and the estimated height is replaced using actual elements.
     *
     * @param index - Index of item to scroll to
     * @param measureItem - Optional callback to measure the height of an individual item
     * @param scrollToMode - Optional defines where in the window the item should be positioned to when scrolling
     */
    List.prototype.scrollToIndex = function (index, measureItem, scrollToMode) {
        if (scrollToMode === void 0) { scrollToMode = __WEBPACK_IMPORTED_MODULE_3__List_types__["a" /* ScrollToMode */].auto; }
        var startIndex = this.props.startIndex;
        var renderCount = this._getRenderCount();
        var endIndex = startIndex + renderCount;
        var allowedRect = this._allowedRect;
        var scrollTop = 0;
        var itemsPerPage = 1;
        for (var itemIndex = startIndex; itemIndex < endIndex; itemIndex += itemsPerPage) {
            var pageSpecification = this._getPageSpecification(itemIndex, allowedRect);
            var pageHeight = pageSpecification.height;
            itemsPerPage = pageSpecification.itemCount;
            var requestedIndexIsInPage = itemIndex <= index && itemIndex + itemsPerPage > index;
            if (requestedIndexIsInPage) {
                // We have found the page. If the user provided a way to measure an individual item, we will try to scroll in just
                // the given item, otherwise we'll only bring the page into view
                if (measureItem && this._scrollElement) {
                    var scrollRect = _measureScrollRect(this._scrollElement);
                    var scrollWindow = {
                        top: this._scrollElement.scrollTop,
                        bottom: this._scrollElement.scrollTop + scrollRect.height
                    };
                    // Adjust for actual item position within page
                    var itemPositionWithinPage = index - itemIndex;
                    for (var itemIndexInPage = 0; itemIndexInPage < itemPositionWithinPage; ++itemIndexInPage) {
                        scrollTop += measureItem(itemIndex + itemIndexInPage);
                    }
                    var scrollBottom = scrollTop + measureItem(index);
                    // If scrollToMode is set to something other than auto, we always want to
                    // scroll the item into a specific position on the page.
                    switch (scrollToMode) {
                        case __WEBPACK_IMPORTED_MODULE_3__List_types__["a" /* ScrollToMode */].top:
                            this._scrollElement.scrollTop = scrollTop;
                            return;
                        case __WEBPACK_IMPORTED_MODULE_3__List_types__["a" /* ScrollToMode */].bottom:
                            this._scrollElement.scrollTop = scrollBottom - scrollRect.height;
                            return;
                        case __WEBPACK_IMPORTED_MODULE_3__List_types__["a" /* ScrollToMode */].center:
                            this._scrollElement.scrollTop = (scrollTop + scrollBottom - scrollRect.height) / 2;
                            return;
                        case __WEBPACK_IMPORTED_MODULE_3__List_types__["a" /* ScrollToMode */].auto:
                        default:
                            break;
                    }
                    var itemIsFullyVisible = scrollTop >= scrollWindow.top && scrollBottom <= scrollWindow.bottom;
                    if (itemIsFullyVisible) {
                        // Item is already visible, do nothing.
                        return;
                    }
                    var itemIsPartiallyAbove = scrollTop < scrollWindow.top;
                    var itemIsPartiallyBelow = scrollBottom > scrollWindow.bottom;
                    if (itemIsPartiallyAbove) {
                        //  We will just scroll to 'scrollTop'
                        //  .------.   - scrollTop
                        //  |Item  |
                        //  | .----|-. - scrollWindow.top
                        //  '------' |
                        //    |      |
                        //    '------'
                    }
                    else if (itemIsPartiallyBelow) {
                        //  Adjust scrollTop position to just bring in the element
                        // .------.  - scrollTop
                        // |      |
                        // | .------.
                        // '-|----' | - scrollWindow.bottom
                        //   | Item |
                        //   '------' - scrollBottom
                        scrollTop = scrollBottom - scrollRect.height;
                    }
                }
                this._scrollElement.scrollTop = scrollTop;
                return;
            }
            scrollTop += pageHeight;
        }
    };
    List.prototype.getStartItemIndexInView = function (measureItem) {
        var pages = this.state.pages || [];
        for (var _i = 0, pages_1 = pages; _i < pages_1.length; _i++) {
            var page = pages_1[_i];
            var isPageVisible = !page.isSpacer && (this._scrollTop || 0) >= page.top && (this._scrollTop || 0) <= page.top + page.height;
            if (isPageVisible) {
                if (!measureItem) {
                    var rowHeight = Math.floor(page.height / page.itemCount);
                    return page.startIndex + Math.floor((this._scrollTop - page.top) / rowHeight);
                }
                else {
                    var totalRowHeight = 0;
                    for (var itemIndex = page.startIndex; itemIndex < page.startIndex + page.itemCount; itemIndex++) {
                        var rowHeight = measureItem(itemIndex);
                        if (page.top + totalRowHeight <= this._scrollTop && this._scrollTop < page.top + totalRowHeight + rowHeight) {
                            return itemIndex;
                        }
                        else {
                            totalRowHeight += rowHeight;
                        }
                    }
                }
            }
        }
        return 0;
    };
    List.prototype.componentDidMount = function () {
        this._updatePages();
        this._measureVersion++;
        this._scrollElement = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["D" /* findScrollableParent */])(this._root.current);
        this._events.on(window, 'resize', this._onAsyncResize);
        if (this._root.current) {
            this._events.on(this._root.current, 'focus', this._onFocus, true);
        }
        if (this._scrollElement) {
            this._events.on(this._scrollElement, 'scroll', this._onScroll);
            this._events.on(this._scrollElement, 'scroll', this._onAsyncScroll);
        }
    };
    List.prototype.componentWillUnmount = function () {
        delete this._scrollElement;
    };
    List.prototype.componentWillReceiveProps = function (newProps) {
        if (newProps.items !== this.props.items ||
            newProps.renderCount !== this.props.renderCount ||
            newProps.startIndex !== this.props.startIndex ||
            newProps.version !== this.props.version) {
            // We have received new items so we want to make sure that initially we only render a single window to
            // fill the currently visible rect, and then later render additional windows.
            this._resetRequiredWindows();
            this._requiredRect = null;
            this._measureVersion++;
            this._invalidatePageCache();
            this._updatePages(newProps);
        }
    };
    List.prototype.shouldComponentUpdate = function (newProps, newState) {
        var oldPages = this.state.pages;
        var newPages = newState.pages;
        var shouldComponentUpdate = false;
        // Update if the page stops scrolling
        if (!newState.isScrolling && this.state.isScrolling) {
            return true;
        }
        if (newProps.version !== this.props.version) {
            return true;
        }
        if (newProps.items === this.props.items && oldPages.length === newPages.length) {
            for (var i = 0; i < oldPages.length; i++) {
                var oldPage = oldPages[i];
                var newPage = newPages[i];
                if (oldPage.key !== newPage.key || oldPage.itemCount !== newPage.itemCount) {
                    shouldComponentUpdate = true;
                    break;
                }
            }
        }
        else {
            shouldComponentUpdate = true;
        }
        return shouldComponentUpdate;
    };
    List.prototype.forceUpdate = function () {
        this._invalidatePageCache();
        // Ensure that when the list is force updated we update the pages first before render.
        this._updateRenderRects(this.props, true);
        this._updatePages();
        this._measureVersion++;
        _super.prototype.forceUpdate.call(this);
    };
    /**
     * Get the current height the list and it's pages.
     */
    List.prototype.getTotalListHeight = function () {
        return this._surfaceRect.height;
    };
    List.prototype.render = function () {
        var _a = this.props, className = _a.className, _b = _a.role, role = _b === void 0 ? 'list' : _b;
        var _c = this.state.pages, pages = _c === void 0 ? [] : _c;
        var pageElements = [];
        var divProps = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["R" /* getNativeProps */])(this.props, __WEBPACK_IMPORTED_MODULE_2__Utilities__["w" /* divProperties */]);
        for (var _i = 0, pages_2 = pages; _i < pages_2.length; _i++) {
            var page = pages_2[_i];
            pageElements.push(this._renderPage(page));
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ ref: this._root }, divProps, { role: pageElements.length > 0 ? role : undefined, className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-List', className) }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: this._surface, className: 'ms-List-surface', role: "presentation" }, pageElements)));
    };
    List.prototype._shouldVirtualize = function (props) {
        if (props === void 0) { props = this.props; }
        var onShouldVirtualize = props.onShouldVirtualize;
        return !onShouldVirtualize || onShouldVirtualize(props);
    };
    /**
     * when props.items change or forceUpdate called, throw away cached pages
     */
    List.prototype._invalidatePageCache = function () {
        this._pageCache = {};
    };
    List.prototype._renderPage = function (page) {
        var usePageCache = this.props.usePageCache;
        var cachedPage;
        // if usePageCache is set and cached page element can be found, just return cached page
        if (usePageCache) {
            cachedPage = this._pageCache[page.key];
            if (cachedPage && cachedPage.pageElement) {
                return cachedPage.pageElement;
            }
        }
        var pageStyle = this._getPageStyle(page);
        var _a = this.props.onRenderPage, onRenderPage = _a === void 0 ? this._onRenderPage : _a;
        var pageElement = onRenderPage({
            page: page,
            className: 'ms-List-page',
            key: page.key,
            ref: page.key,
            style: pageStyle,
            role: 'presentation'
        }, this._onRenderPage);
        // cache the first page for now since it is re-rendered a lot times unnecessarily.
        // todo: a more aggresive caching mechanism is to cache pages constaining the items not changed.
        // now we re-render pages too frequently, for example, props.items increased from 30 to 60, although the
        // first 30 items did not change, we still re-rendered all of them in this props.items change.
        if (usePageCache && page.startIndex === 0) {
            this._pageCache[page.key] = {
                page: page,
                pageElement: pageElement
            };
        }
        return pageElement;
    };
    /** Generate the style object for the page. */
    List.prototype._getPageStyle = function (page) {
        var getPageStyle = this.props.getPageStyle;
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, (getPageStyle ? getPageStyle(page) : {}), (!page.items
            ? {
                height: page.height
            }
            : {}));
    };
    /** Track the last item index focused so that we ensure we keep it rendered. */
    List.prototype._onFocus = function (ev) {
        var target = ev.target;
        while (target !== this._surface.current) {
            var indexString = target.getAttribute('data-list-index');
            if (indexString) {
                this._focusedIndex = Number(indexString);
                break;
            }
            target = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["T" /* getParent */])(target);
        }
    };
    /**
     * Called synchronously to reset the required render range to 0 on scrolling. After async scroll has executed,
     * we will call onAsyncIdle which will reset it back to it's correct value.
     */
    List.prototype._onScroll = function () {
        if (!this.state.isScrolling) {
            this.setState({ isScrolling: true });
        }
        this._resetRequiredWindows();
        this._onScrollingDone();
    };
    List.prototype._resetRequiredWindows = function () {
        this._requiredWindowsAhead = 0;
        this._requiredWindowsBehind = 0;
    };
    /**
     * Debounced method to asynchronously update the visible region on a scroll event.
     */
    List.prototype._onAsyncScroll = function () {
        this._updateRenderRects();
        // Only update pages when the visible rect falls outside of the materialized rect.
        if (!this._materializedRect || !_isContainedWithin(this._requiredRect, this._materializedRect)) {
            this._updatePages();
        }
        else {
            // console.log('requiredRect contained in materialized', this._requiredRect, this._materializedRect);
        }
    };
    /**
     * This is an async debounced method that will try and increment the windows we render. If we can increment
     * either, we increase the amount we render and re-evaluate.
     */
    List.prototype._onAsyncIdle = function () {
        var _a = this.props, renderedWindowsAhead = _a.renderedWindowsAhead, renderedWindowsBehind = _a.renderedWindowsBehind;
        var _b = this, requiredWindowsAhead = _b._requiredWindowsAhead, requiredWindowsBehind = _b._requiredWindowsBehind;
        var windowsAhead = Math.min(renderedWindowsAhead, requiredWindowsAhead + 1);
        var windowsBehind = Math.min(renderedWindowsBehind, requiredWindowsBehind + 1);
        if (windowsAhead !== requiredWindowsAhead || windowsBehind !== requiredWindowsBehind) {
            // console.log('idling', windowsBehind, windowsAhead);
            this._requiredWindowsAhead = windowsAhead;
            this._requiredWindowsBehind = windowsBehind;
            this._updateRenderRects();
            this._updatePages();
        }
        if (renderedWindowsAhead > windowsAhead || renderedWindowsBehind > windowsBehind) {
            // Async increment on next tick.
            this._onAsyncIdle();
        }
    };
    /**
     * Function to call when the list is done scrolling.
     * This function is debounced.
     */
    List.prototype._onScrollingDone = function () {
        this.setState({ isScrolling: false });
    };
    List.prototype._onAsyncResize = function () {
        this.forceUpdate();
    };
    List.prototype._updatePages = function (props) {
        // console.log('updating pages');
        var _this = this;
        if (props === void 0) { props = this.props; }
        if (!this._requiredRect) {
            this._updateRenderRects(props);
        }
        var newListState = this._buildPages(props);
        var oldListPages = this.state.pages;
        this._notifyPageChanges(oldListPages, newListState.pages);
        this.setState(newListState, function () {
            // Multiple updates may have been queued, so the callback will reflect all of them.
            // Re-fetch the current props and states to avoid using a stale props or state captured in the closure.
            var finalProps = _this.props;
            var finalState = _this.state;
            // If we weren't provided with the page height, measure the pages
            if (!finalProps.getPageHeight) {
                // If measured version is invalid since we've updated the DOM
                var heightsChanged = _this._updatePageMeasurements(finalState.pages);
                // On first render, we should re-measure so that we don't get a visual glitch.
                if (heightsChanged) {
                    _this._materializedRect = null;
                    if (!_this._hasCompletedFirstRender) {
                        _this._hasCompletedFirstRender = true;
                        _this._updatePages(finalProps);
                    }
                    else {
                        _this._onAsyncScroll();
                    }
                }
                else {
                    // Enqueue an idle bump.
                    _this._onAsyncIdle();
                }
            }
            else {
                // Enqueue an idle bump
                _this._onAsyncIdle();
            }
            // Notify the caller that rendering the new pages has completed
            if (finalProps.onPagesUpdated) {
                finalProps.onPagesUpdated(finalState.pages);
            }
        });
    };
    /**
     * Notify consumers that the rendered pages have changed
     * @param oldPages - The old pages
     * @param newPages - The new pages
     * @param props - The props to use
     */
    List.prototype._notifyPageChanges = function (oldPages, newPages, props) {
        if (props === void 0) { props = this.props; }
        var onPageAdded = props.onPageAdded, onPageRemoved = props.onPageRemoved;
        if (onPageAdded || onPageRemoved) {
            var renderedIndexes = {};
            for (var _i = 0, oldPages_1 = oldPages; _i < oldPages_1.length; _i++) {
                var page = oldPages_1[_i];
                if (page.items) {
                    renderedIndexes[page.startIndex] = page;
                }
            }
            for (var _a = 0, newPages_1 = newPages; _a < newPages_1.length; _a++) {
                var page = newPages_1[_a];
                if (page.items) {
                    if (!renderedIndexes[page.startIndex]) {
                        this._onPageAdded(page);
                    }
                    else {
                        delete renderedIndexes[page.startIndex];
                    }
                }
            }
            for (var index in renderedIndexes) {
                if (renderedIndexes.hasOwnProperty(index)) {
                    this._onPageRemoved(renderedIndexes[index]);
                }
            }
        }
    };
    List.prototype._updatePageMeasurements = function (pages) {
        var heightChanged = false;
        // when not in virtualize mode, we render all the items without page measurement
        if (!this._shouldVirtualize()) {
            return heightChanged;
        }
        for (var i = 0; i < pages.length; i++) {
            var page = pages[i];
            if (page.items) {
                heightChanged = this._measurePage(page) || heightChanged;
            }
        }
        return heightChanged;
    };
    /**
     * Given a page, measure its dimensions, update cache.
     * @returns True if the height has changed.
     */
    List.prototype._measurePage = function (page) {
        var hasChangedHeight = false;
        var pageElement = this.refs[page.key];
        var cachedHeight = this._cachedPageHeights[page.startIndex];
        // console.log('   * measure attempt', page.startIndex, cachedHeight);
        if (pageElement && this._shouldVirtualize() && (!cachedHeight || cachedHeight.measureVersion !== this._measureVersion)) {
            var newClientRect = {
                width: pageElement.clientWidth,
                height: pageElement.clientHeight
            };
            if (newClientRect.height || newClientRect.width) {
                hasChangedHeight = page.height !== newClientRect.height;
                // console.warn(' *** expensive page measure', page.startIndex, page.height, newClientRect.height);
                page.height = newClientRect.height;
                this._cachedPageHeights[page.startIndex] = {
                    height: newClientRect.height,
                    measureVersion: this._measureVersion
                };
                this._estimatedPageHeight = Math.round((this._estimatedPageHeight * this._totalEstimates + newClientRect.height) / (this._totalEstimates + 1));
                this._totalEstimates++;
            }
        }
        return hasChangedHeight;
    };
    /** Called when a page has been added to the DOM. */
    List.prototype._onPageAdded = function (page) {
        var onPageAdded = this.props.onPageAdded;
        // console.log('page added', page.startIndex, this.state.pages.map(page => page.key).join(', '));
        if (onPageAdded) {
            onPageAdded(page);
        }
    };
    /** Called when a page has been removed from the DOM. */
    List.prototype._onPageRemoved = function (page) {
        var onPageRemoved = this.props.onPageRemoved;
        // console.log('  --- page removed', page.startIndex, this.state.pages.map(page => page.key).join(', '));
        if (onPageRemoved) {
            onPageRemoved(page);
        }
    };
    /** Build up the pages that should be rendered. */
    List.prototype._buildPages = function (props) {
        var renderCount = props.renderCount;
        var items = props.items, startIndex = props.startIndex, getPageHeight = props.getPageHeight;
        renderCount = this._getRenderCount(props);
        var materializedRect = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, EMPTY_RECT);
        var pages = [];
        var itemsPerPage = 1;
        var pageTop = 0;
        var currentSpacer = null;
        var focusedIndex = this._focusedIndex;
        var endIndex = startIndex + renderCount;
        var shouldVirtualize = this._shouldVirtualize(props);
        // First render is very important to track; when we render cells, we have no idea of estimated page height.
        // So we should default to rendering only the first page so that we can get information.
        // However if the user provides a measure function, let's just assume they know the right heights.
        var isFirstRender = this._estimatedPageHeight === 0 && !getPageHeight;
        var allowedRect = this._allowedRect;
        var _loop_1 = function (itemIndex) {
            var pageSpecification = this_1._getPageSpecification(itemIndex, allowedRect);
            var pageHeight = pageSpecification.height;
            var pageData = pageSpecification.data;
            var key = pageSpecification.key;
            itemsPerPage = pageSpecification.itemCount;
            var pageBottom = pageTop + pageHeight - 1;
            var isPageRendered = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["C" /* findIndex */])(this_1.state.pages, function (page) { return !!page.items && page.startIndex === itemIndex; }) > -1;
            var isPageInAllowedRange = !allowedRect || (pageBottom >= allowedRect.top && pageTop <= allowedRect.bottom);
            var isPageInRequiredRange = !this_1._requiredRect || (pageBottom >= this_1._requiredRect.top && pageTop <= this_1._requiredRect.bottom);
            var isPageVisible = (!isFirstRender && (isPageInRequiredRange || (isPageInAllowedRange && isPageRendered))) || !shouldVirtualize;
            var isPageFocused = focusedIndex >= itemIndex && focusedIndex < itemIndex + itemsPerPage;
            var isFirstPage = itemIndex === startIndex;
            // console.log('building page', itemIndex, 'pageTop: ' + pageTop, 'inAllowed: ' +
            // isPageInAllowedRange, 'inRequired: ' + isPageInRequiredRange);
            // Only render whats visible, focused, or first page,
            // or when running in fast rendering mode (not in virtualized mode), we render all current items in pages
            if (isPageVisible || isPageFocused || isFirstPage) {
                if (currentSpacer) {
                    pages.push(currentSpacer);
                    currentSpacer = null;
                }
                var itemsInPage = Math.min(itemsPerPage, endIndex - itemIndex);
                var newPage = this_1._createPage(key, items.slice(itemIndex, itemIndex + itemsInPage), itemIndex, undefined, undefined, pageData);
                newPage.top = pageTop;
                newPage.height = pageHeight;
                if (this_1._visibleRect && this_1._visibleRect.bottom) {
                    newPage.isVisible = pageBottom >= this_1._visibleRect.top && pageTop <= this_1._visibleRect.bottom;
                }
                pages.push(newPage);
                if (isPageInRequiredRange && this_1._allowedRect) {
                    _mergeRect(materializedRect, {
                        top: pageTop,
                        bottom: pageBottom,
                        height: pageHeight,
                        left: allowedRect.left,
                        right: allowedRect.right,
                        width: allowedRect.width
                    });
                }
            }
            else {
                if (!currentSpacer) {
                    currentSpacer = this_1._createPage(SPACER_KEY_PREFIX + itemIndex, undefined, itemIndex, 0, undefined, pageData, true /*isSpacer*/);
                }
                currentSpacer.height = (currentSpacer.height || 0) + (pageBottom - pageTop) + 1;
                currentSpacer.itemCount += itemsPerPage;
            }
            pageTop += pageBottom - pageTop + 1;
            // in virtualized mode, we render need to render first page then break and measure,
            // otherwise, we render all items without measurement to make rendering fast
            if (isFirstRender && shouldVirtualize) {
                return "break";
            }
        };
        var this_1 = this;
        for (var itemIndex = startIndex; itemIndex < endIndex; itemIndex += itemsPerPage) {
            var state_1 = _loop_1(itemIndex);
            if (state_1 === "break")
                break;
        }
        if (currentSpacer) {
            currentSpacer.key = SPACER_KEY_PREFIX + 'end';
            pages.push(currentSpacer);
        }
        this._materializedRect = materializedRect;
        // console.log('materialized: ', materializedRect);
        return {
            pages: pages,
            measureVersion: this._measureVersion
        };
    };
    List.prototype._getPageSpecification = function (itemIndex, visibleRect) {
        var getPageSpecification = this.props.getPageSpecification;
        if (getPageSpecification) {
            var pageData = getPageSpecification(itemIndex, visibleRect);
            var _a = pageData.itemCount, itemCount = _a === void 0 ? this._getItemCountForPage(itemIndex, visibleRect) : _a;
            var _b = pageData.height, height = _b === void 0 ? this._getPageHeight(itemIndex, visibleRect, itemCount) : _b;
            return {
                itemCount: itemCount,
                height: height,
                data: pageData.data,
                key: pageData.key
            };
        }
        else {
            var itemCount = this._getItemCountForPage(itemIndex, visibleRect);
            return {
                itemCount: itemCount,
                height: this._getPageHeight(itemIndex, visibleRect, itemCount)
            };
        }
    };
    /**
     * Get the pixel height of a give page. Will use the props getPageHeight first, and if not provided, fallback to
     * cached height, or estimated page height, or default page height.
     */
    List.prototype._getPageHeight = function (itemIndex, visibleRect, itemsPerPage) {
        if (this.props.getPageHeight) {
            return this.props.getPageHeight(itemIndex, visibleRect, itemsPerPage);
        }
        else {
            var cachedHeight = this._cachedPageHeights[itemIndex];
            return cachedHeight ? cachedHeight.height : this._estimatedPageHeight || DEFAULT_PAGE_HEIGHT;
        }
    };
    List.prototype._getItemCountForPage = function (itemIndex, visibileRect) {
        var itemsPerPage = this.props.getItemCountForPage ? this.props.getItemCountForPage(itemIndex, visibileRect) : DEFAULT_ITEMS_PER_PAGE;
        return itemsPerPage ? itemsPerPage : DEFAULT_ITEMS_PER_PAGE;
    };
    List.prototype._createPage = function (pageKey, items, startIndex, count, style, data, isSpacer) {
        if (startIndex === void 0) { startIndex = -1; }
        if (count === void 0) { count = items ? items.length : 0; }
        if (style === void 0) { style = {}; }
        pageKey = pageKey || PAGE_KEY_PREFIX + startIndex;
        var cachedPage = this._pageCache[pageKey];
        if (cachedPage && cachedPage.page) {
            return cachedPage.page;
        }
        return {
            key: pageKey,
            startIndex: startIndex,
            itemCount: count,
            items: items,
            style: style,
            top: 0,
            height: 0,
            data: data,
            isSpacer: isSpacer || false
        };
    };
    List.prototype._getRenderCount = function (props) {
        var _a = props || this.props, items = _a.items, startIndex = _a.startIndex, renderCount = _a.renderCount;
        return renderCount === undefined ? (items ? items.length - startIndex : 0) : renderCount;
    };
    /** Calculate the visible rect within the list where top: 0 and left: 0 is the top/left of the list. */
    List.prototype._updateRenderRects = function (props, forceUpdate) {
        props = props || this.props;
        var renderedWindowsAhead = props.renderedWindowsAhead, renderedWindowsBehind = props.renderedWindowsBehind;
        var pages = this.state.pages;
        // when not in virtualize mode, we render all items without measurement to optimize page rendering perf
        if (!this._shouldVirtualize(props)) {
            return;
        }
        var surfaceRect = this._surfaceRect || __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, EMPTY_RECT);
        var scrollHeight = this._scrollElement && this._scrollElement.scrollHeight;
        var scrollTop = this._scrollElement ? this._scrollElement.scrollTop : 0;
        // WARNING: EXPENSIVE CALL! We need to know the surface top relative to the window.
        // This needs to be called to recalculate when new pages should be loaded.
        // We check to see how far we've scrolled and if it's further than a third of a page we run it again.
        if (this._surface.current &&
            (forceUpdate ||
                !pages ||
                !this._surfaceRect ||
                !scrollHeight ||
                scrollHeight !== this._scrollHeight ||
                Math.abs(this._scrollTop - scrollTop) > this._estimatedPageHeight / 3)) {
            surfaceRect = this._surfaceRect = _measureSurfaceRect(this._surface.current);
            this._scrollTop = scrollTop;
        }
        // If the scroll height has changed, something in the container likely resized and
        // we should redo the page heights incase their content resized.
        if (forceUpdate || !scrollHeight || scrollHeight !== this._scrollHeight) {
            this._measureVersion++;
        }
        this._scrollHeight = scrollHeight;
        // If the surface is above the container top or below the container bottom, or if this is not the first
        // render return empty rect.
        // The first time the list gets rendered we need to calculate the rectangle. The width of the list is
        // used to calculate the width of the list items.
        var visibleTop = Math.max(0, -surfaceRect.top);
        var win = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["Z" /* getWindow */])(this._root.current);
        var visibleRect = {
            top: visibleTop,
            left: surfaceRect.left,
            bottom: visibleTop + win.innerHeight,
            right: surfaceRect.right,
            width: surfaceRect.width,
            height: win.innerHeight
        };
        // The required/allowed rects are adjusted versions of the visible rect.
        this._requiredRect = _expandRect(visibleRect, this._requiredWindowsBehind, this._requiredWindowsAhead);
        this._allowedRect = _expandRect(visibleRect, renderedWindowsBehind, renderedWindowsAhead);
        // store the visible rect for later use.
        this._visibleRect = visibleRect;
    };
    List.defaultProps = {
        startIndex: 0,
        onRenderCell: function (item, index, containsFocus) { return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null, (item && item.name) || ''); },
        renderedWindowsAhead: DEFAULT_RENDERED_WINDOWS_AHEAD,
        renderedWindowsBehind: DEFAULT_RENDERED_WINDOWS_BEHIND
    };
    return List;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

function _expandRect(rect, pagesBefore, pagesAfter) {
    var top = rect.top - pagesBefore * rect.height;
    var height = rect.height + (pagesBefore + pagesAfter) * rect.height;
    return {
        top: top,
        bottom: top + height,
        height: height,
        left: rect.left,
        right: rect.right,
        width: rect.width
    };
}
function _isContainedWithin(innerRect, outerRect) {
    return (innerRect.top >= outerRect.top &&
        innerRect.left >= outerRect.left &&
        innerRect.bottom <= outerRect.bottom &&
        innerRect.right <= outerRect.right);
}
function _mergeRect(targetRect, newRect) {
    targetRect.top = newRect.top < targetRect.top || targetRect.top === -1 ? newRect.top : targetRect.top;
    targetRect.left = newRect.left < targetRect.left || targetRect.left === -1 ? newRect.left : targetRect.left;
    targetRect.bottom = newRect.bottom > targetRect.bottom || targetRect.bottom === -1 ? newRect.bottom : targetRect.bottom;
    targetRect.right = newRect.right > targetRect.right || targetRect.right === -1 ? newRect.right : targetRect.right;
    targetRect.width = targetRect.right - targetRect.left + 1;
    targetRect.height = targetRect.bottom - targetRect.top + 1;
    return targetRect;
}
//# sourceMappingURL=List.js.map

/***/ }),
/* 1722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DetailsRow_styles__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DetailsHeader_styles__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Check_Check_styles__ = __webpack_require__(402);




var GlobalClassNames = {
    root: 'ms-DetailsRow-check',
    isDisabled: 'ms-DetailsRow-check--isDisabled',
    isHeader: 'ms-DetailsRow-check--isHeader'
};
var getStyles = function (props) {
    var theme = props.theme, className = props.className, isHeader = props.isHeader, selected = props.selected, anySelected = props.anySelected, canSelect = props.canSelect, compact = props.compact, isVisible = props.isVisible, useGlobalCheckHostClass = props.useGlobalCheckHostClass;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    var rowHeight = __WEBPACK_IMPORTED_MODULE_1__DetailsRow_styles__["b" /* DEFAULT_ROW_HEIGHTS */].rowHeight, compactRowHeight = __WEBPACK_IMPORTED_MODULE_1__DetailsRow_styles__["b" /* DEFAULT_ROW_HEIGHTS */].compactRowHeight;
    var height = isHeader ? __WEBPACK_IMPORTED_MODULE_2__DetailsHeader_styles__["a" /* HEADER_HEIGHT */] : compact ? compactRowHeight : rowHeight;
    var isCheckVisible = isVisible || selected || anySelected;
    return {
        root: [classNames.root, className],
        check: [
            !canSelect && classNames.isDisabled,
            isHeader && classNames.isHeader,
            Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["v" /* getFocusStyle */])(theme),
            theme.fonts.small,
            useGlobalCheckHostClass && __WEBPACK_IMPORTED_MODULE_3__Check_Check_styles__["a" /* CheckGlobalClassNames */].checkHost,
            {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'default',
                boxSizing: 'border-box',
                verticalAlign: 'top',
                background: 'none',
                backgroundColor: 'transparent',
                border: 'none',
                opacity: isCheckVisible ? 1 : 0,
                height: height,
                width: 40,
                padding: 0,
                margin: 0
            },
            useGlobalCheckHostClass && {
                selectors: {
                    '&:hover': {
                        opacity: 1
                    }
                }
            }
        ],
        isDisabled: []
    };
};
//# sourceMappingURL=DetailsRowCheck.styles.js.map

/***/ }),
/* 1723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DragDropHelper__ = __webpack_require__(688);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__DragDropHelper__["a"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 1724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DetailsColumn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DetailsColumn_base__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DetailsColumn_styles__ = __webpack_require__(1725);



var DetailsColumn = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__DetailsColumn_base__["a" /* DetailsColumnBase */], __WEBPACK_IMPORTED_MODULE_2__DetailsColumn_styles__["a" /* getStyles */], undefined, { scope: 'DetailsColumn' });
//# sourceMappingURL=DetailsColumn.js.map

/***/ }),
/* 1725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DetailsRow_styles__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DetailsHeader_styles__ = __webpack_require__(406);




var GlobalClassNames = {
    isActionable: 'is-actionable',
    cellIsCheck: 'ms-DetailsHeader-cellIsCheck',
    collapseButton: 'ms-DetailsHeader-collapseButton',
    isCollapsed: 'is-collapsed',
    isAllSelected: 'is-allSelected',
    isSelectAllHidden: 'is-selectAllHidden',
    isResizingColumn: 'is-resizingColumn',
    isEmpty: 'is-empty',
    isIconVisible: 'is-icon-visible',
    cellSizer: 'ms-DetailsHeader-cellSizer',
    isResizing: 'is-resizing',
    dropHintCircleStyle: 'ms-DetailsHeader-dropHintCircleStyle',
    dropHintLineStyle: 'ms-DetailsHeader-dropHintLineStyle',
    cellTitle: 'ms-DetailsHeader-cellTitle',
    cellName: 'ms-DetailsHeader-cellName',
    filterChevron: 'ms-DetailsHeader-filterChevron',
    gripperBarVerticalStyle: 'ms-DetailsColumn-gripperBar'
};
var getStyles = function (props) {
    var theme = props.theme, headerClassName = props.headerClassName, iconClassName = props.iconClassName, isActionable = props.isActionable, isEmpty = props.isEmpty, isIconVisible = props.isIconVisible, isPadded = props.isPadded, isIconOnly = props.isIconOnly, _a = props.cellStyleProps, cellStyleProps = _a === void 0 ? __WEBPACK_IMPORTED_MODULE_2__DetailsRow_styles__["a" /* DEFAULT_CELL_STYLE_PROPS */] : _a, transitionDurationDrag = props.transitionDurationDrag, transitionDurationDrop = props.transitionDurationDrop;
    var semanticColors = theme.semanticColors, palette = theme.palette;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    var colors = {
        iconForegroundColor: semanticColors.bodySubtext,
        headerForegroundColor: semanticColors.bodyText,
        headerBackgroundColor: semanticColors.bodyBackground,
        dropdownChevronForegroundColor: palette.neutralTertiary,
        resizerColor: palette.neutralTertiaryAlt
    };
    var nearIconStyle = {
        color: colors.iconForegroundColor,
        opacity: 1,
        paddingLeft: 8
    };
    var borderWhileDragging = {
        outline: "1px solid " + palette.themePrimary
    };
    var borderAfterDragOrDrop = {
        outlineColor: 'transparent'
    };
    return {
        root: [
            Object(__WEBPACK_IMPORTED_MODULE_3__DetailsHeader_styles__["b" /* getCellStyles */])(props),
            theme.fonts.small,
            isActionable && [
                classNames.isActionable,
                {
                    selectors: {
                        ':hover': {
                            color: semanticColors.bodyText,
                            background: semanticColors.listHeaderBackgroundHovered
                        },
                        ':active': {
                            background: semanticColors.listHeaderBackgroundPressed
                        }
                    }
                }
            ],
            isEmpty && [
                classNames.isEmpty,
                {
                    textOverflow: 'clip'
                }
            ],
            isIconVisible && classNames.isIconVisible,
            isPadded && {
                paddingRight: cellStyleProps.cellExtraRightPadding + cellStyleProps.cellRightPadding
            },
            {
                selectors: {
                    ':hover i[data-icon-name="GripperBarVertical"]': {
                        display: 'block'
                    }
                }
            },
            headerClassName
        ],
        gripperBarVerticalStyle: {
            display: 'none',
            position: 'absolute',
            textAlign: 'left',
            color: palette.neutralTertiary,
            left: 1
        },
        nearIcon: nearIconStyle,
        sortIcon: [
            nearIconStyle,
            {
                paddingLeft: 4,
                position: 'relative',
                top: 1
            }
        ],
        iconClassName: [
            {
                color: colors.iconForegroundColor,
                opacity: 1
            },
            iconClassName
        ],
        filterChevron: [
            classNames.filterChevron,
            {
                color: colors.dropdownChevronForegroundColor,
                paddingLeft: 4,
                verticalAlign: 'middle'
            }
        ],
        cellTitle: [
            classNames.cellTitle,
            Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["v" /* getFocusStyle */])(theme),
            __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'stretch', boxSizing: 'border-box', overflow: 'hidden', padding: "0 " + cellStyleProps.cellRightPadding + "px 0 " + cellStyleProps.cellLeftPadding + "px" }, (isIconOnly
                ? {
                    alignContent: 'flex-end',
                    maxHeight: '100%',
                    flexWrap: 'wrap-reverse'
                }
                : {}))
        ],
        cellName: [
            classNames.cellName,
            {
                flex: '0 1 auto',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            },
            isIconOnly && {
                selectors: {
                    $nearIcon: {
                        paddingLeft: 0
                    }
                }
            }
        ],
        cellTooltip: {
            display: 'block',
            position: 'absolute',
            top: 0,
            left: 0,
            bottom: 0,
            right: 0
        },
        accessibleLabel: __WEBPACK_IMPORTED_MODULE_1__Styling__["B" /* hiddenContentStyle */],
        borderWhileDragging: borderWhileDragging,
        noBorderWhileDragging: [borderAfterDragOrDrop, { transition: "outline " + transitionDurationDrag + "ms ease" }],
        borderAfterDropping: borderWhileDragging,
        noBorderAfterDropping: [borderAfterDragOrDrop, { transition: "outline  " + transitionDurationDrop + "ms ease" }]
    };
};
//# sourceMappingURL=DetailsColumn.styles.js.map

/***/ }),
/* 1726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DetailsRowFields; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DetailsRow_styles__ = __webpack_require__(99);




var getCellText = function (item, column) {
    var value = item && column && column.fieldName ? item[column.fieldName] : '';
    if (value === null || value === undefined) {
        value = '';
    }
    return value;
};
/**
 * Component for rendering a row's cells in a `DetailsList`.
 *
 * {@docCategory DetailsList}
 */
var DetailsRowFields = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](DetailsRowFields, _super);
    function DetailsRowFields(props) {
        var _this = _super.call(this, props) || this;
        _this._cellValueKeys = {};
        return _this;
    }
    DetailsRowFields.prototype.render = function () {
        var _a = this.props, columns = _a.columns, columnStartIndex = _a.columnStartIndex, shimmer = _a.shimmer, rowClassNames = _a.rowClassNames, _b = _a.cellStyleProps, cellStyleProps = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_3__DetailsRow_styles__["a" /* DEFAULT_CELL_STYLE_PROPS */] : _b, item = _a.item, itemIndex = _a.itemIndex, onRenderItemColumn = _a.onRenderItemColumn, getCellValueKey = _a.getCellValueKey, cellsByColumn = _a.cellsByColumn, enableUpdateAnimations = _a.enableUpdateAnimations;
        var cellValueKeys = this._cellValueKeys;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: rowClassNames.fields, "data-automationid": "DetailsRowFields", role: "presentation" }, columns.map(function (column, columnIndex) {
            var width = typeof column.calculatedWidth === 'undefined'
                ? 'auto'
                : column.calculatedWidth +
                    cellStyleProps.cellLeftPadding +
                    cellStyleProps.cellRightPadding +
                    (column.isPadded ? cellStyleProps.cellExtraRightPadding : 0);
            var _a = column.onRender, onRender = _a === void 0 ? onRenderItemColumn : _a, _b = column.getValueKey, getValueKey = _b === void 0 ? getCellValueKey : _b;
            var cellContentsRender = cellsByColumn && column.key in cellsByColumn
                ? cellsByColumn[column.key]
                : onRender && !shimmer
                    ? onRender(item, itemIndex, column)
                    : getCellText(item, column);
            var previousValueKey = cellValueKeys[column.key];
            var cellValueKey = enableUpdateAnimations && getValueKey ? getValueKey(item, itemIndex, column) : undefined;
            var showAnimation = false;
            if (cellValueKey !== undefined && previousValueKey !== undefined && cellValueKey !== previousValueKey) {
                showAnimation = true;
            }
            cellValueKeys[column.key] = cellValueKey;
            // generate a key that auto-dirties when content changes, to force the container to re-render, to trigger animation
            var key = "" + column.key + (cellValueKey !== undefined ? "-" + cellValueKey : '');
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { key: key, role: column.isRowHeader ? 'rowheader' : 'gridcell', "aria-colindex": columnIndex + columnStartIndex + 1, className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])(column.className, column.isMultiline && rowClassNames.isMultiline, column.isRowHeader && rowClassNames.isRowHeader, column.isIconOnly && shimmer && rowClassNames.shimmerIconPlaceholder, shimmer && rowClassNames.shimmer, rowClassNames.cell, column.isPadded ? rowClassNames.cellPadded : rowClassNames.cellUnpadded, showAnimation && rowClassNames.cellAnimation), style: { width: width }, "data-automationid": "DetailsRowCell", "data-automation-key": column.key }, cellContentsRender));
        })));
    };
    return DetailsRowFields;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));

//# sourceMappingURL=DetailsRowFields.js.map

/***/ }),
/* 1727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withViewport;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseDecorator__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utilities__ = __webpack_require__(1);




var RESIZE_DELAY = 500;
var MAX_RESIZE_ATTEMPTS = 3;
/**
 * A decorator to update decorated component on viewport or window resize events.
 *
 * @param ComposedComponent decorated React component reference.
 */
function withViewport(ComposedComponent) {
    return /** @class */ (function (_super) {
        __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](WithViewportComponent, _super);
        function WithViewportComponent(props) {
            var _this = _super.call(this, props) || this;
            _this._root = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
            _this._registerResizeObserver = function () {
                var win = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["Z" /* getWindow */])(_this._root.current);
                _this._viewportResizeObserver = new win.ResizeObserver(_this._onAsyncResize);
                _this._viewportResizeObserver.observe(_this._root.current);
            };
            _this._unregisterResizeObserver = function () {
                if (_this._viewportResizeObserver) {
                    _this._viewportResizeObserver.disconnect();
                    _this._viewportResizeObserver = null;
                }
            };
            /* Note: using lambda here because decorators don't seem to work in decorators. */
            _this._updateViewport = function (withForceUpdate) {
                var viewport = _this.state.viewport;
                var viewportElement = _this._root.current;
                var scrollElement = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["D" /* findScrollableParent */])(viewportElement);
                var scrollRect = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["X" /* getRect */])(scrollElement);
                var clientRect = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["X" /* getRect */])(viewportElement);
                var updateComponent = function () {
                    if (withForceUpdate && _this._composedComponentInstance) {
                        _this._composedComponentInstance.forceUpdate();
                    }
                };
                var isSizeChanged = (clientRect && clientRect.width) !== viewport.width || (scrollRect && scrollRect.height) !== viewport.height;
                if (isSizeChanged && _this._resizeAttempts < MAX_RESIZE_ATTEMPTS && clientRect && scrollRect) {
                    _this._resizeAttempts++;
                    _this.setState({
                        viewport: {
                            width: clientRect.width,
                            height: scrollRect.height
                        }
                    }, function () {
                        _this._updateViewport(withForceUpdate);
                    });
                }
                else {
                    _this._resizeAttempts = 0;
                    updateComponent();
                }
            };
            _this._resizeAttempts = 0;
            _this.state = {
                viewport: {
                    width: 0,
                    height: 0
                }
            };
            return _this;
        }
        WithViewportComponent.prototype.componentDidMount = function () {
            var skipViewportMeasures = this.props.skipViewportMeasures;
            var win = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["Z" /* getWindow */])(this._root.current);
            this._onAsyncResize = this._async.debounce(this._onAsyncResize, RESIZE_DELAY, {
                leading: false
            });
            // ResizeObserver seems always fire even window is not resized. This is
            // particularly bad when skipViewportMeasures is set when optimizing fixed layout lists.
            // It will measure and update and re-render the entire list after list is fully rendered.
            // So fallback to listen to resize event when skipViewportMeasures is set.
            if (!skipViewportMeasures && this._isResizeObserverAvailable()) {
                this._registerResizeObserver();
            }
            else {
                this._events.on(win, 'resize', this._onAsyncResize);
            }
            if (!skipViewportMeasures) {
                this._updateViewport();
            }
        };
        WithViewportComponent.prototype.componentDidUpdate = function (newProps) {
            var oldSkipViewportMeasures = this.props.skipViewportMeasures;
            var newSkipViewportMeasures = newProps.skipViewportMeasures;
            var win = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["Z" /* getWindow */])(this._root.current);
            if (oldSkipViewportMeasures !== newSkipViewportMeasures) {
                if (newSkipViewportMeasures) {
                    this._unregisterResizeObserver();
                    this._events.on(win, 'resize', this._onAsyncResize);
                }
                else if (!newSkipViewportMeasures && this._isResizeObserverAvailable()) {
                    this._events.off(win, 'resize', this._onAsyncResize);
                    this._registerResizeObserver();
                }
            }
            if (!!newSkipViewportMeasures) {
                this._updateViewport();
            }
        };
        WithViewportComponent.prototype.componentWillUnmount = function () {
            this._events.dispose();
            if (this._viewportResizeObserver) {
                this._viewportResizeObserver.disconnect();
            }
        };
        WithViewportComponent.prototype.render = function () {
            var viewport = this.state.viewport;
            var newViewport = viewport.width > 0 && viewport.height > 0 ? viewport : undefined;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "ms-Viewport", ref: this._root, style: { minWidth: 1, minHeight: 1 } },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ComposedComponent, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ ref: this._updateComposedComponentRef, viewport: newViewport }, this.props))));
        };
        WithViewportComponent.prototype.forceUpdate = function () {
            this._updateViewport(true);
        };
        WithViewportComponent.prototype._onAsyncResize = function () {
            this._updateViewport();
        };
        WithViewportComponent.prototype._isResizeObserverAvailable = function () {
            var win = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["Z" /* getWindow */])(this._root.current);
            return win && win.ResizeObserver;
        };
        return WithViewportComponent;
    }(__WEBPACK_IMPORTED_MODULE_2__BaseDecorator__["a" /* BaseDecorator */]));
}
//# sourceMappingURL=withViewport.js.map

/***/ }),
/* 1728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GetGroupCount; });
/**
 * Takes an array of groups and returns a count of the groups and all descendant groups.
 * @param groups - The array of groups to count.
 */
var GetGroupCount = function (groups) {
    var total = 0;
    if (groups) {
        var remainingGroups = groups.slice();
        var currentGroup = void 0;
        while (remainingGroups && remainingGroups.length > 0) {
            ++total;
            currentGroup = remainingGroups.pop();
            if (currentGroup && currentGroup.children) {
                remainingGroups.push.apply(remainingGroups, currentGroup.children);
            }
        }
    }
    return total;
};
//# sourceMappingURL=GroupedListUtility.js.map

/***/ }),
/* 1729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var GlobalClassNames = {
    root: 'ms-DetailsList',
    compact: 'ms-DetailsList--Compact',
    contentWrapper: 'ms-DetailsList-contentWrapper',
    headerWrapper: 'ms-DetailsList-headerWrapper',
    isFixed: 'is-fixed',
    isHorizontalConstrained: 'is-horizontalConstrained',
    listCell: 'ms-List-cell'
};
var getStyles = function (props) {
    var theme = props.theme, className = props.className, isHorizontalConstrained = props.isHorizontalConstrained, compact = props.compact, isFixed = props.isFixed;
    var semanticColors = theme.semanticColors;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            theme.fonts.small,
            {
                position: 'relative',
                fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].small,
                background: semanticColors.listBackground,
                color: semanticColors.listText,
                selectors: (_a = {},
                    _a["& ." + classNames.listCell] = {
                        minHeight: 38,
                        wordBreak: 'break-word'
                    },
                    _a)
            },
            isFixed && classNames.isFixed,
            compact && [
                classNames.compact,
                {
                    selectors: (_b = {},
                        _b["." + classNames.listCell] = {
                            minHeight: 32
                        },
                        _b)
                }
            ],
            isHorizontalConstrained && [
                classNames.isHorizontalConstrained,
                {
                    overflowX: 'auto',
                    overflowY: 'visible',
                    WebkitOverflowScrolling: 'touch'
                }
            ],
            className
        ],
        focusZone: [
            {
                display: 'inline-block',
                minWidth: '100%',
                minHeight: 1
            }
        ],
        headerWrapper: classNames.headerWrapper,
        contentWrapper: classNames.contentWrapper
    };
    var _a, _b;
};
//# sourceMappingURL=DetailsList.styles.js.map

/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

(function (root) {
   "use strict";

/***** unorm.js *****/

/*
 * UnicodeNormalizer 1.0.0
 * Copyright (c) 2008 Matsuza
 * Dual licensed under the MIT (MIT-LICENSE.txt) and GPL (GPL-LICENSE.txt) licenses.
 * $Date: 2008-06-05 16:44:17 +0200 (Thu, 05 Jun 2008) $
 * $Rev: 13309 $
 */

   var DEFAULT_FEATURE = [null, 0, {}];
   var CACHE_THRESHOLD = 10;
   var SBase = 0xAC00, LBase = 0x1100, VBase = 0x1161, TBase = 0x11A7, LCount = 19, VCount = 21, TCount = 28;
   var NCount = VCount * TCount; // 588
   var SCount = LCount * NCount; // 11172

   var UChar = function(cp, feature){
      this.codepoint = cp;
      this.feature = feature;
   };

   // Strategies
   var cache = {};
   var cacheCounter = [];
   for (var i = 0; i <= 0xFF; ++i){
      cacheCounter[i] = 0;
   }

   function fromCache(next, cp, needFeature){
      var ret = cache[cp];
      if(!ret){
         ret = next(cp, needFeature);
         if(!!ret.feature && ++cacheCounter[(cp >> 8) & 0xFF] > CACHE_THRESHOLD){
            cache[cp] = ret;
         }
      }
      return ret;
   }

   function fromData(next, cp, needFeature){
      var hash = cp & 0xFF00;
      var dunit = UChar.udata[hash] || {};
      var f = dunit[cp];
      return f ? new UChar(cp, f) : new UChar(cp, DEFAULT_FEATURE);
   }
   function fromCpOnly(next, cp, needFeature){
      return !!needFeature ? next(cp, needFeature) : new UChar(cp, null);
   }
   function fromRuleBasedJamo(next, cp, needFeature){
      var j;
      if(cp < LBase || (LBase + LCount <= cp && cp < SBase) || (SBase + SCount < cp)){
         return next(cp, needFeature);
      }
      if(LBase <= cp && cp < LBase + LCount){
         var c = {};
         var base = (cp - LBase) * VCount;
         for (j = 0; j < VCount; ++j){
            c[VBase + j] = SBase + TCount * (j + base);
         }
         return new UChar(cp, [,,c]);
      }

      var SIndex = cp - SBase;
      var TIndex = SIndex % TCount;
      var feature = [];
      if(TIndex !== 0){
         feature[0] = [SBase + SIndex - TIndex, TBase + TIndex];
      } else {
         feature[0] = [LBase + Math.floor(SIndex / NCount), VBase + Math.floor((SIndex % NCount) / TCount)];
         feature[2] = {};
         for (j = 1; j < TCount; ++j){
            feature[2][TBase + j] = cp + j;
         }
      }
      return new UChar(cp, feature);
   }
   function fromCpFilter(next, cp, needFeature){
      return cp < 60 || 13311 < cp && cp < 42607 ? new UChar(cp, DEFAULT_FEATURE) : next(cp, needFeature);
   }

   var strategies = [fromCpFilter, fromCache, fromCpOnly, fromRuleBasedJamo, fromData];

   UChar.fromCharCode = strategies.reduceRight(function (next, strategy) {
      return function (cp, needFeature) {
         return strategy(next, cp, needFeature);
      };
   }, null);

   UChar.isHighSurrogate = function(cp){
      return cp >= 0xD800 && cp <= 0xDBFF;
   };
   UChar.isLowSurrogate = function(cp){
      return cp >= 0xDC00 && cp <= 0xDFFF;
   };

   UChar.prototype.prepFeature = function(){
      if(!this.feature){
         this.feature = UChar.fromCharCode(this.codepoint, true).feature;
      }
   };

   UChar.prototype.toString = function(){
      if(this.codepoint < 0x10000){
         return String.fromCharCode(this.codepoint);
      } else {
         var x = this.codepoint - 0x10000;
         return String.fromCharCode(Math.floor(x / 0x400) + 0xD800, x % 0x400 + 0xDC00);
      }
   };

   UChar.prototype.getDecomp = function(){
      this.prepFeature();
      return this.feature[0] || null;
   };

   UChar.prototype.isCompatibility = function(){
      this.prepFeature();
      return !!this.feature[1] && (this.feature[1] & (1 << 8));
   };
   UChar.prototype.isExclude = function(){
      this.prepFeature();
      return !!this.feature[1] && (this.feature[1] & (1 << 9));
   };
   UChar.prototype.getCanonicalClass = function(){
      this.prepFeature();
      return !!this.feature[1] ? (this.feature[1] & 0xff) : 0;
   };
   UChar.prototype.getComposite = function(following){
      this.prepFeature();
      if(!this.feature[2]){
         return null;
      }
      var cp = this.feature[2][following.codepoint];
      return cp ? UChar.fromCharCode(cp) : null;
   };

   var UCharIterator = function(str){
      this.str = str;
      this.cursor = 0;
   };
   UCharIterator.prototype.next = function(){
      if(!!this.str && this.cursor < this.str.length){
         var cp = this.str.charCodeAt(this.cursor++);
         var d;
         if(UChar.isHighSurrogate(cp) && this.cursor < this.str.length && UChar.isLowSurrogate((d = this.str.charCodeAt(this.cursor)))){
            cp = (cp - 0xD800) * 0x400 + (d -0xDC00) + 0x10000;
            ++this.cursor;
         }
         return UChar.fromCharCode(cp);
      } else {
         this.str = null;
         return null;
      }
   };

   var RecursDecompIterator = function(it, cano){
      this.it = it;
      this.canonical = cano;
      this.resBuf = [];
   };

   RecursDecompIterator.prototype.next = function(){
      function recursiveDecomp(cano, uchar){
         var decomp = uchar.getDecomp();
         if(!!decomp && !(cano && uchar.isCompatibility())){
            var ret = [];
            for(var i = 0; i < decomp.length; ++i){
               var a = recursiveDecomp(cano, UChar.fromCharCode(decomp[i]));
                ret = ret.concat(a);
            }
            return ret;
         } else {
            return [uchar];
         }
      }
      if(this.resBuf.length === 0){
         var uchar = this.it.next();
         if(!uchar){
            return null;
         }
         this.resBuf = recursiveDecomp(this.canonical, uchar);
      }
      return this.resBuf.shift();
   };

   var DecompIterator = function(it){
      this.it = it;
      this.resBuf = [];
   };

   DecompIterator.prototype.next = function(){
      var cc;
      if(this.resBuf.length === 0){
         do{
            var uchar = this.it.next();
            if(!uchar){
               break;
            }
            cc = uchar.getCanonicalClass();
            var inspt = this.resBuf.length;
            if(cc !== 0){
               for(; inspt > 0; --inspt){
                  var uchar2 = this.resBuf[inspt - 1];
                  var cc2 = uchar2.getCanonicalClass();
                  if(cc2 <= cc){
                     break;
                  }
               }
            }
            this.resBuf.splice(inspt, 0, uchar);
         } while(cc !== 0);
      }
      return this.resBuf.shift();
   };

   var CompIterator = function(it){
      this.it = it;
      this.procBuf = [];
      this.resBuf = [];
      this.lastClass = null;
   };

   CompIterator.prototype.next = function(){
      while(this.resBuf.length === 0){
         var uchar = this.it.next();
         if(!uchar){
            this.resBuf = this.procBuf;
            this.procBuf = [];
            break;
         }
         if(this.procBuf.length === 0){
            this.lastClass = uchar.getCanonicalClass();
            this.procBuf.push(uchar);
         } else {
            var starter = this.procBuf[0];
            var composite = starter.getComposite(uchar);
            var cc = uchar.getCanonicalClass();
            if(!!composite && (this.lastClass < cc || this.lastClass === 0)){
               this.procBuf[0] = composite;
            } else {
               if(cc === 0){
                  this.resBuf = this.procBuf;
                  this.procBuf = [];
               }
               this.lastClass = cc;
               this.procBuf.push(uchar);
            }
         }
      }
      return this.resBuf.shift();
   };

   var createIterator = function(mode, str){
      switch(mode){
         case "NFD":
            return new DecompIterator(new RecursDecompIterator(new UCharIterator(str), true));
         case "NFKD":
            return new DecompIterator(new RecursDecompIterator(new UCharIterator(str), false));
         case "NFC":
            return new CompIterator(new DecompIterator(new RecursDecompIterator(new UCharIterator(str), true)));
         case "NFKC":
            return new CompIterator(new DecompIterator(new RecursDecompIterator(new UCharIterator(str), false)));
      }
      throw mode + " is invalid";
   };
   var normalize = function(mode, str){
      var it = createIterator(mode, str);
      var ret = "";
      var uchar;
      while(!!(uchar = it.next())){
         ret += uchar.toString();
      }
      return ret;
   };

   /* API functions */
   function nfd(str){
      return normalize("NFD", str);
   }

   function nfkd(str){
      return normalize("NFKD", str);
   }

   function nfc(str){
      return normalize("NFC", str);
   }

   function nfkc(str){
      return normalize("NFKC", str);
   }

/* Unicode data */
UChar.udata={
0:{60:[,,{824:8814}],61:[,,{824:8800}],62:[,,{824:8815}],65:[,,{768:192,769:193,770:194,771:195,772:256,774:258,775:550,776:196,777:7842,778:197,780:461,783:512,785:514,803:7840,805:7680,808:260}],66:[,,{775:7682,803:7684,817:7686}],67:[,,{769:262,770:264,775:266,780:268,807:199}],68:[,,{775:7690,780:270,803:7692,807:7696,813:7698,817:7694}],69:[,,{768:200,769:201,770:202,771:7868,772:274,774:276,775:278,776:203,777:7866,780:282,783:516,785:518,803:7864,807:552,808:280,813:7704,816:7706}],70:[,,{775:7710}],71:[,,{769:500,770:284,772:7712,774:286,775:288,780:486,807:290}],72:[,,{770:292,775:7714,776:7718,780:542,803:7716,807:7720,814:7722}],73:[,,{768:204,769:205,770:206,771:296,772:298,774:300,775:304,776:207,777:7880,780:463,783:520,785:522,803:7882,808:302,816:7724}],74:[,,{770:308}],75:[,,{769:7728,780:488,803:7730,807:310,817:7732}],76:[,,{769:313,780:317,803:7734,807:315,813:7740,817:7738}],77:[,,{769:7742,775:7744,803:7746}],78:[,,{768:504,769:323,771:209,775:7748,780:327,803:7750,807:325,813:7754,817:7752}],79:[,,{768:210,769:211,770:212,771:213,772:332,774:334,775:558,776:214,777:7886,779:336,780:465,783:524,785:526,795:416,803:7884,808:490}],80:[,,{769:7764,775:7766}],82:[,,{769:340,775:7768,780:344,783:528,785:530,803:7770,807:342,817:7774}],83:[,,{769:346,770:348,775:7776,780:352,803:7778,806:536,807:350}],84:[,,{775:7786,780:356,803:7788,806:538,807:354,813:7792,817:7790}],85:[,,{768:217,769:218,770:219,771:360,772:362,774:364,776:220,777:7910,778:366,779:368,780:467,783:532,785:534,795:431,803:7908,804:7794,808:370,813:7798,816:7796}],86:[,,{771:7804,803:7806}],87:[,,{768:7808,769:7810,770:372,775:7814,776:7812,803:7816}],88:[,,{775:7818,776:7820}],89:[,,{768:7922,769:221,770:374,771:7928,772:562,775:7822,776:376,777:7926,803:7924}],90:[,,{769:377,770:7824,775:379,780:381,803:7826,817:7828}],97:[,,{768:224,769:225,770:226,771:227,772:257,774:259,775:551,776:228,777:7843,778:229,780:462,783:513,785:515,803:7841,805:7681,808:261}],98:[,,{775:7683,803:7685,817:7687}],99:[,,{769:263,770:265,775:267,780:269,807:231}],100:[,,{775:7691,780:271,803:7693,807:7697,813:7699,817:7695}],101:[,,{768:232,769:233,770:234,771:7869,772:275,774:277,775:279,776:235,777:7867,780:283,783:517,785:519,803:7865,807:553,808:281,813:7705,816:7707}],102:[,,{775:7711}],103:[,,{769:501,770:285,772:7713,774:287,775:289,780:487,807:291}],104:[,,{770:293,775:7715,776:7719,780:543,803:7717,807:7721,814:7723,817:7830}],105:[,,{768:236,769:237,770:238,771:297,772:299,774:301,776:239,777:7881,780:464,783:521,785:523,803:7883,808:303,816:7725}],106:[,,{770:309,780:496}],107:[,,{769:7729,780:489,803:7731,807:311,817:7733}],108:[,,{769:314,780:318,803:7735,807:316,813:7741,817:7739}],109:[,,{769:7743,775:7745,803:7747}],110:[,,{768:505,769:324,771:241,775:7749,780:328,803:7751,807:326,813:7755,817:7753}],111:[,,{768:242,769:243,770:244,771:245,772:333,774:335,775:559,776:246,777:7887,779:337,780:466,783:525,785:527,795:417,803:7885,808:491}],112:[,,{769:7765,775:7767}],114:[,,{769:341,775:7769,780:345,783:529,785:531,803:7771,807:343,817:7775}],115:[,,{769:347,770:349,775:7777,780:353,803:7779,806:537,807:351}],116:[,,{775:7787,776:7831,780:357,803:7789,806:539,807:355,813:7793,817:7791}],117:[,,{768:249,769:250,770:251,771:361,772:363,774:365,776:252,777:7911,778:367,779:369,780:468,783:533,785:535,795:432,803:7909,804:7795,808:371,813:7799,816:7797}],118:[,,{771:7805,803:7807}],119:[,,{768:7809,769:7811,770:373,775:7815,776:7813,778:7832,803:7817}],120:[,,{775:7819,776:7821}],121:[,,{768:7923,769:253,770:375,771:7929,772:563,775:7823,776:255,777:7927,778:7833,803:7925}],122:[,,{769:378,770:7825,775:380,780:382,803:7827,817:7829}],160:[[32],256],168:[[32,776],256,{768:8173,769:901,834:8129}],170:[[97],256],175:[[32,772],256],178:[[50],256],179:[[51],256],180:[[32,769],256],181:[[956],256],184:[[32,807],256],185:[[49],256],186:[[111],256],188:[[49,8260,52],256],189:[[49,8260,50],256],190:[[51,8260,52],256],192:[[65,768]],193:[[65,769]],194:[[65,770],,{768:7846,769:7844,771:7850,777:7848}],195:[[65,771]],196:[[65,776],,{772:478}],197:[[65,778],,{769:506}],198:[,,{769:508,772:482}],199:[[67,807],,{769:7688}],200:[[69,768]],201:[[69,769]],202:[[69,770],,{768:7872,769:7870,771:7876,777:7874}],203:[[69,776]],204:[[73,768]],205:[[73,769]],206:[[73,770]],207:[[73,776],,{769:7726}],209:[[78,771]],210:[[79,768]],211:[[79,769]],212:[[79,770],,{768:7890,769:7888,771:7894,777:7892}],213:[[79,771],,{769:7756,772:556,776:7758}],214:[[79,776],,{772:554}],216:[,,{769:510}],217:[[85,768]],218:[[85,769]],219:[[85,770]],220:[[85,776],,{768:475,769:471,772:469,780:473}],221:[[89,769]],224:[[97,768]],225:[[97,769]],226:[[97,770],,{768:7847,769:7845,771:7851,777:7849}],227:[[97,771]],228:[[97,776],,{772:479}],229:[[97,778],,{769:507}],230:[,,{769:509,772:483}],231:[[99,807],,{769:7689}],232:[[101,768]],233:[[101,769]],234:[[101,770],,{768:7873,769:7871,771:7877,777:7875}],235:[[101,776]],236:[[105,768]],237:[[105,769]],238:[[105,770]],239:[[105,776],,{769:7727}],241:[[110,771]],242:[[111,768]],243:[[111,769]],244:[[111,770],,{768:7891,769:7889,771:7895,777:7893}],245:[[111,771],,{769:7757,772:557,776:7759}],246:[[111,776],,{772:555}],248:[,,{769:511}],249:[[117,768]],250:[[117,769]],251:[[117,770]],252:[[117,776],,{768:476,769:472,772:470,780:474}],253:[[121,769]],255:[[121,776]]},
256:{256:[[65,772]],257:[[97,772]],258:[[65,774],,{768:7856,769:7854,771:7860,777:7858}],259:[[97,774],,{768:7857,769:7855,771:7861,777:7859}],260:[[65,808]],261:[[97,808]],262:[[67,769]],263:[[99,769]],264:[[67,770]],265:[[99,770]],266:[[67,775]],267:[[99,775]],268:[[67,780]],269:[[99,780]],270:[[68,780]],271:[[100,780]],274:[[69,772],,{768:7700,769:7702}],275:[[101,772],,{768:7701,769:7703}],276:[[69,774]],277:[[101,774]],278:[[69,775]],279:[[101,775]],280:[[69,808]],281:[[101,808]],282:[[69,780]],283:[[101,780]],284:[[71,770]],285:[[103,770]],286:[[71,774]],287:[[103,774]],288:[[71,775]],289:[[103,775]],290:[[71,807]],291:[[103,807]],292:[[72,770]],293:[[104,770]],296:[[73,771]],297:[[105,771]],298:[[73,772]],299:[[105,772]],300:[[73,774]],301:[[105,774]],302:[[73,808]],303:[[105,808]],304:[[73,775]],306:[[73,74],256],307:[[105,106],256],308:[[74,770]],309:[[106,770]],310:[[75,807]],311:[[107,807]],313:[[76,769]],314:[[108,769]],315:[[76,807]],316:[[108,807]],317:[[76,780]],318:[[108,780]],319:[[76,183],256],320:[[108,183],256],323:[[78,769]],324:[[110,769]],325:[[78,807]],326:[[110,807]],327:[[78,780]],328:[[110,780]],329:[[700,110],256],332:[[79,772],,{768:7760,769:7762}],333:[[111,772],,{768:7761,769:7763}],334:[[79,774]],335:[[111,774]],336:[[79,779]],337:[[111,779]],340:[[82,769]],341:[[114,769]],342:[[82,807]],343:[[114,807]],344:[[82,780]],345:[[114,780]],346:[[83,769],,{775:7780}],347:[[115,769],,{775:7781}],348:[[83,770]],349:[[115,770]],350:[[83,807]],351:[[115,807]],352:[[83,780],,{775:7782}],353:[[115,780],,{775:7783}],354:[[84,807]],355:[[116,807]],356:[[84,780]],357:[[116,780]],360:[[85,771],,{769:7800}],361:[[117,771],,{769:7801}],362:[[85,772],,{776:7802}],363:[[117,772],,{776:7803}],364:[[85,774]],365:[[117,774]],366:[[85,778]],367:[[117,778]],368:[[85,779]],369:[[117,779]],370:[[85,808]],371:[[117,808]],372:[[87,770]],373:[[119,770]],374:[[89,770]],375:[[121,770]],376:[[89,776]],377:[[90,769]],378:[[122,769]],379:[[90,775]],380:[[122,775]],381:[[90,780]],382:[[122,780]],383:[[115],256,{775:7835}],416:[[79,795],,{768:7900,769:7898,771:7904,777:7902,803:7906}],417:[[111,795],,{768:7901,769:7899,771:7905,777:7903,803:7907}],431:[[85,795],,{768:7914,769:7912,771:7918,777:7916,803:7920}],432:[[117,795],,{768:7915,769:7913,771:7919,777:7917,803:7921}],439:[,,{780:494}],452:[[68,381],256],453:[[68,382],256],454:[[100,382],256],455:[[76,74],256],456:[[76,106],256],457:[[108,106],256],458:[[78,74],256],459:[[78,106],256],460:[[110,106],256],461:[[65,780]],462:[[97,780]],463:[[73,780]],464:[[105,780]],465:[[79,780]],466:[[111,780]],467:[[85,780]],468:[[117,780]],469:[[220,772]],470:[[252,772]],471:[[220,769]],472:[[252,769]],473:[[220,780]],474:[[252,780]],475:[[220,768]],476:[[252,768]],478:[[196,772]],479:[[228,772]],480:[[550,772]],481:[[551,772]],482:[[198,772]],483:[[230,772]],486:[[71,780]],487:[[103,780]],488:[[75,780]],489:[[107,780]],490:[[79,808],,{772:492}],491:[[111,808],,{772:493}],492:[[490,772]],493:[[491,772]],494:[[439,780]],495:[[658,780]],496:[[106,780]],497:[[68,90],256],498:[[68,122],256],499:[[100,122],256],500:[[71,769]],501:[[103,769]],504:[[78,768]],505:[[110,768]],506:[[197,769]],507:[[229,769]],508:[[198,769]],509:[[230,769]],510:[[216,769]],511:[[248,769]],66045:[,220]},
512:{512:[[65,783]],513:[[97,783]],514:[[65,785]],515:[[97,785]],516:[[69,783]],517:[[101,783]],518:[[69,785]],519:[[101,785]],520:[[73,783]],521:[[105,783]],522:[[73,785]],523:[[105,785]],524:[[79,783]],525:[[111,783]],526:[[79,785]],527:[[111,785]],528:[[82,783]],529:[[114,783]],530:[[82,785]],531:[[114,785]],532:[[85,783]],533:[[117,783]],534:[[85,785]],535:[[117,785]],536:[[83,806]],537:[[115,806]],538:[[84,806]],539:[[116,806]],542:[[72,780]],543:[[104,780]],550:[[65,775],,{772:480}],551:[[97,775],,{772:481}],552:[[69,807],,{774:7708}],553:[[101,807],,{774:7709}],554:[[214,772]],555:[[246,772]],556:[[213,772]],557:[[245,772]],558:[[79,775],,{772:560}],559:[[111,775],,{772:561}],560:[[558,772]],561:[[559,772]],562:[[89,772]],563:[[121,772]],658:[,,{780:495}],688:[[104],256],689:[[614],256],690:[[106],256],691:[[114],256],692:[[633],256],693:[[635],256],694:[[641],256],695:[[119],256],696:[[121],256],728:[[32,774],256],729:[[32,775],256],730:[[32,778],256],731:[[32,808],256],732:[[32,771],256],733:[[32,779],256],736:[[611],256],737:[[108],256],738:[[115],256],739:[[120],256],740:[[661],256],66272:[,220]},
768:{768:[,230],769:[,230],770:[,230],771:[,230],772:[,230],773:[,230],774:[,230],775:[,230],776:[,230,{769:836}],777:[,230],778:[,230],779:[,230],780:[,230],781:[,230],782:[,230],783:[,230],784:[,230],785:[,230],786:[,230],787:[,230],788:[,230],789:[,232],790:[,220],791:[,220],792:[,220],793:[,220],794:[,232],795:[,216],796:[,220],797:[,220],798:[,220],799:[,220],800:[,220],801:[,202],802:[,202],803:[,220],804:[,220],805:[,220],806:[,220],807:[,202],808:[,202],809:[,220],810:[,220],811:[,220],812:[,220],813:[,220],814:[,220],815:[,220],816:[,220],817:[,220],818:[,220],819:[,220],820:[,1],821:[,1],822:[,1],823:[,1],824:[,1],825:[,220],826:[,220],827:[,220],828:[,220],829:[,230],830:[,230],831:[,230],832:[[768],230],833:[[769],230],834:[,230],835:[[787],230],836:[[776,769],230],837:[,240],838:[,230],839:[,220],840:[,220],841:[,220],842:[,230],843:[,230],844:[,230],845:[,220],846:[,220],848:[,230],849:[,230],850:[,230],851:[,220],852:[,220],853:[,220],854:[,220],855:[,230],856:[,232],857:[,220],858:[,220],859:[,230],860:[,233],861:[,234],862:[,234],863:[,233],864:[,234],865:[,234],866:[,233],867:[,230],868:[,230],869:[,230],870:[,230],871:[,230],872:[,230],873:[,230],874:[,230],875:[,230],876:[,230],877:[,230],878:[,230],879:[,230],884:[[697]],890:[[32,837],256],894:[[59]],900:[[32,769],256],901:[[168,769]],902:[[913,769]],903:[[183]],904:[[917,769]],905:[[919,769]],906:[[921,769]],908:[[927,769]],910:[[933,769]],911:[[937,769]],912:[[970,769]],913:[,,{768:8122,769:902,772:8121,774:8120,787:7944,788:7945,837:8124}],917:[,,{768:8136,769:904,787:7960,788:7961}],919:[,,{768:8138,769:905,787:7976,788:7977,837:8140}],921:[,,{768:8154,769:906,772:8153,774:8152,776:938,787:7992,788:7993}],927:[,,{768:8184,769:908,787:8008,788:8009}],929:[,,{788:8172}],933:[,,{768:8170,769:910,772:8169,774:8168,776:939,788:8025}],937:[,,{768:8186,769:911,787:8040,788:8041,837:8188}],938:[[921,776]],939:[[933,776]],940:[[945,769],,{837:8116}],941:[[949,769]],942:[[951,769],,{837:8132}],943:[[953,769]],944:[[971,769]],945:[,,{768:8048,769:940,772:8113,774:8112,787:7936,788:7937,834:8118,837:8115}],949:[,,{768:8050,769:941,787:7952,788:7953}],951:[,,{768:8052,769:942,787:7968,788:7969,834:8134,837:8131}],953:[,,{768:8054,769:943,772:8145,774:8144,776:970,787:7984,788:7985,834:8150}],959:[,,{768:8056,769:972,787:8000,788:8001}],961:[,,{787:8164,788:8165}],965:[,,{768:8058,769:973,772:8161,774:8160,776:971,787:8016,788:8017,834:8166}],969:[,,{768:8060,769:974,787:8032,788:8033,834:8182,837:8179}],970:[[953,776],,{768:8146,769:912,834:8151}],971:[[965,776],,{768:8162,769:944,834:8167}],972:[[959,769]],973:[[965,769]],974:[[969,769],,{837:8180}],976:[[946],256],977:[[952],256],978:[[933],256,{769:979,776:980}],979:[[978,769]],980:[[978,776]],981:[[966],256],982:[[960],256],1008:[[954],256],1009:[[961],256],1010:[[962],256],1012:[[920],256],1013:[[949],256],1017:[[931],256],66422:[,230],66423:[,230],66424:[,230],66425:[,230],66426:[,230]},
1024:{1024:[[1045,768]],1025:[[1045,776]],1027:[[1043,769]],1030:[,,{776:1031}],1031:[[1030,776]],1036:[[1050,769]],1037:[[1048,768]],1038:[[1059,774]],1040:[,,{774:1232,776:1234}],1043:[,,{769:1027}],1045:[,,{768:1024,774:1238,776:1025}],1046:[,,{774:1217,776:1244}],1047:[,,{776:1246}],1048:[,,{768:1037,772:1250,774:1049,776:1252}],1049:[[1048,774]],1050:[,,{769:1036}],1054:[,,{776:1254}],1059:[,,{772:1262,774:1038,776:1264,779:1266}],1063:[,,{776:1268}],1067:[,,{776:1272}],1069:[,,{776:1260}],1072:[,,{774:1233,776:1235}],1075:[,,{769:1107}],1077:[,,{768:1104,774:1239,776:1105}],1078:[,,{774:1218,776:1245}],1079:[,,{776:1247}],1080:[,,{768:1117,772:1251,774:1081,776:1253}],1081:[[1080,774]],1082:[,,{769:1116}],1086:[,,{776:1255}],1091:[,,{772:1263,774:1118,776:1265,779:1267}],1095:[,,{776:1269}],1099:[,,{776:1273}],1101:[,,{776:1261}],1104:[[1077,768]],1105:[[1077,776]],1107:[[1075,769]],1110:[,,{776:1111}],1111:[[1110,776]],1116:[[1082,769]],1117:[[1080,768]],1118:[[1091,774]],1140:[,,{783:1142}],1141:[,,{783:1143}],1142:[[1140,783]],1143:[[1141,783]],1155:[,230],1156:[,230],1157:[,230],1158:[,230],1159:[,230],1217:[[1046,774]],1218:[[1078,774]],1232:[[1040,774]],1233:[[1072,774]],1234:[[1040,776]],1235:[[1072,776]],1238:[[1045,774]],1239:[[1077,774]],1240:[,,{776:1242}],1241:[,,{776:1243}],1242:[[1240,776]],1243:[[1241,776]],1244:[[1046,776]],1245:[[1078,776]],1246:[[1047,776]],1247:[[1079,776]],1250:[[1048,772]],1251:[[1080,772]],1252:[[1048,776]],1253:[[1080,776]],1254:[[1054,776]],1255:[[1086,776]],1256:[,,{776:1258}],1257:[,,{776:1259}],1258:[[1256,776]],1259:[[1257,776]],1260:[[1069,776]],1261:[[1101,776]],1262:[[1059,772]],1263:[[1091,772]],1264:[[1059,776]],1265:[[1091,776]],1266:[[1059,779]],1267:[[1091,779]],1268:[[1063,776]],1269:[[1095,776]],1272:[[1067,776]],1273:[[1099,776]]},
1280:{1415:[[1381,1410],256],1425:[,220],1426:[,230],1427:[,230],1428:[,230],1429:[,230],1430:[,220],1431:[,230],1432:[,230],1433:[,230],1434:[,222],1435:[,220],1436:[,230],1437:[,230],1438:[,230],1439:[,230],1440:[,230],1441:[,230],1442:[,220],1443:[,220],1444:[,220],1445:[,220],1446:[,220],1447:[,220],1448:[,230],1449:[,230],1450:[,220],1451:[,230],1452:[,230],1453:[,222],1454:[,228],1455:[,230],1456:[,10],1457:[,11],1458:[,12],1459:[,13],1460:[,14],1461:[,15],1462:[,16],1463:[,17],1464:[,18],1465:[,19],1466:[,19],1467:[,20],1468:[,21],1469:[,22],1471:[,23],1473:[,24],1474:[,25],1476:[,230],1477:[,220],1479:[,18]},
1536:{1552:[,230],1553:[,230],1554:[,230],1555:[,230],1556:[,230],1557:[,230],1558:[,230],1559:[,230],1560:[,30],1561:[,31],1562:[,32],1570:[[1575,1619]],1571:[[1575,1620]],1572:[[1608,1620]],1573:[[1575,1621]],1574:[[1610,1620]],1575:[,,{1619:1570,1620:1571,1621:1573}],1608:[,,{1620:1572}],1610:[,,{1620:1574}],1611:[,27],1612:[,28],1613:[,29],1614:[,30],1615:[,31],1616:[,32],1617:[,33],1618:[,34],1619:[,230],1620:[,230],1621:[,220],1622:[,220],1623:[,230],1624:[,230],1625:[,230],1626:[,230],1627:[,230],1628:[,220],1629:[,230],1630:[,230],1631:[,220],1648:[,35],1653:[[1575,1652],256],1654:[[1608,1652],256],1655:[[1735,1652],256],1656:[[1610,1652],256],1728:[[1749,1620]],1729:[,,{1620:1730}],1730:[[1729,1620]],1746:[,,{1620:1747}],1747:[[1746,1620]],1749:[,,{1620:1728}],1750:[,230],1751:[,230],1752:[,230],1753:[,230],1754:[,230],1755:[,230],1756:[,230],1759:[,230],1760:[,230],1761:[,230],1762:[,230],1763:[,220],1764:[,230],1767:[,230],1768:[,230],1770:[,220],1771:[,230],1772:[,230],1773:[,220]},
1792:{1809:[,36],1840:[,230],1841:[,220],1842:[,230],1843:[,230],1844:[,220],1845:[,230],1846:[,230],1847:[,220],1848:[,220],1849:[,220],1850:[,230],1851:[,220],1852:[,220],1853:[,230],1854:[,220],1855:[,230],1856:[,230],1857:[,230],1858:[,220],1859:[,230],1860:[,220],1861:[,230],1862:[,220],1863:[,230],1864:[,220],1865:[,230],1866:[,230],2027:[,230],2028:[,230],2029:[,230],2030:[,230],2031:[,230],2032:[,230],2033:[,230],2034:[,220],2035:[,230]},
2048:{2070:[,230],2071:[,230],2072:[,230],2073:[,230],2075:[,230],2076:[,230],2077:[,230],2078:[,230],2079:[,230],2080:[,230],2081:[,230],2082:[,230],2083:[,230],2085:[,230],2086:[,230],2087:[,230],2089:[,230],2090:[,230],2091:[,230],2092:[,230],2093:[,230],2137:[,220],2138:[,220],2139:[,220],2276:[,230],2277:[,230],2278:[,220],2279:[,230],2280:[,230],2281:[,220],2282:[,230],2283:[,230],2284:[,230],2285:[,220],2286:[,220],2287:[,220],2288:[,27],2289:[,28],2290:[,29],2291:[,230],2292:[,230],2293:[,230],2294:[,220],2295:[,230],2296:[,230],2297:[,220],2298:[,220],2299:[,230],2300:[,230],2301:[,230],2302:[,230],2303:[,230]},
2304:{2344:[,,{2364:2345}],2345:[[2344,2364]],2352:[,,{2364:2353}],2353:[[2352,2364]],2355:[,,{2364:2356}],2356:[[2355,2364]],2364:[,7],2381:[,9],2385:[,230],2386:[,220],2387:[,230],2388:[,230],2392:[[2325,2364],512],2393:[[2326,2364],512],2394:[[2327,2364],512],2395:[[2332,2364],512],2396:[[2337,2364],512],2397:[[2338,2364],512],2398:[[2347,2364],512],2399:[[2351,2364],512],2492:[,7],2503:[,,{2494:2507,2519:2508}],2507:[[2503,2494]],2508:[[2503,2519]],2509:[,9],2524:[[2465,2492],512],2525:[[2466,2492],512],2527:[[2479,2492],512]},
2560:{2611:[[2610,2620],512],2614:[[2616,2620],512],2620:[,7],2637:[,9],2649:[[2582,2620],512],2650:[[2583,2620],512],2651:[[2588,2620],512],2654:[[2603,2620],512],2748:[,7],2765:[,9],68109:[,220],68111:[,230],68152:[,230],68153:[,1],68154:[,220],68159:[,9],68325:[,230],68326:[,220]},
2816:{2876:[,7],2887:[,,{2878:2891,2902:2888,2903:2892}],2888:[[2887,2902]],2891:[[2887,2878]],2892:[[2887,2903]],2893:[,9],2908:[[2849,2876],512],2909:[[2850,2876],512],2962:[,,{3031:2964}],2964:[[2962,3031]],3014:[,,{3006:3018,3031:3020}],3015:[,,{3006:3019}],3018:[[3014,3006]],3019:[[3015,3006]],3020:[[3014,3031]],3021:[,9]},
3072:{3142:[,,{3158:3144}],3144:[[3142,3158]],3149:[,9],3157:[,84],3158:[,91],3260:[,7],3263:[,,{3285:3264}],3264:[[3263,3285]],3270:[,,{3266:3274,3285:3271,3286:3272}],3271:[[3270,3285]],3272:[[3270,3286]],3274:[[3270,3266],,{3285:3275}],3275:[[3274,3285]],3277:[,9]},
3328:{3398:[,,{3390:3402,3415:3404}],3399:[,,{3390:3403}],3402:[[3398,3390]],3403:[[3399,3390]],3404:[[3398,3415]],3405:[,9],3530:[,9],3545:[,,{3530:3546,3535:3548,3551:3550}],3546:[[3545,3530]],3548:[[3545,3535],,{3530:3549}],3549:[[3548,3530]],3550:[[3545,3551]]},
3584:{3635:[[3661,3634],256],3640:[,103],3641:[,103],3642:[,9],3656:[,107],3657:[,107],3658:[,107],3659:[,107],3763:[[3789,3762],256],3768:[,118],3769:[,118],3784:[,122],3785:[,122],3786:[,122],3787:[,122],3804:[[3755,3737],256],3805:[[3755,3745],256]},
3840:{3852:[[3851],256],3864:[,220],3865:[,220],3893:[,220],3895:[,220],3897:[,216],3907:[[3906,4023],512],3917:[[3916,4023],512],3922:[[3921,4023],512],3927:[[3926,4023],512],3932:[[3931,4023],512],3945:[[3904,4021],512],3953:[,129],3954:[,130],3955:[[3953,3954],512],3956:[,132],3957:[[3953,3956],512],3958:[[4018,3968],512],3959:[[4018,3969],256],3960:[[4019,3968],512],3961:[[4019,3969],256],3962:[,130],3963:[,130],3964:[,130],3965:[,130],3968:[,130],3969:[[3953,3968],512],3970:[,230],3971:[,230],3972:[,9],3974:[,230],3975:[,230],3987:[[3986,4023],512],3997:[[3996,4023],512],4002:[[4001,4023],512],4007:[[4006,4023],512],4012:[[4011,4023],512],4025:[[3984,4021],512],4038:[,220]},
4096:{4133:[,,{4142:4134}],4134:[[4133,4142]],4151:[,7],4153:[,9],4154:[,9],4237:[,220],4348:[[4316],256],69702:[,9],69759:[,9],69785:[,,{69818:69786}],69786:[[69785,69818]],69787:[,,{69818:69788}],69788:[[69787,69818]],69797:[,,{69818:69803}],69803:[[69797,69818]],69817:[,9],69818:[,7]},
4352:{69888:[,230],69889:[,230],69890:[,230],69934:[[69937,69927]],69935:[[69938,69927]],69937:[,,{69927:69934}],69938:[,,{69927:69935}],69939:[,9],69940:[,9],70003:[,7],70080:[,9]},
4608:{70197:[,9],70198:[,7],70377:[,7],70378:[,9]},
4864:{4957:[,230],4958:[,230],4959:[,230],70460:[,7],70471:[,,{70462:70475,70487:70476}],70475:[[70471,70462]],70476:[[70471,70487]],70477:[,9],70502:[,230],70503:[,230],70504:[,230],70505:[,230],70506:[,230],70507:[,230],70508:[,230],70512:[,230],70513:[,230],70514:[,230],70515:[,230],70516:[,230]},
5120:{70841:[,,{70832:70844,70842:70843,70845:70846}],70843:[[70841,70842]],70844:[[70841,70832]],70846:[[70841,70845]],70850:[,9],70851:[,7]},
5376:{71096:[,,{71087:71098}],71097:[,,{71087:71099}],71098:[[71096,71087]],71099:[[71097,71087]],71103:[,9],71104:[,7]},
5632:{71231:[,9],71350:[,9],71351:[,7]},
5888:{5908:[,9],5940:[,9],6098:[,9],6109:[,230]},
6144:{6313:[,228]},
6400:{6457:[,222],6458:[,230],6459:[,220]},
6656:{6679:[,230],6680:[,220],6752:[,9],6773:[,230],6774:[,230],6775:[,230],6776:[,230],6777:[,230],6778:[,230],6779:[,230],6780:[,230],6783:[,220],6832:[,230],6833:[,230],6834:[,230],6835:[,230],6836:[,230],6837:[,220],6838:[,220],6839:[,220],6840:[,220],6841:[,220],6842:[,220],6843:[,230],6844:[,230],6845:[,220]},
6912:{6917:[,,{6965:6918}],6918:[[6917,6965]],6919:[,,{6965:6920}],6920:[[6919,6965]],6921:[,,{6965:6922}],6922:[[6921,6965]],6923:[,,{6965:6924}],6924:[[6923,6965]],6925:[,,{6965:6926}],6926:[[6925,6965]],6929:[,,{6965:6930}],6930:[[6929,6965]],6964:[,7],6970:[,,{6965:6971}],6971:[[6970,6965]],6972:[,,{6965:6973}],6973:[[6972,6965]],6974:[,,{6965:6976}],6975:[,,{6965:6977}],6976:[[6974,6965]],6977:[[6975,6965]],6978:[,,{6965:6979}],6979:[[6978,6965]],6980:[,9],7019:[,230],7020:[,220],7021:[,230],7022:[,230],7023:[,230],7024:[,230],7025:[,230],7026:[,230],7027:[,230],7082:[,9],7083:[,9],7142:[,7],7154:[,9],7155:[,9]},
7168:{7223:[,7],7376:[,230],7377:[,230],7378:[,230],7380:[,1],7381:[,220],7382:[,220],7383:[,220],7384:[,220],7385:[,220],7386:[,230],7387:[,230],7388:[,220],7389:[,220],7390:[,220],7391:[,220],7392:[,230],7394:[,1],7395:[,1],7396:[,1],7397:[,1],7398:[,1],7399:[,1],7400:[,1],7405:[,220],7412:[,230],7416:[,230],7417:[,230]},
7424:{7468:[[65],256],7469:[[198],256],7470:[[66],256],7472:[[68],256],7473:[[69],256],7474:[[398],256],7475:[[71],256],7476:[[72],256],7477:[[73],256],7478:[[74],256],7479:[[75],256],7480:[[76],256],7481:[[77],256],7482:[[78],256],7484:[[79],256],7485:[[546],256],7486:[[80],256],7487:[[82],256],7488:[[84],256],7489:[[85],256],7490:[[87],256],7491:[[97],256],7492:[[592],256],7493:[[593],256],7494:[[7426],256],7495:[[98],256],7496:[[100],256],7497:[[101],256],7498:[[601],256],7499:[[603],256],7500:[[604],256],7501:[[103],256],7503:[[107],256],7504:[[109],256],7505:[[331],256],7506:[[111],256],7507:[[596],256],7508:[[7446],256],7509:[[7447],256],7510:[[112],256],7511:[[116],256],7512:[[117],256],7513:[[7453],256],7514:[[623],256],7515:[[118],256],7516:[[7461],256],7517:[[946],256],7518:[[947],256],7519:[[948],256],7520:[[966],256],7521:[[967],256],7522:[[105],256],7523:[[114],256],7524:[[117],256],7525:[[118],256],7526:[[946],256],7527:[[947],256],7528:[[961],256],7529:[[966],256],7530:[[967],256],7544:[[1085],256],7579:[[594],256],7580:[[99],256],7581:[[597],256],7582:[[240],256],7583:[[604],256],7584:[[102],256],7585:[[607],256],7586:[[609],256],7587:[[613],256],7588:[[616],256],7589:[[617],256],7590:[[618],256],7591:[[7547],256],7592:[[669],256],7593:[[621],256],7594:[[7557],256],7595:[[671],256],7596:[[625],256],7597:[[624],256],7598:[[626],256],7599:[[627],256],7600:[[628],256],7601:[[629],256],7602:[[632],256],7603:[[642],256],7604:[[643],256],7605:[[427],256],7606:[[649],256],7607:[[650],256],7608:[[7452],256],7609:[[651],256],7610:[[652],256],7611:[[122],256],7612:[[656],256],7613:[[657],256],7614:[[658],256],7615:[[952],256],7616:[,230],7617:[,230],7618:[,220],7619:[,230],7620:[,230],7621:[,230],7622:[,230],7623:[,230],7624:[,230],7625:[,230],7626:[,220],7627:[,230],7628:[,230],7629:[,234],7630:[,214],7631:[,220],7632:[,202],7633:[,230],7634:[,230],7635:[,230],7636:[,230],7637:[,230],7638:[,230],7639:[,230],7640:[,230],7641:[,230],7642:[,230],7643:[,230],7644:[,230],7645:[,230],7646:[,230],7647:[,230],7648:[,230],7649:[,230],7650:[,230],7651:[,230],7652:[,230],7653:[,230],7654:[,230],7655:[,230],7656:[,230],7657:[,230],7658:[,230],7659:[,230],7660:[,230],7661:[,230],7662:[,230],7663:[,230],7664:[,230],7665:[,230],7666:[,230],7667:[,230],7668:[,230],7669:[,230],7676:[,233],7677:[,220],7678:[,230],7679:[,220]},
7680:{7680:[[65,805]],7681:[[97,805]],7682:[[66,775]],7683:[[98,775]],7684:[[66,803]],7685:[[98,803]],7686:[[66,817]],7687:[[98,817]],7688:[[199,769]],7689:[[231,769]],7690:[[68,775]],7691:[[100,775]],7692:[[68,803]],7693:[[100,803]],7694:[[68,817]],7695:[[100,817]],7696:[[68,807]],7697:[[100,807]],7698:[[68,813]],7699:[[100,813]],7700:[[274,768]],7701:[[275,768]],7702:[[274,769]],7703:[[275,769]],7704:[[69,813]],7705:[[101,813]],7706:[[69,816]],7707:[[101,816]],7708:[[552,774]],7709:[[553,774]],7710:[[70,775]],7711:[[102,775]],7712:[[71,772]],7713:[[103,772]],7714:[[72,775]],7715:[[104,775]],7716:[[72,803]],7717:[[104,803]],7718:[[72,776]],7719:[[104,776]],7720:[[72,807]],7721:[[104,807]],7722:[[72,814]],7723:[[104,814]],7724:[[73,816]],7725:[[105,816]],7726:[[207,769]],7727:[[239,769]],7728:[[75,769]],7729:[[107,769]],7730:[[75,803]],7731:[[107,803]],7732:[[75,817]],7733:[[107,817]],7734:[[76,803],,{772:7736}],7735:[[108,803],,{772:7737}],7736:[[7734,772]],7737:[[7735,772]],7738:[[76,817]],7739:[[108,817]],7740:[[76,813]],7741:[[108,813]],7742:[[77,769]],7743:[[109,769]],7744:[[77,775]],7745:[[109,775]],7746:[[77,803]],7747:[[109,803]],7748:[[78,775]],7749:[[110,775]],7750:[[78,803]],7751:[[110,803]],7752:[[78,817]],7753:[[110,817]],7754:[[78,813]],7755:[[110,813]],7756:[[213,769]],7757:[[245,769]],7758:[[213,776]],7759:[[245,776]],7760:[[332,768]],7761:[[333,768]],7762:[[332,769]],7763:[[333,769]],7764:[[80,769]],7765:[[112,769]],7766:[[80,775]],7767:[[112,775]],7768:[[82,775]],7769:[[114,775]],7770:[[82,803],,{772:7772}],7771:[[114,803],,{772:7773}],7772:[[7770,772]],7773:[[7771,772]],7774:[[82,817]],7775:[[114,817]],7776:[[83,775]],7777:[[115,775]],7778:[[83,803],,{775:7784}],7779:[[115,803],,{775:7785}],7780:[[346,775]],7781:[[347,775]],7782:[[352,775]],7783:[[353,775]],7784:[[7778,775]],7785:[[7779,775]],7786:[[84,775]],7787:[[116,775]],7788:[[84,803]],7789:[[116,803]],7790:[[84,817]],7791:[[116,817]],7792:[[84,813]],7793:[[116,813]],7794:[[85,804]],7795:[[117,804]],7796:[[85,816]],7797:[[117,816]],7798:[[85,813]],7799:[[117,813]],7800:[[360,769]],7801:[[361,769]],7802:[[362,776]],7803:[[363,776]],7804:[[86,771]],7805:[[118,771]],7806:[[86,803]],7807:[[118,803]],7808:[[87,768]],7809:[[119,768]],7810:[[87,769]],7811:[[119,769]],7812:[[87,776]],7813:[[119,776]],7814:[[87,775]],7815:[[119,775]],7816:[[87,803]],7817:[[119,803]],7818:[[88,775]],7819:[[120,775]],7820:[[88,776]],7821:[[120,776]],7822:[[89,775]],7823:[[121,775]],7824:[[90,770]],7825:[[122,770]],7826:[[90,803]],7827:[[122,803]],7828:[[90,817]],7829:[[122,817]],7830:[[104,817]],7831:[[116,776]],7832:[[119,778]],7833:[[121,778]],7834:[[97,702],256],7835:[[383,775]],7840:[[65,803],,{770:7852,774:7862}],7841:[[97,803],,{770:7853,774:7863}],7842:[[65,777]],7843:[[97,777]],7844:[[194,769]],7845:[[226,769]],7846:[[194,768]],7847:[[226,768]],7848:[[194,777]],7849:[[226,777]],7850:[[194,771]],7851:[[226,771]],7852:[[7840,770]],7853:[[7841,770]],7854:[[258,769]],7855:[[259,769]],7856:[[258,768]],7857:[[259,768]],7858:[[258,777]],7859:[[259,777]],7860:[[258,771]],7861:[[259,771]],7862:[[7840,774]],7863:[[7841,774]],7864:[[69,803],,{770:7878}],7865:[[101,803],,{770:7879}],7866:[[69,777]],7867:[[101,777]],7868:[[69,771]],7869:[[101,771]],7870:[[202,769]],7871:[[234,769]],7872:[[202,768]],7873:[[234,768]],7874:[[202,777]],7875:[[234,777]],7876:[[202,771]],7877:[[234,771]],7878:[[7864,770]],7879:[[7865,770]],7880:[[73,777]],7881:[[105,777]],7882:[[73,803]],7883:[[105,803]],7884:[[79,803],,{770:7896}],7885:[[111,803],,{770:7897}],7886:[[79,777]],7887:[[111,777]],7888:[[212,769]],7889:[[244,769]],7890:[[212,768]],7891:[[244,768]],7892:[[212,777]],7893:[[244,777]],7894:[[212,771]],7895:[[244,771]],7896:[[7884,770]],7897:[[7885,770]],7898:[[416,769]],7899:[[417,769]],7900:[[416,768]],7901:[[417,768]],7902:[[416,777]],7903:[[417,777]],7904:[[416,771]],7905:[[417,771]],7906:[[416,803]],7907:[[417,803]],7908:[[85,803]],7909:[[117,803]],7910:[[85,777]],7911:[[117,777]],7912:[[431,769]],7913:[[432,769]],7914:[[431,768]],7915:[[432,768]],7916:[[431,777]],7917:[[432,777]],7918:[[431,771]],7919:[[432,771]],7920:[[431,803]],7921:[[432,803]],7922:[[89,768]],7923:[[121,768]],7924:[[89,803]],7925:[[121,803]],7926:[[89,777]],7927:[[121,777]],7928:[[89,771]],7929:[[121,771]]},
7936:{7936:[[945,787],,{768:7938,769:7940,834:7942,837:8064}],7937:[[945,788],,{768:7939,769:7941,834:7943,837:8065}],7938:[[7936,768],,{837:8066}],7939:[[7937,768],,{837:8067}],7940:[[7936,769],,{837:8068}],7941:[[7937,769],,{837:8069}],7942:[[7936,834],,{837:8070}],7943:[[7937,834],,{837:8071}],7944:[[913,787],,{768:7946,769:7948,834:7950,837:8072}],7945:[[913,788],,{768:7947,769:7949,834:7951,837:8073}],7946:[[7944,768],,{837:8074}],7947:[[7945,768],,{837:8075}],7948:[[7944,769],,{837:8076}],7949:[[7945,769],,{837:8077}],7950:[[7944,834],,{837:8078}],7951:[[7945,834],,{837:8079}],7952:[[949,787],,{768:7954,769:7956}],7953:[[949,788],,{768:7955,769:7957}],7954:[[7952,768]],7955:[[7953,768]],7956:[[7952,769]],7957:[[7953,769]],7960:[[917,787],,{768:7962,769:7964}],7961:[[917,788],,{768:7963,769:7965}],7962:[[7960,768]],7963:[[7961,768]],7964:[[7960,769]],7965:[[7961,769]],7968:[[951,787],,{768:7970,769:7972,834:7974,837:8080}],7969:[[951,788],,{768:7971,769:7973,834:7975,837:8081}],7970:[[7968,768],,{837:8082}],7971:[[7969,768],,{837:8083}],7972:[[7968,769],,{837:8084}],7973:[[7969,769],,{837:8085}],7974:[[7968,834],,{837:8086}],7975:[[7969,834],,{837:8087}],7976:[[919,787],,{768:7978,769:7980,834:7982,837:8088}],7977:[[919,788],,{768:7979,769:7981,834:7983,837:8089}],7978:[[7976,768],,{837:8090}],7979:[[7977,768],,{837:8091}],7980:[[7976,769],,{837:8092}],7981:[[7977,769],,{837:8093}],7982:[[7976,834],,{837:8094}],7983:[[7977,834],,{837:8095}],7984:[[953,787],,{768:7986,769:7988,834:7990}],7985:[[953,788],,{768:7987,769:7989,834:7991}],7986:[[7984,768]],7987:[[7985,768]],7988:[[7984,769]],7989:[[7985,769]],7990:[[7984,834]],7991:[[7985,834]],7992:[[921,787],,{768:7994,769:7996,834:7998}],7993:[[921,788],,{768:7995,769:7997,834:7999}],7994:[[7992,768]],7995:[[7993,768]],7996:[[7992,769]],7997:[[7993,769]],7998:[[7992,834]],7999:[[7993,834]],8000:[[959,787],,{768:8002,769:8004}],8001:[[959,788],,{768:8003,769:8005}],8002:[[8000,768]],8003:[[8001,768]],8004:[[8000,769]],8005:[[8001,769]],8008:[[927,787],,{768:8010,769:8012}],8009:[[927,788],,{768:8011,769:8013}],8010:[[8008,768]],8011:[[8009,768]],8012:[[8008,769]],8013:[[8009,769]],8016:[[965,787],,{768:8018,769:8020,834:8022}],8017:[[965,788],,{768:8019,769:8021,834:8023}],8018:[[8016,768]],8019:[[8017,768]],8020:[[8016,769]],8021:[[8017,769]],8022:[[8016,834]],8023:[[8017,834]],8025:[[933,788],,{768:8027,769:8029,834:8031}],8027:[[8025,768]],8029:[[8025,769]],8031:[[8025,834]],8032:[[969,787],,{768:8034,769:8036,834:8038,837:8096}],8033:[[969,788],,{768:8035,769:8037,834:8039,837:8097}],8034:[[8032,768],,{837:8098}],8035:[[8033,768],,{837:8099}],8036:[[8032,769],,{837:8100}],8037:[[8033,769],,{837:8101}],8038:[[8032,834],,{837:8102}],8039:[[8033,834],,{837:8103}],8040:[[937,787],,{768:8042,769:8044,834:8046,837:8104}],8041:[[937,788],,{768:8043,769:8045,834:8047,837:8105}],8042:[[8040,768],,{837:8106}],8043:[[8041,768],,{837:8107}],8044:[[8040,769],,{837:8108}],8045:[[8041,769],,{837:8109}],8046:[[8040,834],,{837:8110}],8047:[[8041,834],,{837:8111}],8048:[[945,768],,{837:8114}],8049:[[940]],8050:[[949,768]],8051:[[941]],8052:[[951,768],,{837:8130}],8053:[[942]],8054:[[953,768]],8055:[[943]],8056:[[959,768]],8057:[[972]],8058:[[965,768]],8059:[[973]],8060:[[969,768],,{837:8178}],8061:[[974]],8064:[[7936,837]],8065:[[7937,837]],8066:[[7938,837]],8067:[[7939,837]],8068:[[7940,837]],8069:[[7941,837]],8070:[[7942,837]],8071:[[7943,837]],8072:[[7944,837]],8073:[[7945,837]],8074:[[7946,837]],8075:[[7947,837]],8076:[[7948,837]],8077:[[7949,837]],8078:[[7950,837]],8079:[[7951,837]],8080:[[7968,837]],8081:[[7969,837]],8082:[[7970,837]],8083:[[7971,837]],8084:[[7972,837]],8085:[[7973,837]],8086:[[7974,837]],8087:[[7975,837]],8088:[[7976,837]],8089:[[7977,837]],8090:[[7978,837]],8091:[[7979,837]],8092:[[7980,837]],8093:[[7981,837]],8094:[[7982,837]],8095:[[7983,837]],8096:[[8032,837]],8097:[[8033,837]],8098:[[8034,837]],8099:[[8035,837]],8100:[[8036,837]],8101:[[8037,837]],8102:[[8038,837]],8103:[[8039,837]],8104:[[8040,837]],8105:[[8041,837]],8106:[[8042,837]],8107:[[8043,837]],8108:[[8044,837]],8109:[[8045,837]],8110:[[8046,837]],8111:[[8047,837]],8112:[[945,774]],8113:[[945,772]],8114:[[8048,837]],8115:[[945,837]],8116:[[940,837]],8118:[[945,834],,{837:8119}],8119:[[8118,837]],8120:[[913,774]],8121:[[913,772]],8122:[[913,768]],8123:[[902]],8124:[[913,837]],8125:[[32,787],256],8126:[[953]],8127:[[32,787],256,{768:8141,769:8142,834:8143}],8128:[[32,834],256],8129:[[168,834]],8130:[[8052,837]],8131:[[951,837]],8132:[[942,837]],8134:[[951,834],,{837:8135}],8135:[[8134,837]],8136:[[917,768]],8137:[[904]],8138:[[919,768]],8139:[[905]],8140:[[919,837]],8141:[[8127,768]],8142:[[8127,769]],8143:[[8127,834]],8144:[[953,774]],8145:[[953,772]],8146:[[970,768]],8147:[[912]],8150:[[953,834]],8151:[[970,834]],8152:[[921,774]],8153:[[921,772]],8154:[[921,768]],8155:[[906]],8157:[[8190,768]],8158:[[8190,769]],8159:[[8190,834]],8160:[[965,774]],8161:[[965,772]],8162:[[971,768]],8163:[[944]],8164:[[961,787]],8165:[[961,788]],8166:[[965,834]],8167:[[971,834]],8168:[[933,774]],8169:[[933,772]],8170:[[933,768]],8171:[[910]],8172:[[929,788]],8173:[[168,768]],8174:[[901]],8175:[[96]],8178:[[8060,837]],8179:[[969,837]],8180:[[974,837]],8182:[[969,834],,{837:8183}],8183:[[8182,837]],8184:[[927,768]],8185:[[908]],8186:[[937,768]],8187:[[911]],8188:[[937,837]],8189:[[180]],8190:[[32,788],256,{768:8157,769:8158,834:8159}]},
8192:{8192:[[8194]],8193:[[8195]],8194:[[32],256],8195:[[32],256],8196:[[32],256],8197:[[32],256],8198:[[32],256],8199:[[32],256],8200:[[32],256],8201:[[32],256],8202:[[32],256],8209:[[8208],256],8215:[[32,819],256],8228:[[46],256],8229:[[46,46],256],8230:[[46,46,46],256],8239:[[32],256],8243:[[8242,8242],256],8244:[[8242,8242,8242],256],8246:[[8245,8245],256],8247:[[8245,8245,8245],256],8252:[[33,33],256],8254:[[32,773],256],8263:[[63,63],256],8264:[[63,33],256],8265:[[33,63],256],8279:[[8242,8242,8242,8242],256],8287:[[32],256],8304:[[48],256],8305:[[105],256],8308:[[52],256],8309:[[53],256],8310:[[54],256],8311:[[55],256],8312:[[56],256],8313:[[57],256],8314:[[43],256],8315:[[8722],256],8316:[[61],256],8317:[[40],256],8318:[[41],256],8319:[[110],256],8320:[[48],256],8321:[[49],256],8322:[[50],256],8323:[[51],256],8324:[[52],256],8325:[[53],256],8326:[[54],256],8327:[[55],256],8328:[[56],256],8329:[[57],256],8330:[[43],256],8331:[[8722],256],8332:[[61],256],8333:[[40],256],8334:[[41],256],8336:[[97],256],8337:[[101],256],8338:[[111],256],8339:[[120],256],8340:[[601],256],8341:[[104],256],8342:[[107],256],8343:[[108],256],8344:[[109],256],8345:[[110],256],8346:[[112],256],8347:[[115],256],8348:[[116],256],8360:[[82,115],256],8400:[,230],8401:[,230],8402:[,1],8403:[,1],8404:[,230],8405:[,230],8406:[,230],8407:[,230],8408:[,1],8409:[,1],8410:[,1],8411:[,230],8412:[,230],8417:[,230],8421:[,1],8422:[,1],8423:[,230],8424:[,220],8425:[,230],8426:[,1],8427:[,1],8428:[,220],8429:[,220],8430:[,220],8431:[,220],8432:[,230]},
8448:{8448:[[97,47,99],256],8449:[[97,47,115],256],8450:[[67],256],8451:[[176,67],256],8453:[[99,47,111],256],8454:[[99,47,117],256],8455:[[400],256],8457:[[176,70],256],8458:[[103],256],8459:[[72],256],8460:[[72],256],8461:[[72],256],8462:[[104],256],8463:[[295],256],8464:[[73],256],8465:[[73],256],8466:[[76],256],8467:[[108],256],8469:[[78],256],8470:[[78,111],256],8473:[[80],256],8474:[[81],256],8475:[[82],256],8476:[[82],256],8477:[[82],256],8480:[[83,77],256],8481:[[84,69,76],256],8482:[[84,77],256],8484:[[90],256],8486:[[937]],8488:[[90],256],8490:[[75]],8491:[[197]],8492:[[66],256],8493:[[67],256],8495:[[101],256],8496:[[69],256],8497:[[70],256],8499:[[77],256],8500:[[111],256],8501:[[1488],256],8502:[[1489],256],8503:[[1490],256],8504:[[1491],256],8505:[[105],256],8507:[[70,65,88],256],8508:[[960],256],8509:[[947],256],8510:[[915],256],8511:[[928],256],8512:[[8721],256],8517:[[68],256],8518:[[100],256],8519:[[101],256],8520:[[105],256],8521:[[106],256],8528:[[49,8260,55],256],8529:[[49,8260,57],256],8530:[[49,8260,49,48],256],8531:[[49,8260,51],256],8532:[[50,8260,51],256],8533:[[49,8260,53],256],8534:[[50,8260,53],256],8535:[[51,8260,53],256],8536:[[52,8260,53],256],8537:[[49,8260,54],256],8538:[[53,8260,54],256],8539:[[49,8260,56],256],8540:[[51,8260,56],256],8541:[[53,8260,56],256],8542:[[55,8260,56],256],8543:[[49,8260],256],8544:[[73],256],8545:[[73,73],256],8546:[[73,73,73],256],8547:[[73,86],256],8548:[[86],256],8549:[[86,73],256],8550:[[86,73,73],256],8551:[[86,73,73,73],256],8552:[[73,88],256],8553:[[88],256],8554:[[88,73],256],8555:[[88,73,73],256],8556:[[76],256],8557:[[67],256],8558:[[68],256],8559:[[77],256],8560:[[105],256],8561:[[105,105],256],8562:[[105,105,105],256],8563:[[105,118],256],8564:[[118],256],8565:[[118,105],256],8566:[[118,105,105],256],8567:[[118,105,105,105],256],8568:[[105,120],256],8569:[[120],256],8570:[[120,105],256],8571:[[120,105,105],256],8572:[[108],256],8573:[[99],256],8574:[[100],256],8575:[[109],256],8585:[[48,8260,51],256],8592:[,,{824:8602}],8594:[,,{824:8603}],8596:[,,{824:8622}],8602:[[8592,824]],8603:[[8594,824]],8622:[[8596,824]],8653:[[8656,824]],8654:[[8660,824]],8655:[[8658,824]],8656:[,,{824:8653}],8658:[,,{824:8655}],8660:[,,{824:8654}]},
8704:{8707:[,,{824:8708}],8708:[[8707,824]],8712:[,,{824:8713}],8713:[[8712,824]],8715:[,,{824:8716}],8716:[[8715,824]],8739:[,,{824:8740}],8740:[[8739,824]],8741:[,,{824:8742}],8742:[[8741,824]],8748:[[8747,8747],256],8749:[[8747,8747,8747],256],8751:[[8750,8750],256],8752:[[8750,8750,8750],256],8764:[,,{824:8769}],8769:[[8764,824]],8771:[,,{824:8772}],8772:[[8771,824]],8773:[,,{824:8775}],8775:[[8773,824]],8776:[,,{824:8777}],8777:[[8776,824]],8781:[,,{824:8813}],8800:[[61,824]],8801:[,,{824:8802}],8802:[[8801,824]],8804:[,,{824:8816}],8805:[,,{824:8817}],8813:[[8781,824]],8814:[[60,824]],8815:[[62,824]],8816:[[8804,824]],8817:[[8805,824]],8818:[,,{824:8820}],8819:[,,{824:8821}],8820:[[8818,824]],8821:[[8819,824]],8822:[,,{824:8824}],8823:[,,{824:8825}],8824:[[8822,824]],8825:[[8823,824]],8826:[,,{824:8832}],8827:[,,{824:8833}],8828:[,,{824:8928}],8829:[,,{824:8929}],8832:[[8826,824]],8833:[[8827,824]],8834:[,,{824:8836}],8835:[,,{824:8837}],8836:[[8834,824]],8837:[[8835,824]],8838:[,,{824:8840}],8839:[,,{824:8841}],8840:[[8838,824]],8841:[[8839,824]],8849:[,,{824:8930}],8850:[,,{824:8931}],8866:[,,{824:8876}],8872:[,,{824:8877}],8873:[,,{824:8878}],8875:[,,{824:8879}],8876:[[8866,824]],8877:[[8872,824]],8878:[[8873,824]],8879:[[8875,824]],8882:[,,{824:8938}],8883:[,,{824:8939}],8884:[,,{824:8940}],8885:[,,{824:8941}],8928:[[8828,824]],8929:[[8829,824]],8930:[[8849,824]],8931:[[8850,824]],8938:[[8882,824]],8939:[[8883,824]],8940:[[8884,824]],8941:[[8885,824]]},
8960:{9001:[[12296]],9002:[[12297]]},
9216:{9312:[[49],256],9313:[[50],256],9314:[[51],256],9315:[[52],256],9316:[[53],256],9317:[[54],256],9318:[[55],256],9319:[[56],256],9320:[[57],256],9321:[[49,48],256],9322:[[49,49],256],9323:[[49,50],256],9324:[[49,51],256],9325:[[49,52],256],9326:[[49,53],256],9327:[[49,54],256],9328:[[49,55],256],9329:[[49,56],256],9330:[[49,57],256],9331:[[50,48],256],9332:[[40,49,41],256],9333:[[40,50,41],256],9334:[[40,51,41],256],9335:[[40,52,41],256],9336:[[40,53,41],256],9337:[[40,54,41],256],9338:[[40,55,41],256],9339:[[40,56,41],256],9340:[[40,57,41],256],9341:[[40,49,48,41],256],9342:[[40,49,49,41],256],9343:[[40,49,50,41],256],9344:[[40,49,51,41],256],9345:[[40,49,52,41],256],9346:[[40,49,53,41],256],9347:[[40,49,54,41],256],9348:[[40,49,55,41],256],9349:[[40,49,56,41],256],9350:[[40,49,57,41],256],9351:[[40,50,48,41],256],9352:[[49,46],256],9353:[[50,46],256],9354:[[51,46],256],9355:[[52,46],256],9356:[[53,46],256],9357:[[54,46],256],9358:[[55,46],256],9359:[[56,46],256],9360:[[57,46],256],9361:[[49,48,46],256],9362:[[49,49,46],256],9363:[[49,50,46],256],9364:[[49,51,46],256],9365:[[49,52,46],256],9366:[[49,53,46],256],9367:[[49,54,46],256],9368:[[49,55,46],256],9369:[[49,56,46],256],9370:[[49,57,46],256],9371:[[50,48,46],256],9372:[[40,97,41],256],9373:[[40,98,41],256],9374:[[40,99,41],256],9375:[[40,100,41],256],9376:[[40,101,41],256],9377:[[40,102,41],256],9378:[[40,103,41],256],9379:[[40,104,41],256],9380:[[40,105,41],256],9381:[[40,106,41],256],9382:[[40,107,41],256],9383:[[40,108,41],256],9384:[[40,109,41],256],9385:[[40,110,41],256],9386:[[40,111,41],256],9387:[[40,112,41],256],9388:[[40,113,41],256],9389:[[40,114,41],256],9390:[[40,115,41],256],9391:[[40,116,41],256],9392:[[40,117,41],256],9393:[[40,118,41],256],9394:[[40,119,41],256],9395:[[40,120,41],256],9396:[[40,121,41],256],9397:[[40,122,41],256],9398:[[65],256],9399:[[66],256],9400:[[67],256],9401:[[68],256],9402:[[69],256],9403:[[70],256],9404:[[71],256],9405:[[72],256],9406:[[73],256],9407:[[74],256],9408:[[75],256],9409:[[76],256],9410:[[77],256],9411:[[78],256],9412:[[79],256],9413:[[80],256],9414:[[81],256],9415:[[82],256],9416:[[83],256],9417:[[84],256],9418:[[85],256],9419:[[86],256],9420:[[87],256],9421:[[88],256],9422:[[89],256],9423:[[90],256],9424:[[97],256],9425:[[98],256],9426:[[99],256],9427:[[100],256],9428:[[101],256],9429:[[102],256],9430:[[103],256],9431:[[104],256],9432:[[105],256],9433:[[106],256],9434:[[107],256],9435:[[108],256],9436:[[109],256],9437:[[110],256],9438:[[111],256],9439:[[112],256],9440:[[113],256],9441:[[114],256],9442:[[115],256],9443:[[116],256],9444:[[117],256],9445:[[118],256],9446:[[119],256],9447:[[120],256],9448:[[121],256],9449:[[122],256],9450:[[48],256]},
10752:{10764:[[8747,8747,8747,8747],256],10868:[[58,58,61],256],10869:[[61,61],256],10870:[[61,61,61],256],10972:[[10973,824],512]},
11264:{11388:[[106],256],11389:[[86],256],11503:[,230],11504:[,230],11505:[,230]},
11520:{11631:[[11617],256],11647:[,9],11744:[,230],11745:[,230],11746:[,230],11747:[,230],11748:[,230],11749:[,230],11750:[,230],11751:[,230],11752:[,230],11753:[,230],11754:[,230],11755:[,230],11756:[,230],11757:[,230],11758:[,230],11759:[,230],11760:[,230],11761:[,230],11762:[,230],11763:[,230],11764:[,230],11765:[,230],11766:[,230],11767:[,230],11768:[,230],11769:[,230],11770:[,230],11771:[,230],11772:[,230],11773:[,230],11774:[,230],11775:[,230]},
11776:{11935:[[27597],256],12019:[[40863],256]},
12032:{12032:[[19968],256],12033:[[20008],256],12034:[[20022],256],12035:[[20031],256],12036:[[20057],256],12037:[[20101],256],12038:[[20108],256],12039:[[20128],256],12040:[[20154],256],12041:[[20799],256],12042:[[20837],256],12043:[[20843],256],12044:[[20866],256],12045:[[20886],256],12046:[[20907],256],12047:[[20960],256],12048:[[20981],256],12049:[[20992],256],12050:[[21147],256],12051:[[21241],256],12052:[[21269],256],12053:[[21274],256],12054:[[21304],256],12055:[[21313],256],12056:[[21340],256],12057:[[21353],256],12058:[[21378],256],12059:[[21430],256],12060:[[21448],256],12061:[[21475],256],12062:[[22231],256],12063:[[22303],256],12064:[[22763],256],12065:[[22786],256],12066:[[22794],256],12067:[[22805],256],12068:[[22823],256],12069:[[22899],256],12070:[[23376],256],12071:[[23424],256],12072:[[23544],256],12073:[[23567],256],12074:[[23586],256],12075:[[23608],256],12076:[[23662],256],12077:[[23665],256],12078:[[24027],256],12079:[[24037],256],12080:[[24049],256],12081:[[24062],256],12082:[[24178],256],12083:[[24186],256],12084:[[24191],256],12085:[[24308],256],12086:[[24318],256],12087:[[24331],256],12088:[[24339],256],12089:[[24400],256],12090:[[24417],256],12091:[[24435],256],12092:[[24515],256],12093:[[25096],256],12094:[[25142],256],12095:[[25163],256],12096:[[25903],256],12097:[[25908],256],12098:[[25991],256],12099:[[26007],256],12100:[[26020],256],12101:[[26041],256],12102:[[26080],256],12103:[[26085],256],12104:[[26352],256],12105:[[26376],256],12106:[[26408],256],12107:[[27424],256],12108:[[27490],256],12109:[[27513],256],12110:[[27571],256],12111:[[27595],256],12112:[[27604],256],12113:[[27611],256],12114:[[27663],256],12115:[[27668],256],12116:[[27700],256],12117:[[28779],256],12118:[[29226],256],12119:[[29238],256],12120:[[29243],256],12121:[[29247],256],12122:[[29255],256],12123:[[29273],256],12124:[[29275],256],12125:[[29356],256],12126:[[29572],256],12127:[[29577],256],12128:[[29916],256],12129:[[29926],256],12130:[[29976],256],12131:[[29983],256],12132:[[29992],256],12133:[[30000],256],12134:[[30091],256],12135:[[30098],256],12136:[[30326],256],12137:[[30333],256],12138:[[30382],256],12139:[[30399],256],12140:[[30446],256],12141:[[30683],256],12142:[[30690],256],12143:[[30707],256],12144:[[31034],256],12145:[[31160],256],12146:[[31166],256],12147:[[31348],256],12148:[[31435],256],12149:[[31481],256],12150:[[31859],256],12151:[[31992],256],12152:[[32566],256],12153:[[32593],256],12154:[[32650],256],12155:[[32701],256],12156:[[32769],256],12157:[[32780],256],12158:[[32786],256],12159:[[32819],256],12160:[[32895],256],12161:[[32905],256],12162:[[33251],256],12163:[[33258],256],12164:[[33267],256],12165:[[33276],256],12166:[[33292],256],12167:[[33307],256],12168:[[33311],256],12169:[[33390],256],12170:[[33394],256],12171:[[33400],256],12172:[[34381],256],12173:[[34411],256],12174:[[34880],256],12175:[[34892],256],12176:[[34915],256],12177:[[35198],256],12178:[[35211],256],12179:[[35282],256],12180:[[35328],256],12181:[[35895],256],12182:[[35910],256],12183:[[35925],256],12184:[[35960],256],12185:[[35997],256],12186:[[36196],256],12187:[[36208],256],12188:[[36275],256],12189:[[36523],256],12190:[[36554],256],12191:[[36763],256],12192:[[36784],256],12193:[[36789],256],12194:[[37009],256],12195:[[37193],256],12196:[[37318],256],12197:[[37324],256],12198:[[37329],256],12199:[[38263],256],12200:[[38272],256],12201:[[38428],256],12202:[[38582],256],12203:[[38585],256],12204:[[38632],256],12205:[[38737],256],12206:[[38750],256],12207:[[38754],256],12208:[[38761],256],12209:[[38859],256],12210:[[38893],256],12211:[[38899],256],12212:[[38913],256],12213:[[39080],256],12214:[[39131],256],12215:[[39135],256],12216:[[39318],256],12217:[[39321],256],12218:[[39340],256],12219:[[39592],256],12220:[[39640],256],12221:[[39647],256],12222:[[39717],256],12223:[[39727],256],12224:[[39730],256],12225:[[39740],256],12226:[[39770],256],12227:[[40165],256],12228:[[40565],256],12229:[[40575],256],12230:[[40613],256],12231:[[40635],256],12232:[[40643],256],12233:[[40653],256],12234:[[40657],256],12235:[[40697],256],12236:[[40701],256],12237:[[40718],256],12238:[[40723],256],12239:[[40736],256],12240:[[40763],256],12241:[[40778],256],12242:[[40786],256],12243:[[40845],256],12244:[[40860],256],12245:[[40864],256]},
12288:{12288:[[32],256],12330:[,218],12331:[,228],12332:[,232],12333:[,222],12334:[,224],12335:[,224],12342:[[12306],256],12344:[[21313],256],12345:[[21316],256],12346:[[21317],256],12358:[,,{12441:12436}],12363:[,,{12441:12364}],12364:[[12363,12441]],12365:[,,{12441:12366}],12366:[[12365,12441]],12367:[,,{12441:12368}],12368:[[12367,12441]],12369:[,,{12441:12370}],12370:[[12369,12441]],12371:[,,{12441:12372}],12372:[[12371,12441]],12373:[,,{12441:12374}],12374:[[12373,12441]],12375:[,,{12441:12376}],12376:[[12375,12441]],12377:[,,{12441:12378}],12378:[[12377,12441]],12379:[,,{12441:12380}],12380:[[12379,12441]],12381:[,,{12441:12382}],12382:[[12381,12441]],12383:[,,{12441:12384}],12384:[[12383,12441]],12385:[,,{12441:12386}],12386:[[12385,12441]],12388:[,,{12441:12389}],12389:[[12388,12441]],12390:[,,{12441:12391}],12391:[[12390,12441]],12392:[,,{12441:12393}],12393:[[12392,12441]],12399:[,,{12441:12400,12442:12401}],12400:[[12399,12441]],12401:[[12399,12442]],12402:[,,{12441:12403,12442:12404}],12403:[[12402,12441]],12404:[[12402,12442]],12405:[,,{12441:12406,12442:12407}],12406:[[12405,12441]],12407:[[12405,12442]],12408:[,,{12441:12409,12442:12410}],12409:[[12408,12441]],12410:[[12408,12442]],12411:[,,{12441:12412,12442:12413}],12412:[[12411,12441]],12413:[[12411,12442]],12436:[[12358,12441]],12441:[,8],12442:[,8],12443:[[32,12441],256],12444:[[32,12442],256],12445:[,,{12441:12446}],12446:[[12445,12441]],12447:[[12424,12426],256],12454:[,,{12441:12532}],12459:[,,{12441:12460}],12460:[[12459,12441]],12461:[,,{12441:12462}],12462:[[12461,12441]],12463:[,,{12441:12464}],12464:[[12463,12441]],12465:[,,{12441:12466}],12466:[[12465,12441]],12467:[,,{12441:12468}],12468:[[12467,12441]],12469:[,,{12441:12470}],12470:[[12469,12441]],12471:[,,{12441:12472}],12472:[[12471,12441]],12473:[,,{12441:12474}],12474:[[12473,12441]],12475:[,,{12441:12476}],12476:[[12475,12441]],12477:[,,{12441:12478}],12478:[[12477,12441]],12479:[,,{12441:12480}],12480:[[12479,12441]],12481:[,,{12441:12482}],12482:[[12481,12441]],12484:[,,{12441:12485}],12485:[[12484,12441]],12486:[,,{12441:12487}],12487:[[12486,12441]],12488:[,,{12441:12489}],12489:[[12488,12441]],12495:[,,{12441:12496,12442:12497}],12496:[[12495,12441]],12497:[[12495,12442]],12498:[,,{12441:12499,12442:12500}],12499:[[12498,12441]],12500:[[12498,12442]],12501:[,,{12441:12502,12442:12503}],12502:[[12501,12441]],12503:[[12501,12442]],12504:[,,{12441:12505,12442:12506}],12505:[[12504,12441]],12506:[[12504,12442]],12507:[,,{12441:12508,12442:12509}],12508:[[12507,12441]],12509:[[12507,12442]],12527:[,,{12441:12535}],12528:[,,{12441:12536}],12529:[,,{12441:12537}],12530:[,,{12441:12538}],12532:[[12454,12441]],12535:[[12527,12441]],12536:[[12528,12441]],12537:[[12529,12441]],12538:[[12530,12441]],12541:[,,{12441:12542}],12542:[[12541,12441]],12543:[[12467,12488],256]},
12544:{12593:[[4352],256],12594:[[4353],256],12595:[[4522],256],12596:[[4354],256],12597:[[4524],256],12598:[[4525],256],12599:[[4355],256],12600:[[4356],256],12601:[[4357],256],12602:[[4528],256],12603:[[4529],256],12604:[[4530],256],12605:[[4531],256],12606:[[4532],256],12607:[[4533],256],12608:[[4378],256],12609:[[4358],256],12610:[[4359],256],12611:[[4360],256],12612:[[4385],256],12613:[[4361],256],12614:[[4362],256],12615:[[4363],256],12616:[[4364],256],12617:[[4365],256],12618:[[4366],256],12619:[[4367],256],12620:[[4368],256],12621:[[4369],256],12622:[[4370],256],12623:[[4449],256],12624:[[4450],256],12625:[[4451],256],12626:[[4452],256],12627:[[4453],256],12628:[[4454],256],12629:[[4455],256],12630:[[4456],256],12631:[[4457],256],12632:[[4458],256],12633:[[4459],256],12634:[[4460],256],12635:[[4461],256],12636:[[4462],256],12637:[[4463],256],12638:[[4464],256],12639:[[4465],256],12640:[[4466],256],12641:[[4467],256],12642:[[4468],256],12643:[[4469],256],12644:[[4448],256],12645:[[4372],256],12646:[[4373],256],12647:[[4551],256],12648:[[4552],256],12649:[[4556],256],12650:[[4558],256],12651:[[4563],256],12652:[[4567],256],12653:[[4569],256],12654:[[4380],256],12655:[[4573],256],12656:[[4575],256],12657:[[4381],256],12658:[[4382],256],12659:[[4384],256],12660:[[4386],256],12661:[[4387],256],12662:[[4391],256],12663:[[4393],256],12664:[[4395],256],12665:[[4396],256],12666:[[4397],256],12667:[[4398],256],12668:[[4399],256],12669:[[4402],256],12670:[[4406],256],12671:[[4416],256],12672:[[4423],256],12673:[[4428],256],12674:[[4593],256],12675:[[4594],256],12676:[[4439],256],12677:[[4440],256],12678:[[4441],256],12679:[[4484],256],12680:[[4485],256],12681:[[4488],256],12682:[[4497],256],12683:[[4498],256],12684:[[4500],256],12685:[[4510],256],12686:[[4513],256],12690:[[19968],256],12691:[[20108],256],12692:[[19977],256],12693:[[22235],256],12694:[[19978],256],12695:[[20013],256],12696:[[19979],256],12697:[[30002],256],12698:[[20057],256],12699:[[19993],256],12700:[[19969],256],12701:[[22825],256],12702:[[22320],256],12703:[[20154],256]},
12800:{12800:[[40,4352,41],256],12801:[[40,4354,41],256],12802:[[40,4355,41],256],12803:[[40,4357,41],256],12804:[[40,4358,41],256],12805:[[40,4359,41],256],12806:[[40,4361,41],256],12807:[[40,4363,41],256],12808:[[40,4364,41],256],12809:[[40,4366,41],256],12810:[[40,4367,41],256],12811:[[40,4368,41],256],12812:[[40,4369,41],256],12813:[[40,4370,41],256],12814:[[40,4352,4449,41],256],12815:[[40,4354,4449,41],256],12816:[[40,4355,4449,41],256],12817:[[40,4357,4449,41],256],12818:[[40,4358,4449,41],256],12819:[[40,4359,4449,41],256],12820:[[40,4361,4449,41],256],12821:[[40,4363,4449,41],256],12822:[[40,4364,4449,41],256],12823:[[40,4366,4449,41],256],12824:[[40,4367,4449,41],256],12825:[[40,4368,4449,41],256],12826:[[40,4369,4449,41],256],12827:[[40,4370,4449,41],256],12828:[[40,4364,4462,41],256],12829:[[40,4363,4457,4364,4453,4523,41],256],12830:[[40,4363,4457,4370,4462,41],256],12832:[[40,19968,41],256],12833:[[40,20108,41],256],12834:[[40,19977,41],256],12835:[[40,22235,41],256],12836:[[40,20116,41],256],12837:[[40,20845,41],256],12838:[[40,19971,41],256],12839:[[40,20843,41],256],12840:[[40,20061,41],256],12841:[[40,21313,41],256],12842:[[40,26376,41],256],12843:[[40,28779,41],256],12844:[[40,27700,41],256],12845:[[40,26408,41],256],12846:[[40,37329,41],256],12847:[[40,22303,41],256],12848:[[40,26085,41],256],12849:[[40,26666,41],256],12850:[[40,26377,41],256],12851:[[40,31038,41],256],12852:[[40,21517,41],256],12853:[[40,29305,41],256],12854:[[40,36001,41],256],12855:[[40,31069,41],256],12856:[[40,21172,41],256],12857:[[40,20195,41],256],12858:[[40,21628,41],256],12859:[[40,23398,41],256],12860:[[40,30435,41],256],12861:[[40,20225,41],256],12862:[[40,36039,41],256],12863:[[40,21332,41],256],12864:[[40,31085,41],256],12865:[[40,20241,41],256],12866:[[40,33258,41],256],12867:[[40,33267,41],256],12868:[[21839],256],12869:[[24188],256],12870:[[25991],256],12871:[[31631],256],12880:[[80,84,69],256],12881:[[50,49],256],12882:[[50,50],256],12883:[[50,51],256],12884:[[50,52],256],12885:[[50,53],256],12886:[[50,54],256],12887:[[50,55],256],12888:[[50,56],256],12889:[[50,57],256],12890:[[51,48],256],12891:[[51,49],256],12892:[[51,50],256],12893:[[51,51],256],12894:[[51,52],256],12895:[[51,53],256],12896:[[4352],256],12897:[[4354],256],12898:[[4355],256],12899:[[4357],256],12900:[[4358],256],12901:[[4359],256],12902:[[4361],256],12903:[[4363],256],12904:[[4364],256],12905:[[4366],256],12906:[[4367],256],12907:[[4368],256],12908:[[4369],256],12909:[[4370],256],12910:[[4352,4449],256],12911:[[4354,4449],256],12912:[[4355,4449],256],12913:[[4357,4449],256],12914:[[4358,4449],256],12915:[[4359,4449],256],12916:[[4361,4449],256],12917:[[4363,4449],256],12918:[[4364,4449],256],12919:[[4366,4449],256],12920:[[4367,4449],256],12921:[[4368,4449],256],12922:[[4369,4449],256],12923:[[4370,4449],256],12924:[[4366,4449,4535,4352,4457],256],12925:[[4364,4462,4363,4468],256],12926:[[4363,4462],256],12928:[[19968],256],12929:[[20108],256],12930:[[19977],256],12931:[[22235],256],12932:[[20116],256],12933:[[20845],256],12934:[[19971],256],12935:[[20843],256],12936:[[20061],256],12937:[[21313],256],12938:[[26376],256],12939:[[28779],256],12940:[[27700],256],12941:[[26408],256],12942:[[37329],256],12943:[[22303],256],12944:[[26085],256],12945:[[26666],256],12946:[[26377],256],12947:[[31038],256],12948:[[21517],256],12949:[[29305],256],12950:[[36001],256],12951:[[31069],256],12952:[[21172],256],12953:[[31192],256],12954:[[30007],256],12955:[[22899],256],12956:[[36969],256],12957:[[20778],256],12958:[[21360],256],12959:[[27880],256],12960:[[38917],256],12961:[[20241],256],12962:[[20889],256],12963:[[27491],256],12964:[[19978],256],12965:[[20013],256],12966:[[19979],256],12967:[[24038],256],12968:[[21491],256],12969:[[21307],256],12970:[[23447],256],12971:[[23398],256],12972:[[30435],256],12973:[[20225],256],12974:[[36039],256],12975:[[21332],256],12976:[[22812],256],12977:[[51,54],256],12978:[[51,55],256],12979:[[51,56],256],12980:[[51,57],256],12981:[[52,48],256],12982:[[52,49],256],12983:[[52,50],256],12984:[[52,51],256],12985:[[52,52],256],12986:[[52,53],256],12987:[[52,54],256],12988:[[52,55],256],12989:[[52,56],256],12990:[[52,57],256],12991:[[53,48],256],12992:[[49,26376],256],12993:[[50,26376],256],12994:[[51,26376],256],12995:[[52,26376],256],12996:[[53,26376],256],12997:[[54,26376],256],12998:[[55,26376],256],12999:[[56,26376],256],13000:[[57,26376],256],13001:[[49,48,26376],256],13002:[[49,49,26376],256],13003:[[49,50,26376],256],13004:[[72,103],256],13005:[[101,114,103],256],13006:[[101,86],256],13007:[[76,84,68],256],13008:[[12450],256],13009:[[12452],256],13010:[[12454],256],13011:[[12456],256],13012:[[12458],256],13013:[[12459],256],13014:[[12461],256],13015:[[12463],256],13016:[[12465],256],13017:[[12467],256],13018:[[12469],256],13019:[[12471],256],13020:[[12473],256],13021:[[12475],256],13022:[[12477],256],13023:[[12479],256],13024:[[12481],256],13025:[[12484],256],13026:[[12486],256],13027:[[12488],256],13028:[[12490],256],13029:[[12491],256],13030:[[12492],256],13031:[[12493],256],13032:[[12494],256],13033:[[12495],256],13034:[[12498],256],13035:[[12501],256],13036:[[12504],256],13037:[[12507],256],13038:[[12510],256],13039:[[12511],256],13040:[[12512],256],13041:[[12513],256],13042:[[12514],256],13043:[[12516],256],13044:[[12518],256],13045:[[12520],256],13046:[[12521],256],13047:[[12522],256],13048:[[12523],256],13049:[[12524],256],13050:[[12525],256],13051:[[12527],256],13052:[[12528],256],13053:[[12529],256],13054:[[12530],256]},
13056:{13056:[[12450,12497,12540,12488],256],13057:[[12450,12523,12501,12449],256],13058:[[12450,12531,12506,12450],256],13059:[[12450,12540,12523],256],13060:[[12452,12491,12531,12464],256],13061:[[12452,12531,12481],256],13062:[[12454,12457,12531],256],13063:[[12456,12473,12463,12540,12489],256],13064:[[12456,12540,12459,12540],256],13065:[[12458,12531,12473],256],13066:[[12458,12540,12512],256],13067:[[12459,12452,12522],256],13068:[[12459,12521,12483,12488],256],13069:[[12459,12525,12522,12540],256],13070:[[12460,12525,12531],256],13071:[[12460,12531,12510],256],13072:[[12462,12460],256],13073:[[12462,12491,12540],256],13074:[[12461,12517,12522,12540],256],13075:[[12462,12523,12480,12540],256],13076:[[12461,12525],256],13077:[[12461,12525,12464,12521,12512],256],13078:[[12461,12525,12513,12540,12488,12523],256],13079:[[12461,12525,12527,12483,12488],256],13080:[[12464,12521,12512],256],13081:[[12464,12521,12512,12488,12531],256],13082:[[12463,12523,12476,12452,12525],256],13083:[[12463,12525,12540,12493],256],13084:[[12465,12540,12473],256],13085:[[12467,12523,12490],256],13086:[[12467,12540,12509],256],13087:[[12469,12452,12463,12523],256],13088:[[12469,12531,12481,12540,12512],256],13089:[[12471,12522,12531,12464],256],13090:[[12475,12531,12481],256],13091:[[12475,12531,12488],256],13092:[[12480,12540,12473],256],13093:[[12487,12471],256],13094:[[12489,12523],256],13095:[[12488,12531],256],13096:[[12490,12494],256],13097:[[12494,12483,12488],256],13098:[[12495,12452,12484],256],13099:[[12497,12540,12475,12531,12488],256],13100:[[12497,12540,12484],256],13101:[[12496,12540,12524,12523],256],13102:[[12500,12450,12473,12488,12523],256],13103:[[12500,12463,12523],256],13104:[[12500,12467],256],13105:[[12499,12523],256],13106:[[12501,12449,12521,12483,12489],256],13107:[[12501,12451,12540,12488],256],13108:[[12502,12483,12471,12455,12523],256],13109:[[12501,12521,12531],256],13110:[[12504,12463,12479,12540,12523],256],13111:[[12506,12477],256],13112:[[12506,12491,12498],256],13113:[[12504,12523,12484],256],13114:[[12506,12531,12473],256],13115:[[12506,12540,12472],256],13116:[[12505,12540,12479],256],13117:[[12509,12452,12531,12488],256],13118:[[12508,12523,12488],256],13119:[[12507,12531],256],13120:[[12509,12531,12489],256],13121:[[12507,12540,12523],256],13122:[[12507,12540,12531],256],13123:[[12510,12452,12463,12525],256],13124:[[12510,12452,12523],256],13125:[[12510,12483,12495],256],13126:[[12510,12523,12463],256],13127:[[12510,12531,12471,12519,12531],256],13128:[[12511,12463,12525,12531],256],13129:[[12511,12522],256],13130:[[12511,12522,12496,12540,12523],256],13131:[[12513,12460],256],13132:[[12513,12460,12488,12531],256],13133:[[12513,12540,12488,12523],256],13134:[[12516,12540,12489],256],13135:[[12516,12540,12523],256],13136:[[12518,12450,12531],256],13137:[[12522,12483,12488,12523],256],13138:[[12522,12521],256],13139:[[12523,12500,12540],256],13140:[[12523,12540,12502,12523],256],13141:[[12524,12512],256],13142:[[12524,12531,12488,12466,12531],256],13143:[[12527,12483,12488],256],13144:[[48,28857],256],13145:[[49,28857],256],13146:[[50,28857],256],13147:[[51,28857],256],13148:[[52,28857],256],13149:[[53,28857],256],13150:[[54,28857],256],13151:[[55,28857],256],13152:[[56,28857],256],13153:[[57,28857],256],13154:[[49,48,28857],256],13155:[[49,49,28857],256],13156:[[49,50,28857],256],13157:[[49,51,28857],256],13158:[[49,52,28857],256],13159:[[49,53,28857],256],13160:[[49,54,28857],256],13161:[[49,55,28857],256],13162:[[49,56,28857],256],13163:[[49,57,28857],256],13164:[[50,48,28857],256],13165:[[50,49,28857],256],13166:[[50,50,28857],256],13167:[[50,51,28857],256],13168:[[50,52,28857],256],13169:[[104,80,97],256],13170:[[100,97],256],13171:[[65,85],256],13172:[[98,97,114],256],13173:[[111,86],256],13174:[[112,99],256],13175:[[100,109],256],13176:[[100,109,178],256],13177:[[100,109,179],256],13178:[[73,85],256],13179:[[24179,25104],256],13180:[[26157,21644],256],13181:[[22823,27491],256],13182:[[26126,27835],256],13183:[[26666,24335,20250,31038],256],13184:[[112,65],256],13185:[[110,65],256],13186:[[956,65],256],13187:[[109,65],256],13188:[[107,65],256],13189:[[75,66],256],13190:[[77,66],256],13191:[[71,66],256],13192:[[99,97,108],256],13193:[[107,99,97,108],256],13194:[[112,70],256],13195:[[110,70],256],13196:[[956,70],256],13197:[[956,103],256],13198:[[109,103],256],13199:[[107,103],256],13200:[[72,122],256],13201:[[107,72,122],256],13202:[[77,72,122],256],13203:[[71,72,122],256],13204:[[84,72,122],256],13205:[[956,8467],256],13206:[[109,8467],256],13207:[[100,8467],256],13208:[[107,8467],256],13209:[[102,109],256],13210:[[110,109],256],13211:[[956,109],256],13212:[[109,109],256],13213:[[99,109],256],13214:[[107,109],256],13215:[[109,109,178],256],13216:[[99,109,178],256],13217:[[109,178],256],13218:[[107,109,178],256],13219:[[109,109,179],256],13220:[[99,109,179],256],13221:[[109,179],256],13222:[[107,109,179],256],13223:[[109,8725,115],256],13224:[[109,8725,115,178],256],13225:[[80,97],256],13226:[[107,80,97],256],13227:[[77,80,97],256],13228:[[71,80,97],256],13229:[[114,97,100],256],13230:[[114,97,100,8725,115],256],13231:[[114,97,100,8725,115,178],256],13232:[[112,115],256],13233:[[110,115],256],13234:[[956,115],256],13235:[[109,115],256],13236:[[112,86],256],13237:[[110,86],256],13238:[[956,86],256],13239:[[109,86],256],13240:[[107,86],256],13241:[[77,86],256],13242:[[112,87],256],13243:[[110,87],256],13244:[[956,87],256],13245:[[109,87],256],13246:[[107,87],256],13247:[[77,87],256],13248:[[107,937],256],13249:[[77,937],256],13250:[[97,46,109,46],256],13251:[[66,113],256],13252:[[99,99],256],13253:[[99,100],256],13254:[[67,8725,107,103],256],13255:[[67,111,46],256],13256:[[100,66],256],13257:[[71,121],256],13258:[[104,97],256],13259:[[72,80],256],13260:[[105,110],256],13261:[[75,75],256],13262:[[75,77],256],13263:[[107,116],256],13264:[[108,109],256],13265:[[108,110],256],13266:[[108,111,103],256],13267:[[108,120],256],13268:[[109,98],256],13269:[[109,105,108],256],13270:[[109,111,108],256],13271:[[80,72],256],13272:[[112,46,109,46],256],13273:[[80,80,77],256],13274:[[80,82],256],13275:[[115,114],256],13276:[[83,118],256],13277:[[87,98],256],13278:[[86,8725,109],256],13279:[[65,8725,109],256],13280:[[49,26085],256],13281:[[50,26085],256],13282:[[51,26085],256],13283:[[52,26085],256],13284:[[53,26085],256],13285:[[54,26085],256],13286:[[55,26085],256],13287:[[56,26085],256],13288:[[57,26085],256],13289:[[49,48,26085],256],13290:[[49,49,26085],256],13291:[[49,50,26085],256],13292:[[49,51,26085],256],13293:[[49,52,26085],256],13294:[[49,53,26085],256],13295:[[49,54,26085],256],13296:[[49,55,26085],256],13297:[[49,56,26085],256],13298:[[49,57,26085],256],13299:[[50,48,26085],256],13300:[[50,49,26085],256],13301:[[50,50,26085],256],13302:[[50,51,26085],256],13303:[[50,52,26085],256],13304:[[50,53,26085],256],13305:[[50,54,26085],256],13306:[[50,55,26085],256],13307:[[50,56,26085],256],13308:[[50,57,26085],256],13309:[[51,48,26085],256],13310:[[51,49,26085],256],13311:[[103,97,108],256]},
27136:{92912:[,1],92913:[,1],92914:[,1],92915:[,1],92916:[,1]},
27392:{92976:[,230],92977:[,230],92978:[,230],92979:[,230],92980:[,230],92981:[,230],92982:[,230]},
42496:{42607:[,230],42612:[,230],42613:[,230],42614:[,230],42615:[,230],42616:[,230],42617:[,230],42618:[,230],42619:[,230],42620:[,230],42621:[,230],42652:[[1098],256],42653:[[1100],256],42655:[,230],42736:[,230],42737:[,230]},
42752:{42864:[[42863],256],43000:[[294],256],43001:[[339],256]},
43008:{43014:[,9],43204:[,9],43232:[,230],43233:[,230],43234:[,230],43235:[,230],43236:[,230],43237:[,230],43238:[,230],43239:[,230],43240:[,230],43241:[,230],43242:[,230],43243:[,230],43244:[,230],43245:[,230],43246:[,230],43247:[,230],43248:[,230],43249:[,230]},
43264:{43307:[,220],43308:[,220],43309:[,220],43347:[,9],43443:[,7],43456:[,9]},
43520:{43696:[,230],43698:[,230],43699:[,230],43700:[,220],43703:[,230],43704:[,230],43710:[,230],43711:[,230],43713:[,230],43766:[,9]},
43776:{43868:[[42791],256],43869:[[43831],256],43870:[[619],256],43871:[[43858],256],44013:[,9]},
48128:{113822:[,1]},
53504:{119134:[[119127,119141],512],119135:[[119128,119141],512],119136:[[119135,119150],512],119137:[[119135,119151],512],119138:[[119135,119152],512],119139:[[119135,119153],512],119140:[[119135,119154],512],119141:[,216],119142:[,216],119143:[,1],119144:[,1],119145:[,1],119149:[,226],119150:[,216],119151:[,216],119152:[,216],119153:[,216],119154:[,216],119163:[,220],119164:[,220],119165:[,220],119166:[,220],119167:[,220],119168:[,220],119169:[,220],119170:[,220],119173:[,230],119174:[,230],119175:[,230],119176:[,230],119177:[,230],119178:[,220],119179:[,220],119210:[,230],119211:[,230],119212:[,230],119213:[,230],119227:[[119225,119141],512],119228:[[119226,119141],512],119229:[[119227,119150],512],119230:[[119228,119150],512],119231:[[119227,119151],512],119232:[[119228,119151],512]},
53760:{119362:[,230],119363:[,230],119364:[,230]},
54272:{119808:[[65],256],119809:[[66],256],119810:[[67],256],119811:[[68],256],119812:[[69],256],119813:[[70],256],119814:[[71],256],119815:[[72],256],119816:[[73],256],119817:[[74],256],119818:[[75],256],119819:[[76],256],119820:[[77],256],119821:[[78],256],119822:[[79],256],119823:[[80],256],119824:[[81],256],119825:[[82],256],119826:[[83],256],119827:[[84],256],119828:[[85],256],119829:[[86],256],119830:[[87],256],119831:[[88],256],119832:[[89],256],119833:[[90],256],119834:[[97],256],119835:[[98],256],119836:[[99],256],119837:[[100],256],119838:[[101],256],119839:[[102],256],119840:[[103],256],119841:[[104],256],119842:[[105],256],119843:[[106],256],119844:[[107],256],119845:[[108],256],119846:[[109],256],119847:[[110],256],119848:[[111],256],119849:[[112],256],119850:[[113],256],119851:[[114],256],119852:[[115],256],119853:[[116],256],119854:[[117],256],119855:[[118],256],119856:[[119],256],119857:[[120],256],119858:[[121],256],119859:[[122],256],119860:[[65],256],119861:[[66],256],119862:[[67],256],119863:[[68],256],119864:[[69],256],119865:[[70],256],119866:[[71],256],119867:[[72],256],119868:[[73],256],119869:[[74],256],119870:[[75],256],119871:[[76],256],119872:[[77],256],119873:[[78],256],119874:[[79],256],119875:[[80],256],119876:[[81],256],119877:[[82],256],119878:[[83],256],119879:[[84],256],119880:[[85],256],119881:[[86],256],119882:[[87],256],119883:[[88],256],119884:[[89],256],119885:[[90],256],119886:[[97],256],119887:[[98],256],119888:[[99],256],119889:[[100],256],119890:[[101],256],119891:[[102],256],119892:[[103],256],119894:[[105],256],119895:[[106],256],119896:[[107],256],119897:[[108],256],119898:[[109],256],119899:[[110],256],119900:[[111],256],119901:[[112],256],119902:[[113],256],119903:[[114],256],119904:[[115],256],119905:[[116],256],119906:[[117],256],119907:[[118],256],119908:[[119],256],119909:[[120],256],119910:[[121],256],119911:[[122],256],119912:[[65],256],119913:[[66],256],119914:[[67],256],119915:[[68],256],119916:[[69],256],119917:[[70],256],119918:[[71],256],119919:[[72],256],119920:[[73],256],119921:[[74],256],119922:[[75],256],119923:[[76],256],119924:[[77],256],119925:[[78],256],119926:[[79],256],119927:[[80],256],119928:[[81],256],119929:[[82],256],119930:[[83],256],119931:[[84],256],119932:[[85],256],119933:[[86],256],119934:[[87],256],119935:[[88],256],119936:[[89],256],119937:[[90],256],119938:[[97],256],119939:[[98],256],119940:[[99],256],119941:[[100],256],119942:[[101],256],119943:[[102],256],119944:[[103],256],119945:[[104],256],119946:[[105],256],119947:[[106],256],119948:[[107],256],119949:[[108],256],119950:[[109],256],119951:[[110],256],119952:[[111],256],119953:[[112],256],119954:[[113],256],119955:[[114],256],119956:[[115],256],119957:[[116],256],119958:[[117],256],119959:[[118],256],119960:[[119],256],119961:[[120],256],119962:[[121],256],119963:[[122],256],119964:[[65],256],119966:[[67],256],119967:[[68],256],119970:[[71],256],119973:[[74],256],119974:[[75],256],119977:[[78],256],119978:[[79],256],119979:[[80],256],119980:[[81],256],119982:[[83],256],119983:[[84],256],119984:[[85],256],119985:[[86],256],119986:[[87],256],119987:[[88],256],119988:[[89],256],119989:[[90],256],119990:[[97],256],119991:[[98],256],119992:[[99],256],119993:[[100],256],119995:[[102],256],119997:[[104],256],119998:[[105],256],119999:[[106],256],120000:[[107],256],120001:[[108],256],120002:[[109],256],120003:[[110],256],120005:[[112],256],120006:[[113],256],120007:[[114],256],120008:[[115],256],120009:[[116],256],120010:[[117],256],120011:[[118],256],120012:[[119],256],120013:[[120],256],120014:[[121],256],120015:[[122],256],120016:[[65],256],120017:[[66],256],120018:[[67],256],120019:[[68],256],120020:[[69],256],120021:[[70],256],120022:[[71],256],120023:[[72],256],120024:[[73],256],120025:[[74],256],120026:[[75],256],120027:[[76],256],120028:[[77],256],120029:[[78],256],120030:[[79],256],120031:[[80],256],120032:[[81],256],120033:[[82],256],120034:[[83],256],120035:[[84],256],120036:[[85],256],120037:[[86],256],120038:[[87],256],120039:[[88],256],120040:[[89],256],120041:[[90],256],120042:[[97],256],120043:[[98],256],120044:[[99],256],120045:[[100],256],120046:[[101],256],120047:[[102],256],120048:[[103],256],120049:[[104],256],120050:[[105],256],120051:[[106],256],120052:[[107],256],120053:[[108],256],120054:[[109],256],120055:[[110],256],120056:[[111],256],120057:[[112],256],120058:[[113],256],120059:[[114],256],120060:[[115],256],120061:[[116],256],120062:[[117],256],120063:[[118],256]},
54528:{120064:[[119],256],120065:[[120],256],120066:[[121],256],120067:[[122],256],120068:[[65],256],120069:[[66],256],120071:[[68],256],120072:[[69],256],120073:[[70],256],120074:[[71],256],120077:[[74],256],120078:[[75],256],120079:[[76],256],120080:[[77],256],120081:[[78],256],120082:[[79],256],120083:[[80],256],120084:[[81],256],120086:[[83],256],120087:[[84],256],120088:[[85],256],120089:[[86],256],120090:[[87],256],120091:[[88],256],120092:[[89],256],120094:[[97],256],120095:[[98],256],120096:[[99],256],120097:[[100],256],120098:[[101],256],120099:[[102],256],120100:[[103],256],120101:[[104],256],120102:[[105],256],120103:[[106],256],120104:[[107],256],120105:[[108],256],120106:[[109],256],120107:[[110],256],120108:[[111],256],120109:[[112],256],120110:[[113],256],120111:[[114],256],120112:[[115],256],120113:[[116],256],120114:[[117],256],120115:[[118],256],120116:[[119],256],120117:[[120],256],120118:[[121],256],120119:[[122],256],120120:[[65],256],120121:[[66],256],120123:[[68],256],120124:[[69],256],120125:[[70],256],120126:[[71],256],120128:[[73],256],120129:[[74],256],120130:[[75],256],120131:[[76],256],120132:[[77],256],120134:[[79],256],120138:[[83],256],120139:[[84],256],120140:[[85],256],120141:[[86],256],120142:[[87],256],120143:[[88],256],120144:[[89],256],120146:[[97],256],120147:[[98],256],120148:[[99],256],120149:[[100],256],120150:[[101],256],120151:[[102],256],120152:[[103],256],120153:[[104],256],120154:[[105],256],120155:[[106],256],120156:[[107],256],120157:[[108],256],120158:[[109],256],120159:[[110],256],120160:[[111],256],120161:[[112],256],120162:[[113],256],120163:[[114],256],120164:[[115],256],120165:[[116],256],120166:[[117],256],120167:[[118],256],120168:[[119],256],120169:[[120],256],120170:[[121],256],120171:[[122],256],120172:[[65],256],120173:[[66],256],120174:[[67],256],120175:[[68],256],120176:[[69],256],120177:[[70],256],120178:[[71],256],120179:[[72],256],120180:[[73],256],120181:[[74],256],120182:[[75],256],120183:[[76],256],120184:[[77],256],120185:[[78],256],120186:[[79],256],120187:[[80],256],120188:[[81],256],120189:[[82],256],120190:[[83],256],120191:[[84],256],120192:[[85],256],120193:[[86],256],120194:[[87],256],120195:[[88],256],120196:[[89],256],120197:[[90],256],120198:[[97],256],120199:[[98],256],120200:[[99],256],120201:[[100],256],120202:[[101],256],120203:[[102],256],120204:[[103],256],120205:[[104],256],120206:[[105],256],120207:[[106],256],120208:[[107],256],120209:[[108],256],120210:[[109],256],120211:[[110],256],120212:[[111],256],120213:[[112],256],120214:[[113],256],120215:[[114],256],120216:[[115],256],120217:[[116],256],120218:[[117],256],120219:[[118],256],120220:[[119],256],120221:[[120],256],120222:[[121],256],120223:[[122],256],120224:[[65],256],120225:[[66],256],120226:[[67],256],120227:[[68],256],120228:[[69],256],120229:[[70],256],120230:[[71],256],120231:[[72],256],120232:[[73],256],120233:[[74],256],120234:[[75],256],120235:[[76],256],120236:[[77],256],120237:[[78],256],120238:[[79],256],120239:[[80],256],120240:[[81],256],120241:[[82],256],120242:[[83],256],120243:[[84],256],120244:[[85],256],120245:[[86],256],120246:[[87],256],120247:[[88],256],120248:[[89],256],120249:[[90],256],120250:[[97],256],120251:[[98],256],120252:[[99],256],120253:[[100],256],120254:[[101],256],120255:[[102],256],120256:[[103],256],120257:[[104],256],120258:[[105],256],120259:[[106],256],120260:[[107],256],120261:[[108],256],120262:[[109],256],120263:[[110],256],120264:[[111],256],120265:[[112],256],120266:[[113],256],120267:[[114],256],120268:[[115],256],120269:[[116],256],120270:[[117],256],120271:[[118],256],120272:[[119],256],120273:[[120],256],120274:[[121],256],120275:[[122],256],120276:[[65],256],120277:[[66],256],120278:[[67],256],120279:[[68],256],120280:[[69],256],120281:[[70],256],120282:[[71],256],120283:[[72],256],120284:[[73],256],120285:[[74],256],120286:[[75],256],120287:[[76],256],120288:[[77],256],120289:[[78],256],120290:[[79],256],120291:[[80],256],120292:[[81],256],120293:[[82],256],120294:[[83],256],120295:[[84],256],120296:[[85],256],120297:[[86],256],120298:[[87],256],120299:[[88],256],120300:[[89],256],120301:[[90],256],120302:[[97],256],120303:[[98],256],120304:[[99],256],120305:[[100],256],120306:[[101],256],120307:[[102],256],120308:[[103],256],120309:[[104],256],120310:[[105],256],120311:[[106],256],120312:[[107],256],120313:[[108],256],120314:[[109],256],120315:[[110],256],120316:[[111],256],120317:[[112],256],120318:[[113],256],120319:[[114],256]},
54784:{120320:[[115],256],120321:[[116],256],120322:[[117],256],120323:[[118],256],120324:[[119],256],120325:[[120],256],120326:[[121],256],120327:[[122],256],120328:[[65],256],120329:[[66],256],120330:[[67],256],120331:[[68],256],120332:[[69],256],120333:[[70],256],120334:[[71],256],120335:[[72],256],120336:[[73],256],120337:[[74],256],120338:[[75],256],120339:[[76],256],120340:[[77],256],120341:[[78],256],120342:[[79],256],120343:[[80],256],120344:[[81],256],120345:[[82],256],120346:[[83],256],120347:[[84],256],120348:[[85],256],120349:[[86],256],120350:[[87],256],120351:[[88],256],120352:[[89],256],120353:[[90],256],120354:[[97],256],120355:[[98],256],120356:[[99],256],120357:[[100],256],120358:[[101],256],120359:[[102],256],120360:[[103],256],120361:[[104],256],120362:[[105],256],120363:[[106],256],120364:[[107],256],120365:[[108],256],120366:[[109],256],120367:[[110],256],120368:[[111],256],120369:[[112],256],120370:[[113],256],120371:[[114],256],120372:[[115],256],120373:[[116],256],120374:[[117],256],120375:[[118],256],120376:[[119],256],120377:[[120],256],120378:[[121],256],120379:[[122],256],120380:[[65],256],120381:[[66],256],120382:[[67],256],120383:[[68],256],120384:[[69],256],120385:[[70],256],120386:[[71],256],120387:[[72],256],120388:[[73],256],120389:[[74],256],120390:[[75],256],120391:[[76],256],120392:[[77],256],120393:[[78],256],120394:[[79],256],120395:[[80],256],120396:[[81],256],120397:[[82],256],120398:[[83],256],120399:[[84],256],120400:[[85],256],120401:[[86],256],120402:[[87],256],120403:[[88],256],120404:[[89],256],120405:[[90],256],120406:[[97],256],120407:[[98],256],120408:[[99],256],120409:[[100],256],120410:[[101],256],120411:[[102],256],120412:[[103],256],120413:[[104],256],120414:[[105],256],120415:[[106],256],120416:[[107],256],120417:[[108],256],120418:[[109],256],120419:[[110],256],120420:[[111],256],120421:[[112],256],120422:[[113],256],120423:[[114],256],120424:[[115],256],120425:[[116],256],120426:[[117],256],120427:[[118],256],120428:[[119],256],120429:[[120],256],120430:[[121],256],120431:[[122],256],120432:[[65],256],120433:[[66],256],120434:[[67],256],120435:[[68],256],120436:[[69],256],120437:[[70],256],120438:[[71],256],120439:[[72],256],120440:[[73],256],120441:[[74],256],120442:[[75],256],120443:[[76],256],120444:[[77],256],120445:[[78],256],120446:[[79],256],120447:[[80],256],120448:[[81],256],120449:[[82],256],120450:[[83],256],120451:[[84],256],120452:[[85],256],120453:[[86],256],120454:[[87],256],120455:[[88],256],120456:[[89],256],120457:[[90],256],120458:[[97],256],120459:[[98],256],120460:[[99],256],120461:[[100],256],120462:[[101],256],120463:[[102],256],120464:[[103],256],120465:[[104],256],120466:[[105],256],120467:[[106],256],120468:[[107],256],120469:[[108],256],120470:[[109],256],120471:[[110],256],120472:[[111],256],120473:[[112],256],120474:[[113],256],120475:[[114],256],120476:[[115],256],120477:[[116],256],120478:[[117],256],120479:[[118],256],120480:[[119],256],120481:[[120],256],120482:[[121],256],120483:[[122],256],120484:[[305],256],120485:[[567],256],120488:[[913],256],120489:[[914],256],120490:[[915],256],120491:[[916],256],120492:[[917],256],120493:[[918],256],120494:[[919],256],120495:[[920],256],120496:[[921],256],120497:[[922],256],120498:[[923],256],120499:[[924],256],120500:[[925],256],120501:[[926],256],120502:[[927],256],120503:[[928],256],120504:[[929],256],120505:[[1012],256],120506:[[931],256],120507:[[932],256],120508:[[933],256],120509:[[934],256],120510:[[935],256],120511:[[936],256],120512:[[937],256],120513:[[8711],256],120514:[[945],256],120515:[[946],256],120516:[[947],256],120517:[[948],256],120518:[[949],256],120519:[[950],256],120520:[[951],256],120521:[[952],256],120522:[[953],256],120523:[[954],256],120524:[[955],256],120525:[[956],256],120526:[[957],256],120527:[[958],256],120528:[[959],256],120529:[[960],256],120530:[[961],256],120531:[[962],256],120532:[[963],256],120533:[[964],256],120534:[[965],256],120535:[[966],256],120536:[[967],256],120537:[[968],256],120538:[[969],256],120539:[[8706],256],120540:[[1013],256],120541:[[977],256],120542:[[1008],256],120543:[[981],256],120544:[[1009],256],120545:[[982],256],120546:[[913],256],120547:[[914],256],120548:[[915],256],120549:[[916],256],120550:[[917],256],120551:[[918],256],120552:[[919],256],120553:[[920],256],120554:[[921],256],120555:[[922],256],120556:[[923],256],120557:[[924],256],120558:[[925],256],120559:[[926],256],120560:[[927],256],120561:[[928],256],120562:[[929],256],120563:[[1012],256],120564:[[931],256],120565:[[932],256],120566:[[933],256],120567:[[934],256],120568:[[935],256],120569:[[936],256],120570:[[937],256],120571:[[8711],256],120572:[[945],256],120573:[[946],256],120574:[[947],256],120575:[[948],256]},
55040:{120576:[[949],256],120577:[[950],256],120578:[[951],256],120579:[[952],256],120580:[[953],256],120581:[[954],256],120582:[[955],256],120583:[[956],256],120584:[[957],256],120585:[[958],256],120586:[[959],256],120587:[[960],256],120588:[[961],256],120589:[[962],256],120590:[[963],256],120591:[[964],256],120592:[[965],256],120593:[[966],256],120594:[[967],256],120595:[[968],256],120596:[[969],256],120597:[[8706],256],120598:[[1013],256],120599:[[977],256],120600:[[1008],256],120601:[[981],256],120602:[[1009],256],120603:[[982],256],120604:[[913],256],120605:[[914],256],120606:[[915],256],120607:[[916],256],120608:[[917],256],120609:[[918],256],120610:[[919],256],120611:[[920],256],120612:[[921],256],120613:[[922],256],120614:[[923],256],120615:[[924],256],120616:[[925],256],120617:[[926],256],120618:[[927],256],120619:[[928],256],120620:[[929],256],120621:[[1012],256],120622:[[931],256],120623:[[932],256],120624:[[933],256],120625:[[934],256],120626:[[935],256],120627:[[936],256],120628:[[937],256],120629:[[8711],256],120630:[[945],256],120631:[[946],256],120632:[[947],256],120633:[[948],256],120634:[[949],256],120635:[[950],256],120636:[[951],256],120637:[[952],256],120638:[[953],256],120639:[[954],256],120640:[[955],256],120641:[[956],256],120642:[[957],256],120643:[[958],256],120644:[[959],256],120645:[[960],256],120646:[[961],256],120647:[[962],256],120648:[[963],256],120649:[[964],256],120650:[[965],256],120651:[[966],256],120652:[[967],256],120653:[[968],256],120654:[[969],256],120655:[[8706],256],120656:[[1013],256],120657:[[977],256],120658:[[1008],256],120659:[[981],256],120660:[[1009],256],120661:[[982],256],120662:[[913],256],120663:[[914],256],120664:[[915],256],120665:[[916],256],120666:[[917],256],120667:[[918],256],120668:[[919],256],120669:[[920],256],120670:[[921],256],120671:[[922],256],120672:[[923],256],120673:[[924],256],120674:[[925],256],120675:[[926],256],120676:[[927],256],120677:[[928],256],120678:[[929],256],120679:[[1012],256],120680:[[931],256],120681:[[932],256],120682:[[933],256],120683:[[934],256],120684:[[935],256],120685:[[936],256],120686:[[937],256],120687:[[8711],256],120688:[[945],256],120689:[[946],256],120690:[[947],256],120691:[[948],256],120692:[[949],256],120693:[[950],256],120694:[[951],256],120695:[[952],256],120696:[[953],256],120697:[[954],256],120698:[[955],256],120699:[[956],256],120700:[[957],256],120701:[[958],256],120702:[[959],256],120703:[[960],256],120704:[[961],256],120705:[[962],256],120706:[[963],256],120707:[[964],256],120708:[[965],256],120709:[[966],256],120710:[[967],256],120711:[[968],256],120712:[[969],256],120713:[[8706],256],120714:[[1013],256],120715:[[977],256],120716:[[1008],256],120717:[[981],256],120718:[[1009],256],120719:[[982],256],120720:[[913],256],120721:[[914],256],120722:[[915],256],120723:[[916],256],120724:[[917],256],120725:[[918],256],120726:[[919],256],120727:[[920],256],120728:[[921],256],120729:[[922],256],120730:[[923],256],120731:[[924],256],120732:[[925],256],120733:[[926],256],120734:[[927],256],120735:[[928],256],120736:[[929],256],120737:[[1012],256],120738:[[931],256],120739:[[932],256],120740:[[933],256],120741:[[934],256],120742:[[935],256],120743:[[936],256],120744:[[937],256],120745:[[8711],256],120746:[[945],256],120747:[[946],256],120748:[[947],256],120749:[[948],256],120750:[[949],256],120751:[[950],256],120752:[[951],256],120753:[[952],256],120754:[[953],256],120755:[[954],256],120756:[[955],256],120757:[[956],256],120758:[[957],256],120759:[[958],256],120760:[[959],256],120761:[[960],256],120762:[[961],256],120763:[[962],256],120764:[[963],256],120765:[[964],256],120766:[[965],256],120767:[[966],256],120768:[[967],256],120769:[[968],256],120770:[[969],256],120771:[[8706],256],120772:[[1013],256],120773:[[977],256],120774:[[1008],256],120775:[[981],256],120776:[[1009],256],120777:[[982],256],120778:[[988],256],120779:[[989],256],120782:[[48],256],120783:[[49],256],120784:[[50],256],120785:[[51],256],120786:[[52],256],120787:[[53],256],120788:[[54],256],120789:[[55],256],120790:[[56],256],120791:[[57],256],120792:[[48],256],120793:[[49],256],120794:[[50],256],120795:[[51],256],120796:[[52],256],120797:[[53],256],120798:[[54],256],120799:[[55],256],120800:[[56],256],120801:[[57],256],120802:[[48],256],120803:[[49],256],120804:[[50],256],120805:[[51],256],120806:[[52],256],120807:[[53],256],120808:[[54],256],120809:[[55],256],120810:[[56],256],120811:[[57],256],120812:[[48],256],120813:[[49],256],120814:[[50],256],120815:[[51],256],120816:[[52],256],120817:[[53],256],120818:[[54],256],120819:[[55],256],120820:[[56],256],120821:[[57],256],120822:[[48],256],120823:[[49],256],120824:[[50],256],120825:[[51],256],120826:[[52],256],120827:[[53],256],120828:[[54],256],120829:[[55],256],120830:[[56],256],120831:[[57],256]},
59392:{125136:[,220],125137:[,220],125138:[,220],125139:[,220],125140:[,220],125141:[,220],125142:[,220]},
60928:{126464:[[1575],256],126465:[[1576],256],126466:[[1580],256],126467:[[1583],256],126469:[[1608],256],126470:[[1586],256],126471:[[1581],256],126472:[[1591],256],126473:[[1610],256],126474:[[1603],256],126475:[[1604],256],126476:[[1605],256],126477:[[1606],256],126478:[[1587],256],126479:[[1593],256],126480:[[1601],256],126481:[[1589],256],126482:[[1602],256],126483:[[1585],256],126484:[[1588],256],126485:[[1578],256],126486:[[1579],256],126487:[[1582],256],126488:[[1584],256],126489:[[1590],256],126490:[[1592],256],126491:[[1594],256],126492:[[1646],256],126493:[[1722],256],126494:[[1697],256],126495:[[1647],256],126497:[[1576],256],126498:[[1580],256],126500:[[1607],256],126503:[[1581],256],126505:[[1610],256],126506:[[1603],256],126507:[[1604],256],126508:[[1605],256],126509:[[1606],256],126510:[[1587],256],126511:[[1593],256],126512:[[1601],256],126513:[[1589],256],126514:[[1602],256],126516:[[1588],256],126517:[[1578],256],126518:[[1579],256],126519:[[1582],256],126521:[[1590],256],126523:[[1594],256],126530:[[1580],256],126535:[[1581],256],126537:[[1610],256],126539:[[1604],256],126541:[[1606],256],126542:[[1587],256],126543:[[1593],256],126545:[[1589],256],126546:[[1602],256],126548:[[1588],256],126551:[[1582],256],126553:[[1590],256],126555:[[1594],256],126557:[[1722],256],126559:[[1647],256],126561:[[1576],256],126562:[[1580],256],126564:[[1607],256],126567:[[1581],256],126568:[[1591],256],126569:[[1610],256],126570:[[1603],256],126572:[[1605],256],126573:[[1606],256],126574:[[1587],256],126575:[[1593],256],126576:[[1601],256],126577:[[1589],256],126578:[[1602],256],126580:[[1588],256],126581:[[1578],256],126582:[[1579],256],126583:[[1582],256],126585:[[1590],256],126586:[[1592],256],126587:[[1594],256],126588:[[1646],256],126590:[[1697],256],126592:[[1575],256],126593:[[1576],256],126594:[[1580],256],126595:[[1583],256],126596:[[1607],256],126597:[[1608],256],126598:[[1586],256],126599:[[1581],256],126600:[[1591],256],126601:[[1610],256],126603:[[1604],256],126604:[[1605],256],126605:[[1606],256],126606:[[1587],256],126607:[[1593],256],126608:[[1601],256],126609:[[1589],256],126610:[[1602],256],126611:[[1585],256],126612:[[1588],256],126613:[[1578],256],126614:[[1579],256],126615:[[1582],256],126616:[[1584],256],126617:[[1590],256],126618:[[1592],256],126619:[[1594],256],126625:[[1576],256],126626:[[1580],256],126627:[[1583],256],126629:[[1608],256],126630:[[1586],256],126631:[[1581],256],126632:[[1591],256],126633:[[1610],256],126635:[[1604],256],126636:[[1605],256],126637:[[1606],256],126638:[[1587],256],126639:[[1593],256],126640:[[1601],256],126641:[[1589],256],126642:[[1602],256],126643:[[1585],256],126644:[[1588],256],126645:[[1578],256],126646:[[1579],256],126647:[[1582],256],126648:[[1584],256],126649:[[1590],256],126650:[[1592],256],126651:[[1594],256]},
61696:{127232:[[48,46],256],127233:[[48,44],256],127234:[[49,44],256],127235:[[50,44],256],127236:[[51,44],256],127237:[[52,44],256],127238:[[53,44],256],127239:[[54,44],256],127240:[[55,44],256],127241:[[56,44],256],127242:[[57,44],256],127248:[[40,65,41],256],127249:[[40,66,41],256],127250:[[40,67,41],256],127251:[[40,68,41],256],127252:[[40,69,41],256],127253:[[40,70,41],256],127254:[[40,71,41],256],127255:[[40,72,41],256],127256:[[40,73,41],256],127257:[[40,74,41],256],127258:[[40,75,41],256],127259:[[40,76,41],256],127260:[[40,77,41],256],127261:[[40,78,41],256],127262:[[40,79,41],256],127263:[[40,80,41],256],127264:[[40,81,41],256],127265:[[40,82,41],256],127266:[[40,83,41],256],127267:[[40,84,41],256],127268:[[40,85,41],256],127269:[[40,86,41],256],127270:[[40,87,41],256],127271:[[40,88,41],256],127272:[[40,89,41],256],127273:[[40,90,41],256],127274:[[12308,83,12309],256],127275:[[67],256],127276:[[82],256],127277:[[67,68],256],127278:[[87,90],256],127280:[[65],256],127281:[[66],256],127282:[[67],256],127283:[[68],256],127284:[[69],256],127285:[[70],256],127286:[[71],256],127287:[[72],256],127288:[[73],256],127289:[[74],256],127290:[[75],256],127291:[[76],256],127292:[[77],256],127293:[[78],256],127294:[[79],256],127295:[[80],256],127296:[[81],256],127297:[[82],256],127298:[[83],256],127299:[[84],256],127300:[[85],256],127301:[[86],256],127302:[[87],256],127303:[[88],256],127304:[[89],256],127305:[[90],256],127306:[[72,86],256],127307:[[77,86],256],127308:[[83,68],256],127309:[[83,83],256],127310:[[80,80,86],256],127311:[[87,67],256],127338:[[77,67],256],127339:[[77,68],256],127376:[[68,74],256]},
61952:{127488:[[12411,12363],256],127489:[[12467,12467],256],127490:[[12469],256],127504:[[25163],256],127505:[[23383],256],127506:[[21452],256],127507:[[12487],256],127508:[[20108],256],127509:[[22810],256],127510:[[35299],256],127511:[[22825],256],127512:[[20132],256],127513:[[26144],256],127514:[[28961],256],127515:[[26009],256],127516:[[21069],256],127517:[[24460],256],127518:[[20877],256],127519:[[26032],256],127520:[[21021],256],127521:[[32066],256],127522:[[29983],256],127523:[[36009],256],127524:[[22768],256],127525:[[21561],256],127526:[[28436],256],127527:[[25237],256],127528:[[25429],256],127529:[[19968],256],127530:[[19977],256],127531:[[36938],256],127532:[[24038],256],127533:[[20013],256],127534:[[21491],256],127535:[[25351],256],127536:[[36208],256],127537:[[25171],256],127538:[[31105],256],127539:[[31354],256],127540:[[21512],256],127541:[[28288],256],127542:[[26377],256],127543:[[26376],256],127544:[[30003],256],127545:[[21106],256],127546:[[21942],256],127552:[[12308,26412,12309],256],127553:[[12308,19977,12309],256],127554:[[12308,20108,12309],256],127555:[[12308,23433,12309],256],127556:[[12308,28857,12309],256],127557:[[12308,25171,12309],256],127558:[[12308,30423,12309],256],127559:[[12308,21213,12309],256],127560:[[12308,25943,12309],256],127568:[[24471],256],127569:[[21487],256]},
63488:{194560:[[20029]],194561:[[20024]],194562:[[20033]],194563:[[131362]],194564:[[20320]],194565:[[20398]],194566:[[20411]],194567:[[20482]],194568:[[20602]],194569:[[20633]],194570:[[20711]],194571:[[20687]],194572:[[13470]],194573:[[132666]],194574:[[20813]],194575:[[20820]],194576:[[20836]],194577:[[20855]],194578:[[132380]],194579:[[13497]],194580:[[20839]],194581:[[20877]],194582:[[132427]],194583:[[20887]],194584:[[20900]],194585:[[20172]],194586:[[20908]],194587:[[20917]],194588:[[168415]],194589:[[20981]],194590:[[20995]],194591:[[13535]],194592:[[21051]],194593:[[21062]],194594:[[21106]],194595:[[21111]],194596:[[13589]],194597:[[21191]],194598:[[21193]],194599:[[21220]],194600:[[21242]],194601:[[21253]],194602:[[21254]],194603:[[21271]],194604:[[21321]],194605:[[21329]],194606:[[21338]],194607:[[21363]],194608:[[21373]],194609:[[21375]],194610:[[21375]],194611:[[21375]],194612:[[133676]],194613:[[28784]],194614:[[21450]],194615:[[21471]],194616:[[133987]],194617:[[21483]],194618:[[21489]],194619:[[21510]],194620:[[21662]],194621:[[21560]],194622:[[21576]],194623:[[21608]],194624:[[21666]],194625:[[21750]],194626:[[21776]],194627:[[21843]],194628:[[21859]],194629:[[21892]],194630:[[21892]],194631:[[21913]],194632:[[21931]],194633:[[21939]],194634:[[21954]],194635:[[22294]],194636:[[22022]],194637:[[22295]],194638:[[22097]],194639:[[22132]],194640:[[20999]],194641:[[22766]],194642:[[22478]],194643:[[22516]],194644:[[22541]],194645:[[22411]],194646:[[22578]],194647:[[22577]],194648:[[22700]],194649:[[136420]],194650:[[22770]],194651:[[22775]],194652:[[22790]],194653:[[22810]],194654:[[22818]],194655:[[22882]],194656:[[136872]],194657:[[136938]],194658:[[23020]],194659:[[23067]],194660:[[23079]],194661:[[23000]],194662:[[23142]],194663:[[14062]],194664:[[14076]],194665:[[23304]],194666:[[23358]],194667:[[23358]],194668:[[137672]],194669:[[23491]],194670:[[23512]],194671:[[23527]],194672:[[23539]],194673:[[138008]],194674:[[23551]],194675:[[23558]],194676:[[24403]],194677:[[23586]],194678:[[14209]],194679:[[23648]],194680:[[23662]],194681:[[23744]],194682:[[23693]],194683:[[138724]],194684:[[23875]],194685:[[138726]],194686:[[23918]],194687:[[23915]],194688:[[23932]],194689:[[24033]],194690:[[24034]],194691:[[14383]],194692:[[24061]],194693:[[24104]],194694:[[24125]],194695:[[24169]],194696:[[14434]],194697:[[139651]],194698:[[14460]],194699:[[24240]],194700:[[24243]],194701:[[24246]],194702:[[24266]],194703:[[172946]],194704:[[24318]],194705:[[140081]],194706:[[140081]],194707:[[33281]],194708:[[24354]],194709:[[24354]],194710:[[14535]],194711:[[144056]],194712:[[156122]],194713:[[24418]],194714:[[24427]],194715:[[14563]],194716:[[24474]],194717:[[24525]],194718:[[24535]],194719:[[24569]],194720:[[24705]],194721:[[14650]],194722:[[14620]],194723:[[24724]],194724:[[141012]],194725:[[24775]],194726:[[24904]],194727:[[24908]],194728:[[24910]],194729:[[24908]],194730:[[24954]],194731:[[24974]],194732:[[25010]],194733:[[24996]],194734:[[25007]],194735:[[25054]],194736:[[25074]],194737:[[25078]],194738:[[25104]],194739:[[25115]],194740:[[25181]],194741:[[25265]],194742:[[25300]],194743:[[25424]],194744:[[142092]],194745:[[25405]],194746:[[25340]],194747:[[25448]],194748:[[25475]],194749:[[25572]],194750:[[142321]],194751:[[25634]],194752:[[25541]],194753:[[25513]],194754:[[14894]],194755:[[25705]],194756:[[25726]],194757:[[25757]],194758:[[25719]],194759:[[14956]],194760:[[25935]],194761:[[25964]],194762:[[143370]],194763:[[26083]],194764:[[26360]],194765:[[26185]],194766:[[15129]],194767:[[26257]],194768:[[15112]],194769:[[15076]],194770:[[20882]],194771:[[20885]],194772:[[26368]],194773:[[26268]],194774:[[32941]],194775:[[17369]],194776:[[26391]],194777:[[26395]],194778:[[26401]],194779:[[26462]],194780:[[26451]],194781:[[144323]],194782:[[15177]],194783:[[26618]],194784:[[26501]],194785:[[26706]],194786:[[26757]],194787:[[144493]],194788:[[26766]],194789:[[26655]],194790:[[26900]],194791:[[15261]],194792:[[26946]],194793:[[27043]],194794:[[27114]],194795:[[27304]],194796:[[145059]],194797:[[27355]],194798:[[15384]],194799:[[27425]],194800:[[145575]],194801:[[27476]],194802:[[15438]],194803:[[27506]],194804:[[27551]],194805:[[27578]],194806:[[27579]],194807:[[146061]],194808:[[138507]],194809:[[146170]],194810:[[27726]],194811:[[146620]],194812:[[27839]],194813:[[27853]],194814:[[27751]],194815:[[27926]]},
63744:{63744:[[35912]],63745:[[26356]],63746:[[36554]],63747:[[36040]],63748:[[28369]],63749:[[20018]],63750:[[21477]],63751:[[40860]],63752:[[40860]],63753:[[22865]],63754:[[37329]],63755:[[21895]],63756:[[22856]],63757:[[25078]],63758:[[30313]],63759:[[32645]],63760:[[34367]],63761:[[34746]],63762:[[35064]],63763:[[37007]],63764:[[27138]],63765:[[27931]],63766:[[28889]],63767:[[29662]],63768:[[33853]],63769:[[37226]],63770:[[39409]],63771:[[20098]],63772:[[21365]],63773:[[27396]],63774:[[29211]],63775:[[34349]],63776:[[40478]],63777:[[23888]],63778:[[28651]],63779:[[34253]],63780:[[35172]],63781:[[25289]],63782:[[33240]],63783:[[34847]],63784:[[24266]],63785:[[26391]],63786:[[28010]],63787:[[29436]],63788:[[37070]],63789:[[20358]],63790:[[20919]],63791:[[21214]],63792:[[25796]],63793:[[27347]],63794:[[29200]],63795:[[30439]],63796:[[32769]],63797:[[34310]],63798:[[34396]],63799:[[36335]],63800:[[38706]],63801:[[39791]],63802:[[40442]],63803:[[30860]],63804:[[31103]],63805:[[32160]],63806:[[33737]],63807:[[37636]],63808:[[40575]],63809:[[35542]],63810:[[22751]],63811:[[24324]],63812:[[31840]],63813:[[32894]],63814:[[29282]],63815:[[30922]],63816:[[36034]],63817:[[38647]],63818:[[22744]],63819:[[23650]],63820:[[27155]],63821:[[28122]],63822:[[28431]],63823:[[32047]],63824:[[32311]],63825:[[38475]],63826:[[21202]],63827:[[32907]],63828:[[20956]],63829:[[20940]],63830:[[31260]],63831:[[32190]],63832:[[33777]],63833:[[38517]],63834:[[35712]],63835:[[25295]],63836:[[27138]],63837:[[35582]],63838:[[20025]],63839:[[23527]],63840:[[24594]],63841:[[29575]],63842:[[30064]],63843:[[21271]],63844:[[30971]],63845:[[20415]],63846:[[24489]],63847:[[19981]],63848:[[27852]],63849:[[25976]],63850:[[32034]],63851:[[21443]],63852:[[22622]],63853:[[30465]],63854:[[33865]],63855:[[35498]],63856:[[27578]],63857:[[36784]],63858:[[27784]],63859:[[25342]],63860:[[33509]],63861:[[25504]],63862:[[30053]],63863:[[20142]],63864:[[20841]],63865:[[20937]],63866:[[26753]],63867:[[31975]],63868:[[33391]],63869:[[35538]],63870:[[37327]],63871:[[21237]],63872:[[21570]],63873:[[22899]],63874:[[24300]],63875:[[26053]],63876:[[28670]],63877:[[31018]],63878:[[38317]],63879:[[39530]],63880:[[40599]],63881:[[40654]],63882:[[21147]],63883:[[26310]],63884:[[27511]],63885:[[36706]],63886:[[24180]],63887:[[24976]],63888:[[25088]],63889:[[25754]],63890:[[28451]],63891:[[29001]],63892:[[29833]],63893:[[31178]],63894:[[32244]],63895:[[32879]],63896:[[36646]],63897:[[34030]],63898:[[36899]],63899:[[37706]],63900:[[21015]],63901:[[21155]],63902:[[21693]],63903:[[28872]],63904:[[35010]],63905:[[35498]],63906:[[24265]],63907:[[24565]],63908:[[25467]],63909:[[27566]],63910:[[31806]],63911:[[29557]],63912:[[20196]],63913:[[22265]],63914:[[23527]],63915:[[23994]],63916:[[24604]],63917:[[29618]],63918:[[29801]],63919:[[32666]],63920:[[32838]],63921:[[37428]],63922:[[38646]],63923:[[38728]],63924:[[38936]],63925:[[20363]],63926:[[31150]],63927:[[37300]],63928:[[38584]],63929:[[24801]],63930:[[20102]],63931:[[20698]],63932:[[23534]],63933:[[23615]],63934:[[26009]],63935:[[27138]],63936:[[29134]],63937:[[30274]],63938:[[34044]],63939:[[36988]],63940:[[40845]],63941:[[26248]],63942:[[38446]],63943:[[21129]],63944:[[26491]],63945:[[26611]],63946:[[27969]],63947:[[28316]],63948:[[29705]],63949:[[30041]],63950:[[30827]],63951:[[32016]],63952:[[39006]],63953:[[20845]],63954:[[25134]],63955:[[38520]],63956:[[20523]],63957:[[23833]],63958:[[28138]],63959:[[36650]],63960:[[24459]],63961:[[24900]],63962:[[26647]],63963:[[29575]],63964:[[38534]],63965:[[21033]],63966:[[21519]],63967:[[23653]],63968:[[26131]],63969:[[26446]],63970:[[26792]],63971:[[27877]],63972:[[29702]],63973:[[30178]],63974:[[32633]],63975:[[35023]],63976:[[35041]],63977:[[37324]],63978:[[38626]],63979:[[21311]],63980:[[28346]],63981:[[21533]],63982:[[29136]],63983:[[29848]],63984:[[34298]],63985:[[38563]],63986:[[40023]],63987:[[40607]],63988:[[26519]],63989:[[28107]],63990:[[33256]],63991:[[31435]],63992:[[31520]],63993:[[31890]],63994:[[29376]],63995:[[28825]],63996:[[35672]],63997:[[20160]],63998:[[33590]],63999:[[21050]],194816:[[27966]],194817:[[28023]],194818:[[27969]],194819:[[28009]],194820:[[28024]],194821:[[28037]],194822:[[146718]],194823:[[27956]],194824:[[28207]],194825:[[28270]],194826:[[15667]],194827:[[28363]],194828:[[28359]],194829:[[147153]],194830:[[28153]],194831:[[28526]],194832:[[147294]],194833:[[147342]],194834:[[28614]],194835:[[28729]],194836:[[28702]],194837:[[28699]],194838:[[15766]],194839:[[28746]],194840:[[28797]],194841:[[28791]],194842:[[28845]],194843:[[132389]],194844:[[28997]],194845:[[148067]],194846:[[29084]],194847:[[148395]],194848:[[29224]],194849:[[29237]],194850:[[29264]],194851:[[149000]],194852:[[29312]],194853:[[29333]],194854:[[149301]],194855:[[149524]],194856:[[29562]],194857:[[29579]],194858:[[16044]],194859:[[29605]],194860:[[16056]],194861:[[16056]],194862:[[29767]],194863:[[29788]],194864:[[29809]],194865:[[29829]],194866:[[29898]],194867:[[16155]],194868:[[29988]],194869:[[150582]],194870:[[30014]],194871:[[150674]],194872:[[30064]],194873:[[139679]],194874:[[30224]],194875:[[151457]],194876:[[151480]],194877:[[151620]],194878:[[16380]],194879:[[16392]],194880:[[30452]],194881:[[151795]],194882:[[151794]],194883:[[151833]],194884:[[151859]],194885:[[30494]],194886:[[30495]],194887:[[30495]],194888:[[30538]],194889:[[16441]],194890:[[30603]],194891:[[16454]],194892:[[16534]],194893:[[152605]],194894:[[30798]],194895:[[30860]],194896:[[30924]],194897:[[16611]],194898:[[153126]],194899:[[31062]],194900:[[153242]],194901:[[153285]],194902:[[31119]],194903:[[31211]],194904:[[16687]],194905:[[31296]],194906:[[31306]],194907:[[31311]],194908:[[153980]],194909:[[154279]],194910:[[154279]],194911:[[31470]],194912:[[16898]],194913:[[154539]],194914:[[31686]],194915:[[31689]],194916:[[16935]],194917:[[154752]],194918:[[31954]],194919:[[17056]],194920:[[31976]],194921:[[31971]],194922:[[32000]],194923:[[155526]],194924:[[32099]],194925:[[17153]],194926:[[32199]],194927:[[32258]],194928:[[32325]],194929:[[17204]],194930:[[156200]],194931:[[156231]],194932:[[17241]],194933:[[156377]],194934:[[32634]],194935:[[156478]],194936:[[32661]],194937:[[32762]],194938:[[32773]],194939:[[156890]],194940:[[156963]],194941:[[32864]],194942:[[157096]],194943:[[32880]],194944:[[144223]],194945:[[17365]],194946:[[32946]],194947:[[33027]],194948:[[17419]],194949:[[33086]],194950:[[23221]],194951:[[157607]],194952:[[157621]],194953:[[144275]],194954:[[144284]],194955:[[33281]],194956:[[33284]],194957:[[36766]],194958:[[17515]],194959:[[33425]],194960:[[33419]],194961:[[33437]],194962:[[21171]],194963:[[33457]],194964:[[33459]],194965:[[33469]],194966:[[33510]],194967:[[158524]],194968:[[33509]],194969:[[33565]],194970:[[33635]],194971:[[33709]],194972:[[33571]],194973:[[33725]],194974:[[33767]],194975:[[33879]],194976:[[33619]],194977:[[33738]],194978:[[33740]],194979:[[33756]],194980:[[158774]],194981:[[159083]],194982:[[158933]],194983:[[17707]],194984:[[34033]],194985:[[34035]],194986:[[34070]],194987:[[160714]],194988:[[34148]],194989:[[159532]],194990:[[17757]],194991:[[17761]],194992:[[159665]],194993:[[159954]],194994:[[17771]],194995:[[34384]],194996:[[34396]],194997:[[34407]],194998:[[34409]],194999:[[34473]],195000:[[34440]],195001:[[34574]],195002:[[34530]],195003:[[34681]],195004:[[34600]],195005:[[34667]],195006:[[34694]],195007:[[17879]],195008:[[34785]],195009:[[34817]],195010:[[17913]],195011:[[34912]],195012:[[34915]],195013:[[161383]],195014:[[35031]],195015:[[35038]],195016:[[17973]],195017:[[35066]],195018:[[13499]],195019:[[161966]],195020:[[162150]],195021:[[18110]],195022:[[18119]],195023:[[35488]],195024:[[35565]],195025:[[35722]],195026:[[35925]],195027:[[162984]],195028:[[36011]],195029:[[36033]],195030:[[36123]],195031:[[36215]],195032:[[163631]],195033:[[133124]],195034:[[36299]],195035:[[36284]],195036:[[36336]],195037:[[133342]],195038:[[36564]],195039:[[36664]],195040:[[165330]],195041:[[165357]],195042:[[37012]],195043:[[37105]],195044:[[37137]],195045:[[165678]],195046:[[37147]],195047:[[37432]],195048:[[37591]],195049:[[37592]],195050:[[37500]],195051:[[37881]],195052:[[37909]],195053:[[166906]],195054:[[38283]],195055:[[18837]],195056:[[38327]],195057:[[167287]],195058:[[18918]],195059:[[38595]],195060:[[23986]],195061:[[38691]],195062:[[168261]],195063:[[168474]],195064:[[19054]],195065:[[19062]],195066:[[38880]],195067:[[168970]],195068:[[19122]],195069:[[169110]],195070:[[38923]],195071:[[38923]]},
64000:{64000:[[20999]],64001:[[24230]],64002:[[25299]],64003:[[31958]],64004:[[23429]],64005:[[27934]],64006:[[26292]],64007:[[36667]],64008:[[34892]],64009:[[38477]],64010:[[35211]],64011:[[24275]],64012:[[20800]],64013:[[21952]],64016:[[22618]],64018:[[26228]],64021:[[20958]],64022:[[29482]],64023:[[30410]],64024:[[31036]],64025:[[31070]],64026:[[31077]],64027:[[31119]],64028:[[38742]],64029:[[31934]],64030:[[32701]],64032:[[34322]],64034:[[35576]],64037:[[36920]],64038:[[37117]],64042:[[39151]],64043:[[39164]],64044:[[39208]],64045:[[40372]],64046:[[37086]],64047:[[38583]],64048:[[20398]],64049:[[20711]],64050:[[20813]],64051:[[21193]],64052:[[21220]],64053:[[21329]],64054:[[21917]],64055:[[22022]],64056:[[22120]],64057:[[22592]],64058:[[22696]],64059:[[23652]],64060:[[23662]],64061:[[24724]],64062:[[24936]],64063:[[24974]],64064:[[25074]],64065:[[25935]],64066:[[26082]],64067:[[26257]],64068:[[26757]],64069:[[28023]],64070:[[28186]],64071:[[28450]],64072:[[29038]],64073:[[29227]],64074:[[29730]],64075:[[30865]],64076:[[31038]],64077:[[31049]],64078:[[31048]],64079:[[31056]],64080:[[31062]],64081:[[31069]],64082:[[31117]],64083:[[31118]],64084:[[31296]],64085:[[31361]],64086:[[31680]],64087:[[32244]],64088:[[32265]],64089:[[32321]],64090:[[32626]],64091:[[32773]],64092:[[33261]],64093:[[33401]],64094:[[33401]],64095:[[33879]],64096:[[35088]],64097:[[35222]],64098:[[35585]],64099:[[35641]],64100:[[36051]],64101:[[36104]],64102:[[36790]],64103:[[36920]],64104:[[38627]],64105:[[38911]],64106:[[38971]],64107:[[24693]],64108:[[148206]],64109:[[33304]],64112:[[20006]],64113:[[20917]],64114:[[20840]],64115:[[20352]],64116:[[20805]],64117:[[20864]],64118:[[21191]],64119:[[21242]],64120:[[21917]],64121:[[21845]],64122:[[21913]],64123:[[21986]],64124:[[22618]],64125:[[22707]],64126:[[22852]],64127:[[22868]],64128:[[23138]],64129:[[23336]],64130:[[24274]],64131:[[24281]],64132:[[24425]],64133:[[24493]],64134:[[24792]],64135:[[24910]],64136:[[24840]],64137:[[24974]],64138:[[24928]],64139:[[25074]],64140:[[25140]],64141:[[25540]],64142:[[25628]],64143:[[25682]],64144:[[25942]],64145:[[26228]],64146:[[26391]],64147:[[26395]],64148:[[26454]],64149:[[27513]],64150:[[27578]],64151:[[27969]],64152:[[28379]],64153:[[28363]],64154:[[28450]],64155:[[28702]],64156:[[29038]],64157:[[30631]],64158:[[29237]],64159:[[29359]],64160:[[29482]],64161:[[29809]],64162:[[29958]],64163:[[30011]],64164:[[30237]],64165:[[30239]],64166:[[30410]],64167:[[30427]],64168:[[30452]],64169:[[30538]],64170:[[30528]],64171:[[30924]],64172:[[31409]],64173:[[31680]],64174:[[31867]],64175:[[32091]],64176:[[32244]],64177:[[32574]],64178:[[32773]],64179:[[33618]],64180:[[33775]],64181:[[34681]],64182:[[35137]],64183:[[35206]],64184:[[35222]],64185:[[35519]],64186:[[35576]],64187:[[35531]],64188:[[35585]],64189:[[35582]],64190:[[35565]],64191:[[35641]],64192:[[35722]],64193:[[36104]],64194:[[36664]],64195:[[36978]],64196:[[37273]],64197:[[37494]],64198:[[38524]],64199:[[38627]],64200:[[38742]],64201:[[38875]],64202:[[38911]],64203:[[38923]],64204:[[38971]],64205:[[39698]],64206:[[40860]],64207:[[141386]],64208:[[141380]],64209:[[144341]],64210:[[15261]],64211:[[16408]],64212:[[16441]],64213:[[152137]],64214:[[154832]],64215:[[163539]],64216:[[40771]],64217:[[40846]],195072:[[38953]],195073:[[169398]],195074:[[39138]],195075:[[19251]],195076:[[39209]],195077:[[39335]],195078:[[39362]],195079:[[39422]],195080:[[19406]],195081:[[170800]],195082:[[39698]],195083:[[40000]],195084:[[40189]],195085:[[19662]],195086:[[19693]],195087:[[40295]],195088:[[172238]],195089:[[19704]],195090:[[172293]],195091:[[172558]],195092:[[172689]],195093:[[40635]],195094:[[19798]],195095:[[40697]],195096:[[40702]],195097:[[40709]],195098:[[40719]],195099:[[40726]],195100:[[40763]],195101:[[173568]]},
64256:{64256:[[102,102],256],64257:[[102,105],256],64258:[[102,108],256],64259:[[102,102,105],256],64260:[[102,102,108],256],64261:[[383,116],256],64262:[[115,116],256],64275:[[1396,1398],256],64276:[[1396,1381],256],64277:[[1396,1387],256],64278:[[1406,1398],256],64279:[[1396,1389],256],64285:[[1497,1460],512],64286:[,26],64287:[[1522,1463],512],64288:[[1506],256],64289:[[1488],256],64290:[[1491],256],64291:[[1492],256],64292:[[1499],256],64293:[[1500],256],64294:[[1501],256],64295:[[1512],256],64296:[[1514],256],64297:[[43],256],64298:[[1513,1473],512],64299:[[1513,1474],512],64300:[[64329,1473],512],64301:[[64329,1474],512],64302:[[1488,1463],512],64303:[[1488,1464],512],64304:[[1488,1468],512],64305:[[1489,1468],512],64306:[[1490,1468],512],64307:[[1491,1468],512],64308:[[1492,1468],512],64309:[[1493,1468],512],64310:[[1494,1468],512],64312:[[1496,1468],512],64313:[[1497,1468],512],64314:[[1498,1468],512],64315:[[1499,1468],512],64316:[[1500,1468],512],64318:[[1502,1468],512],64320:[[1504,1468],512],64321:[[1505,1468],512],64323:[[1507,1468],512],64324:[[1508,1468],512],64326:[[1510,1468],512],64327:[[1511,1468],512],64328:[[1512,1468],512],64329:[[1513,1468],512],64330:[[1514,1468],512],64331:[[1493,1465],512],64332:[[1489,1471],512],64333:[[1499,1471],512],64334:[[1508,1471],512],64335:[[1488,1500],256],64336:[[1649],256],64337:[[1649],256],64338:[[1659],256],64339:[[1659],256],64340:[[1659],256],64341:[[1659],256],64342:[[1662],256],64343:[[1662],256],64344:[[1662],256],64345:[[1662],256],64346:[[1664],256],64347:[[1664],256],64348:[[1664],256],64349:[[1664],256],64350:[[1658],256],64351:[[1658],256],64352:[[1658],256],64353:[[1658],256],64354:[[1663],256],64355:[[1663],256],64356:[[1663],256],64357:[[1663],256],64358:[[1657],256],64359:[[1657],256],64360:[[1657],256],64361:[[1657],256],64362:[[1700],256],64363:[[1700],256],64364:[[1700],256],64365:[[1700],256],64366:[[1702],256],64367:[[1702],256],64368:[[1702],256],64369:[[1702],256],64370:[[1668],256],64371:[[1668],256],64372:[[1668],256],64373:[[1668],256],64374:[[1667],256],64375:[[1667],256],64376:[[1667],256],64377:[[1667],256],64378:[[1670],256],64379:[[1670],256],64380:[[1670],256],64381:[[1670],256],64382:[[1671],256],64383:[[1671],256],64384:[[1671],256],64385:[[1671],256],64386:[[1677],256],64387:[[1677],256],64388:[[1676],256],64389:[[1676],256],64390:[[1678],256],64391:[[1678],256],64392:[[1672],256],64393:[[1672],256],64394:[[1688],256],64395:[[1688],256],64396:[[1681],256],64397:[[1681],256],64398:[[1705],256],64399:[[1705],256],64400:[[1705],256],64401:[[1705],256],64402:[[1711],256],64403:[[1711],256],64404:[[1711],256],64405:[[1711],256],64406:[[1715],256],64407:[[1715],256],64408:[[1715],256],64409:[[1715],256],64410:[[1713],256],64411:[[1713],256],64412:[[1713],256],64413:[[1713],256],64414:[[1722],256],64415:[[1722],256],64416:[[1723],256],64417:[[1723],256],64418:[[1723],256],64419:[[1723],256],64420:[[1728],256],64421:[[1728],256],64422:[[1729],256],64423:[[1729],256],64424:[[1729],256],64425:[[1729],256],64426:[[1726],256],64427:[[1726],256],64428:[[1726],256],64429:[[1726],256],64430:[[1746],256],64431:[[1746],256],64432:[[1747],256],64433:[[1747],256],64467:[[1709],256],64468:[[1709],256],64469:[[1709],256],64470:[[1709],256],64471:[[1735],256],64472:[[1735],256],64473:[[1734],256],64474:[[1734],256],64475:[[1736],256],64476:[[1736],256],64477:[[1655],256],64478:[[1739],256],64479:[[1739],256],64480:[[1733],256],64481:[[1733],256],64482:[[1737],256],64483:[[1737],256],64484:[[1744],256],64485:[[1744],256],64486:[[1744],256],64487:[[1744],256],64488:[[1609],256],64489:[[1609],256],64490:[[1574,1575],256],64491:[[1574,1575],256],64492:[[1574,1749],256],64493:[[1574,1749],256],64494:[[1574,1608],256],64495:[[1574,1608],256],64496:[[1574,1735],256],64497:[[1574,1735],256],64498:[[1574,1734],256],64499:[[1574,1734],256],64500:[[1574,1736],256],64501:[[1574,1736],256],64502:[[1574,1744],256],64503:[[1574,1744],256],64504:[[1574,1744],256],64505:[[1574,1609],256],64506:[[1574,1609],256],64507:[[1574,1609],256],64508:[[1740],256],64509:[[1740],256],64510:[[1740],256],64511:[[1740],256]},
64512:{64512:[[1574,1580],256],64513:[[1574,1581],256],64514:[[1574,1605],256],64515:[[1574,1609],256],64516:[[1574,1610],256],64517:[[1576,1580],256],64518:[[1576,1581],256],64519:[[1576,1582],256],64520:[[1576,1605],256],64521:[[1576,1609],256],64522:[[1576,1610],256],64523:[[1578,1580],256],64524:[[1578,1581],256],64525:[[1578,1582],256],64526:[[1578,1605],256],64527:[[1578,1609],256],64528:[[1578,1610],256],64529:[[1579,1580],256],64530:[[1579,1605],256],64531:[[1579,1609],256],64532:[[1579,1610],256],64533:[[1580,1581],256],64534:[[1580,1605],256],64535:[[1581,1580],256],64536:[[1581,1605],256],64537:[[1582,1580],256],64538:[[1582,1581],256],64539:[[1582,1605],256],64540:[[1587,1580],256],64541:[[1587,1581],256],64542:[[1587,1582],256],64543:[[1587,1605],256],64544:[[1589,1581],256],64545:[[1589,1605],256],64546:[[1590,1580],256],64547:[[1590,1581],256],64548:[[1590,1582],256],64549:[[1590,1605],256],64550:[[1591,1581],256],64551:[[1591,1605],256],64552:[[1592,1605],256],64553:[[1593,1580],256],64554:[[1593,1605],256],64555:[[1594,1580],256],64556:[[1594,1605],256],64557:[[1601,1580],256],64558:[[1601,1581],256],64559:[[1601,1582],256],64560:[[1601,1605],256],64561:[[1601,1609],256],64562:[[1601,1610],256],64563:[[1602,1581],256],64564:[[1602,1605],256],64565:[[1602,1609],256],64566:[[1602,1610],256],64567:[[1603,1575],256],64568:[[1603,1580],256],64569:[[1603,1581],256],64570:[[1603,1582],256],64571:[[1603,1604],256],64572:[[1603,1605],256],64573:[[1603,1609],256],64574:[[1603,1610],256],64575:[[1604,1580],256],64576:[[1604,1581],256],64577:[[1604,1582],256],64578:[[1604,1605],256],64579:[[1604,1609],256],64580:[[1604,1610],256],64581:[[1605,1580],256],64582:[[1605,1581],256],64583:[[1605,1582],256],64584:[[1605,1605],256],64585:[[1605,1609],256],64586:[[1605,1610],256],64587:[[1606,1580],256],64588:[[1606,1581],256],64589:[[1606,1582],256],64590:[[1606,1605],256],64591:[[1606,1609],256],64592:[[1606,1610],256],64593:[[1607,1580],256],64594:[[1607,1605],256],64595:[[1607,1609],256],64596:[[1607,1610],256],64597:[[1610,1580],256],64598:[[1610,1581],256],64599:[[1610,1582],256],64600:[[1610,1605],256],64601:[[1610,1609],256],64602:[[1610,1610],256],64603:[[1584,1648],256],64604:[[1585,1648],256],64605:[[1609,1648],256],64606:[[32,1612,1617],256],64607:[[32,1613,1617],256],64608:[[32,1614,1617],256],64609:[[32,1615,1617],256],64610:[[32,1616,1617],256],64611:[[32,1617,1648],256],64612:[[1574,1585],256],64613:[[1574,1586],256],64614:[[1574,1605],256],64615:[[1574,1606],256],64616:[[1574,1609],256],64617:[[1574,1610],256],64618:[[1576,1585],256],64619:[[1576,1586],256],64620:[[1576,1605],256],64621:[[1576,1606],256],64622:[[1576,1609],256],64623:[[1576,1610],256],64624:[[1578,1585],256],64625:[[1578,1586],256],64626:[[1578,1605],256],64627:[[1578,1606],256],64628:[[1578,1609],256],64629:[[1578,1610],256],64630:[[1579,1585],256],64631:[[1579,1586],256],64632:[[1579,1605],256],64633:[[1579,1606],256],64634:[[1579,1609],256],64635:[[1579,1610],256],64636:[[1601,1609],256],64637:[[1601,1610],256],64638:[[1602,1609],256],64639:[[1602,1610],256],64640:[[1603,1575],256],64641:[[1603,1604],256],64642:[[1603,1605],256],64643:[[1603,1609],256],64644:[[1603,1610],256],64645:[[1604,1605],256],64646:[[1604,1609],256],64647:[[1604,1610],256],64648:[[1605,1575],256],64649:[[1605,1605],256],64650:[[1606,1585],256],64651:[[1606,1586],256],64652:[[1606,1605],256],64653:[[1606,1606],256],64654:[[1606,1609],256],64655:[[1606,1610],256],64656:[[1609,1648],256],64657:[[1610,1585],256],64658:[[1610,1586],256],64659:[[1610,1605],256],64660:[[1610,1606],256],64661:[[1610,1609],256],64662:[[1610,1610],256],64663:[[1574,1580],256],64664:[[1574,1581],256],64665:[[1574,1582],256],64666:[[1574,1605],256],64667:[[1574,1607],256],64668:[[1576,1580],256],64669:[[1576,1581],256],64670:[[1576,1582],256],64671:[[1576,1605],256],64672:[[1576,1607],256],64673:[[1578,1580],256],64674:[[1578,1581],256],64675:[[1578,1582],256],64676:[[1578,1605],256],64677:[[1578,1607],256],64678:[[1579,1605],256],64679:[[1580,1581],256],64680:[[1580,1605],256],64681:[[1581,1580],256],64682:[[1581,1605],256],64683:[[1582,1580],256],64684:[[1582,1605],256],64685:[[1587,1580],256],64686:[[1587,1581],256],64687:[[1587,1582],256],64688:[[1587,1605],256],64689:[[1589,1581],256],64690:[[1589,1582],256],64691:[[1589,1605],256],64692:[[1590,1580],256],64693:[[1590,1581],256],64694:[[1590,1582],256],64695:[[1590,1605],256],64696:[[1591,1581],256],64697:[[1592,1605],256],64698:[[1593,1580],256],64699:[[1593,1605],256],64700:[[1594,1580],256],64701:[[1594,1605],256],64702:[[1601,1580],256],64703:[[1601,1581],256],64704:[[1601,1582],256],64705:[[1601,1605],256],64706:[[1602,1581],256],64707:[[1602,1605],256],64708:[[1603,1580],256],64709:[[1603,1581],256],64710:[[1603,1582],256],64711:[[1603,1604],256],64712:[[1603,1605],256],64713:[[1604,1580],256],64714:[[1604,1581],256],64715:[[1604,1582],256],64716:[[1604,1605],256],64717:[[1604,1607],256],64718:[[1605,1580],256],64719:[[1605,1581],256],64720:[[1605,1582],256],64721:[[1605,1605],256],64722:[[1606,1580],256],64723:[[1606,1581],256],64724:[[1606,1582],256],64725:[[1606,1605],256],64726:[[1606,1607],256],64727:[[1607,1580],256],64728:[[1607,1605],256],64729:[[1607,1648],256],64730:[[1610,1580],256],64731:[[1610,1581],256],64732:[[1610,1582],256],64733:[[1610,1605],256],64734:[[1610,1607],256],64735:[[1574,1605],256],64736:[[1574,1607],256],64737:[[1576,1605],256],64738:[[1576,1607],256],64739:[[1578,1605],256],64740:[[1578,1607],256],64741:[[1579,1605],256],64742:[[1579,1607],256],64743:[[1587,1605],256],64744:[[1587,1607],256],64745:[[1588,1605],256],64746:[[1588,1607],256],64747:[[1603,1604],256],64748:[[1603,1605],256],64749:[[1604,1605],256],64750:[[1606,1605],256],64751:[[1606,1607],256],64752:[[1610,1605],256],64753:[[1610,1607],256],64754:[[1600,1614,1617],256],64755:[[1600,1615,1617],256],64756:[[1600,1616,1617],256],64757:[[1591,1609],256],64758:[[1591,1610],256],64759:[[1593,1609],256],64760:[[1593,1610],256],64761:[[1594,1609],256],64762:[[1594,1610],256],64763:[[1587,1609],256],64764:[[1587,1610],256],64765:[[1588,1609],256],64766:[[1588,1610],256],64767:[[1581,1609],256]},
64768:{64768:[[1581,1610],256],64769:[[1580,1609],256],64770:[[1580,1610],256],64771:[[1582,1609],256],64772:[[1582,1610],256],64773:[[1589,1609],256],64774:[[1589,1610],256],64775:[[1590,1609],256],64776:[[1590,1610],256],64777:[[1588,1580],256],64778:[[1588,1581],256],64779:[[1588,1582],256],64780:[[1588,1605],256],64781:[[1588,1585],256],64782:[[1587,1585],256],64783:[[1589,1585],256],64784:[[1590,1585],256],64785:[[1591,1609],256],64786:[[1591,1610],256],64787:[[1593,1609],256],64788:[[1593,1610],256],64789:[[1594,1609],256],64790:[[1594,1610],256],64791:[[1587,1609],256],64792:[[1587,1610],256],64793:[[1588,1609],256],64794:[[1588,1610],256],64795:[[1581,1609],256],64796:[[1581,1610],256],64797:[[1580,1609],256],64798:[[1580,1610],256],64799:[[1582,1609],256],64800:[[1582,1610],256],64801:[[1589,1609],256],64802:[[1589,1610],256],64803:[[1590,1609],256],64804:[[1590,1610],256],64805:[[1588,1580],256],64806:[[1588,1581],256],64807:[[1588,1582],256],64808:[[1588,1605],256],64809:[[1588,1585],256],64810:[[1587,1585],256],64811:[[1589,1585],256],64812:[[1590,1585],256],64813:[[1588,1580],256],64814:[[1588,1581],256],64815:[[1588,1582],256],64816:[[1588,1605],256],64817:[[1587,1607],256],64818:[[1588,1607],256],64819:[[1591,1605],256],64820:[[1587,1580],256],64821:[[1587,1581],256],64822:[[1587,1582],256],64823:[[1588,1580],256],64824:[[1588,1581],256],64825:[[1588,1582],256],64826:[[1591,1605],256],64827:[[1592,1605],256],64828:[[1575,1611],256],64829:[[1575,1611],256],64848:[[1578,1580,1605],256],64849:[[1578,1581,1580],256],64850:[[1578,1581,1580],256],64851:[[1578,1581,1605],256],64852:[[1578,1582,1605],256],64853:[[1578,1605,1580],256],64854:[[1578,1605,1581],256],64855:[[1578,1605,1582],256],64856:[[1580,1605,1581],256],64857:[[1580,1605,1581],256],64858:[[1581,1605,1610],256],64859:[[1581,1605,1609],256],64860:[[1587,1581,1580],256],64861:[[1587,1580,1581],256],64862:[[1587,1580,1609],256],64863:[[1587,1605,1581],256],64864:[[1587,1605,1581],256],64865:[[1587,1605,1580],256],64866:[[1587,1605,1605],256],64867:[[1587,1605,1605],256],64868:[[1589,1581,1581],256],64869:[[1589,1581,1581],256],64870:[[1589,1605,1605],256],64871:[[1588,1581,1605],256],64872:[[1588,1581,1605],256],64873:[[1588,1580,1610],256],64874:[[1588,1605,1582],256],64875:[[1588,1605,1582],256],64876:[[1588,1605,1605],256],64877:[[1588,1605,1605],256],64878:[[1590,1581,1609],256],64879:[[1590,1582,1605],256],64880:[[1590,1582,1605],256],64881:[[1591,1605,1581],256],64882:[[1591,1605,1581],256],64883:[[1591,1605,1605],256],64884:[[1591,1605,1610],256],64885:[[1593,1580,1605],256],64886:[[1593,1605,1605],256],64887:[[1593,1605,1605],256],64888:[[1593,1605,1609],256],64889:[[1594,1605,1605],256],64890:[[1594,1605,1610],256],64891:[[1594,1605,1609],256],64892:[[1601,1582,1605],256],64893:[[1601,1582,1605],256],64894:[[1602,1605,1581],256],64895:[[1602,1605,1605],256],64896:[[1604,1581,1605],256],64897:[[1604,1581,1610],256],64898:[[1604,1581,1609],256],64899:[[1604,1580,1580],256],64900:[[1604,1580,1580],256],64901:[[1604,1582,1605],256],64902:[[1604,1582,1605],256],64903:[[1604,1605,1581],256],64904:[[1604,1605,1581],256],64905:[[1605,1581,1580],256],64906:[[1605,1581,1605],256],64907:[[1605,1581,1610],256],64908:[[1605,1580,1581],256],64909:[[1605,1580,1605],256],64910:[[1605,1582,1580],256],64911:[[1605,1582,1605],256],64914:[[1605,1580,1582],256],64915:[[1607,1605,1580],256],64916:[[1607,1605,1605],256],64917:[[1606,1581,1605],256],64918:[[1606,1581,1609],256],64919:[[1606,1580,1605],256],64920:[[1606,1580,1605],256],64921:[[1606,1580,1609],256],64922:[[1606,1605,1610],256],64923:[[1606,1605,1609],256],64924:[[1610,1605,1605],256],64925:[[1610,1605,1605],256],64926:[[1576,1582,1610],256],64927:[[1578,1580,1610],256],64928:[[1578,1580,1609],256],64929:[[1578,1582,1610],256],64930:[[1578,1582,1609],256],64931:[[1578,1605,1610],256],64932:[[1578,1605,1609],256],64933:[[1580,1605,1610],256],64934:[[1580,1581,1609],256],64935:[[1580,1605,1609],256],64936:[[1587,1582,1609],256],64937:[[1589,1581,1610],256],64938:[[1588,1581,1610],256],64939:[[1590,1581,1610],256],64940:[[1604,1580,1610],256],64941:[[1604,1605,1610],256],64942:[[1610,1581,1610],256],64943:[[1610,1580,1610],256],64944:[[1610,1605,1610],256],64945:[[1605,1605,1610],256],64946:[[1602,1605,1610],256],64947:[[1606,1581,1610],256],64948:[[1602,1605,1581],256],64949:[[1604,1581,1605],256],64950:[[1593,1605,1610],256],64951:[[1603,1605,1610],256],64952:[[1606,1580,1581],256],64953:[[1605,1582,1610],256],64954:[[1604,1580,1605],256],64955:[[1603,1605,1605],256],64956:[[1604,1580,1605],256],64957:[[1606,1580,1581],256],64958:[[1580,1581,1610],256],64959:[[1581,1580,1610],256],64960:[[1605,1580,1610],256],64961:[[1601,1605,1610],256],64962:[[1576,1581,1610],256],64963:[[1603,1605,1605],256],64964:[[1593,1580,1605],256],64965:[[1589,1605,1605],256],64966:[[1587,1582,1610],256],64967:[[1606,1580,1610],256],65008:[[1589,1604,1746],256],65009:[[1602,1604,1746],256],65010:[[1575,1604,1604,1607],256],65011:[[1575,1603,1576,1585],256],65012:[[1605,1581,1605,1583],256],65013:[[1589,1604,1593,1605],256],65014:[[1585,1587,1608,1604],256],65015:[[1593,1604,1610,1607],256],65016:[[1608,1587,1604,1605],256],65017:[[1589,1604,1609],256],65018:[[1589,1604,1609,32,1575,1604,1604,1607,32,1593,1604,1610,1607,32,1608,1587,1604,1605],256],65019:[[1580,1604,32,1580,1604,1575,1604,1607],256],65020:[[1585,1740,1575,1604],256]},
65024:{65040:[[44],256],65041:[[12289],256],65042:[[12290],256],65043:[[58],256],65044:[[59],256],65045:[[33],256],65046:[[63],256],65047:[[12310],256],65048:[[12311],256],65049:[[8230],256],65056:[,230],65057:[,230],65058:[,230],65059:[,230],65060:[,230],65061:[,230],65062:[,230],65063:[,220],65064:[,220],65065:[,220],65066:[,220],65067:[,220],65068:[,220],65069:[,220],65072:[[8229],256],65073:[[8212],256],65074:[[8211],256],65075:[[95],256],65076:[[95],256],65077:[[40],256],65078:[[41],256],65079:[[123],256],65080:[[125],256],65081:[[12308],256],65082:[[12309],256],65083:[[12304],256],65084:[[12305],256],65085:[[12298],256],65086:[[12299],256],65087:[[12296],256],65088:[[12297],256],65089:[[12300],256],65090:[[12301],256],65091:[[12302],256],65092:[[12303],256],65095:[[91],256],65096:[[93],256],65097:[[8254],256],65098:[[8254],256],65099:[[8254],256],65100:[[8254],256],65101:[[95],256],65102:[[95],256],65103:[[95],256],65104:[[44],256],65105:[[12289],256],65106:[[46],256],65108:[[59],256],65109:[[58],256],65110:[[63],256],65111:[[33],256],65112:[[8212],256],65113:[[40],256],65114:[[41],256],65115:[[123],256],65116:[[125],256],65117:[[12308],256],65118:[[12309],256],65119:[[35],256],65120:[[38],256],65121:[[42],256],65122:[[43],256],65123:[[45],256],65124:[[60],256],65125:[[62],256],65126:[[61],256],65128:[[92],256],65129:[[36],256],65130:[[37],256],65131:[[64],256],65136:[[32,1611],256],65137:[[1600,1611],256],65138:[[32,1612],256],65140:[[32,1613],256],65142:[[32,1614],256],65143:[[1600,1614],256],65144:[[32,1615],256],65145:[[1600,1615],256],65146:[[32,1616],256],65147:[[1600,1616],256],65148:[[32,1617],256],65149:[[1600,1617],256],65150:[[32,1618],256],65151:[[1600,1618],256],65152:[[1569],256],65153:[[1570],256],65154:[[1570],256],65155:[[1571],256],65156:[[1571],256],65157:[[1572],256],65158:[[1572],256],65159:[[1573],256],65160:[[1573],256],65161:[[1574],256],65162:[[1574],256],65163:[[1574],256],65164:[[1574],256],65165:[[1575],256],65166:[[1575],256],65167:[[1576],256],65168:[[1576],256],65169:[[1576],256],65170:[[1576],256],65171:[[1577],256],65172:[[1577],256],65173:[[1578],256],65174:[[1578],256],65175:[[1578],256],65176:[[1578],256],65177:[[1579],256],65178:[[1579],256],65179:[[1579],256],65180:[[1579],256],65181:[[1580],256],65182:[[1580],256],65183:[[1580],256],65184:[[1580],256],65185:[[1581],256],65186:[[1581],256],65187:[[1581],256],65188:[[1581],256],65189:[[1582],256],65190:[[1582],256],65191:[[1582],256],65192:[[1582],256],65193:[[1583],256],65194:[[1583],256],65195:[[1584],256],65196:[[1584],256],65197:[[1585],256],65198:[[1585],256],65199:[[1586],256],65200:[[1586],256],65201:[[1587],256],65202:[[1587],256],65203:[[1587],256],65204:[[1587],256],65205:[[1588],256],65206:[[1588],256],65207:[[1588],256],65208:[[1588],256],65209:[[1589],256],65210:[[1589],256],65211:[[1589],256],65212:[[1589],256],65213:[[1590],256],65214:[[1590],256],65215:[[1590],256],65216:[[1590],256],65217:[[1591],256],65218:[[1591],256],65219:[[1591],256],65220:[[1591],256],65221:[[1592],256],65222:[[1592],256],65223:[[1592],256],65224:[[1592],256],65225:[[1593],256],65226:[[1593],256],65227:[[1593],256],65228:[[1593],256],65229:[[1594],256],65230:[[1594],256],65231:[[1594],256],65232:[[1594],256],65233:[[1601],256],65234:[[1601],256],65235:[[1601],256],65236:[[1601],256],65237:[[1602],256],65238:[[1602],256],65239:[[1602],256],65240:[[1602],256],65241:[[1603],256],65242:[[1603],256],65243:[[1603],256],65244:[[1603],256],65245:[[1604],256],65246:[[1604],256],65247:[[1604],256],65248:[[1604],256],65249:[[1605],256],65250:[[1605],256],65251:[[1605],256],65252:[[1605],256],65253:[[1606],256],65254:[[1606],256],65255:[[1606],256],65256:[[1606],256],65257:[[1607],256],65258:[[1607],256],65259:[[1607],256],65260:[[1607],256],65261:[[1608],256],65262:[[1608],256],65263:[[1609],256],65264:[[1609],256],65265:[[1610],256],65266:[[1610],256],65267:[[1610],256],65268:[[1610],256],65269:[[1604,1570],256],65270:[[1604,1570],256],65271:[[1604,1571],256],65272:[[1604,1571],256],65273:[[1604,1573],256],65274:[[1604,1573],256],65275:[[1604,1575],256],65276:[[1604,1575],256]},
65280:{65281:[[33],256],65282:[[34],256],65283:[[35],256],65284:[[36],256],65285:[[37],256],65286:[[38],256],65287:[[39],256],65288:[[40],256],65289:[[41],256],65290:[[42],256],65291:[[43],256],65292:[[44],256],65293:[[45],256],65294:[[46],256],65295:[[47],256],65296:[[48],256],65297:[[49],256],65298:[[50],256],65299:[[51],256],65300:[[52],256],65301:[[53],256],65302:[[54],256],65303:[[55],256],65304:[[56],256],65305:[[57],256],65306:[[58],256],65307:[[59],256],65308:[[60],256],65309:[[61],256],65310:[[62],256],65311:[[63],256],65312:[[64],256],65313:[[65],256],65314:[[66],256],65315:[[67],256],65316:[[68],256],65317:[[69],256],65318:[[70],256],65319:[[71],256],65320:[[72],256],65321:[[73],256],65322:[[74],256],65323:[[75],256],65324:[[76],256],65325:[[77],256],65326:[[78],256],65327:[[79],256],65328:[[80],256],65329:[[81],256],65330:[[82],256],65331:[[83],256],65332:[[84],256],65333:[[85],256],65334:[[86],256],65335:[[87],256],65336:[[88],256],65337:[[89],256],65338:[[90],256],65339:[[91],256],65340:[[92],256],65341:[[93],256],65342:[[94],256],65343:[[95],256],65344:[[96],256],65345:[[97],256],65346:[[98],256],65347:[[99],256],65348:[[100],256],65349:[[101],256],65350:[[102],256],65351:[[103],256],65352:[[104],256],65353:[[105],256],65354:[[106],256],65355:[[107],256],65356:[[108],256],65357:[[109],256],65358:[[110],256],65359:[[111],256],65360:[[112],256],65361:[[113],256],65362:[[114],256],65363:[[115],256],65364:[[116],256],65365:[[117],256],65366:[[118],256],65367:[[119],256],65368:[[120],256],65369:[[121],256],65370:[[122],256],65371:[[123],256],65372:[[124],256],65373:[[125],256],65374:[[126],256],65375:[[10629],256],65376:[[10630],256],65377:[[12290],256],65378:[[12300],256],65379:[[12301],256],65380:[[12289],256],65381:[[12539],256],65382:[[12530],256],65383:[[12449],256],65384:[[12451],256],65385:[[12453],256],65386:[[12455],256],65387:[[12457],256],65388:[[12515],256],65389:[[12517],256],65390:[[12519],256],65391:[[12483],256],65392:[[12540],256],65393:[[12450],256],65394:[[12452],256],65395:[[12454],256],65396:[[12456],256],65397:[[12458],256],65398:[[12459],256],65399:[[12461],256],65400:[[12463],256],65401:[[12465],256],65402:[[12467],256],65403:[[12469],256],65404:[[12471],256],65405:[[12473],256],65406:[[12475],256],65407:[[12477],256],65408:[[12479],256],65409:[[12481],256],65410:[[12484],256],65411:[[12486],256],65412:[[12488],256],65413:[[12490],256],65414:[[12491],256],65415:[[12492],256],65416:[[12493],256],65417:[[12494],256],65418:[[12495],256],65419:[[12498],256],65420:[[12501],256],65421:[[12504],256],65422:[[12507],256],65423:[[12510],256],65424:[[12511],256],65425:[[12512],256],65426:[[12513],256],65427:[[12514],256],65428:[[12516],256],65429:[[12518],256],65430:[[12520],256],65431:[[12521],256],65432:[[12522],256],65433:[[12523],256],65434:[[12524],256],65435:[[12525],256],65436:[[12527],256],65437:[[12531],256],65438:[[12441],256],65439:[[12442],256],65440:[[12644],256],65441:[[12593],256],65442:[[12594],256],65443:[[12595],256],65444:[[12596],256],65445:[[12597],256],65446:[[12598],256],65447:[[12599],256],65448:[[12600],256],65449:[[12601],256],65450:[[12602],256],65451:[[12603],256],65452:[[12604],256],65453:[[12605],256],65454:[[12606],256],65455:[[12607],256],65456:[[12608],256],65457:[[12609],256],65458:[[12610],256],65459:[[12611],256],65460:[[12612],256],65461:[[12613],256],65462:[[12614],256],65463:[[12615],256],65464:[[12616],256],65465:[[12617],256],65466:[[12618],256],65467:[[12619],256],65468:[[12620],256],65469:[[12621],256],65470:[[12622],256],65474:[[12623],256],65475:[[12624],256],65476:[[12625],256],65477:[[12626],256],65478:[[12627],256],65479:[[12628],256],65482:[[12629],256],65483:[[12630],256],65484:[[12631],256],65485:[[12632],256],65486:[[12633],256],65487:[[12634],256],65490:[[12635],256],65491:[[12636],256],65492:[[12637],256],65493:[[12638],256],65494:[[12639],256],65495:[[12640],256],65498:[[12641],256],65499:[[12642],256],65500:[[12643],256],65504:[[162],256],65505:[[163],256],65506:[[172],256],65507:[[175],256],65508:[[166],256],65509:[[165],256],65510:[[8361],256],65512:[[9474],256],65513:[[8592],256],65514:[[8593],256],65515:[[8594],256],65516:[[8595],256],65517:[[9632],256],65518:[[9675],256]}

};

   /***** Module to export */
   var unorm = {
      nfc: nfc,
      nfd: nfd,
      nfkc: nfkc,
      nfkd: nfkd
   };

   /*globals module:true,define:true*/

   // CommonJS
   if (true) {
      module.exports = unorm;

   // AMD
   } else if (typeof define === "function" && define.amd) {
      define("unorm", function () {
         return unorm;
      });

   // Global
   } else {
      root.unorm = unorm;
   }

   /***** Export as shim for String::normalize method *****/
   /*
      http://wiki.ecmascript.org/doku.php?id=harmony:specification_drafts#november_8_2013_draft_rev_21

      21.1.3.12 String.prototype.normalize(form="NFC")
      When the normalize method is called with one argument form, the following steps are taken:

      1. Let O be CheckObjectCoercible(this value).
      2. Let S be ToString(O).
      3. ReturnIfAbrupt(S).
      4. If form is not provided or undefined let form be "NFC".
      5. Let f be ToString(form).
      6. ReturnIfAbrupt(f).
      7. If f is not one of "NFC", "NFD", "NFKC", or "NFKD", then throw a RangeError Exception.
      8. Let ns be the String value is the result of normalizing S into the normalization form named by f as specified in Unicode Standard Annex #15, UnicodeNormalizatoin Forms.
      9. Return ns.

      The length property of the normalize method is 0.

      *NOTE* The normalize function is intentionally generic; it does not require that its this value be a String object. Therefore it can be transferred to other kinds of objects for use as a method.
   */
    unorm.shimApplied = false;

   if (!String.prototype.normalize) {
      Object.defineProperty(String.prototype, "normalize", {
         enumerable: false,
         configurable: true,
         writable: true,
         value: function normalize (/*form*/) {
            
            var str = "" + this;
            var form = arguments[0] === undefined ? "NFC" : arguments[0];

            if (this === null || this === undefined) {
               throw new TypeError("Cannot call method on " + Object.prototype.toString.call(this));
            }

            if (form === "NFC") {
               return unorm.nfc(str);
            } else if (form === "NFD") {
               return unorm.nfd(str);
            } else if (form === "NFKC") {
               return unorm.nfkc(str);
            } else if (form === "NFKD") {
               return unorm.nfkd(str);
            } else {
               throw new RangeError("Invalid normalization form: " + form);
            }
         }
      });

      unorm.shimApplied = true;
   }
}(this));


/***/ }),
/* 1731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sale_RoundSection_RoundEdit__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Localization__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var IncreaseStep2=Object(__WEBPACK_IMPORTED_MODULE_3__components_Localization__["a" /* localizable */])(_class=(_temp=_class2=function(_Component){_inherits(IncreaseStep2,_Component);function IncreaseStep2(){_classCallCheck(this,IncreaseStep2);return _possibleConstructorReturn(this,(IncreaseStep2.__proto__||Object.getPrototypeOf(IncreaseStep2)).apply(this,arguments));}_createClass(IncreaseStep2,[{key:'render',value:function render(){var _props=this.props,_props$store=_props.store,roundEditStore=_props$store.roundEditStore,_props$store$accepted=_props$store.acceptedOffers,acceptedOffers=_props$store$accepted===undefined?[]:_props$store$accepted,_props$store$offers=_props$store.offers,offers=_props$store$offers===undefined?[]:_props$store$offers,t=_props.t;var offersValues=offers.filter(function(o){return acceptedOffers.includes(o.buyerId);}).map(function(o){return o.submittedValue;});var highestOffer=Math.max.apply(Math,_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["n" /* toJS */])(offersValues)).concat([0]));return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('ul',{className:'hint'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',null,t('Please define the next round.')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',null,t('Validity of offers set to the same value'))),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Sale_RoundSection_RoundEdit__["a" /* default */],{store:roundEditStore,allowChangeType:roundEditStore.isSimpleOffer,disallowedRounds:['simple_offer'],overrideStartPrice:highestOffer>0?highestOffer:null})));}}]);return IncreaseStep2;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class2.displayName='IncreaseStep2',_temp))||_class;/* harmony default export */ __webpack_exports__["a"] = (IncreaseStep2);

/***/ }),
/* 1732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseButton__ = __webpack_require__(150);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__BaseButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Button_types__ = __webpack_require__(704);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Button__ = __webpack_require__(1755);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__Button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ActionButton_ActionButton__ = __webpack_require__(413);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__ActionButton_ActionButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CommandBarButton_CommandBarButton__ = __webpack_require__(1759);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__CommandBarButton_CommandBarButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CommandButton_CommandButton__ = __webpack_require__(1761);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__CommandButton_CommandButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CompoundButton_CompoundButton__ = __webpack_require__(707);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DefaultButton_DefaultButton__ = __webpack_require__(273);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_7__DefaultButton_DefaultButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MessageBarButton_MessageBarButton__ = __webpack_require__(1762);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PrimaryButton_PrimaryButton__ = __webpack_require__(709);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_9__PrimaryButton_PrimaryButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__IconButton_IconButton__ = __webpack_require__(708);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_10__IconButton_IconButton__["a"]; });











//# sourceMappingURL=index.js.map

/***/ }),
/* 1733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ContextualMenu__ = __webpack_require__(1734);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ContextualMenu__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContextualMenu_base__ = __webpack_require__(695);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ContextualMenu_types__ = __webpack_require__(696);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__ContextualMenu_types__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContextualMenuItem__ = __webpack_require__(183);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContextualMenuItem_base__ = __webpack_require__(701);
/* unused harmony namespace reexport */





//# sourceMappingURL=index.js.map

/***/ }),
/* 1734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContextualMenu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContextualMenu_base__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContextualMenu_styles__ = __webpack_require__(1753);





// This is to prevent cyclic import with ContextualMenu.base.tsx.
var LocalContextualMenu;
function onRenderSubMenu(subMenuProps) {
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](LocalContextualMenu, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, subMenuProps));
}
LocalContextualMenu = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_3__ContextualMenu_base__["a" /* ContextualMenuBase */], __WEBPACK_IMPORTED_MODULE_4__ContextualMenu_styles__["a" /* getStyles */], function () {
    return {
        onRenderSubMenu: onRenderSubMenu
    };
}, { scope: 'ContextualMenu' });
/**
 * ContextualMenu description
 */
var ContextualMenu = LocalContextualMenu;
//# sourceMappingURL=ContextualMenu.js.map

/***/ }),
/* 1735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getIsChecked;
/* harmony export (immutable) */ __webpack_exports__["b"] = hasSubmenu;
/* harmony export (immutable) */ __webpack_exports__["c"] = isItemDisabled;
/**
 * Determines the effective checked state of a menu item.
 *
 * @param item {IContextualMenuItem} to get the check state of.
 * @returns {true} if the item is checked.
 * @returns {false} if the item is unchecked.
 * @returns {null} if the item is not checkable.
 */
function getIsChecked(item) {
    if (item.canCheck) {
        return !!(item.isChecked || item.checked);
    }
    if (typeof item.isChecked === 'boolean') {
        return item.isChecked;
    }
    if (typeof item.checked === 'boolean') {
        return item.checked;
    }
    // Item is not checkable.
    return null;
}
function hasSubmenu(item) {
    return !!(item.subMenuProps || item.items);
}
function isItemDisabled(item) {
    return !!(item.isDisabled || item.disabled);
}
//# sourceMappingURL=contextualMenuUtility.js.map

/***/ }),
/* 1736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CalloutContent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CalloutContent_base__ = __webpack_require__(1737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CalloutContent_styles__ = __webpack_require__(1741);



var CalloutContent = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__CalloutContent_base__["a" /* CalloutContentBase */], __WEBPACK_IMPORTED_MODULE_2__CalloutContent_styles__["a" /* getStyles */], undefined, { scope: 'CalloutContent' });
//# sourceMappingURL=CalloutContent.js.map

/***/ }),
/* 1737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CalloutContentBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_DirectionalHint__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_positioning__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Popup__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Styling__ = __webpack_require__(5);








var ANIMATIONS = (_a = {},
    _a[__WEBPACK_IMPORTED_MODULE_4__utilities_positioning__["b" /* RectangleEdge */].top] = __WEBPACK_IMPORTED_MODULE_6__Styling__["a" /* AnimationClassNames */].slideUpIn10,
    _a[__WEBPACK_IMPORTED_MODULE_4__utilities_positioning__["b" /* RectangleEdge */].bottom] = __WEBPACK_IMPORTED_MODULE_6__Styling__["a" /* AnimationClassNames */].slideDownIn10,
    _a[__WEBPACK_IMPORTED_MODULE_4__utilities_positioning__["b" /* RectangleEdge */].left] = __WEBPACK_IMPORTED_MODULE_6__Styling__["a" /* AnimationClassNames */].slideLeftIn10,
    _a[__WEBPACK_IMPORTED_MODULE_4__utilities_positioning__["b" /* RectangleEdge */].right] = __WEBPACK_IMPORTED_MODULE_6__Styling__["a" /* AnimationClassNames */].slideRightIn10,
    _a);
var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["r" /* classNamesFunction */])({
    disableCaching: true
});
var BORDER_WIDTH = 1;
var BEAK_ORIGIN_POSITION = { top: 0, left: 0 };
// Microsoft Edge will overwrite inline styles if there is an animation pertaining to that style.
// To help ensure that edge will respect the offscreen style opacity
// filter needs to be added as an additional way to set opacity.
var OFF_SCREEN_STYLE = { opacity: 0, filter: 'opacity(0)' };
// role and role description go hand-in-hand. Both would be included by spreading getNativeProps for a basic element
// This constant array can be used to filter these out of native props spread on callout root and apply them together on
// calloutMain (the Popup component within the callout)
var ARIA_ROLE_ATTRIBUTES = ['role', 'aria-roledescription'];
var CalloutContentBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](CalloutContentBase, _super);
    function CalloutContentBase(props) {
        var _this = _super.call(this, props) || this;
        _this._hostElement = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._calloutElement = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._hasListeners = false;
        _this._disposables = [];
        _this.dismiss = function (ev) {
            var onDismiss = _this.props.onDismiss;
            if (onDismiss) {
                onDismiss(ev);
            }
        };
        _this._dismissOnScroll = function (ev) {
            var preventDismissOnScroll = _this.props.preventDismissOnScroll;
            if (_this.state.positions && !preventDismissOnScroll) {
                _this._dismissOnClickOrScroll(ev);
            }
        };
        _this._dismissOnResize = function (ev) {
            var preventDismissOnResize = _this.props.preventDismissOnResize;
            if (!preventDismissOnResize) {
                _this.dismiss(ev);
            }
        };
        _this._dismissOnLostFocus = function (ev) {
            var preventDismissOnLostFocus = _this.props.preventDismissOnLostFocus;
            if (!preventDismissOnLostFocus) {
                _this._dismissOnClickOrScroll(ev);
            }
        };
        _this._setInitialFocus = function () {
            if (_this.props.setInitialFocus && !_this._didSetInitialFocus && _this.state.positions && _this._calloutElement.current) {
                _this._didSetInitialFocus = true;
                _this._async.requestAnimationFrame(function () { return Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["F" /* focusFirstChild */])(_this._calloutElement.current); }, _this._calloutElement.current);
            }
        };
        _this._onComponentDidMount = function () {
            _this._addListeners();
            if (_this.props.onLayerMounted) {
                _this.props.onLayerMounted();
            }
            _this._updateAsyncPosition();
            _this._setHeightOffsetEveryFrame();
        };
        _this._async = new __WEBPACK_IMPORTED_MODULE_3__Utilities__["a" /* Async */](_this);
        _this._didSetInitialFocus = false;
        _this.state = {
            positions: undefined,
            slideDirectionalClassName: undefined,
            // @TODO it looks like this is not even being used anymore.
            calloutElementRect: undefined,
            heightOffset: 0
        };
        _this._positionAttempts = 0;
        return _this;
    }
    CalloutContentBase.prototype.componentDidUpdate = function () {
        if (!this.props.hidden) {
            this._setInitialFocus();
            if (!this._hasListeners) {
                this._addListeners();
            }
            this._updateAsyncPosition();
        }
        else {
            if (this._hasListeners) {
                this._removeListeners();
            }
        }
    };
    CalloutContentBase.prototype.shouldComponentUpdate = function (newProps, newState) {
        if (this.props.hidden && newProps.hidden) {
            // Do not update when hidden.
            return false;
        }
        return !Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_27" /* shallowCompare */])(this.props, newProps) || !Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_27" /* shallowCompare */])(this.state, newState);
    };
    CalloutContentBase.prototype.componentWillMount = function () {
        this._setTargetWindowAndElement(this._getTarget());
    };
    CalloutContentBase.prototype.componentWillUnmount = function () {
        this._async.dispose();
        this._disposables.forEach(function (dispose) { return dispose(); });
    };
    CalloutContentBase.prototype.componentWillUpdate = function (newProps) {
        // If the target element changed, find the new one. If we are tracking target with class name, always find element because we
        // do not know if fabric has rendered a new element and disposed the old element.
        var newTarget = this._getTarget(newProps);
        var oldTarget = this._getTarget();
        if ((newTarget !== oldTarget || typeof newTarget === 'string' || newTarget instanceof String) && !this._blockResetHeight) {
            this._maxHeight = undefined;
            this._setTargetWindowAndElement(newTarget);
        }
        if (newProps.gapSpace !== this.props.gapSpace || this.props.beakWidth !== newProps.beakWidth) {
            this._maxHeight = undefined;
        }
        if (newProps.finalHeight !== this.props.finalHeight) {
            this._setHeightOffsetEveryFrame();
        }
        // Ensure positioning is recalculated when we are about to show a persisted menu.
        if (!newProps.hidden && newProps.hidden !== this.props.hidden) {
            this._maxHeight = undefined;
            // Target might have been updated while hidden.
            this._setTargetWindowAndElement(newTarget);
            this.setState({
                positions: undefined
            });
            this._didSetInitialFocus = false;
            this._bounds = undefined;
        }
        this._blockResetHeight = false;
    };
    CalloutContentBase.prototype.componentDidMount = function () {
        if (!this.props.hidden) {
            this._onComponentDidMount();
        }
    };
    CalloutContentBase.prototype.render = function () {
        // If there is no target window then we are likely in server side rendering and we should not render anything.
        if (!this._targetWindow) {
            return null;
        }
        var target = this.props.target;
        var _a = this.props, styles = _a.styles, style = _a.style, ariaLabel = _a.ariaLabel, ariaDescribedBy = _a.ariaDescribedBy, ariaLabelledBy = _a.ariaLabelledBy, className = _a.className, isBeakVisible = _a.isBeakVisible, children = _a.children, beakWidth = _a.beakWidth, calloutWidth = _a.calloutWidth, calloutMaxWidth = _a.calloutMaxWidth, finalHeight = _a.finalHeight, _b = _a.hideOverflow, hideOverflow = _b === void 0 ? !!finalHeight : _b, backgroundColor = _a.backgroundColor, calloutMaxHeight = _a.calloutMaxHeight, onScroll = _a.onScroll, _c = _a.shouldRestoreFocus, shouldRestoreFocus = _c === void 0 ? true : _c;
        target = this._getTarget();
        var positions = this.state.positions;
        var getContentMaxHeight = this._getMaxHeight() ? this._getMaxHeight() + this.state.heightOffset : undefined;
        var contentMaxHeight = calloutMaxHeight && getContentMaxHeight && calloutMaxHeight < getContentMaxHeight ? calloutMaxHeight : getContentMaxHeight;
        var overflowYHidden = hideOverflow;
        var beakVisible = isBeakVisible && !!target;
        this._classNames = getClassNames(styles, {
            theme: this.props.theme,
            className: className,
            overflowYHidden: overflowYHidden,
            calloutWidth: calloutWidth,
            positions: positions,
            beakWidth: beakWidth,
            backgroundColor: backgroundColor,
            calloutMaxWidth: calloutMaxWidth
        });
        var overflowStyle = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, style, { maxHeight: contentMaxHeight }, (overflowYHidden && { overflowY: 'hidden' }));
        var visibilityStyle = this.props.hidden ? { visibility: 'hidden' } : undefined;
        // React.CSSProperties does not understand IRawStyle, so the inline animations will need to be cast as any for now.
        var content = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: this._hostElement, className: this._classNames.container, style: visibilityStyle },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["R" /* getNativeProps */])(this.props, __WEBPACK_IMPORTED_MODULE_3__Utilities__["w" /* divProperties */], ARIA_ROLE_ATTRIBUTES), { className: Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["t" /* css */])(this._classNames.root, positions && positions.targetEdge && ANIMATIONS[positions.targetEdge]), style: positions ? positions.elementPosition : OFF_SCREEN_STYLE, tabIndex: -1, 
                // See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#Clicking_and_focus
                ref: this._calloutElement }),
                beakVisible && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.beak, style: this._getBeakPosition() }),
                beakVisible && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.beakCurtain }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Popup__["a" /* Popup */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["R" /* getNativeProps */])(this.props, ARIA_ROLE_ATTRIBUTES), { ariaLabel: ariaLabel, ariaDescribedBy: ariaDescribedBy, ariaLabelledBy: ariaLabelledBy, className: this._classNames.calloutMain, onDismiss: this.dismiss, onScroll: onScroll, shouldRestoreFocus: shouldRestoreFocus, style: overflowStyle }), children))));
        return content;
    };
    CalloutContentBase.prototype._dismissOnClickOrScroll = function (ev) {
        var target = ev.target;
        var isEventTargetOutsideCallout = this._hostElement.current && !Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["y" /* elementContains */])(this._hostElement.current, target);
        if ((!this._target && isEventTargetOutsideCallout) ||
            (ev.target !== this._targetWindow &&
                isEventTargetOutsideCallout &&
                (this._target.stopPropagation ||
                    (!this._target || (target !== this._target && !Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["y" /* elementContains */])(this._target, target)))))) {
            this.dismiss(ev);
        }
    };
    CalloutContentBase.prototype._addListeners = function () {
        var _this = this;
        // This is added so the callout will dismiss when the window is scrolled
        // but not when something inside the callout is scrolled. The delay seems
        // to be required to avoid React firing an async focus event in IE from
        // the target changing focus quickly prior to rendering the callout.
        this._async.setTimeout(function () {
            _this._disposables.push(Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_18" /* on */])(_this._targetWindow, 'scroll', _this._dismissOnScroll, true), Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_18" /* on */])(_this._targetWindow, 'resize', _this._dismissOnResize, true), Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_18" /* on */])(_this._targetWindow.document.documentElement, 'focus', _this._dismissOnLostFocus, true), Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_18" /* on */])(_this._targetWindow.document.documentElement, 'click', _this._dismissOnLostFocus, true));
            _this._hasListeners = true;
        }, 0);
    };
    CalloutContentBase.prototype._removeListeners = function () {
        this._disposables.forEach(function (dispose) { return dispose(); });
        this._disposables = [];
        this._hasListeners = false;
    };
    CalloutContentBase.prototype._updateAsyncPosition = function () {
        var _this = this;
        this._async.requestAnimationFrame(function () { return _this._updatePosition(); }, this._calloutElement.current);
    };
    CalloutContentBase.prototype._getBeakPosition = function () {
        var positions = this.state.positions;
        var beakPostionStyle = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, (positions && positions.beakPosition ? positions.beakPosition.elementPosition : null));
        if (!beakPostionStyle.top && !beakPostionStyle.bottom && !beakPostionStyle.left && !beakPostionStyle.right) {
            beakPostionStyle.left = BEAK_ORIGIN_POSITION.left;
            beakPostionStyle.top = BEAK_ORIGIN_POSITION.top;
        }
        return beakPostionStyle;
    };
    CalloutContentBase.prototype._updatePosition = function () {
        // Try to update the target, page might have changed
        this._setTargetWindowAndElement(this._getTarget());
        var positions = this.state.positions;
        var hostElement = this._hostElement.current;
        var calloutElement = this._calloutElement.current;
        // If we expect a target element to position against, we need to wait until `this._target` is resolved. Otherwise
        // we can try to position.
        var expectsTarget = !!this.props.target;
        if (hostElement && calloutElement && (!expectsTarget || this._target)) {
            var currentProps = void 0;
            currentProps = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["n" /* assign */])(currentProps, this.props);
            currentProps.bounds = this._getBounds();
            currentProps.target = this._target;
            // If there is a finalHeight given then we assume that the user knows and will handle
            // additional positioning adjustments so we should call positionCard
            var newPositions = this.props.finalHeight
                ? Object(__WEBPACK_IMPORTED_MODULE_4__utilities_positioning__["f" /* positionCard */])(currentProps, hostElement, calloutElement, positions)
                : Object(__WEBPACK_IMPORTED_MODULE_4__utilities_positioning__["e" /* positionCallout */])(currentProps, hostElement, calloutElement, positions);
            // Set the new position only when the positions are not exists or one of the new callout positions are different.
            // The position should not change if the position is within 2 decimal places.
            if ((!positions && newPositions) ||
                (positions && newPositions && !this._arePositionsEqual(positions, newPositions) && this._positionAttempts < 5)) {
                // We should not reposition the callout more than a few times, if it is then the content is likely resizing
                // and we should stop trying to reposition to prevent a stack overflow.
                this._positionAttempts++;
                this.setState({
                    positions: newPositions
                });
            }
            else if (this._positionAttempts > 0) {
                // Only call the onPositioned callback if the callout has been re-positioned at least once.
                this._positionAttempts = 0;
                if (this.props.onPositioned) {
                    this.props.onPositioned(this.state.positions);
                }
            }
        }
    };
    CalloutContentBase.prototype._getBounds = function () {
        if (!this._bounds) {
            var currentBounds = this.props.bounds;
            if (!currentBounds) {
                currentBounds = {
                    top: 0 + this.props.minPagePadding,
                    left: 0 + this.props.minPagePadding,
                    right: this._targetWindow.innerWidth - this.props.minPagePadding,
                    bottom: this._targetWindow.innerHeight - this.props.minPagePadding,
                    width: this._targetWindow.innerWidth - this.props.minPagePadding * 2,
                    height: this._targetWindow.innerHeight - this.props.minPagePadding * 2
                };
            }
            this._bounds = currentBounds;
        }
        return this._bounds;
    };
    // Max height should remain as synchronous as possible, which is why it is not done using set state.
    // It needs to be synchronous since it will impact the ultimate position of the callout.
    CalloutContentBase.prototype._getMaxHeight = function () {
        var _this = this;
        if (!this._maxHeight) {
            if (this.props.directionalHintFixed && this._target) {
                var beakWidth = this.props.isBeakVisible ? this.props.beakWidth : 0;
                var gapSpace = this.props.gapSpace ? this.props.gapSpace : 0;
                // Since the callout cannot measure it's border size it must be taken into account here. Otherwise it will
                // overlap with the target.
                var totalGap_1 = gapSpace + beakWidth + BORDER_WIDTH * 2;
                this._async.requestAnimationFrame(function () {
                    if (_this._target) {
                        _this._maxHeight = Object(__WEBPACK_IMPORTED_MODULE_4__utilities_positioning__["c" /* getMaxHeight */])(_this._target, _this.props.directionalHint, totalGap_1, _this._getBounds(), _this.props.coverTarget);
                        _this._blockResetHeight = true;
                        _this.forceUpdate();
                    }
                }, this._target);
            }
            else {
                this._maxHeight = this._getBounds().height - BORDER_WIDTH * 2;
            }
        }
        return this._maxHeight;
    };
    CalloutContentBase.prototype._arePositionsEqual = function (positions, newPosition) {
        return (this._comparePositions(positions.elementPosition, newPosition.elementPosition) &&
            this._comparePositions(positions.beakPosition.elementPosition, newPosition.beakPosition.elementPosition));
    };
    CalloutContentBase.prototype._comparePositions = function (oldPositions, newPositions) {
        for (var key in newPositions) {
            // This needs to be checked here and below because there is a linting error if for in does not immediately have an if statement
            if (newPositions.hasOwnProperty(key)) {
                var oldPositionEdge = oldPositions[key];
                var newPositionEdge = newPositions[key];
                if (oldPositionEdge !== undefined && newPositionEdge !== undefined) {
                    if (oldPositionEdge.toFixed(2) !== newPositionEdge.toFixed(2)) {
                        return false;
                    }
                }
                else {
                    return false;
                }
            }
        }
        return true;
    };
    CalloutContentBase.prototype._setTargetWindowAndElement = function (target) {
        var currentElement = this._calloutElement.current;
        if (target) {
            if (typeof target === 'string') {
                var currentDoc = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["I" /* getDocument */])(currentElement);
                this._target = currentDoc ? currentDoc.querySelector(target) : null;
                this._targetWindow = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["Z" /* getWindow */])(currentElement);
            }
            else if (target.stopPropagation) {
                this._targetWindow = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["Z" /* getWindow */])(target.toElement);
                this._target = target;
            }
            else if (target.getBoundingClientRect) {
                var targetElement = target;
                this._targetWindow = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["Z" /* getWindow */])(targetElement);
                this._target = target;
                // HTMLImgElements can have x and y values. The check for it being a point must go last.
            }
            else {
                this._targetWindow = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["Z" /* getWindow */])(currentElement);
                this._target = target;
            }
        }
        else {
            this._targetWindow = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["Z" /* getWindow */])(currentElement);
        }
    };
    CalloutContentBase.prototype._setHeightOffsetEveryFrame = function () {
        var _this = this;
        if (this._calloutElement.current && this.props.finalHeight) {
            this._setHeightOffsetTimer = this._async.requestAnimationFrame(function () {
                var calloutMainElem = _this._calloutElement.current && _this._calloutElement.current.lastChild;
                if (!calloutMainElem) {
                    return;
                }
                var cardScrollHeight = calloutMainElem.scrollHeight;
                var cardCurrHeight = calloutMainElem.offsetHeight;
                var scrollDiff = cardScrollHeight - cardCurrHeight;
                _this.setState({
                    heightOffset: _this.state.heightOffset + scrollDiff
                });
                if (calloutMainElem.offsetHeight < _this.props.finalHeight) {
                    _this._setHeightOffsetEveryFrame();
                }
                else {
                    _this._async.cancelAnimationFrame(_this._setHeightOffsetTimer, _this._calloutElement.current);
                }
            }, this._calloutElement.current);
        }
    };
    CalloutContentBase.prototype._getTarget = function (props) {
        if (props === void 0) { props = this.props; }
        var target = props.target;
        return target;
    };
    CalloutContentBase.defaultProps = {
        preventDismissOnLostFocus: false,
        preventDismissOnScroll: false,
        preventDismissOnResize: false,
        isBeakVisible: true,
        beakWidth: 16,
        gapSpace: 0,
        minPagePadding: 8,
        directionalHint: __WEBPACK_IMPORTED_MODULE_2__common_DirectionalHint__["a" /* DirectionalHint */].bottomAutoEdge
    };
    return CalloutContentBase;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

var _a;
//# sourceMappingURL=CalloutContent.base.js.map

/***/ }),
/* 1738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__positioning__ = __webpack_require__(1739);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__positioning__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__positioning__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__positioning__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__positioning__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__positioning__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__positioning_types__ = __webpack_require__(699);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__positioning_types__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__positioning_types__["b"]; });


//# sourceMappingURL=index.js.map

/***/ }),
/* 1739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Rectangle */
/* unused harmony export __positioningTestPackage */
/* harmony export (immutable) */ __webpack_exports__["e"] = positionElement;
/* harmony export (immutable) */ __webpack_exports__["c"] = positionCallout;
/* harmony export (immutable) */ __webpack_exports__["d"] = positionCard;
/* harmony export (immutable) */ __webpack_exports__["a"] = getMaxHeight;
/* harmony export (immutable) */ __webpack_exports__["b"] = getOppositeEdge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_DirectionalHint__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__positioning_types__ = __webpack_require__(699);




var Rectangle = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](Rectangle, _super);
    function Rectangle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Rectangle;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["h" /* Rectangle */]));

function _createPositionData(targetEdge, alignmentEdge, isAuto) {
    return {
        targetEdge: targetEdge,
        alignmentEdge: alignmentEdge,
        isAuto: isAuto
    };
}
// Currently the beakPercent is set to 50 for all positions meaning that it should tend to the center of the target
var DirectionalDictionary = (_a = {},
    _a[__WEBPACK_IMPORTED_MODULE_1__common_DirectionalHint__["a" /* DirectionalHint */].topLeftEdge] = _createPositionData(__WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */].top, __WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */].left),
    _a[__WEBPACK_IMPORTED_MODULE_1__common_DirectionalHint__["a" /* DirectionalHint */].topCenter] = _createPositionData(__WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */].top),
    _a[__WEBPACK_IMPORTED_MODULE_1__common_DirectionalHint__["a" /* DirectionalHint */].topRightEdge] = _createPositionData(__WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */].top, __WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */].right),
    _a[__WEBPACK_IMPORTED_MODULE_1__common_DirectionalHint__["a" /* DirectionalHint */].topAutoEdge] = _createPositionData(__WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */].top, undefined, true),
    _a[__WEBPACK_IMPORTED_MODULE_1__common_DirectionalHint__["a" /* DirectionalHint */].bottomLeftEdge] = _createPositionData(__WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */].bottom, __WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */].left),
    _a[__WEBPACK_IMPORTED_MODULE_1__common_DirectionalHint__["a" /* DirectionalHint */].bottomCenter] = _createPositionData(__WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */].bottom),
    _a[__WEBPACK_IMPORTED_MODULE_1__common_DirectionalHint__["a" /* DirectionalHint */].bottomRightEdge] = _createPositionData(__WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */].bottom, __WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */].right),
    _a[__WEBPACK_IMPORTED_MODULE_1__common_DirectionalHint__["a" /* DirectionalHint */].bottomAutoEdge] = _createPositionData(__WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */].bottom, undefined, true),
    _a[__WEBPACK_IMPORTED_MODULE_1__common_DirectionalHint__["a" /* DirectionalHint */].leftTopEdge] = _createPositionData(__WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */].left, __WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */].top),
    _a[__WEBPACK_IMPORTED_MODULE_1__common_DirectionalHint__["a" /* DirectionalHint */].leftCenter] = _createPositionData(__WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */].left),
    _a[__WEBPACK_IMPORTED_MODULE_1__common_DirectionalHint__["a" /* DirectionalHint */].leftBottomEdge] = _createPositionData(__WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */].left, __WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */].bottom),
    _a[__WEBPACK_IMPORTED_MODULE_1__common_DirectionalHint__["a" /* DirectionalHint */].rightTopEdge] = _createPositionData(__WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */].right, __WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */].top),
    _a[__WEBPACK_IMPORTED_MODULE_1__common_DirectionalHint__["a" /* DirectionalHint */].rightCenter] = _createPositionData(__WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */].right),
    _a[__WEBPACK_IMPORTED_MODULE_1__common_DirectionalHint__["a" /* DirectionalHint */].rightBottomEdge] = _createPositionData(__WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */].right, __WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */].bottom),
    _a);
function _isRectangleWithinBounds(rect, boundingRect) {
    if (rect.top < boundingRect.top) {
        return false;
    }
    if (rect.bottom > boundingRect.bottom) {
        return false;
    }
    if (rect.left < boundingRect.left) {
        return false;
    }
    if (rect.right > boundingRect.right) {
        return false;
    }
    return true;
}
/**
 * Gets all of the edges of a rectangle that are outside of the given bounds.
 * If there are no out of bounds edges it returns an empty array.
 */
function _getOutOfBoundsEdges(rect, boundingRect) {
    var outOfBounds = new Array();
    if (rect.top < boundingRect.top) {
        outOfBounds.push(__WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */].top);
    }
    if (rect.bottom > boundingRect.bottom) {
        outOfBounds.push(__WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */].bottom);
    }
    if (rect.left < boundingRect.left) {
        outOfBounds.push(__WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */].left);
    }
    if (rect.right > boundingRect.right) {
        outOfBounds.push(__WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */].right);
    }
    return outOfBounds;
}
function _getEdgeValue(rect, edge) {
    return rect[__WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */][edge]];
}
function _setEdgeValue(rect, edge, value) {
    rect[__WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */][edge]] = value;
    return rect;
}
/**
 * Returns the middle value of an edge. Only returns 1 value rather than xy coordinates as
 * the itself already contains the other coordinate.
 * For instance, a bottom edge's current value is it's y coordinate, so the number returned is the x.
 *
 * @param {Rectangle} rect
 * @param {RectangleEdge} edge
 * @returns {number}
 */
function _getCenterValue(rect, edge) {
    var edges = _getFlankingEdges(edge);
    return (_getEdgeValue(rect, edges.positiveEdge) + _getEdgeValue(rect, edges.negativeEdge)) / 2;
}
/**
 * Flips the value depending on the edge.
 * If the edge is a "positive" edge, Top or Left, then the value should stay as it is.
 * If the edge is a "negative" edge, Bottom or Right, then the value should be flipped.
 * This is to account for the fact that the coordinates are effectively reveserved in certain cases for the "negative" edges.
 * For example, when testing to see if a bottom edge 1 is within the bounds of another bottom edge 2.
 * If edge 1 is greater than edge 2 then it is out of bounds. This is reversed for top edge 1 and top edge 2.
 * If top edge 1 is less than edge 2 then it is out of bounds.
 *
 *
 * @param {RectangleEdge} edge
 * @param {number} value
 * @returns {number}
 */
function _getRelativeEdgeValue(edge, value) {
    if (edge > 0) {
        return value;
    }
    else {
        return value * -1;
    }
}
function _getRelativeRectEdgeValue(edge, rect) {
    return _getRelativeEdgeValue(edge, _getEdgeValue(rect, edge));
}
function _getRelativeEdgeDifference(rect, hostRect, edge) {
    var edgeDifference = _getEdgeValue(rect, edge) - _getEdgeValue(hostRect, edge);
    return _getRelativeEdgeValue(edge, edgeDifference);
}
/**
 * Moves the edge of a rectangle to the value given. It only moves the edge in a linear direction based on that edge.
 * For example, if it's a bottom edge it will only change y coordinates.
 *
 * @param {Rectangle} rect
 * @param {RectangleEdge} edge
 * @param {number} newValue
 * @returns {Rectangle}
 */
function _moveEdge(rect, edge, newValue) {
    var difference = _getEdgeValue(rect, edge) - newValue;
    rect = _setEdgeValue(rect, edge, newValue);
    rect = _setEdgeValue(rect, edge * -1, _getEdgeValue(rect, edge * -1) - difference);
    return rect;
}
/**
 * Aligns the edge on the passed in rect to the target. If there is a gap then it will have that space between the two.
 *
 * @param {Rectangle} rect
 * @param {Rectangle} target
 * @param {RectangleEdge} edge
 * @param {number} [gap=0]
 * @returns {Rectangle}
 */
function _alignEdges(rect, target, edge, gap) {
    if (gap === void 0) { gap = 0; }
    return _moveEdge(rect, edge, _getEdgeValue(target, edge) + _getRelativeEdgeValue(edge, gap));
}
/**
 * Aligns the targetEdge on the passed in target to the rects corresponding opposite edge.
 * For instance if targetEdge is bottom, then the rects top will be moved to match it.
 *
 * @param {Rectangle} rect
 * @param {Rectangle} target
 * @param {RectangleEdge} targetEdge
 * @param {number} [gap=0]
 * @returns {Rectangle}
 */
function _alignOppositeEdges(rect, target, targetEdge, gap) {
    if (gap === void 0) { gap = 0; }
    var oppositeEdge = targetEdge * -1;
    var adjustedGap = _getRelativeEdgeValue(oppositeEdge, gap);
    return _moveEdge(rect, targetEdge * -1, _getEdgeValue(target, targetEdge) + adjustedGap);
}
/**
 * Tests to see if the given edge is within the bounds of the given rectangle.
 *
 * @param {Rectangle} rect
 * @param {Rectangle} bounds
 * @param {RectangleEdge} edge
 * @returns {boolean}
 */
function _isEdgeInBounds(rect, bounds, edge) {
    var adjustedRectValue = _getRelativeRectEdgeValue(edge, rect);
    return adjustedRectValue > _getRelativeRectEdgeValue(edge, bounds);
}
/**
 * Attempts to move the rectangle through various sides of the target to find a place to fit.
 * If no fit is found, the original position should be returned.
 *
 * @param {Rectangle} rect
 * @param {Rectangle} target
 * @param {Rectangle} bounding
 * @param {IPositionDirectionalHintData} positionData
 * @param {number} [gap=0]
 * @returns {IElementPosition}
 */
function _flipToFit(rect, target, bounding, positionData, gap) {
    if (gap === void 0) { gap = 0; }
    var directions = [__WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */].left, __WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */].right, __WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */].bottom, __WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */].top];
    var currentEstimate = rect;
    var currentEdge = positionData.targetEdge;
    var currentAlignment = positionData.alignmentEdge;
    // Keep switching sides until one is found with enough space. If all sides don't fit then return the unmodified element.
    for (var i = 0; i < 4; i++) {
        if (!_isEdgeInBounds(currentEstimate, bounding, currentEdge)) {
            directions.splice(directions.indexOf(currentEdge), 1);
            if (directions.indexOf(currentEdge * -1) > -1) {
                currentEdge = currentEdge * -1;
            }
            else {
                currentAlignment = currentEdge;
                currentEdge = directions.slice(-1)[0];
            }
            currentEstimate = _estimatePosition(rect, target, { targetEdge: currentEdge, alignmentEdge: currentAlignment }, gap);
        }
        else {
            return {
                elementRectangle: currentEstimate,
                targetEdge: currentEdge,
                alignmentEdge: currentAlignment
            };
        }
    }
    return {
        elementRectangle: rect,
        targetEdge: positionData.targetEdge,
        alignmentEdge: currentAlignment
    };
}
/**
 * Flips only the alignment edge of an element rectangle. This is used instead of nudging the alignment edges into position,
 * when alignTargetEdge is specified.
 * @param elementEstimate
 * @param target
 * @param bounding
 * @param gap
 */
function _flipAlignmentEdge(elementEstimate, target, gap, coverTarget) {
    var alignmentEdge = elementEstimate.alignmentEdge, targetEdge = elementEstimate.targetEdge, elementRectangle = elementEstimate.elementRectangle;
    var oppositeEdge = alignmentEdge * -1;
    var newEstimate = _estimatePosition(elementRectangle, target, { targetEdge: targetEdge, alignmentEdge: oppositeEdge }, gap, coverTarget);
    return {
        elementRectangle: newEstimate,
        targetEdge: targetEdge,
        alignmentEdge: oppositeEdge
    };
}
/**
 * Adjusts a element rectangle to fit within the bounds given. If directionalHintFixed or covertarget is passed in
 * then the element will not flip sides on the target. They will, however, be nudged to fit within the bounds given.
 *
 * @param {Rectangle} element
 * @param {Rectangle} target
 * @param {Rectangle} bounding
 * @param {IPositionDirectionalHintData} positionData
 * @param {number} [gap=0]
 * @param {boolean} [directionalHintFixed]
 * @param {boolean} [coverTarget]
 * @returns {IElementPosition}
 */
function _adjustFitWithinBounds(element, target, bounding, positionData, gap, directionalHintFixed, coverTarget) {
    if (gap === void 0) { gap = 0; }
    var alignmentEdge = positionData.alignmentEdge, alignTargetEdge = positionData.alignTargetEdge;
    var elementEstimate = {
        elementRectangle: element,
        targetEdge: positionData.targetEdge,
        alignmentEdge: alignmentEdge
    };
    if (!directionalHintFixed && !coverTarget) {
        elementEstimate = _flipToFit(element, target, bounding, positionData, gap);
    }
    var outOfBounds = _getOutOfBoundsEdges(element, bounding);
    if (alignTargetEdge) {
        // The edge opposite to the alignment edge might be out of bounds. Flip alignment to see if we can get it within bounds.
        if (elementEstimate.alignmentEdge && outOfBounds.indexOf(elementEstimate.alignmentEdge * -1) > -1) {
            var flippedElementEstimate = _flipAlignmentEdge(elementEstimate, target, gap, coverTarget);
            if (_isRectangleWithinBounds(flippedElementEstimate.elementRectangle, bounding)) {
                return flippedElementEstimate;
            }
        }
    }
    else {
        for (var _i = 0, outOfBounds_1 = outOfBounds; _i < outOfBounds_1.length; _i++) {
            var direction = outOfBounds_1[_i];
            elementEstimate.elementRectangle = _alignEdges(elementEstimate.elementRectangle, bounding, direction);
        }
    }
    return elementEstimate;
}
/**
 * Moves the middle point on an edge to the point given.
 * Only moves in one direction. For instance if a bottom edge is passed in, then
 * the bottom edge will be moved in the x axis to match the point.
 *
 * @param {Rectangle} rect
 * @param {RectangleEdge} edge
 * @param {number} point
 * @returns {Rectangle}
 */
function _centerEdgeToPoint(rect, edge, point) {
    var positiveEdge = _getFlankingEdges(edge).positiveEdge;
    var elementMiddle = _getCenterValue(rect, edge);
    var distanceToMiddle = elementMiddle - _getEdgeValue(rect, positiveEdge);
    return _moveEdge(rect, positiveEdge, point - distanceToMiddle);
}
/**
 * Moves the element rectangle to be appropriately positioned relative to a given target.
 * Does not flip or adjust the element.
 *
 * @param {Rectangle} elementToPosition
 * @param {Rectangle} target
 * @param {IPositionDirectionalHintData} positionData
 * @param {number} [gap=0]
 * @param {boolean} [coverTarget]
 * @returns {Rectangle}
 */
function _estimatePosition(elementToPosition, target, positionData, gap, coverTarget) {
    if (gap === void 0) { gap = 0; }
    var estimatedElementPosition;
    var alignmentEdge = positionData.alignmentEdge, targetEdge = positionData.targetEdge;
    var elementEdge = coverTarget ? targetEdge : targetEdge * -1;
    estimatedElementPosition = coverTarget
        ? _alignEdges(elementToPosition, target, targetEdge, gap)
        : _alignOppositeEdges(elementToPosition, target, targetEdge, gap);
    // if no alignment edge is provided it's supposed to be centered.
    if (!alignmentEdge) {
        var targetMiddlePoint = _getCenterValue(target, targetEdge);
        estimatedElementPosition = _centerEdgeToPoint(estimatedElementPosition, elementEdge, targetMiddlePoint);
    }
    else {
        estimatedElementPosition = _alignEdges(estimatedElementPosition, target, alignmentEdge);
    }
    return estimatedElementPosition;
}
/**
 * Returns the non-opposite edges of the target edge.
 * For instance if bottom is passed in then left and right will be returned.
 *
 * @param {RectangleEdge} edge
 * @returns {{ firstEdge: RectangleEdge, secondEdge: RectangleEdge }}
 */
function _getFlankingEdges(edge) {
    if (edge === __WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */].top || edge === __WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */].bottom) {
        return {
            positiveEdge: __WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */].left,
            negativeEdge: __WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */].right
        };
    }
    else {
        return {
            positiveEdge: __WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */].top,
            negativeEdge: __WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */].bottom
        };
    }
}
/**
 * Retrieve the final value for the return edge of elementRectangle.
 * If the elementRectangle is closer to one side of the bounds versus the other, the return edge is flipped to grow inward.
 *
 * @param elementRectangle
 * @param targetEdge
 * @param bounds
 */
function _finalizeReturnEdge(elementRectangle, returnEdge, bounds) {
    if (bounds &&
        Math.abs(_getRelativeEdgeDifference(elementRectangle, bounds, returnEdge)) >
            Math.abs(_getRelativeEdgeDifference(elementRectangle, bounds, returnEdge * -1))) {
        return returnEdge * -1;
    }
    return returnEdge;
}
/**
 * Finalizes the element positon based on the hostElement. Only returns the
 * rectangle values to position such that they are anchored to the target.
 * This helps prevent resizing from looking very strange.
 * For instance, if the target edge is top and aligned with the left side then
 * the bottom and left values are returned so as the callou shrinks it shrinks towards that corner.
 *
 * @param {Rectangle} elementRectangle
 * @param {HTMLElement} hostElement
 * @param {RectangleEdge} targetEdge
 * @param {RectangleEdge} bounds
 * @param {RectangleEdge} [alignmentEdge]
 * @param {boolean} coverTarget
 * @param {boolean} doNotFinalizeReturnEdge
 * @returns {IPartialIRectangle}
 */
function _finalizeElementPosition(elementRectangle, hostElement, targetEdge, bounds, alignmentEdge, coverTarget, doNotFinalizeReturnEdge) {
    var returnValue = {};
    var hostRect = _getRectangleFromElement(hostElement);
    var elementEdge = coverTarget ? targetEdge : targetEdge * -1;
    var elementEdgeString = __WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */][elementEdge];
    var returnEdge = alignmentEdge ? alignmentEdge : _getFlankingEdges(targetEdge).positiveEdge;
    if (!doNotFinalizeReturnEdge) {
        returnEdge = _finalizeReturnEdge(elementRectangle, returnEdge, bounds);
    }
    returnValue[elementEdgeString] = _getRelativeEdgeDifference(elementRectangle, hostRect, elementEdge);
    returnValue[__WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */][returnEdge]] = _getRelativeEdgeDifference(elementRectangle, hostRect, returnEdge);
    return returnValue;
}
// Since the beak is rotated 45 degrees the actual height/width is the length of the diagonal.
// We still want to position the beak based on it's midpoint which does not change. It will
// be at (beakwidth / 2, beakwidth / 2)
function _calculateActualBeakWidthInPixels(beakWidth) {
    return Math.sqrt(beakWidth * beakWidth * 2);
}
/**
 * Returns the appropriate IPositionData based on the props altered for RTL.
 * If directionalHintForRTL is passed in that is used if the page is RTL.
 * If a directionalHint is specified and no directionalHintForRTL is available and the page is RTL the hint will be flipped.
 * For instance bottomLeftEdge would become bottomRightEdge.
 * If there is no directionalHint passed in bottomAutoEdge is chosen automatically.
 *
 * @param {IPositionProps} props
 * @returns {IPositionDirectionalHintData}
 */
function _getPositionData(directionalHint, directionalHintForRTL, previousPositions) {
    if (directionalHint === void 0) { directionalHint = __WEBPACK_IMPORTED_MODULE_1__common_DirectionalHint__["a" /* DirectionalHint */].bottomAutoEdge; }
    if (previousPositions) {
        return {
            alignmentEdge: previousPositions.alignmentEdge,
            isAuto: previousPositions.isAuto,
            targetEdge: previousPositions.targetEdge
        };
    }
    var positionInformation = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, DirectionalDictionary[directionalHint]);
    if (Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["V" /* getRTL */])()) {
        // If alignment edge exists and that alignment edge is -2 or 2, right or left, then flip it.
        if (positionInformation.alignmentEdge && positionInformation.alignmentEdge % 2 === 0) {
            positionInformation.alignmentEdge = positionInformation.alignmentEdge * -1;
        }
        return directionalHintForRTL !== undefined ? DirectionalDictionary[directionalHintForRTL] : positionInformation;
    }
    return positionInformation;
}
/**
 * Get's the alignment data for the given information. This only really matters if the positioning is Auto.
 * If it is auto then the alignmentEdge should be chosen based on the target edge's position relative to
 * the center of the page.
 *
 * @param {IPositionDirectionalHintData} positionData
 * @param {Rectangle} target
 * @param {Rectangle} boundingRect
 * @param {boolean} [coverTarget]
 * @returns {IPositionDirectionalHintData}
 */
function _getAlignmentData(positionData, target, boundingRect, coverTarget, alignTargetEdge) {
    if (positionData.isAuto) {
        positionData.alignmentEdge = getClosestEdge(positionData.targetEdge, target, boundingRect);
    }
    positionData.alignTargetEdge = alignTargetEdge;
    return positionData;
}
function getClosestEdge(targetEdge, target, boundingRect) {
    var targetCenter = _getCenterValue(target, targetEdge);
    var boundingCenter = _getCenterValue(boundingRect, targetEdge);
    var _a = _getFlankingEdges(targetEdge), positiveEdge = _a.positiveEdge, negativeEdge = _a.negativeEdge;
    if (targetCenter <= boundingCenter) {
        return positiveEdge;
    }
    else {
        return negativeEdge;
    }
}
function _positionElementWithinBounds(elementToPosition, target, bounding, positionData, gap, directionalHintFixed, coverTarget) {
    var estimatedElementPosition = _estimatePosition(elementToPosition, target, positionData, gap, coverTarget);
    if (_isRectangleWithinBounds(estimatedElementPosition, bounding)) {
        return {
            elementRectangle: estimatedElementPosition,
            targetEdge: positionData.targetEdge,
            alignmentEdge: positionData.alignmentEdge
        };
    }
    else {
        return _adjustFitWithinBounds(elementToPosition, target, bounding, positionData, gap, directionalHintFixed, coverTarget);
    }
}
function _finalizeBeakPosition(elementPosition, positionedBeak, bounds) {
    var targetEdge = elementPosition.targetEdge * -1;
    // The "host" element that we will use to help position the beak.
    var actualElement = new Rectangle(0, elementPosition.elementRectangle.width, 0, elementPosition.elementRectangle.height);
    var returnValue = {};
    var returnEdge = _finalizeReturnEdge(elementPosition.elementRectangle, elementPosition.alignmentEdge ? elementPosition.alignmentEdge : _getFlankingEdges(targetEdge).positiveEdge, bounds);
    returnValue[__WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */][targetEdge]] = _getEdgeValue(positionedBeak, targetEdge);
    returnValue[__WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */][returnEdge]] = _getRelativeEdgeDifference(positionedBeak, actualElement, returnEdge);
    return {
        elementPosition: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, returnValue),
        closestEdge: getClosestEdge(elementPosition.targetEdge, positionedBeak, actualElement),
        targetEdge: targetEdge
    };
}
function _positionBeak(beakWidth, elementPosition) {
    var target = elementPosition.targetRectangle;
    /**
     * Note about beak positioning: The actual beak width only matters for getting the gap between the callout and
     * target, it does not impact the beak placement within the callout. For example example, if the beakWidth is 8,
     * then the actual beakWidth is sqrroot(8^2 + 8^2) = 11.31x11.31. So the callout will need to be an extra 3 pixels
     * away from its target. While the beak is being positioned in the callout it still acts as though it were 8x8.
     * */
    var _a = _getFlankingEdges(elementPosition.targetEdge), positiveEdge = _a.positiveEdge, negativeEdge = _a.negativeEdge;
    var beakTargetPoint = _getCenterValue(target, elementPosition.targetEdge);
    var elementBounds = new Rectangle(beakWidth / 2, elementPosition.elementRectangle.width - beakWidth / 2, beakWidth / 2, elementPosition.elementRectangle.height - beakWidth / 2);
    var beakPosition = new Rectangle(0, beakWidth, 0, beakWidth);
    beakPosition = _moveEdge(beakPosition, elementPosition.targetEdge * -1, -beakWidth / 2);
    beakPosition = _centerEdgeToPoint(beakPosition, elementPosition.targetEdge * -1, beakTargetPoint - _getRelativeRectEdgeValue(positiveEdge, elementPosition.elementRectangle));
    if (!_isEdgeInBounds(beakPosition, elementBounds, positiveEdge)) {
        beakPosition = _alignEdges(beakPosition, elementBounds, positiveEdge);
    }
    else if (!_isEdgeInBounds(beakPosition, elementBounds, negativeEdge)) {
        beakPosition = _alignEdges(beakPosition, elementBounds, negativeEdge);
    }
    return beakPosition;
}
function _getRectangleFromElement(element) {
    var clientRect = element.getBoundingClientRect();
    return new Rectangle(clientRect.left, clientRect.right, clientRect.top, clientRect.bottom);
}
function _getRectangleFromIRect(rect) {
    return new Rectangle(rect.left, rect.right, rect.top, rect.bottom);
}
function _getTargetRect(bounds, target) {
    var targetRectangle;
    if (target) {
        if (target.preventDefault) {
            var ev = target;
            targetRectangle = new Rectangle(ev.clientX, ev.clientX, ev.clientY, ev.clientY);
        }
        else if (target.getBoundingClientRect) {
            targetRectangle = _getRectangleFromElement(target);
            // HTMLImgElements can have x and y values. The check for it being a point must go last.
        }
        else {
            var point = target;
            targetRectangle = new Rectangle(point.x, point.x, point.y, point.y);
        }
        if (!_isRectangleWithinBounds(targetRectangle, bounds)) {
            var outOfBounds = _getOutOfBoundsEdges(targetRectangle, bounds);
            for (var _i = 0, outOfBounds_2 = outOfBounds; _i < outOfBounds_2.length; _i++) {
                var direction = outOfBounds_2[_i];
                targetRectangle[__WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */][direction]] = bounds[__WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */][direction]];
            }
        }
    }
    else {
        targetRectangle = new Rectangle(0, 0, 0, 0);
    }
    return targetRectangle;
}
/**
 * If max height is less than zero it returns the bounds height instead.
 */
function _getMaxHeightFromTargetRectangle(targetRectangle, targetEdge, gapSpace, bounds, coverTarget) {
    var maxHeight = 0;
    var directionalHint = DirectionalDictionary[targetEdge];
    // If cover target is set, then the max height should be calculated using the opposite of the target edge since
    // that's the direction that the callout will expand in.
    // For instance, if the directionalhint is bottomLeftEdge then the callout will position so it's bottom edge
    // is aligned with the bottom of the target and expand up towards the top of the screen and the calculated max height
    // is (bottom of target) - (top of screen) - gapSpace.
    var target = coverTarget ? directionalHint.targetEdge * -1 : directionalHint.targetEdge;
    if (target === __WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */].top) {
        maxHeight = _getEdgeValue(targetRectangle, directionalHint.targetEdge) - bounds.top - gapSpace;
    }
    else if (target === __WEBPACK_IMPORTED_MODULE_3__positioning_types__["b" /* RectangleEdge */].bottom) {
        maxHeight = bounds.bottom - _getEdgeValue(targetRectangle, directionalHint.targetEdge) - gapSpace;
    }
    else {
        maxHeight = bounds.bottom - targetRectangle.top - gapSpace;
    }
    return maxHeight > 0 ? maxHeight : bounds.height;
}
function _positionElementRelative(props, elementToPosition, boundingRect, previousPositions) {
    var gap = props.gapSpace ? props.gapSpace : 0;
    var targetRect = _getTargetRect(boundingRect, props.target);
    var positionData = _getAlignmentData(_getPositionData(props.directionalHint, props.directionalHintForRTL, previousPositions), targetRect, boundingRect, props.coverTarget, props.alignTargetEdge);
    var positionedElement = _positionElementWithinBounds(_getRectangleFromElement(elementToPosition), targetRect, boundingRect, positionData, gap, props.directionalHintFixed, props.coverTarget);
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, positionedElement, { targetRectangle: targetRect });
}
function _finalizePositionData(positionedElement, hostElement, bounds, coverTarget, doNotFinalizeReturnEdge) {
    var finalizedElement = _finalizeElementPosition(positionedElement.elementRectangle, hostElement, positionedElement.targetEdge, bounds, positionedElement.alignmentEdge, coverTarget, doNotFinalizeReturnEdge);
    return {
        elementPosition: finalizedElement,
        targetEdge: positionedElement.targetEdge,
        alignmentEdge: positionedElement.alignmentEdge
    };
}
function _positionElement(props, hostElement, elementToPosition, previousPositions) {
    var boundingRect = props.bounds
        ? _getRectangleFromIRect(props.bounds)
        : new Rectangle(0, window.innerWidth - Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["Y" /* getScrollbarWidth */])(), 0, window.innerHeight);
    var positionedElement = _positionElementRelative(props, elementToPosition, boundingRect, previousPositions);
    return _finalizePositionData(positionedElement, hostElement, boundingRect, props.coverTarget);
}
function _positionCallout(props, hostElement, callout, previousPositions, doNotFinalizeReturnEdge) {
    var beakWidth = props.isBeakVisible ? props.beakWidth || 0 : 0;
    var gap = _calculateActualBeakWidthInPixels(beakWidth) / 2 + (props.gapSpace ? props.gapSpace : 0);
    var positionProps = props;
    positionProps.gapSpace = gap;
    var boundingRect = props.bounds
        ? _getRectangleFromIRect(props.bounds)
        : new Rectangle(0, window.innerWidth - Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["Y" /* getScrollbarWidth */])(), 0, window.innerHeight);
    var positionedElement = _positionElementRelative(positionProps, callout, boundingRect, previousPositions);
    var beakPositioned = _positionBeak(beakWidth, positionedElement);
    var finalizedBeakPosition = _finalizeBeakPosition(positionedElement, beakPositioned, boundingRect);
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, _finalizePositionData(positionedElement, hostElement, boundingRect, props.coverTarget, doNotFinalizeReturnEdge), { beakPosition: finalizedBeakPosition });
}
function _positionCard(props, hostElement, callout, previousPositions) {
    return _positionCallout(props, hostElement, callout, previousPositions, true);
}
// END PRIVATE FUNCTIONS
/* tslint:disable:variable-name */
var __positioningTestPackage = {
    _finalizePositionData: _finalizePositionData,
    _finalizeBeakPosition: _finalizeBeakPosition,
    _calculateActualBeakWidthInPixels: _calculateActualBeakWidthInPixels,
    _positionElementWithinBounds: _positionElementWithinBounds,
    _positionBeak: _positionBeak,
    _getPositionData: _getPositionData,
    _getMaxHeightFromTargetRectangle: _getMaxHeightFromTargetRectangle
};
/* tslint:enable:variable-name */
/**
 * Used to position an element relative to the given positioning props.
 * If positioning has been completed before, previousPositioningData
 * can be passed to ensure that the positioning element repositions based on
 * its previous targets rather than starting with directionalhint.
 *
 * @export
 * @param {IPositionProps} props
 * @param {HTMLElement} hostElement
 * @param {HTMLElement} elementToPosition
 * @param {IPositionedData} previousPositions
 * @returns
 */
function positionElement(props, hostElement, elementToPosition, previousPositions) {
    return _positionElement(props, hostElement, elementToPosition, previousPositions);
}
function positionCallout(props, hostElement, elementToPosition, previousPositions) {
    return _positionCallout(props, hostElement, elementToPosition, previousPositions);
}
function positionCard(props, hostElement, elementToPosition, previousPositions) {
    return _positionCard(props, hostElement, elementToPosition, previousPositions);
}
/**
 * Get's the maximum height that a rectangle can have in order to fit below or above a target.
 * If the directional hint specifies a left or right edge (i.e. leftCenter) it will limit the height to the topBorder
 * of the target given.
 * If no bounds are provided then the window is treated as the bounds.
 */
function getMaxHeight(target, targetEdge, gapSpace, bounds, coverTarget) {
    if (gapSpace === void 0) { gapSpace = 0; }
    var mouseTarget = target;
    var elementTarget = target;
    var pointTarget = target;
    var targetRect;
    var boundingRectangle = bounds
        ? _getRectangleFromIRect(bounds)
        : new Rectangle(0, window.innerWidth - Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["Y" /* getScrollbarWidth */])(), 0, window.innerHeight);
    if (mouseTarget.stopPropagation) {
        targetRect = new Rectangle(mouseTarget.clientX, mouseTarget.clientX, mouseTarget.clientY, mouseTarget.clientY);
    }
    else if (pointTarget.x !== undefined && pointTarget.y !== undefined) {
        targetRect = new Rectangle(pointTarget.x, pointTarget.x, pointTarget.y, pointTarget.y);
    }
    else {
        targetRect = _getRectangleFromElement(elementTarget);
    }
    return _getMaxHeightFromTargetRectangle(targetRect, targetEdge, gapSpace, boundingRectangle, coverTarget);
}
/**
 * Returns the opposite edge of the given RectangleEdge.
 */
function getOppositeEdge(edge) {
    return edge * -1;
}
var _a;
//# sourceMappingURL=positioning.js.map

/***/ }),
/* 1740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Popup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);



/**
 * This adds accessibility to Dialog and Panel controls
 */
var Popup = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](Popup, _super);
    function Popup(props) {
        var _this = _super.call(this, props) || this;
        _this._root = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._disposables = [];
        _this._onKeyDown = function (ev) {
            switch (ev.which) {
                case __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].escape:
                    if (_this.props.onDismiss) {
                        _this.props.onDismiss(ev);
                        ev.preventDefault();
                        ev.stopPropagation();
                    }
                    break;
            }
        };
        _this._onFocus = function () {
            _this._containsFocus = true;
        };
        _this._onBlur = function (ev) {
            if (_this._root.current && _this._root.current.contains(ev.relatedTarget)) {
                _this._containsFocus = false;
            }
        };
        _this._async = new __WEBPACK_IMPORTED_MODULE_2__Utilities__["a" /* Async */](_this);
        _this.state = { needsVerticalScrollBar: false };
        return _this;
    }
    Popup.prototype.componentWillMount = function () {
        this._originalFocusedElement = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["I" /* getDocument */])().activeElement;
    };
    Popup.prototype.componentDidMount = function () {
        if (this._root.current) {
            this._disposables.push(Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_18" /* on */])(this._root.current, 'focus', this._onFocus, true), Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_18" /* on */])(this._root.current, 'blur', this._onBlur, true));
            if (Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["x" /* doesElementContainFocus */])(this._root.current)) {
                this._containsFocus = true;
            }
        }
        this._updateScrollBarAsync();
    };
    Popup.prototype.componentDidUpdate = function () {
        this._updateScrollBarAsync();
        this._async.dispose();
    };
    Popup.prototype.componentWillUnmount = function () {
        this._disposables.forEach(function (dispose) { return dispose(); });
        if (this.props.shouldRestoreFocus &&
            this._originalFocusedElement &&
            this._containsFocus &&
            this._originalFocusedElement !== window) {
            // This slight delay is required so that we can unwind the stack, let react try to mess with focus, and then
            // apply the correct focus. Without the setTimeout, we end up focusing the correct thing, and then React wants
            // to reset the focus back to the thing it thinks should have been focused.
            if (this._originalFocusedElement) {
                this._originalFocusedElement.focus();
            }
        }
    };
    Popup.prototype.render = function () {
        var _a = this.props, role = _a.role, className = _a.className, ariaLabel = _a.ariaLabel, ariaLabelledBy = _a.ariaLabelledBy, ariaDescribedBy = _a.ariaDescribedBy, style = _a.style;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ ref: this._root }, Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["R" /* getNativeProps */])(this.props, __WEBPACK_IMPORTED_MODULE_2__Utilities__["w" /* divProperties */]), { className: className, role: role, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-describedby": ariaDescribedBy, onKeyDown: this._onKeyDown, style: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ overflowY: this.state.needsVerticalScrollBar ? 'scroll' : undefined, outline: 'none' }, style) }), this.props.children));
    };
    Popup.prototype._updateScrollBarAsync = function () {
        var _this = this;
        this._async.requestAnimationFrame(function () {
            _this._getScrollBar();
        });
    };
    Popup.prototype._getScrollBar = function () {
        // If overflowY is overriden, don't waste time calculating whether the scrollbar is necessary.
        if (this.props.style && this.props.style.overflowY) {
            return;
        }
        var needsVerticalScrollBar = false;
        if (this._root && this._root.current && this._root.current.firstElementChild) {
            // ClientHeight returns the client height of an element rounded to an
            // integer. On some browsers at different zoom levels this rounding
            // can generate different results for the root container and child even
            // though they are the same height. This causes us to show a scroll bar
            // when not needed. Ideally we would use BoundingClientRect().height
            // instead however seems that the API is 90% slower than using ClientHeight.
            // Therefore instead we will calculate the difference between heights and
            // allow for a 1px difference to still be considered ok and not show the
            // scroll bar.
            var rootHeight = this._root.current.clientHeight;
            var firstChildHeight = this._root.current.firstElementChild.clientHeight;
            if (rootHeight > 0 && firstChildHeight > rootHeight) {
                needsVerticalScrollBar = firstChildHeight - rootHeight > 1;
            }
        }
        if (this.state.needsVerticalScrollBar !== needsVerticalScrollBar) {
            this.setState({
                needsVerticalScrollBar: needsVerticalScrollBar
            });
        }
    };
    Popup.defaultProps = {
        shouldRestoreFocus: true
    };
    return Popup;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=Popup.js.map

/***/ }),
/* 1741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

function getBeakStyle(beakWidth) {
    return {
        height: beakWidth,
        width: beakWidth
    };
}
var GlobalClassNames = {
    container: 'ms-Callout-container',
    root: 'ms-Callout',
    beak: 'ms-Callout-beak',
    beakCurtain: 'ms-Callout-beakCurtain',
    calloutMain: 'ms-Callout-main'
};
var getStyles = function (props) {
    var theme = props.theme, className = props.className, overflowYHidden = props.overflowYHidden, calloutWidth = props.calloutWidth, beakWidth = props.beakWidth, backgroundColor = props.backgroundColor, calloutMaxWidth = props.calloutMaxWidth;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    var palette = theme.palette;
    return {
        container: [
            classNames.container,
            {
                position: 'relative'
            }
        ],
        root: [
            classNames.root,
            theme.fonts.medium,
            {
                position: 'absolute',
                boxSizing: 'border-box',
                borderWidth: 1,
                borderStyle: 'solid',
                borderColor: palette.neutralLight,
                boxShadow: '0 0 5px 0px rgba(0,0,0,0.4)',
                selectors: (_a = {},
                    _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        borderWidth: 1,
                        borderStyle: 'solid',
                        borderColor: 'WindowText'
                    },
                    _a)
            },
            Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["u" /* focusClear */])(),
            className,
            !!calloutWidth && { width: calloutWidth },
            !!calloutMaxWidth && { maxWidth: calloutMaxWidth }
        ],
        beak: [
            classNames.beak,
            {
                position: 'absolute',
                backgroundColor: palette.white,
                boxShadow: 'inherit',
                border: 'inherit',
                boxSizing: 'border-box',
                transform: 'rotate(45deg)'
            },
            getBeakStyle(beakWidth),
            backgroundColor && {
                backgroundColor: backgroundColor
            }
        ],
        beakCurtain: [
            classNames.beakCurtain,
            {
                position: 'absolute',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                backgroundColor: palette.white
            }
        ],
        calloutMain: [
            classNames.calloutMain,
            {
                backgroundColor: palette.white,
                overflowX: 'hidden',
                overflowY: 'auto',
                position: 'relative'
            },
            overflowYHidden && {
                overflowY: 'hidden'
            },
            backgroundColor && {
                backgroundColor: backgroundColor
            }
        ]
    };
    var _a;
};
//# sourceMappingURL=CalloutContent.styles.js.map

/***/ }),
/* 1742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FocusTrapCallout; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Callout__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FocusTrapZone__ = __webpack_require__(271);




/**
 * A special Callout that uses FocusTrapZone to trap focus
 * @param props - Props for the component
 */
var FocusTrapCallout = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Callout__["a" /* Callout */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, props),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__FocusTrapZone__["a" /* FocusTrapZone */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ disabled: props.hidden }, props.focusTrapProps), props.children)));
};
//# sourceMappingURL=FocusTrapCallout.js.map

/***/ }),
/* 1743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FocusTrapZone; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);



var FocusTrapZone = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](FocusTrapZone, _super);
    function FocusTrapZone(props) {
        var _this = _super.call(this, props) || this;
        _this._root = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._firstBumper = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._lastBumper = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._hasFocus = false;
        _this._onRootFocus = function (ev) {
            if (_this.props.onFocus) {
                _this.props.onFocus(ev);
            }
            _this._hasFocus = true;
        };
        _this._onRootBlur = function (ev) {
            if (_this.props.onBlur) {
                _this.props.onBlur(ev);
            }
            var relatedTarget = ev.relatedTarget;
            if (ev.relatedTarget === null) {
                // In IE11, due to lack of support, event.relatedTarget is always
                // null making every onBlur call to be "outside" of the ComboBox
                // even when it's not. Using document.activeElement is another way
                // for us to be able to get what the relatedTarget without relying
                // on the event
                relatedTarget = document.activeElement;
            }
            if (!Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["y" /* elementContains */])(_this._root.current, relatedTarget)) {
                _this._hasFocus = false;
            }
        };
        _this._onFirstBumperFocus = function () {
            _this._onBumperFocus(true);
        };
        _this._onLastBumperFocus = function () {
            _this._onBumperFocus(false);
        };
        _this._onBumperFocus = function (isFirstBumper) {
            if (_this.props.disabled) {
                return;
            }
            var currentBumper = (isFirstBumper === _this._hasFocus ? _this._lastBumper.current : _this._firstBumper.current);
            if (_this._root.current) {
                var nextFocusable = isFirstBumper === _this._hasFocus
                    ? Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["Q" /* getLastTabbable */])(_this._root.current, currentBumper, true, false)
                    : Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["L" /* getFirstTabbable */])(_this._root.current, currentBumper, true, false);
                if (nextFocusable) {
                    if (_this._isBumper(nextFocusable)) {
                        // This can happen when FTZ contains no tabbable elements. focus will take care of finding a focusable element in FTZ.
                        _this.focus();
                    }
                    else {
                        nextFocusable.focus();
                    }
                }
            }
        };
        _this._onFocusCapture = function (ev) {
            if (_this.props.onFocusCapture) {
                _this.props.onFocusCapture(ev);
            }
            if (ev.target !== ev.currentTarget && !_this._isBumper(ev.target)) {
                // every time focus changes within the trap zone, remember the focused element so that
                // it can be restored if focus leaves the pane and returns via keystroke (i.e. via a call to this.focus(true))
                _this._previouslyFocusedElementInTrapZone = ev.target;
            }
        };
        _this._forceFocusInTrap = function (ev) {
            if (_this.props.disabled) {
                return;
            }
            if (FocusTrapZone._focusStack.length && _this === FocusTrapZone._focusStack[FocusTrapZone._focusStack.length - 1]) {
                var focusedElement = document.activeElement;
                if (!Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["y" /* elementContains */])(_this._root.current, focusedElement)) {
                    _this.focus();
                    _this._hasFocus = true; // set focus here since we stop event propagation
                    ev.preventDefault();
                    ev.stopPropagation();
                }
            }
        };
        _this._forceClickInTrap = function (ev) {
            if (_this.props.disabled) {
                return;
            }
            if (FocusTrapZone._focusStack.length && _this === FocusTrapZone._focusStack[FocusTrapZone._focusStack.length - 1]) {
                var clickedElement = ev.target;
                if (clickedElement && !Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["y" /* elementContains */])(_this._root.current, clickedElement)) {
                    _this.focus();
                    _this._hasFocus = true; // set focus here since we stop event propagation
                    ev.preventDefault();
                    ev.stopPropagation();
                }
            }
        };
        Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_5" /* initializeComponentRef */])(_this);
        return _this;
    }
    FocusTrapZone.prototype.componentDidMount = function () {
        this._bringFocusIntoZone();
        this._updateEventHandlers(this.props);
    };
    FocusTrapZone.prototype.componentWillReceiveProps = function (nextProps) {
        var elementToFocusOnDismiss = nextProps.elementToFocusOnDismiss;
        if (elementToFocusOnDismiss && this._previouslyFocusedElementOutsideTrapZone !== elementToFocusOnDismiss) {
            this._previouslyFocusedElementOutsideTrapZone = elementToFocusOnDismiss;
        }
        this._updateEventHandlers(nextProps);
    };
    FocusTrapZone.prototype.componentDidUpdate = function (prevProps) {
        var prevForceFocusInsideTrap = prevProps.forceFocusInsideTrap !== undefined ? prevProps.forceFocusInsideTrap : true;
        var newForceFocusInsideTrap = this.props.forceFocusInsideTrap !== undefined ? this.props.forceFocusInsideTrap : true;
        var prevDisabled = prevProps.disabled !== undefined ? prevProps.disabled : false;
        var newDisabled = this.props.disabled !== undefined ? this.props.disabled : false;
        if ((!prevForceFocusInsideTrap && newForceFocusInsideTrap) || (prevDisabled && !newDisabled)) {
            // Transition from forceFocusInsideTrap / FTZ disabled to enabled.
            // Emulate what happens when a FocusTrapZone gets mounted.
            this._bringFocusIntoZone();
        }
        else if ((prevForceFocusInsideTrap && !newForceFocusInsideTrap) || (!prevDisabled && newDisabled)) {
            // Transition from forceFocusInsideTrap / FTZ enabled to disabled.
            // Emulate what happens when a FocusTrapZone gets unmounted.
            this._returnFocusToInitiator();
        }
    };
    FocusTrapZone.prototype.componentWillUnmount = function () {
        // don't handle return focus unless forceFocusInsideTrap is true or focus is still within FocusTrapZone
        if (!this.props.disabled ||
            this.props.forceFocusInsideTrap ||
            !Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["y" /* elementContains */])(this._root.current, document.activeElement)) {
            this._returnFocusToInitiator();
        }
    };
    FocusTrapZone.prototype.render = function () {
        var _a = this.props, className = _a.className, _b = _a.disabled, disabled = _b === void 0 ? false : _b, ariaLabelledBy = _a.ariaLabelledBy;
        var divProps = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["R" /* getNativeProps */])(this.props, __WEBPACK_IMPORTED_MODULE_2__Utilities__["w" /* divProperties */]);
        var bumperProps = {
            style: {
                pointerEvents: 'none',
                position: 'fixed' // 'fixed' prevents browsers from scrolling to bumpers when viewport does not contain them
            },
            tabIndex: disabled ? -1 : 0,
            'data-is-visible': true
        };
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, divProps, { className: className, ref: this._root, "aria-labelledby": ariaLabelledBy, onFocusCapture: this._onFocusCapture, onFocus: this._onRootFocus, onBlur: this._onRootBlur }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, bumperProps, { ref: this._firstBumper, onFocus: this._onFirstBumperFocus })),
            this.props.children,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, bumperProps, { ref: this._lastBumper, onFocus: this._onLastBumperFocus }))));
    };
    FocusTrapZone.prototype.focus = function () {
        var _a = this.props, focusPreviouslyFocusedInnerElement = _a.focusPreviouslyFocusedInnerElement, firstFocusableSelector = _a.firstFocusableSelector;
        if (focusPreviouslyFocusedInnerElement &&
            this._previouslyFocusedElementInTrapZone &&
            Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["y" /* elementContains */])(this._root.current, this._previouslyFocusedElementInTrapZone)) {
            // focus on the last item that had focus in the zone before we left the zone
            this._focusAsync(this._previouslyFocusedElementInTrapZone);
            return;
        }
        var focusSelector = typeof firstFocusableSelector === 'string' ? firstFocusableSelector : firstFocusableSelector && firstFocusableSelector();
        var _firstFocusableChild;
        if (this._root.current) {
            if (focusSelector) {
                _firstFocusableChild = this._root.current.querySelector('.' + focusSelector);
            }
            // Fall back to first element if query selector did not match any elements.
            if (!_firstFocusableChild) {
                _firstFocusableChild = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["S" /* getNextElement */])(this._root.current, this._root.current.firstChild, false, false, false, true);
            }
        }
        if (_firstFocusableChild) {
            this._focusAsync(_firstFocusableChild);
        }
    };
    FocusTrapZone.prototype._focusAsync = function (element) {
        if (!this._isBumper(element)) {
            Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["E" /* focusAsync */])(element);
        }
    };
    FocusTrapZone.prototype._bringFocusIntoZone = function () {
        var _a = this.props, elementToFocusOnDismiss = _a.elementToFocusOnDismiss, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.disableFirstFocus, disableFirstFocus = _c === void 0 ? false : _c;
        if (disabled) {
            return;
        }
        FocusTrapZone._focusStack.push(this);
        this._previouslyFocusedElementOutsideTrapZone = elementToFocusOnDismiss
            ? elementToFocusOnDismiss
            : document.activeElement;
        if (!disableFirstFocus && !Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["y" /* elementContains */])(this._root.current, this._previouslyFocusedElementOutsideTrapZone)) {
            this.focus();
        }
    };
    FocusTrapZone.prototype._returnFocusToInitiator = function () {
        var _this = this;
        var ignoreExternalFocusing = this.props.ignoreExternalFocusing;
        FocusTrapZone._focusStack = FocusTrapZone._focusStack.filter(function (value) {
            return _this !== value;
        });
        var activeElement = document.activeElement;
        if (!ignoreExternalFocusing &&
            this._previouslyFocusedElementOutsideTrapZone &&
            typeof this._previouslyFocusedElementOutsideTrapZone.focus === 'function' &&
            (Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["y" /* elementContains */])(this._root.current, activeElement) || activeElement === document.body)) {
            this._focusAsync(this._previouslyFocusedElementOutsideTrapZone);
        }
    };
    FocusTrapZone.prototype._updateEventHandlers = function (newProps) {
        var _a = newProps.isClickableOutsideFocusTrap, isClickableOutsideFocusTrap = _a === void 0 ? false : _a, _b = newProps.forceFocusInsideTrap, forceFocusInsideTrap = _b === void 0 ? true : _b;
        if (forceFocusInsideTrap && !this._disposeFocusHandler) {
            this._disposeFocusHandler = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_18" /* on */])(window, 'focus', this._forceFocusInTrap, true);
        }
        else if (!forceFocusInsideTrap && this._disposeFocusHandler) {
            this._disposeFocusHandler();
            this._disposeFocusHandler = undefined;
        }
        if (!isClickableOutsideFocusTrap && !this._disposeClickHandler) {
            this._disposeClickHandler = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_18" /* on */])(window, 'click', this._forceClickInTrap, true);
        }
        else if (isClickableOutsideFocusTrap && this._disposeClickHandler) {
            this._disposeClickHandler();
            this._disposeClickHandler = undefined;
        }
    };
    FocusTrapZone.prototype._isBumper = function (element) {
        return element === this._firstBumper.current || element === this._lastBumper.current;
    };
    FocusTrapZone._focusStack = [];
    return FocusTrapZone;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=FocusTrapZone.js.map

/***/ }),
/* 1744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDividerClassNames; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Styling__ = __webpack_require__(5);


/**
 * @deprecated use getStyles exported from VerticalDivider.styles.ts
 */
var getDividerClassNames = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_15" /* memoizeFunction */])(function (theme) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["E" /* mergeStyleSets */])({
        wrapper: {
            display: 'inline-flex',
            height: '100%',
            alignItems: 'center'
        },
        divider: {
            width: 1,
            height: '100%',
            backgroundColor: theme.palette.neutralTertiaryAlt
        }
    });
});
//# sourceMappingURL=VerticalDivider.classNames.js.map

/***/ }),
/* 1745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ContextualMenuAnchor__ = __webpack_require__(1746);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ContextualMenuAnchor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContextualMenuButton__ = __webpack_require__(1747);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__ContextualMenuButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ContextualMenuSplitButton__ = __webpack_require__(1748);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__ContextualMenuSplitButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContextualMenuItemWrapper__ = __webpack_require__(272);
/* unused harmony namespace reexport */




//# sourceMappingURL=index.js.map

/***/ }),
/* 1746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContextualMenuAnchor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContextualMenuItemWrapper__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__KeytipData__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_contextualMenu_index__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ContextualMenuItem__ = __webpack_require__(183);







var ContextualMenuAnchor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ContextualMenuAnchor, _super);
    function ContextualMenuAnchor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._anchor = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._getSubmenuTarget = function () {
            return _this._anchor.current ? _this._anchor.current : undefined;
        };
        _this._onItemClick = function (ev) {
            var _a = _this.props, item = _a.item, onItemClick = _a.onItemClick;
            if (onItemClick) {
                onItemClick(item, ev);
            }
        };
        return _this;
    }
    ContextualMenuAnchor.prototype.render = function () {
        var _this = this;
        var _a = this.props, item = _a.item, classNames = _a.classNames, index = _a.index, focusableElementIndex = _a.focusableElementIndex, totalItemCount = _a.totalItemCount, hasCheckmarks = _a.hasCheckmarks, hasIcons = _a.hasIcons, _b = _a.contextualMenuItemAs, ChildrenRenderer = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_6__ContextualMenuItem__["a" /* ContextualMenuItem */] : _b, expandedMenuItemKey = _a.expandedMenuItemKey, onItemClick = _a.onItemClick, openSubMenu = _a.openSubMenu, dismissSubMenu = _a.dismissSubMenu, dismissMenu = _a.dismissMenu;
        var anchorRel = item.rel;
        if (item.target && item.target.toLowerCase() === '_blank') {
            anchorRel = anchorRel ? anchorRel : 'nofollow noopener noreferrer'; // Safe default to prevent tabjacking
        }
        var subMenuId = this._getSubMenuId(item);
        var itemHasSubmenu = Object(__WEBPACK_IMPORTED_MODULE_5__utilities_contextualMenu_index__["b" /* hasSubmenu */])(item);
        var nativeProps = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["R" /* getNativeProps */])(item, __WEBPACK_IMPORTED_MODULE_2__Utilities__["k" /* anchorProperties */]);
        var disabled = Object(__WEBPACK_IMPORTED_MODULE_5__utilities_contextualMenu_index__["c" /* isItemDisabled */])(item);
        var itemProps = item.itemProps;
        var keytipProps = item.keytipProps;
        if (keytipProps && itemHasSubmenu) {
            keytipProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, keytipProps, { hasMenu: true });
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__KeytipData__["a" /* KeytipData */], { keytipProps: item.keytipProps, ariaDescribedBy: nativeProps['aria-describedby'], disabled: disabled }, function (keytipAttributes) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, nativeProps, keytipAttributes, { ref: _this._anchor, href: item.href, target: item.target, rel: anchorRel, className: classNames.root, role: "menuitem", "aria-owns": item.key === expandedMenuItemKey ? subMenuId : undefined, "aria-haspopup": itemHasSubmenu || undefined, "aria-expanded": itemHasSubmenu ? item.key === expandedMenuItemKey : undefined, "aria-posinset": focusableElementIndex + 1, "aria-setsize": totalItemCount, "aria-disabled": Object(__WEBPACK_IMPORTED_MODULE_5__utilities_contextualMenu_index__["c" /* isItemDisabled */])(item), style: item.style, onClick: _this._onItemClick, onMouseEnter: _this._onItemMouseEnter, onMouseLeave: _this._onItemMouseLeave, onMouseMove: _this._onItemMouseMove, onKeyDown: itemHasSubmenu ? _this._onItemKeyDown : undefined }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ChildrenRenderer, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ componentRef: item.componentRef, item: item, classNames: classNames, index: index, onCheckmarkClick: hasCheckmarks && onItemClick ? onItemClick : undefined, hasIcons: hasIcons, openSubMenu: openSubMenu, dismissSubMenu: dismissSubMenu, dismissMenu: dismissMenu, getSubmenuTarget: _this._getSubmenuTarget }, itemProps)))); })));
    };
    return ContextualMenuAnchor;
}(__WEBPACK_IMPORTED_MODULE_3__ContextualMenuItemWrapper__["a" /* ContextualMenuItemWrapper */]));

//# sourceMappingURL=ContextualMenuAnchor.js.map

/***/ }),
/* 1747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContextualMenuButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContextualMenuItemWrapper__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__KeytipData__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_contextualMenu_index__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ContextualMenuItem__ = __webpack_require__(183);







var ContextualMenuButton = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ContextualMenuButton, _super);
    function ContextualMenuButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._btn = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._getSubmenuTarget = function () {
            return _this._btn.current ? _this._btn.current : undefined;
        };
        return _this;
    }
    ContextualMenuButton.prototype.render = function () {
        var _this = this;
        var _a = this.props, item = _a.item, classNames = _a.classNames, index = _a.index, focusableElementIndex = _a.focusableElementIndex, totalItemCount = _a.totalItemCount, hasCheckmarks = _a.hasCheckmarks, hasIcons = _a.hasIcons, _b = _a.contextualMenuItemAs, ChildrenRenderer = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_6__ContextualMenuItem__["a" /* ContextualMenuItem */] : _b, expandedMenuItemKey = _a.expandedMenuItemKey, onItemMouseDown = _a.onItemMouseDown, onItemClick = _a.onItemClick, openSubMenu = _a.openSubMenu, dismissSubMenu = _a.dismissSubMenu, dismissMenu = _a.dismissMenu;
        var subMenuId = this._getSubMenuId(item);
        var isChecked = Object(__WEBPACK_IMPORTED_MODULE_5__utilities_contextualMenu_index__["a" /* getIsChecked */])(item);
        var canCheck = isChecked !== null;
        var defaultRole = canCheck ? 'menuitemcheckbox' : 'menuitem';
        var itemHasSubmenu = Object(__WEBPACK_IMPORTED_MODULE_5__utilities_contextualMenu_index__["b" /* hasSubmenu */])(item);
        var itemProps = item.itemProps, ariaLabel = item.ariaLabel;
        var buttonNativeProperties = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["R" /* getNativeProps */])(item, __WEBPACK_IMPORTED_MODULE_2__Utilities__["p" /* buttonProperties */]);
        // Do not add the disabled attribute to the button so that it is focusable
        delete buttonNativeProperties.disabled;
        var itemButtonProperties = {
            className: classNames.root,
            onClick: this._onItemClick,
            onKeyDown: itemHasSubmenu ? this._onItemKeyDown : undefined,
            onMouseEnter: this._onItemMouseEnter,
            onMouseLeave: this._onItemMouseLeave,
            onMouseDown: function (ev) { return (onItemMouseDown ? onItemMouseDown(item, ev) : undefined); },
            onMouseMove: this._onItemMouseMove,
            href: item.href,
            title: item.title,
            'aria-label': ariaLabel,
            'aria-haspopup': itemHasSubmenu || undefined,
            'aria-owns': item.key === expandedMenuItemKey ? subMenuId : undefined,
            'aria-expanded': itemHasSubmenu ? item.key === expandedMenuItemKey : undefined,
            'aria-checked': canCheck ? !!isChecked : undefined,
            'aria-posinset': focusableElementIndex + 1,
            'aria-setsize': totalItemCount,
            'aria-disabled': Object(__WEBPACK_IMPORTED_MODULE_5__utilities_contextualMenu_index__["c" /* isItemDisabled */])(item),
            role: item.role || defaultRole,
            style: item.style
        };
        var keytipProps = item.keytipProps;
        if (keytipProps && itemHasSubmenu) {
            keytipProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, keytipProps, { hasMenu: true });
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__KeytipData__["a" /* KeytipData */], { keytipProps: keytipProps, ariaDescribedBy: buttonNativeProperties['aria-describedby'], disabled: Object(__WEBPACK_IMPORTED_MODULE_5__utilities_contextualMenu_index__["c" /* isItemDisabled */])(item) }, function (keytipAttributes) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("button", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ ref: _this._btn }, buttonNativeProperties, itemButtonProperties, keytipAttributes),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ChildrenRenderer, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ componentRef: item.componentRef, item: item, classNames: classNames, index: index, onCheckmarkClick: hasCheckmarks && onItemClick ? onItemClick : undefined, hasIcons: hasIcons, openSubMenu: openSubMenu, dismissSubMenu: dismissSubMenu, dismissMenu: dismissMenu, getSubmenuTarget: _this._getSubmenuTarget }, itemProps)))); }));
    };
    return ContextualMenuButton;
}(__WEBPACK_IMPORTED_MODULE_3__ContextualMenuItemWrapper__["a" /* ContextualMenuItemWrapper */]));

//# sourceMappingURL=ContextualMenuButton.js.map

/***/ }),
/* 1748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContextualMenuSplitButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContextualMenuItem__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContextualMenu_classNames__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__KeytipData__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_contextualMenu_index__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Divider__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ContextualMenuItemWrapper__ = __webpack_require__(272);









var TouchIdleDelay = 500; /* ms */
var ContextualMenuSplitButton = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ContextualMenuSplitButton, _super);
    function ContextualMenuSplitButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onItemKeyDown = function (ev) {
            var _a = _this.props, item = _a.item, onItemKeyDown = _a.onItemKeyDown;
            if (ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].enter) {
                _this._executeItemClick(ev);
                ev.preventDefault();
                ev.stopPropagation();
            }
            else if (onItemKeyDown) {
                onItemKeyDown(item, ev);
            }
        };
        _this._getSubmenuTarget = function () {
            return _this._splitButton;
        };
        _this._onItemMouseEnterPrimary = function (ev) {
            var _a = _this.props, item = _a.item, onItemMouseEnter = _a.onItemMouseEnter;
            if (onItemMouseEnter) {
                onItemMouseEnter(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, item, { subMenuProps: undefined, items: undefined }), ev, _this._splitButton);
            }
        };
        _this._onItemMouseEnterIcon = function (ev) {
            var _a = _this.props, item = _a.item, onItemMouseEnter = _a.onItemMouseEnter;
            if (onItemMouseEnter) {
                onItemMouseEnter(item, ev, _this._splitButton);
            }
        };
        _this._onItemMouseMovePrimary = function (ev) {
            var _a = _this.props, item = _a.item, onItemMouseMove = _a.onItemMouseMove;
            if (onItemMouseMove) {
                onItemMouseMove(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, item, { subMenuProps: undefined, items: undefined }), ev, _this._splitButton);
            }
        };
        _this._onItemMouseMoveIcon = function (ev) {
            var _a = _this.props, item = _a.item, onItemMouseMove = _a.onItemMouseMove;
            if (onItemMouseMove) {
                onItemMouseMove(item, ev, _this._splitButton);
            }
        };
        _this._onIconItemClick = function (ev) {
            var _a = _this.props, item = _a.item, onItemClickBase = _a.onItemClickBase;
            if (onItemClickBase) {
                onItemClickBase(item, ev, (_this._splitButton ? _this._splitButton : ev.currentTarget));
            }
        };
        _this._executeItemClick = function (ev) {
            var _a = _this.props, item = _a.item, executeItemClick = _a.executeItemClick, onItemClick = _a.onItemClick;
            if (item.disabled || item.isDisabled) {
                return;
            }
            if (_this._processingTouch && onItemClick) {
                return onItemClick(item, ev);
            }
            if (executeItemClick) {
                executeItemClick(item, ev);
            }
        };
        _this._onTouchStart = function (ev) {
            if (_this._splitButton && !('onpointerdown' in _this._splitButton)) {
                _this._handleTouchAndPointerEvent(ev);
            }
        };
        _this._onPointerDown = function (ev) {
            if (ev.pointerType === 'touch') {
                _this._handleTouchAndPointerEvent(ev);
                ev.preventDefault();
                ev.stopImmediatePropagation();
            }
        };
        return _this;
    }
    ContextualMenuSplitButton.prototype.componentDidMount = function () {
        if (this._splitButton && 'onpointerdown' in this._splitButton) {
            this._events.on(this._splitButton, 'pointerdown', this._onPointerDown, true);
        }
    };
    ContextualMenuSplitButton.prototype.render = function () {
        var _this = this;
        var _a = this.props, item = _a.item, classNames = _a.classNames, index = _a.index, focusableElementIndex = _a.focusableElementIndex, totalItemCount = _a.totalItemCount, hasCheckmarks = _a.hasCheckmarks, hasIcons = _a.hasIcons, onItemMouseLeave = _a.onItemMouseLeave, expandedMenuItemKey = _a.expandedMenuItemKey;
        var itemHasSubmenu = Object(__WEBPACK_IMPORTED_MODULE_6__utilities_contextualMenu_index__["b" /* hasSubmenu */])(item);
        var keytipProps = item.keytipProps;
        if (keytipProps) {
            keytipProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, keytipProps, { hasMenu: true });
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__KeytipData__["a" /* KeytipData */], { keytipProps: keytipProps, disabled: Object(__WEBPACK_IMPORTED_MODULE_6__utilities_contextualMenu_index__["c" /* isItemDisabled */])(item) }, function (keytipAttributes) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { "data-ktp-target": keytipAttributes['data-ktp-target'], ref: function (splitButton) { return (_this._splitButton = splitButton); }, role: 'menuitem', "aria-label": item.ariaLabel, className: classNames.splitContainer, "aria-disabled": Object(__WEBPACK_IMPORTED_MODULE_6__utilities_contextualMenu_index__["c" /* isItemDisabled */])(item), "aria-expanded": itemHasSubmenu ? item.key === expandedMenuItemKey : undefined, "aria-haspopup": true, "aria-describedby": Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_16" /* mergeAriaAttributeValues */])(item.ariaDescription, keytipAttributes['aria-describedby']), "aria-checked": item.isChecked || item.checked, "aria-posinset": focusableElementIndex + 1, "aria-setsize": totalItemCount, onMouseEnter: _this._onItemMouseEnterPrimary, onMouseLeave: onItemMouseLeave ? onItemMouseLeave.bind(_this, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, item, { subMenuProps: null, items: null })) : undefined, onMouseMove: _this._onItemMouseMovePrimary, onKeyDown: _this._onItemKeyDown, onClick: _this._executeItemClick, onTouchStart: _this._onTouchStart, tabIndex: 0, "data-is-focusable": true, "aria-roledescription": item['aria-roledescription'] },
            _this._renderSplitPrimaryButton(item, classNames, index, hasCheckmarks, hasIcons),
            _this._renderSplitDivider(item),
            _this._renderSplitIconButton(item, classNames, index, keytipAttributes))); }));
    };
    ContextualMenuSplitButton.prototype._renderSplitPrimaryButton = function (item, classNames, index, hasCheckmarks, hasIcons) {
        var _a = this.props, _b = _a.contextualMenuItemAs, ChildrenRenderer = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_3__ContextualMenuItem__["a" /* ContextualMenuItem */] : _b, onItemClick = _a.onItemClick;
        var itemProps = {
            key: item.key,
            disabled: Object(__WEBPACK_IMPORTED_MODULE_6__utilities_contextualMenu_index__["c" /* isItemDisabled */])(item) || item.primaryDisabled,
            name: item.name,
            text: item.text || item.name,
            className: classNames.splitPrimary,
            canCheck: item.canCheck,
            isChecked: item.isChecked,
            checked: item.checked,
            iconProps: item.iconProps,
            'data-is-focusable': false,
            'aria-hidden': true
        };
        var itemComponentProps = item.itemProps;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("button", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["R" /* getNativeProps */])(itemProps, __WEBPACK_IMPORTED_MODULE_2__Utilities__["p" /* buttonProperties */])),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ChildrenRenderer, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ "data-is-focusable": false, item: itemProps, classNames: classNames, index: index, onCheckmarkClick: hasCheckmarks && onItemClick ? onItemClick : undefined, hasIcons: hasIcons }, itemComponentProps))));
    };
    ContextualMenuSplitButton.prototype._renderSplitDivider = function (item) {
        var getDividerClassNames = item.getSplitButtonVerticalDividerClassNames || __WEBPACK_IMPORTED_MODULE_4__ContextualMenu_classNames__["b" /* getSplitButtonVerticalDividerClassNames */];
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Divider__["a" /* VerticalDivider */], { getClassNames: getDividerClassNames });
    };
    ContextualMenuSplitButton.prototype._renderSplitIconButton = function (item, classNames, index, keytipAttributes) {
        var _a = this.props, _b = _a.contextualMenuItemAs, ChildrenRenderer = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_3__ContextualMenuItem__["a" /* ContextualMenuItem */] : _b, onItemMouseLeave = _a.onItemMouseLeave, onItemMouseDown = _a.onItemMouseDown, openSubMenu = _a.openSubMenu, dismissSubMenu = _a.dismissSubMenu, dismissMenu = _a.dismissMenu;
        var itemProps = {
            onClick: this._onIconItemClick,
            disabled: Object(__WEBPACK_IMPORTED_MODULE_6__utilities_contextualMenu_index__["c" /* isItemDisabled */])(item),
            className: classNames.splitMenu,
            subMenuProps: item.subMenuProps,
            submenuIconProps: item.submenuIconProps,
            split: true,
            key: item.key
        };
        var buttonProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["R" /* getNativeProps */])(itemProps, __WEBPACK_IMPORTED_MODULE_2__Utilities__["p" /* buttonProperties */]), {
            onMouseEnter: this._onItemMouseEnterIcon,
            onMouseLeave: onItemMouseLeave ? onItemMouseLeave.bind(this, item) : undefined,
            onMouseDown: function (ev) { return (onItemMouseDown ? onItemMouseDown(item, ev) : undefined); },
            onMouseMove: this._onItemMouseMoveIcon,
            'data-is-focusable': false,
            'data-ktp-execute-target': keytipAttributes['data-ktp-execute-target'],
            'aria-hidden': true
        });
        var itemComponentProps = item.itemProps;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("button", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, buttonProps),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ChildrenRenderer, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ componentRef: item.componentRef, item: itemProps, classNames: classNames, index: index, hasIcons: false, openSubMenu: openSubMenu, dismissSubMenu: dismissSubMenu, dismissMenu: dismissMenu, getSubmenuTarget: this._getSubmenuTarget }, itemComponentProps))));
    };
    ContextualMenuSplitButton.prototype._handleTouchAndPointerEvent = function (ev) {
        var _this = this;
        var onTap = this.props.onTap;
        if (onTap) {
            onTap(ev);
        }
        // If we already have an existing timeout from a previous touch/pointer event
        // cancel that timeout so we can set a new one.
        if (this._lastTouchTimeoutId) {
            this._async.clearTimeout(this._lastTouchTimeoutId);
            this._lastTouchTimeoutId = undefined;
        }
        this._processingTouch = true;
        this._lastTouchTimeoutId = this._async.setTimeout(function () {
            _this._processingTouch = false;
            _this._lastTouchTimeoutId = undefined;
        }, TouchIdleDelay);
    };
    return ContextualMenuSplitButton;
}(__WEBPACK_IMPORTED_MODULE_8__ContextualMenuItemWrapper__["a" /* ContextualMenuItemWrapper */]));

//# sourceMappingURL=ContextualMenuSplitButton.js.map

/***/ }),
/* 1749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VerticalDivider__ = __webpack_require__(1750);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__VerticalDivider__["a"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 1750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VerticalDivider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VerticalDivider_styles__ = __webpack_require__(1751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VerticalDivider_base__ = __webpack_require__(1752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);



var VerticalDivider = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__VerticalDivider_base__["a" /* VerticalDividerBase */], __WEBPACK_IMPORTED_MODULE_0__VerticalDivider_styles__["a" /* getStyles */], undefined, {
    scope: 'VerticalDivider'
});
//# sourceMappingURL=VerticalDivider.js.map

/***/ }),
/* 1751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
var getStyles = function (props) {
    var theme = props.theme, getClassNames = props.getClassNames, className = props.className;
    if (!theme) {
        throw new Error('Theme is undefined or null.');
    }
    if (getClassNames) {
        var names = getClassNames(theme);
        return {
            wrapper: [names.wrapper],
            divider: [names.divider]
        };
    }
    return {
        wrapper: [
            {
                display: 'inline-flex',
                height: '100%',
                alignItems: 'center'
            },
            className
        ],
        divider: [
            {
                width: 1,
                height: '100%',
                backgroundColor: theme.palette.neutralTertiaryAlt
            }
        ]
    };
};
//# sourceMappingURL=VerticalDivider.styles.js.map

/***/ }),
/* 1752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VerticalDividerBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utilities__ = __webpack_require__(1);


var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["r" /* classNamesFunction */])();
var VerticalDividerBase = function (props) {
    var styles = props.styles, theme = props.theme, deprecatedGetClassNames = props.getClassNames, className = props.className;
    var classNames = getClassNames(styles, { theme: theme, getClassNames: deprecatedGetClassNames, className: className });
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: classNames.wrapper },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", { className: classNames.divider })));
};
//# sourceMappingURL=VerticalDivider.base.js.map

/***/ }),
/* 1753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContextualMenu_cnstyles__ = __webpack_require__(702);


var GlobalClassNames = {
    root: 'ms-ContextualMenu',
    container: 'ms-ContextualMenu-container',
    list: 'ms-ContextualMenu-list',
    header: 'ms-ContextualMenu-header',
    title: 'ms-ContextualMenu-title',
    isopen: 'is-open'
};
var getStyles = function (props) {
    var className = props.className, theme = props.theme;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    var palette = theme.palette, fonts = theme.fonts, semanticColors = theme.semanticColors;
    return {
        root: [
            theme.fonts.medium,
            classNames.root,
            classNames.isopen,
            {
                backgroundColor: semanticColors.bodyBackground,
                minWidth: '180px'
            },
            className
        ],
        container: [
            classNames.container,
            {
                selectors: {
                    ':focus': { outline: 0 }
                }
            }
        ],
        list: [
            classNames.list,
            classNames.isopen,
            {
                listStyleType: 'none',
                margin: '0',
                padding: '0'
            }
        ],
        header: [
            classNames.header,
            fonts.small,
            {
                fontWeight: __WEBPACK_IMPORTED_MODULE_0__Styling__["f" /* FontWeights */].semibold,
                color: semanticColors.menuHeader,
                background: 'none',
                backgroundColor: 'transparent',
                border: 'none',
                height: __WEBPACK_IMPORTED_MODULE_1__ContextualMenu_cnstyles__["a" /* CONTEXTUAL_MENU_ITEM_HEIGHT */],
                lineHeight: __WEBPACK_IMPORTED_MODULE_1__ContextualMenu_cnstyles__["a" /* CONTEXTUAL_MENU_ITEM_HEIGHT */],
                cursor: 'default',
                padding: '0px 6px',
                userSelect: 'none',
                textAlign: 'left'
            }
        ],
        title: [
            classNames.title,
            {
                fontSize: '16px',
                paddingRight: '14px',
                paddingLeft: '14px',
                paddingBottom: '5px',
                paddingTop: '5px',
                backgroundColor: palette.neutralLight
            }
        ],
        subComponentStyles: { callout: {}, menuItem: {} }
    };
};
//# sourceMappingURL=ContextualMenu.styles.js.map

/***/ }),
/* 1754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getClassNames; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Styling__ = __webpack_require__(5);


var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_15" /* memoizeFunction */])(function (styles, disabled, expanded, checked, primaryDisabled) {
    return {
        root: Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["F" /* mergeStyles */])(styles.splitButtonMenuButton, expanded && [styles.splitButtonMenuButtonExpanded], disabled && [styles.splitButtonMenuButtonDisabled], checked && !disabled && [styles.splitButtonMenuButtonChecked]),
        splitButtonContainer: Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["F" /* mergeStyles */])(styles.splitButtonContainer, checked &&
            !disabled && [
            styles.splitButtonContainerChecked,
            {
                selectors: {
                    ':hover': styles.splitButtonContainerCheckedHovered
                }
            }
        ], !disabled &&
            !checked && [
            {
                selectors: {
                    ':hover': styles.splitButtonContainerHovered,
                    ':focus': styles.splitButtonContainerFocused
                }
            }
        ], disabled && styles.splitButtonContainerDisabled),
        icon: Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["F" /* mergeStyles */])(styles.splitButtonMenuIcon, disabled && styles.splitButtonMenuIconDisabled, !disabled && primaryDisabled && styles.splitButtonMenuIcon),
        flexContainer: Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["F" /* mergeStyles */])(styles.splitButtonFlexContainer),
        divider: Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["F" /* mergeStyles */])(styles.splitButtonDivider, (primaryDisabled || disabled) && styles.splitButtonDividerDisabled)
    };
});
//# sourceMappingURL=SplitButton.classNames.js.map

/***/ }),
/* 1755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Button_types__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DefaultButton_DefaultButton__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ActionButton_ActionButton__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CompoundButton_CompoundButton__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__IconButton_IconButton__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PrimaryButton_PrimaryButton__ = __webpack_require__(709);









/**
 * This class is deprecated. Use the individual *Button components instead.
 * @deprecated Use the individual *Button components instead.
 * {@docCategory Button}
 */
var Button = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](Button, _super);
    function Button(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Set this BaseComponent._skipComponentRefResolution to true, bypassing resolution of componentRef.
         */
        _this._skipComponentRefResolution = true;
        Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_34" /* warn */])("The Button component has been deprecated. Use specific variants instead. " +
            "(PrimaryButton, DefaultButton, IconButton, ActionButton, etc.)");
        return _this;
    }
    Button.prototype.render = function () {
        var props = this.props;
        switch (props.buttonType) {
            case __WEBPACK_IMPORTED_MODULE_3__Button_types__["a" /* ButtonType */].command:
                return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__ActionButton_ActionButton__["a" /* ActionButton */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, props));
            case __WEBPACK_IMPORTED_MODULE_3__Button_types__["a" /* ButtonType */].compound:
                return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__CompoundButton_CompoundButton__["a" /* CompoundButton */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, props));
            case __WEBPACK_IMPORTED_MODULE_3__Button_types__["a" /* ButtonType */].icon:
                return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__IconButton_IconButton__["a" /* IconButton */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, props));
            case __WEBPACK_IMPORTED_MODULE_3__Button_types__["a" /* ButtonType */].primary:
                return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__PrimaryButton_PrimaryButton__["a" /* PrimaryButton */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, props));
            default:
                return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__DefaultButton_DefaultButton__["a" /* DefaultButton */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, props));
        }
    };
    return Button;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=Button.js.map

/***/ }),
/* 1756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseButton_styles__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SplitButton_SplitButton_styles__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ButtonThemes__ = __webpack_require__(705);





var DEFAULT_BUTTON_HEIGHT = '32px';
var DEFAULT_BUTTON_MINWIDTH = '80px';
var getStyles = Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["_15" /* memoizeFunction */])(function (theme, customStyles, primary) {
    var baseButtonStyles = Object(__WEBPACK_IMPORTED_MODULE_2__BaseButton_styles__["a" /* getStyles */])(theme);
    var splitButtonStyles = Object(__WEBPACK_IMPORTED_MODULE_3__SplitButton_SplitButton_styles__["a" /* getStyles */])(theme);
    var defaultButtonStyles = {
        root: {
            minWidth: DEFAULT_BUTTON_MINWIDTH,
            height: DEFAULT_BUTTON_HEIGHT
        },
        label: {
            fontWeight: __WEBPACK_IMPORTED_MODULE_0__Styling__["f" /* FontWeights */].semibold
        }
    };
    return Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["t" /* concatStyleSets */])(baseButtonStyles, defaultButtonStyles, primary ? Object(__WEBPACK_IMPORTED_MODULE_4__ButtonThemes__["a" /* primaryStyles */])(theme) : Object(__WEBPACK_IMPORTED_MODULE_4__ButtonThemes__["b" /* standardStyles */])(theme), splitButtonStyles, customStyles);
});
//# sourceMappingURL=DefaultButton.styles.js.map

/***/ }),
/* 1757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseButton_styles__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SplitButton_SplitButton_styles__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ButtonThemes__ = __webpack_require__(705);





var getStyles = Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["_15" /* memoizeFunction */])(function (theme, customStyles, primary) {
    var baseButtonStyles = Object(__WEBPACK_IMPORTED_MODULE_2__BaseButton_styles__["a" /* getStyles */])(theme);
    var splitButtonStyles = Object(__WEBPACK_IMPORTED_MODULE_3__SplitButton_SplitButton_styles__["a" /* getStyles */])(theme);
    var compoundButtonStyles = {
        root: {
            maxWidth: '280px',
            minHeight: '72px',
            height: 'auto',
            padding: '20px'
        },
        flexContainer: {
            flexDirection: 'row',
            alignItems: 'flex-start',
            minWidth: '100%',
            margin: ''
        },
        textContainer: {
            textAlign: 'left'
        },
        icon: {
            fontSize: '2em',
            lineHeight: '1em',
            height: '1em',
            margin: '0px 8px 0px 0px',
            flexBasis: '1em',
            flexShrink: '0'
        },
        label: {
            margin: '0 0 5px',
            lineHeight: '100%',
            fontWeight: __WEBPACK_IMPORTED_MODULE_0__Styling__["f" /* FontWeights */].semibold
        },
        description: [
            theme.fonts.small,
            {
                lineHeight: '100%'
            }
        ]
    };
    var standardCompoundTheme = {
        description: {
            color: theme.palette.neutralSecondary
        },
        descriptionHovered: {
            color: theme.palette.neutralDark
        },
        descriptionPressed: {
            color: 'inherit'
        },
        descriptionChecked: {
            color: 'inherit'
        },
        descriptionDisabled: {
            color: 'inherit'
        }
    };
    var primaryCompoundTheme = {
        description: {
            color: theme.palette.white,
            selectors: (_a = {},
                _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                    color: 'Window',
                    backgroundColor: 'WindowText',
                    MsHighContrastAdjust: 'none'
                },
                _a)
        },
        descriptionHovered: {
            color: theme.palette.white,
            selectors: (_b = {},
                _b[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                    color: 'Window',
                    backgroundColor: 'Highlight',
                    MsHighContrastAdjust: 'none'
                },
                _b)
        },
        descriptionPressed: {
            color: 'inherit'
        },
        descriptionChecked: {
            color: 'inherit'
        },
        descriptionDisabled: {
            color: 'inherit',
            selectors: (_c = {},
                _c[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                    color: 'inherit'
                },
                _c)
        }
    };
    return Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["t" /* concatStyleSets */])(baseButtonStyles, compoundButtonStyles, primary ? Object(__WEBPACK_IMPORTED_MODULE_4__ButtonThemes__["a" /* primaryStyles */])(theme) : Object(__WEBPACK_IMPORTED_MODULE_4__ButtonThemes__["b" /* standardStyles */])(theme), primary ? primaryCompoundTheme : standardCompoundTheme, splitButtonStyles, customStyles);
    var _a, _b, _c;
});
//# sourceMappingURL=CompoundButton.styles.js.map

/***/ }),
/* 1758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseButton_styles__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SplitButton_SplitButton_styles__ = __webpack_require__(274);




var getStyles = Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["_15" /* memoizeFunction */])(function (theme, customStyles) {
    var baseButtonStyles = Object(__WEBPACK_IMPORTED_MODULE_2__BaseButton_styles__["a" /* getStyles */])(theme);
    var splitButtonStyles = Object(__WEBPACK_IMPORTED_MODULE_3__SplitButton_SplitButton_styles__["a" /* getStyles */])(theme);
    var palette = theme.palette, semanticColors = theme.semanticColors;
    var iconButtonStyles = {
        root: {
            padding: '0 4px',
            width: '32px',
            height: '32px',
            backgroundColor: 'transparent',
            border: 'none',
            color: semanticColors.actionLink
        },
        rootHovered: {
            color: semanticColors.actionLinkHovered,
            selectors: (_a = {},
                _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                    borderColor: 'Highlight',
                    color: 'Highlight'
                },
                _a)
        },
        rootPressed: {
            color: palette.themePrimary
        },
        rootExpanded: {
            color: palette.themePrimary
        },
        rootChecked: {
            backgroundColor: semanticColors.buttonBackgroundChecked
        },
        rootCheckedHovered: {
            backgroundColor: semanticColors.buttonBackgroundHovered
        },
        rootDisabled: {
            color: semanticColors.disabledText
        }
    };
    return Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["t" /* concatStyleSets */])(baseButtonStyles, iconButtonStyles, splitButtonStyles, customStyles);
    var _a;
});
//# sourceMappingURL=IconButton.styles.js.map

/***/ }),
/* 1759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CommandBarButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseButton__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CommandBarButton_styles__ = __webpack_require__(1760);





/**
 * {@docCategory Button}
 */
var CommandBarButton = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](CommandBarButton, _super);
    function CommandBarButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Tell BaseComponent to bypass resolution of componentRef.
         */
        _this._skipComponentRefResolution = true;
        return _this;
    }
    CommandBarButton.prototype.render = function () {
        var _a = this.props, styles = _a.styles, theme = _a.theme;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__BaseButton__["a" /* BaseButton */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this.props, { variantClassName: "ms-Button--commandBar", styles: Object(__WEBPACK_IMPORTED_MODULE_4__CommandBarButton_styles__["a" /* getStyles */])(theme, styles), onRenderDescription: __WEBPACK_IMPORTED_MODULE_3__Utilities__["_17" /* nullRender */] })));
    };
    CommandBarButton = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["u" /* customizable */])('CommandBarButton', ['theme', 'styles'], true)
    ], CommandBarButton);
    return CommandBarButton;
}(__WEBPACK_IMPORTED_MODULE_3__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=CommandBarButton.js.map

/***/ }),
/* 1760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseButton_styles__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SplitButton_SplitButton_styles__ = __webpack_require__(274);




var getStyles = Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["_15" /* memoizeFunction */])(function (theme, customStyles, focusInset, focusColor) {
    var baseButtonStyles = Object(__WEBPACK_IMPORTED_MODULE_2__BaseButton_styles__["a" /* getStyles */])(theme);
    var baseSplitButtonStyles = Object(__WEBPACK_IMPORTED_MODULE_3__SplitButton_SplitButton_styles__["a" /* getStyles */])(theme);
    var commandButtonHighContrastFocus = {
        left: 4,
        top: 4,
        bottom: 4,
        right: 4,
        border: 'none'
    };
    var commandButtonStyles = {
        root: [
            Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["v" /* getFocusStyle */])(theme, { inset: -1, highContrastStyle: commandButtonHighContrastFocus }),
            theme.fonts.medium,
            {
                minWidth: '40px',
                backgroundColor: theme.palette.neutralLighter,
                color: theme.palette.neutralPrimary,
                padding: '0 4px',
                selectors: (_a = {},
                    _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        border: 'none'
                    },
                    _a)
            }
        ],
        rootHovered: {
            backgroundColor: theme.palette.neutralLight,
            color: theme.palette.neutralDark,
            selectors: (_b = {},
                _b[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                    color: 'Highlight'
                },
                _b)
        },
        rootPressed: {
            backgroundColor: theme.palette.neutralQuaternaryAlt,
            color: theme.palette.black
        },
        rootChecked: {
            backgroundColor: theme.palette.neutralQuaternaryAlt,
            color: theme.palette.black
        },
        rootExpanded: {
            backgroundColor: theme.palette.neutralQuaternaryAlt,
            color: theme.palette.black
        },
        rootCheckedHovered: {
            backgroundColor: theme.palette.neutralQuaternary,
            color: theme.palette.black
        },
        // Split button styles
        splitButtonContainer: {
            selectors: (_c = {},
                _c[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                    border: 'none'
                },
                _c)
        },
        splitButtonDivider: {
            backgroundColor: theme.palette.neutralTertiaryAlt,
            marginTop: 4,
            marginBottom: 4
        },
        splitButtonMenuButton: {
            backgroundColor: theme.palette.neutralLighter,
            color: theme.palette.neutralPrimary,
            selectors: {
                ':hover': {
                    backgroundColor: theme.palette.neutralLight,
                    color: theme.palette.neutralDark,
                    selectors: (_d = {},
                        _d[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                            color: 'Highlight'
                        },
                        _d)
                }
            }
        },
        splitButtonMenuButtonDisabled: {
            backgroundColor: theme.palette.neutralLighter,
            selectors: {
                ':hover': {
                    backgroundColor: theme.palette.neutralLighter
                }
            }
        },
        splitButtonMenuButtonChecked: {
            backgroundColor: theme.palette.neutralQuaternaryAlt,
            color: theme.palette.black,
            selectors: {
                ':hover': {
                    backgroundColor: theme.palette.neutralQuaternaryAlt
                }
            }
        },
        splitButtonMenuButtonExpanded: {
            backgroundColor: theme.palette.neutralQuaternaryAlt,
            color: theme.palette.black,
            selectors: {
                ':hover': {
                    backgroundColor: theme.palette.neutralQuaternaryAlt
                }
            }
        },
        splitButtonMenuIcon: {
            color: theme.palette.neutralPrimary
        },
        splitButtonMenuIconDisabled: {
            color: theme.palette.neutralTertiary
        },
        label: {
            fontWeight: 'normal' // theme.fontWeights.semibold,
        },
        icon: {
            color: theme.palette.themeDarkAlt
        },
        menuIcon: {
            color: theme.palette.neutralSecondary
        }
    };
    return Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["t" /* concatStyleSets */])(baseButtonStyles, commandButtonStyles, baseSplitButtonStyles, customStyles);
    var _a, _b, _c, _d;
});
//# sourceMappingURL=CommandBarButton.styles.js.map

/***/ }),
/* 1761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CommandButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ActionButton_ActionButton__ = __webpack_require__(413);

/**
 * {@docCategory Button}
 */
var CommandButton = __WEBPACK_IMPORTED_MODULE_0__ActionButton_ActionButton__["a" /* ActionButton */];
//# sourceMappingURL=CommandButton.js.map

/***/ }),
/* 1762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MessageBarButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DefaultButton_DefaultButton__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MessageBarButton_styles__ = __webpack_require__(1763);





/**
 * {@docCategory MessageBar}
 */
var MessageBarButton = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](MessageBarButton, _super);
    function MessageBarButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MessageBarButton.prototype.render = function () {
        var _a = this.props, styles = _a.styles, theme = _a.theme;
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__DefaultButton_DefaultButton__["a" /* DefaultButton */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this.props, { styles: Object(__WEBPACK_IMPORTED_MODULE_4__MessageBarButton_styles__["a" /* getStyles */])(theme, styles), onRenderDescription: __WEBPACK_IMPORTED_MODULE_3__Utilities__["_17" /* nullRender */] }));
    };
    MessageBarButton = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["u" /* customizable */])('MessageBarButton', ['theme', 'styles'], true)
    ], MessageBarButton);
    return MessageBarButton;
}(__WEBPACK_IMPORTED_MODULE_3__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=MessageBarButton.js.map

/***/ }),
/* 1763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseButton_styles__ = __webpack_require__(137);



var getStyles = Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["_15" /* memoizeFunction */])(function (theme, customStyles, focusInset, focusColor) {
    var baseButtonStyles = Object(__WEBPACK_IMPORTED_MODULE_2__BaseButton_styles__["a" /* getStyles */])(theme);
    var messageBarButtonStyles = {
        root: [
            Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["v" /* getFocusStyle */])(theme, {
                inset: 1,
                highContrastStyle: {
                    outlineOffset: '-4px',
                    outlineColor: 'ActiveBorder'
                },
                borderColor: 'transparent'
            }),
            {
                backgroundColor: theme.palette.neutralQuaternaryAlt,
                color: theme.palette.neutralPrimary
            }
        ],
        rootHovered: {
            backgroundColor: theme.palette.neutralTertiaryAlt,
            color: theme.palette.neutralDark
        },
        rootPressed: {
            backgroundColor: theme.palette.neutralTertiary,
            color: theme.palette.neutralDark
        }
    };
    return Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["t" /* concatStyleSets */])(baseButtonStyles, messageBarButtonStyles, customStyles);
});
//# sourceMappingURL=MessageBarButton.styles.js.map

/***/ }),
/* 1764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dialog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dialog_base__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dialog_styles__ = __webpack_require__(1773);



var Dialog = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__Dialog_base__["a" /* DialogBase */], __WEBPACK_IMPORTED_MODULE_2__Dialog_styles__["a" /* getStyles */], undefined, { scope: 'Dialog' });
//# sourceMappingURL=Dialog.js.map

/***/ }),
/* 1765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Modal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Modal_base__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modal_styles__ = __webpack_require__(714);



var Modal = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__Modal_base__["a" /* ModalBase */], __WEBPACK_IMPORTED_MODULE_2__Modal_styles__["b" /* getStyles */], undefined, {
    scope: 'Modal'
});
//# sourceMappingURL=Modal.js.map

/***/ }),
/* 1766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Overlay__ = __webpack_require__(1767);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Overlay__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Overlay_base__ = __webpack_require__(715);
/* unused harmony namespace reexport */


//# sourceMappingURL=index.js.map

/***/ }),
/* 1767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Overlay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Overlay_base__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Overlay_styles__ = __webpack_require__(1768);



var Overlay = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__Overlay_base__["a" /* OverlayBase */], __WEBPACK_IMPORTED_MODULE_2__Overlay_styles__["a" /* getStyles */], undefined, {
    scope: 'Overlay'
});
//# sourceMappingURL=Overlay.js.map

/***/ }),
/* 1768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var GlobalClassNames = {
    root: 'ms-Overlay',
    rootDark: 'ms-Overlay--dark'
};
var getStyles = function (props) {
    var className = props.className, theme = props.theme, isNone = props.isNone, isDark = props.isDark;
    var palette = theme.palette;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            {
                backgroundColor: palette.whiteTranslucent40,
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                position: 'absolute',
                selectors: (_a = {},
                    _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        border: '1px solid WindowText',
                        opacity: 0
                    },
                    _a)
            },
            isNone && {
                visibility: 'hidden'
            },
            isDark && [
                classNames.rootDark,
                {
                    backgroundColor: palette.blackTranslucent40
                }
            ],
            className
        ]
    };
    var _a;
};
//# sourceMappingURL=Overlay.styles.js.map

/***/ }),
/* 1769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DraggableZone__ = __webpack_require__(1770);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__DraggableZone__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DraggableZone_styles__ = __webpack_require__(716);
/* unused harmony namespace reexport */


//# sourceMappingURL=index.js.map

/***/ }),
/* 1770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DraggableZone; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DraggableZone_styles__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utilities__ = __webpack_require__(1);




var eventMapping = {
    touch: {
        start: 'touchstart',
        move: 'touchmove',
        stop: 'touchend'
    },
    mouse: {
        start: 'mousedown',
        move: 'mousemove',
        stop: 'mouseup'
    }
};
var DraggableZone = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](DraggableZone, _super);
    function DraggableZone(props) {
        var _this = _super.call(this, props) || this;
        _this._currentEventType = eventMapping.mouse;
        _this._events = [];
        _this._onMouseDown = function (event) {
            var onMouseDown = __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(_this.props.children).props.onMouseDown;
            if (onMouseDown) {
                onMouseDown(event);
            }
            _this._currentEventType = eventMapping.mouse;
            return _this._onDragStart(event);
        };
        _this._onMouseUp = function (event) {
            var onMouseUp = __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(_this.props.children).props.onMouseUp;
            if (onMouseUp) {
                onMouseUp(event);
            }
            _this._currentEventType = eventMapping.mouse;
            return _this._onDragStop(event);
        };
        _this._onTouchStart = function (event) {
            var onTouchStart = __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(_this.props.children).props.onTouchStart;
            if (onTouchStart) {
                onTouchStart(event);
            }
            _this._currentEventType = eventMapping.touch;
            return _this._onDragStart(event);
        };
        _this._onTouchEnd = function (event) {
            var onTouchEnd = __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(_this.props.children).props.onTouchEnd;
            if (onTouchEnd) {
                onTouchEnd(event);
            }
            _this._currentEventType = eventMapping.touch;
            _this._onDragStop(event);
        };
        _this._onDragStart = function (event) {
            // Only handle left click for dragging
            if (typeof event.button === 'number' && event.button !== 0) {
                return false;
            }
            // If the target doesn't match the handleSelector OR
            // if the target does match the preventDragSelector, bail out
            if ((_this.props.handleSelector && !_this._matchesSelector(event.target, _this.props.handleSelector)) ||
                (_this.props.preventDragSelector && _this._matchesSelector(event.target, _this.props.preventDragSelector))) {
                return;
            }
            // Remember the touch identifier if this is a touch event so we can
            // distinguish between individual touches in multitouch scenarios
            // by remembering which touch point we were given
            _this._touchId = _this._getTouchId(event);
            var position = _this._getControlPosition(event);
            if (position === undefined) {
                return;
            }
            var dragData = _this._createDragDataFromPosition(position);
            _this.props.onStart && _this.props.onStart(event, dragData);
            _this.setState({
                isDragging: true,
                lastPosition: position
            });
            // hook up the appropriate mouse/touch events to the body to ensure
            // smooth dragging
            _this._events = [
                Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_18" /* on */])(document.body, _this._currentEventType.move, _this._onDrag),
                Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_18" /* on */])(document.body, _this._currentEventType.stop, _this._onDragStop)
            ];
        };
        _this._onDrag = function (event) {
            // Prevent scrolling on mobile devices
            if (event.type === 'touchmove') {
                event.preventDefault();
            }
            var position = _this._getControlPosition(event);
            if (!position) {
                return;
            }
            // create the updated drag data from the position data
            var updatedData = _this._createUpdatedDragData(_this._createDragDataFromPosition(position));
            var updatedPosition = updatedData.position;
            _this.props.onDragChange && _this.props.onDragChange(event, updatedData);
            _this.setState({
                position: updatedPosition,
                lastPosition: position
            });
        };
        _this._onDragStop = function (event) {
            if (!_this.state.isDragging) {
                return;
            }
            var position = _this._getControlPosition(event);
            if (!position) {
                return;
            }
            var baseDragData = _this._createDragDataFromPosition(position);
            // Set dragging to false and reset the lastPosition
            _this.setState({
                isDragging: false,
                lastPosition: undefined
            });
            _this.props.onStop && _this.props.onStop(event, baseDragData);
            if (_this.props.position) {
                _this.setState({
                    position: _this.props.position
                });
            }
            // Remove event handlers
            _this._events.forEach(function (dispose) { return dispose(); });
        };
        _this.state = {
            isDragging: false,
            position: _this.props.position || { x: 0, y: 0 },
            lastPosition: undefined
        };
        return _this;
    }
    DraggableZone.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.position && (!prevProps.position || this.props.position !== prevProps.position)) {
            this.setState({ position: this.props.position });
        }
    };
    DraggableZone.prototype.componentWillUnmount = function () {
        this._events.forEach(function (dispose) { return dispose(); });
    };
    DraggableZone.prototype.render = function () {
        var child = __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
        var props = child.props;
        var position = this.props.position;
        var _a = this.state, statePosition = _a.position, isDragging = _a.isDragging;
        var x = statePosition.x;
        var y = statePosition.y;
        if (position && !isDragging) {
            x = position.x;
            y = position.y;
        }
        return __WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"](child, {
            style: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, props.style, { transform: "translate(" + x + "px, " + y + "px)" }),
            className: Object(__WEBPACK_IMPORTED_MODULE_2__DraggableZone_styles__["a" /* getClassNames */])(props.className, this.state.isDragging).root,
            onMouseDown: this._onMouseDown,
            onMouseUp: this._onMouseUp,
            onTouchStart: this._onTouchStart,
            onTouchEnd: this._onTouchEnd
        });
    };
    /**
     * Get the control position based off the event that fired
     * @param event - The event to get offsets from
     */
    DraggableZone.prototype._getControlPosition = function (event) {
        var touchObj = this._getActiveTouch(event);
        // did we get the right touch?
        if (this._touchId !== undefined && !touchObj) {
            return undefined;
        }
        var eventToGetOffset = touchObj || event;
        return {
            x: eventToGetOffset.clientX,
            y: eventToGetOffset.clientY
        };
    };
    /**
     * Get the active touch point that we have saved from the event's TouchList
     * @param event - The event used to get the TouchList for the active touch point
     */
    DraggableZone.prototype._getActiveTouch = function (event) {
        return ((event.targetTouches && this._findTouchInTouchList(event.targetTouches)) ||
            (event.changedTouches && this._findTouchInTouchList(event.changedTouches)));
    };
    /**
     * Get the initial touch identifier associated with the given event
     * @param event - The event that contains the TouchList
     */
    DraggableZone.prototype._getTouchId = function (event) {
        var touch = (event.targetTouches && event.targetTouches[0]) || (event.changedTouches && event.changedTouches[0]);
        if (touch) {
            return touch.identifier;
        }
    };
    /**
     * Returns if an element (or any of the element's parents) match the given selector
     */
    DraggableZone.prototype._matchesSelector = function (element, selector) {
        if (!element || element === document.body) {
            return false;
        }
        /* tslint:disable-next-line:no-string-literal */
        var matchesSelectorFn = element.matches || element.webkitMatchesSelector || element['msMatchesSelector'] /* for IE */;
        if (!matchesSelectorFn) {
            return false;
        }
        return matchesSelectorFn.call(element, selector) || this._matchesSelector(element.parentElement, selector);
    };
    /**
     * Attempts to find the Touch that matches the identifier  we stored in dragStart
     * @param touchList The TouchList to look for the stored identifier from dragStart
     */
    DraggableZone.prototype._findTouchInTouchList = function (touchList) {
        if (this._touchId === undefined) {
            return;
        }
        for (var i = 0; i < touchList.length; i++) {
            if (touchList[i].identifier === this._touchId) {
                return touchList[i];
            }
        }
        return undefined;
    };
    /**
     * Create DragData based off of the last known position and the new position passed in
     * @param position The new position as part of the drag
     */
    DraggableZone.prototype._createDragDataFromPosition = function (position) {
        var lastPosition = this.state.lastPosition;
        // If we have no lastPosition, use the given position
        // for last position
        if (lastPosition === undefined) {
            return {
                delta: { x: 0, y: 0 },
                lastPosition: position,
                position: position
            };
        }
        return {
            delta: {
                x: position.x - lastPosition.x,
                y: position.y - lastPosition.y
            },
            lastPosition: lastPosition,
            position: position
        };
    };
    /**
     * Creates an updated DragData based off the current position and given baseDragData
     * @param baseDragData The base DragData (gotten from _createDragDataFromPosition) used to calculate the updated positions
     */
    DraggableZone.prototype._createUpdatedDragData = function (baseDragData) {
        var position = this.state.position;
        return {
            position: {
                x: position.x + baseDragData.delta.x,
                y: position.y + baseDragData.delta.y
            },
            delta: baseDragData.delta,
            lastPosition: position
        };
    };
    return DraggableZone;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=DraggableZone.js.map

/***/ }),
/* 1771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var GlobalClassNames = {
    actions: 'ms-Dialog-actions',
    action: 'ms-Dialog-action',
    actionsRight: 'ms-Dialog-actionsRight'
};
var getStyles = function (props) {
    var className = props.className, theme = props.theme;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    return {
        actions: [
            classNames.actions,
            {
                position: 'relative',
                width: '100%',
                minHeight: '24px',
                lineHeight: '24px',
                margin: '20px 0 0',
                fontSize: '0',
                selectors: {
                    '.ms-Button': {
                        lineHeight: 'normal'
                    }
                }
            },
            className
        ],
        action: [classNames.action],
        actionsRight: [
            classNames.actionsRight,
            {
                textAlign: 'right',
                marginRight: '-4px',
                fontSize: '0',
                selectors: {
                    $action: {
                        margin: '0 4px'
                    }
                }
            }
        ]
    };
};
//# sourceMappingURL=DialogFooter.styles.js.map

/***/ }),
/* 1772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var GlobalClassNames = {
    contentLgHeader: 'ms-Dialog-lgHeader',
    close: 'ms-Dialog--close',
    subText: 'ms-Dialog-subText',
    header: 'ms-Dialog-header',
    headerLg: 'ms-Dialog--lgHeader',
    button: 'ms-Dialog-button ms-Dialog-button--close',
    inner: 'ms-Dialog-inner',
    content: 'ms-Dialog-content',
    title: 'ms-Dialog-title'
};
var getStyles = function (props) {
    var className = props.className, theme = props.theme, isLargeHeader = props.isLargeHeader, isClose = props.isClose, hidden = props.hidden, isMultiline = props.isMultiline, draggableHeaderClassName = props.draggableHeaderClassName;
    var palette = theme.palette, fonts = theme.fonts;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    return {
        content: [
            isLargeHeader && classNames.contentLgHeader,
            isClose && classNames.close,
            {
                flexGrow: 1,
                overflowY: 'hidden' // required for allowScrollOnElement
            },
            className
        ],
        subText: [
            classNames.subText,
            isLargeHeader ? fonts.medium : fonts.small,
            {
                margin: '0 0 20px 0',
                paddingTop: '8px',
                color: palette.neutralPrimary,
                lineHeight: '1.5',
                wordWrap: 'break-word',
                fontWeight: __WEBPACK_IMPORTED_MODULE_0__Styling__["f" /* FontWeights */].semilight
            }
        ],
        header: [
            classNames.header,
            {
                position: 'relative',
                width: '100%',
                boxSizing: 'border-box'
            },
            isLargeHeader && [
                classNames.headerLg,
                {
                    backgroundColor: palette.themePrimary
                }
            ],
            isClose && classNames.close,
            draggableHeaderClassName && [
                draggableHeaderClassName,
                {
                    cursor: 'move'
                }
            ]
        ],
        button: [
            classNames.button,
            hidden && {
                selectors: {
                    '.ms-Icon.ms-Icon--Cancel': {
                        color: palette.neutralSecondary,
                        fontSize: '16px'
                    }
                }
            }
        ],
        inner: [
            classNames.inner,
            {
                padding: isMultiline ? '0 20px 20px' : '0 28px 20px'
            }
        ],
        innerContent: [
            classNames.content,
            {
                position: 'relative',
                width: '100%',
                selectors: {
                    '.ms-Button.ms-Button--compount': {
                        marginBottom: '20px',
                        selectors: {
                            '&:last-child': {
                                marginBottom: '0'
                            }
                        }
                    }
                }
            },
            className
        ],
        title: [
            classNames.title,
            {
                color: palette.neutralPrimary,
                margin: '0',
                padding: '20px 36px 20px 28px'
            },
            fonts.xLarge,
            isLargeHeader && [
                {
                    color: palette.white,
                    marginBottom: '8px',
                    padding: '26px 28px 28px'
                },
                fonts.xxLarge
            ],
            isMultiline && fonts.xxLarge
        ],
        topButton: [
            {
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'nowrap',
                position: 'absolute',
                top: '0',
                right: '0',
                padding: '12px 12px 0 0',
                selectors: {
                    '> *': {
                        flex: '0 0 auto'
                    }
                }
            }
        ]
    };
};
//# sourceMappingURL=DialogContent.styles.js.map

/***/ }),
/* 1773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var GlobalClassNames = {
    root: 'ms-Dialog'
};
var getStyles = function (props) {
    var className = props.className, containerClassName = props.containerClassName, _a = props.dialogDefaultMinWidth, dialogDefaultMinWidth = _a === void 0 ? '288px' : _a, _b = props.dialogDefaultMaxWidth, dialogDefaultMaxWidth = _b === void 0 ? '340px' : _b, hidden = props.hidden, theme = props.theme;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    return {
        root: [classNames.root, theme.fonts.medium, className],
        main: [
            {
                width: dialogDefaultMinWidth,
                outline: '3px solid transparent',
                selectors: (_c = {},
                    _c["@media (min-width: " + __WEBPACK_IMPORTED_MODULE_0__Styling__["o" /* ScreenWidthMinMedium */] + "px)"] = {
                        width: 'auto',
                        maxWidth: dialogDefaultMaxWidth,
                        minWidth: dialogDefaultMinWidth
                    },
                    _c)
            },
            !hidden && { display: 'flex' },
            containerClassName
        ]
    };
    var _c;
};
//# sourceMappingURL=Dialog.styles.js.map

/***/ }),
/* 1774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tooltip__ = __webpack_require__(721);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tooltip_base__ = __webpack_require__(722);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tooltip_types__ = __webpack_require__(275);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TooltipHost__ = __webpack_require__(1776);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__TooltipHost__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TooltipHost_base__ = __webpack_require__(723);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TooltipHost_types__ = __webpack_require__(724);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__TooltipHost_types__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_DirectionalHint__ = __webpack_require__(36);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_6__common_DirectionalHint__["a"]; });







//# sourceMappingURL=index.js.map

/***/ }),
/* 1775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tooltip_types__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Styling__ = __webpack_require__(5);


var getStyles = function (props) {
    var className = props.className, delay = props.delay, _a = props.beakWidth, beakWidth = _a === void 0 ? 16 : _a, _b = props.gapSpace, gapSpace = _b === void 0 ? 0 : _b, maxWidth = props.maxWidth, theme = props.theme;
    var palette = theme.palette, fonts = theme.fonts;
    // The math here is done to account for the 45 degree rotation of the beak
    var tooltipGapSpace = -(Math.sqrt((beakWidth * beakWidth) / 2) + gapSpace);
    return {
        root: [
            'ms-Tooltip',
            theme.fonts.medium,
            __WEBPACK_IMPORTED_MODULE_1__Styling__["a" /* AnimationClassNames */].fadeIn200,
            {
                background: palette.white,
                padding: '8px',
                animationDelay: '300ms',
                maxWidth: maxWidth,
                selectors: {
                    ':after': {
                        content: "''",
                        position: 'absolute',
                        bottom: tooltipGapSpace,
                        left: tooltipGapSpace,
                        right: tooltipGapSpace,
                        top: tooltipGapSpace,
                        zIndex: 0
                    }
                }
            },
            delay === __WEBPACK_IMPORTED_MODULE_0__Tooltip_types__["a" /* TooltipDelay */].zero && {
                animationDelay: '0s'
            },
            delay === __WEBPACK_IMPORTED_MODULE_0__Tooltip_types__["a" /* TooltipDelay */].long && {
                animationDelay: '500ms'
            },
            className
        ],
        content: [
            'ms-Tooltip-content',
            fonts.small,
            {
                position: 'relative',
                zIndex: 1,
                color: palette.neutralPrimary,
                wordWrap: 'break-word',
                overflowWrap: 'break-word',
                overflow: 'hidden'
            }
        ],
        subText: [
            'ms-Tooltip-subtext',
            {
                // Using inherit here to avoid unintentional global overrides of the <p> tag.
                fontSize: 'inherit',
                fontWeight: 'inherit',
                color: 'inherit',
                margin: 0
            }
        ]
    };
};
//# sourceMappingURL=Tooltip.styles.js.map

/***/ }),
/* 1776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TooltipHost; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TooltipHost_base__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TooltipHost_styles__ = __webpack_require__(1777);



var TooltipHost = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__TooltipHost_base__["a" /* TooltipHostBase */], __WEBPACK_IMPORTED_MODULE_2__TooltipHost_styles__["a" /* getStyles */], undefined, {
    scope: 'TooltipHost'
});
//# sourceMappingURL=TooltipHost.js.map

/***/ }),
/* 1777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var GlobalClassNames = {
    root: 'ms-TooltipHost'
};
var getStyles = function (props) {
    var className = props.className, theme = props.theme;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            {
                display: 'inline'
            },
            className
        ]
    };
};
//# sourceMappingURL=TooltipHost.styles.js.map

/***/ }),
/* 1778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Toggle__ = __webpack_require__(1779);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Toggle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Toggle_base__ = __webpack_require__(726);
/* unused harmony namespace reexport */


//# sourceMappingURL=index.js.map

/***/ }),
/* 1779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Toggle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Toggle_base__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Toggle_styles__ = __webpack_require__(1783);



var Toggle = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__Toggle_base__["a" /* ToggleBase */], __WEBPACK_IMPORTED_MODULE_2__Toggle_styles__["a" /* getStyles */], undefined, { scope: 'Toggle' });
//# sourceMappingURL=Toggle.js.map

/***/ }),
/* 1780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Label_base__ = __webpack_require__(727);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Label__ = __webpack_require__(1781);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Label__["a"]; });


//# sourceMappingURL=index.js.map

/***/ }),
/* 1781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Label; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Label_base__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Label_styles__ = __webpack_require__(1782);



var Label = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__Label_base__["a" /* LabelBase */], __WEBPACK_IMPORTED_MODULE_2__Label_styles__["a" /* getStyles */], undefined, {
    scope: 'Label'
});
//# sourceMappingURL=Label.js.map

/***/ }),
/* 1782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var getStyles = function (props) {
    var theme = props.theme, className = props.className, disabled = props.disabled, required = props.required;
    return {
        root: [
            'ms-Label',
            theme.fonts.medium,
            {
                color: theme.semanticColors.bodyText,
                boxSizing: 'border-box',
                boxShadow: 'none',
                margin: 0,
                display: 'block',
                padding: '5px 0',
                wordWrap: 'break-word',
                overflowWrap: 'break-word'
            },
            disabled && {
                color: theme.semanticColors.disabledBodyText,
                selectors: (_a = {},
                    _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        color: 'GrayText'
                    },
                    _a)
            },
            required && {
                selectors: {
                    '::after': {
                        content: "' *'",
                        color: theme.semanticColors.errorText,
                        paddingRight: 12
                    }
                }
            },
            className
        ]
    };
    var _a;
};
//# sourceMappingURL=Label.styles.js.map

/***/ }),
/* 1783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var getStyles = function (props) {
    var theme = props.theme, className = props.className, disabled = props.disabled, checked = props.checked, inlineLabel = props.inlineLabel, onOffMissing = props.onOffMissing;
    var semanticColors = theme.semanticColors;
    var pillUncheckedBackground = semanticColors.bodyBackground;
    var pillCheckedBackground = semanticColors.inputBackgroundChecked;
    var pillCheckedHoveredBackground = semanticColors.inputBackgroundCheckedHovered;
    var pillCheckedDisabledBackground = semanticColors.disabledBodySubtext;
    var thumbBackground = semanticColors.inputBorderHovered;
    var thumbCheckedBackground = semanticColors.inputForegroundChecked;
    var thumbDisabledBackground = semanticColors.disabledBodySubtext;
    var thumbCheckedDisabledBackground = semanticColors.disabledBackground;
    var pillBorderColor = semanticColors.smallInputBorder;
    var pillBorderHoveredColor = semanticColors.inputBorderHovered;
    var pillBorderDisabledColor = semanticColors.disabledBodySubtext;
    var textDisabledColor = semanticColors.disabledText;
    return {
        root: [
            'ms-Toggle',
            checked && 'is-checked',
            !disabled && 'is-enabled',
            disabled && 'is-disabled',
            theme.fonts.medium,
            {
                marginBottom: '8px'
            },
            inlineLabel && {
                display: 'flex',
                alignItems: 'center'
            },
            className
        ],
        label: [
            'ms-Toggle-label',
            disabled && {
                color: textDisabledColor,
                selectors: (_a = {},
                    _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        color: 'GrayText'
                    },
                    _a)
            },
            inlineLabel &&
                !onOffMissing && {
                marginRight: 16
            },
            onOffMissing &&
                inlineLabel && {
                order: 1,
                marginLeft: 16
            }
        ],
        container: [
            'ms-Toggle-innerContainer',
            {
                display: 'inline-flex',
                position: 'relative'
            }
        ],
        pill: [
            'ms-Toggle-background',
            Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["v" /* getFocusStyle */])(theme, { inset: -3 }),
            {
                fontSize: '20px',
                boxSizing: 'border-box',
                width: '2.2em',
                height: '1em',
                borderRadius: '1em',
                transition: 'all 0.1s ease',
                borderWidth: '1px',
                borderStyle: 'solid',
                background: pillUncheckedBackground,
                borderColor: pillBorderColor,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                padding: '0 .2em'
            },
            !disabled && [
                !checked && {
                    selectors: {
                        ':hover': [
                            {
                                borderColor: pillBorderHoveredColor
                            }
                        ],
                        ':hover .ms-Toggle-thumb': [
                            {
                                selectors: (_b = {},
                                    _b[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                                        borderColor: 'Highlight'
                                    },
                                    _b)
                            }
                        ]
                    }
                },
                checked && [
                    {
                        background: pillCheckedBackground,
                        borderColor: 'transparent',
                        justifyContent: 'flex-end'
                    },
                    {
                        selectors: (_c = {
                                ':hover': [
                                    {
                                        backgroundColor: pillCheckedHoveredBackground,
                                        borderColor: 'transparent',
                                        selectors: (_d = {},
                                            _d[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                                                backgroundColor: 'Highlight'
                                            },
                                            _d)
                                    }
                                ]
                            },
                            _c[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                                backgroundColor: 'WindowText'
                            },
                            _c)
                    }
                ]
            ],
            disabled && [
                {
                    cursor: 'default'
                },
                !checked && [
                    {
                        borderColor: pillBorderDisabledColor
                    }
                ],
                checked && [
                    {
                        backgroundColor: pillCheckedDisabledBackground,
                        borderColor: 'transparent',
                        justifyContent: 'flex-end'
                    }
                ]
            ],
            !disabled && {
                selectors: {
                    '&:hover': {
                        selectors: (_e = {},
                            _e[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                                borderColor: 'Highlight'
                            },
                            _e)
                    }
                }
            }
        ],
        thumb: [
            'ms-Toggle-thumb',
            {
                width: '.5em',
                height: '.5em',
                borderRadius: '.5em',
                transition: 'all 0.1s ease',
                backgroundColor: thumbBackground,
                /* Border is added to handle high contrast mode for Firefox */
                borderColor: 'transparent',
                borderWidth: '.28em',
                borderStyle: 'solid',
                boxSizing: 'border-box'
            },
            !disabled &&
                checked && [
                {
                    backgroundColor: thumbCheckedBackground,
                    selectors: (_f = {},
                        _f[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                            backgroundColor: 'Window',
                            borderColor: 'Window'
                        },
                        _f)
                }
            ],
            disabled && [
                !checked && [
                    {
                        backgroundColor: thumbDisabledBackground
                    }
                ],
                checked && [
                    {
                        backgroundColor: thumbCheckedDisabledBackground
                    }
                ]
            ]
        ],
        text: [
            'ms-Toggle-stateText',
            {
                selectors: {
                    // Workaround: make rules more specific than Label rules.
                    '&&': {
                        padding: '0',
                        margin: '0 8px',
                        userSelect: 'none'
                    }
                }
            },
            disabled && {
                selectors: {
                    '&&': {
                        color: textDisabledColor,
                        selectors: (_g = {},
                            _g[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                                color: 'GrayText'
                            },
                            _g)
                    }
                }
            }
        ]
    };
    var _a, _b, _c, _d, _e, _f, _g;
};
//# sourceMappingURL=Toggle.styles.js.map

/***/ }),
/* 1784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_src_app_components_dynamicImport__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RoundDurationEditDefault__ = __webpack_require__(2085);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RoundDurationEditContent=Object(__WEBPACK_IMPORTED_MODULE_0__build_src_app_components_dynamicImport__["b" /* default */])({component:'/containers/Sale/RoundSection/RoundDurationEdit',fallback:__WEBPACK_IMPORTED_MODULE_2__RoundDurationEditDefault__["a" /* default */]});var RoundDurationEdit=(_temp=_class=function(_Component){_inherits(RoundDurationEdit,_Component);function RoundDurationEdit(){_classCallCheck(this,RoundDurationEdit);return _possibleConstructorReturn(this,(RoundDurationEdit.__proto__||Object.getPrototypeOf(RoundDurationEdit)).apply(this,arguments));}_createClass(RoundDurationEdit,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(RoundDurationEditContent,this.props);}}]);return RoundDurationEdit;}(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__["Component"]),_class.displayName='RoundDurationEdit',_temp);/* harmony default export */ __webpack_exports__["a"] = (RoundDurationEdit);

/***/ }),
/* 1785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED */
/* unused harmony export lazy */
/* unused harmony export loadableReady */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(1786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(1787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(1788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_is__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics__);








/* eslint-disable import/prefer-default-export */
function invariant(condition, message) {
  if (condition) return;
  var error = new Error("loadable: " + message);
  error.framesToPop = 1;
  error.name = 'Invariant Violation';
  throw error;
}
function warn(message) {
  // eslint-disable-next-line no-console
  console.warn("loadable: " + message);
}

var Context = /*#__PURE__*/
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext();

var LOADABLE_REQUIRED_CHUNKS_KEY = '__LOADABLE_REQUIRED_CHUNKS__';
function getRequiredChunkKey(namespace) {
  return "" + namespace + LOADABLE_REQUIRED_CHUNKS_KEY;
}

var sharedInternals = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getRequiredChunkKey: getRequiredChunkKey,
  invariant: invariant,
  Context: Context
});

var LOADABLE_SHARED = {
  initialChunks: {}
};

var STATUS_PENDING = 'PENDING';
var STATUS_RESOLVED = 'RESOLVED';
var STATUS_REJECTED = 'REJECTED';

function resolveConstructor(ctor) {
  if (typeof ctor === 'function') {
    return {
      requireAsync: ctor,
      resolve: function resolve() {
        return undefined;
      },
      chunkName: function chunkName() {
        return undefined;
      }
    };
  }

  return ctor;
}

var withChunkExtractor = function withChunkExtractor(Component) {
  var LoadableWithChunkExtractor = function LoadableWithChunkExtractor(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Context.Consumer, null, function (extractor) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, Object.assign({
        __chunkExtractor: extractor
      }, props));
    });
  };

  if (Component.displayName) {
    LoadableWithChunkExtractor.displayName = Component.displayName + "WithChunkExtractor";
  }

  return LoadableWithChunkExtractor;
};

var identity = function identity(v) {
  return v;
};

function createLoadable(_ref) {
  var _ref$defaultResolveCo = _ref.defaultResolveComponent,
      defaultResolveComponent = _ref$defaultResolveCo === void 0 ? identity : _ref$defaultResolveCo,
      _render = _ref.render,
      onLoad = _ref.onLoad;

  function loadable(loadableConstructor, options) {
    if (options === void 0) {
      options = {};
    }

    var ctor = resolveConstructor(loadableConstructor);
    var cache = {};
    /**
     * Cachekey represents the component to be loaded
     * if key changes - component has to be reloaded
     * @param props
     * @returns {null|Component}
     */

    function _getCacheKey(props) {
      if (options.cacheKey) {
        return options.cacheKey(props);
      }

      if (ctor.resolve) {
        return ctor.resolve(props);
      }

      return 'static';
    }
    /**
     * Resolves loaded `module` to a specific `Component
     * @param module
     * @param props
     * @param Loadable
     * @returns Component
     */


    function resolve(module, props, Loadable) {
      var Component = options.resolveComponent ? options.resolveComponent(module, props) : defaultResolveComponent(module);

      if (options.resolveComponent && !Object(__WEBPACK_IMPORTED_MODULE_5_react_is__["isValidElementType"])(Component)) {
        throw new Error("resolveComponent returned something that is not a React component!");
      }

      __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics___default()(Loadable, Component, {
        preload: true
      });
      return Component;
    }

    var InnerLoadable =
    /*#__PURE__*/
    function (_React$Component) {
      Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(InnerLoadable, _React$Component);

      InnerLoadable.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        var cacheKey = _getCacheKey(props);

        return Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state, {
          cacheKey: cacheKey,
          // change of a key triggers loading state automatically
          loading: state.loading || state.cacheKey !== cacheKey
        });
      };

      function InnerLoadable(props) {
        var _this;

        _this = _React$Component.call(this, props) || this;
        _this.state = {
          result: null,
          error: null,
          loading: true,
          cacheKey: _getCacheKey(props)
        };
        invariant(!props.__chunkExtractor || ctor.requireSync, 'SSR requires `@loadable/babel-plugin`, please install it'); // Server-side

        if (props.__chunkExtractor) {
          // This module has been marked with no SSR
          if (options.ssr === false) {
            return Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this);
          } // We run load function, we assume that it won't fail and that it
          // triggers a synchronous loading of the module


          ctor.requireAsync(props)["catch"](function () {
            return null;
          }); // So we can require now the module synchronously

          _this.loadSync();

          props.__chunkExtractor.addChunk(ctor.chunkName(props));

          return Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this);
        } // Client-side with `isReady` method present (SSR probably)
        // If module is already loaded, we use a synchronous loading
        // Only perform this synchronous loading if the component has not
        // been marked with no SSR, else we risk hydration mismatches


        if (options.ssr !== false && ( // is ready - was loaded in this session
        ctor.isReady && ctor.isReady(props) || // is ready - was loaded during SSR process
        ctor.chunkName && LOADABLE_SHARED.initialChunks[ctor.chunkName(props)])) {
          _this.loadSync();
        }

        return _this;
      }

      var _proto = InnerLoadable.prototype;

      _proto.componentDidMount = function componentDidMount() {
        this.mounted = true; // retrieve loading promise from a global cache

        var cachedPromise = this.getCache(); // if promise exists, but rejected - clear cache

        if (cachedPromise && cachedPromise.status === STATUS_REJECTED) {
          this.setCache();
        } // component might be resolved synchronously in the constructor


        if (this.state.loading) {
          this.loadAsync();
        }
      };

      _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        // Component has to be reloaded on cacheKey change
        if (prevState.cacheKey !== this.state.cacheKey) {
          this.loadAsync();
        }
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
      };

      _proto.safeSetState = function safeSetState(nextState, callback) {
        if (this.mounted) {
          this.setState(nextState, callback);
        }
      }
      /**
       * returns a cache key for the current props
       * @returns {Component|string}
       */
      ;

      _proto.getCacheKey = function getCacheKey() {
        return _getCacheKey(this.props);
      }
      /**
       * access the persistent cache
       */
      ;

      _proto.getCache = function getCache() {
        return cache[this.getCacheKey()];
      }
      /**
       * sets the cache value. If called without value sets it as undefined
       */
      ;

      _proto.setCache = function setCache(value) {
        if (value === void 0) {
          value = undefined;
        }

        cache[this.getCacheKey()] = value;
      };

      _proto.triggerOnLoad = function triggerOnLoad() {
        var _this2 = this;

        if (onLoad) {
          setTimeout(function () {
            onLoad(_this2.state.result, _this2.props);
          });
        }
      }
      /**
       * Synchronously loads component
       * target module is expected to already exists in the module cache
       * or be capable to resolve synchronously (webpack target=node)
       */
      ;

      _proto.loadSync = function loadSync() {
        // load sync is expecting component to be in the "loading" state already
        // sounds weird, but loading=true is the initial state of InnerLoadable
        if (!this.state.loading) return;

        try {
          var loadedModule = ctor.requireSync(this.props);
          var result = resolve(loadedModule, this.props, Loadable);
          this.state.result = result;
          this.state.loading = false;
        } catch (error) {
          console.error('loadable-components: failed to synchronously load component, which expected to be available', {
            fileName: ctor.resolve(this.props),
            chunkName: ctor.chunkName(this.props),
            error: error ? error.message : error
          });
          this.state.error = error;
        }
      }
      /**
       * Asynchronously loads a component.
       */
      ;

      _proto.loadAsync = function loadAsync() {
        var _this3 = this;

        var promise = this.resolveAsync();
        promise.then(function (loadedModule) {
          var result = resolve(loadedModule, _this3.props, {
            Loadable: Loadable
          });

          _this3.safeSetState({
            result: result,
            loading: false
          }, function () {
            return _this3.triggerOnLoad();
          });
        })["catch"](function (error) {
          return _this3.safeSetState({
            error: error,
            loading: false
          });
        });
        return promise;
      }
      /**
       * Asynchronously resolves(not loads) a component.
       * Note - this function does not change the state
       */
      ;

      _proto.resolveAsync = function resolveAsync() {
        var _this4 = this;

        var _this$props = this.props,
            __chunkExtractor = _this$props.__chunkExtractor,
            forwardedRef = _this$props.forwardedRef,
            props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["__chunkExtractor", "forwardedRef"]);

        var promise = this.getCache();

        if (!promise) {
          promise = ctor.requireAsync(props);
          promise.status = STATUS_PENDING;
          this.setCache(promise);
          promise.then(function () {
            promise.status = STATUS_RESOLVED;
          }, function (error) {
            console.error('loadable-components: failed to asynchronously load component', {
              fileName: ctor.resolve(_this4.props),
              chunkName: ctor.chunkName(_this4.props),
              error: error ? error.message : error
            });
            promise.status = STATUS_REJECTED;
          });
        }

        return promise;
      };

      _proto.render = function render() {
        var _this$props2 = this.props,
            forwardedRef = _this$props2.forwardedRef,
            propFallback = _this$props2.fallback,
            __chunkExtractor = _this$props2.__chunkExtractor,
            props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["forwardedRef", "fallback", "__chunkExtractor"]);

        var _this$state = this.state,
            error = _this$state.error,
            loading = _this$state.loading,
            result = _this$state.result;

        if (options.suspense) {
          var cachedPromise = this.getCache() || this.loadAsync();

          if (cachedPromise.status === STATUS_PENDING) {
            throw this.loadAsync();
          }
        }

        if (error) {
          throw error;
        }

        var fallback = propFallback || options.fallback || null;

        if (loading) {
          return fallback;
        }

        return _render({
          fallback: fallback,
          result: result,
          options: options,
          props: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
            ref: forwardedRef
          })
        });
      };

      return InnerLoadable;
    }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

    var EnhancedInnerLoadable = withChunkExtractor(InnerLoadable);
    var Loadable = __WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(function (props, ref) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EnhancedInnerLoadable, Object.assign({
        forwardedRef: ref
      }, props));
    });
    Loadable.displayName = 'Loadable'; // In future, preload could use `<link rel="preload">`

    Loadable.preload = function (props) {
      ctor.requireAsync(props);
    };

    Loadable.load = function (props) {
      return ctor.requireAsync(props);
    };

    return Loadable;
  }

  function lazy(ctor, options) {
    return loadable(ctor, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      suspense: true
    }));
  }

  return {
    loadable: loadable,
    lazy: lazy
  };
}

function defaultResolveComponent(loadedModule) {
  // eslint-disable-next-line no-underscore-dangle
  return loadedModule.__esModule ? loadedModule["default"] : loadedModule["default"] || loadedModule;
}

/* eslint-disable no-use-before-define, react/no-multi-comp */

var _createLoadable =
/*#__PURE__*/
createLoadable({
  defaultResolveComponent: defaultResolveComponent,
  render: function render(_ref) {
    var Component = _ref.result,
        props = _ref.props;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, props);
  }
}),
    loadable = _createLoadable.loadable,
    lazy = _createLoadable.lazy;

/* eslint-disable no-use-before-define, react/no-multi-comp */

var _createLoadable$1 =
/*#__PURE__*/
createLoadable({
  onLoad: function onLoad(result, props) {
    if (result && props.forwardedRef) {
      if (typeof props.forwardedRef === 'function') {
        props.forwardedRef(result);
      } else {
        props.forwardedRef.current = result;
      }
    }
  },
  render: function render(_ref) {
    var result = _ref.result,
        props = _ref.props;

    if (props.children) {
      return props.children(result);
    }

    return null;
  }
}),
    loadable$1 = _createLoadable$1.loadable,
    lazy$1 = _createLoadable$1.lazy;

/* eslint-disable no-underscore-dangle, camelcase */
var BROWSER = typeof window !== 'undefined';
function loadableReady(done, _temp) {
  if (done === void 0) {
    done = function done() {};
  }

  var _ref = _temp === void 0 ? {} : _temp,
      _ref$namespace = _ref.namespace,
      namespace = _ref$namespace === void 0 ? '' : _ref$namespace,
      _ref$chunkLoadingGlob = _ref.chunkLoadingGlobal,
      chunkLoadingGlobal = _ref$chunkLoadingGlob === void 0 ? '__LOADABLE_LOADED_CHUNKS__' : _ref$chunkLoadingGlob;

  if (!BROWSER) {
    warn('`loadableReady()` must be called in browser only');
    done();
    return Promise.resolve();
  }

  var requiredChunks = null;

  if (BROWSER) {
    var id = getRequiredChunkKey(namespace);
    var dataElement = document.getElementById(id);

    if (dataElement) {
      requiredChunks = JSON.parse(dataElement.textContent);
      var extElement = document.getElementById(id + "_ext");

      if (extElement) {
        var _JSON$parse = JSON.parse(extElement.textContent),
            namedChunks = _JSON$parse.namedChunks;

        namedChunks.forEach(function (chunkName) {
          LOADABLE_SHARED.initialChunks[chunkName] = true;
        });
      } else {
        // version mismatch
        throw new Error('loadable-component: @loadable/server does not match @loadable/component');
      }
    }
  }

  if (!requiredChunks) {
    warn('`loadableReady()` requires state, please use `getScriptTags` or `getScriptElements` server-side');
    done();
    return Promise.resolve();
  }

  var resolved = false;
  return new Promise(function (resolve) {
    window[chunkLoadingGlobal] = window[chunkLoadingGlobal] || [];
    var loadedChunks = window[chunkLoadingGlobal];
    var originalPush = loadedChunks.push.bind(loadedChunks);

    function checkReadyState() {
      if (requiredChunks.every(function (chunk) {
        return loadedChunks.some(function (_ref2) {
          var chunks = _ref2[0];
          return chunks.indexOf(chunk) > -1;
        });
      })) {
        if (!resolved) {
          resolved = true;
          resolve();
        }
      }
    }

    loadedChunks.push = function () {
      originalPush.apply(void 0, arguments);
      checkReadyState();
    };

    checkReadyState();
  }).then(done);
}

/* eslint-disable no-underscore-dangle */
var loadable$2 = loadable;
loadable$2.lib = loadable$1;
var lazy$2 = lazy;
lazy$2.lib = lazy$1;
var __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = sharedInternals;

/* harmony default export */ __webpack_exports__["a"] = (loadable$2);



/***/ }),
/* 1786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 1787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 1788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(1789);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 1789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),
/* 1790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Empty=function Empty(){return null;};/* harmony default export */ __webpack_exports__["a"] = (Empty);

/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./@amarc21/components/Logo": [
		303,
		31
	],
	"./@amarc21/components/Logo/": [
		303,
		31
	],
	"./@amarc21/components/Logo/index": [
		303,
		31
	],
	"./@amarc21/components/Logo/index.js": [
		303,
		31
	],
	"./@amarc21/config": [
		907,
		243
	],
	"./@amarc21/config.js": [
		907,
		243
	],
	"./@amarc21/containers/Overview/SaleCreatePanelContent": [
		1013,
		145
	],
	"./@amarc21/containers/Overview/SaleCreatePanelContent.jsx": [
		1013,
		145
	],
	"./@amarc21/containers/Sale/OffersSection/OfferDetails/AgentProvisionForm": [
		1014,
		242
	],
	"./@amarc21/containers/Sale/OffersSection/OfferDetails/AgentProvisionForm.jsx": [
		1014,
		242
	],
	"./@amarc21/containers/Sale/OffersSection/OfferDetails/BuyerDataForm": [
		1015,
		144
	],
	"./@amarc21/containers/Sale/OffersSection/OfferDetails/BuyerDataForm.jsx": [
		1015,
		144
	],
	"./@amarc21/containers/Sale/OffersSection/OfferDetails/CompanyDataForm": [
		1016,
		143
	],
	"./@amarc21/containers/Sale/OffersSection/OfferDetails/CompanyDataForm.jsx": [
		1016,
		143
	],
	"./@amarc21/containers/Sale/OffersSection/OfferDetails/OfferDetailsForm": [
		1017,
		241
	],
	"./@amarc21/containers/Sale/OffersSection/OfferDetails/OfferDetailsForm.jsx": [
		1017,
		241
	],
	"./@amarc21/containers/Sale/OffersSection/RefuseDialog": [
		1018,
		142
	],
	"./@amarc21/containers/Sale/OffersSection/RefuseDialog.jsx": [
		1018,
		142
	],
	"./@amarc21/containers/Sale/OffersSection/RegistrationPanel": [
		1019,
		60
	],
	"./@amarc21/containers/Sale/OffersSection/RegistrationPanel.jsx": [
		1019,
		60
	],
	"./@amarc21/containers/Sale/RoundSection/RoundPriceEdit": [
		1020,
		240
	],
	"./@amarc21/containers/Sale/RoundSection/RoundPriceEdit.jsx": [
		1020,
		240
	],
	"./@amarc21/containers/Sale/SaleEditSection/AgencyDataForm": [
		948,
		139
	],
	"./@amarc21/containers/Sale/SaleEditSection/AgencyDataForm.jsx": [
		948,
		139
	],
	"./@amarc21/containers/Sale/SaleEditSection/NotaryDataForm": [
		949,
		239
	],
	"./@amarc21/containers/Sale/SaleEditSection/NotaryDataForm.jsx": [
		949,
		239
	],
	"./@amarc21/containers/Sale/SaleEditSection/Page1": [
		1021,
		141
	],
	"./@amarc21/containers/Sale/SaleEditSection/Page1.jsx": [
		1021,
		141
	],
	"./@amarc21/containers/Sale/SaleEditSection/Page2": [
		1022,
		44
	],
	"./@amarc21/containers/Sale/SaleEditSection/Page2.jsx": [
		1022,
		44
	],
	"./@amarc21/containers/Sale/SaleEditSection/SellerDataForm": [
		950,
		238
	],
	"./@amarc21/containers/Sale/SaleEditSection/SellerDataForm.jsx": [
		950,
		238
	],
	"./@amarc21/containers/Sale/SaleEditSection/stores": [
		304,
		13
	],
	"./@amarc21/containers/Sale/SaleEditSection/stores/": [
		304,
		13
	],
	"./@amarc21/containers/Sale/SaleEditSection/stores/index": [
		304,
		13
	],
	"./@amarc21/containers/Sale/SaleEditSection/stores/index.js": [
		304,
		13
	],
	"./@amarc21/containers/Search/SearchPanelContent": [
		1023,
		140
	],
	"./@amarc21/containers/Search/SearchPanelContent.jsx": [
		1023,
		140
	],
	"./@amarc21/locales": [
		189
	],
	"./@amarc21/locales/": [
		189
	],
	"./@amarc21/locales/de": [
		441
	],
	"./@amarc21/locales/de.json": [
		441
	],
	"./@amarc21/locales/en": [
		442
	],
	"./@amarc21/locales/en.json": [
		442
	],
	"./@amarc21/locales/index": [
		189
	],
	"./@amarc21/locales/index.js": [
		189
	],
	"./@amarc21/theme": [
		1024,
		237
	],
	"./@amarc21/theme.js": [
		1024,
		237
	],
	"./@lbsi/components/Logo": [
		305,
		30
	],
	"./@lbsi/components/Logo/": [
		305,
		30
	],
	"./@lbsi/components/Logo/index": [
		305,
		30
	],
	"./@lbsi/components/Logo/index.js": [
		305,
		30
	],
	"./@lbsi/config": [
		913,
		236
	],
	"./@lbsi/config.js": [
		913,
		236
	],
	"./@lbsi/containers/Overview/SaleCreatePanelContent": [
		1025,
		138
	],
	"./@lbsi/containers/Overview/SaleCreatePanelContent.jsx": [
		1025,
		138
	],
	"./@lbsi/containers/Sale/OffersSection/OfferDetails/AgentProvisionForm": [
		1026,
		235
	],
	"./@lbsi/containers/Sale/OffersSection/OfferDetails/AgentProvisionForm.jsx": [
		1026,
		235
	],
	"./@lbsi/containers/Sale/OffersSection/OfferDetails/BuyerDataForm": [
		1027,
		92
	],
	"./@lbsi/containers/Sale/OffersSection/OfferDetails/BuyerDataForm.jsx": [
		1027,
		92
	],
	"./@lbsi/containers/Sale/OffersSection/OfferDetails/CompanyDataForm": [
		1028,
		234
	],
	"./@lbsi/containers/Sale/OffersSection/OfferDetails/CompanyDataForm.jsx": [
		1028,
		234
	],
	"./@lbsi/containers/Sale/OffersSection/OfferDetails/OfferDetailsForm": [
		1029,
		233
	],
	"./@lbsi/containers/Sale/OffersSection/OfferDetails/OfferDetailsForm.jsx": [
		1029,
		233
	],
	"./@lbsi/containers/Sale/OffersSection/RefuseDialog": [
		1030,
		137
	],
	"./@lbsi/containers/Sale/OffersSection/RefuseDialog.jsx": [
		1030,
		137
	],
	"./@lbsi/containers/Sale/OffersSection/RegistrationPanel": [
		1031,
		59
	],
	"./@lbsi/containers/Sale/OffersSection/RegistrationPanel.jsx": [
		1031,
		59
	],
	"./@lbsi/containers/Sale/RoundSection/RoundDurationEdit": [
		1032,
		136
	],
	"./@lbsi/containers/Sale/RoundSection/RoundDurationEdit.jsx": [
		1032,
		136
	],
	"./@lbsi/containers/Sale/RoundSection/RoundPriceEdit": [
		1034,
		232
	],
	"./@lbsi/containers/Sale/RoundSection/RoundPriceEdit.jsx": [
		1034,
		232
	],
	"./@lbsi/containers/Sale/SaleEditSection/Page1": [
		1035,
		135
	],
	"./@lbsi/containers/Sale/SaleEditSection/Page1.jsx": [
		1035,
		135
	],
	"./@lbsi/containers/Sale/SaleEditSection/stores": [
		306,
		29
	],
	"./@lbsi/containers/Sale/SaleEditSection/stores/": [
		306,
		29
	],
	"./@lbsi/containers/Sale/SaleEditSection/stores/index": [
		306,
		29
	],
	"./@lbsi/containers/Sale/SaleEditSection/stores/index.js": [
		306,
		29
	],
	"./@lbsi/containers/Search/SearchPanelContent": [
		1036,
		134
	],
	"./@lbsi/containers/Search/SearchPanelContent.jsx": [
		1036,
		134
	],
	"./@lbsi/locales": [
		190
	],
	"./@lbsi/locales/": [
		190
	],
	"./@lbsi/locales/de": [
		443
	],
	"./@lbsi/locales/de.json": [
		443
	],
	"./@lbsi/locales/en": [
		444
	],
	"./@lbsi/locales/en.json": [
		444
	],
	"./@lbsi/locales/index": [
		190
	],
	"./@lbsi/locales/index.js": [
		190
	],
	"./@lbsi/theme": [
		1037,
		231
	],
	"./@lbsi/theme.js": [
		1037,
		231
	],
	"./@propnow-developments/components/Logo": [
		313,
		28
	],
	"./@propnow-developments/components/Logo/": [
		313,
		28
	],
	"./@propnow-developments/components/Logo/index": [
		313,
		28
	],
	"./@propnow-developments/components/Logo/index.js": [
		313,
		28
	],
	"./@propnow-developments/config": [
		922,
		230
	],
	"./@propnow-developments/config.js": [
		922,
		230
	],
	"./@propnow-developments/containers/Overview/SaleCreatePanelContent": [
		1068,
		133
	],
	"./@propnow-developments/containers/Overview/SaleCreatePanelContent.jsx": [
		1068,
		133
	],
	"./@propnow-developments/containers/Sale/OffersSection/OfferDetails/AgentProvisionForm": [
		1069,
		229
	],
	"./@propnow-developments/containers/Sale/OffersSection/OfferDetails/AgentProvisionForm.jsx": [
		1069,
		229
	],
	"./@propnow-developments/containers/Sale/OffersSection/OfferDetails/BuyerDataForm": [
		1070,
		91
	],
	"./@propnow-developments/containers/Sale/OffersSection/OfferDetails/BuyerDataForm.jsx": [
		1070,
		91
	],
	"./@propnow-developments/containers/Sale/OffersSection/OfferDetails/CompanyDataForm": [
		1071,
		132
	],
	"./@propnow-developments/containers/Sale/OffersSection/OfferDetails/CompanyDataForm.jsx": [
		1071,
		132
	],
	"./@propnow-developments/containers/Sale/OffersSection/OfferDetails/OfferDetailsForm": [
		1072,
		228
	],
	"./@propnow-developments/containers/Sale/OffersSection/OfferDetails/OfferDetailsForm.jsx": [
		1072,
		228
	],
	"./@propnow-developments/containers/Sale/OffersSection/RefuseDialog": [
		1073,
		131
	],
	"./@propnow-developments/containers/Sale/OffersSection/RefuseDialog.jsx": [
		1073,
		131
	],
	"./@propnow-developments/containers/Sale/OffersSection/RegistrationPanel": [
		1074,
		58
	],
	"./@propnow-developments/containers/Sale/OffersSection/RegistrationPanel.jsx": [
		1074,
		58
	],
	"./@propnow-developments/containers/Sale/RoundSection/RoundPriceEdit": [
		1075,
		227
	],
	"./@propnow-developments/containers/Sale/RoundSection/RoundPriceEdit.jsx": [
		1075,
		227
	],
	"./@propnow-developments/containers/Sale/SaleEditSection/Page1": [
		1076,
		226
	],
	"./@propnow-developments/containers/Sale/SaleEditSection/Page1.jsx": [
		1076,
		226
	],
	"./@propnow-developments/containers/Sale/SaleEditSection/Page2": [
		1077,
		84
	],
	"./@propnow-developments/containers/Sale/SaleEditSection/Page2.jsx": [
		1077,
		84
	],
	"./@propnow-developments/containers/Sale/SaleEditSection/stores": [
		314,
		27
	],
	"./@propnow-developments/containers/Sale/SaleEditSection/stores/": [
		314,
		27
	],
	"./@propnow-developments/containers/Sale/SaleEditSection/stores/index": [
		314,
		27
	],
	"./@propnow-developments/containers/Sale/SaleEditSection/stores/index.js": [
		314,
		27
	],
	"./@propnow-developments/containers/Search/SearchPanelContent": [
		1078,
		130
	],
	"./@propnow-developments/containers/Search/SearchPanelContent.jsx": [
		1078,
		130
	],
	"./@propnow-developments/locales": [
		205
	],
	"./@propnow-developments/locales/": [
		205
	],
	"./@propnow-developments/locales/de": [
		463
	],
	"./@propnow-developments/locales/de.json": [
		463
	],
	"./@propnow-developments/locales/en": [
		464
	],
	"./@propnow-developments/locales/en.json": [
		464
	],
	"./@propnow-developments/locales/index": [
		205
	],
	"./@propnow-developments/locales/index.js": [
		205
	],
	"./@propnow-developments/theme": [
		1079,
		225
	],
	"./@propnow-developments/theme.js": [
		1079,
		225
	],
	"./@propnow/components/Address": [
		293,
		12
	],
	"./@propnow/components/Address/": [
		293,
		12
	],
	"./@propnow/components/Address/_default": [
		288,
		0
	],
	"./@propnow/components/Address/_default/": [
		288,
		0
	],
	"./@propnow/components/Address/_default/index": [
		288,
		0
	],
	"./@propnow/components/Address/_default/index.jsx": [
		288,
		0
	],
	"./@propnow/components/Address/_es": [
		289,
		3
	],
	"./@propnow/components/Address/_es/": [
		289,
		3
	],
	"./@propnow/components/Address/_es/index": [
		289,
		3
	],
	"./@propnow/components/Address/_es/index.jsx": [
		289,
		3
	],
	"./@propnow/components/Address/_it": [
		290,
		2
	],
	"./@propnow/components/Address/_it/": [
		290,
		2
	],
	"./@propnow/components/Address/_it/index": [
		290,
		2
	],
	"./@propnow/components/Address/_it/index.jsx": [
		290,
		2
	],
	"./@propnow/components/Address/_za": [
		291,
		1
	],
	"./@propnow/components/Address/_za/": [
		291,
		1
	],
	"./@propnow/components/Address/_za/index": [
		291,
		1
	],
	"./@propnow/components/Address/_za/index.jsx": [
		291,
		1
	],
	"./@propnow/components/Address/index": [
		293,
		12
	],
	"./@propnow/components/Address/index.jsx": [
		293,
		12
	],
	"./@propnow/components/Logo": [
		307,
		26
	],
	"./@propnow/components/Logo/": [
		307,
		26
	],
	"./@propnow/components/Logo/index": [
		307,
		26
	],
	"./@propnow/components/Logo/index.js": [
		307,
		26
	],
	"./@propnow/config": [
		104
	],
	"./@propnow/config.js": [
		104
	],
	"./@propnow/containers/Overview/SaleCreatePanelContent": [
		1038,
		224
	],
	"./@propnow/containers/Overview/SaleCreatePanelContent.jsx": [
		1038,
		224
	],
	"./@propnow/containers/Sale/OffersSection/OfferDetails/AgentProvisionForm": [
		1039,
		223
	],
	"./@propnow/containers/Sale/OffersSection/OfferDetails/AgentProvisionForm.jsx": [
		1039,
		223
	],
	"./@propnow/containers/Sale/OffersSection/OfferDetails/BuyerDataForm": [
		1040,
		35
	],
	"./@propnow/containers/Sale/OffersSection/OfferDetails/BuyerDataForm.jsx": [
		1040,
		35
	],
	"./@propnow/containers/Sale/OffersSection/OfferDetails/CompanyDataForm": [
		1041,
		222
	],
	"./@propnow/containers/Sale/OffersSection/OfferDetails/CompanyDataForm.jsx": [
		1041,
		222
	],
	"./@propnow/containers/Sale/OffersSection/OfferDetails/OfferDetailsForm": [
		1042,
		38
	],
	"./@propnow/containers/Sale/OffersSection/OfferDetails/OfferDetailsForm.jsx": [
		1042,
		38
	],
	"./@propnow/containers/Sale/OffersSection/RefuseDialog": [
		1043,
		221
	],
	"./@propnow/containers/Sale/OffersSection/RefuseDialog.jsx": [
		1043,
		221
	],
	"./@propnow/containers/Sale/OffersSection/RegistrationPanel": [
		1044,
		34
	],
	"./@propnow/containers/Sale/OffersSection/RegistrationPanel.jsx": [
		1044,
		34
	],
	"./@propnow/containers/Sale/OffersSection/_at/OfferDetails/BuyerDataForm": [
		951,
		129
	],
	"./@propnow/containers/Sale/OffersSection/_at/OfferDetails/BuyerDataForm.jsx": [
		951,
		129
	],
	"./@propnow/containers/Sale/OffersSection/_at/OfferDetails/OfferDetailsForm": [
		960,
		220
	],
	"./@propnow/containers/Sale/OffersSection/_at/OfferDetails/OfferDetailsForm.jsx": [
		960,
		220
	],
	"./@propnow/containers/Sale/OffersSection/_at/RegistrationPanel": [
		968,
		76
	],
	"./@propnow/containers/Sale/OffersSection/_at/RegistrationPanel.jsx": [
		968,
		76
	],
	"./@propnow/containers/Sale/OffersSection/_bsx/OfferDetails/BuyerDataForm": [
		1045,
		128
	],
	"./@propnow/containers/Sale/OffersSection/_bsx/OfferDetails/BuyerDataForm.jsx": [
		1045,
		128
	],
	"./@propnow/containers/Sale/OffersSection/_bsx/OfferDetails/OfferDetailsForm": [
		1046,
		219
	],
	"./@propnow/containers/Sale/OffersSection/_bsx/OfferDetails/OfferDetailsForm.jsx": [
		1046,
		219
	],
	"./@propnow/containers/Sale/OffersSection/_bsx/RegistrationPanel": [
		1047,
		75
	],
	"./@propnow/containers/Sale/OffersSection/_bsx/RegistrationPanel.jsx": [
		1047,
		75
	],
	"./@propnow/containers/Sale/OffersSection/_ch/OfferDetails/BuyerDataForm": [
		954,
		127
	],
	"./@propnow/containers/Sale/OffersSection/_ch/OfferDetails/BuyerDataForm.jsx": [
		954,
		127
	],
	"./@propnow/containers/Sale/OffersSection/_ch/OfferDetails/OfferDetailsForm": [
		963,
		218
	],
	"./@propnow/containers/Sale/OffersSection/_ch/OfferDetails/OfferDetailsForm.jsx": [
		963,
		218
	],
	"./@propnow/containers/Sale/OffersSection/_ch/RegistrationPanel": [
		969,
		74
	],
	"./@propnow/containers/Sale/OffersSection/_ch/RegistrationPanel.jsx": [
		969,
		74
	],
	"./@propnow/containers/Sale/OffersSection/_default/OfferDetails/BuyerDataForm": [
		953,
		126
	],
	"./@propnow/containers/Sale/OffersSection/_default/OfferDetails/BuyerDataForm.jsx": [
		953,
		126
	],
	"./@propnow/containers/Sale/OffersSection/_default/OfferDetails/OfferDetailsForm": [
		962,
		217
	],
	"./@propnow/containers/Sale/OffersSection/_default/OfferDetails/OfferDetailsForm.jsx": [
		962,
		217
	],
	"./@propnow/containers/Sale/OffersSection/_default/RegistrationPanel": [
		980,
		73
	],
	"./@propnow/containers/Sale/OffersSection/_default/RegistrationPanel.jsx": [
		980,
		73
	],
	"./@propnow/containers/Sale/OffersSection/_es/OfferDetails/BuyerDataForm": [
		957,
		216
	],
	"./@propnow/containers/Sale/OffersSection/_es/OfferDetails/BuyerDataForm.jsx": [
		957,
		216
	],
	"./@propnow/containers/Sale/OffersSection/_es/OfferDetails/CompanyDataForm": [
		1048,
		215
	],
	"./@propnow/containers/Sale/OffersSection/_es/OfferDetails/CompanyDataForm.jsx": [
		1048,
		215
	],
	"./@propnow/containers/Sale/OffersSection/_es/OfferDetails/OfferDetailsForm": [
		966,
		214
	],
	"./@propnow/containers/Sale/OffersSection/_es/OfferDetails/OfferDetailsForm.jsx": [
		966,
		214
	],
	"./@propnow/containers/Sale/OffersSection/_es/RegistrationPanel": [
		975,
		72
	],
	"./@propnow/containers/Sale/OffersSection/_es/RegistrationPanel.jsx": [
		975,
		72
	],
	"./@propnow/containers/Sale/OffersSection/_fi/OfferDetails/BuyerDataForm": [
		1049,
		125
	],
	"./@propnow/containers/Sale/OffersSection/_fi/OfferDetails/BuyerDataForm.jsx": [
		1049,
		125
	],
	"./@propnow/containers/Sale/OffersSection/_fi/OfferDetails/OfferDetailsForm": [
		1050,
		213
	],
	"./@propnow/containers/Sale/OffersSection/_fi/OfferDetails/OfferDetailsForm.jsx": [
		1050,
		213
	],
	"./@propnow/containers/Sale/OffersSection/_fi/RegistrationPanel": [
		972,
		71
	],
	"./@propnow/containers/Sale/OffersSection/_fi/RegistrationPanel.jsx": [
		972,
		71
	],
	"./@propnow/containers/Sale/OffersSection/_gb/OfferDetails/BuyerDataForm": [
		952,
		212
	],
	"./@propnow/containers/Sale/OffersSection/_gb/OfferDetails/BuyerDataForm.jsx": [
		952,
		212
	],
	"./@propnow/containers/Sale/OffersSection/_gb/OfferDetails/OfferDetailsForm": [
		961,
		211
	],
	"./@propnow/containers/Sale/OffersSection/_gb/OfferDetails/OfferDetailsForm.jsx": [
		961,
		211
	],
	"./@propnow/containers/Sale/OffersSection/_gb/RegistrationPanel": [
		970,
		70
	],
	"./@propnow/containers/Sale/OffersSection/_gb/RegistrationPanel.jsx": [
		970,
		70
	],
	"./@propnow/containers/Sale/OffersSection/_it/OfferDetails/BuyerDataForm": [
		958,
		210
	],
	"./@propnow/containers/Sale/OffersSection/_it/OfferDetails/BuyerDataForm.jsx": [
		958,
		210
	],
	"./@propnow/containers/Sale/OffersSection/_it/OfferDetails/CompanyDataForm": [
		1051,
		209
	],
	"./@propnow/containers/Sale/OffersSection/_it/OfferDetails/CompanyDataForm.jsx": [
		1051,
		209
	],
	"./@propnow/containers/Sale/OffersSection/_it/OfferDetails/OfferDetailsForm": [
		967,
		208
	],
	"./@propnow/containers/Sale/OffersSection/_it/OfferDetails/OfferDetailsForm.jsx": [
		967,
		208
	],
	"./@propnow/containers/Sale/OffersSection/_it/RegistrationPanel": [
		973,
		69
	],
	"./@propnow/containers/Sale/OffersSection/_it/RegistrationPanel.jsx": [
		973,
		69
	],
	"./@propnow/containers/Sale/OffersSection/_lu/OfferDetails/BuyerDataForm": [
		959,
		207
	],
	"./@propnow/containers/Sale/OffersSection/_lu/OfferDetails/BuyerDataForm.jsx": [
		959,
		207
	],
	"./@propnow/containers/Sale/OffersSection/_lu/OfferDetails/CompanyDataForm": [
		1052,
		206
	],
	"./@propnow/containers/Sale/OffersSection/_lu/OfferDetails/CompanyDataForm.jsx": [
		1052,
		206
	],
	"./@propnow/containers/Sale/OffersSection/_lu/OfferDetails/OfferDetailsForm": [
		1053,
		205
	],
	"./@propnow/containers/Sale/OffersSection/_lu/OfferDetails/OfferDetailsForm.jsx": [
		1053,
		205
	],
	"./@propnow/containers/Sale/OffersSection/_lu/RegistrationPanel": [
		979,
		68
	],
	"./@propnow/containers/Sale/OffersSection/_lu/RegistrationPanel.jsx": [
		979,
		68
	],
	"./@propnow/containers/Sale/OffersSection/_pr/OfferDetails/BuyerDataForm": [
		1054,
		124
	],
	"./@propnow/containers/Sale/OffersSection/_pr/OfferDetails/BuyerDataForm.jsx": [
		1054,
		124
	],
	"./@propnow/containers/Sale/OffersSection/_pr/OfferDetails/OfferDetailsForm": [
		1055,
		204
	],
	"./@propnow/containers/Sale/OffersSection/_pr/OfferDetails/OfferDetailsForm.jsx": [
		1055,
		204
	],
	"./@propnow/containers/Sale/OffersSection/_pr/RegistrationPanel": [
		978,
		67
	],
	"./@propnow/containers/Sale/OffersSection/_pr/RegistrationPanel.jsx": [
		978,
		67
	],
	"./@propnow/containers/Sale/OffersSection/_ro/OfferDetails/BuyerDataForm": [
		1056,
		123
	],
	"./@propnow/containers/Sale/OffersSection/_ro/OfferDetails/BuyerDataForm.jsx": [
		1056,
		123
	],
	"./@propnow/containers/Sale/OffersSection/_ro/OfferDetails/CompanyDataForm": [
		1057,
		203
	],
	"./@propnow/containers/Sale/OffersSection/_ro/OfferDetails/CompanyDataForm.jsx": [
		1057,
		203
	],
	"./@propnow/containers/Sale/OffersSection/_ro/OfferDetails/OfferDetailsForm": [
		1058,
		202
	],
	"./@propnow/containers/Sale/OffersSection/_ro/OfferDetails/OfferDetailsForm.jsx": [
		1058,
		202
	],
	"./@propnow/containers/Sale/OffersSection/_ro/RefuseDialog": [
		1059,
		201
	],
	"./@propnow/containers/Sale/OffersSection/_ro/RefuseDialog.jsx": [
		1059,
		201
	],
	"./@propnow/containers/Sale/OffersSection/_ro/RegistrationPanel": [
		977,
		66
	],
	"./@propnow/containers/Sale/OffersSection/_ro/RegistrationPanel.jsx": [
		977,
		66
	],
	"./@propnow/containers/Sale/OffersSection/_si/OfferDetails/BuyerDataForm": [
		955,
		122
	],
	"./@propnow/containers/Sale/OffersSection/_si/OfferDetails/BuyerDataForm.jsx": [
		955,
		122
	],
	"./@propnow/containers/Sale/OffersSection/_si/OfferDetails/OfferDetailsForm": [
		964,
		200
	],
	"./@propnow/containers/Sale/OffersSection/_si/OfferDetails/OfferDetailsForm.jsx": [
		964,
		200
	],
	"./@propnow/containers/Sale/OffersSection/_si/RegistrationPanel": [
		971,
		65
	],
	"./@propnow/containers/Sale/OffersSection/_si/RegistrationPanel.jsx": [
		971,
		65
	],
	"./@propnow/containers/Sale/OffersSection/_vi/OfferDetails/BuyerDataForm": [
		1060,
		121
	],
	"./@propnow/containers/Sale/OffersSection/_vi/OfferDetails/BuyerDataForm.jsx": [
		1060,
		121
	],
	"./@propnow/containers/Sale/OffersSection/_vi/OfferDetails/OfferDetailsForm": [
		1061,
		199
	],
	"./@propnow/containers/Sale/OffersSection/_vi/OfferDetails/OfferDetailsForm.jsx": [
		1061,
		199
	],
	"./@propnow/containers/Sale/OffersSection/_vi/RegistrationPanel": [
		976,
		64
	],
	"./@propnow/containers/Sale/OffersSection/_vi/RegistrationPanel.jsx": [
		976,
		64
	],
	"./@propnow/containers/Sale/OffersSection/_za/OfferDetails/BuyerDataForm": [
		956,
		83
	],
	"./@propnow/containers/Sale/OffersSection/_za/OfferDetails/BuyerDataForm.jsx": [
		956,
		83
	],
	"./@propnow/containers/Sale/OffersSection/_za/OfferDetails/OfferDetailsForm": [
		965,
		198
	],
	"./@propnow/containers/Sale/OffersSection/_za/OfferDetails/OfferDetailsForm.jsx": [
		965,
		198
	],
	"./@propnow/containers/Sale/OffersSection/_za/RegistrationPanel": [
		974,
		63
	],
	"./@propnow/containers/Sale/OffersSection/_za/RegistrationPanel.jsx": [
		974,
		63
	],
	"./@propnow/containers/Sale/SaleEditSection/Page1": [
		1062,
		33
	],
	"./@propnow/containers/Sale/SaleEditSection/Page1.jsx": [
		1062,
		33
	],
	"./@propnow/containers/Sale/SaleEditSection/Page2": [
		1063,
		32
	],
	"./@propnow/containers/Sale/SaleEditSection/Page2.jsx": [
		1063,
		32
	],
	"./@propnow/containers/Sale/SaleEditSection/_at/Page1": [
		981,
		197
	],
	"./@propnow/containers/Sale/SaleEditSection/_at/Page1.jsx": [
		981,
		197
	],
	"./@propnow/containers/Sale/SaleEditSection/_at/Page2": [
		996,
		196
	],
	"./@propnow/containers/Sale/SaleEditSection/_at/Page2.jsx": [
		996,
		196
	],
	"./@propnow/containers/Sale/SaleEditSection/_at/stores": [
		191
	],
	"./@propnow/containers/Sale/SaleEditSection/_at/stores/": [
		191
	],
	"./@propnow/containers/Sale/SaleEditSection/_at/stores/index": [
		191
	],
	"./@propnow/containers/Sale/SaleEditSection/_at/stores/index.js": [
		191
	],
	"./@propnow/containers/Sale/SaleEditSection/_bs/Page1": [
		982,
		195
	],
	"./@propnow/containers/Sale/SaleEditSection/_bs/Page1.jsx": [
		982,
		195
	],
	"./@propnow/containers/Sale/SaleEditSection/_bs/Page2": [
		1064,
		41
	],
	"./@propnow/containers/Sale/SaleEditSection/_bs/Page2.jsx": [
		1064,
		41
	],
	"./@propnow/containers/Sale/SaleEditSection/_bs/form": [
		300,
		10
	],
	"./@propnow/containers/Sale/SaleEditSection/_bs/form/": [
		300,
		10
	],
	"./@propnow/containers/Sale/SaleEditSection/_bs/form/SellerDataForm": [
		945,
		55
	],
	"./@propnow/containers/Sale/SaleEditSection/_bs/form/SellerDataForm.jsx": [
		945,
		55
	],
	"./@propnow/containers/Sale/SaleEditSection/_bs/form/SellerFormAddress": [
		923,
		120
	],
	"./@propnow/containers/Sale/SaleEditSection/_bs/form/SellerFormAddress.jsx": [
		923,
		120
	],
	"./@propnow/containers/Sale/SaleEditSection/_bs/form/SellerFormListItem": [
		939,
		89
	],
	"./@propnow/containers/Sale/SaleEditSection/_bs/form/SellerFormListItem.jsx": [
		939,
		89
	],
	"./@propnow/containers/Sale/SaleEditSection/_bs/form/SellerFromBase": [
		919,
		194
	],
	"./@propnow/containers/Sale/SaleEditSection/_bs/form/SellerFromBase.jsx": [
		919,
		194
	],
	"./@propnow/containers/Sale/SaleEditSection/_bs/form/index": [
		300,
		10
	],
	"./@propnow/containers/Sale/SaleEditSection/_bs/form/index.js": [
		300,
		10
	],
	"./@propnow/containers/Sale/SaleEditSection/_bs/stores": [
		308,
		25
	],
	"./@propnow/containers/Sale/SaleEditSection/_bs/stores/": [
		308,
		25
	],
	"./@propnow/containers/Sale/SaleEditSection/_bs/stores/index": [
		308,
		25
	],
	"./@propnow/containers/Sale/SaleEditSection/_bs/stores/index.js": [
		308,
		25
	],
	"./@propnow/containers/Sale/SaleEditSection/_ch/Page1": [
		983,
		193
	],
	"./@propnow/containers/Sale/SaleEditSection/_ch/Page1.jsx": [
		983,
		193
	],
	"./@propnow/containers/Sale/SaleEditSection/_ch/Page2": [
		997,
		119
	],
	"./@propnow/containers/Sale/SaleEditSection/_ch/Page2.jsx": [
		997,
		119
	],
	"./@propnow/containers/Sale/SaleEditSection/_ch/stores": [
		192
	],
	"./@propnow/containers/Sale/SaleEditSection/_ch/stores/": [
		192
	],
	"./@propnow/containers/Sale/SaleEditSection/_ch/stores/index": [
		192
	],
	"./@propnow/containers/Sale/SaleEditSection/_ch/stores/index.js": [
		192
	],
	"./@propnow/containers/Sale/SaleEditSection/_default/Page1": [
		994,
		192
	],
	"./@propnow/containers/Sale/SaleEditSection/_default/Page1.jsx": [
		994,
		192
	],
	"./@propnow/containers/Sale/SaleEditSection/_default/Page2": [
		1006,
		191
	],
	"./@propnow/containers/Sale/SaleEditSection/_default/Page2.jsx": [
		1006,
		191
	],
	"./@propnow/containers/Sale/SaleEditSection/_default/stores": [
		193
	],
	"./@propnow/containers/Sale/SaleEditSection/_default/stores/": [
		193
	],
	"./@propnow/containers/Sale/SaleEditSection/_default/stores/index": [
		193
	],
	"./@propnow/containers/Sale/SaleEditSection/_default/stores/index.js": [
		193
	],
	"./@propnow/containers/Sale/SaleEditSection/_es/Cadastral": [
		941,
		190
	],
	"./@propnow/containers/Sale/SaleEditSection/_es/Cadastral.jsx": [
		941,
		190
	],
	"./@propnow/containers/Sale/SaleEditSection/_es/Page1": [
		984,
		57
	],
	"./@propnow/containers/Sale/SaleEditSection/_es/Page1.jsx": [
		984,
		57
	],
	"./@propnow/containers/Sale/SaleEditSection/_es/Page2": [
		998,
		47
	],
	"./@propnow/containers/Sale/SaleEditSection/_es/Page2.jsx": [
		998,
		47
	],
	"./@propnow/containers/Sale/SaleEditSection/_es/cadastreFields": [
		162
	],
	"./@propnow/containers/Sale/SaleEditSection/_es/cadastreFields/": [
		162
	],
	"./@propnow/containers/Sale/SaleEditSection/_es/cadastreFields/index": [
		162
	],
	"./@propnow/containers/Sale/SaleEditSection/_es/cadastreFields/index.js": [
		162
	],
	"./@propnow/containers/Sale/SaleEditSection/_es/form": [
		295,
		11
	],
	"./@propnow/containers/Sale/SaleEditSection/_es/form/": [
		295,
		11
	],
	"./@propnow/containers/Sale/SaleEditSection/_es/form/SellerDataForm": [
		934,
		62
	],
	"./@propnow/containers/Sale/SaleEditSection/_es/form/SellerDataForm.jsx": [
		934,
		62
	],
	"./@propnow/containers/Sale/SaleEditSection/_es/form/SellerFormAddress": [
		914,
		118
	],
	"./@propnow/containers/Sale/SaleEditSection/_es/form/SellerFormAddress.jsx": [
		914,
		118
	],
	"./@propnow/containers/Sale/SaleEditSection/_es/form/SellerFormListItem": [
		927,
		88
	],
	"./@propnow/containers/Sale/SaleEditSection/_es/form/SellerFormListItem.jsx": [
		927,
		88
	],
	"./@propnow/containers/Sale/SaleEditSection/_es/form/SellerFromBase": [
		908,
		189
	],
	"./@propnow/containers/Sale/SaleEditSection/_es/form/SellerFromBase.jsx": [
		908,
		189
	],
	"./@propnow/containers/Sale/SaleEditSection/_es/form/index": [
		295,
		11
	],
	"./@propnow/containers/Sale/SaleEditSection/_es/form/index.js": [
		295,
		11
	],
	"./@propnow/containers/Sale/SaleEditSection/_es/stores": [
		194
	],
	"./@propnow/containers/Sale/SaleEditSection/_es/stores/": [
		194
	],
	"./@propnow/containers/Sale/SaleEditSection/_es/stores/index": [
		194
	],
	"./@propnow/containers/Sale/SaleEditSection/_es/stores/index.js": [
		194
	],
	"./@propnow/containers/Sale/SaleEditSection/_fi/Page1": [
		985,
		188
	],
	"./@propnow/containers/Sale/SaleEditSection/_fi/Page1.jsx": [
		985,
		188
	],
	"./@propnow/containers/Sale/SaleEditSection/_fi/Page2": [
		999,
		187
	],
	"./@propnow/containers/Sale/SaleEditSection/_fi/Page2.jsx": [
		999,
		187
	],
	"./@propnow/containers/Sale/SaleEditSection/_fi/stores": [
		195
	],
	"./@propnow/containers/Sale/SaleEditSection/_fi/stores/": [
		195
	],
	"./@propnow/containers/Sale/SaleEditSection/_fi/stores/index": [
		195
	],
	"./@propnow/containers/Sale/SaleEditSection/_fi/stores/index.js": [
		195
	],
	"./@propnow/containers/Sale/SaleEditSection/_gb/Page1": [
		986,
		186
	],
	"./@propnow/containers/Sale/SaleEditSection/_gb/Page1.jsx": [
		986,
		186
	],
	"./@propnow/containers/Sale/SaleEditSection/_gb/stores": [
		196
	],
	"./@propnow/containers/Sale/SaleEditSection/_gb/stores/": [
		196
	],
	"./@propnow/containers/Sale/SaleEditSection/_gb/stores/index": [
		196
	],
	"./@propnow/containers/Sale/SaleEditSection/_gb/stores/index.js": [
		196
	],
	"./@propnow/containers/Sale/SaleEditSection/_it/Cadastral": [
		942,
		185
	],
	"./@propnow/containers/Sale/SaleEditSection/_it/Cadastral.jsx": [
		942,
		185
	],
	"./@propnow/containers/Sale/SaleEditSection/_it/Page1": [
		987,
		56
	],
	"./@propnow/containers/Sale/SaleEditSection/_it/Page1.jsx": [
		987,
		56
	],
	"./@propnow/containers/Sale/SaleEditSection/_it/Page2": [
		1000,
		36
	],
	"./@propnow/containers/Sale/SaleEditSection/_it/Page2.jsx": [
		1000,
		36
	],
	"./@propnow/containers/Sale/SaleEditSection/_it/cadastreFields": [
		163
	],
	"./@propnow/containers/Sale/SaleEditSection/_it/cadastreFields/": [
		163
	],
	"./@propnow/containers/Sale/SaleEditSection/_it/cadastreFields/cadastreLandFields": [
		445
	],
	"./@propnow/containers/Sale/SaleEditSection/_it/cadastreFields/cadastreLandFields.js": [
		445
	],
	"./@propnow/containers/Sale/SaleEditSection/_it/cadastreFields/cadastreUrbanFields": [
		446
	],
	"./@propnow/containers/Sale/SaleEditSection/_it/cadastreFields/cadastreUrbanFields.js": [
		446
	],
	"./@propnow/containers/Sale/SaleEditSection/_it/cadastreFields/index": [
		163
	],
	"./@propnow/containers/Sale/SaleEditSection/_it/cadastreFields/index.js": [
		163
	],
	"./@propnow/containers/Sale/SaleEditSection/_it/form": [
		296,
		4
	],
	"./@propnow/containers/Sale/SaleEditSection/_it/form/": [
		296,
		4
	],
	"./@propnow/containers/Sale/SaleEditSection/_it/form/SellerDataForm": [
		935,
		43
	],
	"./@propnow/containers/Sale/SaleEditSection/_it/form/SellerDataForm.jsx": [
		935,
		43
	],
	"./@propnow/containers/Sale/SaleEditSection/_it/form/SellerFormAddress": [
		915,
		117
	],
	"./@propnow/containers/Sale/SaleEditSection/_it/form/SellerFormAddress.jsx": [
		915,
		117
	],
	"./@propnow/containers/Sale/SaleEditSection/_it/form/SellerFormListItem": [
		928,
		61
	],
	"./@propnow/containers/Sale/SaleEditSection/_it/form/SellerFormListItem.jsx": [
		928,
		61
	],
	"./@propnow/containers/Sale/SaleEditSection/_it/form/SellerFromBase": [
		909,
		184
	],
	"./@propnow/containers/Sale/SaleEditSection/_it/form/SellerFromBase.jsx": [
		909,
		184
	],
	"./@propnow/containers/Sale/SaleEditSection/_it/form/index": [
		296,
		4
	],
	"./@propnow/containers/Sale/SaleEditSection/_it/form/index.js": [
		296,
		4
	],
	"./@propnow/containers/Sale/SaleEditSection/_it/stores": [
		197
	],
	"./@propnow/containers/Sale/SaleEditSection/_it/stores/": [
		197
	],
	"./@propnow/containers/Sale/SaleEditSection/_it/stores/index": [
		197
	],
	"./@propnow/containers/Sale/SaleEditSection/_it/stores/index.js": [
		197
	],
	"./@propnow/containers/Sale/SaleEditSection/_lu/AgencyDataForm": [
		944,
		183
	],
	"./@propnow/containers/Sale/SaleEditSection/_lu/AgencyDataForm.jsx": [
		944,
		183
	],
	"./@propnow/containers/Sale/SaleEditSection/_lu/Page1": [
		988,
		182
	],
	"./@propnow/containers/Sale/SaleEditSection/_lu/Page1.jsx": [
		988,
		182
	],
	"./@propnow/containers/Sale/SaleEditSection/_lu/Page2": [
		1005,
		37
	],
	"./@propnow/containers/Sale/SaleEditSection/_lu/Page2.jsx": [
		1005,
		37
	],
	"./@propnow/containers/Sale/SaleEditSection/_lu/form": [
		299,
		9
	],
	"./@propnow/containers/Sale/SaleEditSection/_lu/form/": [
		299,
		9
	],
	"./@propnow/containers/Sale/SaleEditSection/_lu/form/SellerDataForm": [
		938,
		54
	],
	"./@propnow/containers/Sale/SaleEditSection/_lu/form/SellerDataForm.jsx": [
		938,
		54
	],
	"./@propnow/containers/Sale/SaleEditSection/_lu/form/SellerFormAddress": [
		918,
		116
	],
	"./@propnow/containers/Sale/SaleEditSection/_lu/form/SellerFormAddress.jsx": [
		918,
		116
	],
	"./@propnow/containers/Sale/SaleEditSection/_lu/form/SellerFormListItem": [
		931,
		81
	],
	"./@propnow/containers/Sale/SaleEditSection/_lu/form/SellerFormListItem.jsx": [
		931,
		81
	],
	"./@propnow/containers/Sale/SaleEditSection/_lu/form/SellerFromBase": [
		912,
		181
	],
	"./@propnow/containers/Sale/SaleEditSection/_lu/form/SellerFromBase.jsx": [
		912,
		181
	],
	"./@propnow/containers/Sale/SaleEditSection/_lu/form/index": [
		299,
		9
	],
	"./@propnow/containers/Sale/SaleEditSection/_lu/form/index.js": [
		299,
		9
	],
	"./@propnow/containers/Sale/SaleEditSection/_lu/stores": [
		198
	],
	"./@propnow/containers/Sale/SaleEditSection/_lu/stores/": [
		198
	],
	"./@propnow/containers/Sale/SaleEditSection/_lu/stores/index": [
		198
	],
	"./@propnow/containers/Sale/SaleEditSection/_lu/stores/index.js": [
		198
	],
	"./@propnow/containers/Sale/SaleEditSection/_pr/Page1": [
		989,
		180
	],
	"./@propnow/containers/Sale/SaleEditSection/_pr/Page1.jsx": [
		989,
		180
	],
	"./@propnow/containers/Sale/SaleEditSection/_pr/Page2": [
		1065,
		179
	],
	"./@propnow/containers/Sale/SaleEditSection/_pr/Page2.jsx": [
		1065,
		179
	],
	"./@propnow/containers/Sale/SaleEditSection/_pr/form": [
		309,
		8
	],
	"./@propnow/containers/Sale/SaleEditSection/_pr/form/": [
		309,
		8
	],
	"./@propnow/containers/Sale/SaleEditSection/_pr/form/SellerDataForm": [
		1007,
		53
	],
	"./@propnow/containers/Sale/SaleEditSection/_pr/form/SellerDataForm.jsx": [
		1007,
		53
	],
	"./@propnow/containers/Sale/SaleEditSection/_pr/form/SellerFormAddress": [
		932,
		115
	],
	"./@propnow/containers/Sale/SaleEditSection/_pr/form/SellerFormAddress.jsx": [
		932,
		115
	],
	"./@propnow/containers/Sale/SaleEditSection/_pr/form/SellerFormListItem": [
		946,
		87
	],
	"./@propnow/containers/Sale/SaleEditSection/_pr/form/SellerFormListItem.jsx": [
		946,
		87
	],
	"./@propnow/containers/Sale/SaleEditSection/_pr/form/SellerFromBase": [
		924,
		178
	],
	"./@propnow/containers/Sale/SaleEditSection/_pr/form/SellerFromBase.jsx": [
		924,
		178
	],
	"./@propnow/containers/Sale/SaleEditSection/_pr/form/index": [
		309,
		8
	],
	"./@propnow/containers/Sale/SaleEditSection/_pr/form/index.js": [
		309,
		8
	],
	"./@propnow/containers/Sale/SaleEditSection/_pr/stores": [
		199
	],
	"./@propnow/containers/Sale/SaleEditSection/_pr/stores/": [
		199
	],
	"./@propnow/containers/Sale/SaleEditSection/_pr/stores/index": [
		199
	],
	"./@propnow/containers/Sale/SaleEditSection/_pr/stores/index.js": [
		199
	],
	"./@propnow/containers/Sale/SaleEditSection/_ro/Page1": [
		990,
		177
	],
	"./@propnow/containers/Sale/SaleEditSection/_ro/Page1.jsx": [
		990,
		177
	],
	"./@propnow/containers/Sale/SaleEditSection/_ro/Page2": [
		1004,
		114
	],
	"./@propnow/containers/Sale/SaleEditSection/_ro/Page2.jsx": [
		1004,
		114
	],
	"./@propnow/containers/Sale/SaleEditSection/_ro/SellerDataForm": [
		943,
		176
	],
	"./@propnow/containers/Sale/SaleEditSection/_ro/SellerDataForm.jsx": [
		943,
		176
	],
	"./@propnow/containers/Sale/SaleEditSection/_ro/stores": [
		310,
		24
	],
	"./@propnow/containers/Sale/SaleEditSection/_ro/stores/": [
		310,
		24
	],
	"./@propnow/containers/Sale/SaleEditSection/_ro/stores/index": [
		310,
		24
	],
	"./@propnow/containers/Sale/SaleEditSection/_ro/stores/index.js": [
		310,
		24
	],
	"./@propnow/containers/Sale/SaleEditSection/_si/Page1": [
		991,
		175
	],
	"./@propnow/containers/Sale/SaleEditSection/_si/Page1.jsx": [
		991,
		175
	],
	"./@propnow/containers/Sale/SaleEditSection/_si/Page2": [
		1001,
		113
	],
	"./@propnow/containers/Sale/SaleEditSection/_si/Page2.jsx": [
		1001,
		113
	],
	"./@propnow/containers/Sale/SaleEditSection/_si/stores": [
		200
	],
	"./@propnow/containers/Sale/SaleEditSection/_si/stores/": [
		200
	],
	"./@propnow/containers/Sale/SaleEditSection/_si/stores/index": [
		200
	],
	"./@propnow/containers/Sale/SaleEditSection/_si/stores/index.js": [
		200
	],
	"./@propnow/containers/Sale/SaleEditSection/_vi/Page1": [
		992,
		174
	],
	"./@propnow/containers/Sale/SaleEditSection/_vi/Page1.jsx": [
		992,
		174
	],
	"./@propnow/containers/Sale/SaleEditSection/_vi/Page2": [
		1002,
		40
	],
	"./@propnow/containers/Sale/SaleEditSection/_vi/Page2.jsx": [
		1002,
		40
	],
	"./@propnow/containers/Sale/SaleEditSection/_vi/form": [
		297,
		7
	],
	"./@propnow/containers/Sale/SaleEditSection/_vi/form/": [
		297,
		7
	],
	"./@propnow/containers/Sale/SaleEditSection/_vi/form/SellerDataForm": [
		936,
		52
	],
	"./@propnow/containers/Sale/SaleEditSection/_vi/form/SellerDataForm.jsx": [
		936,
		52
	],
	"./@propnow/containers/Sale/SaleEditSection/_vi/form/SellerFormAddress": [
		916,
		112
	],
	"./@propnow/containers/Sale/SaleEditSection/_vi/form/SellerFormAddress.jsx": [
		916,
		112
	],
	"./@propnow/containers/Sale/SaleEditSection/_vi/form/SellerFormListItem": [
		929,
		86
	],
	"./@propnow/containers/Sale/SaleEditSection/_vi/form/SellerFormListItem.jsx": [
		929,
		86
	],
	"./@propnow/containers/Sale/SaleEditSection/_vi/form/SellerFromBase": [
		910,
		173
	],
	"./@propnow/containers/Sale/SaleEditSection/_vi/form/SellerFromBase.jsx": [
		910,
		173
	],
	"./@propnow/containers/Sale/SaleEditSection/_vi/form/index": [
		297,
		7
	],
	"./@propnow/containers/Sale/SaleEditSection/_vi/form/index.js": [
		297,
		7
	],
	"./@propnow/containers/Sale/SaleEditSection/_vi/stores": [
		201
	],
	"./@propnow/containers/Sale/SaleEditSection/_vi/stores/": [
		201
	],
	"./@propnow/containers/Sale/SaleEditSection/_vi/stores/index": [
		201
	],
	"./@propnow/containers/Sale/SaleEditSection/_vi/stores/index.js": [
		201
	],
	"./@propnow/containers/Sale/SaleEditSection/_za/Page1": [
		993,
		90
	],
	"./@propnow/containers/Sale/SaleEditSection/_za/Page1.jsx": [
		993,
		90
	],
	"./@propnow/containers/Sale/SaleEditSection/_za/Page2": [
		1003,
		42
	],
	"./@propnow/containers/Sale/SaleEditSection/_za/Page2.jsx": [
		1003,
		42
	],
	"./@propnow/containers/Sale/SaleEditSection/_za/form": [
		298,
		6
	],
	"./@propnow/containers/Sale/SaleEditSection/_za/form/": [
		298,
		6
	],
	"./@propnow/containers/Sale/SaleEditSection/_za/form/SellerDataForm": [
		937,
		48
	],
	"./@propnow/containers/Sale/SaleEditSection/_za/form/SellerDataForm.jsx": [
		937,
		48
	],
	"./@propnow/containers/Sale/SaleEditSection/_za/form/SellerFormAddress": [
		917,
		82
	],
	"./@propnow/containers/Sale/SaleEditSection/_za/form/SellerFormAddress.jsx": [
		917,
		82
	],
	"./@propnow/containers/Sale/SaleEditSection/_za/form/SellerFormListItem": [
		930,
		77
	],
	"./@propnow/containers/Sale/SaleEditSection/_za/form/SellerFormListItem.jsx": [
		930,
		77
	],
	"./@propnow/containers/Sale/SaleEditSection/_za/form/SellerFromBase": [
		911,
		172
	],
	"./@propnow/containers/Sale/SaleEditSection/_za/form/SellerFromBase.jsx": [
		911,
		172
	],
	"./@propnow/containers/Sale/SaleEditSection/_za/form/index": [
		298,
		6
	],
	"./@propnow/containers/Sale/SaleEditSection/_za/form/index.js": [
		298,
		6
	],
	"./@propnow/containers/Sale/SaleEditSection/_za/stores": [
		202
	],
	"./@propnow/containers/Sale/SaleEditSection/_za/stores/": [
		202
	],
	"./@propnow/containers/Sale/SaleEditSection/_za/stores/index": [
		202
	],
	"./@propnow/containers/Sale/SaleEditSection/_za/stores/index.js": [
		202
	],
	"./@propnow/containers/Sale/SaleEditSection/stores": [
		203
	],
	"./@propnow/containers/Sale/SaleEditSection/stores/": [
		203
	],
	"./@propnow/containers/Sale/SaleEditSection/stores/index": [
		203
	],
	"./@propnow/containers/Sale/SaleEditSection/stores/index.js": [
		203
	],
	"./@propnow/containers/Sale/SellerInviteSection": [
		312,
		22
	],
	"./@propnow/containers/Sale/SellerInviteSection/": [
		312,
		22
	],
	"./@propnow/containers/Sale/SellerInviteSection/_fi": [
		311,
		23
	],
	"./@propnow/containers/Sale/SellerInviteSection/_fi/": [
		311,
		23
	],
	"./@propnow/containers/Sale/SellerInviteSection/_fi/index": [
		311,
		23
	],
	"./@propnow/containers/Sale/SellerInviteSection/_fi/index.jsx": [
		311,
		23
	],
	"./@propnow/containers/Sale/SellerInviteSection/index": [
		312,
		22
	],
	"./@propnow/containers/Sale/SellerInviteSection/index.jsx": [
		312,
		22
	],
	"./@propnow/containers/Search/SearchPanelContent": [
		1067,
		171
	],
	"./@propnow/containers/Search/SearchPanelContent.jsx": [
		1067,
		171
	],
	"./@propnow/locales": [
		204
	],
	"./@propnow/locales/": [
		204
	],
	"./@propnow/locales/bhs/en": [
		447
	],
	"./@propnow/locales/bhs/en.json": [
		447
	],
	"./@propnow/locales/de": [
		449
	],
	"./@propnow/locales/de-CH": [
		448
	],
	"./@propnow/locales/de-CH.json": [
		448
	],
	"./@propnow/locales/de.json": [
		449
	],
	"./@propnow/locales/en": [
		453
	],
	"./@propnow/locales/en-GB": [
		450
	],
	"./@propnow/locales/en-GB.json": [
		450
	],
	"./@propnow/locales/en-US": [
		451
	],
	"./@propnow/locales/en-US.json": [
		451
	],
	"./@propnow/locales/en-ZA": [
		452
	],
	"./@propnow/locales/en-ZA.json": [
		452
	],
	"./@propnow/locales/en.json": [
		453
	],
	"./@propnow/locales/es": [
		454
	],
	"./@propnow/locales/es.json": [
		454
	],
	"./@propnow/locales/fi": [
		455
	],
	"./@propnow/locales/fi.json": [
		455
	],
	"./@propnow/locales/fr": [
		456
	],
	"./@propnow/locales/fr.json": [
		456
	],
	"./@propnow/locales/index": [
		204
	],
	"./@propnow/locales/index.js": [
		204
	],
	"./@propnow/locales/it": [
		457
	],
	"./@propnow/locales/it.json": [
		457
	],
	"./@propnow/locales/pri/en": [
		461
	],
	"./@propnow/locales/pri/en.json": [
		461
	],
	"./@propnow/locales/ro": [
		459
	],
	"./@propnow/locales/ro.json": [
		459
	],
	"./@propnow/locales/sl": [
		458
	],
	"./@propnow/locales/sl.json": [
		458
	],
	"./@propnow/locales/vir/en": [
		460
	],
	"./@propnow/locales/vir/en.json": [
		460
	],
	"./@propnow/locales/zaf/en": [
		462
	],
	"./@propnow/locales/zaf/en.json": [
		462
	],
	"./@propnow/theme": [
		392
	],
	"./@propnow/theme.js": [
		392
	],
	"./@remax-at/components/Logo": [
		315,
		21
	],
	"./@remax-at/components/Logo/": [
		315,
		21
	],
	"./@remax-at/components/Logo/index": [
		315,
		21
	],
	"./@remax-at/components/Logo/index.js": [
		315,
		21
	],
	"./@remax-at/config": [
		925,
		170
	],
	"./@remax-at/config.js": [
		925,
		170
	],
	"./@remax-at/containers/Overview/SaleCreatePanelContent": [
		1080,
		169
	],
	"./@remax-at/containers/Overview/SaleCreatePanelContent.jsx": [
		1080,
		169
	],
	"./@remax-at/containers/Sale/OffersSection/OfferDetails/AgentProvisionForm": [
		1008,
		111
	],
	"./@remax-at/containers/Sale/OffersSection/OfferDetails/AgentProvisionForm.jsx": [
		1008,
		111
	],
	"./@remax-at/containers/Sale/OffersSection/OfferDetails/BuyerDataForm": [
		1081,
		110
	],
	"./@remax-at/containers/Sale/OffersSection/OfferDetails/BuyerDataForm.jsx": [
		1081,
		110
	],
	"./@remax-at/containers/Sale/OffersSection/OfferDetails/CompanyDataForm": [
		1082,
		168
	],
	"./@remax-at/containers/Sale/OffersSection/OfferDetails/CompanyDataForm.jsx": [
		1082,
		168
	],
	"./@remax-at/containers/Sale/OffersSection/OfferDetails/OfferDetailsForm": [
		1083,
		167
	],
	"./@remax-at/containers/Sale/OffersSection/OfferDetails/OfferDetailsForm.jsx": [
		1083,
		167
	],
	"./@remax-at/containers/Sale/OffersSection/RefuseDialog": [
		1084,
		166
	],
	"./@remax-at/containers/Sale/OffersSection/RefuseDialog.jsx": [
		1084,
		166
	],
	"./@remax-at/containers/Sale/OffersSection/RegistrationPanel": [
		1085,
		46
	],
	"./@remax-at/containers/Sale/OffersSection/RegistrationPanel.jsx": [
		1085,
		46
	],
	"./@remax-at/containers/Sale/SaleEditSection/Page1": [
		1086,
		109
	],
	"./@remax-at/containers/Sale/SaleEditSection/Page1.jsx": [
		1086,
		109
	],
	"./@remax-at/containers/Sale/SaleEditSection/Page2": [
		1087,
		108
	],
	"./@remax-at/containers/Sale/SaleEditSection/Page2.jsx": [
		1087,
		108
	],
	"./@remax-at/containers/Sale/SaleEditSection/stores": [
		316,
		20
	],
	"./@remax-at/containers/Sale/SaleEditSection/stores/": [
		316,
		20
	],
	"./@remax-at/containers/Sale/SaleEditSection/stores/index": [
		316,
		20
	],
	"./@remax-at/containers/Sale/SaleEditSection/stores/index.js": [
		316,
		20
	],
	"./@remax-at/containers/Search/SearchPanelContent": [
		1088,
		165
	],
	"./@remax-at/containers/Search/SearchPanelContent.jsx": [
		1088,
		165
	],
	"./@remax-at/locales": [
		206
	],
	"./@remax-at/locales/": [
		206
	],
	"./@remax-at/locales/de": [
		465
	],
	"./@remax-at/locales/de.json": [
		465
	],
	"./@remax-at/locales/en": [
		466
	],
	"./@remax-at/locales/en.json": [
		466
	],
	"./@remax-at/locales/index": [
		206
	],
	"./@remax-at/locales/index.js": [
		206
	],
	"./@remax-at/theme": [
		1089,
		164
	],
	"./@remax-at/theme.js": [
		1089,
		164
	],
	"./@remax-de/components/Logo": [
		317,
		19
	],
	"./@remax-de/components/Logo/": [
		317,
		19
	],
	"./@remax-de/components/Logo/index": [
		317,
		19
	],
	"./@remax-de/components/Logo/index.js": [
		317,
		19
	],
	"./@remax-de/config": [
		920,
		163
	],
	"./@remax-de/config.js": [
		920,
		163
	],
	"./@remax-de/containers/Overview/SaleCreatePanelContent": [
		1090,
		107
	],
	"./@remax-de/containers/Overview/SaleCreatePanelContent.jsx": [
		1090,
		107
	],
	"./@remax-de/containers/Sale/OffersSection/OfferDetails/AgentProvisionForm": [
		1091,
		162
	],
	"./@remax-de/containers/Sale/OffersSection/OfferDetails/AgentProvisionForm.jsx": [
		1091,
		162
	],
	"./@remax-de/containers/Sale/OffersSection/OfferDetails/BuyerDataForm": [
		1092,
		106
	],
	"./@remax-de/containers/Sale/OffersSection/OfferDetails/BuyerDataForm.jsx": [
		1092,
		106
	],
	"./@remax-de/containers/Sale/OffersSection/OfferDetails/CompanyDataForm": [
		1093,
		161
	],
	"./@remax-de/containers/Sale/OffersSection/OfferDetails/CompanyDataForm.jsx": [
		1093,
		161
	],
	"./@remax-de/containers/Sale/OffersSection/OfferDetails/OfferDetailsForm": [
		1094,
		160
	],
	"./@remax-de/containers/Sale/OffersSection/OfferDetails/OfferDetailsForm.jsx": [
		1094,
		160
	],
	"./@remax-de/containers/Sale/OffersSection/RefuseDialog": [
		1095,
		105
	],
	"./@remax-de/containers/Sale/OffersSection/RefuseDialog.jsx": [
		1095,
		105
	],
	"./@remax-de/containers/Sale/OffersSection/RegistrationPanel": [
		1096,
		51
	],
	"./@remax-de/containers/Sale/OffersSection/RegistrationPanel.jsx": [
		1096,
		51
	],
	"./@remax-de/containers/Sale/SaleEditSection/Page1": [
		1097,
		104
	],
	"./@remax-de/containers/Sale/SaleEditSection/Page1.jsx": [
		1097,
		104
	],
	"./@remax-de/containers/Sale/SaleEditSection/Page2": [
		1098,
		80
	],
	"./@remax-de/containers/Sale/SaleEditSection/Page2.jsx": [
		1098,
		80
	],
	"./@remax-de/containers/Sale/SaleEditSection/stores": [
		318,
		18
	],
	"./@remax-de/containers/Sale/SaleEditSection/stores/": [
		318,
		18
	],
	"./@remax-de/containers/Sale/SaleEditSection/stores/index": [
		318,
		18
	],
	"./@remax-de/containers/Sale/SaleEditSection/stores/index.js": [
		318,
		18
	],
	"./@remax-de/containers/Search/SearchPanelContent": [
		1099,
		103
	],
	"./@remax-de/containers/Search/SearchPanelContent.jsx": [
		1099,
		103
	],
	"./@remax-de/locales": [
		207
	],
	"./@remax-de/locales/": [
		207
	],
	"./@remax-de/locales/de": [
		467
	],
	"./@remax-de/locales/de.json": [
		467
	],
	"./@remax-de/locales/en": [
		468
	],
	"./@remax-de/locales/en.json": [
		468
	],
	"./@remax-de/locales/index": [
		207
	],
	"./@remax-de/locales/index.js": [
		207
	],
	"./@remax-de/theme": [
		1100,
		159
	],
	"./@remax-de/theme.js": [
		1100,
		159
	],
	"./@remax-it/components/Logo": [
		319,
		17
	],
	"./@remax-it/components/Logo/": [
		319,
		17
	],
	"./@remax-it/components/Logo/index": [
		319,
		17
	],
	"./@remax-it/components/Logo/index.js": [
		319,
		17
	],
	"./@remax-it/config": [
		903,
		158
	],
	"./@remax-it/config.js": [
		903,
		158
	],
	"./@remax-it/containers/Overview/SaleCreatePanelContent": [
		1101,
		102
	],
	"./@remax-it/containers/Overview/SaleCreatePanelContent.jsx": [
		1101,
		102
	],
	"./@remax-it/containers/Sale/OffersSection/OfferDetails/BuyerDataForm": [
		1102,
		157
	],
	"./@remax-it/containers/Sale/OffersSection/OfferDetails/BuyerDataForm.jsx": [
		1102,
		157
	],
	"./@remax-it/containers/Sale/OffersSection/OfferDetails/CompanyDataForm": [
		1103,
		156
	],
	"./@remax-it/containers/Sale/OffersSection/OfferDetails/CompanyDataForm.jsx": [
		1103,
		156
	],
	"./@remax-it/containers/Sale/OffersSection/OfferDetails/OfferDetailsForm": [
		1104,
		155
	],
	"./@remax-it/containers/Sale/OffersSection/OfferDetails/OfferDetailsForm.jsx": [
		1104,
		155
	],
	"./@remax-it/containers/Sale/OffersSection/RefuseDialog": [
		1105,
		101
	],
	"./@remax-it/containers/Sale/OffersSection/RefuseDialog.jsx": [
		1105,
		101
	],
	"./@remax-it/containers/Sale/OffersSection/RegistrationPanel": [
		1106,
		50
	],
	"./@remax-it/containers/Sale/OffersSection/RegistrationPanel.jsx": [
		1106,
		50
	],
	"./@remax-it/containers/Sale/Prompts/OpenRoundConfirmation": [
		1107,
		154
	],
	"./@remax-it/containers/Sale/Prompts/OpenRoundConfirmation.jsx": [
		1107,
		154
	],
	"./@remax-it/containers/Sale/RoundSection/RoundPriceEdit": [
		1109,
		153
	],
	"./@remax-it/containers/Sale/RoundSection/RoundPriceEdit.jsx": [
		1109,
		153
	],
	"./@remax-it/containers/Sale/SaleEditSection/Page1": [
		1110,
		79
	],
	"./@remax-it/containers/Sale/SaleEditSection/Page1.jsx": [
		1110,
		79
	],
	"./@remax-it/containers/Sale/SaleEditSection/Page2": [
		1111,
		39
	],
	"./@remax-it/containers/Sale/SaleEditSection/Page2.jsx": [
		1111,
		39
	],
	"./@remax-it/containers/Sale/SaleEditSection/form": [
		301,
		5
	],
	"./@remax-it/containers/Sale/SaleEditSection/form/": [
		301,
		5
	],
	"./@remax-it/containers/Sale/SaleEditSection/form/SellerDataForm": [
		947,
		45
	],
	"./@remax-it/containers/Sale/SaleEditSection/form/SellerDataForm.jsx": [
		947,
		45
	],
	"./@remax-it/containers/Sale/SaleEditSection/form/SellerFormAddress": [
		926,
		99
	],
	"./@remax-it/containers/Sale/SaleEditSection/form/SellerFormAddress.jsx": [
		926,
		99
	],
	"./@remax-it/containers/Sale/SaleEditSection/form/SellerFormListItem": [
		940,
		78
	],
	"./@remax-it/containers/Sale/SaleEditSection/form/SellerFormListItem.jsx": [
		940,
		78
	],
	"./@remax-it/containers/Sale/SaleEditSection/form/SellerFromBase": [
		921,
		152
	],
	"./@remax-it/containers/Sale/SaleEditSection/form/SellerFromBase.jsx": [
		921,
		152
	],
	"./@remax-it/containers/Sale/SaleEditSection/form/index": [
		301,
		5
	],
	"./@remax-it/containers/Sale/SaleEditSection/form/index.js": [
		301,
		5
	],
	"./@remax-it/containers/Sale/SaleEditSection/stores": [
		320,
		16
	],
	"./@remax-it/containers/Sale/SaleEditSection/stores/": [
		320,
		16
	],
	"./@remax-it/containers/Sale/SaleEditSection/stores/index": [
		320,
		16
	],
	"./@remax-it/containers/Sale/SaleEditSection/stores/index.js": [
		320,
		16
	],
	"./@remax-it/containers/Search/SearchPanelContent": [
		1112,
		100
	],
	"./@remax-it/containers/Search/SearchPanelContent.jsx": [
		1112,
		100
	],
	"./@remax-it/locales": [
		209
	],
	"./@remax-it/locales/": [
		209
	],
	"./@remax-it/locales/en": [
		469
	],
	"./@remax-it/locales/en.json": [
		469
	],
	"./@remax-it/locales/index": [
		209
	],
	"./@remax-it/locales/index.js": [
		209
	],
	"./@remax-it/locales/it": [
		470
	],
	"./@remax-it/locales/it.json": [
		470
	],
	"./@remax-it/theme": [
		1113,
		151
	],
	"./@remax-it/theme.js": [
		1113,
		151
	],
	"./@remax-ro/components/Logo": [
		321,
		15
	],
	"./@remax-ro/components/Logo/": [
		321,
		15
	],
	"./@remax-ro/components/Logo/index": [
		321,
		15
	],
	"./@remax-ro/components/Logo/index.js": [
		321,
		15
	],
	"./@remax-ro/config": [
		906,
		150
	],
	"./@remax-ro/config.js": [
		906,
		150
	],
	"./@remax-ro/containers/Overview/SaleCreatePanelContent": [
		1114,
		98
	],
	"./@remax-ro/containers/Overview/SaleCreatePanelContent.jsx": [
		1114,
		98
	],
	"./@remax-ro/containers/Sale/OffersSection/OfferDetails/BuyerDataForm": [
		1115,
		97
	],
	"./@remax-ro/containers/Sale/OffersSection/OfferDetails/BuyerDataForm.jsx": [
		1115,
		97
	],
	"./@remax-ro/containers/Sale/OffersSection/OfferDetails/CompanyDataForm": [
		1116,
		149
	],
	"./@remax-ro/containers/Sale/OffersSection/OfferDetails/CompanyDataForm.jsx": [
		1116,
		149
	],
	"./@remax-ro/containers/Sale/OffersSection/OfferDetails/OfferDetailsForm": [
		1117,
		148
	],
	"./@remax-ro/containers/Sale/OffersSection/OfferDetails/OfferDetailsForm.jsx": [
		1117,
		148
	],
	"./@remax-ro/containers/Sale/OffersSection/RefuseDialog": [
		1118,
		96
	],
	"./@remax-ro/containers/Sale/OffersSection/RefuseDialog.jsx": [
		1118,
		96
	],
	"./@remax-ro/containers/Sale/OffersSection/RegistrationPanel": [
		1119,
		49
	],
	"./@remax-ro/containers/Sale/OffersSection/RegistrationPanel.jsx": [
		1119,
		49
	],
	"./@remax-ro/containers/Sale/RoundSection/RoundPriceEdit": [
		1120,
		147
	],
	"./@remax-ro/containers/Sale/RoundSection/RoundPriceEdit.jsx": [
		1120,
		147
	],
	"./@remax-ro/containers/Sale/SaleEditSection/Page1": [
		1121,
		95
	],
	"./@remax-ro/containers/Sale/SaleEditSection/Page1.jsx": [
		1121,
		95
	],
	"./@remax-ro/containers/Sale/SaleEditSection/Page2": [
		1122,
		85
	],
	"./@remax-ro/containers/Sale/SaleEditSection/Page2.jsx": [
		1122,
		85
	],
	"./@remax-ro/containers/Sale/SaleEditSection/SellerDataForm": [
		1009,
		94
	],
	"./@remax-ro/containers/Sale/SaleEditSection/SellerDataForm.jsx": [
		1009,
		94
	],
	"./@remax-ro/containers/Sale/SaleEditSection/stores": [
		322,
		14
	],
	"./@remax-ro/containers/Sale/SaleEditSection/stores/": [
		322,
		14
	],
	"./@remax-ro/containers/Sale/SaleEditSection/stores/index": [
		322,
		14
	],
	"./@remax-ro/containers/Sale/SaleEditSection/stores/index.js": [
		322,
		14
	],
	"./@remax-ro/containers/Search/SearchPanelContent": [
		1123,
		93
	],
	"./@remax-ro/containers/Search/SearchPanelContent.jsx": [
		1123,
		93
	],
	"./@remax-ro/locales": [
		210
	],
	"./@remax-ro/locales/": [
		210
	],
	"./@remax-ro/locales/en": [
		471
	],
	"./@remax-ro/locales/en.json": [
		471
	],
	"./@remax-ro/locales/index": [
		210
	],
	"./@remax-ro/locales/index.js": [
		210
	],
	"./@remax-ro/locales/ro": [
		472
	],
	"./@remax-ro/locales/ro.json": [
		472
	],
	"./@remax-ro/theme": [
		1124,
		146
	],
	"./@remax-ro/theme.js": [
		1124,
		146
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1791;
module.exports = webpackAsyncContext;

/***/ }),
/* 1792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TextField__ = __webpack_require__(728);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TextField__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TextField_base__ = __webpack_require__(729);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MaskedTextField_MaskedTextField__ = __webpack_require__(1794);
/* unused harmony namespace reexport */



//# sourceMappingURL=index.js.map

/***/ }),
/* 1793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStyles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var globalClassNames = {
    root: 'ms-TextField',
    description: 'ms-TextField-description',
    errorMessage: 'ms-TextField-errorMessage',
    field: 'ms-TextField-field',
    fieldGroup: 'ms-TextField-fieldGroup',
    prefix: 'ms-TextField-prefix',
    suffix: 'ms-TextField-suffix',
    wrapper: 'ms-TextField-wrapper',
    multiline: 'ms-TextField--multiline',
    borderless: 'ms-TextField--borderless',
    underlined: 'ms-TextField--underlined',
    unresizable: 'ms-TextField--unresizable',
    required: 'is-required',
    disabled: 'is-disabled',
    active: 'is-active'
};
function getLabelStyles(props) {
    var underlined = props.underlined, disabled = props.disabled, focused = props.focused;
    return function () {
        return ({
            root: [
                underlined &&
                    disabled && {
                    color: props.theme.palette.neutralTertiary
                },
                underlined && {
                    fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].medium,
                    marginRight: 8,
                    paddingLeft: 12,
                    paddingRight: 0,
                    lineHeight: '22px',
                    height: 32
                },
                underlined &&
                    focused && {
                    selectors: (_a = {},
                        _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                            height: 31 // -1px to prevent jumpiness in HC with the increased border-width to 2px
                        },
                        _a)
                }
            ]
        });
        var _a;
    };
}
function getStyles(props) {
    var theme = props.theme, className = props.className, disabled = props.disabled, focused = props.focused, required = props.required, multiline = props.multiline, hasLabel = props.hasLabel, borderless = props.borderless, underlined = props.underlined, hasIcon = props.hasIcon, resizable = props.resizable, hasErrorMessage = props.hasErrorMessage, iconClass = props.iconClass, inputClassName = props.inputClassName, autoAdjustHeight = props.autoAdjustHeight;
    var semanticColors = theme.semanticColors;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(globalClassNames, theme);
    var fieldPrefixSuffix = {
        background: semanticColors.disabledBackground,
        color: !disabled ? semanticColors.inputPlaceholderText : semanticColors.disabledText,
        display: 'flex',
        alignItems: 'center',
        padding: '0 10px',
        lineHeight: 1,
        whiteSpace: 'nowrap',
        flexShrink: 0
    };
    // placeholder style constants
    var placeholderStyles = [
        theme.fonts.medium,
        {
            color: semanticColors.inputPlaceholderText,
            opacity: 1
        }
    ];
    var disabledPlaceholderStyles = {
        color: semanticColors.disabledText
    };
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            required && classNames.required,
            disabled && classNames.disabled,
            focused && classNames.active,
            multiline && classNames.multiline,
            borderless && classNames.borderless,
            underlined && classNames.underlined,
            __WEBPACK_IMPORTED_MODULE_0__Styling__["H" /* normalize */],
            {
                position: 'relative'
            },
            className
        ],
        wrapper: [
            classNames.wrapper,
            underlined && {
                display: 'flex',
                borderBottomWidth: 1,
                borderBottomStyle: 'solid',
                borderBottomColor: semanticColors.inputBorder,
                width: '100%'
            },
            hasErrorMessage &&
                underlined &&
                !disabled && {
                borderBottomColor: semanticColors.errorText,
                selectors: {
                    ':hover': {
                        borderBottomColor: semanticColors.errorText,
                        selectors: (_a = {},
                            _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                                borderBottomColor: 'Highlight'
                            },
                            _a)
                    }
                }
            },
            underlined &&
                disabled && {
                borderBottomColor: semanticColors.disabledBackground
            },
            underlined &&
                !disabled &&
                !focused &&
                !hasErrorMessage && {
                selectors: {
                    ':hover': {
                        borderBottomColor: semanticColors.inputBorderHovered,
                        selectors: (_b = {},
                            _b[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                                borderBottomColor: 'Highlight'
                            },
                            _b)
                    }
                }
            },
            underlined &&
                focused && {
                borderBottomColor: !hasErrorMessage ? semanticColors.inputFocusBorderAlt : semanticColors.errorText,
                selectors: (_c = {},
                    _c[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        borderBottomWidth: 2,
                        borderBottomColor: 'Highlight'
                    },
                    _c)
            }
        ],
        fieldGroup: [
            classNames.fieldGroup,
            __WEBPACK_IMPORTED_MODULE_0__Styling__["H" /* normalize */],
            {
                border: "1px solid " + semanticColors.inputBorder,
                background: semanticColors.inputBackground,
                cursor: 'text',
                height: 32,
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'stretch',
                position: 'relative',
                selectors: {
                    ':hover': {
                        selectors: (_d = {},
                            _d[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                                borderColor: 'Highlight'
                            },
                            _d)
                    }
                }
            },
            multiline && {
                minHeight: '60px',
                height: 'auto',
                display: 'flex'
            },
            borderless && {
                border: 'none'
            },
            !focused &&
                !disabled && {
                selectors: {
                    ':hover': {
                        borderColor: semanticColors.inputBorderHovered
                    }
                }
            },
            focused && {
                borderColor: semanticColors.inputFocusBorderAlt,
                selectors: (_e = {},
                    _e[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        borderWidth: 2,
                        borderColor: 'Highlight'
                    },
                    _e)
            },
            disabled && {
                backgroundColor: semanticColors.disabledBackground,
                borderColor: semanticColors.disabledBackground,
                cursor: 'default'
            },
            underlined && {
                flex: '1 1 0px',
                border: 'none',
                textAlign: 'left'
            },
            underlined &&
                focused && {
                selectors: (_f = {},
                    _f[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        height: 31 // -1px to prevent jumpiness in HC with the increased border-width to 2px
                    },
                    _f)
            },
            underlined &&
                disabled && {
                backgroundColor: 'transparent'
            },
            hasErrorMessage && {
                borderColor: semanticColors.errorText,
                selectors: {
                    '&:focus, &:hover': {
                        borderColor: semanticColors.errorText
                    }
                }
            },
            hasErrorMessage &&
                focused && {
                borderColor: semanticColors.errorText
            },
            !hasLabel &&
                required && {
                selectors: (_g = {
                        ':after': {
                            content: "'*'",
                            color: semanticColors.errorText,
                            position: 'absolute',
                            top: -5,
                            right: -10
                        }
                    },
                    _g[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        selectors: {
                            ':after': {
                                right: -14 // moving the * 4 pixel to right to alleviate border clipping in HC mode.
                            }
                        }
                    },
                    _g)
            }
        ],
        field: [
            theme.fonts.medium,
            classNames.field,
            __WEBPACK_IMPORTED_MODULE_0__Styling__["H" /* normalize */],
            {
                fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].medium,
                borderRadius: 0,
                border: 'none',
                background: 'none',
                backgroundColor: 'transparent',
                color: semanticColors.inputText,
                padding: '0 12px',
                width: '100%',
                minWidth: 0,
                textOverflow: 'ellipsis',
                outline: 0,
                selectors: {
                    '&:active, &:focus, &:hover': { outline: 0 },
                    '::-ms-clear': {
                        display: 'none'
                    }
                }
            },
            Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["y" /* getPlaceholderStyles */])(placeholderStyles),
            multiline &&
                !resizable && [
                classNames.unresizable,
                {
                    resize: 'none'
                }
            ],
            multiline && {
                minHeight: 'inherit',
                lineHeight: 17,
                flexGrow: 1,
                paddingTop: 6,
                overflow: 'auto',
                width: '100%'
            },
            multiline &&
                autoAdjustHeight && {
                overflow: 'hidden'
            },
            hasIcon && {
                paddingRight: 24
            },
            multiline &&
                hasIcon && {
                paddingRight: 40
            },
            disabled && [
                {
                    backgroundColor: 'transparent',
                    borderColor: 'transparent',
                    color: semanticColors.disabledText
                },
                Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["y" /* getPlaceholderStyles */])(disabledPlaceholderStyles)
            ],
            underlined && {
                textAlign: 'left'
            },
            focused &&
                !borderless && {
                selectors: (_h = {},
                    _h[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        paddingLeft: 11,
                        paddingRight: 11
                    },
                    _h)
            },
            focused &&
                multiline &&
                !borderless && {
                selectors: (_j = {},
                    _j[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        paddingTop: 4 // take into consideration the 2px increased border-width (not when borderless).
                    },
                    _j)
            },
            inputClassName
        ],
        icon: [
            multiline && {
                paddingRight: 24,
                paddingBottom: 8,
                alignItems: 'flex-end'
            },
            {
                pointerEvents: 'none',
                position: 'absolute',
                bottom: 5,
                right: 8,
                top: 'auto',
                fontSize: 16,
                lineHeight: 18
            },
            disabled && {
                color: semanticColors.disabledText
            },
            iconClass
        ],
        description: [
            classNames.description,
            {
                color: semanticColors.bodySubtext,
                fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].xSmall
            }
        ],
        errorMessage: [
            classNames.errorMessage,
            __WEBPACK_IMPORTED_MODULE_0__Styling__["a" /* AnimationClassNames */].slideDownIn20,
            theme.fonts.small,
            {
                color: semanticColors.errorText,
                margin: 0,
                paddingTop: 5,
                display: 'flex',
                alignItems: 'center'
            }
        ],
        prefix: [classNames.prefix, fieldPrefixSuffix],
        suffix: [classNames.suffix, fieldPrefixSuffix],
        subComponentStyles: {
            label: getLabelStyles(props)
        }
    };
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
}
//# sourceMappingURL=TextField.styles.js.map

/***/ }),
/* 1794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_MASK_CHAR */
/* unused harmony export MaskedTextField */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TextField__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__inputMask__ = __webpack_require__(1795);





var DEFAULT_MASK_CHAR = '_';
var MaskedTextField = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](MaskedTextField, _super);
    function MaskedTextField(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Tell BaseComponent to bypass resolution of componentRef.
         */
        _this._skipComponentRefResolution = true;
        _this._textField = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["_5" /* initializeComponentRef */])(_this);
        // Translate mask into charData
        _this._maskCharData = Object(__WEBPACK_IMPORTED_MODULE_4__inputMask__["i" /* parseMask */])(props.mask, props.maskFormat);
        // If an initial value is provided, use it to populate the format chars
        props.value !== undefined && _this.setValue(props.value);
        _this._isFocused = false;
        _this._moveCursorOnMouseUp = false;
        _this.state = {
            displayValue: Object(__WEBPACK_IMPORTED_MODULE_4__inputMask__["f" /* getMaskDisplay */])(props.mask, _this._maskCharData, props.maskChar)
        };
        return _this;
    }
    MaskedTextField.prototype.componentWillReceiveProps = function (newProps) {
        if (newProps.mask !== this.props.mask || newProps.value !== this.props.value) {
            this._maskCharData = Object(__WEBPACK_IMPORTED_MODULE_4__inputMask__["i" /* parseMask */])(newProps.mask, newProps.maskFormat);
            newProps.value !== undefined && this.setValue(newProps.value);
            this.setState({
                displayValue: Object(__WEBPACK_IMPORTED_MODULE_4__inputMask__["f" /* getMaskDisplay */])(newProps.mask, this._maskCharData, newProps.maskChar)
            });
        }
    };
    MaskedTextField.prototype.componentDidUpdate = function () {
        // Move the cursor to the start of the mask format on update
        if (this._isFocused && this.state.maskCursorPosition !== undefined && this._textField.current) {
            this._textField.current.setSelectionRange(this.state.maskCursorPosition, this.state.maskCursorPosition);
        }
    };
    MaskedTextField.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__TextField__["a" /* TextField */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this.props, { onFocus: this._onFocus, onBlur: this._onBlur, onMouseDown: this._onMouseDown, onMouseUp: this._onMouseUp, onChange: this._onInputChange, onBeforeChange: this._onBeforeChange, onKeyDown: this._onKeyDown, onPaste: this._onPaste, value: this.state.displayValue, componentRef: this._textField })));
    };
    Object.defineProperty(MaskedTextField.prototype, "value", {
        /**
         * @returns The value of all filled format characters or undefined if not all format characters are filled
         */
        get: function () {
            var value = '';
            for (var i = 0; i < this._maskCharData.length; i++) {
                if (!this._maskCharData[i].value) {
                    return undefined;
                }
                value += this._maskCharData[i].value;
            }
            return value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     *
     */
    MaskedTextField.prototype.setValue = function (newValue) {
        var valueIndex = 0, charDataIndex = 0;
        while (valueIndex < newValue.length && charDataIndex < this._maskCharData.length) {
            // Test if the next character in the new value fits the next format character
            var testVal = newValue[valueIndex];
            if (this._maskCharData[charDataIndex].format.test(testVal)) {
                this._maskCharData[charDataIndex].value = testVal;
                charDataIndex++;
            }
            valueIndex++;
        }
    };
    MaskedTextField.prototype.focus = function () {
        var current = this._textField.current;
        current && current.focus();
    };
    MaskedTextField.prototype.blur = function () {
        var current = this._textField.current;
        current && current.blur();
    };
    MaskedTextField.prototype.select = function () {
        var current = this._textField.current;
        current && current.select();
    };
    MaskedTextField.prototype.setSelectionStart = function (value) {
        var current = this._textField.current;
        current && current.setSelectionStart(value);
    };
    MaskedTextField.prototype.setSelectionEnd = function (value) {
        var current = this._textField.current;
        current && current.setSelectionEnd(value);
    };
    MaskedTextField.prototype.setSelectionRange = function (start, end) {
        var current = this._textField.current;
        current && current.setSelectionRange(start, end);
    };
    Object.defineProperty(MaskedTextField.prototype, "selectionStart", {
        get: function () {
            var current = this._textField.current;
            return current && current.selectionStart !== null ? current.selectionStart : -1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MaskedTextField.prototype, "selectionEnd", {
        get: function () {
            var current = this._textField.current;
            return current && current.selectionEnd ? current.selectionEnd : -1;
        },
        enumerable: true,
        configurable: true
    });
    MaskedTextField.prototype._onFocus = function (event) {
        if (this.props.onFocus) {
            this.props.onFocus(event);
        }
        this._isFocused = true;
        // Move the cursor position to the leftmost unfilled position
        for (var i = 0; i < this._maskCharData.length; i++) {
            if (!this._maskCharData[i].value) {
                this.setState({
                    maskCursorPosition: this._maskCharData[i].displayIndex
                });
                break;
            }
        }
    };
    MaskedTextField.prototype._onBlur = function (event) {
        if (this.props.onBlur) {
            this.props.onBlur(event);
        }
        this._isFocused = false;
        this._moveCursorOnMouseUp = true;
    };
    MaskedTextField.prototype._onMouseDown = function (event) {
        if (this.props.onMouseDown) {
            this.props.onMouseDown(event);
        }
        if (!this._isFocused) {
            this._moveCursorOnMouseUp = true;
        }
    };
    MaskedTextField.prototype._onMouseUp = function (event) {
        if (this.props.onMouseUp) {
            this.props.onMouseUp(event);
        }
        // Move the cursor on mouseUp after focusing the textField
        if (this._moveCursorOnMouseUp) {
            this._moveCursorOnMouseUp = false;
            // Move the cursor position to the rightmost unfilled position
            for (var i = 0; i < this._maskCharData.length; i++) {
                if (!this._maskCharData[i].value) {
                    this.setState({
                        maskCursorPosition: this._maskCharData[i].displayIndex
                    });
                    break;
                }
            }
        }
    };
    MaskedTextField.prototype._onBeforeChange = function (value) {
        var current = this._textField.current;
        if (this.props.onBeforeChange) {
            this.props.onBeforeChange(value);
        }
        if (this._changeSelectionData === null && current) {
            this._changeSelectionData = {
                changeType: 'default',
                selectionStart: current.selectionStart !== null ? current.selectionStart : -1,
                selectionEnd: current.selectionEnd !== null ? current.selectionEnd : -1
            };
        }
    };
    MaskedTextField.prototype._onInputChange = function (ev, value) {
        if (!this._changeSelectionData) {
            return;
        }
        var displayValue = this.state.displayValue;
        // The initial value of cursorPos does not matter
        var cursorPos = 0;
        var _a = this._changeSelectionData, changeType = _a.changeType, selectionStart = _a.selectionStart, selectionEnd = _a.selectionEnd;
        if (changeType === 'textPasted') {
            var charsSelected = selectionEnd - selectionStart, charCount = value.length + charsSelected - displayValue.length, startPos = selectionStart, pastedString = value.substr(startPos, charCount);
            // Clear any selected characters
            if (charsSelected) {
                this._maskCharData = Object(__WEBPACK_IMPORTED_MODULE_4__inputMask__["d" /* clearRange */])(this._maskCharData, selectionStart, charsSelected);
            }
            cursorPos = Object(__WEBPACK_IMPORTED_MODULE_4__inputMask__["h" /* insertString */])(this._maskCharData, startPos, pastedString);
        }
        else if (changeType === 'delete' || changeType === 'backspace') {
            // isDel is true If the characters are removed LTR, otherwise RTL
            var isDel = changeType === 'delete', charCount = selectionEnd - selectionStart;
            if (charCount) {
                // charCount is > 0 if range was deleted
                this._maskCharData = Object(__WEBPACK_IMPORTED_MODULE_4__inputMask__["d" /* clearRange */])(this._maskCharData, selectionStart, charCount);
                cursorPos = Object(__WEBPACK_IMPORTED_MODULE_4__inputMask__["g" /* getRightFormatIndex */])(this._maskCharData, selectionStart);
            }
            else {
                // If charCount === 0, there was no selection and a single character was deleted
                if (isDel) {
                    this._maskCharData = Object(__WEBPACK_IMPORTED_MODULE_4__inputMask__["b" /* clearNext */])(this._maskCharData, selectionStart);
                    cursorPos = Object(__WEBPACK_IMPORTED_MODULE_4__inputMask__["g" /* getRightFormatIndex */])(this._maskCharData, selectionStart);
                }
                else {
                    this._maskCharData = Object(__WEBPACK_IMPORTED_MODULE_4__inputMask__["c" /* clearPrev */])(this._maskCharData, selectionStart);
                    cursorPos = Object(__WEBPACK_IMPORTED_MODULE_4__inputMask__["e" /* getLeftFormatIndex */])(this._maskCharData, selectionStart);
                }
            }
        }
        else if (value.length > displayValue.length) {
            // This case is if the user added characters
            var charCount = value.length - displayValue.length, startPos = selectionEnd - charCount, enteredString = value.substr(startPos, charCount);
            cursorPos = Object(__WEBPACK_IMPORTED_MODULE_4__inputMask__["h" /* insertString */])(this._maskCharData, startPos, enteredString);
        }
        else if (value.length <= displayValue.length) {
            /**
             * This case is reached only if the user has selected a block of 1 or more
             * characters and input a character replacing the characters they've selected.
             */
            var charCount = 1, selectCount = displayValue.length + charCount - value.length, startPos = selectionEnd - charCount, enteredString = value.substr(startPos, charCount);
            // Clear the selected range
            this._maskCharData = Object(__WEBPACK_IMPORTED_MODULE_4__inputMask__["d" /* clearRange */])(this._maskCharData, startPos, selectCount);
            // Insert the printed character
            cursorPos = Object(__WEBPACK_IMPORTED_MODULE_4__inputMask__["h" /* insertString */])(this._maskCharData, startPos, enteredString);
        }
        this._changeSelectionData = null;
        var newValue = Object(__WEBPACK_IMPORTED_MODULE_4__inputMask__["f" /* getMaskDisplay */])(this.props.mask, this._maskCharData, this.props.maskChar);
        this.setState({
            displayValue: newValue,
            maskCursorPosition: cursorPos
        });
        // Perform onChange/d after input has been processed. Return value is expected to be the displayed text
        if (this.props.onChange) {
            this.props.onChange(ev, newValue);
        }
        if (this.props.onChanged) {
            this.props.onChanged(newValue);
        }
    };
    MaskedTextField.prototype._onKeyDown = function (event) {
        var current = this._textField.current;
        if (this.props.onKeyDown) {
            this.props.onKeyDown(event);
        }
        this._changeSelectionData = null;
        if (current && current.value) {
            var keyCode = event.keyCode, ctrlKey = event.ctrlKey, metaKey = event.metaKey;
            // Ignore ctrl and meta keydown
            if (ctrlKey || metaKey) {
                return;
            }
            // On backspace or delete, store the selection and the keyCode
            if (keyCode === __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].backspace || keyCode === __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].del) {
                var selectionStart = event.target.selectionStart, selectionEnd = event.target.selectionEnd;
                // Check if backspace or delete press is valid.
                if (!(keyCode === __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].backspace && selectionEnd && selectionEnd > 0) &&
                    !(keyCode === __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].del && selectionStart !== null && selectionStart < current.value.length)) {
                    return;
                }
                this._changeSelectionData = {
                    changeType: keyCode === __WEBPACK_IMPORTED_MODULE_3__Utilities__["g" /* KeyCodes */].backspace ? 'backspace' : 'delete',
                    selectionStart: selectionStart !== null ? selectionStart : -1,
                    selectionEnd: selectionEnd !== null ? selectionEnd : -1
                };
            }
        }
    };
    MaskedTextField.prototype._onPaste = function (event) {
        if (this.props.onPaste) {
            this.props.onPaste(event);
        }
        var selectionStart = event.target.selectionStart, selectionEnd = event.target.selectionEnd;
        // Store the paste selection range
        this._changeSelectionData = {
            changeType: 'textPasted',
            selectionStart: selectionStart !== null ? selectionStart : -1,
            selectionEnd: selectionEnd !== null ? selectionEnd : -1
        };
    };
    MaskedTextField.defaultProps = {
        maskChar: DEFAULT_MASK_CHAR,
        maskFormat: __WEBPACK_IMPORTED_MODULE_4__inputMask__["a" /* DEFAULT_MASK_FORMAT_CHARS */]
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_3__Utilities__["o" /* autobind */]
    ], MaskedTextField.prototype, "_onFocus", null);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_3__Utilities__["o" /* autobind */]
    ], MaskedTextField.prototype, "_onBlur", null);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_3__Utilities__["o" /* autobind */]
    ], MaskedTextField.prototype, "_onMouseDown", null);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_3__Utilities__["o" /* autobind */]
    ], MaskedTextField.prototype, "_onMouseUp", null);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_3__Utilities__["o" /* autobind */]
    ], MaskedTextField.prototype, "_onBeforeChange", null);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_3__Utilities__["o" /* autobind */]
    ], MaskedTextField.prototype, "_onInputChange", null);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_3__Utilities__["o" /* autobind */]
    ], MaskedTextField.prototype, "_onKeyDown", null);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        __WEBPACK_IMPORTED_MODULE_3__Utilities__["o" /* autobind */]
    ], MaskedTextField.prototype, "_onPaste", null);
    return MaskedTextField;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=MaskedTextField.js.map

/***/ }),
/* 1795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_MASK_FORMAT_CHARS; });
/* harmony export (immutable) */ __webpack_exports__["i"] = parseMask;
/* harmony export (immutable) */ __webpack_exports__["f"] = getMaskDisplay;
/* harmony export (immutable) */ __webpack_exports__["g"] = getRightFormatIndex;
/* harmony export (immutable) */ __webpack_exports__["e"] = getLeftFormatIndex;
/* harmony export (immutable) */ __webpack_exports__["d"] = clearRange;
/* harmony export (immutable) */ __webpack_exports__["b"] = clearNext;
/* harmony export (immutable) */ __webpack_exports__["c"] = clearPrev;
/* harmony export (immutable) */ __webpack_exports__["h"] = insertString;
var DEFAULT_MASK_FORMAT_CHARS = {
    '9': /[0-9]/,
    a: /[a-zA-Z]/,
    '*': /[a-zA-Z0-9]/
};
/**
 * Takes in the mask string and the formatCharacters and returns an array of MaskValues
 * Example:
 * mask = 'Phone Number: (999) - 9999'
 * return = [
 *    { value: undefined, displayIndex: 16, format: /[0-9]/ },
 *    { value: undefined, displayIndex: 17, format: /[0-9]/ },
 *    { value: undefined, displayIndex: 18, format: /[0-9]/ },
 *    { value: undefined, displayIndex: 22, format: /[0-9]/ },
 * ]
 *
 * @param mask The string use to define the format of the displayed maskedValue.
 * @param formatChars An object defining how certain characters in the mask should accept input.
 */
function parseMask(mask, formatChars) {
    if (formatChars === void 0) { formatChars = DEFAULT_MASK_FORMAT_CHARS; }
    if (!mask) {
        return [];
    }
    var maskCharData = [];
    // Count the escape characters in the mask string.
    var escapedChars = 0;
    for (var i = 0; i + escapedChars < mask.length; i++) {
        var maskChar = mask.charAt(i + escapedChars);
        if (maskChar === '\\') {
            escapedChars++;
        }
        else {
            // Check if the maskChar is a format character.
            var maskFormat = formatChars[maskChar];
            if (maskFormat) {
                maskCharData.push({
                    /**
                     * Do not add escapedChars to the displayIndex.
                     * The index refers to a position in the mask's displayValue.
                     * Since the backslashes don't appear in the displayValue,
                     * we do not add them to the charData displayIndex.
                     */
                    displayIndex: i,
                    format: maskFormat
                });
            }
        }
    }
    return maskCharData;
}
/**
 * Takes in the mask string, an array of MaskValues, and the maskCharacter
 * returns the mask string formatted with the input values and maskCharacter.
 * If the maskChar is undefined, the maskDisplay is truncated to the last filled format character.
 * Example:
 * mask = 'Phone Number: (999) 999 - 9999'
 * maskCharData = '12345'
 * maskChar = '_'
 * return = 'Phone Number: (123) 45_ - ___'
 *
 * Example:
 * mask = 'Phone Number: (999) 999 - 9999'
 * value = '12345'
 * maskChar = undefined
 * return = 'Phone Number: (123) 45'
 *
 * @param mask The string use to define the format of the displayed maskedValue.
 * @param maskCharData The input values to insert into the mask string for displaying.
 * @param maskChar? A character to display in place of unfilled mask format characters.
 */
function getMaskDisplay(mask, maskCharData, maskChar) {
    var maskDisplay = mask;
    if (!maskDisplay) {
        return '';
    }
    // Remove all backslashes
    maskDisplay = maskDisplay.replace(/\\/g, '');
    // lastDisplayIndex is is used to truncate the string if necessary.
    var lastDisplayIndex = 0;
    if (maskCharData.length > 0) {
        lastDisplayIndex = maskCharData[0].displayIndex - 1;
    }
    /**
     * For each input value, replace the character in the maskDisplay with the value.
     * If there is no value set for the format character, use the maskChar.
     */
    for (var _i = 0, maskCharData_1 = maskCharData; _i < maskCharData_1.length; _i++) {
        var charData = maskCharData_1[_i];
        var nextChar = ' ';
        if (charData.value) {
            nextChar = charData.value;
            if (charData.displayIndex > lastDisplayIndex) {
                lastDisplayIndex = charData.displayIndex;
            }
        }
        else {
            if (maskChar) {
                nextChar = maskChar;
            }
        }
        // Insert the character into the maskdisplay at its corresponding index
        maskDisplay = maskDisplay.slice(0, charData.displayIndex) + nextChar + maskDisplay.slice(charData.displayIndex + 1);
    }
    // Cut off all mask characters after the last filled format value
    if (!maskChar) {
        maskDisplay = maskDisplay.slice(0, lastDisplayIndex + 1);
    }
    return maskDisplay;
}
/**
 * Get the next format index right of or at a specified index.
 * If no index exists, returns the rightmost index.
 * @param maskCharData
 * @param index
 */
function getRightFormatIndex(maskCharData, index) {
    for (var i = 0; i < maskCharData.length; i++) {
        if (maskCharData[i].displayIndex >= index) {
            return maskCharData[i].displayIndex;
        }
    }
    return maskCharData[maskCharData.length - 1].displayIndex;
}
/**
 * Get the next format index left of a specified index.
 * If no index exists, returns the leftmost index.
 * @param maskCharData
 * @param index
 */
function getLeftFormatIndex(maskCharData, index) {
    for (var i = maskCharData.length - 1; i >= 0; i--) {
        if (maskCharData[i].displayIndex < index) {
            return maskCharData[i].displayIndex;
        }
    }
    return maskCharData[0].displayIndex;
}
/**
 * Deletes all values in maskCharData with a displayIndex that falls inside the specified range.
 * maskCharData is modified inline and also returned.
 * @param maskCharData
 * @param selectionStart
 * @param selectionCount
 */
function clearRange(maskCharData, selectionStart, selectionCount) {
    for (var i = 0; i < maskCharData.length; i++) {
        if (maskCharData[i].displayIndex >= selectionStart) {
            if (maskCharData[i].displayIndex >= selectionStart + selectionCount) {
                break;
            }
            maskCharData[i].value = undefined;
        }
    }
    return maskCharData;
}
/**
 * Deletes the input character at or after a specified index and returns the new array of charData
 * maskCharData is modified inline and also returned.
 * @param maskCharData
 * @param selectionStart
 */
function clearNext(maskCharData, selectionStart) {
    for (var i = 0; i < maskCharData.length; i++) {
        if (maskCharData[i].displayIndex >= selectionStart) {
            maskCharData[i].value = undefined;
            break;
        }
    }
    return maskCharData;
}
/**
 * Deletes the input character before a specified index and returns the new array of charData
 * maskCharData is modified inline and also returned.
 * @param maskCharData
 * @param selectionStart
 */
function clearPrev(maskCharData, selectionStart) {
    for (var i = maskCharData.length - 1; i >= 0; i--) {
        if (maskCharData[i].displayIndex < selectionStart) {
            maskCharData[i].value = undefined;
            break;
        }
    }
    return maskCharData;
}
/**
 * Deletes all values in maskCharData with a displayIndex that falls inside the specified range.
 * Modifies the maskCharData inplace with the passed string and returns the display index of the
 * next format character after the inserted string.
 * @param maskCharData
 * @param selectionStart
 * @param selectionCount
 * @return The displayIndex of the next format character
 */
function insertString(maskCharData, selectionStart, newString) {
    var stringIndex = 0;
    var nextIndex = 0;
    var isStringInserted = false;
    // Iterate through _maskCharData finding values with a displayIndex after the specified range start
    for (var i = 0; i < maskCharData.length && stringIndex < newString.length; i++) {
        if (maskCharData[i].displayIndex >= selectionStart) {
            isStringInserted = true;
            nextIndex = maskCharData[i].displayIndex;
            // Find the next character in the newString that matches the format
            while (stringIndex < newString.length) {
                // If the character matches the format regexp, set the maskCharData to the new character
                if (maskCharData[i].format.test(newString.charAt(stringIndex))) {
                    maskCharData[i].value = newString.charAt(stringIndex++);
                    // Set the nextIndex to the display index of the next mask format character.
                    if (i + 1 < maskCharData.length) {
                        nextIndex = maskCharData[i + 1].displayIndex;
                    }
                    else {
                        nextIndex++;
                    }
                    break;
                }
                stringIndex++;
            }
        }
    }
    return isStringInserted ? nextIndex : selectionStart;
}
//# sourceMappingURL=inputMask.js.map

/***/ }),
/* 1796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dropdown__ = __webpack_require__(1797);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Dropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dropdown_base__ = __webpack_require__(730);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dropdown_types__ = __webpack_require__(416);
/* unused harmony namespace reexport */



//# sourceMappingURL=index.js.map

/***/ }),
/* 1797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dropdown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dropdown_base__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dropdown_styles__ = __webpack_require__(1807);



var Dropdown = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__Dropdown_base__["a" /* DropdownBase */], __WEBPACK_IMPORTED_MODULE_2__Dropdown_styles__["a" /* getStyles */], undefined, {
    scope: 'Dropdown'
});
//# sourceMappingURL=Dropdown.js.map

/***/ }),
/* 1798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Checkbox__ = __webpack_require__(1799);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Checkbox__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Checkbox_base__ = __webpack_require__(731);
/* unused harmony namespace reexport */


//# sourceMappingURL=index.js.map

/***/ }),
/* 1799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Checkbox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Checkbox_base__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Checkbox_styles__ = __webpack_require__(1800);



var Checkbox = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__Checkbox_base__["a" /* CheckboxBase */], __WEBPACK_IMPORTED_MODULE_2__Checkbox_styles__["a" /* getStyles */], undefined, { scope: 'Checkbox' });
//# sourceMappingURL=Checkbox.js.map

/***/ }),
/* 1800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utilities__ = __webpack_require__(1);


var MS_CHECKBOX_LABEL_SIZE = '20px';
var MS_CHECKBOX_TRANSITION_DURATION = '200ms';
var MS_CHECKBOX_TRANSITION_TIMING = 'cubic-bezier(.4, 0, .23, 1)';
var getStyles = function (props) {
    var className = props.className, theme = props.theme, reversed = props.reversed, checked = props.checked, disabled = props.disabled, isUsingCustomLabelRender = props.isUsingCustomLabelRender;
    var semanticColors = theme.semanticColors;
    var checkmarkFontColor = semanticColors.inputForegroundChecked;
    var checkmarkFontColorCheckedDisabled = semanticColors.disabledBackground;
    var checkmarkFontColorHovered = semanticColors.inputBorder;
    var checkboxBorderColor = semanticColors.smallInputBorder;
    var checkboxBorderColorChecked = semanticColors.inputBackgroundChecked;
    var checkboxBorderColorDisabled = semanticColors.disabledBodySubtext;
    var checkboxBorderHoveredColor = semanticColors.inputBorderHovered;
    var checkboxBackgroundChecked = semanticColors.inputBackgroundChecked;
    var checkboxBackgroundCheckedHovered = semanticColors.inputBackgroundCheckedHovered;
    var checkboxBorderColorCheckedHovered = semanticColors.inputBackgroundCheckedHovered;
    var checkboxHoveredTextColor = semanticColors.bodyText;
    var checkboxBackgroundDisabledChecked = semanticColors.disabledBodySubtext;
    var checkboxTextColor = semanticColors.bodyText;
    var checkboxTextColorDisabled = semanticColors.disabledText;
    return {
        root: [
            'ms-Checkbox',
            {
                position: 'relative',
                display: 'flex'
            },
            reversed && 'reversed',
            checked && 'is-checked',
            !disabled && 'is-enabled',
            disabled && 'is-disabled',
            className
        ],
        input: [
            {
                position: 'absolute',
                background: 'none',
                opacity: 0,
                selectors: (_a = {},
                    _a["." + __WEBPACK_IMPORTED_MODULE_1__Utilities__["f" /* IsFocusVisibleClassName */] + " &:focus + label"] = {
                        outline: '1px solid ' + theme.palette.neutralSecondary,
                        outlineOffset: '2px',
                        selectors: (_b = {},
                            _b[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                                outline: '1px solid ActiveBorder'
                            },
                            _b)
                    },
                    _a)
            }
        ],
        label: [
            'ms-Checkbox-label',
            theme.fonts.medium,
            {
                display: 'flex',
                alignItems: isUsingCustomLabelRender ? 'center' : 'flex-start',
                cursor: disabled ? 'default' : 'pointer',
                position: 'relative',
                userSelect: 'none',
                textAlign: 'left'
            },
            reversed && {
                flexDirection: 'row-reverse',
                justifyContent: 'flex-end'
            },
            !disabled && [
                !checked && {
                    selectors: {
                        ':hover .ms-Checkbox-checkbox': {
                            borderColor: checkboxBorderHoveredColor,
                            selectors: (_c = {},
                                _c[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                                    borderColor: 'Highlight'
                                },
                                _c)
                        },
                        ':focus .ms-Checkbox-checkbox': { borderColor: checkboxBorderHoveredColor },
                        ':hover .ms-Checkbox-checkmark': {
                            color: checkmarkFontColorHovered,
                            opacity: '1',
                            selectors: (_d = {},
                                _d[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                                    color: 'Highlight'
                                },
                                _d)
                        }
                    }
                },
                checked && {
                    selectors: (_e = {
                            ':hover .ms-Checkbox-checkbox': {
                                background: checkboxBackgroundCheckedHovered,
                                borderColor: checkboxBorderColorCheckedHovered
                            },
                            ':focus .ms-Checkbox-checkbox': {
                                background: checkboxBackgroundCheckedHovered,
                                borderColor: checkboxBorderColorCheckedHovered
                            }
                        },
                        _e[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                            selectors: {
                                ':hover .ms-Checkbox-checkbox': {
                                    background: 'Window',
                                    borderColor: 'Highlight'
                                },
                                ':focus .ms-Checkbox-checkbox': {
                                    background: 'Highlight'
                                },
                                ':focus:hover .ms-Checkbox-checkbox': {
                                    background: 'Highlight'
                                },
                                ':focus:hover .ms-Checkbox-checkmark': {
                                    color: 'Window'
                                },
                                ':hover .ms-Checkbox-checkmark': {
                                    color: 'Highlight'
                                }
                            }
                        },
                        _e)
                },
                {
                    selectors: {
                        ':hover .ms-Checkbox-text': { color: checkboxHoveredTextColor },
                        ':focus .ms-Checkbox-text': { color: checkboxHoveredTextColor }
                    }
                }
            ]
        ],
        checkbox: [
            'ms-Checkbox-checkbox',
            {
                display: 'flex',
                flexShrink: 0,
                alignItems: 'center',
                justifyContent: 'center',
                height: MS_CHECKBOX_LABEL_SIZE,
                width: MS_CHECKBOX_LABEL_SIZE,
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: checkboxBorderColor,
                boxSizing: 'border-box',
                transitionProperty: 'background, border, border-color',
                transitionDuration: MS_CHECKBOX_TRANSITION_DURATION,
                transitionTimingFunction: MS_CHECKBOX_TRANSITION_TIMING,
                /* in case the icon is bigger than the box */
                overflow: 'hidden'
            },
            !reversed
                ? // this margin on the checkbox is for backwards compat.
                    // notably it has the effect where a customRender is used, there will be only a 4px margin from checkbox to label.
                    // the label by default would have another 4px margin for a total of 8px margin between checkbox and label.
                    // we don't combine the two (and move it into the text) to not incur a breaking change for everyone using custom render atm.
                    {
                        marginRight: 4
                    }
                : {
                    marginLeft: 4
                },
            !disabled &&
                checked && {
                background: checkboxBackgroundChecked,
                borderColor: checkboxBorderColorChecked,
                selectors: (_f = {},
                    _f[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        background: 'Highlight',
                        borderColor: 'Highlight'
                    },
                    _f)
            },
            disabled && {
                borderColor: checkboxBorderColorDisabled,
                selectors: (_g = {},
                    _g[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        borderColor: 'InactiveBorder'
                    },
                    _g)
            },
            checked &&
                disabled && {
                background: checkboxBackgroundDisabledChecked,
                borderColor: checkboxBorderColorDisabled
            }
        ],
        checkmark: [
            'ms-Checkbox-checkmark',
            {
                opacity: checked ? '1' : '0',
                color: checked && disabled ? checkmarkFontColorCheckedDisabled : checkmarkFontColor,
                selectors: (_h = {},
                    _h[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        color: disabled ? 'InactiveBorder' : 'Window',
                        MsHighContrastAdjust: 'none'
                    },
                    _h)
            }
        ],
        text: [
            'ms-Checkbox-text',
            {
                color: disabled ? checkboxTextColorDisabled : checkboxTextColor,
                fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].medium,
                lineHeight: '20px'
            },
            !reversed
                ? {
                    marginLeft: 4
                }
                : {
                    marginRight: 4
                },
            disabled && {
                selectors: (_j = {},
                    _j[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        // backwards compat for the color of the text when the checkbox was rendered
                        // using a Button.
                        color: 'InactiveBorder'
                    },
                    _j)
            }
        ]
    };
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
};
//# sourceMappingURL=Checkbox.styles.js.map

/***/ }),
/* 1801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DropdownSizePosCache; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dropdown_types__ = __webpack_require__(416);

/**
 * A utility class to cache size and position in cache.
 *
 * Dropdown options has non-selectable display types. It is therefore not cheap to determine
 * the total number of actual selectable options as well as the position an option is in the
 * list of options - O(n) cost for each lookup.
 *
 * Given that we potentially have to make this determination on every single render pass, this
 * cache should provide a little bit of relief.
 */
var DropdownSizePosCache = /** @class */ (function () {
    function DropdownSizePosCache() {
        this._size = 0;
    }
    /**
     * Invalidates the cache and recalculate the size of selectable options.
     */
    DropdownSizePosCache.prototype.updateOptions = function (options) {
        var displayOnlyOptionsCache = [];
        var size = 0;
        for (var i = 0; i < options.length; i++) {
            if (options[i].itemType === __WEBPACK_IMPORTED_MODULE_0__Dropdown_types__["a" /* DropdownMenuItemType */].Divider || options[i].itemType === __WEBPACK_IMPORTED_MODULE_0__Dropdown_types__["a" /* DropdownMenuItemType */].Header) {
                displayOnlyOptionsCache.push(i);
            }
            else {
                size++;
            }
        }
        this._size = size;
        this._displayOnlyOptionsCache = displayOnlyOptionsCache;
    };
    Object.defineProperty(DropdownSizePosCache.prototype, "optionSetSize", {
        /**
         * The size of all the selectable options.
         */
        get: function () {
            return this._size;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns the position of this option element relative to the full set of selectable option elements.
     * Note: the first selectable element is position 1 in the set.
     * @param index The raw index of the option element.
     */
    DropdownSizePosCache.prototype.positionInSet = function (index) {
        if (index === undefined) {
            return undefined;
        }
        // we could possibly memoize this too but this should be good enough, most of the time (the expectation is that
        // when you have a lot of options, the selectable options will heavily dominate over the non-selectable options.
        var offset = 0;
        while (index > this._displayOnlyOptionsCache[offset]) {
            offset++;
        }
        if (this._displayOnlyOptionsCache[offset] === index) {
            throw new Error("Unexpected: Option at index " + index + " is not a selectable element.");
        }
        return index - offset + 1;
    };
    return DropdownSizePosCache;
}());

//# sourceMappingURL=DropdownSizePosCache.js.map

/***/ }),
/* 1802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Panel__ = __webpack_require__(1803);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Panel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Panel_types__ = __webpack_require__(418);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Panel_types__["a"]; });


//# sourceMappingURL=index.js.map

/***/ }),
/* 1803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Panel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Panel_base__ = __webpack_require__(1804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Panel_styles__ = __webpack_require__(1805);



/**
 * Panel description
 */
var Panel = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__Panel_base__["a" /* PanelBase */], __WEBPACK_IMPORTED_MODULE_2__Panel_styles__["a" /* getStyles */], undefined, {
    scope: 'Panel'
});
//# sourceMappingURL=Panel.js.map

/***/ }),
/* 1804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PanelBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Layer__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Overlay__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Popup__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FocusTrapZone_index__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Panel_types__ = __webpack_require__(418);










var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_7__Utilities__["r" /* classNamesFunction */])();
var PanelBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](PanelBase, _super);
    function PanelBase(props) {
        var _this = _super.call(this, props) || this;
        _this._panel = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.dismiss = function (ev) {
            if (_this._isOpen) {
                _this._isOpen = false;
                if (_this.props.onDismiss) {
                    _this.props.onDismiss(ev);
                }
                if (!ev || (ev && !ev.defaultPrevented)) {
                    _this.setState({
                        isAnimating: true
                    }, function () {
                        _this._async.setTimeout(_this._onTransitionComplete, 200);
                    });
                }
            }
        };
        // Allow the user to scroll within the panel but not on the body
        _this._allowScrollOnPanel = function (elt) {
            if (elt) {
                Object(__WEBPACK_IMPORTED_MODULE_7__Utilities__["j" /* allowScrollOnElement */])(elt, _this._events);
            }
            else {
                _this._events.off(_this._scrollableContent);
            }
            _this._scrollableContent = elt;
        };
        _this._onRenderNavigation = function (props) {
            if (!_this.props.onRenderNavigationContent && !_this.props.onRenderNavigation && !_this.props.hasCloseButton) {
                return null;
            }
            var _a = _this.props.onRenderNavigationContent, onRenderNavigationContent = _a === void 0 ? _this._onRenderNavigationContent : _a;
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: _this._classNames.navigation }, onRenderNavigationContent(props, _this._onRenderNavigationContent));
        };
        _this._onRenderNavigationContent = function (props) {
            var closeButtonAriaLabel = props.closeButtonAriaLabel, hasCloseButton = props.hasCloseButton;
            var theme = Object(__WEBPACK_IMPORTED_MODULE_6__Styling__["A" /* getTheme */])();
            if (hasCloseButton) {
                // TODO -Issue #5689: Comment in once Button is converted to mergeStyles
                // const iconButtonStyles = this._classNames.subComponentStyles
                // ? (this._classNames.subComponentStyles.iconButton as IStyleFunctionOrObject<IButtonStyleProps, IButtonStyles>)
                // : undefined;
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Button__["g" /* IconButton */]
                // TODO -Issue #5689: Comment in once Button is converted to mergeStyles
                // className={iconButtonStyles}
                , { 
                    // TODO -Issue #5689: Comment in once Button is converted to mergeStyles
                    // className={iconButtonStyles}
                    styles: {
                        root: {
                            height: 'auto',
                            width: '44px',
                            color: theme.palette.neutralSecondary,
                            fontSize: __WEBPACK_IMPORTED_MODULE_6__Styling__["j" /* IconFontSizes */].large
                        },
                        rootHovered: {
                            color: theme.palette.neutralPrimary
                        }
                    }, className: _this._classNames.closeButton, onClick: _this._onPanelClick, ariaLabel: closeButtonAriaLabel, title: closeButtonAriaLabel, "data-is-visible": true, iconProps: { iconName: 'Cancel' } }));
            }
            return null;
        };
        _this._onRenderHeader = function (props, defaultRender, headerTextId) {
            var headerText = props.headerText;
            if (headerText) {
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: _this._classNames.header },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("p", { className: _this._classNames.headerText, id: headerTextId, role: "heading", "aria-level": 2 }, headerText)));
            }
            return null;
        };
        _this._onRenderBody = function (props) {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: _this._classNames.content }, props.children);
        };
        _this._onRenderFooter = function (props) {
            var _a = _this.props.onRenderFooterContent, onRenderFooterContent = _a === void 0 ? null : _a;
            if (onRenderFooterContent) {
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: _this._classNames.footer },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: _this._classNames.footerInner }, onRenderFooterContent())));
            }
            return null;
        };
        _this._onPanelClick = function (ev) {
            _this.dismiss(ev);
        };
        _this._onTransitionComplete = function () {
            _this._updateFooterPosition();
            _this.setState({
                isAnimating: false
            });
            if (_this._isOpen && _this.props.onOpened) {
                _this.props.onOpened();
            }
            if (!_this._isOpen && _this.props.onDismissed) {
                _this.props.onDismissed();
            }
        };
        _this._warnDeprecations({
            ignoreExternalFocusing: 'focusTrapZoneProps',
            forceFocusInsideTrap: 'focusTrapZoneProps',
            firstFocusableSelector: 'focusTrapZoneProps'
        });
        _this._isOpen = !!props.isOpen;
        _this.state = {
            isFooterSticky: false,
            isAnimating: false,
            id: Object(__WEBPACK_IMPORTED_MODULE_7__Utilities__["N" /* getId */])('Panel')
        };
        return _this;
    }
    PanelBase.prototype.componentDidMount = function () {
        this._events.on(window, 'resize', this._updateFooterPosition);
        if (this._shouldListenForOuterClick(this.props)) {
            this._events.on(document.body, 'mousedown', this._dismissOnOuterClick, true);
        }
        if (this.props.isOpen) {
            this.open();
        }
    };
    PanelBase.prototype.componentDidUpdate = function (previousProps) {
        var shouldListenOnOuterClick = this._shouldListenForOuterClick(this.props);
        var previousShouldListenOnOuterClick = this._shouldListenForOuterClick(previousProps);
        if (shouldListenOnOuterClick && !previousShouldListenOnOuterClick) {
            this._events.on(document.body, 'mousedown', this._dismissOnOuterClick, true);
        }
        else if (!shouldListenOnOuterClick && previousShouldListenOnOuterClick) {
            this._events.off(document.body, 'mousedown', this._dismissOnOuterClick, true);
        }
    };
    PanelBase.prototype.componentWillReceiveProps = function (newProps) {
        if (newProps.isOpen !== this._isOpen) {
            if (newProps.isOpen) {
                this.open();
            }
            else {
                this.dismiss();
            }
        }
    };
    PanelBase.prototype.render = function () {
        var _a = this.props, _b = _a.className, className = _b === void 0 ? '' : _b, elementToFocusOnDismiss = _a.elementToFocusOnDismiss, firstFocusableSelector = _a.firstFocusableSelector, focusTrapZoneProps = _a.focusTrapZoneProps, forceFocusInsideTrap = _a.forceFocusInsideTrap, hasCloseButton = _a.hasCloseButton, headerText = _a.headerText, _c = _a.headerClassName, headerClassName = _c === void 0 ? '' : _c, ignoreExternalFocusing = _a.ignoreExternalFocusing, isBlocking = _a.isBlocking, isFooterAtBottom = _a.isFooterAtBottom, isLightDismiss = _a.isLightDismiss, isHiddenOnDismiss = _a.isHiddenOnDismiss, layerProps = _a.layerProps, type = _a.type, styles = _a.styles, theme = _a.theme, customWidth = _a.customWidth, _d = _a.onLightDismissClick, onLightDismissClick = _d === void 0 ? this._onPanelClick : _d, _e = _a.onRenderNavigation, onRenderNavigation = _e === void 0 ? this._onRenderNavigation : _e, _f = _a.onRenderHeader, onRenderHeader = _f === void 0 ? this._onRenderHeader : _f, _g = _a.onRenderBody, onRenderBody = _g === void 0 ? this._onRenderBody : _g, _h = _a.onRenderFooter, onRenderFooter = _h === void 0 ? this._onRenderFooter : _h;
        var _j = this.state, isFooterSticky = _j.isFooterSticky, isAnimating = _j.isAnimating, id = _j.id;
        var isLeft = type === __WEBPACK_IMPORTED_MODULE_9__Panel_types__["a" /* PanelType */].smallFixedNear || type === __WEBPACK_IMPORTED_MODULE_9__Panel_types__["a" /* PanelType */].customNear ? true : false;
        var isRTL = Object(__WEBPACK_IMPORTED_MODULE_7__Utilities__["V" /* getRTL */])();
        var isOnRightSide = isRTL ? isLeft : !isLeft;
        var headerTextId = headerText && id + '-headerText';
        var customWidthStyles = type === __WEBPACK_IMPORTED_MODULE_9__Panel_types__["a" /* PanelType */].custom || type === __WEBPACK_IMPORTED_MODULE_9__Panel_types__["a" /* PanelType */].customNear ? { width: customWidth } : {};
        var nativeProps = Object(__WEBPACK_IMPORTED_MODULE_7__Utilities__["R" /* getNativeProps */])(this.props, __WEBPACK_IMPORTED_MODULE_7__Utilities__["w" /* divProperties */]);
        var isOpen = this._isOpen;
        if (!isOpen && !isAnimating && !isHiddenOnDismiss) {
            return null;
        }
        this._classNames = getClassNames(styles, {
            theme: theme,
            className: className,
            focusTrapZoneClassName: focusTrapZoneProps ? focusTrapZoneProps.className : undefined,
            hasCloseButton: hasCloseButton,
            headerClassName: headerClassName,
            isAnimating: isAnimating,
            isFooterSticky: isFooterSticky,
            isFooterAtBottom: isFooterAtBottom,
            isOnRightSide: isOnRightSide,
            isOpen: isOpen,
            isHiddenOnDismiss: isHiddenOnDismiss,
            type: type
        });
        var _classNames = this._classNames;
        var overlay;
        if (isBlocking && isOpen) {
            overlay = __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Overlay__["a" /* Overlay */], { className: _classNames.overlay, isDarkThemed: false, onClick: isLightDismiss ? onLightDismissClick : undefined });
        }
        var header = onRenderHeader(this.props, this._onRenderHeader, headerTextId);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Layer__["a" /* Layer */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, layerProps),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Popup__["a" /* Popup */], { role: "dialog", "aria-modal": "true", ariaLabelledBy: header ? headerTextId : undefined, onDismiss: this.dismiss, className: _classNames.hiddenPanel },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ "aria-hidden": !isOpen && isAnimating }, nativeProps, { ref: this._panel, className: _classNames.root }),
                    overlay,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__FocusTrapZone_index__["a" /* FocusTrapZone */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ ignoreExternalFocusing: ignoreExternalFocusing, forceFocusInsideTrap: !isBlocking || (isHiddenOnDismiss && !isOpen) ? false : forceFocusInsideTrap, firstFocusableSelector: firstFocusableSelector, isClickableOutsideFocusTrap: true }, focusTrapZoneProps, { className: _classNames.main, style: customWidthStyles, elementToFocusOnDismiss: elementToFocusOnDismiss }),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: _classNames.commands, "data-is-visible": true }, onRenderNavigation(this.props, this._onRenderNavigation)),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: _classNames.contentInner },
                            header,
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: this._allowScrollOnPanel, className: _classNames.scrollableContent, "data-is-scrollable": true }, onRenderBody(this.props, this._onRenderBody)),
                            onRenderFooter(this.props, this._onRenderFooter)))))));
    };
    PanelBase.prototype.open = function () {
        var _this = this;
        if (!this._isOpen) {
            this._isOpen = true;
            this.setState({
                isAnimating: true
            }, function () {
                _this._async.setTimeout(_this._onTransitionComplete, 200);
            });
            if (this.props.onOpen) {
                this.props.onOpen();
            }
        }
    };
    PanelBase.prototype._shouldListenForOuterClick = function (props) {
        return !!props.isBlocking && !!props.isOpen;
    };
    PanelBase.prototype._updateFooterPosition = function () {
        var scrollableContent = this._scrollableContent;
        if (scrollableContent) {
            var height = scrollableContent.clientHeight;
            var innerHeight_1 = scrollableContent.scrollHeight;
            this.setState({
                isFooterSticky: height < innerHeight_1 ? true : false
            });
        }
    };
    PanelBase.prototype._dismissOnOuterClick = function (ev) {
        var panel = this._panel.current;
        if (this._isOpen && panel) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_7__Utilities__["y" /* elementContains */])(panel, ev.target)) {
                if (this.props.onOuterClick) {
                    this.props.onOuterClick();
                    ev.preventDefault();
                }
                else {
                    this.dismiss();
                }
            }
        }
    };
    PanelBase.defaultProps = {
        isHiddenOnDismiss: false,
        isOpen: false,
        isBlocking: true,
        hasCloseButton: true,
        type: __WEBPACK_IMPORTED_MODULE_9__Panel_types__["a" /* PanelType */].smallFixedFar
    };
    return PanelBase;
}(__WEBPACK_IMPORTED_MODULE_7__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=Panel.base.js.map

/***/ }),
/* 1805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Panel_types__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Styling__ = __webpack_require__(5);



// TODO -Issue #5689: Comment in once Button is converted to mergeStyles
// import { IStyleFunctionOrObject } from '../../Utilities';
// import { IButtonStyles, IButtonStyleProps } from '../../Button';
var GlobalClassNames = {
    root: 'ms-Panel',
    main: 'ms-Panel-main',
    commands: 'ms-Panel-commands',
    contentInner: 'ms-Panel-contentInner',
    scrollableContent: 'ms-Panel-scrollableContent',
    navigation: 'ms-Panel-navigation',
    closeButton: 'ms-Panel-closeButton ms-PanelAction-close',
    header: 'ms-Panel-header',
    headerText: 'ms-Panel-headerText',
    content: 'ms-Panel-content',
    footer: 'ms-Panel-footer',
    footerInner: 'ms-Panel-footerInner',
    isOpen: 'is-open',
    hasCloseButton: 'ms-Panel--hasCloseButton',
    smallFluid: 'ms-Panel--smFluid',
    smallFixedNear: 'ms-Panel--smLeft',
    smallFixedFar: 'ms-Panel--sm',
    medium: 'ms-Panel--md',
    large: 'ms-Panel--lg',
    largeFixed: 'ms-Panel--fixed',
    extraLarge: 'ms-Panel--xl',
    custom: 'ms-Panel--custom',
    customNear: 'ms-Panel--customLeft'
};
var panelWidth = {
    full: '100%',
    auto: 'auto',
    xs: 272,
    sm: 340,
    md1: 592,
    md2: 644,
    lg: 940
};
var panelMargin = {
    auto: 'auto',
    none: 0,
    md: 48,
    lg: 428,
    xl: 176
};
// Following consts are used below in `getPanelBreakpoints()` function to provide
// necessary fallbacks for different types of Panel in different breakpoints.
var smallPanelSelectors = (_a = {},
    _a["@media (min-width: " + __WEBPACK_IMPORTED_MODULE_2__Styling__["o" /* ScreenWidthMinMedium */] + "px)"] = {
        width: panelWidth.sm
    },
    _a);
var mediumPanelSelectors = (_b = {},
    _b["@media (min-width: " + __WEBPACK_IMPORTED_MODULE_2__Styling__["n" /* ScreenWidthMinLarge */] + "px)"] = {
        width: panelWidth.md1
    },
    _b["@media (min-width: " + __WEBPACK_IMPORTED_MODULE_2__Styling__["q" /* ScreenWidthMinXLarge */] + "px)"] = {
        width: panelWidth.md2
    },
    _b);
var largePanelSelectors = (_c = {},
    _c["@media (min-width: " + __WEBPACK_IMPORTED_MODULE_2__Styling__["p" /* ScreenWidthMinUhfMobile */] + "px)"] = {
        left: panelMargin.md,
        width: panelWidth.auto
    },
    _c["@media (min-width: " + __WEBPACK_IMPORTED_MODULE_2__Styling__["r" /* ScreenWidthMinXXLarge */] + "px)"] = {
        left: panelMargin.lg
    },
    _c);
var largeFixedPanelSelectors = (_d = {},
    _d["@media (min-width: " + __WEBPACK_IMPORTED_MODULE_2__Styling__["r" /* ScreenWidthMinXXLarge */] + "px)"] = {
        left: panelMargin.auto,
        width: panelWidth.lg
    },
    _d);
var extraLargePanelSelectors = (_e = {},
    _e["@media (min-width: " + __WEBPACK_IMPORTED_MODULE_2__Styling__["r" /* ScreenWidthMinXXLarge */] + "px)"] = {
        left: panelMargin.xl
    },
    _e);
// Make sure Panels have fallbacks to different breakpoints by reusing same selectors.
// This is done in the effort to follow design redlines.
var getPanelBreakpoints = function (type) {
    var selectors;
    // Panel types `smallFluid`, `smallFixedNear`, `custom` and `customNear`
    // are not checked in here because they render the same in all the breakpoints
    // and have the checks done separately in the `getStyles` function below.
    switch (type) {
        case __WEBPACK_IMPORTED_MODULE_1__Panel_types__["a" /* PanelType */].smallFixedFar:
            selectors = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, smallPanelSelectors);
            break;
        case __WEBPACK_IMPORTED_MODULE_1__Panel_types__["a" /* PanelType */].medium:
            selectors = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, smallPanelSelectors, mediumPanelSelectors);
            break;
        case __WEBPACK_IMPORTED_MODULE_1__Panel_types__["a" /* PanelType */].large:
            selectors = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, smallPanelSelectors, mediumPanelSelectors, largePanelSelectors);
            break;
        case __WEBPACK_IMPORTED_MODULE_1__Panel_types__["a" /* PanelType */].largeFixed:
            selectors = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, smallPanelSelectors, mediumPanelSelectors, largePanelSelectors, largeFixedPanelSelectors);
            break;
        case __WEBPACK_IMPORTED_MODULE_1__Panel_types__["a" /* PanelType */].extraLarge:
            selectors = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, smallPanelSelectors, mediumPanelSelectors, largePanelSelectors, extraLargePanelSelectors);
            break;
        default:
            break;
    }
    return selectors;
};
var commandBarHeight = '44px';
var sharedPaddingStyles = {
    paddingLeft: '16px',
    paddingRight: '16px',
    selectors: (_f = {},
        _f["@media screen and (min-width: " + __WEBPACK_IMPORTED_MODULE_2__Styling__["n" /* ScreenWidthMinLarge */] + "px)"] = {
            paddingLeft: '32px',
            paddingRight: '32px'
        },
        _f["@media screen and (min-width: " + __WEBPACK_IMPORTED_MODULE_2__Styling__["r" /* ScreenWidthMinXXLarge */] + "px)"] = {
            paddingLeft: '40px',
            paddingRight: '40px'
        },
        _f)
};
// // TODO -Issue #5689: Comment in once Button is converted to mergeStyles
// function getIconButtonStyles(props: IPanelStyleProps): IStyleFunctionOrObject<IButtonStyleProps, IButtonStyles> {
//   const { theme } = props;
//   return () => ({
//     root: {
//       height: 'auto',
//       width: '44px',
//       color: theme.palette.neutralSecondary,
//       fontSize: IconFontSizes.large
//     },
//     rootHovered: {
//       color: theme.palette.neutralPrimary
//     }
//   });
// }
var getStyles = function (props) {
    var className = props.className, focusTrapZoneClassName = props.focusTrapZoneClassName, hasCloseButton = props.hasCloseButton, headerClassName = props.headerClassName, isAnimating = props.isAnimating, isFooterSticky = props.isFooterSticky, isFooterAtBottom = props.isFooterAtBottom, isOnRightSide = props.isOnRightSide, isOpen = props.isOpen, isHiddenOnDismiss = props.isHiddenOnDismiss, theme = props.theme, _a = props.type, type = _a === void 0 ? __WEBPACK_IMPORTED_MODULE_1__Panel_types__["a" /* PanelType */].smallFixedFar : _a;
    var palette = theme.palette;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_2__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    var isCustomPanel = type === __WEBPACK_IMPORTED_MODULE_1__Panel_types__["a" /* PanelType */].custom || type === __WEBPACK_IMPORTED_MODULE_1__Panel_types__["a" /* PanelType */].customNear;
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            isOpen && classNames.isOpen,
            hasCloseButton && classNames.hasCloseButton,
            {
                pointerEvents: 'none',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0
            },
            isCustomPanel && isOnRightSide && classNames.custom,
            isCustomPanel && !isOnRightSide && classNames.customNear,
            className
        ],
        overlay: [
            {
                pointerEvents: 'auto',
                cursor: 'pointer'
            },
            isOpen && isAnimating && __WEBPACK_IMPORTED_MODULE_2__Styling__["a" /* AnimationClassNames */].fadeIn100,
            !isOpen && isAnimating && __WEBPACK_IMPORTED_MODULE_2__Styling__["a" /* AnimationClassNames */].fadeOut100
        ],
        hiddenPanel: [
            !isOpen &&
                !isAnimating &&
                isHiddenOnDismiss && {
                visibility: 'hidden'
            }
        ],
        main: [
            classNames.main,
            {
                backgroundColor: palette.white,
                boxShadow: '0px 0px 30px 0px rgba(0,0,0,0.2)',
                pointerEvents: 'auto',
                position: 'absolute',
                display: 'flex',
                flexDirection: 'column',
                overflowX: 'hidden',
                overflowY: 'auto',
                WebkitOverflowScrolling: 'touch',
                bottom: 0,
                top: 0,
                // (left, right, width) - Properties to be overridden depending on the type of the Panel and the screen breakpoint.
                left: panelMargin.auto,
                right: panelMargin.none,
                width: panelWidth.full,
                selectors: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]((_b = {}, _b[__WEBPACK_IMPORTED_MODULE_2__Styling__["g" /* HighContrastSelector */]] = {
                    borderLeft: "3px solid " + palette.neutralLight,
                    borderRight: "3px solid " + palette.neutralLight
                }, _b), getPanelBreakpoints(type))
            },
            type === __WEBPACK_IMPORTED_MODULE_1__Panel_types__["a" /* PanelType */].smallFluid && {
                left: panelMargin.none
            },
            type === __WEBPACK_IMPORTED_MODULE_1__Panel_types__["a" /* PanelType */].smallFixedNear && {
                left: panelMargin.none,
                right: panelMargin.auto,
                width: panelWidth.xs
            },
            type === __WEBPACK_IMPORTED_MODULE_1__Panel_types__["a" /* PanelType */].customNear && {
                right: 'auto',
                left: 0
            },
            isCustomPanel && {
                maxWidth: '100vw'
            },
            isOpen && isAnimating && !isOnRightSide && __WEBPACK_IMPORTED_MODULE_2__Styling__["a" /* AnimationClassNames */].slideRightIn40,
            isOpen && isAnimating && isOnRightSide && __WEBPACK_IMPORTED_MODULE_2__Styling__["a" /* AnimationClassNames */].slideLeftIn40,
            !isOpen && isAnimating && !isOnRightSide && __WEBPACK_IMPORTED_MODULE_2__Styling__["a" /* AnimationClassNames */].slideLeftOut40,
            !isOpen && isAnimating && isOnRightSide && __WEBPACK_IMPORTED_MODULE_2__Styling__["a" /* AnimationClassNames */].slideRightOut40,
            focusTrapZoneClassName
        ],
        commands: [classNames.commands],
        navigation: [
            classNames.navigation,
            {
                padding: '0 5px',
                height: commandBarHeight,
                display: 'flex',
                justifyContent: 'flex-end'
            }
        ],
        closeButton: [classNames.closeButton],
        contentInner: [
            classNames.contentInner,
            {
                display: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
                overflowY: 'hidden'
            }
        ],
        header: [
            classNames.header,
            sharedPaddingStyles,
            {
                margin: '14px 0',
                // Ensure that title doesn't shrink if screen is too small
                flexGrow: 0,
                selectors: (_c = {},
                    _c["@media (min-width: " + __WEBPACK_IMPORTED_MODULE_2__Styling__["q" /* ScreenWidthMinXLarge */] + "px)"] = {
                        marginTop: '30px'
                    },
                    _c)
            }
        ],
        headerText: [
            classNames.headerText,
            __WEBPACK_IMPORTED_MODULE_2__Styling__["d" /* DefaultFontStyles */].xLarge,
            {
                color: palette.neutralPrimary,
                lineHeight: '32px',
                margin: 0
            },
            headerClassName
        ],
        scrollableContent: [
            classNames.scrollableContent,
            {
                overflowY: 'auto'
            },
            isFooterAtBottom && {
                flexGrow: 1
            }
        ],
        content: [
            classNames.content,
            sharedPaddingStyles,
            {
                marginBottom: 0,
                paddingBottom: 20
            }
        ],
        footer: [
            classNames.footer,
            {
                // Ensure that footer doesn't shrink if screen is too small
                flexGrow: 0,
                borderTop: '1px solid transparent',
                transition: "opacity " + __WEBPACK_IMPORTED_MODULE_2__Styling__["c" /* AnimationVariables */].durationValue3 + " " + __WEBPACK_IMPORTED_MODULE_2__Styling__["c" /* AnimationVariables */].easeFunction2
            },
            isFooterSticky && {
                background: palette.white,
                borderTopColor: palette.neutralLight
            }
        ],
        footerInner: [
            classNames.footerInner,
            sharedPaddingStyles,
            {
                paddingBottom: '20px',
                paddingTop: '20px'
            }
        ]
        // subComponentStyles: {
        //   iconButton: getIconButtonStyles(props)
        // }
    };
    var _b, _c;
};
var _a, _b, _c, _d, _e, _f;
//# sourceMappingURL=Panel.styles.js.map

/***/ }),
/* 1806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAllSelectedOptions;
function getAllSelectedOptions(options, selectedIndices) {
    var selectedOptions = [];
    for (var _i = 0, selectedIndices_1 = selectedIndices; _i < selectedIndices_1.length; _i++) {
        var index = selectedIndices_1[_i];
        var option = options[index];
        if (option) {
            selectedOptions.push(option);
        }
    }
    return selectedOptions;
}
//# sourceMappingURL=SelectableOption.js.map

/***/ }),
/* 1807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Styling__ = __webpack_require__(5);


var GlobalClassNames = {
    root: 'ms-Dropdown-container',
    label: 'ms-Dropdown-label',
    dropdown: 'ms-Dropdown',
    title: 'ms-Dropdown-title',
    caretDownWrapper: 'ms-Dropdown-caretDownWrapper',
    caretDown: 'ms-Dropdown-caretDown',
    callout: 'ms-Dropdown-callout',
    panel: 'ms-Dropdown-panel',
    dropdownItems: 'ms-Dropdown-items',
    dropdownItem: 'ms-Dropdown-item',
    dropdownDivider: 'ms-Dropdown-divider',
    dropdownOptionText: 'ms-Dropdown-optionText',
    dropdownItemHeader: 'ms-Dropdown-header',
    titleIsPlaceHolder: 'ms-Dropdown-titleIsPlaceHolder',
    titleHasError: 'ms-Dropdown-title--hasError'
};
var DROPDOWN_HEIGHT = 32;
var DROPDOWN_ITEM_HEIGHT = 32;
var highContrastAdjustMixin = (_a = {},
    _a[__WEBPACK_IMPORTED_MODULE_1__Styling__["g" /* HighContrastSelector */] + ", " + __WEBPACK_IMPORTED_MODULE_1__Styling__["i" /* HighContrastSelectorWhite */].replace('@media ', '')] = {
        MsHighContrastAdjust: 'none'
    },
    _a);
var highContrastItemAndTitleStateMixin = {
    selectors: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]((_b = {}, _b[__WEBPACK_IMPORTED_MODULE_1__Styling__["g" /* HighContrastSelector */]] = {
        backgroundColor: 'Highlight',
        borderColor: 'Highlight',
        color: 'HighlightText',
        selectors: {
            ':hover': {
                color: 'HighlightText' // overrides the hover styling for buttons that are also selected
            }
        }
    }, _b), highContrastAdjustMixin)
};
var highContrastBorderState = {
    selectors: (_c = {},
        _c[__WEBPACK_IMPORTED_MODULE_1__Styling__["g" /* HighContrastSelector */]] = {
            borderColor: 'Highlight'
        },
        _c)
};
var MinimumScreenSelector = Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["z" /* getScreenSelector */])(0, __WEBPACK_IMPORTED_MODULE_1__Styling__["o" /* ScreenWidthMinMedium */]);
var getStyles = function (props) {
    var theme = props.theme, hasError = props.hasError, hasLabel = props.hasLabel, className = props.className, isOpen = props.isOpen, disabled = props.disabled, required = props.required, isRenderingPlaceholder = props.isRenderingPlaceholder, panelClassName = props.panelClassName, calloutClassName = props.calloutClassName;
    if (!theme) {
        throw new Error('theme is undefined or null in base Dropdown getStyles function.');
    }
    var globalClassnames = Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    var palette = theme.palette, semanticColors = theme.semanticColors;
    var rootHoverFocusActiveSelectorNeutralDarkMixin = {
        color: semanticColors.menuItemTextHovered
    };
    var rootHoverFocusActiveSelectorBodySubtextMixin = {
        color: semanticColors.bodySubtext
    };
    var borderColorError = {
        borderColor: semanticColors.errorText
    };
    var dropdownItemStyle = [
        globalClassnames.dropdownItem,
        {
            backgroundColor: 'transparent',
            boxSizing: 'border-box',
            cursor: 'pointer',
            display: 'block',
            padding: '4px 16px',
            width: '100%',
            minHeight: DROPDOWN_ITEM_HEIGHT,
            lineHeight: 20,
            height: 'auto',
            position: 'relative',
            border: '1px solid transparent',
            wordWrap: 'break-word',
            overflowWrap: 'break-word',
            textAlign: 'left'
        }
    ];
    var dropdownItemSelected = dropdownItemStyle.concat([
        {
            backgroundColor: palette.neutralQuaternaryAlt,
            color: palette.black
        },
        highContrastItemAndTitleStateMixin
    ]);
    var dropdownItemDisabled = dropdownItemStyle.concat([
        {
            color: semanticColors.disabledText,
            cursor: 'default'
        }
    ]);
    return {
        root: globalClassnames.root,
        label: globalClassnames.label,
        dropdown: [
            globalClassnames.dropdown,
            __WEBPACK_IMPORTED_MODULE_1__Styling__["H" /* normalize */],
            __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, theme.fonts.medium, { color: semanticColors.menuItemText, position: 'relative', outline: 0, userSelect: 'none', selectors: (_a = {},
                    _a['&:hover .' + globalClassnames.title] = [
                        !disabled && rootHoverFocusActiveSelectorNeutralDarkMixin,
                        { borderColor: palette.neutralDark },
                        highContrastBorderState
                    ],
                    _a['&:focus .' + globalClassnames.title] = [
                        !disabled && rootHoverFocusActiveSelectorNeutralDarkMixin,
                        {
                            borderColor: palette.themePrimary /* see https://github.com/OfficeDev/office-ui-fabric-react/pull/9182 for semantic color disc */
                        },
                        highContrastItemAndTitleStateMixin
                    ],
                    _a['&:active .' + globalClassnames.title] = [
                        !disabled && rootHoverFocusActiveSelectorNeutralDarkMixin,
                        { borderColor: palette.themeDark },
                        highContrastBorderState
                    ],
                    _a['&:hover .' + globalClassnames.caretDown] = !disabled && rootHoverFocusActiveSelectorNeutralDarkMixin,
                    _a['&:focus .' + globalClassnames.caretDown] = [
                        !disabled && rootHoverFocusActiveSelectorNeutralDarkMixin,
                        { selectors: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]((_b = {}, _b[__WEBPACK_IMPORTED_MODULE_1__Styling__["g" /* HighContrastSelector */]] = { color: 'HighlightText' }, _b), highContrastAdjustMixin) }
                    ],
                    _a['&:active .' + globalClassnames.caretDown] = !disabled && rootHoverFocusActiveSelectorNeutralDarkMixin,
                    _a['&:hover .' + globalClassnames.titleIsPlaceHolder] = rootHoverFocusActiveSelectorBodySubtextMixin,
                    _a['&:focus .' + globalClassnames.titleIsPlaceHolder] = rootHoverFocusActiveSelectorBodySubtextMixin,
                    _a['&:active .' + globalClassnames.titleIsPlaceHolder] = rootHoverFocusActiveSelectorBodySubtextMixin,
                    _a['&:hover .' + globalClassnames.titleHasError] = borderColorError,
                    _a['&:active .' + globalClassnames.titleHasError] = borderColorError,
                    _a['&:focus .' + globalClassnames.titleHasError] = borderColorError,
                    _a) }),
            className,
            isOpen && 'is-open',
            disabled && 'is-disabled',
            required && 'is-required',
            required &&
                !hasLabel && {
                selectors: (_c = {
                        ':after': {
                            content: "'*'",
                            color: semanticColors.errorText,
                            position: 'absolute',
                            top: -5,
                            right: -10
                        }
                    },
                    _c[__WEBPACK_IMPORTED_MODULE_1__Styling__["g" /* HighContrastSelector */]] = {
                        selectors: {
                            ':after': {
                                right: -14 // moving the * 4 pixel to right to alleviate border clipping in HC mode.
                            }
                        }
                    },
                    _c)
            }
        ],
        title: [
            globalClassnames.title,
            __WEBPACK_IMPORTED_MODULE_1__Styling__["H" /* normalize */],
            {
                backgroundColor: semanticColors.inputBackground,
                borderWidth: 1,
                borderStyle: 'solid',
                borderColor: semanticColors.inputBorder,
                cursor: 'pointer',
                display: 'block',
                height: DROPDOWN_HEIGHT,
                lineHeight: DROPDOWN_HEIGHT - 2,
                padding: "0 " + DROPDOWN_HEIGHT + "px 0 12px",
                position: 'relative',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis'
            },
            isRenderingPlaceholder && [globalClassnames.titleIsPlaceHolder, { color: semanticColors.inputPlaceholderText }],
            hasError && [globalClassnames.titleHasError, borderColorError],
            disabled && {
                backgroundColor: semanticColors.disabledBackground,
                border: 'none',
                color: semanticColors.disabledText,
                cursor: 'default',
                selectors: (_d = {}, _d[__WEBPACK_IMPORTED_MODULE_1__Styling__["g" /* HighContrastSelector */]] = { border: '1px solid GrayText', color: 'GrayText' }, _d)
            }
        ],
        caretDownWrapper: [
            globalClassnames.caretDownWrapper,
            {
                position: 'absolute',
                top: 1,
                right: 12,
                height: DROPDOWN_HEIGHT,
                lineHeight: DROPDOWN_HEIGHT - 2 // height minus the border
            },
            !disabled && {
                cursor: 'pointer'
            }
        ],
        caretDown: [
            globalClassnames.caretDown,
            { color: semanticColors.bodySubtext, fontSize: __WEBPACK_IMPORTED_MODULE_1__Styling__["e" /* FontSizes */].small, pointerEvents: 'none' },
            disabled && { color: semanticColors.disabledText, selectors: (_e = {}, _e[__WEBPACK_IMPORTED_MODULE_1__Styling__["g" /* HighContrastSelector */]] = { color: 'GrayText' }, _e) }
        ],
        errorMessage: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ color: semanticColors.errorText }, theme.fonts.small, { paddingTop: 5 }),
        callout: [
            globalClassnames.callout,
            {
                boxShadow: '0 0 2px 0 rgba(0,0,0,0.2)',
                border: "1px solid " + semanticColors.variantBorder
            },
            calloutClassName
        ],
        dropdownItemsWrapper: { selectors: { '&:focus': { outline: 0 } } },
        dropdownItems: [globalClassnames.dropdownItems, { display: 'block' }],
        dropdownItem: dropdownItemStyle.concat([
            {
                selectors: (_f = {},
                    _f[__WEBPACK_IMPORTED_MODULE_1__Styling__["g" /* HighContrastSelector */]] = {
                        borderColor: 'Window'
                    },
                    _f['&:hover'] = {
                        color: 'inherit'
                    },
                    _f['&:focus'] = {
                        backgroundColor: semanticColors.listItemBackgroundHovered
                    },
                    _f['&:active'] = {
                        backgroundColor: semanticColors.listHeaderBackgroundHovered,
                        color: palette.black
                    },
                    _f)
            }
        ]),
        dropdownItemSelected: dropdownItemSelected,
        dropdownItemDisabled: dropdownItemDisabled,
        dropdownItemSelectedAndDisabled: [dropdownItemSelected, dropdownItemDisabled, { backgroundColor: 'transparent' }],
        dropdownItemHidden: dropdownItemStyle.concat([{ display: 'none' }]),
        dropdownDivider: [globalClassnames.dropdownDivider, { height: 1, backgroundColor: semanticColors.bodyDivider }],
        dropdownOptionText: [
            globalClassnames.dropdownOptionText,
            {
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                minWidth: 0,
                maxWidth: '100%',
                wordWrap: 'break-word',
                overflowWrap: 'break-word',
                margin: '1px'
            }
        ],
        dropdownItemHeader: [
            globalClassnames.dropdownItemHeader,
            __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, theme.fonts.medium, { fontWeight: __WEBPACK_IMPORTED_MODULE_1__Styling__["f" /* FontWeights */].semibold, color: semanticColors.menuHeader, background: 'none', backgroundColor: 'transparent', border: 'none', height: DROPDOWN_ITEM_HEIGHT, lineHeight: DROPDOWN_ITEM_HEIGHT, cursor: 'default', padding: '0px 16px', userSelect: 'none', textAlign: 'left' })
        ],
        subComponentStyles: {
            label: { root: { display: 'inline-block' } },
            panel: {
                root: [panelClassName],
                main: {
                    // Force drop shadow even under medium breakpoint
                    boxShadow: '-30px 0px 30px -30px rgba(0,0,0,0.2)',
                    selectors: (_g = {},
                        // In case of extra small screen sizes
                        _g[MinimumScreenSelector] = {
                            // panelWidth xs
                            width: 272
                        },
                        _g)
                },
                contentInner: { padding: '0 0 20px' }
            }
        }
    };
    var _a, _b, _c, _d, _e, _f, _g;
};
var _a, _b, _c;
//# sourceMappingURL=Dropdown.styles.js.map

/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(0)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports.reactTextMask=t(require("react")):e.reactTextMask=t(e.React)}(this,function(e){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={exports:{},id:n,loaded:!1};return e[n].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var r={};return t.m=e,t.c=r,t.p="",t(0)}([function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var r={};for(var n in e)t.indexOf(n)>=0||Object.prototype.hasOwnProperty.call(e,n)&&(r[n]=e[n]);return r}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.conformToMask=void 0;var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},l=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),f=r(3);Object.defineProperty(t,"conformToMask",{enumerable:!0,get:function(){return n(f).default}});var c=r(11),p=n(c),d=r(9),h=n(d),v=r(5),y=n(v),m=r(2),b=function(e){function t(){var e;i(this,t);for(var r=arguments.length,n=Array(r),o=0;o<r;o++)n[o]=arguments[o];var u=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(n)));return u.setRef=u.setRef.bind(u),u.onBlur=u.onBlur.bind(u),u.onChange=u.onChange.bind(u),u}return u(t,e),l(t,[{key:"setRef",value:function(e){this.inputElement=e}},{key:"initTextMask",value:function(){var e=this.props,t=this.props.value;this.textMaskInputElement=(0,y.default)(s({inputElement:this.inputElement},e)),this.textMaskInputElement.update(t)}},{key:"componentDidMount",value:function(){this.initTextMask()}},{key:"componentDidUpdate",value:function(e){var t=this.props,r=t.value,n=t.pipe,o=t.mask,i=t.guide,a=t.placeholderChar,u=t.showMask,s={guide:i,placeholderChar:a,showMask:u},l="function"==typeof n&&"function"==typeof e.pipe?n.toString()!==e.pipe.toString():(0,m.isNil)(n)&&!(0,m.isNil)(e.pipe)||!(0,m.isNil)(n)&&(0,m.isNil)(e.pipe),f=o.toString()!==e.mask.toString(),c=Object.keys(s).some(function(t){return s[t]!==e[t]})||f||l,p=r!==this.inputElement.value;(p||c)&&this.initTextMask()}},{key:"render",value:function e(){var t=this.props,e=t.render,r=o(t,["render"]);return delete r.mask,delete r.guide,delete r.pipe,delete r.placeholderChar,delete r.keepCharPositions,delete r.value,delete r.onBlur,delete r.onChange,delete r.showMask,e(this.setRef,s({onBlur:this.onBlur,onChange:this.onChange,defaultValue:this.props.value},r))}},{key:"onChange",value:function(e){this.textMaskInputElement.update(),"function"==typeof this.props.onChange&&this.props.onChange(e)}},{key:"onBlur",value:function(e){"function"==typeof this.props.onBlur&&this.props.onBlur(e)}}]),t}(p.default.PureComponent);t.default=b,b.propTypes={mask:h.default.oneOfType([h.default.array,h.default.func,h.default.bool,h.default.shape({mask:h.default.oneOfType([h.default.array,h.default.func]),pipe:h.default.func})]).isRequired,guide:h.default.bool,value:h.default.oneOfType([h.default.string,h.default.number]),pipe:h.default.func,placeholderChar:h.default.string,keepCharPositions:h.default.bool,showMask:h.default.bool},b.defaultProps={render:function(e,t){return p.default.createElement("input",s({ref:e},t))}}},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.placeholderChar="_",t.strFunction="function"},function(e,t,r){"use strict";function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:f,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:l.placeholderChar;if(!o(e))throw new Error("Text-mask:convertMaskToPlaceholder; The mask property must be an array.");if(e.indexOf(t)!==-1)throw new Error("Placeholder character must not be used as part of the mask. Please specify a character that is not present in your mask as your placeholder character.\n\n"+("The placeholder character that was received is: "+JSON.stringify(t)+"\n\n")+("The mask that was received is: "+JSON.stringify(e)));return e.map(function(e){return e instanceof RegExp?t:e}).join("")}function o(e){return Array.isArray&&Array.isArray(e)||e instanceof Array}function i(e){return"string"==typeof e||e instanceof String}function a(e){return"number"==typeof e&&void 0===e.length&&!isNaN(e)}function u(e){return"undefined"==typeof e||null===e}function s(e){for(var t=[],r=void 0;r=e.indexOf(c),r!==-1;)t.push(r),e.splice(r,1);return{maskWithoutCaretTraps:e,indexes:t}}Object.defineProperty(t,"__esModule",{value:!0}),t.convertMaskToPlaceholder=n,t.isArray=o,t.isString=i,t.isNumber=a,t.isNil=u,t.processCaretTraps=s;var l=r(1),f=[],c="[]"},function(e,t,r){"use strict";function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:s,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:u,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};if(!(0,i.isArray)(t)){if(("undefined"==typeof t?"undefined":o(t))!==a.strFunction)throw new Error("Text-mask:conformToMask; The mask property must be an array.");t=t(e,r),t=(0,i.processCaretTraps)(t).maskWithoutCaretTraps}var n=r.guide,l=void 0===n||n,f=r.previousConformedValue,c=void 0===f?s:f,p=r.placeholderChar,d=void 0===p?a.placeholderChar:p,h=r.placeholder,v=void 0===h?(0,i.convertMaskToPlaceholder)(t,d):h,y=r.currentCaretPosition,m=r.keepCharPositions,b=l===!1&&void 0!==c,g=e.length,k=c.length,C=v.length,O=t.length,T=g-k,P=T>0,x=y+(P?-T:0),w=x+Math.abs(T);if(m===!0&&!P){for(var S=s,_=x;_<w;_++)v[_]===d&&(S+=d);e=e.slice(0,x)+S+e.slice(x,g)}for(var M=e.split(s).map(function(e,t){return{char:e,isNew:t>=x&&t<w}}),j=g-1;j>=0;j--){var E=M[j].char;if(E!==d){var R=j>=x&&k===O;E===v[R?j-T:j]&&M.splice(j,1)}}var V=s,N=!1;e:for(var A=0;A<C;A++){var B=v[A];if(B===d){if(M.length>0)for(;M.length>0;){var I=M.shift(),F=I.char,q=I.isNew;if(F===d&&b!==!0){V+=d;continue e}if(t[A].test(F)){if(m===!0&&q!==!1&&c!==s&&l!==!1&&P){for(var D=M.length,L=null,W=0;W<D;W++){var J=M[W];if(J.char!==d&&J.isNew===!1)break;if(J.char===d){L=W;break}}null!==L?(V+=F,M.splice(L,1)):A--}else V+=F;continue e}N=!0}b===!1&&(V+=v.substr(A,C));break}V+=B}if(b&&P===!1){for(var U=null,H=0;H<V.length;H++)v[H]===d&&(U=H);V=null!==U?V.substr(0,U+1):s}return{conformedValue:V,meta:{someCharsRejected:N}}}Object.defineProperty(t,"__esModule",{value:!0});var o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=n;var i=r(2),a=r(1),u=[],s=""},function(e,t){"use strict";function r(e){var t=e.previousConformedValue,r=void 0===t?o:t,i=e.previousPlaceholder,a=void 0===i?o:i,u=e.currentCaretPosition,s=void 0===u?0:u,l=e.conformedValue,f=e.rawValue,c=e.placeholderChar,p=e.placeholder,d=e.indexesOfPipedChars,h=void 0===d?n:d,v=e.caretTrapIndexes,y=void 0===v?n:v;if(0===s||!f.length)return 0;var m=f.length,b=r.length,g=p.length,k=l.length,C=m-b,O=C>0,T=0===b,P=C>1&&!O&&!T;if(P)return s;var x=O&&(r===l||l===p),w=0,S=void 0,_=void 0;if(x)w=s-C;else{var M=l.toLowerCase(),j=f.toLowerCase(),E=j.substr(0,s).split(o),R=E.filter(function(e){return M.indexOf(e)!==-1});_=R[R.length-1];var V=a.substr(0,R.length).split(o).filter(function(e){return e!==c}).length,N=p.substr(0,R.length).split(o).filter(function(e){return e!==c}).length,A=N!==V,B=void 0!==a[R.length-1]&&void 0!==p[R.length-2]&&a[R.length-1]!==c&&a[R.length-1]!==p[R.length-1]&&a[R.length-1]===p[R.length-2];!O&&(A||B)&&V>0&&p.indexOf(_)>-1&&void 0!==f[s]&&(S=!0,_=f[s]);for(var I=h.map(function(e){return M[e]}),F=I.filter(function(e){return e===_}).length,q=R.filter(function(e){return e===_}).length,D=p.substr(0,p.indexOf(c)).split(o).filter(function(e,t){return e===_&&f[t]!==e}).length,L=D+q+F+(S?1:0),W=0,J=0;J<k;J++){var U=M[J];if(w=J+1,U===_&&W++,W>=L)break}}if(O){for(var H=w,Y=w;Y<=g;Y++)if(p[Y]===c&&(H=Y),p[Y]===c||y.indexOf(Y)!==-1||Y===g)return H}else if(S){for(var z=w-1;z>=0;z--)if(l[z]===_||y.indexOf(z)!==-1||0===z)return z}else for(var G=w;G>=0;G--)if(p[G-1]===c||y.indexOf(G)!==-1||0===G)return G}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;var n=[],o=""},function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function o(e){var t={previousConformedValue:void 0,previousPlaceholder:void 0};return{state:t,update:function(r){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:e,o=n.inputElement,l=n.mask,c=n.guide,y=n.pipe,b=n.placeholderChar,g=void 0===b?h.placeholderChar:b,k=n.keepCharPositions,C=void 0!==k&&k,O=n.showMask,T=void 0!==O&&O;if("undefined"==typeof r&&(r=o.value),r!==t.previousConformedValue){("undefined"==typeof l?"undefined":s(l))===m&&void 0!==l.pipe&&void 0!==l.mask&&(y=l.pipe,l=l.mask);var P=void 0,x=void 0;if(l instanceof Array&&(P=(0,d.convertMaskToPlaceholder)(l,g)),l!==!1){var w=a(r),S=o.selectionEnd,_=t.previousConformedValue,M=t.previousPlaceholder,j=void 0;if(("undefined"==typeof l?"undefined":s(l))===h.strFunction){if(x=l(w,{currentCaretPosition:S,previousConformedValue:_,placeholderChar:g}),x===!1)return;var E=(0,d.processCaretTraps)(x),R=E.maskWithoutCaretTraps,V=E.indexes;x=R,j=V,P=(0,d.convertMaskToPlaceholder)(x,g)}else x=l;var N={previousConformedValue:_,guide:c,placeholderChar:g,pipe:y,placeholder:P,currentCaretPosition:S,keepCharPositions:C},A=(0,p.default)(w,x,N),B=A.conformedValue,I=("undefined"==typeof y?"undefined":s(y))===h.strFunction,F={};I&&(F=y(B,u({rawValue:w},N)),F===!1?F={value:_,rejected:!0}:(0,d.isString)(F)&&(F={value:F}));var q=I?F.value:B,D=(0,f.default)({previousConformedValue:_,previousPlaceholder:M,conformedValue:q,placeholder:P,rawValue:w,currentCaretPosition:S,placeholderChar:g,indexesOfPipedChars:F.indexesOfPipedChars,caretTrapIndexes:j}),L=q===P&&0===D,W=T?P:v,J=L?W:q;t.previousConformedValue=J,t.previousPlaceholder=P,o.value!==J&&(o.value=J,i(o,D))}}}}}function i(e,t){document.activeElement===e&&(b?g(function(){return e.setSelectionRange(t,t,y)},0):e.setSelectionRange(t,t,y))}function a(e){if((0,d.isString)(e))return e;if((0,d.isNumber)(e))return String(e);if(void 0===e||null===e)return v;throw new Error("The 'value' provided to Text Mask needs to be a string or a number. The value received was:\n\n "+JSON.stringify(e))}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=o;var l=r(4),f=n(l),c=r(3),p=n(c),d=r(2),h=r(1),v="",y="none",m="object",b="undefined"!=typeof navigator&&/Android/i.test(navigator.userAgent),g="undefined"!=typeof requestAnimationFrame?requestAnimationFrame:setTimeout},function(e,t){"use strict";function r(e){return function(){return e}}var n=function(){};n.thatReturns=r,n.thatReturnsFalse=r(!1),n.thatReturnsTrue=r(!0),n.thatReturnsNull=r(null),n.thatReturnsThis=function(){return this},n.thatReturnsArgument=function(e){return e},e.exports=n},function(e,t,r){"use strict";function n(e,t,r,n,i,a,u,s){if(o(t),!e){var l;if(void 0===t)l=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var f=[r,n,i,a,u,s],c=0;l=new Error(t.replace(/%s/g,function(){return f[c++]})),l.name="Invariant Violation"}throw l.framesToPop=1,l}}var o=function(e){};e.exports=n},function(e,t,r){"use strict";var n=r(6),o=r(7),i=r(10);e.exports=function(){function e(e,t,r,n,a,u){u!==i&&o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var r={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return r.checkPropTypes=n,r.PropTypes=r,r}},function(e,t,r){"use strict";"function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},e.exports=r(8)()},function(e,t){"use strict";var r="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=r},function(t,r){t.exports=e}])});

/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.createNumberMask=t():e.createNumberMask=t()}(this,function(){return function(e){function t(n){if(o[n])return o[n].exports;var i=o[n]={exports:{},id:n,loaded:!1};return e[n].call(i.exports,i,i.exports,t),i.loaded=!0,i.exports}var o={};return t.m=e,t.c=o,t.p="",t(0)}([function(e,t,o){e.exports=o(2)},,function(e,t){"use strict";function o(){function e(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:l,t=e.length;if(e===l||e[0]===y[0]&&1===t)return y.split(l).concat([v]).concat(g.split(l));if(e===k&&M)return y.split(l).concat(["0",k,v]).concat(g.split(l));var o=e[0]===s&&q;o&&(e=e.toString().substr(1));var c=e.lastIndexOf(k),u=c!==-1,a=void 0,b=void 0,h=void 0;if(e.slice(T*-1)===g&&(e=e.slice(0,T*-1)),u&&(M||$)?(a=e.slice(e.slice(0,R)===y?R:0,c),b=e.slice(c+1,t),b=n(b.replace(f,l))):a=e.slice(0,R)===y?e.slice(R):e,P&&("undefined"==typeof P?"undefined":r(P))===p){var S="."===j?"[.]":""+j,w=(a.match(new RegExp(S,"g"))||[]).length;a=a.slice(0,P+w*Z)}return a=a.replace(f,l),E||(a=a.replace(/^0+(0$|[^0])/,"$1")),a=x?i(a,j):a,h=n(a),(u&&M||$===!0)&&(e[c-1]!==k&&h.push(m),h.push(k,m),b&&(("undefined"==typeof L?"undefined":r(L))===p&&(b=b.slice(0,L)),h=h.concat(b)),$===!0&&e[c-1]===k&&h.push(v)),R>0&&(h=y.split(l).concat(h)),o&&(h.length===R&&h.push(v),h=[d].concat(h)),g.length>0&&(h=h.concat(g.split(l))),h}var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},o=t.prefix,y=void 0===o?c:o,b=t.suffix,g=void 0===b?l:b,h=t.includeThousandsSeparator,x=void 0===h||h,S=t.thousandsSeparatorSymbol,j=void 0===S?u:S,w=t.allowDecimal,M=void 0!==w&&w,N=t.decimalSymbol,k=void 0===N?a:N,D=t.decimalLimit,L=void 0===D?2:D,O=t.requireDecimal,$=void 0!==O&&O,_=t.allowNegative,q=void 0!==_&&_,B=t.allowLeadingZeroes,E=void 0!==B&&B,I=t.integerLimit,P=void 0===I?null:I,R=y&&y.length||0,T=g&&g.length||0,Z=j&&j.length||0;return e.instanceOf="createNumberMask",e}function n(e){return e.split(l).map(function(e){return v.test(e)?v:e})}function i(e,t){return e.replace(/\B(?=(\d{3})+(?!\d))/g,t)}Object.defineProperty(t,"__esModule",{value:!0});var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=o;var c="$",l="",u=",",a=".",s="-",d=/-/,f=/\D+/g,p="number",v=/\d/,m="[]"}])});

/***/ }),
/* 1810 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DatePicker__ = __webpack_require__(1812);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__DatePicker__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DatePicker_base__ = __webpack_require__(732);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Calendar_Calendar_types__ = __webpack_require__(733);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Calendar_Calendar_types__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 1812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DatePicker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DatePicker_base__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DatePicker_styles__ = __webpack_require__(1819);



/**
 * DatePicker description
 */
var DatePicker = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__DatePicker_base__["a" /* DatePickerBase */], __WEBPACK_IMPORTED_MODULE_2__DatePicker_styles__["a" /* styles */], undefined, {
    scope: 'DatePicker'
});
//# sourceMappingURL=DatePicker.js.map

/***/ }),
/* 1813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Calendar__ = __webpack_require__(1814);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Calendar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Calendar_types__ = __webpack_require__(733);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Calendar_types__["a"]; });


//# sourceMappingURL=index.js.map

/***/ }),
/* 1814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Calendar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_dateValues_DateValues__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CalendarDay__ = __webpack_require__(1815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CalendarMonth__ = __webpack_require__(1817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_dateMath_DateMath__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Calendar_scss__ = __webpack_require__(277);








var styles = __WEBPACK_IMPORTED_MODULE_7__Calendar_scss__;
var leftArrow = 'Up';
var rightArrow = 'Down';
var closeIcon = 'CalculatorMultiply';
var iconStrings = {
    leftNavigation: leftArrow,
    rightNavigation: rightArrow,
    closeIcon: closeIcon
};
var defaultWorkWeekDays = [__WEBPACK_IMPORTED_MODULE_2__utilities_dateValues_DateValues__["b" /* DayOfWeek */].Monday, __WEBPACK_IMPORTED_MODULE_2__utilities_dateValues_DateValues__["b" /* DayOfWeek */].Tuesday, __WEBPACK_IMPORTED_MODULE_2__utilities_dateValues_DateValues__["b" /* DayOfWeek */].Wednesday, __WEBPACK_IMPORTED_MODULE_2__utilities_dateValues_DateValues__["b" /* DayOfWeek */].Thursday, __WEBPACK_IMPORTED_MODULE_2__utilities_dateValues_DateValues__["b" /* DayOfWeek */].Friday];
var dateTimeFormatterCallbacks = {
    formatMonthDayYear: function (date, strings) {
        return strings.months[date.getMonth()] + ' ' + date.getDate() + ', ' + date.getFullYear();
    },
    formatMonthYear: function (date, strings) { return strings.months[date.getMonth()] + ' ' + date.getFullYear(); },
    formatDay: function (date) { return date.getDate().toString(); },
    formatYear: function (date) { return date.getFullYear().toString(); }
};
var Calendar = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](Calendar, _super);
    function Calendar(props) {
        var _this = _super.call(this, props) || this;
        _this._dayPicker = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._monthPicker = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._navigateDayPickerDay = function (date) {
            _this.setState({
                navigatedDayDate: date,
                navigatedMonthDate: date
            });
        };
        _this._navigateMonthPickerDay = function (date) {
            _this.setState({
                navigatedMonthDate: date
            });
        };
        _this._onNavigateDayDate = function (date, focusOnNavigatedDay) {
            _this._navigateDayPickerDay(date);
            _this._focusOnUpdate = focusOnNavigatedDay;
        };
        _this._onNavigateMonthDate = function (date, focusOnNavigatedDay) {
            if (!focusOnNavigatedDay) {
                _this._navigateMonthPickerDay(date);
                _this._focusOnUpdate = focusOnNavigatedDay;
                return;
            }
            var monthPickerOnly = !_this.props.showMonthPickerAsOverlay && !_this.props.isDayPickerVisible;
            if (monthPickerOnly) {
                _this._onSelectDate(date);
            }
            _this._navigateDayPickerDay(date);
        };
        _this._onSelectDate = function (date, selectedDateRangeArray) {
            var onSelectDate = _this.props.onSelectDate;
            _this.setState({
                selectedDate: date
            });
            if (onSelectDate) {
                onSelectDate(date, selectedDateRangeArray);
            }
        };
        _this._onHeaderSelect = function (focus) {
            _this.setState({
                isDayPickerVisible: !_this.state.isDayPickerVisible,
                isMonthPickerVisible: !_this.state.isMonthPickerVisible
            });
            if (focus) {
                _this._focusOnUpdate = true;
            }
        };
        _this._onGotoToday = function () {
            var _a = _this.props, dateRangeType = _a.dateRangeType, firstDayOfWeek = _a.firstDayOfWeek, today = _a.today, workWeekDays = _a.workWeekDays, selectDateOnClick = _a.selectDateOnClick;
            if (selectDateOnClick) {
                // When using Defaultprops, TypeScript doesn't know that React is going to inject defaults
                // so we use exclamation mark as a hint to the type checker (see link below)
                // https://decembersoft.com/posts/error-ts2532-optional-react-component-props-in-typescript/
                var dates = Object(__WEBPACK_IMPORTED_MODULE_5__utilities_dateMath_DateMath__["g" /* getDateRangeArray */])(today, dateRangeType, firstDayOfWeek, workWeekDays);
                _this._onSelectDate(today, dates);
            }
            _this._navigateDayPickerDay(today);
            _this._focusOnUpdate = true;
        };
        _this._onGotoTodayClick = function (ev) {
            _this._onGotoToday();
        };
        _this._onGotoTodayKeyDown = function (ev) {
            if (ev.which === __WEBPACK_IMPORTED_MODULE_6__Utilities__["g" /* KeyCodes */].enter) {
                ev.preventDefault();
                _this._onGotoToday();
            }
        };
        _this._onDatePickerPopupKeyDown = function (ev) {
            switch (ev.which) {
                case __WEBPACK_IMPORTED_MODULE_6__Utilities__["g" /* KeyCodes */].enter:
                    ev.preventDefault();
                    break;
                case __WEBPACK_IMPORTED_MODULE_6__Utilities__["g" /* KeyCodes */].backspace:
                    ev.preventDefault();
                    break;
                case __WEBPACK_IMPORTED_MODULE_6__Utilities__["g" /* KeyCodes */].escape:
                    _this._handleEscKey(ev);
                    break;
                default:
                    break;
            }
        };
        _this._handleEscKey = function (ev) {
            if (_this.props.onDismiss) {
                _this.props.onDismiss();
            }
        };
        var currentDate = props.value && !isNaN(props.value.getTime()) ? props.value : props.today || new Date();
        _this.state = {
            selectedDate: currentDate,
            navigatedDayDate: currentDate,
            navigatedMonthDate: currentDate,
            /** When showMonthPickerAsOverlay is active it overrides isMonthPickerVisible/isDayPickerVisible props
             (These props permanently set the visibility of their respective calendars). */
            isMonthPickerVisible: _this.props.showMonthPickerAsOverlay ? false : _this.props.isMonthPickerVisible,
            isDayPickerVisible: _this.props.showMonthPickerAsOverlay ? true : _this.props.isDayPickerVisible
        };
        _this._focusOnUpdate = false;
        return _this;
    }
    Calendar.prototype.componentWillReceiveProps = function (nextProps) {
        var autoNavigateOnSelection = nextProps.autoNavigateOnSelection, value = nextProps.value, _a = nextProps.today, today = _a === void 0 ? new Date() : _a;
        // Make sure auto-navigation is supported for programmatic changes to selected date, i.e.,
        // if selected date is updated via props, we may need to modify the navigated date
        var overrideNavigatedDate = autoNavigateOnSelection && !Object(__WEBPACK_IMPORTED_MODULE_5__utilities_dateMath_DateMath__["f" /* compareDates */])(value, this.props.value);
        if (overrideNavigatedDate) {
            this.setState({
                navigatedMonthDate: value,
                navigatedDayDate: value
            });
        }
        this.setState({
            selectedDate: value || today
        });
    };
    Calendar.prototype.componentDidUpdate = function () {
        if (this._focusOnUpdate) {
            this.focus();
            this._focusOnUpdate = false;
        }
    };
    Calendar.prototype.render = function () {
        var rootClass = 'ms-DatePicker';
        var _a = this.props, firstDayOfWeek = _a.firstDayOfWeek, dateRangeType = _a.dateRangeType, strings = _a.strings, showMonthPickerAsOverlay = _a.showMonthPickerAsOverlay, autoNavigateOnSelection = _a.autoNavigateOnSelection, showGoToToday = _a.showGoToToday, highlightCurrentMonth = _a.highlightCurrentMonth, highlightSelectedMonth = _a.highlightSelectedMonth, navigationIcons = _a.navigationIcons, minDate = _a.minDate, maxDate = _a.maxDate, restrictedDates = _a.restrictedDates, className = _a.className, showCloseButton = _a.showCloseButton, allFocusable = _a.allFocusable, yearPickerHidden = _a.yearPickerHidden, today = _a.today;
        var nativeProps = Object(__WEBPACK_IMPORTED_MODULE_6__Utilities__["R" /* getNativeProps */])(this.props, __WEBPACK_IMPORTED_MODULE_6__Utilities__["w" /* divProperties */], ['value']);
        var _b = this.state, selectedDate = _b.selectedDate, navigatedDayDate = _b.navigatedDayDate, navigatedMonthDate = _b.navigatedMonthDate, isMonthPickerVisible = _b.isMonthPickerVisible, isDayPickerVisible = _b.isDayPickerVisible;
        var onHeaderSelect = showMonthPickerAsOverlay ? this._onHeaderSelect : undefined;
        var monthPickerOnly = !showMonthPickerAsOverlay && !isDayPickerVisible;
        var overlayedWithButton = showMonthPickerAsOverlay && showGoToToday;
        var goTodayEnabled = showGoToToday;
        if (goTodayEnabled && navigatedDayDate && navigatedMonthDate && today) {
            goTodayEnabled =
                navigatedDayDate.getFullYear() !== today.getFullYear() ||
                    navigatedDayDate.getMonth() !== today.getMonth() ||
                    navigatedMonthDate.getFullYear() !== today.getFullYear() ||
                    navigatedMonthDate.getMonth() !== today.getMonth();
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: Object(__WEBPACK_IMPORTED_MODULE_6__Utilities__["t" /* css */])(rootClass, styles.root, className), role: "application" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, nativeProps, { className: Object(__WEBPACK_IMPORTED_MODULE_6__Utilities__["t" /* css */])('ms-DatePicker-picker ms-DatePicker-picker--opened ms-DatePicker-picker--focused', styles.picker, styles.pickerIsOpened, styles.pickerIsFocused, isMonthPickerVisible && 'ms-DatePicker-monthPickerVisible ' + styles.monthPickerVisible, isMonthPickerVisible && isDayPickerVisible && 'ms-DatePicker-calendarsInline ' + styles.calendarsInline, monthPickerOnly && 'ms-DatePicker-monthPickerOnly ' + styles.monthPickerOnly, showMonthPickerAsOverlay && 'ms-DatePicker-monthPickerAsOverlay ' + styles.monthPickerAsOverlay) }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: Object(__WEBPACK_IMPORTED_MODULE_6__Utilities__["t" /* css */])('ms-DatePicker-holder ms-slideDownIn10', styles.holder, overlayedWithButton && styles.holderWithButton), onKeyDown: this._onDatePickerPopupKeyDown },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: Object(__WEBPACK_IMPORTED_MODULE_6__Utilities__["t" /* css */])('ms-DatePicker-frame', styles.frame) },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: Object(__WEBPACK_IMPORTED_MODULE_6__Utilities__["t" /* css */])('ms-DatePicker-wrap', styles.wrap, showGoToToday && styles.goTodaySpacing) },
                            isDayPickerVisible && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__CalendarDay__["a" /* CalendarDay */], { selectedDate: selectedDate, navigatedDate: navigatedDayDate, today: this.props.today, onSelectDate: this._onSelectDate, onNavigateDate: this._onNavigateDayDate, onDismiss: this.props.onDismiss, firstDayOfWeek: firstDayOfWeek, dateRangeType: dateRangeType, autoNavigateOnSelection: autoNavigateOnSelection, strings: strings, onHeaderSelect: onHeaderSelect, navigationIcons: navigationIcons, showWeekNumbers: this.props.showWeekNumbers, firstWeekOfYear: this.props.firstWeekOfYear, dateTimeFormatter: this.props.dateTimeFormatter, showSixWeeksByDefault: this.props.showSixWeeksByDefault, minDate: minDate, maxDate: maxDate, restrictedDates: restrictedDates, workWeekDays: this.props.workWeekDays, componentRef: this._dayPicker, showCloseButton: showCloseButton, allFocusable: allFocusable })),
                            isDayPickerVisible && isMonthPickerVisible && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: styles.divider }),
                            isMonthPickerVisible && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__CalendarMonth__["a" /* CalendarMonth */], { navigatedDate: navigatedMonthDate, selectedDate: navigatedDayDate, strings: strings, onNavigateDate: this._onNavigateMonthDate, today: this.props.today, highlightCurrentMonth: highlightCurrentMonth, highlightSelectedMonth: highlightSelectedMonth, onHeaderSelect: onHeaderSelect, navigationIcons: navigationIcons, dateTimeFormatter: this.props.dateTimeFormatter, minDate: minDate, maxDate: maxDate, componentRef: this._monthPicker, yearPickerHidden: yearPickerHidden || showMonthPickerAsOverlay })),
                            showGoToToday && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("button", { role: "button", className: Object(__WEBPACK_IMPORTED_MODULE_6__Utilities__["t" /* css */])('ms-DatePicker-goToday js-goToday', styles.goToday, (_c = {},
                                    _c[styles.goTodayInlineMonth] = isMonthPickerVisible,
                                    _c[styles.goToTodayIsDisabled] = !goTodayEnabled,
                                    _c)), onClick: this._onGotoTodayClick, onKeyDown: this._onGotoTodayKeyDown, tabIndex: 0, disabled: !goTodayEnabled, type: "button" }, strings.goToToday))))))));
        var _c;
    };
    Calendar.prototype.focus = function () {
        if (this.state.isDayPickerVisible && this._dayPicker.current) {
            this._dayPicker.current.focus();
        }
        else if (this.state.isMonthPickerVisible && this._monthPicker.current) {
            this._monthPicker.current.focus();
        }
    };
    Calendar.defaultProps = {
        onSelectDate: undefined,
        onDismiss: undefined,
        isMonthPickerVisible: true,
        isDayPickerVisible: true,
        showMonthPickerAsOverlay: false,
        value: undefined,
        today: new Date(),
        firstDayOfWeek: __WEBPACK_IMPORTED_MODULE_2__utilities_dateValues_DateValues__["b" /* DayOfWeek */].Sunday,
        dateRangeType: __WEBPACK_IMPORTED_MODULE_2__utilities_dateValues_DateValues__["a" /* DateRangeType */].Day,
        autoNavigateOnSelection: false,
        showGoToToday: true,
        strings: null,
        highlightCurrentMonth: false,
        highlightSelectedMonth: false,
        navigationIcons: iconStrings,
        showWeekNumbers: false,
        firstWeekOfYear: __WEBPACK_IMPORTED_MODULE_2__utilities_dateValues_DateValues__["c" /* FirstWeekOfYear */].FirstDay,
        dateTimeFormatter: dateTimeFormatterCallbacks,
        showSixWeeksByDefault: false,
        workWeekDays: defaultWorkWeekDays,
        showCloseButton: false,
        allFocusable: false
    };
    return Calendar;
}(__WEBPACK_IMPORTED_MODULE_6__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=Calendar.js.map

/***/ }),
/* 1815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CalendarDay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_dateValues_DateValues__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FocusZone__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_dateMath_DateMath__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Calendar_scss__ = __webpack_require__(277);








var styles = __WEBPACK_IMPORTED_MODULE_7__Calendar_scss__;
var DAYS_IN_WEEK = 7;
var CalendarDay = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](CalendarDay, _super);
    function CalendarDay(props) {
        var _this = _super.call(this, props) || this;
        _this.days = {};
        _this._onKeyDown = function (callback, ev) {
            if (ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].enter || ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].space) {
                callback();
            }
        };
        _this._onDayKeyDown = function (originalDate, weekIndex, dayIndex) {
            return function (ev) {
                if (ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].enter) {
                    _this._onSelectDate(originalDate, ev);
                }
                else {
                    _this._navigateMonthEdge(ev, originalDate, weekIndex, dayIndex);
                }
            };
        };
        _this._onDayMouseDown = function (originalDate, weekIndex, dayIndex, dateRangeType) {
            return function (ev) {
                // set the press styling
                if (dateRangeType === __WEBPACK_IMPORTED_MODULE_3__utilities_dateValues_DateValues__["a" /* DateRangeType */].Month) {
                    _this._applyFunctionToDayRefs(function (ref, day) {
                        if (ref && day.originalDate.getMonth() === originalDate.getMonth() && day.isInBounds) {
                            ref.classList.add(styles.dayPress);
                        }
                    });
                }
                else {
                    // week or work week view
                    _this._applyFunctionToDayRefs(function (ref, day, dayWeekIndex) {
                        if (ref && dayWeekIndex === weekIndex && day.isInBounds) {
                            ref.classList.add(styles.dayPress);
                            ref.classList.add(styles.dayIsHighlighted);
                        }
                        else if (ref) {
                            ref.classList.remove(styles.dayIsHighlighted);
                        }
                    });
                }
            };
        };
        _this._onDayMouseUp = function (originalDate, weekIndex, dayIndex, dateRangeType) {
            return function (ev) {
                // remove press styling
                if (dateRangeType === __WEBPACK_IMPORTED_MODULE_3__utilities_dateValues_DateValues__["a" /* DateRangeType */].Month) {
                    _this._applyFunctionToDayRefs(function (ref, day) {
                        if (ref && day.originalDate.getMonth() === originalDate.getMonth() && day.isInBounds) {
                            ref.classList.remove(styles.dayPress);
                        }
                    });
                }
                else {
                    // week or work week view
                    _this._applyFunctionToDayRefs(function (ref, day, dayWeekIndex) {
                        if (ref && dayWeekIndex === weekIndex && day.isInBounds) {
                            ref.classList.remove(styles.dayPress);
                        }
                    });
                }
            };
        };
        _this._onDayMouseOver = function (originalDate, weekIndex, dayIndex, dateRangeType) {
            return function (ev) {
                // set the hover styling on every day in the same month
                if (dateRangeType === __WEBPACK_IMPORTED_MODULE_3__utilities_dateValues_DateValues__["a" /* DateRangeType */].Month) {
                    _this._applyFunctionToDayRefs(function (ref, day) {
                        if (ref && day.originalDate.getMonth() === originalDate.getMonth() && day.isInBounds) {
                            ref.classList.add(styles.dayHover);
                        }
                    });
                }
                else {
                    // week or work week view
                    _this._applyFunctionToDayRefs(function (ref, day, dayWeekIndex) {
                        if (ref && dayWeekIndex === weekIndex && day.isInBounds) {
                            ref.classList.add(styles.dayHover);
                        }
                    });
                }
            };
        };
        _this._onDayMouseLeave = function (originalDate, weekIndex, dayIndex, dateRangeType) {
            return function (ev) {
                // remove the hover and pressed styling
                if (dateRangeType === __WEBPACK_IMPORTED_MODULE_3__utilities_dateValues_DateValues__["a" /* DateRangeType */].Month) {
                    _this._applyFunctionToDayRefs(function (ref, day) {
                        if (ref && day.originalDate.getMonth() === originalDate.getMonth() && day.isInBounds) {
                            ref.classList.remove(styles.dayHover);
                        }
                    });
                }
                else {
                    // week or work week view
                    _this._applyFunctionToDayRefs(function (ref, day, dayWeekIndex) {
                        if (ref && dayWeekIndex === weekIndex && day.isInBounds) {
                            ref.classList.remove(styles.dayHover);
                        }
                    });
                }
            };
        };
        _this._onTableMouseLeave = function (ev) {
            if (ev.target.contains &&
                ev.relatedTarget &&
                ev.relatedTarget.contains &&
                ev.target.contains(ev.relatedTarget)) {
                return;
            }
            _this._applyFunctionToDayRefs(function (ref, day) {
                if (ref) {
                    ref.classList.remove(styles.dayHover);
                    ref.classList.remove(styles.dayPress);
                }
            });
        };
        _this._onTableMouseUp = function (ev) {
            if (ev.target.contains &&
                ev.relatedTarget &&
                ev.relatedTarget.contains &&
                ev.target.contains(ev.relatedTarget)) {
                return;
            }
            _this._applyFunctionToDayRefs(function (ref, day) {
                if (ref) {
                    ref.classList.remove(styles.dayPress);
                }
            });
        };
        _this._onSelectDate = function (selectedDate, ev) {
            var _a = _this.props, onSelectDate = _a.onSelectDate, dateRangeType = _a.dateRangeType, firstDayOfWeek = _a.firstDayOfWeek, navigatedDate = _a.navigatedDate, autoNavigateOnSelection = _a.autoNavigateOnSelection, minDate = _a.minDate, maxDate = _a.maxDate, workWeekDays = _a.workWeekDays;
            if (ev) {
                ev.stopPropagation();
            }
            var dateRange = Object(__WEBPACK_IMPORTED_MODULE_6__utilities_dateMath_DateMath__["g" /* getDateRangeArray */])(selectedDate, dateRangeType, firstDayOfWeek, workWeekDays);
            if (dateRangeType !== __WEBPACK_IMPORTED_MODULE_3__utilities_dateValues_DateValues__["a" /* DateRangeType */].Day) {
                dateRange = _this._getBoundedDateRange(dateRange, minDate, maxDate);
            }
            dateRange = dateRange.filter(function (d) {
                return !_this._getIsRestrictedDate(d);
            });
            if (onSelectDate) {
                onSelectDate(selectedDate, dateRange);
            }
            // Navigate to next or previous month if needed
            if (autoNavigateOnSelection && selectedDate.getMonth() !== navigatedDate.getMonth()) {
                var compareResult = Object(__WEBPACK_IMPORTED_MODULE_6__utilities_dateMath_DateMath__["e" /* compareDatePart */])(selectedDate, navigatedDate);
                if (compareResult < 0) {
                    _this._onSelectPrevMonth();
                }
                else if (compareResult > 0) {
                    _this._onSelectNextMonth();
                }
            }
        };
        _this._onSelectNextMonth = function () {
            _this.props.onNavigateDate(Object(__WEBPACK_IMPORTED_MODULE_6__utilities_dateMath_DateMath__["b" /* addMonths */])(_this.props.navigatedDate, 1), false);
        };
        _this._onSelectPrevMonth = function () {
            _this.props.onNavigateDate(Object(__WEBPACK_IMPORTED_MODULE_6__utilities_dateMath_DateMath__["b" /* addMonths */])(_this.props.navigatedDate, -1), false);
        };
        _this._onClose = function () {
            if (_this.props.onDismiss) {
                _this.props.onDismiss();
            }
        };
        _this._onHeaderSelect = function () {
            var onHeaderSelect = _this.props.onHeaderSelect;
            if (onHeaderSelect) {
                onHeaderSelect(true);
            }
        };
        _this._onHeaderKeyDown = function (ev) {
            var onHeaderSelect = _this.props.onHeaderSelect;
            if (onHeaderSelect && (ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].enter || ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].space)) {
                onHeaderSelect(true);
            }
        };
        _this._onPrevMonthKeyDown = function (ev) {
            if (ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].enter) {
                _this._onKeyDown(_this._onSelectPrevMonth, ev);
            }
        };
        _this._onNextMonthKeyDown = function (ev) {
            if (ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].enter) {
                _this._onKeyDown(_this._onSelectNextMonth, ev);
            }
        };
        _this._onCloseButtonKeyDown = function (ev) {
            if (ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].enter) {
                _this._onKeyDown(_this._onClose, ev);
            }
        };
        _this.state = {
            activeDescendantId: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["N" /* getId */])('DatePickerDay-active'),
            weeks: _this._getWeeks(props)
        };
        _this._onSelectNextMonth = _this._onSelectNextMonth.bind(_this);
        _this._onSelectPrevMonth = _this._onSelectPrevMonth.bind(_this);
        _this._onClose = _this._onClose.bind(_this);
        return _this;
    }
    CalendarDay.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState({
            weeks: this._getWeeks(nextProps)
        });
    };
    CalendarDay.prototype.render = function () {
        var _this = this;
        var _a = this.state, activeDescendantId = _a.activeDescendantId, weeks = _a.weeks;
        var _b = this.props, firstDayOfWeek = _b.firstDayOfWeek, strings = _b.strings, navigatedDate = _b.navigatedDate, selectedDate = _b.selectedDate, dateRangeType = _b.dateRangeType, navigationIcons = _b.navigationIcons, showWeekNumbers = _b.showWeekNumbers, firstWeekOfYear = _b.firstWeekOfYear, dateTimeFormatter = _b.dateTimeFormatter, minDate = _b.minDate, maxDate = _b.maxDate, showCloseButton = _b.showCloseButton, allFocusable = _b.allFocusable;
        var dayPickerId = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["N" /* getId */])('DatePickerDay-dayPicker');
        var monthAndYearId = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["N" /* getId */])('DatePickerDay-monthAndYear');
        var leftNavigationIcon = navigationIcons.leftNavigation;
        var rightNavigationIcon = navigationIcons.rightNavigation;
        var closeNavigationIcon = navigationIcons.closeIcon;
        var weekNumbers = showWeekNumbers ? Object(__WEBPACK_IMPORTED_MODULE_6__utilities_dateMath_DateMath__["k" /* getWeekNumbersInMonth */])(weeks.length, firstDayOfWeek, firstWeekOfYear, navigatedDate) : null;
        var selectedDateWeekNumber = showWeekNumbers ? Object(__WEBPACK_IMPORTED_MODULE_6__utilities_dateMath_DateMath__["j" /* getWeekNumber */])(selectedDate, firstDayOfWeek, firstWeekOfYear) : undefined;
        // When the month is highlighted get the corner dates so that styles can be added to them
        var weekCorners = this._getWeekCornerStyles(weeks, dateRangeType);
        // determine if previous/next months are in bounds
        var prevMonthInBounds = minDate ? Object(__WEBPACK_IMPORTED_MODULE_6__utilities_dateMath_DateMath__["e" /* compareDatePart */])(minDate, Object(__WEBPACK_IMPORTED_MODULE_6__utilities_dateMath_DateMath__["i" /* getMonthStart */])(navigatedDate)) < 0 : true;
        var nextMonthInBounds = maxDate ? Object(__WEBPACK_IMPORTED_MODULE_6__utilities_dateMath_DateMath__["e" /* compareDatePart */])(Object(__WEBPACK_IMPORTED_MODULE_6__utilities_dateMath_DateMath__["h" /* getMonthEnd */])(navigatedDate), maxDate) < 0 : true;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-DatePicker-dayPicker', styles.dayPicker, showWeekNumbers && 'ms-DatePicker-showWeekNumbers' && (Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["V" /* getRTL */])() ? styles.showWeekNumbersRTL : styles.showWeekNumbers)), id: dayPickerId },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-DatePicker-header', styles.header) },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { "aria-live": "polite", "aria-relevant": "text", "aria-atomic": "true", id: monthAndYearId, className: styles.monthAndYear }, this.props.onHeaderSelect ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-DatePicker-monthAndYear js-showMonthPicker', styles.headerToggleView), onClick: this._onHeaderSelect, onKeyDown: this._onHeaderKeyDown, "aria-label": dateTimeFormatter.formatMonthYear(navigatedDate, strings), role: "button", tabIndex: 0 }, dateTimeFormatter.formatMonthYear(navigatedDate, strings))) : (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-DatePicker-monthAndYear', styles.monthAndYear) }, dateTimeFormatter.formatMonthYear(navigatedDate, strings)))),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-DatePicker-monthComponents', styles.monthComponents) },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-DatePicker-navContainer', styles.navContainer) },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("button", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-DatePicker-prevMonth js-prevMonth', styles.prevMonth, (_c = {},
                                _c['ms-DatePicker-prevMonth--disabled ' + styles.prevMonthIsDisabled] = !prevMonthInBounds,
                                _c)), disabled: !allFocusable && !prevMonthInBounds, "aria-disabled": !prevMonthInBounds, onClick: prevMonthInBounds ? this._onSelectPrevMonth : undefined, onKeyDown: prevMonthInBounds ? this._onPrevMonthKeyDown : undefined, "aria-controls": dayPickerId, title: strings.prevMonthAriaLabel
                                ? strings.prevMonthAriaLabel + ' ' + strings.months[Object(__WEBPACK_IMPORTED_MODULE_6__utilities_dateMath_DateMath__["b" /* addMonths */])(navigatedDate, -1).getMonth()]
                                : undefined, role: "button", type: "button" },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Icon__["Icon"], { iconName: leftNavigationIcon })),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("button", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-DatePicker-nextMonth js-nextMonth', styles.nextMonth, (_d = {},
                                _d['ms-DatePicker-nextMonth--disabled ' + styles.nextMonthIsDisabled] = !nextMonthInBounds,
                                _d)), disabled: !allFocusable && !nextMonthInBounds, "aria-disabled": !nextMonthInBounds, onClick: nextMonthInBounds ? this._onSelectNextMonth : undefined, onKeyDown: nextMonthInBounds ? this._onNextMonthKeyDown : undefined, "aria-controls": dayPickerId, title: strings.nextMonthAriaLabel
                                ? strings.nextMonthAriaLabel + ' ' + strings.months[Object(__WEBPACK_IMPORTED_MODULE_6__utilities_dateMath_DateMath__["b" /* addMonths */])(navigatedDate, 1).getMonth()]
                                : undefined, role: "button", type: "button" },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Icon__["Icon"], { iconName: rightNavigationIcon })),
                        showCloseButton && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("button", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-DatePicker-closeButton js-closeButton', styles.closeButton), onClick: this._onClose, onKeyDown: this._onCloseButtonKeyDown, title: strings.closeButtonAriaLabel, role: "button", type: "button" },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Icon__["Icon"], { iconName: closeNavigationIcon })))))),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__FocusZone__["a" /* FocusZone */], null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("table", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-DatePicker-table', styles.table), "aria-readonly": "true", "aria-multiselectable": "false", "aria-labelledby": monthAndYearId, "aria-activedescendant": activeDescendantId, role: "grid" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("thead", null,
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("tr", null,
                            showWeekNumbers && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("th", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-DatePicker-weekday', styles.weekday) }),
                            strings.shortDays.map(function (val, index) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("th", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-DatePicker-weekday', styles.weekday), role: "columnheader", scope: "col", key: index, title: strings.days[(index + firstDayOfWeek) % DAYS_IN_WEEK], "aria-label": strings.days[(index + firstDayOfWeek) % DAYS_IN_WEEK], "data-is-focusable": allFocusable ? true : undefined }, strings.shortDays[(index + firstDayOfWeek) % DAYS_IN_WEEK])); }))),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("tbody", { onMouseLeave: dateRangeType !== __WEBPACK_IMPORTED_MODULE_3__utilities_dateValues_DateValues__["a" /* DateRangeType */].Day ? this._onTableMouseLeave : undefined, onMouseUp: dateRangeType !== __WEBPACK_IMPORTED_MODULE_3__utilities_dateValues_DateValues__["a" /* DateRangeType */].Day ? this._onTableMouseUp : undefined }, weeks.map(function (week, weekIndex) {
                        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("tr", { key: weekNumbers ? weekNumbers[weekIndex] : weekIndex },
                            showWeekNumbers && weekNumbers && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("th", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-DatePicker-weekNumbers', 'ms-DatePicker-weekday', styles.weekday, styles.weekNumbers), key: weekIndex, title: weekNumbers && strings.weekNumberFormatString && Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["G" /* format */])(strings.weekNumberFormatString, weekNumbers[weekIndex]), "aria-label": weekNumbers && strings.weekNumberFormatString && Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["G" /* format */])(strings.weekNumberFormatString, weekNumbers[weekIndex]), scope: "row" },
                                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-DatePicker-day', styles.day, (_a = {},
                                        _a['ms-DatePicker-week--highlighted ' + styles.weekIsHighlighted] = selectedDateWeekNumber === weekNumbers[weekIndex],
                                        _a)) },
                                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", null, weekNumbers[weekIndex])))),
                            week.map(function (day, dayIndex) {
                                var isNavigatedDate = Object(__WEBPACK_IMPORTED_MODULE_6__utilities_dateMath_DateMath__["f" /* compareDates */])(navigatedDate, day.originalDate);
                                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", { key: day.key, onClick: day.isInBounds ? day.onSelected : undefined, className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])(styles.dayWrapper, 'ms-DatePicker-day', _this._getHighlightedCornerStyle(weekCorners, dayIndex, weekIndex), (_a = {},
                                        _a['ms-DatePicker-weekBackground ' + styles.weekBackground] = day.isSelected && (dateRangeType === __WEBPACK_IMPORTED_MODULE_3__utilities_dateValues_DateValues__["a" /* DateRangeType */].Week || dateRangeType === __WEBPACK_IMPORTED_MODULE_3__utilities_dateValues_DateValues__["a" /* DateRangeType */].WorkWeek),
                                        _a['ms-DatePicker-dayBackground ' + styles.dayBackground] = dateRangeType === __WEBPACK_IMPORTED_MODULE_3__utilities_dateValues_DateValues__["a" /* DateRangeType */].Day,
                                        _a['ms-DatePicker-day--highlighted ' + styles.dayIsHighlighted] = day.isSelected && dateRangeType === __WEBPACK_IMPORTED_MODULE_3__utilities_dateValues_DateValues__["a" /* DateRangeType */].Day,
                                        _a['ms-DatePicker-day--infocus ' + styles.dayIsFocused] = day.isInBounds && day.isInMonth,
                                        _a['ms-DatePicker-day--outfocus ' + styles.dayIsUnfocused] = day.isInBounds && !day.isInMonth,
                                        _a[styles.daySelection] = dateRangeType === __WEBPACK_IMPORTED_MODULE_3__utilities_dateValues_DateValues__["a" /* DateRangeType */].Day,
                                        _a[styles.weekSelection] = dateRangeType === __WEBPACK_IMPORTED_MODULE_3__utilities_dateValues_DateValues__["a" /* DateRangeType */].Week || dateRangeType === __WEBPACK_IMPORTED_MODULE_3__utilities_dateValues_DateValues__["a" /* DateRangeType */].WorkWeek,
                                        _a[styles.monthSelection] = dateRangeType === __WEBPACK_IMPORTED_MODULE_3__utilities_dateValues_DateValues__["a" /* DateRangeType */].Month,
                                        _a)), ref: function (element) { return _this._setDayCellRef(element, day, isNavigatedDate); }, onMouseOver: dateRangeType !== __WEBPACK_IMPORTED_MODULE_3__utilities_dateValues_DateValues__["a" /* DateRangeType */].Day && day.isInBounds
                                        ? _this._onDayMouseOver(day.originalDate, weekIndex, dayIndex, dateRangeType)
                                        : undefined, onMouseLeave: dateRangeType !== __WEBPACK_IMPORTED_MODULE_3__utilities_dateValues_DateValues__["a" /* DateRangeType */].Day && day.isInBounds
                                        ? _this._onDayMouseLeave(day.originalDate, weekIndex, dayIndex, dateRangeType)
                                        : undefined, onMouseDown: dateRangeType !== __WEBPACK_IMPORTED_MODULE_3__utilities_dateValues_DateValues__["a" /* DateRangeType */].Day && day.isInBounds
                                        ? _this._onDayMouseDown(day.originalDate, weekIndex, dayIndex, dateRangeType)
                                        : undefined, onMouseUp: dateRangeType !== __WEBPACK_IMPORTED_MODULE_3__utilities_dateValues_DateValues__["a" /* DateRangeType */].Day && day.isInBounds
                                        ? _this._onDayMouseUp(day.originalDate, weekIndex, dayIndex, dateRangeType)
                                        : undefined, role: 'gridcell' },
                                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("button", { key: day.key + 'button', onClick: day.isInBounds ? day.onSelected : undefined, className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])(styles.day, 'ms-DatePicker-day-button', (_b = {},
                                            _b['ms-DatePicker-day--disabled ' + styles.dayIsDisabled] = !day.isInBounds,
                                            _b['ms-DatePicker-day--today ' + styles.dayIsToday] = day.isToday,
                                            _b)), role: "gridcell", onKeyDown: _this._onDayKeyDown(day.originalDate, weekIndex, dayIndex), "aria-label": dateTimeFormatter.formatMonthDayYear(day.originalDate, strings), id: isNavigatedDate ? activeDescendantId : undefined, "aria-readonly": true, "aria-selected": day.isInBounds ? day.isSelected : undefined, "data-is-focusable": allFocusable || (day.isInBounds ? true : undefined), ref: function (element) { return _this._setDayRef(element, day, isNavigatedDate); }, disabled: !allFocusable && !day.isInBounds, "aria-disabled": !day.isInBounds, type: "button" },
                                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { "aria-hidden": "true" }, dateTimeFormatter.formatDay(day.originalDate)))));
                                var _a, _b;
                            })));
                        var _a;
                    }))))));
        var _c, _d;
    };
    CalendarDay.prototype.focus = function () {
        if (this.navigatedDay) {
            this.navigatedDay.tabIndex = 0;
            this.navigatedDay.focus();
        }
    };
    CalendarDay.prototype._setDayRef = function (element, day, isNavigatedDate) {
        if (isNavigatedDate) {
            this.navigatedDay = element;
        }
    };
    CalendarDay.prototype._setDayCellRef = function (element, day, isNavigatedDate) {
        this.days[day.key] = element;
    };
    CalendarDay.prototype._getWeekCornerStyles = function (weeks, dateRangeType) {
        var _this = this;
        var weekCornersStyled = {};
        switch (dateRangeType) {
            case __WEBPACK_IMPORTED_MODULE_3__utilities_dateValues_DateValues__["a" /* DateRangeType */].Month:
                /* need to handle setting all of the corners on arbitrarily shaped blobs
                      __
                   __|A |
                  |B |C |__
                  |D |E |F |
        
                  in this case, A needs top left rounded, top right rounded
                  B needs top left rounded
                  C doesn't need any rounding
                  D needs bottom left rounded
                  E doesn't need any rounding
                  F needs top right rounding
                */
                // if there's an item above, lose both top corners. Item below, lose both bottom corners, etc.
                weeks.forEach(function (week, weekIndex) {
                    week.forEach(function (day, dayIndex) {
                        var above = weeks[weekIndex - 1] &&
                            weeks[weekIndex - 1][dayIndex] &&
                            weeks[weekIndex - 1][dayIndex].originalDate.getMonth() === weeks[weekIndex][dayIndex].originalDate.getMonth();
                        var below = weeks[weekIndex + 1] &&
                            weeks[weekIndex + 1][dayIndex] &&
                            weeks[weekIndex + 1][dayIndex].originalDate.getMonth() === weeks[weekIndex][dayIndex].originalDate.getMonth();
                        var left = weeks[weekIndex][dayIndex - 1] &&
                            weeks[weekIndex][dayIndex - 1].originalDate.getMonth() === weeks[weekIndex][dayIndex].originalDate.getMonth();
                        var right = weeks[weekIndex][dayIndex + 1] &&
                            weeks[weekIndex][dayIndex + 1].originalDate.getMonth() === weeks[weekIndex][dayIndex].originalDate.getMonth();
                        var roundedTopLeft = !above && !left;
                        var roundedTopRight = !above && !right;
                        var roundedBottomLeft = !below && !left;
                        var roundedBottomRight = !below && !right;
                        var style = '';
                        if (roundedTopLeft) {
                            style = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["V" /* getRTL */])() ? style.concat(styles.topRightCornerDate + ' ') : style.concat(styles.topLeftCornerDate + ' ');
                        }
                        if (roundedTopRight) {
                            style = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["V" /* getRTL */])() ? style.concat(styles.topLeftCornerDate + ' ') : style.concat(styles.topRightCornerDate + ' ');
                        }
                        if (roundedBottomLeft) {
                            style = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["V" /* getRTL */])() ? style.concat(styles.bottomRightCornerDate + ' ') : style.concat(styles.bottomLeftCornerDate + ' ');
                        }
                        if (roundedBottomRight) {
                            style = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["V" /* getRTL */])() ? style.concat(styles.bottomLeftCornerDate + ' ') : style.concat(styles.bottomRightCornerDate + ' ');
                        }
                        if (!above) {
                            style = style.concat(styles.topDate + ' ');
                        }
                        if (!below) {
                            style = style.concat(styles.bottomDate + ' ');
                        }
                        if (!right) {
                            style = style.concat(styles.rightDate + ' ');
                        }
                        if (!left) {
                            style = style.concat(styles.leftdate + ' ');
                        }
                        weekCornersStyled[weekIndex + '_' + dayIndex] = style;
                    });
                });
                break;
            case __WEBPACK_IMPORTED_MODULE_3__utilities_dateValues_DateValues__["a" /* DateRangeType */].Week:
            case __WEBPACK_IMPORTED_MODULE_3__utilities_dateValues_DateValues__["a" /* DateRangeType */].WorkWeek:
                weeks.forEach(function (week, weekIndex) {
                    var minIndex = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["C" /* findIndex */])(week, function (item) {
                        return item.isInBounds;
                    });
                    var maxIndex = _this._findLastIndex(week, function (item) {
                        return item.isInBounds;
                    });
                    var leftStyle = styles.topLeftCornerDate + ' ' + styles.bottomLeftCornerDate;
                    var rightStyle = styles.topRightCornerDate + ' ' + styles.bottomRightCornerDate;
                    weekCornersStyled[weekIndex + '_' + minIndex] = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["V" /* getRTL */])() ? rightStyle : leftStyle;
                    weekCornersStyled[weekIndex + '_' + maxIndex] = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["V" /* getRTL */])() ? leftStyle : rightStyle;
                });
                break;
        }
        return weekCornersStyled;
    };
    CalendarDay.prototype._getHighlightedCornerStyle = function (weekCorners, dayIndex, weekIndex) {
        var cornerStyle = weekCorners[weekIndex + '_' + dayIndex] ? weekCorners[weekIndex + '_' + dayIndex] : '';
        return cornerStyle;
    };
    CalendarDay.prototype._navigateMonthEdge = function (ev, date, weekIndex, dayIndex) {
        var _a = this.props, minDate = _a.minDate, maxDate = _a.maxDate;
        var targetDate = undefined;
        if (weekIndex === 0 && ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].up) {
            targetDate = Object(__WEBPACK_IMPORTED_MODULE_6__utilities_dateMath_DateMath__["c" /* addWeeks */])(date, -1);
        }
        else if (weekIndex === this.state.weeks.length - 1 && ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].down) {
            targetDate = Object(__WEBPACK_IMPORTED_MODULE_6__utilities_dateMath_DateMath__["c" /* addWeeks */])(date, 1);
        }
        else if (dayIndex === 0 && ev.which === Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["W" /* getRTLSafeKeyCode */])(__WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].left)) {
            targetDate = Object(__WEBPACK_IMPORTED_MODULE_6__utilities_dateMath_DateMath__["a" /* addDays */])(date, -1);
        }
        else if (dayIndex === DAYS_IN_WEEK - 1 && ev.which === Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["W" /* getRTLSafeKeyCode */])(__WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].right)) {
            targetDate = Object(__WEBPACK_IMPORTED_MODULE_6__utilities_dateMath_DateMath__["a" /* addDays */])(date, 1);
        }
        // Don't navigate to out-of-bounds date
        if (targetDate &&
            (minDate ? Object(__WEBPACK_IMPORTED_MODULE_6__utilities_dateMath_DateMath__["e" /* compareDatePart */])(minDate, targetDate) < 1 : true) &&
            (maxDate ? Object(__WEBPACK_IMPORTED_MODULE_6__utilities_dateMath_DateMath__["e" /* compareDatePart */])(targetDate, maxDate) < 1 : true)) {
            this.props.onNavigateDate(targetDate, true);
            ev.preventDefault();
        }
    };
    CalendarDay.prototype._applyFunctionToDayRefs = function (func) {
        var _this = this;
        if (this.state.weeks) {
            this.state.weeks.map(function (week, weekIndex) {
                week.map(function (day) {
                    var ref = _this.days[day.key];
                    func(ref, day, weekIndex);
                });
            });
        }
    };
    CalendarDay.prototype._getWeeks = function (propsToUse) {
        var navigatedDate = propsToUse.navigatedDate, selectedDate = propsToUse.selectedDate, dateRangeType = propsToUse.dateRangeType, firstDayOfWeek = propsToUse.firstDayOfWeek, today = propsToUse.today, minDate = propsToUse.minDate, maxDate = propsToUse.maxDate, showSixWeeksByDefault = propsToUse.showSixWeeksByDefault, workWeekDays = propsToUse.workWeekDays;
        var date = new Date(navigatedDate.getFullYear(), navigatedDate.getMonth(), 1);
        var todaysDate = today || new Date();
        var weeks = [];
        // Cycle the date backwards to get to the first day of the week.
        while (date.getDay() !== firstDayOfWeek) {
            date.setDate(date.getDate() - 1);
        }
        // a flag to indicate whether all days of the week are in the month
        var isAllDaysOfWeekOutOfMonth = false;
        // in work week view we want to select the whole week
        var selectedDateRangeType = dateRangeType === __WEBPACK_IMPORTED_MODULE_3__utilities_dateValues_DateValues__["a" /* DateRangeType */].WorkWeek ? __WEBPACK_IMPORTED_MODULE_3__utilities_dateValues_DateValues__["a" /* DateRangeType */].Week : dateRangeType;
        var selectedDates = Object(__WEBPACK_IMPORTED_MODULE_6__utilities_dateMath_DateMath__["g" /* getDateRangeArray */])(selectedDate, selectedDateRangeType, firstDayOfWeek, workWeekDays);
        if (dateRangeType !== __WEBPACK_IMPORTED_MODULE_3__utilities_dateValues_DateValues__["a" /* DateRangeType */].Day) {
            selectedDates = this._getBoundedDateRange(selectedDates, minDate, maxDate);
        }
        var shouldGetWeeks = true;
        for (var weekIndex = 0; shouldGetWeeks; weekIndex++) {
            var week = [];
            isAllDaysOfWeekOutOfMonth = true;
            for (var dayIndex = 0; dayIndex < DAYS_IN_WEEK; dayIndex++) {
                var originalDate = new Date(date.toString());
                var dayInfo = {
                    key: date.toString(),
                    date: date.getDate().toString(),
                    originalDate: originalDate,
                    isInMonth: date.getMonth() === navigatedDate.getMonth(),
                    isToday: Object(__WEBPACK_IMPORTED_MODULE_6__utilities_dateMath_DateMath__["f" /* compareDates */])(todaysDate, date),
                    isSelected: Object(__WEBPACK_IMPORTED_MODULE_6__utilities_dateMath_DateMath__["n" /* isInDateRangeArray */])(date, selectedDates),
                    onSelected: this._onSelectDate.bind(this, originalDate),
                    isInBounds: (minDate ? Object(__WEBPACK_IMPORTED_MODULE_6__utilities_dateMath_DateMath__["e" /* compareDatePart */])(minDate, date) < 1 : true) &&
                        (maxDate ? Object(__WEBPACK_IMPORTED_MODULE_6__utilities_dateMath_DateMath__["e" /* compareDatePart */])(date, maxDate) < 1 : true) &&
                        !this._getIsRestrictedDate(date)
                };
                week.push(dayInfo);
                if (dayInfo.isInMonth) {
                    isAllDaysOfWeekOutOfMonth = false;
                }
                date.setDate(date.getDate() + 1);
            }
            // We append the condition of the loop depending upon the showSixWeeksByDefault prop.
            shouldGetWeeks = showSixWeeksByDefault ? !isAllDaysOfWeekOutOfMonth || weekIndex <= 5 : !isAllDaysOfWeekOutOfMonth;
            if (shouldGetWeeks) {
                weeks.push(week);
            }
        }
        return weeks;
    };
    CalendarDay.prototype._getIsRestrictedDate = function (date) {
        var restrictedDates = this.props.restrictedDates;
        if (!restrictedDates) {
            return false;
        }
        var restrictedDate = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["A" /* find */])(restrictedDates, function (rd) {
            return Object(__WEBPACK_IMPORTED_MODULE_6__utilities_dateMath_DateMath__["f" /* compareDates */])(rd, date);
        });
        return restrictedDate ? true : false;
    };
    CalendarDay.prototype._getBoundedDateRange = function (dateRange, minDate, maxDate) {
        var boundedDateRange = dateRange.slice();
        if (minDate) {
            boundedDateRange = boundedDateRange.filter(function (date) { return Object(__WEBPACK_IMPORTED_MODULE_6__utilities_dateMath_DateMath__["e" /* compareDatePart */])(date, minDate) >= 0; });
        }
        if (maxDate) {
            boundedDateRange = boundedDateRange.filter(function (date) { return Object(__WEBPACK_IMPORTED_MODULE_6__utilities_dateMath_DateMath__["e" /* compareDatePart */])(date, maxDate) <= 0; });
        }
        return boundedDateRange;
    };
    /**
     * Returns the index of the last element in the array where the predicate is true, and -1
     * otherwise
     * @param items Array of items to be iterated over using the predicate
     * @param predicate find calls predicate once for each element of the array, in descending
     * order, until it finds one where predicate returns true if such an element is found.
     */
    CalendarDay.prototype._findLastIndex = function (items, predicate) {
        for (var i = items.length - 1; i >= 0; i--) {
            var item = items[i];
            if (predicate(item)) {
                return i;
            }
        }
        return -1;
    };
    return CalendarDay;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=CalendarDay.js.map

/***/ }),
/* 1816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Common constants and methods
 */
var TimeConstants = {
    MillisecondsInOneDay: 86400000,
    MillisecondsIn1Sec: 1000,
    MillisecondsIn1Min: 60000,
    MillisecondsIn30Mins: 1800000,
    MillisecondsIn1Hour: 3600000,
    MinutesInOneDay: 1440,
    MinutesInOneHour: 60,
    DaysInOneWeek: 7,
    MonthInOneYear: 12
};
/* harmony default export */ __webpack_exports__["a"] = (TimeConstants);
//# sourceMappingURL=TimeConstants.js.map

/***/ }),
/* 1817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CalendarMonth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FocusZone__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_dateMath_DateMath__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Calendar_scss__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CalendarYear__ = __webpack_require__(1818);








var styles = __WEBPACK_IMPORTED_MODULE_6__Calendar_scss__;
var MONTHS_PER_ROW = 4;
var CalendarMonth = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](CalendarMonth, _super);
    function CalendarMonth(props) {
        var _this = _super.call(this, props) || this;
        _this._navigatedMonthRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._onCalendarYearRef = function (ref) {
            _this._calendarYearRef = ref;
        };
        _this._onKeyDown = function (callback, ev) {
            if (ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].enter) {
                callback();
            }
        };
        _this._onSelectYear = function (selectedYear) {
            _this._focusOnUpdate = true;
            var _a = _this.props, navigatedDate = _a.navigatedDate, onNavigateDate = _a.onNavigateDate, maxDate = _a.maxDate, minDate = _a.minDate;
            var navYear = navigatedDate.getFullYear();
            if (navYear !== selectedYear) {
                var newNavigationDate = new Date(navigatedDate.getTime());
                newNavigationDate.setFullYear(selectedYear);
                // for min and max dates, adjust the new navigation date - perhaps this should be
                // checked on the master navigation date handler (i.e. in Calendar)
                if (maxDate && newNavigationDate > maxDate) {
                    newNavigationDate = Object(__WEBPACK_IMPORTED_MODULE_4__utilities_dateMath_DateMath__["o" /* setMonth */])(newNavigationDate, maxDate.getMonth());
                }
                else if (minDate && newNavigationDate < minDate) {
                    newNavigationDate = Object(__WEBPACK_IMPORTED_MODULE_4__utilities_dateMath_DateMath__["o" /* setMonth */])(newNavigationDate, minDate.getMonth());
                }
                onNavigateDate(newNavigationDate, true);
            }
            _this.setState({ isYearPickerVisible: false });
        };
        _this._yearToString = function (year) {
            var _a = _this.props, navigatedDate = _a.navigatedDate, dateTimeFormatter = _a.dateTimeFormatter;
            if (dateTimeFormatter) {
                // create a date based on the current nav date
                var yearFormattingDate = new Date(navigatedDate.getTime());
                yearFormattingDate.setFullYear(year);
                return dateTimeFormatter.formatYear(yearFormattingDate);
            }
            return String(year);
        };
        _this._yearRangeToString = function (yearRange) {
            return _this._yearToString(yearRange.fromYear) + " - " + _this._yearToString(yearRange.toYear);
        };
        _this._yearRangeToNextDecadeLabel = function (yearRange) {
            var strings = _this.props.strings;
            return strings.nextYearRangeAriaLabel ? strings.nextYearRangeAriaLabel + " " + _this._yearRangeToString(yearRange) : '';
        };
        _this._yearRangeToPrevDecadeLabel = function (yearRange) {
            var strings = _this.props.strings;
            return strings.prevYearRangeAriaLabel ? strings.prevYearRangeAriaLabel + " " + _this._yearRangeToString(yearRange) : '';
        };
        _this._onRenderYear = function (year) {
            return _this._yearToString(year);
        };
        _this._onSelectNextYear = function () {
            var _a = _this.props, navigatedDate = _a.navigatedDate, onNavigateDate = _a.onNavigateDate;
            onNavigateDate(Object(__WEBPACK_IMPORTED_MODULE_4__utilities_dateMath_DateMath__["d" /* addYears */])(navigatedDate, 1), false);
        };
        _this._onSelectNextYearKeyDown = function (ev) {
            if (ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].enter) {
                _this._onKeyDown(_this._onSelectNextYear, ev);
            }
        };
        _this._onSelectPrevYear = function () {
            var _a = _this.props, navigatedDate = _a.navigatedDate, onNavigateDate = _a.onNavigateDate;
            onNavigateDate(Object(__WEBPACK_IMPORTED_MODULE_4__utilities_dateMath_DateMath__["d" /* addYears */])(navigatedDate, -1), false);
        };
        _this._onSelectPrevYearKeyDown = function (ev) {
            if (ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].enter) {
                _this._onKeyDown(_this._onSelectPrevYear, ev);
            }
        };
        _this._onSelectMonthKeyDown = function (index) {
            return function (ev) { return _this._onKeyDown(function () { return _this._onSelectMonth(index); }, ev); };
        };
        _this._onSelectMonth = function (newMonth) {
            var _a = _this.props, navigatedDate = _a.navigatedDate, onNavigateDate = _a.onNavigateDate, onHeaderSelect = _a.onHeaderSelect;
            // If header is clickable the calendars are overlayed, switch back to day picker when month is clicked
            if (onHeaderSelect) {
                onHeaderSelect(true);
            }
            onNavigateDate(Object(__WEBPACK_IMPORTED_MODULE_4__utilities_dateMath_DateMath__["o" /* setMonth */])(navigatedDate, newMonth), true);
        };
        _this._onHeaderSelect = function () {
            var _a = _this.props, onHeaderSelect = _a.onHeaderSelect, yearPickerHidden = _a.yearPickerHidden;
            if (!yearPickerHidden) {
                _this._focusOnUpdate = true;
                _this.setState({ isYearPickerVisible: true });
            }
            else if (onHeaderSelect) {
                onHeaderSelect(true);
            }
        };
        _this._onYearPickerHeaderSelect = function (focus) {
            _this._focusOnUpdate = focus;
            _this.setState({ isYearPickerVisible: false });
        };
        _this._onHeaderKeyDown = function (ev) {
            if (_this._onHeaderSelect && (ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].enter || ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].space)) {
                _this._onHeaderSelect();
            }
        };
        _this._selectMonthCallbacks = [];
        props.strings.shortMonths.map(function (month, index) {
            _this._selectMonthCallbacks[index] = _this._onSelectMonth.bind(_this, index);
        });
        _this._isCurrentMonth = _this._isCurrentMonth.bind(_this);
        _this._onSelectNextYear = _this._onSelectNextYear.bind(_this);
        _this._onSelectPrevYear = _this._onSelectPrevYear.bind(_this);
        _this._onSelectMonth = _this._onSelectMonth.bind(_this);
        _this.state = { isYearPickerVisible: false };
        return _this;
    }
    CalendarMonth.prototype.componentDidUpdate = function () {
        if (this._focusOnUpdate) {
            this.focus();
            this._focusOnUpdate = false;
        }
    };
    CalendarMonth.prototype.render = function () {
        var _this = this;
        var _a = this.props, navigatedDate = _a.navigatedDate, selectedDate = _a.selectedDate, strings = _a.strings, today = _a.today, highlightCurrentMonth = _a.highlightCurrentMonth, highlightSelectedMonth = _a.highlightSelectedMonth, navigationIcons = _a.navigationIcons, dateTimeFormatter = _a.dateTimeFormatter, minDate = _a.minDate, maxDate = _a.maxDate, yearPickerHidden = _a.yearPickerHidden;
        if (this.state.isYearPickerVisible) {
            // default the year picker to the current navigated date
            var currentSelectedDate = navigatedDate ? navigatedDate.getFullYear() : undefined;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__CalendarYear__["a" /* CalendarYear */], { key: 'calendarYear_' + (currentSelectedDate && currentSelectedDate.toString()), minYear: minDate ? minDate.getFullYear() : undefined, maxYear: maxDate ? maxDate.getFullYear() : undefined, onSelectYear: this._onSelectYear, navigationIcons: navigationIcons, onHeaderSelect: this._onYearPickerHeaderSelect, selectedYear: currentSelectedDate, onRenderYear: this._onRenderYear, strings: {
                    rangeAriaLabel: this._yearRangeToString,
                    prevRangeAriaLabel: this._yearRangeToPrevDecadeLabel,
                    nextRangeAriaLabel: this._yearRangeToNextDecadeLabel
                }, ref: this._onCalendarYearRef }));
        }
        var rowIndexes = [];
        for (var i = 0; i < strings.shortMonths.length / MONTHS_PER_ROW; i++) {
            rowIndexes.push(i);
        }
        var leftNavigationIcon = navigationIcons.leftNavigation;
        var rightNavigationIcon = navigationIcons.rightNavigation;
        // determine if previous/next years are in bounds
        var isPrevYearInBounds = minDate ? Object(__WEBPACK_IMPORTED_MODULE_4__utilities_dateMath_DateMath__["e" /* compareDatePart */])(minDate, Object(__WEBPACK_IMPORTED_MODULE_4__utilities_dateMath_DateMath__["m" /* getYearStart */])(navigatedDate)) < 0 : true;
        var isNextYearInBounds = maxDate ? Object(__WEBPACK_IMPORTED_MODULE_4__utilities_dateMath_DateMath__["e" /* compareDatePart */])(Object(__WEBPACK_IMPORTED_MODULE_4__utilities_dateMath_DateMath__["l" /* getYearEnd */])(navigatedDate), maxDate) < 0 : true;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-DatePicker-monthPicker', styles.monthPicker) },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-DatePicker-header', styles.header) },
                this.props.onHeaderSelect || !yearPickerHidden ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-DatePicker-currentYear js-showYearPicker', styles.currentYear, styles.headerToggleView), onClick: this._onHeaderSelect, onKeyDown: this._onHeaderKeyDown, "aria-label": dateTimeFormatter.formatYear(navigatedDate), role: "button", "aria-atomic": true, "aria-live": "polite", tabIndex: 0 }, dateTimeFormatter.formatYear(navigatedDate))) : (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-DatePicker-currentYear js-showYearPicker', styles.currentYear) }, dateTimeFormatter.formatYear(navigatedDate))),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-DatePicker-yearComponents', styles.yearComponents) },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-DatePicker-navContainer', styles.navContainer) },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("button", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-DatePicker-prevYear js-prevYear', styles.prevYear, (_b = {},
                                _b['ms-DatePicker-prevYear--disabled ' + styles.prevYearIsDisabled] = !isPrevYearInBounds,
                                _b)), disabled: !isPrevYearInBounds, onClick: isPrevYearInBounds ? this._onSelectPrevYear : undefined, onKeyDown: isPrevYearInBounds ? this._onSelectPrevYearKeyDown : undefined, title: strings.prevYearAriaLabel
                                ? strings.prevYearAriaLabel + ' ' + dateTimeFormatter.formatYear(Object(__WEBPACK_IMPORTED_MODULE_4__utilities_dateMath_DateMath__["d" /* addYears */])(navigatedDate, -1))
                                : undefined, role: "button", type: "button" },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Icon__["Icon"], { iconName: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["V" /* getRTL */])() ? rightNavigationIcon : leftNavigationIcon })),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("button", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-DatePicker-nextYear js-nextYear', styles.nextYear, (_c = {},
                                _c['ms-DatePicker-nextYear--disabled ' + styles.nextYearIsDisabled] = !isNextYearInBounds,
                                _c)), disabled: !isNextYearInBounds, onClick: isNextYearInBounds ? this._onSelectNextYear : undefined, onKeyDown: isNextYearInBounds ? this._onSelectNextYearKeyDown : undefined, title: strings.nextYearAriaLabel
                                ? strings.nextYearAriaLabel + ' ' + dateTimeFormatter.formatYear(Object(__WEBPACK_IMPORTED_MODULE_4__utilities_dateMath_DateMath__["d" /* addYears */])(navigatedDate, 1))
                                : undefined, role: "button", type: "button" },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Icon__["Icon"], { iconName: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["V" /* getRTL */])() ? leftNavigationIcon : rightNavigationIcon }))))),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__FocusZone__["a" /* FocusZone */], null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-DatePicker-optionGrid', styles.optionGrid), role: "grid", "aria-readonly": "true" }, rowIndexes.map(function (rowNum) {
                    var monthsForRow = strings.shortMonths.slice(rowNum * MONTHS_PER_ROW, (rowNum + 1) * MONTHS_PER_ROW);
                    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { key: 'monthRow_' + rowNum, role: "row" }, monthsForRow.map(function (month, index) {
                        var monthIndex = rowNum * MONTHS_PER_ROW + index;
                        var indexedMonth = Object(__WEBPACK_IMPORTED_MODULE_4__utilities_dateMath_DateMath__["o" /* setMonth */])(navigatedDate, monthIndex);
                        var isCurrentMonth = _this._isCurrentMonth(monthIndex, navigatedDate.getFullYear(), today);
                        var isNavigatedMonth = navigatedDate.getMonth() === monthIndex;
                        var isSelectedMonth = selectedDate.getMonth() === monthIndex;
                        var isSelectedYear = selectedDate.getFullYear() === navigatedDate.getFullYear();
                        var isInBounds = (minDate ? Object(__WEBPACK_IMPORTED_MODULE_4__utilities_dateMath_DateMath__["e" /* compareDatePart */])(minDate, Object(__WEBPACK_IMPORTED_MODULE_4__utilities_dateMath_DateMath__["h" /* getMonthEnd */])(indexedMonth)) < 1 : true) &&
                            (maxDate ? Object(__WEBPACK_IMPORTED_MODULE_4__utilities_dateMath_DateMath__["e" /* compareDatePart */])(Object(__WEBPACK_IMPORTED_MODULE_4__utilities_dateMath_DateMath__["i" /* getMonthStart */])(indexedMonth), maxDate) < 1 : true);
                        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("button", { role: 'gridcell', className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-DatePicker-monthOption', styles.monthOption, (_a = {},
                                _a['ms-DatePicker-day--today ' + styles.monthIsCurrentMonth] = highlightCurrentMonth && isCurrentMonth,
                                _a['ms-DatePicker-day--highlighted ' + styles.monthIsHighlighted] = (highlightCurrentMonth || highlightSelectedMonth) && isSelectedMonth && isSelectedYear,
                                _a['ms-DatePicker-monthOption--disabled ' + styles.monthOptionIsDisabled] = !isInBounds,
                                _a)), disabled: !isInBounds, key: monthIndex, onClick: isInBounds ? _this._selectMonthCallbacks[monthIndex] : undefined, onKeyDown: isInBounds ? _this._onSelectMonthKeyDown(monthIndex) : undefined, "aria-label": dateTimeFormatter.formatMonthYear(indexedMonth, strings), "aria-selected": isCurrentMonth || isNavigatedMonth, "data-is-focusable": isInBounds ? true : undefined, ref: isNavigatedMonth ? _this._navigatedMonthRef : undefined, type: "button" }, month));
                        var _a;
                    })));
                })))));
        var _b, _c;
    };
    CalendarMonth.prototype.focus = function () {
        if (this._calendarYearRef) {
            this._calendarYearRef.focus();
        }
        else if (this._navigatedMonthRef.current) {
            this._navigatedMonthRef.current.tabIndex = 0;
            this._navigatedMonthRef.current.focus();
        }
    };
    CalendarMonth.prototype._isCurrentMonth = function (month, year, today) {
        return today.getFullYear() === year && today.getMonth() === month;
    };
    return CalendarMonth;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=CalendarMonth.js.map

/***/ }),
/* 1818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CalendarYear; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FocusZone__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Calendar_scss__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon__ = __webpack_require__(12);






var styles = __WEBPACK_IMPORTED_MODULE_4__Calendar_scss__;
var CELL_COUNT = 12;
var DefaultCalendarYearStrings = {
    prevRangeAriaLabel: undefined,
    nextRangeAriaLabel: undefined
};
var DefaultNavigationIcons = {
    leftNavigation: 'Up',
    rightNavigation: 'Down',
    closeIcon: 'CalculatorMultiply'
};
var CalendarYearGridCell = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](CalendarYearGridCell, _super);
    function CalendarYearGridCell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._buttonRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._onRenderYear = function () {
            var _a = _this.props, year = _a.year, onRenderYear = _a.onRenderYear;
            if (onRenderYear) {
                return onRenderYear(year);
            }
            return year;
        };
        _this._onClick = function () {
            if (_this.props.onSelectYear) {
                _this.props.onSelectYear(_this.props.year);
            }
        };
        _this._onKeyDown = function (ev) {
            if (_this.props.onSelectYear && ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].enter) {
                _this.props.onSelectYear(_this.props.year);
            }
        };
        return _this;
    }
    CalendarYearGridCell.prototype.focus = function () {
        if (this._buttonRef.current) {
            this._buttonRef.current.focus();
        }
    };
    CalendarYearGridCell.prototype.render = function () {
        var _a = this.props, year = _a.year, selected = _a.selected, disabled = _a.disabled, onSelectYear = _a.onSelectYear;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("button", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-DatePicker-yearOption', styles.yearOption, (_b = {},
                _b['ms-DatePicker-day--highlighted ' + styles.yearIsHighlighted] = selected,
                _b['ms-DatePicker-yearOption--disabled ' + styles.yearOptionIsDisabled] = disabled,
                _b)), type: "button", role: "gridcell", onClick: !disabled && onSelectYear ? this._onClick : undefined, onKeyDown: !disabled && onSelectYear ? this._onKeyDown : undefined, disabled: disabled, "aria-label": String(year), "aria-selected": selected, ref: this._buttonRef }, this._onRenderYear()));
        var _b;
    };
    return CalendarYearGridCell;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
var CalendarYearGrid = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](CalendarYearGrid, _super);
    function CalendarYearGrid() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._selectedCellRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._currentCellRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._renderCell = function (year) {
            var selected = year === _this.props.selectedYear;
            var _a = _this.props, minYear = _a.minYear, maxYear = _a.maxYear, onSelectYear = _a.onSelectYear;
            var disabled = (minYear !== undefined && year < minYear) || (maxYear !== undefined && year > maxYear);
            var current = year === new Date().getFullYear();
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](CalendarYearGridCell, { key: year, year: year, selected: selected, current: current, disabled: disabled, onSelectYear: onSelectYear, ref: selected ? _this._selectedCellRef : current ? _this._currentCellRef : undefined }));
        };
        return _this;
    }
    CalendarYearGrid.prototype.focus = function () {
        if (this._selectedCellRef.current) {
            this._selectedCellRef.current.focus();
        }
        else if (this._currentCellRef.current) {
            this._currentCellRef.current.focus();
        }
    };
    CalendarYearGrid.prototype.render = function () {
        var _a = this.props, fromYear = _a.fromYear, toYear = _a.toYear;
        var year = fromYear;
        var cells = [];
        while (year <= toYear) {
            cells.push(this._renderCell(year));
            year++;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__FocusZone__["a" /* FocusZone */], null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-DatePicker-optionGrid', styles.optionGrid), role: "grid" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { role: "row" }, cells))));
    };
    return CalendarYearGrid;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
var CalendarYearNavPrev = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](CalendarYearNavPrev, _super);
    function CalendarYearNavPrev() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onSelectPrev = function () {
            if (!_this.isDisabled && _this.props.onSelectPrev) {
                _this.props.onSelectPrev();
            }
        };
        _this._onKeyDown = function (ev) {
            if (ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].enter) {
                _this._onSelectPrev();
            }
        };
        return _this;
    }
    CalendarYearNavPrev.prototype.render = function () {
        var iconStrings = this.props.navigationIcons || DefaultNavigationIcons;
        var strings = this.props.strings || DefaultCalendarYearStrings;
        var prevRangeAriaLabel = strings.prevRangeAriaLabel;
        var prevRange = { fromYear: this.props.fromYear - CELL_COUNT, toYear: this.props.toYear - CELL_COUNT };
        var prevAriaLabel = prevRangeAriaLabel
            ? typeof prevRangeAriaLabel === 'string'
                ? prevRangeAriaLabel
                : prevRangeAriaLabel(prevRange)
            : undefined;
        var disabled = this.isDisabled;
        var onSelectPrev = this.props.onSelectPrev;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("button", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-DatePicker-prevDecade', styles.prevDecade, (_a = {},
                _a['ms-DatePicker-prevDecade--disabled ' + styles.prevDecadeIsDisabled] = disabled,
                _a)), onClick: !disabled && onSelectPrev ? this._onSelectPrev : undefined, onKeyDown: !disabled && onSelectPrev ? this._onKeyDown : undefined, type: "button", tabIndex: 0, title: prevAriaLabel, disabled: disabled },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Icon__["Icon"], { iconName: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["V" /* getRTL */])() ? iconStrings.rightNavigation : iconStrings.leftNavigation })));
        var _a;
    };
    Object.defineProperty(CalendarYearNavPrev.prototype, "isDisabled", {
        get: function () {
            var minYear = this.props.minYear;
            return minYear !== undefined && this.props.fromYear < minYear;
        },
        enumerable: true,
        configurable: true
    });
    return CalendarYearNavPrev;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
var CalendarYearNavNext = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](CalendarYearNavNext, _super);
    function CalendarYearNavNext() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onSelectNext = function () {
            if (!_this.isDisabled && _this.props.onSelectNext) {
                _this.props.onSelectNext();
            }
        };
        _this._onKeyDown = function (ev) {
            if (ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].enter) {
                _this._onSelectNext();
            }
        };
        return _this;
    }
    CalendarYearNavNext.prototype.render = function () {
        var iconStrings = this.props.navigationIcons || DefaultNavigationIcons;
        var strings = this.props.strings || DefaultCalendarYearStrings;
        var nextRangeAriaLabel = strings.nextRangeAriaLabel;
        var nextRange = { fromYear: this.props.fromYear + CELL_COUNT, toYear: this.props.toYear + CELL_COUNT };
        var nextAriaLabel = nextRangeAriaLabel
            ? typeof nextRangeAriaLabel === 'string'
                ? nextRangeAriaLabel
                : nextRangeAriaLabel(nextRange)
            : undefined;
        var onSelectNext = this.props.onSelectNext;
        var disabled = this.isDisabled;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("button", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-DatePicker-nextDecade', styles.nextDecade, (_a = {},
                _a['ms-DatePicker-nextDecade--disabled ' + styles.nextDecadeIsDisabled] = disabled,
                _a)), onClick: !disabled && onSelectNext ? this._onSelectNext : undefined, onKeyDown: !disabled && onSelectNext ? this._onKeyDown : undefined, type: "button", tabIndex: 0, title: nextAriaLabel, disabled: this.isDisabled },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Icon__["Icon"], { iconName: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["V" /* getRTL */])() ? iconStrings.leftNavigation : iconStrings.rightNavigation })));
        var _a;
    };
    Object.defineProperty(CalendarYearNavNext.prototype, "isDisabled", {
        get: function () {
            var maxYear = this.props.maxYear;
            return maxYear !== undefined && this.props.fromYear + CELL_COUNT > maxYear;
        },
        enumerable: true,
        configurable: true
    });
    return CalendarYearNavNext;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
var CalendarYearNav = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](CalendarYearNav, _super);
    function CalendarYearNav() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CalendarYearNav.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-DatePicker-decadeComponents', styles.decadeComponents) },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-DatePicker-navContainer', styles.navContainer) },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](CalendarYearNavPrev, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this.props)),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](CalendarYearNavNext, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this.props)))));
    };
    return CalendarYearNav;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
var CalendarYearTitle = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](CalendarYearTitle, _super);
    function CalendarYearTitle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onHeaderSelect = function () {
            if (_this.props.onHeaderSelect) {
                _this.props.onHeaderSelect(true);
            }
        };
        _this._onHeaderKeyDown = function (ev) {
            if (_this.props.onHeaderSelect && (ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].enter || ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].space)) {
                _this.props.onHeaderSelect(true);
            }
        };
        _this._onRenderYear = function (year) {
            if (_this.props.onRenderYear) {
                return _this.props.onRenderYear(year);
            }
            return year;
        };
        return _this;
    }
    CalendarYearTitle.prototype.render = function () {
        var _a = this.props, fromYear = _a.fromYear, toYear = _a.toYear, onHeaderSelect = _a.onHeaderSelect;
        if (onHeaderSelect) {
            var strings = this.props.strings || DefaultCalendarYearStrings;
            var rangeAriaLabel = strings.rangeAriaLabel;
            var ariaLabel = rangeAriaLabel
                ? typeof rangeAriaLabel === 'string'
                    ? rangeAriaLabel
                    : rangeAriaLabel(this.props)
                : undefined;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-DatePicker-currentDecade js-showYearPicker', styles.currentDecade, styles.headerToggleView), onClick: this._onHeaderSelect, onKeyDown: this._onHeaderKeyDown, "aria-label": ariaLabel, role: "button", "aria-atomic": true, "aria-live": "polite", tabIndex: 0 },
                this._onRenderYear(fromYear),
                " - ",
                this._onRenderYear(toYear)));
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-DatePicker-currentDecade js-showYearPicker', styles.currentDecade) },
            this._onRenderYear(fromYear),
            " - ",
            this._onRenderYear(toYear)));
    };
    return CalendarYearTitle;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
var CalendarYearHeader = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](CalendarYearHeader, _super);
    function CalendarYearHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onRenderTitle = function () {
            if (_this.props.onRenderTitle) {
                return _this.props.onRenderTitle(_this.props);
            }
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](CalendarYearTitle, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, _this.props));
        };
        _this._onRenderNav = function () {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](CalendarYearNav, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, _this.props));
        };
        return _this;
    }
    CalendarYearHeader.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-DatePicker-header', styles.header) },
            this._onRenderTitle(),
            this._onRenderNav()));
    };
    return CalendarYearHeader;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
var CalendarYear = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](CalendarYear, _super);
    function CalendarYear(props) {
        var _this = _super.call(this, props) || this;
        _this._gridRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._onNavNext = function () {
            _this.setState({ fromYear: _this.state.fromYear + CELL_COUNT });
        };
        _this._onNavPrev = function () {
            _this.setState({ fromYear: _this.state.fromYear - CELL_COUNT });
        };
        _this._renderHeader = function () {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](CalendarYearHeader, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, _this.props, { fromYear: _this.state.fromYear, toYear: _this.state.fromYear + CELL_COUNT - 1, onSelectPrev: _this._onNavPrev, onSelectNext: _this._onNavNext })));
        };
        _this._renderGrid = function () {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](CalendarYearGrid, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, _this.props, { fromYear: _this.state.fromYear, toYear: _this.state.fromYear + CELL_COUNT - 1, ref: _this._gridRef })));
        };
        _this.state = _this._calculateInitialStateFromProps(props);
        return _this;
    }
    CalendarYear.prototype.focus = function () {
        if (this._gridRef.current) {
            this._gridRef.current.focus();
        }
    };
    CalendarYear.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-DatePicker-yearPicker', styles.yearPicker) },
            this._renderHeader(),
            this._renderGrid()));
    };
    CalendarYear.prototype._calculateInitialStateFromProps = function (props) {
        var selectedYear = props.selectedYear, navigatedYear = props.navigatedYear;
        var rangeYear = selectedYear || navigatedYear || new Date().getFullYear();
        var fromYear = Math.floor(rangeYear / 10) * 10;
        return {
            fromYear: fromYear,
            navigatedYear: navigatedYear,
            selectedYear: selectedYear
        };
    };
    return CalendarYear;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=CalendarYear.js.map

/***/ }),
/* 1819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var GlobalClassNames = {
    root: 'ms-DatePicker',
    callout: 'ms-DatePicker-callout',
    withLabel: 'ms-DatePicker-event--with-label',
    withoutLabel: 'ms-DatePicker-event--without-label',
    disabled: 'msDatePickerDisabled '
};
var styles = function (props) {
    var className = props.className, theme = props.theme, disabled = props.disabled, label = props.label, isDatePickerShown = props.isDatePickerShown;
    var palette = theme.palette, semanticColors = theme.semanticColors;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    var DatePickerEvent = {
        color: palette.neutralSecondary,
        fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].icon,
        lineHeight: '18px',
        pointerEvents: 'none',
        position: 'absolute',
        right: '9px'
    };
    return {
        root: [classNames.root, theme.fonts.medium, isDatePickerShown && 'is-open', __WEBPACK_IMPORTED_MODULE_0__Styling__["H" /* normalize */], className],
        textField: [
            {
                position: 'relative',
                selectors: {
                    '& input[readonly]': {
                        cursor: 'pointer'
                    },
                    input: {
                        selectors: {
                            '::-ms-clear': {
                                display: 'none'
                            }
                        }
                    }
                }
            },
            disabled && {
                selectors: {
                    '& input[readonly]': {
                        cursor: 'default'
                    }
                }
            }
        ],
        callout: [classNames.callout],
        icon: [
            DatePickerEvent,
            !label && [classNames.withoutLabel, { top: '7px' }],
            label && [classNames.withLabel, { bottom: '5px' }],
            !disabled && [
                classNames.disabled,
                {
                    pointerEvents: 'initial',
                    cursor: 'pointer'
                }
            ],
            disabled && {
                color: semanticColors.disabledText,
                cursor: 'default'
            }
        ]
    };
};
//# sourceMappingURL=DatePicker.styles.js.map

/***/ }),
/* 1820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_selectableOption_SelectableOption_types__ = __webpack_require__(417);
/* unused harmony reexport SelectableOptionMenuItemType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ComboBox__ = __webpack_require__(734);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__ComboBox__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VirtualizedComboBox__ = __webpack_require__(1823);
/* unused harmony namespace reexport */



//# sourceMappingURL=index.js.map

/***/ }),
/* 1821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getOptionStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCaretDownButtonStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utilities__ = __webpack_require__(1);


var ComboBoxHeight = '32px';
var ComboBoxLineHeight = '30px';
var ComboxBoxCaretDownWidth = '32px';
var ComboBoxOptionHeight = '32px';
var getDisabledStyles = Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["_15" /* memoizeFunction */])(function (theme) {
    var semanticColors = theme.semanticColors;
    return {
        backgroundColor: semanticColors.disabledBackground,
        borderColor: semanticColors.disabledBackground,
        color: semanticColors.disabledText,
        cursor: 'default',
        selectors: (_a = {},
            _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                borderColor: 'GrayText',
                color: 'GrayText'
            },
            _a)
    };
    var _a;
});
var getListOptionHighContrastStyles = Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["_15" /* memoizeFunction */])(function (theme) {
    return {
        selectors: (_a = {},
            _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                backgroundColor: 'Highlight',
                borderColor: 'Highlight',
                color: 'HighlightText',
                MsHighContrastAdjust: 'none'
            },
            _a)
    };
    var _a;
});
var getOptionStyles = Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["_15" /* memoizeFunction */])(function (theme, customStylesForAllOptions, customOptionStylesForCurrentOption, isPending, isHidden) {
    var semanticColors = theme.semanticColors, palette = theme.palette;
    var ComboBoxOptionBackgroundHovered = semanticColors.menuItemBackgroundHovered;
    var ComboBoxOptionTextColorHovered = semanticColors.bodyText;
    var ComboBoxOptionTextColorSelected = palette.black;
    var ComboBoxOptionTextColorDisabled = semanticColors.disabledText;
    var ComboBoxOptionBackgroundDisabled = semanticColors.bodyBackground;
    var optionStyles = {
        root: [
            theme.fonts.medium,
            {
                backgroundColor: isPending ? ComboBoxOptionBackgroundHovered : 'transparent',
                boxSizing: 'border-box',
                cursor: 'pointer',
                display: isHidden ? 'none' : 'block',
                width: '100%',
                height: 'auto',
                minHeight: ComboBoxOptionHeight,
                lineHeight: '20px',
                padding: '5px 16px',
                position: 'relative',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: 'transparent',
                wordWrap: 'break-word',
                overflowWrap: 'break-word',
                textAlign: 'left',
                selectors: (_a = {},
                    _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        borderColor: 'Background'
                    },
                    _a)
            }
        ],
        rootHovered: {
            backgroundColor: ComboBoxOptionBackgroundHovered,
            color: ComboBoxOptionTextColorHovered
        },
        rootFocused: {
            backgroundColor: ComboBoxOptionBackgroundHovered
        },
        rootChecked: [
            {
                backgroundColor: ComboBoxOptionBackgroundHovered,
                color: ComboBoxOptionTextColorSelected
            },
            Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["v" /* getFocusStyle */])(theme, { isFocusedOnly: false }),
            getListOptionHighContrastStyles(theme)
        ],
        rootDisabled: {
            backgroundColor: ComboBoxOptionBackgroundDisabled,
            color: ComboBoxOptionTextColorDisabled,
            cursor: 'default',
            selectors: {
                '& .ms-Button-flexContainer': {
                    justifyContent: 'flex-start'
                }
            }
        },
        optionText: {
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            minWidth: '0px',
            maxWidth: '100%',
            wordWrap: 'break-word',
            overflowWrap: 'break-word',
            margin: '1px',
            display: 'inline-block'
        },
        optionTextWrapper: {
            maxWidth: '100%'
        }
    };
    return Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["t" /* concatStyleSets */])(optionStyles, customStylesForAllOptions, customOptionStylesForCurrentOption);
    var _a;
});
var getCaretDownButtonStyles = Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["_15" /* memoizeFunction */])(function (theme, customStyles) {
    var semanticColors = theme.semanticColors;
    var caretButtonTextColor = semanticColors.bodySubtext;
    var caretButtonTextColorHoveredChecked = semanticColors.buttonTextChecked;
    var caretButtonBackgroundHovered = semanticColors.listItemBackgroundHovered;
    var caretButtonBackgroundChecked = semanticColors.listItemBackgroundChecked;
    var caretButtonBackgroundCheckedHovered = semanticColors.listItemBackgroundCheckedHovered;
    var styles = {
        root: {
            color: caretButtonTextColor,
            fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].small,
            position: 'absolute',
            // The negative positioning accounts for the 1px root border now that box-sizing is border-box
            top: '-1px',
            right: '-1px',
            height: ComboBoxHeight,
            lineHeight: ComboBoxLineHeight,
            width: ComboxBoxCaretDownWidth,
            textAlign: 'center',
            cursor: 'default',
            selectors: (_a = {},
                _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                    backgroundColor: 'ButtonFace',
                    borderColor: 'ButtonText',
                    color: 'ButtonText',
                    MsHighContrastAdjust: 'none'
                },
                _a)
        },
        icon: {
            fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].small
        },
        rootHovered: {
            backgroundColor: caretButtonBackgroundHovered,
            color: caretButtonTextColorHoveredChecked,
            cursor: 'pointer'
        },
        rootPressed: {
            backgroundColor: caretButtonBackgroundChecked,
            color: caretButtonTextColorHoveredChecked
        },
        rootChecked: {
            backgroundColor: caretButtonBackgroundChecked,
            color: caretButtonTextColorHoveredChecked
        },
        rootCheckedHovered: {
            backgroundColor: caretButtonBackgroundCheckedHovered,
            color: caretButtonTextColorHoveredChecked
        },
        rootDisabled: getDisabledStyles(theme)
    };
    return Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["t" /* concatStyleSets */])(styles, customStyles);
    var _a;
});
var getStyles = Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["_15" /* memoizeFunction */])(function (theme, customStyles, comboBoxOptionWidth) {
    var semanticColors = theme.semanticColors, fonts = theme.fonts, palette = theme.palette;
    var ComboBoxRootBackground = semanticColors.bodyBackground;
    var ComboBoxRootTextColor = semanticColors.bodyText;
    var ComboBoxRootBorderColor = semanticColors.inputBorder;
    var ComboBoxRootBorderColorHovered = semanticColors.inputBorderHovered;
    var ComboBoxRootBorderColorFocused = semanticColors.inputFocusBorderAlt;
    var ComboBoxRootColorErrored = semanticColors.errorText;
    var ComboBoxCalloutBorderColor = palette.neutralLight;
    var ComboBoxOptionHeaderTextColor = semanticColors.menuHeader;
    var ComboBoxOptionDividerBorderColor = semanticColors.bodyDivider;
    // placeholder style variables
    var placeholderStyles = {
        color: semanticColors.inputPlaceholderText
    };
    var hoverPlaceholderStyles = {
        color: palette.neutralPrimary
    };
    var disabledPlaceholderStyles = {
        color: semanticColors.disabledText
    };
    var ComboBoxRootHighContrastFocused = {
        color: 'HighlightText',
        borderColor: 'Highlight',
        backgroundColor: 'Window',
        borderWidth: '2px',
        MsHighContrastAdjust: 'none',
        paddingLeft: '11px',
        paddingTop: '0',
        paddingBottom: '0',
        selectors: {
            '.ms-ComboBox-CaretDown-button': {
                // Negative positioning to account for the 2px border
                right: '-2px',
                top: '-2px'
            }
        }
    };
    var styles = {
        container: {},
        label: {},
        labelDisabled: {},
        root: [
            theme.fonts.medium,
            {
                boxShadow: 'none',
                marginLeft: '0',
                paddingTop: '1px',
                paddingBottom: '1px',
                paddingRight: ComboxBoxCaretDownWidth,
                paddingLeft: '12px',
                color: ComboBoxRootTextColor,
                position: 'relative',
                outline: '0',
                userSelect: 'none',
                backgroundColor: ComboBoxRootBackground,
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: ComboBoxRootBorderColor,
                cursor: 'text',
                display: 'block',
                height: ComboBoxHeight,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                boxSizing: 'border-box',
                selectors: {
                    '.ms-Label': {
                        display: 'inline-block',
                        marginBottom: '8px'
                    },
                    '&.is-open': {
                        borderColor: ComboBoxRootBorderColorFocused,
                        selectors: (_a = {},
                            _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = ComboBoxRootHighContrastFocused,
                            _a)
                    }
                }
            }
        ],
        rootHovered: {
            borderColor: ComboBoxRootBorderColorHovered,
            selectors: (_b = {
                    '.ms-ComboBox-Input': [{ color: palette.neutralDark }, Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["y" /* getPlaceholderStyles */])(hoverPlaceholderStyles)]
                },
                _b[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                    color: 'HighlightText',
                    borderColor: 'Highlight',
                    backgroundColor: 'Window',
                    MsHighContrastAdjust: 'none'
                },
                _b)
        },
        rootPressed: {
            borderColor: ComboBoxRootBorderColorFocused,
            selectors: (_c = {},
                _c[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = ComboBoxRootHighContrastFocused,
                _c)
        },
        rootFocused: {
            borderColor: ComboBoxRootBorderColorFocused,
            selectors: (_d = {},
                _d[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = ComboBoxRootHighContrastFocused,
                _d)
        },
        rootDisabled: getDisabledStyles(theme),
        rootError: {
            borderColor: ComboBoxRootColorErrored,
            marginBottom: '5px'
        },
        rootDisallowFreeForm: {},
        input: [
            Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["y" /* getPlaceholderStyles */])(placeholderStyles),
            {
                backgroundColor: ComboBoxRootBackground,
                color: ComboBoxRootTextColor,
                boxSizing: 'border-box',
                width: '100%',
                height: '28px',
                borderStyle: 'none',
                outline: 'none',
                font: 'inherit',
                textOverflow: 'ellipsis',
                padding: '0',
                selectors: {
                    '::-ms-clear': {
                        display: 'none'
                    }
                }
            }
        ],
        inputDisabled: [getDisabledStyles(theme), Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["y" /* getPlaceholderStyles */])(disabledPlaceholderStyles)],
        errorMessage: {
            color: ComboBoxRootColorErrored
        },
        callout: {
            boxShadow: '0 0px 5px 0px rgba(0, 0, 0, 0.4)',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: ComboBoxCalloutBorderColor
        },
        optionsContainerWrapper: {
            width: comboBoxOptionWidth
        },
        optionsContainer: {
            display: 'block'
        },
        header: [
            fonts.medium,
            {
                fontWeight: __WEBPACK_IMPORTED_MODULE_0__Styling__["f" /* FontWeights */].semibold,
                color: ComboBoxOptionHeaderTextColor,
                backgroundColor: 'none',
                borderStyle: 'none',
                height: ComboBoxOptionHeight,
                lineHeight: ComboBoxOptionHeight,
                cursor: 'default',
                padding: '0px 16px',
                userSelect: 'none',
                textAlign: 'left'
            }
        ],
        divider: {
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: ComboBoxOptionDividerBorderColor
        }
    };
    return Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["t" /* concatStyleSets */])(styles, customStyles);
    var _a, _b, _c, _d;
});
//# sourceMappingURL=ComboBox.styles.js.map

/***/ }),
/* 1822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getClassNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getComboBoxOptionClassNames; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Styling__ = __webpack_require__(5);


var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_15" /* memoizeFunction */])(function (styles, className, isOpen, disabled, required, focused, allowFreeForm, hasErrorMessage) {
    return {
        container: Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["F" /* mergeStyles */])('ms-ComboBox-container', className, styles.container),
        label: Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["F" /* mergeStyles */])(styles.label, disabled && styles.labelDisabled),
        root: Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["F" /* mergeStyles */])('ms-ComboBox', hasErrorMessage ? styles.rootError : isOpen && 'is-open', required && 'is-required', styles.root, !allowFreeForm && styles.rootDisallowFreeForm, hasErrorMessage ? styles.rootError : !disabled && focused && styles.rootFocused, !disabled && {
            selectors: {
                ':hover': hasErrorMessage ? styles.rootError : !isOpen && !focused && styles.rootHovered,
                ':active': hasErrorMessage ? styles.rootError : styles.rootPressed,
                ':focus': hasErrorMessage ? styles.rootError : styles.rootFocused
            }
        }, disabled && ['is-disabled', styles.rootDisabled]),
        input: Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["F" /* mergeStyles */])('ms-ComboBox-Input', styles.input, disabled && styles.inputDisabled),
        errorMessage: Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["F" /* mergeStyles */])(styles.errorMessage),
        callout: Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["F" /* mergeStyles */])('ms-ComboBox-callout', styles.callout),
        optionsContainerWrapper: Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["F" /* mergeStyles */])('ms-ComboBox-optionsContainerWrapper', styles.optionsContainerWrapper),
        optionsContainer: Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["F" /* mergeStyles */])('ms-ComboBox-optionsContainer', styles.optionsContainer),
        header: Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["F" /* mergeStyles */])('ms-ComboBox-header', styles.header),
        divider: Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["F" /* mergeStyles */])('ms-ComboBox-divider', styles.divider)
    };
});
var getComboBoxOptionClassNames = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_15" /* memoizeFunction */])(function (styles) {
    return {
        optionText: Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["F" /* mergeStyles */])('ms-ComboBox-optionText', styles.optionText),
        root: Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["F" /* mergeStyles */])('ms-ComboBox-option', styles.root, {
            selectors: {
                ':hover': styles.rootHovered,
                ':focus': styles.rootFocused,
                ':active': styles.rootPressed
            }
        }),
        optionTextWrapper: Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["F" /* mergeStyles */])(styles.optionTextWrapper)
    };
});
//# sourceMappingURL=ComboBox.classNames.js.map

/***/ }),
/* 1823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VirtualizedComboBox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ComboBox__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__List__ = __webpack_require__(181);





var VirtualizedComboBox = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](VirtualizedComboBox, _super);
    function VirtualizedComboBox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** The combo box element */
        _this._comboBox = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        /** The virtualized list element */
        _this._list = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._onRenderList = function (props) {
            var onRenderItem = props.onRenderItem;
            // Render virtualized list
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__List__["a" /* List */], { componentRef: _this._list, role: "listbox", items: props.options, onRenderCell: onRenderItem ? function (item) { return onRenderItem(item); } : function () { return null; } }));
        };
        _this._onScrollToItem = function (itemIndex) {
            // We are using the List component, call scrollToIndex
            _this._list.current && _this._list.current.scrollToIndex(itemIndex);
        };
        return _this;
    }
    Object.defineProperty(VirtualizedComboBox.prototype, "selectedOptions", {
        /**
         * All selected options
         */
        get: function () {
            if (this._comboBox.current) {
                return this._comboBox.current.selectedOptions;
            }
            return [];
        },
        enumerable: true,
        configurable: true
    });
    VirtualizedComboBox.prototype.dismissMenu = function () {
        if (this._comboBox.current) {
            return this._comboBox.current.dismissMenu();
        }
    };
    VirtualizedComboBox.prototype.focus = function () {
        if (this._comboBox.current) {
            this._comboBox.current.focus();
            return true;
        }
        return false;
    };
    VirtualizedComboBox.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__ComboBox__["a" /* ComboBox */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this.props, { componentRef: this._comboBox, onRenderList: this._onRenderList, onScrollToItem: this._onScrollToItem })));
    };
    return VirtualizedComboBox;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=VirtualizedComboBox.js.map

/***/ }),
/* 1824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BuyerDocumentSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_Checkbox__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Localization__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BuyerDocumentSelector=Object(__WEBPACK_IMPORTED_MODULE_3__Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["e" /* observer */])(_class=(_temp2=_class2=function(_Component){_inherits(BuyerDocumentSelector,_Component);function BuyerDocumentSelector(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BuyerDocumentSelector);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BuyerDocumentSelector.__proto__||Object.getPrototypeOf(BuyerDocumentSelector)).call.apply(_ref,[this].concat(args))),_this),_this.handleChange=function(doc,checked){var _this$props=_this.props,required=_this$props.required,disabled=_this$props.disabled;var _disabled=Array.isArray(disabled)?disabled:[disabled];if(_disabled.includes(doc))return;// disabled item cannot be checked/unchecked
var index=required.indexOf(doc);var exists=index!==-1;if(checked&&!exists){required.push(doc);}if(!checked&&exists){required.splice(index,1);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BuyerDocumentSelector,[{key:'render',value:function render(){var _this2=this;var _props=this.props,options=_props.options,label=_props.label,required=_props.required,disabled=_props.disabled;if(!options||!options.length){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.Fragment,null);}var _disabled=Array.isArray(disabled)?disabled:[disabled];return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid',style:{margin:'1em 0'}},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm6'},label)),options.map(function(o){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{key:o.key,className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm6'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_Checkbox__["a" /* Checkbox */],{label:o.text,checked:required.indexOf(o.key)!==-1,disabled:_disabled.includes(o.key),onChange:function onChange(_,checked){return _this2.handleChange(o.key,checked);}})));}));}}]);return BuyerDocumentSelector;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class2.displayName='BuyerDocumentSelector',_temp2))||_class)||_class;

/***/ }),
/* 1825 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(1827);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

/*
 *          __        ___
 *    _____/ /___  __/ (_)____
 *   / ___/ __/ / / / / / ___/
 *  (__  ) /_/ /_/ / / (__  )
 * /____/\__/\__, /_/_/____/
 *          /____/
 *
 * light - weight css preprocessor @licence MIT
 */
(function (factory) {/* eslint-disable */
	 true ? (module['exports'] = factory(null)) :
		typeof define === 'function' && define['amd'] ? define(factory(null)) :
			(window['stylis'] = factory(null))
}(/** @param {*=} options */function factory (options) {/* eslint-disable */

	'use strict'

	/**
	 * Notes
	 *
	 * The ['<method name>'] pattern is used to support closure compiler
	 * the jsdoc signatures are also used to the same effect
	 *
	 * ----
	 *
	 * int + int + int === n4 [faster]
	 *
	 * vs
	 *
	 * int === n1 && int === n2 && int === n3
	 *
	 * ----
	 *
	 * switch (int) { case ints...} [faster]
	 *
	 * vs
	 *
	 * if (int == 1 && int === 2 ...)
	 *
	 * ----
	 *
	 * The (first*n1 + second*n2 + third*n3) format used in the property parser
	 * is a simple way to hash the sequence of characters
	 * taking into account the index they occur in
	 * since any number of 3 character sequences could produce duplicates.
	 *
	 * On the other hand sequences that are directly tied to the index of the character
	 * resolve a far more accurate measure, it's also faster
	 * to evaluate one condition in a switch statement
	 * than three in an if statement regardless of the added math.
	 *
	 * This allows the vendor prefixer to be both small and fast.
	 */

	var nullptn = /^\0+/g /* matches leading null characters */
	var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */
	var colonptn = /: */g /* splits animation rules */
	var cursorptn = /zoo|gra/ /* assert cursor varient */
	var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */
	var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */
	var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */
	var elementptn = / *[\0] */g /* selector elements */
	var selectorptn = /,\r+?/g /* splits selectors */
	var andptn = /([\t\r\n ])*\f?&/g /* match & */
	var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */
	var invalidptn = /\W+/g /* removes invalid characters from keyframes */
	var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */
	var plcholdrptn = /::(place)/g /* match ::placeholder varient */
	var readonlyptn = /:(read-only)/g /* match :read-only varient */
	var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */
	var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */
	var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */
	var whiteptn = /\s{2,}/g /* matches repeating whitespace */
	var pseudoptn = /([^\(])(:+) */g /* pseudo element */
	var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */
	var gradientptn = /([\w-]+t\()/g /* match *gradient property */
	var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */
	var propertyptn = /([\s\S]*?);/g /* match properties leading semicolon */
	var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */
	var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */
	var trimptn = /[ \t]+$/ /* match tail whitspace */
	var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/ /* match max/min/fit-content, fill-available */
	var imgsrcptn = /([^-])(image-set\()/

	/* vendors */
	var webkit = '-webkit-'
	var moz = '-moz-'
	var ms = '-ms-'

	/* character codes */
	var SEMICOLON = 59 /* ; */
	var CLOSEBRACES = 125 /* } */
	var OPENBRACES = 123 /* { */
	var OPENPARENTHESES = 40 /* ( */
	var CLOSEPARENTHESES = 41 /* ) */
	var OPENBRACKET = 91 /* [ */
	var CLOSEBRACKET = 93 /* ] */
	var NEWLINE = 10 /* \n */
	var CARRIAGE = 13 /* \r */
	var TAB = 9 /* \t */
	var AT = 64 /* @ */
	var SPACE = 32 /*   */
	var AND = 38 /* & */
	var DASH = 45 /* - */
	var UNDERSCORE = 95 /* _ */
	var STAR = 42 /* * */
	var COMMA = 44 /* , */
	var COLON = 58 /* : */
	var SINGLEQUOTE = 39 /* ' */
	var DOUBLEQUOTE = 34 /* " */
	var FOWARDSLASH = 47 /* / */
	var GREATERTHAN = 62 /* > */
	var PLUS = 43 /* + */
	var TILDE = 126 /* ~ */
	var NULL = 0 /* \0 */
	var FORMFEED = 12 /* \f */
	var VERTICALTAB = 11 /* \v */

	/* special identifiers */
	var KEYFRAME = 107 /* k */
	var MEDIA = 109 /* m */
	var SUPPORTS = 115 /* s */
	var PLACEHOLDER = 112 /* p */
	var READONLY = 111 /* o */
	var IMPORT = 105 /* <at>i */
	var CHARSET = 99 /* <at>c */
	var DOCUMENT = 100 /* <at>d */
	var PAGE = 112 /* <at>p */

	var column = 1 /* current column */
	var line = 1 /* current line numebr */
	var pattern = 0 /* :pattern */

	var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */
	var prefix = 1 /* vendor prefix */
	var escape = 1 /* escape :global() pattern */
	var compress = 0 /* compress output */
	var semicolon = 0 /* no/semicolon option */
	var preserve = 0 /* preserve empty selectors */

	/* empty reference */
	var array = []

	/* plugins */
	var plugins = []
	var plugged = 0
	var should = null

	/* plugin context */
	var POSTS = -2
	var PREPS = -1
	var UNKWN = 0
	var PROPS = 1
	var BLCKS = 2
	var ATRUL = 3

	/* plugin newline context */
	var unkwn = 0

	/* keyframe animation */
	var keyed = 1
	var key = ''

	/* selector namespace */
	var nscopealt = ''
	var nscope = ''

	/**
	 * Compile
	 *
	 * @param {Array<string>} parent
	 * @param {Array<string>} current
	 * @param {string} body
	 * @param {number} id
	 * @param {number} depth
	 * @return {string}
	 */
	function compile (parent, current, body, id, depth) {
		var bracket = 0 /* brackets [] */
		var comment = 0 /* comments /* // or /* */
		var parentheses = 0 /* functions () */
		var quote = 0 /* quotes '', "" */

		var first = 0 /* first character code */
		var second = 0 /* second character code */
		var code = 0 /* current character code */
		var tail = 0 /* previous character code */
		var trail = 0 /* character before previous code */
		var peak = 0 /* previous non-whitespace code */

		var counter = 0 /* count sequence termination */
		var context = 0 /* track current context */
		var atrule = 0 /* track @at-rule context */
		var pseudo = 0 /* track pseudo token index */
		var caret = 0 /* current character index */
		var format = 0 /* control character formating context */
		var insert = 0 /* auto semicolon insertion */
		var invert = 0 /* inverted selector pattern */
		var length = 0 /* generic length address */
		var eof = body.length /* end of file(length) */
		var eol = eof - 1 /* end of file(characters) */

		var char = '' /* current character */
		var chars = '' /* current buffer of characters */
		var child = '' /* next buffer of characters */
		var out = '' /* compiled body */
		var children = '' /* compiled children */
		var flat = '' /* compiled leafs */
		var selector /* generic selector address */
		var result /* generic address */

		// ...build body
		while (caret < eof) {
			code = body.charCodeAt(caret)

			// eof varient
			if (caret === eol) {
				// last character + noop context, add synthetic padding for noop context to terminate
				if (comment + quote + parentheses + bracket !== 0) {
					if (comment !== 0) {
						code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH
					}

					quote = parentheses = bracket = 0
					eof++
					eol++
				}
			}

			if (comment + quote + parentheses + bracket === 0) {
				// eof varient
				if (caret === eol) {
					if (format > 0) {
						chars = chars.replace(formatptn, '')
					}

					if (chars.trim().length > 0) {
						switch (code) {
							case SPACE:
							case TAB:
							case SEMICOLON:
							case CARRIAGE:
							case NEWLINE: {
								break
							}
							default: {
								chars += body.charAt(caret)
							}
						}

						code = SEMICOLON
					}
				}

				// auto semicolon insertion
				if (insert === 1) {
					switch (code) {
						// false flags
						case OPENBRACES:
						case CLOSEBRACES:
						case SEMICOLON:
						case DOUBLEQUOTE:
						case SINGLEQUOTE:
						case OPENPARENTHESES:
						case CLOSEPARENTHESES:
						case COMMA: {
							insert = 0
						}
						// ignore
						case TAB:
						case CARRIAGE:
						case NEWLINE:
						case SPACE: {
							break
						}
						// valid
						default: {
							insert = 0
							length = caret
							first = code
							caret--
							code = SEMICOLON

							while (length < eof) {
								switch (body.charCodeAt(length++)) {
									case NEWLINE:
									case CARRIAGE:
									case SEMICOLON: {
										++caret
										code = first
										length = eof
										break
									}
									case COLON: {
										if (format > 0) {
											++caret
											code = first
										}
									}
									case OPENBRACES: {
										length = eof
									}
								}
							}
						}
					}
				}

				// token varient
				switch (code) {
					case OPENBRACES: {
						chars = chars.trim()
						first = chars.charCodeAt(0)
						counter = 1
						length = ++caret

						while (caret < eof) {
							switch (code = body.charCodeAt(caret)) {
								case OPENBRACES: {
									counter++
									break
								}
								case CLOSEBRACES: {
									counter--
									break
								}
								case FOWARDSLASH: {
									switch (second = body.charCodeAt(caret + 1)) {
										// /*, //
										case STAR:
										case FOWARDSLASH: {
											caret = delimited(second, caret, eol, body)
										}
									}
									break
								}
								// given "[" === 91 & "]" === 93 hence forth 91 + 1 + 1 === 93
								case OPENBRACKET: {
									code++
								}
								// given "(" === 40 & ")" === 41 hence forth 40 + 1 === 41
								case OPENPARENTHESES: {
									code++
								}
								// quote tail delimiter is identical to the head delimiter hence noop,
								// fallthrough clauses have been shifted to the correct tail delimiter
								case DOUBLEQUOTE:
								case SINGLEQUOTE: {
									while (caret++ < eol) {
										if (body.charCodeAt(caret) === code) {
											break
										}
									}
								}
							}

							if (counter === 0) {
								break
							}

							caret++
						}

						child = body.substring(length, caret)

						if (first === NULL) {
							first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0)
						}

						switch (first) {
							// @at-rule
							case AT: {
								if (format > 0) {
									chars = chars.replace(formatptn, '')
								}

								second = chars.charCodeAt(1)

								switch (second) {
									case DOCUMENT:
									case MEDIA:
									case SUPPORTS:
									case DASH: {
										selector = current
										break
									}
									default: {
										selector = array
									}
								}

								child = compile(current, selector, child, second, depth+1)
								length = child.length

								// preserve empty @at-rule
								if (preserve > 0 && length === 0) {
									length = chars.length
								}

								// execute plugins, @at-rule context
								if (plugged > 0) {
									selector = select(array, chars, invert)
									result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id)
									chars = selector.join('')

									if (result !== void 0) {
										if ((length = (child = result.trim()).length) === 0) {
											second = 0
											child = ''
										}
									}
								}

								if (length > 0) {
									switch (second) {
										case SUPPORTS: {
											chars = chars.replace(supportsptn, supports)
										}
										case DOCUMENT:
										case MEDIA:
										case DASH: {
											child = chars + '{' + child + '}'
											break
										}
										case KEYFRAME: {
											chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''))
											child = chars + '{' + child + '}'

											if (prefix === 1 || (prefix === 2 && vendor('@'+child, 3))) {
												child = '@' + webkit + child + '@' + child
											} else {
												child = '@' + child
											}
											break
										}
										default: {
											child = chars + child

											if (id === PAGE) {
												child = (out += child, '')
											}
										}
									}
								} else {
									child = ''
								}

								break
							}
							// selector
							default: {
								child = compile(current, select(current, chars, invert), child, id, depth+1)
							}
						}

						children += child

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						atrule = 0
						chars = ''
						child = ''
						code = body.charCodeAt(++caret)
						break
					}
					case CLOSEBRACES:
					case SEMICOLON: {
						chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim()

						if ((length = chars.length) > 1) {
							// monkey-patch missing colon
							if (pseudo === 0) {
								first = chars.charCodeAt(0)

								// first character is a letter or dash, buffer has a space character
								if ((first === DASH || first > 96 && first < 123)) {
									length = (chars = chars.replace(' ', ':')).length
								}
							}

							// execute plugins, property context
							if (plugged > 0) {
								if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
									if ((length = (chars = result.trim()).length) === 0) {
										chars = '\0\0'
									}
								}
							}

							first = chars.charCodeAt(0)
							second = chars.charCodeAt(1)

							switch (first) {
								case NULL: {
									break
								}
								case AT: {
									if (second === IMPORT || second === CHARSET) {
										flat += chars + body.charAt(caret)
										break
									}
								}
								default: {
									if (chars.charCodeAt(length-1) === COLON) {
										break
									}

									out += property(chars, first, second, chars.charCodeAt(2))
								}
							}
						}

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						chars = ''
						code = body.charCodeAt(++caret)
						break
					}
				}
			}

			// parse characters
			switch (code) {
				case CARRIAGE:
				case NEWLINE: {
					// auto insert semicolon
					if (comment + quote + parentheses + bracket + semicolon === 0) {
						// valid non-whitespace characters that
						// may precede a newline
						switch (peak) {
							case CLOSEPARENTHESES:
							case SINGLEQUOTE:
							case DOUBLEQUOTE:
							case AT:
							case TILDE:
							case GREATERTHAN:
							case STAR:
							case PLUS:
							case FOWARDSLASH:
							case DASH:
							case COLON:
							case COMMA:
							case SEMICOLON:
							case OPENBRACES:
							case CLOSEBRACES: {
								break
							}
							default: {
								// current buffer has a colon
								if (pseudo > 0) {
									insert = 1
								}
							}
						}
					}

					// terminate line comment
					if (comment === FOWARDSLASH) {
						comment = 0
					} else if (cascade + context === 0 && id !== KEYFRAME && chars.length > 0) {
						format = 1
						chars += '\0'
					}

					// execute plugins, newline context
					if (plugged * unkwn > 0) {
						proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id)
					}

					// next line, reset column position
					column = 1
					line++
					break
				}
				case SEMICOLON:
				case CLOSEBRACES: {
					if (comment + quote + parentheses + bracket === 0) {
						column++
						break
					}
				}
				default: {
					// increment column position
					column++

					// current character
					char = body.charAt(caret)

					// remove comments, escape functions, strings, attributes and prepare selectors
					switch (code) {
						case TAB:
						case SPACE: {
							if (quote + bracket + comment === 0) {
								switch (tail) {
									case COMMA:
									case COLON:
									case TAB:
									case SPACE: {
										char = ''
										break
									}
									default: {
										if (code !== SPACE) {
											char = ' '
										}
									}
								}
							}
							break
						}
						// escape breaking control characters
						case NULL: {
							char = '\\0'
							break
						}
						case FORMFEED: {
							char = '\\f'
							break
						}
						case VERTICALTAB: {
							char = '\\v'
							break
						}
						// &
						case AND: {
							// inverted selector pattern i.e html &
							if (quote + comment + bracket === 0 && cascade > 0) {
								invert = 1
								format = 1
								char = '\f' + char
							}
							break
						}
						// ::p<l>aceholder, l
						// :read-on<l>y, l
						case 108: {
							if (quote + comment + bracket + pattern === 0 && pseudo > 0) {
								switch (caret - pseudo) {
									// ::placeholder
									case 2: {
										if (tail === PLACEHOLDER && body.charCodeAt(caret-3) === COLON) {
											pattern = tail
										}
									}
									// :read-only
									case 8: {
										if (trail === READONLY) {
											pattern = trail
										}
									}
								}
							}
							break
						}
						// :<pattern>
						case COLON: {
							if (quote + comment + bracket === 0) {
								pseudo = caret
							}
							break
						}
						// selectors
						case COMMA: {
							if (comment + parentheses + quote + bracket === 0) {
								format = 1
								char += '\r'
							}
							break
						}
						// quotes
						case DOUBLEQUOTE:
						case SINGLEQUOTE: {
							if (comment === 0) {
								quote = quote === code ? 0 : (quote === 0 ? code : quote)
							}
							break
						}
						// attributes
						case OPENBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket++
							}
							break
						}
						case CLOSEBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket--
							}
							break
						}
						// functions
						case CLOSEPARENTHESES: {
							if (quote + comment + bracket === 0) {
								parentheses--
							}
							break
						}
						case OPENPARENTHESES: {
							if (quote + comment + bracket === 0) {
								if (context === 0) {
									switch (tail*2 + trail*3) {
										// :matches
										case 533: {
											break
										}
										// :global, :not, :nth-child etc...
										default: {
											counter = 0
											context = 1
										}
									}
								}

								parentheses++
							}
							break
						}
						case AT: {
							if (comment + parentheses + quote + bracket + pseudo + atrule === 0) {
								atrule = 1
							}
							break
						}
						// block/line comments
						case STAR:
						case FOWARDSLASH: {
							if (quote + bracket + parentheses > 0) {
								break
							}

							switch (comment) {
								// initialize line/block comment context
								case 0: {
									switch (code*2 + body.charCodeAt(caret+1)*3) {
										// //
										case 235: {
											comment = FOWARDSLASH
											break
										}
										// /*
										case 220: {
											length = caret
											comment = STAR
											break
										}
									}
									break
								}
								// end block comment context
								case STAR: {
									if (code === FOWARDSLASH && tail === STAR && length + 2 !== caret) {
										// /*<!> ... */, !
										if (body.charCodeAt(length+2) === 33) {
											out += body.substring(length, caret+1)
										}
										char = ''
										comment = 0
									}
								}
							}
						}
					}

					// ignore comment blocks
					if (comment === 0) {
						// aggressive isolation mode, divide each individual selector
						// including selectors in :not function but excluding selectors in :global function
						if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) {
							switch (code) {
								case COMMA:
								case TILDE:
								case GREATERTHAN:
								case PLUS:
								case CLOSEPARENTHESES:
								case OPENPARENTHESES: {
									if (context === 0) {
										// outside of an isolated context i.e nth-child(<...>)
										switch (tail) {
											case TAB:
											case SPACE:
											case NEWLINE:
											case CARRIAGE: {
												char = char + '\0'
												break
											}
											default: {
												char = '\0' + char + (code === COMMA ? '' : '\0')
											}
										}
										format = 1
									} else {
										// within an isolated context, sleep untill it's terminated
										switch (code) {
											case OPENPARENTHESES: {
												// :globa<l>(
												if (pseudo + 7 === caret && tail === 108) {
													pseudo = 0
												}
												context = ++counter
												break
											}
											case CLOSEPARENTHESES: {
												if ((context = --counter) === 0) {
													format = 1
													char += '\0'
												}
												break
											}
										}
									}
									break
								}
								case TAB:
								case SPACE: {
									switch (tail) {
										case NULL:
										case OPENBRACES:
										case CLOSEBRACES:
										case SEMICOLON:
										case COMMA:
										case FORMFEED:
										case TAB:
										case SPACE:
										case NEWLINE:
										case CARRIAGE: {
											break
										}
										default: {
											// ignore in isolated contexts
											if (context === 0) {
												format = 1
												char += '\0'
											}
										}
									}
								}
							}
						}

						// concat buffer of characters
						chars += char

						// previous non-whitespace character code
						if (code !== SPACE && code !== TAB) {
							peak = code
						}
					}
				}
			}

			// tail character codes
			trail = tail
			tail = code

			// visit every character
			caret++
		}

		length = out.length

		// preserve empty selector
 		if (preserve > 0) {
 			if (length === 0 && children.length === 0 && (current[0].length === 0) === false) {
 				if (id !== MEDIA || (current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0])) {
					length = current.join(',').length + 2
 				}
 			}
		}

		if (length > 0) {
			// cascade isolation mode?
			selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current

			// execute plugins, block context
			if (plugged > 0) {
				result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id)

				if (result !== void 0 && (out = result).length === 0) {
					return flat + out + children
				}
			}

			out = selector.join(',') + '{' + out + '}'

			if (prefix*pattern !== 0) {
				if (prefix === 2 && !vendor(out, 2))
					pattern = 0

				switch (pattern) {
					// ::read-only
					case READONLY: {
						out = out.replace(readonlyptn, ':'+moz+'$1')+out
						break
					}
					// ::placeholder
					case PLACEHOLDER: {
						out = (
							out.replace(plcholdrptn, '::' + webkit + 'input-$1') +
							out.replace(plcholdrptn, '::' + moz + '$1') +
							out.replace(plcholdrptn, ':' + ms + 'input-$1') + out
						)
						break
					}
				}

				pattern = 0
			}
		}

		return flat + out + children
	}

	/**
	 * Select
	 *
	 * @param {Array<string>} parent
	 * @param {string} current
	 * @param {number} invert
	 * @return {Array<string>}
	 */
	function select (parent, current, invert) {
		var selectors = current.trim().split(selectorptn)
		var out = selectors

		var length = selectors.length
		var l = parent.length

		switch (l) {
			// 0-1 parent selectors
			case 0:
			case 1: {
				for (var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i) {
					out[i] = scope(selector, out[i], invert, l).trim()
				}
				break
			}
			// >2 parent selectors, nested
			default: {
				for (var i = 0, j = 0, out = []; i < length; ++i) {
					for (var k = 0; k < l; ++k) {
						out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim()
					}
				}
			}
		}

		return out
	}

	/**
	 * Scope
	 *
	 * @param {string} parent
	 * @param {string} current
	 * @param {number} invert
	 * @param {number} level
	 * @return {string}
	 */
	function scope (parent, current, invert, level) {
		var selector = current
		var code = selector.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (selector = selector.trim()).charCodeAt(0)
		}

		switch (code) {
			// &
			case AND: {
				switch (cascade + level) {
					case 0:
					case 1: {
						if (parent.trim().length === 0) {
							break
						}
					}
					default: {
						return selector.replace(andptn, '$1'+parent.trim())
					}
				}
				break
			}
			// :
			case COLON: {
				switch (selector.charCodeAt(1)) {
					// g in :global
					case 103: {
						if (escape > 0 && cascade > 0) {
							return selector.replace(escapeptn, '$1').replace(andptn, '$1'+nscope)
						}
						break
					}
					default: {
						// :hover
						return parent.trim() + selector.replace(andptn, '$1'+parent.trim())
					}
				}
			}
			default: {
				// html &
				if (invert*cascade > 0 && selector.indexOf('\f') > 0) {
					return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1')+parent.trim())
				}
			}
		}

		return parent + selector
	}

	/**
	 * Property
	 *
	 * @param {string} input
	 * @param {number} first
	 * @param {number} second
	 * @param {number} third
	 * @return {string}
	 */
	function property (input, first, second, third) {
		var index = 0
		var out = input + ';'
		var hash = (first*2) + (second*3) + (third*4)
		var cache

		// animation: a, n, i characters
		if (hash === 944) {
			return animation(out)
		} else if (prefix === 0 || (prefix === 2 && !vendor(out, 1))) {
			return out
		}

		// vendor prefix
		switch (hash) {
			// text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
			case 1015: {
				// text-shadow/text-align/text-transform, a
				return out.charCodeAt(10) === 97 ? webkit + out + out : out
			}
			// filter/fill f, i, l
			case 951: {
				// filter, t
				return out.charCodeAt(3) === 116 ? webkit + out + out : out
			}
			// color/column, c, o, l
			case 963: {
				// column, n
				return out.charCodeAt(5) === 110 ? webkit + out + out : out
			}
			// box-decoration-break, b, o, x
			case 1009: {
				if (out.charCodeAt(4) !== 100) {
					break
				}
			}
			// mask, m, a, s
			// clip-path, c, l, i
			case 969:
			case 942: {
				return webkit + out + out
			}
			// appearance: a, p, p
			case 978: {
				return webkit + out + moz + out + out
			}
			// hyphens: h, y, p
			// user-select: u, s, e
			case 1019:
			case 983: {
				return webkit + out + moz + out + ms + out + out
			}
			// background/backface-visibility, b, a, c
			case 883: {
				// backface-visibility, -
				if (out.charCodeAt(8) === DASH) {
					return webkit + out + out
				}

				// image-set(...)
				if (out.indexOf('image-set(', 11) > 0) {
					return out.replace(imgsrcptn, '$1'+webkit+'$2') + out
				}

				return out
			}
			// flex: f, l, e
			case 932: {
				if (out.charCodeAt(4) === DASH) {
					switch (out.charCodeAt(5)) {
						// flex-grow, g
						case 103: {
							return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out
						}
						// flex-shrink, s
						case 115: {
							return webkit + out + ms + out.replace('shrink', 'negative') + out
						}
						// flex-basis, b
						case 98: {
							return webkit + out + ms + out.replace('basis', 'preferred-size') + out
						}
					}
				}

				return webkit + out + ms + out + out
			}
			// order: o, r, d
			case 964: {
				return webkit + out + ms + 'flex' + '-' + out + out
			}
			// justify-items/justify-content, j, u, s
			case 1023: {
				// justify-content, c
				if (out.charCodeAt(8) !== 99) {
					break
				}

				cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify')
				return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out
			}
			// cursor, c, u, r
			case 1005: {
				return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out
			}
			// writing-mode, w, r, i
			case 1000: {
				cache = out.substring(13).trim()
				index = cache.indexOf('-') + 1

				switch (cache.charCodeAt(0)+cache.charCodeAt(index)) {
					// vertical-lr
					case 226: {
						cache = out.replace(writingptn, 'tb')
						break
					}
					// vertical-rl
					case 232: {
						cache = out.replace(writingptn, 'tb-rl')
						break
					}
					// horizontal-tb
					case 220: {
						cache = out.replace(writingptn, 'lr')
						break
					}
					default: {
						return out
					}
				}

				return webkit + out + ms + cache + out
			}
			// position: sticky
			case 1017: {
				if (out.indexOf('sticky', 9) === -1) {
					return out
				}
			}
			// display(flex/inline-flex/inline-box): d, i, s
			case 975: {
				index = (out = input).length - 10
				cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim()

				switch (hash = cache.charCodeAt(0) + (cache.charCodeAt(7)|0)) {
					// inline-
					case 203: {
						// inline-box
						if (cache.charCodeAt(8) < 111) {
							break
						}
					}
					// inline-box/sticky
					case 115: {
						out = out.replace(cache, webkit+cache)+';'+out
						break
					}
					// inline-flex
					// flex
					case 207:
					case 102: {
						out = (
							out.replace(cache, webkit+(hash > 102 ? 'inline-' : '')+'box')+';'+
							out.replace(cache, webkit+cache)+';'+
							out.replace(cache, ms+cache+'box')+';'+
							out
						)
					}
				}

				return out + ';'
			}
			// align-items, align-center, align-self: a, l, i, -
			case 938: {
				if (out.charCodeAt(5) === DASH) {
					switch (out.charCodeAt(6)) {
						// align-items, i
						case 105: {
							cache = out.replace('-items', '')
							return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out
						}
						// align-self, s
						case 115: {
							return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out
						}
						// align-content
						default: {
							return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out
						}
					}
				}
				break
			}
			// min/max
			case 973:
			case 989: {
				// min-/max- height/width/block-size/inline-size
				if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) {
					break
				}
			}
			// height/width: min-content / width: max-content
			case 931:
			case 953: {
				if (dimensionptn.test(input) === true) {
					// stretch
					if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115)
						return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch')
					else
						return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out
				}
				break
			}
			// transform, transition: t, r, a
			case 962: {
				out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out

				// transitions
				if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) {
					return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out
				}

				break
			}
		}

		return out
	}

	/**
	 * Vendor
	 *
	 * @param {string} content
	 * @param {number} context
	 * @return {boolean}
	 */
	function vendor (content, context) {
		var index = content.indexOf(context === 1 ? ':' : '{')
		var key = content.substring(0, context !== 3 ? index : 10)
		var value = content.substring(index + 1, content.length - 1)

		return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context)
	}

	/**
	 * Supports
	 *
	 * @param {string} match
	 * @param {string} group
	 * @return {string}
	 */
	function supports (match, group) {
		var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2))

		return out !== group+';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '('+group+')'
	}

	/**
	 * Animation
	 *
	 * @param {string} input
	 * @return {string}
	 */
	function animation (input) {
		var length = input.length
		var index = input.indexOf(':', 9) + 1
		var declare = input.substring(0, index).trim()
		var out = input.substring(index, length-1).trim()

		switch (input.charCodeAt(9)*keyed) {
			case 0: {
				break
			}
			// animation-*, -
			case DASH: {
				// animation-name, n
				if (input.charCodeAt(10) !== 110) {
					break
				}
			}
			// animation/animation-name
			default: {
				// split in case of multiple animations
				var list = out.split((out = '', animationptn))

				for (var i = 0, index = 0, length = list.length; i < length; index = 0, ++i) {
					var value = list[i]
					var items = value.split(propertiesptn)

					while (value = items[index]) {
						var peak = value.charCodeAt(0)

						if (keyed === 1 && (
							// letters
							(peak > AT && peak < 90) || (peak > 96 && peak < 123) || peak === UNDERSCORE ||
							// dash but not in sequence i.e --
							(peak === DASH && value.charCodeAt(1) !== DASH)
						)) {
							// not a number/function
							switch (isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)) {
								case 1: {
									switch (value) {
										// not a valid reserved keyword
										case 'infinite': case 'alternate': case 'backwards': case 'running':
										case 'normal': case 'forwards': case 'both': case 'none': case 'linear':
										case 'ease': case 'ease-in': case 'ease-out': case 'ease-in-out':
										case 'paused': case 'reverse': case 'alternate-reverse': case 'inherit':
										case 'initial': case 'unset': case 'step-start': case 'step-end': {
											break
										}
										default: {
											value += key
										}
									}
								}
							}
						}

						items[index++] = value
					}

					out += (i === 0 ? '' : ',') + items.join(' ')
				}
			}
		}

		out = declare + out + ';'

		if (prefix === 1 || (prefix === 2 && vendor(out, 1)))
			return webkit + out + out

		return out
	}

	/**
	 * Isolate
	 *
	 * @param {Array<string>} current
	 */
	function isolate (current) {
		for (var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i) {
			// split individual elements in a selector i.e h1 h2 === [h1, h2]
			var elements = current[i].split(elementptn)
			var out = ''

			for (var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j) {
				// empty element
				if ((size = (element = elements[j]).length) === 0 && l > 1) {
					continue
				}

				tail = out.charCodeAt(out.length-1)
				code = element.charCodeAt(0)
				padding = ''

				if (j !== 0) {
					// determine if we need padding
					switch (tail) {
						case STAR:
						case TILDE:
						case GREATERTHAN:
						case PLUS:
						case SPACE:
						case OPENPARENTHESES:  {
							break
						}
						default: {
							padding = ' '
						}
					}
				}

				switch (code) {
					case AND: {
						element = padding + nscopealt
					}
					case TILDE:
					case GREATERTHAN:
					case PLUS:
					case SPACE:
					case CLOSEPARENTHESES:
					case OPENPARENTHESES: {
						break
					}
					case OPENBRACKET: {
						element = padding + element + nscopealt
						break
					}
					case COLON: {
						switch (element.charCodeAt(1)*2 + element.charCodeAt(2)*3) {
							// :global
							case 530: {
								if (escape > 0) {
									element = padding + element.substring(8, size - 1)
									break
								}
							}
							// :hover, :nth-child(), ...
							default: {
								if (j < 1 || elements[j-1].length < 1) {
									element = padding + nscopealt + element
								}
							}
						}
						break
					}
					case COMMA: {
						padding = ''
					}
					default: {
						if (size > 1 && element.indexOf(':') > 0) {
							element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2')
						} else {
							element = padding + element + nscopealt
						}
					}
				}

				out += element
			}

			selector[i] = out.replace(formatptn, '').trim()
		}

		return selector
	}

	/**
	 * Proxy
	 *
	 * @param {number} context
	 * @param {string} content
	 * @param {Array<string>} selectors
	 * @param {Array<string>} parents
	 * @param {number} line
	 * @param {number} column
	 * @param {number} length
	 * @param {number} id
	 * @param {number} depth
	 * @param {number} at
	 * @return {(string|void|*)}
	 */
	function proxy (context, content, selectors, parents, line, column, length, id, depth, at) {
		for (var i = 0, out = content, next; i < plugged; ++i) {
			switch (next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)) {
				case void 0:
				case false:
				case true:
				case null: {
					break
				}
				default: {
					out = next
				}
			}
		}
		if (out !== content) {
		  return out
		}
	}

	/**
	 * @param {number} code
	 * @param {number} index
	 * @param {number} length
	 * @param {string} body
	 * @return {number}
	 */
	function delimited (code, index, length, body) {
		for (var i = index + 1; i < length; ++i) {
			switch (body.charCodeAt(i)) {
				// /*
				case FOWARDSLASH: {
					if (code === STAR) {
						if (body.charCodeAt(i - 1) === STAR &&  index + 2 !== i) {
							return i + 1
						}
					}
					break
				}
				// //
				case NEWLINE: {
					if (code === FOWARDSLASH) {
						return i + 1
					}
				}
			}
		}

		return i
	}

	/**
	 * @param {number} type
	 * @param {number} index
	 * @param {number} length
	 * @param {number} find
	 * @param {string} body
	 * @return {number}
	 */
	function match (type, index, length, body) {
		for (var i = index + 1; i < length; ++i) {
			switch (body.charCodeAt(i)) {
				case type: {
					return i
				}
			}
		}

		return i
	}

	/**
	 * Minify
	 *
	 * @param {(string|*)} output
	 * @return {string}
	 */
	function minify (output) {
		return output
			.replace(formatptn, '')
			.replace(beforeptn, '')
			.replace(afterptn, '$1')
			.replace(tailptn, '$1')
			.replace(whiteptn, ' ')
	}

	/**
	 * Use
	 *
	 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
	 */
	function use (plugin) {
		switch (plugin) {
			case void 0:
			case null: {
				plugged = plugins.length = 0
				break
			}
			default: {
				if (typeof plugin === 'function') {
					plugins[plugged++] = plugin
				}	else if (typeof plugin === 'object') {
					for (var i = 0, length = plugin.length; i < length; ++i) {
						use(plugin[i])
					}
				} else {
					unkwn = !!plugin|0
				}
			}
 		}

 		return use
	}

	/**
	 * Set
	 *
	 * @param {*} options
	 */
	function set (options) {
		for (var name in options) {
			var value = options[name]
			switch (name) {
				case 'keyframe': keyed = value|0; break
				case 'global': escape = value|0; break
				case 'cascade': cascade = value|0; break
				case 'compress': compress = value|0; break
				case 'semicolon': semicolon = value|0; break
				case 'preserve': preserve = value|0; break
				case 'prefix':
					should = null

					if (!value) {
						prefix = 0
					} else if (typeof value !== 'function') {
						prefix = 1
					} else {
						prefix = 2
						should = value
					}
			}
		}

		return set
	}

	/**
	 * Stylis
	 *
	 * @param {string} selector
	 * @param {string} input
	 * @return {*}
	 */
	function stylis (selector, input) {
		if (this !== void 0 && this.constructor === stylis) {
			return factory(selector)
		}

		// setup
		var ns = selector
		var code = ns.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (ns = ns.trim()).charCodeAt(0)
		}

		// keyframe/animation namespace
		if (keyed > 0) {
			key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-')
		}

		// reset, used to assert if a plugin is moneky-patching the return value
		code = 1

		// cascade/isolate
		if (cascade === 1) {
			nscope = ns
		} else {
			nscopealt = ns
		}

		var selectors = [nscope]
		var result

		// execute plugins, pre-process context
		if (plugged > 0) {
			result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0)

			if (result !== void 0 && typeof result === 'string') {
				input = result
			}
		}

		// build
		var output = compile(array, selectors, input, 0, 0)

		// execute plugins, post-process context
		if (plugged > 0) {
			result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0)

			// bypass minification
			if (result !== void 0 && typeof(output = result) !== 'string') {
				code = 0
			}
		}

		// reset
		key = ''
		nscope = ''
		nscopealt = ''
		pattern = 0
		line = 1
		column = 1

		return compress*code === 0 ? output : minify(output)
	}

	stylis['use'] = use
	stylis['set'] = set

	if (options !== void 0) {
		set(options)
	}

	return stylis
}));


/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		typeof define === 'function' && define['amd'] ? define(factory()) :
			(window['stylisRuleSheet'] = factory())
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = '/*|*/'
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 1831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ActivityItem_index__ = __webpack_require__(1832);
/* unused harmony namespace reexport */

//# sourceMappingURL=ActivityItem.js.map

/***/ }),
/* 1832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ActivityItem__ = __webpack_require__(1833);
/* unused harmony namespace reexport */

//# sourceMappingURL=index.js.map

/***/ }),
/* 1833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ActivityItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ActivityItem_classNames__ = __webpack_require__(1834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ActivityItem_styles__ = __webpack_require__(1835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Persona__ = __webpack_require__(110);





/**
 * {@docCategory ActivityItem}
 */
var ActivityItem = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ActivityItem, _super);
    function ActivityItem(props) {
        var _this = _super.call(this, props) || this;
        _this._onRenderIcon = function (props) {
            if (props.activityPersonas) {
                return _this._onRenderPersonaArray(props);
            }
            else {
                return _this.props.activityIcon;
            }
        };
        _this._onRenderActivityDescription = function (props) {
            var classNames = _this._getClassNames(props);
            var activityDescription = props.activityDescription || props.activityDescriptionText;
            if (activityDescription) {
                return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: classNames.activityText }, activityDescription);
            }
            return null;
        };
        _this._onRenderComments = function (props) {
            var classNames = _this._getClassNames(props);
            var comments = props.comments || props.commentText;
            if (!props.isCompact && comments) {
                return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.commentText }, comments);
            }
            return null;
        };
        _this._onRenderTimeStamp = function (props) {
            var classNames = _this._getClassNames(props);
            if (!props.isCompact && props.timeStamp) {
                return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.timeStamp }, props.timeStamp);
            }
            return null;
        };
        // If activityPersonas is an array of persona props, build the persona cluster element.
        _this._onRenderPersonaArray = function (props) {
            var classNames = _this._getClassNames(props);
            var personaElement = null;
            var activityPersonas = props.activityPersonas;
            if (activityPersonas[0].imageUrl || activityPersonas[0].imageInitials) {
                var personaList_1 = [];
                var showSize16Personas_1 = activityPersonas.length > 1 || props.isCompact;
                var personaLimit_1 = props.isCompact ? 3 : 4;
                var style_1 = undefined;
                if (props.isCompact) {
                    style_1 = {
                        display: 'inline-block',
                        width: '10px',
                        minWidth: '10px',
                        overflow: 'visible'
                    };
                }
                activityPersonas
                    .filter(function (person, index) { return index < personaLimit_1; })
                    .forEach(function (person, index) {
                    personaList_1.push(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Persona__["b" /* PersonaCoin */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, person, { 
                        // tslint:disable-next-line:no-string-literal
                        key: person['key'] ? person['key'] : index, className: classNames.activityPersona, size: showSize16Personas_1 ? __WEBPACK_IMPORTED_MODULE_4__Persona__["d" /* PersonaSize */].size16 : __WEBPACK_IMPORTED_MODULE_4__Persona__["d" /* PersonaSize */].size32, style: style_1 })));
                });
                personaElement = __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.personaContainer }, personaList_1);
            }
            return personaElement;
        };
        return _this;
    }
    ActivityItem.prototype.render = function () {
        var _a = this.props, _b = _a.onRenderIcon, onRenderIcon = _b === void 0 ? this._onRenderIcon : _b, _c = _a.onRenderActivityDescription, onRenderActivityDescription = _c === void 0 ? this._onRenderActivityDescription : _c, _d = _a.onRenderComments, onRenderComments = _d === void 0 ? this._onRenderComments : _d, _e = _a.onRenderTimeStamp, onRenderTimeStamp = _e === void 0 ? this._onRenderTimeStamp : _e, animateBeaconSignal = _a.animateBeaconSignal, isCompact = _a.isCompact;
        var classNames = this._getClassNames(this.props);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.root, style: this.props.style },
            (this.props.activityPersonas || this.props.activityIcon || this.props.onRenderIcon) && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.activityTypeIcon },
                animateBeaconSignal && isCompact && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.pulsingBeacon }),
                onRenderIcon(this.props))),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.activityContent },
                onRenderActivityDescription(this.props, this._onRenderActivityDescription),
                onRenderComments(this.props, this._onRenderComments),
                onRenderTimeStamp(this.props, this._onRenderTimeStamp))));
    };
    ActivityItem.prototype._getClassNames = function (props) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__ActivityItem_classNames__["a" /* getClassNames */])(Object(__WEBPACK_IMPORTED_MODULE_3__ActivityItem_styles__["a" /* getStyles */])(undefined, props.styles, props.animateBeaconSignal, props.beaconColorOne, props.beaconColorTwo, props.isCompact), props.className, props.activityPersonas, props.isCompact);
    };
    return ActivityItem;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=ActivityItem.js.map

/***/ }),
/* 1834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getClassNames; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utilities__ = __webpack_require__(1);


var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["_15" /* memoizeFunction */])(function (styles, className, activityPersonas, isCompact) {
    return {
        root: Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["F" /* mergeStyles */])('ms-ActivityItem', className, styles.root, isCompact && styles.isCompactRoot),
        pulsingBeacon: Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["F" /* mergeStyles */])('ms-ActivityItem-pulsingBeacon', styles.pulsingBeacon),
        personaContainer: Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["F" /* mergeStyles */])('ms-ActivityItem-personaContainer', styles.personaContainer, isCompact && styles.isCompactPersonaContainer),
        activityPersona: Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["F" /* mergeStyles */])('ms-ActivityItem-activityPersona', styles.activityPersona, isCompact && styles.isCompactPersona, !isCompact && activityPersonas && activityPersonas.length === 2 && styles.doublePersona),
        activityTypeIcon: Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["F" /* mergeStyles */])('ms-ActivityItem-activityTypeIcon', styles.activityTypeIcon, isCompact && styles.isCompactIcon),
        activityContent: Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["F" /* mergeStyles */])('ms-ActivityItem-activityContent', styles.activityContent, isCompact && styles.isCompactContent),
        activityText: Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["F" /* mergeStyles */])('ms-ActivityItem-activityText', styles.activityText),
        commentText: Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["F" /* mergeStyles */])('ms-ActivityItem-commentText', styles.commentText),
        timeStamp: Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["F" /* mergeStyles */])('ms-ActivityItem-timeStamp', styles.timeStamp, isCompact && styles.isCompactTimeStamp)
    };
});
//# sourceMappingURL=ActivityItem.classNames.js.map

/***/ }),
/* 1835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utilities__ = __webpack_require__(1);


var DEFAULT_PERSONA_SIZE = '32px';
var COMPACT_PERSONA_SIZE = '16px';
var DEFAULT_ICON_SIZE = '16px';
var COMPACT_ICON_SIZE = '13px';
var ANIMATION_INNER_DIMENSION = '4px';
var ANIMATION_OUTER_DIMENSION = '28px';
var ANIMATION_BORDER_WIDTH = '4px';
var getStyles = Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["_15" /* memoizeFunction */])(function (theme, customStyles, animateBeaconSignal, beaconColorOne, beaconColorTwo, isCompact) {
    if (theme === void 0) { theme = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["A" /* getTheme */])(); }
    var continuousPulse = __WEBPACK_IMPORTED_MODULE_0__Styling__["k" /* PulsingBeaconAnimationStyles */].continuousPulseAnimationSingle(beaconColorOne ? beaconColorOne : theme.palette.themePrimary, beaconColorTwo ? beaconColorTwo : theme.palette.themeTertiary, ANIMATION_INNER_DIMENSION, ANIMATION_OUTER_DIMENSION, ANIMATION_BORDER_WIDTH);
    var fadeIn = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["C" /* keyframes */])({
        from: { opacity: 0 },
        to: { opacity: 1 }
    });
    var slideIn = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["C" /* keyframes */])({
        from: { transform: 'translateX(-10px)' },
        to: { transform: 'translateX(0)' }
    });
    var continuousPulseAnimation = {
        animationName: continuousPulse,
        animationIterationCount: '1',
        animationDuration: '.8s',
        zIndex: 1
    };
    var slideInAnimation = {
        animationName: slideIn,
        animationIterationCount: '1',
        animationDuration: '.5s'
    };
    var fadeInAnimation = {
        animationName: fadeIn,
        animationIterationCount: '1',
        animationDuration: '.5s'
    };
    var ActivityItemStyles = {
        root: [
            theme.fonts.small,
            {
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                boxSizing: 'border-box',
                color: theme.palette.neutralSecondary
            },
            isCompact && animateBeaconSignal && fadeInAnimation
        ],
        pulsingBeacon: [
            {
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '0px',
                height: '0px',
                borderRadius: '225px',
                borderStyle: 'solid',
                opacity: 0
            },
            isCompact && animateBeaconSignal && continuousPulseAnimation
        ],
        isCompactRoot: {
            alignItems: 'center'
        },
        personaContainer: {
            display: 'flex',
            flexWrap: 'wrap',
            minWidth: DEFAULT_PERSONA_SIZE,
            width: DEFAULT_PERSONA_SIZE,
            height: DEFAULT_PERSONA_SIZE
        },
        isCompactPersonaContainer: {
            display: 'inline-flex',
            flexWrap: 'nowrap',
            flexBasis: 'auto',
            height: COMPACT_PERSONA_SIZE,
            width: 'auto',
            minWidth: '0',
            paddingRight: '6px'
        },
        activityTypeIcon: {
            height: DEFAULT_PERSONA_SIZE,
            fontSize: DEFAULT_ICON_SIZE,
            lineHeight: DEFAULT_ICON_SIZE,
            marginTop: '3px'
        },
        isCompactIcon: {
            height: COMPACT_PERSONA_SIZE,
            minWidth: COMPACT_PERSONA_SIZE,
            fontSize: COMPACT_ICON_SIZE,
            lineHeight: COMPACT_ICON_SIZE,
            color: theme.palette.themePrimary,
            marginTop: '1px',
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            selectors: {
                '.ms-Persona-imageArea': {
                    margin: '-2px 0 0 -2px',
                    border: '2px solid' + theme.palette.white,
                    borderRadius: '50%',
                    selectors: (_a = {},
                        _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                            border: 'none',
                            margin: '0'
                        },
                        _a)
                }
            }
        },
        activityPersona: {
            display: 'block'
        },
        doublePersona: {
            selectors: {
                ':first-child': {
                    alignSelf: 'flex-end'
                }
            }
        },
        isCompactPersona: {
            display: 'inline-block',
            width: '8px',
            minWidth: '8px',
            overflow: 'visible'
        },
        activityContent: [
            {
                padding: '0 8px'
            },
            isCompact && animateBeaconSignal && slideInAnimation
        ],
        activityText: {
            display: 'inline'
        },
        isCompactContent: {
            flex: '1',
            padding: '0 4px',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflowX: 'hidden'
        },
        commentText: {
            color: theme.palette.neutralPrimary
        },
        timeStamp: [
            theme.fonts.tiny,
            {
                fontWeight: 400,
                color: theme.palette.neutralSecondary
            }
        ],
        isCompactTimeStamp: {
            display: 'inline-block',
            paddingLeft: '0.3em',
            fontSize: '1em'
        }
    };
    return Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["t" /* concatStyleSets */])(ActivityItemStyles, customStyles);
    var _a;
});
//# sourceMappingURL=ActivityItem.styles.js.map

/***/ }),
/* 1836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Persona; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Persona_base__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Persona_styles__ = __webpack_require__(1842);



/**
 * Personas are used for rendering an individual's avatar, presence and details.
 * They are used within the PeoplePicker components.
 */
var Persona = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__Persona_base__["a" /* PersonaBase */], __WEBPACK_IMPORTED_MODULE_2__Persona_styles__["a" /* getStyles */], undefined, {
    scope: 'Persona'
});
//# sourceMappingURL=Persona.js.map

/***/ }),
/* 1837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PersonaPresence__ = __webpack_require__(1838);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__PersonaPresence__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PersonaPresence_base__ = __webpack_require__(740);
/* unused harmony namespace reexport */


//# sourceMappingURL=index.js.map

/***/ }),
/* 1838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PersonaPresence; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PersonaPresence_base__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PersonaPresence_styles__ = __webpack_require__(1839);



/**
 * PersonaPresence is used to render an individual's presence.
 */
var PersonaPresence = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__PersonaPresence_base__["a" /* PersonaPresenceBase */], __WEBPACK_IMPORTED_MODULE_2__PersonaPresence_styles__["a" /* getStyles */], undefined, { scope: 'PersonaPresence' });
//# sourceMappingURL=PersonaPresence.js.map

/***/ }),
/* 1839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PersonaConsts__ = __webpack_require__(153);


var GlobalClassNames = {
    presence: 'ms-Persona-presence',
    presenceIcon: 'ms-Persona-presenceIcon'
};
var getStyles = function (props) {
    var theme = props.theme;
    var semanticColors = theme.semanticColors;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    var size = Object(__WEBPACK_IMPORTED_MODULE_1__PersonaConsts__["d" /* sizeBoolean */])(props.size);
    var presence = Object(__WEBPACK_IMPORTED_MODULE_1__PersonaConsts__["c" /* presenceBoolean */])(props.presence);
    // Presence colors
    var presenceColorAvailable = '#7FBA00';
    var presenceColorAway = '#FCD116';
    var presenceColorBusy = '#D93B3B';
    var presenceColorDnd = '#E81123';
    var presenceColorOffline = '#93ABBD';
    var presenceColorOof = '#B4009E';
    var isOpenCirclePresence = presence.isOffline || (props.isOutOfOffice && (presence.isAvailable || presence.isBusy || presence.isAway || presence.isDoNotDisturb));
    var borderSizeForSmallPersonas = '1px';
    var borderSizeForLargePersonas = '2px';
    var borderSize = size.isSize72 || size.isSize100 ? borderSizeForLargePersonas : borderSizeForSmallPersonas;
    return {
        presence: [
            classNames.presence,
            {
                position: 'absolute',
                height: __WEBPACK_IMPORTED_MODULE_1__PersonaConsts__["a" /* personaPresenceSize */].size12,
                width: __WEBPACK_IMPORTED_MODULE_1__PersonaConsts__["a" /* personaPresenceSize */].size12,
                borderRadius: '50%',
                top: 'auto',
                right: '-2px',
                bottom: '-2px',
                border: "2px solid " + semanticColors.bodyBackground,
                textAlign: 'center',
                boxSizing: 'content-box',
                backgroundClip: 'content-box',
                MsHighContrastAdjust: 'none',
                selectors: (_a = {},
                    _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        borderColor: 'Window',
                        backgroundColor: 'WindowText'
                    },
                    _a)
            },
            size.isSize10 && {
                right: 'auto',
                top: '7px',
                left: 0,
                border: 0,
                selectors: (_b = {},
                    _b[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        top: '9px',
                        border: '1px solid WindowText'
                    },
                    _b)
            },
            (size.isSize10 || size.isSize24 || size.isSize28 || size.isSize32) && makeSizeStyle(__WEBPACK_IMPORTED_MODULE_1__PersonaConsts__["a" /* personaPresenceSize */].size8),
            (size.isSize40 || size.isSize48) && makeSizeStyle(__WEBPACK_IMPORTED_MODULE_1__PersonaConsts__["a" /* personaPresenceSize */].size12),
            size.isSize16 && {
                height: __WEBPACK_IMPORTED_MODULE_1__PersonaConsts__["a" /* personaPresenceSize */].size6,
                width: __WEBPACK_IMPORTED_MODULE_1__PersonaConsts__["a" /* personaPresenceSize */].size6,
                borderWidth: '1.5px'
            },
            size.isSize72 && makeSizeStyle(__WEBPACK_IMPORTED_MODULE_1__PersonaConsts__["a" /* personaPresenceSize */].size20),
            size.isSize100 && makeSizeStyle(__WEBPACK_IMPORTED_MODULE_1__PersonaConsts__["a" /* personaPresenceSize */].size28),
            presence.isAvailable && {
                backgroundColor: presenceColorAvailable,
                selectors: (_c = {},
                    _c[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = backgroundColor('Highlight'),
                    _c)
            },
            presence.isAway && backgroundColor(presenceColorAway),
            presence.isBlocked && [
                {
                    selectors: (_d = {
                            // Only show :after at larger sizes
                            ':after': size.isSize40 || size.isSize48 || size.isSize72 || size.isSize100
                                ? {
                                    content: '""',
                                    width: '100%',
                                    height: borderSize,
                                    backgroundColor: presenceColorBusy,
                                    transform: 'translateY(-50%) rotate(-45deg)',
                                    position: 'absolute',
                                    top: '50%',
                                    left: 0
                                }
                                : undefined
                        },
                        _d[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                            selectors: {
                                ':after': {
                                    width: "calc(100% - 4px)",
                                    left: '2px',
                                    backgroundColor: 'Window'
                                }
                            }
                        },
                        _d)
                }
            ],
            presence.isBusy && backgroundColor(presenceColorBusy),
            presence.isDoNotDisturb && backgroundColor(presenceColorDnd),
            presence.isOffline && backgroundColor(presenceColorOffline),
            (isOpenCirclePresence || presence.isBlocked) && [
                {
                    backgroundColor: semanticColors.bodyBackground,
                    selectors: (_e = {
                            ':before': {
                                content: '""',
                                width: '100%',
                                height: '100%',
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                border: borderSize + " solid " + presenceColorBusy,
                                borderRadius: '50%',
                                boxSizing: 'border-box'
                            }
                        },
                        _e[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                            backgroundColor: 'WindowText',
                            selectors: {
                                ':before': {
                                    width: "calc(100% - 2px)",
                                    height: "calc(100% - 2px)",
                                    top: '1px',
                                    left: '1px',
                                    borderColor: 'Window'
                                }
                            }
                        },
                        _e)
                }
            ],
            isOpenCirclePresence && presence.isAvailable && makeBeforeBorderStyle(borderSize, presenceColorAvailable),
            isOpenCirclePresence && presence.isBusy && makeBeforeBorderStyle(borderSize, presenceColorBusy),
            isOpenCirclePresence && presence.isAway && makeBeforeBorderStyle(borderSize, presenceColorOof),
            isOpenCirclePresence && presence.isDoNotDisturb && makeBeforeBorderStyle(borderSize, presenceColorDnd),
            isOpenCirclePresence && presence.isOffline && makeBeforeBorderStyle(borderSize, presenceColorOffline),
            isOpenCirclePresence && presence.isOffline && props.isOutOfOffice && makeBeforeBorderStyle(borderSize, presenceColorOof)
        ],
        presenceIcon: [
            classNames.presenceIcon,
            {
                color: semanticColors.bodyBackground,
                fontSize: '6px',
                lineHeight: __WEBPACK_IMPORTED_MODULE_1__PersonaConsts__["a" /* personaPresenceSize */].size12,
                verticalAlign: 'top',
                selectors: (_f = {},
                    _f[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        color: 'Window'
                    },
                    _f)
            },
            size.isSize72 && {
                fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].small,
                lineHeight: __WEBPACK_IMPORTED_MODULE_1__PersonaConsts__["a" /* personaPresenceSize */].size20
            },
            size.isSize100 && {
                fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].medium,
                lineHeight: __WEBPACK_IMPORTED_MODULE_1__PersonaConsts__["a" /* personaPresenceSize */].size28
            },
            presence.isAway && {
                position: 'relative',
                left: isOpenCirclePresence ? undefined : '1px'
            },
            isOpenCirclePresence && presence.isAvailable && makeOpenCircleIconStyle(presenceColorAvailable),
            isOpenCirclePresence && presence.isBusy && makeOpenCircleIconStyle(presenceColorBusy),
            isOpenCirclePresence && presence.isAway && makeOpenCircleIconStyle(presenceColorOof),
            isOpenCirclePresence && presence.isDoNotDisturb && makeOpenCircleIconStyle(presenceColorDnd),
            isOpenCirclePresence && presence.isOffline && makeOpenCircleIconStyle(presenceColorOffline),
            isOpenCirclePresence && presence.isOffline && props.isOutOfOffice && makeOpenCircleIconStyle(presenceColorOof)
        ]
    };
    var _a, _b, _c, _d, _e, _f;
};
function makeOpenCircleIconStyle(color) {
    return {
        color: color,
        borderColor: color
    };
}
function makeBeforeBorderStyle(borderSize, color) {
    return {
        selectors: {
            ':before': {
                border: borderSize + " solid " + color
            }
        }
    };
}
function makeSizeStyle(size) {
    return {
        height: size,
        width: size
    };
}
function backgroundColor(color) {
    return { backgroundColor: color };
}
//# sourceMappingURL=PersonaPresence.styles.js.map

/***/ }),
/* 1840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Image__ = __webpack_require__(397);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Image__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Image_base__ = __webpack_require__(674);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Image_types__ = __webpack_require__(398);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Image_types__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__Image_types__["c"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 1841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PersonaConsts__ = __webpack_require__(153);


var GlobalClassNames = {
    coin: 'ms-Persona-coin',
    imageArea: 'ms-Persona-imageArea',
    image: 'ms-Persona-image',
    initials: 'ms-Persona-initials',
    size10: 'ms-Persona--size10',
    size16: 'ms-Persona--size16',
    size24: 'ms-Persona--size24',
    size28: 'ms-Persona--size28',
    size32: 'ms-Persona--size32',
    size40: 'ms-Persona--size40',
    size48: 'ms-Persona--size48',
    size72: 'ms-Persona--size72',
    size100: 'ms-Persona--size100'
};
var getStyles = function (props) {
    var className = props.className, theme = props.theme, coinSize = props.coinSize;
    var palette = theme.palette;
    var size = Object(__WEBPACK_IMPORTED_MODULE_1__PersonaConsts__["d" /* sizeBoolean */])(props.size);
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    // Static colors used when displaying 'unknown persona' coin
    var unknownPersonaBackgroundColor = 'rgb(234, 234, 234)';
    var unknownPersonaFontColor = 'rgb(168, 0, 0)';
    var dimension = coinSize || (props.size && __WEBPACK_IMPORTED_MODULE_1__PersonaConsts__["e" /* sizeToPixels */][props.size]) || 48;
    return {
        coin: [
            classNames.coin,
            theme.fonts.medium,
            size.isSize10 && classNames.size10,
            size.isSize16 && classNames.size16,
            size.isSize24 && classNames.size24,
            size.isSize28 && classNames.size28,
            size.isSize32 && classNames.size32,
            size.isSize40 && classNames.size40,
            size.isSize48 && classNames.size48,
            size.isSize72 && classNames.size72,
            size.isSize100 && classNames.size100,
            className
        ],
        size10WithoutPresenceIcon: {
            fontSize: '10px',
            position: 'absolute',
            top: '5px',
            right: 'auto',
            left: 0
        },
        imageArea: [
            classNames.imageArea,
            {
                position: 'relative',
                textAlign: 'center',
                flex: '0 0 auto',
                height: dimension,
                width: dimension
            },
            dimension <= 10 && {
                overflow: 'visible',
                background: 'transparent',
                height: 0,
                width: 0
            }
        ],
        image: [
            classNames.image,
            {
                marginRight: '10px',
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                border: 0,
                borderRadius: '50%',
                perspective: '1px'
            },
            dimension <= 10 && {
                overflow: 'visible',
                background: 'transparent',
                height: 0,
                width: 0
            },
            dimension > 10 && {
                height: dimension,
                width: dimension
            }
        ],
        initials: [
            classNames.initials,
            {
                borderRadius: '50%',
                color: props.showUnknownPersonaCoin ? unknownPersonaFontColor : palette.white,
                fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].large,
                fontWeight: __WEBPACK_IMPORTED_MODULE_0__Styling__["f" /* FontWeights */].regular,
                lineHeight: dimension === 48 ? 46 : dimension,
                height: dimension,
                selectors: (_a = {},
                    _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        border: '1px solid WindowText',
                        MsHighContrastAdjust: 'none',
                        color: 'WindowText',
                        boxSizing: 'border-box',
                        backgroundColor: 'Window !important'
                    },
                    _a)
            },
            props.showUnknownPersonaCoin && {
                backgroundColor: unknownPersonaBackgroundColor
            },
            dimension < 32 && {
                fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].xSmall
            },
            dimension >= 32 &&
                dimension < 48 && {
                fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].medium
            },
            dimension >= 72 &&
                dimension < 100 && {
                fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].xxLarge
            },
            dimension >= 100 && {
                fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].superLarge
            }
        ]
    };
    var _a;
};
//# sourceMappingURL=PersonaCoin.styles.js.map

/***/ }),
/* 1842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PersonaConsts__ = __webpack_require__(153);


var GlobalClassNames = {
    root: 'ms-Persona',
    size10: 'ms-Persona--size10',
    size16: 'ms-Persona--size16',
    size24: 'ms-Persona--size24',
    size28: 'ms-Persona--size28',
    size32: 'ms-Persona--size32',
    size40: 'ms-Persona--size40',
    size48: 'ms-Persona--size48',
    size72: 'ms-Persona--size72',
    size100: 'ms-Persona--size100',
    available: 'ms-Persona--online',
    away: 'ms-Persona--away',
    blocked: 'ms-Persona--blocked',
    busy: 'ms-Persona--busy',
    doNotDisturb: 'ms-Persona--donotdisturb',
    offline: 'ms-Persona--offline',
    details: 'ms-Persona-details',
    primaryText: 'ms-Persona-primaryText',
    secondaryText: 'ms-Persona-secondaryText',
    tertiaryText: 'ms-Persona-tertiaryText',
    optionalText: 'ms-Persona-optionalText',
    textContent: 'ms-Persona-textContent'
};
var getStyles = function (props) {
    var className = props.className, showSecondaryText = props.showSecondaryText, theme = props.theme;
    var palette = theme.palette;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    var size = Object(__WEBPACK_IMPORTED_MODULE_1__PersonaConsts__["d" /* sizeBoolean */])(props.size);
    var presence = Object(__WEBPACK_IMPORTED_MODULE_1__PersonaConsts__["c" /* presenceBoolean */])(props.presence);
    var showSecondaryTextDefaultHeight = '16px';
    var sharedTextStyles = {
        color: palette.neutralSecondary,
        fontWeight: __WEBPACK_IMPORTED_MODULE_0__Styling__["f" /* FontWeights */].regular,
        fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].small
    };
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            __WEBPACK_IMPORTED_MODULE_0__Styling__["H" /* normalize */],
            {
                color: palette.neutralPrimary,
                fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].medium,
                fontWeight: __WEBPACK_IMPORTED_MODULE_0__Styling__["f" /* FontWeights */].regular,
                position: 'relative',
                height: __WEBPACK_IMPORTED_MODULE_1__PersonaConsts__["b" /* personaSize */].size48,
                minWidth: __WEBPACK_IMPORTED_MODULE_1__PersonaConsts__["b" /* personaSize */].size48,
                display: 'flex',
                alignItems: 'center',
                selectors: {
                    '.contextualHost': {
                        display: 'none'
                    },
                    ':hover': {
                        selectors: {
                            $primaryText: {
                                color: palette.neutralDark
                            }
                        }
                    }
                }
            },
            size.isSize10 && [
                classNames.size10,
                {
                    height: __WEBPACK_IMPORTED_MODULE_1__PersonaConsts__["b" /* personaSize */].size10,
                    minWidth: __WEBPACK_IMPORTED_MODULE_1__PersonaConsts__["b" /* personaSize */].size10
                }
            ],
            size.isSize16 && [
                classNames.size16,
                {
                    height: __WEBPACK_IMPORTED_MODULE_1__PersonaConsts__["b" /* personaSize */].size16,
                    minWidth: __WEBPACK_IMPORTED_MODULE_1__PersonaConsts__["b" /* personaSize */].size16
                }
            ],
            size.isSize24 && [
                classNames.size24,
                {
                    height: __WEBPACK_IMPORTED_MODULE_1__PersonaConsts__["b" /* personaSize */].size24,
                    minWidth: __WEBPACK_IMPORTED_MODULE_1__PersonaConsts__["b" /* personaSize */].size24
                }
            ],
            size.isSize24 &&
                showSecondaryText && {
                height: '36px'
            },
            size.isSize28 && [
                classNames.size28,
                {
                    height: __WEBPACK_IMPORTED_MODULE_1__PersonaConsts__["b" /* personaSize */].size28,
                    minWidth: __WEBPACK_IMPORTED_MODULE_1__PersonaConsts__["b" /* personaSize */].size28
                }
            ],
            size.isSize28 &&
                showSecondaryText && {
                height: '32px'
            },
            size.isSize32 && [
                classNames.size32,
                {
                    height: __WEBPACK_IMPORTED_MODULE_1__PersonaConsts__["b" /* personaSize */].size32,
                    minWidth: __WEBPACK_IMPORTED_MODULE_1__PersonaConsts__["b" /* personaSize */].size32
                }
            ],
            size.isSize40 && [
                classNames.size40,
                {
                    height: __WEBPACK_IMPORTED_MODULE_1__PersonaConsts__["b" /* personaSize */].size40,
                    minWidth: __WEBPACK_IMPORTED_MODULE_1__PersonaConsts__["b" /* personaSize */].size40
                }
            ],
            size.isSize48 && classNames.size48,
            size.isSize72 && [
                classNames.size72,
                {
                    height: __WEBPACK_IMPORTED_MODULE_1__PersonaConsts__["b" /* personaSize */].size72,
                    minWidth: __WEBPACK_IMPORTED_MODULE_1__PersonaConsts__["b" /* personaSize */].size72
                }
            ],
            size.isSize100 && [
                classNames.size100,
                {
                    height: __WEBPACK_IMPORTED_MODULE_1__PersonaConsts__["b" /* personaSize */].size100,
                    minWidth: __WEBPACK_IMPORTED_MODULE_1__PersonaConsts__["b" /* personaSize */].size100
                }
            ],
            /**
             * Modifiers: presence
             */
            presence.isAvailable && classNames.available,
            presence.isAway && classNames.away,
            presence.isBlocked && classNames.blocked,
            presence.isBusy && classNames.busy,
            presence.isDoNotDisturb && classNames.doNotDisturb,
            presence.isOffline && classNames.offline,
            className
        ],
        details: [
            classNames.details,
            {
                padding: '0 24px 0 16px',
                minWidth: 0,
                width: '100%',
                textAlign: 'left',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-around'
            },
            size.isSize10 && {
                paddingLeft: '17px'
            },
            (size.isSize24 || size.isSize28) && {
                padding: '0 12px'
            }
        ],
        primaryText: [
            classNames.primaryText,
            __WEBPACK_IMPORTED_MODULE_0__Styling__["G" /* noWrap */],
            {
                color: palette.neutralPrimary,
                fontWeight: __WEBPACK_IMPORTED_MODULE_0__Styling__["f" /* FontWeights */].regular,
                fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].large
            },
            showSecondaryText && {
                height: showSecondaryTextDefaultHeight,
                lineHeight: showSecondaryTextDefaultHeight,
                overflowX: 'hidden'
            },
            size.isSize10 && {
                fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].small,
                lineHeight: __WEBPACK_IMPORTED_MODULE_1__PersonaConsts__["b" /* personaSize */].size10
            },
            (size.isSize16 || size.isSize24 || size.isSize28 || size.isSize32 || size.isSize40) && {
                fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].medium
            },
            size.isSize16 && {
                lineHeight: __WEBPACK_IMPORTED_MODULE_1__PersonaConsts__["b" /* personaSize */].size28
            },
            (size.isSize24 || size.isSize28 || size.isSize32 || size.isSize40) &&
                showSecondaryText && {
                height: '18px'
            },
            size.isSize72 && {
                fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].xLarge
            },
            size.isSize100 && {
                fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].xLarge,
                fontWeight: __WEBPACK_IMPORTED_MODULE_0__Styling__["f" /* FontWeights */].semilight
            }
        ],
        secondaryText: [
            classNames.secondaryText,
            __WEBPACK_IMPORTED_MODULE_0__Styling__["G" /* noWrap */],
            sharedTextStyles,
            (size.isSize10 || size.isSize16 || size.isSize24 || size.isSize28 || size.isSize32) && {
                display: 'none'
            },
            size.isSize24 &&
                showSecondaryText && {
                height: '18px'
            },
            (size.isSize72 || size.isSize100) && {
                fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].medium
            },
            showSecondaryText && {
                display: 'block',
                height: showSecondaryTextDefaultHeight,
                lineHeight: showSecondaryTextDefaultHeight,
                overflowX: 'hidden'
            }
        ],
        tertiaryText: [
            classNames.tertiaryText,
            __WEBPACK_IMPORTED_MODULE_0__Styling__["G" /* noWrap */],
            sharedTextStyles,
            {
                display: 'none'
            },
            (size.isSize72 || size.isSize100) && {
                display: 'block'
            }
        ],
        optionalText: [
            classNames.optionalText,
            __WEBPACK_IMPORTED_MODULE_0__Styling__["G" /* noWrap */],
            sharedTextStyles,
            {
                display: 'none'
            },
            size.isSize100 && {
                display: 'block'
            }
        ],
        textContent: [classNames.textContent, __WEBPACK_IMPORTED_MODULE_0__Styling__["G" /* noWrap */]]
    };
};
//# sourceMappingURL=Persona.styles.js.map

/***/ }),
/* 1843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PersonaCoin__ = __webpack_require__(738);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__PersonaCoin__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PersonaCoin_base__ = __webpack_require__(739);
/* unused harmony namespace reexport */


//# sourceMappingURL=index.js.map

/***/ }),
/* 1844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Announced_index__ = __webpack_require__(1845);
/* unused harmony namespace reexport */

//# sourceMappingURL=Announced.js.map

/***/ }),
/* 1845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Announced__ = __webpack_require__(1846);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Announced_base__ = __webpack_require__(743);
/* unused harmony namespace reexport */


//# sourceMappingURL=index.js.map

/***/ }),
/* 1846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Announced */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Announced_base__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Announced_styles__ = __webpack_require__(1847);



var Announced = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__Announced_base__["a" /* AnnouncedBase */], __WEBPACK_IMPORTED_MODULE_2__Announced_styles__["a" /* getStyles */]);
//# sourceMappingURL=Announced.js.map

/***/ }),
/* 1847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var getStyles = function () {
    return {
        screenReaderText: __WEBPACK_IMPORTED_MODULE_0__Styling__["B" /* hiddenContentStyle */]
    };
};
//# sourceMappingURL=Announced.styles.js.map

/***/ }),
/* 1848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Breadcrumb_index__ = __webpack_require__(1849);
/* unused harmony namespace reexport */

//# sourceMappingURL=Breadcrumb.js.map

/***/ }),
/* 1849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Breadcrumb__ = __webpack_require__(1850);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_base__ = __webpack_require__(744);
/* unused harmony namespace reexport */


//# sourceMappingURL=index.js.map

/***/ }),
/* 1850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Breadcrumb */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_base__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Breadcrumb_styles__ = __webpack_require__(1853);



var Breadcrumb = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__Breadcrumb_base__["a" /* BreadcrumbBase */], __WEBPACK_IMPORTED_MODULE_2__Breadcrumb_styles__["a" /* getStyles */], undefined, { scope: 'Breadcrumb' });
//# sourceMappingURL=Breadcrumb.js.map

/***/ }),
/* 1851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ResizeGroup__ = __webpack_require__(1852);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ResizeGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ResizeGroup_base__ = __webpack_require__(745);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResizeGroup_types__ = __webpack_require__(746);
/* unused harmony namespace reexport */



//# sourceMappingURL=index.js.map

/***/ }),
/* 1852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResizeGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ResizeGroup_base__ = __webpack_require__(745);

var ResizeGroup = __WEBPACK_IMPORTED_MODULE_0__ResizeGroup_base__["a" /* ResizeGroupBase */];
//# sourceMappingURL=ResizeGroup.js.map

/***/ }),
/* 1853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utilities__ = __webpack_require__(1);


var SingleLineTextStyle = {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
};
var MinimumScreenSelector = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["z" /* getScreenSelector */])(0, __WEBPACK_IMPORTED_MODULE_0__Styling__["m" /* ScreenWidthMaxSmall */]);
var MediumScreenSelector = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["z" /* getScreenSelector */])(__WEBPACK_IMPORTED_MODULE_0__Styling__["o" /* ScreenWidthMinMedium */], __WEBPACK_IMPORTED_MODULE_0__Styling__["l" /* ScreenWidthMaxMedium */]);
var getStyles = function (props) {
    var className = props.className, theme = props.theme;
    var overflowButtonFontSize = 16;
    var chevronSmallFontSize = 8;
    return {
        root: [
            'ms-Breadcrumb',
            theme.fonts.medium,
            {
                margin: '23px 0 1px'
            },
            className
        ],
        list: [
            'ms-Breadcrumb-list',
            {
                whiteSpace: 'nowrap',
                padding: 0,
                margin: 0,
                display: 'flex',
                alignItems: 'stretch'
            }
        ],
        listItem: [
            'ms-Breadcrumb-listItem',
            {
                listStyleType: 'none',
                margin: '0',
                padding: '0',
                display: 'flex',
                position: 'relative',
                alignItems: 'center'
            }
        ],
        chevron: [
            'ms-Breadcrumb-chevron',
            {
                color: theme.palette.neutralSecondary,
                fontSize: theme.fonts.small.fontSize,
                selectors: (_a = {},
                    _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        color: 'WindowText',
                        MsHighContrastAdjust: 'none'
                    },
                    _a[MediumScreenSelector] = {
                        fontSize: chevronSmallFontSize
                    },
                    _a[MinimumScreenSelector] = {
                        fontSize: chevronSmallFontSize
                    },
                    _a)
            }
        ],
        overflow: [
            'ms-Breadcrumb-overflow',
            {
                position: 'relative',
                display: 'flex',
                alignItems: 'center'
            }
        ],
        overflowButton: [
            'ms-Breadcrumb-overflowButton',
            Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["v" /* getFocusStyle */])(theme),
            SingleLineTextStyle,
            {
                fontSize: overflowButtonFontSize,
                height: '100%',
                cursor: 'pointer',
                selectors: (_b = {
                        ':hover': {
                            backgroundColor: theme.palette.neutralLighter
                        },
                        ':active': {
                            backgroundColor: theme.palette.neutralTertiaryAlt,
                            color: theme.semanticColors.bodyText
                        },
                        ':hover:active': {
                            // This seems unnecessary.
                            backgroundColor: theme.palette.neutralQuaternary
                        }
                    },
                    _b[MinimumScreenSelector] = {
                        padding: '4px 6px'
                    },
                    _b[MediumScreenSelector] = {
                        fontSize: theme.fonts.mediumPlus.fontSize
                    },
                    _b)
            }
        ],
        itemLink: [
            'ms-Breadcrumb-itemLink',
            Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["v" /* getFocusStyle */])(theme),
            SingleLineTextStyle,
            theme.fonts.xLarge,
            {
                textDecoration: 'none',
                color: theme.semanticColors.bodyText,
                padding: '0 8px',
                selectors: (_c = {
                        ':hover': {
                            backgroundColor: theme.semanticColors.menuItemBackgroundHovered,
                            color: 'initial',
                            cursor: 'pointer',
                            selectors: (_d = {},
                                _d[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                                    color: 'Highlight'
                                },
                                _d)
                        },
                        ':focus': {
                            color: theme.palette.neutralDark
                        },
                        ':active': {
                            backgroundColor: theme.palette.neutralTertiaryAlt,
                            color: theme.palette.neutralPrimary
                        }
                    },
                    _c[MediumScreenSelector] = theme.fonts.large,
                    _c[MinimumScreenSelector] = [theme.fonts.medium],
                    _c["." + __WEBPACK_IMPORTED_MODULE_1__Utilities__["f" /* IsFocusVisibleClassName */] + " &:focus"] = {
                        outline: "none"
                    },
                    _c)
            }
        ],
        item: [
            'ms-Breadcrumb-item',
            theme.fonts.xLarge,
            {
                color: theme.semanticColors.bodyText,
                padding: '0 8px',
                selectors: {
                    ':hover': {
                        cursor: 'default'
                    }
                }
            }
        ]
    };
    var _a, _b, _c, _d;
};
//# sourceMappingURL=Breadcrumb.styles.js.map

/***/ }),
/* 1854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ChoiceGroup__ = __webpack_require__(1855);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ChoiceGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ChoiceGroup_base__ = __webpack_require__(747);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChoiceGroupOption_index__ = __webpack_require__(423);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__ChoiceGroupOption_index__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 1855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChoiceGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ChoiceGroup_base__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChoiceGroup_styles__ = __webpack_require__(1859);



var ChoiceGroup = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__ChoiceGroup_base__["a" /* ChoiceGroupBase */], __WEBPACK_IMPORTED_MODULE_2__ChoiceGroup_styles__["a" /* getStyles */], undefined, { scope: 'ChoiceGroup' });
//# sourceMappingURL=ChoiceGroup.js.map

/***/ }),
/* 1856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChoiceGroupOption; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ChoiceGroupOption_base__ = __webpack_require__(1857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChoiceGroupOption_styles__ = __webpack_require__(1858);



var ChoiceGroupOption = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__ChoiceGroupOption_base__["a" /* ChoiceGroupOptionBase */], __WEBPACK_IMPORTED_MODULE_2__ChoiceGroupOption_styles__["a" /* getStyles */], undefined, { scope: 'ChoiceGroupOption' });
//# sourceMappingURL=ChoiceGroupOption.js.map

/***/ }),
/* 1857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChoiceGroupOptionBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Image__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icon__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utilities__ = __webpack_require__(1);





var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_4__Utilities__["r" /* classNamesFunction */])();
/**
 * {@docCategory ChoiceGroup}
 */
var ChoiceGroupOptionBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ChoiceGroupOptionBase, _super);
    function ChoiceGroupOptionBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._inputElement = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._onRenderField = function (props) {
            var _a = props.onRenderLabel, onRenderLabel = _a === void 0 ? _this._onRenderLabel : _a, id = props.id, imageSrc = props.imageSrc, imageAlt = props.imageAlt, selectedImageSrc = props.selectedImageSrc, iconProps = props.iconProps;
            var imageSize = props.imageSize ? props.imageSize : { width: 32, height: 32 };
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("label", { htmlFor: id, className: _this._classNames.field },
                imageSrc && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: _this._classNames.innerField, style: { height: imageSize.height, width: imageSize.width } },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: _this._classNames.imageWrapper },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Image__["a" /* Image */], { src: imageSrc, alt: imageAlt ? imageAlt : '', width: imageSize.width, height: imageSize.height })),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: _this._classNames.selectedImageWrapper },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Image__["a" /* Image */], { src: selectedImageSrc, alt: imageAlt ? imageAlt : '', width: imageSize.width, height: imageSize.height })))),
                iconProps ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: _this._classNames.innerField },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: _this._classNames.iconWrapper },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Icon__["Icon"], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, iconProps))))) : null,
                imageSrc || iconProps ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: _this._classNames.labelWrapper, style: { maxWidth: imageSize.width * 2 } }, onRenderLabel(props))) : (onRenderLabel(props))));
        };
        _this._onRenderLabel = function (props) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { id: props.labelId, className: "ms-ChoiceFieldLabel" }, props.text));
        };
        return _this;
    }
    ChoiceGroupOptionBase.prototype.render = function () {
        var _a = this.props, ariaLabel = _a.ariaLabel, focused = _a.focused, required = _a.required, theme = _a.theme, iconProps = _a.iconProps, imageSrc = _a.imageSrc, _b = _a.imageSize, imageSize = _b === void 0 ? { width: 32, height: 32 } : _b, disabled = _a.disabled, checked = _a.checked, id = _a.id, styles = _a.styles, name = _a.name, _c = _a.onRenderField, onRenderField = _c === void 0 ? this._onRenderField : _c, rest = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __rest */](_a, ["ariaLabel", "focused", "required", "theme", "iconProps", "imageSrc", "imageSize", "disabled", "checked", "id", "styles", "name", "onRenderField"]);
        this._classNames = getClassNames(styles, {
            theme: theme,
            hasIcon: !!iconProps,
            hasImage: !!imageSrc,
            checked: checked,
            disabled: disabled,
            imageIsLarge: !!imageSrc && (imageSize.width > 71 || imageSize.height > 71),
            focused: focused
        });
        var _d = Object(__WEBPACK_IMPORTED_MODULE_4__Utilities__["R" /* getNativeProps */])(rest, __WEBPACK_IMPORTED_MODULE_4__Utilities__["_7" /* inputProperties */]), className = _d.className, nativeProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __rest */](_d, ["className"]);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.root },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.choiceFieldWrapper },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("input", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ "aria-label": ariaLabel ? ariaLabel : undefined, ref: this._inputElement, id: id, className: Object(__WEBPACK_IMPORTED_MODULE_4__Utilities__["t" /* css */])(this._classNames.input, className), type: "radio", name: name, disabled: disabled, checked: checked, required: required, onChange: this._onChange.bind(this, this.props), onFocus: this._onFocus.bind(this, this.props), onBlur: this._onBlur.bind(this, this.props) }, nativeProps)),
                onRenderField(this.props, this._onRenderField))));
    };
    ChoiceGroupOptionBase.prototype._onChange = function (props, evt) {
        var onChange = props.onChange;
        if (onChange) {
            onChange(evt, props);
        }
    };
    ChoiceGroupOptionBase.prototype._onBlur = function (props, evt) {
        var onBlur = props.onBlur;
        if (onBlur) {
            onBlur(evt, props);
        }
    };
    ChoiceGroupOptionBase.prototype._onFocus = function (props, evt) {
        var onFocus = props.onFocus;
        if (onFocus) {
            onFocus(evt, props);
        }
    };
    return ChoiceGroupOptionBase;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=ChoiceGroupOption.base.js.map

/***/ }),
/* 1858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utilities__ = __webpack_require__(1);


var GlobalClassNames = {
    root: 'ms-ChoiceField',
    choiceFieldWrapper: 'ms-ChoiceField-wrapper',
    input: 'ms-ChoiceField-input',
    field: 'ms-ChoiceField-field',
    innerField: 'ms-ChoiceField-innerField',
    imageWrapper: 'ms-ChoiceField-imageWrapper',
    iconWrapper: 'ms-ChoiceField-iconWrapper',
    labelWrapper: 'ms-ChoiceField-labelWrapper',
    checked: 'is-checked'
};
var labelWrapperLineHeight = 15;
var iconSize = 32;
var choiceFieldSize = 20;
var choiceFieldTransitionDuration = '200ms';
var choiceFieldTransitionTiming = 'cubic-bezier(.4, 0, .23, 1)';
var radioButtonSpacing = 3;
var radioButtonInnerSize = 5;
function getChoiceGroupFocusStyle(palette, hasIconOrImage) {
    return [
        'is-inFocus',
        {
            selectors: (_a = {},
                _a["." + __WEBPACK_IMPORTED_MODULE_1__Utilities__["f" /* IsFocusVisibleClassName */] + " &"] = {
                    position: 'relative',
                    outline: 'transparent',
                    selectors: {
                        '::-moz-focus-inner': {
                            border: 0
                        },
                        ':after': {
                            content: '""',
                            top: -2,
                            right: -2,
                            bottom: -2,
                            left: -2,
                            pointerEvents: 'none',
                            border: '1px solid ' + (hasIconOrImage ? palette.neutralSecondary : palette.neutralPrimary),
                            position: 'absolute',
                            selectors: (_b = {},
                                _b[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                                    borderColor: 'WindowText',
                                    borderWidth: hasIconOrImage ? 1 : 2
                                },
                                _b)
                        }
                    }
                },
                _a)
        }
    ];
    var _a, _b;
}
function getImageWrapperStyle(isSelectedImageWrapper, className, checked) {
    return [
        className,
        {
            paddingBottom: 2,
            transitionProperty: 'opacity',
            transitionDuration: choiceFieldTransitionDuration,
            transitionTimingFunction: 'ease',
            selectors: {
                '.ms-Image': {
                    display: 'inline-block',
                    borderStyle: 'none'
                }
            }
        },
        (checked ? !isSelectedImageWrapper : isSelectedImageWrapper) && [
            'is-hidden',
            {
                position: 'absolute',
                left: 0,
                top: 0,
                width: '100%',
                height: '100%',
                overflow: 'hidden',
                opacity: 0
            }
        ]
    ];
}
var getStyles = function (props) {
    var theme = props.theme, hasIcon = props.hasIcon, hasImage = props.hasImage, checked = props.checked, disabled = props.disabled, imageIsLarge = props.imageIsLarge, focused = props.focused;
    var palette = theme.palette, semanticColors = theme.semanticColors;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    var fieldHoverOrFocusProperties = {
        selectors: {
            '.ms-ChoiceFieldLabel': {
                color: semanticColors.bodyTextChecked
            },
            ':before': {
                borderColor: checked ? semanticColors.inputBackgroundCheckedHovered : semanticColors.inputBorderHovered
            }
        }
    };
    var enabledFieldWithImageHoverOrFocusProperties = {
        borderColor: checked ? palette.themeDark : palette.neutralTertiaryAlt,
        selectors: {
            ':before': {
                opacity: 1,
                borderColor: checked ? palette.themeDark : semanticColors.inputBorderHovered
            }
        }
    };
    var circleAreaProperties = [
        {
            content: '""',
            display: 'inline-block',
            backgroundColor: semanticColors.bodyBackground,
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: semanticColors.smallInputBorder,
            width: choiceFieldSize,
            height: choiceFieldSize,
            fontWeight: 'normal',
            position: 'absolute',
            top: 0,
            left: 0,
            boxSizing: 'border-box',
            transitionProperty: 'border-color',
            transitionDuration: choiceFieldTransitionDuration,
            transitionTimingFunction: choiceFieldTransitionTiming,
            borderRadius: '50%'
        },
        disabled && {
            backgroundColor: checked ? semanticColors.bodyBackground : semanticColors.disabledText,
            borderColor: semanticColors.disabledText,
            selectors: (_a = {},
                _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                    color: 'GrayText'
                },
                _a)
        },
        checked && {
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: disabled ? semanticColors.disabledText : semanticColors.inputBackgroundChecked,
            selectors: (_b = {},
                _b[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                    borderColor: 'Highlight'
                },
                _b)
        },
        (hasIcon || hasImage) && {
            top: radioButtonSpacing,
            right: radioButtonSpacing,
            left: 'auto',
            opacity: !disabled && checked ? 1 : 0
        }
    ];
    var dotAreaProperties = [
        {
            content: '""',
            width: 0,
            height: 0,
            borderRadius: '50%',
            position: 'absolute',
            left: choiceFieldSize / 2,
            right: 0,
            transitionProperty: 'border-width',
            transitionDuration: choiceFieldTransitionDuration,
            transitionTimingFunction: choiceFieldTransitionTiming,
            boxSizing: 'border-box'
        },
        checked && {
            borderWidth: 5,
            borderStyle: 'solid',
            borderColor: disabled ? semanticColors.disabledText : semanticColors.inputBackgroundChecked,
            left: 5,
            top: 5,
            width: 10,
            height: 10,
            selectors: (_c = {},
                _c[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                    borderColor: 'Highlight'
                },
                _c)
        },
        checked &&
            (hasIcon || hasImage) && {
            top: radioButtonSpacing + radioButtonInnerSize,
            right: radioButtonSpacing + radioButtonInnerSize,
            left: 'auto' // To reset the value of 'left' to its default value, so that 'right' works
        }
    ];
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            {
                display: 'flex',
                alignItems: 'center',
                boxSizing: 'border-box',
                color: semanticColors.bodyText,
                fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].medium,
                fontWeight: __WEBPACK_IMPORTED_MODULE_0__Styling__["f" /* FontWeights */].regular,
                minHeight: 26,
                border: 'none',
                position: 'relative',
                marginTop: 8,
                selectors: {
                    '.ms-ChoiceFieldLabel': {
                        fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].medium,
                        display: 'inline-block'
                    }
                }
            },
            !hasIcon &&
                !hasImage && {
                selectors: {
                    '.ms-ChoiceFieldLabel': {
                        paddingLeft: '26px'
                    }
                }
            },
            hasImage && 'ms-ChoiceField--image',
            hasIcon && 'ms-ChoiceField--icon',
            (hasIcon || hasImage) && {
                display: 'inline-flex',
                fontSize: 0,
                margin: '0 4px 4px 0',
                paddingLeft: 0,
                backgroundColor: palette.neutralLighter,
                height: '100%'
            }
        ],
        choiceFieldWrapper: [classNames.choiceFieldWrapper, focused && getChoiceGroupFocusStyle(palette, hasIcon || hasImage)],
        // The hidden input
        input: [
            classNames.input,
            {
                position: 'absolute',
                opacity: 0,
                top: 0,
                right: 0,
                width: '100%',
                height: '100%',
                margin: 0
            }
        ],
        field: [
            classNames.field,
            checked && classNames.checked,
            {
                display: 'inline-block',
                cursor: 'pointer',
                marginTop: 0,
                position: 'relative',
                verticalAlign: 'top',
                userSelect: 'none',
                minHeight: 20,
                selectors: {
                    ':hover': !disabled && fieldHoverOrFocusProperties,
                    ':focus': !disabled && fieldHoverOrFocusProperties,
                    // The circle
                    ':before': circleAreaProperties,
                    // The dot
                    ':after': dotAreaProperties
                }
            },
            hasIcon && 'ms-ChoiceField--icon',
            hasImage && 'ms-ChoiceField-field--image',
            (hasIcon || hasImage) && {
                boxSizing: 'content-box',
                cursor: 'pointer',
                paddingTop: 22,
                margin: 0,
                textAlign: 'center',
                transitionProperty: 'all',
                transitionDuration: choiceFieldTransitionDuration,
                transitionTimingFunction: 'ease',
                border: '2px solid transparent',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column'
            },
            checked && {
                borderColor: palette.themePrimary
            },
            (hasIcon || hasImage) &&
                !disabled && {
                selectors: {
                    ':hover': enabledFieldWithImageHoverOrFocusProperties,
                    ':focus': enabledFieldWithImageHoverOrFocusProperties
                }
            },
            disabled && {
                cursor: 'default',
                selectors: (_d = {
                        '.ms-ChoiceFieldLabel': {
                            color: semanticColors.disabledBodyText
                        }
                    },
                    _d[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        color: 'GrayText'
                    },
                    _d)
            }
        ],
        innerField: [
            classNames.innerField,
            (hasIcon || hasImage) && {
                position: 'relative',
                display: 'inline-block',
                paddingLeft: 30,
                paddingRight: 30
            },
            (hasIcon || hasImage) &&
                imageIsLarge && {
                paddingLeft: 24,
                paddingRight: 24
            },
            (hasIcon || hasImage) &&
                disabled && {
                opacity: 0.25,
                selectors: (_e = {},
                    _e[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        color: 'GrayText',
                        opacity: 1
                    },
                    _e)
            }
        ],
        imageWrapper: getImageWrapperStyle(false, classNames.imageWrapper, checked),
        selectedImageWrapper: getImageWrapperStyle(true, classNames.imageWrapper, checked),
        iconWrapper: [
            classNames.iconWrapper,
            {
                fontSize: iconSize,
                lineHeight: iconSize,
                height: iconSize
            }
        ],
        labelWrapper: [
            classNames.labelWrapper,
            (hasIcon || hasImage) && {
                display: 'block',
                position: 'relative',
                margin: '4px 8px',
                height: labelWrapperLineHeight * 2,
                lineHeight: labelWrapperLineHeight,
                overflow: 'hidden',
                whiteSpace: 'pre-wrap',
                textOverflow: 'ellipsis',
                fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].medium,
                fontWeight: __WEBPACK_IMPORTED_MODULE_0__Styling__["f" /* FontWeights */].regular
            }
        ]
    };
    var _a, _b, _c, _d, _e;
};
//# sourceMappingURL=ChoiceGroupOption.styles.js.map

/***/ }),
/* 1859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var GlobalClassNames = {
    root: 'ms-ChoiceFieldGroup',
    flexContainer: 'ms-ChoiceFieldGroup-flexContainer'
};
var getStyles = function (props) {
    var className = props.className, optionsContainIconOrImage = props.optionsContainIconOrImage, theme = props.theme;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    return {
        applicationRole: className,
        root: [
            classNames.root,
            theme.fonts.medium,
            {
                display: 'block'
            }
        ],
        flexContainer: [
            classNames.flexContainer,
            optionsContainIconOrImage && {
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap'
            }
        ]
    };
};
//# sourceMappingURL=ChoiceGroup.styles.js.map

/***/ }),
/* 1860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ChoiceGroup_ChoiceGroupOption_index__ = __webpack_require__(423);
/* unused harmony namespace reexport */

//# sourceMappingURL=ChoiceGroupOption.js.map

/***/ }),
/* 1861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Coachmark_index__ = __webpack_require__(1862);
/* unused harmony namespace reexport */

//# sourceMappingURL=Coachmark.js.map

/***/ }),
/* 1862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Coachmark__ = __webpack_require__(1863);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Coachmark_base__ = __webpack_require__(749);
/* unused harmony namespace reexport */


//# sourceMappingURL=index.js.map

/***/ }),
/* 1863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Coachmark */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Coachmark_styles__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Coachmark_base__ = __webpack_require__(749);



var Coachmark = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_2__Coachmark_base__["a" /* CoachmarkBase */], __WEBPACK_IMPORTED_MODULE_1__Coachmark_styles__["c" /* getStyles */], undefined, {
    scope: 'Coachmark'
});
//# sourceMappingURL=Coachmark.js.map

/***/ }),
/* 1864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PositioningContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PositioningContainer_styles__ = __webpack_require__(1865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Layer__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_DirectionalHint__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_positioning__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Styling__ = __webpack_require__(5);




// Utilites/Helpers




var OFF_SCREEN_STYLE = { opacity: 0 };
// In order for some of the max height logic to work
// properly we need to set the border.
// The value is abitrary.
var BORDER_WIDTH = 1;
var SLIDE_ANIMATIONS = (_a = {},
    _a[__WEBPACK_IMPORTED_MODULE_6__utilities_positioning__["b" /* RectangleEdge */].top] = 'slideUpIn20',
    _a[__WEBPACK_IMPORTED_MODULE_6__utilities_positioning__["b" /* RectangleEdge */].bottom] = 'slideDownIn20',
    _a[__WEBPACK_IMPORTED_MODULE_6__utilities_positioning__["b" /* RectangleEdge */].left] = 'slideLeftIn20',
    _a[__WEBPACK_IMPORTED_MODULE_6__utilities_positioning__["b" /* RectangleEdge */].right] = 'slideRightIn20',
    _a);
var PositioningContainer = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](PositioningContainer, _super);
    function PositioningContainer(props) {
        var _this = _super.call(this, props) || this;
        /**
         * The primary positioned div.
         */
        _this._positionedHost = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        // @TODO rename to reflect the name of this class
        _this._contentHost = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        /**
         * Deprecated, use `onResize` instead.
         * @deprecated Use `onResize` instead.
         */
        _this.dismiss = function (ev) {
            _this.onResize(ev);
        };
        _this.onResize = function (ev) {
            var onDismiss = _this.props.onDismiss;
            if (onDismiss) {
                onDismiss(ev);
            }
            else {
                _this._updateAsyncPosition();
            }
        };
        _this._setInitialFocus = function () {
            if (_this._contentHost.current && _this.props.setInitialFocus && !_this._didSetInitialFocus && _this.state.positions) {
                _this._didSetInitialFocus = true;
                Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["F" /* focusFirstChild */])(_this._contentHost.current);
            }
        };
        _this._onComponentDidMount = function () {
            // This is added so the positioningContainer will dismiss when the window is scrolled
            // but not when something inside the positioningContainer is scrolled. The delay seems
            // to be required to avoid React firing an async focus event in IE from
            // the target changing focus quickly prior to rendering the positioningContainer.
            _this._async.setTimeout(function () {
                _this._events.on(_this._targetWindow, 'scroll', _this._async.throttle(_this._dismissOnScroll, 10), true);
                _this._events.on(_this._targetWindow, 'resize', _this._async.throttle(_this.onResize, 10), true);
                _this._events.on(_this._targetWindow.document.body, 'focus', _this._dismissOnLostFocus, true);
                _this._events.on(_this._targetWindow.document.body, 'click', _this._dismissOnLostFocus, true);
            }, 0);
            if (_this.props.onLayerMounted) {
                _this.props.onLayerMounted();
            }
            _this._updateAsyncPosition();
            _this._setHeightOffsetEveryFrame();
        };
        _this._didSetInitialFocus = false;
        _this.state = {
            positions: undefined,
            heightOffset: 0
        };
        _this._positionAttempts = 0;
        return _this;
    }
    PositioningContainer.prototype.componentWillMount = function () {
        this._setTargetWindowAndElement(this._getTarget());
    };
    PositioningContainer.prototype.componentDidMount = function () {
        this._onComponentDidMount();
    };
    PositioningContainer.prototype.componentDidUpdate = function () {
        this._setInitialFocus();
        this._updateAsyncPosition();
    };
    PositioningContainer.prototype.componentWillUpdate = function (newProps) {
        // If the target element changed, find the new one. If we are tracking
        // target with class name, always find element because we do not know if
        // fabric has rendered a new element and disposed the old element.
        var newTarget = this._getTarget(newProps);
        var oldTarget = this._getTarget();
        if (newTarget !== oldTarget || typeof newTarget === 'string' || newTarget instanceof String) {
            this._maxHeight = undefined;
            this._setTargetWindowAndElement(newTarget);
        }
        if (newProps.offsetFromTarget !== this.props.offsetFromTarget) {
            this._maxHeight = undefined;
        }
        if (newProps.finalHeight !== this.props.finalHeight) {
            this._setHeightOffsetEveryFrame();
        }
    };
    PositioningContainer.prototype.render = function () {
        // If there is no target window then we are likely in server side rendering and we should not render anything.
        if (!this._targetWindow) {
            return null;
        }
        var _a = this.props, className = _a.className, positioningContainerWidth = _a.positioningContainerWidth, positioningContainerMaxHeight = _a.positioningContainerMaxHeight, children = _a.children;
        var positions = this.state.positions;
        var styles = Object(__WEBPACK_IMPORTED_MODULE_2__PositioningContainer_styles__["a" /* getClassNames */])();
        var directionalClassName = positions && positions.targetEdge ? __WEBPACK_IMPORTED_MODULE_7__Styling__["a" /* AnimationClassNames */][SLIDE_ANIMATIONS[positions.targetEdge]] : '';
        var getContentMaxHeight = this._getMaxHeight() + this.state.heightOffset;
        var contentMaxHeight = positioningContainerMaxHeight && positioningContainerMaxHeight > getContentMaxHeight
            ? getContentMaxHeight
            : positioningContainerMaxHeight;
        var content = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: this._positionedHost, className: Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["t" /* css */])('ms-PositioningContainer', styles.container) },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: Object(__WEBPACK_IMPORTED_MODULE_7__Styling__["F" /* mergeStyles */])('ms-PositioningContainer-layerHost', styles.root, className, directionalClassName, !!positioningContainerWidth && { width: positioningContainerWidth }), 
                // tslint:disable-next-line:jsx-ban-props
                style: positions ? positions.elementPosition : OFF_SCREEN_STYLE, tabIndex: -1, 
                // See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#Clicking_and_focus
                ref: this._contentHost },
                children,
                // @TODO apply to the content container
                contentMaxHeight)));
        return this.props.doNotLayer ? content : __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Layer__["a" /* Layer */], null, content);
    };
    PositioningContainer.prototype._dismissOnScroll = function (ev) {
        var preventDismissOnScroll = this.props.preventDismissOnScroll;
        if (this.state.positions && !preventDismissOnScroll) {
            this._dismissOnLostFocus(ev);
        }
    };
    PositioningContainer.prototype._dismissOnLostFocus = function (ev) {
        var target = ev.target;
        var clickedOutsideCallout = this._positionedHost.current && !Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["y" /* elementContains */])(this._positionedHost.current, target);
        if ((!this._target && clickedOutsideCallout) ||
            (ev.target !== this._targetWindow &&
                clickedOutsideCallout &&
                (this._target.stopPropagation ||
                    (!this._target || (target !== this._target && !Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["y" /* elementContains */])(this._target, target)))))) {
            this.onResize(ev);
        }
    };
    PositioningContainer.prototype._updateAsyncPosition = function () {
        var _this = this;
        this._async.requestAnimationFrame(function () { return _this._updatePosition(); });
    };
    PositioningContainer.prototype._updatePosition = function () {
        var positions = this.state.positions;
        var _a = this.props, offsetFromTarget = _a.offsetFromTarget, onPositioned = _a.onPositioned;
        var hostElement = this._positionedHost.current;
        var positioningContainerElement = this._contentHost.current;
        if (hostElement && positioningContainerElement) {
            var currentProps = void 0;
            currentProps = Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["n" /* assign */])(currentProps, this.props);
            currentProps.bounds = this._getBounds();
            currentProps.target = this._target;
            if (document.body.contains(currentProps.target)) {
                currentProps.gapSpace = offsetFromTarget;
                var newPositions_1 = Object(__WEBPACK_IMPORTED_MODULE_6__utilities_positioning__["g" /* positionElement */])(currentProps, hostElement, positioningContainerElement);
                // Set the new position only when the positions are not exists or one of the new positioningContainer positions are different.
                // The position should not change if the position is within 2 decimal places.
                if ((!positions && newPositions_1) ||
                    (positions && newPositions_1 && !this._arePositionsEqual(positions, newPositions_1) && this._positionAttempts < 5)) {
                    // We should not reposition the positioningContainer more than a few times, if it is then the content is likely resizing
                    // and we should stop trying to reposition to prevent a stack overflow.
                    this._positionAttempts++;
                    this.setState({
                        positions: newPositions_1
                    }, function () {
                        if (onPositioned) {
                            onPositioned(newPositions_1);
                        }
                    });
                }
                else {
                    this._positionAttempts = 0;
                    if (onPositioned) {
                        onPositioned(newPositions_1);
                    }
                }
            }
            else if (positions !== undefined) {
                this.setState({
                    positions: undefined
                });
            }
        }
    };
    PositioningContainer.prototype._getBounds = function () {
        if (!this._positioningBounds) {
            var currentBounds = this.props.bounds;
            if (!currentBounds) {
                currentBounds = {
                    top: 0 + this.props.minPagePadding,
                    left: 0 + this.props.minPagePadding,
                    right: this._targetWindow.innerWidth - this.props.minPagePadding,
                    bottom: this._targetWindow.innerHeight - this.props.minPagePadding,
                    width: this._targetWindow.innerWidth - this.props.minPagePadding * 2,
                    height: this._targetWindow.innerHeight - this.props.minPagePadding * 2
                };
            }
            this._positioningBounds = currentBounds;
        }
        return this._positioningBounds;
    };
    /**
     * Return the maximum height the container can grow to
     * without going out of the specified bounds
     */
    PositioningContainer.prototype._getMaxHeight = function () {
        var _a = this.props, directionalHintFixed = _a.directionalHintFixed, offsetFromTarget = _a.offsetFromTarget, directionalHint = _a.directionalHint;
        if (!this._maxHeight) {
            if (directionalHintFixed && this._target) {
                var gapSpace = offsetFromTarget ? offsetFromTarget : 0;
                this._maxHeight = Object(__WEBPACK_IMPORTED_MODULE_6__utilities_positioning__["c" /* getMaxHeight */])(this._target, directionalHint, gapSpace, this._getBounds());
            }
            else {
                this._maxHeight = this._getBounds().height - BORDER_WIDTH * 2;
            }
        }
        return this._maxHeight;
    };
    PositioningContainer.prototype._arePositionsEqual = function (positions, newPosition) {
        return this._comparePositions(positions.elementPosition, newPosition.elementPosition);
    };
    PositioningContainer.prototype._comparePositions = function (oldPositions, newPositions) {
        for (var key in newPositions) {
            // This needs to be checked here and below because there is a linting error if for in does not immediately have an if statement
            if (newPositions.hasOwnProperty(key)) {
                var oldPositionEdge = oldPositions[key];
                var newPositionEdge = newPositions[key];
                if (oldPositionEdge && newPositionEdge) {
                    if (oldPositionEdge.toFixed(2) !== newPositionEdge.toFixed(2)) {
                        return false;
                    }
                }
            }
        }
        return true;
    };
    PositioningContainer.prototype._setTargetWindowAndElement = function (target) {
        var currentElement = this._positionedHost.current;
        if (target) {
            if (typeof target === 'string') {
                var currentDoc = Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["I" /* getDocument */])();
                this._target = currentDoc ? currentDoc.querySelector(target) : null;
                this._targetWindow = Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["Z" /* getWindow */])(currentElement);
            }
            else if (target.stopPropagation) {
                this._targetWindow = Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["Z" /* getWindow */])(target.toElement);
                this._target = target;
            }
            else if (target.x !== undefined && target.y !== undefined) {
                this._targetWindow = Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["Z" /* getWindow */])(currentElement);
                this._target = target;
            }
            else {
                var targetElement = target;
                this._targetWindow = Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["Z" /* getWindow */])(targetElement);
                this._target = target;
            }
        }
        else {
            this._targetWindow = Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["Z" /* getWindow */])(currentElement);
        }
    };
    /**
     * Animates the height if finalHeight was given.
     */
    PositioningContainer.prototype._setHeightOffsetEveryFrame = function () {
        var _this = this;
        if (this._contentHost && this.props.finalHeight) {
            this._setHeightOffsetTimer = this._async.requestAnimationFrame(function () {
                if (!_this._contentHost.current) {
                    return;
                }
                var positioningContainerMainElem = _this._contentHost.current.lastChild;
                var cardScrollHeight = positioningContainerMainElem.scrollHeight;
                var cardCurrHeight = positioningContainerMainElem.offsetHeight;
                var scrollDiff = cardScrollHeight - cardCurrHeight;
                _this.setState({
                    heightOffset: _this.state.heightOffset + scrollDiff
                });
                if (positioningContainerMainElem.offsetHeight < _this.props.finalHeight) {
                    _this._setHeightOffsetEveryFrame();
                }
                else {
                    _this._async.cancelAnimationFrame(_this._setHeightOffsetTimer);
                }
            });
        }
    };
    PositioningContainer.prototype._getTarget = function (props) {
        if (props === void 0) { props = this.props; }
        var target = props.target;
        return target;
    };
    PositioningContainer.defaultProps = {
        preventDismissOnScroll: false,
        offsetFromTarget: 0,
        minPagePadding: 8,
        directionalHint: __WEBPACK_IMPORTED_MODULE_4__common_DirectionalHint__["a" /* DirectionalHint */].bottomAutoEdge
    };
    return PositioningContainer;
}(__WEBPACK_IMPORTED_MODULE_5__Utilities__["c" /* BaseComponent */]));

var _a;
//# sourceMappingURL=PositioningContainer.js.map

/***/ }),
/* 1865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getClassNames; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Styling__ = __webpack_require__(5);


var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_15" /* memoizeFunction */])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["E" /* mergeStyleSets */])({
        root: [
            {
                position: 'absolute',
                boxSizing: 'border-box',
                border: '1px solid ${}',
                selectors: (_a = {},
                    _a[__WEBPACK_IMPORTED_MODULE_1__Styling__["g" /* HighContrastSelector */]] = {
                        border: '1px solid WindowText'
                    },
                    _a)
            },
            Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["u" /* focusClear */])()
        ],
        container: {
            position: 'relative'
        },
        main: {
            backgroundColor: '#ffffff',
            overflowX: 'hidden',
            overflowY: 'hidden',
            position: 'relative'
        },
        overFlowYHidden: {
            overflowY: 'hidden'
        }
    });
    var _a;
});
//# sourceMappingURL=PositioningContainer.styles.js.map

/***/ }),
/* 1866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BEAK_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BEAK_WIDTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Beak; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Beak_styles__ = __webpack_require__(1867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_positioning__ = __webpack_require__(151);





var BEAK_HEIGHT = 10;
var BEAK_WIDTH = 18;
var Beak = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](Beak, _super);
    function Beak(props) {
        return _super.call(this, props) || this;
    }
    Beak.prototype.render = function () {
        var _a = this.props, left = _a.left, top = _a.top, bottom = _a.bottom, right = _a.right, color = _a.color, _b = _a.direction, direction = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_4__utilities_positioning__["b" /* RectangleEdge */].top : _b;
        var svgHeight;
        var svgWidth;
        if (direction === __WEBPACK_IMPORTED_MODULE_4__utilities_positioning__["b" /* RectangleEdge */].top || direction === __WEBPACK_IMPORTED_MODULE_4__utilities_positioning__["b" /* RectangleEdge */].bottom) {
            svgHeight = BEAK_HEIGHT;
            svgWidth = BEAK_WIDTH;
        }
        else {
            svgHeight = BEAK_WIDTH;
            svgWidth = BEAK_HEIGHT;
        }
        var pointOne;
        var pointTwo;
        var pointThree;
        var transform;
        switch (direction) {
            case __WEBPACK_IMPORTED_MODULE_4__utilities_positioning__["b" /* RectangleEdge */].top:
            default:
                pointOne = BEAK_WIDTH / 2 + ", 0";
                pointTwo = BEAK_WIDTH + ", " + BEAK_HEIGHT;
                pointThree = "0, " + BEAK_HEIGHT;
                transform = 'translateY(-100%)';
                break;
            case __WEBPACK_IMPORTED_MODULE_4__utilities_positioning__["b" /* RectangleEdge */].right:
                pointOne = "0, 0";
                pointTwo = BEAK_HEIGHT + ", " + BEAK_HEIGHT;
                pointThree = "0, " + BEAK_WIDTH;
                transform = 'translateX(100%)';
                break;
            case __WEBPACK_IMPORTED_MODULE_4__utilities_positioning__["b" /* RectangleEdge */].bottom:
                pointOne = "0, 0";
                pointTwo = BEAK_WIDTH + ", 0";
                pointThree = BEAK_WIDTH / 2 + ", " + BEAK_HEIGHT;
                transform = 'translateY(100%)';
                break;
            case __WEBPACK_IMPORTED_MODULE_4__utilities_positioning__["b" /* RectangleEdge */].left:
                pointOne = BEAK_HEIGHT + ", 0";
                pointTwo = "0, " + BEAK_HEIGHT;
                pointThree = BEAK_HEIGHT + ", " + BEAK_WIDTH;
                transform = 'translateX(-100%)';
                break;
        }
        var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
        var classNames = getClassNames(__WEBPACK_IMPORTED_MODULE_3__Beak_styles__["a" /* getStyles */], {
            left: left,
            top: top,
            bottom: bottom,
            right: right,
            height: svgHeight + "px",
            width: svgWidth + "px",
            transform: transform,
            color: color
        });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.root, role: "presentation" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg", { height: svgHeight, width: svgWidth, className: classNames.beak },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("polygon", { points: pointOne + ' ' + pointTwo + ' ' + pointThree }))));
    };
    return Beak;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=Beak.js.map

/***/ }),
/* 1867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStyles;
function getStyles(props) {
    return {
        root: [
            {
                position: 'absolute',
                boxShadow: 'inherit',
                border: 'none',
                boxSizing: 'border-box',
                transform: props.transform,
                width: props.width,
                height: props.height,
                left: props.left,
                top: props.top,
                right: props.right,
                bottom: props.bottom
            }
        ],
        beak: {
            fill: props.color,
            display: 'block'
        }
    };
}
//# sourceMappingURL=Beak.styles.js.map

/***/ }),
/* 1868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_color_index__ = __webpack_require__(1869);
/* unused harmony namespace reexport */

//# sourceMappingURL=Color.js.map

/***/ }),
/* 1869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(1870);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shades__ = __webpack_require__(434);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__consts__ = __webpack_require__(37);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cssColor__ = __webpack_require__(424);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rgb2hex__ = __webpack_require__(154);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__clamp__ = __webpack_require__(155);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hsl2rgb__ = __webpack_require__(425);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__hsl2hsv__ = __webpack_require__(426);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hsv2rgb__ = __webpack_require__(120);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__hsv2hex__ = __webpack_require__(278);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__rgb2hsv__ = __webpack_require__(427);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__hsv2hsl__ = __webpack_require__(428);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__getColorFromString__ = __webpack_require__(121);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__getColorFromRGBA__ = __webpack_require__(156);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__getColorFromHSV__ = __webpack_require__(751);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__getFullColorString__ = __webpack_require__(429);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__updateSV__ = __webpack_require__(430);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__updateH__ = __webpack_require__(431);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__updateRGB__ = __webpack_require__(752);
/* unused harmony namespace reexport */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__updateA__ = __webpack_require__(432);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__correctRGB__ = __webpack_require__(433);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__correctHSV__ = __webpack_require__(753);
/* unused harmony namespace reexport */























//# sourceMappingURL=index.js.map

/***/ }),
/* 1870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__consts__ = __webpack_require__(37);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cssColor__ = __webpack_require__(424);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rgb2hex__ = __webpack_require__(154);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__clamp__ = __webpack_require__(155);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hsl2rgb__ = __webpack_require__(425);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hsl2hsv__ = __webpack_require__(426);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hsv2rgb__ = __webpack_require__(120);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__hsv2hex__ = __webpack_require__(278);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__rgb2hsv__ = __webpack_require__(427);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__hsv2hsl__ = __webpack_require__(428);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__getColorFromString__ = __webpack_require__(121);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__getColorFromRGBA__ = __webpack_require__(156);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__getColorFromHSV__ = __webpack_require__(751);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__getFullColorString__ = __webpack_require__(429);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__updateSV__ = __webpack_require__(430);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__updateH__ = __webpack_require__(431);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__updateRGB__ = __webpack_require__(752);
/* unused harmony namespace reexport */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__updateA__ = __webpack_require__(432);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__correctRGB__ = __webpack_require__(433);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__correctHSV__ = __webpack_require__(753);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__correctHex__ = __webpack_require__(754);
/* unused harmony namespace reexport */






















//# sourceMappingURL=colors.js.map

/***/ }),
/* 1871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ColorPicker_index__ = __webpack_require__(1872);
/* unused harmony namespace reexport */

//# sourceMappingURL=ColorPicker.js.map

/***/ }),
/* 1872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ColorPicker__ = __webpack_require__(1873);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ColorPicker_base__ = __webpack_require__(755);
/* unused harmony namespace reexport */


//# sourceMappingURL=index.js.map

/***/ }),
/* 1873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ColorPicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ColorPicker_base__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ColorPicker_styles__ = __webpack_require__(1880);



var ColorPicker = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__ColorPicker_base__["a" /* ColorPickerBase */], __WEBPACK_IMPORTED_MODULE_2__ColorPicker_styles__["a" /* getStyles */], undefined, { scope: 'ColorPicker' });
//# sourceMappingURL=ColorPicker.js.map

/***/ }),
/* 1874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ColorRectangle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ColorRectangle_base__ = __webpack_require__(1875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ColorRectangle_styles__ = __webpack_require__(1876);



var ColorRectangle = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__ColorRectangle_base__["a" /* ColorRectangleBase */], __WEBPACK_IMPORTED_MODULE_2__ColorRectangle_styles__["a" /* getStyles */], undefined, { scope: 'ColorRectangle' });
//# sourceMappingURL=ColorRectangle.js.map

/***/ }),
/* 1875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ColorRectangleBase; });
/* unused harmony export _getNewColor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_color_consts__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_color_getFullColorString__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_color_updateSV__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_color_clamp__ = __webpack_require__(155);







var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
/**
 * {@docCategory ColorPicker}
 */
var ColorRectangleBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ColorRectangleBase, _super);
    function ColorRectangleBase(props) {
        var _this = _super.call(this, props) || this;
        _this._root = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._onMouseDown = function (ev) {
            _this._events.on(window, 'mousemove', _this._onMouseMove, true);
            _this._events.on(window, 'mouseup', _this._disableEvents, true);
            _this._onMouseMove(ev);
        };
        _this._onMouseMove = function (ev) {
            var _a = _this.props, color = _a.color, onSVChanged = _a.onSVChanged, onChange = _a.onChange;
            if (!_this._root.current) {
                return;
            }
            // If the primary button (1) isn't pressed, the user is no longer dragging, so turn off the
            // event handlers and exit. (this may only be relevant while debugging)
            // tslint:disable-next-line:no-bitwise
            if (!(ev.buttons & 1)) {
                _this._disableEvents();
                return;
            }
            var newColor = _getNewColor(ev, color, _this._root.current);
            if (newColor) {
                _this.setState({
                    color: newColor
                });
                if (onChange) {
                    onChange(ev, newColor);
                }
                if (onSVChanged) {
                    onSVChanged(newColor.s, newColor.v);
                }
            }
            ev.preventDefault();
            ev.stopPropagation();
        };
        _this._disableEvents = function () {
            _this._events.off();
        };
        Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_5" /* initializeComponentRef */])(_this);
        _this._events = new __WEBPACK_IMPORTED_MODULE_2__Utilities__["e" /* EventGroup */](_this);
        Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_35" /* warnDeprecations */])('ColorRectangle', props, {
            onSVChanged: 'onChange'
        });
        var color = _this.props.color;
        _this.state = {
            color: color
        };
        return _this;
    }
    Object.defineProperty(ColorRectangleBase.prototype, "color", {
        get: function () {
            return this.state.color;
        },
        enumerable: true,
        configurable: true
    });
    ColorRectangleBase.prototype.componentWillReceiveProps = function (newProps) {
        var color = newProps.color;
        this.setState({
            color: color
        });
    };
    ColorRectangleBase.prototype.componentWillUnmount = function () {
        this._events.dispose();
    };
    ColorRectangleBase.prototype.render = function () {
        var _a = this.props, minSize = _a.minSize, theme = _a.theme, className = _a.className, styles = _a.styles;
        var color = this.state.color;
        var classNames = getClassNames(styles, {
            theme: theme,
            className: className
        });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: this._root, className: classNames.root, style: { minWidth: minSize, minHeight: minSize, backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_4__utilities_color_getFullColorString__["a" /* getFullColorString */])(color) }, onMouseDown: this._onMouseDown },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.light }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.dark }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.thumb, style: { left: color.s + '%', top: __WEBPACK_IMPORTED_MODULE_3__utilities_color_consts__["g" /* MAX_COLOR_VALUE */] - color.v + '%', backgroundColor: color.str } })));
    };
    ColorRectangleBase.defaultProps = {
        minSize: 220
    };
    return ColorRectangleBase;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

/**
 * Exported for testing only.
 * @internal
 */
function _getNewColor(ev, prevColor, root) {
    var rectSize = root.getBoundingClientRect();
    var sPercentage = (ev.clientX - rectSize.left) / rectSize.width;
    var vPercentage = (ev.clientY - rectSize.top) / rectSize.height;
    return Object(__WEBPACK_IMPORTED_MODULE_5__utilities_color_updateSV__["a" /* updateSV */])(prevColor, Object(__WEBPACK_IMPORTED_MODULE_6__utilities_color_clamp__["a" /* clamp */])(sPercentage * __WEBPACK_IMPORTED_MODULE_3__utilities_color_consts__["f" /* MAX_COLOR_SATURATION */], __WEBPACK_IMPORTED_MODULE_3__utilities_color_consts__["f" /* MAX_COLOR_SATURATION */]), Object(__WEBPACK_IMPORTED_MODULE_6__utilities_color_clamp__["a" /* clamp */])(__WEBPACK_IMPORTED_MODULE_3__utilities_color_consts__["g" /* MAX_COLOR_VALUE */] - vPercentage * __WEBPACK_IMPORTED_MODULE_3__utilities_color_consts__["g" /* MAX_COLOR_VALUE */], __WEBPACK_IMPORTED_MODULE_3__utilities_color_consts__["g" /* MAX_COLOR_VALUE */]));
}
//# sourceMappingURL=ColorRectangle.base.js.map

/***/ }),
/* 1876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var getStyles = function (props) {
    var className = props.className;
    return {
        root: [
            'ms-ColorPicker-colorRect',
            {
                position: 'relative',
                marginBottom: 10,
                selectors: (_a = {},
                    _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        MsHighContrastAdjust: 'none'
                    },
                    _a)
            },
            className
        ],
        light: [
            'ms-ColorPicker-light',
            {
                position: 'absolute',
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                background: 'linear-gradient(to right, white 0%, transparent 100%)'
            }
        ],
        dark: [
            'ms-ColorPicker-dark',
            {
                position: 'absolute',
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                background: 'linear-gradient(to bottom, transparent 0, #000 100%)'
            }
        ],
        thumb: [
            'ms-ColorPicker-thumb',
            {
                position: 'absolute',
                width: 20,
                height: 20,
                background: 'white',
                border: '1px solid rgba(255,255,255,.8)',
                borderRadius: '50%',
                boxShadow: '0 0 15px -5px black',
                transform: 'translate(-50%, -50%)'
            }
        ]
    };
    var _a;
};
//# sourceMappingURL=ColorRectangle.styles.js.map

/***/ }),
/* 1877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ColorSlider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ColorSlider_base__ = __webpack_require__(1878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ColorSlider_styles__ = __webpack_require__(1879);



var ColorSlider = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__ColorSlider_base__["a" /* ColorSliderBase */], __WEBPACK_IMPORTED_MODULE_2__ColorSlider_styles__["a" /* getStyles */], undefined, { scope: 'ColorSlider' });
//# sourceMappingURL=ColorSlider.js.map

/***/ }),
/* 1878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ColorSliderBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);



var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
/**
 * {@docCategory ColorPicker}
 */
var ColorSliderBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ColorSliderBase, _super);
    function ColorSliderBase(props) {
        var _this = _super.call(this, props) || this;
        _this._root = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._onMouseDown = function (ev) {
            _this._events.on(window, 'mousemove', _this._onMouseMove, true);
            _this._events.on(window, 'mouseup', _this._onMouseUp, true);
            _this._onMouseMove(ev);
        };
        _this._onMouseMove = function (ev) {
            if (!_this._root.current) {
                return;
            }
            var _a = _this.props, onChange = _a.onChange, onChanged = _a.onChanged, minValue = _a.minValue, maxValue = _a.maxValue;
            var rectSize = _this._root.current.getBoundingClientRect();
            var currentPercentage = (ev.clientX - rectSize.left) / rectSize.width;
            var newValue = Math.min(maxValue, Math.max(minValue, currentPercentage * maxValue));
            _this.setState({
                currentValue: newValue
            });
            if (onChange) {
                onChange(ev, newValue);
            }
            if (onChanged) {
                onChanged(newValue);
            }
            ev.preventDefault();
            ev.stopPropagation();
        };
        _this._onMouseUp = function (ev) {
            _this._events.off();
        };
        Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_5" /* initializeComponentRef */])(_this);
        _this._events = new __WEBPACK_IMPORTED_MODULE_2__Utilities__["e" /* EventGroup */](_this);
        Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_35" /* warnDeprecations */])('ColorSlider', props, {
            onChanged: 'onChange'
        });
        var value = _this.props.value;
        _this.state = {
            currentValue: value
        };
        return _this;
    }
    ColorSliderBase.prototype.componentWillReceiveProps = function (newProps) {
        if (newProps && newProps.value) {
            this.setState({ currentValue: newProps.value });
        }
    };
    ColorSliderBase.prototype.componentWillUnmount = function () {
        this._events.dispose();
    };
    ColorSliderBase.prototype.render = function () {
        var _a = this.props, isAlpha = _a.isAlpha, minValue = _a.minValue, maxValue = _a.maxValue, overlayStyle = _a.overlayStyle, theme = _a.theme, className = _a.className, styles = _a.styles;
        var currentValue = this.state.currentValue;
        var classNames = getClassNames(styles, {
            theme: theme,
            className: className
        });
        var currentPercentage = (100 * (currentValue - minValue)) / (maxValue - minValue);
        var hueStyle = {
            background: 
            // tslint:disable-next-line:max-line-length
            'linear-gradient(to left,red 0,#f09 10%,#cd00ff 20%,#3200ff 30%,#06f 40%,#00fffd 50%,#0f6 60%,#35ff00 70%,#cdff00 80%,#f90 90%,red 100%)'
        };
        var alphaStyle = {
            backgroundImage: 
            // tslint:disable-next-line:max-line-length
            'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAJUlEQVQYV2N89erVfwY0ICYmxoguxjgUFKI7GsTH5m4M3w1ChQC1/Ca8i2n1WgAAAABJRU5ErkJggg==)'
        };
        var sliderStyle = isAlpha ? alphaStyle : hueStyle;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: this._root, className: classNames.root, onMouseDown: this._onMouseDown, style: sliderStyle },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.sliderOverlay, style: overlayStyle }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.sliderThumb, style: { left: currentPercentage + '%' } })));
    };
    ColorSliderBase.defaultProps = {
        minValue: 0,
        maxValue: 100,
        thumbColor: 'inherit',
        value: 0
    };
    return ColorSliderBase;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=ColorSlider.base.js.map

/***/ }),
/* 1879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
var getStyles = function (props) {
    var theme = props.theme, className = props.className;
    var palette = theme.palette;
    return {
        root: [
            'ms-ColorPicker-slider',
            {
                position: 'relative',
                height: 20,
                marginBottom: 5,
                border: "1px solid " + palette.neutralLight,
                boxSizing: 'border-box'
            },
            className
        ],
        sliderOverlay: [
            'ms-ColorPicker-sliderOverlay',
            {
                content: '',
                position: 'absolute',
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            }
        ],
        sliderThumb: [
            'ms-ColorPicker-thumb',
            'is-slider',
            {
                position: 'absolute',
                width: 20,
                height: 20,
                background: 'white',
                border: '1px solid rgba(255,255,255,.8)',
                borderRadius: '50%',
                boxShadow: '0 0 15px -5px black',
                transform: 'translate(-50%, -50%)',
                top: '50%'
            }
        ]
    };
};
//# sourceMappingURL=ColorSlider.styles.js.map

/***/ }),
/* 1880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);

var getStyles = function (props) {
    var className = props.className, theme = props.theme;
    return {
        root: [
            'ms-ColorPicker',
            theme.fonts.medium,
            {
                position: 'relative',
                maxWidth: 300
            },
            className
        ],
        panel: [
            'ms-ColorPicker-panel',
            {
                padding: '16px'
            }
        ],
        table: [
            'ms-ColorPicker-table',
            {
                tableLayout: 'fixed',
                width: '100%'
            }
        ],
        tableHeader: [
            __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, theme.fonts.small)
        ],
        tableHexCell: [
            {
                width: '25%'
            }
        ],
        input: [
            'ms-ColorPicker-input',
            {
                width: '100%',
                border: 'none',
                boxSizing: 'border-box',
                height: 30,
                selectors: {
                    '&.ms-TextField': {
                        paddingRight: 2
                    },
                    '& .ms-TextField-field': {
                        minWidth: 'auto',
                        padding: 5,
                        textOverflow: 'clip'
                    }
                }
            }
        ]
    };
};
//# sourceMappingURL=ColorPicker.styles.js.map

/***/ }),
/* 1881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CommandBar__ = __webpack_require__(1882);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CommandBar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CommandBar_base__ = __webpack_require__(756);
/* unused harmony namespace reexport */


//# sourceMappingURL=index.js.map

/***/ }),
/* 1882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CommandBar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CommandBar_base__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CommandBar_styles__ = __webpack_require__(1886);



// Create a CommandBar variant which uses these default styles and this styled subcomponent.
var CommandBar = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__CommandBar_base__["a" /* CommandBarBase */], __WEBPACK_IMPORTED_MODULE_2__CommandBar_styles__["a" /* getStyles */], undefined, {
    scope: 'CommandBar'
});
//# sourceMappingURL=CommandBar.js.map

/***/ }),
/* 1883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OverflowSet__ = __webpack_require__(1884);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__OverflowSet__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OverflowSet_base__ = __webpack_require__(758);
/* unused harmony namespace reexport */


//# sourceMappingURL=index.js.map

/***/ }),
/* 1884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OverflowSet; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OverflowSet_base__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OverflowSet_styles__ = __webpack_require__(1885);



var OverflowSet = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__OverflowSet_base__["a" /* OverflowSetBase */], __WEBPACK_IMPORTED_MODULE_2__OverflowSet_styles__["a" /* getStyles */], undefined, {
    scope: 'OverflowSet'
});
//# sourceMappingURL=OverflowSet.js.map

/***/ }),
/* 1885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
var overflowItemStyle = {
    flexShrink: 0,
    display: 'inherit'
};
var getStyles = function (props) {
    var className = props.className, vertical = props.vertical;
    return {
        root: [
            'ms-OverflowSet',
            {
                position: 'relative',
                display: 'flex',
                flexWrap: 'nowrap'
            },
            vertical && { flexDirection: 'column' },
            className
        ],
        item: ['ms-OverflowSet-item', overflowItemStyle],
        overflowButton: ['ms-OverflowSet-overflowButton', overflowItemStyle]
    };
};
//# sourceMappingURL=OverflowSet.styles.js.map

/***/ }),
/* 1886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
var getStyles = function (props) {
    var className = props.className, theme = props.theme;
    var palette = theme.palette;
    return {
        root: [
            theme.fonts.medium,
            'ms-CommandBar',
            {
                display: 'flex',
                backgroundColor: palette.neutralLighter,
                padding: '0 16px',
                height: '40px'
            },
            className
        ],
        primarySet: [
            'ms-CommandBar-primaryCommand',
            {
                flexGrow: '1',
                display: 'flex',
                alignItems: 'stretch'
            }
        ],
        secondarySet: [
            'ms-CommandBar-secondaryCommand',
            {
                flexShrink: '0',
                display: 'flex',
                alignItems: 'stretch'
            }
        ]
    };
};
//# sourceMappingURL=CommandBar.styles.js.map

/***/ }),
/* 1887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DocumentCard_index__ = __webpack_require__(1888);
/* unused harmony namespace reexport */

//# sourceMappingURL=DocumentCard.js.map

/***/ }),
/* 1888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DocumentCard__ = __webpack_require__(1889);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DocumentCard_types__ = __webpack_require__(759);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DocumentCardActions__ = __webpack_require__(1892);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DocumentCardActivity__ = __webpack_require__(1895);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DocumentCardDetails__ = __webpack_require__(1897);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DocumentCardLocation__ = __webpack_require__(1900);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DocumentCardPreview__ = __webpack_require__(1902);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DocumentCardImage__ = __webpack_require__(1904);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DocumentCardTitle__ = __webpack_require__(1907);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DocumentCardLogo__ = __webpack_require__(1909);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DocumentCardStatus__ = __webpack_require__(1912);
/* unused harmony namespace reexport */











//# sourceMappingURL=index.js.map

/***/ }),
/* 1889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DocumentCard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DocumentCard_base__ = __webpack_require__(1890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DocumentCard_styles__ = __webpack_require__(1891);



var DocumentCard = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__DocumentCard_base__["a" /* DocumentCardBase */], __WEBPACK_IMPORTED_MODULE_2__DocumentCard_styles__["a" /* getStyles */], undefined, { scope: 'DocumentCard' });
//# sourceMappingURL=DocumentCard.js.map

/***/ }),
/* 1890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DocumentCardBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DocumentCard_types__ = __webpack_require__(759);




var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
/**
 * {@docCategory DocumentCard}
 */
var DocumentCardBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](DocumentCardBase, _super);
    function DocumentCardBase(props) {
        var _this = _super.call(this, props) || this;
        _this._rootElement = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._onClick = function (ev) {
            _this._onAction(ev);
        };
        _this._onKeyDown = function (ev) {
            if (ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].enter || ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].space) {
                _this._onAction(ev);
            }
        };
        _this._onAction = function (ev) {
            var _a = _this.props, onClick = _a.onClick, onClickHref = _a.onClickHref;
            if (onClick) {
                onClick(ev);
            }
            else if (!onClick && onClickHref) {
                // If no onClick Function was provided and we do have an onClickHref, redirect to the onClickHref
                window.location.href = onClickHref;
                ev.preventDefault();
                ev.stopPropagation();
            }
        };
        _this._warnDeprecations({
            accentColor: undefined
        });
        return _this;
    }
    DocumentCardBase.prototype.render = function () {
        var _a = this.props, onClick = _a.onClick, onClickHref = _a.onClickHref, children = _a.children, type = _a.type, accentColor = _a.accentColor, styles = _a.styles, theme = _a.theme, className = _a.className;
        var nativeProps = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["R" /* getNativeProps */])(this.props, __WEBPACK_IMPORTED_MODULE_2__Utilities__["w" /* divProperties */], ['className', 'onClick', 'type', 'role']);
        var actionable = onClick || onClickHref ? true : false;
        this._classNames = getClassNames(styles, {
            theme: theme,
            className: className,
            actionable: actionable,
            compact: type === __WEBPACK_IMPORTED_MODULE_3__DocumentCard_types__["a" /* DocumentCardType */].compact ? true : false
        });
        // Override the border color if an accent color was provided (compact card only)
        var style;
        if (type === __WEBPACK_IMPORTED_MODULE_3__DocumentCard_types__["a" /* DocumentCardType */].compact && accentColor) {
            style = {
                borderBottomColor: accentColor
            };
        }
        // if this element is actionable it should have an aria role
        var role = this.props.role || (actionable ? (onClick ? 'button' : 'link') : undefined);
        var tabIndex = actionable ? 0 : undefined;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ ref: this._rootElement, tabIndex: tabIndex, "data-is-focusable": actionable, role: role, className: this._classNames.root, onKeyDown: actionable ? this._onKeyDown : undefined, onClick: actionable ? this._onClick : undefined, style: style }, nativeProps), children));
    };
    DocumentCardBase.prototype.focus = function () {
        if (this._rootElement.current) {
            this._rootElement.current.focus();
        }
    };
    DocumentCardBase.defaultProps = {
        type: __WEBPACK_IMPORTED_MODULE_3__DocumentCard_types__["a" /* DocumentCardType */].normal
    };
    return DocumentCardBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=DocumentCard.base.js.map

/***/ }),
/* 1891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DocumentCardPreview_styles__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DocumentCardActivity_styles__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DocumentCardTitle_styles__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DocumentCardLocation_styles__ = __webpack_require__(763);





var GlobalClassNames = {
    root: 'ms-DocumentCard',
    rootActionable: 'ms-DocumentCard--actionable',
    rootCompact: 'ms-DocumentCard--compact'
};
var getStyles = function (props) {
    var className = props.className, theme = props.theme, actionable = props.actionable, compact = props.compact;
    var palette = theme.palette;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            {
                WebkitFontSmoothing: 'antialiased',
                backgroundColor: palette.white,
                border: "1px solid " + palette.neutralLight,
                boxSizing: 'border-box',
                maxWidth: '320px',
                minWidth: '206px',
                userSelect: 'none',
                position: 'relative',
                selectors: (_a = {},
                    _a["." + __WEBPACK_IMPORTED_MODULE_4__DocumentCardLocation_styles__["a" /* DocumentCardLocationGlobalClassNames */].root + " + ." + __WEBPACK_IMPORTED_MODULE_3__DocumentCardTitle_styles__["a" /* DocumentCardTitleGlobalClassNames */].root] = {
                        paddingTop: '4px'
                    },
                    _a)
            },
            actionable && [
                classNames.rootActionable,
                {
                    selectors: {
                        ':hover': {
                            cursor: 'pointer',
                            borderColor: palette.neutralTertiaryAlt
                        },
                        ':hover:after': {
                            content: '" "',
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0,
                            border: "1px solid " + palette.neutralTertiaryAlt,
                            pointerEvents: 'none'
                        }
                    }
                }
            ],
            compact && [
                classNames.rootCompact,
                {
                    display: 'flex',
                    maxWidth: '480px',
                    height: '108px',
                    selectors: (_b = {},
                        _b["." + __WEBPACK_IMPORTED_MODULE_1__DocumentCardPreview_styles__["a" /* DocumentCardPreviewGlobalClassNames */].root] = {
                            borderRight: "1px solid " + palette.neutralLight,
                            borderBottom: 0,
                            maxHeight: '106px',
                            maxWidth: '144px'
                        },
                        _b["." + __WEBPACK_IMPORTED_MODULE_1__DocumentCardPreview_styles__["a" /* DocumentCardPreviewGlobalClassNames */].icon] = {
                            maxHeight: '32px',
                            maxWidth: '32px'
                        },
                        _b["." + __WEBPACK_IMPORTED_MODULE_2__DocumentCardActivity_styles__["a" /* DocumentCardActivityGlobalClassNames */].root] = {
                            paddingBottom: '12px'
                        },
                        _b["." + __WEBPACK_IMPORTED_MODULE_3__DocumentCardTitle_styles__["a" /* DocumentCardTitleGlobalClassNames */].root] = {
                            paddingBottom: '12px 16px 8px 16px',
                            fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].mediumPlus,
                            lineHeight: '16px'
                        },
                        _b)
                }
            ],
            className
        ]
    };
    var _a, _b;
};
//# sourceMappingURL=DocumentCard.styles.js.map

/***/ }),
/* 1892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DocumentCardActions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DocumentCardActions_base__ = __webpack_require__(1893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DocumentCardActions_styles__ = __webpack_require__(1894);



var DocumentCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__DocumentCardActions_base__["a" /* DocumentCardActionsBase */], __WEBPACK_IMPORTED_MODULE_2__DocumentCardActions_styles__["a" /* getStyles */], undefined, { scope: 'DocumentCardActions' });
//# sourceMappingURL=DocumentCardActions.js.map

/***/ }),
/* 1893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DocumentCardActionsBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icon__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Button__ = __webpack_require__(10);





var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
/**
 * {@docCategory DocumentCard}
 */
var DocumentCardActionsBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](DocumentCardActionsBase, _super);
    function DocumentCardActionsBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DocumentCardActionsBase.prototype.render = function () {
        var _this = this;
        var _a = this.props, actions = _a.actions, views = _a.views, styles = _a.styles, theme = _a.theme, className = _a.className;
        this._classNames = getClassNames(styles, {
            theme: theme,
            className: className
        });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.root },
            actions &&
                actions.map(function (action, index) {
                    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: _this._classNames.action, key: index },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Button__["g" /* IconButton */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, action))));
                }),
            views > 0 && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.views },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Icon__["Icon"], { iconName: "View", className: this._classNames.viewsIcon }),
                views))));
    };
    return DocumentCardActionsBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=DocumentCardActions.base.js.map

/***/ }),
/* 1894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var ACTION_SIZE = 34;
var HORIZONTAL_PADDING = 12;
var VERTICAL_PADDING = 4;
var GlobalClassNames = {
    root: 'ms-DocumentCardActions',
    action: 'ms-DocumentCardActions-action',
    views: 'ms-DocumentCardActions-views'
};
var getStyles = function (props) {
    var className = props.className, theme = props.theme;
    var palette = theme.palette;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            {
                height: ACTION_SIZE + "px",
                padding: VERTICAL_PADDING + "px " + HORIZONTAL_PADDING + "px",
                position: 'relative'
            },
            className
        ],
        action: [
            classNames.action,
            {
                float: 'left',
                marginRight: '4px',
                color: palette.neutralSecondary,
                cursor: 'pointer',
                selectors: {
                    '.ms-Button': {
                        fontSize: '16px',
                        height: ACTION_SIZE,
                        width: ACTION_SIZE
                    },
                    '.ms-Button:hover .ms-Button-icon': {
                        color: theme.semanticColors.buttonText,
                        cursor: 'pointer'
                    }
                }
            }
        ],
        views: [
            classNames.views,
            {
                textAlign: 'right',
                lineHeight: ACTION_SIZE
            }
        ],
        viewsIcon: {
            marginRight: '8px',
            fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].medium,
            verticalAlign: 'top'
        }
    };
};
//# sourceMappingURL=DocumentCardActions.styles.js.map

/***/ }),
/* 1895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DocumentCardActivity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DocumentCardActivity_base__ = __webpack_require__(1896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DocumentCardActivity_styles__ = __webpack_require__(761);



var DocumentCardActivity = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__DocumentCardActivity_base__["a" /* DocumentCardActivityBase */], __WEBPACK_IMPORTED_MODULE_2__DocumentCardActivity_styles__["b" /* getStyles */], undefined, { scope: 'DocumentCardActivity' });
//# sourceMappingURL=DocumentCardActivity.js.map

/***/ }),
/* 1896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DocumentCardActivityBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Persona__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PersonaCoin__ = __webpack_require__(435);





var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
/**
 * {@docCategory DocumentCard}
 */
var DocumentCardActivityBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](DocumentCardActivityBase, _super);
    function DocumentCardActivityBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DocumentCardActivityBase.prototype.render = function () {
        var _a = this.props, activity = _a.activity, people = _a.people, styles = _a.styles, theme = _a.theme, className = _a.className;
        this._classNames = getClassNames(styles, {
            theme: theme,
            className: className,
            multiplePeople: people.length > 1
        });
        if (!people || people.length === 0) {
            return null;
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.root },
            this._renderAvatars(people),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.details },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: this._classNames.name }, this._getNameString(people)),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: this._classNames.activity }, activity))));
    };
    DocumentCardActivityBase.prototype._renderAvatars = function (people) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.avatars },
            people.length > 1 ? this._renderAvatar(people[1]) : null,
            this._renderAvatar(people[0])));
    };
    DocumentCardActivityBase.prototype._renderAvatar = function (person) {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.avatar },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__PersonaCoin__["a" /* PersonaCoin */], { imageInitials: person.initials, text: person.name, imageUrl: person.profileImageSrc, initialsColor: person.initialsColor, allowPhoneInitials: person.allowPhoneInitials, role: "presentation", size: __WEBPACK_IMPORTED_MODULE_3__Persona__["d" /* PersonaSize */].size32 })));
    };
    DocumentCardActivityBase.prototype._getNameString = function (people) {
        var nameString = people[0].name;
        if (people.length >= 2) {
            nameString += ' +' + (people.length - 1);
        }
        return nameString;
    };
    return DocumentCardActivityBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=DocumentCardActivity.base.js.map

/***/ }),
/* 1897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DocumentCardDetails */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DocumentCardDetails_base__ = __webpack_require__(1898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DocumentCardDetails_styles__ = __webpack_require__(1899);



var DocumentCardDetails = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__DocumentCardDetails_base__["a" /* DocumentCardDetailsBase */], __WEBPACK_IMPORTED_MODULE_2__DocumentCardDetails_styles__["a" /* getStyles */], undefined, { scope: 'DocumentCardDetails' });
//# sourceMappingURL=DocumentCardDetails.js.map

/***/ }),
/* 1898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DocumentCardDetailsBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);



var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
/**
 * {@docCategory DocumentCard}
 */
var DocumentCardDetailsBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](DocumentCardDetailsBase, _super);
    function DocumentCardDetailsBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DocumentCardDetailsBase.prototype.render = function () {
        var _a = this.props, children = _a.children, styles = _a.styles, theme = _a.theme, className = _a.className;
        this._classNames = getClassNames(styles, {
            theme: theme,
            className: className
        });
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.root }, children);
    };
    return DocumentCardDetailsBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=DocumentCardDetails.base.js.map

/***/ }),
/* 1899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var GlobalClassNames = {
    root: 'ms-DocumentCardDetails'
};
var getStyles = function (props) {
    var className = props.className, theme = props.theme;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            {
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                justifyContent: 'space-between',
                overflow: 'hidden'
            },
            className
        ]
    };
};
//# sourceMappingURL=DocumentCardDetails.styles.js.map

/***/ }),
/* 1900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DocumentCardLocation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DocumentCardLocation_base__ = __webpack_require__(1901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DocumentCardLocation_styles__ = __webpack_require__(763);



var DocumentCardLocation = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__DocumentCardLocation_base__["a" /* DocumentCardLocationBase */], __WEBPACK_IMPORTED_MODULE_2__DocumentCardLocation_styles__["b" /* getStyles */], undefined, { scope: 'DocumentCardLocation' });
//# sourceMappingURL=DocumentCardLocation.js.map

/***/ }),
/* 1901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DocumentCardLocationBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);



var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
/**
 * {@docCategory DocumentCard}
 */
var DocumentCardLocationBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](DocumentCardLocationBase, _super);
    function DocumentCardLocationBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DocumentCardLocationBase.prototype.render = function () {
        var _a = this.props, location = _a.location, locationHref = _a.locationHref, ariaLabel = _a.ariaLabel, onClick = _a.onClick, styles = _a.styles, theme = _a.theme, className = _a.className;
        this._classNames = getClassNames(styles, {
            theme: theme,
            className: className
        });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { className: this._classNames.root, href: locationHref, onClick: onClick, "aria-label": ariaLabel }, location));
    };
    return DocumentCardLocationBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=DocumentCardLocation.base.js.map

/***/ }),
/* 1902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DocumentCardPreview */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DocumentCardPreview_base__ = __webpack_require__(1903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DocumentCardPreview_styles__ = __webpack_require__(760);



var DocumentCardPreview = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__DocumentCardPreview_base__["a" /* DocumentCardPreviewBase */], __WEBPACK_IMPORTED_MODULE_2__DocumentCardPreview_styles__["b" /* getStyles */], undefined, { scope: 'DocumentCardPreview' });
//# sourceMappingURL=DocumentCardPreview.js.map

/***/ }),
/* 1903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DocumentCardPreviewBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Icon__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Image__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Link__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Utilities__ = __webpack_require__(1);






var LIST_ITEM_COUNT = 3;
var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["r" /* classNamesFunction */])();
/**
 * {@docCategory DocumentCard}
 */
var DocumentCardPreviewBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](DocumentCardPreviewBase, _super);
    function DocumentCardPreviewBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._renderPreviewList = function (previewImages) {
            var getOverflowDocumentCountText = _this.props.getOverflowDocumentCountText;
            // Determine how many documents we won't be showing
            var overflowDocumentCount = previewImages.length - LIST_ITEM_COUNT;
            // Determine the overflow text that will be rendered after the preview list.
            var overflowText = overflowDocumentCount
                ? getOverflowDocumentCountText
                    ? getOverflowDocumentCountText(overflowDocumentCount)
                    : '+' + overflowDocumentCount
                : null;
            // Create list items for the documents to be shown
            var fileListItems = previewImages.slice(0, LIST_ITEM_COUNT).map(function (file, fileIndex) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("li", { key: fileIndex },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Image__["a" /* Image */], { className: _this._classNames.fileListIcon, src: file.iconSrc, role: "presentation", alt: "", width: "16px", height: "16px" }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Link__["Link"], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, (file.linkProps, { href: file.url || (file.linkProps && file.linkProps.href) })), file.name))); });
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("ul", { className: _this._classNames.fileList }, fileListItems),
                overflowText && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: _this._classNames.fileListOverflowText }, overflowText)));
        };
        return _this;
    }
    DocumentCardPreviewBase.prototype.render = function () {
        var _a = this.props, previewImages = _a.previewImages, styles = _a.styles, theme = _a.theme, className = _a.className;
        var style, preview;
        var isFileList = previewImages.length > 1;
        this._classNames = getClassNames(styles, {
            theme: theme,
            className: className,
            isFileList: isFileList
        });
        if (previewImages.length > 1) {
            // Render a list of files
            preview = this._renderPreviewList(previewImages);
        }
        else if (previewImages.length === 1) {
            // Render a single preview
            preview = this._renderPreviewImage(previewImages[0]);
            // Override the border color if an accent color was provided
            if (previewImages[0].accentColor) {
                style = {
                    borderBottomColor: previewImages[0].accentColor
                };
            }
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.root, style: style }, preview));
    };
    DocumentCardPreviewBase.prototype._renderPreviewImage = function (previewImage) {
        var width = previewImage.width, height = previewImage.height, imageFit = previewImage.imageFit, previewIconProps = previewImage.previewIconProps, previewIconContainerClass = previewImage.previewIconContainerClass;
        if (previewIconProps) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["t" /* css */])(this._classNames.previewIcon, previewIconContainerClass), style: { width: width, height: height } },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Icon__["Icon"], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, previewIconProps))));
        }
        var image = __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Image__["a" /* Image */], { width: width, height: height, imageFit: imageFit, src: previewImage.previewImageSrc, role: "presentation", alt: "" });
        var icon;
        if (previewImage.iconSrc) {
            icon = __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Image__["a" /* Image */], { className: this._classNames.icon, src: previewImage.iconSrc, role: "presentation", alt: "" });
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
            image,
            icon));
    };
    return DocumentCardPreviewBase;
}(__WEBPACK_IMPORTED_MODULE_5__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=DocumentCardPreview.base.js.map

/***/ }),
/* 1904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DocumentCardImage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DocumentCardImage_base__ = __webpack_require__(1905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DocumentCardImage_styles__ = __webpack_require__(1906);



var DocumentCardImage = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__DocumentCardImage_base__["a" /* DocumentCardImageBase */], __WEBPACK_IMPORTED_MODULE_2__DocumentCardImage_styles__["a" /* getStyles */], undefined, { scope: 'DocumentCardImage' });
//# sourceMappingURL=DocumentCardImage.js.map

/***/ }),
/* 1905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DocumentCardImageBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Icon__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Image__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utilities__ = __webpack_require__(1);





var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_4__Utilities__["r" /* classNamesFunction */])();
/**
 * {@docCategory DocumentCard}
 */
var DocumentCardImageBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](DocumentCardImageBase, _super);
    function DocumentCardImageBase(props) {
        var _this = _super.call(this, props) || this;
        _this._onImageLoad = function () {
            _this.setState({ imageHasLoaded: true });
        };
        _this.state = { imageHasLoaded: false };
        return _this;
    }
    DocumentCardImageBase.prototype.render = function () {
        var _a = this.props, styles = _a.styles, width = _a.width, height = _a.height, imageFit = _a.imageFit, imageSrc = _a.imageSrc;
        this._classNames = getClassNames(styles, this.props);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.root },
            imageSrc && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Image__["a" /* Image */], { width: width, height: height, imageFit: imageFit, src: imageSrc, role: "presentation", alt: "", onLoad: this._onImageLoad })),
            this.state.imageHasLoaded ? this._renderCornerIcon() : this._renderCenterIcon()));
    };
    DocumentCardImageBase.prototype._renderCenterIcon = function () {
        var iconProps = this.props.iconProps;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.centeredIconWrapper },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Icon__["Icon"], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ className: this._classNames.centeredIcon }, iconProps))));
    };
    DocumentCardImageBase.prototype._renderCornerIcon = function () {
        var iconProps = this.props.iconProps;
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Icon__["Icon"], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ className: this._classNames.cornerIcon }, iconProps));
    };
    return DocumentCardImageBase;
}(__WEBPACK_IMPORTED_MODULE_4__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=DocumentCardImage.base.js.map

/***/ }),
/* 1906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
var centeredIconSize = '42px';
var cornerIconSize = '32px';
var getStyles = function (props) {
    var theme = props.theme, className = props.className, height = props.height, width = props.width;
    var palette = theme.palette;
    return {
        root: [
            {
                borderBottom: "1px solid " + palette.neutralLight,
                position: 'relative',
                backgroundColor: palette.neutralLighterAlt,
                overflow: "hidden",
                height: height && height + "px",
                width: width && width + "px"
            },
            className
        ],
        centeredIcon: [
            {
                height: centeredIconSize,
                width: centeredIconSize,
                fontSize: centeredIconSize
            }
        ],
        centeredIconWrapper: [
            {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                width: '100%',
                position: 'absolute',
                top: 0,
                left: 0
            }
        ],
        cornerIcon: [
            {
                left: '10px',
                bottom: '10px',
                height: cornerIconSize,
                width: cornerIconSize,
                fontSize: cornerIconSize,
                position: 'absolute',
                overflow: 'visible'
            }
        ]
    };
};
//# sourceMappingURL=DocumentCardImage.styles.js.map

/***/ }),
/* 1907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DocumentCardTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DocumentCardTitle_base__ = __webpack_require__(1908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DocumentCardTitle_styles__ = __webpack_require__(762);



var DocumentCardTitle = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__DocumentCardTitle_base__["a" /* DocumentCardTitleBase */], __WEBPACK_IMPORTED_MODULE_2__DocumentCardTitle_styles__["b" /* getStyles */], undefined, { scope: 'DocumentCardTitle' });
//# sourceMappingURL=DocumentCardTitle.js.map

/***/ }),
/* 1908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DocumentCardTitleBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);



var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var TRUNCATION_VERTICAL_OVERFLOW_THRESHOLD = 5;
/**
 * {@docCategory DocumentCard}
 */
var DocumentCardTitleBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](DocumentCardTitleBase, _super);
    function DocumentCardTitleBase(props) {
        var _this = _super.call(this, props) || this;
        _this._titleElement = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._measureTitleElement = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        // Truncate logic here way can't handle the case that chars with different widths are mixed very well, let _shrinkTitle take care of that.
        _this._truncateTitle = function () {
            if (!_this.state.needMeasurement) {
                return;
            }
            _this._async.requestAnimationFrame(_this._truncateWhenInAnimation);
        };
        _this._truncateWhenInAnimation = function () {
            var originalTitle = _this.props.title;
            var element = _this._measureTitleElement.current;
            if (element) {
                var style = getComputedStyle(element);
                if (style.width && style.lineHeight && style.height) {
                    var clientWidth = element.clientWidth, scrollWidth = element.scrollWidth;
                    var lines = Math.floor((parseInt(style.height, 10) + TRUNCATION_VERTICAL_OVERFLOW_THRESHOLD) / parseInt(style.lineHeight, 10));
                    // Use overflow to predict truncated length.
                    // Take an example.The text is: A text with A very long text that need to be truncated.ppt
                    // if container is like
                    // |A text with A very| long text that need to be truncated.ppt
                    // The scroll width is 58, (take two | out of length)
                    // The client width is 18
                    // the overflow rate is scrollWidth/clientWidth which should be close to length(overflowText)/length(visualText)
                    // And the length of remaining text should be truncated is (original Length)/(58/18) -3 = 15.
                    // So that the logic can predict truncated text well.
                    // first piece will be `A text `, * second piece will be `ated.ppt`
                    // |A text ...ated.ppt|
                    var overFlowRate = scrollWidth / (parseInt(style.width, 10) * lines);
                    if (overFlowRate > 1) {
                        var truncatedLength = originalTitle.length / overFlowRate - 3 /** Saved for separator */;
                        return _this.setState({
                            truncatedTitleFirstPiece: originalTitle.slice(0, truncatedLength / 2),
                            truncatedTitleSecondPiece: originalTitle.slice(originalTitle.length - truncatedLength / 2),
                            clientWidth: clientWidth,
                            needMeasurement: false
                        });
                    }
                }
            }
            return _this.setState({ needMeasurement: false });
        };
        _this._shrinkTitle = function () {
            var _a = _this.state, truncatedTitleFirstPiece = _a.truncatedTitleFirstPiece, truncatedTitleSecondPiece = _a.truncatedTitleSecondPiece;
            if (truncatedTitleFirstPiece && truncatedTitleSecondPiece) {
                var titleElement = _this._titleElement.current;
                if (!titleElement) {
                    return;
                }
                if (titleElement.scrollHeight > titleElement.clientHeight + TRUNCATION_VERTICAL_OVERFLOW_THRESHOLD ||
                    titleElement.scrollWidth > titleElement.clientWidth) {
                    _this.setState({
                        truncatedTitleFirstPiece: truncatedTitleFirstPiece.slice(0, truncatedTitleFirstPiece.length - 1),
                        truncatedTitleSecondPiece: truncatedTitleSecondPiece.slice(1)
                    });
                }
            }
        };
        _this.state = {
            truncatedTitleFirstPiece: '',
            truncatedTitleSecondPiece: '',
            previousTitle: props.title,
            needMeasurement: !!props.shouldTruncate
        };
        return _this;
    }
    DocumentCardTitleBase.prototype.componentDidUpdate = function () {
        if (this.props.title !== this.state.previousTitle) {
            this.setState({
                truncatedTitleFirstPiece: undefined,
                truncatedTitleSecondPiece: undefined,
                clientWidth: undefined,
                previousTitle: this.props.title,
                needMeasurement: !!this.props.shouldTruncate
            });
        }
        this._events.off(window, 'resize', this._updateTruncation);
        if (this.props.shouldTruncate) {
            this._truncateTitle();
            requestAnimationFrame(this._shrinkTitle);
            this._events.on(window, 'resize', this._updateTruncation);
        }
    };
    DocumentCardTitleBase.prototype.componentDidMount = function () {
        if (this.props.shouldTruncate) {
            this._truncateTitle();
            this._events.on(window, 'resize', this._updateTruncation);
        }
    };
    DocumentCardTitleBase.prototype.componentWillUnmount = function () {
        this._events.off(window, 'resize', this._updateTruncation);
    };
    DocumentCardTitleBase.prototype.render = function () {
        var _a = this.props, title = _a.title, shouldTruncate = _a.shouldTruncate, showAsSecondaryTitle = _a.showAsSecondaryTitle, styles = _a.styles, theme = _a.theme, className = _a.className;
        var _b = this.state, truncatedTitleFirstPiece = _b.truncatedTitleFirstPiece, truncatedTitleSecondPiece = _b.truncatedTitleSecondPiece, needMeasurement = _b.needMeasurement;
        this._classNames = getClassNames(styles, {
            theme: theme,
            className: className,
            showAsSecondaryTitle: showAsSecondaryTitle
        });
        var documentCardTitle;
        if (needMeasurement) {
            documentCardTitle = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.root, ref: this._measureTitleElement, title: title, style: { whiteSpace: 'nowrap' } }, title));
        }
        else if (shouldTruncate && truncatedTitleFirstPiece && truncatedTitleSecondPiece) {
            documentCardTitle = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.root, ref: this._titleElement, title: title },
                truncatedTitleFirstPiece,
                "\u2026",
                truncatedTitleSecondPiece));
        }
        else {
            documentCardTitle = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.root, ref: this._titleElement, title: title }, title));
        }
        return documentCardTitle;
    };
    DocumentCardTitleBase.prototype._updateTruncation = function () {
        var _this = this;
        this._async.requestAnimationFrame(function () {
            // Only update truncation if the title's size has changed since the last time we truncated
            if (_this._titleElement.current) {
                var clientWidth = _this._titleElement.current.clientWidth;
                // Throttle truncation so that it doesn't happen during a window resize
                clearTimeout(_this._titleTruncationTimer);
                if (_this.state.clientWidth !== clientWidth) {
                    _this._titleTruncationTimer = _this._async.setTimeout(function () {
                        return _this.setState({
                            truncatedTitleFirstPiece: undefined,
                            truncatedTitleSecondPiece: undefined,
                            needMeasurement: true
                        });
                    }, 250);
                }
            }
        });
    };
    return DocumentCardTitleBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=DocumentCardTitle.base.js.map

/***/ }),
/* 1909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DocumentCardLogo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DocumentCardLogo_base__ = __webpack_require__(1910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DocumentCardLogo_styles__ = __webpack_require__(1911);



var DocumentCardLogo = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__DocumentCardLogo_base__["a" /* DocumentCardLogoBase */], __WEBPACK_IMPORTED_MODULE_2__DocumentCardLogo_styles__["a" /* getStyles */], undefined, { scope: 'DocumentCardLogo' });
//# sourceMappingURL=DocumentCardLogo.js.map

/***/ }),
/* 1910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DocumentCardLogoBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Icon__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utilities__ = __webpack_require__(1);




var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["r" /* classNamesFunction */])();
/**
 * {@docCategory DocumentCard}
 */
var DocumentCardLogoBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](DocumentCardLogoBase, _super);
    function DocumentCardLogoBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DocumentCardLogoBase.prototype.render = function () {
        var _a = this.props, logoIcon = _a.logoIcon, styles = _a.styles, theme = _a.theme, className = _a.className;
        this._classNames = getClassNames(styles, {
            theme: theme,
            className: className
        });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.root },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Icon__["Icon"], { iconName: logoIcon })));
    };
    return DocumentCardLogoBase;
}(__WEBPACK_IMPORTED_MODULE_3__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=DocumentCardLogo.base.js.map

/***/ }),
/* 1911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var GlobalClassNames = {
    root: 'ms-DocumentCardLogo'
};
var getStyles = function (props) {
    var theme = props.theme, className = props.className;
    var palette = theme.palette;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            {
                fontSize: '32px',
                color: palette.themePrimary,
                display: 'block',
                padding: '16px 16px 0 16px'
            },
            className
        ]
    };
};
//# sourceMappingURL=DocumentCardLogo.styles.js.map

/***/ }),
/* 1912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DocumentCardStatus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DocumentCardStatus_base__ = __webpack_require__(1913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DocumentCardStatus_styles__ = __webpack_require__(1914);



var DocumentCardStatus = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__DocumentCardStatus_base__["a" /* DocumentCardStatusBase */], __WEBPACK_IMPORTED_MODULE_2__DocumentCardStatus_styles__["a" /* getStyles */], undefined, { scope: 'DocumentCardStatus' });
//# sourceMappingURL=DocumentCardStatus.js.map

/***/ }),
/* 1913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DocumentCardStatusBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icon__ = __webpack_require__(12);




var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
/**
 * {@docCategory DocumentCard}
 */
var DocumentCardStatusBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](DocumentCardStatusBase, _super);
    function DocumentCardStatusBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DocumentCardStatusBase.prototype.render = function () {
        var _a = this.props, statusIcon = _a.statusIcon, status = _a.status, styles = _a.styles, theme = _a.theme, className = _a.className;
        var iconProps = {
            iconName: statusIcon,
            styles: {
                root: { padding: '8px' }
            }
        };
        this._classNames = getClassNames(styles, {
            theme: theme,
            className: className
        });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this._classNames.root },
            statusIcon && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Icon__["Icon"], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, iconProps)),
            status));
    };
    return DocumentCardStatusBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=DocumentCardStatus.base.js.map

/***/ }),
/* 1914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var GlobalClassNames = {
    root: 'ms-DocumentCardStatus'
};
var getStyles = function (props) {
    var className = props.className, theme = props.theme;
    var palette = theme.palette, fonts = theme.fonts;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            fonts.medium,
            {
                margin: '8px 16px',
                color: palette.neutralPrimary,
                backgroundColor: palette.neutralLighter,
                height: '32px'
            },
            className
        ]
    };
};
//# sourceMappingURL=DocumentCardStatus.styles.js.map

/***/ }),
/* 1915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ExtendedPicker_index__ = __webpack_require__(1916);
/* unused harmony namespace reexport */

//# sourceMappingURL=ExtendedPicker.js.map

/***/ }),
/* 1916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseExtendedPicker__ = __webpack_require__(764);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PeoplePicker_ExtendedPeoplePicker__ = __webpack_require__(1918);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__examples_PeopleExampleData__ = __webpack_require__(1920);
/* unused harmony namespace reexport */



//# sourceMappingURL=index.js.map

/***/ }),
/* 1917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pickerText", function() { return pickerText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pickerInput", function() { return pickerInput; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_load_themed_styles__ = __webpack_require__(67);
/* tslint:disable */

Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_load_themed_styles__["a" /* loadStyles */])([{ "rawString": ".pickerText_55459320{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-sizing:border-box;box-sizing:border-box;border:1px solid " }, { "theme": "neutralTertiary", "defaultValue": "#a6a6a6" }, { "rawString": ";min-width:180px;padding:1px;min-height:32px}.pickerText_55459320:hover{border-color:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": "}.pickerInput_55459320{height:34px;border:none;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;outline:none;padding:0 6px 0px;margin:1px}.pickerInput_55459320::-ms-clear{display:none}\n" }]);
var pickerText = "pickerText_55459320";
var pickerInput = "pickerInput_55459320";
//# sourceMappingURL=BaseExtendedPicker.scss.js.map

/***/ }),
/* 1918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BaseExtendedPeoplePicker */
/* unused harmony export ExtendedPeoplePicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ExtendedPeoplePicker_scss__ = __webpack_require__(1919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseExtendedPicker__ = __webpack_require__(764);



/**
 * {@docCategory ExtendedPeoplePicker}
 */
var BaseExtendedPeoplePicker = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](BaseExtendedPeoplePicker, _super);
    function BaseExtendedPeoplePicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BaseExtendedPeoplePicker;
}(__WEBPACK_IMPORTED_MODULE_2__BaseExtendedPicker__["a" /* BaseExtendedPicker */]));

/**
 * {@docCategory ExtendedPeoplePicker}
 */
var ExtendedPeoplePicker = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ExtendedPeoplePicker, _super);
    function ExtendedPeoplePicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ExtendedPeoplePicker;
}(BaseExtendedPeoplePicker));

//# sourceMappingURL=ExtendedPeoplePicker.js.map

/***/ }),
/* 1919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export resultContent */
/* unused harmony export resultItem */
/* unused harmony export peoplePickerPersona */
/* unused harmony export peoplePicker */
/* unused harmony export peoplePickerPersonaContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_load_themed_styles__ = __webpack_require__(67);
/* tslint:disable */

Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_load_themed_styles__["a" /* loadStyles */])([{ "rawString": ".resultContent_8d238594{display:table-row}.resultContent_8d238594 .resultItem_8d238594{display:table-cell;vertical-align:bottom}.peoplePickerPersona_8d238594{width:180px}.peoplePickerPersona_8d238594 .ms-Persona-details{width:100%}.peoplePicker_8d238594 .ms-BasePicker-text{min-height:40px}.peoplePickerPersonaContent_8d238594{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}\n" }]);
var resultContent = "resultContent_8d238594";
var resultItem = "resultItem_8d238594";
var peoplePickerPersona = "peoplePickerPersona_8d238594";
var peoplePicker = "peoplePicker_8d238594";
var peoplePickerPersonaContent = "peoplePickerPersonaContent_8d238594";
//# sourceMappingURL=ExtendedPeoplePicker.scss.js.map

/***/ }),
/* 1920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export people */
/* unused harmony export mru */
/* unused harmony export groupOne */
/* unused harmony export groupTwo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Persona__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_TestImages__ = __webpack_require__(1921);
// If this file is moved or split, the scripts for building codepen examples will likely need to be updated.


var people = [
    {
        key: 1,
        imageUrl: __WEBPACK_IMPORTED_MODULE_1__common_TestImages__["a" /* TestImages */].personaFemale,
        imageInitials: 'PV',
        text: 'Annie Lindqvist',
        secondaryText: 'Designer',
        tertiaryText: 'In a meeting',
        optionalText: 'Available at 4:00pm',
        isValid: true,
        presence: __WEBPACK_IMPORTED_MODULE_0__Persona__["c" /* PersonaPresence */].online
    },
    {
        key: 2,
        imageUrl: __WEBPACK_IMPORTED_MODULE_1__common_TestImages__["a" /* TestImages */].personaMale,
        imageInitials: 'AR',
        text: 'Aaron Reid',
        secondaryText: 'Designer',
        tertiaryText: 'In a meeting',
        optionalText: 'Available at 4:00pm',
        isValid: true,
        presence: __WEBPACK_IMPORTED_MODULE_0__Persona__["c" /* PersonaPresence */].busy
    },
    {
        key: 3,
        imageUrl: __WEBPACK_IMPORTED_MODULE_1__common_TestImages__["a" /* TestImages */].personaMale,
        imageInitials: 'AL',
        text: 'Alex Lundberg',
        secondaryText: 'Software Developer',
        tertiaryText: 'In a meeting',
        optionalText: 'Available at 4:00pm',
        isValid: true,
        presence: __WEBPACK_IMPORTED_MODULE_0__Persona__["c" /* PersonaPresence */].dnd
    },
    {
        key: 4,
        imageUrl: __WEBPACK_IMPORTED_MODULE_1__common_TestImages__["a" /* TestImages */].personaMale,
        imageInitials: 'RK',
        text: 'Roko Kolar',
        secondaryText: 'Financial Analyst',
        tertiaryText: 'In a meeting',
        optionalText: 'Available at 4:00pm',
        isValid: true,
        presence: __WEBPACK_IMPORTED_MODULE_0__Persona__["c" /* PersonaPresence */].offline
    },
    {
        key: 5,
        imageUrl: __WEBPACK_IMPORTED_MODULE_1__common_TestImages__["a" /* TestImages */].personaMale,
        imageInitials: 'CB',
        text: 'Christian Bergqvist',
        secondaryText: 'Sr. Designer',
        tertiaryText: 'In a meeting',
        optionalText: 'Available at 4:00pm',
        isValid: true,
        presence: __WEBPACK_IMPORTED_MODULE_0__Persona__["c" /* PersonaPresence */].online
    },
    {
        key: 6,
        imageUrl: __WEBPACK_IMPORTED_MODULE_1__common_TestImages__["a" /* TestImages */].personaFemale,
        imageInitials: 'VL',
        text: 'Valentina Lovric',
        secondaryText: 'Design Developer',
        tertiaryText: 'In a meeting',
        optionalText: 'Available at 4:00pm',
        isValid: true,
        presence: __WEBPACK_IMPORTED_MODULE_0__Persona__["c" /* PersonaPresence */].online
    },
    {
        key: 7,
        imageUrl: __WEBPACK_IMPORTED_MODULE_1__common_TestImages__["a" /* TestImages */].personaMale,
        imageInitials: 'MS',
        text: 'Maor Sharett',
        secondaryText: 'UX Designer',
        tertiaryText: 'In a meeting',
        optionalText: 'Available at 4:00pm',
        isValid: true,
        presence: __WEBPACK_IMPORTED_MODULE_0__Persona__["c" /* PersonaPresence */].away
    },
    {
        key: 8,
        imageUrl: __WEBPACK_IMPORTED_MODULE_1__common_TestImages__["a" /* TestImages */].personaFemale,
        imageInitials: 'PV',
        text: 'Anny Lindqvist',
        secondaryText: 'Designer',
        tertiaryText: 'In a meeting',
        optionalText: 'Available at 4:00pm',
        isValid: true,
        presence: __WEBPACK_IMPORTED_MODULE_0__Persona__["c" /* PersonaPresence */].busy
    },
    {
        key: 9,
        imageUrl: __WEBPACK_IMPORTED_MODULE_1__common_TestImages__["a" /* TestImages */].personaMale,
        imageInitials: 'AR',
        text: 'Aron Reid',
        secondaryText: 'Designer',
        tertiaryText: 'In a meeting',
        optionalText: 'Available at 4:00pm',
        isValid: true,
        presence: __WEBPACK_IMPORTED_MODULE_0__Persona__["c" /* PersonaPresence */].dnd
    },
    {
        key: 10,
        imageUrl: __WEBPACK_IMPORTED_MODULE_1__common_TestImages__["a" /* TestImages */].personaMale,
        imageInitials: 'AL',
        text: 'Alix Lundberg',
        secondaryText: 'Software Developer',
        tertiaryText: 'In a meeting',
        optionalText: 'Available at 4:00pm',
        isValid: true,
        presence: __WEBPACK_IMPORTED_MODULE_0__Persona__["c" /* PersonaPresence */].offline
    },
    {
        key: 11,
        imageUrl: __WEBPACK_IMPORTED_MODULE_1__common_TestImages__["a" /* TestImages */].personaMale,
        imageInitials: 'RK',
        text: 'Roko Kular',
        secondaryText: 'Financial Analyst',
        tertiaryText: 'In a meeting',
        optionalText: 'Available at 4:00pm',
        isValid: true,
        presence: __WEBPACK_IMPORTED_MODULE_0__Persona__["c" /* PersonaPresence */].none
    },
    {
        key: 12,
        imageUrl: __WEBPACK_IMPORTED_MODULE_1__common_TestImages__["a" /* TestImages */].personaMale,
        imageInitials: 'CB',
        text: 'Christian Bergqvest',
        secondaryText: 'Sr. Designer',
        tertiaryText: 'In a meeting',
        optionalText: 'Available at 4:00pm',
        isValid: true,
        presence: __WEBPACK_IMPORTED_MODULE_0__Persona__["c" /* PersonaPresence */].busy
    },
    {
        key: 13,
        imageUrl: __WEBPACK_IMPORTED_MODULE_1__common_TestImages__["a" /* TestImages */].personaFemale,
        imageInitials: 'VL',
        text: 'Valintina Lovric',
        secondaryText: 'Design Developer',
        tertiaryText: 'In a meeting',
        optionalText: 'Available at 4:00pm',
        isValid: true,
        presence: __WEBPACK_IMPORTED_MODULE_0__Persona__["c" /* PersonaPresence */].busy
    },
    {
        key: 14,
        imageUrl: __WEBPACK_IMPORTED_MODULE_1__common_TestImages__["a" /* TestImages */].personaMale,
        imageInitials: 'MS',
        text: 'Maor Sharet',
        secondaryText: 'UX Designer',
        tertiaryText: 'In a meeting',
        optionalText: 'Available at 4:00pm',
        isValid: true,
        presence: __WEBPACK_IMPORTED_MODULE_0__Persona__["c" /* PersonaPresence */].blocked
    },
    {
        key: 15,
        imageUrl: __WEBPACK_IMPORTED_MODULE_1__common_TestImages__["a" /* TestImages */].personaFemale,
        imageInitials: 'VL',
        text: 'Anny Lindqvest',
        secondaryText: 'SDE',
        tertiaryText: 'In a meeting',
        optionalText: 'Available at 4:00pm',
        isValid: true,
        presence: __WEBPACK_IMPORTED_MODULE_0__Persona__["c" /* PersonaPresence */].blocked
    },
    {
        key: 16,
        imageUrl: __WEBPACK_IMPORTED_MODULE_1__common_TestImages__["a" /* TestImages */].personaMale,
        imageInitials: 'MS',
        text: 'Alix Lunberg',
        secondaryText: 'SE',
        tertiaryText: 'In a meeting',
        optionalText: 'Available at 4:00pm',
        isValid: true,
        presence: __WEBPACK_IMPORTED_MODULE_0__Persona__["c" /* PersonaPresence */].away
    },
    {
        key: 17,
        imageUrl: __WEBPACK_IMPORTED_MODULE_1__common_TestImages__["a" /* TestImages */].personaFemale,
        imageInitials: 'VL',
        text: 'Annie Lindqvest',
        secondaryText: 'SDET',
        tertiaryText: 'In a meeting',
        optionalText: 'Available at 4:00pm',
        isValid: true,
        presence: __WEBPACK_IMPORTED_MODULE_0__Persona__["c" /* PersonaPresence */].online
    },
    {
        key: 18,
        imageUrl: __WEBPACK_IMPORTED_MODULE_1__common_TestImages__["a" /* TestImages */].personaMale,
        imageInitials: 'MS',
        text: 'Alixander Lundberg',
        secondaryText: 'Senior Manager of SDET',
        tertiaryText: 'In a meeting',
        optionalText: 'Available at 4:00pm',
        isValid: true,
        presence: __WEBPACK_IMPORTED_MODULE_0__Persona__["c" /* PersonaPresence */].offline
    },
    {
        key: 19,
        imageUrl: __WEBPACK_IMPORTED_MODULE_1__common_TestImages__["a" /* TestImages */].personaFemale,
        imageInitials: 'VL',
        text: 'Anny Lundqvist',
        secondaryText: 'Junior Manager of Software',
        tertiaryText: 'In a meeting',
        optionalText: 'Available at 4:00pm',
        isValid: true,
        presence: __WEBPACK_IMPORTED_MODULE_0__Persona__["c" /* PersonaPresence */].away
    },
    {
        key: 20,
        imageUrl: __WEBPACK_IMPORTED_MODULE_1__common_TestImages__["a" /* TestImages */].personaMale,
        imageInitials: 'MS',
        text: 'Maor Shorett',
        secondaryText: 'UX Designer',
        tertiaryText: 'In a meeting',
        optionalText: 'Available at 4:00pm',
        isValid: true,
        presence: __WEBPACK_IMPORTED_MODULE_0__Persona__["c" /* PersonaPresence */].blocked
    },
    {
        key: 21,
        imageUrl: __WEBPACK_IMPORTED_MODULE_1__common_TestImages__["a" /* TestImages */].personaFemale,
        imageInitials: 'VL',
        text: 'Valentina Lovrics',
        secondaryText: 'Design Developer',
        tertiaryText: 'In a meeting',
        optionalText: 'Available at 4:00pm',
        isValid: true,
        presence: __WEBPACK_IMPORTED_MODULE_0__Persona__["c" /* PersonaPresence */].online
    },
    {
        key: 22,
        imageUrl: __WEBPACK_IMPORTED_MODULE_1__common_TestImages__["a" /* TestImages */].personaMale,
        imageInitials: 'MS',
        text: 'Maor Sharet',
        secondaryText: 'UX Designer',
        tertiaryText: 'In a meeting',
        optionalText: 'Available at 4:00pm',
        isValid: true,
        presence: __WEBPACK_IMPORTED_MODULE_0__Persona__["c" /* PersonaPresence */].online
    },
    {
        key: 23,
        imageUrl: __WEBPACK_IMPORTED_MODULE_1__common_TestImages__["a" /* TestImages */].personaFemale,
        imageInitials: 'VL',
        text: 'Valentina Lovrecs',
        secondaryText: 'Design Developer',
        tertiaryText: 'In a meeting',
        optionalText: 'Available at 4:00pm',
        isValid: true,
        presence: __WEBPACK_IMPORTED_MODULE_0__Persona__["c" /* PersonaPresence */].blocked
    },
    {
        key: 24,
        imageUrl: __WEBPACK_IMPORTED_MODULE_1__common_TestImages__["a" /* TestImages */].personaMale,
        imageInitials: 'MS',
        text: 'Maor Sharitt',
        secondaryText: 'UX Designer',
        tertiaryText: 'In a meeting',
        optionalText: 'Available at 4:00pm',
        isValid: true,
        presence: __WEBPACK_IMPORTED_MODULE_0__Persona__["c" /* PersonaPresence */].offline
    },
    {
        key: 25,
        imageUrl: './images/persona-male.png',
        imageInitials: 'MS',
        text: 'Maor Shariett',
        secondaryText: 'Design Developer',
        tertiaryText: 'In a meeting',
        optionalText: 'Available at 3:00pm',
        isValid: true,
        presence: __WEBPACK_IMPORTED_MODULE_0__Persona__["c" /* PersonaPresence */].online
    },
    {
        key: 26,
        imageUrl: './images/persona-female.png',
        imageInitials: 'AL',
        text: 'Alix Lundburg',
        secondaryText: 'UX Designer',
        tertiaryText: 'In a meeting',
        optionalText: 'Available at 3:00pm',
        isValid: true,
        presence: __WEBPACK_IMPORTED_MODULE_0__Persona__["c" /* PersonaPresence */].away
    },
    {
        key: 27,
        imageUrl: './images/persona-female.png',
        imageInitials: 'VL',
        text: 'Valantena Lovric',
        secondaryText: 'UX Designer',
        tertiaryText: 'In a meeting',
        optionalText: 'Available at 4:00pm',
        isValid: true,
        presence: __WEBPACK_IMPORTED_MODULE_0__Persona__["c" /* PersonaPresence */].busy
    },
    {
        key: 28,
        imageUrl: './images/persona-female.png',
        imageInitials: 'VL',
        text: 'Velatine Lourvric',
        secondaryText: 'UX Designer',
        tertiaryText: 'In a meeting',
        optionalText: 'Available at 4:00pm',
        isValid: true,
        presence: __WEBPACK_IMPORTED_MODULE_0__Persona__["c" /* PersonaPresence */].online
    },
    {
        key: 29,
        imageUrl: './images/persona-female.png',
        imageInitials: 'VL',
        text: 'Valentyna Lovrique',
        secondaryText: 'UX Designer',
        tertiaryText: 'In a meeting',
        optionalText: 'Available at 4:00pm',
        isValid: true,
        presence: __WEBPACK_IMPORTED_MODULE_0__Persona__["c" /* PersonaPresence */].busy
    },
    {
        key: 30,
        imageUrl: './images/persona-female.png',
        imageInitials: 'AL',
        text: 'Annie Lindquest',
        secondaryText: 'UX Designer',
        tertiaryText: 'In a meeting',
        optionalText: 'Available at 4:00pm',
        isValid: true,
        presence: __WEBPACK_IMPORTED_MODULE_0__Persona__["c" /* PersonaPresence */].dnd
    },
    {
        key: 31,
        imageUrl: './images/persona-female.png',
        imageInitials: 'AL',
        text: 'Anne Lindquist',
        secondaryText: 'UX Designer',
        tertiaryText: 'In a meeting',
        optionalText: 'Available at 4:00pm',
        isValid: true,
        presence: __WEBPACK_IMPORTED_MODULE_0__Persona__["c" /* PersonaPresence */].blocked
    },
    {
        key: 32,
        imageUrl: './images/persona-female.png',
        imageInitials: 'AL',
        text: 'Ann Lindqiest',
        secondaryText: 'UX Designer',
        tertiaryText: 'In a meeting',
        optionalText: 'Available at 4:00pm',
        isValid: true,
        presence: __WEBPACK_IMPORTED_MODULE_0__Persona__["c" /* PersonaPresence */].online
    },
    {
        key: 33,
        imageUrl: './images/persona-male.png',
        imageInitials: 'AR',
        text: 'Aron Reid',
        secondaryText: 'UX Designer',
        tertiaryText: 'In a meeting',
        optionalText: 'Available at 4:00pm',
        isValid: true,
        presence: __WEBPACK_IMPORTED_MODULE_0__Persona__["c" /* PersonaPresence */].away
    },
    {
        key: 34,
        imageUrl: './images/persona-male.png',
        imageInitials: 'AR',
        text: 'Aaron Reed',
        secondaryText: 'UX Designer',
        tertiaryText: 'In a meeting',
        optionalText: 'Available at 4:00pm',
        isValid: true,
        presence: __WEBPACK_IMPORTED_MODULE_0__Persona__["c" /* PersonaPresence */].offline
    },
    {
        key: 35,
        imageUrl: './images/persona-female.png',
        imageInitials: 'AL',
        text: 'Alix Lindberg',
        secondaryText: 'UX Designer',
        tertiaryText: 'In a meeting',
        optionalText: 'Available at 4:00pm',
        isValid: true,
        presence: __WEBPACK_IMPORTED_MODULE_0__Persona__["c" /* PersonaPresence */].busy
    },
    {
        key: 36,
        imageUrl: './images/persona-male.png',
        imageInitials: 'AL',
        text: 'Alan Lindberg',
        secondaryText: 'UX Designer',
        tertiaryText: 'In a meeting',
        optionalText: 'Available at 4:00pm',
        isValid: true,
        presence: __WEBPACK_IMPORTED_MODULE_0__Persona__["c" /* PersonaPresence */].busy
    },
    {
        key: 37,
        imageUrl: './images/persona-male.png',
        imageInitials: 'MS',
        text: 'Maor Sharit',
        secondaryText: 'UX Designer',
        tertiaryText: 'In a meeting',
        optionalText: 'Available at 4:00pm',
        isValid: true,
        presence: __WEBPACK_IMPORTED_MODULE_0__Persona__["c" /* PersonaPresence */].offline
    },
    {
        key: 38,
        imageUrl: './images/persona-male.png',
        imageInitials: 'MS',
        text: 'Maorr Sherit',
        secondaryText: 'UX Designer',
        tertiaryText: 'In a meeting',
        optionalText: 'Available at 4:00pm',
        isValid: true,
        presence: __WEBPACK_IMPORTED_MODULE_0__Persona__["c" /* PersonaPresence */].online
    },
    {
        key: 39,
        imageUrl: './images/persona-male.png',
        imageInitials: 'AL',
        text: 'Alex Lindbirg',
        secondaryText: 'Software Developer',
        tertiaryText: 'In a meeting',
        optionalText: 'Available at 4:00pm',
        isValid: true,
        presence: __WEBPACK_IMPORTED_MODULE_0__Persona__["c" /* PersonaPresence */].dnd
    },
    {
        key: 40,
        imageUrl: './images/persona-male.png',
        imageInitials: 'AL',
        text: 'Alex Lindbarg',
        secondaryText: 'Software Developer',
        tertiaryText: 'In a meeting',
        optionalText: 'Available at 4:00pm',
        isValid: true,
        presence: __WEBPACK_IMPORTED_MODULE_0__Persona__["c" /* PersonaPresence */].online
    },
    {
        key: 41,
        imageInitials: 'GO',
        text: 'Group One',
        canExpand: true,
        isValid: true
    },
    {
        key: 42,
        imageInitials: 'GT',
        text: 'Group Two',
        canExpand: true,
        isValid: true
    }
];
var mru = people.slice(0, 5);
var groupOne = people.slice(6, 10);
var groupTwo = people.slice(11, 16);
//# sourceMappingURL=PeopleExampleData.js.map

/***/ }),
/* 1921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TestImages; });
// If this file is moved or split, the scripts for building codepen examples will likely need to be updated.
var baseProductionCdnUrl = 'https://static2.sharepointonline.com/files/fabric/office-ui-fabric-react-assets/';
var TestImages = {
    choiceGroupBarUnselected: baseProductionCdnUrl + 'choicegroup-bar-unselected.png',
    choiceGroupBarSelected: baseProductionCdnUrl + 'choicegroup-bar-selected.png',
    choiceGroupPieUnselected: baseProductionCdnUrl + 'choicegroup-pie-unselected.png',
    choiceGroupPieSelected: baseProductionCdnUrl + 'choicegroup-pie-selected.png',
    documentPreview: baseProductionCdnUrl + 'document-preview.png',
    documentPreviewTwo: baseProductionCdnUrl + 'document-preview2.png',
    documentPreviewThree: baseProductionCdnUrl + 'document-preview3.png',
    iconOne: baseProductionCdnUrl + 'icon-one.png',
    iconPpt: baseProductionCdnUrl + 'icon-ppt.png',
    personaFemale: baseProductionCdnUrl + 'persona-female.png',
    personaMale: baseProductionCdnUrl + 'persona-male.png'
};
//# sourceMappingURL=TestImages.js.map

/***/ }),
/* 1922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Facepile_index__ = __webpack_require__(1923);
/* unused harmony namespace reexport */

//# sourceMappingURL=Facepile.js.map

/***/ }),
/* 1923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Facepile_types__ = __webpack_require__(765);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Facepile_base__ = __webpack_require__(766);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Facepile__ = __webpack_require__(1926);
/* unused harmony namespace reexport */



//# sourceMappingURL=index.js.map

/***/ }),
/* 1924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FacepileButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FacepileButton_styles__ = __webpack_require__(1925);





var FacepileButton = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](FacepileButton, _super);
    function FacepileButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Tell BaseComponent to bypass resolution of componentRef.
         */
        _this._skipComponentRefResolution = true;
        return _this;
    }
    FacepileButton.prototype.render = function () {
        var _a = this.props, className = _a.className, styles = _a.styles, rest = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __rest */](_a, ["className", "styles"]);
        var customStyles = Object(__WEBPACK_IMPORTED_MODULE_4__FacepileButton_styles__["a" /* getStyles */])(this.props.theme, className, styles);
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Button__["b" /* BaseButton */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, rest, { variantClassName: "ms-Button--facepile", styles: customStyles, onRenderDescription: __WEBPACK_IMPORTED_MODULE_3__Utilities__["_17" /* nullRender */] }));
    };
    FacepileButton = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_3__Utilities__["u" /* customizable */])('FacepileButton', ['theme', 'styles'], true)
    ], FacepileButton);
    return FacepileButton;
}(__WEBPACK_IMPORTED_MODULE_3__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=FacepileButton.js.map

/***/ }),
/* 1925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Button_BaseButton_styles__ = __webpack_require__(137);




var getStyles = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_15" /* memoizeFunction */])(function (theme, className, customStyles) {
    var baseButtonStyles = Object(__WEBPACK_IMPORTED_MODULE_3__Button_BaseButton_styles__["a" /* getStyles */])(theme);
    var customButtonStyles = Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["t" /* concatStyleSets */])(baseButtonStyles, customStyles);
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, customButtonStyles, { root: [baseButtonStyles.root, className, theme.fonts.medium, customStyles && customStyles.root] });
});
//# sourceMappingURL=FacepileButton.styles.js.map

/***/ }),
/* 1926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Facepile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Facepile_base__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Facepile_styles__ = __webpack_require__(1927);



/**
 * The Facepile shows a list of faces or initials in a horizontal lockup. Each circle represents a person.
 */
var Facepile = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__Facepile_base__["a" /* FacepileBase */], __WEBPACK_IMPORTED_MODULE_2__Facepile_styles__["a" /* styles */], undefined, {
    scope: 'Facepile'
});
//# sourceMappingURL=Facepile.js.map

/***/ }),
/* 1927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var GlobalClassNames = {
    root: 'ms-Facepile',
    addButton: 'ms-Facepile-addButton ms-Facepile-itemButton',
    descriptiveOverflowButton: 'ms-Facepile-descriptiveOverflowButton ms-Facepile-itemButton',
    itemButton: 'ms-Facepile-itemButton ms-Facepile-person',
    itemContainer: 'ms-Facepile-itemContainer',
    members: 'ms-Facepile-members',
    member: 'ms-Facepile-member',
    overflowButton: 'ms-Facepile-overflowButton ms-Facepile-itemButton'
};
var styles = function (props) {
    var className = props.className, theme = props.theme, _a = props.spacingAroundItemButton, spacingAroundItemButton = _a === void 0 ? 2 : _a;
    var palette = theme.palette, fonts = theme.fonts;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    var ItemButtonStyles = {
        textAlign: 'center',
        padding: 0,
        borderRadius: '50%',
        verticalAlign: 'top',
        display: 'inline',
        backgroundColor: 'transparent',
        cursor: 'pointer',
        border: 'none',
        selectors: {
            '&::-moz-focus-inner': {
                padding: 0,
                border: 0
            }
        }
    };
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            {
                width: 'auto'
            },
            className
        ],
        addButton: [
            classNames.addButton,
            Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["v" /* getFocusStyle */])(theme, { inset: -1 }),
            ItemButtonStyles,
            {
                fontSize: fonts.medium.fontSize,
                color: palette.white,
                backgroundColor: palette.themePrimary,
                marginRight: spacingAroundItemButton * 2 + 'px',
                selectors: {
                    '&:hover': {
                        backgroundColor: palette.themeDark
                    },
                    '&:focus': {
                        backgroundColor: palette.themeDark
                    },
                    '&:active': {
                        backgroundColor: palette.themeDarker
                    },
                    '&:disabled': {
                        backgroundColor: palette.neutralTertiaryAlt
                    }
                }
            }
        ],
        descriptiveOverflowButton: [
            classNames.descriptiveOverflowButton,
            Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["v" /* getFocusStyle */])(theme, { inset: -1 }),
            ItemButtonStyles,
            {
                fontSize: fonts.small.fontSize,
                color: palette.neutralSecondary,
                backgroundColor: palette.neutralLight,
                marginLeft: spacingAroundItemButton * 2 + "px"
            }
        ],
        itemButton: [classNames.itemButton, ItemButtonStyles],
        itemContainer: [
            classNames.itemContainer,
            {
                display: 'flex'
            }
        ],
        members: [
            classNames.members,
            {
                display: 'flex',
                overflow: 'hidden',
                listStyleType: 'none',
                padding: 0,
                margin: "-" + spacingAroundItemButton + "px"
            }
        ],
        member: [
            classNames.member,
            {
                display: 'inline-flex',
                flex: '0 0 auto',
                margin: spacingAroundItemButton + "px"
            }
        ],
        overflowButton: [
            classNames.overflowButton,
            Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["v" /* getFocusStyle */])(theme, { inset: -1 }),
            ItemButtonStyles,
            {
                fontSize: fonts.medium.fontSize,
                color: palette.neutralSecondary,
                backgroundColor: palette.neutralLight,
                marginLeft: spacingAroundItemButton * 2 + "px"
            }
        ],
        overflowInitialsIcon: [
            {
                color: palette.neutralPrimary
            }
        ],
        screenReaderOnly: __WEBPACK_IMPORTED_MODULE_0__Styling__["B" /* hiddenContentStyle */]
    };
};
//# sourceMappingURL=Facepile.styles.js.map

/***/ }),
/* 1928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FloatingPicker_index__ = __webpack_require__(1929);
/* unused harmony namespace reexport */

//# sourceMappingURL=FloatingPicker.js.map

/***/ }),
/* 1929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseFloatingPicker__ = __webpack_require__(767);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PeoplePicker_FloatingPeoplePicker__ = __webpack_require__(1943);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Suggestions_SuggestionsStore__ = __webpack_require__(1945);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Suggestions_SuggestionsControl__ = __webpack_require__(768);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Suggestions_SuggestionsCore__ = __webpack_require__(769);
/* unused harmony namespace reexport */





//# sourceMappingURL=index.js.map

/***/ }),
/* 1930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "callout", function() { return callout; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_load_themed_styles__ = __webpack_require__(67);
/* tslint:disable */

Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_load_themed_styles__["a" /* loadStyles */])([{ "rawString": ".callout_e8e64567 .ms-Suggestions-itemButton{padding:0px;border:none}.callout_e8e64567 .ms-Suggestions{min-width:300px}\n" }]);
var callout = "callout_e8e64567";
//# sourceMappingURL=BaseFloatingPicker.scss.js.map

/***/ }),
/* 1931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Suggestions_Suggestions__ = __webpack_require__(771);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Suggestions_Suggestions_types__ = __webpack_require__(772);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Suggestions_SuggestionsItem__ = __webpack_require__(773);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__Suggestions_SuggestionsItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Suggestions_SuggestionsController__ = __webpack_require__(776);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AutoFill_BaseAutoFill__ = __webpack_require__(1932);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BasePicker__ = __webpack_require__(437);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BasePicker_types__ = __webpack_require__(280);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PeoplePicker_PeoplePicker__ = __webpack_require__(1935);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PeoplePicker_PeoplePickerItems_PeoplePickerItem__ = __webpack_require__(777);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PeoplePicker_PeoplePickerItems_PeoplePickerItemSuggestion__ = __webpack_require__(778);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TagPicker_TagPicker__ = __webpack_require__(1938);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TagPicker_TagItem__ = __webpack_require__(780);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TagPicker_TagItemSuggestion__ = __webpack_require__(781);
/* unused harmony namespace reexport */













//# sourceMappingURL=index.js.map

/***/ }),
/* 1932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Autofill_Autofill__ = __webpack_require__(735);
/* unused harmony namespace reexport */
// Deprecated, import directly from the component folder now.

//# sourceMappingURL=BaseAutoFill.js.map

/***/ }),
/* 1933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStyles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var GlobalClassNames = {
    root: 'ms-Suggestions',
    suggestionsContainer: 'ms-Suggestions-container',
    title: 'ms-Suggestions-title',
    forceResolveButton: 'ms-forceResolve-button',
    searchForMoreButton: 'ms-SearchMore-button',
    spinner: 'ms-Suggestions-spinner',
    noSuggestions: 'ms-Suggestions-none',
    suggestionsAvailable: 'ms-Suggestions-suggestionsAvailable',
    isSelected: 'is-selected'
};
function getStyles(props) {
    var className = props.className, suggestionsClassName = props.suggestionsClassName, theme = props.theme, forceResolveButtonSelected = props.forceResolveButtonSelected, searchForMoreButtonSelected = props.searchForMoreButtonSelected;
    var palette = theme.palette;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    var actionButtonStyles = {
        background: 'none',
        backgroundColor: 'transparent',
        border: 0,
        cursor: 'pointer',
        margin: 0,
        paddingLeft: 8,
        position: 'relative',
        borderTop: "1px solid " + palette.neutralLight,
        height: 40,
        textAlign: 'left',
        width: '100%',
        fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].small,
        selectors: {
            ':hover': {
                backgroundColor: palette.neutralLight,
                cursor: 'pointer'
            },
            ':focus, :active': {
                backgroundColor: palette.themeLight
            },
            '.ms-Button-icon': {
                fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].icon,
                width: 25
            },
            '.ms-Button-label': {
                margin: '0 4px 0 9px'
            }
        }
    };
    var actionButtonSelectedStyles = {
        backgroundColor: palette.themeLight
    };
    return {
        root: [
            classNames.root,
            {
                minWidth: 260
            },
            className
        ],
        suggestionsContainer: [
            classNames.suggestionsContainer,
            {
                overflowY: 'auto',
                overflowX: 'hidden',
                maxHeight: 300,
                borderBottom: "1px solid " + palette.neutralLight
            },
            suggestionsClassName
        ],
        title: [
            classNames.title,
            {
                padding: '0 12px',
                fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].small,
                color: palette.themePrimary,
                lineHeight: 40,
                borderBottom: "1px solid " + palette.neutralLight
            }
        ],
        forceResolveButton: [
            classNames.forceResolveButton,
            actionButtonStyles,
            forceResolveButtonSelected && [classNames.isSelected, actionButtonSelectedStyles]
        ],
        searchForMoreButton: [
            classNames.searchForMoreButton,
            actionButtonStyles,
            searchForMoreButtonSelected && [classNames.isSelected, actionButtonSelectedStyles]
        ],
        noSuggestions: [
            classNames.noSuggestions,
            {
                textAlign: 'center',
                color: palette.neutralSecondary,
                fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].small,
                lineHeight: 30
            }
        ],
        suggestionsAvailable: [classNames.suggestionsAvailable, __WEBPACK_IMPORTED_MODULE_0__Styling__["B" /* hiddenContentStyle */]],
        subComponentStyles: {
            spinner: {
                root: [
                    classNames.spinner,
                    {
                        margin: '5px 0',
                        paddingLeft: 14,
                        textAlign: 'left',
                        whiteSpace: 'nowrap',
                        lineHeight: 20,
                        fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].small
                    }
                ],
                circle: {
                    display: 'inline-block',
                    verticalAlign: 'middle'
                },
                label: {
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    margin: '0 10px 0 16px'
                }
            }
        }
    };
}
//# sourceMappingURL=Suggestions.styles.js.map

/***/ }),
/* 1934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pickerText", function() { return pickerText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inputFocused", function() { return inputFocused; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pickerInput", function() { return pickerInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pickerItems", function() { return pickerItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "screenReaderOnly", function() { return screenReaderOnly; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_load_themed_styles__ = __webpack_require__(67);
/* tslint:disable */

Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_load_themed_styles__["a" /* loadStyles */])([{ "rawString": ".pickerText_de6ce0eb{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-sizing:border-box;box-sizing:border-box;border:1px solid " }, { "theme": "neutralTertiary", "defaultValue": "#a6a6a6" }, { "rawString": ";min-width:180px;min-height:30px}.pickerText_de6ce0eb:hover{border-color:" }, { "theme": "inputBorderHovered", "defaultValue": "#333333" }, { "rawString": "}.pickerText_de6ce0eb.inputFocused_de6ce0eb{border-color:" }, { "theme": "inputFocusBorderAlt", "defaultValue": "#0078d4" }, { "rawString": "}.pickerInput_de6ce0eb{height:34px;border:none;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;outline:none;padding:0 6px 0px;-ms-flex-item-align:end;align-self:flex-end}.pickerItems_de6ce0eb{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.screenReaderOnly_de6ce0eb{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);border:0}\n" }]);
var pickerText = "pickerText_de6ce0eb";
var inputFocused = "inputFocused_de6ce0eb";
var pickerInput = "pickerInput_de6ce0eb";
var pickerItems = "pickerItems_de6ce0eb";
var screenReaderOnly = "screenReaderOnly_de6ce0eb";
//# sourceMappingURL=BasePicker.scss.js.map

/***/ }),
/* 1935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BasePeoplePicker */
/* unused harmony export MemberListPeoplePicker */
/* unused harmony export NormalPeoplePickerBase */
/* unused harmony export CompactPeoplePickerBase */
/* unused harmony export ListPeoplePickerBase */
/* unused harmony export createGenericItem */
/* unused harmony export NormalPeoplePicker */
/* unused harmony export CompactPeoplePicker */
/* unused harmony export ListPeoplePicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BasePicker__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BasePicker_types__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PeoplePickerItems_PeoplePickerItem__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PeoplePickerItems_PeoplePickerItemSuggestion__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BasePicker_styles__ = __webpack_require__(779);








/**
 * {@docCategory PeoplePicker}
 */
var BasePeoplePicker = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](BasePeoplePicker, _super);
    function BasePeoplePicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BasePeoplePicker;
}(__WEBPACK_IMPORTED_MODULE_3__BasePicker__["a" /* BasePicker */]));

/**
 * {@docCategory PeoplePicker}
 */
var MemberListPeoplePicker = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](MemberListPeoplePicker, _super);
    function MemberListPeoplePicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MemberListPeoplePicker;
}(__WEBPACK_IMPORTED_MODULE_3__BasePicker__["b" /* BasePickerListBelow */]));

/**
 * Standard People Picker.
 * {@docCategory PeoplePicker}
 */
var NormalPeoplePickerBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](NormalPeoplePickerBase, _super);
    function NormalPeoplePickerBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /** Default props for NormalPeoplePicker. */
    NormalPeoplePickerBase.defaultProps = {
        onRenderItem: function (props) { return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__PeoplePickerItems_PeoplePickerItem__["a" /* PeoplePickerItem */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, props)); },
        onRenderSuggestionsItem: function (personaProps, suggestionsProps) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__PeoplePickerItems_PeoplePickerItemSuggestion__["a" /* PeoplePickerItemSuggestion */], { personaProps: personaProps, suggestionsProps: suggestionsProps })); },
        createGenericItem: createGenericItem
    };
    return NormalPeoplePickerBase;
}(BasePeoplePicker));

/**
 * Compact layout. It uses personas without secondary text when displaying search results.
 * {@docCategory PeoplePicker}
 */
var CompactPeoplePickerBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](CompactPeoplePickerBase, _super);
    function CompactPeoplePickerBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /** Default props for CompactPeoplePicker. */
    CompactPeoplePickerBase.defaultProps = {
        onRenderItem: function (props) { return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__PeoplePickerItems_PeoplePickerItem__["a" /* PeoplePickerItem */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, props)); },
        onRenderSuggestionsItem: function (personaProps, suggestionsProps) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__PeoplePickerItems_PeoplePickerItemSuggestion__["a" /* PeoplePickerItemSuggestion */], { personaProps: personaProps, suggestionsProps: suggestionsProps, compact: true })); },
        createGenericItem: createGenericItem
    };
    return CompactPeoplePickerBase;
}(BasePeoplePicker));

/**
 * MemberList layout. The selected people show up below the search box.
 * {@docCategory PeoplePicker}
 */
var ListPeoplePickerBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ListPeoplePickerBase, _super);
    function ListPeoplePickerBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /** Default props for ListPeoplePicker. */
    ListPeoplePickerBase.defaultProps = {
        onRenderItem: function (props) { return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__PeoplePickerItems_PeoplePickerItem__["a" /* PeoplePickerItem */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, props)); },
        onRenderSuggestionsItem: function (personaProps, suggestionsProps) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__PeoplePickerItems_PeoplePickerItemSuggestion__["a" /* PeoplePickerItemSuggestion */], { personaProps: personaProps, suggestionsProps: suggestionsProps })); },
        createGenericItem: createGenericItem
    };
    return ListPeoplePickerBase;
}(MemberListPeoplePicker));

/**
 * {@docCategory PeoplePicker}
 */
function createGenericItem(name, currentValidationState) {
    var personaToConvert = {
        key: name,
        primaryText: name,
        imageInitials: '!',
        ValidationState: currentValidationState
    };
    if (currentValidationState !== __WEBPACK_IMPORTED_MODULE_4__BasePicker_types__["a" /* ValidationState */].warning) {
        personaToConvert.imageInitials = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["O" /* getInitials */])(name, Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["V" /* getRTL */])());
    }
    return personaToConvert;
}
var NormalPeoplePicker = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_29" /* styled */])(NormalPeoplePickerBase, __WEBPACK_IMPORTED_MODULE_7__BasePicker_styles__["a" /* getStyles */], undefined, {
    scope: 'NormalPeoplePicker'
});
var CompactPeoplePicker = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_29" /* styled */])(CompactPeoplePickerBase, __WEBPACK_IMPORTED_MODULE_7__BasePicker_styles__["a" /* getStyles */], undefined, {
    scope: 'CompactPeoplePicker'
});
var ListPeoplePicker = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_29" /* styled */])(ListPeoplePickerBase, __WEBPACK_IMPORTED_MODULE_7__BasePicker_styles__["a" /* getStyles */], undefined, {
    scope: 'ListPeoplePickerBase'
});
//# sourceMappingURL=PeoplePicker.js.map

/***/ }),
/* 1936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStyles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Button_BaseButton_classNames__ = __webpack_require__(412);


var GlobalClassNames = {
    root: 'ms-PickerPersona-container',
    itemContent: 'ms-PickerItem-content',
    removeButton: 'ms-PickerItem-removeButton',
    isSelected: 'is-selected',
    isInvalid: 'is-invalid'
};
var REMOVE_BUTTON_SIZE = 24;
function getStyles(props) {
    var className = props.className, theme = props.theme, selected = props.selected, invalid = props.invalid, disabled = props.disabled;
    var palette = theme.palette, semanticColors = theme.semanticColors;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    var personaPrimaryTextStyles = [
        selected &&
            !invalid &&
            !disabled && {
            color: palette.white,
            selectors: (_a = {},
                _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                    color: 'HighlightText'
                },
                _a)
        },
        ((invalid && !selected) || (invalid && selected && disabled)) && {
            color: palette.redDark,
            borderBottom: "2px dotted " + palette.redDark,
            selectors: {
                '$root:hover &': {
                    // override Persona root:hover selector
                    color: palette.redDark
                }
            }
        },
        invalid &&
            selected &&
            !disabled && {
            color: palette.white,
            borderBottom: "2px dotted " + palette.white
        },
        disabled && {
            selectors: (_b = {},
                _b[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                    color: 'GrayText'
                },
                _b)
        }
    ];
    var personaCoinInitialsStyles = [
        invalid && {
            fontSize: 20 // does not exist on the FontSizes type ramp.
        }
    ];
    return {
        root: [
            classNames.root,
            Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["v" /* getFocusStyle */])(theme, { inset: -2 }),
            {
                borderRadius: 15,
                display: 'inline-flex',
                alignItems: 'center',
                background: palette.neutralLighter,
                margin: '1px 2px',
                cursor: 'default',
                userSelect: 'none',
                maxWidth: 300,
                verticalAlign: 'middle',
                minWidth: 0,
                selectors: (_c = {
                        ':hover': {
                            background: !selected && !disabled ? palette.neutralLight : ''
                        }
                    },
                    _c[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = [{ border: '1px solid WindowText' }, disabled && { borderColor: 'GrayText' }],
                    _c)
            },
            selected &&
                !disabled && [
                classNames.isSelected,
                {
                    background: palette.themePrimary,
                    selectors: (_d = {},
                        _d[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                            borderColor: 'HighLight',
                            background: 'Highlight',
                            MsHighContrastAdjust: 'none'
                        },
                        _d)
                }
            ],
            invalid && [classNames.isInvalid],
            invalid &&
                selected &&
                !disabled && {
                background: palette.redDark
            },
            className
        ],
        itemContent: [
            classNames.itemContent,
            {
                flex: '0 1 auto',
                minWidth: 0,
                // CSS below is needed for IE 11 to properly truncate long persona names in the picker
                // and to clip the presence indicator (in all browsers)
                maxWidth: '100%',
                overflow: 'hidden'
            }
        ],
        removeButton: [
            classNames.removeButton,
            {
                borderRadius: 15,
                flex: '0 0 auto',
                width: REMOVE_BUTTON_SIZE,
                height: REMOVE_BUTTON_SIZE,
                flexBasis: REMOVE_BUTTON_SIZE,
                selectors: {
                    ':hover': {
                        background: palette.neutralTertiaryAlt,
                        color: palette.neutralDark
                    }
                }
            },
            selected && [
                {
                    color: palette.white,
                    selectors: (_e = {
                            ':hover': {
                                color: palette.white,
                                background: palette.themeDark
                            }
                        },
                        _e[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                            color: 'HighlightText'
                        },
                        _e)
                },
                invalid && {
                    selectors: {
                        ':hover': {
                            background: palette.red
                        }
                    }
                }
            ],
            disabled && {
                selectors: (_f = {},
                    _f["." + __WEBPACK_IMPORTED_MODULE_1__Button_BaseButton_classNames__["a" /* ButtonGlobalClassNames */].msButtonIcon] = {
                        color: semanticColors.buttonText
                    },
                    _f)
            }
        ],
        subComponentStyles: {
            persona: {
                primaryText: personaPrimaryTextStyles
            },
            personaCoin: {
                initials: personaCoinInitialsStyles
            }
        }
    };
    var _a, _b, _c, _d, _e, _f;
}
//# sourceMappingURL=PeoplePickerItem.styles.js.map

/***/ }),
/* 1937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStyles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Suggestions_SuggestionsItem_styles__ = __webpack_require__(775);


var GlobalClassNames = {
    root: 'ms-PeoplePicker-personaContent',
    personaWrapper: 'ms-PeoplePicker-Persona'
};
function getStyles(props) {
    var className = props.className, theme = props.theme;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    var textSelectorsStyles = {
        selectors: (_a = {},
            _a["." + __WEBPACK_IMPORTED_MODULE_1__Suggestions_SuggestionsItem_styles__["a" /* SuggestionsItemGlobalClassNames */].isSuggested + " &"] = {
                selectors: (_b = {},
                    _b[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        color: 'HighlightText'
                    },
                    _b)
            },
            _a["." + classNames.root + ":hover &"] = {
                selectors: (_c = {},
                    _c[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        color: 'HighlightText'
                    },
                    _c)
            },
            _a)
    };
    return {
        root: [
            classNames.root,
            {
                width: '100%',
                padding: '4px 12px'
            },
            className
        ],
        personaWrapper: [
            classNames.personaWrapper,
            {
                width: 180
            }
        ],
        subComponentStyles: {
            persona: {
                primaryText: textSelectorsStyles,
                secondaryText: textSelectorsStyles
            }
        }
    };
    var _a, _b, _c;
}
//# sourceMappingURL=PeoplePickerItemSuggestion.styles.js.map

/***/ }),
/* 1938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TagPickerBase */
/* unused harmony export TagPicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BasePicker__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BasePicker_styles__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TagItem__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TagItemSuggestion__ = __webpack_require__(781);

/* tslint:disable */

/* tslint:enable */





/**
 * {@docCategory TagPicker}
 */
var TagPickerBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](TagPickerBase, _super);
    function TagPickerBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TagPickerBase.defaultProps = {
        onRenderItem: function (props) { return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__TagItem__["a" /* TagItem */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, props), props.item.name); },
        onRenderSuggestionsItem: function (props) { return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__TagItemSuggestion__["a" /* TagItemSuggestion */], null, props.name); }
    };
    return TagPickerBase;
}(__WEBPACK_IMPORTED_MODULE_3__BasePicker__["a" /* BasePicker */]));

var TagPicker = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_29" /* styled */])(TagPickerBase, __WEBPACK_IMPORTED_MODULE_4__BasePicker_styles__["a" /* getStyles */], undefined, {
    scope: 'TagPicker'
});
//# sourceMappingURL=TagPicker.js.map

/***/ }),
/* 1939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStyles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Button_BaseButton_classNames__ = __webpack_require__(412);


var GlobalClassNames = {
    root: 'ms-TagItem',
    text: 'ms-TagItem-text',
    close: 'ms-TagItem-close',
    isSelected: 'is-selected'
};
var TAG_HEIGHT = 26;
function getStyles(props) {
    var className = props.className, theme = props.theme, selected = props.selected, disabled = props.disabled;
    var palette = theme.palette;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["v" /* getFocusStyle */])(theme),
            {
                boxSizing: 'content-box',
                flexShrink: '1',
                margin: 2,
                height: TAG_HEIGHT,
                lineHeight: TAG_HEIGHT,
                cursor: 'default',
                userSelect: 'none',
                display: 'flex',
                flexWrap: 'nowrap',
                maxWidth: 300,
                background: !selected || disabled ? palette.neutralLighter : palette.themePrimary,
                selectors: (_a = {
                        ':hover': [
                            !disabled &&
                                !selected && {
                                background: palette.neutralLight,
                                selectors: {
                                    '.ms-TagItem-close': {
                                        color: palette.neutralPrimary
                                    }
                                }
                            },
                            disabled && { background: palette.neutralLighter },
                            selected && !disabled && { background: palette.themePrimary }
                        ]
                    },
                    _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        border: "1px solid " + (!selected ? 'WindowText' : 'WindowFrame')
                    },
                    _a)
            },
            disabled && {
                selectors: (_b = {},
                    _b[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        borderColor: 'GrayText'
                    },
                    _b)
            },
            selected &&
                !disabled && [
                classNames.isSelected,
                {
                    color: palette.white
                }
            ],
            className
        ],
        text: [
            classNames.text,
            {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                minWidth: 30,
                margin: '0 8px'
            },
            disabled && {
                selectors: (_c = {},
                    _c[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        color: 'GrayText'
                    },
                    _c)
            }
        ],
        close: [
            classNames.close,
            {
                color: palette.neutralSecondary,
                width: 30,
                height: '100%',
                flex: '0 0 auto',
                selectors: {
                    ':hover': {
                        background: palette.neutralQuaternaryAlt,
                        color: palette.neutralPrimary
                    }
                }
            },
            selected && {
                color: palette.white,
                selectors: (_d = {
                        ':hover': {
                            color: palette.white,
                            background: palette.themeDark
                        }
                    },
                    _d[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        color: 'HighlightText'
                    },
                    _d)
            },
            disabled && {
                selectors: (_e = {},
                    _e["." + __WEBPACK_IMPORTED_MODULE_1__Button_BaseButton_classNames__["a" /* ButtonGlobalClassNames */].msButtonIcon] = {
                        color: palette.neutralSecondary
                    },
                    _e)
            }
        ]
    };
    var _a, _b, _c, _d, _e;
}
//# sourceMappingURL=TagItem.styles.js.map

/***/ }),
/* 1940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStyles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var GlobalClassNames = {
    suggestionTextOverflow: 'ms-TagItem-TextOverflow'
};
function getStyles(props) {
    var className = props.className, theme = props.theme;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    return {
        suggestionTextOverflow: [
            classNames.suggestionTextOverflow,
            {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '60vw',
                padding: '6px 12px 7px',
                whiteSpace: 'nowrap'
            },
            className
        ]
    };
}
//# sourceMappingURL=TagItemSuggestion.styles.js.map

/***/ }),
/* 1941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "suggestionsContainer", function() { return suggestionsContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_load_themed_styles__ = __webpack_require__(67);
/* tslint:disable */

Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_load_themed_styles__["a" /* loadStyles */])([{ "rawString": ".suggestionsContainer_54c57b9b{overflow-y:auto;overflow-x:hidden;max-height:300px}.suggestionsContainer_54c57b9b .ms-Suggestion-item:hover{background-color:" }, { "theme": "neutralLighter", "defaultValue": "#f4f4f4" }, { "rawString": ";cursor:pointer}.suggestionsContainer_54c57b9b .is-suggested{background-color:" }, { "theme": "themeLighter", "defaultValue": "#deecf9" }, { "rawString": "}.suggestionsContainer_54c57b9b .is-suggested:hover{background-color:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": ";cursor:pointer}\n" }]);
var suggestionsContainer = "suggestionsContainer_54c57b9b";
//# sourceMappingURL=SuggestionsCore.scss.js.map

/***/ }),
/* 1942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "root", function() { return root; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actionButton", function() { return actionButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "buttonSelected", function() { return buttonSelected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "suggestionsTitle", function() { return suggestionsTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "suggestionsSpinner", function() { return suggestionsSpinner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "itemButton", function() { return itemButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "screenReaderOnly", function() { return screenReaderOnly; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_load_themed_styles__ = __webpack_require__(67);
/* tslint:disable */

Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_load_themed_styles__["a" /* loadStyles */])([{ "rawString": ".root_084d4d9e{min-width:260px}.actionButton_084d4d9e{background:none;background-color:transparent;border:0;cursor:pointer;margin:0;padding:0px;position:relative;width:100%;font-size:12px}html[dir='ltr'] .actionButton_084d4d9e{text-align:left}html[dir='rtl'] .actionButton_084d4d9e{text-align:right}.actionButton_084d4d9e:hover{background-color:" }, { "theme": "neutralLighter", "defaultValue": "#f4f4f4" }, { "rawString": ";cursor:pointer}.actionButton_084d4d9e:focus,.actionButton_084d4d9e:active{background-color:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": "}.actionButton_084d4d9e .ms-Button-icon{font-size:16px;width:25px}.actionButton_084d4d9e .ms-Button-label{margin:0 4px 0 9px}html[dir='rtl'] .actionButton_084d4d9e .ms-Button-label{margin:0 9px 0 4px}.buttonSelected_084d4d9e{background-color:" }, { "theme": "themeLighter", "defaultValue": "#deecf9" }, { "rawString": "}.buttonSelected_084d4d9e:hover{background-color:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": ";cursor:pointer}.suggestionsTitle_084d4d9e{font-size:12px}.suggestionsSpinner_084d4d9e{margin:5px 0;white-space:nowrap;line-height:20px;font-size:12px}html[dir='ltr'] .suggestionsSpinner_084d4d9e{padding-left:14px}html[dir='rtl'] .suggestionsSpinner_084d4d9e{padding-right:14px}html[dir='ltr'] .suggestionsSpinner_084d4d9e{text-align:left}html[dir='rtl'] .suggestionsSpinner_084d4d9e{text-align:right}.suggestionsSpinner_084d4d9e .ms-Spinner-circle{display:inline-block;vertical-align:middle}.suggestionsSpinner_084d4d9e .ms-Spinner-label{display:inline-block;margin:0px 10px 0 16px;vertical-align:middle}html[dir='rtl'] .suggestionsSpinner_084d4d9e .ms-Spinner-label{margin:0px 16px 0 10px}.itemButton_084d4d9e{height:100%;width:100%;padding:7px 12px}@media screen and (-ms-high-contrast: active){.itemButton_084d4d9e{color:WindowText}}.screenReaderOnly_084d4d9e{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);border:0}\n" }]);
var root = "root_084d4d9e";
var actionButton = "actionButton_084d4d9e";
var buttonSelected = "buttonSelected_084d4d9e";
var suggestionsTitle = "suggestionsTitle_084d4d9e";
var suggestionsSpinner = "suggestionsSpinner_084d4d9e";
var itemButton = "itemButton_084d4d9e";
var screenReaderOnly = "screenReaderOnly_084d4d9e";
//# sourceMappingURL=SuggestionsControl.scss.js.map

/***/ }),
/* 1943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BaseFloatingPeoplePicker */
/* unused harmony export FloatingPeoplePicker */
/* unused harmony export createItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseFloatingPicker__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PeoplePickerItems_SuggestionItemDefault__ = __webpack_require__(1944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PeoplePicker_scss__ = __webpack_require__(782);





/**
 * {@docCategory FloatingPeoplePicker}
 */
var BaseFloatingPeoplePicker = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](BaseFloatingPeoplePicker, _super);
    function BaseFloatingPeoplePicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BaseFloatingPeoplePicker;
}(__WEBPACK_IMPORTED_MODULE_2__BaseFloatingPicker__["a" /* BaseFloatingPicker */]));

var FloatingPeoplePicker = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](FloatingPeoplePicker, _super);
    function FloatingPeoplePicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // tslint:disable-next-line:no-any
    FloatingPeoplePicker.defaultProps = {
        onRenderSuggestionsItem: function (props, itemProps) {
            return Object(__WEBPACK_IMPORTED_MODULE_3__PeoplePickerItems_SuggestionItemDefault__["a" /* SuggestionItemNormal */])(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, props), __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, itemProps));
        },
        createGenericItem: createItem
    };
    return FloatingPeoplePicker;
}(BaseFloatingPeoplePicker));

function createItem(name, isValid) {
    // tslint:disable-next-line:no-any
    var personaToConvert = {
        key: name,
        primaryText: name,
        imageInitials: '!',
        isValid: isValid
    };
    if (!isValid) {
        personaToConvert.imageInitials = Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["O" /* getInitials */])(name, Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["V" /* getRTL */])());
    }
    return personaToConvert;
}
//# sourceMappingURL=FloatingPeoplePicker.js.map

/***/ }),
/* 1944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SuggestionItemNormal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Persona__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PeoplePicker_scss__ = __webpack_require__(782);

/* tslint:disable */

/* tslint:enable */



var SuggestionItemNormal = function (personaProps, suggestionItemProps) {
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-PeoplePicker-personaContent', __WEBPACK_IMPORTED_MODULE_4__PeoplePicker_scss__["b" /* peoplePickerPersonaContent */]) },
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Persona__["a" /* Persona */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ presence: personaProps.presence !== undefined ? personaProps.presence : __WEBPACK_IMPORTED_MODULE_3__Persona__["c" /* PersonaPresence */].none, size: __WEBPACK_IMPORTED_MODULE_3__Persona__["d" /* PersonaSize */].size40, className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-PeoplePicker-Persona', __WEBPACK_IMPORTED_MODULE_4__PeoplePicker_scss__["a" /* peoplePickerPersona */]), showSecondaryText: true }, personaProps))));
};
//# sourceMappingURL=SuggestionItemDefault.js.map

/***/ }),
/* 1945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SuggestionsStore */
var SuggestionsStore = /** @class */ (function () {
    function SuggestionsStore(options) {
        var _this = this;
        this._isSuggestionModel = function (value) {
            return value.item !== undefined;
        };
        this._ensureSuggestionModel = function (suggestion) {
            if (_this._isSuggestionModel(suggestion)) {
                return suggestion;
            }
            else {
                return {
                    item: suggestion,
                    selected: false,
                    ariaLabel: _this.getAriaLabel !== undefined
                        ? _this.getAriaLabel(suggestion)
                        : // tslint:disable-next-line:no-any
                            suggestion.name || suggestion.primaryText
                };
            }
        };
        this.suggestions = [];
        this.getAriaLabel = options && options.getAriaLabel;
    }
    SuggestionsStore.prototype.updateSuggestions = function (newSuggestions) {
        if (newSuggestions && newSuggestions.length > 0) {
            this.suggestions = this.convertSuggestionsToSuggestionItems(newSuggestions);
        }
        else {
            this.suggestions = [];
        }
    };
    SuggestionsStore.prototype.getSuggestions = function () {
        return this.suggestions;
    };
    SuggestionsStore.prototype.getSuggestionAtIndex = function (index) {
        return this.suggestions[index];
    };
    SuggestionsStore.prototype.removeSuggestion = function (index) {
        this.suggestions.splice(index, 1);
    };
    SuggestionsStore.prototype.convertSuggestionsToSuggestionItems = function (suggestions) {
        return Array.isArray(suggestions) ? suggestions.map(this._ensureSuggestionModel) : [];
    };
    return SuggestionsStore;
}());

//# sourceMappingURL=SuggestionsStore.js.map

/***/ }),
/* 1946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createComponent__ = __webpack_require__(1947);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createComponent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slots__ = __webpack_require__(783);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__slots__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__slots__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ThemeProvider__ = __webpack_require__(1948);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__version__ = __webpack_require__(1949);




//# sourceMappingURL=index.js.map

/***/ }),
/* 1947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createComponent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__uifabric_styling__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__uifabric_utilities__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__slots__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities__ = __webpack_require__(784);






/**
 * Assembles a higher order component based on the following: styles, theme, view, and state.
 * Imposes a separation of concern and centralizes styling processing to increase ease of use and robustness
 * in how components use and apply styling and theming.
 *
 * Automatically merges and applies themes and styles with theme / styleprops having the highest priority.
 * State component, if provided, is passed in props for processing. Props from state / user are automatically processed
 * and styled before finally being passed to view.
 *
 * State components should contain all stateful behavior and should not generate any JSX, but rather simply call the view prop.
 * Views should simply be stateless pure functions that receive all props needed for rendering their output.
 * State component is optional. If state is not provided, created component is essentially a functional stateless component.
 *
 * @param component - component Component options. See IComponent for more detail.
 */
function createComponent(component) {
    var _a = component.factoryOptions, factoryOptions = _a === void 0 ? {} : _a;
    var defaultProp = factoryOptions.defaultProp;
    var result = function (componentProps) {
        return (
        // TODO: createComponent is also affected by https://github.com/OfficeDev/office-ui-fabric-react/issues/6603
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__uifabric_utilities__["f" /* CustomizerContext */].Consumer, null, function (context) {
            // TODO: this next line is basically saying 'theme' prop will ALWAYS be available from getCustomizations
            //        via ICustomizationProps cast. Is there mechanism that guarantees theme and other request fields will be defined?
            //        is there a static init that guarantees theme will be provided?
            //        what happens if createTheme/loadTheme is not called?
            //        if so, convey through getCustomizations typing keying off fields. can we convey this
            //          all the way from Customizations with something like { { K in fields }: object}? hmm
            //        if not, how does existing "theme!" styles code work without risk of failing (assuming it doesn't fail)?
            // For now cast return value as if theme is always available.
            var settings = _getCustomizations(component.displayName, context, component.fields);
            var renderView = function (viewProps) {
                // The approach here is to allow state components to provide only the props they care about, automatically
                //    merging user props and state props together. This ensures all props are passed properly to view,
                //    including children and styles.
                // TODO: for full 'fields' support, 'rest' props from customizations need to pass onto view.
                //        however, customized props like theme will break snapshots. how is styled not showing theme output in snapshots?
                var mergedProps = viewProps
                    ? __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, componentProps, viewProps) : componentProps;
                var theme = mergedProps.theme || settings.theme;
                var tokens = _resolveTokens(mergedProps, theme, component.tokens, settings.tokens, mergedProps.tokens);
                var styles = _resolveStyles(mergedProps, theme, tokens, component.styles, settings.styles, mergedProps.styles);
                var viewComponentProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, mergedProps, { styles: styles,
                    tokens: tokens, _defaultStyles: styles });
                return component.view(viewComponentProps);
            };
            return component.state ? __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](component.state, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, componentProps, { renderView: renderView })) : renderView();
        }));
    };
    result.displayName = component.displayName;
    // If a shorthand prop is defined, create a factory for the component.
    // TODO: This shouldn't be a concern of createComponent.. factoryOptions should just be forwarded.
    //       Need to weigh creating default factories on component creation vs. memozing them on use in slots.tsx.
    if (defaultProp) {
        result.create = Object(__WEBPACK_IMPORTED_MODULE_4__slots__["a" /* createFactory */])(result, { defaultProp: defaultProp });
    }
    Object(__WEBPACK_IMPORTED_MODULE_5__utilities__["a" /* assign */])(result, component.statics);
    // Later versions of TypeSript should allow us to merge objects in a type safe way and avoid this cast.
    return result;
}
/**
 * Resolve all styles functions with both props and tokens and flatten results along with all styles objects.
 */
function _resolveStyles(props, theme, tokens) {
    var allStyles = [];
    for (var _i = 3; _i < arguments.length; _i++) {
        allStyles[_i - 3] = arguments[_i];
    }
    return __WEBPACK_IMPORTED_MODULE_2__uifabric_styling__["t" /* concatStyleSets */].apply(void 0, allStyles.map(function (styles) {
        return typeof styles === 'function' ? styles(props, theme, tokens) : styles;
    }));
}
/**
 * Resolve all tokens functions with props flatten results along with all tokens objects.
 */
function _resolveTokens(props, theme) {
    var allTokens = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        allTokens[_i - 2] = arguments[_i];
    }
    var tokens = {};
    for (var _a = 0, allTokens_1 = allTokens; _a < allTokens_1.length; _a++) {
        var currentTokens = allTokens_1[_a];
        if (currentTokens) {
            currentTokens = typeof currentTokens === 'function' ? currentTokens(props, theme) : currentTokens;
            if (Array.isArray(currentTokens)) {
                currentTokens = _resolveTokens.apply(void 0, [props, theme].concat(currentTokens));
            }
            __WEBPACK_IMPORTED_MODULE_5__utilities__["a" /* assign */].apply(void 0, [tokens].concat(currentTokens));
        }
    }
    return tokens;
}
/**
 * Helper function for calling Customizations.getSettings falling back to default fields.
 *
 * @param displayName Displayable name for component.
 * @param context React context passed to component containing contextual settings.
 * @param fields Optional list of properties to grab from global store and context.
 */
function _getCustomizations(displayName, context, fields) {
    // TODO: do we want field props? should fields be part of IComponent and used here?
    // TODO: should we centrally define DefaultFields? (not exported from styling)
    // TOOD: tie this array to ICustomizationProps, such that each array element is keyof ICustomizationProps
    var DefaultFields = ['theme', 'styles', 'tokens'];
    return __WEBPACK_IMPORTED_MODULE_3__uifabric_utilities__["d" /* Customizations */].getSettings(fields || DefaultFields, displayName, context.customizations);
}
//# sourceMappingURL=createComponent.js.map

/***/ }),
/* 1948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ThemeProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__uifabric_styling__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__uifabric_utilities__ = __webpack_require__(61);




/**
 * Theme provider is a simplified version of Customizer that activates the appropriate theme data
 * for a given scheme name.
 *
 * @param providers - Injected providers for accessing theme data and providing it via a Customizer component.
 */
var ThemeProvider = function (props) {
    var scheme = props.scheme, theme = props.theme, rest = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __rest */](props, ["scheme", "theme"]);
    // TODO: consider merging implementation with theme-proto, which only stores a reference / scheme name to theme in context
    //        and uses quick global store accessor to trigger change by passing in theme object as child and triggering re-render.
    //        (perf benefits need verification)
    // tslint:disable-next-line:typedef
    var contextTransform = function (context) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__uifabric_styling__["B" /* getThemedContext */])(context, scheme, theme);
    };
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__uifabric_utilities__["e" /* Customizer */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, rest, { contextTransform: contextTransform }));
};
//# sourceMappingURL=ThemeProvider.js.map

/***/ }),
/* 1949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uifabric_set_version__ = __webpack_require__(145);
// @uifabric/foundation@0.8.2
// Do not modify this file, the file is generated as part of publish. The checked in version is a placeholder only.

Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_set_version__["a" /* setVersion */])('@uifabric/foundation', '0.8.2');
//# sourceMappingURL=version.js.map

/***/ }),
/* 1950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_grid_index__ = __webpack_require__(1951);
/* unused harmony namespace reexport */

//# sourceMappingURL=Grid.js.map

/***/ }),
/* 1951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Grid__ = __webpack_require__(785);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GridCell__ = __webpack_require__(786);
/* unused harmony namespace reexport */


//# sourceMappingURL=index.js.map

/***/ }),
/* 1952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GridBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FocusZone__ = __webpack_require__(28);




var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
var GridBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](GridBase, _super);
    function GridBase(props) {
        var _this = _super.call(this, props) || this;
        _this._id = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["N" /* getId */])();
        return _this;
    }
    GridBase.prototype.render = function () {
        var _this = this;
        var _a = this.props, items = _a.items, columnCount = _a.columnCount, onRenderItem = _a.onRenderItem, positionInSet = _a.positionInSet, setSize = _a.setSize, styles = _a.styles;
        var htmlProps = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["R" /* getNativeProps */])(this.props, __WEBPACK_IMPORTED_MODULE_2__Utilities__["_3" /* htmlElementProperties */], ['onBlur, aria-posinset, aria-setsize']);
        var classNames = getClassNames(styles, { theme: this.props.theme });
        // Array to store the cells in the correct row index
        var rowsOfItems = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_31" /* toMatrix */])(items, columnCount);
        var content = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("table", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, htmlProps, { "aria-posinset": positionInSet, "aria-setsize": setSize, id: this._id, role: 'grid', className: classNames.root }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("tbody", null, rowsOfItems.map(function (rows, rowIndex) {
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("tr", { role: 'row', key: _this._id + '-' + rowIndex + '-row' }, rows.map(function (cell, cellIndex) {
                    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("td", { role: 'presentation', key: _this._id + '-' + cellIndex + '-cell', className: classNames.tableCell }, onRenderItem(cell, cellIndex)));
                })));
            }))));
        // Create the table/grid
        return this.props.doNotContainWithinFocusZone ? (content) : (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__FocusZone__["a" /* FocusZone */], { isCircularNavigation: this.props.shouldFocusCircularNavigate, className: classNames.focusedContainer, onBlur: this.props.onBlur }, content));
    };
    return GridBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=Grid.base.js.map

/***/ }),
/* 1953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
var getStyles = function (props) {
    return {
        root: {
            padding: 2,
            outline: 'none'
        },
        tableCell: {
            padding: 0
        }
    };
};
//# sourceMappingURL=Grid.styles.js.map

/***/ }),
/* 1954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_HoverCard_index__ = __webpack_require__(1955);
/* unused harmony namespace reexport */

//# sourceMappingURL=HoverCard.js.map

/***/ }),
/* 1955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HoverCard__ = __webpack_require__(1956);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HoverCard_base__ = __webpack_require__(787);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HoverCard_types__ = __webpack_require__(788);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ExpandingCard__ = __webpack_require__(789);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ExpandingCard_base__ = __webpack_require__(790);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ExpandingCard_types__ = __webpack_require__(438);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PlainCard_PlainCard__ = __webpack_require__(792);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PlainCard_PlainCard_base__ = __webpack_require__(793);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_DirectionalHint__ = __webpack_require__(36);
/* unused harmony namespace reexport */









//# sourceMappingURL=index.js.map

/***/ }),
/* 1956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HoverCard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HoverCard_styles__ = __webpack_require__(1957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HoverCard_base__ = __webpack_require__(787);



var HoverCard = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_2__HoverCard_base__["a" /* HoverCardBase */], __WEBPACK_IMPORTED_MODULE_1__HoverCard_styles__["a" /* getStyles */], undefined, {
    scope: 'HoverCard'
});
//# sourceMappingURL=HoverCard.js.map

/***/ }),
/* 1957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStyles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var GlobalClassNames = {
    host: 'ms-HoverCard-host'
};
function getStyles(props) {
    var className = props.className, theme = props.theme;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    return {
        host: [classNames.host, className]
    };
}
//# sourceMappingURL=HoverCard.styles.js.map

/***/ }),
/* 1958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStyles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var GlobalClassNames = {
    root: 'ms-ExpandingCard-root',
    compactCard: 'ms-ExpandingCard-compactCard',
    expandedCard: 'ms-ExpandingCard-expandedCard',
    expandedCardScroll: 'ms-ExpandingCard-expandedCardScrollRegion'
};
function getStyles(props) {
    var theme = props.theme, needsScroll = props.needsScroll, expandedCardFirstFrameRendered = props.expandedCardFirstFrameRendered, compactCardHeight = props.compactCardHeight, expandedCardHeight = props.expandedCardHeight, className = props.className;
    var palette = theme.palette;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            {
                width: '340px',
                pointerEvents: 'none',
                boxShadow: '0 0 20px rgba(0, 0, 0, .2)',
                border: 'none',
                selectors: (_a = {},
                    _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        border: '1px solid WindowText'
                    },
                    _a)
            },
            className
        ],
        compactCard: [
            classNames.compactCard,
            {
                pointerEvents: 'auto',
                position: 'relative',
                height: compactCardHeight
            }
        ],
        expandedCard: [
            classNames.expandedCard,
            {
                height: '1px',
                overflowY: 'hidden',
                pointerEvents: 'auto',
                transition: 'height 0.467s cubic-bezier(0.5, 0, 0, 1)',
                selectors: {
                    ':before': {
                        content: '""',
                        position: 'relative',
                        display: 'block',
                        top: '0',
                        left: '24px',
                        width: '292px',
                        height: '1px',
                        backgroundColor: palette.neutralLighter
                    }
                }
            },
            expandedCardFirstFrameRendered && {
                height: expandedCardHeight
            }
        ],
        expandedCardScroll: [
            classNames.expandedCardScroll,
            needsScroll && {
                height: '100%',
                boxSizing: 'border-box',
                overflowY: 'auto'
            }
        ]
    };
    var _a;
}
//# sourceMappingURL=ExpandingCard.styles.js.map

/***/ }),
/* 1959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStyles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var GlobalClassNames = {
    root: 'ms-PlainCard-root'
};
function getStyles(props) {
    var theme = props.theme, className = props.className;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            {
                pointerEvents: 'auto',
                boxShadow: '0 0 20px rgba(0, 0, 0, .2)',
                border: 'none',
                selectors: (_a = {},
                    _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        border: '1px solid WindowText'
                    },
                    _a)
            },
            className
        ]
    };
    var _a;
}
//# sourceMappingURL=PlainCard.styles.js.map

/***/ }),
/* 1960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uifabric_icons__ = __webpack_require__(794);
/* unused harmony namespace reexport */

//# sourceMappingURL=Icons.js.map

/***/ }),
/* 1961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initializeIcons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uifabric_styling__ = __webpack_require__(22);
// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
// tslint:disable:max-line-length

function initializeIcons(baseUrl, options) {
    if (baseUrl === void 0) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons\"",
            src: "url('" + baseUrl + "fabric-icons-a13498cf.woff') format('woff')"
        },
        icons: {
            GlobalNavButton: '\uE700',
            ChevronDown: '\uE70D',
            ChevronUp: '\uE70E',
            Edit: '\uE70F',
            Add: '\uE710',
            Cancel: '\uE711',
            More: '\uE712',
            Settings: '\uE713',
            Mail: '\uE715',
            Filter: '\uE71C',
            Search: '\uE721',
            Share: '\uE72D',
            BlockedSite: '\uE72F',
            FavoriteStar: '\uE734',
            FavoriteStarFill: '\uE735',
            CheckMark: '\uE73E',
            Delete: '\uE74D',
            ChevronLeft: '\uE76B',
            ChevronRight: '\uE76C',
            Calendar: '\uE787',
            Megaphone: '\uE789',
            Undo: '\uE7A7',
            Flag: '\uE7C1',
            Page: '\uE7C3',
            Pinned: '\uE840',
            View: '\uE890',
            Clear: '\uE894',
            Download: '\uE896',
            Upload: '\uE898',
            Folder: '\uE8B7',
            Sort: '\uE8CB',
            AlignRight: '\uE8E2',
            AlignLeft: '\uE8E4',
            Tag: '\uE8EC',
            AddFriend: '\uE8FA',
            Info: '\uE946',
            SortLines: '\uE9D0',
            List: '\uEA37',
            CircleRing: '\uEA3A',
            Heart: '\uEB51',
            HeartFill: '\uEB52',
            Tiles: '\uECA5',
            Embed: '\uECCE',
            Glimmer: '\uECF4',
            Ascending: '\uEDC0',
            Descending: '\uEDC1',
            SortUp: '\uEE68',
            SortDown: '\uEE69',
            SyncToPC: '\uEE6E',
            LargeGrid: '\uEECB',
            SkypeCheck: '\uEF80',
            SkypeClock: '\uEF81',
            SkypeMinus: '\uEF82',
            ClearFilter: '\uEF8F',
            Flow: '\uEF90',
            StatusCircleCheckmark: '\uF13E',
            MoreVertical: '\uF2BC'
        }
    };
    Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_styling__["K" /* registerIcons */])(subset, options);
}
//# sourceMappingURL=fabric-icons.js.map

/***/ }),
/* 1962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initializeIcons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uifabric_styling__ = __webpack_require__(22);
// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
// tslint:disable:max-line-length

function initializeIcons(baseUrl, options) {
    if (baseUrl === void 0) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-0\"",
            src: "url('" + baseUrl + "fabric-icons-0-2a8db1f5.woff') format('woff')"
        },
        icons: {
            InternetSharing: '\uE704',
            Brightness: '\uE706',
            MapPin: '\uE707',
            Airplane: '\uE709',
            Tablet: '\uE70A',
            QuickNote: '\uE70B',
            Video: '\uE714',
            People: '\uE716',
            Phone: '\uE717',
            Pin: '\uE718',
            Shop: '\uE719',
            Stop: '\uE71A',
            Link: '\uE71B',
            AllApps: '\uE71D',
            Zoom: '\uE71E',
            ZoomOut: '\uE71F',
            Microphone: '\uE720',
            Camera: '\uE722',
            Attach: '\uE723',
            Send: '\uE724',
            FavoriteList: '\uE728',
            PageSolid: '\uE729',
            Forward: '\uE72A',
            Back: '\uE72B',
            Refresh: '\uE72C',
            Lock: '\uE72E',
            ReportHacked: '\uE730',
            EMI: '\uE731',
            MiniLink: '\uE732',
            Blocked: '\uE733',
            ReadingMode: '\uE736',
            Favicon: '\uE737',
            Remove: '\uE738',
            Checkbox: '\uE739',
            CheckboxComposite: '\uE73A',
            CheckboxFill: '\uE73B',
            CheckboxIndeterminate: '\uE73C',
            CheckboxCompositeReversed: '\uE73D',
            BackToWindow: '\uE73F',
            FullScreen: '\uE740',
            Print: '\uE749',
            Up: '\uE74A',
            Down: '\uE74B',
            OEM: '\uE74C',
            Save: '\uE74E',
            ReturnKey: '\uE751',
            Cloud: '\uE753',
            Flashlight: '\uE754',
            CommandPrompt: '\uE756',
            Sad: '\uE757',
            RealEstate: '\uE758',
            SIPMove: '\uE759',
            EraseTool: '\uE75C',
            GripperTool: '\uE75E',
            Dialpad: '\uE75F',
            PageLeft: '\uE760',
            PageRight: '\uE761',
            MultiSelect: '\uE762',
            KeyboardClassic: '\uE765',
            Play: '\uE768',
            Pause: '\uE769',
            InkingTool: '\uE76D',
            Emoji2: '\uE76E',
            GripperBarHorizontal: '\uE76F',
            System: '\uE770',
            Personalize: '\uE771',
            SearchAndApps: '\uE773',
            Globe: '\uE774',
            EaseOfAccess: '\uE776',
            ContactInfo: '\uE779',
            Unpin: '\uE77A',
            Contact: '\uE77B',
            Memo: '\uE77C',
            IncomingCall: '\uE77E',
            Paste: '\uE77F',
            WindowsLogo: '\uE782',
            Error: '\uE783',
            GripperBarVertical: '\uE784',
            Unlock: '\uE785',
            Slideshow: '\uE786',
            AutoEnhanceOn: '\uE78D',
            AutoEnhanceOff: '\uE78E',
            Color: '\uE790',
            SaveAs: '\uE792',
            Light: '\uE793',
            Filters: '\uE795',
            AspectRatio: '\uE799',
            Contrast: '\uE7A1',
            Redo: '\uE7A6',
            Crop: '\uE7A8',
            PhotoCollection: '\uE7AA',
            Album: '\uE7AB',
            Rotate: '\uE7AD',
            PanoIndicator: '\uE7B0',
            Translate: '\uE7B2',
            RedEye: '\uE7B3',
            ThumbnailView: '\uE7B6',
            Package: '\uE7B8',
            Telemarketer: '\uE7B9',
            Warning: '\uE7BA'
        }
    };
    Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_styling__["K" /* registerIcons */])(subset, options);
}
//# sourceMappingURL=fabric-icons-0.js.map

/***/ }),
/* 1963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initializeIcons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uifabric_styling__ = __webpack_require__(22);
// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
// tslint:disable:max-line-length

function initializeIcons(baseUrl, options) {
    if (baseUrl === void 0) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-1\"",
            src: "url('" + baseUrl + "fabric-icons-1-360e3054.woff') format('woff')"
        },
        icons: {
            Financial: '\uE7BB',
            Education: '\uE7BE',
            ShoppingCart: '\uE7BF',
            Train: '\uE7C0',
            Move: '\uE7C2',
            TouchPointer: '\uE7C9',
            Merge: '\uE7D5',
            TurnRight: '\uE7DB',
            Ferry: '\uE7E3',
            Highlight: '\uE7E6',
            PowerButton: '\uE7E8',
            Tab: '\uE7E9',
            Admin: '\uE7EF',
            TVMonitor: '\uE7F4',
            Speakers: '\uE7F5',
            Game: '\uE7FC',
            UnstackSelected: '\uE7FE',
            StackIndicator: '\uE7FF',
            Nav2DMapView: '\uE800',
            StreetsideSplitMinimize: '\uE802',
            Car: '\uE804',
            Bus: '\uE806',
            EatDrink: '\uE807',
            SeeDo: '\uE808',
            LocationCircle: '\uE80E',
            Home: '\uE80F',
            SwitcherStartEnd: '\uE810',
            ParkingLocation: '\uE811',
            IncidentTriangle: '\uE814',
            Touch: '\uE815',
            MapDirections: '\uE816',
            CaretHollow: '\uE817',
            CaretSolid: '\uE818',
            History: '\uE81C',
            Location: '\uE81D',
            MapLayers: '\uE81E',
            SearchNearby: '\uE820',
            Work: '\uE821',
            Recent: '\uE823',
            Hotel: '\uE824',
            Bank: '\uE825',
            LocationDot: '\uE827',
            Dictionary: '\uE82D',
            ChromeBack: '\uE830',
            FolderOpen: '\uE838',
            PinnedFill: '\uE842',
            RevToggleKey: '\uE845',
            USB: '\uE88E',
            Previous: '\uE892',
            Next: '\uE893',
            Sync: '\uE895',
            Help: '\uE897',
            Emoji: '\uE899',
            MailForward: '\uE89C',
            ClosePane: '\uE89F',
            OpenPane: '\uE8A0',
            PreviewLink: '\uE8A1',
            ZoomIn: '\uE8A3',
            Bookmarks: '\uE8A4',
            Document: '\uE8A5',
            ProtectedDocument: '\uE8A6',
            OpenInNewWindow: '\uE8A7',
            MailFill: '\uE8A8',
            ViewAll: '\uE8A9',
            Switch: '\uE8AB',
            Rename: '\uE8AC',
            Go: '\uE8AD',
            Remote: '\uE8AF',
            SelectAll: '\uE8B3',
            Orientation: '\uE8B4',
            Import: '\uE8B5',
            Picture: '\uE8B9',
            ChromeClose: '\uE8BB',
            ShowResults: '\uE8BC',
            Message: '\uE8BD',
            CalendarDay: '\uE8BF',
            CalendarWeek: '\uE8C0',
            MailReplyAll: '\uE8C2',
            Read: '\uE8C3',
            Cut: '\uE8C6',
            PaymentCard: '\uE8C7',
            Copy: '\uE8C8',
            Important: '\uE8C9',
            MailReply: '\uE8CA',
            GotoToday: '\uE8D1',
            Font: '\uE8D2',
            FontColor: '\uE8D3',
            FolderFill: '\uE8D5',
            Permissions: '\uE8D7',
            DisableUpdates: '\uE8D8',
            Unfavorite: '\uE8D9',
            Italic: '\uE8DB',
            Underline: '\uE8DC',
            Bold: '\uE8DD',
            MoveToFolder: '\uE8DE',
            Dislike: '\uE8E0',
            Like: '\uE8E1',
            AlignCenter: '\uE8E3',
            OpenFile: '\uE8E5',
            FontDecrease: '\uE8E7'
        }
    };
    Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_styling__["K" /* registerIcons */])(subset, options);
}
//# sourceMappingURL=fabric-icons-1.js.map

/***/ }),
/* 1964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initializeIcons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uifabric_styling__ = __webpack_require__(22);
// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
// tslint:disable:max-line-length

function initializeIcons(baseUrl, options) {
    if (baseUrl === void 0) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-2\"",
            src: "url('" + baseUrl + "fabric-icons-2-8820ef0b.woff') format('woff')"
        },
        icons: {
            FontIncrease: '\uE8E8',
            FontSize: '\uE8E9',
            CellPhone: '\uE8EA',
            RepeatOne: '\uE8ED',
            RepeatAll: '\uE8EE',
            Calculator: '\uE8EF',
            Library: '\uE8F1',
            PostUpdate: '\uE8F3',
            NewFolder: '\uE8F4',
            CalendarReply: '\uE8F5',
            UnsyncFolder: '\uE8F6',
            SyncFolder: '\uE8F7',
            BlockContact: '\uE8F8',
            Accept: '\uE8FB',
            BulletedList: '\uE8FD',
            Preview: '\uE8FF',
            News: '\uE900',
            Chat: '\uE901',
            Group: '\uE902',
            World: '\uE909',
            Comment: '\uE90A',
            DockLeft: '\uE90C',
            DockRight: '\uE90D',
            Repair: '\uE90F',
            Accounts: '\uE910',
            Street: '\uE913',
            RadioBullet: '\uE915',
            Stopwatch: '\uE916',
            Clock: '\uE917',
            WorldClock: '\uE918',
            AlarmClock: '\uE919',
            Photo: '\uE91B',
            ActionCenter: '\uE91C',
            Hospital: '\uE91D',
            Timer: '\uE91E',
            FullCircleMask: '\uE91F',
            LocationFill: '\uE920',
            ChromeMinimize: '\uE921',
            ChromeRestore: '\uE923',
            Annotation: '\uE924',
            Fingerprint: '\uE928',
            Handwriting: '\uE929',
            ChromeFullScreen: '\uE92D',
            Completed: '\uE930',
            Label: '\uE932',
            FlickDown: '\uE935',
            FlickUp: '\uE936',
            FlickLeft: '\uE937',
            FlickRight: '\uE938',
            MiniExpand: '\uE93A',
            MiniContract: '\uE93B',
            Streaming: '\uE93E',
            MusicInCollection: '\uE940',
            OneDriveLogo: '\uE941',
            CompassNW: '\uE942',
            Code: '\uE943',
            LightningBolt: '\uE945',
            CalculatorMultiply: '\uE947',
            CalculatorAddition: '\uE948',
            CalculatorSubtract: '\uE949',
            CalculatorPercentage: '\uE94C',
            CalculatorEqualTo: '\uE94E',
            PrintfaxPrinterFile: '\uE956',
            StorageOptical: '\uE958',
            Communications: '\uE95A',
            Headset: '\uE95B',
            Health: '\uE95E',
            FrontCamera: '\uE96B',
            ChevronUpSmall: '\uE96D',
            ChevronDownSmall: '\uE96E',
            ChevronLeftSmall: '\uE96F',
            ChevronRightSmall: '\uE970',
            ChevronUpMed: '\uE971',
            ChevronDownMed: '\uE972',
            ChevronLeftMed: '\uE973',
            ChevronRightMed: '\uE974',
            Devices2: '\uE975',
            PC1: '\uE977',
            PresenceChickletVideo: '\uE979',
            Reply: '\uE97A',
            HalfAlpha: '\uE97E',
            ConstructionCone: '\uE98F',
            DoubleChevronLeftMed: '\uE991',
            Volume0: '\uE992',
            Volume1: '\uE993',
            Volume2: '\uE994',
            Volume3: '\uE995',
            Chart: '\uE999',
            Robot: '\uE99A',
            Manufacturing: '\uE99C',
            LockSolid: '\uE9A2',
            FitPage: '\uE9A6',
            FitWidth: '\uE9A7',
            BidiLtr: '\uE9AA',
            BidiRtl: '\uE9AB',
            RightDoubleQuote: '\uE9B1',
            Sunny: '\uE9BD',
            CloudWeather: '\uE9BE',
            Cloudy: '\uE9BF',
            PartlyCloudyDay: '\uE9C0'
        }
    };
    Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_styling__["K" /* registerIcons */])(subset, options);
}
//# sourceMappingURL=fabric-icons-2.js.map

/***/ }),
/* 1965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initializeIcons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uifabric_styling__ = __webpack_require__(22);
// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
// tslint:disable:max-line-length

function initializeIcons(baseUrl, options) {
    if (baseUrl === void 0) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-3\"",
            src: "url('" + baseUrl + "fabric-icons-3-7c253e01.woff') format('woff')"
        },
        icons: {
            PartlyCloudyNight: '\uE9C1',
            ClearNight: '\uE9C2',
            RainShowersDay: '\uE9C3',
            Rain: '\uE9C4',
            Thunderstorms: '\uE9C6',
            RainSnow: '\uE9C7',
            Snow: '\uE9C8',
            BlowingSnow: '\uE9C9',
            Frigid: '\uE9CA',
            Fog: '\uE9CB',
            Squalls: '\uE9CC',
            Duststorm: '\uE9CD',
            Unknown: '\uE9CE',
            Precipitation: '\uE9CF',
            Ribbon: '\uE9D1',
            AreaChart: '\uE9D2',
            Assign: '\uE9D3',
            FlowChart: '\uE9D4',
            CheckList: '\uE9D5',
            Diagnostic: '\uE9D9',
            Generate: '\uE9DA',
            LineChart: '\uE9E6',
            Equalizer: '\uE9E9',
            BarChartHorizontal: '\uE9EB',
            BarChartVertical: '\uE9EC',
            Freezing: '\uE9EF',
            FunnelChart: '\uE9F1',
            Processing: '\uE9F5',
            Quantity: '\uE9F8',
            ReportDocument: '\uE9F9',
            StackColumnChart: '\uE9FC',
            SnowShowerDay: '\uE9FD',
            HailDay: '\uEA00',
            WorkFlow: '\uEA01',
            HourGlass: '\uEA03',
            StoreLogoMed20: '\uEA04',
            TimeSheet: '\uEA05',
            TriangleSolid: '\uEA08',
            UpgradeAnalysis: '\uEA0B',
            VideoSolid: '\uEA0C',
            RainShowersNight: '\uEA0F',
            SnowShowerNight: '\uEA11',
            Teamwork: '\uEA12',
            HailNight: '\uEA13',
            PeopleAdd: '\uEA15',
            Glasses: '\uEA16',
            DateTime2: '\uEA17',
            Shield: '\uEA18',
            Header1: '\uEA19',
            PageAdd: '\uEA1A',
            NumberedList: '\uEA1C',
            PowerBILogo: '\uEA1E',
            Info2: '\uEA1F',
            MusicInCollectionFill: '\uEA36',
            Asterisk: '\uEA38',
            ErrorBadge: '\uEA39',
            CircleFill: '\uEA3B',
            Record2: '\uEA3F',
            AllAppsMirrored: '\uEA40',
            BookmarksMirrored: '\uEA41',
            BulletedListMirrored: '\uEA42',
            CaretHollowMirrored: '\uEA45',
            CaretSolidMirrored: '\uEA46',
            ChromeBackMirrored: '\uEA47',
            ClosePaneMirrored: '\uEA49',
            DockLeftMirrored: '\uEA4C',
            DoubleChevronLeftMedMirrored: '\uEA4D',
            GoMirrored: '\uEA4F',
            HelpMirrored: '\uEA51',
            ImportMirrored: '\uEA52',
            ImportAllMirrored: '\uEA53',
            ListMirrored: '\uEA55',
            MailForwardMirrored: '\uEA56',
            MailReplyMirrored: '\uEA57',
            MailReplyAllMirrored: '\uEA58',
            MiniContractMirrored: '\uEA59',
            MiniExpandMirrored: '\uEA5A',
            OpenPaneMirrored: '\uEA5B',
            ParkingLocationMirrored: '\uEA5E',
            SendMirrored: '\uEA63',
            ShowResultsMirrored: '\uEA65',
            ThumbnailViewMirrored: '\uEA67',
            Media: '\uEA69',
            Devices3: '\uEA6C',
            Focus: '\uEA6F',
            VideoLightOff: '\uEA74',
            Lightbulb: '\uEA80',
            StatusTriangle: '\uEA82',
            VolumeDisabled: '\uEA85',
            Puzzle: '\uEA86',
            EmojiNeutral: '\uEA87',
            EmojiDisappointed: '\uEA88',
            HomeSolid: '\uEA8A',
            Ringer: '\uEA8F',
            PDF: '\uEA90',
            HeartBroken: '\uEA92',
            StoreLogo16: '\uEA96',
            MultiSelectMirrored: '\uEA98',
            Broom: '\uEA99',
            Cocktails: '\uEA9D'
        }
    };
    Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_styling__["K" /* registerIcons */])(subset, options);
}
//# sourceMappingURL=fabric-icons-3.js.map

/***/ }),
/* 1966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initializeIcons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uifabric_styling__ = __webpack_require__(22);
// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
// tslint:disable:max-line-length

function initializeIcons(baseUrl, options) {
    if (baseUrl === void 0) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-4\"",
            src: "url('" + baseUrl + "fabric-icons-4-15a649f8.woff') format('woff')"
        },
        icons: {
            Wines: '\uEABF',
            Articles: '\uEAC1',
            Cycling: '\uEAC7',
            DietPlanNotebook: '\uEAC8',
            Pill: '\uEACB',
            ExerciseTracker: '\uEACC',
            HandsFree: '\uEAD0',
            Medical: '\uEAD4',
            Running: '\uEADA',
            Weights: '\uEADB',
            Trackers: '\uEADF',
            AddNotes: '\uEAE3',
            AllCurrency: '\uEAE4',
            BarChart4: '\uEAE7',
            CirclePlus: '\uEAEE',
            Coffee: '\uEAEF',
            Cotton: '\uEAF3',
            Market: '\uEAFC',
            Money: '\uEAFD',
            PieDouble: '\uEB04',
            PieSingle: '\uEB05',
            RemoveFilter: '\uEB08',
            Savings: '\uEB0B',
            Sell: '\uEB0C',
            StockDown: '\uEB0F',
            StockUp: '\uEB11',
            Lamp: '\uEB19',
            Source: '\uEB1B',
            MSNVideos: '\uEB1C',
            Cricket: '\uEB1E',
            Golf: '\uEB1F',
            Baseball: '\uEB20',
            Soccer: '\uEB21',
            MoreSports: '\uEB22',
            AutoRacing: '\uEB24',
            CollegeHoops: '\uEB25',
            CollegeFootball: '\uEB26',
            ProFootball: '\uEB27',
            ProHockey: '\uEB28',
            Rugby: '\uEB2D',
            SubstitutionsIn: '\uEB31',
            Tennis: '\uEB33',
            Arrivals: '\uEB34',
            Design: '\uEB3C',
            Website: '\uEB41',
            Drop: '\uEB42',
            HistoricalWeather: '\uEB43',
            SkiResorts: '\uEB45',
            Snowflake: '\uEB46',
            BusSolid: '\uEB47',
            FerrySolid: '\uEB48',
            AirplaneSolid: '\uEB4C',
            TrainSolid: '\uEB4D',
            Ticket: '\uEB54',
            WifiWarning4: '\uEB63',
            Devices4: '\uEB66',
            AzureLogo: '\uEB6A',
            BingLogo: '\uEB6B',
            MSNLogo: '\uEB6C',
            OutlookLogoInverse: '\uEB6D',
            OfficeLogo: '\uEB6E',
            SkypeLogo: '\uEB6F',
            Door: '\uEB75',
            EditMirrored: '\uEB7E',
            GiftCard: '\uEB8E',
            DoubleBookmark: '\uEB8F',
            StatusErrorFull: '\uEB90',
            Certificate: '\uEB95',
            FastForward: '\uEB9D',
            Rewind: '\uEB9E',
            Photo2: '\uEB9F',
            OpenSource: '\uEBC2',
            Movers: '\uEBCD',
            CloudDownload: '\uEBD3',
            Family: '\uEBDA',
            WindDirection: '\uEBE6',
            Bug: '\uEBE8',
            SiteScan: '\uEBEC',
            BrowserScreenShot: '\uEBED',
            F12DevTools: '\uEBEE',
            CSS: '\uEBEF',
            JS: '\uEBF0',
            DeliveryTruck: '\uEBF4',
            ReminderPerson: '\uEBF7',
            ReminderGroup: '\uEBF8',
            TabletMode: '\uEBFC',
            Umbrella: '\uEC04',
            NetworkTower: '\uEC05',
            CityNext: '\uEC06',
            CityNext2: '\uEC07',
            Section: '\uEC0C',
            OneNoteLogoInverse: '\uEC0D',
            ToggleFilled: '\uEC11',
            ToggleBorder: '\uEC12',
            SliderThumb: '\uEC13',
            ToggleThumb: '\uEC14',
            Documentation: '\uEC17',
            Badge: '\uEC1B',
            Giftbox: '\uEC1F',
            VisualStudioLogo: '\uEC22'
        }
    };
    Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_styling__["K" /* registerIcons */])(subset, options);
}
//# sourceMappingURL=fabric-icons-4.js.map

/***/ }),
/* 1967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initializeIcons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uifabric_styling__ = __webpack_require__(22);
// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
// tslint:disable:max-line-length

function initializeIcons(baseUrl, options) {
    if (baseUrl === void 0) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-5\"",
            src: "url('" + baseUrl + "fabric-icons-5-f6de453a.woff') format('woff')"
        },
        icons: {
            HomeGroup: '\uEC26',
            ExcelLogoInverse: '\uEC28',
            WordLogoInverse: '\uEC29',
            PowerPointLogoInverse: '\uEC2A',
            Cafe: '\uEC32',
            SpeedHigh: '\uEC4A',
            Commitments: '\uEC4D',
            ThisPC: '\uEC4E',
            MusicNote: '\uEC4F',
            MicOff: '\uEC54',
            EdgeLogo: '\uEC60',
            CompletedSolid: '\uEC61',
            AlbumRemove: '\uEC62',
            MessageFill: '\uEC70',
            TabletSelected: '\uEC74',
            MobileSelected: '\uEC75',
            LaptopSelected: '\uEC76',
            TVMonitorSelected: '\uEC77',
            DeveloperTools: '\uEC7A',
            Shapes: '\uEC7C',
            InsertTextBox: '\uEC7D',
            LowerBrightness: '\uEC8A',
            WebComponents: '\uEC8B',
            OfflineStorage: '\uEC8C',
            DOM: '\uEC8D',
            CloudUpload: '\uEC8E',
            ScrollUpDown: '\uEC8F',
            DateTime: '\uEC92',
            Event: '\uECA3',
            Cake: '\uECA4',
            Org: '\uECA6',
            PartyLeader: '\uECA7',
            DRM: '\uECA8',
            CloudAdd: '\uECA9',
            AppIconDefault: '\uECAA',
            Photo2Add: '\uECAB',
            Photo2Remove: '\uECAC',
            POI: '\uECAF',
            AddTo: '\uECC8',
            RadioBtnOff: '\uECCA',
            RadioBtnOn: '\uECCB',
            ExploreContent: '\uECCD',
            Product: '\uECDC',
            ProgressLoopInner: '\uECDE',
            ProgressLoopOuter: '\uECDF',
            Blocked2: '\uECE4',
            FangBody: '\uECEB',
            PageHeader: '\uECEE',
            ChatInviteFriend: '\uECFE',
            Brush: '\uECFF',
            Shirt: '\uED00',
            Crown: '\uED01',
            Diamond: '\uED02',
            ScaleUp: '\uED09',
            QRCode: '\uED14',
            Feedback: '\uED15',
            SharepointLogoInverse: '\uED18',
            YammerLogo: '\uED19',
            Hide: '\uED1A',
            Uneditable: '\uED1D',
            ReturnToSession: '\uED24',
            OpenFolderHorizontal: '\uED25',
            CalendarMirrored: '\uED28',
            SwayLogoInverse: '\uED29',
            OutOfOffice: '\uED34',
            Trophy: '\uED3F',
            ReopenPages: '\uED50',
            EmojiTabSymbols: '\uED58',
            AADLogo: '\uED68',
            AccessLogo: '\uED69',
            AdminALogoInverse32: '\uED6A',
            AdminCLogoInverse32: '\uED6B',
            AdminDLogoInverse32: '\uED6C',
            AdminELogoInverse32: '\uED6D',
            AdminLLogoInverse32: '\uED6E',
            AdminMLogoInverse32: '\uED6F',
            AdminOLogoInverse32: '\uED70',
            AdminPLogoInverse32: '\uED71',
            AdminSLogoInverse32: '\uED72',
            AdminYLogoInverse32: '\uED73',
            DelveLogoInverse: '\uED76',
            ExchangeLogoInverse: '\uED78',
            LyncLogo: '\uED79',
            OfficeVideoLogoInverse: '\uED7A',
            SocialListeningLogo: '\uED7C',
            VisioLogoInverse: '\uED7D',
            Balloons: '\uED7E',
            Cat: '\uED7F',
            MailAlert: '\uED80',
            MailCheck: '\uED81',
            MailLowImportance: '\uED82',
            MailPause: '\uED83',
            MailRepeat: '\uED84',
            SecurityGroup: '\uED85',
            Table: '\uED86',
            VoicemailForward: '\uED87',
            VoicemailReply: '\uED88',
            Waffle: '\uED89',
            RemoveEvent: '\uED8A',
            EventInfo: '\uED8B'
        }
    };
    Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_styling__["K" /* registerIcons */])(subset, options);
}
//# sourceMappingURL=fabric-icons-5.js.map

/***/ }),
/* 1968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initializeIcons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uifabric_styling__ = __webpack_require__(22);
// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
// tslint:disable:max-line-length

function initializeIcons(baseUrl, options) {
    if (baseUrl === void 0) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-6\"",
            src: "url('" + baseUrl + "fabric-icons-6-32b702b9.woff') format('woff')"
        },
        icons: {
            ForwardEvent: '\uED8C',
            WipePhone: '\uED8D',
            AddOnlineMeeting: '\uED8E',
            JoinOnlineMeeting: '\uED8F',
            RemoveLink: '\uED90',
            PeopleBlock: '\uED91',
            PeopleRepeat: '\uED92',
            PeopleAlert: '\uED93',
            PeoplePause: '\uED94',
            TransferCall: '\uED95',
            AddPhone: '\uED96',
            UnknownCall: '\uED97',
            NoteReply: '\uED98',
            NoteForward: '\uED99',
            NotePinned: '\uED9A',
            RemoveOccurrence: '\uED9B',
            Timeline: '\uED9C',
            EditNote: '\uED9D',
            CircleHalfFull: '\uED9E',
            Room: '\uED9F',
            Unsubscribe: '\uEDA0',
            Subscribe: '\uEDA1',
            HardDrive: '\uEDA2',
            RecurringTask: '\uEDB2',
            TaskManager: '\uEDB7',
            TaskManagerMirrored: '\uEDB8',
            Combine: '\uEDBB',
            Split: '\uEDBC',
            DoubleChevronUp: '\uEDBD',
            DoubleChevronLeft: '\uEDBE',
            DoubleChevronRight: '\uEDBF',
            TextBox: '\uEDC2',
            TextField: '\uEDC3',
            NumberField: '\uEDC4',
            Dropdown: '\uEDC5',
            PenWorkspace: '\uEDC6',
            BookingsLogo: '\uEDC7',
            ClassNotebookLogoInverse: '\uEDC8',
            DelveAnalyticsLogo: '\uEDCA',
            DocsLogoInverse: '\uEDCB',
            Dynamics365Logo: '\uEDCC',
            DynamicSMBLogo: '\uEDCD',
            OfficeAssistantLogo: '\uEDCE',
            OfficeStoreLogo: '\uEDCF',
            OneNoteEduLogoInverse: '\uEDD0',
            PlannerLogo: '\uEDD1',
            PowerApps: '\uEDD2',
            Suitcase: '\uEDD3',
            ProjectLogoInverse: '\uEDD4',
            CaretLeft8: '\uEDD5',
            CaretRight8: '\uEDD6',
            CaretUp8: '\uEDD7',
            CaretDown8: '\uEDD8',
            CaretLeftSolid8: '\uEDD9',
            CaretRightSolid8: '\uEDDA',
            CaretUpSolid8: '\uEDDB',
            CaretDownSolid8: '\uEDDC',
            ClearFormatting: '\uEDDD',
            Superscript: '\uEDDE',
            Subscript: '\uEDDF',
            Strikethrough: '\uEDE0',
            Export: '\uEDE1',
            ExportMirrored: '\uEDE2',
            SingleBookmark: '\uEDFF',
            SingleBookmarkSolid: '\uEE00',
            DoubleChevronDown: '\uEE04',
            FollowUser: '\uEE05',
            ReplyAll: '\uEE0A',
            WorkforceManagement: '\uEE0F',
            RecruitmentManagement: '\uEE12',
            Questionnaire: '\uEE19',
            ManagerSelfService: '\uEE23',
            ProductRelease: '\uEE2E',
            ReplyMirrored: '\uEE35',
            ReplyAllMirrored: '\uEE36',
            Medal: '\uEE38',
            AddGroup: '\uEE3D',
            QuestionnaireMirrored: '\uEE4B',
            TemporaryUser: '\uEE58',
            CaretSolid16: '\uEE62',
            GroupedDescending: '\uEE66',
            GroupedAscending: '\uEE67',
            AwayStatus: '\uEE6A',
            MyMoviesTV: '\uEE6C',
            GenericScan: '\uEE6F',
            AustralianRules: '\uEE70',
            WifiEthernet: '\uEE77',
            TrackersMirrored: '\uEE92',
            DateTimeMirrored: '\uEE93',
            StopSolid: '\uEE95',
            DoubleChevronUp12: '\uEE96',
            DoubleChevronDown12: '\uEE97',
            DoubleChevronLeft12: '\uEE98',
            DoubleChevronRight12: '\uEE99',
            CalendarAgenda: '\uEE9A',
            AddEvent: '\uEEB5',
            AssetLibrary: '\uEEB6',
            DataConnectionLibrary: '\uEEB7',
            DocLibrary: '\uEEB8',
            FormLibrary: '\uEEB9'
        }
    };
    Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_styling__["K" /* registerIcons */])(subset, options);
}
//# sourceMappingURL=fabric-icons-6.js.map

/***/ }),
/* 1969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initializeIcons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uifabric_styling__ = __webpack_require__(22);
// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
// tslint:disable:max-line-length

function initializeIcons(baseUrl, options) {
    if (baseUrl === void 0) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-7\"",
            src: "url('" + baseUrl + "fabric-icons-7-bbebf62d.woff') format('woff')"
        },
        icons: {
            FormLibraryMirrored: '\uEEBA',
            ReportLibrary: '\uEEBB',
            ReportLibraryMirrored: '\uEEBC',
            ContactCard: '\uEEBD',
            CustomList: '\uEEBE',
            CustomListMirrored: '\uEEBF',
            IssueTracking: '\uEEC0',
            IssueTrackingMirrored: '\uEEC1',
            PictureLibrary: '\uEEC2',
            OfficeAddinsLogo: '\uEEC7',
            OfflineOneDriveParachute: '\uEEC8',
            OfflineOneDriveParachuteDisabled: '\uEEC9',
            TriangleSolidUp12: '\uEECC',
            TriangleSolidDown12: '\uEECD',
            TriangleSolidLeft12: '\uEECE',
            TriangleSolidRight12: '\uEECF',
            TriangleUp12: '\uEED0',
            TriangleDown12: '\uEED1',
            TriangleLeft12: '\uEED2',
            TriangleRight12: '\uEED3',
            ArrowUpRight8: '\uEED4',
            ArrowDownRight8: '\uEED5',
            DocumentSet: '\uEED6',
            DelveAnalytics: '\uEEEE',
            ArrowUpRightMirrored8: '\uEEEF',
            ArrowDownRightMirrored8: '\uEEF0',
            CompanyDirectory: '\uEF0D',
            OpenEnrollment: '\uEF1C',
            CompanyDirectoryMirrored: '\uEF2B',
            OneDriveAdd: '\uEF32',
            ProfileSearch: '\uEF35',
            Header2: '\uEF36',
            Header3: '\uEF37',
            Header4: '\uEF38',
            RingerSolid: '\uEF3A',
            Eyedropper: '\uEF3C',
            MarketDown: '\uEF42',
            CalendarWorkWeek: '\uEF51',
            SidePanel: '\uEF52',
            GlobeFavorite: '\uEF53',
            CaretTopLeftSolid8: '\uEF54',
            CaretTopRightSolid8: '\uEF55',
            ViewAll2: '\uEF56',
            DocumentReply: '\uEF57',
            PlayerSettings: '\uEF58',
            ReceiptForward: '\uEF59',
            ReceiptReply: '\uEF5A',
            ReceiptCheck: '\uEF5B',
            Fax: '\uEF5C',
            RecurringEvent: '\uEF5D',
            ReplyAlt: '\uEF5E',
            ReplyAllAlt: '\uEF5F',
            EditStyle: '\uEF60',
            EditMail: '\uEF61',
            Lifesaver: '\uEF62',
            LifesaverLock: '\uEF63',
            InboxCheck: '\uEF64',
            FolderSearch: '\uEF65',
            CollapseMenu: '\uEF66',
            ExpandMenu: '\uEF67',
            Boards: '\uEF68',
            SunAdd: '\uEF69',
            SunQuestionMark: '\uEF6A',
            LandscapeOrientation: '\uEF6B',
            DocumentSearch: '\uEF6C',
            PublicCalendar: '\uEF6D',
            PublicContactCard: '\uEF6E',
            PublicEmail: '\uEF6F',
            PublicFolder: '\uEF70',
            WordDocument: '\uEF71',
            PowerPointDocument: '\uEF72',
            ExcelDocument: '\uEF73',
            GroupedList: '\uEF74',
            ClassroomLogo: '\uEF75',
            Sections: '\uEF76',
            EditPhoto: '\uEF77',
            Starburst: '\uEF78',
            ShareiOS: '\uEF79',
            AirTickets: '\uEF7A',
            PencilReply: '\uEF7B',
            Tiles2: '\uEF7C',
            SkypeCircleCheck: '\uEF7D',
            SkypeCircleClock: '\uEF7E',
            SkypeCircleMinus: '\uEF7F',
            SkypeMessage: '\uEF83',
            ClosedCaption: '\uEF84',
            ATPLogo: '\uEF85',
            OfficeFormsLogoInverse: '\uEF86',
            RecycleBin: '\uEF87',
            EmptyRecycleBin: '\uEF88',
            Hide2: '\uEF89',
            Breadcrumb: '\uEF8C',
            BirthdayCake: '\uEF8D',
            TimeEntry: '\uEF95',
            CRMProcesses: '\uEFB1',
            PageEdit: '\uEFB6',
            PageArrowRight: '\uEFB8',
            PageRemove: '\uEFBA',
            Database: '\uEFC7',
            DataManagementSettings: '\uEFC8'
        }
    };
    Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_styling__["K" /* registerIcons */])(subset, options);
}
//# sourceMappingURL=fabric-icons-7.js.map

/***/ }),
/* 1970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initializeIcons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uifabric_styling__ = __webpack_require__(22);
// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
// tslint:disable:max-line-length

function initializeIcons(baseUrl, options) {
    if (baseUrl === void 0) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-8\"",
            src: "url('" + baseUrl + "fabric-icons-8-50fd817c.woff') format('woff')"
        },
        icons: {
            CRMServices: '\uEFD2',
            EditContact: '\uEFD3',
            ConnectContacts: '\uEFD4',
            AppIconDefaultAdd: '\uEFDA',
            AppIconDefaultList: '\uEFDE',
            ActivateOrders: '\uEFE0',
            DeactivateOrders: '\uEFE1',
            DocumentManagement: '\uEFFC',
            CRMReport: '\uEFFE',
            KnowledgeArticle: '\uF000',
            Relationship: '\uF003',
            HomeVerify: '\uF00E',
            ZipFolder: '\uF012',
            SurveyQuestions: '\uF01B',
            TextDocument: '\uF029',
            TextDocumentShared: '\uF02B',
            PageCheckedOut: '\uF02C',
            SaveAndClose: '\uF038',
            Script: '\uF03A',
            Archive: '\uF03F',
            ActivityFeed: '\uF056',
            Compare: '\uF057',
            EventDate: '\uF059',
            ArrowUpRight: '\uF069',
            CaretRight: '\uF06B',
            SetAction: '\uF071',
            CaretSolidLeft: '\uF08D',
            CaretSolidDown: '\uF08E',
            CaretSolidRight: '\uF08F',
            CaretSolidUp: '\uF090',
            PowerAppsLogo: '\uF091',
            PowerApps2Logo: '\uF092',
            SearchIssue: '\uF09A',
            SearchIssueMirrored: '\uF09B',
            FabricAssetLibrary: '\uF09C',
            FabricDataConnectionLibrary: '\uF09D',
            FabricDocLibrary: '\uF09E',
            FabricFormLibrary: '\uF09F',
            FabricFormLibraryMirrored: '\uF0A0',
            FabricReportLibrary: '\uF0A1',
            FabricReportLibraryMirrored: '\uF0A2',
            FabricPublicFolder: '\uF0A3',
            FabricFolderSearch: '\uF0A4',
            FabricMovetoFolder: '\uF0A5',
            FabricUnsyncFolder: '\uF0A6',
            FabricSyncFolder: '\uF0A7',
            FabricOpenFolderHorizontal: '\uF0A8',
            FabricFolder: '\uF0A9',
            FabricFolderFill: '\uF0AA',
            FabricNewFolder: '\uF0AB',
            FabricPictureLibrary: '\uF0AC',
            AddFavorite: '\uF0C8',
            AddFavoriteFill: '\uF0C9',
            BufferTimeBefore: '\uF0CF',
            BufferTimeAfter: '\uF0D0',
            BufferTimeBoth: '\uF0D1',
            PublishContent: '\uF0D4',
            ClipboardList: '\uF0E3',
            ClipboardListMirrored: '\uF0E4',
            CannedChat: '\uF0F2',
            SkypeForBusinessLogo: '\uF0FC',
            TabCenter: '\uF100',
            PageCheckedin: '\uF104',
            PageList: '\uF106',
            ReadOutLoud: '\uF112',
            CaretBottomLeftSolid8: '\uF121',
            CaretBottomRightSolid8: '\uF122',
            FolderHorizontal: '\uF12B',
            MicrosoftStaffhubLogo: '\uF130',
            GiftboxOpen: '\uF133',
            StatusCircleOuter: '\uF136',
            StatusCircleInner: '\uF137',
            StatusCircleRing: '\uF138',
            StatusTriangleOuter: '\uF139',
            StatusTriangleInner: '\uF13A',
            StatusTriangleExclamation: '\uF13B',
            StatusCircleExclamation: '\uF13C',
            StatusCircleErrorX: '\uF13D',
            StatusCircleInfo: '\uF13F',
            StatusCircleBlock: '\uF140',
            StatusCircleBlock2: '\uF141',
            StatusCircleQuestionMark: '\uF142',
            StatusCircleSync: '\uF143',
            Toll: '\uF160',
            ExploreContentSingle: '\uF164',
            CollapseContent: '\uF165',
            CollapseContentSingle: '\uF166',
            InfoSolid: '\uF167',
            ProgressRingDots: '\uF16A',
            CaloriesAdd: '\uF172',
            BranchFork: '\uF173',
            AddHome: '\uF17B',
            MobileReport: '\uF18A',
            ScaleVolume: '\uF18C',
            HardDriveGroup: '\uF18F',
            FastMode: '\uF19A',
            ToggleLeft: '\uF19E',
            ToggleRight: '\uF19F',
            TriangleShape: '\uF1A7',
            RectangleShape: '\uF1A9'
        }
    };
    Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_styling__["K" /* registerIcons */])(subset, options);
}
//# sourceMappingURL=fabric-icons-8.js.map

/***/ }),
/* 1971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initializeIcons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uifabric_styling__ = __webpack_require__(22);
// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
// tslint:disable:max-line-length

function initializeIcons(baseUrl, options) {
    if (baseUrl === void 0) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-9\"",
            src: "url('" + baseUrl + "fabric-icons-9-88060b8a.woff') format('woff')"
        },
        icons: {
            Trophy2: '\uF1AE',
            BucketColor: '\uF1B6',
            BucketColorFill: '\uF1B7',
            Taskboard: '\uF1C2',
            SingleColumn: '\uF1D3',
            DoubleColumn: '\uF1D4',
            TripleColumn: '\uF1D5',
            ColumnLeftTwoThirds: '\uF1D6',
            ColumnRightTwoThirds: '\uF1D7',
            AccessLogoFill: '\uF1DB',
            AnalyticsLogo: '\uF1DE',
            AnalyticsQuery: '\uF1DF',
            NewAnalyticsQuery: '\uF1E0',
            AnalyticsReport: '\uF1E1',
            WordLogo: '\uF1E3',
            WordLogoFill: '\uF1E4',
            ExcelLogo: '\uF1E5',
            ExcelLogoFill: '\uF1E6',
            OneNoteLogo: '\uF1E7',
            OneNoteLogoFill: '\uF1E8',
            OutlookLogo: '\uF1E9',
            OutlookLogoFill: '\uF1EA',
            PowerPointLogo: '\uF1EB',
            PowerPointLogoFill: '\uF1EC',
            PublisherLogo: '\uF1ED',
            PublisherLogoFill: '\uF1EE',
            ScheduleEventAction: '\uF1EF',
            FlameSolid: '\uF1F3',
            ServerProcesses: '\uF1FE',
            Server: '\uF201',
            SaveAll: '\uF203',
            LinkedInLogo: '\uF20A',
            Decimals: '\uF218',
            SidePanelMirrored: '\uF221',
            ProtectRestrict: '\uF22A',
            Blog: '\uF22B',
            UnknownMirrored: '\uF22E',
            PublicContactCardMirrored: '\uF230',
            GridViewSmall: '\uF232',
            GridViewMedium: '\uF233',
            GridViewLarge: '\uF234',
            Step: '\uF241',
            StepInsert: '\uF242',
            StepShared: '\uF243',
            StepSharedAdd: '\uF244',
            StepSharedInsert: '\uF245',
            ViewDashboard: '\uF246',
            ViewList: '\uF247',
            ViewListGroup: '\uF248',
            ViewListTree: '\uF249',
            TriggerAuto: '\uF24A',
            TriggerUser: '\uF24B',
            PivotChart: '\uF24C',
            StackedBarChart: '\uF24D',
            StackedLineChart: '\uF24E',
            BuildQueue: '\uF24F',
            BuildQueueNew: '\uF250',
            UserFollowed: '\uF25C',
            ContactLink: '\uF25F',
            Stack: '\uF26F',
            Bullseye: '\uF272',
            VennDiagram: '\uF273',
            FiveTileGrid: '\uF274',
            FocalPoint: '\uF277',
            RingerRemove: '\uF279',
            TeamsLogoInverse: '\uF27A',
            TeamsLogo: '\uF27B',
            TeamsLogoFill: '\uF27C',
            SkypeForBusinessLogoFill: '\uF27D',
            SharepointLogo: '\uF27E',
            SharepointLogoFill: '\uF27F',
            DelveLogo: '\uF280',
            DelveLogoFill: '\uF281',
            OfficeVideoLogo: '\uF282',
            OfficeVideoLogoFill: '\uF283',
            ExchangeLogo: '\uF284',
            ExchangeLogoFill: '\uF285',
            Signin: '\uF286',
            DocumentApproval: '\uF28B',
            CloneToDesktop: '\uF28C',
            InstallToDrive: '\uF28D',
            Blur: '\uF28E',
            Build: '\uF28F',
            ProcessMetaTask: '\uF290',
            BranchFork2: '\uF291',
            BranchLocked: '\uF292',
            BranchCommit: '\uF293',
            BranchCompare: '\uF294',
            BranchMerge: '\uF295',
            BranchPullRequest: '\uF296',
            BranchSearch: '\uF297',
            BranchShelveset: '\uF298',
            RawSource: '\uF299',
            MergeDuplicate: '\uF29A',
            RowsGroup: '\uF29B',
            RowsChild: '\uF29C',
            Deploy: '\uF29D',
            Redeploy: '\uF29E',
            ServerEnviroment: '\uF29F',
            VisioDiagram: '\uF2A0'
        }
    };
    Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_styling__["K" /* registerIcons */])(subset, options);
}
//# sourceMappingURL=fabric-icons-9.js.map

/***/ }),
/* 1972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initializeIcons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uifabric_styling__ = __webpack_require__(22);
// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
// tslint:disable:max-line-length

function initializeIcons(baseUrl, options) {
    if (baseUrl === void 0) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-10\"",
            src: "url('" + baseUrl + "fabric-icons-10-1ca3e4a1.woff') format('woff')"
        },
        icons: {
            HighlightMappedShapes: '\uF2A1',
            TextCallout: '\uF2A2',
            IconSetsFlag: '\uF2A4',
            VisioLogo: '\uF2A7',
            VisioLogoFill: '\uF2A8',
            VisioDocument: '\uF2A9',
            TimelineProgress: '\uF2AA',
            TimelineDelivery: '\uF2AB',
            Backlog: '\uF2AC',
            TeamFavorite: '\uF2AD',
            TaskGroup: '\uF2AE',
            TaskGroupMirrored: '\uF2AF',
            ScopeTemplate: '\uF2B0',
            AssessmentGroupTemplate: '\uF2B1',
            NewTeamProject: '\uF2B2',
            CommentAdd: '\uF2B3',
            CommentNext: '\uF2B4',
            CommentPrevious: '\uF2B5',
            ShopServer: '\uF2B6',
            LocaleLanguage: '\uF2B7',
            QueryList: '\uF2B8',
            UserSync: '\uF2B9',
            UserPause: '\uF2BA',
            StreamingOff: '\uF2BB',
            ArrowTallUpLeft: '\uF2BD',
            ArrowTallUpRight: '\uF2BE',
            ArrowTallDownLeft: '\uF2BF',
            ArrowTallDownRight: '\uF2C0',
            FieldEmpty: '\uF2C1',
            FieldFilled: '\uF2C2',
            FieldChanged: '\uF2C3',
            FieldNotChanged: '\uF2C4',
            RingerOff: '\uF2C5',
            PlayResume: '\uF2C6',
            BulletedList2: '\uF2C7',
            BulletedList2Mirrored: '\uF2C8',
            ImageCrosshair: '\uF2C9',
            GitGraph: '\uF2CA',
            Repo: '\uF2CB',
            RepoSolid: '\uF2CC',
            FolderQuery: '\uF2CD',
            FolderList: '\uF2CE',
            FolderListMirrored: '\uF2CF',
            LocationOutline: '\uF2D0',
            POISolid: '\uF2D1',
            CalculatorNotEqualTo: '\uF2D2',
            BoxSubtractSolid: '\uF2D3',
            BoxAdditionSolid: '\uF2D4',
            BoxMultiplySolid: '\uF2D5',
            BoxPlaySolid: '\uF2D6',
            BoxCheckmarkSolid: '\uF2D7',
            CirclePauseSolid: '\uF2D8',
            CirclePause: '\uF2D9',
            MSNVideosSolid: '\uF2DA',
            CircleStopSolid: '\uF2DB',
            CircleStop: '\uF2DC',
            NavigateBack: '\uF2DD',
            NavigateBackMirrored: '\uF2DE',
            NavigateForward: '\uF2DF',
            NavigateForwardMirrored: '\uF2E0',
            UnknownSolid: '\uF2E1',
            UnknownMirroredSolid: '\uF2E2',
            CircleAddition: '\uF2E3',
            CircleAdditionSolid: '\uF2E4',
            FilePDB: '\uF2E5',
            FileTemplate: '\uF2E6',
            FileSQL: '\uF2E7',
            FileJAVA: '\uF2E8',
            FileASPX: '\uF2E9',
            FileCSS: '\uF2EA',
            FileSass: '\uF2EB',
            FileLess: '\uF2EC',
            FileHTML: '\uF2ED',
            JavaScriptLanguage: '\uF2EE',
            CSharpLanguage: '\uF2EF',
            CSharp: '\uF2F0',
            VisualBasicLanguage: '\uF2F1',
            VB: '\uF2F2',
            CPlusPlusLanguage: '\uF2F3',
            CPlusPlus: '\uF2F4',
            FSharpLanguage: '\uF2F5',
            FSharp: '\uF2F6',
            TypeScriptLanguage: '\uF2F7',
            PythonLanguage: '\uF2F8',
            PY: '\uF2F9',
            CoffeeScript: '\uF2FA',
            MarkDownLanguage: '\uF2FB',
            FullWidth: '\uF2FE',
            FullWidthEdit: '\uF2FF',
            Plug: '\uF300',
            PlugSolid: '\uF301',
            PlugConnected: '\uF302',
            PlugDisconnected: '\uF303',
            UnlockSolid: '\uF304',
            Variable: '\uF305',
            Parameter: '\uF306',
            CommentUrgent: '\uF307',
            Storyboard: '\uF308',
            DiffInline: '\uF309',
            DiffSideBySide: '\uF30A'
        }
    };
    Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_styling__["K" /* registerIcons */])(subset, options);
}
//# sourceMappingURL=fabric-icons-10.js.map

/***/ }),
/* 1973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initializeIcons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uifabric_styling__ = __webpack_require__(22);
// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
// tslint:disable:max-line-length

function initializeIcons(baseUrl, options) {
    if (baseUrl === void 0) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-11\"",
            src: "url('" + baseUrl + "fabric-icons-11-93bad8ee.woff') format('woff')"
        },
        icons: {
            ImageDiff: '\uF30B',
            ImagePixel: '\uF30C',
            FileBug: '\uF30D',
            FileCode: '\uF30E',
            FileComment: '\uF30F',
            BusinessHoursSign: '\uF310',
            FileImage: '\uF311',
            FileSymlink: '\uF312',
            AutoFillTemplate: '\uF313',
            WorkItem: '\uF314',
            WorkItemBug: '\uF315',
            LogRemove: '\uF316',
            ColumnOptions: '\uF317',
            Packages: '\uF318',
            BuildIssue: '\uF319',
            AssessmentGroup: '\uF31A',
            VariableGroup: '\uF31B',
            FullHistory: '\uF31C',
            SingleColumnEdit: '\uF321',
            DoubleColumnEdit: '\uF322',
            TripleColumnEdit: '\uF323',
            ColumnLeftTwoThirdsEdit: '\uF324',
            ColumnRightTwoThirdsEdit: '\uF325',
            StreamLogo: '\uF329',
            PassiveAuthentication: '\uF32A',
            AlertSolid: '\uF331',
            MegaphoneSolid: '\uF332',
            TaskSolid: '\uF333',
            ConfigurationSolid: '\uF334',
            BugSolid: '\uF335',
            CrownSolid: '\uF336',
            Trophy2Solid: '\uF337',
            QuickNoteSolid: '\uF338',
            ConstructionConeSolid: '\uF339',
            PageListSolid: '\uF33A',
            PageListMirroredSolid: '\uF33B',
            StarburstSolid: '\uF33C',
            ReadingModeSolid: '\uF33D',
            SadSolid: '\uF33E',
            HealthSolid: '\uF33F',
            ShieldSolid: '\uF340',
            GiftBoxSolid: '\uF341',
            ShoppingCartSolid: '\uF342',
            MailSolid: '\uF343',
            ChatSolid: '\uF344',
            RibbonSolid: '\uF345',
            FinancialSolid: '\uF346',
            FinancialMirroredSolid: '\uF347',
            HeadsetSolid: '\uF348',
            PermissionsSolid: '\uF349',
            ParkingSolid: '\uF34A',
            ParkingMirroredSolid: '\uF34B',
            DiamondSolid: '\uF34C',
            AsteriskSolid: '\uF34D',
            OfflineStorageSolid: '\uF34E',
            BankSolid: '\uF34F',
            DecisionSolid: '\uF350',
            Parachute: '\uF351',
            ParachuteSolid: '\uF352',
            FiltersSolid: '\uF353',
            ColorSolid: '\uF354',
            ReviewSolid: '\uF355',
            ReviewRequestSolid: '\uF356',
            ReviewRequestMirroredSolid: '\uF357',
            ReviewResponseSolid: '\uF358',
            FeedbackRequestSolid: '\uF359',
            FeedbackRequestMirroredSolid: '\uF35A',
            FeedbackResponseSolid: '\uF35B',
            WorkItemBar: '\uF35C',
            WorkItemBarSolid: '\uF35D',
            Separator: '\uF35E',
            NavigateExternalInline: '\uF35F',
            PlanView: '\uF360',
            TimelineMatrixView: '\uF361',
            EngineeringGroup: '\uF362',
            ProjectCollection: '\uF363',
            CaretBottomRightCenter8: '\uF364',
            CaretBottomLeftCenter8: '\uF365',
            CaretTopRightCenter8: '\uF366',
            CaretTopLeftCenter8: '\uF367',
            DonutChart: '\uF368',
            ChevronUnfold10: '\uF369',
            ChevronFold10: '\uF36A',
            DoubleChevronDown8: '\uF36B',
            DoubleChevronUp8: '\uF36C',
            DoubleChevronLeft8: '\uF36D',
            DoubleChevronRight8: '\uF36E',
            ChevronDownEnd6: '\uF36F',
            ChevronUpEnd6: '\uF370',
            ChevronLeftEnd6: '\uF371',
            ChevronRightEnd6: '\uF372',
            ContextMenu: '\uF37C',
            AzureAPIManagement: '\uF37F',
            AzureServiceEndpoint: '\uF380',
            VSTSLogo: '\uF381',
            VSTSAltLogo1: '\uF382',
            VSTSAltLogo2: '\uF383',
            FileTypeSolution: '\uF387',
            WordLogoInverse16: '\uF390',
            WordLogo16: '\uF391'
        }
    };
    Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_styling__["K" /* registerIcons */])(subset, options);
}
//# sourceMappingURL=fabric-icons-11.js.map

/***/ }),
/* 1974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initializeIcons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uifabric_styling__ = __webpack_require__(22);
// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
// tslint:disable:max-line-length

function initializeIcons(baseUrl, options) {
    if (baseUrl === void 0) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-12\"",
            src: "url('" + baseUrl + "fabric-icons-12-d9534567.woff') format('woff')"
        },
        icons: {
            WordLogoFill16: '\uF392',
            PowerPointLogoInverse16: '\uF393',
            PowerPointLogo16: '\uF394',
            PowerPointLogoFill16: '\uF395',
            ExcelLogoInverse16: '\uF396',
            ExcelLogo16: '\uF397',
            ExcelLogoFill16: '\uF398',
            OneNoteLogoInverse16: '\uF399',
            OneNoteLogo16: '\uF39A',
            OneNoteLogoFill16: '\uF39B',
            OutlookLogoInverse16: '\uF39C',
            OutlookLogo16: '\uF39D',
            OutlookLogoFill16: '\uF39E',
            PublisherLogoInverse16: '\uF39F',
            PublisherLogo16: '\uF3A0',
            PublisherLogoFill16: '\uF3A1',
            VisioLogoInverse16: '\uF3A2',
            VisioLogo16: '\uF3A3',
            VisioLogoFill16: '\uF3A4',
            TestBeaker: '\uF3A5',
            TestBeakerSolid: '\uF3A6',
            TestExploreSolid: '\uF3A7',
            TestAutoSolid: '\uF3A8',
            TestUserSolid: '\uF3A9',
            TestImpactSolid: '\uF3AA',
            TestPlan: '\uF3AB',
            TestStep: '\uF3AC',
            TestParameter: '\uF3AD',
            TestSuite: '\uF3AE',
            TestCase: '\uF3AF',
            Sprint: '\uF3B0',
            SignOut: '\uF3B1',
            TriggerApproval: '\uF3B2',
            Rocket: '\uF3B3',
            AzureKeyVault: '\uF3B4',
            Onboarding: '\uF3BA',
            Transition: '\uF3BC',
            LikeSolid: '\uF3BF',
            DislikeSolid: '\uF3C0',
            CRMCustomerInsightsApp: '\uF3C8',
            EditCreate: '\uF3C9',
            UnSetColor: '\uF3F9',
            DeclineCall: '\uF405',
            RectangularClipping: '\uF407',
            TeamsLogo16: '\uF40A',
            TeamsLogoFill16: '\uF40B',
            Spacer: '\uF40D',
            SkypeLogo16: '\uF40E',
            SkypeForBusinessLogo16: '\uF40F',
            SkypeForBusinessLogoFill16: '\uF410',
            FilterSolid: '\uF412',
            MailUndelivered: '\uF415',
            MailTentative: '\uF416',
            MailTentativeMirrored: '\uF417',
            MailReminder: '\uF418',
            ReceiptUndelivered: '\uF419',
            ReceiptTentative: '\uF41A',
            ReceiptTentativeMirrored: '\uF41B',
            Inbox: '\uF41C',
            IRMReply: '\uF41D',
            IRMReplyMirrored: '\uF41E',
            IRMForward: '\uF41F',
            IRMForwardMirrored: '\uF420',
            VoicemailIRM: '\uF421',
            EventAccepted: '\uF422',
            EventTentative: '\uF423',
            EventTentativeMirrored: '\uF424',
            EventDeclined: '\uF425',
            IDBadge: '\uF427',
            BackgroundColor: '\uF42B',
            OfficeFormsLogoInverse16: '\uF433',
            OfficeFormsLogo: '\uF434',
            OfficeFormsLogoFill: '\uF435',
            OfficeFormsLogo16: '\uF436',
            OfficeFormsLogoFill16: '\uF437',
            OfficeFormsLogoInverse24: '\uF43A',
            OfficeFormsLogo24: '\uF43B',
            OfficeFormsLogoFill24: '\uF43C',
            PageLock: '\uF43F',
            NotExecuted: '\uF440',
            NotImpactedSolid: '\uF441',
            FieldReadOnly: '\uF442',
            FieldRequired: '\uF443',
            BacklogBoard: '\uF444',
            ExternalBuild: '\uF445',
            ExternalTFVC: '\uF446',
            ExternalXAML: '\uF447',
            IssueSolid: '\uF448',
            DefectSolid: '\uF449',
            LadybugSolid: '\uF44A',
            NugetLogo: '\uF44C',
            TFVCLogo: '\uF44D',
            ProjectLogo32: '\uF47E',
            ProjectLogoFill32: '\uF47F',
            ProjectLogo16: '\uF480',
            ProjectLogoFill16: '\uF481',
            SwayLogo32: '\uF482',
            SwayLogoFill32: '\uF483',
            SwayLogo16: '\uF484',
            SwayLogoFill16: '\uF485'
        }
    };
    Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_styling__["K" /* registerIcons */])(subset, options);
}
//# sourceMappingURL=fabric-icons-12.js.map

/***/ }),
/* 1975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initializeIcons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uifabric_styling__ = __webpack_require__(22);
// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
// tslint:disable:max-line-length

function initializeIcons(baseUrl, options) {
    if (baseUrl === void 0) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-13\"",
            src: "url('" + baseUrl + "fabric-icons-13-0b48c801.woff') format('woff')"
        },
        icons: {
            ClassNotebookLogo32: '\uF486',
            ClassNotebookLogoFill32: '\uF487',
            ClassNotebookLogo16: '\uF488',
            ClassNotebookLogoFill16: '\uF489',
            ClassNotebookLogoInverse32: '\uF48A',
            ClassNotebookLogoInverse16: '\uF48B',
            StaffNotebookLogo32: '\uF48C',
            StaffNotebookLogoFill32: '\uF48D',
            StaffNotebookLogo16: '\uF48E',
            StaffNotebookLogoFill16: '\uF48F',
            StaffNotebookLogoInverted32: '\uF490',
            StaffNotebookLogoInverted16: '\uF491',
            KaizalaLogo: '\uF492',
            TaskLogo: '\uF493',
            ProtectionCenterLogo32: '\uF494',
            GallatinLogo: '\uF496',
            Globe2: '\uF49A',
            Guitar: '\uF49B',
            Breakfast: '\uF49C',
            Brunch: '\uF49D',
            BeerMug: '\uF49E',
            Vacation: '\uF49F',
            Teeth: '\uF4A0',
            Taxi: '\uF4A1',
            Chopsticks: '\uF4A2',
            SyncOccurence: '\uF4A3',
            UnsyncOccurence: '\uF4A4',
            GIF: '\uF4A9',
            PrimaryCalendar: '\uF4AE',
            SearchCalendar: '\uF4AF',
            VideoOff: '\uF4B0',
            MicrosoftFlowLogo: '\uF4B1',
            BusinessCenterLogo: '\uF4B2',
            ToDoLogoBottom: '\uF4B3',
            ToDoLogoTop: '\uF4B4',
            EditSolid12: '\uF4B5',
            EditSolidMirrored12: '\uF4B6',
            UneditableSolid12: '\uF4B7',
            UneditableSolidMirrored12: '\uF4B8',
            UneditableMirrored: '\uF4B9',
            AdminALogo32: '\uF4BA',
            AdminALogoFill32: '\uF4BB',
            ToDoLogoInverse: '\uF4BC',
            Snooze: '\uF4BD',
            WaffleOffice365: '\uF4E0',
            ImageSearch: '\uF4E8',
            NewsSearch: '\uF4E9',
            VideoSearch: '\uF4EA',
            R: '\uF4EB',
            FontColorA: '\uF4EC',
            FontColorSwatch: '\uF4ED',
            LightWeight: '\uF4EE',
            NormalWeight: '\uF4EF',
            SemiboldWeight: '\uF4F0',
            GroupObject: '\uF4F1',
            UngroupObject: '\uF4F2',
            AlignHorizontalLeft: '\uF4F3',
            AlignHorizontalCenter: '\uF4F4',
            AlignHorizontalRight: '\uF4F5',
            AlignVerticalTop: '\uF4F6',
            AlignVerticalCenter: '\uF4F7',
            AlignVerticalBottom: '\uF4F8',
            HorizontalDistributeCenter: '\uF4F9',
            VerticalDistributeCenter: '\uF4FA',
            Ellipse: '\uF4FB',
            Line: '\uF4FC',
            Octagon: '\uF4FD',
            Hexagon: '\uF4FE',
            Pentagon: '\uF4FF',
            RightTriangle: '\uF500',
            HalfCircle: '\uF501',
            QuarterCircle: '\uF502',
            ThreeQuarterCircle: '\uF503',
            '6PointStar': '\uF504',
            '12PointStar': '\uF505',
            ArrangeBringToFront: '\uF506',
            ArrangeSendToBack: '\uF507',
            ArrangeSendBackward: '\uF508',
            ArrangeBringForward: '\uF509',
            BorderDash: '\uF50A',
            BorderDot: '\uF50B',
            LineStyle: '\uF50C',
            LineThickness: '\uF50D',
            WindowEdit: '\uF50E',
            HintText: '\uF50F',
            MediaAdd: '\uF510',
            AnchorLock: '\uF511',
            AutoHeight: '\uF512',
            ChartSeries: '\uF513',
            ChartXAngle: '\uF514',
            ChartYAngle: '\uF515',
            Combobox: '\uF516',
            LineSpacing: '\uF517',
            Padding: '\uF518',
            PaddingTop: '\uF519',
            PaddingBottom: '\uF51A',
            PaddingLeft: '\uF51B',
            PaddingRight: '\uF51C',
            NavigationFlipper: '\uF51D',
            AlignJustify: '\uF51E'
        }
    };
    Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_styling__["K" /* registerIcons */])(subset, options);
}
//# sourceMappingURL=fabric-icons-13.js.map

/***/ }),
/* 1976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initializeIcons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uifabric_styling__ = __webpack_require__(22);
// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
// tslint:disable:max-line-length

function initializeIcons(baseUrl, options) {
    if (baseUrl === void 0) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-14\"",
            src: "url('" + baseUrl + "fabric-icons-14-9a8324a9.woff') format('woff')"
        },
        icons: {
            TextOverflow: '\uF51F',
            VisualsFolder: '\uF520',
            VisualsStore: '\uF521',
            PictureCenter: '\uF522',
            PictureFill: '\uF523',
            PicturePosition: '\uF524',
            PictureStretch: '\uF525',
            PictureTile: '\uF526',
            Slider: '\uF527',
            SliderHandleSize: '\uF528',
            DefaultRatio: '\uF529',
            NumberSequence: '\uF52A',
            GUID: '\uF52B',
            ReportAdd: '\uF52C',
            DashboardAdd: '\uF52D',
            MapPinSolid: '\uF52E',
            WebPublish: '\uF52F',
            PieSingleSolid: '\uF530',
            BlockedSolid: '\uF531',
            DrillDown: '\uF532',
            DrillDownSolid: '\uF533',
            DrillExpand: '\uF534',
            DrillShow: '\uF535',
            SpecialEvent: '\uF536',
            OneDriveFolder16: '\uF53B',
            FunctionalManagerDashboard: '\uF542',
            BIDashboard: '\uF543',
            CodeEdit: '\uF544',
            RenewalCurrent: '\uF545',
            RenewalFuture: '\uF546',
            SplitObject: '\uF547',
            BulkUpload: '\uF548',
            DownloadDocument: '\uF549',
            Flower: '\uF54E',
            WaitlistConfirm: '\uF550',
            WaitlistConfirmMirrored: '\uF551',
            LaptopSecure: '\uF552',
            DragObject: '\uF553',
            EntryView: '\uF554',
            EntryDecline: '\uF555',
            ContactCardSettings: '\uF556',
            ContactCardSettingsMirrored: '\uF557',
            CalendarSettings: '\uF558',
            CalendarSettingsMirrored: '\uF559',
            HardDriveLock: '\uF55A',
            HardDriveUnlock: '\uF55B',
            AccountManagement: '\uF55C',
            TransitionPop: '\uF5B2',
            TransitionPush: '\uF5B3',
            TransitionEffect: '\uF5B4',
            LookupEntities: '\uF5B5',
            ExploreData: '\uF5B6',
            AddBookmark: '\uF5B7',
            SearchBookmark: '\uF5B8',
            DrillThrough: '\uF5B9',
            MasterDatabase: '\uF5BA',
            CertifiedDatabase: '\uF5BB',
            MaximumValue: '\uF5BC',
            MinimumValue: '\uF5BD',
            VisualStudioIDELogo32: '\uF5D0',
            PasteAsText: '\uF5D5',
            PasteAsCode: '\uF5D6',
            BrowserTab: '\uF5D7',
            BrowserTabScreenshot: '\uF5D8',
            DesktopScreenshot: '\uF5D9',
            FileYML: '\uF5DA',
            ClipboardSolid: '\uF5DC',
            FabricUserFolder: '\uF5E5',
            FabricNetworkFolder: '\uF5E6',
            AnalyticsView: '\uF5F1',
            Video360Generic: '\uF609',
            Leave: '\uF627',
            Trending12: '\uF62D',
            Blocked12: '\uF62E',
            Warning12: '\uF62F',
            CheckedOutByOther12: '\uF630',
            CheckedOutByYou12: '\uF631',
            CircleShapeSolid: '\uF63C',
            SquareShapeSolid: '\uF63D',
            TriangleShapeSolid: '\uF63E',
            DropShapeSolid: '\uF63F',
            RectangleShapeSolid: '\uF640',
            ZoomToFit: '\uF649',
            InsertColumnsLeft: '\uF64A',
            InsertColumnsRight: '\uF64B',
            InsertRowsAbove: '\uF64C',
            InsertRowsBelow: '\uF64D',
            DeleteColumns: '\uF64E',
            DeleteRows: '\uF64F',
            DeleteRowsMirrored: '\uF650',
            DeleteTable: '\uF651',
            AccountBrowser: '\uF652',
            VersionControlPush: '\uF664',
            StackedColumnChart2: '\uF666',
            TripleColumnWide: '\uF66E',
            QuadColumn: '\uF66F',
            WhiteBoardApp16: '\uF673',
            WhiteBoardApp32: '\uF674',
            InsertSignatureLine: '\uF677',
            ArrangeByFrom: '\uF678'
        }
    };
    Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_styling__["K" /* registerIcons */])(subset, options);
}
//# sourceMappingURL=fabric-icons-14.js.map

/***/ }),
/* 1977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initializeIcons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uifabric_styling__ = __webpack_require__(22);
// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
// tslint:disable:max-line-length

function initializeIcons(baseUrl, options) {
    if (baseUrl === void 0) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-15\"",
            src: "url('" + baseUrl + "fabric-icons-15-65272067.woff') format('woff')"
        },
        icons: {
            Phishing: '\uF679',
            CreateMailRule: '\uF67A',
            PublishCourse: '\uF699',
            DictionaryRemove: '\uF69A',
            UserRemove: '\uF69B',
            UserEvent: '\uF69C',
            Encryption: '\uF69D',
            PasswordField: '\uF6AA',
            OpenInNewTab: '\uF6AB',
            Hide3: '\uF6AC',
            VerifiedBrandSolid: '\uF6AD',
            MarkAsProtected: '\uF6AE',
            AuthenticatorApp: '\uF6B1',
            WebTemplate: '\uF6B2',
            DefenderTVM: '\uF6B3',
            MedalSolid: '\uF6B9',
            D365TalentLearn: '\uF6BB',
            D365TalentInsight: '\uF6BC',
            D365TalentHRCore: '\uF6BD',
            BacklogList: '\uF6BF',
            ButtonControl: '\uF6C0',
            TableGroup: '\uF6D9',
            MountainClimbing: '\uF6DB',
            TagUnknown: '\uF6DF',
            TagUnknownMirror: '\uF6E0',
            TagUnknown12: '\uF6E1',
            TagUnknown12Mirror: '\uF6E2',
            Link12: '\uF6E3',
            Presentation: '\uF6E4',
            Presentation12: '\uF6E5',
            Lock12: '\uF6E6',
            BuildDefinition: '\uF6E9',
            ReleaseDefinition: '\uF6EA',
            SaveTemplate: '\uF6EC',
            UserGauge: '\uF6ED',
            BlockedSiteSolid12: '\uF70A',
            TagSolid: '\uF70E',
            OfficeChat: '\uF70F',
            OfficeChatSolid: '\uF710',
            MailSchedule: '\uF72E',
            WarningSolid: '\uF736',
            Blocked2Solid: '\uF737',
            SkypeCircleArrow: '\uF747',
            SkypeArrow: '\uF748',
            SyncStatus: '\uF751',
            SyncStatusSolid: '\uF752',
            ProjectDocument: '\uF759',
            ToDoLogoOutline: '\uF75B',
            VisioOnlineLogoFill32: '\uF75F',
            VisioOnlineLogo32: '\uF760',
            VisioOnlineLogoCloud32: '\uF761',
            VisioDiagramSync: '\uF762',
            Event12: '\uF763',
            EventDateMissed12: '\uF764',
            UserOptional: '\uF767',
            ResponsesMenu: '\uF768',
            DoubleDownArrow: '\uF769',
            DistributeDown: '\uF76A',
            BookmarkReport: '\uF76B',
            FilterSettings: '\uF76C',
            GripperDotsVertical: '\uF772',
            MailAttached: '\uF774',
            AddIn: '\uF775',
            LinkedDatabase: '\uF779',
            PromotedDatabase: '\uF77D',
            BarChartVerticalFilter: '\uF77E',
            BarChartVerticalFilterSolid: '\uF77F',
            MicrosoftTranslatorLogo: '\uF782',
            ShowTimeAs: '\uF787',
            FileRequest: '\uF789',
            WorkItemAlert: '\uF78F',
            PowerBILogo16: '\uF790',
            PowerBILogoBackplate16: '\uF791',
            BulletedListText: '\uF792',
            BulletedListBullet: '\uF793',
            BulletedListTextMirrored: '\uF794',
            BulletedListBulletMirrored: '\uF795',
            NumberedListText: '\uF796',
            NumberedListNumber: '\uF797',
            NumberedListTextMirrored: '\uF798',
            NumberedListNumberMirrored: '\uF799',
            RemoveLinkChain: '\uF79A',
            RemoveLinkX: '\uF79B',
            FabricTextHighlight: '\uF79C',
            ClearFormattingA: '\uF79D',
            ClearFormattingEraser: '\uF79E',
            Photo2Fill: '\uF79F',
            IncreaseIndentText: '\uF7A0',
            IncreaseIndentArrow: '\uF7A1',
            DecreaseIndentText: '\uF7A2',
            DecreaseIndentArrow: '\uF7A3',
            IncreaseIndentTextMirrored: '\uF7A4',
            IncreaseIndentArrowMirrored: '\uF7A5',
            DecreaseIndentTextMirrored: '\uF7A6',
            DecreaseIndentArrowMirrored: '\uF7A7',
            CheckListText: '\uF7A8',
            CheckListCheck: '\uF7A9',
            CheckListTextMirrored: '\uF7AA',
            CheckListCheckMirrored: '\uF7AB',
            NumberSymbol: '\uF7AC'
        }
    };
    Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_styling__["K" /* registerIcons */])(subset, options);
}
//# sourceMappingURL=fabric-icons-15.js.map

/***/ }),
/* 1978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initializeIcons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uifabric_styling__ = __webpack_require__(22);
// Your use of the content in the files referenced here is subject to the terms of the license at https://aka.ms/fabric-assets-license
// tslint:disable:max-line-length

function initializeIcons(baseUrl, options) {
    if (baseUrl === void 0) { baseUrl = ''; }
    var subset = {
        style: {
            MozOsxFontSmoothing: 'grayscale',
            WebkitFontSmoothing: 'antialiased',
            fontStyle: 'normal',
            fontWeight: 'normal',
            speak: 'none'
        },
        fontFace: {
            fontFamily: "\"FabricMDL2Icons-16\"",
            src: "url('" + baseUrl + "fabric-icons-16-dff5b9a6.woff') format('woff')"
        },
        icons: {
            Coupon: '\uF7BC',
            VerifiedBrand: '\uF7BD',
            ReleaseGate: '\uF7BE',
            ReleaseGateCheck: '\uF7BF',
            ReleaseGateError: '\uF7C0',
            M365InvoicingLogo: '\uF7C1',
            FabricTextHighlightComposite: '\uF7DA',
            Dataflows: '\uF7DD',
            GenericScanFilled: '\uF7DE',
            DiagnosticDataBarTooltip: '\uF7DF',
            SaveToMobile: '\uF7E0',
            Orientation2: '\uF7E1',
            ScreenCast: '\uF7E2',
            ShowGrid: '\uF7E3',
            SnapToGrid: '\uF7E4',
            ContactList: '\uF7E5',
            NewMail: '\uF7EA',
            EyeShadow: '\uF7EB',
            FabricFolderConfirm: '\uF7FF',
            InformationBarriers: '\uF803',
            CommentActive: '\uF804',
            ColumnVerticalSectionEdit: '\uF806',
            WavingHand: '\uF807',
            ShakeDevice: '\uF80A',
            SmartGlassRemote: '\uF80B',
            Rotate90Clockwise: '\uF80D',
            Rotate90CounterClockwise: '\uF80E',
            CampaignTemplate: '\uF811',
            ChartTemplate: '\uF812',
            PageListFilter: '\uF813',
            SecondaryNav: '\uF814',
            ColumnVerticalSection: '\uF81E',
            SkypeCircleSlash: '\uF825',
            SkypeSlash: '\uF826',
            CustomizeToolbar: '\uF828',
            DuplicateRow: '\uF82A',
            RemoveFromTrash: '\uF82B',
            MailOptions: '\uF82C',
            Childof: '\uF82D',
            Footer: '\uF82E',
            Header: '\uF82F',
            BarChartVerticalFill: '\uF830',
            StackedColumnChart2Fill: '\uF831',
            PlainText: '\uF834',
            AccessibiltyChecker: '\uF835',
            DatabaseSync: '\uF842',
            ReservationOrders: '\uF845',
            TabOneColumn: '\uF849',
            TabTwoColumn: '\uF84A',
            TabThreeColumn: '\uF84B',
            MicrosoftTranslatorLogoGreen: '\uF852',
            MicrosoftTranslatorLogoBlue: '\uF853',
            InternalInvestigation: '\uF854',
            AppleTVPlay: '\uF859',
            AppleTVMonitor: '\uF85A',
            AppleTVMicrophone: '\uF85B',
            AppleTVMenu: '\uF85C',
            AddReaction: '\uF85D',
            DecreaseIndentLegacy: '\uE290',
            IncreaseIndentLegacy: '\uE291',
            SizeLegacy: '\uE2B2'
        }
    };
    Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_styling__["K" /* registerIcons */])(subset, options);
}
//# sourceMappingURL=fabric-icons-16.js.map

/***/ }),
/* 1979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return registerIconAliases; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uifabric_styling__ = __webpack_require__(22);

var registerIconAliases = function () {
    Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_styling__["J" /* registerIconAlias */])('trash', 'delete');
    Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_styling__["J" /* registerIconAlias */])('onedrive', 'onedrivelogo');
    Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_styling__["J" /* registerIconAlias */])('alertsolid12', 'eventdatemissed12');
    Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_styling__["J" /* registerIconAlias */])('sixpointstar', '6pointstar');
    Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_styling__["J" /* registerIconAlias */])('twelvepointstar', '12pointstar');
    Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_styling__["J" /* registerIconAlias */])('toggleon', 'toggleleft');
    Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_styling__["J" /* registerIconAlias */])('toggleoff', 'toggleright');
};
/* unused harmony default export */ var _unused_webpack_default_export = (registerIconAliases);
//# sourceMappingURL=iconAliases.js.map

/***/ }),
/* 1980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uifabric_set_version__ = __webpack_require__(145);
// @uifabric/icons@6.5.4
// Do not modify this file, the file is generated as part of publish. The checked in version is a placeholder only.

Object(__WEBPACK_IMPORTED_MODULE_0__uifabric_set_version__["a" /* setVersion */])('@uifabric/icons', '6.5.4');
//# sourceMappingURL=version.js.map

/***/ }),
/* 1981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Keytip__ = __webpack_require__(1982);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Keytip__["a"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 1982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Keytip; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_keytips_KeytipUtils__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Callout__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContextualMenu__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__KeytipContent__ = __webpack_require__(1983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Keytip_styles__ = __webpack_require__(796);







/**
 * A callout corresponding to another Fabric component to describe a key sequence that will activate that component
 */
var Keytip = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](Keytip, _super);
    function Keytip() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Keytip.prototype.render = function () {
        var _a = this.props, keySequences = _a.keySequences, offset = _a.offset, overflowSetSequence = _a.overflowSetSequence;
        var calloutProps = this.props.calloutProps;
        var keytipTarget;
        // Take into consideration the overflow sequence
        if (overflowSetSequence) {
            keytipTarget = Object(__WEBPACK_IMPORTED_MODULE_2__utilities_keytips_KeytipUtils__["c" /* ktpTargetFromSequences */])(Object(__WEBPACK_IMPORTED_MODULE_2__utilities_keytips_KeytipUtils__["d" /* mergeOverflows */])(keySequences, overflowSetSequence));
        }
        else {
            keytipTarget = Object(__WEBPACK_IMPORTED_MODULE_2__utilities_keytips_KeytipUtils__["c" /* ktpTargetFromSequences */])(keySequences);
        }
        if (offset) {
            // Set callout to top-left corner, will be further positioned in
            // getCalloutOffsetStyles
            calloutProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, calloutProps, { coverTarget: true, directionalHint: __WEBPACK_IMPORTED_MODULE_4__ContextualMenu__["b" /* DirectionalHint */].topLeftEdge });
        }
        if (!calloutProps || calloutProps.directionalHint === undefined) {
            // Default callout directional hint to BottomCenter
            calloutProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, calloutProps, { directionalHint: __WEBPACK_IMPORTED_MODULE_4__ContextualMenu__["b" /* DirectionalHint */].bottomCenter });
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Callout__["a" /* Callout */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, calloutProps, { isBeakVisible: false, doNotLayer: true, minPagePadding: 0, styles: offset ? Object(__WEBPACK_IMPORTED_MODULE_6__Keytip_styles__["a" /* getCalloutOffsetStyles */])(offset) : __WEBPACK_IMPORTED_MODULE_6__Keytip_styles__["b" /* getCalloutStyles */], preventDismissOnScroll: true, target: keytipTarget }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__KeytipContent__["a" /* KeytipContent */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this.props))));
    };
    return Keytip;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=Keytip.js.map

/***/ }),
/* 1983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KeytipContent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__KeytipContent_base__ = __webpack_require__(1984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Keytip_styles__ = __webpack_require__(796);



var KeytipContent = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__KeytipContent_base__["a" /* KeytipContentBase */], __WEBPACK_IMPORTED_MODULE_2__Keytip_styles__["c" /* getStyles */], undefined, {
    scope: 'KeytipContent'
});
//# sourceMappingURL=KeytipContent.js.map

/***/ }),
/* 1984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KeytipContentBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);



/**
 * A component corresponding the the content rendered inside the callout of the keytip component.
 * {@docCategory Keytips}
 */
var KeytipContentBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](KeytipContentBase, _super);
    function KeytipContentBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KeytipContentBase.prototype.render = function () {
        var _a = this.props, content = _a.content, styles = _a.styles, theme = _a.theme, disabled = _a.disabled, visible = _a.visible;
        var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
        var classNames = getClassNames(styles, {
            theme: theme,
            disabled: disabled,
            visible: visible
        });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.container },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: classNames.root }, content)));
    };
    return KeytipContentBase;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

//# sourceMappingURL=KeytipContent.base.js.map

/***/ }),
/* 1985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_KeytipLayer_index__ = __webpack_require__(1986);
/* unused harmony namespace reexport */

//# sourceMappingURL=KeytipLayer.js.map

/***/ }),
/* 1986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__KeytipLayer__ = __webpack_require__(1987);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__KeytipLayer_base__ = __webpack_require__(797);
/* unused harmony namespace reexport */


//# sourceMappingURL=index.js.map

/***/ }),
/* 1987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KeytipLayer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__KeytipLayer_base__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__KeytipLayer_styles__ = __webpack_require__(798);



var KeytipLayer = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__KeytipLayer_base__["a" /* KeytipLayerBase */], __WEBPACK_IMPORTED_MODULE_2__KeytipLayer_styles__["b" /* getStyles */], undefined, {
    scope: 'KeytipLayer'
});
//# sourceMappingURL=KeytipLayer.js.map

/***/ }),
/* 1988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KeytipTree; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_keytips_KeytipUtils__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_keytips_KeytipConstants__ = __webpack_require__(268);



/**
 * This class is responsible for handling the parent/child relationships between keytips
 */
var KeytipTree = /** @class */ (function () {
    /**
     * KeytipTree constructor
     */
    function KeytipTree() {
        this.nodeMap = {};
        // Root has no keytipSequence
        this.root = {
            id: __WEBPACK_IMPORTED_MODULE_2__utilities_keytips_KeytipConstants__["d" /* KTP_LAYER_ID */],
            children: [],
            parent: '',
            keySequences: []
        };
        this.nodeMap[this.root.id] = this.root;
    }
    /**
     * Add a keytip node to this KeytipTree
     *
     * @param keytipProps - Keytip to add to the Tree
     * @param uniqueID - Unique ID for this keytip
     * @param persisted - T/F if this keytip should be marked as persisted
     */
    KeytipTree.prototype.addNode = function (keytipProps, uniqueID, persisted) {
        var fullSequence = this._getFullSequence(keytipProps);
        var nodeID = Object(__WEBPACK_IMPORTED_MODULE_1__utilities_keytips_KeytipUtils__["e" /* sequencesToID */])(fullSequence);
        // Take off the last item to calculate the parent sequence
        fullSequence.pop();
        // Parent ID is the root if there aren't any more sequences
        var parentID = this._getParentID(fullSequence);
        // Create node and add to map
        var node = this._createNode(nodeID, parentID, [], keytipProps, persisted);
        this.nodeMap[uniqueID] = node;
        // Try to add self to parents children, if they exist
        var parent = this.getNode(parentID);
        if (parent) {
            parent.children.push(nodeID);
        }
    };
    /**
     * Updates a node in the tree
     *
     * @param keytipProps - Keytip props to update
     * @param uniqueID - Unique ID for this keytip
     */
    KeytipTree.prototype.updateNode = function (keytipProps, uniqueID) {
        var fullSequence = this._getFullSequence(keytipProps);
        var nodeID = Object(__WEBPACK_IMPORTED_MODULE_1__utilities_keytips_KeytipUtils__["e" /* sequencesToID */])(fullSequence);
        // Take off the last item to calculate the parent sequence
        fullSequence.pop();
        // Parent ID is the root if there aren't any more sequences
        var parentID = this._getParentID(fullSequence);
        var node = this.nodeMap[uniqueID];
        var parent = this.getNode(parentID);
        if (node) {
            // If the ID of the node has changed, update node's parent's array of children with new ID
            if (parent && node.id !== nodeID) {
                var index = parent.children.indexOf(node.id);
                index >= 0 && (parent.children[index] = nodeID);
            }
            // Update values
            node.id = nodeID;
            node.keySequences = keytipProps.keySequences;
            node.overflowSetSequence = keytipProps.overflowSetSequence;
            node.onExecute = keytipProps.onExecute;
            node.onReturn = keytipProps.onReturn;
            node.hasDynamicChildren = keytipProps.hasDynamicChildren;
            node.hasMenu = keytipProps.hasMenu;
            node.parent = parentID;
            node.disabled = keytipProps.disabled;
        }
    };
    /**
     * Removes a node from the KeytipTree
     *
     * @param sequence - full string of the node to remove
     */
    KeytipTree.prototype.removeNode = function (keytipProps, uniqueID) {
        var fullSequence = this._getFullSequence(keytipProps);
        var nodeID = Object(__WEBPACK_IMPORTED_MODULE_1__utilities_keytips_KeytipUtils__["e" /* sequencesToID */])(fullSequence);
        // Take off the last sequence to calculate the parent ID
        fullSequence.pop();
        // Parent ID is the root if there aren't any more sequences
        var parentID = this._getParentID(fullSequence);
        var parent = this.getNode(parentID);
        if (parent) {
            // Remove node from its parent's children
            parent.children.splice(parent.children.indexOf(nodeID), 1);
        }
        if (this.nodeMap[uniqueID]) {
            // Remove the node from the nodeMap
            delete this.nodeMap[uniqueID];
        }
    };
    /**
     * Searches the currentKeytip's children to exactly match a sequence. Will not match disabled nodes but
     * will match persisted nodes
     *
     * @param keySequence - string to match
     * @param currentKeytip - The keytip whose children will try to match
     * @returns The node that exactly matched the keySequence, or undefined if none matched
     */
    KeytipTree.prototype.getExactMatchedNode = function (keySequence, currentKeytip) {
        var _this = this;
        var possibleNodes = this.getNodes(currentKeytip.children);
        return Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["A" /* find */])(possibleNodes, function (node) {
            return _this._getNodeSequence(node) === keySequence && !node.disabled;
        });
    };
    /**
     * Searches the currentKeytip's children to find nodes that start with the given sequence. Will not match
     * disabled nodes but will match persisted nodes
     *
     * @param keySequence - string to partially match
     * @param currentKeytip - The keytip whose children will try to partially match
     * @returns List of tree nodes that partially match the given sequence
     */
    KeytipTree.prototype.getPartiallyMatchedNodes = function (keySequence, currentKeytip) {
        var _this = this;
        // Get children that are persisted
        var possibleNodes = this.getNodes(currentKeytip.children);
        return possibleNodes.filter(function (node) {
            return _this._getNodeSequence(node).indexOf(keySequence) === 0 && !node.disabled;
        });
    };
    /**
     * Get the non-persisted children of the give node
     * If no node is given, will use the 'currentKeytip'
     *
     * @param node - Node to get the children for
     * @returns List of node IDs that are the children of the node
     */
    KeytipTree.prototype.getChildren = function (node) {
        var _this = this;
        if (!node) {
            node = this.currentKeytip;
            if (!node) {
                return [];
            }
        }
        var children = node.children;
        return Object.keys(this.nodeMap).reduce(function (nodes, key) {
            if (children.indexOf(_this.nodeMap[key].id) >= 0 && !_this.nodeMap[key].persisted) {
                nodes.push(_this.nodeMap[key].id);
            }
            return nodes;
        }, []);
    };
    /**
     * Gets all nodes from their IDs
     *
     * @param ids - List of keytip IDs
     * @returns Array of nodes that match the given IDs, can be empty
     */
    KeytipTree.prototype.getNodes = function (ids) {
        var _this = this;
        return Object.keys(this.nodeMap).reduce(function (nodes, key) {
            if (ids.indexOf(_this.nodeMap[key].id) >= 0) {
                nodes.push(_this.nodeMap[key]);
            }
            return nodes;
        }, []);
    };
    /**
     * Gets a single node from its ID
     *
     * @param id - ID of the node to get
     * @returns Node with the given ID, if found
     */
    KeytipTree.prototype.getNode = function (id) {
        var nodeMapValues = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_33" /* values */])(this.nodeMap);
        return Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["A" /* find */])(nodeMapValues, function (node) {
            return node.id === id;
        });
    };
    /**
     * Tests if the currentKeytip in this.keytipTree is the parent of 'keytipProps'
     *
     * @param keytipProps - Keytip to test the parent for
     * @returns T/F if the currentKeytip is this keytipProps' parent
     */
    KeytipTree.prototype.isCurrentKeytipParent = function (keytipProps) {
        if (this.currentKeytip) {
            var fullSequence = keytipProps.keySequences.slice();
            if (keytipProps.overflowSetSequence) {
                fullSequence = Object(__WEBPACK_IMPORTED_MODULE_1__utilities_keytips_KeytipUtils__["d" /* mergeOverflows */])(fullSequence, keytipProps.overflowSetSequence);
            }
            // Take off the last sequence to calculate the parent ID
            fullSequence.pop();
            // Parent ID is the root if there aren't any more sequences
            var parentID = fullSequence.length === 0 ? this.root.id : Object(__WEBPACK_IMPORTED_MODULE_1__utilities_keytips_KeytipUtils__["e" /* sequencesToID */])(fullSequence);
            var matchesCurrWithoutOverflow = false;
            if (this.currentKeytip.overflowSetSequence) {
                var currKeytipIdWithoutOverflow = Object(__WEBPACK_IMPORTED_MODULE_1__utilities_keytips_KeytipUtils__["e" /* sequencesToID */])(this.currentKeytip.keySequences);
                matchesCurrWithoutOverflow = currKeytipIdWithoutOverflow === parentID;
            }
            return matchesCurrWithoutOverflow || this.currentKeytip.id === parentID;
        }
        return false;
    };
    KeytipTree.prototype._getParentID = function (fullSequence) {
        return fullSequence.length === 0 ? this.root.id : Object(__WEBPACK_IMPORTED_MODULE_1__utilities_keytips_KeytipUtils__["e" /* sequencesToID */])(fullSequence);
    };
    KeytipTree.prototype._getFullSequence = function (keytipProps) {
        var fullSequence = keytipProps.keySequences.slice();
        if (keytipProps.overflowSetSequence) {
            fullSequence = Object(__WEBPACK_IMPORTED_MODULE_1__utilities_keytips_KeytipUtils__["d" /* mergeOverflows */])(fullSequence, keytipProps.overflowSetSequence);
        }
        return fullSequence;
    };
    KeytipTree.prototype._getNodeSequence = function (node) {
        var fullSequence = node.keySequences.slice();
        if (node.overflowSetSequence) {
            fullSequence = Object(__WEBPACK_IMPORTED_MODULE_1__utilities_keytips_KeytipUtils__["d" /* mergeOverflows */])(fullSequence, node.overflowSetSequence);
        }
        return fullSequence[fullSequence.length - 1];
    };
    KeytipTree.prototype._createNode = function (id, parentId, children, keytipProps, persisted) {
        var _this = this;
        var keySequences = keytipProps.keySequences, hasDynamicChildren = keytipProps.hasDynamicChildren, overflowSetSequence = keytipProps.overflowSetSequence, hasMenu = keytipProps.hasMenu, onExecute = keytipProps.onExecute, onReturn = keytipProps.onReturn, disabled = keytipProps.disabled;
        var node = {
            id: id,
            keySequences: keySequences,
            overflowSetSequence: overflowSetSequence,
            parent: parentId,
            children: children,
            onExecute: onExecute,
            onReturn: onReturn,
            hasDynamicChildren: hasDynamicChildren,
            hasMenu: hasMenu,
            disabled: disabled,
            persisted: persisted
        };
        node.children = Object.keys(this.nodeMap).reduce(function (array, nodeMapKey) {
            if (_this.nodeMap[nodeMapKey].parent === id) {
                array.push(_this.nodeMap[nodeMapKey].id);
            }
            return array;
        }, []);
        return node;
    };
    return KeytipTree;
}());

//# sourceMappingURL=KeytipTree.js.map

/***/ }),
/* 1989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KeytipTransitionModifier; });
/* unused harmony export transitionKeysAreEqual */
/* harmony export (immutable) */ __webpack_exports__["b"] = transitionKeysContain;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);

var KeytipTransitionModifier;
(function (KeytipTransitionModifier) {
    KeytipTransitionModifier[KeytipTransitionModifier["shift"] = __WEBPACK_IMPORTED_MODULE_0__Utilities__["g" /* KeyCodes */].shift] = "shift";
    KeytipTransitionModifier[KeytipTransitionModifier["ctrl"] = __WEBPACK_IMPORTED_MODULE_0__Utilities__["g" /* KeyCodes */].ctrl] = "ctrl";
    KeytipTransitionModifier[KeytipTransitionModifier["alt"] = __WEBPACK_IMPORTED_MODULE_0__Utilities__["g" /* KeyCodes */].alt] = "alt";
    KeytipTransitionModifier[KeytipTransitionModifier["meta"] = __WEBPACK_IMPORTED_MODULE_0__Utilities__["g" /* KeyCodes */].leftWindow] = "meta";
})(KeytipTransitionModifier || (KeytipTransitionModifier = {}));
/**
 * Tests for equality between two IKeytipTransitionKeys.
 *
 * @param key1 - First IKeytipTransitionKey.
 * @param key2 - Second IKeytipTransitionKey.
 * @returns {boolean} T/F if the transition keys are equal.
 */
function transitionKeysAreEqual(key1, key2) {
    if (key1.key !== key2.key) {
        return false;
    }
    var mod1 = key1.modifierKeys;
    var mod2 = key2.modifierKeys;
    if ((!mod1 && mod2) || (mod1 && !mod2)) {
        // Not equal if one modifier is defined and the other isn't
        return false;
    }
    if (mod1 && mod2) {
        if (mod1.length !== mod2.length) {
            return false;
        }
        // Sort both arrays
        mod1 = mod1.sort();
        mod2 = mod2.sort();
        for (var i = 0; i < mod1.length; i++) {
            if (mod1[i] !== mod2[i]) {
                return false;
            }
        }
    }
    return true;
}
/**
 * Tests if 'key' is present in 'keys'.
 *
 * @param keys - Array of IKeytipTransitionKey.
 * @param key - IKeytipTransitionKey to find in 'keys'.
 * @returns {boolean} T/F if 'keys' contains 'key'.
 */
function transitionKeysContain(keys, key) {
    return !!Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["A" /* find */])(keys, function (transitionKey) {
        return transitionKeysAreEqual(transitionKey, key);
    });
}
//# sourceMappingURL=IKeytipTransitionKey.js.map

/***/ }),
/* 1990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MarqueeSelection_MarqueeSelection__ = __webpack_require__(1991);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_selection_index__ = __webpack_require__(119);
/* unused harmony namespace reexport */


//# sourceMappingURL=MarqueeSelection.js.map

/***/ }),
/* 1991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MarqueeSelection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MarqueeSelection_base__ = __webpack_require__(1992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MarqueeSelection_styles__ = __webpack_require__(1993);



var MarqueeSelection = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__MarqueeSelection_base__["a" /* MarqueeSelectionBase */], __WEBPACK_IMPORTED_MODULE_2__MarqueeSelection_styles__["a" /* getStyles */], undefined, {
    scope: 'MarqueeSelection'
});
//# sourceMappingURL=MarqueeSelection.js.map

/***/ }),
/* 1992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MarqueeSelectionBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);



var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["r" /* classNamesFunction */])();
// We want to make the marquee selection start when the user drags a minimum distance. Otherwise we'd start
// the drag even if they just click an item without moving.
var MIN_DRAG_DISTANCE = 5;
/**
 * MarqueeSelection component abstracts managing a draggable rectangle which sets items selected/not selected.
 * Elements which have data-selectable-index attributes are queried and measured once to determine if they
 * fall within the bounds of the rectangle. The measure is memoized during the drag as a performance optimization
 * so if the items change sizes while dragging, that could cause incorrect results.
 */
var MarqueeSelectionBase = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](MarqueeSelectionBase, _super);
    function MarqueeSelectionBase(props) {
        var _this = _super.call(this, props) || this;
        _this._root = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._onMouseDown = function (ev) {
            var _a = _this.props, isEnabled = _a.isEnabled, onShouldStartSelection = _a.onShouldStartSelection;
            // Ensure the mousedown is within the boundaries of the target. If not, it may have been a click on a scrollbar.
            if (_this._isMouseEventOnScrollbar(ev)) {
                return;
            }
            if (_this._isInSelectionToggle(ev)) {
                return;
            }
            if (!_this._isTouch && isEnabled && !_this._isDragStartInSelection(ev) && (!onShouldStartSelection || onShouldStartSelection(ev))) {
                if (_this._scrollableSurface && ev.button === 0 && _this._root.current) {
                    _this._selectedIndicies = {};
                    _this._preservedIndicies = undefined;
                    _this._events.on(window, 'mousemove', _this._onAsyncMouseMove);
                    _this._events.on(_this._scrollableParent, 'scroll', _this._onAsyncMouseMove);
                    _this._events.on(window, 'click', _this._onMouseUp, true);
                    _this._autoScroll = new __WEBPACK_IMPORTED_MODULE_2__Utilities__["b" /* AutoScroll */](_this._root.current);
                    _this._scrollTop = _this._scrollableSurface.scrollTop;
                    _this._rootRect = _this._root.current.getBoundingClientRect();
                    _this._onMouseMove(ev);
                }
            }
        };
        _this._onTouchStart = function (ev) {
            _this._isTouch = true;
            _this._async.setTimeout(function () {
                _this._isTouch = false;
            }, 0);
        };
        _this._onPointerDown = function (ev) {
            if (ev.pointerType === 'touch') {
                _this._isTouch = true;
                _this._async.setTimeout(function () {
                    _this._isTouch = false;
                }, 0);
            }
        };
        _this.state = {
            dragRect: undefined
        };
        return _this;
    }
    MarqueeSelectionBase.prototype.componentDidMount = function () {
        this._scrollableParent = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["D" /* findScrollableParent */])(this._root.current);
        this._scrollableSurface = this._scrollableParent === window ? document.body : this._scrollableParent;
        // When scroll events come from window, we need to read scrollTop values from the body.
        var hitTarget = this.props.isDraggingConstrainedToRoot ? this._root.current : this._scrollableSurface;
        this._events.on(hitTarget, 'mousedown', this._onMouseDown);
        this._events.on(hitTarget, 'touchstart', this._onTouchStart, true);
        this._events.on(hitTarget, 'pointerdown', this._onPointerDown, true);
    };
    MarqueeSelectionBase.prototype.componentWillUnmount = function () {
        if (this._autoScroll) {
            this._autoScroll.dispose();
        }
        delete this._scrollableParent;
        delete this._scrollableSurface;
    };
    MarqueeSelectionBase.prototype.render = function () {
        var _a = this.props, rootProps = _a.rootProps, children = _a.children, theme = _a.theme, className = _a.className, styles = _a.styles;
        var dragRect = this.state.dragRect;
        var classNames = getClassNames(styles, {
            theme: theme,
            className: className
        });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, rootProps, { className: classNames.root, ref: this._root }),
            children,
            dragRect && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.dragMask }),
            dragRect && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.box, style: dragRect },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.boxFill })))));
    };
    /** Determine if the mouse event occured on a scrollbar of the target element. */
    MarqueeSelectionBase.prototype._isMouseEventOnScrollbar = function (ev) {
        var targetElement = ev.target;
        var targetScrollbarWidth = targetElement.offsetWidth - targetElement.clientWidth;
        if (targetScrollbarWidth) {
            var targetRect = targetElement.getBoundingClientRect();
            // Check vertical scroll
            if (Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["V" /* getRTL */])()) {
                if (ev.clientX < targetRect.left + targetScrollbarWidth) {
                    return true;
                }
            }
            else {
                if (ev.clientX > targetRect.left + targetElement.clientWidth) {
                    return true;
                }
            }
            // Check horizontal scroll
            if (ev.clientY > targetRect.top + targetElement.clientHeight) {
                return true;
            }
        }
        return false;
    };
    MarqueeSelectionBase.prototype._getRootRect = function () {
        return {
            left: this._rootRect.left,
            top: this._rootRect.top + (this._scrollTop - this._scrollableSurface.scrollTop),
            width: this._rootRect.width,
            height: this._rootRect.height
        };
    };
    MarqueeSelectionBase.prototype._onAsyncMouseMove = function (ev) {
        var _this = this;
        this._async.requestAnimationFrame(function () {
            _this._onMouseMove(ev);
        });
        ev.stopPropagation();
        ev.preventDefault();
    };
    MarqueeSelectionBase.prototype._onMouseMove = function (ev) {
        if (!this._autoScroll) {
            return;
        }
        if (ev.clientX !== undefined) {
            this._lastMouseEvent = ev;
        }
        var rootRect = this._getRootRect();
        var currentPoint = { x: ev.clientX - rootRect.left, y: ev.clientY - rootRect.top };
        if (!this._dragOrigin) {
            this._dragOrigin = currentPoint;
        }
        if (ev.buttons !== undefined && ev.buttons === 0) {
            this._onMouseUp(ev);
        }
        else {
            if (this.state.dragRect || Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["H" /* getDistanceBetweenPoints */])(this._dragOrigin, currentPoint) > MIN_DRAG_DISTANCE) {
                if (!this.state.dragRect) {
                    var selection = this.props.selection;
                    if (!ev.shiftKey) {
                        selection.setAllSelected(false);
                    }
                    this._preservedIndicies = selection && selection.getSelectedIndices && selection.getSelectedIndices();
                }
                // We need to constrain the current point to the rootRect boundaries.
                var constrainedPoint = this.props.isDraggingConstrainedToRoot
                    ? {
                        x: Math.max(0, Math.min(rootRect.width, this._lastMouseEvent.clientX - rootRect.left)),
                        y: Math.max(0, Math.min(rootRect.height, this._lastMouseEvent.clientY - rootRect.top))
                    }
                    : {
                        x: this._lastMouseEvent.clientX - rootRect.left,
                        y: this._lastMouseEvent.clientY - rootRect.top
                    };
                var dragRect = {
                    left: Math.min(this._dragOrigin.x, constrainedPoint.x),
                    top: Math.min(this._dragOrigin.y, constrainedPoint.y),
                    width: Math.abs(constrainedPoint.x - this._dragOrigin.x),
                    height: Math.abs(constrainedPoint.y - this._dragOrigin.y)
                };
                this._evaluateSelection(dragRect, rootRect);
                this.setState({ dragRect: dragRect });
            }
        }
        return false;
    };
    MarqueeSelectionBase.prototype._onMouseUp = function (ev) {
        this._events.off(window);
        this._events.off(this._scrollableParent, 'scroll');
        if (this._autoScroll) {
            this._autoScroll.dispose();
        }
        this._autoScroll = this._dragOrigin = this._lastMouseEvent = this._selectedIndicies = this._itemRectCache = undefined;
        if (this.state.dragRect) {
            this.setState({
                dragRect: undefined
            });
            ev.preventDefault();
            ev.stopPropagation();
        }
    };
    MarqueeSelectionBase.prototype._isPointInRectangle = function (rectangle, point) {
        return rectangle.top < point.y && rectangle.bottom > point.y && rectangle.left < point.x && rectangle.right > point.x;
    };
    /**
     * We do not want to start the marquee if we're trying to marquee
     * from within an existing marquee selection.
     */
    MarqueeSelectionBase.prototype._isDragStartInSelection = function (ev) {
        var selection = this.props.selection;
        if (!this._root.current || (selection && selection.getSelectedCount() === 0)) {
            return false;
        }
        var allElements = this._root.current.querySelectorAll('[data-selection-index]');
        for (var i = 0; i < allElements.length; i++) {
            var element = allElements[i];
            var index = Number(element.getAttribute('data-selection-index'));
            if (selection.isIndexSelected(index)) {
                var itemRect = element.getBoundingClientRect();
                if (this._isPointInRectangle(itemRect, { x: ev.clientX, y: ev.clientY })) {
                    return true;
                }
            }
        }
        return false;
    };
    MarqueeSelectionBase.prototype._isInSelectionToggle = function (ev) {
        var element = ev.target;
        while (element && element !== this._root.current) {
            if (element.getAttribute('data-selection-toggle') === 'true') {
                return true;
            }
            element = element.parentElement;
        }
        return false;
    };
    MarqueeSelectionBase.prototype._evaluateSelection = function (dragRect, rootRect) {
        // Break early if we don't need to evaluate.
        if (!dragRect || !this._root.current) {
            return;
        }
        var selection = this.props.selection;
        var allElements = this._root.current.querySelectorAll('[data-selection-index]');
        if (!this._itemRectCache) {
            this._itemRectCache = {};
        }
        for (var i = 0; i < allElements.length; i++) {
            var element = allElements[i];
            var index = element.getAttribute('data-selection-index');
            // Pull the memoized rectangle for the item, or the get the rect and memoize.
            var itemRect = this._itemRectCache[index];
            if (!itemRect) {
                itemRect = element.getBoundingClientRect();
                // Normalize the item rect to the dragRect coordinates.
                itemRect = {
                    left: itemRect.left - rootRect.left,
                    top: itemRect.top - rootRect.top,
                    width: itemRect.width,
                    height: itemRect.height,
                    right: itemRect.left - rootRect.left + itemRect.width,
                    bottom: itemRect.top - rootRect.top + itemRect.height
                };
                if (itemRect.width > 0 && itemRect.height > 0) {
                    this._itemRectCache[index] = itemRect;
                }
            }
            if (itemRect.top < dragRect.top + dragRect.height &&
                itemRect.bottom > dragRect.top &&
                itemRect.left < dragRect.left + dragRect.width &&
                itemRect.right > dragRect.left) {
                this._selectedIndicies[index] = true;
            }
            else {
                delete this._selectedIndicies[index];
            }
        }
        // set previousSelectedIndices to be all of the selected indices from last time
        var previousSelectedIndices = this._allSelectedIndices || {};
        this._allSelectedIndices = {};
        // set all indices that are supposed to be selected in _allSelectedIndices
        for (var index in this._selectedIndicies) {
            if (this._selectedIndicies.hasOwnProperty(index)) {
                this._allSelectedIndices[index] = true;
            }
        }
        if (this._preservedIndicies) {
            for (var _i = 0, _a = this._preservedIndicies; _i < _a.length; _i++) {
                var index = _a[_i];
                this._allSelectedIndices[index] = true;
            }
        }
        // check if needs to update selection, only when current _allSelectedIndices
        // is different than previousSelectedIndices
        var needToUpdate = false;
        for (var index in this._allSelectedIndices) {
            if (this._allSelectedIndices[index] !== previousSelectedIndices[index]) {
                needToUpdate = true;
                break;
            }
        }
        if (!needToUpdate) {
            for (var index in previousSelectedIndices) {
                if (this._allSelectedIndices[index] !== previousSelectedIndices[index]) {
                    needToUpdate = true;
                    break;
                }
            }
        }
        // only update selection when needed
        if (needToUpdate) {
            // Stop change events, clear selection to re-populate.
            selection.setChangeEvents(false);
            selection.setAllSelected(false);
            for (var _b = 0, _c = Object.keys(this._allSelectedIndices); _b < _c.length; _b++) {
                var index = _c[_b];
                selection.setIndexSelected(Number(index), true, false);
            }
            selection.setChangeEvents(true);
        }
    };
    MarqueeSelectionBase.defaultProps = {
        rootTagName: 'div',
        rootProps: {},
        isEnabled: true
    };
    return MarqueeSelectionBase;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=MarqueeSelection.base.js.map

/***/ }),
/* 1993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var getStyles = function (props) {
    var theme = props.theme, className = props.className;
    var palette = theme.palette;
    return {
        root: [
            className,
            {
                position: 'relative',
                cursor: 'default'
            }
        ],
        dragMask: [
            {
                position: 'absolute',
                background: 'rgba(255, 0, 0, 0)',
                left: 0,
                top: 0,
                right: 0,
                bottom: 0,
                selectors: (_a = {},
                    _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        background: 'none',
                        backgroundColor: 'transparent'
                    },
                    _a)
            }
        ],
        box: [
            {
                position: 'absolute',
                boxSizing: 'border-box',
                border: "1px solid " + palette.themePrimary,
                pointerEvents: 'none',
                zIndex: 10,
                selectors: (_b = {},
                    _b[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        borderColor: 'Highlight'
                    },
                    _b)
            }
        ],
        boxFill: [
            {
                position: 'absolute',
                boxSizing: 'border-box',
                backgroundColor: palette.themePrimary,
                opacity: 0.1,
                left: 0,
                top: 0,
                right: 0,
                bottom: 0,
                selectors: (_c = {},
                    _c[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        background: 'none',
                        backgroundColor: 'transparent'
                    },
                    _c)
            }
        ]
    };
    var _a, _b, _c;
};
//# sourceMappingURL=MarqueeSelection.styles.js.map

/***/ }),
/* 1994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MessageBar__ = __webpack_require__(1995);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__MessageBar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MessageBar_base__ = __webpack_require__(799);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MessageBar_types__ = __webpack_require__(439);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__MessageBar_types__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 1995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MessageBar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MessageBar_base__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MessageBar_styles__ = __webpack_require__(1996);



var MessageBar = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__MessageBar_base__["a" /* MessageBarBase */], __WEBPACK_IMPORTED_MODULE_2__MessageBar_styles__["a" /* getStyles */], undefined, {
    scope: 'MessageBar'
});
//# sourceMappingURL=MessageBar.js.map

/***/ }),
/* 1996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MessageBar_types__ = __webpack_require__(439);



var GlobalClassNames = {
    root: 'ms-MessageBar',
    error: 'ms-MessageBar--error',
    blocked: 'ms-MessageBar--blocked',
    severeWarning: 'ms-MessageBar--severeWarning',
    success: 'ms-MessageBar--success',
    warning: 'ms-MessageBar--warning',
    multiline: 'ms-MessageBar-multiline',
    singleline: 'ms-MessageBar-singleline',
    dismissalSingleLine: 'ms-MessageBar-dismissalSingleLine',
    expandingSingleLine: 'ms-MessageBar-expandingSingleLine',
    content: 'ms-MessageBar-content',
    iconContainer: 'ms-MessageBar-icon',
    text: 'ms-MessageBar-text',
    innerText: 'ms-MessageBar-innerText',
    dismissSingleLine: 'ms-MessageBar-dismissSingleLine',
    expandSingleLine: 'ms-MessageBar-expandSingleLine',
    dismissal: 'ms-MessageBar-dismissal',
    expand: 'ms-MessageBar-expand',
    actions: 'ms-MessageBar-actions',
    actionsSingleline: 'ms-MessageBar-actionsSingleLine'
};
// Returns the background color of the MessageBar root element based on the type of MessageBar.
var getRootBackground = function (messageBarType, palette, semanticColors) {
    switch (messageBarType) {
        case __WEBPACK_IMPORTED_MODULE_2__MessageBar_types__["a" /* MessageBarType */].error:
        case __WEBPACK_IMPORTED_MODULE_2__MessageBar_types__["a" /* MessageBarType */].blocked:
            return semanticColors.errorBackground;
        case __WEBPACK_IMPORTED_MODULE_2__MessageBar_types__["a" /* MessageBarType */].severeWarning:
            return semanticColors.blockingBackground;
        case __WEBPACK_IMPORTED_MODULE_2__MessageBar_types__["a" /* MessageBarType */].success:
            return semanticColors.successBackground;
        case __WEBPACK_IMPORTED_MODULE_2__MessageBar_types__["a" /* MessageBarType */].warning:
            return semanticColors.warningBackground;
    }
    return palette.neutralLighter;
};
// Returns the icon color based on the type of MessageBar.
var getIconColor = function (messageBarType, palette, semanticColors) {
    switch (messageBarType) {
        case __WEBPACK_IMPORTED_MODULE_2__MessageBar_types__["a" /* MessageBarType */].error:
        case __WEBPACK_IMPORTED_MODULE_2__MessageBar_types__["a" /* MessageBarType */].blocked:
        case __WEBPACK_IMPORTED_MODULE_2__MessageBar_types__["a" /* MessageBarType */].severeWarning:
            return semanticColors.errorText;
        case __WEBPACK_IMPORTED_MODULE_2__MessageBar_types__["a" /* MessageBarType */].success:
            return palette.green;
        case __WEBPACK_IMPORTED_MODULE_2__MessageBar_types__["a" /* MessageBarType */].warning:
            return semanticColors.warningText;
    }
    return palette.neutralSecondary;
};
var getStyles = function (props) {
    var theme = props.theme, className = props.className, messageBarType = props.messageBarType, onDismiss = props.onDismiss, actions = props.actions, truncated = props.truncated, isMultiline = props.isMultiline, expandSingleLine = props.expandSingleLine;
    var semanticColors = theme.semanticColors, palette = theme.palette, fonts = theme.fonts;
    var SmallScreenSelector = Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["z" /* getScreenSelector */])(0, __WEBPACK_IMPORTED_MODULE_1__Styling__["m" /* ScreenWidthMaxSmall */]);
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    var dismissalAndExpandIconStyle = {
        fontSize: 12,
        height: 12,
        lineHeight: '12px',
        color: palette.neutralPrimary,
        selectors: (_a = {},
            _a[__WEBPACK_IMPORTED_MODULE_1__Styling__["g" /* HighContrastSelector */]] = {
                MsHighContrastAdjust: 'none',
                color: 'window'
            },
            _a)
    };
    var dismissalAndExpandSingleLineStyle = {
        display: 'flex',
        selectors: {
            '& .ms-Button-icon': dismissalAndExpandIconStyle
        }
    };
    var dismissalAndExpandStyle = [
        Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["v" /* getFocusStyle */])(theme, {
            inset: 1,
            highContrastStyle: {
                outlineOffset: '-4px',
                outlineColor: 'Window'
            },
            borderColor: 'transparent'
        }),
        {
            flexShrink: 0,
            margin: 8,
            marginLeft: 0,
            selectors: (_b = {
                    '& .ms-Button-icon': dismissalAndExpandIconStyle
                },
                _b[SmallScreenSelector] = {
                    margin: '0px 0px 0px 8px'
                },
                _b)
        }
    ];
    var focusStyle = Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["v" /* getFocusStyle */])(theme, { borderColor: palette.black });
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            messageBarType === __WEBPACK_IMPORTED_MODULE_2__MessageBar_types__["a" /* MessageBarType */].error && classNames.error,
            messageBarType === __WEBPACK_IMPORTED_MODULE_2__MessageBar_types__["a" /* MessageBarType */].blocked && classNames.blocked,
            messageBarType === __WEBPACK_IMPORTED_MODULE_2__MessageBar_types__["a" /* MessageBarType */].severeWarning && classNames.severeWarning,
            messageBarType === __WEBPACK_IMPORTED_MODULE_2__MessageBar_types__["a" /* MessageBarType */].success && classNames.success,
            messageBarType === __WEBPACK_IMPORTED_MODULE_2__MessageBar_types__["a" /* MessageBarType */].warning && classNames.warning,
            isMultiline ? classNames.multiline : classNames.singleline,
            !isMultiline && onDismiss && classNames.dismissalSingleLine,
            !isMultiline && truncated && classNames.expandingSingleLine,
            {
                background: getRootBackground(messageBarType, palette, semanticColors),
                color: palette.neutralPrimary,
                minHeight: 32,
                width: '100%',
                boxSizing: 'border-box',
                display: 'flex',
                wordBreak: 'break-word',
                selectors: (_c = {
                        '& .ms-Link': __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ color: palette.themeDark }, fonts.small)
                    },
                    _c[__WEBPACK_IMPORTED_MODULE_1__Styling__["g" /* HighContrastSelector */]] = {
                        background: 'windowText',
                        color: 'Window'
                    },
                    _c)
            },
            isMultiline && {
                flexDirection: 'column'
            },
            !isMultiline && {
                selectors: (_d = {},
                    _d[SmallScreenSelector] = {
                        flexDirection: 'column'
                    },
                    _d)
            },
            truncated && {
                flexDirection: 'column',
                selectors: {
                    '& .ms-Button-icon': dismissalAndExpandIconStyle
                }
            },
            className
        ],
        content: [
            classNames.content,
            {
                display: 'flex',
                lineHeight: 'normal',
                width: '100%',
                boxSizing: 'border-box'
            },
            !isMultiline && {
                selectors: (_e = {},
                    _e[SmallScreenSelector] = {
                        flexDirection: 'row'
                    },
                    _e)
            },
            (truncated || isMultiline) && {
                flexDirection: 'row'
            }
        ],
        iconContainer: [
            classNames.iconContainer,
            {
                fontSize: 16,
                minWidth: 16,
                minHeight: 16,
                display: 'flex',
                color: palette.neutralSecondary,
                flexShrink: 0,
                margin: 16,
                marginRight: 0,
                selectors: (_f = {},
                    _f[SmallScreenSelector] = {
                        margin: '8px 0px 8px 8px'
                    },
                    _f)
            }
        ],
        icon: {
            color: getIconColor(messageBarType, palette, semanticColors),
            selectors: (_g = {},
                _g[__WEBPACK_IMPORTED_MODULE_1__Styling__["g" /* HighContrastSelector */]] = {
                    MsHighContrastAdjust: 'none',
                    color: 'window'
                },
                _g)
        },
        text: [
            classNames.text,
            __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ minWidth: 0, display: 'flex', flexGrow: 1, margin: '16px 8px' }, fonts.small, { selectors: (_h = {},
                    _h[SmallScreenSelector] = {
                        margin: '8px 0px 8px 8px'
                    },
                    _h[__WEBPACK_IMPORTED_MODULE_1__Styling__["g" /* HighContrastSelector */]] = {
                        MsHighContrastAdjust: 'none',
                        color: 'window'
                    },
                    _h) }),
            !onDismiss && {
                marginRight: 16,
                selectors: (_j = {},
                    _j[SmallScreenSelector] = {
                        marginRight: 8
                    },
                    _j)
            },
            isMultiline &&
                actions && {
                marginBottom: 8,
                selectors: (_k = {},
                    _k[SmallScreenSelector] = {
                        marginBottom: 0
                    },
                    _k)
            },
            !isMultiline &&
                actions && {
                selectors: (_l = {},
                    _l[SmallScreenSelector] = {
                        marginBottom: 0
                    },
                    _l)
            }
        ],
        innerText: [
            classNames.innerText,
            {
                lineHeight: 16,
                selectors: {
                    '& span': {
                        selectors: {
                            '& a': {
                                paddingLeft: 4
                            }
                        }
                    }
                }
            },
            truncated && {
                overflow: 'visible',
                whiteSpace: 'pre-wrap'
            },
            !isMultiline && {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            },
            !isMultiline &&
                !truncated && {
                selectors: (_m = {},
                    _m[SmallScreenSelector] = {
                        overflow: 'visible',
                        whiteSpace: 'pre-wrap'
                    },
                    _m)
            },
            expandSingleLine && {
                overflow: 'visible',
                whiteSpace: 'pre-wrap'
            }
        ],
        dismissSingleLine: [classNames.dismissSingleLine, dismissalAndExpandSingleLineStyle],
        expandSingleLine: [classNames.expandSingleLine, dismissalAndExpandSingleLineStyle],
        dismissal: [classNames.dismissal, dismissalAndExpandStyle, focusStyle],
        expand: [classNames.expand, dismissalAndExpandStyle, focusStyle],
        actions: [
            isMultiline ? classNames.actions : classNames.actionsSingleline,
            {
                display: 'flex',
                flexGrow: 0,
                flexShrink: 0,
                flexBasis: 'auto',
                flexDirection: 'row-reverse',
                alignItems: 'center',
                margin: '8px 8px 8px 0',
                selectors: {
                    '& button:nth-child(n+2)': {
                        marginLeft: 8
                    }
                }
            },
            isMultiline && {
                margin: '0px 12px 12px 0',
                selectors: {
                    '& button:nth-child(n+2)': {
                        marginLeft: 12
                    }
                }
            }
        ]
    };
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
};
//# sourceMappingURL=MessageBar.styles.js.map

/***/ }),
/* 1997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Nav_index__ = __webpack_require__(1998);
/* unused harmony namespace reexport */

//# sourceMappingURL=Nav.js.map

/***/ }),
/* 1998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Nav__ = __webpack_require__(1999);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Nav_base__ = __webpack_require__(800);
/* unused harmony namespace reexport */


//# sourceMappingURL=index.js.map

/***/ }),
/* 1999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Nav */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Nav_base__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Nav_styles__ = __webpack_require__(801);



var Nav = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__Nav_base__["a" /* NavBase */], __WEBPACK_IMPORTED_MODULE_2__Nav_styles__["b" /* getStyles */], undefined, {
    scope: 'Nav'
});
//# sourceMappingURL=Nav.js.map

/***/ }),
/* 2000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Pivot_index__ = __webpack_require__(2001);
/* unused harmony namespace reexport */

//# sourceMappingURL=Pivot.js.map

/***/ }),
/* 2001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pivot__ = __webpack_require__(2002);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Pivot_base__ = __webpack_require__(802);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PivotItem__ = __webpack_require__(803);
/* unused harmony reexport PivotItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Pivot_types__ = __webpack_require__(440);
/* unused harmony namespace reexport */




//# sourceMappingURL=index.js.map

/***/ }),
/* 2002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Pivot */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Pivot_base__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Pivot_styles__ = __webpack_require__(2003);



/**
 * The Pivot control and related tabs pattern are used for navigating frequently accessed,
 * distinct content categories. Pivots allow for navigation between two or more content
 * views and relies on text headers to articulate the different sections of content.
 */
var Pivot = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__Pivot_base__["a" /* PivotBase */], __WEBPACK_IMPORTED_MODULE_2__Pivot_styles__["a" /* getStyles */], undefined, {
    scope: 'Pivot'
});
//# sourceMappingURL=Pivot.js.map

/***/ }),
/* 2003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utilities__ = __webpack_require__(1);


var globalClassNames = {
    count: 'ms-Pivot-count',
    icon: 'ms-Pivot-icon',
    linkIsSelected: 'is-selected',
    link: 'ms-Pivot-link',
    linkContent: 'ms-Pivot-linkContent',
    root: 'ms-Pivot',
    rootIsLarge: 'ms-Pivot--large',
    rootIsTabs: 'ms-Pivot--tabs',
    text: 'ms-Pivot-text'
};
var linkStyles = function (props) {
    var rootIsLarge = props.rootIsLarge, rootIsTabs = props.rootIsTabs;
    var _a = props.theme, palette = _a.palette, semanticColors = _a.semanticColors;
    return [
        {
            color: semanticColors.actionLink,
            display: 'inline-block',
            fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].medium,
            fontWeight: __WEBPACK_IMPORTED_MODULE_0__Styling__["f" /* FontWeights */].regular,
            lineHeight: '40px',
            marginRight: '8px',
            padding: '0 8px',
            textAlign: 'center',
            position: 'relative',
            backgroundColor: 'transparent',
            border: 0,
            selectors: (_b = {
                    ':before': {
                        backgroundColor: 'transparent',
                        bottom: 0,
                        content: '""',
                        height: '2px',
                        left: '8px',
                        position: 'absolute',
                        right: '8px',
                        transition: "background-color " + __WEBPACK_IMPORTED_MODULE_0__Styling__["c" /* AnimationVariables */].durationValue2 + " " + __WEBPACK_IMPORTED_MODULE_0__Styling__["c" /* AnimationVariables */].easeFunction2
                    },
                    ':after': {
                        color: 'transparent',
                        content: 'attr(data-content)',
                        display: 'block',
                        fontWeight: __WEBPACK_IMPORTED_MODULE_0__Styling__["f" /* FontWeights */].bold,
                        height: '1px',
                        overflow: 'hidden',
                        visibility: 'hidden'
                    },
                    ':hover': {
                        color: semanticColors.actionLinkHovered,
                        cursor: 'pointer'
                    },
                    ':focus': {
                        outline: 'none'
                    }
                },
                _b["." + __WEBPACK_IMPORTED_MODULE_1__Utilities__["f" /* IsFocusVisibleClassName */] + " &:focus"] = {
                    outline: "1px solid " + semanticColors.focusBorder
                },
                _b["." + __WEBPACK_IMPORTED_MODULE_1__Utilities__["f" /* IsFocusVisibleClassName */] + " &:focus:after"] = {
                    content: 'attr(data-content)',
                    position: 'relative',
                    border: 0
                },
                _b)
        },
        rootIsLarge && {
            fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].large
        },
        rootIsTabs && [
            {
                marginRight: 0,
                height: '40px',
                lineHeight: '40px',
                backgroundColor: palette.neutralLighter,
                padding: '0 10px',
                verticalAlign: 'top',
                selectors: (_c = {
                        ':focus': {
                            outlineOffset: '-1px'
                        }
                    },
                    _c["." + __WEBPACK_IMPORTED_MODULE_1__Utilities__["f" /* IsFocusVisibleClassName */] + " &:focus::before"] = {
                        height: 'auto',
                        background: 'transparent',
                        transition: 'none'
                    },
                    _c)
            }
        ]
    ];
    var _b, _c;
};
var getStyles = function (props) {
    var className = props.className, rootIsLarge = props.rootIsLarge, rootIsTabs = props.rootIsTabs, theme = props.theme;
    var palette = theme.palette, semanticColors = theme.semanticColors;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(globalClassNames, theme);
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            __WEBPACK_IMPORTED_MODULE_0__Styling__["H" /* normalize */],
            {
                fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].medium,
                fontWeight: __WEBPACK_IMPORTED_MODULE_0__Styling__["f" /* FontWeights */].regular,
                position: 'relative',
                color: palette.themePrimary,
                whiteSpace: 'nowrap'
            },
            rootIsLarge && classNames.rootIsLarge,
            rootIsTabs && classNames.rootIsTabs,
            className
        ],
        link: [
            classNames.link
        ].concat(linkStyles(props), [
            {
                selectors: {
                    ':hover::before': {
                        boxSizing: 'border-box',
                        borderBottom: '2px solid transparent'
                    }
                }
            },
            rootIsTabs && {
                selectors: {
                    '&:hover, &:focus': {
                        color: palette.black
                    },
                    ':active': {
                        backgroundColor: palette.themePrimary
                    }
                }
            }
        ]),
        linkIsSelected: [
            classNames.link,
            classNames.linkIsSelected
        ].concat(linkStyles(props), [
            {
                fontWeight: __WEBPACK_IMPORTED_MODULE_0__Styling__["f" /* FontWeights */].semibold,
                selectors: (_a = {
                        ':before': {
                            boxSizing: 'border-box',
                            borderBottom: "2px solid " + semanticColors.inputBackgroundChecked,
                            selectors: (_b = {},
                                _b[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                                    borderBottomColor: 'Highlight'
                                },
                                _b)
                        }
                    },
                    _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        color: 'Highlight'
                    },
                    _a)
            },
            rootIsTabs && {
                backgroundColor: palette.themePrimary,
                color: palette.white,
                fontWeight: __WEBPACK_IMPORTED_MODULE_0__Styling__["f" /* FontWeights */].semilight,
                selectors: (_c = {
                        ':before': {
                            backgroundColor: 'transparent',
                            transition: 'none',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            content: '""',
                            height: 'auto'
                        },
                        '&:active, &:hover': {
                            color: palette.white
                        }
                    },
                    _c[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        fontWeight: __WEBPACK_IMPORTED_MODULE_0__Styling__["f" /* FontWeights */].semibold,
                        color: 'HighlightText',
                        background: 'Highlight',
                        MsHighContrastAdjust: 'none'
                    },
                    _c)
            }
        ]),
        linkContent: [classNames.linkContent],
        text: [
            classNames.text,
            {
                display: 'inline-block',
                verticalAlign: 'top'
            }
        ],
        count: [
            classNames.count,
            {
                marginLeft: '4px',
                display: 'inline-block',
                verticalAlign: 'top'
            }
        ],
        icon: [
            classNames.icon,
            {
                selectors: {
                    '& + $text': {
                        marginLeft: '4px'
                    }
                }
            }
        ]
    };
    var _a, _b, _c;
};
//# sourceMappingURL=Pivot.styles.js.map

/***/ }),
/* 2004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Coachmark_PositioningContainer_index__ = __webpack_require__(750);
/* unused harmony namespace reexport */

//# sourceMappingURL=PositioningContainer.js.map

/***/ }),
/* 2005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ProgressIndicator_index__ = __webpack_require__(2006);
/* unused harmony namespace reexport */

//# sourceMappingURL=ProgressIndicator.js.map

/***/ }),
/* 2006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProgressIndicator__ = __webpack_require__(2007);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProgressIndicator_base__ = __webpack_require__(804);
/* unused harmony namespace reexport */


//# sourceMappingURL=index.js.map

/***/ }),
/* 2007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProgressIndicator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProgressIndicator_base__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProgressIndicator_styles__ = __webpack_require__(2008);



/**
 * ProgressIndicator description
 */
var ProgressIndicator = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__ProgressIndicator_base__["a" /* ProgressIndicatorBase */], __WEBPACK_IMPORTED_MODULE_2__ProgressIndicator_styles__["a" /* getStyles */], undefined, { scope: 'ProgressIndicator' });
//# sourceMappingURL=ProgressIndicator.js.map

/***/ }),
/* 2008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utilities__ = __webpack_require__(1);


var GlobalClassNames = {
    root: 'ms-ProgressIndicator',
    itemName: 'ms-ProgressIndicator-itemName',
    itemDescription: 'ms-ProgressIndicator-itemDescription',
    itemProgress: 'ms-ProgressIndicator-itemProgress',
    progressTrack: 'ms-ProgressIndicator-progressTrack',
    progressBar: 'ms-ProgressIndicator-progressBar'
};
var IndeterminateProgress = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["C" /* keyframes */])({
    '0%': {
        left: '-30%'
    },
    '100%': {
        left: '100%'
    }
});
var IndeterminateProgressRTL = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["C" /* keyframes */])({
    '100%': {
        right: '-30%'
    },
    '0%': {
        right: '100%'
    }
});
var getStyles = function (props) {
    var isRTL = Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["V" /* getRTL */])();
    var className = props.className, indeterminate = props.indeterminate, theme = props.theme, _a = props.barHeight, barHeight = _a === void 0 ? 2 : _a;
    var palette = theme.palette, semanticColors = theme.semanticColors;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    var marginBetweenText = 8;
    var textHeight = 18;
    var progressTrackColor = palette.neutralLight;
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            {
                fontWeight: __WEBPACK_IMPORTED_MODULE_0__Styling__["f" /* FontWeights */].regular
            },
            className
        ],
        itemName: [
            classNames.itemName,
            __WEBPACK_IMPORTED_MODULE_0__Styling__["G" /* noWrap */],
            {
                color: semanticColors.bodyText,
                fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].medium,
                paddingTop: marginBetweenText / 2,
                lineHeight: textHeight + 2
            }
        ],
        itemDescription: [
            classNames.itemDescription,
            {
                color: semanticColors.bodySubtext,
                fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].xSmall,
                lineHeight: textHeight
            }
        ],
        itemProgress: [
            classNames.itemProgress,
            {
                position: 'relative',
                overflow: 'hidden',
                height: barHeight,
                padding: marginBetweenText + "px 0"
            }
        ],
        progressTrack: [
            classNames.progressTrack,
            {
                position: 'absolute',
                width: '100%',
                height: barHeight,
                backgroundColor: progressTrackColor,
                selectors: (_b = {},
                    _b[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        borderBottom: '1px solid WindowText'
                    },
                    _b)
            }
        ],
        progressBar: [
            {
                backgroundColor: palette.themePrimary,
                height: barHeight,
                position: 'absolute',
                transition: 'width .3s ease',
                width: 0,
                selectors: (_c = {},
                    _c[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        backgroundColor: 'WindowText'
                    },
                    _c)
            },
            indeterminate
                ? {
                    position: 'absolute',
                    minWidth: '33%',
                    background: "linear-gradient(to right, " + progressTrackColor + " 0%, " + palette.themePrimary + " 50%, " + progressTrackColor + " 100%)",
                    animation: (isRTL ? IndeterminateProgressRTL : IndeterminateProgress) + " 3s infinite"
                }
                : {
                    transition: 'width .15s linear'
                },
            classNames.progressBar
        ]
    };
    var _b, _c;
};
//# sourceMappingURL=ProgressIndicator.styles.js.map

/***/ }),
/* 2009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Rating_index__ = __webpack_require__(2010);
/* unused harmony namespace reexport */

//# sourceMappingURL=Rating.js.map

/***/ }),
/* 2010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Rating__ = __webpack_require__(2011);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Rating_base__ = __webpack_require__(805);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Rating_types__ = __webpack_require__(806);
/* unused harmony namespace reexport */



//# sourceMappingURL=index.js.map

/***/ }),
/* 2011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Rating */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Rating_styles__ = __webpack_require__(2012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Rating_base__ = __webpack_require__(805);



var Rating = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_2__Rating_base__["a" /* RatingBase */], __WEBPACK_IMPORTED_MODULE_1__Rating_styles__["a" /* getStyles */], undefined, { scope: 'Rating' });
//# sourceMappingURL=Rating.js.map

/***/ }),
/* 2012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStyles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var GlobalClassNames = {
    root: 'ms-RatingStar-root',
    rootIsSmall: 'ms-RatingStar-root--small',
    rootIsLarge: 'ms-RatingStar-root--large',
    ratingStar: 'ms-RatingStar-container',
    ratingStarBack: 'ms-RatingStar-back',
    ratingStarFront: 'ms-RatingStar-front',
    ratingButton: 'ms-Rating-button',
    ratingStarIsSmall: 'ms-Rating--small',
    ratingStartIsLarge: 'ms-Rating--large',
    labelText: 'ms-Rating-labelText',
    ratingFocusZone: 'ms-Rating-focuszone'
};
function _getColorWithHighContrast(color, highContrastColor) {
    return {
        color: color,
        selectors: (_a = {},
            _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                color: highContrastColor
            },
            _a)
    };
    var _a;
}
function getStyles(props) {
    var disabled = props.disabled, readOnly = props.readOnly, theme = props.theme;
    var semanticColors = theme.semanticColors, palette = theme.palette;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    var ratingSmallIconSize = 16;
    var ratingLargeIconSize = 20;
    var ratingVerticalPadding = 8;
    var ratingHorizontalPadding = 2;
    var ratingStarUncheckedColor = palette.neutralTertiary;
    var ratingStarUncheckedHoverColor = palette.themePrimary;
    var ratingStarUncheckedHoverSelectedColor = palette.themeDark;
    var ratingStarCheckedColor = semanticColors.bodyTextChecked;
    var ratingStarDisabledColor = semanticColors.disabledBodySubtext;
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            !disabled &&
                !readOnly && {
                selectors: {
                    // This is part 1 of highlighting all stars up to the one the user is hovering over
                    '&:hover': {
                        selectors: {
                            '.ms-RatingStar-back': _getColorWithHighContrast(ratingStarCheckedColor, 'Highlight')
                        }
                    }
                }
            }
        ],
        rootIsSmall: [
            classNames.rootIsSmall,
            {
                height: ratingSmallIconSize + ratingVerticalPadding * 2 + 'px'
            }
        ],
        rootIsLarge: [
            classNames.rootIsLarge,
            {
                height: ratingLargeIconSize + ratingVerticalPadding * 2 + 'px'
            }
        ],
        ratingStar: [
            classNames.ratingStar,
            {
                display: 'inline-block',
                position: 'relative',
                height: 'inherit'
            }
        ],
        ratingStarBack: [
            classNames.ratingStarBack,
            {
                // TODO: Use a proper semantic color for this
                color: ratingStarUncheckedColor,
                width: '100%'
            },
            disabled && _getColorWithHighContrast(ratingStarDisabledColor, 'GrayText')
        ],
        ratingStarFront: [
            classNames.ratingStarFront,
            {
                position: 'absolute',
                height: '100 %',
                left: '0',
                top: '0',
                textAlign: 'center',
                verticalAlign: 'middle',
                overflow: 'hidden'
            },
            _getColorWithHighContrast(ratingStarCheckedColor, 'Highlight')
        ],
        ratingButton: [
            Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["v" /* getFocusStyle */])(theme),
            classNames.ratingButton,
            {
                backgroundColor: 'transparent',
                padding: ratingVerticalPadding + "px " + ratingHorizontalPadding + "px",
                boxSizing: 'content-box',
                margin: '0px',
                border: 'none',
                cursor: 'pointer',
                selectors: {
                    '&:disabled': {
                        cursor: 'default'
                    },
                    '&[disabled]': {
                        cursor: 'default'
                    }
                }
            },
            !disabled &&
                !readOnly && {
                selectors: {
                    // This is part 2 of highlighting all stars up to the one the user is hovering over
                    '&:hover ~ .ms-Rating-button': {
                        selectors: {
                            '.ms-RatingStar-back': _getColorWithHighContrast(ratingStarUncheckedColor, 'WindowText'),
                            '.ms-RatingStar-front': _getColorWithHighContrast(ratingStarUncheckedColor, 'WindowText')
                        }
                    },
                    '&:hover': {
                        selectors: {
                            '.ms-RatingStar-back': {
                                color: ratingStarUncheckedHoverColor
                            },
                            '.ms-RatingStar-front': {
                                color: ratingStarUncheckedHoverSelectedColor
                            }
                        }
                    }
                }
            },
            disabled && {
                cursor: 'default'
            }
        ],
        ratingStarIsSmall: [
            classNames.ratingStarIsSmall,
            {
                fontSize: ratingSmallIconSize + 'px',
                lineHeight: ratingSmallIconSize + 'px',
                height: ratingSmallIconSize + 'px'
            }
        ],
        ratingStarIsLarge: [
            classNames.ratingStartIsLarge,
            {
                fontSize: ratingLargeIconSize + 'px',
                lineHeight: ratingLargeIconSize + 'px',
                height: ratingLargeIconSize + 'px'
            }
        ],
        labelText: [classNames.labelText, __WEBPACK_IMPORTED_MODULE_0__Styling__["B" /* hiddenContentStyle */]],
        ratingFocusZone: [
            classNames.ratingFocusZone,
            {
                display: 'inline-block'
            }
        ]
    };
}
//# sourceMappingURL=Rating.styles.js.map

/***/ }),
/* 2013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ScrollablePane_index__ = __webpack_require__(2014);
/* unused harmony namespace reexport */

//# sourceMappingURL=ScrollablePane.js.map

/***/ }),
/* 2014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScrollablePane__ = __webpack_require__(2015);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ScrollablePane_base__ = __webpack_require__(807);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ScrollablePane_types__ = __webpack_require__(2017);
/* unused harmony namespace reexport */



//# sourceMappingURL=index.js.map

/***/ }),
/* 2015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ScrollablePane */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ScrollablePane_base__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ScrollablePane_styles__ = __webpack_require__(2016);



var ScrollablePane = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__ScrollablePane_base__["a" /* ScrollablePaneBase */], __WEBPACK_IMPORTED_MODULE_2__ScrollablePane_styles__["a" /* getStyles */], undefined, { scope: 'ScrollablePane' });
//# sourceMappingURL=ScrollablePane.js.map

/***/ }),
/* 2016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var GlobalClassNames = {
    root: 'ms-ScrollablePane',
    contentContainer: 'ms-ScrollablePane--contentContainer'
};
var getStyles = function (props) {
    var className = props.className, theme = props.theme;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    var AboveAndBelowStyles = {
        position: 'absolute',
        pointerEvents: 'auto'
    };
    var positioningStyle = {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        WebkitOverflowScrolling: 'touch'
    };
    return {
        root: [classNames.root, theme.fonts.medium, positioningStyle, className],
        contentContainer: [
            classNames.contentContainer,
            {
                overflowY: props.scrollbarVisibility === 'always' ? 'scroll' : 'auto'
            },
            positioningStyle
        ],
        stickyAbove: [
            {
                top: 0,
                selectors: (_a = {},
                    _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        borderBottom: '1px solid WindowText'
                    },
                    _a)
            },
            AboveAndBelowStyles
        ],
        stickyBelow: [
            {
                bottom: 0,
                selectors: (_b = {},
                    _b[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        borderTop: '1px solid WindowText'
                    },
                    _b)
            },
            AboveAndBelowStyles
        ],
        stickyBelowItems: [
            {
                bottom: 0
            },
            AboveAndBelowStyles,
            {
                width: '100%'
            }
        ]
    };
    var _a, _b;
};
//# sourceMappingURL=ScrollablePane.styles.js.map

/***/ }),
/* 2017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ScrollbarVisibility */
/**
 * {@docCategory ScrollablePane}
 */
var ScrollbarVisibility = {
    auto: 'auto',
    always: 'always'
};
//# sourceMappingURL=ScrollablePane.types.js.map

/***/ }),
/* 2018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SearchBox_index__ = __webpack_require__(2019);
/* unused harmony namespace reexport */

//# sourceMappingURL=SearchBox.js.map

/***/ }),
/* 2019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SearchBox__ = __webpack_require__(2020);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SearchBox_base__ = __webpack_require__(808);
/* unused harmony namespace reexport */


//# sourceMappingURL=index.js.map

/***/ }),
/* 2020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SearchBox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SearchBox_base__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SearchBox_styles__ = __webpack_require__(2021);



var SearchBox = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__SearchBox_base__["a" /* SearchBoxBase */], __WEBPACK_IMPORTED_MODULE_2__SearchBox_styles__["a" /* getStyles */], undefined, { scope: 'SearchBox' });
//# sourceMappingURL=SearchBox.js.map

/***/ }),
/* 2021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStyles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__uifabric_styling__ = __webpack_require__(22);


function getStyles(props) {
    var theme = props.theme, underlined = props.underlined, disabled = props.disabled, hasFocus = props.hasFocus, className = props.className, hasInput = props.hasInput, disableAnimation = props.disableAnimation;
    var palette = theme.palette, fonts = theme.fonts, semanticColors = theme.semanticColors;
    // placeholder style constants
    var placeholderStyles = {
        color: semanticColors.inputPlaceholderText,
        opacity: 1
    };
    return {
        root: [
            'ms-SearchBox',
            fonts.medium,
            __WEBPACK_IMPORTED_MODULE_0__Styling__["H" /* normalize */],
            {
                color: palette.neutralPrimary,
                backgroundColor: semanticColors.inputBackground,
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'nowrap',
                alignItems: 'stretch',
                // The 1px top and bottom padding ensure the input field does not overlap the border
                padding: '1px 0 1px 4px',
                border: "1px solid " + palette.neutralTertiary,
                height: 32,
                selectors: (_a = {},
                    _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        border: '1px solid WindowText'
                    },
                    _a[':hover'] = {
                        borderColor: palette.neutralDark,
                        selectors: (_b = {},
                            _b[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                                borderColor: 'Highlight'
                            },
                            _b)
                    },
                    _a[':hover $iconContainer'] = {
                        color: palette.themeDark
                    },
                    _a)
            },
            hasFocus && [
                'is-active',
                {
                    borderColor: palette.themePrimary,
                    selectors: (_c = {
                            ':hover': {
                                borderColor: palette.themePrimary
                            }
                        },
                        _c[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                            borderColor: 'Highlight'
                        },
                        _c)
                }
            ],
            disabled && [
                'is-disabled',
                {
                    borderColor: palette.neutralLighter,
                    backgroundColor: palette.neutralLighter,
                    pointerEvents: 'none',
                    cursor: 'default'
                }
            ],
            underlined && [
                'is-underlined',
                {
                    borderWidth: '0 0 1px 0',
                    // Underlined SearchBox has a larger padding left to vertically align with the waffle in product
                    padding: '1px 0 1px 8px'
                }
            ],
            underlined &&
                disabled && {
                backgroundColor: 'transparent'
            },
            hasInput && 'can-clear',
            className
        ],
        iconContainer: [
            'ms-SearchBox-iconContainer',
            {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                flexShrink: 0,
                fontSize: 16,
                width: 32,
                textAlign: 'center',
                color: palette.themePrimary,
                cursor: 'text'
            },
            hasFocus && {
                width: 4
            },
            disabled && {
                color: palette.neutralTertiary
            },
            !disableAnimation && {
                transition: "width " + __WEBPACK_IMPORTED_MODULE_0__Styling__["c" /* AnimationVariables */].durationValue1
            }
        ],
        icon: [
            'ms-SearchBox-icon',
            {
                opacity: 1
            },
            hasFocus && {
                opacity: 0
            },
            !disableAnimation && {
                transition: "opacity " + __WEBPACK_IMPORTED_MODULE_0__Styling__["c" /* AnimationVariables */].durationValue1 + " 0s"
            }
        ],
        clearButton: [
            'ms-SearchBox-clearButton',
            {
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'stretch',
                cursor: 'pointer',
                flexBasis: '32px',
                flexShrink: 0,
                padding: 1,
                color: palette.themePrimary
            }
        ],
        field: [
            'ms-SearchBox-field',
            __WEBPACK_IMPORTED_MODULE_0__Styling__["H" /* normalize */],
            Object(__WEBPACK_IMPORTED_MODULE_1__uifabric_styling__["y" /* getPlaceholderStyles */])(placeholderStyles),
            {
                backgroundColor: 'transparent',
                border: 'none',
                outline: 'none',
                fontWeight: 'inherit',
                fontFamily: 'inherit',
                fontSize: 'inherit',
                color: palette.neutralPrimary,
                flex: '1 1 0px',
                // The default implicit value of 'auto' prevents the input from shrinking. Setting min-width to
                // 0px allows the input element to shrink to fit the container.
                minWidth: '0px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                // This padding forces the text placement to round up.
                paddingBottom: 0.5,
                // This removes the IE specific clear button in the input since we implimented our own
                selectors: {
                    '::-ms-clear': {
                        display: 'none'
                    }
                }
            },
            disabled && {
                color: palette.neutralTertiary
            }
        ]
    };
    var _a, _b, _c;
}
//# sourceMappingURL=SearchBox.styles.js.map

/***/ }),
/* 2022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_selectableOption_index__ = __webpack_require__(419);
/* unused harmony namespace reexport */

//# sourceMappingURL=SelectableOption.js.map

/***/ }),
/* 2023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SelectedItemsList_index__ = __webpack_require__(2024);
/* unused harmony namespace reexport */

//# sourceMappingURL=SelectedItemsList.js.map

/***/ }),
/* 2024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseSelectedItemsList__ = __webpack_require__(809);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SelectedPeopleList_SelectedPeopleList__ = __webpack_require__(2025);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SelectedPeopleList_Items_ExtendedSelectedItem__ = __webpack_require__(810);
/* unused harmony namespace reexport */



//# sourceMappingURL=index.js.map

/***/ }),
/* 2025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BasePeopleSelectedItemsList */
/* unused harmony export SelectedPeopleList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseSelectedItemsList__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Items_ExtendedSelectedItem__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Items_SelectedItemWithContextMenu__ = __webpack_require__(2027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Items_EditingItem__ = __webpack_require__(2028);

/* tslint:disable */

/* tslint:enable */




/**
 * {@docCategory SelectedPeopleList}
 */
var BasePeopleSelectedItemsList = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](BasePeopleSelectedItemsList, _super);
    function BasePeopleSelectedItemsList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BasePeopleSelectedItemsList;
}(__WEBPACK_IMPORTED_MODULE_2__BaseSelectedItemsList__["a" /* BaseSelectedItemsList */]));

/**
 * Standard People Picker.
 */
var SelectedPeopleList = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](SelectedPeopleList, _super);
    function SelectedPeopleList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderItems = function () {
            var items = _this.state.items;
            // tslint:disable-next-line:no-any
            return items.map(function (item, index) { return _this._renderItem(item, index); });
        };
        _this._beginEditing = function (item) {
            item.isEditing = true;
            _this.forceUpdate();
        };
        // tslint:disable-next-line:no-any
        _this._completeEditing = function (oldItem, newItem) {
            oldItem.isEditing = false;
            _this.replaceItem(oldItem, newItem);
        };
        return _this;
    }
    // tslint:disable-next-line:no-any
    SelectedPeopleList.prototype._renderItem = function (item, index) {
        var _this = this;
        var removeButtonAriaLabel = this.props.removeButtonAriaLabel;
        var expandGroup = this.props.onExpandGroup;
        var props = {
            item: item,
            index: index,
            key: item.key ? item.key : index,
            selected: this.selection.isIndexSelected(index),
            onRemoveItem: function () { return _this.removeItem(item); },
            onItemChange: this.onItemChange,
            removeButtonAriaLabel: removeButtonAriaLabel,
            onCopyItem: function (itemToCopy) { return _this.copyItems([itemToCopy]); },
            onExpandItem: expandGroup ? function () { return expandGroup(item); } : undefined,
            menuItems: this._createMenuItems(item)
        };
        var hasContextMenu = props.menuItems.length > 0;
        if (item.isEditing && hasContextMenu) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Items_EditingItem__["a" /* EditingItem */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, props, { onRenderFloatingPicker: this.props.onRenderFloatingPicker, floatingPickerProps: this.props.floatingPickerProps, onEditingComplete: this._completeEditing, getEditingItemText: this.props.getEditingItemText })));
        }
        else {
            // This cast is here because we are guaranteed that onRenderItem is set
            // from static defaultProps
            // TODO: Move this component to composition with required onRenderItem to remove
            // this cast.
            var onRenderItem = this.props.onRenderItem;
            var renderedItem = onRenderItem(props);
            return hasContextMenu ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Items_SelectedItemWithContextMenu__["a" /* SelectedItemWithContextMenu */], { key: props.key, renderedItem: renderedItem, beginEditing: this._beginEditing, menuItems: this._createMenuItems(props.item), item: props.item })) : (renderedItem);
        }
    };
    // tslint:disable-next-line:no-any
    SelectedPeopleList.prototype._createMenuItems = function (item) {
        var _this = this;
        var menuItems = [];
        if (this.props.editMenuItemText && this.props.getEditingItemText) {
            menuItems.push({
                key: 'Edit',
                text: this.props.editMenuItemText,
                onClick: function (ev, menuItem) {
                    _this._beginEditing(menuItem.data);
                },
                data: item
            });
        }
        if (this.props.removeMenuItemText) {
            menuItems.push({
                key: 'Remove',
                text: this.props.removeMenuItemText,
                onClick: function (ev, menuItem) {
                    _this.removeItem(menuItem.data);
                },
                data: item
            });
        }
        if (this.props.copyMenuItemText) {
            menuItems.push({
                key: 'Copy',
                text: this.props.copyMenuItemText,
                onClick: function (ev, menuItem) {
                    if (_this.props.onCopyItems) {
                        _this.copyItems([menuItem.data]);
                    }
                },
                data: item
            });
        }
        return menuItems;
    };
    // tslint:disable-next-line:no-any
    SelectedPeopleList.defaultProps = {
        onRenderItem: function (props) { return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Items_ExtendedSelectedItem__["a" /* ExtendedSelectedItem */], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, props)); }
    };
    return SelectedPeopleList;
}(BasePeopleSelectedItemsList));

//# sourceMappingURL=SelectedPeopleList.js.map

/***/ }),
/* 2026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "personaContainer", function() { return personaContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hover", function() { return hover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actionButton", function() { return actionButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "personaContainerIsSelected", function() { return personaContainerIsSelected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validationError", function() { return validationError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "itemContent", function() { return itemContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeButton", function() { return removeButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "expandButton", function() { return expandButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "personaWrapper", function() { return personaWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "personaDetails", function() { return personaDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "itemContainer", function() { return itemContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_load_themed_styles__ = __webpack_require__(67);
/* tslint:disable */

Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_load_themed_styles__["a" /* loadStyles */])([{ "rawString": ".personaContainer_59642838{border-radius:15px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:" }, { "theme": "themeLighterAlt", "defaultValue": "#eff6fc" }, { "rawString": ";margin:4px;cursor:default;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;vertical-align:middle;position:relative}.personaContainer_59642838::-moz-focus-inner{border:0}.personaContainer_59642838{outline:transparent}.personaContainer_59642838{position:relative}.ms-Fabric--isFocusVisible .personaContainer_59642838:focus:after{content:'';position:absolute;top:-2px;right:-2px;bottom:-2px;left:-2px;pointer-events:none;border:1px solid " }, { "theme": "focusBorder", "defaultValue": "#666666" }, { "rawString": "}.personaContainer_59642838 .ms-Persona-primaryText{color:" }, { "theme": "themeDark", "defaultValue": "#005a9e" }, { "rawString": ";font-size:14px;font-weight:400}.personaContainer_59642838 .ms-Persona-primaryText.hover_59642838{color:" }, { "theme": "themeDark", "defaultValue": "#005a9e" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.personaContainer_59642838 .ms-Persona-primaryText{color:HighlightText}}.personaContainer_59642838 .actionButton_59642838:hover{background:" }, { "theme": "themeLight", "defaultValue": "#c7e0f4" }, { "rawString": "}.personaContainer_59642838 .actionButton_59642838 .ms-Button-icon{color:" }, { "theme": "themeDark", "defaultValue": "#005a9e" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.personaContainer_59642838 .actionButton_59642838 .ms-Button-icon{color:HighlightText}}.personaContainer_59642838:hover{background:" }, { "theme": "themeLighter", "defaultValue": "#deecf9" }, { "rawString": "}.personaContainer_59642838:hover .ms-Persona-primaryText{color:" }, { "theme": "themeDark", "defaultValue": "#005a9e" }, { "rawString": ";font-size:14px;font-weight:400}@media screen and (-ms-high-contrast: active){.personaContainer_59642838:hover .ms-Persona-primaryText{color:HighlightText}}.personaContainer_59642838.personaContainerIsSelected_59642838{background:" }, { "theme": "themePrimary", "defaultValue": "#0078d4" }, { "rawString": "}.personaContainer_59642838.personaContainerIsSelected_59642838 .ms-Persona-primaryText{color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.personaContainer_59642838.personaContainerIsSelected_59642838 .ms-Persona-primaryText{color:HighlightText}}.personaContainer_59642838.personaContainerIsSelected_59642838 .actionButton_59642838{color:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": "}.personaContainer_59642838.personaContainerIsSelected_59642838 .actionButton_59642838 .ms-Button-icon{color:" }, { "theme": "themeDark", "defaultValue": "#005a9e" }, { "rawString": "}.personaContainer_59642838.personaContainerIsSelected_59642838 .actionButton_59642838 .ms-Button-icon:hover{background:" }, { "theme": "themeDark", "defaultValue": "#005a9e" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.personaContainer_59642838.personaContainerIsSelected_59642838 .actionButton_59642838 .ms-Button-icon{color:HighlightText}}@media screen and (-ms-high-contrast: active){.personaContainer_59642838.personaContainerIsSelected_59642838{border-color:Highlight;background:Highlight;-ms-high-contrast-adjust:none}}.personaContainer_59642838.validationError_59642838 .ms-Persona-primaryText{color:" }, { "theme": "red", "defaultValue": "#e81123" }, { "rawString": "}.personaContainer_59642838.validationError_59642838 .ms-Persona-initials{font-size:20px}@media screen and (-ms-high-contrast: active){.personaContainer_59642838{border:1px solid WindowText}}.personaContainer_59642838 .itemContent_59642838{-webkit-box-flex:0;-ms-flex:0 1 auto;flex:0 1 auto;min-width:0px;max-width:100%}.personaContainer_59642838 .removeButton_59642838{border-radius:15px;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;width:33px;height:33px;-ms-flex-preferred-size:32px;flex-basis:32px}.personaContainer_59642838 .expandButton_59642838{border-radius:15px 0px 0px 15px;height:33px;width:44px;padding-right:16px;position:inherit;display:-webkit-box;display:-ms-flexbox;display:flex;margin-right:-17px}.personaContainer_59642838 .personaWrapper_59642838{position:relative;display:inherit}.personaContainer_59642838 .personaWrapper_59642838 .ms-Persona-details{padding:0px 8px}.personaContainer_59642838 .personaDetails_59642838{-webkit-box-flex:0;-ms-flex:0 1 auto;flex:0 1 auto}.itemContainer_59642838{display:inline-block;vertical-align:top}\n" }]);
var personaContainer = "personaContainer_59642838";
var hover = "hover_59642838";
var actionButton = "actionButton_59642838";
var personaContainerIsSelected = "personaContainerIsSelected_59642838";
var validationError = "validationError_59642838";
var itemContent = "itemContent_59642838";
var removeButton = "removeButton_59642838";
var expandButton = "expandButton_59642838";
var personaWrapper = "personaWrapper_59642838";
var personaDetails = "personaDetails_59642838";
var itemContainer = "itemContainer_59642838";
//# sourceMappingURL=ExtendedSelectedItem.scss.js.map

/***/ }),
/* 2027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectedItemWithContextMenu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContextualMenu__ = __webpack_require__(270);

/* tslint:disable */

/* tslint:enable */


var SelectedItemWithContextMenu = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](SelectedItemWithContextMenu, _super);
    function SelectedItemWithContextMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.itemElement = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._onClick = function (ev) {
            ev.preventDefault();
            if (_this.props.beginEditing && !_this.props.item.isValid) {
                _this.props.beginEditing(_this.props.item);
            }
            else {
                _this.setState({ contextualMenuVisible: true });
            }
        };
        _this._onCloseContextualMenu = function (ev) {
            _this.setState({ contextualMenuVisible: false });
        };
        _this.state = { contextualMenuVisible: false };
        return _this;
    }
    SelectedItemWithContextMenu.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: this.itemElement, onContextMenu: this._onClick },
            this.props.renderedItem,
            this.state.contextualMenuVisible ? (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__ContextualMenu__["a" /* ContextualMenu */], { items: this.props.menuItems, shouldFocusOnMount: true, target: this.itemElement.current, onDismiss: this._onCloseContextualMenu, directionalHint: __WEBPACK_IMPORTED_MODULE_3__ContextualMenu__["b" /* DirectionalHint */].bottomLeftEdge })) : null));
    };
    return SelectedItemWithContextMenu;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=SelectedItemWithContextMenu.js.map

/***/ }),
/* 2028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditingItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EditingItem_scss__ = __webpack_require__(2029);

/* tslint:disable */

/* tslint:enable */


// tslint:disable-next-line:no-any
var styles = __WEBPACK_IMPORTED_MODULE_3__EditingItem_scss__;
var EditingItem = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](EditingItem, _super);
    function EditingItem(props) {
        var _this = _super.call(this, props) || this;
        _this._editingFloatingPicker = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._renderEditingSuggestions = function () {
            var FloatingPicker = _this.props.onRenderFloatingPicker;
            var floatingPickerProps = _this.props.floatingPickerProps;
            if (!FloatingPicker || !floatingPickerProps) {
                return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null);
            }
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](FloatingPicker, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ componentRef: _this._editingFloatingPicker, onChange: _this._onSuggestionSelected, inputElement: _this._editingInput, selectedItems: [] }, floatingPickerProps)));
        };
        _this._resolveInputRef = function (ref) {
            _this._editingInput = ref;
            _this.forceUpdate(function () {
                _this._editingInput.focus();
            });
        };
        _this._onInputClick = function () {
            _this._editingFloatingPicker.current && _this._editingFloatingPicker.current.showPicker(true /*updatevalue*/);
        };
        _this._onInputBlur = function (ev) {
            if (_this._editingFloatingPicker.current && ev.relatedTarget !== null) {
                var target = ev.relatedTarget;
                if (target.className.indexOf('ms-Suggestions-itemButton') === -1 && target.className.indexOf('ms-Suggestions-sectionButton') === -1) {
                    _this._editingFloatingPicker.current.forceResolveSuggestion();
                }
            }
        };
        _this._onInputChange = function (ev) {
            var value = ev.target.value;
            if (value === '') {
                if (_this.props.onRemoveItem) {
                    _this.props.onRemoveItem();
                }
            }
            else {
                _this._editingFloatingPicker.current && _this._editingFloatingPicker.current.onQueryStringChanged(value);
            }
        };
        _this._onSuggestionSelected = function (item) {
            _this.props.onEditingComplete(_this.props.item, item);
        };
        _this.state = { contextualMenuVisible: false };
        return _this;
    }
    EditingItem.prototype.componentDidMount = function () {
        var getEditingItemText = this.props.getEditingItemText;
        var itemText = getEditingItemText(this.props.item);
        this._editingFloatingPicker.current && this._editingFloatingPicker.current.onQueryStringChanged(itemText);
        this._editingInput.value = itemText;
        this._editingInput.focus();
    };
    EditingItem.prototype.render = function () {
        var itemId = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["N" /* getId */])();
        var nativeProps = Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["R" /* getNativeProps */])(this.props, __WEBPACK_IMPORTED_MODULE_2__Utilities__["_7" /* inputProperties */]);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { "aria-labelledby": 'editingItemPersona-' + itemId, className: Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["t" /* css */])('ms-EditingItem', styles.editingContainer) },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("input", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ autoCapitalize: 'off', autoComplete: 'off' }, nativeProps, { ref: this._resolveInputRef, onChange: this._onInputChange, onKeyDown: this._onInputKeyDown, onBlur: this._onInputBlur, onClick: this._onInputClick, "data-lpignore": true, className: styles.editingInput, id: itemId })),
            this._renderEditingSuggestions()));
    };
    EditingItem.prototype._onInputKeyDown = function (ev) {
        if (ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].backspace || ev.which === __WEBPACK_IMPORTED_MODULE_2__Utilities__["g" /* KeyCodes */].del) {
            ev.stopPropagation();
        }
    };
    return EditingItem;
}(__WEBPACK_IMPORTED_MODULE_2__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=EditingItem.js.map

/***/ }),
/* 2029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editingInput", function() { return editingInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editingContainer", function() { return editingContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_load_themed_styles__ = __webpack_require__(67);
/* tslint:disable */

Object(__WEBPACK_IMPORTED_MODULE_0__microsoft_load_themed_styles__["a" /* loadStyles */])([{ "rawString": ".editingInput_aec7d74f{border:0px;outline:none;width:100%}.editingInput_aec7d74f::-ms-clear{display:none}.editingContainer_aec7d74f{margin:4px}\n" }]);
var editingInput = "editingInput_aec7d74f";
var editingContainer = "editingContainer_aec7d74f";
//# sourceMappingURL=EditingItem.scss.js.map

/***/ }),
/* 2030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Separator_index__ = __webpack_require__(2031);
/* unused harmony namespace reexport */

//# sourceMappingURL=Separator.js.map

/***/ }),
/* 2031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Separator_base__ = __webpack_require__(811);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Separator__ = __webpack_require__(2032);
/* unused harmony namespace reexport */


//# sourceMappingURL=index.js.map

/***/ }),
/* 2032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Separator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Separator_styles__ = __webpack_require__(2033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Separator_base__ = __webpack_require__(811);



var Separator = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_2__Separator_base__["a" /* SeparatorBase */], __WEBPACK_IMPORTED_MODULE_1__Separator_styles__["a" /* getStyles */], undefined, {
    scope: 'Separator'
});
//# sourceMappingURL=Separator.js.map

/***/ }),
/* 2033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
var getStyles = function (props) {
    var theme = props.theme, alignContent = props.alignContent, vertical = props.vertical, className = props.className;
    var alignStart = alignContent === 'start';
    var alignCenter = alignContent === 'center';
    var alignEnd = alignContent === 'end';
    return {
        root: [
            theme.fonts.medium,
            {
                position: 'relative'
            },
            alignContent && {
                textAlign: alignContent
            },
            !alignContent && {
                textAlign: 'center'
            },
            vertical &&
                (alignCenter || !alignContent) && {
                verticalAlign: 'middle'
            },
            vertical &&
                alignStart && {
                verticalAlign: 'top'
            },
            vertical &&
                alignEnd && {
                verticalAlign: 'bottom'
            },
            vertical && {
                padding: '0 4px',
                height: 'inherit',
                display: 'table-cell',
                zIndex: 1,
                selectors: {
                    ':after': {
                        backgroundColor: theme.palette.neutralLighter,
                        width: '1px',
                        content: '""',
                        position: 'absolute',
                        top: '0',
                        bottom: '0',
                        left: '50%',
                        right: '0',
                        zIndex: -1
                    }
                }
            },
            !vertical && {
                padding: '4px 0',
                selectors: {
                    ':before': {
                        backgroundColor: theme.palette.neutralLighter,
                        height: '1px',
                        content: '""',
                        display: 'block',
                        position: 'absolute',
                        top: '50%',
                        bottom: '0',
                        left: '0',
                        right: '0'
                    }
                }
            },
            className
        ],
        content: [
            {
                position: 'relative',
                display: 'inline-block',
                padding: '0 12px',
                color: theme.semanticColors.bodyText,
                background: theme.semanticColors.bodyBackground
            },
            vertical && {
                padding: '12px 0'
            }
        ]
    };
};
//# sourceMappingURL=Separator.styles.js.map

/***/ }),
/* 2034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Shimmer__ = __webpack_require__(2035);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Shimmer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shimmer_base__ = __webpack_require__(813);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shimmer_types__ = __webpack_require__(816);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Shimmer_types__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ShimmerLine_ShimmerLine__ = __webpack_require__(817);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ShimmerLine_ShimmerLine_base__ = __webpack_require__(818);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ShimmerCircle_ShimmerCircle__ = __webpack_require__(821);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ShimmerCircle_ShimmerCircle_base__ = __webpack_require__(822);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ShimmerGap_ShimmerGap__ = __webpack_require__(819);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ShimmerGap_ShimmerGap_base__ = __webpack_require__(820);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ShimmerElementsGroup_ShimmerElementsGroup__ = __webpack_require__(814);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_9__ShimmerElementsGroup_ShimmerElementsGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ShimmerElementsGroup_ShimmerElementsGroup_base__ = __webpack_require__(815);
/* unused harmony namespace reexport */











//# sourceMappingURL=index.js.map

/***/ }),
/* 2035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Shimmer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shimmer_styles__ = __webpack_require__(2036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shimmer_base__ = __webpack_require__(813);



var Shimmer = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_2__Shimmer_base__["a" /* ShimmerBase */], __WEBPACK_IMPORTED_MODULE_1__Shimmer_styles__["a" /* getStyles */], undefined, {
    scope: 'Shimmer'
});
//# sourceMappingURL=Shimmer.js.map

/***/ }),
/* 2036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStyles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utilities__ = __webpack_require__(1);


var GlobalClassNames = {
    root: 'ms-Shimmer-container',
    shimmerWrapper: 'ms-Shimmer-shimmerWrapper',
    dataWrapper: 'ms-Shimmer-dataWrapper'
};
var BACKGROUND_OFF_SCREEN_POSITION = '1000%';
var shimmerAnimation = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["C" /* keyframes */])({
    '0%': {
        backgroundPosition: "-" + BACKGROUND_OFF_SCREEN_POSITION
    },
    '100%': {
        backgroundPosition: BACKGROUND_OFF_SCREEN_POSITION
    }
});
var shimmerAnimationRTL = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["C" /* keyframes */])({
    '100%': {
        backgroundPosition: "-" + BACKGROUND_OFF_SCREEN_POSITION
    },
    '0%': {
        backgroundPosition: BACKGROUND_OFF_SCREEN_POSITION
    }
});
function getStyles(props) {
    var isDataLoaded = props.isDataLoaded, className = props.className, theme = props.theme, transitionAnimationInterval = props.transitionAnimationInterval, shimmerColor = props.shimmerColor, shimmerWaveColor = props.shimmerWaveColor;
    var palette = theme.palette;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    var isRTL = Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["V" /* getRTL */])();
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            {
                position: 'relative',
                height: 'auto'
            },
            className
        ],
        shimmerWrapper: [
            classNames.shimmerWrapper,
            {
                background: (shimmerColor || palette.neutralLighter) + "\n                    linear-gradient(\n                      to right,\n                      " + (shimmerColor || palette.neutralLighter) + " 0%,\n                      " + (shimmerWaveColor || palette.neutralLight) + " 50%,\n                      " + (shimmerColor || palette.neutralLighter) + " 100%)\n                    0 0 / 90% 100%\n                    no-repeat",
                animationDuration: '2s',
                animationTimingFunction: 'ease-in-out',
                animationDirection: 'normal',
                animationIterationCount: 'infinite',
                animationName: isRTL ? shimmerAnimationRTL : shimmerAnimation,
                transition: "opacity " + transitionAnimationInterval + "ms",
                selectors: (_a = {},
                    _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        background: "WindowText\n                        linear-gradient(\n                          to right,\n                          transparent 0%,\n                          Window 50%,\n                          transparent 100%)\n                        0 0 / 90% 100%\n                        no-repeat"
                    },
                    _a)
            },
            isDataLoaded && {
                opacity: '0',
                position: 'absolute',
                top: '0',
                bottom: '0',
                left: '0',
                right: '0'
            }
        ],
        dataWrapper: [
            classNames.dataWrapper,
            {
                position: 'absolute',
                top: '0',
                bottom: '0',
                left: '0',
                right: '0',
                opacity: '0',
                background: 'none',
                backgroundColor: 'transparent',
                border: 'none',
                transition: "opacity " + transitionAnimationInterval + "ms"
            },
            isDataLoaded && {
                opacity: '1',
                position: 'static'
            }
        ],
        screenReaderText: __WEBPACK_IMPORTED_MODULE_0__Styling__["B" /* hiddenContentStyle */]
    };
    var _a;
}
//# sourceMappingURL=Shimmer.styles.js.map

/***/ }),
/* 2037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStyles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var GlobalClassNames = {
    root: 'ms-ShimmerLine-root',
    topLeftCorner: 'ms-ShimmerLine-topLeftCorner',
    topRightCorner: 'ms-ShimmerLine-topRightCorner',
    bottomLeftCorner: 'ms-ShimmerLine-bottomLeftCorner',
    bottomRightCorner: 'ms-ShimmerLine-bottomRightCorner'
};
function getStyles(props) {
    var height = props.height, borderStyle = props.borderStyle, theme = props.theme;
    var palette = theme.palette;
    var globalClassNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    var borderStyles = !!borderStyle ? borderStyle : {};
    var sharedCornerStyles = {
        position: 'absolute',
        fill: palette.white
    };
    return {
        root: [
            globalClassNames.root,
            theme.fonts.medium,
            {
                height: height + "px",
                boxSizing: 'content-box',
                position: 'relative',
                borderTopStyle: 'solid',
                borderBottomStyle: 'solid',
                borderColor: palette.white,
                selectors: (_a = {},
                    _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        borderColor: 'Window',
                        selectors: {
                            '> *': {
                                fill: 'Window'
                            }
                        }
                    },
                    _a)
            },
            borderStyles
        ],
        topLeftCorner: [
            globalClassNames.topLeftCorner,
            {
                top: '0',
                left: '0'
            },
            sharedCornerStyles
        ],
        topRightCorner: [
            globalClassNames.topRightCorner,
            {
                top: '0',
                right: '0'
            },
            sharedCornerStyles
        ],
        bottomRightCorner: [
            globalClassNames.bottomRightCorner,
            {
                bottom: '0',
                right: '0'
            },
            sharedCornerStyles
        ],
        bottomLeftCorner: [
            globalClassNames.bottomLeftCorner,
            {
                bottom: '0',
                left: '0'
            },
            sharedCornerStyles
        ]
    };
    var _a;
}
//# sourceMappingURL=ShimmerLine.styles.js.map

/***/ }),
/* 2038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStyles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var GlobalClassNames = {
    root: 'ms-ShimmerGap-root'
};
function getStyles(props) {
    var height = props.height, borderStyle = props.borderStyle, theme = props.theme;
    var palette = theme.palette;
    var globalClassNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    var borderStyles = !!borderStyle ? borderStyle : {};
    return {
        root: [
            globalClassNames.root,
            theme.fonts.medium,
            {
                backgroundColor: palette.white,
                height: height + "px",
                boxSizing: 'content-box',
                borderTopStyle: 'solid',
                borderBottomStyle: 'solid',
                borderColor: palette.white,
                selectors: (_a = {},
                    _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        backgroundColor: 'Window',
                        borderColor: 'Window'
                    },
                    _a)
            },
            borderStyles
        ]
    };
    var _a;
}
//# sourceMappingURL=ShimmerGap.styles.js.map

/***/ }),
/* 2039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStyles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var GlobalClassNames = {
    root: 'ms-ShimmerCircle-root',
    svg: 'ms-ShimmerCircle-svg'
};
function getStyles(props) {
    var height = props.height, borderStyle = props.borderStyle, theme = props.theme;
    var palette = theme.palette;
    var globalClassNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    var borderStyles = !!borderStyle ? borderStyle : {};
    return {
        root: [
            globalClassNames.root,
            theme.fonts.medium,
            {
                width: height + "px",
                height: height + "px",
                minWidth: height + "px",
                boxSizing: 'content-box',
                borderTopStyle: 'solid',
                borderBottomStyle: 'solid',
                borderColor: palette.white,
                selectors: (_a = {},
                    _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        borderColor: 'Window'
                    },
                    _a)
            },
            borderStyles
        ],
        svg: [
            globalClassNames.svg,
            {
                display: 'block',
                fill: palette.white,
                selectors: (_b = {},
                    _b[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        fill: 'Window'
                    },
                    _b)
            }
        ]
    };
    var _a, _b;
}
//# sourceMappingURL=ShimmerCircle.styles.js.map

/***/ }),
/* 2040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStyles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var GlobalClassNames = {
    root: 'ms-ShimmerElementsGroup-root'
};
function getStyles(props) {
    var flexWrap = props.flexWrap, theme = props.theme;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            {
                display: 'flex',
                alignItems: 'center',
                flexWrap: flexWrap ? 'wrap' : 'nowrap'
            }
        ]
    };
}
//# sourceMappingURL=ShimmerElementsGroup.styles.js.map

/***/ }),
/* 2041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DetailsList_ShimmeredDetailsList__ = __webpack_require__(2042);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DetailsList_ShimmeredDetailsList_base__ = __webpack_require__(823);
/* unused harmony namespace reexport */


//# sourceMappingURL=ShimmeredDetailsList.js.map

/***/ }),
/* 2042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ShimmeredDetailsList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ShimmeredDetailsList_base__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShimmeredDetailsList_styles__ = __webpack_require__(2043);



var ShimmeredDetailsList = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__ShimmeredDetailsList_base__["a" /* ShimmeredDetailsListBase */], __WEBPACK_IMPORTED_MODULE_2__ShimmeredDetailsList_styles__["a" /* getStyles */], undefined, { scope: 'ShimmeredDetailsList' });
//# sourceMappingURL=ShimmeredDetailsList.js.map

/***/ }),
/* 2043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
var getStyles = function (props) {
    var theme = props.theme, className = props.className, enableShimmer = props.enableShimmer;
    var semanticColors = theme.semanticColors, palette = theme.palette;
    var overlayStyles = {
        // set `position: relative` to stop the fading overlay cover the DetailsList header.
        position: 'relative',
        selectors: {
            ':after': {
                content: '""',
                position: 'absolute',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                backgroundImage: "linear-gradient(to bottom,\n                          transparent 30%,\n                          " + palette.whiteTranslucent40 + " 65%,\n                          " + semanticColors.listBackground + " 100%)"
            }
        }
    };
    return {
        root: [enableShimmer && overlayStyles, className]
    };
};
//# sourceMappingURL=ShimmeredDetailsList.styles.js.map

/***/ }),
/* 2044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Slider_index__ = __webpack_require__(2045);
/* unused harmony namespace reexport */

//# sourceMappingURL=Slider.js.map

/***/ }),
/* 2045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Slider__ = __webpack_require__(2046);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Slider_base__ = __webpack_require__(824);
/* unused harmony namespace reexport */


//# sourceMappingURL=index.js.map

/***/ }),
/* 2046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Slider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Slider_base__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Slider_styles__ = __webpack_require__(2047);



var Slider = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__Slider_base__["a" /* SliderBase */], __WEBPACK_IMPORTED_MODULE_2__Slider_styles__["a" /* getStyles */], undefined, {
    scope: 'Slider'
});
//# sourceMappingURL=Slider.js.map

/***/ }),
/* 2047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__ = __webpack_require__(61);


var GlobalClassNames = {
    root: 'ms-Slider',
    enabled: 'ms-Slider-enabled',
    disabled: 'ms-Slider-disabled',
    row: 'ms-Slider-row',
    column: 'ms-Slider-column',
    container: 'ms-Slider-container',
    slideBox: 'ms-Slider-slideBox',
    line: 'ms-Slider-line',
    thumb: 'ms-Slider-thumb',
    activeSection: 'ms-Slider-active',
    inactiveSection: 'ms-Slider-inactive',
    valueLabel: 'ms-Slider-value',
    showValue: 'ms-Slider-showValue',
    showTransitions: 'ms-Slider-showTransitions',
    zeroTick: 'ms-Slider-zeroTick'
};
var getStyles = function (props) {
    var className = props.className, titleLabelClassName = props.titleLabelClassName, theme = props.theme;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    var slideBoxActiveSectionStyles = !props.disabled && {
        backgroundColor: theme.palette.themePrimary,
        selectors: (_a = {},
            _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                backgroundColor: 'Highlight'
            },
            _a)
    };
    var slideBoxInactiveSectionStyles = !props.disabled && {
        backgroundColor: theme.palette.themeLight,
        selectors: (_b = {},
            _b[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                borderColor: 'Highlight'
            },
            _b)
    };
    var slideBoxActiveThumbStyles = !props.disabled && {
        border: "2px solid " + theme.palette.themePrimary,
        selectors: (_c = {},
            _c[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                borderColor: 'Highlight'
            },
            _c)
    };
    var slideBoxActiveZeroTickStyles = !props.disabled && {
        backgroundColor: theme.palette.themeLight,
        selectors: (_d = {},
            _d[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                backgroundColor: 'Highlight'
            },
            _d)
    };
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            {
                userSelect: 'none'
            },
            props.vertical && {
                marginRight: 8
            }
        ].concat([!props.disabled ? classNames.enabled : undefined], [props.disabled ? classNames.disabled : undefined], [!props.vertical ? classNames.row : undefined], [props.vertical ? classNames.column : undefined], [
            className
        ]),
        titleLabel: [
            {
                padding: 0
            },
            titleLabelClassName
        ],
        container: [
            classNames.container,
            {
                display: 'flex',
                flexWrap: 'nowrap',
                alignItems: 'center'
            },
            props.vertical && {
                flexDirection: 'column',
                height: '100%',
                textAlign: 'center',
                margin: '8px 0'
            }
        ],
        slideBox: [
            classNames.slideBox,
            Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["v" /* getFocusStyle */])(theme),
            {
                background: 'transparent',
                border: 'none',
                flexGrow: 1,
                lineHeight: 28,
                display: 'flex',
                alignItems: 'center',
                selectors: {
                    ':active $activeSection': slideBoxActiveSectionStyles,
                    ':hover $activeSection': slideBoxActiveSectionStyles,
                    ':active $inactiveSection': slideBoxInactiveSectionStyles,
                    ':hover $inactiveSection': slideBoxInactiveSectionStyles,
                    ':active $thumb': slideBoxActiveThumbStyles,
                    ':hover $thumb': slideBoxActiveThumbStyles,
                    ':active $zeroTick': slideBoxActiveZeroTickStyles,
                    ':hover $zeroTick': slideBoxActiveZeroTickStyles,
                    $thumb: [
                        {
                            borderWidth: 2,
                            borderStyle: 'solid',
                            borderColor: theme.palette.neutralSecondary,
                            borderRadius: 10,
                            boxSizing: 'border-box',
                            background: theme.palette.white,
                            display: 'block',
                            width: 16,
                            height: 16,
                            position: 'absolute'
                        },
                        props.vertical
                            ? {
                                left: -6,
                                margin: '0 auto',
                                transform: 'translateY(8px)'
                            }
                            : {
                                top: -6,
                                transform: Object(__WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_3" /* getRTL */])() ? 'translateX(50%)' : 'translateX(-50%)'
                            },
                        props.showTransitions && {
                            transition: "left " + __WEBPACK_IMPORTED_MODULE_0__Styling__["c" /* AnimationVariables */].durationValue3 + " " + __WEBPACK_IMPORTED_MODULE_0__Styling__["c" /* AnimationVariables */].easeFunction1
                        },
                        props.disabled && {
                            borderColor: theme.palette.neutralTertiaryAlt,
                            selectors: (_e = {},
                                _e[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                                    borderColor: 'GrayText'
                                },
                                _e)
                        }
                    ]
                }
            },
            props.vertical
                ? {
                    height: '100%',
                    width: 28,
                    padding: '8px 0' // Make room for thumb at bottom of line
                }
                : {
                    height: 28,
                    width: 'auto',
                    padding: '0 8px' // Make room for thumb at ends of line
                }
        ].concat([props.showValue ? classNames.showValue : undefined], [props.showTransitions ? classNames.showTransitions : undefined]),
        thumb: [classNames.thumb],
        line: [
            classNames.line,
            {
                display: 'flex',
                position: 'relative',
                selectors: {
                    $lineContainer: [
                        {
                            borderRadius: 4,
                            boxSizing: 'border-box'
                        },
                        props.vertical
                            ? {
                                width: 4,
                                height: '100%'
                            }
                            : {
                                height: 4,
                                width: '100%'
                            }
                    ]
                }
            },
            props.vertical
                ? {
                    height: '100%',
                    width: 4,
                    margin: '0 auto',
                    flexDirection: 'column-reverse'
                }
                : {
                    width: '100%'
                }
        ],
        lineContainer: [{}],
        activeSection: [
            classNames.activeSection,
            {
                background: theme.palette.neutralSecondary,
                selectors: (_f = {},
                    _f[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        backgroundColor: 'WindowText'
                    },
                    _f)
            },
            props.showTransitions && {
                transition: "width " + __WEBPACK_IMPORTED_MODULE_0__Styling__["c" /* AnimationVariables */].durationValue3 + " " + __WEBPACK_IMPORTED_MODULE_0__Styling__["c" /* AnimationVariables */].easeFunction1
            },
            props.disabled && {
                background: theme.palette.neutralTertiaryAlt,
                selectors: (_g = {},
                    _g[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        backgroundColor: 'GrayText',
                        borderColor: 'GrayText'
                    },
                    _g)
            }
        ],
        inactiveSection: [
            classNames.inactiveSection,
            {
                background: theme.palette.neutralTertiaryAlt,
                selectors: (_h = {},
                    _h[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        border: '1px solid WindowText'
                    },
                    _h)
            },
            props.showTransitions && {
                transition: "width " + __WEBPACK_IMPORTED_MODULE_0__Styling__["c" /* AnimationVariables */].durationValue3 + " " + __WEBPACK_IMPORTED_MODULE_0__Styling__["c" /* AnimationVariables */].easeFunction1
            },
            props.disabled && {
                background: theme.palette.neutralLight,
                selectors: (_j = {},
                    _j[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        borderColor: 'GrayText'
                    },
                    _j)
            }
        ],
        zeroTick: [
            classNames.zeroTick,
            {
                position: 'absolute',
                background: theme.palette.neutralTertiaryAlt,
                selectors: (_k = {},
                    _k[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        backgroundColor: 'WindowText'
                    },
                    _k)
            },
            props.disabled && {
                background: theme.palette.neutralLight,
                selectors: (_l = {},
                    _l[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                        backgroundColor: 'GrayText'
                    },
                    _l)
            },
            props.vertical
                ? {
                    width: '16px',
                    height: '1px',
                    transform: Object(__WEBPACK_IMPORTED_MODULE_1__uifabric_utilities__["_3" /* getRTL */])() ? 'translateX(6px)' : 'translateX(-6px)'
                }
                : {
                    width: '1px',
                    height: '16px',
                    transform: 'translateY(-6px)'
                }
        ],
        valueLabel: [
            classNames.valueLabel,
            {
                flexShrink: 1,
                width: 30,
                lineHeight: '1' // using a string here meaning it's relative to the size of the font
            },
            props.vertical
                ? {
                    margin: '0 auto',
                    whiteSpace: 'nowrap',
                    width: 40
                }
                : {
                    margin: '0 8px',
                    whiteSpace: 'nowrap',
                    width: 40
                }
        ]
    };
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
};
//# sourceMappingURL=Slider.styles.js.map

/***/ }),
/* 2048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SpinButton_index__ = __webpack_require__(2049);
/* unused harmony namespace reexport */

//# sourceMappingURL=SpinButton.js.map

/***/ }),
/* 2049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SpinButton__ = __webpack_require__(2050);
/* unused harmony namespace reexport */

//# sourceMappingURL=index.js.map

/***/ }),
/* 2050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KeyboardSpinDirection */
/* unused harmony export SpinButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Label__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Icon__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_positioning__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SpinButton_styles__ = __webpack_require__(2051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SpinButton_classNames__ = __webpack_require__(2052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__KeytipData__ = __webpack_require__(89);










var KeyboardSpinDirection;
(function (KeyboardSpinDirection) {
    KeyboardSpinDirection[KeyboardSpinDirection["down"] = -1] = "down";
    KeyboardSpinDirection[KeyboardSpinDirection["notSpinning"] = 0] = "notSpinning";
    KeyboardSpinDirection[KeyboardSpinDirection["up"] = 1] = "up";
})(KeyboardSpinDirection || (KeyboardSpinDirection = {}));
var SpinButton = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](SpinButton, _super);
    function SpinButton(props) {
        var _this = _super.call(this, props) || this;
        _this._input = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._initialStepDelay = 400;
        _this._stepDelay = 75;
        _this._onFocus = function (ev) {
            // We can't set focus on a non-existing element
            if (!_this._input.current) {
                return;
            }
            if (_this._spinningByMouse || _this.state.keyboardSpinDirection !== KeyboardSpinDirection.notSpinning) {
                _this._stop();
            }
            _this._input.current.select();
            _this.setState({ isFocused: true });
            if (_this.props.onFocus) {
                _this.props.onFocus(ev);
            }
        };
        _this._onBlur = function (ev) {
            _this._validate(ev);
            _this.setState({ isFocused: false });
            if (_this.props.onBlur) {
                _this.props.onBlur(ev);
            }
        };
        _this._onValidate = function (value, event) {
            if (_this.props.onValidate) {
                return _this.props.onValidate(value, event);
            }
            else {
                return _this._defaultOnValidate(value);
            }
        };
        _this._calculatePrecision = function (props) {
            var _a = props.precision, precision = _a === void 0 ? Math.max(Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["q" /* calculatePrecision */])(props.step), 0) : _a;
            return precision;
        };
        /**
         * Validate function to use if one is not passed in
         */
        _this._defaultOnValidate = function (value) {
            if (value === null || value.trim().length === 0 || isNaN(Number(value))) {
                return _this._lastValidValue;
            }
            var newValue = Math.min(_this.props.max, Math.max(_this.props.min, Number(value)));
            return String(newValue);
        };
        _this._onIncrement = function (value) {
            if (_this.props.onIncrement) {
                return _this.props.onIncrement(value);
            }
            else {
                return _this._defaultOnIncrement(value);
            }
        };
        /**
         * Increment function to use if one is not passed in
         */
        _this._defaultOnIncrement = function (value) {
            var _a = _this.props, max = _a.max, step = _a.step;
            var newValue = Math.min(Number(value) + Number(step), max);
            newValue = Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["_20" /* precisionRound */])(newValue, _this._precision);
            return String(newValue);
        };
        _this._onDecrement = function (value) {
            if (_this.props.onDecrement) {
                return _this.props.onDecrement(value);
            }
            else {
                return _this._defaultOnDecrement(value);
            }
        };
        /**
         * Increment function to use if one is not passed in
         */
        _this._defaultOnDecrement = function (value) {
            var _a = _this.props, min = _a.min, step = _a.step;
            var newValue = Math.max(Number(value) - Number(step), min);
            newValue = Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["_20" /* precisionRound */])(newValue, _this._precision);
            return String(newValue);
        };
        /**
         * This is used when validating text entry
         * in the input (not when changed via the buttons)
         * @param event - the event that fired
         */
        _this._validate = function (event) {
            if (_this.state.value !== undefined && _this._valueToValidate !== undefined && _this._valueToValidate !== _this._lastValidValue) {
                var newValue = _this._onValidate(_this._valueToValidate, event);
                if (newValue) {
                    _this._lastValidValue = newValue;
                    _this._valueToValidate = undefined;
                    _this.setState({ value: newValue });
                }
            }
        };
        /**
         * The method is needed to ensure we are updating the actual input value.
         * without this our value will never change (and validation will not have the correct number)
         * @param event - the event that was fired
         */
        _this._onInputChange = function (event) {
            var element = event.target;
            var value = element.value;
            _this._valueToValidate = value;
            _this.setState({
                value: value
            });
        };
        /**
         * Update the value with the given stepFunction
         * @param shouldSpin - should we fire off another updateValue when we are done here? This should be true
         * when spinning in response to a mouseDown
         * @param stepFunction - function to use to step by
         */
        _this._updateValue = function (shouldSpin, stepDelay, stepFunction) {
            var newValue = stepFunction(_this.state.value);
            if (newValue) {
                _this._lastValidValue = newValue;
                _this.setState({ value: newValue });
            }
            if (_this._spinningByMouse !== shouldSpin) {
                _this._spinningByMouse = shouldSpin;
            }
            if (shouldSpin) {
                _this._currentStepFunctionHandle = _this._async.setTimeout(function () {
                    _this._updateValue(shouldSpin, _this._stepDelay, stepFunction);
                }, stepDelay);
            }
        };
        /**
         * Stop spinning (clear any currently pending update and set spinning to false)
         */
        _this._stop = function () {
            if (_this._currentStepFunctionHandle >= 0) {
                _this._async.clearTimeout(_this._currentStepFunctionHandle);
                _this._currentStepFunctionHandle = -1;
            }
            if (_this._spinningByMouse || _this.state.keyboardSpinDirection !== KeyboardSpinDirection.notSpinning) {
                _this._spinningByMouse = false;
                _this.setState({ keyboardSpinDirection: KeyboardSpinDirection.notSpinning });
            }
        };
        /**
         * Handle keydown on the text field. We need to update
         * the value when up or down arrow are depressed
         * @param event - the keyboardEvent that was fired
         */
        _this._handleKeyDown = function (event) {
            // eat the up and down arrow keys to keep focus in the spinButton
            // (especially when a spinButton is inside of a FocusZone)
            if (event.which === __WEBPACK_IMPORTED_MODULE_5__Utilities__["g" /* KeyCodes */].up || event.which === __WEBPACK_IMPORTED_MODULE_5__Utilities__["g" /* KeyCodes */].down || event.which === __WEBPACK_IMPORTED_MODULE_5__Utilities__["g" /* KeyCodes */].enter) {
                event.preventDefault();
                event.stopPropagation();
            }
            if (_this.props.disabled) {
                _this._stop();
                return;
            }
            var spinDirection = KeyboardSpinDirection.notSpinning;
            switch (event.which) {
                case __WEBPACK_IMPORTED_MODULE_5__Utilities__["g" /* KeyCodes */].up:
                    spinDirection = KeyboardSpinDirection.up;
                    _this._updateValue(false /* shouldSpin */, _this._initialStepDelay, _this._onIncrement);
                    break;
                case __WEBPACK_IMPORTED_MODULE_5__Utilities__["g" /* KeyCodes */].down:
                    spinDirection = KeyboardSpinDirection.down;
                    _this._updateValue(false /* shouldSpin */, _this._initialStepDelay, _this._onDecrement);
                    break;
                case __WEBPACK_IMPORTED_MODULE_5__Utilities__["g" /* KeyCodes */].enter:
                case __WEBPACK_IMPORTED_MODULE_5__Utilities__["g" /* KeyCodes */].tab:
                    _this._validate(event);
                    break;
                case __WEBPACK_IMPORTED_MODULE_5__Utilities__["g" /* KeyCodes */].escape:
                    if (_this.state.value !== _this._lastValidValue) {
                        _this.setState({ value: _this._lastValidValue });
                    }
                    break;
                default:
                    break;
            }
            // style the increment/decrement button to look active
            // when the corresponding up/down arrow keys trigger a step
            if (_this.state.keyboardSpinDirection !== spinDirection) {
                _this.setState({ keyboardSpinDirection: spinDirection });
            }
        };
        /**
         * Make sure that we have stopped spinning on keyUp
         * if the up or down arrow fired this event
         * @param event - keyboard event
         */
        _this._handleKeyUp = function (event) {
            if (_this.props.disabled || event.which === __WEBPACK_IMPORTED_MODULE_5__Utilities__["g" /* KeyCodes */].up || event.which === __WEBPACK_IMPORTED_MODULE_5__Utilities__["g" /* KeyCodes */].down) {
                _this._stop();
                return;
            }
        };
        _this._onIncrementMouseDown = function () {
            _this._updateValue(true /* shouldSpin */, _this._initialStepDelay, _this._onIncrement);
        };
        _this._onDecrementMouseDown = function () {
            _this._updateValue(true /* shouldSpin */, _this._initialStepDelay, _this._onDecrement);
        };
        _this._warnMutuallyExclusive({
            value: 'defaultValue'
        });
        var value = props.value || props.defaultValue || String(props.min) || '0';
        _this._lastValidValue = value;
        // Ensure that the autocalculated precision is not negative.
        _this._precision = _this._calculatePrecision(_this.props);
        _this.state = {
            isFocused: false,
            value: value,
            keyboardSpinDirection: KeyboardSpinDirection.notSpinning
        };
        _this._currentStepFunctionHandle = -1;
        _this._labelId = Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["N" /* getId */])('Label');
        _this._inputId = Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["N" /* getId */])('input');
        _this._spinningByMouse = false;
        _this._valueToValidate = undefined;
        return _this;
    }
    /**
     * Invoked when a component is receiving new props. This method is not called for the initial render.
     */
    SpinButton.prototype.componentWillReceiveProps = function (newProps) {
        this._lastValidValue = this.state.value;
        var value = newProps.value ? newProps.value : String(newProps.min);
        if (newProps.defaultValue) {
            value = String(Math.max(newProps.min, Math.min(newProps.max, Number(newProps.defaultValue))));
        }
        if (newProps.value !== undefined) {
            this.setState({
                value: value
            });
        }
        this._precision = this._calculatePrecision(newProps);
    };
    SpinButton.prototype.render = function () {
        var _this = this;
        var _a = this.props, disabled = _a.disabled, label = _a.label, min = _a.min, max = _a.max, labelPosition = _a.labelPosition, iconProps = _a.iconProps, incrementButtonIcon = _a.incrementButtonIcon, incrementButtonAriaLabel = _a.incrementButtonAriaLabel, decrementButtonIcon = _a.decrementButtonIcon, decrementButtonAriaLabel = _a.decrementButtonAriaLabel, title = _a.title, ariaLabel = _a.ariaLabel, ariaDescribedBy = _a.ariaDescribedBy, customStyles = _a.styles, customUpArrowButtonStyles = _a.upArrowButtonStyles, customDownArrowButtonStyles = _a.downArrowButtonStyles, theme = _a.theme, ariaPositionInSet = _a.ariaPositionInSet, ariaSetSize = _a.ariaSetSize, ariaValueNow = _a.ariaValueNow, ariaValueText = _a.ariaValueText, keytipProps = _a.keytipProps, className = _a.className;
        var _b = this.state, isFocused = _b.isFocused, value = _b.value, keyboardSpinDirection = _b.keyboardSpinDirection;
        var classNames = this.props.getClassNames
            ? this.props.getClassNames(theme, !!disabled, !!isFocused, keyboardSpinDirection, labelPosition, className)
            : Object(__WEBPACK_IMPORTED_MODULE_8__SpinButton_classNames__["a" /* getClassNames */])(Object(__WEBPACK_IMPORTED_MODULE_7__SpinButton_styles__["b" /* getStyles */])(theme, customStyles), !!disabled, !!isFocused, keyboardSpinDirection, labelPosition, className);
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.root },
            labelPosition !== __WEBPACK_IMPORTED_MODULE_6__utilities_positioning__["a" /* Position */].bottom && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.labelWrapper },
                iconProps && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Icon__["Icon"], __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, iconProps, { className: classNames.icon, "aria-hidden": "true" })),
                label && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Label__["a" /* Label */], { id: this._labelId, htmlFor: this._inputId, className: classNames.label }, label)))),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__KeytipData__["a" /* KeytipData */], { keytipProps: keytipProps, disabled: disabled }, function (keytipAttributes) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.spinButtonWrapper, title: title && title, "aria-label": ariaLabel && ariaLabel, "aria-posinset": ariaPositionInSet, "aria-setsize": ariaSetSize, "data-ktp-target": keytipAttributes['data-ktp-target'] },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("input", { value: value, id: _this._inputId, onChange: _this._onChange, onInput: _this._onInputChange, className: classNames.input, type: "text", autoComplete: "off", role: "spinbutton", "aria-labelledby": label && _this._labelId, "aria-valuenow": !isNaN(Number(ariaValueNow)) ? ariaValueNow : !isNaN(Number(value)) ? Number(value) : undefined, "aria-valuetext": ariaValueText ? ariaValueText : isNaN(Number(value)) ? value : undefined, "aria-valuemin": min, "aria-valuemax": max, "aria-describedby": Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["_16" /* mergeAriaAttributeValues */])(ariaDescribedBy, keytipAttributes['aria-describedby']), onBlur: _this._onBlur, ref: _this._input, onFocus: _this._onFocus, onKeyDown: _this._handleKeyDown, onKeyUp: _this._handleKeyUp, readOnly: disabled, "aria-disabled": disabled, "data-lpignore": true, "data-ktp-execute-target": keytipAttributes['data-ktp-execute-target'] }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: classNames.arrowBox },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Button__["g" /* IconButton */], { styles: Object(__WEBPACK_IMPORTED_MODULE_7__SpinButton_styles__["a" /* getArrowButtonStyles */])(theme, true, customUpArrowButtonStyles), className: 'ms-UpButton', checked: keyboardSpinDirection === KeyboardSpinDirection.up, disabled: disabled, iconProps: incrementButtonIcon, onMouseDown: _this._onIncrementMouseDown, onMouseLeave: _this._stop, onMouseUp: _this._stop, tabIndex: -1, ariaLabel: incrementButtonAriaLabel, "data-is-focusable": false }),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Button__["g" /* IconButton */], { styles: Object(__WEBPACK_IMPORTED_MODULE_7__SpinButton_styles__["a" /* getArrowButtonStyles */])(theme, false, customDownArrowButtonStyles), className: 'ms-DownButton', checked: keyboardSpinDirection === KeyboardSpinDirection.down, disabled: disabled, iconProps: decrementButtonIcon, onMouseDown: _this._onDecrementMouseDown, onMouseLeave: _this._stop, onMouseUp: _this._stop, tabIndex: -1, ariaLabel: decrementButtonAriaLabel, "data-is-focusable": false })))); }),
            labelPosition === __WEBPACK_IMPORTED_MODULE_6__utilities_positioning__["a" /* Position */].bottom && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: classNames.labelWrapper },
                iconProps && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Icon__["Icon"], { iconName: iconProps.iconName, className: classNames.icon, "aria-hidden": "true" }),
                label && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Label__["a" /* Label */], { id: this._labelId, htmlFor: this._inputId, className: classNames.label }, label))))));
    };
    SpinButton.prototype.focus = function () {
        if (this._input.current) {
            this._input.current.focus();
        }
    };
    Object.defineProperty(SpinButton.prototype, "value", {
        /**
         * Gets the value of the spin button.
         */
        get: function () {
            return this.props.value === undefined ? this.state.value : this.props.value;
        },
        enumerable: true,
        configurable: true
    });
    SpinButton.prototype._onChange = function () {
        /**
         * A noop input change handler.
         * https://github.com/facebook/react/issues/7027.
         * Using the native onInput handler fixes the issue but onChange
         * still need to be wired to avoid React console errors
         * TODO: Check if issue is resolved when React 16 is available.
         */
    };
    SpinButton.defaultProps = {
        step: 1,
        min: 0,
        max: 100,
        disabled: false,
        labelPosition: __WEBPACK_IMPORTED_MODULE_6__utilities_positioning__["a" /* Position */].start,
        label: '',
        incrementButtonIcon: { iconName: 'ChevronUpSmall' },
        decrementButtonIcon: { iconName: 'ChevronDownSmall' }
    };
    SpinButton = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __decorate */]([
        Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["u" /* customizable */])('SpinButton', ['theme', 'styles'], true)
    ], SpinButton);
    return SpinButton;
}(__WEBPACK_IMPORTED_MODULE_5__Utilities__["c" /* BaseComponent */]));

//# sourceMappingURL=SpinButton.js.map

/***/ }),
/* 2051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getArrowButtonStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utilities__ = __webpack_require__(1);


var _getDisabledStyles = Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["_15" /* memoizeFunction */])(function (theme) {
    var semanticColors = theme.semanticColors;
    var SpinButtonTextColorDisabled = semanticColors.disabledText;
    var SpinButtonBackgroundColorDisabled = semanticColors.disabledBackground;
    return {
        backgroundColor: SpinButtonBackgroundColorDisabled,
        borderColor: 'transparent',
        pointerEvents: 'none',
        cursor: 'default',
        color: SpinButtonTextColorDisabled,
        selectors: (_a = {},
            _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                color: 'GrayText'
            },
            _a)
    };
    var _a;
});
var getArrowButtonStyles = Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["_15" /* memoizeFunction */])(function (theme, isUpArrow, customSpecificArrowStyles) {
    var semanticColors = theme.semanticColors;
    var ArrowButtonTextColor = semanticColors.buttonText;
    var ArrowButtonTextColorHovered = semanticColors.buttonTextHovered;
    var ArrowButtonTextColorPressed = semanticColors.buttonTextChecked;
    var ArrowButtonBackgroundHovered = semanticColors.buttonBackgroundHovered;
    var ArrowButtonBackgroundPressed = semanticColors.buttonBackgroundChecked;
    var defaultArrowButtonStyles = {
        root: {
            outline: 'none',
            display: 'block',
            height: '50%',
            width: '14px',
            padding: '0',
            backgroundColor: 'transparent',
            textAlign: 'center',
            cursor: 'default',
            color: ArrowButtonTextColor
        },
        rootHovered: {
            backgroundColor: ArrowButtonBackgroundHovered,
            color: ArrowButtonTextColorHovered
        },
        rootChecked: {
            backgroundColor: ArrowButtonBackgroundPressed,
            color: ArrowButtonTextColorPressed,
            selectors: (_a = {},
                _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                    backgroundColor: 'Highlight',
                    color: 'HighlightText'
                },
                _a)
        },
        rootPressed: {
            backgroundColor: ArrowButtonBackgroundPressed,
            color: ArrowButtonTextColorPressed,
            selectors: (_b = {},
                _b[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                    backgroundColor: 'Highlight',
                    color: 'HighlightText'
                },
                _b)
        },
        rootDisabled: {
            opacity: 0.5,
            selectors: (_c = {},
                _c[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                    color: 'GrayText',
                    opacity: 1
                },
                _c)
        },
        icon: {
            fontSize: '6px',
            marginTop: '0',
            marginRight: '0',
            marginBottom: '0',
            marginLeft: '0'
        }
    };
    // No specific styles needed as of now.
    var defaultUpArrowButtonStyles = {};
    var defaultDownArrowButtonStyles = {};
    return Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["t" /* concatStyleSets */])(defaultArrowButtonStyles, isUpArrow ? defaultUpArrowButtonStyles : defaultDownArrowButtonStyles, customSpecificArrowStyles);
    var _a, _b, _c;
});
var getStyles = Object(__WEBPACK_IMPORTED_MODULE_1__Utilities__["_15" /* memoizeFunction */])(function (theme, customStyles) {
    var palette = theme.palette, semanticColors = theme.semanticColors;
    var SpinButtonRootBorderColor = semanticColors.inputBorder;
    var SpinButtonRootBorderColorHovered = semanticColors.inputBorderHovered;
    var SpinButtonRootBorderColorFocused = semanticColors.inputFocusBorderAlt;
    var SpinButtonTextColorDisabled = semanticColors.disabledText;
    var SpinButtonInputTextColor = semanticColors.bodyText;
    var SpinButtonInputTextColorSelected = palette.white;
    var SpinButtonInputBackgroundColorSelected = palette.themePrimary;
    var SpinButtonIconDisabledColor = semanticColors.disabledText;
    var defaultStyles = {
        root: {
            outline: 'none',
            fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].medium,
            width: '100%',
            minWidth: '86px'
        },
        labelWrapper: {
            display: 'inline-flex'
        },
        labelWrapperStart: {
            float: 'left',
            marginRight: '10px'
        },
        labelWrapperEnd: {
            float: 'right',
            marginLeft: '10px'
        },
        labelWrapperTop: {
            marginBottom: '10px'
        },
        labelWrapperBottom: {
            marginTop: '10px'
        },
        icon: {
            padding: '2px 5px',
            fontSize: '20px'
        },
        iconDisabled: {
            color: SpinButtonIconDisabledColor
        },
        label: {
            pointerEvents: 'none',
            padding: '2px 0'
        },
        labelDisabled: {
            cursor: 'default',
            color: SpinButtonTextColorDisabled,
            selectors: (_a = {},
                _a[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                    color: 'GrayText'
                },
                _a)
        },
        spinButtonWrapper: {
            display: 'flex',
            boxSizing: 'border-box',
            height: '32px',
            minWidth: '86px',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: SpinButtonRootBorderColor
        },
        spinButtonWrapperTopBottom: {
            width: '100%'
        },
        spinButtonWrapperHovered: {
            borderColor: SpinButtonRootBorderColorHovered,
            outline: '2px dashed transparent',
            selectors: (_b = {},
                _b[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                    borderColor: 'Highlight',
                    outline: 'none'
                },
                _b)
        },
        spinButtonWrapperFocused: {
            borderColor: SpinButtonRootBorderColorFocused,
            outline: '2px dashed transparent',
            selectors: (_c = {},
                _c[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                    borderColor: 'Highlight',
                    outline: 'none'
                },
                _c)
        },
        spinButtonWrapperDisabled: _getDisabledStyles(theme),
        input: {
            boxSizing: 'border-box',
            boxShadow: 'none',
            borderStyle: 'none',
            marginTop: '0',
            marginRight: '0',
            marginBottom: '0',
            marginLeft: '0',
            fontSize: __WEBPACK_IMPORTED_MODULE_0__Styling__["e" /* FontSizes */].medium,
            color: SpinButtonInputTextColor,
            height: '100%',
            padding: '0 12px',
            outline: '0',
            textOverflow: 'ellipsis',
            display: 'block',
            float: 'left',
            width: 'calc(100% - 14px)',
            minWidth: '72px',
            overflow: 'hidden',
            cursor: 'text',
            userSelect: 'text'
        },
        inputTextSelected: {
            backgroundColor: SpinButtonInputBackgroundColorSelected,
            color: SpinButtonInputTextColorSelected,
            selectors: (_d = {},
                _d[__WEBPACK_IMPORTED_MODULE_0__Styling__["g" /* HighContrastSelector */]] = {
                    backgroundColor: 'Highlight',
                    borderColor: 'Highlight',
                    color: 'HighlightText'
                },
                _d)
        },
        inputDisabled: _getDisabledStyles(theme),
        arrowButtonsContainer: {
            outline: 'none',
            fontSize: '12px',
            display: 'block',
            float: 'left',
            height: '100%',
            cursor: 'default',
            padding: '0',
            boxSizing: 'border-box'
        },
        arrowButtonsContainerDisabled: _getDisabledStyles(theme)
    };
    return Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["t" /* concatStyleSets */])(defaultStyles, customStyles);
    var _a, _b, _c, _d;
});
//# sourceMappingURL=SpinButton.styles.js.map

/***/ }),
/* 2052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getClassNames; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Styling__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_positioning__ = __webpack_require__(151);



var getClassNames = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_15" /* memoizeFunction */])(function (styles, disabled, isFocused, keyboardSpinDirection, labelPosition, className) {
    if (labelPosition === void 0) { labelPosition = __WEBPACK_IMPORTED_MODULE_2__utilities_positioning__["a" /* Position */].start; }
    if (className === void 0) { className = undefined; }
    return {
        root: Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["F" /* mergeStyles */])(styles.root, className),
        labelWrapper: Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["F" /* mergeStyles */])(styles.labelWrapper, _getStyleForLabelBasedOnPosition(labelPosition, styles)),
        icon: Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["F" /* mergeStyles */])(styles.icon, disabled && styles.iconDisabled),
        label: Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["F" /* mergeStyles */])(styles.label, disabled && styles.labelDisabled),
        spinButtonWrapper: Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["F" /* mergeStyles */])(styles.spinButtonWrapper, _getStyleForRootBasedOnPosition(labelPosition, styles), !disabled && [
            {
                selectors: {
                    ':hover': styles.spinButtonWrapperHovered
                }
            },
            isFocused && {
                // This is to increase the specifity of the focus styles
                // and make it equal to that of the hover styles.
                selectors: {
                    '&&': styles.spinButtonWrapperFocused
                }
            }
        ], disabled && styles.spinButtonWrapperDisabled),
        input: Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["F" /* mergeStyles */])('ms-spinButton-input', styles.input, !disabled && {
            selectors: {
                '::selection': styles.inputTextSelected
            }
        }, disabled && styles.inputDisabled),
        arrowBox: Object(__WEBPACK_IMPORTED_MODULE_1__Styling__["F" /* mergeStyles */])(styles.arrowButtonsContainer, disabled && styles.arrowButtonsContainerDisabled)
    };
});
/**
 * Returns the Style corresponding to the label position
 */
function _getStyleForLabelBasedOnPosition(labelPosition, styles) {
    switch (labelPosition) {
        case __WEBPACK_IMPORTED_MODULE_2__utilities_positioning__["a" /* Position */].start:
            return styles.labelWrapperStart;
        case __WEBPACK_IMPORTED_MODULE_2__utilities_positioning__["a" /* Position */].end:
            return styles.labelWrapperEnd;
        case __WEBPACK_IMPORTED_MODULE_2__utilities_positioning__["a" /* Position */].top:
            return styles.labelWrapperTop;
        case __WEBPACK_IMPORTED_MODULE_2__utilities_positioning__["a" /* Position */].bottom:
            return styles.labelWrapperBottom;
    }
}
/**
 * Returns the Style corresponding to the label position
 */
function _getStyleForRootBasedOnPosition(labelPosition, styles) {
    switch (labelPosition) {
        case __WEBPACK_IMPORTED_MODULE_2__utilities_positioning__["a" /* Position */].top:
        case __WEBPACK_IMPORTED_MODULE_2__utilities_positioning__["a" /* Position */].bottom:
            return styles.spinButtonWrapperTopBottom;
        default:
            return {};
    }
}
//# sourceMappingURL=SpinButton.classNames.js.map

/***/ }),
/* 2053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StackItem_StackItem__ = __webpack_require__(826);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Stack__ = __webpack_require__(2055);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Stack__["a"]; });


//# sourceMappingURL=index.js.map

/***/ }),
/* 2054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StackItemStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var GlobalClassNames = {
    root: 'ms-StackItem'
};
var alignMap = {
    start: 'flex-start',
    end: 'flex-end'
};
var StackItemStyles = function (props, theme, tokens) {
    var grow = props.grow, shrink = props.shrink, disableShrink = props.disableShrink, align = props.align, verticalFill = props.verticalFill, order = props.order, className = props.className;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    return {
        root: [
            theme.fonts.medium,
            classNames.root,
            {
                margin: tokens.margin,
                height: verticalFill ? '100%' : 'auto',
                width: 'auto'
            },
            grow && { flexGrow: grow === true ? 1 : grow },
            (disableShrink || (!grow && !shrink)) && {
                flexShrink: 0
            },
            shrink &&
                !disableShrink && {
                flexShrink: 1
            },
            align && {
                alignSelf: alignMap[align] || align
            },
            order && {
                order: order
            },
            className
        ]
        // TODO: this cast may be hiding some potential issues with styling and name
        //        lookups and should be removed
    };
};
//# sourceMappingURL=StackItem.styles.js.map

/***/ }),
/* 2055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Stack; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Foundation__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StackItem_StackItem__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Stack_styles__ = __webpack_require__(2056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Utilities__ = __webpack_require__(1);

/** @jsx withSlots */





var StackItemType = Object(__WEBPACK_IMPORTED_MODULE_2__Foundation__["c" /* withSlots */])(__WEBPACK_IMPORTED_MODULE_3__StackItem_StackItem__["a" /* default */], null).type;
var view = function (props) {
    var _a = props.as, RootType = _a === void 0 ? 'div' : _a, disableShrink = props.disableShrink, wrap = props.wrap, rest = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __rest */](props, ["as", "disableShrink", "wrap"]);
    var stackChildren = __WEBPACK_IMPORTED_MODULE_1_react__["Children"].map(props.children, function (child, index) {
        if (!child) {
            return null;
        }
        if (child.type === StackItemType) {
            var defaultItemProps = {
                shrink: !disableShrink
            };
            return __WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"](child, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, defaultItemProps, child.props));
        }
        return child;
    });
    var nativeProps = Object(__WEBPACK_IMPORTED_MODULE_5__Utilities__["R" /* getNativeProps */])(rest, __WEBPACK_IMPORTED_MODULE_5__Utilities__["_3" /* htmlElementProperties */]);
    var Slots = Object(__WEBPACK_IMPORTED_MODULE_2__Foundation__["b" /* getSlots */])(props, {
        root: RootType,
        inner: 'div'
    });
    if (wrap) {
        return (Object(__WEBPACK_IMPORTED_MODULE_2__Foundation__["c" /* withSlots */])(Slots.root, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, nativeProps),
            Object(__WEBPACK_IMPORTED_MODULE_2__Foundation__["c" /* withSlots */])(Slots.inner, null, stackChildren)));
    }
    return Object(__WEBPACK_IMPORTED_MODULE_2__Foundation__["c" /* withSlots */])(Slots.root, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, nativeProps), stackChildren);
};
var StackStatics = {
    Item: __WEBPACK_IMPORTED_MODULE_3__StackItem_StackItem__["a" /* default */]
};
var Stack = Object(__WEBPACK_IMPORTED_MODULE_2__Foundation__["a" /* createComponent */])({
    displayName: 'Stack',
    styles: __WEBPACK_IMPORTED_MODULE_4__Stack_styles__["a" /* styles */],
    view: view,
    statics: StackStatics
});
/* unused harmony default export */ var _unused_webpack_default_export = (Stack);
//# sourceMappingURL=Stack.js.map

/***/ }),
/* 2056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StackUtils__ = __webpack_require__(2057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Styling__ = __webpack_require__(5);



var nameMap = {
    start: 'flex-start',
    end: 'flex-end'
};
var GlobalClassNames = {
    root: 'ms-Stack',
    inner: 'ms-Stack-inner'
};
var styles = function (props, theme, tokens) {
    var verticalFill = props.verticalFill, maxWidth = props.maxWidth, maxHeight = props.maxHeight, horizontal = props.horizontal, reversed = props.reversed, gap = props.gap, grow = props.grow, wrap = props.wrap, padding = props.padding, horizontalAlign = props.horizontalAlign, verticalAlign = props.verticalAlign, disableShrink = props.disableShrink, className = props.className;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_2__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    var childrenGap = tokens && tokens.childrenGap ? tokens.childrenGap : gap;
    var _a = Object(__WEBPACK_IMPORTED_MODULE_1__StackUtils__["a" /* parseGap */])(childrenGap, theme), rowGap = _a.rowGap, columnGap = _a.columnGap;
    var horizontalMargin = "" + -0.5 * columnGap.value + columnGap.unit;
    var verticalMargin = "" + -0.5 * rowGap.value + rowGap.unit;
    // styles to be applied to all direct children regardless of wrap or direction
    var childStyles = {
        textOverflow: 'ellipsis'
    };
    // selectors to be applied regardless of wrap or direction
    var commonSelectors = {
        // flexShrink styles are applied by the StackItem
        '> *:not(.ms-StackItem)': {
            flexShrink: disableShrink ? 0 : 1
        }
    };
    if (wrap) {
        return {
            root: [
                classNames.root,
                {
                    flexWrap: 'wrap',
                    maxWidth: maxWidth,
                    maxHeight: maxHeight,
                    width: 'auto',
                    overflow: 'visible',
                    height: '100%'
                },
                horizontalAlign && (_b = {},
                    _b[horizontal ? 'justifyContent' : 'alignItems'] = nameMap[horizontalAlign] || horizontalAlign,
                    _b),
                verticalAlign && (_c = {},
                    _c[horizontal ? 'alignItems' : 'justifyContent'] = nameMap[verticalAlign] || verticalAlign,
                    _c),
                className,
                {
                    // not allowed to be overridden by className
                    // since this is necessary in order to prevent collapsing margins
                    display: 'flex'
                },
                horizontal && {
                    height: verticalFill ? '100%' : 'auto'
                }
            ],
            inner: [
                classNames.inner,
                {
                    display: 'flex',
                    flexWrap: 'wrap',
                    marginLeft: horizontalMargin,
                    marginRight: horizontalMargin,
                    marginTop: verticalMargin,
                    marginBottom: verticalMargin,
                    overflow: 'visible',
                    boxSizing: 'border-box',
                    padding: Object(__WEBPACK_IMPORTED_MODULE_1__StackUtils__["b" /* parsePadding */])(padding, theme),
                    // avoid unnecessary calc() calls if horizontal gap is 0
                    width: columnGap.value === 0 ? '100%' : "calc(100% + " + columnGap.value + columnGap.unit + ")",
                    maxWidth: '100vw',
                    selectors: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ '> *': __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ margin: "" + 0.5 * rowGap.value + rowGap.unit + " " + 0.5 * columnGap.value + columnGap.unit }, childStyles) }, commonSelectors)
                },
                horizontalAlign && (_d = {},
                    _d[horizontal ? 'justifyContent' : 'alignItems'] = nameMap[horizontalAlign] || horizontalAlign,
                    _d),
                verticalAlign && (_e = {},
                    _e[horizontal ? 'alignItems' : 'justifyContent'] = nameMap[verticalAlign] || verticalAlign,
                    _e),
                horizontal && {
                    flexDirection: reversed ? 'row-reverse' : 'row',
                    // avoid unnecessary calc() calls if vertical gap is 0
                    height: rowGap.value === 0 ? '100%' : "calc(100% + " + rowGap.value + rowGap.unit + ")",
                    selectors: {
                        '> *': {
                            maxWidth: columnGap.value === 0 ? '100%' : "calc(100% - " + columnGap.value + columnGap.unit + ")"
                        }
                    }
                },
                !horizontal && {
                    flexDirection: reversed ? 'column-reverse' : 'column',
                    height: "calc(100% + " + rowGap.value + rowGap.unit + ")",
                    selectors: {
                        '> *': {
                            maxHeight: rowGap.value === 0 ? '100%' : "calc(100% - " + rowGap.value + rowGap.unit + ")"
                        }
                    }
                }
            ]
        };
    }
    return {
        root: [
            classNames.root,
            {
                display: 'flex',
                flexDirection: horizontal ? (reversed ? 'row-reverse' : 'row') : reversed ? 'column-reverse' : 'column',
                flexWrap: 'nowrap',
                width: 'auto',
                height: verticalFill ? '100%' : 'auto',
                maxWidth: maxWidth,
                maxHeight: maxHeight,
                padding: Object(__WEBPACK_IMPORTED_MODULE_1__StackUtils__["b" /* parsePadding */])(padding, theme),
                boxSizing: 'border-box',
                selectors: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]((_f = { '> *': childStyles }, _f[reversed ? '> *:not(:last-child)' : '> *:not(:first-child)'] = [
                    horizontal && {
                        marginLeft: "" + columnGap.value + columnGap.unit
                    },
                    !horizontal && {
                        marginTop: "" + rowGap.value + rowGap.unit
                    }
                ], _f), commonSelectors)
            },
            grow && {
                flexGrow: grow === true ? 1 : grow,
                overflow: 'hidden'
            },
            horizontalAlign && (_g = {},
                _g[horizontal ? 'justifyContent' : 'alignItems'] = nameMap[horizontalAlign] || horizontalAlign,
                _g),
            verticalAlign && (_h = {},
                _h[horizontal ? 'alignItems' : 'justifyContent'] = nameMap[verticalAlign] || verticalAlign,
                _h),
            className
        ]
        // TODO: this cast may be hiding some potential issues with styling and name
        //        lookups and should be removed
    };
    var _b, _c, _d, _e, _f, _g, _h;
};
//# sourceMappingURL=Stack.styles.js.map

/***/ }),
/* 2057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return parseGap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return parsePadding; });
/**
 * Functions used by Stack components to simplify style-related computations
 */
// Helper function that converts a themed spacing key (if given) to the corresponding themed spacing value.
var _getThemedSpacing = function (space, theme) {
    if (theme.spacing.hasOwnProperty(space)) {
        return theme.spacing[space];
    }
    return space;
};
// Helper function that takes a gap as a string and converts it into a { value, unit } representation.
var _getValueUnitGap = function (gap) {
    var numericalPart = parseFloat(gap);
    var numericalValue = isNaN(numericalPart) ? 0 : numericalPart;
    var numericalString = isNaN(numericalPart) ? '' : numericalPart.toString();
    var unitPart = gap.substring(numericalString.toString().length);
    return {
        value: numericalValue,
        unit: unitPart || 'px'
    };
};
/**
 * Takes in a gap size in either a CSS-style format (e.g. 10 or "10px")
 *  or a key of a themed spacing value (e.g. "s1").
 * Returns the separate numerical value of the padding (e.g. 10)
 *  and the CSS unit (e.g. "px").
 */
var parseGap = function (gap, theme) {
    if (gap === undefined || gap === '') {
        return {
            rowGap: {
                value: 0,
                unit: 'px'
            },
            columnGap: {
                value: 0,
                unit: 'px'
            }
        };
    }
    if (typeof gap === 'number') {
        return {
            rowGap: {
                value: gap,
                unit: 'px'
            },
            columnGap: {
                value: gap,
                unit: 'px'
            }
        };
    }
    var splitGap = gap.split(' ');
    // If the array has more than two values, then return 0px.
    if (splitGap.length > 2) {
        return {
            rowGap: {
                value: 0,
                unit: 'px'
            },
            columnGap: {
                value: 0,
                unit: 'px'
            }
        };
    }
    // If the array has two values, then parse each one.
    if (splitGap.length === 2) {
        return {
            rowGap: _getValueUnitGap(_getThemedSpacing(splitGap[0], theme)),
            columnGap: _getValueUnitGap(_getThemedSpacing(splitGap[1], theme))
        };
    }
    // Else, parse the numerical value and pass it as both the vertical and horizontal gap.
    var calculatedGap = _getValueUnitGap(_getThemedSpacing(gap, theme));
    return {
        rowGap: calculatedGap,
        columnGap: calculatedGap
    };
};
/**
 * Takes in a padding in a CSS-style format (e.g. 10, "10px", "10px 10px", etc.)
 *  where the separate padding values can also be the key of a themed spacing value
 *  (e.g. "s1 m", "10px l1 20px l2", etc.).
 * Returns a CSS-style padding.
 */
var parsePadding = function (padding, theme) {
    if (padding === undefined || typeof padding === 'number' || padding === '') {
        return padding;
    }
    var paddingValues = padding.split(' ');
    if (paddingValues.length < 2) {
        return _getThemedSpacing(padding, theme);
    }
    return paddingValues.reduce(function (padding1, padding2) {
        return _getThemedSpacing(padding1, theme) + ' ' + _getThemedSpacing(padding2, theme);
    });
};
//# sourceMappingURL=StackUtils.js.map

/***/ }),
/* 2058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Sticky_index__ = __webpack_require__(2059);
/* unused harmony namespace reexport */

//# sourceMappingURL=Sticky.js.map

/***/ }),
/* 2059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Sticky__ = __webpack_require__(2060);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sticky_types__ = __webpack_require__(827);
/* unused harmony namespace reexport */


//# sourceMappingURL=index.js.map

/***/ }),
/* 2060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Sticky */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Sticky_types__ = __webpack_require__(827);





var Sticky = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](Sticky, _super);
    function Sticky(props) {
        var _this = _super.call(this, props) || this;
        _this._root = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._stickyContentTop = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._stickyContentBottom = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._nonStickyContent = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this._placeHolder = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.syncScroll = function (container) {
            var nonStickyContent = _this.nonStickyContent;
            if (nonStickyContent && _this.props.isScrollSynced) {
                nonStickyContent.scrollLeft = container.scrollLeft;
            }
        };
        _this._onScrollEvent = function (container, footerStickyContainer) {
            if (_this.root && _this.nonStickyContent) {
                var distanceFromTop = _this._getNonStickyDistanceFromTop(container);
                var isStickyTop = false;
                var isStickyBottom = false;
                if (_this.canStickyTop) {
                    var distanceToStickTop = distanceFromTop - _this._getStickyDistanceFromTop();
                    isStickyTop = distanceToStickTop < container.scrollTop;
                }
                // Can sticky bottom if the scrollablePane - total sticky footer height is smaller than the sticky's distance from the top of the pane
                if (_this.canStickyBottom && container.clientHeight - footerStickyContainer.offsetHeight <= distanceFromTop) {
                    isStickyBottom =
                        distanceFromTop - Math.floor(container.scrollTop) >= _this._getStickyDistanceFromTopForFooter(container, footerStickyContainer);
                }
                if (document.activeElement &&
                    _this.nonStickyContent.contains(document.activeElement) &&
                    (_this.state.isStickyTop !== isStickyTop || _this.state.isStickyBottom !== isStickyBottom)) {
                    _this._activeElement = document.activeElement;
                }
                else {
                    _this._activeElement = undefined;
                }
                _this.setState({
                    isStickyTop: _this.canStickyTop && isStickyTop,
                    isStickyBottom: isStickyBottom,
                    distanceFromTop: distanceFromTop
                });
            }
        };
        _this._getStickyDistanceFromTop = function () {
            var distance = 0;
            if (_this.stickyContentTop) {
                distance = _this.stickyContentTop.offsetTop;
            }
            return distance;
        };
        _this._getStickyDistanceFromTopForFooter = function (container, footerStickyVisibleContainer) {
            var distance = 0;
            if (_this.stickyContentBottom) {
                distance = container.clientHeight - footerStickyVisibleContainer.offsetHeight + _this.stickyContentBottom.offsetTop;
            }
            return distance;
        };
        _this._getNonStickyDistanceFromTop = function (container) {
            var distance = 0;
            var currElem = _this.root;
            if (currElem) {
                while (currElem && currElem.offsetParent !== container) {
                    distance += currElem.offsetTop;
                    currElem = currElem.offsetParent;
                }
                if (currElem && currElem.offsetParent === container) {
                    distance += currElem.offsetTop;
                }
            }
            return distance;
        };
        _this.state = {
            isStickyTop: false,
            isStickyBottom: false,
            distanceFromTop: undefined
        };
        _this._activeElement = undefined;
        return _this;
    }
    Object.defineProperty(Sticky.prototype, "root", {
        get: function () {
            return this._root.current;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Sticky.prototype, "placeholder", {
        get: function () {
            return this._placeHolder.current;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Sticky.prototype, "stickyContentTop", {
        get: function () {
            return this._stickyContentTop.current;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Sticky.prototype, "stickyContentBottom", {
        get: function () {
            return this._stickyContentBottom.current;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Sticky.prototype, "nonStickyContent", {
        get: function () {
            return this._nonStickyContent.current;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Sticky.prototype, "canStickyTop", {
        get: function () {
            return this.props.stickyPosition === __WEBPACK_IMPORTED_MODULE_4__Sticky_types__["a" /* StickyPositionType */].Both || this.props.stickyPosition === __WEBPACK_IMPORTED_MODULE_4__Sticky_types__["a" /* StickyPositionType */].Header;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Sticky.prototype, "canStickyBottom", {
        get: function () {
            return this.props.stickyPosition === __WEBPACK_IMPORTED_MODULE_4__Sticky_types__["a" /* StickyPositionType */].Both || this.props.stickyPosition === __WEBPACK_IMPORTED_MODULE_4__Sticky_types__["a" /* StickyPositionType */].Footer;
        },
        enumerable: true,
        configurable: true
    });
    Sticky.prototype.componentDidMount = function () {
        var scrollablePane = this.context.scrollablePane;
        if (!scrollablePane) {
            return;
        }
        scrollablePane.subscribe(this._onScrollEvent);
        scrollablePane.addSticky(this);
    };
    Sticky.prototype.componentWillUnmount = function () {
        var scrollablePane = this.context.scrollablePane;
        if (!scrollablePane) {
            return;
        }
        scrollablePane.unsubscribe(this._onScrollEvent);
        scrollablePane.removeSticky(this);
    };
    Sticky.prototype.componentDidUpdate = function (prevProps, prevState) {
        var scrollablePane = this.context.scrollablePane;
        if (!scrollablePane) {
            return;
        }
        var _a = this.state, isStickyBottom = _a.isStickyBottom, isStickyTop = _a.isStickyTop, distanceFromTop = _a.distanceFromTop;
        var syncScroll = false;
        if (prevState.distanceFromTop !== distanceFromTop) {
            scrollablePane.sortSticky(this, true /*sortAgain*/);
            syncScroll = true;
        }
        if (prevState.isStickyTop !== isStickyTop || prevState.isStickyBottom !== isStickyBottom) {
            if (this._activeElement) {
                this._activeElement.focus();
            }
            scrollablePane.updateStickyRefHeights();
            syncScroll = true;
        }
        if (syncScroll) {
            // Sync Sticky scroll position with content container on each update
            scrollablePane.syncScrollSticky(this);
        }
    };
    Sticky.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        if (!this.context.scrollablePane) {
            return true;
        }
        var _a = this.state, isStickyTop = _a.isStickyTop, isStickyBottom = _a.isStickyBottom, distanceFromTop = _a.distanceFromTop;
        return (isStickyTop !== nextState.isStickyTop ||
            isStickyBottom !== nextState.isStickyBottom ||
            this.props.stickyPosition !== nextProps.stickyPosition ||
            this.props.children !== nextProps.children ||
            distanceFromTop !== nextState.distanceFromTop ||
            _isOffsetHeightDifferent(this._nonStickyContent, this._stickyContentTop) ||
            _isOffsetHeightDifferent(this._nonStickyContent, this._stickyContentBottom) ||
            _isOffsetHeightDifferent(this._nonStickyContent, this._placeHolder));
    };
    Sticky.prototype.render = function () {
        var _a = this.state, isStickyTop = _a.isStickyTop, isStickyBottom = _a.isStickyBottom;
        var _b = this.props, stickyClassName = _b.stickyClassName, children = _b.children;
        if (!this.context.scrollablePane) {
            return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null, this.props.children);
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: this._root },
            this.canStickyTop && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: this._stickyContentTop, "aria-hidden": !isStickyTop, style: { pointerEvents: isStickyTop ? 'auto' : 'none' } },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { style: this._getStickyPlaceholderHeight(isStickyTop) }))),
            this.canStickyBottom && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: this._stickyContentBottom, "aria-hidden": !isStickyBottom, style: { pointerEvents: isStickyBottom ? 'auto' : 'none' } },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { style: this._getStickyPlaceholderHeight(isStickyBottom) }))),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { style: this._getNonStickyPlaceholderHeightAndWidth(), ref: this._placeHolder },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { ref: this._nonStickyContent, className: isStickyTop || isStickyBottom ? stickyClassName : undefined, style: this._getContentStyles(isStickyTop || isStickyBottom) }, children))));
    };
    Sticky.prototype.addSticky = function (stickyContent) {
        if (this.nonStickyContent) {
            stickyContent.appendChild(this.nonStickyContent);
        }
    };
    Sticky.prototype.resetSticky = function () {
        if (this.nonStickyContent && this.placeholder) {
            this.placeholder.appendChild(this.nonStickyContent);
        }
    };
    Sticky.prototype.setDistanceFromTop = function (container) {
        var distanceFromTop = this._getNonStickyDistanceFromTop(container);
        this.setState({ distanceFromTop: distanceFromTop });
    };
    Sticky.prototype._getContentStyles = function (isSticky) {
        return {
            backgroundColor: this.props.stickyBackgroundColor || this._getBackground(),
            overflow: isSticky ? 'hidden' : ''
        };
    };
    Sticky.prototype._getStickyPlaceholderHeight = function (isSticky) {
        var height = this.nonStickyContent ? this.nonStickyContent.offsetHeight : 0;
        return {
            visibility: isSticky ? 'hidden' : 'visible',
            height: isSticky ? 0 : height
        };
    };
    Sticky.prototype._getNonStickyPlaceholderHeightAndWidth = function () {
        var _a = this.state, isStickyTop = _a.isStickyTop, isStickyBottom = _a.isStickyBottom;
        if (isStickyTop || isStickyBottom) {
            var height = 0, width = 0;
            // Why is placeHolder width needed?
            // ScrollablePane content--container is reponsible for providing scrollbars depending on content overflow.
            // If the overflow is caused by content of sticky component when it is in non-sticky state,
            // ScrollablePane content--conatiner will provide horizontal scrollbar.
            // If the component becomes sticky, i.e., when state.isStickyTop || state.isStickyBottom becomes true,
            // it's actual content is no more inside ScrollablePane content--container.
            // ScrollablePane content--conatiner will see no need for horizontal scrollbar. (Assuming no other content is causing overflow)
            // The complete content of sticky component will not be viewable.
            // It is necessary to provide a placeHolder of a certain width (height is already being set) in the content--container,
            // to get a horizontal scrollbar & be able to view the complete content of sticky component.
            if (this.nonStickyContent && this.nonStickyContent.firstElementChild) {
                height = this.nonStickyContent.offsetHeight;
                // What value should be substituted for placeHolder width?
                // Assumption:
                //    1. Content inside <Sticky> should always be wrapped in a single div.
                //        <Sticky><div id={'firstElementChild'}>{intended_content}</div><Sticky/>
                //    2. -ve padding, margin, etc. are not be used.
                //    3. scrollWidth of a parent is greater than or equal to max of scrollWidths of it's children and same holds for children.
                // placeHolder width should be computed in the best possible way to prevent overscroll/underscroll.
                width =
                    this.nonStickyContent.firstElementChild.scrollWidth +
                        (this.nonStickyContent.firstElementChild.offsetWidth - this.nonStickyContent.firstElementChild.clientWidth);
            }
            return {
                height: height,
                width: width
            };
        }
        else {
            return {};
        }
    };
    // Gets background of nearest parent element that has a declared background-color attribute
    Sticky.prototype._getBackground = function () {
        if (!this.root) {
            return undefined;
        }
        var curr = this.root;
        while (window.getComputedStyle(curr).getPropertyValue('background-color') === 'rgba(0, 0, 0, 0)' ||
            window.getComputedStyle(curr).getPropertyValue('background-color') === 'transparent') {
            if (curr.tagName === 'HTML') {
                // Fallback color if no element has a declared background-color attribute
                return undefined;
            }
            if (curr.parentElement) {
                curr = curr.parentElement;
            }
        }
        return window.getComputedStyle(curr).getPropertyValue('background-color');
    };
    Sticky.defaultProps = {
        stickyPosition: __WEBPACK_IMPORTED_MODULE_4__Sticky_types__["a" /* StickyPositionType */].Both,
        isScrollSynced: true
    };
    Sticky.contextTypes = {
        scrollablePane: __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"]
    };
    return Sticky;
}(__WEBPACK_IMPORTED_MODULE_3__Utilities__["c" /* BaseComponent */]));

function _isOffsetHeightDifferent(a, b) {
    return (a && b && a.current && b.current && a.current.offsetHeight !== b.current.offsetHeight);
}
//# sourceMappingURL=Sticky.js.map

/***/ }),
/* 2061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SwatchColorPicker_index__ = __webpack_require__(2062);
/* unused harmony namespace reexport */

//# sourceMappingURL=SwatchColorPicker.js.map

/***/ }),
/* 2062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SwatchColorPicker__ = __webpack_require__(2063);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SwatchColorPicker_base__ = __webpack_require__(828);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ColorPickerGridCell__ = __webpack_require__(829);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ColorPickerGridCell_base__ = __webpack_require__(830);
/* unused harmony namespace reexport */




//# sourceMappingURL=index.js.map

/***/ }),
/* 2063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SwatchColorPicker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SwatchColorPicker_base__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SwatchColorPicker_styles__ = __webpack_require__(2065);



var SwatchColorPicker = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__SwatchColorPicker_base__["a" /* SwatchColorPickerBase */], __WEBPACK_IMPORTED_MODULE_2__SwatchColorPicker_styles__["a" /* getStyles */], undefined, { scope: 'SwatchColorPicker' });
//# sourceMappingURL=SwatchColorPicker.js.map

/***/ }),
/* 2064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Styling__ = __webpack_require__(5);


// Size breakpoint when the default border width changes from 2px to 4px.
var CELL_BORDER_BREAKPOINT = 24;
var LARGE_BORDER = 4;
var SMALL_BORDER = 2;
var DIVIDING_PADDING = 2;
var DEFAULT_CELL_SIZE = 20;
var getStyles = function (props) {
    var theme = props.theme, disabled = props.disabled, selected = props.selected, circle = props.circle, isWhite = props.isWhite, _a = props.height, height = _a === void 0 ? DEFAULT_CELL_SIZE : _a, _b = props.width, width = _b === void 0 ? DEFAULT_CELL_SIZE : _b, borderWidth = props.borderWidth;
    var semanticColors = theme.semanticColors;
    // If user provided a value, use it. If not, then we decide depending on the 24px size breakpoint.
    var calculatedBorderWidth = borderWidth ? borderWidth : width < CELL_BORDER_BREAKPOINT ? SMALL_BORDER : LARGE_BORDER;
    return {
        // this is a button that wraps the color
        colorCell: [
            {
                backgroundColor: semanticColors.bodyBackground,
                padding: 0,
                position: 'relative',
                boxSizing: 'border-box',
                display: 'inline-block',
                cursor: 'pointer',
                userSelect: 'none',
                border: 'none',
                height: height,
                width: width
            },
            !circle && {
                selectors: (_c = {},
                    _c["." + __WEBPACK_IMPORTED_MODULE_0__Utilities__["f" /* IsFocusVisibleClassName */] + " &:focus::after"] = {
                        // -1px so that we don't increase visually the size of the cell.
                        outlineOffset: calculatedBorderWidth - 1 + "px"
                    },
                    _c)
            },
            // In focus state for circle we want a round border which is not possible with outline.
            circle && {
                borderRadius: '50%',
                selectors: (_d = {},
                    _d["." + __WEBPACK_IMPORTED_MODULE_0__Utilities__["f" /* IsFocusVisibleClassName */] + " &:focus::after"] = {
                        outline: 'none',
                        borderColor: semanticColors.focusBorder,
                        borderRadius: '50%',
                        left: -calculatedBorderWidth,
                        right: -calculatedBorderWidth,
                        top: -calculatedBorderWidth,
                        bottom: -calculatedBorderWidth,
                        selectors: (_e = {},
                            _e[__WEBPACK_IMPORTED_MODULE_1__Styling__["g" /* HighContrastSelector */]] = {
                                outline: "1px solid ButtonText"
                            },
                            _e)
                    },
                    _d)
            },
            selected && {
                padding: DIVIDING_PADDING,
                border: calculatedBorderWidth + "px solid " + theme.palette.neutralTertiaryAlt,
                selectors: (_f = {},
                    _f['&:hover::before'] = {
                        content: '""',
                        height: height,
                        width: width,
                        position: 'absolute',
                        top: -calculatedBorderWidth,
                        left: -calculatedBorderWidth,
                        borderRadius: circle ? '50%' : 'default',
                        boxShadow: "inset 0 0 0 1px " + theme.palette.neutralSecondary
                    },
                    _f)
            },
            !selected && {
                selectors: (_g = {},
                    _g['&:hover, &:active, &:focus'] = {
                        backgroundColor: semanticColors.bodyBackground,
                        padding: DIVIDING_PADDING,
                        border: calculatedBorderWidth + "px solid " + theme.palette.neutralLight
                    },
                    _g['&:focus'] = {
                        borderColor: semanticColors.bodyBackground,
                        padding: 0,
                        selectors: {
                            ':hover': {
                                borderColor: theme.palette.neutralLight,
                                padding: DIVIDING_PADDING
                            }
                        }
                    },
                    _g)
            },
            disabled && {
                color: semanticColors.disabledBodyText,
                pointerEvents: 'none',
                opacity: 0.3
            },
            isWhite &&
                !selected && {
                // fake a border for white
                backgroundColor: semanticColors.bodyDivider,
                padding: 1
            }
        ],
        // the <svg> that holds the color
        svg: [
            {
                width: '100%',
                height: '100%'
            },
            circle && {
                borderRadius: '50%'
            }
        ]
    };
    var _c, _d, _e, _f, _g;
};
//# sourceMappingURL=ColorPickerGridCell.styles.js.map

/***/ }),
/* 2065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Styling__ = __webpack_require__(5);

var GlobalClassNames = {
    focusedContainer: 'ms-swatchColorPickerBodyContainer'
};
var getStyles = function (props) {
    var className = props.className, theme = props.theme, cellMargin = props.cellMargin;
    var classNames = Object(__WEBPACK_IMPORTED_MODULE_0__Styling__["w" /* getGlobalClassNames */])(GlobalClassNames, theme);
    return {
        root: {
            margin: '8px 0',
            borderCollapse: 'collapse'
        },
        tableCell: {
            padding: cellMargin / 2
        },
        focusedContainer: [
            classNames.focusedContainer,
            {
                clear: 'both',
                display: 'block',
                minWidth: '180px'
            },
            className
        ]
    };
};
//# sourceMappingURL=SwatchColorPicker.styles.js.map

/***/ }),
/* 2066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TeachingBubble_index__ = __webpack_require__(2067);
/* unused harmony namespace reexport */

//# sourceMappingURL=TeachingBubble.js.map

/***/ }),
/* 2067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TeachingBubble__ = __webpack_require__(2068);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TeachingBubble_base__ = __webpack_require__(831);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TeachingBubbleContent__ = __webpack_require__(832);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TeachingBubbleContent_base__ = __webpack_require__(833);
/* unused harmony namespace reexport */




//# sourceMappingURL=index.js.map

/***/ }),
/* 2068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TeachingBubble */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TeachingBubble_base__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TeachingBubble_styles__ = __webpack_require__(834);



var TeachingBubble = Object(__WEBPACK_IMPORTED_MODULE_0__Utilities__["_29" /* styled */])(__WEBPACK_IMPORTED_MODULE_1__TeachingBubble_base__["a" /* TeachingBubbleBase */], __WEBPACK_IMPORTED_MODULE_2__TeachingBubble_styles__["a" /* getStyles */], undefined, { scope: 'TeachingBubble' });
//# sourceMappingURL=TeachingBubble.js.map

/***/ }),
/* 2069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Text_index__ = __webpack_require__(2070);
/* unused harmony namespace reexport */

//# sourceMappingURL=Text.js.map

/***/ }),
/* 2070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Text__ = __webpack_require__(2071);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Text_view__ = __webpack_require__(835);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Text_styles__ = __webpack_require__(836);
/* unused harmony namespace reexport */



//# sourceMappingURL=index.js.map

/***/ }),
/* 2071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Text */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Foundation__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Text_view__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Text_styles__ = __webpack_require__(836);



var Text = Object(__WEBPACK_IMPORTED_MODULE_0__Foundation__["a" /* createComponent */])({
    displayName: 'Text',
    styles: __WEBPACK_IMPORTED_MODULE_2__Text_styles__["a" /* TextStyles */],
    view: __WEBPACK_IMPORTED_MODULE_1__Text_view__["a" /* TextView */]
});
/* unused harmony default export */ var _unused_webpack_default_export = (Text);
//# sourceMappingURL=Text.js.map

/***/ }),
/* 2072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ThemeGenerator_index__ = __webpack_require__(2073);
/* unused harmony namespace reexport */

//# sourceMappingURL=ThemeGenerator.js.map

/***/ }),
/* 2073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ThemeGenerator__ = __webpack_require__(2074);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ThemeRulesStandard__ = __webpack_require__(2075);
/* unused harmony namespace reexport */


//# sourceMappingURL=index.js.map

/***/ }),
/* 2074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ThemeGenerator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_color_getColorFromString__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_color_shades__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);



var ThemeGenerator = /** @class */ (function () {
    function ThemeGenerator() {
    }
    /* Sets an IThemeSlotRule to the given color and cascades it to the rest of the theme, updating other IThemeSlotRules in the theme that
     *   inherit from that color.
     * isInverted: whether it's a dark theme or not, which affects the algorithm used to generate shades
     * isCustomization should be true only if it's a user action, and indicates overwriting the slot's inheritance (if any)
     * overwriteCustomColor: a slot could have a generated color based on its inheritance rules (isCustomized is false), or a custom color
                              based on user input (isCustomized is true), this bool tells us whether to override existing customized colors */
    ThemeGenerator.setSlot = function (rule, color, isInverted, isCustomization, overwriteCustomColor) {
        if (isInverted === void 0) { isInverted = false; }
        if (isCustomization === void 0) { isCustomization = false; }
        if (overwriteCustomColor === void 0) { overwriteCustomColor = true; }
        if (!rule.color && rule.value) {
            // not a color rule
            return;
        }
        if (overwriteCustomColor) {
            var colorAsIColor = void 0;
            if (typeof color === 'string') {
                colorAsIColor = Object(__WEBPACK_IMPORTED_MODULE_0__utilities_color_getColorFromString__["a" /* getColorFromString */])(color); // the ! is a lie here but we'll verify it in the next line
                if (!colorAsIColor) {
                    throw 'color is invalid in setSlot(): ' + color;
                }
            }
            else {
                colorAsIColor = color;
            }
            ThemeGenerator._setSlot(rule, colorAsIColor, isInverted, isCustomization, overwriteCustomColor);
        }
        else if (rule.color) {
            ThemeGenerator._setSlot(rule, rule.color, isInverted, isCustomization, overwriteCustomColor);
        }
    };
    /* Sets the color of each slot based on its rule. Slots that don't inherit must have a color already.
     * If this completes without error, then the theme is ready to use. (All slots will have a color.)
     * setSlot() can be called before this, but this must be called before getThemeAs*().
     * Does not override colors of rules where isCustomized is true (i.e. doesn't override existing customizations).
     */
    ThemeGenerator.insureSlots = function (slotRules, isInverted) {
        // Get all the "root" rules, the ones which don't inherit. Then "set" them to trigger updating dependent slots.
        for (var ruleName in slotRules) {
            if (slotRules.hasOwnProperty(ruleName)) {
                var rule = slotRules[ruleName];
                if (!rule.inherits && !rule.value) {
                    if (!rule.color) {
                        throw 'A color slot rule that does not inherit must provide its own color.';
                    }
                    ThemeGenerator._setSlot(rule, rule.color, isInverted, false, false);
                }
            }
        }
    };
    /* Gets the JSON-formatted blob that describes the theme, usable with the REST request endpoints
     * { [theme slot name as string] : [color as string],
     *  "tokenName": "#f00f00",
     *  "tokenName2": "#ba2ba2",
     *   ... }
     */
    ThemeGenerator.getThemeAsJson = function (slotRules) {
        var theme = {};
        for (var ruleName in slotRules) {
            if (slotRules.hasOwnProperty(ruleName)) {
                var rule = slotRules[ruleName];
                theme[rule.name] = rule.color ? rule.color.str : rule.value || '';
            }
        }
        return theme;
    };
    /*
     * Gets code-formatted load theme blob that can be copy and pasted.
     */
    ThemeGenerator.getThemeAsCode = function (slotRules) {
        var attributeTemplate = "    {0}: '{1}',\n";
        var output = '';
        output += 'loadTheme({\n  palette: {\n';
        for (var ruleName in slotRules) {
            if (slotRules.hasOwnProperty(ruleName)) {
                var rule = slotRules[ruleName];
                var camelCasedName = rule.name.charAt(0).toLowerCase() + rule.name.slice(1);
                var outputColor = rule.color ? '#' + rule.color.hex : rule.value || '';
                output += Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["G" /* format */])(attributeTemplate, camelCasedName, outputColor);
            }
        }
        output += '  }\n});';
        return output;
    };
    /* Gets the theme as a list of SASS variables that can be used in code
     * $tokenName: "[theme:tokenName, default:#f00f00]";
     * $tokenName2: "[theme:tokenName2, default:#ba2ba2]";
     * ...
     */
    ThemeGenerator.getThemeAsSass = function (slotRules) {
        var sassVarTemplate = '${0}Color: "[theme: {1}, default: {2}]";\n';
        var output = '';
        for (var ruleName in slotRules) {
            if (slotRules.hasOwnProperty(ruleName)) {
                var rule = slotRules[ruleName];
                var camelCasedName = rule.name.charAt(0).toLowerCase() + rule.name.slice(1);
                output += Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["G" /* format */])(sassVarTemplate, camelCasedName, camelCasedName, rule.color ? rule.color.str : rule.value || '');
            }
        }
        return output;
    };
    /* Gets the theme formatted for PowerShell scripts
     * @{
     * "tokenName" = "#f00f00";
     * "tokenName2" = "#ba2ba2";
     * ...
     * }
     */
    ThemeGenerator.getThemeForPowerShell = function (slotRules) {
        var psVarTemplate = '"{0}" = "{1}";\n';
        var output = '';
        for (var ruleName in slotRules) {
            if (slotRules.hasOwnProperty(ruleName)) {
                var rule = slotRules[ruleName];
                if (rule.value) {
                    // skip this one, it's not a color
                    continue;
                }
                var camelCasedName = rule.name.charAt(0).toLowerCase() + rule.name.slice(1);
                var outputColor = rule.color ? '#' + rule.color.hex : rule.value || '';
                // powershell endpoint uses the RGBA format
                if (rule.color && rule.color.a && rule.color.a !== 100) {
                    outputColor += String(rule.color.a.toString(16));
                }
                output += Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["G" /* format */])(psVarTemplate, camelCasedName, outputColor);
            }
        }
        return '@{\n' + output + '}';
    };
    /* Sets the given slot's color to the appropriate color, shading it if necessary.
       Then, iterates through all other rules (that are this rule's dependents) to update them accordingly.
       isCustomization=true means it's a user provided color, set it to that raw color
       isCustomization=false means the rule it's inheriting from changed, so updated using asShade */
    ThemeGenerator._setSlot = function (rule, color, isInverted, isCustomization, overwriteCustomColor) {
        if (overwriteCustomColor === void 0) { overwriteCustomColor = true; }
        if (!rule.color && rule.value) {
            // not a color rule
            return;
        }
        if (overwriteCustomColor || !rule.color || !rule.isCustomized || !rule.inherits) {
            // set the rule's color under these conditions
            if ((overwriteCustomColor || !rule.isCustomized) && !isCustomization && rule.inherits && Object(__WEBPACK_IMPORTED_MODULE_1__utilities_color_shades__["d" /* isValidShade */])(rule.asShade)) {
                // it's inheriting by shade
                if (rule.isBackgroundShade) {
                    rule.color = Object(__WEBPACK_IMPORTED_MODULE_1__utilities_color_shades__["b" /* getBackgroundShade */])(color, rule.asShade, isInverted);
                }
                else {
                    rule.color = Object(__WEBPACK_IMPORTED_MODULE_1__utilities_color_shades__["c" /* getShade */])(color, rule.asShade, isInverted);
                }
                rule.isCustomized = false;
            }
            else {
                rule.color = color;
                rule.isCustomized = true;
            }
            // then update dependent colors
            for (var _i = 0, _a = rule.dependentRules; _i < _a.length; _i++) {
                var ruleToUpdate = _a[_i];
                ThemeGenerator._setSlot(ruleToUpdate, rule.color, isInverted, false, overwriteCustomColor);
            }
        }
    };
    return ThemeGenerator;
}());

//# sourceMappingURL=ThemeGenerator.js.map

/***/ }),
/* 2075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BaseSlots */
/* unused harmony export FabricSlots */
/* unused harmony export SemanticColorSlots */
/* unused harmony export themeRulesStandardCreator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_color_getColorFromString__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities__ = __webpack_require__(1);



/* This is the set of rules for our default theme.
   We start with three base slots, defining the background, foreground (text), and
   primary color (sometimes called theme color). Each Fabric slot is generated from
   shades (or tints) of one of those three, creating the Fabric palette.
   Then, we have semantic slots, the new thing intended to eventually replace the
   Fabric palette. The semantic slots inherit from the Fabric palette. */
/* The most minimal set of slots we start with. All other ones can be generated based on rules.
 * This is not so much an enum as it is a list. The enum is used to insure "type"-safety.
 * For now, we are only dealing with color. */
var BaseSlots;
(function (BaseSlots) {
    BaseSlots[BaseSlots["primaryColor"] = 0] = "primaryColor";
    BaseSlots[BaseSlots["backgroundColor"] = 1] = "backgroundColor";
    BaseSlots[BaseSlots["foregroundColor"] = 2] = "foregroundColor";
})(BaseSlots || (BaseSlots = {}));
/* The original Fabric palette, only for back-compat. */
var FabricSlots;
(function (FabricSlots) {
    FabricSlots[FabricSlots["themePrimary"] = 0] = "themePrimary";
    FabricSlots[FabricSlots["themeLighterAlt"] = 1] = "themeLighterAlt";
    FabricSlots[FabricSlots["themeLighter"] = 2] = "themeLighter";
    FabricSlots[FabricSlots["themeLight"] = 3] = "themeLight";
    FabricSlots[FabricSlots["themeTertiary"] = 4] = "themeTertiary";
    FabricSlots[FabricSlots["themeSecondary"] = 5] = "themeSecondary";
    FabricSlots[FabricSlots["themeDarkAlt"] = 6] = "themeDarkAlt";
    FabricSlots[FabricSlots["themeDark"] = 7] = "themeDark";
    FabricSlots[FabricSlots["themeDarker"] = 8] = "themeDarker";
    FabricSlots[FabricSlots["neutralLighterAlt"] = 9] = "neutralLighterAlt";
    FabricSlots[FabricSlots["neutralLighter"] = 10] = "neutralLighter";
    FabricSlots[FabricSlots["neutralLight"] = 11] = "neutralLight";
    FabricSlots[FabricSlots["neutralQuaternaryAlt"] = 12] = "neutralQuaternaryAlt";
    FabricSlots[FabricSlots["neutralQuaternary"] = 13] = "neutralQuaternary";
    FabricSlots[FabricSlots["neutralTertiaryAlt"] = 14] = "neutralTertiaryAlt";
    FabricSlots[FabricSlots["neutralTertiary"] = 15] = "neutralTertiary";
    // deprecated: neutralSecondaryAlt, // BaseSlots.foregroundColor, Shade[Shade.Shade4]);
    FabricSlots[FabricSlots["neutralSecondary"] = 16] = "neutralSecondary";
    FabricSlots[FabricSlots["neutralPrimaryAlt"] = 17] = "neutralPrimaryAlt";
    FabricSlots[FabricSlots["neutralPrimary"] = 18] = "neutralPrimary";
    FabricSlots[FabricSlots["neutralDark"] = 19] = "neutralDark";
    FabricSlots[FabricSlots["black"] = 20] = "black";
    FabricSlots[FabricSlots["white"] = 21] = "white"; // BaseSlots.backgroundColor, Shade[Shade.Unshaded]);
})(FabricSlots || (FabricSlots = {}));
/* List of all the semantic color slots for this theme.
 * This is not so much an enum as it is a list. The enum is used to insure "type"-safety. */
var SemanticColorSlots;
(function (SemanticColorSlots) {
    SemanticColorSlots[SemanticColorSlots["bodyBackground"] = 0] = "bodyBackground";
    SemanticColorSlots[SemanticColorSlots["bodyText"] = 1] = "bodyText";
    SemanticColorSlots[SemanticColorSlots["disabledBackground"] = 2] = "disabledBackground";
    SemanticColorSlots[SemanticColorSlots["disabledText"] = 3] = "disabledText";
})(SemanticColorSlots || (SemanticColorSlots = {}));
function themeRulesStandardCreator() {
    var slotRules = {};
    /*** BASE COLORS and their SHADES */
    // iterate through each base slot and make the SlotRules for those
    Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_14" /* mapEnumByName */])(BaseSlots, function (baseSlot) {
        // first make the SlotRule for the unshaded base Color
        slotRules[baseSlot] = {
            name: baseSlot,
            isCustomized: true,
            dependentRules: []
        };
        // then make a rule for each shade of this base color, but skip unshaded
        Object(__WEBPACK_IMPORTED_MODULE_2__Utilities__["_14" /* mapEnumByName */])(__WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */], function (shadeName, shadeValue) {
            if (shadeName === __WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */][__WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */].Unshaded]) {
                return;
            }
            var inherits = slotRules[baseSlot];
            var thisSlotRule = {
                name: baseSlot + shadeName,
                inherits: slotRules[baseSlot],
                asShade: shadeValue,
                isCustomized: false,
                isBackgroundShade: baseSlot === BaseSlots[BaseSlots.backgroundColor] ? true : false,
                dependentRules: []
            };
            slotRules[baseSlot + shadeName] = thisSlotRule;
            inherits.dependentRules.push(thisSlotRule);
            return void 0;
        });
        return void 0;
    });
    // set default colors for the base colors
    slotRules[BaseSlots[BaseSlots.primaryColor]].color = Object(__WEBPACK_IMPORTED_MODULE_1__utilities_color_getColorFromString__["a" /* getColorFromString */])('#0078d4');
    slotRules[BaseSlots[BaseSlots.backgroundColor]].color = Object(__WEBPACK_IMPORTED_MODULE_1__utilities_color_getColorFromString__["a" /* getColorFromString */])('#fff');
    slotRules[BaseSlots[BaseSlots.foregroundColor]].color = Object(__WEBPACK_IMPORTED_MODULE_1__utilities_color_getColorFromString__["a" /* getColorFromString */])('#333');
    // set default colors for shades (the slot rules were already created above and will be used if the base colors ever change)
    slotRules[BaseSlots[BaseSlots.primaryColor] + __WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */][__WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */].Shade1]].color = Object(__WEBPACK_IMPORTED_MODULE_1__utilities_color_getColorFromString__["a" /* getColorFromString */])('#eff6fc');
    slotRules[BaseSlots[BaseSlots.primaryColor] + __WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */][__WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */].Shade2]].color = Object(__WEBPACK_IMPORTED_MODULE_1__utilities_color_getColorFromString__["a" /* getColorFromString */])('#deecf9');
    slotRules[BaseSlots[BaseSlots.primaryColor] + __WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */][__WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */].Shade3]].color = Object(__WEBPACK_IMPORTED_MODULE_1__utilities_color_getColorFromString__["a" /* getColorFromString */])('#c7e0f4');
    slotRules[BaseSlots[BaseSlots.primaryColor] + __WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */][__WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */].Shade4]].color = Object(__WEBPACK_IMPORTED_MODULE_1__utilities_color_getColorFromString__["a" /* getColorFromString */])('#71afe5');
    slotRules[BaseSlots[BaseSlots.primaryColor] + __WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */][__WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */].Shade5]].color = Object(__WEBPACK_IMPORTED_MODULE_1__utilities_color_getColorFromString__["a" /* getColorFromString */])('#2b88d8');
    slotRules[BaseSlots[BaseSlots.primaryColor] + __WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */][__WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */].Shade6]].color = Object(__WEBPACK_IMPORTED_MODULE_1__utilities_color_getColorFromString__["a" /* getColorFromString */])('#106ebe');
    slotRules[BaseSlots[BaseSlots.primaryColor] + __WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */][__WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */].Shade7]].color = Object(__WEBPACK_IMPORTED_MODULE_1__utilities_color_getColorFromString__["a" /* getColorFromString */])('#005a9e');
    slotRules[BaseSlots[BaseSlots.primaryColor] + __WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */][__WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */].Shade8]].color = Object(__WEBPACK_IMPORTED_MODULE_1__utilities_color_getColorFromString__["a" /* getColorFromString */])('#004578');
    // set default colors for shades (the slot rules were already created above and will be used if the base colors ever change)
    slotRules[BaseSlots[BaseSlots.foregroundColor] + __WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */][__WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */].Shade1]].color = Object(__WEBPACK_IMPORTED_MODULE_1__utilities_color_getColorFromString__["a" /* getColorFromString */])('#eaeaea');
    slotRules[BaseSlots[BaseSlots.foregroundColor] + __WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */][__WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */].Shade2]].color = Object(__WEBPACK_IMPORTED_MODULE_1__utilities_color_getColorFromString__["a" /* getColorFromString */])('#c8c8c8');
    slotRules[BaseSlots[BaseSlots.foregroundColor] + __WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */][__WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */].Shade3]].color = Object(__WEBPACK_IMPORTED_MODULE_1__utilities_color_getColorFromString__["a" /* getColorFromString */])('#a6a6a6');
    slotRules[BaseSlots[BaseSlots.foregroundColor] + __WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */][__WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */].Shade4]].color = Object(__WEBPACK_IMPORTED_MODULE_1__utilities_color_getColorFromString__["a" /* getColorFromString */])('#767676');
    slotRules[BaseSlots[BaseSlots.foregroundColor] + __WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */][__WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */].Shade5]].color = Object(__WEBPACK_IMPORTED_MODULE_1__utilities_color_getColorFromString__["a" /* getColorFromString */])('#666666');
    slotRules[BaseSlots[BaseSlots.foregroundColor] + __WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */][__WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */].Shade6]].color = Object(__WEBPACK_IMPORTED_MODULE_1__utilities_color_getColorFromString__["a" /* getColorFromString */])('#3c3c3c');
    slotRules[BaseSlots[BaseSlots.foregroundColor] + __WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */][__WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */].Shade7]].color = Object(__WEBPACK_IMPORTED_MODULE_1__utilities_color_getColorFromString__["a" /* getColorFromString */])('#212121');
    slotRules[BaseSlots[BaseSlots.foregroundColor] + __WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */][__WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */].Shade8]].color = Object(__WEBPACK_IMPORTED_MODULE_1__utilities_color_getColorFromString__["a" /* getColorFromString */])('#000000');
    function _makeFabricSlotRule(slotName, inheritedBase, inheritedShade, isBackgroundShade) {
        if (isBackgroundShade === void 0) { isBackgroundShade = false; }
        var inherits = slotRules[BaseSlots[inheritedBase]];
        var thisSlotRule = {
            name: slotName,
            inherits: inherits,
            asShade: inheritedShade,
            isCustomized: false,
            isBackgroundShade: isBackgroundShade,
            dependentRules: []
        };
        slotRules[slotName] = thisSlotRule;
        inherits.dependentRules.push(thisSlotRule);
    }
    _makeFabricSlotRule(FabricSlots[FabricSlots.themePrimary], BaseSlots.primaryColor, __WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */].Unshaded);
    _makeFabricSlotRule(FabricSlots[FabricSlots.themeLighterAlt], BaseSlots.primaryColor, __WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */].Shade1);
    _makeFabricSlotRule(FabricSlots[FabricSlots.themeLighter], BaseSlots.primaryColor, __WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */].Shade2);
    _makeFabricSlotRule(FabricSlots[FabricSlots.themeLight], BaseSlots.primaryColor, __WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */].Shade3);
    _makeFabricSlotRule(FabricSlots[FabricSlots.themeTertiary], BaseSlots.primaryColor, __WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */].Shade4);
    _makeFabricSlotRule(FabricSlots[FabricSlots.themeSecondary], BaseSlots.primaryColor, __WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */].Shade5);
    _makeFabricSlotRule(FabricSlots[FabricSlots.themeDarkAlt], BaseSlots.primaryColor, __WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */].Shade6);
    _makeFabricSlotRule(FabricSlots[FabricSlots.themeDark], BaseSlots.primaryColor, __WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */].Shade7);
    _makeFabricSlotRule(FabricSlots[FabricSlots.themeDarker], BaseSlots.primaryColor, __WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */].Shade8);
    _makeFabricSlotRule(FabricSlots[FabricSlots.neutralLighterAlt], BaseSlots.backgroundColor, __WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */].Shade1, true);
    _makeFabricSlotRule(FabricSlots[FabricSlots.neutralLighter], BaseSlots.backgroundColor, __WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */].Shade2, true);
    _makeFabricSlotRule(FabricSlots[FabricSlots.neutralLight], BaseSlots.backgroundColor, __WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */].Shade3, true);
    _makeFabricSlotRule(FabricSlots[FabricSlots.neutralQuaternaryAlt], BaseSlots.backgroundColor, __WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */].Shade4, true);
    _makeFabricSlotRule(FabricSlots[FabricSlots.neutralQuaternary], BaseSlots.backgroundColor, __WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */].Shade5, true);
    _makeFabricSlotRule(FabricSlots[FabricSlots.neutralTertiaryAlt], BaseSlots.backgroundColor, __WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */].Shade6, true); // bg6 or fg2
    _makeFabricSlotRule(FabricSlots[FabricSlots.neutralTertiary], BaseSlots.foregroundColor, __WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */].Shade3);
    _makeFabricSlotRule(FabricSlots[FabricSlots.neutralSecondary], BaseSlots.foregroundColor, __WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */].Shade4);
    _makeFabricSlotRule(FabricSlots[FabricSlots.neutralPrimaryAlt], BaseSlots.foregroundColor, __WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */].Shade5);
    _makeFabricSlotRule(FabricSlots[FabricSlots.neutralPrimary], BaseSlots.foregroundColor, __WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */].Unshaded);
    _makeFabricSlotRule(FabricSlots[FabricSlots.neutralDark], BaseSlots.foregroundColor, __WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */].Shade7);
    _makeFabricSlotRule(FabricSlots[FabricSlots.black], BaseSlots.foregroundColor, __WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */].Shade8);
    _makeFabricSlotRule(FabricSlots[FabricSlots.white], BaseSlots.backgroundColor, __WEBPACK_IMPORTED_MODULE_0__utilities_color_shades__["a" /* Shade */].Unshaded, true);
    // manually set initial colors for the primary-based Fabric slots to match the default theme
    slotRules[FabricSlots[FabricSlots.themeLighterAlt]].color = Object(__WEBPACK_IMPORTED_MODULE_1__utilities_color_getColorFromString__["a" /* getColorFromString */])('#eff6fc');
    slotRules[FabricSlots[FabricSlots.themeLighter]].color = Object(__WEBPACK_IMPORTED_MODULE_1__utilities_color_getColorFromString__["a" /* getColorFromString */])('#deecf9');
    slotRules[FabricSlots[FabricSlots.themeLight]].color = Object(__WEBPACK_IMPORTED_MODULE_1__utilities_color_getColorFromString__["a" /* getColorFromString */])('#c7e0f4');
    slotRules[FabricSlots[FabricSlots.themeTertiary]].color = Object(__WEBPACK_IMPORTED_MODULE_1__utilities_color_getColorFromString__["a" /* getColorFromString */])('#71afe5');
    slotRules[FabricSlots[FabricSlots.themeSecondary]].color = Object(__WEBPACK_IMPORTED_MODULE_1__utilities_color_getColorFromString__["a" /* getColorFromString */])('#2b88d8');
    slotRules[FabricSlots[FabricSlots.themeDarkAlt]].color = Object(__WEBPACK_IMPORTED_MODULE_1__utilities_color_getColorFromString__["a" /* getColorFromString */])('#106ebe');
    slotRules[FabricSlots[FabricSlots.themeDark]].color = Object(__WEBPACK_IMPORTED_MODULE_1__utilities_color_getColorFromString__["a" /* getColorFromString */])('#005a9e');
    slotRules[FabricSlots[FabricSlots.themeDarker]].color = Object(__WEBPACK_IMPORTED_MODULE_1__utilities_color_getColorFromString__["a" /* getColorFromString */])('#004578');
    slotRules[FabricSlots[FabricSlots.themeLighterAlt]].isCustomized = true;
    slotRules[FabricSlots[FabricSlots.themeLighter]].isCustomized = true;
    slotRules[FabricSlots[FabricSlots.themeLight]].isCustomized = true;
    slotRules[FabricSlots[FabricSlots.themeTertiary]].isCustomized = true;
    slotRules[FabricSlots[FabricSlots.themeSecondary]].isCustomized = true;
    slotRules[FabricSlots[FabricSlots.themeDarkAlt]].isCustomized = true;
    slotRules[FabricSlots[FabricSlots.themeDark]].isCustomized = true;
    slotRules[FabricSlots[FabricSlots.themeDarker]].isCustomized = true;
    /*** SEMANTIC SLOTS */
    // This code is commented out for now but left for future semantic color customization.
    // create the SlotRule for a semantic slot
    // function _makeSemanticSlotRule(semanticSlot: SemanticColorSlots, inheritedFabricSlot: FabricSlots): void {
    //   const inherits = slotRules[FabricSlots[inheritedFabricSlot]];
    //   const thisSlotRule = {
    //     name: SemanticColorSlots[semanticSlot],
    //     inherits: slotRules[FabricSlots[inheritedFabricSlot]],
    //     isCustomized: false,
    //     dependentRules: []
    //   };
    //   slotRules[SemanticColorSlots[semanticSlot]] = thisSlotRule;
    //   inherits.dependentRules.push(thisSlotRule);
    // }
    // Basic simple slots
    // _makeSemanticSlotRule(SemanticColorSlots.bodyBackground, FabricSlots.white);
    // _makeSemanticSlotRule(SemanticColorSlots.bodyText, FabricSlots.neutralPrimary);
    return slotRules;
}
//# sourceMappingURL=ThemeRulesStandard.js.map

/***/ }),
/* 2076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__IncrementalAuctionPriceEdit__ = __webpack_require__(2077);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__IncrementalAuctionPriceEdit__["a"]; });


/***/ }),
/* 2077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_src_app_components_MoneyField__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Dropdown__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ToggleField__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__biddingStepsDefinitions__ = __webpack_require__(837);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2,_descriptor,_class3,_temp2;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}var IncrementalAuctionPriceEdit=(_dec=Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__["d" /* inject */])('app','sale'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__["e" /* observer */])(_class=(_class2=(_temp2=_class3=function(_Component){_inherits(IncrementalAuctionPriceEdit,_Component);function IncrementalAuctionPriceEdit(){var _ref;var _temp,_this,_ret;_classCallCheck(this,IncrementalAuctionPriceEdit);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=IncrementalAuctionPriceEdit.__proto__||Object.getPrototypeOf(IncrementalAuctionPriceEdit)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'minPriceChanged',_descriptor,_this),_this.handleFieldChanged=function(field){return function(value){var round=_this.props.store.round;round[field]=value;};},_this.handleMinPriceChange=function(value){var round=_this.props.store.round;round.minPrice=value;_this.minPriceChanged=true;},_this.handleStartPriceChange=function(value){var round=_this.props.store.round;round['startPrice']=value;var bid=_this.selectedStepValue(value,true);round['biddingSteps']=bid==='default'?null:'0=0;1='+bid;if(!_this.minPriceChanged){round.minPrice=value&&value>=100?value*0.8:null;}},_this.handleBidStepChanged=function(option){var round=_this.props.store.round;round['biddingSteps']=option.key==='default'?null:'0=0;1='+option.key;},_this.handleChoiceChanged=function(field){return function(_,opt){var round=_this.props.store.round;round[field]=opt.key;};},_this.handleToggleChanged=function(field){return function(_,value){var round=_this.props.store.round;round[field]=value;};},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(IncrementalAuctionPriceEdit,[{key:'componentDidMount',value:function componentDidMount(){var overrideStartPrice=this.props.overrideStartPrice;if(!overrideStartPrice)return;var step=this.biddingSteps(overrideStartPrice);var startPrice=overrideStartPrice+step.default;this.handleStartPriceChange(startPrice);}},{key:'render',value:function render(){var _props=this.props,app=_props.app,sale=_props.sale,store=_props.store,intl=_props.intl,t=_props.t,overrideStartPrice=_props.overrideStartPrice;var round=store.round;var step=this.biddingSteps(overrideStartPrice||round.startPrice);return __WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_src_app_components_MoneyField__["a" /* default */],{label:t('Starting price'),currency:app.currency.code,locale:intl.locale,value:round.startPrice,onChanged:this.handleStartPriceChange,tooltip:t('Starting price - tooltip'),autoComplete:'off',errorMessage:!store.startPriceError?undefined:t(store.startPriceError),required:true})),__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement('div',{style:{marginTop:'0.5em'}},__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_ToggleField__["a" /* default */],{label:t('Flexible bidding'),tooltip:t('Flexible bidding - tooltip'),onChange:this.handleToggleChanged('enableFlexibleBidding'),checked:round.enableFlexibleBidding,disabled:round.status==='opened'})),!!round.enableFlexibleBidding?__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_ToggleField__["a" /* default */],{label:__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:t('Hide highest bid / bid history for non-bidders')}}),tooltip:t('Hide highest bid / bid history for non-bidders - tooltip'),onChange:this.handleToggleChanged('hideBiddingInfoForNonBidders'),checked:round.hideBiddingInfoForNonBidders})),__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_ToggleField__["a" /* default */],{label:t(sale.saleConfig.roundAllowShowBidsBelowStartingPrice?'Allow bidding below starting price':'Allow bidding below starting price hidden'),tooltip:t('Allow bidding below starting price - tooltip'),onChange:this.handleToggleChanged('biddingBelowStartingPrice'),checked:round.biddingBelowStartingPrice}))):null,round.enableFlexibleBidding&&sale.saleConfig.roundAllowShowBidsBelowStartingPrice&&!!round.biddingBelowStartingPrice?__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_ToggleField__["a" /* default */],{label:t('Show bids below starting price'),tooltip:t('Show bids below starting price - tooltip'),onChange:this.handleToggleChanged('showBidsBelowStartingPrice'),checked:round.showBidsBelowStartingPrice})):null,!!round.biddingBelowStartingPrice?__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_src_app_components_MoneyField__["a" /* default */],{label:t('Min price'),currency:app.currency.code,locale:intl.locale,value:round.minPrice,onChanged:this.handleMinPriceChange,tooltip:t('Min price - tooltip'),autoComplete:'off',errorMessage:!store.minPriceError?undefined:t(store.minPriceError)})):null,sale.saleConfig.roundShowRedButtonPrice&&__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_src_app_components_MoneyField__["a" /* default */],{label:t('Red button price'),currency:app.currency.code,locale:intl.locale,value:round.redButtonPrice,onChanged:this.handleFieldChanged('redButtonPrice'),tooltip:t('Red button price - tooltip'),autoComplete:'off'})),sale.saleConfig.roundShowBidSteps&&__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Dropdown__["a" /* Dropdown */],{onChanged:this.handleBidStepChanged,label:__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react__["Fragment"],null,t('Bidding steps'),' ',__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react__["i" /* TooltipHost */],{content:t('Bidding steps - tooltip')},__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react__["f" /* Icon */],{iconName:'Info'}))),selectedKey:this.selectedStepValue(round.startPrice),options:[].concat(_toConsumableArray(sale.saleConfig.roundShowDefaultBidSteps?[{key:'default',text:t('Bidding steps - standard')}]:[]),_toConsumableArray(step.values.map(function(v){var str=v.toString();return{key:str,text:v.toFormattedMoney(intl.locale,app.currency.code,0)};})))})));}},{key:'biddingSteps',get:function get(){return function(startingPrice){var key=0;Object.keys(__WEBPACK_IMPORTED_MODULE_7__biddingStepsDefinitions__["a" /* biddingStepsDefinitions */]).forEach(function(b){if(b<=startingPrice){key=b;}if(b>startingPrice)return;});return __WEBPACK_IMPORTED_MODULE_7__biddingStepsDefinitions__["a" /* biddingStepsDefinitions */][key];};}},{key:'currentBidStep',get:function get(){var round=this.props.store.round;if(!round.biddingSteps){return undefined;}return round.biddingSteps.replace('0=0;1=','');}},{key:'selectedStepValue',get:function get(){var _this2=this;return function(startPrice,useStepDefaultValue){var step=_this2.biddingSteps(startPrice);var stepValue=_this2.currentBidStep;var result=stepValue&&step.values.some(function(v){return v.toString()===stepValue;})?stepValue:useStepDefaultValue?step.default.toString():'default';//step.default.toString();
return result;};}}]);return IncrementalAuctionPriceEdit;}(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react__["Component"]),_class3.displayName='IncrementalAuctionPriceEdit',_temp2),(_applyDecoratedDescriptor(_class2.prototype,'biddingSteps',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class2.prototype,'biddingSteps'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'currentBidStep',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class2.prototype,'currentBidStep'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'selectedStepValue',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class2.prototype,'selectedStepValue'),_class2.prototype),_descriptor=_applyDecoratedDescriptor(_class2.prototype,'minPriceChanged',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}})),_class2))||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (IncrementalAuctionPriceEdit);

/***/ }),
/* 2078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportMultiple; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getDataTransferItems;
/* harmony export (immutable) */ __webpack_exports__["b"] = fileAccepted;
/* harmony export (immutable) */ __webpack_exports__["c"] = fileMatchSize;
/* harmony export (immutable) */ __webpack_exports__["a"] = allFilesAccepted;
/* harmony export (immutable) */ __webpack_exports__["f"] = onDocumentDragOver;
/* harmony export (immutable) */ __webpack_exports__["e"] = isIeOrEdge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_attr_accept__ = __webpack_require__(2079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_attr_accept___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_attr_accept__);


var supportMultiple = typeof document !== 'undefined' && document && document.createElement ? 'multiple' in document.createElement('input') : true;

function getDataTransferItems(event) {
  var dataTransferItemsList = [];
  if (event.dataTransfer) {
    var dt = event.dataTransfer;

    if (dt.files && dt.files.length) {
      dataTransferItemsList = dt.files;
    } else if (dt.items && dt.items.length) {
      // During the drag even the dataTransfer.files is null
      // but Chrome implements some drag store, which is accesible via dataTransfer.items
      dataTransferItemsList = dt.items;
    }
  } else if (event.target && event.target.files) {
    dataTransferItemsList = event.target.files;
  }

  // Convert from DataTransferItemsList to the native Array
  return Array.prototype.slice.call(dataTransferItemsList);
}

// Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted
function fileAccepted(file, accept) {
  return file.type === 'application/x-moz-file' || __WEBPACK_IMPORTED_MODULE_0_attr_accept___default()(file, accept);
}

function fileMatchSize(file, maxSize, minSize) {
  return file.size <= maxSize && file.size >= minSize;
}

function allFilesAccepted(files, accept) {
  return files.every(function (file) {
    return fileAccepted(file, accept);
  });
}

// allow the entire document to be a drag target
function onDocumentDragOver(evt) {
  evt.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf('Edge/') !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;

  return isIe(userAgent) || isEdge(userAgent);
}

/***/ }),
/* 2079 */
/***/ (function(module, exports) {

module.exports=function(t){function n(e){if(r[e])return r[e].exports;var o=r[e]={i:e,l:!1,exports:{}};return t[e].call(o.exports,o,o.exports,n),o.l=!0,o.exports}var r={};return n.m=t,n.c=r,n.d=function(t,r,e){n.o(t,r)||Object.defineProperty(t,r,{configurable:!1,enumerable:!0,get:e})},n.n=function(t){var r=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(r,"a",r),r},n.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},n.p="",n(n.s=13)}([function(t,n){var r=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r)},function(t,n){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,n){var r=t.exports={version:"2.5.0"};"number"==typeof __e&&(__e=r)},function(t,n,r){t.exports=!r(4)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,n){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,n){var r={}.toString;t.exports=function(t){return r.call(t).slice(8,-1)}},function(t,n,r){var e=r(32)("wks"),o=r(9),i=r(0).Symbol,u="function"==typeof i;(t.exports=function(t){return e[t]||(e[t]=u&&i[t]||(u?i:o)("Symbol."+t))}).store=e},function(t,n,r){var e=r(0),o=r(2),i=r(8),u=r(22),c=r(10),f=function(t,n,r){var a,s,p,l,v=t&f.F,y=t&f.G,h=t&f.S,d=t&f.P,x=t&f.B,g=y?e:h?e[n]||(e[n]={}):(e[n]||{}).prototype,m=y?o:o[n]||(o[n]={}),b=m.prototype||(m.prototype={});y&&(r=n);for(a in r)s=!v&&g&&void 0!==g[a],p=(s?g:r)[a],l=x&&s?c(p,e):d&&"function"==typeof p?c(Function.call,p):p,g&&u(g,a,p,t&f.U),m[a]!=p&&i(m,a,l),d&&b[a]!=p&&(b[a]=p)};e.core=o,f.F=1,f.G=2,f.S=4,f.P=8,f.B=16,f.W=32,f.U=64,f.R=128,t.exports=f},function(t,n,r){var e=r(16),o=r(21);t.exports=r(3)?function(t,n,r){return e.f(t,n,o(1,r))}:function(t,n,r){return t[n]=r,t}},function(t,n){var r=0,e=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++r+e).toString(36))}},function(t,n,r){var e=r(24);t.exports=function(t,n,r){if(e(t),void 0===n)return t;switch(r){case 1:return function(r){return t.call(n,r)};case 2:return function(r,e){return t.call(n,r,e)};case 3:return function(r,e,o){return t.call(n,r,e,o)}}return function(){return t.apply(n,arguments)}}},function(t,n){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,n,r){var e=r(28),o=Math.min;t.exports=function(t){return t>0?o(e(t),9007199254740991):0}},function(t,n,r){"use strict";n.__esModule=!0,n.default=function(t,n){if(t&&n){var r=Array.isArray(n)?n:n.split(","),e=t.name||"",o=t.type||"",i=o.replace(/\/.*$/,"");return r.some(function(t){var n=t.trim();return"."===n.charAt(0)?e.toLowerCase().endsWith(n.toLowerCase()):n.endsWith("/*")?i===n.replace(/\/.*$/,""):o===n})}return!0},r(14),r(34)},function(t,n,r){r(15),t.exports=r(2).Array.some},function(t,n,r){"use strict";var e=r(7),o=r(25)(3);e(e.P+e.F*!r(33)([].some,!0),"Array",{some:function(t){return o(this,t,arguments[1])}})},function(t,n,r){var e=r(17),o=r(18),i=r(20),u=Object.defineProperty;n.f=r(3)?Object.defineProperty:function(t,n,r){if(e(t),n=i(n,!0),e(r),o)try{return u(t,n,r)}catch(t){}if("get"in r||"set"in r)throw TypeError("Accessors not supported!");return"value"in r&&(t[n]=r.value),t}},function(t,n,r){var e=r(1);t.exports=function(t){if(!e(t))throw TypeError(t+" is not an object!");return t}},function(t,n,r){t.exports=!r(3)&&!r(4)(function(){return 7!=Object.defineProperty(r(19)("div"),"a",{get:function(){return 7}}).a})},function(t,n,r){var e=r(1),o=r(0).document,i=e(o)&&e(o.createElement);t.exports=function(t){return i?o.createElement(t):{}}},function(t,n,r){var e=r(1);t.exports=function(t,n){if(!e(t))return t;var r,o;if(n&&"function"==typeof(r=t.toString)&&!e(o=r.call(t)))return o;if("function"==typeof(r=t.valueOf)&&!e(o=r.call(t)))return o;if(!n&&"function"==typeof(r=t.toString)&&!e(o=r.call(t)))return o;throw TypeError("Can't convert object to primitive value")}},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}}},function(t,n,r){var e=r(0),o=r(8),i=r(23),u=r(9)("src"),c=Function.toString,f=(""+c).split("toString");r(2).inspectSource=function(t){return c.call(t)},(t.exports=function(t,n,r,c){var a="function"==typeof r;a&&(i(r,"name")||o(r,"name",n)),t[n]!==r&&(a&&(i(r,u)||o(r,u,t[n]?""+t[n]:f.join(String(n)))),t===e?t[n]=r:c?t[n]?t[n]=r:o(t,n,r):(delete t[n],o(t,n,r)))})(Function.prototype,"toString",function(){return"function"==typeof this&&this[u]||c.call(this)})},function(t,n){var r={}.hasOwnProperty;t.exports=function(t,n){return r.call(t,n)}},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,n,r){var e=r(10),o=r(26),i=r(27),u=r(12),c=r(29);t.exports=function(t,n){var r=1==t,f=2==t,a=3==t,s=4==t,p=6==t,l=5==t||p,v=n||c;return function(n,c,y){for(var h,d,x=i(n),g=o(x),m=e(c,y,3),b=u(g.length),_=0,w=r?v(n,b):f?v(n,0):void 0;b>_;_++)if((l||_ in g)&&(h=g[_],d=m(h,_,x),t))if(r)w[_]=d;else if(d)switch(t){case 3:return!0;case 5:return h;case 6:return _;case 2:w.push(h)}else if(s)return!1;return p?-1:a||s?s:w}}},function(t,n,r){var e=r(5);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==e(t)?t.split(""):Object(t)}},function(t,n,r){var e=r(11);t.exports=function(t){return Object(e(t))}},function(t,n){var r=Math.ceil,e=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?e:r)(t)}},function(t,n,r){var e=r(30);t.exports=function(t,n){return new(e(t))(n)}},function(t,n,r){var e=r(1),o=r(31),i=r(6)("species");t.exports=function(t){var n;return o(t)&&(n=t.constructor,"function"!=typeof n||n!==Array&&!o(n.prototype)||(n=void 0),e(n)&&null===(n=n[i])&&(n=void 0)),void 0===n?Array:n}},function(t,n,r){var e=r(5);t.exports=Array.isArray||function(t){return"Array"==e(t)}},function(t,n,r){var e=r(0),o=e["__core-js_shared__"]||(e["__core-js_shared__"]={});t.exports=function(t){return o[t]||(o[t]={})}},function(t,n,r){"use strict";var e=r(4);t.exports=function(t,n){return!!t&&e(function(){n?t.call(null,function(){},1):t.call(null)})}},function(t,n,r){r(35),t.exports=r(2).String.endsWith},function(t,n,r){"use strict";var e=r(7),o=r(12),i=r(36),u="".endsWith;e(e.P+e.F*r(38)("endsWith"),"String",{endsWith:function(t){var n=i(this,t,"endsWith"),r=arguments.length>1?arguments[1]:void 0,e=o(n.length),c=void 0===r?e:Math.min(o(r),e),f=String(t);return u?u.call(n,f,c):n.slice(c-f.length,c)===f}})},function(t,n,r){var e=r(37),o=r(11);t.exports=function(t,n,r){if(e(n))throw TypeError("String#"+r+" doesn't accept regex!");return String(o(t))}},function(t,n,r){var e=r(1),o=r(5),i=r(6)("match");t.exports=function(t){var n;return e(t)&&(void 0!==(n=t[i])?!!n:"RegExp"==o(t))}},function(t,n,r){var e=r(6)("match");t.exports=function(t){var n=/./;try{"/./"[t](n)}catch(r){try{return n[e]=!1,!"/./"[t](n)}catch(t){}}return!0}}]);

/***/ }),
/* 2080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  rejected: {
    borderStyle: 'solid',
    borderColor: '#c66',
    backgroundColor: '#eee'
  },
  disabled: {
    opacity: 0.5
  },
  active: {
    borderStyle: 'solid',
    borderColor: '#6c6',
    backgroundColor: '#eee'
  },
  default: {
    width: 200,
    height: 200,
    borderWidth: 2,
    borderColor: '#666',
    borderStyle: 'dashed',
    borderRadius: 5
  }
});

/***/ }),
/* 2081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_office_ui_fabric_react_lib_Link__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DocPreview__ = __webpack_require__(2082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css__ = __webpack_require__(2083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_css__);
var Doc=function Doc(_ref){var i=_ref.i,d=_ref.d,t=_ref.t,handleEdit=_ref.handleEdit,handleDelete=_ref.handleDelete,handleMoveUp=_ref.handleMoveUp,handleMoveDown=_ref.handleMoveDown;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'doc'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'doc__image',style:{paddingRight:'5px'}},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DocPreview__["a" /* default */],{item:d})),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'doc__info'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_office_ui_fabric_react_lib_Link__["Link"],{onClick:handleEdit(d)},d.full||t('no type')),'\xA0',d.details&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',null,t('from'),' ',d.details.toFormatedDateString('L'))),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('p',{className:'doc__info__original ms-font-xs'},t('Original name',{originalFilename:d.originalFilename,uploadedAt:new Date(d.uploadedAt)}))),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'doc__actions'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_office_ui_fabric_react_lib_Link__["Link"],{onClick:handleMoveUp(d)},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('i',{className:'ms-Icon ms-Icon--Up','aria-hidden':'true'})),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_office_ui_fabric_react_lib_Link__["Link"],{onClick:handleMoveDown(d)},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('i',{className:'ms-Icon ms-Icon--Down','aria-hidden':'true'})),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_office_ui_fabric_react_lib_Link__["Link"],{onClick:handleEdit(d)},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('i',{className:'ms-Icon ms-Icon--Edit','aria-hidden':'true'})),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_office_ui_fabric_react_lib_Link__["Link"],{onClick:handleDelete(d)},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('i',{className:'ms-Icon ms-Icon--Delete','aria-hidden':'true'}))));};Doc.displayName='Doc';/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__components_Localization__["a" /* localizable */])(Doc));

/***/ }),
/* 2082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_office_ui_fabric_react_lib_Image__ = __webpack_require__(103);
var previewProperties={imageFit:__WEBPACK_IMPORTED_MODULE_1__build_node_modules_office_ui_fabric_react_lib_Image__["b" /* ImageFit */].contain,width:120,height:120};function generatePreviewUrl(_ref){var id=_ref.id;return'https://res.cloudinary.com/auctiontech/image/upload/c_pad,b_white,h_'+previewProperties.height+',w_'+previewProperties.width+'/'+id+'.jpg';}var DocPreview=function DocPreview(_ref2){var item=_ref2.item;var src=generatePreviewUrl(item);return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_office_ui_fabric_react_lib_Image__["a" /* Image */],Object.assign({src:src},previewProperties));};/* harmony default export */ __webpack_exports__["a"] = (DocPreview);

/***/ }),
/* 2083 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_office_ui_fabric_react_lib_Icon__ = __webpack_require__(12);
// const config = require(`../../../@${process.env.REACT_APP_TENANT}/config.js`)
//   .default;
var DocRequiredInfoList=function DocRequiredInfoList(_ref){var requiredDocumentTypes=_ref.requiredDocumentTypes,uploadedDocumentTypes=_ref.uploadedDocumentTypes,t=_ref.t;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('ul',{style:{listStyleType:'none',paddingLeft:0}},requiredDocumentTypes.map(function(documentType){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',{key:documentType},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_office_ui_fabric_react_lib_Icon__["Icon"],{iconName:uploadedDocumentTypes.includes(documentType)?'CheckboxComposite':'Checkbox'}),' ',t('documenttype::'+documentType));}));};var DocRequiredInfo=function DocRequiredInfo(_ref2){var sale=_ref2.sale,offerData=_ref2.offerData,docs=_ref2.docs,t=_ref2.t,config=_ref2.config;var requiredDocumentTypes=config.getRequiredDocumentTypes(sale,offerData);var uploadedDocumentTypes=docs.map(function(doc){return doc.type;});return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,Array.isArray(requiredDocumentTypes)&&requiredDocumentTypes.length>0&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',null,t('Upload following documents'),':'),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(DocRequiredInfoList,{requiredDocumentTypes:requiredDocumentTypes,uploadedDocumentTypes:uploadedDocumentTypes,t:t})),!Array.isArray(requiredDocumentTypes)&&Object.keys(requiredDocumentTypes).length>0&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{style:{marginBottom:'10px'}},t('Upload following documents'),':'),Object.keys(requiredDocumentTypes).map(function(key){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],{key:key},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('strong',null,t('section__'+key))),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(DocRequiredInfoList,{requiredDocumentTypes:requiredDocumentTypes[key],uploadedDocumentTypes:uploadedDocumentTypes,t:t}));})));};/* harmony default export */ __webpack_exports__["a"] = (DocRequiredInfo);

/***/ }),
/* 2085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_src_app_components_NumericTextField__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_ChoiceGroup__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_src_app_components_DatePicker__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_Dialog__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__build_node_modules_office_ui_fabric_react_lib_Dropdown__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__build_node_modules_office_ui_fabric_react__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Calendar__ = __webpack_require__(2086);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2,_descriptor,_descriptor2,_class3,_temp2;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var RoundDurationEditDefault=(_dec=Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__["d" /* inject */])('app','sale'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__["e" /* observer */])(_class=(_class2=(_temp2=_class3=function(_Component){_inherits(RoundDurationEditDefault,_Component);function RoundDurationEditDefault(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RoundDurationEditDefault);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RoundDurationEditDefault.__proto__||Object.getPrototypeOf(RoundDurationEditDefault)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'changedFields',_descriptor,_this),_initDefineProp(_this,'sendNotification',_descriptor2,_this),_this.handleSelectNow=function(field){return function(value){if(!value)return;var round=_this.props.store.round;round[field]=value;_this.changedFields[field]=true;_this.ensureRoundEnd(field,value);};},_this.handleFieldChanged=function(field){return function(value){var round=_this.props.store.round;var h=12;var m=0;if(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default()(round[field]).isValid()){h=__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default()(round[field]).hours();m=__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default()(round[field]).minutes();}if(value instanceof Date)value=__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default()(value).hour(h).minute(m).toDate();round[field]=value;_this.changedFields[field]=true;_this.ensureRoundEnd(field,value);};},_this.handleDurationTypeChanged=function(_,opt){var round=_this.props.store.round;round.durationType=opt.key;},_this.handleTimeChange=function(field){return function(value){var round=_this.props.store.round;var duration=value.key;var h=__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default.a.duration(duration,'minutes').hours();var m=__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default.a.duration(duration,'minutes').minutes();round[field]=__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default()(round[field]).hour(h).minute(m).toDate();_this.ensureRoundEnd(field,value);};},_this.ensureRoundEnd=function(field,value){var _this$props=_this.props,round=_this$props.store.round,sale=_this$props.sale;var config=sale.saleConfig;if(field!=='endsAt')return;if(!_this.changedFields['offerValidityUntil'])round.offerValidityUntil=__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default()(round.endsAt).add(config.roundDefaultOfferValidityExtensionInDays,'d').toDate();var oldValue=__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default()(round.endsAt).toDate();_this.sendNotification=round.status==='opened'&&!__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default()(oldValue).isSame(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default()(_this.endsAt));},_this.renderWarning=function(){var t=_this.props.t;var close=function close(){return _this.openRoundWarning=false;};return __WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_Dialog__["a" /* Dialog */],{hidden:false,onDismiss:close,dialogContentProps:{type:__WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_Dialog__["c" /* DialogType */].close},modalProps:{titleAriaId:'myLabelId',subtitleAriaId:'mySubTextId',isBlocking:true,containerClassName:'ms-dialogMainOverride'}},t('open round warning'),__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_Dialog__["b" /* DialogFooter */],null,__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Button__["h" /* PrimaryButton */],{onClick:close,text:t('Ok')})));},_this.renderFlexibleDurationTypeForm=function(){var _this$props2=_this.props,round=_this$props2.store.round,t=_this$props2.t,hideValidity=_this$props2.hideValidity;var isSimpleOffer=round.type==='simple_offer';return __WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('div',null,isSimpleOffer?null:__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_src_app_components_NumericTextField__["a" /* default */],{label:t('Duration'),suffix:t('Days'),value:round.durationInDays,locale:_this.props.intl.locale,onChanged:_this.handleFieldChanged('durationInDays'),required:true,defaultValue:0,autoComplete:'off'})),!hideValidity&&__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_src_app_components_NumericTextField__["a" /* default */],{label:isSimpleOffer?t('duration'):t('offer validity'),suffix:t('Days'),value:round.offerValidityInDays||0,locale:_this.props.intl.locale,onChanged:_this.handleFieldChanged('offerValidityInDays'),required:true,defaultValue:0,autoComplete:'off'})),isSimpleOffer&&__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12'},__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__build_node_modules_office_ui_fabric_react__["g" /* MessageBar */],null,t('Simple offer duration suggestion notice'))))));},_this.renderFixedDurationTypeForm=function(){var _this$props3=_this.props,round=_this$props3.store.round,sale=_this$props3.sale,t=_this$props3.t,hideValidity=_this$props3.hideValidity;var momentData=__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default.a.localeData();var timezone=sale.saleEdit.offerData.timezone;var probeDate=round.endsAt||round.startsAt||round.offerValidityUntil||new Date();var isInTimezone=!timezone||__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default()(probeDate).format('Z')===__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default()(probeDate).tz(timezone).format('Z');var timeZoneSuffix=!isInTimezone?' ('+__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default.a.tz(timezone).format('z')+')':'';var isSimpleOffer=round.type==='simple_offer';return __WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid',style:{padding:0}},isSimpleOffer?null:__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm8'},__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_src_app_components_DatePicker__["a" /* default */],{calendarAs:__WEBPACK_IMPORTED_MODULE_11__Calendar__["a" /* default */],calendarProps:{t:t,onClickNow:_this.handleSelectNow('startsAt'),timezone:timezone},label:t('Start'),tooltip:t('Start - tooltip'),isRequired:false,value:round.startsAt,onSelectDate:_this.handleFieldChanged('startsAt'),allowTextInput:true// maxDate={round.endsAt}
,strings:{months:momentData._months,shortMonths:momentData._monthsShort,days:momentData._weekdays,shortDays:momentData._weekdaysMin,goToToday:t('Start Now')},showGoToToday:false})),__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm4'},__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement(TimeSelect,{value:duration(round.startsAt),onChanged:_this.handleTimeChange('startsAt'),label:''+t('Time of day')+timeZoneSuffix,momentData:momentData}))),__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm8'},__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_src_app_components_DatePicker__["a" /* default */],{label:t('Ends at'),tooltip:t('Ends at - tooltip'),isRequired:true,firstDayOfWeek:momentData.firstDayOfWeek(),value:round.endsAt,formatDate:_this.renderFormattedDate,onSelectDate:_this.handleFieldChanged('endsAt'),minDate:round.startsAt// maxDate={
//   this.changedFields['offerValidityUntil']
//     ? round.offerValidityUntil
//     : null
// }
,strings:{months:momentData._months,shortMonths:momentData._monthsShort,days:momentData._weekdays,shortDays:momentData._weekdaysMin},showGoToToday:false})),__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm4'},__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement(TimeSelect,{value:duration(round.endsAt),onChanged:_this.handleTimeChange('endsAt'),label:''+t('Time of day')+timeZoneSuffix,momentData:momentData}))),(round.type==='open_bidding'||round.type==='incremental_auction')&&__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12'},__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__build_node_modules_office_ui_fabric_react__["g" /* MessageBar */],null,t('Antisniping notice'))))),_this.sendNotification&&__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12',style:{paddingTop:'10px',paddingBottom:'10px'}},__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('span',{style:{color:'#a80000'}},t('End date changed')))),!hideValidity&&__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm8'},__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_src_app_components_DatePicker__["a" /* default */],Object.assign({label:isSimpleOffer?t('date'):t('offer validity'),isRequired:true,firstDayOfWeek:momentData.firstDayOfWeek()},!!round.offerValidityUntil?{value:round.offerValidityUntil}:{},{formatDate:_this.renderFormattedDate,onSelectDate:_this.handleFieldChanged('offerValidityUntil'),minDate:round.endsAt,strings:{months:momentData._months,shortMonths:momentData._monthsShort,days:momentData._weekdays,shortDays:momentData._weekdaysMin},showGoToToday:false}))),__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm4'},__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement(TimeSelect,{value:duration(round.offerValidityUntil),onChanged:_this.handleTimeChange('offerValidityUntil'),label:''+t('Time of day')+timeZoneSuffix,momentData:momentData}))),isSimpleOffer&&__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12'},__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__build_node_modules_office_ui_fabric_react__["g" /* MessageBar */],null,t('Simple offer duration suggestion notice'))))));},_this.renderFormattedDate=function(date){return date.toString().toFormatedDateString();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RoundDurationEditDefault,[{key:'render',value:function render(){var _props=this.props,round=_props.store.round,t=_props.t,canChangeDurationType=_props.canChangeDurationType,sale=_props.sale;var isSimpleOffer=round.type==='simple_offer';var config=sale.saleConfig;var durationTypes=function durationTypes(t){return config.durationTypes.map(function(key){return{key:key,text:t('durationtype::'+key)};});};return __WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react__["Fragment"],null,this.openRoundWarning&&this.renderWarning(),canChangeDurationType&&__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_ChoiceGroup__["a" /* ChoiceGroup */],{defaultSelectedKey:round.durationType,options:durationTypes(t),onChange:this.handleDurationTypeChanged// label={t('Duration type')}
,label:isSimpleOffer?t('Offer validity'):t('Duration type')})),round.durationType==='flexible'?this.renderFlexibleDurationTypeForm():this.renderFixedDurationTypeForm());}}]);return RoundDurationEditDefault;}(__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react__["Component"]),_class3.displayName='RoundDurationEditDefault',_temp2),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'changedFields',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,'sendNotification',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}})),_class2))||_class)||_class);var duration=function duration(date){return __WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default.a.duration(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default()(date).format('HH:mm')).asMinutes();};var timeOptions=function timeOptions(momentData){var format=momentData.longDateFormat('LT');return[].concat(_toConsumableArray(Array(24*4).keys())).map(function(v){return{key:v*15,text:__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default()('2020-01-01').add(v*15,'minutes').format(format)};});};var TimeSelect=function TimeSelect(_ref2){var label=_ref2.label,onChanged=_ref2.onChanged,value=_ref2.value,momentData=_ref2.momentData;return __WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__build_node_modules_office_ui_fabric_react_lib_Dropdown__["a" /* Dropdown */],{label:label,ariaLabel:label,selectedKey:value,options:timeOptions(momentData),isRequired:true,onChanged:onChanged});};/* harmony default export */ __webpack_exports__["a"] = (RoundDurationEditDefault);

/***/ }),
/* 2086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CustomCalendar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_moment_timezone__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Calendar__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles={actionBar:['ms-actionBar',{selectors:{'.ms-Button':{marginTop:'-5px',marginLeft:'10px',marginBottom:'10px'}}}]};var getClassNames=Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react__["j" /* classNamesFunction */])();var classNames=getClassNames(styles,{});var CustomCalendar=Object(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx_react__["e" /* observer */])(_class=(_temp2=_class2=function(_Component){_inherits(CustomCalendar,_Component);function CustomCalendar(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CustomCalendar);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CustomCalendar.__proto__||Object.getPrototypeOf(CustomCalendar)).call.apply(_ref,[this].concat(args))),_this),_this.handleNow=function(){var _this$props=_this.props,onClickNow=_this$props.onClickNow,onDismiss=_this$props.onDismiss,timezone=_this$props.timezone;if(onClickNow){var now=!timezone?__WEBPACK_IMPORTED_MODULE_1__build_node_modules_moment_timezone__():__WEBPACK_IMPORTED_MODULE_1__build_node_modules_moment_timezone__["utc"]().tz(timezone);var hour=now.hour();var minute=Math.floor(now.minute()/15)*15;var value=now.hour(hour).minute(minute).second(0);onClickNow(new Date(value.format("YYYY-MM-DD HH:mm:ss")));}if(onDismiss)onDismiss();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CustomCalendar,[{key:'render',value:function render(){var t=this.props.t;return __WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Calendar__["a" /* Calendar */],this.props),__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement('div',{className:Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react__["k" /* css */])(classNames.actionBar)},__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react__["a" /* ActionButton */],{iconProps:{iconName:'Running'},onClick:this.handleNow},t('Now'))));}}]);return CustomCalendar;}(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react__["Component"]),_class2.displayName='CustomCalendar',_temp2))||_class;

/***/ }),
/* 2087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_src_app_components_dynamicImport__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RoundPriceEditDefault__ = __webpack_require__(1012);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RoundPriceEditContent=Object(__WEBPACK_IMPORTED_MODULE_0__build_src_app_components_dynamicImport__["b" /* default */])({component:'/containers/Sale/RoundSection/RoundPriceEdit',fallback:__WEBPACK_IMPORTED_MODULE_3__RoundPriceEditDefault__["a" /* default */]});var RoundPriceEdit=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["e" /* observer */])(_class=(_temp=_class2=function(_Component){_inherits(RoundPriceEdit,_Component);function RoundPriceEdit(){_classCallCheck(this,RoundPriceEdit);return _possibleConstructorReturn(this,(RoundPriceEdit.__proto__||Object.getPrototypeOf(RoundPriceEdit)).apply(this,arguments));}_createClass(RoundPriceEdit,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_2__build_node_modules_react___default.a.createElement(RoundPriceEditContent,this.props);}}]);return RoundPriceEdit;}(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_react__["Component"]),_class2.displayName='RoundPriceEdit',_temp))||_class;/* harmony default export */ __webpack_exports__["a"] = (RoundPriceEdit);

/***/ }),
/* 2088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RoundTypeSelector__ = __webpack_require__(2089);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__RoundTypeSelector__["a"]; });


/***/ }),
/* 2089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RoundTypeSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DropDownField__ = __webpack_require__(2090);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RoundTypeSelector=Object(__WEBPACK_IMPORTED_MODULE_0__build_src_app_components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["e" /* observer */])(_class=(_temp2=_class2=function(_Component){_inherits(RoundTypeSelector,_Component);function RoundTypeSelector(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RoundTypeSelector);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RoundTypeSelector.__proto__||Object.getPrototypeOf(RoundTypeSelector)).call.apply(_ref,[this].concat(args))),_this),_this.handleSelect=function(type){var onSelect=_this.props.onSelect;if(onSelect)onSelect(type.key);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RoundTypeSelector,[{key:'render',value:function render(){var _props=this.props,rounds=_props.rounds,disabled=_props.disabled,t=_props.t;var selected=rounds.find(function(r){return r.selected;});var tooltip=t('bidding type tooltip');return __WEBPACK_IMPORTED_MODULE_2__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_2__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_DropDownField__["a" /* default */],{placeholder:t('Select a bidding type'),label:t('Bidding type'),ariaLabel:t('Bidding type'),selectedKey:!!selected?selected.type:undefined,options:rounds.map(function(r){return{key:r.type,text:t('roundtype::'+r.type)};}),onChanged:this.handleSelect,disabled:disabled,tooltip:tooltip!=='bidding type tooltip'?tooltip:null}));}}]);return RoundTypeSelector;}(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_react__["Component"]),_class2.displayName='RoundTypeSelector',_temp2))||_class)||_class;

/***/ }),
/* 2090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DropDownField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_Icon__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Tooltip__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Utilities__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Dropdown__ = __webpack_require__(56);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DropDownField=(_temp2=_class=function(_Component){_inherits(DropDownField,_Component);function DropDownField(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DropDownField);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DropDownField.__proto__||Object.getPrototypeOf(DropDownField)).call.apply(_ref,[this].concat(args))),_this),_this.hostId=Object(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Utilities__["N" /* getId */])('tooltipHost'),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DropDownField,[{key:'componentWillMount',value:function componentWillMount(){this.id=__WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash___default.a.uniqueId('DropDownField');}},{key:'render',value:function render(){var _props=this.props,label=_props.label,tooltip=_props.tooltip,required=_props.required;var forwardedProps=Object.assign({},this.props);delete forwardedProps.label;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('label',{className:'ms-Label',required:required||false,htmlFor:this.id,style:{paddingTop:'5px',paddingBottom:'5px',display:'inline-block'}},label),tooltip&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{// there's a "padding-right: 12px" after the red asterix
style:required?{marginLeft:'-5px',display:'inline-block'}:{marginLeft:'5px',display:'inline-block'}},' ',__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Tooltip__["b" /* TooltipHost */],{content:tooltip,id:this.hostId,calloutProps:{gapSpace:0}},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_Icon__["Icon"],{iconName:'Info'}))),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Dropdown__["a" /* Dropdown */],forwardedProps));}}]);return DropDownField;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class.displayName='DropDownField',_temp2);

/***/ }),
/* 2091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_office_ui_fabric_react_lib_TextField__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Localization__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var IncreaseStep3=Object(__WEBPACK_IMPORTED_MODULE_2__components_Localization__["a" /* localizable */])(_class=(_temp=_class2=function(_Component){_inherits(IncreaseStep3,_Component);function IncreaseStep3(){_classCallCheck(this,IncreaseStep3);return _possibleConstructorReturn(this,(IncreaseStep3.__proto__||Object.getPrototypeOf(IncreaseStep3)).apply(this,arguments));}_createClass(IncreaseStep3,[{key:'render',value:function render(){var _props=this.props,_props$store=_props.store,buyerMessage=_props$store.buyerMessage,handleBuyerMessageChange=_props$store.handleBuyerMessageChange,t=_props.t;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('ul',{className:'hint'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',null,t('This text will appear as an additional note'))),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_office_ui_fabric_react_lib_TextField__["a" /* TextField */],{label:t('Message'),multiline:true,name:'ag',value:buyerMessage,onChanged:handleBuyerMessageChange})));}}]);return IncreaseStep3;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class2.displayName='IncreaseStep3',_temp))||_class;/* harmony default export */ __webpack_exports__["a"] = (IncreaseStep3);

/***/ }),
/* 2092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_RoundInfo__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_BaseStep__ = __webpack_require__(68);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var IncreaseSummary=Object(__WEBPACK_IMPORTED_MODULE_1__components_Localization__["a" /* localizable */])(_class=(_temp=_class2=function(_BaseStep){_inherits(IncreaseSummary,_BaseStep);function IncreaseSummary(){_classCallCheck(this,IncreaseSummary);return _possibleConstructorReturn(this,(IncreaseSummary.__proto__||Object.getPrototypeOf(IncreaseSummary)).apply(this,arguments));}_createClass(IncreaseSummary,[{key:'render',value:function render(){var _this2=this;var _props=this.props,_props$store=_props.store,acceptedOfferDetails=_props$store.acceptedOfferDetails,rejectedOfferDetails=_props$store.rejectedOfferDetails,buyerMessage=_props$store.buyerMessage,roundEditStore=_props$store.roundEditStore,t=_props.t;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('h2',null,t('Summary')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('h3',null,t('Customers for the next round')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('ol',null,acceptedOfferDetails&&acceptedOfferDetails.map(function(i){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',{key:i.buyerId},_this2.renderBuyerName(i.item));})),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('h3',null,t('Customers not participating in the next round')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('ol',null,rejectedOfferDetails&&rejectedOfferDetails.map(function(i){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',{key:i.buyerId},_this2.renderBuyerName(i.item));})),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('h3',null,t('Additional information text')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('p',null,buyerMessage||__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('i',null,t('not entered'))),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('h3',null,t('Round details')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_RoundInfo__["a" /* default */],{round:roundEditStore.round}),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('p',null,t('Click "Finish" to start a new round'),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('br',null),t('This action cannot be undone.')));}}]);return IncreaseSummary;}(__WEBPACK_IMPORTED_MODULE_3__components_BaseStep__["a" /* default */]),_class2.displayName='IncreaseSummary',_temp))||_class;/* harmony default export */ __webpack_exports__["a"] = (IncreaseSummary);

/***/ }),
/* 2093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Step1__ = __webpack_require__(2094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Step2__ = __webpack_require__(2095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Step3__ = __webpack_require__(2096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Step4__ = __webpack_require__(2097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Summary__ = __webpack_require__(2098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_request__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var Store=(_class=function(){_createClass(Store,[{key:'getSteps',value:function getSteps(){var _this=this;return this.steps.filter(function(step){return step.key!=='reject'||_this.eligibleOffersForWinner.length>1;}).filter(function(step){return step.key!=='reject-message'||_this.eligibleOffersForWinner.length>1;});}},{key:'selectedBuyer',get:function get(){var _this2=this;if(!this.offers)return[];return this.offers.filter(function(o){return o.buyerId===_this2.selectedBuyerId;})[0]||{};}},{key:'eligibleOffersForWinner',get:function get(){if(!this.offers)return[];return this.offers.filter(function(item){return item.status==='confirmed'||item.status==='accepted'||item.status==='awarded';}).sort(function(a,b){return b.submittedValue-a.submittedValue;});}},{key:'eligibleOffersToReject',get:function get(){var _this3=this;if(!this.offers)return[];return this.offers.filter(function(item){return item.buyerId!==_this3.selectedBuyerId&&(item.status==='confirmed'||item.status==='accepted'||item.status==='awarded');}).sort(function(a,b){return b.submittedValue-a.submittedValue;});}},{key:'rejectedOfferDetails',get:function get(){var lookup=this.offers.reduce(function(acc,i){acc[i.buyerId]=i;return acc;},{});return this.rejectedOffers.map(function(o){return lookup[o];});}}]);function Store(management){var _this4=this;_classCallCheck(this,Store);this.steps=[{key:'winner',title:'Choose a winner',implementation:__WEBPACK_IMPORTED_MODULE_2__Step1__["a" /* default */]},{key:'message',title:'Message to winner',implementation:__WEBPACK_IMPORTED_MODULE_4__Step3__["a" /* default */]},{key:'reject',title:'Choose offers to reject',implementation:__WEBPACK_IMPORTED_MODULE_3__Step2__["a" /* default */]},{key:'reject-message',title:'Message to rejected',implementation:__WEBPACK_IMPORTED_MODULE_5__Step4__["a" /* default */]}];_initDefineProp(this,'offers',_descriptor,this);_initDefineProp(this,'rejectedOffers',_descriptor2,this);_initDefineProp(this,'selectedBuyerId',_descriptor3,this);_initDefineProp(this,'message',_descriptor4,this);_initDefineProp(this,'rejectMessage',_descriptor5,this);this.summaryClass=__WEBPACK_IMPORTED_MODULE_6__Summary__["a" /* default */];this.handleMessageChange=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */])(function(value){_this4.message=value;});this.handleRejectMessageChange=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */])(function(value){_this4.rejectMessage=value;});this.offers=management.source.offers.viewModel.offers.map(function(item){return{item:item,buyerId:item.buyerId,name:item.buyer.buyer_lastName+', '+item.buyer.buyer_firstName,submittedValue:item.submittedValue,validity:item.data.offer_validity,status:item.status};});}_createClass(Store,[{key:'submit',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(saleId,token){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_7__services_request__["e" /* post */])('/api/v1/wizard/'+saleId+'/award',{rejectOffers:this.rejectedOffers,buyerId:this.selectedBuyerId,message:this.message,rejectMessage:this.rejectMessage},token);case 2:case'end':return _context.stop();}}},_callee,this);}));function submit(_x,_x2){return _ref.apply(this,arguments);}return submit;}()}]);return Store;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'offers',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:null}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'rejectedOffers',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'selectedBuyerId',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:null}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'message',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'rejectMessage',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return'';}}),_applyDecoratedDescriptor(_class.prototype,'selectedBuyer',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'selectedBuyer'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'eligibleOffersForWinner',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'eligibleOffersForWinner'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'eligibleOffersToReject',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'eligibleOffersToReject'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'rejectedOfferDetails',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'rejectedOfferDetails'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'submit',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'submit'),_class.prototype)),_class);

/***/ }),
/* 2094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_DetailsList__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_src_app_components_Money__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_BaseStep__ = __webpack_require__(68);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var columns=function columns(t){return[{key:'name',name:t('Customer name'),fieldName:'name',minWidth:150,maxWidth:400,isSorted:true,isSortedDescending:false},{key:'submittedValue',name:t('Submitted value'),fieldName:'submittedValue',minWidth:100,maxWidth:150,isSorted:false,isSortedDescending:false},{key:'validity',name:t('Expiration date'),fieldName:'validity',minWidth:100,maxWidth:150,isSorted:false,isSortedDescending:false}];};var AwardStep1=(_dec=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["d" /* inject */])('app'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_3__build_src_app_components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["e" /* observer */])(_class=(_temp=_class2=function(_BaseStep){_inherits(AwardStep1,_BaseStep);function AwardStep1(props){_classCallCheck(this,AwardStep1);var _this=_possibleConstructorReturn(this,(AwardStep1.__proto__||Object.getPrototypeOf(AwardStep1)).call(this,props));_this.handleRenderItemColumn=function(item,_,column){var t=_this.props.t;var content=item[column.fieldName];switch(column.key){case'name':return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',null,_this.renderBuyerName(item.item));case'validity':return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,content?content.toFormatedDateString():'');case'submittedValue':return content<0?__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',null,t('hidden')):__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_src_app_components_Money__["a" /* default */],{value:content,currency:_this.props.app.currency.code,locale:_this.props.intl.locale});default:return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',null,content);}};_this.handleSelectionChanged=function(){var store=_this.props.store;var selected=_this.selection.getSelection()[0];if(!!selected){store.selectedBuyerId=selected.buyerId;}};_this.selection=new __WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_DetailsList__["d" /* Selection */]({onSelectionChanged:_this.handleSelectionChanged});_this.selection.setModal(true);return _this;}_createClass(AwardStep1,[{key:'render',value:function render(){var _props=this.props,store=_props.store,t=_props.t;var eligibleOffersForWinner=store.eligibleOffersForWinner;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('ul',{className:'hint'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',null,t('Choose a winner'))),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_DetailsList__["b" /* DetailsList */],{columns:columns(t),items:eligibleOffersForWinner||[],selection:this.selection,onRenderItemColumn:this.handleRenderItemColumn,enterModalSelectionOnTouch:true,selectionPreservedOnEmptyClick:true,compact:true,layoutMode:__WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_DetailsList__["c" /* DetailsListLayoutMode */].justified,selectionMode:__WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_DetailsList__["e" /* SelectionMode */].single})));}}]);return AwardStep1;}(__WEBPACK_IMPORTED_MODULE_5__components_BaseStep__["a" /* default */]),_class2.displayName='AwardStep1',_temp))||_class)||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (AwardStep1);

/***/ }),
/* 2095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_DetailsList__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_src_app_components_Money__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_BaseStep__ = __webpack_require__(68);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var columns=function columns(t){return[{key:'name',name:t('Name'),fieldName:'name',minWidth:150,maxWidth:400,isSorted:true,isSortedDescending:false},{key:'submittedValue',name:t('Submitted value'),fieldName:'submittedValue',minWidth:100,maxWidth:150,isSorted:false,isSortedDescending:false},{key:'validity',name:t('Expiration date'),fieldName:'validity',minWidth:100,maxWidth:150,isSorted:false,isSortedDescending:false}];};var AwardStep2=(_dec=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["d" /* inject */])('app'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_4__build_src_app_components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["e" /* observer */])(_class=(_temp=_class2=function(_BaseStep){_inherits(AwardStep2,_BaseStep);function AwardStep2(props){_classCallCheck(this,AwardStep2);var _this=_possibleConstructorReturn(this,(AwardStep2.__proto__||Object.getPrototypeOf(AwardStep2)).call(this,props));_this.handleRenderItemColumn=function(item,_,column){var t=_this.props.t;var content=item[column.fieldName];switch(column.key){case'name':return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',null,_this.renderBuyerName(item.item));case'validity':return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,content?content.toFormatedDateString():'');case'submittedValue':return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_src_app_components_Money__["a" /* default */],{value:content,defaultValue:content==='hidden'?t(content):content,currency:_this.props.app.currency.code,locale:_this.props.intl.locale});default:return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',null,content);}};_this.handleSelectionChanged=function(){var store=_this.props.store;store.rejectedOffers=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.flatten(_this.selection.getSelection()).map(function(i){return i.buyerId;});};_this.selection=new __WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_DetailsList__["d" /* Selection */]({onSelectionChanged:_this.handleSelectionChanged});_this.selection.setModal(true);return _this;}_createClass(AwardStep2,[{key:'render',value:function render(){var _props=this.props,store=_props.store,t=_props.t;var eligibleOffersToReject=store.eligibleOffersToReject;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('ul',{className:'hint'},t('Select customers to reject theirs offer').split('\n').map(function(fragment,i){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',{key:i},fragment);})),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_DetailsList__["b" /* DetailsList */],{columns:columns(t),items:eligibleOffersToReject||[],selection:this.selection,onRenderItemColumn:this.handleRenderItemColumn,enterModalSelectionOnTouch:true,selectionPreservedOnEmptyClick:true,compact:true,layoutMode:__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_DetailsList__["c" /* DetailsListLayoutMode */].justified,selectionMode:__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_DetailsList__["e" /* SelectionMode */].multiple})));}}]);return AwardStep2;}(__WEBPACK_IMPORTED_MODULE_6__components_BaseStep__["a" /* default */]),_class2.displayName='AwardStep2',_temp))||_class)||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (AwardStep2);

/***/ }),
/* 2096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_office_ui_fabric_react_lib_TextField__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Localization__ = __webpack_require__(8);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__components_Localization__["a" /* localizable */])('AwardStep2')(function(_ref){var t=_ref.t,_ref$store=_ref.store,message=_ref$store.message,handleMessageChange=_ref$store.handleMessageChange;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('ul',{className:'hint'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',null,t('This text will appear as an additional note'))),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_office_ui_fabric_react_lib_TextField__["a" /* TextField */],{label:t('Message'),multiline:true,name:'ag',value:message,onChanged:handleMessageChange})));}));

/***/ }),
/* 2097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_office_ui_fabric_react_lib_TextField__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Localization__ = __webpack_require__(8);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__components_Localization__["a" /* localizable */])('AwardStep4')(function(_ref){var t=_ref.t,_ref$store=_ref.store,rejectMessage=_ref$store.rejectMessage,handleRejectMessageChange=_ref$store.handleRejectMessageChange;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('ul',{className:'hint'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',null,t('This text will appear as an additional note'))),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_office_ui_fabric_react_lib_TextField__["a" /* TextField */],{label:t('Reject message'),multiline:true,name:'ag',value:rejectMessage,onChanged:handleRejectMessageChange})));}));

/***/ }),
/* 2098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_src_app_components_Money__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_BaseStep__ = __webpack_require__(68);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AwardSummary=(_dec=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["d" /* inject */])('app'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_3__build_src_app_components_Localization__["a" /* localizable */])(_class=(_temp=_class2=function(_BaseStep){_inherits(AwardSummary,_BaseStep);function AwardSummary(){_classCallCheck(this,AwardSummary);return _possibleConstructorReturn(this,(AwardSummary.__proto__||Object.getPrototypeOf(AwardSummary)).apply(this,arguments));}_createClass(AwardSummary,[{key:'render',value:function render(){var _this2=this;var _props=this.props,_props$store=_props.store,message=_props$store.message,rejectMessage=_props$store.rejectMessage,selectedBuyer=_props$store.selectedBuyer,rejectedOfferDetails=_props$store.rejectedOfferDetails,t=_props.t;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('h2',null,t('Summary')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('h2',null,t('Selected winner')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',null,this.renderBuyerName(selectedBuyer.item)),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',null,t('Offer'),':',' ',__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__build_src_app_components_Money__["a" /* default */],{value:selectedBuyer.submittedValue,currency:this.props.app.currency.code,locale:this.props.intl.locale})),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('h3',null,t('Additional information text')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('p',null,message||__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('i',null,t('Not entered'))),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('h2',null,t('Rejected customers offers')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('ol',null,rejectedOfferDetails&&rejectedOfferDetails.map(function(i){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',{key:i.buyerId},_this2.renderBuyerName(i.item));})),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('h3',null,t('Additional information text')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('p',null,rejectMessage||__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('i',null,t('Not entered'))),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('p',null,t('If you click "Finish", you confirm the winner'),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('br',null),t('This action cannot be undone.')));}}]);return AwardSummary;}(__WEBPACK_IMPORTED_MODULE_4__components_BaseStep__["a" /* default */]),_class2.displayName='AwardSummary',_temp))||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (AwardSummary);

/***/ }),
/* 2099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_src_app_components_AuctionFinals_stores__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Step1__ = __webpack_require__(2101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Step2__ = __webpack_require__(2107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Info__ = __webpack_require__(2108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Summary__ = __webpack_require__(2109);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var Store=(_class=function(){function Store(management){_classCallCheck(this,Store);_initDefineProp(this,'loading',_descriptor,this);_initDefineProp(this,'loaded',_descriptor2,this);this.steps=[{key:'winners',title:'Choose winners',implementation:__WEBPACK_IMPORTED_MODULE_3__Step1__["a" /* default */],info:__WEBPACK_IMPORTED_MODULE_5__Info__["a" /* default */]},{key:'review',title:'Review winners',implementation:__WEBPACK_IMPORTED_MODULE_4__Step2__["a" /* default */],info:__WEBPACK_IMPORTED_MODULE_5__Info__["a" /* default */]}];this.auctionFinalsStore=null;this.summaryClass=__WEBPACK_IMPORTED_MODULE_6__Summary__["a" /* default */];this.management=management;this.auctionFinalsStore=new __WEBPACK_IMPORTED_MODULE_2__build_src_app_components_AuctionFinals_stores__["a" /* AuctionFinalsStore */](management.source);}_createClass(Store,[{key:'submit',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(saleId,token){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return this.auctionFinalsStore.awardAll();case 2:case'end':return _context.stop();}}},_callee,this);}));function submit(_x,_x2){return _ref.apply(this,arguments);}return submit;}()}]);return Store;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'loading',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'loaded',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_applyDecoratedDescriptor(_class.prototype,'submit',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'submit'),_class.prototype)),_class);

/***/ }),
/* 2100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuctionFinalsStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_src_app_services_request__ = __webpack_require__(18);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_class2,_temp,_initialiseProps;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var AuctionFinalsStore=(_class=(_temp=_class2=function(){// successfully awarded offers (progress report)
// sale: SaleStore
// selection[<object id>] = <buyer id>
// objects = [ { id, name } ]
function AuctionFinalsStore(sale){_classCallCheck(this,AuctionFinalsStore);_initialiseProps.call(this);this.sale=sale;this.objects=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */])([]);this.buyers=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */])([]);this.selection=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */])({});this.results=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */])({succeeded:[],failed:[]});}// { succeeded: [ { saleId, buyerId }], failed: [ {saleId, buyerId, error }] }
// buyers = [ { id, name, offers: [ { id, price, preference }] }]
_createClass(AuctionFinalsStore,[{key:'selected',get:function get(){return Object.keys(this.selection).length;}// remove awarded offers from selection
}]);return AuctionFinalsStore;}(),_initialiseProps=function _initialiseProps(){var _this=this;_initDefineProp(this,'objects',_descriptor,this);_initDefineProp(this,'buyers',_descriptor2,this);_initDefineProp(this,'selection',_descriptor3,this);_initDefineProp(this,'awardedCount',_descriptor4,this);_initDefineProp(this,'awardedPrice',_descriptor5,this);_initDefineProp(this,'selectedCount',_descriptor6,this);_initDefineProp(this,'selectedPrice',_descriptor7,this);_initDefineProp(this,'results',_descriptor8,this);_initDefineProp(this,'processed',_descriptor9,this);this.recalculate=function(){_this.awardedCount=0;_this.awardedPrice=0;// assign buyer.awarded
_this.buyers.forEach(function(buyer){var awarded=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.find(buyer.offers,{awarded:true});if(awarded){buyer.awarded=true;_this.awardedCount++;_this.awardedPrice+=awarded.price;}});// calculate the highest offer for each property
_this.objects.forEach(function(object){// get all offers for the current property and sort them
var objectOffers=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.map(_this.buyers,function(buyer){var objectOffer=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.find(buyer.offers,function(offer){return offer.id===object.id;});if(objectOffer)return Object.assign(objectOffer,{buyerId:buyer.id});return null;});objectOffers=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.filter(objectOffers,function(offer){return offer!==null;});objectOffers=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.sortBy(objectOffers,function(offer){return-offer.price;});// DESC
object.offers=objectOffers;var highestOffer=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.find(object.offers,function(offer){return!offer.awarded;});object.highestBuyerId=highestOffer?highestOffer.buyerId:null;object.awarded=typeof __WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.find(object.offers,function(offer){return offer.awarded;})!=='undefined';});// calculate position of each offer from each buyer
_this.buyers.forEach(function(buyer){buyer.offers.forEach(function(offer){var _object=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.find(_this.objects,function(o){return o.id===offer.id;});var _nonAwaredOffers=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.filter(_object.offers,function(offer){return!offer.awarded;});offer.position=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.findIndex(_nonAwaredOffers,function(offer){return offer.buyerId===buyer.id;});offer.count=_nonAwaredOffers.length;});var nonAwaredOffers=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.filter(buyer.offers,function(offer){return!offer.awarded;});buyer.preferredOffer=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.minBy(nonAwaredOffers,function(_offer){return _offer.preference;});});//console.log('objects', this.objects);
//console.log('buyers', this.buyers);
};this.calculateTotals=function(){_this.selectedCount=0;_this.selectedPrice=0;Object.keys(_this.selection).forEach(function(objectId){var buyerId=_this.selection[objectId];var buyer=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.find(_this.buyers,function(buyer){return buyer.id===buyerId;});if(buyer){var offer=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.find(buyer.offers,function(offer){return offer.id===objectId;});if(offer){_this.selectedCount++;_this.selectedPrice+=offer.price;}}});};this.isBuyerSelected=function(buyerId){return __WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.find(_this.selection,function(_buyerId){return _buyerId===buyerId;});};this.isObjectSelected=function(objectId){return typeof _this.selection[objectId]!=='undefined';};this.select=function(objectId,buyerId){var notify=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;var object=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.find(_this.objects,{id:objectId});var buyer=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.find(_this.buyers,{id:buyerId});if(object&&object.awarded||buyer&&buyer.awarded)return;// no interaction allowed on awarded
if(_this.selection[objectId]===buyerId)delete _this.selection[objectId];else{Object.keys(_this.selection).forEach(function(key){if(_this.selection[key]===buyerId)delete _this.selection[key];// deselect another offer
});_this.selection[objectId]=buyerId;// select this offer
}if(notify)_this.selectionChanged();};this.clearSelection=function(){_this.selection=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */])({});_this.selectionChanged();};this.selectionChanged=function(){// calculate the highest offer for each property
_this.objects.forEach(function(object){object.selected=_this.selection[object.id];});// calculate position of each offer from each buyer
_this.buyers.forEach(function(buyer){buyer.selected=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.findKey(_this.selection,function(buyerId){return buyerId===buyer.id;});});_this.calculateTotals();// recalculate total price
if(_this.onSelectionChanged)_this.onSelectionChanged(_this.selection);};this.load=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(){var abortSignal=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var sales,sortedSales,offers,sortedOffers,filteredOffers;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.objects.clear();_this.buyers.clear();_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3__build_src_app_services_request__["d" /* get */])('/api/v1/package-auctions/'+_this.sale.saleId+'/sales',_this.sale.user.accessToken,null,abortSignal);case 4:sales=_context.sent;sortedSales=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.sortBy(sales,function(sale){return sale.attributes.title;});sortedSales.forEach(function(sale){_this.objects.push({id:sale.saleId,name:sale.attributes.number,title:sale.attributes.title,address:sale.attributes.object_address});});_context.next=9;return Object(__WEBPACK_IMPORTED_MODULE_3__build_src_app_services_request__["d" /* get */])('/api/v1/package-auctions/'+_this.sale.saleId+'/offers',_this.sale.user.accessToken,null,abortSignal);case 9:offers=_context.sent;if(!(abortSignal!=null&&abortSignal.aborted)){_context.next=12;break;}return _context.abrupt('return');case 12:sortedOffers=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.sortBy(offers,function(offer){return offer.submittedAt;});filteredOffers=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.filter(sortedOffers,function(offer){return offer.status==='confirmed'||offer.status==='awarded';});filteredOffers.forEach(function(offer){var buyer=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.find(_this.buyers,function(b){return b.id===offer.buyerId;});if(!buyer){buyer={id:offer.buyerId,name:offer.buyer.buyer_firstName+' '+offer.buyer.buyer_lastName,offers:[{id:offer.saleId,price:!!offer.data.units?offer.submittedValue*offer.data.units:offer.submittedValue,preference:1,awarded:offer.status==='awarded'}]};_this.buyers.push(buyer);}else{buyer.offers.push({id:offer.saleId,price:!!offer.data.units?offer.submittedValue*offer.data.units:offer.submittedValue,preference:buyer.offers.length+1,awarded:offer.status==='awarded'});}});_this.recalculate();case 16:case'end':return _context.stop();}}},_callee,_this);}));this.award=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3(){var abortSignal=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var objectIds,_loop,i,_ret;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:objectIds=Object.keys(_this.selection);_this.processed=0;_this.results.succeeded.clear();_this.results.failed.clear();_loop=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(i){var selectedObjectId,selectedBuyerId,buyer,offer;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:selectedObjectId=objectIds[i];selectedBuyerId=_this.selection[selectedObjectId];buyer=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.find(_this.buyers,function(buyer){return buyer.id===selectedBuyerId;});offer=buyer?__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.find(buyer.offers,function(offer){return offer.id===selectedObjectId;}):null;_context2.prev=4;_context2.next=7;return Object(__WEBPACK_IMPORTED_MODULE_3__build_src_app_services_request__["e" /* post */])('/api/v1/wizard/'+selectedObjectId+'/award',{rejectOffers:[],buyerId:selectedBuyerId,message:''},_this.sale.user.accessToken,abortSignal);case 7:if(!(abortSignal!=null&&abortSignal.aborted)){_context2.next=9;break;}return _context2.abrupt('return',{v:void 0});case 9:_this.results.succeeded.push({saleId:selectedObjectId,buyerId:selectedBuyerId});if(offer)offer.awarded=true;_context2.next=16;break;case 13:_context2.prev=13;_context2.t0=_context2['catch'](4);_this.results.failed.push({saleId:selectedObjectId,buyerId:selectedBuyerId,error:_context2.t0});case 16:_this.processed=_this.processed+1;case 17:case'end':return _context2.stop();}}},_callee2,_this,[[4,13]]);});i=0;case 6:if(!(i<objectIds.length)){_context3.next=14;break;}return _context3.delegateYield(_loop(i),'t0',8);case 8:_ret=_context3.t0;if(!((typeof _ret==='undefined'?'undefined':_typeof(_ret))==="object")){_context3.next=11;break;}return _context3.abrupt('return',_ret.v);case 11:i++;_context3.next=6;break;case 14:case'end':return _context3.stop();}}},_callee3,_this);}));this.awardAll=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee4(){var abortSignal=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var payload,response,i,result,buyer,_offer2;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_this.processed=0;_this.results.succeeded.clear();_this.results.failed.clear();payload=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.map(Object.keys(_this.selection),function(objectId){return{saleId:objectId,rejectOffers:[],buyerId:_this.selection[objectId],message:''};});_context4.prev=4;_context4.next=7;return Object(__WEBPACK_IMPORTED_MODULE_3__build_src_app_services_request__["e" /* post */])('/api/v1/wizard/awardall',payload,_this.sale.user.accessToken,abortSignal);case 7:response=_context4.sent;if(!(abortSignal!=null&&abortSignal.aborted)){_context4.next=10;break;}return _context4.abrupt('return');case 10:_this.processed=_this.processed+_this.selectedCount;//console.log(response);
if(!(response&&response.results)){_context4.next=21;break;}i=0;case 13:if(!(i<payload.length)){_context4.next=21;break;}if(!(response.results.length<=i)){_context4.next=16;break;}return _context4.abrupt('break',21);case 16:result=response.results[i];if(result.successful){_this.results.succeeded.push({saleId:payload[i].saleId,buyerId:payload[i].buyerId});buyer=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.find(_this.buyers,{id:payload[i].buyerId});if(buyer){_offer2=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.find(buyer.offers,{id:payload[i].saleId});if(_offer2)_offer2.awarded=true;}}else{_this.results.failed.push({saleId:payload[i].saleId,buyerId:payload[i].buyerId,error:result.error});}case 18:i++;_context4.next=13;break;case 21:_context4.next=26;break;case 23:_context4.prev=23;_context4.t0=_context4['catch'](4);console.error(_context4.t0);case 26:case'end':return _context4.stop();}}},_callee4,_this,[[4,23]]);}));this.removeAwarded=function(){var objectIds=Object.keys(_this.selection);objectIds.forEach(function(objectId){var buyer=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.find(_this.buyers,function(buyer){return buyer.id===_this.selection[objectId];});if(buyer){var _offer3=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.find(buyer.offers,function(offer){return offer.id===objectId;});if(_offer3&&_offer3.awarded)delete _this.selection[objectId];}});_this.recalculate();_this.selectionChanged();};},_temp),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'objects',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'buyers',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'selection',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'awardedCount',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'awardedPrice',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'selectedCount',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'selectedPrice',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'results',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return{};}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'processed',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return 0;}})),_class);

/***/ }),
/* 2101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_Spinner__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_src_app_components_AuctionFinals_components__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_BaseStep__ = __webpack_require__(68);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AwardAllStep1=Object(__WEBPACK_IMPORTED_MODULE_4__build_src_app_components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["e" /* observer */])(_class=(_temp2=_class2=function(_BaseStep){_inherits(AwardAllStep1,_BaseStep);function AwardAllStep1(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AwardAllStep1);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AwardAllStep1.__proto__||Object.getPrototypeOf(AwardAllStep1)).call.apply(_ref,[this].concat(args))),_this),_this.handleSelectionChanged=function(selection){var _this$props=_this.props,store=_this$props.store,onValidChanged=_this$props.onValidChanged;onValidChanged(store.auctionFinalsStore.selectedCount>0);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AwardAllStep1,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,store=_props.store,onValidChanged=_props.onValidChanged;onValidChanged(store.auctionFinalsStore.selectedCount>0);store.auctionFinalsStore.onSelectionChanged=this.handleSelectionChanged;if(!store.loaded){store.loading=true;store.auctionFinalsStore.load().then(function(result){store.loading=false;store.loaded=true;});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){var store=this.props.store;store.auctionFinalsStore.onSelectionChanged=null;}},{key:'render',value:function render(){var _props2=this.props,store=_props2.store,t=_props2.t;var sale=store.auctionFinalsStore.sale;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{style:{width:'100%',minHeight:'50px'}},store.loading&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_Spinner__["a" /* Spinner */],{label:t('Loading offers, please wait')+'...',size:__WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_Spinner__["b" /* SpinnerSize */].medium}),store.loaded&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_src_app_components_AuctionFinals_components__["b" /* AuctionFinalsMatrix */],{sale:sale,store:store.auctionFinalsStore,locale:sale.saleEdit.locale,currency:sale.saleEdit.currencyCode})));}}]);return AwardAllStep1;}(__WEBPACK_IMPORTED_MODULE_5__components_BaseStep__["a" /* default */]),_class2.displayName='AwardAllStep1',_temp2))||_class)||_class;/* harmony default export */ __webpack_exports__["a"] = (AwardAllStep1);

/***/ }),
/* 2102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuctionFinalsMatrix; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AuctionFinalsMatrix_css__ = __webpack_require__(2103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AuctionFinalsMatrix_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__AuctionFinalsMatrix_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// props.store = AuctionFinalsStore
var AuctionFinalsMatrix=Object(__WEBPACK_IMPORTED_MODULE_4__build_src_app_components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__["e" /* observer */])(_class=(_temp2=_class2=function(_Component){_inherits(AuctionFinalsMatrix,_Component);function AuctionFinalsMatrix(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AuctionFinalsMatrix);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AuctionFinalsMatrix.__proto__||Object.getPrototypeOf(AuctionFinalsMatrix)).call.apply(_ref,[this].concat(args))),_this),_this.formatObjectCellClassName=function(object){return'object '+(object.selected?'selected':'')+' '+(object.awarded?'awarded':'');},_this.formatObjectCellContent=function(object){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,object.name,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('br',null),object.title);},_this.formatBuyerRowClassName=function(buyer){return''+(buyer.awarded?'awarded':'');},_this.formatBuyerCellClassName=function(buyer){return'buyer '+(buyer.selected?'selected':'')+' '+(buyer.awarded?'awarded':'');},_this.buyerCellContentFormatter=function(buyer){return buyer.name;// const index = buyer.name.indexOf(' ');
// if (index > 0)
//   return buyer.name.substr(0, 1) + buyer.name.substr(index + 1, 1);
// else return buyer.name.substr(0, 3);
},_this.getOfferWarnings=function(object,buyer,offer){var _this$props=_this.props,store=_this$props.store,t=_this$props.t;var result=[];// any offer for the current property is selected
var isObjectOfferSelected=object.selected;// any offer made by the current buyer is selected
var isBuyerOfferSelected=buyer.selected;// is the current offer selected
var isCurrentOfferSelected=store.selection[object.id]===buyer.id;if(isCurrentOfferSelected)return result;// get the highest offer for the current property
var isHighest=object.highestBuyerId===buyer.id;if(isHighest&&isObjectOfferSelected)result.push(t("This is the highest offer for this property, but it's not selected"));var bestPreference=buyer.preferredOffer;var isMostPreferred=bestPreference&&bestPreference.preference===offer.preference;if(isMostPreferred&&isBuyerOfferSelected)result.push(t("This is the most preferred offer for this buyer, but it's not selected"));return result;},_this.formatOfferCellTitle=function(object,buyer,offer,warnings){var _this$props2=_this.props,currency=_this$props2.currency,locale=_this$props2.locale,t=_this$props2.t;var result=t('Property')+': '+object.name+'\n'+t('Customer')+': '+buyer.name+'\n'+t('Offer')+': '+offer.price.toFormattedMoney(locale,currency)+'\n'+t('Position')+': '+(offer.position+1)+' / '+offer.count+'\n'+t('Preference')+': '+offer.preference;if(offer.awarded)result=result+('\n'+t('Awarded')+'!');if(warnings.length>0)warnings.forEach(function(warning){return result=result+'\n'+warning;});return result;},_this.formatOfferCellClassName=function(object,buyer,offer,warnings){var store=_this.props.store;var isSelected=store.selection[object.id]===buyer.id||offer.awarded;var hasWarning=warnings.length>0;return'offer '+(isSelected?'selected':hasWarning?'warning':'')+' '+(object.awarded||buyer.awarded?'awarded':'');},_this.formatNonOfferCellClassName=function(object,buyer){if(!!object&&object.awarded||!!buyer&&buyer.awarded)return'awarded';if(!!object&&object.selected||!!buyer&&buyer.selected)return'selected';return'';},_this.formatOfferCellColor=function(object,buyer,offer,warnings){if(object.awarded||buyer.awarded)return null;var store=_this.props.store;var isSelected=store.selection[object.id]===buyer.id;var hue=120-Math.round(offer.position/offer.count*120);return'hsl('+hue+', 100%, '+(isSelected?'40':'80')+'%)';},_this.formatOfferCellContent=function(object,buyer,offer,warnings){var hasWarning=warnings.length>0;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Button__["g" /* IconButton */],{iconProps:{iconName:!offer.awarded&&hasWarning?'StatusCircleExclamation':'Accept'},onClick:_this.handleSelect(object.id,buyer.id)});},_this.handleSelect=function(objectId,buyerId){return function(){var store=_this.props.store;store.select(objectId,buyerId);};},_this.handleClearSelection=function(){var store=_this.props.store;store.clearSelection();},_this.handleSelectPreferedHighestOffers=function(){var store=_this.props.store;store.objects.forEach(function(object){if(!object.awarded&&object.highestBuyerId&&object.offers[0].preference===1&&!store.isBuyerSelected(object.highestBuyerId))store.select(object.id,object.highestBuyerId);});},_this.handleSelectHighestOffers=function(){var store=_this.props.store;store.buyers.forEach(function(buyer){if(!buyer.awarded&&!store.isBuyerSelected(buyer.id)){// filter only highest offers of the current buyer
var highestOffers=__WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash___default.a.filter(buyer.offers,function(offer){if(offer.awarded||store.isObjectSelected(offer.id))return false;var object=__WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash___default.a.find(store.objects,{id:offer.id});if(object&&object.highestBuyerId===buyer.id)return true;return false;});var bestOffer=__WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash___default.a.minBy(highestOffers,'preference');if(bestOffer)store.select(bestOffer.id,buyer.id);}});},_this.handleSelectBestOffers=function(){var store=_this.props.store;store.objects.forEach(function(object){if(!object.awarded){var availableOffers=__WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash___default.a.filter(object.offers,function(offer){return!offer.awarded&&!store.isBuyerSelected(offer.buyerId);});var bestOffer=__WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash___default.a.maxBy(availableOffers,function(offer){return offer.price;});if(bestOffer)store.select(object.id,bestOffer.buyerId);}});},_temp),_possibleConstructorReturn(_this,_ret);}// for each property select most preferred offer if it is also the highest offer
// for each property select the highest offer (if available, i.e. the highest bidder has not been awarded to another property)
// for each property select the best (still available) offer
_createClass(AuctionFinalsMatrix,[{key:'render',value:function render(){var _this2=this;var _props=this.props,store=_props.store,t=_props.t;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('table',{style:{borderCollapse:'collapse'},className:'auction-finals-matrix'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('th',null),store.objects.map(function(object){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('th',{key:object.id,title:object.name+' - '+object.title,className:_this2.formatObjectCellClassName(object)},_this2.formatObjectCellContent(object));}))),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('tbody',null,store.buyers.map(function(buyer){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('tr',{key:buyer.id,className:_this2.formatBuyerRowClassName(buyer)},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('th',{key:'buyer',title:buyer.name,className:_this2.formatBuyerCellClassName(buyer)},_this2.buyerCellContentFormatter(buyer)),store.objects.map(function(object){var offer=__WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash___default.a.find(buyer.offers,function(offer){return offer.id===object.id;});var warnings=offer?_this2.getOfferWarnings(object,buyer,offer):[];return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],{key:object.id},offer&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('td',{title:_this2.formatOfferCellTitle(object,buyer,offer,warnings),className:_this2.formatOfferCellClassName(object,buyer,offer,warnings),style:{backgroundColor:_this2.formatOfferCellColor(object,buyer,offer,warnings),color:'Red'}},_this2.formatOfferCellContent(object,buyer,offer,warnings)),!offer&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('td',{className:_this2.formatNonOfferCellClassName(object,buyer)}));}));}))),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{style:{display:'none'}},store.selectedCount))),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Button__["f" /* DefaultButton */],{text:t('Clear selection'),onClick:this.handleClearSelection,style:{marginRight:'5px'}}),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Button__["f" /* DefaultButton */],{text:'1. '+t('Select preferred highest offers'),title:t('For each property pick the highest offer if it is the most preferred offer of the highest bidder'),onClick:this.handleSelectPreferedHighestOffers,style:{marginRight:'5px'}}),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Button__["f" /* DefaultButton */],{text:'2. '+t('Select highest offers'),title:t('For each property pick the highest offer if the highest bidder has not been assigned to another property yet'),onClick:this.handleSelectHighestOffers,style:{marginRight:'5px'}}),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Button__["f" /* DefaultButton */],{text:'3. '+t('Select best offers'),title:t('For each property pick the best available offer'),onClick:this.handleSelectBestOffers})));}}]);return AuctionFinalsMatrix;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class2.displayName='AuctionFinalsMatrix',_temp2))||_class)||_class;

/***/ }),
/* 2103 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuctionFinalsList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AuctionFinalsList_css__ = __webpack_require__(2105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AuctionFinalsList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__AuctionFinalsList_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// props.store = AuctionFinalsStore
// props.showResults = true | false
// props.showTotals = true | false
var AuctionFinalsList=Object(__WEBPACK_IMPORTED_MODULE_5__build_src_app_components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__["e" /* observer */])(_class=(_temp2=_class2=function(_Component){_inherits(AuctionFinalsList,_Component);function AuctionFinalsList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AuctionFinalsList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AuctionFinalsList.__proto__||Object.getPrototypeOf(AuctionFinalsList)).call.apply(_ref,[this].concat(args))),_this),_this.handleRemove=function(objectId){return function(){var store=_this.props.store;delete store.selection[objectId];_this.selectionChanged();};},_this.selectionChanged=function(){var store=_this.props.store;store.selectionChanged();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AuctionFinalsList,[{key:'render',value:function render(){var _this2=this;var _props=this.props,store=_props.store,showResults=_props.showResults,showTotals=_props.showTotals,locale=_props.locale,currency=_props.currency,t=_props.t,style=_props.style;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('table',{className:'auction-finals-list',style:style},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('th',null,t('Object no.')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('th',null,t('Title')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('th',null,t('Selected buyer')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('th',null,t('Purchase price')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('tbody',null,store.objects.map(function(object){var buyerId=store.selection[object.id];if(buyerId){var buyer=__WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash___default.a.find(store.buyers,function(buyer){return buyer.id===buyerId;});if(buyer){var offer=__WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash___default.a.find(buyer.offers,function(offer){return offer.id===object.id;});if(offer){var succeeded=showResults?__WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash___default.a.find(store.results.succeeded,{saleId:object.id,buyerId:buyer.id}):null;var failed=showResults?__WEBPACK_IMPORTED_MODULE_1__build_node_modules_lodash___default.a.find(store.results.failed,{saleId:object.id,buyerId:buyer.id}):null;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('tr',{key:object.id,className:showResults?!!succeeded?'succeeded':!!failed?'failed':'':''},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('td',null,object.name),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('td',null,object.title),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('td',null,buyer.name),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('td',null,offer.price.toFormattedMoney(locale,currency)),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('td',null,showResults&&!!succeeded&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react__["f" /* Icon */],{iconName:'CheckMark'}),showResults&&!!failed&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react__["f" /* Icon */],{iconName:'Error',title:failed.error}),!showResults&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Button__["g" /* IconButton */],{iconProps:{iconName:'Cancel'},onClick:_this2.handleRemove(object.id)})));}}}return null;}),!showResults&&store.selected===0&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('td',{colSpan:'5'},t('No offer selected for awardwing, go back to the matrix and pick some.'))),showTotals&&store.selected>0&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('td',{colSpan:'3'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('strong',null,t('Total'))),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('strong',null,store.selectedPrice.toFormattedMoney(locale,currency))),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('td',null)))),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{style:{display:'none'}},store.selectedPrice),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{style:{display:'none'}},store.processed));}}]);return AuctionFinalsList;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class2.displayName='AuctionFinalsList',_temp2))||_class)||_class;

/***/ }),
/* 2105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuctionFinalsTotals; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_src_app_components_Localization__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// props.store = AuctionFinalsStore
var AuctionFinalsTotals=Object(__WEBPACK_IMPORTED_MODULE_2__build_src_app_components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["e" /* observer */])(_class=(_temp=_class2=function(_Component){_inherits(AuctionFinalsTotals,_Component);function AuctionFinalsTotals(){_classCallCheck(this,AuctionFinalsTotals);return _possibleConstructorReturn(this,(AuctionFinalsTotals.__proto__||Object.getPrototypeOf(AuctionFinalsTotals)).apply(this,arguments));}_createClass(AuctionFinalsTotals,[{key:'render',value:function render(){var _props=this.props,store=_props.store,locale=_props.locale,currency=_props.currency,t=_props.t;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,t('Awarded'),': ',store.awardedPrice.toFormattedMoney(locale,currency),' ','(',store.awardedCount,'), ',t('Selected'),':',' ',store.selectedPrice.toFormattedMoney(locale,currency),' (',store.selectedCount,'), ',t('Total'),':',' ',(store.awardedPrice+store.selectedPrice).toFormattedMoney(locale,currency),' ','(',store.awardedCount+store.selectedCount,')');}}]);return AuctionFinalsTotals;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class2.displayName='AuctionFinalsTotals',_temp))||_class)||_class;

/***/ }),
/* 2107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_src_app_components_AuctionFinals_components__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_BaseStep__ = __webpack_require__(68);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AwardAllStep2=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["e" /* observer */])(_class=(_temp2=_class2=function(_BaseStep){_inherits(AwardAllStep2,_BaseStep);function AwardAllStep2(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AwardAllStep2);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AwardAllStep2.__proto__||Object.getPrototypeOf(AwardAllStep2)).call.apply(_ref,[this].concat(args))),_this),_this.handleSelectionChanged=function(selection){var _this$props=_this.props,store=_this$props.store,onValidChanged=_this$props.onValidChanged;onValidChanged(store.auctionFinalsStore.selectedCount>0);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AwardAllStep2,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,store=_props.store,onValidChanged=_props.onValidChanged;onValidChanged(store.auctionFinalsStore.selectedCount>0);store.auctionFinalsStore.onSelectionChanged=this.handleSelectionChanged;}},{key:'componentWillUnmount',value:function componentWillUnmount(){var store=this.props.store;store.auctionFinalsStore.onSelectionChanged=null;}},{key:'render',value:function render(){var store=this.props.store;var sale=store.auctionFinalsStore.sale;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__build_src_app_components_AuctionFinals_components__["a" /* AuctionFinalsList */],{sale:sale,store:store.auctionFinalsStore,locale:sale.saleEdit.locale,currency:sale.saleEdit.currencyCode,style:{width:'100%'}});}}]);return AwardAllStep2;}(__WEBPACK_IMPORTED_MODULE_3__components_BaseStep__["a" /* default */]),_class2.displayName='AwardAllStep2',_temp2))||_class;/* harmony default export */ __webpack_exports__["a"] = (AwardAllStep2);

/***/ }),
/* 2108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_src_app_components_AuctionFinals_components__ = __webpack_require__(211);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AwardAllInfo=(_temp=_class=function(_Component){_inherits(AwardAllInfo,_Component);function AwardAllInfo(){_classCallCheck(this,AwardAllInfo);return _possibleConstructorReturn(this,(AwardAllInfo.__proto__||Object.getPrototypeOf(AwardAllInfo)).apply(this,arguments));}_createClass(AwardAllInfo,[{key:'render',value:function render(){var store=this.props.store;var sale=store.auctionFinalsStore.sale;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_src_app_components_AuctionFinals_components__["c" /* AuctionFinalsTotals */],{store:store.auctionFinalsStore,locale:sale.saleEdit.locale,currency:sale.saleEdit.currencyCode});}}]);return AwardAllInfo;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class.displayName='AwardAllInfo',_temp);/* harmony default export */ __webpack_exports__["a"] = (AwardAllInfo);

/***/ }),
/* 2109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_src_app_components_AuctionFinals_components__ = __webpack_require__(211);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AwardAllSummary=(_temp=_class=function(_Component){_inherits(AwardAllSummary,_Component);function AwardAllSummary(){_classCallCheck(this,AwardAllSummary);return _possibleConstructorReturn(this,(AwardAllSummary.__proto__||Object.getPrototypeOf(AwardAllSummary)).apply(this,arguments));}_createClass(AwardAllSummary,[{key:'render',value:function render(){var store=this.props.store;var sale=store.auctionFinalsStore.sale;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_src_app_components_AuctionFinals_components__["a" /* AuctionFinalsList */],{sale:sale,store:store.auctionFinalsStore,locale:sale.saleEdit.locale,currency:sale.saleEdit.currencyCode,showResults:true,showTotals:true,style:{width:'100%'}});}}]);return AwardAllSummary;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class.displayName='AwardAllSummary',_temp);/* harmony default export */ __webpack_exports__["a"] = (AwardAllSummary);

/***/ }),
/* 2110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_src_app_services_request__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Step1__ = __webpack_require__(2111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Summary__ = __webpack_require__(2112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Results__ = __webpack_require__(2113);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}var Store=(_class=function(){function Store(management){_classCallCheck(this,Store);this.steps=[{key:'tc',title:'Accept T&C',implementation:__WEBPACK_IMPORTED_MODULE_3__Step1__["a" /* default */]}];this.summaryClass=__WEBPACK_IMPORTED_MODULE_4__Summary__["a" /* default */];this.resultsClass=__WEBPACK_IMPORTED_MODULE_5__Results__["a" /* default */];this.data=null;this.saleId=null;this.source=management.source;var user=management.source.user;this.data={agentData:user.agentData()};}_createClass(Store,[{key:'submit',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(saleId,token){var response;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__build_src_app_services_request__["e" /* post */])('/api/v1/wizard/'+saleId+'/duplicate',this.data,token);case 2:response=_context.sent;this.saleId=response.command.saleId;case 4:case'end':return _context.stop();}}},_callee,this);}));function submit(_x,_x2){return _ref.apply(this,arguments);}return submit;}()}]);return Store;}(),(_applyDecoratedDescriptor(_class.prototype,'submit',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'submit'),_class.prototype)),_class);

/***/ }),
/* 2111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_react_intl__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_styled_components__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Checkbox__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SaleInfo__ = __webpack_require__(842);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp2;var _templateObject=_taggedTemplateLiteral(['\n  a {\n    color: ',';\n  }\n'],['\n  a {\n    color: ',';\n  }\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var TocSection=__WEBPACK_IMPORTED_MODULE_3__build_node_modules_styled_components__["a" /* default */].span(_templateObject,function(props){return props.theme.palette.themePrimary;});var DuplicateStep1=(_dec=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["d" /* inject */])('app','user'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_5__build_src_app_components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["e" /* observer */])(_class=(_temp2=_class2=function(_Component){_inherits(DuplicateStep1,_Component);function DuplicateStep1(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DuplicateStep1);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DuplicateStep1.__proto__||Object.getPrototypeOf(DuplicateStep1)).call.apply(_ref,[this].concat(args))),_this),_this.handleOpenToc=function(e,page){var _this$props=_this.props,user=_this$props.user,app=_this$props.app;e.preventDefault();e.stopPropagation();// HACK-ing
var url='/content/'+page+'?locale='+user.claims.locale;if(app.config.tenant.startsWith('propnow'))url=window.location.origin.replace('://app.','://'+user.claims.tenant+'.')+url;window.open(url);},_this.handleTocChange=function(_,isChecked){var onValidChanged=_this.props.onValidChanged;onValidChanged(isChecked);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DuplicateStep1,[{key:'componentDidMount',value:function componentDidMount(){var onValidChanged=this.props.onValidChanged;onValidChanged(false);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,app=_props.app,store=_props.store,t=_props.t;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('ul',{className:'hint'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',null,t('hint1')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',null,t('hint2'))),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{style:{paddingBottom:'1em'}},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('h2',null,t('Duplicating sale')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SaleInfo__["a" /* default */],{store:store,t:t})),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Checkbox__["a" /* Checkbox */],{onChange:this.handleTocChange,label:t('I agree with terms and conditions'),onRenderLabel:function onRenderLabel(){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(TocSection,{theme:app.theme},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_react_intl__["a" /* FormattedMessage */],{id:'SaleCreatePanel::i_agree_to_the_link',values:{agbs:__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.handleOpenToc(e,'agb');}},t('agbs')),dataprotection:__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.handleOpenToc(e,'datenschutzerklaerung');}},t('dataprotection')),avv:__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.handleOpenToc(e,'avv');}},t('avv'))}}));}})));}}]);return DuplicateStep1;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class2.displayName='DuplicateStep1',_temp2))||_class)||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (DuplicateStep1);

/***/ }),
/* 2112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SaleInfo__ = __webpack_require__(842);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DuplicateSummary=(_dec=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["d" /* inject */])('app'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_2__build_src_app_components_Localization__["a" /* localizable */])(_class=(_temp=_class2=function(_Component){_inherits(DuplicateSummary,_Component);function DuplicateSummary(){_classCallCheck(this,DuplicateSummary);return _possibleConstructorReturn(this,(DuplicateSummary.__proto__||Object.getPrototypeOf(DuplicateSummary)).apply(this,arguments));}_createClass(DuplicateSummary,[{key:'render',value:function render(){var _props=this.props,store=_props.store,t=_props.t;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('h2',null,t('Summary')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{style:{paddingBottom:'1em'}},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('h3',null,t('Duplicating sale')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SaleInfo__["a" /* default */],{store:store,t:t})));}}]);return DuplicateSummary;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class2.displayName='DuplicateSummary',_temp))||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (DuplicateSummary);

/***/ }),
/* 2113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_styled_components__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_src_app_components_Localization__ = __webpack_require__(8);
var _templateObject=_taggedTemplateLiteral(['\n  margin-top: 3em;\n  display: block;\n  text-align: center;\n  color: ',';\n  font-size: 1.5em;\n  cursor: pointer;\n\n  i {\n    margin-left: 0.2em;\n  }\n'],['\n  margin-top: 3em;\n  display: block;\n  text-align: center;\n  color: ',';\n  font-size: 1.5em;\n  cursor: pointer;\n\n  i {\n    margin-left: 0.2em;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ContinueButton=__WEBPACK_IMPORTED_MODULE_1__build_node_modules_styled_components__["a" /* default */].a(_templateObject,function(props){return props.theme.palette.themePrimary;});/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__build_src_app_components_Localization__["a" /* localizable */])('SaleWizardResult')(function(_ref){var store=_ref.store,t=_ref.t,theme=_ref.theme;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('h1',null,t('Confirmation')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('p',null,t('Successful')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(ContinueButton,{theme:theme,onClick:function onClick(){return window.location.href='/dashboard/'+store.actionStore.saleId;}},t('Continue to the duplicated sale'),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('i',{className:'ms-Icon ms-Icon--NavigateForward','aria-hidden':'true'})));}));

/***/ }),
/* 2114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_request__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Step1__ = __webpack_require__(2115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Summary__ = __webpack_require__(2116);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var Store=(_class=function(){_createClass(Store,[{key:'selectedBuyer',get:function get(){if(!this.offers)return[];var _offers$filter=this.offers.filter(function(o){return o.status==='awarded';}),_offers$filter2=_slicedToArray(_offers$filter,1),awarded=_offers$filter2[0];return awarded||{};}},{key:'offersToReject',get:function get(){if(!this.offers)return[];return this.offers.filter(function(item){return item.status==='confirmed'||item.status==='accepted';}).sort(function(a,b){return b.submittedValue-a.submittedValue;});}}]);function Store(management){var _this=this;_classCallCheck(this,Store);this.steps=[{key:'reject-message',title:'Message to rejected',implementation:__WEBPACK_IMPORTED_MODULE_3__Step1__["a" /* default */]}];_initDefineProp(this,'offers',_descriptor,this);_initDefineProp(this,'rejectMessage',_descriptor2,this);this.summaryClass=__WEBPACK_IMPORTED_MODULE_4__Summary__["a" /* default */];this.handleRejectMessageChange=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */])(function(value){_this.rejectMessage=value;});this.offers=management.source.offers.viewModel.offers.map(function(item){return{item:item,buyerId:item.buyerId,name:item.buyer.buyer_lastName+', '+item.buyer.buyer_firstName,submittedValue:item.submittedValue,validity:item.data.offer_validity,status:item.status};});}_createClass(Store,[{key:'submit',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(saleId,token){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__services_request__["e" /* post */])('/api/v1/wizard/'+saleId+'/award/confirm',{buyerId:this.selectedBuyer.buyerId,rejectMessage:this.rejectMessage},token);case 2:case'end':return _context.stop();}}},_callee,this);}));function submit(_x,_x2){return _ref.apply(this,arguments);}return submit;}()}]);return Store;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'offers',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:null}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'rejectMessage',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return'';}}),_applyDecoratedDescriptor(_class.prototype,'selectedBuyer',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'selectedBuyer'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'offersToReject',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'offersToReject'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'submit',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'submit'),_class.prototype)),_class);

/***/ }),
/* 2115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_office_ui_fabric_react_lib_TextField__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Localization__ = __webpack_require__(8);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__components_Localization__["a" /* localizable */])('ConfirmAwardStep1')(function(_ref){var t=_ref.t,_ref$store=_ref.store,rejectMessage=_ref$store.rejectMessage,handleRejectMessageChange=_ref$store.handleRejectMessageChange;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('ul',{className:'hint'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',null,t('This text will appear as an additional note'))),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_office_ui_fabric_react_lib_TextField__["a" /* TextField */],{label:t('Reject message'),multiline:true,name:'ag',value:rejectMessage,onChanged:handleRejectMessageChange})));}));

/***/ }),
/* 2116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_src_app_components_Money__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_BaseStep__ = __webpack_require__(68);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ConfirmAwardSummary=(_dec=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["d" /* inject */])('app'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_3__build_src_app_components_Localization__["a" /* localizable */])(_class=(_temp=_class2=function(_BaseStep){_inherits(ConfirmAwardSummary,_BaseStep);function ConfirmAwardSummary(){_classCallCheck(this,ConfirmAwardSummary);return _possibleConstructorReturn(this,(ConfirmAwardSummary.__proto__||Object.getPrototypeOf(ConfirmAwardSummary)).apply(this,arguments));}_createClass(ConfirmAwardSummary,[{key:'render',value:function render(){var _this2=this;var _props=this.props,_props$store=_props.store,selectedBuyer=_props$store.selectedBuyer,offersToReject=_props$store.offersToReject,rejectMessage=_props$store.rejectMessage,t=_props.t;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('h2',null,t('Summary')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('h2',null,t('Selected winner')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',null,this.renderBuyerName(selectedBuyer.item)),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',null,t('Offer'),':',' ',__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__build_src_app_components_Money__["a" /* default */],{value:selectedBuyer.submittedValue,currency:this.props.app.currency.code,locale:this.props.intl.locale})),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('h2',null,t('Rejected customers offers')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('ol',null,offersToReject&&offersToReject.map(function(i){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',{key:i.buyerId},_this2.renderBuyerName(i.item));})),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('h3',null,t('Additional information text')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('p',null,rejectMessage||__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('i',null,t('Not entered'))),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('p',null,t('If you click "Finish", you confirm the winner'),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('br',null),t('This action cannot be undone.')));}}]);return ConfirmAwardSummary;}(__WEBPACK_IMPORTED_MODULE_4__components_BaseStep__["a" /* default */]),_class2.displayName='ConfirmAwardSummary',_temp))||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (ConfirmAwardSummary);

/***/ }),
/* 2117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_request__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Step1__ = __webpack_require__(2118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Summary__ = __webpack_require__(2119);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var Store=(_class=function(){_createClass(Store,[{key:'eligibleOffersToReject',get:function get(){if(!this.offers)return[];return this.offers.filter(function(item){return item.status==='confirmed'||item.status==='accepted'||item.status==='awarded';}).sort(function(a,b){return b.submittedValue-a.submittedValue;});}},{key:'rejectedOfferDetails',get:function get(){var lookup=this.offers.reduce(function(acc,i){acc[i.buyerId]=i;return acc;},{});return this.rejectedOffers.map(function(o){return lookup[o];});}}]);function Store(management){_classCallCheck(this,Store);this.steps=[{key:'offers',title:'Choose offers to reject',implementation:__WEBPACK_IMPORTED_MODULE_3__Step1__["a" /* default */]}];_initDefineProp(this,'offers',_descriptor,this);_initDefineProp(this,'rejectedOffers',_descriptor2,this);_initDefineProp(this,'message',_descriptor3,this);this.summaryClass=__WEBPACK_IMPORTED_MODULE_4__Summary__["a" /* default */];this.offers=management.source.offers.viewModel.offers.map(function(item){return{item:item,buyerId:item.buyerId,name:item.buyer.buyer_lastName+', '+item.buyer.buyer_firstName,submittedValue:item.submittedValue,validity:item.data.offer_validity,status:item.status};});}_createClass(Store,[{key:'submit',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(saleId,token){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__services_request__["e" /* post */])('/api/v1/wizard/'+saleId+'/reject',{rejectOffers:this.rejectedOffers},token);case 2:case'end':return _context.stop();}}},_callee,this);}));function submit(_x,_x2){return _ref.apply(this,arguments);}return submit;}()}]);return Store;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'offers',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:null}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'rejectedOffers',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'message',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return'';}}),_applyDecoratedDescriptor(_class.prototype,'eligibleOffersToReject',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'eligibleOffersToReject'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'rejectedOfferDetails',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'rejectedOfferDetails'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'submit',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'submit'),_class.prototype)),_class);

/***/ }),
/* 2118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_DetailsList__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_src_app_components_Money__ = __webpack_require__(69);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var columns=function columns(t){return[{key:'name',name:t('Name'),fieldName:'name',minWidth:150,maxWidth:400,isSorted:true,isSortedDescending:false},{key:'submittedValue',name:t('Submitted value'),fieldName:'submittedValue',minWidth:100,maxWidth:150,isSorted:false,isSortedDescending:false},{key:'validity',name:t('Expiration date'),fieldName:'validity',minWidth:100,maxWidth:150,isSorted:false,isSortedDescending:false}];};var RejectOffersStep1=(_dec=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["d" /* inject */])('app'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_4__build_src_app_components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["e" /* observer */])(_class=(_temp=_class2=function(_Component){_inherits(RejectOffersStep1,_Component);function RejectOffersStep1(props){_classCallCheck(this,RejectOffersStep1);var _this=_possibleConstructorReturn(this,(RejectOffersStep1.__proto__||Object.getPrototypeOf(RejectOffersStep1)).call(this,props));_this.handleRenderItemColumn=function(item,_,column){var t=_this.props.t;var content=item[column.fieldName];switch(column.key){case'name':return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',null,_this.renderBuyerName(item.item));case'validity':return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,content?content.toFormatedDateString():'');case'submittedValue':return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_src_app_components_Money__["a" /* default */],{value:content,defaultValue:content==='hidden'?t(content):content,currency:_this.props.app.currency.code,locale:_this.props.intl.locale});default:return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',null,content);}};_this.handleSelectionChanged=function(){var store=_this.props.store;store.rejectedOffers=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.flatten(_this.selection.getSelection()).map(function(i){return i.buyerId;});};_this.selection=new __WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_DetailsList__["d" /* Selection */]({onSelectionChanged:_this.handleSelectionChanged});_this.selection.setModal(true);return _this;}_createClass(RejectOffersStep1,[{key:'render',value:function render(){var _props=this.props,store=_props.store,t=_props.t;var eligibleOffersToReject=store.eligibleOffersToReject;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('ul',{className:'hint'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',null,t('Select customers to reject theirs offer'))),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_DetailsList__["b" /* DetailsList */],{columns:columns(t),items:eligibleOffersToReject||[],selection:this.selection,onRenderItemColumn:this.handleRenderItemColumn,enterModalSelectionOnTouch:true,selectionPreservedOnEmptyClick:true,compact:true,layoutMode:__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_DetailsList__["c" /* DetailsListLayoutMode */].justified,selectionMode:__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_DetailsList__["e" /* SelectionMode */].multiple})));}}]);return RejectOffersStep1;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class2.displayName='RejectOffersStep1',_temp))||_class)||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (RejectOffersStep1);

/***/ }),
/* 2119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_BaseStep__ = __webpack_require__(68);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AwardSummary=(_dec=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["d" /* inject */])('app'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_2__build_src_app_components_Localization__["a" /* localizable */])(_class=(_temp=_class2=function(_BaseStep){_inherits(AwardSummary,_BaseStep);function AwardSummary(){_classCallCheck(this,AwardSummary);return _possibleConstructorReturn(this,(AwardSummary.__proto__||Object.getPrototypeOf(AwardSummary)).apply(this,arguments));}_createClass(AwardSummary,[{key:'render',value:function render(){var _this2=this;var _props=this.props,rejectedOfferDetails=_props.store.rejectedOfferDetails,t=_props.t;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('h2',null,t('Summary')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('h3',null,t('Rejected customers offers')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('ol',null,rejectedOfferDetails&&rejectedOfferDetails.map(function(i){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',{key:i.buyerId},_this2.renderBuyerName(i.item));})),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('p',null,t('If you click "Finish", you confirm the winner'),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('br',null),t('This action cannot be undone.')));}}]);return AwardSummary;}(__WEBPACK_IMPORTED_MODULE_3__components_BaseStep__["a" /* default */]),_class2.displayName='AwardSummary',_temp))||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (AwardSummary);

/***/ }),
/* 2120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Summary__ = __webpack_require__(2121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_src_app_services_request__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var Store=(_class=function(){function Store(management){var _this=this;_classCallCheck(this,Store);this.steps=[];_initDefineProp(this,'offers',_descriptor,this);_initDefineProp(this,'message',_descriptor2,this);this.summaryClass=__WEBPACK_IMPORTED_MODULE_2__Summary__["a" /* default */];this.handleMessageChange=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */])(function(value){_this.message=value;});this.offers=management.source.offers.viewModel.offers.map(function(item){return{item:item,buyerId:item.buyerId,name:item.buyer.buyer_lastName+', '+item.buyer.buyer_firstName,submittedValue:item.submittedValue,validity:item.data?item.data.offer_validity:null,status:item.status};});}_createClass(Store,[{key:'submit',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(saleId,token){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3__build_src_app_services_request__["e" /* post */])('/api/v1/wizard/'+saleId+'/rejectall',{message:this.message},token);case 2:case'end':return _context.stop();}}},_callee,this);}));function submit(_x,_x2){return _ref.apply(this,arguments);}return submit;}()}]);return Store;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'offers',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:null}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'message',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return'';}}),_applyDecoratedDescriptor(_class.prototype,'submit',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'submit'),_class.prototype)),_class);

/***/ }),
/* 2121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Localization__ = __webpack_require__(8);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__components_Localization__["a" /* localizable */])('RejectSummary')(function(_ref){var message=_ref.store.message,t=_ref.t;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('h2',null,t('Summary')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('p',null,t('Click "Finish" to reject all offers'),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('br',null),t('This action cannot be undone.')));}));

/***/ }),
/* 2122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Step1__ = __webpack_require__(2123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Step2__ = __webpack_require__(2124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Step3__ = __webpack_require__(2125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Summary__ = __webpack_require__(2126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_request__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__build_src_app_containers_Sale_RoundSection_stores_RoundEditStore__ = __webpack_require__(473);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var Store=(_class=function(){_createClass(Store,[{key:'rejectedOffers',get:function get(){var _this=this;return this.offers.filter(function(item){return!_this.acceptedOffers.some(function(i){return item.buyerId===i;});}).map(function(i){return i.buyerId;});}},{key:'acceptedOfferDetails',get:function get(){var lookup=this.offers.reduce(function(acc,i){acc[i.buyerId]=i;return acc;},{});return this.acceptedOffers.map(function(o){return lookup[o];});}},{key:'rejectedOfferDetails',get:function get(){var lookup=this.offers.reduce(function(acc,i){acc[i.buyerId]=i;return acc;},{});return this.rejectedOffers.map(function(o){return lookup[o];});}// @observable roundData = {
//   roundType: 'counteroffer_bidding',
//   durationType: 'fixed',
//   startingPrice: '',
//   estimate: '',
//   redButtonPrice: '',
//   endsAt: '',
//   offerValidityUntil: '',
//   durationInDays: defaultDurationInDays,
//   offerValidityInDays:
//     defaultDurationInDays + defaultOfferValidityExtensionInDays,
// };
}]);function Store(management){var _this2=this;_classCallCheck(this,Store);_initDefineProp(this,'offers',_descriptor,this);_initDefineProp(this,'eligibleOffers',_descriptor2,this);_initDefineProp(this,'acceptedOffers',_descriptor3,this);_initDefineProp(this,'buyerMessage',_descriptor4,this);this.roundEditStore=null;this.steps=[{key:'offers',title:'Choose offers for next round',implementation:__WEBPACK_IMPORTED_MODULE_2__Step1__["a" /* default */]},{key:'round',title:'Next round details',implementation:__WEBPACK_IMPORTED_MODULE_3__Step2__["a" /* default */]},{key:'message',title:'Message to buyers',implementation:__WEBPACK_IMPORTED_MODULE_4__Step3__["a" /* default */]}];this.summaryClass=__WEBPACK_IMPORTED_MODULE_5__Summary__["a" /* default */];this.handleBuyerMessageChange=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */])(function(value){_this2.buyerMessage=value;});this.offers=management.source.offers.viewModel.offers.map(function(item){return{item:item,buyerId:item.buyerId,name:item.buyer.buyer_lastName+', '+item.buyer.buyer_firstName,submittedValue:item.submittedValue,validity:item.data.offer_validity,status:item.status};});this.eligibleOffers=this.offers.filter(function(item){return item.status!=='block'&&item.status!=='rejected';});var round=management.source.round.definition;this.roundEditStore=new __WEBPACK_IMPORTED_MODULE_7__build_src_app_containers_Sale_RoundSection_stores_RoundEditStore__["a" /* default */](round,management.source.saleEdit.root.saleConfig);this.roundEditStore.round.type='counteroffer_bidding';}_createClass(Store,[{key:'submit',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(saleId,token){var lookup,round,accepted;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:lookup=this.offers.reduce(function(acc,i){acc[i.buyerId]=i;return acc;},{});round=this.roundEditStore.saveableRound;accepted=this.acceptedOffers.map(function(o){return lookup[o];}).filter(function(o){return o.status==='confirmed'||o.status==='accepted';}).map(function(o){return o.buyerId;});_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_6__services_request__["e" /* post */])('/api/v1/wizard/'+saleId+'/counteroffer',{round:Object.assign({},round,{message:this.buyerMessage}),acceptOffers:accepted,rejectOffers:this.rejectedOffers},token);case 5:case'end':return _context.stop();}}},_callee,this);}));function submit(_x,_x2){return _ref.apply(this,arguments);}return submit;}()}]);return Store;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'offers',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:null}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'eligibleOffers',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:null}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'acceptedOffers',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}}),_applyDecoratedDescriptor(_class.prototype,'rejectedOffers',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'rejectedOffers'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'acceptedOfferDetails',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'acceptedOfferDetails'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'rejectedOfferDetails',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'rejectedOfferDetails'),_class.prototype),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'buyerMessage',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return'';}}),_applyDecoratedDescriptor(_class.prototype,'submit',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'submit'),_class.prototype)),_class);

/***/ }),
/* 2123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_DetailsList__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_src_app_components_Money__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_BaseStep__ = __webpack_require__(68);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var columns=function columns(t){return[{key:'name',name:t('Name'),fieldName:'name',minWidth:150,maxWidth:400,isSorted:true,isSortedDescending:false},{key:'submittedValue',name:t('Submitted value'),fieldName:'submittedValue',minWidth:100,maxWidth:150,isSorted:false,isSortedDescending:false},{key:'validity',name:t('Expiration date'),fieldName:'validity',minWidth:100,maxWidth:150,isSorted:false,isSortedDescending:false}];};var IncreaseStep1=(_dec=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["d" /* inject */])('app'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_4__build_src_app_components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["e" /* observer */])(_class=(_temp=_class2=function(_BaseStep){_inherits(IncreaseStep1,_BaseStep);function IncreaseStep1(props){_classCallCheck(this,IncreaseStep1);var _this=_possibleConstructorReturn(this,(IncreaseStep1.__proto__||Object.getPrototypeOf(IncreaseStep1)).call(this,props));_this.handleRenderItemColumn=function(item,_,column){var t=_this.props.t;var content=item[column.fieldName];switch(column.key){case'name':return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',null,_this.renderBuyerName(item.item));case'validity':return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,content?content.toFormatedDateString():'');case'submittedValue':return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_src_app_components_Money__["a" /* default */],{value:content,defaultValue:content==='hidden'?t(content):content,currency:_this.props.app.currency.code,locale:_this.props.intl.locale});default:return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',null,content);}};_this.handleSelectionChanged=function(){var store=_this.props.store;store.acceptedOffers=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.flatten(_this.selection.getSelection()).map(function(i){return i.buyerId;});};_this.selection=new __WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_DetailsList__["d" /* Selection */]({onSelectionChanged:_this.handleSelectionChanged});_this.selection.setModal(true);return _this;}_createClass(IncreaseStep1,[{key:'render',value:function render(){var _props=this.props,store=_props.store,t=_props.t;var eligibleOffers=store.eligibleOffers;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('ul',{className:'hint'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',null,t('Select customers')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',null,t('All other offers will be rejected')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',null,t('Invite more customers after start of next round'))),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_DetailsList__["b" /* DetailsList */],{columns:columns(t),items:eligibleOffers||[],selection:this.selection,onRenderItemColumn:this.handleRenderItemColumn,enterModalSelectionOnTouch:true,selectionPreservedOnEmptyClick:true,compact:true,layoutMode:__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_DetailsList__["c" /* DetailsListLayoutMode */].justified,selectionMode:__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_DetailsList__["e" /* SelectionMode */].single})));}}]);return IncreaseStep1;}(__WEBPACK_IMPORTED_MODULE_6__components_BaseStep__["a" /* default */]),_class2.displayName='IncreaseStep1',_temp))||_class)||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (IncreaseStep1);

/***/ }),
/* 2124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sale_RoundSection_RoundEdit__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Localization__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CounterofferStep2=Object(__WEBPACK_IMPORTED_MODULE_2__components_Localization__["a" /* localizable */])(_class=(_temp=_class2=function(_Component){_inherits(CounterofferStep2,_Component);function CounterofferStep2(){_classCallCheck(this,CounterofferStep2);return _possibleConstructorReturn(this,(CounterofferStep2.__proto__||Object.getPrototypeOf(CounterofferStep2)).apply(this,arguments));}_createClass(CounterofferStep2,[{key:'render',value:function render(){var _props=this.props,roundEditStore=_props.store.roundEditStore,t=_props.t;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('ul',{className:'hint'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',null,t('Please define the next round.')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',null,t('Validity of offers set to the same value'))),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Sale_RoundSection_RoundEdit__["a" /* default */],{store:roundEditStore,allowedRounds:["counteroffer_bidding"]})));}}]);return CounterofferStep2;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class2.displayName='CounterofferStep2',_temp))||_class;/* harmony default export */ __webpack_exports__["a"] = (CounterofferStep2);

/***/ }),
/* 2125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_office_ui_fabric_react_lib_TextField__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Localization__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var IncreaseStep3=Object(__WEBPACK_IMPORTED_MODULE_2__components_Localization__["a" /* localizable */])(_class=(_temp=_class2=function(_Component){_inherits(IncreaseStep3,_Component);function IncreaseStep3(){_classCallCheck(this,IncreaseStep3);return _possibleConstructorReturn(this,(IncreaseStep3.__proto__||Object.getPrototypeOf(IncreaseStep3)).apply(this,arguments));}_createClass(IncreaseStep3,[{key:'render',value:function render(){var _props=this.props,_props$store=_props.store,buyerMessage=_props$store.buyerMessage,handleBuyerMessageChange=_props$store.handleBuyerMessageChange,t=_props.t;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('ul',{className:'hint'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',null,t('This text will appear as an additional note'))),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_office_ui_fabric_react_lib_TextField__["a" /* TextField */],{label:t('Message'),multiline:true,name:'ag',value:buyerMessage,onChanged:handleBuyerMessageChange})));}}]);return IncreaseStep3;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class2.displayName='IncreaseStep3',_temp))||_class;/* harmony default export */ __webpack_exports__["a"] = (IncreaseStep3);

/***/ }),
/* 2126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_RoundInfo__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_BaseStep__ = __webpack_require__(68);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CounterofferSummary=Object(__WEBPACK_IMPORTED_MODULE_1__components_Localization__["a" /* localizable */])(_class=(_temp=_class2=function(_BaseStep){_inherits(CounterofferSummary,_BaseStep);function CounterofferSummary(){_classCallCheck(this,CounterofferSummary);return _possibleConstructorReturn(this,(CounterofferSummary.__proto__||Object.getPrototypeOf(CounterofferSummary)).apply(this,arguments));}_createClass(CounterofferSummary,[{key:'render',value:function render(){var _this2=this;var _props=this.props,_props$store=_props.store,acceptedOfferDetails=_props$store.acceptedOfferDetails,rejectedOfferDetails=_props$store.rejectedOfferDetails,buyerMessage=_props$store.buyerMessage,roundEditStore=_props$store.roundEditStore,t=_props.t;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('h2',null,t('Summary')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('h3',null,t('Customers for the next round')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('ol',null,acceptedOfferDetails&&acceptedOfferDetails.map(function(i){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',{key:i.buyerId},_this2.renderBuyerName(i.item));})),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('h3',null,t('Customers not participating in the next round')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('ol',null,rejectedOfferDetails&&rejectedOfferDetails.map(function(i){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',{key:i.buyerId},_this2.renderBuyerName(i.item));})),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('h3',null,t('Additional information text')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('p',null,buyerMessage||__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('i',null,t('not entered'))),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('h3',null,t('Round details')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_RoundInfo__["a" /* default */],{round:roundEditStore.round}),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('p',null,t('Click "Finish" to start a new round'),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('br',null),t('This action cannot be undone.')));}}]);return CounterofferSummary;}(__WEBPACK_IMPORTED_MODULE_3__components_BaseStep__["a" /* default */]),_class2.displayName='CounterofferSummary',_temp))||_class;/* harmony default export */ __webpack_exports__["a"] = (CounterofferSummary);

/***/ }),
/* 2127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Step1__ = __webpack_require__(2128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Summary__ = __webpack_require__(2129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_src_app_services_request__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var Store=(_class=function(){function Store(management){var _this=this;_classCallCheck(this,Store);this.steps=[{key:'message',title:'Message to seller',implementation:__WEBPACK_IMPORTED_MODULE_2__Step1__["a" /* default */]}];_initDefineProp(this,'message',_descriptor,this);this.summaryClass=__WEBPACK_IMPORTED_MODULE_3__Summary__["a" /* default */];this.handleMessageChange=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */])(function(value){_this.message=value;});this.sale=management.source;}_createClass(Store,[{key:'submit',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(saleId,token){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_4__build_src_app_services_request__["e" /* post */])('/api/v1/wizard/'+saleId+'/notifyseller',{message:this.message},token);case 2:case'end':return _context.stop();}}},_callee,this);}));function submit(_x,_x2){return _ref.apply(this,arguments);}return submit;}()},{key:'offers',get:function get(){return this.sale.offers.accessibleOffers.map(function(item){return{item:item,buyerId:item.buyerId,name:item.buyer.buyer_lastName+', '+item.buyer.buyer_firstName,submittedValue:item.submittedValue,validity:item.data.offer_validity,status:item.status};});}}]);return Store;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'message',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return'';}}),_applyDecoratedDescriptor(_class.prototype,'offers',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'offers'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'submit',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'submit'),_class.prototype)),_class);

/***/ }),
/* 2128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_office_ui_fabric_react_lib_TextField__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Localization__ = __webpack_require__(8);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__components_Localization__["a" /* localizable */])('NotifySeller')(function(_ref){var t=_ref.t,_ref$store=_ref.store,message=_ref$store.message,handleMessageChange=_ref$store.handleMessageChange;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('ul',{className:'hint'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',null,t('This text will appear as an additional note'))),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'control'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_office_ui_fabric_react_lib_TextField__["a" /* TextField */],{label:t('Message'),multiline:true,name:'ag',value:message,onChanged:handleMessageChange})));}));

/***/ }),
/* 2129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_BaseStep__ = __webpack_require__(68);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NotifySellerSummary=Object(__WEBPACK_IMPORTED_MODULE_1__components_Localization__["a" /* localizable */])(_class=(_temp=_class2=function(_BaseStep){_inherits(NotifySellerSummary,_BaseStep);function NotifySellerSummary(){_classCallCheck(this,NotifySellerSummary);return _possibleConstructorReturn(this,(NotifySellerSummary.__proto__||Object.getPrototypeOf(NotifySellerSummary)).apply(this,arguments));}_createClass(NotifySellerSummary,[{key:'render',value:function render(){var _this2=this;var _props=this.props,store=_props.store,t=_props.t;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('h2',null,t('Summary')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',null,t('description')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('ol',null,store.offers.map(function(i){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',{key:i.buyerId},_this2.renderBuyerName(i.item));})),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('h3',null,t('Message to seller')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('p',null,store.message||__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('i',null,t('Not entered'))));}}]);return NotifySellerSummary;}(__WEBPACK_IMPORTED_MODULE_2__components_BaseStep__["a" /* default */]),_class2.displayName='NotifySellerSummary',_temp))||_class;/* harmony default export */ __webpack_exports__["a"] = (NotifySellerSummary);

/***/ }),
/* 2130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Routes__ = __webpack_require__(2131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_src_app_components_LoadingOverlay__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_src_app_locales__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__build_node_modules_moment_locale_de__ = __webpack_require__(2305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__build_node_modules_moment_locale_de___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__build_node_modules_moment_locale_de__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__build_node_modules_moment_locale_es__ = __webpack_require__(2306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__build_node_modules_moment_locale_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__build_node_modules_moment_locale_es__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__build_node_modules_moment_locale_fi__ = __webpack_require__(2307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__build_node_modules_moment_locale_fi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__build_node_modules_moment_locale_fi__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__build_node_modules_moment_locale_fr__ = __webpack_require__(2308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__build_node_modules_moment_locale_fr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__build_node_modules_moment_locale_fr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__build_node_modules_moment_locale_it__ = __webpack_require__(2309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__build_node_modules_moment_locale_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__build_node_modules_moment_locale_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__build_node_modules_moment_locale_si__ = __webpack_require__(2310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__build_node_modules_moment_locale_si___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__build_node_modules_moment_locale_si__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__build_src_app_components_Localization_LocalizationAssistant_css__ = __webpack_require__(2311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__build_src_app_components_Localization_LocalizationAssistant_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__build_src_app_components_Localization_LocalizationAssistant_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__build_src_app_components_Localization_LocalizationAssistant_js__ = __webpack_require__(2312);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var defineLocale=function defineLocale(locale){if(!!__WEBPACK_IMPORTED_MODULE_6__build_src_app_locales__["a" /* default */].locales[locale]&&!!__WEBPACK_IMPORTED_MODULE_6__build_src_app_locales__["a" /* default */].locales[locale].moment){__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default.a.defineLocale(locale,__WEBPACK_IMPORTED_MODULE_6__build_src_app_locales__["a" /* default */].locales[locale].moment);}else{__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default.a.locale(locale);}};var App=(_dec=Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__["d" /* inject */])('app','user'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__["e" /* observer */])(_class=(_temp=_class2=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).apply(this,arguments));}_createClass(App,[{key:'componentWillMount',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(){var app;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.t0="propnow";_context.next=_context.t0==='amarc21'?3:_context.t0==='remax-at'?6:_context.t0==='remax-it'?9:_context.t0==='remax-de'?14:_context.t0==='remax-ro'?17:20;break;case 3:__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default.a.updateLocale('en',__WEBPACK_IMPORTED_MODULE_6__build_src_app_locales__["a" /* default */].locales.en.moment);__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default.a.defineLocale('de',__WEBPACK_IMPORTED_MODULE_6__build_src_app_locales__["a" /* default */].locales.de.moment);return _context.abrupt('break',27);case 6:__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default.a.defineLocale('de',__WEBPACK_IMPORTED_MODULE_6__build_src_app_locales__["a" /* default */].locales.de.moment);__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default.a.updateLocale('en',__WEBPACK_IMPORTED_MODULE_6__build_src_app_locales__["a" /* default */].locales.en.moment);return _context.abrupt('break',27);case 9:__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default.a.updateLocale('en',__WEBPACK_IMPORTED_MODULE_6__build_src_app_locales__["a" /* default */].locales.en.moment);__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default.a.defineLocale('de',__WEBPACK_IMPORTED_MODULE_6__build_src_app_locales__["a" /* default */].locales.de.moment);__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default.a.defineLocale('fr',__WEBPACK_IMPORTED_MODULE_6__build_src_app_locales__["a" /* default */].locales.fr.moment);__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default.a.defineLocale('it',__WEBPACK_IMPORTED_MODULE_6__build_src_app_locales__["a" /* default */].locales.it.moment);return _context.abrupt('break',27);case 14:__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default.a.updateLocale('en',__WEBPACK_IMPORTED_MODULE_6__build_src_app_locales__["a" /* default */].locales.en.moment);__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default.a.defineLocale('de',__WEBPACK_IMPORTED_MODULE_6__build_src_app_locales__["a" /* default */].locales.de.moment);return _context.abrupt('break',27);case 17:__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default.a.updateLocale('en',__WEBPACK_IMPORTED_MODULE_6__build_src_app_locales__["a" /* default */].locales.en.moment);__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default.a.defineLocale('ro',__WEBPACK_IMPORTED_MODULE_6__build_src_app_locales__["a" /* default */].locales.ro.moment);return _context.abrupt('break',27);case 20:__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default.a.defineLocale('de',__WEBPACK_IMPORTED_MODULE_6__build_src_app_locales__["a" /* default */].locales.de.moment);defineLocale('fi');defineLocale('en-ZA');// defineLocale('es');
__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default.a.defineLocale('es',__WEBPACK_IMPORTED_MODULE_6__build_src_app_locales__["a" /* default */].locales.es.moment);__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default.a.defineLocale('sl',__WEBPACK_IMPORTED_MODULE_6__build_src_app_locales__["a" /* default */].locales.sl.moment);__WEBPACK_IMPORTED_MODULE_3__build_node_modules_moment_timezone___default.a.defineLocale('sl-SI',__WEBPACK_IMPORTED_MODULE_6__build_src_app_locales__["a" /* default */].locales.sl.moment);return _context.abrupt('break',27);case 27:app=this.props.app;if(!app.ready){app.init();}case 29:case'end':return _context.stop();}}},_callee,this);}));function componentWillMount(){return _ref.apply(this,arguments);}return componentWillMount;}()},{key:'componentDidMount',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if("false"===true||"false"==='true'){window.LocalizationAssistant_Url="https://translate.lingohub.com/auctiontech/editor?q={key}&targetLocale={locale}&project=dav-slash-dashboard";setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_14__build_src_app_components_Localization_LocalizationAssistant_js__["b" /* LocalizationAssistant_Parse */])(document.body);this.observer=new MutationObserver(__WEBPACK_IMPORTED_MODULE_14__build_src_app_components_Localization_LocalizationAssistant_js__["a" /* LocalizationAssistant_MutationObserver_Callback */]);this.observer.observe(document.body,{childList:true,attributes:true,subtree:true});},100);}case 1:case'end':return _context2.stop();}}},_callee2,this);}));function componentDidMount(){return _ref2.apply(this,arguments);}return componentDidMount;}()},{key:'componentWillUnmount',value:function componentWillUnmount(){if(this.observer){this.observer.disconnect();this.observer=null;}}},{key:'render',value:function render(){var app=this.props.app;return!app.ready?__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_src_app_components_LoadingOverlay__["a" /* default */],{fullscreen:true}):__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Routes__["a" /* default */],{history:app.history});}}]);return App;}(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__["Component"]),_class2.displayName='App',_temp))||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 2131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react_router_dom__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dashboard__ = __webpack_require__(2145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Callback__ = __webpack_require__(2303);
var Routes=function Routes(_ref){var history=_ref.history;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react_router_dom__["b" /* Router */],{history:history},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react_router_dom__["c" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react_router_dom__["a" /* Route */],{path:'/dashboard',component:__WEBPACK_IMPORTED_MODULE_2__Dashboard__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react_router_dom__["a" /* Route */],{exact:true,path:'/callback',component:__WEBPACK_IMPORTED_MODULE_3__Callback__["a" /* default */]})));};/* harmony default export */ __webpack_exports__["a"] = (Routes);

/***/ }),
/* 2132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(474);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (BrowserRouter);

/***/ }),
/* 2133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(474);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 2134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(845);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 2135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(844);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* unused harmony default export */ var _unused_webpack_default_export = (NavLink);

/***/ }),
/* 2136 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 2137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(848);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 2138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(849);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 2139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(850);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 2140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(851);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 2141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(476);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 2142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(282);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 2143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(852);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 2144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 2145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_styled_components__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_react_helmet__ = __webpack_require__(2146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Routes__ = __webpack_require__(2149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_Fabric__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__build_node_modules_uifabric_icons__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__build_node_modules_office_ui_fabric_react_lib_Link__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__build_node_modules_office_ui_fabric_react_lib_Callout__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__build_src_app_components_Prompt__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__build_src_app_components_AuthWrapper__ = __webpack_require__(2279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__build_src_app_components_IntlWrapper__ = __webpack_require__(2280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_css__ = __webpack_require__(2298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Watermark__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__build_src_app_components_dynamicImport__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__helpers_colors__ = __webpack_require__(2299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__build_node_modules_office_ui_fabric_react__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__build_node_modules_js_cookie__ = __webpack_require__(2302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__build_node_modules_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__build_node_modules_js_cookie__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2,_descriptor,_descriptor2,_class3,_temp2;var _templateObject=_taggedTemplateLiteral(['\n  display: grid;\n  align-content: stretch;\n  grid-template-columns: 10em auto 25em;\n  grid-template-rows: 3em 3em auto;\n  grid-template-areas:\n    \'logo title identity\'\n    \'menu menu menu\'\n    \'content content content\';\n\n  > .content-without-menu {\n    grid-column: 1 / span 3;\n    grid-row: 2 / span 2;\n    position: relative;\n  }\n\n  > .title {\n    grid-area: title;\n    background: ',';\n    color: ',';\n    padding: 0.2em 0.5em;\n\n    display: grid;\n    grid-template-columns: min-content minmax(0, min-content) minmax(\n        auto,\n        max-content\n      );\n    grid-column-gap: 0.5em;\n    grid-template-areas: \'back collapsible label\';\n\n    .back {\n      grid-area: back;\n      padding-top: 0.15em;\n      span {\n        display: none;\n      }\n    }\n\n    &,\n    * {\n      font-size: 1.5rem;\n      line-height: 1.5;\n      font-weight: 500;\n    }\n\n    > * {\n      display: block;\n      white-space: nowrap;\n    }\n\n    .collapsible {\n      grid-area: collapsible;\n      flex-shrink: 1;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      text-align: left;\n    }\n\n    .label {\n      grid-area: label;\n    }\n\n    a {\n      cursor: pointer;\n    }\n  }\n\n  @media only screen and (min-height: 400px) {\n    height: 100vh;\n\n    > .content {\n      overflow: auto;\n    }\n  }\n\n  @media only screen and (max-width: 1023px) {\n    grid-template-columns: 6em 1fr;\n    grid-template-rows: 2em min-content 3em auto;\n    grid-template-areas:\n      \'logo identity\'\n      \'title title\'\n      \'menu menu\'\n      \'content content\';\n\n    .content-without-menu {\n      grid-row: 3 / span 2;\n    }\n  }\n\n  @media only screen and (max-width: 479px) {\n    .title {\n      grid-template-columns: min-content auto;\n      grid-template-rows: repeat(auto, 2);\n      grid-column-gap: 0.2em;\n      grid-template-areas:\n        \'back collapsible\'\n        \'label label\';\n    }\n    .identity {\n      font-size: 14px;\n    }\n  }\n\n  > .identity {\n    grid-area: identity;\n    background: ',';\n    padding-right: 0.5em;\n\n    display: flex;\n    flex-flow: row nowrap;\n    justify-content: flex-end;\n    align-items: center;\n    color: ',';\n\n    > span {\n      margin-right: 1em;\n    }\n\n    > * {\n      color: ',';\n    }\n  }\n\n  > .logo {\n    grid-area: logo;\n    background: ',';\n    display: flex;\n    align-items: center;\n    padding-left: 0.5em;\n    img {\n      max-height: 75%;\n      max-width: 100%;\n    }\n  }\n\n  > .menu {\n    grid-area: menu;\n  }\n\n  > .content {\n    grid-area: content;\n    position: relative;\n  }\n'],['\n  display: grid;\n  align-content: stretch;\n  grid-template-columns: 10em auto 25em;\n  grid-template-rows: 3em 3em auto;\n  grid-template-areas:\n    \'logo title identity\'\n    \'menu menu menu\'\n    \'content content content\';\n\n  > .content-without-menu {\n    grid-column: 1 / span 3;\n    grid-row: 2 / span 2;\n    position: relative;\n  }\n\n  > .title {\n    grid-area: title;\n    background: ',';\n    color: ',';\n    padding: 0.2em 0.5em;\n\n    display: grid;\n    grid-template-columns: min-content minmax(0, min-content) minmax(\n        auto,\n        max-content\n      );\n    grid-column-gap: 0.5em;\n    grid-template-areas: \'back collapsible label\';\n\n    .back {\n      grid-area: back;\n      padding-top: 0.15em;\n      span {\n        display: none;\n      }\n    }\n\n    &,\n    * {\n      font-size: 1.5rem;\n      line-height: 1.5;\n      font-weight: 500;\n    }\n\n    > * {\n      display: block;\n      white-space: nowrap;\n    }\n\n    .collapsible {\n      grid-area: collapsible;\n      flex-shrink: 1;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      text-align: left;\n    }\n\n    .label {\n      grid-area: label;\n    }\n\n    a {\n      cursor: pointer;\n    }\n  }\n\n  @media only screen and (min-height: 400px) {\n    height: 100vh;\n\n    > .content {\n      overflow: auto;\n    }\n  }\n\n  @media only screen and (max-width: 1023px) {\n    grid-template-columns: 6em 1fr;\n    grid-template-rows: 2em min-content 3em auto;\n    grid-template-areas:\n      \'logo identity\'\n      \'title title\'\n      \'menu menu\'\n      \'content content\';\n\n    .content-without-menu {\n      grid-row: 3 / span 2;\n    }\n  }\n\n  @media only screen and (max-width: 479px) {\n    .title {\n      grid-template-columns: min-content auto;\n      grid-template-rows: repeat(auto, 2);\n      grid-column-gap: 0.2em;\n      grid-template-areas:\n        \'back collapsible\'\n        \'label label\';\n    }\n    .identity {\n      font-size: 14px;\n    }\n  }\n\n  > .identity {\n    grid-area: identity;\n    background: ',';\n    padding-right: 0.5em;\n\n    display: flex;\n    flex-flow: row nowrap;\n    justify-content: flex-end;\n    align-items: center;\n    color: ',';\n\n    > span {\n      margin-right: 1em;\n    }\n\n    > * {\n      color: ',';\n    }\n  }\n\n  > .logo {\n    grid-area: logo;\n    background: ',';\n    display: flex;\n    align-items: center;\n    padding-left: 0.5em;\n    img {\n      max-height: 75%;\n      max-width: 100%;\n    }\n  }\n\n  > .menu {\n    grid-area: menu;\n  }\n\n  > .content {\n    grid-area: content;\n    position: relative;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  padding: 1em;\n  @media screen and (max-width: 479px) {\n    left: 0 !important;\n    width: 100%;\n  }\n'],['\n  padding: 1em;\n  @media screen and (max-width: 479px) {\n    left: 0 !important;\n    width: 100%;\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Logo=Object(__WEBPACK_IMPORTED_MODULE_17__build_src_app_components_dynamicImport__["b" /* default */])({component:'/components/Logo'});Object(__WEBPACK_IMPORTED_MODULE_8__build_node_modules_uifabric_icons__["a" /* initializeIcons */])();//loadTheme({ ...theme });
var Wrapper=Object(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_styled_components__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_Fabric__["a" /* Fabric */])(_templateObject,function(_ref){var theme=_ref.theme;return theme.palette.themeSecondary||theme.palette.themePrimary;},function(_ref2){var theme=_ref2.theme;return Object(__WEBPACK_IMPORTED_MODULE_18__helpers_colors__["a" /* getContrastText */])(theme.palette.themeSecondary||theme.palette.themePrimary);},function(_ref3){var theme=_ref3.theme;return theme.palette.themeSecondary||theme.palette.themePrimary;},function(_ref4){var theme=_ref4.theme;return Object(__WEBPACK_IMPORTED_MODULE_18__helpers_colors__["a" /* getContrastText */])(theme.palette.themeSecondary||theme.palette.themePrimary);},function(_ref5){var theme=_ref5.theme;return Object(__WEBPACK_IMPORTED_MODULE_18__helpers_colors__["a" /* getContrastText */])(theme.palette.themeSecondary||theme.palette.themePrimary);},function(_ref6){var theme=_ref6.theme;return theme.palette.themeSecondary||theme.palette.themePrimary;});var SupportCallout=Object(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_styled_components__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_10__build_node_modules_office_ui_fabric_react_lib_Callout__["a" /* Callout */])(_templateObject2);var Dashboard=(_dec=Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__["d" /* inject */])('app','user'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_11__build_src_app_components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__["e" /* observer */])(_class=(_class2=(_temp2=_class3=function(_Component){_inherits(Dashboard,_Component);function Dashboard(){var _ref7,_this2=this;var _temp,_this,_ret;_classCallCheck(this,Dashboard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref7=Dashboard.__proto__||Object.getPrototypeOf(Dashboard)).call.apply(_ref7,[this].concat(args))),_this),_initDefineProp(_this,'showSignoutPrompt',_descriptor,_this),_this.handleSignoutPrompt=function(){_this.showSignoutPrompt=!_this.showSignoutPrompt;},_this.handleSwitchDashboard=function(){__WEBPACK_IMPORTED_MODULE_20__build_node_modules_js_cookie___default.a.set('dashboard2','true',{expires:365});window.location.href='/dashboard';window.location.reload();},_this.handleSignout=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(){var _this$props,user,app,result;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.showSignoutPrompt=false;_this$props=_this.props,user=_this$props.user,app=_this$props.app;_context.next=4;return user.signout();case 4:result=_context.sent;if(result&&result.redirect){window.location.href=app.config.oidc.authority+'/signout';}case 6:case'end':return _context.stop();}}},_callee,_this2);})),_initDefineProp(_this,'calloutVisible',_descriptor2,_this),_this.handleCalloutToggle=Object(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["c" /* action */])(function(){_this.calloutVisible=!_this.calloutVisible;}),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Dashboard,[{key:'componentWillUnmount',value:function componentWillUnmount(){this.showSignoutPrompt=false;}},{key:'render',value:function render(){var _this3=this;var _props=this.props,app=_props.app,user=_props.user,t=_props.t;var watermark=app.config.watermark&&app.config.watermark!==''?app.config.watermark:null;var name=user.profile.family_name?user.profile.given_name+' '+user.profile.family_name:user.profile.name;return __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(Wrapper,{className:'dashboard',theme:app.theme},app.data?__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_react_helmet__["a" /* Helmet */],null,!!user.claims.locale&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('html',{lang:user.claims.locale}),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('title',null,t('page_title',{friendly_name:app.data.friendly_name})),!!app.theme.favicon_url&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('link',{rel:'icon',href:app.theme.favicon_url,sizes:'16x16'})):null,watermark&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_Watermark__["a" /* default */],null,watermark),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('a',{href:'/dashboard',className:'logo'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(Logo,{url:app.theme.logo_url})),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'identity'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('i',{className:'ms-Icon ms-Icon--Contact','aria-hidden':'true'}),' ',name),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('i',{className:'ms-Icon ms-Icon--Help',style:{cursor:'pointer'},ref:function ref(element){return _this3.supportIcon=element;},onClick:this.handleCalloutToggle,'aria-hidden':'true',title:'Hilfe'})),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__build_node_modules_office_ui_fabric_react_lib_Link__["Link"],{onClick:this.handleSignoutPrompt},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('i',{className:'ms-Icon ms-Icon--SignOut','aria-hidden':'true'}),' ',t('Log out')),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__build_src_app_components_Prompt__["a" /* default */],{title:t('Log out'),message:t('Do you really want to log out?'),opened:this.showSignoutPrompt,onSubmit:this.handleSignout,onClose:this.handleSignoutPrompt}),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(SupportCallout,{role:'alertdialog',gapSpace:0,target:this.supportIcon,onDismiss:this.handleCalloutToggle,setInitialFocus:true,hidden:!this.calloutVisible},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-font-l ms-fontWeight-semibold',style:{color:app.theme.palette.themePrimary}},t('Customer service contact'),':'),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('p',null,t('Customer service p')),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('a',{href:'https://support.propnow.com/de/help',target:'_blank',rel:'noopener noreferrer',style:{float:'left',width:'5rem',height:'2.7rem',border:'1px solid #777',borderRadius:'3px',textAlign:'center',margin:'0 1rem 0 0.2rem',justifyContent:'center',alignItems:'center',textDecoration:'none',display:'flex',color:'#333'}},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('span',null,'F.A.Q.')),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',null,t('Tel'),':',' ',__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('a',{href:'tel:'+t('customer_service_telephone_href')},t('customer_service_telephone'))),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',null,t('E-Mail'),':',' ',__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('a',{href:'mailto:'+t('customer_service_email')},t('customer_service_email'))),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__build_node_modules_office_ui_fabric_react__["f" /* Icon */],{title:'Zu neuen Dashboard wechseln (beta)',iconName:'AirTickets',onClick:this.handleSwitchDashboard}))))),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Routes__["a" /* default */],null));}}]);return Dashboard;}(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__["Component"]),_class3.displayName='Dashboard',_temp2),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'showSignoutPrompt',[__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,'calloutVisible',[__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}})),_class2))||_class)||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_13__build_src_app_components_AuthWrapper__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_14__build_src_app_components_IntlWrapper__["a" /* default */])(Dashboard)));

/***/ }),
/* 2146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HelmetExport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_side_effect__ = __webpack_require__(2147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_side_effect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_side_effect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fast_compare__ = __webpack_require__(2148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fast_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_fast_compare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_object_assign__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_object_assign__);






var ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};

var TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};

var VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
    return TAG_NAMES[name];
});

var TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src",
    TARGET: "target"
};

var REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};

var HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};

var HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
    obj[REACT_TAG_MAP[key]] = key;
    return obj;
}, {});

var SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];

var HELMET_ATTRIBUTE = "data-react-helmet";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (encode === false) {
        return String(str);
    }

    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, TAG_NAMES.TITLE);
    var innermostTemplate = getInnermostProperty(propsList, HELMET_PROPS.TITLE_TEMPLATE);

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, HELMET_PROPS.DEFAULT_TITLE);

    return innermostTitle || innermostDefaultTitle || undefined;
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        if (Array.isArray(props[tagName])) {
            return true;
        }
        if (typeof props[tagName] !== "undefined") {
            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
        }
        return false;
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === TAG_PROPERTIES.INNER_HTML || attributeKey === TAG_PROPERTIES.CSS_TEXT || attributeKey === TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = __WEBPACK_IMPORTED_MODULE_4_object_assign___default()({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props.hasOwnProperty(property)) {
            return props[property];
        }
    }

    return null;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: getBaseTagFromPropsList([TAG_PROPERTIES.HREF, TAG_PROPERTIES.TARGET], propsList),
        bodyAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.BODY, propsList),
        defer: getInnermostProperty(propsList, HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: getTagsFromPropsList(TAG_NAMES.LINK, [TAG_PROPERTIES.REL, TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(TAG_NAMES.META, [TAG_PROPERTIES.NAME, TAG_PROPERTIES.CHARSET, TAG_PROPERTIES.HTTPEQUIV, TAG_PROPERTIES.PROPERTY, TAG_PROPERTIES.ITEM_PROP], propsList),
        noscriptTags: getTagsFromPropsList(TAG_NAMES.NOSCRIPT, [TAG_PROPERTIES.INNER_HTML], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList(TAG_NAMES.SCRIPT, [TAG_PROPERTIES.SRC, TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(TAG_NAMES.STYLE, [TAG_PROPERTIES.CSS_TEXT], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.TITLE, propsList)
    };
};

var rafPolyfill = function () {
    var clock = Date.now();

    return function (callback) {
        var currentTime = Date.now();

        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else {
            setTimeout(function () {
                rafPolyfill(callback);
            }, 0);
        }
    };
}();

var cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};

var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;

var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;

var warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};

var _helmetCallback = null;

var handleClientStateChange = function handleClientStateChange(newState) {
    if (_helmetCallback) {
        cancelAnimationFrame(_helmetCallback);
    }

    if (newState.defer) {
        _helmetCallback = requestAnimationFrame(function () {
            commitTagChanges(newState, function () {
                _helmetCallback = null;
            });
        });
    } else {
        commitTagChanges(newState);
        _helmetCallback = null;
    }
};

var commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag,
        bodyAttributes = newState.bodyAttributes,
        htmlAttributes = newState.htmlAttributes,
        linkTags = newState.linkTags,
        metaTags = newState.metaTags,
        noscriptTags = newState.noscriptTags,
        onChangeClientState = newState.onChangeClientState,
        scriptTags = newState.scriptTags,
        styleTags = newState.styleTags,
        title = newState.title,
        titleAttributes = newState.titleAttributes;

    updateAttributes(TAG_NAMES.BODY, bodyAttributes);
    updateAttributes(TAG_NAMES.HTML, htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(TAG_NAMES.BASE, baseTag),
        linkTags: updateTags(TAG_NAMES.LINK, linkTags),
        metaTags: updateTags(TAG_NAMES.META, metaTags),
        noscriptTags: updateTags(TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: updateTags(TAG_NAMES.SCRIPT, scriptTags),
        styleTags: updateTags(TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;


        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    cb && cb();

    onChangeClientState(newState, addedTags, removedTags);
};

var flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};

var updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) {
        document.title = flattenArray(title);
    }

    updateAttributes(TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];

    if (!elementTag) {
        return;
    }

    var helmetAttributeString = elementTag.getAttribute(HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";

        if (elementTag.getAttribute(attribute) !== value) {
            elementTag.setAttribute(attribute, value);
        }

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        elementTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        elementTag.removeAttribute(HELMET_ATTRIBUTE);
    } else if (elementTag.getAttribute(HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
        elementTag.setAttribute(HELMET_ATTRIBUTE, attributeKeys.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector(TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === TAG_PROPERTIES.INNER_HTML) {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === TAG_PROPERTIES.CSS_TEXT) {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = generateElementAttributesAsString(attributes);
    var flattenedTitle = flattenArray(title);
    return attributeString ? "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === TAG_PROPERTIES.INNER_HTML || attribute === TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = SELF_CLOSING_TAGS.indexOf(type) === -1;

        return str + "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(attributes).reduce(function (obj, key) {
        obj[REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};

var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(props).reduce(function (obj, key) {
        obj[HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;

    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[HELMET_ATTRIBUTE] = true, _initProps);
    var props = convertElementAttributestoReactProps(attributes, initProps);

    return [__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var _mappedTag;

        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[HELMET_ATTRIBUTE] = true, _mappedTag);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === TAG_PROPERTIES.INNER_HTML || mappedAttribute === TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch (type) {
        case TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case ATTRIBUTE_NAMES.BODY:
        case ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags, encode);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag,
        bodyAttributes = _ref.bodyAttributes,
        encode = _ref.encode,
        htmlAttributes = _ref.htmlAttributes,
        linkTags = _ref.linkTags,
        metaTags = _ref.metaTags,
        noscriptTags = _ref.noscriptTags,
        scriptTags = _ref.scriptTags,
        styleTags = _ref.styleTags,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? "" : _ref$title,
        titleAttributes = _ref.titleAttributes;
    return {
        base: getMethodsForTag(TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: getMethodsForTag(ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: getMethodsForTag(ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: getMethodsForTag(TAG_NAMES.LINK, linkTags, encode),
        meta: getMethodsForTag(TAG_NAMES.META, metaTags, encode),
        noscript: getMethodsForTag(TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: getMethodsForTag(TAG_NAMES.SCRIPT, scriptTags, encode),
        style: getMethodsForTag(TAG_NAMES.STYLE, styleTags, encode),
        title: getMethodsForTag(TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
    };
};

var Helmet = function Helmet(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            classCallCheck(this, HelmetWrapper);
            return possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !__WEBPACK_IMPORTED_MODULE_2_react_fast_compare___default()(this.props, nextProps);
        };

        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) {
                return null;
            }

            switch (child.type) {
                case TAG_NAMES.SCRIPT:
                case TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };

                case TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }

            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };

        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _babelHelpers$extends;

            var child = _ref.child,
                arrayTypeChildren = _ref.arrayTypeChildren,
                newChildProps = _ref.newChildProps,
                nestedChildren = _ref.nestedChildren;

            return _extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _babelHelpers$extends));
        };

        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _babelHelpers$extends2, _babelHelpers$extends3;

            var child = _ref2.child,
                newProps = _ref2.newProps,
                newChildProps = _ref2.newChildProps,
                nestedChildren = _ref2.nestedChildren;

            switch (child.type) {
                case TAG_NAMES.TITLE:
                    return _extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = _extends({}, newChildProps), _babelHelpers$extends2));

                case TAG_NAMES.BODY:
                    return _extends({}, newProps, {
                        bodyAttributes: _extends({}, newChildProps)
                    });

                case TAG_NAMES.HTML:
                    return _extends({}, newProps, {
                        htmlAttributes: _extends({}, newChildProps)
                    });
            }

            return _extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = _extends({}, newChildProps), _babelHelpers$extends3));
        };

        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = _extends({}, newProps);

            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
                var _babelHelpers$extends4;

                newFlattenedProps = _extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
            });

            return newFlattenedProps;
        };

        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            if (false) {
                if (!VALID_TAG_NAMES.some(function (name) {
                    return child.type === name;
                })) {
                    if (typeof child.type === "function") {
                        return warn("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
                    }

                    return warn("Only elements types " + VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
                }

                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
                    return typeof nestedChild !== "string";
                }))) {
                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
                }
            }

            return true;
        };

        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;

            var arrayTypeChildren = {};

            __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.forEach(children, function (child) {
                if (!child || !child.props) {
                    return;
                }

                var _child$props = child.props,
                    nestedChildren = _child$props.children,
                    childProps = objectWithoutProperties(_child$props, ["children"]);

                var newChildProps = convertReactPropstoHtmlAttributes(childProps);

                _this2.warnOnInvalidChildren(child, nestedChildren);

                switch (child.type) {
                    case TAG_NAMES.LINK:
                    case TAG_NAMES.META:
                    case TAG_NAMES.NOSCRIPT:
                    case TAG_NAMES.SCRIPT:
                    case TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;

                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });

            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };

        HelmetWrapper.prototype.render = function render() {
            var _props = this.props,
                children = _props.children,
                props = objectWithoutProperties(_props, ["children"]);

            var newProps = _extends({}, props);

            if (children) {
                newProps = this.mapChildrenToProps(children, newProps);
            }

            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, newProps);
        };

        createClass(HelmetWrapper, null, [{
            key: "canUseDOM",


            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.

            /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */
            set: function set$$1(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
        }]);
        return HelmetWrapper;
    }(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component), _class.propTypes = {
        base: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
        bodyAttributes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
        children: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node]),
        defaultTitle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
        defer: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
        encodeSpecialCharacters: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
        htmlAttributes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
        link: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        meta: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        noscript: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        onChangeClientState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
        script: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        style: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
        titleAttributes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
        titleTemplate: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = mapStateOnServer({
                baseTag: [],
                bodyAttributes: {},
                encodeSpecialCharacters: true,
                htmlAttributes: {},
                linkTags: [],
                metaTags: [],
                noscriptTags: [],
                scriptTags: [],
                styleTags: [],
                title: "",
                titleAttributes: {}
            });
        }

        return mappedState;
    }, _temp;
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = __WEBPACK_IMPORTED_MODULE_1_react_side_effect___default()(reducePropsToState, handleClientStateChange, mapStateOnServer)(NullComponent);

var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;

/* unused harmony default export */ var _unused_webpack_default_export = (HelmetExport);


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(33)))

/***/ }),
/* 2147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(0);
var React__default = _interopDefault(React);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }

  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }

  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect = /*#__PURE__*/function (_PureComponent) {
      _inheritsLoose(SideEffect, _PureComponent);

      function SideEffect() {
        return _PureComponent.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      // Expose canUseDOM so tests can monkeypatch it
      SideEffect.peek = function peek() {
        return state;
      };

      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      var _proto = SideEffect.prototype;

      _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return /*#__PURE__*/React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(React.PureComponent);

    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    _defineProperty(SideEffect, "canUseDOM", canUseDOM);

    return SideEffect;
  };
}

module.exports = withSideEffect;


/***/ }),
/* 2148 */
/***/ (function(module, exports) {

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),
/* 2149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react_router_dom__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Overview__ = __webpack_require__(2150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Overview_Mls__ = __webpack_require__(2153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Sale__ = __webpack_require__(2154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Search__ = __webpack_require__(2269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SaleWizard__ = __webpack_require__(2271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Whitelisting__ = __webpack_require__(2274);
// nginx rewrites every unmatched path to index.html, so any file-looking
// request under /dashboard (silent-renew.html, favicon.ico, a stray source map)
// used to boot the SPA and be handed to :sale as if it were a sale id. Sale ids
// never contain a dot, so excluding it keeps those requests out of the router.
var SALE_ID='[^/.]+';var Routes=function Routes(){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react_router_dom__["c" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react_router_dom__["a" /* Route */],{path:'/dashboard/mls',component:__WEBPACK_IMPORTED_MODULE_3__Overview_Mls__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react_router_dom__["a" /* Route */],{path:'/dashboard/search',component:__WEBPACK_IMPORTED_MODULE_5__Search__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react_router_dom__["a" /* Route */],{path:'/dashboard/:sale('+SALE_ID+')/whitelisting/:user/:action',component:__WEBPACK_IMPORTED_MODULE_7__Whitelisting__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react_router_dom__["a" /* Route */],{path:'/dashboard/:sale('+SALE_ID+')/wizard',component:__WEBPACK_IMPORTED_MODULE_6__SaleWizard__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react_router_dom__["a" /* Route */],{path:'/dashboard/:sale('+SALE_ID+')',component:__WEBPACK_IMPORTED_MODULE_4__Sale__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react_router_dom__["a" /* Route */],{component:__WEBPACK_IMPORTED_MODULE_2__Overview__["a" /* default */]}));};/* harmony default export */ __webpack_exports__["a"] = (Routes);

/***/ }),
/* 2150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_CommandBar__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_DetailsList__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Link__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__build_src_app_components_LoadingOverlay__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__build_src_app_components_GuideOverlay__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__build_src_app_components_SaleCreatePanel__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__build_node_modules_styled_components__ = __webpack_require__(47);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2,_descriptor,_descriptor2,_class3,_temp2;var _templateObject=_taggedTemplateLiteral(['\n  background: grey;\n  margin-right: 0.5em;\n  border-radius: 3px;\n  color: #fff;\n  font-size: 0.8em;\n  padding: 2px 4px;\n'],['\n  background: grey;\n  margin-right: 0.5em;\n  border-radius: 3px;\n  color: #fff;\n  font-size: 0.8em;\n  padding: 2px 4px;\n']);function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Badge=__WEBPACK_IMPORTED_MODULE_10__build_node_modules_styled_components__["a" /* default */].span(_templateObject);// @inject('listings', 'saleCreate', 'user', 'inventory', 'app')
var ListingsOverview=(_dec=Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__["d" /* inject */])('listings','user','inventory','app'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_6__build_src_app_components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__["e" /* observer */])(_class=(_class2=(_temp2=_class3=function(_Component){_inherits(ListingsOverview,_Component);function ListingsOverview(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ListingsOverview);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ListingsOverview.__proto__||Object.getPrototypeOf(ListingsOverview)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'creating',_descriptor,_this),_initDefineProp(_this,'isTest',_descriptor2,_this),_this.handleAddNew=function(){var history=_this.props.history;history.push('/dashboard/search');},_this.handleMls=function(){var history=_this.props.history;history.push('/dashboard/mls');},_this.handleColumnHeaderClick=function(e,column){var listings=_this.props.listings;listings.sortBy(column.fieldName);},_this.handleRenderObjectColumn=function(item,index,column){var content=item[column.fieldName];var roundNumber=item.roundNumber,roundType=item.roundType,roundStatus=item.roundStatus,whitelistedAgentStatus=item.whitelistedAgentStatus;var t=_this.props.t;var hasAccess=true;// (!item.whitelistedAgentId && !item.whitelistedAgentStatus) ||
// whitelistedAgentStatus === 'whitelisted';
switch(column.key){case'itemNumber':return hasAccess?__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Link__["Link"],{'data-selection-invoke':true},content):__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',null,content);case'status':return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',{content:content},t('statusvalue',{whitelistedAgentStatus:whitelistedAgentStatus,content:content,roundNumber:roundNumber,roundType:roundType,roundStatus:roundStatus}));case'startAt':case'endAt':return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',null,content?content.toFormatedDateString():'');case'title':return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',null,item.features&&item.features.test&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(Badge,null,'TEST'),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Link__["Link"],{'data-selection-invoke':true},content));default:return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',null,content);}},_this.handleItemInvoked=function(item,index){var history=_this.props.history;// const hasAccess =
//   (!item.whitelistedAgentId && !item.whitelistedAgentStatus) ||
//   item.whitelistedAgentStatus === 'whitelisted';
// if (hasAccess)
history.push('/dashboard/'+item.id);},_this.handleStartSale=function(isTest){return function(){var _this$props=_this.props,history=_this$props.history,app=_this$props.app;if(app.config.inventory&&app.config.inventory.url&&app.features&&app.features.createSaleFromInventory)history.push('/dashboard/search'+(isTest?'?test=1':''));else{_this.creating=true;_this.isTest=isTest;}};},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ListingsOverview,[{key:'componentWillMount',value:function componentWillMount(){var _props=this.props,listings=_props.listings,t=_props.t;listings.load();listings.initColumns(t,this.handleColumnHeaderClick);}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,app=_props2.app,listings=_props2.listings,inventory=_props2.inventory,history=_props2.history,t=_props2.t,user=_props2.user;if(inventory.redirect){history.push('/dashboard/'+inventory.startedSale);}var commands=[];if(app.features){if(app.config.inventory&&app.config.inventory.url&&app.features&&app.features.createSaleFromInventory||app.features.createBlankSale){commands.push({key:'create',name:t('Start new sale'),iconProps:{iconName:'Add'},onClick:this.handleStartSale(false),disabled:!user.hasReadWritePermissions});if(app.features.createTestSale){commands.push({key:'create-test',name:t('Start new test sale'),iconProps:{iconName:'TestBeaker'},onClick:this.handleStartSale(true),disabled:!user.hasReadWritePermissions});}}}if(app.canMls){commands.push({key:'mls',name:t('mls'),iconProps:{iconName:'MultiSelect'},onClick:this.handleMls,disabled:!user.hasReadWritePermissions});}return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'title',style:{whiteSpace:'nowrap'}},t('My listings overview')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'menu'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_CommandBar__["a" /* CommandBar */],{items:commands})),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'content'},/* fetching */listings.fetching&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{style:{marginTop:5}},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__build_src_app_components_LoadingOverlay__["a" /* default */],{label:t('Loading listings')+'...'})),/* no active listings */!listings.fetching&&(!listings.items||!listings.items.length)&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__build_src_app_components_GuideOverlay__["a" /* default */],{theme:app.theme},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('p',null,t('Guide - you should add a new listing')))),/* you have some active listings */!listings.fetching&&listings.items&&listings.items.length&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_DetailsList__["b" /* DetailsList */],{columns:listings.columns,items:listings.items,onRenderItemColumn:this.handleRenderObjectColumn,onItemInvoked:this.handleItemInvoked,selectionMode:1,checkboxVisibility:2,layoutMode:__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_DetailsList__["c" /* DetailsListLayoutMode */].justified,isHeaderVisible:true,selectionPreservedOnEmptyClick:true}),this.creating&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__build_src_app_components_SaleCreatePanel__["a" /* default */],{onClose:function onClose(){return _this2.creating=false;},isTest:this.isTest})));}}]);return ListingsOverview;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class3.displayName='ListingsOverview',_temp2),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'creating',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,'isTest',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}})),_class2))||_class)||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (ListingsOverview);

/***/ }),
/* 2151 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SaleCreateStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_src_app_services_cloudinary__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_request__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Overview_stores_ListingsStore__ = __webpack_require__(394);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var SaleCreateStore=(_class=function(){_createClass(SaleCreateStore,[{key:'canCreateSale',get:function get(){return this.agents.length>0&&this.user.hasReadWritePermissions;}},{key:'config',get:function get(){return this.user.userConfig;}}]);function SaleCreateStore(user,sale,app){_classCallCheck(this,SaleCreateStore);_initDefineProp(this,'agents',_descriptor,this);_initDefineProp(this,'selectedAgent',_descriptor2,this);_initDefineProp(this,'isTest',_descriptor3,this);_initDefineProp(this,'selfRegistration',_descriptor4,this);_initDefineProp(this,'masterSaleId',_descriptor5,this);this.user=user;this.sale=sale;this.app=app;this.selectedAgent=this.user.agentData();this.listings=__WEBPACK_IMPORTED_MODULE_4__containers_Overview_stores_ListingsStore__["a" /* default */];}_createClass(SaleCreateStore,[{key:'upload',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(file){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__build_src_app_services_cloudinary__["b" /* upload */])({file:file,accessToken:this.user.accessToken});case 2:return _context.abrupt('return',_context.sent);case 3:case'end':return _context.stop();}}},_callee,this);}));function upload(_x){return _ref.apply(this,arguments);}return upload;}()},{key:'remove',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(deleteToken){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__build_src_app_services_cloudinary__["a" /* remove */])({deleteToken:deleteToken,accessToken:this.user.accessToken});case 2:return _context2.abrupt('return',_context2.sent);case 3:case'end':return _context2.stop();}}},_callee2,this);}));function remove(_x2){return _ref2.apply(this,arguments);}return remove;}()},{key:'start',value:function start(data){var user=this.user;var app=this.app;var saleFeatures=app.getSaleFeatures({test:!!this.isTest,isMasterSale:this.masterSaleId==='master',disableAutomaticReminders:!!this.masterSaleId&&this.masterSaleId!=='master',selfRegistration:!!this.selfRegistration});var agentData=this.selectedAgent||user.agentData();var offerData=Object.assign({},user.userConfig.defaultSaleOfferData||{},{objectno:data.number,object_address:data.address});var item={masterSaleId:!this.masterSaleId||this.masterSaleId==='master'?undefined:this.masterSaleId,referenceId:(data.number||'').toString(),itemData:data,offerData:offerData,agentData:agentData,mls:data.mls,inviteOnly:data.inviteOnly,offerForm:offerData.offer_form,features:saleFeatures};if(app.data&&app.data.sale_country)item.offerData.sale_country=app.data.sale_country;item.itemData.agent=Object.assign({},item.agentData);this.sale.start(item);}},{key:'loadAgents',value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3(){var _this=this;var um,result;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.prev=0;um=this.app.config&&this.app.config.userManagement&&this.app.config.userManagement.url?this.app.config.userManagement.url:'';_context3.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3__services_request__["d" /* get */])(um+'/users/lookup',this.user.accessToken);case 4:result=_context3.sent;Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["l" /* runInAction */])(function(){return _this.populateAgents(result);});_context3.next=10;break;case 8:_context3.prev=8;_context3.t0=_context3['catch'](0);case 10:case'end':return _context3.stop();}}},_callee3,this,[[0,8]]);}));function loadAgents(){return _ref3.apply(this,arguments);}return loadAgents;}()},{key:'populateAgents',value:function populateAgents(agents){this.agents=agents;var current=this.user.agentData();this.selectedAgent=this.agents.find(function(a){return String(a.sub)===String(current.sub);})||this.agents.find(function(a){return(String(a.id)||String(a.agent_id))===String(current.id)&&(!a.office_id&&!current.office_id||String(a.office_id)===String(current.office_id));})||(agents.length===1?agents[0]:undefined);}},{key:'masterSales',get:function get(){var filtered=this.listings.items.filter(function(i){return i.features!=null&&!!i.features.isMasterSale;}).map(function(s){return{key:s.id,text:s.title};});return filtered;}}]);return SaleCreateStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'agents',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'selectedAgent',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:null}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'isTest',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'selfRegistration',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'masterSaleId',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return'';}}),_applyDecoratedDescriptor(_class.prototype,'canCreateSale',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'canCreateSale'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'config',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'config'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'masterSales',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'masterSales'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'loadAgents',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'loadAgents'),_class.prototype)),_class);

/***/ }),
/* 2153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_src_app_components_GuideOverlay__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_src_app_components_LoadingOverlay__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_src_app_components_Prompt__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_DetailsList__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__build_node_modules_office_ui_fabric_react_lib_Link__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__build_node_modules_office_ui_fabric_react_lib_Icon__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2,_descriptor,_descriptor2,_descriptor3,_class3,_temp2;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var Mls=(_dec=Object(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_mobx_react__["d" /* inject */])('mls','user','inventory','app'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_3__build_src_app_components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_mobx_react__["e" /* observer */])(_class=(_class2=(_temp2=_class3=function(_Component){_inherits(Mls,_Component);function Mls(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,Mls);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Mls.__proto__||Object.getPrototypeOf(Mls)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'creating',_descriptor,_this),_initDefineProp(_this,'openPrompt',_descriptor2,_this),_initDefineProp(_this,'selectedSale',_descriptor3,_this),_this.handleColumnHeaderClick=function(e,column){var mls=_this.props.mls;mls.sortBy(column.fieldName);},_this.handleRenderObjectColumn=function(item,_,column){var content=item[column.fieldName];var roundNumber=item.roundNumber,roundType=item.roundType,roundStatus=item.roundStatus,endAt=item.endAt;var t=_this.props.t;switch(column.key){case'title':return __WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('span',null,item.inviteOnly?__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__build_node_modules_office_ui_fabric_react_lib_Icon__["Icon"],{iconName:'LockSolid'}),' '):null,content);case'itemNumber':return __WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__build_node_modules_office_ui_fabric_react_lib_Link__["Link"],{'data-selection-invoke':true},content);case'status':return __WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('span',{content:content},t('statusvalue',{content:content,roundNumber:roundNumber,roundType:roundType,roundStatus:roundStatus,endAt:endAt.toFormatedDateString()}));case'startAt':case'endAt':return __WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('span',null,content?content.toFormatedDateString():'');default:return __WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('span',null,content);}},_this.handleItemInvoked=function(item,_){var history=_this.props.history;if(item.inviteOnly){Object(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx__["l" /* runInAction */])(function(){_this.selectedSale=item;_this.openPrompt=true;});}else{history.push('/dashboard/'+item.id);}},_this.handleBack=function(){var history=_this.props.history;history.push('/dashboard');},_this.handleRequestAccess=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(){var _this$props,history,mls,user,ok;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this$props=_this.props,history=_this$props.history,mls=_this$props.mls,user=_this$props.user;_context.next=3;return mls.requestAccess({saleId:_this.selectedSale.id,userId:user.profile.sub,agent:user.agentData()});case 3:ok=_context.sent;_this.openPrompt=false;if(ok){history.push('/dashboard');}case 6:case'end':return _context.stop();}}},_callee,_this2);})),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Mls,[{key:'componentWillMount',value:function componentWillMount(){var _props=this.props,mls=_props.mls,t=_props.t;mls.load();mls.initColumns(t,this.handleColumnHeaderClick);}},{key:'render',value:function render(){var _this3=this;var _props2=this.props,app=_props2.app,mls=_props2.mls,t=_props2.t;return __WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('div',{className:'title'},__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('a',{className:'back',onClick:this.handleBack},__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('i',{className:'ms-Icon ms-Icon--NavigateBack','aria-hidden':'true'}),__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('span',null,t('Back'))),__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('span',null,t('mls'))),__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('div',{className:'content-without-menu'},/* fetching */mls.fetching&&__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('div',{style:{marginTop:5}},__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__build_src_app_components_LoadingOverlay__["a" /* default */],{label:t('Loading mls')+'...'})),/* no active mls */!mls.fetching&&(!mls.items||!mls.items.length)&&__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_src_app_components_GuideOverlay__["a" /* default */],{theme:app.theme},__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('p',null,t('no sale for mls')))),/* you have some active mls */!mls.fetching&&mls.items&&mls.items.length&&__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_DetailsList__["b" /* DetailsList */],{columns:mls.columns,items:mls.items,onRenderItemColumn:this.handleRenderObjectColumn,onItemInvoked:this.handleItemInvoked,selectionMode:1,checkboxVisibility:2,layoutMode:__WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_DetailsList__["c" /* DetailsListLayoutMode */].justified,isHeaderVisible:true,selectionPreservedOnEmptyClick:true})),__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_src_app_components_Prompt__["a" /* default */],{title:t('Request Access'),opened:this.openPrompt,onClose:function onClose(){return _this3.openPrompt=false;},onSubmit:this.handleRequestAccess},__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('div',null,t('Request Access Description'))));}}]);return Mls;}(__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react__["Component"]),_class3.displayName='Mls',_temp2),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'creating',[__WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,'openPrompt',[__WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor3=_applyDecoratedDescriptor(_class2.prototype,'selectedSale',[__WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return null;}})),_class2))||_class)||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (Mls);

/***/ }),
/* 2154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_MessageBar__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_styled_components__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_LoadingOverlay__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Watermark__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_queryString__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_websockets__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__BiddingSection__ = __webpack_require__(2155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Commands__ = __webpack_require__(2157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Guides__ = __webpack_require__(2162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__OffersSection__ = __webpack_require__(2166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Prompts__ = __webpack_require__(2245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__RoundSection__ = __webpack_require__(2248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__SaleEditSection__ = __webpack_require__(2251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__SaleManageSection__ = __webpack_require__(2255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__SaleNotificationsSection__ = __webpack_require__(2257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__SaleMessagingSection__ = __webpack_require__(2259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__SellerInviteSection__ = __webpack_require__(2261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__WhitelistingSection__ = __webpack_require__(2263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__BuyerAgentInviteSection__ = __webpack_require__(2266);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2,_descriptor,_class3,_temp2;var _templateObject=_taggedTemplateLiteral(['\n  position: fixed !important;\n  top: 0;\n  left: 10vw;\n  width: 80vw !important;\n  z-index: 1;\n\n  background-color: #facfd3 !important;\n'],['\n  position: fixed !important;\n  top: 0;\n  left: 10vw;\n  width: 80vw !important;\n  z-index: 1;\n\n  background-color: #facfd3 !important;\n']),_templateObject2=_taggedTemplateLiteral(['\n  .label {\n    align-self: center;\n\n    font-size: 0.8rem !important;\n    font-weight: bold !important;\n\n    color: #fff;\n\n    padding: 0.1em 0.8em 0.3em 0.8em;\n\n    line-height: 1.2;\n\n    &.with-icon {\n      padding-left: 0.5em;\n    }\n\n    .ms-Icon {\n      font-size: 0.8rem !important;\n      margin-right: 0.5em;\n    }\n  }\n'],['\n  .label {\n    align-self: center;\n\n    font-size: 0.8rem !important;\n    font-weight: bold !important;\n\n    color: #fff;\n\n    padding: 0.1em 0.8em 0.3em 0.8em;\n\n    line-height: 1.2;\n\n    &.with-icon {\n      padding-left: 0.5em;\n    }\n\n    .ms-Icon {\n      font-size: 0.8rem !important;\n      margin-right: 0.5em;\n    }\n  }\n']);function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/*
const OpenRoundConfirmation = dynamicImport({
  component: '/containers/Sale/Prompts/OpenRoundConfirmation',
});
*/var SaleMessageBar=Object(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_styled_components__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_MessageBar__["a" /* MessageBar */])(_templateObject);var TitleSection=__WEBPACK_IMPORTED_MODULE_4__build_node_modules_styled_components__["a" /* default */].div(_templateObject2);var Sale=(_dec=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["d" /* inject */])('user','sale','app'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_6__components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["e" /* observer */])(_class=(_class2=(_temp2=_class3=function(_Component){_inherits(Sale,_Component);function Sale(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Sale);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Sale.__proto__||Object.getPrototypeOf(Sale)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'currentPanel',_descriptor,_this),_this.handleBack=function(){var history=_this.props.history;history.push('/dashboard');},_this.handleDismissErrorBar=function(){var sale=_this.props.sale;sale.clearError();},_this.renderErrorBar=function(err){var t=_this.props.t;return err?__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement(SaleMessageBar,{messageBarType:__WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_MessageBar__["b" /* MessageBarType */].error,isMultiline:true,onDismiss:_this.handleDismissErrorBar},err.code&&__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement('div',null,t(err.code,null,err.text)),!err.code&&err.message&&__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement('div',null,err.message)):__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react__["Fragment"],null);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Sale,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,sale=_props.sale,match=_props.match;if(!sale.connected){var uri=Object(__WEBPACK_IMPORTED_MODULE_9__helpers_websockets__["a" /* websocketsUri */])('/events/v1/sale?sid='+encodeURIComponent(match.params.sale));sale.connect(uri);}sale.clearResponse();}},{key:'componentWillUnmount',value:function componentWillUnmount(){var sale=this.props.sale;sale.reset();sale.disconnect();}},{key:'componentWillReact',value:function componentWillReact(){var _props2=this.props,sale=_props2.sale,history=_props2.history;var preventRedirect=Object(__WEBPACK_IMPORTED_MODULE_8__helpers_queryString__["a" /* getQueryStringValue */])('r')==='hold';if(sale.isDeleted&&!preventRedirect){history.push('/dashboard');}}},{key:'render',value:function render(){var _props3=this.props,app=_props3.app,sale=_props3.sale,history=_props3.history,user=_props3.user,t=_props3.t,match=_props3.match;var item=sale.item,error=sale.error;var ui=sale.ui,round=sale.round,offers=sale.offers,saleEdit=sale.saleEdit,docs=sale.docs,whitelisting=sale.whitelisting;if(sale.forbidden){return this.renderErrorBar({code:'forbidden'});}if(sale.notFound){return this.renderErrorBar({code:'sale_not_found',text:'This sale could not be found.'});}if(sale.unavailable){return this.renderErrorBar({code:'sale_connection_unavailable',text:'Lost the connection to this sale. Please reload the page.'});}if(sale.isDeleted){return this.renderErrorBar({code:sale.status});}if(sale.saleId!==match.params.sale){return __WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_LoadingOverlay__["a" /* default */],{label:t('Loading sale')+'...',fullscreen:true});}var watermark=sale.isTest&&!(app.config.watermark&&app.config.watermark!=='');return __WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react__["Fragment"],null,watermark&&__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Watermark__["a" /* default */],{'data-test-id':'test-watermark'},t('test_sale_watermark')),this.renderErrorBar(error),__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement(TitleSection,{className:'title'},__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement('a',{className:'back',onClick:this.handleBack},__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement('i',{className:'ms-Icon ms-Icon--Home','aria-hidden':'true'}),__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement('span',null,t('Back'))),__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement('span',{className:'collapsible'},item.number,'\xA0',item.title),__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__RoundSection__["a" /* RoundInfo */],{round:round.definition})),__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement('div',{className:'menu'},__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Commands__["a" /* default */],{store:sale,history:history,user:user,app:app})),__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Guides__["a" /* default */],{app:app,store:sale,t:t,theme:app.theme}),ui.currentPanel==='roundStart'&&__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__RoundSection__["b" /* RoundSection */],{store:round,ui:ui}),ui.currentPanel==='inviteSeller'&&__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__SellerInviteSection__["a" /* default */],null),ui.currentPanel==='inviteBuyerAgent'&&__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__BuyerAgentInviteSection__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__SaleEditSection__["a" /* default */],{store:saleEdit,docs:docs,ui:ui}),__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__SaleManageSection__["a" /* default */],{sale:saleEdit,user:user,ui:ui}),__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__SaleNotificationsSection__["a" /* default */],{sale:saleEdit,user:user,ui:ui}),__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__WhitelistingSection__["a" /* default */],{whitelisting:whitelisting,sale:saleEdit,user:user,ui:ui}),__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__SaleMessagingSection__["a" /* default */],{sale:saleEdit,user:user,ui:ui}),__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__OffersSection__["a" /* default */],{store:offers,ui:ui}),ui.currentPanel==='biddingHistory'&&__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__BiddingSection__["a" /* default */],{store:sale.bidding,closePanel:function closePanel(){return ui.closePanel();}}),sale.ui.prompt.openRound&&__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Prompts__["c" /* OpenRoundConfirmation */],{sale:sale,app:app,user:user,saleEdit:saleEdit,t:t,locale:this.props.intl.locale})||sale.ui.prompt.block&&__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Prompts__["a" /* BlockUser */],{sale:sale,t:t})||sale.ui.prompt.upload&&__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Prompts__["d" /* UploadOfferConfirmation */],{sale:sale,saleEdit:saleEdit,t:t})||sale.ui.prompt.opened&&__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Prompts__["b" /* GenericPrompt */],{sale:sale}),__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_LoadingOverlay__["a" /* default */],{label:t('Processing')+'...',fullscreen:true,isVisible:ui.loading.hasPenddingActions,opacity:0.9})));}}]);return Sale;}(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react__["Component"]),_class3.displayName='Sale',_temp2),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'currentPanel',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return null;}})),_class2))||_class)||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (Sale);

/***/ }),
/* 2155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Modal__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_DetailsList__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_src_app_components_Money__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_css__ = __webpack_require__(2156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__style_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2,_descriptor,_class3,_temp;function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var byDefaultDoNothing=function byDefaultDoNothing(){};var columns=function columns(t){var onClick=arguments.length>1&&arguments[1]!==undefined?arguments[1]:byDefaultDoNothing;return[{key:'name',name:t('Customer name'),fieldName:'name',minWidth:150,maxWidth:400,onColumnClick:onClick,isSorted:false,isSortedDescending:false},{key:'status',name:t('Status'),fieldName:'status',minWidth:100,maxWidth:150,onColumnClick:onClick,isSorted:false,isSortedDescending:false},{key:'createdAt',name:t('Submitted on'),fieldName:'createdAt',minWidth:100,maxWidth:150,onColumnClick:onClick,isSorted:true,isSortedDescending:true},{key:'value',name:t('Bid amount'),fieldName:'value',minWidth:100,maxWidth:150,onColumnClick:onClick,isSorted:false,isSortedDescending:false}];};var BiddingSection=(_dec=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["d" /* inject */])('app'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_5__build_src_app_components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["e" /* observer */])(_class=(_class2=(_temp=_class3=function(_Component){_inherits(BiddingSection,_Component);function BiddingSection(props){_classCallCheck(this,BiddingSection);var _this=_possibleConstructorReturn(this,(BiddingSection.__proto__||Object.getPrototypeOf(BiddingSection)).call(this,props));_initDefineProp(_this,'columns',_descriptor,_this);_this.handleRenderItemColumn=function(item,index,column){var t=_this.props.t;var content=item[column.fieldName];switch(column.key){case'createdAt':return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',null,content?content.toFormatedDateString('ll LT'):'');case'value':return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',{style:{color:item.redButtonPriceFlag?'#dc1c2e':'inherit'}},content<0&&t('hidden'),content>=0&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_src_app_components_Money__["a" /* default */],{value:content,currency:_this.props.app.currency.code,locale:_this.props.intl.locale}));default:return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',null,content);}};_this.selection=new __WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_DetailsList__["d" /* Selection */]({onSelectionChanged:_this.handleSelectionChanged});_this.columns=columns(props.t,_this.handleColumnHeaderClick);return _this;}_createClass(BiddingSection,[{key:'render',value:function render(){var _props=this.props,vm=_props.store.vm,store=_props.store,t=_props.t;var closePanel=this.props.closePanel;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Modal__["a" /* Modal */],{isOpen:true,onDismiss:closePanel,isBlocking:false,containerClassName:'history--modal'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'clearfix history--container',tabIndex:'0',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',null,t('The next minimum offer'),':',' ',__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_src_app_components_Money__["a" /* default */],{value:vm.askingPrice,currency:this.props.app.currency.code,locale:this.props.intl.locale})),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',null,t('The highest offer'),':',' ',__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_src_app_components_Money__["a" /* default */],{value:vm.highestBidValue,currency:this.props.app.currency.code,locale:this.props.intl.locale})),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',null,t('Highest bidder'),': ',store.highestBidder),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',null,t('Round opens on'),':',' ',store.offers.root.round.definition.createdAt.toFormatedDateString()),vm.history&&vm.history.length>0&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_DetailsList__["b" /* DetailsList */],{columns:this.columns,items:store.history,selectionMode:1,checkboxVisibility:0,layoutMode:__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_DetailsList__["c" /* DetailsListLayoutMode */].justified,onRenderItemColumn:this.handleRenderItemColumn})));}}]);return BiddingSection;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class3.displayName='BiddingSection',_temp),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'columns',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}})),_class2))||_class)||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (BiddingSection);

/***/ }),
/* 2156 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Commands; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_CommandBar__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__saleCommandItems__ = __webpack_require__(2158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__roundCommandItems__ = __webpack_require__(2159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bidderCommandItems__ = __webpack_require__(2160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__offerCommandItems__ = __webpack_require__(2161);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Commands=Object(__WEBPACK_IMPORTED_MODULE_3__components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["e" /* observer */])(_class=(_temp=_class2=function(_Component){_inherits(Commands,_Component);function Commands(){_classCallCheck(this,Commands);return _possibleConstructorReturn(this,(Commands.__proto__||Object.getPrototypeOf(Commands)).apply(this,arguments));}_createClass(Commands,[{key:'render',value:function render(){var _props=this.props,app=_props.app,user=_props.user,store=_props.store,t=_props.t;var items=[].concat(Object(__WEBPACK_IMPORTED_MODULE_6__bidderCommandItems__["a" /* bidderCommandItems */])(app,user,store,t),Object(__WEBPACK_IMPORTED_MODULE_7__offerCommandItems__["a" /* offerCommandItems */])(app,store,t),__WEBPACK_IMPORTED_MODULE_4__saleCommandItems__["a" /* saleCommandItems */].items(app,store,t));var farItems=[].concat(__WEBPACK_IMPORTED_MODULE_4__saleCommandItems__["a" /* saleCommandItems */].farItems(app,store,t),Object(__WEBPACK_IMPORTED_MODULE_5__roundCommandItems__["a" /* roundCommandItems */])(app,store,t));return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_CommandBar__["a" /* CommandBar */],{items:items,farItems:farItems});}}]);return Commands;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class2.displayName='Commands',_temp))||_class)||_class;

/***/ }),
/* 2158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return saleCommandItems; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_lodash__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_lodash__);
var allCommands=function allCommands(app,store,t){var features=app.features;return[{key:'edit',name:t('Edit'),iconProps:{iconName:'PageEdit'},disabled:!store.cmdBar.saleEditEnabled,onClick:function onClick(){return store.ui.editSale();}},features.inviteSeller&&{key:'inviteSeller',name:t('Invite Seller'),iconProps:{iconName:'ChatInviteFriend'},disabled:!store.cmdBar.inviteSellerEnabled,onClick:function onClick(){return store.ui.inviteSeller();}},{key:'messaging',name:t('Messaging'),iconProps:{iconName:'Mail'},iconOnly:true,disabled:!store.hasSalePermissions,onClick:store.ui.messaging},features.inviteBuyerAgent&&{key:'inviteBuyerAgent',name:t('Invite Buyer Agent'),iconProps:{iconName:'ChatInviteFriend'},disabled:!store.cmdBar.inviteBuyerAgentEnabled,onClick:function onClick(){return store.ui.inviteBuyerAgent();}},{key:'preview',name:t('Preview'),iconProps:{iconName:'Preview'},onClick:store.ui.showSalePreview},{key:'previewPdf',name:t('Blank offer'),iconProps:{iconName:'pdf'},onClick:store.ui.showPreviewPdf},{key:'delete',name:t('Delete'),iconProps:{iconName:'Delete'},disabled:!store.cmdBar.saleDeleteEnabled,onClick:function onClick(){return store.ui.prompt.open({title:t('Delete sale'),message:t('Are you sure? This action can not be undone.'),action:function action(){return store.saleEdit.delete();}});}},{key:'close',name:t('Close'),iconProps:{iconName:'Stop'},disabled:!store.cmdBar.saleCloseEnabled,onClick:function onClick(){return store.ui.prompt.open({title:t('Close sale'),message:t('Are you sure to close the sale?'),action:function action(){return store.saleEdit.close();}});}},{key:'overview',name:t('Overview'),iconProps:{iconName:'GroupedList'},// disabled: !store.hasSalePermissions,
onClick:store.ui.openOverview},{key:'download',name:t('Download documents'),iconProps:{iconName:'DownloadDocument'},disabled:!store.saleEdit.docs.length,onClick:function onClick(){return window.open('/api/v1/sales/'+store.saleId+'/docs');}},{key:'manage',name:t('Manage'),iconProps:{iconName:'PeopleRepeat'},iconOnly:true,onClick:store.ui.manage},{key:'notifications',name:t('Notifications'),iconProps:{iconName:'MailAlert'},iconOnly:true,disabled:!store.hasSalePermissions,onClick:store.ui.notifications},{key:'auctionFinals',name:t('Auction Finals'),iconProps:{iconName:'CheckList'},onClick:store.ui.auctionFinals}].filter(Boolean);};var saleCommandItems={items:function items(app,store,t){var commands=[];if(store.cmdBar.whitelistingVisible){commands.push({key:'whitelisting',name:''+t('Whitelisting')+(store.whitelisting.pendingRequests?' ('+store.whitelisting.pendingRequests+')':''),iconProps:{iconName:'MultiSelect'},iconOnly:false,onClick:function onClick(){return store.ui.whitelisting();},disabled:!store.cmdBar.whitelistingEnabled});}commands.push({key:'settings',name:t('Sale wizard'),iconProps:{iconName:'Feedback'},iconOnly:false,onClick:store.ui.showSaleWizard,disabled:!store.cmdBar.saleWizardEnabled});return commands.filter(function(item){return app.tenantConfig.saleCommands.includes(item.key);});},farItems:function farItems(app,store,t){return[{key:'sale',name:t('Sale'),subMenuProps:{items:__WEBPACK_IMPORTED_MODULE_0__build_node_modules_lodash___default.a.filter(allCommands(app,store,t),function(item){return app.tenantConfig.saleCommands.includes(item.key);})}}];}};

/***/ }),
/* 2159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return roundCommandItems; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_lodash__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_lodash__);
var config=__webpack_require__(104).default;var allCommands=function allCommands(app,store,t){var cmdBar=store.cmdBar,round=store.round;return[{key:'bidding-history',name:t('All offers'),iconProps:{iconName:'NumberedList'},iconOnly:true,onClick:function onClick(){return store.ui.showBiddingHistory();},disabled:!store.round.isOpenBidding},// DAV-814: This is hidden as users try to start 2nd round here instead of wizard which results in a messed up round
// {
//   key: 'start',
//   name: t('New'),
//   iconProps: {
//     iconName: 'CirclePlus',
//   },
//   iconOnly: true,
//   onClick: () => store.ui.startRound(),
//   disabled: !cmdBar.roundStartEnabled,
// },
{key:'edit',name:t('Edit'),iconProps:{iconName:'CirclePlus'},iconOnly:true,onClick:function onClick(){return store.ui.startRound();},disabled:!cmdBar.roundEditEnabled},{key:'open',name:t('Open'),iconProps:{iconName:'MSNVideos'},iconOnly:true,onClick:function onClick(){return store.ui.prompt.open({title:t('Round open'),action:function action(){return store.round.open();},content:'openRound'});},disabled:!cmdBar.roundOpenEnabled},{key:'stop',name:t('Round close'),iconProps:{iconName:'CircleStop'},iconOnly:true,onClick:function onClick(){return store.ui.prompt.open({title:t('End round early'),message:round.type==='sealed_bidding'?t('are_you_sure_to_end_round_early_sealed'):t('are_you_sure_to_end_round_early'),action:function action(){return store.round.close();}});},disabled:!cmdBar.roundCloseEnabled}].filter(Boolean);};var roundCommandItems=function roundCommandItems(app,store,t){return[{key:'round',name:t('Round'),subMenuProps:{items:__WEBPACK_IMPORTED_MODULE_0__build_node_modules_lodash___default.a.filter(allCommands(app,store,t),function(item){return config.roundCommands.includes(item.key);})}}];};

/***/ }),
/* 2160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bidderCommandItems; });
var bidderCommandItems=function bidderCommandItems(app,user,store,t){var cmdBar=store.cmdBar,_store$integrations=store.integrations,integrations=_store$integrations===undefined?{}:_store$integrations;var features=app.features;var inviteOptions=[features.bulkRegistrationPropUp&&user.claims&&user.claims.idp&&user.claims.idp==='propup'?{key:'bulkregistrationpropup',name:t('Import registrations from PropUp'),iconProps:{iconName:'PeopleRepeat'},disabled:!cmdBar.userRegistrationEnabled,onClick:function onClick(){return store.ui.bulkRegistrationPropUp();}}:null,features.bulkRegistrationOnOffice?{key:'bulkregistrationonoffice',name:t('Import registrations from OnOffice'),iconProps:{iconName:'PeopleRepeat'},disabled:!cmdBar.userRegistrationEnabled,onClick:function onClick(){return store.ui.bulkRegistrationOnOffice();}}:null,features.bulkRegistrationPropstack?{key:'bulkregistrationpropstack',name:t('Import registrations from Propstack'),iconProps:{iconName:'PeopleRepeat'},disabled:!cmdBar.userRegistrationEnabled,onClick:function onClick(){return store.ui.bulkRegistrationPropstack();}}:null,features.bulkRegistrationCrm||!!(integrations&&integrations.justimmo)?{key:'bulkregistrationcrm',name:t('Import registrations from CRM'),iconProps:{iconName:'PeopleRepeat'},disabled:!cmdBar.userRegistrationEnabled,onClick:function onClick(){return store.ui.bulkRegistrationCrm();}}:null,features.registrationReadOnly?null:{key:'register',text:t('Register new user'),iconProps:{iconName:'PeopleAdd'},disabled:!cmdBar.userRegistrationEnabled,onClick:function onClick(){return store.ui.registerUser();}},features.bulkRegistrationCsv?{key:'bulkregistrationcsv',text:t('Import registrations from CSV file'),iconProps:{iconName:'AddGroup'},disabled:!cmdBar.userRegistrationEnabled,onClick:function onClick(){return store.ui.bulkRegistrationCsv();}}:null,features.inviteBuyerAgent?{key:'inviteBuyerAgent',name:t('Invite Buyer Agent'),iconProps:{iconName:'ChatInviteFriend'},disabled:!store.cmdBar.inviteBuyerAgentEnabled,onClick:function onClick(){return store.ui.inviteBuyerAgent();}}:null].filter(Boolean);var items=[];if(inviteOptions.length===1){items.push(Object.assign({},inviteOptions[0],{text:t('Register')}));}if(inviteOptions.length>1){items.push({key:'invite',name:t('Register'),iconProps:{iconName:'PeopleAdd'},disabled:!cmdBar.userRegistrationEnabled,subMenuProps:{items:inviteOptions}});}items.push({key:'block',name:t('Block user'),iconProps:{iconName:'PeopleBlock'},iconOnly:true,disabled:!cmdBar.userBlockingEnabled,onClick:function onClick(){return store.ui.prompt.open({title:t('Block user'),message:t('Are you sure to block user?'),content:'block',action:function action(data){store.offers.block(data);}});}});if(features.selfRegistration){items.push({key:'registration',name:t('registration'),disabled:!cmdBar.registrationEnabled,subMenuProps:{items:[{key:'approve',name:t('approve-registration'),iconProps:{iconName:'accept'},iconOnly:true,onClick:function onClick(){return store.ui.approveRegistration();}// () => store.offers.approveRegistration(),
},{key:'refuse',name:t('refuse-registration'),iconProps:{iconName:'cancel'},iconOnly:true,onClick:function onClick(){return store.offers.refuseRegistration();}}]}});}return items;};

/***/ }),
/* 2161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return offerCommandItems; });
var offerCommandItems=function offerCommandItems(app,store,t){var cmd=store.cmdBar;var features=app.features;var items=[];if(!features.registrationReadOnly){items.push({key:'upload',name:t('Upload'),iconProps:{iconName:'CloudUpload'},iconOnly:true,disabled:!cmd.offerUploadEnabled,onClick:function onClick(){return store.ui.registerOnBehalf();}});}items.push({key:'refuse',name:t('Refuse'),iconProps:{iconName:'ReceiptUndelivered'},iconOnly:true,disabled:!cmd.offerRefuseEnabled,onClick:function onClick(){return store.ui.refuseOffer();}});//{
//   key: 'award',
//   name: t('Award'),
//   icon: 'DecisionSolid',
//   iconOnly: true,
//   disabled: !cmd.offerAwardEnabled,
//   onClick: () =>
//     store.ui.prompt.open({ title: t('Kaufangebot annehmen'), message: t('Sind Sie sicher? Alle anderen Kunden bekommen entsprechende ablehnungs Benachrichtigung.'), action: () =>
//       store.offers.award()
//     })
// }, {
//   key: 'accept',
//   name: t('Accept'),
//   icon: 'Accept',
//   iconOnly: true,
//   disabled: !cmd.offerAcceptEnabled,
//   onClick: () => store.offers.accept()
// }, {
//   key: 'reject',
//   name: t('Reject'),
//   icon: 'Blocked',
//   iconOnly: true,
//   disabled: !cmd.offerRejectEnabled,
//   onClick: () =>
//     store.ui.prompt.open({ title: t('Angebot endgültig ablehnen'), message: t('Sind Sie sicher?'), action: () =>
//       store.offers.reject()
//     })
// },
items.push({key:'offer',name:t('Offer'),subMenuProps:{items:[{key:'confirm-on-behalf',name:t('Confirm'),iconProps:{iconName:'SkypeCircleCheck'},iconOnly:true,onClick:function onClick(){return store.offers.confirmOnBehalf();},disabled:!cmd.offerConfirmOnBehalfEnabled},{key:'pdf',name:t('PDF Export'),iconProps:{iconName:'PDF'},iconOnly:true,onClick:function onClick(){return store.ui.printOffer();},disabled:!cmd.offerPreviewEnabled},{key:'update-contact',name:t('Update Contact'),iconProps:{iconName:'EditContact'},iconOnly:true,onClick:function onClick(){return store.ui.updateContact();},disabled:!cmd.updateContactEnabled}]}});return items;};

/***/ }),
/* 2162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_src_app_components_GuideOverlay__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Link__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_styled_components__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RoundSelector__ = __webpack_require__(2163);
var _templateObject=_taggedTemplateLiteral(['\n  border: solid 1px ',';\n  background: rgba(91, 160, 209, 0.133);\n  margin: 0.1em 0;\n  padding: 0.5em 1em;\n  text-align: center;\n\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: center;\n  align-items: center;\n\n  button {\n    margin: 0 1em;\n    background: ',';\n    color: #fff;\n\n    .ms-Icon {\n      margin-right: 0.2em;\n    }\n  }\n'],['\n  border: solid 1px ',';\n  background: rgba(91, 160, 209, 0.133);\n  margin: 0.1em 0;\n  padding: 0.5em 1em;\n  text-align: center;\n\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: center;\n  align-items: center;\n\n  button {\n    margin: 0 1em;\n    background: ',';\n    color: #fff;\n\n    .ms-Icon {\n      margin-right: 0.2em;\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  border: solid 1px #498205;\n  background: #a7b992;\n  margin: 0.1em 0;\n  padding: 0.5em 1em;\n  text-align: center;\n\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: center;\n  align-items: center;\n\n  button {\n    background: #498205;\n  }\n'],['\n  border: solid 1px #498205;\n  background: #a7b992;\n  margin: 0.1em 0;\n  padding: 0.5em 1em;\n  text-align: center;\n\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: center;\n  align-items: center;\n\n  button {\n    background: #498205;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GuideLayer=__WEBPACK_IMPORTED_MODULE_5__build_node_modules_styled_components__["a" /* default */].section(_templateObject,function(props){return props.theme.palette.themePrimary;},function(props){return props.theme.palette.themePrimary;});var GuideUpgradeLayer=Object(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_styled_components__["a" /* default */])(GuideLayer)(_templateObject2);var Guides=function Guides(_ref){var app=_ref.app,store=_ref.store,t=_ref.t,theme=_ref.theme;var config=store.saleConfig;return __WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.Fragment,null,/* not complete offer form */store.ui.guideNext==='saleEdit'&&__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_src_app_components_GuideOverlay__["a" /* default */],{theme:theme},__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement('p',null,t('Guide - define offer form'),__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement('br',null),t('Guide - missing mandatory offer form')),__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Link__["Link"],{onClick:function onClick(){return store.ui.editSale();}},__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement('i',{className:'ms-Icon ms-Icon--Edit','aria-hidden':'true'}),' ',t('Guide action - Edit sale')))),/* not defined round */store.ui.guideNext==='roundStart'&&__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_src_app_components_GuideOverlay__["a" /* default */],{theme:theme},__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement('span',null,config.roundTypes.includes('simple_offer')?__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement('p',null,t('Guide - start round')),__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__RoundSelector__["a" /* default */],{theme:theme,handleSelect:function handleSelect(round){store.round.definition.type=round;store.ui.startRound();}})):null,!config.hideSaleEditGuide&&__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement('p',null,t('Guide - start round edit sale')),__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Link__["Link"],{onClick:function onClick(){return store.ui.editSale();}},app.features.saleReadOnly&&__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement('i',{className:'ms-Icon ms-Icon--View','aria-hidden':'true'}),' ',t('Guide action - Start round view')),!app.features.saleReadOnly&&__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement('i',{className:'ms-Icon ms-Icon--Edit','aria-hidden':'true'}),' ',t('Guide action - Start round edit')))),!config.roundTypes.includes('simple_offer')?__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement('p',null,t('Guide - start round')),__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Link__["Link"],{onClick:function onClick(){return store.ui.startRound();}},__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement('i',{className:'ms-Icon ms-Icon--CirclePlus','aria-hidden':'true'}),' ',t('Guide action - Start round'))):null)),/* not defined round */store.ui.guideNext==='roundOpen'&&__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_src_app_components_GuideOverlay__["a" /* default */],{theme:theme},__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement('p',null,t('Guide - open round')),__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Link__["Link"],{onClick:function onClick(){store.ui.prompt.open({title:__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement('div',{style:{textAlign:'center'}},t('Guide action - Open round')),action:function action(){return store.round.open();},content:'openRound'});}},__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement('i',{className:'ms-Icon ms-Icon--MSNVideos','aria-hidden':'true'}),' ',t('Guide action - Open round')),__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement('p',null,t('Guide - edit round')),__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Link__["Link"],{onClick:function onClick(){return store.ui.startRound();}},__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement('i',{className:'ms-Icon ms-Icon--Edit','aria-hidden':'true'}),' ',t('Guide action - edit round')))),/* no invites yet */store.ui.guideNext==='registration'&&__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_src_app_components_GuideOverlay__["a" /* default */],{theme:theme},!app.features.registrationReadOnly&&__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement('p',null,t('Guide - invite users')),__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Link__["Link"],{onClick:function onClick(){return store.ui.registerUser();}},__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement('i',{className:'ms-Icon ms-Icon--PeopleAdd','aria-hidden':'true'}),' ',t('Guide action - Invite bidders'))),app.features.registrationReadOnly&&app.features.bulkRegistrationCsv&&__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement('p',null,t('Guide - import users csv')),app.features.bulkRegistrationCsv&&__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Link__["Link"],{onClick:function onClick(){return store.ui.bulkRegistrationCsv();}},__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement('i',{className:'ms-Icon ms-Icon--AddGroup','aria-hidden':'true'}),' ',t('Guide action - import users csv')))),/* upgrade current round to auction */store.ui.showUpgrade&&__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement(GuideUpgradeLayer,{theme:theme},t('Guides - upgrade'),config.saleCommands.includes('settings')&&__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_Button__["c" /* Button */],{onClick:function onClick(){return store.ui.showSaleWizard('increase');}},__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement('i',{className:'ms-Icon ms-Icon--Feedback','aria-hidden':'true'}),' ',t('Guides - start open process'))),/* round closed, resolve */(store.ui.guideNext==='saleWizard'||store.ui.guideNext==='saleSimpleWizard')&&store.cmdBar.saleWizardEnabled&&__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement(GuideLayer,{theme:theme},store.ui.guideNext==='saleSimpleWizard'?t('Guides - offers present'):t('Guides - round closed'),__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_Button__["c" /* Button */],{onClick:store.ui.openOverview},__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement('i',{className:'ms-Icon ms-Icon--GroupedList','aria-hidden':'true'}),' ',t('Guides - Show overview')),config.saleCommands.includes('settings')&&__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_Button__["c" /* Button */],{onClick:function onClick(){return store.ui.showSaleWizard();}},__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement('i',{className:'ms-Icon ms-Icon--Feedback','aria-hidden':'true'}),' ',t('Guides - Manage the sale'))));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["e" /* observer */])(Guides));

/***/ }),
/* 2163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_src_app_components_ActionItem__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Rounds__ = __webpack_require__(2164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__stores_SaleStore__ = __webpack_require__(264);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2,_descriptor,_class3,_temp2;function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var excludedRoundTypes=['registration','counteroffer'];var RoundSelector=(_dec=Object(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx_react__["d" /* inject */])('app','sale'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_1__build_src_app_components_Localization__["a" /* localizable */])(_class=(_class2=(_temp2=_class3=function(_Component){_inherits(RoundSelector,_Component);function RoundSelector(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RoundSelector);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RoundSelector.__proto__||Object.getPrototypeOf(RoundSelector)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'openRoundWarning',_descriptor,_this),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RoundSelector,[{key:'render',value:function render(){var _props=this.props,className=_props.className,handleSelect=_props.handleSelect,theme=_props.theme;return __WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_src_app_components_ActionItem__["b" /* ActionWrapper */],{className:className+' clearfix'},this.rounds&&this.rounds.map(function(round){return __WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Rounds__["a" /* RoundItem */],Object.assign({handleSelect:handleSelect,theme:theme,round:round},{key:round,badges:(__WEBPACK_IMPORTED_MODULE_6__stores_SaleStore__["a" /* default */].saleConfig.roundTypeBadges||{})[round],costHighlight:(__WEBPACK_IMPORTED_MODULE_6__stores_SaleStore__["a" /* default */].saleConfig.roundCostHighlight||{})[round]}));}));}},{key:'rounds',get:function get(){var sale=this.props.sale;if(!!sale.features&&sale.features.isMasterSale)return['registration'];return sale.saleConfig.roundTypes.filter(function(round){return!excludedRoundTypes.includes(round);});}}]);return RoundSelector;}(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react__["Component"]),_class3.displayName='RoundSelector',_temp2),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'openRoundWarning',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_applyDecoratedDescriptor(_class2.prototype,'rounds',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class2.prototype,'rounds'),_class2.prototype)),_class2))||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx_react__["e" /* observer */])(RoundSelector));

/***/ }),
/* 2164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RoundItem__ = __webpack_require__(2165);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__RoundItem__["a"]; });


/***/ }),
/* 2165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RoundItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_src_app_components_ActionItem__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}// html output from string for dummies - as markdown etc. were too complicated to implement
var Formatter=function Formatter(_ref){var text=_ref.text;var transformed=text.split('\n').reduce(function(acc,v){if(v.indexOf('- ')!==0)return[].concat(_toConsumableArray(acc),[{type:'text',value:v}]);var trimmed=v.substring(2);var _ref2=acc.length>0?{done:acc.slice(0,acc.length-1),current:acc[acc.length-1]}:{done:[],current:undefined},done=_ref2.done,current=_ref2.current;if(!!current&&current.type==='bullets')return[].concat(_toConsumableArray(done),[{type:'bullets',value:[].concat(_toConsumableArray(current.value),[trimmed])}]);return[].concat(_toConsumableArray(acc),[{type:'bullets',value:[trimmed]}]);},[]);var rendered=transformed.map(function(_ref3,i){var type=_ref3.type,value=_ref3.value;if(type==='text')return __WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement('div',{key:i,style:{paddingTop:'5px'},dangerouslySetInnerHTML:{__html:value}});if(type==='bullets')return __WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement('ul',{key:i},value.map(function(a,i){return __WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement('li',{key:i,dangerouslySetInnerHTML:{__html:a}});}));return __WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement('div',{key:i});});return rendered;};var RoundItem=Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__["e" /* observer */])(_class=Object(__WEBPACK_IMPORTED_MODULE_1__build_src_app_components_Localization__["a" /* localizable */])(_class=(_temp=_class2=function(_Component){_inherits(RoundItem,_Component);function RoundItem(){_classCallCheck(this,RoundItem);return _possibleConstructorReturn(this,(RoundItem.__proto__||Object.getPrototypeOf(RoundItem)).apply(this,arguments));}_createClass(RoundItem,[{key:'render',value:function render(){var _props=this.props,t=_props.t,round=_props.round,theme=_props.theme,handleSelect=_props.handleSelect,badges=_props.badges,costHighlight=_props.costHighlight;var badge=!badges||!badges.length?undefined:[badges].flat().map(function(b){return t('badge '+b);}).join(t('badge_separator'));return __WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_src_app_components_ActionItem__["a" /* ActionItem */],{theme:theme,onClick:function onClick(){return handleSelect(round);}},__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement('div',{className:'header'},badge?__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement('span',{className:'badge'},badge):null,__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement('h2',null,t(round+'_title')),__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement('div',{className:'subtitle'},t(round+'_subtitle'))),__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement('div',{className:'description'},__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement('b',null,t('How it works'),':')),__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement(Formatter,{text:t(round+'_howItWorksPoints')})),__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement('b',null,t('When to use it'),':')),__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement(Formatter,{text:t(round+'_whenToUseItPoints')})),t(round+'_costs')!==round+'_costs'&&__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement('div',{style:costHighlight?{color:'red'}:{}},__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement('b',null,t('Costs'),':'),__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement(Formatter,{text:t(round+'_costs')}))));}}]);return RoundItem;}(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react__["Component"]),_class2.displayName='RoundItem',_temp))||_class)||_class;

/***/ }),
/* 2166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_DetailsList__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Icon__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_Link__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__build_src_app_components_OfferPreview__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__build_src_app_components_Money__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__RegistrationPanel__ = __webpack_require__(2168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ContactPanel__ = __webpack_require__(2169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__BulkRegistration_BulkRegistrationCsvPanel__ = __webpack_require__(2170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__BulkRegistration_BulkRegistrationInventoryPanel__ = __webpack_require__(2236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__RefuseDialog__ = __webpack_require__(2237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__DevLinkOffer__ = __webpack_require__(2238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__SelfRegistrationApprovalDialog__ = __webpack_require__(2239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__OfferNotificationsPanel__ = __webpack_require__(2240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_AuctionFinals_AuctionFinalsPanel__ = __webpack_require__(2244);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2,_descriptor,_descriptor2,_descriptor3,_class3,_temp;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var statusToHidePreview=['invited','submitted','refused'];var byDefaultDoNothing=function byDefaultDoNothing(){};var columns=function columns(t){var onClick=arguments.length>1&&arguments[1]!==undefined?arguments[1]:byDefaultDoNothing;var hasPreviousValue=arguments[2];var previousValue={key:'previousRound',name:t('Previous round'),fieldName:'previousRound',minWidth:100,maxWidth:150,onColumnClick:onClick,isSorted:false,isSortedDescending:false,isResizable:true};var columns=[{key:'preview',minWidth:20,maxWidth:20},{key:'name',name:t('Customer name'),fieldName:'name',minWidth:150,maxWidth:400,onColumnClick:onClick,isSorted:true,isSortedDescending:false,isResizable:true},{key:'status',name:t('Status'),fieldName:'status',minWidth:100,maxWidth:150,onColumnClick:onClick,isSorted:false,isSortedDescending:false,isResizable:true},{key:'invitedAt',name:t('Invited on'),fieldName:'invitedAt',minWidth:100,maxWidth:150,onColumnClick:onClick,isSorted:false,isSortedDescending:false,isResizable:true},{key:'submittedAt',name:t('Submitted at'),fieldName:'submittedAt',minWidth:100,maxWidth:150,onColumnClick:onClick,isSorted:false,isSortedDescending:false,isResizable:true},{key:'submittedValue',name:t('Submitted value'),fieldName:'submittedValue',minWidth:100,maxWidth:150,onColumnClick:onClick,isSorted:false,isSortedDescending:false,isResizable:true}];if(hasPreviousValue){columns.push(previousValue);}columns.push({key:'actions',minWidth:50});return columns;};var OffersSection=(_dec=Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__["d" /* inject */])('app','sale','user'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_7__build_src_app_components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__["e" /* observer */])(_class=(_class2=(_temp=_class3=function(_Component){_inherits(OffersSection,_Component);function OffersSection(props){_classCallCheck(this,OffersSection);var _this=_possibleConstructorReturn(this,(OffersSection.__proto__||Object.getPrototypeOf(OffersSection)).call(this,props));_initDefineProp(_this,'offersColumns',_descriptor,_this);_initDefineProp(_this,'submitError',_descriptor2,_this);_initDefineProp(_this,'dismissDisabled',_descriptor3,_this);_this.handleColumnHeaderClick=function(e,c){var t=_this.props.t;var field=c.fieldName;var index=_this.offersColumns.findIndex(function(c){return c.key===field;});var column=_this.offersColumns[index];if(!column){return;}var _this$props=_this.props,store=_this$props.store,_this$props$store$vie=_this$props.store.viewModel,vm=_this$props$store$vie===undefined?{}:_this$props$store$vie;if(!vm.offers||vm.offers.length===0){return;}switch(field){case'name':store.sortOffersByBuyerName(column.isSortedDescending);break;case'submittedValue':vm.offers=vm.offers.sortBy(field,column.isSortedDescending,function(v){return v||0;});break;case'status':vm.offers=vm.offers.sortBy(field,column.isSortedDescending,function(v){return t(v);});break;default:vm.offers=vm.offers.sortBy(field,column.isSortedDescending);break;}_this.offersColumns=_this.offersColumns.map(function(c,i){if(i!==index){c.isSorted=false;c.isSortedDescending=false;}else{c.isSorted=true;c.isSortedDescending=!c.isSortedDescending;}return c;});};_this.handleRenderItemColumn=function(item,index,column){var _this$props2=_this.props,t=_this$props2.t,ui=_this$props2.ui,sale=_this$props2.sale,user=_this$props2.user;var content=item[column.fieldName];var hasPermissions=sale.user.hasPermissions(item.agentData,user.roleDefinitions.readonly);switch(column.key){case'name':return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.Fragment,null,_this.renderBuyerName(item,ui,t),item.failedChannels&&item.failedChannels.includes('email')&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_Link__["Link"],{onClick:function onClick(){return ui.offerNotifications();}},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Icon__["Icon"],{iconName:'MailAlert',title:t('email_failed'),style:{color:'red',paddingLeft:'5px'}})),item.failedChannels&&item.failedChannels.includes('sms')&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_Link__["Link"],{onClick:function onClick(){return ui.offerNotifications();}},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Icon__["Icon"],{iconName:'Message',title:t('sms_failed'),style:{color:'red',paddingLeft:'5px'}})));case'submittedAt':var round=_this.props.store.root.round;if(round.isOpen&&item.status!=='confirmed'&&item.confirmedOffer&&item.confirmedOffer.submittedAt){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',null,item.confirmedOffer.submittedAt.toFormatedDateString('ll LTS'));}return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',null,content?content.toFormatedDateString('ll LTS'):'');case'invitedAt':case'expireAt':return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',null,content?content.toFormatedDateString('ll'):'');case'submittedValue':{var _round=_this.props.store.root.round;if(_round.type==='registration')return'';if(_round.isOpen&&item.status!=='confirmed'){if(item.data&&item.data.offer_gross_value&&item.confirmedOffer&&item.confirmedOffer.status==='confirmed'){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__build_src_app_components_Money__["a" /* default */],{value:item.data.offer_gross_value,currency:_this.props.app.currency.code,locale:_this.props.intl.locale});}return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',null);}return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',{style:{color:item.redButtonPriceFlag?'#dc1c2e':'inherit'}},content<0&&t('hidden'),content>=0&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__build_src_app_components_Money__["a" /* default */],{value:content,currency:_this.props.app.currency.code,locale:_this.props.intl.locale}));}case'previousRound':{var _round2=_this.props.store.root.round;var lastValues=item.previousRounds||{};var lastRound=Math.max.apply(Math,_toConsumableArray(Object.keys(lastValues)));if(!_round2.isOpen){var rounds=Object.keys(lastValues)||[];lastRound=rounds[rounds.length-2]||1;}if(lastRound<1){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',null);}return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',{style:{color:item.redButtonPriceFlag?'#dc1c2e':'inherit'}},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__build_src_app_components_Money__["a" /* default */],{value:lastValues[lastRound],defaultValue:content==='hidden'?t(content):content,currency:_this.props.app.currency.code,locale:_this.props.intl.locale}));}case'status':return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',{className:'offerstatus-'+content},t('offerstatus::'+content));case'preview':if(statusToHidePreview.some(function(s){return s===item.status;})||!item.isValid||!hasPermissions){return null;}return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_Link__["Link"],{onClick:function onClick(){return ui.showOfferPreview();}},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Icon__["Icon"],{iconName:'Preview'}));case'actions':return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{style:{textAlign:'right'}},hasPermissions?__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_Link__["Link"],{onClick:function onClick(){return ui.offerNotifications();}},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Icon__["Icon"],{iconName:'MailForward'})):null,'\xA0\xA0',__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__DevLinkOffer__["a" /* default */],{item:item}));default:return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',null,content);}};_this.renderBuyerName=function(offer,ui,t){if(!offer.buyer.buyer_lastName&&!offer.buyer.buyer_firstName&&!offer.buyer.buyer_company_name){if(offer.agentData){if(offer.agentData.buyer_reference)return _this.buyerName(t('Customer {buyer_reference} of {name}',offer.agentData),offer);return _this.buyerName(t('Customer of {name}',offer.agentData),offer);}return _this.buyerName(t('Customer'),offer);}var names=[];names.push(offer.buyer.buyer_firstName+' '+offer.buyer.buyer_lastName);if(offer.buyer.buyer_type==='company')names.push(offer.buyer.buyer_company_name);if(offer.buyer.others)offer.buyer.others.forEach(function(buyer2){names.push(buyer2.buyer_firstName+' '+buyer2.buyer_lastName);});var name=names.join(', ');return _this.buyerName(name,offer,function(){return ui.editOffer();});};_this.buyerName=function(content,offer,onClick){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',{onClick:onClick,style:{cursor:onClick?'pointer':'inherit',textDecoration:offer.buyerIsBlocked?'line-through':'underline'}},content);};_this.handleSelectionChanged=function(){_this.props.store.select(_this.selection.getSelection()[0]);};_this.handleClosePanel=function(){if(!_this.dismissDisabled)_this.props.ui.closePanel();};_this.handleRegistration=function(reg){_this.submitError=null;_this.props.store.register(reg).then(function(){_this.handleClosePanel();},function(error){if(error&&error.response&&error.response.result&&!error.response.result.successful&&error.response.result.error){_this.submitError={data:reg,error:error.response.result.error};}else{_this.props.sale.failed(error);_this.handleClosePanel();}});};_this.handleUpdateOffer=function(offer){_this.submitError=null;_this.props.store.updateBuyer(offer).then(function(){_this.handleClosePanel();},function(error){if(error&&error.response&&error.response.result&&!error.response.result.successful&&error.response.result.error){_this.submitError={data:offer,error:error.response.result.error};}else{_this.props.sale.failed(error);_this.handleClosePanel();}});};_this.handleUpdateContact=function(contact){_this.submitError=null;_this.props.store.updateContact(contact).then(function(){_this.handleClosePanel();},function(error){if(error&&error.response&&error.response.result&&!error.response.result.successful&&error.response.result.error){_this.submitError={data:contact,error:error.response.result.error};}else{_this.props.sale.failed(error);_this.handleClosePanel();}});};_this.handleUploadOffer=function(offer){_this.submitError=null;_this.props.store.uploadOffer(offer).then(function(){_this.handleClosePanel();},function(error){if(error&&error.response&&error.response.result&&!error.response.result.successful&&error.response.result.error){_this.submitError={data:offer,error:error.response.result.error};}else{_this.props.sale.failed(error);_this.handleClosePanel();}});};_this.handleIncreaseOffer=function(offer){_this.props.store.increaseOffer(offer);_this.handleClosePanel();};_this.handleRefuseOffer=function(reason,offer){_this.props.store.refuse(reason,offer);_this.handleClosePanel();};_this.handleApproveRegistration=function(_ref){var offerData=_ref.offerData;_this.props.store.approveRegistration(offerData);_this.handleClosePanel();};_this.selection=new __WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_DetailsList__["d" /* Selection */]({onSelectionChanged:_this.handleSelectionChanged});return _this;}_createClass(OffersSection,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,round=_props.store.root.round,t=_props.t;if(round.definition){var hasPreviousValue=round.definition.number>1;this.offersColumns=columns(t,this.handleColumnHeaderClick,hasPreviousValue);}var inviteStr=sessionStorage.getItem('invite');var hasInvitation=inviteStr&&inviteStr.length>0;if(!hasInvitation){return;}var sale=this.props.sale;var canInvite=sale.cmdBar.userRegistrationEnabled;if(canInvite){var invite=JSON.parse(inviteStr);this.props.ui.currentPanel=invite.panel;}else{sessionStorage.removeItem('invite');sale.error={code:'registration_disabled'};}}},{key:'componentWillReact',value:function componentWillReact(){var _props2=this.props,round=_props2.store.root.round,t=_props2.t;if(round.definition){var hasPreviousValue=round.definition.number>1;this.offersColumns=columns(t,this.handleColumnHeaderClick,hasPreviousValue);}}},{key:'render',value:function render(){var _this2=this;var _props3=this.props,ui=_props3.ui,_props3$store=_props3.store,_props3$store$viewMod=_props3$store.viewModel,vm=_props3$store$viewMod===undefined?{}:_props3$store$viewMod,selected=_props3$store.selectedOffer,t=_props3.t;var _props$store$root=this.props.store.root,saleEdit=_props$store$root.saleEdit,round=_props$store$root.round;// if (!vm.isEnabled) {
//   return <span />;
// }
return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',null,vm.offers&&vm.offers.length>0&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_DetailsList__["b" /* DetailsList */],{columns:this.offersColumns,items:vm.offers||[],onRenderItemColumn:this.handleRenderItemColumn,selectionMode:1,checkboxVisibility:0,selection:this.selection,selectionPreservedOnEmptyClick:true,layoutMode:__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_DetailsList__["c" /* DetailsListLayoutMode */].justified}),ui.currentPanel==='registration'&&this.renderRegistrationPanel({sale:saleEdit,onSave:this.handleRegistration}),ui.currentPanel==='bulkRegistrationCsv'&&this.renderBulkRegistrationCsvPanel({sale:saleEdit}),ui.currentPanel==='bulkRegistrationOnOffice'&&this.renderBulkRegistrationInventoryPanel({sale:saleEdit,title:t('OnOffice Import')}),ui.currentPanel==='bulkRegistrationPropUp'&&this.renderBulkRegistrationInventoryPanel({sale:saleEdit,title:t('PropUp Import')}),ui.currentPanel==='bulkRegistrationPropstack'&&this.renderBulkRegistrationInventoryPanel({sale:saleEdit,title:t('Propstack Import')}),ui.currentPanel==='bulkRegistrationCrm'&&this.renderBulkRegistrationInventoryPanel({sale:saleEdit,title:t('CRM Import')}),ui.currentPanel==='editOffer'&&!!selected&&this.renderRegistrationPanel({sale:saleEdit,onSave:this.handleUpdateOffer,offer:selected}),ui.currentPanel==='updateContact'&&!!selected&&this.renderUpdateContact({sale:saleEdit,onSave:this.handleUpdateContact,offer:selected}),ui.currentPanel==='registerOnBehalf'&&this.renderRegistrationPanel({sale:saleEdit,round:round,onSave:function onSave(o){_this2.dismissDisabled=true;ui.prompt.open({title:!!selected&&selected.isValid?t('Increase offer on behalf of the customer'):t('Upload offer on behalf of a customer'),content:'upload',action:function action(){_this2.dismissDisabled=false;if(!!selected&&selected.isValid)_this2.handleIncreaseOffer(o);else _this2.handleUploadOffer(o);}});},mode:!!selected&&selected.isValid?'increase':'upload',offer:selected}),ui.currentPanel==='registrationApproval'&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__SelfRegistrationApprovalDialog__["a" /* default */],{sale:saleEdit,offer:selected,onSubmit:this.handleApproveRegistration,onClose:this.handleClosePanel}),ui.currentPanel==='refuse'&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__RefuseDialog__["a" /* default */],{sale:saleEdit,offer:selected,onSubmit:this.handleRefuseOffer,onClose:this.handleClosePanel}),ui.currentPanel==='offerPreview'&&selected&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__build_src_app_components_OfferPreview__["a" /* default */],{closePanel:function closePanel(){return ui.closePanel();}// selectedOffer={selected}
// url={`/api/v1/offers/${selected.saleId}/${selected.buyerId}/preview?locale={user.claims.locale}`}
,data:{template:'/api/v1/offers/{saleId}/{offerId}/preview',saleId:selected.saleId,offerId:selected.buyerId}}),ui.currentPanel==='offerNotifications'&&!!selected&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__OfferNotificationsPanel__["a" /* default */],{sale:saleEdit,offer:selected,isOpen:true,onClose:this.handleClosePanel}),ui.currentPanel==='auctionFinals'&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_AuctionFinals_AuctionFinalsPanel__["a" /* default */],{sale:saleEdit.root,onClose:this.handleClosePanel}));}},{key:'renderRegistrationPanel',value:function renderRegistrationPanel(_ref2){var sale=_ref2.sale,round=_ref2.round,onSave=_ref2.onSave,_ref2$offer=_ref2.offer,offer=_ref2$offer===undefined?undefined:_ref2$offer,_ref2$mode=_ref2.mode,mode=_ref2$mode===undefined?'read':_ref2$mode;var hasPermissions=this.props.sale.hasOfferPermissions;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__RegistrationPanel__["a" /* default */],{sale:sale,round:round,offer:offer,mode:mode,isOpen:true,onSave:onSave,onClose:this.handleClosePanel,usedEmails:this.props.store.emails,submitError:this.submitError,hasPermissions:hasPermissions});}},{key:'renderUpdateContact',value:function renderUpdateContact(_ref3){var sale=_ref3.sale,onSave=_ref3.onSave,_ref3$offer=_ref3.offer,offer=_ref3$offer===undefined?undefined:_ref3$offer;var hasPermissions=this.props.sale.hasOfferPermissions;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ContactPanel__["a" /* default */],{sale:sale,offer:offer,isOpen:true,onSave:onSave,onClose:this.handleClosePanel,usedEmails:this.props.store.emails,submitError:this.submitError,hasPermissions:hasPermissions});}},{key:'renderBulkRegistrationCsvPanel',value:function renderBulkRegistrationCsvPanel(_ref4){var sale=_ref4.sale,round=_ref4.round,_ref4$offer=_ref4.offer,offer=_ref4$offer===undefined?undefined:_ref4$offer,_ref4$mode=_ref4.mode,mode=_ref4$mode===undefined?'read':_ref4$mode;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__BulkRegistration_BulkRegistrationCsvPanel__["a" /* default */],{sale:sale,round:round,offer:offer,mode:mode,isOpen:true,onClose:this.handleClosePanel,usedEmails:this.props.store.emails,submitError:this.submitError});}},{key:'renderBulkRegistrationInventoryPanel',value:function renderBulkRegistrationInventoryPanel(_ref5){var sale=_ref5.sale,round=_ref5.round,_ref5$offer=_ref5.offer,offer=_ref5$offer===undefined?undefined:_ref5$offer,_ref5$mode=_ref5.mode,mode=_ref5$mode===undefined?'read':_ref5$mode,_ref5$title=_ref5.title,title=_ref5$title===undefined?'':_ref5$title;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__BulkRegistration_BulkRegistrationInventoryPanel__["a" /* default */],{sale:sale,round:round,offer:offer,mode:mode,isOpen:true,title:title,onClose:this.handleClosePanel,usedEmails:this.props.store.emails,submitError:this.submitError});}/*
  renderBulkRegistrationPropUpPanel({
    sale,
    round,
    offer = undefined,
    mode = 'read',
  }) {
    return (
      <BulkRegistrationPropUpPanel
        sale={sale}
        round={round}
        offer={offer}
        mode={mode}
        isOpen={true}
        onClose={this.handleClosePanel}
        usedEmails={this.props.store.emails}
        submitError={this.submitError}
      />
    );
  }
  */}]);return OffersSection;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class3.displayName='OffersSection',_class3.propTypes={store:__WEBPACK_IMPORTED_MODULE_1__build_node_modules_prop_types___default.a.object.isRequired},_temp),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'offersColumns',[__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,'submitError',[__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:null}),_descriptor3=_applyDecoratedDescriptor(_class2.prototype,'dismissDisabled',[__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}})),_class2))||_class)||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (OffersSection);

/***/ }),
/* 2167 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_src_app_components_dynamicImport__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_src_app_services_request__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2,_descriptor,_descriptor2,_descriptor3,_class3,_temp2;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var RegistrationPanelContent=Object(__WEBPACK_IMPORTED_MODULE_2__build_src_app_components_dynamicImport__["b" /* default */])({component:'/containers/Sale/OffersSection/RegistrationPanel'});var RegistrationPanel=(_dec=Object(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx_react__["d" /* inject */])('app','sale','user'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_3__build_src_app_components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx_react__["e" /* observer */])(_class=(_class2=(_temp2=_class3=function(_Component){_inherits(RegistrationPanel,_Component);function RegistrationPanel(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RegistrationPanel);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RegistrationPanel.__proto__||Object.getPrototypeOf(RegistrationPanel)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'agents',_descriptor,_this),_initDefineProp(_this,'loading',_descriptor2,_this),_initDefineProp(_this,'invite',_descriptor3,_this),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RegistrationPanel,[{key:'componentDidMount',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(){var _this2=this;var inviteStr,_props,sale,user,app,um,result;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:try{inviteStr=sessionStorage.getItem('invite');if(!!inviteStr){this.invite=JSON.parse(inviteStr).payload;sessionStorage.removeItem('invite');}}catch(e){}_props=this.props,sale=_props.sale,user=_props.user,app=_props.app;if(sale.root.isMls){_context.next=5;break;}this.loading=false;return _context.abrupt('return');case 5:_context.prev=5;this.loading=true;um=app.config&&app.config.userManagement&&app.config.userManagement.url?app.config.userManagement.url:'';_context.next=10;return Object(__WEBPACK_IMPORTED_MODULE_6__build_src_app_services_request__["d" /* get */])(um+'/users/lookup',user.accessToken);case 10:result=_context.sent;Object(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_mobx__["l" /* runInAction */])(function(){_this2.loading=false;_this2.agents=result?result:[];});_context.next=16;break;case 14:_context.prev=14;_context.t0=_context['catch'](5);case 16:case'end':return _context.stop();}}},_callee,this,[[5,14]]);}));function componentDidMount(){return _ref2.apply(this,arguments);}return componentDidMount;}()},{key:'render',value:function render(){return this.loading?null:__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(RegistrationPanelContent,Object.assign({},this.props,{agents:this.agents,invite:this.invite}));}}]);return RegistrationPanel;}(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__["Component"]),_class3.displayName='RegistrationPanel',_temp2),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'agents',[__WEBPACK_IMPORTED_MODULE_4__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:null}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,'loading',[__WEBPACK_IMPORTED_MODULE_4__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor3=_applyDecoratedDescriptor(_class2.prototype,'invite',[__WEBPACK_IMPORTED_MODULE_4__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return null;}})),_class2))||_class)||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (RegistrationPanel);

/***/ }),
/* 2169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_src_app_components_EmailField__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_src_app_components_PanelFooter__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_src_app_containers_Sale_OffersSection_style_css__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_src_app_containers_Sale_OffersSection_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__build_src_app_containers_Sale_OffersSection_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_Panel__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__build_node_modules_office_ui_fabric_react_lib_TextField__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2,_descriptor,_descriptor2,_class3,_temp2;function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var ContactPanel=(_dec=Object(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx_react__["d" /* inject */])('app','user'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_1__build_src_app_components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx_react__["e" /* observer */])(_class=(_class2=(_temp2=_class3=function(_Component){_inherits(ContactPanel,_Component);function ContactPanel(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ContactPanel);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ContactPanel.__proto__||Object.getPrototypeOf(ContactPanel)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'email',_descriptor,_this),_initDefineProp(_this,'phoneNumber',_descriptor2,_this),_this.emailValidation=function(_){if(_this.isUnique){return'';}var t=_this.props.t;return t('Already registered');},_this.handleSave=function(){var onSave=_this.props.onSave;if(!onSave)return;onSave({email:_this.email,phoneNumber:_this.phoneNumber});},_this.handleClose=function(){var onClose=_this.props.onClose;if(onClose)onClose();},_this.handleChanged=function(field){return function(value,index,customValue){var valueKey=!!value?value.key:undefined;_this[field]=customValue||valueKey||value;};},_this.renderPanelFooterContent=function(){var t=_this.props.t;return __WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__build_src_app_components_PanelFooter__["a" /* FooterContainer */],null,__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_Button__["h" /* PrimaryButton */],{onClick:_this.handleSave,style:{marginRight:'8px'},disabled:!_this.isValid},t('Save')),__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_Button__["f" /* DefaultButton */],{onClick:_this.handleClose},t('Cancel')));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ContactPanel,[{key:'componentDidMount',value:function componentDidMount(){var offer=this.props.offer;this.email=offer.buyer.buyer_email;this.phoneNumber=offer.buyer.buyer_phone;}},{key:'render',value:function render(){var _this2=this;var t=this.props.t;return __WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_Panel__["a" /* Panel */],{headerText:t('Update Contact'),type:__WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_Panel__["b" /* PanelType */].medium,isOpen:this.props.isOpen,onDismiss:this.handleClose,onRenderFooterContent:function onRenderFooterContent(){return _this2.renderPanelFooterContent();},isFooterAtBottom:true,closeButtonAriaLabel:'Close'},__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid'},__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-lg6 ms-md12 ms-sm12'},__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_src_app_components_EmailField__["a" /* default */],{label:t('Email'),value:this.email,iconProps:{iconName:'Mail'},required:true,onChanged:this.handleChanged('email'),validateOnLoad:false,onGetErrorMessage:this.emailValidation,componentRef:function componentRef(ref){return _this2.emailTextField=ref;},validateOnFocusOut:true,autoComplete:'nope'})),__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-lg6 ms-md12 ms-sm12'},__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__build_node_modules_office_ui_fabric_react_lib_TextField__["a" /* TextField */],{label:t('Phone number'),placeholder:t('Phone number placeholder'),value:this.phoneNumber,iconProps:{iconName:'Phone'},onChanged:this.handleChanged('phoneNumber'),validateOnLoad:false,componentRef:function componentRef(ref){return _this2.phoneNumberTextField=ref;},errorMessage:this.phoneNumberError,validateOnFocusIn:true,validateOnFocusOut:true,autoComplete:'nope',inputMode:'tel'})))));}},{key:'isUnique',get:function get(){var offer=this.props.offer;if(offer&&offer.buyer&&offer.buyer.buyer_email===this.email){return true;}return this.email!==''&&!this.props.usedEmails.includes(this.email);}},{key:'isValid',get:function get(){var hasPermissions=this.props.hasPermissions;return this.isUnique&&hasPermissions;}},{key:'phoneNumberError',get:function get(){var _props=this.props,submitError=_props.submitError,t=_props.t;return submitError&&submitError.data.phoneNumber===this.phoneNumber&&submitError.error.startsWith('phone_number_')?t('phonenumbererror::'+submitError.error.substring('phone_number_'.length)):'';}}]);return ContactPanel;}(__WEBPACK_IMPORTED_MODULE_9__build_node_modules_react__["Component"]),_class3.displayName='ContactPanel',_temp2),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'email',[__WEBPACK_IMPORTED_MODULE_4__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,'phoneNumber',[__WEBPACK_IMPORTED_MODULE_4__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return'';}}),_applyDecoratedDescriptor(_class2.prototype,'isUnique',[__WEBPACK_IMPORTED_MODULE_4__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class2.prototype,'isUnique'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'isValid',[__WEBPACK_IMPORTED_MODULE_4__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class2.prototype,'isValid'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'phoneNumberError',[__WEBPACK_IMPORTED_MODULE_4__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class2.prototype,'phoneNumberError'),_class2.prototype)),_class2))||_class)||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (ContactPanel);

/***/ }),
/* 2170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_react_papaparse__ = __webpack_require__(2171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_moment_timezone__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_node_modules_lodash__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_node_modules_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_Panel__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__build_node_modules_office_ui_fabric_react_lib_Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__build_node_modules_office_ui_fabric_react_lib_MessageBar__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CsvMappingTable__ = __webpack_require__(2184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__BulkRegistrationTable__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__BulkRegistrationPanelBase__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__BulkRegistrationStore__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__build_node_modules_office_ui_fabric_react_lib_Dropdown__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__build_src_app_helpers_uploadTypes__ = __webpack_require__(302);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value2,_class2,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_class3,_temp2;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var maxDataShow=5;// max number of rows in the mapping preview
var getAt=function getAt(arr,index){var defaultValue=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;return index>=0&&index<arr.length?arr[index]:defaultValue;};var encodings=['UTF-8','ISO-8859-1','ISO-8859-2'];var BulkRegistrationCsvPanel=(_dec=Object(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx_react__["d" /* inject */])('app','user','sale'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_10__build_src_app_components_Localization__["a" /* localizable */])(_class=(_class2=(_temp2=_class3=function(_BulkRegistrationPane){_inherits(BulkRegistrationCsvPanel,_BulkRegistrationPane);function BulkRegistrationCsvPanel(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,BulkRegistrationCsvPanel);for(var _len=arguments.length,args=Array(_len),_key2=0;_key2<_len;_key2++){args[_key2]=arguments[_key2];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BulkRegistrationCsvPanel.__proto__||Object.getPrototypeOf(BulkRegistrationCsvPanel)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'encoding',_descriptor,_this),_this.fields={},_initDefineProp(_this,'loading',_descriptor2,_this),_initDefineProp(_this,'loaded',_descriptor3,_this),_initDefineProp(_this,'enableBackToMapping',_descriptor4,_this),_initDefineProp(_this,'data',_descriptor5,_this),_initDefineProp(_this,'mapping',_descriptor6,_this),_initDefineProp(_this,'errors',_descriptor7,_this),_this.handleOpenDialog=function(e){if(_this.csvReaderRef){_this.csvReaderRef.open(e);_this.reset();}},_this.encodingChange=function(ev,option){_this.encoding=option.key;},_initDefineProp(_this,'handleOnFileLoad',_descriptor8,_this),_this.resolveColumnMapping=function(data){_this.mapping.clear();data.forEach(function(value){var mappedKey='';if(value){// assume the value from the input row to be a header
var _value=value.toUpperCase();__WEBPACK_IMPORTED_MODULE_6__build_node_modules_lodash___default.a.forOwn(_this.fields,function(field,key){// check our fields and try to match the header to one of the defined field header candidates
var header=__WEBPACK_IMPORTED_MODULE_6__build_node_modules_lodash___default.a.find(field.headers,function(_header){return _header.toUpperCase()===_value;});// there can multiple columns mapped to the same field
if(header&&/*!this.mapping.includes(key) &&*/!mappedKey){// we found a candidate which is not yet mapped
mappedKey=key;}});}_this.mapping.push(mappedKey);});},_this.handleOnError=function(err,file,inputElem,reason){_this.errors.push(reason);},_this.handleImport=function(){// convert each imported row into our import object using the mapping
var inverseMapping=_this.inverseMapping;_this.data.forEach(function(_data){var _item=__WEBPACK_IMPORTED_MODULE_6__build_node_modules_lodash___default.a.mapValues(_this.fields,function(field,key){// pick the first non-empty csv field that are mapped to this field
var candidates=inverseMapping[key].map(function(index){return getAt(_data,index,'');}).filter(function(value){return!!value;});var value=candidates.length>0?candidates[0]:'';//if (typeof field.import === 'function')
//  value = field.import(value, _data);
return value;});// apply 'import' functions
__WEBPACK_IMPORTED_MODULE_6__build_node_modules_lodash___default.a.forOwn(_this.fields,function(field,key){if(typeof field.import==='function')_item[key]=field.import(_item[key],_item,_data);});_item.requiredUploads=Object(__WEBPACK_IMPORTED_MODULE_16__build_src_app_helpers_uploadTypes__["a" /* getDefaultUploadTypes */])(_this.props.sale.root.saleConfig,_this.props.sale.offerData);_this.store.add(_item);});_this.editing=true;},_this.renderFormatedDate=function(date){return new Date(date).toFormatedDateString('L');},_this.parseDateFromString=function(value){return!!value?__WEBPACK_IMPORTED_MODULE_5__build_node_modules_moment_timezone___default()(value,'DD.MM.YYYY').toDate():value;},_this.handleBackToMapping=function(){_this.editing=false;_this.store.items.clear();},_this.handleSave=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(){var onClose;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:onClose=_this.props.onClose;_context.next=3;return _this.store.save();case 3://this.enableBackToMapping = false; // you can't go back once you tried to upload the registrations
// if nothing's left -> close the panel
if(!__WEBPACK_IMPORTED_MODULE_6__build_node_modules_lodash___default.a.find(_this.store.items,function(item){return!_this.store.isItemEmpty(item);})){if(onClose)onClose();// only if there's no item left
}case 4:case'end':return _context.stop();}}},_callee,_this2);})),_this.renderPanelFooterContentAdditional=function(){var t=_this.props.t;return __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__["Fragment"],null,_this.loaded&&_this.editing&&_this.enableBackToMapping&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__build_node_modules_office_ui_fabric_react_lib_Button__["f" /* DefaultButton */],{onClick:_this.handleBackToMapping,disabled:false,style:{marginRight:'8px',alignSelf:'flex-end'},iconProps:{iconName:'Back'}},t('Back to mapping')));},_temp),_possibleConstructorReturn(_this,_ret);}// fields[<field key>] = { field properties from config schema }
// raw loaded data
_createClass(BulkRegistrationCsvPanel,[{key:'reset',value:function reset(){this.store.reset();this.loading=false;this.loaded=false;this.editing=false;this.enableBackToMapping=false;this.data.clear();this.mapping.clear();this.errors.clear();}},{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,user=_props.user,sale=_props.sale,usedEmails=_props.usedEmails,t=_props.t;this.store=new __WEBPACK_IMPORTED_MODULE_14__BulkRegistrationStore__["a" /* default */](user,sale,sale.round,usedEmails,t);var config=sale.root.saleConfig;this.reset();this.fields=config.getRegistrationScheme(sale,t);if(config.csvImportDefaultEncoding&&encodings.includes(config.csvImportDefaultEncoding)){this.encoding=config.csvImportDefaultEncoding;var self=this;setTimeout(function(){self.handleOpenDialog(document.createEvent('Event'));},250);}}},{key:'render',value:function render(){var _this3=this;var _props2=this.props,t=_props2.t,sale=_props2.sale,usedEmails=_props2.usedEmails;return __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_Panel__["a" /* Panel */],{headerText:t('Import from CSV file'),hasCloseButton:false,type:__WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_Panel__["b" /* PanelType */].smallFluid,isOpen:this.props.isOpen,onDismiss:this.handleClose,onRenderFooterContent:function onRenderFooterContent(){return _this3.renderPanelFooterContent();},isFooterAtBottom:true,closeButtonAriaLabel:'Close',styles:{content:{height:'100%',paddingBottom:'0'}}},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx_react__["a" /* Observer */],{render:function render(){return __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__["Fragment"],null,!_this3.loaded&&!sale.root.saleConfig.csvImportDefaultEncoding&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm2'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__build_node_modules_office_ui_fabric_react_lib_Dropdown__["a" /* Dropdown */],{label:t('Encoding'),selectedKey:_this3.encoding,options:encodings.map(function(encoding){return{key:encoding,text:encoding};}),onChange:_this3.encodingChange})))),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react_papaparse__["a" /* CSVReader */],{disableClick:true,ref:function ref(node){_this3.csvReaderRef=node;},onFileLoad:_this3.handleOnFileLoad,onError:_this3.handleOnError,noClick:true,isReset:true,config:{dynamicTyping:false,skipEmptyLines:true,encoding:_this3.encoding}},function(_ref3){var file=_ref3.file;return __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__["Fragment"],null,!_this3.loaded&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row',style:{paddingTop:'10px',paddingBottom:'10px'}},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__build_node_modules_office_ui_fabric_react_lib_Button__["h" /* PrimaryButton */],{onClick:_this3.handleOpenDialog,disabled:false},'1. '+t('Upload'))))));}),_this3.errors.length>0&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row',style:{padding:'10px 0'}},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__build_node_modules_office_ui_fabric_react_lib_MessageBar__["a" /* MessageBar */],{messageBarType:__WEBPACK_IMPORTED_MODULE_9__build_node_modules_office_ui_fabric_react_lib_MessageBar__["b" /* MessageBarType */].error},_this3.errors.map(function(error,index){return __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{key:index},error);}))))),_this3.loaded&&!_this3.editing&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('strong',null,t('Total number of rows: {count}',{count:_this3.data.length})))))),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__CsvMappingTable__["a" /* default */],{data:_this3.dataReduced,fields:_this3.fields,mapping:_this3.mapping}))),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row',style:{paddingTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__build_node_modules_office_ui_fabric_react_lib_Button__["h" /* PrimaryButton */],{onClick:_this3.handleImport,disabled:false},'2. '+t('Import'))))),_this3.loaded&&_this3.editing&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__["Fragment"],null,_this3.renderRegistrationResult(),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__BulkRegistrationTable__["a" /* default */],{store:_this3.store,usedEmails:usedEmails})));}}));}},{key:'inverseMapping',// csv field mapping, mapping[<column index (in csv data)>] = <field key> | ''
// inverseMapping[<field key>] = [array of <column index (in csv data)>]
get:function get(){var _this4=this;return __WEBPACK_IMPORTED_MODULE_6__build_node_modules_lodash___default.a.mapValues(this.fields,function(value,key){return _this4.mapping.map(function(_key,_index){return key===_key?_index:-1;}).filter(function(_index){return _index>=0;});});}},{key:'mappedFieldsCount',get:function get(){var inverseMapping=this.inverseMapping;return __WEBPACK_IMPORTED_MODULE_6__build_node_modules_lodash___default.a.filter(this.fields,function(field,key){return inverseMapping[key]&&inverseMapping[key].length>0;}).length;}},{key:'areAllMainFieldsMapped',get:function get(){var inverseMapping=this.inverseMapping;return!__WEBPACK_IMPORTED_MODULE_6__build_node_modules_lodash___default.a.some(this.fields,function(field,key){return!field.additional&&!(field.target instanceof Array&&field.target.length===0)&&(!inverseMapping[key]||inverseMapping[key].length===0);});}},{key:'dataReduced',get:function get(){return this.data.length>maxDataShow?__WEBPACK_IMPORTED_MODULE_6__build_node_modules_lodash___default.a.take(this.data,maxDataShow).concat([['...']]):this.data;}},{key:'canSave',get:function get(){return!this.importing&&this.editing&&!this.store.saving&&this.store.validItemsCount>0;}}]);return BulkRegistrationCsvPanel;}(__WEBPACK_IMPORTED_MODULE_13__BulkRegistrationPanelBase__["a" /* default */]),_class3.displayName='BulkRegistrationCsvPanel',_temp2),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'encoding',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return'UTF-8';}}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,'loading',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor3=_applyDecoratedDescriptor(_class2.prototype,'loaded',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor4=_applyDecoratedDescriptor(_class2.prototype,'enableBackToMapping',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor5=_applyDecoratedDescriptor(_class2.prototype,'data',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["j" /* observable */])([]);}}),_descriptor6=_applyDecoratedDescriptor(_class2.prototype,'mapping',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["j" /* observable */])([]);}}),_applyDecoratedDescriptor(_class2.prototype,'inverseMapping',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class2.prototype,'inverseMapping'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'mappedFieldsCount',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class2.prototype,'mappedFieldsCount'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'areAllMainFieldsMapped',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class2.prototype,'areAllMainFieldsMapped'),_class2.prototype),_descriptor7=_applyDecoratedDescriptor(_class2.prototype,'errors',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["j" /* observable */])([]);}}),_applyDecoratedDescriptor(_class2.prototype,'dataReduced',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class2.prototype,'dataReduced'),_class2.prototype),_descriptor8=_applyDecoratedDescriptor(_class2.prototype,'handleOnFileLoad',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this5=this;return function(data){_this5.reset();var maxcolcount=0;_this5.mapping.clear();__WEBPACK_IMPORTED_MODULE_6__build_node_modules_lodash___default.a.forEach(data,function(row,index){if(row.errors.length>0){__WEBPACK_IMPORTED_MODULE_6__build_node_modules_lodash___default.a.forEach(row.errors,function(error){_this5.errors.push('['+(index+1)+'] '+error.message);});}if(index===0){// assume the first line to be headers and try to identify column mapping
_this5.resolveColumnMapping(row.data);_this5.enableBackToMapping=!_this5.areAllMainFieldsMapped;if(_this5.mappedFieldsCount===0)_this5.data.push(row.data);// no column has been mapped -> assume no headers in the first row
}else _this5.data.push(row.data);if(row.data.length>maxcolcount)maxcolcount=row.data.length;});_this5.loaded=true;// if all main fields are mapped, continue with import
if(_this5.areAllMainFieldsMapped)_this5.handleImport();};}}),_applyDecoratedDescriptor(_class2.prototype,'canSave',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class2.prototype,'canSave'),_class2.prototype)),_class2))||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (BulkRegistrationCsvPanel);

/***/ }),
/* 2171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export BAD_DELIMITERS */
/* unused harmony export BUTTON_TYPE */
/* unused harmony export CSVDownloader */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ue; });
/* unused harmony export DefaultDelimiter */
/* unused harmony export LINK_TYPE */
/* unused harmony export LocalChunkSize */
/* unused harmony export RECORD_SEP */
/* unused harmony export UNIT_SEP */
/* unused harmony export WORKERS_SUPPORTED */
/* unused harmony export jsonToCSV */
/* unused harmony export readRemoteFile */
/* unused harmony export readString */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_stream__ = __webpack_require__(2172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_stream___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_stream__);
"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self&&self;function t(e,t){return e(t={exports:{}},t.exports),t.exports}var r=t((function(t,r){
/* @license
Papa Parse
v5.3.0
https://github.com/mholt/PapaParse
License: MIT
*/
t.exports=function t(){var r="undefined"!=typeof self?self:"undefined"!=typeof window?window:void 0!==r?r:{},n=!r.document&&!!r.postMessage,o=n&&/blob:/i.test((r.location||{}).protocol),i={},a=0,s={parse:function(e,n){var o=(n=n||{}).dynamicTyping||!1;if(E(o)&&(n.dynamicTypingFunction=o,o={}),n.dynamicTyping=o,n.transform=!!E(n.transform)&&n.transform,n.worker&&s.WORKERS_SUPPORTED){var u=function(){if(!s.WORKERS_SUPPORTED)return!1;var e,n,o=(e=r.URL||r.webkitURL||null,n=t.toString(),s.BLOB_URL||(s.BLOB_URL=e.createObjectURL(new Blob(["(",n,")();"],{type:"text/javascript"})))),u=new r.Worker(o);return u.onmessage=g,u.id=a++,i[u.id]=u,u}();return u.userStep=n.step,u.userChunk=n.chunk,u.userComplete=n.complete,u.userError=n.error,n.step=E(n.step),n.chunk=E(n.chunk),n.complete=E(n.complete),n.error=E(n.error),delete n.worker,void u.postMessage({input:e,config:n,workerId:u.id})}var l=null;return e===s.NODE_STREAM_INPUT&&"undefined"==typeof PAPA_BROWSER_CONTEXT?(l=new h(n)).getStream():("string"==typeof e?l=n.download?new c(n):new d(n):!0===e.readable&&E(e.read)&&E(e.on)?l=new p(n):(r.File&&e instanceof File||e instanceof Object)&&(l=new f(n)),l.stream(e))},unparse:function(e,t){var r=!1,n=!0,o=",",i="\r\n",a='"',u=a+a,l=!1,c=null,f=!1;!function(){if("object"==typeof t){if("string"!=typeof t.delimiter||s.BAD_DELIMITERS.filter((function(e){return-1!==t.delimiter.indexOf(e)})).length||(o=t.delimiter),("boolean"==typeof t.quotes||"function"==typeof t.quotes||Array.isArray(t.quotes))&&(r=t.quotes),"boolean"!=typeof t.skipEmptyLines&&"string"!=typeof t.skipEmptyLines||(l=t.skipEmptyLines),"string"==typeof t.newline&&(i=t.newline),"string"==typeof t.quoteChar&&(a=t.quoteChar),"boolean"==typeof t.header&&(n=t.header),Array.isArray(t.columns)){if(0===t.columns.length)throw new Error("Option columns is empty");c=t.columns}void 0!==t.escapeChar&&(u=t.escapeChar+a),"boolean"==typeof t.escapeFormulae&&(f=t.escapeFormulae)}}();var d=new RegExp(v(a),"g");if("string"==typeof e&&(e=JSON.parse(e)),Array.isArray(e)){if(!e.length||Array.isArray(e[0]))return h(null,e,l);if("object"==typeof e[0])return h(c||p(e[0]),e,l)}else if("object"==typeof e)return"string"==typeof e.data&&(e.data=JSON.parse(e.data)),Array.isArray(e.data)&&(e.fields||(e.fields=e.meta&&e.meta.fields),e.fields||(e.fields=Array.isArray(e.data[0])?e.fields:p(e.data[0])),Array.isArray(e.data[0])||"object"==typeof e.data[0]||(e.data=[e.data])),h(e.fields||[],e.data||[],l);throw new Error("Unable to serialize unrecognized input");function p(e){if("object"!=typeof e)return[];var t=[];for(var r in e)t.push(r);return t}function h(e,t,r){var a="";"string"==typeof e&&(e=JSON.parse(e)),"string"==typeof t&&(t=JSON.parse(t));var s=Array.isArray(e)&&e.length>0,u=!Array.isArray(t[0]);if(s&&n){for(var l=0;l<e.length;l++)l>0&&(a+=o),a+=m(e[l],l);t.length>0&&(a+=i)}for(var c=0;c<t.length;c++){var f=s?e.length:t[c].length,d=!1,p=s?0===Object.keys(t[c]).length:0===t[c].length;if(r&&!s&&(d="greedy"===r?""===t[c].join("").trim():1===t[c].length&&0===t[c][0].length),"greedy"===r&&s){for(var h=[],v=0;v<f;v++){var y=u?e[v]:v;h.push(t[c][y])}d=""===h.join("").trim()}if(!d){for(var g=0;g<f;g++){g>0&&!p&&(a+=o);var _=s&&u?e[g]:g;a+=m(t[c][_],g)}c<t.length-1&&(!r||f>0&&!p)&&(a+=i)}}return a}function m(e,t){if(null==e)return"";if(e.constructor===Date)return JSON.stringify(e).slice(1,25);!0===f&&"string"==typeof e&&null!==e.match(/^[=+\-@].*$/)&&(e="'"+e);var n=e.toString().replace(d,u);return"boolean"==typeof r&&r||"function"==typeof r&&r(e,t)||Array.isArray(r)&&r[t]||function(e,t){for(var r=0;r<t.length;r++)if(e.indexOf(t[r])>-1)return!0;return!1}(n,s.BAD_DELIMITERS)||n.indexOf(o)>-1||" "===n.charAt(0)||" "===n.charAt(n.length-1)?a+n+a:n}}};if(s.RECORD_SEP=String.fromCharCode(30),s.UNIT_SEP=String.fromCharCode(31),s.BYTE_ORDER_MARK="\ufeff",s.BAD_DELIMITERS=["\r","\n",'"',s.BYTE_ORDER_MARK],s.WORKERS_SUPPORTED=!n&&!!r.Worker,s.NODE_STREAM_INPUT=1,s.LocalChunkSize=10485760,s.RemoteChunkSize=5242880,s.DefaultDelimiter=",",s.Parser=y,s.ParserHandle=m,s.NetworkStreamer=c,s.FileStreamer=f,s.StringStreamer=d,s.ReadableStreamStreamer=p,"undefined"==typeof PAPA_BROWSER_CONTEXT&&(s.DuplexStreamStreamer=h),r.jQuery){var u=r.jQuery;u.fn.parse=function(e){var t=e.config||{},n=[];return this.each((function(e){if("INPUT"!==u(this).prop("tagName").toUpperCase()||"file"!==u(this).attr("type").toLowerCase()||!r.FileReader||!this.files||0===this.files.length)return!0;for(var o=0;o<this.files.length;o++)n.push({file:this.files[o],inputElem:this,instanceConfig:u.extend({},t)})})),o(),this;function o(){if(0!==n.length){var t,r,o,a,l=n[0];if(E(e.before)){var c=e.before(l.file,l.inputElem);if("object"==typeof c){if("abort"===c.action)return t="AbortError",r=l.file,o=l.inputElem,a=c.reason,void(E(e.error)&&e.error({name:t},r,o,a));if("skip"===c.action)return void i();"object"==typeof c.config&&(l.instanceConfig=u.extend(l.instanceConfig,c.config))}else if("skip"===c)return void i()}var f=l.instanceConfig.complete;l.instanceConfig.complete=function(e){E(f)&&f(e,l.file,l.inputElem),i()},s.parse(l.file,l.instanceConfig)}else E(e.complete)&&e.complete()}function i(){n.splice(0,1),o()}}}function l(e){this._handle=null,this._finished=!1,this._completed=!1,this._halted=!1,this._input=null,this._baseIndex=0,this._partialLine="",this._rowCount=0,this._start=0,this._nextChunk=null,this.isFirstChunk=!0,this._completeResults={data:[],errors:[],meta:{}},function(e){var t=C(e);t.chunkSize=parseInt(t.chunkSize),e.step||e.chunk||(t.chunkSize=null),this._handle=new m(t),this._handle.streamer=this,this._config=t}.call(this,e),this.parseChunk=function(e,t){if(this.isFirstChunk&&E(this._config.beforeFirstChunk)){var n=this._config.beforeFirstChunk(e);void 0!==n&&(e=n)}this.isFirstChunk=!1,this._halted=!1;var i=this._partialLine+e;this._partialLine="";var a=this._handle.parse(i,this._baseIndex,!this._finished);if(!this._handle.paused()&&!this._handle.aborted()){var u=a.meta.cursor;this._finished||(this._partialLine=i.substring(u-this._baseIndex),this._baseIndex=u),a&&a.data&&(this._rowCount+=a.data.length);var l=this._finished||this._config.preview&&this._rowCount>=this._config.preview;if(o)r.postMessage({results:a,workerId:s.WORKER_ID,finished:l});else if(E(this._config.chunk)&&!t){if(this._config.chunk(a,this._handle),this._handle.paused()||this._handle.aborted())return void(this._halted=!0);a=void 0,this._completeResults=void 0}return this._config.step||this._config.chunk||(this._completeResults.data=this._completeResults.data.concat(a.data),this._completeResults.errors=this._completeResults.errors.concat(a.errors),this._completeResults.meta=a.meta),this._completed||!l||!E(this._config.complete)||a&&a.meta.aborted||(this._config.complete(this._completeResults,this._input),this._completed=!0),l||a&&a.meta.paused||this._nextChunk(),a}this._halted=!0},this._sendError=function(e){E(this._config.error)?this._config.error(e):o&&this._config.error&&r.postMessage({workerId:s.WORKER_ID,error:e,finished:!1})}}function c(e){var t;(e=e||{}).chunkSize||(e.chunkSize=s.RemoteChunkSize),l.call(this,e),this._nextChunk=n?function(){this._readChunk(),this._chunkLoaded()}:function(){this._readChunk()},this.stream=function(e){this._input=e,this._nextChunk()},this._readChunk=function(){if(this._finished)this._chunkLoaded();else{if(t=new XMLHttpRequest,this._config.withCredentials&&(t.withCredentials=this._config.withCredentials),n||(t.onload=R(this._chunkLoaded,this),t.onerror=R(this._chunkError,this)),t.open(this._config.downloadRequestBody?"POST":"GET",this._input,!n),this._config.downloadRequestHeaders){var e=this._config.downloadRequestHeaders;for(var r in e)t.setRequestHeader(r,e[r])}if(this._config.chunkSize){var o=this._start+this._config.chunkSize-1;t.setRequestHeader("Range","bytes="+this._start+"-"+o)}try{t.send(this._config.downloadRequestBody)}catch(e){this._chunkError(e.message)}n&&0===t.status&&this._chunkError()}},this._chunkLoaded=function(){4===t.readyState&&(t.status<200||t.status>=400?this._chunkError():(this._start+=this._config.chunkSize?this._config.chunkSize:t.responseText.length,this._finished=!this._config.chunkSize||this._start>=function(e){var t=e.getResponseHeader("Content-Range");return null===t?-1:parseInt(t.substring(t.lastIndexOf("/")+1))}(t),this.parseChunk(t.responseText)))},this._chunkError=function(e){var r=t.statusText||e;this._sendError(new Error(r))}}function f(e){var t,r;(e=e||{}).chunkSize||(e.chunkSize=s.LocalChunkSize),l.call(this,e);var n="undefined"!=typeof FileReader;this.stream=function(e){this._input=e,r=e.slice||e.webkitSlice||e.mozSlice,n?((t=new FileReader).onload=R(this._chunkLoaded,this),t.onerror=R(this._chunkError,this)):t=new FileReaderSync,this._nextChunk()},this._nextChunk=function(){this._finished||this._config.preview&&!(this._rowCount<this._config.preview)||this._readChunk()},this._readChunk=function(){var e=this._input;if(this._config.chunkSize){var o=Math.min(this._start+this._config.chunkSize,this._input.size);e=r.call(e,this._start,o)}var i=t.readAsText(e,this._config.encoding);n||this._chunkLoaded({target:{result:i}})},this._chunkLoaded=function(e){this._start+=this._config.chunkSize,this._finished=!this._config.chunkSize||this._start>=this._input.size,this.parseChunk(e.target.result)},this._chunkError=function(){this._sendError(t.error)}}function d(e){var t;e=e||{},l.call(this,e),this.stream=function(e){return t=e,this._nextChunk()},this._nextChunk=function(){if(!this._finished){var e,r=this._config.chunkSize;return r?(e=t.substring(0,r),t=t.substring(r)):(e=t,t=""),this._finished=!t,this.parseChunk(e)}}}function p(e){e=e||{},l.call(this,e);var t=[],r=!0,n=!1;this.pause=function(){l.prototype.pause.apply(this,arguments),this._input.pause()},this.resume=function(){l.prototype.resume.apply(this,arguments),this._input.resume()},this.stream=function(e){this._input=e,this._input.on("data",this._streamData),this._input.on("end",this._streamEnd),this._input.on("error",this._streamError)},this._checkIsFinished=function(){n&&1===t.length&&(this._finished=!0)},this._nextChunk=function(){this._checkIsFinished(),t.length?this.parseChunk(t.shift()):r=!0},this._streamData=R((function(e){try{t.push("string"==typeof e?e:e.toString(this._config.encoding)),r&&(r=!1,this._checkIsFinished(),this.parseChunk(t.shift()))}catch(e){this._streamError(e)}}),this),this._streamError=R((function(e){this._streamCleanUp(),this._sendError(e)}),this),this._streamEnd=R((function(){this._streamCleanUp(),n=!0,this._streamData("")}),this),this._streamCleanUp=R((function(){this._input.removeListener("data",this._streamData),this._input.removeListener("end",this._streamEnd),this._input.removeListener("error",this._streamError)}),this)}function h(t){var r=__WEBPACK_IMPORTED_MODULE_0_stream___default.a.Duplex,n=C(t),o=!0,i=!1,a=[],s=null;this._onCsvData=function(e){var t=e.data;s.push(t)||this._handle.paused()||this._handle.pause()},this._onCsvComplete=function(){s.push(null)},n.step=R(this._onCsvData,this),n.complete=R(this._onCsvComplete,this),l.call(this,n),this._nextChunk=function(){i&&1===a.length&&(this._finished=!0),a.length?a.shift()():o=!0},this._addToParseQueue=function(e,t){a.push(R((function(){if(this.parseChunk("string"==typeof e?e:e.toString(n.encoding)),E(t))return t()}),this)),o&&(o=!1,this._nextChunk())},this._onRead=function(){this._handle.paused()&&this._handle.resume()},this._onWrite=function(e,t,r){this._addToParseQueue(e,r)},this._onWriteComplete=function(){i=!0,this._addToParseQueue("")},this.getStream=function(){return s},(s=new r({readableObjectMode:!0,decodeStrings:!1,read:R(this._onRead,this),write:R(this._onWrite,this)})).once("finish",R(this._onWriteComplete,this))}function m(e){var t,r,n,o=Math.pow(2,53),i=-o,a=/^\s*-?(\d+\.?|\.\d+|\d+\.\d+)(e[-+]?\d+)?\s*$/,u=/(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))/,l=this,c=0,f=0,d=!1,p=!1,h=[],m={data:[],errors:[],meta:{}};if(E(e.step)){var g=e.step;e.step=function(t){if(m=t,R())b();else{if(b(),0===m.data.length)return;c+=t.data.length,e.preview&&c>e.preview?r.abort():(m.data=m.data[0],g(m,l))}}}function _(t){return"greedy"===e.skipEmptyLines?""===t.join("").trim():1===t.length&&0===t[0].length}function b(){if(m&&n&&(S("Delimiter","UndetectableDelimiter","Unable to auto-detect delimiting character; defaulted to '"+s.DefaultDelimiter+"'"),n=!1),e.skipEmptyLines)for(var t=0;t<m.data.length;t++)_(m.data[t])&&m.data.splice(t--,1);return R()&&function(){if(m)if(Array.isArray(m.data[0])){for(var t=0;R()&&t<m.data.length;t++)m.data[t].forEach(r);m.data.splice(0,1)}else m.data.forEach(r);function r(t,r){E(e.transformHeader)&&(t=e.transformHeader(t,r)),h.push(t)}}(),function(){if(!m||!e.header&&!e.dynamicTyping&&!e.transform)return m;function t(t,r){var n,o=e.header?{}:[];for(n=0;n<t.length;n++){var i=n,a=t[n];e.header&&(i=n>=h.length?"__parsed_extra":h[n]),e.transform&&(a=e.transform(a,i)),a=w(i,a),"__parsed_extra"===i?(o[i]=o[i]||[],o[i].push(a)):o[i]=a}return e.header&&(n>h.length?S("FieldMismatch","TooManyFields","Too many fields: expected "+h.length+" fields but parsed "+n,f+r):n<h.length&&S("FieldMismatch","TooFewFields","Too few fields: expected "+h.length+" fields but parsed "+n,f+r)),o}var r=1;return!m.data.length||Array.isArray(m.data[0])?(m.data=m.data.map(t),r=m.data.length):m.data=t(m.data,0),e.header&&m.meta&&(m.meta.fields=h),f+=r,m}()}function R(){return e.header&&0===h.length}function w(t,r){return function(t){return e.dynamicTypingFunction&&void 0===e.dynamicTyping[t]&&(e.dynamicTyping[t]=e.dynamicTypingFunction(t)),!0===(e.dynamicTyping[t]||e.dynamicTyping)}(t)?"true"===r||"TRUE"===r||"false"!==r&&"FALSE"!==r&&(function(e){if(a.test(e)){var t=parseFloat(e);if(t>i&&t<o)return!0}return!1}(r)?parseFloat(r):u.test(r)?new Date(r):""===r?null:r):r}function S(e,t,r,n){var o={type:e,code:t,message:r};void 0!==n&&(o.row=n),m.errors.push(o)}this.parse=function(o,i,a){var u=e.quoteChar||'"';if(e.newline||(e.newline=function(e,t){e=e.substring(0,1048576);var r=new RegExp(v(t)+"([^]*?)"+v(t),"gm"),n=(e=e.replace(r,"")).split("\r"),o=e.split("\n"),i=o.length>1&&o[0].length<n[0].length;if(1===n.length||i)return"\n";for(var a=0,s=0;s<n.length;s++)"\n"===n[s][0]&&a++;return a>=n.length/2?"\r\n":"\r"}(o,u)),n=!1,e.delimiter)E(e.delimiter)&&(e.delimiter=e.delimiter(o),m.meta.delimiter=e.delimiter);else{var l=function(t,r,n,o,i){var a,u,l,c;i=i||[",","\t","|",";",s.RECORD_SEP,s.UNIT_SEP];for(var f=0;f<i.length;f++){var d=i[f],p=0,h=0,m=0;l=void 0;for(var v=new y({comments:o,delimiter:d,newline:r,preview:10}).parse(t),g=0;g<v.data.length;g++)if(n&&_(v.data[g]))m++;else{var b=v.data[g].length;h+=b,void 0!==l?b>0&&(p+=Math.abs(b-l),l=b):l=b}v.data.length>0&&(h/=v.data.length-m),(void 0===u||p<=u)&&(void 0===c||h>c)&&h>1.99&&(u=p,a=d,c=h)}return e.delimiter=a,{successful:!!a,bestDelimiter:a}}(o,e.newline,e.skipEmptyLines,e.comments,e.delimitersToGuess);l.successful?e.delimiter=l.bestDelimiter:(n=!0,e.delimiter=s.DefaultDelimiter),m.meta.delimiter=e.delimiter}var c=C(e);return e.preview&&e.header&&c.preview++,t=o,r=new y(c),m=r.parse(t,i,a),b(),d?{meta:{paused:!0}}:m||{meta:{paused:!1}}},this.paused=function(){return d},this.pause=function(){d=!0,r.abort(),t=E(e.chunk)?"":t.substring(r.getCharIndex())},this.resume=function(){l.streamer._halted?(d=!1,l.streamer.parseChunk(t,!0)):setTimeout(l.resume,3)},this.aborted=function(){return p},this.abort=function(){p=!0,r.abort(),m.meta.aborted=!0,E(e.complete)&&e.complete(m),t=""}}function v(e){return e.replace(/[.*+?^${}()|[\]\\]/g,"\\$&")}function y(e){var t,r=(e=e||{}).delimiter,n=e.newline,o=e.comments,i=e.step,a=e.preview,u=e.fastMode,l=t=void 0===e.quoteChar?'"':e.quoteChar;if(void 0!==e.escapeChar&&(l=e.escapeChar),("string"!=typeof r||s.BAD_DELIMITERS.indexOf(r)>-1)&&(r=","),o===r)throw new Error("Comment character same as delimiter");!0===o?o="#":("string"!=typeof o||s.BAD_DELIMITERS.indexOf(o)>-1)&&(o=!1),"\n"!==n&&"\r"!==n&&"\r\n"!==n&&(n="\n");var c=0,f=!1;this.parse=function(e,s,d){if("string"!=typeof e)throw new Error("Input must be a string");var p=e.length,h=r.length,m=n.length,y=o.length,g=E(i);c=0;var _=[],b=[],C=[],R=0;if(!e)return L();if(u||!1!==u&&-1===e.indexOf(t)){for(var w=e.split(n),S=0;S<w.length;S++){if(C=w[S],c+=C.length,S!==w.length-1)c+=n.length;else if(d)return L();if(!o||C.substring(0,y)!==o){if(g){if(_=[],D(C.split(r)),$(),f)return L()}else D(C.split(r));if(a&&S>=a)return _=_.slice(0,a),L(!0)}}return L()}for(var k=e.indexOf(r,c),O=e.indexOf(n,c),x=new RegExp(v(l)+v(t),"g"),P=e.indexOf(t,c);;)if(e[c]!==t)if(o&&0===C.length&&e.substring(c,c+y)===o){if(-1===O)return L();c=O+m,O=e.indexOf(n,c),k=e.indexOf(r,c)}else{if(-1!==k&&(k<O||-1===O)){if(!(P>k)){C.push(e.substring(c,k)),c=k+h,k=e.indexOf(r,c);continue}var j=N(k,P,O);if(j&&void 0!==j.nextDelim){k=j.nextDelim,P=j.quoteSearch,C.push(e.substring(c,k)),c=k+h,k=e.indexOf(r,c);continue}}if(-1===O)break;if(C.push(e.substring(c,O)),B(O+m),g&&($(),f))return L();if(a&&_.length>=a)return L(!0)}else for(P=c,c++;;){if(-1===(P=e.indexOf(t,P+1)))return d||b.push({type:"Quotes",code:"MissingQuotes",message:"Quoted field unterminated",row:_.length,index:c}),T();if(P===p-1)return T(e.substring(c,P).replace(x,t));if(t!==l||e[P+1]!==l){if(t===l||0===P||e[P-1]!==l){-1!==k&&k<P+1&&(k=e.indexOf(r,P+1)),-1!==O&&O<P+1&&(O=e.indexOf(n,P+1));var A=F(-1===O?k:Math.min(k,O));if(e[P+1+A]===r){C.push(e.substring(c,P).replace(x,t)),c=P+1+A+h,e[P+1+A+h]!==t&&(P=e.indexOf(t,c)),k=e.indexOf(r,c),O=e.indexOf(n,c);break}var I=F(O);if(e.substring(P+1+I,P+1+I+m)===n){if(C.push(e.substring(c,P).replace(x,t)),B(P+1+I+m),k=e.indexOf(r,c),P=e.indexOf(t,c),g&&($(),f))return L();if(a&&_.length>=a)return L(!0);break}b.push({type:"Quotes",code:"InvalidQuotes",message:"Trailing quote on quoted field is malformed",row:_.length,index:c}),P++}}else P++}return T();function D(e){_.push(e),R=c}function F(t){var r=0;if(-1!==t){var n=e.substring(P+1,t);n&&""===n.trim()&&(r=n.length)}return r}function T(t){return d||(void 0===t&&(t=e.substring(c)),C.push(t),c=p,D(C),g&&$()),L()}function B(t){c=t,D(C),C=[],O=e.indexOf(n,c)}function L(e){return{data:_,errors:b,meta:{delimiter:r,linebreak:n,aborted:f,truncated:!!e,cursor:R+(s||0)}}}function $(){i(L()),_=[],b=[]}function N(n,o,i){var a={nextDelim:void 0,quoteSearch:void 0},s=e.indexOf(t,o+1);if(n>o&&n<s&&(s<i||-1===i)){var u=e.indexOf(r,s);if(-1===u)return a;u>s&&(s=e.indexOf(t,s+1)),a=N(u,s,i)}else a={nextDelim:n,quoteSearch:o};return a}},this.abort=function(){f=!0},this.getCharIndex=function(){return c}}function g(e){var t=e.data,r=i[t.workerId],n=!1;if(t.error)r.userError(t.error,t.file);else if(t.results&&t.results.data){var o={abort:function(){n=!0,_(t.workerId,{data:[],errors:[],meta:{aborted:!0}})},pause:b,resume:b};if(E(r.userStep)){for(var a=0;a<t.results.data.length&&(r.userStep({data:t.results.data[a],errors:t.results.errors,meta:t.results.meta},o),!n);a++);delete t.results}else E(r.userChunk)&&(r.userChunk(t.results,o,t.file),delete t.results)}t.finished&&!n&&_(t.workerId,t.results)}function _(e,t){var r=i[e];E(r.userComplete)&&r.userComplete(t),r.terminate(),delete i[e]}function b(){throw new Error("Not implemented.")}function C(e){if("object"!=typeof e||null===e)return e;var t=Array.isArray(e)?[]:{};for(var r in e)t[r]=C(e[r]);return t}function R(e,t){return function(){e.apply(t,arguments)}}function E(e){return"function"==typeof e}return o&&(r.onmessage=function(e){var t=e.data;if(void 0===s.WORKER_ID&&t&&(s.WORKER_ID=t.workerId),"string"==typeof t.input)r.postMessage({workerId:s.WORKER_ID,results:s.parse(t.input,t.config),finished:!0});else if(r.File&&t.input instanceof File||t.input instanceof Object){var n=s.parse(t.input,t.config);n&&r.postMessage({workerId:s.WORKER_ID,results:n,finished:!0})}}),c.prototype=Object.create(l.prototype),c.prototype.constructor=c,f.prototype=Object.create(l.prototype),f.prototype.constructor=f,d.prototype=Object.create(d.prototype),d.prototype.constructor=d,p.prototype=Object.create(l.prototype),p.prototype.constructor=p,"undefined"==typeof PAPA_BROWSER_CONTEXT&&(h.prototype=Object.create(l.prototype),h.prototype.constructor=h),s}()})),n=function(e,t){return(n=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r])})(e,t)};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */function o(e,t){function r(){this.constructor=e}n(e,t),e.prototype=null===t?Object.create(t):(r.prototype=t.prototype,new r)}function i(){for(var e=0,t=0,r=arguments.length;t<r;t++)e+=arguments[t].length;var n=Array(e),o=0;for(t=0;t<r;t++)for(var i=arguments[t],a=0,s=i.length;a<s;a++,o++)n[o]=i[a];return n}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/var a=Object.getOwnPropertySymbols,s=Object.prototype.hasOwnProperty,u=Object.prototype.propertyIsEnumerable;function l(e){if(null==e)throw new TypeError("Object.assign cannot be called with null or undefined");return Object(e)}var c=function(){try{if(!Object.assign)return!1;var e=new String("abc");if(e[5]="de","5"===Object.getOwnPropertyNames(e)[0])return!1;for(var t={},r=0;r<10;r++)t["_"+String.fromCharCode(r)]=r;if("0123456789"!==Object.getOwnPropertyNames(t).map((function(e){return t[e]})).join(""))return!1;var n={};return"abcdefghijklmnopqrst".split("").forEach((function(e){n[e]=e})),"abcdefghijklmnopqrst"===Object.keys(Object.assign({},n)).join("")}catch(e){return!1}}()?Object.assign:function(e,t){for(var r,n,o=l(e),i=1;i<arguments.length;i++){for(var c in r=Object(arguments[i]))s.call(r,c)&&(o[c]=r[c]);if(a){n=a(r);for(var f=0;f<n.length;f++)u.call(r,n[f])&&(o[n[f]]=r[n[f]])}}return o},f="function"==typeof Symbol&&Symbol.for,d=f?Symbol.for("react.element"):60103,p=f?Symbol.for("react.portal"):60106,h=f?Symbol.for("react.fragment"):60107,m=f?Symbol.for("react.strict_mode"):60108,v=f?Symbol.for("react.profiler"):60114,y=f?Symbol.for("react.provider"):60109,g=f?Symbol.for("react.context"):60110,_=f?Symbol.for("react.forward_ref"):60112,b=f?Symbol.for("react.suspense"):60113,C=f?Symbol.for("react.memo"):60115,R=f?Symbol.for("react.lazy"):60116,E="function"==typeof Symbol&&Symbol.iterator;function w(e){for(var t="https://reactjs.org/docs/error-decoder.html?invariant="+e,r=1;r<arguments.length;r++)t+="&args[]="+encodeURIComponent(arguments[r]);return"Minified React error #"+e+"; visit "+t+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}var S={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},k={};function O(e,t,r){this.props=e,this.context=t,this.refs=k,this.updater=r||S}function x(){}function P(e,t,r){this.props=e,this.context=t,this.refs=k,this.updater=r||S}O.prototype.isReactComponent={},O.prototype.setState=function(e,t){if("object"!=typeof e&&"function"!=typeof e&&null!=e)throw Error(w(85));this.updater.enqueueSetState(this,e,t,"setState")},O.prototype.forceUpdate=function(e){this.updater.enqueueForceUpdate(this,e,"forceUpdate")},x.prototype=O.prototype;var j=P.prototype=new x;j.constructor=P,c(j,O.prototype),j.isPureReactComponent=!0;var A={current:null},I=Object.prototype.hasOwnProperty,D={key:!0,ref:!0,__self:!0,__source:!0};function F(e,t,r){var n,o={},i=null,a=null;if(null!=t)for(n in void 0!==t.ref&&(a=t.ref),void 0!==t.key&&(i=""+t.key),t)I.call(t,n)&&!D.hasOwnProperty(n)&&(o[n]=t[n]);var s=arguments.length-2;if(1===s)o.children=r;else if(1<s){for(var u=Array(s),l=0;l<s;l++)u[l]=arguments[l+2];o.children=u}if(e&&e.defaultProps)for(n in s=e.defaultProps)void 0===o[n]&&(o[n]=s[n]);return{$$typeof:d,type:e,key:i,ref:a,props:o,_owner:A.current}}function T(e){return"object"==typeof e&&null!==e&&e.$$typeof===d}var B=/\/+/g,L=[];function $(e,t,r,n){if(L.length){var o=L.pop();return o.result=e,o.keyPrefix=t,o.func=r,o.context=n,o.count=0,o}return{result:e,keyPrefix:t,func:r,context:n,count:0}}function N(e){e.result=null,e.keyPrefix=null,e.func=null,e.context=null,e.count=0,10>L.length&&L.push(e)}function M(e,t,r){return null==e?0:function e(t,r,n,o){var i=typeof t;"undefined"!==i&&"boolean"!==i||(t=null);var a=!1;if(null===t)a=!0;else switch(i){case"string":case"number":a=!0;break;case"object":switch(t.$$typeof){case d:case p:a=!0}}if(a)return n(o,t,""===r?"."+z(t,0):r),1;if(a=0,r=""===r?".":r+":",Array.isArray(t))for(var s=0;s<t.length;s++){var u=r+z(i=t[s],s);a+=e(i,u,n,o)}else if(null===t||"object"!=typeof t?u=null:u="function"==typeof(u=E&&t[E]||t["@@iterator"])?u:null,"function"==typeof u)for(t=u.call(t),s=0;!(i=t.next()).done;)a+=e(i=i.value,u=r+z(i,s++),n,o);else if("object"===i)throw n=""+t,Error(w(31,"[object Object]"===n?"object with keys {"+Object.keys(t).join(", ")+"}":n,""));return a}(e,"",t,r)}function z(e,t){return"object"==typeof e&&null!==e&&null!=e.key?function(e){var t={"=":"=0",":":"=2"};return"$"+(""+e).replace(/[=:]/g,(function(e){return t[e]}))}(e.key):t.toString(36)}function U(e,t){e.func.call(e.context,t,e.count++)}function q(e,t,r){var n=e.result,o=e.keyPrefix;e=e.func.call(e.context,t,e.count++),Array.isArray(e)?W(e,n,r,(function(e){return e})):null!=e&&(T(e)&&(e=function(e,t){return{$$typeof:d,type:e.type,key:t,ref:e.ref,props:e.props,_owner:e._owner}}(e,o+(!e.key||t&&t.key===e.key?"":(""+e.key).replace(B,"$&/")+"/")+r)),n.push(e))}function W(e,t,r,n,o){var i="";null!=r&&(i=(""+r).replace(B,"$&/")+"/"),M(e,q,t=$(t,i,n,o)),N(t)}var V={current:null};function H(){var e=V.current;if(null===e)throw Error(w(321));return e}var K={Children:{map:function(e,t,r){if(null==e)return e;var n=[];return W(e,n,null,t,r),n},forEach:function(e,t,r){if(null==e)return e;M(e,U,t=$(null,null,t,r)),N(t)},count:function(e){return M(e,(function(){return null}),null)},toArray:function(e){var t=[];return W(e,t,null,(function(e){return e})),t},only:function(e){if(!T(e))throw Error(w(143));return e}},Component:O,Fragment:h,Profiler:v,PureComponent:P,StrictMode:m,Suspense:b,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:V,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:A,IsSomeRendererActing:{current:!1},assign:c},cloneElement:function(e,t,r){if(null==e)throw Error(w(267,e));var n=c({},e.props),o=e.key,i=e.ref,a=e._owner;if(null!=t){if(void 0!==t.ref&&(i=t.ref,a=A.current),void 0!==t.key&&(o=""+t.key),e.type&&e.type.defaultProps)var s=e.type.defaultProps;for(u in t)I.call(t,u)&&!D.hasOwnProperty(u)&&(n[u]=void 0===t[u]&&void 0!==s?s[u]:t[u])}var u=arguments.length-2;if(1===u)n.children=r;else if(1<u){s=Array(u);for(var l=0;l<u;l++)s[l]=arguments[l+2];n.children=s}return{$$typeof:d,type:e.type,key:o,ref:i,props:n,_owner:a}},createContext:function(e,t){return void 0===t&&(t=null),(e={$$typeof:g,_calculateChangedBits:t,_currentValue:e,_currentValue2:e,_threadCount:0,Provider:null,Consumer:null}).Provider={$$typeof:y,_context:e},e.Consumer=e},createElement:F,createFactory:function(e){var t=F.bind(null,e);return t.type=e,t},createRef:function(){return{current:null}},forwardRef:function(e){return{$$typeof:_,render:e}},isValidElement:T,lazy:function(e){return{$$typeof:R,_ctor:e,_status:-1,_result:null}},memo:function(e,t){return{$$typeof:C,type:e,compare:void 0===t?null:t}},useCallback:function(e,t){return H().useCallback(e,t)},useContext:function(e,t){return H().useContext(e,t)},useDebugValue:function(){},useEffect:function(e,t){return H().useEffect(e,t)},useImperativeHandle:function(e,t,r){return H().useImperativeHandle(e,t,r)},useLayoutEffect:function(e,t){return H().useLayoutEffect(e,t)},useMemo:function(e,t){return H().useMemo(e,t)},useReducer:function(e,t,r){return H().useReducer(e,t,r)},useRef:function(e){return H().useRef(e)},useState:function(e){return H().useState(e)},version:"16.14.0"},Y=function(){};if(false){var Q="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",J={},X=Function.call.bind(Object.prototype.hasOwnProperty);Y=function(e){var t="Warning: "+e;"undefined"!=typeof console&&console.error(t);try{throw new Error(t)}catch(e){}}}function G(e,t,r,n,o){if(false)for(var i in e)if(X(e,i)){var a;try{if("function"!=typeof e[i]){var s=Error((n||"React class")+": "+r+" type `"+i+"` is invalid; it must be a function, usually from the `prop-types` package, but received `"+typeof e[i]+"`.");throw s.name="Invariant Violation",s}a=e[i](t,i,n,r,null,Q)}catch(e){a=e}if(!a||a instanceof Error||Y((n||"React class")+": type specification of "+r+" `"+i+"` is invalid; the type checker function must return `null` or an `Error` but returned a "+typeof a+". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."),a instanceof Error&&!(a.message in J)){J[a.message]=!0;var u=o?o():"";Y("Failed "+r+" type: "+a.message+(null!=u?u:""))}}}G.resetWarningCache=function(){"production"!=="production"&&(J={})};var Z=G,ee=t((function(e,t){"production"!=="production"&&function(){var e=c,r=Z,n="function"==typeof Symbol&&Symbol.for,o=n?Symbol.for("react.element"):60103,i=n?Symbol.for("react.portal"):60106,a=n?Symbol.for("react.fragment"):60107,s=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,l=n?Symbol.for("react.provider"):60109,f=n?Symbol.for("react.context"):60110,d=n?Symbol.for("react.concurrent_mode"):60111,p=n?Symbol.for("react.forward_ref"):60112,h=n?Symbol.for("react.suspense"):60113,m=n?Symbol.for("react.suspense_list"):60120,v=n?Symbol.for("react.memo"):60115,y=n?Symbol.for("react.lazy"):60116,g=n?Symbol.for("react.block"):60121,_=n?Symbol.for("react.fundamental"):60117,b=n?Symbol.for("react.responder"):60118,C=n?Symbol.for("react.scope"):60119,R="function"==typeof Symbol&&Symbol.iterator;function E(e){if(null===e||"object"!=typeof e)return null;var t=R&&e[R]||e["@@iterator"];return"function"==typeof t?t:null}var w={current:null},S={current:null},k=/^(.*)[\\\/]/;function O(e){if(null==e)return null;if("number"==typeof e.tag&&D("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."),"function"==typeof e)return e.displayName||e.name||null;if("string"==typeof e)return e;switch(e){case a:return"Fragment";case i:return"Portal";case u:return"Profiler";case s:return"StrictMode";case h:return"Suspense";case m:return"SuspenseList"}if("object"==typeof e)switch(e.$$typeof){case f:return"Context.Consumer";case l:return"Context.Provider";case p:return n=e,o=e.render,c="ForwardRef",d=o.displayName||o.name||"",n.displayName||(""!==d?c+"("+d+")":c);case v:return O(e.type);case g:return O(e.render);case y:var t=1===(r=e)._status?r._result:null;if(t)return O(t)}var r,n,o,c,d;return null}var x={},P=null;function j(e){P=e}x.getCurrentStack=null,x.getStackAddendum=function(){var e="";if(P){var t=O(P.type),r=P._owner;e+=function(e,t,r){var n="";if(t){var o=t.fileName,i=o.replace(k,"");if(/^index\./.test(i)){var a=o.match(k);if(a){var s=a[1];if(s)i=s.replace(k,"")+"/"+i}}n=" (at "+i+":"+t.lineNumber+")"}else r&&(n=" (created by "+r+")");return"\n    in "+(e||"Unknown")+n}(t,P._source,r&&O(r.type))}var n=x.getCurrentStack;return n&&(e+=n()||""),e};var A={ReactCurrentDispatcher:w,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:S,IsSomeRendererActing:{current:!1},assign:e};function I(e){for(var t=arguments.length,r=new Array(t>1?t-1:0),n=1;n<t;n++)r[n-1]=arguments[n];F("warn",e,r)}function D(e){for(var t=arguments.length,r=new Array(t>1?t-1:0),n=1;n<t;n++)r[n-1]=arguments[n];F("error",e,r)}function F(e,t,r){if(!(r.length>0&&"string"==typeof r[r.length-1]&&0===r[r.length-1].indexOf("\n    in"))){var n=A.ReactDebugCurrentFrame.getStackAddendum();""!==n&&(t+="%s",r=r.concat([n]))}var o=r.map((function(e){return""+e}));o.unshift("Warning: "+t),Function.prototype.apply.call(console[e],console,o);try{var i=0,a="Warning: "+t.replace(/%s/g,(function(){return r[i++]}));throw new Error(a)}catch(e){}}e(A,{ReactDebugCurrentFrame:x,ReactComponentTreeHook:{}});var T={};function B(e,t){var r=e.constructor,n=r&&(r.displayName||r.name)||"ReactClass",o=n+"."+t;T[o]||(D("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.",t,n),T[o]=!0)}var L={isMounted:function(e){return!1},enqueueForceUpdate:function(e,t,r){B(e,"forceUpdate")},enqueueReplaceState:function(e,t,r,n){B(e,"replaceState")},enqueueSetState:function(e,t,r,n){B(e,"setState")}},$={};function N(e,t,r){this.props=e,this.context=t,this.refs=$,this.updater=r||L}Object.freeze($),N.prototype.isReactComponent={},N.prototype.setState=function(e,t){if("object"!=typeof e&&"function"!=typeof e&&null!=e)throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");this.updater.enqueueSetState(this,e,t,"setState")},N.prototype.forceUpdate=function(e){this.updater.enqueueForceUpdate(this,e,"forceUpdate")};var M={isMounted:["isMounted","Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],replaceState:["replaceState","Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]},z=function(e,t){Object.defineProperty(N.prototype,e,{get:function(){I("%s(...) is deprecated in plain JavaScript React classes. %s",t[0],t[1])}})};for(var U in M)M.hasOwnProperty(U)&&z(U,M[U]);function q(){}function W(e,t,r){this.props=e,this.context=t,this.refs=$,this.updater=r||L}q.prototype=N.prototype;var V=W.prototype=new q;V.constructor=W,e(V,N.prototype),V.isPureReactComponent=!0;var H,K,Y,Q=Object.prototype.hasOwnProperty,J={key:!0,ref:!0,__self:!0,__source:!0};function X(e){if(Q.call(e,"ref")){var t=Object.getOwnPropertyDescriptor(e,"ref").get;if(t&&t.isReactWarning)return!1}return void 0!==e.ref}function G(e){if(Q.call(e,"key")){var t=Object.getOwnPropertyDescriptor(e,"key").get;if(t&&t.isReactWarning)return!1}return void 0!==e.key}function ee(e,t){var r=function(){H||(H=!0,D("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://fb.me/react-special-props)",t))};r.isReactWarning=!0,Object.defineProperty(e,"key",{get:r,configurable:!0})}function te(e,t){var r=function(){K||(K=!0,D("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://fb.me/react-special-props)",t))};r.isReactWarning=!0,Object.defineProperty(e,"ref",{get:r,configurable:!0})}function re(e){if("string"==typeof e.ref&&S.current&&e.__self&&S.current.stateNode!==e.__self){var t=O(S.current.type);Y[t]||(D('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://fb.me/react-strict-mode-string-ref',O(S.current.type),e.ref),Y[t]=!0)}}Y={};var ne=function(e,t,r,n,i,a,s){var u={$$typeof:o,type:e,key:t,ref:r,props:s,_owner:a,_store:{}};return Object.defineProperty(u._store,"validated",{configurable:!1,enumerable:!1,writable:!0,value:!1}),Object.defineProperty(u,"_self",{configurable:!1,enumerable:!1,writable:!1,value:n}),Object.defineProperty(u,"_source",{configurable:!1,enumerable:!1,writable:!1,value:i}),Object.freeze&&(Object.freeze(u.props),Object.freeze(u)),u};function oe(e,t,r){var n,o={},i=null,a=null,s=null,u=null;if(null!=t)for(n in X(t)&&(a=t.ref,re(t)),G(t)&&(i=""+t.key),s=void 0===t.__self?null:t.__self,u=void 0===t.__source?null:t.__source,t)Q.call(t,n)&&!J.hasOwnProperty(n)&&(o[n]=t[n]);var l=arguments.length-2;if(1===l)o.children=r;else if(l>1){for(var c=Array(l),f=0;f<l;f++)c[f]=arguments[f+2];Object.freeze&&Object.freeze(c),o.children=c}if(e&&e.defaultProps){var d=e.defaultProps;for(n in d)void 0===o[n]&&(o[n]=d[n])}if(i||a){var p="function"==typeof e?e.displayName||e.name||"Unknown":e;i&&ee(o,p),a&&te(o,p)}return ne(e,i,a,s,u,S.current,o)}function ie(t,r,n){if(null==t)throw Error("React.cloneElement(...): The argument must be a React element, but you passed "+t+".");var o,i,a=e({},t.props),s=t.key,u=t.ref,l=t._self,c=t._source,f=t._owner;if(null!=r)for(o in X(r)&&(u=r.ref,f=S.current),G(r)&&(s=""+r.key),t.type&&t.type.defaultProps&&(i=t.type.defaultProps),r)Q.call(r,o)&&!J.hasOwnProperty(o)&&(void 0===r[o]&&void 0!==i?a[o]=i[o]:a[o]=r[o]);var d=arguments.length-2;if(1===d)a.children=n;else if(d>1){for(var p=Array(d),h=0;h<d;h++)p[h]=arguments[h+2];a.children=p}return ne(t.type,s,u,l,c,f,a)}function ae(e){return"object"==typeof e&&null!==e&&e.$$typeof===o}var se=!1,ue=/\/+/g;function le(e){return(""+e).replace(ue,"$&/")}var ce,fe=[];function de(e,t,r,n){if(fe.length){var o=fe.pop();return o.result=e,o.keyPrefix=t,o.func=r,o.context=n,o.count=0,o}return{result:e,keyPrefix:t,func:r,context:n,count:0}}function pe(e){e.result=null,e.keyPrefix=null,e.func=null,e.context=null,e.count=0,fe.length<10&&fe.push(e)}function he(e,t,r){return null==e?0:function e(t,r,n,a){var s=typeof t;"undefined"!==s&&"boolean"!==s||(t=null);var u,l=!1;if(null===t)l=!0;else switch(s){case"string":case"number":l=!0;break;case"object":switch(t.$$typeof){case o:case i:l=!0}}if(l)return n(a,t,""===r?"."+me(t,0):r),1;var c=0,f=""===r?".":r+":";if(Array.isArray(t))for(var d=0;d<t.length;d++)c+=e(u=t[d],f+me(u,d),n,a);else{var p=E(t);if("function"==typeof p){p===t.entries&&(se||I("Using Maps as children is deprecated and will be removed in a future major release. Consider converting children to an array of keyed ReactElements instead."),se=!0);for(var h,m=p.call(t),v=0;!(h=m.next()).done;)c+=e(u=h.value,f+me(u,v++),n,a)}else if("object"===s){var y;y=" If you meant to render a collection of children, use an array instead."+x.getStackAddendum();var g=""+t;throw Error("Objects are not valid as a React child (found: "+("[object Object]"===g?"object with keys {"+Object.keys(t).join(", ")+"}":g)+")."+y)}}return c}(e,"",t,r)}function me(e,t){return"object"==typeof e&&null!==e&&null!=e.key?(r=e.key,n={"=":"=0",":":"=2"},"$"+(""+r).replace(/[=:]/g,(function(e){return n[e]}))):t.toString(36);var r,n}function ve(e,t,r){var n=e.func,o=e.context;n.call(o,t,e.count++)}function ye(e,t,r){var n,o,i=e.result,a=e.keyPrefix,s=e.func,u=e.context,l=s.call(u,t,e.count++);Array.isArray(l)?ge(l,i,r,(function(e){return e})):null!=l&&(ae(l)&&(n=l,o=a+(!l.key||t&&t.key===l.key?"":le(l.key)+"/")+r,l=ne(n.type,o,n.ref,n._self,n._source,n._owner,n.props)),i.push(l))}function ge(e,t,r,n,o){var i="";null!=r&&(i=le(r)+"/");var a=de(t,i,n,o);he(e,ye,a),pe(a)}function _e(e){return"string"==typeof e||"function"==typeof e||e===a||e===d||e===u||e===s||e===h||e===m||"object"==typeof e&&null!==e&&(e.$$typeof===y||e.$$typeof===v||e.$$typeof===l||e.$$typeof===f||e.$$typeof===p||e.$$typeof===_||e.$$typeof===b||e.$$typeof===C||e.$$typeof===g)}function be(){var e=w.current;if(null===e)throw Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://fb.me/react-invalid-hook-call for tips about how to debug and fix this problem.");return e}function Ce(){if(S.current){var e=O(S.current.type);if(e)return"\n\nCheck the render method of `"+e+"`."}return""}function Re(e){return null!=e&&void 0!==(t=e.__source)?"\n\nCheck your code at "+t.fileName.replace(/^.*[\\\/]/,"")+":"+t.lineNumber+".":"";var t}ce=!1;var Ee={};function we(e,t){if(e._store&&!e._store.validated&&null==e.key){e._store.validated=!0;var r=function(e){var t=Ce();if(!t){var r="string"==typeof e?e:e.displayName||e.name;r&&(t="\n\nCheck the top-level render call using <"+r+">.")}return t}(t);if(!Ee[r]){Ee[r]=!0;var n="";e&&e._owner&&e._owner!==S.current&&(n=" It was passed a child from "+O(e._owner.type)+"."),j(e),D('Each child in a list should have a unique "key" prop.%s%s See https://fb.me/react-warning-keys for more information.',r,n),j(null)}}}function Se(e,t){if("object"==typeof e)if(Array.isArray(e))for(var r=0;r<e.length;r++){var n=e[r];ae(n)&&we(n,t)}else if(ae(e))e._store&&(e._store.validated=!0);else if(e){var o=E(e);if("function"==typeof o&&o!==e.entries)for(var i,a=o.call(e);!(i=a.next()).done;)ae(i.value)&&we(i.value,t)}}function ke(e){var t=e.type;if(null!=t&&"string"!=typeof t){var n,o=O(t);if("function"==typeof t)n=t.propTypes;else{if("object"!=typeof t||t.$$typeof!==p&&t.$$typeof!==v)return;n=t.propTypes}n?(j(e),r(n,e.props,"prop",o,x.getStackAddendum),j(null)):void 0===t.PropTypes||ce||(ce=!0,D("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?",o||"Unknown")),"function"!=typeof t.getDefaultProps||t.getDefaultProps.isReactClassApproved||D("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.")}}function Oe(e){j(e);for(var t=Object.keys(e.props),r=0;r<t.length;r++){var n=t[r];if("children"!==n&&"key"!==n){D("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.",n);break}}null!==e.ref&&D("Invalid attribute `ref` supplied to `React.Fragment`."),j(null)}function xe(e,t,r){var n=_e(e);if(!n){var i="";(void 0===e||"object"==typeof e&&null!==e&&0===Object.keys(e).length)&&(i+=" You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");var s,u=Re(t);i+=u||Ce(),null===e?s="null":Array.isArray(e)?s="array":void 0!==e&&e.$$typeof===o?(s="<"+(O(e.type)||"Unknown")+" />",i=" Did you accidentally export a JSX literal instead of a component?"):s=typeof e,D("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s",s,i)}var l=oe.apply(this,arguments);if(null==l)return l;if(n)for(var c=2;c<arguments.length;c++)Se(arguments[c],e);return e===a?Oe(l):ke(l),l}var Pe=!1;try{var je=Object.freeze({}),Ae=new Map([[je,null]]),Ie=new Set([je]);Ae.set(0,0),Ie.add(0)}catch(e){}var De=xe,Fe=function(e,t,r){for(var n=ie.apply(this,arguments),o=2;o<arguments.length;o++)Se(arguments[o],n.type);return ke(n),n},Te=function(e){var t=xe.bind(null,e);return t.type=e,Pe||(Pe=!0,I("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.")),Object.defineProperty(t,"type",{enumerable:!1,get:function(){return I("Factory.type is deprecated. Access the class directly before passing it to createFactory."),Object.defineProperty(this,"type",{value:e}),e}}),t},Be={map:function(e,t,r){if(null==e)return e;var n=[];return ge(e,n,null,t,r),n},forEach:function(e,t,r){if(null==e)return e;var n=de(null,null,t,r);he(e,ve,n),pe(n)},count:function(e){return he(e,(function(){return null}),null)},toArray:function(e){var t=[];return ge(e,t,null,(function(e){return e})),t},only:function(e){if(!ae(e))throw Error("React.Children.only expected to receive a single React element child.");return e}};t.Children=Be,t.Component=N,t.Fragment=a,t.Profiler=u,t.PureComponent=W,t.StrictMode=s,t.Suspense=h,t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=A,t.cloneElement=Fe,t.createContext=function(e,t){void 0===t?t=null:null!==t&&"function"!=typeof t&&D("createContext: Expected the optional second argument to be a function. Instead received: %s",t);var r={$$typeof:f,_calculateChangedBits:t,_currentValue:e,_currentValue2:e,_threadCount:0,Provider:null,Consumer:null};r.Provider={$$typeof:l,_context:r};var n=!1,o=!1,i={$$typeof:f,_context:r,_calculateChangedBits:r._calculateChangedBits};return Object.defineProperties(i,{Provider:{get:function(){return o||(o=!0,D("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?")),r.Provider},set:function(e){r.Provider=e}},_currentValue:{get:function(){return r._currentValue},set:function(e){r._currentValue=e}},_currentValue2:{get:function(){return r._currentValue2},set:function(e){r._currentValue2=e}},_threadCount:{get:function(){return r._threadCount},set:function(e){r._threadCount=e}},Consumer:{get:function(){return n||(n=!0,D("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?")),r.Consumer}}}),r.Consumer=i,r._currentRenderer=null,r._currentRenderer2=null,r},t.createElement=De,t.createFactory=Te,t.createRef=function(){var e={current:null};return Object.seal(e),e},t.forwardRef=function(e){return null!=e&&e.$$typeof===v?D("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...))."):"function"!=typeof e?D("forwardRef requires a render function but was given %s.",null===e?"null":typeof e):0!==e.length&&2!==e.length&&D("forwardRef render functions accept exactly two parameters: props and ref. %s",1===e.length?"Did you forget to use the ref parameter?":"Any additional parameter will be undefined."),null!=e&&(null==e.defaultProps&&null==e.propTypes||D("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?")),{$$typeof:p,render:e}},t.isValidElement=ae,t.lazy=function(e){var t,r,n={$$typeof:y,_ctor:e,_status:-1,_result:null};return Object.defineProperties(n,{defaultProps:{configurable:!0,get:function(){return t},set:function(e){D("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."),t=e,Object.defineProperty(n,"defaultProps",{enumerable:!0})}},propTypes:{configurable:!0,get:function(){return r},set:function(e){D("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."),r=e,Object.defineProperty(n,"propTypes",{enumerable:!0})}}}),n},t.memo=function(e,t){return _e(e)||D("memo: The first argument must be a component. Instead received: %s",null===e?"null":typeof e),{$$typeof:v,type:e,compare:void 0===t?null:t}},t.useCallback=function(e,t){return be().useCallback(e,t)},t.useContext=function(e,t){var r=be();if(void 0!==t&&D("useContext() second argument is reserved for future use in React. Passing it is not supported. You passed: %s.%s",t,"number"==typeof t&&Array.isArray(arguments[2])?"\n\nDid you call array.map(useContext)? Calling Hooks inside a loop is not supported. Learn more at https://fb.me/rules-of-hooks":""),void 0!==e._context){var n=e._context;n.Consumer===e?D("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?"):n.Provider===e&&D("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?")}return r.useContext(e,t)},t.useDebugValue=function(e,t){return be().useDebugValue(e,t)},t.useEffect=function(e,t){return be().useEffect(e,t)},t.useImperativeHandle=function(e,t,r){return be().useImperativeHandle(e,t,r)},t.useLayoutEffect=function(e,t){return be().useLayoutEffect(e,t)},t.useMemo=function(e,t){return be().useMemo(e,t)},t.useReducer=function(e,t,r){return be().useReducer(e,t,r)},t.useRef=function(e){return be().useRef(e)},t.useState=function(e){return be().useState(e)},t.version="16.14.0"}()}));ee.Children,ee.Component,ee.Fragment,ee.Profiler,ee.PureComponent,ee.StrictMode,ee.Suspense,ee.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,ee.cloneElement,ee.createContext,ee.createElement,ee.createFactory,ee.createRef,ee.forwardRef,ee.isValidElement,ee.lazy,ee.memo,ee.useCallback,ee.useContext,ee.useDebugValue,ee.useEffect,ee.useImperativeHandle,ee.useLayoutEffect,ee.useMemo,ee.useReducer,ee.useRef,ee.useState,ee.version;var te=t((function(e){ true?e.exports=K:e.exports=ee}));function re(e){if(e<1048576){var t=Number((e/1024).toFixed(0));return t<=0?e+" B":t+" KB"}return e<1073741824?(e/1048576).toFixed(0)+" MB":e<1099511627776?(e/1073741824).toFixed(0)+" GB":""}function ne(e,t){var r=!1;"#"==e[0]&&(e=e.slice(1),r=!0);var n=parseInt(e,16),o=(n>>16)+t;o>255?o=255:o<0&&(o=0);var i=(n>>8&255)+t;i>255?i=255:i<0&&(i=0);var a=(255&n)+t;return a>255?a=255:a<0&&(a=0),(r?"#":"")+(a|i<<8|o<<16).toString(16)}function oe(e){return te.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"23",height:"23",viewBox:"0 0 512 512"},te.createElement("path",{fill:e.color,d:"M504.1 256C504.1 119 393 7.9 256 7.9S7.9 119 7.9 256 119 504.1 256 504.1 504.1 393 504.1 256z"}),te.createElement("path",{fill:"#FFF",d:"M285 256l72.5-84.2c7.9-9.2 6.9-23-2.3-31-9.2-7.9-23-6.9-30.9 2.3L256 222.4l-68.2-79.2c-7.9-9.2-21.8-10.2-31-2.3-9.2 7.9-10.2 21.8-2.3 31L227 256l-72.5 84.2c-7.9 9.2-6.9 23 2.3 31 4.1 3.6 9.2 5.3 14.3 5.3 6.2 0 12.3-2.6 16.6-7.6l68.2-79.2 68.2 79.2c4.3 5 10.5 7.6 16.6 7.6 5.1 0 10.2-1.7 14.3-5.3 9.2-7.9 10.2-21.8 2.3-31L285 256z"}))}var ie={progressBar:{borderRadius:3,boxShadow:"inset 0 1px 3px rgba(0, 0, 0, .2)",bottom:14,position:"absolute",width:"80%"},buttonProgressBar:{position:"inherit",width:"100%"},progressBarFill:{backgroundColor:"#659cef",borderRadius:3,height:10,transition:"width 500ms ease-in-out"}},ae=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return o(t,e),t.prototype.render=function(){var e=this.props,t=e.style,r=e.progressBar,n=e.displayProgressBarStatus,o=e.isButtonProgressBar;return te.createElement("div",{style:Object.assign({},ie.progressBar,o&&ie.buttonProgressBar)},te.createElement("span",{style:Object.assign({},ie.progressBarFill,t,{width:r+"%",display:n})}))},t}(te.Component),se={dropArea:{alignItems:"center",borderStyle:"dashed",borderWidth:2,borderRadius:20,borderColor:"#CCC",display:"flex",flexDirection:"column",height:"100%",justifyContent:"center",padding:20},dropAreaDefaultBorderColor:{borderColor:"#CCC"},inputFile:{display:"none"},highlight:{borderColor:"#686868"},unhighlight:{borderColor:"#CCC"},dropFile:{background:"linear-gradient(to bottom, #EEE, #DDD)",borderRadius:20,display:"block",height:120,width:100,paddingLeft:10,paddingRight:10,position:"relative",zIndex:10},column:{alignItems:"center",display:"flex",flexDirection:"column",justifyContent:"center"},fileSizeInfo:{backgroundColor:"rgba(255, 255, 255, 0.4)",borderRadius:3,lineHeight:1,marginBottom:"0.5em",padding:"0 0.4em"},fileNameInfo:{backgroundColor:"rgba(255, 255, 255, 0.4)",borderRadius:3,fontSize:14,lineHeight:1,padding:"0 0.4em"},defaultCursor:{cursor:"default"},pointerCursor:{cursor:"pointer"},dropFileRemoveButton:{height:23,position:"absolute",right:6,top:6,width:23}},ue=function(e){function t(){var t,n,o,a,s,u,l,c,f,d=e.apply(this,arguments)||this;return d.inputFileRef=te.createRef(),d.dropAreaRef=te.createRef(),d.fileSizeInfoRef=te.createRef(),d.fileNameInfoRef=te.createRef(),d.REMOVE_ICON_COLOR=d.props.removeButtonColor||(null===(a=null===(o=null===(n=null===(t=d.props.style)||void 0===t?void 0:t.dropArea)||void 0===n?void 0:n.dropFile)||void 0===o?void 0:o.removeButton)||void 0===a?void 0:a.color)||(null===(l=null===(u=null===(s=d.props.style)||void 0===s?void 0:s.dropFile)||void 0===u?void 0:u.removeButton)||void 0===l?void 0:l.color)||(null===(f=null===(c=d.props.style)||void 0===c?void 0:c.removeButton)||void 0===f?void 0:f.color)||"#A01919",d.REMOVE_ICON_COLOR_LIGHT=ne(d.REMOVE_ICON_COLOR,40),d.state={dropAreaCustom:{},progressBar:0,displayProgressBarStatus:"none",file:null,timeout:null,files:null,removeIconColor:d.REMOVE_ICON_COLOR,isCanceled:!1},d.componentDidUpdate=function(e){d.props.isReset!==e.isReset&&d.removeFile()},d.componentDidMount=function(){var e=d.dropAreaRef.current;if(e){if(["dragenter","dragover","dragleave","drop"].forEach((function(t){e.addEventListener(t,d.preventDefaults,!1)})),!d.props.noDrag){["dragenter","dragover"].forEach((function(t){e.addEventListener(t,d.highlight,!1)})),e.addEventListener("dragleave",d.unhighlight,!1),e.addEventListener("drop",d.unhighlight,!1),e.addEventListener("drop",d.visibleProgressBar,!1),e.addEventListener("drop",d.handleDrop,!1)}}},d.componentWillUnmount=function(){var e=d.dropAreaRef.current;if(["dragenter","dragover","dragleave","drop"].forEach((function(t){e.removeEventListener(t,d.preventDefaults,!1)})),!d.props.noDrag){["dragenter","dragover"].forEach((function(t){e.removeEventListener(t,d.highlight,!1)})),e.removeEventListener("dragleave",d.unhighlight,!1),e.removeEventListener("drop",d.unhighlight,!1),e.removeEventListener("drop",d.visibleProgressBar,!1),e.removeEventListener("drop",d.handleDrop,!1)}},d.preventDefaults=function(e){e.preventDefault(),e.stopPropagation()},d.highlight=function(){var e,t,r,n,o=d.props.style;d.setState({dropAreaCustom:Object.assign({},(null==o?void 0:o.dropAreaActive)?(null==o?void 0:o.dropAreaActive.borderColor)?null==o?void 0:o.dropAreaActive:Object.assign({},null==o?void 0:o.dropAreaActive,se.highlight):(null===(e=null==o?void 0:o.dropArea)||void 0===e?void 0:e.dropAreaActive)?(null===(t=null==o?void 0:o.dropArea)||void 0===t?void 0:t.dropAreaActive.borderColor)?null===(r=null==o?void 0:o.dropArea)||void 0===r?void 0:r.dropAreaActive:Object.assign({},null===(n=null==o?void 0:o.dropArea)||void 0===n?void 0:n.dropAreaActive,se.highlight):se.highlight)}),d.setState({progressBar:0})},d.unhighlight=function(){var e,t;d.setState({dropAreaCustom:Object.assign({},(null===(t=null===(e=d.props.style)||void 0===e?void 0:e.dropArea)||void 0===t?void 0:t.borderColor)?{}:se.dropAreaDefaultBorderColor)})},d.visibleProgressBar=function(){d.props.noProgressBar||d.setState({displayProgressBarStatus:"block"})},d.handleDrop=function(e){var t=null,r=!1;void 0===e.files?t=e.dataTransfer.files:t=e.files;0===t.length&&(t=d.state.files,r=!0),d.setState({files:t,isCanceled:r},(function(){d.handleFiles()}))},d.handleFiles=function(){d.setState({progressBar:0});i(d.state.files).forEach(d.uploadFile)},d.uploadFile=function(e){d.displayFileInfo(e),d.setState({file:e});var t=d.props,n=t.onDrop,o=t.onFileLoad,i=t.onError,a=t.config,s=void 0===a?{}:a,u=new window.FileReader,l={},c=e.size,f=[],p=0;if(n||o){var h=d;l=Object.assign({complete:(null==s?void 0:s.complete)||(null==s?void 0:s.step)?s.complete:function(){!n&&o?o(f,e):n&&!o&&n(f,e)},step:(null==s?void 0:s.step)?s.step:function(t){if(f.push(t),s&&s.preview)p=Math.round(f.length/s.preview*100),h.setState({progressBar:p}),f.length===s.preview&&(!n&&o?o(f,e):n&&!o&&n(f,e));else{var r=t.meta.cursor,i=Math.round(r/c*100);if(i===p)return;p=i}h.setState({progressBar:p})}},l)}i&&(l=Object.assign({error:i},l)),s&&(l=Object.assign({},s,l)),u.onload=function(e){r.parse(e.target.result,l)},u.onloadend=function(){clearTimeout(d.state.timeout),d.setState({timeout:setTimeout((function(){d.disableProgressBar()}),2e3)})},u.readAsText(e,s.encoding||"utf-8")},d.displayFileInfo=function(e){d.childrenIsFunction()||(d.fileSizeInfoRef.current.innerHTML=re(e.size),d.fileNameInfoRef.current.innerHTML=e.name)},d.disableProgressBar=function(){d.props.noProgressBar||d.setState({displayProgressBarStatus:"none"})},d.childrenIsFunction=function(){return"function"==typeof d.props.children},d.fileChange=function(e){var t=e.target;d.props.noProgressBar?d.handleDrop(t):d.setState({displayProgressBarStatus:"block"},(function(){d.handleDrop(t)}))},d.open=function(e){var t=d.state.displayProgressBarStatus;e&&"none"===t&&(d.preventDefaults(e),d.inputFileRef.current.value=null,d.inputFileRef.current.click())},d.renderChildren=function(){var e=d.props.children,t=d.state,r=t.file,n=t.progressBar;return d.childrenIsFunction()?e({file:r,progressBar:n}):e},d.handleRemoveFile=function(e){e&&(e.stopPropagation(),d.removeFile())},d.removeFile=function(){d.setState({files:null,file:null});var e=d.props.onRemoveFile;e&&e(null),d.inputFileRef.current.value=null},d.changeRemoveIconColor=function(e){e&&d.setState({removeIconColor:e})},d.renderDropFileRemoveButton=function(){var e=d.props.addRemoveButton,t=d.state,r=t.removeIconColor,n=t.displayProgressBarStatus;return e&&"none"===n?te.createElement("div",{style:se.dropFileRemoveButton,onClick:function(e){return d.handleRemoveFile(e)},onMouseOver:function(){return d.changeRemoveIconColor(d.REMOVE_ICON_COLOR_LIGHT)},onMouseOut:function(){return d.changeRemoveIconColor(d.REMOVE_ICON_COLOR)}},te.createElement(oe,{color:r})):e?te.createElement("div",{style:se.dropFileRemoveButton},te.createElement(oe,{color:d.REMOVE_ICON_COLOR})):null},d}return o(t,e),t.prototype.render=function(){var e,t,r,n,o,i,a,s,u,l,c,f,d,p=this,h=this.props,m=h.style,v=h.noClick,y=h.children,g=h.noProgressBar,_=h.progressBarColor,b=h.accept,C=this.state,R=C.dropAreaCustom,E=C.files,w=C.isCanceled,S=C.progressBar,k=C.displayProgressBarStatus;return te.createElement(te.Fragment,null,te.createElement("input",{type:"file",accept:b||"text/csv, .csv, application/vnd.ms-excel",ref:this.inputFileRef,style:se.inputFile,onChange:function(e){return p.fileChange(e)}}),this.childrenIsFunction()?te.createElement("div",{ref:this.dropAreaRef},this.renderChildren(),E&&E.length>0&&!w&&!g&&te.createElement(ae,{style:Object.assign({},_?{backgroundColor:_}:{},(null===(f=null===(c=null==m?void 0:m.dropArea)||void 0===c?void 0:c.dropFile)||void 0===f?void 0:f.progressBar)||(null===(d=null==m?void 0:m.dropFile)||void 0===d?void 0:d.progressBar)||(null==m?void 0:m.progressBar)),progressBar:S,displayProgressBarStatus:k,isButtonProgressBar:!0})):te.createElement("div",{ref:this.dropAreaRef,style:Object.assign({},se.dropArea,null==m?void 0:m.dropArea,R,void 0!==v||"block"===k?se.defaultCursor:se.pointerCursor),onClick:function(e){v||p.open(e)}},E&&E.length>0?te.createElement("div",{style:Object.assign({},se.dropFile,se.column,(null===(e=null==m?void 0:m.dropArea)||void 0===e?void 0:e.dropFile)||(null==m?void 0:m.dropFile))},this.renderDropFileRemoveButton(),te.createElement("div",{style:se.column},te.createElement("span",{style:Object.assign({},se.fileSizeInfo,(null===(r=null===(t=null==m?void 0:m.dropArea)||void 0===t?void 0:t.dropFile)||void 0===r?void 0:r.fileSizeInfo)||(null===(n=null==m?void 0:m.dropArea)||void 0===n?void 0:n.fileSizeInfo)||(null==m?void 0:m.fileSizeInfo)),ref:this.fileSizeInfoRef}),te.createElement("span",{style:Object.assign({},se.fileNameInfo,(null===(i=null===(o=null==m?void 0:m.dropArea)||void 0===o?void 0:o.dropFile)||void 0===i?void 0:i.fileNameInfo)||(null===(a=null==m?void 0:m.dropFile)||void 0===a?void 0:a.fileNameInfo)||(null==m?void 0:m.fileNameInfo)),ref:this.fileNameInfoRef})),E&&E.length>0&&!w&&!g&&te.createElement(ae,{style:Object.assign({},_?{backgroundColor:_}:{},(null===(u=null===(s=null==m?void 0:m.dropArea)||void 0===s?void 0:s.dropFile)||void 0===u?void 0:u.progressBar)||(null===(l=null==m?void 0:m.dropFile)||void 0===l?void 0:l.progressBar)||(null==m?void 0:m.progressBar)),progressBar:S,displayProgressBarStatus:k})):y))},t.defaultProps={isReset:!1},t}(te.Component),le="link",ce="button",fe=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.download=function(e,t,n,o){var i=n?"\ufeff":"",a=null;a="object"==typeof e?r.unparse(e,o):e;var s=new Blob([""+i+a],{type:"text/csv;charset=utf-8;"}),u=null;u=navigator.msSaveBlob?navigator.msSaveBlob(s,t+".csv"):window.URL.createObjectURL(s);var l=document.createElement("a");l.href=u,l.setAttribute("download",t+".csv"),l.click(),l.remove()},t}return o(t,e),t.prototype.render=function(){var e=this,t=this.props,r=t.children,n=t.data,o=t.filename,i=t.type,a=t.className,s=t.style,u=t.bom,l=void 0!==u&&u,c=t.config,f=void 0===c?{}:c;return"link"===i?te.createElement("a",{onClick:function(){return e.download(n,o,l,f)},className:a,style:s},r):te.createElement("button",{onClick:function(){return e.download(n,o,l,f)},className:a,style:s},r)},t.defaultProps={type:"link"},t}(te.Component);function de(e,t){return void 0===t&&(t={}),r.parse(e,t)}function pe(e,t){void 0===t&&(t={}),r.parse(e,Object.assign({},{download:!0},t))}function he(e,t){return void 0===t&&(t={}),r.unparse(e,t)}var me=r.BAD_DELIMITERS,ve=r.RECORD_SEP,ye=r.UNIT_SEP,ge=r.WORKERS_SUPPORTED,_e=r.LocalChunkSize,be=r.DefaultDelimiter;

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(33)))

/***/ }),
/* 2172 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = __webpack_require__(477).EventEmitter;
var inherits = __webpack_require__(158);

inherits(Stream, EE);
Stream.Readable = __webpack_require__(478);
Stream.Writable = __webpack_require__(2180);
Stream.Duplex = __webpack_require__(2181);
Stream.Transform = __webpack_require__(2182);
Stream.PassThrough = __webpack_require__(2183);

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};


/***/ }),
/* 2173 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = __webpack_require__(285).Buffer;
var util = __webpack_require__(2175);

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}

/***/ }),
/* 2175 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2176 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(2177);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)))

/***/ }),
/* 2177 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33), __webpack_require__(147)))

/***/ }),
/* 2178 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)))

/***/ }),
/* 2179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__(863);

/*<replacement>*/
var util = Object.create(__webpack_require__(212));
util.inherits = __webpack_require__(158);
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),
/* 2180 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(479);


/***/ }),
/* 2181 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(138);


/***/ }),
/* 2182 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(478).Transform


/***/ }),
/* 2183 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(478).PassThrough


/***/ }),
/* 2184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_DetailsList__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Dropdown__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Icon__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__build_node_modules_mobx__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_desc,_value,_class2,_class3,_temp2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}var CsvMappingTable=Object(__WEBPACK_IMPORTED_MODULE_6__build_src_app_components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["e" /* observer */])(_class=(_class2=(_temp2=_class3=function(_Component){_inherits(CsvMappingTable,_Component);function CsvMappingTable(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CsvMappingTable);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CsvMappingTable.__proto__||Object.getPrototypeOf(CsvMappingTable)).call.apply(_ref,[this].concat(args))),_this),_this.handleChangeMapping=function(index){return function(ev,option,_index,value){var mapping=_this.props.mapping;mapping[index]=option.key;};},_this.handleRenderDetailsHeader=function(props,defaultRenderer){props.onRenderColumnHeaderTooltip=_this.handleRenderColumnHeaderTooltip;return defaultRenderer(props);},_this.handleRenderColumnHeaderTooltip=function(props){var _this$props=_this.props,mapping=_this$props.mapping,t=_this$props.t;if(props.content==='additional')return'';return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Dropdown__["a" /* Dropdown */],{defaultSelectedKey:mapping[props.content],options:[{key:'',text:'-- '+t('do not import')+' --'}].concat(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.map(_this.mainFields,function(field,key){return{key:key,text:field.title};})),onChange:_this.handleChangeMapping(props.content)});},_this.handleRenderItemColumn=function(item,index,column){var _this$props2=_this.props,fields=_this$props2.fields,mapping=_this$props2.mapping;if(column.key==='additional'){var additional=[];mapping.forEach(function(m,_index){if(m&&_this.additionalFields[m]&&fields[m].title&&!!item[_index])additional.push(fields[m].title+': '+item[_index]);});var _content=additional.join('\n');return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Icon__["Icon"],{iconName:'More',title:_content});}var content=item[column.key];return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',null,content);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CsvMappingTable,[{key:'render',value:function render(){var _props=this.props,data=_props.data,fields=_props.fields,mapping=_props.mapping;var columns=mapping.map(function(m,index){return{key:index,name:'Column '+index,data:'string',minWidth:120,maxWidth:150,ariaLabel:index,// this is passed to the handleRenderColumnHeaderTooltip as props.content
additional:typeof fields[m]!=='undefined'&&fields[m].additional};});// filter out mapped additional fields, as these shall not be used for main mapping
columns=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.filter(columns,function(column){return!column.additional;});var hasAdditional=__WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.some(fields,function(field){return field.additional;});if(hasAdditional)columns.push({key:'additional',name:'Additional',data:'string',minWidth:40,maxWidth:40,ariaLabel:'additional'});return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_DetailsList__["b" /* DetailsList */],{columns:columns,items:data,onRenderItemColumn:this.handleRenderItemColumn,onRenderDetailsHeader:this.handleRenderDetailsHeader,checkboxVisibility:__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_DetailsList__["a" /* CheckboxVisibility */].hidden,layoutMode:__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_DetailsList__["c" /* DetailsListLayoutMode */].justified});}},{key:'mainFields',get:function get(){var fields=this.props.fields;return __WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.pickBy(fields,function(field){return!field.additional;});}},{key:'additionalFields',get:function get(){var fields=this.props.fields;return __WEBPACK_IMPORTED_MODULE_2__build_node_modules_lodash___default.a.pickBy(fields,function(field){return field.additional;});}}]);return CsvMappingTable;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class3.displayName='CsvMappingTable',_temp2),(_applyDecoratedDescriptor(_class2.prototype,'mainFields',[__WEBPACK_IMPORTED_MODULE_7__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class2.prototype,'mainFields'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'additionalFields',[__WEBPACK_IMPORTED_MODULE_7__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class2.prototype,'additionalFields'),_class2.prototype)),_class2))||_class)||_class;/* harmony default export */ __webpack_exports__["a"] = (CsvMappingTable);

/***/ }),
/* 2185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ArrowKeyStepper__ = __webpack_require__(2186);
/* unused harmony reexport ArrowKeyStepper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AutoSizer__ = __webpack_require__(2197);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__AutoSizer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CellMeasurer__ = __webpack_require__(874);
/* unused harmony reexport CellMeasurer */
/* unused harmony reexport CellMeasurerCache */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Collection__ = __webpack_require__(2200);
/* unused harmony reexport Collection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ColumnSizer__ = __webpack_require__(2207);
/* unused harmony reexport ColumnSizer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Grid__ = __webpack_require__(55);
/* unused harmony reexport accessibilityOverscanIndicesGetter */
/* unused harmony reexport defaultCellRangeRenderer */
/* unused harmony reexport defaultOverscanIndicesGetter */
/* unused harmony reexport Grid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InfiniteLoader__ = __webpack_require__(2209);
/* unused harmony reexport InfiniteLoader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__List__ = __webpack_require__(2215);
/* unused harmony reexport List */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Masonry__ = __webpack_require__(2216);
/* unused harmony reexport createMasonryCellPositioner */
/* unused harmony reexport Masonry */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MultiGrid__ = __webpack_require__(2225);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_9__MultiGrid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ScrollSync__ = __webpack_require__(2228);
/* unused harmony reexport ScrollSync */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Table__ = __webpack_require__(2230);
/* unused harmony reexport createTableMultiSort */
/* unused harmony reexport defaultTableCellDataGetter */
/* unused harmony reexport defaultTableCellRenderer */
/* unused harmony reexport defaultTableHeaderRenderer */
/* unused harmony reexport defaultTableHeaderRowRenderer */
/* unused harmony reexport defaultTableRowRenderer */
/* unused harmony reexport Table */
/* unused harmony reexport Column */
/* unused harmony reexport SortDirection */
/* unused harmony reexport SortIndicator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__WindowScroller__ = __webpack_require__(2233);
/* unused harmony reexport WindowScroller */














/***/ }),
/* 2186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ArrowKeyStepper__ = __webpack_require__(865);
/* unused harmony reexport default */
/* unused harmony reexport ArrowKeyStepper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(871);
/* unused harmony reexport bpfrpt_proptype_ScrollIndices */





/***/ }),
/* 2187 */
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  }

  return _typeof(obj);
}

module.exports = _typeof;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 2188 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 2189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calculateSizeAndPositionDataAndUpdateScrollOffset;
/**
 * Helper method that determines when to recalculate row or column metadata.
 */
function calculateSizeAndPositionDataAndUpdateScrollOffset(_ref) {
  var cellCount = _ref.cellCount,
      cellSize = _ref.cellSize,
      computeMetadataCallback = _ref.computeMetadataCallback,
      computeMetadataCallbackProps = _ref.computeMetadataCallbackProps,
      nextCellsCount = _ref.nextCellsCount,
      nextCellSize = _ref.nextCellSize,
      nextScrollToIndex = _ref.nextScrollToIndex,
      scrollToIndex = _ref.scrollToIndex,
      updateScrollOffsetForScrollToIndex = _ref.updateScrollOffsetForScrollToIndex;

  // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
  // In that event users should use the manual recompute methods to inform of changes.
  if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
    computeMetadataCallback(computeMetadataCallbackProps); // Updated cell metadata may have hidden the previous scrolled-to item.
    // In this case we should also update the scrollTop to ensure it stays visible.

    if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) {
      updateScrollOffsetForScrollToIndex();
    }
  }
}

/***/ }),
/* 2190 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 2191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CellSizeAndPositionManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(15);




/**
 * Just-in-time calculates and caches size and position information for a collection of cells.
 */
var CellSizeAndPositionManager =
/*#__PURE__*/
function () {
  // Cache of size and position data for cells, mapped by cell index.
  // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
  // Measurements for cells up to this index can be trusted; cells afterward should be estimated.
  // Used in deferred mode to track which cells have been queued for measurement.
  function CellSizeAndPositionManager(_ref) {
    var cellCount = _ref.cellCount,
        cellSizeGetter = _ref.cellSizeGetter,
        estimatedCellSize = _ref.estimatedCellSize;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, CellSizeAndPositionManager);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "_cellSizeAndPositionData", {});

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "_lastMeasuredIndex", -1);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "_lastBatchedIndex", -1);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "_cellCount", void 0);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "_cellSizeGetter", void 0);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "_estimatedCellSize", void 0);

    this._cellSizeGetter = cellSizeGetter;
    this._cellCount = cellCount;
    this._estimatedCellSize = estimatedCellSize;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(CellSizeAndPositionManager, [{
    key: "areOffsetsAdjusted",
    value: function areOffsetsAdjusted() {
      return false;
    }
  }, {
    key: "configure",
    value: function configure(_ref2) {
      var cellCount = _ref2.cellCount,
          estimatedCellSize = _ref2.estimatedCellSize,
          cellSizeGetter = _ref2.cellSizeGetter;
      this._cellCount = cellCount;
      this._estimatedCellSize = estimatedCellSize;
      this._cellSizeGetter = cellSizeGetter;
    }
  }, {
    key: "getCellCount",
    value: function getCellCount() {
      return this._cellCount;
    }
  }, {
    key: "getEstimatedCellSize",
    value: function getEstimatedCellSize() {
      return this._estimatedCellSize;
    }
  }, {
    key: "getLastMeasuredIndex",
    value: function getLastMeasuredIndex() {
      return this._lastMeasuredIndex;
    }
  }, {
    key: "getOffsetAdjustment",
    value: function getOffsetAdjustment() {
      return 0;
    }
    /**
     * This method returns the size and position for the cell at the specified index.
     * It just-in-time calculates (or used cached values) for cells leading up to the index.
     */

  }, {
    key: "getSizeAndPositionOfCell",
    value: function getSizeAndPositionOfCell(index) {
      if (index < 0 || index >= this._cellCount) {
        throw Error("Requested index ".concat(index, " is outside of range 0..").concat(this._cellCount));
      }

      if (index > this._lastMeasuredIndex) {
        var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
        var offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;

        for (var i = this._lastMeasuredIndex + 1; i <= index; i++) {
          var size = this._cellSizeGetter({
            index: i
          }); // undefined or NaN probably means a logic error in the size getter.
          // null means we're using CellMeasurer and haven't yet measured a given index.


          if (size === undefined || isNaN(size)) {
            throw Error("Invalid size returned for cell ".concat(i, " of value ").concat(size));
          } else if (size === null) {
            this._cellSizeAndPositionData[i] = {
              offset: offset,
              size: 0
            };
            this._lastBatchedIndex = index;
          } else {
            this._cellSizeAndPositionData[i] = {
              offset: offset,
              size: size
            };
            offset += size;
            this._lastMeasuredIndex = index;
          }
        }
      }

      return this._cellSizeAndPositionData[index];
    }
  }, {
    key: "getSizeAndPositionOfLastMeasuredCell",
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
        offset: 0,
        size: 0
      };
    }
    /**
     * Total size of all cells being measured.
     * This value will be completely estimated initially.
     * As cells are measured, the estimate will be updated.
     */

  }, {
    key: "getTotalSize",
    value: function getTotalSize() {
      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
      var totalSizeOfMeasuredCells = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
      var numUnmeasuredCells = this._cellCount - this._lastMeasuredIndex - 1;
      var totalSizeOfUnmeasuredCells = numUnmeasuredCells * this._estimatedCellSize;
      return totalSizeOfMeasuredCells + totalSizeOfUnmeasuredCells;
    }
    /**
     * Determines a new offset that ensures a certain cell is visible, given the current offset.
     * If the cell is already visible then the current offset will be returned.
     * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
     *
     * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
     * @param containerSize Size (width or height) of the container viewport
     * @param currentOffset Container's current (x or y) offset
     * @param totalSize Total size (width or height) of all cells
     * @return Offset to use to ensure the specified cell is visible
     */

  }, {
    key: "getUpdatedOffsetForIndex",
    value: function getUpdatedOffsetForIndex(_ref3) {
      var _ref3$align = _ref3.align,
          align = _ref3$align === void 0 ? 'auto' : _ref3$align,
          containerSize = _ref3.containerSize,
          currentOffset = _ref3.currentOffset,
          targetIndex = _ref3.targetIndex;

      if (containerSize <= 0) {
        return 0;
      }

      var datum = this.getSizeAndPositionOfCell(targetIndex);
      var maxOffset = datum.offset;
      var minOffset = maxOffset - containerSize + datum.size;
      var idealOffset;

      switch (align) {
        case 'start':
          idealOffset = maxOffset;
          break;

        case 'end':
          idealOffset = minOffset;
          break;

        case 'center':
          idealOffset = maxOffset - (containerSize - datum.size) / 2;
          break;

        default:
          idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
          break;
      }

      var totalSize = this.getTotalSize();
      return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
    }
  }, {
    key: "getVisibleCellRange",
    value: function getVisibleCellRange(params) {
      var containerSize = params.containerSize,
          offset = params.offset;
      var totalSize = this.getTotalSize();

      if (totalSize === 0) {
        return {};
      }

      var maxOffset = offset + containerSize;

      var start = this._findNearestCell(offset);

      var datum = this.getSizeAndPositionOfCell(start);
      offset = datum.offset + datum.size;
      var stop = start;

      while (offset < maxOffset && stop < this._cellCount - 1) {
        stop++;
        offset += this.getSizeAndPositionOfCell(stop).size;
      }

      return {
        start: start,
        stop: stop
      };
    }
    /**
     * Clear all cached values for cells after the specified index.
     * This method should be called for any cell that has changed its size.
     * It will not immediately perform any calculations; they'll be performed the next time getSizeAndPositionOfCell() is called.
     */

  }, {
    key: "resetCell",
    value: function resetCell(index) {
      this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
    }
  }, {
    key: "_binarySearch",
    value: function _binarySearch(high, low, offset) {
      while (low <= high) {
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = this.getSizeAndPositionOfCell(middle).offset;

        if (currentOffset === offset) {
          return middle;
        } else if (currentOffset < offset) {
          low = middle + 1;
        } else if (currentOffset > offset) {
          high = middle - 1;
        }
      }

      if (low > 0) {
        return low - 1;
      } else {
        return 0;
      }
    }
  }, {
    key: "_exponentialSearch",
    value: function _exponentialSearch(index, offset) {
      var interval = 1;

      while (index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset) {
        index += interval;
        interval *= 2;
      }

      return this._binarySearch(Math.min(index, this._cellCount - 1), Math.floor(index / 2), offset);
    }
    /**
     * Searches for the cell (index) nearest the specified offset.
     *
     * If no exact match is found the next lowest cell index will be returned.
     * This allows partially visible cells (with offsets just before/above the fold) to be visible.
     */

  }, {
    key: "_findNearestCell",
    value: function _findNearestCell(offset) {
      if (isNaN(offset)) {
        throw Error("Invalid offset ".concat(offset, " specified"));
      } // Our search algorithms find the nearest match at or below the specified offset.
      // So make sure the offset is at least 0 or no match will be found.


      offset = Math.max(0, offset);
      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
      var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);

      if (lastMeasuredCellSizeAndPosition.offset >= offset) {
        // If we've already measured cells within this range just use a binary search as it's faster.
        return this._binarySearch(lastMeasuredIndex, 0, offset);
      } else {
        // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
        // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
        // The overall complexity for this approach is O(log n).
        return this._exponentialSearch(lastMeasuredIndex, offset);
      }
    }
  }]);

  return CellSizeAndPositionManager;
}();






/***/ }),
/* 2192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getMaxElementSize; });
var DEFAULT_MAX_ELEMENT_SIZE = 1500000;
var CHROME_MAX_ELEMENT_SIZE = 1.67771e7;

var isBrowser = function isBrowser() {
  return typeof window !== 'undefined';
};

var isChrome = function isChrome() {
  return !!window.chrome;
};

var getMaxElementSize = function getMaxElementSize() {
  if (isBrowser()) {
    if (isChrome()) {
      return CHROME_MAX_ELEMENT_SIZE;
    }
  }

  return DEFAULT_MAX_ELEMENT_SIZE;
};

/***/ }),
/* 2193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updateScrollIndexHelper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScalingCellSizeAndPositionManager_js__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(15);

/**
 * Helper function that determines when to update scroll offsets to ensure that a scroll-to-index remains visible.
 * This function also ensures that the scroll ofset isn't past the last column/row of cells.
 */

function updateScrollIndexHelper(_ref) {
  var cellSize = _ref.cellSize,
      cellSizeAndPositionManager = _ref.cellSizeAndPositionManager,
      previousCellsCount = _ref.previousCellsCount,
      previousCellSize = _ref.previousCellSize,
      previousScrollToAlignment = _ref.previousScrollToAlignment,
      previousScrollToIndex = _ref.previousScrollToIndex,
      previousSize = _ref.previousSize,
      scrollOffset = _ref.scrollOffset,
      scrollToAlignment = _ref.scrollToAlignment,
      scrollToIndex = _ref.scrollToIndex,
      size = _ref.size,
      sizeJustIncreasedFromZero = _ref.sizeJustIncreasedFromZero,
      updateScrollIndexCallback = _ref.updateScrollIndexCallback;
  var cellCount = cellSizeAndPositionManager.getCellCount();
  var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
  var sizeHasChanged = size !== previousSize || sizeJustIncreasedFromZero || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize; // If we have a new scroll target OR if height/row-height has changed,
  // We should ensure that the scroll target is visible.

  if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) {
    updateScrollIndexCallback(scrollToIndex); // If we don't have a selected item but list size or number of children have decreased,
    // Make sure we aren't scrolled too far past the current content.
  } else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) {
    // We need to ensure that the current scroll offset is still within the collection's range.
    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
    // Just check to make sure we're still okay.
    // Only adjust the scroll position if we've scrolled below the last set of rows.
    if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) {
      updateScrollIndexCallback(cellCount - 1);
    }
  }
}



/***/ }),
/* 2194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (!!(typeof window !== 'undefined' && window.document && window.document.createElement));

/***/ }),
/* 2195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return raf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return caf; });
// Properly handle server-side rendering.
var win;

if (typeof window !== 'undefined') {
  win = window;
} else if (typeof self !== 'undefined') {
  win = self;
} else {
  win = {};
} // requestAnimationFrame() shim by Paul Irish
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/


var request = win.requestAnimationFrame || win.webkitRequestAnimationFrame || win.mozRequestAnimationFrame || win.oRequestAnimationFrame || win.msRequestAnimationFrame || function (callback) {
  return win.setTimeout(callback, 1000 / 60);
};

var cancel = win.cancelAnimationFrame || win.webkitCancelAnimationFrame || win.mozCancelAnimationFrame || win.oCancelAnimationFrame || win.msCancelAnimationFrame || function (id) {
  win.clearTimeout(id);
};

var raf = request;
var caf = cancel;

/***/ }),
/* 2196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SCROLL_DIRECTION_BACKWARD */
/* unused harmony export SCROLL_DIRECTION_FORWARD */
/* unused harmony export SCROLL_DIRECTION_HORIZONTAL */
/* unused harmony export SCROLL_DIRECTION_VERTICAL */
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultOverscanIndicesGetter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(15);
var SCROLL_DIRECTION_BACKWARD = -1;
var SCROLL_DIRECTION_FORWARD = 1;
var SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var SCROLL_DIRECTION_VERTICAL = 'vertical';
/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */

function defaultOverscanIndicesGetter(_ref) {
  var cellCount = _ref.cellCount,
      overscanCellsCount = _ref.overscanCellsCount,
      scrollDirection = _ref.scrollDirection,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;
  // Make sure we render at least 1 cell extra before and after (except near boundaries)
  // This is necessary in order to support keyboard navigation (TAB/SHIFT+TAB) in some cases
  // For more info see issues #625
  overscanCellsCount = Math.max(1, overscanCellsCount);

  if (scrollDirection === SCROLL_DIRECTION_FORWARD) {
    return {
      overscanStartIndex: Math.max(0, startIndex - 1),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  } else {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + 1)
    };
  }
}



/***/ }),
/* 2197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AutoSizer__ = __webpack_require__(872);
/* unused harmony reexport default */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AutoSizer__["a"]; });



/***/ }),
/* 2198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CellMeasurer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__types__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);








var _class, _temp;




/**
 * Wraps a cell and measures its rendered content.
 * Measurements are stored in a per-cell cache.
 * Cached-content is not be re-measured.
 */
var CellMeasurer = (_temp = _class =
/*#__PURE__*/
function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(CellMeasurer, _React$PureComponent);

  function CellMeasurer() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, CellMeasurer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(CellMeasurer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_child", void 0);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_measure", function () {
      var _this$props = _this.props,
          cache = _this$props.cache,
          _this$props$columnInd = _this$props.columnIndex,
          columnIndex = _this$props$columnInd === void 0 ? 0 : _this$props$columnInd,
          parent = _this$props.parent,
          _this$props$rowIndex = _this$props.rowIndex,
          rowIndex = _this$props$rowIndex === void 0 ? _this.props.index || 0 : _this$props$rowIndex;

      var _this$_getCellMeasure = _this._getCellMeasurements(),
          height = _this$_getCellMeasure.height,
          width = _this$_getCellMeasure.width;

      if (height !== cache.getHeight(rowIndex, columnIndex) || width !== cache.getWidth(rowIndex, columnIndex)) {
        cache.set(rowIndex, columnIndex, width, height);

        if (parent && typeof parent.recomputeGridSize === 'function') {
          parent.recomputeGridSize({
            columnIndex: columnIndex,
            rowIndex: rowIndex
          });
        }
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_registerChild", function (element) {
      if (element && !(element instanceof Element)) {
        console.warn('CellMeasurer registerChild expects to be passed Element or null');
      }

      _this._child = element;

      if (element) {
        _this._maybeMeasureCell();
      }
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(CellMeasurer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._maybeMeasureCell();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this._maybeMeasureCell();
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return typeof children === 'function' ? children({
        measure: this._measure,
        registerChild: this._registerChild
      }) : children;
    }
  }, {
    key: "_getCellMeasurements",
    value: function _getCellMeasurements() {
      var cache = this.props.cache;
      var node = this._child || Object(__WEBPACK_IMPORTED_MODULE_8_react_dom__["findDOMNode"])(this); // TODO Check for a bad combination of fixedWidth and missing numeric width or vice versa with height

      if (node && node.ownerDocument && node.ownerDocument.defaultView && node instanceof node.ownerDocument.defaultView.HTMLElement) {
        var styleWidth = node.style.width;
        var styleHeight = node.style.height; // If we are re-measuring a cell that has already been measured,
        // It will have a hard-coded width/height from the previous measurement.
        // The fact that we are measuring indicates this measurement is probably stale,
        // So explicitly clear it out (eg set to "auto") so we can recalculate.
        // See issue #593 for more info.
        // Even if we are measuring initially- if we're inside of a MultiGrid component,
        // Explicitly clear width/height before measuring to avoid being tainted by another Grid.
        // eg top/left Grid renders before bottom/right Grid
        // Since the CellMeasurerCache is shared between them this taints derived cell size values.

        if (!cache.hasFixedWidth()) {
          node.style.width = 'auto';
        }

        if (!cache.hasFixedHeight()) {
          node.style.height = 'auto';
        }

        var height = Math.ceil(node.offsetHeight);
        var width = Math.ceil(node.offsetWidth); // Reset after measuring to avoid breaking styles; see #660

        if (styleWidth) {
          node.style.width = styleWidth;
        }

        if (styleHeight) {
          node.style.height = styleHeight;
        }

        return {
          height: height,
          width: width
        };
      } else {
        return {
          height: 0,
          width: 0
        };
      }
    }
  }, {
    key: "_maybeMeasureCell",
    value: function _maybeMeasureCell() {
      var _this$props2 = this.props,
          cache = _this$props2.cache,
          _this$props2$columnIn = _this$props2.columnIndex,
          columnIndex = _this$props2$columnIn === void 0 ? 0 : _this$props2$columnIn,
          parent = _this$props2.parent,
          _this$props2$rowIndex = _this$props2.rowIndex,
          rowIndex = _this$props2$rowIndex === void 0 ? this.props.index || 0 : _this$props2$rowIndex;

      if (!cache.has(rowIndex, columnIndex)) {
        var _this$_getCellMeasure2 = this._getCellMeasurements(),
            height = _this$_getCellMeasure2.height,
            width = _this$_getCellMeasure2.width;

        cache.set(rowIndex, columnIndex, width, height); // If size has changed, let Grid know to re-render.

        if (parent && typeof parent.invalidateCellSizeAfterRender === 'function') {
          parent.invalidateCellSizeAfterRender({
            columnIndex: columnIndex,
            rowIndex: rowIndex
          });
        }
      }
    }
  }]);

  return CellMeasurer;
}(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"]), __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(_class, "propTypes",  true ? null : {
  "cache": function cache() {
    return (typeof bpfrpt_proptype_CellMeasureCache === "function" ? bpfrpt_proptype_CellMeasureCache.isRequired ? bpfrpt_proptype_CellMeasureCache.isRequired : bpfrpt_proptype_CellMeasureCache : PropTypes.shape(bpfrpt_proptype_CellMeasureCache).isRequired).apply(this, arguments);
  },
  "children": PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
  "columnIndex": PropTypes.number,
  "index": PropTypes.number,
  "parent": PropTypes.shape({
    invalidateCellSizeAfterRender: PropTypes.func,
    recomputeGridSize: PropTypes.func
  }).isRequired,
  "rowIndex": PropTypes.number
}), _temp); // Used for DEV mode warning check

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(CellMeasurer, "__internalCellMeasurerFlag", false);



if (false) {
  CellMeasurer.__internalCellMeasurerFlag = true;
}




/***/ }),
/* 2199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_HEIGHT */
/* unused harmony export DEFAULT_WIDTH */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(875);



var DEFAULT_HEIGHT = 30;
var DEFAULT_WIDTH = 100; // Enables more intelligent mapping of a given column and row index to an item ID.
// This prevents a cell cache from being invalidated when its parent collection is modified.

/**
 * Caches measurements for a given cell.
 */
var CellMeasurerCache =
/*#__PURE__*/
function () {
  function CellMeasurerCache() {
    var _this = this;

    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, CellMeasurerCache);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "_cellHeightCache", {});

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "_cellWidthCache", {});

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "_columnWidthCache", {});

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "_rowHeightCache", {});

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "_defaultHeight", void 0);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "_defaultWidth", void 0);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "_minHeight", void 0);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "_minWidth", void 0);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "_keyMapper", void 0);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "_hasFixedHeight", void 0);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "_hasFixedWidth", void 0);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "_columnCount", 0);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "_rowCount", 0);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "columnWidth", function (_ref) {
      var index = _ref.index;

      var key = _this._keyMapper(0, index);

      return _this._columnWidthCache[key] !== undefined ? _this._columnWidthCache[key] : _this._defaultWidth;
    });

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "rowHeight", function (_ref2) {
      var index = _ref2.index;

      var key = _this._keyMapper(index, 0);

      return _this._rowHeightCache[key] !== undefined ? _this._rowHeightCache[key] : _this._defaultHeight;
    });

    var defaultHeight = params.defaultHeight,
        defaultWidth = params.defaultWidth,
        fixedHeight = params.fixedHeight,
        fixedWidth = params.fixedWidth,
        keyMapper = params.keyMapper,
        minHeight = params.minHeight,
        minWidth = params.minWidth;
    this._hasFixedHeight = fixedHeight === true;
    this._hasFixedWidth = fixedWidth === true;
    this._minHeight = minHeight || 0;
    this._minWidth = minWidth || 0;
    this._keyMapper = keyMapper || defaultKeyMapper;
    this._defaultHeight = Math.max(this._minHeight, typeof defaultHeight === 'number' ? defaultHeight : DEFAULT_HEIGHT);
    this._defaultWidth = Math.max(this._minWidth, typeof defaultWidth === 'number' ? defaultWidth : DEFAULT_WIDTH);

    if (false) {
      if (this._hasFixedHeight === false && this._hasFixedWidth === false) {
        console.warn("CellMeasurerCache should only measure a cell's width or height. " + 'You have configured CellMeasurerCache to measure both. ' + 'This will result in poor performance.');
      }

      if (this._hasFixedHeight === false && this._defaultHeight === 0) {
        console.warn('Fixed height CellMeasurerCache should specify a :defaultHeight greater than 0. ' + 'Failing to do so will lead to unnecessary layout and poor performance.');
      }

      if (this._hasFixedWidth === false && this._defaultWidth === 0) {
        console.warn('Fixed width CellMeasurerCache should specify a :defaultWidth greater than 0. ' + 'Failing to do so will lead to unnecessary layout and poor performance.');
      }
    }
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(CellMeasurerCache, [{
    key: "clear",
    value: function clear(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var key = this._keyMapper(rowIndex, columnIndex);

      delete this._cellHeightCache[key];
      delete this._cellWidthCache[key];

      this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
    }
  }, {
    key: "clearAll",
    value: function clearAll() {
      this._cellHeightCache = {};
      this._cellWidthCache = {};
      this._columnWidthCache = {};
      this._rowHeightCache = {};
      this._rowCount = 0;
      this._columnCount = 0;
    }
  }, {
    key: "hasFixedHeight",
    value: function hasFixedHeight() {
      return this._hasFixedHeight;
    }
  }, {
    key: "hasFixedWidth",
    value: function hasFixedWidth() {
      return this._hasFixedWidth;
    }
  }, {
    key: "getHeight",
    value: function getHeight(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (this._hasFixedHeight) {
        return this._defaultHeight;
      } else {
        var _key = this._keyMapper(rowIndex, columnIndex);

        return this._cellHeightCache[_key] !== undefined ? Math.max(this._minHeight, this._cellHeightCache[_key]) : this._defaultHeight;
      }
    }
  }, {
    key: "getWidth",
    value: function getWidth(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (this._hasFixedWidth) {
        return this._defaultWidth;
      } else {
        var _key2 = this._keyMapper(rowIndex, columnIndex);

        return this._cellWidthCache[_key2] !== undefined ? Math.max(this._minWidth, this._cellWidthCache[_key2]) : this._defaultWidth;
      }
    }
  }, {
    key: "has",
    value: function has(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var key = this._keyMapper(rowIndex, columnIndex);

      return this._cellHeightCache[key] !== undefined;
    }
  }, {
    key: "set",
    value: function set(rowIndex, columnIndex, width, height) {
      var key = this._keyMapper(rowIndex, columnIndex);

      if (columnIndex >= this._columnCount) {
        this._columnCount = columnIndex + 1;
      }

      if (rowIndex >= this._rowCount) {
        this._rowCount = rowIndex + 1;
      } // Size is cached per cell so we don't have to re-measure if cells are re-ordered.


      this._cellHeightCache[key] = height;
      this._cellWidthCache[key] = width;

      this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
    }
  }, {
    key: "_updateCachedColumnAndRowSizes",
    value: function _updateCachedColumnAndRowSizes(rowIndex, columnIndex) {
      // :columnWidth and :rowHeight are derived based on all cells in a column/row.
      // Pre-cache these derived values for faster lookup later.
      // Reads are expected to occur more frequently than writes in this case.
      // Only update non-fixed dimensions though to avoid doing unnecessary work.
      if (!this._hasFixedWidth) {
        var columnWidth = 0;

        for (var i = 0; i < this._rowCount; i++) {
          columnWidth = Math.max(columnWidth, this.getWidth(i, columnIndex));
        }

        var columnKey = this._keyMapper(0, columnIndex);

        this._columnWidthCache[columnKey] = columnWidth;
      }

      if (!this._hasFixedHeight) {
        var rowHeight = 0;

        for (var _i = 0; _i < this._columnCount; _i++) {
          rowHeight = Math.max(rowHeight, this.getHeight(rowIndex, _i));
        }

        var rowKey = this._keyMapper(rowIndex, 0);

        this._rowHeightCache[rowKey] = rowHeight;
      }
    }
  }, {
    key: "defaultHeight",
    get: function get() {
      return this._defaultHeight;
    }
  }, {
    key: "defaultWidth",
    get: function get() {
      return this._defaultWidth;
    }
  }]);

  return CellMeasurerCache;
}();



function defaultKeyMapper(rowIndex, columnIndex) {
  return "".concat(rowIndex, "-").concat(columnIndex);
}



/***/ }),
/* 2200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Collection__ = __webpack_require__(2201);
/* unused harmony reexport Collection */

/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__Collection__["a" /* default */]);


/***/ }),
/* 2201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Collection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CollectionView__ = __webpack_require__(2202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_calculateSizeAndPositionData__ = __webpack_require__(2203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_getUpdatedOffsetForIndex__ = __webpack_require__(2206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__types__ = __webpack_require__(161);














/**
 * Renders scattered or non-linear data.
 * Unlike Grid, which renders checkerboard data, Collection can render arbitrarily positioned- even overlapping- data.
 */
var Collection =
/*#__PURE__*/
function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Collection, _React$PureComponent);

  function Collection(props, context) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Collection);

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Collection).call(this, props, context));
    _this._cellMetadata = [];
    _this._lastRenderedCellIndices = []; // Cell cache during scroll (for performance)

    _this._cellCache = [];
    _this._isScrollingChange = _this._isScrollingChange.bind(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this));
    _this._setCollectionViewRef = _this._setCollectionViewRef.bind(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this));
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Collection, [{
    key: "forceUpdate",
    value: function forceUpdate() {
      if (this._collectionView !== undefined) {
        this._collectionView.forceUpdate();
      }
    }
    /** See Collection#recomputeCellSizesAndPositions */

  }, {
    key: "recomputeCellSizesAndPositions",
    value: function recomputeCellSizesAndPositions() {
      this._cellCache = [];

      this._collectionView.recomputeCellSizesAndPositions();
    }
    /** React lifecycle methods */

  }, {
    key: "render",
    value: function render() {
      var props = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, this.props);

      return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__CollectionView__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
        cellLayoutManager: this,
        isScrollingChange: this._isScrollingChange,
        ref: this._setCollectionViewRef
      }, props));
    }
    /** CellLayoutManager interface */

  }, {
    key: "calculateSizeAndPositionData",
    value: function calculateSizeAndPositionData() {
      var _this$props = this.props,
          cellCount = _this$props.cellCount,
          cellSizeAndPositionGetter = _this$props.cellSizeAndPositionGetter,
          sectionSize = _this$props.sectionSize;

      var data = Object(__WEBPACK_IMPORTED_MODULE_11__utils_calculateSizeAndPositionData__["a" /* default */])({
        cellCount: cellCount,
        cellSizeAndPositionGetter: cellSizeAndPositionGetter,
        sectionSize: sectionSize
      });

      this._cellMetadata = data.cellMetadata;
      this._sectionManager = data.sectionManager;
      this._height = data.height;
      this._width = data.width;
    }
    /**
     * Returns the most recently rendered set of cell indices.
     */

  }, {
    key: "getLastRenderedIndices",
    value: function getLastRenderedIndices() {
      return this._lastRenderedCellIndices;
    }
    /**
     * Calculates the minimum amount of change from the current scroll position to ensure the specified cell is (fully) visible.
     */

  }, {
    key: "getScrollPositionForCell",
    value: function getScrollPositionForCell(_ref) {
      var align = _ref.align,
          cellIndex = _ref.cellIndex,
          height = _ref.height,
          scrollLeft = _ref.scrollLeft,
          scrollTop = _ref.scrollTop,
          width = _ref.width;
      var cellCount = this.props.cellCount;

      if (cellIndex >= 0 && cellIndex < cellCount) {
        var cellMetadata = this._cellMetadata[cellIndex];
        scrollLeft = Object(__WEBPACK_IMPORTED_MODULE_12__utils_getUpdatedOffsetForIndex__["a" /* default */])({
          align: align,
          cellOffset: cellMetadata.x,
          cellSize: cellMetadata.width,
          containerSize: width,
          currentOffset: scrollLeft,
          targetIndex: cellIndex
        });
        scrollTop = Object(__WEBPACK_IMPORTED_MODULE_12__utils_getUpdatedOffsetForIndex__["a" /* default */])({
          align: align,
          cellOffset: cellMetadata.y,
          cellSize: cellMetadata.height,
          containerSize: height,
          currentOffset: scrollTop,
          targetIndex: cellIndex
        });
      }

      return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      };
    }
  }, {
    key: "getTotalSize",
    value: function getTotalSize() {
      return {
        height: this._height,
        width: this._width
      };
    }
  }, {
    key: "cellRenderers",
    value: function cellRenderers(_ref2) {
      var _this2 = this;

      var height = _ref2.height,
          isScrolling = _ref2.isScrolling,
          width = _ref2.width,
          x = _ref2.x,
          y = _ref2.y;
      var _this$props2 = this.props,
          cellGroupRenderer = _this$props2.cellGroupRenderer,
          cellRenderer = _this$props2.cellRenderer; // Store for later calls to getLastRenderedIndices()

      this._lastRenderedCellIndices = this._sectionManager.getCellIndices({
        height: height,
        width: width,
        x: x,
        y: y
      });
      return cellGroupRenderer({
        cellCache: this._cellCache,
        cellRenderer: cellRenderer,
        cellSizeAndPositionGetter: function cellSizeAndPositionGetter(_ref3) {
          var index = _ref3.index;
          return _this2._sectionManager.getCellMetadata({
            index: index
          });
        },
        indices: this._lastRenderedCellIndices,
        isScrolling: isScrolling
      });
    }
  }, {
    key: "_isScrollingChange",
    value: function _isScrollingChange(isScrolling) {
      if (!isScrolling) {
        this._cellCache = [];
      }
    }
  }, {
    key: "_setCollectionViewRef",
    value: function _setCollectionViewRef(ref) {
      this._collectionView = ref;
    }
  }]);

  return Collection;
}(__WEBPACK_IMPORTED_MODULE_9_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Collection, "defaultProps", {
  'aria-label': 'grid',
  cellGroupRenderer: defaultCellGroupRenderer
});


Collection.propTypes =  false ? {
  'aria-label': PropTypes.string,

  /**
   * Number of cells in Collection.
   */
  cellCount: PropTypes.number.isRequired,

  /**
   * Responsible for rendering a group of cells given their indices.
   * Should implement the following interface: ({
   *   cellSizeAndPositionGetter:Function,
   *   indices: Array<number>,
   *   cellRenderer: Function
   * }): Array<PropTypes.node>
   */
  cellGroupRenderer: PropTypes.func.isRequired,

  /**
   * Responsible for rendering a cell given an row and column index.
   * Should implement the following interface: ({ index: number, key: string, style: object }): PropTypes.element
   */
  cellRenderer: PropTypes.func.isRequired,

  /**
   * Callback responsible for returning size and offset/position information for a given cell (index).
   * ({ index: number }): { height: number, width: number, x: number, y: number }
   */
  cellSizeAndPositionGetter: PropTypes.func.isRequired,

  /**
   * Optionally override the size of the sections a Collection's cells are split into.
   */
  sectionSize: PropTypes.number
} : {};

function defaultCellGroupRenderer(_ref4) {
  var cellCache = _ref4.cellCache,
      cellRenderer = _ref4.cellRenderer,
      cellSizeAndPositionGetter = _ref4.cellSizeAndPositionGetter,
      indices = _ref4.indices,
      isScrolling = _ref4.isScrolling;
  return indices.map(function (index) {
    var cellMetadata = cellSizeAndPositionGetter({
      index: index
    });
    var cellRendererProps = {
      index: index,
      isScrolling: isScrolling,
      key: index,
      style: {
        height: cellMetadata.height,
        left: cellMetadata.x,
        position: 'absolute',
        top: cellMetadata.y,
        width: cellMetadata.width
      }
    }; // Avoid re-creating cells while scrolling.
    // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
    // If a scroll is in progress- cache and reuse cells.
    // This cache will be thrown away once scrolling complets.

    if (isScrolling) {
      if (!(index in cellCache)) {
        cellCache[index] = cellRenderer(cellRendererProps);
      }

      return cellCache[index];
    } else {
      return cellRenderer(cellRendererProps);
    }
  }).filter(function (renderedCell) {
    return !!renderedCell;
  });
}




/***/ }),
/* 2202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_clsx__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_lifecycles_compat__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_createCallbackMemoizer__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_dom_helpers_scrollbarSize__ = __webpack_require__(870);








function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






 // @TODO Merge Collection and CollectionView

/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */

var IS_SCROLLING_TIMEOUT = 150;
/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */

var SCROLL_POSITION_CHANGE_REASONS = {
  OBSERVED: 'observed',
  REQUESTED: 'requested'
};
/**
 * Monitors changes in properties (eg. cellCount) and state (eg. scroll offsets) to determine when rendering needs to occur.
 * This component does not render any visible content itself; it defers to the specified :cellLayoutManager.
 */

var CollectionView =
/*#__PURE__*/
function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(CollectionView, _React$PureComponent);

  // Invokes callbacks only when their values have changed.
  function CollectionView() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, CollectionView);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(CollectionView)).call.apply(_getPrototypeOf2, [this].concat(args))); // If this component is being rendered server-side, getScrollbarSize() will return undefined.
    // We handle this case in componentDidMount()

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      isScrolling: false,
      scrollLeft: 0,
      scrollTop: 0
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_calculateSizeAndPositionDataOnNextUpdate", false);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_onSectionRenderedMemoizer", Object(__WEBPACK_IMPORTED_MODULE_11__utils_createCallbackMemoizer__["a" /* default */])());

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_onScrollMemoizer", Object(__WEBPACK_IMPORTED_MODULE_11__utils_createCallbackMemoizer__["a" /* default */])(false));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_invokeOnSectionRenderedHelper", function () {
      var _this$props = _this.props,
          cellLayoutManager = _this$props.cellLayoutManager,
          onSectionRendered = _this$props.onSectionRendered;

      _this._onSectionRenderedMemoizer({
        callback: onSectionRendered,
        indices: {
          indices: cellLayoutManager.getLastRenderedIndices()
        }
      });
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_setScrollingContainerRef", function (ref) {
      _this._scrollingContainer = ref;
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_updateScrollPositionForScrollToCell", function () {
      var _this$props2 = _this.props,
          cellLayoutManager = _this$props2.cellLayoutManager,
          height = _this$props2.height,
          scrollToAlignment = _this$props2.scrollToAlignment,
          scrollToCell = _this$props2.scrollToCell,
          width = _this$props2.width;
      var _this$state = _this.state,
          scrollLeft = _this$state.scrollLeft,
          scrollTop = _this$state.scrollTop;

      if (scrollToCell >= 0) {
        var scrollPosition = cellLayoutManager.getScrollPositionForCell({
          align: scrollToAlignment,
          cellIndex: scrollToCell,
          height: height,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          width: width
        });

        if (scrollPosition.scrollLeft !== scrollLeft || scrollPosition.scrollTop !== scrollTop) {
          _this._setScrollPosition(scrollPosition);
        }
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_onScroll", function (event) {
      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
      // See issue #404 for more information.
      if (event.target !== _this._scrollingContainer) {
        return;
      } // Prevent pointer events from interrupting a smooth scroll


      _this._enablePointerEventsAfterDelay(); // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scrollTop never exceeds the total height.


      var _this$props3 = _this.props,
          cellLayoutManager = _this$props3.cellLayoutManager,
          height = _this$props3.height,
          isScrollingChange = _this$props3.isScrollingChange,
          width = _this$props3.width;
      var scrollbarSize = _this._scrollbarSize;

      var _cellLayoutManager$ge = cellLayoutManager.getTotalSize(),
          totalHeight = _cellLayoutManager$ge.height,
          totalWidth = _cellLayoutManager$ge.width;

      var scrollLeft = Math.max(0, Math.min(totalWidth - width + scrollbarSize, event.target.scrollLeft));
      var scrollTop = Math.max(0, Math.min(totalHeight - height + scrollbarSize, event.target.scrollTop)); // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.

      if (_this.state.scrollLeft !== scrollLeft || _this.state.scrollTop !== scrollTop) {
        // Browsers with cancelable scroll events (eg. Firefox) interrupt scrolling animations if scrollTop/scrollLeft is set.
        // Other browsers (eg. Safari) don't scroll as well without the help under certain conditions (DOM or style changes during scrolling).
        // All things considered, this seems to be the best current work around that I'm aware of.
        // For more information see https://github.com/bvaughn/react-virtualized/pull/124
        var scrollPositionChangeReason = event.cancelable ? SCROLL_POSITION_CHANGE_REASONS.OBSERVED : SCROLL_POSITION_CHANGE_REASONS.REQUESTED; // Synchronously set :isScrolling the first time (since _setNextState will reschedule its animation frame each time it's called)

        if (!_this.state.isScrolling) {
          isScrollingChange(true);
        }

        _this.setState({
          isScrolling: true,
          scrollLeft: scrollLeft,
          scrollPositionChangeReason: scrollPositionChangeReason,
          scrollTop: scrollTop
        });
      }

      _this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        totalWidth: totalWidth,
        totalHeight: totalHeight
      });
    });

    _this._scrollbarSize = Object(__WEBPACK_IMPORTED_MODULE_12_dom_helpers_scrollbarSize__["a" /* default */])();

    if (_this._scrollbarSize === undefined) {
      _this._scrollbarSizeMeasured = false;
      _this._scrollbarSize = 0;
    } else {
      _this._scrollbarSizeMeasured = true;
    }

    return _this;
  }
  /**
   * Forced recompute of cell sizes and positions.
   * This function should be called if cell sizes have changed but nothing else has.
   * Since cell positions are calculated by callbacks, the collection view has no way of detecting when the underlying data has changed.
   */


  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(CollectionView, [{
    key: "recomputeCellSizesAndPositions",
    value: function recomputeCellSizesAndPositions() {
      this._calculateSizeAndPositionDataOnNextUpdate = true;
      this.forceUpdate();
    }
    /* ---------------------------- Component lifecycle methods ---------------------------- */

    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props4 = this.props,
          cellLayoutManager = _this$props4.cellLayoutManager,
          scrollLeft = _this$props4.scrollLeft,
          scrollToCell = _this$props4.scrollToCell,
          scrollTop = _this$props4.scrollTop; // If this component was first rendered server-side, scrollbar size will be undefined.
      // In that event we need to remeasure.

      if (!this._scrollbarSizeMeasured) {
        this._scrollbarSize = Object(__WEBPACK_IMPORTED_MODULE_12_dom_helpers_scrollbarSize__["a" /* default */])();
        this._scrollbarSizeMeasured = true;
        this.setState({});
      }

      if (scrollToCell >= 0) {
        this._updateScrollPositionForScrollToCell();
      } else if (scrollLeft >= 0 || scrollTop >= 0) {
        this._setScrollPosition({
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        });
      } // Update onSectionRendered callback.


      this._invokeOnSectionRenderedHelper();

      var _cellLayoutManager$ge2 = cellLayoutManager.getTotalSize(),
          totalHeight = _cellLayoutManager$ge2.height,
          totalWidth = _cellLayoutManager$ge2.width; // Initialize onScroll callback.


      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft || 0,
        scrollTop: scrollTop || 0,
        totalHeight: totalHeight,
        totalWidth: totalWidth
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props5 = this.props,
          height = _this$props5.height,
          scrollToAlignment = _this$props5.scrollToAlignment,
          scrollToCell = _this$props5.scrollToCell,
          width = _this$props5.width;
      var _this$state2 = this.state,
          scrollLeft = _this$state2.scrollLeft,
          scrollPositionChangeReason = _this$state2.scrollPositionChangeReason,
          scrollTop = _this$state2.scrollTop; // Make sure requested changes to :scrollLeft or :scrollTop get applied.
      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
      // So we only set these when we require an adjustment of the scroll position.
      // See issue #2 for more information.

      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
        if (scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft && scrollLeft !== this._scrollingContainer.scrollLeft) {
          this._scrollingContainer.scrollLeft = scrollLeft;
        }

        if (scrollTop >= 0 && scrollTop !== prevState.scrollTop && scrollTop !== this._scrollingContainer.scrollTop) {
          this._scrollingContainer.scrollTop = scrollTop;
        }
      } // Update scroll offsets if the current :scrollToCell values requires it


      if (height !== prevProps.height || scrollToAlignment !== prevProps.scrollToAlignment || scrollToCell !== prevProps.scrollToCell || width !== prevProps.width) {
        this._updateScrollPositionForScrollToCell();
      } // Update onRowsRendered callback if start/stop indices have changed


      this._invokeOnSectionRenderedHelper();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._disablePointerEventsTimeoutId) {
        clearTimeout(this._disablePointerEventsTimeoutId);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          autoHeight = _this$props6.autoHeight,
          cellCount = _this$props6.cellCount,
          cellLayoutManager = _this$props6.cellLayoutManager,
          className = _this$props6.className,
          height = _this$props6.height,
          horizontalOverscanSize = _this$props6.horizontalOverscanSize,
          id = _this$props6.id,
          noContentRenderer = _this$props6.noContentRenderer,
          style = _this$props6.style,
          verticalOverscanSize = _this$props6.verticalOverscanSize,
          width = _this$props6.width;
      var _this$state3 = this.state,
          isScrolling = _this$state3.isScrolling,
          scrollLeft = _this$state3.scrollLeft,
          scrollTop = _this$state3.scrollTop; // Memoization reset

      if (this._lastRenderedCellCount !== cellCount || this._lastRenderedCellLayoutManager !== cellLayoutManager || this._calculateSizeAndPositionDataOnNextUpdate) {
        this._lastRenderedCellCount = cellCount;
        this._lastRenderedCellLayoutManager = cellLayoutManager;
        this._calculateSizeAndPositionDataOnNextUpdate = false;
        cellLayoutManager.calculateSizeAndPositionData();
      }

      var _cellLayoutManager$ge3 = cellLayoutManager.getTotalSize(),
          totalHeight = _cellLayoutManager$ge3.height,
          totalWidth = _cellLayoutManager$ge3.width; // Safely expand the rendered area by the specified overscan amount


      var left = Math.max(0, scrollLeft - horizontalOverscanSize);
      var top = Math.max(0, scrollTop - verticalOverscanSize);
      var right = Math.min(totalWidth, scrollLeft + width + horizontalOverscanSize);
      var bottom = Math.min(totalHeight, scrollTop + height + verticalOverscanSize);
      var childrenToDisplay = height > 0 && width > 0 ? cellLayoutManager.cellRenderers({
        height: bottom - top,
        isScrolling: isScrolling,
        width: right - left,
        x: left,
        y: top
      }) : [];
      var collectionStyle = {
        boxSizing: 'border-box',
        direction: 'ltr',
        height: autoHeight ? 'auto' : height,
        position: 'relative',
        WebkitOverflowScrolling: 'touch',
        width: width,
        willChange: 'transform'
      }; // Force browser to hide scrollbars when we know they aren't necessary.
      // Otherwise once scrollbars appear they may not disappear again.
      // For more info see issue #116

      var verticalScrollBarSize = totalHeight > height ? this._scrollbarSize : 0;
      var horizontalScrollBarSize = totalWidth > width ? this._scrollbarSize : 0; // Also explicitly init styles to 'auto' if scrollbars are required.
      // This works around an obscure edge case where external CSS styles have not yet been loaded,
      // But an initial scroll index of offset is set as an external prop.
      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
      // This was originally reported via clauderic/react-infinite-calendar/issues/23

      collectionStyle.overflowX = totalWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
      collectionStyle.overflowY = totalHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
      return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("div", {
        ref: this._setScrollingContainerRef,
        "aria-label": this.props['aria-label'],
        className: Object(__WEBPACK_IMPORTED_MODULE_7_clsx__["a" /* default */])('ReactVirtualized__Collection', className),
        id: id,
        onScroll: this._onScroll,
        role: "grid",
        style: _objectSpread({}, collectionStyle, {}, style),
        tabIndex: 0
      }, cellCount > 0 && __WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("div", {
        className: "ReactVirtualized__Collection__innerScrollContainer",
        style: {
          height: totalHeight,
          maxHeight: totalHeight,
          maxWidth: totalWidth,
          overflow: 'hidden',
          pointerEvents: isScrolling ? 'none' : '',
          width: totalWidth
        }
      }, childrenToDisplay), cellCount === 0 && noContentRenderer());
    }
    /* ---------------------------- Helper methods ---------------------------- */

    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Collection.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */

  }, {
    key: "_enablePointerEventsAfterDelay",
    value: function _enablePointerEventsAfterDelay() {
      var _this2 = this;

      if (this._disablePointerEventsTimeoutId) {
        clearTimeout(this._disablePointerEventsTimeoutId);
      }

      this._disablePointerEventsTimeoutId = setTimeout(function () {
        var isScrollingChange = _this2.props.isScrollingChange;
        isScrollingChange(false);
        _this2._disablePointerEventsTimeoutId = null;

        _this2.setState({
          isScrolling: false
        });
      }, IS_SCROLLING_TIMEOUT);
    }
  }, {
    key: "_invokeOnScrollMemoizer",
    value: function _invokeOnScrollMemoizer(_ref) {
      var _this3 = this;

      var scrollLeft = _ref.scrollLeft,
          scrollTop = _ref.scrollTop,
          totalHeight = _ref.totalHeight,
          totalWidth = _ref.totalWidth;

      this._onScrollMemoizer({
        callback: function callback(_ref2) {
          var scrollLeft = _ref2.scrollLeft,
              scrollTop = _ref2.scrollTop;
          var _this3$props = _this3.props,
              height = _this3$props.height,
              onScroll = _this3$props.onScroll,
              width = _this3$props.width;
          onScroll({
            clientHeight: height,
            clientWidth: width,
            scrollHeight: totalHeight,
            scrollLeft: scrollLeft,
            scrollTop: scrollTop,
            scrollWidth: totalWidth
          });
        },
        indices: {
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        }
      });
    }
  }, {
    key: "_setScrollPosition",
    value: function _setScrollPosition(_ref3) {
      var scrollLeft = _ref3.scrollLeft,
          scrollTop = _ref3.scrollTop;
      var newState = {
        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
      };

      if (scrollLeft >= 0) {
        newState.scrollLeft = scrollLeft;
      }

      if (scrollTop >= 0) {
        newState.scrollTop = scrollTop;
      }

      if (scrollLeft >= 0 && scrollLeft !== this.state.scrollLeft || scrollTop >= 0 && scrollTop !== this.state.scrollTop) {
        this.setState(newState);
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.cellCount === 0 && (prevState.scrollLeft !== 0 || prevState.scrollTop !== 0)) {
        return {
          scrollLeft: 0,
          scrollTop: 0,
          scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
        };
      } else if (nextProps.scrollLeft !== prevState.scrollLeft || nextProps.scrollTop !== prevState.scrollTop) {
        return {
          scrollLeft: nextProps.scrollLeft != null ? nextProps.scrollLeft : prevState.scrollLeft,
          scrollTop: nextProps.scrollTop != null ? nextProps.scrollTop : prevState.scrollTop,
          scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
        };
      }

      return null;
    }
  }]);

  return CollectionView;
}(__WEBPACK_IMPORTED_MODULE_9_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(CollectionView, "defaultProps", {
  'aria-label': 'grid',
  horizontalOverscanSize: 0,
  noContentRenderer: function noContentRenderer() {
    return null;
  },
  onScroll: function onScroll() {
    return null;
  },
  onSectionRendered: function onSectionRendered() {
    return null;
  },
  scrollToAlignment: 'auto',
  scrollToCell: -1,
  style: {},
  verticalOverscanSize: 0
});

CollectionView.propTypes =  false ? {
  'aria-label': PropTypes.string,

  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  autoHeight: PropTypes.bool,

  /**
   * Number of cells in collection.
   */
  cellCount: PropTypes.number.isRequired,

  /**
   * Calculates cell sizes and positions and manages rendering the appropriate cells given a specified window.
   */
  cellLayoutManager: PropTypes.object.isRequired,

  /**
   * Optional custom CSS class name to attach to root Collection element.
   */
  className: PropTypes.string,

  /**
   * Height of Collection; this property determines the number of visible (vs virtualized) rows.
   */
  height: PropTypes.number.isRequired,

  /**
   * Optional custom id to attach to root Collection element.
   */
  id: PropTypes.string,

  /**
   * Enables the `Collection` to horiontally "overscan" its content similar to how `Grid` does.
   * This can reduce flicker around the edges when a user scrolls quickly.
   */
  horizontalOverscanSize: PropTypes.number.isRequired,
  isScrollingChange: PropTypes.func,

  /**
   * Optional renderer to be used in place of rows when either :rowCount or :cellCount is 0.
   */
  noContentRenderer: PropTypes.func.isRequired,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   * ({ clientHeight, clientWidth, scrollHeight, scrollLeft, scrollTop, scrollWidth }): void
   */
  onScroll: PropTypes.func.isRequired,

  /**
   * Callback invoked with information about the section of the Collection that was just rendered.
   * This callback is passed a named :indices parameter which is an Array of the most recently rendered section indices.
   */
  onSectionRendered: PropTypes.func.isRequired,

  /**
   * Horizontal offset.
   */
  scrollLeft: PropTypes.number,

  /**
   * Controls scroll-to-cell behavior of the Grid.
   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
   */
  scrollToAlignment: PropTypes.oneOf(['auto', 'end', 'start', 'center']).isRequired,

  /**
   * Cell index to ensure visible (by forcefully scrolling if necessary).
   */
  scrollToCell: PropTypes.number.isRequired,

  /**
   * Vertical offset.
   */
  scrollTop: PropTypes.number,

  /**
   * Optional custom inline style to attach to root Collection element.
   */
  style: PropTypes.object,

  /**
   * Enables the `Collection` to vertically "overscan" its content similar to how `Grid` does.
   * This can reduce flicker around the edges when a user scrolls quickly.
   */
  verticalOverscanSize: PropTypes.number.isRequired,

  /**
   * Width of Collection; this property determines the number of visible (vs virtualized) columns.
   */
  width: PropTypes.number.isRequired
} : {};
Object(__WEBPACK_IMPORTED_MODULE_10_react_lifecycles_compat__["a" /* polyfill */])(CollectionView);
/* harmony default export */ __webpack_exports__["a"] = (CollectionView);

/***/ }),
/* 2203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calculateSizeAndPositionData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SectionManager__ = __webpack_require__(2204);

function calculateSizeAndPositionData(_ref) {
  var cellCount = _ref.cellCount,
      cellSizeAndPositionGetter = _ref.cellSizeAndPositionGetter,
      sectionSize = _ref.sectionSize;
  var cellMetadata = [];
  var sectionManager = new __WEBPACK_IMPORTED_MODULE_0__SectionManager__["a" /* default */](sectionSize);
  var height = 0;
  var width = 0;

  for (var index = 0; index < cellCount; index++) {
    var cellMetadatum = cellSizeAndPositionGetter({
      index: index
    });

    if (cellMetadatum.height == null || isNaN(cellMetadatum.height) || cellMetadatum.width == null || isNaN(cellMetadatum.width) || cellMetadatum.x == null || isNaN(cellMetadatum.x) || cellMetadatum.y == null || isNaN(cellMetadatum.y)) {
      throw Error("Invalid metadata returned for cell ".concat(index, ":\n        x:").concat(cellMetadatum.x, ", y:").concat(cellMetadatum.y, ", width:").concat(cellMetadatum.width, ", height:").concat(cellMetadatum.height));
    }

    height = Math.max(height, cellMetadatum.y + cellMetadatum.height);
    width = Math.max(width, cellMetadatum.x + cellMetadatum.width);
    cellMetadata[index] = cellMetadatum;
    sectionManager.registerCell({
      cellMetadatum: cellMetadatum,
      index: index
    });
  }

  return {
    cellMetadata: cellMetadata,
    height: height,
    sectionManager: sectionManager,
    width: width
  };
}

/***/ }),
/* 2204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SectionManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Section__ = __webpack_require__(2205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(161);



/**
 * Window Sections are used to group nearby cells.
 * This enables us to more quickly determine which cells to display in a given region of the Window.
 * 
 */

var SECTION_SIZE = 100;

/**
 * Contains 0 to many Sections.
 * Grows (and adds Sections) dynamically as cells are registered.
 * Automatically adds cells to the appropriate Section(s).
 */
var SectionManager =
/*#__PURE__*/
function () {
  function SectionManager() {
    var sectionSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SECTION_SIZE;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, SectionManager);

    this._sectionSize = sectionSize;
    this._cellMetadata = [];
    this._sections = {};
  }
  /**
   * Gets all cell indices contained in the specified region.
   * A region may encompass 1 or more Sections.
   */


  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(SectionManager, [{
    key: "getCellIndices",
    value: function getCellIndices(_ref) {
      var height = _ref.height,
          width = _ref.width,
          x = _ref.x,
          y = _ref.y;
      var indices = {};
      this.getSections({
        height: height,
        width: width,
        x: x,
        y: y
      }).forEach(function (section) {
        return section.getCellIndices().forEach(function (index) {
          indices[index] = index;
        });
      }); // Object keys are strings; this function returns numbers

      return Object.keys(indices).map(function (index) {
        return indices[index];
      });
    }
    /** Get size and position information for the cell specified. */

  }, {
    key: "getCellMetadata",
    value: function getCellMetadata(_ref2) {
      var index = _ref2.index;
      return this._cellMetadata[index];
    }
    /** Get all Sections overlapping the specified region. */

  }, {
    key: "getSections",
    value: function getSections(_ref3) {
      var height = _ref3.height,
          width = _ref3.width,
          x = _ref3.x,
          y = _ref3.y;
      var sectionXStart = Math.floor(x / this._sectionSize);
      var sectionXStop = Math.floor((x + width - 1) / this._sectionSize);
      var sectionYStart = Math.floor(y / this._sectionSize);
      var sectionYStop = Math.floor((y + height - 1) / this._sectionSize);
      var sections = [];

      for (var sectionX = sectionXStart; sectionX <= sectionXStop; sectionX++) {
        for (var sectionY = sectionYStart; sectionY <= sectionYStop; sectionY++) {
          var key = "".concat(sectionX, ".").concat(sectionY);

          if (!this._sections[key]) {
            this._sections[key] = new __WEBPACK_IMPORTED_MODULE_2__Section__["a" /* default */]({
              height: this._sectionSize,
              width: this._sectionSize,
              x: sectionX * this._sectionSize,
              y: sectionY * this._sectionSize
            });
          }

          sections.push(this._sections[key]);
        }
      }

      return sections;
    }
    /** Total number of Sections based on the currently registered cells. */

  }, {
    key: "getTotalSectionCount",
    value: function getTotalSectionCount() {
      return Object.keys(this._sections).length;
    }
    /** Intended for debugger/test purposes only */

  }, {
    key: "toString",
    value: function toString() {
      var _this = this;

      return Object.keys(this._sections).map(function (index) {
        return _this._sections[index].toString();
      });
    }
    /** Adds a cell to the appropriate Sections and registers it metadata for later retrievable. */

  }, {
    key: "registerCell",
    value: function registerCell(_ref4) {
      var cellMetadatum = _ref4.cellMetadatum,
          index = _ref4.index;
      this._cellMetadata[index] = cellMetadatum;
      this.getSections(cellMetadatum).forEach(function (section) {
        return section.addCellIndex({
          index: index
        });
      });
    }
  }]);

  return SectionManager;
}();





/***/ }),
/* 2205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Section; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(161);



/**
 * A section of the Window.
 * Window Sections are used to group nearby cells.
 * This enables us to more quickly determine which cells to display in a given region of the Window.
 * Sections have a fixed size and contain 0 to many cells (tracked by their indices).
 */
var Section =
/*#__PURE__*/
function () {
  function Section(_ref) {
    var height = _ref.height,
        width = _ref.width,
        x = _ref.x,
        y = _ref.y;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Section);

    this.height = height;
    this.width = width;
    this.x = x;
    this.y = y;
    this._indexMap = {};
    this._indices = [];
  }
  /** Add a cell to this section. */


  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Section, [{
    key: "addCellIndex",
    value: function addCellIndex(_ref2) {
      var index = _ref2.index;

      if (!this._indexMap[index]) {
        this._indexMap[index] = true;

        this._indices.push(index);
      }
    }
    /** Get all cell indices that have been added to this section. */

  }, {
    key: "getCellIndices",
    value: function getCellIndices() {
      return this._indices;
    }
    /** Intended for debugger/test purposes only */

  }, {
    key: "toString",
    value: function toString() {
      return "".concat(this.x, ",").concat(this.y, " ").concat(this.width, "x").concat(this.height);
    }
  }]);

  return Section;
}();





/***/ }),
/* 2206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUpdatedOffsetForIndex;
/**
 * Determines a new offset that ensures a certain cell is visible, given the current offset.
 * If the cell is already visible then the current offset will be returned.
 * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
 *
 * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
 * @param cellOffset Offset (x or y) position for cell
 * @param cellSize Size (width or height) of cell
 * @param containerSize Total size (width or height) of the container
 * @param currentOffset Container's current (x or y) offset
 * @return Offset to use to ensure the specified cell is visible
 */
function getUpdatedOffsetForIndex(_ref) {
  var _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'auto' : _ref$align,
      cellOffset = _ref.cellOffset,
      cellSize = _ref.cellSize,
      containerSize = _ref.containerSize,
      currentOffset = _ref.currentOffset;
  var maxOffset = cellOffset;
  var minOffset = maxOffset - containerSize + cellSize;

  switch (align) {
    case 'start':
      return maxOffset;

    case 'end':
      return minOffset;

    case 'center':
      return maxOffset - (containerSize - cellSize) / 2;

    default:
      return Math.max(minOffset, Math.min(maxOffset, currentOffset));
  }
}

/***/ }),
/* 2207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ColumnSizer__ = __webpack_require__(2208);
/* unused harmony reexport ColumnSizer */

/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__ColumnSizer__["a" /* default */]);


/***/ }),
/* 2208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ColumnSizer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);








/**
 * High-order component that auto-calculates column-widths for `Grid` cells.
 */

var ColumnSizer =
/*#__PURE__*/
function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(ColumnSizer, _React$PureComponent);

  function ColumnSizer(props, context) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, ColumnSizer);

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(ColumnSizer).call(this, props, context));
    _this._registerChild = _this._registerChild.bind(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this));
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ColumnSizer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          columnMaxWidth = _this$props.columnMaxWidth,
          columnMinWidth = _this$props.columnMinWidth,
          columnCount = _this$props.columnCount,
          width = _this$props.width;

      if (columnMaxWidth !== prevProps.columnMaxWidth || columnMinWidth !== prevProps.columnMinWidth || columnCount !== prevProps.columnCount || width !== prevProps.width) {
        if (this._registeredChild) {
          this._registeredChild.recomputeGridSize();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          columnMaxWidth = _this$props2.columnMaxWidth,
          columnMinWidth = _this$props2.columnMinWidth,
          columnCount = _this$props2.columnCount,
          width = _this$props2.width;
      var safeColumnMinWidth = columnMinWidth || 1;
      var safeColumnMaxWidth = columnMaxWidth ? Math.min(columnMaxWidth, width) : width;
      var columnWidth = width / columnCount;
      columnWidth = Math.max(safeColumnMinWidth, columnWidth);
      columnWidth = Math.min(safeColumnMaxWidth, columnWidth);
      columnWidth = Math.floor(columnWidth);
      var adjustedWidth = Math.min(width, columnWidth * columnCount);
      return children({
        adjustedWidth: adjustedWidth,
        columnWidth: columnWidth,
        getColumnWidth: function getColumnWidth() {
          return columnWidth;
        },
        registerChild: this._registerChild
      });
    }
  }, {
    key: "_registerChild",
    value: function _registerChild(child) {
      if (child && typeof child.recomputeGridSize !== 'function') {
        throw Error('Unexpected child type registered; only Grid/MultiGrid children are supported.');
      }

      this._registeredChild = child;

      if (this._registeredChild) {
        this._registeredChild.recomputeGridSize();
      }
    }
  }]);

  return ColumnSizer;
}(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"]);


ColumnSizer.propTypes =  false ? {
  /**
   * Function responsible for rendering a virtualized Grid.
   * This function should implement the following signature:
   * ({ adjustedWidth, getColumnWidth, registerChild }) => PropTypes.element
   *
   * The specified :getColumnWidth function should be passed to the Grid's :columnWidth property.
   * The :registerChild should be passed to the Grid's :ref property.
   * The :adjustedWidth property is optional; it reflects the lesser of the overall width or the width of all columns.
   */
  children: PropTypes.func.isRequired,

  /** Optional maximum allowed column width */
  columnMaxWidth: PropTypes.number,

  /** Optional minimum allowed column width */
  columnMinWidth: PropTypes.number,

  /** Number of columns in Grid or Table child */
  columnCount: PropTypes.number.isRequired,

  /** Width of Grid or Table child */
  width: PropTypes.number.isRequired
} : {};

/***/ }),
/* 2209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InfiniteLoader__ = __webpack_require__(2210);
/* unused harmony reexport InfiniteLoader */

/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__InfiniteLoader__["a" /* default */]);


/***/ }),
/* 2210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InfiniteLoader; });
/* unused harmony export isRangeVisible */
/* unused harmony export scanForUnloadedRanges */
/* unused harmony export forceUpdateReactVirtualizedComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(2211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createCallbackMemoizer__ = __webpack_require__(481);











/**
 * Higher-order component that manages lazy-loading for "infinite" data.
 * This component decorates a virtual component and just-in-time prefetches rows as a user scrolls.
 * It is intended as a convenience component; fork it if you'd like finer-grained control over data-loading.
 */

var InfiniteLoader =
/*#__PURE__*/
function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(InfiniteLoader, _React$PureComponent);

  function InfiniteLoader(props, context) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, InfiniteLoader);

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(InfiniteLoader).call(this, props, context));
    _this._loadMoreRowsMemoizer = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createCallbackMemoizer__["a" /* default */])();
    _this._onRowsRendered = _this._onRowsRendered.bind(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this));
    _this._registerChild = _this._registerChild.bind(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this));
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(InfiniteLoader, [{
    key: "resetLoadMoreRowsCache",
    value: function resetLoadMoreRowsCache(autoReload) {
      this._loadMoreRowsMemoizer = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createCallbackMemoizer__["a" /* default */])();

      if (autoReload) {
        this._doStuff(this._lastRenderedStartIndex, this._lastRenderedStopIndex);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children({
        onRowsRendered: this._onRowsRendered,
        registerChild: this._registerChild
      });
    }
  }, {
    key: "_loadUnloadedRanges",
    value: function _loadUnloadedRanges(unloadedRanges) {
      var _this2 = this;

      var loadMoreRows = this.props.loadMoreRows;
      unloadedRanges.forEach(function (unloadedRange) {
        var promise = loadMoreRows(unloadedRange);

        if (promise) {
          promise.then(function () {
            // Refresh the visible rows if any of them have just been loaded.
            // Otherwise they will remain in their unloaded visual state.
            if (isRangeVisible({
              lastRenderedStartIndex: _this2._lastRenderedStartIndex,
              lastRenderedStopIndex: _this2._lastRenderedStopIndex,
              startIndex: unloadedRange.startIndex,
              stopIndex: unloadedRange.stopIndex
            })) {
              if (_this2._registeredChild) {
                forceUpdateReactVirtualizedComponent(_this2._registeredChild, _this2._lastRenderedStartIndex);
              }
            }
          });
        }
      });
    }
  }, {
    key: "_onRowsRendered",
    value: function _onRowsRendered(_ref) {
      var startIndex = _ref.startIndex,
          stopIndex = _ref.stopIndex;
      this._lastRenderedStartIndex = startIndex;
      this._lastRenderedStopIndex = stopIndex;

      this._doStuff(startIndex, stopIndex);
    }
  }, {
    key: "_doStuff",
    value: function _doStuff(startIndex, stopIndex) {
      var _ref2,
          _this3 = this;

      var _this$props = this.props,
          isRowLoaded = _this$props.isRowLoaded,
          minimumBatchSize = _this$props.minimumBatchSize,
          rowCount = _this$props.rowCount,
          threshold = _this$props.threshold;
      var unloadedRanges = scanForUnloadedRanges({
        isRowLoaded: isRowLoaded,
        minimumBatchSize: minimumBatchSize,
        rowCount: rowCount,
        startIndex: Math.max(0, startIndex - threshold),
        stopIndex: Math.min(rowCount - 1, stopIndex + threshold)
      }); // For memoize comparison

      var squashedUnloadedRanges = (_ref2 = []).concat.apply(_ref2, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(unloadedRanges.map(function (_ref3) {
        var startIndex = _ref3.startIndex,
            stopIndex = _ref3.stopIndex;
        return [startIndex, stopIndex];
      })));

      this._loadMoreRowsMemoizer({
        callback: function callback() {
          _this3._loadUnloadedRanges(unloadedRanges);
        },
        indices: {
          squashedUnloadedRanges: squashedUnloadedRanges
        }
      });
    }
  }, {
    key: "_registerChild",
    value: function _registerChild(registeredChild) {
      this._registeredChild = registeredChild;
    }
  }]);

  return InfiniteLoader;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);
/**
 * Determines if the specified start/stop range is visible based on the most recently rendered range.
 */


__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(InfiniteLoader, "defaultProps", {
  minimumBatchSize: 10,
  rowCount: 0,
  threshold: 15
});


InfiniteLoader.propTypes =  false ? {
  /**
   * Function responsible for rendering a virtualized component.
   * This function should implement the following signature:
   * ({ onRowsRendered, registerChild }) => PropTypes.element
   *
   * The specified :onRowsRendered function should be passed through to the child's :onRowsRendered property.
   * The :registerChild callback should be set as the virtualized component's :ref.
   */
  children: PropTypes.func.isRequired,

  /**
   * Function responsible for tracking the loaded state of each row.
   * It should implement the following signature: ({ index: number }): boolean
   */
  isRowLoaded: PropTypes.func.isRequired,

  /**
   * Callback to be invoked when more rows must be loaded.
   * It should implement the following signature: ({ startIndex, stopIndex }): Promise
   * The returned Promise should be resolved once row data has finished loading.
   * It will be used to determine when to refresh the list with the newly-loaded data.
   * This callback may be called multiple times in reaction to a single scroll event.
   */
  loadMoreRows: PropTypes.func.isRequired,

  /**
   * Minimum number of rows to be loaded at a time.
   * This property can be used to batch requests to reduce HTTP requests.
   */
  minimumBatchSize: PropTypes.number.isRequired,

  /**
   * Number of rows in list; can be arbitrary high number if actual number is unknown.
   */
  rowCount: PropTypes.number.isRequired,

  /**
   * Threshold at which to pre-fetch data.
   * A threshold X means that data will start loading when a user scrolls within X rows.
   * This value defaults to 15.
   */
  threshold: PropTypes.number.isRequired
} : {};
function isRangeVisible(_ref4) {
  var lastRenderedStartIndex = _ref4.lastRenderedStartIndex,
      lastRenderedStopIndex = _ref4.lastRenderedStopIndex,
      startIndex = _ref4.startIndex,
      stopIndex = _ref4.stopIndex;
  return !(startIndex > lastRenderedStopIndex || stopIndex < lastRenderedStartIndex);
}
/**
 * Returns all of the ranges within a larger range that contain unloaded rows.
 */

function scanForUnloadedRanges(_ref5) {
  var isRowLoaded = _ref5.isRowLoaded,
      minimumBatchSize = _ref5.minimumBatchSize,
      rowCount = _ref5.rowCount,
      startIndex = _ref5.startIndex,
      stopIndex = _ref5.stopIndex;
  var unloadedRanges = [];
  var rangeStartIndex = null;
  var rangeStopIndex = null;

  for (var index = startIndex; index <= stopIndex; index++) {
    var loaded = isRowLoaded({
      index: index
    });

    if (!loaded) {
      rangeStopIndex = index;

      if (rangeStartIndex === null) {
        rangeStartIndex = index;
      }
    } else if (rangeStopIndex !== null) {
      unloadedRanges.push({
        startIndex: rangeStartIndex,
        stopIndex: rangeStopIndex
      });
      rangeStartIndex = rangeStopIndex = null;
    }
  } // If :rangeStopIndex is not null it means we haven't ran out of unloaded rows.
  // Scan forward to try filling our :minimumBatchSize.


  if (rangeStopIndex !== null) {
    var potentialStopIndex = Math.min(Math.max(rangeStopIndex, rangeStartIndex + minimumBatchSize - 1), rowCount - 1);

    for (var _index = rangeStopIndex + 1; _index <= potentialStopIndex; _index++) {
      if (!isRowLoaded({
        index: _index
      })) {
        rangeStopIndex = _index;
      } else {
        break;
      }
    }

    unloadedRanges.push({
      startIndex: rangeStartIndex,
      stopIndex: rangeStopIndex
    });
  } // Check to see if our first range ended prematurely.
  // In this case we should scan backwards to try filling our :minimumBatchSize.


  if (unloadedRanges.length) {
    var firstUnloadedRange = unloadedRanges[0];

    while (firstUnloadedRange.stopIndex - firstUnloadedRange.startIndex + 1 < minimumBatchSize && firstUnloadedRange.startIndex > 0) {
      var _index2 = firstUnloadedRange.startIndex - 1;

      if (!isRowLoaded({
        index: _index2
      })) {
        firstUnloadedRange.startIndex = _index2;
      } else {
        break;
      }
    }
  }

  return unloadedRanges;
}
/**
 * Since RV components use shallowCompare we need to force a render (even though props haven't changed).
 * However InfiniteLoader may wrap a Grid or it may wrap a Table or List.
 * In the first case the built-in React forceUpdate() method is sufficient to force a re-render,
 * But in the latter cases we need to use the RV-specific forceUpdateGrid() method.
 * Else the inner Grid will not be re-rendered and visuals may be stale.
 *
 * Additionally, while a Grid is scrolling the cells can be cached,
 * So it's important to invalidate that cache by recalculating sizes
 * before forcing a rerender.
 */

function forceUpdateReactVirtualizedComponent(component) {
  var currentIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var recomputeSize = typeof component.recomputeGridSize === 'function' ? component.recomputeGridSize : component.recomputeRowHeights;

  if (recomputeSize) {
    recomputeSize.call(component, currentIndex);
  } else {
    component.forceUpdate();
  }
}

/***/ }),
/* 2211 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(2212);

var iterableToArray = __webpack_require__(2213);

var unsupportedIterableToArray = __webpack_require__(877);

var nonIterableSpread = __webpack_require__(2214);

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 2212 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(876);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 2213 */
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

module.exports = _iterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 2214 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 2215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List__ = __webpack_require__(878);
/* unused harmony reexport default */
/* unused harmony reexport List */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(286);
/* unused harmony reexport bpfrpt_proptype_RowRendererParams */





/***/ }),
/* 2216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createCellPositioner__ = __webpack_require__(2217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Masonry__ = __webpack_require__(482);
/* unused harmony reexport createCellPositioner */
/* unused harmony reexport Masonry */


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_1__Masonry__["a" /* default */]);


/***/ }),
/* 2217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Masonry__ = __webpack_require__(482);
function createCellPositioner(_ref) {
  var cellMeasurerCache = _ref.cellMeasurerCache,
      columnCount = _ref.columnCount,
      columnWidth = _ref.columnWidth,
      _ref$spacer = _ref.spacer,
      spacer = _ref$spacer === void 0 ? 0 : _ref$spacer;
  var columnHeights;
  initOrResetDerivedValues();

  function cellPositioner(index) {
    // Find the shortest column and use it.
    var columnIndex = 0;

    for (var i = 1; i < columnHeights.length; i++) {
      if (columnHeights[i] < columnHeights[columnIndex]) {
        columnIndex = i;
      }
    }

    var left = columnIndex * (columnWidth + spacer);
    var top = columnHeights[columnIndex] || 0;
    columnHeights[columnIndex] = top + cellMeasurerCache.getHeight(index) + spacer;
    return {
      left: left,
      top: top
    };
  }

  function initOrResetDerivedValues() {
    // Track the height of each column.
    // Layout algorithm below always inserts into the shortest column.
    columnHeights = [];

    for (var i = 0; i < columnCount; i++) {
      columnHeights[i] = 0;
    }
  }

  function reset(params) {
    columnCount = params.columnCount;
    columnWidth = params.columnWidth;
    spacer = params.spacer;
    initOrResetDerivedValues();
  }

  cellPositioner.reset = reset;
  return cellPositioner;
}



/***/ }),
/* 2218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PositionCache; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(2219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vendor_intervalTree__ = __webpack_require__(2223);






// Position cache requirements:
//   O(log(n)) lookup of cells to render for a given viewport size
//   O(1) lookup of shortest measured column (so we know when to enter phase 1)
var PositionCache =
/*#__PURE__*/
function () {
  function PositionCache() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, PositionCache);

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(this, "_columnSizeMap", {});

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(this, "_intervalTree", Object(__WEBPACK_IMPORTED_MODULE_4__vendor_intervalTree__["a" /* default */])());

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(this, "_leftMap", {});
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(PositionCache, [{
    key: "estimateTotalHeight",
    value: function estimateTotalHeight(cellCount, columnCount, defaultCellHeight) {
      var unmeasuredCellCount = cellCount - this.count;
      return this.tallestColumnSize + Math.ceil(unmeasuredCellCount / columnCount) * defaultCellHeight;
    } // Render all cells visible within the viewport range defined.

  }, {
    key: "range",
    value: function range(scrollTop, clientHeight, renderCallback) {
      var _this = this;

      this._intervalTree.queryInterval(scrollTop, scrollTop + clientHeight, function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_ref, 3),
            top = _ref2[0],
            _ = _ref2[1],
            index = _ref2[2];

        return renderCallback(index, _this._leftMap[index], top);
      });
    }
  }, {
    key: "setPosition",
    value: function setPosition(index, left, top, height) {
      this._intervalTree.insert([top, top + height, index]);

      this._leftMap[index] = left;
      var columnSizeMap = this._columnSizeMap;
      var columnHeight = columnSizeMap[left];

      if (columnHeight === undefined) {
        columnSizeMap[left] = top + height;
      } else {
        columnSizeMap[left] = Math.max(columnHeight, top + height);
      }
    }
  }, {
    key: "count",
    get: function get() {
      return this._intervalTree.count;
    }
  }, {
    key: "shortestColumnSize",
    get: function get() {
      var columnSizeMap = this._columnSizeMap;
      var size = 0;

      for (var i in columnSizeMap) {
        var height = columnSizeMap[i];
        size = size === 0 ? height : Math.min(size, height);
      }

      return size;
    }
  }, {
    key: "tallestColumnSize",
    get: function get() {
      var columnSizeMap = this._columnSizeMap;
      var size = 0;

      for (var i in columnSizeMap) {
        var height = columnSizeMap[i];
        size = Math.max(size, height);
      }

      return size;
    }
  }]);

  return PositionCache;
}();



/***/ }),
/* 2219 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(2220);

var iterableToArrayLimit = __webpack_require__(2221);

var unsupportedIterableToArray = __webpack_require__(877);

var nonIterableRest = __webpack_require__(2222);

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 2220 */
/***/ (function(module, exports) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 2221 */
/***/ (function(module, exports) {

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 2222 */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableRest;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 2223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createWrapper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__binarySearchBounds__ = __webpack_require__(2224);
/**
 * Binary Search Bounds
 * https://github.com/mikolalysenko/interval-tree-1d
 * Mikola Lysenko
 *
 * Inlined because of Content Security Policy issue caused by the use of `new Function(...)` syntax in an upstream dependency.
 * Issue reported here: https://github.com/mikolalysenko/binary-search-bounds/issues/5
 **/

var NOT_FOUND = 0;
var SUCCESS = 1;
var EMPTY = 2;

function IntervalTreeNode(mid, left, right, leftPoints, rightPoints) {
  this.mid = mid;
  this.left = left;
  this.right = right;
  this.leftPoints = leftPoints;
  this.rightPoints = rightPoints;
  this.count = (left ? left.count : 0) + (right ? right.count : 0) + leftPoints.length;
}

var proto = IntervalTreeNode.prototype;

function copy(a, b) {
  a.mid = b.mid;
  a.left = b.left;
  a.right = b.right;
  a.leftPoints = b.leftPoints;
  a.rightPoints = b.rightPoints;
  a.count = b.count;
}

function rebuild(node, intervals) {
  var ntree = createIntervalTree(intervals);
  node.mid = ntree.mid;
  node.left = ntree.left;
  node.right = ntree.right;
  node.leftPoints = ntree.leftPoints;
  node.rightPoints = ntree.rightPoints;
  node.count = ntree.count;
}

function rebuildWithInterval(node, interval) {
  var intervals = node.intervals([]);
  intervals.push(interval);
  rebuild(node, intervals);
}

function rebuildWithoutInterval(node, interval) {
  var intervals = node.intervals([]);
  var idx = intervals.indexOf(interval);

  if (idx < 0) {
    return NOT_FOUND;
  }

  intervals.splice(idx, 1);
  rebuild(node, intervals);
  return SUCCESS;
}

proto.intervals = function (result) {
  result.push.apply(result, this.leftPoints);

  if (this.left) {
    this.left.intervals(result);
  }

  if (this.right) {
    this.right.intervals(result);
  }

  return result;
};

proto.insert = function (interval) {
  var weight = this.count - this.leftPoints.length;
  this.count += 1;

  if (interval[1] < this.mid) {
    if (this.left) {
      if (4 * (this.left.count + 1) > 3 * (weight + 1)) {
        rebuildWithInterval(this, interval);
      } else {
        this.left.insert(interval);
      }
    } else {
      this.left = createIntervalTree([interval]);
    }
  } else if (interval[0] > this.mid) {
    if (this.right) {
      if (4 * (this.right.count + 1) > 3 * (weight + 1)) {
        rebuildWithInterval(this, interval);
      } else {
        this.right.insert(interval);
      }
    } else {
      this.right = createIntervalTree([interval]);
    }
  } else {
    var l = __WEBPACK_IMPORTED_MODULE_0__binarySearchBounds__["a" /* default */].ge(this.leftPoints, interval, compareBegin);
    var r = __WEBPACK_IMPORTED_MODULE_0__binarySearchBounds__["a" /* default */].ge(this.rightPoints, interval, compareEnd);
    this.leftPoints.splice(l, 0, interval);
    this.rightPoints.splice(r, 0, interval);
  }
};

proto.remove = function (interval) {
  var weight = this.count - this.leftPoints;

  if (interval[1] < this.mid) {
    if (!this.left) {
      return NOT_FOUND;
    }

    var rw = this.right ? this.right.count : 0;

    if (4 * rw > 3 * (weight - 1)) {
      return rebuildWithoutInterval(this, interval);
    }

    var r = this.left.remove(interval);

    if (r === EMPTY) {
      this.left = null;
      this.count -= 1;
      return SUCCESS;
    } else if (r === SUCCESS) {
      this.count -= 1;
    }

    return r;
  } else if (interval[0] > this.mid) {
    if (!this.right) {
      return NOT_FOUND;
    }

    var lw = this.left ? this.left.count : 0;

    if (4 * lw > 3 * (weight - 1)) {
      return rebuildWithoutInterval(this, interval);
    }

    var r = this.right.remove(interval);

    if (r === EMPTY) {
      this.right = null;
      this.count -= 1;
      return SUCCESS;
    } else if (r === SUCCESS) {
      this.count -= 1;
    }

    return r;
  } else {
    if (this.count === 1) {
      if (this.leftPoints[0] === interval) {
        return EMPTY;
      } else {
        return NOT_FOUND;
      }
    }

    if (this.leftPoints.length === 1 && this.leftPoints[0] === interval) {
      if (this.left && this.right) {
        var p = this;
        var n = this.left;

        while (n.right) {
          p = n;
          n = n.right;
        }

        if (p === this) {
          n.right = this.right;
        } else {
          var l = this.left;
          var r = this.right;
          p.count -= n.count;
          p.right = n.left;
          n.left = l;
          n.right = r;
        }

        copy(this, n);
        this.count = (this.left ? this.left.count : 0) + (this.right ? this.right.count : 0) + this.leftPoints.length;
      } else if (this.left) {
        copy(this, this.left);
      } else {
        copy(this, this.right);
      }

      return SUCCESS;
    }

    for (var l = __WEBPACK_IMPORTED_MODULE_0__binarySearchBounds__["a" /* default */].ge(this.leftPoints, interval, compareBegin); l < this.leftPoints.length; ++l) {
      if (this.leftPoints[l][0] !== interval[0]) {
        break;
      }

      if (this.leftPoints[l] === interval) {
        this.count -= 1;
        this.leftPoints.splice(l, 1);

        for (var r = __WEBPACK_IMPORTED_MODULE_0__binarySearchBounds__["a" /* default */].ge(this.rightPoints, interval, compareEnd); r < this.rightPoints.length; ++r) {
          if (this.rightPoints[r][1] !== interval[1]) {
            break;
          } else if (this.rightPoints[r] === interval) {
            this.rightPoints.splice(r, 1);
            return SUCCESS;
          }
        }
      }
    }

    return NOT_FOUND;
  }
};

function reportLeftRange(arr, hi, cb) {
  for (var i = 0; i < arr.length && arr[i][0] <= hi; ++i) {
    var r = cb(arr[i]);

    if (r) {
      return r;
    }
  }
}

function reportRightRange(arr, lo, cb) {
  for (var i = arr.length - 1; i >= 0 && arr[i][1] >= lo; --i) {
    var r = cb(arr[i]);

    if (r) {
      return r;
    }
  }
}

function reportRange(arr, cb) {
  for (var i = 0; i < arr.length; ++i) {
    var r = cb(arr[i]);

    if (r) {
      return r;
    }
  }
}

proto.queryPoint = function (x, cb) {
  if (x < this.mid) {
    if (this.left) {
      var r = this.left.queryPoint(x, cb);

      if (r) {
        return r;
      }
    }

    return reportLeftRange(this.leftPoints, x, cb);
  } else if (x > this.mid) {
    if (this.right) {
      var r = this.right.queryPoint(x, cb);

      if (r) {
        return r;
      }
    }

    return reportRightRange(this.rightPoints, x, cb);
  } else {
    return reportRange(this.leftPoints, cb);
  }
};

proto.queryInterval = function (lo, hi, cb) {
  if (lo < this.mid && this.left) {
    var r = this.left.queryInterval(lo, hi, cb);

    if (r) {
      return r;
    }
  }

  if (hi > this.mid && this.right) {
    var r = this.right.queryInterval(lo, hi, cb);

    if (r) {
      return r;
    }
  }

  if (hi < this.mid) {
    return reportLeftRange(this.leftPoints, hi, cb);
  } else if (lo > this.mid) {
    return reportRightRange(this.rightPoints, lo, cb);
  } else {
    return reportRange(this.leftPoints, cb);
  }
};

function compareNumbers(a, b) {
  return a - b;
}

function compareBegin(a, b) {
  var d = a[0] - b[0];

  if (d) {
    return d;
  }

  return a[1] - b[1];
}

function compareEnd(a, b) {
  var d = a[1] - b[1];

  if (d) {
    return d;
  }

  return a[0] - b[0];
}

function createIntervalTree(intervals) {
  if (intervals.length === 0) {
    return null;
  }

  var pts = [];

  for (var i = 0; i < intervals.length; ++i) {
    pts.push(intervals[i][0], intervals[i][1]);
  }

  pts.sort(compareNumbers);
  var mid = pts[pts.length >> 1];
  var leftIntervals = [];
  var rightIntervals = [];
  var centerIntervals = [];

  for (var i = 0; i < intervals.length; ++i) {
    var s = intervals[i];

    if (s[1] < mid) {
      leftIntervals.push(s);
    } else if (mid < s[0]) {
      rightIntervals.push(s);
    } else {
      centerIntervals.push(s);
    }
  } //Split center intervals


  var leftPoints = centerIntervals;
  var rightPoints = centerIntervals.slice();
  leftPoints.sort(compareBegin);
  rightPoints.sort(compareEnd);
  return new IntervalTreeNode(mid, createIntervalTree(leftIntervals), createIntervalTree(rightIntervals), leftPoints, rightPoints);
} //User friendly wrapper that makes it possible to support empty trees


function IntervalTree(root) {
  this.root = root;
}

var tproto = IntervalTree.prototype;

tproto.insert = function (interval) {
  if (this.root) {
    this.root.insert(interval);
  } else {
    this.root = new IntervalTreeNode(interval[0], null, null, [interval], [interval]);
  }
};

tproto.remove = function (interval) {
  if (this.root) {
    var r = this.root.remove(interval);

    if (r === EMPTY) {
      this.root = null;
    }

    return r !== NOT_FOUND;
  }

  return false;
};

tproto.queryPoint = function (p, cb) {
  if (this.root) {
    return this.root.queryPoint(p, cb);
  }
};

tproto.queryInterval = function (lo, hi, cb) {
  if (lo <= hi && this.root) {
    return this.root.queryInterval(lo, hi, cb);
  }
};

Object.defineProperty(tproto, 'count', {
  get: function get() {
    if (this.root) {
      return this.root.count;
    }

    return 0;
  }
});
Object.defineProperty(tproto, 'intervals', {
  get: function get() {
    if (this.root) {
      return this.root.intervals([]);
    }

    return [];
  }
});
function createWrapper(intervals) {
  if (!intervals || intervals.length === 0) {
    return new IntervalTree(null);
  }

  return new IntervalTree(createIntervalTree(intervals));
}

/***/ }),
/* 2224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Binary Search Bounds
 * https://github.com/mikolalysenko/binary-search-bounds
 * Mikola Lysenko
 *
 * Inlined because of Content Security Policy issue caused by the use of `new Function(...)` syntax.
 * Issue reported here: https://github.com/mikolalysenko/binary-search-bounds/issues/5
 **/
function _GEA(a, l, h, y) {
  var i = h + 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (x >= y) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }

  return i;
}

function _GEP(a, l, h, y, c) {
  var i = h + 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (c(x, y) >= 0) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }

  return i;
}

function dispatchBsearchGE(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _GEP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _GEA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _GTA(a, l, h, y) {
  var i = h + 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (x > y) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }

  return i;
}

function _GTP(a, l, h, y, c) {
  var i = h + 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (c(x, y) > 0) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }

  return i;
}

function dispatchBsearchGT(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _GTP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _GTA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _LTA(a, l, h, y) {
  var i = l - 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (x < y) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }

  return i;
}

function _LTP(a, l, h, y, c) {
  var i = l - 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (c(x, y) < 0) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }

  return i;
}

function dispatchBsearchLT(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _LTP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _LTA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _LEA(a, l, h, y) {
  var i = l - 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (x <= y) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }

  return i;
}

function _LEP(a, l, h, y, c) {
  var i = l - 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (c(x, y) <= 0) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }

  return i;
}

function dispatchBsearchLE(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _LEP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _LEA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _EQA(a, l, h, y) {
  l - 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];

    if (x === y) {
      return m;
    } else if (x <= y) {
      l = m + 1;
    } else {
      h = m - 1;
    }
  }

  return -1;
}

function _EQP(a, l, h, y, c) {
  l - 1;

  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    var p = c(x, y);

    if (p === 0) {
      return m;
    } else if (p <= 0) {
      l = m + 1;
    } else {
      h = m - 1;
    }
  }

  return -1;
}

function dispatchBsearchEQ(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _EQP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _EQA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  ge: dispatchBsearchGE,
  gt: dispatchBsearchGT,
  lt: dispatchBsearchLT,
  le: dispatchBsearchLE,
  eq: dispatchBsearchEQ
});

/***/ }),
/* 2225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MultiGrid__ = __webpack_require__(2226);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__MultiGrid__["a"]; });

/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__MultiGrid__["a" /* default */]);


/***/ }),
/* 2226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_lifecycles_compat__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CellMeasurerCacheDecorator__ = __webpack_require__(2227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Grid__ = __webpack_require__(55);










function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var SCROLLBAR_SIZE_BUFFER = 20;
/**
 * Renders 1, 2, or 4 Grids depending on configuration.
 * A main (body) Grid will always be rendered.
 * Optionally, 1-2 Grids for sticky header rows will also be rendered.
 * If no sticky columns, only 1 sticky header Grid will be rendered.
 * If sticky columns, 2 sticky header Grids will be rendered.
 */

var MultiGrid =
/*#__PURE__*/
function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(MultiGrid, _React$PureComponent);

  function MultiGrid(props, context) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, MultiGrid);

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(MultiGrid).call(this, props, context));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      scrollLeft: 0,
      scrollTop: 0,
      scrollbarSize: 0,
      showHorizontalScrollbar: false,
      showVerticalScrollbar: false
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "_deferredInvalidateColumnIndex", null);

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "_deferredInvalidateRowIndex", null);

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "_bottomLeftGridRef", function (ref) {
      _this._bottomLeftGrid = ref;
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "_bottomRightGridRef", function (ref) {
      _this._bottomRightGrid = ref;
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "_cellRendererBottomLeftGrid", function (_ref) {
      var rowIndex = _ref.rowIndex,
          rest = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_ref, ["rowIndex"]);

      var _this$props = _this.props,
          cellRenderer = _this$props.cellRenderer,
          fixedRowCount = _this$props.fixedRowCount,
          rowCount = _this$props.rowCount;

      if (rowIndex === rowCount - fixedRowCount) {
        return __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("div", {
          key: rest.key,
          style: _objectSpread({}, rest.style, {
            height: SCROLLBAR_SIZE_BUFFER
          })
        });
      } else {
        return cellRenderer(_objectSpread({}, rest, {
          parent: __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this),
          rowIndex: rowIndex + fixedRowCount
        }));
      }
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "_cellRendererBottomRightGrid", function (_ref2) {
      var columnIndex = _ref2.columnIndex,
          rowIndex = _ref2.rowIndex,
          rest = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_ref2, ["columnIndex", "rowIndex"]);

      var _this$props2 = _this.props,
          cellRenderer = _this$props2.cellRenderer,
          fixedColumnCount = _this$props2.fixedColumnCount,
          fixedRowCount = _this$props2.fixedRowCount;
      return cellRenderer(_objectSpread({}, rest, {
        columnIndex: columnIndex + fixedColumnCount,
        parent: __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this),
        rowIndex: rowIndex + fixedRowCount
      }));
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "_cellRendererTopRightGrid", function (_ref3) {
      var columnIndex = _ref3.columnIndex,
          rest = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_ref3, ["columnIndex"]);

      var _this$props3 = _this.props,
          cellRenderer = _this$props3.cellRenderer,
          columnCount = _this$props3.columnCount,
          fixedColumnCount = _this$props3.fixedColumnCount;

      if (columnIndex === columnCount - fixedColumnCount) {
        return __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("div", {
          key: rest.key,
          style: _objectSpread({}, rest.style, {
            width: SCROLLBAR_SIZE_BUFFER
          })
        });
      } else {
        return cellRenderer(_objectSpread({}, rest, {
          columnIndex: columnIndex + fixedColumnCount,
          parent: __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this)
        }));
      }
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "_columnWidthRightGrid", function (_ref4) {
      var index = _ref4.index;
      var _this$props4 = _this.props,
          columnCount = _this$props4.columnCount,
          fixedColumnCount = _this$props4.fixedColumnCount,
          columnWidth = _this$props4.columnWidth;
      var _this$state = _this.state,
          scrollbarSize = _this$state.scrollbarSize,
          showHorizontalScrollbar = _this$state.showHorizontalScrollbar; // An extra cell is added to the count
      // This gives the smaller Grid extra room for offset,
      // In case the main (bottom right) Grid has a scrollbar
      // If no scrollbar, the extra space is overflow:hidden anyway

      if (showHorizontalScrollbar && index === columnCount - fixedColumnCount) {
        return scrollbarSize;
      }

      return typeof columnWidth === 'function' ? columnWidth({
        index: index + fixedColumnCount
      }) : columnWidth;
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "_onScroll", function (scrollInfo) {
      var scrollLeft = scrollInfo.scrollLeft,
          scrollTop = scrollInfo.scrollTop;

      _this.setState({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      });

      var onScroll = _this.props.onScroll;

      if (onScroll) {
        onScroll(scrollInfo);
      }
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "_onScrollbarPresenceChange", function (_ref5) {
      var horizontal = _ref5.horizontal,
          size = _ref5.size,
          vertical = _ref5.vertical;
      var _this$state2 = _this.state,
          showHorizontalScrollbar = _this$state2.showHorizontalScrollbar,
          showVerticalScrollbar = _this$state2.showVerticalScrollbar;

      if (horizontal !== showHorizontalScrollbar || vertical !== showVerticalScrollbar) {
        _this.setState({
          scrollbarSize: size,
          showHorizontalScrollbar: horizontal,
          showVerticalScrollbar: vertical
        });

        var onScrollbarPresenceChange = _this.props.onScrollbarPresenceChange;

        if (typeof onScrollbarPresenceChange === 'function') {
          onScrollbarPresenceChange({
            horizontal: horizontal,
            size: size,
            vertical: vertical
          });
        }
      }
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "_onScrollLeft", function (scrollInfo) {
      var scrollLeft = scrollInfo.scrollLeft;

      _this._onScroll({
        scrollLeft: scrollLeft,
        scrollTop: _this.state.scrollTop
      });
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "_onScrollTop", function (scrollInfo) {
      var scrollTop = scrollInfo.scrollTop;

      _this._onScroll({
        scrollTop: scrollTop,
        scrollLeft: _this.state.scrollLeft
      });
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "_rowHeightBottomGrid", function (_ref6) {
      var index = _ref6.index;
      var _this$props5 = _this.props,
          fixedRowCount = _this$props5.fixedRowCount,
          rowCount = _this$props5.rowCount,
          rowHeight = _this$props5.rowHeight;
      var _this$state3 = _this.state,
          scrollbarSize = _this$state3.scrollbarSize,
          showVerticalScrollbar = _this$state3.showVerticalScrollbar; // An extra cell is added to the count
      // This gives the smaller Grid extra room for offset,
      // In case the main (bottom right) Grid has a scrollbar
      // If no scrollbar, the extra space is overflow:hidden anyway

      if (showVerticalScrollbar && index === rowCount - fixedRowCount) {
        return scrollbarSize;
      }

      return typeof rowHeight === 'function' ? rowHeight({
        index: index + fixedRowCount
      }) : rowHeight;
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "_topLeftGridRef", function (ref) {
      _this._topLeftGrid = ref;
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "_topRightGridRef", function (ref) {
      _this._topRightGrid = ref;
    });

    var deferredMeasurementCache = props.deferredMeasurementCache,
        _fixedColumnCount = props.fixedColumnCount,
        _fixedRowCount = props.fixedRowCount;

    _this._maybeCalculateCachedStyles(true);

    if (deferredMeasurementCache) {
      _this._deferredMeasurementCacheBottomLeftGrid = _fixedRowCount > 0 ? new __WEBPACK_IMPORTED_MODULE_12__CellMeasurerCacheDecorator__["a" /* default */]({
        cellMeasurerCache: deferredMeasurementCache,
        columnIndexOffset: 0,
        rowIndexOffset: _fixedRowCount
      }) : deferredMeasurementCache;
      _this._deferredMeasurementCacheBottomRightGrid = _fixedColumnCount > 0 || _fixedRowCount > 0 ? new __WEBPACK_IMPORTED_MODULE_12__CellMeasurerCacheDecorator__["a" /* default */]({
        cellMeasurerCache: deferredMeasurementCache,
        columnIndexOffset: _fixedColumnCount,
        rowIndexOffset: _fixedRowCount
      }) : deferredMeasurementCache;
      _this._deferredMeasurementCacheTopRightGrid = _fixedColumnCount > 0 ? new __WEBPACK_IMPORTED_MODULE_12__CellMeasurerCacheDecorator__["a" /* default */]({
        cellMeasurerCache: deferredMeasurementCache,
        columnIndexOffset: _fixedColumnCount,
        rowIndexOffset: 0
      }) : deferredMeasurementCache;
    }

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(MultiGrid, [{
    key: "forceUpdateGrids",
    value: function forceUpdateGrids() {
      this._bottomLeftGrid && this._bottomLeftGrid.forceUpdate();
      this._bottomRightGrid && this._bottomRightGrid.forceUpdate();
      this._topLeftGrid && this._topLeftGrid.forceUpdate();
      this._topRightGrid && this._topRightGrid.forceUpdate();
    }
    /** See Grid#invalidateCellSizeAfterRender */

  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender() {
      var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref7$columnIndex = _ref7.columnIndex,
          columnIndex = _ref7$columnIndex === void 0 ? 0 : _ref7$columnIndex,
          _ref7$rowIndex = _ref7.rowIndex,
          rowIndex = _ref7$rowIndex === void 0 ? 0 : _ref7$rowIndex;

      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
    }
    /** See Grid#measureAllCells */

  }, {
    key: "measureAllCells",
    value: function measureAllCells() {
      this._bottomLeftGrid && this._bottomLeftGrid.measureAllCells();
      this._bottomRightGrid && this._bottomRightGrid.measureAllCells();
      this._topLeftGrid && this._topLeftGrid.measureAllCells();
      this._topRightGrid && this._topRightGrid.measureAllCells();
    }
    /** See Grid#recomputeGridSize */

  }, {
    key: "recomputeGridSize",
    value: function recomputeGridSize() {
      var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref8$columnIndex = _ref8.columnIndex,
          columnIndex = _ref8$columnIndex === void 0 ? 0 : _ref8$columnIndex,
          _ref8$rowIndex = _ref8.rowIndex,
          rowIndex = _ref8$rowIndex === void 0 ? 0 : _ref8$rowIndex;

      var _this$props6 = this.props,
          fixedColumnCount = _this$props6.fixedColumnCount,
          fixedRowCount = _this$props6.fixedRowCount;
      var adjustedColumnIndex = Math.max(0, columnIndex - fixedColumnCount);
      var adjustedRowIndex = Math.max(0, rowIndex - fixedRowCount);
      this._bottomLeftGrid && this._bottomLeftGrid.recomputeGridSize({
        columnIndex: columnIndex,
        rowIndex: adjustedRowIndex
      });
      this._bottomRightGrid && this._bottomRightGrid.recomputeGridSize({
        columnIndex: adjustedColumnIndex,
        rowIndex: adjustedRowIndex
      });
      this._topLeftGrid && this._topLeftGrid.recomputeGridSize({
        columnIndex: columnIndex,
        rowIndex: rowIndex
      });
      this._topRightGrid && this._topRightGrid.recomputeGridSize({
        columnIndex: adjustedColumnIndex,
        rowIndex: rowIndex
      });
      this._leftGridWidth = null;
      this._topGridHeight = null;

      this._maybeCalculateCachedStyles(true);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props7 = this.props,
          scrollLeft = _this$props7.scrollLeft,
          scrollTop = _this$props7.scrollTop;

      if (scrollLeft > 0 || scrollTop > 0) {
        var newState = {};

        if (scrollLeft > 0) {
          newState.scrollLeft = scrollLeft;
        }

        if (scrollTop > 0) {
          newState.scrollTop = scrollTop;
        }

        this.setState(newState);
      }

      this._handleInvalidatedGridSize();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this._handleInvalidatedGridSize();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props8 = this.props,
          onScroll = _this$props8.onScroll,
          onSectionRendered = _this$props8.onSectionRendered,
          onScrollbarPresenceChange = _this$props8.onScrollbarPresenceChange,
          scrollLeftProp = _this$props8.scrollLeft,
          scrollToColumn = _this$props8.scrollToColumn,
          scrollTopProp = _this$props8.scrollTop,
          scrollToRow = _this$props8.scrollToRow,
          rest = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_this$props8, ["onScroll", "onSectionRendered", "onScrollbarPresenceChange", "scrollLeft", "scrollToColumn", "scrollTop", "scrollToRow"]);

      this._prepareForRender(); // Don't render any of our Grids if there are no cells.
      // This mirrors what Grid does,
      // And prevents us from recording inaccurage measurements when used with CellMeasurer.


      if (this.props.width === 0 || this.props.height === 0) {
        return null;
      } // scrollTop and scrollLeft props are explicitly filtered out and ignored


      var _this$state4 = this.state,
          scrollLeft = _this$state4.scrollLeft,
          scrollTop = _this$state4.scrollTop;
      return __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("div", {
        style: this._containerOuterStyle
      }, __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("div", {
        style: this._containerTopStyle
      }, this._renderTopLeftGrid(rest), this._renderTopRightGrid(_objectSpread({}, rest, {
        onScroll: onScroll,
        scrollLeft: scrollLeft
      }))), __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("div", {
        style: this._containerBottomStyle
      }, this._renderBottomLeftGrid(_objectSpread({}, rest, {
        onScroll: onScroll,
        scrollTop: scrollTop
      })), this._renderBottomRightGrid(_objectSpread({}, rest, {
        onScroll: onScroll,
        onSectionRendered: onSectionRendered,
        scrollLeft: scrollLeft,
        scrollToColumn: scrollToColumn,
        scrollToRow: scrollToRow,
        scrollTop: scrollTop
      }))));
    }
  }, {
    key: "_getBottomGridHeight",
    value: function _getBottomGridHeight(props) {
      var height = props.height;

      var topGridHeight = this._getTopGridHeight(props);

      return height - topGridHeight;
    }
  }, {
    key: "_getLeftGridWidth",
    value: function _getLeftGridWidth(props) {
      var fixedColumnCount = props.fixedColumnCount,
          columnWidth = props.columnWidth;

      if (this._leftGridWidth == null) {
        if (typeof columnWidth === 'function') {
          var leftGridWidth = 0;

          for (var index = 0; index < fixedColumnCount; index++) {
            leftGridWidth += columnWidth({
              index: index
            });
          }

          this._leftGridWidth = leftGridWidth;
        } else {
          this._leftGridWidth = columnWidth * fixedColumnCount;
        }
      }

      return this._leftGridWidth;
    }
  }, {
    key: "_getRightGridWidth",
    value: function _getRightGridWidth(props) {
      var width = props.width;

      var leftGridWidth = this._getLeftGridWidth(props);

      return width - leftGridWidth;
    }
  }, {
    key: "_getTopGridHeight",
    value: function _getTopGridHeight(props) {
      var fixedRowCount = props.fixedRowCount,
          rowHeight = props.rowHeight;

      if (this._topGridHeight == null) {
        if (typeof rowHeight === 'function') {
          var topGridHeight = 0;

          for (var index = 0; index < fixedRowCount; index++) {
            topGridHeight += rowHeight({
              index: index
            });
          }

          this._topGridHeight = topGridHeight;
        } else {
          this._topGridHeight = rowHeight * fixedRowCount;
        }
      }

      return this._topGridHeight;
    }
  }, {
    key: "_handleInvalidatedGridSize",
    value: function _handleInvalidatedGridSize() {
      if (typeof this._deferredInvalidateColumnIndex === 'number') {
        var columnIndex = this._deferredInvalidateColumnIndex;
        var rowIndex = this._deferredInvalidateRowIndex;
        this._deferredInvalidateColumnIndex = null;
        this._deferredInvalidateRowIndex = null;
        this.recomputeGridSize({
          columnIndex: columnIndex,
          rowIndex: rowIndex
        });
        this.forceUpdate();
      }
    }
    /**
     * Avoid recreating inline styles each render; this bypasses Grid's shallowCompare.
     * This method recalculates styles only when specific props change.
     */

  }, {
    key: "_maybeCalculateCachedStyles",
    value: function _maybeCalculateCachedStyles(resetAll) {
      var _this$props9 = this.props,
          columnWidth = _this$props9.columnWidth,
          enableFixedColumnScroll = _this$props9.enableFixedColumnScroll,
          enableFixedRowScroll = _this$props9.enableFixedRowScroll,
          height = _this$props9.height,
          fixedColumnCount = _this$props9.fixedColumnCount,
          fixedRowCount = _this$props9.fixedRowCount,
          rowHeight = _this$props9.rowHeight,
          style = _this$props9.style,
          styleBottomLeftGrid = _this$props9.styleBottomLeftGrid,
          styleBottomRightGrid = _this$props9.styleBottomRightGrid,
          styleTopLeftGrid = _this$props9.styleTopLeftGrid,
          styleTopRightGrid = _this$props9.styleTopRightGrid,
          width = _this$props9.width;
      var sizeChange = resetAll || height !== this._lastRenderedHeight || width !== this._lastRenderedWidth;
      var leftSizeChange = resetAll || columnWidth !== this._lastRenderedColumnWidth || fixedColumnCount !== this._lastRenderedFixedColumnCount;
      var topSizeChange = resetAll || fixedRowCount !== this._lastRenderedFixedRowCount || rowHeight !== this._lastRenderedRowHeight;

      if (resetAll || sizeChange || style !== this._lastRenderedStyle) {
        this._containerOuterStyle = _objectSpread({
          height: height,
          overflow: 'visible',
          // Let :focus outline show through
          width: width
        }, style);
      }

      if (resetAll || sizeChange || topSizeChange) {
        this._containerTopStyle = {
          height: this._getTopGridHeight(this.props),
          position: 'relative',
          width: width
        };
        this._containerBottomStyle = {
          height: height - this._getTopGridHeight(this.props),
          overflow: 'visible',
          // Let :focus outline show through
          position: 'relative',
          width: width
        };
      }

      if (resetAll || styleBottomLeftGrid !== this._lastRenderedStyleBottomLeftGrid) {
        this._bottomLeftGridStyle = _objectSpread({
          left: 0,
          overflowX: 'hidden',
          overflowY: enableFixedColumnScroll ? 'auto' : 'hidden',
          position: 'absolute'
        }, styleBottomLeftGrid);
      }

      if (resetAll || leftSizeChange || styleBottomRightGrid !== this._lastRenderedStyleBottomRightGrid) {
        this._bottomRightGridStyle = _objectSpread({
          left: this._getLeftGridWidth(this.props),
          position: 'absolute'
        }, styleBottomRightGrid);
      }

      if (resetAll || styleTopLeftGrid !== this._lastRenderedStyleTopLeftGrid) {
        this._topLeftGridStyle = _objectSpread({
          left: 0,
          overflowX: 'hidden',
          overflowY: 'hidden',
          position: 'absolute',
          top: 0
        }, styleTopLeftGrid);
      }

      if (resetAll || leftSizeChange || styleTopRightGrid !== this._lastRenderedStyleTopRightGrid) {
        this._topRightGridStyle = _objectSpread({
          left: this._getLeftGridWidth(this.props),
          overflowX: enableFixedRowScroll ? 'auto' : 'hidden',
          overflowY: 'hidden',
          position: 'absolute',
          top: 0
        }, styleTopRightGrid);
      }

      this._lastRenderedColumnWidth = columnWidth;
      this._lastRenderedFixedColumnCount = fixedColumnCount;
      this._lastRenderedFixedRowCount = fixedRowCount;
      this._lastRenderedHeight = height;
      this._lastRenderedRowHeight = rowHeight;
      this._lastRenderedStyle = style;
      this._lastRenderedStyleBottomLeftGrid = styleBottomLeftGrid;
      this._lastRenderedStyleBottomRightGrid = styleBottomRightGrid;
      this._lastRenderedStyleTopLeftGrid = styleTopLeftGrid;
      this._lastRenderedStyleTopRightGrid = styleTopRightGrid;
      this._lastRenderedWidth = width;
    }
  }, {
    key: "_prepareForRender",
    value: function _prepareForRender() {
      if (this._lastRenderedColumnWidth !== this.props.columnWidth || this._lastRenderedFixedColumnCount !== this.props.fixedColumnCount) {
        this._leftGridWidth = null;
      }

      if (this._lastRenderedFixedRowCount !== this.props.fixedRowCount || this._lastRenderedRowHeight !== this.props.rowHeight) {
        this._topGridHeight = null;
      }

      this._maybeCalculateCachedStyles();

      this._lastRenderedColumnWidth = this.props.columnWidth;
      this._lastRenderedFixedColumnCount = this.props.fixedColumnCount;
      this._lastRenderedFixedRowCount = this.props.fixedRowCount;
      this._lastRenderedRowHeight = this.props.rowHeight;
    }
  }, {
    key: "_renderBottomLeftGrid",
    value: function _renderBottomLeftGrid(props) {
      var enableFixedColumnScroll = props.enableFixedColumnScroll,
          fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount,
          rowCount = props.rowCount,
          hideBottomLeftGridScrollbar = props.hideBottomLeftGridScrollbar;
      var showVerticalScrollbar = this.state.showVerticalScrollbar;

      if (!fixedColumnCount) {
        return null;
      }

      var additionalRowCount = showVerticalScrollbar ? 1 : 0,
          height = this._getBottomGridHeight(props),
          width = this._getLeftGridWidth(props),
          scrollbarSize = this.state.showVerticalScrollbar ? this.state.scrollbarSize : 0,
          gridWidth = hideBottomLeftGridScrollbar ? width + scrollbarSize : width;

      var bottomLeftGrid = __WEBPACK_IMPORTED_MODULE_10_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__Grid__["b" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, props, {
        cellRenderer: this._cellRendererBottomLeftGrid,
        className: this.props.classNameBottomLeftGrid,
        columnCount: fixedColumnCount,
        deferredMeasurementCache: this._deferredMeasurementCacheBottomLeftGrid,
        height: height,
        onScroll: enableFixedColumnScroll ? this._onScrollTop : undefined,
        ref: this._bottomLeftGridRef,
        rowCount: Math.max(0, rowCount - fixedRowCount) + additionalRowCount,
        rowHeight: this._rowHeightBottomGrid,
        style: this._bottomLeftGridStyle,
        tabIndex: null,
        width: gridWidth
      }));

      if (hideBottomLeftGridScrollbar) {
        return __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("div", {
          className: "BottomLeftGrid_ScrollWrapper",
          style: _objectSpread({}, this._bottomLeftGridStyle, {
            height: height,
            width: width,
            overflowY: 'hidden'
          })
        }, bottomLeftGrid);
      }

      return bottomLeftGrid;
    }
  }, {
    key: "_renderBottomRightGrid",
    value: function _renderBottomRightGrid(props) {
      var columnCount = props.columnCount,
          fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount,
          rowCount = props.rowCount,
          scrollToColumn = props.scrollToColumn,
          scrollToRow = props.scrollToRow;
      return __WEBPACK_IMPORTED_MODULE_10_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__Grid__["b" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, props, {
        cellRenderer: this._cellRendererBottomRightGrid,
        className: this.props.classNameBottomRightGrid,
        columnCount: Math.max(0, columnCount - fixedColumnCount),
        columnWidth: this._columnWidthRightGrid,
        deferredMeasurementCache: this._deferredMeasurementCacheBottomRightGrid,
        height: this._getBottomGridHeight(props),
        onScroll: this._onScroll,
        onScrollbarPresenceChange: this._onScrollbarPresenceChange,
        ref: this._bottomRightGridRef,
        rowCount: Math.max(0, rowCount - fixedRowCount),
        rowHeight: this._rowHeightBottomGrid,
        scrollToColumn: scrollToColumn - fixedColumnCount,
        scrollToRow: scrollToRow - fixedRowCount,
        style: this._bottomRightGridStyle,
        width: this._getRightGridWidth(props)
      }));
    }
  }, {
    key: "_renderTopLeftGrid",
    value: function _renderTopLeftGrid(props) {
      var fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount;

      if (!fixedColumnCount || !fixedRowCount) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_10_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__Grid__["b" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, props, {
        className: this.props.classNameTopLeftGrid,
        columnCount: fixedColumnCount,
        height: this._getTopGridHeight(props),
        ref: this._topLeftGridRef,
        rowCount: fixedRowCount,
        style: this._topLeftGridStyle,
        tabIndex: null,
        width: this._getLeftGridWidth(props)
      }));
    }
  }, {
    key: "_renderTopRightGrid",
    value: function _renderTopRightGrid(props) {
      var columnCount = props.columnCount,
          enableFixedRowScroll = props.enableFixedRowScroll,
          fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount,
          scrollLeft = props.scrollLeft,
          hideTopRightGridScrollbar = props.hideTopRightGridScrollbar;
      var _this$state5 = this.state,
          showHorizontalScrollbar = _this$state5.showHorizontalScrollbar,
          scrollbarSize = _this$state5.scrollbarSize;

      if (!fixedRowCount) {
        return null;
      }

      var additionalColumnCount = showHorizontalScrollbar ? 1 : 0,
          height = this._getTopGridHeight(props),
          width = this._getRightGridWidth(props),
          additionalHeight = showHorizontalScrollbar ? scrollbarSize : 0;

      var gridHeight = height,
          style = this._topRightGridStyle;

      if (hideTopRightGridScrollbar) {
        gridHeight = height + additionalHeight;
        style = _objectSpread({}, this._topRightGridStyle, {
          left: 0
        });
      }

      var topRightGrid = __WEBPACK_IMPORTED_MODULE_10_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__Grid__["b" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, props, {
        cellRenderer: this._cellRendererTopRightGrid,
        className: this.props.classNameTopRightGrid,
        columnCount: Math.max(0, columnCount - fixedColumnCount) + additionalColumnCount,
        columnWidth: this._columnWidthRightGrid,
        deferredMeasurementCache: this._deferredMeasurementCacheTopRightGrid,
        height: gridHeight,
        onScroll: enableFixedRowScroll ? this._onScrollLeft : undefined,
        ref: this._topRightGridRef,
        rowCount: fixedRowCount,
        scrollLeft: scrollLeft,
        style: style,
        tabIndex: null,
        width: width
      }));

      if (hideTopRightGridScrollbar) {
        return __WEBPACK_IMPORTED_MODULE_10_react__["createElement"]("div", {
          className: "TopRightGrid_ScrollWrapper",
          style: _objectSpread({}, this._topRightGridStyle, {
            height: height,
            width: width,
            overflowX: 'hidden'
          })
        }, topRightGrid);
      }

      return topRightGrid;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.scrollLeft !== prevState.scrollLeft || nextProps.scrollTop !== prevState.scrollTop) {
        return {
          scrollLeft: nextProps.scrollLeft != null && nextProps.scrollLeft >= 0 ? nextProps.scrollLeft : prevState.scrollLeft,
          scrollTop: nextProps.scrollTop != null && nextProps.scrollTop >= 0 ? nextProps.scrollTop : prevState.scrollTop
        };
      }

      return null;
    }
  }]);

  return MultiGrid;
}(__WEBPACK_IMPORTED_MODULE_10_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(MultiGrid, "defaultProps", {
  classNameBottomLeftGrid: '',
  classNameBottomRightGrid: '',
  classNameTopLeftGrid: '',
  classNameTopRightGrid: '',
  enableFixedColumnScroll: false,
  enableFixedRowScroll: false,
  fixedColumnCount: 0,
  fixedRowCount: 0,
  scrollToColumn: -1,
  scrollToRow: -1,
  style: {},
  styleBottomLeftGrid: {},
  styleBottomRightGrid: {},
  styleTopLeftGrid: {},
  styleTopRightGrid: {},
  hideTopRightGridScrollbar: false,
  hideBottomLeftGridScrollbar: false
});

MultiGrid.propTypes =  false ? {
  classNameBottomLeftGrid: PropTypes.string.isRequired,
  classNameBottomRightGrid: PropTypes.string.isRequired,
  classNameTopLeftGrid: PropTypes.string.isRequired,
  classNameTopRightGrid: PropTypes.string.isRequired,
  enableFixedColumnScroll: PropTypes.bool.isRequired,
  enableFixedRowScroll: PropTypes.bool.isRequired,
  fixedColumnCount: PropTypes.number.isRequired,
  fixedRowCount: PropTypes.number.isRequired,
  onScrollbarPresenceChange: PropTypes.func,
  style: PropTypes.object.isRequired,
  styleBottomLeftGrid: PropTypes.object.isRequired,
  styleBottomRightGrid: PropTypes.object.isRequired,
  styleTopLeftGrid: PropTypes.object.isRequired,
  styleTopRightGrid: PropTypes.object.isRequired,
  hideTopRightGridScrollbar: PropTypes.bool,
  hideBottomLeftGridScrollbar: PropTypes.bool
} : {};
Object(__WEBPACK_IMPORTED_MODULE_11_react_lifecycles_compat__["a" /* polyfill */])(MultiGrid);
/* harmony default export */ __webpack_exports__["a"] = (MultiGrid);

/***/ }),
/* 2227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CellMeasurerCacheDecorator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CellMeasurer__ = __webpack_require__(874);





/**
 * Caches measurements for a given cell.
 */
var CellMeasurerCacheDecorator =
/*#__PURE__*/
function () {
  function CellMeasurerCacheDecorator() {
    var _this = this;

    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, CellMeasurerCacheDecorator);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "_cellMeasurerCache", void 0);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "_columnIndexOffset", void 0);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "_rowIndexOffset", void 0);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "columnWidth", function (_ref) {
      var index = _ref.index;

      _this._cellMeasurerCache.columnWidth({
        index: index + _this._columnIndexOffset
      });
    });

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "rowHeight", function (_ref2) {
      var index = _ref2.index;

      _this._cellMeasurerCache.rowHeight({
        index: index + _this._rowIndexOffset
      });
    });

    var cellMeasurerCache = params.cellMeasurerCache,
        _params$columnIndexOf = params.columnIndexOffset,
        columnIndexOffset = _params$columnIndexOf === void 0 ? 0 : _params$columnIndexOf,
        _params$rowIndexOffse = params.rowIndexOffset,
        rowIndexOffset = _params$rowIndexOffse === void 0 ? 0 : _params$rowIndexOffse;
    this._cellMeasurerCache = cellMeasurerCache;
    this._columnIndexOffset = columnIndexOffset;
    this._rowIndexOffset = rowIndexOffset;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(CellMeasurerCacheDecorator, [{
    key: "clear",
    value: function clear(rowIndex, columnIndex) {
      this._cellMeasurerCache.clear(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: "clearAll",
    value: function clearAll() {
      this._cellMeasurerCache.clearAll();
    }
  }, {
    key: "hasFixedHeight",
    value: function hasFixedHeight() {
      return this._cellMeasurerCache.hasFixedHeight();
    }
  }, {
    key: "hasFixedWidth",
    value: function hasFixedWidth() {
      return this._cellMeasurerCache.hasFixedWidth();
    }
  }, {
    key: "getHeight",
    value: function getHeight(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this._cellMeasurerCache.getHeight(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: "getWidth",
    value: function getWidth(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this._cellMeasurerCache.getWidth(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: "has",
    value: function has(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this._cellMeasurerCache.has(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: "set",
    value: function set(rowIndex, columnIndex, width, height) {
      this._cellMeasurerCache.set(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset, width, height);
    }
  }, {
    key: "defaultHeight",
    get: function get() {
      return this._cellMeasurerCache.defaultHeight;
    }
  }, {
    key: "defaultWidth",
    get: function get() {
      return this._cellMeasurerCache.defaultWidth;
    }
  }]);

  return CellMeasurerCacheDecorator;
}();



/***/ }),
/* 2228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScrollSync__ = __webpack_require__(2229);
/* unused harmony reexport ScrollSync */

/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__ScrollSync__["a" /* default */]);


/***/ }),
/* 2229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollSync; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);








/**
 * HOC that simplifies the process of synchronizing scrolling between two or more virtualized components.
 */

var ScrollSync =
/*#__PURE__*/
function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(ScrollSync, _React$PureComponent);

  function ScrollSync(props, context) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, ScrollSync);

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(ScrollSync).call(this, props, context));
    _this.state = {
      clientHeight: 0,
      clientWidth: 0,
      scrollHeight: 0,
      scrollLeft: 0,
      scrollTop: 0,
      scrollWidth: 0
    };
    _this._onScroll = _this._onScroll.bind(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this));
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ScrollSync, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      var _this$state = this.state,
          clientHeight = _this$state.clientHeight,
          clientWidth = _this$state.clientWidth,
          scrollHeight = _this$state.scrollHeight,
          scrollLeft = _this$state.scrollLeft,
          scrollTop = _this$state.scrollTop,
          scrollWidth = _this$state.scrollWidth;
      return children({
        clientHeight: clientHeight,
        clientWidth: clientWidth,
        onScroll: this._onScroll,
        scrollHeight: scrollHeight,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        scrollWidth: scrollWidth
      });
    }
  }, {
    key: "_onScroll",
    value: function _onScroll(_ref) {
      var clientHeight = _ref.clientHeight,
          clientWidth = _ref.clientWidth,
          scrollHeight = _ref.scrollHeight,
          scrollLeft = _ref.scrollLeft,
          scrollTop = _ref.scrollTop,
          scrollWidth = _ref.scrollWidth;
      this.setState({
        clientHeight: clientHeight,
        clientWidth: clientWidth,
        scrollHeight: scrollHeight,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        scrollWidth: scrollWidth
      });
    }
  }]);

  return ScrollSync;
}(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"]);


ScrollSync.propTypes =  false ? {
  /**
   * Function responsible for rendering 2 or more virtualized components.
   * This function should implement the following signature:
   * ({ onScroll, scrollLeft, scrollTop }) => PropTypes.element
   */
  children: PropTypes.func.isRequired
} : {};

/***/ }),
/* 2230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createMultiSort__ = __webpack_require__(2231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultCellDataGetter__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultCellRenderer__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaultHeaderRowRenderer_js__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__defaultHeaderRenderer__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__defaultRowRenderer__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Column__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SortDirection__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SortIndicator__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Table__ = __webpack_require__(2232);
/* unused harmony reexport createMultiSort */
/* unused harmony reexport defaultCellDataGetter */
/* unused harmony reexport defaultCellRenderer */
/* unused harmony reexport defaultHeaderRowRenderer */
/* unused harmony reexport defaultHeaderRenderer */
/* unused harmony reexport defaultRowRenderer */
/* unused harmony reexport Column */
/* unused harmony reexport SortDirection */
/* unused harmony reexport SortIndicator */
/* unused harmony reexport Table */










/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_9__Table__["a" /* default */]);


/***/ }),
/* 2231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
function createMultiSort(sortCallback) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      defaultSortBy = _ref.defaultSortBy,
      _ref$defaultSortDirec = _ref.defaultSortDirection,
      defaultSortDirection = _ref$defaultSortDirec === void 0 ? {} : _ref$defaultSortDirec;

  if (!sortCallback) {
    throw Error("Required parameter \"sortCallback\" not specified");
  }

  var sortBy = defaultSortBy || [];
  var sortDirection = {};
  sortBy.forEach(function (dataKey) {
    sortDirection[dataKey] = defaultSortDirection[dataKey] !== undefined ? defaultSortDirection[dataKey] : 'ASC';
  });

  function sort(_ref2) {
    var defaultSortDirection = _ref2.defaultSortDirection,
        event = _ref2.event,
        dataKey = _ref2.sortBy;

    if (event.shiftKey) {
      // Shift + click appends a column to existing criteria
      if (sortDirection[dataKey] !== undefined) {
        sortDirection[dataKey] = sortDirection[dataKey] === 'ASC' ? 'DESC' : 'ASC';
      } else {
        sortDirection[dataKey] = defaultSortDirection;
        sortBy.push(dataKey);
      }
    } else if (event.ctrlKey || event.metaKey) {
      // Control + click removes column from sort (if pressent)
      var index = sortBy.indexOf(dataKey);

      if (index >= 0) {
        sortBy.splice(index, 1);
        delete sortDirection[dataKey];
      }
    } else {
      // Clear sortBy array of all non-selected keys
      sortBy.length = 0;
      sortBy.push(dataKey); // Clear sortDirection object of all non-selected keys

      var sortDirectionKeys = Object.keys(sortDirection);
      sortDirectionKeys.forEach(function (key) {
        if (key !== dataKey) delete sortDirection[key];
      }); // If key is already selected, reverse sort direction.
      // Else, set sort direction to default direction.

      if (sortDirection[dataKey] !== undefined) {
        sortDirection[dataKey] = sortDirection[dataKey] === 'ASC' ? 'DESC' : 'ASC';
      } else {
        sortDirection[dataKey] = defaultSortDirection;
      }
    } // Notify application code


    sortCallback({
      sortBy: sortBy,
      sortDirection: sortDirection
    });
  }

  return {
    sort: sort,
    sortBy: sortBy,
    sortDirection: sortDirection
  };
}

/***/ }),
/* 2232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Table; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_clsx__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Column__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_dom__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Grid__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__defaultRowRenderer__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__defaultHeaderRowRenderer__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__SortDirection__ = __webpack_require__(287);









function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










/**
 * Table component with fixed headers and virtualized rows for improved performance with large data sets.
 * This component expects explicit width, height, and padding parameters.
 */

var Table =
/*#__PURE__*/
function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Table, _React$PureComponent);

  function Table(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Table);

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Table).call(this, props));
    _this.state = {
      scrollbarWidth: 0
    };
    _this._createColumn = _this._createColumn.bind(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this));
    _this._createRow = _this._createRow.bind(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this));
    _this._onScroll = _this._onScroll.bind(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this));
    _this._onSectionRendered = _this._onSectionRendered.bind(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this));
    _this._setRef = _this._setRef.bind(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this));
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Table, [{
    key: "forceUpdateGrid",
    value: function forceUpdateGrid() {
      if (this.Grid) {
        this.Grid.forceUpdate();
      }
    }
    /** See Grid#getOffsetForCell */

  }, {
    key: "getOffsetForRow",
    value: function getOffsetForRow(_ref) {
      var alignment = _ref.alignment,
          index = _ref.index;

      if (this.Grid) {
        var _this$Grid$getOffsetF = this.Grid.getOffsetForCell({
          alignment: alignment,
          rowIndex: index
        }),
            scrollTop = _this$Grid$getOffsetF.scrollTop;

        return scrollTop;
      }

      return 0;
    }
    /** CellMeasurer compatibility */

  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender(_ref2) {
      var columnIndex = _ref2.columnIndex,
          rowIndex = _ref2.rowIndex;

      if (this.Grid) {
        this.Grid.invalidateCellSizeAfterRender({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }
    /** See Grid#measureAllCells */

  }, {
    key: "measureAllRows",
    value: function measureAllRows() {
      if (this.Grid) {
        this.Grid.measureAllCells();
      }
    }
    /** CellMeasurer compatibility */

  }, {
    key: "recomputeGridSize",
    value: function recomputeGridSize() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$columnIndex = _ref3.columnIndex,
          columnIndex = _ref3$columnIndex === void 0 ? 0 : _ref3$columnIndex,
          _ref3$rowIndex = _ref3.rowIndex,
          rowIndex = _ref3$rowIndex === void 0 ? 0 : _ref3$rowIndex;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }
    /** See Grid#recomputeGridSize */

  }, {
    key: "recomputeRowHeights",
    value: function recomputeRowHeights() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: index
        });
      }
    }
    /** See Grid#scrollToPosition */

  }, {
    key: "scrollToPosition",
    value: function scrollToPosition() {
      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToPosition({
          scrollTop: scrollTop
        });
      }
    }
    /** See Grid#scrollToCell */

  }, {
    key: "scrollToRow",
    value: function scrollToRow() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToCell({
          columnIndex: 0,
          rowIndex: index
        });
      }
    }
  }, {
    key: "getScrollbarWidth",
    value: function getScrollbarWidth() {
      if (this.Grid) {
        var _Grid = Object(__WEBPACK_IMPORTED_MODULE_12_react_dom__["findDOMNode"])(this.Grid);

        var clientWidth = _Grid.clientWidth || 0;
        var offsetWidth = _Grid.offsetWidth || 0;
        return offsetWidth - clientWidth;
      }

      return 0;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this._setScrollbarWidth();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this._setScrollbarWidth();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          disableHeader = _this$props.disableHeader,
          gridClassName = _this$props.gridClassName,
          gridStyle = _this$props.gridStyle,
          headerHeight = _this$props.headerHeight,
          headerRowRenderer = _this$props.headerRowRenderer,
          height = _this$props.height,
          id = _this$props.id,
          noRowsRenderer = _this$props.noRowsRenderer,
          rowClassName = _this$props.rowClassName,
          rowStyle = _this$props.rowStyle,
          scrollToIndex = _this$props.scrollToIndex,
          style = _this$props.style,
          width = _this$props.width;
      var scrollbarWidth = this.state.scrollbarWidth;
      var availableRowsHeight = disableHeader ? height : height - headerHeight;
      var rowClass = typeof rowClassName === 'function' ? rowClassName({
        index: -1
      }) : rowClassName;
      var rowStyleObject = typeof rowStyle === 'function' ? rowStyle({
        index: -1
      }) : rowStyle; // Precompute and cache column styles before rendering rows and columns to speed things up

      this._cachedColumnStyles = [];
      __WEBPACK_IMPORTED_MODULE_11_react__["Children"].toArray(children).forEach(function (column, index) {
        var flexStyles = _this2._getFlexStyleForColumn(column, column.props.style);

        _this2._cachedColumnStyles[index] = _objectSpread({
          overflow: 'hidden'
        }, flexStyles);
      }); // Note that we specify :rowCount, :scrollbarWidth, :sortBy, and :sortDirection as properties on Grid even though these have nothing to do with Grid.
      // This is done because Grid is a pure component and won't update unless its properties or state has changed.
      // Any property that should trigger a re-render of Grid then is specified here to avoid a stale display.

      return __WEBPACK_IMPORTED_MODULE_11_react__["createElement"]("div", {
        "aria-label": this.props['aria-label'],
        "aria-labelledby": this.props['aria-labelledby'],
        "aria-colcount": __WEBPACK_IMPORTED_MODULE_11_react__["Children"].toArray(children).length,
        "aria-rowcount": this.props.rowCount,
        className: Object(__WEBPACK_IMPORTED_MODULE_8_clsx__["a" /* default */])('ReactVirtualized__Table', className),
        id: id,
        role: "grid",
        style: style
      }, !disableHeader && headerRowRenderer({
        className: Object(__WEBPACK_IMPORTED_MODULE_8_clsx__["a" /* default */])('ReactVirtualized__Table__headerRow', rowClass),
        columns: this._getHeaderColumns(),
        style: _objectSpread({
          height: headerHeight,
          overflow: 'hidden',
          paddingRight: scrollbarWidth,
          width: width
        }, rowStyleObject)
      }), __WEBPACK_IMPORTED_MODULE_11_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__Grid__["b" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, this.props, {
        "aria-readonly": null,
        autoContainerWidth: true,
        className: Object(__WEBPACK_IMPORTED_MODULE_8_clsx__["a" /* default */])('ReactVirtualized__Table__Grid', gridClassName),
        cellRenderer: this._createRow,
        columnWidth: width,
        columnCount: 1,
        height: availableRowsHeight,
        id: undefined,
        noContentRenderer: noRowsRenderer,
        onScroll: this._onScroll,
        onSectionRendered: this._onSectionRendered,
        ref: this._setRef,
        role: "rowgroup",
        scrollbarWidth: scrollbarWidth,
        scrollToRow: scrollToIndex,
        style: _objectSpread({}, gridStyle, {
          overflowX: 'hidden'
        })
      })));
    }
  }, {
    key: "_createColumn",
    value: function _createColumn(_ref4) {
      var column = _ref4.column,
          columnIndex = _ref4.columnIndex,
          isScrolling = _ref4.isScrolling,
          parent = _ref4.parent,
          rowData = _ref4.rowData,
          rowIndex = _ref4.rowIndex;
      var onColumnClick = this.props.onColumnClick;
      var _column$props = column.props,
          cellDataGetter = _column$props.cellDataGetter,
          cellRenderer = _column$props.cellRenderer,
          className = _column$props.className,
          columnData = _column$props.columnData,
          dataKey = _column$props.dataKey,
          id = _column$props.id;
      var cellData = cellDataGetter({
        columnData: columnData,
        dataKey: dataKey,
        rowData: rowData
      });
      var renderedCell = cellRenderer({
        cellData: cellData,
        columnData: columnData,
        columnIndex: columnIndex,
        dataKey: dataKey,
        isScrolling: isScrolling,
        parent: parent,
        rowData: rowData,
        rowIndex: rowIndex
      });

      var onClick = function onClick(event) {
        onColumnClick && onColumnClick({
          columnData: columnData,
          dataKey: dataKey,
          event: event
        });
      };

      var style = this._cachedColumnStyles[columnIndex];
      var title = typeof renderedCell === 'string' ? renderedCell : null; // Avoid using object-spread syntax with multiple objects here,
      // Since it results in an extra method call to 'babel-runtime/helpers/extends'
      // See PR https://github.com/bvaughn/react-virtualized/pull/942

      return __WEBPACK_IMPORTED_MODULE_11_react__["createElement"]("div", {
        "aria-colindex": columnIndex + 1,
        "aria-describedby": id,
        className: Object(__WEBPACK_IMPORTED_MODULE_8_clsx__["a" /* default */])('ReactVirtualized__Table__rowColumn', className),
        key: 'Row' + rowIndex + '-' + 'Col' + columnIndex,
        onClick: onClick,
        role: "gridcell",
        style: style,
        title: title
      }, renderedCell);
    }
  }, {
    key: "_createHeader",
    value: function _createHeader(_ref5) {
      var column = _ref5.column,
          index = _ref5.index;
      var _this$props2 = this.props,
          headerClassName = _this$props2.headerClassName,
          headerStyle = _this$props2.headerStyle,
          onHeaderClick = _this$props2.onHeaderClick,
          sort = _this$props2.sort,
          sortBy = _this$props2.sortBy,
          sortDirection = _this$props2.sortDirection;
      var _column$props2 = column.props,
          columnData = _column$props2.columnData,
          dataKey = _column$props2.dataKey,
          defaultSortDirection = _column$props2.defaultSortDirection,
          disableSort = _column$props2.disableSort,
          headerRenderer = _column$props2.headerRenderer,
          id = _column$props2.id,
          label = _column$props2.label;
      var sortEnabled = !disableSort && sort;
      var classNames = Object(__WEBPACK_IMPORTED_MODULE_8_clsx__["a" /* default */])('ReactVirtualized__Table__headerColumn', headerClassName, column.props.headerClassName, {
        ReactVirtualized__Table__sortableHeaderColumn: sortEnabled
      });

      var style = this._getFlexStyleForColumn(column, _objectSpread({}, headerStyle, {}, column.props.headerStyle));

      var renderedHeader = headerRenderer({
        columnData: columnData,
        dataKey: dataKey,
        disableSort: disableSort,
        label: label,
        sortBy: sortBy,
        sortDirection: sortDirection
      });
      var headerOnClick, headerOnKeyDown, headerTabIndex, headerAriaSort, headerAriaLabel;

      if (sortEnabled || onHeaderClick) {
        // If this is a sortable header, clicking it should update the table data's sorting.
        var isFirstTimeSort = sortBy !== dataKey; // If this is the firstTime sort of this column, use the column default sort order.
        // Otherwise, invert the direction of the sort.

        var newSortDirection = isFirstTimeSort ? defaultSortDirection : sortDirection === __WEBPACK_IMPORTED_MODULE_16__SortDirection__["a" /* default */].DESC ? __WEBPACK_IMPORTED_MODULE_16__SortDirection__["a" /* default */].ASC : __WEBPACK_IMPORTED_MODULE_16__SortDirection__["a" /* default */].DESC;

        var onClick = function onClick(event) {
          sortEnabled && sort({
            defaultSortDirection: defaultSortDirection,
            event: event,
            sortBy: dataKey,
            sortDirection: newSortDirection
          });
          onHeaderClick && onHeaderClick({
            columnData: columnData,
            dataKey: dataKey,
            event: event
          });
        };

        var onKeyDown = function onKeyDown(event) {
          if (event.key === 'Enter' || event.key === ' ') {
            onClick(event);
          }
        };

        headerAriaLabel = column.props['aria-label'] || label || dataKey;
        headerAriaSort = 'none';
        headerTabIndex = 0;
        headerOnClick = onClick;
        headerOnKeyDown = onKeyDown;
      }

      if (sortBy === dataKey) {
        headerAriaSort = sortDirection === __WEBPACK_IMPORTED_MODULE_16__SortDirection__["a" /* default */].ASC ? 'ascending' : 'descending';
      } // Avoid using object-spread syntax with multiple objects here,
      // Since it results in an extra method call to 'babel-runtime/helpers/extends'
      // See PR https://github.com/bvaughn/react-virtualized/pull/942


      return __WEBPACK_IMPORTED_MODULE_11_react__["createElement"]("div", {
        "aria-label": headerAriaLabel,
        "aria-sort": headerAriaSort,
        className: classNames,
        id: id,
        key: 'Header-Col' + index,
        onClick: headerOnClick,
        onKeyDown: headerOnKeyDown,
        role: "columnheader",
        style: style,
        tabIndex: headerTabIndex
      }, renderedHeader);
    }
  }, {
    key: "_createRow",
    value: function _createRow(_ref6) {
      var _this3 = this;

      var index = _ref6.rowIndex,
          isScrolling = _ref6.isScrolling,
          key = _ref6.key,
          parent = _ref6.parent,
          style = _ref6.style;
      var _this$props3 = this.props,
          children = _this$props3.children,
          onRowClick = _this$props3.onRowClick,
          onRowDoubleClick = _this$props3.onRowDoubleClick,
          onRowRightClick = _this$props3.onRowRightClick,
          onRowMouseOver = _this$props3.onRowMouseOver,
          onRowMouseOut = _this$props3.onRowMouseOut,
          rowClassName = _this$props3.rowClassName,
          rowGetter = _this$props3.rowGetter,
          rowRenderer = _this$props3.rowRenderer,
          rowStyle = _this$props3.rowStyle;
      var scrollbarWidth = this.state.scrollbarWidth;
      var rowClass = typeof rowClassName === 'function' ? rowClassName({
        index: index
      }) : rowClassName;
      var rowStyleObject = typeof rowStyle === 'function' ? rowStyle({
        index: index
      }) : rowStyle;
      var rowData = rowGetter({
        index: index
      });
      var columns = __WEBPACK_IMPORTED_MODULE_11_react__["Children"].toArray(children).map(function (column, columnIndex) {
        return _this3._createColumn({
          column: column,
          columnIndex: columnIndex,
          isScrolling: isScrolling,
          parent: parent,
          rowData: rowData,
          rowIndex: index,
          scrollbarWidth: scrollbarWidth
        });
      });
      var className = Object(__WEBPACK_IMPORTED_MODULE_8_clsx__["a" /* default */])('ReactVirtualized__Table__row', rowClass);

      var flattenedStyle = _objectSpread({}, style, {
        height: this._getRowHeight(index),
        overflow: 'hidden',
        paddingRight: scrollbarWidth
      }, rowStyleObject);

      return rowRenderer({
        className: className,
        columns: columns,
        index: index,
        isScrolling: isScrolling,
        key: key,
        onRowClick: onRowClick,
        onRowDoubleClick: onRowDoubleClick,
        onRowRightClick: onRowRightClick,
        onRowMouseOver: onRowMouseOver,
        onRowMouseOut: onRowMouseOut,
        rowData: rowData,
        style: flattenedStyle
      });
    }
    /**
     * Determines the flex-shrink, flex-grow, and width values for a cell (header or column).
     */

  }, {
    key: "_getFlexStyleForColumn",
    value: function _getFlexStyleForColumn(column) {
      var customStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var flexValue = "".concat(column.props.flexGrow, " ").concat(column.props.flexShrink, " ").concat(column.props.width, "px");

      var style = _objectSpread({}, customStyle, {
        flex: flexValue,
        msFlex: flexValue,
        WebkitFlex: flexValue
      });

      if (column.props.maxWidth) {
        style.maxWidth = column.props.maxWidth;
      }

      if (column.props.minWidth) {
        style.minWidth = column.props.minWidth;
      }

      return style;
    }
  }, {
    key: "_getHeaderColumns",
    value: function _getHeaderColumns() {
      var _this4 = this;

      var _this$props4 = this.props,
          children = _this$props4.children,
          disableHeader = _this$props4.disableHeader;
      var items = disableHeader ? [] : __WEBPACK_IMPORTED_MODULE_11_react__["Children"].toArray(children);
      return items.map(function (column, index) {
        return _this4._createHeader({
          column: column,
          index: index
        });
      });
    }
  }, {
    key: "_getRowHeight",
    value: function _getRowHeight(rowIndex) {
      var rowHeight = this.props.rowHeight;
      return typeof rowHeight === 'function' ? rowHeight({
        index: rowIndex
      }) : rowHeight;
    }
  }, {
    key: "_onScroll",
    value: function _onScroll(_ref7) {
      var clientHeight = _ref7.clientHeight,
          scrollHeight = _ref7.scrollHeight,
          scrollTop = _ref7.scrollTop;
      var onScroll = this.props.onScroll;
      onScroll({
        clientHeight: clientHeight,
        scrollHeight: scrollHeight,
        scrollTop: scrollTop
      });
    }
  }, {
    key: "_onSectionRendered",
    value: function _onSectionRendered(_ref8) {
      var rowOverscanStartIndex = _ref8.rowOverscanStartIndex,
          rowOverscanStopIndex = _ref8.rowOverscanStopIndex,
          rowStartIndex = _ref8.rowStartIndex,
          rowStopIndex = _ref8.rowStopIndex;
      var onRowsRendered = this.props.onRowsRendered;
      onRowsRendered({
        overscanStartIndex: rowOverscanStartIndex,
        overscanStopIndex: rowOverscanStopIndex,
        startIndex: rowStartIndex,
        stopIndex: rowStopIndex
      });
    }
  }, {
    key: "_setRef",
    value: function _setRef(ref) {
      this.Grid = ref;
    }
  }, {
    key: "_setScrollbarWidth",
    value: function _setScrollbarWidth() {
      var scrollbarWidth = this.getScrollbarWidth();
      this.setState({
        scrollbarWidth: scrollbarWidth
      });
    }
  }]);

  return Table;
}(__WEBPACK_IMPORTED_MODULE_11_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Table, "defaultProps", {
  disableHeader: false,
  estimatedRowSize: 30,
  headerHeight: 0,
  headerStyle: {},
  noRowsRenderer: function noRowsRenderer() {
    return null;
  },
  onRowsRendered: function onRowsRendered() {
    return null;
  },
  onScroll: function onScroll() {
    return null;
  },
  overscanIndicesGetter: __WEBPACK_IMPORTED_MODULE_13__Grid__["a" /* accessibilityOverscanIndicesGetter */],
  overscanRowCount: 10,
  rowRenderer: __WEBPACK_IMPORTED_MODULE_14__defaultRowRenderer__["a" /* default */],
  headerRowRenderer: __WEBPACK_IMPORTED_MODULE_15__defaultHeaderRowRenderer__["a" /* default */],
  rowStyle: {},
  scrollToAlignment: 'auto',
  scrollToIndex: -1,
  style: {}
});


Table.propTypes =  false ? {
  /** This is just set on the grid top element. */
  'aria-label': PropTypes.string,

  /** This is just set on the grid top element. */
  'aria-labelledby': PropTypes.string,

  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  autoHeight: PropTypes.bool,

  /** One or more Columns describing the data displayed in this row */
  children: function children(props) {
    var children = React.Children.toArray(props.children);

    for (var i = 0; i < children.length; i++) {
      var childType = children[i].type;

      if (childType !== Column && !(childType.prototype instanceof Column)) {
        return new Error('Table only accepts children of type Column');
      }
    }
  },

  /** Optional CSS class name */
  className: PropTypes.string,

  /** Disable rendering the header at all */
  disableHeader: PropTypes.bool,

  /**
   * Used to estimate the total height of a Table before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  estimatedRowSize: PropTypes.number.isRequired,

  /** Optional custom CSS class name to attach to inner Grid element. */
  gridClassName: PropTypes.string,

  /** Optional inline style to attach to inner Grid element. */
  gridStyle: PropTypes.object,

  /** Optional CSS class to apply to all column headers */
  headerClassName: PropTypes.string,

  /** Fixed height of header row */
  headerHeight: PropTypes.number.isRequired,

  /**
   * Responsible for rendering a table row given an array of columns:
   * Should implement the following interface: ({
   *   className: string,
   *   columns: any[],
   *   style: any
   * }): PropTypes.node
   */
  headerRowRenderer: PropTypes.func,

  /** Optional custom inline style to attach to table header columns. */
  headerStyle: PropTypes.object,

  /** Fixed/available height for out DOM element */
  height: PropTypes.number.isRequired,

  /** Optional id */
  id: PropTypes.string,

  /** Optional renderer to be used in place of table body rows when rowCount is 0 */
  noRowsRenderer: PropTypes.func,

  /**
   * Optional callback when a column is clicked.
   * ({ columnData: any, dataKey: string }): void
   */
  onColumnClick: PropTypes.func,

  /**
   * Optional callback when a column's header is clicked.
   * ({ columnData: any, dataKey: string }): void
   */
  onHeaderClick: PropTypes.func,

  /**
   * Callback invoked when a user clicks on a table row.
   * ({ index: number }): void
   */
  onRowClick: PropTypes.func,

  /**
   * Callback invoked when a user double-clicks on a table row.
   * ({ index: number }): void
   */
  onRowDoubleClick: PropTypes.func,

  /**
   * Callback invoked when the mouse leaves a table row.
   * ({ index: number }): void
   */
  onRowMouseOut: PropTypes.func,

  /**
   * Callback invoked when a user moves the mouse over a table row.
   * ({ index: number }): void
   */
  onRowMouseOver: PropTypes.func,

  /**
   * Callback invoked when a user right-clicks on a table row.
   * ({ index: number }): void
   */
  onRowRightClick: PropTypes.func,

  /**
   * Callback invoked with information about the slice of rows that were just rendered.
   * ({ startIndex, stopIndex }): void
   */
  onRowsRendered: PropTypes.func,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   * ({ clientHeight, scrollHeight, scrollTop }): void
   */
  onScroll: PropTypes.func.isRequired,

  /** See Grid#overscanIndicesGetter */
  overscanIndicesGetter: PropTypes.func.isRequired,

  /**
   * Number of rows to render above/below the visible bounds of the list.
   * These rows can help for smoother scrolling on touch devices.
   */
  overscanRowCount: PropTypes.number.isRequired,

  /**
   * Optional CSS class to apply to all table rows (including the header row).
   * This property can be a CSS class name (string) or a function that returns a class name.
   * If a function is provided its signature should be: ({ index: number }): string
   */
  rowClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),

  /**
   * Callback responsible for returning a data row given an index.
   * ({ index: number }): any
   */
  rowGetter: PropTypes.func.isRequired,

  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * ({ index: number }): number
   */
  rowHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.func]).isRequired,

  /** Number of rows in table. */
  rowCount: PropTypes.number.isRequired,

  /**
   * Responsible for rendering a table row given an array of columns:
   * Should implement the following interface: ({
   *   className: string,
   *   columns: Array,
   *   index: number,
   *   isScrolling: boolean,
   *   onRowClick: ?Function,
   *   onRowDoubleClick: ?Function,
   *   onRowMouseOver: ?Function,
   *   onRowMouseOut: ?Function,
   *   rowData: any,
   *   style: any
   * }): PropTypes.node
   */
  rowRenderer: PropTypes.func,

  /** Optional custom inline style to attach to table rows. */
  rowStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,

  /** See Grid#scrollToAlignment */
  scrollToAlignment: PropTypes.oneOf(['auto', 'end', 'start', 'center']).isRequired,

  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  scrollToIndex: PropTypes.number.isRequired,

  /** Vertical offset. */
  scrollTop: PropTypes.number,

  /**
   * Sort function to be called if a sortable header is clicked.
   * Should implement the following interface: ({
   *   defaultSortDirection: 'ASC' | 'DESC',
   *   event: MouseEvent,
   *   sortBy: string,
   *   sortDirection: SortDirection
   * }): void
   */
  sort: PropTypes.func,

  /** Table data is currently sorted by this :dataKey (if it is sorted at all) */
  sortBy: PropTypes.string,

  /** Table data is currently sorted in this direction (if it is sorted at all) */
  sortDirection: PropTypes.oneOf([SortDirection.ASC, SortDirection.DESC]),

  /** Optional inline style */
  style: PropTypes.object,

  /** Tab index for focus */
  tabIndex: PropTypes.number,

  /** Width of list */
  width: PropTypes.number.isRequired
} : {};


/***/ }),
/* 2233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WindowScroller__ = __webpack_require__(886);
/* unused harmony reexport WindowScroller */
/* unused harmony reexport IS_SCROLLING_TIMEOUT */

/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__WindowScroller__["a" /* default */]);


/***/ }),
/* 2234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = registerScrollListener;
/* harmony export (immutable) */ __webpack_exports__["b"] = unregisterScrollListener;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_requestAnimationTimeout__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WindowScroller_js__ = __webpack_require__(886);

var mountedInstances = [];
var originalBodyPointerEvents = null;
var disablePointerEventsTimeoutId = null;

function enablePointerEventsIfDisabled() {
  if (disablePointerEventsTimeoutId) {
    disablePointerEventsTimeoutId = null;

    if (document.body && originalBodyPointerEvents != null) {
      document.body.style.pointerEvents = originalBodyPointerEvents;
    }

    originalBodyPointerEvents = null;
  }
}

function enablePointerEventsAfterDelayCallback() {
  enablePointerEventsIfDisabled();
  mountedInstances.forEach(function (instance) {
    return instance.__resetIsScrolling();
  });
}

function enablePointerEventsAfterDelay() {
  if (disablePointerEventsTimeoutId) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_requestAnimationTimeout__["a" /* cancelAnimationTimeout */])(disablePointerEventsTimeoutId);
  }

  var maximumTimeout = 0;
  mountedInstances.forEach(function (instance) {
    maximumTimeout = Math.max(maximumTimeout, instance.props.scrollingResetTimeInterval);
  });
  disablePointerEventsTimeoutId = Object(__WEBPACK_IMPORTED_MODULE_0__utils_requestAnimationTimeout__["b" /* requestAnimationTimeout */])(enablePointerEventsAfterDelayCallback, maximumTimeout);
}

function onScrollWindow(event) {
  if (event.currentTarget === window && originalBodyPointerEvents == null && document.body) {
    originalBodyPointerEvents = document.body.style.pointerEvents;
    document.body.style.pointerEvents = 'none';
  }

  enablePointerEventsAfterDelay();
  mountedInstances.forEach(function (instance) {
    if (instance.props.scrollElement === event.currentTarget) {
      instance.__handleWindowScrollEvent();
    }
  });
}

function registerScrollListener(component, element) {
  if (!mountedInstances.some(function (instance) {
    return instance.props.scrollElement === element;
  })) {
    element.addEventListener('scroll', onScrollWindow);
  }

  mountedInstances.push(component);
}
function unregisterScrollListener(component, element) {
  mountedInstances = mountedInstances.filter(function (instance) {
    return instance !== component;
  });

  if (!mountedInstances.length) {
    element.removeEventListener('scroll', onScrollWindow);

    if (disablePointerEventsTimeoutId) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_requestAnimationTimeout__["a" /* cancelAnimationTimeout */])(disablePointerEventsTimeoutId);
      enablePointerEventsIfDisabled();
    }
  }
}


/***/ }),
/* 2235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDimensions;
/* harmony export (immutable) */ __webpack_exports__["b"] = getPositionOffset;
/* harmony export (immutable) */ __webpack_exports__["c"] = getScrollOffset;
/**
 * Gets the dimensions of the element, accounting for API differences between
 * `window` and other DOM elements.
 */
// TODO Move this into WindowScroller and import from there
var isWindow = function isWindow(element) {
  return element === window;
};

var getBoundingBox = function getBoundingBox(element) {
  return element.getBoundingClientRect();
};

function getDimensions(scrollElement, props) {
  if (!scrollElement) {
    return {
      height: props.serverHeight,
      width: props.serverWidth
    };
  } else if (isWindow(scrollElement)) {
    var _window = window,
        innerHeight = _window.innerHeight,
        innerWidth = _window.innerWidth;
    return {
      height: typeof innerHeight === 'number' ? innerHeight : 0,
      width: typeof innerWidth === 'number' ? innerWidth : 0
    };
  } else {
    return getBoundingBox(scrollElement);
  }
}
/**
 * Gets the vertical and horizontal position of an element within its scroll container.
 * Elements that have been “scrolled past” return negative values.
 * Handles edge-case where a user is navigating back (history) from an already-scrolled page.
 * In this case the body’s top or left position will be a negative number and this element’s top or left will be increased (by that amount).
 */

function getPositionOffset(element, container) {
  if (isWindow(container) && document.documentElement) {
    var containerElement = document.documentElement;
    var elementRect = getBoundingBox(element);
    var containerRect = getBoundingBox(containerElement);
    return {
      top: elementRect.top - containerRect.top,
      left: elementRect.left - containerRect.left
    };
  } else {
    var scrollOffset = getScrollOffset(container);

    var _elementRect = getBoundingBox(element);

    var _containerRect = getBoundingBox(container);

    return {
      top: _elementRect.top + scrollOffset.top - _containerRect.top,
      left: _elementRect.left + scrollOffset.left - _containerRect.left
    };
  }
}
/**
 * Gets the vertical and horizontal scroll amount of the element, accounting for IE compatibility
 * and API differences between `window` and other DOM elements.
 */

function getScrollOffset(element) {
  if (isWindow(element) && document.documentElement) {
    return {
      top: 'scrollY' in window ? window.scrollY : document.documentElement.scrollTop,
      left: 'scrollX' in window ? window.scrollX : document.documentElement.scrollLeft
    };
  } else {
    return {
      top: element.scrollTop,
      left: element.scrollLeft
    };
  }
}

/***/ }),
/* 2236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_lodash__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Panel__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_MessageBar__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_src_app_components_LoadingOverlay__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BulkRegistrationTable__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__BulkRegistrationStore__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__BulkRegistrationPanelBase__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__build_src_app_helpers_uploadTypes__ = __webpack_require__(302);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2,_descriptor,_descriptor2,_class3,_temp;function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var BulkRegistrationInventoryPanel=(_dec=Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__["d" /* inject */])('user','sale','inventory'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_7__build_src_app_components_Localization__["a" /* localizable */])(_class=(_class2=(_temp=_class3=function(_BulkRegistrationPane){_inherits(BulkRegistrationInventoryPanel,_BulkRegistrationPane);function BulkRegistrationInventoryPanel(props){_classCallCheck(this,BulkRegistrationInventoryPanel);var _this=_possibleConstructorReturn(this,(BulkRegistrationInventoryPanel.__proto__||Object.getPrototypeOf(BulkRegistrationInventoryPanel)).call(this,props));_initDefineProp(_this,'importing',_descriptor,_this);_initDefineProp(_this,'error',_descriptor2,_this);_this.handleImported=function(data){var config=_this.props.sale.root.saleConfig;_this.store.clear();__WEBPACK_IMPORTED_MODULE_3__build_node_modules_lodash___default.a.forEach(data,function(item){var _item={key:item.email,email:item.email,phone:item.phone,salutation:item.salutation,title:item.title,// "combobox" must be controlled component
firstName:item.first_name,lastName:item.last_name,offerViewing:'',dob:item.dob,pob:item.pob,street:(item.address||{}).street,zip:(item.address||{}).zip,city:(item.address||{}).city,country:(item.address||{}).state,requiredUploads:Object(__WEBPACK_IMPORTED_MODULE_11__build_src_app_helpers_uploadTypes__["a" /* getDefaultUploadTypes */])(config,_this.props.sale.offerData),integrations:item.integrations};_this.store.add(_item);});_this.editing=true;};var _this$props=_this.props,user=_this$props.user,sale=_this$props.sale,usedEmails=_this$props.usedEmails,t=_this$props.t;_this.store=new __WEBPACK_IMPORTED_MODULE_9__BulkRegistrationStore__["a" /* default */](user,sale,sale.round,usedEmails,t);return _this;}_createClass(BulkRegistrationInventoryPanel,[{key:'reset',value:function reset(){this.store.reset();this.importing=false;this.editing=false;this.error=null;}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var _props=this.props,sale=_props.sale,inventory=_props.inventory;var contacts=null;try{var inviteStr=sessionStorage.getItem('invite');if(!!inviteStr){contacts=JSON.parse(inviteStr).payload;sessionStorage.removeItem('invite');}}catch(e){}// this.store = new BulkRegistrationStore(
//   user,
//   sale,
//   sale.round,
//   usedEmails,
//   t
// );
this.reset();this.importing=true;inventory.listBuyers(sale.offerData.objectno,sale.root.saleId,contacts).then(function(data){_this2.importing=false;_this2.handleImported(data);},function(error){_this2.importing=false;_this2.error=error;});}},{key:'render',value:function render(){var _this3=this;var _props2=this.props,t=_props2.t,title=_props2.title,usedEmails=_props2.usedEmails;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Panel__["a" /* Panel */],{headerText:title,hasCloseButton:false,type:__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Panel__["b" /* PanelType */].smallFluid,isOpen:this.props.isOpen,onDismiss:this.handleClose,onRenderFooterContent:function onRenderFooterContent(){return _this3.renderPanelFooterContent();},isFooterAtBottom:true,closeButtonAriaLabel:'Close',styles:{content:{height:'100%',paddingBottom:'0'}}},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__["a" /* Observer */],{render:function render(){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_src_app_components_LoadingOverlay__["a" /* default */],{label:t('Importing')+'...',fullscreen:false,isVisible:_this3.importing}),!_this3.importing&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,_this3.errors&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row',style:{padding:'10px 0'}},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_MessageBar__["a" /* MessageBar */],{messageBarType:__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_MessageBar__["b" /* MessageBarType */].error},_this3.error)))),_this3.editing&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,_this3.renderRegistrationResult(),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__BulkRegistrationTable__["a" /* default */],{store:_this3.store,usedEmails:usedEmails}))));}}));}}]);return BulkRegistrationInventoryPanel;}(__WEBPACK_IMPORTED_MODULE_10__BulkRegistrationPanelBase__["a" /* default */]),_class3.displayName='BulkRegistrationInventoryPanel',_temp),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'importing',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,'error',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return null;}})),_class2))||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (BulkRegistrationInventoryPanel);

/***/ }),
/* 2237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_src_app_components_dynamicImport__ = __webpack_require__(62);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RefuseDialogContent=Object(__WEBPACK_IMPORTED_MODULE_3__build_src_app_components_dynamicImport__["b" /* default */])({component:'/containers/Sale/OffersSection/RefuseDialog'});var RefuseDialog=(_dec=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["d" /* inject */])('app'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_2__build_src_app_components_Localization__["a" /* localizable */])(_class=(_temp=_class2=function(_Component){_inherits(RefuseDialog,_Component);function RefuseDialog(){_classCallCheck(this,RefuseDialog);return _possibleConstructorReturn(this,(RefuseDialog.__proto__||Object.getPrototypeOf(RefuseDialog)).apply(this,arguments));}_createClass(RefuseDialog,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(RefuseDialogContent,this.props);}}]);return RefuseDialog;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class2.displayName='RefuseDialog',_temp))||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (RefuseDialog);

/***/ }),
/* 2238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
var DevLinkOffer=function DevLinkOffer(_ref){var item=_ref.item,user=_ref.user,app=_ref.app;var show=app.features&&app.features.offerLinks;if(!show){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',null);}var _window$location=window.location,protocol=_window$location.protocol,host=_window$location.host;var path=''+(item.buyer.buyer_locale?item.buyer.buyer_locale+'/':'')+item.saleId+'?sub='+item.buyerId;var tenant="propnow".startsWith('propnow')?user.claims.tenant||"propnow":"propnow";var url=protocol+'//'+host.replace(/^app/,tenant)+'/'+path;// console.log('test', url);
var _require=__webpack_require__(53),Link=_require.Link;var _require2=__webpack_require__(12),Icon=_require2.Icon;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(Link,{href:url,target:'_blank','data-test-id':'buyer-link','data-test-value':item.buyer.buyer_email},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(Icon,{iconName:'FieldNotChanged'}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["d" /* inject */])('user','app')(Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["e" /* observer */])(DevLinkOffer)));

/***/ }),
/* 2239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelfRegistrationApprovalDialog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_src_app_components_BuyerDocumentSelector__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Dialog__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_node_modules_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_node_modules_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__build_node_modules_office_ui_fabric_react__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__build_src_app_helpers_uploadTypes__ = __webpack_require__(302);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_dec2,_class,_desc,_value,_class2,_descriptor,_descriptor2,_descriptor3,_class3,_temp2;function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}// eslint-disable-next-line no-unused-vars
var SelfRegistrationApprovalDialog=(_dec=__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["j" /* observable */].shallow,_dec2=__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["j" /* observable */].shallow,Object(__WEBPACK_IMPORTED_MODULE_1__build_src_app_components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__["e" /* observer */])(_class=(_class2=(_temp2=_class3=function(_Component){_inherits(SelfRegistrationApprovalDialog,_Component);function SelfRegistrationApprovalDialog(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SelfRegistrationApprovalDialog);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SelfRegistrationApprovalDialog.__proto__||Object.getPrototypeOf(SelfRegistrationApprovalDialog)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'requiredUploads',_descriptor,_this),_initDefineProp(_this,'optionalUploads',_descriptor2,_this),_initDefineProp(_this,'paddleNumber',_descriptor3,_this),_this.handleSubmit=function(){var _this$props=_this.props,offer=_this$props.offer,onSubmit=_this$props.onSubmit;var _offer=Object.assign({},offer,{offerData:Object.assign({},offer.data,{required_uploads:_this.requiredUploads,optional_uploads:_this.optionalUploads// paddle_number: this.paddleNumber,
})});onSubmit(_offer);},_temp),_possibleConstructorReturn(_this,_ret);}// just keys
// just keys
_createClass(SelfRegistrationApprovalDialog,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var _props=this.props,offer=_props.offer,sale=_props.sale;var _config$requiredUploa=this.config.requiredUploadTypes,requiredUploadTypes=_config$requiredUploa===undefined?[]:_config$requiredUploa;var defaultUploadTypes=Object(__WEBPACK_IMPORTED_MODULE_9__build_src_app_helpers_uploadTypes__["a" /* getDefaultUploadTypes */])(this.config,sale.offerData);if(offer.data){if(offer.data.required_uploads)this.requiredUploads.replace(offer.data.required_uploads);if(offer.data.optional_uploads)this.optionalUploads.replace(offer.data.optional_uploads);}if(!this.requiredUploads.length){defaultUploadTypes.forEach(function(type){if(!_this2.requiredUploads.includes(type))_this2.requiredUploads.push(type);});}requiredUploadTypes.forEach(function(type){if(!_this2.requiredUploads.includes(type))_this2.requiredUploads.push(type);});}},{key:'render',value:function render(){var _props2=this.props,onClose=_props2.onClose,t=_props2.t;var _config=this.config,_config$uploadTypes=_config.uploadTypes,uploadTypes=_config$uploadTypes===undefined?[]:_config$uploadTypes,_config$requiredUploa2=_config.requiredUploadTypes,requiredUploadTypes=_config$requiredUploa2===undefined?[]:_config$requiredUploa2;var localizedUploadTypes=uploadTypes.map(function(key){return{key:key,text:t('uploadtype::'+key)};});return __WEBPACK_IMPORTED_MODULE_7__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Dialog__["a" /* Dialog */],{minWidth:600,hidden:false,onDismiss:onClose,dialogContentProps:{type:__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Dialog__["c" /* DialogType */].largeHeader,title:t('Approve Registration')},modalProps:{isBlocking:true,containerClassName:'ms-dialogMainOverride'}},__WEBPACK_IMPORTED_MODULE_7__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid'},__WEBPACK_IMPORTED_MODULE_7__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_7__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-lg12 ms-md12 ms-sm12'},__WEBPACK_IMPORTED_MODULE_7__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_src_app_components_BuyerDocumentSelector__["a" /* BuyerDocumentSelector */],{label:t('Documents'),options:localizedUploadTypes,required:this.requiredUploads// optional={this.optionalUploads}
,disabled:requiredUploadTypes})))),__WEBPACK_IMPORTED_MODULE_7__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Dialog__["b" /* DialogFooter */],null,__WEBPACK_IMPORTED_MODULE_7__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Button__["h" /* PrimaryButton */],{onClick:this.handleSubmit,text:t('Approve')}),__WEBPACK_IMPORTED_MODULE_7__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Button__["f" /* DefaultButton */],{onClick:onClose,text:t('Cancel')})));}},{key:'config',get:function get(){var sale=this.props.sale;return sale.root.saleConfig;}}]);return SelfRegistrationApprovalDialog;}(__WEBPACK_IMPORTED_MODULE_7__build_node_modules_react__["Component"]),_class3.displayName='SelfRegistrationApprovalDialog',_class3.propTypes={sale:__WEBPACK_IMPORTED_MODULE_6__build_node_modules_prop_types___default.a.object.isRequired,onSubmit:__WEBPACK_IMPORTED_MODULE_6__build_node_modules_prop_types___default.a.func,onClose:__WEBPACK_IMPORTED_MODULE_6__build_node_modules_prop_types___default.a.func},_temp2),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'requiredUploads',[_dec],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,'optionalUploads',[_dec2],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor3=_applyDecoratedDescriptor(_class2.prototype,'paddleNumber',[__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return'';}})),_class2))||_class)||_class);

/***/ }),
/* 2240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Panel__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_PanelFooter__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__OfferNotificationsList__ = __webpack_require__(2241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__stores_OfferNotificationStore__ = __webpack_require__(2243);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OfferNotificationsPanel=(_dec=Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__["d" /* inject */])('user'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_5__components_Localization__["a" /* localizable */])(_class=(_temp=_class2=function(_Component){_inherits(OfferNotificationsPanel,_Component);function OfferNotificationsPanel(props){_classCallCheck(this,OfferNotificationsPanel);var _this=_possibleConstructorReturn(this,(OfferNotificationsPanel.__proto__||Object.getPrototypeOf(OfferNotificationsPanel)).call(this,props));_this.handleRefresh=function(){_this.store.load();};_this.handleClose=function(){var onClose=_this.props.onClose;if(onClose){onClose();}};_this.renderPanelFooterContent=function(){var t=_this.props.t;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_PanelFooter__["a" /* FooterContainer */],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Button__["f" /* DefaultButton */],{onClick:_this.handleRefresh},t('Refresh')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Button__["h" /* PrimaryButton */],{onClick:_this.handleClose},t('Close')));};_this.store=new __WEBPACK_IMPORTED_MODULE_8__stores_OfferNotificationStore__["a" /* default */](props.user,props.offer);return _this;}_createClass(OfferNotificationsPanel,[{key:'componentDidMount',value:function componentDidMount(){this.store.load();}},{key:'render',value:function render(){var _this2=this;var _props=this.props,t=_props.t,offer=_props.offer;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Panel__["a" /* Panel */],{headerText:t('Notifications')+': '+offer.buyer.buyer_lastName+', '+offer.buyer.buyer_firstName,type:__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Panel__["b" /* PanelType */].large,isOpen:this.props.isOpen,onDismiss:this.handleClose,onRenderFooterContent:function onRenderFooterContent(){return _this2.renderPanelFooterContent();},isFooterAtBottom:true,closeButtonAriaLabel:'Close'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__OfferNotificationsList__["a" /* default */],{store:this.store})));}}]);return OfferNotificationsPanel;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class2.displayName='OfferNotificationsPanel',_class2.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1__build_node_modules_prop_types___default.a.bool,onClose:__WEBPACK_IMPORTED_MODULE_1__build_node_modules_prop_types___default.a.func},_class2.defaultProps={isOpen:false},_temp))||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (OfferNotificationsPanel);

/***/ }),
/* 2241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_DetailsList__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_LoadingOverlay__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OfferNotificationDetails__ = __webpack_require__(2242);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var columns=function columns(t){return[{key:'created',name:t('Created On'),fieldName:'createdAt',columnActionsMode:null,minWidth:200,maxWidth:200,isSorted:true,isSortedDescending:true},{key:'recipient',name:t('Recipient'),fieldName:'recipient',columnActionsMode:null,minWidth:200,isSorted:false,isSortedDescending:false},{key:'template',name:t('Template'),fieldName:'template',columnActionsMode:null,minWidth:200,isSorted:false,isSortedDescending:false},{key:'status',name:t('Status'),fieldName:'status',columnActionsMode:null,minWidth:100,isSorted:false,isSortedDescending:false},{key:'updated',name:t('Updated On'),fieldName:'updatedAt',columnActionsMode:null,minWidth:200,maxWidth:200,isSorted:false,isSortedDescending:false},{key:'serviceStatus',name:t('Service Status'),fieldName:'serviceResponse',columnActionsMode:null,minWidth:200,isSorted:false,isSortedDescending:false}];};var OfferNotificationsList=Object(__WEBPACK_IMPORTED_MODULE_3__components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["e" /* observer */])(_class=(_temp2=_class2=function(_Component){_inherits(OfferNotificationsList,_Component);function OfferNotificationsList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,OfferNotificationsList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=OfferNotificationsList.__proto__||Object.getPrototypeOf(OfferNotificationsList)).call.apply(_ref,[this].concat(args))),_this),_this.handleRenderItemColumn=function(item,index,column){var t=_this.props.t;var content=item[column.fieldName];switch(column.key){case'template':var canonical=content.replace(/^(open|sealed|registration)_/,'').replace(/^(cust_round_closing)_.*$/,'$1').toLowerCase();return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',null,t('notificationemailtemplate::'+canonical));case'status':return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',null,t('notificationservicestatus::'+content.toLowerCase()));case'created':case'updated':return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',null,content&&content.toFormattedDateTimeString());case'serviceStatus':return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',null,content,content&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__OfferNotificationDetails__["a" /* default */],{item:item}));default:return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',null,content);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(OfferNotificationsList,[{key:'render',value:function render(){var _props=this.props,t=_props.t,store=_props.store;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_LoadingOverlay__["a" /* default */],{label:t('Loading')+'...',fullscreen:true,isVisible:store.fetching}),!store.fetching&&store.succeeded&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_DetailsList__["b" /* DetailsList */],{columns:columns(t),items:store.list,onRenderItemColumn:this.handleRenderItemColumn,selectionMode:0,checkboxVisibility:0,layoutMode:__WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_DetailsList__["c" /* DetailsListLayoutMode */].justified}),!store.fetching&&store.failed&&t('Error loading'));}}]);return OfferNotificationsList;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class2.displayName='OfferNotificationsList',_temp2))||_class)||_class;/* harmony default export */ __webpack_exports__["a"] = (OfferNotificationsList);

/***/ }),
/* 2242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OfferNotificationDetails; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Dialog__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Icon__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_Link__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Localization__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_desc,_value,_class2,_descriptor,_class3,_temp2;function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var OfferNotificationDetails=Object(__WEBPACK_IMPORTED_MODULE_7__components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["e" /* observer */])(_class=(_class2=(_temp2=_class3=function(_Component){_inherits(OfferNotificationDetails,_Component);function OfferNotificationDetails(){var _ref;var _temp,_this,_ret;_classCallCheck(this,OfferNotificationDetails);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=OfferNotificationDetails.__proto__||Object.getPrototypeOf(OfferNotificationDetails)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'isOpen',_descriptor,_this),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(OfferNotificationDetails,[{key:'render',value:function render(){var _this2=this;var _props=this.props,t=_props.t,item=_props.item;var open=function open(){return _this2.isOpen=true;};var close=function close(){return _this2.isOpen=false;};return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',null,'\xA0\xA0',__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_Link__["Link"],{onClick:open},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Icon__["Icon"],{iconName:'Zoom'})),this.isOpen&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Dialog__["a" /* Dialog */],{hidden:false,dialogContentProps:{type:__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Dialog__["c" /* DialogType */].largeHeader,onDismiss:close,title:t('Service Data')},modalProps:{isBlocking:true,containerClassName:'ms-dialogMainOverride ms-dialogWideOverride'}},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('pre',null,item.serviceData)),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Dialog__["b" /* DialogFooter */],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Button__["h" /* PrimaryButton */],{onClick:close,text:t('Close')}))));}}]);return OfferNotificationDetails;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class3.displayName='OfferNotificationDetails',_temp2),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'isOpen',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}})),_class2))||_class)||_class;

/***/ }),
/* 2243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OfferNotificationStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_request__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_dec2,_desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4;function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var OfferNotificationStore=(_dec=__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["c" /* action */].bound,_dec2=__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["c" /* action */].bound,(_class=function(){function OfferNotificationStore(user,offer){_classCallCheck(this,OfferNotificationStore);_initDefineProp(this,'list',_descriptor,this);_initDefineProp(this,'fetching',_descriptor2,this);_initDefineProp(this,'succeeded',_descriptor3,this);_initDefineProp(this,'failed',_descriptor4,this);this.user=user;this.offer=offer;}_createClass(OfferNotificationStore,[{key:'load',value:function load(){this.fetching=true;this.succeeded=false;this.failed=false;Object(__WEBPACK_IMPORTED_MODULE_1__services_request__["d" /* get */])('/api/v1/notifications/'+this.offer.saleId+'/'+this.offer.buyerId,this.user.accessToken).then(this.success,this.error);}},{key:'success',value:function success(data){this.list=data;this.fetching=false;this.succeeded=true;this.failed=false;}},{key:'error',value:function error(_error){this.fetching=false;this.succeeded=false;this.failed=true;}}]);return OfferNotificationStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'list',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'fetching',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'succeeded',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'failed',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_applyDecoratedDescriptor(_class.prototype,'load',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'load'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'success',[_dec],Object.getOwnPropertyDescriptor(_class.prototype,'success'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'error',[_dec2],Object.getOwnPropertyDescriptor(_class.prototype,'error'),_class.prototype)),_class));

/***/ }),
/* 2244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuctionFinalsPanel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Panel__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_Spinner__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__build_src_app_components_LoadingOverlay__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__build_src_app_components_PanelFooter__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__stores__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components__ = __webpack_require__(211);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_desc,_value,_class2,_descriptor,_descriptor2,_descriptor3,_descriptor4,_class3,_temp;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var AuctionFinalsPanel=Object(__WEBPACK_IMPORTED_MODULE_8__build_src_app_components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__["e" /* observer */])(_class=(_class2=(_temp=_class3=function(_Component){_inherits(AuctionFinalsPanel,_Component);// = new AbortController()
function AuctionFinalsPanel(props){var _this2=this;_classCallCheck(this,AuctionFinalsPanel);var _this=_possibleConstructorReturn(this,(AuctionFinalsPanel.__proto__||Object.getPrototypeOf(AuctionFinalsPanel)).call(this,props));_initDefineProp(_this,'phase',_descriptor,_this);_initDefineProp(_this,'loading',_descriptor2,_this);_initDefineProp(_this,'loaded',_descriptor3,_this);_initDefineProp(_this,'error',_descriptor4,_this);_this.store=null;_this.load=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.abortController=typeof window.AbortController!=='undefined'?new window.AbortController():null;_this.loaded=false;_this.loading=true;_this.error=false;_context.prev=4;_context.next=7;return _this.store.load(_this.abortController?_this.abortController.signal:null);case 7:_this.loading=false;_this.loaded=true;_this.abortController=null;_context.next=18;break;case 12:_context.prev=12;_context.t0=_context['catch'](4);console.error(_context.t0);_this.loading=false;_this.error=true;_this.abortController=null;case 18:case'end':return _context.stop();}}},_callee,_this2,[[4,12]]);}));_this.abort=function(){if(_this.abortController)_this.abortController.abort();_this.abortController=null;};_this.handleCancel=function(){_this.abort();_this.phase='results';};_this.handleClose=function(){_this.abort();var onClose=_this.props.onClose;if(onClose){onClose();}};_this.handleSetPhase=function(phase){return function(){_this.phase=phase;_this.error=false;};};_this.handleBackFromResults=function(){// remove awarded offers from selection
_this.store.removeAwarded();_this.phase='review';};_this.handleAward=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_this.abortController=typeof window.AbortController!=='undefined'?new window.AbortController():null;_this.phase='awarding';_this.error=false;_context2.prev=3;_context2.next=6;return _this.store.award(_this.abortController?_this.abortController.signal:null);case 6:_this.phase='results';_context2.next=13;break;case 9:_context2.prev=9;_context2.t0=_context2['catch'](3);console.error(_context2.t0);_this.error=true;case 13:case'end':return _context2.stop();}}},_callee2,_this2,[[3,9]]);}));_this.store=new __WEBPACK_IMPORTED_MODULE_10__stores__["a" /* AuctionFinalsStore */](props.sale);// sale = SaleStore
return _this;}// AuctionFinalsStore
// select, review, awarding, results
_createClass(AuctionFinalsPanel,[{key:'componentDidMount',value:function componentDidMount(){this.load();}},{key:'render',value:function render(){var _this3=this;var _props=this.props,sale=_props.sale,t=_props.t;var _store=this.store,selected=_store.selected,processed=_store.processed,results=_store.results;return __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Panel__["a" /* Panel */],{type:__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Panel__["b" /* PanelType */].smallFluid,isOpen:true,onDismiss:this.handleClose,isFooterAtBottom:true,headerText:this.phase==='select'?t('Select winners'):this.phase==='review'?t('Review winners'):t('Report'),onRenderFooterContent:function onRenderFooterContent(){return __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__["a" /* Observer */],{render:function render(){return __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'space-between',alignItems:'center'}},(_this3.phase==='select'||_this3.phase==='review')&&_this3.loaded&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('strong',null,__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components__["c" /* AuctionFinalsTotals */],{store:_this3.store,locale:sale.saleEdit.locale,currency:sale.saleEdit.currencyCode})),(_this3.phase==='awarding'||_this3.phase==='results')&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('strong',null,t('Succeeded'),': ',results.succeeded.length,', ',t('Failed'),':',results.failed.length),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__build_src_app_components_PanelFooter__["a" /* FooterContainer */],null,_this3.phase==='select'&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Button__["f" /* DefaultButton */],{onClick:_this3.handleClose},t('Close')),_this3.loaded&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Button__["h" /* PrimaryButton */],{onClick:_this3.handleSetPhase('review'),disabled:_this3.store.selectedCount===0},t('Continue'))),_this3.phase==='review'&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Button__["f" /* DefaultButton */],{onClick:_this3.handleSetPhase('select')},t('Back')),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Button__["f" /* DefaultButton */],{onClick:_this3.handleClose},t('Close')),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Button__["h" /* PrimaryButton */],{onClick:_this3.handleAward,disabled:_this3.store.selectedCount===0},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__["Fragment"],null,t('Confirm')))),_this3.phase==='awarding'&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Button__["f" /* DefaultButton */],{onClick:_this3.handleCancel},t('Cancel')),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Button__["h" /* PrimaryButton */],{disabled:true},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__["Fragment"],null,t('Confirm'),' ('+(processed+1)+' / '+selected+')',__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_Spinner__["a" /* Spinner */],{size:__WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_Spinner__["b" /* SpinnerSize */].xSmall,style:{paddingLeft:'10px'}})))),_this3.phase==='results'&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Button__["f" /* DefaultButton */],{onClick:_this3.handleBackFromResults},t('Back')),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Button__["f" /* DefaultButton */],{onClick:_this3.handleClose},t('Close')))));}});},closeButtonAriaLabel:'Close'},this.phase==='select'&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__["Fragment"],null,this.loaded&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{style:{width:'calc(100% - 80)'}},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__["a" /* Observer */],{render:function render(){return __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components__["b" /* AuctionFinalsMatrix */],{sale:sale,store:_this3.store,locale:sale.saleEdit.locale,currency:sale.saleEdit.currencyCode}));}})),!this.loaded&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__["Fragment"],null,this.loading&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__build_src_app_components_LoadingOverlay__["a" /* default */],null),this.error&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{style:{marginTop:'50vh',textAlign:'center',color:'Red'}},t('Error loading data from server')))),this.phase!=='select'&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components__["a" /* AuctionFinalsList */],{sale:sale,store:this.store,locale:sale.saleEdit.locale,currency:sale.saleEdit.currencyCode,showResults:this.phase==='awarding'||this.phase==='results'}));}}]);return AuctionFinalsPanel;}(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__["Component"]),_class3.displayName='AuctionFinalsPanel',_temp),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'phase',[__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return'select';}}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,'loading',[__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor3=_applyDecoratedDescriptor(_class2.prototype,'loaded',[__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor4=_applyDecoratedDescriptor(_class2.prototype,'error',[__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}})),_class2))||_class)||_class;

/***/ }),
/* 2245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return OpenRoundConfirmation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_src_app_components_dynamicImport__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OpenRoundConfirmation__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Prompts__ = __webpack_require__(2246);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Prompts__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__Prompts__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BlockUser__ = __webpack_require__(2247);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__BlockUser__["a"]; });
var OpenRoundConfirmation=Object(__WEBPACK_IMPORTED_MODULE_0__build_src_app_components_dynamicImport__["b" /* default */])({component:'/containers/Sale/Prompts/OpenRoundConfirmation',fallback:__WEBPACK_IMPORTED_MODULE_1__OpenRoundConfirmation__["a" /* default */]});

/***/ }),
/* 2246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UploadOfferConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GenericPrompt; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_src_app_components_Prompt__ = __webpack_require__(208);
var UploadOfferConfirmation=function UploadOfferConfirmation(_ref){var sale=_ref.sale,t=_ref.t;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_src_app_components_Prompt__["a" /* default */],Object.assign({},sale.ui.prompt,{opened:sale.ui.prompt.opened}),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',null,t('You are about to upload offer in the name of customer')),sale.offers.isOfferSelected&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{style:{paddingTop:'5px'}},t('All information entered by customer will be overwritten')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{style:{paddingTop:'5px'}},t('Would you like to continue?')));};var GenericPrompt=function GenericPrompt(_ref2){var sale=_ref2.sale;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_src_app_components_Prompt__["a" /* default */],Object.assign({},sale.ui.prompt,{opened:sale.ui.prompt.opened}));};

/***/ }),
/* 2247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BlockUser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_src_app_components_Prompt__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_TextField__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_desc,_value,_class2,_descriptor,_class3,_temp2;function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var BlockUser=Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__["e" /* observer */])(_class=(_class2=(_temp2=_class3=function(_Component){_inherits(BlockUser,_Component);function BlockUser(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BlockUser);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BlockUser.__proto__||Object.getPrototypeOf(BlockUser)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'reason',_descriptor,_this),_this.handleChanged=function(field){return function(value){_this[field]=value;};},_this.handleSubmit=function(){var sale=_this.props.sale;if(sale.ui.prompt.onSubmit){sale.ui.prompt.onSubmit({reason:_this.reason});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BlockUser,[{key:'render',value:function render(){var _props=this.props,sale=_props.sale,t=_props.t;return __WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_src_app_components_Prompt__["a" /* default */],Object.assign({},sale.ui.prompt,{opened:sale.ui.prompt.opened,onSubmit:this.handleSubmit,disablePrimaryButton:!this.isValid}),__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_TextField__["a" /* TextField */],{label:t('Reason'),multiline:true,name:'reason',value:this.reason,onChanged:this.handleChanged('reason'),required:true})));}},{key:'isValid',get:function get(){return this.reason&&this.reason!=='';}}]);return BlockUser;}(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react__["Component"]),_class3.displayName='BlockUser',_temp2),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'reason',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return'';}}),_applyDecoratedDescriptor(_class2.prototype,'isValid',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class2.prototype,'isValid'),_class2.prototype)),_class2))||_class;

/***/ }),
/* 2248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RoundSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RoundPanel__ = __webpack_require__(2249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RoundInfo__ = __webpack_require__(2250);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__RoundInfo__["a"]; });
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RoundSection=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["e" /* observer */])(_class=(_temp2=_class2=function(_Component){_inherits(RoundSection,_Component);function RoundSection(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RoundSection);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RoundSection.__proto__||Object.getPrototypeOf(RoundSection)).call.apply(_ref,[this].concat(args))),_this),_this.handleSaveRound=function(roundDefinition){var _this$props=_this.props,ui=_this$props.ui,store=_this$props.store,mode=_this$props.store.mode;switch(mode){case'new':store.start(roundDefinition);break;case'edit':store.edit(roundDefinition);break;default:break;}ui.closePanel();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RoundSection,[{key:'render',value:function render(){var _props=this.props,ui=_props.ui,store=_props.store,_props$store=_props.store,round=_props$store.definition,mode=_props$store.mode;if(!round.isEnabled){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',null);}return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__RoundPanel__["a" /* default */],{isOpen:true,mode:mode,round:round,offerData:store.root.saleEdit.offerData,canChangeType:store.canChangeType,onSave:this.handleSaveRound,onClose:function onClose(){return ui.closePanel();}});}}]);return RoundSection;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class2.displayName='RoundSection',_class2.propTypes={ui:__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["b" /* PropTypes */].observableObject,store:__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["b" /* PropTypes */].observableObject},_temp2))||_class;

/***/ }),
/* 2249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Panel__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_src_app_components_PanelFooter__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RoundEdit__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__stores_RoundEditStore__ = __webpack_require__(473);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2,_class3,_temp2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}// Modal Panel with RoundEdit component inside
var RoundPanel=(_dec=Object(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx_react__["d" /* inject */])('app','sale'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_5__build_src_app_components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx_react__["e" /* observer */])(_class=(_class2=(_temp2=_class3=function(_Component){_inherits(RoundPanel,_Component);function RoundPanel(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RoundPanel);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RoundPanel.__proto__||Object.getPrototypeOf(RoundPanel)).call.apply(_ref,[this].concat(args))),_this),_this.store=null,_this.handleSave=function(){var onSave=_this.props.onSave;if(!onSave)return;onSave(_this.store.saveableRound);},_this.handleClose=function(){var onClose=_this.props.onClose;if(onClose)onClose();},_this.renderPanelFooterContent=function(){var t=_this.props.t;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx_react__["a" /* Observer */],{render:function render(){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_src_app_components_PanelFooter__["b" /* default */],{saveBtnLabel:t('Save'),closeBtnLabel:t('Cancel'),saveDisabled:!_this.isValid,onSave:_this.handleSave,onClose:_this.handleClose});}});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RoundPanel,[{key:'componentWillMount',// RoundEditStore
value:function componentWillMount(){var _props=this.props,round=_props.round,sale=_props.sale;this.store=new __WEBPACK_IMPORTED_MODULE_8__stores_RoundEditStore__["a" /* default */](round,sale.saleConfig,sale.saleEdit.offerData.timezone);}},{key:'render',value:function render(){var _props2=this.props,intl=_props2.intl,t=_props2.t;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Panel__["a" /* Panel */],{headerText:t('Round'),type:__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Panel__["b" /* PanelType */].medium,isOpen:this.props.isOpen,onDismissed:this.handleClose,onRenderFooterContent:this.renderPanelFooterContent,isFooterAtBottom:true,closeButtonAriaLabel:t('Close')},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__RoundEdit__["a" /* default */],{store:this.store,intl:intl}));}},{key:'isValid',get:function get(){return this.store.isValid;}}]);return RoundPanel;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class3.displayName='RoundPanel',_class3.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1__build_node_modules_prop_types___default.a.bool,onSave:__WEBPACK_IMPORTED_MODULE_1__build_node_modules_prop_types___default.a.func,onClose:__WEBPACK_IMPORTED_MODULE_1__build_node_modules_prop_types___default.a.func},_class3.defaultProps={isOpen:false},_temp2),(_applyDecoratedDescriptor(_class2.prototype,'isValid',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class2.prototype,'isValid'),_class2.prototype)),_class2))||_class)||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (RoundPanel);

/***/ }),
/* 2250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_styled_components__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_moment_timezone__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Callout__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_src_app_components_RoundDateDisplay__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__build_src_app_components_Localization__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_desc,_value,_class2,_descriptor,_class3,_temp2;var _templateObject=_taggedTemplateLiteral(['\n  padding: 1em;\n  @media screen and (max-width: 479px) {\n    left: 0 !important;\n    width: 100%;\n  }\n'],['\n  padding: 1em;\n  @media screen and (max-width: 479px) {\n    left: 0 !important;\n    width: 100%;\n  }\n']);function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var config={started:{color:'#666666',icon:'Stop'},opened:{color:'#107c10',icon:'Play'},closed:{color:'#ffb900',icon:'StatusCircleCheckmark'}};var RoundCallout=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_styled_components__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Callout__["a" /* Callout */])(_templateObject);function getRoundType(_ref){var type=_ref.type,enableFlexibleBidding=_ref.enableFlexibleBidding;switch(type){case'incremental_auction':return enableFlexibleBidding?'incremental_auction':'open_bidding';default:return type;}}var RoundInfo=Object(__WEBPACK_IMPORTED_MODULE_7__build_src_app_components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_mobx_react__["e" /* observer */])(_class=(_class2=(_temp2=_class3=function(_Component){_inherits(RoundInfo,_Component);function RoundInfo(){var _ref2;var _temp,_this,_ret;_classCallCheck(this,RoundInfo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=RoundInfo.__proto__||Object.getPrototypeOf(RoundInfo)).call.apply(_ref2,[this].concat(args))),_this),_initDefineProp(_this,'calloutVisible',_descriptor,_this),_this.handleCalloutToggle=Object(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["c" /* action */])(function(){_this.calloutVisible=!_this.calloutVisible;}),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RoundInfo,[{key:'render',value:function render(){var _this2=this;var _props=this.props,round=_props.round,t=_props.t;if(round.status==='notStarted'){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',null);}var data=Object.assign({},round,{status:round.status||'',type:getRoundType(round),isPreview:!!round.startsAt&&__WEBPACK_IMPORTED_MODULE_2__build_node_modules_moment_timezone___default()(round.startsAt).isAfter(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_moment_timezone___default()()),startDuration:!!round.startsAt?__WEBPACK_IMPORTED_MODULE_2__build_node_modules_moment_timezone___default.a.duration(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_moment_timezone___default()(round.startsAt).diff(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_moment_timezone___default()())).humanize(true):'',isPast:__WEBPACK_IMPORTED_MODULE_2__build_node_modules_moment_timezone___default()(round.endsAt).isBefore(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_moment_timezone___default()()),hasEnd:!!round.endsAt||!!round.durationInDays,endDuration:round.durationType==='fixed'?__WEBPACK_IMPORTED_MODULE_2__build_node_modules_moment_timezone___default.a.duration(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_moment_timezone___default()().diff(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_moment_timezone___default()(round.endsAt))).humanize():'',endText:round.durationType==='fixed'?__WEBPACK_IMPORTED_MODULE_2__build_node_modules_moment_timezone___default()(round.endsAt).format('ddd ll LT'):''});return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'label',style:{borderRadius:'1em',background:config[round.status].color,cursor:'pointer'},ref:function ref(element){return _this2.labelElement=element;},onClick:this.handleCalloutToggle},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('i',{className:'ms-Icon ms-Icon--'+config[round.status].icon,'aria-hidden':'true'}),t('label',data)),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(RoundCallout,{role:'alertdialog',gapSpace:0,target:this.labelElement,onDismiss:this.handleCalloutToggle,setInitialFocus:true,hidden:!this.calloutVisible},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'ms-font-l ms-fontWeight-semibold',style:{color:'#003da5'}},t('roundtype::'+round.type),' (',t('Round'),' ',round.number,')'),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',null,t('Status'),': ',t('roundstatus::'+round.status)),round.startsAt&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,t('Starts'),':',' ',round.startsAt.toFormatedDateString('ddd ll / HH:mm'),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('br',null)),t('Ends'),':',' ',__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_src_app_components_RoundDateDisplay__["a" /* default */],{end:round.endsAt,duration:round.durationInDays,format:'ddd ll / LT'}),(!!round.offerValidityUntil||!!round.offerValidityInDays)&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('br',null),t('Offer validity'),':',' ',__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_src_app_components_RoundDateDisplay__["a" /* default */],{end:round.offerValidityUntil,duration:round.offerValidityInDays,format:'ddd ll / LT'})))));}}]);return RoundInfo;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class3.displayName='RoundInfo',_temp2),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'calloutVisible',[__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}})),_class2))||_class)||_class;/* harmony default export */ __webpack_exports__["a"] = (RoundInfo);

/***/ }),
/* 2251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SaleEditSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EditPanel__ = __webpack_require__(2252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_OfferPreview__ = __webpack_require__(858);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_desc,_value,_class2,_descriptor,_class3,_temp2;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var SaleEditSection=Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__["e" /* observer */])(_class=(_class2=(_temp2=_class3=function(_Component){_inherits(SaleEditSection,_Component);function SaleEditSection(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,SaleEditSection);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SaleEditSection.__proto__||Object.getPrototypeOf(SaleEditSection)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'page',_descriptor,_this),_this.handleSaveValues=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(data){var store;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:store=_this.props.store;_context.next=3;return store.update(data);case 3:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}(),_this.handleUpload=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(file){var store;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:store=_this.props.store;_context2.next=3;return store.upload(file);case 3:return _context2.abrupt('return',_context2.sent);case 4:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref3.apply(this,arguments);};}(),_this.handleDelete=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3(file){var store;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:store=_this.props.store;_context3.next=3;return store.remove(file);case 3:return _context3.abrupt('return',_context3.sent);case 4:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x3){return _ref4.apply(this,arguments);};}(),_this.handleSaveDocs=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee4(data){var store;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:store=_this.props.store;_context4.next=3;return store.updateDocs(data);case 3:case'end':return _context4.stop();}}},_callee4,_this2);}));return function(_x4){return _ref5.apply(this,arguments);};}(),_this.handleCancel=function(){_this.props.ui.closePanel();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SaleEditSection,[{key:'render',value:function render(){var _props=this.props,ui=_props.ui,_props$store=_props.store,offerData=_props$store.offerData,docs=_props$store.docs,root=_props$store.root;var _root$round=root.round,isStarted=_root$round.isStarted,isOpen=_root$round.isOpen;return __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',null,ui.currentPanel==='saleEdit'&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__EditPanel__["a" /* default */],{isRoundStarted:isStarted||isOpen,offerData:Object.assign({},offerData),docs:docs,saveValues:this.handleSaveValues,saveDocs:this.handleSaveDocs,uploadDoc:this.handleUpload,deleteDoc:this.handleDelete,cancel:this.handleCancel,config:root.saleConfig}),ui.currentPanel==='salePreview'&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_OfferPreview__["a" /* default */],{closePanel:function closePanel(){return ui.closePanel();},url:'/api/v1/sales/'+root.saleId+'/preview?locale='+root.user.claims.locale}));}}]);return SaleEditSection;}(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__["Component"]),_class3.displayName='SaleEditSection',_temp2),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'page',[__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return 1;}})),_class2))||_class;

/***/ }),
/* 2252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditPanel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_src_app_components_PanelFooter__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_lodash__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_Panel__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Page1__ = __webpack_require__(2253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Page2__ = __webpack_require__(2254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Page3__ = __webpack_require__(995);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2,_descriptor,_class3,_temp2;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var SaleEditStore=__webpack_require__(203).default;var EditPanel=(_dec=Object(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx_react__["d" /* inject */])('user','app','sale'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_1__build_src_app_components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx_react__["e" /* observer */])(_class=(_class2=(_temp2=_class3=function(_Component){_inherits(EditPanel,_Component);function EditPanel(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,EditPanel);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=EditPanel.__proto__||Object.getPrototypeOf(EditPanel)).call.apply(_ref,[this].concat(args))),_this),_this.store=null,_initDefineProp(_this,'page',_descriptor,_this),_this.handleSave=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(){var _this$props,saveValues,saveDocs,config;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this$props=_this.props,saveValues=_this$props.saveValues,saveDocs=_this$props.saveDocs;config=_this.props.sale.saleConfig;if(!(_this.page===config.saleEditTotalPages&&!!config.saleEditDocs)){_context.next=7;break;}_context.next=5;return saveDocs({docs:_this.docs});case 5:_context.next=9;break;case 7:_context.next=9;return saveValues({offerData:_this.offerData});case 9:case'end':return _context.stop();}}},_callee,_this2);})),_this.handleCancel=function(){var cancel=_this.props.cancel;if(cancel){cancel();}},_this.handlePageStep=function(step){return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.handleSave();case 2:_this.page=_this.page+step;case 3:case'end':return _context2.stop();}}},_callee2,_this2);}));},_this.handleSaveAndCancel=function(){_this.handleSave();_this.handleCancel();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(EditPanel,[{key:'componentWillMount',value:function componentWillMount(){var _props=this.props,user=_props.user,app=_props.app,offerData=_props.offerData,docs=_props.docs;this.store=typeof SaleEditStore.create==='function'?SaleEditStore.create(user,offerData,app.data):new SaleEditStore(user);// backward compatibility
this.store.initialize(offerData,docs);}},{key:'render',value:function render(){var _this3=this;var _props2=this.props,t=_props2.t,uploadDoc=_props2.uploadDoc,deleteDoc=_props2.deleteDoc,app=_props2.app,config=_props2.config;var readonly=app.features.saleReadOnly;return __WEBPACK_IMPORTED_MODULE_8__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_Panel__["a" /* Panel */],{headerText:t('Edit offer form'),type:__WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_Panel__["b" /* PanelType */].medium,onDismiss:this.handleCancel,isOpen:true,isFooterAtBottom:true,closeButtonAriaLabel:'Close',onRenderFooterContent:function onRenderFooterContent(){return __WEBPACK_IMPORTED_MODULE_8__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_mobx_react__["a" /* Observer */],{render:function render(){return __WEBPACK_IMPORTED_MODULE_8__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__build_src_app_components_PanelFooter__["a" /* FooterContainer */],null,_this3.page>1&&__WEBPACK_IMPORTED_MODULE_8__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_Button__["f" /* DefaultButton */],{text:t('Previous'),onClick:_this3.handlePageStep(-1)}),_this3.page<_this3.props.sale.saleConfig.saleEditTotalPages&&__WEBPACK_IMPORTED_MODULE_8__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_Button__["h" /* PrimaryButton */],{disabled:!_this3.canSave,text:t('Next'),onClick:_this3.handlePageStep(+1)}),!readonly&&_this3.page<_this3.props.sale.saleConfig.saleEditTotalPages&&__WEBPACK_IMPORTED_MODULE_8__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_Button__["f" /* DefaultButton */],{disabled:!_this3.canSave,text:t('Save'),onClick:_this3.handleSaveAndCancel}),!readonly&&_this3.page>=_this3.props.sale.saleConfig.saleEditTotalPages&&__WEBPACK_IMPORTED_MODULE_8__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_Button__["h" /* PrimaryButton */],{disabled:!_this3.canSave,text:t('Save'),onClick:_this3.handleSaveAndCancel}),__WEBPACK_IMPORTED_MODULE_8__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_Button__["f" /* DefaultButton */],{text:t('Cancel'),onClick:_this3.handleCancel}));}});}},this.page===1&&__WEBPACK_IMPORTED_MODULE_8__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Page1__["a" /* default */],{sale:this.store,offerData:this.offerData,isRoundStarted:this.props.isRoundStarted,config:config}),this.page===2&&__WEBPACK_IMPORTED_MODULE_8__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Page2__["a" /* default */],{isRoundStarted:this.props.isRoundStarted,sale:this.store,offerData:this.offerData,docs:this.docs,documentTypes:this.props.sale.saleConfig.documentTypes,uploadDoc:uploadDoc,deleteDoc:deleteDoc,config:config}),this.page===3&&__WEBPACK_IMPORTED_MODULE_8__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Page3__["a" /* default */],{sale:this.store,offerData:this.offerData,docs:this.docs,documentTypes:this.props.sale.saleConfig.documentTypes,uploadDoc:uploadDoc,deleteDoc:deleteDoc,config:config}));}},{key:'offerData',get:function get(){return this.store.offerData;}},{key:'docs',get:function get(){return this.store.docs;}},{key:'isPage1Valid',get:function get(){return this.store.isPage1Valid;}},{key:'isPage2Valid',get:function get(){return this.store.isPage2Valid;}},{key:'isPage3Valid',get:function get(){return this.store.isPage3Valid;}},{key:'canSave',get:function get(){if(this.props.isRoundStarted){switch(this.page){case 1:return this.isPage1Valid;case 2:return this.isPage2Valid;case 3:return this.isPage3Valid;default:}}if(this.page!==this.props.sale.saleConfig.saleEditTotalPages){return true;}return!__WEBPACK_IMPORTED_MODULE_3__build_node_modules_lodash___default.a.some(this.docs,function(d){return!d.type;});}}]);return EditPanel;}(__WEBPACK_IMPORTED_MODULE_8__build_node_modules_react__["Component"]),_class3.displayName='EditPanel',_temp2),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'page',[__WEBPACK_IMPORTED_MODULE_4__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return 1;}}),_applyDecoratedDescriptor(_class2.prototype,'offerData',[__WEBPACK_IMPORTED_MODULE_4__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class2.prototype,'offerData'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'docs',[__WEBPACK_IMPORTED_MODULE_4__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class2.prototype,'docs'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'isPage1Valid',[__WEBPACK_IMPORTED_MODULE_4__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class2.prototype,'isPage1Valid'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'isPage2Valid',[__WEBPACK_IMPORTED_MODULE_4__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class2.prototype,'isPage2Valid'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'isPage3Valid',[__WEBPACK_IMPORTED_MODULE_4__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class2.prototype,'isPage3Valid'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'canSave',[__WEBPACK_IMPORTED_MODULE_4__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class2.prototype,'canSave'),_class2.prototype)),_class2))||_class)||_class)||_class);

/***/ }),
/* 2253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dynamicImport__ = __webpack_require__(62);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Page=Object(__WEBPACK_IMPORTED_MODULE_3__components_dynamicImport__["b" /* default */])({component:'/containers/Sale/SaleEditSection/Page1'});var Page1=(_dec=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["d" /* inject */])('app'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_2__build_src_app_components_Localization__["a" /* localizable */])(_class=(_temp=_class2=function(_Component){_inherits(Page1,_Component);function Page1(){_classCallCheck(this,Page1);return _possibleConstructorReturn(this,(Page1.__proto__||Object.getPrototypeOf(Page1)).apply(this,arguments));}_createClass(Page1,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(Page,this.props);}}]);return Page1;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class2.displayName='Page1',_temp))||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (Page1);

/***/ }),
/* 2254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_src_app_components_dynamicImport__ = __webpack_require__(62);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Page=Object(__WEBPACK_IMPORTED_MODULE_3__build_src_app_components_dynamicImport__["b" /* default */])({component:'/containers/Sale/SaleEditSection/Page2'});var Page2=(_dec=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["d" /* inject */])('app'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_2__build_src_app_components_Localization__["a" /* localizable */])(_class=(_temp=_class2=function(_Component){_inherits(Page2,_Component);function Page2(){_classCallCheck(this,Page2);return _possibleConstructorReturn(this,(Page2.__proto__||Object.getPrototypeOf(Page2)).apply(this,arguments));}_createClass(Page2,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(Page,this.props);}}]);return Page2;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class2.displayName='Page2',_temp))||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (Page2);

/***/ }),
/* 2255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SaleManageSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ManagePanel__ = __webpack_require__(2256);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SaleManageSection=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["e" /* observer */])(_class=(_temp=_class2=function(_Component){_inherits(SaleManageSection,_Component);function SaleManageSection(){_classCallCheck(this,SaleManageSection);return _possibleConstructorReturn(this,(SaleManageSection.__proto__||Object.getPrototypeOf(SaleManageSection)).apply(this,arguments));}_createClass(SaleManageSection,[{key:'render',value:function render(){var _props=this.props,ui=_props.ui,sale=_props.sale,user=_props.user;return ui.currentPanel==='saleManage'&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ManagePanel__["a" /* default */],{isOpen:true,sale:sale,user:user,onClose:function onClose(){return ui.closePanel();}});}}]);return SaleManageSection;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class2.displayName='SaleManageSection',_class2.propTypes={ui:__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["b" /* PropTypes */].observableObject,store:__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["b" /* PropTypes */].observableObject},_temp))||_class;

/***/ }),
/* 2256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Panel__ = __webpack_require__(32);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var row={marginTop:'15px'};var ManagePanel=Object(__WEBPACK_IMPORTED_MODULE_3__components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__["e" /* observer */])(_class=(_temp2=_class2=function(_Component){_inherits(ManagePanel,_Component);function ManagePanel(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ManagePanel);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ManagePanel.__proto__||Object.getPrototypeOf(ManagePanel)).call.apply(_ref,[this].concat(args))),_this),_this.handleClose=function(){var onClose=_this.props.onClose;if(onClose){onClose();}},_this.renderPanelFooterContent=function(){var t=_this.props.t;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'ms-textAlignRight'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Button__["f" /* DefaultButton */],{onClick:_this.handleClose},t('Close')));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ManagePanel,[{key:'render',value:function render(){var _props=this.props,t=_props.t,sale=_props.sale,user=_props.user;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Panel__["a" /* Panel */],{headerText:t('Administration'),type:__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Panel__["b" /* PanelType */].medium,isOpen:this.props.isOpen,onDismissed:this.handleClose,onRenderFooterContent:this.renderPanelFooterContent,isFooterAtBottom:true,closeButtonAriaLabel:t('Close')},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12 ms-fontWeight-semibold'},t('Notifications'),':'),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12'},sale.agentData.email),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12'},sale.agentData.phone)))),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row',style:row},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12 ms-fontWeight-semibold'},t('Object supervisor'),':'),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12'},sale.offerData.legal_entity)))),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row',style:row},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12 ms-fontWeight-semibold'},t('My data'),':'),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12'},user.claims.name),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12'},user.claims.email),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12'},user.claims.phone||user.claims.phone_number))))));}}]);return ManagePanel;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class2.displayName='ManagePanel',_class2.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1__build_node_modules_prop_types___default.a.bool,onClose:__WEBPACK_IMPORTED_MODULE_1__build_node_modules_prop_types___default.a.func},_temp2))||_class)||_class;/* harmony default export */ __webpack_exports__["a"] = (ManagePanel);

/***/ }),
/* 2257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SaleNotificationsSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NotificationsPanel__ = __webpack_require__(2258);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SaleNotificationsSection=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["e" /* observer */])(_class=(_temp=_class2=function(_Component){_inherits(SaleNotificationsSection,_Component);function SaleNotificationsSection(){_classCallCheck(this,SaleNotificationsSection);return _possibleConstructorReturn(this,(SaleNotificationsSection.__proto__||Object.getPrototypeOf(SaleNotificationsSection)).apply(this,arguments));}_createClass(SaleNotificationsSection,[{key:'render',value:function render(){var _props=this.props,ui=_props.ui,sale=_props.sale,user=_props.user;return ui.currentPanel==='saleNotifications'&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__NotificationsPanel__["a" /* default */],{isOpen:true,sale:sale,user:user,onClose:function onClose(){return ui.closePanel();}});}}]);return SaleNotificationsSection;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class2.displayName='SaleNotificationsSection',_class2.propTypes={ui:__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["b" /* PropTypes */].observableObject,store:__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["b" /* PropTypes */].observableObject},_temp))||_class;

/***/ }),
/* 2258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Panel__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_Checkbox__ = __webpack_require__(91);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NotificationsPanel=Object(__WEBPACK_IMPORTED_MODULE_3__components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__["e" /* observer */])(_class=(_temp2=_class2=function(_Component){_inherits(NotificationsPanel,_Component);function NotificationsPanel(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NotificationsPanel);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NotificationsPanel.__proto__||Object.getPrototypeOf(NotificationsPanel)).call.apply(_ref,[this].concat(args))),_this),_this.handleClose=function(){var onClose=_this.props.onClose;if(onClose){onClose();}},_this.handleChange=function(i){return function(_,checked){var sale=_this.props.sale;sale.notifications[i].enabled=checked;sale.changeNotificationSettings();};},_this.renderPanelFooterContent=function(){var t=_this.props.t;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'ms-textAlignRight'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Button__["f" /* DefaultButton */],{onClick:_this.handleClose},t('Close')));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NotificationsPanel,[{key:'render',value:function render(){var _this2=this;var _props=this.props,t=_props.t,sale=_props.sale;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Panel__["a" /* Panel */],{headerText:t('Notifications'),type:__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Panel__["b" /* PanelType */].medium,isOpen:this.props.isOpen,onDismissed:this.handleClose,onRenderFooterContent:this.renderPanelFooterContent,isFooterAtBottom:true,closeButtonAriaLabel:t('Close')},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('p',null,t('Explanation')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('table',{style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('th',{style:{textAlign:'left'}},t('Active')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('th',{style:{textAlign:'left'}},t('Recipient')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('th',{style:{textAlign:'left'}},t('Email')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('th',{style:{textAlign:'left'}},t('Phone number')))),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('tbody',null,sale.notifications.map(function(n,i){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_Checkbox__["a" /* Checkbox */],{checked:n.enabled,onChange:_this2.handleChange(i),key:'enabled'})),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('td',{style:{paddingRight:'5px'}},n.name),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('td',{style:{paddingRight:'5px'}},n.email),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('td',null,n.phoneNumber));})))));}}]);return NotificationsPanel;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class2.displayName='NotificationsPanel',_class2.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1__build_node_modules_prop_types___default.a.bool,onClose:__WEBPACK_IMPORTED_MODULE_1__build_node_modules_prop_types___default.a.func},_temp2))||_class)||_class;/* harmony default export */ __webpack_exports__["a"] = (NotificationsPanel);

/***/ }),
/* 2259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SaleMessagingSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MessagingPanel__ = __webpack_require__(2260);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SaleMessagingSection=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["e" /* observer */])(_class=(_temp=_class2=function(_Component){_inherits(SaleMessagingSection,_Component);function SaleMessagingSection(){_classCallCheck(this,SaleMessagingSection);return _possibleConstructorReturn(this,(SaleMessagingSection.__proto__||Object.getPrototypeOf(SaleMessagingSection)).apply(this,arguments));}_createClass(SaleMessagingSection,[{key:'render',value:function render(){var _props=this.props,ui=_props.ui,sale=_props.sale,user=_props.user;return ui.currentPanel==='saleMessaging'&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__MessagingPanel__["a" /* default */],{isOpen:true,sale:sale,user:user,onClose:function onClose(){return ui.closePanel();}});}}]);return SaleMessagingSection;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class2.displayName='SaleMessagingSection',_class2.propTypes={ui:__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["b" /* PropTypes */].observableObject,store:__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["b" /* PropTypes */].observableObject},_temp))||_class;

/***/ }),
/* 2260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_Panel__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_Dropdown__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__build_node_modules_office_ui_fabric_react_lib_TextField__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__build_node_modules_office_ui_fabric_react_lib_Spinner__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__build_node_modules_office_ui_fabric_react_lib_MessageBar__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__build_src_app_components_PanelFooter__ = __webpack_require__(101);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_desc,_value,_class2,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_class3,_temp2;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var config=__webpack_require__(104).default;var MessagingPanel=Object(__WEBPACK_IMPORTED_MODULE_11__build_src_app_components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx_react__["e" /* observer */])(_class=(_class2=(_temp2=_class3=function(_Component){_inherits(MessagingPanel,_Component);function MessagingPanel(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,MessagingPanel);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MessagingPanel.__proto__||Object.getPrototypeOf(MessagingPanel)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'audience',_descriptor,_this),_initDefineProp(_this,'template',_descriptor2,_this),_initDefineProp(_this,'subject',_descriptor3,_this),_initDefineProp(_this,'text',_descriptor4,_this),_initDefineProp(_this,'sending',_descriptor5,_this),_initDefineProp(_this,'result',_descriptor6,_this),_initDefineProp(_this,'error',_descriptor7,_this),_this.handleChange=function(field){return function(ev,value){_this[field]=value;};},_this.handleChangeOptionKey=function(field){return function(ev,option,index,value){if(option)_this[field]=option.key;else _this[field]=value;};},_this.isSectionDisabled=function(section){return!config.messagingTemplates[_this.template].includes(section);},_this.handleSend=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(){var _this$props,sale,t;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this$props=_this.props,sale=_this$props.sale,t=_this$props.t;_this.sending=true;_context.prev=2;_context.next=5;return sale.sendNotification({audience:_this.audience,templateName:_this.template,data:{subject:_this.subject,text:_this.text}});case 5:_this.result=_context.sent;_context.next=11;break;case 8:_context.prev=8;_context.t0=_context['catch'](2);_this.error=t('Failed to send the message');case 11:_context.prev=11;_this.sending=false;return _context.finish(11);case 14:case'end':return _context.stop();}}},_callee,_this2,[[2,8,11,14]]);})),_this.handleClose=function(){var onClose=_this.props.onClose;if(onClose){onClose();}},_this.renderPanelFooterContent=function(){var t=_this.props.t;return __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx_react__["a" /* Observer */],{render:function render(){return __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__build_src_app_components_PanelFooter__["a" /* FooterContainer */],null,__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Button__["h" /* PrimaryButton */],{onClick:_this.handleSend,disabled:!_this.isValid||_this.sending||_this.result},_this.sending?t('Sending')+'...':t('Send'),_this.sending&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__build_node_modules_office_ui_fabric_react_lib_Spinner__["a" /* Spinner */],{size:__WEBPACK_IMPORTED_MODULE_9__build_node_modules_office_ui_fabric_react_lib_Spinner__["b" /* SpinnerSize */].xSmall,style:{paddingLeft:'10px'}})),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Button__["f" /* DefaultButton */],{onClick:_this.handleClose},t('Close')));}});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MessagingPanel,[{key:'render',value:function render(){var t=this.props.t;return __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_Panel__["a" /* Panel */],{headerText:t('Messaging'),type:__WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_Panel__["b" /* PanelType */].medium,isOpen:this.props.isOpen,onDismissed:this.handleClose,onRenderFooterContent:this.renderPanelFooterContent,isFooterAtBottom:true,closeButtonAriaLabel:t('Close')},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid'},this.result===null&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_Dropdown__["a" /* Dropdown */],{label:t('Template'),name:'template',selectedKey:this.template,onChange:this.handleChangeOptionKey('template'),options:Object.keys(config.messagingTemplates).map(function(key){return{key:key,text:t('template::'+key)};}),required:true,disabled:this.sending}))),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_Dropdown__["a" /* Dropdown */],{label:t('Audience'),name:'audience',selectedKey:this.audience,onChange:this.handleChangeOptionKey('audience'),options:config.messagingAudienceTypes.map(function(key){return{key:key,text:t('audiencetype::'+key)};}),required:true,disabled:this.sending}))),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__build_node_modules_office_ui_fabric_react_lib_TextField__["a" /* TextField */],{label:t('Subject'),name:'subject',value:this.subject,onChange:this.handleChange('subject'),required:true,disabled:this.sending||this.isSectionDisabled('subject')}))),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__build_node_modules_office_ui_fabric_react_lib_TextField__["a" /* TextField */],{label:t('Text'),multiline:true,name:'text',value:this.text,onChange:this.handleChange('text'),required:true,disabled:this.sending||this.isSectionDisabled('text')}))),this.error&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row',style:{paddingTop:'15px'}},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__build_node_modules_office_ui_fabric_react_lib_MessageBar__["a" /* MessageBar */],{messageBarType:__WEBPACK_IMPORTED_MODULE_10__build_node_modules_office_ui_fabric_react_lib_MessageBar__["b" /* MessageBarType */].error},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',null,this.error))))),this.result&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12'},this.result.succeeded.length>0&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__build_node_modules_office_ui_fabric_react_lib_MessageBar__["a" /* MessageBar */],{messageBarType:__WEBPACK_IMPORTED_MODULE_10__build_node_modules_office_ui_fabric_react_lib_MessageBar__["b" /* MessageBarType */].success},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',null,t('Number of successfully sent messages'),':',this.result.succeeded.length)),this.result.failed.length>0&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__build_node_modules_office_ui_fabric_react_lib_MessageBar__["a" /* MessageBar */],{messageBarType:__WEBPACK_IMPORTED_MODULE_10__build_node_modules_office_ui_fabric_react_lib_MessageBar__["b" /* MessageBarType */].error},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',null,t('Number of failed messages'),':',this.result.failed.length)),this.result.succeeded.length===0&&this.result.failed.length===0&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__build_node_modules_office_ui_fabric_react_lib_MessageBar__["a" /* MessageBar */],{messageBarType:__WEBPACK_IMPORTED_MODULE_10__build_node_modules_office_ui_fabric_react_lib_MessageBar__["b" /* MessageBarType */].info},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',null,t('No message has been sent'))))))));}},{key:'isValid',get:function get(){return(this.isSectionDisabled('subject')||!!this.subject)&&(this.isSectionDisabled('text')||!!this.text);}}]);return MessagingPanel;}(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__["Component"]),_class3.displayName='MessagingPanel',_class3.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_2__build_node_modules_prop_types___default.a.bool,onClose:__WEBPACK_IMPORTED_MODULE_2__build_node_modules_prop_types___default.a.func},_temp2),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'audience',[__WEBPACK_IMPORTED_MODULE_4__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return'everyone';}}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,'template',[__WEBPACK_IMPORTED_MODULE_4__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return'cust_message';}}),_descriptor3=_applyDecoratedDescriptor(_class2.prototype,'subject',[__WEBPACK_IMPORTED_MODULE_4__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor4=_applyDecoratedDescriptor(_class2.prototype,'text',[__WEBPACK_IMPORTED_MODULE_4__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor5=_applyDecoratedDescriptor(_class2.prototype,'sending',[__WEBPACK_IMPORTED_MODULE_4__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor6=_applyDecoratedDescriptor(_class2.prototype,'result',[__WEBPACK_IMPORTED_MODULE_4__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor7=_applyDecoratedDescriptor(_class2.prototype,'error',[__WEBPACK_IMPORTED_MODULE_4__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return null;}}),_applyDecoratedDescriptor(_class2.prototype,'isValid',[__WEBPACK_IMPORTED_MODULE_4__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class2.prototype,'isValid'),_class2.prototype)),_class2))||_class)||_class;/* harmony default export */ __webpack_exports__["a"] = (MessagingPanel);

/***/ }),
/* 2261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_src_app_components_dynamicImport__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SellerInviteSection__ = __webpack_require__(1066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stores__ = __webpack_require__(2262);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Content=Object(__WEBPACK_IMPORTED_MODULE_0__build_src_app_components_dynamicImport__["b" /* default */])({component:'/containers/Sale/SellerInviteSection',fallback:__WEBPACK_IMPORTED_MODULE_3__SellerInviteSection__["a" /* default */]});var SellerInviteSection=(_dec=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["d" /* inject */])('app','sale'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["e" /* observer */])(_class=(_temp=_class2=function(_Component){_inherits(SellerInviteSection,_Component);function SellerInviteSection(props){_classCallCheck(this,SellerInviteSection);var _this=_possibleConstructorReturn(this,(SellerInviteSection.__proto__||Object.getPrototypeOf(SellerInviteSection)).call(this,props));_this.seller=new __WEBPACK_IMPORTED_MODULE_4__stores__["a" /* default */](props.sale);return _this;}_createClass(SellerInviteSection,[{key:'render',value:function render(){if(!this.seller.data){return null;}return __WEBPACK_IMPORTED_MODULE_2__build_node_modules_react___default.a.createElement(Content,Object.assign({},this.props,{seller:this.seller}));}}]);return SellerInviteSection;}(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_react__["Component"]),_class2.displayName='SellerInviteSection',_temp))||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (SellerInviteSection);

/***/ }),
/* 2262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SellerInviteStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var error={error:'',data:{}};var SellerInviteStore=(_class=function(){_createClass(SellerInviteStore,[{key:'phoneNumberError',get:function get(){return this.submitError.error&&this.submitError.data.phoneNumber===this.data.phoneNumber&&this.submitError.error.startsWith('phone_number_')?'phonenumbererror::'+this.submitError.error.substring('phone_number_'.length):'';}},{key:'isBlocked',get:function get(){return this.sale.saleEdit.invitedSeller.blocked;}}]);function SellerInviteStore(sale){var _this=this;_classCallCheck(this,SellerInviteStore);_initDefineProp(this,'sale',_descriptor,this);_initDefineProp(this,'data',_descriptor2,this);_initDefineProp(this,'submitError',_descriptor3,this);this.invite=function(){var _sale=_this.sale,saleEdit=_sale.saleEdit,ui=_sale.ui;_this.submitError.error='';saleEdit.inviteSeller(_this.data).then(function(){ui.closePanel();},function(error){if(error&&error.response&&error.response.result&&!error.response.result.successful&&error.response.result.error){_this.submitError.error=error.response.result.error;_this.submitError.data=_this.data;}else{saleEdit.root.failed(error);ui.closePanel();}});};this.block=function(){var _sale2=_this.sale,saleEdit=_sale2.saleEdit,ui=_sale2.ui;saleEdit.blockSeller();ui.closePanel();};this.close=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.sale.ui.closePanel();case 1:case'end':return _context.stop();}}},_callee,_this);}));this.propChanged=function(field,value,customValue){var valueKey=!!value?value.key:undefined;_this.data[field]=customValue||valueKey||value;};this.titleChanged=function(option,value){_this.data.title=option?option.text:value;};this.sale=sale;this.data=Object.assign({locale:sale.saleConfig.localeCodes.at(0)},sale.saleEdit.invitedSeller.data);}_createClass(SellerInviteStore,[{key:'setData',value:function setData(data){this.data=Object.assign({},data,{locale:this.data.locale},// do not lose default / current locale
this.sale.saleEdit.invitedSeller.data);}}]);return SellerInviteStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'sale',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:null}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'data',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:null}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'submitError',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return error;}}),_applyDecoratedDescriptor(_class.prototype,'phoneNumberError',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'phoneNumberError'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'isBlocked',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'isBlocked'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setData',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'setData'),_class.prototype)),_class);

/***/ }),
/* 2263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WhitelistingSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WhitelistingPanel__ = __webpack_require__(2264);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WhitelistingSection=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["e" /* observer */])(_class=(_temp=_class2=function(_Component){_inherits(WhitelistingSection,_Component);function WhitelistingSection(){_classCallCheck(this,WhitelistingSection);return _possibleConstructorReturn(this,(WhitelistingSection.__proto__||Object.getPrototypeOf(WhitelistingSection)).apply(this,arguments));}_createClass(WhitelistingSection,[{key:'render',value:function render(){var _props=this.props,ui=_props.ui,sale=_props.sale,whitelisting=_props.whitelisting,user=_props.user;return ui.currentPanel==='whitelisting'&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__WhitelistingPanel__["a" /* default */],{isOpen:true,whitelisting:whitelisting,sale:sale,user:user,onClose:function onClose(){return ui.closePanel();}});}}]);return WhitelistingSection;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class2.displayName='WhitelistingSection',_class2.propTypes={ui:__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["b" /* PropTypes */].observableObject,store:__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["b" /* PropTypes */].observableObject},_temp))||_class;

/***/ }),
/* 2264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Panel__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BlockDialog__ = __webpack_require__(2265);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_desc,_value,_class2,_descriptor,_descriptor2,_class3,_temp2;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var WhitelistingPanel=Object(__WEBPACK_IMPORTED_MODULE_7__components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__["e" /* observer */])(_class=(_class2=(_temp2=_class3=function(_Component){_inherits(WhitelistingPanel,_Component);function WhitelistingPanel(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,WhitelistingPanel);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=WhitelistingPanel.__proto__||Object.getPrototypeOf(WhitelistingPanel)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'isOpenBlockDialog',_descriptor,_this),_initDefineProp(_this,'selectedUserId',_descriptor2,_this),_this.handleClose=function(){var onClose=_this.props.onClose;if(onClose){onClose();}},_this.formattedDate=function(date){return new Date(date).toFormatedDateString('L LT');},_this.openBlockDialog=function(userId){_this.selectedUserId=userId;_this.isOpenBlockDialog=true;},_this.closeBlockDialog=function(){_this.selectedUserId=undefined;_this.isOpenBlockDialog=false;},_this.handleAccept=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(userId){var whitelisting;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(userId){_context.next=2;break;}return _context.abrupt('return');case 2:whitelisting=_this.props.whitelisting;_context.next=5;return whitelisting.accept({userId:userId});case 5:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}(),_this.handleBlock=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(_ref3){var userId=_ref3.userId,reason=_ref3.reason;var whitelisting,ok;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(userId){_context2.next=2;break;}return _context2.abrupt('return');case 2:whitelisting=_this.props.whitelisting;_context2.next=5;return whitelisting.block({userId:userId,reason:reason});case 5:ok=_context2.sent;if(ok){_this.closeBlockDialog();}case 7:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref4.apply(this,arguments);};}(),_this.renderPanelFooterContent=function(){var t=_this.props.t;return __WEBPACK_IMPORTED_MODULE_6__build_node_modules_react___default.a.createElement('div',{className:'ms-textAlignRight'},__WEBPACK_IMPORTED_MODULE_6__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Button__["f" /* DefaultButton */],{onClick:_this.handleClose},t('Close')));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(WhitelistingPanel,[{key:'render',value:function render(){var _this3=this;var _props=this.props,t=_props.t,whitelisting=_props.whitelisting;return __WEBPACK_IMPORTED_MODULE_6__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Panel__["a" /* Panel */],{headerText:t('Whitelisting'),type:__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_Panel__["b" /* PanelType */].large,isOpen:this.props.isOpen,onDismissed:this.handleClose,onRenderFooterContent:this.renderPanelFooterContent,isFooterAtBottom:true,closeButtonAriaLabel:t('Close')},this.isOpenBlockDialog&&__WEBPACK_IMPORTED_MODULE_6__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__BlockDialog__["a" /* default */],{isOpen:this.isOpenBlockDialog,onClose:this.closeBlockDialog,onSubmit:function onSubmit(reason){_this3.handleBlock({userId:_this3.selectedUserId,reason:reason});}}),__WEBPACK_IMPORTED_MODULE_6__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_6__build_node_modules_react___default.a.createElement('table',{style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_6__build_node_modules_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_6__build_node_modules_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_6__build_node_modules_react___default.a.createElement('th',{style:{textAlign:'left'}},t('Agent')),__WEBPACK_IMPORTED_MODULE_6__build_node_modules_react___default.a.createElement('th',{style:{textAlign:'left'}},t('Status')),__WEBPACK_IMPORTED_MODULE_6__build_node_modules_react___default.a.createElement('th',{style:{textAlign:'left'}},t('Requested')),__WEBPACK_IMPORTED_MODULE_6__build_node_modules_react___default.a.createElement('th',{style:{textAlign:'left'}},t('Action')))),__WEBPACK_IMPORTED_MODULE_6__build_node_modules_react___default.a.createElement('tbody',null,whitelisting.whitelist.map(function(w){return __WEBPACK_IMPORTED_MODULE_6__build_node_modules_react___default.a.createElement('tr',{key:w.userId},__WEBPACK_IMPORTED_MODULE_6__build_node_modules_react___default.a.createElement('td',null,getAgentName(w.data.agent)),__WEBPACK_IMPORTED_MODULE_6__build_node_modules_react___default.a.createElement('td',null,t(w.status)),__WEBPACK_IMPORTED_MODULE_6__build_node_modules_react___default.a.createElement('td',null,_this3.formattedDate(w.createdAt)),__WEBPACK_IMPORTED_MODULE_6__build_node_modules_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_6__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Button__["h" /* PrimaryButton */],{text:t('accept'),onClick:function onClick(){return _this3.handleAccept(w.userId);},allowDisabledFocus:true,disabled:w.status==='whitelisted'}),__WEBPACK_IMPORTED_MODULE_6__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Button__["f" /* DefaultButton */],{text:t('block'),onClick:function onClick(){return _this3.openBlockDialog(w.userId);},allowDisabledFocus:true,disabled:w.status==='blocked'})));})))));}}]);return WhitelistingPanel;}(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_react__["Component"]),_class3.displayName='WhitelistingPanel',_class3.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_5__build_node_modules_prop_types___default.a.bool,onClose:__WEBPACK_IMPORTED_MODULE_5__build_node_modules_prop_types___default.a.func},_temp2),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'isOpenBlockDialog',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,'selectedUserId',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:null})),_class2))||_class)||_class;function getAgentName(agent){if(agent.name){return agent.name;}if(agent.given_name&&agent.family_name){return agent.given_name+' '+agent.family_name;}if(agent.email){return agent.email;}if(agent.profile){return getAgentName(agent.profile);}}/* harmony default export */ __webpack_exports__["a"] = (WhitelistingPanel);

/***/ }),
/* 2265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BlockDialog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Dialog__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_TextField__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_desc,_value,_class2,_descriptor,_class3,_temp2;function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var BlockDialog=Object(__WEBPACK_IMPORTED_MODULE_5__components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["e" /* observer */])(_class=(_class2=(_temp2=_class3=function(_Component){_inherits(BlockDialog,_Component);function BlockDialog(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BlockDialog);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BlockDialog.__proto__||Object.getPrototypeOf(BlockDialog)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'reason',_descriptor,_this),_this.handleChange=function(e){_this.reason=e.target.value;},_this.handleSubmit=function(){var onSubmit=_this.props.onSubmit;if(onSubmit){onSubmit(_this.reason);}},_this.handleClose=function(){var onClose=_this.props.onClose;if(onClose){onClose();_this.reason='';}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BlockDialog,[{key:'render',value:function render(){var _props=this.props,onClose=_props.onClose,t=_props.t;return __WEBPACK_IMPORTED_MODULE_6__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Dialog__["a" /* Dialog */],{minWidth:600,hidden:false,onDismiss:onClose,dialogContentProps:{type:__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Dialog__["c" /* DialogType */].largeHeader,title:t('Block Agent')},modalProps:{isBlocking:true,containerClassName:'ms-dialogMainOverride'}},__WEBPACK_IMPORTED_MODULE_6__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid'},__WEBPACK_IMPORTED_MODULE_6__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_6__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-lg12 ms-md12 ms-sm12'},__WEBPACK_IMPORTED_MODULE_6__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_office_ui_fabric_react_lib_TextField__["a" /* TextField */],{label:t('Reason'),multiline:true,name:'reason',value:this.reason,onChange:this.handleChange})))),__WEBPACK_IMPORTED_MODULE_6__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Dialog__["b" /* DialogFooter */],null,__WEBPACK_IMPORTED_MODULE_6__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_Button__["h" /* PrimaryButton */],{onClick:this.handleSubmit,text:t('Block')}),__WEBPACK_IMPORTED_MODULE_6__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_Button__["f" /* DefaultButton */],{onClick:onClose,text:t('Cancel')})));}}]);return BlockDialog;}(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_react__["Component"]),_class3.displayName='BlockDialog',_temp2),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'reason',[__WEBPACK_IMPORTED_MODULE_0__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return'';}})),_class2))||_class)||_class;

/***/ }),
/* 2266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_src_app_components_dynamicImport__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BuyerAgentInviteSection__ = __webpack_require__(2267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stores__ = __webpack_require__(2268);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Content=Object(__WEBPACK_IMPORTED_MODULE_0__build_src_app_components_dynamicImport__["b" /* default */])({component:'/containers/Sale/BuyerAgentInviteSection',fallback:__WEBPACK_IMPORTED_MODULE_3__BuyerAgentInviteSection__["a" /* default */]});var BuyerAgentInviteSection=(_dec=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["d" /* inject */])('app','sale'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["e" /* observer */])(_class=(_temp=_class2=function(_Component){_inherits(BuyerAgentInviteSection,_Component);function BuyerAgentInviteSection(props){_classCallCheck(this,BuyerAgentInviteSection);var _this=_possibleConstructorReturn(this,(BuyerAgentInviteSection.__proto__||Object.getPrototypeOf(BuyerAgentInviteSection)).call(this,props));_this.agent=new __WEBPACK_IMPORTED_MODULE_4__stores__["a" /* default */](props.sale);return _this;}_createClass(BuyerAgentInviteSection,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_2__build_node_modules_react___default.a.createElement(Content,Object.assign({},this.props,{agent:this.agent}));}}]);return BuyerAgentInviteSection;}(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_react__["Component"]),_class2.displayName='BuyerAgentInviteSection',_temp))||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (BuyerAgentInviteSection);

/***/ }),
/* 2267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BuyerAgentInviteSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_src_app_components_EmailField__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_src_app_components_PanelFooter__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_Panel__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_TextField__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__build_node_modules_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_temp2;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var defaultData={email:'',phoneNumber:'',firstName:'',lastName:'',locale:''};var BuyerAgentInviteSection=Object(__WEBPACK_IMPORTED_MODULE_2__build_src_app_components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_mobx_react__["e" /* observer */])(_class=(_temp2=_class2=function(_Component){_inherits(BuyerAgentInviteSection,_Component);function BuyerAgentInviteSection(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,BuyerAgentInviteSection);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BuyerAgentInviteSection.__proto__||Object.getPrototypeOf(BuyerAgentInviteSection)).call.apply(_ref,[this].concat(args))),_this),_this.handleInvite=function(){var agent=_this.props.agent;agent.invite();},_this.handleCancel=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(){var agent;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:agent=_this.props.agent;agent.close();case 2:case'end':return _context.stop();}}},_callee,_this2);})),_this.handleChanged=function(field){return function(value,_,customValue){var agent=_this.props.agent;agent.propChanged(field,value,customValue);};},_this.handleTitleChanged=function(option,_,value){var agent=_this.props.agent;agent.titleChanged(option,value);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BuyerAgentInviteSection,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,agent=_props.agent,app=_props.app;var data=Object.assign({},defaultData,{tenant:app.tenantConfig.agentRegistrationDefaultTenant});console.log('data',data);agent.setData(data);}},{key:'render',value:function render(){var _this3=this;var _props2=this.props,agent=_props2.agent,t=_props2.t;//const config = app.tenantConfig;
return __WEBPACK_IMPORTED_MODULE_8__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_8__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_Panel__["a" /* Panel */],{headerText:t('Invite Buyer Agent'),type:__WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_Panel__["b" /* PanelType */].medium,onDismiss:this.handleCancel,isOpen:true,isFooterAtBottom:true,closeButtonAriaLabel:'Close',onRenderFooterContent:function onRenderFooterContent(){return __WEBPACK_IMPORTED_MODULE_8__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_src_app_components_PanelFooter__["a" /* FooterContainer */],null,__WEBPACK_IMPORTED_MODULE_8__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Button__["h" /* PrimaryButton */],{text:t('Invite'),onClick:_this3.handleInvite}),__WEBPACK_IMPORTED_MODULE_8__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_office_ui_fabric_react_lib_Button__["f" /* DefaultButton */],{text:t('Cancel'),onClick:_this3.handleCancel}));}},__WEBPACK_IMPORTED_MODULE_8__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid'},__WEBPACK_IMPORTED_MODULE_8__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_8__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-lg6 ms-md12 ms-sm12'},__WEBPACK_IMPORTED_MODULE_8__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_src_app_components_EmailField__["a" /* default */],{label:t('Email'),value:agent.data.email,iconProps:{iconName:'Mail'},required:true,onChanged:this.handleChanged('email'),validateOnLoad:false,autoComplete:'nope',validateOnFocusOut:true})),__WEBPACK_IMPORTED_MODULE_8__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-lg6 ms-md12 ms-sm12'},__WEBPACK_IMPORTED_MODULE_8__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_TextField__["a" /* TextField */],{label:t('Phone number'),placeholder:'+49 150 0000 0000',value:agent.data.phoneNumber,iconProps:{iconName:'Phone'},required:true,onChanged:this.handleChanged('phoneNumber'),validateOnLoad:false,errorMessage:agent.phoneNumberError===''?agent.phoneNumberError:t(agent.phoneNumberError),validateOnFocusIn:true,validateOnFocusOut:true,autoComplete:'nope',inputMode:'tel'}))),__WEBPACK_IMPORTED_MODULE_8__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_8__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-md12 ms-sm12 ms-lg6'},__WEBPACK_IMPORTED_MODULE_8__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_TextField__["a" /* TextField */],{label:t('First name'),value:agent.data.firstName,onChanged:this.handleChanged('firstName'),required:true,validateOnLoad:false,onGetErrorMessage:this.requiredValidation,validateOnFocusOut:true,autoComplete:'nope'})),__WEBPACK_IMPORTED_MODULE_8__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-md12 ms-sm12 ms-lg6'},__WEBPACK_IMPORTED_MODULE_8__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_TextField__["a" /* TextField */],{label:t('Last name'),value:agent.data.lastName,onChanged:this.handleChanged('lastName'),required:true,validateOnLoad:false,onGetErrorMessage:this.requiredValidation,validateOnFocusOut:true,autoComplete:'nope'}))))));}}]);return BuyerAgentInviteSection;}(__WEBPACK_IMPORTED_MODULE_8__build_node_modules_react__["Component"]),_class2.displayName='BuyerAgentInviteSection',_temp2))||_class)||_class;

/***/ }),
/* 2268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BuyerAgentInviteStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var error={error:'',data:{}};var BuyerAgentInviteStore=(_class=function(){function BuyerAgentInviteStore(sale){var _this=this;_classCallCheck(this,BuyerAgentInviteStore);_initDefineProp(this,'sale',_descriptor,this);_initDefineProp(this,'data',_descriptor2,this);_initDefineProp(this,'submitError',_descriptor3,this);this.invite=function(){var _sale=_this.sale,saleEdit=_sale.saleEdit,ui=_sale.ui;_this.submitError.error='';if(_this.data.locale===''){_this.data.locale=saleEdit.locale;}saleEdit.inviteBuyerAgent(_this.data).then(function(){ui.closePanel();},function(error){if(error&&error.response&&error.response.result&&!error.response.result.successful&&error.response.result.error){_this.submitError.error=error.response.result.error;_this.submitError.data=_this.data;}else{saleEdit.root.failed(error);ui.closePanel();}});};this.close=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.sale.ui.closePanel();case 1:case'end':return _context.stop();}}},_callee,_this);}));this.propChanged=function(field,value,customValue){var valueKey=!!value?value.key:undefined;_this.data[field]=customValue||valueKey||value;};this.titleChanged=function(option,value){_this.data.title=option?option.text:value;};this.sale=sale;this.data={};}_createClass(BuyerAgentInviteStore,[{key:'setData',value:function setData(data){this.data=Object.assign({},data);}},{key:'phoneNumberError',get:function get(){return this.submitError.error&&this.submitError.data.phoneNumber===this.data.phoneNumber&&this.submitError.error.startsWith('phone_number_')?'phonenumbererror::'+this.submitError.error.substring('phone_number_'.length):'';}}]);return BuyerAgentInviteStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'sale',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:null}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'data',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:null}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'submitError',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return error;}}),_applyDecoratedDescriptor(_class.prototype,'phoneNumberError',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'phoneNumberError'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'setData',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["c" /* action */]],Object.getOwnPropertyDescriptor(_class.prototype,'setData'),_class.prototype)),_class);

/***/ }),
/* 2269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_moment_timezone__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_lodash__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_node_modules_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__build_node_modules_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_CommandBar__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_DetailsList__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__build_node_modules_office_ui_fabric_react_lib_Image__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__build_node_modules_office_ui_fabric_react_lib_Checkbox__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__build_node_modules_office_ui_fabric_react_lib_Dropdown__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__build_node_modules_office_ui_fabric_react_lib_Panel__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__build_node_modules_office_ui_fabric_react_lib_Link__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__build_node_modules_office_ui_fabric_react_lib_Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__build_node_modules_office_ui_fabric_react_lib_Spinner__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__build_src_app_components_LoadingOverlay__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__build_src_app_components_Money__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__build_src_app_components_GuideOverlay__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__build_src_app_components_dynamicImport__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__build_src_app_components_SaleCreatePanel__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__build_src_app_components_BehalfOfAgentsDropdown__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__build_src_app_helpers_queryString__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Documents__ = __webpack_require__(2270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__build_src_app_services_request__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_TermsLabel__ = __webpack_require__(492);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_class3,_temp;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var SearchPanelContent=Object(__WEBPACK_IMPORTED_MODULE_19__build_src_app_components_dynamicImport__["b" /* default */])({component:'/containers/Search/SearchPanelContent'});var Search=(_dec=Object(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx_react__["d" /* inject */])('inventory','sale','app','user'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_15__build_src_app_components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx_react__["e" /* observer */])(_class=(_class2=(_temp=_class3=function(_Component){_inherits(Search,_Component);_createClass(Search,[{key:'selectedDocumentsCount',// [ { id, title, fileName, type, url, _disabled, _selected, _error, _uploaded: {} } ]
get:function get(){return __WEBPACK_IMPORTED_MODULE_5__build_node_modules_lodash___default.a.filter(this.documents,function(doc){return doc._selected;}).length;}// = new AbortController()
},{key:'documentUploadErrorsCount',get:function get(){return __WEBPACK_IMPORTED_MODULE_5__build_node_modules_lodash___default.a.filter(this.documents,function(doc){return doc._error;}).length;}},{key:'tocDisabled',get:function get(){var config=this.props.user.userConfig;if(!config.saleCreateRequireTC){return true;}return typeof config.disableSaleToC!=='undefined'&&config.disableSaleToC.includes(this.props.user.profile.tenant);}}]);function Search(props){_classCallCheck(this,Search);var _this=_possibleConstructorReturn(this,(Search.__proto__||Object.getPrototypeOf(Search)).call(this,props));_initDefineProp(_this,'toc',_descriptor,_this);_initDefineProp(_this,'openNewSalePanel',_descriptor2,_this);_initDefineProp(_this,'creating',_descriptor3,_this);_initDefineProp(_this,'mls',_descriptor4,_this);_initDefineProp(_this,'masterSaleId',_descriptor5,_this);_initDefineProp(_this,'selfRegistration',_descriptor6,_this);_initDefineProp(_this,'isTest',_descriptor7,_this);_initDefineProp(_this,'documents',_descriptor8,_this);_initDefineProp(_this,'processedDocumentsCount',_descriptor9,_this);_this.handleBack=function(){var history=_this.props.history;history.push('/dashboard');};_initDefineProp(_this,'handleAddNew',_descriptor10,_this);_this.handleRenderObjectColumn=function(object,index,column){var intl=_this.props.intl;var content=object[column.fieldName];switch(column.key){case'image':return __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__build_node_modules_office_ui_fabric_react_lib_Image__["a" /* Image */],{src:content,width:50,height:50,imageFit:__WEBPACK_IMPORTED_MODULE_8__build_node_modules_office_ui_fabric_react_lib_Image__["b" /* ImageFit */].cover});case'price':return __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__build_src_app_components_Money__["a" /* default */],{value:content,currency:_this.props.app.currency.code//TODO: currency code could be taken from the corresponding sale
,locale:_this.props.intl.locale});case'area':return __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('span',null,intl.formatNumber(content));default:return __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('span',null,content);}};_this.handleSelectionChanged=function(){_this.documents.clear();var item=_this.selection.getSelection()[0];if(!item){return;}var inventory=_this.props.inventory;_this.toc=false;inventory.select(item).then(function(){_this.handleItemSelected();});};_this.isDocAllowed=function(doc){if(!doc.fileName)return true;var extension=doc.fileName.includes('.')?doc.fileName.substr(doc.fileName.lastIndexOf('.')+1):'';return['JPG','PNG','PDF'].includes(extension.toUpperCase());};_this.handleItemSelected=function(){var inventory=_this.props.inventory;var config=_this.props.user.userConfig;_this.documents.clear();_this.mls=config.mlsTypes&&config.mlsTypes.length>0?config.mlsTypes[0]:'';if(inventory.selectedItem&&inventory.selectedItem.docs){inventory.selectedItem.docs.forEach(function(doc){if(!doc.type){// use title or fileName if no type could be inferred
if(doc.title)doc.type=doc.title;else if(doc.fileName)doc.type=doc.fileName.includes('.')?doc.fileName.substr(0,doc.fileName.lastIndexOf('.')):doc.fileName;}_this.documents.push(Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["e" /* extendObservable */])(Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["j" /* observable */])(doc),{_disabled:!_this.isDocAllowed(doc),_selected:false,// this.isDocAllowed(doc),
_error:null}));});}if(inventory.agents.length===1)inventory.selectedAgent=inventory.agents[0];if(inventory.agents.length>1){var itemAgent=inventory.agents.find(function(a){return a.agent_id===inventory.selectedItem.public.agent.id;});inventory.selectedAgent=!!itemAgent?itemAgent:null;}};_this.handleDocumentSelectionChanged=function(id,selected){_this.documents.forEach(function(doc){if(doc.id===id&&!doc._disabled)doc._selected=selected;});};_this.handleColumnHeaderClick=function(e,column){var inventory=_this.props.inventory;inventory.sortBy(column.fieldName);};_this.handleOpenNewSalePanel=function(){_this.openNewSalePanel=!_this.openNewSalePanel;};_this.handleMlsChange=function(ev,option,index,value){_this.mls=option.key;};_this.handleAgentChanged=function(e){var inventory=_this.props.inventory;inventory.selectedAgent=e;};_this.renderPanelFooterContent=function(){var _this$props=_this.props,t=_this$props.t,inventory=_this$props.inventory,app=_this$props.app,user=_this$props.user;return __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_mobx_react__["a" /* Observer */],{render:function render(){return!inventory.fetchingItem&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid'},inventory.isListed&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12',style:{color:'#DC1C2E'}},t('This object is already active'))),inventory.saleAgent?null:__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12',style:{color:'#DC1C2E'}},t('Agent not found'))),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},!_this.tocDisabled&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12',style:{paddingTop:'15px'}},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__build_node_modules_office_ui_fabric_react_lib_Checkbox__["a" /* Checkbox */],{onChange:_this.handleTocChange,label:t('I agree with terms and conditions'),onRenderLabel:function onRenderLabel(){return __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_TermsLabel__["a" /* TermsLabel */],{app:app,t:t,user:user});}})),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12',style:{paddingTop:'15px'}},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__build_node_modules_office_ui_fabric_react_lib_Button__["f" /* DefaultButton */],{onClick:function onClick(){if(!_this.creating)inventory.deselect();if(_this.creationAbortController)_this.creationAbortController.abort();},style:{marginRight:'8px'}},t('Cancel')),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__build_node_modules_office_ui_fabric_react_lib_Button__["h" /* PrimaryButton */],{onClick:_this.handleAddNew,disabled:!user.hasReadWritePermissions||!_this.toc&&!_this.tocDisabled||_this.creating||!inventory.saleAgent},_this.creating?t('Creating')+' ('+_this.processedDocumentsCount+' / '+_this.selectedDocumentsCount+')...':t('Add'),_this.creating&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__build_node_modules_office_ui_fabric_react_lib_Spinner__["a" /* Spinner */],{size:__WEBPACK_IMPORTED_MODULE_14__build_node_modules_office_ui_fabric_react_lib_Spinner__["b" /* SpinnerSize */].xSmall,style:{paddingLeft:'10px'}})))));}});};_this.handleTocChange=function(_,isChecked){_this.toc=isChecked;};_this.selection=new __WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_DetailsList__["d" /* Selection */]({onSelectionChanged:_this.handleSelectionChanged});return _this;}_createClass(Search,[{key:'componentDidMount',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(){var _this2=this;var _props,inventory,history,t,propertyId,existing;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_props=this.props,inventory=_props.inventory,history=_props.history,t=_props.t;propertyId=Object(__WEBPACK_IMPORTED_MODULE_22__build_src_app_helpers_queryString__["a" /* getQueryStringValue */])('property')||Object(__WEBPACK_IMPORTED_MODULE_22__build_src_app_helpers_queryString__["a" /* getQueryStringValue */])('search');this.isTest=Object(__WEBPACK_IMPORTED_MODULE_22__build_src_app_helpers_queryString__["a" /* getQueryStringValue */])('test')==='1';inventory.initColumns(t,this.handleColumnHeaderClick);if(!propertyId){_context.next=12;break;}_context.next=7;return inventory.getExistingSale(propertyId);case 7:existing=_context.sent;if(!existing){_context.next=11;break;}history.replace('/dashboard/'+existing);return _context.abrupt('return');case 11:inventory.get(propertyId).then(function(){if(!inventory.isListed&&!!inventory.selectedItem)_this2.handleItemSelected();},function(){});case 12:inventory.search();_context.next=15;return inventory.loadAgents();case 15:case'end':return _context.stop();}}},_callee,this);}));function componentDidMount(){return _ref.apply(this,arguments);}return componentDidMount;}()},{key:'componentDidUpdate',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(prevProps){var propertyId,_props2,inventory,history,listed,invite,inviteDecoded,contact,contactId;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:propertyId=Object(__WEBPACK_IMPORTED_MODULE_22__build_src_app_helpers_queryString__["a" /* getQueryStringValue */])('property')||Object(__WEBPACK_IMPORTED_MODULE_22__build_src_app_helpers_queryString__["a" /* getQueryStringValue */])('search');if(propertyId){_context2.next=3;break;}return _context2.abrupt('return');case 3:_props2=this.props,inventory=_props2.inventory,history=_props2.history;if(propertyId){_context2.next=6;break;}return _context2.abrupt('return');case 6:_context2.t0=inventory.listed;if(_context2.t0){_context2.next=11;break;}_context2.next=10;return inventory.findListing(propertyId);case 10:_context2.t0=_context2.sent;case 11:listed=_context2.t0;if(listed){_context2.next=14;break;}return _context2.abrupt('return');case 14:invite=Object(__WEBPACK_IMPORTED_MODULE_22__build_src_app_helpers_queryString__["a" /* getQueryStringValue */])('invite');if(invite&&invite.length>0){inviteDecoded=decodeURI(invite);contact={};inviteDecoded.split(',').forEach(function(keyValue){var _keyValue$split=keyValue.split(':'),_keyValue$split2=_slicedToArray(_keyValue$split,2),prop=_keyValue$split2[0],value=_keyValue$split2[1];if(prop&&value)contact[prop]=value;});if(Object.keys(contact).length!==0){sessionStorage.setItem('invite',JSON.stringify({panel:'registration',payload:contact}));}}contactId=Object(__WEBPACK_IMPORTED_MODULE_22__build_src_app_helpers_queryString__["a" /* getQueryStringValue */])('contactIds');if(contactId&&contactId.length>0){sessionStorage.setItem('invite',JSON.stringify({panel:'bulkRegistrationCrm',payload:contactId}));}history.replace('/dashboard/'+listed.id);case 19:case'end':return _context2.stop();}}},_callee2,this);}));function componentDidUpdate(_x){return _ref2.apply(this,arguments);}return componentDidUpdate;}()},{key:'render',value:function render(){var _this3=this;var _props3=this.props,inventory=_props3.inventory,history=_props3.history,t=_props3.t,intl=_props3.intl,app=_props3.app,user=_props3.user;if(inventory.redirect){history.push('/dashboard/'+inventory.startedSale);}var canCreateBlankSale=app.features&&app.features.createBlankSale;var commands=[];if(canCreateBlankSale){commands.push({key:'create',name:this.isTest?t('Start new test sale'):t('Start new sale'),iconProps:{iconName:this.isTest?'TestBeaker':'Add'},onClick:this.handleOpenNewSalePanel,disabled:!user.hasReadWritePermissions});}return __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'title'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('a',{className:'back',onClick:this.handleBack},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('i',{className:'ms-Icon ms-Icon--NavigateBack','aria-hidden':'true'}),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('span',null,t('Back'))),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('span',null,t('Add new listing'))),commands.length>0&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'menu'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_node_modules_office_ui_fabric_react_lib_CommandBar__["a" /* CommandBar */],{items:commands})),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:commands.length>0?'content':'content-without-menu'},inventory.fetching&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{style:{marginTop:5}},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__build_src_app_components_LoadingOverlay__["a" /* default */],{label:t('Loading properties')+'...'})),!inventory.fetching&&inventory.items&&inventory.items.length>0&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__build_node_modules_office_ui_fabric_react_lib_DetailsList__["b" /* DetailsList */],{columns:inventory.columns,items:inventory.items,selectionMode:1,checkboxVisibility:0,onRenderItemColumn:this.handleRenderObjectColumn,selection:this.selection,selectionPreservedOnEmptyClick:true}),!inventory.fetching&&(!inventory.items||!inventory.items.length)&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__build_src_app_components_GuideOverlay__["a" /* default */],{theme:app.theme},inventory.error&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('p',{style:{color:'Red'}},t('Error loading objects')),!inventory.error&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('p',null,t('Guide no objects')),canCreateBlankSale&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__build_node_modules_office_ui_fabric_react_lib_Link__["Link"],{onClick:this.handleOpenNewSalePanel},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('i',{className:'ms-Icon ms-Icon--CirclePlus','aria-hidden':'true'}),' ',t('Create new listing')))),(inventory.selectedItem||inventory.fetchingItem)&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__build_node_modules_office_ui_fabric_react_lib_Panel__["a" /* Panel */],{headerText:this.isTest?t('Start new test sale'):t('Start new sale'),type:__WEBPACK_IMPORTED_MODULE_11__build_node_modules_office_ui_fabric_react_lib_Panel__["b" /* PanelType */].medium,isOpen:true,onRenderFooterContent:this.renderPanelFooterContent,isFooterAtBottom:true,onDismiss:function onDismiss(){return inventory.deselect();}},inventory.fetchingItem?__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{style:{marginTop:5}},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__build_src_app_components_LoadingOverlay__["a" /* default */],{label:t('Loading details')+'...'})):__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__["Fragment"],null,this.isTest&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12 ms-lg12'},t('test_sale_explanation'))),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(SearchPanelContent,{item:inventory.selectedItem,toc:this.toc,intl:intl,t:t}),typeof inventory.selectedItem.docs!=='undefined'&&inventory.selectedItem.docs.length>0&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12 ms-lg3 ms-fontWeight-semibold'},t('Documents'),':'),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12 ms-lg9'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__Documents__["a" /* default */],{documents:this.documents,t:t,onSelectionChanged:this.handleDocumentSelectionChanged})))),__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12 ms-lg12'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__build_src_app_components_BehalfOfAgentsDropdown__["a" /* default */],{agents:inventory.agentsForSelectedItem,selectedAgent:inventory.selectedAgent,onAgentChanged:this.handleAgentChanged})))),app.canMls&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__build_node_modules_office_ui_fabric_react_lib_Dropdown__["a" /* Dropdown */],{label:t('MLS'),selectedKey:this.mls,onChange:this.handleMlsChange,options:user.userConfig.mlsTypes.map(function(key){return{key:key,text:t('mls::'+key)};}),required:true})))),app.tenantConfig.features.packageAuctions&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__build_node_modules_office_ui_fabric_react_lib_Dropdown__["a" /* Dropdown */],{label:t('Select master sale'),selectedKey:this.masterSaleId,onChange:function onChange(_,_ref3){var key=_ref3.key;return _this3.masterSaleId=key;},options:[{text:t('not part of master sale'),key:''},{text:t('is master sale'),key:'master'}].concat(_toConsumableArray(inventory.masterSales))})))),app.tenantConfig.features.allowSelfRegistration&&(!this.masterSaleId||this.masterSaleId==='master')&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-row'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement('div',{className:'ms-Grid-col ms-sm12'},__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__build_node_modules_office_ui_fabric_react_lib_Checkbox__["a" /* Checkbox */],{onChange:function onChange(_,checked){return _this3.selfRegistration=checked;},value:this.selfRegistration,label:t('Self registration')})))))),this.openNewSalePanel&&__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__build_src_app_components_SaleCreatePanel__["a" /* default */],{isTest:this.isTest,onClose:function onClose(){return _this3.openNewSalePanel=false;}})));}}]);return Search;}(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__["Component"]),_class3.displayName='Search',_temp),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'toc',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,'openNewSalePanel',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor3=_applyDecoratedDescriptor(_class2.prototype,'creating',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor4=_applyDecoratedDescriptor(_class2.prototype,'mls',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor5=_applyDecoratedDescriptor(_class2.prototype,'masterSaleId',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor6=_applyDecoratedDescriptor(_class2.prototype,'selfRegistration',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor7=_applyDecoratedDescriptor(_class2.prototype,'isTest',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor8=_applyDecoratedDescriptor(_class2.prototype,'documents',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}}),_applyDecoratedDescriptor(_class2.prototype,'selectedDocumentsCount',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class2.prototype,'selectedDocumentsCount'),_class2.prototype),_descriptor9=_applyDecoratedDescriptor(_class2.prototype,'processedDocumentsCount',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return 0;}}),_applyDecoratedDescriptor(_class2.prototype,'documentUploadErrorsCount',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class2.prototype,'documentUploadErrorsCount'),_class2.prototype),_applyDecoratedDescriptor(_class2.prototype,'tocDisabled',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class2.prototype,'tocDisabled'),_class2.prototype),_descriptor10=_applyDecoratedDescriptor(_class2.prototype,'handleAddNew',[__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this4=this;return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3(){var _props4,inventory,sale,app,user,t,_inventory$selectedIt,id,inventoryId,agentData,saleFeatures,offerData,command,inventoryUrl,i,doc,url,file;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_props4=_this4.props,inventory=_props4.inventory,sale=_props4.sale,app=_props4.app,user=_props4.user,t=_props4.t;_inventory$selectedIt=inventory.selectedItem,id=_inventory$selectedIt.id,inventoryId=_inventory$selectedIt.inventoryId;_this4.creating=true;_this4.processedDocumentsCount=0;_this4.documents.forEach(function(doc){doc._error=null;});_this4.creationAbortController=typeof window.AbortController!=='undefined'?new window.AbortController():null;_context3.prev=6;agentData=Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx__["n" /* toJS */])(inventory.saleAgent);saleFeatures=app.getSaleFeatures({test:!!_this4.isTest,isMasterSale:_this4.masterSaleId==='master',disableAutomaticReminders:!!_this4.masterSaleId&&_this4.masterSaleId!=='master',selfRegistration:!!_this4.selfRegistration});offerData=Object.assign({},user.userConfig.defaultSaleOfferData||{},inventory.selectedItem.private);command={referenceId:(id||'').toString(),masterSaleId:!_this4.masterSaleId||_this4.masterSaleId==='master'?undefined:_this4.masterSaleId,itemData:Object.assign({},inventory.selectedItem.public,{agent:agentData}),offerData:offerData,agentData:agentData,integrations:inventory.selectedItem.integrations,offerForm:offerData.offer_form,docs:[],mls:_this4.mls,features:saleFeatures};//TODO: command.offerData.sale_country from inventory?
if(!command.offerData.sale_country&&!!app.data&&!!app.data.sale_country)command.offerData.sale_country=app.data.sale_country;if(!(_this4.selectedDocumentsCount>0)){_context3.next=37;break;}inventoryUrl=app.config.inventory.url+(app.config.inventory.url.endsWith('/')?'':'/');i=0;case 15:if(!(i<_this4.documents.length)){_context3.next=37;break;}doc=_this4.documents[i];if(!(!doc._disabled&&doc._selected)){_context3.next=32;break;}_this4.processedDocumentsCount++;if(doc._uploaded){_context3.next=31;break;}// document not yet retrieved from Inventory, so try to retrieve it now
// if the returned document URL contains '://' consider it an absolute URL,
// if not, consider it relative to the Inventory URL
url=doc.url.includes('://')?doc.url:inventoryUrl+doc.url;_context3.prev=21;_context3.next=24;return Object(__WEBPACK_IMPORTED_MODULE_24__build_src_app_services_request__["d" /* get */])(url,user.accessToken,null,_this4.creationAbortController?_this4.creationAbortController.signal:null);case 24:file=_context3.sent;if(file.url)doc._uploaded={id:file.id||doc.id,originalFilename:doc.fileName,url:file.url,type:doc.type,uploadedAt:__WEBPACK_IMPORTED_MODULE_4__build_node_modules_moment_timezone___default.a.utc().format(),short:doc.type?t('documenttype::'+doc.type):'',full:doc.type?t('documenttype::'+doc.type+'_long',{},'documenttype::'+doc.type):'',fileName:doc.type};_context3.next=31;break;case 28:_context3.prev=28;_context3.t0=_context3['catch'](21);if(!_this4.creationAbortController||!_this4.creationAbortController.signal.aborted)doc._error=t('Error retrieving file')+(typeof _context3.t0.response!=='undefined'?' ('+_context3.t0.response+')':'');case 31:if(doc._uploaded)command.docs.push(doc._uploaded);case 32:if(!(_this4.creationAbortController&&_this4.creationAbortController.signal.aborted)){_context3.next=34;break;}return _context3.abrupt('break',37);case 34:i++;_context3.next=15;break;case 37:if(!(_this4.documentUploadErrorsCount===0)){_context3.next=46;break;}if(!(!_this4.creationAbortController||!_this4.creationAbortController.signal.aborted)){_context3.next=46;break;}_this4.toc=false;inventory.deselect();_context3.next=43;return sale.start(command);case 43:if(!(app.features&&app.features.deleteSaleFromInventory)){_context3.next=46;break;}_context3.next=46;return inventory.delete(inventoryId);case 46:_context3.prev=46;_this4.creating=false;_this4.creationAbortController=null;return _context3.finish(46);case 50:case'end':return _context3.stop();}}},_callee3,_this4,[[6,,46,50],[21,28]]);}));}})),_class2))||_class)||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (Search);

/***/ }),
/* 2270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Documents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_Checkbox__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_MessageBar__ = __webpack_require__(112);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Documents=(_dec=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["d" /* inject */])('app'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["e" /* observer */])(_class=(_temp2=_class2=function(_Component){_inherits(Documents,_Component);function Documents(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Documents);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Documents.__proto__||Object.getPrototypeOf(Documents)).call.apply(_ref,[this].concat(args))),_this),_this.handleChangeBool=function(id){return function(ev,checked){var onSelectionChanged=_this.props.onSelectionChanged;if(onSelectionChanged)onSelectionChanged(id,checked);};},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Documents,[{key:'render',value:function render(){var _this2=this;var _props=this.props,documents=_props.documents,t=_props.t;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('ul',{style:{listStyle:'none',padding:0}},documents.map(function(doc){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',{key:doc.id},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_office_ui_fabric_react_lib_Checkbox__["a" /* Checkbox */],{label:doc.title+' ('+doc.fileName+')'+(doc.type?', '+t('documenttype::'+doc.type):''),name:'document_'+doc.id,checked:doc._selected,onChange:_this2.handleChangeBool(doc.id),disabled:doc._disabled}),doc._error&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{style:{padding:'5px 0 10px 28px',color:'rgb(168, 0, 0)',fontSize:'smaller'}},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',null,doc._error)));})),documents.filter(function(d){return d._disabled;}).length>0&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_MessageBar__["a" /* MessageBar */],{messageBarType:__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_MessageBar__["b" /* MessageBarType */].warning},t('Allowed file formats')));}}]);return Documents;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class2.displayName='Documents',_temp2))||_class)||_class);

/***/ }),
/* 2271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_styled_components__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Button__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_src_app_helpers_websockets__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ActionSelector__ = __webpack_require__(2272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Results__ = __webpack_require__(2273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__build_src_app_components_NotificationPreview__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_queryString__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__build_node_modules_mobx__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp2;var _templateObject=_taggedTemplateLiteral(['\n  display: flex;\n  flex-flow: row-reverse nowrap;\n  box-shadow: 0 0 15 #767676;\n\n  .control {\n    flex: 2 2;\n    padding-right: 2em;\n  }\n\n  .hint {\n    flex: 1 1;\n    width: 20em;\n    box-sizing: border-box;\n    padding: 1em 1em 1em 2em;\n    border: solid 2px ',';\n    color: ',';\n  }\n\n  @media only screen and (max-width: 479px) {\n    flex-flow: column nowrap;\n    box-shadow: 0;\n    .control {\n      padding-right: 0;\n    }\n    .hint {\n      border: solid 1px ',';\n      width: auto;\n    }\n  }\n'],['\n  display: flex;\n  flex-flow: row-reverse nowrap;\n  box-shadow: 0 0 15 #767676;\n\n  .control {\n    flex: 2 2;\n    padding-right: 2em;\n  }\n\n  .hint {\n    flex: 1 1;\n    width: 20em;\n    box-sizing: border-box;\n    padding: 1em 1em 1em 2em;\n    border: solid 2px ',';\n    color: ',';\n  }\n\n  @media only screen and (max-width: 479px) {\n    flex-flow: column nowrap;\n    box-shadow: 0;\n    .control {\n      padding-right: 0;\n    }\n    .hint {\n      border: solid 1px ',';\n      width: auto;\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  .card {\n    max-width: 80em;\n    margin: 2em auto;\n    padding: 1em 1em 5em 1em;\n\n    box-shadow: rgba(0, 0, 0, 0.4) 0px 0px 5px 0px;\n    box-sizing: border-box;\n\n    position: relative;\n  }\n\n  .actions {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    box-sizing: border-box;\n    width: 100%;\n    padding: 1em;\n    display: flex;\n    justify-content: space-between;\n    border-top: solid 1px #eee;\n\n    .buttons > * {\n      margin-left: 1em;\n    }\n  }\n\n  @media only screen and (max-width: 479px) {\n    .card {\n      max-width: 479px;\n      margin-top: 0;\n      box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 0px;\n      position: initial;\n    }\n  }\n'],['\n  .card {\n    max-width: 80em;\n    margin: 2em auto;\n    padding: 1em 1em 5em 1em;\n\n    box-shadow: rgba(0, 0, 0, 0.4) 0px 0px 5px 0px;\n    box-sizing: border-box;\n\n    position: relative;\n  }\n\n  .actions {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    box-sizing: border-box;\n    width: 100%;\n    padding: 1em;\n    display: flex;\n    justify-content: space-between;\n    border-top: solid 1px #eee;\n\n    .buttons > * {\n      margin-left: 1em;\n    }\n  }\n\n  @media only screen and (max-width: 479px) {\n    .card {\n      max-width: 479px;\n      margin-top: 0;\n      box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 0px;\n      position: initial;\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  list-style: none outside;\n  margin: 1em;\n  padding: 0em;\n\n  display: flex;\n  flex-flow: row nowrap;\n  justify-items: center;\n'],['\n  list-style: none outside;\n  margin: 1em;\n  padding: 0em;\n\n  display: flex;\n  flex-flow: row nowrap;\n  justify-items: center;\n']),_templateObject4=_taggedTemplateLiteral(['\n  color: #767676;\n\n  &:before {\n    content: \' > \';\n    font-weight: normal;\n    display: inline-block;\n    text-align: center;\n    width: 3em;\n  }\n\n  .index {\n    border: solid 2px #767676;\n    border-radius: 1em;\n    margin-right: 0.2em;\n    display: inline-block;\n    width: 1.8em;\n    line-height: 1.8em;\n    text-align: center;\n    font-weight: bold;\n  }\n\n  white-space: nowrap;\n\n  &.selected {\n    font-weight: bold;\n\n    .index {\n      background: #767676;\n      color: #fff;\n    }\n  }\n\n  &:first-child:before {\n    display: none;\n  }\n\n  &.selected:first-child ~ li {\n    display: none;\n  }\n\n  @media only screen and (max-width: 479px) {\n    &:before {\n      content: \'>\';\n      width: 1.5em;\n    }\n    .index {\n      border: solid 1px #767676;\n      border-radius: 1em;\n      margin-right: 0.1em;\n      display: inline-block;\n      width: 1.5em;\n      line-height: 1.5em;\n    }\n    .title {\n      display: none;\n    }\n    &.selected:first-child {\n      .title {\n        display: initial;\n      }\n    }\n  }\n'],['\n  color: #767676;\n\n  &:before {\n    content: \' > \';\n    font-weight: normal;\n    display: inline-block;\n    text-align: center;\n    width: 3em;\n  }\n\n  .index {\n    border: solid 2px #767676;\n    border-radius: 1em;\n    margin-right: 0.2em;\n    display: inline-block;\n    width: 1.8em;\n    line-height: 1.8em;\n    text-align: center;\n    font-weight: bold;\n  }\n\n  white-space: nowrap;\n\n  &.selected {\n    font-weight: bold;\n\n    .index {\n      background: #767676;\n      color: #fff;\n    }\n  }\n\n  &:first-child:before {\n    display: none;\n  }\n\n  &.selected:first-child ~ li {\n    display: none;\n  }\n\n  @media only screen and (max-width: 479px) {\n    &:before {\n      content: \'>\';\n      width: 1.5em;\n    }\n    .index {\n      border: solid 1px #767676;\n      border-radius: 1em;\n      margin-right: 0.1em;\n      display: inline-block;\n      width: 1.5em;\n      line-height: 1.5em;\n    }\n    .title {\n      display: none;\n    }\n    &.selected:first-child {\n      .title {\n        display: initial;\n      }\n    }\n  }\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Confirmation=function Confirmation(_ref){var className=_ref.className,_ref$store=_ref.store,summaryClass=_ref$store.summaryClass,actionStore=_ref$store.actionStore;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:className},Object(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["createElement"])(summaryClass,{store:actionStore}));};var Results=function Results(_ref2){var theme=_ref2.theme,store=_ref2.store,history=_ref2.history;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',null,store.resultsClass&&Object(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["createElement"])(store.resultsClass,{key:'results',theme:theme,store:store,history:history}),!store.resultsClass&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Results__["a" /* default */],{key:'results',theme:theme,store:store,history:history}));};var Action=function Action(_ref3){var className=_ref3.className,_ref3$store=_ref3.store,currentActionStep=_ref3$store.currentActionStep,actionStore=_ref3$store.actionStore,onValidChanged=_ref3.onValidChanged;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:className},Object(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["createElement"])(currentActionStep,{store:actionStore,onValidChanged:onValidChanged}));};var Info=function Info(_ref4){var _ref4$store=_ref4.store,currentActionInfo=_ref4$store.currentActionInfo,actionStore=_ref4$store.actionStore;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,currentActionInfo&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,Object(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["createElement"])(currentActionInfo,{store:actionStore})));};var StyledAction=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_styled_components__["a" /* default */])(Action)(_templateObject,function(props){return props.theme.palette.themePrimary;},function(props){return props.theme.palette.themePrimary;},function(props){return props.theme.palette.themePrimary;});var Content=__WEBPACK_IMPORTED_MODULE_1__build_node_modules_styled_components__["a" /* default */].div(_templateObject2);var Breadcrumbs=__WEBPACK_IMPORTED_MODULE_1__build_node_modules_styled_components__["a" /* default */].ul(_templateObject3);var BreadcrumbItem=Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_styled_components__["a" /* default */])(function(_ref5){var index=_ref5.index,title=_ref5.title,rest=_objectWithoutProperties(_ref5,['index','title']);return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',rest,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',{className:'index'},index),' ',__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',{className:'title'},title));})(_templateObject4);var SaleWizard=(_dec=Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__["d" /* inject */])('saleWizard','sale','user','app'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_5__build_src_app_components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__["e" /* observer */])(_class=(_temp2=_class2=function(_Component){_inherits(SaleWizard,_Component);function SaleWizard(){var _ref6;var _temp,_this,_ret;_classCallCheck(this,SaleWizard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref6=SaleWizard.__proto__||Object.getPrototypeOf(SaleWizard)).call.apply(_ref6,[this].concat(args))),_this),_this.handleBack=function(){var _this$props=_this.props,history=_this$props.history,saleWizard=_this$props.saleWizard;history.push('/dashboard/'+saleWizard.source.saleId);},_this.onValidChanged=function(valid){var saleWizard=_this.props.saleWizard;saleWizard.currentStepValidChanged(valid);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SaleWizard,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,sale=_props.sale,saleWizard=_props.saleWizard,match=_props.match;if(!sale.connected){var uri=Object(__WEBPACK_IMPORTED_MODULE_4__build_src_app_helpers_websockets__["a" /* websocketsUri */])('/events/v1/sale?sid='+encodeURIComponent(match.params.sale));sale.connect(uri);}var disposer=Object(__WEBPACK_IMPORTED_MODULE_10__build_node_modules_mobx__["p" /* when */])(function(){return sale.connected&&sale.saleId;},function(){var action=Object(__WEBPACK_IMPORTED_MODULE_9__helpers_queryString__["a" /* getQueryStringValue */])('action');if(!!action){saleWizard.selectActionByKey(action);}disposer();});}},{key:'renderActionStep',value:function renderActionStep(){var _props$saleWizard=this.props.saleWizard,currentActionStep=_props$saleWizard.currentActionStep,actionStore=_props$saleWizard.actionStore;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',null,Object(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["createElement"])(currentActionStep,{store:actionStore}));}},{key:'render',value:function render(){var _props2=this.props,t=_props2.t,history=_props2.history,app=_props2.app,sale=_props2.sale;if(!sale.connected){return null;// TODO: spinner?
}var _props$saleWizard2=this.props.saleWizard,currentAction=_props$saleWizard2.currentAction,currentStep=_props$saleWizard2.currentStep,isInitialStep=_props$saleWizard2.isInitialStep,isActionStep=_props$saleWizard2.isActionStep,isConfirmationStep=_props$saleWizard2.isConfirmationStep,isResultsStep=_props$saleWizard2.isResultsStep,breadcrumbs=_props$saleWizard2.breadcrumbs,showPrevious=_props$saleWizard2.showPrevious,showNext=_props$saleWizard2.showNext,showSubmit=_props$saleWizard2.showSubmit,handlePrevious=_props$saleWizard2.handlePrevious,handleNext=_props$saleWizard2.handleNext,handleSubmit=_props$saleWizard2.handleSubmit;var item=this.props.saleWizard.source.item;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'title'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('a',{className:'back',onClick:this.handleBack},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('i',{className:'ms-Icon ms-Icon--NavigateBack','aria-hidden':'true'}),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',null,t('Back'))),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',null,isInitialStep?t('Sale wizard'):t(currentAction+' title')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('span',{className:'collapsible'},item.number,': ',item.title)),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(Breadcrumbs,{className:'menu'},breadcrumbs.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(BreadcrumbItem,{key:item,className:index===currentStep?'selected':'',index:index+1,title:t(item+' title')});})),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(Content,{className:'content'},isInitialStep?__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_ActionSelector__["a" /* default */],{theme:app.theme,key:'initial',className:'ms-fadeIn100',store:this.props.saleWizard,t:t}):__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'card'},isConfirmationStep&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(Confirmation,{key:'confirm',className:'ms-fadeIn100',store:this.props.saleWizard}),isActionStep&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(StyledAction,{theme:app.theme,key:'action',className:'ms-fadeIn100',store:this.props.saleWizard,onValidChanged:this.onValidChanged}),isResultsStep&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(Results,{theme:app.theme,store:this.props.saleWizard,history:history}),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'actions'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'info'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(Info,{store:this.props.saleWizard})),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'buttons'},showPrevious&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Button__["c" /* Button */],{onClick:handlePrevious},t('Previous')),showNext&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Button__["h" /* PrimaryButton */],{onClick:handleNext},t('Next')),showSubmit&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_office_ui_fabric_react_lib_Button__["h" /* PrimaryButton */],{onClick:handleSubmit},t('Submit')),showSubmit&&currentAction==='award'&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__build_src_app_components_NotificationPreview__["a" /* default */],{action:'/api/v1/wizard/'+this.props.saleWizard.source.saleId+'/award/notifications',trigger:'button',query:{locale:this.props.saleWizard.source.user.claims.locale},data:{buyerId:this.props.saleWizard.actionStore.selectedBuyerId,message:this.props.saleWizard.actionStore.message,rejectMessage:this.props.saleWizard.actionStore.rejectMessage}}),showSubmit&&currentAction==='confirmAward'&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__build_src_app_components_NotificationPreview__["a" /* default */],{action:'/api/v1/wizard/'+this.props.saleWizard.source.saleId+'/award/confirm/notifications',trigger:'button',query:{locale:this.props.saleWizard.source.user.claims.locale},data:{rejectMessage:this.props.saleWizard.actionStore.rejectMessage}}),showSubmit&&currentAction==='increase'&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__build_src_app_components_NotificationPreview__["a" /* default */],{action:'/api/v1/wizard/'+this.props.saleWizard.source.saleId+'/increase/notifications',trigger:'button',query:{locale:this.props.saleWizard.source.user.claims.locale},data:{message:this.props.saleWizard.actionStore.message,round:Object.assign({},this.props.saleWizard.actionStore.roundEditStore.saveableRound,{message:this.props.saleWizard.actionStore.buyerMessage}),acceptOffers:this.props.saleWizard.actionStore.acceptedOffers,rejectOffers:this.props.saleWizard.actionStore.rejectedOffers}}),showSubmit&&currentAction==='rejectAll'&&__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__build_src_app_components_NotificationPreview__["a" /* default */],{action:'/api/v1/wizard/'+this.props.saleWizard.source.saleId+'/rejectall/notifications',trigger:'button',query:{locale:this.props.saleWizard.source.user.claims.locale},data:{message:this.props.saleWizard.actionStore.message}}))))));}}]);return SaleWizard;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class2.displayName='SaleWizard',_temp2))||_class)||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (SaleWizard);

/***/ }),
/* 2272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_styled_components__ = __webpack_require__(47);
var _templateObject=_taggedTemplateLiteral(['\n  display: flex;\n  flex-flow: row wrap;\n\n  justify-content: center;\n'],['\n  display: flex;\n  flex-flow: row wrap;\n\n  justify-content: center;\n']),_templateObject2=_taggedTemplateLiteral(['\n  width: 30em;\n  height: 32em;\n  box-sizing: border-box;\n  margin: 1em 2em;\n\n  cursor: pointer;\n\n  border: solid 2px ',';\n  background: ','00;\n  transition: background-color 0.5s;\n\n  display: grid;\n  grid: 5em 7em auto / 7em auto;\n  grid-template-areas:\n    \'header header\'\n    \'icon subtitle\'\n    \'description description\';\n\n  > i {\n    grid-area: icon;\n    color: ',';\n    font-size: 4em;\n    font-weight: bold;\n    text-align: center;\n    padding-top: 2rem;\n  }\n\n  > h2 {\n    grid-area: header;\n    margin: 0;\n    font-size: 1.7em;\n    line-height: 2.9;\n    text-align: center;\n    background: ',';\n    color: #fff;\n  }\n\n  > .subtitle {\n    grid-area: subtitle;\n    font-weight: bold;\n    padding: 1em;\n  }\n\n  > .description {\n    grid-area: description;\n    padding: 0 2em;\n    font-size: 0.9em;\n    ul,\n    li {\n      margin: 0;\n      padding: 0;\n    }\n    ul {\n      margin: 1em 0 0 1em;\n    }\n  }\n\n  @media only screen and (max-width: 479px) {\n    margin: 0.5em;\n    height: auto;\n    grid-template-areas:\n      \'header header\'\n      \'data data\';\n    i {\n      display: none;\n    }\n    div {\n      padding: 0 2em;\n      ul {\n        margin: 1em 0;\n      }\n    }\n    h2 {\n      line-height: initial;\n      font-size: 1.5em;\n      line-height: 1.5;\n    }\n  }\n\n  &:hover {\n    background: ','11;\n    box-shadow: 0 0 20px #777;\n  }\n'],['\n  width: 30em;\n  height: 32em;\n  box-sizing: border-box;\n  margin: 1em 2em;\n\n  cursor: pointer;\n\n  border: solid 2px ',';\n  background: ','00;\n  transition: background-color 0.5s;\n\n  display: grid;\n  grid: 5em 7em auto / 7em auto;\n  grid-template-areas:\n    \'header header\'\n    \'icon subtitle\'\n    \'description description\';\n\n  > i {\n    grid-area: icon;\n    color: ',';\n    font-size: 4em;\n    font-weight: bold;\n    text-align: center;\n    padding-top: 2rem;\n  }\n\n  > h2 {\n    grid-area: header;\n    margin: 0;\n    font-size: 1.7em;\n    line-height: 2.9;\n    text-align: center;\n    background: ',';\n    color: #fff;\n  }\n\n  > .subtitle {\n    grid-area: subtitle;\n    font-weight: bold;\n    padding: 1em;\n  }\n\n  > .description {\n    grid-area: description;\n    padding: 0 2em;\n    font-size: 0.9em;\n    ul,\n    li {\n      margin: 0;\n      padding: 0;\n    }\n    ul {\n      margin: 1em 0 0 1em;\n    }\n  }\n\n  @media only screen and (max-width: 479px) {\n    margin: 0.5em;\n    height: auto;\n    grid-template-areas:\n      \'header header\'\n      \'data data\';\n    i {\n      display: none;\n    }\n    div {\n      padding: 0 2em;\n      ul {\n        margin: 1em 0;\n      }\n    }\n    h2 {\n      line-height: initial;\n      font-size: 1.5em;\n      line-height: 1.5;\n    }\n  }\n\n  &:hover {\n    background: ','11;\n    box-shadow: 0 0 20px #777;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var icons={counteroffer:'Sync',increase:'PageAdd',award:'DecisionSolid',awardAll:'CheckList',confirmAward:'CheckMark',reject:'Cancel',rejectAll:'Cancel',duplicate:'Copy',reset:'Refresh',edit:'CircleStop',close:'CircleStop',abort:'CircleStop',notifySeller:'Mail'};var descriptions={counteroffer:function counteroffer(t){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('ul',null,t('counteroffer').split('\n').filter(function(a){return!!a;}).map(function(t,i){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',{key:i},t);})));},increase:function increase(t){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('ul',null,t('increase').split('\n').filter(function(a){return!!a;}).map(function(t,i){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',{key:i},t);})));},award:function award(t){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('ul',null,t('award').split('\n').filter(function(a){return!!a;}).map(function(t,i){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',{key:i},t);})));},awardAll:function awardAll(t){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('ul',null,t('awardAll').split('\n').filter(function(a){return!!a;}).map(function(t,i){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',{key:i},t);})));},confirmAward:function confirmAward(t){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('ul',null,t('confirmAward').split('\n').filter(function(a){return!!a;}).map(function(t,i){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',{key:i},t);})));},reject:function reject(t){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('ul',null,t('reject').split('\n').filter(function(a){return!!a;}).map(function(t,i){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',{key:i},t);})));},rejectAll:function rejectAll(t){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('ul',null,t('rejectAll').split('\n').filter(function(a){return!!a;}).map(function(t,i){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',{key:i},t);})));},duplicate:function duplicate(t){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('ul',null,t('duplicate').split('\n').filter(function(a){return!!a;}).map(function(t,i){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',{key:i},t);})));},notifySeller:function notifySeller(t){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('ul',null,t('notifySeller').split('\n').filter(function(a){return!!a;}).map(function(t,i){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('li',{key:i},t);})));}};var ActionWrapper=__WEBPACK_IMPORTED_MODULE_1__build_node_modules_styled_components__["a" /* default */].section(_templateObject);var ActionItem=__WEBPACK_IMPORTED_MODULE_1__build_node_modules_styled_components__["a" /* default */].a(_templateObject2,function(props){return props.theme.palette.themePrimary;},function(props){return props.theme.palette.themePrimary;},function(props){return props.theme.palette.themePrimary;},function(props){return props.theme.palette.themePrimary;},function(props){return props.theme.palette.themePrimary;});/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var className=_ref.className,_ref$store=_ref.store,availableActions=_ref$store.availableActions,handleSelectAction=_ref$store.handleSelectAction,theme=_ref.theme,t=_ref.t;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(ActionWrapper,{className:className+' clearfix'},availableActions&&availableActions.map(function(item){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(ActionItem,{key:item,onClick:handleSelectAction(item),theme:theme},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('i',{className:'ms-Icon ms-Icon--'+icons[item],'aria-hidden':'true'}),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('h2',null,t(item+' title')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'subtitle'},t(item+' subtitle')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',{className:'description'},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('p',null,t('action functionality')),descriptions[item](t)));}));});

/***/ }),
/* 2273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_styled_components__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_src_app_components_Localization__ = __webpack_require__(8);
var _templateObject=_taggedTemplateLiteral(['\n  margin-top: 3em;\n  display: block;\n  text-align: center;\n  color: ',';\n  font-size: 1.5em;\n  cursor: pointer;\n\n  i {\n    margin-right: 0.2em;\n  }\n'],['\n  margin-top: 3em;\n  display: block;\n  text-align: center;\n  color: ',';\n  font-size: 1.5em;\n  cursor: pointer;\n\n  i {\n    margin-right: 0.2em;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var BackButton=__WEBPACK_IMPORTED_MODULE_1__build_node_modules_styled_components__["a" /* default */].a(_templateObject,function(props){return props.theme.palette.themePrimary;});/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__build_src_app_components_Localization__["a" /* localizable */])('SaleWizardResult')(function(_ref){var history=_ref.history,store=_ref.store,t=_ref.t,theme=_ref.theme;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('h1',null,t('Confirmation')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('p',null,t('Successful')),__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(BackButton,{theme:theme,onClick:function onClick(){return history.push('/dashboard/'+store.source.saleId);}},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement('i',{className:'ms-Icon ms-Icon--NavigateBack','aria-hidden':'true'}),t('Back to sale')));}));

/***/ }),
/* 2274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_src_app_components_Localization__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_src_app_components_LoadingOverlay__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_src_app_components_MessageOverlay__ = __webpack_require__(2275);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_desc,_value,_class2,_descriptor,_descriptor2,_descriptor3,_class3,_temp2;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new __WEBPACK_IMPORTED_MODULE_6__build_src_app_components_MessageOverlay__["a" /* Error */]('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var Whitelisting=(_dec=Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__["d" /* inject */])('app','user','sale'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_4__build_src_app_components_Localization__["a" /* localizable */])(_class=Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__["e" /* observer */])(_class=(_class2=(_temp2=_class3=function(_Component){_inherits(Whitelisting,_Component);function Whitelisting(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Whitelisting);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Whitelisting.__proto__||Object.getPrototypeOf(Whitelisting)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'error',_descriptor,_this),_initDefineProp(_this,'ok',_descriptor2,_this),_initDefineProp(_this,'executing',_descriptor3,_this),_this.handleResponse=function(){var _this$props=_this.props,match=_this$props.match,history=_this$props.history;var sale=match.params.sale;history.push('/dashboard/'+sale);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Whitelisting,[{key:'componentDidMount',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(){var _props,sale,match,t,_match$params,action,userId,saleId;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_props=this.props,sale=_props.sale,match=_props.match,t=_props.t;_match$params=match.params,action=_match$params.action,userId=_match$params.user,saleId=_match$params.sale;_context.t0=action;_context.next=_context.t0==='accept'?5:_context.t0==='block'?9:13;break;case 5:_context.next=7;return sale.whitelisting.accept({userId:userId,saleId:saleId});case 7:this.ok=_context.sent;return _context.abrupt('break',15);case 9:_context.next=11;return sale.whitelisting.block({userId:userId,saleId:saleId});case 11:this.ok=_context.sent;return _context.abrupt('break',15);case 13:this.error=t('whitelisting_unknown_action');return _context.abrupt('break',15);case 15:if(!this.ok){this.error=t('whitelisting_error');}this.executing=false;case 17:case'end':return _context.stop();}}},_callee,this);}));function componentDidMount(){return _ref2.apply(this,arguments);}return componentDidMount;}()},{key:'render',value:function render(){var t=this.props.t;return this.executing?__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__build_src_app_components_LoadingOverlay__["a" /* default */],{fullscreen:true}):this.ok?__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_src_app_components_MessageOverlay__["b" /* Success */],{message:t('whitelisting_done'),onClick:this.handleResponse}):__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__build_src_app_components_MessageOverlay__["a" /* Error */],{message:this.error,onClick:this.handleResponse});}},{key:'hasResponse',get:function get(){return this.ok!==undefined;}}]);return Whitelisting;}(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react__["Component"]),_class3.displayName='Whitelisting',_temp2),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'error',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return undefined;}}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,'ok',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return undefined;}}),_descriptor3=_applyDecoratedDescriptor(_class2.prototype,'executing',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["j" /* observable */]],{enumerable:true,initializer:function initializer(){return true;}}),_applyDecoratedDescriptor(_class2.prototype,'hasResponse',[__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx__["d" /* computed */]],Object.getOwnPropertyDescriptor(_class2.prototype,'hasResponse'),_class2.prototype)),_class2))||_class)||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (Whitelisting);

/***/ }),
/* 2275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Error__ = __webpack_require__(2276);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Error__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Success__ = __webpack_require__(2278);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Success__["a"]; });


/***/ }),
/* 2276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OverlayMessage__ = __webpack_require__(889);
var Error=function Error(props){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__OverlayMessage__["a" /* default */],Object.assign({},props,{iconName:'Error'}));};/* harmony default export */ __webpack_exports__["a"] = (Error);

/***/ }),
/* 2277 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OverlayMessage__ = __webpack_require__(889);
var Success=function Success(props){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__OverlayMessage__["a" /* default */],Object.assign({},props,{iconName:'Accept'}));};/* harmony default export */ __webpack_exports__["a"] = (Success);

/***/ }),
/* 2279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_src_app_helpers_queryString__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_src_app_components_LoadingOverlay__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_src_app_services_WebStorage__ = __webpack_require__(393);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var withAuth=function withAuth(WrappedComponent){var _class,_temp;var AuthWrapper=(_temp=_class=function(_Component){_inherits(AuthWrapper,_Component);function AuthWrapper(props){_classCallCheck(this,AuthWrapper);var _this=_possibleConstructorReturn(this,(AuthWrapper.__proto__||Object.getPrototypeOf(AuthWrapper)).call(this,props));_this.storage=new __WEBPACK_IMPORTED_MODULE_5__build_src_app_services_WebStorage__["a" /* default */]();return _this;}_createClass(AuthWrapper,[{key:'componentDidMount',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(){var user,userToken,queryString;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:user=this.props.user;if(user.isAuthenticated){_context.next=9;break;}userToken=Object(__WEBPACK_IMPORTED_MODULE_3__build_src_app_helpers_queryString__["a" /* getQueryStringValue */])('usertoken');queryString=window.location.search;if(userToken){queryString=window.location.search.replace('usertoken='+userToken,'').replace('?&','?').replace('&&','&');}_context.next=7;return this.storage.set('origin',''+window.location.origin+window.location.pathname+queryString);case 7:_context.next=9;return user.signin();case 9:case'end':return _context.stop();}}},_callee,this);}));function componentDidMount(){return _ref.apply(this,arguments);}return componentDidMount;}()},{key:'render',value:function render(){var user=this.props.user;return!user.isAuthenticated?__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__build_src_app_components_LoadingOverlay__["a" /* default */],{fullscreen:true}):__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react___default.a.createElement(WrappedComponent,Object.assign({locale:user.profile.locale},this.props));}}]);return AuthWrapper;}(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_react__["Component"]),_class.displayName='AuthWrapper',_temp);return Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__["d" /* inject */])('user')(Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__["e" /* observer */])(AuthWrapper));};/* harmony default export */ __webpack_exports__["a"] = (withAuth);

/***/ }),
/* 2280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_react_intl__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_src_app_services_localeFactory__ = __webpack_require__(2281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_src_app_amarc21_locales__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_src_app_lbsi_locales__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__build_src_app_remax_at_locales__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__build_src_app_remax_it_locales__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__build_src_app_remax_de_locales__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__build_src_app_remax_ro_locales__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__build_src_app_propnow_locales__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__build_src_app_propnow_developments_locales__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__build_src_app_locales__ = __webpack_require__(890);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//const locales = require(`../../@${process.env.REACT_APP_TENANT}/locales`);
var withIntl=function withIntl(WrappedComponent){var _class,_temp;var IntlWrapper=(_temp=_class=function(_Component){_inherits(IntlWrapper,_Component);function IntlWrapper(){_classCallCheck(this,IntlWrapper);return _possibleConstructorReturn(this,(IntlWrapper.__proto__||Object.getPrototypeOf(IntlWrapper)).apply(this,arguments));}_createClass(IntlWrapper,[{key:'render',value:function render(){var locale=this.props.locale;var specific={};switch("propnow"){case'amarc21':specific=__WEBPACK_IMPORTED_MODULE_4__build_src_app_amarc21_locales__["default"];break;case'lbsi':specific=__WEBPACK_IMPORTED_MODULE_5__build_src_app_lbsi_locales__["default"];break;case'remax-at':specific=__WEBPACK_IMPORTED_MODULE_6__build_src_app_remax_at_locales__["default"];break;case'remax-it':specific=__WEBPACK_IMPORTED_MODULE_7__build_src_app_remax_it_locales__["default"];break;case'remax-de':specific=__WEBPACK_IMPORTED_MODULE_8__build_src_app_remax_de_locales__["default"];break;case'remax-ro':specific=__WEBPACK_IMPORTED_MODULE_9__build_src_app_remax_ro_locales__["default"];break;case'propnow':specific=__WEBPACK_IMPORTED_MODULE_10__build_src_app_propnow_locales__["default"];break;case'propnow-developments':specific=__WEBPACK_IMPORTED_MODULE_11__build_src_app_propnow_developments_locales__["default"];break;default:break;}var localeSet=Object(__WEBPACK_IMPORTED_MODULE_3__build_src_app_services_localeFactory__["a" /* default */])(locale,specific.invariant,__WEBPACK_IMPORTED_MODULE_12__build_src_app_locales__["a" /* default */],specific);return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_react_intl__["b" /* IntlProvider */],{locale:locale,messages:localeSet.messages,onError:function onError(){}},__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react___default.a.createElement(WrappedComponent,this.props));}}]);return IntlWrapper;}(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_react__["Component"]),_class.displayName='IntlWrapper',_temp);return Object(__WEBPACK_IMPORTED_MODULE_1__build_node_modules_mobx_react__["e" /* observer */])(IntlWrapper);};/* harmony default export */ __webpack_exports__["a"] = (withIntl);

/***/ }),
/* 2281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
function getParentLocale(locale){if(!locale||locale.indexOf('-')<0)return null;return locale.substring(0,locale.indexOf('-'));}function getApplicableLocales(locale,invariantLocale){var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(iterator);return Array.from(iterator(locale,invariantLocale)).filter(function(a){return a!=null;});function iterator(l,i){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function iterator$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!i){_context.next=5;break;}_context.next=3;return getParentLocale(i);case 3:_context.next=5;return i;case 5:if(!l){_context.next=10;break;}_context.next=8;return getParentLocale(l);case 8:_context.next=10;return l;case 10:case'end':return _context.stop();}}},_marked,this);}}function getLocale(locale,invariantLocale,generic,tenantSpecific){var result={messages:{}};var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=getApplicableLocales(locale,invariantLocale)[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var l=_step.value;result=Object.assign(Object.assign({},result,generic.locales&&generic.locales[l],tenantSpecific.locales&&tenantSpecific.locales[l]),{messages:Object.assign({},result.messages,generic.locales&&generic.locales[l]&&generic.locales[l].messages,tenantSpecific.locales&&tenantSpecific.locales[l]&&tenantSpecific.locales[l].messages,generic.messages&&generic.messages[l],tenantSpecific.messages&&tenantSpecific.messages[l])});}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return result;}

/***/ }),
/* 2282 */
/***/ (function(module, exports) {

module.exports = {"AuctionFinalsMatrix::for_each_property_pick_the_best_available_offer":"Für jede Immobilie das beste verfügbare Anbot auswählen","AuctionFinalsMatrix::for_each_property_pick_the_highest_offer_if_it_is_the_most_preferred_offer_of_the_highest_bidder":"Für jede Immobilie das höchste Anbot auswählen, wenn es das am meisten bevorzugte Anbot des Höchstbietenden ist","AuctionFinalsMatrix::for_each_property_pick_the_highest_offer_if_the_highest_bidder_has_not_been_assigned_to_another_property_yet":"Wählen Sie für jede Immobilie das höchste Anbot aus, wenn der Höchstbietende nicht einer anderen Immobilie zugewiesen wurde","AuctionFinalsMatrix::select_best_offers":"Beste Anbote auswählen","AuctionFinalsMatrix::select_highest_offers":"Wählen Sie die höchsten Anbote aus","AuctionFinalsMatrix::select_preferred_highest_offers":"Wählen Sie die bevorzugten höchsten Anbote aus","AuctionFinalsMatrix::this_is_the_highest_offer_for_this_property_but_its_not_selected":"Dies ist das höchste Anbot für dieses Objekt, aber es ist nicht ausgewählt","AuctionFinalsMatrix::this_is_the_most_preferred_offer_for_this_buyer_but_its_not_selected":"Dies ist das am meisten bevorzugte Anbot für diesen Käufer, aber es ist nicht ausgewählt","AwardAllStep1::loading_offers_please_wait":"Anbote werden geladen, bitte warten","AwardStep1::expiration_date":"Anbotsgültigkeit","AwardStep2::expiration_date":"Anbotsgültigkeit","AwardStep2::select_customers_to_reject_theirs_offer":"Wählen Sie diejenigen Anbote aus, die Sie endgültig ablehnen möchten.\nDiese abgelehnten Kunden erhalten automatisch eine entsprechende Benachrichtigung.\nAlle anderen Kunden, deren Anbot nicht abgelehnt wurde, erhalten bis zur Bestätigung des endgültigen Käufers keine weitere Nachricht. ","AwardSummary::rejected_customers_offers":"Abgelehnte Anbote","BiddingSection::the_highest_offer":"Das höchste Anbot","BiddingSection::the_next_minimum_offer":"Das nächste mindest Anbot","Commands::all_offers":"Alle Anbote","Commands::are_you_sure_to_end_round_early":"Sind Sie sicher? Wenn Sie die Runde beenden können keine Anbote mehr abgegeben werden.","Commands::are_you_sure_to_end_round_early_sealed":"Sind Sie sicher? Wenn Sie die Runde beenden können keine Anbote mehr abgegeben und Anbotshöhe wird offengelegt.","Commands::award":"Kaufanbot annehmen","Commands::blank_offer":"Blankoanbot PDF","Commands::offer":"Anbote","Commands::upload":"Anbot im Namen von Kunden hochladen","Confirmation::sale_round_not_opened":"Ihr Anbot kann nicht angenommen werden, da die Runde bereits geschlossen ist","ConfirmAwardSummary::if_you_click_finish_you_confirm_the_winner":"Wenn Sie \"Abschließen\" klicken, bestätigen Sie den Käufer. Alle anderen Anbote werden zurückgewiesen und die Kunden benachrichtigt.","ConfirmAwardSummary::rejected_customers_offers":"Abgelehnte Anbote","EditPanel::edit_offer_form":"Kaufanbotsformular vorbereiten","IncreaseStep1::all_other_offers_will_be_rejected":"Alle anderen Anbote werden abgelehnt und haben nicht die Möglichkeit an einer weiteren Runde teilzunehmen.","IncreaseStep2::validity_of_offers_set_to_the_same_value":"Der Zeitpunkt der Gültigkeit der Kaufanbote für die weiteren Anbote wurde automatisch auf den gleichen Wert wie bei der vorherigen Runde gesetzt.","ListingsOverview::pending_offers":"Offene Anbote","notificationemailtemplate::cust_bid_refused":"Anbot zurückgewiesen","notificationemailtemplate::cust_offer_placed":"Anbot abgegeben","notificationemailtemplate::cust_offer_raised":"Anbot erhöht","notificationemailtemplate::cust_offer_refused":"Anbot zurückgewiesen","notificationemailtemplate::cust_outbid":"Anbot überboten","notificationemailtemplate::cust_outbid_antisniping":"Anbot überboten","notificationemailtemplate::cust_phase_offer_starting":"Anbotsabgabe gestartet","notificationemailtemplate::cust_rejected_round_closed":"Anbot abgelehnt","notificationemailtemplate::cust_rejected_sold":"Anbot abgelehnt","notificationemailtemplate::cust_rejected_unsold":"Anbot abgelehnt","NotifySellerSummary::description":"Kaufanbote von folgenden Kunden werden direkt per E-Mail an den Abgeber gesendet:","offer":"Anbot","OfferDetailsForm::purchase_offer_valid_until":"Kaufanbot gültig bis","OffersSection::increase_offer_on_behalf_of_the_customer":"Anbot im Namen des Kunden erhöhen","OffersSection::upload_offer_on_behalf_of_a_customer":"Anbot im Namen des Kunden abgeben","Page2::exceptions":"Ausnahmen der Lastenfreiheit","phone_number_placeholder":"+43 660 00 00 000","RefuseDialog::refuse_an_offer":"Anbot zurückweisen","RegistrationPanel::upload_an_offer":"Anbot (im Kundennamen) hochladen","RegistrationPanel::upload_new_offer":"Neues Anbot im Namen des Kunden hochladen","RegistrationPanel::upload_offer":"Anbot hochladen","RejectSummary::click_finish_to_reject_all_offers":"Wenn Sie \"Abschließen\" klicken, werden alle Anbote abgelehnt und die Kunden informiert.","RoundEdit::allow_bidding_below_starting_price":"Anbote unter Startpreis zulassen","RoundEdit::allow_bidding_below_starting_price__tooltip":"Im offenen Verfahren können Interessenten normalerweise erst ab Startpreis bieten, was dazu führen kann, dass preissensiblere Kunden häufig nicht mitbieten. Mit dieser Option bieten Sie Interessenten die Möglichkeit, ein Anbot auch <u>unterhalb</u> des Startpreises abzugeben – aber oberhalb des vom Makler festgelegten (zunächst verdeckten) Mindestpreises. Dies hat den Vorteil, dass mehr Interessenten ein Anbot abgeben, da auch geringerpreisige Anbote zugelassen werden. Dies schafft ein breiteres Bieterfeld und kann dadurch die Verkaufschancen erhöhen. Alle Anbote unterhalb des Startpreises sind für andere Interessenten verdeckt, um einen negativen Anker-Effekt zu vermeiden. Erst Gebote ab Startpreis werden standardmäßig angezeigt, es sei denn, Sie aktivieren die Option „Anbote unter Startpreis anderen Bietern anzeigen“.","RoundEdit::allow_bidding_below_starting_price_hidden":"Anbote unter Startpreis zulassen (verdeckt)","RoundEdit::antisniping_notice":"Das Ende der Anbotsfrist wird automatisch um 15 Minuten verlängert, wenn innerhalb der letzten 15 Minuten vor Ende ein neues Anbot eingeht. Diese Verlängerung wiederholt sich solange, bis 15 Minuten lang kein weiteres Anbot mehr abgegeben wird.","RoundEdit::bidding_steps__tooltip":"Dies ist der Mindesterhöhungsbetrag bei neuen Kaufanboten. Jedes neue Anbot muss um mindestens diesen Betrag höher sein als das aktuelle Höchstgebot. Sollten Sie die Option „Gebote unter Höchstgebot zulassen“ gewählt haben, so bezieht sich der Mindestbietschritt auf das vorige Anbot des einzelnen Kunden, sollte dieser bereits ein Anbot abgegeben haben (weitere Information siehe Infobutton: „Gebote unter Höchstgebot zulassen“)","RoundEdit::estimate__tooltip":"Der Richtpreis ist ein Preis, der dem Kaufinteressenten als Richtwert kommuniziert wird. Dies dient als Hilfestellung bei der Festlegung seines eigenen Angebotspreises. Wichtig: Der Richtpreis stellt keinen Mindestpreis dar. D.h. der Interessent kann auch ein Anbot unterhalb des Richtpreises abgeben.","RoundEdit::flexible_bidding__tooltip":"Im offenen Verfahren müssen Interessenten normalerweise mit jedem neuen Anbot immer auch ein neues Höchstgebot abgeben, was dazu führen kann, dass einzelne Interessenten frühzeitig aussteigen oder vielleicht gar nicht erst mitbieten. Mit Auswahl dieser flexiblen Biet-Option hat der Interessent die Möglichkeit, ein Anbot auch <u>unterhalb</u> des aktuellen Höchstgebotes abzugeben. Das neue Gebot muss allerdings <u>über</u> dem vorigen Gebotspreis des entsprechenden Kunden liegen, sollte dieser bereits ein Anbot abgegeben haben. Hierbei ist der Mindestbietschritt maßgeblich und wird nur <b>auf sein eigenes Gebot</b> angewendet. Vorteil dieser Biet-Option ist es, dass dadurch einzelne Interessenten häufiger bieten und ein stärkeres Mittelfeld entsteht, da Bieter nicht vorzeitig aussteigen. Dies kann die Verkaufschancen erhöhen, insbesondere bei wenigen Interessenten bzw. wenn der Startpreis etwas zu hoch ist.","RoundEdit::hide_highest_bid__bid_history_for_nonbidders":"Andere Anbote erst <strong>nach</strong> eigener Angebotsabgabe anzeigen","RoundEdit::hide_highest_bid__bid_history_for_nonbidders__tooltip":"Aus Gründen der Transparenz werden normalerweise im offenen Verfahren das aktuelle Höchstgebot, sowie alle abgegebenen Kaufanbote, allen Eingeladenen von vornherein angezeigt – auch bevor sie selbst ein Anbot abgeben haben. Dies kann in Einzelfällen dazu führen, dass einzelne Interessenten, abgeschreckt durch bereits sehr hohe Gebotspreise, erst gar kein Anbot abgeben, obwohl sie gerne ein Anbot abgegeben hätten. Um dies zu vermeiden und jeden Kaufwilligen zu motivieren ebenfalls ein Kaufanbot abzugeben, kann diese Biet-Option hilfreich sein.","RoundEdit::min_price__tooltip":"Mindestkaufpreis, den Interessent bieten muss. Wird nur angezeigt, wenn Interessent ein Anbot unterhalb dieses Preises abgeben möchte.","RoundEdit::offer_validity":"Gültigkeit der Kaufanbote (Befristung)","RoundEdit::show_bids_below_starting_price":"Anbote unter Startpreis anderen Bietern anzeigen","RoundEdit::simple_offer_duration_suggestion_notice":"Dies ist die vorgeschlagene befristete Gültigkeit der Kaufanbote. Der Kaufinteressent kann diese allerdings bei Abgabe seines Anbotes ändern","RoundEdit::start__tooltip":"Sollten Sie die Interessenten <u>vor</u> Start des Angebotsverfahrens (Bietfrist) einladen, können diese bereits Ihre Daten eintragen, die Objektunterlagen einsehen und ein Anbot <u>vorbereiten</u>. Das Anbot kann aber noch <u>nicht abgegeben</u> werden! Sobald der Startzeitpunkt erreicht ist und die Bietfrist des Angebotsverfahrens begonnen hat, erhalten alle eingeladenen Interessenten eine Benachrichtigung und können dann beginnen, ihre Kaufanbote abzugeben.<br /><br /> Tipp: Die durchschnittliche Länge des Angebotsverfahrens, also der Zeitraum, in dem Anbote abgegeben werden können (Bietfrist), beträgt ca. 5-7 Tage. Dies schafft ausreichend Momentum und stellt gleichzeitig sicher, dass einzelne Interessenten nicht das Interesse an der Immobilie verlieren (was im Falle einer zu lang gewählten Bietzeit geschehen kann). Der Zeitraum von 5-7 Tagen setzt allerdings auch voraus, dass alle Interessenten zum Startzeitpunkt des Angebotsverfahrens bereits von Ihnen als Makler ausreichend vorqualifiziert worden sind, inkl. Besichtigung der Immobilie und Abklärung der Finanzierungsmöglichkeiten. Sollte allerdings bei der Mehrzahl der Interessenten die Finanzierung noch unklar sein und Sie daher die Option „Finanzierungsbestätigung“ hochladen beim Einladen der Interessenten wählen, so wählen Sie dann ebenfalls eine etwas längere Laufzeit des Angebotsverfahrens, um Interessenten genügend Zeit zu geben, auch während des laufenden Verfahrens noch ihre Finanzierung abzuklären. Bei weiteren Fragen hierzu kontaktieren Sie gerne unser Team.","RoundInfo::offer_validity":"Kaufanbote gültig","RoundItem::open_bidding_howitworkspoints":"- Der erste Bieter muss mindestens den Startpreis bieten\n- Jedes Gebot <b>muss höher sein als alle vorigen Anbote</b>\n- Jeder Kunde kann sein Anbot verbessern\n- Alle <b>Anbote sind sichtbar</b>\n- Kundennamen für andere Kunden anonymisiert\n- Expliziter Start und Ende der Verfahrens","RoundItem::sealed_bidding_howitworkspoints":"- Richtpreis kein Mindestpreis\n- Gebotshöhe <u>frei wählbar</u> \n- Jeder Kunde kann nur <u>ein</u> Anbot abgeben\n- Bieter und Gebote <u>verdeckt</u>\n- Fester Endtermin\n- <u>Keine</u> automatische Verlängerung bei Last-Minute Geboten","RoundItem::sealed_bidding_subtitle":"mit versteckten Anboten","RoundItem::simple_offer_howitworkspoints":"- Einfache digitale Anbotsabgabe\n- Listingpreis = Referenz\n- Angebotspreis <u>frei</u> wählbar\n- Kunde kann nur <u>ein</u> Anbot abgeben\n- Keine Information zu möglichen anderen Interessenten\n- Kein fester Endtermin\n- Möglichkeit, flexibel ins Offene Anbotsverfahren zu wechseln, wenn mehrere Kunden Anbote abgeben","RoundItem::simple_offer_title":"Digitales Kaufanbot","RoundItem::simple_offer_whentouseitpoints":"- Wenig Interessenten\n- Langer Verkaufsprozess\n- Kaufbereitschaft testen\n- Möglichkeit, Anbot unter Vorbehalt abzugeben","roundtype::simple_offer":"Digitales Kaufanbot","Sale::already_confirmed":"Dieser Kunde hat ein Kaufanbot abgegeben. Ein weiteres Anbot im Kundennamen ist nicht möglich.","Sale::guide__start_round_edit_sale":"Sie haben alle Pflichtfelder des Anbotsformulars ausgefüllt. Hier können Sie diese ggf. nochmal kontrollieren oder bearbeiten.","Sale::guide_action__edit_sale":"Kaufanbotsformular vorbereiten","Sale::guide_action__start_round_edit":"Kaufanbotsformular bearbeiten","Sale::guides__offers_present":"Sie können nun die \"Übersicht\" der Anbote mit dem Abgeber besprechen und seine Entscheidung dann im \"Rundenassistenten\" eingeben.","Sale::guides__round_closed":"Das Angebotsverfahren ist beendet. Sie können nun die \"Übersicht\" der Anbote mit dem Abgeber besprechen und seine Entscheidung dann im \"Rundenassistenten\" eingeben.","Sale::guides__upgrade":"Sie haben mehrere Anbote erhalten. Um das Verkaufsergebnis zu optimieren, können Sie zum Angebotsverfahren wechseln","Sale::invalid_bid_value":"Dieses Anbot kann nicht angenommen werden. Es liegt bereits ein höheres oder gleichwertiges vor. Bitte benachrichtigen Sie den Kunden, damit er sein Anbot anpassen kann.","Sale::open_round_info_notice_incremental_auction_flexible":"Sie öffnen eine <strong>flexible</strong> Runde mit <strong>Startpreis von {startPrice}</strong> die <strong>in {duration} Tagen</strong> nach Eingang vom ersten Anbot endet.</strong>","Sale::open_round_info_notice_openbidding_flexible":"Sie öffnen eine <strong>offene</strong> Runde mit <strong>Startpreis von {startPrice}</strong> die <strong>in {duration} Tagen</strong> nach Eingang vom ersten Anbot endet.</strong>","Sale::open_round_info_notice_sealedbidding_flexible":"Sie öffnen eine <strong>geschlossene</strong> Runde mit <strong>Richtpreis von {estimate}</strong> die <strong>in {duration} Tagen</strong> nach Eingang vom ersten Anbot endet.</strong>","Sale::open_round_info_notice_simple_offer_fixed":"Sie öffnen eine <strong>Digitale Kaufanbotsrunde</strong>.","Sale::open_round_info_notice_simple_offer_flexible":"Sie öffnen eine <strong>Digitale Kaufanbotsrunde</strong>.","Sale::you_are_about_to_upload_offer_in_the_name_of_customer":"Sie sind dabei das Kaufanbot im Namen des Kunden hochzuladen. Somit kann der Kunde sein Kaufanbot nicht mehr online abgeben. Unbedingt das original Anbotsformular aufheben! Wenn der Kunde später sein Anbot selbstständig erhöhen möchte, müssen Sie Ihn nach dem Hochladen noch zusätzlich einladen!","SaleWizard::award":"Sie können den vom Abgeber favorisierten Käufer über die Annahme seines Anbotes  informieren, inkl. persönlicher Nachricht.\nSie können Interessenten, deren Anbot definitiv abgelehnt wurde,  informieren. Diese werden dann vom weiteren Prozess ausgeschlossen.\nAlle sonstigen Bieter, die weder der Favorit sind, noch zu den definitiv abgelehnten Bietern gehören, bleiben hier zur Absicherung als mögliche „Ersatzkäufer“ bis zum endgültigen Verkaufsabschluss im Prozess.","SaleWizard::choose_offers_for_next_round_title":"Anbote auswählen","SaleWizard::confirmaward":"Sie können nach erfolgreich abgeschlossenem Verkauf den Käufer bestätigen.\nAlle verbliebenen Interessenten werden automatisch über den Verkauf informiert und deren Anbote endgültig abgelehnt.\nDas Verfahren wird geschlossen.","SaleWizard::counteroffer":"Wenn der Käufer den Wert des Gegenanbots annimmt, wird er als Käufer bestätigt und das Anbot von der Abgeberseite ist bindend\nSie können einen Käufer auswählen, der bereits ein Anbot abgegeben hat\nDann können Sie ein Gegenanbot angeben Wert und die Frist, bis zu der der Käufer entscheiden muss\nDer Käufer kann entweder:\nden Wert annehmen und wird dann sofort als ausgewählter Käufer ausgewählt\nein Anbot abgeben, das höher ist als sein vorheriges Gebot, aber niedriger als das Gegenanbot, in dem Falls die Runde geschlossen wird und Sie es dann mit dem Abgeber klären können\nTun Sie nichts und die Runde wird wie geplant geschlossen","SaleWizard::increase":"Sie können eine weitere Anbotsrunde starten (mit ggf. neuem Richtpreis), um dadurch einen besseren Preis zu erzielen.\nAlle (bzw. ausgewählte) Bieter der letzten Runde können daran teilnehmen und ihr bestehendes Anbot erhöhen; sie erhalten automatisch eine Benachrichtigung.\nAußerdem können neue Interessenten eingeladen werden, die bisher noch nicht teilgenommen haben.\nAlle bisherigen Bieter, die nicht in die neue Runde eingeladen worden sind, erhalten automatisch eine Benachrichtigung mit der Ablehnung ihres bestehenden Anbotes.","SaleWizard::increase_subtitle":"Nutzen Sie diese Funktion, wenn Sie den Kaufinteressenten die Möglichkeit geben wollen, ihr Anbot zu erhöhen.","SaleWizard::notifyseller":"Informieren Sie den Abgeber über die Anbote Ihrer Kunden","SaleWizard::rejectall":"Alle Interessenten, die ein Anbot abgegeben haben, werden über die ablehnende Entscheidung des Abgeber informiert.\nDas Verfahren wird geschlossen.","SaleWizard::rejectall_subtitle":"Nutzen Sie diese Funktion, wenn der Abgeber keines der Anbote annehmen und auch das Verfahren nicht fortführen möchte.","SaleWizard::rejectall_title":"Alle Anbote ablehnen","SaleWizardRoundInfo::offer_validity":"Kaufanbote gültig"}

/***/ }),
/* 2283 */
/***/ (function(module, exports) {

module.exports = {"post_code":"Street code","SaleCreatePanel::address":"Address (incl. Post code)"}

/***/ }),
/* 2284 */
/***/ (function(module, exports) {

module.exports = {"area_unit":"sqft","phone_number_placeholder":"+1 555 555 5555","Search::number":"MLS ID"}

/***/ }),
/* 2285 */
/***/ (function(module, exports) {

module.exports = {"post_code":"Street code","salutation":"Title","title":"Academic title"}

/***/ }),
/* 2286 */
/***/ (function(module, exports) {

module.exports = {"DateField::dateformat":"gg.mm.aaaa","DuplicateStep1::agbs":"CGC","phone_number_placeholder":"+41 79 111 11 11","SaleCreatePanel::agbs":"CGC","SaleCreatePanel::image":"Foto del titolo della proprietà","SaleCreatePanel::number":"Numero della proprietà","Search::agbs":"CGC","Search::i_agree_to_the_link":"Accetto le {agbs}","Search::i_agree_with_terms_and_conditions":"Accetto le CGC"}

/***/ }),
/* 2287 */
/***/ (function(module, exports) {

module.exports = {"area_unit":"sqft","phone_number_placeholder":"+1 555 555 5555","Search::number":"MLS ID"}

/***/ }),
/* 2288 */
/***/ (function(module, exports) {

module.exports = {"area_unit":"sqft","phone_number_placeholder":"+1 555 555 5555","Search::number":"MLS ID"}

/***/ }),
/* 2289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__de_json__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__de_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__de_json__);
function processRelativeTime(number,withoutSuffix,key,isFuture){var format={m:['eine Minute','einer Minute'],h:['eine Stunde','einer Stunde'],d:['ein Tag','einem Tag'],dd:[number+' Tage',number+' Tagen'],M:['ein Monat','einem Monat'],MM:[number+' Monate',number+' Monaten'],y:['ein Jahr','einem Jahr'],yy:[number+' Jahre',number+' Jahren']};return withoutSuffix?format[key][0]:format[key][1];}/* harmony default export */ __webpack_exports__["a"] = ({locale:'de',messages:Object.assign({},__WEBPACK_IMPORTED_MODULE_0__de_json___default.a,{'RoundDateDisplay::format':'{ hasEnd, select,\n      true {\n        { preposition, select,\n          at { am { end } }\n          until { bis { end } }\n        }\n      }\n      other { { duration, plural,\n          one { # Tag }\n          other { # Tage }\n        }\n      }\n    }',statusvalue:'{ whitelistedAgentStatus, select,\n      requested { Teilnahme angefragt }\n      blocked { Zugang geblockt }\n      other {\n\n        { roundNumber, select,\n          0 {\n            { content, select,\n              Preview { In Vorbereitung }\n              Resolved { Abgeschlossen }\n              other { {content} }\n            }\n          }\n          other {\n            { roundType, select,\n              sealed_bidding { Geschlossenes Verfahren }\n              open_bidding { Offenes Verfahren }\n              counteroffer_bidding { Gegenangebot }\n              incremental_auction { Flexibles Verfahren }\n              registration { Anmeldung }\n              simple_offer { Digitales Kaufangebot }\n            }\n\n            { roundStatus, select,\n              opened { ge\xF6ffnet }\n              started { gestartet }\n              closed { beendet }\n              other { {roundStatus} }\n            }\n          }\n        }\n      }\n    }','RoundInfo::label':'\n      { type, select,\n        sealed_bidding { Geschlossene }\n        open_bidding { Offene }\n        incremental_auction { Flexible }\n        registration { Anmeldung }\n        simple_offer { Digitales Kaufangebot }\n      }\n      Runde\n      { number }\n      { status, select,\n        started { noch nicht ge\xF6ffnet }\n        opened\n        {\n          { hasEnd, select,\n            true {\n              { durationType, select,\n                  fixed {\n                    { isPreview, select,\n                      true { startet {startDuration} }\n                      false {\n                        { isPast, select,\n                          false { noch {endDuration} }\n                          other { vorbei }\n                        }\n                      }\n                    }\n                  }\n                  flexible { noch {durationInDays} Tage }\n              }\n            }\n            other {  }\n          }\n        }\n        closed { beendet am { endText } }\n        other { {status} }\n      }\n    '}),moment:{months:'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),monthsShort:'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),monthsParseExact:true,weekdays:'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),weekdaysShort:'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),weekdaysMin:'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),weekdaysParseExact:true,longDateFormat:{LT:'HH:mm',LTS:'HH:mm:ss',L:'DD.MM.YYYY',LL:'D. MMMM YYYY',LLL:'D. MMMM YYYY HH:mm',LLLL:'dddd, D. MMMM YYYY HH:mm'},calendar:{sameDay:'[heute um] LT [Uhr]',sameElse:'L',nextDay:'[morgen um] LT [Uhr]',nextWeek:'dddd [um] LT [Uhr]',lastDay:'[gestern um] LT [Uhr]',lastWeek:'[letzten] dddd [um] LT [Uhr]'},relativeTime:{future:'in %s',past:'vor %s',s:'ein paar Sekunden',ss:'%d Sekunden',m:processRelativeTime,mm:'%d Minuten',h:processRelativeTime,hh:'%d Stunden',d:processRelativeTime,dd:processRelativeTime,M:processRelativeTime,MM:processRelativeTime,y:processRelativeTime,yy:processRelativeTime},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:'%d.',week:{dow:1,// Monday is the first day of the week.
doy:4// The week that contains Jan 4th is the first week of the year.
}}});

/***/ }),
/* 2290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__en_json__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__en_json__);
/*
//TODO
function processRelativeTime(number, withoutSuffix, key, isFuture) {
  var format = {
    'm': ['one minute', 'einer Minute'],
    'h': ['eine Stunde', 'einer Stunde'],
    'd': ['ein Tag', 'einem Tag'],
    'dd': [number + ' Tage', number + ' Tagen'],
    'M': ['ein Monat', 'einem Monat'],
    'MM': [number + ' Monate', number + ' Monaten'],
    'y': ['ein Jahr', 'einem Jahr'],
    'yy': [number + ' Jahre', number + ' Jahren']
  };
  return withoutSuffix ? format[key][0] : format[key][1];
}
*//* harmony default export */ __webpack_exports__["a"] = ({locale:'en',messages:Object.assign({},__WEBPACK_IMPORTED_MODULE_0__en_json___default.a,{'RoundDateDisplay::format':'{ hasEnd, select,\n      true {\n        { preposition, select,\n          at { at { end } }\n          until { until { end } }\n        }\n      }\n      other { { duration, plural,\n          one { # Day }\n          other { # Days }\n        }\n      }\n    }',statusvalue:'{ whitelistedAgentStatus, select,\n      requested { Participation requested }\n      blocked { Access blocked }\n      other {\n\n        { roundNumber, select,\n          0 {\n            { content, select,\n              Preview { Preview }\n              Resolved { Resolved }\n              other { {content} }\n            }\n          }\n          other {\n            { roundType, select,\n              counteroffer_bidding { Counteroffer }\n              incremental_auction { Flexible }\n              live_auction { Live Auction }\n              open_bidding { Open }\n              registration { Registration }\n              sealed_bidding { Sealed }\n              simple_offer { Digital offer }\n            }\n            round\n            { roundNumber }\n            { roundStatus, select,\n              opened { opened }\n              started { started }\n              closed { closed }\n              other { {roundStatus} }\n            }\n          }\n        }\n      }\n    }','RoundInfo::label':'\n      { type, select,\n        sealed_bidding { Sealed }\n        open_bidding { Open }\n        incremental_auction { Flexible }\n        live_auction { Live Auction }\n        counteroffer_bidding { Counteroffer }\n        registration { Registration }\n        simple_offer { Simple Offer }\n      }\n      round\n      { number }\n      { status, select,\n        started { not yet opened }\n        opened\n        {\n          { hasEnd, select,\n            true {\n              { durationType, select,\n                  fixed {\n                    { isPreview, select,\n                      true { starts {startDuration} }\n                      false {\n                        { isPast, select,\n                          false { ends {endDuration} }\n                          other { past }\n                        }\n                      }\n                    }\n                  }\n                  flexible { in {durationInDays} days }\n              }\n            }\n            other { }\n          }\n        }\n        closed { closed on { endText } }\n        other { {status} }\n      }\n    '}),moment:{months:'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),monthsShort:'Jan._Feb._Mar._Apr._May_Jun._Jul._Aug._Sep._Oct._Nov._Dec.'.split('_'),monthsParseExact:true,weekdays:'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),weekdaysShort:'Su._Mo._Tu._We._Th._Fr._Sa.'.split('_'),weekdaysMin:'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),weekdaysParseExact:true,longDateFormat:{LT:'HH:mm',LTS:'HH:mm:ss',L:'DD.MM.YYYY',LL:'D. MMMM YYYY',LLL:'D. MMMM YYYY HH:mm',LLLL:'dddd, D. MMMM YYYY HH:mm'},calendar:{sameDay:"[today at] LT [O'Clock]",sameElse:'L',nextDay:"[tomorrow at] LT [O'Clock]",nextWeek:"dddd [at] LT [O'Clock]",lastDay:"[yesterday at] LT [O'Clock]",lastWeek:"[last] dddd [at] LT [O'Clock]"},/*
    //TODO
    relativeTime: {
      future: 'in %s',
      past: 'past %s',
      s: 'a few seconds',
      ss: '%d seconds',
      m: processRelativeTime,
      mm: '%d minutes',
      h: processRelativeTime,
      hh: '%d hours',
      d: processRelativeTime,
      dd: processRelativeTime,
      M: processRelativeTime,
      MM: processRelativeTime,
      y: processRelativeTime,
      yy: processRelativeTime
    },
    */dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:'%d.',week:{dow:1,// Monday is the first day of the week.
doy:4// The week that contains Jan 4th is the first week of the year.
}}});

/***/ }),
/* 2291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({locale:'en-ZA',moment:{months:'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),monthsShort:'Jan._Feb._Mar._Apr._May_Jun._Jul._Aug._Sep._Oct._Nov._Dec.'.split('_'),monthsParseExact:true,weekdays:'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),weekdaysShort:'Su._Mo._Tu._We._Th._Fr._Sa.'.split('_'),weekdaysMin:'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),weekdaysParseExact:true,longDateFormat:{LT:'HH:mm',LTS:'HH:mm:ss',L:'YYYY/MM/DD',LL:'D MMMM YYYY',LLL:'D MMMM YYYY HH:mm',LLLL:'DDDD, DD MMMM YYYY HH:mm'},calendar:{sameDay:"[today at] LT [O'Clock]",sameElse:'L',nextDay:"[tomorrow at] LT [O'Clock]",nextWeek:"dddd [at] LT [O'Clock]",lastDay:"[yesterday at] LT [O'Clock]",lastWeek:"[last] dddd [at] LT [O'Clock]"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:'%d.',week:{dow:1,// Monday is the first day of the week.
doy:4// The week that contains Jan 4th is the first week of the year.
}}});

/***/ }),
/* 2292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__es_json__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__es_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__es_json__);
var monthsParse=[/^ene/i,/^feb/i,/^mar/i,/^abr/i,/^may/i,/^jun/i,/^jul/i,/^ago/i,/^sep/i,/^oct/i,/^nov/i,/^dic/i],monthsRegex=/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;/*
//TODO
function processRelativeTime(number, withoutSuffix, key, isFuture) {
  var format = {
    'm': ['one minute', 'einer Minute'],
    'h': ['eine Stunde', 'einer Stunde'],
    'd': ['ein Tag', 'einem Tag'],
    'dd': [number + ' Tage', number + ' Tagen'],
    'M': ['ein Monat', 'einem Monat'],
    'MM': [number + ' Monate', number + ' Monaten'],
    'y': ['ein Jahr', 'einem Jahr'],
    'yy': [number + ' Jahre', number + ' Jahren']
  };
  return withoutSuffix ? format[key][0] : format[key][1];
}
*//* harmony default export */ __webpack_exports__["a"] = ({locale:'es',messages:Object.assign({},__WEBPACK_IMPORTED_MODULE_0__es_json___default.a,{'RoundDateDisplay::format':'{ hasEnd, select,\n      true {\n        { preposition, select,\n          at { at { end } }\n          until { until { end } }\n        }\n      }\n      other { { duration, plural,\n          one { # Day }\n          other { # Days }\n        }\n      }\n    }',statusvalue:'{ whitelistedAgentStatus, select,\n      requested { Participation requested }\n      blocked { Access blocked }\n      other {\n\n        { roundNumber, select,\n          0 {\n            { content, select,\n              Preview { Preview }\n              Resolved { Resolved }\n              other { {content} }\n            }\n          }\n          other {\n            { roundType, select,\n              counteroffer_bidding { Contraoferta }\n              incremental_auction { Ofertas flexibles }\n              open_bidding { Ofertas abiertas }\n              registration { Invitaci\xF3n }\n              sealed_bidding { Ofertas cerrada }\n              simple_offer { Ofertas individuales }\n            }\n            ronda\n            { roundNumber }\n            { roundStatus, select,\n              opened { abierta }\n              started { comenzada }\n              closed { cerrada }\n              other { {roundStatus} }\n            }\n          }\n        }\n      }\n    }','RoundInfo::label':'\n      { type, select,\n        sealed_bidding { Ofertas cerrada }\n        open_bidding { Ofertas flexibles }\n        incremental_auction { Ofertas flexibles }\n        counteroffer_bidding { Contraoferta }\n        registration { Invitaci\xF3n }\n        simple_offer { Ofertas individuales }\n      }\n      ronda\n      { number }\n      { status, select,\n        started { a\xFAn no abierta }\n        opened\n        {\n          {\n            durationType, select,\n              fixed {\n                { isPreview, select,\n                  true { comienza {startDuration} }\n                  false {\n                    { isPast, select,\n                      false { termina {endDuration} }\n                      other { ha terminado }\n                    }\n                  }\n                }\n              }\n              flexible { termina en {durationInDays} dias }\n          }\n        }\n        closed { finaliz\xF3 el { endText } }\n        other { {status} }\n      }\n    '}),moment:{months:'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),monthsShort:'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),monthsRegex:monthsRegex,monthsShortRegex:monthsRegex,monthsStrictRegex:/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,monthsShortStrictRegex:/^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,monthsParse:monthsParse,longMonthsParse:monthsParse,shortMonthsParse:monthsParse,weekdays:'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),weekdaysShort:'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),weekdaysMin:'do_lu_ma_mi_ju_vi_sá'.split('_'),weekdaysParseExact:true,longDateFormat:{LT:'H:mm',LTS:'H:mm:ss',L:'DD/MM/YYYY',LL:'D [de] MMMM [de] YYYY',LLL:'D [de] MMMM [de] YYYY H:mm',LLLL:'dddd, D [de] MMMM [de] YYYY H:mm'},calendar:{sameDay:function sameDay(){return'[hoy a la'+(this.hours()!==1?'s':'')+'] LT';},nextDay:function nextDay(){return'[mañana a la'+(this.hours()!==1?'s':'')+'] LT';},nextWeek:function nextWeek(){return'dddd [a la'+(this.hours()!==1?'s':'')+'] LT';},lastDay:function lastDay(){return'[ayer a la'+(this.hours()!==1?'s':'')+'] LT';},lastWeek:function lastWeek(){return'[el] dddd [pasado a la'+(this.hours()!==1?'s':'')+'] LT';},sameElse:'L'},relativeTime:{future:'en %s',past:'hace %s',s:'unos segundos',ss:'%d segundos',m:'un minuto',mm:'%d minutos',h:'una hora',hh:'%d horas',d:'un día',dd:'%d días',w:'una semana',ww:'%d semanas',M:'un mes',MM:'%d meses',y:'un año',yy:'%d años'},dayOfMonthOrdinalParse:/\d{1,2}º/,ordinal:'%dº',week:{dow:1,// Monday is the first day of the week.
doy:4// The week that contains Jan 4th is the first week of the year.
},invalidDate:'Fecha inválida'}});

/***/ }),
/* 2293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fi_json__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fi_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__fi_json__);
/* harmony default export */ __webpack_exports__["a"] = ({locale:'fi',messages:Object.assign({},__WEBPACK_IMPORTED_MODULE_0__fi_json___default.a,{'RoundDateDisplay::format':'{ hasEnd, select,\n      true {\n        { preposition, select,\n          at { at { end } }\n          until { until { end } }\n        }\n      }\n      other { { duration, plural,\n          one { # p\xE4iv\xE4ss\xE4 }\n          other { # p\xE4iv\xE4ss\xE4 }\n        }\n      }\n    }',statusvalue:'{ roundNumber, select,\n      0 {\n        { content, select,\n          Preview { Esikatselu }\n          Resolved { Ratkaistu }\n          other { {content} }\n        }\n      }\n      other {\n        { roundType, select,\n          sealed_bidding { Suljettu }\n          open_bidding { Avoin }\n          counteroffer_bidding { Vastatarjous }\n          registration { Rekister\xF6inti }\n          SealedBidding { Suljettu }\n          OpenBidding { Avoin }\n          CounterofferBidding { Vastatarjous }\n          incremental_auction { Joustava }\n          simple_offer { Digitaalinen ostotarjous }\n        }\n        kierros\n        { roundNumber }\n        { roundStatus, select,\n          opened { avattu }\n          started { alkoi }\n          closed { p\xE4\xE4ttyi }\n          other { {roundStatus} }\n        }\n      }\n    }','RoundInfo::label':'\n      { type, select,\n        sealed_bidding { Suljettu }\n        open_bidding { Avoin }\n        incremental_auction { Joustava }\n        counteroffer_bidding { Vastatarjous }\n        registration { Rekister\xF6inti }\n        simple_offer { Digitaalinen ostotarjous }\n      }\n      kierros\n      { number }\n      { status, select,\n        started { ei viel\xE4 avattu }\n        opened\n        {\n          {\n            durationType, select,\n              fixed {\n                { isPast, select,\n                  false { p\xE4\xE4ttyy {endDuration} kuluttua }\n                  other { ohi }\n                }\n              }\n              flexible { p\xE4\xE4ttyy {durationInDays} p\xE4iv\xE4n kuluttua }\n\n          }\n        }\n        closed { p\xE4\xE4ttyi { endText } }\n        other { {status} }\n      }\n    '})});

/***/ }),
/* 2294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fr_json__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fr_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__fr_json__);
/* harmony default export */ __webpack_exports__["a"] = ({locale:'fr',messages:Object.assign({},__WEBPACK_IMPORTED_MODULE_0__fr_json___default.a,{'RoundDateDisplay::format':'{ hasEnd, select,\n      true {\n        { preposition, select,\n          at { le { end } }\n          until { jusqu\u2019au { end } }\n        }\n      }\n      other { { duration, plural,\n          one { # jour }\n          other { # jours }\n        }\n      }\n    }',statusvalue:'{ roundNumber, select,\n      0 {\n        { content, select,\n          Preview { En pr\xE9paration }\n          Resolved { Conclu }\n          other { {content} }\n        }\n      }\n      other {\n        { roundType, select,\n          sealed_bidding { Processus ferm\xE9 }\n          open_bidding { Processus ouvert }\n          counteroffer_bidding { Contre-offre }\n          incremental_auction { Processus flexible }\n          registration { Inscription }\n          simple_offer { Offre digitale }\n        }\n        { roundStatus, select,\n          opened { en cours }\n          started { commenc\xE9e }\n          closed { termin\xE9 }\n          other { {roundStatus} }\n        }\n      }\n    }','Mls::statusvalue':'{ roundType, select,\n        sealed_bidding { Processus ferm\xE9 }\n        open_bidding { Processus ouvert }\n        counteroffer_bidding { Contre-offre }\n        incremental_auction { Processus flexible }\n        registration { Inscription }\n        simple_offer { Offre digitale }\n      }\n      { roundStatus, select,\n        opened { encore {endAt} }\n        started { pas encore ouvert }\n        closed { termin\xE9 }\n        other { {roundStatus} }\n      }\n    ','RoundInfo::label':'{ type, select,\n              sealed_bidding { Processus ferm\xE9 }\n              open_bidding { Processus ouvert }\n              counteroffer_bidding { Contre-offre }\n              incremental_auction { Processus flexible }\n              registration { Inscription }\n              simple_offer { Offre digitale }\n            }\n            { status, select,\n              started { pas encore ouvert }\n              opened\n              {\n                { hasEnd, select,\n                  true {\n                    { durationType, select,\n                        fixed {\n                          { isPreview, select,\n                            true { commence {startDuration} }\n                            false {\n                              { isPast, select,\n                                false { encore {endDuration} }\n                                other { termin\xE9 }\n                              }\n                            }\n                          }\n                        }\n                        flexible { encore {durationInDays} jours }\n                      }\n                    }\n                    other {  }\n                  }\n                }\n              closed { termin\xE9 { endText } }\n              other { {status} }\n            }'}),moment:{months:'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),monthsShort:'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),monthsParseExact:true,weekdays:'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),weekdaysShort:'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),weekdaysMin:'di_lu_ma_me_je_ve_sa'.split('_'),weekdaysParseExact:true,longDateFormat:{LT:'HH:mm',LTS:'HH:mm:ss',L:'DD/MM/YYYY',LL:'D MMMM YYYY',LLL:'D MMMM YYYY HH:mm',LLLL:'dddd D MMMM YYYY HH:mm'},calendar:{sameDay:'[Aujourd’hui à] LT',nextDay:'[Demain à] LT',nextWeek:'dddd [à] LT',lastDay:'[Hier à] LT',lastWeek:'dddd [dernier à] LT',sameElse:'L'},relativeTime:{future:'dans %s',past:'il y a %s',s:'quelques secondes',ss:'%d secondes',m:'une minute',mm:'%d minutes',h:'une heure',hh:'%d heures',d:'un jour',dd:'%d jours',M:'un mois',MM:'%d mois',y:'un an',yy:'%d ans'},dayOfMonthOrdinalParse:/\d{1,2}(er|)/,ordinal:function ordinal(number,period){switch(period){case'D':return number+(number===1?'er':'');default:case'M':case'Q':case'DDD':case'd':return number+(number===1?'er':'e');case'w':case'W':return number+(number===1?'re':'e');}},week:{dow:1,// Monday is the first day of the week.
doy:4// The week that contains Jan 4th is the first week of the year.
}}});

/***/ }),
/* 2295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__it_json__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__it_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__it_json__);
/* harmony default export */ __webpack_exports__["a"] = ({locale:'it',messages:Object.assign({},__WEBPACK_IMPORTED_MODULE_0__it_json___default.a,{'RoundDateDisplay::format':'{ hasEnd, select,\n            true {\n              { preposition, select,\n                at { il { end } }\n                until { fino { end } }\n              }\n            }\n            other { { duration, plural,\n                one { # giorno }\n                other { # giorni }\n              }\n            }\n          }',statusvalue:'{ roundNumber, select,\n            0 {\n              { content, select,\n                Preview { In preparazione }\n                Resolved { Concluso }\n                other { {content} }\n              }\n            }\n            other {\n              { roundType, select,\n                counteroffer_bidding { Controfferta }\n                incremental_auction { Flessibile }\n                open_bidding { Aperta }\n                registration { Registrazione }\n                sealed_bidding { Chiusa }\n                simple_offer { Offerta digitale }\n              }\n              { roundStatus, select,\n                opened { aperto }\n                started { lanciato }\n                closed { terminato }\n                other { {roundStatus} }\n              }\n            }\n          }','RoundInfo::label':'{ type, select,\n              open_bidding { Aperta }\n              sealed_bidding { Chiusa }\n              incremental_auction { Flessibile }\n              registration { Registrazione }\n              simple_offer { Offerta digitale }\n            }\n            { status, select,\n              started { non ancora aperta }\n              opened\n              {\n                { hasEnd, select,\n                  true {\n\n                    { durationType, select,\n                        fixed {\n                          { isPreview, select,\n                            true { inizia {startDuration} }\n                            false {\n                              { isPast, select,\n                                false { ancora {endDuration} }\n                                other { terminata }\n                              }\n                            }\n                          }\n                        }\n                        flexible { il {durationInDays} giorni }\n                    }\n                  }\n                  other {  }\n                }\n              }\n              closed { si conclude { endText } }\n              other { {status} }\n            }'}),moment:{months:'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),monthsShort:'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),weekdays:'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),weekdaysShort:'dom_lun_mar_mer_gio_ven_sab'.split('_'),weekdaysMin:'do_lu_ma_me_gi_ve_sa'.split('_'),longDateFormat:{LT:'HH:mm',LTS:'HH:mm:ss',L:'DD/MM/YYYY',LL:'D MMMM YYYY',LLL:'D MMMM YYYY HH:mm',LLLL:'dddd D MMMM YYYY HH:mm'},calendar:{sameDay:'[Oggi alle] LT',nextDay:'[Domani alle] LT',nextWeek:'dddd [alle] LT',lastDay:'[Ieri alle] LT',lastWeek:function lastWeek(){switch(this.day()){case 0:return'[la scorsa] dddd [alle] LT';default:return'[lo scorso] dddd [alle] LT';}},sameElse:'L'},relativeTime:{future:function future(s){return(/^[0-9].+$/.test(s)?'tra':'in')+' '+s;},past:'%s fa',s:'alcuni secondi',ss:'%d secondi',m:'un minuto',mm:'%d minuti',h:"un'ora",hh:'%d ore',d:'un giorno',dd:'%d giorni',M:'un mese',MM:'%d mesi',y:'un anno',yy:'%d anni'},dayOfMonthOrdinalParse:/\d{1,2}º/,ordinal:'%dº',week:{dow:1,// Monday is the first day of the week.
doy:4// The week that contains Jan 4th is the first week of the year.
}}});

/***/ }),
/* 2296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ro_json__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ro_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ro_json__);
function relativeTimeWithPlural(number,withoutSuffix,key){var format={ss:'secunde',mm:'minute',hh:'ore',dd:'zile',ww:'săptămâni',MM:'luni',yy:'ani'},separator=' ';if(number%100>=20||number>=100&&number%100===0){separator=' de ';}return number+separator+format[key];}/* harmony default export */ __webpack_exports__["a"] = ({locale:'ro',messages:Object.assign({},__WEBPACK_IMPORTED_MODULE_0__ro_json___default.a,{'RoundDateDisplay::format':'{ hasEnd, select,\n      true {\n        { preposition, select,\n          at { la ora { end } }\n          until { p\xE2n\u0103 la ora { end } }\n        }\n      }\n      other { { duration, plural,\n          one { # zi }\n          other { # zile }\n        }\n      }\n    }',statusvalue:'{ roundNumber, select,\n      0 {\n        { content, select,\n          Preview { previzualizare }\n          Resolved { \xCEncheiat }\n          other { {content} }\n        }\n      }\n      other {\n        { roundType, select,\n          sealed_bidding { Inchis\u0103 }\n          open_bidding { Deschis\u0103 }\n          counteroffer_bidding { Contra oferta }\n          registration { \xCEnregistrare }\n          SealedBidding { Inchis\u0103 }\n          OpenBidding { Deschis\u0103 }\n          CounterofferBidding { Contra oferta }\n        }\n        round\n        { roundNumber }\n        { roundStatus, select,\n          opened { deschis }\n          started { a \xEEnceput }\n          closed { \xEEnchis }\n          other { {roundStatus} }\n        }\n      }\n    }','RoundInfo::label':'\n      { type, select,\n        sealed_bidding { \xCEnchis\u0103 }\n        open_bidding { Deschis\u0103 }\n        incremental_auction { Flexibil\u0103 }\n        counteroffer_bidding { Contraofert\u0103 }\n        registration { \xCEnregistrare }\n        simple_offer { Ofert\u0103 de cump\u0103rare digital\u0103 }\n      }\n      rund\u0103\n      { number }\n      { status, select,\n        started { nu a fost \xEEnc\u0103 deschis\u0103 }\n        opened\n        {\n          { hasEnd, select,\n            true {\n              { durationType, select,\n                  fixed {\n                    { isPreview, select,\n                      true { \xEEncepe {startDuration} }\n                      false {\n                        { isPast, select,\n                          false { peste {endDuration} }\n                          other { a trecut }\n                        }\n                      }\n                    }\n                  }\n                  flexible { peste {durationInDays} zile }\n              }\n            }\n            other {  }\n          }\n        }\n        closed { \xEEnchis\u0103 la { endText } }\n        other { {status} }\n      }\n    '}),moment:{months:'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),monthsShort:'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),monthsParseExact:true,weekdays:'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),weekdaysShort:'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),weekdaysMin:'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),longDateFormat:{LT:'H:mm',LTS:'H:mm:ss',L:'DD.MM.YYYY',LL:'D MMMM YYYY',LLL:'D MMMM YYYY H:mm',LLLL:'dddd, D MMMM YYYY H:mm'},calendar:{sameDay:'[azi la] LT',nextDay:'[mâine la] LT',nextWeek:'dddd [la] LT',lastDay:'[ieri la] LT',lastWeek:'[fosta] dddd [la] LT',sameElse:'L'},relativeTime:{future:'peste %s',past:'%s în urmă',s:'câteva secunde',ss:relativeTimeWithPlural,m:'un minut',mm:relativeTimeWithPlural,h:'o oră',hh:relativeTimeWithPlural,d:'o zi',dd:relativeTimeWithPlural,w:'o săptămână',ww:relativeTimeWithPlural,M:'o lună',MM:relativeTimeWithPlural,y:'un an',yy:relativeTimeWithPlural},week:{dow:1,// Monday is the first day of the week.
doy:7// The week that contains Jan 7th is the first week of the year.
}}});

/***/ }),
/* 2297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sl_json__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sl_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__sl_json__);
function processRelativeTime(number,withoutSuffix,key,isFuture){var format={m:['eno minuto','v minuti'],h:['eno uro','v eni uri'],d:['eno dan','v enem dnevu'],dd:[number+' dni',number+' dneh'],M:['en mesec','v enem mesecu'],MM:[number+' mesecev',number+' mesecih'],y:['eno leto','v enem letu'],yy:[number+' let',number+' letih']};return withoutSuffix?format[key][0]:format[key][1];}/* harmony default export */ __webpack_exports__["a"] = ({locale:'sl',messages:Object.assign({},__WEBPACK_IMPORTED_MODULE_0__sl_json___default.a,{'RoundDateDisplay::format':'{ hasEnd, select,\n      true {\n        { preposition, select,\n          at { ob { end } }\n          until { { end } }\n        }\n      }\n      other { { duration, plural,\n          one { # Dan }\n          other { # Dnevi }\n        }\n      }\n    }',statusvalue:'{ whitelistedAgentStatus, select,\n      requested { Za\u017Eeljena udele\u017Eba }\n      blocked { Dostop blokiran }\n      other {\n\n        { roundNumber, select,\n          0 {\n            { content, select,\n              Preview { Predogled }\n              Resolved { Re\u0161eno }\n              other { {content} }\n            }\n          }\n          other {\n            { roundType, select,\n              sealed_bidding { Zape\u010Daten postopek }\n              open_bidding { Odprti postopek }\n              counteroffer_bidding { Nasprotni postopek }\n              incremental_auction { Prilagodljiv postopek }\n              registration { Registracija }\n              simple_offer { Ponudba digitalnega nakupa }\n            }\n\n            { roundStatus, select,\n              opened { odprt }\n              started { za\u010Del }\n              closed { zaprt }\n              other { {roundStatus} }\n            }\n          }\n        }\n      }\n    }','RoundInfo::label':'\n      { type, select,\n\n        sealed_bidding { Zape\u010Daten postopek dra\u017Ebe }\n        open_bidding { Odprti postopek dra\u017Ebe }\n        incremental_auction { Prilagodljiv postopek dra\u017Ebe }\n        registration { Registracija }\n        simple_offer { Ponudba digitalnega nakupa }\n        counteroffer_bidding { Nasprotni postopek }\n      }\n      ({ number }. krog)\n      { status, select,\n        started { \u0161e ni odprt }\n        opened\n        {\n          { hasEnd, select,\n            true {\n              { durationType, select,\n                  fixed {\n                    { isPreview, select,\n                      true { se za\u010Dne {startDuration} }\n                      false {\n                        { isPast, select,\n                          false { se zaklju\u010Di \u010Dez {endDuration} }\n                          other { je zaklju\u010Den }\n                        }\n                      }\n                    }\n                  }\n                  flexible {\n                    { durationInDays, plural,\n                    one { se zaklju\u010Di \u010Dez 1 dan }\n                    other { se zaklju\u010Di \u010Dez {durationInDays} dnech  }\n                  }\n                }\n              }\n            }\n            other {  }\n          }\n        }\n        closed { je zaprt v { endText } }\n        other { {status} }\n      }\n    '}),moment:{months:'Januar_Februar_Marec_April_Maj_Junij_Julij_Avgust_September_Oktober_November_December'.split('_'),monthsShort:'jan._feb._mar._apr._maj_jun._jul._avg._sep._okt._nov._dec.'.split('_'),monthsParseExact:true,weekdays:'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),weekdaysShort:'Ne._Po._To._Sr._Če._Pe._So.'.split('_'),weekdaysMin:'Ne_Po_To_Sr_Če_Pe_So'.split('_'),weekdaysParseExact:true,longDateFormat:{LT:'HH:mm',LTS:'HH:mm:ss',L:'DD.MM.YYYY',LL:'D. MMMM YYYY',LLL:'D. MMMM YYYY HH:mm',LLLL:'dddd, D. MMMM YYYY HH:mm'},calendar:{sameDay:'[danes ob] LT [uri]',sameElse:'L',nextDay:'[jutri ob] LT [uri]',nextWeek:'dddd [ob] LT [uri]',lastDay:'[včeraj ob] LT [uri]',lastWeek:'[zadnji] dddd [ob] LT [uri]'},relativeTime:{future:'v %s',past:'zadnjih %s',s:'nekaj sekund',ss:'%d sekund',m:processRelativeTime,mm:'%d minut',h:processRelativeTime,hh:'%d ur',d:processRelativeTime,dd:processRelativeTime,M:processRelativeTime,MM:processRelativeTime,y:processRelativeTime,yy:processRelativeTime},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:'%d.',week:{dow:1,// Monday is the first day of the week.
doy:4// The week that contains Jan 4th is the first week of the year.
}}});

/***/ }),
/* 2298 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getContrastText;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_polished__ = __webpack_require__(2300);
function getContrastText(color){return Object(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_polished__["a" /* getLuminance */])(color)>0.6?'#333':'#fff';}

/***/ }),
/* 2300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export adjustHue */
/* unused harmony export animation */
/* unused harmony export backgroundImages */
/* unused harmony export backgrounds */
/* unused harmony export between */
/* unused harmony export border */
/* unused harmony export borderColor */
/* unused harmony export borderRadius */
/* unused harmony export borderStyle */
/* unused harmony export borderWidth */
/* unused harmony export buttons */
/* unused harmony export clearFix */
/* unused harmony export complement */
/* unused harmony export cover */
/* unused harmony export darken */
/* unused harmony export desaturate */
/* unused harmony export directionalProperty */
/* unused harmony export ellipsis */
/* unused harmony export em */
/* unused harmony export fluidRange */
/* unused harmony export fontFace */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLuminance; });
/* unused harmony export getValueAndUnit */
/* unused harmony export grayscale */
/* unused harmony export invert */
/* unused harmony export hideText */
/* unused harmony export hideVisually */
/* unused harmony export hiDPI */
/* unused harmony export hsl */
/* unused harmony export hsla */
/* unused harmony export lighten */
/* unused harmony export margin */
/* unused harmony export mix */
/* unused harmony export modularScale */
/* unused harmony export normalize */
/* unused harmony export opacify */
/* unused harmony export padding */
/* unused harmony export parseToHsl */
/* unused harmony export parseToRgb */
/* unused harmony export placeholder */
/* unused harmony export position */
/* unused harmony export radialGradient */
/* unused harmony export readableColor */
/* unused harmony export rem */
/* unused harmony export retinaImage */
/* unused harmony export rgb */
/* unused harmony export rgba */
/* unused harmony export saturate */
/* unused harmony export selection */
/* unused harmony export setHue */
/* unused harmony export setLightness */
/* unused harmony export setSaturation */
/* unused harmony export shade */
/* unused harmony export size */
/* unused harmony export stripUnit */
/* unused harmony export textInputs */
/* unused harmony export timingFunctions */
/* unused harmony export tint */
/* unused harmony export toColorString */
/* unused harmony export transitions */
/* unused harmony export transparentize */
/* unused harmony export triangle */
/* unused harmony export wordWrap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_taggedTemplateLiteralLoose__ = __webpack_require__(2301);



// @private
function capitalizeString(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var positionMap = ['Top', 'Right', 'Bottom', 'Left'];

function generateProperty(property, position) {
  if (!property) return position.toLowerCase();
  var splitProperty = property.split('-');

  if (splitProperty.length > 1) {
    splitProperty.splice(1, 0, position);
    return splitProperty.reduce(function (acc, val) {
      return "" + acc + capitalizeString(val);
    });
  }

  var joinedProperty = property.replace(/([a-z])([A-Z])/g, "$1" + position + "$2");
  return property === joinedProperty ? "" + property + position : joinedProperty;
}

function generateStyles(property, valuesWithDefaults) {
  var styles = {};

  for (var i = 0; i < valuesWithDefaults.length; i += 1) {
    if (valuesWithDefaults[i] || valuesWithDefaults[i] === 0) {
      styles[generateProperty(property, positionMap[i])] = valuesWithDefaults[i];
    }
  }

  return styles;
}
/**
 * Enables shorthand for direction-based properties. It accepts a property (hyphenated or camelCased) and up to four values that map to top, right, bottom, and left, respectively. You can optionally pass an empty string to get only the directional values as properties. You can also optionally pass a null argument for a directional value to ignore it.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...directionalProperty('padding', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${directionalProperty('padding', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */


function directionalProperty(property) {
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  //  prettier-ignore
  var firstValue = values[0],
      _values$ = values[1],
      secondValue = _values$ === void 0 ? firstValue : _values$,
      _values$2 = values[2],
      thirdValue = _values$2 === void 0 ? firstValue : _values$2,
      _values$3 = values[3],
      fourthValue = _values$3 === void 0 ? secondValue : _values$3;
  var valuesWithDefaults = [firstValue, secondValue, thirdValue, fourthValue];
  return generateStyles(property, valuesWithDefaults);
}

function endsWith (string, suffix) {
  return string.substr(-suffix.length) === suffix;
}

/**
 * Returns a given CSS value minus its unit (or the original value if an invalid string is passed).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': stripUnit('100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${stripUnit('100px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 * }
 */
function stripUnit(value) {
  var unitlessValue = parseFloat(value);
  if (isNaN(unitlessValue)) return value;
  return unitlessValue;
}

/**
 * Factory function that creates pixel-to-x converters
 * @private
 */

var pxtoFactory = function pxtoFactory(to) {
  return function (pxval, base) {
    if (base === void 0) {
      base = '16px';
    }

    var newPxval = pxval;
    var newBase = base;

    if (typeof pxval === 'string') {
      if (!endsWith(pxval, 'px')) {
        throw new Error("Expected a string ending in \"px\" or a number passed as the first argument to " + to + "(), got \"" + pxval + "\" instead.");
      }

      newPxval = stripUnit(pxval);
    }

    if (typeof base === 'string') {
      if (!endsWith(base, 'px')) {
        throw new Error("Expected a string ending in \"px\" or a number passed as the second argument to " + to + "(), got \"" + base + "\" instead.");
      }

      newBase = stripUnit(base);
    }

    if (typeof newPxval === 'string') {
      throw new Error("Passed invalid pixel value (\"" + pxval + "\") to " + to + "(), please pass a value like \"12px\" or 12.");
    }

    if (typeof newBase === 'string') {
      throw new Error("Passed invalid base value (\"" + base + "\") to " + to + "(), please pass a value like \"12px\" or 12.");
    }

    return "" + newPxval / newBase + to;
  };
};

/**
 * Convert pixel value to ems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': em('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${em('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1em'
 * }
 */

var em =
/*#__PURE__*/
pxtoFactory('em');

var cssRegex = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
/**
 * Returns a given CSS value and its unit as elements of an array.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': getValueAndUnit('100px')[0]
 *   '--unit': getValueAndUnit('100px')[1]
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${getValueAndUnit('100px')[0]}
 *   --unit: ${getValueAndUnit('100px')[1]}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 *   '--unit': 'px'
 * }
 */

function getValueAndUnit(value) {
  if (typeof value !== 'string') return [value, ''];
  var matchedValue = value.match(cssRegex);
  if (matchedValue) return [parseFloat(value), matchedValue[2]];
  return [value, undefined];
}

var ratioNames = {
  minorSecond: 1.067,
  majorSecond: 1.125,
  minorThird: 1.2,
  majorThird: 1.25,
  perfectFourth: 1.333,
  augFourth: 1.414,
  perfectFifth: 1.5,
  minorSixth: 1.6,
  goldenSection: 1.618,
  majorSixth: 1.667,
  minorSeventh: 1.778,
  majorSeventh: 1.875,
  octave: 2,
  majorTenth: 2.5,
  majorEleventh: 2.667,
  majorTwelfth: 3,
  doubleOctave: 4
};

function getRatio(ratioName) {
  return ratioNames[ratioName];
}
/**
 * Establish consistent measurements and spacial relationships throughout your projects by incrementing up or down a defined scale. We provide a list of commonly used scales as pre-defined variables.
 * @example
 * // Styles as object usage
 * const styles = {
 *    // Increment two steps up the default scale
 *   'fontSize': modularScale(2)
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *    // Increment two steps up the default scale
 *   fontSize: ${modularScale(2)}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'fontSize': '1.77689em'
 * }
 */


function modularScale(steps, base, ratio) {
  if (base === void 0) {
    base = '1em';
  }

  if (ratio === void 0) {
    ratio = 'perfectFourth';
  }

  if (typeof steps !== 'number') {
    throw new Error('Please provide a number of steps to the modularScale helper.');
  }

  if (typeof ratio === 'string' && !ratioNames[ratio]) {
    throw new Error('Please pass a number or one of the predefined scales to the modularScale helper as the ratio.');
  }

  var realBase = typeof base === 'string' ? stripUnit(base) : base;
  var realRatio = typeof ratio === 'string' ? getRatio(ratio) : ratio;

  if (typeof realBase === 'string') {
    throw new Error("Invalid value passed as base to modularScale, expected number or em string but got \"" + base + "\"");
  }

  return realBase * Math.pow(realRatio, steps) + "em";
}

/**
 * Convert pixel value to rems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': rem('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${rem('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1rem'
 * }
 */

var rem =
/*#__PURE__*/
pxtoFactory('rem');

/**
 * Returns a CSS calc formula for linear interpolation of a property between two values. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px').
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   fontSize: between('20px', '100px', '400px', '1000px'),
 *   fontSize: between('20px', '100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   fontSize: ${between('20px', '100px', '400px', '1000px')};
 *   fontSize: ${between('20px', '100px')}
 * `
 *
 * // CSS as JS Output
 *
 * h1: {
 *   'fontSize': 'calc(-33.33333333333334px + 13.333333333333334vw)',
 *   'fontSize': 'calc(-9.090909090909093px + 9.090909090909092vw)'
 * }
 */

function between(fromSize, toSize, minScreen, maxScreen) {
  if (minScreen === void 0) {
    minScreen = '320px';
  }

  if (maxScreen === void 0) {
    maxScreen = '1200px';
  }

  var _getValueAndUnit = getValueAndUnit(fromSize),
      unitlessFromSize = _getValueAndUnit[0],
      fromSizeUnit = _getValueAndUnit[1];

  var _getValueAndUnit2 = getValueAndUnit(toSize),
      unitlessToSize = _getValueAndUnit2[0],
      toSizeUnit = _getValueAndUnit2[1];

  var _getValueAndUnit3 = getValueAndUnit(minScreen),
      unitlessMinScreen = _getValueAndUnit3[0],
      minScreenUnit = _getValueAndUnit3[1];

  var _getValueAndUnit4 = getValueAndUnit(maxScreen),
      unitlessMaxScreen = _getValueAndUnit4[0],
      maxScreenUnit = _getValueAndUnit4[1];

  if (typeof unitlessMinScreen !== 'number' || typeof unitlessMaxScreen !== 'number' || !minScreenUnit || !maxScreenUnit || minScreenUnit !== maxScreenUnit) {
    throw new Error('minScreen and maxScreen must be provided as stringified numbers with the same units.');
  }

  if (typeof unitlessFromSize !== 'number' || typeof unitlessToSize !== 'number' || !fromSizeUnit || !toSizeUnit || fromSizeUnit !== toSizeUnit) {
    throw new Error('fromSize and toSize must be provided as stringified numbers with the same units.');
  }

  var slope = (unitlessFromSize - unitlessToSize) / (unitlessMinScreen - unitlessMaxScreen);
  var base = unitlessToSize - slope * unitlessMaxScreen;
  return "calc(" + base.toFixed(2) + fromSizeUnit + " + " + (100 * slope).toFixed(2) + "vw)";
}

/**
 * CSS to contain a float (credit to CSSMojo).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...clearFix(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${clearFix()}
 * `
 *
 * // CSS as JS Output
 *
 * '&::after': {
 *   'clear': 'both',
 *   'content': '""',
 *   'display': 'table'
 * }
 */
function clearFix(parent) {
  var _ref;

  if (parent === void 0) {
    parent = '&';
  }

  var pseudoSelector = parent + "::after";
  return _ref = {}, _ref[pseudoSelector] = {
    clear: 'both',
    content: '""',
    display: 'table'
  }, _ref;
}

/**
 * CSS to fully cover an area. Can optionally be passed an offset to act as a "padding".
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...cover()
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${cover()}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'position': 'absolute',
 *   'top': '0',
 *   'right: '0',
 *   'bottom': '0',
 *   'left: '0'
 * }
 */
function cover(offset) {
  if (offset === void 0) {
    offset = 0;
  }

  return {
    position: 'absolute',
    top: offset,
    right: offset,
    bottom: offset,
    left: offset
  };
}

/**
 * CSS to represent truncated text with an ellipsis.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...ellipsis('250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${ellipsis('250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'display': 'inline-block',
 *   'maxWidth': '250px',
 *   'overflow': 'hidden',
 *   'textOverflow': 'ellipsis',
 *   'whiteSpace': 'nowrap',
 *   'wordWrap': 'normal'
 * }
 */
function ellipsis(width) {
  if (width === void 0) {
    width = '100%';
  }

  return {
    display: 'inline-block',
    maxWidth: width,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    wordWrap: 'normal'
  };
}

/**
 * Returns a set of media queries that resizes a property (or set of properties) between a provided fromSize and toSize. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px') to constrain the interpolation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...fluidRange(
 *    {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${fluidRange(
 *      {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   "@media (min-width: 1000px)": Object {
 *     "padding": "100px",
 *   },
 *   "@media (min-width: 400px)": Object {
 *     "padding": "calc(-33.33333333333334px + 13.333333333333334vw)",
 *   },
 *   "padding": "20px",
 * }
 */
function fluidRange(cssProp, minScreen, maxScreen) {
  if (minScreen === void 0) {
    minScreen = '320px';
  }

  if (maxScreen === void 0) {
    maxScreen = '1200px';
  }

  if (!Array.isArray(cssProp) && typeof cssProp !== 'object' || cssProp === null) {
    throw new Error('expects either an array of objects or a single object with the properties prop, fromSize, and toSize.');
  }

  if (Array.isArray(cssProp)) {
    var mediaQueries = {};
    var fallbacks = {};

    for (var _iterator = cssProp, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _extends2, _extends3;

      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var obj = _ref;

      if (!obj.prop || !obj.fromSize || !obj.toSize) {
        throw new Error('expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.');
      }

      fallbacks[obj.prop] = obj.fromSize;
      mediaQueries["@media (min-width: " + minScreen + ")"] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, mediaQueries["@media (min-width: " + minScreen + ")"], (_extends2 = {}, _extends2[obj.prop] = between(obj.fromSize, obj.toSize, minScreen, maxScreen), _extends2));
      mediaQueries["@media (min-width: " + maxScreen + ")"] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, mediaQueries["@media (min-width: " + maxScreen + ")"], (_extends3 = {}, _extends3[obj.prop] = obj.toSize, _extends3));
    }

    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, fallbacks, mediaQueries);
  } else {
    var _ref2, _ref3, _ref4;

    if (!cssProp.prop || !cssProp.fromSize || !cssProp.toSize) {
      throw new Error('expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.');
    }

    return _ref4 = {}, _ref4[cssProp.prop] = cssProp.fromSize, _ref4["@media (min-width: " + minScreen + ")"] = (_ref2 = {}, _ref2[cssProp.prop] = between(cssProp.fromSize, cssProp.toSize, minScreen, maxScreen), _ref2), _ref4["@media (min-width: " + maxScreen + ")"] = (_ref3 = {}, _ref3[cssProp.prop] = cssProp.toSize, _ref3), _ref4;
  }
}

function generateFileReferences(fontFilePath, fileFormats) {
  var fileFontReferences = fileFormats.map(function (format) {
    return "url(\"" + fontFilePath + "." + format + "\")";
  });
  return fileFontReferences.join(', ');
}

function generateLocalReferences(localFonts) {
  var localFontReferences = localFonts.map(function (font) {
    return "local(\"" + font + "\")";
  });
  return localFontReferences.join(', ');
}

function generateSources(fontFilePath, localFonts, fileFormats) {
  var fontReferences = [];
  if (localFonts) fontReferences.push(generateLocalReferences(localFonts));

  if (fontFilePath) {
    fontReferences.push(generateFileReferences(fontFilePath, fileFormats));
  }

  return fontReferences.join(', ');
}
/**
 * CSS for a @font-face declaration.
 *
 * @example
 * // Styles as object basic usage
 * const styles = {
 *    ...fontFace({
 *      'fontFamily': 'Sans-Pro',
 *      'fontFilePath': 'path/to/file'
 *    })
 * }
 *
 * // styled-components basic usage
 * const GlobalStyle = createGlobalStyle`${
 *   fontFace({
 *     'fontFamily': 'Sans-Pro',
 *     'fontFilePath': 'path/to/file'
 *   }
 * )}`
 *
 * // CSS as JS Output
 *
 * '@font-face': {
 *   'fontFamily': 'Sans-Pro',
 *   'src': 'url("path/to/file.eot"), url("path/to/file.woff2"), url("path/to/file.woff"), url("path/to/file.ttf"), url("path/to/file.svg")',
 * }
 */


function fontFace(_ref) {
  var fontFamily = _ref.fontFamily,
      fontFilePath = _ref.fontFilePath,
      fontStretch = _ref.fontStretch,
      fontStyle = _ref.fontStyle,
      fontVariant = _ref.fontVariant,
      fontWeight = _ref.fontWeight,
      _ref$fileFormats = _ref.fileFormats,
      fileFormats = _ref$fileFormats === void 0 ? ['eot', 'woff2', 'woff', 'ttf', 'svg'] : _ref$fileFormats,
      localFonts = _ref.localFonts,
      unicodeRange = _ref.unicodeRange,
      fontDisplay = _ref.fontDisplay,
      fontVariationSettings = _ref.fontVariationSettings,
      fontFeatureSettings = _ref.fontFeatureSettings;
  // Error Handling
  if (!fontFamily) throw new Error('fontFace expects a name of a font-family.');

  if (!fontFilePath && !localFonts) {
    throw new Error('fontFace expects either the path to the font file(s) or a name of a local copy.');
  }

  if (localFonts && !Array.isArray(localFonts)) {
    throw new Error('fontFace expects localFonts to be an array.');
  }

  if (!Array.isArray(fileFormats)) {
    throw new Error('fontFace expects fileFormats to be an array.');
  }

  var fontFaceDeclaration = {
    '@font-face': {
      fontFamily: fontFamily,
      src: generateSources(fontFilePath, localFonts, fileFormats),
      unicodeRange: unicodeRange,
      fontStretch: fontStretch,
      fontStyle: fontStyle,
      fontVariant: fontVariant,
      fontWeight: fontWeight,
      fontDisplay: fontDisplay,
      fontVariationSettings: fontVariationSettings,
      fontFeatureSettings: fontFeatureSettings
    } // Removes undefined fields for cleaner css object.

  };
  return JSON.parse(JSON.stringify(fontFaceDeclaration));
}

/**
 * CSS to hide text to show a background image in a SEO-friendly way.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'backgroundImage': 'url(logo.png)',
 *   ...hideText(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   backgroundImage: url(logo.png);
 *   ${hideText()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'backgroundImage': 'url(logo.png)',
 *   'textIndent': '101%',
 *   'overflow': 'hidden',
 *   'whiteSpace': 'nowrap',
 * }
 */
function hideText() {
  return {
    textIndent: '101%',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  };
}

/**
 * CSS to hide content visually but remain accessible to screen readers.
 * from [HTML5 Boilerplate](https://github.com/h5bp/html5-boilerplate/blob/9a176f57af1cfe8ec70300da4621fb9b07e5fa31/src/css/main.css#L121)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...hideVisually(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hideVisually()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'border': '0',
 *   'clip': 'rect(0 0 0 0)',
 *   'clipPath': 'inset(50%)',
 *   'height': '1px',
 *   'margin': '-1px',
 *   'overflow': 'hidden',
 *   'padding': '0',
 *   'position': 'absolute',
 *   'whiteSpace': 'nowrap',
 *   'width': '1px',
 * }
 */
function hideVisually() {
  return {
    border: '0',
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: '0',
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
  };
}

/**
 * Generates a media query to target HiDPI devices.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  [hiDPI(1.5)]: {
 *    width: 200px;
 *  }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hiDPI(1.5)} {
 *     width: 200px;
 *   }
 * `
 *
 * // CSS as JS Output
 *
 * '@media only screen and (-webkit-min-device-pixel-ratio: 1.5),
 *  only screen and (min--moz-device-pixel-ratio: 1.5),
 *  only screen and (-o-min-device-pixel-ratio: 1.5/1),
 *  only screen and (min-resolution: 144dpi),
 *  only screen and (min-resolution: 1.5dppx)': {
 *   'width': '200px',
 * }
 */
function hiDPI(ratio) {
  if (ratio === void 0) {
    ratio = 1.3;
  }

  return "\n    @media only screen and (-webkit-min-device-pixel-ratio: " + ratio + "),\n    only screen and (min--moz-device-pixel-ratio: " + ratio + "),\n    only screen and (-o-min-device-pixel-ratio: " + ratio + "/1),\n    only screen and (min-resolution: " + Math.round(ratio * 96) + "dpi),\n    only screen and (min-resolution: " + ratio + "dppx)\n  ";
}

/**
 * CSS to normalize abnormalities across browsers (normalize.css v8.0.0 | MIT License | github.com/necolas/normalize.css)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...normalize(),
 * }
 *
 * // styled-components usage
 * const GlobalStyle = createGlobalStyle`${normalize()}`
 *
 * // CSS as JS Output
 *
 * html {
 *   lineHeight: 1.15,
 *   textSizeAdjust: 100%,
 * } ...
 */
function normalize() {
  var _ref;

  return [(_ref = {
    html: {
      lineHeight: '1.15',
      textSizeAdjust: '100%'
    },
    body: {
      margin: '0'
    },
    h1: {
      fontSize: '2em',
      margin: '0.67em 0'
    },
    hr: {
      boxSizing: 'content-box',
      height: '0',
      overflow: 'visible'
    },
    pre: {
      fontFamily: 'monospace, monospace',
      fontSize: '1em'
    },
    a: {
      backgroundColor: 'transparent'
    },
    'abbr[title]': {
      borderBottom: 'none',
      textDecoration: 'underline'
    }
  }, _ref["b,\n    strong"] = {
    fontWeight: 'bolder'
  }, _ref["code,\n    kbd,\n    samp"] = {
    fontFamily: 'monospace, monospace',
    fontSize: '1em'
  }, _ref.small = {
    fontSize: '80%'
  }, _ref["sub,\n    sup"] = {
    fontSize: '75%',
    lineHeight: '0',
    position: 'relative',
    verticalAlign: 'baseline'
  }, _ref.sub = {
    bottom: '-0.25em'
  }, _ref.sup = {
    top: '-0.5em'
  }, _ref.img = {
    borderStyle: 'none'
  }, _ref["button,\n    input,\n    optgroup,\n    select,\n    textarea"] = {
    fontFamily: 'inherit',
    fontSize: '100%',
    lineHeight: '1.15',
    margin: '0'
  }, _ref["button,\n    input"] = {
    overflow: 'visible'
  }, _ref["button,\n    select"] = {
    textTransform: 'none'
  }, _ref["button,\n    html [type=\"button\"],\n    [type=\"reset\"],\n    [type=\"submit\"]"] = {
    WebkitAppearance: 'button'
  }, _ref["button::-moz-focus-inner,\n    [type=\"button\"]::-moz-focus-inner,\n    [type=\"reset\"]::-moz-focus-inner,\n    [type=\"submit\"]::-moz-focus-inner"] = {
    borderStyle: 'none',
    padding: '0'
  }, _ref["button:-moz-focusring,\n    [type=\"button\"]:-moz-focusring,\n    [type=\"reset\"]:-moz-focusring,\n    [type=\"submit\"]:-moz-focusring"] = {
    outline: '1px dotted ButtonText'
  }, _ref.fieldset = {
    padding: '0.35em 0.625em 0.75em'
  }, _ref.legend = {
    boxSizing: 'border-box',
    color: 'inherit',
    display: 'table',
    maxWidth: '100%',
    padding: '0',
    whiteSpace: 'normal'
  }, _ref.progress = {
    verticalAlign: 'baseline'
  }, _ref.textarea = {
    overflow: 'auto'
  }, _ref["[type=\"checkbox\"],\n    [type=\"radio\"]"] = {
    boxSizing: 'border-box',
    padding: '0'
  }, _ref["[type=\"number\"]::-webkit-inner-spin-button,\n    [type=\"number\"]::-webkit-outer-spin-button"] = {
    height: 'auto'
  }, _ref['[type="search"]'] = {
    WebkitAppearance: 'textfield',
    outlineOffset: '-2px'
  }, _ref['[type="search"]::-webkit-search-decoration'] = {
    WebkitAppearance: 'none'
  }, _ref['::-webkit-file-upload-button'] = {
    WebkitAppearance: 'button',
    font: 'inherit'
  }, _ref.details = {
    display: 'block'
  }, _ref.summary = {
    display: 'list-item'
  }, _ref.template = {
    display: 'none'
  }, _ref['[hidden]'] = {
    display: 'none'
  }, _ref), {
    'abbr[title]': {
      textDecoration: 'underline dotted'
    }
  }];
}

/**
 * CSS to style the placeholder pseudo-element.
 *
 * @deprecated - placeholder has been marked for deprecation in polished 2.0 and will be fully deprecated in 3.0. It is no longer needed and can safely be replaced with the non-prefixed placeholder pseudo-element.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...placeholder({'color': 'blue'})
 * }
 *
 * // styled-components usage
 * const div = styled.input`
 *    ${placeholder({'color': 'blue'})}
 * `
 *
 * // CSS as JS Output
 *
 * 'input': {
 *   '&:-moz-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&:-ms-input-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&::-moz-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&::-webkit-input-placeholder': {
 *     'color': 'blue',
 *   },
 * },
 */
function placeholder(styles, parent) {
  var _ref;

  if (parent === void 0) {
    parent = '&';
  }

  return _ref = {}, _ref[parent + "::-webkit-input-placeholder"] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styles), _ref[parent + ":-moz-placeholder"] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styles), _ref[parent + "::-moz-placeholder"] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styles), _ref[parent + ":-ms-input-placeholder"] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styles), _ref;
}

function _templateObject() {
  var data = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_taggedTemplateLiteralLoose__["a" /* default */])(["radial-gradient(", "", "", "", ")"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function parseFallback(colorStops) {
  return colorStops[0].split(' ')[0];
}

function constructGradientValue(literals) {
  var template = '';

  for (var i = 0; i < literals.length; i += 1) {
    template += literals[i]; // Adds leading coma if properties preceed color-stops

    if (i === 3 && (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]) && ((arguments.length <= 1 ? undefined : arguments[1]) || (arguments.length <= 2 ? undefined : arguments[2]) || (arguments.length <= 3 ? undefined : arguments[3]))) {
      template = template.slice(0, -1);
      template += ", " + (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]); // No trailing space if color-stops is the only param provided
    } else if (i === 3 && (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]) && !(arguments.length <= 1 ? undefined : arguments[1]) && !(arguments.length <= 2 ? undefined : arguments[2]) && !(arguments.length <= 3 ? undefined : arguments[3])) {
      template += "" + (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]); // Only adds substitution if it is defined
    } else if (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]) {
      template += (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]) + " ";
    }
  }

  return template.trim();
}
/**
 * CSS for declaring a radial gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#00FFFF',
 *   'backgroundImage': 'radial-gradient(center ellipse farthest-corner at 45px 45px, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */


function radialGradient(_ref) {
  var colorStops = _ref.colorStops,
      extent = _ref.extent,
      fallback = _ref.fallback,
      position = _ref.position,
      shape = _ref.shape;

  if (!colorStops || colorStops.length < 2) {
    throw new Error('radialGradient requries at least 2 color-stops to properly render.');
  }

  return {
    backgroundColor: fallback || parseFallback(colorStops),
    backgroundImage: constructGradientValue(_templateObject(), position, shape, extent, colorStops.join(', '))
  };
}

/**
 * A helper to generate a retina background image and non-retina
 * background image. The retina background image will output to a HiDPI media query. The mixin uses
 * a _2x.png filename suffix by default.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  ...retinaImage('my-img')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${retinaImage('my-img')}
 * `
 *
 * // CSS as JS Output
 * div {
 *   backgroundImage: 'url(my-img.png)',
 *   '@media only screen and (-webkit-min-device-pixel-ratio: 1.3),
 *    only screen and (min--moz-device-pixel-ratio: 1.3),
 *    only screen and (-o-min-device-pixel-ratio: 1.3/1),
 *    only screen and (min-resolution: 144dpi),
 *    only screen and (min-resolution: 1.5dppx)': {
 *     backgroundImage: 'url(my-img_2x.png)',
 *   }
 * }
 */
function retinaImage(filename, backgroundSize, extension, retinaFilename, retinaSuffix) {
  var _ref;

  if (extension === void 0) {
    extension = 'png';
  }

  if (retinaSuffix === void 0) {
    retinaSuffix = '_2x';
  }

  if (!filename) {
    throw new Error('Please supply a filename to retinaImage() as the first argument.');
  } // Replace the dot at the beginning of the passed extension if one exists


  var ext = extension.replace(/^\./, '');
  var rFilename = retinaFilename ? retinaFilename + "." + ext : "" + filename + retinaSuffix + "." + ext;
  return _ref = {
    backgroundImage: "url(" + filename + "." + ext + ")"
  }, _ref[hiDPI()] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    backgroundImage: "url(" + rFilename + ")"
  }, backgroundSize ? {
    backgroundSize: backgroundSize
  } : {}), _ref;
}

/**
 * CSS to style the selection pseudo-element.
 *
 * @deprecated - selection has been marked for deprecation in polished 2.0 and will be fully deprecated in 3.0. It is no longer needed and can safely be replaced with the non-prefixed selection pseudo-element.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...selection({
 *     'backgroundColor': 'blue'
 *   }, 'section')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${selection({'backgroundColor': 'blue'}, 'section')}
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'section::-moz-selection': {
 *     'backgroundColor':'blue',
 *   },
 *   'section::selection': {
 *     'backgroundColor': 'blue',
 *   }
 * }
 */
function selection(styles, parent) {
  var _ref;

  if (parent === void 0) {
    parent = '';
  }

  return _ref = {}, _ref[parent + "::-moz-selection"] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styles), _ref[parent + "::selection"] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styles), _ref;
}

/* eslint-disable key-spacing */
var functionsMap = {
  easeInBack: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
  easeInCirc: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
  easeInCubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
  easeInExpo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
  easeInQuad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
  easeInQuart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
  easeInQuint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
  easeInSine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)',
  easeOutBack: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
  easeOutCubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
  easeOutCirc: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
  easeOutExpo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
  easeOutQuad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
  easeOutQuart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
  easeOutQuint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
  easeOutSine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)',
  easeInOutBack: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
  easeInOutCirc: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
  easeInOutCubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
  easeInOutExpo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
  easeInOutQuad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
  easeInOutQuart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
  easeInOutQuint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
  easeInOutSine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
  /* eslint-enable key-spacing */

};

function getTimingFunction(functionName) {
  return functionsMap[functionName];
}
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': timingFunctions('easeInQuad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${timingFunctions('easeInQuad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
 * }
 */


function timingFunctions(timingFunction) {
  return getTimingFunction(timingFunction);
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderColor('red', 'green', 'blue', 'yellow')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderColor('red', 'green', 'blue', 'yellow')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderRightColor': 'green',
 *   'borderBottomColor': 'blue',
 *   'borderLeftColor': 'yellow'
 * }
 */
function borderColor() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(void 0, ['borderColor'].concat(values));
}

var getBorderWidth = function getBorderWidth(pointingDirection, height, width) {
  switch (pointingDirection) {
    case 'top':
      return "0 " + width[0] / 2 + width[1] + " " + height[0] + height[1] + " " + width[0] / 2 + width[1];

    case 'left':
      return "" + height[0] / 2 + height[1] + " " + width[0] + width[1] + " " + height[0] / 2 + height[1] + " 0";

    case 'bottom':
      return "" + height[0] + height[1] + " " + width[0] / 2 + width[1] + " 0 " + width[0] / 2 + width[1];

    case 'right':
      return "" + height[0] / 2 + height[1] + " 0 " + height[0] / 2 + height[1] + " " + width[0] + width[1];

    default:
      throw new Error("Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.");
  }
}; // needed for border-color


var reverseDirection = ['bottom', 'left', 'top', 'right'];
var NUMBER_AND_FLOAT = /(\d*\.?\d*)/;
/**
 * CSS to represent triangle with any pointing direction with an optional background color. Accepts number or px values for height and width.
 *
 * @example
 * // Styles as object usage
 *
 * const styles = {
 *   ...triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })
 * }
 *
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })}
 *
 *
 * // CSS as JS Output
 *
 * div: {
 *  'borderColor': 'transparent',
 *  'borderLeftColor': 'red !important',
 *  'borderStyle': 'solid',
 *  'borderWidth': '50px 0 50px 100px',
 *  'height': '0',
 *  'width': '0',
 * }
 */

function triangle(_ref) {
  var pointingDirection = _ref.pointingDirection,
      height = _ref.height,
      width = _ref.width,
      foregroundColor = _ref.foregroundColor,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? 'transparent' : _ref$backgroundColor;
  var widthAndUnit = [parseFloat(width), String(width).replace(NUMBER_AND_FLOAT, '') || 'px'];
  var heightAndUnit = [parseFloat(height), String(height).replace(NUMBER_AND_FLOAT, '') || 'px'];

  if (isNaN(heightAndUnit[0]) || isNaN(widthAndUnit[0])) {
    throw new Error('Passed an invalid value to `height` or `width`. Please provide a pixel based unit');
  }

  var reverseDirectionIndex = reverseDirection.indexOf(pointingDirection);
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    width: '0',
    height: '0',
    borderWidth: getBorderWidth(pointingDirection, heightAndUnit, widthAndUnit),
    borderStyle: 'solid'
  }, borderColor.apply(void 0, Array.from({
    length: 4
  }).map(function (_, index) {
    return index === reverseDirectionIndex ? foregroundColor : backgroundColor;
  })));
}

/**
 * Provides an easy way to change the `wordWrap` property.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...wordWrap('break-word')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${wordWrap('break-word')}
 * `
 *
 * // CSS as JS Output
 *
 * const styles = {
 *   overflowWrap: 'break-word',
 *   wordWrap: 'break-word',
 *   wordBreak: 'break-all',
 * }
 */
function wordWrap(wrap) {
  if (wrap === void 0) {
    wrap = 'break-word';
  }

  var wordBreak = wrap === 'break-word' ? 'break-all' : wrap;
  return {
    overflowWrap: wrap,
    wordWrap: wrap,
    wordBreak: wordBreak
  };
}

function colorToInt(color) {
  return Math.round(color * 255);
}

function convertToInt(red, green, blue) {
  return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
}

function hslToRgb(hue, saturation, lightness, convert) {
  if (convert === void 0) {
    convert = convertToInt;
  }

  if (saturation === 0) {
    // achromatic
    return convert(lightness, lightness, lightness);
  } // formular from https://en.wikipedia.org/wiki/HSL_and_HSV


  var huePrime = hue % 360 / 60;
  var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
  var red = 0;
  var green = 0;
  var blue = 0;

  if (huePrime >= 0 && huePrime < 1) {
    red = chroma;
    green = secondComponent;
  } else if (huePrime >= 1 && huePrime < 2) {
    red = secondComponent;
    green = chroma;
  } else if (huePrime >= 2 && huePrime < 3) {
    green = chroma;
    blue = secondComponent;
  } else if (huePrime >= 3 && huePrime < 4) {
    green = secondComponent;
    blue = chroma;
  } else if (huePrime >= 4 && huePrime < 5) {
    red = secondComponent;
    blue = chroma;
  } else if (huePrime >= 5 && huePrime < 6) {
    red = chroma;
    blue = secondComponent;
  }

  var lightnessModification = lightness - chroma / 2;
  var finalRed = red + lightnessModification;
  var finalGreen = green + lightnessModification;
  var finalBlue = blue + lightnessModification;
  return convert(finalRed, finalGreen, finalBlue);
}

var namedColorMap = {
  aliceblue: 'f0f8ff',
  antiquewhite: 'faebd7',
  aqua: '00ffff',
  aquamarine: '7fffd4',
  azure: 'f0ffff',
  beige: 'f5f5dc',
  bisque: 'ffe4c4',
  black: '000',
  blanchedalmond: 'ffebcd',
  blue: '0000ff',
  blueviolet: '8a2be2',
  brown: 'a52a2a',
  burlywood: 'deb887',
  cadetblue: '5f9ea0',
  chartreuse: '7fff00',
  chocolate: 'd2691e',
  coral: 'ff7f50',
  cornflowerblue: '6495ed',
  cornsilk: 'fff8dc',
  crimson: 'dc143c',
  cyan: '00ffff',
  darkblue: '00008b',
  darkcyan: '008b8b',
  darkgoldenrod: 'b8860b',
  darkgray: 'a9a9a9',
  darkgreen: '006400',
  darkgrey: 'a9a9a9',
  darkkhaki: 'bdb76b',
  darkmagenta: '8b008b',
  darkolivegreen: '556b2f',
  darkorange: 'ff8c00',
  darkorchid: '9932cc',
  darkred: '8b0000',
  darksalmon: 'e9967a',
  darkseagreen: '8fbc8f',
  darkslateblue: '483d8b',
  darkslategray: '2f4f4f',
  darkslategrey: '2f4f4f',
  darkturquoise: '00ced1',
  darkviolet: '9400d3',
  deeppink: 'ff1493',
  deepskyblue: '00bfff',
  dimgray: '696969',
  dimgrey: '696969',
  dodgerblue: '1e90ff',
  firebrick: 'b22222',
  floralwhite: 'fffaf0',
  forestgreen: '228b22',
  fuchsia: 'ff00ff',
  gainsboro: 'dcdcdc',
  ghostwhite: 'f8f8ff',
  gold: 'ffd700',
  goldenrod: 'daa520',
  gray: '808080',
  green: '008000',
  greenyellow: 'adff2f',
  grey: '808080',
  honeydew: 'f0fff0',
  hotpink: 'ff69b4',
  indianred: 'cd5c5c',
  indigo: '4b0082',
  ivory: 'fffff0',
  khaki: 'f0e68c',
  lavender: 'e6e6fa',
  lavenderblush: 'fff0f5',
  lawngreen: '7cfc00',
  lemonchiffon: 'fffacd',
  lightblue: 'add8e6',
  lightcoral: 'f08080',
  lightcyan: 'e0ffff',
  lightgoldenrodyellow: 'fafad2',
  lightgray: 'd3d3d3',
  lightgreen: '90ee90',
  lightgrey: 'd3d3d3',
  lightpink: 'ffb6c1',
  lightsalmon: 'ffa07a',
  lightseagreen: '20b2aa',
  lightskyblue: '87cefa',
  lightslategray: '789',
  lightslategrey: '789',
  lightsteelblue: 'b0c4de',
  lightyellow: 'ffffe0',
  lime: '0f0',
  limegreen: '32cd32',
  linen: 'faf0e6',
  magenta: 'f0f',
  maroon: '800000',
  mediumaquamarine: '66cdaa',
  mediumblue: '0000cd',
  mediumorchid: 'ba55d3',
  mediumpurple: '9370db',
  mediumseagreen: '3cb371',
  mediumslateblue: '7b68ee',
  mediumspringgreen: '00fa9a',
  mediumturquoise: '48d1cc',
  mediumvioletred: 'c71585',
  midnightblue: '191970',
  mintcream: 'f5fffa',
  mistyrose: 'ffe4e1',
  moccasin: 'ffe4b5',
  navajowhite: 'ffdead',
  navy: '000080',
  oldlace: 'fdf5e6',
  olive: '808000',
  olivedrab: '6b8e23',
  orange: 'ffa500',
  orangered: 'ff4500',
  orchid: 'da70d6',
  palegoldenrod: 'eee8aa',
  palegreen: '98fb98',
  paleturquoise: 'afeeee',
  palevioletred: 'db7093',
  papayawhip: 'ffefd5',
  peachpuff: 'ffdab9',
  peru: 'cd853f',
  pink: 'ffc0cb',
  plum: 'dda0dd',
  powderblue: 'b0e0e6',
  purple: '800080',
  rebeccapurple: '639',
  red: 'f00',
  rosybrown: 'bc8f8f',
  royalblue: '4169e1',
  saddlebrown: '8b4513',
  salmon: 'fa8072',
  sandybrown: 'f4a460',
  seagreen: '2e8b57',
  seashell: 'fff5ee',
  sienna: 'a0522d',
  silver: 'c0c0c0',
  skyblue: '87ceeb',
  slateblue: '6a5acd',
  slategray: '708090',
  slategrey: '708090',
  snow: 'fffafa',
  springgreen: '00ff7f',
  steelblue: '4682b4',
  tan: 'd2b48c',
  teal: '008080',
  thistle: 'd8bfd8',
  tomato: 'ff6347',
  turquoise: '40e0d0',
  violet: 'ee82ee',
  wheat: 'f5deb3',
  white: 'fff',
  whitesmoke: 'f5f5f5',
  yellow: 'ff0',
  yellowgreen: '9acd32'
  /**
   * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
   * @private
   */

};

function nameToHex(color) {
  if (typeof color !== 'string') return color;
  var normalizedColorName = color.toLowerCase();
  return namedColorMap[normalizedColorName] ? "#" + namedColorMap[normalizedColorName] : color;
}

var hexRegex = /^#[a-fA-F0-9]{6}$/;
var hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var rgbRegex = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
var rgbaRegex = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;
var hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*\)$/;
var hslaRegex = /^hsla\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = parseToRgb('rgb(255, 0, 0)');
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
 */

function parseToRgb(color) {
  if (typeof color !== 'string') {
    throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
  }

  var normalizedColor = nameToHex(color);

  if (normalizedColor.match(hexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
  }

  if (normalizedColor.match(hexRgbaRegex)) {
    var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
      alpha: alpha
    };
  }

  if (normalizedColor.match(reducedHexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
  }

  if (normalizedColor.match(reducedRgbaHexRegex)) {
    var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));

    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
      alpha: _alpha
    };
  }

  var rgbMatched = rgbRegex.exec(normalizedColor);

  if (rgbMatched) {
    return {
      red: parseInt("" + rgbMatched[1], 10),
      green: parseInt("" + rgbMatched[2], 10),
      blue: parseInt("" + rgbMatched[3], 10)
    };
  }

  var rgbaMatched = rgbaRegex.exec(normalizedColor);

  if (rgbaMatched) {
    return {
      red: parseInt("" + rgbaMatched[1], 10),
      green: parseInt("" + rgbaMatched[2], 10),
      blue: parseInt("" + rgbaMatched[3], 10),
      alpha: parseFloat("" + rgbaMatched[4])
    };
  }

  var hslMatched = hslRegex.exec(normalizedColor);

  if (hslMatched) {
    var hue = parseInt("" + hslMatched[1], 10);
    var saturation = parseInt("" + hslMatched[2], 10) / 100;
    var lightness = parseInt("" + hslMatched[3], 10) / 100;
    var rgbColorString = "rgb(" + hslToRgb(hue, saturation, lightness) + ")";
    var hslRgbMatched = rgbRegex.exec(rgbColorString);

    if (!hslRgbMatched) {
      throw new Error("Couldn't generate valid rgb string from " + normalizedColor + ", it returned " + rgbColorString + ".");
    }

    return {
      red: parseInt("" + hslRgbMatched[1], 10),
      green: parseInt("" + hslRgbMatched[2], 10),
      blue: parseInt("" + hslRgbMatched[3], 10)
    };
  }

  var hslaMatched = hslaRegex.exec(normalizedColor);

  if (hslaMatched) {
    var _hue = parseInt("" + hslaMatched[1], 10);

    var _saturation = parseInt("" + hslaMatched[2], 10) / 100;

    var _lightness = parseInt("" + hslaMatched[3], 10) / 100;

    var _rgbColorString = "rgb(" + hslToRgb(_hue, _saturation, _lightness) + ")";

    var _hslRgbMatched = rgbRegex.exec(_rgbColorString);

    if (!_hslRgbMatched) {
      throw new Error("Couldn't generate valid rgb string from " + normalizedColor + ", it returned " + _rgbColorString + ".");
    }

    return {
      red: parseInt("" + _hslRgbMatched[1], 10),
      green: parseInt("" + _hslRgbMatched[2], 10),
      blue: parseInt("" + _hslRgbMatched[3], 10),
      alpha: parseFloat("" + hslaMatched[4])
    };
  }

  throw new Error("Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.");
}

function rgbToHsl(color) {
  // make sure rgb are contained in a set of [0, 255]
  var red = color.red / 255;
  var green = color.green / 255;
  var blue = color.blue / 255;
  var max = Math.max(red, green, blue);
  var min = Math.min(red, green, blue);
  var lightness = (max + min) / 2;

  if (max === min) {
    // achromatic
    if (color.alpha !== undefined) {
      return {
        hue: 0,
        saturation: 0,
        lightness: lightness,
        alpha: color.alpha
      };
    } else {
      return {
        hue: 0,
        saturation: 0,
        lightness: lightness
      };
    }
  }

  var hue;
  var delta = max - min;
  var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);

  switch (max) {
    case red:
      hue = (green - blue) / delta + (green < blue ? 6 : 0);
      break;

    case green:
      hue = (blue - red) / delta + 2;
      break;

    default:
      // blue case
      hue = (red - green) / delta + 4;
      break;
  }

  hue *= 60;

  if (color.alpha !== undefined) {
    return {
      hue: hue,
      saturation: saturation,
      lightness: lightness,
      alpha: color.alpha
    };
  }

  return {
    hue: hue,
    saturation: saturation,
    lightness: lightness
  };
}

/**
 * Returns an HslColor or HslaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a HslColor or HslaColor object back to a string.
 *
 * @example
 * // Assigns `{ hue: 0, saturation: 1, lightness: 0.5 }` to color1
 * const color1 = parseToHsl('rgb(255, 0, 0)');
 * // Assigns `{ hue: 128, saturation: 1, lightness: 0.5, alpha: 0.75 }` to color2
 * const color2 = parseToHsl('hsla(128, 100%, 50%, 0.75)');
 */
function parseToHsl(color) {
  // Note: At a later stage we can optimize this function as right now a hsl
  // color would be parsed converted to rgb values and converted back to hsl.
  return rgbToHsl(parseToRgb(color));
}

/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */
var reduceHexValue = function reduceHexValue(value) {
  if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
    return "#" + value[1] + value[3] + value[5];
  }

  return value;
};

function numberToHex(value) {
  var hex = value.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}

function colorToHex(color) {
  return numberToHex(Math.round(color * 255));
}

function convertToHex(red, green, blue) {
  return reduceHexValue("#" + colorToHex(red) + colorToHex(green) + colorToHex(blue));
}

function hslToHex(hue, saturation, lightness) {
  return hslToRgb(hue, saturation, lightness, convertToHex);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsl(359, 0.75, 0.4),
 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsl(359, 0.75, 0.4)};
 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#b3191c";
 *   background: "#b3191c";
 * }
 */
function hsl(value, saturation, lightness) {
  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number') {
    return hslToHex(value, saturation, lightness);
  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined) {
    return hslToHex(value.hue, value.saturation, value.lightness);
  }

  throw new Error('Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).');
}

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsla(359, 0.75, 0.4, 0.7),
 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
 *   background: hsla(359, 0.75, 0.4, 1),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
 *   background: ${hsla(359, 0.75, 0.4, 1)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(179,25,28,0.7)";
 *   background: "rgba(179,25,28,0.7)";
 *   background: "#b3191c";
 * }
 */
function hsla(value, saturation, lightness, alpha) {
  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number' && typeof alpha === 'number') {
    return alpha >= 1 ? hslToHex(value, saturation, lightness) : "rgba(" + hslToRgb(value, saturation, lightness) + "," + alpha + ")";
  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined && alpha === undefined) {
    return value.alpha >= 1 ? hslToHex(value.hue, value.saturation, value.lightness) : "rgba(" + hslToRgb(value.hue, value.saturation, value.lightness) + "," + value.alpha + ")";
  }

  throw new Error('Passed invalid arguments to hsla, please pass multiple numbers e.g. hsl(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).');
}

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */
function rgb(value, green, blue) {
  if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') {
    return reduceHexValue("#" + numberToHex(value) + numberToHex(green) + numberToHex(blue));
  } else if (typeof value === 'object' && green === undefined && blue === undefined) {
    return reduceHexValue("#" + numberToHex(value.red) + numberToHex(value.green) + numberToHex(value.blue));
  }

  throw new Error('Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).');
}

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */
function rgba(firstValue, secondValue, thirdValue, fourthValue) {
  if (typeof firstValue === 'string' && typeof secondValue === 'number') {
    var rgbValue = parseToRgb(firstValue);
    return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
  } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') {
    return fourthValue >= 1 ? rgb(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
  } else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) {
    return firstValue.alpha >= 1 ? rgb(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
  }

  throw new Error('Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).');
}

var isRgb = function isRgb(color) {
  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};

var isRgba = function isRgba(color) {
  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && typeof color.alpha === 'number';
};

var isHsl = function isHsl(color) {
  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};

var isHsla = function isHsla(color) {
  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && typeof color.alpha === 'number';
};

var errMsg = 'Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.';
/**
 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */

function toColorString(color) {
  if (typeof color !== 'object') throw new Error(errMsg);
  if (isRgba(color)) return rgba(color);
  if (isRgb(color)) return rgb(color);
  if (isHsla(color)) return hsla(color);
  if (isHsl(color)) return hsl(color);
  throw new Error(errMsg);
}

// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-redeclare
function curried(f, length, acc) {
  return function fn() {
    // eslint-disable-next-line prefer-rest-params
    var combined = acc.concat(Array.prototype.slice.call(arguments));
    return combined.length >= length ? f.apply(this, combined) : curried(f, length, combined);
  };
} // eslint-disable-next-line no-redeclare


function curry(f) {
  // eslint-disable-line no-redeclare
  return curried(f, f.length, []);
}

/**
 * Changes the hue of the color. Hue is a number between 0 to 360. The first
 * argument for adjustHue is the amount of degrees the color is rotated along
 * the color wheel.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: adjustHue(180, '#448'),
 *   background: adjustHue('180', 'rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${adjustHue(180, '#448')};
 *   background: ${adjustHue('180', 'rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#888844";
 *   background: "rgba(136,136,68,0.7)";
 * }
 */

function adjustHue(degree, color) {
  var hslColor = parseToHsl(color);
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, hslColor, {
    hue: (hslColor.hue + parseFloat(degree)) % 360
  }));
} // prettier-ignore


var curriedAdjustHue =
/*#__PURE__*/
curry
/* ::<number | string, string, string> */
(adjustHue);

/**
 * Returns the complement of the provided color. This is identical to adjustHue(180, <color>).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: complement('#448'),
 *   background: complement('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${complement('#448')};
 *   background: ${complement('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#884";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */

function complement(color) {
  var hslColor = parseToHsl(color);
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, hslColor, {
    hue: (hslColor.hue + 180) % 360
  }));
}

function guard(lowerBoundary, upperBoundary, value) {
  return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}

/**
 * Returns a string value for the darkened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: darken(0.2, '#FFCD64'),
 *   background: darken('0.2', 'rgba(255,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${darken(0.2, '#FFCD64')};
 *   background: ${darken('0.2', 'rgba(255,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffbd31";
 *   background: "rgba(255,189,49,0.7)";
 * }
 */

function darken(amount, color) {
  var hslColor = parseToHsl(color);
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness - parseFloat(amount))
  }));
} // prettier-ignore


var curriedDarken =
/*#__PURE__*/
curry
/* ::<number | string, string, string> */
(darken);

/**
 * Decreases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the desaturate function is the amount by how much the color
 * intensity should be decreased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: desaturate(0.2, '#CCCD64'),
 *   background: desaturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${desaturate(0.2, '#CCCD64')};
 *   background: ${desaturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#b8b979";
 *   background: "rgba(184,185,121,0.7)";
 * }
 */

function desaturate(amount, color) {
  var hslColor = parseToHsl(color);
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, hslColor, {
    saturation: guard(0, 1, hslColor.saturation - parseFloat(amount))
  }));
} // prettier-ignore


var curriedDesaturate =
/*#__PURE__*/
curry
/* ::<number | string, string, string> */
(desaturate);

/**
 * Returns a number (float) representing the luminance of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff',
 *   background: getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)',
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff'};
 *   background: ${getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)'};
 *
 * // CSS in JS Output
 *
 * div {
 *   background: "#CCCD64";
 *   background: "rgba(58, 133, 255, 1)";
 * }
 */

function getLuminance(color) {
  var rgbColor = parseToRgb(color);

  var _Object$keys$map = Object.keys(rgbColor).map(function (key) {
    var channel = rgbColor[key] / 255;
    return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
  }),
      r = _Object$keys$map[0],
      g = _Object$keys$map[1],
      b = _Object$keys$map[2];

  return parseFloat((0.2126 * r + 0.7152 * g + 0.0722 * b).toFixed(3));
}

/**
 * Converts the color to a grayscale, by reducing its saturation to 0.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: grayscale('#CCCD64'),
 *   background: grayscale('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${grayscale('#CCCD64')};
 *   background: ${grayscale('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#999";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */

function grayscale(color) {
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, parseToHsl(color), {
    saturation: 0
  }));
}

/**
 * Inverts the red, green and blue values of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: invert('#CCCD64'),
 *   background: invert('rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${invert('#CCCD64')};
 *   background: ${invert('rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#33329b";
 *   background: "rgba(154,155,50,0.7)";
 * }
 */

function invert(color) {
  // parse color string to rgb
  var value = parseToRgb(color);
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, value, {
    red: 255 - value.red,
    green: 255 - value.green,
    blue: 255 - value.blue
  }));
}

/**
 * Returns a string value for the lightened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: lighten(0.2, '#CCCD64'),
 *   background: lighten('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${lighten(0.2, '#FFCD64')};
 *   background: ${lighten('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e5e6b1";
 *   background: "rgba(229,230,177,0.7)";
 * }
 */

function lighten(amount, color) {
  var hslColor = parseToHsl(color);
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness + parseFloat(amount))
  }));
} // prettier-ignore


var curriedLighten =
/*#__PURE__*/
curry
/* ::<number | string, string, string> */
(lighten);

/**
 * Mixes the two provided colors together by calculating the average of each of the RGB components weighted to the first color by the provided weight.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: mix(0.5, '#f00', '#00f')
 *   background: mix(0.25, '#f00', '#00f')
 *   background: mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${mix(0.5, '#f00', '#00f')};
 *   background: ${mix(0.25, '#f00', '#00f')};
 *   background: ${mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#7f007f";
 *   background: "#3f00bf";
 *   background: "rgba(63, 0, 191, 0.75)";
 * }
 */

function mix(weight, color, otherColor) {
  var parsedColor1 = parseToRgb(color);

  var color1 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, parsedColor1, {
    alpha: typeof parsedColor1.alpha === 'number' ? parsedColor1.alpha : 1
  });

  var parsedColor2 = parseToRgb(otherColor);

  var color2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, parsedColor2, {
    alpha: typeof parsedColor2.alpha === 'number' ? parsedColor2.alpha : 1 // The formular is copied from the original Sass implementation:
    // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method

  });

  var alphaDelta = color1.alpha - color2.alpha;
  var x = parseFloat(weight) * 2 - 1;
  var y = x * alphaDelta === -1 ? x : x + alphaDelta;
  var z = 1 + x * alphaDelta;
  var weight1 = (y / z + 1) / 2.0;
  var weight2 = 1 - weight1;
  var mixedColor = {
    red: Math.floor(color1.red * weight1 + color2.red * weight2),
    green: Math.floor(color1.green * weight1 + color2.green * weight2),
    blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
    alpha: color1.alpha + (color2.alpha - color1.alpha) * (parseFloat(weight) / 1.0)
  };
  return rgba(mixedColor);
} // prettier-ignore


var curriedMix =
/*#__PURE__*/
curry
/* ::<number | string, string, string, string> */
(mix);

/**
 * Increases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: opacify(0.1, 'rgba(255, 255, 255, 0.9)');
 *   background: opacify(0.2, 'hsla(0, 0%, 100%, 0.5)'),
 *   background: opacify('0.5', 'rgba(255, 0, 0, 0.2)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${opacify(0.1, 'rgba(255, 255, 255, 0.9)')};
 *   background: ${opacify(0.2, 'hsla(0, 0%, 100%, 0.5)')},
 *   background: ${opacify('0.5', 'rgba(255, 0, 0, 0.2)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#fff";
 *   background: "rgba(255,255,255,0.7)";
 *   background: "rgba(255,0,0,0.7)";
 * }
 */

function opacify(amount, color) {
  var parsedColor = parseToRgb(color);
  var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;

  var colorWithAlpha = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, parsedColor, {
    alpha: guard(0, 1, (alpha * 100 + parseFloat(amount) * 100) / 100)
  });

  return rgba(colorWithAlpha);
} // prettier-ignore


var curriedOpacify =
/*#__PURE__*/
curry
/* ::<number | string, string, string> */
(opacify);

/**
 * Returns black or white for best contrast depending on the luminosity of the given color.
 * Follows W3C specs for readability at https://www.w3.org/TR/WCAG20-TECHS/G18.html
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   color: readableColor('#000'),
 *   color: readableColor('papayawhip'),
 *   color: readableColor('rgb(255,0,0)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   color: ${readableColor('#000')};
 *   color: ${readableColor('papayawhip')};
 *   color: ${readableColor('rgb(255,0,0)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   color: "#fff";
 *   color: "#fff";
 *   color: "#000";
 * }
 */

function readableColor(color) {
  return getLuminance(color) > 0.179 ? '#000' : '#fff';
}

/**
 * Increases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the saturate function is the amount by how much the color
 * intensity should be increased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: saturate(0.2, '#CCCD64'),
 *   background: saturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${saturate(0.2, '#FFCD64')};
 *   background: ${saturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e0e250";
 *   background: "rgba(224,226,80,0.7)";
 * }
 */

function saturate(amount, color) {
  var hslColor = parseToHsl(color);
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, hslColor, {
    saturation: guard(0, 1, hslColor.saturation + parseFloat(amount))
  }));
} // prettier-ignore


var curriedSaturate =
/*#__PURE__*/
curry
/* ::<number | string, string, string> */
(saturate);

/**
 * Sets the hue of a color to the provided value. The hue range can be
 * from 0 and 359.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setHue(42, '#CCCD64'),
 *   background: setHue('244', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setHue(42, '#CCCD64')};
 *   background: ${setHue('244', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#cdae64";
 *   background: "rgba(107,100,205,0.7)";
 * }
 */

function setHue(hue, color) {
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, parseToHsl(color), {
    hue: parseFloat(hue)
  }));
} // prettier-ignore


var curriedSetHue =
/*#__PURE__*/
curry
/* ::<number | string, string, string> */
(setHue);

/**
 * Sets the lightness of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setLightness(0.2, '#CCCD64'),
 *   background: setLightness('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setLightness(0.2, '#CCCD64')};
 *   background: ${setLightness('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#4d4d19";
 *   background: "rgba(223,224,159,0.7)";
 * }
 */

function setLightness(lightness, color) {
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, parseToHsl(color), {
    lightness: parseFloat(lightness)
  }));
} // prettier-ignore


var curriedSetLightness =
/*#__PURE__*/
curry
/* ::<number | string, string, string> */
(setLightness);

/**
 * Sets the saturation of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setSaturation(0.2, '#CCCD64'),
 *   background: setSaturation('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setSaturation(0.2, '#CCCD64')};
 *   background: ${setSaturation('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#adad84";
 *   background: "rgba(228,229,76,0.7)";
 * }
 */

function setSaturation(saturation, color) {
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, parseToHsl(color), {
    saturation: parseFloat(saturation)
  }));
} // prettier-ignore


var curriedSetSaturation =
/*#__PURE__*/
curry
/* ::<number | string, string, string> */
(setSaturation);

/**
 * Shades a color by mixing it with black. `shade` can produce
 * hue shifts, where as `darken` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: shade(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${shade(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#00003f";
 * }
 */

function shade(percentage, color) {
  return curriedMix(parseFloat(percentage), 'rgb(0, 0, 0)', color);
} // prettier-ignore


var curriedShade =
/*#__PURE__*/
curry
/* ::<number | string, string, string> */
(shade);

/**
 * Tints a color by mixing it with white. `tint` can produce
 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: tint(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${tint(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#bfbfff";
 * }
 */

function tint(percentage, color) {
  return curriedMix(parseFloat(percentage), 'rgb(255, 255, 255)', color);
} // prettier-ignore


var curriedTint =
/*#__PURE__*/
curry
/* ::<number | string, string, string> */
(tint);

/**
 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: transparentize(0.1, '#fff');
 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
 *   background: transparentize('0.5', 'rgba(255, 0, 0, 0.8)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${transparentize(0.1, '#fff')};
 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')},
 *   background: ${transparentize('0.5', 'rgba(255, 0, 0, 0.8)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,255,255,0.9)";
 *   background: "rgba(255,255,255,0.8)";
 *   background: "rgba(255,0,0,0.3)";
 * }
 */

function transparentize(amount, color) {
  var parsedColor = parseToRgb(color);
  var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;

  var colorWithAlpha = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, parsedColor, {
    alpha: guard(0, 1, (alpha * 100 - parseFloat(amount) * 100) / 100)
  });

  return rgba(colorWithAlpha);
} // prettier-ignore


var curriedTransparentize =
/*#__PURE__*/
curry
/* ::<number | string, string, string> */
(transparentize);

/**
 * Shorthand for easily setting the animation property. Allows either multiple arrays with animations
 * or a single animation spread over the arguments.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out, colorchange 2s'
 * }
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation('rotate', '1s', 'ease-in-out')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation('rotate', '1s', 'ease-in-out')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out'
 * }
 */
function animation() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  // Allow single or multiple animations passed
  var multiMode = Array.isArray(args[0]);

  if (!multiMode && args.length > 8) {
    throw new Error('The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation');
  }

  var code = args.map(function (arg) {
    if (multiMode && !Array.isArray(arg) || !multiMode && Array.isArray(arg)) {
      throw new Error("To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')");
    }

    if (Array.isArray(arg) && arg.length > 8) {
      throw new Error('The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation');
    }

    return Array.isArray(arg) ? arg.join(' ') : arg;
  }).join(', ');
  return {
    animation: code
  };
}

/**
 * Shorthand that accepts any number of backgroundImage values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'backgroundImage': 'url("/image/background.jpg"), linear-gradient(red, green)'
 * }
 */
function backgroundImages() {
  for (var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }

  return {
    backgroundImage: properties.join(', ')
  };
}

/**
 * Shorthand that accepts any number of background values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'background': 'url("/image/background.jpg"), linear-gradient(red, green), center no-repeat'
 * }
 */
function backgrounds() {
  for (var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }

  return {
    background: properties.join(', ')
  };
}

var sideMap = ['top', 'right', 'bottom', 'left'];
/**
 * Shorthand for the border property that splits out individual properties for use with tools like Fela and Styletron. A side keyword can optionally be passed to target only one side's border properties.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...border('1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderColor': 'red',
 *   'borderStyle': 'solid',
 *   'borderWidth': `1px`,
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...border('top', '1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('top', '1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderTopStyle': 'solid',
 *   'borderTopWidth': `1px`,
 * }
 */

function border(sideKeyword) {
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  if (typeof sideKeyword === 'string' && sideMap.indexOf(sideKeyword) >= 0) {
    var _ref;

    return _ref = {}, _ref["border" + capitalizeString(sideKeyword) + "Width"] = values[0], _ref["border" + capitalizeString(sideKeyword) + "Style"] = values[1], _ref["border" + capitalizeString(sideKeyword) + "Color"] = values[2], _ref;
  } else {
    values.unshift(sideKeyword);
    return {
      borderWidth: values[0],
      borderStyle: values[1],
      borderColor: values[2]
    };
  }
}

/**
 * Shorthand that accepts a value for side and a value for radius and applies the radius value to both corners of the side.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderRadius('top', '5px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderRadius('top', '5px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopRightRadius': '5px',
 *   'borderTopLeftRadius': '5px',
 * }
 */
function borderRadius(side, radius) {
  var uppercaseSide = capitalizeString(side);

  if (!radius && radius !== 0) {
    throw new Error('borderRadius expects a radius value as a string or number as the second argument.');
  }

  if (uppercaseSide === 'Top' || uppercaseSide === 'Bottom') {
    var _ref;

    return _ref = {}, _ref["border" + uppercaseSide + "RightRadius"] = radius, _ref["border" + uppercaseSide + "LeftRadius"] = radius, _ref;
  }

  if (uppercaseSide === 'Left' || uppercaseSide === 'Right') {
    var _ref2;

    return _ref2 = {}, _ref2["borderTop" + uppercaseSide + "Radius"] = radius, _ref2["borderBottom" + uppercaseSide + "Radius"] = radius, _ref2;
  }

  throw new Error('borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.');
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderStyle('solid', 'dashed', 'dotted', 'double')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderStyle('solid', 'dashed', 'dotted', 'double')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopStyle': 'solid',
 *   'borderRightStyle': 'dashed',
 *   'borderBottomStyle': 'dotted',
 *   'borderLeftStyle': 'double'
 * }
 */
function borderStyle() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(void 0, ['borderStyle'].concat(values));
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderWidth('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderWidth('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopWidth': '12px',
 *   'borderRightWidth': '24px',
 *   'borderBottomWidth': '36px',
 *   'borderLeftWidth': '48px'
 * }
 */
function borderWidth() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(void 0, ['borderWidth'].concat(values));
}

function generateSelectors(template, state) {
  var stateSuffix = state ? ":" + state : '';
  return template(stateSuffix);
}
/**
 * Function helper that adds an array of states to a template of selectors. Used in textInputs and buttons.
 * @private
 */


function statefulSelectors(states, template, stateMap) {
  if (!template) throw new Error('You must provide a template to this method.');
  if (states.length === 0) return generateSelectors(template, null);
  var selectors = [];

  for (var i = 0; i < states.length; i += 1) {
    if (stateMap && stateMap.indexOf(states[i]) < 0) {
      throw new Error('You passed an unsupported selector state to this method.');
    }

    selectors.push(generateSelectors(template, states[i]));
  }

  selectors = selectors.join(',');
  return selectors;
}

var stateMap = [undefined, null, 'active', 'focus', 'hover'];

function template(state) {
  return "button" + state + ",\n  input[type=\"button\"]" + state + ",\n  input[type=\"reset\"]" + state + ",\n  input[type=\"submit\"]" + state;
}
/**
 * Populates selectors that target all buttons. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [buttons('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${buttons('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'button:active,
 *  'input[type="button"]:active,
 *  'input[type=\"reset\"]:active,
 *  'input[type=\"submit\"]:active: {
 *   'border': 'none'
 * }
 */


function buttons() {
  for (var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++) {
    states[_key] = arguments[_key];
  }

  return statefulSelectors(states, template, stateMap);
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...margin('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${margin('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'marginTop': '12px',
 *   'marginRight': '24px',
 *   'marginBottom': '36px',
 *   'marginLeft': '48px'
 * }
 */
function margin() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(void 0, ['margin'].concat(values));
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...padding('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${padding('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */
function padding() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(void 0, ['padding'].concat(values));
}

var positionMap$1 = ['absolute', 'fixed', 'relative', 'static', 'sticky'];
/**
 * Shorthand accepts up to five values, including null to skip a value, and maps them to their respective directions. The first value can optionally be a position keyword.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...position('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...position('absolute', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('absolute', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'position': 'absolute',
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 */

function position(positionKeyword) {
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  if (positionMap$1.indexOf(positionKeyword) >= 0) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      position: positionKeyword
    }, directionalProperty.apply(void 0, [''].concat(values)));
  } else {
    var firstValue = positionKeyword; // in this case position is actually the first value

    return directionalProperty.apply(void 0, ['', firstValue].concat(values));
  }
}

/**
 * Shorthand to set the height and width properties in a single statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...size('300px', '250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${size('300px', '250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'height': '300px',
 *   'width': '250px',
 * }
 */
function size(height, width) {
  if (width === void 0) {
    width = height;
  }

  return {
    height: height,
    width: width
  };
}

var stateMap$1 = [undefined, null, 'active', 'focus', 'hover'];

function template$1(state) {
  return "input[type=\"color\"]" + state + ",\n    input[type=\"date\"]" + state + ",\n    input[type=\"datetime\"]" + state + ",\n    input[type=\"datetime-local\"]" + state + ",\n    input[type=\"email\"]" + state + ",\n    input[type=\"month\"]" + state + ",\n    input[type=\"number\"]" + state + ",\n    input[type=\"password\"]" + state + ",\n    input[type=\"search\"]" + state + ",\n    input[type=\"tel\"]" + state + ",\n    input[type=\"text\"]" + state + ",\n    input[type=\"time\"]" + state + ",\n    input[type=\"url\"]" + state + ",\n    input[type=\"week\"]" + state + ",\n    input:not([type])" + state + ",\n    textarea" + state;
}
/**
 * Populates selectors that target all text inputs. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [textInputs('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${textInputs('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'input[type="color"]:active,
 *  input[type="date"]:active,
 *  input[type="datetime"]:active,
 *  input[type="datetime-local"]:active,
 *  input[type="email"]:active,
 *  input[type="month"]:active,
 *  input[type="number"]:active,
 *  input[type="password"]:active,
 *  input[type="search"]:active,
 *  input[type="tel"]:active,
 *  input[type="text"]:active,
 *  input[type="time"]:active,
 *  input[type="url"]:active,
 *  input[type="week"]:active,
 *  input:not([type]):active,
 *  textarea:active': {
 *   'border': 'none'
 * }
 */


function textInputs() {
  for (var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++) {
    states[_key] = arguments[_key];
  }

  return statefulSelectors(states, template$1, stateMap$1);
}

/**
 * Accepts any number of transition values as parameters for creating a single transition statement. You may also pass an array of properties as the first parameter that you would like to apply the same tranisition values to (second parameter).
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s'),
 *   ...transitions(['color', 'background-color'], '2.0s ease-in 2s')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')};
 *   ${transitions(['color', 'background-color'], '2.0s ease-in 2s'),};
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'transition': 'opacity 1.0s ease-in 0s, width 2.0s ease-in 2s'
 *   'transition': 'color 2.0s ease-in 2s, background-color 2.0s ease-in 2s',
 * }
 */
function transitions() {
  for (var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }

  if (Array.isArray(properties[0]) && properties.length === 2) {
    var value = properties[1];

    if (typeof value !== 'string') {
      throw new Error('Property must be a string value.');
    }

    var transitionsString = properties[0].map(function (property) {
      return property + " " + value;
    }).join(', ');
    return {
      transition: transitionsString
    };
  } else {
    return {
      transition: properties.join(', ')
    };
  }
}

// Helpers




/***/ }),
/* 2301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _taggedTemplateLiteralLoose;
function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

/***/ }),
/* 2302 */
/***/ (function(module, exports, __webpack_require__) {

/*! js-cookie v3.0.1 | MIT */
;
(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, (function () {
    var current = global.Cookies;
    var exports = global.Cookies = factory();
    exports.noConflict = function () { global.Cookies = current; return exports; };
  }()));
}(this, (function () { 'use strict';

  /* eslint-disable no-var */
  function assign (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        target[key] = source[key];
      }
    }
    return target
  }
  /* eslint-enable no-var */

  /* eslint-disable no-var */
  var defaultConverter = {
    read: function (value) {
      if (value[0] === '"') {
        value = value.slice(1, -1);
      }
      return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
    },
    write: function (value) {
      return encodeURIComponent(value).replace(
        /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
        decodeURIComponent
      )
    }
  };
  /* eslint-enable no-var */

  /* eslint-disable no-var */

  function init (converter, defaultAttributes) {
    function set (key, value, attributes) {
      if (typeof document === 'undefined') {
        return
      }

      attributes = assign({}, defaultAttributes, attributes);

      if (typeof attributes.expires === 'number') {
        attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
      }
      if (attributes.expires) {
        attributes.expires = attributes.expires.toUTCString();
      }

      key = encodeURIComponent(key)
        .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
        .replace(/[()]/g, escape);

      var stringifiedAttributes = '';
      for (var attributeName in attributes) {
        if (!attributes[attributeName]) {
          continue
        }

        stringifiedAttributes += '; ' + attributeName;

        if (attributes[attributeName] === true) {
          continue
        }

        // Considers RFC 6265 section 5.2:
        // ...
        // 3.  If the remaining unparsed-attributes contains a %x3B (";")
        //     character:
        // Consume the characters of the unparsed-attributes up to,
        // not including, the first %x3B (";") character.
        // ...
        stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
      }

      return (document.cookie =
        key + '=' + converter.write(value, key) + stringifiedAttributes)
    }

    function get (key) {
      if (typeof document === 'undefined' || (arguments.length && !key)) {
        return
      }

      // To prevent the for loop in the first place assign an empty array
      // in case there are no cookies at all.
      var cookies = document.cookie ? document.cookie.split('; ') : [];
      var jar = {};
      for (var i = 0; i < cookies.length; i++) {
        var parts = cookies[i].split('=');
        var value = parts.slice(1).join('=');

        try {
          var foundKey = decodeURIComponent(parts[0]);
          jar[foundKey] = converter.read(value, foundKey);

          if (key === foundKey) {
            break
          }
        } catch (e) {}
      }

      return key ? jar[key] : jar
    }

    return Object.create(
      {
        set: set,
        get: get,
        remove: function (key, attributes) {
          set(
            key,
            '',
            assign({}, attributes, {
              expires: -1
            })
          );
        },
        withAttributes: function (attributes) {
          return init(this.converter, assign({}, this.attributes, attributes))
        },
        withConverter: function (converter) {
          return init(assign({}, this.converter, converter), this.attributes)
        }
      },
      {
        attributes: { value: Object.freeze(defaultAttributes) },
        converter: { value: Object.freeze(converter) }
      }
    )
  }

  var api = init(defaultConverter, { path: '/' });
  /* eslint-enable no-var */

  return api;

})));


/***/ }),
/* 2303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__build_src_app_components_LoadingOverlay__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__build_node_modules_react_router__ = __webpack_require__(2304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__build_src_app_services_WebStorage__ = __webpack_require__(393);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CallbackComponent=(_dec=Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__["d" /* inject */])('user'),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_2__build_node_modules_mobx_react__["e" /* observer */])(_class=(_temp=_class2=function(_React$Component){_inherits(CallbackComponent,_React$Component);function CallbackComponent(props){var _this2=this;_classCallCheck(this,CallbackComponent);var _this=_possibleConstructorReturn(this,(CallbackComponent.__proto__||Object.getPrototypeOf(CallbackComponent)).call(this,props));_this.onRedirectSuccess=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(user){var origin,url;return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.storage.get('origin');case 2:origin=_context.sent;_context.next=5;return _this.storage.remove('origin');case 5:url=new URL(origin);url.searchParams.delete('idp');_this.props.history.push(''+url.pathname+url.search);case 8:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.onRedirectError=function(error){if(_this.props.errorCallback){_this.props.errorCallback(error);}else{throw new Error('Error handling redirect callback: '+error.message);}};_this.storage=new __WEBPACK_IMPORTED_MODULE_5__build_src_app_services_WebStorage__["a" /* default */]();return _this;}_createClass(CallbackComponent,[{key:'componentDidMount',value:function componentDidMount(){var _this3=this;this.props.user.manager.signinRedirectCallback().then(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(user){return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this3.onRedirectSuccess(user);case 2:return _context2.abrupt('return',_context2.sent);case 3:case'end':return _context2.stop();}}},_callee2,_this3);}));return function(_x2){return _ref2.apply(this,arguments);};}()).catch(function(error){return _this3.onRedirectError(error);});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__build_src_app_components_LoadingOverlay__["a" /* default */],{isVisible:true,fullscreen:true});}}]);return CallbackComponent;}(__WEBPACK_IMPORTED_MODULE_3__build_node_modules_react___default.a.Component),_class2.displayName='CallbackComponent',_temp))||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__build_node_modules_react_router__["a" /* withRouter */])(CallbackComponent));

/***/ }),
/* 2304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__ = __webpack_require__(845);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Prompt__ = __webpack_require__(848);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redirect__ = __webpack_require__(849);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(475);
/* unused harmony reexport Route */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(281);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaticRouter__ = __webpack_require__(850);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch__ = __webpack_require__(851);
/* unused harmony reexport Switch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__generatePath__ = __webpack_require__(476);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__matchPath__ = __webpack_require__(282);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__withRouter__ = __webpack_require__(852);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_9__withRouter__["a"]; });





















/***/ }),
/* 2305 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(102)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
            '_'
        ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return de;

})));


/***/ }),
/* 2306 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__(102)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
            '_'
        ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return es;

})));


/***/ }),
/* 2307 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    true ? factory(__webpack_require__(102)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
            ' '
        ),
        numbersFuture = [
            'nolla',
            'yhden',
            'kahden',
            'kolmen',
            'neljän',
            'viiden',
            'kuuden',
            numbersPast[7],
            numbersPast[8],
            numbersPast[9],
        ];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                result = isFuture ? 'sekunnin' : 'sekuntia';
                break;
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10
            ? isFuture
                ? numbersFuture[number]
                : numbersPast[number]
            : number;
    }

    var fi = moment.defineLocale('fi', {
        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
            '_'
        ),
        monthsShort: 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
            '_'
        ),
        weekdays: 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
            '_'
        ),
        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM[ta] YYYY',
            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l: 'D.M.YYYY',
            ll: 'Do MMM YYYY',
            lll: 'Do MMM YYYY, [klo] HH.mm',
            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
        },
        calendar: {
            sameDay: '[tänään] [klo] LT',
            nextDay: '[huomenna] [klo] LT',
            nextWeek: 'dddd [klo] LT',
            lastDay: '[eilen] [klo] LT',
            lastWeek: '[viime] dddd[na] [klo] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s päästä',
            past: '%s sitten',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fi;

})));


/***/ }),
/* 2308 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__(102)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsStrictRegex = /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsShortStrictRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
        monthsRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsParse = [
            /^janv/i,
            /^févr/i,
            /^mars/i,
            /^avr/i,
            /^mai/i,
            /^juin/i,
            /^juil/i,
            /^août/i,
            /^sept/i,
            /^oct/i,
            /^nov/i,
            /^déc/i,
        ];

    var fr = moment.defineLocale('fr', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
            '_'
        ),
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            w: 'une semaine',
            ww: '%d semaines',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal: function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fr;

})));


/***/ }),
/* 2309 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz
//! author: Marco : https://github.com/Manfre98

;(function (global, factory) {
    true ? factory(__webpack_require__(102)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var it = moment.defineLocale('it', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: function () {
                return (
                    '[Oggi a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextDay: function () {
                return (
                    '[Domani a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextWeek: function () {
                return (
                    'dddd [a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastDay: function () {
                return (
                    '[Ieri a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return (
                            '[La scorsa] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                ? ' '
                                : "ll'") +
                            ']LT'
                        );
                    default:
                        return (
                            '[Lo scorso] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                ? ' '
                                : "ll'") +
                            ']LT'
                        );
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'tra %s',
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            w: 'una settimana',
            ww: '%d settimane',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return it;

})));


/***/ }),
/* 2310 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    true ? factory(__webpack_require__(102)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    /*jshint -W100*/
    var si = moment.defineLocale('si', {
        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
            '_'
        ),
        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
            '_'
        ),
        weekdays: 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
            '_'
        ),
        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'a h:mm',
            LTS: 'a h:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY MMMM D',
            LLL: 'YYYY MMMM D, a h:mm',
            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
        },
        calendar: {
            sameDay: '[අද] LT[ට]',
            nextDay: '[හෙට] LT[ට]',
            nextWeek: 'dddd LT[ට]',
            lastDay: '[ඊයේ] LT[ට]',
            lastWeek: '[පසුගිය] dddd LT[ට]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sකින්',
            past: '%sකට පෙර',
            s: 'තත්පර කිහිපය',
            ss: 'තත්පර %d',
            m: 'මිනිත්තුව',
            mm: 'මිනිත්තු %d',
            h: 'පැය',
            hh: 'පැය %d',
            d: 'දිනය',
            dd: 'දින %d',
            M: 'මාසය',
            MM: 'මාස %d',
            y: 'වසර',
            yy: 'වසර %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal: function (number) {
            return number + ' වැනි';
        },
        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM: function (input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        },
    });

    return si;

})));


/***/ }),
/* 2311 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = LocalizationAssistant_Parse;
/* harmony export (immutable) */ __webpack_exports__["a"] = LocalizationAssistant_MutationObserver_Callback;
var LocalizationAssistant_RegExp=new RegExp('~(([a-zA-Z0-9_]+)(::([a-zA-Z0-9_]+))?)~','g');function LocalizationAssistant_Parse(element){[].forEach.call(element.childNodes,function(childNode){if(childNode.nodeType===3)LocalizationAssistant_Process(childNode);else LocalizationAssistant_Parse(childNode);});}function LocalizationAssistant_Process(textNode){var matches=LocalizationAssistant_RegExp.exec(textNode.textContent);if(matches){// exception for some elements, e.g. <option>
if(textNode.parentElement!==null&&textNode.parentElement.nodeName.toLowerCase()==='option')textNode.textContent=textNode.textContent.replace(LocalizationAssistant_RegExp,' #'+matches[1]);else{var wrapperElement=document.createElement('div');wrapperElement.className='localization-assistant-wrapper';var innerElement=document.createElement('div');innerElement.innerText='#';innerElement.className='localization-assistant';innerElement.setAttribute('title',matches[1]);innerElement.setAttribute('localization-assistant-key',matches[1]);innerElement.setAttribute('localization-assistant-namespace',matches[2]);innerElement.setAttribute('localization-assistant-id',matches[4]);innerElement.addEventListener('click',function(){var url=window.LocalizationAssistant_Url;if(url){url=url.replace('{key}',encodeURIComponent(this.getAttribute('localization-assistant-key')));url=url.replace('{locale}',encodeURIComponent(window.locale));window.open(url,'_blank');}},false);wrapperElement.appendChild(innerElement);if(textNode.nextSibling)textNode.parentNode.insertBefore(wrapperElement,textNode.nextSibling);else textNode.parentNode.appendChild(wrapperElement);textNode.textContent=textNode.textContent.replace(LocalizationAssistant_RegExp,'');}}}function LocalizationAssistant_MutationObserver_Callback(mutationList,observer){mutationList.forEach(function(mutation){switch(mutation.type){case'childList':if(mutation.target)LocalizationAssistant_Parse(mutation.target);break;case'attributes':if(mutation.target)LocalizationAssistant_Parse(mutation.target);break;case'characterData':if(mutation.target)LocalizationAssistant_Process(mutation.target);break;default:break;}});}

/***/ }),
/* 2313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_moment_timezone__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__build_node_modules_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__build_node_modules_moment_timezone__);
/* eslint no-extend-native: "off" */function isNumeric(num){return!isNaN(parseFloat(num));}if(typeof String.prototype.toFormatedDateString!=='function'){String.prototype.toFormatedDateString=function(){var format=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'ddd ll';return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_moment_timezone___default()(this).format(format);};}if(typeof Date.prototype.toFormatedDateString!=='function'){Date.prototype.toFormatedDateString=function(){var format=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'ddd ll';return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_moment_timezone___default()(this).format(format);};}if(typeof String.prototype.toFormattedDateTimeString!=='function'){String.prototype.toFormattedDateTimeString=function(){var format=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'ddd ll, LT';return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_moment_timezone___default()(this).format(format);};}if(typeof Date.prototype.toFormattedDateTimeString!=='function'){Date.prototype.toFormattedDateTimeString=function(){var format=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'ddd ll, LT';return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_moment_timezone___default()(this).format(format);};}if(typeof String.prototype.formatWith!=='function'){String.prototype.formatWith=function(args){var i=0;var props=Object.keys(args);return this.replace(/%s/g,function(){return args[props[i++]];});};}if(typeof Number.prototype.toFormattedMoney!=='function'){Number.prototype.toFormattedMoney=function(locale,currency){var defaultValue=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';return isNumeric(this)?new Intl.NumberFormat(locale,{style:'currency',currency:currency,minimumFractionDigits:0,maximumFractionDigits:0,useGrouping:true}).format(this):defaultValue;};}if(typeof String.prototype.replaceAll!=='function'){String.prototype.replaceAll=function(search,replacement){var target=this;return target.split(search).join(replacement);};}if(typeof Date.prototype.toStringFormat!=='function'){Date.prototype.toStringFormat=function(){var format=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'dddd, DD MMMM YYYY';return __WEBPACK_IMPORTED_MODULE_0__build_node_modules_moment_timezone___default()(this).format(format);};}if(typeof Array.prototype.groupBy!=='function'){Array.prototype.groupBy=function(prop){return this.reduce(function(groups,item){var val=item[prop];groups[val]=groups[val]||[];groups[val].push(item);return groups;},{});};}if(typeof Array.prototype.sortBy!=='function'){Array.prototype.sortBy=function(field){var desc=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var valueFormatter=arguments.length>2&&arguments[2]!==undefined?arguments[2]:function(v){return v||'';};return this.concat([]).sort(function(a,b){var firstValue=valueFormatter(a[field]);var secondValue=valueFormatter(b[field]);if(firstValue===secondValue){return 0;}if(desc){return firstValue>secondValue?1:-1;}else{return firstValue>secondValue?-1:1;}});};}

/***/ }),
/* 2314 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// dashboard/js/main.7928f14a.js